(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1164"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1164"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("a58XM", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $757152ee82640ba0$export$ffb0004e005737fa; }, function (v) { return $757152ee82640ba0$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $757152ee82640ba0$export$34b9dba7ce09269b; }, function (v) { return $757152ee82640ba0$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $757152ee82640ba0$export$25062201e9e25d76; }, function (v) { return $757152ee82640ba0$export$25062201e9e25d76 = v; });
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $757152ee82640ba0$export$ffb0004e005737fa;
var $757152ee82640ba0$export$34b9dba7ce09269b;
var $757152ee82640ba0$export$25062201e9e25d76;
"use strict";
parcelRequire("7JwYr");

var $6cds3 = parcelRequire("6cds3");
var $757152ee82640ba0$var$g = 60103;
$757152ee82640ba0$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $757152ee82640ba0$var$h = Symbol.for;
    $757152ee82640ba0$var$g = $757152ee82640ba0$var$h("react.element");
    $757152ee82640ba0$export$ffb0004e005737fa = $757152ee82640ba0$var$h("react.fragment");
}
var $757152ee82640ba0$var$m = $6cds3.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $757152ee82640ba0$var$n = Object.prototype.hasOwnProperty, $757152ee82640ba0$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $757152ee82640ba0$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$757152ee82640ba0$var$n.call(a, b) && !$757152ee82640ba0$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $757152ee82640ba0$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $757152ee82640ba0$var$m.current
    };
}
$757152ee82640ba0$export$34b9dba7ce09269b = $757152ee82640ba0$var$q;
$757152ee82640ba0$export$25062201e9e25d76 = $757152ee82640ba0$var$q;

});
parcelRegister("7JwYr", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $5a165049bd898272$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $5a165049bd898272$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $5a165049bd898272$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $5a165049bd898272$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $5a165049bd898272$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $5a165049bd898272$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $5a165049bd898272$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($5a165049bd898272$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($5a165049bd898272$var$getOwnPropertySymbols) {
            symbols = $5a165049bd898272$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($5a165049bd898272$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("6cds3", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gx6CV"));

});
parcelRegister("gx6CV", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $c094de5bd35107a3$export$ffb0004e005737fa; }, function (v) { return $c094de5bd35107a3$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "StrictMode", function () { return $c094de5bd35107a3$export$5f8d39834fd61797; }, function (v) { return $c094de5bd35107a3$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Profiler", function () { return $c094de5bd35107a3$export$e2c29f18771995cb; }, function (v) { return $c094de5bd35107a3$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "Suspense", function () { return $c094de5bd35107a3$export$74bf444e3cd11ea5; }, function (v) { return $c094de5bd35107a3$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "Children", function () { return $c094de5bd35107a3$export$dca3b0875bd9a954; }, function (v) { return $c094de5bd35107a3$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $c094de5bd35107a3$export$16fa2f45be04daa8; }, function (v) { return $c094de5bd35107a3$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "PureComponent", function () { return $c094de5bd35107a3$export$221d75b3f55bb0bd; }, function (v) { return $c094de5bd35107a3$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $c094de5bd35107a3$export$ae55be85d98224ed; }, function (v) { return $c094de5bd35107a3$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $c094de5bd35107a3$export$e530037191fcd5d7; }, function (v) { return $c094de5bd35107a3$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $c094de5bd35107a3$export$fd42f52fd3ae1109; }, function (v) { return $c094de5bd35107a3$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $c094de5bd35107a3$export$c8a8987d4410bf2d; }, function (v) { return $c094de5bd35107a3$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $c094de5bd35107a3$export$d38cd72104c1f0e9; }, function (v) { return $c094de5bd35107a3$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $c094de5bd35107a3$export$7d1e3a5e95ceca43; }, function (v) { return $c094de5bd35107a3$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $c094de5bd35107a3$export$257a8862b851cb5b; }, function (v) { return $c094de5bd35107a3$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $c094de5bd35107a3$export$a8257692ac88316c; }, function (v) { return $c094de5bd35107a3$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $c094de5bd35107a3$export$488013bae63b21da; }, function (v) { return $c094de5bd35107a3$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $c094de5bd35107a3$export$7c73462e0d25e514; }, function (v) { return $c094de5bd35107a3$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "useCallback", function () { return $c094de5bd35107a3$export$35808ee640e87ca7; }, function (v) { return $c094de5bd35107a3$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $c094de5bd35107a3$export$fae74005e78b1a27; }, function (v) { return $c094de5bd35107a3$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $c094de5bd35107a3$export$dc8fbce3eb94dc1e; }, function (v) { return $c094de5bd35107a3$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useEffect", function () { return $c094de5bd35107a3$export$6d9c69b0de29b591; }, function (v) { return $c094de5bd35107a3$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $c094de5bd35107a3$export$d5a552a76deda3c2; }, function (v) { return $c094de5bd35107a3$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $c094de5bd35107a3$export$e5c5a5f917a5871c; }, function (v) { return $c094de5bd35107a3$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $c094de5bd35107a3$export$1538c33de8887b59; }, function (v) { return $c094de5bd35107a3$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $c094de5bd35107a3$export$13e3392192263954; }, function (v) { return $c094de5bd35107a3$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $c094de5bd35107a3$export$b8f5890fc79d6aca; }, function (v) { return $c094de5bd35107a3$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $c094de5bd35107a3$export$60241385465d0a34; }, function (v) { return $c094de5bd35107a3$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "version", function () { return $c094de5bd35107a3$export$83d89fbfd8236492; }, function (v) { return $c094de5bd35107a3$export$83d89fbfd8236492 = v; });
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c094de5bd35107a3$export$ffb0004e005737fa;
var $c094de5bd35107a3$export$5f8d39834fd61797;
var $c094de5bd35107a3$export$e2c29f18771995cb;
var $c094de5bd35107a3$export$74bf444e3cd11ea5;
var $c094de5bd35107a3$export$dca3b0875bd9a954;
var $c094de5bd35107a3$export$16fa2f45be04daa8;
var $c094de5bd35107a3$export$221d75b3f55bb0bd;
var $c094de5bd35107a3$export$ae55be85d98224ed;
var $c094de5bd35107a3$export$e530037191fcd5d7;
var $c094de5bd35107a3$export$fd42f52fd3ae1109;
var $c094de5bd35107a3$export$c8a8987d4410bf2d;
var $c094de5bd35107a3$export$d38cd72104c1f0e9;
var $c094de5bd35107a3$export$7d1e3a5e95ceca43;
var $c094de5bd35107a3$export$257a8862b851cb5b;
var $c094de5bd35107a3$export$a8257692ac88316c;
var $c094de5bd35107a3$export$488013bae63b21da;
var $c094de5bd35107a3$export$7c73462e0d25e514;
var $c094de5bd35107a3$export$35808ee640e87ca7;
var $c094de5bd35107a3$export$fae74005e78b1a27;
var $c094de5bd35107a3$export$dc8fbce3eb94dc1e;
var $c094de5bd35107a3$export$6d9c69b0de29b591;
var $c094de5bd35107a3$export$d5a552a76deda3c2;
var $c094de5bd35107a3$export$e5c5a5f917a5871c;
var $c094de5bd35107a3$export$1538c33de8887b59;
var $c094de5bd35107a3$export$13e3392192263954;
var $c094de5bd35107a3$export$b8f5890fc79d6aca;
var $c094de5bd35107a3$export$60241385465d0a34;
var $c094de5bd35107a3$export$83d89fbfd8236492;
"use strict";

var $7JwYr = parcelRequire("7JwYr");
var $c094de5bd35107a3$var$n = 60103, $c094de5bd35107a3$var$p = 60106;
$c094de5bd35107a3$export$ffb0004e005737fa = 60107;
$c094de5bd35107a3$export$5f8d39834fd61797 = 60108;
$c094de5bd35107a3$export$e2c29f18771995cb = 60114;
var $c094de5bd35107a3$var$q = 60109, $c094de5bd35107a3$var$r = 60110, $c094de5bd35107a3$var$t = 60112;
$c094de5bd35107a3$export$74bf444e3cd11ea5 = 60113;
var $c094de5bd35107a3$var$u = 60115, $c094de5bd35107a3$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $c094de5bd35107a3$var$w = Symbol.for;
    $c094de5bd35107a3$var$n = $c094de5bd35107a3$var$w("react.element");
    $c094de5bd35107a3$var$p = $c094de5bd35107a3$var$w("react.portal");
    $c094de5bd35107a3$export$ffb0004e005737fa = $c094de5bd35107a3$var$w("react.fragment");
    $c094de5bd35107a3$export$5f8d39834fd61797 = $c094de5bd35107a3$var$w("react.strict_mode");
    $c094de5bd35107a3$export$e2c29f18771995cb = $c094de5bd35107a3$var$w("react.profiler");
    $c094de5bd35107a3$var$q = $c094de5bd35107a3$var$w("react.provider");
    $c094de5bd35107a3$var$r = $c094de5bd35107a3$var$w("react.context");
    $c094de5bd35107a3$var$t = $c094de5bd35107a3$var$w("react.forward_ref");
    $c094de5bd35107a3$export$74bf444e3cd11ea5 = $c094de5bd35107a3$var$w("react.suspense");
    $c094de5bd35107a3$var$u = $c094de5bd35107a3$var$w("react.memo");
    $c094de5bd35107a3$var$v = $c094de5bd35107a3$var$w("react.lazy");
}
var $c094de5bd35107a3$var$x = "function" === typeof Symbol && Symbol.iterator;
function $c094de5bd35107a3$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $c094de5bd35107a3$var$x && a[$c094de5bd35107a3$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $c094de5bd35107a3$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $c094de5bd35107a3$var$A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $c094de5bd35107a3$var$B = {};
function $c094de5bd35107a3$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $c094de5bd35107a3$var$B;
    this.updater = c || $c094de5bd35107a3$var$A;
}
$c094de5bd35107a3$var$C.prototype.isReactComponent = {};
$c094de5bd35107a3$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($c094de5bd35107a3$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$c094de5bd35107a3$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $c094de5bd35107a3$var$D() {}
$c094de5bd35107a3$var$D.prototype = $c094de5bd35107a3$var$C.prototype;
function $c094de5bd35107a3$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $c094de5bd35107a3$var$B;
    this.updater = c || $c094de5bd35107a3$var$A;
}
var $c094de5bd35107a3$var$F = $c094de5bd35107a3$var$E.prototype = new $c094de5bd35107a3$var$D;
$c094de5bd35107a3$var$F.constructor = $c094de5bd35107a3$var$E;
$7JwYr($c094de5bd35107a3$var$F, $c094de5bd35107a3$var$C.prototype);
$c094de5bd35107a3$var$F.isPureReactComponent = !0;
var $c094de5bd35107a3$var$G = {
    current: null
}, $c094de5bd35107a3$var$H = Object.prototype.hasOwnProperty, $c094de5bd35107a3$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $c094de5bd35107a3$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$c094de5bd35107a3$var$H.call(b, e) && !$c094de5bd35107a3$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $c094de5bd35107a3$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $c094de5bd35107a3$var$G.current
    };
}
function $c094de5bd35107a3$var$K(a, b) {
    return {
        $$typeof: $c094de5bd35107a3$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $c094de5bd35107a3$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $c094de5bd35107a3$var$n;
}
function $c094de5bd35107a3$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $c094de5bd35107a3$var$M = /\/+/g;
function $c094de5bd35107a3$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $c094de5bd35107a3$var$escape("" + a.key) : b.toString(36);
}
function $c094de5bd35107a3$var$O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $c094de5bd35107a3$var$n:
                case $c094de5bd35107a3$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $c094de5bd35107a3$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($c094de5bd35107a3$var$M, "$&/") + "/"), $c094de5bd35107a3$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($c094de5bd35107a3$var$L(d) && (d = $c094de5bd35107a3$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($c094de5bd35107a3$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $c094de5bd35107a3$var$N(k, g);
        h += $c094de5bd35107a3$var$O(k, b, c, f, d);
    }
    else if (f = $c094de5bd35107a3$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $c094de5bd35107a3$var$N(k, g++), h += $c094de5bd35107a3$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($c094de5bd35107a3$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $c094de5bd35107a3$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $c094de5bd35107a3$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $c094de5bd35107a3$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $c094de5bd35107a3$var$R = {
    current: null
};
function $c094de5bd35107a3$var$S() {
    var a = $c094de5bd35107a3$var$R.current;
    if (null === a) throw Error($c094de5bd35107a3$var$z(321));
    return a;
}
var $c094de5bd35107a3$var$T = {
    ReactCurrentDispatcher: $c094de5bd35107a3$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $c094de5bd35107a3$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $7JwYr
};
$c094de5bd35107a3$export$dca3b0875bd9a954 = {
    map: $c094de5bd35107a3$var$P,
    forEach: function(a, b, c) {
        $c094de5bd35107a3$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $c094de5bd35107a3$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $c094de5bd35107a3$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$c094de5bd35107a3$var$L(a)) throw Error($c094de5bd35107a3$var$z(143));
        return a;
    }
};
$c094de5bd35107a3$export$16fa2f45be04daa8 = $c094de5bd35107a3$var$C;
$c094de5bd35107a3$export$221d75b3f55bb0bd = $c094de5bd35107a3$var$E;
$c094de5bd35107a3$export$ae55be85d98224ed = $c094de5bd35107a3$var$T;
$c094de5bd35107a3$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($c094de5bd35107a3$var$z(267, a));
    var e = $7JwYr({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $c094de5bd35107a3$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$c094de5bd35107a3$var$H.call(b, f) && !$c094de5bd35107a3$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $c094de5bd35107a3$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$c094de5bd35107a3$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $c094de5bd35107a3$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $c094de5bd35107a3$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$c094de5bd35107a3$export$c8a8987d4410bf2d = $c094de5bd35107a3$var$J;
$c094de5bd35107a3$export$d38cd72104c1f0e9 = function(a) {
    var b = $c094de5bd35107a3$var$J.bind(null, a);
    b.type = a;
    return b;
};
$c094de5bd35107a3$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$c094de5bd35107a3$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $c094de5bd35107a3$var$t,
        render: a
    };
};
$c094de5bd35107a3$export$a8257692ac88316c = $c094de5bd35107a3$var$L;
$c094de5bd35107a3$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $c094de5bd35107a3$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $c094de5bd35107a3$var$Q
    };
};
$c094de5bd35107a3$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $c094de5bd35107a3$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$c094de5bd35107a3$export$35808ee640e87ca7 = function(a, b) {
    return $c094de5bd35107a3$var$S().useCallback(a, b);
};
$c094de5bd35107a3$export$fae74005e78b1a27 = function(a, b) {
    return $c094de5bd35107a3$var$S().useContext(a, b);
};
$c094de5bd35107a3$export$dc8fbce3eb94dc1e = function() {};
$c094de5bd35107a3$export$6d9c69b0de29b591 = function(a, b) {
    return $c094de5bd35107a3$var$S().useEffect(a, b);
};
$c094de5bd35107a3$export$d5a552a76deda3c2 = function(a, b, c) {
    return $c094de5bd35107a3$var$S().useImperativeHandle(a, b, c);
};
$c094de5bd35107a3$export$e5c5a5f917a5871c = function(a, b) {
    return $c094de5bd35107a3$var$S().useLayoutEffect(a, b);
};
$c094de5bd35107a3$export$1538c33de8887b59 = function(a, b) {
    return $c094de5bd35107a3$var$S().useMemo(a, b);
};
$c094de5bd35107a3$export$13e3392192263954 = function(a, b, c) {
    return $c094de5bd35107a3$var$S().useReducer(a, b, c);
};
$c094de5bd35107a3$export$b8f5890fc79d6aca = function(a) {
    return $c094de5bd35107a3$var$S().useRef(a);
};
$c094de5bd35107a3$export$60241385465d0a34 = function(a) {
    return $c094de5bd35107a3$var$S().useState(a);
};
$c094de5bd35107a3$export$83d89fbfd8236492 = "17.0.2";

});



parcelRegister("3tMCR", function(module, exports) {
(function(f) {
    var g;
    module.exports = f();
})(function() {
    var define, module1, exports;
    var _$breadcrumbTypes_8 = [
        "navigation",
        "request",
        "process",
        "log",
        "user",
        "state",
        "error",
        "manual"
    ];
    // Array#reduce
    var _$reduce_17 = function(arr, fn, accum) {
        var val = accum;
        for(var i = 0, len = arr.length; i < len; i++)val = fn(val, arr[i], i, arr);
        return val;
    }; /* removed: var _$reduce_17 = require('./reduce'); */ 
    // Array#filter
    var _$filter_12 = function(arr, fn) {
        return _$reduce_17(arr, function(accum, item, i, arr) {
            return !fn(item, i, arr) ? accum : accum.concat(item);
        }, []);
    }; /* removed: var _$reduce_17 = require('./reduce'); */ 
    // Array#includes
    var _$includes_13 = function(arr, x) {
        return _$reduce_17(arr, function(accum, item, i, arr) {
            return accum === true || item === x;
        }, false);
    };
    // Array#isArray
    var _$isArray_14 = function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    /* eslint-disable-next-line no-prototype-builtins */ var _hasDontEnumBug = !({
        toString: null
    }).propertyIsEnumerable("toString");
    var _dontEnums = [
        "toString",
        "toLocaleString",
        "valueOf",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "constructor"
    ];
    // Object#keys
    var _$keys_15 = function(obj) {
        // stripped down version of
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/Keys
        var result = [];
        var prop;
        for(prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) result.push(prop);
        if (!_hasDontEnumBug) return result;
        for(var i = 0, len = _dontEnums.length; i < len; i++)if (Object.prototype.hasOwnProperty.call(obj, _dontEnums[i])) result.push(_dontEnums[i]);
        return result;
    };
    var _$intRange_24 = function(min, max) {
        if (min === void 0) min = 1;
        if (max === void 0) max = Infinity;
        return function(value) {
            return typeof value === "number" && parseInt("" + value, 10) === value && value >= min && value <= max;
        };
    }; /* removed: var _$filter_12 = require('../es-utils/filter'); */ 
    var _$listOfFunctions_25 = function(value) {
        return typeof value === "function" || _$isArray_14(value) && _$filter_12(value, function(f) {
            return typeof f === "function";
        }).length === value.length;
    };
    var _$stringWithLength_26 = function(value) {
        return typeof value === "string" && !!value.length;
    };
    var _$config_5 = {}; /* removed: var _$filter_12 = require('./lib/es-utils/filter'); */ 
    var defaultErrorTypes = function() {
        return {
            unhandledExceptions: true,
            unhandledRejections: true
        };
    };
    _$config_5.schema = {
        apiKey: {
            defaultValue: function() {
                return null;
            },
            message: "is required",
            validate: _$stringWithLength_26
        },
        appVersion: {
            defaultValue: function() {
                return undefined;
            },
            message: "should be a string",
            validate: function(value) {
                return value === undefined || _$stringWithLength_26(value);
            }
        },
        appType: {
            defaultValue: function() {
                return undefined;
            },
            message: "should be a string",
            validate: function(value) {
                return value === undefined || _$stringWithLength_26(value);
            }
        },
        autoDetectErrors: {
            defaultValue: function() {
                return true;
            },
            message: "should be true|false",
            validate: function(value) {
                return value === true || value === false;
            }
        },
        enabledErrorTypes: {
            defaultValue: function() {
                return defaultErrorTypes();
            },
            message: "should be an object containing the flags { unhandledExceptions:true|false, unhandledRejections:true|false }",
            allowPartialObject: true,
            validate: function(value) {
                // ensure we have an object
                if (typeof value !== "object" || !value) return false;
                var providedKeys = _$keys_15(value);
                var defaultKeys = _$keys_15(defaultErrorTypes());
                // ensure it only has a subset of the allowed keys
                if (_$filter_12(providedKeys, function(k) {
                    return _$includes_13(defaultKeys, k);
                }).length < providedKeys.length) return false;
                // ensure all of the values are boolean
                if (_$filter_12(_$keys_15(value), function(k) {
                    return typeof value[k] !== "boolean";
                }).length > 0) return false;
                return true;
            }
        },
        onError: {
            defaultValue: function() {
                return [];
            },
            message: "should be a function or array of functions",
            validate: _$listOfFunctions_25
        },
        onSession: {
            defaultValue: function() {
                return [];
            },
            message: "should be a function or array of functions",
            validate: _$listOfFunctions_25
        },
        onBreadcrumb: {
            defaultValue: function() {
                return [];
            },
            message: "should be a function or array of functions",
            validate: _$listOfFunctions_25
        },
        endpoints: {
            defaultValue: function() {
                return {
                    notify: "https://notify.bugsnag.com",
                    sessions: "https://sessions.bugsnag.com"
                };
            },
            message: "should be an object containing endpoint URLs { notify, sessions }",
            validate: function(val) {
                return(// first, ensure it's an object
                val && typeof val === "object" && // notify and sessions must always be set
                _$stringWithLength_26(val.notify) && _$stringWithLength_26(val.sessions) && // ensure no keys other than notify/session are set on endpoints object
                _$filter_12(_$keys_15(val), function(k) {
                    return !_$includes_13([
                        "notify",
                        "sessions"
                    ], k);
                }).length === 0);
            }
        },
        autoTrackSessions: {
            defaultValue: function(val) {
                return true;
            },
            message: "should be true|false",
            validate: function(val) {
                return val === true || val === false;
            }
        },
        enabledReleaseStages: {
            defaultValue: function() {
                return null;
            },
            message: "should be an array of strings",
            validate: function(value) {
                return value === null || _$isArray_14(value) && _$filter_12(value, function(f) {
                    return typeof f === "string";
                }).length === value.length;
            }
        },
        releaseStage: {
            defaultValue: function() {
                return "production";
            },
            message: "should be a string",
            validate: function(value) {
                return typeof value === "string" && value.length;
            }
        },
        maxBreadcrumbs: {
            defaultValue: function() {
                return 25;
            },
            message: "should be a number \u2264100",
            validate: function(value) {
                return _$intRange_24(0, 100)(value);
            }
        },
        enabledBreadcrumbTypes: {
            defaultValue: function() {
                return _$breadcrumbTypes_8;
            },
            message: "should be null or a list of available breadcrumb types (" + _$breadcrumbTypes_8.join(",") + ")",
            validate: function(value) {
                return value === null || _$isArray_14(value) && _$reduce_17(value, function(accum, maybeType) {
                    if (accum === false) return accum;
                    return _$includes_13(_$breadcrumbTypes_8, maybeType);
                }, true);
            }
        },
        context: {
            defaultValue: function() {
                return undefined;
            },
            message: "should be a string",
            validate: function(value) {
                return value === undefined || typeof value === "string";
            }
        },
        user: {
            defaultValue: function() {
                return {};
            },
            message: "should be an object with { id, email, name } properties",
            validate: function(value) {
                return value === null || value && _$reduce_17(_$keys_15(value), function(accum, key) {
                    return accum && _$includes_13([
                        "id",
                        "email",
                        "name"
                    ], key);
                }, true);
            }
        },
        metadata: {
            defaultValue: function() {
                return {};
            },
            message: "should be an object",
            validate: function(value) {
                return typeof value === "object" && value !== null;
            }
        },
        logger: {
            defaultValue: function() {
                return undefined;
            },
            message: "should be null or an object with methods { debug, info, warn, error }",
            validate: function(value) {
                return !value || value && _$reduce_17([
                    "debug",
                    "info",
                    "warn",
                    "error"
                ], function(accum, method) {
                    return accum && typeof value[method] === "function";
                }, true);
            }
        },
        redactedKeys: {
            defaultValue: function() {
                return [
                    "password"
                ];
            },
            message: "should be an array of strings|regexes",
            validate: function(value) {
                return _$isArray_14(value) && value.length === _$filter_12(value, function(s) {
                    return typeof s === "string" || s && typeof s.test === "function";
                }).length;
            }
        },
        plugins: {
            defaultValue: function() {
                return [];
            },
            message: "should be an array of plugin objects",
            validate: function(value) {
                return _$isArray_14(value) && value.length === _$filter_12(value, function(p) {
                    return p && typeof p === "object" && typeof p.load === "function";
                }).length;
            }
        },
        featureFlags: {
            defaultValue: function() {
                return [];
            },
            message: 'should be an array of objects that have a "name" property',
            validate: function(value) {
                return _$isArray_14(value) && value.length === _$filter_12(value, function(feature) {
                    return feature && typeof feature === "object" && typeof feature.name === "string";
                }).length;
            }
        }
    };
    // extends helper from babel
    // https://github.com/babel/babel/blob/916429b516e6466fd06588ee820e40e025d7f3a3/packages/babel-helpers/src/helpers.js#L377-L393
    var _$assign_11 = function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }; /* removed: var _$reduce_17 = require('./reduce'); */ 
    // Array#map
    var _$map_16 = function(arr, fn) {
        return _$reduce_17(arr, function(accum, item, i, arr) {
            return accum.concat(fn(item, i, arr));
        }, []);
    };
    function _extends() {
        _extends = Object.assign ? Object.assign.bind() : function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        return _extends.apply(this, arguments);
    }
    var schema = _$config_5.schema; /* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */ 
    var _$config_1 = {
        releaseStage: _$assign_11({}, schema.releaseStage, {
            defaultValue: function() {
                if (/^localhost(:\d+)?$/.test(window.location.host)) return "development";
                return "production";
            }
        }),
        appType: _extends({}, schema.appType, {
            defaultValue: function() {
                return "browser";
            }
        }),
        logger: _$assign_11({}, schema.logger, {
            defaultValue: function() {
                return(// set logger based on browser capability
                typeof console !== "undefined" && typeof console.debug === "function" ? getPrefixedConsole() : undefined);
            }
        })
    };
    var getPrefixedConsole = function() {
        var logger = {};
        var consoleLog = console.log;
        _$map_16([
            "debug",
            "info",
            "warn",
            "error"
        ], function(method) {
            var consoleMethod = console[method];
            logger[method] = typeof consoleMethod === "function" ? consoleMethod.bind(console, "[bugsnag]") : consoleLog.bind(console, "[bugsnag]");
        });
        return logger;
    };
    var Breadcrumb = /*#__PURE__*/ function() {
        function Breadcrumb(message, metadata, type, timestamp) {
            if (timestamp === void 0) timestamp = new Date();
            this.type = type;
            this.message = message;
            this.metadata = metadata;
            this.timestamp = timestamp;
        }
        var _proto = Breadcrumb.prototype;
        _proto.toJSON = function toJSON() {
            return {
                type: this.type,
                name: this.message,
                timestamp: this.timestamp,
                metaData: this.metadata
            };
        };
        return Breadcrumb;
    }();
    var _$Breadcrumb_3 = Breadcrumb;
    var _$stackframe_34 = {};
    (function(root, factory) {
        "use strict";
        // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
        /* istanbul ignore next */ if (typeof define === "function" && define.amd) define("stackframe", [], factory);
        else if (typeof _$stackframe_34 === "object") _$stackframe_34 = factory();
        else root.StackFrame = factory();
    })(this, function() {
        "use strict";
        function _isNumber(n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        }
        function _capitalize(str) {
            return str.charAt(0).toUpperCase() + str.substring(1);
        }
        function _getter(p) {
            return function() {
                return this[p];
            };
        }
        var booleanProps = [
            "isConstructor",
            "isEval",
            "isNative",
            "isToplevel"
        ];
        var numericProps = [
            "columnNumber",
            "lineNumber"
        ];
        var stringProps = [
            "fileName",
            "functionName",
            "source"
        ];
        var arrayProps = [
            "args"
        ];
        var props = booleanProps.concat(numericProps, stringProps, arrayProps);
        function StackFrame(obj) {
            if (obj instanceof Object) {
                for(var i = 0; i < props.length; i++)if (obj.hasOwnProperty(props[i]) && obj[props[i]] !== undefined) this["set" + _capitalize(props[i])](obj[props[i]]);
            }
        }
        StackFrame.prototype = {
            getArgs: function() {
                return this.args;
            },
            setArgs: function(v) {
                if (Object.prototype.toString.call(v) !== "[object Array]") throw new TypeError("Args must be an Array");
                this.args = v;
            },
            getEvalOrigin: function() {
                return this.evalOrigin;
            },
            setEvalOrigin: function(v) {
                if (v instanceof StackFrame) this.evalOrigin = v;
                else if (v instanceof Object) this.evalOrigin = new StackFrame(v);
                else throw new TypeError("Eval Origin must be an Object or StackFrame");
            },
            toString: function() {
                var functionName = this.getFunctionName() || "{anonymous}";
                var args = "(" + (this.getArgs() || []).join(",") + ")";
                var fileName = this.getFileName() ? "@" + this.getFileName() : "";
                var lineNumber = _isNumber(this.getLineNumber()) ? ":" + this.getLineNumber() : "";
                var columnNumber = _isNumber(this.getColumnNumber()) ? ":" + this.getColumnNumber() : "";
                return functionName + args + fileName + lineNumber + columnNumber;
            }
        };
        for(var i = 0; i < booleanProps.length; i++){
            StackFrame.prototype["get" + _capitalize(booleanProps[i])] = _getter(booleanProps[i]);
            StackFrame.prototype["set" + _capitalize(booleanProps[i])] = function(p) {
                return function(v) {
                    this[p] = Boolean(v);
                };
            }(booleanProps[i]);
        }
        for(var j = 0; j < numericProps.length; j++){
            StackFrame.prototype["get" + _capitalize(numericProps[j])] = _getter(numericProps[j]);
            StackFrame.prototype["set" + _capitalize(numericProps[j])] = function(p) {
                return function(v) {
                    if (!_isNumber(v)) throw new TypeError(p + " must be a Number");
                    this[p] = Number(v);
                };
            }(numericProps[j]);
        }
        for(var k = 0; k < stringProps.length; k++){
            StackFrame.prototype["get" + _capitalize(stringProps[k])] = _getter(stringProps[k]);
            StackFrame.prototype["set" + _capitalize(stringProps[k])] = function(p) {
                return function(v) {
                    this[p] = String(v);
                };
            }(stringProps[k]);
        }
        return StackFrame;
    });
    var _$errorStackParser_31 = {};
    (function(root, factory) {
        "use strict";
        // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
        /* istanbul ignore next */ if (typeof define === "function" && define.amd) define("error-stack-parser", [
            "stackframe"
        ], factory);
        else if (typeof _$errorStackParser_31 === "object") _$errorStackParser_31 = factory(_$stackframe_34);
        else root.ErrorStackParser = factory(root.StackFrame);
    })(this, function ErrorStackParser(StackFrame) {
        "use strict";
        var FIREFOX_SAFARI_STACK_REGEXP = /(^|@)\S+\:\d+/;
        var CHROME_IE_STACK_REGEXP = /^\s*at .*(\S+\:\d+|\(native\))/m;
        var SAFARI_NATIVE_CODE_REGEXP = /^(eval@)?(\[native code\])?$/;
        return {
            /**
     * Given an Error object, extract the most information from it.
     *
     * @param {Error} error object
     * @return {Array} of StackFrames
     */ parse: function ErrorStackParser$$parse(error) {
                if (typeof error.stacktrace !== "undefined" || typeof error["opera#sourceloc"] !== "undefined") return this.parseOpera(error);
                else if (error.stack && error.stack.match(CHROME_IE_STACK_REGEXP)) return this.parseV8OrIE(error);
                else if (error.stack) return this.parseFFOrSafari(error);
                else throw new Error("Cannot parse given Error object");
            },
            // Separate line and column numbers from a string of the form: (URI:Line:Column)
            extractLocation: function ErrorStackParser$$extractLocation(urlLike) {
                // Fail-fast but return locations like "(native)"
                if (urlLike.indexOf(":") === -1) return [
                    urlLike
                ];
                var regExp = /(.+?)(?:\:(\d+))?(?:\:(\d+))?$/;
                var parts = regExp.exec(urlLike.replace(/[\(\)]/g, ""));
                return [
                    parts[1],
                    parts[2] || undefined,
                    parts[3] || undefined
                ];
            },
            parseV8OrIE: function ErrorStackParser$$parseV8OrIE(error) {
                var filtered = error.stack.split("\n").filter(function(line) {
                    return !!line.match(CHROME_IE_STACK_REGEXP);
                }, this);
                return filtered.map(function(line) {
                    if (line.indexOf("(eval ") > -1) // Throw away eval information until we implement stacktrace.js/stackframe#8
                    line = line.replace(/eval code/g, "eval").replace(/(\(eval at [^\()]*)|(\)\,.*$)/g, "");
                    var sanitizedLine = line.replace(/^\s+/, "").replace(/\(eval code/g, "(");
                    // capture and preseve the parenthesized location "(/foo/my bar.js:12:87)" in
                    // case it has spaces in it, as the string is split on \s+ later on
                    var location = sanitizedLine.match(/ (\((.+):(\d+):(\d+)\)$)/);
                    // remove the parenthesized location from the line, if it was matched
                    sanitizedLine = location ? sanitizedLine.replace(location[0], "") : sanitizedLine;
                    var tokens = sanitizedLine.split(/\s+/).slice(1);
                    // if a location was matched, pass it to extractLocation() otherwise pop the last token
                    var locationParts = this.extractLocation(location ? location[1] : tokens.pop());
                    var functionName = tokens.join(" ") || undefined;
                    var fileName = [
                        "eval",
                        "<anonymous>"
                    ].indexOf(locationParts[0]) > -1 ? undefined : locationParts[0];
                    return new StackFrame({
                        functionName: functionName,
                        fileName: fileName,
                        lineNumber: locationParts[1],
                        columnNumber: locationParts[2],
                        source: line
                    });
                }, this);
            },
            parseFFOrSafari: function ErrorStackParser$$parseFFOrSafari(error) {
                var filtered = error.stack.split("\n").filter(function(line) {
                    return !line.match(SAFARI_NATIVE_CODE_REGEXP);
                }, this);
                return filtered.map(function(line) {
                    // Throw away eval information until we implement stacktrace.js/stackframe#8
                    if (line.indexOf(" > eval") > -1) line = line.replace(/ line (\d+)(?: > eval line \d+)* > eval\:\d+\:\d+/g, ":$1");
                    if (line.indexOf("@") === -1 && line.indexOf(":") === -1) // Safari eval frames only have function names and nothing else
                    return new StackFrame({
                        functionName: line
                    });
                    else {
                        var functionNameRegex = /((.*".+"[^@]*)?[^@]*)(?:@)/;
                        var matches = line.match(functionNameRegex);
                        var functionName = matches && matches[1] ? matches[1] : undefined;
                        var locationParts = this.extractLocation(line.replace(functionNameRegex, ""));
                        return new StackFrame({
                            functionName: functionName,
                            fileName: locationParts[0],
                            lineNumber: locationParts[1],
                            columnNumber: locationParts[2],
                            source: line
                        });
                    }
                }, this);
            },
            parseOpera: function ErrorStackParser$$parseOpera(e) {
                if (!e.stacktrace || e.message.indexOf("\n") > -1 && e.message.split("\n").length > e.stacktrace.split("\n").length) return this.parseOpera9(e);
                else if (!e.stack) return this.parseOpera10(e);
                else return this.parseOpera11(e);
            },
            parseOpera9: function ErrorStackParser$$parseOpera9(e) {
                var lineRE = /Line (\d+).*script (?:in )?(\S+)/i;
                var lines = e.message.split("\n");
                var result = [];
                for(var i = 2, len = lines.length; i < len; i += 2){
                    var match = lineRE.exec(lines[i]);
                    if (match) result.push(new StackFrame({
                        fileName: match[2],
                        lineNumber: match[1],
                        source: lines[i]
                    }));
                }
                return result;
            },
            parseOpera10: function ErrorStackParser$$parseOpera10(e) {
                var lineRE = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i;
                var lines = e.stacktrace.split("\n");
                var result = [];
                for(var i = 0, len = lines.length; i < len; i += 2){
                    var match = lineRE.exec(lines[i]);
                    if (match) result.push(new StackFrame({
                        functionName: match[3] || undefined,
                        fileName: match[2],
                        lineNumber: match[1],
                        source: lines[i]
                    }));
                }
                return result;
            },
            // Opera 10.65+ Error.stack very similar to FF/Safari
            parseOpera11: function ErrorStackParser$$parseOpera11(error) {
                var filtered = error.stack.split("\n").filter(function(line) {
                    return !!line.match(FIREFOX_SAFARI_STACK_REGEXP) && !line.match(/^Error created at/);
                }, this);
                return filtered.map(function(line) {
                    var tokens = line.split("@");
                    var locationParts = this.extractLocation(tokens.pop());
                    var functionCall = tokens.shift() || "";
                    var functionName = functionCall.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^\)]*\)/g, "") || undefined;
                    var argsRaw;
                    if (functionCall.match(/\(([^\)]*)\)/)) argsRaw = functionCall.replace(/^[^\(]+\(([^\)]*)\)$/, "$1");
                    var args = argsRaw === undefined || argsRaw === "[arguments not available]" ? undefined : argsRaw.split(",");
                    return new StackFrame({
                        functionName: functionName,
                        args: args,
                        fileName: locationParts[0],
                        lineNumber: locationParts[1],
                        columnNumber: locationParts[2],
                        source: line
                    });
                }, this);
            }
        };
    });
    var _$errorStackParser_10 = _$errorStackParser_31;
    var _$safeJsonStringify_30 = function(data, replacer, space, opts) {
        var redactedKeys = opts && opts.redactedKeys ? opts.redactedKeys : [];
        var redactedPaths = opts && opts.redactedPaths ? opts.redactedPaths : [];
        return JSON.stringify(prepareObjForSerialization(data, redactedKeys, redactedPaths), replacer, space);
    };
    var MAX_DEPTH = 20;
    var MAX_EDGES = 25000;
    var MIN_PRESERVED_DEPTH = 8;
    var REPLACEMENT_NODE = "...";
    function isError(o) {
        return o instanceof Error || /^\[object (Error|(Dom)?Exception)\]$/.test(Object.prototype.toString.call(o));
    }
    function throwsMessage(err) {
        return "[Throws: " + (err ? err.message : "?") + "]";
    }
    function find(haystack, needle) {
        for(var i = 0, len = haystack.length; i < len; i++){
            if (haystack[i] === needle) return true;
        }
        return false;
    }
    // returns true if the string `path` starts with any of the provided `paths`
    function isDescendent(paths, path) {
        for(var i = 0, len = paths.length; i < len; i++){
            if (path.indexOf(paths[i]) === 0) return true;
        }
        return false;
    }
    function shouldRedact(patterns, key) {
        for(var i = 0, len = patterns.length; i < len; i++){
            if (typeof patterns[i] === "string" && patterns[i].toLowerCase() === key.toLowerCase()) return true;
            if (patterns[i] && typeof patterns[i].test === "function" && patterns[i].test(key)) return true;
        }
        return false;
    }
    function __isArray_30(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    }
    function safelyGetProp(obj, prop) {
        try {
            return obj[prop];
        } catch (err) {
            return throwsMessage(err);
        }
    }
    function prepareObjForSerialization(obj, redactedKeys, redactedPaths) {
        var seen = []; // store references to objects we have seen before
        var edges = 0;
        function visit(obj, path) {
            function edgesExceeded() {
                return path.length > MIN_PRESERVED_DEPTH && edges > MAX_EDGES;
            }
            edges++;
            if (path.length > MAX_DEPTH) return REPLACEMENT_NODE;
            if (edgesExceeded()) return REPLACEMENT_NODE;
            if (obj === null || typeof obj !== "object") return obj;
            if (find(seen, obj)) return "[Circular]";
            seen.push(obj);
            if (typeof obj.toJSON === "function") try {
                // we're not going to count this as an edge because it
                // replaces the value of the currently visited object
                edges--;
                var fResult = visit(obj.toJSON(), path);
                seen.pop();
                return fResult;
            } catch (err) {
                return throwsMessage(err);
            }
            var er = isError(obj);
            if (er) {
                edges--;
                var eResult = visit({
                    name: obj.name,
                    message: obj.message
                }, path);
                seen.pop();
                return eResult;
            }
            if (__isArray_30(obj)) {
                var aResult = [];
                for(var i = 0, len = obj.length; i < len; i++){
                    if (edgesExceeded()) {
                        aResult.push(REPLACEMENT_NODE);
                        break;
                    }
                    aResult.push(visit(obj[i], path.concat("[]")));
                }
                seen.pop();
                return aResult;
            }
            var result = {};
            try {
                for(var prop in obj){
                    if (!Object.prototype.hasOwnProperty.call(obj, prop)) continue;
                    if (isDescendent(redactedPaths, path.join(".")) && shouldRedact(redactedKeys, prop)) {
                        result[prop] = "[REDACTED]";
                        continue;
                    }
                    if (edgesExceeded()) {
                        result[prop] = REPLACEMENT_NODE;
                        break;
                    }
                    result[prop] = visit(safelyGetProp(obj, prop), path.concat(prop));
                }
            } catch (e) {}
            seen.pop();
            return result;
        }
        return visit(obj, []);
    } /* removed: var _$map_16 = require('./es-utils/map'); */ 
    function add(existingFeatures, existingFeatureKeys, name, variant) {
        if (typeof name !== "string") return;
        if (variant === undefined) variant = null;
        else if (variant !== null && typeof variant !== "string") variant = _$safeJsonStringify_30(variant);
        var existingIndex = existingFeatureKeys[name];
        if (typeof existingIndex === "number") {
            existingFeatures[existingIndex] = {
                name: name,
                variant: variant
            };
            return;
        }
        existingFeatures.push({
            name: name,
            variant: variant
        });
        existingFeatureKeys[name] = existingFeatures.length - 1;
    }
    function merge(existingFeatures, newFeatures, existingFeatureKeys) {
        if (!_$isArray_14(newFeatures)) return;
        for(var i = 0; i < newFeatures.length; ++i){
            var feature = newFeatures[i];
            if (feature === null || typeof feature !== "object") continue;
            // 'add' will handle if 'name' doesn't exist & 'variant' is optional
            add(existingFeatures, existingFeatureKeys, feature.name, feature.variant);
        }
        return existingFeatures;
    }
    // convert feature flags from a map of 'name -> variant' into the format required
    // by the Bugsnag Event API:
    //   [{ featureFlag: 'name', variant: 'variant' }, { featureFlag: 'name 2' }]
    function toEventApi(featureFlags) {
        return _$map_16(_$filter_12(featureFlags, Boolean), function(_ref) {
            var name = _ref.name, variant = _ref.variant;
            var flag = {
                featureFlag: name
            };
            // don't add a 'variant' property unless there's actually a value
            if (typeof variant === "string") flag.variant = variant;
            return flag;
        });
    }
    function clear(features, featuresIndex, name) {
        var existingIndex = featuresIndex[name];
        if (typeof existingIndex === "number") {
            features[existingIndex] = null;
            delete featuresIndex[name];
        }
    }
    var _$featureFlagDelegate_18 = {
        add: add,
        clear: clear,
        merge: merge,
        toEventApi: toEventApi
    };
    // Given `err` which may be an error, does it have a stack property which is a string?
    var _$hasStack_19 = function(err) {
        return !!err && (!!err.stack || !!err.stacktrace || !!err["opera#sourceloc"]) && typeof (err.stack || err.stacktrace || err["opera#sourceloc"]) === "string" && err.stack !== err.name + ": " + err.message;
    };
    /**
 * Expose `isError`.
 */ var _$isError_32 = __isError_32;
    /**
 * Test whether `value` is error object.
 *
 * @param {*} value
 * @returns {boolean}
 */ function __isError_32(value) {
        switch(Object.prototype.toString.call(value)){
            case "[object Error]":
                return true;
            case "[object Exception]":
                return true;
            case "[object DOMException]":
                return true;
            default:
                return value instanceof Error;
        }
    }
    var _$iserror_20 = _$isError_32; /* removed: var _$assign_11 = require('./es-utils/assign'); */ 
    var __add_22 = function(state, section, keyOrObj, maybeVal) {
        var _updates;
        if (!section) return;
        var updates;
        // addMetadata("section", null) -> clears section
        if (keyOrObj === null) return __clear_22(state, section);
        // normalise the two supported input types into object form
        if (typeof keyOrObj === "object") updates = keyOrObj;
        if (typeof keyOrObj === "string") updates = (_updates = {}, _updates[keyOrObj] = maybeVal, _updates);
        // exit if we don't have an updates object at this point
        if (!updates) return;
        // ensure a section with this name exists
        if (!state[section]) state[section] = {};
        // merge the updates with the existing section
        state[section] = _$assign_11({}, state[section], updates);
    };
    var get = function(state, section, key) {
        if (typeof section !== "string") return undefined;
        if (!key) return state[section];
        if (state[section]) return state[section][key];
        return undefined;
    };
    var __clear_22 = function(state, section, key) {
        if (typeof section !== "string") return;
        // clear an entire section
        if (!key) {
            delete state[section];
            return;
        }
        // clear a single value from a section
        if (state[section]) delete state[section][key];
    };
    var _$metadataDelegate_22 = {
        add: __add_22,
        get: get,
        clear: __clear_22
    };
    var _$stackGenerator_33 = {};
    (function(root, factory) {
        "use strict";
        // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
        /* istanbul ignore next */ if (typeof define === "function" && define.amd) define("stack-generator", [
            "stackframe"
        ], factory);
        else if (typeof _$stackGenerator_33 === "object") _$stackGenerator_33 = factory(_$stackframe_34);
        else root.StackGenerator = factory(root.StackFrame);
    })(this, function(StackFrame) {
        return {
            backtrace: function StackGenerator$$backtrace(opts) {
                var stack = [];
                var maxStackSize = 10;
                if (typeof opts === "object" && typeof opts.maxStackSize === "number") maxStackSize = opts.maxStackSize;
                var curr = arguments.callee;
                while(curr && stack.length < maxStackSize && curr["arguments"]){
                    // Allow V8 optimizations
                    var args = new Array(curr["arguments"].length);
                    for(var i = 0; i < args.length; ++i)args[i] = curr["arguments"][i];
                    if (/function(?:\s+([\w$]+))+\s*\(/.test(curr.toString())) stack.push(new StackFrame({
                        functionName: RegExp.$1 || undefined,
                        args: args
                    }));
                    else stack.push(new StackFrame({
                        args: args
                    }));
                    try {
                        curr = curr.caller;
                    } catch (e) {
                        break;
                    }
                }
                return stack;
            }
        };
    }); /* removed: var _$errorStackParser_10 = require('./lib/error-stack-parser'); */ 
    var Event = /*#__PURE__*/ function() {
        function Event(errorClass, errorMessage, stacktrace, handledState, originalError) {
            if (stacktrace === void 0) stacktrace = [];
            if (handledState === void 0) handledState = defaultHandledState();
            this.apiKey = undefined;
            this.context = undefined;
            this.groupingHash = undefined;
            this.originalError = originalError;
            this._handledState = handledState;
            this.severity = this._handledState.severity;
            this.unhandled = this._handledState.unhandled;
            this.app = {};
            this.device = {};
            this.request = {};
            this.breadcrumbs = [];
            this.threads = [];
            this._metadata = {};
            this._features = [];
            this._featuresIndex = {};
            this._user = {};
            this._session = undefined;
            this.errors = [
                createBugsnagError(errorClass, errorMessage, Event.__type, stacktrace)
            ];
        // Flags.
        // Note these are not initialised unless they are used
        // to save unnecessary bytes in the browser bundle
        /* this.attemptImmediateDelivery, default: true */ }
        var _proto = Event.prototype;
        _proto.addMetadata = function addMetadata(section, keyOrObj, maybeVal) {
            return _$metadataDelegate_22.add(this._metadata, section, keyOrObj, maybeVal);
        };
        _proto.getMetadata = function getMetadata(section, key) {
            return _$metadataDelegate_22.get(this._metadata, section, key);
        };
        _proto.clearMetadata = function clearMetadata(section, key) {
            return _$metadataDelegate_22.clear(this._metadata, section, key);
        };
        _proto.addFeatureFlag = function addFeatureFlag(name, variant) {
            if (variant === void 0) variant = null;
            _$featureFlagDelegate_18.add(this._features, this._featuresIndex, name, variant);
        };
        _proto.addFeatureFlags = function addFeatureFlags(featureFlags) {
            _$featureFlagDelegate_18.merge(this._features, featureFlags, this._featuresIndex);
        };
        _proto.getFeatureFlags = function getFeatureFlags() {
            return _$featureFlagDelegate_18.toEventApi(this._features);
        };
        _proto.clearFeatureFlag = function clearFeatureFlag(name) {
            _$featureFlagDelegate_18.clear(this._features, this._featuresIndex, name);
        };
        _proto.clearFeatureFlags = function clearFeatureFlags() {
            this._features = [];
            this._featuresIndex = {};
        };
        _proto.getUser = function getUser() {
            return this._user;
        };
        _proto.setUser = function setUser(id, email, name) {
            this._user = {
                id: id,
                email: email,
                name: name
            };
        };
        _proto.toJSON = function toJSON() {
            return {
                payloadVersion: "4",
                exceptions: _$map_16(this.errors, function(er) {
                    return _$assign_11({}, er, {
                        message: er.errorMessage
                    });
                }),
                severity: this.severity,
                unhandled: this._handledState.unhandled,
                severityReason: this._handledState.severityReason,
                app: this.app,
                device: this.device,
                request: this.request,
                breadcrumbs: this.breadcrumbs,
                context: this.context,
                groupingHash: this.groupingHash,
                metaData: this._metadata,
                user: this._user,
                session: this._session,
                featureFlags: this.getFeatureFlags()
            };
        };
        return Event;
    }(); // takes a stacktrace.js style stackframe (https://github.com/stacktracejs/stackframe)
    // and returns a Bugsnag compatible stackframe (https://docs.bugsnag.com/api/error-reporting/#json-payload)
    var formatStackframe = function(frame) {
        var f = {
            file: frame.fileName,
            method: normaliseFunctionName(frame.functionName),
            lineNumber: frame.lineNumber,
            columnNumber: frame.columnNumber,
            code: undefined,
            inProject: undefined
        };
        // Some instances result in no file:
        // - calling notify() from chrome's terminal results in no file/method.
        // - non-error exception thrown from global code in FF
        // This adds one.
        if (f.lineNumber > -1 && !f.file && !f.method) f.file = "global code";
        return f;
    };
    var normaliseFunctionName = function(name) {
        return /^global code$/i.test(name) ? "global code" : name;
    };
    var defaultHandledState = function() {
        return {
            unhandled: false,
            severity: "warning",
            severityReason: {
                type: "handledException"
            }
        };
    };
    var ensureString = function(str) {
        return typeof str === "string" ? str : "";
    };
    function createBugsnagError(errorClass, errorMessage, type, stacktrace) {
        return {
            errorClass: ensureString(errorClass),
            errorMessage: ensureString(errorMessage),
            type: type,
            stacktrace: _$reduce_17(stacktrace, function(accum, frame) {
                var f = formatStackframe(frame);
                // don't include a stackframe if none of its properties are defined
                try {
                    if (JSON.stringify(f) === "{}") return accum;
                    return accum.concat(f);
                } catch (e) {
                    return accum;
                }
            }, [])
        };
    }
    function getCauseStack(error) {
        if (error.cause) return [
            error
        ].concat(getCauseStack(error.cause));
        else return [
            error
        ];
    }
    // Helpers
    Event.getStacktrace = function(error, errorFramesToSkip, backtraceFramesToSkip) {
        if (_$hasStack_19(error)) return _$errorStackParser_10.parse(error).slice(errorFramesToSkip);
        // error wasn't provided or didn't have a stacktrace so try to walk the callstack
        try {
            return _$filter_12(_$stackGenerator_33.backtrace(), function(frame) {
                return (frame.functionName || "").indexOf("StackGenerator$$") === -1;
            }).slice(1 + backtraceFramesToSkip);
        } catch (e) {
            return [];
        }
    };
    Event.create = function(maybeError, tolerateNonErrors, handledState, component, errorFramesToSkip, logger) {
        if (errorFramesToSkip === void 0) errorFramesToSkip = 0;
        var _normaliseError = normaliseError(maybeError, tolerateNonErrors, component, logger), error = _normaliseError[0], internalFrames = _normaliseError[1];
        var event;
        try {
            var stacktrace = Event.getStacktrace(error, // if an error was created/throw in the normaliseError() function, we need to
            // tell the getStacktrace() function to skip the number of frames we know will
            // be from our own functions. This is added to the number of frames deep we
            // were told about
            internalFrames > 0 ? 1 + internalFrames + errorFramesToSkip : 0, // if there's no stacktrace, the callstack may be walked to generated one.
            // this is how many frames should be removed because they come from our library
            1 + errorFramesToSkip);
            event = new Event(error.name, error.message, stacktrace, handledState, maybeError);
        } catch (e) {
            event = new Event(error.name, error.message, [], handledState, maybeError);
        }
        if (error.name === "InvalidError") event.addMetadata("" + component, "non-error parameter", makeSerialisable(maybeError));
        if (error.cause) {
            var _event$errors;
            var causes = getCauseStack(error).slice(1);
            var normalisedCauses = _$map_16(causes, function(cause) {
                // Only get stacktrace for error causes that are a valid JS Error and already have a stack
                var stacktrace = _$iserror_20(cause) && _$hasStack_19(cause) ? _$errorStackParser_10.parse(cause) : [];
                var _normaliseError2 = normaliseError(cause, true, "error cause"), error = _normaliseError2[0];
                if (error.name === "InvalidError") event.addMetadata("error cause", makeSerialisable(cause));
                return createBugsnagError(error.name, error.message, Event.__type, stacktrace);
            });
            (_event$errors = event.errors).push.apply(_event$errors, normalisedCauses);
        }
        return event;
    };
    var makeSerialisable = function(err) {
        if (err === null) return "null";
        if (err === undefined) return "undefined";
        return err;
    };
    var normaliseError = function(maybeError, tolerateNonErrors, component, logger) {
        var error;
        var internalFrames = 0;
        var createAndLogInputError = function(reason) {
            var verb = component === "error cause" ? "was" : "received";
            if (logger) logger.warn(component + " " + verb + ' a non-error: "' + reason + '"');
            var err = new Error(component + " " + verb + ' a non-error. See "' + component + '" tab for more detail.');
            err.name = "InvalidError";
            return err;
        };
        // In some cases:
        //
        //  - the promise rejection handler (both in the browser and node)
        //  - the node uncaughtException handler
        //
        // We are really limited in what we can do to get a stacktrace. So we use the
        // tolerateNonErrors option to ensure that the resulting error communicates as
        // such.
        if (!tolerateNonErrors) {
            if (_$iserror_20(maybeError)) error = maybeError;
            else {
                error = createAndLogInputError(typeof maybeError);
                internalFrames += 2;
            }
        } else switch(typeof maybeError){
            case "string":
            case "number":
            case "boolean":
                error = new Error(String(maybeError));
                internalFrames += 1;
                break;
            case "function":
                error = createAndLogInputError("function");
                internalFrames += 2;
                break;
            case "object":
                if (maybeError !== null && _$iserror_20(maybeError)) error = maybeError;
                else if (maybeError !== null && hasNecessaryFields(maybeError)) {
                    error = new Error(maybeError.message || maybeError.errorMessage);
                    error.name = maybeError.name || maybeError.errorClass;
                    internalFrames += 1;
                } else {
                    error = createAndLogInputError(maybeError === null ? "null" : "unsupported object");
                    internalFrames += 2;
                }
                break;
            default:
                error = createAndLogInputError("nothing");
                internalFrames += 2;
        }
        if (!_$hasStack_19(error)) // in IE10/11 a new Error() doesn't have a stacktrace until you throw it, so try that here
        try {
            throw error;
        } catch (e) {
            if (_$hasStack_19(e)) {
                error = e;
                // if the error only got a stacktrace after we threw it here, we know it
                // will only have one extra internal frame from this function, regardless
                // of whether it went through createAndLogInputError() or not
                internalFrames = 1;
            }
        }
        return [
            error,
            internalFrames
        ];
    };
    // default value for stacktrace.type
    Event.__type = "browserjs";
    var hasNecessaryFields = function(error) {
        return (typeof error.name === "string" || typeof error.errorClass === "string") && (typeof error.message === "string" || typeof error.errorMessage === "string");
    };
    var _$Event_6 = Event;
    // This is a heavily modified/simplified version of
    //   https://github.com/othiym23/async-some
    // with the logic flipped so that it is akin to the
    // synchronous "every" method instead of "some".
    // run the asynchronous test function (fn) over each item in the array (arr)
    // in series until:
    //   - fn(item, cb) => calls cb(null, false)
    //   - or the end of the array is reached
    // the callback (cb) will be passed (null, false) if any of the items in arr
    // caused fn to call back with false, otherwise it will be passed (null, true)
    var _$asyncEvery_7 = function(arr, fn, cb) {
        var index = 0;
        var next = function() {
            if (index >= arr.length) return cb(null, true);
            fn(arr[index], function(err, result) {
                if (err) return cb(err);
                if (result === false) return cb(null, false);
                index++;
                next();
            });
        };
        next();
    }; /* removed: var _$asyncEvery_7 = require('./async-every'); */ 
    var _$callbackRunner_9 = function(callbacks, event, onCallbackError, cb) {
        // This function is how we support different kinds of callback:
        //  - synchronous - return value
        //  - node-style async with callback - cb(err, value)
        //  - promise/thenable - resolve(value)
        // It normalises each of these into the lowest common denominator – a node-style callback
        var runMaybeAsyncCallback = function(fn, cb) {
            if (typeof fn !== "function") return cb(null);
            try {
                // if function appears sync…
                if (fn.length !== 2) {
                    var ret = fn(event);
                    // check if it returned a "thenable" (promise)
                    if (ret && typeof ret.then === "function") return ret.then(// resolve
                    function(val) {
                        return setTimeout(function() {
                            return cb(null, val);
                        });
                    }, // reject
                    function(err) {
                        setTimeout(function() {
                            onCallbackError(err);
                            return cb(null, true);
                        });
                    });
                    return cb(null, ret);
                }
                // if function is async…
                fn(event, function(err, result) {
                    if (err) {
                        onCallbackError(err);
                        return cb(null);
                    }
                    cb(null, result);
                });
            } catch (e) {
                onCallbackError(e);
                cb(null);
            }
        };
        _$asyncEvery_7(callbacks, runMaybeAsyncCallback, cb);
    };
    var _$syncCallbackRunner_23 = function(callbacks, callbackArg, callbackType, logger) {
        var ignore = false;
        var cbs = callbacks.slice();
        while(!ignore){
            if (!cbs.length) break;
            try {
                ignore = cbs.pop()(callbackArg) === false;
            } catch (e) {
                logger.error("Error occurred in " + callbackType + " callback, continuing anyway\u2026");
                logger.error(e);
            }
        }
        return ignore;
    };
    var _$pad_29 = function pad(num, size) {
        var s = "000000000" + num;
        return s.substr(s.length - size);
    }; /* removed: var _$pad_29 = require('./pad.js'); */ 
    var env = typeof window === "object" ? window : self;
    var globalCount = 0;
    for(var prop in env)if (Object.hasOwnProperty.call(env, prop)) globalCount++;
    var mimeTypesLength = navigator.mimeTypes ? navigator.mimeTypes.length : 0;
    var clientId = _$pad_29((mimeTypesLength + navigator.userAgent.length).toString(36) + globalCount.toString(36), 4);
    var _$fingerprint_28 = function fingerprint() {
        return clientId;
    }; /* removed: var _$fingerprint_28 = require('./lib/fingerprint.js'); */ 
    var c = 0, blockSize = 4, base = 36, discreteValues = Math.pow(base, blockSize);
    function randomBlock() {
        return _$pad_29((Math.random() * discreteValues << 0).toString(base), blockSize);
    }
    function safeCounter() {
        c = c < discreteValues ? c : 0;
        c++; // this is not subliminal
        return c - 1;
    }
    function cuid() {
        // Starting with a lowercase letter makes
        // it HTML element ID friendly.
        var letter = "c", // hard-coded allows for sequential access
        // timestamp
        // warning: this exposes the exact date and time
        // that the uid was created.
        timestamp = new Date().getTime().toString(base), // Prevent same-machine collisions.
        counter = _$pad_29(safeCounter().toString(base), blockSize), // A few chars to generate distinct ids for different
        // clients (so different computers are far less
        // likely to generate the same id)
        print = _$fingerprint_28(), // Grab some more chars from Math.random()
        random = randomBlock() + randomBlock();
        return letter + timestamp + counter + print + random;
    }
    cuid.fingerprint = _$fingerprint_28;
    var _$cuid_27 = cuid; /* removed: var _$cuid_27 = require('@bugsnag/cuid'); */ 
    var Session = /*#__PURE__*/ function() {
        function Session() {
            this.id = _$cuid_27();
            this.startedAt = new Date();
            this._handled = 0;
            this._unhandled = 0;
            this._user = {};
            this.app = {};
            this.device = {};
        }
        var _proto = Session.prototype;
        _proto.getUser = function getUser() {
            return this._user;
        };
        _proto.setUser = function setUser(id, email, name) {
            this._user = {
                id: id,
                email: email,
                name: name
            };
        };
        _proto.toJSON = function toJSON() {
            return {
                id: this.id,
                startedAt: this.startedAt,
                events: {
                    handled: this._handled,
                    unhandled: this._unhandled
                }
            };
        };
        _proto._track = function _track(event) {
            this[event._handledState.unhandled ? "_unhandled" : "_handled"] += 1;
        };
        return Session;
    }();
    var _$Session_35 = Session; /* removed: var _$config_5 = require('./config'); */ 
    var __add_4 = _$featureFlagDelegate_18.add, __clear_4 = _$featureFlagDelegate_18.clear, __merge_4 = _$featureFlagDelegate_18.merge;
    var noop = function() {};
    var Client = /*#__PURE__*/ function() {
        function Client(configuration, schema, internalPlugins, notifier) {
            var _this = this;
            if (schema === void 0) schema = _$config_5.schema;
            if (internalPlugins === void 0) internalPlugins = [];
            // notifier id
            this._notifier = notifier;
            // intialise opts and config
            this._config = {};
            this._schema = schema;
            // i/o
            this._delivery = {
                sendSession: noop,
                sendEvent: noop
            };
            this._logger = {
                debug: noop,
                info: noop,
                warn: noop,
                error: noop
            };
            // plugins
            this._plugins = {};
            // state
            this._breadcrumbs = [];
            this._session = null;
            this._metadata = {};
            this._featuresIndex = {};
            this._features = [];
            this._context = undefined;
            this._user = {};
            // callbacks:
            //  e: onError
            //  s: onSession
            //  sp: onSessionPayload
            //  b: onBreadcrumb
            // (note these names are minified by hand because object
            // properties are not safe to minify automatically)
            this._cbs = {
                e: [],
                s: [],
                sp: [],
                b: []
            };
            // expose internal constructors
            this.Client = Client;
            this.Event = _$Event_6;
            this.Breadcrumb = _$Breadcrumb_3;
            this.Session = _$Session_35;
            this._config = this._configure(configuration, internalPlugins);
            _$map_16(internalPlugins.concat(this._config.plugins), function(pl) {
                if (pl) _this._loadPlugin(pl);
            });
            // when notify() is called we need to know how many frames are from our own source
            // this inital value is 1 not 0 because we wrap notify() to ensure it is always
            // bound to have the client as its `this` value – see below.
            this._depth = 1;
            var self1 = this;
            var notify = this.notify;
            this.notify = function() {
                return notify.apply(self1, arguments);
            };
        }
        var _proto = Client.prototype;
        _proto.addMetadata = function addMetadata(section, keyOrObj, maybeVal) {
            return _$metadataDelegate_22.add(this._metadata, section, keyOrObj, maybeVal);
        };
        _proto.getMetadata = function getMetadata(section, key) {
            return _$metadataDelegate_22.get(this._metadata, section, key);
        };
        _proto.clearMetadata = function clearMetadata(section, key) {
            return _$metadataDelegate_22.clear(this._metadata, section, key);
        };
        _proto.addFeatureFlag = function addFeatureFlag(name, variant) {
            if (variant === void 0) variant = null;
            __add_4(this._features, this._featuresIndex, name, variant);
        };
        _proto.addFeatureFlags = function addFeatureFlags(featureFlags) {
            __merge_4(this._features, featureFlags, this._featuresIndex);
        };
        _proto.clearFeatureFlag = function clearFeatureFlag(name) {
            __clear_4(this._features, this._featuresIndex, name);
        };
        _proto.clearFeatureFlags = function clearFeatureFlags() {
            this._features = [];
            this._featuresIndex = {};
        };
        _proto.getContext = function getContext() {
            return this._context;
        };
        _proto.setContext = function setContext(c) {
            this._context = c;
        };
        _proto._configure = function _configure(opts, internalPlugins) {
            var schema = _$reduce_17(internalPlugins, function(schema, plugin) {
                if (plugin && plugin.configSchema) return _$assign_11({}, schema, plugin.configSchema);
                return schema;
            }, this._schema);
            // accumulate configuration and error messages
            var _reduce = _$reduce_17(_$keys_15(schema), function(accum, key) {
                var defaultValue = schema[key].defaultValue(opts[key]);
                if (opts[key] !== undefined) {
                    var valid = schema[key].validate(opts[key]);
                    if (!valid) {
                        accum.errors[key] = schema[key].message;
                        accum.config[key] = defaultValue;
                    } else if (schema[key].allowPartialObject) accum.config[key] = _$assign_11(defaultValue, opts[key]);
                    else accum.config[key] = opts[key];
                } else accum.config[key] = defaultValue;
                return accum;
            }, {
                errors: {},
                config: {}
            }), errors = _reduce.errors, config = _reduce.config;
            if (schema.apiKey) {
                // missing api key is the only fatal error
                if (!config.apiKey) throw new Error("No Bugsnag API Key set");
                // warn about an apikey that is not of the expected format
                if (!/^[0-9a-f]{32}$/i.test(config.apiKey)) errors.apiKey = "should be a string of 32 hexadecimal characters";
            }
            // update and elevate some options
            this._metadata = _$assign_11({}, config.metadata);
            __merge_4(this._features, config.featureFlags, this._featuresIndex);
            this._user = _$assign_11({}, config.user);
            this._context = config.context;
            if (config.logger) this._logger = config.logger;
            // add callbacks
            if (config.onError) this._cbs.e = this._cbs.e.concat(config.onError);
            if (config.onBreadcrumb) this._cbs.b = this._cbs.b.concat(config.onBreadcrumb);
            if (config.onSession) this._cbs.s = this._cbs.s.concat(config.onSession);
            // finally warn about any invalid config where we fell back to the default
            if (_$keys_15(errors).length) this._logger.warn(generateConfigErrorMessage(errors, opts));
            return config;
        };
        _proto.getUser = function getUser() {
            return this._user;
        };
        _proto.setUser = function setUser(id, email, name) {
            this._user = {
                id: id,
                email: email,
                name: name
            };
        };
        _proto._loadPlugin = function _loadPlugin(plugin) {
            var result = plugin.load(this);
            // JS objects are not the safest way to store arbitrarily keyed values,
            // so bookend the key with some characters that prevent tampering with
            // stuff like __proto__ etc. (only store the result if the plugin had a
            // name)
            if (plugin.name) this._plugins["~" + plugin.name + "~"] = result;
            return this;
        };
        _proto.getPlugin = function getPlugin(name) {
            return this._plugins["~" + name + "~"];
        };
        _proto._setDelivery = function _setDelivery(d) {
            this._delivery = d(this);
        };
        _proto.startSession = function startSession() {
            var session = new _$Session_35();
            session.app.releaseStage = this._config.releaseStage;
            session.app.version = this._config.appVersion;
            session.app.type = this._config.appType;
            session._user = _$assign_11({}, this._user);
            // run onSession callbacks
            var ignore = _$syncCallbackRunner_23(this._cbs.s, session, "onSession", this._logger);
            if (ignore) {
                this._logger.debug("Session not started due to onSession callback");
                return this;
            }
            return this._sessionDelegate.startSession(this, session);
        };
        _proto.addOnError = function addOnError(fn, front) {
            if (front === void 0) front = false;
            this._cbs.e[front ? "unshift" : "push"](fn);
        };
        _proto.removeOnError = function removeOnError(fn) {
            this._cbs.e = _$filter_12(this._cbs.e, function(f) {
                return f !== fn;
            });
        };
        _proto._addOnSessionPayload = function _addOnSessionPayload(fn) {
            this._cbs.sp.push(fn);
        };
        _proto.addOnSession = function addOnSession(fn) {
            this._cbs.s.push(fn);
        };
        _proto.removeOnSession = function removeOnSession(fn) {
            this._cbs.s = _$filter_12(this._cbs.s, function(f) {
                return f !== fn;
            });
        };
        _proto.addOnBreadcrumb = function addOnBreadcrumb(fn, front) {
            if (front === void 0) front = false;
            this._cbs.b[front ? "unshift" : "push"](fn);
        };
        _proto.removeOnBreadcrumb = function removeOnBreadcrumb(fn) {
            this._cbs.b = _$filter_12(this._cbs.b, function(f) {
                return f !== fn;
            });
        };
        _proto.pauseSession = function pauseSession() {
            return this._sessionDelegate.pauseSession(this);
        };
        _proto.resumeSession = function resumeSession() {
            return this._sessionDelegate.resumeSession(this);
        };
        _proto.leaveBreadcrumb = function leaveBreadcrumb(message, metadata, type) {
            // coerce bad values so that the defaults get set
            message = typeof message === "string" ? message : "";
            type = typeof type === "string" && _$includes_13(_$breadcrumbTypes_8, type) ? type : "manual";
            metadata = typeof metadata === "object" && metadata !== null ? metadata : {};
            // if no message, discard
            if (!message) return;
            var crumb = new _$Breadcrumb_3(message, metadata, type);
            // run onBreadcrumb callbacks
            var ignore = _$syncCallbackRunner_23(this._cbs.b, crumb, "onBreadcrumb", this._logger);
            if (ignore) {
                this._logger.debug("Breadcrumb not attached due to onBreadcrumb callback");
                return;
            }
            // push the valid crumb onto the queue and maintain the length
            this._breadcrumbs.push(crumb);
            if (this._breadcrumbs.length > this._config.maxBreadcrumbs) this._breadcrumbs = this._breadcrumbs.slice(this._breadcrumbs.length - this._config.maxBreadcrumbs);
        };
        _proto._isBreadcrumbTypeEnabled = function _isBreadcrumbTypeEnabled(type) {
            var types = this._config.enabledBreadcrumbTypes;
            return types === null || _$includes_13(types, type);
        };
        _proto.notify = function notify(maybeError, onError, postReportCallback) {
            if (postReportCallback === void 0) postReportCallback = noop;
            var event = _$Event_6.create(maybeError, true, undefined, "notify()", this._depth + 1, this._logger);
            this._notify(event, onError, postReportCallback);
        };
        _proto._notify = function _notify(event, onError, postReportCallback) {
            var _this2 = this;
            if (postReportCallback === void 0) postReportCallback = noop;
            event.app = _$assign_11({}, event.app, {
                releaseStage: this._config.releaseStage,
                version: this._config.appVersion,
                type: this._config.appType
            });
            event.context = event.context || this._context;
            event._metadata = _$assign_11({}, event._metadata, this._metadata);
            event._user = _$assign_11({}, event._user, this._user);
            event.breadcrumbs = this._breadcrumbs.slice();
            __merge_4(event._features, this._features, event._featuresIndex);
            // exit early if events should not be sent on the current releaseStage
            if (this._config.enabledReleaseStages !== null && !_$includes_13(this._config.enabledReleaseStages, this._config.releaseStage)) {
                this._logger.warn("Event not sent due to releaseStage/enabledReleaseStages configuration");
                return postReportCallback(null, event);
            }
            var originalSeverity = event.severity;
            var onCallbackError = function(err) {
                // errors in callbacks are tolerated but we want to log them out
                _this2._logger.error("Error occurred in onError callback, continuing anyway\u2026");
                _this2._logger.error(err);
            };
            var callbacks = [].concat(this._cbs.e).concat(onError);
            _$callbackRunner_9(callbacks, event, onCallbackError, function(err, shouldSend) {
                if (err) onCallbackError(err);
                if (!shouldSend) {
                    _this2._logger.debug("Event not sent due to onError callback");
                    return postReportCallback(null, event);
                }
                if (_this2._isBreadcrumbTypeEnabled("error")) // only leave a crumb for the error if actually got sent
                Client.prototype.leaveBreadcrumb.call(_this2, event.errors[0].errorClass, {
                    errorClass: event.errors[0].errorClass,
                    errorMessage: event.errors[0].errorMessage,
                    severity: event.severity
                }, "error");
                if (originalSeverity !== event.severity) event._handledState.severityReason = {
                    type: "userCallbackSetSeverity"
                };
                if (event.unhandled !== event._handledState.unhandled) {
                    event._handledState.severityReason.unhandledOverridden = true;
                    event._handledState.unhandled = event.unhandled;
                }
                if (_this2._session) {
                    _this2._session._track(event);
                    event._session = _this2._session;
                }
                _this2._delivery.sendEvent({
                    apiKey: event.apiKey || _this2._config.apiKey,
                    notifier: _this2._notifier,
                    events: [
                        event
                    ]
                }, function(err) {
                    return postReportCallback(err, event);
                });
            });
        };
        return Client;
    }();
    var generateConfigErrorMessage = function(errors, rawInput) {
        var er = new Error("Invalid configuration\n" + _$map_16(_$keys_15(errors), function(key) {
            return "  - " + key + " " + errors[key] + ", got " + stringify(rawInput[key]);
        }).join("\n\n"));
        return er;
    };
    var stringify = function(val) {
        switch(typeof val){
            case "string":
            case "number":
            case "object":
                return JSON.stringify(val);
            default:
                return String(val);
        }
    };
    var _$Client_4 = Client;
    var _$jsonPayload_21 = {}; /* removed: var _$safeJsonStringify_30 = require('@bugsnag/safe-json-stringify'); */ 
    var EVENT_REDACTION_PATHS = [
        "events.[].metaData",
        "events.[].breadcrumbs.[].metaData",
        "events.[].request"
    ];
    _$jsonPayload_21.event = function(event, redactedKeys) {
        var payload = _$safeJsonStringify_30(event, null, null, {
            redactedPaths: EVENT_REDACTION_PATHS,
            redactedKeys: redactedKeys
        });
        if (payload.length > 10e5) {
            event.events[0]._metadata = {
                notifier: "WARNING!\nSerialized payload was " + payload.length / 10e5 + "MB (limit = 1MB)\nmetadata was removed"
            };
            payload = _$safeJsonStringify_30(event, null, null, {
                redactedPaths: EVENT_REDACTION_PATHS,
                redactedKeys: redactedKeys
            });
        }
        return payload;
    };
    _$jsonPayload_21.session = function(session, redactedKeys) {
        var payload = _$safeJsonStringify_30(session, null, null);
        return payload;
    };
    var _$delivery_36 = {}; /* removed: var _$jsonPayload_21 = require('@bugsnag/core/lib/json-payload'); */ 
    _$delivery_36 = function(client, win) {
        if (win === void 0) win = window;
        return {
            sendEvent: function(event, cb) {
                if (cb === void 0) cb = function() {};
                var url = getApiUrl(client._config, "notify", "4", win);
                var body = _$jsonPayload_21.event(event, client._config.redactedKeys);
                var req = new win.XDomainRequest();
                req.onload = function() {
                    cb(null);
                };
                req.onerror = function() {
                    var err = new Error("Event failed to send");
                    client._logger.error("Event failed to send\u2026", err);
                    if (body.length > 10e5) client._logger.warn("Event oversized (" + (body.length / 10e5).toFixed(2) + " MB)");
                    cb(err);
                };
                req.open("POST", url);
                setTimeout(function() {
                    try {
                        req.send(body);
                    } catch (e) {
                        client._logger.error(e);
                        cb(e);
                    }
                }, 0);
            },
            sendSession: function(session, cb) {
                if (cb === void 0) cb = function() {};
                var url = getApiUrl(client._config, "sessions", "1", win);
                var req = new win.XDomainRequest();
                req.onload = function() {
                    cb(null);
                };
                req.open("POST", url);
                setTimeout(function() {
                    try {
                        req.send(_$jsonPayload_21.session(session, client._config.redactedKeys));
                    } catch (e) {
                        client._logger.error(e);
                        cb(e);
                    }
                }, 0);
            }
        };
    };
    var getApiUrl = function(config, endpoint, version, win) {
        // IE8 doesn't support Date.prototype.toISOstring(), but it does convert a date
        // to an ISO string when you use JSON stringify. Simply parsing the result of
        // JSON.stringify is smaller than using a toISOstring() polyfill.
        var isoDate = JSON.parse(JSON.stringify(new Date()));
        var url = matchPageProtocol(config.endpoints[endpoint], win.location.protocol);
        return url + "?apiKey=" + encodeURIComponent(config.apiKey) + "&payloadVersion=" + version + "&sentAt=" + encodeURIComponent(isoDate);
    };
    var matchPageProtocol = _$delivery_36._matchPageProtocol = function(endpoint, pageProtocol) {
        return pageProtocol === "http:" ? endpoint.replace(/^https:/, "http:") : endpoint;
    }; /* removed: var _$jsonPayload_21 = require('@bugsnag/core/lib/json-payload'); */ 
    var _$delivery_37 = function(client, win) {
        if (win === void 0) win = window;
        return {
            sendEvent: function(event, cb) {
                if (cb === void 0) cb = function() {};
                try {
                    var url = client._config.endpoints.notify;
                    var req = new win.XMLHttpRequest();
                    var body = _$jsonPayload_21.event(event, client._config.redactedKeys);
                    req.onreadystatechange = function() {
                        if (req.readyState === win.XMLHttpRequest.DONE) {
                            var status = req.status;
                            if (status === 0 || status >= 400) {
                                var err = new Error("Request failed with status " + status);
                                client._logger.error("Event failed to send\u2026", err);
                                if (body.length > 10e5) client._logger.warn("Event oversized (" + (body.length / 10e5).toFixed(2) + " MB)");
                                cb(err);
                            } else cb(null);
                        }
                    };
                    req.open("POST", url);
                    req.setRequestHeader("Content-Type", "application/json");
                    req.setRequestHeader("Bugsnag-Api-Key", event.apiKey || client._config.apiKey);
                    req.setRequestHeader("Bugsnag-Payload-Version", "4");
                    req.setRequestHeader("Bugsnag-Sent-At", new Date().toISOString());
                    req.send(body);
                } catch (e) {
                    client._logger.error(e);
                }
            },
            sendSession: function(session, cb) {
                if (cb === void 0) cb = function() {};
                try {
                    var url = client._config.endpoints.sessions;
                    var req = new win.XMLHttpRequest();
                    req.onreadystatechange = function() {
                        if (req.readyState === win.XMLHttpRequest.DONE) {
                            var status = req.status;
                            if (status === 0 || status >= 400) {
                                var err = new Error("Request failed with status " + status);
                                client._logger.error("Session failed to send\u2026", err);
                                cb(err);
                            } else cb(null);
                        }
                    };
                    req.open("POST", url);
                    req.setRequestHeader("Content-Type", "application/json");
                    req.setRequestHeader("Bugsnag-Api-Key", client._config.apiKey);
                    req.setRequestHeader("Bugsnag-Payload-Version", "1");
                    req.setRequestHeader("Bugsnag-Sent-At", new Date().toISOString());
                    req.send(_$jsonPayload_21.session(session, client._config.redactedKeys));
                } catch (e) {
                    client._logger.error(e);
                }
            }
        };
    };
    var appStart = new Date();
    var reset = function() {
        appStart = new Date();
    };
    var _$app_38 = {
        name: "appDuration",
        load: function(client) {
            client.addOnError(function(event) {
                var now = new Date();
                event.app.duration = now - appStart;
            }, true);
            return {
                reset: reset
            };
        }
    };
    /*
 * Sets the default context to be the current URL
 */ var _$context_39 = function(win) {
        if (win === void 0) win = window;
        return {
            load: function(client) {
                client.addOnError(function(event) {
                    if (event.context !== undefined) return;
                    event.context = win.location.pathname;
                }, true);
            }
        };
    };
    var _$pad_43 = function pad(num, size) {
        var s = "000000000" + num;
        return s.substr(s.length - size);
    }; /* removed: var _$pad_43 = require('./pad.js'); */ 
    var __env_42 = typeof window === "object" ? window : self;
    var __globalCount_42 = 0;
    for(var __prop_42 in __env_42)if (Object.hasOwnProperty.call(__env_42, __prop_42)) __globalCount_42++;
    var __mimeTypesLength_42 = navigator.mimeTypes ? navigator.mimeTypes.length : 0;
    var __clientId_42 = _$pad_43((__mimeTypesLength_42 + navigator.userAgent.length).toString(36) + __globalCount_42.toString(36), 4);
    var _$fingerprint_42 = function fingerprint() {
        return __clientId_42;
    }; /* removed: var _$fingerprint_42 = require('./lib/fingerprint.js'); */ 
    var __c_41 = 0, __blockSize_41 = 4, __base_41 = 36, __discreteValues_41 = Math.pow(__base_41, __blockSize_41);
    function __randomBlock_41() {
        return _$pad_43((Math.random() * __discreteValues_41 << 0).toString(__base_41), __blockSize_41);
    }
    function __safeCounter_41() {
        __c_41 = __c_41 < __discreteValues_41 ? __c_41 : 0;
        __c_41++; // this is not subliminal
        return __c_41 - 1;
    }
    function __cuid_41() {
        // Starting with a lowercase letter makes
        // it HTML element ID friendly.
        var letter = "c", // hard-coded allows for sequential access
        // timestamp
        // warning: this exposes the exact date and time
        // that the uid was created.
        timestamp = new Date().getTime().toString(__base_41), // Prevent same-machine collisions.
        counter = _$pad_43(__safeCounter_41().toString(__base_41), __blockSize_41), // A few chars to generate distinct ids for different
        // clients (so different computers are far less
        // likely to generate the same id)
        print = _$fingerprint_42(), // Grab some more chars from Math.random()
        random = __randomBlock_41() + __randomBlock_41();
        return letter + timestamp + counter + print + random;
    }
    __cuid_41.fingerprint = _$fingerprint_42;
    var _$cuid_41 = __cuid_41; /* removed: var _$assign_11 = require('@bugsnag/core/lib/es-utils/assign'); */ 
    var BUGSNAG_ANONYMOUS_ID_KEY = "bugsnag-anonymous-id";
    var getDeviceId = function(win) {
        try {
            var storage = win.localStorage;
            var id = storage.getItem(BUGSNAG_ANONYMOUS_ID_KEY);
            // If we get an ID, make sure it looks like a valid cuid. The length can
            // fluctuate slightly, so some leeway is built in
            if (id && /^c[a-z0-9]{20,32}$/.test(id)) return id;
             /* removed: var _$cuid_41 = require('@bugsnag/cuid'); */ 
            id = _$cuid_41();
            storage.setItem(BUGSNAG_ANONYMOUS_ID_KEY, id);
            return id;
        } catch (err) {
        // If localStorage is not available (e.g. because it's disabled) then give up
        }
    };
    /*
 * Automatically detects browser device details
 */ var _$device_40 = function(nav, win) {
        if (nav === void 0) nav = navigator;
        if (win === void 0) win = window;
        return {
            load: function(client) {
                var device = {
                    locale: nav.browserLanguage || nav.systemLanguage || nav.userLanguage || nav.language,
                    userAgent: nav.userAgent
                };
                if (win && win.screen && win.screen.orientation && win.screen.orientation.type) device.orientation = win.screen.orientation.type;
                else if (win && win.document) device.orientation = win.document.documentElement.clientWidth > win.document.documentElement.clientHeight ? "landscape" : "portrait";
                if (client._config.generateAnonymousId) device.id = getDeviceId(win);
                client.addOnSession(function(session) {
                    session.device = _$assign_11({}, session.device, device);
                    // only set device id if collectUserIp is false
                    if (!client._config.collectUserIp) setDefaultUserId(session);
                });
                // add time just as the event is sent
                client.addOnError(function(event) {
                    event.device = _$assign_11({}, event.device, device, {
                        time: new Date()
                    });
                    if (!client._config.collectUserIp) setDefaultUserId(event);
                }, true);
            },
            configSchema: {
                generateAnonymousId: {
                    validate: function(value) {
                        return value === true || value === false;
                    },
                    defaultValue: function() {
                        return true;
                    },
                    message: "should be true|false"
                }
            }
        };
    };
    var setDefaultUserId = function(eventOrSession) {
        // device id is also used to populate the user id field, if it's not already set
        var user = eventOrSession.getUser();
        if (!user || !user.id) eventOrSession.setUser(eventOrSession.device.id);
    }; /* removed: var _$assign_11 = require('@bugsnag/core/lib/es-utils/assign'); */ 
    /*
 * Sets the event request: { url } to be the current href
 */ var _$request_44 = function(win) {
        if (win === void 0) win = window;
        return {
            load: function(client) {
                client.addOnError(function(event) {
                    if (event.request && event.request.url) return;
                    event.request = _$assign_11({}, event.request, {
                        url: win.location.href
                    });
                }, true);
            }
        };
    }; /* removed: var _$includes_13 = require('@bugsnag/core/lib/es-utils/includes'); */ 
    var _$session_45 = {
        load: function(client) {
            client._sessionDelegate = sessionDelegate;
        }
    };
    var sessionDelegate = {
        startSession: function(client, session) {
            var sessionClient = client;
            sessionClient._session = session;
            sessionClient._pausedSession = null;
            // exit early if the current releaseStage is not enabled
            if (sessionClient._config.enabledReleaseStages !== null && !_$includes_13(sessionClient._config.enabledReleaseStages, sessionClient._config.releaseStage)) {
                sessionClient._logger.warn("Session not sent due to releaseStage/enabledReleaseStages configuration");
                return sessionClient;
            }
            sessionClient._delivery.sendSession({
                notifier: sessionClient._notifier,
                device: session.device,
                app: session.app,
                sessions: [
                    {
                        id: session.id,
                        startedAt: session.startedAt,
                        user: session._user
                    }
                ]
            });
            return sessionClient;
        },
        resumeSession: function(client) {
            // Do nothing if there's already an active session
            if (client._session) return client;
            // If we have a paused session then make it the active session
            if (client._pausedSession) {
                client._session = client._pausedSession;
                client._pausedSession = null;
                return client;
            }
            // Otherwise start a new session
            return client.startSession();
        },
        pauseSession: function(client) {
            client._pausedSession = client._session;
            client._session = null;
        }
    }; /* removed: var _$assign_11 = require('@bugsnag/core/lib/es-utils/assign'); */ 
    /*
 * Prevent collection of user IPs
 */ var _$clientIp_46 = {
        load: function(client) {
            if (client._config.collectUserIp) return;
            client.addOnError(function(event) {
                // If user.id is explicitly undefined, it will be missing from the payload. It needs
                // removing so that the following line replaces it
                if (event._user && typeof event._user.id === "undefined") delete event._user.id;
                event._user = _$assign_11({
                    id: "[REDACTED]"
                }, event._user);
                event.request = _$assign_11({
                    clientIp: "[REDACTED]"
                }, event.request);
            });
        },
        configSchema: {
            collectUserIp: {
                defaultValue: function() {
                    return true;
                },
                message: "should be true|false",
                validate: function(value) {
                    return value === true || value === false;
                }
            }
        }
    };
    var _$consoleBreadcrumbs_47 = {}; /* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */ 
    /*
 * Leaves breadcrumbs when console log methods are called
 */ _$consoleBreadcrumbs_47.load = function(client) {
        var isDev = /^(local-)?dev(elopment)?$/.test(client._config.releaseStage);
        if (isDev || !client._isBreadcrumbTypeEnabled("log")) return;
        _$map_16(CONSOLE_LOG_METHODS, function(method) {
            var original = console[method];
            console[method] = function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                client.leaveBreadcrumb("Console output", _$reduce_17(args, function(accum, arg, i) {
                    // do the best/simplest stringification of each argument
                    var stringified = "[Unknown value]";
                    // this may fail if the input is:
                    // - an object whose [[Prototype]] is null (no toString)
                    // - an object with a broken toString or @@toPrimitive implementation
                    try {
                        stringified = String(arg);
                    } catch (e) {}
                    // if it stringifies to [object Object] attempt to JSON stringify
                    if (stringified === "[object Object]") // catch stringify errors and fallback to [object Object]
                    try {
                        stringified = JSON.stringify(arg);
                    } catch (e) {}
                    accum["[" + i + "]"] = stringified;
                    return accum;
                }, {
                    severity: method.indexOf("group") === 0 ? "log" : method
                }), "log");
                original.apply(console, args);
            };
            console[method]._restore = function() {
                console[method] = original;
            };
        });
    };
    var CONSOLE_LOG_METHODS = _$filter_12([
        "log",
        "debug",
        "info",
        "warn",
        "error"
    ], function(method) {
        return typeof console !== "undefined" && typeof console[method] === "function";
    }); /* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */ 
    var MAX_LINE_LENGTH = 200;
    var MAX_SCRIPT_LENGTH = 500000;
    var _$inlineScriptContent_48 = function(doc, win) {
        if (doc === void 0) doc = document;
        if (win === void 0) win = window;
        return {
            load: function(client) {
                if (!client._config.trackInlineScripts) return;
                var originalLocation = win.location.href;
                var html = "";
                // in IE8-10 the 'interactive' state can fire too soon (before scripts have finished executing), so in those
                // we wait for the 'complete' state before assuming that synchronous scripts are no longer executing
                var isOldIe = !!doc.attachEvent;
                var DOMContentLoaded = isOldIe ? doc.readyState === "complete" : doc.readyState !== "loading";
                var getHtml = function() {
                    return doc.documentElement.outerHTML;
                };
                // get whatever HTML exists at this point in time
                html = getHtml();
                var prev = doc.onreadystatechange;
                // then update it when the DOM content has loaded
                doc.onreadystatechange = function() {
                    // IE8 compatible alternative to document#DOMContentLoaded
                    if (doc.readyState === "interactive") {
                        html = getHtml();
                        DOMContentLoaded = true;
                    }
                    try {
                        prev.apply(this, arguments);
                    } catch (e) {}
                };
                var _lastScript = null;
                var updateLastScript = function(script) {
                    _lastScript = script;
                };
                var getCurrentScript = function() {
                    var script = doc.currentScript || _lastScript;
                    if (!script && !DOMContentLoaded) {
                        var scripts = doc.scripts || doc.getElementsByTagName("script");
                        script = scripts[scripts.length - 1];
                    }
                    return script;
                };
                var addSurroundingCode = function(lineNumber) {
                    // get whatever html has rendered at this point
                    if (!DOMContentLoaded || !html) html = getHtml();
                    // simulate the raw html
                    var htmlLines = [
                        "<!-- DOC START -->"
                    ].concat(html.split("\n"));
                    var zeroBasedLine = lineNumber - 1;
                    var start = Math.max(zeroBasedLine - 3, 0);
                    var end = Math.min(zeroBasedLine + 3, htmlLines.length);
                    return _$reduce_17(htmlLines.slice(start, end), function(accum, line, i) {
                        accum[start + 1 + i] = line.length <= MAX_LINE_LENGTH ? line : line.substr(0, MAX_LINE_LENGTH);
                        return accum;
                    }, {});
                };
                client.addOnError(function(event) {
                    // remove any of our own frames that may be part the stack this
                    // happens before the inline script check as it happens for all errors
                    event.errors[0].stacktrace = _$filter_12(event.errors[0].stacktrace, function(f) {
                        return !/__trace__$/.test(f.method);
                    });
                    var frame = event.errors[0].stacktrace[0];
                    // remove hash and query string from url
                    var cleanUrl = function(url) {
                        return url.replace(/#.*$/, "").replace(/\?.*$/, "");
                    };
                    // if frame.file exists and is not the original location of the page, this can't be an inline script
                    if (frame && frame.file && cleanUrl(frame.file) !== cleanUrl(originalLocation)) return;
                    // grab the last script known to have run
                    var currentScript = getCurrentScript();
                    if (currentScript) {
                        var content = currentScript.innerHTML;
                        event.addMetadata("script", "content", content.length <= MAX_SCRIPT_LENGTH ? content : content.substr(0, MAX_SCRIPT_LENGTH));
                        // only attempt to grab some surrounding code if we have a line number
                        if (frame && frame.lineNumber) frame.code = addSurroundingCode(frame.lineNumber);
                    }
                }, true);
                // Proxy all the timer functions whose callback is their 0th argument.
                // Keep a reference to the original setTimeout because we need it later
                var _map = _$map_16([
                    "setTimeout",
                    "setInterval",
                    "setImmediate",
                    "requestAnimationFrame"
                ], function(fn) {
                    return __proxy(win, fn, function(original) {
                        return __traceOriginalScript(original, function(args) {
                            return {
                                get: function() {
                                    return args[0];
                                },
                                replace: function(fn) {
                                    args[0] = fn;
                                }
                            };
                        });
                    });
                }), _setTimeout = _map[0];
                // Proxy all the host objects whose prototypes have an addEventListener function
                _$map_16([
                    "EventTarget",
                    "Window",
                    "Node",
                    "ApplicationCache",
                    "AudioTrackList",
                    "ChannelMergerNode",
                    "CryptoOperation",
                    "EventSource",
                    "FileReader",
                    "HTMLUnknownElement",
                    "IDBDatabase",
                    "IDBRequest",
                    "IDBTransaction",
                    "KeyOperation",
                    "MediaController",
                    "MessagePort",
                    "ModalWindow",
                    "Notification",
                    "SVGElementInstance",
                    "Screen",
                    "TextTrack",
                    "TextTrackCue",
                    "TextTrackList",
                    "WebSocket",
                    "WebSocketWorker",
                    "Worker",
                    "XMLHttpRequest",
                    "XMLHttpRequestEventTarget",
                    "XMLHttpRequestUpload"
                ], function(o) {
                    if (!win[o] || !win[o].prototype || !Object.prototype.hasOwnProperty.call(win[o].prototype, "addEventListener")) return;
                    __proxy(win[o].prototype, "addEventListener", function(original) {
                        return __traceOriginalScript(original, eventTargetCallbackAccessor);
                    });
                    __proxy(win[o].prototype, "removeEventListener", function(original) {
                        return __traceOriginalScript(original, eventTargetCallbackAccessor, true);
                    });
                });
                function __traceOriginalScript(fn, callbackAccessor, alsoCallOriginal) {
                    if (alsoCallOriginal === void 0) alsoCallOriginal = false;
                    return function() {
                        // this is required for removeEventListener to remove anything added with
                        // addEventListener before the functions started being wrapped by Bugsnag
                        var args = [].slice.call(arguments);
                        try {
                            var cba = callbackAccessor(args);
                            var cb = cba.get();
                            if (alsoCallOriginal) fn.apply(this, args);
                            if (typeof cb !== "function") return fn.apply(this, args);
                            if (cb.__trace__) cba.replace(cb.__trace__);
                            else {
                                var script = getCurrentScript();
                                // this function mustn't be annonymous due to a bug in the stack
                                // generation logic, meaning it gets tripped up
                                // see: https://github.com/stacktracejs/stack-generator/issues/6
                                cb.__trace__ = function __trace__() {
                                    // set the script that called this function
                                    updateLastScript(script);
                                    // immediately unset the currentScript synchronously below, however
                                    // if this cb throws an error the line after will not get run so schedule
                                    // an almost-immediate aysnc update too
                                    _setTimeout(function() {
                                        updateLastScript(null);
                                    }, 0);
                                    var ret = cb.apply(this, arguments);
                                    updateLastScript(null);
                                    return ret;
                                };
                                cb.__trace__.__trace__ = cb.__trace__;
                                cba.replace(cb.__trace__);
                            }
                        } catch (e) {
                        // swallow these errors on Selenium:
                        // Permission denied to access property '__trace__'
                        // WebDriverException: Message: Permission denied to access property "handleEvent"
                        }
                        // IE8 doesn't let you call .apply() on setTimeout/setInterval
                        if (fn.apply) return fn.apply(this, args);
                        switch(args.length){
                            case 1:
                                return fn(args[0]);
                            case 2:
                                return fn(args[0], args[1]);
                            default:
                                return fn();
                        }
                    };
                }
            },
            configSchema: {
                trackInlineScripts: {
                    validate: function(value) {
                        return value === true || value === false;
                    },
                    defaultValue: function() {
                        return true;
                    },
                    message: "should be true|false"
                }
            }
        };
    };
    function __proxy(host, name, replacer) {
        var original = host[name];
        if (!original) return original;
        var replacement = replacer(original);
        host[name] = replacement;
        return original;
    }
    function eventTargetCallbackAccessor(args) {
        var isEventHandlerObj = !!args[1] && typeof args[1].handleEvent === "function";
        return {
            get: function() {
                return isEventHandlerObj ? args[1].handleEvent : args[1];
            },
            replace: function(fn) {
                if (isEventHandlerObj) args[1].handleEvent = fn;
                else args[1] = fn;
            }
        };
    }
    /*
 * Leaves breadcrumbs when the user interacts with the DOM
 */ var _$interactionBreadcrumbs_49 = function(win) {
        if (win === void 0) win = window;
        return {
            load: function(client) {
                if (!("addEventListener" in win)) return;
                if (!client._isBreadcrumbTypeEnabled("user")) return;
                win.addEventListener("click", function(event) {
                    var targetText, targetSelector;
                    try {
                        targetText = getNodeText(event.target);
                        targetSelector = getNodeSelector(event.target, win);
                    } catch (e) {
                        targetText = "[hidden]";
                        targetSelector = "[hidden]";
                        client._logger.error("Cross domain error when tracking click event. See docs: https://tinyurl.com/yy3rn63z");
                    }
                    client.leaveBreadcrumb("UI click", {
                        targetText: targetText,
                        targetSelector: targetSelector
                    }, "user");
                }, true);
            }
        };
    };
    var trimStart = /^\s+/;
    var trimEnd = /(^|[^\s])\s+$/;
    function getNodeText(el) {
        var text = el.textContent || el.innerText || "";
        if (!text && (el.type === "submit" || el.type === "button")) text = el.value;
        text = text.replace(trimStart, "").replace(trimEnd, "$1");
        if (text.length > 140) return text.slice(0, 135) + "(...)";
        return text;
    }
    // Create a label from tagname, id and css class of the element
    function getNodeSelector(el, win) {
        var parts = [
            el.tagName
        ];
        if (el.id) parts.push("#" + el.id);
        if (el.className && el.className.length) parts.push("." + el.className.split(" ").join("."));
        // Can't get much more advanced with the current browser
        if (!win.document.querySelectorAll || !Array.prototype.indexOf) return parts.join("");
        try {
            if (win.document.querySelectorAll(parts.join("")).length === 1) return parts.join("");
        } catch (e) {
            // Sometimes the query selector can be invalid just return it as-is
            return parts.join("");
        }
        // try to get a more specific selector if this one matches more than one element
        if (el.parentNode.childNodes.length > 1) {
            var index = Array.prototype.indexOf.call(el.parentNode.childNodes, el) + 1;
            parts.push(":nth-child(" + index + ")");
        }
        if (win.document.querySelectorAll(parts.join("")).length === 1) return parts.join("");
        // try prepending the parent node selector
        if (el.parentNode) return getNodeSelector(el.parentNode, win) + " > " + parts.join("");
        return parts.join("");
    }
    var _$navigationBreadcrumbs_50 = {};
    /*
* Leaves breadcrumbs when navigation methods are called or events are emitted
*/ _$navigationBreadcrumbs_50 = function(win) {
        if (win === void 0) win = window;
        var plugin = {
            load: function(client) {
                if (!("addEventListener" in win)) return;
                if (!client._isBreadcrumbTypeEnabled("navigation")) return;
                // returns a function that will drop a breadcrumb with a given name
                var drop = function(name) {
                    return function() {
                        return client.leaveBreadcrumb(name, {}, "navigation");
                    };
                };
                // simple drops – just names, no meta
                win.addEventListener("pagehide", drop("Page hidden"), true);
                win.addEventListener("pageshow", drop("Page shown"), true);
                win.addEventListener("load", drop("Page loaded"), true);
                win.document.addEventListener("DOMContentLoaded", drop("DOMContentLoaded"), true);
                // some browsers like to emit popstate when the page loads, so only add the popstate listener after that
                win.addEventListener("load", function() {
                    return win.addEventListener("popstate", drop("Navigated back"), true);
                });
                // hashchange has some metadata that we care about
                win.addEventListener("hashchange", function(event) {
                    var metadata = event.oldURL ? {
                        from: relativeLocation(event.oldURL, win),
                        to: relativeLocation(event.newURL, win),
                        state: getCurrentState(win)
                    } : {
                        to: relativeLocation(win.location.href, win)
                    };
                    client.leaveBreadcrumb("Hash changed", metadata, "navigation");
                }, true);
                // the only way to know about replaceState/pushState is to wrap them… >_<
                if (win.history.replaceState) wrapHistoryFn(client, win.history, "replaceState", win);
                if (win.history.pushState) wrapHistoryFn(client, win.history, "pushState", win);
            }
        };
        return plugin;
    };
    // takes a full url like http://foo.com:1234/pages/01.html?yes=no#section-2 and returns
    // just the path and hash parts, e.g. /pages/01.html?yes=no#section-2
    var relativeLocation = function(url, win) {
        var a = win.document.createElement("A");
        a.href = url;
        return "" + a.pathname + a.search + a.hash;
    };
    var stateChangeToMetadata = function(win, state, title, url) {
        var currentPath = relativeLocation(win.location.href, win);
        return {
            title: title,
            state: state,
            prevState: getCurrentState(win),
            to: url || currentPath,
            from: currentPath
        };
    };
    var wrapHistoryFn = function(client, target, fn, win) {
        var orig = target[fn];
        target[fn] = function(state, title, url) {
            client.leaveBreadcrumb("History " + fn, stateChangeToMetadata(win, state, title, url), "navigation");
            // if throttle plugin is in use, reset the event sent count
            if (typeof client.resetEventCount === "function") client.resetEventCount();
            // if the client is operating in auto session-mode, a new route should trigger a new session
            if (client._config.autoTrackSessions) client.startSession();
            // Internet Explorer will convert `undefined` to a string when passed, causing an unintended redirect
            // to '/undefined'. therefore we only pass the url if it's not undefined.
            orig.apply(target, [
                state,
                title
            ].concat(url !== undefined ? url : []));
        };
    };
    var getCurrentState = function(win) {
        try {
            return win.history.state;
        } catch (e) {}
    };
    var BREADCRUMB_TYPE = "request"; /* removed: var _$includes_13 = require('@bugsnag/core/lib/es-utils/includes'); */ 
    /*
 * Leaves breadcrumbs when network requests occur
 */ var _$networkBreadcrumbs_51 = function(_ignoredUrls, win) {
        if (_ignoredUrls === void 0) _ignoredUrls = [];
        if (win === void 0) win = window;
        var restoreFunctions = [];
        var plugin = {
            load: function(client) {
                if (!client._isBreadcrumbTypeEnabled("request")) return;
                var ignoredUrls = [
                    client._config.endpoints.notify,
                    client._config.endpoints.sessions
                ].concat(_ignoredUrls);
                monkeyPatchXMLHttpRequest();
                monkeyPatchFetch();
                // XMLHttpRequest monkey patch
                function monkeyPatchXMLHttpRequest() {
                    if (!("addEventListener" in win.XMLHttpRequest.prototype)) return;
                    var nativeOpen = win.XMLHttpRequest.prototype.open;
                    // override native open()
                    win.XMLHttpRequest.prototype.open = function open(method, url) {
                        var _this = this;
                        var requestSetupKey = false;
                        var error = function() {
                            return handleXHRError(method, url);
                        };
                        var load = function() {
                            return handleXHRLoad(method, url, _this.status);
                        };
                        // if we have already setup listeners, it means open() was called twice, we need to remove
                        // the listeners and recreate them
                        if (requestSetupKey) {
                            this.removeEventListener("load", load);
                            this.removeEventListener("error", error);
                        }
                        // attach load event listener
                        this.addEventListener("load", load);
                        // attach error event listener
                        this.addEventListener("error", error);
                        requestSetupKey = true;
                        nativeOpen.apply(this, arguments);
                    };
                }
                function handleXHRLoad(method, url, status) {
                    if (url === undefined) {
                        client._logger.warn("The request URL is no longer present on this XMLHttpRequest. A breadcrumb cannot be left for this request.");
                        return;
                    }
                    // an XMLHttpRequest's URL can be an object as long as its 'toString'
                    // returns a URL, e.g. a HTMLAnchorElement
                    if (typeof url === "string" && _$includes_13(ignoredUrls, url.replace(/\?.*$/, ""))) // don't leave a network breadcrumb from bugsnag notify calls
                    return;
                    var metadata = {
                        status: status,
                        request: method + " " + url
                    };
                    if (status >= 400) // contacted server but got an error response
                    client.leaveBreadcrumb("XMLHttpRequest failed", metadata, BREADCRUMB_TYPE);
                    else client.leaveBreadcrumb("XMLHttpRequest succeeded", metadata, BREADCRUMB_TYPE);
                }
                function handleXHRError(method, url) {
                    if (url === undefined) {
                        client._logger.warn("The request URL is no longer present on this XMLHttpRequest. A breadcrumb cannot be left for this request.");
                        return;
                    }
                    if (typeof url === "string" && _$includes_13(ignoredUrls, url.replace(/\?.*$/, ""))) // don't leave a network breadcrumb from bugsnag notify calls
                    return;
                    // failed to contact server
                    client.leaveBreadcrumb("XMLHttpRequest error", {
                        request: method + " " + url
                    }, BREADCRUMB_TYPE);
                }
                // window.fetch monkey patch
                function monkeyPatchFetch() {
                    // only patch it if it exists and if it is not a polyfill (patching a polyfilled
                    // fetch() results in duplicate breadcrumbs for the same request because the
                    // implementation uses XMLHttpRequest which is also patched)
                    if (!("fetch" in win) || win.fetch.polyfill) return;
                    var oldFetch = win.fetch;
                    win.fetch = function fetch() {
                        var _arguments = arguments;
                        var urlOrRequest = arguments[0];
                        var options = arguments[1];
                        var method;
                        var url = null;
                        if (urlOrRequest && typeof urlOrRequest === "object") {
                            url = urlOrRequest.url;
                            if (options && "method" in options) method = options.method;
                            else if (urlOrRequest && "method" in urlOrRequest) method = urlOrRequest.method;
                        } else {
                            url = urlOrRequest;
                            if (options && "method" in options) method = options.method;
                        }
                        if (method === undefined) method = "GET";
                        return new Promise(function(resolve, reject) {
                            // pass through to native fetch
                            oldFetch.apply(void 0, _arguments).then(function(response) {
                                handleFetchSuccess(response, method, url);
                                resolve(response);
                            })["catch"](function(error) {
                                handleFetchError(method, url);
                                reject(error);
                            });
                        });
                    };
                }
                var handleFetchSuccess = function(response, method, url) {
                    var metadata = {
                        status: response.status,
                        request: method + " " + url
                    };
                    if (response.status >= 400) // when the request comes back with a 4xx or 5xx status it does not reject the fetch promise,
                    client.leaveBreadcrumb("fetch() failed", metadata, BREADCRUMB_TYPE);
                    else client.leaveBreadcrumb("fetch() succeeded", metadata, BREADCRUMB_TYPE);
                };
                var handleFetchError = function(method, url) {
                    client.leaveBreadcrumb("fetch() error", {
                        request: method + " " + url
                    }, BREADCRUMB_TYPE);
                };
            }
        };
        return plugin;
    }; /* removed: var _$intRange_24 = require('@bugsnag/core/lib/validators/int-range'); */ 
    /*
 * Throttles and dedupes events
 */ var _$throttle_52 = {
        load: function(client) {
            // track sent events for each init of the plugin
            var n = 0;
            // add onError hook
            client.addOnError(function(event) {
                // have max events been sent already?
                if (n >= client._config.maxEvents) {
                    client._logger.warn("Cancelling event send due to maxEvents per session limit of " + client._config.maxEvents + " being reached");
                    return false;
                }
                n++;
            });
            client.resetEventCount = function() {
                n = 0;
            };
        },
        configSchema: {
            maxEvents: {
                defaultValue: function() {
                    return 10;
                },
                message: "should be a positive integer \u2264100",
                validate: function(val) {
                    return _$intRange_24(1, 100)(val);
                }
            }
        }
    };
    var _$stripQueryString_53 = {}; /* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */ 
    _$stripQueryString_53 = {
        load: function(client) {
            client.addOnError(function(event) {
                var allFrames = _$reduce_17(event.errors, function(accum, er) {
                    return accum.concat(er.stacktrace);
                }, []);
                _$map_16(allFrames, function(frame) {
                    frame.file = strip(frame.file);
                });
            });
        }
    };
    var strip = _$stripQueryString_53._strip = function(str) {
        return typeof str === "string" ? str.replace(/\?.*$/, "").replace(/#.*$/, "") : str;
    };
    /*
 * Automatically notifies Bugsnag when window.onerror is called
 */ var _$onerror_54 = function(win, component) {
        if (win === void 0) win = window;
        if (component === void 0) component = "window onerror";
        return {
            load: function(client) {
                if (!client._config.autoDetectErrors) return;
                if (!client._config.enabledErrorTypes.unhandledExceptions) return;
                function onerror(messageOrEvent, url, lineNo, charNo, error) {
                    // Ignore errors with no info due to CORS settings
                    if (lineNo === 0 && /Script error\.?/.test(messageOrEvent)) client._logger.warn("Ignoring cross-domain or eval script error. See docs: https://tinyurl.com/yy3rn63z");
                    else {
                        // any error sent to window.onerror is unhandled and has severity=error
                        var handledState = {
                            severity: "error",
                            unhandled: true,
                            severityReason: {
                                type: "unhandledException"
                            }
                        };
                        var event;
                        // window.onerror can be called in a number of ways. This big if-else is how we
                        // figure out which arguments were supplied, and what kind of values it received.
                        if (error) {
                            // if the last parameter (error) was supplied, this is a modern browser's
                            // way of saying "this value was thrown and not caught"
                            event = client.Event.create(error, true, handledState, component, 1);
                            decorateStack(event.errors[0].stacktrace, url, lineNo, charNo);
                        } else if (// This complex case detects "error" events that are typically synthesised
                        // by jquery's trigger method (although can be created in other ways). In
                        // order to detect this:
                        // - the first argument (message) must exist and be an object (most likely it's a jQuery event)
                        // - the second argument (url) must either not exist or be something other than a string (if it
                        //    exists and is not a string, it'll be the extraParameters argument from jQuery's trigger()
                        //    function)
                        // - the third, fourth and fifth arguments must not exist (lineNo, charNo and error)
                        typeof messageOrEvent === "object" && messageOrEvent !== null && (!url || typeof url !== "string") && !lineNo && !charNo && !error) {
                            // The jQuery event may have a "type" property, if so use it as part of the error message
                            var name = messageOrEvent.type ? "Event: " + messageOrEvent.type : "Error";
                            // attempt to find a message from one of the conventional properties, but
                            // default to empty string (the event will fill it with a placeholder)
                            var message = messageOrEvent.message || messageOrEvent.detail || "";
                            event = client.Event.create({
                                name: name,
                                message: message
                            }, true, handledState, component, 1);
                            // provide the original thing onerror received – not our error-like object we passed to _notify
                            event.originalError = messageOrEvent;
                            // include the raw input as metadata – it might contain more info than we extracted
                            event.addMetadata(component, {
                                event: messageOrEvent,
                                extraParameters: url
                            });
                        } else {
                            // Lastly, if there was no "error" parameter this event was probably from an old
                            // browser that doesn't support that. Instead we need to generate a stacktrace.
                            event = client.Event.create(messageOrEvent, true, handledState, component, 1);
                            decorateStack(event.errors[0].stacktrace, url, lineNo, charNo);
                        }
                        client._notify(event);
                    }
                    if (typeof prevOnError === "function") prevOnError.apply(this, arguments);
                }
                var prevOnError = win.onerror;
                win.onerror = onerror;
            }
        };
    };
    // Sometimes the stacktrace has less information than was passed to window.onerror.
    // This function will augment the first stackframe with any useful info that was
    // received as arguments to the onerror callback.
    var decorateStack = function(stack, url, lineNo, charNo) {
        if (!stack[0]) stack.push({});
        var culprit = stack[0];
        if (!culprit.file && typeof url === "string") culprit.file = url;
        if (!culprit.lineNumber && isActualNumber(lineNo)) culprit.lineNumber = lineNo;
        if (!culprit.columnNumber) {
            if (isActualNumber(charNo)) culprit.columnNumber = charNo;
            else if (window.event && isActualNumber(window.event.errorCharacter)) culprit.columnNumber = window.event.errorCharacter;
        }
    };
    var isActualNumber = function(n) {
        return typeof n === "number" && String.call(n) !== "NaN";
    }; /* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */ 
    var _listener;
    /*
 * Automatically notifies Bugsnag when window.onunhandledrejection is called
 */ var _$unhandledRejection_55 = function(win) {
        if (win === void 0) win = window;
        var plugin = {
            load: function(client) {
                if (!client._config.autoDetectErrors || !client._config.enabledErrorTypes.unhandledRejections) return;
                var listener = function(evt) {
                    var error = evt.reason;
                    var isBluebird = false;
                    // accessing properties on evt.detail can throw errors (see #394)
                    try {
                        if (evt.detail && evt.detail.reason) {
                            error = evt.detail.reason;
                            isBluebird = true;
                        }
                    } catch (e) {}
                    var event = client.Event.create(error, false, {
                        severity: "error",
                        unhandled: true,
                        severityReason: {
                            type: "unhandledPromiseRejection"
                        }
                    }, "unhandledrejection handler", 1, client._logger);
                    if (isBluebird) _$map_16(event.errors[0].stacktrace, fixBluebirdStacktrace(error));
                    client._notify(event, function(event) {
                        if (_$iserror_20(event.originalError) && !event.originalError.stack) {
                            var _event$addMetadata;
                            event.addMetadata("unhandledRejection handler", (_event$addMetadata = {}, _event$addMetadata[Object.prototype.toString.call(event.originalError)] = {
                                name: event.originalError.name,
                                message: event.originalError.message,
                                code: event.originalError.code
                            }, _event$addMetadata));
                        }
                    });
                };
                if ("addEventListener" in win) win.addEventListener("unhandledrejection", listener);
                else win.onunhandledrejection = function(reason, promise) {
                    listener({
                        detail: {
                            reason: reason,
                            promise: promise
                        }
                    });
                };
                _listener = listener;
            }
        };
        return plugin;
    };
    // The stack parser on bluebird stacks in FF get a suprious first frame:
    //
    // Error: derp
    //   b@http://localhost:5000/bluebird.html:22:24
    //   a@http://localhost:5000/bluebird.html:18:9
    //   @http://localhost:5000/bluebird.html:14:9
    //
    // results in
    //   […]
    //     0: Object { file: "Error: derp", method: undefined, lineNumber: undefined, … }
    //     1: Object { file: "http://localhost:5000/bluebird.html", method: "b", lineNumber: 22, … }
    //     2: Object { file: "http://localhost:5000/bluebird.html", method: "a", lineNumber: 18, … }
    //     3: Object { file: "http://localhost:5000/bluebird.html", lineNumber: 14, columnNumber: 9, … }
    //
    // so the following reduce/accumulator function removes such frames
    //
    // Bluebird pads method names with spaces so trim that too…
    // https://github.com/petkaantonov/bluebird/blob/b7f21399816d02f979fe434585334ce901dcaf44/src/debuggability.js#L568-L571
    var fixBluebirdStacktrace = function(error) {
        return function(frame) {
            if (frame.file === error.toString()) return;
            if (frame.method) frame.method = frame.method.replace(/^\s+/, "");
        };
    };
    var _$notifier_2 = {};
    var name = "Bugsnag JavaScript";
    var version = "7.22.4";
    var url = "https://github.com/bugsnag/bugsnag-js"; /* removed: var _$Client_4 = require('@bugsnag/core/client'); */ 
    // extend the base config schema with some browser-specific options
    var __schema_2 = _$assign_11({}, _$config_5.schema, _$config_1); /* removed: var _$onerror_54 = require('@bugsnag/plugin-window-onerror'); */ 
    var Bugsnag = {
        _client: null,
        createClient: function(opts) {
            // handle very simple use case where user supplies just the api key as a string
            if (typeof opts === "string") opts = {
                apiKey: opts
            };
            if (!opts) opts = {};
            var internalPlugins = [
                // add browser-specific plugins
                _$app_38,
                _$device_40(),
                _$context_39(),
                _$request_44(),
                _$throttle_52,
                _$session_45,
                _$clientIp_46,
                _$stripQueryString_53,
                _$onerror_54(),
                _$unhandledRejection_55(),
                _$navigationBreadcrumbs_50(),
                _$interactionBreadcrumbs_49(),
                _$networkBreadcrumbs_51(),
                _$consoleBreadcrumbs_47,
                // this one added last to avoid wrapping functionality before bugsnag uses it
                _$inlineScriptContent_48()
            ];
            // configure a client with user supplied options
            var bugsnag = new _$Client_4(opts, __schema_2, internalPlugins, {
                name: name,
                version: version,
                url: url
            });
            // set delivery based on browser capability (IE 8+9 have an XDomainRequest object)
            bugsnag._setDelivery(window.XDomainRequest ? _$delivery_36 : _$delivery_37);
            bugsnag._logger.debug("Loaded!");
            bugsnag.leaveBreadcrumb("Bugsnag loaded", {}, "state");
            return bugsnag._config.autoTrackSessions ? bugsnag.startSession() : bugsnag;
        },
        start: function(opts) {
            if (Bugsnag._client) {
                Bugsnag._client._logger.warn("Bugsnag.start() was called more than once. Ignoring.");
                return Bugsnag._client;
            }
            Bugsnag._client = Bugsnag.createClient(opts);
            return Bugsnag._client;
        },
        isStarted: function() {
            return Bugsnag._client != null;
        }
    };
    _$map_16([
        "resetEventCount"
    ].concat(_$keys_15(_$Client_4.prototype)), function(m) {
        if (/^_/.test(m)) return;
        Bugsnag[m] = function() {
            if (!Bugsnag._client) return console.log("Bugsnag." + m + "() was called before Bugsnag.start()");
            Bugsnag._client._depth += 1;
            var ret = Bugsnag._client[m].apply(Bugsnag._client, arguments);
            Bugsnag._client._depth -= 1;
            return ret;
        };
    });
    _$notifier_2 = Bugsnag;
    _$notifier_2.Client = _$Client_4;
    _$notifier_2.Event = _$Event_6;
    _$notifier_2.Session = _$Session_35;
    _$notifier_2.Breadcrumb = _$Breadcrumb_3;
    // Export a "default" property for compatibility with ESM imports
    _$notifier_2["default"] = Bugsnag;
    return _$notifier_2;
});

});

parcelRegister("jZA9I", function(module, exports) {
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";

var $6cds3 = parcelRequire("6cds3");

var $7JwYr = parcelRequire("7JwYr");

var $1c9zD = parcelRequire("1c9zD");
function y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$6cds3) throw Error(y(227));
var ba = new Set, ca = {};
function da(a, b) {
    ea(a, b);
    ea(a + "Capture", b);
}
function ea(a, b) {
    ca[a] = b;
    for(a = 0; a < b.length; a++)ba.add(b[a]);
}
var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a) {
    if (ia.call(ka, a)) return !0;
    if (ia.call(ja, a)) return !1;
    if (ha.test(a)) return ka[a] = !0;
    ja[a] = !0;
    return !1;
}
function ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    D[a] = new B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    D[b] = new B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    D[a] = new B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    D[a] = new B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    D[a] = new B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;
function pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function qa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var ra = $6cds3.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    sa = E("react.element");
    ta = E("react.portal");
    ua = E("react.fragment");
    wa = E("react.strict_mode");
    xa = E("react.profiler");
    ya = E("react.provider");
    za = E("react.context");
    Aa = E("react.forward_ref");
    Ba = E("react.suspense");
    Ca = E("react.suspense_list");
    Da = E("react.memo");
    Ea = E("react.lazy");
    Fa = E("react.block");
    E("react.scope");
    Ga = E("react.opaque.id");
    Ha = E("react.debug_trace_mode");
    Ia = E("react.offscreen");
    Ja = E("react.legacy_hidden");
}
var Ka = "function" === typeof Symbol && Symbol.iterator;
function La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ka && a[Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var Ma;
function Na(a) {
    if (void 0 === Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        Ma = b && b[1] || "";
    }
    return "\n" + Ma + a;
}
var Oa = !1;
function Pa(a, b) {
    if (!a || Oa) return "";
    Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}
function Qa(a) {
    switch(a.tag){
        case 5:
            return Na(a.type);
        case 16:
            return Na("Lazy");
        case 13:
            return Na("Suspense");
        case 19:
            return Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Pa(a.type, !1), a;
        case 11:
            return a = Pa(a.type.render, !1), a;
        case 22:
            return a = Pa(a.type._render, !1), a;
        case 1:
            return a = Pa(a.type, !0), a;
        default:
            return "";
    }
}
function Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ua:
            return "Fragment";
        case ta:
            return "Portal";
        case xa:
            return "Profiler";
        case wa:
            return "StrictMode";
        case Ba:
            return "Suspense";
        case Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case za:
            return (a.displayName || "Context") + ".Consumer";
        case ya:
            return (a._context.displayName || "Context") + ".Provider";
        case Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case Da:
            return Ra(a.type);
        case Fa:
            return Ra(a._render);
        case Ea:
            b = a._payload;
            a = a._init;
            try {
                return Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return $7JwYr({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a(a, b) {
    b = b.checked;
    null != b && qa(a, "checked", b, !1);
}
function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function db(a) {
    var b = "";
    $6cds3.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function eb(a, b) {
    a = $7JwYr({
        children: void 0
    }, b);
    if (b = db(b.children)) a.children = b;
    return a;
}
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
    return $7JwYr({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var nb, ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        nb = nb || document.createElement("div");
        nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(qb).forEach(function(a) {
    rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        qb[b] = qb[a];
    });
});
function sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}
function tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var ub = $7JwYr({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function vb(a, b) {
    if (b) {
        if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
    }
}
function wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(y(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ib() {}
var Jb = Gb, Kb = !1, Lb = !1;
function Mb() {
    if (null !== zb || null !== Ab) Ib(), Fb();
}
function Nb(a, b, c) {
    if (Lb) return a(b, c);
    Lb = !0;
    try {
        return Jb(a, b, c);
    } finally{
        Lb = !1, Mb();
    }
}
function Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(y(231, b, typeof c));
    return c;
}
var Pb = !1;
if (fa) try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", {
        get: function() {
            Pb = !0;
        }
    });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
} catch (a) {
    Pb = !1;
}
function Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Sb = !1, Tb = null, Ub = !1, Vb = null, Wb = {
    onError: function(a) {
        Sb = !0;
        Tb = a;
    }
};
function Xb(a, b, c, d, e, f, g, h, k) {
    Sb = !1;
    Tb = null;
    Rb.apply(Wb, arguments);
}
function Yb(a, b, c, d, e, f, g, h, k) {
    Xb.apply(this, arguments);
    if (Sb) {
        if (Sb) {
            var l = Tb;
            Sb = !1;
            Tb = null;
        } else throw Error(y(198));
        Ub || (Ub = !0, Vb = l);
    }
}
function Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function ac(a) {
    if (Zb(a) !== a) throw Error(y(188));
}
function bc(a) {
    var b = a.alternate;
    if (!b) {
        b = Zb(a);
        if (null === b) throw Error(y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return ac(e), a;
                if (f === d) return ac(e), b;
                f = f.sibling;
            }
            throw Error(y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(y(189));
            }
        }
        if (c.alternate !== d) throw Error(y(190));
    }
    if (3 !== c.tag) throw Error(y(188));
    return c.stateNode.current === c ? a : b;
}
function cc(a) {
    a = bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var ec, fc, gc, hc, ic = !1, jc = [], kc = null, lc = null, mc = null, nc = new Map, oc = new Map, pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            kc = null;
            break;
        case "dragenter":
        case "dragleave":
            lc = null;
            break;
        case "mouseover":
        case "mouseout":
            mc = null;
            break;
        case "pointerover":
        case "pointerout":
            nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            oc.delete(b.pointerId);
    }
}
function tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return kc = tc(kc, a, b, c, d, e), !0;
        case "dragenter":
            return lc = tc(lc, a, b, c, d, e), !0;
        case "mouseover":
            return mc = tc(mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function vc(a) {
    var b = wc(a.target);
    if (null !== b) {
        var c = Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b(c), null !== b) {
                    a.blockedOn = b;
                    hc(a.lanePriority, function() {
                        $1c9zD.unstable_runWithPriority(a.priority, function() {
                            gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function zc(a, b, c) {
    xc(a) && c.delete(b);
}
function Ac() {
    for(ic = !1; 0 < jc.length;){
        var a = jc[0];
        if (null !== a.blockedOn) {
            a = Cb(a.blockedOn);
            null !== a && ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && jc.shift();
    }
    null !== kc && xc(kc) && (kc = null);
    null !== lc && xc(lc) && (lc = null);
    null !== mc && xc(mc) && (mc = null);
    nc.forEach(zc);
    oc.forEach(zc);
}
function Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, $1c9zD.unstable_scheduleCallback($1c9zD.unstable_NormalPriority, Ac)));
}
function Cc(a) {
    function b(b) {
        return Bc(b, a);
    }
    if (0 < jc.length) {
        Bc(jc[0], a);
        for(var c = 1; c < jc.length; c++){
            var d = jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== kc && Bc(kc, a);
    null !== lc && Bc(lc, a);
    null !== mc && Bc(mc, a);
    nc.forEach(b);
    oc.forEach(b);
    for(c = 0; c < pc.length; c++)d = pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < pc.length && (c = pc[0], null === c.blockedOn);)vc(c), null === c.blockedOn && pc.shift();
}
function Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Ec = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
}, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a) {
    if (Fc[a]) return Fc[a];
    if (!Ec[a]) return a;
    var b = Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
    return a;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = new Map, Nc = new Map, Oc = [
    "abort",
    "abort",
    Ic,
    "animationEnd",
    Jc,
    "animationIteration",
    Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        Nc.set(d, b);
        Mc.set(d, e);
        da(e, [
            d
        ]);
    }
}
var Qc = $1c9zD.unstable_now;
Qc();
var F = 8;
function Rc(a) {
    if (0 !== (1 & a)) return F = 15, 1;
    if (0 !== (2 & a)) return F = 14, 2;
    if (0 !== (4 & a)) return F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return F = 12, b;
    if (0 !== (a & 32)) return F = 11, 32;
    b = 192 & a;
    if (0 !== b) return F = 10, b;
    if (0 !== (a & 256)) return F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return F = 8, b;
    if (0 !== (a & 4096)) return F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return F = 5, b;
    if (a & 67108864) return F = 4, 67108864;
    if (0 !== (a & 134217728)) return F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return F = 2, b;
    if (0 !== (1073741824 & a)) return F = 1, 1073741824;
    F = 8;
    return a;
}
function Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error(y(358, a));
    }
}
function Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
    } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
    if (0 === d) return 0;
    d = 31 - Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        Rc(b);
        if (e <= F) return b;
        F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;
        case 10:
            return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;
        case 8:
            return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error(y(358, a));
}
function Yc(a) {
    return a & -a;
}
function Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - Vc(b);
    a[b] = c;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a) {
    return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}
var dd = $1c9zD.unstable_UserBlockingPriority, ed = $1c9zD.unstable_runWithPriority, fd = !0;
function gd(a, b, c, d) {
    Kb || Ib();
    var e = hd, f = Kb;
    Kb = !0;
    try {
        Hb(e, a, b, c, d);
    } finally{
        (Kb = f) || Mb();
    }
}
function id(a, b, c, d) {
    ed(dd, hd.bind(null, a, b, c, d));
}
function hd(a, b, c, d) {
    if (fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);
        else {
            var f = yc(a, b, c, d);
            if (null === f) e && sc(a, d);
            else {
                if (e) {
                    if (-1 < qc.indexOf(a)) {
                        a = rc(f, a, b, c, d);
                        jc.push(a);
                        return;
                    }
                    if (uc(f, a, b, c, d)) return;
                    sc(a, d);
                }
                jd(a, b, d, null, c);
            }
        }
    }
}
function yc(a, b, c, d) {
    var e = xb(d);
    e = wc(e);
    if (null !== e) {
        var f = Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    jd(a, b, d, e, c);
    return null;
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    $7JwYr(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = $7JwYr({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = $7JwYr({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = $7JwYr({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = $7JwYr({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = $7JwYr({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = $7JwYr({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = $7JwYr({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = $7JwYr({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = $7JwYr({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = $7JwYr({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = $7JwYr({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = $7JwYr({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (fa) {
    var xe;
    if (fa) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        a = re;
        if (Kb) a(b);
        else {
            Kb = !0;
            try {
                Gb(a, b);
            } finally{
                Kb = !1, Mb();
            }
        }
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Le(a, b) {
    var c = Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Ke(c);
    }
}
function Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Ne() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for(var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++)Nc.set(Ve[We], 0);
ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
        }
    }
    if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}
function G(a, b) {
    var c = $e(b), d = a + "__bubble";
    c.has(d) || (af(b, a, 2, !1), c.add(d));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a) {
    a[bf] || (a[bf] = !0, ba.forEach(function(b) {
        Ye.has(b) || df(b, !1, a, null);
        df(b, !0, a, null);
    }));
}
function df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}
function af(a, b, c, d) {
    var e = Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = gd;
            break;
        case 1:
            e = id;
            break;
        default:
            e = hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Nb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = Mc.get(a);
            if (void 0 !== h) {
                var k = td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case Ic:
                    case Jc:
                    case Kc:
                        k = Hd;
                        break;
                    case Lc:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : ue(k);
                        q = null == x ? h : ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = gf(q))t++;
                            q = 0;
                            for(v = u; v; v = gf(v))q++;
                            for(; 0 < t - q;)w = gf(w), t--;
                            for(; 0 < q - t;)u = gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = gf(w);
                                u = gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && hf(g, h, k, w, !1);
                        null !== x && null !== z && hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = ve;
                else if (me(h)) {
                    if (we) J = Fe;
                    else {
                        J = De;
                        var K = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);
                if (J && (J = J(a, d))) {
                    ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            K = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(K) || "true" === K.contentEditable) Qe = K, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var Q;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(d, L), 0 < K.length && (L = new Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
            if (Q = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        se(g, b);
    });
}
function ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function jf() {}
var kf = null, lf = null;
function mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var of = "function" === typeof setTimeout ? setTimeout : void 0, pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var tf = 0;
function uf(a) {
    return {
        $$typeof: Ga,
        toString: a,
        valueOf: a
    };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a) {
    var b = a[wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[ff] || c[wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = sf(a); null !== a;){
                if (c = a[wf]) return c;
                a = sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[wf] || a[ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(y(33));
}
function Db(a) {
    return a[xf] || null;
}
function $e(a) {
    var b = a[yf];
    void 0 === b && (b = a[yf] = new Set);
    return b;
}
var zf = [], Af = -1;
function Bf(a) {
    return {
        current: a
    };
}
function H(a) {
    0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}
function I(a, b) {
    Af++;
    zf[Af] = a.current;
    a.current = b;
}
var Cf = {}, M = Bf(Cf), N = Bf(!1), Df = Cf;
function Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Gf() {
    H(N);
    H(M);
}
function Hf(a, b, c) {
    if (M.current !== Cf) throw Error(y(168));
    I(M, b);
    I(N, c);
}
function If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
    return $7JwYr({}, c, d);
}
function Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
    Df = M.current;
    I(M, a);
    I(N, N.current);
    return !0;
}
function Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(y(169));
    c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
    I(N, c);
}
var Lf = null, Mf = null, Nf = $1c9zD.unstable_runWithPriority, Of = $1c9zD.unstable_scheduleCallback, Pf = $1c9zD.unstable_cancelCallback, Qf = $1c9zD.unstable_shouldYield, Rf = $1c9zD.unstable_requestPaint, Sf = $1c9zD.unstable_now, Tf = $1c9zD.unstable_getCurrentPriorityLevel, Uf = $1c9zD.unstable_ImmediatePriority, Vf = $1c9zD.unstable_UserBlockingPriority, Wf = $1c9zD.unstable_NormalPriority, Xf = $1c9zD.unstable_LowPriority, Yf = $1c9zD.unstable_IdlePriority, Zf = {}, $f = void 0 !== Rf ? Rf : function() {}, ag = null, bg = null, cg = !1, dg = Sf(), O = 1E4 > dg ? Sf : function() {
    return Sf() - dg;
};
function eg() {
    switch(Tf()){
        case Uf:
            return 99;
        case Vf:
            return 98;
        case Wf:
            return 97;
        case Xf:
            return 96;
        case Yf:
            return 95;
        default:
            throw Error(y(332));
    }
}
function fg(a) {
    switch(a){
        case 99:
            return Uf;
        case 98:
            return Vf;
        case 97:
            return Wf;
        case 96:
            return Xf;
        case 95:
            return Yf;
        default:
            throw Error(y(332));
    }
}
function gg(a, b) {
    a = fg(a);
    return Nf(a, b);
}
function hg(a, b, c) {
    a = fg(a);
    return Of(a, b, c);
}
function ig() {
    if (null !== bg) {
        var a = bg;
        bg = null;
        Pf(a);
    }
    jg();
}
function jg() {
    if (!cg && null !== ag) {
        cg = !0;
        var a = 0;
        try {
            var b = ag;
            gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            ag = null;
        } catch (c) {
            throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
        } finally{
            cg = !1;
        }
    }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a, b) {
    if (a && a.defaultProps) {
        b = $7JwYr({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
    pg = og = ng = null;
}
function rg(a) {
    var b = mg.current;
    H(mg);
    a.type._context._currentValue = b;
}
function sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function tg(a, b) {
    ng = a;
    pg = og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}
function vg(a, b) {
    if (pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === og) {
            if (null === ng) throw Error(y(308));
            og = b;
            ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else og = og.next = b;
    }
    return a._currentValue;
}
var wg = !1;
function xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Cg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = $7JwYr({}, A, h);
                            break a;
                        case 2:
                            wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(y(191, e));
            e.call(d);
        }
    }
}
var Fg = (new $6cds3.Component).refs;
function Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $7JwYr({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = Hg(), d = Ig(a), e = zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        Ag(a, e);
        Jg(a, d, c);
    }
};
function Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}
function Mg(a, b, c) {
    var d = !1, e = Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}
function Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Fg;
    xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
    Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(y(284));
        if (!c._owner) throw Error(y(290, a));
    }
    return a;
}
function Rg(a, b) {
    if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
        d = Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case sa:
                    return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;
                case ta:
                    return b = Wg(b, a.mode, c), b.return = a, b;
            }
            if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
            Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case sa:
                    return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
            Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = La(h);
        if ("function" !== typeof l) throw Error(y(150));
        h = l.call(h);
        if (null == h) throw Error(y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if (Pg(f)) return x(a, d, f, h);
        if (La(f)) return w(a, d, f, h);
        l && Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error(y(152, Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var Yg = Sg(!0), Zg = Sg(!1), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a) {
    if (a === $g) throw Error(y(174));
    return a;
}
function eh(a, b) {
    I(ch, b);
    I(bh, a);
    I(ah, $g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
    }
    H(ah);
    I(ah, b);
}
function fh() {
    H(ah);
    H(bh);
    H(ch);
}
function gh(a) {
    dh(ch.current);
    var b = dh(ah.current);
    var c = mb(b, a.type);
    b !== c && (I(bh, a), I(ah, c));
}
function hh(a) {
    bh.current === a && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var jh = null, kh = null, lh = !1;
function mh(a, b) {
    var c = nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function ph(a) {
    if (lh) {
        var b = kh;
        if (b) {
            var c = b;
            if (!oh(a, b)) {
                b = rf(c.nextSibling);
                if (!b || !oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    lh = !1;
                    jh = a;
                    return;
                }
                mh(jh, c);
            }
            jh = a;
            kh = rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
    }
}
function qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    jh = a;
}
function rh(a) {
    if (a !== jh) return !1;
    if (!lh) return qh(a), lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for(b = kh; b;)mh(a, b), b = rf(b.nextSibling);
    qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            kh = rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            kh = null;
        }
    } else kh = jh ? rf(a.stateNode.nextSibling) : null;
    return !0;
}
function sh() {
    kh = jh = null;
    lh = !1;
}
var th = [];
function uh() {
    for(var a = 0; a < th.length; a++)th[a]._workInProgressVersionPrimary = null;
    th.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = !1, zh = !1;
function Ah() {
    throw Error(y(321));
}
function Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Ch(a, b, c, d, e, f) {
    xh = f;
    R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    vh.current = null === a || null === a.memoizedState ? Dh : Eh;
    a = c(d, e);
    if (zh) {
        f = 0;
        do {
            zh = !1;
            if (!(25 > f)) throw Error(y(301));
            f += 1;
            T = S = null;
            b.updateQueue = null;
            vh.current = Fh;
            a = c(d, e);
        }while (zh);
    }
    vh.current = Gh;
    b = null !== S && null !== S.next;
    xh = 0;
    T = S = R = null;
    yh = !1;
    if (b) throw Error(y(300));
    return a;
}
function Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
    return T;
}
function Ih() {
    if (null === S) {
        var a = R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = S.next;
    var b = null === T ? R.memoizedState : T.next;
    if (null !== b) T = b, S = a;
    else {
        if (null === a) throw Error(y(310));
        S = a;
        a = {
            memoizedState: S.memoizedState,
            baseState: S.baseState,
            baseQueue: S.baseQueue,
            queue: S.queue,
            next: null
        };
        null === T ? R.memoizedState = T = a : T = T.next = a;
    }
    return T;
}
function Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Kh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if ((xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                R.lanes |= l;
                Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        He(d, b.memoizedState) || (ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Lh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
    if (a) return c(b._source);
    th.push(b);
    throw Error(y(350));
}
function Nh(a, b, c, d) {
    var e = U;
    if (null === e) throw Error(y(349));
    var f = b._getVersion, g = f(b._source), h = vh.current, k = h.useState(function() {
        return Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!He(g, a)) {
            a = c(b._source);
            He(n, a) || (l(a), a = Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    He(C, c) && He(x, b) && He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: n
    }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function Ph(a, b, c) {
    var d = Ih();
    return Nh(d, a, b, c);
}
function Qh(a) {
    var b = Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: a
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [
        b.memoizedState,
        a
    ];
}
function Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Sh(a) {
    var b = Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function Th() {
    return Ih().memoizedState;
}
function Uh(a, b, c, d) {
    var e = Hh();
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Vh(a, b, c, d) {
    var e = Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== S) {
        var g = S.memoizedState;
        f = g.destroy;
        if (null !== d && Bh(d, g.deps)) {
            Rh(b, c, f, d);
            return;
        }
    }
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, f, d);
}
function Wh(a, b) {
    return Uh(516, 4, a, b);
}
function Xh(a, b) {
    return Vh(516, 4, a, b);
}
function Yh(a, b) {
    return Vh(4, 2, a, b);
}
function Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Vh(4, 2, Zh.bind(null, b, a), c);
}
function ai() {}
function bi(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ci(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function di(a, b) {
    var c = eg();
    gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    gg(97 < c ? 97 : c, function() {
        var c = wh.transition;
        wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            wh.transition = c;
        }
    });
}
function Oh(a, b, c) {
    var d = Hg(), e = Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === R || null !== g && g === R) zh = yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if (He(k, h)) return;
        } catch (l) {} finally{}
        Jg(a, e, d);
    }
}
var Gh = {
    readContext: vg,
    useCallback: Ah,
    useContext: Ah,
    useEffect: Ah,
    useImperativeHandle: Ah,
    useLayoutEffect: Ah,
    useMemo: Ah,
    useReducer: Ah,
    useRef: Ah,
    useState: Ah,
    useDebugValue: Ah,
    useDeferredValue: Ah,
    useTransition: Ah,
    useMutableSource: Ah,
    useOpaqueIdentifier: Ah,
    unstable_isNewReconciler: !1
}, Dh = {
    readContext: vg,
    useCallback: function(a, b) {
        Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: vg,
    useEffect: Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Uh(4, 2, Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = Oh.bind(null, R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: Sh,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Qh(a), c = b[0], d = b[1];
        Wh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Qh(!1), b = a[0];
        a = di.bind(null, a[1]);
        Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if (lh) {
            var a = !1, b = uf(function() {
                a || (a = !0, c("r:" + (tf++).toString(36)));
                throw Error(y(355));
            }), c = Qh(b)[1];
            0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function() {
                c("r:" + (tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + (tf++).toString(36);
        Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, Eh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Kh,
    useRef: Th,
    useState: function() {
        return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Kh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Kh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, Fh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Lh,
    useRef: Th,
    useState: function() {
        return Lh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Lh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Lh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Lh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, ei = ra.ReactCurrentOwner, ug = !1;
function fi(a, b, c, d) {
    b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}
function gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    tg(b, e);
    d = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, d, e);
    return b.child;
}
function ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
        a = Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
    b.flags |= 1;
    a = Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ki(a, b, c, d, e, f) {
    if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) {
        if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);
        else return b.lanes = a.lanes, hi(a, b, f);
    }
    return li(a, b, c, d, f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
    fi(a, b, e, c);
    return b.child;
}
function oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function li(a, b, c, d, e) {
    var f = Ff(c) ? Df : M.current;
    f = Ef(b, f);
    tg(b, e);
    c = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, c, e);
    return b.child;
}
function pi(a, b, c, d, e) {
    if (Ff(c)) {
        var f = !0;
        Jf(b);
    } else f = !1;
    tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
        wg = !1;
        var p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
        wg = !1;
        p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return qi(a, b, c, d, f, e);
}
function qi(a, b, c, d, e, f) {
    oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
    d = b.stateNode;
    ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
    b.memoizedState = d.state;
    e && Kf(b, c, !0);
    return b.child;
}
function ri(a) {
    var b = a.stateNode;
    b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
    eh(a, b.containerInfo);
}
var si = {
    dehydrated: null,
    retryLane: 0
};
function ti(a, b, c) {
    var d = b.pendingProps, e = P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    I(P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, b.lanes = 33554432, a;
        c = vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
        c = xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
    c = Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
    null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    sg(a.return, b);
}
function zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    fi(a, b, d.children, c);
    d = P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && yi(a, c);
            else if (19 === a.tag) yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error(y(153));
        if (null !== b.child) {
            a = b.child;
            c = Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var Bi, Ci, Di, Ei;
Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Ci = function() {};
Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        dh(ah.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "option":
                e = eb(a, e);
                d = eb(a, d);
                f = [];
                break;
            case "select":
                e = $7JwYr({}, e, {
                    value: void 0
                });
                d = $7JwYr({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
        }
        vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Fi(a, b) {
    if (!lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return Ff(b.type) && Gf(), null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            Ci(b);
            return null;
        case 5:
            hh(b);
            var e = dh(ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(y(166));
                    return null;
                }
                a = dh(ah.current);
                if (rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[wf] = b;
                    d[xf] = f;
                    switch(c){
                        case "dialog":
                            G("cancel", d);
                            G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < Xe.length; a++)G(Xe[a], d);
                            break;
                        case "source":
                            G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", d);
                            G("load", d);
                            break;
                        case "details":
                            G("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            G("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), G("invalid", d);
                    }
                    vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
                    switch(c){
                        case "input":
                            Va(d);
                            cb(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === kb.html && (a = lb(c));
                    a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[wf] = b;
                    a[xf] = d;
                    Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = wb(c, d);
                    switch(c){
                        case "dialog":
                            G("cancel", a);
                            G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < Xe.length; e++)G(Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", a);
                            G("load", a);
                            e = d;
                            break;
                        case "details":
                            G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            Za(a, d);
                            e = Ya(a, d);
                            G("invalid", a);
                            break;
                        case "option":
                            e = eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = $7JwYr({}, d, {
                                value: void 0
                            });
                            G("invalid", a);
                            break;
                        case "textarea":
                            hb(a, d);
                            e = gb(a, d);
                            G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            Va(a);
                            cb(a, d, !1);
                            break;
                        case "textarea":
                            Va(a);
                            jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = jf);
                    }
                    mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
                c = dh(ch.current);
                dh(ah.current);
                rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            H(P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);
                else {
                    if (0 === V || 3 === V) V = 4;
                    null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;
        case 10:
            return rg(b), null;
        case 17:
            return Ff(b.type) && Gf(), null;
        case 19:
            H(P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) Fi(d, !1);
                else {
                    if (0 !== V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            I(P, P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error(y(156, b.tag));
}
function Li(a) {
    switch(a.tag){
        case 1:
            Ff(a.type) && Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error(y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return hh(a), null;
        case 13:
            return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return H(P), null;
        case 4:
            return fh(), null;
        case 10:
            return rg(a), null;
        case 23:
        case 24:
            return Ki(), null;
        default:
            return null;
    }
}
function Mi(a, b) {
    try {
        var c = "", d = b;
        do c += Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Oi = "function" === typeof WeakMap ? WeakMap : Map;
function Pi(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Qi || (Qi = !0, Ri = d);
        Ni(a, b);
    };
    return c;
}
function Si(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === Ti ? Ti = new Set([
            this
        ]) : Ti.add(this), Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var Ui = "function" === typeof WeakSet ? WeakSet : Set;
function Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Wi(a, c);
        }
        else b.current = null;
    }
}
function Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(y(163));
}
function Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error(y(163));
}
function aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function bj(a, b) {
    if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
        Mf.onCommitFiberUnmount(Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                Wi(b, f);
            }
            break;
        case 5:
            Vi(b);
            break;
        case 4:
            cj(a, b);
    }
}
function dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (ej(b)) break a;
            b = b.return;
        }
        throw Error(y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(y(161));
    }
    c.flags & 16 && (pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? gj(a, c, b) : hj(a, c, b);
}
function gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));
    else if (4 !== d && (a = a.child, null !== a)) for(gj(a, b, c), a = a.sibling; null !== a;)gj(a, b, c), a = a.sibling;
}
function hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(hj(a, b, c), a = a.sibling; null !== a;)hj(a, b, c), a = a.sibling;
}
function cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error(y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if (bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $a(c, d);
                    wb(a, e);
                    b = wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            ab(c, d);
                            break;
                        case "textarea":
                            ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && (jj = O(), aj(b.child, !0));
            kj(b);
            return;
        case 19:
            kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            aj(b, null !== b.memoizedState);
            return;
    }
    throw Error(y(163));
}
function kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ui);
        b.forEach(function(b) {
            var d = lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
    Ji = O() + 500;
}
var Z = null, Qi = !1, Ri = null, Ti = null, xj = !1, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = !1;
function Hg() {
    return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}
function Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
    0 === Gj && (Gj = tj);
    if (0 !== kg.transition) {
        0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
        a = Gj;
        var b = 4186112 & ~Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = eg();
    0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
    return a;
}
function Jg(a, b, c) {
    if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
    a = Kj(a, b);
    if (null === a) return null;
    $c(a, b, c);
    a === U && (Hi |= b, 4 === V && Ii(a, W));
    var d = eg();
    1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([
        a
    ]) : Cj.add(a)), Mj(a, c));
    vj = a;
}
function Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                Rc(k);
                var n = F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = Uc(a, a === U ? W : 0);
    b = F;
    if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== Zf && Pf(c);
        }
        15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [
            c
        ], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Nj(a) {
    Fj = -1;
    Hj = Gj = 0;
    if (0 !== (X & 48)) throw Error(y(327));
    var b = a.callbackNode;
    if (Oj() && a.callbackNode !== b) return null;
    var c = Uc(a, a === U ? W : 0);
    if (0 === c) return null;
    var d = c;
    var e = X;
    X |= 16;
    var f = Pj();
    if (U !== a || W !== d) wj(), Qj(a, d);
    for(;;)try {
        Rj();
        break;
    } catch (h) {
        Sj(a, h);
    }
    qg();
    oj.current = f;
    X = e;
    null !== Y ? d = 0 : (U = null, W = 0, d = V);
    if (0 !== (tj & Hi)) Qj(a, 0);
    else if (0 !== d) {
        2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
        if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error(y(345));
            case 2:
                Uj(a);
                break;
            case 3:
                Ii(a, c);
                if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
                    if (0 !== Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = of(Uj.bind(null, a), d);
                    break;
                }
                Uj(a);
                break;
            case 4:
                Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = of(Uj.bind(null, a), c);
                    break;
                }
                Uj(a);
                break;
            case 5:
                Uj(a);
                break;
            default:
                throw Error(y(329));
        }
    }
    Mj(a, O());
    return a.callbackNode === b ? Nj.bind(null, a) : null;
}
function Ii(a, b) {
    b &= ~uj;
    b &= ~Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Lj(a) {
    if (0 !== (X & 48)) throw Error(y(327));
    Oj();
    if (a === U && 0 !== (a.expiredLanes & W)) {
        var b = W;
        var c = Tj(a, b);
        0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
    } else b = Uc(a, 0), c = Tj(a, b);
    0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
    if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Uj(a);
    Mj(a, O());
    return null;
}
function Vj() {
    if (null !== Cj) {
        var a = Cj;
        Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            Mj(a, O());
        });
    }
    ig();
}
function Wj(a, b) {
    var c = X;
    X |= 1;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function Xj(a, b) {
    var c = X;
    X &= -2;
    X |= 8;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function ni(a, b) {
    I(rj, qj);
    qj |= b;
    tj |= b;
}
function Ki() {
    qj = rj.current;
    H(rj);
}
function Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, pf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Gf();
                break;
            case 3:
                fh();
                H(N);
                H(M);
                uh();
                break;
            case 5:
                hh(d);
                break;
            case 4:
                fh();
                break;
            case 13:
                H(P);
                break;
            case 19:
                H(P);
                break;
            case 10:
                rg(d);
                break;
            case 23:
            case 24:
                Ki();
        }
        c = c.return;
    }
    U = a;
    Y = Tg(a.current, null);
    W = qj = tj = b;
    V = 0;
    sj = null;
    uj = Hi = Dg = 0;
}
function Sj(a, b) {
    do {
        var c = Y;
        try {
            qg();
            vh.current = Gh;
            if (yh) {
                for(var d = R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                yh = !1;
            }
            xh = 0;
            T = S = R = null;
            zh = !1;
            pj.current = null;
            if (null === c || null === c.return) {
                V = 1;
                sj = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== (P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = zg(-1, 1);
                                        t.tag = 2;
                                        Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== V && (V = 2);
                k = Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = Pi(p, f, b);
                            Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = Si(p, f, b);
                                Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            Zj(c);
        } catch (va) {
            b = va;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Pj() {
    var a = oj.current;
    oj.current = Gh;
    return null === a ? Gh : a;
}
function Tj(a, b) {
    var c = X;
    X |= 16;
    var d = Pj();
    U === a && W === b || Qj(a, b);
    for(;;)try {
        ak();
        break;
    } catch (e) {
        Sj(a, e);
    }
    qg();
    X = c;
    oj.current = d;
    if (null !== Y) throw Error(y(261));
    U = null;
    W = 0;
    return V;
}
function ak() {
    for(; null !== Y;)bk(Y);
}
function Rj() {
    for(; null !== Y && !Qf();)bk(Y);
}
function bk(a) {
    var b = ck(a.alternate, a, qj);
    a.memoizedProps = a.pendingProps;
    null === b ? Zj(a) : Y = b;
    pj.current = null;
}
function Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = Gi(c, b, qj);
            if (null !== c) {
                Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = Li(b);
            if (null !== c) {
                c.flags &= 2047;
                Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === V && (V = 5);
}
function Uj(a) {
    var b = eg();
    gg(99, dk.bind(null, a, b));
    return null;
}
function dk(a, b) {
    do Oj();
    while (null !== yj);
    if (0 !== (X & 48)) throw Error(y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
    a === U && (Y = U = null, W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = X;
        X |= 32;
        pj.current = null;
        kf = fd;
        g = Ne();
        if (Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        lf = {
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Ij = null;
        Jj = !1;
        Z = d;
        do try {
            ek();
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Ij = null;
        Z = d;
        do try {
            for(g = a; null !== Z;){
                var t = Z.flags;
                t & 16 && pb(Z.stateNode, "");
                if (t & 128) {
                    var q = Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        fj(Z);
                        Z.flags &= -3;
                        break;
                    case 6:
                        fj(Z);
                        Z.flags &= -3;
                        ij(Z.alternate, Z);
                        break;
                    case 1024:
                        Z.flags &= -1025;
                        break;
                    case 1028:
                        Z.flags &= -1025;
                        ij(Z.alternate, Z);
                        break;
                    case 4:
                        ij(Z.alternate, Z);
                        break;
                    case 8:
                        h = Z;
                        cj(g, h);
                        var J = h.alternate;
                        dj(h);
                        null !== J && dj(J);
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        v = lf;
        q = Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
            null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        fd = !!kf;
        lf = kf = null;
        a.current = c;
        Z = d;
        do try {
            for(t = a; null !== Z;){
                var K = Z.flags;
                K & 36 && Yi(t, Z.alternate, Z);
                if (K & 128) {
                    q = void 0;
                    var Q = Z.ref;
                    if (null !== Q) {
                        var L = Z.stateNode;
                        switch(Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Z = null;
        $f();
        X = e;
    } else a.current = c;
    if (xj) xj = !1, yj = a, zj = b;
    else for(Z = d; null !== Z;)b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
    d = a.pendingLanes;
    0 === d && (Ti = null);
    1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
    c = c.stateNode;
    if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
        Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    Mj(a, O());
    if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
    if (0 !== (X & 8)) return null;
    ig();
    return null;
}
function ek() {
    for(; null !== Z;){
        var a = Z.alternate;
        Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
        var b = Z.flags;
        0 !== (b & 256) && Xi(a, Z);
        0 === (b & 512) || xj || (xj = !0, hg(97, function() {
            Oj();
            return null;
        }));
        Z = Z.nextEffect;
    }
}
function Oj() {
    if (90 !== zj) {
        var a = 97 < zj ? 97 : zj;
        zj = 90;
        return gg(a, fk);
    }
    return !1;
}
function $i(a, b) {
    Aj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function Zi(a, b) {
    Bj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function fk() {
    if (null === yj) return !1;
    var a = yj;
    yj = null;
    if (0 !== (X & 48)) throw Error(y(331));
    var b = X;
    X |= 32;
    var c = Bj;
    Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    c = Aj;
    Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    X = b;
    ig();
    return !0;
}
function gk(a, b, c) {
    b = Mi(c, b);
    b = Pi(a, b, 1);
    Ag(a, b);
    b = Hg();
    a = Kj(a, 1);
    null !== a && ($c(a, 1, b), Mj(a, b));
}
function Wi(a, b) {
    if (3 === a.tag) gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
                a = Mi(b, a);
                var e = Si(c, a, 1);
                Ag(c, e);
                e = Hg();
                c = Kj(c, 1);
                if (null !== c) $c(c, 1, e), Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
    Mj(a, b);
}
function lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
    c = Hg();
    a = Kj(a, b);
    null !== a && ($c(a, b, c), Mj(a, c));
}
var ck;
ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;
        else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            ug = !1;
            switch(b.tag){
                case 3:
                    ri(b);
                    sh();
                    break;
                case 5:
                    gh(b);
                    break;
                case 1:
                    Ff(b.type) && Jf(b);
                    break;
                case 4:
                    eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    I(mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
                        I(P, P.current & 1);
                        b = hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    I(P, P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    I(P, P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, mi(a, b, c);
            }
            return hi(a, b, c);
        }
    } else ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = Ef(b, M.current);
            tg(b, c);
            e = Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (Ff(d)) {
                    var f = !0;
                    Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Gg(b, d, g, a);
                e.updater = Kg;
                b.stateNode = e;
                e._reactInternals = b;
                Og(b, d, a, c);
                b = qi(null, b, d, !0, f, c);
            } else b.tag = 0, fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = hk(e);
                a = lg(e, a);
                switch(f){
                    case 0:
                        b = li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ii(null, b, e, lg(e.type, a), d, c);
                        break a;
                }
                throw Error(y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);
        case 3:
            ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            yg(a, b);
            Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) sh(), b = hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
                    c = Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else fi(a, b, d, c), sh();
                b = b.child;
            }
            return b;
        case 5:
            return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;
        case 6:
            return null === a && ph(b), null;
        case 13:
            return ti(a, b, c);
        case 4:
            return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);
        case 7:
            return fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !N.current) {
                            b = hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);
        case 15:
            return ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);
        case 19:
            return Ai(a, b, c);
        case 23:
            return mi(a, b, c);
        case 24:
            return mi(a, b, c);
    }
    throw Error(y(156, b.tag));
};
function ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function nh(a, b, c, d) {
    return new ik(a, b, c, d);
}
function ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function hk(a) {
    if ("function" === typeof a) return ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Aa) return 11;
        if (a === Da) return 14;
    }
    return 2;
}
function Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ua:
            return Xg(c.children, e, f, b);
        case Ha:
            g = 8;
            e |= 16;
            break;
        case wa:
            g = 8;
            e |= 1;
            break;
        case xa:
            return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;
        case Ba:
            return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;
        case Ca:
            return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;
        case Ia:
            return vi(c, e, f, b);
        case Ja:
            return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case ya:
                    g = 10;
                    break a;
                case za:
                    g = 9;
                    break a;
                case Aa:
                    g = 11;
                    break a;
                case Da:
                    g = 14;
                    break a;
                case Ea:
                    g = 16;
                    d = null;
                    break a;
                case Fa:
                    g = 22;
                    break a;
            }
            throw Error(y(130, null == a ? a : typeof a, ""));
    }
    b = nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Xg(a, b, c, d) {
    a = nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function vi(a, b, c, d) {
    a = nh(23, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    return a;
}
function Ug(a, b, c) {
    a = nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function Wg(a, b, c) {
    b = nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = Zc(0);
    this.expirationTimes = Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function lk(a, b, c, d) {
    var e = b.current, f = Hg(), g = Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (Ff(k)) {
                c = If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    Jg(e, g, f);
    return g;
}
function mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function ok(a, b) {
    nk(a, b);
    (a = a.alternate) && nk(a, b);
}
function pk() {
    return null;
}
function qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new jk(a, b, null != c && !0 === c.hydrate);
    b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    xg(b);
    a[ff] = c.current;
    cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
qk.prototype.render = function(a) {
    lk(a, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    lk(null, a, null, function() {
        b[ff] = null;
    });
};
function rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = mk(g);
                h.call(a);
            };
        }
        lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = mk(g);
                k.call(a);
            };
        }
        Xj(function() {
            lk(b, g, a, e);
        });
    }
    return mk(g);
}
ec = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 4, b);
        ok(a, 4);
    }
};
fc = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 67108864, b);
        ok(a, 67108864);
    }
};
gc = function(a) {
    if (13 === a.tag) {
        var b = Hg(), c = Ig(a);
        Jg(a, c, b);
        ok(a, c);
    }
};
hc = function(a, b) {
    return b();
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(y(90));
                        Wa(d);
                        ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Wj;
Hb = function(a, b, c, d, e) {
    var f = X;
    X |= 4;
    try {
        return gg(98, a.bind(null, b, c, d, e));
    } finally{
        X = f, 0 === X && (wj(), ig());
    }
};
Ib = function() {
    0 === (X & 49) && (Vj(), Oj());
};
Jb = function(a, b) {
    var c = X;
    X |= 2;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
};
function uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!rk(b)) throw Error(y(200));
    return kk(a, b, null, c);
}
var vk = {
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Oj,
        {
            current: !1
        }
    ]
}, wk = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var xk = {
    bundleType: wk.bundleType,
    version: wk.version,
    rendererPackageName: wk.rendererPackageName,
    rendererConfig: wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: wk.findFiberByHostInstance || pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yk.isDisabled && yk.supportsFiber) try {
        Lf = yk.inject(xk), Mf = yk;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(y(188));
        throw Error(y(268, Object.keys(a)));
    }
    a = cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    var c = X;
    if (0 !== (c & 48)) return a(b);
    X |= 1;
    try {
        if (a) return gg(99, a.bind(null, b));
    } finally{
        X = c, ig();
    }
};
exports.hydrate = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!rk(a)) throw Error(y(40));
    return a._reactRootContainer ? (Xj(function() {
        tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[ff] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Wj;
exports.unstable_createPortal = function(a, b) {
    return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!rk(c)) throw Error(y(200));
    if (null == a || void 0 === a._reactInternals) throw Error(y(38));
    return tk(a, b, c, !1, d);
};
exports.version = "17.0.2";

});
parcelRegister("1c9zD", function(module, exports) {
"use strict";

module.exports = (parcelRequire("lffg4"));

});
parcelRegister("lffg4", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $f776d5a8b0cafef3$export$c4744153514ff05d; }, function (v) { return $f776d5a8b0cafef3$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $f776d5a8b0cafef3$export$b5836b71941fa3ed; }, function (v) { return $f776d5a8b0cafef3$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $f776d5a8b0cafef3$export$d66a1c1c77bd778b; }, function (v) { return $f776d5a8b0cafef3$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $f776d5a8b0cafef3$export$3e506c1ccc9cc1a7; }, function (v) { return $f776d5a8b0cafef3$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $f776d5a8b0cafef3$export$e26fe2ed2fa76875; }, function (v) { return $f776d5a8b0cafef3$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $f776d5a8b0cafef3$export$502329bbf4b505b1; }, function (v) { return $f776d5a8b0cafef3$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $f776d5a8b0cafef3$export$6e3807111c4874c4; }, function (v) { return $f776d5a8b0cafef3$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $f776d5a8b0cafef3$export$c27134553091fb3a; }, function (v) { return $f776d5a8b0cafef3$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $f776d5a8b0cafef3$export$33ee1acdc04fd2a2; }, function (v) { return $f776d5a8b0cafef3$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $f776d5a8b0cafef3$export$b00a404bbd5edef2; }, function (v) { return $f776d5a8b0cafef3$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $f776d5a8b0cafef3$export$8352ce38b91d0c62; }, function (v) { return $f776d5a8b0cafef3$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $f776d5a8b0cafef3$export$d3dfb8e4810cb555; }, function (v) { return $f776d5a8b0cafef3$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $f776d5a8b0cafef3$export$839f9183b0465a69; }, function (v) { return $f776d5a8b0cafef3$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $f776d5a8b0cafef3$export$72fdf0e06517287b; }, function (v) { return $f776d5a8b0cafef3$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $f776d5a8b0cafef3$export$4b844e58a3e414b4; }, function (v) { return $f776d5a8b0cafef3$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $f776d5a8b0cafef3$export$816d2913ae6b83b1; }, function (v) { return $f776d5a8b0cafef3$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $f776d5a8b0cafef3$export$61bcfe829111a1d0; }, function (v) { return $f776d5a8b0cafef3$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $f776d5a8b0cafef3$export$7ee8c9beb337bc3f; }, function (v) { return $f776d5a8b0cafef3$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $f776d5a8b0cafef3$export$cf845f2c119da08a; }, function (v) { return $f776d5a8b0cafef3$export$cf845f2c119da08a = v; });
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f776d5a8b0cafef3$export$c4744153514ff05d;
var $f776d5a8b0cafef3$export$b5836b71941fa3ed;
var $f776d5a8b0cafef3$export$d66a1c1c77bd778b;
var $f776d5a8b0cafef3$export$3e506c1ccc9cc1a7;
var $f776d5a8b0cafef3$export$e26fe2ed2fa76875;
var $f776d5a8b0cafef3$export$502329bbf4b505b1;
var $f776d5a8b0cafef3$export$6e3807111c4874c4;
var $f776d5a8b0cafef3$export$c27134553091fb3a;
var $f776d5a8b0cafef3$export$33ee1acdc04fd2a2;
var $f776d5a8b0cafef3$export$b00a404bbd5edef2;
var $f776d5a8b0cafef3$export$8352ce38b91d0c62;
var $f776d5a8b0cafef3$export$d3dfb8e4810cb555;
var $f776d5a8b0cafef3$export$839f9183b0465a69;
var $f776d5a8b0cafef3$export$72fdf0e06517287b;
var $f776d5a8b0cafef3$export$4b844e58a3e414b4;
var $f776d5a8b0cafef3$export$816d2913ae6b83b1;
var $f776d5a8b0cafef3$export$61bcfe829111a1d0;
var $f776d5a8b0cafef3$export$7ee8c9beb337bc3f;
var $f776d5a8b0cafef3$export$cf845f2c119da08a;
"use strict";
var $f776d5a8b0cafef3$var$f, $f776d5a8b0cafef3$var$g, $f776d5a8b0cafef3$var$h, $f776d5a8b0cafef3$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $f776d5a8b0cafef3$var$l = performance;
    $f776d5a8b0cafef3$export$c4744153514ff05d = function() {
        return $f776d5a8b0cafef3$var$l.now();
    };
} else {
    var $f776d5a8b0cafef3$var$p = Date, $f776d5a8b0cafef3$var$q = $f776d5a8b0cafef3$var$p.now();
    $f776d5a8b0cafef3$export$c4744153514ff05d = function() {
        return $f776d5a8b0cafef3$var$p.now() - $f776d5a8b0cafef3$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $f776d5a8b0cafef3$var$t = null, $f776d5a8b0cafef3$var$u = null, $f776d5a8b0cafef3$var$w = function() {
        if (null !== $f776d5a8b0cafef3$var$t) try {
            var a = $f776d5a8b0cafef3$export$c4744153514ff05d();
            $f776d5a8b0cafef3$var$t(!0, a);
            $f776d5a8b0cafef3$var$t = null;
        } catch (b) {
            throw setTimeout($f776d5a8b0cafef3$var$w, 0), b;
        }
    };
    $f776d5a8b0cafef3$var$f = function(a) {
        null !== $f776d5a8b0cafef3$var$t ? setTimeout($f776d5a8b0cafef3$var$f, 0, a) : ($f776d5a8b0cafef3$var$t = a, setTimeout($f776d5a8b0cafef3$var$w, 0));
    };
    $f776d5a8b0cafef3$var$g = function(a, b) {
        $f776d5a8b0cafef3$var$u = setTimeout(a, b);
    };
    $f776d5a8b0cafef3$var$h = function() {
        clearTimeout($f776d5a8b0cafef3$var$u);
    };
    $f776d5a8b0cafef3$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $f776d5a8b0cafef3$var$k = $f776d5a8b0cafef3$export$d66a1c1c77bd778b = function() {};
} else {
    var $f776d5a8b0cafef3$var$x = window.setTimeout, $f776d5a8b0cafef3$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $f776d5a8b0cafef3$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $f776d5a8b0cafef3$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $f776d5a8b0cafef3$var$A = !1, $f776d5a8b0cafef3$var$B = null, $f776d5a8b0cafef3$var$C = -1, $f776d5a8b0cafef3$var$D = 5, $f776d5a8b0cafef3$var$E = 0;
    $f776d5a8b0cafef3$export$b5836b71941fa3ed = function() {
        return $f776d5a8b0cafef3$export$c4744153514ff05d() >= $f776d5a8b0cafef3$var$E;
    };
    $f776d5a8b0cafef3$var$k = function() {};
    $f776d5a8b0cafef3$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $f776d5a8b0cafef3$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $f776d5a8b0cafef3$var$F = new MessageChannel, $f776d5a8b0cafef3$var$G = $f776d5a8b0cafef3$var$F.port2;
    $f776d5a8b0cafef3$var$F.port1.onmessage = function() {
        if (null !== $f776d5a8b0cafef3$var$B) {
            var a = $f776d5a8b0cafef3$export$c4744153514ff05d();
            $f776d5a8b0cafef3$var$E = a + $f776d5a8b0cafef3$var$D;
            try {
                $f776d5a8b0cafef3$var$B(!0, a) ? $f776d5a8b0cafef3$var$G.postMessage(null) : ($f776d5a8b0cafef3$var$A = !1, $f776d5a8b0cafef3$var$B = null);
            } catch (b) {
                throw $f776d5a8b0cafef3$var$G.postMessage(null), b;
            }
        } else $f776d5a8b0cafef3$var$A = !1;
    };
    $f776d5a8b0cafef3$var$f = function(a) {
        $f776d5a8b0cafef3$var$B = a;
        $f776d5a8b0cafef3$var$A || ($f776d5a8b0cafef3$var$A = !0, $f776d5a8b0cafef3$var$G.postMessage(null));
    };
    $f776d5a8b0cafef3$var$g = function(a, b) {
        $f776d5a8b0cafef3$var$C = $f776d5a8b0cafef3$var$x(function() {
            a($f776d5a8b0cafef3$export$c4744153514ff05d());
        }, b);
    };
    $f776d5a8b0cafef3$var$h = function() {
        $f776d5a8b0cafef3$var$y($f776d5a8b0cafef3$var$C);
        $f776d5a8b0cafef3$var$C = -1;
    };
}
function $f776d5a8b0cafef3$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $f776d5a8b0cafef3$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $f776d5a8b0cafef3$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $f776d5a8b0cafef3$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $f776d5a8b0cafef3$var$I(n, c)) void 0 !== r && 0 > $f776d5a8b0cafef3$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $f776d5a8b0cafef3$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $f776d5a8b0cafef3$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $f776d5a8b0cafef3$var$L = [], $f776d5a8b0cafef3$var$M = [], $f776d5a8b0cafef3$var$N = 1, $f776d5a8b0cafef3$var$O = null, $f776d5a8b0cafef3$var$P = 3, $f776d5a8b0cafef3$var$Q = !1, $f776d5a8b0cafef3$var$R = !1, $f776d5a8b0cafef3$var$S = !1;
function $f776d5a8b0cafef3$var$T(a) {
    for(var b = $f776d5a8b0cafef3$var$J($f776d5a8b0cafef3$var$M); null !== b;){
        if (null === b.callback) $f776d5a8b0cafef3$var$K($f776d5a8b0cafef3$var$M);
        else if (b.startTime <= a) $f776d5a8b0cafef3$var$K($f776d5a8b0cafef3$var$M), b.sortIndex = b.expirationTime, $f776d5a8b0cafef3$var$H($f776d5a8b0cafef3$var$L, b);
        else break;
        b = $f776d5a8b0cafef3$var$J($f776d5a8b0cafef3$var$M);
    }
}
function $f776d5a8b0cafef3$var$U(a) {
    $f776d5a8b0cafef3$var$S = !1;
    $f776d5a8b0cafef3$var$T(a);
    if (!$f776d5a8b0cafef3$var$R) {
        if (null !== $f776d5a8b0cafef3$var$J($f776d5a8b0cafef3$var$L)) $f776d5a8b0cafef3$var$R = !0, $f776d5a8b0cafef3$var$f($f776d5a8b0cafef3$var$V);
        else {
            var b = $f776d5a8b0cafef3$var$J($f776d5a8b0cafef3$var$M);
            null !== b && $f776d5a8b0cafef3$var$g($f776d5a8b0cafef3$var$U, b.startTime - a);
        }
    }
}
function $f776d5a8b0cafef3$var$V(a, b) {
    $f776d5a8b0cafef3$var$R = !1;
    $f776d5a8b0cafef3$var$S && ($f776d5a8b0cafef3$var$S = !1, $f776d5a8b0cafef3$var$h());
    $f776d5a8b0cafef3$var$Q = !0;
    var c = $f776d5a8b0cafef3$var$P;
    try {
        $f776d5a8b0cafef3$var$T(b);
        for($f776d5a8b0cafef3$var$O = $f776d5a8b0cafef3$var$J($f776d5a8b0cafef3$var$L); null !== $f776d5a8b0cafef3$var$O && (!($f776d5a8b0cafef3$var$O.expirationTime > b) || a && !$f776d5a8b0cafef3$export$b5836b71941fa3ed());){
            var d = $f776d5a8b0cafef3$var$O.callback;
            if ("function" === typeof d) {
                $f776d5a8b0cafef3$var$O.callback = null;
                $f776d5a8b0cafef3$var$P = $f776d5a8b0cafef3$var$O.priorityLevel;
                var e = d($f776d5a8b0cafef3$var$O.expirationTime <= b);
                b = $f776d5a8b0cafef3$export$c4744153514ff05d();
                "function" === typeof e ? $f776d5a8b0cafef3$var$O.callback = e : $f776d5a8b0cafef3$var$O === $f776d5a8b0cafef3$var$J($f776d5a8b0cafef3$var$L) && $f776d5a8b0cafef3$var$K($f776d5a8b0cafef3$var$L);
                $f776d5a8b0cafef3$var$T(b);
            } else $f776d5a8b0cafef3$var$K($f776d5a8b0cafef3$var$L);
            $f776d5a8b0cafef3$var$O = $f776d5a8b0cafef3$var$J($f776d5a8b0cafef3$var$L);
        }
        if (null !== $f776d5a8b0cafef3$var$O) var m = !0;
        else {
            var n = $f776d5a8b0cafef3$var$J($f776d5a8b0cafef3$var$M);
            null !== n && $f776d5a8b0cafef3$var$g($f776d5a8b0cafef3$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $f776d5a8b0cafef3$var$O = null, $f776d5a8b0cafef3$var$P = c, $f776d5a8b0cafef3$var$Q = !1;
    }
}
var $f776d5a8b0cafef3$var$W = $f776d5a8b0cafef3$var$k;
$f776d5a8b0cafef3$export$3e506c1ccc9cc1a7 = 5;
$f776d5a8b0cafef3$export$e26fe2ed2fa76875 = 1;
$f776d5a8b0cafef3$export$502329bbf4b505b1 = 4;
$f776d5a8b0cafef3$export$6e3807111c4874c4 = 3;
$f776d5a8b0cafef3$export$c27134553091fb3a = null;
$f776d5a8b0cafef3$export$33ee1acdc04fd2a2 = 2;
$f776d5a8b0cafef3$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$f776d5a8b0cafef3$export$8352ce38b91d0c62 = function() {
    $f776d5a8b0cafef3$var$R || $f776d5a8b0cafef3$var$Q || ($f776d5a8b0cafef3$var$R = !0, $f776d5a8b0cafef3$var$f($f776d5a8b0cafef3$var$V));
};
$f776d5a8b0cafef3$export$d3dfb8e4810cb555 = function() {
    return $f776d5a8b0cafef3$var$P;
};
$f776d5a8b0cafef3$export$839f9183b0465a69 = function() {
    return $f776d5a8b0cafef3$var$J($f776d5a8b0cafef3$var$L);
};
$f776d5a8b0cafef3$export$72fdf0e06517287b = function(a) {
    switch($f776d5a8b0cafef3$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $f776d5a8b0cafef3$var$P;
    }
    var c = $f776d5a8b0cafef3$var$P;
    $f776d5a8b0cafef3$var$P = b;
    try {
        return a();
    } finally{
        $f776d5a8b0cafef3$var$P = c;
    }
};
$f776d5a8b0cafef3$export$4b844e58a3e414b4 = function() {};
$f776d5a8b0cafef3$export$816d2913ae6b83b1 = $f776d5a8b0cafef3$var$W;
$f776d5a8b0cafef3$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $f776d5a8b0cafef3$var$P;
    $f776d5a8b0cafef3$var$P = a;
    try {
        return b();
    } finally{
        $f776d5a8b0cafef3$var$P = c;
    }
};
$f776d5a8b0cafef3$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $f776d5a8b0cafef3$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $f776d5a8b0cafef3$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $f776d5a8b0cafef3$var$H($f776d5a8b0cafef3$var$M, a), null === $f776d5a8b0cafef3$var$J($f776d5a8b0cafef3$var$L) && a === $f776d5a8b0cafef3$var$J($f776d5a8b0cafef3$var$M) && ($f776d5a8b0cafef3$var$S ? $f776d5a8b0cafef3$var$h() : $f776d5a8b0cafef3$var$S = !0, $f776d5a8b0cafef3$var$g($f776d5a8b0cafef3$var$U, c - d))) : (a.sortIndex = e, $f776d5a8b0cafef3$var$H($f776d5a8b0cafef3$var$L, a), $f776d5a8b0cafef3$var$R || $f776d5a8b0cafef3$var$Q || ($f776d5a8b0cafef3$var$R = !0, $f776d5a8b0cafef3$var$f($f776d5a8b0cafef3$var$V)));
    return a;
};
$f776d5a8b0cafef3$export$cf845f2c119da08a = function(a) {
    var b = $f776d5a8b0cafef3$var$P;
    return function() {
        var c = $f776d5a8b0cafef3$var$P;
        $f776d5a8b0cafef3$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $f776d5a8b0cafef3$var$P = c;
        }
    };
};

});



parcelRegister("c9wMV", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("4qPUL", function(module, exports) {
(function(globalScope) {
    "use strict";
    /*!
   *  decimal.js v10.4.3
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js
   *  Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Licence
   */ // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
    // The maximum exponent magnitude.
    // The limit on the value of `toExpNeg`, `toExpPos`, `minE` and `maxE`.
    var EXP_LIMIT = 9e15, // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
    MAX_DIGITS = 1e9, // Base conversion alphabet.
    NUMERALS = "0123456789abcdef", // The natural logarithm of 10 (1025 digits).
    LN10 = "2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058", // Pi (1025 digits).
    PI = "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789", // The initial configuration properties of the Decimal constructor.
    DEFAULTS = {
        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed at run-time using the `Decimal.config` method.
        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,
        // The rounding mode used when rounding to `precision`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,
        // The modulo mode used when calculating the modulus: a mod n.
        // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
        // The remainder (r) is calculated as: r = a - n * q.
        //
        // UP         0 The remainder is positive if the dividend is negative, else is negative.
        // DOWN       1 The remainder has the same sign as the dividend (JavaScript %).
        // FLOOR      3 The remainder has the same sign as the divisor (Python %).
        // HALF_EVEN  6 The IEEE 754 remainder function.
        // EUCLID     9 Euclidian division. q = sign(n) * floor(a / abs(n)). Always positive.
        //
        // Truncated division (1), floored division (3), the IEEE 754 remainder (6), and Euclidian
        // division (9) are commonly used for the modulus operation. The other rounding modes can also
        // be used, but they may not give useful results.
        modulo: 1,
        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,
        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos: 21,
        // The minimum exponent value, beneath which underflow to zero occurs.
        // JavaScript numbers: -324  (5e-324)
        minE: -EXP_LIMIT,
        // The maximum exponent value, above which overflow to Infinity occurs.
        // JavaScript numbers: 308  (1.7976931348623157e+308)
        maxE: EXP_LIMIT,
        // Whether to use cryptographically-secure random number generation, if available.
        crypto: false // true/false
    }, // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
    Decimal, inexact, noConflict, quadrant, external = true, decimalError = "[DecimalError] ", invalidArgument = decimalError + "Invalid argument: ", precisionLimitExceeded = decimalError + "Precision limit exceeded", cryptoUnavailable = decimalError + "crypto unavailable", tag = "[object Decimal]", mathfloor = Math.floor, mathpow = Math.pow, isBinary = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i, isHex = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i, isOctal = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, LN10_PRECISION = LN10.length - 1, PI_PRECISION = PI.length - 1, // Decimal.prototype object
    P = {
        toStringTag: tag
    };
    // Decimal prototype methods
    /*
   *  absoluteValue             abs
   *  ceil
   *  clampedTo                 clamp
   *  comparedTo                cmp
   *  cosine                    cos
   *  cubeRoot                  cbrt
   *  decimalPlaces             dp
   *  dividedBy                 div
   *  dividedToIntegerBy        divToInt
   *  equals                    eq
   *  floor
   *  greaterThan               gt
   *  greaterThanOrEqualTo      gte
   *  hyperbolicCosine          cosh
   *  hyperbolicSine            sinh
   *  hyperbolicTangent         tanh
   *  inverseCosine             acos
   *  inverseHyperbolicCosine   acosh
   *  inverseHyperbolicSine     asinh
   *  inverseHyperbolicTangent  atanh
   *  inverseSine               asin
   *  inverseTangent            atan
   *  isFinite
   *  isInteger                 isInt
   *  isNaN
   *  isNegative                isNeg
   *  isPositive                isPos
   *  isZero
   *  lessThan                  lt
   *  lessThanOrEqualTo         lte
   *  logarithm                 log
   *  [maximum]                 [max]
   *  [minimum]                 [min]
   *  minus                     sub
   *  modulo                    mod
   *  naturalExponential        exp
   *  naturalLogarithm          ln
   *  negated                   neg
   *  plus                      add
   *  precision                 sd
   *  round
   *  sine                      sin
   *  squareRoot                sqrt
   *  tangent                   tan
   *  times                     mul
   *  toBinary
   *  toDecimalPlaces           toDP
   *  toExponential
   *  toFixed
   *  toFraction
   *  toHexadecimal             toHex
   *  toNearest
   *  toNumber
   *  toOctal
   *  toPower                   pow
   *  toPrecision
   *  toSignificantDigits       toSD
   *  toString
   *  truncated                 trunc
   *  valueOf                   toJSON
   */ /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */ P.absoluteValue = P.abs = function() {
        var x = new this.constructor(this);
        if (x.s < 0) x.s = 1;
        return finalise(x);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number in the
   * direction of positive Infinity.
   *
   */ P.ceil = function() {
        return finalise(new this.constructor(this), this.e + 1, 2);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal clamped to the range
   * delineated by `min` and `max`.
   *
   * min {number|string|Decimal}
   * max {number|string|Decimal}
   *
   */ P.clampedTo = P.clamp = function(min, max) {
        var k, x = this, Ctor = x.constructor;
        min = new Ctor(min);
        max = new Ctor(max);
        if (!min.s || !max.s) return new Ctor(NaN);
        if (min.gt(max)) throw Error(invalidArgument + max);
        k = x.cmp(min);
        return k < 0 ? min : x.cmp(max) > 0 ? max : new Ctor(x);
    };
    /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value,
   *   NaN  if the value of either Decimal is NaN.
   *
   */ P.comparedTo = P.cmp = function(y) {
        var i, j, xdL, ydL, x = this, xd = x.d, yd = (y = new x.constructor(y)).d, xs = x.s, ys = y.s;
        // Either NaN or ±Infinity?
        if (!xd || !yd) return !xs || !ys ? NaN : xs !== ys ? xs : xd === yd ? 0 : !xd ^ xs < 0 ? 1 : -1;
        // Either zero?
        if (!xd[0] || !yd[0]) return xd[0] ? xs : yd[0] ? -ys : 0;
        // Signs differ?
        if (xs !== ys) return xs;
        // Compare exponents.
        if (x.e !== y.e) return x.e > y.e ^ xs < 0 ? 1 : -1;
        xdL = xd.length;
        ydL = yd.length;
        // Compare digit by digit.
        for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
            if (xd[i] !== yd[i]) return xd[i] > yd[i] ^ xs < 0 ? 1 : -1;
        }
        // Compare lengths.
        return xdL === ydL ? 0 : xdL > ydL ^ xs < 0 ? 1 : -1;
    };
    /*
   * Return a new Decimal whose value is the cosine of the value in radians of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-1, 1]
   *
   * cos(0)         = 1
   * cos(-0)        = 1
   * cos(Infinity)  = NaN
   * cos(-Infinity) = NaN
   * cos(NaN)       = NaN
   *
   */ P.cosine = P.cos = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.d) return new Ctor(NaN);
        // cos(0) = cos(-0) = 1
        if (!x.d[0]) return new Ctor(1);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(x.e, x.sd()) + LOG_BASE;
        Ctor.rounding = 1;
        x = cosine(Ctor, toLessThanHalfPi(Ctor, x));
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return finalise(quadrant == 2 || quadrant == 3 ? x.neg() : x, pr, rm, true);
    };
    /*
   *
   * Return a new Decimal whose value is the cube root of the value of this Decimal, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   *  cbrt(0)  =  0
   *  cbrt(-0) = -0
   *  cbrt(1)  =  1
   *  cbrt(-1) = -1
   *  cbrt(N)  =  N
   *  cbrt(-I) = -I
   *  cbrt(I)  =  I
   *
   * Math.cbrt(x) = (x < 0 ? -Math.pow(-x, 1/3) : Math.pow(x, 1/3))
   *
   */ P.cubeRoot = P.cbrt = function() {
        var e, m, n, r, rep, s, sd, t, t3, t3plusx, x = this, Ctor = x.constructor;
        if (!x.isFinite() || x.isZero()) return new Ctor(x);
        external = false;
        // Initial estimate.
        s = x.s * mathpow(x.s * x, 1 / 3);
        // Math.cbrt underflow/overflow?
        // Pass x to Math.pow as integer, then adjust the exponent of the result.
        if (!s || Math.abs(s) == 1 / 0) {
            n = digitsToString(x.d);
            e = x.e;
            // Adjust n exponent so it is a multiple of 3 away from x exponent.
            if (s = (e - n.length + 1) % 3) n += s == 1 || s == -2 ? "0" : "00";
            s = mathpow(n, 1 / 3);
            // Rarely, e may be one less than the result exponent value.
            e = mathfloor((e + 1) / 3) - (e % 3 == (e < 0 ? -1 : 2));
            if (s == 1 / 0) n = "5e" + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf("e") + 1) + e;
            }
            r = new Ctor(n);
            r.s = x.s;
        } else r = new Ctor(s.toString());
        sd = (e = Ctor.precision) + 3;
        // Halley's method.
        // TODO? Compare Newton's method.
        for(;;){
            t = r;
            t3 = t.times(t).times(t);
            t3plusx = t3.plus(x);
            r = divide(t3plusx.plus(x).times(t), t3plusx.plus(t3), sd + 2, 1);
            // TODO? Replace with for-loop and checkRoundingDigits.
            if (digitsToString(t.d).slice(0, sd) === (n = digitsToString(r.d)).slice(0, sd)) {
                n = n.slice(sd - 3, sd + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or 4999
                // , i.e. approaching a rounding boundary, continue the iteration.
                if (n == "9999" || !rep && n == "4999") {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    if (!rep) {
                        finalise(t, e + 1, 0);
                        if (t.times(t).times(t).eq(x)) {
                            r = t;
                            break;
                        }
                    }
                    sd += 4;
                    rep = 1;
                } else {
                    // If the rounding digits are null, 0{0,4} or 50{0,3}, check for an exact result.
                    // If not, then there are further digits and m will be truthy.
                    if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
                        // Truncate to the first rounding digit.
                        finalise(r, e + 1, 1);
                        m = !r.times(r).times(r).eq(x);
                    }
                    break;
                }
            }
        }
        external = true;
        return finalise(r, e, Ctor.rounding, m);
    };
    /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */ P.decimalPlaces = P.dp = function() {
        var w, d = this.d, n = NaN;
        if (d) {
            w = d.length - 1;
            n = (w - mathfloor(this.e / LOG_BASE)) * LOG_BASE;
            // Subtract the number of trailing zeros of the last word.
            w = d[w];
            if (w) for(; w % 10 == 0; w /= 10)n--;
            if (n < 0) n = 0;
        }
        return n;
    };
    /*
   *  n / 0 = I
   *  n / N = N
   *  n / I = 0
   *  0 / n = 0
   *  0 / 0 = N
   *  0 / N = N
   *  0 / I = 0
   *  N / n = N
   *  N / 0 = N
   *  N / N = N
   *  N / I = N
   *  I / n = I
   *  I / 0 = I
   *  I / N = N
   *  I / I = N
   *
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   */ P.dividedBy = P.div = function(y) {
        return divide(this, new this.constructor(y));
    };
    /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, rounded to `precision` significant digits using rounding mode `rounding`.
   *
   */ P.dividedToIntegerBy = P.divToInt = function(y) {
        var x = this, Ctor = x.constructor;
        return finalise(divide(x, new Ctor(y), 0, 1, 1), Ctor.precision, Ctor.rounding);
    };
    /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */ P.equals = P.eq = function(y) {
        return this.cmp(y) === 0;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number in the
   * direction of negative Infinity.
   *
   */ P.floor = function() {
        return finalise(new this.constructor(this), this.e + 1, 3);
    };
    /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */ P.greaterThan = P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */ P.greaterThanOrEqualTo = P.gte = function(y) {
        var k = this.cmp(y);
        return k == 1 || k === 0;
    };
    /*
   * Return a new Decimal whose value is the hyperbolic cosine of the value in radians of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [1, Infinity]
   *
   * cosh(x) = 1 + x^2/2! + x^4/4! + x^6/6! + ...
   *
   * cosh(0)         = 1
   * cosh(-0)        = 1
   * cosh(Infinity)  = Infinity
   * cosh(-Infinity) = Infinity
   * cosh(NaN)       = NaN
   *
   *  x        time taken (ms)   result
   * 1000      9                 9.8503555700852349694e+433
   * 10000     25                4.4034091128314607936e+4342
   * 100000    171               1.4033316802130615897e+43429
   * 1000000   3817              1.5166076984010437725e+434294
   * 10000000  abandoned after 2 minute wait
   *
   * TODO? Compare performance of cosh(x) = 0.5 * (exp(x) + exp(-x))
   *
   */ P.hyperbolicCosine = P.cosh = function() {
        var k, n, pr, rm, len, x = this, Ctor = x.constructor, one = new Ctor(1);
        if (!x.isFinite()) return new Ctor(x.s ? 1 / 0 : NaN);
        if (x.isZero()) return one;
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(x.e, x.sd()) + 4;
        Ctor.rounding = 1;
        len = x.d.length;
        // Argument reduction: cos(4x) = 1 - 8cos^2(x) + 8cos^4(x) + 1
        // i.e. cos(x) = 1 - cos^2(x/4)(8 - 8cos^2(x/4))
        // Estimate the optimum number of times to use the argument reduction.
        // TODO? Estimation reused from cosine() and may not be optimal here.
        if (len < 32) {
            k = Math.ceil(len / 3);
            n = (1 / tinyPow(4, k)).toString();
        } else {
            k = 16;
            n = "2.3283064365386962890625e-10";
        }
        x = taylorSeries(Ctor, 1, x.times(n), new Ctor(1), true);
        // Reverse argument reduction
        var cosh2_x, i = k, d8 = new Ctor(8);
        for(; i--;){
            cosh2_x = x.times(x);
            x = one.minus(cosh2_x.times(d8.minus(cosh2_x.times(d8))));
        }
        return finalise(x, Ctor.precision = pr, Ctor.rounding = rm, true);
    };
    /*
   * Return a new Decimal whose value is the hyperbolic sine of the value in radians of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-Infinity, Infinity]
   *
   * sinh(x) = x + x^3/3! + x^5/5! + x^7/7! + ...
   *
   * sinh(0)         = 0
   * sinh(-0)        = -0
   * sinh(Infinity)  = Infinity
   * sinh(-Infinity) = -Infinity
   * sinh(NaN)       = NaN
   *
   * x        time taken (ms)
   * 10       2 ms
   * 100      5 ms
   * 1000     14 ms
   * 10000    82 ms
   * 100000   886 ms            1.4033316802130615897e+43429
   * 200000   2613 ms
   * 300000   5407 ms
   * 400000   8824 ms
   * 500000   13026 ms          8.7080643612718084129e+217146
   * 1000000  48543 ms
   *
   * TODO? Compare performance of sinh(x) = 0.5 * (exp(x) - exp(-x))
   *
   */ P.hyperbolicSine = P.sinh = function() {
        var k, pr, rm, len, x = this, Ctor = x.constructor;
        if (!x.isFinite() || x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(x.e, x.sd()) + 4;
        Ctor.rounding = 1;
        len = x.d.length;
        if (len < 3) x = taylorSeries(Ctor, 2, x, x, true);
        else {
            // Alternative argument reduction: sinh(3x) = sinh(x)(3 + 4sinh^2(x))
            // i.e. sinh(x) = sinh(x/3)(3 + 4sinh^2(x/3))
            // 3 multiplications and 1 addition
            // Argument reduction: sinh(5x) = sinh(x)(5 + sinh^2(x)(20 + 16sinh^2(x)))
            // i.e. sinh(x) = sinh(x/5)(5 + sinh^2(x/5)(20 + 16sinh^2(x/5)))
            // 4 multiplications and 2 additions
            // Estimate the optimum number of times to use the argument reduction.
            k = 1.4 * Math.sqrt(len);
            k = k > 16 ? 16 : k | 0;
            x = x.times(1 / tinyPow(5, k));
            x = taylorSeries(Ctor, 2, x, x, true);
            // Reverse argument reduction
            var sinh2_x, d5 = new Ctor(5), d16 = new Ctor(16), d20 = new Ctor(20);
            for(; k--;){
                sinh2_x = x.times(x);
                x = x.times(d5.plus(sinh2_x.times(d16.times(sinh2_x).plus(d20))));
            }
        }
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return finalise(x, pr, rm, true);
    };
    /*
   * Return a new Decimal whose value is the hyperbolic tangent of the value in radians of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-1, 1]
   *
   * tanh(x) = sinh(x) / cosh(x)
   *
   * tanh(0)         = 0
   * tanh(-0)        = -0
   * tanh(Infinity)  = 1
   * tanh(-Infinity) = -1
   * tanh(NaN)       = NaN
   *
   */ P.hyperbolicTangent = P.tanh = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.isFinite()) return new Ctor(x.s);
        if (x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + 7;
        Ctor.rounding = 1;
        return divide(x.sinh(), x.cosh(), Ctor.precision = pr, Ctor.rounding = rm);
    };
    /*
   * Return a new Decimal whose value is the arccosine (inverse cosine) in radians of the value of
   * this Decimal.
   *
   * Domain: [-1, 1]
   * Range: [0, pi]
   *
   * acos(x) = pi/2 - asin(x)
   *
   * acos(0)       = pi/2
   * acos(-0)      = pi/2
   * acos(1)       = 0
   * acos(-1)      = pi
   * acos(1/2)     = pi/3
   * acos(-1/2)    = 2*pi/3
   * acos(|x| > 1) = NaN
   * acos(NaN)     = NaN
   *
   */ P.inverseCosine = P.acos = function() {
        var halfPi, x = this, Ctor = x.constructor, k = x.abs().cmp(1), pr = Ctor.precision, rm = Ctor.rounding;
        if (k !== -1) return k === 0 ? x.isNeg() ? getPi(Ctor, pr, rm) : new Ctor(0) : new Ctor(NaN);
        if (x.isZero()) return getPi(Ctor, pr + 4, rm).times(0.5);
        // TODO? Special case acos(0.5) = pi/3 and acos(-0.5) = 2*pi/3
        Ctor.precision = pr + 6;
        Ctor.rounding = 1;
        x = x.asin();
        halfPi = getPi(Ctor, pr + 4, rm).times(0.5);
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return halfPi.minus(x);
    };
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic cosine in radians of the
   * value of this Decimal.
   *
   * Domain: [1, Infinity]
   * Range: [0, Infinity]
   *
   * acosh(x) = ln(x + sqrt(x^2 - 1))
   *
   * acosh(x < 1)     = NaN
   * acosh(NaN)       = NaN
   * acosh(Infinity)  = Infinity
   * acosh(-Infinity) = NaN
   * acosh(0)         = NaN
   * acosh(-0)        = NaN
   * acosh(1)         = 0
   * acosh(-1)        = NaN
   *
   */ P.inverseHyperbolicCosine = P.acosh = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (x.lte(1)) return new Ctor(x.eq(1) ? 0 : NaN);
        if (!x.isFinite()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(Math.abs(x.e), x.sd()) + 4;
        Ctor.rounding = 1;
        external = false;
        x = x.times(x).minus(1).sqrt().plus(x);
        external = true;
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.ln();
    };
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic sine in radians of the value
   * of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-Infinity, Infinity]
   *
   * asinh(x) = ln(x + sqrt(x^2 + 1))
   *
   * asinh(NaN)       = NaN
   * asinh(Infinity)  = Infinity
   * asinh(-Infinity) = -Infinity
   * asinh(0)         = 0
   * asinh(-0)        = -0
   *
   */ P.inverseHyperbolicSine = P.asinh = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.isFinite() || x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + 2 * Math.max(Math.abs(x.e), x.sd()) + 6;
        Ctor.rounding = 1;
        external = false;
        x = x.times(x).plus(1).sqrt().plus(x);
        external = true;
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.ln();
    };
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic tangent in radians of the
   * value of this Decimal.
   *
   * Domain: [-1, 1]
   * Range: [-Infinity, Infinity]
   *
   * atanh(x) = 0.5 * ln((1 + x) / (1 - x))
   *
   * atanh(|x| > 1)   = NaN
   * atanh(NaN)       = NaN
   * atanh(Infinity)  = NaN
   * atanh(-Infinity) = NaN
   * atanh(0)         = 0
   * atanh(-0)        = -0
   * atanh(1)         = Infinity
   * atanh(-1)        = -Infinity
   *
   */ P.inverseHyperbolicTangent = P.atanh = function() {
        var pr, rm, wpr, xsd, x = this, Ctor = x.constructor;
        if (!x.isFinite()) return new Ctor(NaN);
        if (x.e >= 0) return new Ctor(x.abs().eq(1) ? x.s / 0 : x.isZero() ? x : NaN);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        xsd = x.sd();
        if (Math.max(xsd, pr) < 2 * -x.e - 1) return finalise(new Ctor(x), pr, rm, true);
        Ctor.precision = wpr = xsd - x.e;
        x = divide(x.plus(1), new Ctor(1).minus(x), wpr + pr, 1);
        Ctor.precision = pr + 4;
        Ctor.rounding = 1;
        x = x.ln();
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.times(0.5);
    };
    /*
   * Return a new Decimal whose value is the arcsine (inverse sine) in radians of the value of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-pi/2, pi/2]
   *
   * asin(x) = 2*atan(x/(1 + sqrt(1 - x^2)))
   *
   * asin(0)       = 0
   * asin(-0)      = -0
   * asin(1/2)     = pi/6
   * asin(-1/2)    = -pi/6
   * asin(1)       = pi/2
   * asin(-1)      = -pi/2
   * asin(|x| > 1) = NaN
   * asin(NaN)     = NaN
   *
   * TODO? Compare performance of Taylor series.
   *
   */ P.inverseSine = P.asin = function() {
        var halfPi, k, pr, rm, x = this, Ctor = x.constructor;
        if (x.isZero()) return new Ctor(x);
        k = x.abs().cmp(1);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        if (k !== -1) {
            // |x| is 1
            if (k === 0) {
                halfPi = getPi(Ctor, pr + 4, rm).times(0.5);
                halfPi.s = x.s;
                return halfPi;
            }
            // |x| > 1 or x is NaN
            return new Ctor(NaN);
        }
        // TODO? Special case asin(1/2) = pi/6 and asin(-1/2) = -pi/6
        Ctor.precision = pr + 6;
        Ctor.rounding = 1;
        x = x.div(new Ctor(1).minus(x.times(x)).sqrt().plus(1)).atan();
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.times(2);
    };
    /*
   * Return a new Decimal whose value is the arctangent (inverse tangent) in radians of the value
   * of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-pi/2, pi/2]
   *
   * atan(x) = x - x^3/3 + x^5/5 - x^7/7 + ...
   *
   * atan(0)         = 0
   * atan(-0)        = -0
   * atan(1)         = pi/4
   * atan(-1)        = -pi/4
   * atan(Infinity)  = pi/2
   * atan(-Infinity) = -pi/2
   * atan(NaN)       = NaN
   *
   */ P.inverseTangent = P.atan = function() {
        var i, j, k, n, px, t, r, wpr, x2, x = this, Ctor = x.constructor, pr = Ctor.precision, rm = Ctor.rounding;
        if (!x.isFinite()) {
            if (!x.s) return new Ctor(NaN);
            if (pr + 4 <= PI_PRECISION) {
                r = getPi(Ctor, pr + 4, rm).times(0.5);
                r.s = x.s;
                return r;
            }
        } else if (x.isZero()) return new Ctor(x);
        else if (x.abs().eq(1) && pr + 4 <= PI_PRECISION) {
            r = getPi(Ctor, pr + 4, rm).times(0.25);
            r.s = x.s;
            return r;
        }
        Ctor.precision = wpr = pr + 10;
        Ctor.rounding = 1;
        // TODO? if (x >= 1 && pr <= PI_PRECISION) atan(x) = halfPi * x.s - atan(1 / x);
        // Argument reduction
        // Ensure |x| < 0.42
        // atan(x) = 2 * atan(x / (1 + sqrt(1 + x^2)))
        k = Math.min(28, wpr / LOG_BASE + 2 | 0);
        for(i = k; i; --i)x = x.div(x.times(x).plus(1).sqrt().plus(1));
        external = false;
        j = Math.ceil(wpr / LOG_BASE);
        n = 1;
        x2 = x.times(x);
        r = new Ctor(x);
        px = x;
        // atan(x) = x - x^3/3 + x^5/5 - x^7/7 + ...
        for(; i !== -1;){
            px = px.times(x2);
            t = r.minus(px.div(n += 2));
            px = px.times(x2);
            r = t.plus(px.div(n += 2));
            if (r.d[j] !== void 0) for(i = j; r.d[i] === t.d[i] && i--;);
        }
        if (k) r = r.times(2 << k - 1);
        external = true;
        return finalise(r, Ctor.precision = pr, Ctor.rounding = rm, true);
    };
    /*
   * Return true if the value of this Decimal is a finite number, otherwise return false.
   *
   */ P.isFinite = function() {
        return !!this.d;
    };
    /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */ P.isInteger = P.isInt = function() {
        return !!this.d && mathfloor(this.e / LOG_BASE) > this.d.length - 2;
    };
    /*
   * Return true if the value of this Decimal is NaN, otherwise return false.
   *
   */ P.isNaN = function() {
        return !this.s;
    };
    /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */ P.isNegative = P.isNeg = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */ P.isPositive = P.isPos = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this Decimal is 0 or -0, otherwise return false.
   *
   */ P.isZero = function() {
        return !!this.d && this.d[0] === 0;
    };
    /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */ P.lessThan = P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */ P.lessThanOrEqualTo = P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return the logarithm of the value of this Decimal to the specified base, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * If no base is specified, return log[10](arg).
   *
   * log[base](arg) = ln(arg) / ln(base)
   *
   * The result will always be correctly rounded if the base of the log is 10, and 'almost always'
   * otherwise:
   *
   * Depending on the rounding mode, the result may be incorrectly rounded if the first fifteen
   * rounding digits are [49]99999999999999 or [50]00000000000000. In that case, the maximum error
   * between the result and the correctly rounded result will be one ulp (unit in the last place).
   *
   * log[-b](a)       = NaN
   * log[0](a)        = NaN
   * log[1](a)        = NaN
   * log[NaN](a)      = NaN
   * log[Infinity](a) = NaN
   * log[b](0)        = -Infinity
   * log[b](-0)       = -Infinity
   * log[b](-a)       = NaN
   * log[b](1)        = 0
   * log[b](Infinity) = Infinity
   * log[b](NaN)      = NaN
   *
   * [base] {number|string|Decimal} The base of the logarithm.
   *
   */ P.logarithm = P.log = function(base) {
        var isBase10, d, denominator, k, inf, num, sd, r, arg = this, Ctor = arg.constructor, pr = Ctor.precision, rm = Ctor.rounding, guard = 5;
        // Default base is 10.
        if (base == null) {
            base = new Ctor(10);
            isBase10 = true;
        } else {
            base = new Ctor(base);
            d = base.d;
            // Return NaN if base is negative, or non-finite, or is 0 or 1.
            if (base.s < 0 || !d || !d[0] || base.eq(1)) return new Ctor(NaN);
            isBase10 = base.eq(10);
        }
        d = arg.d;
        // Is arg negative, non-finite, 0 or 1?
        if (arg.s < 0 || !d || !d[0] || arg.eq(1)) return new Ctor(d && !d[0] ? -1 / 0 : arg.s != 1 ? NaN : d ? 0 : 1 / 0);
        // The result will have a non-terminating decimal expansion if base is 10 and arg is not an
        // integer power of 10.
        if (isBase10) {
            if (d.length > 1) inf = true;
            else {
                for(k = d[0]; k % 10 === 0;)k /= 10;
                inf = k !== 1;
            }
        }
        external = false;
        sd = pr + guard;
        num = naturalLogarithm(arg, sd);
        denominator = isBase10 ? getLn10(Ctor, sd + 10) : naturalLogarithm(base, sd);
        // The result will have 5 rounding digits.
        r = divide(num, denominator, sd, 1);
        // If at a rounding boundary, i.e. the result's rounding digits are [49]9999 or [50]0000,
        // calculate 10 further digits.
        //
        // If the result is known to have an infinite decimal expansion, repeat this until it is clear
        // that the result is above or below the boundary. Otherwise, if after calculating the 10
        // further digits, the last 14 are nines, round up and assume the result is exact.
        // Also assume the result is exact if the last 14 are zero.
        //
        // Example of a result that will be incorrectly rounded:
        // log[1048576](4503599627370502) = 2.60000000000000009610279511444746...
        // The above result correctly rounded using ROUND_CEIL to 1 decimal place should be 2.7, but it
        // will be given as 2.6 as there are 15 zeros immediately after the requested decimal place, so
        // the exact result would be assumed to be 2.6, which rounded using ROUND_CEIL to 1 decimal
        // place is still 2.6.
        if (checkRoundingDigits(r.d, k = pr, rm)) do {
            sd += 10;
            num = naturalLogarithm(arg, sd);
            denominator = isBase10 ? getLn10(Ctor, sd + 10) : naturalLogarithm(base, sd);
            r = divide(num, denominator, sd, 1);
            if (!inf) {
                // Check for 14 nines from the 2nd rounding digit, as the first may be 4.
                if (+digitsToString(r.d).slice(k + 1, k + 15) + 1 == 1e14) r = finalise(r, pr + 1, 0);
                break;
            }
        }while (checkRoundingDigits(r.d, k += 10, rm));
        external = true;
        return finalise(r, pr, rm);
    };
    /*
   * Return a new Decimal whose value is the maximum of the arguments and the value of this Decimal.
   *
   * arguments {number|string|Decimal}
   *
  P.max = function () {
    Array.prototype.push.call(arguments, this);
    return maxOrMin(this.constructor, arguments, 'lt');
  };
   */ /*
   * Return a new Decimal whose value is the minimum of the arguments and the value of this Decimal.
   *
   * arguments {number|string|Decimal}
   *
  P.min = function () {
    Array.prototype.push.call(arguments, this);
    return maxOrMin(this.constructor, arguments, 'gt');
  };
   */ /*
   *  n - 0 = n
   *  n - N = N
   *  n - I = -I
   *  0 - n = -n
   *  0 - 0 = 0
   *  0 - N = N
   *  0 - I = -I
   *  N - n = N
   *  N - 0 = N
   *  N - N = N
   *  N - I = N
   *  I - n = I
   *  I - 0 = I
   *  I - N = N
   *  I - I = N
   *
   * Return a new Decimal whose value is the value of this Decimal minus `y`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   */ P.minus = P.sub = function(y) {
        var d, e, i, j, k, len, pr, rm, xd, xe, xLTy, yd, x = this, Ctor = x.constructor;
        y = new Ctor(y);
        // If either is not finite...
        if (!x.d || !y.d) {
            // Return NaN if either is NaN.
            if (!x.s || !y.s) y = new Ctor(NaN);
            else if (x.d) y.s = -y.s;
            else y = new Ctor(y.d || x.s !== y.s ? x : NaN);
            return y;
        }
        // If signs differ...
        if (x.s != y.s) {
            y.s = -y.s;
            return x.plus(y);
        }
        xd = x.d;
        yd = y.d;
        pr = Ctor.precision;
        rm = Ctor.rounding;
        // If either is zero...
        if (!xd[0] || !yd[0]) {
            // Return y negated if x is zero and y is non-zero.
            if (yd[0]) y.s = -y.s;
            else if (xd[0]) y = new Ctor(x);
            else return new Ctor(rm === 3 ? -0 : 0);
            return external ? finalise(y, pr, rm) : y;
        }
        // x and y are finite, non-zero numbers with the same sign.
        // Calculate base 1e7 exponents.
        e = mathfloor(y.e / LOG_BASE);
        xe = mathfloor(x.e / LOG_BASE);
        xd = xd.slice();
        k = xe - e;
        // If base 1e7 exponents differ...
        if (k) {
            xLTy = k < 0;
            if (xLTy) {
                d = xd;
                k = -k;
                len = yd.length;
            } else {
                d = yd;
                e = xe;
                len = xd.length;
            }
            // Numbers with massively different exponents would result in a very high number of
            // zeros needing to be prepended, but this can be avoided while still ensuring correct
            // rounding by limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
            i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
            if (k > i) {
                k = i;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents.
            d.reverse();
            for(i = k; i--;)d.push(0);
            d.reverse();
        // Base 1e7 exponents equal.
        } else {
            // Check digits to determine which is the bigger number.
            i = xd.length;
            len = yd.length;
            xLTy = i < len;
            if (xLTy) len = i;
            for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
                xLTy = xd[i] < yd[i];
                break;
            }
            k = 0;
        }
        if (xLTy) {
            d = xd;
            xd = yd;
            yd = d;
            y.s = -y.s;
        }
        len = xd.length;
        // Append zeros to `xd` if shorter.
        // Don't add zeros to `yd` if shorter as subtraction only needs to start at `yd` length.
        for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
        // Subtract yd from xd.
        for(i = yd.length; i > k;){
            if (xd[--i] < yd[i]) {
                for(j = i; j && xd[--j] === 0;)xd[j] = BASE - 1;
                --xd[j];
                xd[i] += BASE;
            }
            xd[i] -= yd[i];
        }
        // Remove trailing zeros.
        for(; xd[--len] === 0;)xd.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xd[0] === 0; xd.shift())--e;
        // Zero?
        if (!xd[0]) return new Ctor(rm === 3 ? -0 : 0);
        y.d = xd;
        y.e = getBase10Exponent(xd, e);
        return external ? finalise(y, pr, rm) : y;
    };
    /*
   *   n % 0 =  N
   *   n % N =  N
   *   n % I =  n
   *   0 % n =  0
   *  -0 % n = -0
   *   0 % 0 =  N
   *   0 % N =  N
   *   0 % I =  0
   *   N % n =  N
   *   N % 0 =  N
   *   N % N =  N
   *   N % I =  N
   *   I % n =  N
   *   I % 0 =  N
   *   I % N =  N
   *   I % I =  N
   *
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * The result depends on the modulo mode.
   *
   */ P.modulo = P.mod = function(y) {
        var q, x = this, Ctor = x.constructor;
        y = new Ctor(y);
        // Return NaN if x is ±Infinity or NaN, or y is NaN or ±0.
        if (!x.d || !y.s || y.d && !y.d[0]) return new Ctor(NaN);
        // Return x if y is ±Infinity or x is ±0.
        if (!y.d || x.d && !x.d[0]) return finalise(new Ctor(x), Ctor.precision, Ctor.rounding);
        // Prevent rounding of intermediate calculations.
        external = false;
        if (Ctor.modulo == 9) {
            // Euclidian division: q = sign(y) * floor(x / abs(y))
            // result = x - q * y    where  0 <= result < abs(y)
            q = divide(x, y.abs(), 0, 3, 1);
            q.s *= y.s;
        } else q = divide(x, y, 0, Ctor.modulo, 1);
        q = q.times(y);
        external = true;
        return x.minus(q);
    };
    /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   */ P.naturalExponential = P.exp = function() {
        return naturalExponential(this);
    };
    /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * rounded to `precision` significant digits using rounding mode `rounding`.
   *
   */ P.naturalLogarithm = P.ln = function() {
        return naturalLogarithm(this);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */ P.negated = P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s;
        return finalise(x);
    };
    /*
   *  n + 0 = n
   *  n + N = N
   *  n + I = I
   *  0 + n = n
   *  0 + 0 = 0
   *  0 + N = N
   *  0 + I = I
   *  N + n = N
   *  N + 0 = N
   *  N + N = N
   *  N + I = N
   *  I + n = I
   *  I + 0 = I
   *  I + N = N
   *  I + I = I
   *
   * Return a new Decimal whose value is the value of this Decimal plus `y`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   */ P.plus = P.add = function(y) {
        var carry, d, e, i, k, len, pr, rm, xd, yd, x = this, Ctor = x.constructor;
        y = new Ctor(y);
        // If either is not finite...
        if (!x.d || !y.d) {
            // Return NaN if either is NaN.
            if (!x.s || !y.s) y = new Ctor(NaN);
            else if (!x.d) y = new Ctor(y.d || x.s === y.s ? x : NaN);
            return y;
        }
        // If signs differ...
        if (x.s != y.s) {
            y.s = -y.s;
            return x.minus(y);
        }
        xd = x.d;
        yd = y.d;
        pr = Ctor.precision;
        rm = Ctor.rounding;
        // If either is zero...
        if (!xd[0] || !yd[0]) {
            // Return x if y is zero.
            // Return y if y is non-zero.
            if (!yd[0]) y = new Ctor(x);
            return external ? finalise(y, pr, rm) : y;
        }
        // x and y are finite, non-zero numbers with the same sign.
        // Calculate base 1e7 exponents.
        k = mathfloor(x.e / LOG_BASE);
        e = mathfloor(y.e / LOG_BASE);
        xd = xd.slice();
        i = k - e;
        // If base 1e7 exponents differ...
        if (i) {
            if (i < 0) {
                d = xd;
                i = -i;
                len = yd.length;
            } else {
                d = yd;
                e = k;
                len = xd.length;
            }
            // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
            k = Math.ceil(pr / LOG_BASE);
            len = k > len ? k + 1 : len + 1;
            if (i > len) {
                i = len;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
            d.reverse();
            for(; i--;)d.push(0);
            d.reverse();
        }
        len = xd.length;
        i = yd.length;
        // If yd is longer than xd, swap xd and yd so xd points to the longer array.
        if (len - i < 0) {
            i = len;
            d = yd;
            yd = xd;
            xd = d;
        }
        // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
        for(carry = 0; i;){
            carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
            xd[i] %= BASE;
        }
        if (carry) {
            xd.unshift(carry);
            ++e;
        }
        // Remove trailing zeros.
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        for(len = xd.length; xd[--len] == 0;)xd.pop();
        y.d = xd;
        y.e = getBase10Exponent(xd, e);
        return external ? finalise(y, pr, rm) : y;
    };
    /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */ P.precision = P.sd = function(z) {
        var k, x = this;
        if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
        if (x.d) {
            k = getPrecision(x.d);
            if (z && x.e + 1 > k) k = x.e + 1;
        } else k = NaN;
        return k;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */ P.round = function() {
        var x = this, Ctor = x.constructor;
        return finalise(new Ctor(x), x.e + 1, Ctor.rounding);
    };
    /*
   * Return a new Decimal whose value is the sine of the value in radians of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-1, 1]
   *
   * sin(x) = x - x^3/3! + x^5/5! - ...
   *
   * sin(0)         = 0
   * sin(-0)        = -0
   * sin(Infinity)  = NaN
   * sin(-Infinity) = NaN
   * sin(NaN)       = NaN
   *
   */ P.sine = P.sin = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.isFinite()) return new Ctor(NaN);
        if (x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(x.e, x.sd()) + LOG_BASE;
        Ctor.rounding = 1;
        x = sine(Ctor, toLessThanHalfPi(Ctor, x));
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return finalise(quadrant > 2 ? x.neg() : x, pr, rm, true);
    };
    /*
   * Return a new Decimal whose value is the square root of this Decimal, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   *  sqrt(-n) =  N
   *  sqrt(N)  =  N
   *  sqrt(-I) =  N
   *  sqrt(I)  =  I
   *  sqrt(0)  =  0
   *  sqrt(-0) = -0
   *
   */ P.squareRoot = P.sqrt = function() {
        var m, n, sd, r, rep, t, x = this, d = x.d, e = x.e, s = x.s, Ctor = x.constructor;
        // Negative/NaN/Infinity/zero?
        if (s !== 1 || !d || !d[0]) return new Ctor(!s || s < 0 && (!d || d[0]) ? NaN : d ? x : 1 / 0);
        external = false;
        // Initial estimate.
        s = Math.sqrt(+x);
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = digitsToString(d);
            if ((n.length + e) % 2 == 0) n += "0";
            s = Math.sqrt(n);
            e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = "5e" + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf("e") + 1) + e;
            }
            r = new Ctor(n);
        } else r = new Ctor(s.toString());
        sd = (e = Ctor.precision) + 3;
        // Newton-Raphson iteration.
        for(;;){
            t = r;
            r = t.plus(divide(x, t, sd + 2, 1)).times(0.5);
            // TODO? Replace with for-loop and checkRoundingDigits.
            if (digitsToString(t.d).slice(0, sd) === (n = digitsToString(r.d)).slice(0, sd)) {
                n = n.slice(sd - 3, sd + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
                // 4999, i.e. approaching a rounding boundary, continue the iteration.
                if (n == "9999" || !rep && n == "4999") {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    if (!rep) {
                        finalise(t, e + 1, 0);
                        if (t.times(t).eq(x)) {
                            r = t;
                            break;
                        }
                    }
                    sd += 4;
                    rep = 1;
                } else {
                    // If the rounding digits are null, 0{0,4} or 50{0,3}, check for an exact result.
                    // If not, then there are further digits and m will be truthy.
                    if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
                        // Truncate to the first rounding digit.
                        finalise(r, e + 1, 1);
                        m = !r.times(r).eq(x);
                    }
                    break;
                }
            }
        }
        external = true;
        return finalise(r, e, Ctor.rounding, m);
    };
    /*
   * Return a new Decimal whose value is the tangent of the value in radians of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-Infinity, Infinity]
   *
   * tan(0)         = 0
   * tan(-0)        = -0
   * tan(Infinity)  = NaN
   * tan(-Infinity) = NaN
   * tan(NaN)       = NaN
   *
   */ P.tangent = P.tan = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.isFinite()) return new Ctor(NaN);
        if (x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + 10;
        Ctor.rounding = 1;
        x = x.sin();
        x.s = 1;
        x = divide(x, new Ctor(1).minus(x.times(x)).sqrt(), pr + 10, 0);
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return finalise(quadrant == 2 || quadrant == 4 ? x.neg() : x, pr, rm, true);
    };
    /*
   *  n * 0 = 0
   *  n * N = N
   *  n * I = I
   *  0 * n = 0
   *  0 * 0 = 0
   *  0 * N = N
   *  0 * I = N
   *  N * n = N
   *  N * 0 = N
   *  N * N = N
   *  N * I = N
   *  I * n = I
   *  I * 0 = N
   *  I * N = N
   *  I * I = I
   *
   * Return a new Decimal whose value is this Decimal times `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   */ P.times = P.mul = function(y) {
        var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
        y.s *= x.s;
        // If either is NaN, ±Infinity or ±0...
        if (!xd || !xd[0] || !yd || !yd[0]) return new Ctor(!y.s || xd && !xd[0] && !yd || yd && !yd[0] && !xd ? NaN : !xd || !yd ? y.s / 0 : y.s * 0);
        e = mathfloor(x.e / LOG_BASE) + mathfloor(y.e / LOG_BASE);
        xdL = xd.length;
        ydL = yd.length;
        // Ensure xd points to the longer array.
        if (xdL < ydL) {
            r = xd;
            xd = yd;
            yd = r;
            rL = xdL;
            xdL = ydL;
            ydL = rL;
        }
        // Initialise the result array with zeros.
        r = [];
        rL = xdL + ydL;
        for(i = rL; i--;)r.push(0);
        // Multiply!
        for(i = ydL; --i >= 0;){
            carry = 0;
            for(k = xdL + i; k > i;){
                t = r[k] + yd[i] * xd[k - i - 1] + carry;
                r[k--] = t % BASE | 0;
                carry = t / BASE | 0;
            }
            r[k] = (r[k] + carry) % BASE | 0;
        }
        // Remove trailing zeros.
        for(; !r[--rL];)r.pop();
        if (carry) ++e;
        else r.shift();
        y.d = r;
        y.e = getBase10Exponent(r, e);
        return external ? finalise(y, Ctor.precision, Ctor.rounding) : y;
    };
    /*
   * Return a string representing the value of this Decimal in base 2, round to `sd` significant
   * digits using rounding mode `rm`.
   *
   * If the optional `sd` argument is present then return binary exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toBinary = function(sd, rm) {
        return toStringBinary(this, 2, sd, rm);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toDecimalPlaces = P.toDP = function(dp, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (dp === void 0) return x;
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        return finalise(x, dp + x.e + 1, rm);
    };
    /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toExponential = function(dp, rm) {
        var str, x = this, Ctor = x.constructor;
        if (dp === void 0) str = finiteToString(x, true);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = finalise(new Ctor(x), dp + 1, rm);
            str = finiteToString(x, true, dp + 1);
        }
        return x.isNeg() && !x.isZero() ? "-" + str : str;
    };
    /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */ P.toFixed = function(dp, rm) {
        var str, y, x = this, Ctor = x.constructor;
        if (dp === void 0) str = finiteToString(x);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            y = finalise(new Ctor(x), dp + x.e + 1, rm);
            str = finiteToString(y, false, dp + y.e + 1);
        }
        // To determine whether to add the minus sign look at the value before it was rounded,
        // i.e. look at `x` rather than `y`.
        return x.isNeg() && !x.isZero() ? "-" + str : str;
    };
    /*
   * Return an array representing the value of this Decimal as a simple fraction with an integer
   * numerator and an integer denominator.
   *
   * The denominator will be a positive non-zero value less than or equal to the specified maximum
   * denominator. If a maximum denominator is not specified, the denominator will be the lowest
   * value necessary to represent the number exactly.
   *
   * [maxD] {number|string|Decimal} Maximum denominator. Integer >= 1 and < Infinity.
   *
   */ P.toFraction = function(maxD) {
        var d, d0, d1, d2, e, k, n, n0, n1, pr, q, r, x = this, xd = x.d, Ctor = x.constructor;
        if (!xd) return new Ctor(x);
        n1 = d0 = new Ctor(1);
        d1 = n0 = new Ctor(0);
        d = new Ctor(d1);
        e = d.e = getPrecision(xd) - x.e - 1;
        k = e % LOG_BASE;
        d.d[0] = mathpow(10, k < 0 ? LOG_BASE + k : k);
        if (maxD == null) // d is 10**e, the minimum max-denominator needed.
        maxD = e > 0 ? d : n1;
        else {
            n = new Ctor(maxD);
            if (!n.isInt() || n.lt(n1)) throw Error(invalidArgument + n);
            maxD = n.gt(d) ? e > 0 ? d : n1 : n;
        }
        external = false;
        n = new Ctor(digitsToString(xd));
        pr = Ctor.precision;
        Ctor.precision = e = xd.length * LOG_BASE * 2;
        for(;;){
            q = divide(n, d, 0, 1, 1);
            d2 = d0.plus(q.times(d1));
            if (d2.cmp(maxD) == 1) break;
            d0 = d1;
            d1 = d2;
            d2 = n1;
            n1 = n0.plus(q.times(d2));
            n0 = d2;
            d2 = d;
            d = n.minus(q.times(d2));
            n = d2;
        }
        d2 = divide(maxD.minus(d0), d1, 0, 1, 1);
        n0 = n0.plus(d2.times(n1));
        d0 = d0.plus(d2.times(d1));
        n0.s = n1.s = x.s;
        // Determine which fraction is closer to x, n0/d0 or n1/d1?
        r = divide(n1, d1, e, 1).minus(x).abs().cmp(divide(n0, d0, e, 1).minus(x).abs()) < 1 ? [
            n1,
            d1
        ] : [
            n0,
            d0
        ];
        Ctor.precision = pr;
        external = true;
        return r;
    };
    /*
   * Return a string representing the value of this Decimal in base 16, round to `sd` significant
   * digits using rounding mode `rm`.
   *
   * If the optional `sd` argument is present then return binary exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toHexadecimal = P.toHex = function(sd, rm) {
        return toStringBinary(this, 16, sd, rm);
    };
    /*
   * Returns a new Decimal whose value is the nearest multiple of `y` in the direction of rounding
   * mode `rm`, or `Decimal.rounding` if `rm` is omitted, to the value of this Decimal.
   *
   * The return value will always have the same sign as this Decimal, unless either this Decimal
   * or `y` is NaN, in which case the return value will be also be NaN.
   *
   * The return value is not affected by the value of `precision`.
   *
   * y {number|string|Decimal} The magnitude to round to a multiple of.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * 'toNearest() rounding mode not an integer: {rm}'
   * 'toNearest() rounding mode out of range: {rm}'
   *
   */ P.toNearest = function(y, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (y == null) {
            // If x is not finite, return x.
            if (!x.d) return x;
            y = new Ctor(1);
            rm = Ctor.rounding;
        } else {
            y = new Ctor(y);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            // If x is not finite, return x if y is not NaN, else NaN.
            if (!x.d) return y.s ? x : y;
            // If y is not finite, return Infinity with the sign of x if y is Infinity, else NaN.
            if (!y.d) {
                if (y.s) y.s = x.s;
                return y;
            }
        }
        // If y is not zero, calculate the nearest multiple of y to x.
        if (y.d[0]) {
            external = false;
            x = divide(x, y, 0, rm, 1).times(y);
            external = true;
            finalise(x);
        // If y is zero, return zero with the sign of x.
        } else {
            y.s = x.s;
            x = y;
        }
        return x;
    };
    /*
   * Return the value of this Decimal converted to a number primitive.
   * Zero keeps its sign.
   *
   */ P.toNumber = function() {
        return +this;
    };
    /*
   * Return a string representing the value of this Decimal in base 8, round to `sd` significant
   * digits using rounding mode `rm`.
   *
   * If the optional `sd` argument is present then return binary exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toOctal = function(sd, rm) {
        return toStringBinary(this, 8, sd, rm);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`, rounded
   * to `precision` significant digits using rounding mode `rounding`.
   *
   * ECMAScript compliant.
   *
   *   pow(x, NaN)                           = NaN
   *   pow(x, ±0)                            = 1

   *   pow(NaN, non-zero)                    = NaN
   *   pow(abs(x) > 1, +Infinity)            = +Infinity
   *   pow(abs(x) > 1, -Infinity)            = +0
   *   pow(abs(x) == 1, ±Infinity)           = NaN
   *   pow(abs(x) < 1, +Infinity)            = +0
   *   pow(abs(x) < 1, -Infinity)            = +Infinity
   *   pow(+Infinity, y > 0)                 = +Infinity
   *   pow(+Infinity, y < 0)                 = +0
   *   pow(-Infinity, odd integer > 0)       = -Infinity
   *   pow(-Infinity, even integer > 0)      = +Infinity
   *   pow(-Infinity, odd integer < 0)       = -0
   *   pow(-Infinity, even integer < 0)      = +0
   *   pow(+0, y > 0)                        = +0
   *   pow(+0, y < 0)                        = +Infinity
   *   pow(-0, odd integer > 0)              = -0
   *   pow(-0, even integer > 0)             = +0
   *   pow(-0, odd integer < 0)              = -Infinity
   *   pow(-0, even integer < 0)             = +Infinity
   *   pow(finite x < 0, finite non-integer) = NaN
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * Assuming the first 15 rounding digits are each equally likely to be any digit 0-9, the
   * probability of an incorrectly rounded result
   * P([49]9{14} | [50]0{14}) = 2 * 0.2 * 10^-14 = 4e-15 = 1/2.5e+14
   * i.e. 1 in 250,000,000,000,000
   *
   * If a result is incorrectly rounded the maximum error will be 1 ulp (unit in last place).
   *
   * y {number|string|Decimal} The power to which to raise this Decimal.
   *
   */ P.toPower = P.pow = function(y) {
        var e, k, pr, r, rm, s, x = this, Ctor = x.constructor, yn = +(y = new Ctor(y));
        // Either ±Infinity, NaN or ±0?
        if (!x.d || !y.d || !x.d[0] || !y.d[0]) return new Ctor(mathpow(+x, yn));
        x = new Ctor(x);
        if (x.eq(1)) return x;
        pr = Ctor.precision;
        rm = Ctor.rounding;
        if (y.eq(1)) return finalise(x, pr, rm);
        // y exponent
        e = mathfloor(y.e / LOG_BASE);
        // If y is a small integer use the 'exponentiation by squaring' algorithm.
        if (e >= y.d.length - 1 && (k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
            r = intPow(Ctor, x, k, pr);
            return y.s < 0 ? new Ctor(1).div(r) : finalise(r, pr, rm);
        }
        s = x.s;
        // if x is negative
        if (s < 0) {
            // if y is not an integer
            if (e < y.d.length - 1) return new Ctor(NaN);
            // Result is positive if x is negative and the last digit of integer y is even.
            if ((y.d[e] & 1) == 0) s = 1;
            // if x.eq(-1)
            if (x.e == 0 && x.d[0] == 1 && x.d.length == 1) {
                x.s = s;
                return x;
            }
        }
        // Estimate result exponent.
        // x^y = 10^e,  where e = y * log10(x)
        // log10(x) = log10(x_significand) + x_exponent
        // log10(x_significand) = ln(x_significand) / ln(10)
        k = mathpow(+x, yn);
        e = k == 0 || !isFinite(k) ? mathfloor(yn * (Math.log("0." + digitsToString(x.d)) / Math.LN10 + x.e + 1)) : new Ctor(k + "").e;
        // Exponent estimate may be incorrect e.g. x: 0.999999999999999999, y: 2.29, e: 0, r.e: -1.
        // Overflow/underflow?
        if (e > Ctor.maxE + 1 || e < Ctor.minE - 1) return new Ctor(e > 0 ? s / 0 : 0);
        external = false;
        Ctor.rounding = x.s = 1;
        // Estimate the extra guard digits needed to ensure five correct rounding digits from
        // naturalLogarithm(x). Example of failure without these extra digits (precision: 10):
        // new Decimal(2.32456).pow('2087987436534566.46411')
        // should be 1.162377823e+764914905173815, but is 1.162355823e+764914905173815
        k = Math.min(12, (e + "").length);
        // r = x^y = exp(y*ln(x))
        r = naturalExponential(y.times(naturalLogarithm(x, pr + k)), pr);
        // r may be Infinity, e.g. (0.9999999999999999).pow(-1e+40)
        if (r.d) {
            // Truncate to the required precision plus five rounding digits.
            r = finalise(r, pr + 5, 1);
            // If the rounding digits are [49]9999 or [50]0000 increase the precision by 10 and recalculate
            // the result.
            if (checkRoundingDigits(r.d, pr, rm)) {
                e = pr + 10;
                // Truncate to the increased precision plus five rounding digits.
                r = finalise(naturalExponential(y.times(naturalLogarithm(x, e + k)), e), e + 5, 1);
                // Check for 14 nines from the 2nd rounding digit (the first rounding digit may be 4 or 9).
                if (+digitsToString(r.d).slice(pr + 1, pr + 15) + 1 == 1e14) r = finalise(r, pr + 1, 0);
            }
        }
        r.s = s;
        external = true;
        Ctor.rounding = rm;
        return finalise(r, pr, rm);
    };
    /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toPrecision = function(sd, rm) {
        var str, x = this, Ctor = x.constructor;
        if (sd === void 0) str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
        else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = finalise(new Ctor(x), sd, rm);
            str = finiteToString(x, sd <= x.e || x.e <= Ctor.toExpNeg, sd);
        }
        return x.isNeg() && !x.isZero() ? "-" + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * 'toSD() digits out of range: {sd}'
   * 'toSD() digits not an integer: {sd}'
   * 'toSD() rounding mode not an integer: {rm}'
   * 'toSD() rounding mode out of range: {rm}'
   *
   */ P.toSignificantDigits = P.toSD = function(sd, rm) {
        var x = this, Ctor = x.constructor;
        if (sd === void 0) {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        }
        return finalise(new Ctor(x), sd, rm);
    };
    /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */ P.toString = function() {
        var x = this, Ctor = x.constructor, str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
        return x.isNeg() && !x.isZero() ? "-" + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal truncated to a whole number.
   *
   */ P.truncated = P.trunc = function() {
        return finalise(new this.constructor(this), this.e + 1, 1);
    };
    /*
   * Return a string representing the value of this Decimal.
   * Unlike `toString`, negative zero will include the minus sign.
   *
   */ P.valueOf = P.toJSON = function() {
        var x = this, Ctor = x.constructor, str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
        return x.isNeg() ? "-" + str : str;
    };
    // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
    /*
   *  digitsToString           P.cubeRoot, P.logarithm, P.squareRoot, P.toFraction, P.toPower,
   *                           finiteToString, naturalExponential, naturalLogarithm
   *  checkInt32               P.toDecimalPlaces, P.toExponential, P.toFixed, P.toNearest,
   *                           P.toPrecision, P.toSignificantDigits, toStringBinary, random
   *  checkRoundingDigits      P.logarithm, P.toPower, naturalExponential, naturalLogarithm
   *  convertBase              toStringBinary, parseOther
   *  cos                      P.cos
   *  divide                   P.atanh, P.cubeRoot, P.dividedBy, P.dividedToIntegerBy,
   *                           P.logarithm, P.modulo, P.squareRoot, P.tan, P.tanh, P.toFraction,
   *                           P.toNearest, toStringBinary, naturalExponential, naturalLogarithm,
   *                           taylorSeries, atan2, parseOther
   *  finalise                 P.absoluteValue, P.atan, P.atanh, P.ceil, P.cos, P.cosh,
   *                           P.cubeRoot, P.dividedToIntegerBy, P.floor, P.logarithm, P.minus,
   *                           P.modulo, P.negated, P.plus, P.round, P.sin, P.sinh, P.squareRoot,
   *                           P.tan, P.times, P.toDecimalPlaces, P.toExponential, P.toFixed,
   *                           P.toNearest, P.toPower, P.toPrecision, P.toSignificantDigits,
   *                           P.truncated, divide, getLn10, getPi, naturalExponential,
   *                           naturalLogarithm, ceil, floor, round, trunc
   *  finiteToString           P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf,
   *                           toStringBinary
   *  getBase10Exponent        P.minus, P.plus, P.times, parseOther
   *  getLn10                  P.logarithm, naturalLogarithm
   *  getPi                    P.acos, P.asin, P.atan, toLessThanHalfPi, atan2
   *  getPrecision             P.precision, P.toFraction
   *  getZeroString            digitsToString, finiteToString
   *  intPow                   P.toPower, parseOther
   *  isOdd                    toLessThanHalfPi
   *  maxOrMin                 max, min
   *  naturalExponential       P.naturalExponential, P.toPower
   *  naturalLogarithm         P.acosh, P.asinh, P.atanh, P.logarithm, P.naturalLogarithm,
   *                           P.toPower, naturalExponential
   *  nonFiniteToString        finiteToString, toStringBinary
   *  parseDecimal             Decimal
   *  parseOther               Decimal
   *  sin                      P.sin
   *  taylorSeries             P.cosh, P.sinh, cos, sin
   *  toLessThanHalfPi         P.cos, P.sin
   *  toStringBinary           P.toBinary, P.toHexadecimal, P.toOctal
   *  truncate                 intPow
   *
   *  Throws:                  P.logarithm, P.precision, P.toFraction, checkInt32, getLn10, getPi,
   *                           naturalLogarithm, config, parseOther, random, Decimal
   */ function digitsToString(d) {
        var i, k, ws, indexOfLastWord = d.length - 1, str = "", w = d[0];
        if (indexOfLastWord > 0) {
            str += w;
            for(i = 1; i < indexOfLastWord; i++){
                ws = d[i] + "";
                k = LOG_BASE - ws.length;
                if (k) str += getZeroString(k);
                str += ws;
            }
            w = d[i];
            ws = w + "";
            k = LOG_BASE - ws.length;
            if (k) str += getZeroString(k);
        } else if (w === 0) return "0";
        // Remove trailing zeros of last w.
        for(; w % 10 === 0;)w /= 10;
        return str + w;
    }
    function checkInt32(i, min, max) {
        if (i !== ~~i || i < min || i > max) throw Error(invalidArgument + i);
    }
    /*
   * Check 5 rounding digits if `repeating` is null, 4 otherwise.
   * `repeating == null` if caller is `log` or `pow`,
   * `repeating != null` if caller is `naturalLogarithm` or `naturalExponential`.
   */ function checkRoundingDigits(d, i, rm, repeating) {
        var di, k, r, rd;
        // Get the length of the first word of the array d.
        for(k = d[0]; k >= 10; k /= 10)--i;
        // Is the rounding digit in the first word of d?
        if (--i < 0) {
            i += LOG_BASE;
            di = 0;
        } else {
            di = Math.ceil((i + 1) / LOG_BASE);
            i %= LOG_BASE;
        }
        // i is the index (0 - 6) of the rounding digit.
        // E.g. if within the word 3487563 the first rounding digit is 5,
        // then i = 4, k = 1000, rd = 3487563 % 1000 = 563
        k = mathpow(10, LOG_BASE - i);
        rd = d[di] % k | 0;
        if (repeating == null) {
            if (i < 3) {
                if (i == 0) rd = rd / 100 | 0;
                else if (i == 1) rd = rd / 10 | 0;
                r = rm < 4 && rd == 99999 || rm > 3 && rd == 49999 || rd == 50000 || rd == 0;
            } else r = (rm < 4 && rd + 1 == k || rm > 3 && rd + 1 == k / 2) && (d[di + 1] / k / 100 | 0) == mathpow(10, i - 2) - 1 || (rd == k / 2 || rd == 0) && (d[di + 1] / k / 100 | 0) == 0;
        } else if (i < 4) {
            if (i == 0) rd = rd / 1000 | 0;
            else if (i == 1) rd = rd / 100 | 0;
            else if (i == 2) rd = rd / 10 | 0;
            r = (repeating || rm < 4) && rd == 9999 || !repeating && rm > 3 && rd == 4999;
        } else r = ((repeating || rm < 4) && rd + 1 == k || !repeating && rm > 3 && rd + 1 == k / 2) && (d[di + 1] / k / 1000 | 0) == mathpow(10, i - 3) - 1;
        return r;
    }
    // Convert string of `baseIn` to an array of numbers of `baseOut`.
    // Eg. convertBase('255', 10, 16) returns [15, 15].
    // Eg. convertBase('ff', 16, 10) returns [2, 5, 5].
    function convertBase(str, baseIn, baseOut) {
        var j, arr = [
            0
        ], arrL, i = 0, strL = str.length;
        for(; i < strL;){
            for(arrL = arr.length; arrL--;)arr[arrL] *= baseIn;
            arr[0] += NUMERALS.indexOf(str.charAt(i++));
            for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                if (arr[j + 1] === void 0) arr[j + 1] = 0;
                arr[j + 1] += arr[j] / baseOut | 0;
                arr[j] %= baseOut;
            }
        }
        return arr.reverse();
    }
    /*
   * cos(x) = 1 - x^2/2! + x^4/4! - ...
   * |x| < pi/2
   *
   */ function cosine(Ctor, x) {
        var k, len, y;
        if (x.isZero()) return x;
        // Argument reduction: cos(4x) = 8*(cos^4(x) - cos^2(x)) + 1
        // i.e. cos(x) = 8*(cos^4(x/4) - cos^2(x/4)) + 1
        // Estimate the optimum number of times to use the argument reduction.
        len = x.d.length;
        if (len < 32) {
            k = Math.ceil(len / 3);
            y = (1 / tinyPow(4, k)).toString();
        } else {
            k = 16;
            y = "2.3283064365386962890625e-10";
        }
        Ctor.precision += k;
        x = taylorSeries(Ctor, 1, x.times(y), new Ctor(1));
        // Reverse argument reduction
        for(var i = k; i--;){
            var cos2x = x.times(x);
            x = cos2x.times(cos2x).minus(cos2x).times(8).plus(1);
        }
        Ctor.precision -= k;
        return x;
    }
    /*
   * Perform division in the specified base.
   */ var divide = function() {
        // Assumes non-zero x and k, and hence non-zero result.
        function multiplyInteger(x, k, base) {
            var temp, carry = 0, i = x.length;
            for(x = x.slice(); i--;){
                temp = x[i] * k + carry;
                x[i] = temp % base | 0;
                carry = temp / base | 0;
            }
            if (carry) x.unshift(carry);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, r;
            if (aL != bL) r = aL > bL ? 1 : -1;
            else {
                for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                    r = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return r;
        }
        function subtract(a, b, aL, base) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * base + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1;)a.shift();
        }
        return function(x, y, pr, rm, dp, base) {
            var cmp, e, i, k, logBase, more, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
            // Either NaN, Infinity or 0?
            if (!xd || !xd[0] || !yd || !yd[0]) return new Ctor(!x.s || !y.s || (xd ? yd && xd[0] == yd[0] : !yd) ? NaN : // Return ±0 if x is 0 or y is ±Infinity, or return ±Infinity as y is 0.
            xd && xd[0] == 0 || !yd ? sign * 0 : sign / 0);
            if (base) {
                logBase = 1;
                e = x.e - y.e;
            } else {
                base = BASE;
                logBase = LOG_BASE;
                e = mathfloor(x.e / logBase) - mathfloor(y.e / logBase);
            }
            yL = yd.length;
            xL = xd.length;
            q = new Ctor(sign);
            qd = q.d = [];
            // Result exponent may be one less than e.
            // The digit array of a Decimal from toStringBinary may have trailing zeros.
            for(i = 0; yd[i] == (xd[i] || 0); i++);
            if (yd[i] > (xd[i] || 0)) e--;
            if (pr == null) {
                sd = pr = Ctor.precision;
                rm = Ctor.rounding;
            } else if (dp) sd = pr + (x.e - y.e) + 1;
            else sd = pr;
            if (sd < 0) {
                qd.push(1);
                more = true;
            } else {
                // Convert precision in number of base 10 digits to base 1e7 digits.
                sd = sd / logBase + 2 | 0;
                i = 0;
                // divisor < 1e7
                if (yL == 1) {
                    k = 0;
                    yd = yd[0];
                    sd++;
                    // k is the carry.
                    for(; (i < xL || k) && sd--; i++){
                        t = k * base + (xd[i] || 0);
                        qd[i] = t / yd | 0;
                        k = t % yd | 0;
                    }
                    more = k || i < xL;
                // divisor >= 1e7
                } else {
                    // Normalise xd and yd so highest order digit of yd is >= base/2
                    k = base / (yd[0] + 1) | 0;
                    if (k > 1) {
                        yd = multiplyInteger(yd, k, base);
                        xd = multiplyInteger(xd, k, base);
                        yL = yd.length;
                        xL = xd.length;
                    }
                    xi = yL;
                    rem = xd.slice(0, yL);
                    remL = rem.length;
                    // Add zeros to make remainder as long as divisor.
                    for(; remL < yL;)rem[remL++] = 0;
                    yz = yd.slice();
                    yz.unshift(0);
                    yd0 = yd[0];
                    if (yd[1] >= base / 2) ++yd0;
                    do {
                        k = 0;
                        // Compare divisor and remainder.
                        cmp = compare(yd, rem, yL, remL);
                        // If divisor < remainder.
                        if (cmp < 0) {
                            // Calculate trial digit, k.
                            rem0 = rem[0];
                            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                            // k will be how many times the divisor goes into the current remainder.
                            k = rem0 / yd0 | 0;
                            //  Algorithm:
                            //  1. product = divisor * trial digit (k)
                            //  2. if product > remainder: product -= divisor, k--
                            //  3. remainder -= product
                            //  4. if product was < remainder at 2:
                            //    5. compare new remainder and divisor
                            //    6. If remainder > divisor: remainder -= divisor, k++
                            if (k > 1) {
                                if (k >= base) k = base - 1;
                                // product = divisor * trial digit.
                                prod = multiplyInteger(yd, k, base);
                                prodL = prod.length;
                                remL = rem.length;
                                // Compare product and remainder.
                                cmp = compare(prod, rem, prodL, remL);
                                // product > remainder.
                                if (cmp == 1) {
                                    k--;
                                    // Subtract divisor from product.
                                    subtract(prod, yL < prodL ? yz : yd, prodL, base);
                                }
                            } else {
                                // cmp is -1.
                                // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                                // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                                if (k == 0) cmp = k = 1;
                                prod = yd.slice();
                            }
                            prodL = prod.length;
                            if (prodL < remL) prod.unshift(0);
                            // Subtract product from remainder.
                            subtract(rem, prod, remL, base);
                            // If product was < previous remainder.
                            if (cmp == -1) {
                                remL = rem.length;
                                // Compare divisor and new remainder.
                                cmp = compare(yd, rem, yL, remL);
                                // If divisor < new remainder, subtract divisor from remainder.
                                if (cmp < 1) {
                                    k++;
                                    // Subtract divisor from remainder.
                                    subtract(rem, yL < remL ? yz : yd, remL, base);
                                }
                            }
                            remL = rem.length;
                        } else if (cmp === 0) {
                            k++;
                            rem = [
                                0
                            ];
                        } // if cmp === 1, k will be 0
                        // Add the next digit, k, to the result array.
                        qd[i++] = k;
                        // Update the remainder.
                        if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                        else {
                            rem = [
                                xd[xi]
                            ];
                            remL = 1;
                        }
                    }while ((xi++ < xL || rem[0] !== void 0) && sd--);
                    more = rem[0] !== void 0;
                }
                // Leading zero?
                if (!qd[0]) qd.shift();
            }
            // logBase is 1 when divide is being used for base conversion.
            if (logBase == 1) {
                q.e = e;
                inexact = more;
            } else {
                // To calculate q.e, first get the number of digits of qd[0].
                for(i = 1, k = qd[0]; k >= 10; k /= 10)i++;
                q.e = i + e * logBase - 1;
                finalise(q, dp ? pr + q.e + 1 : pr, rm, more);
            }
            return q;
        };
    }();
    /*
   * Round `x` to `sd` significant digits using rounding mode `rm`.
   * Check for over/under-flow.
   */ function finalise(x, sd, rm, isTruncated) {
        var digits, i, j, k, rd, roundUp, w, xd, xdi, Ctor = x.constructor;
        // Don't round if sd is null or undefined.
        out: if (sd != null) {
            xd = x.d;
            // Infinity/NaN.
            if (!xd) return x;
            // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
            // w: the word of xd containing rd, a base 1e7 number.
            // xdi: the index of w within xd.
            // digits: the number of digits of w.
            // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
            // they had leading zeros)
            // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
            // Get the length of the first word of the digits array xd.
            for(digits = 1, k = xd[0]; k >= 10; k /= 10)digits++;
            i = sd - digits;
            // Is the rounding digit in the first word of xd?
            if (i < 0) {
                i += LOG_BASE;
                j = sd;
                w = xd[xdi = 0];
                // Get the rounding digit at index j of w.
                rd = w / mathpow(10, digits - j - 1) % 10 | 0;
            } else {
                xdi = Math.ceil((i + 1) / LOG_BASE);
                k = xd.length;
                if (xdi >= k) {
                    if (isTruncated) {
                        // Needed by `naturalExponential`, `naturalLogarithm` and `squareRoot`.
                        for(; k++ <= xdi;)xd.push(0);
                        w = rd = 0;
                        digits = 1;
                        i %= LOG_BASE;
                        j = i - LOG_BASE + 1;
                    } else break out;
                } else {
                    w = k = xd[xdi];
                    // Get the number of digits of w.
                    for(digits = 1; k >= 10; k /= 10)digits++;
                    // Get the index of rd within w.
                    i %= LOG_BASE;
                    // Get the index of rd within w, adjusted for leading zeros.
                    // The number of leading zeros of w is given by LOG_BASE - digits.
                    j = i - LOG_BASE + digits;
                    // Get the rounding digit at index j of w.
                    rd = j < 0 ? 0 : w / mathpow(10, digits - j - 1) % 10 | 0;
                }
            }
            // Are there any non-zero digits after the rounding digit?
            isTruncated = isTruncated || sd < 0 || xd[xdi + 1] !== void 0 || (j < 0 ? w : w % mathpow(10, digits - j - 1));
            // The expression `w % mathpow(10, digits - j - 1)` returns all the digits of w to the right
            // of the digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression
            // will give 714.
            roundUp = rm < 4 ? (rd || isTruncated) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || isTruncated || rm == 6 && (i > 0 ? j > 0 ? w / mathpow(10, digits - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
            if (sd < 1 || !xd[0]) {
                xd.length = 0;
                if (roundUp) {
                    // Convert sd to decimal places.
                    sd -= x.e + 1;
                    // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                    xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
                    x.e = -sd || 0;
                } else // Zero.
                xd[0] = x.e = 0;
                return x;
            }
            // Remove excess digits.
            if (i == 0) {
                xd.length = xdi;
                k = 1;
                xdi--;
            } else {
                xd.length = xdi + 1;
                k = mathpow(10, LOG_BASE - i);
                // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                // j > 0 means i > number of leading zeros of w.
                xd[xdi] = j > 0 ? (w / mathpow(10, digits - j) % mathpow(10, j) | 0) * k : 0;
            }
            if (roundUp) {
                for(;;)// Is the digit to be rounded up in the first word of xd?
                if (xdi == 0) {
                    // i will be the length of xd[0] before k is added.
                    for(i = 1, j = xd[0]; j >= 10; j /= 10)i++;
                    j = xd[0] += k;
                    for(k = 1; j >= 10; j /= 10)k++;
                    // if i != k the length has increased.
                    if (i != k) {
                        x.e++;
                        if (xd[0] == BASE) xd[0] = 1;
                    }
                    break;
                } else {
                    xd[xdi] += k;
                    if (xd[xdi] != BASE) break;
                    xd[xdi--] = 0;
                    k = 1;
                }
            }
            // Remove trailing zeros.
            for(i = xd.length; xd[--i] === 0;)xd.pop();
        }
        if (external) {
            // Overflow?
            if (x.e > Ctor.maxE) {
                // Infinity.
                x.d = null;
                x.e = NaN;
            // Underflow?
            } else if (x.e < Ctor.minE) {
                // Zero.
                x.e = 0;
                x.d = [
                    0
                ];
            // Ctor.underflow = true;
            } // else Ctor.underflow = false;
        }
        return x;
    }
    function finiteToString(x, isExp, sd) {
        if (!x.isFinite()) return nonFiniteToString(x);
        var k, e = x.e, str = digitsToString(x.d), len = str.length;
        if (isExp) {
            if (sd && (k = sd - len) > 0) str = str.charAt(0) + "." + str.slice(1) + getZeroString(k);
            else if (len > 1) str = str.charAt(0) + "." + str.slice(1);
            str = str + (x.e < 0 ? "e" : "e+") + x.e;
        } else if (e < 0) {
            str = "0." + getZeroString(-e - 1) + str;
            if (sd && (k = sd - len) > 0) str += getZeroString(k);
        } else if (e >= len) {
            str += getZeroString(e + 1 - len);
            if (sd && (k = sd - e - 1) > 0) str = str + "." + getZeroString(k);
        } else {
            if ((k = e + 1) < len) str = str.slice(0, k) + "." + str.slice(k);
            if (sd && (k = sd - len) > 0) {
                if (e + 1 === len) str += ".";
                str += getZeroString(k);
            }
        }
        return str;
    }
    // Calculate the base 10 exponent from the base 1e7 exponent.
    function getBase10Exponent(digits, e) {
        var w = digits[0];
        // Add the number of digits of the first word of the digits array.
        for(e *= LOG_BASE; w >= 10; w /= 10)e++;
        return e;
    }
    function getLn10(Ctor, sd, pr) {
        if (sd > LN10_PRECISION) {
            // Reset global state in case the exception is caught.
            external = true;
            if (pr) Ctor.precision = pr;
            throw Error(precisionLimitExceeded);
        }
        return finalise(new Ctor(LN10), sd, 1, true);
    }
    function getPi(Ctor, sd, rm) {
        if (sd > PI_PRECISION) throw Error(precisionLimitExceeded);
        return finalise(new Ctor(PI), sd, rm, true);
    }
    function getPrecision(digits) {
        var w = digits.length - 1, len = w * LOG_BASE + 1;
        w = digits[w];
        // If non-zero...
        if (w) {
            // Subtract the number of trailing zeros of the last word.
            for(; w % 10 == 0; w /= 10)len--;
            // Add the number of digits of the first word.
            for(w = digits[0]; w >= 10; w /= 10)len++;
        }
        return len;
    }
    function getZeroString(k) {
        var zs = "";
        for(; k--;)zs += "0";
        return zs;
    }
    /*
   * Return a new Decimal whose value is the value of Decimal `x` to the power `n`, where `n` is an
   * integer of type number.
   *
   * Implements 'exponentiation by squaring'. Called by `pow` and `parseOther`.
   *
   */ function intPow(Ctor, x, n, pr) {
        var isTruncated, r = new Ctor(1), // Max n of 9007199254740991 takes 53 loop iterations.
        // Maximum digits array length; leaves [28, 34] guard digits.
        k = Math.ceil(pr / LOG_BASE + 4);
        external = false;
        for(;;){
            if (n % 2) {
                r = r.times(x);
                if (truncate(r.d, k)) isTruncated = true;
            }
            n = mathfloor(n / 2);
            if (n === 0) {
                // To ensure correct rounding when r.d is truncated, increment the last word if it is zero.
                n = r.d.length - 1;
                if (isTruncated && r.d[n] === 0) ++r.d[n];
                break;
            }
            x = x.times(x);
            truncate(x.d, k);
        }
        external = true;
        return r;
    }
    function isOdd(n) {
        return n.d[n.d.length - 1] & 1;
    }
    /*
   * Handle `max` and `min`. `ltgt` is 'lt' or 'gt'.
   */ function maxOrMin(Ctor, args, ltgt) {
        var y, x = new Ctor(args[0]), i = 0;
        for(; ++i < args.length;){
            y = new Ctor(args[i]);
            if (!y.s) {
                x = y;
                break;
            } else if (x[ltgt](y)) x = y;
        }
        return x;
    }
    /*
   * Return a new Decimal whose value is the natural exponential of `x` rounded to `sd` significant
   * digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * Max integer argument: exp('20723265836946413') = 6.3e+9000000000000000
   * Min integer argument: exp('-20723265836946411') = 1.2e-9000000000000000
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(Infinity)  = Infinity
   *  exp(-Infinity) = 0
   *  exp(NaN)       = NaN
   *  exp(±0)        = 1
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   *  The result will always be correctly rounded.
   *
   */ function naturalExponential(x, sd) {
        var denominator, guard, j, pow, sum, t, wpr, rep = 0, i = 0, k = 0, Ctor = x.constructor, rm = Ctor.rounding, pr = Ctor.precision;
        // 0/NaN/Infinity?
        if (!x.d || !x.d[0] || x.e > 17) return new Ctor(x.d ? !x.d[0] ? 1 : x.s < 0 ? 0 : 1 / 0 : x.s ? x.s < 0 ? 0 : x : 0 / 0);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        t = new Ctor(0.03125);
        // while abs(x) >= 0.1
        while(x.e > -2){
            // x = x / 2^5
            x = x.times(t);
            k += 5;
        }
        // Use 2 * log10(2^k) + 5 (empirically derived) to estimate the increase in precision
        // necessary to ensure the first 4 rounding digits are correct.
        guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
        wpr += guard;
        denominator = pow = sum = new Ctor(1);
        Ctor.precision = wpr;
        for(;;){
            pow = finalise(pow.times(x), wpr, 1);
            denominator = denominator.times(++i);
            t = sum.plus(divide(pow, denominator, wpr, 1));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                j = k;
                while(j--)sum = finalise(sum.times(sum), wpr, 1);
                // Check to see if the first 4 rounding digits are [49]999.
                // If so, repeat the summation with a higher precision, otherwise
                // e.g. with precision: 18, rounding: 1
                // exp(18.404272462595034083567793919843761) = 98372560.1229999999 (should be 98372560.123)
                // `wpr - guard` is the index of first rounding digit.
                if (sd == null) {
                    if (rep < 3 && checkRoundingDigits(sum.d, wpr - guard, rm, rep)) {
                        Ctor.precision = wpr += 10;
                        denominator = pow = t = new Ctor(1);
                        i = 0;
                        rep++;
                    } else return finalise(sum, Ctor.precision = pr, rm, external = true);
                } else {
                    Ctor.precision = pr;
                    return sum;
                }
            }
            sum = t;
        }
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x` rounded to `sd` significant
   * digits.
   *
   *  ln(-n)        = NaN
   *  ln(0)         = -Infinity
   *  ln(-0)        = -Infinity
   *  ln(1)         = 0
   *  ln(Infinity)  = Infinity
   *  ln(-Infinity) = NaN
   *  ln(NaN)       = NaN
   *
   *  ln(n) (n != 1) is non-terminating.
   *
   */ function naturalLogarithm(y, sd) {
        var c, c0, denominator, e, numerator, rep, sum, t, wpr, x1, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, rm = Ctor.rounding, pr = Ctor.precision;
        // Is x negative or Infinity, NaN, 0 or 1?
        if (x.s < 0 || !xd || !xd[0] || !x.e && xd[0] == 1 && xd.length == 1) return new Ctor(xd && !xd[0] ? -1 / 0 : x.s != 1 ? NaN : xd ? 0 : x);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        Ctor.precision = wpr += guard;
        c = digitsToString(xd);
        c0 = c.charAt(0);
        if (Math.abs(e = x.e) < 1.5e15) {
            // Argument reduction.
            // The series converges faster the closer the argument is to 1, so using
            // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
            // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
            // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
            // later be divided by this number, then separate out the power of 10 using
            // ln(a*10^b) = ln(a) + b*ln(10).
            // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
            //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
            // max n is 6 (gives 0.7 - 1.3)
            while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
                x = x.times(y);
                c = digitsToString(x.d);
                c0 = c.charAt(0);
                n++;
            }
            e = x.e;
            if (c0 > 1) {
                x = new Ctor("0." + c);
                e++;
            } else x = new Ctor(c0 + "." + c.slice(1));
        } else {
            // The argument reduction method above may result in overflow if the argument y is a massive
            // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
            // function using ln(x*10^e) = ln(x) + e*ln(10).
            t = getLn10(Ctor, wpr + 2, pr).times(e + "");
            x = naturalLogarithm(new Ctor(c0 + "." + c.slice(1)), wpr - guard).plus(t);
            Ctor.precision = pr;
            return sd == null ? finalise(x, pr, rm, external = true) : x;
        }
        // x1 is x reduced to a value near 1.
        x1 = x;
        // Taylor series.
        // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
        // where x = (y - 1)/(y + 1)    (|x| < 1)
        sum = numerator = x = divide(x.minus(1), x.plus(1), wpr, 1);
        x2 = finalise(x.times(x), wpr, 1);
        denominator = 3;
        for(;;){
            numerator = finalise(numerator.times(x2), wpr, 1);
            t = sum.plus(divide(numerator, new Ctor(denominator), wpr, 1));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                sum = sum.times(2);
                // Reverse the argument reduction. Check that e is not 0 because, besides preventing an
                // unnecessary calculation, -0 + 0 = +0 and to ensure correct rounding -0 needs to stay -0.
                if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ""));
                sum = divide(sum, new Ctor(n), wpr, 1);
                // Is rm > 3 and the first 4 rounding digits 4999, or rm < 4 (or the summation has
                // been repeated previously) and the first 4 rounding digits 9999?
                // If so, restart the summation with a higher precision, otherwise
                // e.g. with precision: 12, rounding: 1
                // ln(135520028.6126091714265381533) = 18.7246299999 when it should be 18.72463.
                // `wpr - guard` is the index of first rounding digit.
                if (sd == null) {
                    if (checkRoundingDigits(sum.d, wpr - guard, rm, rep)) {
                        Ctor.precision = wpr += guard;
                        t = numerator = x = divide(x1.minus(1), x1.plus(1), wpr, 1);
                        x2 = finalise(x.times(x), wpr, 1);
                        denominator = rep = 1;
                    } else return finalise(sum, Ctor.precision = pr, rm, external = true);
                } else {
                    Ctor.precision = pr;
                    return sum;
                }
            }
            sum = t;
            denominator += 2;
        }
    }
    // ±Infinity, NaN.
    function nonFiniteToString(x) {
        // Unsigned.
        return String(x.s * x.s / 0);
    }
    /*
   * Parse the value of a new Decimal `x` from string `str`.
   */ function parseDecimal(x, str) {
        var e, i, len;
        // Decimal point?
        if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +str.slice(i + 1);
            str = str.substring(0, i);
        } else if (e < 0) // Integer.
        e = str.length;
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48; i++);
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(len - 1) === 48; --len);
        str = str.slice(i, len);
        if (str) {
            len -= i;
            x.e = e = e - i - 1;
            x.d = [];
            // Transform base
            // e is the base 10 exponent.
            // i is where to slice str to get the first word of the digits array.
            i = (e + 1) % LOG_BASE;
            if (e < 0) i += LOG_BASE;
            if (i < len) {
                if (i) x.d.push(+str.slice(0, i));
                for(len -= LOG_BASE; i < len;)x.d.push(+str.slice(i, i += LOG_BASE));
                str = str.slice(i);
                i = LOG_BASE - str.length;
            } else i -= len;
            for(; i--;)str += "0";
            x.d.push(+str);
            if (external) {
                // Overflow?
                if (x.e > x.constructor.maxE) {
                    // Infinity.
                    x.d = null;
                    x.e = NaN;
                // Underflow?
                } else if (x.e < x.constructor.minE) {
                    // Zero.
                    x.e = 0;
                    x.d = [
                        0
                    ];
                // x.constructor.underflow = true;
                } // else x.constructor.underflow = false;
            }
        } else {
            // Zero.
            x.e = 0;
            x.d = [
                0
            ];
        }
        return x;
    }
    /*
   * Parse the value of a new Decimal `x` from a string `str`, which is not a decimal value.
   */ function parseOther(x, str) {
        var base, Ctor, divisor, i, isFloat, len, p, xd, xe;
        if (str.indexOf("_") > -1) {
            str = str.replace(/(\d)_(?=\d)/g, "$1");
            if (isDecimal.test(str)) return parseDecimal(x, str);
        } else if (str === "Infinity" || str === "NaN") {
            if (!+str) x.s = NaN;
            x.e = NaN;
            x.d = null;
            return x;
        }
        if (isHex.test(str)) {
            base = 16;
            str = str.toLowerCase();
        } else if (isBinary.test(str)) base = 2;
        else if (isOctal.test(str)) base = 8;
        else throw Error(invalidArgument + str);
        // Is there a binary exponent part?
        i = str.search(/p/i);
        if (i > 0) {
            p = +str.slice(i + 1);
            str = str.substring(2, i);
        } else str = str.slice(2);
        // Convert `str` as an integer then divide the result by `base` raised to a power such that the
        // fraction part will be restored.
        i = str.indexOf(".");
        isFloat = i >= 0;
        Ctor = x.constructor;
        if (isFloat) {
            str = str.replace(".", "");
            len = str.length;
            i = len - i;
            // log[10](16) = 1.2041... , log[10](88) = 1.9444....
            divisor = intPow(Ctor, new Ctor(base), i, i * 2);
        }
        xd = convertBase(str, base, BASE);
        xe = xd.length - 1;
        // Remove trailing zeros.
        for(i = xe; xd[i] === 0; --i)xd.pop();
        if (i < 0) return new Ctor(x.s * 0);
        x.e = getBase10Exponent(xd, xe);
        x.d = xd;
        external = false;
        // At what precision to perform the division to ensure exact conversion?
        // maxDecimalIntegerPartDigitCount = ceil(log[10](b) * otherBaseIntegerPartDigitCount)
        // log[10](2) = 0.30103, log[10](8) = 0.90309, log[10](16) = 1.20412
        // E.g. ceil(1.2 * 3) = 4, so up to 4 decimal digits are needed to represent 3 hex int digits.
        // maxDecimalFractionPartDigitCount = {Hex:4|Oct:3|Bin:1} * otherBaseFractionPartDigitCount
        // Therefore using 4 * the number of digits of str will always be enough.
        if (isFloat) x = divide(x, divisor, len * 4);
        // Multiply by the binary exponent part if present.
        if (p) x = x.times(Math.abs(p) < 54 ? mathpow(2, p) : Decimal.pow(2, p));
        external = true;
        return x;
    }
    /*
   * sin(x) = x - x^3/3! + x^5/5! - ...
   * |x| < pi/2
   *
   */ function sine(Ctor, x) {
        var k, len = x.d.length;
        if (len < 3) return x.isZero() ? x : taylorSeries(Ctor, 2, x, x);
        // Argument reduction: sin(5x) = 16*sin^5(x) - 20*sin^3(x) + 5*sin(x)
        // i.e. sin(x) = 16*sin^5(x/5) - 20*sin^3(x/5) + 5*sin(x/5)
        // and  sin(x) = sin(x/5)(5 + sin^2(x/5)(16sin^2(x/5) - 20))
        // Estimate the optimum number of times to use the argument reduction.
        k = 1.4 * Math.sqrt(len);
        k = k > 16 ? 16 : k | 0;
        x = x.times(1 / tinyPow(5, k));
        x = taylorSeries(Ctor, 2, x, x);
        // Reverse argument reduction
        var sin2_x, d5 = new Ctor(5), d16 = new Ctor(16), d20 = new Ctor(20);
        for(; k--;){
            sin2_x = x.times(x);
            x = x.times(d5.plus(sin2_x.times(d16.times(sin2_x).minus(d20))));
        }
        return x;
    }
    // Calculate Taylor series for `cos`, `cosh`, `sin` and `sinh`.
    function taylorSeries(Ctor, n, x, y, isHyperbolic) {
        var j, t, u, x2, i = 1, pr = Ctor.precision, k = Math.ceil(pr / LOG_BASE);
        external = false;
        x2 = x.times(x);
        u = new Ctor(y);
        for(;;){
            t = divide(u.times(x2), new Ctor(n++ * n++), pr, 1);
            u = isHyperbolic ? y.plus(t) : y.minus(t);
            y = divide(t.times(x2), new Ctor(n++ * n++), pr, 1);
            t = u.plus(y);
            if (t.d[k] !== void 0) {
                for(j = k; t.d[j] === u.d[j] && j--;);
                if (j == -1) break;
            }
            j = u;
            u = y;
            y = t;
            t = j;
            i++;
        }
        external = true;
        t.d.length = k + 1;
        return t;
    }
    // Exponent e must be positive and non-zero.
    function tinyPow(b, e) {
        var n = b;
        while(--e)n *= b;
        return n;
    }
    // Return the absolute value of `x` reduced to less than or equal to half pi.
    function toLessThanHalfPi(Ctor, x) {
        var t, isNeg = x.s < 0, pi = getPi(Ctor, Ctor.precision, 1), halfPi = pi.times(0.5);
        x = x.abs();
        if (x.lte(halfPi)) {
            quadrant = isNeg ? 4 : 1;
            return x;
        }
        t = x.divToInt(pi);
        if (t.isZero()) quadrant = isNeg ? 3 : 2;
        else {
            x = x.minus(t.times(pi));
            // 0 <= x < pi
            if (x.lte(halfPi)) {
                quadrant = isOdd(t) ? isNeg ? 2 : 3 : isNeg ? 4 : 1;
                return x;
            }
            quadrant = isOdd(t) ? isNeg ? 1 : 4 : isNeg ? 3 : 2;
        }
        return x.minus(pi).abs();
    }
    /*
   * Return the value of Decimal `x` as a string in base `baseOut`.
   *
   * If the optional `sd` argument is present include a binary exponent suffix.
   */ function toStringBinary(x, baseOut, sd, rm) {
        var base, e, i, k, len, roundUp, str, xd, y, Ctor = x.constructor, isExp = sd !== void 0;
        if (isExp) {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        } else {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        }
        if (!x.isFinite()) str = nonFiniteToString(x);
        else {
            str = finiteToString(x);
            i = str.indexOf(".");
            // Use exponential notation according to `toExpPos` and `toExpNeg`? No, but if required:
            // maxBinaryExponent = floor((decimalExponent + 1) * log[2](10))
            // minBinaryExponent = floor(decimalExponent * log[2](10))
            // log[2](10) = 3.321928094887362347870319429489390175864
            if (isExp) {
                base = 2;
                if (baseOut == 16) sd = sd * 4 - 3;
                else if (baseOut == 8) sd = sd * 3 - 2;
            } else base = baseOut;
            // Convert the number as an integer then divide the result by its base raised to a power such
            // that the fraction part will be restored.
            // Non-integer.
            if (i >= 0) {
                str = str.replace(".", "");
                y = new Ctor(1);
                y.e = str.length - i;
                y.d = convertBase(finiteToString(y), 10, base);
                y.e = y.d.length;
            }
            xd = convertBase(str, 10, base);
            e = len = xd.length;
            // Remove trailing zeros.
            for(; xd[--len] == 0;)xd.pop();
            if (!xd[0]) str = isExp ? "0p+0" : "0";
            else {
                if (i < 0) e--;
                else {
                    x = new Ctor(x);
                    x.d = xd;
                    x.e = e;
                    x = divide(x, y, sd, rm, 0, base);
                    xd = x.d;
                    e = x.e;
                    roundUp = inexact;
                }
                // The rounding digit, i.e. the digit after the digit that may be rounded up.
                i = xd[sd];
                k = base / 2;
                roundUp = roundUp || xd[sd + 1] !== void 0;
                roundUp = rm < 4 ? (i !== void 0 || roundUp) && (rm === 0 || rm === (x.s < 0 ? 3 : 2)) : i > k || i === k && (rm === 4 || roundUp || rm === 6 && xd[sd - 1] & 1 || rm === (x.s < 0 ? 8 : 7));
                xd.length = sd;
                if (roundUp) // Rounding up may mean the previous digit has to be rounded up and so on.
                for(; ++xd[--sd] > base - 1;){
                    xd[sd] = 0;
                    if (!sd) {
                        ++e;
                        xd.unshift(1);
                    }
                }
                // Determine trailing zeros.
                for(len = xd.length; !xd[len - 1]; --len);
                // E.g. [4, 11, 15] becomes 4bf.
                for(i = 0, str = ""; i < len; i++)str += NUMERALS.charAt(xd[i]);
                // Add binary exponent suffix?
                if (isExp) {
                    if (len > 1) {
                        if (baseOut == 16 || baseOut == 8) {
                            i = baseOut == 16 ? 4 : 3;
                            for(--len; len % i; len++)str += "0";
                            xd = convertBase(str, base, baseOut);
                            for(len = xd.length; !xd[len - 1]; --len);
                            // xd[0] will always be be 1
                            for(i = 1, str = "1."; i < len; i++)str += NUMERALS.charAt(xd[i]);
                        } else str = str.charAt(0) + "." + str.slice(1);
                    }
                    str = str + (e < 0 ? "p" : "p+") + e;
                } else if (e < 0) {
                    for(; ++e;)str = "0" + str;
                    str = "0." + str;
                } else {
                    if (++e > len) for(e -= len; e--;)str += "0";
                    else if (e < len) str = str.slice(0, e) + "." + str.slice(e);
                }
            }
            str = (baseOut == 16 ? "0x" : baseOut == 2 ? "0b" : baseOut == 8 ? "0o" : "") + str;
        }
        return x.s < 0 ? "-" + str : str;
    }
    // Does not strip trailing zeros.
    function truncate(arr, len) {
        if (arr.length > len) {
            arr.length = len;
            return true;
        }
    }
    // Decimal methods
    /*
   *  abs
   *  acos
   *  acosh
   *  add
   *  asin
   *  asinh
   *  atan
   *  atanh
   *  atan2
   *  cbrt
   *  ceil
   *  clamp
   *  clone
   *  config
   *  cos
   *  cosh
   *  div
   *  exp
   *  floor
   *  hypot
   *  ln
   *  log
   *  log2
   *  log10
   *  max
   *  min
   *  mod
   *  mul
   *  pow
   *  random
   *  round
   *  set
   *  sign
   *  sin
   *  sinh
   *  sqrt
   *  sub
   *  sum
   *  tan
   *  tanh
   *  trunc
   */ /*
   * Return a new Decimal whose value is the absolute value of `x`.
   *
   * x {number|string|Decimal}
   *
   */ function abs(x) {
        return new this(x).abs();
    }
    /*
   * Return a new Decimal whose value is the arccosine in radians of `x`.
   *
   * x {number|string|Decimal}
   *
   */ function acos(x) {
        return new this(x).acos();
    }
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic cosine of `x`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function acosh(x) {
        return new this(x).acosh();
    }
    /*
   * Return a new Decimal whose value is the sum of `x` and `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */ function add(x, y) {
        return new this(x).plus(y);
    }
    /*
   * Return a new Decimal whose value is the arcsine in radians of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function asin(x) {
        return new this(x).asin();
    }
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic sine of `x`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function asinh(x) {
        return new this(x).asinh();
    }
    /*
   * Return a new Decimal whose value is the arctangent in radians of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function atan(x) {
        return new this(x).atan();
    }
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic tangent of `x`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function atanh(x) {
        return new this(x).atanh();
    }
    /*
   * Return a new Decimal whose value is the arctangent in radians of `y/x` in the range -pi to pi
   * (inclusive), rounded to `precision` significant digits using rounding mode `rounding`.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-pi, pi]
   *
   * y {number|string|Decimal} The y-coordinate.
   * x {number|string|Decimal} The x-coordinate.
   *
   * atan2(±0, -0)               = ±pi
   * atan2(±0, +0)               = ±0
   * atan2(±0, -x)               = ±pi for x > 0
   * atan2(±0, x)                = ±0 for x > 0
   * atan2(-y, ±0)               = -pi/2 for y > 0
   * atan2(y, ±0)                = pi/2 for y > 0
   * atan2(±y, -Infinity)        = ±pi for finite y > 0
   * atan2(±y, +Infinity)        = ±0 for finite y > 0
   * atan2(±Infinity, x)         = ±pi/2 for finite x
   * atan2(±Infinity, -Infinity) = ±3*pi/4
   * atan2(±Infinity, +Infinity) = ±pi/4
   * atan2(NaN, x) = NaN
   * atan2(y, NaN) = NaN
   *
   */ function atan2(y, x) {
        y = new this(y);
        x = new this(x);
        var r, pr = this.precision, rm = this.rounding, wpr = pr + 4;
        // Either NaN
        if (!y.s || !x.s) r = new this(NaN);
        else if (!y.d && !x.d) {
            r = getPi(this, wpr, 1).times(x.s > 0 ? 0.25 : 0.75);
            r.s = y.s;
        // x is ±Infinity or y is ±0
        } else if (!x.d || y.isZero()) {
            r = x.s < 0 ? getPi(this, pr, rm) : new this(0);
            r.s = y.s;
        // y is ±Infinity or x is ±0
        } else if (!y.d || x.isZero()) {
            r = getPi(this, wpr, 1).times(0.5);
            r.s = y.s;
        // Both non-zero and finite
        } else if (x.s < 0) {
            this.precision = wpr;
            this.rounding = 1;
            r = this.atan(divide(y, x, wpr, 1));
            x = getPi(this, wpr, 1);
            this.precision = pr;
            this.rounding = rm;
            r = y.s < 0 ? r.minus(x) : r.plus(x);
        } else r = this.atan(divide(y, x, wpr, 1));
        return r;
    }
    /*
   * Return a new Decimal whose value is the cube root of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function cbrt(x) {
        return new this(x).cbrt();
    }
    /*
   * Return a new Decimal whose value is `x` rounded to an integer using `ROUND_CEIL`.
   *
   * x {number|string|Decimal}
   *
   */ function ceil(x) {
        return finalise(x = new this(x), x.e + 1, 2);
    }
    /*
   * Return a new Decimal whose value is `x` clamped to the range delineated by `min` and `max`.
   *
   * x {number|string|Decimal}
   * min {number|string|Decimal}
   * max {number|string|Decimal}
   *
   */ function clamp(x, min, max) {
        return new this(x).clamp(min, max);
    }
    /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *   maxE       {number}
   *   minE       {number}
   *   modulo     {number}
   *   crypto     {boolean|number}
   *   defaults   {true}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */ function config(obj) {
        if (!obj || typeof obj !== "object") throw Error(decimalError + "Object expected");
        var i, p, v, useDefaults = obj.defaults === true, ps = [
            "precision",
            1,
            MAX_DIGITS,
            "rounding",
            0,
            8,
            "toExpNeg",
            -EXP_LIMIT,
            0,
            "toExpPos",
            0,
            EXP_LIMIT,
            "maxE",
            0,
            EXP_LIMIT,
            "minE",
            -EXP_LIMIT,
            0,
            "modulo",
            0,
            9
        ];
        for(i = 0; i < ps.length; i += 3){
            if (p = ps[i], useDefaults) this[p] = DEFAULTS[p];
            if ((v = obj[p]) !== void 0) {
                if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
                else throw Error(invalidArgument + p + ": " + v);
            }
        }
        if (p = "crypto", useDefaults) this[p] = DEFAULTS[p];
        if ((v = obj[p]) !== void 0) {
            if (v === true || v === false || v === 0 || v === 1) {
                if (v) {
                    if (typeof crypto != "undefined" && crypto && (crypto.getRandomValues || crypto.randomBytes)) this[p] = true;
                    else throw Error(cryptoUnavailable);
                } else this[p] = false;
            } else throw Error(invalidArgument + p + ": " + v);
        }
        return this;
    }
    /*
   * Return a new Decimal whose value is the cosine of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function cos(x) {
        return new this(x).cos();
    }
    /*
   * Return a new Decimal whose value is the hyperbolic cosine of `x`, rounded to precision
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function cosh(x) {
        return new this(x).cosh();
    }
    /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */ function clone(obj) {
        var i, p, ps;
        /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * v {number|string|Decimal} A numeric value.
     *
     */ function Decimal(v) {
            var e, i, t, x = this;
            // Decimal called without new.
            if (!(x instanceof Decimal)) return new Decimal(v);
            // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
            // which points to Object.
            x.constructor = Decimal;
            // Duplicate.
            if (isDecimalInstance(v)) {
                x.s = v.s;
                if (external) {
                    if (!v.d || v.e > Decimal.maxE) {
                        // Infinity.
                        x.e = NaN;
                        x.d = null;
                    } else if (v.e < Decimal.minE) {
                        // Zero.
                        x.e = 0;
                        x.d = [
                            0
                        ];
                    } else {
                        x.e = v.e;
                        x.d = v.d.slice();
                    }
                } else {
                    x.e = v.e;
                    x.d = v.d ? v.d.slice() : v.d;
                }
                return;
            }
            t = typeof v;
            if (t === "number") {
                if (v === 0) {
                    x.s = 1 / v < 0 ? -1 : 1;
                    x.e = 0;
                    x.d = [
                        0
                    ];
                    return;
                }
                if (v < 0) {
                    v = -v;
                    x.s = -1;
                } else x.s = 1;
                // Fast path for small integers.
                if (v === ~~v && v < 1e7) {
                    for(e = 0, i = v; i >= 10; i /= 10)e++;
                    if (external) {
                        if (e > Decimal.maxE) {
                            x.e = NaN;
                            x.d = null;
                        } else if (e < Decimal.minE) {
                            x.e = 0;
                            x.d = [
                                0
                            ];
                        } else {
                            x.e = e;
                            x.d = [
                                v
                            ];
                        }
                    } else {
                        x.e = e;
                        x.d = [
                            v
                        ];
                    }
                    return;
                // Infinity, NaN.
                } else if (v * 0 !== 0) {
                    if (!v) x.s = NaN;
                    x.e = NaN;
                    x.d = null;
                    return;
                }
                return parseDecimal(x, v.toString());
            } else if (t !== "string") throw Error(invalidArgument + v);
            // Minus sign?
            if ((i = v.charCodeAt(0)) === 45) {
                v = v.slice(1);
                x.s = -1;
            } else {
                // Plus sign?
                if (i === 43) v = v.slice(1);
                x.s = 1;
            }
            return isDecimal.test(v) ? parseDecimal(x, v) : parseOther(x, v);
        }
        Decimal.prototype = P;
        Decimal.ROUND_UP = 0;
        Decimal.ROUND_DOWN = 1;
        Decimal.ROUND_CEIL = 2;
        Decimal.ROUND_FLOOR = 3;
        Decimal.ROUND_HALF_UP = 4;
        Decimal.ROUND_HALF_DOWN = 5;
        Decimal.ROUND_HALF_EVEN = 6;
        Decimal.ROUND_HALF_CEIL = 7;
        Decimal.ROUND_HALF_FLOOR = 8;
        Decimal.EUCLID = 9;
        Decimal.config = Decimal.set = config;
        Decimal.clone = clone;
        Decimal.isDecimal = isDecimalInstance;
        Decimal.abs = abs;
        Decimal.acos = acos;
        Decimal.acosh = acosh; // ES6
        Decimal.add = add;
        Decimal.asin = asin;
        Decimal.asinh = asinh; // ES6
        Decimal.atan = atan;
        Decimal.atanh = atanh; // ES6
        Decimal.atan2 = atan2;
        Decimal.cbrt = cbrt; // ES6
        Decimal.ceil = ceil;
        Decimal.clamp = clamp;
        Decimal.cos = cos;
        Decimal.cosh = cosh; // ES6
        Decimal.div = div;
        Decimal.exp = exp;
        Decimal.floor = floor;
        Decimal.hypot = hypot; // ES6
        Decimal.ln = ln;
        Decimal.log = log;
        Decimal.log10 = log10; // ES6
        Decimal.log2 = log2; // ES6
        Decimal.max = max;
        Decimal.min = min;
        Decimal.mod = mod;
        Decimal.mul = mul;
        Decimal.pow = pow;
        Decimal.random = random;
        Decimal.round = round;
        Decimal.sign = sign; // ES6
        Decimal.sin = sin;
        Decimal.sinh = sinh; // ES6
        Decimal.sqrt = sqrt;
        Decimal.sub = sub;
        Decimal.sum = sum;
        Decimal.tan = tan;
        Decimal.tanh = tanh; // ES6
        Decimal.trunc = trunc; // ES6
        if (obj === void 0) obj = {};
        if (obj) {
            if (obj.defaults !== true) {
                ps = [
                    "precision",
                    "rounding",
                    "toExpNeg",
                    "toExpPos",
                    "maxE",
                    "minE",
                    "modulo",
                    "crypto"
                ];
                for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
            }
        }
        Decimal.config(obj);
        return Decimal;
    }
    /*
   * Return a new Decimal whose value is `x` divided by `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */ function div(x, y) {
        return new this(x).div(y);
    }
    /*
   * Return a new Decimal whose value is the natural exponential of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} The power to which to raise the base of the natural log.
   *
   */ function exp(x) {
        return new this(x).exp();
    }
    /*
   * Return a new Decimal whose value is `x` round to an integer using `ROUND_FLOOR`.
   *
   * x {number|string|Decimal}
   *
   */ function floor(x) {
        return finalise(x = new this(x), x.e + 1, 3);
    }
    /*
   * Return a new Decimal whose value is the square root of the sum of the squares of the arguments,
   * rounded to `precision` significant digits using rounding mode `rounding`.
   *
   * hypot(a, b, ...) = sqrt(a^2 + b^2 + ...)
   *
   * arguments {number|string|Decimal}
   *
   */ function hypot() {
        var i, n, t = new this(0);
        external = false;
        for(i = 0; i < arguments.length;){
            n = new this(arguments[i++]);
            if (!n.d) {
                if (n.s) {
                    external = true;
                    return new this(1 / 0);
                }
                t = n;
            } else if (t.d) t = t.plus(n.times(n));
        }
        external = true;
        return t.sqrt();
    }
    /*
   * Return true if object is a Decimal instance (where Decimal is any Decimal constructor),
   * otherwise return false.
   *
   */ function isDecimalInstance(obj) {
        return obj instanceof Decimal || obj && obj.toStringTag === tag || false;
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function ln(x) {
        return new this(x).ln();
    }
    /*
   * Return a new Decimal whose value is the log of `x` to the base `y`, or to base 10 if no base
   * is specified, rounded to `precision` significant digits using rounding mode `rounding`.
   *
   * log[y](x)
   *
   * x {number|string|Decimal} The argument of the logarithm.
   * y {number|string|Decimal} The base of the logarithm.
   *
   */ function log(x, y) {
        return new this(x).log(y);
    }
    /*
   * Return a new Decimal whose value is the base 2 logarithm of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function log2(x) {
        return new this(x).log(2);
    }
    /*
   * Return a new Decimal whose value is the base 10 logarithm of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function log10(x) {
        return new this(x).log(10);
    }
    /*
   * Return a new Decimal whose value is the maximum of the arguments.
   *
   * arguments {number|string|Decimal}
   *
   */ function max() {
        return maxOrMin(this, arguments, "lt");
    }
    /*
   * Return a new Decimal whose value is the minimum of the arguments.
   *
   * arguments {number|string|Decimal}
   *
   */ function min() {
        return maxOrMin(this, arguments, "gt");
    }
    /*
   * Return a new Decimal whose value is `x` modulo `y`, rounded to `precision` significant digits
   * using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */ function mod(x, y) {
        return new this(x).mod(y);
    }
    /*
   * Return a new Decimal whose value is `x` multiplied by `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */ function mul(x, y) {
        return new this(x).mul(y);
    }
    /*
   * Return a new Decimal whose value is `x` raised to the power `y`, rounded to precision
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} The base.
   * y {number|string|Decimal} The exponent.
   *
   */ function pow(x, y) {
        return new this(x).pow(y);
    }
    /*
   * Returns a new Decimal with a random value equal to or greater than 0 and less than 1, and with
   * `sd`, or `Decimal.precision` if `sd` is omitted, significant digits (or less if trailing zeros
   * are produced).
   *
   * [sd] {number} Significant digits. Integer, 0 to MAX_DIGITS inclusive.
   *
   */ function random(sd) {
        var d, e, k, n, i = 0, r = new this(1), rd = [];
        if (sd === void 0) sd = this.precision;
        else checkInt32(sd, 1, MAX_DIGITS);
        k = Math.ceil(sd / LOG_BASE);
        if (!this.crypto) for(; i < k;)rd[i++] = Math.random() * 1e7 | 0;
        else if (crypto.getRandomValues) {
            d = crypto.getRandomValues(new Uint32Array(k));
            for(; i < k;){
                n = d[i];
                // 0 <= n < 4294967296
                // Probability n >= 4.29e9, is 4967296 / 4294967296 = 0.00116 (1 in 865).
                if (n >= 4.29e9) d[i] = crypto.getRandomValues(new Uint32Array(1))[0];
                else // 0 <= n <= 4289999999
                // 0 <= (n % 1e7) <= 9999999
                rd[i++] = n % 1e7;
            }
        // Node.js supporting crypto.randomBytes.
        } else if (crypto.randomBytes) {
            // buffer
            d = crypto.randomBytes(k *= 4);
            for(; i < k;){
                // 0 <= n < 2147483648
                n = d[i] + (d[i + 1] << 8) + (d[i + 2] << 16) + ((d[i + 3] & 0x7f) << 24);
                // Probability n >= 2.14e9, is 7483648 / 2147483648 = 0.0035 (1 in 286).
                if (n >= 2.14e9) crypto.randomBytes(4).copy(d, i);
                else {
                    // 0 <= n <= 2139999999
                    // 0 <= (n % 1e7) <= 9999999
                    rd.push(n % 1e7);
                    i += 4;
                }
            }
            i = k / 4;
        } else throw Error(cryptoUnavailable);
        k = rd[--i];
        sd %= LOG_BASE;
        // Convert trailing digits to zeros according to sd.
        if (k && sd) {
            n = mathpow(10, LOG_BASE - sd);
            rd[i] = (k / n | 0) * n;
        }
        // Remove trailing words which are zero.
        for(; rd[i] === 0; i--)rd.pop();
        // Zero?
        if (i < 0) {
            e = 0;
            rd = [
                0
            ];
        } else {
            e = -1;
            // Remove leading words which are zero and adjust exponent accordingly.
            for(; rd[0] === 0; e -= LOG_BASE)rd.shift();
            // Count the digits of the first word of rd to determine leading zeros.
            for(k = 1, n = rd[0]; n >= 10; n /= 10)k++;
            // Adjust the exponent for leading zeros of the first word of rd.
            if (k < LOG_BASE) e -= LOG_BASE - k;
        }
        r.e = e;
        r.d = rd;
        return r;
    }
    /*
   * Return a new Decimal whose value is `x` rounded to an integer using rounding mode `rounding`.
   *
   * To emulate `Math.round`, set rounding to 7 (ROUND_HALF_CEIL).
   *
   * x {number|string|Decimal}
   *
   */ function round(x) {
        return finalise(x = new this(x), x.e + 1, this.rounding);
    }
    /*
   * Return
   *   1    if x > 0,
   *  -1    if x < 0,
   *   0    if x is 0,
   *  -0    if x is -0,
   *   NaN  otherwise
   *
   * x {number|string|Decimal}
   *
   */ function sign(x) {
        x = new this(x);
        return x.d ? x.d[0] ? x.s : 0 * x.s : x.s || NaN;
    }
    /*
   * Return a new Decimal whose value is the sine of `x`, rounded to `precision` significant digits
   * using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function sin(x) {
        return new this(x).sin();
    }
    /*
   * Return a new Decimal whose value is the hyperbolic sine of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function sinh(x) {
        return new this(x).sinh();
    }
    /*
   * Return a new Decimal whose value is the square root of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function sqrt(x) {
        return new this(x).sqrt();
    }
    /*
   * Return a new Decimal whose value is `x` minus `y`, rounded to `precision` significant digits
   * using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */ function sub(x, y) {
        return new this(x).sub(y);
    }
    /*
   * Return a new Decimal whose value is the sum of the arguments, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * Only the result is rounded, not the intermediate calculations.
   *
   * arguments {number|string|Decimal}
   *
   */ function sum() {
        var i = 0, args = arguments, x = new this(args[i]);
        external = false;
        for(; x.s && ++i < args.length;)x = x.plus(args[i]);
        external = true;
        return finalise(x, this.precision, this.rounding);
    }
    /*
   * Return a new Decimal whose value is the tangent of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function tan(x) {
        return new this(x).tan();
    }
    /*
   * Return a new Decimal whose value is the hyperbolic tangent of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function tanh(x) {
        return new this(x).tanh();
    }
    /*
   * Return a new Decimal whose value is `x` truncated to an integer.
   *
   * x {number|string|Decimal}
   *
   */ function trunc(x) {
        return finalise(x = new this(x), x.e + 1, 1);
    }
    // Create and configure initial Decimal constructor.
    Decimal = clone(DEFAULTS);
    Decimal.prototype.constructor = Decimal;
    Decimal["default"] = Decimal.Decimal = Decimal;
    // Create the internal constants from their string values.
    LN10 = new Decimal(LN10);
    PI = new Decimal(PI);
    // Export.
    // AMD.
    if (typeof define == "function" && define.amd) define(function() {
        return Decimal;
    });
    else if (0, module.exports) {
        if (typeof Symbol == "function" && typeof Symbol.iterator == "symbol") {
            P[Symbol["for"]("nodejs.util.inspect.custom")] = P.toString;
            P[Symbol.toStringTag] = "Decimal";
        }
        module.exports = Decimal;
    // Browser.
    } else {
        if (!globalScope) globalScope = typeof self != "undefined" && self && self.self == self ? self : window;
        noConflict = globalScope.Decimal;
        Decimal.noConflict = function() {
            globalScope.Decimal = noConflict;
            return Decimal;
        };
        globalScope.Decimal = Decimal;
    }
})(module.exports);

});

parcelRegister("1FN1V", function(module, exports) {
// A port of an algorithm by Johannes Baagøe <baagoe@baagoe.com>, 2010
// http://baagoe.com/en/RandomMusings/javascript/
// https://github.com/nquinlan/better-random-numbers-for-javascript-mirror
// Original work is under MIT license -
// Copyright (C) 2010 by Johannes Baagøe <baagoe@baagoe.org>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
(function(global, module1, define1) {
    function Alea(seed) {
        var me = this, mash = Mash();
        me.next = function() {
            var t = 2091639 * me.s0 + me.c * 2.3283064365386963e-10; // 2^-32
            me.s0 = me.s1;
            me.s1 = me.s2;
            return me.s2 = t - (me.c = t | 0);
        };
        // Apply the seeding algorithm from Baagoe.
        me.c = 1;
        me.s0 = mash(" ");
        me.s1 = mash(" ");
        me.s2 = mash(" ");
        me.s0 -= mash(seed);
        if (me.s0 < 0) me.s0 += 1;
        me.s1 -= mash(seed);
        if (me.s1 < 0) me.s1 += 1;
        me.s2 -= mash(seed);
        if (me.s2 < 0) me.s2 += 1;
        mash = null;
    }
    function copy(f, t) {
        t.c = f.c;
        t.s0 = f.s0;
        t.s1 = f.s1;
        t.s2 = f.s2;
        return t;
    }
    function impl(seed, opts) {
        var xg = new Alea(seed), state = opts && opts.state, prng = xg.next;
        prng.int32 = function() {
            return xg.next() * 0x100000000 | 0;
        };
        prng.double = function() {
            return prng() + (prng() * 0x200000 | 0) * 1.1102230246251565e-16; // 2^-53
        };
        prng.quick = prng;
        if (state) {
            if (typeof state == "object") copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    function Mash() {
        var n = 0xefc8249d;
        var mash = function(data) {
            data = String(data);
            for(var i = 0; i < data.length; i++){
                n += data.charCodeAt(i);
                var h = 0.02519603282416938 * n;
                n = h >>> 0;
                h -= n;
                h *= n;
                n = h >>> 0;
                h -= n;
                n += h * 0x100000000; // 2^32
            }
            return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
        };
        return mash;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.alea = impl;
})(this, module, typeof define == "function" && define // present with an AMD loader
);

});

parcelRegister("ckzGC", function(module, exports) {
// A Javascript implementaion of the "xor128" prng algorithm by
// George Marsaglia.  See http://www.jstatsoft.org/v08/i14/paper
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this, strseed = "";
        me.x = 0;
        me.y = 0;
        me.z = 0;
        me.w = 0;
        // Set up generator function.
        me.next = function() {
            var t = me.x ^ me.x << 11;
            me.x = me.y;
            me.y = me.z;
            me.z = me.w;
            return me.w ^= me.w >>> 19 ^ t ^ t >>> 8;
        };
        if (seed === (seed | 0)) // Integer seed.
        me.x = seed;
        else // String seed.
        strseed += seed;
        // Mix in string seed, then discard an initial batch of 64 values.
        for(var k = 0; k < strseed.length + 64; k++){
            me.x ^= strseed.charCodeAt(k) | 0;
            me.next();
        }
    }
    function copy(f, t) {
        t.x = f.x;
        t.y = f.y;
        t.z = f.z;
        t.w = f.w;
        return t;
    }
    function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (typeof state == "object") copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xor128 = impl;
})(this, module, typeof define == "function" && define // present with an AMD loader
);

});

parcelRegister("hjML1", function(module, exports) {
// A Javascript implementaion of the "xorwow" prng algorithm by
// George Marsaglia.  See http://www.jstatsoft.org/v08/i14/paper
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this, strseed = "";
        // Set up generator function.
        me.next = function() {
            var t = me.x ^ me.x >>> 2;
            me.x = me.y;
            me.y = me.z;
            me.z = me.w;
            me.w = me.v;
            return (me.d = me.d + 362437 | 0) + (me.v = me.v ^ me.v << 4 ^ (t ^ t << 1)) | 0;
        };
        me.x = 0;
        me.y = 0;
        me.z = 0;
        me.w = 0;
        me.v = 0;
        if (seed === (seed | 0)) // Integer seed.
        me.x = seed;
        else // String seed.
        strseed += seed;
        // Mix in string seed, then discard an initial batch of 64 values.
        for(var k = 0; k < strseed.length + 64; k++){
            me.x ^= strseed.charCodeAt(k) | 0;
            if (k == strseed.length) me.d = me.x << 10 ^ me.x >>> 4;
            me.next();
        }
    }
    function copy(f, t) {
        t.x = f.x;
        t.y = f.y;
        t.z = f.z;
        t.w = f.w;
        t.v = f.v;
        t.d = f.d;
        return t;
    }
    function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (typeof state == "object") copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xorwow = impl;
})(this, module, typeof define == "function" && define // present with an AMD loader
);

});

parcelRegister("1CTAg", function(module, exports) {
// A Javascript implementaion of the "xorshift7" algorithm by
// François Panneton and Pierre L'ecuyer:
// "On the Xorgshift Random Number Generators"
// http://saluc.engr.uconn.edu/refs/crypto/rng/panneton05onthexorshift.pdf
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this;
        // Set up generator function.
        me.next = function() {
            // Update xor generator.
            var X = me.x, i = me.i, t, v, w;
            t = X[i];
            t ^= t >>> 7;
            v = t ^ t << 24;
            t = X[i + 1 & 7];
            v ^= t ^ t >>> 10;
            t = X[i + 3 & 7];
            v ^= t ^ t >>> 3;
            t = X[i + 4 & 7];
            v ^= t ^ t << 7;
            t = X[i + 7 & 7];
            t = t ^ t << 13;
            v ^= t ^ t << 9;
            X[i] = v;
            me.i = i + 1 & 7;
            return v;
        };
        function init(me, seed) {
            var j, w, X = [];
            if (seed === (seed | 0)) // Seed state array using a 32-bit integer.
            w = X[0] = seed;
            else {
                // Seed state using a string.
                seed = "" + seed;
                for(j = 0; j < seed.length; ++j)X[j & 7] = X[j & 7] << 15 ^ seed.charCodeAt(j) + X[j + 1 & 7] << 13;
            }
            // Enforce an array length of 8, not all zeroes.
            while(X.length < 8)X.push(0);
            for(j = 0; j < 8 && X[j] === 0; ++j);
            if (j == 8) w = X[7] = -1;
            else w = X[j];
            me.x = X;
            me.i = 0;
            // Discard an initial 256 values.
            for(j = 256; j > 0; --j)me.next();
        }
        init(me, seed);
    }
    function copy(f, t) {
        t.x = f.x.slice();
        t.i = f.i;
        return t;
    }
    function impl(seed, opts) {
        if (seed == null) seed = +new Date;
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (state.x) copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xorshift7 = impl;
})(this, module, typeof define == "function" && define // present with an AMD loader
);

});

parcelRegister("iBClV", function(module, exports) {
// A Javascript implementaion of Richard Brent's Xorgens xor4096 algorithm.
//
// This fast non-cryptographic random number generator is designed for
// use in Monte-Carlo algorithms. It combines a long-period xorshift
// generator with a Weyl generator, and it passes all common batteries
// of stasticial tests for randomness while consuming only a few nanoseconds
// for each prng generated.  For background on the generator, see Brent's
// paper: "Some long-period random number generators using shifts and xors."
// http://arxiv.org/pdf/1004.3115v1.pdf
//
// Usage:
//
// var xor4096 = require('xor4096');
// random = xor4096(1);                        // Seed with int32 or string.
// assert.equal(random(), 0.1520436450538547); // (0, 1) range, 53 bits.
// assert.equal(random.int32(), 1806534897);   // signed int32, 32 bits.
//
// For nonzero numeric keys, this impelementation provides a sequence
// identical to that by Brent's xorgens 3 implementaion in C.  This
// implementation also provides for initalizing the generator with
// string seeds, or for saving and restoring the state of the generator.
//
// On Chrome, this prng benchmarks about 2.1 times slower than
// Javascript's built-in Math.random().
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this;
        // Set up generator function.
        me.next = function() {
            var w = me.w, X = me.X, i = me.i, t, v;
            // Update Weyl generator.
            me.w = w = w + 0x61c88647 | 0;
            // Update xor generator.
            v = X[i + 34 & 127];
            t = X[i = i + 1 & 127];
            v ^= v << 13;
            t ^= t << 17;
            v ^= v >>> 15;
            t ^= t >>> 12;
            // Update Xor generator array state.
            v = X[i] = v ^ t;
            me.i = i;
            // Result is the combination.
            return v + (w ^ w >>> 16) | 0;
        };
        function init(me, seed) {
            var t, v, i, j, w, X = [], limit = 128;
            if (seed === (seed | 0)) {
                // Numeric seeds initialize v, which is used to generates X.
                v = seed;
                seed = null;
            } else {
                // String seeds are mixed into v and X one character at a time.
                seed = seed + "\x00";
                v = 0;
                limit = Math.max(limit, seed.length);
            }
            // Initialize circular array and weyl value.
            for(i = 0, j = -32; j < limit; ++j){
                // Put the unicode characters into the array, and shuffle them.
                if (seed) v ^= seed.charCodeAt((j + 32) % seed.length);
                // After 32 shuffles, take v as the starting w value.
                if (j === 0) w = v;
                v ^= v << 10;
                v ^= v >>> 15;
                v ^= v << 4;
                v ^= v >>> 13;
                if (j >= 0) {
                    w = w + 0x61c88647 | 0; // Weyl.
                    t = X[j & 127] ^= v + w; // Combine xor and weyl to init array.
                    i = 0 == t ? i + 1 : 0; // Count zeroes.
                }
            }
            // We have detected all zeroes; make the key nonzero.
            if (i >= 128) X[(seed && seed.length || 0) & 127] = -1;
            // Run the generator 512 times to further mix the state before using it.
            // Factoring this as a function slows the main generator, so it is just
            // unrolled here.  The weyl generator is not advanced while warming up.
            i = 127;
            for(j = 512; j > 0; --j){
                v = X[i + 34 & 127];
                t = X[i = i + 1 & 127];
                v ^= v << 13;
                t ^= t << 17;
                v ^= v >>> 15;
                t ^= t >>> 12;
                X[i] = v ^ t;
            }
            // Storing state as object members is faster than using closure variables.
            me.w = w;
            me.X = X;
            me.i = i;
        }
        init(me, seed);
    }
    function copy(f, t) {
        t.i = f.i;
        t.w = f.w;
        t.X = f.X.slice();
        return t;
    }
    function impl(seed, opts) {
        if (seed == null) seed = +new Date;
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (state.X) copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xor4096 = impl;
})(this, module, typeof define == "function" && define // present with an AMD loader
);

});

parcelRegister("cuVEv", function(module, exports) {
// A Javascript implementaion of the "Tyche-i" prng algorithm by
// Samuel Neves and Filipe Araujo.
// See https://eden.dei.uc.pt/~sneves/pubs/2011-snfa2.pdf
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this, strseed = "";
        // Set up generator function.
        me.next = function() {
            var b = me.b, c = me.c, d = me.d, a = me.a;
            b = b << 25 ^ b >>> 7 ^ c;
            c = c - d | 0;
            d = d << 24 ^ d >>> 8 ^ a;
            a = a - b | 0;
            me.b = b = b << 20 ^ b >>> 12 ^ c;
            me.c = c = c - d | 0;
            me.d = d << 16 ^ c >>> 16 ^ a;
            return me.a = a - b | 0;
        };
        /* The following is non-inverted tyche, which has better internal
   * bit diffusion, but which is about 25% slower than tyche-i in JS.
  me.next = function() {
    var a = me.a, b = me.b, c = me.c, d = me.d;
    a = (me.a + me.b | 0) >>> 0;
    d = me.d ^ a; d = d << 16 ^ d >>> 16;
    c = me.c + d | 0;
    b = me.b ^ c; b = b << 12 ^ d >>> 20;
    me.a = a = a + b | 0;
    d = d ^ a; me.d = d = d << 8 ^ d >>> 24;
    me.c = c = c + d | 0;
    b = b ^ c;
    return me.b = (b << 7 ^ b >>> 25);
  }
  */ me.a = 0;
        me.b = 0;
        me.c = -1640531527;
        me.d = 1367130551;
        if (seed === Math.floor(seed)) {
            // Integer seed.
            me.a = seed / 0x100000000 | 0;
            me.b = seed | 0;
        } else // String seed.
        strseed += seed;
        // Mix in string seed, then discard an initial batch of 64 values.
        for(var k = 0; k < strseed.length + 20; k++){
            me.b ^= strseed.charCodeAt(k) | 0;
            me.next();
        }
    }
    function copy(f, t) {
        t.a = f.a;
        t.b = f.b;
        t.c = f.c;
        t.d = f.d;
        return t;
    }
    function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (typeof state == "object") copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.tychei = impl;
})(this, module, typeof define == "function" && define // present with an AMD loader
);

});

parcelRegister("aqbQf", function(module, exports) {
"use strict";

});

parcelRegister("jlWHo", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("aqbQf")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("9A55m", function(module, exports) {
module.exports = $6f9b6bb9e2148035$var$Long;
/**
 * wasm optimizations, to do native i64 multiplication and divide
 */ var $6f9b6bb9e2148035$var$wasm = null;
try {
    $6f9b6bb9e2148035$var$wasm = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([
        0,
        97,
        115,
        109,
        1,
        0,
        0,
        0,
        1,
        13,
        2,
        96,
        0,
        1,
        127,
        96,
        4,
        127,
        127,
        127,
        127,
        1,
        127,
        3,
        7,
        6,
        0,
        1,
        1,
        1,
        1,
        1,
        6,
        6,
        1,
        127,
        1,
        65,
        0,
        11,
        7,
        50,
        6,
        3,
        109,
        117,
        108,
        0,
        1,
        5,
        100,
        105,
        118,
        95,
        115,
        0,
        2,
        5,
        100,
        105,
        118,
        95,
        117,
        0,
        3,
        5,
        114,
        101,
        109,
        95,
        115,
        0,
        4,
        5,
        114,
        101,
        109,
        95,
        117,
        0,
        5,
        8,
        103,
        101,
        116,
        95,
        104,
        105,
        103,
        104,
        0,
        0,
        10,
        191,
        1,
        6,
        4,
        0,
        35,
        0,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        126,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        127,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        128,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        129,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        130,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11
    ])), {}).exports;
} catch (e) {
// no wasm support :(
}
/**
 * Constructs a 64 bit two's-complement integer, given its low and high 32 bit values as *signed* integers.
 *  See the from* functions below for more convenient ways of constructing Longs.
 * @exports Long
 * @class A Long class for representing a 64 bit two's-complement integer value.
 * @param {number} low The low (signed) 32 bits of the long
 * @param {number} high The high (signed) 32 bits of the long
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @constructor
 */ function $6f9b6bb9e2148035$var$Long(low, high, unsigned) {
    /**
     * The low 32 bits as a signed value.
     * @type {number}
     */ this.low = low | 0;
    /**
     * The high 32 bits as a signed value.
     * @type {number}
     */ this.high = high | 0;
    /**
     * Whether unsigned or not.
     * @type {boolean}
     */ this.unsigned = !!unsigned;
}
// The internal representation of a long is the two given signed, 32-bit values.
// We use 32-bit pieces because these are the size of integers on which
// Javascript performs bit-operations.  For operations like addition and
// multiplication, we split each number into 16 bit pieces, which can easily be
// multiplied within Javascript's floating-point representation without overflow
// or change in sign.
//
// In the algorithms below, we frequently reduce the negative case to the
// positive case by negating the input(s) and then post-processing the result.
// Note that we must ALWAYS check specially whether those values are MIN_VALUE
// (-2^63) because -MIN_VALUE == MIN_VALUE (since 2^63 cannot be represented as
// a positive number, it overflows back into a negative).  Not handling this
// case would often result in infinite recursion.
//
// Common constant values ZERO, ONE, NEG_ONE, etc. are defined below the from*
// methods on which they depend.
/**
 * An indicator used to reliably determine if an object is a Long or not.
 * @type {boolean}
 * @const
 * @private
 */ $6f9b6bb9e2148035$var$Long.prototype.__isLong__;
Object.defineProperty($6f9b6bb9e2148035$var$Long.prototype, "__isLong__", {
    value: true
});
/**
 * @function
 * @param {*} obj Object
 * @returns {boolean}
 * @inner
 */ function $6f9b6bb9e2148035$var$isLong(obj) {
    return (obj && obj["__isLong__"]) === true;
}
/**
 * Tests if the specified object is a Long.
 * @function
 * @param {*} obj Object
 * @returns {boolean}
 */ $6f9b6bb9e2148035$var$Long.isLong = $6f9b6bb9e2148035$var$isLong;
/**
 * A cache of the Long representations of small integer values.
 * @type {!Object}
 * @inner
 */ var $6f9b6bb9e2148035$var$INT_CACHE = {};
/**
 * A cache of the Long representations of small unsigned integer values.
 * @type {!Object}
 * @inner
 */ var $6f9b6bb9e2148035$var$UINT_CACHE = {};
/**
 * @param {number} value
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $6f9b6bb9e2148035$var$fromInt(value, unsigned) {
    var obj, cachedObj, cache;
    if (unsigned) {
        value >>>= 0;
        if (cache = 0 <= value && value < 256) {
            cachedObj = $6f9b6bb9e2148035$var$UINT_CACHE[value];
            if (cachedObj) return cachedObj;
        }
        obj = $6f9b6bb9e2148035$var$fromBits(value, (value | 0) < 0 ? -1 : 0, true);
        if (cache) $6f9b6bb9e2148035$var$UINT_CACHE[value] = obj;
        return obj;
    } else {
        value |= 0;
        if (cache = -128 <= value && value < 128) {
            cachedObj = $6f9b6bb9e2148035$var$INT_CACHE[value];
            if (cachedObj) return cachedObj;
        }
        obj = $6f9b6bb9e2148035$var$fromBits(value, value < 0 ? -1 : 0, false);
        if (cache) $6f9b6bb9e2148035$var$INT_CACHE[value] = obj;
        return obj;
    }
}
/**
 * Returns a Long representing the given 32 bit integer value.
 * @function
 * @param {number} value The 32 bit integer in question
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $6f9b6bb9e2148035$var$Long.fromInt = $6f9b6bb9e2148035$var$fromInt;
/**
 * @param {number} value
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $6f9b6bb9e2148035$var$fromNumber(value, unsigned) {
    if (isNaN(value)) return unsigned ? $6f9b6bb9e2148035$var$UZERO : $6f9b6bb9e2148035$var$ZERO;
    if (unsigned) {
        if (value < 0) return $6f9b6bb9e2148035$var$UZERO;
        if (value >= $6f9b6bb9e2148035$var$TWO_PWR_64_DBL) return $6f9b6bb9e2148035$var$MAX_UNSIGNED_VALUE;
    } else {
        if (value <= -$6f9b6bb9e2148035$var$TWO_PWR_63_DBL) return $6f9b6bb9e2148035$var$MIN_VALUE;
        if (value + 1 >= $6f9b6bb9e2148035$var$TWO_PWR_63_DBL) return $6f9b6bb9e2148035$var$MAX_VALUE;
    }
    if (value < 0) return $6f9b6bb9e2148035$var$fromNumber(-value, unsigned).neg();
    return $6f9b6bb9e2148035$var$fromBits(value % $6f9b6bb9e2148035$var$TWO_PWR_32_DBL | 0, value / $6f9b6bb9e2148035$var$TWO_PWR_32_DBL | 0, unsigned);
}
/**
 * Returns a Long representing the given value, provided that it is a finite number. Otherwise, zero is returned.
 * @function
 * @param {number} value The number in question
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $6f9b6bb9e2148035$var$Long.fromNumber = $6f9b6bb9e2148035$var$fromNumber;
/**
 * @param {number} lowBits
 * @param {number} highBits
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $6f9b6bb9e2148035$var$fromBits(lowBits, highBits, unsigned) {
    return new $6f9b6bb9e2148035$var$Long(lowBits, highBits, unsigned);
}
/**
 * Returns a Long representing the 64 bit integer that comes by concatenating the given low and high bits. Each is
 *  assumed to use 32 bits.
 * @function
 * @param {number} lowBits The low 32 bits
 * @param {number} highBits The high 32 bits
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $6f9b6bb9e2148035$var$Long.fromBits = $6f9b6bb9e2148035$var$fromBits;
/**
 * @function
 * @param {number} base
 * @param {number} exponent
 * @returns {number}
 * @inner
 */ var $6f9b6bb9e2148035$var$pow_dbl = Math.pow; // Used 4 times (4*8 to 15+4)
/**
 * @param {string} str
 * @param {(boolean|number)=} unsigned
 * @param {number=} radix
 * @returns {!Long}
 * @inner
 */ function $6f9b6bb9e2148035$var$fromString(str, unsigned, radix) {
    if (str.length === 0) throw Error("empty string");
    if (str === "NaN" || str === "Infinity" || str === "+Infinity" || str === "-Infinity") return $6f9b6bb9e2148035$var$ZERO;
    if (typeof unsigned === "number") // For goog.math.long compatibility
    radix = unsigned, unsigned = false;
    else unsigned = !!unsigned;
    radix = radix || 10;
    if (radix < 2 || 36 < radix) throw RangeError("radix");
    var p;
    if ((p = str.indexOf("-")) > 0) throw Error("interior hyphen");
    else if (p === 0) return $6f9b6bb9e2148035$var$fromString(str.substring(1), unsigned, radix).neg();
    // Do several (8) digits each time through the loop, so as to
    // minimize the calls to the very expensive emulated div.
    var radixToPower = $6f9b6bb9e2148035$var$fromNumber($6f9b6bb9e2148035$var$pow_dbl(radix, 8));
    var result = $6f9b6bb9e2148035$var$ZERO;
    for(var i = 0; i < str.length; i += 8){
        var size = Math.min(8, str.length - i), value = parseInt(str.substring(i, i + size), radix);
        if (size < 8) {
            var power = $6f9b6bb9e2148035$var$fromNumber($6f9b6bb9e2148035$var$pow_dbl(radix, size));
            result = result.mul(power).add($6f9b6bb9e2148035$var$fromNumber(value));
        } else {
            result = result.mul(radixToPower);
            result = result.add($6f9b6bb9e2148035$var$fromNumber(value));
        }
    }
    result.unsigned = unsigned;
    return result;
}
/**
 * Returns a Long representation of the given string, written using the specified radix.
 * @function
 * @param {string} str The textual representation of the Long
 * @param {(boolean|number)=} unsigned Whether unsigned or not, defaults to signed
 * @param {number=} radix The radix in which the text is written (2-36), defaults to 10
 * @returns {!Long} The corresponding Long value
 */ $6f9b6bb9e2148035$var$Long.fromString = $6f9b6bb9e2148035$var$fromString;
/**
 * @function
 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $6f9b6bb9e2148035$var$fromValue(val, unsigned) {
    if (typeof val === "number") return $6f9b6bb9e2148035$var$fromNumber(val, unsigned);
    if (typeof val === "string") return $6f9b6bb9e2148035$var$fromString(val, unsigned);
    // Throws for non-objects, converts non-instanceof Long:
    return $6f9b6bb9e2148035$var$fromBits(val.low, val.high, typeof unsigned === "boolean" ? unsigned : val.unsigned);
}
/**
 * Converts the specified value to a Long using the appropriate from* function for its type.
 * @function
 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val Value
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long}
 */ $6f9b6bb9e2148035$var$Long.fromValue = $6f9b6bb9e2148035$var$fromValue;
// NOTE: the compiler should inline these constant values below and then remove these variables, so there should be
// no runtime penalty for these.
/**
 * @type {number}
 * @const
 * @inner
 */ var $6f9b6bb9e2148035$var$TWO_PWR_16_DBL = 65536;
/**
 * @type {number}
 * @const
 * @inner
 */ var $6f9b6bb9e2148035$var$TWO_PWR_24_DBL = 16777216;
/**
 * @type {number}
 * @const
 * @inner
 */ var $6f9b6bb9e2148035$var$TWO_PWR_32_DBL = $6f9b6bb9e2148035$var$TWO_PWR_16_DBL * $6f9b6bb9e2148035$var$TWO_PWR_16_DBL;
/**
 * @type {number}
 * @const
 * @inner
 */ var $6f9b6bb9e2148035$var$TWO_PWR_64_DBL = $6f9b6bb9e2148035$var$TWO_PWR_32_DBL * $6f9b6bb9e2148035$var$TWO_PWR_32_DBL;
/**
 * @type {number}
 * @const
 * @inner
 */ var $6f9b6bb9e2148035$var$TWO_PWR_63_DBL = $6f9b6bb9e2148035$var$TWO_PWR_64_DBL / 2;
/**
 * @type {!Long}
 * @const
 * @inner
 */ var $6f9b6bb9e2148035$var$TWO_PWR_24 = $6f9b6bb9e2148035$var$fromInt($6f9b6bb9e2148035$var$TWO_PWR_24_DBL);
/**
 * @type {!Long}
 * @inner
 */ var $6f9b6bb9e2148035$var$ZERO = $6f9b6bb9e2148035$var$fromInt(0);
/**
 * Signed zero.
 * @type {!Long}
 */ $6f9b6bb9e2148035$var$Long.ZERO = $6f9b6bb9e2148035$var$ZERO;
/**
 * @type {!Long}
 * @inner
 */ var $6f9b6bb9e2148035$var$UZERO = $6f9b6bb9e2148035$var$fromInt(0, true);
/**
 * Unsigned zero.
 * @type {!Long}
 */ $6f9b6bb9e2148035$var$Long.UZERO = $6f9b6bb9e2148035$var$UZERO;
/**
 * @type {!Long}
 * @inner
 */ var $6f9b6bb9e2148035$var$ONE = $6f9b6bb9e2148035$var$fromInt(1);
/**
 * Signed one.
 * @type {!Long}
 */ $6f9b6bb9e2148035$var$Long.ONE = $6f9b6bb9e2148035$var$ONE;
/**
 * @type {!Long}
 * @inner
 */ var $6f9b6bb9e2148035$var$UONE = $6f9b6bb9e2148035$var$fromInt(1, true);
/**
 * Unsigned one.
 * @type {!Long}
 */ $6f9b6bb9e2148035$var$Long.UONE = $6f9b6bb9e2148035$var$UONE;
/**
 * @type {!Long}
 * @inner
 */ var $6f9b6bb9e2148035$var$NEG_ONE = $6f9b6bb9e2148035$var$fromInt(-1);
/**
 * Signed negative one.
 * @type {!Long}
 */ $6f9b6bb9e2148035$var$Long.NEG_ONE = $6f9b6bb9e2148035$var$NEG_ONE;
/**
 * @type {!Long}
 * @inner
 */ var $6f9b6bb9e2148035$var$MAX_VALUE = $6f9b6bb9e2148035$var$fromBits(-1, 2147483647, false);
/**
 * Maximum signed value.
 * @type {!Long}
 */ $6f9b6bb9e2148035$var$Long.MAX_VALUE = $6f9b6bb9e2148035$var$MAX_VALUE;
/**
 * @type {!Long}
 * @inner
 */ var $6f9b6bb9e2148035$var$MAX_UNSIGNED_VALUE = $6f9b6bb9e2148035$var$fromBits(-1, -1, true);
/**
 * Maximum unsigned value.
 * @type {!Long}
 */ $6f9b6bb9e2148035$var$Long.MAX_UNSIGNED_VALUE = $6f9b6bb9e2148035$var$MAX_UNSIGNED_VALUE;
/**
 * @type {!Long}
 * @inner
 */ var $6f9b6bb9e2148035$var$MIN_VALUE = $6f9b6bb9e2148035$var$fromBits(0, -2147483648, false);
/**
 * Minimum signed value.
 * @type {!Long}
 */ $6f9b6bb9e2148035$var$Long.MIN_VALUE = $6f9b6bb9e2148035$var$MIN_VALUE;
/**
 * @alias Long.prototype
 * @inner
 */ var $6f9b6bb9e2148035$var$LongPrototype = $6f9b6bb9e2148035$var$Long.prototype;
/**
 * Converts the Long to a 32 bit integer, assuming it is a 32 bit integer.
 * @returns {number}
 */ $6f9b6bb9e2148035$var$LongPrototype.toInt = function toInt() {
    return this.unsigned ? this.low >>> 0 : this.low;
};
/**
 * Converts the Long to a the nearest floating-point representation of this value (double, 53 bit mantissa).
 * @returns {number}
 */ $6f9b6bb9e2148035$var$LongPrototype.toNumber = function toNumber() {
    if (this.unsigned) return (this.high >>> 0) * $6f9b6bb9e2148035$var$TWO_PWR_32_DBL + (this.low >>> 0);
    return this.high * $6f9b6bb9e2148035$var$TWO_PWR_32_DBL + (this.low >>> 0);
};
/**
 * Converts the Long to a string written in the specified radix.
 * @param {number=} radix Radix (2-36), defaults to 10
 * @returns {string}
 * @override
 * @throws {RangeError} If `radix` is out of range
 */ $6f9b6bb9e2148035$var$LongPrototype.toString = function toString(radix) {
    radix = radix || 10;
    if (radix < 2 || 36 < radix) throw RangeError("radix");
    if (this.isZero()) return "0";
    if (this.isNegative()) {
        if (this.eq($6f9b6bb9e2148035$var$MIN_VALUE)) {
            // We need to change the Long value before it can be negated, so we remove
            // the bottom-most digit in this base and then recurse to do the rest.
            var radixLong = $6f9b6bb9e2148035$var$fromNumber(radix), div = this.div(radixLong), rem1 = div.mul(radixLong).sub(this);
            return div.toString(radix) + rem1.toInt().toString(radix);
        } else return "-" + this.neg().toString(radix);
    }
    // Do several (6) digits each time through the loop, so as to
    // minimize the calls to the very expensive emulated div.
    var radixToPower = $6f9b6bb9e2148035$var$fromNumber($6f9b6bb9e2148035$var$pow_dbl(radix, 6), this.unsigned), rem = this;
    var result = "";
    while(true){
        var remDiv = rem.div(radixToPower), intval = rem.sub(remDiv.mul(radixToPower)).toInt() >>> 0, digits = intval.toString(radix);
        rem = remDiv;
        if (rem.isZero()) return digits + result;
        else {
            while(digits.length < 6)digits = "0" + digits;
            result = "" + digits + result;
        }
    }
};
/**
 * Gets the high 32 bits as a signed integer.
 * @returns {number} Signed high bits
 */ $6f9b6bb9e2148035$var$LongPrototype.getHighBits = function getHighBits() {
    return this.high;
};
/**
 * Gets the high 32 bits as an unsigned integer.
 * @returns {number} Unsigned high bits
 */ $6f9b6bb9e2148035$var$LongPrototype.getHighBitsUnsigned = function getHighBitsUnsigned() {
    return this.high >>> 0;
};
/**
 * Gets the low 32 bits as a signed integer.
 * @returns {number} Signed low bits
 */ $6f9b6bb9e2148035$var$LongPrototype.getLowBits = function getLowBits() {
    return this.low;
};
/**
 * Gets the low 32 bits as an unsigned integer.
 * @returns {number} Unsigned low bits
 */ $6f9b6bb9e2148035$var$LongPrototype.getLowBitsUnsigned = function getLowBitsUnsigned() {
    return this.low >>> 0;
};
/**
 * Gets the number of bits needed to represent the absolute value of this Long.
 * @returns {number}
 */ $6f9b6bb9e2148035$var$LongPrototype.getNumBitsAbs = function getNumBitsAbs() {
    if (this.isNegative()) return this.eq($6f9b6bb9e2148035$var$MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();
    var val = this.high != 0 ? this.high : this.low;
    for(var bit = 31; bit > 0; bit--)if ((val & 1 << bit) != 0) break;
    return this.high != 0 ? bit + 33 : bit + 1;
};
/**
 * Tests if this Long's value equals zero.
 * @returns {boolean}
 */ $6f9b6bb9e2148035$var$LongPrototype.isZero = function isZero() {
    return this.high === 0 && this.low === 0;
};
/**
 * Tests if this Long's value equals zero. This is an alias of {@link Long#isZero}.
 * @returns {boolean}
 */ $6f9b6bb9e2148035$var$LongPrototype.eqz = $6f9b6bb9e2148035$var$LongPrototype.isZero;
/**
 * Tests if this Long's value is negative.
 * @returns {boolean}
 */ $6f9b6bb9e2148035$var$LongPrototype.isNegative = function isNegative() {
    return !this.unsigned && this.high < 0;
};
/**
 * Tests if this Long's value is positive.
 * @returns {boolean}
 */ $6f9b6bb9e2148035$var$LongPrototype.isPositive = function isPositive() {
    return this.unsigned || this.high >= 0;
};
/**
 * Tests if this Long's value is odd.
 * @returns {boolean}
 */ $6f9b6bb9e2148035$var$LongPrototype.isOdd = function isOdd() {
    return (this.low & 1) === 1;
};
/**
 * Tests if this Long's value is even.
 * @returns {boolean}
 */ $6f9b6bb9e2148035$var$LongPrototype.isEven = function isEven() {
    return (this.low & 1) === 0;
};
/**
 * Tests if this Long's value equals the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $6f9b6bb9e2148035$var$LongPrototype.equals = function equals(other) {
    if (!$6f9b6bb9e2148035$var$isLong(other)) other = $6f9b6bb9e2148035$var$fromValue(other);
    if (this.unsigned !== other.unsigned && this.high >>> 31 === 1 && other.high >>> 31 === 1) return false;
    return this.high === other.high && this.low === other.low;
};
/**
 * Tests if this Long's value equals the specified's. This is an alias of {@link Long#equals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $6f9b6bb9e2148035$var$LongPrototype.eq = $6f9b6bb9e2148035$var$LongPrototype.equals;
/**
 * Tests if this Long's value differs from the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $6f9b6bb9e2148035$var$LongPrototype.notEquals = function notEquals(other) {
    return !this.eq(/* validates */ other);
};
/**
 * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $6f9b6bb9e2148035$var$LongPrototype.neq = $6f9b6bb9e2148035$var$LongPrototype.notEquals;
/**
 * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $6f9b6bb9e2148035$var$LongPrototype.ne = $6f9b6bb9e2148035$var$LongPrototype.notEquals;
/**
 * Tests if this Long's value is less than the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $6f9b6bb9e2148035$var$LongPrototype.lessThan = function lessThan(other) {
    return this.comp(/* validates */ other) < 0;
};
/**
 * Tests if this Long's value is less than the specified's. This is an alias of {@link Long#lessThan}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $6f9b6bb9e2148035$var$LongPrototype.lt = $6f9b6bb9e2148035$var$LongPrototype.lessThan;
/**
 * Tests if this Long's value is less than or equal the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $6f9b6bb9e2148035$var$LongPrototype.lessThanOrEqual = function lessThanOrEqual(other) {
    return this.comp(/* validates */ other) <= 0;
};
/**
 * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $6f9b6bb9e2148035$var$LongPrototype.lte = $6f9b6bb9e2148035$var$LongPrototype.lessThanOrEqual;
/**
 * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $6f9b6bb9e2148035$var$LongPrototype.le = $6f9b6bb9e2148035$var$LongPrototype.lessThanOrEqual;
/**
 * Tests if this Long's value is greater than the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $6f9b6bb9e2148035$var$LongPrototype.greaterThan = function greaterThan(other) {
    return this.comp(/* validates */ other) > 0;
};
/**
 * Tests if this Long's value is greater than the specified's. This is an alias of {@link Long#greaterThan}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $6f9b6bb9e2148035$var$LongPrototype.gt = $6f9b6bb9e2148035$var$LongPrototype.greaterThan;
/**
 * Tests if this Long's value is greater than or equal the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $6f9b6bb9e2148035$var$LongPrototype.greaterThanOrEqual = function greaterThanOrEqual(other) {
    return this.comp(/* validates */ other) >= 0;
};
/**
 * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $6f9b6bb9e2148035$var$LongPrototype.gte = $6f9b6bb9e2148035$var$LongPrototype.greaterThanOrEqual;
/**
 * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $6f9b6bb9e2148035$var$LongPrototype.ge = $6f9b6bb9e2148035$var$LongPrototype.greaterThanOrEqual;
/**
 * Compares this Long's value with the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {number} 0 if they are the same, 1 if the this is greater and -1
 *  if the given one is greater
 */ $6f9b6bb9e2148035$var$LongPrototype.compare = function compare(other) {
    if (!$6f9b6bb9e2148035$var$isLong(other)) other = $6f9b6bb9e2148035$var$fromValue(other);
    if (this.eq(other)) return 0;
    var thisNeg = this.isNegative(), otherNeg = other.isNegative();
    if (thisNeg && !otherNeg) return -1;
    if (!thisNeg && otherNeg) return 1;
    // At this point the sign bits are the same
    if (!this.unsigned) return this.sub(other).isNegative() ? -1 : 1;
    // Both are positive if at least one is unsigned
    return other.high >>> 0 > this.high >>> 0 || other.high === this.high && other.low >>> 0 > this.low >>> 0 ? -1 : 1;
};
/**
 * Compares this Long's value with the specified's. This is an alias of {@link Long#compare}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {number} 0 if they are the same, 1 if the this is greater and -1
 *  if the given one is greater
 */ $6f9b6bb9e2148035$var$LongPrototype.comp = $6f9b6bb9e2148035$var$LongPrototype.compare;
/**
 * Negates this Long's value.
 * @returns {!Long} Negated Long
 */ $6f9b6bb9e2148035$var$LongPrototype.negate = function negate() {
    if (!this.unsigned && this.eq($6f9b6bb9e2148035$var$MIN_VALUE)) return $6f9b6bb9e2148035$var$MIN_VALUE;
    return this.not().add($6f9b6bb9e2148035$var$ONE);
};
/**
 * Negates this Long's value. This is an alias of {@link Long#negate}.
 * @function
 * @returns {!Long} Negated Long
 */ $6f9b6bb9e2148035$var$LongPrototype.neg = $6f9b6bb9e2148035$var$LongPrototype.negate;
/**
 * Returns the sum of this and the specified Long.
 * @param {!Long|number|string} addend Addend
 * @returns {!Long} Sum
 */ $6f9b6bb9e2148035$var$LongPrototype.add = function add(addend) {
    if (!$6f9b6bb9e2148035$var$isLong(addend)) addend = $6f9b6bb9e2148035$var$fromValue(addend);
    // Divide each number into 4 chunks of 16 bits, and then sum the chunks.
    var a48 = this.high >>> 16;
    var a32 = this.high & 0xFFFF;
    var a16 = this.low >>> 16;
    var a00 = this.low & 0xFFFF;
    var b48 = addend.high >>> 16;
    var b32 = addend.high & 0xFFFF;
    var b16 = addend.low >>> 16;
    var b00 = addend.low & 0xFFFF;
    var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
    c00 += a00 + b00;
    c16 += c00 >>> 16;
    c00 &= 0xFFFF;
    c16 += a16 + b16;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c32 += a32 + b32;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c48 += a48 + b48;
    c48 &= 0xFFFF;
    return $6f9b6bb9e2148035$var$fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
};
/**
 * Returns the difference of this and the specified Long.
 * @param {!Long|number|string} subtrahend Subtrahend
 * @returns {!Long} Difference
 */ $6f9b6bb9e2148035$var$LongPrototype.subtract = function subtract(subtrahend) {
    if (!$6f9b6bb9e2148035$var$isLong(subtrahend)) subtrahend = $6f9b6bb9e2148035$var$fromValue(subtrahend);
    return this.add(subtrahend.neg());
};
/**
 * Returns the difference of this and the specified Long. This is an alias of {@link Long#subtract}.
 * @function
 * @param {!Long|number|string} subtrahend Subtrahend
 * @returns {!Long} Difference
 */ $6f9b6bb9e2148035$var$LongPrototype.sub = $6f9b6bb9e2148035$var$LongPrototype.subtract;
/**
 * Returns the product of this and the specified Long.
 * @param {!Long|number|string} multiplier Multiplier
 * @returns {!Long} Product
 */ $6f9b6bb9e2148035$var$LongPrototype.multiply = function multiply(multiplier) {
    if (this.isZero()) return $6f9b6bb9e2148035$var$ZERO;
    if (!$6f9b6bb9e2148035$var$isLong(multiplier)) multiplier = $6f9b6bb9e2148035$var$fromValue(multiplier);
    // use wasm support if present
    if ($6f9b6bb9e2148035$var$wasm) {
        var low = $6f9b6bb9e2148035$var$wasm.mul(this.low, this.high, multiplier.low, multiplier.high);
        return $6f9b6bb9e2148035$var$fromBits(low, $6f9b6bb9e2148035$var$wasm.get_high(), this.unsigned);
    }
    if (multiplier.isZero()) return $6f9b6bb9e2148035$var$ZERO;
    if (this.eq($6f9b6bb9e2148035$var$MIN_VALUE)) return multiplier.isOdd() ? $6f9b6bb9e2148035$var$MIN_VALUE : $6f9b6bb9e2148035$var$ZERO;
    if (multiplier.eq($6f9b6bb9e2148035$var$MIN_VALUE)) return this.isOdd() ? $6f9b6bb9e2148035$var$MIN_VALUE : $6f9b6bb9e2148035$var$ZERO;
    if (this.isNegative()) {
        if (multiplier.isNegative()) return this.neg().mul(multiplier.neg());
        else return this.neg().mul(multiplier).neg();
    } else if (multiplier.isNegative()) return this.mul(multiplier.neg()).neg();
    // If both longs are small, use float multiplication
    if (this.lt($6f9b6bb9e2148035$var$TWO_PWR_24) && multiplier.lt($6f9b6bb9e2148035$var$TWO_PWR_24)) return $6f9b6bb9e2148035$var$fromNumber(this.toNumber() * multiplier.toNumber(), this.unsigned);
    // Divide each long into 4 chunks of 16 bits, and then add up 4x4 products.
    // We can skip products that would overflow.
    var a48 = this.high >>> 16;
    var a32 = this.high & 0xFFFF;
    var a16 = this.low >>> 16;
    var a00 = this.low & 0xFFFF;
    var b48 = multiplier.high >>> 16;
    var b32 = multiplier.high & 0xFFFF;
    var b16 = multiplier.low >>> 16;
    var b00 = multiplier.low & 0xFFFF;
    var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
    c00 += a00 * b00;
    c16 += c00 >>> 16;
    c00 &= 0xFFFF;
    c16 += a16 * b00;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c16 += a00 * b16;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c32 += a32 * b00;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c32 += a16 * b16;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c32 += a00 * b32;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c48 += a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48;
    c48 &= 0xFFFF;
    return $6f9b6bb9e2148035$var$fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
};
/**
 * Returns the product of this and the specified Long. This is an alias of {@link Long#multiply}.
 * @function
 * @param {!Long|number|string} multiplier Multiplier
 * @returns {!Long} Product
 */ $6f9b6bb9e2148035$var$LongPrototype.mul = $6f9b6bb9e2148035$var$LongPrototype.multiply;
/**
 * Returns this Long divided by the specified. The result is signed if this Long is signed or
 *  unsigned if this Long is unsigned.
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Quotient
 */ $6f9b6bb9e2148035$var$LongPrototype.divide = function divide(divisor) {
    if (!$6f9b6bb9e2148035$var$isLong(divisor)) divisor = $6f9b6bb9e2148035$var$fromValue(divisor);
    if (divisor.isZero()) throw Error("division by zero");
    // use wasm support if present
    if ($6f9b6bb9e2148035$var$wasm) {
        // guard against signed division overflow: the largest
        // negative number / -1 would be 1 larger than the largest
        // positive number, due to two's complement.
        if (!this.unsigned && this.high === -2147483648 && divisor.low === -1 && divisor.high === -1) // be consistent with non-wasm code path
        return this;
        var low = (this.unsigned ? $6f9b6bb9e2148035$var$wasm.div_u : $6f9b6bb9e2148035$var$wasm.div_s)(this.low, this.high, divisor.low, divisor.high);
        return $6f9b6bb9e2148035$var$fromBits(low, $6f9b6bb9e2148035$var$wasm.get_high(), this.unsigned);
    }
    if (this.isZero()) return this.unsigned ? $6f9b6bb9e2148035$var$UZERO : $6f9b6bb9e2148035$var$ZERO;
    var approx, rem, res;
    if (!this.unsigned) {
        // This section is only relevant for signed longs and is derived from the
        // closure library as a whole.
        if (this.eq($6f9b6bb9e2148035$var$MIN_VALUE)) {
            if (divisor.eq($6f9b6bb9e2148035$var$ONE) || divisor.eq($6f9b6bb9e2148035$var$NEG_ONE)) return $6f9b6bb9e2148035$var$MIN_VALUE; // recall that -MIN_VALUE == MIN_VALUE
            else if (divisor.eq($6f9b6bb9e2148035$var$MIN_VALUE)) return $6f9b6bb9e2148035$var$ONE;
            else {
                // At this point, we have |other| >= 2, so |this/other| < |MIN_VALUE|.
                var halfThis = this.shr(1);
                approx = halfThis.div(divisor).shl(1);
                if (approx.eq($6f9b6bb9e2148035$var$ZERO)) return divisor.isNegative() ? $6f9b6bb9e2148035$var$ONE : $6f9b6bb9e2148035$var$NEG_ONE;
                else {
                    rem = this.sub(divisor.mul(approx));
                    res = approx.add(rem.div(divisor));
                    return res;
                }
            }
        } else if (divisor.eq($6f9b6bb9e2148035$var$MIN_VALUE)) return this.unsigned ? $6f9b6bb9e2148035$var$UZERO : $6f9b6bb9e2148035$var$ZERO;
        if (this.isNegative()) {
            if (divisor.isNegative()) return this.neg().div(divisor.neg());
            return this.neg().div(divisor).neg();
        } else if (divisor.isNegative()) return this.div(divisor.neg()).neg();
        res = $6f9b6bb9e2148035$var$ZERO;
    } else {
        // The algorithm below has not been made for unsigned longs. It's therefore
        // required to take special care of the MSB prior to running it.
        if (!divisor.unsigned) divisor = divisor.toUnsigned();
        if (divisor.gt(this)) return $6f9b6bb9e2148035$var$UZERO;
        if (divisor.gt(this.shru(1))) return $6f9b6bb9e2148035$var$UONE;
        res = $6f9b6bb9e2148035$var$UZERO;
    }
    // Repeat the following until the remainder is less than other:  find a
    // floating-point that approximates remainder / other *from below*, add this
    // into the result, and subtract it from the remainder.  It is critical that
    // the approximate value is less than or equal to the real value so that the
    // remainder never becomes negative.
    rem = this;
    while(rem.gte(divisor)){
        // Approximate the result of division. This may be a little greater or
        // smaller than the actual value.
        approx = Math.max(1, Math.floor(rem.toNumber() / divisor.toNumber()));
        // We will tweak the approximate result by changing it in the 48-th digit or
        // the smallest non-fractional digit, whichever is larger.
        var log2 = Math.ceil(Math.log(approx) / Math.LN2), delta = log2 <= 48 ? 1 : $6f9b6bb9e2148035$var$pow_dbl(2, log2 - 48), // Decrease the approximation until it is smaller than the remainder.  Note
        // that if it is too large, the product overflows and is negative.
        approxRes = $6f9b6bb9e2148035$var$fromNumber(approx), approxRem = approxRes.mul(divisor);
        while(approxRem.isNegative() || approxRem.gt(rem)){
            approx -= delta;
            approxRes = $6f9b6bb9e2148035$var$fromNumber(approx, this.unsigned);
            approxRem = approxRes.mul(divisor);
        }
        // We know the answer can't be zero... and actually, zero would cause
        // infinite recursion since we would make no progress.
        if (approxRes.isZero()) approxRes = $6f9b6bb9e2148035$var$ONE;
        res = res.add(approxRes);
        rem = rem.sub(approxRem);
    }
    return res;
};
/**
 * Returns this Long divided by the specified. This is an alias of {@link Long#divide}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Quotient
 */ $6f9b6bb9e2148035$var$LongPrototype.div = $6f9b6bb9e2148035$var$LongPrototype.divide;
/**
 * Returns this Long modulo the specified.
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $6f9b6bb9e2148035$var$LongPrototype.modulo = function modulo(divisor) {
    if (!$6f9b6bb9e2148035$var$isLong(divisor)) divisor = $6f9b6bb9e2148035$var$fromValue(divisor);
    // use wasm support if present
    if ($6f9b6bb9e2148035$var$wasm) {
        var low = (this.unsigned ? $6f9b6bb9e2148035$var$wasm.rem_u : $6f9b6bb9e2148035$var$wasm.rem_s)(this.low, this.high, divisor.low, divisor.high);
        return $6f9b6bb9e2148035$var$fromBits(low, $6f9b6bb9e2148035$var$wasm.get_high(), this.unsigned);
    }
    return this.sub(this.div(divisor).mul(divisor));
};
/**
 * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $6f9b6bb9e2148035$var$LongPrototype.mod = $6f9b6bb9e2148035$var$LongPrototype.modulo;
/**
 * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $6f9b6bb9e2148035$var$LongPrototype.rem = $6f9b6bb9e2148035$var$LongPrototype.modulo;
/**
 * Returns the bitwise NOT of this Long.
 * @returns {!Long}
 */ $6f9b6bb9e2148035$var$LongPrototype.not = function not() {
    return $6f9b6bb9e2148035$var$fromBits(~this.low, ~this.high, this.unsigned);
};
/**
 * Returns the bitwise AND of this Long and the specified.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $6f9b6bb9e2148035$var$LongPrototype.and = function and(other) {
    if (!$6f9b6bb9e2148035$var$isLong(other)) other = $6f9b6bb9e2148035$var$fromValue(other);
    return $6f9b6bb9e2148035$var$fromBits(this.low & other.low, this.high & other.high, this.unsigned);
};
/**
 * Returns the bitwise OR of this Long and the specified.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $6f9b6bb9e2148035$var$LongPrototype.or = function or(other) {
    if (!$6f9b6bb9e2148035$var$isLong(other)) other = $6f9b6bb9e2148035$var$fromValue(other);
    return $6f9b6bb9e2148035$var$fromBits(this.low | other.low, this.high | other.high, this.unsigned);
};
/**
 * Returns the bitwise XOR of this Long and the given one.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $6f9b6bb9e2148035$var$LongPrototype.xor = function xor(other) {
    if (!$6f9b6bb9e2148035$var$isLong(other)) other = $6f9b6bb9e2148035$var$fromValue(other);
    return $6f9b6bb9e2148035$var$fromBits(this.low ^ other.low, this.high ^ other.high, this.unsigned);
};
/**
 * Returns this Long with bits shifted to the left by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $6f9b6bb9e2148035$var$LongPrototype.shiftLeft = function shiftLeft(numBits) {
    if ($6f9b6bb9e2148035$var$isLong(numBits)) numBits = numBits.toInt();
    if ((numBits &= 63) === 0) return this;
    else if (numBits < 32) return $6f9b6bb9e2148035$var$fromBits(this.low << numBits, this.high << numBits | this.low >>> 32 - numBits, this.unsigned);
    else return $6f9b6bb9e2148035$var$fromBits(0, this.low << numBits - 32, this.unsigned);
};
/**
 * Returns this Long with bits shifted to the left by the given amount. This is an alias of {@link Long#shiftLeft}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $6f9b6bb9e2148035$var$LongPrototype.shl = $6f9b6bb9e2148035$var$LongPrototype.shiftLeft;
/**
 * Returns this Long with bits arithmetically shifted to the right by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $6f9b6bb9e2148035$var$LongPrototype.shiftRight = function shiftRight(numBits) {
    if ($6f9b6bb9e2148035$var$isLong(numBits)) numBits = numBits.toInt();
    if ((numBits &= 63) === 0) return this;
    else if (numBits < 32) return $6f9b6bb9e2148035$var$fromBits(this.low >>> numBits | this.high << 32 - numBits, this.high >> numBits, this.unsigned);
    else return $6f9b6bb9e2148035$var$fromBits(this.high >> numBits - 32, this.high >= 0 ? 0 : -1, this.unsigned);
};
/**
 * Returns this Long with bits arithmetically shifted to the right by the given amount. This is an alias of {@link Long#shiftRight}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $6f9b6bb9e2148035$var$LongPrototype.shr = $6f9b6bb9e2148035$var$LongPrototype.shiftRight;
/**
 * Returns this Long with bits logically shifted to the right by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $6f9b6bb9e2148035$var$LongPrototype.shiftRightUnsigned = function shiftRightUnsigned(numBits) {
    if ($6f9b6bb9e2148035$var$isLong(numBits)) numBits = numBits.toInt();
    numBits &= 63;
    if (numBits === 0) return this;
    else {
        var high = this.high;
        if (numBits < 32) {
            var low = this.low;
            return $6f9b6bb9e2148035$var$fromBits(low >>> numBits | high << 32 - numBits, high >>> numBits, this.unsigned);
        } else if (numBits === 32) return $6f9b6bb9e2148035$var$fromBits(high, 0, this.unsigned);
        else return $6f9b6bb9e2148035$var$fromBits(high >>> numBits - 32, 0, this.unsigned);
    }
};
/**
 * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $6f9b6bb9e2148035$var$LongPrototype.shru = $6f9b6bb9e2148035$var$LongPrototype.shiftRightUnsigned;
/**
 * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $6f9b6bb9e2148035$var$LongPrototype.shr_u = $6f9b6bb9e2148035$var$LongPrototype.shiftRightUnsigned;
/**
 * Converts this Long to signed.
 * @returns {!Long} Signed long
 */ $6f9b6bb9e2148035$var$LongPrototype.toSigned = function toSigned() {
    if (!this.unsigned) return this;
    return $6f9b6bb9e2148035$var$fromBits(this.low, this.high, false);
};
/**
 * Converts this Long to unsigned.
 * @returns {!Long} Unsigned long
 */ $6f9b6bb9e2148035$var$LongPrototype.toUnsigned = function toUnsigned() {
    if (this.unsigned) return this;
    return $6f9b6bb9e2148035$var$fromBits(this.low, this.high, true);
};
/**
 * Converts this Long to its byte representation.
 * @param {boolean=} le Whether little or big endian, defaults to big endian
 * @returns {!Array.<number>} Byte representation
 */ $6f9b6bb9e2148035$var$LongPrototype.toBytes = function toBytes(le) {
    return le ? this.toBytesLE() : this.toBytesBE();
};
/**
 * Converts this Long to its little endian byte representation.
 * @returns {!Array.<number>} Little endian byte representation
 */ $6f9b6bb9e2148035$var$LongPrototype.toBytesLE = function toBytesLE() {
    var hi = this.high, lo = this.low;
    return [
        lo & 0xff,
        lo >>> 8 & 0xff,
        lo >>> 16 & 0xff,
        lo >>> 24,
        hi & 0xff,
        hi >>> 8 & 0xff,
        hi >>> 16 & 0xff,
        hi >>> 24
    ];
};
/**
 * Converts this Long to its big endian byte representation.
 * @returns {!Array.<number>} Big endian byte representation
 */ $6f9b6bb9e2148035$var$LongPrototype.toBytesBE = function toBytesBE() {
    var hi = this.high, lo = this.low;
    return [
        hi >>> 24,
        hi >>> 16 & 0xff,
        hi >>> 8 & 0xff,
        hi & 0xff,
        lo >>> 24,
        lo >>> 16 & 0xff,
        lo >>> 8 & 0xff,
        lo & 0xff
    ];
};
/**
 * Creates a Long from its byte representation.
 * @param {!Array.<number>} bytes Byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @param {boolean=} le Whether little or big endian, defaults to big endian
 * @returns {Long} The corresponding Long value
 */ $6f9b6bb9e2148035$var$Long.fromBytes = function fromBytes(bytes, unsigned, le) {
    return le ? $6f9b6bb9e2148035$var$Long.fromBytesLE(bytes, unsigned) : $6f9b6bb9e2148035$var$Long.fromBytesBE(bytes, unsigned);
};
/**
 * Creates a Long from its little endian byte representation.
 * @param {!Array.<number>} bytes Little endian byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {Long} The corresponding Long value
 */ $6f9b6bb9e2148035$var$Long.fromBytesLE = function fromBytesLE(bytes, unsigned) {
    return new $6f9b6bb9e2148035$var$Long(bytes[0] | bytes[1] << 8 | bytes[2] << 16 | bytes[3] << 24, bytes[4] | bytes[5] << 8 | bytes[6] << 16 | bytes[7] << 24, unsigned);
};
/**
 * Creates a Long from its big endian byte representation.
 * @param {!Array.<number>} bytes Big endian byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {Long} The corresponding Long value
 */ $6f9b6bb9e2148035$var$Long.fromBytesBE = function fromBytesBE(bytes, unsigned) {
    return new $6f9b6bb9e2148035$var$Long(bytes[4] << 24 | bytes[5] << 16 | bytes[6] << 8 | bytes[7], bytes[0] << 24 | bytes[1] << 16 | bytes[2] << 8 | bytes[3], unsigned);
};

});

parcelRegister("i2pIU", function(module, exports) {
// minimal library entry point.
"use strict";

module.exports = (parcelRequire("aJEGQ"));

});
parcelRegister("aJEGQ", function(module, exports) {
"use strict";
var $7d0dab8a30b3b328$var$protobuf = module.exports;
/**
 * Build type, one of `"full"`, `"light"` or `"minimal"`.
 * @name build
 * @type {string}
 * @const
 */ $7d0dab8a30b3b328$var$protobuf.build = "minimal";

// Serialization
$7d0dab8a30b3b328$var$protobuf.Writer = (parcelRequire("UGYDC"));

$7d0dab8a30b3b328$var$protobuf.BufferWriter = (parcelRequire("1TRcz"));

$7d0dab8a30b3b328$var$protobuf.Reader = (parcelRequire("aAsQy"));

$7d0dab8a30b3b328$var$protobuf.BufferReader = (parcelRequire("50bs2"));

// Utility
$7d0dab8a30b3b328$var$protobuf.util = (parcelRequire("hZopo"));

$7d0dab8a30b3b328$var$protobuf.rpc = (parcelRequire("2Wwl8"));

$7d0dab8a30b3b328$var$protobuf.roots = (parcelRequire("fM1Ek"));
$7d0dab8a30b3b328$var$protobuf.configure = $7d0dab8a30b3b328$var$configure;
/* istanbul ignore next */ /**
 * Reconfigures the library according to the environment.
 * @returns {undefined}
 */ function $7d0dab8a30b3b328$var$configure() {
    $7d0dab8a30b3b328$var$protobuf.util._configure();
    $7d0dab8a30b3b328$var$protobuf.Writer._configure($7d0dab8a30b3b328$var$protobuf.BufferWriter);
    $7d0dab8a30b3b328$var$protobuf.Reader._configure($7d0dab8a30b3b328$var$protobuf.BufferReader);
}
// Set up buffer utility according to the environment
$7d0dab8a30b3b328$var$configure();

});
parcelRegister("UGYDC", function(module, exports) {
"use strict";
module.exports = $0aa6916bcba80353$var$Writer;

var $hZopo = parcelRequire("hZopo");
var $0aa6916bcba80353$var$BufferWriter; // cyclic
var $0aa6916bcba80353$var$LongBits = $hZopo.LongBits, $0aa6916bcba80353$var$base64 = $hZopo.base64, $0aa6916bcba80353$var$utf8 = $hZopo.utf8;
/**
 * Constructs a new writer operation instance.
 * @classdesc Scheduled writer operation.
 * @constructor
 * @param {function(*, Uint8Array, number)} fn Function to call
 * @param {number} len Value byte length
 * @param {*} val Value to write
 * @ignore
 */ function $0aa6916bcba80353$var$Op(fn, len, val) {
    /**
     * Function to call.
     * @type {function(Uint8Array, number, *)}
     */ this.fn = fn;
    /**
     * Value byte length.
     * @type {number}
     */ this.len = len;
    /**
     * Next operation.
     * @type {Writer.Op|undefined}
     */ this.next = undefined;
    /**
     * Value to write.
     * @type {*}
     */ this.val = val; // type varies
}
/* istanbul ignore next */ function $0aa6916bcba80353$var$noop() {} // eslint-disable-line no-empty-function
/**
 * Constructs a new writer state instance.
 * @classdesc Copied writer state.
 * @memberof Writer
 * @constructor
 * @param {Writer} writer Writer to copy state from
 * @ignore
 */ function $0aa6916bcba80353$var$State(writer) {
    /**
     * Current head.
     * @type {Writer.Op}
     */ this.head = writer.head;
    /**
     * Current tail.
     * @type {Writer.Op}
     */ this.tail = writer.tail;
    /**
     * Current buffer length.
     * @type {number}
     */ this.len = writer.len;
    /**
     * Next state.
     * @type {State|null}
     */ this.next = writer.states;
}
/**
 * Constructs a new writer instance.
 * @classdesc Wire format writer using `Uint8Array` if available, otherwise `Array`.
 * @constructor
 */ function $0aa6916bcba80353$var$Writer() {
    /**
     * Current length.
     * @type {number}
     */ this.len = 0;
    /**
     * Operations head.
     * @type {Object}
     */ this.head = new $0aa6916bcba80353$var$Op($0aa6916bcba80353$var$noop, 0, 0);
    /**
     * Operations tail
     * @type {Object}
     */ this.tail = this.head;
    /**
     * Linked forked states.
     * @type {Object|null}
     */ this.states = null;
// When a value is written, the writer calculates its byte length and puts it into a linked
// list of operations to perform when finish() is called. This both allows us to allocate
// buffers of the exact required size and reduces the amount of work we have to do compared
// to first calculating over objects and then encoding over objects. In our case, the encoding
// part is just a linked list walk calling operations with already prepared values.
}
var $0aa6916bcba80353$var$create = function create() {
    return $hZopo.Buffer ? function create_buffer_setup() {
        return ($0aa6916bcba80353$var$Writer.create = function create_buffer() {
            return new $0aa6916bcba80353$var$BufferWriter();
        })();
    } : function create_array() {
        return new $0aa6916bcba80353$var$Writer();
    };
};
/**
 * Creates a new writer.
 * @function
 * @returns {BufferWriter|Writer} A {@link BufferWriter} when Buffers are supported, otherwise a {@link Writer}
 */ $0aa6916bcba80353$var$Writer.create = $0aa6916bcba80353$var$create();
/**
 * Allocates a buffer of the specified size.
 * @param {number} size Buffer size
 * @returns {Uint8Array} Buffer
 */ $0aa6916bcba80353$var$Writer.alloc = function alloc(size) {
    return new $hZopo.Array(size);
};
// Use Uint8Array buffer pool in the browser, just like node does with buffers
/* istanbul ignore else */ if ($hZopo.Array !== Array) $0aa6916bcba80353$var$Writer.alloc = $hZopo.pool($0aa6916bcba80353$var$Writer.alloc, $hZopo.Array.prototype.subarray);
/**
 * Pushes a new operation to the queue.
 * @param {function(Uint8Array, number, *)} fn Function to call
 * @param {number} len Value byte length
 * @param {number} val Value to write
 * @returns {Writer} `this`
 * @private
 */ $0aa6916bcba80353$var$Writer.prototype._push = function push(fn, len, val) {
    this.tail = this.tail.next = new $0aa6916bcba80353$var$Op(fn, len, val);
    this.len += len;
    return this;
};
function $0aa6916bcba80353$var$writeByte(val, buf, pos) {
    buf[pos] = val & 255;
}
function $0aa6916bcba80353$var$writeVarint32(val, buf, pos) {
    while(val > 127){
        buf[pos++] = val & 127 | 128;
        val >>>= 7;
    }
    buf[pos] = val;
}
/**
 * Constructs a new varint writer operation instance.
 * @classdesc Scheduled varint writer operation.
 * @extends Op
 * @constructor
 * @param {number} len Value byte length
 * @param {number} val Value to write
 * @ignore
 */ function $0aa6916bcba80353$var$VarintOp(len, val) {
    this.len = len;
    this.next = undefined;
    this.val = val;
}
$0aa6916bcba80353$var$VarintOp.prototype = Object.create($0aa6916bcba80353$var$Op.prototype);
$0aa6916bcba80353$var$VarintOp.prototype.fn = $0aa6916bcba80353$var$writeVarint32;
/**
 * Writes an unsigned 32 bit value as a varint.
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $0aa6916bcba80353$var$Writer.prototype.uint32 = function write_uint32(value) {
    // here, the call to this.push has been inlined and a varint specific Op subclass is used.
    // uint32 is by far the most frequently used operation and benefits significantly from this.
    this.len += (this.tail = this.tail.next = new $0aa6916bcba80353$var$VarintOp((value = value >>> 0) < 128 ? 1 : value < 16384 ? 2 : value < 2097152 ? 3 : value < 268435456 ? 4 : 5, value)).len;
    return this;
};
/**
 * Writes a signed 32 bit value as a varint.
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $0aa6916bcba80353$var$Writer.prototype.int32 = function write_int32(value) {
    return value < 0 ? this._push($0aa6916bcba80353$var$writeVarint64, 10, $0aa6916bcba80353$var$LongBits.fromNumber(value)) // 10 bytes per spec
     : this.uint32(value);
};
/**
 * Writes a 32 bit value as a varint, zig-zag encoded.
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $0aa6916bcba80353$var$Writer.prototype.sint32 = function write_sint32(value) {
    return this.uint32((value << 1 ^ value >> 31) >>> 0);
};
function $0aa6916bcba80353$var$writeVarint64(val, buf, pos) {
    while(val.hi){
        buf[pos++] = val.lo & 127 | 128;
        val.lo = (val.lo >>> 7 | val.hi << 25) >>> 0;
        val.hi >>>= 7;
    }
    while(val.lo > 127){
        buf[pos++] = val.lo & 127 | 128;
        val.lo = val.lo >>> 7;
    }
    buf[pos++] = val.lo;
}
/**
 * Writes an unsigned 64 bit value as a varint.
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $0aa6916bcba80353$var$Writer.prototype.uint64 = function write_uint64(value) {
    var bits = $0aa6916bcba80353$var$LongBits.from(value);
    return this._push($0aa6916bcba80353$var$writeVarint64, bits.length(), bits);
};
/**
 * Writes a signed 64 bit value as a varint.
 * @function
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $0aa6916bcba80353$var$Writer.prototype.int64 = $0aa6916bcba80353$var$Writer.prototype.uint64;
/**
 * Writes a signed 64 bit value as a varint, zig-zag encoded.
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $0aa6916bcba80353$var$Writer.prototype.sint64 = function write_sint64(value) {
    var bits = $0aa6916bcba80353$var$LongBits.from(value).zzEncode();
    return this._push($0aa6916bcba80353$var$writeVarint64, bits.length(), bits);
};
/**
 * Writes a boolish value as a varint.
 * @param {boolean} value Value to write
 * @returns {Writer} `this`
 */ $0aa6916bcba80353$var$Writer.prototype.bool = function write_bool(value) {
    return this._push($0aa6916bcba80353$var$writeByte, 1, value ? 1 : 0);
};
function $0aa6916bcba80353$var$writeFixed32(val, buf, pos) {
    buf[pos] = val & 255;
    buf[pos + 1] = val >>> 8 & 255;
    buf[pos + 2] = val >>> 16 & 255;
    buf[pos + 3] = val >>> 24;
}
/**
 * Writes an unsigned 32 bit value as fixed 32 bits.
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $0aa6916bcba80353$var$Writer.prototype.fixed32 = function write_fixed32(value) {
    return this._push($0aa6916bcba80353$var$writeFixed32, 4, value >>> 0);
};
/**
 * Writes a signed 32 bit value as fixed 32 bits.
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $0aa6916bcba80353$var$Writer.prototype.sfixed32 = $0aa6916bcba80353$var$Writer.prototype.fixed32;
/**
 * Writes an unsigned 64 bit value as fixed 64 bits.
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $0aa6916bcba80353$var$Writer.prototype.fixed64 = function write_fixed64(value) {
    var bits = $0aa6916bcba80353$var$LongBits.from(value);
    return this._push($0aa6916bcba80353$var$writeFixed32, 4, bits.lo)._push($0aa6916bcba80353$var$writeFixed32, 4, bits.hi);
};
/**
 * Writes a signed 64 bit value as fixed 64 bits.
 * @function
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $0aa6916bcba80353$var$Writer.prototype.sfixed64 = $0aa6916bcba80353$var$Writer.prototype.fixed64;
/**
 * Writes a float (32 bit).
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $0aa6916bcba80353$var$Writer.prototype.float = function write_float(value) {
    return this._push($hZopo.float.writeFloatLE, 4, value);
};
/**
 * Writes a double (64 bit float).
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $0aa6916bcba80353$var$Writer.prototype.double = function write_double(value) {
    return this._push($hZopo.float.writeDoubleLE, 8, value);
};
var $0aa6916bcba80353$var$writeBytes = $hZopo.Array.prototype.set ? function writeBytes_set(val, buf, pos) {
    buf.set(val, pos); // also works for plain array values
} : function writeBytes_for(val, buf, pos) {
    for(var i = 0; i < val.length; ++i)buf[pos + i] = val[i];
};
/**
 * Writes a sequence of bytes.
 * @param {Uint8Array|string} value Buffer or base64 encoded string to write
 * @returns {Writer} `this`
 */ $0aa6916bcba80353$var$Writer.prototype.bytes = function write_bytes(value) {
    var len = value.length >>> 0;
    if (!len) return this._push($0aa6916bcba80353$var$writeByte, 1, 0);
    if ($hZopo.isString(value)) {
        var buf = $0aa6916bcba80353$var$Writer.alloc(len = $0aa6916bcba80353$var$base64.length(value));
        $0aa6916bcba80353$var$base64.decode(value, buf, 0);
        value = buf;
    }
    return this.uint32(len)._push($0aa6916bcba80353$var$writeBytes, len, value);
};
/**
 * Writes a string.
 * @param {string} value Value to write
 * @returns {Writer} `this`
 */ $0aa6916bcba80353$var$Writer.prototype.string = function write_string(value) {
    var len = $0aa6916bcba80353$var$utf8.length(value);
    return len ? this.uint32(len)._push($0aa6916bcba80353$var$utf8.write, len, value) : this._push($0aa6916bcba80353$var$writeByte, 1, 0);
};
/**
 * Forks this writer's state by pushing it to a stack.
 * Calling {@link Writer#reset|reset} or {@link Writer#ldelim|ldelim} resets the writer to the previous state.
 * @returns {Writer} `this`
 */ $0aa6916bcba80353$var$Writer.prototype.fork = function fork() {
    this.states = new $0aa6916bcba80353$var$State(this);
    this.head = this.tail = new $0aa6916bcba80353$var$Op($0aa6916bcba80353$var$noop, 0, 0);
    this.len = 0;
    return this;
};
/**
 * Resets this instance to the last state.
 * @returns {Writer} `this`
 */ $0aa6916bcba80353$var$Writer.prototype.reset = function reset() {
    if (this.states) {
        this.head = this.states.head;
        this.tail = this.states.tail;
        this.len = this.states.len;
        this.states = this.states.next;
    } else {
        this.head = this.tail = new $0aa6916bcba80353$var$Op($0aa6916bcba80353$var$noop, 0, 0);
        this.len = 0;
    }
    return this;
};
/**
 * Resets to the last state and appends the fork state's current write length as a varint followed by its operations.
 * @returns {Writer} `this`
 */ $0aa6916bcba80353$var$Writer.prototype.ldelim = function ldelim() {
    var head = this.head, tail = this.tail, len = this.len;
    this.reset().uint32(len);
    if (len) {
        this.tail.next = head.next; // skip noop
        this.tail = tail;
        this.len += len;
    }
    return this;
};
/**
 * Finishes the write operation.
 * @returns {Uint8Array} Finished buffer
 */ $0aa6916bcba80353$var$Writer.prototype.finish = function finish() {
    var head = this.head.next, buf = this.constructor.alloc(this.len), pos = 0;
    while(head){
        head.fn(head.val, buf, pos);
        pos += head.len;
        head = head.next;
    }
    // this.head = this.tail = null;
    return buf;
};
$0aa6916bcba80353$var$Writer._configure = function(BufferWriter_) {
    $0aa6916bcba80353$var$BufferWriter = BufferWriter_;
    $0aa6916bcba80353$var$Writer.create = $0aa6916bcba80353$var$create();
    $0aa6916bcba80353$var$BufferWriter._configure();
};

});
parcelRegister("hZopo", function(module, exports) {
"use strict";
var $d18b1130581c4abe$var$util = module.exports;

// used to return a Promise where callback is omitted
$d18b1130581c4abe$var$util.asPromise = (parcelRequire("gRdPx"));

// converts to / from base64 encoded strings
$d18b1130581c4abe$var$util.base64 = (parcelRequire("bEJrZ"));

// base class of rpc.Service
$d18b1130581c4abe$var$util.EventEmitter = (parcelRequire("lcCgU"));

// float handling accross browsers
$d18b1130581c4abe$var$util.float = (parcelRequire("iJT0W"));

// requires modules optionally and hides the call from bundlers
$d18b1130581c4abe$var$util.inquire = (parcelRequire("hvyA6"));

// converts to / from utf8 encoded strings
$d18b1130581c4abe$var$util.utf8 = (parcelRequire("1GVlo"));

// provides a node-like buffer pool in the browser
$d18b1130581c4abe$var$util.pool = (parcelRequire("hzR7K"));

// utility to work with the low and high bits of a 64 bit value
$d18b1130581c4abe$var$util.LongBits = (parcelRequire("7B9Lu"));
/**
 * Whether running within node or not.
 * @memberof util
 * @type {boolean}
 */ $d18b1130581c4abe$var$util.isNode = Boolean(typeof $parcel$global !== "undefined" && $parcel$global && $parcel$global.process && $parcel$global.process.versions && $parcel$global.process.versions.node);
/**
 * Global object reference.
 * @memberof util
 * @type {Object}
 */ $d18b1130581c4abe$var$util.global = $d18b1130581c4abe$var$util.isNode && $parcel$global || typeof window !== "undefined" && window || typeof self !== "undefined" && self || module.exports; // eslint-disable-line no-invalid-this
/**
 * An immuable empty array.
 * @memberof util
 * @type {Array.<*>}
 * @const
 */ $d18b1130581c4abe$var$util.emptyArray = Object.freeze ? Object.freeze([]) : /* istanbul ignore next */ []; // used on prototypes
/**
 * An immutable empty object.
 * @type {Object}
 * @const
 */ $d18b1130581c4abe$var$util.emptyObject = Object.freeze ? Object.freeze({}) : /* istanbul ignore next */ {}; // used on prototypes
/**
 * Tests if the specified value is an integer.
 * @function
 * @param {*} value Value to test
 * @returns {boolean} `true` if the value is an integer
 */ $d18b1130581c4abe$var$util.isInteger = Number.isInteger || /* istanbul ignore next */ function isInteger(value) {
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
};
/**
 * Tests if the specified value is a string.
 * @param {*} value Value to test
 * @returns {boolean} `true` if the value is a string
 */ $d18b1130581c4abe$var$util.isString = function isString(value) {
    return typeof value === "string" || value instanceof String;
};
/**
 * Tests if the specified value is a non-null object.
 * @param {*} value Value to test
 * @returns {boolean} `true` if the value is a non-null object
 */ $d18b1130581c4abe$var$util.isObject = function isObject(value) {
    return value && typeof value === "object";
};
/**
 * Checks if a property on a message is considered to be present.
 * This is an alias of {@link util.isSet}.
 * @function
 * @param {Object} obj Plain object or message instance
 * @param {string} prop Property name
 * @returns {boolean} `true` if considered to be present, otherwise `false`
 */ $d18b1130581c4abe$var$util.isset = /**
 * Checks if a property on a message is considered to be present.
 * @param {Object} obj Plain object or message instance
 * @param {string} prop Property name
 * @returns {boolean} `true` if considered to be present, otherwise `false`
 */ $d18b1130581c4abe$var$util.isSet = function isSet(obj, prop) {
    var value = obj[prop];
    if (value != null && obj.hasOwnProperty(prop)) return typeof value !== "object" || (Array.isArray(value) ? value.length : Object.keys(value).length) > 0;
    return false;
};
/**
 * Any compatible Buffer instance.
 * This is a minimal stand-alone definition of a Buffer instance. The actual type is that exported by node's typings.
 * @interface Buffer
 * @extends Uint8Array
 */ /**
 * Node's Buffer class if available.
 * @type {Constructor<Buffer>}
 */ $d18b1130581c4abe$var$util.Buffer = function() {
    try {
        var Buffer = $d18b1130581c4abe$var$util.inquire("buffer").Buffer;
        // refuse to use non-node buffers if not explicitly assigned (perf reasons):
        return Buffer.prototype.utf8Write ? Buffer : /* istanbul ignore next */ null;
    } catch (e) {
        /* istanbul ignore next */ return null;
    }
}();
// Internal alias of or polyfull for Buffer.from.
$d18b1130581c4abe$var$util._Buffer_from = null;
// Internal alias of or polyfill for Buffer.allocUnsafe.
$d18b1130581c4abe$var$util._Buffer_allocUnsafe = null;
/**
 * Creates a new buffer of whatever type supported by the environment.
 * @param {number|number[]} [sizeOrArray=0] Buffer size or number array
 * @returns {Uint8Array|Buffer} Buffer
 */ $d18b1130581c4abe$var$util.newBuffer = function newBuffer(sizeOrArray) {
    /* istanbul ignore next */ return typeof sizeOrArray === "number" ? $d18b1130581c4abe$var$util.Buffer ? $d18b1130581c4abe$var$util._Buffer_allocUnsafe(sizeOrArray) : new $d18b1130581c4abe$var$util.Array(sizeOrArray) : $d18b1130581c4abe$var$util.Buffer ? $d18b1130581c4abe$var$util._Buffer_from(sizeOrArray) : typeof Uint8Array === "undefined" ? sizeOrArray : new Uint8Array(sizeOrArray);
};
/**
 * Array implementation used in the browser. `Uint8Array` if supported, otherwise `Array`.
 * @type {Constructor<Uint8Array>}
 */ $d18b1130581c4abe$var$util.Array = typeof Uint8Array !== "undefined" ? Uint8Array /* istanbul ignore next */  : Array;
/**
 * Any compatible Long instance.
 * This is a minimal stand-alone definition of a Long instance. The actual type is that exported by long.js.
 * @interface Long
 * @property {number} low Low bits
 * @property {number} high High bits
 * @property {boolean} unsigned Whether unsigned or not
 */ /**
 * Long.js's Long class if available.
 * @type {Constructor<Long>}
 */ $d18b1130581c4abe$var$util.Long = /* istanbul ignore next */ $d18b1130581c4abe$var$util.global.dcodeIO && /* istanbul ignore next */ $d18b1130581c4abe$var$util.global.dcodeIO.Long || /* istanbul ignore next */ $d18b1130581c4abe$var$util.global.Long || $d18b1130581c4abe$var$util.inquire("long");
/**
 * Regular expression used to verify 2 bit (`bool`) map keys.
 * @type {RegExp}
 * @const
 */ $d18b1130581c4abe$var$util.key2Re = /^true|false|0|1$/;
/**
 * Regular expression used to verify 32 bit (`int32` etc.) map keys.
 * @type {RegExp}
 * @const
 */ $d18b1130581c4abe$var$util.key32Re = /^-?(?:0|[1-9][0-9]*)$/;
/**
 * Regular expression used to verify 64 bit (`int64` etc.) map keys.
 * @type {RegExp}
 * @const
 */ $d18b1130581c4abe$var$util.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/;
/**
 * Converts a number or long to an 8 characters long hash string.
 * @param {Long|number} value Value to convert
 * @returns {string} Hash
 */ $d18b1130581c4abe$var$util.longToHash = function longToHash(value) {
    return value ? $d18b1130581c4abe$var$util.LongBits.from(value).toHash() : $d18b1130581c4abe$var$util.LongBits.zeroHash;
};
/**
 * Converts an 8 characters long hash string to a long or number.
 * @param {string} hash Hash
 * @param {boolean} [unsigned=false] Whether unsigned or not
 * @returns {Long|number} Original value
 */ $d18b1130581c4abe$var$util.longFromHash = function longFromHash(hash, unsigned) {
    var bits = $d18b1130581c4abe$var$util.LongBits.fromHash(hash);
    if ($d18b1130581c4abe$var$util.Long) return $d18b1130581c4abe$var$util.Long.fromBits(bits.lo, bits.hi, unsigned);
    return bits.toNumber(Boolean(unsigned));
};
/**
 * Merges the properties of the source object into the destination object.
 * @memberof util
 * @param {Object.<string,*>} dst Destination object
 * @param {Object.<string,*>} src Source object
 * @param {boolean} [ifNotSet=false] Merges only if the key is not already set
 * @returns {Object.<string,*>} Destination object
 */ function $d18b1130581c4abe$var$merge(dst, src, ifNotSet) {
    for(var keys = Object.keys(src), i = 0; i < keys.length; ++i)if (dst[keys[i]] === undefined || !ifNotSet) dst[keys[i]] = src[keys[i]];
    return dst;
}
$d18b1130581c4abe$var$util.merge = $d18b1130581c4abe$var$merge;
/**
 * Converts the first character of a string to lower case.
 * @param {string} str String to convert
 * @returns {string} Converted string
 */ $d18b1130581c4abe$var$util.lcFirst = function lcFirst(str) {
    return str.charAt(0).toLowerCase() + str.substring(1);
};
/**
 * Creates a custom error constructor.
 * @memberof util
 * @param {string} name Error name
 * @returns {Constructor<Error>} Custom error constructor
 */ function $d18b1130581c4abe$var$newError(name) {
    function CustomError(message, properties) {
        if (!(this instanceof CustomError)) return new CustomError(message, properties);
        // Error.call(this, message);
        // ^ just returns a new error instance because the ctor can be called as a function
        Object.defineProperty(this, "message", {
            get: function() {
                return message;
            }
        });
        /* istanbul ignore next */ if (Error.captureStackTrace) Error.captureStackTrace(this, CustomError);
        else Object.defineProperty(this, "stack", {
            value: new Error().stack || ""
        });
        if (properties) $d18b1130581c4abe$var$merge(this, properties);
    }
    (CustomError.prototype = Object.create(Error.prototype)).constructor = CustomError;
    Object.defineProperty(CustomError.prototype, "name", {
        get: function() {
            return name;
        }
    });
    CustomError.prototype.toString = function toString() {
        return this.name + ": " + this.message;
    };
    return CustomError;
}
$d18b1130581c4abe$var$util.newError = $d18b1130581c4abe$var$newError;
/**
 * Constructs a new protocol error.
 * @classdesc Error subclass indicating a protocol specifc error.
 * @memberof util
 * @extends Error
 * @template T extends Message<T>
 * @constructor
 * @param {string} message Error message
 * @param {Object.<string,*>} [properties] Additional properties
 * @example
 * try {
 *     MyMessage.decode(someBuffer); // throws if required fields are missing
 * } catch (e) {
 *     if (e instanceof ProtocolError && e.instance)
 *         console.log("decoded so far: " + JSON.stringify(e.instance));
 * }
 */ $d18b1130581c4abe$var$util.ProtocolError = $d18b1130581c4abe$var$newError("ProtocolError");
/**
 * So far decoded message instance.
 * @name util.ProtocolError#instance
 * @type {Message<T>}
 */ /**
 * A OneOf getter as returned by {@link util.oneOfGetter}.
 * @typedef OneOfGetter
 * @type {function}
 * @returns {string|undefined} Set field name, if any
 */ /**
 * Builds a getter for a oneof's present field name.
 * @param {string[]} fieldNames Field names
 * @returns {OneOfGetter} Unbound getter
 */ $d18b1130581c4abe$var$util.oneOfGetter = function getOneOf(fieldNames) {
    var fieldMap = {};
    for(var i = 0; i < fieldNames.length; ++i)fieldMap[fieldNames[i]] = 1;
    /**
     * @returns {string|undefined} Set field name, if any
     * @this Object
     * @ignore
     */ return function() {
        for(var keys = Object.keys(this), i = keys.length - 1; i > -1; --i)if (fieldMap[keys[i]] === 1 && this[keys[i]] !== undefined && this[keys[i]] !== null) return keys[i];
    };
};
/**
 * A OneOf setter as returned by {@link util.oneOfSetter}.
 * @typedef OneOfSetter
 * @type {function}
 * @param {string|undefined} value Field name
 * @returns {undefined}
 */ /**
 * Builds a setter for a oneof's present field name.
 * @param {string[]} fieldNames Field names
 * @returns {OneOfSetter} Unbound setter
 */ $d18b1130581c4abe$var$util.oneOfSetter = function setOneOf(fieldNames) {
    /**
     * @param {string} name Field name
     * @returns {undefined}
     * @this Object
     * @ignore
     */ return function(name) {
        for(var i = 0; i < fieldNames.length; ++i)if (fieldNames[i] !== name) delete this[fieldNames[i]];
    };
};
/**
 * Default conversion options used for {@link Message#toJSON} implementations.
 *
 * These options are close to proto3's JSON mapping with the exception that internal types like Any are handled just like messages. More precisely:
 *
 * - Longs become strings
 * - Enums become string keys
 * - Bytes become base64 encoded strings
 * - (Sub-)Messages become plain objects
 * - Maps become plain objects with all string keys
 * - Repeated fields become arrays
 * - NaN and Infinity for float and double fields become strings
 *
 * @type {IConversionOptions}
 * @see https://developers.google.com/protocol-buffers/docs/proto3?hl=en#json
 */ $d18b1130581c4abe$var$util.toJSONOptions = {
    longs: String,
    enums: String,
    bytes: String,
    json: true
};
// Sets up buffer utility according to the environment (called in index-minimal)
$d18b1130581c4abe$var$util._configure = function() {
    var Buffer = $d18b1130581c4abe$var$util.Buffer;
    /* istanbul ignore if */ if (!Buffer) {
        $d18b1130581c4abe$var$util._Buffer_from = $d18b1130581c4abe$var$util._Buffer_allocUnsafe = null;
        return;
    }
    // because node 4.x buffers are incompatible & immutable
    // see: https://github.com/dcodeIO/protobuf.js/pull/665
    $d18b1130581c4abe$var$util._Buffer_from = Buffer.from !== Uint8Array.from && Buffer.from || /* istanbul ignore next */ function Buffer_from(value, encoding) {
        return new Buffer(value, encoding);
    };
    $d18b1130581c4abe$var$util._Buffer_allocUnsafe = Buffer.allocUnsafe || /* istanbul ignore next */ function Buffer_allocUnsafe(size) {
        return new Buffer(size);
    };
};

});
parcelRegister("gRdPx", function(module, exports) {
"use strict";
module.exports = $c45c5300213f79cf$var$asPromise;
/**
 * Callback as used by {@link util.asPromise}.
 * @typedef asPromiseCallback
 * @type {function}
 * @param {Error|null} error Error, if any
 * @param {...*} params Additional arguments
 * @returns {undefined}
 */ /**
 * Returns a promise from a node-style callback function.
 * @memberof util
 * @param {asPromiseCallback} fn Function to call
 * @param {*} ctx Function context
 * @param {...*} params Function arguments
 * @returns {Promise<*>} Promisified function
 */ function $c45c5300213f79cf$var$asPromise(fn, ctx /*, varargs */ ) {
    var params = new Array(arguments.length - 1), offset = 0, index = 2, pending = true;
    while(index < arguments.length)params[offset++] = arguments[index++];
    return new Promise(function executor(resolve, reject) {
        params[offset] = function callback(err /*, varargs */ ) {
            if (pending) {
                pending = false;
                if (err) reject(err);
                else {
                    var params = new Array(arguments.length - 1), offset = 0;
                    while(offset < params.length)params[offset++] = arguments[offset];
                    resolve.apply(null, params);
                }
            }
        };
        try {
            fn.apply(ctx || null, params);
        } catch (err) {
            if (pending) {
                pending = false;
                reject(err);
            }
        }
    });
}

});

parcelRegister("bEJrZ", function(module, exports) {
"use strict";
/**
 * A minimal base64 implementation for number arrays.
 * @memberof util
 * @namespace
 */ var $87c6afa867b38d4a$var$base64 = module.exports;
/**
 * Calculates the byte length of a base64 encoded string.
 * @param {string} string Base64 encoded string
 * @returns {number} Byte length
 */ $87c6afa867b38d4a$var$base64.length = function length(string) {
    var p = string.length;
    if (!p) return 0;
    var n = 0;
    while(--p % 4 > 1 && string.charAt(p) === "=")++n;
    return Math.ceil(string.length * 3) / 4 - n;
};
// Base64 encoding table
var $87c6afa867b38d4a$var$b64 = new Array(64);
// Base64 decoding table
var $87c6afa867b38d4a$var$s64 = new Array(123);
// 65..90, 97..122, 48..57, 43, 47
for(var $87c6afa867b38d4a$var$i = 0; $87c6afa867b38d4a$var$i < 64;)$87c6afa867b38d4a$var$s64[$87c6afa867b38d4a$var$b64[$87c6afa867b38d4a$var$i] = $87c6afa867b38d4a$var$i < 26 ? $87c6afa867b38d4a$var$i + 65 : $87c6afa867b38d4a$var$i < 52 ? $87c6afa867b38d4a$var$i + 71 : $87c6afa867b38d4a$var$i < 62 ? $87c6afa867b38d4a$var$i - 4 : $87c6afa867b38d4a$var$i - 59 | 43] = $87c6afa867b38d4a$var$i++;
/**
 * Encodes a buffer to a base64 encoded string.
 * @param {Uint8Array} buffer Source buffer
 * @param {number} start Source start
 * @param {number} end Source end
 * @returns {string} Base64 encoded string
 */ $87c6afa867b38d4a$var$base64.encode = function encode(buffer, start, end) {
    var parts = null, chunk = [];
    var i = 0, j = 0, t; // temporary
    while(start < end){
        var b = buffer[start++];
        switch(j){
            case 0:
                chunk[i++] = $87c6afa867b38d4a$var$b64[b >> 2];
                t = (b & 3) << 4;
                j = 1;
                break;
            case 1:
                chunk[i++] = $87c6afa867b38d4a$var$b64[t | b >> 4];
                t = (b & 15) << 2;
                j = 2;
                break;
            case 2:
                chunk[i++] = $87c6afa867b38d4a$var$b64[t | b >> 6];
                chunk[i++] = $87c6afa867b38d4a$var$b64[b & 63];
                j = 0;
                break;
        }
        if (i > 8191) {
            (parts || (parts = [])).push(String.fromCharCode.apply(String, chunk));
            i = 0;
        }
    }
    if (j) {
        chunk[i++] = $87c6afa867b38d4a$var$b64[t];
        chunk[i++] = 61;
        if (j === 1) chunk[i++] = 61;
    }
    if (parts) {
        if (i) parts.push(String.fromCharCode.apply(String, chunk.slice(0, i)));
        return parts.join("");
    }
    return String.fromCharCode.apply(String, chunk.slice(0, i));
};
var $87c6afa867b38d4a$var$invalidEncoding = "invalid encoding";
/**
 * Decodes a base64 encoded string to a buffer.
 * @param {string} string Source string
 * @param {Uint8Array} buffer Destination buffer
 * @param {number} offset Destination offset
 * @returns {number} Number of bytes written
 * @throws {Error} If encoding is invalid
 */ $87c6afa867b38d4a$var$base64.decode = function decode(string, buffer, offset) {
    var start = offset;
    var j = 0, t; // temporary
    for(var i = 0; i < string.length;){
        var c = string.charCodeAt(i++);
        if (c === 61 && j > 1) break;
        if ((c = $87c6afa867b38d4a$var$s64[c]) === undefined) throw Error($87c6afa867b38d4a$var$invalidEncoding);
        switch(j){
            case 0:
                t = c;
                j = 1;
                break;
            case 1:
                buffer[offset++] = t << 2 | (c & 48) >> 4;
                t = c;
                j = 2;
                break;
            case 2:
                buffer[offset++] = (t & 15) << 4 | (c & 60) >> 2;
                t = c;
                j = 3;
                break;
            case 3:
                buffer[offset++] = (t & 3) << 6 | c;
                j = 0;
                break;
        }
    }
    if (j === 1) throw Error($87c6afa867b38d4a$var$invalidEncoding);
    return offset - start;
};
/**
 * Tests if the specified string appears to be base64 encoded.
 * @param {string} string String to test
 * @returns {boolean} `true` if probably base64 encoded, otherwise false
 */ $87c6afa867b38d4a$var$base64.test = function test(string) {
    return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(string);
};

});

parcelRegister("lcCgU", function(module, exports) {
"use strict";
module.exports = $f6f867f1644a6039$var$EventEmitter;
/**
 * Constructs a new event emitter instance.
 * @classdesc A minimal event emitter.
 * @memberof util
 * @constructor
 */ function $f6f867f1644a6039$var$EventEmitter() {
    /**
     * Registered listeners.
     * @type {Object.<string,*>}
     * @private
     */ this._listeners = {};
}
/**
 * Registers an event listener.
 * @param {string} evt Event name
 * @param {function} fn Listener
 * @param {*} [ctx] Listener context
 * @returns {util.EventEmitter} `this`
 */ $f6f867f1644a6039$var$EventEmitter.prototype.on = function on(evt, fn, ctx) {
    (this._listeners[evt] || (this._listeners[evt] = [])).push({
        fn: fn,
        ctx: ctx || this
    });
    return this;
};
/**
 * Removes an event listener or any matching listeners if arguments are omitted.
 * @param {string} [evt] Event name. Removes all listeners if omitted.
 * @param {function} [fn] Listener to remove. Removes all listeners of `evt` if omitted.
 * @returns {util.EventEmitter} `this`
 */ $f6f867f1644a6039$var$EventEmitter.prototype.off = function off(evt, fn) {
    if (evt === undefined) this._listeners = {};
    else if (fn === undefined) this._listeners[evt] = [];
    else {
        var listeners = this._listeners[evt];
        for(var i = 0; i < listeners.length;)if (listeners[i].fn === fn) listeners.splice(i, 1);
        else ++i;
    }
    return this;
};
/**
 * Emits an event by calling its listeners with the specified arguments.
 * @param {string} evt Event name
 * @param {...*} args Arguments
 * @returns {util.EventEmitter} `this`
 */ $f6f867f1644a6039$var$EventEmitter.prototype.emit = function emit(evt) {
    var listeners = this._listeners[evt];
    if (listeners) {
        var args = [], i = 1;
        for(; i < arguments.length;)args.push(arguments[i++]);
        for(i = 0; i < listeners.length;)listeners[i].fn.apply(listeners[i++].ctx, args);
    }
    return this;
};

});

parcelRegister("iJT0W", function(module, exports) {
"use strict";
module.exports = $da471aa0f1d88630$var$factory($da471aa0f1d88630$var$factory);
/**
 * Reads / writes floats / doubles from / to buffers.
 * @name util.float
 * @namespace
 */ /**
 * Writes a 32 bit float to a buffer using little endian byte order.
 * @name util.float.writeFloatLE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Writes a 32 bit float to a buffer using big endian byte order.
 * @name util.float.writeFloatBE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Reads a 32 bit float from a buffer using little endian byte order.
 * @name util.float.readFloatLE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ /**
 * Reads a 32 bit float from a buffer using big endian byte order.
 * @name util.float.readFloatBE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ /**
 * Writes a 64 bit double to a buffer using little endian byte order.
 * @name util.float.writeDoubleLE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Writes a 64 bit double to a buffer using big endian byte order.
 * @name util.float.writeDoubleBE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Reads a 64 bit double from a buffer using little endian byte order.
 * @name util.float.readDoubleLE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ /**
 * Reads a 64 bit double from a buffer using big endian byte order.
 * @name util.float.readDoubleBE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ // Factory function for the purpose of node-based testing in modified global environments
function $da471aa0f1d88630$var$factory(exports) {
    // float: typed array
    if (typeof Float32Array !== "undefined") (function() {
        var f32 = new Float32Array([
            -0
        ]), f8b = new Uint8Array(f32.buffer), le = f8b[3] === 128;
        function writeFloat_f32_cpy(val, buf, pos) {
            f32[0] = val;
            buf[pos] = f8b[0];
            buf[pos + 1] = f8b[1];
            buf[pos + 2] = f8b[2];
            buf[pos + 3] = f8b[3];
        }
        function writeFloat_f32_rev(val, buf, pos) {
            f32[0] = val;
            buf[pos] = f8b[3];
            buf[pos + 1] = f8b[2];
            buf[pos + 2] = f8b[1];
            buf[pos + 3] = f8b[0];
        }
        /* istanbul ignore next */ exports.writeFloatLE = le ? writeFloat_f32_cpy : writeFloat_f32_rev;
        /* istanbul ignore next */ exports.writeFloatBE = le ? writeFloat_f32_rev : writeFloat_f32_cpy;
        function readFloat_f32_cpy(buf, pos) {
            f8b[0] = buf[pos];
            f8b[1] = buf[pos + 1];
            f8b[2] = buf[pos + 2];
            f8b[3] = buf[pos + 3];
            return f32[0];
        }
        function readFloat_f32_rev(buf, pos) {
            f8b[3] = buf[pos];
            f8b[2] = buf[pos + 1];
            f8b[1] = buf[pos + 2];
            f8b[0] = buf[pos + 3];
            return f32[0];
        }
        /* istanbul ignore next */ exports.readFloatLE = le ? readFloat_f32_cpy : readFloat_f32_rev;
        /* istanbul ignore next */ exports.readFloatBE = le ? readFloat_f32_rev : readFloat_f32_cpy;
    // float: ieee754
    })();
    else (function() {
        function writeFloat_ieee754(writeUint, val, buf, pos) {
            var sign = val < 0 ? 1 : 0;
            if (sign) val = -val;
            if (val === 0) writeUint(1 / val > 0 ? /* positive */ 0 : /* negative 0 */ 2147483648, buf, pos);
            else if (isNaN(val)) writeUint(2143289344, buf, pos);
            else if (val > 3.4028234663852886e+38) writeUint((sign << 31 | 2139095040) >>> 0, buf, pos);
            else if (val < 1.1754943508222875e-38) writeUint((sign << 31 | Math.round(val / 1.401298464324817e-45)) >>> 0, buf, pos);
            else {
                var exponent = Math.floor(Math.log(val) / Math.LN2), mantissa = Math.round(val * Math.pow(2, -exponent) * 8388608) & 8388607;
                writeUint((sign << 31 | exponent + 127 << 23 | mantissa) >>> 0, buf, pos);
            }
        }
        exports.writeFloatLE = writeFloat_ieee754.bind(null, $da471aa0f1d88630$var$writeUintLE);
        exports.writeFloatBE = writeFloat_ieee754.bind(null, $da471aa0f1d88630$var$writeUintBE);
        function readFloat_ieee754(readUint, buf, pos) {
            var uint = readUint(buf, pos), sign = (uint >> 31) * 2 + 1, exponent = uint >>> 23 & 255, mantissa = uint & 8388607;
            return exponent === 255 ? mantissa ? NaN : sign * Infinity : exponent === 0 // denormal
             ? sign * 1.401298464324817e-45 * mantissa : sign * Math.pow(2, exponent - 150) * (mantissa + 8388608);
        }
        exports.readFloatLE = readFloat_ieee754.bind(null, $da471aa0f1d88630$var$readUintLE);
        exports.readFloatBE = readFloat_ieee754.bind(null, $da471aa0f1d88630$var$readUintBE);
    })();
    // double: typed array
    if (typeof Float64Array !== "undefined") (function() {
        var f64 = new Float64Array([
            -0
        ]), f8b = new Uint8Array(f64.buffer), le = f8b[7] === 128;
        function writeDouble_f64_cpy(val, buf, pos) {
            f64[0] = val;
            buf[pos] = f8b[0];
            buf[pos + 1] = f8b[1];
            buf[pos + 2] = f8b[2];
            buf[pos + 3] = f8b[3];
            buf[pos + 4] = f8b[4];
            buf[pos + 5] = f8b[5];
            buf[pos + 6] = f8b[6];
            buf[pos + 7] = f8b[7];
        }
        function writeDouble_f64_rev(val, buf, pos) {
            f64[0] = val;
            buf[pos] = f8b[7];
            buf[pos + 1] = f8b[6];
            buf[pos + 2] = f8b[5];
            buf[pos + 3] = f8b[4];
            buf[pos + 4] = f8b[3];
            buf[pos + 5] = f8b[2];
            buf[pos + 6] = f8b[1];
            buf[pos + 7] = f8b[0];
        }
        /* istanbul ignore next */ exports.writeDoubleLE = le ? writeDouble_f64_cpy : writeDouble_f64_rev;
        /* istanbul ignore next */ exports.writeDoubleBE = le ? writeDouble_f64_rev : writeDouble_f64_cpy;
        function readDouble_f64_cpy(buf, pos) {
            f8b[0] = buf[pos];
            f8b[1] = buf[pos + 1];
            f8b[2] = buf[pos + 2];
            f8b[3] = buf[pos + 3];
            f8b[4] = buf[pos + 4];
            f8b[5] = buf[pos + 5];
            f8b[6] = buf[pos + 6];
            f8b[7] = buf[pos + 7];
            return f64[0];
        }
        function readDouble_f64_rev(buf, pos) {
            f8b[7] = buf[pos];
            f8b[6] = buf[pos + 1];
            f8b[5] = buf[pos + 2];
            f8b[4] = buf[pos + 3];
            f8b[3] = buf[pos + 4];
            f8b[2] = buf[pos + 5];
            f8b[1] = buf[pos + 6];
            f8b[0] = buf[pos + 7];
            return f64[0];
        }
        /* istanbul ignore next */ exports.readDoubleLE = le ? readDouble_f64_cpy : readDouble_f64_rev;
        /* istanbul ignore next */ exports.readDoubleBE = le ? readDouble_f64_rev : readDouble_f64_cpy;
    // double: ieee754
    })();
    else (function() {
        function writeDouble_ieee754(writeUint, off0, off1, val, buf, pos) {
            var sign = val < 0 ? 1 : 0;
            if (sign) val = -val;
            if (val === 0) {
                writeUint(0, buf, pos + off0);
                writeUint(1 / val > 0 ? /* positive */ 0 : /* negative 0 */ 2147483648, buf, pos + off1);
            } else if (isNaN(val)) {
                writeUint(0, buf, pos + off0);
                writeUint(2146959360, buf, pos + off1);
            } else if (val > 1.7976931348623157e+308) {
                writeUint(0, buf, pos + off0);
                writeUint((sign << 31 | 2146435072) >>> 0, buf, pos + off1);
            } else {
                var mantissa;
                if (val < 2.2250738585072014e-308) {
                    mantissa = val / 5e-324;
                    writeUint(mantissa >>> 0, buf, pos + off0);
                    writeUint((sign << 31 | mantissa / 4294967296) >>> 0, buf, pos + off1);
                } else {
                    var exponent = Math.floor(Math.log(val) / Math.LN2);
                    if (exponent === 1024) exponent = 1023;
                    mantissa = val * Math.pow(2, -exponent);
                    writeUint(mantissa * 4503599627370496 >>> 0, buf, pos + off0);
                    writeUint((sign << 31 | exponent + 1023 << 20 | mantissa * 1048576 & 1048575) >>> 0, buf, pos + off1);
                }
            }
        }
        exports.writeDoubleLE = writeDouble_ieee754.bind(null, $da471aa0f1d88630$var$writeUintLE, 0, 4);
        exports.writeDoubleBE = writeDouble_ieee754.bind(null, $da471aa0f1d88630$var$writeUintBE, 4, 0);
        function readDouble_ieee754(readUint, off0, off1, buf, pos) {
            var lo = readUint(buf, pos + off0), hi = readUint(buf, pos + off1);
            var sign = (hi >> 31) * 2 + 1, exponent = hi >>> 20 & 2047, mantissa = 4294967296 * (hi & 1048575) + lo;
            return exponent === 2047 ? mantissa ? NaN : sign * Infinity : exponent === 0 // denormal
             ? sign * 5e-324 * mantissa : sign * Math.pow(2, exponent - 1075) * (mantissa + 4503599627370496);
        }
        exports.readDoubleLE = readDouble_ieee754.bind(null, $da471aa0f1d88630$var$readUintLE, 0, 4);
        exports.readDoubleBE = readDouble_ieee754.bind(null, $da471aa0f1d88630$var$readUintBE, 4, 0);
    })();
    return exports;
}
// uint helpers
function $da471aa0f1d88630$var$writeUintLE(val, buf, pos) {
    buf[pos] = val & 255;
    buf[pos + 1] = val >>> 8 & 255;
    buf[pos + 2] = val >>> 16 & 255;
    buf[pos + 3] = val >>> 24;
}
function $da471aa0f1d88630$var$writeUintBE(val, buf, pos) {
    buf[pos] = val >>> 24;
    buf[pos + 1] = val >>> 16 & 255;
    buf[pos + 2] = val >>> 8 & 255;
    buf[pos + 3] = val & 255;
}
function $da471aa0f1d88630$var$readUintLE(buf, pos) {
    return (buf[pos] | buf[pos + 1] << 8 | buf[pos + 2] << 16 | buf[pos + 3] << 24) >>> 0;
}
function $da471aa0f1d88630$var$readUintBE(buf, pos) {
    return (buf[pos] << 24 | buf[pos + 1] << 16 | buf[pos + 2] << 8 | buf[pos + 3]) >>> 0;
}

});

parcelRegister("hvyA6", function(module, exports) {
"use strict";
module.exports = inquire;
/**
 * Requires a module only if available.
 * @memberof util
 * @param {string} moduleName Module to require
 * @returns {?Object} Required module if available and not empty, otherwise `null`
 */ function inquire(moduleName) {
    try {
        var mod = eval("quire".replace(/^/, "re"))(moduleName); // eslint-disable-line no-eval
        if (mod && (mod.length || Object.keys(mod).length)) return mod;
    } catch (e) {} // eslint-disable-line no-empty
    return null;
}

});

parcelRegister("1GVlo", function(module, exports) {
"use strict";
/**
 * A minimal UTF8 implementation for number arrays.
 * @memberof util
 * @namespace
 */ var $13b63206797e5994$var$utf8 = module.exports;
/**
 * Calculates the UTF8 byte length of a string.
 * @param {string} string String
 * @returns {number} Byte length
 */ $13b63206797e5994$var$utf8.length = function utf8_length(string) {
    var len = 0, c = 0;
    for(var i = 0; i < string.length; ++i){
        c = string.charCodeAt(i);
        if (c < 128) len += 1;
        else if (c < 2048) len += 2;
        else if ((c & 0xFC00) === 0xD800 && (string.charCodeAt(i + 1) & 0xFC00) === 0xDC00) {
            ++i;
            len += 4;
        } else len += 3;
    }
    return len;
};
/**
 * Reads UTF8 bytes as a string.
 * @param {Uint8Array} buffer Source buffer
 * @param {number} start Source start
 * @param {number} end Source end
 * @returns {string} String read
 */ $13b63206797e5994$var$utf8.read = function utf8_read(buffer, start, end) {
    var len = end - start;
    if (len < 1) return "";
    var parts = null, chunk = [], i = 0, t; // temporary
    while(start < end){
        t = buffer[start++];
        if (t < 128) chunk[i++] = t;
        else if (t > 191 && t < 224) chunk[i++] = (t & 31) << 6 | buffer[start++] & 63;
        else if (t > 239 && t < 365) {
            t = ((t & 7) << 18 | (buffer[start++] & 63) << 12 | (buffer[start++] & 63) << 6 | buffer[start++] & 63) - 0x10000;
            chunk[i++] = 0xD800 + (t >> 10);
            chunk[i++] = 0xDC00 + (t & 1023);
        } else chunk[i++] = (t & 15) << 12 | (buffer[start++] & 63) << 6 | buffer[start++] & 63;
        if (i > 8191) {
            (parts || (parts = [])).push(String.fromCharCode.apply(String, chunk));
            i = 0;
        }
    }
    if (parts) {
        if (i) parts.push(String.fromCharCode.apply(String, chunk.slice(0, i)));
        return parts.join("");
    }
    return String.fromCharCode.apply(String, chunk.slice(0, i));
};
/**
 * Writes a string as UTF8 bytes.
 * @param {string} string Source string
 * @param {Uint8Array} buffer Destination buffer
 * @param {number} offset Destination offset
 * @returns {number} Bytes written
 */ $13b63206797e5994$var$utf8.write = function utf8_write(string, buffer, offset) {
    var start = offset, c1, c2; // character 2
    for(var i = 0; i < string.length; ++i){
        c1 = string.charCodeAt(i);
        if (c1 < 128) buffer[offset++] = c1;
        else if (c1 < 2048) {
            buffer[offset++] = c1 >> 6 | 192;
            buffer[offset++] = c1 & 63 | 128;
        } else if ((c1 & 0xFC00) === 0xD800 && ((c2 = string.charCodeAt(i + 1)) & 0xFC00) === 0xDC00) {
            c1 = 0x10000 + ((c1 & 0x03FF) << 10) + (c2 & 0x03FF);
            ++i;
            buffer[offset++] = c1 >> 18 | 240;
            buffer[offset++] = c1 >> 12 & 63 | 128;
            buffer[offset++] = c1 >> 6 & 63 | 128;
            buffer[offset++] = c1 & 63 | 128;
        } else {
            buffer[offset++] = c1 >> 12 | 224;
            buffer[offset++] = c1 >> 6 & 63 | 128;
            buffer[offset++] = c1 & 63 | 128;
        }
    }
    return offset - start;
};

});

parcelRegister("hzR7K", function(module, exports) {
"use strict";
module.exports = $ccbee9e266f8b8c0$var$pool;
/**
 * An allocator as used by {@link util.pool}.
 * @typedef PoolAllocator
 * @type {function}
 * @param {number} size Buffer size
 * @returns {Uint8Array} Buffer
 */ /**
 * A slicer as used by {@link util.pool}.
 * @typedef PoolSlicer
 * @type {function}
 * @param {number} start Start offset
 * @param {number} end End offset
 * @returns {Uint8Array} Buffer slice
 * @this {Uint8Array}
 */ /**
 * A general purpose buffer pool.
 * @memberof util
 * @function
 * @param {PoolAllocator} alloc Allocator
 * @param {PoolSlicer} slice Slicer
 * @param {number} [size=8192] Slab size
 * @returns {PoolAllocator} Pooled allocator
 */ function $ccbee9e266f8b8c0$var$pool(alloc, slice, size) {
    var SIZE = size || 8192;
    var MAX = SIZE >>> 1;
    var slab = null;
    var offset = SIZE;
    return function pool_alloc(size) {
        if (size < 1 || size > MAX) return alloc(size);
        if (offset + size > SIZE) {
            slab = alloc(SIZE);
            offset = 0;
        }
        var buf = slice.call(slab, offset, offset += size);
        if (offset & 7) offset = (offset | 7) + 1;
        return buf;
    };
}

});

parcelRegister("7B9Lu", function(module, exports) {
"use strict";
module.exports = $5883903fae6d4c97$var$LongBits;

var $hZopo = parcelRequire("hZopo");
/**
 * Constructs new long bits.
 * @classdesc Helper class for working with the low and high bits of a 64 bit value.
 * @memberof util
 * @constructor
 * @param {number} lo Low 32 bits, unsigned
 * @param {number} hi High 32 bits, unsigned
 */ function $5883903fae6d4c97$var$LongBits(lo, hi) {
    // note that the casts below are theoretically unnecessary as of today, but older statically
    // generated converter code might still call the ctor with signed 32bits. kept for compat.
    /**
     * Low bits.
     * @type {number}
     */ this.lo = lo >>> 0;
    /**
     * High bits.
     * @type {number}
     */ this.hi = hi >>> 0;
}
/**
 * Zero bits.
 * @memberof util.LongBits
 * @type {util.LongBits}
 */ var $5883903fae6d4c97$var$zero = $5883903fae6d4c97$var$LongBits.zero = new $5883903fae6d4c97$var$LongBits(0, 0);
$5883903fae6d4c97$var$zero.toNumber = function() {
    return 0;
};
$5883903fae6d4c97$var$zero.zzEncode = $5883903fae6d4c97$var$zero.zzDecode = function() {
    return this;
};
$5883903fae6d4c97$var$zero.length = function() {
    return 1;
};
/**
 * Zero hash.
 * @memberof util.LongBits
 * @type {string}
 */ var $5883903fae6d4c97$var$zeroHash = $5883903fae6d4c97$var$LongBits.zeroHash = "\x00\x00\x00\x00\x00\x00\x00\x00";
/**
 * Constructs new long bits from the specified number.
 * @param {number} value Value
 * @returns {util.LongBits} Instance
 */ $5883903fae6d4c97$var$LongBits.fromNumber = function fromNumber(value) {
    if (value === 0) return $5883903fae6d4c97$var$zero;
    var sign = value < 0;
    if (sign) value = -value;
    var lo = value >>> 0, hi = (value - lo) / 4294967296 >>> 0;
    if (sign) {
        hi = ~hi >>> 0;
        lo = ~lo >>> 0;
        if (++lo > 4294967295) {
            lo = 0;
            if (++hi > 4294967295) hi = 0;
        }
    }
    return new $5883903fae6d4c97$var$LongBits(lo, hi);
};
/**
 * Constructs new long bits from a number, long or string.
 * @param {Long|number|string} value Value
 * @returns {util.LongBits} Instance
 */ $5883903fae6d4c97$var$LongBits.from = function from(value) {
    if (typeof value === "number") return $5883903fae6d4c97$var$LongBits.fromNumber(value);
    if ($hZopo.isString(value)) {
        /* istanbul ignore else */ if ($hZopo.Long) value = $hZopo.Long.fromString(value);
        else return $5883903fae6d4c97$var$LongBits.fromNumber(parseInt(value, 10));
    }
    return value.low || value.high ? new $5883903fae6d4c97$var$LongBits(value.low >>> 0, value.high >>> 0) : $5883903fae6d4c97$var$zero;
};
/**
 * Converts this long bits to a possibly unsafe JavaScript number.
 * @param {boolean} [unsigned=false] Whether unsigned or not
 * @returns {number} Possibly unsafe number
 */ $5883903fae6d4c97$var$LongBits.prototype.toNumber = function toNumber(unsigned) {
    if (!unsigned && this.hi >>> 31) {
        var lo = ~this.lo + 1 >>> 0, hi = ~this.hi >>> 0;
        if (!lo) hi = hi + 1 >>> 0;
        return -(lo + hi * 4294967296);
    }
    return this.lo + this.hi * 4294967296;
};
/**
 * Converts this long bits to a long.
 * @param {boolean} [unsigned=false] Whether unsigned or not
 * @returns {Long} Long
 */ $5883903fae6d4c97$var$LongBits.prototype.toLong = function toLong(unsigned) {
    return $hZopo.Long ? new $hZopo.Long(this.lo | 0, this.hi | 0, Boolean(unsigned)) : {
        low: this.lo | 0,
        high: this.hi | 0,
        unsigned: Boolean(unsigned)
    };
};
var $5883903fae6d4c97$var$charCodeAt = String.prototype.charCodeAt;
/**
 * Constructs new long bits from the specified 8 characters long hash.
 * @param {string} hash Hash
 * @returns {util.LongBits} Bits
 */ $5883903fae6d4c97$var$LongBits.fromHash = function fromHash(hash) {
    if (hash === $5883903fae6d4c97$var$zeroHash) return $5883903fae6d4c97$var$zero;
    return new $5883903fae6d4c97$var$LongBits(($5883903fae6d4c97$var$charCodeAt.call(hash, 0) | $5883903fae6d4c97$var$charCodeAt.call(hash, 1) << 8 | $5883903fae6d4c97$var$charCodeAt.call(hash, 2) << 16 | $5883903fae6d4c97$var$charCodeAt.call(hash, 3) << 24) >>> 0, ($5883903fae6d4c97$var$charCodeAt.call(hash, 4) | $5883903fae6d4c97$var$charCodeAt.call(hash, 5) << 8 | $5883903fae6d4c97$var$charCodeAt.call(hash, 6) << 16 | $5883903fae6d4c97$var$charCodeAt.call(hash, 7) << 24) >>> 0);
};
/**
 * Converts this long bits to a 8 characters long hash.
 * @returns {string} Hash
 */ $5883903fae6d4c97$var$LongBits.prototype.toHash = function toHash() {
    return String.fromCharCode(this.lo & 255, this.lo >>> 8 & 255, this.lo >>> 16 & 255, this.lo >>> 24, this.hi & 255, this.hi >>> 8 & 255, this.hi >>> 16 & 255, this.hi >>> 24);
};
/**
 * Zig-zag encodes this long bits.
 * @returns {util.LongBits} `this`
 */ $5883903fae6d4c97$var$LongBits.prototype.zzEncode = function zzEncode() {
    var mask = this.hi >> 31;
    this.hi = ((this.hi << 1 | this.lo >>> 31) ^ mask) >>> 0;
    this.lo = (this.lo << 1 ^ mask) >>> 0;
    return this;
};
/**
 * Zig-zag decodes this long bits.
 * @returns {util.LongBits} `this`
 */ $5883903fae6d4c97$var$LongBits.prototype.zzDecode = function zzDecode() {
    var mask = -(this.lo & 1);
    this.lo = ((this.lo >>> 1 | this.hi << 31) ^ mask) >>> 0;
    this.hi = (this.hi >>> 1 ^ mask) >>> 0;
    return this;
};
/**
 * Calculates the length of this longbits when encoded as a varint.
 * @returns {number} Length
 */ $5883903fae6d4c97$var$LongBits.prototype.length = function length() {
    var part0 = this.lo, part1 = (this.lo >>> 28 | this.hi << 4) >>> 0, part2 = this.hi >>> 24;
    return part2 === 0 ? part1 === 0 ? part0 < 16384 ? part0 < 128 ? 1 : 2 : part0 < 2097152 ? 3 : 4 : part1 < 16384 ? part1 < 128 ? 5 : 6 : part1 < 2097152 ? 7 : 8 : part2 < 128 ? 9 : 10;
};

});



parcelRegister("1TRcz", function(module, exports) {
"use strict";
module.exports = $16243246ff88aff3$var$BufferWriter;

var $UGYDC = parcelRequire("UGYDC");
($16243246ff88aff3$var$BufferWriter.prototype = Object.create($UGYDC.prototype)).constructor = $16243246ff88aff3$var$BufferWriter;

var $hZopo = parcelRequire("hZopo");
/**
 * Constructs a new buffer writer instance.
 * @classdesc Wire format writer using node buffers.
 * @extends Writer
 * @constructor
 */ function $16243246ff88aff3$var$BufferWriter() {
    $UGYDC.call(this);
}
$16243246ff88aff3$var$BufferWriter._configure = function() {
    /**
     * Allocates a buffer of the specified size.
     * @function
     * @param {number} size Buffer size
     * @returns {Buffer} Buffer
     */ $16243246ff88aff3$var$BufferWriter.alloc = $hZopo._Buffer_allocUnsafe;
    $16243246ff88aff3$var$BufferWriter.writeBytesBuffer = $hZopo.Buffer && $hZopo.Buffer.prototype instanceof Uint8Array && $hZopo.Buffer.prototype.set.name === "set" ? function writeBytesBuffer_set(val, buf, pos) {
        buf.set(val, pos); // faster than copy (requires node >= 4 where Buffers extend Uint8Array and set is properly inherited)
    // also works for plain array values
    } : function writeBytesBuffer_copy(val, buf, pos) {
        if (val.copy) val.copy(buf, pos, 0, val.length);
        else for(var i = 0; i < val.length;)buf[pos++] = val[i++];
    };
};
/**
 * @override
 */ $16243246ff88aff3$var$BufferWriter.prototype.bytes = function write_bytes_buffer(value) {
    if ($hZopo.isString(value)) value = $hZopo._Buffer_from(value, "base64");
    var len = value.length >>> 0;
    this.uint32(len);
    if (len) this._push($16243246ff88aff3$var$BufferWriter.writeBytesBuffer, len, value);
    return this;
};
function $16243246ff88aff3$var$writeStringBuffer(val, buf, pos) {
    if (val.length < 40) $hZopo.utf8.write(val, buf, pos);
    else if (buf.utf8Write) buf.utf8Write(val, pos);
    else buf.write(val, pos);
}
/**
 * @override
 */ $16243246ff88aff3$var$BufferWriter.prototype.string = function write_string_buffer(value) {
    var len = $hZopo.Buffer.byteLength(value);
    this.uint32(len);
    if (len) this._push($16243246ff88aff3$var$writeStringBuffer, len, value);
    return this;
};
/**
 * Finishes the write operation.
 * @name BufferWriter#finish
 * @function
 * @returns {Buffer} Finished buffer
 */ $16243246ff88aff3$var$BufferWriter._configure();

});

parcelRegister("aAsQy", function(module, exports) {
"use strict";
module.exports = $7b53a487bcbd6686$var$Reader;

var $hZopo = parcelRequire("hZopo");
var $7b53a487bcbd6686$var$BufferReader; // cyclic
var $7b53a487bcbd6686$var$LongBits = $hZopo.LongBits, $7b53a487bcbd6686$var$utf8 = $hZopo.utf8;
/* istanbul ignore next */ function $7b53a487bcbd6686$var$indexOutOfRange(reader, writeLength) {
    return RangeError("index out of range: " + reader.pos + " + " + (writeLength || 1) + " > " + reader.len);
}
/**
 * Constructs a new reader instance using the specified buffer.
 * @classdesc Wire format reader using `Uint8Array` if available, otherwise `Array`.
 * @constructor
 * @param {Uint8Array} buffer Buffer to read from
 */ function $7b53a487bcbd6686$var$Reader(buffer) {
    /**
     * Read buffer.
     * @type {Uint8Array}
     */ this.buf = buffer;
    /**
     * Read buffer position.
     * @type {number}
     */ this.pos = 0;
    /**
     * Read buffer length.
     * @type {number}
     */ this.len = buffer.length;
}
var $7b53a487bcbd6686$var$create_array = typeof Uint8Array !== "undefined" ? function create_typed_array(buffer) {
    if (buffer instanceof Uint8Array || Array.isArray(buffer)) return new $7b53a487bcbd6686$var$Reader(buffer);
    throw Error("illegal buffer");
} : function create_array(buffer) {
    if (Array.isArray(buffer)) return new $7b53a487bcbd6686$var$Reader(buffer);
    throw Error("illegal buffer");
};
var $7b53a487bcbd6686$var$create = function create() {
    return $hZopo.Buffer ? function create_buffer_setup(buffer) {
        return ($7b53a487bcbd6686$var$Reader.create = function create_buffer(buffer) {
            return $hZopo.Buffer.isBuffer(buffer) ? new $7b53a487bcbd6686$var$BufferReader(buffer) : $7b53a487bcbd6686$var$create_array(buffer);
        })(buffer);
    } : $7b53a487bcbd6686$var$create_array;
};
/**
 * Creates a new reader using the specified buffer.
 * @function
 * @param {Uint8Array|Buffer} buffer Buffer to read from
 * @returns {Reader|BufferReader} A {@link BufferReader} if `buffer` is a Buffer, otherwise a {@link Reader}
 * @throws {Error} If `buffer` is not a valid buffer
 */ $7b53a487bcbd6686$var$Reader.create = $7b53a487bcbd6686$var$create();
$7b53a487bcbd6686$var$Reader.prototype._slice = $hZopo.Array.prototype.subarray || /* istanbul ignore next */ $hZopo.Array.prototype.slice;
/**
 * Reads a varint as an unsigned 32 bit value.
 * @function
 * @returns {number} Value read
 */ $7b53a487bcbd6686$var$Reader.prototype.uint32 = function read_uint32_setup() {
    var value = 4294967295; // optimizer type-hint, tends to deopt otherwise (?!)
    return function read_uint32() {
        value = (this.buf[this.pos] & 127) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) << 7) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) << 14) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) << 21) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 15) << 28) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        /* istanbul ignore if */ if ((this.pos += 5) > this.len) {
            this.pos = this.len;
            throw $7b53a487bcbd6686$var$indexOutOfRange(this, 10);
        }
        return value;
    };
}();
/**
 * Reads a varint as a signed 32 bit value.
 * @returns {number} Value read
 */ $7b53a487bcbd6686$var$Reader.prototype.int32 = function read_int32() {
    return this.uint32() | 0;
};
/**
 * Reads a zig-zag encoded varint as a signed 32 bit value.
 * @returns {number} Value read
 */ $7b53a487bcbd6686$var$Reader.prototype.sint32 = function read_sint32() {
    var value = this.uint32();
    return value >>> 1 ^ -(value & 1) | 0;
};
/* eslint-disable no-invalid-this */ function $7b53a487bcbd6686$var$readLongVarint() {
    // tends to deopt with local vars for octet etc.
    var bits = new $7b53a487bcbd6686$var$LongBits(0, 0);
    var i = 0;
    if (this.len - this.pos > 4) {
        for(; i < 4; ++i){
            // 1st..4th
            bits.lo = (bits.lo | (this.buf[this.pos] & 127) << i * 7) >>> 0;
            if (this.buf[this.pos++] < 128) return bits;
        }
        // 5th
        bits.lo = (bits.lo | (this.buf[this.pos] & 127) << 28) >>> 0;
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) >> 4) >>> 0;
        if (this.buf[this.pos++] < 128) return bits;
        i = 0;
    } else {
        for(; i < 3; ++i){
            /* istanbul ignore if */ if (this.pos >= this.len) throw $7b53a487bcbd6686$var$indexOutOfRange(this);
            // 1st..3th
            bits.lo = (bits.lo | (this.buf[this.pos] & 127) << i * 7) >>> 0;
            if (this.buf[this.pos++] < 128) return bits;
        }
        // 4th
        bits.lo = (bits.lo | (this.buf[this.pos++] & 127) << i * 7) >>> 0;
        return bits;
    }
    if (this.len - this.pos > 4) for(; i < 5; ++i){
        // 6th..10th
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) << i * 7 + 3) >>> 0;
        if (this.buf[this.pos++] < 128) return bits;
    }
    else for(; i < 5; ++i){
        /* istanbul ignore if */ if (this.pos >= this.len) throw $7b53a487bcbd6686$var$indexOutOfRange(this);
        // 6th..10th
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) << i * 7 + 3) >>> 0;
        if (this.buf[this.pos++] < 128) return bits;
    }
    /* istanbul ignore next */ throw Error("invalid varint encoding");
}
/* eslint-enable no-invalid-this */ /**
 * Reads a varint as a signed 64 bit value.
 * @name Reader#int64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a varint as an unsigned 64 bit value.
 * @name Reader#uint64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a zig-zag encoded varint as a signed 64 bit value.
 * @name Reader#sint64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a varint as a boolean.
 * @returns {boolean} Value read
 */ $7b53a487bcbd6686$var$Reader.prototype.bool = function read_bool() {
    return this.uint32() !== 0;
};
function $7b53a487bcbd6686$var$readFixed32_end(buf, end) {
    return (buf[end - 4] | buf[end - 3] << 8 | buf[end - 2] << 16 | buf[end - 1] << 24) >>> 0;
}
/**
 * Reads fixed 32 bits as an unsigned 32 bit integer.
 * @returns {number} Value read
 */ $7b53a487bcbd6686$var$Reader.prototype.fixed32 = function read_fixed32() {
    /* istanbul ignore if */ if (this.pos + 4 > this.len) throw $7b53a487bcbd6686$var$indexOutOfRange(this, 4);
    return $7b53a487bcbd6686$var$readFixed32_end(this.buf, this.pos += 4);
};
/**
 * Reads fixed 32 bits as a signed 32 bit integer.
 * @returns {number} Value read
 */ $7b53a487bcbd6686$var$Reader.prototype.sfixed32 = function read_sfixed32() {
    /* istanbul ignore if */ if (this.pos + 4 > this.len) throw $7b53a487bcbd6686$var$indexOutOfRange(this, 4);
    return $7b53a487bcbd6686$var$readFixed32_end(this.buf, this.pos += 4) | 0;
};
/* eslint-disable no-invalid-this */ function $7b53a487bcbd6686$var$readFixed64() {
    /* istanbul ignore if */ if (this.pos + 8 > this.len) throw $7b53a487bcbd6686$var$indexOutOfRange(this, 8);
    return new $7b53a487bcbd6686$var$LongBits($7b53a487bcbd6686$var$readFixed32_end(this.buf, this.pos += 4), $7b53a487bcbd6686$var$readFixed32_end(this.buf, this.pos += 4));
}
/* eslint-enable no-invalid-this */ /**
 * Reads fixed 64 bits.
 * @name Reader#fixed64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads zig-zag encoded fixed 64 bits.
 * @name Reader#sfixed64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a float (32 bit) as a number.
 * @function
 * @returns {number} Value read
 */ $7b53a487bcbd6686$var$Reader.prototype.float = function read_float() {
    /* istanbul ignore if */ if (this.pos + 4 > this.len) throw $7b53a487bcbd6686$var$indexOutOfRange(this, 4);
    var value = $hZopo.float.readFloatLE(this.buf, this.pos);
    this.pos += 4;
    return value;
};
/**
 * Reads a double (64 bit float) as a number.
 * @function
 * @returns {number} Value read
 */ $7b53a487bcbd6686$var$Reader.prototype.double = function read_double() {
    /* istanbul ignore if */ if (this.pos + 8 > this.len) throw $7b53a487bcbd6686$var$indexOutOfRange(this, 4);
    var value = $hZopo.float.readDoubleLE(this.buf, this.pos);
    this.pos += 8;
    return value;
};
/**
 * Reads a sequence of bytes preceeded by its length as a varint.
 * @returns {Uint8Array} Value read
 */ $7b53a487bcbd6686$var$Reader.prototype.bytes = function read_bytes() {
    var length = this.uint32(), start = this.pos, end = this.pos + length;
    /* istanbul ignore if */ if (end > this.len) throw $7b53a487bcbd6686$var$indexOutOfRange(this, length);
    this.pos += length;
    if (Array.isArray(this.buf)) return this.buf.slice(start, end);
    return start === end // fix for IE 10/Win8 and others' subarray returning array of size 1
     ? new this.buf.constructor(0) : this._slice.call(this.buf, start, end);
};
/**
 * Reads a string preceeded by its byte length as a varint.
 * @returns {string} Value read
 */ $7b53a487bcbd6686$var$Reader.prototype.string = function read_string() {
    var bytes = this.bytes();
    return $7b53a487bcbd6686$var$utf8.read(bytes, 0, bytes.length);
};
/**
 * Skips the specified number of bytes if specified, otherwise skips a varint.
 * @param {number} [length] Length if known, otherwise a varint is assumed
 * @returns {Reader} `this`
 */ $7b53a487bcbd6686$var$Reader.prototype.skip = function skip(length) {
    if (typeof length === "number") {
        /* istanbul ignore if */ if (this.pos + length > this.len) throw $7b53a487bcbd6686$var$indexOutOfRange(this, length);
        this.pos += length;
    } else do {
        /* istanbul ignore if */ if (this.pos >= this.len) throw $7b53a487bcbd6686$var$indexOutOfRange(this);
    }while (this.buf[this.pos++] & 128);
    return this;
};
/**
 * Skips the next element of the specified wire type.
 * @param {number} wireType Wire type received
 * @returns {Reader} `this`
 */ $7b53a487bcbd6686$var$Reader.prototype.skipType = function(wireType) {
    switch(wireType){
        case 0:
            this.skip();
            break;
        case 1:
            this.skip(8);
            break;
        case 2:
            this.skip(this.uint32());
            break;
        case 3:
            while((wireType = this.uint32() & 7) !== 4)this.skipType(wireType);
            break;
        case 5:
            this.skip(4);
            break;
        /* istanbul ignore next */ default:
            throw Error("invalid wire type " + wireType + " at offset " + this.pos);
    }
    return this;
};
$7b53a487bcbd6686$var$Reader._configure = function(BufferReader_) {
    $7b53a487bcbd6686$var$BufferReader = BufferReader_;
    $7b53a487bcbd6686$var$Reader.create = $7b53a487bcbd6686$var$create();
    $7b53a487bcbd6686$var$BufferReader._configure();
    var fn = $hZopo.Long ? "toLong" : /* istanbul ignore next */ "toNumber";
    $hZopo.merge($7b53a487bcbd6686$var$Reader.prototype, {
        int64: function read_int64() {
            return $7b53a487bcbd6686$var$readLongVarint.call(this)[fn](false);
        },
        uint64: function read_uint64() {
            return $7b53a487bcbd6686$var$readLongVarint.call(this)[fn](true);
        },
        sint64: function read_sint64() {
            return $7b53a487bcbd6686$var$readLongVarint.call(this).zzDecode()[fn](false);
        },
        fixed64: function read_fixed64() {
            return $7b53a487bcbd6686$var$readFixed64.call(this)[fn](true);
        },
        sfixed64: function read_sfixed64() {
            return $7b53a487bcbd6686$var$readFixed64.call(this)[fn](false);
        }
    });
};

});

parcelRegister("50bs2", function(module, exports) {
"use strict";
module.exports = $3a45d5cf2d190029$var$BufferReader;

var $aAsQy = parcelRequire("aAsQy");
($3a45d5cf2d190029$var$BufferReader.prototype = Object.create($aAsQy.prototype)).constructor = $3a45d5cf2d190029$var$BufferReader;

var $hZopo = parcelRequire("hZopo");
/**
 * Constructs a new buffer reader instance.
 * @classdesc Wire format reader using node buffers.
 * @extends Reader
 * @constructor
 * @param {Buffer} buffer Buffer to read from
 */ function $3a45d5cf2d190029$var$BufferReader(buffer) {
    $aAsQy.call(this, buffer);
/**
     * Read buffer.
     * @name BufferReader#buf
     * @type {Buffer}
     */ }
$3a45d5cf2d190029$var$BufferReader._configure = function() {
    /* istanbul ignore else */ if ($hZopo.Buffer) $3a45d5cf2d190029$var$BufferReader.prototype._slice = $hZopo.Buffer.prototype.slice;
};
/**
 * @override
 */ $3a45d5cf2d190029$var$BufferReader.prototype.string = function read_string_buffer() {
    var len = this.uint32(); // modifies pos
    return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + len, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + len, this.len));
};
/**
 * Reads a sequence of bytes preceeded by its length as a varint.
 * @name BufferReader#bytes
 * @function
 * @returns {Buffer} Value read
 */ $3a45d5cf2d190029$var$BufferReader._configure();

});

parcelRegister("2Wwl8", function(module, exports) {
"use strict";
/**
 * Streaming RPC helpers.
 * @namespace
 */ var $224a158f25a0714c$var$rpc = module.exports;

/**
 * RPC implementation passed to {@link Service#create} performing a service request on network level, i.e. by utilizing http requests or websockets.
 * @typedef RPCImpl
 * @type {function}
 * @param {Method|rpc.ServiceMethod<Message<{}>,Message<{}>>} method Reflected or static method being called
 * @param {Uint8Array} requestData Request data
 * @param {RPCImplCallback} callback Callback function
 * @returns {undefined}
 * @example
 * function rpcImpl(method, requestData, callback) {
 *     if (protobuf.util.lcFirst(method.name) !== "myMethod") // compatible with static code
 *         throw Error("no such method");
 *     asynchronouslyObtainAResponse(requestData, function(err, responseData) {
 *         callback(err, responseData);
 *     });
 * }
 */ /**
 * Node-style callback as used by {@link RPCImpl}.
 * @typedef RPCImplCallback
 * @type {function}
 * @param {Error|null} error Error, if any, otherwise `null`
 * @param {Uint8Array|null} [response] Response data or `null` to signal end of stream, if there hasn't been an error
 * @returns {undefined}
 */ $224a158f25a0714c$var$rpc.Service = (parcelRequire("g6DHc"));

});
parcelRegister("g6DHc", function(module, exports) {
"use strict";
module.exports = $bb9bffa4633771d2$var$Service;

var $hZopo = parcelRequire("hZopo");
// Extends EventEmitter
($bb9bffa4633771d2$var$Service.prototype = Object.create($hZopo.EventEmitter.prototype)).constructor = $bb9bffa4633771d2$var$Service;
/**
 * A service method callback as used by {@link rpc.ServiceMethod|ServiceMethod}.
 *
 * Differs from {@link RPCImplCallback} in that it is an actual callback of a service method which may not return `response = null`.
 * @typedef rpc.ServiceMethodCallback
 * @template TRes extends Message<TRes>
 * @type {function}
 * @param {Error|null} error Error, if any
 * @param {TRes} [response] Response message
 * @returns {undefined}
 */ /**
 * A service method part of a {@link rpc.Service} as created by {@link Service.create}.
 * @typedef rpc.ServiceMethod
 * @template TReq extends Message<TReq>
 * @template TRes extends Message<TRes>
 * @type {function}
 * @param {TReq|Properties<TReq>} request Request message or plain object
 * @param {rpc.ServiceMethodCallback<TRes>} [callback] Node-style callback called with the error, if any, and the response message
 * @returns {Promise<Message<TRes>>} Promise if `callback` has been omitted, otherwise `undefined`
 */ /**
 * Constructs a new RPC service instance.
 * @classdesc An RPC service as returned by {@link Service#create}.
 * @exports rpc.Service
 * @extends util.EventEmitter
 * @constructor
 * @param {RPCImpl} rpcImpl RPC implementation
 * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
 * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
 */ function $bb9bffa4633771d2$var$Service(rpcImpl, requestDelimited, responseDelimited) {
    if (typeof rpcImpl !== "function") throw TypeError("rpcImpl must be a function");
    $hZopo.EventEmitter.call(this);
    /**
     * RPC implementation. Becomes `null` once the service is ended.
     * @type {RPCImpl|null}
     */ this.rpcImpl = rpcImpl;
    /**
     * Whether requests are length-delimited.
     * @type {boolean}
     */ this.requestDelimited = Boolean(requestDelimited);
    /**
     * Whether responses are length-delimited.
     * @type {boolean}
     */ this.responseDelimited = Boolean(responseDelimited);
}
/**
 * Calls a service method through {@link rpc.Service#rpcImpl|rpcImpl}.
 * @param {Method|rpc.ServiceMethod<TReq,TRes>} method Reflected or static method
 * @param {Constructor<TReq>} requestCtor Request constructor
 * @param {Constructor<TRes>} responseCtor Response constructor
 * @param {TReq|Properties<TReq>} request Request message or plain object
 * @param {rpc.ServiceMethodCallback<TRes>} callback Service callback
 * @returns {undefined}
 * @template TReq extends Message<TReq>
 * @template TRes extends Message<TRes>
 */ $bb9bffa4633771d2$var$Service.prototype.rpcCall = function rpcCall(method, requestCtor, responseCtor, request, callback) {
    if (!request) throw TypeError("request must be specified");
    var self = this;
    if (!callback) return $hZopo.asPromise(rpcCall, self, method, requestCtor, responseCtor, request);
    if (!self.rpcImpl) {
        setTimeout(function() {
            callback(Error("already ended"));
        }, 0);
        return undefined;
    }
    try {
        return self.rpcImpl(method, requestCtor[self.requestDelimited ? "encodeDelimited" : "encode"](request).finish(), function rpcCallback(err, response) {
            if (err) {
                self.emit("error", err, method);
                return callback(err);
            }
            if (response === null) {
                self.end(/* endedByRPC */ true);
                return undefined;
            }
            if (!(response instanceof responseCtor)) try {
                response = responseCtor[self.responseDelimited ? "decodeDelimited" : "decode"](response);
            } catch (err) {
                self.emit("error", err, method);
                return callback(err);
            }
            self.emit("data", response, method);
            return callback(null, response);
        });
    } catch (err) {
        self.emit("error", err, method);
        setTimeout(function() {
            callback(err);
        }, 0);
        return undefined;
    }
};
/**
 * Ends this service and emits the `end` event.
 * @param {boolean} [endedByRPC=false] Whether the service has been ended by the RPC implementation.
 * @returns {rpc.Service} `this`
 */ $bb9bffa4633771d2$var$Service.prototype.end = function end(endedByRPC) {
    if (this.rpcImpl) {
        if (!endedByRPC) this.rpcImpl(null, null, null);
        this.rpcImpl = null;
        this.emit("end").off();
    }
    return this;
};

});


parcelRegister("fM1Ek", function(module, exports) {
"use strict";
module.exports = {}; /**
 * Named roots.
 * This is where pbjs stores generated structures (the option `-r, --root` specifies a name).
 * Can also be used manually to make roots available accross modules.
 * @name roots
 * @type {Object.<string,Root>}
 * @example
 * // pbjs -r myroot -o compiled.js ...
 *
 * // in another module:
 * require("./compiled.js");
 *
 * // in any subsequent module:
 * var root = protobuf.roots["myroot"];
 */ 

});



parcelRegister("7LFKz", function(module, exports) {

$parcel$export(module.exports, "byteLength", function () { return $5a7d4ee62d502cb1$export$a48f0734ac7c2329; }, function (v) { return $5a7d4ee62d502cb1$export$a48f0734ac7c2329 = v; });
$parcel$export(module.exports, "toByteArray", function () { return $5a7d4ee62d502cb1$export$d622b2ad8d90c771; }, function (v) { return $5a7d4ee62d502cb1$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $5a7d4ee62d502cb1$export$6100ba28696e12de; }, function (v) { return $5a7d4ee62d502cb1$export$6100ba28696e12de = v; });
var $5a7d4ee62d502cb1$export$a48f0734ac7c2329;
var $5a7d4ee62d502cb1$export$d622b2ad8d90c771;
var $5a7d4ee62d502cb1$export$6100ba28696e12de;
"use strict";
$5a7d4ee62d502cb1$export$a48f0734ac7c2329 = $5a7d4ee62d502cb1$var$byteLength;
$5a7d4ee62d502cb1$export$d622b2ad8d90c771 = $5a7d4ee62d502cb1$var$toByteArray;
$5a7d4ee62d502cb1$export$6100ba28696e12de = $5a7d4ee62d502cb1$var$fromByteArray;
var $5a7d4ee62d502cb1$var$lookup = [];
var $5a7d4ee62d502cb1$var$revLookup = [];
var $5a7d4ee62d502cb1$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $5a7d4ee62d502cb1$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $5a7d4ee62d502cb1$var$i = 0, $5a7d4ee62d502cb1$var$len = $5a7d4ee62d502cb1$var$code.length; $5a7d4ee62d502cb1$var$i < $5a7d4ee62d502cb1$var$len; ++$5a7d4ee62d502cb1$var$i){
    $5a7d4ee62d502cb1$var$lookup[$5a7d4ee62d502cb1$var$i] = $5a7d4ee62d502cb1$var$code[$5a7d4ee62d502cb1$var$i];
    $5a7d4ee62d502cb1$var$revLookup[$5a7d4ee62d502cb1$var$code.charCodeAt($5a7d4ee62d502cb1$var$i)] = $5a7d4ee62d502cb1$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$5a7d4ee62d502cb1$var$revLookup["-".charCodeAt(0)] = 62;
$5a7d4ee62d502cb1$var$revLookup["_".charCodeAt(0)] = 63;
function $5a7d4ee62d502cb1$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $5a7d4ee62d502cb1$var$byteLength(b64) {
    var lens = $5a7d4ee62d502cb1$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $5a7d4ee62d502cb1$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $5a7d4ee62d502cb1$var$toByteArray(b64) {
    var tmp;
    var lens = $5a7d4ee62d502cb1$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $5a7d4ee62d502cb1$var$Arr($5a7d4ee62d502cb1$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i)] << 18 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i)] << 2 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i)] << 10 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $5a7d4ee62d502cb1$var$tripletToBase64(num) {
    return $5a7d4ee62d502cb1$var$lookup[num >> 18 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[num >> 12 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[num >> 6 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[num & 0x3F];
}
function $5a7d4ee62d502cb1$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($5a7d4ee62d502cb1$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $5a7d4ee62d502cb1$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($5a7d4ee62d502cb1$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($5a7d4ee62d502cb1$var$lookup[tmp >> 2] + $5a7d4ee62d502cb1$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($5a7d4ee62d502cb1$var$lookup[tmp >> 10] + $5a7d4ee62d502cb1$var$lookup[tmp >> 4 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("guCs7", function(module, exports) {
"use strict";
var $c01d4687d4f4d3ac$var$ALPHABET = "qpzry9x8gf2tvdw0s3jn54khce6mua7l";
// pre-compute lookup table
var $c01d4687d4f4d3ac$var$ALPHABET_MAP = {};
for(var $c01d4687d4f4d3ac$var$z = 0; $c01d4687d4f4d3ac$var$z < $c01d4687d4f4d3ac$var$ALPHABET.length; $c01d4687d4f4d3ac$var$z++){
    var $c01d4687d4f4d3ac$var$x = $c01d4687d4f4d3ac$var$ALPHABET.charAt($c01d4687d4f4d3ac$var$z);
    if ($c01d4687d4f4d3ac$var$ALPHABET_MAP[$c01d4687d4f4d3ac$var$x] !== undefined) throw new TypeError($c01d4687d4f4d3ac$var$x + " is ambiguous");
    $c01d4687d4f4d3ac$var$ALPHABET_MAP[$c01d4687d4f4d3ac$var$x] = $c01d4687d4f4d3ac$var$z;
}
function $c01d4687d4f4d3ac$var$polymodStep(pre) {
    var b = pre >> 25;
    return (pre & 0x1FFFFFF) << 5 ^ -(b >> 0 & 1) & 0x3b6a57b2 ^ -(b >> 1 & 1) & 0x26508e6d ^ -(b >> 2 & 1) & 0x1ea119fa ^ -(b >> 3 & 1) & 0x3d4233dd ^ -(b >> 4 & 1) & 0x2a1462b3;
}
function $c01d4687d4f4d3ac$var$prefixChk(prefix) {
    var chk = 1;
    for(var i = 0; i < prefix.length; ++i){
        var c = prefix.charCodeAt(i);
        if (c < 33 || c > 126) return "Invalid prefix (" + prefix + ")";
        chk = $c01d4687d4f4d3ac$var$polymodStep(chk) ^ c >> 5;
    }
    chk = $c01d4687d4f4d3ac$var$polymodStep(chk);
    for(i = 0; i < prefix.length; ++i){
        var v = prefix.charCodeAt(i);
        chk = $c01d4687d4f4d3ac$var$polymodStep(chk) ^ v & 0x1f;
    }
    return chk;
}
function $c01d4687d4f4d3ac$var$encode(prefix, words, LIMIT) {
    LIMIT = LIMIT || 90;
    if (prefix.length + 7 + words.length > LIMIT) throw new TypeError("Exceeds length limit");
    prefix = prefix.toLowerCase();
    // determine chk mod
    var chk = $c01d4687d4f4d3ac$var$prefixChk(prefix);
    if (typeof chk === "string") throw new Error(chk);
    var result = prefix + "1";
    for(var i = 0; i < words.length; ++i){
        var x = words[i];
        if (x >> 5 !== 0) throw new Error("Non 5-bit word");
        chk = $c01d4687d4f4d3ac$var$polymodStep(chk) ^ x;
        result += $c01d4687d4f4d3ac$var$ALPHABET.charAt(x);
    }
    for(i = 0; i < 6; ++i)chk = $c01d4687d4f4d3ac$var$polymodStep(chk);
    chk ^= 1;
    for(i = 0; i < 6; ++i){
        var v = chk >> (5 - i) * 5 & 0x1f;
        result += $c01d4687d4f4d3ac$var$ALPHABET.charAt(v);
    }
    return result;
}
function $c01d4687d4f4d3ac$var$__decode(str, LIMIT) {
    LIMIT = LIMIT || 90;
    if (str.length < 8) return str + " too short";
    if (str.length > LIMIT) return "Exceeds length limit";
    // don't allow mixed case
    var lowered = str.toLowerCase();
    var uppered = str.toUpperCase();
    if (str !== lowered && str !== uppered) return "Mixed-case string " + str;
    str = lowered;
    var split = str.lastIndexOf("1");
    if (split === -1) return "No separator character for " + str;
    if (split === 0) return "Missing prefix for " + str;
    var prefix = str.slice(0, split);
    var wordChars = str.slice(split + 1);
    if (wordChars.length < 6) return "Data too short";
    var chk = $c01d4687d4f4d3ac$var$prefixChk(prefix);
    if (typeof chk === "string") return chk;
    var words = [];
    for(var i = 0; i < wordChars.length; ++i){
        var c = wordChars.charAt(i);
        var v = $c01d4687d4f4d3ac$var$ALPHABET_MAP[c];
        if (v === undefined) return "Unknown character " + c;
        chk = $c01d4687d4f4d3ac$var$polymodStep(chk) ^ v;
        // not in the checksum?
        if (i + 6 >= wordChars.length) continue;
        words.push(v);
    }
    if (chk !== 1) return "Invalid checksum for " + str;
    return {
        prefix: prefix,
        words: words
    };
}
function $c01d4687d4f4d3ac$var$decodeUnsafe() {
    var res = $c01d4687d4f4d3ac$var$__decode.apply(null, arguments);
    if (typeof res === "object") return res;
}
function $c01d4687d4f4d3ac$var$decode(str) {
    var res = $c01d4687d4f4d3ac$var$__decode.apply(null, arguments);
    if (typeof res === "object") return res;
    throw new Error(res);
}
function $c01d4687d4f4d3ac$var$convert(data, inBits, outBits, pad) {
    var value = 0;
    var bits = 0;
    var maxV = (1 << outBits) - 1;
    var result = [];
    for(var i = 0; i < data.length; ++i){
        value = value << inBits | data[i];
        bits += inBits;
        while(bits >= outBits){
            bits -= outBits;
            result.push(value >> bits & maxV);
        }
    }
    if (pad) {
        if (bits > 0) result.push(value << outBits - bits & maxV);
    } else {
        if (bits >= inBits) return "Excess padding";
        if (value << outBits - bits & maxV) return "Non-zero padding";
    }
    return result;
}
function $c01d4687d4f4d3ac$var$toWordsUnsafe(bytes) {
    var res = $c01d4687d4f4d3ac$var$convert(bytes, 8, 5, true);
    if (Array.isArray(res)) return res;
}
function $c01d4687d4f4d3ac$var$toWords(bytes) {
    var res = $c01d4687d4f4d3ac$var$convert(bytes, 8, 5, true);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
function $c01d4687d4f4d3ac$var$fromWordsUnsafe(words) {
    var res = $c01d4687d4f4d3ac$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
}
function $c01d4687d4f4d3ac$var$fromWords(words) {
    var res = $c01d4687d4f4d3ac$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
module.exports = {
    decodeUnsafe: $c01d4687d4f4d3ac$var$decodeUnsafe,
    decode: $c01d4687d4f4d3ac$var$decode,
    encode: $c01d4687d4f4d3ac$var$encode,
    toWordsUnsafe: $c01d4687d4f4d3ac$var$toWordsUnsafe,
    toWords: $c01d4687d4f4d3ac$var$toWords,
    fromWordsUnsafe: $c01d4687d4f4d3ac$var$fromWordsUnsafe,
    fromWords: $c01d4687d4f4d3ac$var$fromWords
};

});

parcelRegister("l8YtI", function(module, exports) {

!function(e) {
    function r(e, r) {
        "use strict";
        var t, a = "uint8array", _ = r.ready.then(function() {
            function a() {
                if (0 !== t._sodium_init()) throw new Error("libsodium was not correctly initialized.");
                for(var r = [
                    "crypto_aead_aegis128l_decrypt",
                    "crypto_aead_aegis128l_decrypt_detached",
                    "crypto_aead_aegis128l_encrypt",
                    "crypto_aead_aegis128l_encrypt_detached",
                    "crypto_aead_aegis128l_keygen",
                    "crypto_aead_aegis256_decrypt",
                    "crypto_aead_aegis256_decrypt_detached",
                    "crypto_aead_aegis256_encrypt",
                    "crypto_aead_aegis256_encrypt_detached",
                    "crypto_aead_aegis256_keygen",
                    "crypto_aead_chacha20poly1305_decrypt",
                    "crypto_aead_chacha20poly1305_decrypt_detached",
                    "crypto_aead_chacha20poly1305_encrypt",
                    "crypto_aead_chacha20poly1305_encrypt_detached",
                    "crypto_aead_chacha20poly1305_ietf_decrypt",
                    "crypto_aead_chacha20poly1305_ietf_decrypt_detached",
                    "crypto_aead_chacha20poly1305_ietf_encrypt",
                    "crypto_aead_chacha20poly1305_ietf_encrypt_detached",
                    "crypto_aead_chacha20poly1305_ietf_keygen",
                    "crypto_aead_chacha20poly1305_keygen",
                    "crypto_aead_xchacha20poly1305_ietf_decrypt",
                    "crypto_aead_xchacha20poly1305_ietf_decrypt_detached",
                    "crypto_aead_xchacha20poly1305_ietf_encrypt",
                    "crypto_aead_xchacha20poly1305_ietf_encrypt_detached",
                    "crypto_aead_xchacha20poly1305_ietf_keygen",
                    "crypto_auth",
                    "crypto_auth_hmacsha256",
                    "crypto_auth_hmacsha256_final",
                    "crypto_auth_hmacsha256_init",
                    "crypto_auth_hmacsha256_keygen",
                    "crypto_auth_hmacsha256_update",
                    "crypto_auth_hmacsha256_verify",
                    "crypto_auth_hmacsha512",
                    "crypto_auth_hmacsha512_final",
                    "crypto_auth_hmacsha512_init",
                    "crypto_auth_hmacsha512_keygen",
                    "crypto_auth_hmacsha512_update",
                    "crypto_auth_hmacsha512_verify",
                    "crypto_auth_keygen",
                    "crypto_auth_verify",
                    "crypto_box_beforenm",
                    "crypto_box_curve25519xchacha20poly1305_beforenm",
                    "crypto_box_curve25519xchacha20poly1305_detached",
                    "crypto_box_curve25519xchacha20poly1305_detached_afternm",
                    "crypto_box_curve25519xchacha20poly1305_easy",
                    "crypto_box_curve25519xchacha20poly1305_easy_afternm",
                    "crypto_box_curve25519xchacha20poly1305_keypair",
                    "crypto_box_curve25519xchacha20poly1305_open_detached",
                    "crypto_box_curve25519xchacha20poly1305_open_detached_afternm",
                    "crypto_box_curve25519xchacha20poly1305_open_easy",
                    "crypto_box_curve25519xchacha20poly1305_open_easy_afternm",
                    "crypto_box_curve25519xchacha20poly1305_seal",
                    "crypto_box_curve25519xchacha20poly1305_seal_open",
                    "crypto_box_curve25519xchacha20poly1305_seed_keypair",
                    "crypto_box_detached",
                    "crypto_box_easy",
                    "crypto_box_easy_afternm",
                    "crypto_box_keypair",
                    "crypto_box_open_detached",
                    "crypto_box_open_easy",
                    "crypto_box_open_easy_afternm",
                    "crypto_box_seal",
                    "crypto_box_seal_open",
                    "crypto_box_seed_keypair",
                    "crypto_core_ed25519_add",
                    "crypto_core_ed25519_from_hash",
                    "crypto_core_ed25519_from_uniform",
                    "crypto_core_ed25519_is_valid_point",
                    "crypto_core_ed25519_random",
                    "crypto_core_ed25519_scalar_add",
                    "crypto_core_ed25519_scalar_complement",
                    "crypto_core_ed25519_scalar_invert",
                    "crypto_core_ed25519_scalar_mul",
                    "crypto_core_ed25519_scalar_negate",
                    "crypto_core_ed25519_scalar_random",
                    "crypto_core_ed25519_scalar_reduce",
                    "crypto_core_ed25519_scalar_sub",
                    "crypto_core_ed25519_sub",
                    "crypto_core_hchacha20",
                    "crypto_core_hsalsa20",
                    "crypto_core_ristretto255_add",
                    "crypto_core_ristretto255_from_hash",
                    "crypto_core_ristretto255_is_valid_point",
                    "crypto_core_ristretto255_random",
                    "crypto_core_ristretto255_scalar_add",
                    "crypto_core_ristretto255_scalar_complement",
                    "crypto_core_ristretto255_scalar_invert",
                    "crypto_core_ristretto255_scalar_mul",
                    "crypto_core_ristretto255_scalar_negate",
                    "crypto_core_ristretto255_scalar_random",
                    "crypto_core_ristretto255_scalar_reduce",
                    "crypto_core_ristretto255_scalar_sub",
                    "crypto_core_ristretto255_sub",
                    "crypto_generichash",
                    "crypto_generichash_blake2b_salt_personal",
                    "crypto_generichash_final",
                    "crypto_generichash_init",
                    "crypto_generichash_keygen",
                    "crypto_generichash_update",
                    "crypto_hash",
                    "crypto_hash_sha256",
                    "crypto_hash_sha256_final",
                    "crypto_hash_sha256_init",
                    "crypto_hash_sha256_update",
                    "crypto_hash_sha512",
                    "crypto_hash_sha512_final",
                    "crypto_hash_sha512_init",
                    "crypto_hash_sha512_update",
                    "crypto_kdf_derive_from_key",
                    "crypto_kdf_keygen",
                    "crypto_kx_client_session_keys",
                    "crypto_kx_keypair",
                    "crypto_kx_seed_keypair",
                    "crypto_kx_server_session_keys",
                    "crypto_onetimeauth",
                    "crypto_onetimeauth_final",
                    "crypto_onetimeauth_init",
                    "crypto_onetimeauth_keygen",
                    "crypto_onetimeauth_update",
                    "crypto_onetimeauth_verify",
                    "crypto_pwhash",
                    "crypto_pwhash_scryptsalsa208sha256",
                    "crypto_pwhash_scryptsalsa208sha256_ll",
                    "crypto_pwhash_scryptsalsa208sha256_str",
                    "crypto_pwhash_scryptsalsa208sha256_str_verify",
                    "crypto_pwhash_str",
                    "crypto_pwhash_str_needs_rehash",
                    "crypto_pwhash_str_verify",
                    "crypto_scalarmult",
                    "crypto_scalarmult_base",
                    "crypto_scalarmult_ed25519",
                    "crypto_scalarmult_ed25519_base",
                    "crypto_scalarmult_ed25519_base_noclamp",
                    "crypto_scalarmult_ed25519_noclamp",
                    "crypto_scalarmult_ristretto255",
                    "crypto_scalarmult_ristretto255_base",
                    "crypto_secretbox_detached",
                    "crypto_secretbox_easy",
                    "crypto_secretbox_keygen",
                    "crypto_secretbox_open_detached",
                    "crypto_secretbox_open_easy",
                    "crypto_secretstream_xchacha20poly1305_init_pull",
                    "crypto_secretstream_xchacha20poly1305_init_push",
                    "crypto_secretstream_xchacha20poly1305_keygen",
                    "crypto_secretstream_xchacha20poly1305_pull",
                    "crypto_secretstream_xchacha20poly1305_push",
                    "crypto_secretstream_xchacha20poly1305_rekey",
                    "crypto_shorthash",
                    "crypto_shorthash_keygen",
                    "crypto_shorthash_siphashx24",
                    "crypto_sign",
                    "crypto_sign_detached",
                    "crypto_sign_ed25519_pk_to_curve25519",
                    "crypto_sign_ed25519_sk_to_curve25519",
                    "crypto_sign_ed25519_sk_to_pk",
                    "crypto_sign_ed25519_sk_to_seed",
                    "crypto_sign_final_create",
                    "crypto_sign_final_verify",
                    "crypto_sign_init",
                    "crypto_sign_keypair",
                    "crypto_sign_open",
                    "crypto_sign_seed_keypair",
                    "crypto_sign_update",
                    "crypto_sign_verify_detached",
                    "crypto_stream_chacha20",
                    "crypto_stream_chacha20_ietf_xor",
                    "crypto_stream_chacha20_ietf_xor_ic",
                    "crypto_stream_chacha20_keygen",
                    "crypto_stream_chacha20_xor",
                    "crypto_stream_chacha20_xor_ic",
                    "crypto_stream_keygen",
                    "crypto_stream_xchacha20_keygen",
                    "crypto_stream_xchacha20_xor",
                    "crypto_stream_xchacha20_xor_ic",
                    "randombytes_buf",
                    "randombytes_buf_deterministic",
                    "randombytes_close",
                    "randombytes_random",
                    "randombytes_set_implementation",
                    "randombytes_stir",
                    "randombytes_uniform",
                    "sodium_version_string"
                ], a = [
                    E,
                    k,
                    S,
                    T,
                    w,
                    Y,
                    B,
                    A,
                    K,
                    M,
                    I,
                    N,
                    L,
                    U,
                    O,
                    C,
                    R,
                    P,
                    G,
                    X,
                    D,
                    F,
                    V,
                    H,
                    q,
                    j,
                    z,
                    W,
                    J,
                    Q,
                    Z,
                    $,
                    ee,
                    re,
                    te,
                    ae,
                    _e,
                    ne,
                    se,
                    ce,
                    oe,
                    he,
                    pe,
                    ye,
                    ie,
                    le,
                    ue,
                    de,
                    ve,
                    ge,
                    be,
                    fe,
                    me,
                    xe,
                    Ee,
                    ke,
                    Se,
                    Te,
                    we,
                    Ye,
                    Be,
                    Ae,
                    Ke,
                    Me,
                    Ie,
                    Ne,
                    Le,
                    Ue,
                    Oe,
                    Ce,
                    Re,
                    Pe,
                    Ge,
                    Xe,
                    De,
                    Fe,
                    Ve,
                    He,
                    qe,
                    je,
                    ze,
                    We,
                    Je,
                    Qe,
                    Ze,
                    $e,
                    er,
                    rr,
                    tr,
                    ar,
                    _r,
                    nr,
                    sr,
                    cr,
                    or,
                    hr,
                    pr,
                    yr,
                    ir,
                    lr,
                    ur,
                    dr,
                    vr,
                    gr,
                    br,
                    fr,
                    mr,
                    xr,
                    Er,
                    kr,
                    Sr,
                    Tr,
                    wr,
                    Yr,
                    Br,
                    Ar,
                    Kr,
                    Mr,
                    Ir,
                    Nr,
                    Lr,
                    Ur,
                    Or,
                    Cr,
                    Rr,
                    Pr,
                    Gr,
                    Xr,
                    Dr,
                    Fr,
                    Vr,
                    Hr,
                    qr,
                    jr,
                    zr,
                    Wr,
                    Jr,
                    Qr,
                    Zr,
                    $r,
                    et,
                    rt,
                    tt,
                    at,
                    _t,
                    nt,
                    st,
                    ct,
                    ot,
                    ht,
                    pt,
                    yt,
                    it,
                    lt,
                    ut,
                    dt,
                    vt,
                    gt,
                    bt,
                    ft,
                    mt,
                    xt,
                    Et,
                    kt,
                    St,
                    Tt,
                    wt,
                    Yt,
                    Bt,
                    At,
                    Kt,
                    Mt,
                    It,
                    Nt,
                    Lt,
                    Ut,
                    Ot,
                    Ct,
                    Rt,
                    Pt,
                    Gt,
                    Xt
                ], _ = 0; _ < a.length; _++)"function" == typeof t["_" + r[_]] && (e[r[_]] = a[_]);
                var n = [
                    "SODIUM_LIBRARY_VERSION_MAJOR",
                    "SODIUM_LIBRARY_VERSION_MINOR",
                    "crypto_aead_chacha20poly1305_ABYTES",
                    "crypto_aead_chacha20poly1305_IETF_ABYTES",
                    "crypto_aead_chacha20poly1305_IETF_KEYBYTES",
                    "crypto_aead_chacha20poly1305_IETF_MESSAGEBYTES_MAX",
                    "crypto_aead_chacha20poly1305_IETF_NPUBBYTES",
                    "crypto_aead_chacha20poly1305_IETF_NSECBYTES",
                    "crypto_aead_chacha20poly1305_KEYBYTES",
                    "crypto_aead_chacha20poly1305_MESSAGEBYTES_MAX",
                    "crypto_aead_chacha20poly1305_NPUBBYTES",
                    "crypto_aead_chacha20poly1305_NSECBYTES",
                    "crypto_aead_chacha20poly1305_ietf_ABYTES",
                    "crypto_aead_chacha20poly1305_ietf_KEYBYTES",
                    "crypto_aead_chacha20poly1305_ietf_MESSAGEBYTES_MAX",
                    "crypto_aead_chacha20poly1305_ietf_NPUBBYTES",
                    "crypto_aead_chacha20poly1305_ietf_NSECBYTES",
                    "crypto_aead_xchacha20poly1305_IETF_ABYTES",
                    "crypto_aead_xchacha20poly1305_IETF_KEYBYTES",
                    "crypto_aead_xchacha20poly1305_IETF_MESSAGEBYTES_MAX",
                    "crypto_aead_xchacha20poly1305_IETF_NPUBBYTES",
                    "crypto_aead_xchacha20poly1305_IETF_NSECBYTES",
                    "crypto_aead_xchacha20poly1305_ietf_ABYTES",
                    "crypto_aead_xchacha20poly1305_ietf_KEYBYTES",
                    "crypto_aead_xchacha20poly1305_ietf_MESSAGEBYTES_MAX",
                    "crypto_aead_xchacha20poly1305_ietf_NPUBBYTES",
                    "crypto_aead_xchacha20poly1305_ietf_NSECBYTES",
                    "crypto_auth_BYTES",
                    "crypto_auth_KEYBYTES",
                    "crypto_auth_hmacsha256_BYTES",
                    "crypto_auth_hmacsha256_KEYBYTES",
                    "crypto_auth_hmacsha512256_BYTES",
                    "crypto_auth_hmacsha512256_KEYBYTES",
                    "crypto_auth_hmacsha512_BYTES",
                    "crypto_auth_hmacsha512_KEYBYTES",
                    "crypto_box_BEFORENMBYTES",
                    "crypto_box_MACBYTES",
                    "crypto_box_MESSAGEBYTES_MAX",
                    "crypto_box_NONCEBYTES",
                    "crypto_box_PUBLICKEYBYTES",
                    "crypto_box_SEALBYTES",
                    "crypto_box_SECRETKEYBYTES",
                    "crypto_box_SEEDBYTES",
                    "crypto_box_curve25519xchacha20poly1305_BEFORENMBYTES",
                    "crypto_box_curve25519xchacha20poly1305_MACBYTES",
                    "crypto_box_curve25519xchacha20poly1305_MESSAGEBYTES_MAX",
                    "crypto_box_curve25519xchacha20poly1305_NONCEBYTES",
                    "crypto_box_curve25519xchacha20poly1305_PUBLICKEYBYTES",
                    "crypto_box_curve25519xchacha20poly1305_SEALBYTES",
                    "crypto_box_curve25519xchacha20poly1305_SECRETKEYBYTES",
                    "crypto_box_curve25519xchacha20poly1305_SEEDBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_BEFORENMBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_MACBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_MESSAGEBYTES_MAX",
                    "crypto_box_curve25519xsalsa20poly1305_NONCEBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_PUBLICKEYBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_SECRETKEYBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_SEEDBYTES",
                    "crypto_core_ed25519_BYTES",
                    "crypto_core_ed25519_HASHBYTES",
                    "crypto_core_ed25519_NONREDUCEDSCALARBYTES",
                    "crypto_core_ed25519_SCALARBYTES",
                    "crypto_core_ed25519_UNIFORMBYTES",
                    "crypto_core_hchacha20_CONSTBYTES",
                    "crypto_core_hchacha20_INPUTBYTES",
                    "crypto_core_hchacha20_KEYBYTES",
                    "crypto_core_hchacha20_OUTPUTBYTES",
                    "crypto_core_hsalsa20_CONSTBYTES",
                    "crypto_core_hsalsa20_INPUTBYTES",
                    "crypto_core_hsalsa20_KEYBYTES",
                    "crypto_core_hsalsa20_OUTPUTBYTES",
                    "crypto_core_ristretto255_BYTES",
                    "crypto_core_ristretto255_HASHBYTES",
                    "crypto_core_ristretto255_NONREDUCEDSCALARBYTES",
                    "crypto_core_ristretto255_SCALARBYTES",
                    "crypto_core_salsa2012_CONSTBYTES",
                    "crypto_core_salsa2012_INPUTBYTES",
                    "crypto_core_salsa2012_KEYBYTES",
                    "crypto_core_salsa2012_OUTPUTBYTES",
                    "crypto_core_salsa20_CONSTBYTES",
                    "crypto_core_salsa20_INPUTBYTES",
                    "crypto_core_salsa20_KEYBYTES",
                    "crypto_core_salsa20_OUTPUTBYTES",
                    "crypto_generichash_BYTES",
                    "crypto_generichash_BYTES_MAX",
                    "crypto_generichash_BYTES_MIN",
                    "crypto_generichash_KEYBYTES",
                    "crypto_generichash_KEYBYTES_MAX",
                    "crypto_generichash_KEYBYTES_MIN",
                    "crypto_generichash_blake2b_BYTES",
                    "crypto_generichash_blake2b_BYTES_MAX",
                    "crypto_generichash_blake2b_BYTES_MIN",
                    "crypto_generichash_blake2b_KEYBYTES",
                    "crypto_generichash_blake2b_KEYBYTES_MAX",
                    "crypto_generichash_blake2b_KEYBYTES_MIN",
                    "crypto_generichash_blake2b_PERSONALBYTES",
                    "crypto_generichash_blake2b_SALTBYTES",
                    "crypto_hash_BYTES",
                    "crypto_hash_sha256_BYTES",
                    "crypto_hash_sha512_BYTES",
                    "crypto_kdf_BYTES_MAX",
                    "crypto_kdf_BYTES_MIN",
                    "crypto_kdf_CONTEXTBYTES",
                    "crypto_kdf_KEYBYTES",
                    "crypto_kdf_blake2b_BYTES_MAX",
                    "crypto_kdf_blake2b_BYTES_MIN",
                    "crypto_kdf_blake2b_CONTEXTBYTES",
                    "crypto_kdf_blake2b_KEYBYTES",
                    "crypto_kx_PUBLICKEYBYTES",
                    "crypto_kx_SECRETKEYBYTES",
                    "crypto_kx_SEEDBYTES",
                    "crypto_kx_SESSIONKEYBYTES",
                    "crypto_onetimeauth_BYTES",
                    "crypto_onetimeauth_KEYBYTES",
                    "crypto_onetimeauth_poly1305_BYTES",
                    "crypto_onetimeauth_poly1305_KEYBYTES",
                    "crypto_pwhash_ALG_ARGON2I13",
                    "crypto_pwhash_ALG_ARGON2ID13",
                    "crypto_pwhash_ALG_DEFAULT",
                    "crypto_pwhash_BYTES_MAX",
                    "crypto_pwhash_BYTES_MIN",
                    "crypto_pwhash_MEMLIMIT_INTERACTIVE",
                    "crypto_pwhash_MEMLIMIT_MAX",
                    "crypto_pwhash_MEMLIMIT_MIN",
                    "crypto_pwhash_MEMLIMIT_MODERATE",
                    "crypto_pwhash_MEMLIMIT_SENSITIVE",
                    "crypto_pwhash_OPSLIMIT_INTERACTIVE",
                    "crypto_pwhash_OPSLIMIT_MAX",
                    "crypto_pwhash_OPSLIMIT_MIN",
                    "crypto_pwhash_OPSLIMIT_MODERATE",
                    "crypto_pwhash_OPSLIMIT_SENSITIVE",
                    "crypto_pwhash_PASSWD_MAX",
                    "crypto_pwhash_PASSWD_MIN",
                    "crypto_pwhash_SALTBYTES",
                    "crypto_pwhash_STRBYTES",
                    "crypto_pwhash_argon2i_BYTES_MAX",
                    "crypto_pwhash_argon2i_BYTES_MIN",
                    "crypto_pwhash_argon2i_SALTBYTES",
                    "crypto_pwhash_argon2i_STRBYTES",
                    "crypto_pwhash_argon2id_BYTES_MAX",
                    "crypto_pwhash_argon2id_BYTES_MIN",
                    "crypto_pwhash_argon2id_SALTBYTES",
                    "crypto_pwhash_argon2id_STRBYTES",
                    "crypto_pwhash_scryptsalsa208sha256_BYTES_MAX",
                    "crypto_pwhash_scryptsalsa208sha256_BYTES_MIN",
                    "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_INTERACTIVE",
                    "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_MAX",
                    "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_MIN",
                    "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_SENSITIVE",
                    "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_INTERACTIVE",
                    "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_MAX",
                    "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_MIN",
                    "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_SENSITIVE",
                    "crypto_pwhash_scryptsalsa208sha256_SALTBYTES",
                    "crypto_pwhash_scryptsalsa208sha256_STRBYTES",
                    "crypto_scalarmult_BYTES",
                    "crypto_scalarmult_SCALARBYTES",
                    "crypto_scalarmult_curve25519_BYTES",
                    "crypto_scalarmult_curve25519_SCALARBYTES",
                    "crypto_scalarmult_ed25519_BYTES",
                    "crypto_scalarmult_ed25519_SCALARBYTES",
                    "crypto_scalarmult_ristretto255_BYTES",
                    "crypto_scalarmult_ristretto255_SCALARBYTES",
                    "crypto_secretbox_KEYBYTES",
                    "crypto_secretbox_MACBYTES",
                    "crypto_secretbox_MESSAGEBYTES_MAX",
                    "crypto_secretbox_NONCEBYTES",
                    "crypto_secretbox_xchacha20poly1305_KEYBYTES",
                    "crypto_secretbox_xchacha20poly1305_MACBYTES",
                    "crypto_secretbox_xchacha20poly1305_MESSAGEBYTES_MAX",
                    "crypto_secretbox_xchacha20poly1305_NONCEBYTES",
                    "crypto_secretbox_xsalsa20poly1305_KEYBYTES",
                    "crypto_secretbox_xsalsa20poly1305_MACBYTES",
                    "crypto_secretbox_xsalsa20poly1305_MESSAGEBYTES_MAX",
                    "crypto_secretbox_xsalsa20poly1305_NONCEBYTES",
                    "crypto_secretstream_xchacha20poly1305_ABYTES",
                    "crypto_secretstream_xchacha20poly1305_HEADERBYTES",
                    "crypto_secretstream_xchacha20poly1305_KEYBYTES",
                    "crypto_secretstream_xchacha20poly1305_MESSAGEBYTES_MAX",
                    "crypto_secretstream_xchacha20poly1305_TAG_FINAL",
                    "crypto_secretstream_xchacha20poly1305_TAG_MESSAGE",
                    "crypto_secretstream_xchacha20poly1305_TAG_PUSH",
                    "crypto_secretstream_xchacha20poly1305_TAG_REKEY",
                    "crypto_shorthash_BYTES",
                    "crypto_shorthash_KEYBYTES",
                    "crypto_shorthash_siphash24_BYTES",
                    "crypto_shorthash_siphash24_KEYBYTES",
                    "crypto_shorthash_siphashx24_BYTES",
                    "crypto_shorthash_siphashx24_KEYBYTES",
                    "crypto_sign_BYTES",
                    "crypto_sign_MESSAGEBYTES_MAX",
                    "crypto_sign_PUBLICKEYBYTES",
                    "crypto_sign_SECRETKEYBYTES",
                    "crypto_sign_SEEDBYTES",
                    "crypto_sign_ed25519_BYTES",
                    "crypto_sign_ed25519_MESSAGEBYTES_MAX",
                    "crypto_sign_ed25519_PUBLICKEYBYTES",
                    "crypto_sign_ed25519_SECRETKEYBYTES",
                    "crypto_sign_ed25519_SEEDBYTES",
                    "crypto_stream_KEYBYTES",
                    "crypto_stream_MESSAGEBYTES_MAX",
                    "crypto_stream_NONCEBYTES",
                    "crypto_stream_chacha20_IETF_KEYBYTES",
                    "crypto_stream_chacha20_IETF_MESSAGEBYTES_MAX",
                    "crypto_stream_chacha20_IETF_NONCEBYTES",
                    "crypto_stream_chacha20_KEYBYTES",
                    "crypto_stream_chacha20_MESSAGEBYTES_MAX",
                    "crypto_stream_chacha20_NONCEBYTES",
                    "crypto_stream_chacha20_ietf_KEYBYTES",
                    "crypto_stream_chacha20_ietf_MESSAGEBYTES_MAX",
                    "crypto_stream_chacha20_ietf_NONCEBYTES",
                    "crypto_stream_salsa2012_KEYBYTES",
                    "crypto_stream_salsa2012_MESSAGEBYTES_MAX",
                    "crypto_stream_salsa2012_NONCEBYTES",
                    "crypto_stream_salsa208_KEYBYTES",
                    "crypto_stream_salsa208_MESSAGEBYTES_MAX",
                    "crypto_stream_salsa208_NONCEBYTES",
                    "crypto_stream_salsa20_KEYBYTES",
                    "crypto_stream_salsa20_MESSAGEBYTES_MAX",
                    "crypto_stream_salsa20_NONCEBYTES",
                    "crypto_stream_xchacha20_KEYBYTES",
                    "crypto_stream_xchacha20_MESSAGEBYTES_MAX",
                    "crypto_stream_xchacha20_NONCEBYTES",
                    "crypto_stream_xsalsa20_KEYBYTES",
                    "crypto_stream_xsalsa20_MESSAGEBYTES_MAX",
                    "crypto_stream_xsalsa20_NONCEBYTES",
                    "crypto_verify_16_BYTES",
                    "crypto_verify_32_BYTES",
                    "crypto_verify_64_BYTES"
                ];
                for(_ = 0; _ < n.length; _++)"function" == typeof (c = t["_" + n[_].toLowerCase()]) && (e[n[_]] = c());
                var s = [
                    "SODIUM_VERSION_STRING",
                    "crypto_pwhash_STRPREFIX",
                    "crypto_pwhash_scryptsalsa208sha256_STRPREFIX"
                ];
                for(_ = 0; _ < s.length; _++){
                    var c;
                    "function" == typeof (c = t["_" + s[_].toLowerCase()]) && (e[s[_]] = t.UTF8ToString(c()));
                }
            }
            t = r;
            try {
                a();
                var _ = new Uint8Array([
                    98,
                    97,
                    108,
                    108,
                    115
                ]), n = e.randombytes_buf(e.crypto_secretbox_NONCEBYTES), s = e.randombytes_buf(e.crypto_secretbox_KEYBYTES), c = e.crypto_secretbox_easy(_, n, s), o = e.crypto_secretbox_open_easy(c, n, s);
                if (e.memcmp(_, o)) return;
            } catch (e) {
                if (null == t.useBackupModule) throw new Error("Both wasm and asm failed to load" + e);
            }
            t.useBackupModule(), a();
        });
        function n(e) {
            if ("function" == typeof TextEncoder) return (new TextEncoder).encode(e);
            e = unescape(encodeURIComponent(e));
            for(var r = new Uint8Array(e.length), t = 0, a = e.length; t < a; t++)r[t] = e.charCodeAt(t);
            return r;
        }
        function s(e) {
            if ("function" == typeof TextDecoder) return new TextDecoder("utf-8", {
                fatal: !0
            }).decode(e);
            var r = 8192, t = Math.ceil(e.length / r);
            if (t <= 1) try {
                return decodeURIComponent(escape(String.fromCharCode.apply(null, e)));
            } catch (e) {
                throw new TypeError("The encoded data was not valid.");
            }
            for(var a = "", _ = 0, n = 0; n < t; n++){
                var c = Array.prototype.slice.call(e, n * r + _, (n + 1) * r + _);
                if (0 != c.length) {
                    var o, h = c.length, p = 0;
                    do {
                        var y = c[--h];
                        y >= 240 ? (p = 4, o = !0) : y >= 224 ? (p = 3, o = !0) : y >= 192 ? (p = 2, o = !0) : y < 128 && (p = 1, o = !0);
                    }while (!o);
                    for(var i = p - (c.length - h), l = 0; l < i; l++)_--, c.pop();
                    a += s(c);
                }
            }
            return a;
        }
        function c(e) {
            e = x(null, e, "input");
            for(var r, t, a, _ = "", n = 0; n < e.length; n++)a = 87 + (t = 15 & e[n]) + (t - 10 >> 8 & -39) << 8 | 87 + (r = e[n] >>> 4) + (r - 10 >> 8 & -39), _ += String.fromCharCode(255 & a) + String.fromCharCode(a >>> 8);
            return _;
        }
        var o = {
            ORIGINAL: 1,
            ORIGINAL_NO_PADDING: 3,
            URLSAFE: 5,
            URLSAFE_NO_PADDING: 7
        };
        function h(e) {
            if (null == e) return o.URLSAFE_NO_PADDING;
            if (e !== o.ORIGINAL && e !== o.ORIGINAL_NO_PADDING && e !== o.URLSAFE && e != o.URLSAFE_NO_PADDING) throw new Error("unsupported base64 variant");
            return e;
        }
        function p(e, r) {
            r = h(r), e = x(_, e, "input");
            var a, _ = [], n = 0 | Math.floor(e.length / 3), c = e.length - 3 * n, o = 4 * n + (0 !== c ? 0 == (2 & r) ? 4 : 2 + (c >>> 1) : 0), p = new u(o + 1), y = d(e);
            return _.push(y), _.push(p.address), 0 === t._sodium_bin2base64(p.address, p.length, y, e.length, r) && b(_, "conversion failed"), p.length = o, a = s(p.to_Uint8Array()), g(_), a;
        }
        function y(e, r) {
            var t = r || a;
            if (!i(t)) throw new Error(t + " output format is not available");
            if (e instanceof u) {
                if ("uint8array" === t) return e.to_Uint8Array();
                if ("text" === t) return s(e.to_Uint8Array());
                if ("hex" === t) return c(e.to_Uint8Array());
                if ("base64" === t) return p(e.to_Uint8Array(), o.URLSAFE_NO_PADDING);
                throw new Error('What is output format "' + t + '"?');
            }
            if ("object" == typeof e) {
                for(var _ = Object.keys(e), n = {}, h = 0; h < _.length; h++)n[_[h]] = y(e[_[h]], t);
                return n;
            }
            if ("string" == typeof e) return e;
            throw new TypeError("Cannot format output");
        }
        function i(e) {
            for(var r = [
                "uint8array",
                "text",
                "hex",
                "base64"
            ], t = 0; t < r.length; t++)if (r[t] === e) return !0;
            return !1;
        }
        function l(e) {
            if (e) {
                if ("string" != typeof e) throw new TypeError("When defined, the output format must be a string");
                if (!i(e)) throw new Error(e + " is not a supported output format");
            }
        }
        function u(e) {
            this.length = e, this.address = v(e);
        }
        function d(e) {
            var r = v(e.length);
            return t.HEAPU8.set(e, r), r;
        }
        function v(e) {
            var r = t._malloc(e);
            if (0 === r) throw {
                message: "_malloc() failed",
                length: e
            };
            return r;
        }
        function g(e) {
            if (e) for(var r = 0; r < e.length; r++)a = e[r], t._free(a);
            var a;
        }
        function b(e, r) {
            throw g(e), new Error(r);
        }
        function f(e, r) {
            throw g(e), new TypeError(r);
        }
        function m(e, r, t) {
            null == r && f(e, t + " cannot be null or undefined");
        }
        function x(e, r, t) {
            return m(e, r, t), r instanceof Uint8Array ? r : "string" == typeof r ? n(r) : void f(e, "unsupported input type for " + t);
        }
        function E(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = null;
            null != e && (o = d(e = x(c, e, "secret_nonce")), e.length, c.push(o)), r = x(c, r, "ciphertext");
            var h, p = t._crypto_aead_aegis128l_abytes(), i = r.length;
            i < p && f(c, "ciphertext is too short"), h = d(r), c.push(h);
            var v = null, m = 0;
            null != a && (v = d(a = x(c, a, "additional_data")), m = a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var E, k = 0 | t._crypto_aead_aegis128l_npubbytes();
            _.length !== k && f(c, "invalid public_nonce length"), E = d(_), c.push(E), n = x(c, n, "key");
            var S, T = 0 | t._crypto_aead_aegis128l_keybytes();
            n.length !== T && f(c, "invalid key length"), S = d(n), c.push(S);
            var w = new u(i - t._crypto_aead_aegis128l_abytes() | 0), Y = w.address;
            if (c.push(Y), 0 === t._crypto_aead_aegis128l_decrypt(Y, null, o, h, i, 0, v, m, 0, E, S)) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "ciphertext cannot be decrypted using that key");
        }
        function k(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = null;
            null != e && (h = d(e = x(o, e, "secret_nonce")), e.length, o.push(h));
            var p = d(r = x(o, r, "ciphertext")), i = r.length;
            o.push(p), a = x(o, a, "mac");
            var v, m = 0 | t._crypto_box_macbytes();
            a.length !== m && f(o, "invalid mac length"), v = d(a), o.push(v);
            var E = null, k = 0;
            null != _ && (E = d(_ = x(o, _, "additional_data")), k = _.length, o.push(E)), n = x(o, n, "public_nonce");
            var S, T = 0 | t._crypto_aead_aegis128l_npubbytes();
            n.length !== T && f(o, "invalid public_nonce length"), S = d(n), o.push(S), s = x(o, s, "key");
            var w, Y = 0 | t._crypto_aead_aegis128l_keybytes();
            s.length !== Y && f(o, "invalid key length"), w = d(s), o.push(w);
            var B = new u(0 | i), A = B.address;
            if (o.push(A), 0 === t._crypto_aead_aegis128l_decrypt_detached(A, h, p, i, 0, v, E, k, 0, S, w)) {
                var K = y(B, c);
                return g(o), K;
            }
            b(o, "ciphertext cannot be decrypted using that key");
        }
        function S(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_aegis128l_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_aegis128l_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(h + t._crypto_aead_aegis128l_abytes() | 0), w = T.address;
            if (c.push(w), 0 === t._crypto_aead_aegis128l_encrypt(w, null, o, h, 0, p, i, 0, v, m, k)) {
                var Y = y(T, s);
                return g(c), Y;
            }
            b(c, "invalid usage");
        }
        function T(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_aegis128l_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_aegis128l_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(0 | h), w = T.address;
            c.push(w);
            var Y = new u(0 | t._crypto_aead_aegis128l_abytes()), B = Y.address;
            if (c.push(B), 0 === t._crypto_aead_aegis128l_encrypt_detached(w, B, null, o, h, 0, p, i, 0, v, m, k)) {
                var A = y({
                    ciphertext: T,
                    mac: Y
                }, s);
                return g(c), A;
            }
            b(c, "invalid usage");
        }
        function w(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_aead_aegis128l_keybytes()), _ = a.address;
            r.push(_), t._crypto_aead_aegis128l_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Y(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = null;
            null != e && (o = d(e = x(c, e, "secret_nonce")), e.length, c.push(o)), r = x(c, r, "ciphertext");
            var h, p = t._crypto_aead_aegis256_abytes(), i = r.length;
            i < p && f(c, "ciphertext is too short"), h = d(r), c.push(h);
            var v = null, m = 0;
            null != a && (v = d(a = x(c, a, "additional_data")), m = a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var E, k = 0 | t._crypto_aead_aegis256_npubbytes();
            _.length !== k && f(c, "invalid public_nonce length"), E = d(_), c.push(E), n = x(c, n, "key");
            var S, T = 0 | t._crypto_aead_aegis256_keybytes();
            n.length !== T && f(c, "invalid key length"), S = d(n), c.push(S);
            var w = new u(i - t._crypto_aead_aegis256_abytes() | 0), Y = w.address;
            if (c.push(Y), 0 === t._crypto_aead_aegis256_decrypt(Y, null, o, h, i, 0, v, m, 0, E, S)) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "ciphertext cannot be decrypted using that key");
        }
        function B(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = null;
            null != e && (h = d(e = x(o, e, "secret_nonce")), e.length, o.push(h));
            var p = d(r = x(o, r, "ciphertext")), i = r.length;
            o.push(p), a = x(o, a, "mac");
            var v, m = 0 | t._crypto_box_macbytes();
            a.length !== m && f(o, "invalid mac length"), v = d(a), o.push(v);
            var E = null, k = 0;
            null != _ && (E = d(_ = x(o, _, "additional_data")), k = _.length, o.push(E)), n = x(o, n, "public_nonce");
            var S, T = 0 | t._crypto_aead_aegis256_npubbytes();
            n.length !== T && f(o, "invalid public_nonce length"), S = d(n), o.push(S), s = x(o, s, "key");
            var w, Y = 0 | t._crypto_aead_aegis256_keybytes();
            s.length !== Y && f(o, "invalid key length"), w = d(s), o.push(w);
            var B = new u(0 | i), A = B.address;
            if (o.push(A), 0 === t._crypto_aead_aegis256_decrypt_detached(A, h, p, i, 0, v, E, k, 0, S, w)) {
                var K = y(B, c);
                return g(o), K;
            }
            b(o, "ciphertext cannot be decrypted using that key");
        }
        function A(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_aegis256_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_aegis256_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(h + t._crypto_aead_aegis256_abytes() | 0), w = T.address;
            if (c.push(w), 0 === t._crypto_aead_aegis256_encrypt(w, null, o, h, 0, p, i, 0, v, m, k)) {
                var Y = y(T, s);
                return g(c), Y;
            }
            b(c, "invalid usage");
        }
        function K(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_aegis256_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_aegis256_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(0 | h), w = T.address;
            c.push(w);
            var Y = new u(0 | t._crypto_aead_aegis256_abytes()), B = Y.address;
            if (c.push(B), 0 === t._crypto_aead_aegis256_encrypt_detached(w, B, null, o, h, 0, p, i, 0, v, m, k)) {
                var A = y({
                    ciphertext: T,
                    mac: Y
                }, s);
                return g(c), A;
            }
            b(c, "invalid usage");
        }
        function M(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_aead_aegis256_keybytes()), _ = a.address;
            r.push(_), t._crypto_aead_aegis256_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function I(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = null;
            null != e && (o = d(e = x(c, e, "secret_nonce")), e.length, c.push(o)), r = x(c, r, "ciphertext");
            var h, p = t._crypto_aead_chacha20poly1305_abytes(), i = r.length;
            i < p && f(c, "ciphertext is too short"), h = d(r), c.push(h);
            var v = null, m = 0;
            null != a && (v = d(a = x(c, a, "additional_data")), m = a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var E, k = 0 | t._crypto_aead_chacha20poly1305_npubbytes();
            _.length !== k && f(c, "invalid public_nonce length"), E = d(_), c.push(E), n = x(c, n, "key");
            var S, T = 0 | t._crypto_aead_chacha20poly1305_keybytes();
            n.length !== T && f(c, "invalid key length"), S = d(n), c.push(S);
            var w = new u(i - t._crypto_aead_chacha20poly1305_abytes() | 0), Y = w.address;
            if (c.push(Y), 0 === t._crypto_aead_chacha20poly1305_decrypt(Y, null, o, h, i, 0, v, m, 0, E, S)) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "ciphertext cannot be decrypted using that key");
        }
        function N(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = null;
            null != e && (h = d(e = x(o, e, "secret_nonce")), e.length, o.push(h));
            var p = d(r = x(o, r, "ciphertext")), i = r.length;
            o.push(p), a = x(o, a, "mac");
            var v, m = 0 | t._crypto_box_macbytes();
            a.length !== m && f(o, "invalid mac length"), v = d(a), o.push(v);
            var E = null, k = 0;
            null != _ && (E = d(_ = x(o, _, "additional_data")), k = _.length, o.push(E)), n = x(o, n, "public_nonce");
            var S, T = 0 | t._crypto_aead_chacha20poly1305_npubbytes();
            n.length !== T && f(o, "invalid public_nonce length"), S = d(n), o.push(S), s = x(o, s, "key");
            var w, Y = 0 | t._crypto_aead_chacha20poly1305_keybytes();
            s.length !== Y && f(o, "invalid key length"), w = d(s), o.push(w);
            var B = new u(0 | i), A = B.address;
            if (o.push(A), 0 === t._crypto_aead_chacha20poly1305_decrypt_detached(A, h, p, i, 0, v, E, k, 0, S, w)) {
                var K = y(B, c);
                return g(o), K;
            }
            b(o, "ciphertext cannot be decrypted using that key");
        }
        function L(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_chacha20poly1305_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_chacha20poly1305_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(h + t._crypto_aead_chacha20poly1305_abytes() | 0), w = T.address;
            if (c.push(w), 0 === t._crypto_aead_chacha20poly1305_encrypt(w, null, o, h, 0, p, i, 0, v, m, k)) {
                var Y = y(T, s);
                return g(c), Y;
            }
            b(c, "invalid usage");
        }
        function U(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_chacha20poly1305_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_chacha20poly1305_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(0 | h), w = T.address;
            c.push(w);
            var Y = new u(0 | t._crypto_aead_chacha20poly1305_abytes()), B = Y.address;
            if (c.push(B), 0 === t._crypto_aead_chacha20poly1305_encrypt_detached(w, B, null, o, h, 0, p, i, 0, v, m, k)) {
                var A = y({
                    ciphertext: T,
                    mac: Y
                }, s);
                return g(c), A;
            }
            b(c, "invalid usage");
        }
        function O(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = null;
            null != e && (o = d(e = x(c, e, "secret_nonce")), e.length, c.push(o)), r = x(c, r, "ciphertext");
            var h, p = t._crypto_aead_chacha20poly1305_ietf_abytes(), i = r.length;
            i < p && f(c, "ciphertext is too short"), h = d(r), c.push(h);
            var v = null, m = 0;
            null != a && (v = d(a = x(c, a, "additional_data")), m = a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var E, k = 0 | t._crypto_aead_chacha20poly1305_ietf_npubbytes();
            _.length !== k && f(c, "invalid public_nonce length"), E = d(_), c.push(E), n = x(c, n, "key");
            var S, T = 0 | t._crypto_aead_chacha20poly1305_ietf_keybytes();
            n.length !== T && f(c, "invalid key length"), S = d(n), c.push(S);
            var w = new u(i - t._crypto_aead_chacha20poly1305_ietf_abytes() | 0), Y = w.address;
            if (c.push(Y), 0 === t._crypto_aead_chacha20poly1305_ietf_decrypt(Y, null, o, h, i, 0, v, m, 0, E, S)) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "ciphertext cannot be decrypted using that key");
        }
        function C(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = null;
            null != e && (h = d(e = x(o, e, "secret_nonce")), e.length, o.push(h));
            var p = d(r = x(o, r, "ciphertext")), i = r.length;
            o.push(p), a = x(o, a, "mac");
            var v, m = 0 | t._crypto_box_macbytes();
            a.length !== m && f(o, "invalid mac length"), v = d(a), o.push(v);
            var E = null, k = 0;
            null != _ && (E = d(_ = x(o, _, "additional_data")), k = _.length, o.push(E)), n = x(o, n, "public_nonce");
            var S, T = 0 | t._crypto_aead_chacha20poly1305_ietf_npubbytes();
            n.length !== T && f(o, "invalid public_nonce length"), S = d(n), o.push(S), s = x(o, s, "key");
            var w, Y = 0 | t._crypto_aead_chacha20poly1305_ietf_keybytes();
            s.length !== Y && f(o, "invalid key length"), w = d(s), o.push(w);
            var B = new u(0 | i), A = B.address;
            if (o.push(A), 0 === t._crypto_aead_chacha20poly1305_ietf_decrypt_detached(A, h, p, i, 0, v, E, k, 0, S, w)) {
                var K = y(B, c);
                return g(o), K;
            }
            b(o, "ciphertext cannot be decrypted using that key");
        }
        function R(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_chacha20poly1305_ietf_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_chacha20poly1305_ietf_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(h + t._crypto_aead_chacha20poly1305_ietf_abytes() | 0), w = T.address;
            if (c.push(w), 0 === t._crypto_aead_chacha20poly1305_ietf_encrypt(w, null, o, h, 0, p, i, 0, v, m, k)) {
                var Y = y(T, s);
                return g(c), Y;
            }
            b(c, "invalid usage");
        }
        function P(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_chacha20poly1305_ietf_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_chacha20poly1305_ietf_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(0 | h), w = T.address;
            c.push(w);
            var Y = new u(0 | t._crypto_aead_chacha20poly1305_ietf_abytes()), B = Y.address;
            if (c.push(B), 0 === t._crypto_aead_chacha20poly1305_ietf_encrypt_detached(w, B, null, o, h, 0, p, i, 0, v, m, k)) {
                var A = y({
                    ciphertext: T,
                    mac: Y
                }, s);
                return g(c), A;
            }
            b(c, "invalid usage");
        }
        function G(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_aead_chacha20poly1305_ietf_keybytes()), _ = a.address;
            r.push(_), t._crypto_aead_chacha20poly1305_ietf_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function X(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_aead_chacha20poly1305_keybytes()), _ = a.address;
            r.push(_), t._crypto_aead_chacha20poly1305_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function D(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = null;
            null != e && (o = d(e = x(c, e, "secret_nonce")), e.length, c.push(o)), r = x(c, r, "ciphertext");
            var h, p = t._crypto_aead_xchacha20poly1305_ietf_abytes(), i = r.length;
            i < p && f(c, "ciphertext is too short"), h = d(r), c.push(h);
            var v = null, m = 0;
            null != a && (v = d(a = x(c, a, "additional_data")), m = a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var E, k = 0 | t._crypto_aead_xchacha20poly1305_ietf_npubbytes();
            _.length !== k && f(c, "invalid public_nonce length"), E = d(_), c.push(E), n = x(c, n, "key");
            var S, T = 0 | t._crypto_aead_xchacha20poly1305_ietf_keybytes();
            n.length !== T && f(c, "invalid key length"), S = d(n), c.push(S);
            var w = new u(i - t._crypto_aead_xchacha20poly1305_ietf_abytes() | 0), Y = w.address;
            if (c.push(Y), 0 === t._crypto_aead_xchacha20poly1305_ietf_decrypt(Y, null, o, h, i, 0, v, m, 0, E, S)) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "ciphertext cannot be decrypted using that key");
        }
        function F(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = null;
            null != e && (h = d(e = x(o, e, "secret_nonce")), e.length, o.push(h));
            var p = d(r = x(o, r, "ciphertext")), i = r.length;
            o.push(p), a = x(o, a, "mac");
            var v, m = 0 | t._crypto_box_macbytes();
            a.length !== m && f(o, "invalid mac length"), v = d(a), o.push(v);
            var E = null, k = 0;
            null != _ && (E = d(_ = x(o, _, "additional_data")), k = _.length, o.push(E)), n = x(o, n, "public_nonce");
            var S, T = 0 | t._crypto_aead_xchacha20poly1305_ietf_npubbytes();
            n.length !== T && f(o, "invalid public_nonce length"), S = d(n), o.push(S), s = x(o, s, "key");
            var w, Y = 0 | t._crypto_aead_xchacha20poly1305_ietf_keybytes();
            s.length !== Y && f(o, "invalid key length"), w = d(s), o.push(w);
            var B = new u(0 | i), A = B.address;
            if (o.push(A), 0 === t._crypto_aead_xchacha20poly1305_ietf_decrypt_detached(A, h, p, i, 0, v, E, k, 0, S, w)) {
                var K = y(B, c);
                return g(o), K;
            }
            b(o, "ciphertext cannot be decrypted using that key");
        }
        function V(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_xchacha20poly1305_ietf_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_xchacha20poly1305_ietf_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(h + t._crypto_aead_xchacha20poly1305_ietf_abytes() | 0), w = T.address;
            if (c.push(w), 0 === t._crypto_aead_xchacha20poly1305_ietf_encrypt(w, null, o, h, 0, p, i, 0, v, m, k)) {
                var Y = y(T, s);
                return g(c), Y;
            }
            b(c, "invalid usage");
        }
        function H(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_xchacha20poly1305_ietf_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_xchacha20poly1305_ietf_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(0 | h), w = T.address;
            c.push(w);
            var Y = new u(0 | t._crypto_aead_xchacha20poly1305_ietf_abytes()), B = Y.address;
            if (c.push(B), 0 === t._crypto_aead_xchacha20poly1305_ietf_encrypt_detached(w, B, null, o, h, 0, p, i, 0, v, m, k)) {
                var A = y({
                    ciphertext: T,
                    mac: Y
                }, s);
                return g(c), A;
            }
            b(c, "invalid usage");
        }
        function q(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_aead_xchacha20poly1305_ietf_keybytes()), _ = a.address;
            r.push(_), t._crypto_aead_xchacha20poly1305_ietf_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function j(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_auth_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_auth_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_auth(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function z(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_auth_hmacsha256_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_auth_hmacsha256_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_auth_hmacsha256(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function W(e, r) {
            var a = [];
            l(r), m(a, e, "state_address");
            var _ = new u(0 | t._crypto_auth_hmacsha256_bytes()), n = _.address;
            if (a.push(n), 0 == (0 | t._crypto_auth_hmacsha256_final(e, n))) {
                var s = (t._free(e), y(_, r));
                return g(a), s;
            }
            b(a, "invalid usage");
        }
        function J(e, r) {
            var a = [];
            l(r);
            var _ = null, n = 0;
            null != e && (_ = d(e = x(a, e, "key")), n = e.length, a.push(_));
            var s = new u(208).address;
            if (0 == (0 | t._crypto_auth_hmacsha256_init(s, _, n))) {
                var c = s;
                return g(a), c;
            }
            b(a, "invalid usage");
        }
        function Q(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_auth_hmacsha256_keybytes()), _ = a.address;
            r.push(_), t._crypto_auth_hmacsha256_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Z(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_auth_hmacsha256_update(e, n, s)) && b(_, "invalid usage"), g(_);
        }
        function $(e, r, a) {
            var _ = [];
            e = x(_, e, "tag");
            var n, s = 0 | t._crypto_auth_hmacsha256_bytes();
            e.length !== s && f(_, "invalid tag length"), n = d(e), _.push(n);
            var c = d(r = x(_, r, "message")), o = r.length;
            _.push(c), a = x(_, a, "key");
            var h, p = 0 | t._crypto_auth_hmacsha256_keybytes();
            a.length !== p && f(_, "invalid key length"), h = d(a), _.push(h);
            var y = 0 == (0 | t._crypto_auth_hmacsha256_verify(n, c, o, 0, h));
            return g(_), y;
        }
        function ee(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_auth_hmacsha512_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_auth_hmacsha512_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_auth_hmacsha512(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function re(e, r) {
            var a = [];
            l(r), m(a, e, "state_address");
            var _ = new u(0 | t._crypto_auth_hmacsha512_bytes()), n = _.address;
            if (a.push(n), 0 == (0 | t._crypto_auth_hmacsha512_final(e, n))) {
                var s = (t._free(e), y(_, r));
                return g(a), s;
            }
            b(a, "invalid usage");
        }
        function te(e, r) {
            var a = [];
            l(r);
            var _ = null, n = 0;
            null != e && (_ = d(e = x(a, e, "key")), n = e.length, a.push(_));
            var s = new u(416).address;
            if (0 == (0 | t._crypto_auth_hmacsha512_init(s, _, n))) {
                var c = s;
                return g(a), c;
            }
            b(a, "invalid usage");
        }
        function ae(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_auth_hmacsha512_keybytes()), _ = a.address;
            r.push(_), t._crypto_auth_hmacsha512_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function _e(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_auth_hmacsha512_update(e, n, s)) && b(_, "invalid usage"), g(_);
        }
        function ne(e, r, a) {
            var _ = [];
            e = x(_, e, "tag");
            var n, s = 0 | t._crypto_auth_hmacsha512_bytes();
            e.length !== s && f(_, "invalid tag length"), n = d(e), _.push(n);
            var c = d(r = x(_, r, "message")), o = r.length;
            _.push(c), a = x(_, a, "key");
            var h, p = 0 | t._crypto_auth_hmacsha512_keybytes();
            a.length !== p && f(_, "invalid key length"), h = d(a), _.push(h);
            var y = 0 == (0 | t._crypto_auth_hmacsha512_verify(n, c, o, 0, h));
            return g(_), y;
        }
        function se(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_auth_keybytes()), _ = a.address;
            r.push(_), t._crypto_auth_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function ce(e, r, a) {
            var _ = [];
            e = x(_, e, "tag");
            var n, s = 0 | t._crypto_auth_bytes();
            e.length !== s && f(_, "invalid tag length"), n = d(e), _.push(n);
            var c = d(r = x(_, r, "message")), o = r.length;
            _.push(c), a = x(_, a, "key");
            var h, p = 0 | t._crypto_auth_keybytes();
            a.length !== p && f(_, "invalid key length"), h = d(a), _.push(h);
            var y = 0 == (0 | t._crypto_auth_verify(n, c, o, 0, h));
            return g(_), y;
        }
        function oe(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "publicKey");
            var n, s = 0 | t._crypto_box_publickeybytes();
            e.length !== s && f(_, "invalid publicKey length"), n = d(e), _.push(n), r = x(_, r, "privateKey");
            var c, o = 0 | t._crypto_box_secretkeybytes();
            r.length !== o && f(_, "invalid privateKey length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_box_beforenmbytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_box_beforenm(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function he(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "publicKey");
            var n, s = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            e.length !== s && f(_, "invalid publicKey length"), n = d(e), _.push(n), r = x(_, r, "privateKey");
            var c, o = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            r.length !== o && f(_, "invalid privateKey length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_box_curve25519xchacha20poly1305_beforenmbytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_beforenm(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function pe(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), a = x(s, a, "publicKey");
            var i, v = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            a.length !== v && f(s, "invalid publicKey length"), i = d(a), s.push(i), _ = x(s, _, "privateKey");
            var m, E = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            _.length !== E && f(s, "invalid privateKey length"), m = d(_), s.push(m);
            var k = new u(0 | o), S = k.address;
            s.push(S);
            var T = new u(0 | t._crypto_box_curve25519xchacha20poly1305_macbytes()), w = T.address;
            if (s.push(w), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_detached(S, w, c, o, 0, h, i, m))) {
                var Y = y({
                    ciphertext: k,
                    mac: T
                }, n);
                return g(s), Y;
            }
            b(s, "invalid usage");
        }
        function ye(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "sharedKey");
            var p, i = 0 | t._crypto_box_curve25519xchacha20poly1305_beforenmbytes();
            a.length !== i && f(n, "invalid sharedKey length"), p = d(a), n.push(p);
            var v = new u(0 | c), m = v.address;
            n.push(m);
            var E = new u(0 | t._crypto_box_curve25519xchacha20poly1305_macbytes()), k = E.address;
            if (n.push(k), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_detached_afternm(m, k, s, c, 0, o, p))) {
                var S = y({
                    ciphertext: v,
                    mac: E
                }, _);
                return g(n), S;
            }
            b(n, "invalid usage");
        }
        function ie(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), a = x(s, a, "publicKey");
            var i, v = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            a.length !== v && f(s, "invalid publicKey length"), i = d(a), s.push(i), _ = x(s, _, "privateKey");
            var m, E = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            _.length !== E && f(s, "invalid privateKey length"), m = d(_), s.push(m);
            var k = new u(o + t._crypto_box_curve25519xchacha20poly1305_macbytes() | 0), S = k.address;
            if (s.push(S), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_easy(S, c, o, 0, h, i, m))) {
                var T = y(k, n);
                return g(s), T;
            }
            b(s, "invalid usage");
        }
        function le(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "sharedKey");
            var p, i = 0 | t._crypto_box_curve25519xchacha20poly1305_beforenmbytes();
            a.length !== i && f(n, "invalid sharedKey length"), p = d(a), n.push(p);
            var v = new u(c + t._crypto_box_curve25519xchacha20poly1305_macbytes() | 0), m = v.address;
            if (n.push(m), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_easy_afternm(m, s, c, 0, o, p))) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "invalid usage");
        }
        function ue(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes()), _ = a.address;
            r.push(_);
            var n = new u(0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes()), s = n.address;
            r.push(s), t._crypto_box_curve25519xchacha20poly1305_keypair(_, s);
            var c = y({
                publicKey: a,
                privateKey: n,
                keyType: "curve25519"
            }, e);
            return g(r), c;
        }
        function de(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "ciphertext")), h = e.length;
            c.push(o), r = x(c, r, "mac");
            var p, i = 0 | t._crypto_box_curve25519xchacha20poly1305_macbytes();
            r.length !== i && f(c, "invalid mac length"), p = d(r), c.push(p), a = x(c, a, "nonce");
            var v, m = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            a.length !== m && f(c, "invalid nonce length"), v = d(a), c.push(v), _ = x(c, _, "publicKey");
            var E, k = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            _.length !== k && f(c, "invalid publicKey length"), E = d(_), c.push(E), n = x(c, n, "privateKey");
            var S, T = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            n.length !== T && f(c, "invalid privateKey length"), S = d(n), c.push(S);
            var w = new u(0 | h), Y = w.address;
            if (c.push(Y), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_open_detached(Y, o, p, h, 0, v, E, S))) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "incorrect key pair for the given ciphertext");
        }
        function ve(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "ciphertext")), o = e.length;
            s.push(c), r = x(s, r, "mac");
            var h, p = 0 | t._crypto_box_curve25519xchacha20poly1305_macbytes();
            r.length !== p && f(s, "invalid mac length"), h = d(r), s.push(h), a = x(s, a, "nonce");
            var i, v = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            a.length !== v && f(s, "invalid nonce length"), i = d(a), s.push(i), _ = x(s, _, "sharedKey");
            var m, E = 0 | t._crypto_box_curve25519xchacha20poly1305_beforenmbytes();
            _.length !== E && f(s, "invalid sharedKey length"), m = d(_), s.push(m);
            var k = new u(0 | o), S = k.address;
            if (s.push(S), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_open_detached_afternm(S, c, h, o, 0, i, m))) {
                var T = y(k, n);
                return g(s), T;
            }
            b(s, "incorrect secret key for the given ciphertext");
        }
        function ge(e, r, a, _, n) {
            var s = [];
            l(n), e = x(s, e, "ciphertext");
            var c, o = t._crypto_box_curve25519xchacha20poly1305_macbytes(), h = e.length;
            h < o && f(s, "ciphertext is too short"), c = d(e), s.push(c), r = x(s, r, "nonce");
            var p, i = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== i && f(s, "invalid nonce length"), p = d(r), s.push(p), a = x(s, a, "publicKey");
            var v, m = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            a.length !== m && f(s, "invalid publicKey length"), v = d(a), s.push(v), _ = x(s, _, "privateKey");
            var E, k = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            _.length !== k && f(s, "invalid privateKey length"), E = d(_), s.push(E);
            var S = new u(h - t._crypto_box_curve25519xchacha20poly1305_macbytes() | 0), T = S.address;
            if (s.push(T), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_open_easy(T, c, h, 0, p, v, E))) {
                var w = y(S, n);
                return g(s), w;
            }
            b(s, "incorrect key pair for the given ciphertext");
        }
        function be(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "ciphertext")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "sharedKey");
            var p, i = 0 | t._crypto_box_curve25519xchacha20poly1305_beforenmbytes();
            a.length !== i && f(n, "invalid sharedKey length"), p = d(a), n.push(p);
            var v = new u(c - t._crypto_box_curve25519xchacha20poly1305_macbytes() | 0), m = v.address;
            if (n.push(m), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_open_easy_afternm(m, s, c, 0, o, p))) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "incorrect secret key for the given ciphertext");
        }
        function fe(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "publicKey");
            var c, o = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            r.length !== o && f(_, "invalid publicKey length"), c = d(r), _.push(c);
            var h = new u(s + t._crypto_box_curve25519xchacha20poly1305_sealbytes() | 0), p = h.address;
            _.push(p), t._crypto_box_curve25519xchacha20poly1305_seal(p, n, s, 0, c);
            var i = y(h, a);
            return g(_), i;
        }
        function me(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "ciphertext");
            var s, c = t._crypto_box_curve25519xchacha20poly1305_sealbytes(), o = e.length;
            o < c && f(n, "ciphertext is too short"), s = d(e), n.push(s), r = x(n, r, "publicKey");
            var h, p = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            r.length !== p && f(n, "invalid publicKey length"), h = d(r), n.push(h), a = x(n, a, "secretKey");
            var i, v = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            a.length !== v && f(n, "invalid secretKey length"), i = d(a), n.push(i);
            var b = new u(o - t._crypto_box_curve25519xchacha20poly1305_sealbytes() | 0), m = b.address;
            n.push(m), t._crypto_box_curve25519xchacha20poly1305_seal_open(m, s, o, 0, h, i);
            var E = y(b, _);
            return g(n), E;
        }
        function xe(e, r) {
            var a = [];
            l(r), e = x(a, e, "seed");
            var _, n = 0 | t._crypto_box_curve25519xchacha20poly1305_seedbytes();
            e.length !== n && f(a, "invalid seed length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes()), c = s.address;
            a.push(c);
            var o = new u(0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes()), h = o.address;
            if (a.push(h), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_seed_keypair(c, h, _))) {
                var p = {
                    publicKey: y(s, r),
                    privateKey: y(o, r),
                    keyType: "x25519"
                };
                return g(a), p;
            }
            b(a, "invalid usage");
        }
        function Ee(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_box_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), a = x(s, a, "publicKey");
            var i, v = 0 | t._crypto_box_publickeybytes();
            a.length !== v && f(s, "invalid publicKey length"), i = d(a), s.push(i), _ = x(s, _, "privateKey");
            var m, E = 0 | t._crypto_box_secretkeybytes();
            _.length !== E && f(s, "invalid privateKey length"), m = d(_), s.push(m);
            var k = new u(0 | o), S = k.address;
            s.push(S);
            var T = new u(0 | t._crypto_box_macbytes()), w = T.address;
            if (s.push(w), 0 == (0 | t._crypto_box_detached(S, w, c, o, 0, h, i, m))) {
                var Y = y({
                    ciphertext: k,
                    mac: T
                }, n);
                return g(s), Y;
            }
            b(s, "invalid usage");
        }
        function ke(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_box_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), a = x(s, a, "publicKey");
            var i, v = 0 | t._crypto_box_publickeybytes();
            a.length !== v && f(s, "invalid publicKey length"), i = d(a), s.push(i), _ = x(s, _, "privateKey");
            var m, E = 0 | t._crypto_box_secretkeybytes();
            _.length !== E && f(s, "invalid privateKey length"), m = d(_), s.push(m);
            var k = new u(o + t._crypto_box_macbytes() | 0), S = k.address;
            if (s.push(S), 0 == (0 | t._crypto_box_easy(S, c, o, 0, h, i, m))) {
                var T = y(k, n);
                return g(s), T;
            }
            b(s, "invalid usage");
        }
        function Se(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_box_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "sharedKey");
            var p, i = 0 | t._crypto_box_beforenmbytes();
            a.length !== i && f(n, "invalid sharedKey length"), p = d(a), n.push(p);
            var v = new u(c + t._crypto_box_macbytes() | 0), m = v.address;
            if (n.push(m), 0 == (0 | t._crypto_box_easy_afternm(m, s, c, 0, o, p))) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "invalid usage");
        }
        function Te(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_box_publickeybytes()), _ = a.address;
            r.push(_);
            var n = new u(0 | t._crypto_box_secretkeybytes()), s = n.address;
            if (r.push(s), 0 == (0 | t._crypto_box_keypair(_, s))) {
                var c = {
                    publicKey: y(a, e),
                    privateKey: y(n, e),
                    keyType: "x25519"
                };
                return g(r), c;
            }
            b(r, "internal error");
        }
        function we(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "ciphertext")), h = e.length;
            c.push(o), r = x(c, r, "mac");
            var p, i = 0 | t._crypto_box_macbytes();
            r.length !== i && f(c, "invalid mac length"), p = d(r), c.push(p), a = x(c, a, "nonce");
            var v, m = 0 | t._crypto_box_noncebytes();
            a.length !== m && f(c, "invalid nonce length"), v = d(a), c.push(v), _ = x(c, _, "publicKey");
            var E, k = 0 | t._crypto_box_publickeybytes();
            _.length !== k && f(c, "invalid publicKey length"), E = d(_), c.push(E), n = x(c, n, "privateKey");
            var S, T = 0 | t._crypto_box_secretkeybytes();
            n.length !== T && f(c, "invalid privateKey length"), S = d(n), c.push(S);
            var w = new u(0 | h), Y = w.address;
            if (c.push(Y), 0 == (0 | t._crypto_box_open_detached(Y, o, p, h, 0, v, E, S))) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "incorrect key pair for the given ciphertext");
        }
        function Ye(e, r, a, _, n) {
            var s = [];
            l(n), e = x(s, e, "ciphertext");
            var c, o = t._crypto_box_macbytes(), h = e.length;
            h < o && f(s, "ciphertext is too short"), c = d(e), s.push(c), r = x(s, r, "nonce");
            var p, i = 0 | t._crypto_box_noncebytes();
            r.length !== i && f(s, "invalid nonce length"), p = d(r), s.push(p), a = x(s, a, "publicKey");
            var v, m = 0 | t._crypto_box_publickeybytes();
            a.length !== m && f(s, "invalid publicKey length"), v = d(a), s.push(v), _ = x(s, _, "privateKey");
            var E, k = 0 | t._crypto_box_secretkeybytes();
            _.length !== k && f(s, "invalid privateKey length"), E = d(_), s.push(E);
            var S = new u(h - t._crypto_box_macbytes() | 0), T = S.address;
            if (s.push(T), 0 == (0 | t._crypto_box_open_easy(T, c, h, 0, p, v, E))) {
                var w = y(S, n);
                return g(s), w;
            }
            b(s, "incorrect key pair for the given ciphertext");
        }
        function Be(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "ciphertext")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_box_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "sharedKey");
            var p, i = 0 | t._crypto_box_beforenmbytes();
            a.length !== i && f(n, "invalid sharedKey length"), p = d(a), n.push(p);
            var v = new u(c - t._crypto_box_macbytes() | 0), m = v.address;
            if (n.push(m), 0 == (0 | t._crypto_box_open_easy_afternm(m, s, c, 0, o, p))) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "incorrect secret key for the given ciphertext");
        }
        function Ae(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "publicKey");
            var c, o = 0 | t._crypto_box_publickeybytes();
            r.length !== o && f(_, "invalid publicKey length"), c = d(r), _.push(c);
            var h = new u(s + t._crypto_box_sealbytes() | 0), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_box_seal(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function Ke(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "ciphertext");
            var s, c = t._crypto_box_sealbytes(), o = e.length;
            o < c && f(n, "ciphertext is too short"), s = d(e), n.push(s), r = x(n, r, "publicKey");
            var h, p = 0 | t._crypto_box_publickeybytes();
            r.length !== p && f(n, "invalid publicKey length"), h = d(r), n.push(h), a = x(n, a, "privateKey");
            var i, v = 0 | t._crypto_box_secretkeybytes();
            a.length !== v && f(n, "invalid privateKey length"), i = d(a), n.push(i);
            var m = new u(o - t._crypto_box_sealbytes() | 0), E = m.address;
            if (n.push(E), 0 == (0 | t._crypto_box_seal_open(E, s, o, 0, h, i))) {
                var k = y(m, _);
                return g(n), k;
            }
            b(n, "incorrect key pair for the given ciphertext");
        }
        function Me(e, r) {
            var a = [];
            l(r), e = x(a, e, "seed");
            var _, n = 0 | t._crypto_box_seedbytes();
            e.length !== n && f(a, "invalid seed length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_box_publickeybytes()), c = s.address;
            a.push(c);
            var o = new u(0 | t._crypto_box_secretkeybytes()), h = o.address;
            if (a.push(h), 0 == (0 | t._crypto_box_seed_keypair(c, h, _))) {
                var p = {
                    publicKey: y(s, r),
                    privateKey: y(o, r),
                    keyType: "x25519"
                };
                return g(a), p;
            }
            b(a, "invalid usage");
        }
        function Ie(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "p");
            var n, s = 0 | t._crypto_core_ed25519_bytes();
            e.length !== s && f(_, "invalid p length"), n = d(e), _.push(n), r = x(_, r, "q");
            var c, o = 0 | t._crypto_core_ed25519_bytes();
            r.length !== o && f(_, "invalid q length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ed25519_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_core_ed25519_add(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "input is an invalid element");
        }
        function Ne(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "r"));
            e.length, a.push(_);
            var n = new u(0 | t._crypto_core_ed25519_bytes()), s = n.address;
            if (a.push(s), 0 == (0 | t._crypto_core_ed25519_from_hash(s, _))) {
                var c = y(n, r);
                return g(a), c;
            }
            b(a, "invalid usage");
        }
        function Le(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "r"));
            e.length, a.push(_);
            var n = new u(0 | t._crypto_core_ed25519_bytes()), s = n.address;
            if (a.push(s), 0 == (0 | t._crypto_core_ed25519_from_uniform(s, _))) {
                var c = y(n, r);
                return g(a), c;
            }
            b(a, "invalid usage");
        }
        function Ue(e, r) {
            var a = [];
            l(r), e = x(a, e, "repr");
            var _, n = 0 | t._crypto_core_ed25519_bytes();
            e.length !== n && f(a, "invalid repr length"), _ = d(e), a.push(_);
            var s = 1 == (0 | t._crypto_core_ed25519_is_valid_point(_));
            return g(a), s;
        }
        function Oe(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_core_ed25519_bytes()), _ = a.address;
            r.push(_), t._crypto_core_ed25519_random(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Ce(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var n, s = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== s && f(_, "invalid x length"), n = d(e), _.push(n), r = x(_, r, "y");
            var c, o = 0 | t._crypto_core_ed25519_scalarbytes();
            r.length !== o && f(_, "invalid y length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ed25519_scalarbytes()), p = h.address;
            _.push(p), t._crypto_core_ed25519_scalar_add(p, n, c);
            var i = y(h, a);
            return g(_), i;
        }
        function Re(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, n = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ed25519_scalarbytes()), c = s.address;
            a.push(c), t._crypto_core_ed25519_scalar_complement(c, _);
            var o = y(s, r);
            return g(a), o;
        }
        function Pe(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, n = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ed25519_scalarbytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_core_ed25519_scalar_invert(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid reciprocate");
        }
        function Ge(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var n, s = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== s && f(_, "invalid x length"), n = d(e), _.push(n), r = x(_, r, "y");
            var c, o = 0 | t._crypto_core_ed25519_scalarbytes();
            r.length !== o && f(_, "invalid y length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ed25519_scalarbytes()), p = h.address;
            _.push(p), t._crypto_core_ed25519_scalar_mul(p, n, c);
            var i = y(h, a);
            return g(_), i;
        }
        function Xe(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, n = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ed25519_scalarbytes()), c = s.address;
            a.push(c), t._crypto_core_ed25519_scalar_negate(c, _);
            var o = y(s, r);
            return g(a), o;
        }
        function De(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_core_ed25519_scalarbytes()), _ = a.address;
            r.push(_), t._crypto_core_ed25519_scalar_random(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Fe(e, r) {
            var a = [];
            l(r), e = x(a, e, "sample");
            var _, n = 0 | t._crypto_core_ed25519_nonreducedscalarbytes();
            e.length !== n && f(a, "invalid sample length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ed25519_scalarbytes()), c = s.address;
            a.push(c), t._crypto_core_ed25519_scalar_reduce(c, _);
            var o = y(s, r);
            return g(a), o;
        }
        function Ve(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var n, s = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== s && f(_, "invalid x length"), n = d(e), _.push(n), r = x(_, r, "y");
            var c, o = 0 | t._crypto_core_ed25519_scalarbytes();
            r.length !== o && f(_, "invalid y length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ed25519_scalarbytes()), p = h.address;
            _.push(p), t._crypto_core_ed25519_scalar_sub(p, n, c);
            var i = y(h, a);
            return g(_), i;
        }
        function He(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "p");
            var n, s = 0 | t._crypto_core_ed25519_bytes();
            e.length !== s && f(_, "invalid p length"), n = d(e), _.push(n), r = x(_, r, "q");
            var c, o = 0 | t._crypto_core_ed25519_bytes();
            r.length !== o && f(_, "invalid q length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ed25519_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_core_ed25519_sub(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "input is an invalid element");
        }
        function qe(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "input");
            var s, c = 0 | t._crypto_core_hchacha20_inputbytes();
            e.length !== c && f(n, "invalid input length"), s = d(e), n.push(s), r = x(n, r, "privateKey");
            var o, h = 0 | t._crypto_core_hchacha20_keybytes();
            r.length !== h && f(n, "invalid privateKey length"), o = d(r), n.push(o);
            var p = null;
            null != a && (p = d(a = x(n, a, "constant")), a.length, n.push(p));
            var i = new u(0 | t._crypto_core_hchacha20_outputbytes()), v = i.address;
            if (n.push(v), 0 == (0 | t._crypto_core_hchacha20(v, s, o, p))) {
                var m = y(i, _);
                return g(n), m;
            }
            b(n, "invalid usage");
        }
        function je(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "input");
            var s, c = 0 | t._crypto_core_hsalsa20_inputbytes();
            e.length !== c && f(n, "invalid input length"), s = d(e), n.push(s), r = x(n, r, "privateKey");
            var o, h = 0 | t._crypto_core_hsalsa20_keybytes();
            r.length !== h && f(n, "invalid privateKey length"), o = d(r), n.push(o);
            var p = null;
            null != a && (p = d(a = x(n, a, "constant")), a.length, n.push(p));
            var i = new u(0 | t._crypto_core_hsalsa20_outputbytes()), v = i.address;
            if (n.push(v), 0 == (0 | t._crypto_core_hsalsa20(v, s, o, p))) {
                var m = y(i, _);
                return g(n), m;
            }
            b(n, "invalid usage");
        }
        function ze(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "p");
            var n, s = 0 | t._crypto_core_ristretto255_bytes();
            e.length !== s && f(_, "invalid p length"), n = d(e), _.push(n), r = x(_, r, "q");
            var c, o = 0 | t._crypto_core_ristretto255_bytes();
            r.length !== o && f(_, "invalid q length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ristretto255_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_core_ristretto255_add(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "input is an invalid element");
        }
        function We(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "r"));
            e.length, a.push(_);
            var n = new u(0 | t._crypto_core_ristretto255_bytes()), s = n.address;
            if (a.push(s), 0 == (0 | t._crypto_core_ristretto255_from_hash(s, _))) {
                var c = y(n, r);
                return g(a), c;
            }
            b(a, "invalid usage");
        }
        function Je(e, r) {
            var a = [];
            l(r), e = x(a, e, "repr");
            var _, n = 0 | t._crypto_core_ristretto255_bytes();
            e.length !== n && f(a, "invalid repr length"), _ = d(e), a.push(_);
            var s = 1 == (0 | t._crypto_core_ristretto255_is_valid_point(_));
            return g(a), s;
        }
        function Qe(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_core_ristretto255_bytes()), _ = a.address;
            r.push(_), t._crypto_core_ristretto255_random(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Ze(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var n, s = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== s && f(_, "invalid x length"), n = d(e), _.push(n), r = x(_, r, "y");
            var c, o = 0 | t._crypto_core_ristretto255_scalarbytes();
            r.length !== o && f(_, "invalid y length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ristretto255_scalarbytes()), p = h.address;
            _.push(p), t._crypto_core_ristretto255_scalar_add(p, n, c);
            var i = y(h, a);
            return g(_), i;
        }
        function $e(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, n = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ristretto255_scalarbytes()), c = s.address;
            a.push(c), t._crypto_core_ristretto255_scalar_complement(c, _);
            var o = y(s, r);
            return g(a), o;
        }
        function er(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, n = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ristretto255_scalarbytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_core_ristretto255_scalar_invert(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid reciprocate");
        }
        function rr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var n, s = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== s && f(_, "invalid x length"), n = d(e), _.push(n), r = x(_, r, "y");
            var c, o = 0 | t._crypto_core_ristretto255_scalarbytes();
            r.length !== o && f(_, "invalid y length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ristretto255_scalarbytes()), p = h.address;
            _.push(p), t._crypto_core_ristretto255_scalar_mul(p, n, c);
            var i = y(h, a);
            return g(_), i;
        }
        function tr(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, n = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ristretto255_scalarbytes()), c = s.address;
            a.push(c), t._crypto_core_ristretto255_scalar_negate(c, _);
            var o = y(s, r);
            return g(a), o;
        }
        function ar(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_core_ristretto255_scalarbytes()), _ = a.address;
            r.push(_), t._crypto_core_ristretto255_scalar_random(_);
            var n = y(a, e);
            return g(r), n;
        }
        function _r(e, r) {
            var a = [];
            l(r), e = x(a, e, "sample");
            var _, n = 0 | t._crypto_core_ristretto255_nonreducedscalarbytes();
            e.length !== n && f(a, "invalid sample length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ristretto255_scalarbytes()), c = s.address;
            a.push(c), t._crypto_core_ristretto255_scalar_reduce(c, _);
            var o = y(s, r);
            return g(a), o;
        }
        function nr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var n, s = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== s && f(_, "invalid x length"), n = d(e), _.push(n), r = x(_, r, "y");
            var c, o = 0 | t._crypto_core_ristretto255_scalarbytes();
            r.length !== o && f(_, "invalid y length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ristretto255_scalarbytes()), p = h.address;
            _.push(p), t._crypto_core_ristretto255_scalar_sub(p, n, c);
            var i = y(h, a);
            return g(_), i;
        }
        function sr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "p");
            var n, s = 0 | t._crypto_core_ristretto255_bytes();
            e.length !== s && f(_, "invalid p length"), n = d(e), _.push(n), r = x(_, r, "q");
            var c, o = 0 | t._crypto_core_ristretto255_bytes();
            r.length !== o && f(_, "invalid q length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ristretto255_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_core_ristretto255_sub(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "input is an invalid element");
        }
        function cr(e, r, a, _) {
            var n = [];
            l(_), m(n, e, "hash_length"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(n, "hash_length must be an unsigned integer");
            var s = d(r = x(n, r, "message")), c = r.length;
            n.push(s);
            var o = null, h = 0;
            null != a && (o = d(a = x(n, a, "key")), h = a.length, n.push(o));
            var p = new u(e |= 0), i = p.address;
            if (n.push(i), 0 == (0 | t._crypto_generichash(i, e, s, c, 0, o, h))) {
                var v = y(p, _);
                return g(n), v;
            }
            b(n, "invalid usage");
        }
        function or(e, r, a, _, n) {
            var s = [];
            l(n), m(s, e, "subkey_len"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(s, "subkey_len must be an unsigned integer");
            var c = null, o = 0;
            null != r && (c = d(r = x(s, r, "key")), o = r.length, s.push(c));
            var h = null, p = 0;
            null != a && (a = x(s, a, "id"), p = 0 | t._crypto_generichash_blake2b_saltbytes(), a.length !== p && f(s, "invalid id length"), h = d(a), s.push(h));
            var i = null, v = 0;
            null != _ && (_ = x(s, _, "ctx"), v = 0 | t._crypto_generichash_blake2b_personalbytes(), _.length !== v && f(s, "invalid ctx length"), i = d(_), s.push(i));
            var E = new u(0 | e), k = E.address;
            if (s.push(k), 0 == (0 | t._crypto_generichash_blake2b_salt_personal(k, e, null, 0, 0, c, o, h, i))) {
                var S = y(E, n);
                return g(s), S;
            }
            b(s, "invalid usage");
        }
        function hr(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address"), m(_, r, "hash_length"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(_, "hash_length must be an unsigned integer");
            var n = new u(r |= 0), s = n.address;
            if (_.push(s), 0 == (0 | t._crypto_generichash_final(e, s, r))) {
                var c = (t._free(e), y(n, a));
                return g(_), c;
            }
            b(_, "invalid usage");
        }
        function pr(e, r, a) {
            var _ = [];
            l(a);
            var n = null, s = 0;
            null != e && (n = d(e = x(_, e, "key")), s = e.length, _.push(n)), m(_, r, "hash_length"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(_, "hash_length must be an unsigned integer");
            var c = new u(357).address;
            if (0 == (0 | t._crypto_generichash_init(c, n, s, r))) {
                var o = c;
                return g(_), o;
            }
            b(_, "invalid usage");
        }
        function yr(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_generichash_keybytes()), _ = a.address;
            r.push(_), t._crypto_generichash_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function ir(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_generichash_update(e, n, s)) && b(_, "invalid usage"), g(_);
        }
        function lr(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "message")), n = e.length;
            a.push(_);
            var s = new u(0 | t._crypto_hash_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_hash(c, _, n, 0))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid usage");
        }
        function ur(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "message")), n = e.length;
            a.push(_);
            var s = new u(0 | t._crypto_hash_sha256_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_hash_sha256(c, _, n, 0))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid usage");
        }
        function dr(e, r) {
            var a = [];
            l(r), m(a, e, "state_address");
            var _ = new u(0 | t._crypto_hash_sha256_bytes()), n = _.address;
            if (a.push(n), 0 == (0 | t._crypto_hash_sha256_final(e, n))) {
                var s = (t._free(e), y(_, r));
                return g(a), s;
            }
            b(a, "invalid usage");
        }
        function vr(e) {
            var r = [];
            l(e);
            var a = new u(104).address;
            if (0 == (0 | t._crypto_hash_sha256_init(a))) {
                var _ = a;
                return g(r), _;
            }
            b(r, "invalid usage");
        }
        function gr(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_hash_sha256_update(e, n, s)) && b(_, "invalid usage"), g(_);
        }
        function br(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "message")), n = e.length;
            a.push(_);
            var s = new u(0 | t._crypto_hash_sha512_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_hash_sha512(c, _, n, 0))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid usage");
        }
        function fr(e, r) {
            var a = [];
            l(r), m(a, e, "state_address");
            var _ = new u(0 | t._crypto_hash_sha512_bytes()), n = _.address;
            if (a.push(n), 0 == (0 | t._crypto_hash_sha512_final(e, n))) {
                var s = (t._free(e), y(_, r));
                return g(a), s;
            }
            b(a, "invalid usage");
        }
        function mr(e) {
            var r = [];
            l(e);
            var a = new u(208).address;
            if (0 == (0 | t._crypto_hash_sha512_init(a))) {
                var _ = a;
                return g(r), _;
            }
            b(r, "invalid usage");
        }
        function xr(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_hash_sha512_update(e, n, s)) && b(_, "invalid usage"), g(_);
        }
        function Er(e, r, a, _, s) {
            var c = [];
            l(s), m(c, e, "subkey_len"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(c, "subkey_len must be an unsigned integer"), m(c, r, "subkey_id"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(c, "subkey_id must be an unsigned integer"), "string" != typeof a && f(c, "ctx must be a string"), a = n(a + "\x00"), null != h && a.length - 1 !== h && f(c, "invalid ctx length");
            var o = d(a), h = a.length - 1;
            c.push(o), _ = x(c, _, "key");
            var p, i = 0 | t._crypto_kdf_keybytes();
            _.length !== i && f(c, "invalid key length"), p = d(_), c.push(p);
            var v = new u(0 | e), b = v.address;
            c.push(b), t._crypto_kdf_derive_from_key(b, e, r, r >>> 24 >>> 8, o, p);
            var E = y(v, s);
            return g(c), E;
        }
        function kr(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_kdf_keybytes()), _ = a.address;
            r.push(_), t._crypto_kdf_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Sr(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "clientPublicKey");
            var s, c = 0 | t._crypto_kx_publickeybytes();
            e.length !== c && f(n, "invalid clientPublicKey length"), s = d(e), n.push(s), r = x(n, r, "clientSecretKey");
            var o, h = 0 | t._crypto_kx_secretkeybytes();
            r.length !== h && f(n, "invalid clientSecretKey length"), o = d(r), n.push(o), a = x(n, a, "serverPublicKey");
            var p, i = 0 | t._crypto_kx_publickeybytes();
            a.length !== i && f(n, "invalid serverPublicKey length"), p = d(a), n.push(p);
            var v = new u(0 | t._crypto_kx_sessionkeybytes()), m = v.address;
            n.push(m);
            var E = new u(0 | t._crypto_kx_sessionkeybytes()), k = E.address;
            if (n.push(k), 0 == (0 | t._crypto_kx_client_session_keys(m, k, s, o, p))) {
                var S = y({
                    sharedRx: v,
                    sharedTx: E
                }, _);
                return g(n), S;
            }
            b(n, "invalid usage");
        }
        function Tr(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_kx_publickeybytes()), _ = a.address;
            r.push(_);
            var n = new u(0 | t._crypto_kx_secretkeybytes()), s = n.address;
            if (r.push(s), 0 == (0 | t._crypto_kx_keypair(_, s))) {
                var c = {
                    publicKey: y(a, e),
                    privateKey: y(n, e),
                    keyType: "x25519"
                };
                return g(r), c;
            }
            b(r, "internal error");
        }
        function wr(e, r) {
            var a = [];
            l(r), e = x(a, e, "seed");
            var _, n = 0 | t._crypto_kx_seedbytes();
            e.length !== n && f(a, "invalid seed length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_kx_publickeybytes()), c = s.address;
            a.push(c);
            var o = new u(0 | t._crypto_kx_secretkeybytes()), h = o.address;
            if (a.push(h), 0 == (0 | t._crypto_kx_seed_keypair(c, h, _))) {
                var p = {
                    publicKey: y(s, r),
                    privateKey: y(o, r),
                    keyType: "x25519"
                };
                return g(a), p;
            }
            b(a, "internal error");
        }
        function Yr(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "serverPublicKey");
            var s, c = 0 | t._crypto_kx_publickeybytes();
            e.length !== c && f(n, "invalid serverPublicKey length"), s = d(e), n.push(s), r = x(n, r, "serverSecretKey");
            var o, h = 0 | t._crypto_kx_secretkeybytes();
            r.length !== h && f(n, "invalid serverSecretKey length"), o = d(r), n.push(o), a = x(n, a, "clientPublicKey");
            var p, i = 0 | t._crypto_kx_publickeybytes();
            a.length !== i && f(n, "invalid clientPublicKey length"), p = d(a), n.push(p);
            var v = new u(0 | t._crypto_kx_sessionkeybytes()), m = v.address;
            n.push(m);
            var E = new u(0 | t._crypto_kx_sessionkeybytes()), k = E.address;
            if (n.push(k), 0 == (0 | t._crypto_kx_server_session_keys(m, k, s, o, p))) {
                var S = y({
                    sharedRx: v,
                    sharedTx: E
                }, _);
                return g(n), S;
            }
            b(n, "invalid usage");
        }
        function Br(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_onetimeauth_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_onetimeauth_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_onetimeauth(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function Ar(e, r) {
            var a = [];
            l(r), m(a, e, "state_address");
            var _ = new u(0 | t._crypto_onetimeauth_bytes()), n = _.address;
            if (a.push(n), 0 == (0 | t._crypto_onetimeauth_final(e, n))) {
                var s = (t._free(e), y(_, r));
                return g(a), s;
            }
            b(a, "invalid usage");
        }
        function Kr(e, r) {
            var a = [];
            l(r);
            var _ = null;
            null != e && (_ = d(e = x(a, e, "key")), e.length, a.push(_));
            var n = new u(144).address;
            if (0 == (0 | t._crypto_onetimeauth_init(n, _))) {
                var s = n;
                return g(a), s;
            }
            b(a, "invalid usage");
        }
        function Mr(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_onetimeauth_keybytes()), _ = a.address;
            r.push(_), t._crypto_onetimeauth_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Ir(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_onetimeauth_update(e, n, s)) && b(_, "invalid usage"), g(_);
        }
        function Nr(e, r, a) {
            var _ = [];
            e = x(_, e, "hash");
            var n, s = 0 | t._crypto_onetimeauth_bytes();
            e.length !== s && f(_, "invalid hash length"), n = d(e), _.push(n);
            var c = d(r = x(_, r, "message")), o = r.length;
            _.push(c), a = x(_, a, "key");
            var h, p = 0 | t._crypto_onetimeauth_keybytes();
            a.length !== p && f(_, "invalid key length"), h = d(a), _.push(h);
            var y = 0 == (0 | t._crypto_onetimeauth_verify(n, c, o, 0, h));
            return g(_), y;
        }
        function Lr(e, r, a, _, n, s, c) {
            var o = [];
            l(c), m(o, e, "keyLength"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(o, "keyLength must be an unsigned integer");
            var h = d(r = x(o, r, "password")), p = r.length;
            o.push(h), a = x(o, a, "salt");
            var i, v = 0 | t._crypto_pwhash_saltbytes();
            a.length !== v && f(o, "invalid salt length"), i = d(a), o.push(i), m(o, _, "opsLimit"), ("number" != typeof _ || (0 | _) !== _ || _ < 0) && f(o, "opsLimit must be an unsigned integer"), m(o, n, "memLimit"), ("number" != typeof n || (0 | n) !== n || n < 0) && f(o, "memLimit must be an unsigned integer"), m(o, s, "algorithm"), ("number" != typeof s || (0 | s) !== s || s < 0) && f(o, "algorithm must be an unsigned integer");
            var E = new u(0 | e), k = E.address;
            if (o.push(k), 0 == (0 | t._crypto_pwhash(k, e, 0, h, p, 0, i, _, 0, n, s))) {
                var S = y(E, c);
                return g(o), S;
            }
            b(o, "invalid usage");
        }
        function Ur(e, r, a, _, n, s) {
            var c = [];
            l(s), m(c, e, "keyLength"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(c, "keyLength must be an unsigned integer");
            var o = d(r = x(c, r, "password")), h = r.length;
            c.push(o), a = x(c, a, "salt");
            var p, i = 0 | t._crypto_pwhash_scryptsalsa208sha256_saltbytes();
            a.length !== i && f(c, "invalid salt length"), p = d(a), c.push(p), m(c, _, "opsLimit"), ("number" != typeof _ || (0 | _) !== _ || _ < 0) && f(c, "opsLimit must be an unsigned integer"), m(c, n, "memLimit"), ("number" != typeof n || (0 | n) !== n || n < 0) && f(c, "memLimit must be an unsigned integer");
            var v = new u(0 | e), E = v.address;
            if (c.push(E), 0 == (0 | t._crypto_pwhash_scryptsalsa208sha256(E, e, 0, o, h, 0, p, _, 0, n))) {
                var k = y(v, s);
                return g(c), k;
            }
            b(c, "invalid usage");
        }
        function Or(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = d(e = x(o, e, "password")), p = e.length;
            o.push(h);
            var i = d(r = x(o, r, "salt")), v = r.length;
            o.push(i), m(o, a, "opsLimit"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(o, "opsLimit must be an unsigned integer"), m(o, _, "r"), ("number" != typeof _ || (0 | _) !== _ || _ < 0) && f(o, "r must be an unsigned integer"), m(o, n, "p"), ("number" != typeof n || (0 | n) !== n || n < 0) && f(o, "p must be an unsigned integer"), m(o, s, "keyLength"), ("number" != typeof s || (0 | s) !== s || s < 0) && f(o, "keyLength must be an unsigned integer");
            var E = new u(0 | s), k = E.address;
            if (o.push(k), 0 == (0 | t._crypto_pwhash_scryptsalsa208sha256_ll(h, p, i, v, a, 0, _, n, k, s))) {
                var S = y(E, c);
                return g(o), S;
            }
            b(o, "invalid usage");
        }
        function Cr(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "password")), c = e.length;
            n.push(s), m(n, r, "opsLimit"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(n, "opsLimit must be an unsigned integer"), m(n, a, "memLimit"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(n, "memLimit must be an unsigned integer");
            var o = new u(0 | t._crypto_pwhash_scryptsalsa208sha256_strbytes()).address;
            if (n.push(o), 0 == (0 | t._crypto_pwhash_scryptsalsa208sha256_str(o, s, c, 0, r, 0, a))) {
                var h = t.UTF8ToString(o);
                return g(n), h;
            }
            b(n, "invalid usage");
        }
        function Rr(e, r, a) {
            var _ = [];
            l(a), "string" != typeof e && f(_, "hashed_password must be a string"), e = n(e + "\x00"), null != c && e.length - 1 !== c && f(_, "invalid hashed_password length");
            var s = d(e), c = e.length - 1;
            _.push(s);
            var o = d(r = x(_, r, "password")), h = r.length;
            _.push(o);
            var p = 0 == (0 | t._crypto_pwhash_scryptsalsa208sha256_str_verify(s, o, h, 0));
            return g(_), p;
        }
        function Pr(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "password")), c = e.length;
            n.push(s), m(n, r, "opsLimit"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(n, "opsLimit must be an unsigned integer"), m(n, a, "memLimit"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(n, "memLimit must be an unsigned integer");
            var o = new u(0 | t._crypto_pwhash_strbytes()).address;
            if (n.push(o), 0 == (0 | t._crypto_pwhash_str(o, s, c, 0, r, 0, a))) {
                var h = t.UTF8ToString(o);
                return g(n), h;
            }
            b(n, "invalid usage");
        }
        function Gr(e, r, a, _) {
            var s = [];
            l(_), "string" != typeof e && f(s, "hashed_password must be a string"), e = n(e + "\x00"), null != o && e.length - 1 !== o && f(s, "invalid hashed_password length");
            var c = d(e), o = e.length - 1;
            s.push(c), m(s, r, "opsLimit"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(s, "opsLimit must be an unsigned integer"), m(s, a, "memLimit"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(s, "memLimit must be an unsigned integer");
            var h = 0 != (0 | t._crypto_pwhash_str_needs_rehash(c, r, 0, a));
            return g(s), h;
        }
        function Xr(e, r, a) {
            var _ = [];
            l(a), "string" != typeof e && f(_, "hashed_password must be a string"), e = n(e + "\x00"), null != c && e.length - 1 !== c && f(_, "invalid hashed_password length");
            var s = d(e), c = e.length - 1;
            _.push(s);
            var o = d(r = x(_, r, "password")), h = r.length;
            _.push(o);
            var p = 0 == (0 | t._crypto_pwhash_str_verify(s, o, h, 0));
            return g(_), p;
        }
        function Dr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "privateKey");
            var n, s = 0 | t._crypto_scalarmult_scalarbytes();
            e.length !== s && f(_, "invalid privateKey length"), n = d(e), _.push(n), r = x(_, r, "publicKey");
            var c, o = 0 | t._crypto_scalarmult_bytes();
            r.length !== o && f(_, "invalid publicKey length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_scalarmult_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_scalarmult(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "weak public key");
        }
        function Fr(e, r) {
            var a = [];
            l(r), e = x(a, e, "privateKey");
            var _, n = 0 | t._crypto_scalarmult_scalarbytes();
            e.length !== n && f(a, "invalid privateKey length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_scalarmult_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_scalarmult_base(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "unknown error");
        }
        function Vr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "n");
            var n, s = 0 | t._crypto_scalarmult_ed25519_scalarbytes();
            e.length !== s && f(_, "invalid n length"), n = d(e), _.push(n), r = x(_, r, "p");
            var c, o = 0 | t._crypto_scalarmult_ed25519_bytes();
            r.length !== o && f(_, "invalid p length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_scalarmult_ed25519_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_scalarmult_ed25519(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid point or scalar is 0");
        }
        function Hr(e, r) {
            var a = [];
            l(r), e = x(a, e, "scalar");
            var _, n = 0 | t._crypto_scalarmult_ed25519_scalarbytes();
            e.length !== n && f(a, "invalid scalar length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_scalarmult_ed25519_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_scalarmult_ed25519_base(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "scalar is 0");
        }
        function qr(e, r) {
            var a = [];
            l(r), e = x(a, e, "scalar");
            var _, n = 0 | t._crypto_scalarmult_ed25519_scalarbytes();
            e.length !== n && f(a, "invalid scalar length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_scalarmult_ed25519_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_scalarmult_ed25519_base_noclamp(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "scalar is 0");
        }
        function jr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "n");
            var n, s = 0 | t._crypto_scalarmult_ed25519_scalarbytes();
            e.length !== s && f(_, "invalid n length"), n = d(e), _.push(n), r = x(_, r, "p");
            var c, o = 0 | t._crypto_scalarmult_ed25519_bytes();
            r.length !== o && f(_, "invalid p length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_scalarmult_ed25519_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_scalarmult_ed25519_noclamp(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid point or scalar is 0");
        }
        function zr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "scalar");
            var n, s = 0 | t._crypto_scalarmult_ristretto255_scalarbytes();
            e.length !== s && f(_, "invalid scalar length"), n = d(e), _.push(n), r = x(_, r, "element");
            var c, o = 0 | t._crypto_scalarmult_ristretto255_bytes();
            r.length !== o && f(_, "invalid element length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_scalarmult_ristretto255_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_scalarmult_ristretto255(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "result is identity element");
        }
        function Wr(e, r) {
            var a = [];
            l(r), e = x(a, e, "scalar");
            var _, n = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== n && f(a, "invalid scalar length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ristretto255_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_scalarmult_ristretto255_base(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "scalar is 0");
        }
        function Jr(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_secretbox_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "key");
            var p, i = 0 | t._crypto_secretbox_keybytes();
            a.length !== i && f(n, "invalid key length"), p = d(a), n.push(p);
            var v = new u(0 | c), m = v.address;
            n.push(m);
            var E = new u(0 | t._crypto_secretbox_macbytes()), k = E.address;
            if (n.push(k), 0 == (0 | t._crypto_secretbox_detached(m, k, s, c, 0, o, p))) {
                var S = y({
                    mac: E,
                    cipher: v
                }, _);
                return g(n), S;
            }
            b(n, "invalid usage");
        }
        function Qr(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_secretbox_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "key");
            var p, i = 0 | t._crypto_secretbox_keybytes();
            a.length !== i && f(n, "invalid key length"), p = d(a), n.push(p);
            var v = new u(c + t._crypto_secretbox_macbytes() | 0), m = v.address;
            if (n.push(m), 0 == (0 | t._crypto_secretbox_easy(m, s, c, 0, o, p))) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "invalid usage");
        }
        function Zr(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_secretbox_keybytes()), _ = a.address;
            r.push(_), t._crypto_secretbox_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function $r(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "ciphertext")), o = e.length;
            s.push(c), r = x(s, r, "mac");
            var h, p = 0 | t._crypto_secretbox_macbytes();
            r.length !== p && f(s, "invalid mac length"), h = d(r), s.push(h), a = x(s, a, "nonce");
            var i, v = 0 | t._crypto_secretbox_noncebytes();
            a.length !== v && f(s, "invalid nonce length"), i = d(a), s.push(i), _ = x(s, _, "key");
            var m, E = 0 | t._crypto_secretbox_keybytes();
            _.length !== E && f(s, "invalid key length"), m = d(_), s.push(m);
            var k = new u(0 | o), S = k.address;
            if (s.push(S), 0 == (0 | t._crypto_secretbox_open_detached(S, c, h, o, 0, i, m))) {
                var T = y(k, n);
                return g(s), T;
            }
            b(s, "wrong secret key for the given ciphertext");
        }
        function et(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "ciphertext");
            var s, c = t._crypto_secretbox_macbytes(), o = e.length;
            o < c && f(n, "ciphertext is too short"), s = d(e), n.push(s), r = x(n, r, "nonce");
            var h, p = 0 | t._crypto_secretbox_noncebytes();
            r.length !== p && f(n, "invalid nonce length"), h = d(r), n.push(h), a = x(n, a, "key");
            var i, v = 0 | t._crypto_secretbox_keybytes();
            a.length !== v && f(n, "invalid key length"), i = d(a), n.push(i);
            var m = new u(o - t._crypto_secretbox_macbytes() | 0), E = m.address;
            if (n.push(E), 0 == (0 | t._crypto_secretbox_open_easy(E, s, o, 0, h, i))) {
                var k = y(m, _);
                return g(n), k;
            }
            b(n, "wrong secret key for the given ciphertext");
        }
        function rt(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "header");
            var n, s = 0 | t._crypto_secretstream_xchacha20poly1305_headerbytes();
            e.length !== s && f(_, "invalid header length"), n = d(e), _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_secretstream_xchacha20poly1305_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(52).address;
            if (0 == (0 | t._crypto_secretstream_xchacha20poly1305_init_pull(h, n, c))) {
                var p = h;
                return g(_), p;
            }
            b(_, "invalid usage");
        }
        function tt(e, r) {
            var a = [];
            l(r), e = x(a, e, "key");
            var _, n = 0 | t._crypto_secretstream_xchacha20poly1305_keybytes();
            e.length !== n && f(a, "invalid key length"), _ = d(e), a.push(_);
            var s = new u(52).address, c = new u(0 | t._crypto_secretstream_xchacha20poly1305_headerbytes()), o = c.address;
            if (a.push(o), 0 == (0 | t._crypto_secretstream_xchacha20poly1305_init_push(s, o, _))) {
                var h = {
                    state: s,
                    header: y(c, r)
                };
                return g(a), h;
            }
            b(a, "invalid usage");
        }
        function at(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_secretstream_xchacha20poly1305_keybytes()), _ = a.address;
            r.push(_), t._crypto_secretstream_xchacha20poly1305_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function _t(e, r, a, _) {
            var n = [];
            l(_), m(n, e, "state_address"), r = x(n, r, "cipher");
            var s, c = t._crypto_secretstream_xchacha20poly1305_abytes(), o = r.length;
            o < c && f(n, "cipher is too short"), s = d(r), n.push(s);
            var h = null, p = 0;
            null != a && (h = d(a = x(n, a, "ad")), p = a.length, n.push(h));
            var i = new u(o - t._crypto_secretstream_xchacha20poly1305_abytes() | 0), b = i.address;
            n.push(b);
            var E, k = (E = v(1), n.push(E), (k = 0 === t._crypto_secretstream_xchacha20poly1305_pull(e, b, 0, E, s, o, 0, h, p) && {
                tag: t.HEAPU8[E],
                message: i
            }) && {
                message: y(k.message, _),
                tag: k.tag
            });
            return g(n), k;
        }
        function nt(e, r, a, _, n) {
            var s = [];
            l(n), m(s, e, "state_address");
            var c = d(r = x(s, r, "message_chunk")), o = r.length;
            s.push(c);
            var h = null, p = 0;
            null != a && (h = d(a = x(s, a, "ad")), p = a.length, s.push(h)), m(s, _, "tag"), ("number" != typeof _ || (0 | _) !== _ || _ < 0) && f(s, "tag must be an unsigned integer");
            var i = new u(o + t._crypto_secretstream_xchacha20poly1305_abytes() | 0), v = i.address;
            if (s.push(v), 0 == (0 | t._crypto_secretstream_xchacha20poly1305_push(e, v, 0, c, o, 0, h, p, 0, _))) {
                var E = y(i, n);
                return g(s), E;
            }
            b(s, "invalid usage");
        }
        function st(e, r) {
            var a = [];
            return l(r), m(a, e, "state_address"), t._crypto_secretstream_xchacha20poly1305_rekey(e), g(a), !0;
        }
        function ct(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_shorthash_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_shorthash_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_shorthash(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function ot(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_shorthash_keybytes()), _ = a.address;
            r.push(_), t._crypto_shorthash_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function ht(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_shorthash_siphashx24_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_shorthash_siphashx24_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_shorthash_siphashx24(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function pt(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "privateKey");
            var c, o = 0 | t._crypto_sign_secretkeybytes();
            r.length !== o && f(_, "invalid privateKey length"), c = d(r), _.push(c);
            var h = new u(e.length + t._crypto_sign_bytes() | 0), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_sign(p, null, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function yt(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "privateKey");
            var c, o = 0 | t._crypto_sign_secretkeybytes();
            r.length !== o && f(_, "invalid privateKey length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_sign_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_sign_detached(p, null, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function it(e, r) {
            var a = [];
            l(r), e = x(a, e, "edPk");
            var _, n = 0 | t._crypto_sign_publickeybytes();
            e.length !== n && f(a, "invalid edPk length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_scalarmult_scalarbytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_sign_ed25519_pk_to_curve25519(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid key");
        }
        function lt(e, r) {
            var a = [];
            l(r), e = x(a, e, "edSk");
            var _, n = 0 | t._crypto_sign_secretkeybytes();
            e.length !== n && f(a, "invalid edSk length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_scalarmult_scalarbytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_sign_ed25519_sk_to_curve25519(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid key");
        }
        function ut(e, r) {
            var a = [];
            l(r), e = x(a, e, "privateKey");
            var _, n = 0 | t._crypto_sign_secretkeybytes();
            e.length !== n && f(a, "invalid privateKey length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_sign_publickeybytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_sign_ed25519_sk_to_pk(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid key");
        }
        function dt(e, r) {
            var a = [];
            l(r), e = x(a, e, "privateKey");
            var _, n = 0 | t._crypto_sign_secretkeybytes();
            e.length !== n && f(a, "invalid privateKey length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_sign_seedbytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_sign_ed25519_sk_to_seed(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid key");
        }
        function vt(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address"), r = x(_, r, "privateKey");
            var n, s = 0 | t._crypto_sign_secretkeybytes();
            r.length !== s && f(_, "invalid privateKey length"), n = d(r), _.push(n);
            var c = new u(0 | t._crypto_sign_bytes()), o = c.address;
            if (_.push(o), 0 == (0 | t._crypto_sign_final_create(e, o, null, n))) {
                var h = (t._free(e), y(c, a));
                return g(_), h;
            }
            b(_, "invalid usage");
        }
        function gt(e, r, a, _) {
            var n = [];
            l(_), m(n, e, "state_address"), r = x(n, r, "signature");
            var s, c = 0 | t._crypto_sign_bytes();
            r.length !== c && f(n, "invalid signature length"), s = d(r), n.push(s), a = x(n, a, "publicKey");
            var o, h = 0 | t._crypto_sign_publickeybytes();
            a.length !== h && f(n, "invalid publicKey length"), o = d(a), n.push(o);
            var p = 0 == (0 | t._crypto_sign_final_verify(e, s, o));
            return g(n), p;
        }
        function bt(e) {
            var r = [];
            l(e);
            var a = new u(208).address;
            if (0 == (0 | t._crypto_sign_init(a))) {
                var _ = a;
                return g(r), _;
            }
            b(r, "internal error");
        }
        function ft(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_sign_publickeybytes()), _ = a.address;
            r.push(_);
            var n = new u(0 | t._crypto_sign_secretkeybytes()), s = n.address;
            if (r.push(s), 0 == (0 | t._crypto_sign_keypair(_, s))) {
                var c = {
                    publicKey: y(a, e),
                    privateKey: y(n, e),
                    keyType: "ed25519"
                };
                return g(r), c;
            }
            b(r, "internal error");
        }
        function mt(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "signedMessage");
            var n, s = t._crypto_sign_bytes(), c = e.length;
            c < s && f(_, "signedMessage is too short"), n = d(e), _.push(n), r = x(_, r, "publicKey");
            var o, h = 0 | t._crypto_sign_publickeybytes();
            r.length !== h && f(_, "invalid publicKey length"), o = d(r), _.push(o);
            var p = new u(c - t._crypto_sign_bytes() | 0), i = p.address;
            if (_.push(i), 0 == (0 | t._crypto_sign_open(i, null, n, c, 0, o))) {
                var v = y(p, a);
                return g(_), v;
            }
            b(_, "incorrect signature for the given public key");
        }
        function xt(e, r) {
            var a = [];
            l(r), e = x(a, e, "seed");
            var _, n = 0 | t._crypto_sign_seedbytes();
            e.length !== n && f(a, "invalid seed length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_sign_publickeybytes()), c = s.address;
            a.push(c);
            var o = new u(0 | t._crypto_sign_secretkeybytes()), h = o.address;
            if (a.push(h), 0 == (0 | t._crypto_sign_seed_keypair(c, h, _))) {
                var p = {
                    publicKey: y(s, r),
                    privateKey: y(o, r),
                    keyType: "ed25519"
                };
                return g(a), p;
            }
            b(a, "invalid usage");
        }
        function Et(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_sign_update(e, n, s, 0)) && b(_, "invalid usage"), g(_);
        }
        function kt(e, r, a) {
            var _ = [];
            e = x(_, e, "signature");
            var n, s = 0 | t._crypto_sign_bytes();
            e.length !== s && f(_, "invalid signature length"), n = d(e), _.push(n);
            var c = d(r = x(_, r, "message")), o = r.length;
            _.push(c), a = x(_, a, "publicKey");
            var h, p = 0 | t._crypto_sign_publickeybytes();
            a.length !== p && f(_, "invalid publicKey length"), h = d(a), _.push(h);
            var y = 0 == (0 | t._crypto_sign_verify_detached(n, c, o, 0, h));
            return g(_), y;
        }
        function St(e, r, a, _) {
            var n = [];
            l(_), m(n, e, "outLength"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(n, "outLength must be an unsigned integer"), r = x(n, r, "key");
            var s, c = 0 | t._crypto_stream_chacha20_keybytes();
            r.length !== c && f(n, "invalid key length"), s = d(r), n.push(s), a = x(n, a, "nonce");
            var o, h = 0 | t._crypto_stream_chacha20_noncebytes();
            a.length !== h && f(n, "invalid nonce length"), o = d(a), n.push(o);
            var p = new u(0 | e), i = p.address;
            n.push(i), t._crypto_stream_chacha20(i, e, 0, o, s);
            var v = y(p, _);
            return g(n), v;
        }
        function Tt(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "input_message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_stream_chacha20_ietf_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "key");
            var p, i = 0 | t._crypto_stream_chacha20_ietf_keybytes();
            a.length !== i && f(n, "invalid key length"), p = d(a), n.push(p);
            var v = new u(0 | c), m = v.address;
            if (n.push(m), 0 === t._crypto_stream_chacha20_ietf_xor(m, s, c, 0, o, p)) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "invalid usage");
        }
        function wt(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "input_message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_stream_chacha20_ietf_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), m(s, a, "nonce_increment"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(s, "nonce_increment must be an unsigned integer"), _ = x(s, _, "key");
            var i, v = 0 | t._crypto_stream_chacha20_ietf_keybytes();
            _.length !== v && f(s, "invalid key length"), i = d(_), s.push(i);
            var E = new u(0 | o), k = E.address;
            if (s.push(k), 0 === t._crypto_stream_chacha20_ietf_xor_ic(k, c, o, 0, h, a, i)) {
                var S = y(E, n);
                return g(s), S;
            }
            b(s, "invalid usage");
        }
        function Yt(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_stream_chacha20_keybytes()), _ = a.address;
            r.push(_), t._crypto_stream_chacha20_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Bt(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "input_message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_stream_chacha20_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "key");
            var p, i = 0 | t._crypto_stream_chacha20_keybytes();
            a.length !== i && f(n, "invalid key length"), p = d(a), n.push(p);
            var v = new u(0 | c), m = v.address;
            if (n.push(m), 0 === t._crypto_stream_chacha20_xor(m, s, c, 0, o, p)) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "invalid usage");
        }
        function At(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "input_message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_stream_chacha20_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), m(s, a, "nonce_increment"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(s, "nonce_increment must be an unsigned integer"), _ = x(s, _, "key");
            var i, v = 0 | t._crypto_stream_chacha20_keybytes();
            _.length !== v && f(s, "invalid key length"), i = d(_), s.push(i);
            var E = new u(0 | o), k = E.address;
            if (s.push(k), 0 === t._crypto_stream_chacha20_xor_ic(k, c, o, 0, h, a, 0, i)) {
                var S = y(E, n);
                return g(s), S;
            }
            b(s, "invalid usage");
        }
        function Kt(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_stream_keybytes()), _ = a.address;
            r.push(_), t._crypto_stream_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Mt(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_stream_xchacha20_keybytes()), _ = a.address;
            r.push(_), t._crypto_stream_xchacha20_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function It(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "input_message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_stream_xchacha20_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "key");
            var p, i = 0 | t._crypto_stream_xchacha20_keybytes();
            a.length !== i && f(n, "invalid key length"), p = d(a), n.push(p);
            var v = new u(0 | c), m = v.address;
            if (n.push(m), 0 === t._crypto_stream_xchacha20_xor(m, s, c, 0, o, p)) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "invalid usage");
        }
        function Nt(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "input_message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_stream_xchacha20_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), m(s, a, "nonce_increment"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(s, "nonce_increment must be an unsigned integer"), _ = x(s, _, "key");
            var i, v = 0 | t._crypto_stream_xchacha20_keybytes();
            _.length !== v && f(s, "invalid key length"), i = d(_), s.push(i);
            var E = new u(0 | o), k = E.address;
            if (s.push(k), 0 === t._crypto_stream_xchacha20_xor_ic(k, c, o, 0, h, a, 0, i)) {
                var S = y(E, n);
                return g(s), S;
            }
            b(s, "invalid usage");
        }
        function Lt(e, r) {
            var a = [];
            l(r), m(a, e, "length"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(a, "length must be an unsigned integer");
            var _ = new u(0 | e), n = _.address;
            a.push(n), t._randombytes_buf(n, e);
            var s = y(_, r);
            return g(a), s;
        }
        function Ut(e, r, a) {
            var _ = [];
            l(a), m(_, e, "length"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(_, "length must be an unsigned integer"), r = x(_, r, "seed");
            var n, s = 0 | t._randombytes_seedbytes();
            r.length !== s && f(_, "invalid seed length"), n = d(r), _.push(n);
            var c = new u(0 | e), o = c.address;
            _.push(o), t._randombytes_buf_deterministic(o, e, n);
            var h = y(c, a);
            return g(_), h;
        }
        function Ot(e) {
            l(e), t._randombytes_close();
        }
        function Ct(e) {
            l(e);
            var r = t._randombytes_random() >>> 0;
            return g([]), r;
        }
        function Rt(e, r) {
            var a = [];
            l(r);
            for(var _ = t._malloc(24), n = 0; n < 6; n++)t.setValue(_ + 4 * n, t.Runtime.addFunction(e[[
                "implementation_name",
                "random",
                "stir",
                "uniform",
                "buf",
                "close"
            ][n]]), "i32");
            0 != (0 | t._randombytes_set_implementation(_)) && b(a, "unsupported implementation"), g(a);
        }
        function Pt(e) {
            l(e), t._randombytes_stir();
        }
        function Gt(e, r) {
            var a = [];
            l(r), m(a, e, "upper_bound"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(a, "upper_bound must be an unsigned integer");
            var _ = t._randombytes_uniform(e) >>> 0;
            return g(a), _;
        }
        function Xt() {
            var e = t._sodium_version_string(), r = t.UTF8ToString(e);
            return g([]), r;
        }
        return u.prototype.to_Uint8Array = function() {
            var e = new Uint8Array(this.length);
            return e.set(t.HEAPU8.subarray(this.address, this.address + this.length)), e;
        }, e.add = function(e, r) {
            if (!(e instanceof Uint8Array && r instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can added");
            var t = e.length, a = 0, _ = 0;
            if (r.length != e.length) throw new TypeError("Arguments must have the same length");
            for(_ = 0; _ < t; _++)a >>= 8, a += e[_] + r[_], e[_] = 255 & a;
        }, e.base64_variants = o, e.compare = function(e, r) {
            if (!(e instanceof Uint8Array && r instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be compared");
            if (e.length !== r.length) throw new TypeError("Only instances of identical length can be compared");
            for(var t = 0, a = 1, _ = e.length; _-- > 0;)t |= r[_] - e[_] >> 8 & a, a &= (r[_] ^ e[_]) - 1 >> 8;
            return t + t + a - 1;
        }, e.from_base64 = function(e, r) {
            r = h(r);
            var a, _ = [], n = new u(3 * (e = x(_, e, "input")).length / 4), s = d(e), c = v(4), o = v(4);
            return _.push(s), _.push(n.address), _.push(n.result_bin_len_p), _.push(n.b64_end_p), 0 !== t._sodium_base642bin(n.address, n.length, s, e.length, 0, c, o, r) && b(_, "invalid input"), t.getValue(o, "i32") - s !== e.length && b(_, "incomplete input"), n.length = t.getValue(c, "i32"), a = n.to_Uint8Array(), g(_), a;
        }, e.from_hex = function(e) {
            var r, a = [], _ = new u((e = x(a, e, "input")).length / 2), n = d(e), s = v(4);
            return a.push(n), a.push(_.address), a.push(_.hex_end_p), 0 !== t._sodium_hex2bin(_.address, _.length, n, e.length, 0, 0, s) && b(a, "invalid input"), t.getValue(s, "i32") - n !== e.length && b(a, "incomplete input"), r = _.to_Uint8Array(), g(a), r;
        }, e.from_string = n, e.increment = function(e) {
            if (!(e instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be incremented");
            for(var r = 256, t = 0, a = e.length; t < a; t++)r >>= 8, r += e[t], e[t] = 255 & r;
        }, e.is_zero = function(e) {
            if (!(e instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be checked");
            for(var r = 0, t = 0, a = e.length; t < a; t++)r |= e[t];
            return 0 === r;
        }, e.libsodium = r, e.memcmp = function(e, r) {
            if (!(e instanceof Uint8Array && r instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be compared");
            if (e.length !== r.length) throw new TypeError("Only instances of identical length can be compared");
            for(var t = 0, a = 0, _ = e.length; a < _; a++)t |= e[a] ^ r[a];
            return 0 === t;
        }, e.memzero = function(e) {
            if (!(e instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be wiped");
            for(var r = 0, t = e.length; r < t; r++)e[r] = 0;
        }, e.output_formats = function() {
            return [
                "uint8array",
                "text",
                "hex",
                "base64"
            ];
        }, e.pad = function(e, r) {
            if (!(e instanceof Uint8Array)) throw new TypeError("buffer must be a Uint8Array");
            if ((r |= 0) <= 0) throw new Error("block size must be > 0");
            var a, _ = [], n = v(4), s = 1, c = 0, o = 0 | e.length, h = new u(o + r);
            _.push(n), _.push(h.address);
            for(var p = h.address, y = h.address + o + r; p < y; p++)t.HEAPU8[p] = e[c], c += s = 1 & ~((65535 & ((o -= s) >>> 48 | o >>> 32 | o >>> 16 | o)) - 1 >> 16);
            return 0 !== t._sodium_pad(n, h.address, e.length, r, h.length) && b(_, "internal error"), h.length = t.getValue(n, "i32"), a = h.to_Uint8Array(), g(_), a;
        }, e.unpad = function(e, r) {
            if (!(e instanceof Uint8Array)) throw new TypeError("buffer must be a Uint8Array");
            if ((r |= 0) <= 0) throw new Error("block size must be > 0");
            var a = [], _ = d(e), n = v(4);
            return a.push(_), a.push(n), 0 !== t._sodium_unpad(n, _, e.length, r) && b(a, "unsupported/invalid padding"), e = (e = new Uint8Array(e)).subarray(0, t.getValue(n, "i32")), g(a), e;
        }, e.ready = _, e.symbols = function() {
            return Object.keys(e).sort();
        }, e.to_base64 = p, e.to_hex = c, e.to_string = s, e;
    }
    var t = "object" == typeof e.sodium && "function" == typeof e.sodium.onload ? e.sodium.onload : null;
    "function" == typeof define && define.amd ? define([
        "exports",
        "libsodium"
    ], r) : "string" != typeof module.exports.nodeName ? r(module.exports, (parcelRequire("d0s4r"))) : e.sodium = r(e.commonJsStrict = {}, e.libsodium), t && e.sodium.ready.then(function() {
        t(e.sodium);
    });
}(module.exports);

});
parcelRegister("d0s4r", function(module, exports) {

var $a8i8g = parcelRequire("a8i8g");
var $97810cacbb360566$var$__dirname = "node_modules/libsodium/dist/modules";

var $gzLuY = parcelRequire("gzLuY");
var $97810cacbb360566$require$Buffer = $gzLuY.Buffer;






!function(A) {
    function I(A) {
        "use strict";
        var I;
        void 0 === (I = A) && (I = {});
        var g = I;
        "object" != typeof g.sodium && ("object" == typeof $parcel$global ? g = $parcel$global : "object" == typeof window && (g = window));
        var C = I;
        return I.ready = new Promise(function(A, I) {
            (Q = C).onAbort = I, Q.print = function(A) {}, Q.printErr = function(A) {}, Q.onRuntimeInitialized = function() {
                try {
                    Q._crypto_secretbox_keybytes(), A();
                } catch (A) {
                    I(A);
                }
            }, Q.useBackupModule = function() {
                return new Promise(function(A, I) {
                    (Q = {}).onAbort = I, Q.onRuntimeInitialized = function() {
                        Object.keys(C).forEach(function(A) {
                            "getRandomValue" !== A && delete C[A];
                        }), Object.keys(Q).forEach(function(A) {
                            C[A] = Q[A];
                        }), A();
                    };
                    var g, B, Q = void 0 !== Q ? Q : {}, i = Object.assign({}, Q), E = "object" == typeof window, o = "function" == typeof importScripts, a = "object" == typeof $a8i8g && "object" == typeof $a8i8g.versions && "string" == typeof $a8i8g.versions.node, f = "";
                    if (a) {
                        var c = (parcelRequire("aqbQf")), e = (parcelRequire("aqbQf"));
                        f = o ? e.dirname(f) + "/" : $97810cacbb360566$var$__dirname + "/", g = (A, I)=>(A = function(A) {
                                return A.startsWith("file://");
                            }(A) ? new URL(A) : e.normalize(A), c.readFileSync(A, I ? void 0 : "utf8")), B = (A)=>{
                            var I = g(A, !0);
                            return I.buffer || (I = new Uint8Array(I)), I;
                        }, !Q.thisProgram && $a8i8g.argv.length > 1 && $a8i8g.argv[1].replace(/\\/g, "/"), $a8i8g.argv.slice(2), module.exports = Q, Q.inspect = ()=>"[Emscripten Module object]";
                    } else (E || o) && (o ? f = self.location.href : "undefined" != typeof document && document.currentScript && (f = document.currentScript.src), f = 0 !== f.indexOf("blob:") ? f.substr(0, f.replace(/[?#].*/, "").lastIndexOf("/") + 1) : "", g = (A)=>{
                        var I = new XMLHttpRequest;
                        return I.open("GET", A, !1), I.send(null), I.responseText;
                    }, o && (B = (A)=>{
                        var I = new XMLHttpRequest;
                        return I.open("GET", A, !1), I.responseType = "arraybuffer", I.send(null), new Uint8Array(I.response);
                    }));
                    Q.print;
                    var r, D = Q.printErr || void 0;
                    Object.assign(Q, i), i = null, Q.arguments && Q.arguments, Q.thisProgram && Q.thisProgram, Q.quit && Q.quit, Q.wasmBinary && (r = Q.wasmBinary), Q.noExitRuntime;
                    var t, y = {
                        Memory: function(A) {
                            this.buffer = new ArrayBuffer(65536 * A.initial);
                        },
                        Module: function(A) {},
                        Instance: function(A, I) {
                            this.exports = function(A) {
                                for(var I, g = new Uint8Array(123), C = 25; C >= 0; --C)g[48 + C] = 52 + C, g[65 + C] = C, g[97 + C] = 26 + C;
                                function B(A, I, C) {
                                    for(var B, Q, i = 0, E = I, o = C.length, a = I + (3 * o >> 2) - ("=" == C[o - 2]) - ("=" == C[o - 1]); i < o; i += 4)B = g[C.charCodeAt(i + 1)], Q = g[C.charCodeAt(i + 2)], A[E++] = g[C.charCodeAt(i)] << 2 | B >> 4, E < a && (A[E++] = B << 4 | Q >> 2), E < a && (A[E++] = Q << 6 | g[C.charCodeAt(i + 3)]);
                                }
                                function Q() {
                                    throw new Error("abort");
                                }
                                return g[43] = 62, g[47] = 63, function(A) {
                                    var g = A.a, C = g.a, i = C.buffer;
                                    C.grow = function(A) {
                                        A |= 0;
                                        var g = 0 | hI(), B = g + A | 0;
                                        if (g < B && B < 65536) {
                                            var Q = new ArrayBuffer(c(B, 65536));
                                            new Int8Array(Q).set(E), E = new Int8Array(Q), new Int16Array(Q), o = new Int32Array(Q), a = new Uint8Array(Q), new Uint16Array(Q), f = new Uint32Array(Q), new Float32Array(Q), new Float64Array(Q), i = Q, C.buffer = i, I = a;
                                        }
                                        return g;
                                    };
                                    var E = new Int8Array(i), o = (new Int16Array(i), new Int32Array(i)), a = new Uint8Array(i), f = (new Uint16Array(i), new Uint32Array(i)), c = (new Float32Array(i), new Float64Array(i), Math.imul), e = (Math.fround, Math.abs, Math.clz32), r = (Math.min, Math.max, Math.floor, Math.ceil, Math.trunc, Math.sqrt, g.b), D = g.c, t = g.d, y = g.e, w = 102096, h = 0;
                                    function n(A, I) {
                                        var g, C, B, Q, i, o = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, n = 0, s = 0, k = 0, F = 0, S = 0, H = 0, G = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, U = 0, Y = 0, d = 0, K = 0, b = 0, P = 0, v = 0, L = 0, R = 0, u = 0, x = 0, m = 0, l = 0, z = 0, q = 0, X = 0, j = 0, T = 0, O = 0, V = 0, Z = 0, W = 0, $ = 0, AA = 0, IA = 0, gA = 0, CA = 0, BA = 0, QA = 0, iA = 0, EA = 0, oA = 0, aA = 0, fA = 0, cA = 0, eA = 0, rA = 0, tA = 0, yA = 0, wA = 0, hA = 0, nA = 0, sA = 0, kA = 0, FA = 0, SA = 0, HA = 0, GA = 0, _A = 0, MA = 0, pA = 0, NA = 0, JA = 0;
                                        rA = a[I + 40 | 0] | a[I + 41 | 0] << 8 | a[I + 42 | 0] << 16 | a[I + 43 | 0] << 24, yA = o = a[I + 44 | 0] | a[I + 45 | 0] << 8 | a[I + 46 | 0] << 16 | a[I + 47 | 0] << 24, gA = a[I + 104 | 0] | a[I + 105 | 0] << 8 | a[I + 106 | 0] << 16 | a[I + 107 | 0] << 24, wA = o = a[I + 108 | 0] | a[I + 109 | 0] << 8 | a[I + 110 | 0] << 16 | a[I + 111 | 0] << 24, o = a[I + 68 | 0] | a[I + 69 | 0] << 8 | a[I + 70 | 0] << 16 | a[I + 71 | 0] << 24, X = a[I + 64 | 0] | a[I + 65 | 0] << 8 | a[I + 66 | 0] << 16 | a[I + 67 | 0] << 24, BA = o, MA = o = a[I + 36 | 0] | a[I + 37 | 0] << 8 | a[I + 38 | 0] << 16 | a[I + 39 | 0] << 24, _ = o, oA = a[I + 120 | 0] | a[I + 121 | 0] << 8 | a[I + 122 | 0] << 16 | a[I + 123 | 0] << 24, kA = o = a[I + 124 | 0] | a[I + 125 | 0] << 8 | a[I + 126 | 0] << 16 | a[I + 127 | 0] << 24, B = o = a[I + 92 | 0] | a[I + 93 | 0] << 8 | a[I + 94 | 0] << 16 | a[I + 95 | 0] << 24, g = a[I + 88 | 0] | a[I + 89 | 0] << 8 | a[I + 90 | 0] << 16 | a[I + 91 | 0] << 24, q = o, EA = a[I + 80 | 0] | a[I + 81 | 0] << 8 | a[I + 82 | 0] << 16 | a[I + 83 | 0] << 24, nA = o = a[I + 84 | 0] | a[I + 85 | 0] << 8 | a[I + 86 | 0] << 16 | a[I + 87 | 0] << 24, j = o, QA = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, o = (fA = a[A + 52 | 0] | a[A + 53 | 0] << 8 | a[A + 54 | 0] << 16 | a[A + 55 | 0] << 24) + _ | 0, l = (aA = a[A + 48 | 0] | a[A + 49 | 0] << 8 | a[A + 50 | 0] << 16 | a[A + 51 | 0] << 24) + (cA = a[I + 32 | 0] | a[I + 33 | 0] << 8 | a[I + 34 | 0] << 16 | a[I + 35 | 0] << 24) | 0, o = (a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24) + (aA >>> 0 > l >>> 0 ? o + 1 | 0 : o) | 0, o = (QA = (f = l) >>> 0 > (l = l + QA | 0) >>> 0 ? o + 1 | 0 : o) + yA | 0, iA = tA = l + rA | 0, tA = o = tA >>> 0 < l >>> 0 ? o + 1 | 0 : o, l = DA(l ^ (a[A + 80 | 0] | a[A + 81 | 0] << 8 | a[A + 82 | 0] << 16 | a[A + 83 | 0] << 24) ^ -79577749, QA ^ (a[A + 84 | 0] | a[A + 85 | 0] << 8 | a[A + 86 | 0] << 16 | a[A + 87 | 0] << 24) ^ 528734635, 32), HA = o = h, o = o + 1013904242 | 0, QA = l, V = o = (l = l - 23791573 | 0) >>> 0 < 4271175723 ? o + 1 | 0 : o, fA = DA(l ^ aA, o ^ fA, 40), o = (o = tA) + (tA = h) | 0, aA = DA(QA ^ (w = aA = fA + iA | 0), HA ^ (n = w >>> 0 < fA >>> 0 ? o + 1 | 0 : o), 48), o = V + (x = h) | 0, S = o = (aA = l + (s = aA) | 0) >>> 0 < l >>> 0 ? o + 1 | 0 : o, aA = o = DA(fA ^ (F = aA), tA ^ o, 1), V = l = h, tA = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, HA = o = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, eA = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, l = (fA = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24) + (QA = a[A + 40 | 0] | a[A + 41 | 0] << 8 | a[A + 42 | 0] << 16 | a[A + 43 | 0] << 24) | 0, o = (pA = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24) + (JA = a[A + 44 | 0] | a[A + 45 | 0] << 8 | a[A + 46 | 0] << 16 | a[A + 47 | 0] << 24) | 0, o = (a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24) + (l >>> 0 < QA >>> 0 ? o + 1 | 0 : o) | 0, o = HA + (iA = (f = l) >>> 0 > (l = l + eA | 0) >>> 0 ? o + 1 | 0 : o) | 0, o = (eA = l + tA | 0) >>> 0 < l >>> 0 ? o + 1 | 0 : o, f = DA(l ^ (a[A + 72 | 0] | a[A + 73 | 0] << 8 | a[A + 74 | 0] << 16 | a[A + 75 | 0] << 24) ^ 725511199, iA ^ (a[A + 76 | 0] | a[A + 77 | 0] << 8 | a[A + 78 | 0] << 16 | a[A + 79 | 0] << 24) ^ -1694144372, 32), D = DA(QA ^ (c = f - 2067093701 | 0), JA ^ (R = (K = l = h) - ((f >>> 0 < 2067093701) + 1150833018 | 0) | 0), 40), o = (m = h) + o | 0, o = (d = (H = l = D + eA | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o) + V | 0, o = (H >>> 0 > (l = H + aA | 0) >>> 0 ? o + 1 | 0 : o) + j | 0, o = (QA = (e = l) >>> 0 > (l = l + EA | 0) >>> 0 ? o + 1 | 0 : o) + q | 0, v = q = l + g | 0, y = o = q >>> 0 < l >>> 0 ? o + 1 | 0 : o, k = aA, FA = V, V = l, iA = QA, aA = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, l = o = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, JA = o = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, Q = QA = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, j = o, o = (GA = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24) + (r = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24) | 0, o = Q + ((q = a[A + 32 | 0] | a[A + 33 | 0] << 8 | a[A + 34 | 0] << 16 | a[A + 35 | 0] << 24) >>> 0 > (e = q + (QA = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24) | 0) >>> 0 ? o + 1 | 0 : o) | 0, o = (eA = (j = e + j | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o) + l | 0, sA = e = j + aA | 0, e = o = e >>> 0 < j >>> 0 ? o + 1 | 0 : o, t = q, q = DA(j ^ (a[0 | (o = A - -64 | 0)] | a[o + 1 | 0] << 8 | a[o + 2 | 0] << 16 | a[o + 3 | 0] << 24) ^ -1377402159, eA ^ (a[o + 4 | 0] | a[o + 5 | 0] << 8 | a[o + 6 | 0] << 16 | a[o + 7 | 0] << 24) ^ 1359893119, 32), eA = o = h, o = o + 1779033703 | 0, j = q, J = o = (q = q - 205731576 | 0) >>> 0 < 4089235720 ? o + 1 | 0 : o, r = DA(t ^ (G = q), o ^ r, 40), o = (P = h) + e | 0, t = DA(j ^ (e = q = r + sA | 0), eA ^ (M = r >>> 0 > e >>> 0 ? o + 1 | 0 : o), 48), o = DA(t ^ V, (W = h) ^ iA, 32), O = q = h, L = o, C = o = a[I + 60 | 0] | a[I + 61 | 0] << 8 | a[I + 62 | 0] << 16 | a[I + 63 | 0] << 24, eA = sA = a[I + 56 | 0] | a[I + 57 | 0] << 8 | a[I + 58 | 0] << 16 | a[I + 59 | 0] << 24, N = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, q = (iA = a[I + 48 | 0] | a[I + 49 | 0] << 8 | a[I + 50 | 0] << 16 | a[I + 51 | 0] << 24) + (j = a[A + 56 | 0] | a[A + 57 | 0] << 8 | a[A + 58 | 0] << 16 | a[A + 59 | 0] << 24) | 0, o = (_A = a[I + 52 | 0] | a[I + 53 | 0] << 8 | a[I + 54 | 0] << 16 | a[I + 55 | 0] << 24) + (b = a[A + 60 | 0] | a[A + 61 | 0] << 8 | a[A + 62 | 0] << 16 | a[A + 63 | 0] << 24) | 0, o = (a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24) + (q >>> 0 < j >>> 0 ? o + 1 | 0 : o) | 0, o = C + (V = (p = q) >>> 0 > (q = N + q | 0) >>> 0 ? o + 1 | 0 : o) | 0, o = (N = q + eA | 0) >>> 0 < q >>> 0 ? o + 1 | 0 : o, V = DA(q ^ (a[A + 88 | 0] | a[A + 89 | 0] << 8 | a[A + 90 | 0] << 16 | a[A + 91 | 0] << 24) ^ 327033209, V ^ (a[A + 92 | 0] | a[A + 93 | 0] << 8 | a[A + 94 | 0] << 16 | a[A + 95 | 0] << 24) ^ 1541459225, 32), j = DA(j ^ (eA = V + 1595750129 | 0), (p = b) ^ (b = (U = q = h) - ((V >>> 0 < 2699217167) + 1521486533 | 0) | 0), 40), o = (IA = h) + o | 0, q = DA((N = q = j + N | 0) ^ V, U ^ (p = N >>> 0 < j >>> 0 ? o + 1 | 0 : o), 48), o = b + ($ = h) | 0, Y = o = (q = eA + (b = q) | 0) >>> 0 < eA >>> 0 ? o + 1 | 0 : o, o = O + o | 0, T = k ^ (V = L + (U = q) | 0), k = o = V >>> 0 < U >>> 0 ? o + 1 | 0 : o, eA = DA(T, o ^ FA, 40), o = (FA = h) + y | 0, q = DA(v = L ^ (y = q = eA + v | 0), O ^ (L = y >>> 0 < eA >>> 0 ? o + 1 | 0 : o), 48), o = k + (CA = h) | 0, O = o = (k = V + (v = q) | 0) >>> 0 < V >>> 0 ? o + 1 | 0 : o, q = (u = DA(k ^ eA, FA ^ o, 1)) + (V = a[I + 72 | 0] | a[I + 73 | 0] << 8 | a[I + 74 | 0] << 16 | a[I + 75 | 0] << 24) | 0, o = (hA = h) + (FA = a[I + 76 | 0] | a[I + 77 | 0] << 8 | a[I + 78 | 0] << 16 | a[I + 79 | 0] << 24) | 0, SA = q, z = q >>> 0 < V >>> 0 ? o + 1 | 0 : o, Z = wA, q = a[I + 96 | 0] | a[I + 97 | 0] << 8 | a[I + 98 | 0] << 16 | a[I + 99 | 0] << 24, eA = o = a[I + 100 | 0] | a[I + 101 | 0] << 8 | a[I + 102 | 0] << 16 | a[I + 103 | 0] << 24, j = (o = w) + (w = DA(U ^ j, Y ^ IA, 1)) | 0, o = (U = h) + n | 0, o = (w >>> 0 > j >>> 0 ? o + 1 | 0 : o) + eA | 0, o = (n = (n = j) >>> 0 > (j = q + j | 0) >>> 0 ? o + 1 | 0 : o) + Z | 0, T = Y = j + gA | 0, Y = o = Y >>> 0 < j >>> 0 ? o + 1 | 0 : o, H = DA(f ^ H, d ^ K, 48), d = o = DA(H ^ j, (K = h) ^ n, 32), o = J + W | 0, o = (IA = j = h) + (G = (j = t + G | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o) | 0, J = o = (n = j) >>> 0 > (t = n + d | 0) >>> 0 ? o + 1 | 0 : o, w = DA(t ^ w, U ^ o, 40), o = (W = h) + Y | 0, o = (U = w >>> 0 > (Y = j = w + T | 0) >>> 0 ? o + 1 | 0 : o) + z | 0, o = (f = Y >>> 0 > (j = Y + SA | 0) >>> 0 ? o + 1 | 0 : o) + kA | 0, SA = z = j + oA | 0, z = o = z >>> 0 < j >>> 0 ? o + 1 | 0 : o, T = j, Z = f, j = a[I + 116 | 0] | a[I + 117 | 0] << 8 | a[I + 118 | 0] << 16 | a[I + 119 | 0] << 24, I = a[I + 112 | 0] | a[I + 113 | 0] << 8 | a[I + 114 | 0] << 16 | a[I + 115 | 0] << 24, r = DA(r ^ n, G ^ P, 1), o = (P = h) + p | 0, o = ((f = r + N | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o) + j | 0, o = (n = (G = f) >>> 0 > (f = I + f | 0) >>> 0 ? o + 1 | 0 : o) + kA | 0, NA = G = f + oA | 0, G = o = G >>> 0 < f >>> 0 ? o + 1 | 0 : o, o = DA(f ^ s, n ^ x, 32), AA = f = h, s = o, n = f, o = K + R | 0, H = f = c + H | 0, N = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, o = o + n | 0, p = f = f + s | 0, x = o = H >>> 0 > f >>> 0 ? o + 1 | 0 : o, n = DA(f ^ r, P ^ o, 40), o = (P = h) + G | 0, s = DA((f = n + NA | 0) ^ s, AA ^ (c = f >>> 0 < n >>> 0 ? o + 1 | 0 : o), 48), o = DA(s ^ T, (NA = h) ^ Z, 32), AA = r = h, G = o, T = r, D = DA(D ^ H, N ^ m, 1), o = M + (H = h) | 0, o = ((r = e) >>> 0 > (e = e + D | 0) >>> 0 ? o + 1 | 0 : o) + BA | 0, o = (e = (r = e + X | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o) + FA | 0, Z = M = r + V | 0, M = o = M >>> 0 < r >>> 0 ? o + 1 | 0 : o, N = D, r = DA(r ^ b, e ^ $, 32), o = (b = h) + S | 0, F = DA(N ^ (e = D = r + F | 0), (S = r >>> 0 > e >>> 0 ? o + 1 | 0 : o) ^ H, 40), o = ($ = h) + M | 0, H = D = F + Z | 0, D = DA(r ^ D, b ^ (M = D >>> 0 < F >>> 0 ? o + 1 | 0 : o), 48), o = S + (i = h) | 0, S = D, b = o = (D = e + D | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o, o = o + T | 0, o = (N = D) >>> 0 > (D = D + G | 0) >>> 0 ? o + 1 | 0 : o, T = D, D ^= u, u = o, r = DA(D, hA ^ o, 40), o = (hA = h) + z | 0, z = D = r + SA | 0, o = B + (Z = r >>> 0 > D >>> 0 ? o + 1 | 0 : o) | 0, SA = D = D + g | 0, K = o = D >>> 0 < g >>> 0 ? o + 1 | 0 : o, D = f, R = gA, m = wA, f = DA(d ^ Y, U ^ IA, 48), o = J + (IA = h) | 0, d = f, J = o = (e = t + f | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o, f = DA(e ^ w, W ^ o, 1), o = (t = h) + m | 0, o = ((w = f + R | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o) + c | 0, o = _A + (D = (c = D + w | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o) | 0, Y = w = c + iA | 0, w = o = w >>> 0 < iA >>> 0 ? o + 1 | 0 : o, c = DA(c ^ S, D ^ i, 32), o = O + (U = h) | 0, S = c, k = o = (c = k + c | 0) >>> 0 < k >>> 0 ? o + 1 | 0 : o, D = DA(f ^ c, o ^ t, 40), o = (o = w) + (w = h) | 0, t = f = D + Y | 0, f = DA(f ^ S, U ^ (Y = f >>> 0 < D >>> 0 ? o + 1 | 0 : o), 48), o = k + (W = h) | 0, U = f, O = o = (k = c + f | 0) >>> 0 < c >>> 0 ? o + 1 | 0 : o, f = DA(D ^ k, w ^ o, 1), o = (w = h) + K | 0, o = C + (D = (c = f + SA | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o) | 0, SA = S = c + sA | 0, S = o = S >>> 0 < sA >>> 0 ? o + 1 | 0 : o, K = f, R = w, o = x + NA | 0, o = (f = s + p | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, s = f, p = o, o = DA(f ^ n, P ^ o, 1), n = w = h, f = o, o = M + j | 0, o = ((H = I + H | 0) >>> 0 < I >>> 0 ? o + 1 | 0 : o) + w | 0, o = nA + (H = (w = f + H | 0) >>> 0 < H >>> 0 ? o + 1 | 0 : o) | 0, x = M = w + EA | 0, M = o = M >>> 0 < EA >>> 0 ? o + 1 | 0 : o, w = DA(w ^ v, H ^ CA, 32), o = J + (v = h) | 0, H = w, J = o = (J = e) >>> 0 > (e = e + w | 0) >>> 0 ? o + 1 | 0 : o, w = DA(f ^ e, o ^ n, 40), o = (P = h) + M | 0, n = f = w + x | 0, f = DA(M = f ^ H, v ^ (H = f >>> 0 < w >>> 0 ? o + 1 | 0 : o), 48), o = J + (CA = h) | 0, J = f, M = f = e + f | 0, v = o = f >>> 0 < e >>> 0 ? o + 1 | 0 : o, x = c, m = D, f = DA(F ^ N, b ^ $, 1), o = (e = h) + _ | 0, o = L + ((c = f + cA | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o) | 0, o = BA + (D = (c = c + y | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o) | 0, L = y = c + X | 0, y = o = y >>> 0 < c >>> 0 ? o + 1 | 0 : o, F = f, f = (c = DA(c ^ d, D ^ IA, 32)) + s | 0, o = (s = h) + p | 0, D = f, e = DA(f ^ F, (d = f >>> 0 < c >>> 0 ? o + 1 | 0 : o) ^ e, 40), o = (IA = h) + y | 0, y = f = e + L | 0, N = DA(f ^ c, s ^ (L = f >>> 0 < e >>> 0 ? o + 1 | 0 : o), 48), c = DA(N ^ x, (o = m) ^ (m = h), 32), o = (x = h) + v | 0, s = f = c + M | 0, F = DA(f ^ K, (p = f >>> 0 < c >>> 0 ? o + 1 | 0 : o) ^ R, 40), o = (K = h) + S | 0, S = f = F + SA | 0, f = DA(f ^ c, x ^ (b = f >>> 0 < F >>> 0 ? o + 1 | 0 : o), 48), o = p + ($ = h) | 0, p = f, x = o = (c = s) >>> 0 > (s = s + f | 0) >>> 0 ? o + 1 | 0 : o, f = DA(s ^ F, K ^ o, 1), o = kA + (SA = h) | 0, K = f, NA = f = oA + f | 0, F = o = f >>> 0 < oA >>> 0 ? o + 1 | 0 : o, c = rA, f = DA(w ^ M, P ^ v, 1), o = Y + (w = h) | 0, o = ((M = t) >>> 0 > (t = f + t | 0) >>> 0 ? o + 1 | 0 : o) + yA | 0, o = (M = (c = c + t | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o) + HA | 0, R = t = c + tA | 0, Y = o = t >>> 0 < c >>> 0 ? o + 1 | 0 : o, v = f, t = DA(G ^ z, Z ^ AA, 48), o = DA(t ^ c, (P = h) ^ M, 32), AA = f = h, G = o, c = f, o = d + m | 0, o = (f = D + N | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = f, d = o, o = o + c | 0, M = f = f + G | 0, N = o = D >>> 0 > f >>> 0 ? o + 1 | 0 : o, c = DA(f ^ v, o ^ w, 40), o = (o = Y) + (Y = h) | 0, v = f = c + R | 0, z = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, o = o + F | 0, Z = o = (w = f + NA | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, F = o, f = DA(e ^ D, d ^ IA, 1), o = l + (e = h) | 0, o = H + ((D = f + aA | 0) >>> 0 < aA >>> 0 ? o + 1 | 0 : o) | 0, o = eA + (n = (D = D + n | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o) | 0, R = H = D + q | 0, H = o = H >>> 0 < q >>> 0 ? o + 1 | 0 : o, d = f, o = DA(D ^ U, n ^ W, 32), m = f = h, D = o, n = f, o = P + u | 0, U = f = t + T | 0, u = o = f >>> 0 < t >>> 0 ? o + 1 | 0 : o, o = o + n | 0, o = (t = f + D | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, f = t ^ d, d = o, n = DA(f, o ^ e, 40), o = (W = h) + H | 0, e = f = n + R | 0, T = DA(f ^ D, m ^ (H = f >>> 0 < n >>> 0 ? o + 1 | 0 : o), 48), o = DA(T ^ w, (IA = h) ^ F, 32), NA = f = h, R = o, F = f, f = DA(r ^ U, u ^ hA, 1), o = L + (r = h) | 0, o = GA + ((D = f + y | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o) | 0, o = (y = (D = D + QA | 0) >>> 0 < QA >>> 0 ? o + 1 | 0 : o) + pA | 0, U = L = D + fA | 0, L = o = L >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = DA(D ^ J, y ^ CA, 32), o = O + (u = h) | 0, J = D, y = r, r = o = (D = k + D | 0) >>> 0 < k >>> 0 ? o + 1 | 0 : o, y = DA(f ^ D, y ^ o, 40), o = (CA = h) + L | 0, k = f = y + U | 0, f = DA(U = f ^ J, u ^ (J = f >>> 0 < y >>> 0 ? o + 1 | 0 : o), 48), o = r + (P = h) | 0, r = f, L = f = D + f | 0, U = o = f >>> 0 < D >>> 0 ? o + 1 | 0 : o, o = o + F | 0, O = o = (F = f + R | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, D = DA(F ^ K, SA ^ o, 40), o = Z + (u = h) | 0, o = ((f = D + w | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o) + wA | 0, w = f, Z = f = f + gA | 0, K = o = w >>> 0 > f >>> 0 ? o + 1 | 0 : o, m = BA, w = DA(G ^ v, z ^ AA, 48), o = (hA = h) + N | 0, G = f = w + M | 0, o = DA(f ^ c, (M = f >>> 0 < w >>> 0 ? o + 1 | 0 : o) ^ Y, 1), Y = c = h, f = o, o = H + B | 0, o = ((e = e + g | 0) >>> 0 < g >>> 0 ? o + 1 | 0 : o) + c | 0, o = (e = (c = f + e | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o) + m | 0, N = H = c + X | 0, H = o = H >>> 0 < c >>> 0 ? o + 1 | 0 : o, c = DA(c ^ r, e ^ P, 32), o = x + (v = h) | 0, s = o = (r = c + s | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, e = DA(f ^ r, o ^ Y, 40), o = (z = h) + H | 0, H = f = e + N | 0, c = DA(f ^ c, v ^ (Y = f >>> 0 < e >>> 0 ? o + 1 | 0 : o), 48), o = s + (N = h) | 0, v = o = (s = c + r | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o, f = DA(e ^ s, z ^ o, 1), o = (z = h) + K | 0, o = FA + ((r = f + Z | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o) | 0, o = (e = (r = r + V | 0) >>> 0 < V >>> 0 ? o + 1 | 0 : o) + _ | 0, SA = _ = r + cA | 0, _ = o = _ >>> 0 < r >>> 0 ? o + 1 | 0 : o, x = f, m = r, P = e, r = rA, f = DA(y ^ L, U ^ CA, 1), o = b + (y = h) | 0, o = ((e = S) >>> 0 > (S = f + S | 0) >>> 0 ? o + 1 | 0 : o) + yA | 0, o = pA + (e = (r = r + S | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o) | 0, b = S = r + fA | 0, L = o = S >>> 0 < fA >>> 0 ? o + 1 | 0 : o, S = f, e = o = DA(r ^ w, e ^ hA, 32), o = d + IA | 0, o = (U = f = h) + (t = (f = t + T | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o) | 0, d = o = (w = f + e | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, S = DA(w ^ S, o ^ y, 40), o = (IA = h) + L | 0, L = DA(b = (r = S + b | 0) ^ e, U ^ (e = r >>> 0 < S >>> 0 ? o + 1 | 0 : o), 48), o = DA(L ^ m, (CA = h) ^ P, 32), hA = y = h, b = o, U = y, f = DA(f ^ n, t ^ W, 1), o = eA + (y = h) | 0, o = J + ((t = f + q | 0) >>> 0 < q >>> 0 ? o + 1 | 0 : o) | 0, o = GA + (k = (t = t + k | 0) >>> 0 < k >>> 0 ? o + 1 | 0 : o) | 0, m = n = t + QA | 0, n = o = n >>> 0 < QA >>> 0 ? o + 1 | 0 : o, J = f, T = y, t = DA(t ^ p, k ^ $, 32), o = (p = h) + M | 0, y = f = t + G | 0, k = DA(f ^ J, (G = f >>> 0 < t >>> 0 ? o + 1 | 0 : o) ^ T, 40), o = (W = h) + n | 0, J = f = k + m | 0, f = DA(f ^ t, p ^ (M = f >>> 0 < k >>> 0 ? o + 1 | 0 : o), 48), o = G + (m = h) | 0, n = f, G = f = y + f | 0, p = o = f >>> 0 < y >>> 0 ? o + 1 | 0 : o, o = o + U | 0, U = f = f + b | 0, t = z, z = o = G >>> 0 > f >>> 0 ? o + 1 | 0 : o, t = DA(f ^ x, t ^ o, 40), o = (o = _) + (_ = h) | 0, T = f = t + SA | 0, x = o = f >>> 0 < t >>> 0 ? o + 1 | 0 : o, y = e, f = DA(R ^ Z, K ^ NA, 48), o = O + ($ = h) | 0, O = f, e = (f = F + f | 0) ^ D, D = o = f >>> 0 < F >>> 0 ? o + 1 | 0 : o, e = DA(e, o ^ u, 1), o = (u = h) + y | 0, o = C + ((r = e + r | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o) | 0, o = (y = (r = r + sA | 0) >>> 0 < sA >>> 0 ? o + 1 | 0 : o) + l | 0, Z = F = r + aA | 0, F = o = F >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = DA(r ^ n, y ^ m, 32), o = v + (K = h) | 0, v = r, s = o = (y = s + r | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, e = DA(e ^ y, u ^ o, 40), o = (o = F) + (F = h) | 0, n = r = e + Z | 0, r = DA(R = r ^ v, K ^ (v = r >>> 0 < e >>> 0 ? o + 1 | 0 : o), 48), o = s + (SA = h) | 0, u = r, Z = o = (s = y + r | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o, r = DA(e ^ s, F ^ o, 1), o = (F = h) + x | 0, o = B + ((e = r + T | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o) | 0, o = j + (y = (e = e + g | 0) >>> 0 < g >>> 0 ? o + 1 | 0 : o) | 0, NA = K = I + e | 0, K = o = K >>> 0 < I >>> 0 ? o + 1 | 0 : o, R = r, m = F, F = e, P = y, r = DA(k ^ G, p ^ W, 1), o = (y = h) + Y | 0, o = nA + ((e = r + H | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o) | 0, o = (k = (e = e + EA | 0) >>> 0 < EA >>> 0 ? o + 1 | 0 : o) + j | 0, Y = H = I + e | 0, H = o = H >>> 0 < e >>> 0 ? o + 1 | 0 : o, G = r, e = o = DA(e ^ O, k ^ $, 32), k = r = h, o = d + CA | 0, d = o = (r = w + L | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o, o = o + k | 0, o = (w = r) >>> 0 > (r = r + e | 0) >>> 0 ? o + 1 | 0 : o, L = r, r ^= G, G = o, y = DA(r, o ^ y, 40), o = (W = h) + H | 0, k = DA(H = (r = y + Y | 0) ^ e, k ^ (e = r >>> 0 < y >>> 0 ? o + 1 | 0 : o), 48), o = DA(k ^ F, (o = P) ^ (P = h), 32), $ = F = h, H = o, Y = D, D = c, o = DA(w ^ S, d ^ IA, 1), p = c = h, w = o, o = M + HA | 0, o = ((S = J + tA | 0) >>> 0 < tA >>> 0 ? o + 1 | 0 : o) + c | 0, S = o = (c = w + S | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o, D = DA(c ^ D, o ^ N, 32), o = (o = Y) + (Y = h) | 0, w = DA((f = D + f | 0) ^ w, p ^ (d = f >>> 0 < D >>> 0 ? o + 1 | 0 : o), 40), o = S + (IA = h) | 0, J = w, o = _A + ((M = c) >>> 0 > (c = c + w | 0) >>> 0 ? o + 1 | 0 : o) | 0, M = o = (w = c + iA | 0) >>> 0 < iA >>> 0 ? o + 1 | 0 : o, c = DA(D ^ w, Y ^ o, 48), o = d + (CA = h) | 0, N = f, D = c, d = f = f + c | 0, Y = o = N >>> 0 > f >>> 0 ? o + 1 | 0 : o, o = o + F | 0, N = o = (F = f + H | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, f = (S = DA(F ^ R, o ^ m, 40)) + NA | 0, o = (NA = h) + K | 0, p = f, O = f >>> 0 < S >>> 0 ? o + 1 | 0 : o, f = DA(b ^ T, x ^ hA, 48), o = (b = h) + z | 0, U = c = f + U | 0, R = _, _ = o = c >>> 0 < f >>> 0 ? o + 1 | 0 : o, o = DA(c ^ t, R ^ o, 1), T = c = h, t = o, o = e + C | 0, o = ((r = r + sA | 0) >>> 0 < sA >>> 0 ? o + 1 | 0 : o) + c | 0, o = FA + (r = (c = r + t | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o) | 0, x = e = c + V | 0, e = o = e >>> 0 < V >>> 0 ? o + 1 | 0 : o, c = DA(c ^ D, r ^ CA, 32), o = Z + (K = h) | 0, z = c, c = (D = s + c | 0) ^ t, t = o = D >>> 0 < s >>> 0 ? o + 1 | 0 : o, r = DA(c, T ^ o, 40), o = (o = e) + (e = h) | 0, T = c = r + x | 0, c = DA(s = c ^ z, K ^ (z = c >>> 0 < r >>> 0 ? o + 1 | 0 : o), 48), o = t + (CA = h) | 0, Z = c, D = o = (c = D + c | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o, r = DA(c ^ r, e ^ o, 1), o = (s = h) + O | 0, o = kA + ((e = r + p | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o) | 0, o = (t = (e = e + oA | 0) >>> 0 < oA >>> 0 ? o + 1 | 0 : o) + BA | 0, AA = x = e + X | 0, x = o = x >>> 0 < e >>> 0 ? o + 1 | 0 : o, K = r, R = e, m = t, r = DA(J ^ d, Y ^ IA, 1), o = (Y = h) + wA | 0, o = v + (r >>> 0 > (e = r + gA | 0) >>> 0 ? o + 1 | 0 : o) | 0, t = o = (e = e + n | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o, o = DA(f ^ e, o ^ b, 32), b = f = h, n = o, o = G + P | 0, o = (f = k + L | 0) >>> 0 < k >>> 0 ? o + 1 | 0 : o, k = f, d = o, o = b + o | 0, G = f = f + n | 0, J = o = k >>> 0 > f >>> 0 ? o + 1 | 0 : o, f = DA(f ^ r, Y ^ o, 40), o = t + (P = h) | 0, L = f, o = eA + ((f = e + f | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o) | 0, o = (f = f + q | 0) >>> 0 < q >>> 0 ? o + 1 | 0 : o, Y = f, f ^= n, n = o, t = DA(f, b ^ o, 48), o = DA(t ^ R, (o = m) ^ (m = h), 32), IA = f = h, b = o, v = f, f = DA(y ^ k, d ^ W, 1), o = HA + (e = h) | 0, o = M + ((r = f + tA | 0) >>> 0 < tA >>> 0 ? o + 1 | 0 : o) | 0, o = (y = (r = r + w | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o) + l | 0, M = k = r + aA | 0, k = o = k >>> 0 < r >>> 0 ? o + 1 | 0 : o, w = f, d = e, f = (r = DA(r ^ u, y ^ SA, 32)) + U | 0, o = (U = h) + _ | 0, e = f, y = DA(y = f ^ w, (w = f >>> 0 < r >>> 0 ? o + 1 | 0 : o) ^ d, 40), o = (W = h) + k | 0, k = f = y + M | 0, r = DA(f ^ r, U ^ (_ = f >>> 0 < y >>> 0 ? o + 1 | 0 : o), 48), o = w + (d = h) | 0, M = f = r + e | 0, U = o = f >>> 0 < e >>> 0 ? o + 1 | 0 : o, o = o + v | 0, v = o = (w = f + b | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, e = DA(w ^ K, o ^ s, 40), o = (u = h) + x | 0, x = f = e + AA | 0, K = o = f >>> 0 < e >>> 0 ? o + 1 | 0 : o, f = c, s = D, D = r, c = DA(H ^ p, O ^ $, 48), o = N + (AA = h) | 0, H = c, F = o = (r = F + c | 0) >>> 0 < F >>> 0 ? o + 1 | 0 : o, o = DA(r ^ S, NA ^ o, 1), N = c = h, S = o, o = n + MA | 0, o = ((n = Y + cA | 0) >>> 0 < cA >>> 0 ? o + 1 | 0 : o) + c | 0, n = o = (c = n + S | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o, D = DA(c ^ D, o ^ d, 32), o = (Y = h) + s | 0, S = DA((f = D + f | 0) ^ S, N ^ (s = f >>> 0 < D >>> 0 ? o + 1 | 0 : o), 40), o = n + (p = h) | 0, o = GA + ((n = c) >>> 0 > (c = c + S | 0) >>> 0 ? o + 1 | 0 : o) | 0, d = o = (n = c + QA | 0) >>> 0 < QA >>> 0 ? o + 1 | 0 : o, c = DA(D ^ n, Y ^ o, 48), o = s + ($ = h) | 0, Y = c, N = o = (s = f + c | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, f = DA(s ^ S, p ^ o, 1), o = (S = h) + K | 0, o = nA + ((c = f + x | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o) | 0, o = kA + (D = (c = c + EA | 0) >>> 0 < EA >>> 0 ? o + 1 | 0 : o) | 0, hA = p = c + oA | 0, p = o = p >>> 0 < oA >>> 0 ? o + 1 | 0 : o, O = f, R = c, f = DA(y ^ M, U ^ W, 1), o = (y = h) + z | 0, o = pA + ((c = f + T | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o) | 0, o = _A + (M = (c = c + fA | 0) >>> 0 < fA >>> 0 ? o + 1 | 0 : o) | 0, T = U = c + iA | 0, U = o = U >>> 0 < iA >>> 0 ? o + 1 | 0 : o, z = f, o = DA(c ^ H, M ^ AA, 32), AA = f = h, c = o, o = J + m | 0, G = f = t + G | 0, H = o = f >>> 0 < t >>> 0 ? o + 1 | 0 : o, o = AA + o | 0, J = o = (t = f + c | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, y = DA(t ^ z, o ^ y, 40), o = (m = h) + U | 0, M = f = y + T | 0, z = DA(f ^ c, AA ^ (U = f >>> 0 < y >>> 0 ? o + 1 | 0 : o), 48), o = DA(z ^ R, (AA = h) ^ D, 32), W = f = h, T = o, D = f, c = rA, f = DA(G ^ L, H ^ P, 1), o = _ + (H = h) | 0, o = ((G = k) >>> 0 > (k = f + k | 0) >>> 0 ? o + 1 | 0 : o) + yA | 0, o = nA + (k = (c = c + k | 0) >>> 0 < k >>> 0 ? o + 1 | 0 : o) | 0, G = _ = c + EA | 0, _ = o = _ >>> 0 < EA >>> 0 ? o + 1 | 0 : o, c = DA(c ^ Z, k ^ CA, 32), o = F + (L = h) | 0, F = c, o = (c = r + c | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = H, H = o, r = DA(f ^ c, r ^ o, 40), o = (P = h) + _ | 0, k = f = r + G | 0, f = DA(f ^ F, L ^ (_ = f >>> 0 < r >>> 0 ? o + 1 | 0 : o), 48), o = H + (R = h) | 0, H = f, G = f = c + f | 0, L = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, o = o + D | 0, o = (F = f + T | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, f = F ^ O, O = o, S = DA(f, o ^ S, 40), o = (CA = h) + p | 0, p = f = S + hA | 0, Z = f >>> 0 < S >>> 0 ? o + 1 | 0 : o, f = DA(b ^ x, K ^ IA, 48), o = v + (IA = h) | 0, b = f, o = (f = w + f | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o, w = f, v = o, o = DA(f ^ e, o ^ u, 1), u = f = h, D = o, o = U + FA | 0, o = ((c = M + V | 0) >>> 0 < V >>> 0 ? o + 1 | 0 : o) + f | 0, o = GA + (c = (f = c + D | 0) >>> 0 < c >>> 0 ? o + 1 | 0 : o) | 0, M = e = f + QA | 0, e = o = e >>> 0 < QA >>> 0 ? o + 1 | 0 : o, f = DA(f ^ H, c ^ R, 32), o = N + (U = h) | 0, H = f, s = o = (c = s + f | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, D = DA(c ^ D, u ^ o, 40), o = (u = h) + e | 0, M = f = D + M | 0, f = DA(e = f ^ H, U ^ (H = f >>> 0 < D >>> 0 ? o + 1 | 0 : o), 48), o = s + (hA = h) | 0, s = f, N = o = (e = c + f | 0) >>> 0 < c >>> 0 ? o + 1 | 0 : o, f = DA(e ^ D, u ^ o, 1), o = (U = h) + Z | 0, o = HA + ((c = f + p | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o) | 0, o = (D = (c = c + tA | 0) >>> 0 < tA >>> 0 ? o + 1 | 0 : o) + wA | 0, SA = u = c + gA | 0, u = o = u >>> 0 < c >>> 0 ? o + 1 | 0 : o, x = f, K = c, R = D, f = DA(r ^ G, P ^ L, 1), o = pA + (D = h) | 0, o = d + ((c = f + fA | 0) >>> 0 < fA >>> 0 ? o + 1 | 0 : o) | 0, o = MA + (r = (c = c + n | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o) | 0, L = n = c + cA | 0, n = o = n >>> 0 < cA >>> 0 ? o + 1 | 0 : o, d = f, G = D, o = DA(c ^ b, r ^ IA, 32), b = f = h, r = o, c = f, o = J + AA | 0, o = (f = t + z | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o, t = f, J = o, o = o + c | 0, o = (D = f + r | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, f = D ^ d, d = o, f = DA(f, o ^ G, 40), o = (o = n) + (n = h) | 0, G = c = f + L | 0, L = o = c >>> 0 < f >>> 0 ? o + 1 | 0 : o, b = DA(c ^ r, b ^ o, 48), o = DA(b ^ K, (o = R) ^ (R = h), 32), P = c = h, z = o, c = DA(t ^ y, J ^ m, 1), o = (t = h) + yA | 0, o = _ + ((r = c + rA | 0) >>> 0 < c >>> 0 ? o + 1 | 0 : o) | 0, o = C + (y = (r = r + k | 0) >>> 0 < k >>> 0 ? o + 1 | 0 : o) | 0, m = k = r + sA | 0, k = o = k >>> 0 < sA >>> 0 ? o + 1 | 0 : o, _ = c, J = t, r = DA(r ^ Y, y ^ $, 32), o = (Y = h) + v | 0, t = c = r + w | 0, c = (y = DA(c ^ _, (w = c >>> 0 < r >>> 0 ? o + 1 | 0 : o) ^ J, 40)) + m | 0, o = (m = h) + k | 0, _ = c, c = DA(c ^ r, Y ^ (J = c >>> 0 < y >>> 0 ? o + 1 | 0 : o), 48), o = w + (AA = h) | 0, Y = c, v = c = t + c | 0, K = o = c >>> 0 < t >>> 0 ? o + 1 | 0 : o, o = P + o | 0, o = (r = c + z | 0) >>> 0 < c >>> 0 ? o + 1 | 0 : o, c = U, U = o, t = DA(r ^ x, c ^ o, 40), o = (IA = h) + u | 0, k = c = t + SA | 0, o = DA(c ^ z, P ^ (u = c >>> 0 < t >>> 0 ? o + 1 | 0 : o), 48), P = c = h, z = o, c = f, o = d + R | 0, d = f = D + b | 0, b = o = f >>> 0 < D >>> 0 ? o + 1 | 0 : o, o = DA(f ^ c, o ^ n, 1), D = c = h, f = o, o = J + B | 0, o = ((w = _ + g | 0) >>> 0 < g >>> 0 ? o + 1 | 0 : o) + c | 0, o = eA + (w = (c = f + w | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o) | 0, R = n = c + q | 0, n = o = n >>> 0 < q >>> 0 ? o + 1 | 0 : o, _ = f, J = D, f = DA(p ^ T, Z ^ W, 48), o = O + (W = h) | 0, p = f, o = (f = F + f | 0) >>> 0 < F >>> 0 ? o + 1 | 0 : o, F = f, c = DA(c ^ s, w ^ hA, 32), O = o, o = o + (T = h) | 0, D = f = c + f | 0, w = DA(f ^ _, (s = f >>> 0 < c >>> 0 ? o + 1 | 0 : o) ^ J, 40), o = (Z = h) + n | 0, n = f = w + R | 0, f = DA(f ^ c, T ^ (_ = f >>> 0 < w >>> 0 ? o + 1 | 0 : o), 48), o = s + ($ = h) | 0, J = f, T = o = (s = D + f | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o, f = DA(w ^ s, Z ^ o, 1), o = GA + (R = h) | 0, Z = f, hA = f = QA + f | 0, D = o = f >>> 0 < QA >>> 0 ? o + 1 | 0 : o, f = DA(S ^ F, O ^ CA, 1), o = (w = h) + L | 0, o = _A + ((c = f + G | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o) | 0, o = BA + (F = (c = c + iA | 0) >>> 0 < iA >>> 0 ? o + 1 | 0 : o) | 0, O = S = c + X | 0, S = o = S >>> 0 < X >>> 0 ? o + 1 | 0 : o, G = w, c = DA(c ^ Y, F ^ AA, 32), o = N + (AA = h) | 0, L = c, o = (w = e + c | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o, e = G, G = o, F = DA(f ^ w, e ^ o, 40), o = (CA = h) + S | 0, Y = f = F + O | 0, o = (N = f >>> 0 < F >>> 0 ? o + 1 | 0 : o) + D | 0, S = o = (D = f + hA | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, O = o = DA(D ^ z, o ^ P, 32), x = f = h, f = DA(y ^ v, K ^ m, 1), o = (e = h) + H | 0, o = j + ((c = f + M | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o) | 0, o = (y = (c = I + c | 0) >>> 0 < I >>> 0 ? o + 1 | 0 : o) + l | 0, K = H = c + aA | 0, H = o = H >>> 0 < c >>> 0 ? o + 1 | 0 : o, M = f, v = e, c = DA(c ^ p, y ^ W, 32), o = (p = h) + b | 0, e = f = c + d | 0, f = (y = DA(f ^ M, (d = f >>> 0 < c >>> 0 ? o + 1 | 0 : o) ^ v, 40)) + K | 0, o = (K = h) + H | 0, H = f, f = DA(f ^ c, p ^ (M = f >>> 0 < y >>> 0 ? o + 1 | 0 : o), 48), o = d + (W = h) | 0, d = f, p = o = (f = e + f | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o, o = o + x | 0, b = o = (e = f) >>> 0 > (f = f + O | 0) >>> 0 ? o + 1 | 0 : o, c = DA(f ^ Z, R ^ o, 40), o = S + (R = h) | 0, v = c, o = B + ((c = D + c | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o) | 0, Z = c = c + g | 0, D = c ^ O, O = o = c >>> 0 < g >>> 0 ? o + 1 | 0 : o, c = DA(D, x ^ o, 48), o = b + (x = h) | 0, b = o = (S = f + c | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, f = o = DA(S ^ v, R ^ o, 1), v = D = h, D = DA(e ^ y, p ^ K, 1), o = _ + (y = h) | 0, o = _A + ((e = D + n | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o) | 0, o = nA + (n = (e = e + iA | 0) >>> 0 < iA >>> 0 ? o + 1 | 0 : o) | 0, R = _ = e + EA | 0, _ = o = _ >>> 0 < EA >>> 0 ? o + 1 | 0 : o, p = D, K = y, o = U + P | 0, o = (D = r + z | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o, U = D, L = DA(Y ^ L, N ^ AA, 48), y = DA(e ^ L, n ^ (AA = h), 32), Y = o, o = o + (hA = h) | 0, n = D = y + D | 0, D = DA(D ^ p, (N = D >>> 0 < y >>> 0 ? o + 1 | 0 : o) ^ K, 40), o = (p = h) + _ | 0, K = o = (r = D + R | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o, o = o + v | 0, o = C + ((z = r) >>> 0 > (r = f + r | 0) >>> 0 ? o + 1 | 0 : o) | 0, o = (e = (r = r + sA | 0) >>> 0 < sA >>> 0 ? o + 1 | 0 : o) + yA | 0, SA = _ = r + rA | 0, R = o = _ >>> 0 < r >>> 0 ? o + 1 | 0 : o, m = f, P = r, o = DA(t ^ U, Y ^ IA, 1), t = r = h, f = o, o = M + pA | 0, o = ((_ = H + fA | 0) >>> 0 < fA >>> 0 ? o + 1 | 0 : o) + r | 0, o = eA + (_ = (r = f + _ | 0) >>> 0 < _ >>> 0 ? o + 1 | 0 : o) | 0, Y = H = r + q | 0, H = o = H >>> 0 < q >>> 0 ? o + 1 | 0 : o, M = f, o = DA(r ^ J, _ ^ $, 32), U = f = h, r = o, _ = f, o = G + AA | 0, G = f = w + L | 0, J = o = f >>> 0 < w >>> 0 ? o + 1 | 0 : o, o = o + _ | 0, o = (w = f + r | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o;
                                        f = w ^ M, M = o, _ = DA(f, o ^ t, 40), o = (AA = h) + H | 0, L = DA(H = (f = _ + Y | 0) ^ r, U ^ (r = f >>> 0 < _ >>> 0 ? o + 1 | 0 : o), 48), o = DA(o = L ^ P, (P = h) ^ e, 32), IA = e = h, Y = o, H = e, e = DA(F ^ G, J ^ CA, 1), o = BA + (F = h) | 0, o = u + ((t = e + X | 0) >>> 0 < X >>> 0 ? o + 1 | 0 : o) | 0, o = HA + (k = (t = t + k | 0) >>> 0 < k >>> 0 ? o + 1 | 0 : o) | 0, J = G = t + tA | 0, G = o = G >>> 0 < tA >>> 0 ? o + 1 | 0 : o, t = DA(t ^ d, k ^ W, 32), o = T + (U = h) | 0, d = t, s = o = (t = s + t | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, k = DA(e ^ t, o ^ F, 40), o = (W = h) + G | 0, F = e = k + J | 0, e = DA(G = e ^ d, U ^ (d = e >>> 0 < k >>> 0 ? o + 1 | 0 : o), 48), o = s + ($ = h) | 0, G = e, J = e = t + e | 0, U = o = e >>> 0 < t >>> 0 ? o + 1 | 0 : o, o = o + H | 0, o = (t = e + Y | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o, e = v, v = o, s = DA(t ^ m, e ^ o, 40), o = (u = h) + R | 0, H = e = s + SA | 0, e = DA(R = e ^ Y, IA ^ (Y = e >>> 0 < s >>> 0 ? o + 1 | 0 : o), 48), o = v + (IA = h) | 0, v = e, t = o = (e = t + e | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o, u = o = DA(e ^ s, u ^ o, 1), CA = o, T = s = h, s = r, r = D, D = DA(y ^ z, K ^ hA, 48), o = N + (hA = h) | 0, N = D, o = (D = n + D | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o, n = f, f = r ^ D, r = o, f = DA(f, o ^ p, 1), o = (p = h) + s | 0, o = MA + (f >>> 0 > (y = n + f | 0) >>> 0 ? o + 1 | 0 : o) | 0, o = wA + (n = (y = y + cA | 0) >>> 0 < cA >>> 0 ? o + 1 | 0 : o) | 0, z = s = y + gA | 0, s = o = s >>> 0 < gA >>> 0 ? o + 1 | 0 : o, y = DA(y ^ G, n ^ $, 32), o = b + (K = h) | 0, G = o = (n = y + S | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o, S = DA(f ^ n, p ^ o, 40), o = ($ = h) + s | 0, p = f = S + z | 0, y = DA(f ^ y, K ^ (b = f >>> 0 < S >>> 0 ? o + 1 | 0 : o), 48), o = G + (z = h) | 0, K = f = y + n | 0, G = f, R = o = f >>> 0 < n >>> 0 ? o + 1 | 0 : o, n = D, s = r, o = M + P | 0, o = (f = w + L | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o, w = f, f ^= _, _ = o, o = DA(f, AA ^ o, 1), m = f = h, M = o, r = o, o = d + l | 0, o = ((D = F + aA | 0) >>> 0 < aA >>> 0 ? o + 1 | 0 : o) + f | 0, F = o = (f = D) >>> 0 > (D = r + D | 0) >>> 0 ? o + 1 | 0 : o, r = DA(c ^ D, o ^ x, 32), o = (o = s) + (s = h) | 0, L = f = r + n | 0, c = DA(c = f ^ M, m ^ (M = f >>> 0 < r >>> 0 ? o + 1 | 0 : o), 40), o = F + (x = h) | 0, o = FA + ((f = c + D | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o) | 0, m = o = (n = f + V | 0) >>> 0 < V >>> 0 ? o + 1 | 0 : o, s = DA(r ^ n, s ^ o, 48), SA = o = h, f = DA(k ^ J, U ^ W, 1), o = (r = h) + O | 0, o = kA + ((D = f + Z | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o) | 0, o = j + (k = (D = D + oA | 0) >>> 0 < oA >>> 0 ? o + 1 | 0 : o) | 0, O = F = I + D | 0, J = o = F >>> 0 < I >>> 0 ? o + 1 | 0 : o, U = f, F = DA(D ^ N, k ^ hA, 32), o = (W = h) + _ | 0, _ = f = F + w | 0, D = DA(f ^ U, (N = f >>> 0 < F >>> 0 ? o + 1 | 0 : o) ^ r, 40), o = (o = J) + (J = h) | 0, U = f = D + O | 0, O = o = f >>> 0 < D >>> 0 ? o + 1 | 0 : o, r = o, o = j + T | 0, o = ((k = I + u | 0) >>> 0 < I >>> 0 ? o + 1 | 0 : o) + r | 0, d = o = (r = f + k | 0) >>> 0 < k >>> 0 ? o + 1 | 0 : o, f = DA(r ^ s, SA ^ o, 32), o = (u = h) + R | 0, w = DA((k = f + G | 0) ^ CA, (o = k >>> 0 < f >>> 0 ? o + 1 | 0 : o) ^ T, 40), T = o, o = wA + (G = h) | 0, o = d + ((Z = w + gA | 0) >>> 0 < gA >>> 0 ? o + 1 | 0 : o) | 0, o = (d = r + Z | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = u, u = o, r = DA(f ^ d, r ^ o, 48), o = (o = T) + (T = h) | 0, f = w ^ (k = r + k | 0), w = o = k >>> 0 < r >>> 0 ? o + 1 | 0 : o, Z = o = DA(f, o ^ G, 1), CA = o, P = f = h, G = e, AA = t, e = D, D = DA(F ^ U, O ^ W, 48), o = N + (U = h) | 0, F = f = D + _ | 0, _ = o = f >>> 0 < _ >>> 0 ? o + 1 | 0 : o, e = DA(f ^ e, o ^ J, 1), o = (O = h) + MA | 0, o = m + ((f = e + cA | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o) | 0, n = o = (t = f + n | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o, f = DA(t ^ y, o ^ z, 32), o = (J = h) + AA | 0, G = y = f + G | 0, N = o = y >>> 0 < f >>> 0 ? o + 1 | 0 : o, e = DA(e ^ y, o ^ O, 40), o = nA + (hA = h) | 0, O = e, o = n + ((e = EA + e | 0) >>> 0 < EA >>> 0 ? o + 1 | 0 : o) | 0, t = o = (e = e + t | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o, y = DA(f ^ e, o ^ J, 48), o = (o = N) + (N = h) | 0, z = f = y + G | 0, J = f, m = o = f >>> 0 < y >>> 0 ? o + 1 | 0 : o, o = M + SA | 0, G = (f = s + L | 0) ^ c, c = o = f >>> 0 < s >>> 0 ? o + 1 | 0 : o, o = DA(G, o ^ x, 1), x = n = h, G = o, o = b + eA | 0, o = ((s = p + q | 0) >>> 0 < q >>> 0 ? o + 1 | 0 : o) + n | 0, M = o = (M = s) >>> 0 > (s = s + G | 0) >>> 0 ? o + 1 | 0 : o, L = n = DA(s ^ v, IA ^ o, 32), p = o = h, o = o + _ | 0, b = n = n + F | 0, v = o = L >>> 0 > n >>> 0 ? o + 1 | 0 : o, n = DA(n ^ G, x ^ o, 40), o = yA + (x = h) | 0, o = M + ((F = n + rA | 0) >>> 0 < rA >>> 0 ? o + 1 | 0 : o) | 0, F = o = (G = s) >>> 0 > (s = s + F | 0) >>> 0 ? o + 1 | 0 : o, G = DA(s ^ L, o ^ p, 48), IA = o = h, _ = o, S = DA(S ^ K, R ^ $, 1), M = o = h, L = D, o = o + l | 0, o = Y + ((D = S + aA | 0) >>> 0 < aA >>> 0 ? o + 1 | 0 : o) | 0, o = (D = D + H | 0) >>> 0 < H >>> 0 ? o + 1 | 0 : o, H = D ^ L, L = o, H = DA(H, o ^ U, 32), o = ($ = h) + c | 0, Y = f = H + f | 0, c = DA(f ^ S, (c = M) ^ (M = f >>> 0 < H >>> 0 ? o + 1 | 0 : o), 40), o = kA + (p = h) | 0, o = L + ((f = c + oA | 0) >>> 0 < oA >>> 0 ? o + 1 | 0 : o) | 0, L = f = f + D | 0, U = o = f >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = o, o = P + _A | 0, o = ((S = Z + iA | 0) >>> 0 < iA >>> 0 ? o + 1 | 0 : o) + D | 0, Z = o = (D = f + S | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o, f = DA(D ^ G, o ^ _, 32), o = (K = h) + m | 0, _ = DA((S = f + J | 0) ^ CA, (o = S >>> 0 < f >>> 0 ? o + 1 | 0 : o) ^ P, 40), R = J = h, P = o, o = J + HA | 0, o = Z + ((J = _ + tA | 0) >>> 0 < tA >>> 0 ? o + 1 | 0 : o) | 0, Z = o = (J = D + J | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = DA(f ^ J, o ^ K, 48), o = (K = h) + P | 0, f = (S = D + S | 0) ^ _, _ = o = S >>> 0 < D >>> 0 ? o + 1 | 0 : o, R = o = DA(f, o ^ R, 1), P = f = h, AA = k, W = y, y = c, c = DA(H ^ L, U ^ $, 48), o = (H = h) + M | 0, M = f = c + Y | 0, L = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, y = DA(f ^ y, o ^ p, 1), o = (p = h) + GA | 0, o = ((f = y + QA | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o) + F | 0, s = o = (k = f + s | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, f = DA(k ^ W, o ^ N, 32), o = (F = h) + w | 0, Y = w = f + AA | 0, N = o = w >>> 0 < f >>> 0 ? o + 1 | 0 : o, y = DA(y ^ w, o ^ p, 40), o = C + (W = h) | 0, p = y, o = s + ((y = sA + y | 0) >>> 0 < sA >>> 0 ? o + 1 | 0 : o) | 0, U = o = (w = y + k | 0) >>> 0 < k >>> 0 ? o + 1 | 0 : o, y = DA(f ^ w, o ^ F, 48), o = (o = N) + (N = h) | 0, Y = f = y + Y | 0, AA = o = f >>> 0 < y >>> 0 ? o + 1 | 0 : o, s = r, k = e, o = v + IA | 0, r = o = (f = G + b | 0) >>> 0 < G >>> 0 ? o + 1 | 0 : o, e = DA(f ^ n, o ^ x, 1), o = (n = h) + BA | 0, o = ((F = e + X | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o) + t | 0, t = DA(s ^ (k = k + F | 0), (o = k >>> 0 < F >>> 0 ? o + 1 | 0 : o) ^ T, 32), F = o, G = e, o = (s = h) + L | 0, o = (e = t + M | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o, M = e, e ^= G, G = o, e = DA(e, o ^ n, 40), o = B + (L = h) | 0, o = ((n = e + g | 0) >>> 0 < g >>> 0 ? o + 1 | 0 : o) + F | 0, b = o = (F = n) >>> 0 > (n = n + k | 0) >>> 0 ? o + 1 | 0 : o, s = DA(t ^ n, o ^ s, 48), IA = o = h, k = o, t = DA(z ^ O, m ^ hA, 1), v = o = h, O = r, o = o + FA | 0, o = u + ((r = t + V | 0) >>> 0 < V >>> 0 ? o + 1 | 0 : o) | 0, F = H, H = o = (r = r + d | 0) >>> 0 < d >>> 0 ? o + 1 | 0 : o, F = DA(c ^ r, F ^ o, 32), o = ($ = h) + O | 0, d = f = F + f | 0, c = DA(f ^ t, (c = v) ^ (v = f >>> 0 < F >>> 0 ? o + 1 | 0 : o), 40), o = pA + (O = h) | 0, o = H + ((f = c + fA | 0) >>> 0 < fA >>> 0 ? o + 1 | 0 : o) | 0, u = f = f + r | 0, z = o = f >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = o, o = P + eA | 0, o = ((t = q + R | 0) >>> 0 < q >>> 0 ? o + 1 | 0 : o) + r | 0, H = o = (r = f + t | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o, f = DA(r ^ s, o ^ k, 32), o = (T = h) + AA | 0, k = DA((t = f + Y | 0) ^ R, (o = t >>> 0 < f >>> 0 ? o + 1 | 0 : o) ^ P, 40), R = o, o = l + (x = h) | 0, o = H + ((m = k + aA | 0) >>> 0 < aA >>> 0 ? o + 1 | 0 : o) | 0, o = (H = r + m | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = T, T = o, r = DA(f ^ H, r ^ o, 48), o = (o = R) + (R = h) | 0, f = (t = r + t | 0) ^ k, k = o = t >>> 0 < r >>> 0 ? o + 1 | 0 : o, x = o = DA(f, o ^ x, 1), m = f = h, P = y, y = c, c = DA(F ^ u, z ^ $, 48), o = (o = v) + (v = h) | 0, d = f = c + d | 0, F = O, O = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, y = DA(f ^ y, F ^ o, 1), o = (u = h) + HA | 0, o = b + ((f = y + tA | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o) | 0, F = n, n = f + n | 0, f = N, N = o = F >>> 0 > n >>> 0 ? o + 1 | 0 : o, f = DA(n ^ P, f ^ o, 32), o = (o = _) + (_ = h) | 0, b = o = (F = f + S | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, S = F, y = DA(y ^ F, o ^ u, 40), o = FA + ($ = h) | 0, u = y, o = N + ((y = V + y | 0) >>> 0 < V >>> 0 ? o + 1 | 0 : o) | 0, N = o = (F = y + n | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o, y = DA(f ^ F, o ^ _, 48), o = (o = b) + (b = h) | 0, z = f = y + S | 0, P = o = f >>> 0 < y >>> 0 ? o + 1 | 0 : o, S = D, o = G + IA | 0, D = o = (f = s + M | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, e = DA(f ^ e, o ^ L, 1), o = wA + (s = h) | 0, o = U + ((n = e + gA | 0) >>> 0 < gA >>> 0 ? o + 1 | 0 : o) | 0, G = (n = w + n | 0) ^ S, S = o = n >>> 0 < w >>> 0 ? o + 1 | 0 : o, w = DA(G, o ^ K, 32), _ = o = h, G = e, o = o + O | 0, o = (e = w + d | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o, M = e, e ^= G, G = o, e = DA(e, o ^ s, 40), o = B + (L = h) | 0, o = S + ((s = e + g | 0) >>> 0 < g >>> 0 ? o + 1 | 0 : o) | 0, U = o = (s = n + s | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o, S = DA(w ^ s, o ^ _, 48), IA = o = h, n = o, w = DA(p ^ Y, W ^ AA, 1), d = o = h, Y = D, o = o + C | 0, o = Z + ((D = w + sA | 0) >>> 0 < sA >>> 0 ? o + 1 | 0 : o) | 0, J = o = (D = D + J | 0) >>> 0 < J >>> 0 ? o + 1 | 0 : o, _ = DA(c ^ D, o ^ v, 32), o = (CA = h) + Y | 0, Y = f = _ + f | 0, c = DA(f ^ w, (p = f >>> 0 < _ >>> 0 ? o + 1 | 0 : o) ^ d, 40), o = j + (v = h) | 0, o = J + ((f = I + c | 0) >>> 0 < I >>> 0 ? o + 1 | 0 : o) | 0, J = f = f + D | 0, O = o = f >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = o, o = m + kA | 0, o = ((w = x + oA | 0) >>> 0 < oA >>> 0 ? o + 1 | 0 : o) + D | 0, d = o = (D = f + w | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o, f = DA(D ^ S, o ^ n, 32), o = (Z = h) + P | 0, n = DA((w = f + z | 0) ^ x, (o = w >>> 0 < f >>> 0 ? o + 1 | 0 : o) ^ m, 40), K = o, o = MA + (x = h) | 0, o = d + ((m = n + cA | 0) >>> 0 < cA >>> 0 ? o + 1 | 0 : o) | 0, o = (d = D + m | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = Z, Z = o, D = DA(f ^ d, D ^ o, 48), o = (o = K) + (K = h) | 0, f = (w = D + w | 0) ^ n, n = o = w >>> 0 < D >>> 0 ? o + 1 | 0 : o, x = o = DA(f, o ^ x, 1), hA = o, m = f = h, AA = t, W = y, t = c, c = DA(_ ^ J, O ^ CA, 48), o = (_ = h) + p | 0, J = f = c + Y | 0, Y = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, t = DA(f ^ t, o ^ v, 1), o = (v = h) + yA | 0, o = U + ((f = t + rA | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o) | 0, s = o = (y = f + s | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, f = DA(y ^ W, o ^ b, 32), o = (p = h) + k | 0, b = o = (k = f + AA | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, t = DA(t ^ k, o ^ v, 40), o = GA + (CA = h) | 0, U = t, o = s + ((t = QA + t | 0) >>> 0 < QA >>> 0 ? o + 1 | 0 : o) | 0, s = t + y | 0, t = p, p = o = s >>> 0 < y >>> 0 ? o + 1 | 0 : o, t = DA(f ^ s, t ^ o, 48), o = (o = b) + (b = h) | 0, v = f = t + k | 0, O = o = f >>> 0 < t >>> 0 ? o + 1 | 0 : o, y = r, o = G + IA | 0, r = o = (f = S + M | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o, e = DA(f ^ e, o ^ L, 1), o = (S = h) + pA | 0, o = N + ((k = e + fA | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o) | 0, y = DA(y ^ (k = k + F | 0), (o = k >>> 0 < F >>> 0 ? o + 1 | 0 : o) ^ R, 32), G = F = h, F = o, M = e, o = G + Y | 0, o = (e = y + J | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o, J = e, e ^= M, M = o, e = DA(e, o ^ S, 40), o = nA + (L = h) | 0, o = ((S = e + EA | 0) >>> 0 < EA >>> 0 ? o + 1 | 0 : o) + F | 0, N = G, G = o = (F = k + S | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o, S = DA(y ^ F, N ^ o, 48), IA = o = h, k = o, y = DA(z ^ u, P ^ $, 1), Y = o = h, N = r, o = o + BA | 0, o = T + ((r = y + X | 0) >>> 0 < X >>> 0 ? o + 1 | 0 : o) | 0, H = o = (r = r + H | 0) >>> 0 < H >>> 0 ? o + 1 | 0 : o, _ = DA(c ^ r, o ^ _, 32), o = ($ = h) + N | 0, N = f = _ + f | 0, c = DA(f ^ y, (c = Y) ^ (Y = f >>> 0 < _ >>> 0 ? o + 1 | 0 : o), 40), o = _A + (u = h) | 0, o = H + ((f = c + iA | 0) >>> 0 < iA >>> 0 ? o + 1 | 0 : o) | 0, z = f = f + r | 0, T = o = f >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = o, o = m + B | 0, o = ((y = x + g | 0) >>> 0 < g >>> 0 ? o + 1 | 0 : o) + r | 0, H = o = (r = f + y | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o, f = DA(r ^ S, o ^ k, 32), o = (x = h) + O | 0, k = DA((y = f + v | 0) ^ hA, (o = y >>> 0 < f >>> 0 ? o + 1 | 0 : o) ^ m, 40), m = o, o = HA + (R = h) | 0, o = H + ((P = k + tA | 0) >>> 0 < tA >>> 0 ? o + 1 | 0 : o) | 0, o = (H = r + P | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = x, x = o, r = DA(f ^ H, r ^ o, 48), o = (o = m) + (m = h) | 0, f = (y = r + y | 0) ^ k, k = o = y >>> 0 < r >>> 0 ? o + 1 | 0 : o, R = o = DA(f, o ^ R, 1), P = f = h, AA = w, W = t, t = c, c = DA(_ ^ z, T ^ $, 48), o = (_ = h) + Y | 0, Y = f = c + N | 0, N = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, t = DA(f ^ t, o ^ u, 1), o = (u = h) + GA | 0, o = G + ((f = t + QA | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o) | 0, F = o = (w = f + F | 0) >>> 0 < F >>> 0 ? o + 1 | 0 : o, f = DA(w ^ W, o ^ b, 32), o = (G = h) + n | 0, b = o = (n = f + AA | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, t = DA(t ^ n, o ^ u, 40), o = BA + ($ = h) | 0, u = t, o = F + ((t = X + t | 0) >>> 0 < X >>> 0 ? o + 1 | 0 : o) | 0, F = t + w | 0, t = G, G = o = F >>> 0 < w >>> 0 ? o + 1 | 0 : o, t = DA(f ^ F, t ^ o, 48), o = (o = b) + (b = h) | 0, z = f = t + n | 0, T = o = f >>> 0 < t >>> 0 ? o + 1 | 0 : o, w = D, o = M + IA | 0, D = o = (f = S + J | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o, e = DA(f ^ e, o ^ L, 1), o = _A + (S = h) | 0, o = p + ((n = e + iA | 0) >>> 0 < iA >>> 0 ? o + 1 | 0 : o) | 0, s = o = (n = n + s | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, w = DA(w ^ n, o ^ K, 32), J = o = h, M = e, o = o + N | 0, o = (e = w + Y | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o, L = e, e ^= M, M = o, e = DA(e, o ^ S, 40), o = kA + (Y = h) | 0, o = s + ((S = e + oA | 0) >>> 0 < oA >>> 0 ? o + 1 | 0 : o) | 0, o = (s = n + S | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o, n = J, J = o, S = DA(w ^ s, n ^ o, 48), IA = o = h, n = o, w = DA(U ^ v, O ^ CA, 1), N = o = h, p = D, o = o + j | 0, o = Z + ((D = I + w | 0) >>> 0 < I >>> 0 ? o + 1 | 0 : o) | 0, d = o = (D = D + d | 0) >>> 0 < d >>> 0 ? o + 1 | 0 : o, _ = DA(c ^ D, o ^ _, 32), o = (CA = h) + p | 0, p = f = _ + f | 0, c = DA(f ^ w, (c = N) ^ (N = f >>> 0 < _ >>> 0 ? o + 1 | 0 : o), 40), o = FA + (U = h) | 0, o = d + ((f = c + V | 0) >>> 0 < V >>> 0 ? o + 1 | 0 : o) | 0, v = f = f + D | 0, O = o = f >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = o, o = P + wA | 0, o = ((w = R + gA | 0) >>> 0 < gA >>> 0 ? o + 1 | 0 : o) + D | 0, d = o = (D = f + w | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o, f = DA(D ^ S, o ^ n, 32), o = (Z = h) + T | 0, n = DA((w = f + z | 0) ^ R, (o = w >>> 0 < f >>> 0 ? o + 1 | 0 : o) ^ P, 40), R = o, o = C + (K = h) | 0, o = d + ((P = n + sA | 0) >>> 0 < sA >>> 0 ? o + 1 | 0 : o) | 0, o = (d = D + P | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = Z, Z = o, D = DA(f ^ d, D ^ o, 48), o = (o = R) + (R = h) | 0, f = (w = D + w | 0) ^ n, n = o = w >>> 0 < D >>> 0 ? o + 1 | 0 : o, K = o = DA(f, o ^ K, 1), P = f = h, AA = y, W = t, t = c, c = DA(_ ^ v, O ^ CA, 48), o = (_ = h) + N | 0, N = f = c + p | 0, p = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, t = DA(f ^ t, o ^ U, 1), o = (U = h) + eA | 0, o = J + ((f = t + q | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o) | 0, s = o = (y = f + s | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, f = DA(y ^ W, o ^ b, 32), o = (J = h) + k | 0, b = o = (k = f + AA | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, t = DA(t ^ k, o ^ U, 40), o = pA + (CA = h) | 0, U = t, o = s + ((t = fA + t | 0) >>> 0 < fA >>> 0 ? o + 1 | 0 : o) | 0, s = t + y | 0, t = J, J = o = s >>> 0 < y >>> 0 ? o + 1 | 0 : o, t = DA(f ^ s, t ^ o, 48), o = (o = b) + (b = h) | 0, v = f = t + k | 0, O = o = f >>> 0 < t >>> 0 ? o + 1 | 0 : o, y = r, o = M + IA | 0, r = o = (f = S + L | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o, e = DA(f ^ e, o ^ Y, 1), o = (S = h) + nA | 0, o = G + ((k = e + EA | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o) | 0, F = o = (k = k + F | 0) >>> 0 < F >>> 0 ? o + 1 | 0 : o, y = DA(y ^ k, o ^ m, 32), G = o = h, M = e, o = o + p | 0, o = (e = y + N | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o, L = e, e ^= M, M = o, e = DA(e, o ^ S, 40), o = yA + (Y = h) | 0, o = F + ((S = e + rA | 0) >>> 0 < rA >>> 0 ? o + 1 | 0 : o) | 0, N = G, G = o = (F = k + S | 0) >>> 0 < k >>> 0 ? o + 1 | 0 : o, S = DA(y ^ F, N ^ o, 48), IA = o = h, k = o, y = DA(z ^ u, T ^ $, 1), N = o = h, p = r, o = o + l | 0, o = x + ((r = y + aA | 0) >>> 0 < aA >>> 0 ? o + 1 | 0 : o) | 0, H = o = (r = r + H | 0) >>> 0 < H >>> 0 ? o + 1 | 0 : o, _ = DA(c ^ r, o ^ _, 32), o = ($ = h) + p | 0, p = f = _ + f | 0, c = DA(f ^ y, (c = N) ^ (N = f >>> 0 < _ >>> 0 ? o + 1 | 0 : o), 40), o = MA + (u = h) | 0, o = H + ((f = c + cA | 0) >>> 0 < cA >>> 0 ? o + 1 | 0 : o) | 0, z = f = f + r | 0, T = o = f >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = o, o = P + C | 0, o = ((y = K + sA | 0) >>> 0 < sA >>> 0 ? o + 1 | 0 : o) + r | 0, H = o = (r = f + y | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o, f = DA(r ^ S, o ^ k, 32), o = (x = h) + O | 0, k = DA((y = f + v | 0) ^ K, (o = y >>> 0 < f >>> 0 ? o + 1 | 0 : o) ^ P, 40), m = o, o = _A + (K = h) | 0, o = H + ((P = k + iA | 0) >>> 0 < iA >>> 0 ? o + 1 | 0 : o) | 0, o = (H = r + P | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = x, x = o, r = DA(f ^ H, r ^ o, 48), o = (o = m) + (m = h) | 0, f = (y = r + y | 0) ^ k, k = o = y >>> 0 < r >>> 0 ? o + 1 | 0 : o, K = o = DA(f, o ^ K, 1), P = f = h, AA = w, W = t, t = c, c = DA(_ ^ z, T ^ $, 48), o = (_ = h) + N | 0, N = f = c + p | 0, p = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, t = DA(f ^ t, o ^ u, 1), o = (u = h) + l | 0, o = G + ((f = t + aA | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o) | 0, F = o = (w = f + F | 0) >>> 0 < F >>> 0 ? o + 1 | 0 : o, f = DA(w ^ W, o ^ b, 32), o = (G = h) + n | 0, b = o = (n = f + AA | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, t = DA(t ^ n, o ^ u, 40), o = yA + ($ = h) | 0, u = t, o = F + ((t = rA + t | 0) >>> 0 < rA >>> 0 ? o + 1 | 0 : o) | 0, F = t + w | 0, t = G, G = o = F >>> 0 < w >>> 0 ? o + 1 | 0 : o, t = DA(f ^ F, t ^ o, 48), o = (o = b) + (b = h) | 0, z = f = t + n | 0, T = o = f >>> 0 < t >>> 0 ? o + 1 | 0 : o, w = D, o = M + IA | 0, D = o = (f = S + L | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o, e = DA(f ^ e, o ^ Y, 1), o = nA + (S = h) | 0, o = J + ((n = e + EA | 0) >>> 0 < EA >>> 0 ? o + 1 | 0 : o) | 0, s = o = (n = n + s | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, w = DA(w ^ n, o ^ R, 32), J = o = h, M = e, o = o + p | 0, o = (e = w + N | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o, L = e, e ^= M, M = o, e = DA(e, o ^ S, 40), o = pA + (Y = h) | 0, o = s + ((S = e + fA | 0) >>> 0 < fA >>> 0 ? o + 1 | 0 : o) | 0, o = (s = n + S | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o, n = J, J = o, S = DA(w ^ s, n ^ o, 48), IA = o = h, n = o, w = DA(U ^ v, O ^ CA, 1), N = o = h, p = D, o = o + BA | 0, o = Z + ((D = w + X | 0) >>> 0 < X >>> 0 ? o + 1 | 0 : o) | 0, d = o = (D = D + d | 0) >>> 0 < d >>> 0 ? o + 1 | 0 : o, _ = DA(c ^ D, o ^ _, 32), o = (CA = h) + p | 0, p = f = _ + f | 0, c = DA(f ^ w, (c = N) ^ (N = f >>> 0 < _ >>> 0 ? o + 1 | 0 : o), 40), o = MA + (U = h) | 0, o = d + ((f = c + cA | 0) >>> 0 < cA >>> 0 ? o + 1 | 0 : o) | 0, v = f = f + D | 0, O = o = f >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = o, o = P + FA | 0, o = ((w = K + V | 0) >>> 0 < V >>> 0 ? o + 1 | 0 : o) + D | 0, d = o = (D = f + w | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o, f = DA(D ^ S, o ^ n, 32), o = (Z = h) + T | 0, n = DA((w = f + z | 0) ^ K, (o = w >>> 0 < f >>> 0 ? o + 1 | 0 : o) ^ P, 40), R = o, o = j + (K = h) | 0, o = d + ((P = I + n | 0) >>> 0 < I >>> 0 ? o + 1 | 0 : o) | 0, o = (d = D + P | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = Z, Z = o, D = DA(f ^ d, D ^ o, 48), o = (o = R) + (R = h) | 0, f = (w = D + w | 0) ^ n, n = o = w >>> 0 < D >>> 0 ? o + 1 | 0 : o, K = o = DA(f, o ^ K, 1), P = f = h, AA = y, W = t, t = c, c = DA(_ ^ v, O ^ CA, 48), o = (_ = h) + N | 0, N = f = c + p | 0, p = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, t = DA(f ^ t, o ^ U, 1), o = (U = h) + kA | 0, o = J + ((f = t + oA | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o) | 0, s = o = (y = f + s | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, f = DA(y ^ W, o ^ b, 32), o = (J = h) + k | 0, b = o = (k = f + AA | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, t = DA(t ^ k, o ^ U, 40), o = B + (CA = h) | 0, U = t, o = s + ((t = g + t | 0) >>> 0 < g >>> 0 ? o + 1 | 0 : o) | 0, s = t + y | 0, t = J, J = o = s >>> 0 < y >>> 0 ? o + 1 | 0 : o, t = DA(f ^ s, t ^ o, 48), o = (o = b) + (b = h) | 0, v = f = t + k | 0, O = o = f >>> 0 < t >>> 0 ? o + 1 | 0 : o, y = r, o = M + IA | 0, r = o = (f = S + L | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o, e = DA(f ^ e, o ^ Y, 1), o = (S = h) + wA | 0, o = G + ((k = e + gA | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o) | 0, F = o = (k = k + F | 0) >>> 0 < F >>> 0 ? o + 1 | 0 : o, y = DA(y ^ k, o ^ m, 32), G = o = h, M = e, o = o + p | 0, o = (e = y + N | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o, L = e, e ^= M, M = o, e = DA(e, o ^ S, 40), o = GA + (Y = h) | 0, o = F + ((S = e + QA | 0) >>> 0 < QA >>> 0 ? o + 1 | 0 : o) | 0, N = G, G = o = (F = k + S | 0) >>> 0 < k >>> 0 ? o + 1 | 0 : o, S = DA(y ^ F, N ^ o, 48), IA = o = h, k = o, y = DA(z ^ u, T ^ $, 1), N = o = h, p = r, o = o + HA | 0, o = x + ((r = y + tA | 0) >>> 0 < tA >>> 0 ? o + 1 | 0 : o) | 0, H = o = (r = r + H | 0) >>> 0 < H >>> 0 ? o + 1 | 0 : o, _ = DA(c ^ r, o ^ _, 32), o = ($ = h) + p | 0, p = f = _ + f | 0, c = DA(f ^ y, (c = N) ^ (N = f >>> 0 < _ >>> 0 ? o + 1 | 0 : o), 40), o = eA + (u = h) | 0, o = H + ((f = c + q | 0) >>> 0 < q >>> 0 ? o + 1 | 0 : o) | 0, z = f = f + r | 0, T = o = f >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = o, o = P + MA | 0, o = ((y = K + cA | 0) >>> 0 < cA >>> 0 ? o + 1 | 0 : o) + r | 0, H = o = (r = f + y | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o, f = DA(r ^ S, o ^ k, 32), o = (x = h) + O | 0, k = DA((y = f + v | 0) ^ K, (o = y >>> 0 < f >>> 0 ? o + 1 | 0 : o) ^ P, 40), m = o, o = yA + (K = h) | 0, o = H + ((P = k + rA | 0) >>> 0 < rA >>> 0 ? o + 1 | 0 : o) | 0, o = (H = r + P | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = x, x = o, r = DA(f ^ H, r ^ o, 48), o = (o = m) + (m = h) | 0, f = (y = r + y | 0) ^ k, k = o = y >>> 0 < r >>> 0 ? o + 1 | 0 : o, K = o = DA(f, o ^ K, 1), P = f = h, AA = w, W = t, t = c, c = DA(_ ^ z, T ^ $, 48), o = (_ = h) + N | 0, N = f = c + p | 0, p = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, t = DA(f ^ t, o ^ u, 1), o = (u = h) + _A | 0, o = G + ((f = t + iA | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o) | 0, F = o = (w = f + F | 0) >>> 0 < F >>> 0 ? o + 1 | 0 : o, f = DA(w ^ W, o ^ b, 32), o = (G = h) + n | 0, b = o = (n = f + AA | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, t = DA(t ^ n, o ^ u, 40), o = C + ($ = h) | 0, u = t, o = F + ((t = sA + t | 0) >>> 0 < sA >>> 0 ? o + 1 | 0 : o) | 0, F = t + w | 0, t = G, G = o = F >>> 0 < w >>> 0 ? o + 1 | 0 : o, t = DA(f ^ F, t ^ o, 48), o = (o = b) + (b = h) | 0, z = f = t + n | 0, T = o = f >>> 0 < t >>> 0 ? o + 1 | 0 : o, w = D, o = M + IA | 0, D = o = (f = S + L | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o, e = DA(f ^ e, o ^ Y, 1), o = GA + (S = h) | 0, o = J + ((n = e + QA | 0) >>> 0 < QA >>> 0 ? o + 1 | 0 : o) | 0, s = o = (n = n + s | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, w = DA(w ^ n, o ^ R, 32), J = o = h, M = e, o = o + p | 0, o = (e = w + N | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o, L = e, e ^= M, M = o, e = DA(e, o ^ S, 40), o = l + (Y = h) | 0, o = s + ((S = e + aA | 0) >>> 0 < aA >>> 0 ? o + 1 | 0 : o) | 0, o = (s = n + S | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o, n = J, J = o, S = DA(w ^ s, n ^ o, 48), IA = o = h, n = o, w = DA(U ^ v, O ^ CA, 1), N = o = h, p = D, o = o + pA | 0, o = Z + ((D = w + fA | 0) >>> 0 < fA >>> 0 ? o + 1 | 0 : o) | 0, d = o = (D = D + d | 0) >>> 0 < d >>> 0 ? o + 1 | 0 : o, _ = DA(c ^ D, o ^ _, 32), o = (CA = h) + p | 0, p = f = _ + f | 0, c = DA(f ^ w, (c = N) ^ (N = f >>> 0 < _ >>> 0 ? o + 1 | 0 : o), 40), o = HA + (U = h) | 0, o = d + ((f = c + tA | 0) >>> 0 < tA >>> 0 ? o + 1 | 0 : o) | 0, v = f = f + D | 0, O = o = f >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = o, o = P + nA | 0, o = ((w = K + EA | 0) >>> 0 < EA >>> 0 ? o + 1 | 0 : o) + D | 0, d = o = (D = f + w | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o, f = DA(D ^ S, o ^ n, 32), o = (Z = h) + T | 0, n = DA((w = f + z | 0) ^ K, (o = w >>> 0 < f >>> 0 ? o + 1 | 0 : o) ^ P, 40), R = o, o = B + (K = h) | 0, o = d + ((P = n + g | 0) >>> 0 < g >>> 0 ? o + 1 | 0 : o) | 0, o = (d = D + P | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = Z, Z = o, D = DA(f ^ d, D ^ o, 48), o = (o = R) + (R = h) | 0, f = (w = D + w | 0) ^ n, n = o = w >>> 0 < D >>> 0 ? o + 1 | 0 : o, K = o = DA(f, o ^ K, 1), P = f = h, AA = y, W = t, t = c, c = DA(_ ^ v, O ^ CA, 48), o = (_ = h) + N | 0, N = f = c + p | 0, p = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, t = DA(f ^ t, o ^ U, 1), o = (v = h) + BA | 0, o = J + ((f = t + X | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o) | 0, s = o = (y = f + s | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, f = DA(y ^ W, o ^ b, 32), o = (J = h) + k | 0, b = k = f + AA | 0, U = o = k >>> 0 < f >>> 0 ? o + 1 | 0 : o, t = DA(t ^ k, o ^ v, 40), o = FA + (AA = h) | 0, v = t, o = s + ((t = V + t | 0) >>> 0 < V >>> 0 ? o + 1 | 0 : o) | 0, k = t + y | 0, t = J, J = o = k >>> 0 < y >>> 0 ? o + 1 | 0 : o, t = DA(f ^ k, t ^ o, 48), o = (o = U) + (U = h) | 0, b = f = t + b | 0, O = o = f >>> 0 < t >>> 0 ? o + 1 | 0 : o, y = r, o = M + IA | 0, r = o = (f = S + L | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o, e = DA(f ^ e, o ^ Y, 1), o = (S = h) + j | 0, o = G + ((s = I + e | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o) | 0, F = o = (s = s + F | 0) >>> 0 < F >>> 0 ? o + 1 | 0 : o, G = y = DA(y ^ s, o ^ m, 32), M = o = h, L = e, o = o + p | 0, o = (e = y + N | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o, Y = e, e ^= L, L = o, e = DA(e, o ^ S, 40), o = kA + (N = h) | 0, o = F + ((y = e + oA | 0) >>> 0 < oA >>> 0 ? o + 1 | 0 : o) | 0, p = (y = y + s | 0) ^ G, G = o = y >>> 0 < s >>> 0 ? o + 1 | 0 : o, s = DA(p, o ^ M, 48), m = o = h, S = o, M = F = DA(z ^ u, T ^ $, 1), p = o = h, u = r, o = o + eA | 0, o = x + ((r = F + q | 0) >>> 0 < q >>> 0 ? o + 1 | 0 : o) | 0, o = (r = r + H | 0) >>> 0 < H >>> 0 ? o + 1 | 0 : o, H = _, _ = o, F = DA(c ^ r, H ^ o, 32), o = (W = h) + u | 0, H = f = F + f | 0, c = DA(c = f ^ M, (M = f >>> 0 < F >>> 0 ? o + 1 | 0 : o) ^ p, 40), o = wA + (p = h) | 0, o = _ + ((f = c + gA | 0) >>> 0 < gA >>> 0 ? o + 1 | 0 : o) | 0, _ = f = f + r | 0, u = o = f >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = o, o = P + FA | 0, o = ((x = V) >>> 0 > (V = K + V | 0) >>> 0 ? o + 1 | 0 : o) + r | 0, FA = o = (f = f + V | 0) >>> 0 < V >>> 0 ? o + 1 | 0 : o, V = DA(f ^ s, o ^ S, 32), o = (z = h) + O | 0, S = DA((r = b + V | 0) ^ K, (o = r >>> 0 < V >>> 0 ? o + 1 | 0 : o) ^ P, 40), x = o, o = kA + (T = h) | 0, o = FA + ((K = oA) >>> 0 > (oA = S + oA | 0) >>> 0 ? o + 1 | 0 : o) | 0, o = (oA = f + oA | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, f = V ^ oA, V = o;
                                        kA = DA(f, o ^ z, 48), o = (FA = h) + x | 0, r = o = (f = r + kA | 0) >>> 0 < kA >>> 0 ? o + 1 | 0 : o, o = DA(f ^ S, o ^ T, 1), S = h, z = o, T = w, w = gA, x = wA, wA = DA(F ^ _, u ^ W, 48), o = (F = h) + M | 0, M = w, H = o = (gA = H + wA | 0) >>> 0 < wA >>> 0 ? o + 1 | 0 : o, w = DA(c ^ (_ = gA), o ^ p, 1), o = (p = h) + x | 0, o = G + (w >>> 0 > (gA = M + w | 0) >>> 0 ? o + 1 | 0 : o) | 0, c = o = (gA = y + gA | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o, t = DA(t ^ gA, o ^ U, 32), o = (o = n) + (n = h) | 0, G = y = t + T | 0, M = o = y >>> 0 < t >>> 0 ? o + 1 | 0 : o, y = DA(y ^ w, o ^ p, 40), o = (p = h) + _A | 0, o = (y >>> 0 > (iA = y + iA | 0) >>> 0 ? o + 1 | 0 : o) + c | 0, c = o = (c = iA) >>> 0 > (iA = gA + iA | 0) >>> 0 ? o + 1 | 0 : o, t = DA(t ^ iA, o ^ n, 48), o = (w = h) + M | 0, n = gA = t + G | 0, _A = o = gA >>> 0 < t >>> 0 ? o + 1 | 0 : o, G = I, M = j, o = L + m | 0, gA = o = (I = s + Y | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, j = DA(I ^ e, o ^ N, 1), o = (s = h) + M | 0, o = J + ((e = G + j | 0) >>> 0 < j >>> 0 ? o + 1 | 0 : o) | 0, D = DA((e = e + k | 0) ^ D, (o = e >>> 0 < k >>> 0 ? o + 1 | 0 : o) ^ R, 32), G = o, J = EA, EA = j, o = (k = h) + H | 0, H = s, s = o = (j = D + _ | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o, EA = DA(j ^ EA, H ^ o, 40), o = (_ = h) + nA | 0, o = ((nA = J + EA | 0) >>> 0 < EA >>> 0 ? o + 1 | 0 : o) + G | 0, G = nA, e = D ^ (nA = e + nA | 0), D = o = G >>> 0 > nA >>> 0 ? o + 1 | 0 : o, o = DA(e, o ^ k, 48), L = e = h, k = o, H = X, G = BA, X = DA(b ^ v, O ^ AA, 1), M = o = h, o = o + MA | 0, o = Z + ((X = (J = X) + cA | 0) >>> 0 < cA >>> 0 ? o + 1 | 0 : o) | 0, cA = o = (X = d + X | 0) >>> 0 < d >>> 0 ? o + 1 | 0 : o, BA = DA(X ^ wA, o ^ F, 32), o = (d = h) + gA | 0, gA = I = BA + I | 0, wA = DA(I ^ J, (F = I >>> 0 < BA >>> 0 ? o + 1 | 0 : o) ^ M, 40), o = (o = G) + (G = h) | 0, o = cA + ((I = wA + H | 0) >>> 0 < wA >>> 0 ? o + 1 | 0 : o) | 0, cA = I = I + X | 0, MA = o = I >>> 0 < X >>> 0 ? o + 1 | 0 : o, X = o, o = S + GA | 0, o = ((J = QA) >>> 0 > (QA = z + QA | 0) >>> 0 ? o + 1 | 0 : o) + X | 0, GA = o = (X = I + QA | 0) >>> 0 < QA >>> 0 ? o + 1 | 0 : o, QA = DA(k ^ X, o ^ e, 32), o = (J = h) + _A | 0, e = I = QA + n | 0, I = DA(I ^ z, (H = S) ^ (S = I >>> 0 < QA >>> 0 ? o + 1 | 0 : o), 40), o = pA + (M = h) | 0, pA = I, o = GA + ((I = fA + I | 0) >>> 0 < fA >>> 0 ? o + 1 | 0 : o) | 0, o = (I = I + X | 0) >>> 0 < X >>> 0 ? o + 1 | 0 : o, GA = I, Y = (a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24) ^ I, H = o, N = o ^ (a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24), X = DA(BA ^ cA, d ^ MA, 48), o = (cA = h) + F | 0, F = I = X + gA | 0, MA = o = I >>> 0 < X >>> 0 ? o + 1 | 0 : o, BA = rA, o = s + L | 0, rA = o = (I = k + j | 0) >>> 0 < j >>> 0 ? o + 1 | 0 : o, EA = DA(I ^ EA, o ^ _, 1), o = (k = h) + yA | 0, o = ((BA = EA + BA | 0) >>> 0 < EA >>> 0 ? o + 1 | 0 : o) + c | 0, BA = o = (yA = BA + iA | 0) >>> 0 < BA >>> 0 ? o + 1 | 0 : o, gA = DA(yA ^ kA, o ^ FA, 32), o = (j = h) + MA | 0, iA = o = (fA = gA + F | 0) >>> 0 < gA >>> 0 ? o + 1 | 0 : o, kA = gA, gA = DA(EA ^ fA, o ^ k, 40), o = (c = h) + HA | 0, o = (gA >>> 0 > (EA = gA + tA | 0) >>> 0 ? o + 1 | 0 : o) + BA | 0, s = j, j = o = (yA = EA + yA | 0) >>> 0 < EA >>> 0 ? o + 1 | 0 : o, EA = DA(kA ^ (tA = yA), s ^ o, 48), o = (k = h) + iA | 0, o = (BA = EA + fA | 0) >>> 0 < EA >>> 0 ? o + 1 | 0 : o, fA = BA, BA ^= Y, E[A + 8 | 0] = BA, E[A + 9 | 0] = BA >>> 8, E[A + 10 | 0] = BA >>> 16, E[A + 11 | 0] = BA >>> 24, iA = o, o ^= N, E[A + 12 | 0] = o, E[A + 13 | 0] = o >>> 8, E[A + 14 | 0] = o >>> 16, E[A + 15 | 0] = o >>> 24, yA = I, BA = rA, I = X, X = DA(y ^ n, p ^ _A, 1), o = (HA = h) + B | 0, o = (X >>> 0 > (rA = X + g | 0) >>> 0 ? o + 1 | 0 : o) + V | 0, oA = o = (n = rA) >>> 0 > (rA = oA + rA | 0) >>> 0 ? o + 1 | 0 : o, I = DA(I ^ rA, o ^ cA, 32), o = (o = BA) + (BA = h) | 0, cA = o = (yA = I + yA | 0) >>> 0 < I >>> 0 ? o + 1 | 0 : o, kA = I, yA = DA(X ^ (V = yA), o ^ HA, 40), o = (y = h) + C | 0, o = oA + ((I = yA + sA | 0) >>> 0 < yA >>> 0 ? o + 1 | 0 : o) | 0, o = (I = I + rA | 0) >>> 0 < rA >>> 0 ? o + 1 | 0 : o, oA = I, I ^= kA, kA = o, rA = DA(I, o ^ BA, 48), o = (n = h) + cA | 0, V = I = rA + V | 0, cA = I >>> 0 < rA >>> 0 ? o + 1 | 0 : o, wA = I = DA(F ^ wA, G ^ MA, 1), HA = o = h, o = o + l | 0, o = D + ((I = I + aA | 0) >>> 0 < aA >>> 0 ? o + 1 | 0 : o) | 0, l = o = (X = I + nA | 0) >>> 0 < nA >>> 0 ? o + 1 | 0 : o, I = (BA = DA(t ^ X, o ^ w, 32)) + f | 0, o = (f = h) + r | 0, nA = I, I = (aA = DA(D = I ^ wA, (wA = I >>> 0 < BA >>> 0 ? o + 1 | 0 : o) ^ HA, 40)) + q | 0, o = (q = h) + eA | 0, o = l + (I >>> 0 < aA >>> 0 ? o + 1 | 0 : o) | 0, o = (l = I + X | 0) >>> 0 < X >>> 0 ? o + 1 | 0 : o, X = l ^ JA ^ V, E[0 | (I = A)] = X, E[I + 1 | 0] = X >>> 8, E[I + 2 | 0] = X >>> 16, E[I + 3 | 0] = X >>> 24, X = o ^ Q ^ cA, E[I + 4 | 0] = X, E[I + 5 | 0] = X >>> 8, E[I + 6 | 0] = X >>> 16, E[I + 7 | 0] = X >>> 24, X = (BA = DA(l ^ BA, o ^ f, 48)) + nA | 0, o = (nA = h) + wA | 0, o = (wA = X >>> 0 < BA >>> 0 ? o + 1 | 0 : o) ^ (a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24) ^ kA, l = (a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24) ^ oA ^ X, E[I + 16 | 0] = l, E[I + 17 | 0] = l >>> 8, E[I + 18 | 0] = l >>> 16, E[I + 19 | 0] = l >>> 24, E[I + 20 | 0] = o, E[I + 21 | 0] = o >>> 8, E[I + 22 | 0] = o >>> 16, E[I + 23 | 0] = o >>> 24, I = DA(QA ^ GA, H ^ J, 48), l = h, oA = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24, o = (a[A + 32 | 0] | a[A + 33 | 0] << 8 | a[A + 34 | 0] << 16 | a[A + 35 | 0] << 24) ^ DA(gA ^ fA, c ^ iA, 1) ^ I, E[A + 32 | 0] = o, E[A + 33 | 0] = o >>> 8, E[A + 34 | 0] = o >>> 16, E[A + 35 | 0] = o >>> 24, o = h ^ oA ^ l, E[A + 36 | 0] = o, E[A + 37 | 0] = o >>> 8, E[A + 38 | 0] = o >>> 16, E[A + 39 | 0] = o >>> 24, o = S + l | 0, o = (oA = I + e | 0) >>> 0 < I >>> 0 ? o + 1 | 0 : o, gA = (a[(I = A) + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24) ^ j ^ o, l = (a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24) ^ tA ^ oA, E[I + 24 | 0] = l, E[I + 25 | 0] = l >>> 8, E[I + 26 | 0] = l >>> 16, E[I + 27 | 0] = l >>> 24, E[I + 28 | 0] = gA, E[I + 29 | 0] = gA >>> 8, E[I + 30 | 0] = gA >>> 16, E[I + 31 | 0] = gA >>> 24, gA = a[I + 44 | 0] | a[I + 45 | 0] << 8 | a[I + 46 | 0] << 16 | a[I + 47 | 0] << 24, I = rA ^ (a[I + 40 | 0] | a[I + 41 | 0] << 8 | a[I + 42 | 0] << 16 | a[I + 43 | 0] << 24) ^ DA(X ^ aA, q ^ wA, 1), E[A + 40 | 0] = I, E[A + 41 | 0] = I >>> 8, E[A + 42 | 0] = I >>> 16, E[A + 43 | 0] = I >>> 24, I = n ^ h ^ gA, E[A + 44 | 0] = I, E[A + 45 | 0] = I >>> 8, E[A + 46 | 0] = I >>> 16, E[A + 47 | 0] = I >>> 24, X = a[A + 60 | 0] | a[A + 61 | 0] << 8 | a[A + 62 | 0] << 16 | a[A + 63 | 0] << 24, I = BA ^ (a[A + 56 | 0] | a[A + 57 | 0] << 8 | a[A + 58 | 0] << 16 | a[A + 59 | 0] << 24) ^ DA(V ^ yA, y ^ cA, 1), E[A + 56 | 0] = I, E[A + 57 | 0] = I >>> 8, E[A + 58 | 0] = I >>> 16, E[A + 59 | 0] = I >>> 24, I = nA ^ h ^ X, E[A + 60 | 0] = I, E[A + 61 | 0] = I >>> 8, E[A + 62 | 0] = I >>> 16, E[A + 63 | 0] = I >>> 24, X = a[A + 52 | 0] | a[A + 53 | 0] << 8 | a[A + 54 | 0] << 16 | a[A + 55 | 0] << 24, I = EA ^ (a[A + 48 | 0] | a[A + 49 | 0] << 8 | a[A + 50 | 0] << 16 | a[A + 51 | 0] << 24) ^ DA(oA ^ pA, o ^ M, 1), E[A + 48 | 0] = I, E[A + 49 | 0] = I >>> 8, E[A + 50 | 0] = I >>> 16, E[A + 51 | 0] = I >>> 24, I = k ^ h ^ X, E[A + 52 | 0] = I, E[A + 53 | 0] = I >>> 8, E[A + 54 | 0] = I >>> 16, E[A + 55 | 0] = I >>> 24;
                                    }
                                    function s(A, I, g, C, B, Q, i) {
                                        var f, c, e, r, D, t, y, n, s, k, S, H, G, _, M, p, J, U, Y, d, K, b, P, v, L, x, m, l, z, q, X, j, T, O, V, Z, W, $, AA, IA, gA, CA, BA, QA, iA, EA, oA, fA, eA = 0, rA = 0, DA = 0, tA = 0, yA = 0, wA = 0, hA = 0, nA = 0, sA = 0, FA = 0, SA = 0, HA = 0, GA = 0, _A = 0, pA = 0, NA = 0, JA = 0, UA = 0, YA = 0, dA = 0, KA = 0, bA = 0, PA = 0, vA = 0, LA = 0, RA = 0, uA = 0, xA = 0, mA = 0, lA = 0, zA = 0, qA = 0, XA = 0, jA = 0, TA = 0, OA = 0, VA = 0, ZA = 0, WA = 0, $A = 0, AI = 0, II = 0, gI = 0, CI = 0, BI = 0, QI = 0;
                                        return w = e = w - 560 | 0, cA(DA = e + 352 | 0), i && R(DA, 35136, 34, 0), aA(e + 288 | 0, Q, 32, 0), R(tA = e + 352 | 0, e + 320 | 0, 32, 0), R(tA, g, C, B), N(tA, nA = e + 224 | 0), sA = a[(rA = Q) + 32 | 0] | a[rA + 33 | 0] << 8 | a[rA + 34 | 0] << 16 | a[rA + 35 | 0] << 24, SA = a[rA + 36 | 0] | a[rA + 37 | 0] << 8 | a[rA + 38 | 0] << 16 | a[rA + 39 | 0] << 24, yA = a[rA + 40 | 0] | a[rA + 41 | 0] << 8 | a[rA + 42 | 0] << 16 | a[rA + 43 | 0] << 24, eA = a[rA + 44 | 0] | a[rA + 45 | 0] << 8 | a[rA + 46 | 0] << 16 | a[rA + 47 | 0] << 24, DA = a[rA + 48 | 0] | a[rA + 49 | 0] << 8 | a[rA + 50 | 0] << 16 | a[rA + 51 | 0] << 24, Q = a[rA + 52 | 0] | a[rA + 53 | 0] << 8 | a[rA + 54 | 0] << 16 | a[rA + 55 | 0] << 24, wA = a[rA + 60 | 0] | a[rA + 61 | 0] << 8 | a[rA + 62 | 0] << 16 | a[rA + 63 | 0] << 24, rA = a[rA + 56 | 0] | a[rA + 57 | 0] << 8 | a[rA + 58 | 0] << 16 | a[rA + 59 | 0] << 24, E[A + 56 | 0] = rA, E[A + 57 | 0] = rA >>> 8, E[A + 58 | 0] = rA >>> 16, E[A + 59 | 0] = rA >>> 24, E[A + 60 | 0] = wA, E[A + 61 | 0] = wA >>> 8, E[A + 62 | 0] = wA >>> 16, E[A + 63 | 0] = wA >>> 24, E[A + 48 | 0] = DA, E[A + 49 | 0] = DA >>> 8, E[A + 50 | 0] = DA >>> 16, E[A + 51 | 0] = DA >>> 24, E[A + 52 | 0] = Q, E[A + 53 | 0] = Q >>> 8, E[A + 54 | 0] = Q >>> 16, E[A + 55 | 0] = Q >>> 24, E[A + 40 | 0] = yA, E[A + 41 | 0] = yA >>> 8, E[A + 42 | 0] = yA >>> 16, E[A + 43 | 0] = yA >>> 24, E[A + 44 | 0] = eA, E[A + 45 | 0] = eA >>> 8, E[A + 46 | 0] = eA >>> 16, E[A + 47 | 0] = eA >>> 24, E[0 | (Q = A + 32 | 0)] = sA, E[Q + 1 | 0] = sA >>> 8, E[Q + 2 | 0] = sA >>> 16, E[Q + 3 | 0] = sA >>> 24, E[Q + 4 | 0] = SA, E[Q + 5 | 0] = SA >>> 8, E[Q + 6 | 0] = SA >>> 16, E[Q + 7 | 0] = SA >>> 24, F(nA), u(e, nA), MA(A, e), cA(tA), i && R(tA, 35136, 34, 0), R(i = e + 352 | 0, A, 64, 0), R(i, g, C, B), N(i, hA = e + 160 | 0), F(hA), E[e + 288 | 0] = 248 & a[e + 288 | 0], E[e + 319 | 0] = 63 & a[e + 319 | 0] | 64, g = a[23 + (A = c = e + 288 | 0) | 0], yA = kA(r = a[A + 21 | 0] | a[A + 22 | 0] << 8 | g << 16 & 2031616, 0, D = (a[hA + 28 | 0] | a[hA + 29 | 0] << 8 | a[hA + 30 | 0] << 16 | a[hA + 31 | 0] << 24) >>> 7 | 0, 0), DA = h, g = (A = a[hA + 27 | 0]) >>> 24 | 0, B = A << 8 | (eA = a[hA + 23 | 0] | a[hA + 24 | 0] << 8 | a[hA + 25 | 0] << 16 | a[hA + 26 | 0] << 24) >>> 24, A = kA(t = 2097151 & ((3 & (SA = (A = (C = a[hA + 28 | 0]) >>> 16 | 0) | g)) << 30 | (g = (C <<= 16) | B) >>> 2), 0, y = (i = a[c + 23 | 0] | a[c + 24 | 0] << 8 | a[c + 25 | 0] << 16 | a[c + 26 | 0] << 24) >>> 5 & 2097151, 0), g = h + DA | 0, C = A >>> 0 > (B = A + yA | 0) >>> 0 ? g + 1 | 0 : g, A = kA(n = (g = a[hA + 23 | 0]) << 16 & 2031616 | a[hA + 21 | 0] | a[hA + 22 | 0] << 8, 0, s = (a[c + 28 | 0] | a[c + 29 | 0] << 8 | a[c + 30 | 0] << 16 | a[c + 31 | 0] << 24) >>> 7 | 0, 0), C = h + C | 0, DA = g = A + B | 0, B = A >>> 0 > g >>> 0 ? C + 1 | 0 : C, C = (A = a[c + 27 | 0]) >>> 24 | 0, i = A << 8 | i >>> 24, A = kA(k = 2097151 & ((3 & (C |= g = (A = a[c + 28 | 0]) >>> 16 | 0)) << 30 | (g = (A <<= 16) | i) >>> 2), 0, S = eA >>> 5 & 2097151, 0), g = h + B | 0, rA = C = A + DA | 0, B = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, eA = kA(y, 0, S, 0), DA = h, g = (A = a[c + 19 | 0]) >>> 24 | 0, i = A << 8 | (JA = a[c + 15 | 0] | a[c + 16 | 0] << 8 | a[c + 17 | 0] << 16 | a[c + 18 | 0] << 24) >>> 24, C = g, g = kA(H = (7 & (C |= g = (A = a[c + 20 | 0]) >>> 16 | 0)) << 29 | (g = (A <<= 16) | i) >>> 3, SA = C >>> 3 | 0, D, 0), A = h + DA | 0, A = g >>> 0 > (C = g + eA | 0) >>> 0 ? A + 1 | 0 : A, i = (g = kA(r, 0, t, 0)) + C | 0, C = h + A | 0, g = g >>> 0 > (eA = i) >>> 0 ? C + 1 | 0 : C, C = (A = a[hA + 19 | 0]) >>> 24 | 0, DA = A << 8 | (NA = a[hA + 15 | 0] | a[hA + 16 | 0] << 8 | a[hA + 17 | 0] << 16 | a[hA + 18 | 0] << 24) >>> 24, A = kA(G = (7 & (yA = (A = (i = a[hA + 20 | 0]) >>> 16 | 0) | C)) << 29 | (C = (i <<= 16) | DA) >>> 3, _ = yA >>> 3 | 0, s, 0), g = h + g | 0, g = A >>> 0 > (C = A + eA | 0) >>> 0 ? g + 1 | 0 : g, A = kA(n, 0, k, 0), g = h + g | 0, sA = g = A >>> 0 > (nA = A + C | 0) >>> 0 ? g + 1 | 0 : g, HA = A = g - ((nA >>> 0 < 4293918720) - 1 | 0) | 0, C = (g = A >>> 21 | 0) + B | 0, eA = C = (A = (2097151 & A) << 11 | (yA = nA - -1048576 | 0) >>> 21) >>> 0 > (rA = A + rA | 0) >>> 0 ? C + 1 | 0 : C, _A = A = C - ((rA >>> 0 < 4293918720) - 1 | 0) | 0, wA = (2097151 & A) << 11 | (DA = rA - -1048576 | 0) >>> 21, i = A >>> 21 | 0, A = kA(s, 0, S, 0), g = h, C = A, A = kA(D, 0, y, 0), g = h + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, GA = (A = C) + (C = kA(t, 0, k, 0)) | 0, A = h + g | 0, A = C >>> 0 > GA >>> 0 ? A + 1 | 0 : A, tA = GA - (g = -2097152 & (C = GA - -1048576 | 0)) | 0, g = (A - ((131071 & (B = A - ((GA >>> 0 < 4293918720) - 1 | 0) | 0)) + (g >>> 0 > GA >>> 0) | 0) | 0) + i | 0, z = g = (A = tA + wA | 0) >>> 0 < tA >>> 0 ? g + 1 | 0 : g, q = A, tA = kA(A, g, 470296, 0), wA = h, g = kA(D, 0, k, 0), A = h, i = g, g = kA(t, 0, s, 0), A = h + A | 0, g = g >>> 0 > (i = i + g | 0) >>> 0 ? A + 1 | 0 : A, A = B >>> 21 | 0, B = (2097151 & B) << 11 | C >>> 21, C = A + g | 0, bA = B = (C = B >>> 0 > (i = B + i | 0) >>> 0 ? C + 1 | 0 : C) - ((i >>> 0 < 4293918720) - 1 | 0) | 0, A = i - (g = -2097152 & (KA = i - -1048576 | 0)) | 0, X = i = C - ((131071 & B) + (g >>> 0 > i >>> 0) | 0) | 0, j = g = rA - (C = -2097152 & DA) | 0, T = B = eA - ((C >>> 0 > rA >>> 0) + _A | 0) | 0, O = A, C = kA(A, i, 666643, 0), A = h + wA | 0, A = C >>> 0 > (i = C + tA | 0) >>> 0 ? A + 1 | 0 : A, C = kA(g, B, 654183, 0), g = h + A | 0, FA = B = C + i | 0, DA = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, GA = nA - (A = -2097152 & yA) | 0, HA = sA - ((A >>> 0 > nA >>> 0) + HA | 0) | 0, g = kA(t, 0, H, SA), C = h, B = (A = g) + (g = kA(M = JA >>> 6 & 2097151, 0, D, 0)) | 0, A = h + C | 0, A = g >>> 0 > B >>> 0 ? A + 1 | 0 : A, g = kA(y, 0, n, 0), C = h + A | 0, C = g >>> 0 > (B = g + B | 0) >>> 0 ? C + 1 | 0 : C, A = kA(r, 0, S, 0), g = h + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, C = kA(s, 0, p = NA >>> 6 & 2097151, 0), A = h + g | 0, A = C >>> 0 > (B = C + B | 0) >>> 0 ? A + 1 | 0 : A, C = kA(k, 0, G, _), g = h + A | 0, nA = B = C + B | 0, i = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, g = (A = a[c + 14 | 0]) >>> 24 | 0, B = A << 8 | (sA = a[c + 10 | 0] | a[c + 11 | 0] << 8 | a[c + 12 | 0] << 16 | a[c + 13 | 0] << 24) >>> 24, g = kA(J = 2097151 & ((1 & (g |= A = (C = a[c + 15 | 0]) >>> 16 | 0)) << 31 | (A = (C <<= 16) | B) >>> 1), 0, D, 0), A = h, C = g, g = kA(t, 0, M, 0), A = h + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = kA(S, 0, H, SA)) + C | 0, C = h + A | 0, C = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, A = kA(y, 0, G, _), g = h + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, A = kA(r, 0, n, 0), g = h + g | 0, yA = C = A + B | 0, B = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, g = (A = a[hA + 14 | 0]) >>> 24 | 0, eA = A << 8 | (rA = a[hA + 10 | 0] | a[hA + 11 | 0] << 8 | a[hA + 12 | 0] << 16 | a[hA + 13 | 0] << 24) >>> 24, C = g, g = (A = a[hA + 15 | 0]) >>> 16 | 0, g = kA(U = 2097151 & ((1 & (g |= C)) << 31 | (A = A << 16 | eA) >>> 1), 0, s, 0), A = h + B | 0, A = g >>> 0 > (C = g + yA | 0) >>> 0 ? A + 1 | 0 : A, g = kA(k, 0, p, 0), A = h + A | 0, eA = A = g >>> 0 > (yA = g + C | 0) >>> 0 ? A + 1 | 0 : A, PA = g = A - ((yA >>> 0 < 4293918720) - 1 | 0) | 0, C = (A = g >>> 21 | 0) + i | 0, wA = C = (g = (2097151 & g) << 11 | (tA = yA - -1048576 | 0) >>> 21) >>> 0 > (_A = g + nA | 0) >>> 0 ? C + 1 | 0 : C, YA = g = C - ((_A >>> 0 < 4293918720) - 1 | 0) | 0, A = (A = g >>> 21 | 0) + HA | 0, V = A = (g = (C = (2097151 & g) << 11 | (nA = _A - -1048576 | 0) >>> 21) + GA | 0) >>> 0 < C >>> 0 ? A + 1 | 0 : A, Z = g, A = kA(g, A, -997805, -1), g = h + DA | 0, FA = C = A + FA | 0, DA = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, GA = (RA = a[23 + (f = e + 224 | 0) | 0] | a[f + 24 | 0] << 8 | a[f + 25 | 0] << 16 | a[f + 26 | 0] << 24) >>> 5 & 2097151, C = kA(Y = (A = a[c + 2 | 0]) << 16 & 2031616 | a[0 | c] | a[c + 1 | 0] << 8, 0, S, 0), g = h, B = (A = kA(n, 0, d = (i = a[c + 2 | 0] | a[c + 3 | 0] << 8 | a[c + 4 | 0] << 16 | a[c + 5 | 0] << 24) >>> 5 & 2097151, 0)) + C | 0, C = h + g | 0, C = A >>> 0 > B >>> 0 ? C + 1 | 0 : C, A = kA(K = (a[c + 7 | 0] | a[c + 8 | 0] << 8 | a[c + 9 | 0] << 16 | a[c + 10 | 0] << 24) >>> 7 & 2097151, 0, p, 0), g = h + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, C = kA(U, 0, b = sA >>> 4 & 2097151, 0), A = h + g | 0, sA = B = C + B | 0, B = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, i = (g = a[c + 6 | 0]) << 8 | i >>> 24, C = A = g >>> 24 | 0, g = (A = a[c + 7 | 0]) >>> 16 | 0, g = kA(P = 2097151 & ((3 & (g |= C)) << 30 | (A = A << 16 | i) >>> 2), 0, G, _), A = h + B | 0, A = g >>> 0 > (C = g + sA | 0) >>> 0 ? A + 1 | 0 : A, B = (g = kA(M, 0, v = (a[hA + 7 | 0] | a[hA + 8 | 0] << 8 | a[hA + 9 | 0] << 16 | a[hA + 10 | 0] << 24) >>> 7 & 2097151, 0)) + C | 0, C = h + A | 0, C = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, g = kA(J, 0, dA = rA >>> 4 & 2097151, 0), A = h + C | 0, i = g >>> 0 > (B = g + B | 0) >>> 0 ? A + 1 | 0 : A, A = (g = a[hA + 6 | 0]) >>> 24 | 0, sA = g << 8 | (rA = a[hA + 2 | 0] | a[hA + 3 | 0] << 8 | a[hA + 4 | 0] << 16 | a[hA + 5 | 0] << 24) >>> 24, g = A, A = kA(H, SA, L = 2097151 & ((3 & (g |= C = (A = a[hA + 7 | 0]) >>> 16 | 0)) << 30 | (A = A << 16 | sA) >>> 2), 0), g = h + i | 0, g = A >>> 0 > (C = A + B | 0) >>> 0 ? g + 1 | 0 : g, B = C, C = kA(x = (A = a[hA + 2 | 0]) << 16 & 2031616 | a[0 | hA] | a[hA + 1 | 0] << 8, 0, y, 0), A = h + g | 0, A = C >>> 0 > (B = B + C | 0) >>> 0 ? A + 1 | 0 : A, g = kA(r, 0, m = rA >>> 5 & 2097151, 0), A = h + A | 0, A = g >>> 0 > (C = g + B | 0) >>> 0 ? A + 1 | 0 : A, g = C, sA = C = C + GA | 0, i = g = g >>> 0 > C >>> 0 ? A + 1 | 0 : A, B = a[f + 21 | 0] | a[f + 22 | 0] << 8, A = kA(n, 0, Y, 0), g = h, rA = (C = A) + (A = kA(G, _, d, 0)) | 0, C = h + g | 0, C = A >>> 0 > rA >>> 0 ? C + 1 | 0 : C, A = kA(U, 0, K, 0), g = h + C | 0, g = A >>> 0 > (rA = A + rA | 0) >>> 0 ? g + 1 | 0 : g, A = kA(b, 0, dA, 0), g = h + g | 0, g = A >>> 0 > (C = A + rA | 0) >>> 0 ? g + 1 | 0 : g, rA = (A = C) + (C = kA(p, 0, P, 0)) | 0, A = h + g | 0, A = C >>> 0 > rA >>> 0 ? A + 1 | 0 : A, g = kA(M, 0, L, 0), A = h + A | 0, A = g >>> 0 > (C = g + rA | 0) >>> 0 ? A + 1 | 0 : A, rA = (g = kA(J, 0, v, 0)) + C | 0, C = h + A | 0, C = g >>> 0 > rA >>> 0 ? C + 1 | 0 : C, A = kA(H, SA, m, 0), g = h + C | 0, g = A >>> 0 > (rA = A + rA | 0) >>> 0 ? g + 1 | 0 : g, A = kA(r, 0, x, 0), g = h + g | 0, A = A >>> 0 > (C = A + rA | 0) >>> 0 ? g + 1 | 0 : g, g = (g = C) >>> 0 > (C = C + B | 0) >>> 0 ? A + 1 | 0 : A, B = C, C = (A = a[f + 23 | 0]) << 16 & 2031616, A = g, C = A = C >>> 0 > (B = B + C | 0) >>> 0 ? A + 1 | 0 : A, hA = A = A - ((B >>> 0 < 4293918720) - 1 | 0) | 0, g = (g = A >>> 21 | 0) + i | 0, A = (g = (i = sA = (A = (2097151 & A) << 11 | (rA = B - -1048576 | 0) >>> 21) + sA | 0) >>> 0 < A >>> 0 ? g + 1 | 0 : g) + DA | 0, A = (DA = i + FA | 0) >>> 0 < i >>> 0 ? A + 1 | 0 : A, JA = i - -1048576 | 0, pA = i = g - ((i >>> 0 < 4293918720) - 1 | 0) | 0, UA = DA - (g = -2097152 & JA) | 0, vA = A - ((g >>> 0 > DA >>> 0) + i | 0) | 0, sA = B, DA = C, A = kA(j, T, 470296, 0), g = h, C = A, A = kA(q, z, 666643, 0), g = h + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, B = (A = C) + (C = kA(Z, V, 654183, 0)) | 0, A = h + g | 0, NA = B, i = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, g = kA(G, _, Y, 0), A = h, C = g, g = kA(p, 0, d, 0), A = h + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = C) + (C = kA(K, 0, dA, 0)) | 0, g = h + A | 0, g = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, A = kA(b, 0, v, 0), C = h + g | 0, C = A >>> 0 > (B = A + B | 0) >>> 0 ? C + 1 | 0 : C, A = kA(U, 0, P, 0), g = h + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, C = kA(M, 0, m, 0), A = h + g | 0, A = C >>> 0 > (B = C + B | 0) >>> 0 ? A + 1 | 0 : A, g = kA(J, 0, L, 0), A = h + A | 0, A = g >>> 0 > (C = g + B | 0) >>> 0 ? A + 1 | 0 : A, B = (g = C) + (C = kA(H, SA, x, 0)) | 0, g = h + A | 0, GA = B, C = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, g = (A = a[f + 19 | 0]) >>> 24 | 0, HA = A << 8 | (FA = a[f + 15 | 0] | a[f + 16 | 0] << 8 | a[f + 17 | 0] << 16 | a[f + 18 | 0] << 24) >>> 24, C = ((LA = (A = (B = a[f + 20 | 0]) >>> 16 | 0) | g) >>> 3 | 0) + C | 0, GA = B = (g = (7 & LA) << 29 | (g = (B <<= 16) | HA) >>> 3) + GA | 0, B = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, HA = FA >>> 6 & 2097151, A = kA(p, 0, Y, 0), g = h, C = A, A = kA(U, 0, d, 0), g = h + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, FA = (A = C) + (C = kA(K, 0, v, 0)) | 0, A = h + g | 0, A = C >>> 0 > FA >>> 0 ? A + 1 | 0 : A, C = kA(b, 0, L, 0), g = h + A | 0, g = C >>> 0 > (FA = C + FA | 0) >>> 0 ? g + 1 | 0 : g, C = kA(P, 0, dA, 0), A = h + g | 0, A = C >>> 0 > (FA = C + FA | 0) >>> 0 ? A + 1 | 0 : A, g = kA(M, 0, x, 0), C = h + A | 0, C = g >>> 0 > (FA = g + FA | 0) >>> 0 ? C + 1 | 0 : C, A = kA(J, 0, m, 0), g = h + C | 0, A = A >>> 0 > (FA = A + FA | 0) >>> 0 ? g + 1 | 0 : g, TA = A = (xA = FA + HA | 0) >>> 0 < FA >>> 0 ? A + 1 | 0 : A, II = A = A - ((xA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (XA = xA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + B | 0, VA = A = C >>> 0 > (OA = C + GA | 0) >>> 0 ? A + 1 | 0 : A, gI = A = A - ((OA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (lA = OA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + i | 0, g = (C >>> 0 > (B = C + NA | 0) >>> 0 ? A + 1 | 0 : A) + DA | 0, DA = (C = B + sA | 0) - (A = -2097152 & rA) | 0, hA = A = (g = C >>> 0 < B >>> 0 ? g + 1 | 0 : g) - ((A >>> 0 > C >>> 0) + hA | 0) | 0, CI = A = A - ((DA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (zA = DA - -1048576 | 0) >>> 21, A = (A >> 21) + vA | 0, B = A = C >>> 0 > (i = C + UA | 0) >>> 0 ? A + 1 | 0 : A, AI = A = A - ((i >>> 0 < 4293918720) - 1 | 0) | 0, qA = (2097151 & A) << 11 | (NA = i - -1048576 | 0) >>> 21, sA = A >> 21, LA = _A - (A = -2097152 & nA) | 0, YA = wA - ((A >>> 0 > _A >>> 0) + YA | 0) | 0, A = kA(D, 0, s, 0), jA = g = h, UA = A, FA = A - -1048576 | 0, mA = g = g - ((A >>> 0 < 4293918720) - 1 | 0) | 0, W = A = g >>> 21 | 0, A = kA(l = (2097151 & g) << 11 | FA >>> 21, A, -683901, -1), g = h + eA | 0, g = A >>> 0 > (C = A + yA | 0) >>> 0 ? g + 1 | 0 : g, nA = C - (A = -2097152 & tA) | 0, rA = g - ((A >>> 0 > C >>> 0) + PA | 0) | 0, g = kA(S, 0, M, 0), A = h, C = g, g = kA(D, 0, b, 0), A = h + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, g = kA(t, 0, J, 0), A = h + A | 0, A = g >>> 0 > (C = g + C | 0) >>> 0 ? A + 1 | 0 : A, eA = (g = C) + (C = kA(n, 0, H, SA)) | 0, g = h + A | 0, g = C >>> 0 > eA >>> 0 ? g + 1 | 0 : g, A = kA(y, 0, p, 0), C = h + g | 0, C = A >>> 0 > (eA = A + eA | 0) >>> 0 ? C + 1 | 0 : C, A = kA(r, 0, G, _), g = h + C | 0, g = A >>> 0 > (eA = A + eA | 0) >>> 0 ? g + 1 | 0 : g, C = kA(s, 0, dA, 0), A = h + g | 0, A = C >>> 0 > (eA = C + eA | 0) >>> 0 ? A + 1 | 0 : A, g = kA(k, 0, U, 0), A = h + A | 0, yA = C = g + eA | 0, eA = g >>> 0 > C >>> 0 ? A + 1 | 0 : A, A = kA(t, 0, b, 0), g = h, C = A, A = kA(D, 0, K, 0), g = h + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, wA = (A = kA(n, 0, M, 0)) + C | 0, C = h + g | 0, C = A >>> 0 > wA >>> 0 ? C + 1 | 0 : C, A = kA(S, 0, J, 0), g = h + C | 0, g = A >>> 0 > (wA = A + wA | 0) >>> 0 ? g + 1 | 0 : g, C = kA(H, SA, G, _), A = h + g | 0, A = C >>> 0 > (wA = C + wA | 0) >>> 0 ? A + 1 | 0 : A, g = kA(y, 0, U, 0), A = h + A | 0, A = g >>> 0 > (C = g + wA | 0) >>> 0 ? A + 1 | 0 : A, wA = (g = C) + (C = kA(r, 0, p, 0)) | 0, g = h + A | 0, g = C >>> 0 > wA >>> 0 ? g + 1 | 0 : g, A = kA(s, 0, v, 0), C = h + g | 0, C = A >>> 0 > (wA = A + wA | 0) >>> 0 ? C + 1 | 0 : C, A = kA(k, 0, dA, 0), g = h + C | 0, HA = g = A >>> 0 > (GA = A + wA | 0) >>> 0 ? g + 1 | 0 : g, WA = A = g - ((GA >>> 0 < 4293918720) - 1 | 0) | 0, g = (2097151 & A) << 11 | (_A = GA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + eA | 0, tA = A = g >>> 0 > (PA = g + yA | 0) >>> 0 ? A + 1 | 0 : A, uA = A = A - ((PA >>> 0 < 4293918720) - 1 | 0) | 0, g = (C = A >>> 21 | 0) + rA | 0, nA = g = (A = (2097151 & A) << 11 | (wA = PA - -1048576 | 0) >>> 21) >>> 0 > (vA = A + nA | 0) >>> 0 ? g + 1 | 0 : g, ZA = A = g - ((vA >>> 0 < 4293918720) - 1 | 0) | 0, eA = (2097151 & A) << 11 | (rA = vA - -1048576 | 0) >>> 21, A = (A >> 21) + YA | 0, $ = A = (g = eA + LA | 0) >>> 0 < eA >>> 0 ? A + 1 | 0 : A, AA = g, A = kA(g, A, -683901, -1), g = h + sA | 0, qA = C = A + qA | 0, sA = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, A = kA(t, 0, Y, 0), g = h, C = A, A = kA(S, 0, d, 0), g = h + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, eA = (A = C) + (C = kA(G, _, K, 0)) | 0, A = h + g | 0, A = C >>> 0 > eA >>> 0 ? A + 1 | 0 : A, g = kA(p, 0, b, 0), C = h + A | 0, C = g >>> 0 > (eA = g + eA | 0) >>> 0 ? C + 1 | 0 : C, g = kA(n, 0, P, 0), A = h + C | 0, A = g >>> 0 > (eA = g + eA | 0) >>> 0 ? A + 1 | 0 : A, C = kA(M, 0, dA, 0), g = h + A | 0, g = C >>> 0 > (eA = C + eA | 0) >>> 0 ? g + 1 | 0 : g, A = kA(J, 0, U, 0), g = h + g | 0, g = A >>> 0 > (C = A + eA | 0) >>> 0 ? g + 1 | 0 : g, eA = (A = C) + (C = kA(H, SA, v, 0)) | 0, A = h + g | 0, A = C >>> 0 > eA >>> 0 ? A + 1 | 0 : A, g = kA(y, 0, m, 0), C = h + A | 0, C = g >>> 0 > (eA = g + eA | 0) >>> 0 ? C + 1 | 0 : C, g = kA(r, 0, L, 0), A = h + C | 0, A = g >>> 0 > (eA = g + eA | 0) >>> 0 ? A + 1 | 0 : A, C = kA(k, 0, x, 0), g = h + A | 0, YA = eA = C + eA | 0, C = C >>> 0 > eA >>> 0 ? g + 1 | 0 : g, g = (A = a[f + 27 | 0]) >>> 24 | 0, yA = A << 8 | RA >>> 24, eA = 2097151 & ((3 & (g |= A = (eA = a[f + 28 | 0]) >>> 16 | 0)) << 30 | (A = (eA <<= 16) | yA) >>> 2), g = C, yA = A = eA + YA | 0, eA = A >>> 0 < eA >>> 0 ? g + 1 | 0 : g, LA = kA(O, X, 470296, 0), YA = h, A = (C = (2097151 & bA) << 11 | KA >>> 21) + (UA - (g = -2097152 & FA) | 0) | 0, g = jA - ((524287 & mA) + (g >>> 0 > UA >>> 0) | 0) + (bA >>> 21) | 0, IA = g = A >>> 0 < C >>> 0 ? g + 1 | 0 : g, gA = A, g = kA(A, g, 666643, 0), A = h + YA | 0, A = g >>> 0 > (C = g + LA | 0) >>> 0 ? A + 1 | 0 : A, FA = (g = kA(q, z, 654183, 0)) + C | 0, C = h + A | 0, C = g >>> 0 > FA >>> 0 ? C + 1 | 0 : C, g = kA(j, T, -997805, -1), A = h + C | 0, A = g >>> 0 > (FA = g + FA | 0) >>> 0 ? A + 1 | 0 : A, C = kA(Z, V, 136657, 0), g = h + A | 0, JA = (A = (2097151 & pA) << 11 | JA >>> 21) + (FA = C + FA | 0) | 0, g = (pA >>> 21 | 0) + (C >>> 0 > FA >>> 0 ? g + 1 | 0 : g) | 0, mA = FA = eA - ((yA >>> 0 < 4293918720) - 1 | 0) | 0, A = (A >>> 0 > JA >>> 0 ? g + 1 | 0 : g) + eA | 0, g = (eA = yA + JA | 0) - (C = -2097152 & (jA = yA - -1048576 | 0)) | 0, C = (A = (A = eA >>> 0 < JA >>> 0 ? A + 1 | 0 : A) - ((C >>> 0 > eA >>> 0) + FA | 0) | 0) + sA | 0, LA = eA = A - ((g >>> 0 < 4293918720) - 1 | 0) | 0, UA = (C = (yA = g + qA | 0) >>> 0 < g >>> 0 ? C + 1 | 0 : C) - (((g = -2097152 & (YA = g - -1048576 | 0)) >>> 0 > yA >>> 0) + eA | 0) | 0, RA = A = yA - g | 0, eA = i, i = B, $A = vA - (A = -2097152 & rA) | 0, FA = nA - ((A >>> 0 > vA >>> 0) + ZA | 0) | 0, A = kA(gA, IA, -683901, -1), g = h, B = (C = A) + (A = kA(l, W, 136657, 0)) | 0, C = h + g | 0, g = tA + (A >>> 0 > B >>> 0 ? C + 1 | 0 : C) | 0, wA = (C = B + PA | 0) - (A = -2097152 & wA) | 0, nA = (g = C >>> 0 < PA >>> 0 ? g + 1 | 0 : g) - ((A >>> 0 > C >>> 0) + uA | 0) | 0, g = kA(l, W, -997805, -1), A = h + HA | 0, A = g >>> 0 > (C = g + GA | 0) >>> 0 ? A + 1 | 0 : A, B = (g = kA(gA, IA, 136657, 0)) + C | 0, C = h + A | 0, C = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, A = kA(O, X, -683901, -1), g = h + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, rA = B - (A = -2097152 & _A) | 0, sA = g - ((A >>> 0 > B >>> 0) + WA | 0) | 0, g = kA(S, 0, b, 0), A = h, C = g, g = kA(t, 0, K, 0), A = h + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = kA(D, 0, P, 0)) + C | 0, C = h + A | 0, C = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, A = kA(G, _, M, 0), g = h + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, C = kA(n, 0, J, 0), A = h + g | 0, A = C >>> 0 > (B = C + B | 0) >>> 0 ? A + 1 | 0 : A, C = kA(H, SA, p, 0), g = h + A | 0, g = C >>> 0 > (B = C + B | 0) >>> 0 ? g + 1 | 0 : g, C = kA(y, 0, dA, 0), A = h + g | 0, A = C >>> 0 > (B = C + B | 0) >>> 0 ? A + 1 | 0 : A, g = kA(r, 0, U, 0), C = h + A | 0, C = g >>> 0 > (B = g + B | 0) >>> 0 ? C + 1 | 0 : C, A = kA(s, 0, L, 0), g = h + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, C = kA(k, 0, v, 0), A = h + g | 0, yA = B = C + B | 0, B = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, A = kA(S, 0, K, 0), g = h, C = A, A = kA(D, 0, d, 0), g = h + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, tA = (A = C) + (C = kA(n, 0, b, 0)) | 0, A = h + g | 0, A = C >>> 0 > tA >>> 0 ? A + 1 | 0 : A, g = kA(t, 0, P, 0), C = h + A | 0, C = g >>> 0 > (tA = g + tA | 0) >>> 0 ? C + 1 | 0 : C, A = kA(M, 0, p, 0), g = h + C | 0, g = A >>> 0 > (tA = A + tA | 0) >>> 0 ? g + 1 | 0 : g, C = kA(G, _, J, 0), A = h + g | 0, A = C >>> 0 > (tA = C + tA | 0) >>> 0 ? A + 1 | 0 : A, C = kA(H, SA, U, 0), g = h + A | 0, g = C >>> 0 > (tA = C + tA | 0) >>> 0 ? g + 1 | 0 : g, C = kA(y, 0, v, 0), A = h + g | 0, A = C >>> 0 > (tA = C + tA | 0) >>> 0 ? A + 1 | 0 : A, g = kA(r, 0, dA, 0), C = h + A | 0, C = g >>> 0 > (tA = g + tA | 0) >>> 0 ? C + 1 | 0 : C, tA = (A = kA(s, 0, m, 0)) + tA | 0, g = h + C | 0, C = kA(k, 0, L, 0), A = h + (A >>> 0 > tA >>> 0 ? g + 1 | 0 : g) | 0, vA = A = C >>> 0 > (ZA = C + tA | 0) >>> 0 ? A + 1 | 0 : A, BA = A = A - ((ZA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (bA = ZA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + B | 0, KA = A = C >>> 0 > (qA = C + yA | 0) >>> 0 ? A + 1 | 0 : A, QA = A = A - ((qA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (pA = qA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + sA | 0, JA = A = C >>> 0 > (PA = C + rA | 0) >>> 0 ? A + 1 | 0 : A, iA = A = A - ((PA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (HA = PA - -1048576 | 0) >>> 21, A = (A >> 21) + nA | 0, B = A = C >>> 0 > (rA = C + wA | 0) >>> 0 ? A + 1 | 0 : A, nA = A = A - ((rA >>> 0 < 4293918720) - 1 | 0) | 0, sA = (2097151 & A) << 11 | (C = rA - -1048576 | 0) >>> 21, A = (A >> 21) + FA | 0, WA = A = (yA = sA + $A | 0) >>> 0 < sA >>> 0 ? A + 1 | 0 : A, uA = yA, A = kA(yA, A, -683901, -1), g = h, yA = A, A = kA(AA, $, 136657, 0), g = h + g | 0, A = (A >>> 0 > (yA = yA + A | 0) >>> 0 ? g + 1 | 0 : g) + i | 0, BI = (i = eA + yA | 0) - (g = -2097152 & NA) | 0, QI = (A = i >>> 0 < yA >>> 0 ? A + 1 | 0 : A) - ((g >>> 0 > i >>> 0) + AI | 0) | 0, sA = DA, yA = hA, DA = kA(uA, WA, 136657, 0), i = h, $A = A = rA - (g = -2097152 & C) | 0, CA = B = B - ((g >>> 0 > rA >>> 0) + nA | 0) | 0, C = kA(AA, $, -997805, -1), g = h + i | 0, g = C >>> 0 > (DA = C + DA | 0) >>> 0 ? g + 1 | 0 : g, C = kA(A, B, -683901, -1), A = h + g | 0, AI = B = C + DA | 0, eA = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, A = kA(Z, V, 470296, 0), g = h, B = (C = A) + (A = kA(j, T, 666643, 0)) | 0, C = h + g | 0, g = VA + (A >>> 0 > B >>> 0 ? C + 1 | 0 : C) | 0, FA = A = B + OA | 0, i = g = A >>> 0 < OA >>> 0 ? g + 1 | 0 : g, g = kA(Z, V, 666643, 0), A = h + TA | 0, A = g >>> 0 > (C = g + xA | 0) >>> 0 ? A + 1 | 0 : A, wA = C - (g = -2097152 & XA) | 0, GA = A - ((g >>> 0 > C >>> 0) + II | 0) | 0, g = kA(U, 0, Y, 0), A = h, C = g, g = kA(d, 0, dA, 0), A = h + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = C) + (C = kA(K, 0, L, 0)) | 0, g = h + A | 0, g = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, C = kA(b, 0, m, 0), A = h + g | 0, A = C >>> 0 > (B = C + B | 0) >>> 0 ? A + 1 | 0 : A, g = kA(P, 0, v, 0), C = h + A | 0, C = g >>> 0 > (B = g + B | 0) >>> 0 ? C + 1 | 0 : C, A = kA(J, 0, x, 0), g = h + C | 0, rA = B = A + B | 0, B = A >>> 0 > B >>> 0 ? g + 1 | 0 : g, g = (A = a[f + 14 | 0]) >>> 24 | 0, DA = A << 8 | (nA = a[f + 10 | 0] | a[f + 11 | 0] << 8 | a[f + 12 | 0] << 16 | a[f + 13 | 0] << 24) >>> 24, g = 2097151 & ((1 & (g |= C = (A = a[f + 15 | 0]) >>> 16 | 0)) << 31 | (A = DA | A << 16) >>> 1), A = B, rA = C = g + rA | 0, B = g >>> 0 > C >>> 0 ? A + 1 | 0 : A, DA = nA >>> 4 & 2097151, A = kA(Y, 0, dA, 0), g = h, C = A, A = kA(d, 0, v, 0), g = h + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, A = kA(K, 0, m, 0), g = h + g | 0, g = A >>> 0 > (C = A + C | 0) >>> 0 ? g + 1 | 0 : g, nA = (A = C) + (C = kA(b, 0, x, 0)) | 0, A = h + g | 0, A = C >>> 0 > nA >>> 0 ? A + 1 | 0 : A, g = kA(P, 0, L, 0), C = h + A | 0, A = g >>> 0 > (nA = g + nA | 0) >>> 0 ? C + 1 | 0 : C, hA = A = (XA = DA + nA | 0) >>> 0 < nA >>> 0 ? A + 1 | 0 : A, EA = A = A - ((XA >>> 0 < 4293918720) - 1 | 0) | 0, g = (C = A >>> 21 | 0) + B | 0, _A = g = (A = (2097151 & A) << 11 | (NA = XA - -1048576 | 0) >>> 21) >>> 0 > (VA = A + rA | 0) >>> 0 ? g + 1 | 0 : g, oA = A = g - ((VA >>> 0 < 4293918720) - 1 | 0) | 0, g = (2097151 & A) << 11 | (tA = VA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + GA | 0, nA = A = g >>> 0 > (wA = g + wA | 0) >>> 0 ? A + 1 | 0 : A, fA = A = A - ((wA >>> 0 < 4293918720) - 1 | 0) | 0, g = (C = A >> 21) + i | 0, II = g = (g = (A = (2097151 & A) << 11 | (rA = wA - -1048576 | 0) >>> 21) >>> 0 > (B = A + FA | 0) >>> 0 ? g + 1 | 0 : g) - (((C = -2097152 & lA) >>> 0 > B >>> 0) + gI | 0) | 0, lA = A = B - C | 0, DA = A - -1048576 | 0, gI = A = g - ((A >>> 0 < 4293918720) - 1 | 0) | 0, C = (g = A >> 21) + eA | 0, g = ((A = (2097151 & A) << 11 | DA >>> 21) >>> 0 > (B = A + AI | 0) >>> 0 ? C + 1 | 0 : C) + yA | 0, xA = g = (g = (A = B) >>> 0 > (B = B + sA | 0) >>> 0 ? g + 1 | 0 : g) - (((C = -2097152 & zA) >>> 0 > B >>> 0) + CI | 0) | 0, yA = A = B - C | 0, i = A - -1048576 | 0, TA = A = g - ((A >>> 0 < 4293918720) - 1 | 0) | 0, C = (g = A >> 21) + QI | 0, zA = A = (C = (A = (2097151 & A) << 11 | i >>> 21) >>> 0 > (eA = A + BI | 0) >>> 0 ? C + 1 | 0 : C) - ((eA >>> 0 < 4293918720) - 1 | 0) | 0, FA = RA - -1048576 | 0, GA = UA - ((RA >>> 0 < 4293918720) - 1 | 0) | 0, sA = (2097151 & A) << 11 | (B = eA - -1048576 | 0) >>> 21, A = (A >> 21) + UA | 0, CI = (RA = sA + RA | 0) - (g = -2097152 & FA) | 0, BI = (sA >>> 0 > RA >>> 0 ? A + 1 | 0 : A) - ((g >>> 0 > RA >>> 0) + GA | 0) | 0, QI = eA - (A = -2097152 & B) | 0, AI = C - ((A >>> 0 > eA >>> 0) + zA | 0) | 0, OA = yA - (A = -2097152 & i) | 0, RA = xA - ((A >>> 0 > yA >>> 0) + TA | 0) | 0, A = kA(uA, WA, -997805, -1), g = h, C = A, A = kA(AA, $, 654183, 0), g = h + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, B = (A = C) + (C = kA($A, CA, 136657, 0)) | 0, A = h + g | 0, g = II + (C >>> 0 > B >>> 0 ? A + 1 | 0 : A) | 0, xA = (C = B + lA | 0) - (A = -2097152 & DA) | 0, TA = (g = C >>> 0 < lA >>> 0 ? g + 1 | 0 : g) - ((A >>> 0 > C >>> 0) + gI | 0) | 0, lA = PA - (A = -2097152 & HA) | 0, UA = JA - ((A >>> 0 > PA >>> 0) + iA | 0) | 0, g = kA(gA, IA, -997805, -1), A = h, C = g, g = kA(l, W, 654183, 0), A = h + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = C) + (C = kA(O, X, 136657, 0)) | 0, g = h + A | 0, g = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, A = kA(q, z, -683901, -1), C = h + g | 0, g = KA + (A >>> 0 > (B = A + B | 0) >>> 0 ? C + 1 | 0 : C) | 0, HA = (C = B + qA | 0) - (A = -2097152 & pA) | 0, JA = (g = C >>> 0 < qA >>> 0 ? g + 1 | 0 : g) - ((A >>> 0 > C >>> 0) + QA | 0) | 0, g = kA(gA, IA, 654183, 0), A = h, C = g, g = kA(l, W, 470296, 0), A = h + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = kA(O, X, -997805, -1)) + C | 0, C = h + A | 0, g = vA + (g >>> 0 > B >>> 0 ? C + 1 | 0 : C) | 0, g = (A = B + ZA | 0) >>> 0 < ZA >>> 0 ? g + 1 | 0 : g, C = A, A = kA(q, z, 136657, 0), g = h + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, B = (A = C) + (C = kA(j, T, -683901, -1)) | 0, A = h + g | 0, DA = B - (g = -2097152 & bA) | 0, i = (C >>> 0 > B >>> 0 ? A + 1 | 0 : A) - ((g >>> 0 > B >>> 0) + BA | 0) | 0, B = (a[f + 28 | 0] | a[f + 29 | 0] << 8 | a[f + 30 | 0] << 16 | a[f + 31 | 0] << 24) >>> 7 | 0, A = kA(D, 0, Y, 0), g = h, eA = (C = A) + (A = kA(t, 0, d, 0)) | 0, C = h + g | 0, C = A >>> 0 > eA >>> 0 ? C + 1 | 0 : C, A = kA(n, 0, K, 0), g = h + C | 0, g = A >>> 0 > (eA = A + eA | 0) >>> 0 ? g + 1 | 0 : g, C = kA(G, _, b, 0), A = h + g | 0, A = C >>> 0 > (eA = C + eA | 0) >>> 0 ? A + 1 | 0 : A, C = kA(S, 0, P, 0), g = h + A | 0, g = C >>> 0 > (eA = C + eA | 0) >>> 0 ? g + 1 | 0 : g, C = kA(M, 0, U, 0), A = h + g | 0, A = C >>> 0 > (eA = C + eA | 0) >>> 0 ? A + 1 | 0 : A, g = kA(p, 0, J, 0), C = h + A | 0, C = g >>> 0 > (eA = g + eA | 0) >>> 0 ? C + 1 | 0 : C, A = kA(H, SA, dA, 0), g = h + C | 0, g = A >>> 0 > (eA = A + eA | 0) >>> 0 ? g + 1 | 0 : g, C = kA(y, 0, L, 0), A = h + g | 0, A = C >>> 0 > (eA = C + eA | 0) >>> 0 ? A + 1 | 0 : A, C = kA(r, 0, v, 0), g = h + A | 0, g = C >>> 0 > (eA = C + eA | 0) >>> 0 ? g + 1 | 0 : g, C = kA(s, 0, x, 0), A = h + g | 0, A = C >>> 0 > (eA = C + eA | 0) >>> 0 ? A + 1 | 0 : A, g = kA(k, 0, m, 0), C = h + A | 0, g = C = g >>> 0 > (eA = g + eA | 0) >>> 0 ? C + 1 | 0 : C, KA = (C = (2097151 & mA) << 11 | jA >>> 21) + (A = B + eA | 0) | 0, A = (mA >>> 21 | 0) + (g = A >>> 0 < eA >>> 0 ? g + 1 | 0 : g) | 0, sA = A = C >>> 0 > KA >>> 0 ? A + 1 | 0 : A, zA = g = A - ((KA >>> 0 < 4293918720) - 1 | 0) | 0, C = (A = g >>> 21 | 0) + i | 0, yA = C = (g = (2097151 & g) << 11 | (SA = KA - -1048576 | 0) >>> 21) >>> 0 > (pA = g + DA | 0) >>> 0 ? C + 1 | 0 : C, jA = g = C - ((pA >>> 0 < 4293918720) - 1 | 0) | 0, A = (A = g >> 21) + JA | 0, DA = A = (g = (2097151 & g) << 11 | (eA = pA - -1048576 | 0) >>> 21) >>> 0 > (HA = g + HA | 0) >>> 0 ? A + 1 | 0 : A, bA = g = A - ((HA >>> 0 < 4293918720) - 1 | 0) | 0, C = (A = g >> 21) + UA | 0, mA = C = (g = (B = (2097151 & g) << 11 | (i = HA - -1048576 | 0) >>> 21) + lA | 0) >>> 0 < B >>> 0 ? C + 1 | 0 : C, UA = g, A = kA(g, C, -683901, -1), g = h + TA | 0, JA = C = A + xA | 0, B = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, g = kA(AA, $, 470296, 0), A = h + nA | 0, A = g >>> 0 > (wA = g + wA | 0) >>> 0 ? A + 1 | 0 : A, g = kA(uA, WA, 654183, 0), A = h + (A - (((C = -2097152 & rA) >>> 0 > wA >>> 0) + fA | 0) | 0) | 0, A = g >>> 0 > (rA = g + (wA - C | 0) | 0) >>> 0 ? A + 1 | 0 : A, C = kA($A, CA, -997805, -1), g = h + A | 0, g = C >>> 0 > (rA = C + rA | 0) >>> 0 ? g + 1 | 0 : g, vA = C = HA - (A = -2097152 & i) | 0, dA = DA = DA - ((A >>> 0 > HA >>> 0) + bA | 0) | 0, rA = (i = kA(UA, mA, 136657, 0)) + rA | 0, A = h + g | 0, C = kA(C, DA, -683901, -1), g = h + (i >>> 0 > rA >>> 0 ? A + 1 | 0 : A) | 0, DA = g = C >>> 0 > (nA = C + rA | 0) >>> 0 ? g + 1 | 0 : g, bA = A = g - ((nA >>> 0 < 4293918720) - 1 | 0) | 0, g = (2097151 & A) << 11 | (i = nA - -1048576 | 0) >>> 21, A = (A >> 21) + B | 0, HA = g = (A = g >>> 0 > (rA = g + JA | 0) >>> 0 ? A + 1 | 0 : A) - ((rA >>> 0 < 4293918720) - 1 | 0) | 0, wA = (2097151 & g) << 11 | (B = rA - -1048576 | 0) >>> 21, g = (g >> 21) + RA | 0, OA = JA = wA + OA | 0, JA = wA >>> 0 > JA >>> 0 ? g + 1 | 0 : g, RA = rA - (g = -2097152 & B) | 0, ZA = A - ((g >>> 0 > rA >>> 0) + HA | 0) | 0, xA = nA - (A = -2097152 & i) | 0, TA = DA - ((A >>> 0 > nA >>> 0) + bA | 0) | 0, A = kA(AA, $, 666643, 0), C = _A + h | 0, C = (i = A + VA | 0) >>> 0 < VA >>> 0 ? C + 1 | 0 : C, B = (A = kA(uA, WA, 470296, 0)) + (i - (g = -2097152 & tA) | 0) | 0, g = h + (C - ((g >>> 0 > i >>> 0) + oA | 0) | 0) | 0, g = A >>> 0 > B >>> 0 ? g + 1 | 0 : g, C = kA($A, CA, 654183, 0), A = h + g | 0, rA = B = C + B | 0, B = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, i = pA - (A = -2097152 & eA) | 0, DA = yA - ((A >>> 0 > pA >>> 0) + jA | 0) | 0, A = kA(gA, IA, 470296, 0), g = h, C = A, A = kA(l, W, 666643, 0), g = h + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, A = kA(O, X, 654183, 0), g = h + g | 0, g = A >>> 0 > (C = A + C | 0) >>> 0 ? g + 1 | 0 : g, eA = (A = C) + (C = kA(q, z, -997805, -1)) | 0, A = h + g | 0, A = C >>> 0 > eA >>> 0 ? A + 1 | 0 : A, g = kA(j, T, 136657, 0), A = h + A | 0, A = g >>> 0 > (C = g + eA | 0) >>> 0 ? A + 1 | 0 : A, eA = (g = kA(Z, V, -683901, -1)) + C | 0, C = h + A | 0, g = sA + (g >>> 0 > eA >>> 0 ? C + 1 | 0 : C) | 0, pA = (C = (2097151 & LA) << 11 | YA >>> 21) + ((eA = eA + KA | 0) - (A = -2097152 & SA) | 0) | 0, A = ((g = eA >>> 0 < KA >>> 0 ? g + 1 | 0 : g) - ((A >>> 0 > eA >>> 0) + zA | 0) | 0) + (LA >> 21) | 0, HA = A = C >>> 0 > pA >>> 0 ? A + 1 | 0 : A, lA = A = A - ((pA >>> 0 < 4293918720) - 1 | 0) | 0, g = i, i = (2097151 & A) << 11 | (tA = pA - -1048576 | 0) >>> 21, A = (A >> 21) + DA | 0, bA = A = (C = g + i | 0) >>> 0 < i >>> 0 ? A + 1 | 0 : A, KA = C, A = kA(C, A, -683901, -1), g = h + B | 0, g = A >>> 0 > (C = A + rA | 0) >>> 0 ? g + 1 | 0 : g, B = (A = C) + (C = kA(UA, mA, -997805, -1)) | 0, A = h + g | 0, A = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, g = kA(vA, dA, 136657, 0), C = h + A | 0, YA = B = g + B | 0, yA = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, rA = XA - (A = -2097152 & NA) | 0, sA = hA - ((A >>> 0 > XA >>> 0) + EA | 0) | 0, g = kA(Y, 0, v, 0), A = h, C = g, g = kA(d, 0, L, 0), A = h + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, g = kA(K, 0, x, 0), A = h + A | 0, A = g >>> 0 > (C = g + C | 0) >>> 0 ? A + 1 | 0 : A, B = (g = kA(P, 0, m, 0)) + C | 0, C = h + A | 0, g = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, SA = C = (A = (a[f + 7 | 0] | a[f + 8 | 0] << 8 | a[f + 9 | 0] << 16 | a[f + 10 | 0] << 24) >>> 7 & 2097151) + B | 0, eA = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, A = kA(Y, 0, L, 0), g = h, C = A, A = kA(d, 0, m, 0), g = h + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, B = (A = C) + (C = kA(P, 0, x, 0)) | 0, A = h + g | 0, DA = B, B = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, A = (g = a[f + 6 | 0]) >>> 24 | 0, i = g << 8 | (zA = a[f + 2 | 0] | a[f + 3 | 0] << 8 | a[f + 4 | 0] << 16 | a[f + 5 | 0] << 24) >>> 24, C = A, g = (A = a[f + 7 | 0]) >>> 16 | 0, g |= C, C = B, i = C = (A = 2097151 & ((3 & g) << 30 | (A = A << 16 | i) >>> 2)) >>> 0 > (DA = A + DA | 0) >>> 0 ? C + 1 | 0 : C, qA = A = C - ((DA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (_A = DA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + eA | 0, wA = A = C >>> 0 > (hA = C + SA | 0) >>> 0 ? A + 1 | 0 : A, jA = A = A - ((hA >>> 0 < 4293918720) - 1 | 0) | 0, C = (g = A >>> 21 | 0) + sA | 0, C = (A = (2097151 & A) << 11 | (nA = hA - -1048576 | 0) >>> 21) >>> 0 > (B = A + rA | 0) >>> 0 ? C + 1 | 0 : C, g = kA(uA, WA, 666643, 0), A = h + C | 0, A = g >>> 0 > (B = g + B | 0) >>> 0 ? A + 1 | 0 : A, g = kA($A, CA, 470296, 0), A = h + A | 0, A = g >>> 0 > (C = g + B | 0) >>> 0 ? A + 1 | 0 : A, B = (g = C) + (C = kA(KA, bA, 136657, 0)) | 0, g = h + A | 0, g = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, A = kA(UA, mA, 654183, 0), g = h + g | 0, g = A >>> 0 > (C = A + B | 0) >>> 0 ? g + 1 | 0 : g, rA = (A = kA(vA, dA, -997805, -1)) + C | 0, C = h + g | 0, sA = C = A >>> 0 > rA >>> 0 ? C + 1 | 0 : C, LA = A = C - ((rA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (SA = rA - -1048576 | 0) >>> 21, A = (A >> 21) + yA | 0, YA = C = (A = C >>> 0 > (B = C + YA | 0) >>> 0 ? A + 1 | 0 : A) - ((B >>> 0 < 4293918720) - 1 | 0) | 0, eA = (2097151 & C) << 11 | (yA = B - -1048576 | 0) >>> 21, C = (C >> 21) + TA | 0, PA = NA = eA + xA | 0, NA = eA >>> 0 > NA >>> 0 ? C + 1 | 0 : C, eA = B, g = A, B = (pA - (A = -2097152 & tA) | 0) + (tA = (2097151 & GA) << 11 | FA >>> 21) | 0, A = (HA - ((A >>> 0 > pA >>> 0) + lA | 0) | 0) + (GA >> 21) | 0, FA = A = B >>> 0 < tA >>> 0 ? A + 1 | 0 : A, xA = A = A - ((B >>> 0 < 4293918720) - 1 | 0) | 0, pA = C = A >> 21, A = kA(uA = (2097151 & A) << 11 | (GA = B - -1048576 | 0) >>> 21, C, -683901, -1), g = h + g | 0, g = A >>> 0 > (C = A + eA | 0) >>> 0 ? g + 1 | 0 : g, TA = C - (A = -2097152 & yA) | 0, XA = g - ((A >>> 0 > C >>> 0) + YA | 0) | 0, g = kA(uA, pA, 136657, 0), A = h + sA | 0, A = g >>> 0 > (C = g + rA | 0) >>> 0 ? A + 1 | 0 : A, VA = C - (g = -2097152 & SA) | 0, LA = A - ((g >>> 0 > C >>> 0) + LA | 0) | 0, g = kA($A, CA, 666643, 0), A = h + (wA - (((C = -2097152 & nA) >>> 0 > hA >>> 0) + jA | 0) | 0) | 0, A = g >>> 0 > (eA = g + (hA - C | 0) | 0) >>> 0 ? A + 1 | 0 : A, C = kA(KA, bA, -997805, -1), g = h + A | 0, g = C >>> 0 > (eA = C + eA | 0) >>> 0 ? g + 1 | 0 : g, A = kA(UA, mA, 470296, 0), C = h + g | 0, C = A >>> 0 > (eA = A + eA | 0) >>> 0 ? C + 1 | 0 : C, g = kA(vA, dA, 654183, 0), A = h + C | 0, YA = eA = g + eA | 0, sA = g >>> 0 > eA >>> 0 ? A + 1 | 0 : A, C = zA >>> 5 & 2097151, A = kA(Y, 0, m, 0), g = h, yA = A, A = kA(d, 0, x, 0), g = h + g | 0, A = A >>> 0 > (eA = yA + A | 0) >>> 0 ? g + 1 | 0 : g, yA = g = C + eA | 0, C = A = g >>> 0 < eA >>> 0 ? A + 1 | 0 : A, hA = (g = kA(Y, 0, x, 0)) + (A = (A = a[f + 2 | 0]) << 16 & 2031616 | a[0 | f] | a[f + 1 | 0] << 8) | 0, g = h, tA = g = A >>> 0 > hA >>> 0 ? g + 1 | 0 : g, lA = g = g - ((hA >>> 0 < 4293918720) - 1 | 0) | 0, A = (A = g >>> 21 | 0) + C | 0, nA = A = (g = (2097151 & g) << 11 | (wA = hA - -1048576 | 0) >>> 21) >>> 0 > (HA = g + yA | 0) >>> 0 ? A + 1 | 0 : A, zA = g = A - ((HA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & g) << 11 | (rA = HA - -1048576 | 0) >>> 21, g = (g >>> 21 | 0) + i | 0, g = C >>> 0 > (eA = C + DA | 0) >>> 0 ? g + 1 | 0 : g, C = kA(KA, bA, 654183, 0), A = h + (g - (((i = -2097152 & _A) >>> 0 > eA >>> 0) + qA | 0) | 0) | 0, A = C >>> 0 > (DA = C + (eA - i | 0) | 0) >>> 0 ? A + 1 | 0 : A, g = kA(UA, mA, 666643, 0), A = h + A | 0, A = g >>> 0 > (C = g + DA | 0) >>> 0 ? A + 1 | 0 : A, SA = (g = C) + (C = kA(vA, dA, 470296, 0)) | 0, g = h + A | 0, yA = g = C >>> 0 > SA >>> 0 ? g + 1 | 0 : g, jA = g = g - ((SA >>> 0 < 4293918720) - 1 | 0) | 0, C = (A = g >> 21) + sA | 0, _A = g = (C = (g = (2097151 & g) << 11 | (eA = SA - -1048576 | 0) >>> 21) >>> 0 > (DA = g + YA | 0) >>> 0 ? C + 1 | 0 : C) - ((DA >>> 0 < 4293918720) - 1 | 0) | 0, sA = (2097151 & g) << 11 | (i = DA - -1048576 | 0) >>> 21, g = (g >> 21) + LA | 0, mA = UA = sA + VA | 0, sA = sA >>> 0 > UA >>> 0 ? g + 1 | 0 : g, A = kA(uA, pA, -997805, -1), g = h + C | 0, g = A >>> 0 > (DA = A + DA | 0) >>> 0 ? g + 1 | 0 : g, LA = DA - (A = -2097152 & i) | 0, YA = g - ((A >>> 0 > DA >>> 0) + _A | 0) | 0, g = kA(uA, pA, 654183, 0), A = h + yA | 0, A = g >>> 0 > (C = g + SA | 0) >>> 0 ? A + 1 | 0 : A, UA = C - (g = -2097152 & eA) | 0, _A = A - ((g >>> 0 > C >>> 0) + jA | 0) | 0, A = kA(KA, bA, 470296, 0), C = h + (nA - (((g = -2097152 & rA) >>> 0 > HA >>> 0) + zA | 0) | 0) | 0, C = A >>> 0 > (i = A + (HA - g | 0) | 0) >>> 0 ? C + 1 | 0 : C, g = kA(vA, dA, 666643, 0), A = h + C | 0, DA = i = g + i | 0, C = g >>> 0 > i >>> 0 ? A + 1 | 0 : A, g = kA(KA, bA, 666643, 0), A = h + (tA - ((4095 & lA) + ((i = -2097152 & wA) >>> 0 > hA >>> 0) | 0) | 0) | 0, SA = A = g >>> 0 > (rA = g + (hA - i | 0) | 0) >>> 0 ? A + 1 | 0 : A, tA = A = A - ((rA >>> 0 < 4293918720) - 1 | 0) | 0, i = (2097151 & A) << 11 | (yA = rA - -1048576 | 0) >>> 21, A = (A >> 21) + C | 0, C = A = i >>> 0 > (eA = i + DA | 0) >>> 0 ? A + 1 | 0 : A, wA = A = A - ((eA >>> 0 < 4293918720) - 1 | 0) | 0, i = (2097151 & A) << 11 | (DA = eA - -1048576 | 0) >>> 21, A = (A >> 21) + _A | 0, i = i >>> 0 > (nA = i + UA | 0) >>> 0 ? A + 1 | 0 : A, A = kA(uA, pA, 470296, 0), C = h + C | 0, C = A >>> 0 > (g = A + eA | 0) >>> 0 ? C + 1 | 0 : C, eA = g - (A = -2097152 & DA) | 0, DA = C - ((A >>> 0 > g >>> 0) + wA | 0) | 0, g = kA(uA, pA, 666643, 0), A = h + (SA - (((C = -2097152 & yA) >>> 0 > rA >>> 0) + tA | 0) | 0) | 0, g = (C = (A = g >>> 0 > (HA = g + (rA - C | 0) | 0) >>> 0 ? A + 1 | 0 : A) >> 21) + DA | 0, A = (A = (g = (A = (2097151 & A) << 11 | HA >>> 21) >>> 0 > (_A = A + eA | 0) >>> 0 ? g + 1 | 0 : g) >> 21) + i | 0, g = (g = (A = (g = (2097151 & g) << 11 | _A >>> 21) >>> 0 > (tA = g + nA | 0) >>> 0 ? A + 1 | 0 : A) >> 21) + YA | 0, C = (A = (g = (A = (2097151 & A) << 11 | tA >>> 21) >>> 0 > (i = A + LA | 0) >>> 0 ? g + 1 | 0 : g) >> 21) + sA | 0, A = (g = (C = (g = (2097151 & g) << 11 | i >>> 21) >>> 0 > (wA = g + mA | 0) >>> 0 ? C + 1 | 0 : C) >> 21) + XA | 0, g = (C = (A = (C = (2097151 & C) << 11 | wA >>> 21) >>> 0 > (nA = C + TA | 0) >>> 0 ? A + 1 | 0 : A) >> 21) + NA | 0, A = (A = (g = (A = (2097151 & A) << 11 | nA >>> 21) >>> 0 > (rA = A + PA | 0) >>> 0 ? g + 1 | 0 : g) >> 21) + ZA | 0, g = (g = (A = (g = (2097151 & g) << 11 | rA >>> 21) >>> 0 > (sA = g + RA | 0) >>> 0 ? A + 1 | 0 : A) >> 21) + JA | 0, C = (A = (g = (A = (2097151 & A) << 11 | sA >>> 21) >>> 0 > (SA = A + OA | 0) >>> 0 ? g + 1 | 0 : g) >> 21) + AI | 0, A = (g = (C = (g = (2097151 & g) << 11 | SA >>> 21) >>> 0 > (yA = g + QI | 0) >>> 0 ? C + 1 | 0 : C) >> 21) + BI | 0, DA = (GA = B - (g = -2097152 & GA) | 0) + ((2097151 & (A = (C = (2097151 & C) << 11 | yA >>> 21) >>> 0 > (eA = C + CI | 0) >>> 0 ? A + 1 | 0 : A)) << 11 | eA >>> 21) | 0, A = (FA - ((g >>> 0 > B >>> 0) + xA | 0) | 0) + (A >> 21) | 0, GA = g = (A = DA >>> 0 < GA >>> 0 ? A + 1 | 0 : A) >> 21, HA = (A = kA(NA = (2097151 & A) << 11 | DA >>> 21, g, 666643, 0)) + (g = 2097151 & HA) | 0, A = h, B = A = g >>> 0 > HA >>> 0 ? A + 1 | 0 : A, E[0 | Q] = HA, E[Q + 1 | 0] = (255 & A) << 24 | HA >>> 8, A = 2097151 & _A, g = kA(NA, GA, 470296, 0) + A | 0, C = h, A = (B >> 21) + (A >>> 0 > g >>> 0 ? C + 1 | 0 : C) | 0, A = (FA = (2097151 & B) << 11 | HA >>> 21) >>> 0 > (_A = FA + g | 0) >>> 0 ? A + 1 | 0 : A, E[Q + 4 | 0] = (2047 & A) << 21 | _A >>> 11, g = A, C = _A, E[Q + 3 | 0] = (7 & A) << 29 | C >>> 3, E[Q + 2 | 0] = 31 & ((65535 & B) << 16 | HA >>> 16) | C << 5, B = 2097151 & tA, tA = kA(NA, GA, 654183, 0) + B | 0, A = h, _A = (2097151 & g) << 11 | C >>> 21, g = (g >> 21) + (B = B >>> 0 > tA >>> 0 ? A + 1 | 0 : A) | 0, A = g = (tA = _A + tA | 0) >>> 0 < _A >>> 0 ? g + 1 | 0 : g, E[Q + 6 | 0] = (63 & A) << 26 | tA >>> 6, B = tA, tA = 0, E[Q + 5 | 0] = tA << 13 | (1572864 & C) >>> 19 | B << 2, C = 2097151 & i, i = kA(NA, GA, -997805, -1) + C | 0, g = h, g = C >>> 0 > i >>> 0 ? g + 1 | 0 : g, tA = (2097151 & (C = A)) << 11 | B >>> 21, C = (A >>= 21) + g | 0, C = (i = tA + i | 0) >>> 0 < tA >>> 0 ? C + 1 | 0 : C, E[Q + 9 | 0] = (511 & C) << 23 | i >>> 9, E[Q + 8 | 0] = (1 & C) << 31 | i >>> 1, g = 0, E[Q + 7 | 0] = g << 18 | (2080768 & B) >>> 14 | i << 7, g = 2097151 & wA, B = kA(NA, GA, 136657, 0) + g | 0, A = h, A = g >>> 0 > B >>> 0 ? A + 1 | 0 : A, wA = (2097151 & (g = C)) << 11 | i >>> 21, g = A + (C = g >> 21) | 0, g = (B = wA + B | 0) >>> 0 < wA >>> 0 ? g + 1 | 0 : g, E[Q + 12 | 0] = (4095 & g) << 20 | B >>> 12, C = B, E[Q + 11 | 0] = (15 & g) << 28 | C >>> 4, B = 0, E[Q + 10 | 0] = B << 15 | (1966080 & i) >>> 17 | C << 4, B = 2097151 & nA, i = kA(NA, GA, -683901, -1) + B | 0, A = h, A = B >>> 0 > i >>> 0 ? A + 1 | 0 : A, B = g, g = A + (g >>= 21) | 0, g = (B = (nA = i) + (i = (2097151 & B) << 11 | C >>> 21) | 0) >>> 0 < i >>> 0 ? g + 1 | 0 : g, E[Q + 14 | 0] = (127 & g) << 25 | B >>> 7, i = 0, E[Q + 13 | 0] = i << 12 | (1048576 & C) >>> 20 | B << 1, A = g >> 21, C = (g = (2097151 & g) << 11 | B >>> 21) >>> 0 > (i = g + (2097151 & rA) | 0) >>> 0 ? A + 1 | 0 : A, E[Q + 17 | 0] = (1023 & C) << 22 | i >>> 10, E[Q + 16 | 0] = (3 & C) << 30 | i >>> 2, g = 0, E[Q + 15 | 0] = g << 17 | (2064384 & B) >>> 15 | i << 6, A = C >> 21, A = (g = (2097151 & C) << 11 | i >>> 21) >>> 0 > (C = g + (2097151 & sA) | 0) >>> 0 ? A + 1 | 0 : A, E[Q + 20 | 0] = (8191 & A) << 19 | C >>> 13, E[Q + 19 | 0] = (31 & A) << 27 | C >>> 5, B = (g = 2097151 & SA) + (SA = (2097151 & A) << 11 | C >>> 21) | 0, g = A >> 21, g = B >>> 0 < SA >>> 0 ? g + 1 | 0 : g, SA = B, E[Q + 21 | 0] = B, sA = 0, E[Q + 18 | 0] = sA << 14 | (1835008 & i) >>> 18 | C << 3, E[Q + 22 | 0] = (255 & g) << 24 | B >>> 8, C = g >> 21, C = (B = (i = (2097151 & g) << 11 | B >>> 21) + (2097151 & yA) | 0) >>> 0 < i >>> 0 ? C + 1 | 0 : C, E[Q + 25 | 0] = (2047 & C) << 21 | B >>> 11, E[Q + 24 | 0] = (7 & C) << 29 | B >>> 3, E[Q + 23 | 0] = 31 & ((65535 & g) << 16 | SA >>> 16) | B << 5, A = C >> 21, A = (g = (2097151 & C) << 11 | B >>> 21) >>> 0 > (C = g + (2097151 & eA) | 0) >>> 0 ? A + 1 | 0 : A, E[Q + 27 | 0] = (63 & A) << 26 | C >>> 6, i = 0, E[Q + 26 | 0] = i << 13 | (1572864 & B) >>> 19 | C << 2, g = A >> 21, g = (A = (B = (2097151 & A) << 11 | C >>> 21) + (2097151 & DA) | 0) >>> 0 < B >>> 0 ? g + 1 | 0 : g, E[Q + 31 | 0] = (131071 & g) << 15 | A >>> 17, E[Q + 30 | 0] = (511 & g) << 23 | A >>> 9, E[Q + 29 | 0] = (1 & g) << 31 | A >>> 1, B = 0, E[Q + 28 | 0] = B << 18 | (2080768 & C) >>> 14 | A << 7, iI(c, 64), iI(f, 64), I && (o[I >> 2] = 64, o[I + 4 >> 2] = 0), w = e + 560 | 0, 0;
                                    }
                                    function k(A, I, g, C) {
                                        for(var B = 0, Q = 0, i = 0, E = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, n = 0, s = 0, k = 0, F = 0, S = 0, H = 0, G = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, U = 0, Y = 0, d = 0, K = 0, b = 0, P = 0, v = 0, L = 0, R = 0, u = 0, x = 0, m = 0, l = 0; i = (B = f << 3) + g | 0, Q = a[0 | (B = I + B | 0)] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, M = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, c = Q << 24 | (65280 & Q) << 8, e = (E = 16711680 & Q) << 24, E = E >>> 8 | 0, B = (D = -16777216 & Q) >>> 24 | 0, o[i >> 2] = e | D << 8 | -16777216 & ((255 & M) << 24 | Q >>> 8) | 16711680 & ((16777215 & M) << 8 | Q >>> 24) | M >>> 8 & 65280 | M >>> 24, Q = B | E | c, B = 0, o[i + 4 >> 2] = Q | B | B, 16 != (0 | (f = f + 1 | 0)););
                                        for(I = o[A + 4 >> 2], o[C >> 2] = o[A >> 2], o[C + 4 >> 2] = I, I = o[A + 60 >> 2], o[C + 56 >> 2] = o[A + 56 >> 2], o[C + 60 >> 2] = I, I = o[A + 52 >> 2], o[C + 48 >> 2] = o[A + 48 >> 2], o[C + 52 >> 2] = I, I = o[A + 44 >> 2], o[C + 40 >> 2] = o[A + 40 >> 2], o[C + 44 >> 2] = I, I = o[A + 36 >> 2], o[C + 32 >> 2] = o[A + 32 >> 2], o[C + 36 >> 2] = I, I = o[A + 28 >> 2], o[C + 24 >> 2] = o[A + 24 >> 2], o[C + 28 >> 2] = I, I = o[A + 20 >> 2], o[C + 16 >> 2] = o[A + 16 >> 2], o[C + 20 >> 2] = I, I = o[A + 12 >> 2], o[C + 8 >> 2] = o[A + 8 >> 2], o[C + 12 >> 2] = I; i = o[C + 56 >> 2], E = o[C + 60 >> 2], B = o[(I = M = (p = l << 3) + g | 0) >> 2], I = o[I + 4 >> 2], S = Q = o[C + 36 >> 2], Q = DA(s = o[C + 32 >> 2], Q, 50), f = h, Q = DA(s, S, 46) ^ Q, f ^= h, Q = DA(s, S, 23) ^ Q, I = (h ^ f) + I | 0, I = (B = Q + B | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, B = (f = o[(Q = p + 34368 | 0) >> 2]) + B | 0, I = o[Q + 4 >> 2] + I | 0, I = B >>> 0 < f >>> 0 ? I + 1 | 0 : I, Q = (f = ((e = o[C + 48 >> 2]) ^ (t = o[C + 40 >> 2])) & s ^ e) + B | 0, B = (((k = o[C + 52 >> 2]) ^ (H = o[C + 44 >> 2])) & S ^ k) + I | 0, I = (Q >>> 0 < f >>> 0 ? B + 1 | 0 : B) + E | 0, I = (i = Q + i | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, f = (Q = o[C + 24 >> 2]) + i | 0, B = o[C + 28 >> 2] + I | 0, y = B = Q >>> 0 > f >>> 0 ? B + 1 | 0 : B, o[C + 24 >> 2] = f, o[C + 28 >> 2] = B, F = B = o[C + 4 >> 2], B = DA(Q = o[C >> 2], B, 36), E = h, B = DA(Q, F, 30) ^ B, E ^= h, D = i + (DA(Q, F, 25) ^ B) | 0, B = I + (h ^ E) | 0, B = i >>> 0 > D >>> 0 ? B + 1 | 0 : B, c = (I = D) + (D = Q & ((E = o[C + 16 >> 2]) | (i = o[C + 8 >> 2])) | i & E) | 0, I = (I = B) + (F & ((B = o[C + 20 >> 2]) | (w = o[C + 12 >> 2])) | B & w) | 0, D = I = c >>> 0 < D >>> 0 ? I + 1 | 0 : I, o[C + 56 >> 2] = c, o[C + 60 >> 2] = I, r = E, n = B, _ = o[(I = v = (G = 8 | p) + g | 0) >> 2], J = o[I + 4 >> 2], B = ((S ^ H) & y ^ H) + k | 0, B = (I = (E = (t ^ s) & f ^ t) + e | 0) >>> 0 < E >>> 0 ? B + 1 | 0 : B, E = DA(f, y, 50), e = h, E = DA(f, y, 46) ^ E, e ^= h, E = (k = DA(f, y, 23) ^ E) + I | 0, I = (h ^ e) + B | 0, I = (E >>> 0 < k >>> 0 ? I + 1 | 0 : I) + J | 0, I = (B = E + _ | 0) >>> 0 < E >>> 0 ? I + 1 | 0 : I, E = (E = B) + (e = o[(B = G + 34368 | 0) >> 2]) | 0, B = o[B + 4 >> 2] + I | 0, B = (I = E >>> 0 < e >>> 0 ? B + 1 | 0 : B) + n | 0, k = B = (e = E + r | 0) >>> 0 < E >>> 0 ? B + 1 | 0 : B, o[C + 16 >> 2] = e, o[C + 20 >> 2] = B, I = I + ((w | F) & D | w & F) | 0, I = (B = E + ((Q | i) & c | Q & i) | 0) >>> 0 < E >>> 0 ? I + 1 | 0 : I, E = DA(c, D, 36), r = h, E = DA(c, D, 30) ^ E, r ^= h, n = B, B = DA(c, D, 25) ^ E, I = (h ^ r) + I | 0, r = I = B >>> 0 > (E = n + B | 0) >>> 0 ? I + 1 | 0 : I, o[C + 48 >> 2] = E, o[C + 52 >> 2] = I, n = i, G = w, I = (w = o[(B = d = (i = 16 | p) + g | 0) >> 2]) + t | 0, B = o[B + 4 >> 2] + H | 0, B = I >>> 0 < w >>> 0 ? B + 1 | 0 : B, i = (t = I) + (w = o[(I = i + 34368 | 0) >> 2]) | 0, I = o[I + 4 >> 2] + B | 0, I = ((y ^ S) & k ^ S) + (I = i >>> 0 < w >>> 0 ? I + 1 | 0 : I) | 0, I = (B = (B = i) + (i = (f ^ s) & e ^ s) | 0) >>> 0 < i >>> 0 ? I + 1 | 0 : I, i = DA(e, k, 50), w = h, i = DA(e, k, 46) ^ i, w ^= h, i = (t = DA(e, k, 23) ^ i) + B | 0, B = (h ^ w) + I | 0, B = (t = i >>> 0 < t >>> 0 ? B + 1 | 0 : B) + G | 0, G = B = (w = i) >>> 0 > (i = i + n | 0) >>> 0 ? B + 1 | 0 : B, o[C + 8 >> 2] = i, o[C + 12 >> 2] = B, I = DA(E, r, 36), B = h, I = DA(E, r, 30) ^ I, B ^= h, H = DA(E, r, 25) ^ I, I = ((D | F) & r | D & F) + (h ^ B) | 0, B = t + ((n = H + ((Q | c) & E | Q & c) | 0) >>> 0 < H >>> 0 ? I + 1 | 0 : I) | 0, w = B = (t = w + n | 0) >>> 0 < w >>> 0 ? B + 1 | 0 : B, o[C + 40 >> 2] = t, o[C + 44 >> 2] = B, n = Q, B = (B = s) + (s = o[(I = L = (Q = 24 | p) + g | 0) >> 2]) | 0, I = o[I + 4 >> 2] + S | 0, I = B >>> 0 < s >>> 0 ? I + 1 | 0 : I, Q = (H = B) + (s = o[(B = Q + 34368 | 0) >> 2]) | 0, B = o[B + 4 >> 2] + I | 0, B = (y ^ (y ^ k) & G) + (B = Q >>> 0 < s >>> 0 ? B + 1 | 0 : B) | 0, B = (I = (I = Q) + (Q = f ^ (f ^ e) & i) | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = DA(i, G, 50), s = h, Q = DA(i, G, 46) ^ Q, s ^= h, Q = (S = DA(i, G, 23) ^ Q) + I | 0, I = (h ^ s) + B | 0, B = (I = Q >>> 0 < S >>> 0 ? I + 1 | 0 : I) + F | 0, S = B = (F = Q + n | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, o[C >> 2] = F, o[C + 4 >> 2] = B, B = DA(t, w, 36), s = h, B = DA(t, w, 30) ^ B, n = h ^ s, H = DA(t, w, 25) ^ B, B = ((D | r) & w | D & r) + (h ^ n) | 0, I = I + ((s = H + ((E | c) & t | E & c) | 0) >>> 0 < H >>> 0 ? B + 1 | 0 : B) | 0, s = I = (n = Q + s | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, o[C + 32 >> 2] = n, o[C + 36 >> 2] = I, Q = o[(B = P = (I = 32 | p) + g | 0) >> 2], B = y + o[B + 4 >> 2] | 0, B = (Q = Q + f | 0) >>> 0 < f >>> 0 ? B + 1 | 0 : B, Q = (f = o[(I = I + 34368 | 0) >> 2]) + Q | 0, I = o[I + 4 >> 2] + B | 0, I = (k ^ (k ^ G) & S) + (I = Q >>> 0 < f >>> 0 ? I + 1 | 0 : I) | 0, I = (B = (B = Q) + (Q = e ^ (i ^ e) & F) | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = DA(F, S, 50), f = h, Q = DA(F, S, 46) ^ Q, f ^= h, Q = (y = DA(F, S, 23) ^ Q) + B | 0, B = (h ^ f) + I | 0, H = B = Q >>> 0 < y >>> 0 ? B + 1 | 0 : B, I = B, B = DA(n, s, 36), f = h, B = DA(n, s, 30) ^ B, y = h ^ f, _ = DA(n, s, 25) ^ B, B = ((r | w) & s | r & w) + (h ^ y) | 0, I = ((f = _ + ((E | t) & n | E & t) | 0) >>> 0 < _ >>> 0 ? B + 1 | 0 : B) + I | 0, f = I = (y = Q + f | 0) >>> 0 < f >>> 0 ? I + 1 | 0 : I, o[C + 24 >> 2] = y, o[C + 28 >> 2] = I, B = D + H | 0, H = B = (D = Q + c | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, o[C + 56 >> 2] = D, o[C + 60 >> 2] = B, Q = o[(I = K = (B = 40 | p) + g | 0) >> 2], I = k + o[I + 4 >> 2] | 0, I = (Q = Q + e | 0) >>> 0 < e >>> 0 ? I + 1 | 0 : I, Q = (c = o[(B = B + 34368 | 0) >> 2]) + Q | 0, B = o[B + 4 >> 2] + I | 0, B = (G ^ (S ^ G) & H) + (B = Q >>> 0 < c >>> 0 ? B + 1 | 0 : B) | 0, B = (I = (I = Q) + (Q = i ^ (i ^ F) & D) | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = DA(D, H, 50), c = h, Q = DA(D, H, 46) ^ Q, c ^= h, Q = (e = DA(D, H, 23) ^ Q) + I | 0, I = (h ^ c) + B | 0, I = Q >>> 0 < e >>> 0 ? I + 1 | 0 : I, B = DA(y, f, 36), c = h, B = DA(y, f, 30) ^ B, e = h ^ c, k = DA(y, f, 25) ^ B, B = ((w | s) & f | w & s) + (h ^ e) | 0, B = ((c = k + ((t | n) & y | t & n) | 0) >>> 0 < k >>> 0 ? B + 1 | 0 : B) + I | 0, c = B = (e = Q + c | 0) >>> 0 < c >>> 0 ? B + 1 | 0 : B, o[C + 16 >> 2] = e, o[C + 20 >> 2] = B, I = I + r | 0, _ = I = (r = Q + E | 0) >>> 0 < E >>> 0 ? I + 1 | 0 : I, o[C + 48 >> 2] = r, o[C + 52 >> 2] = I, Q = o[(B = Y = (I = 48 | p) + g | 0) >> 2], B = G + o[B + 4 >> 2] | 0, B = (Q = Q + i | 0) >>> 0 < i >>> 0 ? B + 1 | 0 : B, Q = (i = o[(I = I + 34368 | 0) >> 2]) + Q | 0, I = o[I + 4 >> 2] + B | 0, I = (S ^ (S ^ H) & _) + (I = Q >>> 0 < i >>> 0 ? I + 1 | 0 : I) | 0, I = (B = (B = Q) + (Q = F ^ (D ^ F) & r) | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = DA(r, _, 50), i = h, Q = DA(r, _, 46) ^ Q, i ^= h, Q = (E = DA(r, _, 23) ^ Q) + B | 0, B = (h ^ i) + I | 0, E = B = Q >>> 0 < E >>> 0 ? B + 1 | 0 : B, I = B, B = DA(e, c, 36), i = h, B = DA(e, c, 30) ^ B, k = h ^ i, G = DA(e, c, 25) ^ B, B = ((f | s) & c | f & s) + (h ^ k) | 0, I = ((i = G + ((y | n) & e | y & n) | 0) >>> 0 < G >>> 0 ? B + 1 | 0 : B) + I | 0, k = I = (B = i) >>> 0 > (i = Q + i | 0) >>> 0 ? I + 1 | 0 : I, o[C + 8 >> 2] = i, o[C + 12 >> 2] = I, B = E + w | 0, G = B = (J = Q + t | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, o[C + 40 >> 2] = J, o[C + 44 >> 2] = B, Q = o[(I = b = (B = 56 | p) + g | 0) >> 2], I = S + o[I + 4 >> 2] | 0, I = (Q = Q + F | 0) >>> 0 < F >>> 0 ? I + 1 | 0 : I, Q = (E = o[(B = B + 34368 | 0) >> 2]) + Q | 0, B = o[B + 4 >> 2] + I | 0, B = (H ^ (H ^ _) & G) + (B = Q >>> 0 < E >>> 0 ? B + 1 | 0 : B) | 0, B = (I = (I = Q) + (Q = D ^ (D ^ r) & J) | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = DA(J, G, 50), E = h, Q = DA(J, G, 46) ^ Q, E ^= h, Q = (w = DA(J, G, 23) ^ Q) + I | 0, I = (h ^ E) + B | 0, I = Q >>> 0 < w >>> 0 ? I + 1 | 0 : I, B = DA(i, k, 36), E = h, B = DA(i, k, 30) ^ B, w = h ^ E, t = DA(i, k, 25) ^ B, B = ((f | c) & k | f & c) + (h ^ w) | 0, B = ((E = t + ((e | y) & i | e & y) | 0) >>> 0 < t >>> 0 ? B + 1 | 0 : B) + I | 0, w = B = (w = E) >>> 0 > (E = Q + E | 0) >>> 0 ? B + 1 | 0 : B, o[C >> 2] = E, o[C + 4 >> 2] = B, I = I + s | 0, S = I = (t = Q + n | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, o[C + 32 >> 2] = t, o[C + 36 >> 2] = I, Q = o[(B = R = (I = 64 | p) + g | 0) >> 2], B = H + o[B + 4 >> 2] | 0, B = (Q = Q + D | 0) >>> 0 < D >>> 0 ? B + 1 | 0 : B, Q = (D = o[(I = I + 34368 | 0) >> 2]) + Q | 0, I = o[I + 4 >> 2] + B | 0, I = (_ ^ (G ^ _) & S) + (I = Q >>> 0 < D >>> 0 ? I + 1 | 0 : I) | 0, I = (B = (B = Q) + (Q = r ^ (r ^ J) & t) | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = DA(t, S, 50), D = h, Q = DA(t, S, 46) ^ Q, D ^= h, Q = (F = DA(t, S, 23) ^ Q) + B | 0, B = (h ^ D) + I | 0, s = B = Q >>> 0 < F >>> 0 ? B + 1 | 0 : B, I = B, B = DA(E, w, 36), D = h, B = DA(E, w, 30) ^ B, F = h ^ D, n = DA(E, w, 25) ^ B, B = ((c | k) & w | c & k) + (h ^ F) | 0, I = ((D = n + ((i | e) & E | i & e) | 0) >>> 0 < n >>> 0 ? B + 1 | 0 : B) + I | 0, D = I = (F = Q + D | 0) >>> 0 < D >>> 0 ? I + 1 | 0 : I, o[C + 56 >> 2] = F, o[C + 60 >> 2] = I, B = f + s | 0, H = B = (f = Q + y | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, o[C + 24 >> 2] = f, o[C + 28 >> 2] = B, Q = o[(I = U = (B = 72 | p) + g | 0) >> 2], I = _ + o[I + 4 >> 2] | 0, I = (Q = Q + r | 0) >>> 0 < r >>> 0 ? I + 1 | 0 : I, Q = (r = o[(B = B + 34368 | 0) >> 2]) + Q | 0, B = o[B + 4 >> 2] + I | 0, B = (G ^ (S ^ G) & H) + (B = Q >>> 0 < r >>> 0 ? B + 1 | 0 : B) | 0, B = (I = (I = Q) + (Q = J ^ (t ^ J) & f) | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = DA(f, H, 50), r = h, Q = DA(f, H, 46) ^ Q, r ^= h, Q = (s = DA(f, H, 23) ^ Q) + I | 0, I = (h ^ r) + B | 0, I = Q >>> 0 < s >>> 0 ? I + 1 | 0 : I, B = DA(F, D, 36), r = h, B = DA(F, D, 30) ^ B, s = h ^ r, n = DA(F, D, 25) ^ B, B = ((w | k) & D | w & k) + (h ^ s) | 0, B = ((r = n + ((i | E) & F | i & E) | 0) >>> 0 < n >>> 0 ? B + 1 | 0 : B) + I | 0, r = B = (s = Q + r | 0) >>> 0 < r >>> 0 ? B + 1 | 0 : B, o[C + 48 >> 2] = s, o[C + 52 >> 2] = B, I = I + c | 0, _ = I = (c = Q + e | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, o[C + 16 >> 2] = c, o[C + 20 >> 2] = I, I = (I = J) + (e = o[(B = J = (Q = 80 | p) + g | 0) >> 2]) | 0, B = o[B + 4 >> 2] + G | 0, B = I >>> 0 < e >>> 0 ? B + 1 | 0 : B, Q = (y = I) + (e = o[(I = Q + 34368 | 0) >> 2]) | 0, I = o[I + 4 >> 2] + B | 0, I = (S ^ (S ^ H) & _) + (I = Q >>> 0 < e >>> 0 ? I + 1 | 0 : I) | 0, I = (B = (B = Q) + (Q = t ^ (f ^ t) & c) | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = DA(c, _, 50), e = h, Q = DA(c, _, 46) ^ Q, e ^= h, Q = (n = DA(c, _, 23) ^ Q) + B | 0, B = (h ^ e) + I | 0, y = B = Q >>> 0 < n >>> 0 ? B + 1 | 0 : B, I = B, B = DA(s, r, 36), e = h, B = DA(s, r, 30) ^ B, n = h ^ e, G = DA(s, r, 25) ^ B, B = ((D | w) & r | D & w) + (h ^ n) | 0, I = ((e = G + ((E | F) & s | E & F) | 0) >>> 0 < G >>> 0 ? B + 1 | 0 : B) + I | 0, e = I = (n = Q + e | 0) >>> 0 < e >>> 0 ? I + 1 | 0 : I, o[C + 40 >> 2] = n, o[C + 44 >> 2] = I, B = y + k | 0, k = B = (y = Q + i | 0) >>> 0 < i >>> 0 ? B + 1 | 0 : B, o[C + 8 >> 2] = y, o[C + 12 >> 2] = B, B = 34368 + (I = 88 | p) | 0, i = o[(I = N = I + g | 0) >> 2], Q = o[B >> 2] + i | 0, I = o[B + 4 >> 2] + o[I + 4 >> 2] | 0, B = S + (Q >>> 0 < i >>> 0 ? I + 1 | 0 : I) | 0, B = (H ^ (H ^ _) & k) + (B = (I = Q + t | 0) >>> 0 < t >>> 0 ? B + 1 | 0 : B) | 0, B = (I = (Q = f ^ (f ^ c) & y) + I | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = DA(y, k, 50), i = h, Q = DA(y, k, 46) ^ Q, i ^= h, Q = (t = DA(y, k, 23) ^ Q) + I | 0, I = (h ^ i) + B | 0, I = Q >>> 0 < t >>> 0 ? I + 1 | 0 : I, B = DA(n, e, 36), i = h, B = DA(n, e, 30) ^ B, t = h ^ i, G = DA(n, e, 25) ^ B, B = ((D | r) & e | D & r) + (h ^ t) | 0, B = ((i = G + ((s | F) & n | s & F) | 0) >>> 0 < G >>> 0 ? B + 1 | 0 : B) + I | 0, t = B = (t = i) >>> 0 > (i = Q + i | 0) >>> 0 ? B + 1 | 0 : B, o[C + 32 >> 2] = i, o[C + 36 >> 2] = B, I = I + w | 0, w = I = (B = E) >>> 0 > (E = Q + E | 0) >>> 0 ? I + 1 | 0 : I, o[C >> 2] = E, o[C + 4 >> 2] = I, B = 34368 + (I = 96 | p) | 0, G = o[(I = u = I + g | 0) >> 2], Q = o[B >> 2] + G | 0, B = o[B + 4 >> 2] + o[I + 4 >> 2] | 0, I = H + (Q >>> 0 < G >>> 0 ? B + 1 | 0 : B) | 0, I = (B = Q + f | 0) >>> 0 < f >>> 0 ? I + 1 | 0 : I, Q = (f = c ^ (c ^ y) & E) + B | 0, B = (_ ^ (k ^ _) & w) + I | 0, B = Q >>> 0 < f >>> 0 ? B + 1 | 0 : B, I = DA(E, w, 50), f = h, I = DA(E, w, 46) ^ I, f ^= h, H = Q, Q = DA(E, w, 23) ^ I, B = (h ^ f) + B | 0, S = B = (I = H + Q | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = I, I = DA(i, t, 36), f = h, I = DA(i, t, 30) ^ I, G = h ^ f, H = DA(i, t, 25) ^ I, I = ((e | r) & t | e & r) + (h ^ G) | 0, B = ((f = H + ((s | n) & i | s & n) | 0) >>> 0 < H >>> 0 ? I + 1 | 0 : I) + B | 0, f = B = (G = Q + f | 0) >>> 0 < f >>> 0 ? B + 1 | 0 : B, o[C + 24 >> 2] = G, o[C + 28 >> 2] = B, B = D + S | 0, D = B = (F = Q + F | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, o[C + 56 >> 2] = F, o[C + 60 >> 2] = B, B = 34368 + (I = 104 | p) | 0, S = o[(I = m = I + g | 0) >> 2], Q = o[B >> 2] + S | 0, I = o[B + 4 >> 2] + o[I + 4 >> 2] | 0, B = _ + (Q >>> 0 < S >>> 0 ? I + 1 | 0 : I) | 0, B = (I = Q + c | 0) >>> 0 < c >>> 0 ? B + 1 | 0 : B, Q = (c = y ^ (E ^ y) & F) + I | 0, I = (k ^ (w ^ k) & D) + B | 0, I = Q >>> 0 < c >>> 0 ? I + 1 | 0 : I, B = DA(F, D, 50), c = h, B = DA(F, D, 46) ^ B, c ^= h, S = DA(F, D, 23) ^ B, B = (h ^ c) + I | 0, H = B = (Q = S + Q | 0) >>> 0 < S >>> 0 ? B + 1 | 0 : B, I = B, B = DA(G, f, 36), c = h, B = DA(G, f, 30) ^ B, S = h ^ c, _ = DA(G, f, 25) ^ B, B = ((e | t) & f | e & t) + (h ^ S) | 0, I = ((c = _ + ((i | n) & G | i & n) | 0) >>> 0 < _ >>> 0 ? B + 1 | 0 : B) + I | 0, c = I = (S = Q + c | 0) >>> 0 < c >>> 0 ? I + 1 | 0 : I, o[C + 16 >> 2] = S, o[C + 20 >> 2] = I, I = r + H | 0, r = I = (s = Q + s | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, o[C + 48 >> 2] = s, o[C + 52 >> 2] = I, B = 34368 + (I = 112 | p) | 0, H = o[(Q = _ = I + g | 0) >> 2], I = o[B >> 2] + H | 0, B = o[B + 4 >> 2] + o[Q + 4 >> 2] | 0, B = k + (I >>> 0 < H >>> 0 ? B + 1 | 0 : B) | 0, B = (w ^ (D ^ w) & r) + (B = (I = I + y | 0) >>> 0 < y >>> 0 ? B + 1 | 0 : B) | 0, B = (I = (Q = E ^ (E ^ F) & s) + I | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = DA(s, r, 50), y = h, Q = DA(s, r, 46) ^ Q, y ^= h, Q = (k = DA(s, r, 23) ^ Q) + I | 0, I = (h ^ y) + B | 0, H = I = Q >>> 0 < k >>> 0 ? I + 1 | 0 : I, B = I, I = DA(S, c, 36), y = h, I = DA(S, c, 30) ^ I, k = h ^ y, x = DA(S, c, 25) ^ I, I = ((f | t) & c | f & t) + (h ^ k) | 0, B = ((y = x + ((i | G) & S | i & G) | 0) >>> 0 < x >>> 0 ? I + 1 | 0 : I) + B | 0, y = B = (k = Q + y | 0) >>> 0 < y >>> 0 ? B + 1 | 0 : B, o[C + 8 >> 2] = k, o[C + 12 >> 2] = B, B = e + H | 0, Q = B = (e = Q + n | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, o[C + 40 >> 2] = e, o[C + 44 >> 2] = B, B = 34368 + (I = 120 | p) | 0, p = o[(I = n = I + g | 0) >> 2], H = o[B >> 2] + p | 0, B = o[B + 4 >> 2] + o[I + 4 >> 2] | 0, I = w + (H >>> 0 < p >>> 0 ? B + 1 | 0 : B) | 0, I = (D ^ (D ^ r) & Q) + (I = (B = E + H | 0) >>> 0 < E >>> 0 ? I + 1 | 0 : I) | 0, I = (B = (E = F ^ (s ^ F) & e) + B | 0) >>> 0 < E >>> 0 ? I + 1 | 0 : I, E = DA(e, Q, 50), D = h, E = DA(e, Q, 46) ^ E, D ^= h, Q = (E = DA(e, Q, 23) ^ E) + B | 0, B = (h ^ D) + I | 0, B = Q >>> 0 < E >>> 0 ? B + 1 | 0 : B, E = Q, D = B, I = B, B = DA(k, y, 36), e = h, B = DA(k, y, 30) ^ B, r = h ^ e, w = DA(k, y, 25) ^ B, B = ((f | c) & y | f & c) + (h ^ r) | 0, I = ((e = w + ((S | G) & k | S & G) | 0) >>> 0 < w >>> 0 ? B + 1 | 0 : B) + I | 0, I = (Q = Q + e | 0) >>> 0 < e >>> 0 ? I + 1 | 0 : I, o[C >> 2] = Q, o[C + 4 >> 2] = I, B = D + t | 0, B = (r = i) >>> 0 > (i = i + E | 0) >>> 0 ? B + 1 | 0 : B, o[C + 32 >> 2] = i, o[C + 36 >> 2] = B, 64 != (0 | l);)c = ((l = l + 16 | 0) << 3) + g | 0, E = o[M >> 2], f = o[M + 4 >> 2], x = o[U >> 2], D = I = o[U + 4 >> 2], B = I, Q = I = o[_ + 4 >> 2], I = DA(G = o[_ >> 2], I, 45), i = h, r = ((63 & Q) << 26 | G >>> 6) ^ (I = DA(G, Q, 3) ^ I), I = (Q >>> 6 ^ (e = h ^ i)) + B | 0, B = ((i = r + x | 0) >>> 0 < r >>> 0 ? I + 1 | 0 : I) + f | 0, B = (I = i + E | 0) >>> 0 < i >>> 0 ? B + 1 | 0 : B, E = i = o[v + 4 >> 2], i = DA(f = o[v >> 2], i, 63), e = h, i = ((127 & E) << 25 | f >>> 7) ^ DA(f, E, 56) ^ i, B = (h ^ e ^ E >>> 7) + B | 0, i = B = i >>> 0 > (S = i + I | 0) >>> 0 ? B + 1 | 0 : B, o[c >> 2] = S, o[c + 4 >> 2] = B, f = (_ = o[J >> 2]) + f | 0, I = (c = o[J + 4 >> 2]) + E | 0, B = f >>> 0 < _ >>> 0 ? I + 1 | 0 : I, E = I = o[n + 4 >> 2], I = DA(H = o[n >> 2], I, 45), e = h, r = f, f = ((63 & E) << 26 | H >>> 6) ^ DA(H, E, 3) ^ I, B = (h ^ e ^ E >>> 6) + B | 0, f = f >>> 0 > (r = r + f | 0) >>> 0 ? B + 1 | 0 : B, B = DA(e = o[d >> 2], I = o[d + 4 >> 2], 63), w = h, y = r, r = ((127 & I) << 25 | e >>> 7) ^ DA(e, I, 56) ^ B, B = (h ^ w ^ I >>> 7) + f | 0, f = B = r >>> 0 > (k = y + r | 0) >>> 0 ? B + 1 | 0 : B, o[M + 136 >> 2] = k, o[M + 140 >> 2] = B, B = (J = o[N >> 2]) + e | 0, I = (e = o[N + 4 >> 2]) + I | 0, r = DA(S, i, 45), w = h, r = (t = ((63 & i) << 26 | S >>> 6) ^ DA(S, i, 3) ^ r) + B | 0, B = (h ^ w ^ i >>> 6) + (B >>> 0 < J >>> 0 ? I + 1 | 0 : I) | 0, B = r >>> 0 < t >>> 0 ? B + 1 | 0 : B, w = I = o[L + 4 >> 2], I = DA(t = o[L >> 2], I, 63), F = h, y = r, r = ((127 & w) << 25 | t >>> 7) ^ DA(t, w, 56) ^ I, B = (h ^ F ^ w >>> 7) + B | 0, r = B = r >>> 0 > (p = y + r | 0) >>> 0 ? B + 1 | 0 : B, o[M + 144 >> 2] = p, o[M + 148 >> 2] = B, t = (v = o[u >> 2]) + t | 0, I = (I = w) + (w = o[u + 4 >> 2]) | 0, B = t >>> 0 < v >>> 0 ? I + 1 | 0 : I, I = DA(k, f, 45), F = h, s = ((63 & f) << 26 | k >>> 6) ^ DA(k, f, 3) ^ I, B = (h ^ F ^ f >>> 6) + B | 0, B = (t = s + t | 0) >>> 0 < s >>> 0 ? B + 1 | 0 : B, F = I = o[P + 4 >> 2], I = DA(s = o[P >> 2], I, 63), n = h, y = t, t = ((127 & F) << 25 | s >>> 7) ^ DA(s, F, 56) ^ I, B = (h ^ n ^ F >>> 7) + B | 0, t = B = t >>> 0 > (d = y + t | 0) >>> 0 ? B + 1 | 0 : B, o[M + 152 >> 2] = d, o[M + 156 >> 2] = B, I = (L = o[m >> 2]) + s | 0, B = (B = F) + (F = o[m + 4 >> 2]) | 0, s = DA(p, r, 45), n = h, s = ((63 & r) << 26 | p >>> 6) ^ DA(p, r, 3) ^ s, B = (h ^ n ^ r >>> 6) + (I >>> 0 < L >>> 0 ? B + 1 | 0 : B) | 0, s = (y = s + I | 0) >>> 0 < s >>> 0 ? B + 1 | 0 : B, B = DA(n = o[K >> 2], I = o[K + 4 >> 2], 63), P = h, N = y, y = ((127 & I) << 25 | n >>> 7) ^ (B = DA(n, I, 56) ^ B), B = (I >>> 7 ^ (K = h ^ P)) + s | 0, s = B = y >>> 0 > (P = N + y | 0) >>> 0 ? B + 1 | 0 : B, o[M + 160 >> 2] = P, o[M + 164 >> 2] = B, I = I + Q | 0, I = (B = n + G | 0) >>> 0 < n >>> 0 ? I + 1 | 0 : I, n = DA(d, t, 45), y = h, n = (K = ((63 & t) << 26 | d >>> 6) ^ DA(d, t, 3) ^ n) + B | 0, B = (h ^ y ^ t >>> 6) + I | 0, B = n >>> 0 < K >>> 0 ? B + 1 | 0 : B, y = o[Y >> 2], Y = I = o[Y + 4 >> 2], I = DA(y, I, 63), K = h, I = DA(y, Y, 56) ^ I, N = n, B = (Y >>> 7 ^ (U = h ^ K)) + B | 0, n = B = (n = ((127 & Y) << 25 | y >>> 7) ^ I) >>> 0 > (K = N + n | 0) >>> 0 ? B + 1 | 0 : B, o[M + 168 >> 2] = K, o[M + 172 >> 2] = B, I = E + Y | 0, I = (B = y + H | 0) >>> 0 < y >>> 0 ? I + 1 | 0 : I, N = y = o[b + 4 >> 2], y = DA(U = o[b >> 2], y, 63), Y = h, y = (b = ((127 & N) << 25 | U >>> 7) ^ DA(U, N, 56) ^ y) + B | 0, B = (h ^ Y ^ N >>> 7) + I | 0, I = y >>> 0 < b >>> 0 ? B + 1 | 0 : B, B = DA(P, s, 45), Y = h, B = DA(P, s, 3) ^ B, b = h ^ Y, Y = y, I = (s >>> 6 ^ b) + I | 0, y = I = (y = ((63 & s) << 26 | P >>> 6) ^ B) >>> 0 > (Y = Y + y | 0) >>> 0 ? I + 1 | 0 : I, o[M + 176 >> 2] = Y, o[M + 180 >> 2] = I, u = o[R >> 2], R = I = o[R + 4 >> 2], b = I, I = DA(x, D, 63), B = h, m = ((127 & D) << 25 | x >>> 7) ^ DA(x, D, 56) ^ I, I = (h ^ B ^ D >>> 7) + f | 0, B = ((k = m + k | 0) >>> 0 < m >>> 0 ? I + 1 | 0 : I) + b | 0, B = (I = k + u | 0) >>> 0 < k >>> 0 ? B + 1 | 0 : B, f = DA(Y, y, 45), k = h, b = (f = ((63 & y) << 26 | Y >>> 6) ^ DA(Y, y, 3) ^ f) + I | 0, I = (h ^ k ^ y >>> 6) + B | 0, f = I = f >>> 0 > b >>> 0 ? I + 1 | 0 : I, o[M + 192 >> 2] = b, o[M + 196 >> 2] = I, B = i + N | 0, B = (I = S + U | 0) >>> 0 < U >>> 0 ? B + 1 | 0 : B, k = DA(u, R, 63), U = h, N = ((127 & R) << 25 | u >>> 7) ^ DA(u, R, 56) ^ k, B = (h ^ U ^ R >>> 7) + B | 0, I = (k = N + I | 0) >>> 0 < N >>> 0 ? B + 1 | 0 : B, B = DA(K, n, 45), U = h, B = DA(K, n, 3) ^ B, R = k, I = (n >>> 6 ^ (N = h ^ U)) + I | 0, k = I = (k = ((63 & n) << 26 | K >>> 6) ^ B) >>> 0 > (U = R + k | 0) >>> 0 ? I + 1 | 0 : I, o[M + 184 >> 2] = U, o[M + 188 >> 2] = I, I = DA(J, e, 63), B = h, I = ((127 & e) << 25 | J >>> 7) ^ DA(J, e, 56) ^ I, B = (h ^ B ^ e >>> 7) + c | 0, I = t + (I >>> 0 > (N = I + _ | 0) >>> 0 ? B + 1 | 0 : B) | 0, I = (B = d + N | 0) >>> 0 < d >>> 0 ? I + 1 | 0 : I, t = DA(b, f, 45), d = h, t = DA(b, f, 3) ^ t, N = h ^ d, d = (t ^= (63 & f) << 26 | b >>> 6) + B | 0, B = (f >>> 6 ^ N) + I | 0, t = B = t >>> 0 > d >>> 0 ? B + 1 | 0 : B, o[M + 208 >> 2] = d, o[M + 212 >> 2] = B, I = DA(_, c, 63), B = h, N = DA(_, c, 56) ^ I, B = ((I = c >>> 7 | 0) ^ h ^ B) + D | 0, I = r + ((c = (_ = N ^ ((127 & c) << 25 | _ >>> 7)) + x | 0) >>> 0 < _ >>> 0 ? B + 1 | 0 : B) | 0, I = (B = c + p | 0) >>> 0 < p >>> 0 ? I + 1 | 0 : I, D = DA(U, k, 45), c = h, r = (D = ((63 & k) << 26 | U >>> 6) ^ DA(U, k, 3) ^ D) + B | 0, B = (h ^ c ^ k >>> 6) + I | 0, D = B = D >>> 0 > r >>> 0 ? B + 1 | 0 : B, o[M + 200 >> 2] = r, o[M + 204 >> 2] = B, I = DA(L, F, 63), B = h, _ = ((127 & F) << 25 | L >>> 7) ^ DA(L, F, 56) ^ I, I = (h ^ B ^ F >>> 7) + w | 0, B = n + ((c = _ + v | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I) | 0, B = (I = c + K | 0) >>> 0 < K >>> 0 ? B + 1 | 0 : B, c = DA(d, t, 45), n = h, _ = I, I = t >>> 6 | 0, c = ((63 & t) << 26 | d >>> 6) ^ DA(d, t, 3) ^ c, B = (I ^ h ^ n) + B | 0, c = B = c >>> 0 > (t = _ + c | 0) >>> 0 ? B + 1 | 0 : B, o[M + 224 >> 2] = t, o[M + 228 >> 2] = B, I = DA(v, w, 63), B = h, I = DA(v, w, 56) ^ I, n = h ^ B, _ = ((127 & w) << 25 | v >>> 7) ^ I, I = ((B = w >>> 7 | 0) ^ n) + e | 0, B = s + ((w = _ + J | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I) | 0, B = (I = w + P | 0) >>> 0 < P >>> 0 ? B + 1 | 0 : B, e = DA(r, D, 45), w = h, n = I, I = D >>> 6 | 0, D = ((63 & D) << 26 | r >>> 6) ^ DA(r, D, 3) ^ e, I = (I ^ h ^ w) + B | 0, D = I = (e = n + D | 0) >>> 0 < D >>> 0 ? I + 1 | 0 : I, o[M + 216 >> 2] = e, o[M + 220 >> 2] = I, I = DA(H, E, 63), B = h, w = ((127 & E) << 25 | H >>> 7) ^ DA(H, E, 56) ^ I, B = (h ^ B ^ E >>> 7) + Q | 0, B = k + ((I = w + G | 0) >>> 0 < w >>> 0 ? B + 1 | 0 : B) | 0, I = (r = I + U | 0) >>> 0 < U >>> 0 ? B + 1 | 0 : B, B = DA(t, c, 45), w = h, n = r, r = DA(t, c, 3) ^ B, B = c >>> 6 | 0, c = n + (r ^= (63 & c) << 26 | t >>> 6) | 0, I = (B ^ h ^ w) + I | 0, o[M + 240 >> 2] = c, o[M + 244 >> 2] = c >>> 0 < r >>> 0 ? I + 1 | 0 : I, I = DA(G, Q, 63), B = h, I = DA(G, Q, 56) ^ I, c = h ^ B, B = ((B = Q >>> 7 | 0) ^ c) + F | 0, I = y + ((I ^= (127 & Q) << 25 | G >>> 7) >>> 0 > (Q = I + L | 0) >>> 0 ? B + 1 | 0 : B) | 0, I = (B = Q + Y | 0) >>> 0 < Y >>> 0 ? I + 1 | 0 : I, Q = DA(e, D, 45), c = h, r = B, B = D >>> 6 | 0, Q = ((63 & D) << 26 | e >>> 6) ^ DA(e, D, 3) ^ Q, B = (B ^ h ^ c) + I | 0, Q = B = Q >>> 0 > (D = r + Q | 0) >>> 0 ? B + 1 | 0 : B, o[M + 232 >> 2] = D, o[M + 236 >> 2] = B, I = DA(S, i, 63), B = h, r = DA(S, i, 56) ^ I, B = ((I = i >>> 7 | 0) ^ h ^ B) + E | 0, I = f + ((i = (c = r ^ ((127 & i) << 25 | S >>> 7)) + H | 0) >>> 0 < c >>> 0 ? B + 1 | 0 : B) | 0, I = (B = i + b | 0) >>> 0 < b >>> 0 ? I + 1 | 0 : I, i = DA(D, Q, 45), E = h, r = B, B = Q >>> 6 | 0, Q = r + (i = ((63 & Q) << 26 | D >>> 6) ^ DA(D, Q, 3) ^ i) | 0, B = (B ^ h ^ E) + I | 0, o[M + 248 >> 2] = Q, o[M + 252 >> 2] = Q >>> 0 < i >>> 0 ? B + 1 | 0 : B;
                                        I = I + o[A + 4 >> 2] | 0, I = (g = Q + o[A >> 2] | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, o[A >> 2] = g, o[A + 4 >> 2] = I, B = o[A + 12 >> 2] + o[C + 12 >> 2] | 0, I = (g = o[C + 8 >> 2]) + o[A + 8 >> 2] | 0, o[A + 8 >> 2] = I, o[A + 12 >> 2] = I >>> 0 < g >>> 0 ? B + 1 | 0 : B, B = o[A + 20 >> 2] + o[C + 20 >> 2] | 0, I = (g = o[C + 16 >> 2]) + o[A + 16 >> 2] | 0, o[A + 16 >> 2] = I, o[A + 20 >> 2] = I >>> 0 < g >>> 0 ? B + 1 | 0 : B, I = o[A + 28 >> 2] + o[C + 28 >> 2] | 0, g = (B = o[C + 24 >> 2]) + o[A + 24 >> 2] | 0, o[A + 24 >> 2] = g, o[A + 28 >> 2] = g >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = o[A + 36 >> 2] + o[C + 36 >> 2] | 0, I = (g = o[C + 32 >> 2]) + o[A + 32 >> 2] | 0, o[A + 32 >> 2] = I, o[A + 36 >> 2] = I >>> 0 < g >>> 0 ? B + 1 | 0 : B, I = o[A + 44 >> 2] + o[C + 44 >> 2] | 0, g = (B = o[C + 40 >> 2]) + o[A + 40 >> 2] | 0, o[A + 40 >> 2] = g, o[A + 44 >> 2] = g >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = o[A + 52 >> 2] + o[C + 52 >> 2] | 0, I = (g = o[C + 48 >> 2]) + o[A + 48 >> 2] | 0, o[A + 48 >> 2] = I, o[A + 52 >> 2] = I >>> 0 < g >>> 0 ? B + 1 | 0 : B, B = o[A + 60 >> 2] + o[C + 60 >> 2] | 0, I = (g = o[C + 56 >> 2]) + o[A + 56 >> 2] | 0, o[A + 56 >> 2] = I, o[A + 60 >> 2] = I >>> 0 < g >>> 0 ? B + 1 | 0 : B;
                                    }
                                    function F(A) {
                                        var I, g, C, B, Q, i, o, f, c, e, r = 0, D = 0, t = 0, y = 0, w = 0, n = 0, s = 0, k = 0, F = 0, S = 0, H = 0, G = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, U = 0, Y = 0, d = 0, K = 0, b = 0, P = 0, v = 0, L = 0, R = 0, u = 0, x = 0, m = 0, l = 0, z = 0, q = 0, X = 0, j = 0, T = 0, O = 0, V = 0, Z = 0;
                                        y = (G = a[A + 44 | 0] | a[A + 45 | 0] << 8 | a[A + 46 | 0] << 16 | a[A + 47 | 0] << 24) >>> 5 & 2097151, t = kA(b = (a[A + 60 | 0] | a[A + 61 | 0] << 8 | a[A + 62 | 0] << 16 | a[A + 63 | 0] << 24) >>> 3 | 0, 0, -683901, -1), D = (r = a[A + 44 | 0]) << 16 & 2031616 | a[A + 42 | 0] | a[A + 43 | 0] << 8, r = h, k = r = D >>> 0 > (F = t + D | 0) >>> 0 ? r + 1 | 0 : r, N = r = r - ((F >>> 0 < 4293918720) - 1 | 0) | 0, t = r >> 21, r = (D = y) + (y = (2097151 & r) << 11 | (n = F - -1048576 | 0) >>> 21) | 0, D = t, l = D = r >>> 0 < y >>> 0 ? D + 1 | 0 : D, z = r, Y = kA(r, D, -683901, -1), S = h, s = kA(I = (a[A + 49 | 0] | a[A + 50 | 0] << 8 | a[A + 51 | 0] << 16 | a[A + 52 | 0] << 24) >>> 7 & 2097151, 0, -997805, -1), t = (r = a[A + 27 | 0]) >>> 24 | 0, y = r << 8 | (_ = a[A + 23 | 0] | a[A + 24 | 0] << 8 | a[A + 25 | 0] << 16 | a[A + 26 | 0] << 24) >>> 24, D = (r = a[A + 28 | 0]) >>> 16 | 0, D = 2097151 & ((3 & (D |= t)) << 30 | (r = y | r << 16) >>> 2), r = h, r = D >>> 0 > (t = D + s | 0) >>> 0 ? r + 1 | 0 : r, D = kA(u = (M = a[A + 52 | 0] | a[A + 53 | 0] << 8 | a[A + 54 | 0] << 16 | a[A + 55 | 0] << 24) >>> 4 & 2097151, 0, 654183, 0), r = h + r | 0, s = t = D + t | 0, t = D >>> 0 > t >>> 0 ? r + 1 | 0 : r, w = (D = a[A + 48 | 0]) << 8 | G >>> 24, D = r = D >>> 24 | 0, r = kA(g = 2097151 & ((3 & (G = (r = (y = a[A + 49 | 0]) >>> 16 | 0) | D)) << 30 | (D = (y <<= 16) | w) >>> 2), 0, 136657, 0), t = h + t | 0, t = r >>> 0 > (D = r + s | 0) >>> 0 ? t + 1 | 0 : t, y = (r = kA(C = (a[A + 57 | 0] | a[A + 58 | 0] << 8 | a[A + 59 | 0] << 16 | a[A + 60 | 0] << 24) >>> 6 & 2097151, 0, 666643, 0)) + D | 0, D = h + t | 0, s = y, t = r >>> 0 > y >>> 0 ? D + 1 | 0 : D, D = (r = a[A + 56 | 0]) >>> 24 | 0, w = r << 8 | M >>> 24, D = kA(B = 2097151 & ((1 & (M = (r = (y = a[A + 57 | 0]) >>> 16 | 0) | D)) << 31 | (D = (y <<= 16) | w) >>> 1), 0, 470296, 0), r = h + t | 0, D = (r = (t = y = D + s | 0) >>> 0 < D >>> 0 ? r + 1 | 0 : r) + S | 0, D = t >>> 0 > (y = t + Y | 0) >>> 0 ? D + 1 | 0 : D, J = t - -1048576 | 0, U = t = r - ((t >>> 0 < 4293918720) - 1 | 0) | 0, S = y - (r = -2097152 & J) | 0, Y = D - ((r >>> 0 > y >>> 0) + t | 0) | 0, D = kA(I, 0, 654183, 0), r = h, r = D >>> 0 > (t = D + (_ >>> 5 & 2097151) | 0) >>> 0 ? r + 1 | 0 : r, y = (D = t) + (t = kA(u, 0, 470296, 0)) | 0, D = h + r | 0, D = t >>> 0 > y >>> 0 ? D + 1 | 0 : D, r = kA(g, X, -997805, -1), D = h + D | 0, D = r >>> 0 > (t = r + y | 0) >>> 0 ? D + 1 | 0 : D, y = (r = t) + (t = kA(B, j, 666643, 0)) | 0, r = h + D | 0, w = y, y = t >>> 0 > y >>> 0 ? r + 1 | 0 : r, s = (t = kA(I, 0, 470296, 0)) + (r = (r = a[A + 23 | 0]) << 16 & 2031616 | a[A + 21 | 0] | a[A + 22 | 0] << 8) | 0, t = h, t = r >>> 0 > s >>> 0 ? t + 1 | 0 : t, s = (D = kA(u, 0, 666643, 0)) + s | 0, r = h + t | 0, t = kA(g, X, 654183, 0), D = h + (D >>> 0 > s >>> 0 ? r + 1 | 0 : r) | 0, M = D = t >>> 0 > (_ = t + s | 0) >>> 0 ? D + 1 | 0 : D, R = D = D - ((_ >>> 0 < 4293918720) - 1 | 0) | 0, r = (r = D >>> 21 | 0) + y | 0, t = r = (D = (2097151 & D) << 11 | (s = _ - -1048576 | 0) >>> 21) >>> 0 > (w = D + w | 0) >>> 0 ? r + 1 | 0 : r, H = D = r - ((w >>> 0 < 4293918720) - 1 | 0) | 0, r = S, S = (2097151 & D) << 11 | (y = w - -1048576 | 0) >>> 21, D = (D >> 21) + Y | 0, G = S = (D = S >>> 0 > (p = r + S | 0) >>> 0 ? D + 1 | 0 : D) - ((p >>> 0 < 4293918720) - 1 | 0) | 0, x = p - (r = -2097152 & (Y = p - -1048576 | 0)) | 0, T = D - ((r >>> 0 > p >>> 0) + S | 0) | 0, r = kA(z, l, 136657, 0), t = h + t | 0, t = r >>> 0 > (D = r + w | 0) >>> 0 ? t + 1 | 0 : t, K = D - (r = -2097152 & y) | 0, m = t - ((r >>> 0 > D >>> 0) + H | 0) | 0, p = F - (r = -2097152 & n) | 0, N = k - ((r >>> 0 > F >>> 0) + N | 0) | 0, k = kA(b, 0, 136657, 0), D = (r = a[A + 40 | 0]) >>> 24 | 0, y = r << 8 | (n = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24) >>> 24, t = (r = a[A + 41 | 0]) >>> 16 | 0, D = (t |= D) >>> 3 | 0, t = (7 & t) << 29 | (r = y | r << 16) >>> 3, r = D + h | 0, r = t >>> 0 > (y = t + k | 0) >>> 0 ? r + 1 | 0 : r, D = kA(C, 0, -683901, -1), r = h + r | 0, r = D >>> 0 > (t = D + y | 0) >>> 0 ? r + 1 | 0 : r, w = t, D = kA(b, 0, -997805, -1), t = h, t = D >>> 0 > (y = D + (n >>> 6 & 2097151) | 0) >>> 0 ? t + 1 | 0 : t, n = (D = y) + (y = kA(C, 0, 136657, 0)) | 0, D = h + t | 0, t = kA(B, j, -683901, -1), D = h + (y >>> 0 > n >>> 0 ? D + 1 | 0 : D) | 0, S = D = t >>> 0 > (P = t + n | 0) >>> 0 ? D + 1 | 0 : D, O = t = D - ((P >>> 0 < 4293918720) - 1 | 0) | 0, r = r + (D = t >> 21) | 0, n = r = (t = (2097151 & t) << 11 | (F = P - -1048576 | 0) >>> 21) >>> 0 > (H = t + w | 0) >>> 0 ? r + 1 | 0 : r, v = r = r - ((H >>> 0 < 4293918720) - 1 | 0) | 0, D = (D = r >> 21) + N | 0, q = D = (r = (t = (2097151 & r) << 11 | (w = H - -1048576 | 0) >>> 21) + p | 0) >>> 0 < t >>> 0 ? D + 1 | 0 : D, L = r, D = kA(r, D, -683901, -1), r = h + m | 0, d = t = D + K | 0, y = D >>> 0 > t >>> 0 ? r + 1 | 0 : r, m = _ - (r = -2097152 & s) | 0, N = M - ((4095 & R) + (r >>> 0 > _ >>> 0) | 0) | 0, _ = kA(I, 0, 666643, 0), r = (D = a[A + 19 | 0]) >>> 24 | 0, s = D << 8 | (M = a[A + 15 | 0] | a[A + 16 | 0] << 8 | a[A + 17 | 0] << 16 | a[A + 18 | 0] << 24) >>> 24, t = r, D = (7 & (t |= D = (r = a[A + 20 | 0]) >>> 16 | 0)) << 29 | (D = (r <<= 16) | s) >>> 3, t = h + (t >>> 3 | 0) | 0, t = D >>> 0 > (s = D + _ | 0) >>> 0 ? t + 1 | 0 : t, r = kA(g, X, 470296, 0), D = h + t | 0, r = r >>> 0 > (s = r + s | 0) >>> 0 ? D + 1 | 0 : D, t = kA(g, X, 666643, 0), D = h, _ = D = t >>> 0 > (K = t + (M >>> 6 & 2097151) | 0) >>> 0 ? D + 1 | 0 : D, V = t = D - ((K >>> 0 < 4293918720) - 1 | 0) | 0, r = r + (D = t >>> 21 | 0) | 0, M = r = (t = (2097151 & t) << 11 | (k = K - -1048576 | 0) >>> 21) >>> 0 > (p = t + s | 0) >>> 0 ? r + 1 | 0 : r, Z = r = r - ((p >>> 0 < 4293918720) - 1 | 0) | 0, D = (D = r >>> 21 | 0) + N | 0, D = (r = (2097151 & r) << 11 | (s = p - -1048576 | 0) >>> 21) >>> 0 > (t = r + m | 0) >>> 0 ? D + 1 | 0 : D, N = (r = t) + (t = kA(z, l, -997805, -1)) | 0, r = h + D | 0, r = t >>> 0 > N >>> 0 ? r + 1 | 0 : r, R = D = H - (t = -2097152 & w) | 0, Q = w = n - ((t >>> 0 > H >>> 0) + v | 0) | 0, t = kA(L, q, 136657, 0), r = h + r | 0, r = t >>> 0 > (n = t + N | 0) >>> 0 ? r + 1 | 0 : r, t = kA(D, w, -683901, -1), D = h + r | 0, n = D = t >>> 0 > (N = t + n | 0) >>> 0 ? D + 1 | 0 : D, v = r = D - ((N >>> 0 < 4293918720) - 1 | 0) | 0, D = (2097151 & r) << 11 | (w = N - -1048576 | 0) >>> 21, r = (r >> 21) + y | 0, d = D = (r = D >>> 0 > (H = D + d | 0) >>> 0 ? r + 1 | 0 : r) - ((H >>> 0 < 4293918720) - 1 | 0) | 0, m = (2097151 & D) << 11 | (y = H - -1048576 | 0) >>> 21, D = (D >> 21) + T | 0, o = x = m + x | 0, m = x >>> 0 < m >>> 0 ? D + 1 | 0 : D, f = H - (D = -2097152 & y) | 0, c = r - ((D >>> 0 > H >>> 0) + d | 0) | 0, x = N - (r = -2097152 & w) | 0, T = n - ((r >>> 0 > N >>> 0) + v | 0) | 0, t = (r = kA(z, l, 654183, 0)) + (p - (D = -2097152 & s) | 0) | 0, D = h + (M - ((2147483647 & Z) + (D >>> 0 > p >>> 0) | 0) | 0) | 0, D = r >>> 0 > t >>> 0 ? D + 1 | 0 : D, r = kA(L, q, -997805, -1), D = h + D | 0, D = r >>> 0 > (t = r + t | 0) >>> 0 ? D + 1 | 0 : D, y = (r = t) + (t = kA(R, Q, 136657, 0)) | 0, r = h + D | 0, d = y, n = t >>> 0 > y >>> 0 ? r + 1 | 0 : r, p = P - (r = -2097152 & F) | 0, H = S - ((r >>> 0 > P >>> 0) + O | 0) | 0, M = kA(u, 0, -683901, -1), r = (D = a[A + 35 | 0]) >>> 24 | 0, y = D << 8 | (s = a[A + 31 | 0] | a[A + 32 | 0] << 8 | a[A + 33 | 0] << 16 | a[A + 34 | 0] << 24) >>> 24, t = r, D = (r = a[A + 36 | 0]) >>> 16 | 0, D |= t, t = h, t = (r = 2097151 & ((1 & D) << 31 | (r = r << 16 | y) >>> 1)) >>> 0 > (D = r + M | 0) >>> 0 ? t + 1 | 0 : t, y = (r = kA(b, 0, 654183, 0)) + D | 0, D = h + t | 0, D = r >>> 0 > y >>> 0 ? D + 1 | 0 : D, t = kA(C, 0, -997805, -1), r = h + D | 0, r = t >>> 0 > (y = t + y | 0) >>> 0 ? r + 1 | 0 : r, D = kA(B, j, 136657, 0), r = h + r | 0, w = t = D + y | 0, y = D >>> 0 > t >>> 0 ? r + 1 | 0 : r, r = kA(I, 0, -683901, -1), D = h, D = r >>> 0 > (t = r + (s >>> 4 & 2097151) | 0) >>> 0 ? D + 1 | 0 : D, s = (r = kA(u, 0, 136657, 0)) + t | 0, t = h + D | 0, t = r >>> 0 > s >>> 0 ? t + 1 | 0 : t, r = kA(b, 0, 470296, 0), D = h + t | 0, D = r >>> 0 > (s = r + s | 0) >>> 0 ? D + 1 | 0 : D, s = (t = kA(C, 0, 654183, 0)) + s | 0, r = h + D | 0, D = kA(B, j, -997805, -1), r = h + (t >>> 0 > s >>> 0 ? r + 1 | 0 : r) | 0, M = r = D >>> 0 > (S = D + s | 0) >>> 0 ? r + 1 | 0 : r, e = D = r - ((S >>> 0 < 4293918720) - 1 | 0) | 0, t = (r = D >> 21) + y | 0, N = D = (t = (D = (2097151 & D) << 11 | (s = S - -1048576 | 0) >>> 21) >>> 0 > (F = D + w | 0) >>> 0 ? t + 1 | 0 : t) - ((F >>> 0 < 4293918720) - 1 | 0) | 0, r = (r = D >> 21) + H | 0, v = r = (D = (y = (2097151 & D) << 11 | (w = F - -1048576 | 0) >>> 21) + p | 0) >>> 0 < y >>> 0 ? r + 1 | 0 : r, y = d, d = D, r = kA(D, r, -683901, -1), D = h + n | 0, H = y = y + r | 0, y = r >>> 0 > y >>> 0 ? D + 1 | 0 : D, n = (r = kA(z, l, 470296, 0)) + (K - (D = -2097152 & k) | 0) | 0, D = h + (_ - ((2047 & V) + (D >>> 0 > K >>> 0) | 0) | 0) | 0, D = r >>> 0 > n >>> 0 ? D + 1 | 0 : D, k = (r = n) + (n = kA(L, q, 654183, 0)) | 0, r = h + D | 0, r = n >>> 0 > k >>> 0 ? r + 1 | 0 : r, n = kA(R, Q, -997805, -1), D = h + r | 0, D = n >>> 0 > (k = n + k | 0) >>> 0 ? D + 1 | 0 : D, P = w = F - (r = -2097152 & w) | 0, i = n = t - ((r >>> 0 > F >>> 0) + N | 0) | 0, t = kA(d, v, 136657, 0), r = h + D | 0, r = t >>> 0 > (k = t + k | 0) >>> 0 ? r + 1 | 0 : r, t = kA(w, n, -683901, -1), D = h + r | 0, n = D = t >>> 0 > (_ = t + k | 0) >>> 0 ? D + 1 | 0 : D, N = r = D - ((_ >>> 0 < 4293918720) - 1 | 0) | 0, D = (2097151 & r) << 11 | (w = _ - -1048576 | 0) >>> 21, r = (r >> 21) + y | 0, H = D = (r = D >>> 0 > (k = D + H | 0) >>> 0 ? r + 1 | 0 : r) - ((k >>> 0 < 4293918720) - 1 | 0) | 0, F = (2097151 & D) << 11 | (y = k - -1048576 | 0) >>> 21, D = (D >> 21) + T | 0, O = p = F + x | 0, p = F >>> 0 > p >>> 0 ? D + 1 | 0 : D, V = k - (D = -2097152 & y) | 0, Z = r - ((D >>> 0 > k >>> 0) + H | 0) | 0, x = _ - (r = -2097152 & w) | 0, T = n - ((r >>> 0 > _ >>> 0) + N | 0) | 0, n = kA(z, l, 666643, 0), r = (D = a[A + 14 | 0]) >>> 24 | 0, y = D << 8 | (N = a[A + 10 | 0] | a[A + 11 | 0] << 8 | a[A + 12 | 0] << 16 | a[A + 13 | 0] << 24) >>> 24, t = r, D = (r = a[A + 15 | 0]) >>> 16 | 0, D |= t, t = h, t = (r = 2097151 & ((1 & D) << 31 | (r = r << 16 | y) >>> 1)) >>> 0 > (D = r + n | 0) >>> 0 ? t + 1 | 0 : t, y = (r = D) + (D = kA(L, q, 470296, 0)) | 0, r = h + t | 0, r = D >>> 0 > y >>> 0 ? r + 1 | 0 : r, D = kA(R, Q, 654183, 0), r = h + r | 0, r = D >>> 0 > (t = D + y | 0) >>> 0 ? r + 1 | 0 : r, y = (D = t) + (t = kA(d, v, -997805, -1)) | 0, D = h + r | 0, D = t >>> 0 > y >>> 0 ? D + 1 | 0 : D, r = kA(P, i, 136657, 0), D = h + D | 0, _ = t = r + y | 0, y = r >>> 0 > t >>> 0 ? D + 1 | 0 : D, s = S - (r = -2097152 & s) | 0, n = M - ((r >>> 0 > S >>> 0) + e | 0) | 0, t = kA(I, 0, 136657, 0), r = h, r = (D = (a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24) >>> 7 & 2097151) >>> 0 > (t = D + t | 0) >>> 0 ? r + 1 | 0 : r, w = (D = t) + (t = kA(u, 0, -997805, -1)) | 0, D = h + r | 0, D = t >>> 0 > w >>> 0 ? D + 1 | 0 : D, r = kA(g, X, -683901, -1), D = h + D | 0, D = r >>> 0 > (t = r + w | 0) >>> 0 ? D + 1 | 0 : D, w = (r = kA(b, 0, 666643, 0)) + t | 0, t = h + D | 0, t = r >>> 0 > w >>> 0 ? t + 1 | 0 : t, D = kA(C, 0, 470296, 0), r = h + t | 0, r = D >>> 0 > (w = D + w | 0) >>> 0 ? r + 1 | 0 : r, D = kA(B, j, 654183, 0), r = h + r | 0, D = (U >> 21) + (D >>> 0 > (t = D + w | 0) >>> 0 ? r + 1 | 0 : r) | 0, F = D = (w = (2097151 & U) << 11 | J >>> 21) >>> 0 > (J = w + t | 0) >>> 0 ? D + 1 | 0 : D, H = r = D - ((J >>> 0 < 4293918720) - 1 | 0) | 0, w = (2097151 & r) << 11 | (k = J - -1048576 | 0) >>> 21, r = (r >> 21) + n | 0, K = r = (D = w + s | 0) >>> 0 < w >>> 0 ? r + 1 | 0 : r, U = D, D = kA(D, r, -683901, -1), r = h + y | 0, w = t = D + _ | 0, y = D >>> 0 > t >>> 0 ? r + 1 | 0 : r, r = kA(L, q, 666643, 0), D = h, D = r >>> 0 > (t = r + (N >>> 4 & 2097151) | 0) >>> 0 ? D + 1 | 0 : D, r = kA(R, Q, 470296, 0), D = h + D | 0, D = r >>> 0 > (t = r + t | 0) >>> 0 ? D + 1 | 0 : D, n = (r = kA(d, v, 654183, 0)) + t | 0, t = h + D | 0, t = r >>> 0 > n >>> 0 ? t + 1 | 0 : t, D = kA(P, i, -997805, -1), r = h + t | 0, r = D >>> 0 > (n = D + n | 0) >>> 0 ? r + 1 | 0 : r, D = kA(U, K, 136657, 0), r = h + r | 0, M = r = D >>> 0 > (S = D + n | 0) >>> 0 ? r + 1 | 0 : r, l = D = r - ((S >>> 0 < 4293918720) - 1 | 0) | 0, r = w, w = (2097151 & D) << 11 | (s = S - -1048576 | 0) >>> 21, D = (D >> 21) + y | 0, L = y = (D = (t = r + w | 0) >>> 0 < w >>> 0 ? D + 1 | 0 : D) - ((t >>> 0 < 4293918720) - 1 | 0) | 0, r = (r = y >> 21) + T | 0, z = w = (y = (2097151 & y) << 11 | (n = t - -1048576 | 0) >>> 21) + x | 0, _ = y >>> 0 > w >>> 0 ? r + 1 | 0 : r, w = t, t = D, y = (J - (D = -2097152 & k) | 0) + (k = (2097151 & G) << 11 | Y >>> 21) | 0, D = (F - ((D >>> 0 > J >>> 0) + H | 0) | 0) + (G >> 21) | 0, N = D = y >>> 0 < k >>> 0 ? D + 1 | 0 : D, u = D = D - ((y >>> 0 < 4293918720) - 1 | 0) | 0, Y = r = D >> 21, r = kA(b = (2097151 & D) << 11 | (H = y - -1048576 | 0) >>> 21, r, -683901, -1), t = h + t | 0, t = r >>> 0 > (D = r + w | 0) >>> 0 ? t + 1 | 0 : t, X = D - (r = -2097152 & n) | 0, j = t - ((r >>> 0 > D >>> 0) + L | 0) | 0, r = kA(b, Y, 136657, 0), D = M + h | 0, q = (t = r + S | 0) - (r = -2097152 & s) | 0, L = (D = t >>> 0 < S >>> 0 ? D + 1 | 0 : D) - ((r >>> 0 > t >>> 0) + l | 0) | 0, D = kA(R, Q, 666643, 0), t = h, t = (r = (a[A + 7 | 0] | a[A + 8 | 0] << 8 | a[A + 9 | 0] << 16 | a[A + 10 | 0] << 24) >>> 7 & 2097151) >>> 0 > (D = r + D | 0) >>> 0 ? t + 1 | 0 : t, w = (r = kA(d, v, 470296, 0)) + D | 0, D = h + t | 0, D = r >>> 0 > w >>> 0 ? D + 1 | 0 : D, r = kA(P, i, 654183, 0), D = h + D | 0, D = r >>> 0 > (t = r + w | 0) >>> 0 ? D + 1 | 0 : D, w = (r = t) + (t = kA(U, K, -997805, -1)) | 0, r = h + D | 0, k = w, w = t >>> 0 > w >>> 0 ? r + 1 | 0 : r, M = kA(d, v, 666643, 0), r = (D = a[A + 6 | 0]) >>> 24 | 0, n = D << 8 | (J = a[A + 2 | 0] | a[A + 3 | 0] << 8 | a[A + 4 | 0] << 16 | a[A + 5 | 0] << 24) >>> 24, t = r, D = (r = a[A + 7 | 0]) >>> 16 | 0, D = 2097151 & ((3 & (D |= t)) << 30 | (r = r << 16 | n) >>> 2), r = h, r = D >>> 0 > (t = D + M | 0) >>> 0 ? r + 1 | 0 : r, n = (D = kA(P, i, 470296, 0)) + t | 0, t = h + r | 0, t = D >>> 0 > n >>> 0 ? t + 1 | 0 : t, D = kA(U, K, 654183, 0), r = h + t | 0, M = r = D >>> 0 > (F = D + n | 0) >>> 0 ? r + 1 | 0 : r, G = r = r - ((F >>> 0 < 4293918720) - 1 | 0) | 0, D = (t = r >> 21) + w | 0, S = r = (D = (r = (2097151 & r) << 11 | (s = F - -1048576 | 0) >>> 21) >>> 0 > (n = r + k | 0) >>> 0 ? D + 1 | 0 : D) - ((n >>> 0 < 4293918720) - 1 | 0) | 0, k = (2097151 & r) << 11 | (w = n - -1048576 | 0) >>> 21, r = (r >> 21) + L | 0, L = d = k + q | 0, k = k >>> 0 > d >>> 0 ? r + 1 | 0 : r, r = kA(b, Y, -997805, -1), D = h + D | 0, D = r >>> 0 > (t = r + n | 0) >>> 0 ? D + 1 | 0 : D, R = t - (r = -2097152 & w) | 0, v = D - ((r >>> 0 > t >>> 0) + S | 0) | 0, D = kA(b, Y, 654183, 0), r = M + h | 0, d = (t = D + F | 0) - (D = -2097152 & s) | 0, G = (r = t >>> 0 < F >>> 0 ? r + 1 | 0 : r) - ((D >>> 0 > t >>> 0) + G | 0) | 0, r = kA(P, i, 666643, 0), D = h, D = r >>> 0 > (t = r + (J >>> 5 & 2097151) | 0) >>> 0 ? D + 1 | 0 : D, r = kA(U, K, 470296, 0), D = h + D | 0, n = t = r + t | 0, t = r >>> 0 > t >>> 0 ? D + 1 | 0 : D, w = kA(U, K, 666643, 0), D = (r = a[A + 2 | 0]) << 16 & 2031616 | a[0 | A] | a[A + 1 | 0] << 8, r = h, M = r = D >>> 0 > (S = w + D | 0) >>> 0 ? r + 1 | 0 : r, K = r = r - ((S >>> 0 < 4293918720) - 1 | 0) | 0, w = (2097151 & r) << 11 | (s = S - -1048576 | 0) >>> 21, r = (r >> 21) + t | 0, t = r = w >>> 0 > (F = w + n | 0) >>> 0 ? r + 1 | 0 : r, J = r = r - ((F >>> 0 < 4293918720) - 1 | 0) | 0, w = (2097151 & r) << 11 | (n = F - -1048576 | 0) >>> 21, r = (r >> 21) + G | 0, w = w >>> 0 > (G = U = w + d | 0) >>> 0 ? r + 1 | 0 : r, r = kA(b, Y, 470296, 0), t = t + h | 0, t = (D = r + F | 0) >>> 0 < F >>> 0 ? t + 1 | 0 : t, F = D - (r = -2097152 & n) | 0, n = t - ((r >>> 0 > D >>> 0) + J | 0) | 0, D = kA(b, Y, 666643, 0), r = h + (M - (((t = -2097152 & s) >>> 0 > S >>> 0) + K | 0) | 0) | 0, D = (t = (r = D >>> 0 > (U = D + (S - t | 0) | 0) >>> 0 ? r + 1 | 0 : r) >> 21) + n | 0, r = (r = (D = (r = (2097151 & r) << 11 | U >>> 21) >>> 0 > (J = r + F | 0) >>> 0 ? D + 1 | 0 : D) >> 21) + w | 0, D = (D = (r = (D = (2097151 & D) << 11 | J >>> 21) >>> 0 > (G = D + G | 0) >>> 0 ? r + 1 | 0 : r) >> 21) + v | 0, t = (r = (D = (r = (2097151 & r) << 11 | G >>> 21) >>> 0 > (w = r + R | 0) >>> 0 ? D + 1 | 0 : D) >> 21) + k | 0, r = (D = (t = (D = (2097151 & D) << 11 | w >>> 21) >>> 0 > (Y = D + L | 0) >>> 0 ? t + 1 | 0 : t) >> 21) + j | 0, D = (t = (r = (t = (2097151 & t) << 11 | Y >>> 21) >>> 0 > (S = t + X | 0) >>> 0 ? r + 1 | 0 : r) >> 21) + _ | 0, r = (r = (D = (r = (2097151 & r) << 11 | S >>> 21) >>> 0 > (F = r + z | 0) >>> 0 ? D + 1 | 0 : D) >> 21) + Z | 0, D = (D = (r = (D = (2097151 & D) << 11 | F >>> 21) >>> 0 > (_ = D + V | 0) >>> 0 ? r + 1 | 0 : r) >> 21) + p | 0, t = (r = (D = (r = (2097151 & r) << 11 | _ >>> 21) >>> 0 > (k = r + O | 0) >>> 0 ? D + 1 | 0 : D) >> 21) + c | 0, r = (D = (t = (D = (2097151 & D) << 11 | k >>> 21) >>> 0 > (M = D + f | 0) >>> 0 ? t + 1 | 0 : t) >> 21) + m | 0, n = (H = y - (D = -2097152 & H) | 0) + ((2097151 & (r = (t = (2097151 & t) << 11 | M >>> 21) >>> 0 > (s = t + o | 0) >>> 0 ? r + 1 | 0 : r)) << 11 | s >>> 21) | 0, r = (N - ((D >>> 0 > y >>> 0) + u | 0) | 0) + (r >> 21) | 0, H = D = (r = n >>> 0 < H >>> 0 ? r + 1 | 0 : r) >> 21, U = (r = kA(p = (2097151 & r) << 11 | n >>> 21, D, 666643, 0)) + (D = 2097151 & U) | 0, r = h, y = r = D >>> 0 > U >>> 0 ? r + 1 | 0 : r, E[0 | A] = U, E[A + 1 | 0] = (255 & r) << 24 | U >>> 8, r = 2097151 & J, D = kA(p, H, 470296, 0) + r | 0, t = h, r = (y >> 21) + (r >>> 0 > D >>> 0 ? t + 1 | 0 : t) | 0, r = (N = (2097151 & y) << 11 | U >>> 21) >>> 0 > (J = N + D | 0) >>> 0 ? r + 1 | 0 : r, E[A + 4 | 0] = (2047 & r) << 21 | J >>> 11, D = r, t = J, E[A + 3 | 0] = (7 & r) << 29 | t >>> 3, E[A + 2 | 0] = 31 & ((65535 & y) << 16 | U >>> 16) | t << 5, y = 2097151 & G, G = kA(p, H, 654183, 0) + y | 0, r = h, J = (2097151 & D) << 11 | t >>> 21, D = (D >> 21) + (y = y >>> 0 > G >>> 0 ? r + 1 | 0 : r) | 0, r = D = (G = J + G | 0) >>> 0 < J >>> 0 ? D + 1 | 0 : D, E[A + 6 | 0] = (63 & r) << 26 | G >>> 6, y = G, G = 0, E[A + 5 | 0] = G << 13 | (1572864 & t) >>> 19 | y << 2, t = 2097151 & w, w = kA(p, H, -997805, -1) + t | 0, D = h, D = t >>> 0 > w >>> 0 ? D + 1 | 0 : D, G = (2097151 & (t = r)) << 11 | y >>> 21, t = (r >>= 21) + D | 0, t = (w = G + w | 0) >>> 0 < G >>> 0 ? t + 1 | 0 : t, E[A + 9 | 0] = (511 & t) << 23 | w >>> 9, E[A + 8 | 0] = (1 & t) << 31 | w >>> 1, D = 0, E[A + 7 | 0] = D << 18 | (2080768 & y) >>> 14 | w << 7, D = 2097151 & Y, y = kA(p, H, 136657, 0) + D | 0, r = h, r = D >>> 0 > y >>> 0 ? r + 1 | 0 : r, Y = (2097151 & (D = t)) << 11 | w >>> 21, D = r + (t = D >> 21) | 0, D = (y = Y + y | 0) >>> 0 < Y >>> 0 ? D + 1 | 0 : D, E[A + 12 | 0] = (4095 & D) << 20 | y >>> 12, t = y, E[A + 11 | 0] = (15 & D) << 28 | t >>> 4, y = 0, E[A + 10 | 0] = y << 15 | (1966080 & w) >>> 17 | t << 4, y = 2097151 & S, w = kA(p, H, -683901, -1) + y | 0, r = h, r = y >>> 0 > w >>> 0 ? r + 1 | 0 : r, y = D, D = r + (D >>= 21) | 0, D = (y = (d = w) + (w = (2097151 & y) << 11 | t >>> 21) | 0) >>> 0 < w >>> 0 ? D + 1 | 0 : D, E[A + 14 | 0] = (127 & D) << 25 | y >>> 7, w = 0, E[A + 13 | 0] = w << 12 | (1048576 & t) >>> 20 | y << 1, r = D >> 21, t = (D = (2097151 & D) << 11 | y >>> 21) >>> 0 > (w = D + (2097151 & F) | 0) >>> 0 ? r + 1 | 0 : r, E[A + 17 | 0] = (1023 & t) << 22 | w >>> 10, E[A + 16 | 0] = (3 & t) << 30 | w >>> 2, D = 0, E[A + 15 | 0] = D << 17 | (2064384 & y) >>> 15 | w << 6, r = t >> 21, r = (D = (2097151 & t) << 11 | w >>> 21) >>> 0 > (t = D + (2097151 & _) | 0) >>> 0 ? r + 1 | 0 : r, E[A + 20 | 0] = (8191 & r) << 19 | t >>> 13, E[A + 19 | 0] = (31 & r) << 27 | t >>> 5, y = (D = 2097151 & k) + (k = (2097151 & r) << 11 | t >>> 21) | 0, D = r >> 21, D = y >>> 0 < k >>> 0 ? D + 1 | 0 : D, k = y, E[A + 21 | 0] = y, _ = 0, E[A + 18 | 0] = _ << 14 | (1835008 & w) >>> 18 | t << 3, E[A + 22 | 0] = (255 & D) << 24 | y >>> 8, t = D >> 21, t = (y = (w = (2097151 & D) << 11 | y >>> 21) + (2097151 & M) | 0) >>> 0 < w >>> 0 ? t + 1 | 0 : t, E[A + 25 | 0] = (2047 & t) << 21 | y >>> 11, E[A + 24 | 0] = (7 & t) << 29 | y >>> 3, E[A + 23 | 0] = 31 & ((65535 & D) << 16 | k >>> 16) | y << 5, r = t >> 21, r = (D = (2097151 & t) << 11 | y >>> 21) >>> 0 > (t = D + (2097151 & s) | 0) >>> 0 ? r + 1 | 0 : r, E[A + 27 | 0] = (63 & r) << 26 | t >>> 6, w = 0, E[A + 26 | 0] = w << 13 | (1572864 & y) >>> 19 | t << 2, D = r >> 21, D = (r = (y = (2097151 & r) << 11 | t >>> 21) + (2097151 & n) | 0) >>> 0 < y >>> 0 ? D + 1 | 0 : D, E[A + 31 | 0] = (131071 & D) << 15 | r >>> 17, E[A + 30 | 0] = (511 & D) << 23 | r >>> 9, E[A + 29 | 0] = (1 & D) << 31 | r >>> 1, y = 0, E[A + 28 | 0] = y << 18 | (2080768 & t) >>> 14 | r << 7;
                                    }
                                    function S(A, I, g, C, B, Q) {
                                        var i, f = 0, e = 0, r = 0, D = 0, t = 0, y = 0, h = 0, n = 0, s = 0, k = 0, S = 0, _ = 0, M = 0, p = 0, J = 0, Y = 0, d = 0, K = 0, L = 0, u = 0, x = 0, m = 0, l = 0, z = 0, q = 0, X = 0, j = 0, T = 0, O = 0, V = 0, Z = 0, $ = 0, AA = 0, IA = 0, gA = 0, CA = 0, BA = 0, QA = 0;
                                        for(w = i = w - 592 | 0, p = -1, S = A + 32 | 0, k = 32, _ = 1; J = a[2672 + (t = k - 1 | 0) | 0], r = (t = ((e = a[t + S | 0]) ^ J) - 1 >> 8 & _) & (y = a[S + (k = k - 2 | 0) | 0]) - (D = a[k + 2672 | 0]) >> 8 | 255 & (e - J >>> 8 & _ | r), _ = t & (D ^ y) - 1 >> 8, k;);
                                        if (255 & r && !(rA(A) | !(((127 & (-1 ^ a[B + 31 | 0]) | a[B + 1 | 0] & a[B + 2 | 0] & a[B + 3 | 0] & a[B + 4 | 0] & a[B + 5 | 0] & a[B + 6 | 0] & a[B + 7 | 0] & a[B + 8 | 0] & a[B + 9 | 0] & a[B + 10 | 0] & a[B + 11 | 0] & a[B + 12 | 0] & a[B + 13 | 0] & a[B + 14 | 0] & a[B + 15 | 0] & a[B + 16 | 0] & a[B + 17 | 0] & a[B + 18 | 0] & a[B + 19 | 0] & a[B + 20 | 0] & a[B + 21 | 0] & a[B + 22 | 0] & a[B + 23 | 0] & a[B + 24 | 0] & a[B + 25 | 0] & a[B + 26 | 0] & a[B + 27 | 0] & a[B + 28 | 0] & a[B + 30 | 0] & a[B + 29 | 0] ^ 255) - 1 & 236 - a[0 | B] ^ -1) >>> 8 & 1) || rA(B) || U(t = i + 128 | 0, B))) {
                                            for(cA(e = i + 384 | 0), Q && R(e, 35136, 34, 0), R(e, A, 32, 0), R(e, B, 32, 0), R(e, I, g, C), N(e, g = i + 320 | 0), F(g), C = i + 8 | 0, B = 0, I = 0, w = f = w - 2272 | 0; e = g + (B >>> 3 | 0) | 0, E[(Q = f + 2016 | 0) + B | 0] = a[0 | e] >>> (6 & B) & 1, E[(r = Q) + (Q = 1 | B) | 0] = a[0 | e] >>> (7 & Q) & 1, 256 != (0 | (B = B + 2 | 0)););
                                            for(;;){
                                                I = (g = I) + 1 | 0;
                                                A: if (!(g >>> 0 > 254) && a[0 | (r = (B = f + 2016 | 0) + g | 0)]) {
                                                    I: if (B = E[0 | (D = I + B | 0)]) {
                                                        if ((0 | (B = (e = B << 1) + (Q = E[0 | r]) | 0)) <= 15) E[0 | r] = B, E[0 | D] = 0;
                                                        else {
                                                            if ((0 | (B = Q - e | 0)) < -15) break A;
                                                            for(E[0 | r] = B, B = I;;){
                                                                if (!a[0 | (Q = (f + 2016 | 0) + B | 0)]) {
                                                                    E[0 | Q] = 1;
                                                                    break I;
                                                                }
                                                                if (E[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, !Q) break;
                                                            }
                                                        }
                                                    }
                                                    if (!(g >>> 0 > 253)) {
                                                        I: if (Q = E[0 | (y = (B = g + 2 | 0) + (f + 2016 | 0) | 0)]) {
                                                            if ((0 | (Q = (D = Q << 2) + (e = E[0 | r]) | 0)) >= 16) {
                                                                if ((0 | (Q = e - D | 0)) < -15) break A;
                                                                for(E[0 | r] = Q;;){
                                                                    if (a[0 | (Q = (f + 2016 | 0) + B | 0)]) {
                                                                        if (E[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                        break I;
                                                                    }
                                                                    break;
                                                                }
                                                                E[0 | Q] = 1;
                                                            } else E[0 | r] = Q, E[0 | y] = 0;
                                                        }
                                                        if (!(g >>> 0 > 252)) {
                                                            I: if (Q = E[0 | (y = (B = g + 3 | 0) + (f + 2016 | 0) | 0)]) {
                                                                if ((0 | (Q = (D = Q << 3) + (e = E[0 | r]) | 0)) >= 16) {
                                                                    if ((0 | (Q = e - D | 0)) < -15) break A;
                                                                    for(E[0 | r] = Q;;){
                                                                        if (a[0 | (Q = (f + 2016 | 0) + B | 0)]) {
                                                                            if (E[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                            break I;
                                                                        }
                                                                        break;
                                                                    }
                                                                    E[0 | Q] = 1;
                                                                } else E[0 | r] = Q, E[0 | y] = 0;
                                                            }
                                                            if (!(g >>> 0 > 251)) {
                                                                I: if (Q = E[0 | (y = (B = g + 4 | 0) + (f + 2016 | 0) | 0)]) {
                                                                    if ((0 | (Q = (D = Q << 4) + (e = E[0 | r]) | 0)) >= 16) {
                                                                        if ((0 | (Q = e - D | 0)) < -15) break A;
                                                                        for(E[0 | r] = Q;;){
                                                                            if (a[0 | (Q = (f + 2016 | 0) + B | 0)]) {
                                                                                if (E[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                                break I;
                                                                            }
                                                                            break;
                                                                        }
                                                                        E[0 | Q] = 1;
                                                                    } else E[0 | r] = Q, E[0 | y] = 0;
                                                                }
                                                                if (!(g >>> 0 > 250)) {
                                                                    I: if (Q = E[0 | (y = (B = g + 5 | 0) + (f + 2016 | 0) | 0)]) {
                                                                        if ((0 | (Q = (D = Q << 5) + (e = E[0 | r]) | 0)) >= 16) {
                                                                            if ((0 | (Q = e - D | 0)) < -15) break A;
                                                                            for(E[0 | r] = Q;;){
                                                                                if (a[0 | (Q = (f + 2016 | 0) + B | 0)]) {
                                                                                    if (E[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                                    break I;
                                                                                }
                                                                                break;
                                                                            }
                                                                            E[0 | Q] = 1;
                                                                        } else E[0 | r] = Q, E[0 | y] = 0;
                                                                    }
                                                                    if (!(g >>> 0 > 249) && (g = E[0 | (D = (B = g + 6 | 0) + (f + 2016 | 0) | 0)])) {
                                                                        if ((0 | (g = (e = g << 6) + (Q = E[0 | r]) | 0)) >= 16) {
                                                                            if ((0 | (g = Q - e | 0)) < -15) break A;
                                                                            for(E[0 | r] = g;;){
                                                                                if (a[0 | (g = (f + 2016 | 0) + B | 0)]) {
                                                                                    if (E[0 | g] = 0, g = B >>> 0 < 255, B = B + 1 | 0, g) continue;
                                                                                    break A;
                                                                                }
                                                                                break;
                                                                            }
                                                                            E[0 | g] = 1;
                                                                        } else E[0 | r] = g, E[0 | D] = 0;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                                if (256 == (0 | I)) break;
                                            }
                                            for(B = 0; g = S + (B >>> 3 | 0) | 0, E[(I = f + 1760 | 0) + B | 0] = a[0 | g] >>> (6 & B) & 1, E[(Q = I) + (I = 1 | B) | 0] = a[0 | g] >>> (7 & I) & 1, 256 != (0 | (B = B + 2 | 0)););
                                            for(I = 0;;){
                                                I = (g = I) + 1 | 0;
                                                A: if (!(g >>> 0 > 254) && a[0 | (r = (B = f + 1760 | 0) + g | 0)]) {
                                                    I: if (B = E[0 | (D = I + B | 0)]) {
                                                        if ((0 | (B = (e = B << 1) + (Q = E[0 | r]) | 0)) <= 15) E[0 | r] = B, E[0 | D] = 0;
                                                        else {
                                                            if ((0 | (B = Q - e | 0)) < -15) break A;
                                                            for(E[0 | r] = B, B = I;;){
                                                                if (!a[0 | (Q = (f + 1760 | 0) + B | 0)]) {
                                                                    E[0 | Q] = 1;
                                                                    break I;
                                                                }
                                                                if (E[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, !Q) break;
                                                            }
                                                        }
                                                    }
                                                    if (!(g >>> 0 > 253)) {
                                                        I: if (Q = E[0 | (y = (B = g + 2 | 0) + (f + 1760 | 0) | 0)]) {
                                                            if ((0 | (Q = (D = Q << 2) + (e = E[0 | r]) | 0)) >= 16) {
                                                                if ((0 | (Q = e - D | 0)) < -15) break A;
                                                                for(E[0 | r] = Q;;){
                                                                    if (a[0 | (Q = (f + 1760 | 0) + B | 0)]) {
                                                                        if (E[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                        break I;
                                                                    }
                                                                    break;
                                                                }
                                                                E[0 | Q] = 1;
                                                            } else E[0 | r] = Q, E[0 | y] = 0;
                                                        }
                                                        if (!(g >>> 0 > 252)) {
                                                            I: if (Q = E[0 | (y = (B = g + 3 | 0) + (f + 1760 | 0) | 0)]) {
                                                                if ((0 | (Q = (D = Q << 3) + (e = E[0 | r]) | 0)) >= 16) {
                                                                    if ((0 | (Q = e - D | 0)) < -15) break A;
                                                                    for(E[0 | r] = Q;;){
                                                                        if (a[0 | (Q = (f + 1760 | 0) + B | 0)]) {
                                                                            if (E[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                            break I;
                                                                        }
                                                                        break;
                                                                    }
                                                                    E[0 | Q] = 1;
                                                                } else E[0 | r] = Q, E[0 | y] = 0;
                                                            }
                                                            if (!(g >>> 0 > 251)) {
                                                                I: if (Q = E[0 | (y = (B = g + 4 | 0) + (f + 1760 | 0) | 0)]) {
                                                                    if ((0 | (Q = (D = Q << 4) + (e = E[0 | r]) | 0)) >= 16) {
                                                                        if ((0 | (Q = e - D | 0)) < -15) break A;
                                                                        for(E[0 | r] = Q;;){
                                                                            if (a[0 | (Q = (f + 1760 | 0) + B | 0)]) {
                                                                                if (E[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                                break I;
                                                                            }
                                                                            break;
                                                                        }
                                                                        E[0 | Q] = 1;
                                                                    } else E[0 | r] = Q, E[0 | y] = 0;
                                                                }
                                                                if (!(g >>> 0 > 250)) {
                                                                    I: if (Q = E[0 | (y = (B = g + 5 | 0) + (f + 1760 | 0) | 0)]) {
                                                                        if ((0 | (Q = (D = Q << 5) + (e = E[0 | r]) | 0)) >= 16) {
                                                                            if ((0 | (Q = e - D | 0)) < -15) break A;
                                                                            for(E[0 | r] = Q;;){
                                                                                if (a[0 | (Q = (f + 1760 | 0) + B | 0)]) {
                                                                                    if (E[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                                    break I;
                                                                                }
                                                                                break;
                                                                            }
                                                                            E[0 | Q] = 1;
                                                                        } else E[0 | r] = Q, E[0 | y] = 0;
                                                                    }
                                                                    if (!(g >>> 0 > 249) && (g = E[0 | (D = (B = g + 6 | 0) + (f + 1760 | 0) | 0)])) {
                                                                        if ((0 | (g = (e = g << 6) + (Q = E[0 | r]) | 0)) >= 16) {
                                                                            if ((0 | (g = Q - e | 0)) < -15) break A;
                                                                            for(E[0 | r] = g;;){
                                                                                if (a[0 | (g = (f + 1760 | 0) + B | 0)]) {
                                                                                    if (E[0 | g] = 0, g = B >>> 0 < 255, B = B + 1 | 0, g) continue;
                                                                                    break A;
                                                                                }
                                                                                break;
                                                                            }
                                                                            E[0 | g] = 1;
                                                                        } else E[0 | r] = g, E[0 | D] = 0;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                                if (256 == (0 | I)) break;
                                            }
                                            for(W(B = f + 480 | 0, t), I = o[t + 36 >> 2], o[f + 192 >> 2] = o[t + 32 >> 2], o[f + 196 >> 2] = I, I = o[t + 28 >> 2], o[f + 184 >> 2] = o[t + 24 >> 2], o[f + 188 >> 2] = I, I = o[t + 20 >> 2], o[f + 176 >> 2] = o[t + 16 >> 2], o[f + 180 >> 2] = I, I = o[t + 12 >> 2], o[f + 168 >> 2] = o[t + 8 >> 2], o[f + 172 >> 2] = I, I = o[t + 4 >> 2], o[f + 160 >> 2] = o[t >> 2], o[f + 164 >> 2] = I, I = o[t + 52 >> 2], o[f + 208 >> 2] = o[t + 48 >> 2], o[f + 212 >> 2] = I, I = o[t + 60 >> 2], o[f + 216 >> 2] = o[t + 56 >> 2], o[f + 220 >> 2] = I, I = o[4 + (g = t - -64 | 0) >> 2], o[f + 224 >> 2] = o[g >> 2], o[f + 228 >> 2] = I, I = o[t + 76 >> 2], o[f + 232 >> 2] = o[t + 72 >> 2], o[f + 236 >> 2] = I, I = o[t + 44 >> 2], o[f + 200 >> 2] = o[t + 40 >> 2], o[f + 204 >> 2] = I, I = o[t + 92 >> 2], o[f + 248 >> 2] = o[t + 88 >> 2], o[f + 252 >> 2] = I, I = o[t + 100 >> 2], o[f + 256 >> 2] = o[t + 96 >> 2], o[f + 260 >> 2] = I, I = o[t + 108 >> 2], o[f + 264 >> 2] = o[t + 104 >> 2], o[f + 268 >> 2] = I, I = o[t + 116 >> 2], o[f + 272 >> 2] = o[t + 112 >> 2], o[f + 276 >> 2] = I, I = o[t + 84 >> 2], o[f + 240 >> 2] = o[t + 80 >> 2], o[f + 244 >> 2] = I, G(Q = f + 320 | 0, g = f + 160 | 0), H(f, Q, h = f + 440 | 0), H(f + 40 | 0, n = f + 360 | 0, s = f + 400 | 0), H(f + 80 | 0, s, h), H(f + 120 | 0, Q, n), b(Q, f, B), H(g, Q, h), H(Y = f + 200 | 0, n, s), H(d = f + 240 | 0, s, h), H(M = f + 280 | 0, Q, n), W(I = f + 640 | 0, g), b(Q, f, I), H(g, Q, h), H(Y, n, s), H(d, s, h), H(M, Q, n), W(I = f + 800 | 0, g), b(Q, f, I), H(g, Q, h), H(Y, n, s), H(d, s, h), H(M, Q, n), W(I = f + 960 | 0, g), b(Q, f, I), H(g, Q, h), H(Y, n, s), H(d, s, h), H(M, Q, n), W(I = f + 1120 | 0, g), b(Q, f, I), H(g, Q, h), H(Y, n, s), H(d, s, h), H(M, Q, n), W(I = f + 1280 | 0, g), b(Q, f, I), H(g, Q, h), H(Y, n, s), H(d, s, h), H(M, Q, n), W(I = f + 1440 | 0, g), b(Q, f, I), H(g, Q, h), H(Y, n, s), H(d, s, h), H(M, Q, n), W(f + 1600 | 0, g), o[C + 32 >> 2] = 0, o[C + 36 >> 2] = 0, o[C + 24 >> 2] = 0, o[C + 28 >> 2] = 0, o[C + 16 >> 2] = 0, o[C + 20 >> 2] = 0, o[C + 8 >> 2] = 0, o[C + 12 >> 2] = 0, o[C >> 2] = 0, o[C + 4 >> 2] = 0, o[C + 44 >> 2] = 0, o[C + 48 >> 2] = 0, o[(j = C + 40 | 0) >> 2] = 1, o[C + 52 >> 2] = 0, o[C + 56 >> 2] = 0, o[C + 60 >> 2] = 0, o[C + 64 >> 2] = 0, o[C + 68 >> 2] = 0, o[C + 72 >> 2] = 0, o[C + 84 >> 2] = 0, o[C + 88 >> 2] = 0, o[C + 76 >> 2] = 0, o[C + 80 >> 2] = 1, o[C + 92 >> 2] = 0, o[C + 96 >> 2] = 0, o[C + 100 >> 2] = 0, o[C + 104 >> 2] = 0, o[C + 108 >> 2] = 0, o[C + 112 >> 2] = 0, o[C + 116 >> 2] = 0, IA = C + 80 | 0, I = 255;;){
                                                A: {
                                                    I: {
                                                        if (!a[(g = f + 2016 | 0) + I | 0] && !a[(B = f + 1760 | 0) + I | 0]) {
                                                            if (!(a[(Q = g) + (g = I - 1 | 0) | 0] | a[g + B | 0])) break I;
                                                            I = g;
                                                        }
                                                        if ((0 | I) < 0) break A;
                                                        for(; G(B = f + 320 | 0, C), (0 | (Q = E[(g = I) + (f + 2016 | 0) | 0])) > 0 ? (H(I = f + 160 | 0, B, h), H(Y, n, s), H(d, s, h), H(M, B, n), b(B, I, (f + 480 | 0) + c((254 & Q) >>> 1 | 0, 160) | 0)) : (0 | Q) >= 0 || (H(I = f + 160 | 0, B = f + 320 | 0, h), H(Y, n, s), H(d, s, h), H(M, B, n), P(B, I, (f + 480 | 0) + c((0 - Q & 254) >>> 1 | 0, 160) | 0)), (0 | (q = E[g + (f + 1760 | 0) | 0])) > 0 ? (H(I = f + 160 | 0, B = f + 320 | 0, h), H(Y, n, s), H(d, s, h), H(M, B, n), v(B, I, c((254 & q) >>> 1 | 0, 120) + 1488 | 0)) : (0 | q) >= 0 || (H(f + 160 | 0, X = f + 320 | 0, h), H(Y, n, s), H(d, s, h), H(M, X, n), K = o[f + 160 >> 2], L = o[f + 200 >> 2], u = o[f + 164 >> 2], x = o[f + 204 >> 2], m = o[f + 168 >> 2], l = o[f + 208 >> 2], z = o[f + 172 >> 2], k = o[f + 212 >> 2], S = o[f + 176 >> 2], _ = o[f + 216 >> 2], p = o[f + 180 >> 2], J = o[f + 220 >> 2], r = o[f + 184 >> 2], y = o[f + 224 >> 2], D = o[f + 188 >> 2], e = o[f + 228 >> 2], t = o[f + 192 >> 2], Q = o[f + 232 >> 2], B = o[f + 236 >> 2], I = o[f + 196 >> 2], o[f + 396 >> 2] = B - I, o[f + 392 >> 2] = Q - t, o[f + 388 >> 2] = e - D, o[f + 384 >> 2] = y - r, o[f + 380 >> 2] = J - p, o[f + 376 >> 2] = _ - S, o[f + 372 >> 2] = k - z, o[f + 368 >> 2] = l - m, o[f + 364 >> 2] = x - u, o[f + 360 >> 2] = L - K, o[f + 356 >> 2] = I + B, o[f + 352 >> 2] = Q + t, o[f + 348 >> 2] = e + D, o[f + 344 >> 2] = r + y, o[f + 340 >> 2] = p + J, o[f + 336 >> 2] = S + _, o[f + 332 >> 2] = k + z, o[f + 328 >> 2] = m + l, o[f + 324 >> 2] = u + x, o[f + 320 >> 2] = K + L, H(s, X, 40 + (I = c((0 - q & 254) >>> 1 | 0, 120) + 1488 | 0) | 0), H(n, n, I), H(h, I + 80 | 0, M), gA = o[f + 276 >> 2], CA = o[f + 272 >> 2], q = o[f + 268 >> 2], X = o[f + 264 >> 2], r = o[f + 260 >> 2], y = o[f + 256 >> 2], D = o[f + 252 >> 2], e = o[f + 248 >> 2], t = o[f + 244 >> 2], Q = o[f + 240 >> 2], T = o[f + 360 >> 2], O = o[f + 400 >> 2], V = o[f + 364 >> 2], Z = o[f + 404 >> 2], $ = o[f + 368 >> 2], AA = o[f + 408 >> 2], K = o[f + 372 >> 2], L = o[f + 412 >> 2], u = o[f + 376 >> 2], x = o[f + 416 >> 2], m = o[f + 380 >> 2], l = o[f + 420 >> 2], z = o[f + 384 >> 2], k = o[f + 424 >> 2], S = o[f + 388 >> 2], _ = o[f + 428 >> 2], p = o[f + 392 >> 2], J = o[f + 432 >> 2], B = o[f + 396 >> 2], I = o[f + 436 >> 2], o[f + 396 >> 2] = B + I, o[f + 392 >> 2] = p + J, o[f + 388 >> 2] = S + _, o[f + 384 >> 2] = k + z, o[f + 380 >> 2] = m + l, o[f + 376 >> 2] = u + x, o[f + 372 >> 2] = K + L, o[f + 368 >> 2] = $ + AA, o[f + 364 >> 2] = V + Z, o[f + 360 >> 2] = T + O, o[f + 356 >> 2] = I - B, o[f + 352 >> 2] = J - p, o[f + 348 >> 2] = _ - S, o[f + 344 >> 2] = k - z, o[f + 340 >> 2] = l - m, o[f + 336 >> 2] = x - u, o[f + 332 >> 2] = L - K, o[f + 328 >> 2] = AA - $, o[f + 324 >> 2] = Z - V, o[f + 320 >> 2] = O - T, K = Q << 1, L = o[f + 440 >> 2], o[f + 400 >> 2] = K - L, u = t << 1, x = o[f + 444 >> 2], o[f + 404 >> 2] = u - x, m = e << 1, l = o[f + 448 >> 2], o[f + 408 >> 2] = m - l, z = D << 1, k = o[f + 452 >> 2], o[f + 412 >> 2] = z - k, S = y << 1, _ = o[f + 456 >> 2], o[f + 416 >> 2] = S - _, p = r << 1, J = o[f + 460 >> 2], o[f + 420 >> 2] = p - J, r = X << 1, y = o[f + 464 >> 2], o[f + 424 >> 2] = r - y, D = q << 1, e = o[f + 468 >> 2], o[f + 428 >> 2] = D - e, t = CA << 1, Q = o[f + 472 >> 2], o[f + 432 >> 2] = t - Q, B = gA << 1, I = o[f + 476 >> 2], o[f + 436 >> 2] = B - I, o[f + 440 >> 2] = K + L, o[f + 444 >> 2] = u + x, o[f + 448 >> 2] = m + l, o[f + 452 >> 2] = k + z, o[f + 456 >> 2] = S + _, o[f + 460 >> 2] = p + J, o[f + 464 >> 2] = r + y, o[f + 468 >> 2] = e + D, o[f + 472 >> 2] = Q + t, o[f + 476 >> 2] = I + B), H(C, f + 320 | 0, h), H(j, n, s), H(IA, s, h), I = g - 1 | 0, (0 | g) > 0;);
                                                        break A;
                                                    }
                                                    if (I = I - 2 | 0, g) continue;
                                                }
                                                break;
                                            }
                                            w = f + 2272 | 0, MA(I = i + 288 | 0, C), BA = -1, QA = nA(I, A), p = ((0 | A) == (0 | I) ? BA : QA) | eA(A, I, 32);
                                        }
                                        return w = i + 592 | 0, p;
                                    }
                                    function H(A, I, g) {
                                        var C, B, Q, i, E, a, f, e, r, D, t, y, w, n, s, k, F, S, H, G, _, M, p, N, J, U, Y, d, K, b, P, v, L, R, u, x, m, l, z, q, X, j, T, O, V, Z, W, $, AA, IA, gA, CA, BA, QA = 0, iA = 0, EA = 0, oA = 0, aA = 0, fA = 0, cA = 0, eA = 0, rA = 0, DA = 0, tA = 0, yA = 0, wA = 0, hA = 0, nA = 0, sA = 0, FA = 0, SA = 0, HA = 0, GA = 0, _A = 0, MA = 0, pA = 0, NA = 0, JA = 0;
                                        QA = kA(C = o[g + 4 >> 2], D = C >> 31, FA = (k = o[I + 20 >> 2]) << 1, P = FA >> 31), EA = h, iA = (wA = kA(nA = o[g >> 2], Q = nA >> 31, B = o[I + 24 >> 2], i = B >> 31)) + QA | 0, QA = h + EA | 0, QA = iA >>> 0 < wA >>> 0 ? QA + 1 | 0 : QA, rA = kA(E = o[g + 8 >> 2], w = E >> 31, wA = o[I + 16 >> 2], a = wA >> 31), EA = h + QA | 0, EA = (iA = rA + iA | 0) >>> 0 < rA >>> 0 ? EA + 1 | 0 : EA, QA = (rA = kA(t = o[g + 12 >> 2], F = t >> 31, N = (S = o[I + 12 >> 2]) << 1, v = N >> 31)) + iA | 0, iA = h + EA | 0, iA = QA >>> 0 < rA >>> 0 ? iA + 1 | 0 : iA, EA = (hA = kA(n = o[g + 16 >> 2], J = n >> 31, rA = o[I + 8 >> 2], f = rA >> 31)) + QA | 0, QA = h + iA | 0, QA = EA >>> 0 < hA >>> 0 ? QA + 1 | 0 : QA, iA = EA, EA = kA(H = o[g + 20 >> 2], L = H >> 31, U = (G = o[I + 4 >> 2]) << 1, R = U >> 31), QA = h + QA | 0, QA = (iA = iA + EA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, Z = cA = o[g + 24 >> 2], EA = (DA = kA(cA, O = cA >> 31, hA = o[I >> 2], e = hA >> 31)) + iA | 0, iA = h + QA | 0, iA = EA >>> 0 < DA >>> 0 ? iA + 1 | 0 : iA, u = o[g + 28 >> 2], QA = (DA = kA(yA = c(u, 19), _ = yA >> 31, Y = (M = o[I + 36 >> 2]) << 1, x = Y >> 31)) + EA | 0, EA = h + iA | 0, EA = QA >>> 0 < DA >>> 0 ? EA + 1 | 0 : EA, _A = o[g + 32 >> 2], iA = (eA = kA(oA = c(_A, 19), s = oA >> 31, DA = o[I + 32 >> 2], r = DA >> 31)) + QA | 0, QA = h + EA | 0, QA = iA >>> 0 < eA >>> 0 ? QA + 1 | 0 : QA, W = o[g + 36 >> 2], g = kA(eA = c(W, 19), y = eA >> 31, d = (p = o[I + 28 >> 2]) << 1, m = d >> 31), QA = h + QA | 0, aA = I = g + iA | 0, g = I >>> 0 < g >>> 0 ? QA + 1 | 0 : QA, I = kA(wA, a, C, D), QA = h, iA = kA(nA, Q, k, l = k >> 31), EA = h + QA | 0, EA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? EA + 1 | 0 : EA, QA = kA(E, w, S, z = S >> 31), iA = h + EA | 0, iA = (I = QA + I | 0) >>> 0 < QA >>> 0 ? iA + 1 | 0 : iA, EA = kA(rA, f, t, F), QA = h + iA | 0, QA = (I = EA + I | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, iA = kA(n, J, G, q = G >> 31), QA = h + QA | 0, QA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = kA(hA, e, H, L), QA = h + QA | 0, QA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = kA(cA = c(cA, 19), K = cA >> 31, M, X = M >> 31), EA = h + QA | 0, EA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? EA + 1 | 0 : EA, QA = kA(DA, r, yA, _), iA = h + EA | 0, iA = (I = QA + I | 0) >>> 0 < QA >>> 0 ? iA + 1 | 0 : iA, EA = kA(oA, s, p, j = p >> 31), QA = h + iA | 0, QA = (I = EA + I | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, iA = kA(eA, y, B, i), QA = h + QA | 0, pA = I = iA + I | 0, SA = I >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, I = kA(C, D, N, v), QA = h, iA = kA(nA, Q, wA, a), QA = h + QA | 0, QA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = kA(rA, f, E, w), EA = h + QA | 0, EA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? EA + 1 | 0 : EA, QA = kA(t, F, U, R), iA = h + EA | 0, iA = (I = QA + I | 0) >>> 0 < QA >>> 0 ? iA + 1 | 0 : iA, EA = kA(hA, e, n, J), QA = h + iA | 0, QA = (I = EA + I | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, iA = kA(b = c(H, 19), T = b >> 31, Y, x), QA = h + QA | 0, QA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = kA(DA, r, cA, K), QA = h + QA | 0, QA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = kA(yA, _, d, m), EA = h + QA | 0, EA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? EA + 1 | 0 : EA, QA = kA(oA, s, B, i), iA = h + EA | 0, iA = (I = QA + I | 0) >>> 0 < QA >>> 0 ? iA + 1 | 0 : iA, EA = kA(eA, y, FA, P), QA = h + iA | 0, $ = I = EA + I | 0, AA = QA = I >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, IA = I = I + 33554432 | 0, gA = QA = I >>> 0 < 33554432 ? QA + 1 | 0 : QA, EA = (67108863 & QA) << 6 | I >>> 26, QA = (QA >> 26) + SA | 0, pA = I = EA + pA | 0, QA = I >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, CA = I = I + 16777216 | 0, QA = g + (iA = (EA = I >>> 0 < 16777216 ? QA + 1 | 0 : QA) >> 25) | 0, QA = (I = (EA = (33554431 & EA) << 7 | I >>> 25) + aA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, HA = g = (iA = I) + 33554432 | 0, I = QA = g >>> 0 < 33554432 ? QA + 1 | 0 : QA, o[A + 24 >> 2] = iA - (-67108864 & g), g = kA(C, D, U, R), QA = h, iA = kA(nA, Q, rA, f), EA = h + QA | 0, EA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? EA + 1 | 0 : EA, iA = (QA = g) + (g = kA(hA, e, E, w)) | 0, QA = h + EA | 0, QA = g >>> 0 > iA >>> 0 ? QA + 1 | 0 : QA, EA = kA(g = c(t, 19), GA = g >> 31, Y, x), QA = h + QA | 0, QA = (iA = EA + iA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, EA = (aA = kA(DA, r, SA = c(n, 19), V = SA >> 31)) + iA | 0, iA = h + QA | 0, iA = EA >>> 0 < aA >>> 0 ? iA + 1 | 0 : iA, aA = kA(d, m, b, T), QA = h + iA | 0, QA = (EA = aA + EA | 0) >>> 0 < aA >>> 0 ? QA + 1 | 0 : QA, iA = (aA = kA(B, i, cA, K)) + EA | 0, EA = h + QA | 0, EA = iA >>> 0 < aA >>> 0 ? EA + 1 | 0 : EA, aA = kA(yA, _, FA, P), QA = h + EA | 0, QA = (iA = aA + iA | 0) >>> 0 < aA >>> 0 ? QA + 1 | 0 : QA, EA = kA(oA, s, wA, a), QA = h + QA | 0, QA = (iA = EA + iA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, EA = (aA = kA(eA, y, N, v)) + iA | 0, iA = h + QA | 0, tA = EA, NA = EA >>> 0 < aA >>> 0 ? iA + 1 | 0 : iA, QA = kA(hA, e, C, D), iA = h, EA = (aA = kA(nA, Q, G, q)) + QA | 0, QA = h + iA | 0, QA = EA >>> 0 < aA >>> 0 ? QA + 1 | 0 : QA, aA = iA = c(E, 19), iA = (fA = kA(iA, MA = iA >> 31, M, X)) + EA | 0, EA = h + QA | 0, EA = iA >>> 0 < fA >>> 0 ? EA + 1 | 0 : EA, fA = kA(DA, r, g, GA), QA = h + EA | 0, QA = (iA = fA + iA | 0) >>> 0 < fA >>> 0 ? QA + 1 | 0 : QA, EA = kA(SA, V, p, j), QA = h + QA | 0, QA = (iA = EA + iA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, EA = (fA = kA(B, i, b, T)) + iA | 0, iA = h + QA | 0, iA = EA >>> 0 < fA >>> 0 ? iA + 1 | 0 : iA, fA = kA(cA, K, k, l), QA = h + iA | 0, QA = (EA = fA + EA | 0) >>> 0 < fA >>> 0 ? QA + 1 | 0 : QA, iA = (fA = kA(wA, a, yA, _)) + EA | 0, EA = h + QA | 0, EA = iA >>> 0 < fA >>> 0 ? EA + 1 | 0 : EA, fA = kA(oA, s, S, z), QA = h + EA | 0, QA = (iA = fA + iA | 0) >>> 0 < fA >>> 0 ? QA + 1 | 0 : QA, EA = kA(eA, y, rA, f), QA = h + QA | 0, JA = iA = EA + iA | 0, fA = iA >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, QA = kA(QA = c(C, 19), QA >> 31, Y, x), iA = h, EA = kA(nA, Q, hA, e), iA = h + iA | 0, iA = (QA = EA + QA | 0) >>> 0 < EA >>> 0 ? iA + 1 | 0 : iA, EA = (aA = kA(DA, r, aA, MA)) + QA | 0, QA = h + iA | 0, g = (iA = kA(g, GA, d, m)) + EA | 0, EA = h + (EA >>> 0 < aA >>> 0 ? QA + 1 | 0 : QA) | 0, EA = g >>> 0 < iA >>> 0 ? EA + 1 | 0 : EA, iA = kA(B, i, SA, V), QA = h + EA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = kA(FA, P, b, T), QA = h + QA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, EA = kA(wA, a, cA, K), iA = h + QA | 0, iA = (g = EA + g | 0) >>> 0 < EA >>> 0 ? iA + 1 | 0 : iA, EA = kA(yA, _, N, v), QA = h + iA | 0, QA = (g = EA + g | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, iA = kA(oA, s, rA, f), EA = h + QA | 0, EA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? EA + 1 | 0 : EA, iA = kA(eA, y, U, R), QA = h + EA | 0, aA = g = iA + g | 0, GA = QA = g >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, MA = g = g + 33554432 | 0, BA = QA = g >>> 0 < 33554432 ? QA + 1 | 0 : QA, iA = (EA = QA >> 26) + fA | 0, fA = g = (QA = (67108863 & QA) << 6 | g >>> 26) + JA | 0, QA = g >>> 0 < QA >>> 0 ? iA + 1 | 0 : iA, JA = g = g + 16777216 | 0, iA = (33554431 & (QA = g >>> 0 < 16777216 ? QA + 1 | 0 : QA)) << 7 | g >>> 25, QA = (QA >> 25) + NA | 0, QA = (g = iA + tA | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, NA = iA = (EA = g) + 33554432 | 0, g = QA = iA >>> 0 < 33554432 ? QA + 1 | 0 : QA, o[A + 8 >> 2] = EA - (-67108864 & iA), QA = kA(B, i, C, D), EA = h, iA = (tA = kA(nA, Q, p, j)) + QA | 0, QA = h + EA | 0, QA = iA >>> 0 < tA >>> 0 ? QA + 1 | 0 : QA, EA = kA(E, w, k, l), QA = h + QA | 0, QA = (iA = EA + iA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, EA = kA(wA, a, t, F), QA = h + QA | 0, QA = (iA = EA + iA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, tA = kA(n, J, S, z), EA = h + QA | 0, EA = (iA = tA + iA | 0) >>> 0 < tA >>> 0 ? EA + 1 | 0 : EA, QA = (tA = kA(rA, f, H, L)) + iA | 0, iA = h + EA | 0, iA = QA >>> 0 < tA >>> 0 ? iA + 1 | 0 : iA, EA = (tA = kA(G, q, Z, O)) + QA | 0, QA = h + iA | 0, QA = EA >>> 0 < tA >>> 0 ? QA + 1 | 0 : QA, iA = EA, EA = kA(hA, e, u, tA = u >> 31), QA = h + QA | 0, QA = (iA = iA + EA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, EA = kA(oA, s, M, X), QA = h + QA | 0, QA = (iA = EA + iA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, sA = kA(eA, y, DA, r), EA = h + QA | 0, QA = I >> 26, I = (HA = (67108863 & I) << 6 | HA >>> 26) + (iA = sA + iA | 0) | 0, iA = QA + (iA >>> 0 < sA >>> 0 ? EA + 1 | 0 : EA) | 0, QA = (EA = I) >>> 0 < HA >>> 0 ? iA + 1 | 0 : iA, HA = iA = EA + 16777216 | 0, I = QA = iA >>> 0 < 16777216 ? QA + 1 | 0 : QA, o[A + 28 >> 2] = EA - (-33554432 & iA), QA = kA(rA, f, C, D), iA = h, sA = kA(nA, Q, S, z), EA = h + iA | 0, EA = (QA = sA + QA | 0) >>> 0 < sA >>> 0 ? EA + 1 | 0 : EA, sA = kA(E, w, G, q), iA = h + EA | 0, iA = (QA = sA + QA | 0) >>> 0 < sA >>> 0 ? iA + 1 | 0 : iA, EA = (sA = kA(hA, e, t, F)) + QA | 0, QA = h + iA | 0, QA = EA >>> 0 < sA >>> 0 ? QA + 1 | 0 : QA, iA = EA, EA = kA(SA, V, M, X), QA = h + QA | 0, QA = (iA = iA + EA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, EA = kA(DA, r, b, T), QA = h + QA | 0, QA = (iA = EA + iA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, iA = (cA = kA(cA, K, p, j)) + iA | 0, EA = h + QA | 0, QA = (yA = kA(B, i, yA, _)) + iA | 0, iA = h + (iA >>> 0 < cA >>> 0 ? EA + 1 | 0 : EA) | 0, EA = (oA = kA(oA, s, k, l)) + QA | 0, QA = h + (QA >>> 0 < yA >>> 0 ? iA + 1 | 0 : iA) | 0, QA = EA >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, iA = EA, EA = kA(eA, y, wA, a), QA = h + QA | 0, oA = iA = iA + EA | 0, QA = (QA = iA >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA) + (iA = g >> 26) | 0, oA = g = oA + (EA = (67108863 & g) << 6 | NA >>> 26) | 0, QA = g >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, yA = iA = g + 16777216 | 0, g = EA = iA >>> 0 < 16777216 ? QA + 1 | 0 : QA, o[A + 12 >> 2] = oA - (-33554432 & iA), QA = kA(C, D, d, m), EA = h, iA = (oA = kA(nA, Q, DA, r)) + QA | 0, QA = h + EA | 0, QA = iA >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, EA = kA(B, i, E, w), QA = h + QA | 0, QA = (iA = EA + iA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, oA = kA(t, F, FA, P), EA = h + QA | 0, EA = (iA = oA + iA | 0) >>> 0 < oA >>> 0 ? EA + 1 | 0 : EA, QA = (oA = kA(wA, a, n, J)) + iA | 0, iA = h + EA | 0, iA = QA >>> 0 < oA >>> 0 ? iA + 1 | 0 : iA, EA = (oA = kA(N, v, H, L)) + QA | 0, QA = h + iA | 0, QA = EA >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, iA = EA, EA = kA(rA, f, Z, O), QA = h + QA | 0, QA = (iA = iA + EA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, EA = kA(u, tA, U, R), QA = h + QA | 0, QA = (iA = EA + iA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, iA = (FA = kA(hA, e, oA = _A, cA = oA >> 31)) + iA | 0, EA = h + QA | 0, QA = (eA = kA(eA, y, Y, x)) + iA | 0, iA = h + (iA >>> 0 < FA >>> 0 ? EA + 1 | 0 : EA) | 0, iA = QA >>> 0 < eA >>> 0 ? iA + 1 | 0 : iA, _A = QA, QA = (QA = I >> 25) + iA | 0, QA = (I = _A + (EA = (33554431 & I) << 7 | HA >>> 25) | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, eA = iA = (EA = I) + 33554432 | 0, I = QA = iA >>> 0 < 33554432 ? QA + 1 | 0 : QA, o[A + 32 >> 2] = EA - (-67108864 & iA), iA = g >> 25, g = (yA = (33554431 & g) << 7 | yA >>> 25) + ($ - (QA = -67108864 & IA) | 0) | 0, QA = iA + (AA - ((QA >>> 0 > $ >>> 0) + gA | 0) | 0) | 0, QA = g >>> 0 < yA >>> 0 ? QA + 1 | 0 : QA, QA = ((67108863 & (QA = (g = (iA = g) + 33554432 | 0) >>> 0 < 33554432 ? QA + 1 | 0 : QA)) << 6 | g >>> 26) + (EA = pA - (-33554432 & CA) | 0) | 0, o[A + 20 >> 2] = QA, o[A + 16 >> 2] = iA - (-67108864 & g), g = kA(DA, r, C, D), QA = h, iA = kA(nA, Q, M, X), QA = h + QA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, EA = kA(E, w, p, j), iA = h + QA | 0, iA = (g = EA + g | 0) >>> 0 < EA >>> 0 ? iA + 1 | 0 : iA, QA = kA(B, i, t, F), EA = h + iA | 0, EA = (g = QA + g | 0) >>> 0 < QA >>> 0 ? EA + 1 | 0 : EA, iA = kA(n, J, k, l), QA = h + EA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = kA(wA, a, H, L), QA = h + QA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = kA(S, z, Z, O), QA = h + QA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, EA = kA(rA, f, u, tA), iA = h + QA | 0, iA = (g = EA + g | 0) >>> 0 < EA >>> 0 ? iA + 1 | 0 : iA, QA = kA(oA, cA, G, q), EA = h + iA | 0, EA = (g = QA + g | 0) >>> 0 < QA >>> 0 ? EA + 1 | 0 : EA, iA = kA(hA, e, W, W >> 31), QA = h + EA | 0, QA = (QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA) + (iA = I >> 26) | 0, QA = (I = (EA = g) + (g = (67108863 & I) << 6 | eA >>> 26) | 0) >>> 0 < g >>> 0 ? QA + 1 | 0 : QA, QA = (I = (g = I) + 16777216 | 0) >>> 0 < 16777216 ? QA + 1 | 0 : QA, o[A + 36 >> 2] = g - (-33554432 & I), EA = fA - (-33554432 & JA) | 0, iA = aA - (g = -67108864 & MA) | 0, nA = GA - ((g >>> 0 > aA >>> 0) + BA | 0) | 0, I = (g = kA((33554431 & (g = QA)) << 7 | I >>> 25, QA >>= 25, 19, 0)) + iA | 0, iA = h + nA | 0, QA = I >>> 0 < g >>> 0 ? iA + 1 | 0 : iA, QA = ((67108863 & (QA = (I = (g = I) + 33554432 | 0) >>> 0 < 33554432 ? QA + 1 | 0 : QA)) << 6 | I >>> 26) + EA | 0, o[A + 4 >> 2] = QA, o[A >> 2] = g - (-67108864 & I);
                                    }
                                    function G(A, I) {
                                        var g, C, B, Q, i, E, a, f, e, r, D, t, y, n, s, k, F, S, H, G, _, p, N, J = 0, U = 0, Y = 0, d = 0, K = 0, b = 0, P = 0, v = 0, L = 0, R = 0, u = 0, x = 0, m = 0, l = 0, z = 0, q = 0, X = 0, j = 0, T = 0, O = 0, V = 0, Z = 0, W = 0, $ = 0, AA = 0, IA = 0, gA = 0, CA = 0, BA = 0, QA = 0, iA = 0, EA = 0, oA = 0, aA = 0, fA = 0, cA = 0;
                                        w = g = w - 48 | 0, M(A, I), M(A + 80 | 0, I + 40 | 0), J = kA(l = (W = o[I + 92 >> 2]) << 1, i = l >> 31, v = (d = o[I + 84 >> 2]) << 1, C = v >> 31), Y = h, CA = X = o[I + 88 >> 2], U = (u = kA(X, T = X >> 31, X, T)) + J | 0, J = h + Y | 0, J = U >>> 0 < u >>> 0 ? J + 1 | 0 : J, Y = kA(K = o[I + 96 >> 2], E = K >> 31, u = (L = o[I + 80 >> 2]) << 1, B = u >> 31), J = h + J | 0, J = (U = Y + U | 0) >>> 0 < Y >>> 0 ? J + 1 | 0 : J, gA = o[I + 108 >> 2], Y = kA(x = c(gA, 38), D = x >> 31, gA, n = gA >> 31), J = h + J | 0, J = (U = Y + U | 0) >>> 0 < Y >>> 0 ? J + 1 | 0 : J, Y = U, $ = o[I + 112 >> 2], R = kA(b = c($, 19), a = b >> 31, U = (O = o[I + 104 >> 2]) << 1, U >> 31), U = h + J | 0, U = (Y = Y + R | 0) >>> 0 < R >>> 0 ? U + 1 | 0 : U, iA = o[I + 116 >> 2], J = kA(R = c(iA, 38), Q = R >> 31, j = (V = o[I + 100 >> 2]) << 1, e = j >> 31), U = h + U | 0, EA = J = (J >>> 0 > (Y = J + Y | 0) >>> 0 ? U + 1 | 0 : U) << 1 | Y >>> 31, oA = Y = 33554432 + (s = Y << 1) | 0, aA = J = Y >>> 0 < 33554432 ? J + 1 | 0 : J, P = (67108863 & J) << 6 | Y >>> 26, Z = J >> 26, J = kA(v, C, K, E), Y = h, U = (AA = kA(X <<= 1, r = X >> 31, W, k = W >> 31)) + J | 0, J = h + Y | 0, J = U >>> 0 < AA >>> 0 ? J + 1 | 0 : J, Y = (AA = kA(V, t = V >> 31, u, B)) + U | 0, U = h + J | 0, U = Y >>> 0 < AA >>> 0 ? U + 1 | 0 : U, BA = kA(b, a, AA = gA << 1, F = AA >> 31), J = h + U | 0, J = (Y = BA + Y | 0) >>> 0 < BA >>> 0 ? J + 1 | 0 : J, U = kA(R, Q, O, f = O >> 31), J = h + J | 0, U = (U = (U >>> 0 > (Y = U + Y | 0) >>> 0 ? J + 1 | 0 : J) << 1 | Y >>> 31) + Z | 0, BA = Y = (J = Y << 1) + P | 0, J = U = J >>> 0 > Y >>> 0 ? U + 1 | 0 : U, fA = Y = Y + 16777216 | 0, P = (33554431 & (J = Y >>> 0 < 16777216 ? J + 1 | 0 : J)) << 7 | Y >>> 25, Z = J >> 25, J = kA(l, i, W, k), Y = h, U = (m = kA(K, E, X, r)) + J | 0, J = h + Y | 0, J = U >>> 0 < m >>> 0 ? J + 1 | 0 : J, Y = kA(v, C, j, e), J = h + J | 0, J = (U = Y + U | 0) >>> 0 < Y >>> 0 ? J + 1 | 0 : J, Y = (m = kA(u, B, O, f)) + U | 0, U = h + J | 0, U = Y >>> 0 < m >>> 0 ? U + 1 | 0 : U, m = kA(b, a, $, y = $ >> 31), J = h + U | 0, J = (Y = m + Y | 0) >>> 0 < m >>> 0 ? J + 1 | 0 : J, m = kA(R, Q, AA, F), U = h + J | 0, U = ((Y = m + Y | 0) >>> 0 < m >>> 0 ? U + 1 | 0 : U) << 1 | Y >>> 31, Y = (J = P) + (P = Y << 1) | 0, J = U + Z | 0, J = Y >>> 0 < P >>> 0 ? J + 1 | 0 : J, Z = Y, m = U = Y + 33554432 | 0, Y = J = U >>> 0 < 33554432 ? J + 1 | 0 : J, o[A + 144 >> 2] = Z - (-67108864 & U), Z = kA(J = c(V, 38), J >> 31, V, t), P = h, L = kA(J = L, U = J >> 31, J, U), U = h + P | 0, U = (J = L + Z | 0) >>> 0 < L >>> 0 ? U + 1 | 0 : U, P = (IA = kA(L = c(O, 19), S = L >> 31, Z = K << 1, H = Z >> 31)) + J | 0, J = h + U | 0, J = P >>> 0 < IA >>> 0 ? J + 1 | 0 : J, U = P, P = kA(l, i, x, D), J = h + J | 0, J = (U = U + P | 0) >>> 0 < P >>> 0 ? J + 1 | 0 : J, P = (IA = kA(b, a, X, r)) + U | 0, U = h + J | 0, U = P >>> 0 < IA >>> 0 ? U + 1 | 0 : U, IA = kA(v, C, R, Q), J = h + U | 0, IA = J = ((P = IA + P | 0) >>> 0 < IA >>> 0 ? J + 1 | 0 : J) << 1 | P >>> 31, p = U = (P = 33554432 + (G = P << 1) | 0) >>> 0 < 33554432 ? J + 1 | 0 : J, QA = (67108863 & U) << 6 | P >>> 26, cA = U >> 26, J = kA(L, S, j, e), z = h, q = d, U = (d = kA(u, B, d, _ = d >> 31)) + J | 0, J = h + z | 0, J = U >>> 0 < d >>> 0 ? J + 1 | 0 : J, d = (z = kA(K, E, x, D)) + U | 0, U = h + J | 0, U = d >>> 0 < z >>> 0 ? U + 1 | 0 : U, z = kA(b, a, l, i), J = h + U | 0, J = (d = z + d | 0) >>> 0 < z >>> 0 ? J + 1 | 0 : J, z = kA(R, Q, CA, T), U = h + J | 0, U = ((d = z + d | 0) >>> 0 < z >>> 0 ? U + 1 | 0 : U) << 1 | d >>> 31, d = (J = QA) + (QA = d << 1) | 0, J = U + cA | 0, J = d >>> 0 < QA >>> 0 ? J + 1 | 0 : J, cA = d, QA = d = d + 16777216 | 0, N = (33554431 & (J = d >>> 0 < 16777216 ? J + 1 | 0 : J)) << 7 | d >>> 25, z = J >> 25, J = kA(u, B, CA, T), d = h, U = (q = kA(v, C, q, _)) + J | 0, J = h + d | 0, d = (L = kA(L, S, O, f)) + U | 0, U = h + (U >>> 0 < q >>> 0 ? J + 1 | 0 : J) | 0, U = d >>> 0 < L >>> 0 ? U + 1 | 0 : U, L = kA(j, e, x, D), J = h + U | 0, J = (d = L + d | 0) >>> 0 < L >>> 0 ? J + 1 | 0 : J, U = d, d = kA(b, a, Z, H), J = h + J | 0, J = (U = U + d | 0) >>> 0 < d >>> 0 ? J + 1 | 0 : J, d = (L = kA(R, Q, l, i)) + U | 0, U = h + J | 0, J = (J = (d >>> 0 < L >>> 0 ? U + 1 | 0 : U) << 1 | d >>> 31) + z | 0, q = d = (U = d << 1) + N | 0, J = U >>> 0 > d >>> 0 ? J + 1 | 0 : J, d = (L = d + 33554432 | 0) >>> 0 < 33554432 ? J + 1 | 0 : J, o[A + 128 >> 2] = q - (-67108864 & L), J = kA(X, r, V, t), U = h, q = kA(K, E, l, i), U = h + U | 0, U = (J = q + J | 0) >>> 0 < q >>> 0 ? U + 1 | 0 : U, q = (z = kA(v, C, O, f)) + J | 0, J = h + U | 0, J = q >>> 0 < z >>> 0 ? J + 1 | 0 : J, z = kA(u, B, gA, n), U = h + J | 0, U = (q = z + q | 0) >>> 0 < z >>> 0 ? U + 1 | 0 : U, z = kA(R, Q, $, y), J = h + U | 0, J = (U = Y >> 26) + (((q = z + q | 0) >>> 0 < z >>> 0 ? J + 1 | 0 : J) << 1 | q >>> 31) | 0, J = (Y = (m = (67108863 & Y) << 6 | m >>> 26) + (q << 1) | 0) >>> 0 < m >>> 0 ? J + 1 | 0 : J, m = Y, U = J, q = J = Y + 16777216 | 0, Y = U = J >>> 0 < 16777216 ? U + 1 | 0 : U, o[A + 148 >> 2] = m - (-33554432 & J), J = kA(u, B, W, k), W = h, U = (T = kA(v, C, CA, T)) + J | 0, J = h + W | 0, J = U >>> 0 < T >>> 0 ? J + 1 | 0 : J, x = kA(O, f, x, D), J = h + J | 0, J = (U = x + U | 0) >>> 0 < x >>> 0 ? J + 1 | 0 : J, b = (x = kA(b, a, j, e)) + U | 0, U = h + J | 0, U = b >>> 0 < x >>> 0 ? U + 1 | 0 : U, J = b, b = kA(R, Q, K, E), U = h + U | 0, U = ((J = J + b | 0) >>> 0 < b >>> 0 ? U + 1 | 0 : U) << 1, b = J, J = (J = U | J >>> 31) + (U = d >> 26) | 0, J = (d = (m = b << 1) + (b = (67108863 & d) << 6 | L >>> 26) | 0) >>> 0 < b >>> 0 ? J + 1 | 0 : J, b = d, x = U = d + 16777216 | 0, d = J = U >>> 0 < 16777216 ? J + 1 | 0 : J, o[A + 132 >> 2] = b - (-33554432 & U), J = kA(O, f, X, r), b = h, U = (K = kA(K, E, K, E)) + J | 0, J = h + b | 0, J = U >>> 0 < K >>> 0 ? J + 1 | 0 : J, K = kA(l, i, j, e), J = h + J | 0, J = (U = K + U | 0) >>> 0 < K >>> 0 ? J + 1 | 0 : J, K = kA(v, C, AA, F), J = h + J | 0, J = (U = K + U | 0) >>> 0 < K >>> 0 ? J + 1 | 0 : J, K = (b = kA(u, B, $, y)) + U | 0, U = h + J | 0, U = K >>> 0 < b >>> 0 ? U + 1 | 0 : U, J = K, K = kA(K = R, Q, R = iA, j = R >> 31), U = h + U | 0, U = ((J = J + K | 0) >>> 0 < K >>> 0 ? U + 1 | 0 : U) << 1, K = J, J = (J = U | J >>> 31) + (U = Y >> 25) | 0, J = (Y = (b = K << 1) + (K = (33554431 & Y) << 7 | q >>> 25) | 0) >>> 0 < K >>> 0 ? J + 1 | 0 : J, K = Y, b = U = Y + 33554432 | 0, Y = J = U >>> 0 < 33554432 ? J + 1 | 0 : J, o[A + 152 >> 2] = K - (-67108864 & U), U = s - (J = -67108864 & oA) | 0, K = EA - ((J >>> 0 > s >>> 0) + aA | 0) | 0, J = d >> 25, d = (x = (33554431 & d) << 7 | x >>> 25) + U | 0, U = J + K | 0, K = d, J = U = d >>> 0 < x >>> 0 ? U + 1 | 0 : U, J = ((67108863 & (J = (d = d + 33554432 | 0) >>> 0 < 33554432 ? J + 1 | 0 : J)) << 6 | d >>> 26) + (T = BA - (-33554432 & fA) | 0) | 0, o[A + 140 >> 2] = J, o[A + 136 >> 2] = K - (-67108864 & d), J = kA(l, i, O, f), U = h, d = kA(V, t, Z, H), U = h + U | 0, U = (J = d + J | 0) >>> 0 < d >>> 0 ? U + 1 | 0 : U, d = (l = kA(X, r, gA, n)) + J | 0, J = h + U | 0, J = d >>> 0 < l >>> 0 ? J + 1 | 0 : J, v = kA(v, C, $, y), U = h + J | 0, U = (d = v + d | 0) >>> 0 < v >>> 0 ? U + 1 | 0 : U, v = kA(u, B, R, j), J = h + U | 0, J = (J = ((d = v + d | 0) >>> 0 < v >>> 0 ? J + 1 | 0 : J) << 1 | d >>> 31) + (U = Y >> 26) | 0, U = (Y = (K = d << 1) + (d = (67108863 & Y) << 6 | b >>> 26) | 0) >>> 0 < d >>> 0 ? J + 1 | 0 : J, U = (J = Y + 16777216 | 0) >>> 0 < 16777216 ? U + 1 | 0 : U, o[A + 156 >> 2] = Y - (-33554432 & J), d = cA - (-33554432 & QA) | 0, v = G - (Y = -67108864 & P) | 0, u = IA - ((Y >>> 0 > G >>> 0) + p | 0) | 0, Y = kA((33554431 & U) << 7 | J >>> 25, U >> 25, 19, 0), U = h + u | 0, U = (J = Y + v | 0) >>> 0 < Y >>> 0 ? U + 1 | 0 : U, Y = J, U = ((67108863 & (U = (J = J + 33554432 | 0) >>> 0 < 33554432 ? U + 1 | 0 : U)) << 6 | J >>> 26) + d | 0, o[A + 124 >> 2] = U, o[A + 120 >> 2] = Y - (-67108864 & J), J = o[I + 40 >> 2], U = o[I + 44 >> 2], Y = o[I + 4 >> 2], d = o[I + 48 >> 2], v = o[I + 8 >> 2], u = o[I + 52 >> 2], R = o[I + 12 >> 2], l = o[I + 56 >> 2], K = o[I + 16 >> 2], b = o[I + 60 >> 2], O = o[I + 20 >> 2], j = o[I - -64 >> 2], X = o[I + 24 >> 2], x = o[I + 68 >> 2], T = o[I + 28 >> 2], V = o[I + 72 >> 2], $ = o[I + 32 >> 2], CA = o[I >> 2], o[A + 76 >> 2] = o[I + 76 >> 2] + o[I + 36 >> 2], o[A + 72 >> 2] = V + $, o[A + 68 >> 2] = x + T, o[(gA = A - -64 | 0) >> 2] = X + j, o[A + 60 >> 2] = b + O, o[A + 56 >> 2] = K + l, o[A + 52 >> 2] = R + u, o[A + 48 >> 2] = d + v, o[A + 44 >> 2] = U + Y, o[(I = A + 40 | 0) >> 2] = J + CA, M(g, I), J = o[A + 80 >> 2], U = o[A + 4 >> 2], Y = o[A + 84 >> 2], d = o[A + 8 >> 2], v = o[A + 88 >> 2], u = o[A + 12 >> 2], R = o[A + 92 >> 2], l = o[A + 16 >> 2], K = o[A + 96 >> 2], b = o[A + 20 >> 2], O = o[A + 100 >> 2], j = o[A + 24 >> 2], X = o[A + 104 >> 2], x = o[A + 28 >> 2], T = o[A + 108 >> 2], V = o[A + 32 >> 2], $ = o[A + 112 >> 2], CA = o[A >> 2], L = (W = o[A + 116 >> 2]) - (AA = o[A + 36 >> 2]) | 0, o[A + 116 >> 2] = L, Z = $ - V | 0, o[A + 112 >> 2] = Z, P = T - x | 0, o[A + 108 >> 2] = P, iA = X - j | 0, o[A + 104 >> 2] = iA, EA = O - b | 0, o[A + 100 >> 2] = EA, oA = K - l | 0, o[A + 96 >> 2] = oA, aA = R - u | 0, o[A + 92 >> 2] = aA, BA = v - d | 0, o[A + 88 >> 2] = BA, fA = Y - U | 0, o[A + 84 >> 2] = fA, m = J - CA | 0, o[A + 80 >> 2] = m, W = W + AA | 0, o[A + 76 >> 2] = W, V = V + $ | 0, o[A + 72 >> 2] = V, x = x + T | 0, o[A + 68 >> 2] = x, j = X + j | 0, o[gA >> 2] = j, b = b + O | 0, o[A + 60 >> 2] = b, l = K + l | 0, o[A + 56 >> 2] = l, u = R + u | 0, o[A + 52 >> 2] = u, d = d + v | 0, o[A + 48 >> 2] = d, U = U + Y | 0, o[A + 44 >> 2] = U, Y = I, I = J + CA | 0, o[Y >> 2] = I, J = o[g >> 2], Y = o[g + 4 >> 2], v = o[g + 8 >> 2], R = o[g + 12 >> 2], K = o[g + 16 >> 2], O = o[g + 20 >> 2], X = o[g + 24 >> 2], T = o[g + 28 >> 2], $ = o[g + 32 >> 2], o[A + 36 >> 2] = o[g + 36 >> 2] - W, o[A + 32 >> 2] = $ - V, o[A + 28 >> 2] = T - x, o[A + 24 >> 2] = X - j, o[A + 20 >> 2] = O - b, o[A + 16 >> 2] = K - l, o[A + 12 >> 2] = R - u, o[A + 8 >> 2] = v - d, o[A + 4 >> 2] = Y - U, o[A >> 2] = J - I, I = o[A + 120 >> 2], J = o[A + 124 >> 2], U = o[A + 128 >> 2], Y = o[A + 132 >> 2], d = o[A + 136 >> 2], v = o[A + 140 >> 2], u = o[A + 144 >> 2], R = o[A + 148 >> 2], l = o[A + 152 >> 2], o[A + 156 >> 2] = o[A + 156 >> 2] - L, o[A + 152 >> 2] = l - Z, o[A + 148 >> 2] = R - P, o[A + 144 >> 2] = u - iA, o[A + 140 >> 2] = v - EA, o[A + 136 >> 2] = d - oA, o[A + 132 >> 2] = Y - aA, o[A + 128 >> 2] = U - BA, o[A + 124 >> 2] = J - fA, o[A + 120 >> 2] = I - m, w = g + 48 | 0;
                                    }
                                    function _(A, I, g, C) {
                                        var B = 0, Q = 0, i = 0, E = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, h = 0, n = 0, s = 0, k = 0, F = 0, S = 0, H = 0, G = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, U = 0, Y = 0;
                                        for(B = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, o[g >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, o[g + 4 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, o[g + 8 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, o[g + 12 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, o[g + 16 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, o[g + 20 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, o[g + 24 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, o[g + 28 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 32 | 0] | a[I + 33 | 0] << 8 | a[I + 34 | 0] << 16 | a[I + 35 | 0] << 24, o[g + 32 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 36 | 0] | a[I + 37 | 0] << 8 | a[I + 38 | 0] << 16 | a[I + 39 | 0] << 24, o[g + 36 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 40 | 0] | a[I + 41 | 0] << 8 | a[I + 42 | 0] << 16 | a[I + 43 | 0] << 24, o[g + 40 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 44 | 0] | a[I + 45 | 0] << 8 | a[I + 46 | 0] << 16 | a[I + 47 | 0] << 24, o[g + 44 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 48 | 0] | a[I + 49 | 0] << 8 | a[I + 50 | 0] << 16 | a[I + 51 | 0] << 24, o[g + 48 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 52 | 0] | a[I + 53 | 0] << 8 | a[I + 54 | 0] << 16 | a[I + 55 | 0] << 24, o[g + 52 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 56 | 0] | a[I + 57 | 0] << 8 | a[I + 58 | 0] << 16 | a[I + 59 | 0] << 24, o[g + 56 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, I = a[I + 60 | 0] | a[I + 61 | 0] << 8 | a[I + 62 | 0] << 16 | a[I + 63 | 0] << 24, o[g + 60 >> 2] = I << 24 | (65280 & I) << 8 | I >>> 8 & 65280 | I >>> 24, I = o[A + 28 >> 2], o[C + 24 >> 2] = o[A + 24 >> 2], o[C + 28 >> 2] = I, I = o[A + 20 >> 2], o[C + 16 >> 2] = o[A + 16 >> 2], o[C + 20 >> 2] = I, I = o[A + 12 >> 2], o[C + 8 >> 2] = o[A + 8 >> 2], o[C + 12 >> 2] = I, I = o[A + 4 >> 2], o[C >> 2] = o[A >> 2], o[C + 4 >> 2] = I; f = o[C + 28 >> 2], B = (I = F << 2) + g | 0, i = o[C + 16 >> 2], c = o[B >> 2] + (RA(i, 26) ^ RA(i, 21) ^ RA(i, 7)) | 0, r = (f = ((Q = o[I + 33968 >> 2] + c | 0) + (i & ((c = o[C + 24 >> 2]) ^ (D = o[C + 20 >> 2])) ^ c) | 0) + f | 0) + o[C + 12 >> 2] | 0, o[C + 12 >> 2] = r, f = (y = f + (RA(e = o[C >> 2], 30) ^ RA(e, 19) ^ RA(e, 10)) | 0) + (e & ((Q = o[C + 8 >> 2]) | (E = o[C + 4 >> 2])) | Q & E) | 0, o[C + 28 >> 2] = f, Q = (y = Q) + (c = (o[(h = (Q = 4 | I) + g | 0) >> 2] + ((c + (D ^ r & (i ^ D)) | 0) + (RA(r, 26) ^ RA(r, 21) ^ RA(r, 7)) | 0) | 0) + o[Q + 33968 >> 2] | 0) | 0, o[C + 8 >> 2] = Q, c = (c + (f & (E | e) | E & e) | 0) + (RA(f, 30) ^ RA(f, 19) ^ RA(f, 10)) | 0, o[C + 24 >> 2] = c, D = (y = E) + (E = (((D + o[(k = (E = 8 | I) + g | 0) >> 2] | 0) + o[E + 33968 >> 2] | 0) + (i ^ Q & (i ^ r)) | 0) + (RA(Q, 26) ^ RA(Q, 21) ^ RA(Q, 7)) | 0) | 0, o[C + 4 >> 2] = D, E = E + ((c & (f | e) | f & e) + (RA(c, 30) ^ RA(c, 19) ^ RA(c, 10)) | 0) | 0, o[C + 20 >> 2] = E, i = (y = e) + (e = (((i + o[(S = (e = 12 | I) + g | 0) >> 2] | 0) + o[e + 33968 >> 2] | 0) + (r ^ D & (Q ^ r)) | 0) + (RA(D, 26) ^ RA(D, 21) ^ RA(D, 7)) | 0) | 0, o[C >> 2] = i, e = e + ((E & (f | c) | f & c) + (RA(E, 30) ^ RA(E, 19) ^ RA(E, 10)) | 0) | 0, o[C + 16 >> 2] = e, r = (t = ((((y = r) + o[(H = (r = 16 | I) + g | 0) >> 2] | 0) + o[r + 33968 >> 2] | 0) + (Q ^ i & (Q ^ D)) | 0) + (RA(i, 26) ^ RA(i, 21) ^ RA(i, 7)) | 0) + ((e & (E | c) | E & c) + (RA(e, 30) ^ RA(e, 19) ^ RA(e, 10)) | 0) | 0, o[C + 12 >> 2] = r, t = f + t | 0, o[C + 28 >> 2] = t, f = (Q = (((Q + o[(G = (f = 20 | I) + g | 0) >> 2] | 0) + o[f + 33968 >> 2] | 0) + (D ^ t & (i ^ D)) | 0) + (RA(t, 26) ^ RA(t, 21) ^ RA(t, 7)) | 0) + ((r & (E | e) | E & e) + (RA(r, 30) ^ RA(r, 19) ^ RA(r, 10)) | 0) | 0, o[C + 8 >> 2] = f, Q = Q + c | 0, o[C + 24 >> 2] = Q, c = (D = (((D + o[(_ = (c = 24 | I) + g | 0) >> 2] | 0) + o[c + 33968 >> 2] | 0) + (i ^ Q & (i ^ t)) | 0) + (RA(Q, 26) ^ RA(Q, 21) ^ RA(Q, 7)) | 0) + ((f & (e | r) | e & r) + (RA(f, 30) ^ RA(f, 19) ^ RA(f, 10)) | 0) | 0, o[C + 4 >> 2] = c, D = E + D | 0, o[C + 20 >> 2] = D, E = (i = (((i + o[(M = (E = 28 | I) + g | 0) >> 2] | 0) + o[E + 33968 >> 2] | 0) + (t ^ D & (Q ^ t)) | 0) + (RA(D, 26) ^ RA(D, 21) ^ RA(D, 7)) | 0) + ((c & (f | r) | f & r) + (RA(c, 30) ^ RA(c, 19) ^ RA(c, 10)) | 0) | 0, o[C >> 2] = E, i = i + e | 0, o[C + 16 >> 2] = i, e = (t = (((t + o[(p = (e = 32 | I) + g | 0) >> 2] | 0) + o[e + 33968 >> 2] | 0) + (Q ^ i & (Q ^ D)) | 0) + (RA(i, 26) ^ RA(i, 21) ^ RA(i, 7)) | 0) + ((E & (f | c) | f & c) + (RA(E, 30) ^ RA(E, 19) ^ RA(E, 10)) | 0) | 0, o[C + 28 >> 2] = e, t = r + t | 0, o[C + 12 >> 2] = t, r = (Q = (((Q + o[(N = (r = 36 | I) + g | 0) >> 2] | 0) + o[r + 33968 >> 2] | 0) + (D ^ t & (i ^ D)) | 0) + (RA(t, 26) ^ RA(t, 21) ^ RA(t, 7)) | 0) + ((e & (E | c) | E & c) + (RA(e, 30) ^ RA(e, 19) ^ RA(e, 10)) | 0) | 0, o[C + 24 >> 2] = r, Q = Q + f | 0, o[C + 8 >> 2] = Q, f = (D = (((D + o[(J = (f = 40 | I) + g | 0) >> 2] | 0) + o[f + 33968 >> 2] | 0) + (i ^ Q & (i ^ t)) | 0) + (RA(Q, 26) ^ RA(Q, 21) ^ RA(Q, 7)) | 0) + ((r & (E | e) | E & e) + (RA(r, 30) ^ RA(r, 19) ^ RA(r, 10)) | 0) | 0, o[C + 20 >> 2] = f, D = c + D | 0, o[C + 4 >> 2] = D, y = (c = 44 | I) + g | 0, c = (i = ((i + (o[c + 33968 >> 2] + o[y >> 2] | 0) | 0) + (t ^ D & (Q ^ t)) | 0) + (RA(D, 26) ^ RA(D, 21) ^ RA(D, 7)) | 0) + ((f & (e | r) | e & r) + (RA(f, 30) ^ RA(f, 19) ^ RA(f, 10)) | 0) | 0, o[C + 16 >> 2] = c, E = E + i | 0, o[C >> 2] = E, s = (i = 48 | I) + g | 0, i = (t = ((t + (o[i + 33968 >> 2] + o[s >> 2] | 0) | 0) + (Q ^ E & (Q ^ D)) | 0) + (RA(E, 26) ^ RA(E, 21) ^ RA(E, 7)) | 0) + ((c & (f | r) | f & r) + (RA(c, 30) ^ RA(c, 19) ^ RA(c, 10)) | 0) | 0, o[C + 12 >> 2] = i, e = e + t | 0, o[C + 28 >> 2] = e, n = (t = 52 | I) + g | 0, Q = (t = (((o[t + 33968 >> 2] + o[n >> 2] | 0) + Q | 0) + (D ^ e & (E ^ D)) | 0) + (RA(e, 26) ^ RA(e, 21) ^ RA(e, 7)) | 0) + ((i & (f | c) | f & c) + (RA(i, 30) ^ RA(i, 19) ^ RA(i, 10)) | 0) | 0, o[C + 8 >> 2] = Q, r = r + t | 0, o[C + 24 >> 2] = r, t = (w = 56 | I) + g | 0, D = (w = (((o[w + 33968 >> 2] + o[t >> 2] | 0) + D | 0) + (E ^ r & (E ^ e)) | 0) + (RA(r, 26) ^ RA(r, 21) ^ RA(r, 7)) | 0) + ((Q & (c | i) | c & i) + (RA(Q, 30) ^ RA(Q, 19) ^ RA(Q, 10)) | 0) | 0, o[C + 4 >> 2] = D, f = f + w | 0, o[C + 20 >> 2] = f, w = (I |= 60) + g | 0, f = (I = ((E + (o[I + 33968 >> 2] + o[w >> 2] | 0) | 0) + (e ^ f & (e ^ r)) | 0) + (RA(f, 26) ^ RA(f, 21) ^ RA(f, 7)) | 0) + ((D & (Q | i) | Q & i) + (RA(D, 30) ^ RA(D, 19) ^ RA(D, 10)) | 0) | 0, o[C >> 2] = f, o[C + 16 >> 2] = I + c, 48 != (0 | F);)E = o[N >> 2], F = F + 16 | 0, I = o[t >> 2], f = (Q = o[B >> 2] + (E + (RA(I, 15) ^ RA(I, 13) ^ I >>> 10) | 0) | 0) + (RA(c = o[h >> 2], 25) ^ RA(c, 14) ^ c >>> 3) | 0, o[(F << 2) + g >> 2] = f, r = (i = (Q = (e = o[J >> 2]) + c | 0) + (RA(c = o[w >> 2], 15) ^ RA(c, 13) ^ c >>> 10) | 0) + (RA(Q = o[k >> 2], 25) ^ RA(Q, 14) ^ Q >>> 3) | 0, o[B + 68 >> 2] = r, D = (y = ((i = Q) + (Q = o[y >> 2]) | 0) + (RA(f, 15) ^ RA(f, 13) ^ f >>> 10) | 0) + (RA(i = o[S >> 2], 25) ^ RA(i, 14) ^ i >>> 3) | 0, o[B + 72 >> 2] = D, t = (w = ((y = i) + (i = o[s >> 2]) | 0) + (RA(r, 15) ^ RA(r, 13) ^ r >>> 10) | 0) + (RA(y = o[H >> 2], 25) ^ RA(y, 14) ^ y >>> 3) | 0, o[B + 76 >> 2] = t, s = (w = ((w = y) + (y = o[n >> 2]) | 0) + (RA(D, 15) ^ RA(D, 13) ^ D >>> 10) | 0) + (RA(n = o[G >> 2], 25) ^ RA(n, 14) ^ n >>> 3) | 0, o[B + 80 >> 2] = s, n = (h = (I + n | 0) + (RA(t, 15) ^ RA(t, 13) ^ t >>> 10) | 0) + (RA(w = o[_ >> 2], 25) ^ RA(w, 14) ^ w >>> 3) | 0, o[B + 84 >> 2] = n, w = ((c + w | 0) + (RA(k = o[M >> 2], 25) ^ RA(k, 14) ^ k >>> 3) | 0) + (RA(s, 15) ^ RA(s, 13) ^ s >>> 10) | 0, o[B + 88 >> 2] = w, r = ((h = o[p >> 2]) + (r + (RA(E, 25) ^ RA(E, 14) ^ E >>> 3) | 0) | 0) + (RA(w, 15) ^ RA(w, 13) ^ w >>> 10) | 0, o[B + 96 >> 2] = r, h = ((f + k | 0) + (RA(h, 25) ^ RA(h, 14) ^ h >>> 3) | 0) + (RA(n, 15) ^ RA(n, 13) ^ n >>> 10) | 0, o[B + 92 >> 2] = h, t = (t + (e + (RA(Q, 25) ^ RA(Q, 14) ^ Q >>> 3) | 0) | 0) + (RA(r, 15) ^ RA(r, 13) ^ r >>> 10) | 0, o[B + 104 >> 2] = t, E = (D + (E + (RA(e, 25) ^ RA(e, 14) ^ e >>> 3) | 0) | 0) + (RA(h, 15) ^ RA(h, 13) ^ h >>> 10) | 0, o[B + 100 >> 2] = E, e = (n + (i + (RA(y, 25) ^ RA(y, 14) ^ y >>> 3) | 0) | 0) + (RA(t, 15) ^ RA(t, 13) ^ t >>> 10) | 0, o[B + 112 >> 2] = e, E = (s + (Q + (RA(i, 25) ^ RA(i, 14) ^ i >>> 3) | 0) | 0) + (RA(E, 15) ^ RA(E, 13) ^ E >>> 10) | 0, o[B + 108 >> 2] = E, U = B, Y = (h + (I + (RA(c, 25) ^ RA(c, 14) ^ c >>> 3) | 0) | 0) + (RA(e, 15) ^ RA(e, 13) ^ e >>> 10) | 0, o[U + 120 >> 2] = Y, I = (w + (y + (RA(I, 25) ^ RA(I, 14) ^ I >>> 3) | 0) | 0) + (RA(E, 15) ^ RA(E, 13) ^ E >>> 10) | 0, o[B + 116 >> 2] = I, U = B, Y = (r + (c + (RA(f, 25) ^ RA(f, 14) ^ f >>> 3) | 0) | 0) + (RA(I, 15) ^ RA(I, 13) ^ I >>> 10) | 0, o[U + 124 >> 2] = Y;
                                        o[A >> 2] = f + o[A >> 2], o[A + 4 >> 2] = o[A + 4 >> 2] + o[C + 4 >> 2], o[A + 8 >> 2] = o[A + 8 >> 2] + o[C + 8 >> 2], o[A + 12 >> 2] = o[A + 12 >> 2] + o[C + 12 >> 2], o[A + 16 >> 2] = o[A + 16 >> 2] + o[C + 16 >> 2], o[A + 20 >> 2] = o[A + 20 >> 2] + o[C + 20 >> 2], o[A + 24 >> 2] = o[A + 24 >> 2] + o[C + 24 >> 2], o[A + 28 >> 2] = o[A + 28 >> 2] + o[C + 28 >> 2];
                                    }
                                    function M(A, I) {
                                        var g, C, B, Q, i, E, a, f, e, r, D, t, y, w, n, s, k, F, S, H, G, _, M, p, N, J, U, Y, d, K, b, P, v = 0, L = 0, R = 0, u = 0, x = 0, m = 0, l = 0, z = 0, q = 0, X = 0, j = 0, T = 0, O = 0, V = 0, Z = 0, W = 0, $ = 0, AA = 0, IA = 0, gA = 0, CA = 0, BA = 0;
                                        v = kA(C = (s = o[I + 12 >> 2]) << 1, E = C >> 31, s, G = s >> 31), R = h, L = (q = kA(x = o[I + 16 >> 2], a = x >> 31, f = (u = o[I + 8 >> 2]) << 1, t = f >> 31)) + v | 0, v = h + R | 0, v = L >>> 0 < q >>> 0 ? v + 1 | 0 : v, R = (X = kA(O = (e = o[I + 20 >> 2]) << 1, y = O >> 31, q = (m = o[I + 4 >> 2]) << 1, B = q >> 31)) + L | 0, L = h + v | 0, L = R >>> 0 < X >>> 0 ? L + 1 | 0 : L, l = kA(g = o[I + 24 >> 2], r = g >> 31, X = (W = o[I >> 2]) << 1, Q = X >> 31), v = h + L | 0, v = (R = l + R | 0) >>> 0 < l >>> 0 ? v + 1 | 0 : v, L = R, w = o[I + 32 >> 2], R = kA(j = c(w, 19), D = j >> 31, w, F = w >> 31), v = h + v | 0, v = (L = L + R | 0) >>> 0 < R >>> 0 ? v + 1 | 0 : v, J = o[I + 36 >> 2], R = kA(l = c(J, 38), i = l >> 31, S = (n = o[I + 28 >> 2]) << 1, _ = S >> 31), I = h + v | 0, Z = L = R + L | 0, R = L >>> 0 < R >>> 0 ? I + 1 | 0 : I, I = kA(q, B, x, a), v = h, L = kA(f, t, s, G), v = h + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, z = kA(e, H = e >> 31, X, Q), L = h + v | 0, L = (I = z + I | 0) >>> 0 < z >>> 0 ? L + 1 | 0 : L, z = kA(j, D, S, _), v = h + L | 0, v = (I = z + I | 0) >>> 0 < z >>> 0 ? v + 1 | 0 : v, L = kA(l, i, g, r), v = h + v | 0, CA = I = L + I | 0, T = I >>> 0 < L >>> 0 ? v + 1 | 0 : v, v = kA(q, B, C, E), L = h, M = I = u, u = kA(I, V = I >> 31, I, V), I = h + L | 0, I = (v = u + v | 0) >>> 0 < u >>> 0 ? I + 1 | 0 : I, L = (u = kA(X, Q, x, a)) + v | 0, v = h + I | 0, v = L >>> 0 < u >>> 0 ? v + 1 | 0 : v, I = (u = kA(z = c(n, 38), k = z >> 31, n, p = n >> 31)) + L | 0, L = h + v | 0, L = I >>> 0 < u >>> 0 ? L + 1 | 0 : L, I = (v = I) + (u = kA(j, D, I = g << 1, I >> 31)) | 0, v = h + L | 0, v = I >>> 0 < u >>> 0 ? v + 1 | 0 : v, L = I, I = kA(l, i, O, y), v = h + v | 0, U = L = L + I | 0, Y = v = I >>> 0 > L >>> 0 ? v + 1 | 0 : v, I = v, d = L = L + 33554432 | 0, K = I = L >>> 0 < 33554432 ? I + 1 | 0 : I, v = (v = I >> 26) + T | 0, CA = I = (L = (67108863 & I) << 6 | L >>> 26) + CA | 0, v = I >>> 0 < L >>> 0 ? v + 1 | 0 : v, b = I = I + 16777216 | 0, v = (v = (L = I >>> 0 < 16777216 ? v + 1 | 0 : v) >> 25) + R | 0, I = (I = (33554431 & L) << 7 | I >>> 25) >>> 0 > (L = I + Z | 0) >>> 0 ? v + 1 | 0 : v, Z = v = L + 33554432 | 0, u = I = v >>> 0 < 33554432 ? I + 1 | 0 : I, o[A + 24 >> 2] = L - (-67108864 & v), I = kA(X, Q, M, V), v = h, R = kA(q, B, m, $ = m >> 31), L = h + v | 0, L = (I = R + I | 0) >>> 0 < R >>> 0 ? L + 1 | 0 : L, T = kA(R = c(g, 19), gA = R >> 31, g, r), v = h + L | 0, v = (I = T + I | 0) >>> 0 < T >>> 0 ? v + 1 | 0 : v, L = (T = kA(O, y, z, k)) + I | 0, I = h + v | 0, I = L >>> 0 < T >>> 0 ? I + 1 | 0 : I, AA = kA(j, D, T = x << 1, N = T >> 31), v = h + I | 0, v = (L = AA + L | 0) >>> 0 < AA >>> 0 ? v + 1 | 0 : v, I = L, L = kA(l, i, C, E), v = h + v | 0, IA = I = I + L | 0, AA = I >>> 0 < L >>> 0 ? v + 1 | 0 : v, I = kA(O, y, R, gA), v = h, m = kA(X, Q, m, $), L = h + v | 0, L = (I = m + I | 0) >>> 0 < m >>> 0 ? L + 1 | 0 : L, m = kA(x, a, z, k), v = h + L | 0, v = (I = m + I | 0) >>> 0 < m >>> 0 ? v + 1 | 0 : v, L = (m = kA(j, D, C, E)) + I | 0, I = h + v | 0, I = L >>> 0 < m >>> 0 ? I + 1 | 0 : I, m = kA(l, i, M, V), v = h + I | 0, BA = L = m + L | 0, $ = L >>> 0 < m >>> 0 ? v + 1 | 0 : v, L = kA(I = c(e, 38), I >> 31, e, H), m = h, I = W, W = L, L = kA(I, v = I >> 31, I, v), v = h + m | 0, v = (I = W + L | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, R = kA(R, gA, T, N), L = h + v | 0, L = (I = R + I | 0) >>> 0 < R >>> 0 ? L + 1 | 0 : L, R = kA(C, E, z, k), v = h + L | 0, v = (I = R + I | 0) >>> 0 < R >>> 0 ? v + 1 | 0 : v, L = (R = kA(j, D, f, t)) + I | 0, I = h + v | 0, I = L >>> 0 < R >>> 0 ? I + 1 | 0 : I, R = kA(q, B, l, i), v = h + I | 0, m = L = R + L | 0, W = v = L >>> 0 < R >>> 0 ? v + 1 | 0 : v, gA = L = L + 33554432 | 0, P = v = L >>> 0 < 33554432 ? v + 1 | 0 : v, I = v >> 26, v = (67108863 & v) << 6 | L >>> 26, L = I + $ | 0, $ = R = v + BA | 0, v = v >>> 0 > R >>> 0 ? L + 1 | 0 : L, BA = L = R + 16777216 | 0, R = (33554431 & (v = L >>> 0 < 16777216 ? v + 1 | 0 : v)) << 7 | L >>> 25, v = (v >> 25) + AA | 0, v = (L = R + IA | 0) >>> 0 < R >>> 0 ? v + 1 | 0 : v, AA = I = L + 33554432 | 0, R = v = I >>> 0 < 33554432 ? v + 1 | 0 : v, o[A + 8 >> 2] = L - (-67108864 & I), I = kA(f, t, e, H), v = h, L = kA(x, a, C, E), v = h + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = kA(q, B, g, r), v = h + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = kA(X, Q, n, p), v = h + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, IA = (L = kA(l, i, w, F)) + I | 0, I = h + v | 0, L = (v = u >> 26) + (L = L >>> 0 > IA >>> 0 ? I + 1 | 0 : I) | 0, Z = I = (u = (67108863 & u) << 6 | Z >>> 26) + IA | 0, v = I >>> 0 < u >>> 0 ? L + 1 | 0 : L, IA = I = I + 16777216 | 0, u = v = I >>> 0 < 16777216 ? v + 1 | 0 : v, o[A + 28 >> 2] = Z - (-33554432 & I), I = kA(X, Q, s, G), L = h, v = (V = kA(q, B, M, V)) + I | 0, I = h + L | 0, I = v >>> 0 < V >>> 0 ? I + 1 | 0 : I, v = (z = kA(g, r, z, k)) + v | 0, L = h + I | 0, I = (j = kA(j, D, O, y)) + v | 0, v = h + (v >>> 0 < z >>> 0 ? L + 1 | 0 : L) | 0, v = I >>> 0 < j >>> 0 ? v + 1 | 0 : v, L = kA(l, i, x, a), v = h + v | 0, v = (v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v) + (L = R >> 26) | 0, I = (L = R = (Z = I) + (I = (67108863 & R) << 6 | AA >>> 26) | 0) >>> 0 < I >>> 0 ? v + 1 | 0 : v, j = v = L + 16777216 | 0, R = I = v >>> 0 < 16777216 ? I + 1 | 0 : I, o[A + 12 >> 2] = L - (-33554432 & v), I = kA(g, r, f, t), v = h, L = kA(x, a, x, a), v = h + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = kA(C, E, O, y), v = h + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = (x = kA(q, B, S, _)) + I | 0, I = h + v | 0, I = L >>> 0 < x >>> 0 ? I + 1 | 0 : I, v = (x = kA(X, Q, w, F)) + L | 0, L = h + I | 0, L = v >>> 0 < x >>> 0 ? L + 1 | 0 : L, I = (x = kA(I = l, i, l = J, O = l >> 31)) + v | 0, v = h + L | 0, v = I >>> 0 < x >>> 0 ? v + 1 | 0 : v, L = I, v = (I = u >> 25) + v | 0, v = (L = L + (u = (33554431 & u) << 7 | IA >>> 25) | 0) >>> 0 < u >>> 0 ? v + 1 | 0 : v, x = I = L + 33554432 | 0, u = v = I >>> 0 < 33554432 ? v + 1 | 0 : v, o[A + 32 >> 2] = L - (-67108864 & I), v = R >> 25, L = (R = (33554431 & R) << 7 | j >>> 25) + (U - (I = -67108864 & d) | 0) | 0, I = v + (Y - ((I >>> 0 > U >>> 0) + K | 0) | 0) | 0, I = L >>> 0 < R >>> 0 ? I + 1 | 0 : I, R = L, I = ((67108863 & (v = (L = L + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I)) << 6 | L >>> 26) + (z = CA - (-33554432 & b) | 0) | 0, o[A + 20 >> 2] = I, o[A + 16 >> 2] = R - (-67108864 & L), I = kA(C, E, g, r), L = h, v = (R = kA(e, H, T, N)) + I | 0, I = h + L | 0, I = v >>> 0 < R >>> 0 ? I + 1 | 0 : I, L = (R = kA(f, t, n, p)) + v | 0, v = h + I | 0, v = L >>> 0 < R >>> 0 ? v + 1 | 0 : v, I = (R = kA(q, B, w, F)) + L | 0, L = h + v | 0, L = I >>> 0 < R >>> 0 ? L + 1 | 0 : L, R = (v = I) + (I = kA(X, Q, l, O)) | 0, v = h + L | 0, v = (I = I >>> 0 > R >>> 0 ? v + 1 | 0 : v) + (v = u >> 26) | 0, I = (L = (u = (67108863 & u) << 6 | x >>> 26) + R | 0) >>> 0 < u >>> 0 ? v + 1 | 0 : v, I = (v = L + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I, o[A + 36 >> 2] = L - (-33554432 & v), u = $ - (-33554432 & BA) | 0, R = m - (L = -67108864 & gA) | 0, q = W - ((L >>> 0 > m >>> 0) + P | 0) | 0, I = kA((33554431 & I) << 7 | v >>> 25, I >> 25, 19, 0), v = h + q | 0, I = I >>> 0 > (L = I + R | 0) >>> 0 ? v + 1 | 0 : v, I = ((67108863 & (I = (v = L + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I)) << 6 | v >>> 26) + u | 0, o[A + 4 >> 2] = I, o[A >> 2] = L - (-67108864 & v);
                                    }
                                    function p(A, I, g, C, B) {
                                        var Q, i, f, c, e, r, D, t, y, h, n, s, k, F, S, H = 0, G = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, U = 0, Y = 0, d = 0, K = 0, b = 0, P = 0, v = 0, L = 0, R = 0, u = 0, x = 0, m = 0, l = 0, z = 0, q = 0, X = 0, j = 0, T = 0, O = 0, V = 0, Z = 0, W = 0, $ = 0, AA = 0, IA = 0, gA = 0, CA = 0;
                                        for(Q = w + -64 | 0, i = o[A + 60 >> 2], f = o[A + 56 >> 2], l = o[A + 52 >> 2], m = o[A + 48 >> 2], c = o[A + 44 >> 2], e = o[A + 40 >> 2], r = o[A + 36 >> 2], D = o[A + 32 >> 2], t = o[A + 28 >> 2], y = o[A + 24 >> 2], h = o[A + 20 >> 2], n = o[A + 16 >> 2], s = o[A + 12 >> 2], k = o[A + 8 >> 2], F = o[A + 4 >> 2], S = o[A >> 2];;){
                                            if (!B & C >>> 0 > 63 | B) H = g;
                                            else {
                                                if (o[Q + 56 >> 2] = 0, o[Q + 60 >> 2] = 0, o[Q + 48 >> 2] = 0, o[Q + 52 >> 2] = 0, o[Q + 40 >> 2] = 0, o[Q + 44 >> 2] = 0, o[Q + 32 >> 2] = 0, o[Q + 36 >> 2] = 0, o[Q + 24 >> 2] = 0, o[Q + 28 >> 2] = 0, o[Q + 16 >> 2] = 0, o[Q + 20 >> 2] = 0, o[Q + 8 >> 2] = 0, o[Q + 12 >> 2] = 0, o[Q >> 2] = 0, o[Q + 4 >> 2] = 0, _ = 0, C | B) for(; E[_ + Q | 0] = a[I + _ | 0], !B & (_ = _ + 1 | 0) >>> 0 < C >>> 0 | B;);
                                                I = H = Q, T = g;
                                            }
                                            for(z = 20, G = S, d = F, K = k, v = s, _ = n, g = h, p = y, N = t, J = D, R = r, b = e, M = i, u = f, L = l, P = m, U = c; Y = _, G = RA((_ = G + _ | 0) ^ P, 16), Y = P = RA(Y ^ (J = G + J | 0), 12), P = RA((x = _ + P | 0) ^ G, 8), _ = RA(Y ^ (J = P + J | 0), 7), M = RA((G = N + v | 0) ^ M, 16), N = RA((U = M + U | 0) ^ N, 12), v = RA((K = p + K | 0) ^ u, 16), p = RA((b = v + b | 0) ^ p, 12), u = (q = G + N | 0) + _ | 0, X = RA((K = p + K | 0) ^ v, 8), G = RA(u ^ X, 16), v = RA((d = g + d | 0) ^ L, 16), g = RA((R = v + R | 0) ^ g, 12), Y = _, L = RA((d = g + d | 0) ^ v, 8), Y = RA(Y ^ (_ = (j = L + R | 0) + G | 0), 12), u = RA(G ^ (v = Y + u | 0), 8), _ = RA((R = u + _ | 0) ^ Y, 7), Y = J, J = K, G = RA(M ^ q, 8), K = RA((M = G + U | 0) ^ N, 7), L = RA((J = J + K | 0) ^ L, 16), U = RA((N = Y + L | 0) ^ K, 12), L = RA(L ^ (K = U + J | 0), 8), N = RA((J = N + L | 0) ^ U, 7), U = M, M = d, d = RA((b = b + X | 0) ^ p, 7), p = U + (P = RA((M = M + d | 0) ^ P, 16)) | 0, U = M, M = RA(p ^ d, 12), P = RA(P ^ (d = U + M | 0), 8), p = RA((U = p + P | 0) ^ M, 7), Y = b, M = G, G = RA(g ^ j, 7), M = RA(M ^ (b = G + x | 0), 16), x = RA((g = Y + M | 0) ^ G, 12), M = RA(M ^ (G = x + b | 0), 8), g = RA((b = g + M | 0) ^ x, 7), z = z - 2 | 0;);
                                            if (z = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, x = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, q = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, X = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, j = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, Y = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, O = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, V = a[I + 32 | 0] | a[I + 33 | 0] << 8 | a[I + 34 | 0] << 16 | a[I + 35 | 0] << 24, Z = a[I + 36 | 0] | a[I + 37 | 0] << 8 | a[I + 38 | 0] << 16 | a[I + 39 | 0] << 24, W = a[I + 40 | 0] | a[I + 41 | 0] << 8 | a[I + 42 | 0] << 16 | a[I + 43 | 0] << 24, $ = a[I + 44 | 0] | a[I + 45 | 0] << 8 | a[I + 46 | 0] << 16 | a[I + 47 | 0] << 24, AA = a[I + 48 | 0] | a[I + 49 | 0] << 8 | a[I + 50 | 0] << 16 | a[I + 51 | 0] << 24, IA = a[I + 52 | 0] | a[I + 53 | 0] << 8 | a[I + 54 | 0] << 16 | a[I + 55 | 0] << 24, gA = a[I + 56 | 0] | a[I + 57 | 0] << 8 | a[I + 58 | 0] << 16 | a[I + 59 | 0] << 24, CA = a[I + 60 | 0] | a[I + 61 | 0] << 8 | a[I + 62 | 0] << 16 | a[I + 63 | 0] << 24, G = G + S ^ (a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24), E[0 | H] = G, E[H + 1 | 0] = G >>> 8, E[H + 2 | 0] = G >>> 16, E[H + 3 | 0] = G >>> 24, G = M + i ^ CA, E[H + 60 | 0] = G, E[H + 61 | 0] = G >>> 8, E[H + 62 | 0] = G >>> 16, E[H + 63 | 0] = G >>> 24, G = u + f ^ gA, E[H + 56 | 0] = G, E[H + 57 | 0] = G >>> 8, E[H + 58 | 0] = G >>> 16, E[H + 59 | 0] = G >>> 24, G = L + l ^ IA, E[H + 52 | 0] = G, E[H + 53 | 0] = G >>> 8, E[H + 54 | 0] = G >>> 16, E[H + 55 | 0] = G >>> 24, G = P + m ^ AA, E[H + 48 | 0] = G, E[H + 49 | 0] = G >>> 8, E[H + 50 | 0] = G >>> 16, E[H + 51 | 0] = G >>> 24, G = U + c ^ $, E[H + 44 | 0] = G, E[H + 45 | 0] = G >>> 8, E[H + 46 | 0] = G >>> 16, E[H + 47 | 0] = G >>> 24, G = b + e ^ W, E[H + 40 | 0] = G, E[H + 41 | 0] = G >>> 8, E[H + 42 | 0] = G >>> 16, E[H + 43 | 0] = G >>> 24, G = R + r ^ Z, E[H + 36 | 0] = G, E[H + 37 | 0] = G >>> 8, E[H + 38 | 0] = G >>> 16, E[H + 39 | 0] = G >>> 24, G = J + D ^ V, E[H + 32 | 0] = G, E[H + 33 | 0] = G >>> 8, E[H + 34 | 0] = G >>> 16, E[H + 35 | 0] = G >>> 24, N = N + t ^ O, E[H + 28 | 0] = N, E[H + 29 | 0] = N >>> 8, E[H + 30 | 0] = N >>> 16, E[H + 31 | 0] = N >>> 24, p = Y ^ p + y, E[H + 24 | 0] = p, E[H + 25 | 0] = p >>> 8, E[H + 26 | 0] = p >>> 16, E[H + 27 | 0] = p >>> 24, g = j ^ g + h, E[H + 20 | 0] = g, E[H + 21 | 0] = g >>> 8, E[H + 22 | 0] = g >>> 16, E[H + 23 | 0] = g >>> 24, g = X ^ _ + n, E[H + 16 | 0] = g, E[H + 17 | 0] = g >>> 8, E[H + 18 | 0] = g >>> 16, E[H + 19 | 0] = g >>> 24, g = q ^ v + s, E[H + 12 | 0] = g, E[H + 13 | 0] = g >>> 8, E[H + 14 | 0] = g >>> 16, E[H + 15 | 0] = g >>> 24, g = x ^ K + k, E[H + 8 | 0] = g, E[H + 9 | 0] = g >>> 8, E[H + 10 | 0] = g >>> 16, E[H + 11 | 0] = g >>> 24, g = z ^ d + F, E[H + 4 | 0] = g, E[H + 5 | 0] = g >>> 8, E[H + 6 | 0] = g >>> 16, E[H + 7 | 0] = g >>> 24, l = !(m = m + 1 | 0) + l | 0, !B & C >>> 0 <= 64) {
                                                if (!(!C | !B & C >>> 0 > 63 | 0 != (0 | B))) for(_ = 0; E[_ + T | 0] = a[H + _ | 0], C >>> 0 > (_ = _ + 1 | 0) >>> 0;);
                                                o[A + 52 >> 2] = l, o[A + 48 >> 2] = m;
                                                break;
                                            }
                                            I = I - -64 | 0, g = H - -64 | 0, B = B - 1 | 0, B = (C = C + -64 | 0) >>> 0 < 4294967232 ? B + 1 | 0 : B;
                                        }
                                    }
                                    function N(A, I) {
                                        var g, C = 0, B = 0, Q = 0, i = 0, a = 0, f = 0, c = 0;
                                        w = g = w - 704 | 0, C = 80 + ((B = o[A + 72 >> 2] >>> 3 & 127) + A | 0) | 0, B >>> 0 >= 112 ? (YA(C, 35008, 128 - B | 0), k(A, B = A + 80 | 0, g, g + 640 | 0), dA(B, 0, 112)) : YA(C, 35008, 112 - B | 0), f = (Q = o[A + 64 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = o[A + 68 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, E[A + 192 | 0] = C, E[A + 193 | 0] = C >>> 8, E[A + 194 | 0] = C >>> 16, E[A + 195 | 0] = C >>> 24, B = (C = B | i | f) | (B = 0) | B | 0, E[A + 196 | 0] = B, E[A + 197 | 0] = B >>> 8, E[A + 198 | 0] = B >>> 16, E[A + 199 | 0] = B >>> 24, f = (Q = o[A + 72 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = o[A + 76 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, E[A + 200 | 0] = C, E[A + 201 | 0] = C >>> 8, E[A + 202 | 0] = C >>> 16, E[A + 203 | 0] = C >>> 24, B = (C = B | i | f) | (B = 0) | B | 0, E[A + 204 | 0] = B, E[A + 205 | 0] = B >>> 8, E[A + 206 | 0] = B >>> 16, E[A + 207 | 0] = B >>> 24, k(A, A + 80 | 0, g, g + 640 | 0), f = (Q = o[A >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = o[A + 4 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, E[0 | I] = C, E[I + 1 | 0] = C >>> 8, E[I + 2 | 0] = C >>> 16, E[I + 3 | 0] = C >>> 24, B = (C = B | i | f) | (B = 0) | B | 0, E[I + 4 | 0] = B, E[I + 5 | 0] = B >>> 8, E[I + 6 | 0] = B >>> 16, E[I + 7 | 0] = B >>> 24, f = (Q = o[A + 8 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = o[A + 12 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, E[I + 8 | 0] = C, E[I + 9 | 0] = C >>> 8, E[I + 10 | 0] = C >>> 16, E[I + 11 | 0] = C >>> 24, B = (C = B | i | f) | (B = 0) | B | 0, E[I + 12 | 0] = B, E[I + 13 | 0] = B >>> 8, E[I + 14 | 0] = B >>> 16, E[I + 15 | 0] = B >>> 24, f = (Q = o[A + 16 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = o[A + 20 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, E[I + 16 | 0] = C, E[I + 17 | 0] = C >>> 8, E[I + 18 | 0] = C >>> 16, E[I + 19 | 0] = C >>> 24, B = (C = B | i | f) | (B = 0) | B | 0, E[I + 20 | 0] = B, E[I + 21 | 0] = B >>> 8, E[I + 22 | 0] = B >>> 16, E[I + 23 | 0] = B >>> 24, f = (Q = o[A + 24 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = o[A + 28 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, E[I + 24 | 0] = C, E[I + 25 | 0] = C >>> 8, E[I + 26 | 0] = C >>> 16, E[I + 27 | 0] = C >>> 24, B = (C = B | i | f) | (B = 0) | B | 0, E[I + 28 | 0] = B, E[I + 29 | 0] = B >>> 8, E[I + 30 | 0] = B >>> 16, E[I + 31 | 0] = B >>> 24, f = (Q = o[A + 32 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = o[A + 36 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, E[I + 32 | 0] = C, E[I + 33 | 0] = C >>> 8, E[I + 34 | 0] = C >>> 16, E[I + 35 | 0] = C >>> 24, B = (C = B | i | f) | (B = 0) | B | 0, E[I + 36 | 0] = B, E[I + 37 | 0] = B >>> 8, E[I + 38 | 0] = B >>> 16, E[I + 39 | 0] = B >>> 24, f = (Q = o[A + 40 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = o[A + 44 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, E[I + 40 | 0] = C, E[I + 41 | 0] = C >>> 8, E[I + 42 | 0] = C >>> 16, E[I + 43 | 0] = C >>> 24, B = (C = B | i | f) | (B = 0) | B | 0, E[I + 44 | 0] = B, E[I + 45 | 0] = B >>> 8, E[I + 46 | 0] = B >>> 16, E[I + 47 | 0] = B >>> 24, f = (Q = o[A + 48 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = o[A + 52 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, E[I + 48 | 0] = C, E[I + 49 | 0] = C >>> 8, E[I + 50 | 0] = C >>> 16, E[I + 51 | 0] = C >>> 24, B = (C = B | i | f) | (B = 0) | B | 0, E[I + 52 | 0] = B, E[I + 53 | 0] = B >>> 8, E[I + 54 | 0] = B >>> 16, E[I + 55 | 0] = B >>> 24, f = (Q = o[A + 56 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, C = I, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, I = c | a << 8 | -16777216 & ((255 & (I = o[A + 60 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & I) << 8 | Q >>> 24) | I >>> 8 & 65280 | I >>> 24, E[C + 56 | 0] = I, E[C + 57 | 0] = I >>> 8, E[C + 58 | 0] = I >>> 16, E[C + 59 | 0] = I >>> 24, I = (I = B | i | f) | (B = 0) | B | 0, E[C + 60 | 0] = I, E[C + 61 | 0] = I >>> 8, E[C + 62 | 0] = I >>> 16, E[C + 63 | 0] = I >>> 24, iI(g, 704), iI(A, 208), w = g + 704 | 0;
                                    }
                                    function J(A, I, g) {
                                        var C, B = 0, i = 0, f = 0, c = 0, e = 0, r = 0;
                                        w = C = w + -64 | 0;
                                        A: {
                                            if ((g - 65 & 255) >>> 0 > 191) {
                                                if (B = -1, !(a[A + 80 | 0] | a[A + 81 | 0] << 8 | a[A + 82 | 0] << 16 | a[A + 83 | 0] << 24 | a[A + 84 | 0] | a[A + 85 | 0] << 8 | a[A + 86 | 0] << 16 | a[A + 87 | 0] << 24)) {
                                                    if ((c = a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) >>> 0 >= 129) {
                                                        if (f = a[0 | (B = A - -64 | 0)] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, e = i = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, i = (c = f + 128 | 0) >>> 0 < 128 ? i + 1 | 0 : i, E[0 | B] = c, E[B + 1 | 0] = c >>> 8, E[B + 2 | 0] = c >>> 16, E[B + 3 | 0] = c >>> 24, E[B + 4 | 0] = i, E[B + 5 | 0] = i >>> 8, E[B + 6 | 0] = i >>> 16, E[B + 7 | 0] = i >>> 24, i = a[A + 76 | 0] | a[A + 77 | 0] << 8 | a[A + 78 | 0] << 16 | a[A + 79 | 0] << 24, i = (B = -1 == (0 | e) & f >>> 0 > 4294967167) >>> 0 > (f = B + (a[A + 72 | 0] | a[A + 73 | 0] << 8 | a[A + 74 | 0] << 16 | a[A + 75 | 0] << 24) | 0) >>> 0 ? i + 1 | 0 : i, E[A + 72 | 0] = f, E[A + 73 | 0] = f >>> 8, E[A + 74 | 0] = f >>> 16, E[A + 75 | 0] = f >>> 24, E[A + 76 | 0] = i, E[A + 77 | 0] = i >>> 8, E[A + 78 | 0] = i >>> 16, E[A + 79 | 0] = i >>> 24, n(A, i = A + 96 | 0), B = (a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) - 128 | 0, E[A + 352 | 0] = B, E[A + 353 | 0] = B >>> 8, E[A + 354 | 0] = B >>> 16, E[A + 355 | 0] = B >>> 24, B >>> 0 >= 129) break A;
                                                        YA(i, A + 224 | 0, B), c = a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24;
                                                    }
                                                    i = a[0 | (B = A - -64 | 0)] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, f = r = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, f = (e = i + c | 0) >>> 0 < c >>> 0 ? f + 1 | 0 : f, E[0 | B] = e, E[B + 1 | 0] = e >>> 8, E[B + 2 | 0] = e >>> 16, E[B + 3 | 0] = e >>> 24, E[B + 4 | 0] = f, E[B + 5 | 0] = f >>> 8, E[B + 6 | 0] = f >>> 16, E[B + 7 | 0] = f >>> 24, B = (0 | f) == (0 | r) & i >>> 0 > e >>> 0 | f >>> 0 < r >>> 0, i = a[A + 76 | 0] | a[A + 77 | 0] << 8 | a[A + 78 | 0] << 16 | a[A + 79 | 0] << 24, i = (f = B + (a[A + 72 | 0] | a[A + 73 | 0] << 8 | a[A + 74 | 0] << 16 | a[A + 75 | 0] << 24) | 0) >>> 0 < B >>> 0 ? i + 1 | 0 : i, E[A + 72 | 0] = f, E[A + 73 | 0] = f >>> 8, E[A + 74 | 0] = f >>> 16, E[A + 75 | 0] = f >>> 24, E[A + 76 | 0] = i, E[A + 77 | 0] = i >>> 8, E[A + 78 | 0] = i >>> 16, E[A + 79 | 0] = i >>> 24, a[A + 356 | 0] && (E[A + 88 | 0] = 255, E[A + 89 | 0] = 255, E[A + 90 | 0] = 255, E[A + 91 | 0] = 255, E[A + 92 | 0] = 255, E[A + 93 | 0] = 255, E[A + 94 | 0] = 255, E[A + 95 | 0] = 255), E[A + 80 | 0] = 255, E[A + 81 | 0] = 255, E[A + 82 | 0] = 255, E[A + 83 | 0] = 255, E[A + 84 | 0] = 255, E[A + 85 | 0] = 255, E[A + 86 | 0] = 255, E[A + 87 | 0] = 255, dA((B = A + 96 | 0) + c | 0, 0, 256 - c | 0), n(A, B), i = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, o[C >> 2] = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, o[C + 4 >> 2] = i, i = a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24, o[C + 8 >> 2] = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, o[C + 12 >> 2] = i, i = a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24, o[C + 16 >> 2] = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, o[C + 20 >> 2] = i, i = a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24, o[C + 24 >> 2] = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, o[C + 28 >> 2] = i, i = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24, o[C + 32 >> 2] = a[A + 32 | 0] | a[A + 33 | 0] << 8 | a[A + 34 | 0] << 16 | a[A + 35 | 0] << 24, o[C + 36 >> 2] = i, i = a[A + 44 | 0] | a[A + 45 | 0] << 8 | a[A + 46 | 0] << 16 | a[A + 47 | 0] << 24, o[C + 40 >> 2] = a[A + 40 | 0] | a[A + 41 | 0] << 8 | a[A + 42 | 0] << 16 | a[A + 43 | 0] << 24, o[C + 44 >> 2] = i, i = a[A + 52 | 0] | a[A + 53 | 0] << 8 | a[A + 54 | 0] << 16 | a[A + 55 | 0] << 24, o[C + 48 >> 2] = a[A + 48 | 0] | a[A + 49 | 0] << 8 | a[A + 50 | 0] << 16 | a[A + 51 | 0] << 24, o[C + 52 >> 2] = i, i = a[A + 60 | 0] | a[A + 61 | 0] << 8 | a[A + 62 | 0] << 16 | a[A + 63 | 0] << 24, o[C + 56 >> 2] = a[A + 56 | 0] | a[A + 57 | 0] << 8 | a[A + 58 | 0] << 16 | a[A + 59 | 0] << 24, o[C + 60 >> 2] = i, YA(I, C, g), iI(A, 64), iI(B, 256), B = 0;
                                                }
                                                return w = C - -64 | 0, B;
                                            }
                                            zA(), Q();
                                        }
                                        D(1280, 1142, 306, 1086), Q();
                                    }
                                    function U(A, I) {
                                        var g, C, B, Q, i, f, c, e, r, D, t, y, h, n, s, k, F = 0, S = 0, G = 0, _ = 0, p = 0, N = 0, J = 0;
                                        for(w = g = w - 320 | 0, L(C = A + 40 | 0, I), o[A + 84 >> 2] = 0, o[A + 88 >> 2] = 0, o[A + 80 >> 2] = 1, o[A + 92 >> 2] = 0, o[A + 96 >> 2] = 0, o[A + 100 >> 2] = 0, o[A + 104 >> 2] = 0, o[A + 108 >> 2] = 0, o[A + 112 >> 2] = 0, o[A + 116 >> 2] = 0, M(N = g + 240 | 0, C), H(_ = g + 192 | 0, N, 1344), J = -1, B = o[g + 240 >> 2] - 1 | 0, o[g + 240 >> 2] = B, o[g + 192 >> 2] = o[g + 192 >> 2] + 1, Q = o[g + 244 >> 2], i = o[g + 248 >> 2], f = o[g + 252 >> 2], c = o[g + 256 >> 2], e = o[g + 260 >> 2], r = o[g + 264 >> 2], D = o[g + 268 >> 2], t = o[g + 272 >> 2], y = o[g + 276 >> 2], M(p = g + 144 | 0, _), H(p, p, _), M(A, p), H(A, A, _), H(A, A, N), w = S = w - 144 | 0, M(G = S + 96 | 0, A), M(F = S + 48 | 0, G), M(F, F), H(F, A, F), H(G, G, F), M(G, G), H(G, F, G), M(F, G), M(F, F), M(F, F), M(F, F), M(F, F), H(G, F, G), M(F, G), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), H(F, F, G), M(S, F), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), H(F, S, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), H(G, F, G), M(F, G), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), H(F, F, G), M(S, F), F = 1; M(S, S), 100 != (0 | (F = F + 1 | 0)););
                                        H(F = S + 48 | 0, S, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), H(G = S + 96 | 0, F, G), M(G, G), M(G, G), H(A, G, A), w = S + 144 | 0, H(A, A, p), H(A, A, N), M(F = g + 96 | 0, A), H(F, F, _), F = o[g + 132 >> 2], o[g + 84 >> 2] = F - y, S = o[g + 128 >> 2], o[g + 80 >> 2] = S - t, G = o[g + 124 >> 2], o[g + 76 >> 2] = G - D, _ = o[g + 120 >> 2], o[g + 72 >> 2] = _ - r, p = o[g + 116 >> 2], o[g + 68 >> 2] = p - e, N = o[g + 112 >> 2], o[g + 64 >> 2] = N - c, h = o[g + 108 >> 2], o[g + 60 >> 2] = h - f, n = o[g + 104 >> 2], o[g + 56 >> 2] = n - i, s = o[g + 100 >> 2], o[g + 52 >> 2] = s - Q, k = o[g + 96 >> 2], o[g + 48 >> 2] = k - B, IA(g, g + 48 | 0);
                                        A: {
                                            if (!fA(g, 32)) {
                                                if (o[g + 36 >> 2] = F + y, o[g + 32 >> 2] = S + t, o[g + 28 >> 2] = G + D, o[g + 24 >> 2] = _ + r, o[g + 20 >> 2] = p + e, o[g + 16 >> 2] = N + c, o[g + 12 >> 2] = f + h, o[g + 8 >> 2] = i + n, o[g + 4 >> 2] = Q + s, o[g >> 2] = B + k, IA(F = g + 288 | 0, g), !fA(F, 32)) break A;
                                                H(A, A, 1392);
                                            }
                                            IA(g + 288 | 0, A), (1 & E[g + 288 | 0]) == (a[I + 31 | 0] >>> 7 | 0) && (o[A >> 2] = 0 - o[A >> 2], o[A + 36 >> 2] = 0 - o[A + 36 >> 2], o[A + 32 >> 2] = 0 - o[A + 32 >> 2], o[A + 28 >> 2] = 0 - o[A + 28 >> 2], o[A + 24 >> 2] = 0 - o[A + 24 >> 2], o[A + 20 >> 2] = 0 - o[A + 20 >> 2], o[A + 16 >> 2] = 0 - o[A + 16 >> 2], o[A + 12 >> 2] = 0 - o[A + 12 >> 2], o[A + 8 >> 2] = 0 - o[A + 8 >> 2], o[A + 4 >> 2] = 0 - o[A + 4 >> 2]), H(A + 120 | 0, A, C), J = 0;
                                        }
                                        return w = g + 320 | 0, J;
                                    }
                                    function Y(A, I, g) {
                                        var C, B, Q, i, o, f, c, e, r, D, t, y, w = 0, h = 0, n = 0, s = 0, k = 0, F = 0, S = 0, H = 0, G = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, U = 0, Y = 0, d = 0, K = 0, b = 0, P = 0;
                                        for(k = 1634760805, h = C = a[0 | g] | a[g + 1 | 0] << 8 | a[g + 2 | 0] << 16 | a[g + 3 | 0] << 24, F = B = a[g + 4 | 0] | a[g + 5 | 0] << 8 | a[g + 6 | 0] << 16 | a[g + 7 | 0] << 24, S = Q = a[g + 8 | 0] | a[g + 9 | 0] << 8 | a[g + 10 | 0] << 16 | a[g + 11 | 0] << 24, H = i = a[g + 12 | 0] | a[g + 13 | 0] << 8 | a[g + 14 | 0] << 16 | a[g + 15 | 0] << 24, p = 857760878, G = o = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, n = f = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, M = c = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, J = e = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, I = 2036477234, s = r = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, w = 1797285236, U = D = a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24, N = t = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, g = y = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24; _ = RA(h + p | 0, 7) ^ J, Y = RA(_ + p | 0, 9) ^ N, H = RA(g + k | 0, 7) ^ H, d = RA(H + k | 0, 9) ^ M, b = RA(d + H | 0, 13) ^ g, S = RA(w + s | 0, 7) ^ S, K = RA(S + w | 0, 9) ^ n, M = RA(S + K | 0, 13) ^ s, s = RA(K + M | 0, 18) ^ w, n = RA(I + G | 0, 7) ^ U, g = b ^ RA(s + n | 0, 7), N = Y ^ RA(g + s | 0, 9), U = RA(g + N | 0, 13) ^ n, w = RA(N + U | 0, 18) ^ s, F = RA(I + n | 0, 9) ^ F, G = RA(F + n | 0, 13) ^ G, I = RA(G + F | 0, 18) ^ I, s = RA(I + _ | 0, 7) ^ M, M = RA(s + I | 0, 9) ^ d, J = RA(s + M | 0, 13) ^ _, I = RA(M + J | 0, 18) ^ I, _ = RA(_ + Y | 0, 13) ^ h, h = RA(_ + Y | 0, 18) ^ p, G = RA(h + H | 0, 7) ^ G, n = RA(G + h | 0, 9) ^ K, H = RA(n + G | 0, 13) ^ H, p = RA(n + H | 0, 18) ^ h, k = RA(d + b | 0, 18) ^ k, h = RA(k + S | 0, 7) ^ _, F = RA(h + k | 0, 9) ^ F, S = RA(h + F | 0, 13) ^ S, k = RA(F + S | 0, 18) ^ k, _ = P >>> 0 < 18, P = P + 2 | 0, _;);
                                        w = w + 1797285236 | 0, E[A + 60 | 0] = w, E[A + 61 | 0] = w >>> 8, E[A + 62 | 0] = w >>> 16, E[A + 63 | 0] = w >>> 24, w = U + D | 0, E[A + 56 | 0] = w, E[A + 57 | 0] = w >>> 8, E[A + 58 | 0] = w >>> 16, E[A + 59 | 0] = w >>> 24, w = N + t | 0, E[A + 52 | 0] = w, E[A + 53 | 0] = w >>> 8, E[A + 54 | 0] = w >>> 16, E[A + 55 | 0] = w >>> 24, g = g + y | 0, E[A + 48 | 0] = g, E[A + 49 | 0] = g >>> 8, E[A + 50 | 0] = g >>> 16, E[A + 51 | 0] = g >>> 24, g = s + r | 0, E[A + 44 | 0] = g, E[A + 45 | 0] = g >>> 8, E[A + 46 | 0] = g >>> 16, E[A + 47 | 0] = g >>> 24, I = I + 2036477234 | 0, E[A + 40 | 0] = I, E[A + 41 | 0] = I >>> 8, E[A + 42 | 0] = I >>> 16, E[A + 43 | 0] = I >>> 24, I = J + e | 0, E[A + 36 | 0] = I, E[A + 37 | 0] = I >>> 8, E[A + 38 | 0] = I >>> 16, E[A + 39 | 0] = I >>> 24, I = M + c | 0, E[A + 32 | 0] = I, E[A + 33 | 0] = I >>> 8, E[A + 34 | 0] = I >>> 16, E[A + 35 | 0] = I >>> 24, I = n + f | 0, E[A + 28 | 0] = I, E[A + 29 | 0] = I >>> 8, E[A + 30 | 0] = I >>> 16, E[A + 31 | 0] = I >>> 24, I = G + o | 0, E[A + 24 | 0] = I, E[A + 25 | 0] = I >>> 8, E[A + 26 | 0] = I >>> 16, E[A + 27 | 0] = I >>> 24, I = p + 857760878 | 0, E[A + 20 | 0] = I, E[A + 21 | 0] = I >>> 8, E[A + 22 | 0] = I >>> 16, E[A + 23 | 0] = I >>> 24, I = H + i | 0, E[A + 16 | 0] = I, E[A + 17 | 0] = I >>> 8, E[A + 18 | 0] = I >>> 16, E[A + 19 | 0] = I >>> 24, I = S + Q | 0, E[A + 12 | 0] = I, E[A + 13 | 0] = I >>> 8, E[A + 14 | 0] = I >>> 16, E[A + 15 | 0] = I >>> 24, I = F + B | 0, E[A + 8 | 0] = I, E[A + 9 | 0] = I >>> 8, E[A + 10 | 0] = I >>> 16, E[A + 11 | 0] = I >>> 24, I = h + C | 0, E[A + 4 | 0] = I, E[A + 5 | 0] = I >>> 8, E[A + 6 | 0] = I >>> 16, E[A + 7 | 0] = I >>> 24, I = k + 1634760805 | 0, E[0 | A] = I, E[A + 1 | 0] = I >>> 8, E[A + 2 | 0] = I >>> 16, E[A + 3 | 0] = I >>> 24;
                                    }
                                    function d(A, I, g, C) {
                                        var B = 0, Q = 0, i = 0, E = 0, f = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, n = 0, s = 0, k = 0, F = 0, S = 0, H = 0, G = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, U = 0, Y = 0;
                                        if (w = o[A + 36 >> 2], t = o[A + 32 >> 2], y = o[A + 28 >> 2], r = o[A + 24 >> 2], D = o[A + 20 >> 2], !C & g >>> 0 >= 16 | C) for(p = !a[A + 80 | 0] << 24, s = o[A + 4 >> 2], N = c(s, 5), F = o[A + 8 >> 2], _ = c(F, 5), H = o[A + 12 >> 2], G = c(H, 5), M = o[A + 16 >> 2], S = c(M, 5), k = o[A >> 2]; B = kA(i = ((a[I + 3 | 0] | a[I + 4 | 0] << 8 | a[I + 5 | 0] << 16 | a[I + 6 | 0] << 24) >>> 2 & 67108863) + r | 0, 0, H, 0), f = h, D = (E = kA(r = (67108863 & (a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24)) + D | 0, 0, M, 0)) + B | 0, B = h + f | 0, B = E >>> 0 > D >>> 0 ? B + 1 | 0 : B, f = kA(y = ((a[I + 6 | 0] | a[I + 7 | 0] << 8 | a[I + 8 | 0] << 16 | a[I + 9 | 0] << 24) >>> 4 & 67108863) + y | 0, 0, F, 0), B = h + B | 0, B = f >>> 0 > (D = f + D | 0) >>> 0 ? B + 1 | 0 : B, f = kA(t = ((a[I + 9 | 0] | a[I + 10 | 0] << 8 | a[I + 11 | 0] << 16 | a[I + 12 | 0] << 24) >>> 6 | 0) + t | 0, 0, s, 0), B = h + B | 0, B = f >>> 0 > (D = f + D | 0) >>> 0 ? B + 1 | 0 : B, f = kA(w = w + p + ((a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24) >>> 8) | 0, 0, k, 0), B = h + B | 0, J = D = f + D | 0, D = f >>> 0 > D >>> 0 ? B + 1 | 0 : B, B = kA(i, 0, F, 0), f = h, E = kA(r, 0, H, 0), Q = h + f | 0, Q = (B = E + B | 0) >>> 0 < E >>> 0 ? Q + 1 | 0 : Q, f = (E = kA(y, 0, s, 0)) + B | 0, B = h + Q | 0, B = E >>> 0 > f >>> 0 ? B + 1 | 0 : B, E = kA(t, 0, k, 0), B = h + B | 0, B = E >>> 0 > (f = E + f | 0) >>> 0 ? B + 1 | 0 : B, E = kA(w, 0, S, 0), B = h + B | 0, U = f = E + f | 0, f = E >>> 0 > f >>> 0 ? B + 1 | 0 : B, B = kA(i, 0, s, 0), e = h, E = (Q = kA(r, 0, F, 0)) + B | 0, B = h + e | 0, B = Q >>> 0 > E >>> 0 ? B + 1 | 0 : B, e = kA(y, 0, k, 0), Q = h + B | 0, Q = (E = e + E | 0) >>> 0 < e >>> 0 ? Q + 1 | 0 : Q, e = kA(t, 0, S, 0), B = h + Q | 0, B = (E = e + E | 0) >>> 0 < e >>> 0 ? B + 1 | 0 : B, e = kA(w, 0, G, 0), B = h + B | 0, Y = E = e + E | 0, E = E >>> 0 < e >>> 0 ? B + 1 | 0 : B, B = kA(i, 0, k, 0), Q = h, e = (n = kA(r, 0, s, 0)) + B | 0, B = h + Q | 0, B = e >>> 0 < n >>> 0 ? B + 1 | 0 : B, Q = kA(y, 0, S, 0), B = h + B | 0, B = Q >>> 0 > (e = Q + e | 0) >>> 0 ? B + 1 | 0 : B, n = kA(t, 0, G, 0), Q = h + B | 0, Q = (e = n + e | 0) >>> 0 < n >>> 0 ? Q + 1 | 0 : Q, n = kA(w, 0, _, 0), B = h + Q | 0, B = (e = n + e | 0) >>> 0 < n >>> 0 ? B + 1 | 0 : B, n = e, e = B, B = kA(i, 0, S, 0), Q = h, i = (r = kA(r, 0, k, 0)) + B | 0, B = h + Q | 0, B = i >>> 0 < r >>> 0 ? B + 1 | 0 : B, r = kA(y, 0, G, 0), B = h + B | 0, B = (i = r + i | 0) >>> 0 < r >>> 0 ? B + 1 | 0 : B, r = kA(t, 0, _, 0), B = h + B | 0, B = (i = r + i | 0) >>> 0 < r >>> 0 ? B + 1 | 0 : B, r = kA(w, 0, N, 0), Q = h + B | 0, Q = (i = r + i | 0) >>> 0 < r >>> 0 ? Q + 1 | 0 : Q, r = i, B = e, B = (i = (y = (67108863 & Q) << 6 | i >>> 26) + n | 0) >>> 0 < y >>> 0 ? B + 1 | 0 : B, y = i, t = (67108863 & B) << 6 | i >>> 26, B = E, B = (i = t + Y | 0) >>> 0 < t >>> 0 ? B + 1 | 0 : B, t = i, Q = f, w = B = (i = (67108863 & B) << 6 | i >>> 26) + U | 0, f = (67108863 & (Q = B >>> 0 < i >>> 0 ? Q + 1 | 0 : Q)) << 6 | B >>> 26, B = D, r = (67108863 & y) + ((B = c((67108863 & ((i = f + J | 0) >>> 0 < f >>> 0 ? B + 1 | 0 : B)) << 6 | i >>> 26, 5) + (67108863 & r) | 0) >>> 26 | 0) | 0, y = 67108863 & t, t = 67108863 & w, w = 67108863 & i, D = 67108863 & B, I = I + 16 | 0, !(C = C - (g >>> 0 < 16) | 0) & (g = g - 16 | 0) >>> 0 > 15 | C;);
                                        o[A + 20 >> 2] = D, o[A + 36 >> 2] = w, o[A + 32 >> 2] = t, o[A + 28 >> 2] = y, o[A + 24 >> 2] = r;
                                    }
                                    function K(A, I, g, C) {
                                        A |= 0, I |= 0;
                                        var B = 0;
                                        return B = -1, (C |= 0) - 65 >>> 0 < 4294967232 | (g |= 0) >>> 0 > 64 || (g && I ? (w = B = w - 128 | 0, !I | ((C &= 255) - 65 & 255) >>> 0 <= 191 | ((g &= 255) - 65 & 255) >>> 0 <= 191 ? (zA(), Q()) : (dA(A - -64 | 0, 0, 293), E[A + 56 | 0] = 121, E[A + 57 | 0] = 33, E[A + 58 | 0] = 126, E[A + 59 | 0] = 19, E[A + 60 | 0] = 25, E[A + 61 | 0] = 205, E[A + 62 | 0] = 224, E[A + 63 | 0] = 91, E[A + 48 | 0] = 107, E[A + 49 | 0] = 189, E[A + 50 | 0] = 65, E[A + 51 | 0] = 251, E[A + 52 | 0] = 171, E[A + 53 | 0] = 217, E[A + 54 | 0] = 131, E[A + 55 | 0] = 31, E[A + 40 | 0] = 31, E[A + 41 | 0] = 108, E[A + 42 | 0] = 62, E[A + 43 | 0] = 43, E[A + 44 | 0] = 140, E[A + 45 | 0] = 104, E[A + 46 | 0] = 5, E[A + 47 | 0] = 155, E[A + 32 | 0] = 209, E[A + 33 | 0] = 130, E[A + 34 | 0] = 230, E[A + 35 | 0] = 173, E[A + 36 | 0] = 127, E[A + 37 | 0] = 82, E[A + 38 | 0] = 14, E[A + 39 | 0] = 81, E[A + 24 | 0] = 241, E[A + 25 | 0] = 54, E[A + 26 | 0] = 29, E[A + 27 | 0] = 95, E[A + 28 | 0] = 58, E[A + 29 | 0] = 245, E[A + 30 | 0] = 79, E[A + 31 | 0] = 165, E[A + 16 | 0] = 43, E[A + 17 | 0] = 248, E[A + 18 | 0] = 148, E[A + 19 | 0] = 254, E[A + 20 | 0] = 114, E[A + 21 | 0] = 243, E[A + 22 | 0] = 110, E[A + 23 | 0] = 60, E[A + 8 | 0] = 59, E[A + 9 | 0] = 167, E[A + 10 | 0] = 202, E[A + 11 | 0] = 132, E[A + 12 | 0] = 133, E[A + 13 | 0] = 174, E[A + 14 | 0] = 103, E[A + 15 | 0] = 187, C = -222443256 ^ (g << 8 | C), E[0 | A] = C, E[A + 1 | 0] = C >>> 8, E[A + 2 | 0] = C >>> 16, E[A + 3 | 0] = C >>> 24, C = g >>> 24 ^ 1779033703, E[A + 4 | 0] = C, E[A + 5 | 0] = C >>> 8, E[A + 6 | 0] = C >>> 16, E[A + 7 | 0] = C >>> 24, dA(g + B | 0, 0, g << 24 >> 24 >= 0 ? 128 - g | 0 : 0), g = YA(B, I, g), YA(A + 96 | 0, g, 128), I = 128 + (a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) | 0, E[A + 352 | 0] = I, E[A + 353 | 0] = I >>> 8, E[A + 354 | 0] = I >>> 16, E[A + 355 | 0] = I >>> 24, iI(g, 128), w = g + 128 | 0)) : (((I = 255 & C) - 65 & 255) >>> 0 <= 191 && (zA(), Q()), dA(A - -64 | 0, 0, 293), E[A + 56 | 0] = 121, E[A + 57 | 0] = 33, E[A + 58 | 0] = 126, E[A + 59 | 0] = 19, E[A + 60 | 0] = 25, E[A + 61 | 0] = 205, E[A + 62 | 0] = 224, E[A + 63 | 0] = 91, E[A + 48 | 0] = 107, E[A + 49 | 0] = 189, E[A + 50 | 0] = 65, E[A + 51 | 0] = 251, E[A + 52 | 0] = 171, E[A + 53 | 0] = 217, E[A + 54 | 0] = 131, E[A + 55 | 0] = 31, E[A + 40 | 0] = 31, E[A + 41 | 0] = 108, E[A + 42 | 0] = 62, E[A + 43 | 0] = 43, E[A + 44 | 0] = 140, E[A + 45 | 0] = 104, E[A + 46 | 0] = 5, E[A + 47 | 0] = 155, E[A + 32 | 0] = 209, E[A + 33 | 0] = 130, E[A + 34 | 0] = 230, E[A + 35 | 0] = 173, E[A + 36 | 0] = 127, E[A + 37 | 0] = 82, E[A + 38 | 0] = 14, E[A + 39 | 0] = 81, E[A + 24 | 0] = 241, E[A + 25 | 0] = 54, E[A + 26 | 0] = 29, E[A + 27 | 0] = 95, E[A + 28 | 0] = 58, E[A + 29 | 0] = 245, E[A + 30 | 0] = 79, E[A + 31 | 0] = 165, E[A + 16 | 0] = 43, E[A + 17 | 0] = 248, E[A + 18 | 0] = 148, E[A + 19 | 0] = 254, E[A + 20 | 0] = 114, E[A + 21 | 0] = 243, E[A + 22 | 0] = 110, E[A + 23 | 0] = 60, E[A + 8 | 0] = 59, E[A + 9 | 0] = 167, E[A + 10 | 0] = 202, E[A + 11 | 0] = 132, E[A + 12 | 0] = 133, E[A + 13 | 0] = 174, E[A + 14 | 0] = 103, E[A + 15 | 0] = 187, I ^= -222443256, E[0 | A] = I, E[A + 1 | 0] = I >>> 8, E[A + 2 | 0] = I >>> 16, E[A + 3 | 0] = I >>> 24, E[A + 4 | 0] = 103, E[A + 5 | 0] = 230, E[A + 6 | 0] = 9, E[A + 7 | 0] = 106), B = 0), 0 | B;
                                    }
                                    function b(A, I, g) {
                                        var C, B, Q, i, E, a, f, c, e, r, D, t = 0, y = 0, w = 0, h = 0, n = 0, s = 0, k = 0, F = 0, S = 0, G = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, U = 0, Y = 0, d = 0, K = 0;
                                        t = o[I + 40 >> 2], y = o[I + 4 >> 2], h = o[I + 44 >> 2], n = o[I + 8 >> 2], s = o[I + 48 >> 2], k = o[I + 12 >> 2], F = o[I + 52 >> 2], S = o[I + 16 >> 2], G = o[I + 56 >> 2], _ = o[I + 20 >> 2], M = o[I + 60 >> 2], p = o[I + 24 >> 2], N = o[(w = I - -64 | 0) >> 2], J = o[I + 28 >> 2], U = o[I + 68 >> 2], Y = o[I + 32 >> 2], d = o[I + 72 >> 2], K = o[I >> 2], o[A + 36 >> 2] = o[I + 36 >> 2] + o[I + 76 >> 2], o[A + 32 >> 2] = Y + d, o[A + 28 >> 2] = J + U, o[A + 24 >> 2] = p + N, o[A + 20 >> 2] = _ + M, o[A + 16 >> 2] = S + G, o[A + 12 >> 2] = k + F, o[A + 8 >> 2] = n + s, o[A + 4 >> 2] = y + h, o[A >> 2] = t + K, h = o[I + 40 >> 2], t = o[I + 4 >> 2], n = o[I + 44 >> 2], s = o[I + 8 >> 2], k = o[I + 48 >> 2], F = o[I + 12 >> 2], S = o[I + 52 >> 2], G = o[I + 16 >> 2], _ = o[I + 56 >> 2], M = o[I + 20 >> 2], p = o[I + 60 >> 2], N = o[I + 24 >> 2], w = o[w >> 2], y = o[I + 28 >> 2], J = o[I + 68 >> 2], U = o[I + 32 >> 2], Y = o[I + 72 >> 2], d = o[I >> 2], o[A + 76 >> 2] = o[I + 76 >> 2] - o[I + 36 >> 2], o[A + 72 >> 2] = Y - U, o[A + 68 >> 2] = J - y, o[(y = A - -64 | 0) >> 2] = w - N, o[A + 60 >> 2] = p - M, o[A + 56 >> 2] = _ - G, o[A + 52 >> 2] = S - F, o[A + 48 >> 2] = k - s, o[A + 44 >> 2] = n - t, o[(t = A + 40 | 0) >> 2] = h - d, H(A + 80 | 0, A, g), H(t, t, g + 40 | 0), H(A + 120 | 0, g + 120 | 0, I + 120 | 0), H(A, I + 80 | 0, g + 80 | 0), K = o[A + 4 >> 2], Q = o[A + 8 >> 2], i = o[A + 12 >> 2], E = o[A + 16 >> 2], a = o[A + 20 >> 2], f = o[A + 24 >> 2], c = o[A + 28 >> 2], e = o[A + 32 >> 2], r = o[A + 36 >> 2], I = o[t >> 2], g = o[A + 80 >> 2], h = o[A + 44 >> 2], n = o[A + 84 >> 2], s = o[A + 48 >> 2], k = o[A + 88 >> 2], F = o[A + 52 >> 2], S = o[A + 92 >> 2], G = o[A + 56 >> 2], _ = o[A + 96 >> 2], M = o[A + 60 >> 2], p = o[A + 100 >> 2], w = o[y >> 2], N = o[A + 104 >> 2], J = o[A + 68 >> 2], U = o[A + 108 >> 2], Y = o[A + 72 >> 2], d = o[A + 112 >> 2], D = o[A >> 2], C = o[A + 76 >> 2], B = o[A + 116 >> 2], o[A + 76 >> 2] = C + B, o[A + 72 >> 2] = Y + d, o[A + 68 >> 2] = J + U, o[y >> 2] = w + N, o[A + 60 >> 2] = M + p, o[A + 56 >> 2] = G + _, o[A + 52 >> 2] = F + S, o[A + 48 >> 2] = s + k, o[A + 44 >> 2] = h + n, o[t >> 2] = I + g, o[A + 36 >> 2] = B - C, o[A + 32 >> 2] = d - Y, o[A + 28 >> 2] = U - J, o[A + 24 >> 2] = N - w, o[A + 20 >> 2] = p - M, o[A + 16 >> 2] = _ - G, o[A + 12 >> 2] = S - F, o[A + 8 >> 2] = k - s, o[A + 4 >> 2] = n - h, o[A >> 2] = g - I, I = r << 1, g = o[A + 156 >> 2], o[A + 156 >> 2] = I - g, t = e << 1, y = o[A + 152 >> 2], o[A + 152 >> 2] = t - y, h = c << 1, n = o[A + 148 >> 2], o[A + 148 >> 2] = h - n, s = f << 1, k = o[A + 144 >> 2], o[A + 144 >> 2] = s - k, F = a << 1, S = o[A + 140 >> 2], o[A + 140 >> 2] = F - S, G = E << 1, _ = o[A + 136 >> 2], o[A + 136 >> 2] = G - _, M = i << 1, p = o[A + 132 >> 2], o[A + 132 >> 2] = M - p, w = Q << 1, N = o[A + 128 >> 2], o[A + 128 >> 2] = w - N, J = K << 1, U = o[A + 124 >> 2], o[A + 124 >> 2] = J - U, Y = D << 1, d = o[A + 120 >> 2], o[A + 120 >> 2] = Y - d, o[A + 112 >> 2] = t + y, o[A + 108 >> 2] = h + n, o[A + 104 >> 2] = s + k, o[A + 100 >> 2] = F + S, o[A + 96 >> 2] = G + _, o[A + 92 >> 2] = M + p, o[A + 88 >> 2] = w + N, o[A + 84 >> 2] = J + U, o[A + 80 >> 2] = Y + d, o[A + 116 >> 2] = I + g;
                                    }
                                    function P(A, I, g) {
                                        var C, B, Q, i, E, a, f, c, e, r, D, t = 0, y = 0, w = 0, h = 0, n = 0, s = 0, k = 0, F = 0, S = 0, G = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, U = 0, Y = 0, d = 0, K = 0;
                                        t = o[I + 40 >> 2], y = o[I + 4 >> 2], h = o[I + 44 >> 2], n = o[I + 8 >> 2], s = o[I + 48 >> 2], k = o[I + 12 >> 2], F = o[I + 52 >> 2], S = o[I + 16 >> 2], G = o[I + 56 >> 2], _ = o[I + 20 >> 2], M = o[I + 60 >> 2], p = o[I + 24 >> 2], N = o[(w = I - -64 | 0) >> 2], J = o[I + 28 >> 2], U = o[I + 68 >> 2], Y = o[I + 32 >> 2], d = o[I + 72 >> 2], K = o[I >> 2], o[A + 36 >> 2] = o[I + 36 >> 2] + o[I + 76 >> 2], o[A + 32 >> 2] = Y + d, o[A + 28 >> 2] = J + U, o[A + 24 >> 2] = p + N, o[A + 20 >> 2] = _ + M, o[A + 16 >> 2] = S + G, o[A + 12 >> 2] = k + F, o[A + 8 >> 2] = n + s, o[A + 4 >> 2] = y + h, o[A >> 2] = t + K, h = o[I + 40 >> 2], t = o[I + 4 >> 2], n = o[I + 44 >> 2], s = o[I + 8 >> 2], k = o[I + 48 >> 2], F = o[I + 12 >> 2], S = o[I + 52 >> 2], G = o[I + 16 >> 2], _ = o[I + 56 >> 2], M = o[I + 20 >> 2], p = o[I + 60 >> 2], N = o[I + 24 >> 2], w = o[w >> 2], y = o[I + 28 >> 2], J = o[I + 68 >> 2], U = o[I + 32 >> 2], Y = o[I + 72 >> 2], d = o[I >> 2], o[A + 76 >> 2] = o[I + 76 >> 2] - o[I + 36 >> 2], o[A + 72 >> 2] = Y - U, o[A + 68 >> 2] = J - y, o[(y = A - -64 | 0) >> 2] = w - N, o[A + 60 >> 2] = p - M, o[A + 56 >> 2] = _ - G, o[A + 52 >> 2] = S - F, o[A + 48 >> 2] = k - s, o[A + 44 >> 2] = n - t, o[(t = A + 40 | 0) >> 2] = h - d, H(A + 80 | 0, A, g + 40 | 0), H(t, t, g), H(A + 120 | 0, g + 120 | 0, I + 120 | 0), H(A, I + 80 | 0, g + 80 | 0), K = o[A + 4 >> 2], Q = o[A + 8 >> 2], i = o[A + 12 >> 2], E = o[A + 16 >> 2], a = o[A + 20 >> 2], f = o[A + 24 >> 2], c = o[A + 28 >> 2], e = o[A + 32 >> 2], r = o[A + 36 >> 2], I = o[t >> 2], g = o[A + 80 >> 2], h = o[A + 44 >> 2], n = o[A + 84 >> 2], s = o[A + 48 >> 2], k = o[A + 88 >> 2], F = o[A + 52 >> 2], S = o[A + 92 >> 2], G = o[A + 56 >> 2], _ = o[A + 96 >> 2], M = o[A + 60 >> 2], p = o[A + 100 >> 2], w = o[y >> 2], N = o[A + 104 >> 2], J = o[A + 68 >> 2], U = o[A + 108 >> 2], Y = o[A + 72 >> 2], d = o[A + 112 >> 2], D = o[A >> 2], C = o[A + 76 >> 2], B = o[A + 116 >> 2], o[A + 76 >> 2] = C + B, o[A + 72 >> 2] = Y + d, o[A + 68 >> 2] = J + U, o[y >> 2] = w + N, o[A + 60 >> 2] = M + p, o[A + 56 >> 2] = G + _, o[A + 52 >> 2] = F + S, o[A + 48 >> 2] = s + k, o[A + 44 >> 2] = h + n, o[t >> 2] = I + g, o[A + 36 >> 2] = B - C, o[A + 32 >> 2] = d - Y, o[A + 28 >> 2] = U - J, o[A + 24 >> 2] = N - w, o[A + 20 >> 2] = p - M, o[A + 16 >> 2] = _ - G, o[A + 12 >> 2] = S - F, o[A + 8 >> 2] = k - s, o[A + 4 >> 2] = n - h, o[A >> 2] = g - I, I = o[A + 156 >> 2], g = r << 1, o[A + 156 >> 2] = I + g, t = o[A + 152 >> 2], y = e << 1, o[A + 152 >> 2] = t + y, h = o[A + 148 >> 2], n = c << 1, o[A + 148 >> 2] = h + n, s = o[A + 144 >> 2], k = f << 1, o[A + 144 >> 2] = s + k, F = o[A + 140 >> 2], S = a << 1, o[A + 140 >> 2] = F + S, G = o[A + 136 >> 2], _ = E << 1, o[A + 136 >> 2] = G + _, M = o[A + 132 >> 2], p = i << 1, o[A + 132 >> 2] = M + p, w = o[A + 128 >> 2], N = Q << 1, o[A + 128 >> 2] = w + N, J = o[A + 124 >> 2], U = K << 1, o[A + 124 >> 2] = J + U, Y = o[A + 120 >> 2], d = D << 1, o[A + 120 >> 2] = Y + d, o[A + 112 >> 2] = y - t, o[A + 108 >> 2] = n - h, o[A + 104 >> 2] = k - s, o[A + 100 >> 2] = S - F, o[A + 96 >> 2] = _ - G, o[A + 92 >> 2] = p - M, o[A + 88 >> 2] = N - w, o[A + 84 >> 2] = U - J, o[A + 80 >> 2] = d - Y, o[A + 116 >> 2] = g - I;
                                    }
                                    function v(A, I, g) {
                                        var C, B, Q, i, E, a, f, c, e, r, D, t = 0, y = 0, w = 0, h = 0, n = 0, s = 0, k = 0, F = 0, S = 0, G = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, U = 0, Y = 0, d = 0, K = 0;
                                        t = o[I + 40 >> 2], y = o[I + 4 >> 2], h = o[I + 44 >> 2], n = o[I + 8 >> 2], s = o[I + 48 >> 2], k = o[I + 12 >> 2], F = o[I + 52 >> 2], S = o[I + 16 >> 2], G = o[I + 56 >> 2], _ = o[I + 20 >> 2], M = o[I + 60 >> 2], p = o[I + 24 >> 2], N = o[(w = I - -64 | 0) >> 2], J = o[I + 28 >> 2], U = o[I + 68 >> 2], Y = o[I + 32 >> 2], d = o[I + 72 >> 2], K = o[I >> 2], o[A + 36 >> 2] = o[I + 36 >> 2] + o[I + 76 >> 2], o[A + 32 >> 2] = Y + d, o[A + 28 >> 2] = J + U, o[A + 24 >> 2] = p + N, o[A + 20 >> 2] = _ + M, o[A + 16 >> 2] = S + G, o[A + 12 >> 2] = k + F, o[A + 8 >> 2] = n + s, o[A + 4 >> 2] = y + h, o[A >> 2] = t + K, h = o[I + 40 >> 2], t = o[I + 4 >> 2], n = o[I + 44 >> 2], s = o[I + 8 >> 2], k = o[I + 48 >> 2], F = o[I + 12 >> 2], S = o[I + 52 >> 2], G = o[I + 16 >> 2], _ = o[I + 56 >> 2], M = o[I + 20 >> 2], p = o[I + 60 >> 2], N = o[I + 24 >> 2], w = o[w >> 2], y = o[I + 28 >> 2], J = o[I + 68 >> 2], U = o[I + 32 >> 2], Y = o[I + 72 >> 2], d = o[I >> 2], o[A + 76 >> 2] = o[I + 76 >> 2] - o[I + 36 >> 2], o[A + 72 >> 2] = Y - U, o[A + 68 >> 2] = J - y, o[(y = A - -64 | 0) >> 2] = w - N, o[A + 60 >> 2] = p - M, o[A + 56 >> 2] = _ - G, o[A + 52 >> 2] = S - F, o[A + 48 >> 2] = k - s, o[A + 44 >> 2] = n - t, o[(t = A + 40 | 0) >> 2] = h - d, H(A + 80 | 0, A, g), H(t, t, g + 40 | 0), H(A + 120 | 0, g + 80 | 0, I + 120 | 0), K = o[I + 80 >> 2], Q = o[I + 84 >> 2], i = o[I + 88 >> 2], E = o[I + 92 >> 2], a = o[I + 96 >> 2], f = o[I + 100 >> 2], c = o[I + 104 >> 2], e = o[I + 108 >> 2], r = o[I + 112 >> 2], D = o[I + 116 >> 2], I = o[t >> 2], g = o[A + 80 >> 2], h = o[A + 44 >> 2], n = o[A + 84 >> 2], s = o[A + 48 >> 2], k = o[A + 88 >> 2], F = o[A + 52 >> 2], S = o[A + 92 >> 2], G = o[A + 56 >> 2], _ = o[A + 96 >> 2], M = o[A + 60 >> 2], p = o[A + 100 >> 2], w = o[y >> 2], N = o[A + 104 >> 2], J = o[A + 68 >> 2], U = o[A + 108 >> 2], Y = o[A + 72 >> 2], d = o[A + 112 >> 2], C = o[A + 76 >> 2], B = o[A + 116 >> 2], o[A + 76 >> 2] = C + B, o[A + 72 >> 2] = Y + d, o[A + 68 >> 2] = J + U, o[y >> 2] = w + N, o[A + 60 >> 2] = M + p, o[A + 56 >> 2] = G + _, o[A + 52 >> 2] = F + S, o[A + 48 >> 2] = s + k, o[A + 44 >> 2] = h + n, o[t >> 2] = I + g, o[A + 36 >> 2] = B - C, o[A + 32 >> 2] = d - Y, o[A + 28 >> 2] = U - J, o[A + 24 >> 2] = N - w, o[A + 20 >> 2] = p - M, o[A + 16 >> 2] = _ - G, o[A + 12 >> 2] = S - F, o[A + 8 >> 2] = k - s, o[A + 4 >> 2] = n - h, o[A >> 2] = g - I, I = D << 1, g = o[A + 156 >> 2], o[A + 156 >> 2] = I - g, t = r << 1, y = o[A + 152 >> 2], o[A + 152 >> 2] = t - y, h = e << 1, n = o[A + 148 >> 2], o[A + 148 >> 2] = h - n, s = c << 1, k = o[A + 144 >> 2], o[A + 144 >> 2] = s - k, F = f << 1, S = o[A + 140 >> 2], o[A + 140 >> 2] = F - S, G = a << 1, _ = o[A + 136 >> 2], o[A + 136 >> 2] = G - _, M = E << 1, p = o[A + 132 >> 2], o[A + 132 >> 2] = M - p, w = i << 1, N = o[A + 128 >> 2], o[A + 128 >> 2] = w - N, J = Q << 1, U = o[A + 124 >> 2], o[A + 124 >> 2] = J - U, Y = K << 1, d = o[A + 120 >> 2], o[A + 120 >> 2] = Y - d, o[A + 112 >> 2] = t + y, o[A + 108 >> 2] = h + n, o[A + 104 >> 2] = s + k, o[A + 100 >> 2] = F + S, o[A + 96 >> 2] = G + _, o[A + 92 >> 2] = M + p, o[A + 88 >> 2] = w + N, o[A + 84 >> 2] = J + U, o[A + 80 >> 2] = Y + d, o[A + 116 >> 2] = I + g;
                                    }
                                    function L(A, I) {
                                        var g, C, B, Q, i, E, f, c, e, r, D, t, y, w, n = 0, s = 0, k = 0, F = 0, S = 0, H = 0, G = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, U = 0;
                                        y = a[I + 31 | 0], g = a[I + 30 | 0], C = a[I + 29 | 0], B = a[I + 6 | 0], Q = a[I + 5 | 0], i = a[I + 4 | 0], E = a[I + 9 | 0], f = a[I + 8 | 0], c = a[I + 7 | 0], e = a[I + 12 | 0], N = a[I + 11 | 0], J = a[I + 10 | 0], r = a[I + 15 | 0], U = a[I + 14 | 0], D = a[I + 13 | 0], G = a[I + 28 | 0], p = a[I + 27 | 0], _ = a[I + 26 | 0], H = a[I + 25 | 0], F = a[I + 24 | 0], k = a[I + 23 | 0], w = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, S = (s = a[I + 21 | 0]) << 15, s = n = s >>> 17 | 0, M = S, M |= (S = a[I + 20 | 0]) << 7, S = (n = S >>> 25 | 0) | s, s = (n = a[I + 22 | 0]) >>> 9 | 0, n = n << 23 | M, s |= S, t = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, I = 0, S = n, n = (33554431 & (I = (M = t + 16777216 | 0) >>> 0 < 16777216 ? 1 : I)) << 7 | M >>> 25, I = (I >>> 25 | 0) + s | 0, n = (s = S = S + n | 0) >>> 0 < n >>> 0 ? I + 1 | 0 : I, I = (S = s + 33554432 | 0) >>> 0 < 33554432 ? n + 1 | 0 : n, o[A + 24 >> 2] = s - (-67108864 & S), n = (s = k >>> 27 | 0) | F >>> 19 | H >>> 11, s = k = (F = H << 21 | (k = F << 13 | k << 5)) + (s = (67108863 & (s = I)) << 6 | S >>> 26) | 0, I = n, n = (k = F + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I, o[A + 28 >> 2] = s - (1040187392 & k), s = (n = (I = n) >>> 25 | 0) + (s = p >>> 20 | _ >>> 28 | G >>> 12) | 0, I = s = (n = k = (I = (33554431 & I) << 7 | k >>> 25) + (p << 12 | _ << 4 | G << 20) | 0) >>> 0 < I >>> 0 ? s + 1 | 0 : s, k = (G = n + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, o[A + 32 >> 2] = n - (-67108864 & G), s = e >>> 13 | (n = N >>> 21 | J >>> 29), I = (s = (p = 16777216 + (N = N << 11 | J << 3 | e << 19) | 0) >>> 0 < 16777216 ? s + 1 | 0 : s) >>> 25 | 0, s = (n = F = U << 10 | D << 2 | r << 18) + (F = (33554431 & s) << 7 | p >>> 25) | 0, n = I + (H = U >>> 22 | D >>> 30 | r >>> 14) | 0, I = n = s >>> 0 < F >>> 0 ? n + 1 | 0 : n, F = ((67108863 & (I = (F = s + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I)) << 6 | (n = F) >>> 26) + (_ = t - (-33554432 & M) | 0) | 0, o[A + 20 >> 2] = F, o[A + 16 >> 2] = s - (-67108864 & n), n = Q >>> 18 | i >>> 26 | B >>> 10, s = (n = (_ = 16777216 + (J = Q << 14 | i << 6 | B << 22) | 0) >>> 0 < 16777216 ? n + 1 | 0 : n) >>> 25 | 0, n = (I = F = f << 13 | c << 5 | E << 21) + (F = (33554431 & n) << 7 | _ >>> 25) | 0, I = s + (H = f >>> 19 | c >>> 27 | E >>> 11) | 0, I = n >>> 0 < F >>> 0 ? I + 1 | 0 : I, s = (H = n + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, o[A + 8 >> 2] = n - (-67108864 & H), G = (k = (67108863 & k) << 6 | G >>> 26) + (U = y << 18 & 33292288 | g << 10 | C << 2) | 0, I = n = g >>> 22 | C >>> 30, n = (k = U + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I, o[A + 36 >> 2] = G - (33554432 & k), s = N + ((67108863 & s) << 6 | H >>> 26) | 0, o[A + 12 >> 2] = s - (234881024 & p), F = J - (2113929216 & _) | 0, s = kA((33554431 & (I = n)) << 7 | k >>> 25, n = I >>> 25 | 0, 19, 0), I = h, s = (n = s + w | 0) >>> 0 < s >>> 0 ? I + 1 | 0 : I, k = ((67108863 & (s = (I = n + 33554432 | 0) >>> 0 < 33554432 ? s + 1 | 0 : s)) << 6 | I >>> 26) + F | 0, o[A + 4 >> 2] = k, o[A >> 2] = n - (-67108864 & I);
                                    }
                                    function R(A, I, g, C) {
                                        var B, Q = 0, i = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, h = 0, n = 0, s = 0;
                                        if (w = B = w - 704 | 0, g | C) {
                                            if (Q = (C << 3 | g >>> 29) + (i = f = o[A + 76 >> 2]) | 0, e = (r = o[A + 72 >> 2]) + (c = g << 3) | 0, o[A + 72 >> 2] = e, Q = c >>> 0 > e >>> 0 ? Q + 1 | 0 : Q, o[A + 76 >> 2] = Q, f = o[4 + (c = A - -64 | 0) >> 2], f = (D = Q = (0 | Q) == (0 | i) & e >>> 0 < r >>> 0 | Q >>> 0 < i >>> 0) >>> 0 > (Q = Q + o[c >> 2] | 0) >>> 0 ? f + 1 | 0 : f, e = (D = C >>> 29 | 0) + Q | 0, Q = f, o[c >> 2] = e, o[c + 4 >> 2] = e >>> 0 < D >>> 0 ? Q + 1 | 0 : Q, (0 | C) == (0 | (f = D = 0 - ((Q = 0) + ((c = 127 & ((7 & i) << 29 | r >>> 3)) >>> 0 > 128) | 0) | 0)) & g >>> 0 >= (e = 128 - c | 0) >>> 0 | C >>> 0 > f >>> 0) {
                                                if (i = 0, f = 0, !Q & (127 ^ c) >>> 0 >= 3 | Q) for(s = 252 & e, r = A + 80 | 0; E[(Q = i + c | 0) + r | 0] = a[I + i | 0], E[r + (c + (Q = 1 | i) | 0) | 0] = a[I + Q | 0], E[r + (c + (Q = 2 | i) | 0) | 0] = a[I + Q | 0], E[r + (c + (Q = 3 | i) | 0) | 0] = a[I + Q | 0], Q = f, f = (i = i + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, Q = y, y = Q = (h = h + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, (0 | h) != (0 | s) | (0 | n) != (0 | Q););
                                                if (r = Q = 0, Q | (y = 3 & e)) for(; E[80 + (A + (Q = i + c | 0) | 0) | 0] = a[I + i | 0], Q = f, f = (i = i + 1 | 0) ? Q : Q + 1 | 0, Q = n, n = Q = (t = t + 1 | 0) ? Q : Q + 1 | 0, (0 | y) != (0 | t) | (0 | r) != (0 | Q););
                                                if (k(A, A + 80 | 0, B, i = B + 640 | 0), I = I + e | 0, !(C = C - ((g >>> 0 < e >>> 0) + D | 0) | 0) & (g = g - e | 0) >>> 0 > 127 | C) for(; k(A, I, B, i), I = I + 128 | 0, !(C = C - (g >>> 0 < 128) | 0) & (g = g - 128 | 0) >>> 0 > 127 | C;);
                                                if (g | C) {
                                                    if (h = 3 & g, e = 0, t = 0, n = 0, i = 0, f = 0, !C & g >>> 0 >= 4 | C) for(c = -4 & g, r = C, y = A + 80 | 0, g = 0, C = 0; E[i + y | 0] = a[I + i | 0], E[(Q = 1 | i) + y | 0] = a[I + Q | 0], E[(Q = 2 | i) + y | 0] = a[I + Q | 0], E[(Q = 3 | i) + y | 0] = a[I + Q | 0], Q = f, f = (i = i + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, Q = C, C = Q = (g = g + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, (0 | g) != (0 | c) | (0 | r) != (0 | Q););
                                                    if (e | h) for(; E[80 + (A + i | 0) | 0] = a[I + i | 0], f = (i = i + 1 | 0) ? f : f + 1 | 0, Q = n, n = Q = (t = t + 1 | 0) ? Q : Q + 1 | 0, (0 | t) != (0 | h) | (0 | e) != (0 | Q););
                                                }
                                                iI(B, 704);
                                            } else {
                                                if (i = 0, f = 0, !C & g >>> 0 >= 4 | C) for(e = -4 & g, r = C, C = A + 80 | 0; E[C + (Q = i + c | 0) | 0] = a[I + i | 0], E[C + (D = c + (Q = 1 | i) | 0) | 0] = a[I + Q | 0], E[C + (D = c + (Q = 2 | i) | 0) | 0] = a[I + Q | 0], E[C + (D = c + (Q = 3 | i) | 0) | 0] = a[I + Q | 0], Q = f, f = (i = i + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, Q = y, y = Q = (h = h + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, (0 | e) != (0 | h) | (0 | r) != (0 | Q););
                                                if ((g &= 3) | (C = 0)) for(; E[80 + (A + (Q = i + c | 0) | 0) | 0] = a[I + i | 0], f = (i = i + 1 | 0) ? f : f + 1 | 0, Q = n, n = Q = (t = t + 1 | 0) ? Q : Q + 1 | 0, (0 | g) != (0 | t) | (0 | C) != (0 | Q););
                                            }
                                        }
                                        return w = B + 704 | 0, 0;
                                    }
                                    function u(A, I) {
                                        var g, C, B, Q, i = 0, f = 0, c = 0, e = 0, r = 0, D = 0;
                                        for(w = g = w - 480 | 0; c = (f = g + 288 | 0) + (i << 1) | 0, e = a[I + i | 0], E[c + 1 | 0] = e >>> 4, E[0 | c] = 15 & e, f = f + ((c = 1 | i) << 1) | 0, c = a[I + c | 0], E[f + 1 | 0] = c >>> 4, E[0 | f] = 15 & c, 32 != (0 | (i = i + 2 | 0)););
                                        for(I = 0; i = 8 + (f = (i = I) + a[0 | (I = (g + 288 | 0) + r | 0)] | 0) | 0, E[0 | I] = f - (240 & i), i = 8 + (f = a[I + 1 | 0] + (i << 24 >> 24 >> 4) | 0) | 0, E[I + 1 | 0] = f - (240 & i), i = 8 + (f = a[I + 2 | 0] + (i << 24 >> 24 >> 4) | 0) | 0, E[I + 2 | 0] = f - (240 & i), I = i << 24 >> 24 >> 4, 63 != (0 | (r = r + 3 | 0)););
                                        for(E[g + 351 | 0] = a[g + 351 | 0] + I, o[A + 32 >> 2] = 0, o[A + 36 >> 2] = 0, o[A + 24 >> 2] = 0, o[A + 28 >> 2] = 0, o[A + 16 >> 2] = 0, o[A + 20 >> 2] = 0, o[A + 8 >> 2] = 0, o[A + 12 >> 2] = 0, o[A >> 2] = 0, o[A + 4 >> 2] = 0, o[A + 44 >> 2] = 0, o[A + 48 >> 2] = 0, o[(I = A + 40 | 0) >> 2] = 1, o[A + 52 >> 2] = 0, o[A + 56 >> 2] = 0, o[A + 60 >> 2] = 0, o[A + 64 >> 2] = 0, o[A + 68 >> 2] = 0, o[A + 72 >> 2] = 0, o[A + 76 >> 2] = 0, o[A + 80 >> 2] = 1, dA(A + 84 | 0, 0, 76), B = A + 120 | 0, r = A + 80 | 0, f = g + 208 | 0, C = g + 168 | 0, c = g + 248 | 0, i = 1; V(D = g + 8 | 0, i >>> 1 | 0, E[(g + 288 | 0) + i | 0]), v(e = g + 128 | 0, A, D), H(A, e, c), H(I, C, f), H(r, f, c), H(B, e, C), D = i >>> 0 < 62, i = i + 2 | 0, D;);
                                        for(i = o[A + 36 >> 2], o[g + 392 >> 2] = o[A + 32 >> 2], o[g + 396 >> 2] = i, i = o[A + 28 >> 2], o[g + 384 >> 2] = o[A + 24 >> 2], o[g + 388 >> 2] = i, i = o[A + 20 >> 2], o[g + 376 >> 2] = o[A + 16 >> 2], o[g + 380 >> 2] = i, i = o[A + 12 >> 2], o[g + 368 >> 2] = o[A + 8 >> 2], o[g + 372 >> 2] = i, i = o[A + 4 >> 2], o[g + 360 >> 2] = o[A >> 2], o[g + 364 >> 2] = i, i = o[I + 12 >> 2], o[g + 408 >> 2] = o[I + 8 >> 2], o[g + 412 >> 2] = i, i = o[I + 20 >> 2], o[g + 416 >> 2] = o[I + 16 >> 2], o[g + 420 >> 2] = i, i = o[I + 28 >> 2], o[g + 424 >> 2] = o[I + 24 >> 2], o[g + 428 >> 2] = i, i = o[I + 36 >> 2], o[g + 432 >> 2] = o[I + 32 >> 2], o[g + 436 >> 2] = i, i = o[I + 4 >> 2], o[g + 400 >> 2] = o[I >> 2], o[g + 404 >> 2] = i, i = o[r + 12 >> 2], o[g + 448 >> 2] = o[r + 8 >> 2], o[g + 452 >> 2] = i, i = o[r + 20 >> 2], o[g + 456 >> 2] = o[r + 16 >> 2], o[g + 460 >> 2] = i, i = o[r + 28 >> 2], o[g + 464 >> 2] = o[r + 24 >> 2], o[g + 468 >> 2] = i, i = o[r + 36 >> 2], o[g + 472 >> 2] = o[r + 32 >> 2], o[g + 476 >> 2] = i, i = o[r + 4 >> 2], o[g + 440 >> 2] = o[r >> 2], o[g + 444 >> 2] = i, G(e, i = g + 360 | 0), H(i, e, c), H(D = g + 400 | 0, C, f), H(Q = g + 440 | 0, f, c), G(e, i), H(i, e, c), H(D, C, f), H(Q, f, c), G(e, i), H(i, e, c), H(D, C, f), H(Q, f, c), G(e, i), H(A, e, c), H(I, C, f), H(r, f, c), H(B, e, C), i = 0; V(D = g + 8 | 0, i >>> 1 | 0, E[(g + 288 | 0) + i | 0]), v(e = g + 128 | 0, A, D), H(A, e, c), H(I, C, f), H(r, f, c), H(B, e, C), e = i >>> 0 < 62, i = i + 2 | 0, e;);
                                        w = g + 480 | 0;
                                    }
                                    function x(A, I, g) {
                                        var C = 0, B = 0, Q = 0, i = 0, o = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, h = 0, n = 0, s = 0, k = 0, F = 0, S = 0, H = 0;
                                        for(B = 2036477234, i = 857760878, C = 1634760805, f = 1797285236, Q = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, r = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, o = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, D = a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24, c = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, k = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24, t = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, y = a[g + 12 | 0] | a[g + 13 | 0] << 8 | a[g + 14 | 0] << 16 | a[g + 15 | 0] << 24, w = a[g + 8 | 0] | a[g + 9 | 0] << 8 | a[g + 10 | 0] << 16 | a[g + 11 | 0] << 24, h = a[g + 4 | 0] | a[g + 5 | 0] << 8 | a[g + 6 | 0] << 16 | a[g + 7 | 0] << 24, I = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, g = a[0 | g] | a[g + 1 | 0] << 8 | a[g + 2 | 0] << 16 | a[g + 3 | 0] << 24; e = g, g = RA((n = I) ^ (I = g + C | 0), 16), e = t = RA(e ^ (C = g + t | 0), 12), F = RA((n = I + t | 0) ^ g, 8), I = RA(e ^ (t = F + C | 0), 7), C = y, y = RA((g = f + y | 0) ^ Q, 16), C = RA(C ^ (D = y + D | 0), 12), Q = w, f = RA((B = B + w | 0) ^ r, 16), Q = RA(Q ^ (w = f + c | 0), 12), c = RA((B = Q + B | 0) ^ f, 8), g = RA(c ^ (f = I + (s = g + C | 0) | 0), 16), r = RA((i = i + h | 0) ^ o, 16), h = RA((o = r + k | 0) ^ h, 12), e = I, I = RA((i = i + h | 0) ^ r, 8), e = RA(e ^ (o = g + (S = I + o | 0) | 0), 12), r = RA(g ^ (f = e + f | 0), 8), g = RA((k = r + o | 0) ^ e, 7), e = B, B = C, s = RA(y ^ s, 8), B = RA(B ^ (C = s + D | 0), 7), y = RA((o = e + B | 0) ^ I, 16), D = RA((I = y + t | 0) ^ B, 12), o = RA(y ^ (B = D + o | 0), 8), y = RA((t = I + o | 0) ^ D, 7), I = RA((I = Q) ^ (Q = c + w | 0), 7), w = RA((i = I + i | 0) ^ F, 16), c = RA(I ^ (C = w + C | 0), 12), I = RA(w ^ (i = c + i | 0), 8), w = RA((D = C + I | 0) ^ c, 7), e = Q, C = RA(h ^ S, 7), c = RA((Q = C + n | 0) ^ s, 16), n = RA(C ^ (h = e + c | 0), 12), Q = RA(c ^ (C = n + Q | 0), 8), h = RA((c = h + Q | 0) ^ n, 7), 10 != (0 | (H = H + 1 | 0)););
                                        E[0 | A] = C, E[A + 1 | 0] = C >>> 8, E[A + 2 | 0] = C >>> 16, E[A + 3 | 0] = C >>> 24, E[A + 28 | 0] = Q, E[A + 29 | 0] = Q >>> 8, E[A + 30 | 0] = Q >>> 16, E[A + 31 | 0] = Q >>> 24, E[A + 24 | 0] = r, E[A + 25 | 0] = r >>> 8, E[A + 26 | 0] = r >>> 16, E[A + 27 | 0] = r >>> 24, E[A + 20 | 0] = o, E[A + 21 | 0] = o >>> 8, E[A + 22 | 0] = o >>> 16, E[A + 23 | 0] = o >>> 24, E[A + 16 | 0] = I, E[A + 17 | 0] = I >>> 8, E[A + 18 | 0] = I >>> 16, E[A + 19 | 0] = I >>> 24, E[A + 12 | 0] = f, E[A + 13 | 0] = f >>> 8, E[A + 14 | 0] = f >>> 16, E[A + 15 | 0] = f >>> 24, E[A + 8 | 0] = B, E[A + 9 | 0] = B >>> 8, E[A + 10 | 0] = B >>> 16, E[A + 11 | 0] = B >>> 24, E[A + 4 | 0] = i, E[A + 5 | 0] = i >>> 8, E[A + 6 | 0] = i >>> 16, E[A + 7 | 0] = i >>> 24;
                                    }
                                    function m(A, I, g) {
                                        var C = 0, B = 0, Q = 0, i = 0, o = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, h = 0, n = 0, s = 0, k = 0, F = 0, S = 0, H = 0;
                                        for(C = 1797285236, c = 2036477234, e = 857760878, B = 1634760805, Q = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, o = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, i = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, n = a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24, h = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, s = 20, y = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24, w = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, r = a[g + 12 | 0] | a[g + 13 | 0] << 8 | a[g + 14 | 0] << 16 | a[g + 15 | 0] << 24, D = a[g + 8 | 0] | a[g + 9 | 0] << 8 | a[g + 10 | 0] << 16 | a[g + 11 | 0] << 24, t = a[g + 4 | 0] | a[g + 5 | 0] << 8 | a[g + 6 | 0] << 16 | a[g + 7 | 0] << 24, I = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, g = a[0 | g] | a[g + 1 | 0] << 8 | a[g + 2 | 0] << 16 | a[g + 3 | 0] << 24; f = RA(g + e | 0, 7) ^ Q, k = RA(f + e | 0, 9) ^ h, r = RA(B + y | 0, 7) ^ r, F = RA(r + B | 0, 9) ^ o, S = RA(F + r | 0, 13) ^ y, D = RA(C + w | 0, 7) ^ D, i = RA(D + C | 0, 9) ^ i, o = RA(i + D | 0, 13) ^ w, C = RA(i + o | 0, 18) ^ C, Q = RA(I + c | 0, 7) ^ n, y = S ^ RA(C + Q | 0, 7), h = k ^ RA(y + C | 0, 9), n = RA(y + h | 0, 13) ^ Q, C = RA(h + n | 0, 18) ^ C, t = RA(Q + c | 0, 9) ^ t, H = RA(t + Q | 0, 13) ^ I, I = RA(H + t | 0, 18) ^ c, w = RA(I + f | 0, 7) ^ o, o = RA(w + I | 0, 9) ^ F, Q = RA(o + w | 0, 13) ^ f, c = RA(Q + o | 0, 18) ^ I, f = RA(f + k | 0, 13) ^ g, g = RA(f + k | 0, 18) ^ e, I = RA(g + r | 0, 7) ^ H, i = RA(I + g | 0, 9) ^ i, r = RA(I + i | 0, 13) ^ r, e = RA(i + r | 0, 18) ^ g, B = RA(F + S | 0, 18) ^ B, g = RA(B + D | 0, 7) ^ f, t = RA(g + B | 0, 9) ^ t, D = RA(g + t | 0, 13) ^ D, B = RA(t + D | 0, 18) ^ B, f = s >>> 0 > 2, s = s - 2 | 0, f;);
                                        return E[0 | A] = B, E[A + 1 | 0] = B >>> 8, E[A + 2 | 0] = B >>> 16, E[A + 3 | 0] = B >>> 24, E[A + 28 | 0] = Q, E[A + 29 | 0] = Q >>> 8, E[A + 30 | 0] = Q >>> 16, E[A + 31 | 0] = Q >>> 24, E[A + 24 | 0] = o, E[A + 25 | 0] = o >>> 8, E[A + 26 | 0] = o >>> 16, E[A + 27 | 0] = o >>> 24, E[A + 20 | 0] = i, E[A + 21 | 0] = i >>> 8, E[A + 22 | 0] = i >>> 16, E[A + 23 | 0] = i >>> 24, E[A + 16 | 0] = I, E[A + 17 | 0] = I >>> 8, E[A + 18 | 0] = I >>> 16, E[A + 19 | 0] = I >>> 24, E[A + 12 | 0] = C, E[A + 13 | 0] = C >>> 8, E[A + 14 | 0] = C >>> 16, E[A + 15 | 0] = C >>> 24, E[A + 8 | 0] = c, E[A + 9 | 0] = c >>> 8, E[A + 10 | 0] = c >>> 16, E[A + 11 | 0] = c >>> 24, E[A + 4 | 0] = e, E[A + 5 | 0] = e >>> 8, E[A + 6 | 0] = e >>> 16, E[A + 7 | 0] = e >>> 24, 0;
                                    }
                                    function l(A, I) {
                                        var g, C, B = 0, Q = 0, i = 0, a = 0;
                                        w = g = w - 288 | 0, Q = 40 + ((B = o[A + 32 >> 2] >>> 3 & 63) + A | 0) | 0, B >>> 0 >= 56 ? (YA(Q, 34224, 64 - B | 0), _(A, A + 40 | 0, g, g + 256 | 0), o[A + 88 >> 2] = 0, o[A + 92 >> 2] = 0, o[A + 80 >> 2] = 0, o[A + 84 >> 2] = 0, o[A + 72 >> 2] = 0, o[A + 76 >> 2] = 0, o[(B = A - -64 | 0) >> 2] = 0, o[B + 4 >> 2] = 0, o[A + 56 >> 2] = 0, o[A + 60 >> 2] = 0, o[A + 48 >> 2] = 0, o[A + 52 >> 2] = 0, o[A + 40 >> 2] = 0, o[A + 44 >> 2] = 0) : YA(Q, 34224, 56 - B | 0), i = (B = 16711680 & (Q = o[A + 32 >> 2])) >>> 8 | 0, a = B << 24, C = (B = -16777216 & Q) >>> 24 | 0, B = (a |= B << 8) | -16777216 & ((255 & (B = o[A + 36 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & B) << 8 | Q >>> 24) | B >>> 8 & 65280 | B >>> 24, E[A + 96 | 0] = B, E[A + 97 | 0] = B >>> 8, E[A + 98 | 0] = B >>> 16, E[A + 99 | 0] = B >>> 24, B = (B = i | C | Q << 24 | (65280 & Q) << 8) | (i = 0) | i, E[A + 100 | 0] = B, E[A + 101 | 0] = B >>> 8, E[A + 102 | 0] = B >>> 16, E[A + 103 | 0] = B >>> 24, _(A, A + 40 | 0, g, g + 256 | 0), B = (B = o[A >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, E[0 | I] = B, E[I + 1 | 0] = B >>> 8, E[I + 2 | 0] = B >>> 16, E[I + 3 | 0] = B >>> 24, B = (B = o[A + 4 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, E[I + 4 | 0] = B, E[I + 5 | 0] = B >>> 8, E[I + 6 | 0] = B >>> 16, E[I + 7 | 0] = B >>> 24, B = (B = o[A + 8 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, E[I + 8 | 0] = B, E[I + 9 | 0] = B >>> 8, E[I + 10 | 0] = B >>> 16, E[I + 11 | 0] = B >>> 24, B = (B = o[A + 12 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, E[I + 12 | 0] = B, E[I + 13 | 0] = B >>> 8, E[I + 14 | 0] = B >>> 16, E[I + 15 | 0] = B >>> 24, B = (B = o[A + 16 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, E[I + 16 | 0] = B, E[I + 17 | 0] = B >>> 8, E[I + 18 | 0] = B >>> 16, E[I + 19 | 0] = B >>> 24, B = (B = o[A + 20 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, E[I + 20 | 0] = B, E[I + 21 | 0] = B >>> 8, E[I + 22 | 0] = B >>> 16, E[I + 23 | 0] = B >>> 24, B = (B = o[A + 24 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, E[I + 24 | 0] = B, E[I + 25 | 0] = B >>> 8, E[I + 26 | 0] = B >>> 16, E[I + 27 | 0] = B >>> 24, B = (B = o[A + 28 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, E[I + 28 | 0] = B, E[I + 29 | 0] = B >>> 8, E[I + 30 | 0] = B >>> 16, E[I + 31 | 0] = B >>> 24, iI(g, 288), iI(A, 104), w = g + 288 | 0;
                                    }
                                    function z(A, I, g) {
                                        var C, B = 0, Q = 0, i = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, h = 0, n = 0;
                                        if (w = C = w - 288 | 0, g) {
                                            if (e = (B = o[A + 36 >> 2]) + (g >>> 29 | 0) | 0, t = (i = o[A + 32 >> 2]) + (f = g << 3) | 0, o[A + 32 >> 2] = t, o[A + 36 >> 2] = f >>> 0 > t >>> 0 ? e + 1 | 0 : e, !0 & (f = 64 - (e = 63 & ((7 & B) << 29 | i >>> 3)) | 0) >>> 0 <= g >>> 0) {
                                                if (B = 0, i = 0, (63 ^ e) >>> 0 >= 3) for(n = 124 & f, t = A + 40 | 0; E[(B + e | 0) + t | 0] = a[I + B | 0], E[(e + (h = 1 | B) | 0) + t | 0] = a[I + h | 0], E[(e + (h = 2 | B) | 0) + t | 0] = a[I + h | 0], E[(e + (h = 3 | B) | 0) + t | 0] = a[I + h | 0], i = (B = B + 4 | 0) >>> 0 < 4 ? i + 1 | 0 : i, (Q = (y = y + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q) | (0 | y) != (0 | n););
                                                if (Q = 3 & f) for(; E[40 + ((B + e | 0) + A | 0) | 0] = a[I + B | 0], i = (B = B + 1 | 0) ? i : i + 1 | 0, (r = (D = D + 1 | 0) ? r : r + 1 | 0) | (0 | Q) != (0 | D););
                                                if (_(A, A + 40 | 0, C, r = C + 256 | 0), I = I + f | 0, !(Q = 0 - ((g >>> 0 < f >>> 0) + c | 0) | 0) & (g = g - f | 0) >>> 0 > 63 | Q) for(; _(A, I, C, r), I = I - -64 | 0, Q = Q - 1 | 0, !(Q = (g = g + -64 | 0) >>> 0 < 4294967232 ? Q + 1 | 0 : Q) & g >>> 0 > 63 | Q;);
                                                if (g | Q) {
                                                    if (y = 3 & g, D = 0, r = 0, B = 0, i = 0, !Q & g >>> 0 >= 4 | Q) for(t = -4 & g, e = Q, f = A + 40 | 0, g = 0, Q = 0; E[B + f | 0] = a[I + B | 0], E[(c = 1 | B) + f | 0] = a[I + c | 0], E[(c = 2 | B) + f | 0] = a[I + c | 0], E[(c = 3 | B) + f | 0] = a[I + c | 0], i = (B = B + 4 | 0) >>> 0 < 4 ? i + 1 | 0 : i, (0 | (g = g + 4 | 0)) != (0 | t) | (0 | (Q = g >>> 0 < 4 ? Q + 1 | 0 : Q)) != (0 | e););
                                                    if (y) for(; E[40 + (A + B | 0) | 0] = a[I + B | 0], i = (B = B + 1 | 0) ? i : i + 1 | 0, (r = (D = D + 1 | 0) ? r : r + 1 | 0) | (0 | D) != (0 | y););
                                                }
                                                iI(C, 288);
                                            } else {
                                                if (B = 0, i = 0, g >>> 0 >= 4) for(t = -4 & g, f = A + 40 | 0; E[(B + e | 0) + f | 0] = a[I + B | 0], E[(e + (c = 1 | B) | 0) + f | 0] = a[I + c | 0], E[(e + (c = 2 | B) | 0) + f | 0] = a[I + c | 0], E[(e + (c = 3 | B) | 0) + f | 0] = a[I + c | 0], i = (B = B + 4 | 0) >>> 0 < 4 ? i + 1 | 0 : i, (Q = (y = y + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q) | (0 | t) != (0 | y););
                                                if (g &= 3) for(; E[40 + ((B + e | 0) + A | 0) | 0] = a[I + B | 0], i = (B = B + 1 | 0) ? i : i + 1 | 0, (r = (D = D + 1 | 0) ? r : r + 1 | 0) | (0 | g) != (0 | D););
                                            }
                                        }
                                        w = C + 288 | 0;
                                    }
                                    function q(A, I, g) {
                                        var C, B = 0, Q = 0, i = 0, f = 0, c = 0, e = 0, r = 0, D = 0;
                                        if (w = C = w - 96 | 0, g >>> 0 >= 65 && (SA(A), z(A, I, g), l(A, C), g = 32, I = C), SA(A), o[C + 88 >> 2] = 909522486, o[C + 92 >> 2] = 909522486, o[C + 80 >> 2] = 909522486, o[C + 84 >> 2] = 909522486, o[C + 72 >> 2] = 909522486, o[C + 76 >> 2] = 909522486, o[(i = r = C - -64 | 0) >> 2] = 909522486, o[i + 4 >> 2] = 909522486, o[C + 56 >> 2] = 909522486, o[C + 60 >> 2] = 909522486, o[C + 48 >> 2] = 909522486, o[C + 52 >> 2] = 909522486, o[C + 40 >> 2] = 909522486, o[C + 44 >> 2] = 909522486, o[C + 32 >> 2] = 909522486, o[C + 36 >> 2] = 909522486, g) {
                                            if (g >>> 0 >= 4) for(f = 124 & g; E[0 | (Q = (i = C + 32 | 0) + B | 0)] = a[0 | Q] ^ a[I + B | 0], E[0 | (D = (Q = 1 | B) + i | 0)] = a[0 | D] ^ a[I + Q | 0], E[0 | (D = (Q = 2 | B) + i | 0)] = a[0 | D] ^ a[I + Q | 0], E[0 | (Q = (Q = i) + (i = 3 | B) | 0)] = a[0 | Q] ^ a[I + i | 0], B = B + 4 | 0, (0 | f) != (0 | (c = c + 4 | 0)););
                                            if (c = 3 & g) for(; E[0 | (i = (C + 32 | 0) + B | 0)] = a[0 | i] ^ a[I + B | 0], B = B + 1 | 0, (0 | c) != (0 | (e = e + 1 | 0)););
                                        }
                                        if (z(A, C + 32 | 0, 64), SA(i = A + 104 | 0), o[C + 88 >> 2] = 1549556828, o[C + 92 >> 2] = 1549556828, o[C + 80 >> 2] = 1549556828, o[C + 84 >> 2] = 1549556828, o[C + 72 >> 2] = 1549556828, o[C + 76 >> 2] = 1549556828, o[r >> 2] = 1549556828, o[r + 4 >> 2] = 1549556828, o[C + 56 >> 2] = 1549556828, o[C + 60 >> 2] = 1549556828, o[C + 48 >> 2] = 1549556828, o[C + 52 >> 2] = 1549556828, o[C + 40 >> 2] = 1549556828, o[C + 44 >> 2] = 1549556828, o[C + 32 >> 2] = 1549556828, o[C + 36 >> 2] = 1549556828, g) {
                                            if (e = 0, B = 0, g >>> 0 >= 4) for(r = 124 & g, c = 0; E[0 | (f = (A = C + 32 | 0) + B | 0)] = a[0 | f] ^ a[I + B | 0], E[0 | (Q = (f = 1 | B) + A | 0)] = a[0 | Q] ^ a[I + f | 0], E[0 | (Q = (f = 2 | B) + A | 0)] = a[0 | Q] ^ a[I + f | 0], E[0 | (f = (Q = A) + (A = 3 | B) | 0)] = a[0 | f] ^ a[A + I | 0], B = B + 4 | 0, (0 | r) != (0 | (c = c + 4 | 0)););
                                            if (A = 3 & g) for(; E[0 | (g = (C + 32 | 0) + B | 0)] = a[0 | g] ^ a[I + B | 0], B = B + 1 | 0, (0 | A) != (0 | (e = e + 1 | 0)););
                                        }
                                        return z(i, A = C + 32 | 0, 64), iI(A, 64), iI(C, 32), w = C + 96 | 0, 0;
                                    }
                                    function X(A, I, g, C, B, i, E) {
                                        var a = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0;
                                        if (I - 65 >>> 0 < 4294967232 | E >>> 0 > 64) A = -1;
                                        else {
                                            D = a = w, w = a = a - 512 & -64;
                                            A: {
                                                I: if (!(!(!(C | B) | g) | !A | ((f = 255 & I) - 65 & 255) >>> 0 <= 191 | !(!(I = 255 & E) || i) | I >>> 0 >= 65)) {
                                                    if (I) {
                                                        if (!i) break I;
                                                        dA(a - -64 | 0, 0, 293), o[a + 56 >> 2] = 327033209, o[a + 60 >> 2] = 1541459225, o[a + 48 >> 2] = -79577749, o[a + 52 >> 2] = 528734635, o[a + 40 >> 2] = 725511199, o[a + 44 >> 2] = -1694144372, o[a + 32 >> 2] = -1377402159, o[a + 36 >> 2] = 1359893119, o[a + 24 >> 2] = 1595750129, o[a + 28 >> 2] = -1521486534, o[a + 16 >> 2] = -23791573, o[a + 20 >> 2] = 1013904242, o[a + 8 >> 2] = -2067093701, o[a + 12 >> 2] = -1150833019, o[a >> 2] = -222443256 ^ (I << 8 | f), o[a + 4 >> 2] = I >>> 24 ^ 1779033703, dA((E = a + 384 | 0) + I | 0, 0, 128 - I | 0), YA(E, i, I), YA(a + 96 | 0, E, 128), o[a + 352 >> 2] = 128, iI(E, 128), I = 128;
                                                    } else dA(a - -64 | 0, 0, 293), o[a + 56 >> 2] = 327033209, o[a + 60 >> 2] = 1541459225, o[a + 48 >> 2] = -79577749, o[a + 52 >> 2] = 528734635, o[a + 40 >> 2] = 725511199, o[a + 44 >> 2] = -1694144372, o[a + 32 >> 2] = -1377402159, o[a + 36 >> 2] = 1359893119, o[a + 24 >> 2] = 1595750129, o[a + 28 >> 2] = -1521486534, o[a + 16 >> 2] = -23791573, o[a + 20 >> 2] = 1013904242, o[a + 8 >> 2] = -2067093701, o[a + 12 >> 2] = -1150833019, o[a >> 2] = -222443256 ^ f, o[a + 4 >> 2] = 1779033703, I = 0;
                                                    g: if (C | B) for(t = a + 224 | 0, c = a + 96 | 0;;){
                                                        if (E = I + c | 0, !B & C >>> 0 <= (i = 256 - I | 0) >>> 0) {
                                                            YA(E, g, C), o[a + 352 >> 2] = C + o[a + 352 >> 2];
                                                            break g;
                                                        }
                                                        if (YA(E, g, i), o[a + 352 >> 2] = i + o[a + 352 >> 2], e = I = o[a + 68 >> 2], I = (r = (E = o[a + 64 >> 2]) + 128 | 0) >>> 0 < 128 ? I + 1 | 0 : I, o[a + 64 >> 2] = r, o[a + 68 >> 2] = I, I = o[a + 76 >> 2], I = (e = E = -1 == (0 | e) & E >>> 0 > 4294967167) >>> 0 > (E = E + o[a + 72 >> 2] | 0) >>> 0 ? I + 1 | 0 : I, o[a + 72 >> 2] = E, o[a + 76 >> 2] = I, n(a, c), YA(c, t, 128), I = o[a + 352 >> 2] - 128 | 0, o[a + 352 >> 2] = I, g = g + i | 0, !((B = B - (C >>> 0 < i >>> 0) | 0) | (C = C - i | 0))) break;
                                                    }
                                                    J(a, A, f), w = D;
                                                    break A;
                                                }
                                                zA(), Q();
                                            }
                                            A = 0;
                                        }
                                        return A;
                                    }
                                    function j(A, I, g, C) {
                                        var B = 0, Q = 0, i = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, h = 0;
                                        A: {
                                            if ((i = o[A + 56 >> 2]) | (B = o[A + 60 >> 2])) {
                                                if (t = Q = 16 - i | 0, c = (Q = (0 | (f = 0 - ((i >>> 0 > 16) + B | 0) | 0)) == (0 | C) & g >>> 0 > Q >>> 0 | C >>> 0 > f >>> 0) ? t : g, t = Q = Q ? f : C, Q | c) {
                                                    if (Q = 0, i = 0, !t & c >>> 0 >= 4 | t) for(e = -4 & c, f = A - -64 | 0; B = Q + o[A + 56 >> 2] | 0, E[B + f | 0] = a[I + Q | 0], B = (y = 1 | Q) + o[A + 56 >> 2] | 0, E[B + f | 0] = a[I + y | 0], B = (y = 2 | Q) + o[A + 56 >> 2] | 0, E[B + f | 0] = a[I + y | 0], B = (y = 3 | Q) + o[A + 56 >> 2] | 0, E[B + f | 0] = a[I + y | 0], B = i, i = (Q = Q + 4 | 0) >>> 0 < 4 ? B + 1 | 0 : B, B = r, r = B = (D = D + 4 | 0) >>> 0 < 4 ? B + 1 | 0 : B, (0 | D) != (0 | e) | (0 | t) != (0 | B););
                                                    if (f = B = 0, B | (r = 3 & c)) for(; D = Q + o[A + 56 >> 2] | 0, E[(A + D | 0) - -64 | 0] = a[I + Q | 0], i = (Q = Q + 1 | 0) ? i : i + 1 | 0, B = h, h = B = (w = w + 1 | 0) ? B : B + 1 | 0, (0 | r) != (0 | w) | (0 | f) != (0 | B););
                                                    i = o[A + 56 >> 2], B = o[A + 60 >> 2];
                                                }
                                                if (B = B + t | 0, B = (i = i + c | 0) >>> 0 < c >>> 0 ? B + 1 | 0 : B, o[A + 56 >> 2] = i, o[A + 60 >> 2] = B, !B & i >>> 0 < 16) break A;
                                                d(A, A - -64 | 0, 16, 0), o[A + 56 >> 2] = 0, o[A + 60 >> 2] = 0, g = (i = g) - c | 0, C = C - ((i >>> 0 < c >>> 0) + t | 0) | 0, I = I + c | 0;
                                            }
                                            if (!C & g >>> 0 >= 16 | C && (d(A, I, i = -16 & g, C), g &= 15, C = 0, I = I + i | 0), g | C) {
                                                if (w = 0, h = 0, Q = 0, i = 0, !C & g >>> 0 >= 4 | C) for(c = 12 & g, t = 0, f = A - -64 | 0, D = 0, r = 0; B = Q + o[A + 56 >> 2] | 0, E[B + f | 0] = a[I + Q | 0], B = (e = 1 | Q) + o[A + 56 >> 2] | 0, E[B + f | 0] = a[I + e | 0], B = (e = 2 | Q) + o[A + 56 >> 2] | 0, E[B + f | 0] = a[I + e | 0], B = (e = 3 | Q) + o[A + 56 >> 2] | 0, E[B + f | 0] = a[I + e | 0], i = (Q = Q + 4 | 0) >>> 0 < 4 ? i + 1 | 0 : i, B = r, r = B = (D = D + 4 | 0) >>> 0 < 4 ? B + 1 | 0 : B, (0 | c) != (0 | D) | (0 | t) != (0 | B););
                                                if (f = B = 0, B | (r = 3 & g)) for(; B = Q + o[A + 56 >> 2] | 0, E[(A + B | 0) - -64 | 0] = a[I + Q | 0], i = (Q = Q + 1 | 0) ? i : i + 1 | 0, B = h, h = B = (w = w + 1 | 0) ? B : B + 1 | 0, (0 | r) != (0 | w) | (0 | f) != (0 | B););
                                                i = C + o[A + 60 >> 2] | 0, i = (I = g + o[A + 56 >> 2] | 0) >>> 0 < g >>> 0 ? i + 1 | 0 : i, o[A + 56 >> 2] = I, o[A + 60 >> 2] = i;
                                            }
                                        }
                                    }
                                    function T(A, I, g) {
                                        var C, B = 0, Q = 0, i = 0, E = 0, a = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, h = 0, n = 0, s = 0, k = 0, F = 0, S = 0;
                                        y = o[I + 4 >> 2], B = o[A + 4 >> 2], w = o[I + 8 >> 2], Q = o[A + 8 >> 2], h = o[I + 12 >> 2], i = o[A + 12 >> 2], n = o[I + 16 >> 2], E = o[A + 16 >> 2], s = o[I + 20 >> 2], a = o[A + 20 >> 2], k = o[I + 24 >> 2], f = o[A + 24 >> 2], D = o[I + 28 >> 2], c = o[A + 28 >> 2], F = o[I + 32 >> 2], e = o[A + 32 >> 2], S = o[I + 36 >> 2], r = o[A + 36 >> 2], g = 0 - g | 0, t = o[A >> 2], o[A >> 2] = g & (t ^ o[I >> 2]) ^ t, o[A + 36 >> 2] = r ^ g & (r ^ S), o[A + 32 >> 2] = e ^ g & (e ^ F), o[A + 28 >> 2] = c ^ g & (c ^ D), o[A + 24 >> 2] = f ^ g & (f ^ k), o[A + 20 >> 2] = a ^ g & (a ^ s), o[A + 16 >> 2] = E ^ g & (E ^ n), o[A + 12 >> 2] = i ^ g & (i ^ h), o[A + 8 >> 2] = Q ^ g & (Q ^ w), o[A + 4 >> 2] = B ^ g & (B ^ y), B = o[A + 40 >> 2], y = o[I + 40 >> 2], Q = o[A + 44 >> 2], w = o[I + 44 >> 2], i = o[A + 48 >> 2], h = o[I + 48 >> 2], E = o[A + 52 >> 2], n = o[I + 52 >> 2], a = o[A + 56 >> 2], s = o[I + 56 >> 2], f = o[A + 60 >> 2], k = o[I + 60 >> 2], c = o[(D = A - -64 | 0) >> 2], F = o[I - -64 >> 2], e = o[A + 68 >> 2], S = o[I + 68 >> 2], r = o[A + 72 >> 2], t = o[I + 72 >> 2], C = o[A + 76 >> 2], o[A + 76 >> 2] = C ^ g & (o[I + 76 >> 2] ^ C), o[A + 72 >> 2] = r ^ g & (r ^ t), o[A + 68 >> 2] = e ^ g & (e ^ S), o[D >> 2] = c ^ g & (c ^ F), o[A + 60 >> 2] = f ^ g & (f ^ k), o[A + 56 >> 2] = a ^ g & (a ^ s), o[A + 52 >> 2] = E ^ g & (E ^ n), o[A + 48 >> 2] = i ^ g & (i ^ h), o[A + 44 >> 2] = Q ^ g & (Q ^ w), o[A + 40 >> 2] = B ^ g & (B ^ y), B = o[A + 80 >> 2], y = o[I + 80 >> 2], Q = o[A + 84 >> 2], w = o[I + 84 >> 2], i = o[A + 88 >> 2], h = o[I + 88 >> 2], E = o[A + 92 >> 2], n = o[I + 92 >> 2], a = o[A + 96 >> 2], s = o[I + 96 >> 2], f = o[A + 100 >> 2], k = o[I + 100 >> 2], c = o[A + 104 >> 2], D = o[I + 104 >> 2], e = o[A + 108 >> 2], F = o[I + 108 >> 2], r = o[A + 112 >> 2], S = o[I + 112 >> 2], t = o[I + 116 >> 2], I = o[A + 116 >> 2], o[A + 116 >> 2] = g & (t ^ I) ^ I, o[A + 112 >> 2] = r ^ g & (r ^ S), o[A + 108 >> 2] = e ^ g & (e ^ F), o[A + 104 >> 2] = c ^ g & (c ^ D), o[A + 100 >> 2] = f ^ g & (f ^ k), o[A + 96 >> 2] = a ^ g & (a ^ s), o[A + 92 >> 2] = E ^ g & (E ^ n), o[A + 88 >> 2] = i ^ g & (i ^ h), o[A + 84 >> 2] = Q ^ g & (Q ^ w), o[A + 80 >> 2] = B ^ g & (B ^ y);
                                    }
                                    function O(A, I) {
                                        var g, C, B = 0;
                                        for(w = g = w - 192 | 0, M(C = g + 144 | 0, I), M(B = g + 96 | 0, C), M(B, B), H(B, I, B), H(C, C, B), M(I = g + 48 | 0, C), H(B, B, I), M(I, B), M(I, I), M(I, I), M(I, I), M(I, I), H(B, I, B), M(I, B), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), H(I, I, B), M(g, I), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), H(I, g, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), H(B, I, B), M(I, B), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), H(I, I, B), M(g, I), I = 1; M(g, g), 100 != (0 | (I = I + 1 | 0)););
                                        H(I = g + 48 | 0, g, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), H(B = g + 96 | 0, I, B), M(B, B), M(B, B), M(B, B), M(B, B), M(B, B), H(A, B, g + 144 | 0), w = g + 192 | 0;
                                    }
                                    function V(A, I, g) {
                                        var C, B, Q, i, E, a, f, e, r = 0;
                                        w = C = w - 128 | 0, o[A >> 2] = 1, o[A + 4 >> 2] = 0, o[A + 8 >> 2] = 0, o[A + 12 >> 2] = 0, o[A + 16 >> 2] = 0, o[A + 20 >> 2] = 0, o[A + 24 >> 2] = 0, o[A + 28 >> 2] = 0, o[A + 32 >> 2] = 0, o[A + 36 >> 2] = 0, o[A + 40 >> 2] = 1, dA(A + 44 | 0, 0, 76), T(A, I = c(I, 960) + 2704 | 0, (255 & (1 ^ (r = g - ((g >> 31 & g) << 1) | 0))) - 1 >>> 31 | 0), T(A, I + 120 | 0, (255 & (2 ^ r)) - 1 >>> 31 | 0), T(A, I + 240 | 0, (255 & (3 ^ r)) - 1 >>> 31 | 0), T(A, I + 360 | 0, (255 & (4 ^ r)) - 1 >>> 31 | 0), T(A, I + 480 | 0, (255 & (5 ^ r)) - 1 >>> 31 | 0), T(A, I + 600 | 0, (255 & (6 ^ r)) - 1 >>> 31 | 0), T(A, I + 720 | 0, (255 & (7 ^ r)) - 1 >>> 31 | 0), T(A, I + 840 | 0, (255 & (8 ^ r)) - 1 >>> 31 | 0), I = o[A + 76 >> 2], o[C + 40 >> 2] = o[A + 72 >> 2], o[C + 44 >> 2] = I, r = o[4 + (I = A - -64 | 0) >> 2], o[C + 32 >> 2] = o[I >> 2], o[C + 36 >> 2] = r, I = o[A + 60 >> 2], o[C + 24 >> 2] = o[A + 56 >> 2], o[C + 28 >> 2] = I, I = o[A + 52 >> 2], o[C + 16 >> 2] = o[A + 48 >> 2], o[C + 20 >> 2] = I, I = o[A + 44 >> 2], o[C + 8 >> 2] = o[A + 40 >> 2], o[C + 12 >> 2] = I, I = o[A + 12 >> 2], o[C + 56 >> 2] = o[A + 8 >> 2], o[C + 60 >> 2] = I, r = o[A + 20 >> 2], o[(I = C - -64 | 0) >> 2] = o[A + 16 >> 2], o[I + 4 >> 2] = r, I = o[A + 28 >> 2], o[C + 72 >> 2] = o[A + 24 >> 2], o[C + 76 >> 2] = I, I = o[A + 36 >> 2], o[C + 80 >> 2] = o[A + 32 >> 2], o[C + 84 >> 2] = I, I = o[A + 4 >> 2], o[C + 48 >> 2] = o[A >> 2], o[C + 52 >> 2] = I, I = o[A + 80 >> 2], r = o[A + 84 >> 2], B = o[A + 88 >> 2], Q = o[A + 92 >> 2], i = o[A + 96 >> 2], E = o[A + 100 >> 2], a = o[A + 104 >> 2], f = o[A + 108 >> 2], e = o[A + 112 >> 2], o[C + 124 >> 2] = 0 - o[A + 116 >> 2], o[C + 120 >> 2] = 0 - e, o[C + 116 >> 2] = 0 - f, o[C + 112 >> 2] = 0 - a, o[C + 108 >> 2] = 0 - E, o[C + 104 >> 2] = 0 - i, o[C + 100 >> 2] = 0 - Q, o[C + 96 >> 2] = 0 - B, o[C + 92 >> 2] = 0 - r, o[C + 88 >> 2] = 0 - I, T(A, C + 8 | 0, (128 & g) >>> 7 | 0), w = C + 128 | 0;
                                    }
                                    function Z(A, I, g, C) {
                                        var B = 0, Q = 0, i = 0, o = 0, f = 0, c = 0, e = 0;
                                        if (g | C) A: for(e = A + 224 | 0, f = A + 96 | 0, Q = a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24;;){
                                            if (B = Q + f | 0, !C & g >>> 0 <= (i = 256 - Q | 0) >>> 0) {
                                                YA(B, I, g), I = g + (a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) | 0, E[A + 352 | 0] = I, E[A + 353 | 0] = I >>> 8, E[A + 354 | 0] = I >>> 16, E[A + 355 | 0] = I >>> 24;
                                                break A;
                                            }
                                            if (YA(B, I, i), B = (a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) + i | 0, E[A + 352 | 0] = B, E[A + 353 | 0] = B >>> 8, E[A + 354 | 0] = B >>> 16, E[A + 355 | 0] = B >>> 24, c = Q = a[A + 68 | 0] | a[A + 69 | 0] << 8 | a[A + 70 | 0] << 16 | a[A + 71 | 0] << 24, Q = (o = 128 + (B = a[A + 64 | 0] | a[A + 65 | 0] << 8 | a[A + 66 | 0] << 16 | a[A + 67 | 0] << 24) | 0) >>> 0 < 128 ? Q + 1 | 0 : Q, E[A + 64 | 0] = o, E[A + 65 | 0] = o >>> 8, E[A + 66 | 0] = o >>> 16, E[A + 67 | 0] = o >>> 24, E[A + 68 | 0] = Q, E[A + 69 | 0] = Q >>> 8, E[A + 70 | 0] = Q >>> 16, E[A + 71 | 0] = Q >>> 24, Q = a[A + 76 | 0] | a[A + 77 | 0] << 8 | a[A + 78 | 0] << 16 | a[A + 79 | 0] << 24, Q = (c = B = -1 == (0 | c) & B >>> 0 > 4294967167) >>> 0 > (B = B + (a[A + 72 | 0] | a[A + 73 | 0] << 8 | a[A + 74 | 0] << 16 | a[A + 75 | 0] << 24) | 0) >>> 0 ? Q + 1 | 0 : Q, E[A + 72 | 0] = B, E[A + 73 | 0] = B >>> 8, E[A + 74 | 0] = B >>> 16, E[A + 75 | 0] = B >>> 24, E[A + 76 | 0] = Q, E[A + 77 | 0] = Q >>> 8, E[A + 78 | 0] = Q >>> 16, E[A + 79 | 0] = Q >>> 24, n(A, f), YA(f, e, 128), B = Q = (a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) - 128 | 0, E[A + 352 | 0] = B, E[A + 353 | 0] = B >>> 8, E[A + 354 | 0] = B >>> 16, E[A + 355 | 0] = B >>> 24, I = I + i | 0, !((C = C - (g >>> 0 < i >>> 0) | 0) | (g = g - i | 0))) break;
                                        }
                                        return 0;
                                    }
                                    function W(A, I) {
                                        var g, C = 0, B = 0, Q = 0, i = 0, E = 0, a = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, h = 0, n = 0, s = 0, k = 0;
                                        C = o[I + 40 >> 2], Q = o[I + 4 >> 2], i = o[I + 44 >> 2], E = o[I + 8 >> 2], a = o[I + 48 >> 2], f = o[I + 12 >> 2], c = o[I + 52 >> 2], e = o[I + 16 >> 2], r = o[I + 56 >> 2], D = o[I + 20 >> 2], t = o[I + 60 >> 2], y = o[I + 24 >> 2], w = o[(B = I - -64 | 0) >> 2], h = o[I + 28 >> 2], n = o[I + 68 >> 2], s = o[I + 32 >> 2], k = o[I + 72 >> 2], g = o[I >> 2], o[A + 36 >> 2] = o[I + 36 >> 2] + o[I + 76 >> 2], o[A + 32 >> 2] = s + k, o[A + 28 >> 2] = h + n, o[A + 24 >> 2] = y + w, o[A + 20 >> 2] = D + t, o[A + 16 >> 2] = e + r, o[A + 12 >> 2] = f + c, o[A + 8 >> 2] = E + a, o[A + 4 >> 2] = Q + i, o[A >> 2] = C + g, C = o[I + 40 >> 2], Q = o[I + 4 >> 2], i = o[I + 44 >> 2], E = o[I + 8 >> 2], a = o[I + 48 >> 2], f = o[I + 12 >> 2], c = o[I + 52 >> 2], e = o[I + 16 >> 2], r = o[I + 56 >> 2], D = o[I + 20 >> 2], t = o[I + 60 >> 2], y = o[I + 24 >> 2], B = o[B >> 2], w = o[I + 28 >> 2], h = o[I + 68 >> 2], n = o[I + 32 >> 2], s = o[I + 72 >> 2], k = o[I >> 2], o[A + 76 >> 2] = o[I + 76 >> 2] - o[I + 36 >> 2], o[A + 72 >> 2] = s - n, o[A + 68 >> 2] = h - w, o[A - -64 >> 2] = B - y, o[A + 60 >> 2] = t - D, o[A + 56 >> 2] = r - e, o[A + 52 >> 2] = c - f, o[A + 48 >> 2] = a - E, o[A + 44 >> 2] = i - Q, o[A + 40 >> 2] = C - k, C = o[I + 84 >> 2], o[A + 80 >> 2] = o[I + 80 >> 2], o[A + 84 >> 2] = C, C = o[I + 92 >> 2], o[A + 88 >> 2] = o[I + 88 >> 2], o[A + 92 >> 2] = C, C = o[I + 100 >> 2], o[A + 96 >> 2] = o[I + 96 >> 2], o[A + 100 >> 2] = C, C = o[I + 108 >> 2], o[A + 104 >> 2] = o[I + 104 >> 2], o[A + 108 >> 2] = C, C = o[I + 116 >> 2], o[A + 112 >> 2] = o[I + 112 >> 2], o[A + 116 >> 2] = C, H(A + 120 | 0, I + 120 | 0, 1440);
                                    }
                                    function $(A, I) {
                                        var g, C, B, Q, i, a = 0, f = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, h = 0, n = 0;
                                        (a = o[A + 56 >> 2]) | (f = o[A + 60 >> 2]) && (E[(r = A - -64 | 0) + a | 0] = 1, !((n = a + 1 | 0) ? f : f + 1 | 0) & n >>> 0 <= 15 && dA(65 + (A + a | 0) | 0, 0, 15 - a | 0), E[A + 80 | 0] = 1, d(A, r, 16, 0)), n = o[A + 52 >> 2], w = o[A + 48 >> 2], r = o[A + 44 >> 2], a = o[A + 24 >> 2], D = o[A + 28 >> 2] + (a >>> 26 | 0) | 0, e = o[A + 32 >> 2] + (D >>> 26 | 0) | 0, g = o[A + 36 >> 2] + (e >>> 26 | 0) | 0, f = (y = (a = (a = (67108863 & a) + ((t = o[A + 20 >> 2] + c(g >>> 26 | 0, 5) | 0) >>> 26 | 0) | 0) & (D = (e = (i = (67108863 & g) + ((Q = (C = 67108863 & e) + ((B = (h = 67108863 & D) + ((t = a + ((f = 5 + (y = 67108863 & t) | 0) >>> 26 | 0) | 0) >>> 26 | 0) | 0) >>> 26 | 0) | 0) >>> 26 | 0) | 0) - 67108864 | 0) >> 31) | t & (e = 67108863 & (t = (e >>> 31 | 0) - 1 | 0))) << 26 | f & e | D & y) + o[A + 40 >> 2] | 0, E[0 | I] = f, E[I + 1 | 0] = f >>> 8, E[I + 2 | 0] = f >>> 16, E[I + 3 | 0] = f >>> 24, y = f >>> 0 < y >>> 0, f = 0, f = (a = (h = D & h | e & B) << 20 | a >>> 6) >>> 0 > (a = a + r | 0) >>> 0 ? 1 : f, f = (r = a) >>> 0 > (a = a + y | 0) >>> 0 ? f + 1 | 0 : f, E[I + 4 | 0] = a, E[I + 5 | 0] = a >>> 8, E[I + 6 | 0] = a >>> 16, E[I + 7 | 0] = a >>> 24, a = 0, r = (r = (e = D & C | e & Q) << 14 | h >>> 12) >>> 0 > (w = r + w | 0) >>> 0 ? 1 : a, a = w, w = f, a = a + f | 0, f = r, f = a >>> 0 < w >>> 0 ? f + 1 | 0 : f, E[I + 8 | 0] = a, E[I + 9 | 0] = a >>> 8, E[I + 10 | 0] = a >>> 16, E[I + 11 | 0] = a >>> 24, f = (a = (a = (t & i | D & g) << 8 | e >>> 18) + n | 0) + f | 0, E[I + 12 | 0] = f, E[I + 13 | 0] = f >>> 8, E[I + 14 | 0] = f >>> 16, E[I + 15 | 0] = f >>> 24, iI(A, 88);
                                    }
                                    function AA(A, I, g) {
                                        var C, B = 0;
                                        return w = C = w - 16 | 0, E[C + 15 | 0] = 0, B = -1, 0 | wI[o[8806]](A, I, g) || (E[C + 15 | 0] = a[0 | A] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 1 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 2 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 3 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 4 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 5 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 6 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 7 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 8 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 9 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 10 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 11 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 12 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 13 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 14 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 15 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 16 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 17 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 18 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 19 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 20 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 21 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 22 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 23 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 24 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 25 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 26 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 27 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 28 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 29 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 30 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 31 | 0] | a[C + 15 | 0], B = (a[C + 15 | 0] << 23) - 8388608 >> 31), w = C + 16 | 0, B;
                                    }
                                    function IA(A, I) {
                                        var g, C, B, Q, i, a, f, e = 0, r = 0;
                                        C = o[I + 32 >> 2], B = o[I + 28 >> 2], Q = o[I + 24 >> 2], i = o[I + 20 >> 2], a = o[I + 16 >> 2], f = o[I + 12 >> 2], e = o[I + 4 >> 2], r = o[I >> 2], g = o[I + 36 >> 2], I = o[I + 8 >> 2], r = c((C + (B + (Q + (i + (a + (f + ((e + (r + (c(g, 19) + 16777216 >>> 25 | 0) >> 26) >> 25) + I >> 26) >> 25) >> 26) >> 25) >> 26) >> 25) >> 26) + g >> 25, 19) + r | 0, E[0 | A] = r, E[A + 2 | 0] = r >>> 16, E[A + 1 | 0] = r >>> 8, e = e + (r >> 26) | 0, E[A + 5 | 0] = e >>> 14, E[A + 4 | 0] = e >>> 6, E[A + 3 | 0] = r >>> 24 & 3 | e << 2, I = I + (e >> 25) | 0, E[A + 8 | 0] = I >>> 13, E[A + 7 | 0] = I >>> 5, E[A + 6 | 0] = I << 3 | (29360128 & e) >>> 22, r = (I >> 26) + f | 0, E[A + 11 | 0] = r >>> 11, E[A + 10 | 0] = r >>> 3, E[A + 9 | 0] = r << 5 | (65011712 & I) >>> 21, e = (r >> 25) + a | 0, E[A + 15 | 0] = e >>> 18, E[A + 14 | 0] = e >>> 10, E[A + 13 | 0] = e >>> 2, I = (e >> 26) + i | 0, E[A + 16 | 0] = I, E[A + 12 | 0] = e << 6 | (33030144 & r) >>> 19, E[A + 18 | 0] = I >>> 16, E[A + 17 | 0] = I >>> 8, e = (I >> 25) + Q | 0, E[A + 21 | 0] = e >>> 15, E[A + 20 | 0] = e >>> 7, E[A + 19 | 0] = I >>> 24 & 1 | e << 1, I = (e >> 26) + B | 0, E[A + 24 | 0] = I >>> 13, E[A + 23 | 0] = I >>> 5, E[A + 22 | 0] = I << 3 | (58720256 & e) >>> 23, e = (I >> 25) + C | 0, E[A + 27 | 0] = e >>> 12, E[A + 26 | 0] = e >>> 4, E[A + 25 | 0] = e << 4 | (31457280 & I) >>> 21, I = g + (e >> 26) | 0, E[A + 30 | 0] = I >>> 10, E[A + 29 | 0] = I >>> 2, E[A + 31 | 0] = (33292288 & I) >>> 18, E[A + 28 | 0] = I << 6 | (66060288 & e) >>> 20;
                                    }
                                    function gA(A, I, g) {
                                        var C, B = 0, Q = 0, i = 0, o = 0, f = 0, c = 0, e = 0;
                                        if (w = C = w - 192 | 0, g >>> 0 >= 129 && (cA(A), R(A, I, g, 0), N(A, C), g = 64, I = C), cA(A), dA(C - -64 | 0, 54, 128), g) {
                                            if (g >>> 0 >= 4) for(e = 252 & g; E[0 | (B = (i = C - -64 | 0) + Q | 0)] = a[0 | B] ^ a[I + Q | 0], E[0 | (o = (B = 1 | Q) + i | 0)] = a[0 | o] ^ a[I + B | 0], E[0 | (o = (B = 2 | Q) + i | 0)] = a[0 | o] ^ a[I + B | 0], E[0 | (B = (B = i) + (i = 3 | Q) | 0)] = a[0 | B] ^ a[I + i | 0], Q = Q + 4 | 0, (0 | e) != (0 | (f = f + 4 | 0)););
                                            if (f = 3 & g) for(; E[0 | (i = (C - -64 | 0) + Q | 0)] = a[0 | i] ^ a[I + Q | 0], Q = Q + 1 | 0, (0 | f) != (0 | (c = c + 1 | 0)););
                                        }
                                        if (R(A, Q = C - -64 | 0, 128, 0), cA(i = A + 208 | 0), dA(Q, 92, 128), g) {
                                            if (c = 0, Q = 0, g >>> 0 >= 4) for(e = 252 & g, f = 0; E[0 | (B = (A = C - -64 | 0) + Q | 0)] = a[0 | B] ^ a[I + Q | 0], E[0 | (o = (B = 1 | Q) + A | 0)] = a[0 | o] ^ a[I + B | 0], E[0 | (o = (B = 2 | Q) + A | 0)] = a[0 | o] ^ a[I + B | 0], E[0 | (B = (B = A) + (A = 3 | Q) | 0)] = a[0 | B] ^ a[A + I | 0], Q = Q + 4 | 0, (0 | e) != (0 | (f = f + 4 | 0)););
                                            if (A = 3 & g) for(; E[0 | (g = (C - -64 | 0) + Q | 0)] = a[0 | g] ^ a[I + Q | 0], Q = Q + 1 | 0, (0 | A) != (0 | (c = c + 1 | 0)););
                                        }
                                        return R(i, A = C - -64 | 0, 128, 0), iI(A, 128), iI(C, 64), w = C + 192 | 0, 0;
                                    }
                                    function CA(A, I) {
                                        var g;
                                        return o[12 + (g = w - 16 | 0) >> 2] = A, o[g + 8 >> 2] = I, o[g + 4 >> 2] = 0, o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2]] ^ a[o[g + 8 >> 2]], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 1 | 0] ^ a[o[g + 8 >> 2] + 1 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 2 | 0] ^ a[o[g + 8 >> 2] + 2 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 3 | 0] ^ a[o[g + 8 >> 2] + 3 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 4 | 0] ^ a[o[g + 8 >> 2] + 4 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 5 | 0] ^ a[o[g + 8 >> 2] + 5 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 6 | 0] ^ a[o[g + 8 >> 2] + 6 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 7 | 0] ^ a[o[g + 8 >> 2] + 7 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 8 | 0] ^ a[o[g + 8 >> 2] + 8 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 9 | 0] ^ a[o[g + 8 >> 2] + 9 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 10 | 0] ^ a[o[g + 8 >> 2] + 10 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 11 | 0] ^ a[o[g + 8 >> 2] + 11 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 12 | 0] ^ a[o[g + 8 >> 2] + 12 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 13 | 0] ^ a[o[g + 8 >> 2] + 13 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 14 | 0] ^ a[o[g + 8 >> 2] + 14 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 15 | 0] ^ a[o[g + 8 >> 2] + 15 | 0], (o[g + 4 >> 2] - 1 >>> 8 & 1) - 1 | 0;
                                    }
                                    function BA(A, I) {
                                        var g, C = 0, B = 0;
                                        g = I;
                                        A: if (C = 255 & I) {
                                            if (3 & A) for(;;){
                                                if (!(I = a[0 | A]) | (0 | I) == (255 & g)) break A;
                                                if (!(3 & (A = A + 1 | 0))) break;
                                            }
                                            I: if (!((-1 ^ (I = o[A >> 2])) & I - 16843009 & -2139062144)) for(C = c(C, 16843009);;){
                                                if ((-1 ^ (I ^= C)) & I - 16843009 & -2139062144) break I;
                                                if (I = o[A + 4 >> 2], A = A + 4 | 0, I - 16843009 & (-1 ^ I) & -2139062144) break;
                                            }
                                            for(; I = A, (C = a[0 | A]) && (A = A + 1 | 0, (0 | C) != (255 & g)););
                                            A = I;
                                        } else {
                                            C = A;
                                            I: {
                                                g: {
                                                    C: if (3 & A) {
                                                        if (I = 0, !a[0 | A]) break I;
                                                        for(;;){
                                                            if (!(3 & (A = A + 1 | 0))) break C;
                                                            if (!a[0 | A]) break;
                                                        }
                                                        break g;
                                                    }
                                                    for(; I = A, A = A + 4 | 0, !((-1 ^ (B = o[I >> 2])) & B - 16843009 & -2139062144););
                                                    for(; I = (A = I) + 1 | 0, a[0 | A];);
                                                }
                                                I = A - C | 0;
                                            }
                                            A = I + C | 0;
                                        }
                                        return a[0 | A] == (255 & g) ? A : 0;
                                    }
                                    function QA(A, I, g, C, B, Q, i) {
                                        var E, a, f = 0, c = 0, e = 0;
                                        w = E = w - 96 | 0, m(E, Q, i), i = E + 32 | 0, a = Q + 16 | 0, wI[o[8808]](i, 32, 0, a, E), Q = -1;
                                        A: {
                                            if (!(0 | wI[o[8802]](g, I, C, B, i))) {
                                                if (Q = 0, !A) break A;
                                                !((!B & C >>> 0 > I - A >>> 0 | 0 != (0 | B)) & A >>> 0 < I >>> 0) & (!B & C >>> 0 <= A - I >>> 0 | A >>> 0 <= I >>> 0) || (I = pA(A, I, C)), c = i = (Q = !B & C >>> 0 >= 32 | 0 != (0 | B)) ? 0 : B, (g = Q ? 32 : C) | i ? (e = YA(E - -64 | 0, I, g), qA(Q = E + 32 | 0, Q, f = g + 32 | 0, i = f >>> 0 < 32 ? i + 1 | 0 : i, a, E), YA(A, e, g)) : qA(Q = E + 32 | 0, Q, f = g + 32 | 0, i = f >>> 0 < 32 ? i + 1 | 0 : i, a, E), iI(E + 32 | 0, 64), Q = 0, !B & C >>> 0 < 33 || jA(A + g | 0, I + g | 0, C - g | 0, B - (c + (g >>> 0 > C >>> 0) | 0) | 0, a, E);
                                            }
                                            iI(E, 32);
                                        }
                                        return w = E + 96 | 0, Q;
                                    }
                                    function iA(A, I, g, C, B, Q, i) {
                                        var E, a, f, c, e = 0;
                                        return w = E = w - 352 | 0, m(E, Q, i), !((!B & C >>> 0 > A - g >>> 0 | 0 != (0 | B)) & A >>> 0 > g >>> 0) & (!B & C >>> 0 <= g - A >>> 0 | A >>> 0 >= g >>> 0) || (g = pA(A, g, C)), o[E + 56 >> 2] = 0, o[E + 60 >> 2] = 0, o[E + 48 >> 2] = 0, o[E + 52 >> 2] = 0, o[E + 40 >> 2] = 0, o[E + 44 >> 2] = 0, o[E + 32 >> 2] = 0, o[E + 36 >> 2] = 0, (f = !((i = (e = !B & C >>> 0 >= 32 | 0 != (0 | B)) ? 32 : C) | (e = e ? 0 : B))) || YA(E - -64 | 0, g, i), qA(a = E + 32 | 0, a, c = i + 32 | 0, c >>> 0 < 32 ? e + 1 | 0 : e, Q = Q + 16 | 0, E), CI(E + 96 | 0, a), f || YA(A, E - -64 | 0, i), iI(E + 32 | 0, 64), !B & C >>> 0 >= 33 | B && jA(A + i | 0, g + i | 0, C - i | 0, B - (e + (C >>> 0 < i >>> 0) | 0) | 0, Q, E), iI(E, 32), $A(g = E + 96 | 0, A, C, B), BI(g, I), iI(g, 256), w = E + 352 | 0, 0;
                                    }
                                    function EA(A, I, g, C, B, Q, i, E, f, c) {
                                        var e, r;
                                        return w = e = w - 400 | 0, o[e + 4 >> 2] = 0, x(r = e + 16 | 0, f, c), c = a[f + 20 | 0] | a[f + 21 | 0] << 8 | a[f + 22 | 0] << 16 | a[f + 23 | 0] << 24, o[e + 8 >> 2] = a[f + 16 | 0] | a[f + 17 | 0] << 8 | a[f + 18 | 0] << 16 | a[f + 19 | 0] << 24, o[e + 12 >> 2] = c, ZA(c = e + 80 | 0, 64, e + 4 | 0, r), CI(f = e + 144 | 0, c), iI(c, 64), $A(f, Q, i, E), $A(f, 33904, 0 - i & 15, 0), $A(f, I, g, C), $A(f, 33904, 0 - g & 15, 0), o[e + 72 >> 2] = i, o[e + 76 >> 2] = E, $A(f, Q = e + 72 | 0, 8, 0), o[e + 72 >> 2] = g, o[e + 76 >> 2] = C, $A(f, Q, 8, 0), BI(f, Q = e + 48 | 0), iI(f, 256), f = CA(Q, B), iI(Q, 16), A && (f ? (dA(A, 0, g), f = -1) : (xA(A, I, g, C, e + 4 | 0, e + 16 | 0), f = 0)), iI(e + 16 | 0, 32), w = e + 400 | 0, f;
                                    }
                                    function oA(A, I, g, C, B, Q, i, E, f, c, e) {
                                        var r, D, t;
                                        return w = r = w - 384 | 0, o[r + 4 >> 2] = 0, x(D = r + 16 | 0, c, e), e = a[c + 20 | 0] | a[c + 21 | 0] << 8 | a[c + 22 | 0] << 16 | a[c + 23 | 0] << 24, o[r + 8 >> 2] = a[c + 16 | 0] | a[c + 17 | 0] << 8 | a[c + 18 | 0] << 16 | a[c + 19 | 0] << 24, o[r + 12 >> 2] = e, ZA(e = r - -64 | 0, 64, t = r + 4 | 0, D), CI(c = r + 128 | 0, e), iI(e, 64), $A(c, i, E, f), $A(c, 33904, 0 - E & 15, 0), xA(A, C, B, Q, t, D), $A(c, A, B, Q), $A(c, 33904, 0 - B & 15, 0), o[r + 56 >> 2] = E, o[r + 60 >> 2] = f, $A(c, A = r + 56 | 0, 8, 0), o[r + 56 >> 2] = B, o[r + 60 >> 2] = Q, $A(c, A, 8, 0), BI(c, I), iI(c, 256), g && (o[g >> 2] = 16, o[g + 4 >> 2] = 0), iI(r + 16 | 0, 32), w = r + 384 | 0, 0;
                                    }
                                    function aA(A, I, g, C) {
                                        var B, Q = 0;
                                        return w = B = w - 208 | 0, o[B + 72 >> 2] = 0, o[B + 76 >> 2] = 0, Q = o[8579], o[B + 8 >> 2] = o[8578], o[B + 12 >> 2] = Q, Q = o[8581], o[B + 16 >> 2] = o[8580], o[B + 20 >> 2] = Q, Q = o[8583], o[B + 24 >> 2] = o[8582], o[B + 28 >> 2] = Q, Q = o[8585], o[B + 32 >> 2] = o[8584], o[B + 36 >> 2] = Q, Q = o[8587], o[B + 40 >> 2] = o[8586], o[B + 44 >> 2] = Q, Q = o[8589], o[B + 48 >> 2] = o[8588], o[B + 52 >> 2] = Q, Q = o[8591], o[B + 56 >> 2] = o[8590], o[B + 60 >> 2] = Q, o[B + 64 >> 2] = 0, o[B + 68 >> 2] = 0, Q = o[8577], o[B >> 2] = o[8576], o[B + 4 >> 2] = Q, R(B, I, g, C), N(B, A), w = B + 208 | 0, 0;
                                    }
                                    function fA(A, I) {
                                        var g, C = 0, B = 0, Q = 0;
                                        if (E[15 + (g = w - 16 | 0) | 0] = 0, I) {
                                            if (B = 3 & I, I >>> 0 >= 4) for(Q = -4 & I, I = 0; E[g + 15 | 0] = a[A + C | 0] | a[g + 15 | 0], E[g + 15 | 0] = a[(1 | C) + A | 0] | a[g + 15 | 0], E[g + 15 | 0] = a[(2 | C) + A | 0] | a[g + 15 | 0], E[g + 15 | 0] = a[(3 | C) + A | 0] | a[g + 15 | 0], C = C + 4 | 0, (0 | Q) != (0 | (I = I + 4 | 0)););
                                            if (B) for(I = 0; E[g + 15 | 0] = a[A + C | 0] | a[g + 15 | 0], C = C + 1 | 0, (0 | B) != (0 | (I = I + 1 | 0)););
                                        }
                                        return a[g + 15 | 0] - 1 >>> 8 & 1;
                                    }
                                    function cA(A) {
                                        var I = 0;
                                        o[A + 64 >> 2] = 0, o[A + 68 >> 2] = 0, o[A + 72 >> 2] = 0, o[A + 76 >> 2] = 0, I = o[8577], o[A >> 2] = o[8576], o[A + 4 >> 2] = I, I = o[8579], o[A + 8 >> 2] = o[8578], o[A + 12 >> 2] = I, I = o[8581], o[A + 16 >> 2] = o[8580], o[A + 20 >> 2] = I, I = o[8583], o[A + 24 >> 2] = o[8582], o[A + 28 >> 2] = I, I = o[8585], o[A + 32 >> 2] = o[8584], o[A + 36 >> 2] = I, I = o[8587], o[A + 40 >> 2] = o[8586], o[A + 44 >> 2] = I, I = o[8589], o[A + 48 >> 2] = o[8588], o[A + 52 >> 2] = I, I = o[8591], o[A + 56 >> 2] = o[8590], o[A + 60 >> 2] = I;
                                    }
                                    function eA(A, I, g) {
                                        var C, B = 0, Q = 0;
                                        if (o[12 + (C = w - 16 | 0) >> 2] = A, o[C + 8 >> 2] = I, A = 0, E[C + 7 | 0] = 0, g) {
                                            if (I = 1 & g, 1 != (0 | g)) for(Q = -2 & g, g = 0; E[C + 7 | 0] = a[C + 7 | 0] | a[o[C + 12 >> 2] + A | 0] ^ a[o[C + 8 >> 2] + A | 0], B = 1 | A, E[C + 7 | 0] = a[C + 7 | 0] | a[B + o[C + 12 >> 2] | 0] ^ a[o[C + 8 >> 2] + B | 0], A = A + 2 | 0, (0 | Q) != (0 | (g = g + 2 | 0)););
                                            I && (E[C + 7 | 0] = a[C + 7 | 0] | a[o[C + 12 >> 2] + A | 0] ^ a[o[C + 8 >> 2] + A | 0]);
                                        }
                                        return (a[C + 7 | 0] - 1 >>> 8 & 1) - 1 | 0;
                                    }
                                    function rA(A) {
                                        for(var I = 0, g = 0, C = 0, B = 0, Q = 0, i = 0, E = 0, o = 0, f = 0, c = 0; B = (g = a[A + C | 0]) ^ a[0 | (I = C + 2448 | 0)] | B, Q = g ^ a[I + 192 | 0] | Q, i = g ^ a[I + 160 | 0] | i, E = g ^ a[I + 128 | 0] | E, o = g ^ a[I + 96 | 0] | o, f = g ^ a[I - -64 | 0] | f, c = g ^ a[I + 32 | 0] | c, 31 != (0 | (C = C + 1 | 0)););
                                        return ((255 & ((I = 127 ^ (A = 127 & a[A + 31 | 0])) | Q)) - 1 | (255 & (I | i)) - 1 | (255 & (I | E)) - 1 | (255 & (122 ^ A | o)) - 1 | (255 & (5 ^ A | f)) - 1 | (255 & (A | c)) - 1 | (255 & (A | B)) - 1) >>> 8 & 1;
                                    }
                                    function DA(A, I, g) {
                                        var C = 0, B = 0, Q = 0, i = 0;
                                        return B = 31 & (Q = i = 63 & g), Q = Q >>> 0 >= 32 ? -1 >>> B | 0 : (C = -1 >>> B | 0) | (1 << B) - 1 << 32 - B, Q &= A, C &= I, B = 31 & i, i >>> 0 >= 32 ? (C = Q << B, i = 0) : (C = (1 << B) - 1 & Q >>> 32 - B | C << B, i = Q << B), Q = C, C = 31 & (B = 0 - g & 63), B >>> 0 >= 32 ? (C = -1 << C, g = 0) : C = (g = -1 << C) | (1 << C) - 1 & -1 >>> 32 - C, A &= g, I &= C, C = 31 & B, B >>> 0 >= 32 ? (g = 0, A = I >>> C | 0) : (g = I >>> C | 0, A = ((1 << C) - 1 & I) << 32 - C | A >>> C), h = g | Q, A | i;
                                    }
                                    function tA(A, I, g, C, B, Q, i, E, a, f) {
                                        var c, e, r;
                                        return w = c = w - 352 | 0, ZA(r = c + 32 | 0, 64, a, f), CI(e = c + 96 | 0, r), iI(r, 64), $A(e, Q, i, E), $A(e, 33920, 0 - i & 15, 0), $A(e, I, g, C), $A(e, 33920, 0 - g & 15, 0), o[c + 24 >> 2] = i, o[c + 28 >> 2] = E, $A(e, Q = c + 24 | 0, 8, 0), o[c + 24 >> 2] = g, o[c + 28 >> 2] = C, $A(e, Q, 8, 0), BI(e, c), iI(e, 256), Q = CA(c, B), iI(c, 16), A && (Q ? (dA(A, 0, g), Q = -1) : (FA(A, I, g, C, a, 1, f), Q = 0)), w = c + 352 | 0, Q;
                                    }
                                    function yA(A, I, g, C, B, Q, i, E, a, f, c) {
                                        var e, r, D;
                                        return w = e = w - 336 | 0, ZA(D = e + 16 | 0, 64, f, c), CI(r = e + 80 | 0, D), iI(D, 64), $A(r, i, E, a), $A(r, 33920, 0 - E & 15, 0), FA(A, C, B, Q, f, 1, c), $A(r, A, B, Q), $A(r, 33920, 0 - B & 15, 0), o[e + 8 >> 2] = E, o[e + 12 >> 2] = a, $A(r, A = e + 8 | 0, 8, 0), o[e + 8 >> 2] = B, o[e + 12 >> 2] = Q, $A(r, A, 8, 0), BI(r, I), iI(r, 256), g && (o[g >> 2] = 16, o[g + 4 >> 2] = 0), w = e + 336 | 0, 0;
                                    }
                                    function wA(A, I, g, C, B, Q, i, E, a, f) {
                                        var c, e, r;
                                        return w = c = w - 352 | 0, WA(r = c + 32 | 0, a, f), CI(e = c + 96 | 0, r), iI(r, 64), $A(e, Q, i, E), o[c + 24 >> 2] = i, o[c + 28 >> 2] = E, $A(e, Q = c + 24 | 0, 8, 0), $A(e, I, g, C), o[c + 24 >> 2] = g, o[c + 28 >> 2] = C, $A(e, Q, 8, 0), BI(e, c), iI(e, 256), Q = CA(c, B), iI(c, 16), A && (Q ? (dA(A, 0, g), Q = -1) : (uA(A, I, g, C, a, f), Q = 0)), w = c + 352 | 0, Q;
                                    }
                                    function hA(A, I, g, C, B, Q, i, E, a, f, c) {
                                        var e, r, D;
                                        return w = e = w - 336 | 0, WA(D = e + 16 | 0, f, c), CI(r = e + 80 | 0, D), iI(D, 64), $A(r, i, E, a), o[e + 8 >> 2] = E, o[e + 12 >> 2] = a, $A(r, i = e + 8 | 0, 8, 0), uA(A, C, B, Q, f, c), $A(r, A, B, Q), o[e + 8 >> 2] = B, o[e + 12 >> 2] = Q, $A(r, i, 8, 0), BI(r, I), iI(r, 256), g && (o[g >> 2] = 16, o[g + 4 >> 2] = 0), w = e + 336 | 0, 0;
                                    }
                                    function nA(A, I) {
                                        var g;
                                        for(o[12 + (g = w - 16 | 0) >> 2] = A, o[g + 8 >> 2] = I, A = 0, o[g + 4 >> 2] = 0; o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + A | 0] ^ a[o[g + 8 >> 2] + A | 0], I = 1 | A, o[g + 4 >> 2] = o[g + 4 >> 2] | a[I + o[g + 12 >> 2] | 0] ^ a[I + o[g + 8 >> 2] | 0], 32 != (0 | (A = A + 2 | 0)););
                                        return (o[g + 4 >> 2] - 1 >>> 8 & 1) - 1 | 0;
                                    }
                                    function sA(A) {
                                        var I = 0, g = 0, C = 0, B = 0;
                                        for(I = 1; I = a[0 | (g = A + C | 0)] + I | 0, E[0 | g] = I, I = a[0 | (g = (1 | C) + A | 0)] + (I >>> 8 | 0) | 0, E[0 | g] = I, I = a[0 | (g = (2 | C) + A | 0)] + (I >>> 8 | 0) | 0, E[0 | g] = I, I = a[0 | (g = (3 | C) + A | 0)] + (I >>> 8 | 0) | 0, E[0 | g] = I, I = I >>> 8 | 0, C = C + 4 | 0, 4 != (0 | (B = B + 4 | 0)););
                                    }
                                    function kA(A, I, g, C) {
                                        var B, Q, i, E, o = 0, a = 0;
                                        return E = c(o = g >>> 16 | 0, a = A >>> 16 | 0), o = (65535 & (a = ((i = c(B = 65535 & g, Q = 65535 & A)) >>> 16 | 0) + c(a, B) | 0)) + c(o, Q) | 0, h = (c(I, g) + E | 0) + c(A, C) + (a >>> 16) + (o >>> 16) | 0, 65535 & i | o << 16;
                                    }
                                    function FA(A, I, g, C, B, i, E) {
                                        var a = 0, f = 0;
                                        a = C, 1 == (((a = (f = g + 63 | 0) >>> 0 < 63 ? a + 1 | 0 : a) >>> 6 | 0) + (0 != (0 | (a = (63 & a) << 26 | f >>> 6))) | 0) & i >>> 0 > (f = 0 - a | 0) >>> 0 | 1 == (0 | C) | C >>> 0 > 1 ? (zA(), Q()) : wI[o[8813]](A, I, g, C, B, i, E);
                                    }
                                    function SA(A) {
                                        var I = 0;
                                        o[A + 32 >> 2] = 0, o[A + 36 >> 2] = 0, I = o[8485], o[A >> 2] = o[8484], o[A + 4 >> 2] = I, I = o[8487], o[A + 8 >> 2] = o[8486], o[A + 12 >> 2] = I, I = o[8489], o[A + 16 >> 2] = o[8488], o[A + 20 >> 2] = I, I = o[8491], o[A + 24 >> 2] = o[8490], o[A + 28 >> 2] = I;
                                    }
                                    function HA(A, I) {
                                        A |= 0;
                                        var g, C = 0, B = 0, Q = 0;
                                        if (w = g = w - 16 | 0, I |= 0) for(; E[g + 15 | 0] = 0, B = A + C | 0, Q = 0 | r(35256, g + 15 | 0, 0), E[0 | B] = Q, (0 | (C = C + 1 | 0)) != (0 | I););
                                        w = g + 16 | 0;
                                    }
                                    function GA(A, I, g, C, B, Q, i) {
                                        var E, o, a = 0;
                                        return w = E = w - 32 | 0, a = -1, (o = g >>> 0 < 16) & !C || UA(E, Q, i) || (a = QA(A, I + 16 | 0, I, g - 16 | 0, C - o | 0, B, E), iI(E, 32)), w = E + 32 | 0, a;
                                    }
                                    function _A(A) {
                                        var I, g;
                                        return (A = (I = o[8800]) + (g = A + 7 & -8) | 0) >>> 0 <= I >>> 0 && g || A >>> 0 > hI() << 16 >>> 0 && !(0 | y(0 | A)) ? (o[9005] = 48, -1) : (o[8800] = A, I);
                                    }
                                    function MA(A, I) {
                                        var g, C, B;
                                        w = g = w - 176 | 0, O(C = g + 96 | 0, I + 80 | 0), H(B = g + 48 | 0, I, C), H(g, I + 40 | 0, C), IA(A, g), IA(g + 144 | 0, B), E[A + 31 | 0] = a[A + 31 | 0] ^ a[g + 144 | 0] << 7, w = g + 176 | 0;
                                    }
                                    function pA(A, I, g) {
                                        var C = 0;
                                        if (A >>> 0 < I >>> 0) return YA(A, I, g);
                                        if (g) for(C = A + g | 0, I = I + g | 0; I = I - 1 | 0, E[0 | (C = C - 1 | 0)] = a[0 | I], g = g - 1 | 0;);
                                        return A;
                                    }
                                    function NA(A, I, g, C, B, i, E) {
                                        var o, a = 0;
                                        if (w = o = w - 32 | 0, !C & g >>> 0 < 4294967280) return a = -1, UA(o, i, E) || (a = iA(A + 16 | 0, A, I, g, C, B, o), iI(o, 32)), w = o + 32 | 0, a;
                                        zA(), Q();
                                    }
                                    function JA(A, I, g, C, B, Q) {
                                        return I |= 0, 0 | (!(C |= 0) & (g |= 0) >>> 0 >= 16 | C ? QA(A |= 0, I + 16 | 0, I, g - 16 | 0, C - (g >>> 0 < 16) | 0, B |= 0, Q |= 0) : -1);
                                    }
                                    function UA(A, I, g) {
                                        A |= 0;
                                        var C, B = 0;
                                        return w = C = w - 32 | 0, B = -1, AA(C, g |= 0, I |= 0) || (B = m(A, 35184, C)), w = C + 32 | 0, 0 | B;
                                    }
                                    function YA(A, I, g) {
                                        var C = 0;
                                        if (g) for(C = A; E[0 | C] = a[0 | I], C = C + 1 | 0, I = I + 1 | 0, g = g - 1 | 0;);
                                        return A;
                                    }
                                    function dA(A, I, g) {
                                        var C = 0;
                                        if (g) for(C = A; E[0 | C] = I, C = C + 1 | 0, g = g - 1 | 0;);
                                        return A;
                                    }
                                    function KA(A, I, g) {
                                        return A |= 0, I |= 0, (g |= 0) >>> 0 >= 256 && (D(1260, 1187, 107, 1067), Q()), 0 | J(A, I, 255 & g);
                                    }
                                    function bA(A, I) {
                                        var g;
                                        w = g = w + -64 | 0, N(A, g), R(A = A + 208 | 0, g, 64, 0), N(A, I), iI(g, 64), w = g - -64 | 0;
                                    }
                                    function PA(A, I, g, C, B, Q, i) {
                                        return 0 | iA(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                    }
                                    function vA(A, I, g, C, B, Q, i) {
                                        return 0 | QA(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                    }
                                    function LA(A, I) {
                                        var g;
                                        w = g = w - 32 | 0, l(A, g), z(A = A + 104 | 0, g, 32), l(A, I), iI(g, 32), w = g + 32 | 0;
                                    }
                                    function RA(A, I) {
                                        var g = 0;
                                        return (-1 >>> (g = 31 & I) & A) << g | ((g = A) & -1 << (A = 0 - I & 31)) >>> A;
                                    }
                                    function uA(A, I, g, C, B, i) {
                                        1 == (0 | C) | C >>> 0 > 1 && (zA(), Q()), wI[o[8812]](A, I, g, C, B, 1, 0, i);
                                    }
                                    function xA(A, I, g, C, B, i) {
                                        1 == (0 | C) | C >>> 0 > 1 && (zA(), Q()), wI[o[8813]](A, I, g, C, B, 1, i);
                                    }
                                    function mA() {
                                        var A;
                                        w = A = w - 16 | 0, E[A + 15 | 0] = 0, r(35292, A + 15 | 0, 0), w = A + 16 | 0;
                                    }
                                    function lA(A, I, g) {
                                        return 0 | AA(A |= 0, I |= 0, g |= 0);
                                    }
                                    function zA() {
                                        var A;
                                        (A = o[9137]) && wI[0 | A](), t(), Q();
                                    }
                                    function qA(A, I, g, C, B, Q) {
                                        wI[o[8809]](A, I, g, C, B, 0, 0, Q);
                                    }
                                    function XA(A, I) {
                                        return A |= 0, HA(I |= 0, 32), 0 | II(A, I);
                                    }
                                    function jA(A, I, g, C, B, Q) {
                                        wI[o[8809]](A, I, g, C, B, 1, 0, Q);
                                    }
                                    function TA(A) {
                                        return A ? 31 - e(A - 1 ^ A) | 0 : 32;
                                    }
                                    function OA(A, I, g, C) {
                                        wI[o[8813]](A, I, 40, 0, g, 0, C);
                                    }
                                    function VA(A, I) {
                                        return 0 | II(A |= 0, I |= 0);
                                    }
                                    function ZA(A, I, g, C) {
                                        wI[o[8811]](A, I, 0, g, C);
                                    }
                                    function WA(A, I, g) {
                                        wI[o[8810]](A, 64, 0, I, g);
                                    }
                                    function $A(A, I, g, C) {
                                        wI[o[8804]](A, I, g, C);
                                    }
                                    function AI(A, I, g, C) {
                                        return R(A, I, g, C), 0;
                                    }
                                    function II(A, I) {
                                        return 0 | wI[o[8807]](A, I);
                                    }
                                    function gI(A, I, g) {
                                        return z(A, I, g), 0;
                                    }
                                    function CI(A, I) {
                                        wI[o[8803]](A, I);
                                    }
                                    function BI(A, I) {
                                        wI[o[8805]](A, I);
                                    }
                                    function QI(A) {
                                        HA(A |= 0, 32);
                                    }
                                    function iI(A, I) {
                                        dA(A, 0, I);
                                    }
                                    function EI() {
                                        return 208;
                                    }
                                    function oI() {
                                        return 16;
                                    }
                                    function aI() {
                                        return 32;
                                    }
                                    function fI() {
                                        return 24;
                                    }
                                    function cI() {
                                        return -17;
                                    }
                                    function eI() {
                                        return 64;
                                    }
                                    function rI() {
                                        return 1;
                                    }
                                    function DI() {
                                        return 8;
                                    }
                                    function tI() {
                                        return 0;
                                    }
                                    B(I = a, 1024, "TGlic29kaXVtRFJHcmFuZG9tYnl0ZXMAYjY0X3BvcyA8PSBiNjRfbGVuAGNyeXB0b19nZW5lcmljaGFzaF9ibGFrZTJiX2ZpbmFsAHJhbmRvbWJ5dGVzL3JhbmRvbWJ5dGVzLmMAc29kaXVtL2NvZGVjcy5jAGNyeXB0b19nZW5lcmljaGFzaC9ibGFrZTJiL3JlZi9ibGFrZTJiLXJlZi5jAGNyeXB0b19nZW5lcmljaGFzaC9ibGFrZTJiL3JlZi9nZW5lcmljaGFzaF9ibGFrZTJiLmMAYnVmX2xlbiA8PSBTSVpFX01BWABvdXRsZW4gPD0gVUlOVDhfTUFYAFMtPmJ1ZmxlbiA8PSBCTEFLRTJCX0JMT0NLQllURVMAMS4wLjE5AHNvZGl1bV9iaW4yYmFzZTY0AAAAAAAAAAC2eFn/hXLTAL1uFf8PCmoAKcABAJjoef+8PKD/mXHO/wC34v60DUj/AAAAAAAAAACwoA7+08mG/54YjwB/aTUAYAy9AKfX+/+fTID+amXh/x78BACSDK4="), B(I, 1440, "WfGy/grlpv973Sr+HhTUAFKAAwAw0fMAd3lA/zLjnP8AbsUBZxuQ"), B(I, 1488, "hTuMAb3xJP/4JcMBYNw3ALdMPv/DQj0AMkykAeGkTP9MPaP/dT4fAFGRQP92QQ4AonPW/waKLgB85vT/CoqPADQawgC49EwAgY8pAb70E/97qnr/YoFEAHnVkwBWZR7/oWebAIxZQ//v5b4BQwu1AMbwif7uRbz/Q5fuABMqbP/lVXEBMkSH/xFqCQAyZwH/UAGoASOYHv8QqLkBOFno/2XS/AAp+kcAzKpP/w4u7/9QTe8AvdZL/xGN+QAmUEz/vlV1AFbkqgCc2NABw8+k/5ZCTP+v4RD/jVBiAUzb8gDGonIALtqYAJsr8f6boGj/M7ulAAIRrwBCVKAB9zoeACNBNf5F7L8ALYb1AaN73QAgbhT/NBelALrWRwDpsGAA8u82ATlZigBTAFT/iKBkAFyOeP5ofL4AtbE+//opVQCYgioBYPz2AJeXP/7vhT4AIDicAC2nvf+OhbMBg1bTALuzlv76qg7/0qNOACU0lwBjTRoA7pzV/9XA0QFJLlQAFEEpATbOTwDJg5L+qm8Y/7EhMv6rJsv/Tvd0ANHdmQCFgLIBOiwZAMknOwG9E/wAMeXSAXW7dQC1s7gBAHLbADBekwD1KTgAfQ3M/vStdwAs3SD+VOoUAPmgxgHsfur/L2Oo/qrimf9ms9gA4o16/3pCmf629YYA4+QZAdY56//YrTj/tefSAHeAnf+BX4j/bn4zAAKpt/8HgmL+RbBe/3QE4wHZ8pH/yq0fAWkBJ/8ur0UA5C86/9fgRf7POEX/EP6L/xfP1P/KFH7/X9Vg/wmwIQDIBc//8SqA/iMhwP/45cQBgRF4APtnl/8HNHD/jDhC/yji9f/ZRiX+rNYJ/0hDhgGSwNb/LCZwAES4S//OWvsAleuNALWqOgB09O8AXJ0CAGatYgDpiWABfzHLAAWblAAXlAn/03oMACKGGv/bzIgAhggp/+BTK/5VGfcAbX8A/qmIMADud9v/563VAM4S/v4Iugf/fgkHAW8qSABvNOz+YD+NAJO/f/7NTsD/DmrtAbvbTACv87v+aVmtAFUZWQGi85QAAnbR/iGeCQCLoy7/XUYoAGwqjv5v/I7/m9+QADPlp/9J/Jv/XnQM/5ig2v+c7iX/s+rP/8UAs/+apI0A4cRoAAojGf7R1PL/Yf3e/rhl5QDeEn8BpIiH/x7PjP6SYfMAgcAa/slUIf9vCk7/k1Gy/wQEGACh7tf/Bo0hADXXDv8ptdD/54udALPL3f//uXEAveKs/3FC1v/KPi3/ZkAI/06uEP6FdUT/"), B(I, 2480, "AQ=="), B(I, 2512, "JuiVj8KyJ7BFw/SJ8u+Y8NXfrAXTxjM5sTgCiG1T/AXHF2pwPU3YT7o8C3YNEGcPKiBT+iw5zMZOx/13kqwDeuz///////////////////////////////////////9/7f///////////////////////////////////////3/u////////////////////////////////////////f+3T9VwaYxJY1pz3ot753hQ="), B(I, 2703, "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"), B(I, 33676, "AQ=="), B(I, 33712, "AQ=="), B(I, 33744, "4Ot6fDtBuK4WVuP68Z/EatoJjeucMrH9hmIFFl9JuABfnJW8o1CMJLHQsVWcg+9bBERcxFgcjobYIk7d0J8RV+z///////////////////////////////////////9/7f///////////////////////////////////////3/u////////////////////////////////////////fw=="), B(I, 33936, "Z+YJaoWuZ7ty8248OvVPpX9SDlGMaAWbq9mDHxnN4FuYL4pCkUQ3cc/7wLWl27XpW8JWOfER8Vmkgj+S1V4cq5iqB9gBW4MSvoUxJMN9DFV0Xb5y/rHegKcG3Jt08ZvBwWmb5IZHvu/GncEPzKEMJG8s6S2qhHRK3KmwXNqI+XZSUT6YbcYxqMgnA7DHf1m/8wvgxkeRp9VRY8oGZykpFIUKtyc4IRsu/G0sTRMNOFNUcwpluwpqdi7JwoGFLHKSoei/oktmGqhwi0vCo1FsxxnoktEkBpnWhTUO9HCgahAWwaQZCGw3Hkx3SCe1vLA0swwcOUqq2E5Pypxb828uaO6Cj3RvY6V4FHjIhAgCx4z6/76Q62xQpPej+b7yeHHGgA=="), B(I, 34304, "CMm882fmCWo7p8qEha5nuyv4lP5y82488TYdXzr1T6XRguatf1IOUR9sPiuMaAWba71B+6vZgx95IX4TGc3gWyKuKNeYL4pCzWXvI5FEN3EvO03sz/vAtbzbiYGl27XpOLVI81vCVjkZ0AW28RHxWZtPGa+kgj+SGIFt2tVeHKtCAgOjmKoH2L5vcEUBW4MSjLLkTr6FMSTitP/Vw30MVW+Je/J0Xb5ysZYWO/6x3oA1Esclpwbcm5Qmac908ZvB0krxnsFpm+TjJU84hke+77XVjIvGncEPZZysd8yhDCR1AitZbyzpLYPkpm6qhHRK1PtBvdypsFy1UxGD2oj5dqvfZu5SUT6YEDK0LW3GMag/IfuYyCcDsOQO777Hf1m/wo+oPfML4MYlpwqTR5Gn1W+CA+BRY8oGcG4OCmcpKRT8L9JGhQq3JybJJlw4IRsu7SrEWvxtLE3fs5WdEw04U95jr4tUcwplqLJ3PLsKanbmru1HLsnCgTs1ghSFLHKSZAPxTKHov6IBMEK8S2YaqJGX+NBwi0vCML5UBqNRbMcYUu/WGeiS0RCpZVUkBpnWKiBxV4U1DvS40bsycKBqEMjQ0rgWwaQZU6tBUQhsNx6Z647fTHdIJ6hIm+G1vLA0Y1rJxbMMHDnLikHjSqrYTnPjY3dPypxbo7iy1vNvLmj8su9d7oKPdGAvF0NvY6V4cqvwoRR4yITsOWQaCALHjCgeYyP6/76Q6b2C3utsUKQVecay96P5vitTcuPyeHHGnGEm6s4+J8oHwsAhx7iG0R7r4M3WfdrqeNFu7n9PffW6bxdyqmfwBqaYyKLFfWMKrg35vgSYPxEbRxwTNQtxG4R9BCP1d9sokyTHQHuryjK8vskVCr6ePEwNEJzEZx1DtkI+y77UxUwqfmX8nCl/Wez61jqrb8tfF1hHSowZRGyA"), B(I, 35136, "U2lnRWQyNTUxOSBubyBFZDI1NTE5IGNvbGxpc2lvbnMB"), B(I, 35200, "0I4BAAEAAAACAAAAAwAAAAQAAAAFAAAABgAAAAcAAAAIAAAACQAAAAoAAAALAAAADAAAAA0=");
                                    var yI, wI = (yI = [
                                        null,
                                        function(A, I, g, C, B) {
                                            var Q, i, f;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, w = Q = (i = w) - 128 & -64, o[Q >> 2] = 67108863 & (a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24), o[Q + 4 >> 2] = (a[B + 3 | 0] | a[B + 4 | 0] << 8 | a[B + 5 | 0] << 16 | a[B + 6 | 0] << 24) >>> 2 & 67108611, o[Q + 8 >> 2] = (a[B + 6 | 0] | a[B + 7 | 0] << 8 | a[B + 8 | 0] << 16 | a[B + 9 | 0] << 24) >>> 4 & 67092735, o[Q + 12 >> 2] = (a[B + 9 | 0] | a[B + 10 | 0] << 8 | a[B + 11 | 0] << 16 | a[B + 12 | 0] << 24) >>> 6 & 66076671, f = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, o[Q + 20 >> 2] = 0, o[Q + 24 >> 2] = 0, o[Q + 28 >> 2] = 0, o[Q + 32 >> 2] = 0, o[Q + 36 >> 2] = 0, o[Q + 16 >> 2] = f >>> 8 & 1048575, o[Q + 40 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, o[Q + 44 >> 2] = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, o[Q + 48 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, B = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, E[Q + 80 | 0] = 0, o[Q + 56 >> 2] = 0, o[Q + 60 >> 2] = 0, o[Q + 52 >> 2] = B, j(Q, I, g, C), $(Q, A), w = i, 0;
                                        },
                                        function(A, I, g, C, B) {
                                            var Q, i, f;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, w = Q = (i = w) - 192 & -64, o[Q + 64 >> 2] = 67108863 & (a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24), o[Q + 68 >> 2] = (a[B + 3 | 0] | a[B + 4 | 0] << 8 | a[B + 5 | 0] << 16 | a[B + 6 | 0] << 24) >>> 2 & 67108611, o[Q + 72 >> 2] = (a[B + 6 | 0] | a[B + 7 | 0] << 8 | a[B + 8 | 0] << 16 | a[B + 9 | 0] << 24) >>> 4 & 67092735, o[Q + 76 >> 2] = (a[B + 9 | 0] | a[B + 10 | 0] << 8 | a[B + 11 | 0] << 16 | a[B + 12 | 0] << 24) >>> 6 & 66076671, f = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, o[Q + 84 >> 2] = 0, o[Q + 88 >> 2] = 0, o[Q + 92 >> 2] = 0, o[Q + 96 >> 2] = 0, o[Q + 100 >> 2] = 0, o[Q + 80 >> 2] = f >>> 8 & 1048575, o[Q + 104 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, o[Q + 108 >> 2] = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, o[Q + 112 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, B = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, E[Q + 144 | 0] = 0, o[Q + 120 >> 2] = 0, o[Q + 124 >> 2] = 0, o[Q + 116 >> 2] = B, j(B = Q - -64 | 0, I, g, C), $(B, I = Q + 48 | 0), A = CA(A, I), w = i, 0 | A;
                                        },
                                        function(A, I) {
                                            var g;
                                            return I |= 0, o[(A |= 0) >> 2] = 67108863 & (a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24), o[A + 4 >> 2] = (a[I + 3 | 0] | a[I + 4 | 0] << 8 | a[I + 5 | 0] << 16 | a[I + 6 | 0] << 24) >>> 2 & 67108611, o[A + 8 >> 2] = (a[I + 6 | 0] | a[I + 7 | 0] << 8 | a[I + 8 | 0] << 16 | a[I + 9 | 0] << 24) >>> 4 & 67092735, o[A + 12 >> 2] = (a[I + 9 | 0] | a[I + 10 | 0] << 8 | a[I + 11 | 0] << 16 | a[I + 12 | 0] << 24) >>> 6 & 66076671, g = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, o[A + 20 >> 2] = 0, o[A + 24 >> 2] = 0, o[A + 28 >> 2] = 0, o[A + 32 >> 2] = 0, o[A + 36 >> 2] = 0, o[A + 16 >> 2] = g >>> 8 & 1048575, o[A + 40 >> 2] = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, o[A + 44 >> 2] = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, o[A + 48 >> 2] = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, I = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, E[A + 80 | 0] = 0, o[A + 56 >> 2] = 0, o[A + 60 >> 2] = 0, o[A + 52 >> 2] = I, 0;
                                        },
                                        function(A, I, g, C) {
                                            return j(A |= 0, I |= 0, g |= 0, C |= 0), 0;
                                        },
                                        function(A, I) {
                                            return $(A |= 0, I |= 0), 0;
                                        },
                                        function(A, I, g) {
                                            A |= 0, I |= 0, g |= 0;
                                            var C, B = 0, Q = 0, i = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, n = 0, s = 0, k = 0, F = 0, S = 0, G = 0, _ = 0, p = 0, N = 0, J = 0, U = 0, Y = 0, d = 0, K = 0, b = 0, P = 0, v = 0, R = 0, u = 0, x = 0, m = 0, l = 0, z = 0, q = 0, X = 0, j = 0, T = 0, V = 0, Z = 0, W = 0, $ = 0, AA = 0, gA = 0, CA = 0, BA = 0, QA = 0, iA = 0, EA = 0, oA = 0, aA = 0, fA = 0, cA = 0, eA = 0, rA = 0, DA = 0, tA = 0, yA = 0, wA = 0, hA = 0, nA = 0, sA = 0, FA = 0, SA = 0, HA = 0, GA = 0, _A = 0;
                                            for(w = C = w - 368 | 0; n = (i = a[g + B | 0]) ^ a[0 | (c = B + 33680 | 0)] | n, y = i ^ a[c + 192 | 0] | y, t = i ^ a[c + 160 | 0] | t, D = i ^ a[c + 128 | 0] | D, f = i ^ a[c + 96 | 0] | f, e = i ^ a[c - -64 | 0] | e, Q = i ^ a[c + 32 | 0] | Q, 31 != (0 | (B = B + 1 | 0)););
                                            if (B = -1, !(256 & ((255 & ((i = 127 ^ (c = 127 & a[g + 31 | 0])) | y)) - 1 | (255 & (i | t)) - 1 | (255 & (i | D)) - 1 | (255 & (87 ^ c | f)) - 1 | (255 & (e | c)) - 1 | (255 & (Q | c)) - 1 | (255 & (c | n)) - 1))) {
                                                for(B = I, I = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, o[C + 360 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, o[C + 364 >> 2] = I, I = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, o[C + 352 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, o[C + 356 >> 2] = I, Q = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, I = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, o[C + 336 >> 2] = I, o[C + 340 >> 2] = Q, Q = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, o[C + 344 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, o[C + 348 >> 2] = Q, E[C + 336 | 0] = 248 & I, E[C + 367 | 0] = 63 & a[C + 367 | 0] | 64, L(C + 288 | 0, g), o[C + 260 >> 2] = 0, o[C + 264 >> 2] = 0, o[C + 268 >> 2] = 0, o[C + 272 >> 2] = 0, o[C + 276 >> 2] = 0, o[C + 208 >> 2] = 0, o[C + 212 >> 2] = 0, o[C + 216 >> 2] = 0, o[C + 220 >> 2] = 0, o[C + 224 >> 2] = 0, o[C + 228 >> 2] = 0, I = o[C + 308 >> 2], o[C + 160 >> 2] = o[C + 304 >> 2], o[C + 164 >> 2] = I, I = o[C + 316 >> 2], o[C + 168 >> 2] = o[C + 312 >> 2], o[C + 172 >> 2] = I, I = o[C + 324 >> 2], o[C + 176 >> 2] = o[C + 320 >> 2], o[C + 180 >> 2] = I, o[C + 244 >> 2] = 0, o[C + 248 >> 2] = 0, o[C + 240 >> 2] = 1, o[C + 252 >> 2] = 0, o[C + 256 >> 2] = 0, o[C + 192 >> 2] = 0, o[C + 196 >> 2] = 0, o[C + 200 >> 2] = 0, o[C + 204 >> 2] = 0, I = o[C + 292 >> 2], o[C + 144 >> 2] = o[C + 288 >> 2], o[C + 148 >> 2] = I, I = o[C + 300 >> 2], o[C + 152 >> 2] = o[C + 296 >> 2], o[C + 156 >> 2] = I, o[C + 116 >> 2] = 0, o[C + 120 >> 2] = 0, o[C + 124 >> 2] = 0, o[C + 128 >> 2] = 0, o[C + 132 >> 2] = 0, o[C + 100 >> 2] = 0, o[C + 104 >> 2] = 0, o[C + 96 >> 2] = 1, o[C + 108 >> 2] = 0, o[C + 112 >> 2] = 0, g = 254; $ = o[C + 276 >> 2], i = o[C + 180 >> 2], AA = o[C + 96 >> 2], gA = o[C + 192 >> 2], CA = o[C + 144 >> 2], BA = o[C + 240 >> 2], QA = o[C + 100 >> 2], iA = o[C + 196 >> 2], EA = o[C + 148 >> 2], oA = o[C + 244 >> 2], Y = o[C + 104 >> 2], aA = o[C + 200 >> 2], d = o[C + 152 >> 2], fA = o[C + 248 >> 2], P = o[C + 108 >> 2], cA = o[C + 204 >> 2], v = o[C + 156 >> 2], eA = o[C + 252 >> 2], K = o[C + 112 >> 2], rA = o[C + 208 >> 2], J = o[C + 160 >> 2], DA = o[C + 256 >> 2], n = o[C + 116 >> 2], tA = o[C + 212 >> 2], r = o[C + 164 >> 2], yA = o[C + 260 >> 2], y = o[C + 120 >> 2], wA = o[C + 216 >> 2], t = o[C + 168 >> 2], hA = o[C + 264 >> 2], D = o[C + 124 >> 2], nA = o[C + 220 >> 2], f = o[C + 172 >> 2], sA = o[C + 268 >> 2], e = o[C + 128 >> 2], FA = o[C + 224 >> 2], Q = o[C + 176 >> 2], N = o[C + 272 >> 2], SA = g, U = (G = (I = 0 - ((I = W) ^ (W = a[(HA = C + 336 | 0) + (g >>> 3 | 0) | 0] >>> (7 & g) & 1)) | 0) & ((B = o[C + 132 >> 2]) ^ (j = o[C + 228 >> 2]))) ^ B, o[C + 132 >> 2] = U, T = i ^ (_ = I & (i ^ $)), o[C + 84 >> 2] = T - U, b = e ^ (k = I & (e ^ FA)), o[C + 128 >> 2] = b, V = (p = I & (Q ^ N)) ^ Q, o[C + 80 >> 2] = V - b, u = D ^ (F = I & (D ^ nA)), o[C + 124 >> 2] = u, GA = f ^ (S = I & (f ^ sA)), o[C + 76 >> 2] = GA - u, x = y ^ (s = I & (y ^ wA)), o[C + 120 >> 2] = x, _A = t ^ (c = I & (t ^ hA)), o[C + 72 >> 2] = _A - x, m = n ^ (i = I & (n ^ tA)), o[C + 116 >> 2] = m, l = r ^ (n = I & (r ^ yA)), o[C + 68 >> 2] = l - m, z = K ^ (y = I & (K ^ rA)), o[C + 112 >> 2] = z, R = J ^ (t = I & (J ^ DA)), o[C + 64 >> 2] = R - z, q = P ^ (D = I & (P ^ cA)), o[C + 108 >> 2] = q, Z = v ^ (f = I & (v ^ eA)), o[C + 60 >> 2] = Z - q, X = Y ^ (e = I & (Y ^ aA)), o[C + 104 >> 2] = X, P = d ^ (Q = I & (d ^ fA)), o[C + 56 >> 2] = P - X, Y = QA ^ (B = I & (QA ^ iA)), o[C + 100 >> 2] = Y, v = EA ^ (g = I & (EA ^ oA)), o[C + 52 >> 2] = v - Y, d = AA ^ (K = I & (AA ^ gA)), o[C + 96 >> 2] = d, J = (I &= CA ^ BA) ^ CA, o[C + 48 >> 2] = J - d, r = _ ^ $, G ^= j, o[C + 36 >> 2] = r - G, _ = p ^ N, k ^= FA, o[C + 32 >> 2] = _ - k, p = S ^ sA, F ^= nA, o[C + 28 >> 2] = p - F, S = c ^ hA, s ^= wA, o[C + 24 >> 2] = S - s, c = n ^ yA, i ^= tA, o[C + 20 >> 2] = c - i, n = t ^ DA, y ^= rA, o[C + 16 >> 2] = n - y, t = f ^ eA, D ^= cA, o[C + 12 >> 2] = t - D, f = Q ^ fA, e ^= aA, o[C + 8 >> 2] = f - e, Q = g ^ oA, B ^= iA, o[C + 4 >> 2] = Q - B, g = I ^ BA, I = K ^ gA, o[C >> 2] = g - I, o[C + 276 >> 2] = r + G, o[C + 272 >> 2] = _ + k, o[C + 268 >> 2] = F + p, o[C + 264 >> 2] = s + S, o[C + 260 >> 2] = i + c, o[C + 256 >> 2] = y + n, o[C + 248 >> 2] = f + e, o[C + 244 >> 2] = B + Q, o[C + 240 >> 2] = I + g, o[C + 252 >> 2] = D + t, o[C + 228 >> 2] = U + T, o[C + 224 >> 2] = b + V, o[C + 220 >> 2] = u + GA, o[C + 216 >> 2] = x + _A, o[C + 212 >> 2] = m + l, o[C + 208 >> 2] = R + z, o[C + 204 >> 2] = q + Z, o[C + 200 >> 2] = P + X, o[C + 196 >> 2] = Y + v, o[C + 192 >> 2] = J + d, H(T = C + 96 | 0, b = C + 48 | 0, U = C + 240 | 0), H(N = C + 192 | 0, N, C), M(b, C), M(C, U), r = o[C + 192 >> 2], G = o[C + 96 >> 2], _ = o[C + 196 >> 2], k = o[C + 100 >> 2], p = o[C + 200 >> 2], F = o[C + 104 >> 2], S = o[C + 204 >> 2], s = o[C + 108 >> 2], c = o[C + 208 >> 2], i = o[C + 112 >> 2], n = o[C + 212 >> 2], y = o[C + 116 >> 2], t = o[C + 216 >> 2], D = o[C + 120 >> 2], f = o[C + 220 >> 2], e = o[C + 124 >> 2], Q = o[C + 224 >> 2], B = o[C + 128 >> 2], g = o[C + 228 >> 2], I = o[C + 132 >> 2], o[C + 180 >> 2] = g + I, o[C + 176 >> 2] = B + Q, o[C + 172 >> 2] = f + e, o[C + 168 >> 2] = D + t, o[C + 164 >> 2] = y + n, o[C + 160 >> 2] = i + c, o[C + 156 >> 2] = s + S, o[C + 152 >> 2] = F + p, o[C + 148 >> 2] = _ + k, o[C + 144 >> 2] = r + G, o[C + 228 >> 2] = I - g, o[C + 224 >> 2] = B - Q, o[C + 220 >> 2] = e - f, o[C + 216 >> 2] = D - t, o[C + 212 >> 2] = y - n, o[C + 208 >> 2] = i - c, o[C + 204 >> 2] = s - S, o[C + 200 >> 2] = F - p, o[C + 196 >> 2] = k - _, o[C + 192 >> 2] = G - r, H(U, C, b), u = o[C + 52 >> 2], s = o[C + 4 >> 2], x = o[C + 56 >> 2], c = o[C + 8 >> 2], m = o[C + 64 >> 2], t = o[C + 16 >> 2], z = o[C + 60 >> 2], D = o[C + 12 >> 2], q = o[C + 72 >> 2], f = o[C + 24 >> 2], X = o[C + 68 >> 2], e = o[C + 20 >> 2], Y = o[C + 80 >> 2], Q = o[C + 32 >> 2], d = o[C + 76 >> 2], B = o[C + 28 >> 2], j = o[C + 84 >> 2], I = o[C + 36 >> 2], V = o[C + 48 >> 2], g = o[C >> 2] - V | 0, o[C >> 2] = g, I = I - j | 0, o[C + 36 >> 2] = I, K = B - d | 0, o[C + 28 >> 2] = K, J = Q - Y | 0, o[C + 32 >> 2] = J, i = e - X | 0, o[C + 20 >> 2] = i, n = f - q | 0, o[C + 24 >> 2] = n, y = D - z | 0, o[C + 12 >> 2] = y, t = t - m | 0, o[C + 16 >> 2] = t, D = c - x | 0, o[C + 8 >> 2] = D, Q = s - u | 0, o[C + 4 >> 2] = Q, M(N, N), I = kA(I, I >> 31, 121666, 0), B = h, Z = I, I = kA((33554431 & (B = (r = I + 16777216 | 0) >>> 0 < 16777216 ? B + 1 | 0 : B)) << 7 | r >>> 25, B >> 25, 19, 0), e = h, B = I, I = kA(g, g >> 31, 121666, 0), R = h + e | 0, I = I >>> 0 > (B = B + I | 0) >>> 0 ? R + 1 | 0 : R, g = (f = B + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, G = B - (-67108864 & f) | 0, o[C + 96 >> 2] = G, e = kA(Q, Q >> 31, 121666, 0), B = h, B = (Q = e + 16777216 | 0) >>> 0 < 16777216 ? B + 1 | 0 : B, _ = (e - (-33554432 & Q) | 0) + ((67108863 & g) << 6 | f >>> 26) | 0, o[C + 100 >> 2] = _, R = (I = B) >> 25, B = (33554431 & I) << 7 | Q >>> 25, g = kA(D, D >> 31, 121666, 0) + B | 0, I = R + h | 0, I = g >>> 0 < B >>> 0 ? I + 1 | 0 : I, e = (k = g + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, p = g - (-67108864 & k) | 0, o[C + 104 >> 2] = p, B = kA(t, t >> 31, 121666, 0), Q = h, g = kA(y, y >> 31, 121666, 0), I = h, l = B, P = g, B = (33554431 & (I = (F = g + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I)) << 7 | F >>> 25, I = (I >> 25) + Q | 0, I = (g = l + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, Q = (S = g + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, s = g - (-67108864 & S) | 0, o[C + 112 >> 2] = s, B = kA(n, n >> 31, 121666, 0), f = h, g = kA(i, i >> 31, 121666, 0), I = h, l = B, v = g, B = (33554431 & (I = (c = g + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I)) << 7 | c >>> 25, I = (I >> 25) + f | 0, I = (g = l + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (i = g + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, n = g - (-67108864 & i) | 0, o[C + 120 >> 2] = n, f = kA(J, J >> 31, 121666, 0), D = h, g = kA(K, K >> 31, 121666, 0), I = h, J = g, g = (33554431 & (I = (y = g + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I)) << 7 | y >>> 25, I = (I >> 25) + D | 0, I = g >>> 0 > (f = g + f | 0) >>> 0 ? I + 1 | 0 : I, g = (t = f + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, D = f - (-67108864 & t) | 0, o[C + 128 >> 2] = D, f = (e = P + ((67108863 & e) << 6 | k >>> 26) | 0) - (-33554432 & F) | 0, o[C + 108 >> 2] = f, e = (Q = v + ((67108863 & Q) << 6 | S >>> 26) | 0) - (-33554432 & c) | 0, o[C + 116 >> 2] = e, Q = (I = J + ((67108863 & B) << 6 | i >>> 26) | 0) - (-33554432 & y) | 0, o[C + 124 >> 2] = Q, g = (g = Z + ((67108863 & g) << 6 | t >>> 26) | 0) - (-33554432 & r) | 0, o[C + 132 >> 2] = g, M(I = C + 144 | 0, I), o[C + 84 >> 2] = g + j, o[C + 80 >> 2] = D + Y, o[C + 76 >> 2] = Q + d, o[C + 72 >> 2] = n + q, o[C + 68 >> 2] = e + X, o[C + 64 >> 2] = s + m, o[C + 60 >> 2] = f + z, o[C + 56 >> 2] = p + x, o[C + 52 >> 2] = _ + u, o[C + 48 >> 2] = G + V, g = SA - 1 | 0, H(T, C + 288 | 0, N), H(N, C, b), SA;);
                                                n = o[C + 144 >> 2], G = o[C + 240 >> 2], y = o[C + 148 >> 2], _ = o[C + 244 >> 2], t = o[C + 152 >> 2], k = o[C + 248 >> 2], D = o[C + 156 >> 2], p = o[C + 252 >> 2], f = o[C + 160 >> 2], F = o[C + 256 >> 2], e = o[C + 164 >> 2], S = o[C + 260 >> 2], Q = o[C + 168 >> 2], s = o[C + 264 >> 2], B = o[C + 172 >> 2], c = o[C + 268 >> 2], g = o[C + 176 >> 2], i = o[C + 272 >> 2], r = 0 - W | 0, I = o[C + 276 >> 2], o[C + 276 >> 2] = r & (I ^ o[C + 180 >> 2]) ^ I, o[C + 272 >> 2] = i ^ r & (g ^ i), o[C + 268 >> 2] = c ^ r & (B ^ c), o[C + 264 >> 2] = s ^ r & (Q ^ s), o[C + 260 >> 2] = S ^ r & (e ^ S), o[C + 256 >> 2] = F ^ r & (f ^ F), o[C + 252 >> 2] = p ^ r & (D ^ p), o[C + 248 >> 2] = k ^ r & (t ^ k), o[C + 244 >> 2] = _ ^ r & (y ^ _), o[C + 240 >> 2] = G ^ r & (n ^ G), G = o[C + 192 >> 2], n = o[C + 96 >> 2], _ = o[C + 196 >> 2], y = o[C + 100 >> 2], k = o[C + 200 >> 2], t = o[C + 104 >> 2], p = o[C + 204 >> 2], D = o[C + 108 >> 2], F = o[C + 208 >> 2], f = o[C + 112 >> 2], S = o[C + 212 >> 2], e = o[C + 116 >> 2], s = o[C + 216 >> 2], Q = o[C + 120 >> 2], c = o[C + 220 >> 2], B = o[C + 124 >> 2], i = o[C + 224 >> 2], g = o[C + 128 >> 2], I = o[C + 228 >> 2], o[C + 228 >> 2] = r & (I ^ o[C + 132 >> 2]) ^ I, o[C + 224 >> 2] = i ^ r & (g ^ i), o[C + 220 >> 2] = c ^ r & (B ^ c), o[C + 216 >> 2] = s ^ r & (Q ^ s), o[C + 212 >> 2] = S ^ r & (e ^ S), o[C + 208 >> 2] = F ^ r & (f ^ F), o[C + 204 >> 2] = p ^ r & (D ^ p), o[C + 200 >> 2] = k ^ r & (t ^ k), o[C + 196 >> 2] = _ ^ r & (y ^ _), o[C + 192 >> 2] = G ^ r & (n ^ G), O(N, N), H(U, U, N), IA(A, U), iI(HA, 32), B = 0;
                                            }
                                            return w = C + 368 | 0, 0 | B;
                                        },
                                        function(A, I) {
                                            var g, C, B, Q, i, f, c, e, r, D, t, y, h, n, s, k, F, S, G, _;
                                            return I |= 0, w = g = w - 304 | 0, E[0 | (A |= 0)] = a[0 | I], E[A + 1 | 0] = a[I + 1 | 0], E[A + 2 | 0] = a[I + 2 | 0], E[A + 3 | 0] = a[I + 3 | 0], E[A + 4 | 0] = a[I + 4 | 0], E[A + 5 | 0] = a[I + 5 | 0], E[A + 6 | 0] = a[I + 6 | 0], E[A + 7 | 0] = a[I + 7 | 0], E[A + 8 | 0] = a[I + 8 | 0], E[A + 9 | 0] = a[I + 9 | 0], E[A + 10 | 0] = a[I + 10 | 0], E[A + 11 | 0] = a[I + 11 | 0], E[A + 12 | 0] = a[I + 12 | 0], E[A + 13 | 0] = a[I + 13 | 0], E[A + 14 | 0] = a[I + 14 | 0], E[A + 15 | 0] = a[I + 15 | 0], E[A + 16 | 0] = a[I + 16 | 0], E[A + 17 | 0] = a[I + 17 | 0], E[A + 18 | 0] = a[I + 18 | 0], E[A + 19 | 0] = a[I + 19 | 0], E[A + 20 | 0] = a[I + 20 | 0], E[A + 21 | 0] = a[I + 21 | 0], E[A + 22 | 0] = a[I + 22 | 0], E[A + 23 | 0] = a[I + 23 | 0], E[A + 24 | 0] = a[I + 24 | 0], E[A + 25 | 0] = a[I + 25 | 0], E[A + 26 | 0] = a[I + 26 | 0], E[A + 27 | 0] = a[I + 27 | 0], E[A + 28 | 0] = a[I + 28 | 0], E[A + 29 | 0] = a[I + 29 | 0], E[A + 30 | 0] = a[I + 30 | 0], I = a[I + 31 | 0], E[0 | A] = 248 & a[0 | A], E[A + 31 | 0] = 63 & I | 64, u(g + 48 | 0, A), I = o[g + 132 >> 2], C = o[g + 92 >> 2], B = o[g + 136 >> 2], Q = o[g + 96 >> 2], i = o[g + 140 >> 2], f = o[g + 100 >> 2], c = o[g + 144 >> 2], e = o[g + 104 >> 2], r = o[g + 148 >> 2], D = o[g + 108 >> 2], t = o[g + 152 >> 2], y = o[g + 112 >> 2], h = o[g + 156 >> 2], n = o[g + 116 >> 2], s = o[g + 160 >> 2], k = o[g + 120 >> 2], F = o[g + 128 >> 2], S = o[g + 88 >> 2], G = o[g + 124 >> 2], _ = o[g + 164 >> 2], o[g + 292 >> 2] = G + _, o[g + 288 >> 2] = s + k, o[g + 284 >> 2] = h + n, o[g + 280 >> 2] = t + y, o[g + 276 >> 2] = r + D, o[g + 272 >> 2] = c + e, o[g + 268 >> 2] = i + f, o[g + 264 >> 2] = B + Q, o[g + 260 >> 2] = I + C, o[g + 256 >> 2] = F + S, o[g + 244 >> 2] = _ - G, o[g + 240 >> 2] = s - k, o[g + 236 >> 2] = h - n, o[g + 232 >> 2] = t - y, o[g + 228 >> 2] = r - D, o[g + 224 >> 2] = c - e, o[g + 220 >> 2] = i - f, o[g + 216 >> 2] = B - Q, o[g + 212 >> 2] = I - C, o[g + 208 >> 2] = F - S, O(I = g + 208 | 0, I), H(g, g + 256 | 0, I), IA(A, g), w = g + 304 | 0, 0;
                                        },
                                        function(A, I, g, C, B) {
                                            A |= 0, C |= 0, B |= 0;
                                            var Q, i = 0, f = 0, c = 0, e = 0;
                                            if (w = Q = w - 112 | 0, (I |= 0) | (g |= 0)) {
                                                i = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, o[Q + 24 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, o[Q + 28 >> 2] = i, i = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, o[Q + 16 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, o[Q + 20 >> 2] = i, i = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, o[Q >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, o[Q + 4 >> 2] = i, i = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, o[Q + 8 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, o[Q + 12 >> 2] = i, B = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, C = a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24, o[Q + 104 >> 2] = 0, o[Q + 108 >> 2] = 0, o[Q + 96 >> 2] = B, o[Q + 100 >> 2] = C;
                                                A: {
                                                    if (!g & I >>> 0 >= 64 | g) {
                                                        for(; Y(A, Q + 96 | 0, Q), C = a[Q + 104 | 0] + 1 | 0, E[Q + 104 | 0] = C, C = a[Q + 105 | 0] + (C >>> 8 | 0) | 0, E[Q + 105 | 0] = C, C = a[Q + 106 | 0] + (C >>> 8 | 0) | 0, E[Q + 106 | 0] = C, C = a[Q + 107 | 0] + (C >>> 8 | 0) | 0, E[Q + 107 | 0] = C, C = a[Q + 108 | 0] + (C >>> 8 | 0) | 0, E[Q + 108 | 0] = C, C = a[Q + 109 | 0] + (C >>> 8 | 0) | 0, E[Q + 109 | 0] = C, C = a[Q + 110 | 0] + (C >>> 8 | 0) | 0, E[Q + 110 | 0] = C, E[Q + 111 | 0] = a[Q + 111 | 0] + (C >>> 8 | 0), A = A - -64 | 0, g = g - 1 | 0, !(g = (I = I + -64 | 0) >>> 0 < 4294967232 ? g + 1 | 0 : g) & I >>> 0 > 63 | g;);
                                                        if (!(I | g)) break A;
                                                    }
                                                    if (C = 0, Y(Q + 32 | 0, Q + 96 | 0, Q), g = 3 & I, B = 0, I - 1 >>> 0 >= 3) for(i = -4 & I, I = 0; f = c = Q + 32 | 0, E[A + B | 0] = a[f + B | 0], E[(e = 1 | B) + A | 0] = a[f + e | 0], E[(f = 2 | B) + A | 0] = a[f + c | 0], E[(f = 3 | B) + A | 0] = a[f + (Q + 32 | 0) | 0], B = B + 4 | 0, (0 | i) != (0 | (I = I + 4 | 0)););
                                                    if (g) for(; E[A + B | 0] = a[(Q + 32 | 0) + B | 0], B = B + 1 | 0, (0 | g) != (0 | (C = C + 1 | 0)););
                                                }
                                                iI(Q + 32 | 0, 64), iI(Q, 32);
                                            }
                                            return w = Q + 112 | 0, 0;
                                        },
                                        function(A, I, g, C, B, Q, i, f) {
                                            A |= 0, I |= 0, B |= 0, Q |= 0, i |= 0, f |= 0;
                                            var c, e = 0;
                                            if (w = c = w - 112 | 0, (g |= 0) | (C |= 0)) {
                                                e = a[f + 28 | 0] | a[f + 29 | 0] << 8 | a[f + 30 | 0] << 16 | a[f + 31 | 0] << 24, o[c + 24 >> 2] = a[f + 24 | 0] | a[f + 25 | 0] << 8 | a[f + 26 | 0] << 16 | a[f + 27 | 0] << 24, o[c + 28 >> 2] = e, e = a[f + 20 | 0] | a[f + 21 | 0] << 8 | a[f + 22 | 0] << 16 | a[f + 23 | 0] << 24, o[c + 16 >> 2] = a[f + 16 | 0] | a[f + 17 | 0] << 8 | a[f + 18 | 0] << 16 | a[f + 19 | 0] << 24, o[c + 20 >> 2] = e, e = a[f + 4 | 0] | a[f + 5 | 0] << 8 | a[f + 6 | 0] << 16 | a[f + 7 | 0] << 24, o[c >> 2] = a[0 | f] | a[f + 1 | 0] << 8 | a[f + 2 | 0] << 16 | a[f + 3 | 0] << 24, o[c + 4 >> 2] = e, e = a[f + 12 | 0] | a[f + 13 | 0] << 8 | a[f + 14 | 0] << 16 | a[f + 15 | 0] << 24, o[c + 8 >> 2] = a[f + 8 | 0] | a[f + 9 | 0] << 8 | a[f + 10 | 0] << 16 | a[f + 11 | 0] << 24, o[c + 12 >> 2] = e, f = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, o[c + 96 >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, o[c + 100 >> 2] = f, E[c + 104 | 0] = Q, E[c + 111 | 0] = i >>> 24, E[c + 110 | 0] = i >>> 16, E[c + 109 | 0] = i >>> 8, E[c + 108 | 0] = i, E[c + 107 | 0] = (16777215 & i) << 8 | Q >>> 24, E[c + 106 | 0] = (65535 & i) << 16 | Q >>> 16, E[c + 105 | 0] = (255 & i) << 24 | Q >>> 8;
                                                A: {
                                                    if (!C & g >>> 0 >= 64 | C) {
                                                        for(;;){
                                                            for(f = 0, Y(c + 32 | 0, c + 96 | 0, c); Q = c + 32 | 0, E[A + f | 0] = a[Q + f | 0] ^ a[I + f | 0], E[(B = 1 | f) + A | 0] = a[B + Q | 0] ^ a[I + B | 0], 64 != (0 | (f = f + 2 | 0)););
                                                            if (B = a[c + 104 | 0] + 1 | 0, E[c + 104 | 0] = B, B = a[c + 105 | 0] + (B >>> 8 | 0) | 0, E[c + 105 | 0] = B, B = a[c + 106 | 0] + (B >>> 8 | 0) | 0, E[c + 106 | 0] = B, B = a[c + 107 | 0] + (B >>> 8 | 0) | 0, E[c + 107 | 0] = B, B = a[c + 108 | 0] + (B >>> 8 | 0) | 0, E[c + 108 | 0] = B, B = a[c + 109 | 0] + (B >>> 8 | 0) | 0, E[c + 109 | 0] = B, B = a[c + 110 | 0] + (B >>> 8 | 0) | 0, E[c + 110 | 0] = B, E[c + 111 | 0] = a[c + 111 | 0] + (B >>> 8 | 0), I = I - -64 | 0, A = A - -64 | 0, C = C - 1 | 0, !(!(C = (g = g + -64 | 0) >>> 0 < 4294967232 ? C + 1 | 0 : C) & g >>> 0 > 63 | C)) break;
                                                        }
                                                        if (!(g | C)) break A;
                                                    }
                                                    if (f = 0, Y(c + 32 | 0, c + 96 | 0, c), C = 1 & g, 1 != (0 | g)) for(Q = -2 & g, B = 0; i = c + 32 | 0, E[A + f | 0] = a[i + f | 0] ^ a[I + f | 0], E[(g = 1 | f) + A | 0] = a[g + i | 0] ^ a[I + g | 0], f = f + 2 | 0, (0 | Q) != (0 | (B = B + 2 | 0)););
                                                    C && (E[A + f | 0] = a[(c + 32 | 0) + f | 0] ^ a[I + f | 0]);
                                                }
                                                iI(c + 32 | 0, 64), iI(c, 32);
                                            }
                                            return w = c + 112 | 0, 0;
                                        },
                                        function(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, C |= 0, B |= 0, w = Q = w + -64 | 0, (I |= 0) | (g |= 0) && (o[Q + 8 >> 2] = 2036477234, o[Q + 12 >> 2] = 1797285236, o[Q >> 2] = 1634760805, o[Q + 4 >> 2] = 857760878, o[Q + 16 >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, o[Q + 20 >> 2] = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, o[Q + 24 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, o[Q + 28 >> 2] = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, o[Q + 32 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, o[Q + 36 >> 2] = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, o[Q + 40 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, B = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, o[Q + 48 >> 2] = 0, o[Q + 52 >> 2] = 0, o[Q + 44 >> 2] = B, o[Q + 56 >> 2] = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, o[Q + 60 >> 2] = a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24, p(Q, A = dA(A, 0, I), A, I, g), iI(Q, 64)), w = Q - -64 | 0, 0;
                                        },
                                        function(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, C |= 0, B |= 0, w = Q = w + -64 | 0, (I |= 0) | (g |= 0) && (o[Q + 8 >> 2] = 2036477234, o[Q + 12 >> 2] = 1797285236, o[Q >> 2] = 1634760805, o[Q + 4 >> 2] = 857760878, o[Q + 16 >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, o[Q + 20 >> 2] = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, o[Q + 24 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, o[Q + 28 >> 2] = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, o[Q + 32 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, o[Q + 36 >> 2] = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, o[Q + 40 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, B = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, o[Q + 48 >> 2] = 0, o[Q + 44 >> 2] = B, o[Q + 52 >> 2] = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, o[Q + 56 >> 2] = a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24, o[Q + 60 >> 2] = a[C + 8 | 0] | a[C + 9 | 0] << 8 | a[C + 10 | 0] << 16 | a[C + 11 | 0] << 24, p(Q, A = dA(A, 0, I), A, I, g), iI(Q, 64)), w = Q - -64 | 0, 0;
                                        },
                                        function(A, I, g, C, B, Q, i, E) {
                                            var f;
                                            return A |= 0, I |= 0, B |= 0, Q |= 0, i |= 0, E |= 0, w = f = w + -64 | 0, (g |= 0) | (C |= 0) && (o[f + 8 >> 2] = 2036477234, o[f + 12 >> 2] = 1797285236, o[f >> 2] = 1634760805, o[f + 4 >> 2] = 857760878, o[f + 16 >> 2] = a[0 | E] | a[E + 1 | 0] << 8 | a[E + 2 | 0] << 16 | a[E + 3 | 0] << 24, o[f + 20 >> 2] = a[E + 4 | 0] | a[E + 5 | 0] << 8 | a[E + 6 | 0] << 16 | a[E + 7 | 0] << 24, o[f + 24 >> 2] = a[E + 8 | 0] | a[E + 9 | 0] << 8 | a[E + 10 | 0] << 16 | a[E + 11 | 0] << 24, o[f + 28 >> 2] = a[E + 12 | 0] | a[E + 13 | 0] << 8 | a[E + 14 | 0] << 16 | a[E + 15 | 0] << 24, o[f + 32 >> 2] = a[E + 16 | 0] | a[E + 17 | 0] << 8 | a[E + 18 | 0] << 16 | a[E + 19 | 0] << 24, o[f + 36 >> 2] = a[E + 20 | 0] | a[E + 21 | 0] << 8 | a[E + 22 | 0] << 16 | a[E + 23 | 0] << 24, o[f + 40 >> 2] = a[E + 24 | 0] | a[E + 25 | 0] << 8 | a[E + 26 | 0] << 16 | a[E + 27 | 0] << 24, o[f + 44 >> 2] = a[E + 28 | 0] | a[E + 29 | 0] << 8 | a[E + 30 | 0] << 16 | a[E + 31 | 0] << 24, o[f + 48 >> 2] = Q, o[f + 52 >> 2] = i, o[f + 56 >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, o[f + 60 >> 2] = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, p(f, I, A, g, C), iI(f, 64)), w = f - -64 | 0, 0;
                                        },
                                        function(A, I, g, C, B, Q, i) {
                                            var E;
                                            return A |= 0, I |= 0, B |= 0, Q |= 0, i |= 0, w = E = w + -64 | 0, (g |= 0) | (C |= 0) && (o[E + 8 >> 2] = 2036477234, o[E + 12 >> 2] = 1797285236, o[E >> 2] = 1634760805, o[E + 4 >> 2] = 857760878, o[E + 16 >> 2] = a[0 | i] | a[i + 1 | 0] << 8 | a[i + 2 | 0] << 16 | a[i + 3 | 0] << 24, o[E + 20 >> 2] = a[i + 4 | 0] | a[i + 5 | 0] << 8 | a[i + 6 | 0] << 16 | a[i + 7 | 0] << 24, o[E + 24 >> 2] = a[i + 8 | 0] | a[i + 9 | 0] << 8 | a[i + 10 | 0] << 16 | a[i + 11 | 0] << 24, o[E + 28 >> 2] = a[i + 12 | 0] | a[i + 13 | 0] << 8 | a[i + 14 | 0] << 16 | a[i + 15 | 0] << 24, o[E + 32 >> 2] = a[i + 16 | 0] | a[i + 17 | 0] << 8 | a[i + 18 | 0] << 16 | a[i + 19 | 0] << 24, o[E + 36 >> 2] = a[i + 20 | 0] | a[i + 21 | 0] << 8 | a[i + 22 | 0] << 16 | a[i + 23 | 0] << 24, o[E + 40 >> 2] = a[i + 24 | 0] | a[i + 25 | 0] << 8 | a[i + 26 | 0] << 16 | a[i + 27 | 0] << 24, i = a[i + 28 | 0] | a[i + 29 | 0] << 8 | a[i + 30 | 0] << 16 | a[i + 31 | 0] << 24, o[E + 48 >> 2] = Q, o[E + 44 >> 2] = i, o[E + 52 >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, o[E + 56 >> 2] = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, o[E + 60 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, p(E, I, A, g, C), iI(E, 64)), w = E - -64 | 0, 0;
                                        }
                                    ], yI.grow = function(A) {
                                        var I = this.length;
                                        return this.length = this.length + A, I;
                                    }, yI.set = function(A, I) {
                                        this[A] = I;
                                    }, yI.get = function(A) {
                                        return this[A];
                                    }, yI);
                                    function hI() {
                                        return i.byteLength / 65536 | 0;
                                    }
                                    return {
                                        f: function() {},
                                        g: function(A, I, g, C, B, Q, i, E, o, a, f, c) {
                                            return 0 | hA(A |= 0, I |= 0, g |= 0, C |= 0, (A = 0) | (B |= 0), Q |= 0, i |= 0, A | (E |= 0), o |= 0, f |= 0, c |= 0);
                                        },
                                        h: function(A, I, g, C, B, i, E, a, f, c, e) {
                                            return A |= 0, I |= 0, C |= 0, E |= 0, f |= 0, E |= f = 0, !(B |= 0) & (C |= f) >>> 0 < 4294967280 ? (hA(A, A + C | 0, 0, g |= 0, C, B, i |= 0, E, a |= 0, c |= 0, e |= 0), I && (B = (A = C + 16 | 0) >>> 0 < 16 ? B + 1 | 0 : B, o[I >> 2] = A, o[I + 4 >> 2] = B)) : (zA(), Q()), 0;
                                        },
                                        i: function(A, I, g, C, B, Q, i, E, o, a, f, c) {
                                            return 0 | yA(A |= 0, I |= 0, g |= 0, C |= 0, (A = 0) | (B |= 0), Q |= 0, i |= 0, A | (E |= 0), o |= 0, f |= 0, c |= 0);
                                        },
                                        j: function(A, I, g, C, B, i, E, a, f, c, e) {
                                            return A |= 0, I |= 0, C |= 0, E |= 0, f |= 0, E |= f = 0, !(B |= 0) & (C |= f) >>> 0 < 4294967280 ? (yA(A, A + C | 0, 0, g |= 0, C, B, i |= 0, E, a |= 0, c |= 0, e |= 0), I && (B = (A = C + 16 | 0) >>> 0 < 16 ? B + 1 | 0 : B, o[I >> 2] = A, o[I + 4 >> 2] = B)) : (zA(), Q()), 0;
                                        },
                                        k: function(A, I, g, C, B, Q, i, E, o, a, f) {
                                            return 0 | wA(A |= 0, g |= 0, (A = 0) | (C |= 0), B |= 0, Q |= 0, i |= 0, A | (E |= 0), o |= 0, a |= 0, f |= 0);
                                        },
                                        l: function(A, I, g, C, B, Q, i, E, a, f, c) {
                                            return I |= 0, g |= 0, C |= 0, B |= 0, E |= 0, E |= 0, g = -1, !(Q |= 0) & (B |= 0) >>> 0 >= 16 | Q && (g = wA(A |= 0, C, B - 16 | 0, Q - (B >>> 0 < 16) | 0, (C + B | 0) - 16 | 0, i |= 0, E, a |= 0, f |= 0, c |= 0)), I && (o[I >> 2] = g ? 0 : B - 16 | 0, o[I + 4 >> 2] = g ? 0 : Q - (B >>> 0 < 16) | 0), 0 | g;
                                        },
                                        m: function(A, I, g, C, B, Q, i, E, o, a, f) {
                                            return 0 | tA(A |= 0, g |= 0, (A = 0) | (C |= 0), B |= 0, Q |= 0, i |= 0, A | (E |= 0), o |= 0, a |= 0, f |= 0);
                                        },
                                        n: function(A, I, g, C, B, Q, i, E, a, f, c) {
                                            return I |= 0, g |= 0, C |= 0, B |= 0, E |= 0, E |= 0, g = -1, !(Q |= 0) & (B |= 0) >>> 0 >= 16 | Q && (g = tA(A |= 0, C, B - 16 | 0, Q - (B >>> 0 < 16) | 0, (C + B | 0) - 16 | 0, i |= 0, E, a |= 0, f |= 0, c |= 0)), I && (o[I >> 2] = g ? 0 : B - 16 | 0, o[I + 4 >> 2] = g ? 0 : Q - (B >>> 0 < 16) | 0), 0 | g;
                                        },
                                        o: aI,
                                        p: function() {
                                            return 12;
                                        },
                                        q: tI,
                                        r: oI,
                                        s: cI,
                                        t: QI,
                                        u: aI,
                                        v: DI,
                                        w: tI,
                                        x: oI,
                                        y: cI,
                                        z: QI,
                                        A: function(A, I, g, C, B, Q, i, E, o, a, f, c) {
                                            return 0 | oA(A |= 0, I |= 0, g |= 0, C |= 0, (A = 0) | (B |= 0), Q |= 0, i |= 0, A | (E |= 0), o |= 0, f |= 0, c |= 0);
                                        },
                                        B: function(A, I, g, C, B, i, E, a, f, c, e) {
                                            return A |= 0, I |= 0, C |= 0, E |= 0, f |= 0, E |= f = 0, !(B |= 0) & (C |= f) >>> 0 < 4294967280 ? (oA(A, A + C | 0, 0, g |= 0, C, B, i |= 0, E, a |= 0, c |= 0, e |= 0), I && (B = (A = C + 16 | 0) >>> 0 < 16 ? B + 1 | 0 : B, o[I >> 2] = A, o[I + 4 >> 2] = B)) : (zA(), Q()), 0;
                                        },
                                        C: function(A, I, g, C, B, Q, i, E, o, a, f) {
                                            return 0 | EA(A |= 0, g |= 0, (A = 0) | (C |= 0), B |= 0, Q |= 0, i |= 0, A | (E |= 0), o |= 0, a |= 0, f |= 0);
                                        },
                                        D: function(A, I, g, C, B, Q, i, E, a, f, c) {
                                            return I |= 0, g |= 0, C |= 0, B |= 0, E |= 0, E |= 0, g = -1, !(Q |= 0) & (B |= 0) >>> 0 >= 16 | Q && (g = EA(A |= 0, C, B - 16 | 0, Q - (B >>> 0 < 16) | 0, (C + B | 0) - 16 | 0, i |= 0, E, a |= 0, f |= 0, c |= 0)), I && (o[I >> 2] = g ? 0 : B - 16 | 0, o[I + 4 >> 2] = g ? 0 : Q - (B >>> 0 < 16) | 0), 0 | g;
                                        },
                                        E: aI,
                                        F: fI,
                                        G: tI,
                                        H: oI,
                                        I: cI,
                                        J: QI,
                                        K: aI,
                                        L: aI,
                                        M: function(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, w = Q = w - 480 | 0, gA(Q, B |= 0, 32), AI(Q, I, g, C), bA(Q, Q + 416 | 0), I = o[Q + 444 >> 2], g = o[Q + 440 >> 2], E[A + 24 | 0] = g, E[A + 25 | 0] = g >>> 8, E[A + 26 | 0] = g >>> 16, E[A + 27 | 0] = g >>> 24, E[A + 28 | 0] = I, E[A + 29 | 0] = I >>> 8, E[A + 30 | 0] = I >>> 16, E[A + 31 | 0] = I >>> 24, I = o[Q + 436 >> 2], g = o[Q + 432 >> 2], E[A + 16 | 0] = g, E[A + 17 | 0] = g >>> 8, E[A + 18 | 0] = g >>> 16, E[A + 19 | 0] = g >>> 24, E[A + 20 | 0] = I, E[A + 21 | 0] = I >>> 8, E[A + 22 | 0] = I >>> 16, E[A + 23 | 0] = I >>> 24, I = o[Q + 428 >> 2], g = o[Q + 424 >> 2], E[A + 8 | 0] = g, E[A + 9 | 0] = g >>> 8, E[A + 10 | 0] = g >>> 16, E[A + 11 | 0] = g >>> 24, E[A + 12 | 0] = I, E[A + 13 | 0] = I >>> 8, E[A + 14 | 0] = I >>> 16, E[A + 15 | 0] = I >>> 24, I = o[Q + 420 >> 2], g = o[Q + 416 >> 2], E[0 | A] = g, E[A + 1 | 0] = g >>> 8, E[A + 2 | 0] = g >>> 16, E[A + 3 | 0] = g >>> 24, E[A + 4 | 0] = I, E[A + 5 | 0] = I >>> 8, E[A + 6 | 0] = I >>> 16, E[A + 7 | 0] = I >>> 24, w = Q + 480 | 0, 0;
                                        },
                                        N: function(A, I, g, C, B) {
                                            var Q, i;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, w = Q = w - 512 | 0, gA(i = Q + 32 | 0, B |= 0, 32), AI(i, I, g, C), bA(i, Q + 448 | 0), I = o[Q + 476 >> 2], o[Q + 24 >> 2] = o[Q + 472 >> 2], o[Q + 28 >> 2] = I, I = o[Q + 468 >> 2], o[Q + 16 >> 2] = o[Q + 464 >> 2], o[Q + 20 >> 2] = I, I = o[Q + 460 >> 2], o[Q + 8 >> 2] = o[Q + 456 >> 2], o[Q + 12 >> 2] = I, I = o[Q + 452 >> 2], o[Q >> 2] = o[Q + 448 >> 2], o[Q + 4 >> 2] = I, I = nA(A, Q), g = eA(Q, A, 32), w = Q + 512 | 0, ((0 | A) == (0 | Q) ? -1 : I) | g;
                                        },
                                        O: QI,
                                        P: aI,
                                        Q: aI,
                                        R: aI,
                                        S: aI,
                                        T: fI,
                                        U: oI,
                                        V: cI,
                                        W: function(A, I, g) {
                                            A |= 0, I |= 0;
                                            var C, B = 0;
                                            return w = C = w + -64 | 0, aA(C, g |= 0, 32, 0), g = o[C + 28 >> 2], B = o[C + 24 >> 2], E[I + 24 | 0] = B, E[I + 25 | 0] = B >>> 8, E[I + 26 | 0] = B >>> 16, E[I + 27 | 0] = B >>> 24, E[I + 28 | 0] = g, E[I + 29 | 0] = g >>> 8, E[I + 30 | 0] = g >>> 16, E[I + 31 | 0] = g >>> 24, g = o[C + 20 >> 2], B = o[C + 16 >> 2], E[I + 16 | 0] = B, E[I + 17 | 0] = B >>> 8, E[I + 18 | 0] = B >>> 16, E[I + 19 | 0] = B >>> 24, E[I + 20 | 0] = g, E[I + 21 | 0] = g >>> 8, E[I + 22 | 0] = g >>> 16, E[I + 23 | 0] = g >>> 24, g = o[C + 12 >> 2], B = o[C + 8 >> 2], E[I + 8 | 0] = B, E[I + 9 | 0] = B >>> 8, E[I + 10 | 0] = B >>> 16, E[I + 11 | 0] = B >>> 24, E[I + 12 | 0] = g, E[I + 13 | 0] = g >>> 8, E[I + 14 | 0] = g >>> 16, E[I + 15 | 0] = g >>> 24, g = o[C + 4 >> 2], B = o[C >> 2], E[0 | I] = B, E[I + 1 | 0] = B >>> 8, E[I + 2 | 0] = B >>> 16, E[I + 3 | 0] = B >>> 24, E[I + 4 | 0] = g, E[I + 5 | 0] = g >>> 8, E[I + 6 | 0] = g >>> 16, E[I + 7 | 0] = g >>> 24, iI(C, 64), A = II(A, I), w = C - -64 | 0, 0 | A;
                                        },
                                        X: XA,
                                        Y: UA,
                                        Z: PA,
                                        _: function(A, I, g, C, B, Q, i, E) {
                                            A |= 0, I |= 0, g |= 0, Q |= 0;
                                            var o, a = 0;
                                            return a = C |= 0, C = B |= 0, o = 0 | a, w = a = w - 32 | 0, B = -1, UA(a, i |= 0, E |= 0) || (B = iA(A, I, g, o, C, Q, a), iI(a, 32)), w = a + 32 | 0, 0 | B;
                                        },
                                        $: function(A, I, g, C, B, i) {
                                            return A |= 0, I |= 0, B |= 0, i |= 0, !(C |= 0) & (g |= 0) >>> 0 >= 4294967280 | C && (zA(), Q()), 0 | iA(A + 16 | 0, A, I, g, C, B, i);
                                        },
                                        aa: function(A, I, g, C, B, Q, i) {
                                            return 0 | NA(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                        },
                                        ba: vA,
                                        ca: function(A, I, g, C, B, Q, i, E) {
                                            A |= 0, I |= 0, g |= 0, Q |= 0;
                                            var o, a = 0;
                                            return a = C |= 0, C = B |= 0, o = 0 | a, w = a = w - 32 | 0, B = -1, UA(a, i |= 0, E |= 0) || (B = QA(A, I, g, o, C, Q, a), iI(a, 32)), w = a + 32 | 0, 0 | B;
                                        },
                                        da: JA,
                                        ea: function(A, I, g, C, B, Q, i) {
                                            return 0 | GA(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                        },
                                        fa: function(A, I, g, C, B) {
                                            A |= 0, I |= 0, B |= 0;
                                            var Q, i, a, f, c = 0, e = 0;
                                            return c = g |= 0, g = C |= 0, f = 0 | c, c = C = w, w = Q = C - 512 & -64, C = -1, XA(i = Q - -64 | 0, a = Q + 32 | 0) || (K(C = Q + 128 | 0, 0, 0, 24), Z(C, i, 32, 0), Z(C, B, 32, 0), KA(C, e = Q + 96 | 0, 24), C = NA(A + 32 | 0, I, f, g, e, B, a), I = o[Q + 92 >> 2], g = o[Q + 88 >> 2], E[A + 24 | 0] = g, E[A + 25 | 0] = g >>> 8, E[A + 26 | 0] = g >>> 16, E[A + 27 | 0] = g >>> 24, E[A + 28 | 0] = I, E[A + 29 | 0] = I >>> 8, E[A + 30 | 0] = I >>> 16, E[A + 31 | 0] = I >>> 24, I = o[Q + 84 >> 2], g = o[Q + 80 >> 2], E[A + 16 | 0] = g, E[A + 17 | 0] = g >>> 8, E[A + 18 | 0] = g >>> 16, E[A + 19 | 0] = g >>> 24, E[A + 20 | 0] = I, E[A + 21 | 0] = I >>> 8, E[A + 22 | 0] = I >>> 16, E[A + 23 | 0] = I >>> 24, I = o[Q + 76 >> 2], g = o[Q + 72 >> 2], E[A + 8 | 0] = g, E[A + 9 | 0] = g >>> 8, E[A + 10 | 0] = g >>> 16, E[A + 11 | 0] = g >>> 24, E[A + 12 | 0] = I, E[A + 13 | 0] = I >>> 8, E[A + 14 | 0] = I >>> 16, E[A + 15 | 0] = I >>> 24, I = o[Q + 68 >> 2], g = o[Q + 64 >> 2], E[0 | A] = g, E[A + 1 | 0] = g >>> 8, E[A + 2 | 0] = g >>> 16, E[A + 3 | 0] = g >>> 24, E[A + 4 | 0] = I, E[A + 5 | 0] = I >>> 8, E[A + 6 | 0] = I >>> 16, E[A + 7 | 0] = I >>> 24, iI(a, 32), iI(i, 32), iI(e, 24)), w = c, 0 | C;
                                        },
                                        ga: function(A, I, g, C, B, Q) {
                                            A |= 0, I |= 0, B |= 0, Q |= 0;
                                            var i, E, o = 0;
                                            return E = o = w, w = i = o - 448 & -64, o = -1, !(C |= 0) & (g |= 0) >>> 0 >= 48 | C && (K(o = i - -64 | 0, 0, 0, 24), Z(o, I, 32, 0), Z(o, B, 32, 0), KA(o, B = i + 32 | 0, 24), o = GA(A, I + 32 | 0, g - 32 | 0, C - (g >>> 0 < 32) | 0, B, I, Q)), w = E, 0 | o;
                                        },
                                        ha: function() {
                                            return 48;
                                        },
                                        ia: oI,
                                        ja: eI,
                                        ka: aI,
                                        la: oI,
                                        ma: eI,
                                        na: aI,
                                        oa: function() {
                                            return 384;
                                        },
                                        pa: function(A, I, g, C, B, Q, i) {
                                            return 0 | X(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                        },
                                        qa: K,
                                        ra: function(A, I, g, C) {
                                            return 0 | Z(A |= 0, I |= 0, g |= 0, C |= 0);
                                        },
                                        sa: KA,
                                        ta: QI,
                                        ua: eI,
                                        va: function(A, I, g, C) {
                                            return 0 | aA(A |= 0, I |= 0, g |= 0, C |= 0);
                                        },
                                        wa: oI,
                                        xa: eI,
                                        ya: DI,
                                        za: aI,
                                        Aa: function(A, I, g, C, B, i) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, i |= 0;
                                            var E, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0;
                                            return w = E = w - 32 | 0, f = a[0 | (B |= 0)] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, B = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, o[E + 24 >> 2] = 0, o[E + 28 >> 2] = 0, o[E + 16 >> 2] = f, o[E + 20 >> 2] = B, o[E + 8 >> 2] = 0, o[E + 12 >> 2] = 0, o[(B = E) >> 2] = g, o[B + 4 >> 2] = C, I - 65 >>> 0 <= 4294967246 ? (o[9005] = 28, A = -1) : I - 65 >>> 0 < 4294967232 ? A = -1 : (w = B = (e = w) - 512 & -64, !i | !A | ((c = 255 & I) - 65 & 255) >>> 0 <= 191 ? (zA(), Q()) : (C = E + 16 | 0, E ? (r = 725511199 ^ (a[E + 8 | 0] | a[E + 9 | 0] << 8 | a[E + 10 | 0] << 16 | a[E + 11 | 0] << 24), D = -1694144372 ^ (a[E + 12 | 0] | a[E + 13 | 0] << 8 | a[E + 14 | 0] << 16 | a[E + 15 | 0] << 24), g = -1377402159 ^ (a[0 | E] | a[E + 1 | 0] << 8 | a[E + 2 | 0] << 16 | a[E + 3 | 0] << 24), I = 1359893119 ^ (a[E + 4 | 0] | a[E + 5 | 0] << 8 | a[E + 6 | 0] << 16 | a[E + 7 | 0] << 24)) : (r = 725511199, D = -1694144372, g = -1377402159, I = 1359893119), C ? (t = 327033209 ^ (a[C + 8 | 0] | a[C + 9 | 0] << 8 | a[C + 10 | 0] << 16 | a[C + 11 | 0] << 24), y = 1541459225 ^ (a[C + 12 | 0] | a[C + 13 | 0] << 8 | a[C + 14 | 0] << 16 | a[C + 15 | 0] << 24), f = -79577749 ^ (a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24), C = 528734635 ^ (a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24)) : (t = 327033209, y = 1541459225, f = -79577749, C = 528734635), dA(B - -64 | 0, 0, 293), o[B + 56 >> 2] = t, o[B + 60 >> 2] = y, o[B + 48 >> 2] = f, o[B + 52 >> 2] = C, o[B + 40 >> 2] = r, o[B + 44 >> 2] = D, o[B + 32 >> 2] = g, o[B + 36 >> 2] = I, o[B + 24 >> 2] = 1595750129, o[B + 28 >> 2] = -1521486534, o[B + 16 >> 2] = -23791573, o[B + 20 >> 2] = 1013904242, o[B + 8 >> 2] = -2067093701, o[B + 12 >> 2] = -1150833019, o[B >> 2] = -222443256 ^ (8192 | c), o[B + 4 >> 2] = 1779033703, dA(32 + (I = B + 384 | 0) | 0, 0, 96), YA(I, i, 32), YA(B + 96 | 0, I, 128), o[B + 352 >> 2] = 128, iI(I, 128), J(B, A, c), w = e), A = 0), w = E + 32 | 0, 0 | A;
                                        },
                                        Ba: QI,
                                        Ca: function(A, I, g) {
                                            return 0 | q(A |= 0, I |= 0, g |= 0);
                                        },
                                        Da: function(A, I, g) {
                                            return 0 | gI(A |= 0, I |= 0, g |= 0);
                                        },
                                        Ea: function(A, I) {
                                            return LA(A |= 0, I |= 0), iI(A, 4), 0;
                                        },
                                        Fa: function(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, C |= 0, B |= 0, w = Q = w - 208 | 0, q(Q, I |= 0, g |= 0), gI(Q, C, B), LA(Q, A), iI(Q, 4), w = Q + 208 | 0, 0;
                                        },
                                        Ga: QI,
                                        Ha: function(A, I, g, C, B) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, B |= 0;
                                            var Q, i = 0, f = 0, c = 0;
                                            if (w = Q = w - 256 | 0, E[Q + 15 | 0] = 1, I >>> 0 <= 8160) {
                                                if (I >>> 0 >= 32) for(i = 32; c = i, q(i = Q + 48 | 0, B, 32), f && gI(i, (A + f | 0) - 32 | 0, 32), gI(i = Q + 48 | 0, g, C), gI(i, Q + 15 | 0, 1), LA(i, A + f | 0), E[Q + 15 | 0] = a[Q + 15 | 0] + 1, (i = (f = c) + 32 | 0) >>> 0 <= I >>> 0;);
                                                (f = 31 & I) && (q(I = Q + 48 | 0, B, 32), c && gI(I, (A + c | 0) - 32 | 0, 32), gI(I = Q + 48 | 0, g, C), gI(I, Q + 15 | 0, 1), LA(g = I, I = Q + 16 | 0), YA(A + c | 0, I, f), iI(I, 32)), iI(Q + 48 | 0, 208), A = 0;
                                            } else o[9005] = 28, A = -1;
                                            return w = Q + 256 | 0, 0 | A;
                                        },
                                        Ia: aI,
                                        Ja: tI,
                                        Ka: function() {
                                            return 8160;
                                        },
                                        La: EI,
                                        Ma: function(A, I, g) {
                                            return 0 | gA(A |= 0, I |= 0, g |= 0);
                                        },
                                        Na: function(A, I, g) {
                                            return 0 | AI(A |= 0, I |= 0, g |= 0, 0);
                                        },
                                        Oa: function(A, I) {
                                            return bA(A |= 0, I |= 0), iI(A, 4), 0;
                                        },
                                        Pa: function(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, C |= 0, B |= 0, w = Q = w - 416 | 0, gA(Q, I |= 0, g |= 0), AI(Q, C, B, 0), bA(Q, A), iI(Q, 4), w = Q + 416 | 0, 0;
                                        },
                                        Qa: function(A) {
                                            HA(A |= 0, 64);
                                        },
                                        Ra: function(A, I, g, C, B) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, B |= 0;
                                            var Q, i = 0, f = 0, c = 0;
                                            if (w = Q = w - 496 | 0, E[Q + 15 | 0] = 1, I >>> 0 <= 16320) {
                                                if (I >>> 0 >= 64) for(i = 64; c = i, gA(i = Q + 80 | 0, B, 64), f && AI(i, (A + f | 0) - 64 | 0, 64, 0), AI(i = Q + 80 | 0, g, C, 0), AI(i, Q + 15 | 0, 1, 0), bA(i, A + f | 0), E[Q + 15 | 0] = a[Q + 15 | 0] + 1, (i = (f = c) - -64 | 0) >>> 0 <= I >>> 0;);
                                                (f = 63 & I) && (gA(I = Q + 80 | 0, B, 64), c && AI(I, (A + c | 0) - 64 | 0, 64, 0), AI(I = Q + 80 | 0, g, C, 0), AI(I, Q + 15 | 0, 1, 0), bA(g = I, I = Q + 16 | 0), YA(A + c | 0, I, f), iI(I, 64)), iI(Q + 80 | 0, 416), A = 0;
                                            } else o[9005] = 28, A = -1;
                                            return w = Q + 496 | 0, 0 | A;
                                        },
                                        Sa: eI,
                                        Ta: tI,
                                        Ua: function() {
                                            return 16320;
                                        },
                                        Va: function(A, I, g) {
                                            return A |= 0, X(I |= 0, 32, g |= 0, 32, 0, 0, 0), 0 | VA(A, I);
                                        },
                                        Wa: function(A, I) {
                                            return A |= 0, HA(I |= 0, 32), 0 | VA(A, I);
                                        },
                                        Xa: function(A, I, g, C, B) {
                                            I |= 0, g |= 0, C |= 0, B |= 0;
                                            var i, o, f = 0, c = 0, e = 0;
                                            if (o = f = w, w = f = f - 512 & -64, i = (A |= 0) || I) {
                                                if (e = -1, !lA(c = f + 96 | 0, C, B)) {
                                                    for(C = I || A, A = 0, K(I = f + 128 | 0, 0, 0, 64), Z(I, c, 32, 0), iI(c, 32), Z(I, g, 32, 0), Z(I, B, 32, 0), KA(I, f + 32 | 0, 64), iI(I, 384); g = (I = f + 32 | 0) + A | 0, E[A + i | 0] = a[0 | g], E[A + C | 0] = a[g + 32 | 0], E[(B = 1 | A) + i | 0] = a[I + B | 0], E[C + B | 0] = a[g + 33 | 0], 32 != (0 | (A = A + 2 | 0)););
                                                    iI(I, 64), e = 0;
                                                }
                                                return w = o, 0 | e;
                                            }
                                            zA(), Q();
                                        },
                                        Ya: function(A, I, g, C, B) {
                                            I |= 0, g |= 0, C |= 0, B |= 0;
                                            var i, o, f = 0, c = 0, e = 0;
                                            if (o = f = w, w = f = f - 512 & -64, i = (A |= 0) || I) {
                                                if (e = -1, !lA(c = f + 96 | 0, C, B)) {
                                                    for(C = I || A, A = 0, K(I = f + 128 | 0, 0, 0, 64), Z(I, c, 32, 0), iI(c, 32), Z(I, B, 32, 0), Z(I, g, 32, 0), KA(I, f + 32 | 0, 64), iI(I, 384); g = (I = f + 32 | 0) + A | 0, E[A + C | 0] = a[0 | g], E[A + i | 0] = a[g + 32 | 0], E[(B = 1 | A) + C | 0] = a[I + B | 0], E[B + i | 0] = a[g + 33 | 0], 32 != (0 | (A = A + 2 | 0)););
                                                    iI(I, 64), e = 0;
                                                }
                                                return w = o, 0 | e;
                                            }
                                            zA(), Q();
                                        },
                                        Za: aI,
                                        _a: aI,
                                        $a: aI,
                                        ab: aI,
                                        bb: VA,
                                        cb: lA,
                                        db: aI,
                                        eb: aI,
                                        fb: aI,
                                        gb: fI,
                                        hb: oI,
                                        ib: cI,
                                        jb: QI,
                                        kb: PA,
                                        lb: function(A, I, g, C, B, i) {
                                            return A |= 0, I |= 0, B |= 0, i |= 0, !(C |= 0) & (g |= 0) >>> 0 >= 4294967280 | C && (zA(), Q()), iA(A + 16 | 0, A, I, g, C, B, i), 0;
                                        },
                                        mb: vA,
                                        nb: JA,
                                        ob: QI,
                                        pb: function(A, I, g) {
                                            return A |= 0, g |= 0, HA(I |= 0, 24), x(A, I, g), E[A + 32 | 0] = 1, E[A + 33 | 0] = 0, E[A + 34 | 0] = 0, E[A + 35 | 0] = 0, g = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, I = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, E[A + 44 | 0] = 0, E[A + 45 | 0] = 0, E[A + 46 | 0] = 0, E[A + 47 | 0] = 0, E[A + 48 | 0] = 0, E[A + 49 | 0] = 0, E[A + 50 | 0] = 0, E[A + 51 | 0] = 0, E[A + 36 | 0] = g, E[A + 37 | 0] = g >>> 8, E[A + 38 | 0] = g >>> 16, E[A + 39 | 0] = g >>> 24, E[A + 40 | 0] = I, E[A + 41 | 0] = I >>> 8, E[A + 42 | 0] = I >>> 16, E[A + 43 | 0] = I >>> 24, 0;
                                        },
                                        qb: function(A, I, g) {
                                            return x(A |= 0, I |= 0, g |= 0), E[A + 32 | 0] = 1, E[A + 33 | 0] = 0, E[A + 34 | 0] = 0, E[A + 35 | 0] = 0, g = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, I = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, E[A + 44 | 0] = 0, E[A + 45 | 0] = 0, E[A + 46 | 0] = 0, E[A + 47 | 0] = 0, E[A + 48 | 0] = 0, E[A + 49 | 0] = 0, E[A + 50 | 0] = 0, E[A + 51 | 0] = 0, E[A + 36 | 0] = g, E[A + 37 | 0] = g >>> 8, E[A + 38 | 0] = g >>> 16, E[A + 39 | 0] = g >>> 24, E[A + 40 | 0] = I, E[A + 41 | 0] = I >>> 8, E[A + 42 | 0] = I >>> 16, E[A + 43 | 0] = I >>> 24, 0;
                                        },
                                        rb: function(A) {
                                            var I, g = 0, C = 0;
                                            w = I = w - 48 | 0, g = a[28 + (A |= 0) | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24, o[I + 24 >> 2] = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, o[I + 28 >> 2] = g, g = a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24, o[I + 16 >> 2] = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, o[I + 20 >> 2] = g, g = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, o[I >> 2] = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, o[I + 4 >> 2] = g, g = a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24, o[I + 8 >> 2] = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, o[I + 12 >> 2] = g, g = a[A + 40 | 0] | a[A + 41 | 0] << 8 | a[A + 42 | 0] << 16 | a[A + 43 | 0] << 24, o[I + 32 >> 2] = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24, o[I + 36 >> 2] = g, OA(I, I, A + 32 | 0, A), g = o[I + 28 >> 2], C = o[I + 24 >> 2], E[A + 24 | 0] = C, E[A + 25 | 0] = C >>> 8, E[A + 26 | 0] = C >>> 16, E[A + 27 | 0] = C >>> 24, E[A + 28 | 0] = g, E[A + 29 | 0] = g >>> 8, E[A + 30 | 0] = g >>> 16, E[A + 31 | 0] = g >>> 24, g = o[I + 20 >> 2], C = o[I + 16 >> 2], E[A + 16 | 0] = C, E[A + 17 | 0] = C >>> 8, E[A + 18 | 0] = C >>> 16, E[A + 19 | 0] = C >>> 24, E[A + 20 | 0] = g, E[A + 21 | 0] = g >>> 8, E[A + 22 | 0] = g >>> 16, E[A + 23 | 0] = g >>> 24, g = o[I + 12 >> 2], C = o[I + 8 >> 2], E[A + 8 | 0] = C, E[A + 9 | 0] = C >>> 8, E[A + 10 | 0] = C >>> 16, E[A + 11 | 0] = C >>> 24, E[A + 12 | 0] = g, E[A + 13 | 0] = g >>> 8, E[A + 14 | 0] = g >>> 16, E[A + 15 | 0] = g >>> 24, g = o[I + 4 >> 2], C = o[I >> 2], E[0 | A] = C, E[A + 1 | 0] = C >>> 8, E[A + 2 | 0] = C >>> 16, E[A + 3 | 0] = C >>> 24, E[A + 4 | 0] = g, E[A + 5 | 0] = g >>> 8, E[A + 6 | 0] = g >>> 16, E[A + 7 | 0] = g >>> 24, C = o[I + 36 >> 2], g = o[I + 32 >> 2], E[A + 32 | 0] = 1, E[A + 33 | 0] = 0, E[A + 34 | 0] = 0, E[A + 35 | 0] = 0, E[A + 36 | 0] = g, E[A + 37 | 0] = g >>> 8, E[A + 38 | 0] = g >>> 16, E[A + 39 | 0] = g >>> 24, E[A + 40 | 0] = C, E[A + 41 | 0] = C >>> 8, E[A + 42 | 0] = C >>> 16, E[A + 43 | 0] = C >>> 24, w = I + 48 | 0;
                                        },
                                        sb: function(A, I, g, C, B, i, f, c, e, r) {
                                            A |= 0, I |= 0, C |= 0, i |= 0, f |= 0, e |= 0, r |= 0;
                                            var D, t = 0, y = 0, h = 0;
                                            return t = B |= 0, t |= B = 0, D = B | (c |= 0), w = B = w - 384 | 0, (g |= 0) && (o[g >> 2] = 0, o[g + 4 >> 2] = 0), !i & t >>> 0 < 4294967279 ? (ZA(y = B + 16 | 0, 64, h = A + 32 | 0, A), CI(c = B + 80 | 0, y), iI(y, 64), $A(c, f, D, e), $A(c, 34288, 0 - D & 15, 0), o[B + 72 >> 2] = 0, o[B + 76 >> 2] = 0, o[(f = B - -64 | 0) >> 2] = 0, o[f + 4 >> 2] = 0, o[B + 56 >> 2] = 0, o[B + 60 >> 2] = 0, o[B + 48 >> 2] = 0, o[B + 52 >> 2] = 0, o[B + 40 >> 2] = 0, o[B + 44 >> 2] = 0, o[B + 32 >> 2] = 0, o[B + 36 >> 2] = 0, o[B + 16 >> 2] = 0, o[B + 20 >> 2] = 0, o[B + 24 >> 2] = 0, o[B + 28 >> 2] = 0, E[B + 16 | 0] = r, FA(y, y, 64, 0, h, 1, A), $A(c, y, 64, 0), E[0 | I] = a[B + 16 | 0], FA(I = I + 1 | 0, C, t, i, h, 2, A), $A(c, I, t, i), $A(c, 34288, 15 & t, 0), o[B + 8 >> 2] = D, o[B + 12 >> 2] = e, $A(c, C = B + 8 | 0, 8, 0), o[B + 8 >> 2] = t - -64, o[B + 12 >> 2] = i - ((t >>> 0 < 4294967232) - 1 | 0), $A(c, C, 8, 0), BI(c, I = I + t | 0), iI(c, 256), E[A + 36 | 0] = a[A + 36 | 0] ^ a[0 | I], E[A + 37 | 0] = a[A + 37 | 0] ^ a[I + 1 | 0], E[A + 38 | 0] = a[A + 38 | 0] ^ a[I + 2 | 0], E[A + 39 | 0] = a[A + 39 | 0] ^ a[I + 3 | 0], E[A + 40 | 0] = a[A + 40 | 0] ^ a[I + 4 | 0], E[A + 41 | 0] = a[A + 41 | 0] ^ a[I + 5 | 0], E[A + 42 | 0] = a[A + 42 | 0] ^ a[I + 6 | 0], E[A + 43 | 0] = a[A + 43 | 0] ^ a[I + 7 | 0], sA(h), (2 & r || fA(h, 4)) && (I = a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24, o[B + 360 >> 2] = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, o[B + 364 >> 2] = I, I = a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24, o[B + 352 >> 2] = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, o[B + 356 >> 2] = I, I = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, o[B + 336 >> 2] = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, o[B + 340 >> 2] = I, I = a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24, o[B + 344 >> 2] = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, o[B + 348 >> 2] = I, I = a[A + 40 | 0] | a[A + 41 | 0] << 8 | a[A + 42 | 0] << 16 | a[A + 43 | 0] << 24, o[B + 368 >> 2] = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24, o[B + 372 >> 2] = I, OA(I = B + 336 | 0, I, h, A), I = o[B + 364 >> 2], C = o[B + 360 >> 2], E[A + 24 | 0] = C, E[A + 25 | 0] = C >>> 8, E[A + 26 | 0] = C >>> 16, E[A + 27 | 0] = C >>> 24, E[A + 28 | 0] = I, E[A + 29 | 0] = I >>> 8, E[A + 30 | 0] = I >>> 16, E[A + 31 | 0] = I >>> 24, I = o[B + 356 >> 2], C = o[B + 352 >> 2], E[A + 16 | 0] = C, E[A + 17 | 0] = C >>> 8, E[A + 18 | 0] = C >>> 16, E[A + 19 | 0] = C >>> 24, E[A + 20 | 0] = I, E[A + 21 | 0] = I >>> 8, E[A + 22 | 0] = I >>> 16, E[A + 23 | 0] = I >>> 24, I = o[B + 348 >> 2], C = o[B + 344 >> 2], E[A + 8 | 0] = C, E[A + 9 | 0] = C >>> 8, E[A + 10 | 0] = C >>> 16, E[A + 11 | 0] = C >>> 24, E[A + 12 | 0] = I, E[A + 13 | 0] = I >>> 8, E[A + 14 | 0] = I >>> 16, E[A + 15 | 0] = I >>> 24, I = o[B + 340 >> 2], C = o[B + 336 >> 2], E[0 | A] = C, E[A + 1 | 0] = C >>> 8, E[A + 2 | 0] = C >>> 16, E[A + 3 | 0] = C >>> 24, E[A + 4 | 0] = I, E[A + 5 | 0] = I >>> 8, E[A + 6 | 0] = I >>> 16, E[A + 7 | 0] = I >>> 24, I = o[B + 368 >> 2], C = o[B + 372 >> 2], E[A + 32 | 0] = 1, E[A + 33 | 0] = 0, E[A + 34 | 0] = 0, E[A + 35 | 0] = 0, E[A + 36 | 0] = I, E[A + 37 | 0] = I >>> 8, E[A + 38 | 0] = I >>> 16, E[A + 39 | 0] = I >>> 24, E[A + 40 | 0] = C, E[A + 41 | 0] = C >>> 8, E[A + 42 | 0] = C >>> 16, E[A + 43 | 0] = C >>> 24), g && (i = (A = t + 17 | 0) >>> 0 < 17 ? i + 1 | 0 : i, o[g >> 2] = A, o[g + 4 >> 2] = i), w = B + 384 | 0) : (zA(), Q()), 0;
                                        },
                                        tb: function(A, I, g, C, B, i, f, c, e, r) {
                                            A |= 0, I |= 0, C |= 0, B |= 0, c |= 0, r |= 0;
                                            var D, t = 0, y = 0, h = 0, n = 0, s = 0, k = 0;
                                            t = i |= 0, i = f |= 0, y = 0 | t, D = e |= 0, w = f = w - 400 | 0, (g |= 0) && (o[g >> 2] = 0, o[g + 4 >> 2] = 0), C && (E[0 | C] = 255), k = -1;
                                            A: {
                                                I: {
                                                    if (!((e = y >>> 0 < 17) & !i)) {
                                                        if (s = t = i - e | 0, !t & (e = y - 17 | 0) >>> 0 >= 4294967279 | t) break I;
                                                        ZA(h = f + 32 | 0, 64, n = A + 32 | 0, A), CI(t = f + 96 | 0, h), iI(h, 64), $A(t, c, D, r), $A(t, 34288, 0 - D & 15, 0), o[f + 88 >> 2] = 0, o[f + 92 >> 2] = 0, o[f + 80 >> 2] = 0, o[f + 84 >> 2] = 0, o[f + 72 >> 2] = 0, o[f + 76 >> 2] = 0, o[(c = f - -64 | 0) >> 2] = 0, o[c + 4 >> 2] = 0, o[f + 56 >> 2] = 0, o[f + 60 >> 2] = 0, o[f + 48 >> 2] = 0, o[f + 52 >> 2] = 0, o[f + 40 >> 2] = 0, o[f + 44 >> 2] = 0, o[f + 32 >> 2] = 0, o[f + 36 >> 2] = 0, E[f + 32 | 0] = a[0 | B], FA(h, h, 64, 0, n, 1, A), c = a[f + 32 | 0], E[f + 32 | 0] = a[0 | B], $A(t, h, 64, 0), $A(t, B = B + 1 | 0, e, s), $A(t, 34288, y - 1 & 15, 0), o[f + 24 >> 2] = D, o[f + 28 >> 2] = r, $A(t, r = f + 24 | 0, 8, 0), i = (y = y + 47 | 0) >>> 0 < 47 ? i + 1 | 0 : i, o[f + 24 >> 2] = y, o[f + 28 >> 2] = i, $A(t, r, 8, 0), BI(t, f), iI(t, 256), eA(f, B + e | 0, 16) ? iI(f, 16) : (FA(I, B, e, s, n, 2, A), E[A + 36 | 0] = a[A + 36 | 0] ^ a[0 | f], E[A + 37 | 0] = a[A + 37 | 0] ^ a[f + 1 | 0], E[A + 38 | 0] = a[A + 38 | 0] ^ a[f + 2 | 0], E[A + 39 | 0] = a[A + 39 | 0] ^ a[f + 3 | 0], E[A + 40 | 0] = a[A + 40 | 0] ^ a[f + 4 | 0], E[A + 41 | 0] = a[A + 41 | 0] ^ a[f + 5 | 0], E[A + 42 | 0] = a[A + 42 | 0] ^ a[f + 6 | 0], E[A + 43 | 0] = a[A + 43 | 0] ^ a[f + 7 | 0], sA(n), (2 & c || fA(n, 4)) && (I = a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24, o[f + 376 >> 2] = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, o[f + 380 >> 2] = I, I = a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24, o[f + 368 >> 2] = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, o[f + 372 >> 2] = I, I = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, o[f + 352 >> 2] = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, o[f + 356 >> 2] = I, I = a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24, o[f + 360 >> 2] = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, o[f + 364 >> 2] = I, I = a[A + 40 | 0] | a[A + 41 | 0] << 8 | a[A + 42 | 0] << 16 | a[A + 43 | 0] << 24, o[f + 384 >> 2] = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24, o[f + 388 >> 2] = I, OA(I = f + 352 | 0, I, n, A), I = o[f + 380 >> 2], B = o[f + 376 >> 2], E[A + 24 | 0] = B, E[A + 25 | 0] = B >>> 8, E[A + 26 | 0] = B >>> 16, E[A + 27 | 0] = B >>> 24, E[A + 28 | 0] = I, E[A + 29 | 0] = I >>> 8, E[A + 30 | 0] = I >>> 16, E[A + 31 | 0] = I >>> 24, I = o[f + 372 >> 2], B = o[f + 368 >> 2], E[A + 16 | 0] = B, E[A + 17 | 0] = B >>> 8, E[A + 18 | 0] = B >>> 16, E[A + 19 | 0] = B >>> 24, E[A + 20 | 0] = I, E[A + 21 | 0] = I >>> 8, E[A + 22 | 0] = I >>> 16, E[A + 23 | 0] = I >>> 24, I = o[f + 364 >> 2], B = o[f + 360 >> 2], E[A + 8 | 0] = B, E[A + 9 | 0] = B >>> 8, E[A + 10 | 0] = B >>> 16, E[A + 11 | 0] = B >>> 24, E[A + 12 | 0] = I, E[A + 13 | 0] = I >>> 8, E[A + 14 | 0] = I >>> 16, E[A + 15 | 0] = I >>> 24, I = o[f + 356 >> 2], B = o[f + 352 >> 2], E[0 | A] = B, E[A + 1 | 0] = B >>> 8, E[A + 2 | 0] = B >>> 16, E[A + 3 | 0] = B >>> 24, E[A + 4 | 0] = I, E[A + 5 | 0] = I >>> 8, E[A + 6 | 0] = I >>> 16, E[A + 7 | 0] = I >>> 24, I = o[f + 384 >> 2], B = o[f + 388 >> 2], E[A + 32 | 0] = 1, E[A + 33 | 0] = 0, E[A + 34 | 0] = 0, E[A + 35 | 0] = 0, E[A + 36 | 0] = I, E[A + 37 | 0] = I >>> 8, E[A + 38 | 0] = I >>> 16, E[A + 39 | 0] = I >>> 24, E[A + 40 | 0] = B, E[A + 41 | 0] = B >>> 8, E[A + 42 | 0] = B >>> 16, E[A + 43 | 0] = B >>> 24), g && (o[g >> 2] = e, o[g + 4 >> 2] = s), k = 0, C && (E[0 | C] = c));
                                                    }
                                                    w = f + 400 | 0;
                                                    break A;
                                                }
                                                zA(), Q();
                                            }
                                            return 0 | k;
                                        },
                                        ub: function() {
                                            return 52;
                                        },
                                        vb: function() {
                                            return 17;
                                        },
                                        wb: fI,
                                        xb: aI,
                                        yb: function() {
                                            return -18;
                                        },
                                        zb: tI,
                                        Ab: rI,
                                        Bb: function() {
                                            return 2;
                                        },
                                        Cb: function() {
                                            return 3;
                                        },
                                        Db: DI,
                                        Eb: oI,
                                        Fb: function(A, I, g, C, B) {
                                            A |= 0, I |= 0, g |= 0, C |= 0;
                                            var Q, i = 0, o = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, n = 0, s = 0, k = 0, F = 0, S = 0;
                                            if (k = 1886610805 ^ (i = a[0 | (B |= 0)] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24), t = 1936682341 ^ (o = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24), i ^= 1852142177, f = 1819895653 ^ o, F = 1852075885 ^ (o = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24), S = 1685025377 ^ (B = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24), D = 2037671283 ^ o, o = 1952801890 ^ B, n = g, (0 | (w = (g + I | 0) - (Q = 7 & g) | 0)) != (0 | I)) {
                                                for(; g = (e = o ^ (s = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24)) + f | 0, D = C = i + (B = D ^ (y = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24)) | 0, r = g = C >>> 0 < B >>> 0 ? g + 1 | 0 : g, i = C, C = g, g = t + S | 0, g = (o = k + F | 0) >>> 0 < F >>> 0 ? g + 1 | 0 : g, c = (f = DA(F, S, 13) ^ o) + i | 0, C = (i = h ^ g) + C | 0, i = DA(f, i, 17) ^ c, k = DA(i, C = (f = f >>> 0 > c >>> 0 ? C + 1 | 0 : C) ^ h, 13), t = h, e = DA(B, e, 16), B = r ^ h, e ^= D, r = DA(o, g, 32), g = h + B | 0, g = (D = C) + (C = (o = e + r | 0) >>> 0 < r >>> 0 ? g + 1 | 0 : g) | 0, r = g = (D = i + o | 0) >>> 0 < o >>> 0 ? g + 1 | 0 : g, k = DA(i = D ^ k, g ^= t, 17), t = h, e = DA(e, B, 21), B = C ^ h, e ^= o, o = DA(c, f, 32), C = h + B | 0, g = (o = o >>> 0 > (f = e + o | 0) >>> 0 ? C + 1 | 0 : C) + g | 0, F = (i = i + f | 0) ^ k, C = g = i >>> 0 < f >>> 0 ? g + 1 | 0 : g, S = g ^ t, g = DA(e, B, 16), e = o ^= h, c = DA(g ^= f, o, 21), f = h, r = (o = DA(D, r, 32)) + g | 0, g = h + e | 0, D = c ^ r, o = (g = o >>> 0 > r >>> 0 ? g + 1 | 0 : g) ^ f, i = DA(i, C, 32), f = h, k = r ^ y, t = g ^ s, (0 | w) != (0 | (I = I + 8 | 0)););
                                                I = w;
                                            }
                                            switch(s = 0, c = n << 24, Q - 1 | 0){
                                                case 6:
                                                    c |= a[I + 6 | 0] << 16;
                                                case 5:
                                                    c |= a[I + 5 | 0] << 8;
                                                case 4:
                                                    c |= a[I + 4 | 0];
                                                case 3:
                                                    s |= (g = a[I + 3 | 0]) << 24, c |= C = g >>> 8 | 0;
                                                case 2:
                                                    s |= (C = a[I + 2 | 0]) << 16, c |= g = C >>> 16 | 0;
                                                case 1:
                                                    s |= (g = a[I + 1 | 0]) << 8, c |= C = g >>> 24 | 0;
                                                case 0:
                                                    s = a[0 | I] | s;
                                            }
                                            return I = A, C = DA(B = D ^ s, A = o ^ c, 16), A = A + f | 0, r = A = (D = B + i | 0) >>> 0 < i >>> 0 ? A + 1 | 0 : A, y = DA(B = C ^ D, A ^= g = h, 21), o = h, g = t + S | 0, C = g = (i = k + F | 0) >>> 0 < F >>> 0 ? g + 1 | 0 : g, w = B, B = DA(i, g, 32), g = h + A | 0, A = o, o = g = B >>> 0 > (f = w + B | 0) >>> 0 ? g + 1 | 0 : g, e = DA(B = f ^ y, A ^= g, 16), y = h, n = DA(F, S, 13) ^ i, C = (w = h ^ C) + r | 0, r = B, B = DA(g = (i = n) + D | 0, C = g >>> 0 < i >>> 0 ? C + 1 | 0 : C, 32), A = h + A | 0, t = DA(i = e ^ (D = r + B | 0), B = (r = B >>> 0 > D >>> 0 ? A + 1 | 0 : A) ^ y, 21), y = h, e = DA(n, w, 17) ^ g, g = (n = h ^ C) + o | 0, A = g = (C = f = (A = e) + f | 0) >>> 0 < A >>> 0 ? g + 1 | 0 : g, o = i, i = DA(C, g, 32), g = h + B | 0, w = g = (o = i >>> 0 > (f = o + i | 0) >>> 0 ? g + 1 | 0 : g) ^ y, y = DA(t ^= f, g, 16), i = h, e = DA(e, n, 13) ^ C, A = (n = A ^ h) + r | 0, C = A = (g = e) >>> 0 > (B = g + D | 0) >>> 0 ? A + 1 | 0 : A, A = DA(B, A, 32), g = w + h | 0, w = g = (r = i) ^ (i = (A = t + (255 ^ A) | 0) >>> 0 < t >>> 0 ? g + 1 | 0 : g), D = A, y = DA(t = y ^ A, g, 21), r = h, e = DA(e, n, 17) ^ B, g = (n = C ^ h) + (o ^ c) | 0, C = g = (A = f ^ s) >>> 0 > (B = e + A | 0) >>> 0 ? g + 1 | 0 : g, A = DA(B, g, 32), g = w + h | 0, w = g = (o = (A = A + t | 0) >>> 0 < t >>> 0 ? g + 1 | 0 : g) ^ r, r = A, y = DA(t = y ^ A, g, 16), f = h, e = DA(e, n, 13) ^ B, A = i + (c = h ^ C) | 0, A = DA(B = D + e | 0, g = A = B >>> 0 < D >>> 0 ? A + 1 | 0 : A, 32), C = w + h | 0, n = C = (i = (A = A + t | 0) >>> 0 < t >>> 0 ? C + 1 | 0 : C) ^ f, f = A, w = DA(t = y ^ A, C, 21), y = h, A = DA(e, c, 17), g = o + (c = g ^ h) | 0, C = g = (B = r + (D = A ^ B) | 0) >>> 0 < r >>> 0 ? g + 1 | 0 : g, A = DA(B, g, 32), g = n + h | 0, r = A = A + t | 0, o = g = A >>> 0 < t >>> 0 ? g + 1 | 0 : g, n = DA(e = w ^ A, g ^= y, 16), w = h, A = DA(D, c, 13), C = i + (y = C ^ h) | 0, A = DA(i = f + (c = A ^ B) | 0, C = i >>> 0 < f >>> 0 ? C + 1 | 0 : C, 32), g = g + h | 0, D = A = A + e | 0, f = g = A >>> 0 < e >>> 0 ? g + 1 | 0 : g, e = DA(B = n ^ A, A = g ^ w, 21), n = h, c = DA(c, y, 17), g = o + (w = C ^ h) | 0, y = i ^ c, i = B, B = DA(C = r + y | 0, g = C >>> 0 < r >>> 0 ? g + 1 | 0 : g, 32), A = h + A | 0, n = DA(i = e ^ (r = i + B | 0), B = (o = B >>> 0 > r >>> 0 ? A + 1 | 0 : A) ^ n, 16), c = h, A = DA(y, w, 13), g = f + (w = g ^ h) | 0, A = g = (C = D + (y = A ^ C) | 0) >>> 0 < D >>> 0 ? g + 1 | 0 : g, f = DA(C, g, 32), g = h + B | 0, c = DA(n ^ (B = i = f + i | 0), (g = B >>> 0 < f >>> 0 ? g + 1 | 0 : g) ^ c, 21), D = h, i = DA(y, w, 17) ^ C, f = DA(i, A ^= h, 13), A = A + o | 0, C = A = h ^ ((i = i + r | 0) >>> 0 < r >>> 0 ? A + 1 | 0 : A), i = DA(o = i ^ f, A, 17) ^ c, A = h ^ D, C = g + C | 0, g = DA(g = B + o | 0, C = g >>> 0 < B >>> 0 ? C + 1 | 0 : C, 32) ^ i ^ g, E[0 | I] = g, E[I + 1 | 0] = g >>> 8, E[I + 2 | 0] = g >>> 16, E[I + 3 | 0] = g >>> 24, A ^= C ^ h, E[I + 4 | 0] = A, E[I + 5 | 0] = A >>> 8, E[I + 6 | 0] = A >>> 16, E[I + 7 | 0] = A >>> 24, 0;
                                        },
                                        Gb: function(A) {
                                            HA(A |= 0, 16);
                                        },
                                        Hb: EI,
                                        Ib: eI,
                                        Jb: aI,
                                        Kb: aI,
                                        Lb: eI,
                                        Mb: function() {
                                            return -65;
                                        },
                                        Nb: function(A, I, g) {
                                            A |= 0;
                                            var C, B, Q, i, o = 0, f = 0, c = 0, e = 0, r = 0;
                                            return w = Q = w - 160 | 0, aA(I |= 0, g |= 0, 32, 0), E[0 | I] = 248 & a[0 | I], E[I + 31 | 0] = 63 & a[I + 31 | 0] | 64, u(Q, I), MA(A, Q), f = a[(B = g) + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, o = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, c = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, e = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, r = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, g = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, i = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, C = I, I = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, E[C + 24 | 0] = I, E[C + 25 | 0] = I >>> 8, E[C + 26 | 0] = I >>> 16, E[C + 27 | 0] = I >>> 24, E[C + 28 | 0] = i, E[C + 29 | 0] = i >>> 8, E[C + 30 | 0] = i >>> 16, E[C + 31 | 0] = i >>> 24, E[C + 16 | 0] = c, E[C + 17 | 0] = c >>> 8, E[C + 18 | 0] = c >>> 16, E[C + 19 | 0] = c >>> 24, E[C + 20 | 0] = e, E[C + 21 | 0] = e >>> 8, E[C + 22 | 0] = e >>> 16, E[C + 23 | 0] = e >>> 24, E[C + 8 | 0] = f, E[C + 9 | 0] = f >>> 8, E[C + 10 | 0] = f >>> 16, E[C + 11 | 0] = f >>> 24, E[C + 12 | 0] = o, E[C + 13 | 0] = o >>> 8, E[C + 14 | 0] = o >>> 16, E[C + 15 | 0] = o >>> 24, E[0 | C] = r, E[C + 1 | 0] = r >>> 8, E[C + 2 | 0] = r >>> 16, E[C + 3 | 0] = r >>> 24, E[C + 4 | 0] = g, E[C + 5 | 0] = g >>> 8, E[C + 6 | 0] = g >>> 16, E[C + 7 | 0] = g >>> 24, c = a[(o = A) + 8 | 0] | a[o + 9 | 0] << 8 | a[o + 10 | 0] << 16 | a[o + 11 | 0] << 24, e = a[o + 12 | 0] | a[o + 13 | 0] << 8 | a[o + 14 | 0] << 16 | a[o + 15 | 0] << 24, r = a[o + 16 | 0] | a[o + 17 | 0] << 8 | a[o + 18 | 0] << 16 | a[o + 19 | 0] << 24, g = a[o + 20 | 0] | a[o + 21 | 0] << 8 | a[o + 22 | 0] << 16 | a[o + 23 | 0] << 24, I = a[0 | o] | a[o + 1 | 0] << 8 | a[o + 2 | 0] << 16 | a[o + 3 | 0] << 24, A = a[o + 4 | 0] | a[o + 5 | 0] << 8 | a[o + 6 | 0] << 16 | a[o + 7 | 0] << 24, f = a[o + 28 | 0] | a[o + 29 | 0] << 8 | a[o + 30 | 0] << 16 | a[o + 31 | 0] << 24, o = a[o + 24 | 0] | a[o + 25 | 0] << 8 | a[o + 26 | 0] << 16 | a[o + 27 | 0] << 24, E[C + 56 | 0] = o, E[C + 57 | 0] = o >>> 8, E[C + 58 | 0] = o >>> 16, E[C + 59 | 0] = o >>> 24, E[C + 60 | 0] = f, E[C + 61 | 0] = f >>> 8, E[C + 62 | 0] = f >>> 16, E[C + 63 | 0] = f >>> 24, E[C + 48 | 0] = r, E[C + 49 | 0] = r >>> 8, E[C + 50 | 0] = r >>> 16, E[C + 51 | 0] = r >>> 24, E[C + 52 | 0] = g, E[C + 53 | 0] = g >>> 8, E[C + 54 | 0] = g >>> 16, E[C + 55 | 0] = g >>> 24, E[C + 40 | 0] = c, E[C + 41 | 0] = c >>> 8, E[C + 42 | 0] = c >>> 16, E[C + 43 | 0] = c >>> 24, E[C + 44 | 0] = e, E[C + 45 | 0] = e >>> 8, E[C + 46 | 0] = e >>> 16, E[C + 47 | 0] = e >>> 24, E[C + 32 | 0] = I, E[C + 33 | 0] = I >>> 8, E[C + 34 | 0] = I >>> 16, E[C + 35 | 0] = I >>> 24, E[C + 36 | 0] = A, E[C + 37 | 0] = A >>> 8, E[C + 38 | 0] = A >>> 16, E[C + 39 | 0] = A >>> 24, w = Q + 160 | 0, 0;
                                        },
                                        Ob: function(A, I) {
                                            A |= 0, I |= 0;
                                            var g, C, B, Q, i, f = 0, c = 0, e = 0;
                                            return w = c = w - 192 | 0, HA(c, 32), aA(I, c, 32, 0), E[0 | I] = 248 & a[0 | I], E[I + 31 | 0] = 63 & a[I + 31 | 0] | 64, u(e = c + 32 | 0, I), MA(A, e), g = c, e = o[c + 28 >> 2], c = o[c + 24 >> 2], E[I + 24 | 0] = c, E[I + 25 | 0] = c >>> 8, E[I + 26 | 0] = c >>> 16, E[I + 27 | 0] = c >>> 24, E[I + 28 | 0] = e, E[I + 29 | 0] = e >>> 8, E[I + 30 | 0] = e >>> 16, E[I + 31 | 0] = e >>> 24, e = o[g + 20 >> 2], c = o[g + 16 >> 2], E[I + 16 | 0] = c, E[I + 17 | 0] = c >>> 8, E[I + 18 | 0] = c >>> 16, E[I + 19 | 0] = c >>> 24, E[I + 20 | 0] = e, E[I + 21 | 0] = e >>> 8, E[I + 22 | 0] = e >>> 16, E[I + 23 | 0] = e >>> 24, e = o[g + 12 >> 2], c = o[g + 8 >> 2], E[I + 8 | 0] = c, E[I + 9 | 0] = c >>> 8, E[I + 10 | 0] = c >>> 16, E[I + 11 | 0] = c >>> 24, E[I + 12 | 0] = e, E[I + 13 | 0] = e >>> 8, E[I + 14 | 0] = e >>> 16, E[I + 15 | 0] = e >>> 24, e = o[g + 4 >> 2], c = o[g >> 2], E[0 | I] = c, E[I + 1 | 0] = c >>> 8, E[I + 2 | 0] = c >>> 16, E[I + 3 | 0] = c >>> 24, E[I + 4 | 0] = e, E[I + 5 | 0] = e >>> 8, E[I + 6 | 0] = e >>> 16, E[I + 7 | 0] = e >>> 24, C = a[(f = A) + 8 | 0] | a[f + 9 | 0] << 8 | a[f + 10 | 0] << 16 | a[f + 11 | 0] << 24, B = a[f + 12 | 0] | a[f + 13 | 0] << 8 | a[f + 14 | 0] << 16 | a[f + 15 | 0] << 24, Q = a[f + 16 | 0] | a[f + 17 | 0] << 8 | a[f + 18 | 0] << 16 | a[f + 19 | 0] << 24, e = a[f + 20 | 0] | a[f + 21 | 0] << 8 | a[f + 22 | 0] << 16 | a[f + 23 | 0] << 24, c = a[0 | f] | a[f + 1 | 0] << 8 | a[f + 2 | 0] << 16 | a[f + 3 | 0] << 24, A = a[f + 4 | 0] | a[f + 5 | 0] << 8 | a[f + 6 | 0] << 16 | a[f + 7 | 0] << 24, i = a[f + 28 | 0] | a[f + 29 | 0] << 8 | a[f + 30 | 0] << 16 | a[f + 31 | 0] << 24, f = a[f + 24 | 0] | a[f + 25 | 0] << 8 | a[f + 26 | 0] << 16 | a[f + 27 | 0] << 24, E[I + 56 | 0] = f, E[I + 57 | 0] = f >>> 8, E[I + 58 | 0] = f >>> 16, E[I + 59 | 0] = f >>> 24, E[I + 60 | 0] = i, E[I + 61 | 0] = i >>> 8, E[I + 62 | 0] = i >>> 16, E[I + 63 | 0] = i >>> 24, E[I + 48 | 0] = Q, E[I + 49 | 0] = Q >>> 8, E[I + 50 | 0] = Q >>> 16, E[I + 51 | 0] = Q >>> 24, E[I + 52 | 0] = e, E[I + 53 | 0] = e >>> 8, E[I + 54 | 0] = e >>> 16, E[I + 55 | 0] = e >>> 24, E[I + 40 | 0] = C, E[I + 41 | 0] = C >>> 8, E[I + 42 | 0] = C >>> 16, E[I + 43 | 0] = C >>> 24, E[I + 44 | 0] = B, E[I + 45 | 0] = B >>> 8, E[I + 46 | 0] = B >>> 16, E[I + 47 | 0] = B >>> 24, E[I + 32 | 0] = c, E[I + 33 | 0] = c >>> 8, E[I + 34 | 0] = c >>> 16, E[I + 35 | 0] = c >>> 24, E[I + 36 | 0] = A, E[I + 37 | 0] = A >>> 8, E[I + 38 | 0] = A >>> 16, E[I + 39 | 0] = A >>> 24, iI(g, 32), w = g + 192 | 0, 0;
                                        },
                                        Pb: function(A, I, g, C, B, Q) {
                                            I |= 0, B |= 0, Q |= 0;
                                            var i, E = 0;
                                            return w = i = w - 16 | 0, s(A |= 0, i + 8 | 0, pA(A - -64 | 0, g |= 0, C |= 0), C, B, Q, 0), 64 != o[i + 8 >> 2] | o[i + 12 >> 2] ? (I && (o[I >> 2] = 0, o[I + 4 >> 2] = 0), dA(A, 0, C - -64 | 0), E = -1) : I && (o[I >> 2] = C - -64, o[I + 4 >> 2] = B - ((C >>> 0 < 4294967232) - 1 | 0)), w = i + 16 | 0, 0 | E;
                                        },
                                        Qb: function(A, I, g, C, B, Q) {
                                            A |= 0, I |= 0, g |= 0;
                                            var i = 0;
                                            A: {
                                                I: {
                                                    if (i = C |= 0, !(!(B |= 0) & C >>> 0 < 64 || (C = B - 1 | 0, !(C = (B = i + -64 | 0) >>> 0 < 4294967232 ? C + 1 | 0 : C) & B >>> 0 > 4294967231 | C))) {
                                                        if (!S(g, i = g - -64 | 0, B, C, Q |= 0, 0)) break I;
                                                        A && dA(A, 0, B);
                                                    }
                                                    if (g = -1, !I) break A;
                                                    o[I >> 2] = 0, o[I + 4 >> 2] = 0;
                                                    break A;
                                                }
                                                I && (o[I >> 2] = B, o[I + 4 >> 2] = C), g = 0, A && pA(A, i, B);
                                            }
                                            return 0 | g;
                                        },
                                        Rb: function(A, I, g, C, B, Q) {
                                            return s(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, 0), 0;
                                        },
                                        Sb: function(A, I, g, C, B) {
                                            return 0 | S(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, 0);
                                        },
                                        Tb: function(A) {
                                            return cA(A |= 0), 0;
                                        },
                                        Ub: function(A, I, g, C) {
                                            return 0 | R(A |= 0, I |= 0, g |= 0, C |= 0);
                                        },
                                        Vb: function(A, I, g, C) {
                                            var B;
                                            return I |= 0, g |= 0, C |= 0, w = B = w + -64 | 0, N(A |= 0, B), A = s(I, g, B, 64, 0, C, 1), w = B - -64 | 0, 0 | A;
                                        },
                                        Wb: function(A, I, g) {
                                            var C;
                                            return I |= 0, g |= 0, w = C = w + -64 | 0, N(A |= 0, C), A = S(I, C, 64, 0, g, 1), w = C - -64 | 0, 0 | A;
                                        },
                                        Xb: function(A, I) {
                                            A |= 0;
                                            var g, C = 0, B = 0, Q = 0, i = 0, a = 0, f = 0, e = 0, r = 0, D = 0, t = 0, y = 0, n = 0, s = 0, k = 0, F = 0, S = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, Y = 0, d = 0, K = 0, v = 0, L = 0, R = 0, u = 0, x = 0, m = 0, l = 0, z = 0, q = 0, X = 0, j = 0, T = 0, V = 0, Z = 0, $ = 0, AA = 0, gA = 0, CA = 0, BA = 0, QA = 0, iA = 0, EA = 0, oA = 0, aA = 0, cA = 0, eA = 0, DA = 0, tA = 0, yA = 0, wA = 0, hA = 0, nA = 0, sA = 0, FA = 0, SA = 0, HA = 0, GA = 0, _A = 0, MA = 0, pA = 0, NA = 0, JA = 0, UA = 0, YA = 0, KA = 0, bA = 0, PA = 0, vA = 0, LA = 0, RA = 0, uA = 0, xA = 0, mA = 0, lA = 0, zA = 0, qA = 0;
                                            if (w = g = w - 256 | 0, vA = -1, !rA(I |= 0) && !U(C = g + 96 | 0, I)) {
                                                for(w = Q = w - 2048 | 0, W(i = Q + 640 | 0, C), C = o[(I = C) + 36 >> 2], o[Q + 352 >> 2] = o[I + 32 >> 2], o[Q + 356 >> 2] = C, C = o[I + 28 >> 2], o[Q + 344 >> 2] = o[I + 24 >> 2], o[Q + 348 >> 2] = C, C = o[I + 20 >> 2], o[Q + 336 >> 2] = o[I + 16 >> 2], o[Q + 340 >> 2] = C, C = o[I + 12 >> 2], o[Q + 328 >> 2] = o[I + 8 >> 2], o[Q + 332 >> 2] = C, C = o[I + 4 >> 2], o[Q + 320 >> 2] = o[I >> 2], o[Q + 324 >> 2] = C, C = o[I + 52 >> 2], o[Q + 368 >> 2] = o[I + 48 >> 2], o[Q + 372 >> 2] = C, C = o[I + 60 >> 2], o[Q + 376 >> 2] = o[I + 56 >> 2], o[Q + 380 >> 2] = C, B = o[4 + (C = I - -64 | 0) >> 2], o[Q + 384 >> 2] = o[C >> 2], o[Q + 388 >> 2] = B, C = o[I + 76 >> 2], o[Q + 392 >> 2] = o[I + 72 >> 2], o[Q + 396 >> 2] = C, C = o[I + 44 >> 2], o[Q + 360 >> 2] = o[I + 40 >> 2], o[Q + 364 >> 2] = C, C = o[I + 92 >> 2], o[Q + 408 >> 2] = o[I + 88 >> 2], o[Q + 412 >> 2] = C, C = o[I + 100 >> 2], o[Q + 416 >> 2] = o[I + 96 >> 2], o[Q + 420 >> 2] = C, C = o[I + 108 >> 2], o[Q + 424 >> 2] = o[I + 104 >> 2], o[Q + 428 >> 2] = C, C = o[I + 116 >> 2], o[Q + 432 >> 2] = o[I + 112 >> 2], o[Q + 436 >> 2] = C, C = o[I + 84 >> 2], o[Q + 400 >> 2] = o[I + 80 >> 2], o[Q + 404 >> 2] = C, G(I = Q + 480 | 0, C = Q + 320 | 0), H(B = Q + 160 | 0, I, f = Q + 600 | 0), H(Q + 200 | 0, r = Q + 520 | 0, D = Q + 560 | 0), H(Q + 240 | 0, D, f), H(Q + 280 | 0, I, r), b(I, B, i), H(C, I, f), H(F = Q + 360 | 0, r, D), H(S = Q + 400 | 0, D, f), H(n = Q + 440 | 0, I, r), W(i = Q + 800 | 0, C), b(I, B, i), H(C, I, f), H(F, r, D), H(S, D, f), H(n, I, r), W(i = Q + 960 | 0, C), b(I, B, i), H(C, I, f), H(F, r, D), H(S, D, f), H(n, I, r), W(i = Q + 1120 | 0, C), b(I, B, i), H(C, I, f), H(F, r, D), H(S, D, f), H(n, I, r), W(i = Q + 1280 | 0, C), b(I, B, i), H(C, I, f), H(F, r, D), H(S, D, f), H(n, I, r), W(i = Q + 1440 | 0, C), b(I, B, i), H(C, I, f), H(F, r, D), H(S, D, f), H(n, I, r), W(i = Q + 1600 | 0, C), b(I, B, i), H(C, I, f), H(F, r, D), H(S, D, f), H(n, I, r), W(Q + 1760 | 0, C), o[Q + 32 >> 2] = 0, o[Q + 36 >> 2] = 0, o[Q + 24 >> 2] = 0, o[Q + 28 >> 2] = 0, o[Q + 16 >> 2] = 0, o[Q + 20 >> 2] = 0, o[Q + 8 >> 2] = 0, o[Q + 12 >> 2] = 0, o[Q + 44 >> 2] = 0, o[Q + 48 >> 2] = 0, o[Q + 52 >> 2] = 0, o[Q + 56 >> 2] = 0, o[Q + 60 >> 2] = 0, o[Q + 64 >> 2] = 0, o[Q + 68 >> 2] = 0, o[Q + 72 >> 2] = 0, o[Q + 76 >> 2] = 0, o[Q + 80 >> 2] = 1, o[Q >> 2] = 0, o[Q + 4 >> 2] = 0, o[Q + 40 >> 2] = 1, dA(Q + 84 | 0, 0, 76), t = Q + 120 | 0, k = Q + 2008 | 0, s = Q + 1968 | 0, C = Q + 80 | 0, B = Q + 40 | 0, i = 252; a = o[Q + 36 >> 2], o[(I = Q + 1960 | 0) >> 2] = o[Q + 32 >> 2], o[I + 4 >> 2] = a, a = o[Q + 28 >> 2], o[(I = Q + 1952 | 0) >> 2] = o[Q + 24 >> 2], o[I + 4 >> 2] = a, a = o[Q + 20 >> 2], o[(I = Q + 1944 | 0) >> 2] = o[Q + 16 >> 2], o[I + 4 >> 2] = a, a = o[Q + 12 >> 2], o[(I = Q + 1936 | 0) >> 2] = o[Q + 8 >> 2], o[I + 4 >> 2] = a, I = o[Q + 4 >> 2], o[Q + 1928 >> 2] = o[Q >> 2], o[Q + 1932 >> 2] = I, a = o[(I = B) + 36 >> 2], o[s + 32 >> 2] = o[I + 32 >> 2], o[s + 36 >> 2] = a, a = o[I + 28 >> 2], o[s + 24 >> 2] = o[I + 24 >> 2], o[s + 28 >> 2] = a, a = o[I + 20 >> 2], o[s + 16 >> 2] = o[I + 16 >> 2], o[s + 20 >> 2] = a, a = o[I + 12 >> 2], o[s + 8 >> 2] = o[I + 8 >> 2], o[s + 12 >> 2] = a, a = o[I + 4 >> 2], o[s >> 2] = o[I >> 2], o[s + 4 >> 2] = a, a = o[(I = C) + 36 >> 2], o[k + 32 >> 2] = o[I + 32 >> 2], o[k + 36 >> 2] = a, a = o[I + 28 >> 2], o[k + 24 >> 2] = o[I + 24 >> 2], o[k + 28 >> 2] = a, a = o[I + 20 >> 2], o[k + 16 >> 2] = o[I + 16 >> 2], o[k + 20 >> 2] = a, a = o[I + 12 >> 2], o[k + 8 >> 2] = o[I + 8 >> 2], o[k + 12 >> 2] = a, a = o[I + 4 >> 2], o[k >> 2] = o[I >> 2], o[k + 4 >> 2] = a, i = E[(I = i) + 33424 | 0], G(a = Q + 480 | 0, Q + 1928 | 0), (0 | i) > 0 ? (H(M = Q + 320 | 0, a, f), H(F, r, D), H(S, D, f), H(n, a, r), b(a, M, (Q + 640 | 0) + c((254 & i) >>> 1 | 0, 160) | 0)) : (0 | i) >= 0 || (H(M = Q + 320 | 0, a = Q + 480 | 0, f), H(F, r, D), H(S, D, f), H(n, a, r), P(a, M, (Q + 640 | 0) + c((0 - i & 254) >>> 1 | 0, 160) | 0)), H(Q, i = Q + 480 | 0, f), H(B, r, D), H(C, D, f), H(t, i, r), i = I - 1 | 0, I;);
                                                IA(I = Q + 640 | 0, Q), I = fA(I, 32), w = Q + 2048 | 0, I && (Q = o[g + 136 >> 2], o[g >> 2] = 1 - Q, vA = 0, z = o[g + 172 >> 2], o[g + 36 >> 2] = 0 - z, F = o[g + 168 >> 2], o[g + 32 >> 2] = 0 - F, q = o[g + 164 >> 2], o[g + 28 >> 2] = 0 - q, r = o[g + 160 >> 2], o[g + 24 >> 2] = 0 - r, X = o[g + 156 >> 2], o[g + 20 >> 2] = 0 - X, D = o[g + 152 >> 2], o[g + 16 >> 2] = 0 - D, j = o[g + 148 >> 2], o[g + 12 >> 2] = 0 - j, k = o[g + 144 >> 2], o[g + 8 >> 2] = 0 - k, T = o[g + 140 >> 2], o[g + 4 >> 2] = 0 - T, O(g, g), I = kA(S = o[g + 4 >> 2], x = S >> 31, Y = X << 1, cA = Y >> 31), C = h, B = kA(f = o[g >> 2], d = f >> 31, r, K = r >> 31), C = h + C | 0, C = (I = B + I | 0) >>> 0 < B >>> 0 ? C + 1 | 0 : C, B = (i = kA(a = o[g + 8 >> 2], V = a >> 31, D, v = D >> 31)) + I | 0, I = h + C | 0, I = B >>> 0 < i >>> 0 ? I + 1 | 0 : I, C = B, B = kA(m = o[g + 12 >> 2], AA = m >> 31, BA = j << 1, eA = BA >> 31), I = h + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = kA(Z = o[g + 16 >> 2], QA = Z >> 31, k, L = k >> 31), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, JA = i = o[g + 20 >> 2], s = kA(i, DA = i >> 31, iA = T << 1, tA = iA >> 31), B = h + I | 0, B = (C = s + C | 0) >>> 0 < s >>> 0 ? B + 1 | 0 : B, UA = p = o[g + 24 >> 2], I = (Q = kA(p, MA = p >> 31, s = Q + 1 | 0, R = s >> 31)) + C | 0, C = h + B | 0, C = I >>> 0 < Q >>> 0 ? C + 1 | 0 : C, yA = o[g + 28 >> 2], B = (Q = kA(M = c(yA, 19), gA = M >> 31, EA = z << 1, wA = EA >> 31)) + I | 0, I = h + C | 0, I = B >>> 0 < Q >>> 0 ? I + 1 | 0 : I, C = B, LA = o[g + 32 >> 2], B = kA(t = c(LA, 19), $ = t >> 31, F, u = F >> 31), I = h + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, RA = o[g + 36 >> 2], B = kA(n = c(RA, 19), l = n >> 31, oA = q << 1, hA = oA >> 31), I = h + I | 0, y = C = B + C | 0, Q = C >>> 0 < B >>> 0 ? I + 1 | 0 : I, I = kA(D, v, S, x), C = h, e = kA(f, d, X, nA = X >> 31), B = h + C | 0, B = (I = e + I | 0) >>> 0 < e >>> 0 ? B + 1 | 0 : B, e = kA(a, V, j, sA = j >> 31), C = h + B | 0, C = (I = e + I | 0) >>> 0 < e >>> 0 ? C + 1 | 0 : C, B = (e = kA(k, L, m, AA)) + I | 0, I = h + C | 0, I = B >>> 0 < e >>> 0 ? I + 1 | 0 : I, C = B, B = kA(Z, QA, T, FA = T >> 31), I = h + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = kA(s, R, i, DA), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, e = kA(p = c(p, 19), aA = p >> 31, z, SA = z >> 31), B = h + I | 0, B = (C = e + C | 0) >>> 0 < e >>> 0 ? B + 1 | 0 : B, I = (e = kA(F, u, M, gA)) + C | 0, C = h + B | 0, C = I >>> 0 < e >>> 0 ? C + 1 | 0 : C, B = (e = kA(t, $, q, HA = q >> 31)) + I | 0, I = h + C | 0, I = B >>> 0 < e >>> 0 ? I + 1 | 0 : I, C = B, B = kA(r, K, n, l), I = h + I | 0, YA = C = C + B | 0, CA = C >>> 0 < B >>> 0 ? I + 1 | 0 : I, I = kA(S, x, BA, eA), B = h, C = (e = kA(f, d, D, v)) + I | 0, I = h + B | 0, I = C >>> 0 < e >>> 0 ? I + 1 | 0 : I, e = kA(k, L, a, V), B = h + I | 0, B = (C = e + C | 0) >>> 0 < e >>> 0 ? B + 1 | 0 : B, I = (e = kA(m, AA, iA, tA)) + C | 0, C = h + B | 0, C = I >>> 0 < e >>> 0 ? C + 1 | 0 : C, B = (e = kA(s, R, Z, QA)) + I | 0, I = h + C | 0, I = B >>> 0 < e >>> 0 ? I + 1 | 0 : I, C = B, B = kA(e = c(i, 19), GA = e >> 31, EA, wA), I = h + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = kA(F, u, p, aA), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, i = kA(M, gA, oA, hA), B = h + I | 0, B = (C = i + C | 0) >>> 0 < i >>> 0 ? B + 1 | 0 : B, I = (i = kA(r, K, t, $)) + C | 0, C = h + B | 0, C = I >>> 0 < i >>> 0 ? C + 1 | 0 : C, B = (i = kA(n, l, Y, cA)) + I | 0, I = h + C | 0, uA = B, xA = I = B >>> 0 < i >>> 0 ? I + 1 | 0 : I, mA = B = B + 33554432 | 0, lA = I = B >>> 0 < 33554432 ? I + 1 | 0 : I, B = (67108863 & I) << 6 | B >>> 26, I = (I >> 26) + CA | 0, YA = i = B + YA | 0, I = B >>> 0 > i >>> 0 ? I + 1 | 0 : I, zA = i = i + 16777216 | 0, I = (C = (B = i >>> 0 < 16777216 ? I + 1 | 0 : I) >> 25) + Q | 0, I = (B = (i = (33554431 & B) << 7 | i >>> 25) + y | 0) >>> 0 < i >>> 0 ? I + 1 | 0 : I, J = C = B + 33554432 | 0, i = I = C >>> 0 < 33554432 ? I + 1 | 0 : I, o[g + 72 >> 2] = B - (-67108864 & C), I = kA(S, x, iA, tA), C = h, Q = kA(f, d, k, L), B = h + C | 0, B = (I = Q + I | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, C = (Q = kA(s, R, a, V)) + I | 0, I = h + B | 0, I = C >>> 0 < Q >>> 0 ? I + 1 | 0 : I, B = kA(Q = c(m, 19), _A = Q >> 31, EA, wA), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (y = kA(CA = c(Z, 19), pA = CA >> 31, F, u)) + C | 0, C = h + I | 0, C = B >>> 0 < y >>> 0 ? C + 1 | 0 : C, y = kA(oA, hA, e, GA), I = h + C | 0, I = (B = y + B | 0) >>> 0 < y >>> 0 ? I + 1 | 0 : I, C = (y = kA(r, K, p, aA)) + B | 0, B = h + I | 0, B = C >>> 0 < y >>> 0 ? B + 1 | 0 : B, y = kA(M, gA, Y, cA), I = h + B | 0, I = (C = y + C | 0) >>> 0 < y >>> 0 ? I + 1 | 0 : I, B = kA(D, v, t, $), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (y = kA(n, l, BA, eA)) + C | 0, C = h + I | 0, N = B, KA = B >>> 0 < y >>> 0 ? C + 1 | 0 : C, I = kA(s, R, S, x), C = h, B = (y = kA(f, d, T, FA)) + I | 0, I = h + C | 0, I = B >>> 0 < y >>> 0 ? I + 1 | 0 : I, y = C = c(a, 19), C = (_ = kA(C, NA = C >> 31, z, SA)) + B | 0, B = h + I | 0, B = C >>> 0 < _ >>> 0 ? B + 1 | 0 : B, _ = kA(Q, _A, F, u), I = h + B | 0, I = (C = _ + C | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, B = kA(CA, pA, q, HA), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (_ = kA(r, K, e, GA)) + C | 0, C = h + I | 0, C = B >>> 0 < _ >>> 0 ? C + 1 | 0 : C, _ = kA(p, aA, X, nA), I = h + C | 0, I = (B = _ + B | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, C = (_ = kA(D, v, M, gA)) + B | 0, B = h + I | 0, B = C >>> 0 < _ >>> 0 ? B + 1 | 0 : B, _ = kA(t, $, j, sA), I = h + B | 0, I = (C = _ + C | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, B = kA(k, L, n, l), I = h + I | 0, bA = C = B + C | 0, _ = C >>> 0 < B >>> 0 ? I + 1 | 0 : I, I = kA(I = c(S, 19), I >> 31, EA, wA), C = h, B = kA(f, d, s, R), C = h + C | 0, C = (I = B + I | 0) >>> 0 < B >>> 0 ? C + 1 | 0 : C, B = (y = kA(y, NA, F, u)) + I | 0, I = h + C | 0, C = (Q = kA(Q, _A, oA, hA)) + B | 0, B = h + (B >>> 0 < y >>> 0 ? I + 1 | 0 : I) | 0, B = C >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = kA(r, K, CA, pA), I = h + B | 0, I = (C = Q + C | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, B = kA(Y, cA, e, GA), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (Q = kA(D, v, p, aA)) + C | 0, C = h + I | 0, C = B >>> 0 < Q >>> 0 ? C + 1 | 0 : C, Q = kA(M, gA, BA, eA), I = h + C | 0, I = (B = Q + B | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, C = (Q = kA(k, L, t, $)) + B | 0, B = h + I | 0, B = C >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = kA(n, l, iA, tA), I = h + B | 0, y = C = Q + C | 0, _A = I = C >>> 0 < Q >>> 0 ? I + 1 | 0 : I, NA = C = C + 33554432 | 0, qA = I = C >>> 0 < 33554432 ? I + 1 | 0 : I, B = I >> 26, I = (67108863 & I) << 6 | C >>> 26, C = B + _ | 0, _ = Q = I + bA | 0, I = C = I >>> 0 > Q >>> 0 ? C + 1 | 0 : C, bA = Q = Q + 16777216 | 0, Q = (33554431 & (I = Q >>> 0 < 16777216 ? I + 1 | 0 : I)) << 7 | Q >>> 25, I = (I >> 25) + KA | 0, I = (C = Q + N | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, B = C, KA = C = C + 33554432 | 0, Q = I = C >>> 0 < 33554432 ? I + 1 | 0 : I, o[g + 56 >> 2] = B - (-67108864 & C), I = kA(r, K, S, x), B = h, C = (N = kA(f, d, q, HA)) + I | 0, I = h + B | 0, I = C >>> 0 < N >>> 0 ? I + 1 | 0 : I, B = kA(a, V, X, nA), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = kA(D, v, m, AA), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, N = kA(Z, QA, j, sA), B = h + I | 0, B = (C = N + C | 0) >>> 0 < N >>> 0 ? B + 1 | 0 : B, I = (N = kA(k, L, JA, DA)) + C | 0, C = h + B | 0, C = I >>> 0 < N >>> 0 ? C + 1 | 0 : C, B = (N = kA(T, FA, UA, MA)) + I | 0, I = h + C | 0, I = B >>> 0 < N >>> 0 ? I + 1 | 0 : I, C = B, B = kA(yA, PA = yA >> 31, s, R), I = h + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = kA(t, $, z, SA), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, N = (B = C) + (C = kA(F, u, n, l)) | 0, B = h + I | 0, C = (I = i >> 26) + (C = C >>> 0 > N >>> 0 ? B + 1 | 0 : B) | 0, J = B = (i = (67108863 & i) << 6 | J >>> 26) + N | 0, I = C = B >>> 0 < i >>> 0 ? C + 1 | 0 : C, N = B = B + 16777216 | 0, i = I = B >>> 0 < 16777216 ? I + 1 | 0 : I, o[g + 76 >> 2] = J - (-33554432 & B), I = kA(k, L, S, x), C = h, J = kA(f, d, j, sA), B = h + C | 0, B = (I = J + I | 0) >>> 0 < J >>> 0 ? B + 1 | 0 : B, J = kA(a, V, T, FA), C = h + B | 0, C = (I = J + I | 0) >>> 0 < J >>> 0 ? C + 1 | 0 : C, B = (J = kA(s, R, m, AA)) + I | 0, I = h + C | 0, I = B >>> 0 < J >>> 0 ? I + 1 | 0 : I, C = B, B = kA(CA, pA, z, SA), I = h + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = kA(F, u, e, GA), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, C = (p = kA(p, aA, q, HA)) + C | 0, B = h + I | 0, I = (M = kA(r, K, M, gA)) + C | 0, C = h + (C >>> 0 < p >>> 0 ? B + 1 | 0 : B) | 0, B = (t = kA(t, $, X, nA)) + I | 0, I = h + (I >>> 0 < M >>> 0 ? C + 1 | 0 : C) | 0, I = B >>> 0 < t >>> 0 ? I + 1 | 0 : I, C = B, B = kA(D, v, n, l), I = h + I | 0, J = C = C + B | 0, I = (I = C >>> 0 < B >>> 0 ? I + 1 | 0 : I) + (C = Q >> 26) | 0, t = Q = J + (B = (67108863 & Q) << 6 | KA >>> 26) | 0, I = B >>> 0 > Q >>> 0 ? I + 1 | 0 : I, M = C = Q + 16777216 | 0, Q = B = C >>> 0 < 16777216 ? I + 1 | 0 : I, o[g + 60 >> 2] = t - (-33554432 & C), I = kA(S, x, oA, hA), B = h, C = (t = kA(f, d, F, u)) + I | 0, I = h + B | 0, I = C >>> 0 < t >>> 0 ? I + 1 | 0 : I, B = kA(r, K, a, V), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, t = kA(m, AA, Y, cA), B = h + I | 0, B = (C = t + C | 0) >>> 0 < t >>> 0 ? B + 1 | 0 : B, I = (t = kA(D, v, Z, QA)) + C | 0, C = h + B | 0, C = I >>> 0 < t >>> 0 ? C + 1 | 0 : C, B = (t = kA(BA, eA, JA, DA)) + I | 0, I = h + C | 0, I = B >>> 0 < t >>> 0 ? I + 1 | 0 : I, C = B, B = kA(k, L, UA, MA), I = h + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = C, C = kA(iA, tA, yA, PA), I = h + I | 0, I = C >>> 0 > (B = B + C | 0) >>> 0 ? I + 1 | 0 : I, t = C = LA, C = (Y = kA(C, p = C >> 31, s, R)) + B | 0, B = h + I | 0, I = (n = kA(n, l, EA, wA)) + C | 0, C = h + (C >>> 0 < Y >>> 0 ? B + 1 | 0 : B) | 0, B = I >>> 0 < n >>> 0 ? C + 1 | 0 : C, C = I, I = (I = i >> 25) + B | 0, I = (C = C + (i = (33554431 & i) << 7 | N >>> 25) | 0) >>> 0 < i >>> 0 ? I + 1 | 0 : I, B = C, n = C = C + 33554432 | 0, i = I = C >>> 0 < 33554432 ? I + 1 | 0 : I, o[g + 80 >> 2] = B - (-67108864 & C), C = Q >> 25, B = (Q = (33554431 & Q) << 7 | M >>> 25) + (uA - (I = -67108864 & mA) | 0) | 0, I = C + (xA - ((I >>> 0 > uA >>> 0) + lA | 0) | 0) | 0, I = B >>> 0 < Q >>> 0 ? I + 1 | 0 : I, I = ((67108863 & (I = (C = B + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I)) << 6 | C >>> 26) + (Y = YA - (-33554432 & zA) | 0) | 0, o[g + 68 >> 2] = I, o[g + 64 >> 2] = B - (-67108864 & C), I = kA(F, u, S, x), B = h, C = (Q = kA(f, d, z, SA)) + I | 0, I = h + B | 0, I = C >>> 0 < Q >>> 0 ? I + 1 | 0 : I, B = (Q = kA(a, V, q, HA)) + C | 0, C = h + I | 0, C = B >>> 0 < Q >>> 0 ? C + 1 | 0 : C, I = (Q = kA(r, K, m, AA)) + B | 0, B = h + C | 0, B = I >>> 0 < Q >>> 0 ? B + 1 | 0 : B, C = (Q = kA(Z, QA, X, nA)) + I | 0, I = h + B | 0, I = C >>> 0 < Q >>> 0 ? I + 1 | 0 : I, B = kA(D, v, JA, DA), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = kA(j, sA, UA, MA), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (Q = kA(k, L, yA, PA)) + C | 0, C = h + I | 0, C = B >>> 0 < Q >>> 0 ? C + 1 | 0 : C, Q = (I = kA(t, p, T, FA)) + B | 0, B = h + C | 0, B = I >>> 0 > Q >>> 0 ? B + 1 | 0 : B, C = Q, Q = kA(I = RA, I >> 31, s, R), I = h + B | 0, B = C = C + Q | 0, I = (I = C >>> 0 < Q >>> 0 ? I + 1 | 0 : I) + (C = i >> 26) | 0, I = (B = B + (i = (67108863 & i) << 6 | n >>> 26) | 0) >>> 0 < i >>> 0 ? I + 1 | 0 : I, I = (C = B + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I, o[g + 84 >> 2] = B - (-33554432 & C), i = _ - (-33554432 & bA) | 0, Q = y - (B = -67108864 & NA) | 0, f = _A - ((B >>> 0 > y >>> 0) + qA | 0) | 0, I = kA((33554431 & (B = I)) << 7 | C >>> 25, I >>= 25, 19, 0), C = h + f | 0, I = I >>> 0 > (B = I + Q | 0) >>> 0 ? C + 1 | 0 : C, I = ((67108863 & (I = (C = B + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I)) << 6 | C >>> 26) + i | 0, o[g + 52 >> 2] = I, o[g + 48 >> 2] = B - (-67108864 & C), IA(A, g + 48 | 0));
                                            }
                                            return w = g + 256 | 0, 0 | vA;
                                        },
                                        Yb: function(A, I) {
                                            A |= 0;
                                            var g, C = 0;
                                            return w = g = w + -64 | 0, aA(g, I |= 0, 32, 0), E[0 | g] = 248 & a[0 | g], E[g + 31 | 0] = 63 & a[g + 31 | 0] | 64, I = o[g + 20 >> 2], C = o[g + 16 >> 2], E[A + 16 | 0] = C, E[A + 17 | 0] = C >>> 8, E[A + 18 | 0] = C >>> 16, E[A + 19 | 0] = C >>> 24, E[A + 20 | 0] = I, E[A + 21 | 0] = I >>> 8, E[A + 22 | 0] = I >>> 16, E[A + 23 | 0] = I >>> 24, I = o[g + 12 >> 2], C = o[g + 8 >> 2], E[A + 8 | 0] = C, E[A + 9 | 0] = C >>> 8, E[A + 10 | 0] = C >>> 16, E[A + 11 | 0] = C >>> 24, E[A + 12 | 0] = I, E[A + 13 | 0] = I >>> 8, E[A + 14 | 0] = I >>> 16, E[A + 15 | 0] = I >>> 24, I = o[g + 4 >> 2], C = o[g >> 2], E[0 | A] = C, E[A + 1 | 0] = C >>> 8, E[A + 2 | 0] = C >>> 16, E[A + 3 | 0] = C >>> 24, E[A + 4 | 0] = I, E[A + 5 | 0] = I >>> 8, E[A + 6 | 0] = I >>> 16, E[A + 7 | 0] = I >>> 24, I = o[g + 28 >> 2], C = o[g + 24 >> 2], E[A + 24 | 0] = C, E[A + 25 | 0] = C >>> 8, E[A + 26 | 0] = C >>> 16, E[A + 27 | 0] = C >>> 24, E[A + 28 | 0] = I, E[A + 29 | 0] = I >>> 8, E[A + 30 | 0] = I >>> 16, E[A + 31 | 0] = I >>> 24, iI(g, 64), w = g - -64 | 0, 0;
                                        },
                                        Zb: function() {
                                            var A, I;
                                            return w = A = w - 16 | 0, E[A + 15 | 0] = 0, I = 0 | r(35256, A + 15 | 0, 0), w = A + 16 | 0, 0 | I;
                                        },
                                        _b: mA,
                                        $b: function(A) {
                                            var I, g = 0, C = 0;
                                            if (w = I = w - 16 | 0, (A |= 0) >>> 0 >= 2) {
                                                for(g = (0 - A >>> 0) % (A >>> 0) | 0; E[I + 15 | 0] = 0, g >>> 0 > (C = 0 | r(35256, I + 15 | 0, 0)) >>> 0;);
                                                g = (C >>> 0) % (A >>> 0) | 0;
                                            }
                                            return w = I + 16 | 0, 0 | g;
                                        },
                                        ac: HA,
                                        bc: function(A, I, g) {
                                            ZA(A |= 0, I |= 0, 1024, g |= 0);
                                        },
                                        cc: aI,
                                        dc: function() {
                                            var A = 0, I = 0;
                                            return (A = o[9004]) && (A = o[A + 20 >> 2]) && (I = 0 | wI[0 | A]()), 0 | I;
                                        },
                                        ec: function(A, I, g) {
                                            A |= 0, I |= 0;
                                            var C, B = 0, i = 0, o = 0;
                                            if (w = C = w - 16 | 0, g |= 0) D(1240, 1100, 197, 1036), Q();
                                            else {
                                                if (I) for(; E[C + 15 | 0] = 0, i = A + B | 0, o = 0 | r(35256, C + 15 | 0, 0), E[0 | i] = o, (0 | I) != (0 | (B = B + 1 | 0)););
                                                w = C + 16 | 0;
                                            }
                                        },
                                        fc: function(A, I, g, C) {
                                            A |= 0, g |= 0;
                                            var B = 0, i = 0, o = 0;
                                            if (!((C |= 0) >>> 0 > 2147483646 | C << 1 >>> 0 >= (I |= 0) >>> 0)) {
                                                if (I = 0, C) {
                                                    for(; B = (I << 1) + A | 0, i = 15 & (o = a[I + g | 0]), E[B + 1 | 0] = 22272 + ((i << 8) + (i + 65526 & 55552) | 0) >>> 8, i = B, B = o >>> 4 | 0, E[0 | i] = 87 + ((B + 65526 >>> 8 & 217) + B | 0), (0 | C) != (0 | (I = I + 1 | 0)););
                                                    I = C << 1;
                                                } else I = 0;
                                                return E[I + A | 0] = 0, 0 | A;
                                            }
                                            zA(), Q();
                                        },
                                        gc: function(A, I, g, C, B, Q, i) {
                                            A |= 0, I |= 0, g |= 0, B |= 0, Q |= 0, i |= 0;
                                            var f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, h = 0, n = 0;
                                            A: if (C |= 0) {
                                                I: {
                                                    g: {
                                                        C: {
                                                            B: {
                                                                if (!B) {
                                                                    for(c = 1, B = 0;;){
                                                                        if (!(255 & ((y = (65526 + (e = (223 & (D = a[g + f | 0])) - 55 & 255) ^ e + 65520) >>> 8 | 0) | (w = 65526 + (D ^= 48) >>> 8 | 0)))) break C;
                                                                        if (I >>> 0 <= t >>> 0) break B;
                                                                        if (e = e & y | D & w, 255 & r ? (E[A + t | 0] = B | e, t = t + 1 | 0) : B = e << 4, r ^= -1, (0 | (f = f + 1 | 0)) == (0 | C)) break;
                                                                    }
                                                                    f = C;
                                                                    break C;
                                                                }
                                                                for(;;){
                                                                    Q: {
                                                                        i: {
                                                                            E: {
                                                                                o: {
                                                                                    a: {
                                                                                        if (!(255 & ((D = (65526 + (e = (223 & (c = a[g + f | 0])) - 55 & 255) ^ e + 65520) >>> 8 | 0) | (w = 65526 + (y = 48 ^ c) >>> 8 | 0)))) {
                                                                                            if (255 & r) break g;
                                                                                            if (!BA(B, c)) break A;
                                                                                            if ((f = r = f + 1 | 0) >>> 0 < C >>> 0) break a;
                                                                                            break A;
                                                                                        }
                                                                                        if (I >>> 0 <= t >>> 0) break B;
                                                                                        if (c = e & D | y & w, !(255 & r)) break o;
                                                                                        E[A + t | 0] = c | n, t = t + 1 | 0;
                                                                                        break Q;
                                                                                    }
                                                                                    for(;;){
                                                                                        if (!(255 & ((D = (65526 + (e = (223 & (c = a[g + f | 0])) - 55 & 255) ^ e + 65520) >>> 8 | 0) | (w = 65526 + (y = 48 ^ c) >>> 8 | 0)))) {
                                                                                            if (!BA(B, c)) break A;
                                                                                            if ((f = f + 1 | 0) >>> 0 < C >>> 0) continue;
                                                                                            break E;
                                                                                        }
                                                                                        break;
                                                                                    }
                                                                                    if (I >>> 0 <= t >>> 0) break i;
                                                                                    c = e & D | y & w;
                                                                                }
                                                                                n = c << 4, r = 0;
                                                                                break Q;
                                                                            }
                                                                            f = C >>> 0 > r >>> 0 ? C : r;
                                                                            break A;
                                                                        }
                                                                        r = 0;
                                                                        break B;
                                                                    }
                                                                    if (r ^= -1, c = 1, !((f = f + 1 | 0) >>> 0 < C >>> 0)) break;
                                                                }
                                                                break C;
                                                            }
                                                            o[9005] = 68, c = 0;
                                                        }
                                                        if (!(255 & r)) break I;
                                                    }
                                                    o[9005] = 28, h = -1, f = f - 1 | 0, t = 0;
                                                    break A;
                                                }
                                                c || (t = 0, h = -1);
                                            }
                                            return i ? o[i >> 2] = g + f : (0 | C) != (0 | f) && (o[9005] = 28, h = -1), Q && (o[Q >> 2] = t), 0 | h;
                                        },
                                        hc: function(A, I) {
                                            A |= 0;
                                            var g = 0;
                                            return 1 != (-7 & (I |= 0)) && (zA(), Q()), 1 + ((3 & (g = (g = A) + c(A = (A >>> 0) / 3 | 0, -3) | 0) ? 2 & I ? g + 1 | 0 : 4 : 0) + (A << 2) | 0) | 0;
                                        },
                                        ic: function(A, I, g, C, B) {
                                            A |= 0, I |= 0, g |= 0, C |= 0;
                                            var i = 0, o = 0, f = 0, e = 0, r = 0, t = 0, y = 0, w = 0, h = 0, n = 0;
                                            A: {
                                                I: {
                                                    g: {
                                                        C: {
                                                            B: {
                                                                Q: {
                                                                    i: {
                                                                        if (1 == (-7 & (B |= 0)) && (r = (o = (C >>> 0) / 3 | 0) << 2, (o = c(o, -3) + C | 0) && (r = 2 & B ? (2 | r) + (o >>> 1 | 0) | 0 : r + 4 | 0), !(I >>> 0 <= r >>> 0))) {
                                                                            if (!(4 & B)) {
                                                                                if (!C) {
                                                                                    B = 0;
                                                                                    break C;
                                                                                }
                                                                                B = 0;
                                                                                break i;
                                                                            }
                                                                            if (!C) {
                                                                                B = 0;
                                                                                break C;
                                                                            }
                                                                            for(B = 0;;){
                                                                                for(y = (w = a[g + t | 0]) | y << 8, o = B, B = 1 + ((((e |= 8) - 6 >>> 0) / 6 | 0) + B | 0) | 0; h = 65510 + (f = y >>> (e = (i = e) - 6 | 0) & 63) >>> 8 | 0, n = f + 65484 >>> 8 | 0, E[A + o | 0] = (1 + (16321 ^ f) ^ -1) >>> 8 & 45 | f + 252 & f + 65474 >>> 8 & (-1 ^ n) | (f + 32705 ^ -1) >>> 8 & 95 | h & f + 65 | n & f + 71 & (-1 ^ h), (0 | (o = o + 1 | 0)) != (0 | B););
                                                                                if ((0 | (t = t + 1 | 0)) == (0 | C)) break;
                                                                            }
                                                                            if (!e) break B;
                                                                            o = (C = 65510 + (i = w << 12 - i & 63) >>> 8 | 0) & i + 65, e = i + 252 & i + 65474 >>> 8 & (-1 ^ (g = i + 65484 >>> 8 | 0)), C = g & i + 71 & (-1 ^ C), t = i + 32705 | 0, y = 95, g = (1 + (16321 ^ i) ^ -1) >>> 8 & 45;
                                                                            break Q;
                                                                        }
                                                                        zA(), Q();
                                                                    }
                                                                    for(;;){
                                                                        for(y = (w = a[g + t | 0]) | y << 8, o = B, B = 1 + ((((e |= 8) - 6 >>> 0) / 6 | 0) + B | 0) | 0; h = 65510 + (f = y >>> (e = (i = e) - 6 | 0) & 63) >>> 8 | 0, n = f + 65484 >>> 8 | 0, E[A + o | 0] = (1 + (16321 ^ f) ^ -1) >>> 8 & 43 | f + 252 & f + 65474 >>> 8 & (-1 ^ n) | (f + 16321 ^ -1) >>> 8 & 47 | h & f + 65 | n & f + 71 & (-1 ^ h), (0 | (o = o + 1 | 0)) != (0 | B););
                                                                        if ((0 | (t = t + 1 | 0)) == (0 | C)) break;
                                                                    }
                                                                    if (!e) break B;
                                                                    o = (C = 65510 + (i = w << 12 - i & 63) >>> 8 | 0) & i + 65, e = i + 252 & i + 65474 >>> 8 & (-1 ^ (g = i + 65484 >>> 8 | 0)), C = g & i + 71 & (-1 ^ C), t = i + 16321 | 0, y = 47, g = (1 + (16321 ^ i) ^ -1) >>> 8 & 43;
                                                                }
                                                                E[A + B | 0] = g | (-1 ^ t) >>> 8 & y | o | e | C, B = B + 1 | 0;
                                                            }
                                                            if (B >>> 0 > r >>> 0) break g;
                                                        }
                                                        if (B >>> 0 < r >>> 0) break I;
                                                        r = B;
                                                        break A;
                                                    }
                                                    D(1048, 1126, 231, 1319), Q();
                                                }
                                                dA(A + B | 0, 61, r - B | 0);
                                            }
                                            return dA(A + r | 0, 0, (I >>> 0 > (g = r + 1 | 0) >>> 0 ? I : g) - r | 0), 0 | A;
                                        },
                                        jc: function(A, I, g, C, B, i, f, c) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, i |= 0, f |= 0;
                                            var e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, h = 0, n = 0;
                                            A: {
                                                I: {
                                                    g: {
                                                        C: {
                                                            B: {
                                                                Q: {
                                                                    i: {
                                                                        E: {
                                                                            o: {
                                                                                a: {
                                                                                    f: {
                                                                                        if (1 == (-7 & (c |= 0))) {
                                                                                            if (D = 0, !C) break E;
                                                                                            if (4 & c) break f;
                                                                                            for(;;){
                                                                                                D = r;
                                                                                                c: {
                                                                                                    e: {
                                                                                                        r: {
                                                                                                            D: {
                                                                                                                for(;;){
                                                                                                                    if (e = (e = (t = E[g + D | 0]) - 65 | 0) & ((90 - t ^ -1) & (-1 ^ e)) >>> 8 & 255 | t + 4 & ((t + 65488 ^ -1) & (57 - t ^ -1)) >>> 8 & 255 | t + 185 & ((t + 65439 ^ -1) & (122 - t ^ -1)) >>> 8 & 255 | (1 + (16336 ^ t) ^ -1) >>> 8 & 63 | (1 + (16340 ^ t) ^ -1) >>> 8 & 62, 255 != (0 | (e |= (e - 1 & 1 + (65470 ^ t)) >>> 8 & 255))) break D;
                                                                                                                    if (e = 0, !B) break o;
                                                                                                                    if (!BA(B, t)) break;
                                                                                                                    if ((D = D + 1 | 0) >>> 0 >= C >>> 0) break r;
                                                                                                                }
                                                                                                                r = D;
                                                                                                                break o;
                                                                                                            }
                                                                                                            if (h = e + (h << 6) | 0, y >>> 0 > 1) break e;
                                                                                                            y = y + 6 | 0;
                                                                                                            break c;
                                                                                                        }
                                                                                                        r = (A = r + 1 | 0) >>> 0 < C >>> 0 ? C : A;
                                                                                                        break o;
                                                                                                    }
                                                                                                    if (y = y - 2 | 0, I >>> 0 <= w >>> 0) break a;
                                                                                                    E[A + w | 0] = h >>> y, w = w + 1 | 0;
                                                                                                }
                                                                                                if (e = 0, !((r = D + 1 | 0) >>> 0 < C >>> 0)) break;
                                                                                            }
                                                                                            break o;
                                                                                        }
                                                                                        zA(), Q();
                                                                                    }
                                                                                    f: for(;;){
                                                                                        for(D = r;;){
                                                                                            c: {
                                                                                                if (e = (e = (t = E[g + D | 0]) - 65 | 0) & ((90 - t ^ -1) & (-1 ^ e)) >>> 8 & 255 | t + 4 & ((t + 65488 ^ -1) & (57 - t ^ -1)) >>> 8 & 255 | t + 185 & ((t + 65439 ^ -1) & (122 - t ^ -1)) >>> 8 & 255 | (1 + (16288 ^ t) ^ -1) >>> 8 & 63 | (1 + (16338 ^ t) ^ -1) >>> 8 & 62, 255 == (0 | (e |= (e - 1 & 1 + (65470 ^ t)) >>> 8 & 255))) {
                                                                                                    if (e = 0, !B) break o;
                                                                                                    if (BA(B, t)) break c;
                                                                                                    r = D;
                                                                                                    break o;
                                                                                                }
                                                                                                if (h = e + (h << 6) | 0, y >>> 0 < 2) y = y + 6 | 0;
                                                                                                else {
                                                                                                    if (y = y - 2 | 0, I >>> 0 <= w >>> 0) break a;
                                                                                                    E[A + w | 0] = h >>> y, w = w + 1 | 0;
                                                                                                }
                                                                                                if (e = 0, (r = D + 1 | 0) >>> 0 < C >>> 0) continue f;
                                                                                                break o;
                                                                                            }
                                                                                            if (!((D = D + 1 | 0) >>> 0 < C >>> 0)) break;
                                                                                        }
                                                                                        break;
                                                                                    }
                                                                                    r = (A = r + 1 | 0) >>> 0 < C >>> 0 ? C : A;
                                                                                    break o;
                                                                                }
                                                                                r = D, o[9005] = 68, e = 1;
                                                                            }
                                                                            if (y >>> 0 > 4) break i;
                                                                            D = r;
                                                                        }
                                                                        if (A = D, I = -1, e) {
                                                                            r = A;
                                                                            break A;
                                                                        }
                                                                        if ((-1 << y ^ -1) & h) {
                                                                            r = A;
                                                                            break A;
                                                                        }
                                                                        if (2 & c) {
                                                                            c = A;
                                                                            break B;
                                                                        }
                                                                        if (y >>> 0 < 2) {
                                                                            c = A;
                                                                            break B;
                                                                        }
                                                                        if (r = A >>> 0 > C >>> 0 ? A : C, D = y >>> 1 | 0, !B) break Q;
                                                                        for(c = A;;){
                                                                            if ((0 | c) == (0 | r)) {
                                                                                e = 68;
                                                                                break C;
                                                                            }
                                                                            if (61 != (0 | (A = E[g + c | 0]))) {
                                                                                if (!BA(B, A)) {
                                                                                    e = 28, r = c;
                                                                                    break C;
                                                                                }
                                                                            } else D = D - 1 | 0;
                                                                            if (c = c + 1 | 0, !D) break;
                                                                        }
                                                                        break B;
                                                                    }
                                                                    I = -1;
                                                                    break A;
                                                                }
                                                                if (e = 68, A >>> 0 >= C >>> 0) break C;
                                                                if (61 != a[A + g | 0]) {
                                                                    r = A, e = 28;
                                                                    break C;
                                                                }
                                                                if (c = A + D | 0, 1 != (0 | D)) {
                                                                    if ((0 | (y = A + 1 | 0)) == (0 | r)) break C;
                                                                    if (61 != a[g + y | 0]) {
                                                                        r = y, e = 28;
                                                                        break C;
                                                                    }
                                                                    if (2 != (0 | D)) {
                                                                        if ((0 | (A = A + 2 | 0)) == (0 | r)) break C;
                                                                        if (e = 28, r = A, 61 != a[A + g | 0]) break C;
                                                                    }
                                                                }
                                                            }
                                                            if (I = 0, B) break g;
                                                            break I;
                                                        }
                                                        o[9005] = e;
                                                        break A;
                                                    }
                                                    if (!(C >>> 0 <= c >>> 0)) {
                                                        for(;;){
                                                            if (!BA(B, E[g + c | 0])) break I;
                                                            if ((0 | (c = c + 1 | 0)) == (0 | C)) break;
                                                        }
                                                        c = C;
                                                    }
                                                }
                                                r = c, n = w;
                                            }
                                            return f ? o[f >> 2] = g + r : (0 | C) != (0 | r) && (o[9005] = 28, I = -1), i && (o[i >> 2] = n), 0 | I;
                                        },
                                        kc: function() {
                                            var A = 0;
                                            return o[9136] ? A = 1 : (mA(), HA(36528, 16), o[9136] = 1, A = 0), 0 | A;
                                        },
                                        lc: function(A, I, g, C, B) {
                                            A |= 0, I |= 0, g |= 0, B |= 0;
                                            var i, f = 0, c = 0, e = 0;
                                            w = i = w - 16 | 0;
                                            A: {
                                                if (C |= 0) {
                                                    if ((f = C - 1 | 0) & C ? (c = -1 ^ g, f = f - ((g >>> 0) % (C >>> 0) | 0) | 0) : f &= c = -1 ^ g, c >>> 0 <= f >>> 0) break A;
                                                    if (c = -1, !((g = g + f | 0) >>> 0 >= B >>> 0)) for(A && (o[A >> 2] = g + 1), A = I + g | 0, c = 0, E[i + 15 | 0] = 0, g = 0; B = I = A - g | 0, e = a[0 | I] & a[i + 15 | 0], I = (g ^ f) - 1 >>> 24 | 0, E[0 | B] = e | 128 & I, E[i + 15 | 0] = I | a[i + 15 | 0], (0 | C) != (0 | (g = g + 1 | 0)););
                                                } else c = -1;
                                                return w = i + 16 | 0, 0 | c;
                                            }
                                            zA(), Q();
                                        },
                                        mc: function(A, I, g, C) {
                                            A |= 0, I |= 0, g |= 0, C |= 0;
                                            var B, Q = 0, i = 0, E = 0, f = 0, c = 0;
                                            if (o[12 + (B = w - 16 | 0) >> 2] = 0, C - 1 >>> 0 < g >>> 0) {
                                                for(c = (Q = g - 1 | 0) + I | 0, g = 0, I = 0; f = ((128 ^ (i = a[c - g | 0])) - 1 & o[B + 12 >> 2] - 1 & E - 1) >>> 8 & 1, o[B + 12 >> 2] = o[B + 12 >> 2] | 0 - f & g, I |= f, E |= i, (0 | C) != (0 | (g = g + 1 | 0)););
                                                o[A >> 2] = Q - o[B + 12 >> 2], A = (255 & I) - 1 | 0;
                                            } else A = -1;
                                            return 0 | A;
                                        },
                                        nc: function() {
                                            return 1312;
                                        },
                                        oc: function() {
                                            return 26;
                                        },
                                        pc: rI,
                                        qc: rI,
                                        rc: function(A) {
                                            var I, g = 0, C = 0, B = 0, Q = 0, i = 0, E = 0, c = 0, r = 0, D = 0, t = 0, y = 0, h = 0;
                                            w = I = w - 16 | 0;
                                            A: {
                                                I: {
                                                    g: {
                                                        C: {
                                                            B: {
                                                                Q: {
                                                                    i: {
                                                                        E: {
                                                                            o: {
                                                                                a: {
                                                                                    f: {
                                                                                        c: {
                                                                                            e: {
                                                                                                r: {
                                                                                                    if ((A |= 0) >>> 0 <= 244) {
                                                                                                        if (3 & (g = (E = o[9006]) >>> (C = (c = A >>> 0 < 11 ? 16 : A + 11 & -8) >>> 3 | 0) | 0)) {
                                                                                                            g = 36064 + (A = (C = C + (1 & (-1 ^ g)) | 0) << 3) | 0, B = o[A + 36072 >> 2], (0 | g) != (0 | (A = o[B + 8 >> 2])) ? (o[A + 12 >> 2] = g, o[g + 8 >> 2] = A) : (y = 36024, h = RA(-2, C) & E, o[y >> 2] = h), A = B + 8 | 0, g = C << 3, o[B + 4 >> 2] = 3 | g, o[4 + (g = g + B | 0) >> 2] = 1 | o[g + 4 >> 2];
                                                                                                            break A;
                                                                                                        }
                                                                                                        if ((t = o[9008]) >>> 0 >= c >>> 0) break r;
                                                                                                        if (g) {
                                                                                                            g = 36064 + (A = (B = TA((0 - (A = 2 << C) | A) & g << C)) << 3) | 0, Q = o[A + 36072 >> 2], (0 | g) != (0 | (A = o[Q + 8 >> 2])) ? (o[A + 12 >> 2] = g, o[g + 8 >> 2] = A) : (E = RA(-2, B) & E, o[9006] = E), o[Q + 4 >> 2] = 3 | c, B = (A = B << 3) - c | 0, o[4 + (C = Q + c | 0) >> 2] = 1 | B, o[A + Q >> 2] = B, t && (g = 36064 + (-8 & t) | 0, i = o[9011], (A = 1 << (t >>> 3)) & E ? A = o[g + 8 >> 2] : (o[9006] = A | E, A = g), o[g + 8 >> 2] = i, o[A + 12 >> 2] = i, o[i + 12 >> 2] = g, o[i + 8 >> 2] = A), A = Q + 8 | 0, o[9011] = C, o[9008] = B;
                                                                                                            break A;
                                                                                                        }
                                                                                                        if (!(D = o[9007])) break r;
                                                                                                        for(C = o[36328 + (TA(D) << 2) >> 2], i = (-8 & o[C + 4 >> 2]) - c | 0, g = C; (A = o[g + 16 >> 2]) || (A = o[g + 20 >> 2]);)i = (B = (g = (-8 & o[A + 4 >> 2]) - c | 0) >>> 0 < i >>> 0) ? g : i, C = B ? A : C, g = A;
                                                                                                        if (r = o[C + 24 >> 2], (0 | (B = o[C + 12 >> 2])) != (0 | C)) {
                                                                                                            A = o[C + 8 >> 2], o[A + 12 >> 2] = B, o[B + 8 >> 2] = A;
                                                                                                            break I;
                                                                                                        }
                                                                                                        if (!(A = o[(g = C + 20 | 0) >> 2])) {
                                                                                                            if (!(A = o[C + 16 >> 2])) break e;
                                                                                                            g = C + 16 | 0;
                                                                                                        }
                                                                                                        for(; Q = g, B = A, (A = o[(g = A + 20 | 0) >> 2]) || (g = B + 16 | 0, A = o[B + 16 >> 2]););
                                                                                                        o[Q >> 2] = 0;
                                                                                                        break I;
                                                                                                    }
                                                                                                    if (c = -1, !(A >>> 0 > 4294967231) && (c = -8 & (A = A + 11 | 0), D = o[9007])) {
                                                                                                        i = 0 - c | 0, E = 0, c >>> 0 < 256 || (E = 31, c >>> 0 > 16777215 || (E = 62 + ((c >>> 38 - (A = e(A >>> 8 | 0)) & 1) - (A << 1) | 0) | 0));
                                                                                                        D: {
                                                                                                            t: {
                                                                                                                if (g = o[36328 + (E << 2) >> 2]) for(A = 0, C = c << (31 != (0 | E) ? 25 - (E >>> 1 | 0) | 0 : 0);;){
                                                                                                                    if (!((Q = (-8 & o[g + 4 >> 2]) - c | 0) >>> 0 >= i >>> 0 || (B = g, i = Q, Q))) {
                                                                                                                        i = 0, A = g;
                                                                                                                        break t;
                                                                                                                    }
                                                                                                                    if (Q = o[g + 20 >> 2], g = o[16 + ((C >>> 29 & 4) + g | 0) >> 2], A = Q ? (0 | Q) == (0 | g) ? A : Q : A, C <<= 1, !g) break;
                                                                                                                }
                                                                                                                else A = 0;
                                                                                                                if (!(A | B)) {
                                                                                                                    if (B = 0, !(A = (0 - (A = 2 << E) | A) & D)) break r;
                                                                                                                    A = o[36328 + (TA(A) << 2) >> 2];
                                                                                                                }
                                                                                                                if (!A) break D;
                                                                                                            }
                                                                                                            for(; i = (C = (g = (-8 & o[A + 4 >> 2]) - c | 0) >>> 0 < i >>> 0) ? g : i, B = C ? A : B, A = (g = o[A + 16 >> 2]) || o[A + 20 >> 2];);
                                                                                                        }
                                                                                                        if (!(!B | o[9008] - c >>> 0 <= i >>> 0)) {
                                                                                                            if (E = o[B + 24 >> 2], (0 | B) != (0 | (C = o[B + 12 >> 2]))) {
                                                                                                                A = o[B + 8 >> 2], o[A + 12 >> 2] = C, o[C + 8 >> 2] = A;
                                                                                                                break g;
                                                                                                            }
                                                                                                            if (!(A = o[(g = B + 20 | 0) >> 2])) {
                                                                                                                if (!(A = o[B + 16 >> 2])) break c;
                                                                                                                g = B + 16 | 0;
                                                                                                            }
                                                                                                            for(; Q = g, C = A, (A = o[(g = A + 20 | 0) >> 2]) || (g = C + 16 | 0, A = o[C + 16 >> 2]););
                                                                                                            o[Q >> 2] = 0;
                                                                                                            break g;
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                                if ((A = o[9008]) >>> 0 >= c >>> 0) {
                                                                                                    B = o[9011], (g = A - c | 0) >>> 0 >= 16 ? (o[4 + (C = B + c | 0) >> 2] = 1 | g, o[A + B >> 2] = g, o[B + 4 >> 2] = 3 | c) : (o[B + 4 >> 2] = 3 | A, o[4 + (A = A + B | 0) >> 2] = 1 | o[A + 4 >> 2], C = 0, g = 0), o[9008] = g, o[9011] = C, A = B + 8 | 0;
                                                                                                    break A;
                                                                                                }
                                                                                                if ((r = o[9009]) >>> 0 > c >>> 0) {
                                                                                                    g = r - c | 0, o[9009] = g, A = (C = o[9012]) + c | 0, o[9012] = A, o[A + 4 >> 2] = 1 | g, o[C + 4 >> 2] = 3 | c, A = C + 8 | 0;
                                                                                                    break A;
                                                                                                }
                                                                                                if (A = 0, D = c + 47 | 0, o[9124] ? C = o[9126] : (o[9127] = -1, o[9128] = -1, o[9125] = 4096, o[9126] = 4096, o[9124] = I + 12 & -16 ^ 1431655768, o[9129] = 0, o[9117] = 0, C = 4096), (g = (Q = D + C | 0) & (i = 0 - C | 0)) >>> 0 <= c >>> 0) break A;
                                                                                                if ((B = o[9116]) && B >>> 0 < (E = (C = o[9114]) + g | 0) >>> 0 | C >>> 0 >= E >>> 0) break A;
                                                                                                r: {
                                                                                                    if (!(4 & a[36468])) {
                                                                                                        D: {
                                                                                                            t: {
                                                                                                                y: {
                                                                                                                    w: {
                                                                                                                        if (B = o[9012]) for(A = 36472;;){
                                                                                                                            if ((C = o[A >> 2]) >>> 0 <= B >>> 0 & B >>> 0 < C + o[A + 4 >> 2] >>> 0) break w;
                                                                                                                            if (!(A = o[A + 8 >> 2])) break;
                                                                                                                        }
                                                                                                                        if (-1 == (0 | (C = _A(0)))) break D;
                                                                                                                        if (E = g, (A = (B = o[9125]) - 1 | 0) & C && (E = (g - C | 0) + (A + C & 0 - B) | 0), E >>> 0 <= c >>> 0) break D;
                                                                                                                        if ((B = o[9116]) && B >>> 0 < (i = (A = o[9114]) + E | 0) >>> 0 | A >>> 0 >= i >>> 0) break D;
                                                                                                                        if ((0 | C) != (0 | (A = _A(E)))) break y;
                                                                                                                        break r;
                                                                                                                    }
                                                                                                                    if ((0 | (C = _A(E = i & Q - r))) == (o[A >> 2] + o[A + 4 >> 2] | 0)) break t;
                                                                                                                    A = C;
                                                                                                                }
                                                                                                                if (-1 == (0 | A)) break D;
                                                                                                                if (c + 48 >>> 0 <= E >>> 0) {
                                                                                                                    C = A;
                                                                                                                    break r;
                                                                                                                }
                                                                                                                if (-1 == (0 | _A(C = (C = o[9126]) + (D - E | 0) & 0 - C))) break D;
                                                                                                                E = C + E | 0, C = A;
                                                                                                                break r;
                                                                                                            }
                                                                                                            if (-1 != (0 | C)) break r;
                                                                                                        }
                                                                                                        o[9117] = 4 | o[9117];
                                                                                                    }
                                                                                                    if (-1 == (0 | (C = _A(g))) | -1 == (0 | (A = _A(0))) | A >>> 0 <= C >>> 0) break o;
                                                                                                    if ((E = A - C | 0) >>> 0 <= c + 40 >>> 0) break o;
                                                                                                }
                                                                                                A = o[9114] + E | 0, o[9114] = A, A >>> 0 > f[9115] && (o[9115] = A);
                                                                                                r: {
                                                                                                    if (Q = o[9012]) {
                                                                                                        for(A = 36472;;){
                                                                                                            if (((B = o[A >> 2]) + (g = o[A + 4 >> 2]) | 0) == (0 | C)) break r;
                                                                                                            if (!(A = o[A + 8 >> 2])) break;
                                                                                                        }
                                                                                                        break f;
                                                                                                    }
                                                                                                    for((A = o[9010]) >>> 0 <= C >>> 0 && A || (o[9010] = C), A = 0, o[9119] = E, o[9118] = C, o[9014] = -1, o[9015] = o[9124], o[9121] = 0; g = 36064 + (B = A << 3) | 0, o[B + 36072 >> 2] = g, o[B + 36076 >> 2] = g, 32 != (0 | (A = A + 1 | 0)););
                                                                                                    g = (B = E - 40 | 0) - (A = -8 - C & 7) | 0, o[9009] = g, A = A + C | 0, o[9012] = A, o[A + 4 >> 2] = 1 | g, o[4 + (C + B | 0) >> 2] = 40, o[9013] = o[9128];
                                                                                                    break a;
                                                                                                }
                                                                                                if (8 & o[A + 12 >> 2] | C >>> 0 <= Q >>> 0 | B >>> 0 > Q >>> 0) break f;
                                                                                                o[A + 4 >> 2] = g + E, C = (A = -8 - Q & 7) + Q | 0, o[9012] = C, A = (g = o[9009] + E | 0) - A | 0, o[9009] = A, o[C + 4 >> 2] = 1 | A, o[4 + (g + Q | 0) >> 2] = 40, o[9013] = o[9128];
                                                                                                break a;
                                                                                            }
                                                                                            B = 0;
                                                                                            break I;
                                                                                        }
                                                                                        C = 0;
                                                                                        break g;
                                                                                    }
                                                                                    f[9010] > C >>> 0 && (o[9010] = C), g = C + E | 0, A = 36472;
                                                                                    f: {
                                                                                        c: {
                                                                                            e: {
                                                                                                for(;;){
                                                                                                    if ((0 | g) != o[A >> 2]) {
                                                                                                        if (A = o[A + 8 >> 2]) continue;
                                                                                                        break e;
                                                                                                    }
                                                                                                    break;
                                                                                                }
                                                                                                if (!(8 & a[A + 12 | 0])) break c;
                                                                                            }
                                                                                            for(A = 36472;;){
                                                                                                if ((g = o[A >> 2]) >>> 0 <= Q >>> 0 && (i = g + o[A + 4 >> 2] | 0) >>> 0 > Q >>> 0) break f;
                                                                                                A = o[A + 8 >> 2];
                                                                                            }
                                                                                        }
                                                                                        if (o[A >> 2] = C, o[A + 4 >> 2] = o[A + 4 >> 2] + E, o[4 + (D = (-8 - C & 7) + C | 0) >> 2] = 3 | c, A = (E = g + (-8 - g & 7) | 0) - (r = c + D | 0) | 0, (0 | Q) == (0 | E)) {
                                                                                            o[9012] = r, A = o[9009] + A | 0, o[9009] = A, o[r + 4 >> 2] = 1 | A;
                                                                                            break C;
                                                                                        }
                                                                                        if (o[9011] == (0 | E)) {
                                                                                            o[9011] = r, A = o[9008] + A | 0, o[9008] = A, o[r + 4 >> 2] = 1 | A, o[A + r >> 2] = A;
                                                                                            break C;
                                                                                        }
                                                                                        if (1 != (3 & (i = o[E + 4 >> 2]))) break B;
                                                                                        if (Q = -8 & i, i >>> 0 <= 255) {
                                                                                            if ((0 | (C = o[E + 12 >> 2])) == (0 | (g = o[E + 8 >> 2]))) {
                                                                                                y = 36024, h = o[9006] & RA(-2, i >>> 3 | 0), o[y >> 2] = h;
                                                                                                break Q;
                                                                                            }
                                                                                            o[g + 12 >> 2] = C, o[C + 8 >> 2] = g;
                                                                                            break Q;
                                                                                        }
                                                                                        if (c = o[E + 24 >> 2], (0 | E) != (0 | (C = o[E + 12 >> 2]))) {
                                                                                            g = o[E + 8 >> 2], o[g + 12 >> 2] = C, o[C + 8 >> 2] = g;
                                                                                            break i;
                                                                                        }
                                                                                        if (!(i = o[(g = E + 20 | 0) >> 2])) {
                                                                                            if (!(i = o[E + 16 >> 2])) break E;
                                                                                            g = E + 16 | 0;
                                                                                        }
                                                                                        for(; B = g, (i = o[(g = (C = i) + 20 | 0) >> 2]) || (g = C + 16 | 0, i = o[C + 16 >> 2]););
                                                                                        o[B >> 2] = 0;
                                                                                        break i;
                                                                                    }
                                                                                    for(g = (B = E - 40 | 0) - (A = -8 - C & 7) | 0, o[9009] = g, A = A + C | 0, o[9012] = A, o[A + 4 >> 2] = 1 | g, o[4 + (C + B | 0) >> 2] = 40, o[9013] = o[9128], o[(B = (A = (i + (39 - i & 7) | 0) - 47 | 0) >>> 0 < Q + 16 >>> 0 ? Q : A) + 4 >> 2] = 27, A = o[9121], o[B + 16 >> 2] = o[9120], o[B + 20 >> 2] = A, A = o[9119], o[B + 8 >> 2] = o[9118], o[B + 12 >> 2] = A, o[9120] = B + 8, o[9119] = E, o[9118] = C, o[9121] = 0, A = B + 24 | 0; o[A + 4 >> 2] = 7, g = A + 8 | 0, A = A + 4 | 0, g >>> 0 < i >>> 0;);
                                                                                    if ((0 | B) != (0 | Q)) {
                                                                                        if (o[B + 4 >> 2] = -2 & o[B + 4 >> 2], i = B - Q | 0, o[Q + 4 >> 2] = 1 | i, o[B >> 2] = i, i >>> 0 <= 255) g = 36064 + (-8 & i) | 0, (C = o[9006]) & (A = 1 << (i >>> 3)) ? A = o[g + 8 >> 2] : (o[9006] = A | C, A = g), o[g + 8 >> 2] = Q, o[A + 12 >> 2] = Q, o[Q + 12 >> 2] = g, o[Q + 8 >> 2] = A;
                                                                                        else {
                                                                                            A = 31, i >>> 0 <= 16777215 && (A = 62 + ((i >>> 38 - (A = e(i >>> 8 | 0)) & 1) - (A << 1) | 0) | 0), o[Q + 28 >> 2] = A, o[Q + 16 >> 2] = 0, o[Q + 20 >> 2] = 0, g = 36328 + (A << 2) | 0;
                                                                                            f: {
                                                                                                if ((B = o[9007]) & (C = 1 << A)) {
                                                                                                    for(A = i << (31 != (0 | A) ? 25 - (A >>> 1 | 0) | 0 : 0), B = o[g >> 2];;){
                                                                                                        if ((0 | i) == (-8 & o[(g = B) + 4 >> 2])) break f;
                                                                                                        if (C = A >>> 29 | 0, A <<= 1, !(B = o[16 + (C = (4 & C) + g | 0) >> 2])) break;
                                                                                                    }
                                                                                                    o[C + 16 >> 2] = Q;
                                                                                                } else o[9007] = C | B, o[g >> 2] = Q;
                                                                                                o[Q + 24 >> 2] = g, o[Q + 12 >> 2] = Q, o[Q + 8 >> 2] = Q;
                                                                                                break a;
                                                                                            }
                                                                                            A = o[g + 8 >> 2], o[A + 12 >> 2] = Q, o[g + 8 >> 2] = Q, o[Q + 24 >> 2] = 0, o[Q + 12 >> 2] = g, o[Q + 8 >> 2] = A;
                                                                                        }
                                                                                    }
                                                                                }
                                                                                if (!((A = o[9009]) >>> 0 <= c >>> 0)) {
                                                                                    g = A - c | 0, o[9009] = g, A = (C = o[9012]) + c | 0, o[9012] = A, o[A + 4 >> 2] = 1 | g, o[C + 4 >> 2] = 3 | c, A = C + 8 | 0;
                                                                                    break A;
                                                                                }
                                                                            }
                                                                            o[9005] = 48, A = 0;
                                                                            break A;
                                                                        }
                                                                        C = 0;
                                                                    }
                                                                    if (c) {
                                                                        B = o[E + 28 >> 2];
                                                                        i: {
                                                                            if (o[(g = 36328 + (B << 2) | 0) >> 2] == (0 | E)) {
                                                                                if (o[g >> 2] = C, C) break i;
                                                                                y = 36028, h = o[9007] & RA(-2, B), o[y >> 2] = h;
                                                                                break Q;
                                                                            }
                                                                            if (o[c + (o[c + 16 >> 2] == (0 | E) ? 16 : 20) >> 2] = C, !C) break Q;
                                                                        }
                                                                        o[C + 24 >> 2] = c, (g = o[E + 16 >> 2]) && (o[C + 16 >> 2] = g, o[g + 24 >> 2] = C), (g = o[E + 20 >> 2]) && (o[C + 20 >> 2] = g, o[g + 24 >> 2] = C);
                                                                    }
                                                                }
                                                                A = A + Q | 0, i = o[4 + (E = Q + E | 0) >> 2];
                                                            }
                                                            if (o[E + 4 >> 2] = -2 & i, o[r + 4 >> 2] = 1 | A, o[A + r >> 2] = A, A >>> 0 <= 255) g = 36064 + (-8 & A) | 0, (C = o[9006]) & (A = 1 << (A >>> 3)) ? A = o[g + 8 >> 2] : (o[9006] = A | C, A = g), o[g + 8 >> 2] = r, o[A + 12 >> 2] = r, o[r + 12 >> 2] = g, o[r + 8 >> 2] = A;
                                                            else {
                                                                i = 31, A >>> 0 <= 16777215 && (i = 62 + ((A >>> 38 - (g = e(A >>> 8 | 0)) & 1) - (g << 1) | 0) | 0), o[r + 28 >> 2] = i, o[r + 16 >> 2] = 0, o[r + 20 >> 2] = 0, g = 36328 + (i << 2) | 0;
                                                                B: {
                                                                    if ((B = o[9007]) & (C = 1 << i)) {
                                                                        for(i = A << (31 != (0 | i) ? 25 - (i >>> 1 | 0) | 0 : 0), C = o[g >> 2];;){
                                                                            if (g = C, (-8 & o[C + 4 >> 2]) == (0 | A)) break B;
                                                                            if (B = i >>> 29 | 0, i <<= 1, !(C = o[16 + (B = (4 & B) + C | 0) >> 2])) break;
                                                                        }
                                                                        o[B + 16 >> 2] = r;
                                                                    } else o[9007] = C | B, o[g >> 2] = r;
                                                                    o[r + 24 >> 2] = g, o[r + 12 >> 2] = r, o[r + 8 >> 2] = r;
                                                                    break C;
                                                                }
                                                                A = o[g + 8 >> 2], o[A + 12 >> 2] = r, o[g + 8 >> 2] = r, o[r + 24 >> 2] = 0, o[r + 12 >> 2] = g, o[r + 8 >> 2] = A;
                                                            }
                                                        }
                                                        A = D + 8 | 0;
                                                        break A;
                                                    }
                                                    g: if (E) {
                                                        g = o[B + 28 >> 2];
                                                        C: {
                                                            if (o[(A = 36328 + (g << 2) | 0) >> 2] == (0 | B)) {
                                                                if (o[A >> 2] = C, C) break C;
                                                                D = RA(-2, g) & D, o[9007] = D;
                                                                break g;
                                                            }
                                                            if (o[E + (o[E + 16 >> 2] == (0 | B) ? 16 : 20) >> 2] = C, !C) break g;
                                                        }
                                                        o[C + 24 >> 2] = E, (A = o[B + 16 >> 2]) && (o[C + 16 >> 2] = A, o[A + 24 >> 2] = C), (A = o[B + 20 >> 2]) && (o[C + 20 >> 2] = A, o[A + 24 >> 2] = C);
                                                    }
                                                    g: if (i >>> 0 <= 15) A = i + c | 0, o[B + 4 >> 2] = 3 | A, o[4 + (A = A + B | 0) >> 2] = 1 | o[A + 4 >> 2];
                                                    else if (o[B + 4 >> 2] = 3 | c, o[4 + (Q = B + c | 0) >> 2] = 1 | i, o[Q + i >> 2] = i, i >>> 0 <= 255) g = 36064 + (-8 & i) | 0, (C = o[9006]) & (A = 1 << (i >>> 3)) ? A = o[g + 8 >> 2] : (o[9006] = A | C, A = g), o[g + 8 >> 2] = Q, o[A + 12 >> 2] = Q, o[Q + 12 >> 2] = g, o[Q + 8 >> 2] = A;
                                                    else {
                                                        A = 31, i >>> 0 <= 16777215 && (A = 62 + ((i >>> 38 - (A = e(i >>> 8 | 0)) & 1) - (A << 1) | 0) | 0), o[Q + 28 >> 2] = A, o[Q + 16 >> 2] = 0, o[Q + 20 >> 2] = 0, g = 36328 + (A << 2) | 0;
                                                        C: {
                                                            if ((C = 1 << A) & D) {
                                                                for(A = i << (31 != (0 | A) ? 25 - (A >>> 1 | 0) | 0 : 0), c = o[g >> 2];;){
                                                                    if ((-8 & o[(g = c) + 4 >> 2]) == (0 | i)) break C;
                                                                    if (C = A >>> 29 | 0, A <<= 1, !(c = o[16 + (C = (4 & C) + g | 0) >> 2])) break;
                                                                }
                                                                o[C + 16 >> 2] = Q;
                                                            } else o[9007] = C | D, o[g >> 2] = Q;
                                                            o[Q + 24 >> 2] = g, o[Q + 12 >> 2] = Q, o[Q + 8 >> 2] = Q;
                                                            break g;
                                                        }
                                                        A = o[g + 8 >> 2], o[A + 12 >> 2] = Q, o[g + 8 >> 2] = Q, o[Q + 24 >> 2] = 0, o[Q + 12 >> 2] = g, o[Q + 8 >> 2] = A;
                                                    }
                                                    A = B + 8 | 0;
                                                    break A;
                                                }
                                                I: if (r) {
                                                    g = o[C + 28 >> 2];
                                                    g: {
                                                        if (o[(A = 36328 + (g << 2) | 0) >> 2] == (0 | C)) {
                                                            if (o[A >> 2] = B, B) break g;
                                                            y = 36028, h = RA(-2, g) & D, o[y >> 2] = h;
                                                            break I;
                                                        }
                                                        if (o[r + (o[r + 16 >> 2] == (0 | C) ? 16 : 20) >> 2] = B, !B) break I;
                                                    }
                                                    o[B + 24 >> 2] = r, (A = o[C + 16 >> 2]) && (o[B + 16 >> 2] = A, o[A + 24 >> 2] = B), (A = o[C + 20 >> 2]) && (o[B + 20 >> 2] = A, o[A + 24 >> 2] = B);
                                                }
                                                i >>> 0 <= 15 ? (A = i + c | 0, o[C + 4 >> 2] = 3 | A, o[4 + (A = A + C | 0) >> 2] = 1 | o[A + 4 >> 2]) : (o[C + 4 >> 2] = 3 | c, o[4 + (B = C + c | 0) >> 2] = 1 | i, o[B + i >> 2] = i, t && (g = 36064 + (-8 & t) | 0, Q = o[9011], (A = 1 << (t >>> 3)) & E ? A = o[g + 8 >> 2] : (o[9006] = A | E, A = g), o[g + 8 >> 2] = Q, o[A + 12 >> 2] = Q, o[Q + 12 >> 2] = g, o[Q + 8 >> 2] = A), o[9011] = B, o[9008] = i), A = C + 8 | 0;
                                            }
                                            return w = I + 16 | 0, 0 | A;
                                        },
                                        sc: function(A) {
                                            var I = 0, g = 0, C = 0, B = 0, Q = 0, i = 0, E = 0, a = 0, c = 0;
                                            A: if (A |= 0) {
                                                Q = (C = A - 8 | 0) + (A = -8 & (I = o[A - 4 >> 2])) | 0;
                                                I: if (!(1 & I)) {
                                                    if (!(3 & I)) break A;
                                                    if ((C = C - (I = o[C >> 2]) | 0) >>> 0 < f[9010]) break A;
                                                    A = A + I | 0;
                                                    g: {
                                                        C: {
                                                            if (o[9011] != (0 | C)) {
                                                                if (I >>> 0 <= 255) {
                                                                    if (B = I >>> 3 | 0, (0 | (I = o[C + 12 >> 2])) == (0 | (g = o[C + 8 >> 2]))) {
                                                                        a = 36024, c = o[9006] & RA(-2, B), o[a >> 2] = c;
                                                                        break I;
                                                                    }
                                                                    o[g + 12 >> 2] = I, o[I + 8 >> 2] = g;
                                                                    break I;
                                                                }
                                                                if (E = o[C + 24 >> 2], (0 | C) != (0 | (I = o[C + 12 >> 2]))) {
                                                                    g = o[C + 8 >> 2], o[g + 12 >> 2] = I, o[I + 8 >> 2] = g;
                                                                    break g;
                                                                }
                                                                if (!(g = o[(B = C + 20 | 0) >> 2])) {
                                                                    if (!(g = o[C + 16 >> 2])) break C;
                                                                    B = C + 16 | 0;
                                                                }
                                                                for(; i = B, (g = o[(B = (I = g) + 20 | 0) >> 2]) || (B = I + 16 | 0, g = o[I + 16 >> 2]););
                                                                o[i >> 2] = 0;
                                                                break g;
                                                            }
                                                            if (3 != (3 & (I = o[Q + 4 >> 2]))) break I;
                                                            return o[9008] = A, o[Q + 4 >> 2] = -2 & I, o[C + 4 >> 2] = 1 | A, void (o[Q >> 2] = A);
                                                        }
                                                        I = 0;
                                                    }
                                                    if (E) {
                                                        g = o[C + 28 >> 2];
                                                        g: {
                                                            if (o[(B = 36328 + (g << 2) | 0) >> 2] == (0 | C)) {
                                                                if (o[B >> 2] = I, I) break g;
                                                                a = 36028, c = o[9007] & RA(-2, g), o[a >> 2] = c;
                                                                break I;
                                                            }
                                                            if (o[E + (o[E + 16 >> 2] == (0 | C) ? 16 : 20) >> 2] = I, !I) break I;
                                                        }
                                                        o[I + 24 >> 2] = E, (g = o[C + 16 >> 2]) && (o[I + 16 >> 2] = g, o[g + 24 >> 2] = I), (g = o[C + 20 >> 2]) && (o[I + 20 >> 2] = g, o[g + 24 >> 2] = I);
                                                    }
                                                }
                                                if (!(C >>> 0 >= Q >>> 0) && 1 & (I = o[Q + 4 >> 2])) {
                                                    I: {
                                                        g: {
                                                            C: {
                                                                B: {
                                                                    if (!(2 & I)) {
                                                                        if (o[9012] == (0 | Q)) {
                                                                            if (o[9012] = C, A = o[9009] + A | 0, o[9009] = A, o[C + 4 >> 2] = 1 | A, o[9011] != (0 | C)) break A;
                                                                            return o[9008] = 0, void (o[9011] = 0);
                                                                        }
                                                                        if (o[9011] == (0 | Q)) return o[9011] = C, A = o[9008] + A | 0, o[9008] = A, o[C + 4 >> 2] = 1 | A, void (o[A + C >> 2] = A);
                                                                        if (A = (-8 & I) + A | 0, I >>> 0 <= 255) {
                                                                            if (B = I >>> 3 | 0, (0 | (I = o[Q + 12 >> 2])) == (0 | (g = o[Q + 8 >> 2]))) {
                                                                                a = 36024, c = o[9006] & RA(-2, B), o[a >> 2] = c;
                                                                                break g;
                                                                            }
                                                                            o[g + 12 >> 2] = I, o[I + 8 >> 2] = g;
                                                                            break g;
                                                                        }
                                                                        if (E = o[Q + 24 >> 2], (0 | Q) != (0 | (I = o[Q + 12 >> 2]))) {
                                                                            g = o[Q + 8 >> 2], o[g + 12 >> 2] = I, o[I + 8 >> 2] = g;
                                                                            break C;
                                                                        }
                                                                        if (!(g = o[(B = Q + 20 | 0) >> 2])) {
                                                                            if (!(g = o[Q + 16 >> 2])) break B;
                                                                            B = Q + 16 | 0;
                                                                        }
                                                                        for(; i = B, (g = o[(B = (I = g) + 20 | 0) >> 2]) || (B = I + 16 | 0, g = o[I + 16 >> 2]););
                                                                        o[i >> 2] = 0;
                                                                        break C;
                                                                    }
                                                                    o[Q + 4 >> 2] = -2 & I, o[C + 4 >> 2] = 1 | A, o[A + C >> 2] = A;
                                                                    break I;
                                                                }
                                                                I = 0;
                                                            }
                                                            if (E) {
                                                                g = o[Q + 28 >> 2];
                                                                C: {
                                                                    if (o[(B = 36328 + (g << 2) | 0) >> 2] == (0 | Q)) {
                                                                        if (o[B >> 2] = I, I) break C;
                                                                        a = 36028, c = o[9007] & RA(-2, g), o[a >> 2] = c;
                                                                        break g;
                                                                    }
                                                                    if (o[E + (o[E + 16 >> 2] == (0 | Q) ? 16 : 20) >> 2] = I, !I) break g;
                                                                }
                                                                o[I + 24 >> 2] = E, (g = o[Q + 16 >> 2]) && (o[I + 16 >> 2] = g, o[g + 24 >> 2] = I), (g = o[Q + 20 >> 2]) && (o[I + 20 >> 2] = g, o[g + 24 >> 2] = I);
                                                            }
                                                        }
                                                        if (o[C + 4 >> 2] = 1 | A, o[A + C >> 2] = A, o[9011] == (0 | C)) return void (o[9008] = A);
                                                    }
                                                    if (A >>> 0 <= 255) return I = 36064 + (-8 & A) | 0, (g = o[9006]) & (A = 1 << (A >>> 3)) ? A = o[I + 8 >> 2] : (o[9006] = A | g, A = I), o[I + 8 >> 2] = C, o[A + 12 >> 2] = C, o[C + 12 >> 2] = I, void (o[C + 8 >> 2] = A);
                                                    g = 31, A >>> 0 <= 16777215 && (g = 62 + ((A >>> 38 - (I = e(A >>> 8 | 0)) & 1) - (I << 1) | 0) | 0), o[C + 28 >> 2] = g, o[C + 16 >> 2] = 0, o[C + 20 >> 2] = 0, I = 36328 + (g << 2) | 0;
                                                    I: {
                                                        g: {
                                                            if ((B = o[9007]) & (i = 1 << g)) {
                                                                for(g = A << (31 != (0 | g) ? 25 - (g >>> 1 | 0) | 0 : 0), I = o[I >> 2];;){
                                                                    if (B = I, (-8 & o[I + 4 >> 2]) == (0 | A)) break g;
                                                                    if (i = g >>> 29 | 0, g <<= 1, !(I = o[16 + (i = I + (4 & i) | 0) >> 2])) break;
                                                                }
                                                                o[i + 16 >> 2] = C, o[C + 24 >> 2] = B;
                                                            } else o[9007] = B | i, o[I >> 2] = C, o[C + 24 >> 2] = I;
                                                            o[C + 12 >> 2] = C, o[C + 8 >> 2] = C;
                                                            break I;
                                                        }
                                                        A = o[B + 8 >> 2], o[A + 12 >> 2] = C, o[B + 8 >> 2] = C, o[C + 24 >> 2] = 0, o[C + 12 >> 2] = B, o[C + 8 >> 2] = A;
                                                    }
                                                    A = o[9014] - 1 | 0, o[9014] = A || -1;
                                                }
                                            }
                                        },
                                        tc: wI
                                    };
                                }(A);
                            }(I);
                        },
                        instantiate: function(A, I) {
                            return {
                                then: function(g) {
                                    var C = new y.Module(A);
                                    g({
                                        instance: new y.Instance(C, I)
                                    });
                                }
                            };
                        },
                        RuntimeError: Error
                    };
                    r = [], "object" != typeof y && d("no native wasm support detected");
                    var w, h, n, s, k, F, S, H = !1;
                    function G() {
                        var A = t.buffer;
                        Q.HEAP8 = w = new Int8Array(A), Q.HEAP16 = n = new Int16Array(A), Q.HEAPU8 = h = new Uint8Array(A), Q.HEAPU16 = new Uint16Array(A), Q.HEAP32 = s = new Int32Array(A), Q.HEAPU32 = k = new Uint32Array(A), Q.HEAPF32 = F = new Float32Array(A), Q.HEAPF64 = S = new Float64Array(A);
                    }
                    var _ = Q.INITIAL_MEMORY || 16777216;
                    _ >= 65536 || d("INITIAL_MEMORY should be larger than STACK_SIZE, was " + _ + "! (STACK_SIZE=65536)"), t = Q.wasmMemory ? Q.wasmMemory : new y.Memory({
                        initial: _ / 65536,
                        maximum: 32768
                    }), G(), _ = t.buffer.byteLength;
                    var M = [], p = [], N = [], J = 0, U = null, Y = null;
                    function d(A) {
                        throw Q.onAbort && Q.onAbort(A), D(A = "Aborted(" + A + ")"), H = !0, A += ". Build with -sASSERTIONS for more info.", new y.RuntimeError(A);
                    }
                    var K, b, P = "data:application/octet-stream;base64,";
                    function v(A) {
                        return A.startsWith(P);
                    }
                    v(K = "<<< WASM_BINARY_FILE >>>") || (b = K, K = Q.locateFile ? Q.locateFile(b, f) : f + b);
                    var L, R = {
                        35256: ()=>Q.getRandomValue(),
                        35292: ()=>{
                            if (void 0 === Q.getRandomValue) try {
                                var A = "object" == typeof window ? window : self, I = void 0 !== A.crypto ? A.crypto : A.msCrypto, g = function() {
                                    var A = new Uint32Array(1);
                                    return I.getRandomValues(A), A[0] >>> 0;
                                };
                                g(), Q.getRandomValue = g;
                            } catch (A) {
                                try {
                                    var C = (parcelRequire("7HCQr")), B = function() {
                                        var A = C.randomBytes(4);
                                        return (A[0] << 24 | A[1] << 16 | A[2] << 8 | A[3]) >>> 0;
                                    };
                                    B(), Q.getRandomValue = B;
                                } catch (A) {
                                    throw "No secure random number generator found";
                                }
                            }
                        }
                    }, u = (A)=>{
                        for(; A.length > 0;)A.shift()(Q);
                    }, x = "undefined" != typeof TextDecoder ? new TextDecoder("utf8") : void 0, m = (A, I)=>A ? ((A, I, g)=>{
                            for(var C = I + g, B = I; A[B] && !(B >= C);)++B;
                            if (B - I > 16 && A.buffer && x) return x.decode(A.subarray(I, B));
                            for(var Q = ""; I < B;){
                                var i = A[I++];
                                if (128 & i) {
                                    var E = 63 & A[I++];
                                    if (192 != (224 & i)) {
                                        var o = 63 & A[I++];
                                        if ((i = 224 == (240 & i) ? (15 & i) << 12 | E << 6 | o : (7 & i) << 18 | E << 12 | o << 6 | 63 & A[I++]) < 65536) Q += String.fromCharCode(i);
                                        else {
                                            var a = i - 65536;
                                            Q += String.fromCharCode(55296 | a >> 10, 56320 | 1023 & a);
                                        }
                                    } else Q += String.fromCharCode((31 & i) << 6 | E);
                                } else Q += String.fromCharCode(i);
                            }
                            return Q;
                        })(h, A, I) : "", l = [], z = (A)=>{
                        var I = (A - t.buffer.byteLength + 65535) / 65536;
                        try {
                            return t.grow(I), G(), 1;
                        } catch (A) {}
                    }, q = {
                        c: (A, I, g, C)=>{
                            d(`Assertion failed: ${m(A)}, at: ` + [
                                I ? m(I) : "unknown filename",
                                g,
                                C ? m(C) : "unknown function"
                            ]);
                        },
                        d: ()=>{
                            d("");
                        },
                        b: (A, I, g)=>((A, I, g)=>{
                                var C = ((A, I)=>{
                                    var g;
                                    for(l.length = 0; g = h[A++];)I += 105 != g && I % 8 ? 4 : 0, l.push(105 == g ? s[I >> 2] : S[I >> 3]), I += 105 == g ? 4 : 8;
                                    return l;
                                })(I, g);
                                return R[A].apply(null, C);
                            })(A, I, g),
                        e: (A)=>{
                            var I = h.length, g = 2147483648;
                            if ((A >>>= 0) > g) return !1;
                            for(var C, B = 1; B <= 4; B *= 2){
                                var Q = I * (1 + .2 / B);
                                Q = Math.min(Q, A + 100663296);
                                var i = Math.min(g, (C = Math.max(A, Q)) + (65536 - C % 65536) % 65536);
                                if (z(i)) return !0;
                            }
                            return !1;
                        },
                        a: t
                    }, X = function() {
                        var A, I, g = {
                            a: q
                        };
                        function C(A, I) {
                            var g, C = A.exports;
                            return (X = C).tc, g = X.f, p.unshift(g), function(A) {
                                if (J--, Q.monitorRunDependencies && Q.monitorRunDependencies(J), 0 == J && (null !== U && (clearInterval(U), U = null), Y)) {
                                    var I = Y;
                                    Y = null, I();
                                }
                            }(), C;
                        }
                        if (J++, Q.monitorRunDependencies && Q.monitorRunDependencies(J), Q.instantiateWasm) try {
                            return Q.instantiateWasm(g, C);
                        } catch (A) {
                            return D(`Module.instantiateWasm callback failed with error: ${A}`), !1;
                        }
                        return A = g, I = function(A) {
                            C(A.instance);
                        }, (function(A) {
                            return Promise.resolve().then(()=>(function(A) {
                                    if (A == K && r) return new Uint8Array(r);
                                    var I = function(A) {
                                        if (v(A)) return function(A) {
                                            if (void 0 !== a && a) {
                                                var I = $97810cacbb360566$require$Buffer.from(A, "base64");
                                                return new Uint8Array(I.buffer, I.byteOffset, I.length);
                                            }
                                            try {
                                                for(var g = atob(A), C = new Uint8Array(g.length), B = 0; B < g.length; ++B)C[B] = g.charCodeAt(B);
                                                return C;
                                            } catch (A) {
                                                throw new Error("Converting base64 string to bytes failed.");
                                            }
                                        }(A.slice(P.length));
                                    }(A);
                                    if (I) return I;
                                    if (B) return B(A);
                                    throw "both async and sync fetching of the wasm failed";
                                })(A));
                        })(K).then((I)=>y.instantiate(I, A)).then((A)=>A).then(I, (A)=>{
                            D(`failed to asynchronously prepare wasm: ${A}`), d(A);
                        }), {};
                    }();
                    function j() {
                        function A() {
                            L || (L = !0, Q.calledRun = !0, H || (u(p), Q.onRuntimeInitialized && Q.onRuntimeInitialized(), function() {
                                if (Q.postRun) for("function" == typeof Q.postRun && (Q.postRun = [
                                    Q.postRun
                                ]); Q.postRun.length;)A = Q.postRun.shift(), N.unshift(A);
                                var A;
                                u(N);
                            }()));
                        }
                        J > 0 || (function() {
                            if (Q.preRun) for("function" == typeof Q.preRun && (Q.preRun = [
                                Q.preRun
                            ]); Q.preRun.length;)A = Q.preRun.shift(), M.unshift(A);
                            var A;
                            u(M);
                        }(), J > 0 || (Q.setStatus ? (Q.setStatus("Running..."), setTimeout(function() {
                            setTimeout(function() {
                                Q.setStatus("");
                            }, 1), A();
                        }, 1)) : A()));
                    }
                    if (Q._crypto_aead_chacha20poly1305_encrypt_detached = (A, I, g, C, B, i, E, o, a, f, c, e)=>(Q._crypto_aead_chacha20poly1305_encrypt_detached = X.g)(A, I, g, C, B, i, E, o, a, f, c, e), Q._crypto_aead_chacha20poly1305_encrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_encrypt = X.h)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_ietf_encrypt_detached = (A, I, g, C, B, i, E, o, a, f, c, e)=>(Q._crypto_aead_chacha20poly1305_ietf_encrypt_detached = X.i)(A, I, g, C, B, i, E, o, a, f, c, e), Q._crypto_aead_chacha20poly1305_ietf_encrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_ietf_encrypt = X.j)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_decrypt_detached = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_decrypt_detached = X.k)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_decrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_decrypt = X.l)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_ietf_decrypt_detached = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_ietf_decrypt_detached = X.m)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_ietf_decrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_ietf_decrypt = X.n)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_ietf_keybytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_keybytes = X.o)(), Q._crypto_aead_chacha20poly1305_ietf_npubbytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_npubbytes = X.p)(), Q._crypto_aead_chacha20poly1305_ietf_nsecbytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_nsecbytes = X.q)(), Q._crypto_aead_chacha20poly1305_ietf_abytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_abytes = X.r)(), Q._crypto_aead_chacha20poly1305_ietf_messagebytes_max = ()=>(Q._crypto_aead_chacha20poly1305_ietf_messagebytes_max = X.s)(), Q._crypto_aead_chacha20poly1305_ietf_keygen = (A)=>(Q._crypto_aead_chacha20poly1305_ietf_keygen = X.t)(A), Q._crypto_aead_chacha20poly1305_keybytes = ()=>(Q._crypto_aead_chacha20poly1305_keybytes = X.u)(), Q._crypto_aead_chacha20poly1305_npubbytes = ()=>(Q._crypto_aead_chacha20poly1305_npubbytes = X.v)(), Q._crypto_aead_chacha20poly1305_nsecbytes = ()=>(Q._crypto_aead_chacha20poly1305_nsecbytes = X.w)(), Q._crypto_aead_chacha20poly1305_abytes = ()=>(Q._crypto_aead_chacha20poly1305_abytes = X.x)(), Q._crypto_aead_chacha20poly1305_messagebytes_max = ()=>(Q._crypto_aead_chacha20poly1305_messagebytes_max = X.y)(), Q._crypto_aead_chacha20poly1305_keygen = (A)=>(Q._crypto_aead_chacha20poly1305_keygen = X.z)(A), Q._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = (A, I, g, C, B, i, E, o, a, f, c, e)=>(Q._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = X.A)(A, I, g, C, B, i, E, o, a, f, c, e), Q._crypto_aead_xchacha20poly1305_ietf_encrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_xchacha20poly1305_ietf_encrypt = X.B)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = X.C)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_xchacha20poly1305_ietf_decrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_xchacha20poly1305_ietf_decrypt = X.D)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_xchacha20poly1305_ietf_keybytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_keybytes = X.E)(), Q._crypto_aead_xchacha20poly1305_ietf_npubbytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_npubbytes = X.F)(), Q._crypto_aead_xchacha20poly1305_ietf_nsecbytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_nsecbytes = X.G)(), Q._crypto_aead_xchacha20poly1305_ietf_abytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_abytes = X.H)(), Q._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = X.I)(), Q._crypto_aead_xchacha20poly1305_ietf_keygen = (A)=>(Q._crypto_aead_xchacha20poly1305_ietf_keygen = X.J)(A), Q._crypto_auth_bytes = ()=>(Q._crypto_auth_bytes = X.K)(), Q._crypto_auth_keybytes = ()=>(Q._crypto_auth_keybytes = X.L)(), Q._crypto_auth = (A, I, g, C, B)=>(Q._crypto_auth = X.M)(A, I, g, C, B), Q._crypto_auth_verify = (A, I, g, C, B)=>(Q._crypto_auth_verify = X.N)(A, I, g, C, B), Q._crypto_auth_keygen = (A)=>(Q._crypto_auth_keygen = X.O)(A), Q._crypto_box_seedbytes = ()=>(Q._crypto_box_seedbytes = X.P)(), Q._crypto_box_publickeybytes = ()=>(Q._crypto_box_publickeybytes = X.Q)(), Q._crypto_box_secretkeybytes = ()=>(Q._crypto_box_secretkeybytes = X.R)(), Q._crypto_box_beforenmbytes = ()=>(Q._crypto_box_beforenmbytes = X.S)(), Q._crypto_box_noncebytes = ()=>(Q._crypto_box_noncebytes = X.T)(), Q._crypto_box_macbytes = ()=>(Q._crypto_box_macbytes = X.U)(), Q._crypto_box_messagebytes_max = ()=>(Q._crypto_box_messagebytes_max = X.V)(), Q._crypto_box_seed_keypair = (A, I, g)=>(Q._crypto_box_seed_keypair = X.W)(A, I, g), Q._crypto_box_keypair = (A, I)=>(Q._crypto_box_keypair = X.X)(A, I), Q._crypto_box_beforenm = (A, I, g)=>(Q._crypto_box_beforenm = X.Y)(A, I, g), Q._crypto_box_detached_afternm = (A, I, g, C, B, i, E)=>(Q._crypto_box_detached_afternm = X.Z)(A, I, g, C, B, i, E), Q._crypto_box_detached = (A, I, g, C, B, i, E, o)=>(Q._crypto_box_detached = X._)(A, I, g, C, B, i, E, o), Q._crypto_box_easy_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_easy_afternm = X.$)(A, I, g, C, B, i), Q._crypto_box_easy = (A, I, g, C, B, i, E)=>(Q._crypto_box_easy = X.aa)(A, I, g, C, B, i, E), Q._crypto_box_open_detached_afternm = (A, I, g, C, B, i, E)=>(Q._crypto_box_open_detached_afternm = X.ba)(A, I, g, C, B, i, E), Q._crypto_box_open_detached = (A, I, g, C, B, i, E, o)=>(Q._crypto_box_open_detached = X.ca)(A, I, g, C, B, i, E, o), Q._crypto_box_open_easy_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_open_easy_afternm = X.da)(A, I, g, C, B, i), Q._crypto_box_open_easy = (A, I, g, C, B, i, E)=>(Q._crypto_box_open_easy = X.ea)(A, I, g, C, B, i, E), Q._crypto_box_seal = (A, I, g, C, B)=>(Q._crypto_box_seal = X.fa)(A, I, g, C, B), Q._crypto_box_seal_open = (A, I, g, C, B, i)=>(Q._crypto_box_seal_open = X.ga)(A, I, g, C, B, i), Q._crypto_box_sealbytes = ()=>(Q._crypto_box_sealbytes = X.ha)(), Q._crypto_generichash_bytes_min = ()=>(Q._crypto_generichash_bytes_min = X.ia)(), Q._crypto_generichash_bytes_max = ()=>(Q._crypto_generichash_bytes_max = X.ja)(), Q._crypto_generichash_bytes = ()=>(Q._crypto_generichash_bytes = X.ka)(), Q._crypto_generichash_keybytes_min = ()=>(Q._crypto_generichash_keybytes_min = X.la)(), Q._crypto_generichash_keybytes_max = ()=>(Q._crypto_generichash_keybytes_max = X.ma)(), Q._crypto_generichash_keybytes = ()=>(Q._crypto_generichash_keybytes = X.na)(), Q._crypto_generichash_statebytes = ()=>(Q._crypto_generichash_statebytes = X.oa)(), Q._crypto_generichash = (A, I, g, C, B, i, E)=>(Q._crypto_generichash = X.pa)(A, I, g, C, B, i, E), Q._crypto_generichash_init = (A, I, g, C)=>(Q._crypto_generichash_init = X.qa)(A, I, g, C), Q._crypto_generichash_update = (A, I, g, C)=>(Q._crypto_generichash_update = X.ra)(A, I, g, C), Q._crypto_generichash_final = (A, I, g)=>(Q._crypto_generichash_final = X.sa)(A, I, g), Q._crypto_generichash_keygen = (A)=>(Q._crypto_generichash_keygen = X.ta)(A), Q._crypto_hash_bytes = ()=>(Q._crypto_hash_bytes = X.ua)(), Q._crypto_hash = (A, I, g, C)=>(Q._crypto_hash = X.va)(A, I, g, C), Q._crypto_kdf_bytes_min = ()=>(Q._crypto_kdf_bytes_min = X.wa)(), Q._crypto_kdf_bytes_max = ()=>(Q._crypto_kdf_bytes_max = X.xa)(), Q._crypto_kdf_contextbytes = ()=>(Q._crypto_kdf_contextbytes = X.ya)(), Q._crypto_kdf_keybytes = ()=>(Q._crypto_kdf_keybytes = X.za)(), Q._crypto_kdf_derive_from_key = (A, I, g, C, B, i)=>(Q._crypto_kdf_derive_from_key = X.Aa)(A, I, g, C, B, i), Q._crypto_kdf_keygen = (A)=>(Q._crypto_kdf_keygen = X.Ba)(A), Q._crypto_kdf_hkdf_sha256_extract_init = (A, I, g)=>(Q._crypto_kdf_hkdf_sha256_extract_init = X.Ca)(A, I, g), Q._crypto_kdf_hkdf_sha256_extract_update = (A, I, g)=>(Q._crypto_kdf_hkdf_sha256_extract_update = X.Da)(A, I, g), Q._crypto_kdf_hkdf_sha256_extract_final = (A, I)=>(Q._crypto_kdf_hkdf_sha256_extract_final = X.Ea)(A, I), Q._crypto_kdf_hkdf_sha256_extract = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha256_extract = X.Fa)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha256_keygen = (A)=>(Q._crypto_kdf_hkdf_sha256_keygen = X.Ga)(A), Q._crypto_kdf_hkdf_sha256_expand = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha256_expand = X.Ha)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha256_keybytes = ()=>(Q._crypto_kdf_hkdf_sha256_keybytes = X.Ia)(), Q._crypto_kdf_hkdf_sha256_bytes_min = ()=>(Q._crypto_kdf_hkdf_sha256_bytes_min = X.Ja)(), Q._crypto_kdf_hkdf_sha256_bytes_max = ()=>(Q._crypto_kdf_hkdf_sha256_bytes_max = X.Ka)(), Q._crypto_kdf_hkdf_sha256_statebytes = ()=>(Q._crypto_kdf_hkdf_sha256_statebytes = X.La)(), Q._crypto_kdf_hkdf_sha512_extract_init = (A, I, g)=>(Q._crypto_kdf_hkdf_sha512_extract_init = X.Ma)(A, I, g), Q._crypto_kdf_hkdf_sha512_extract_update = (A, I, g)=>(Q._crypto_kdf_hkdf_sha512_extract_update = X.Na)(A, I, g), Q._crypto_kdf_hkdf_sha512_extract_final = (A, I)=>(Q._crypto_kdf_hkdf_sha512_extract_final = X.Oa)(A, I), Q._crypto_kdf_hkdf_sha512_extract = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha512_extract = X.Pa)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha512_keygen = (A)=>(Q._crypto_kdf_hkdf_sha512_keygen = X.Qa)(A), Q._crypto_kdf_hkdf_sha512_expand = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha512_expand = X.Ra)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha512_keybytes = ()=>(Q._crypto_kdf_hkdf_sha512_keybytes = X.Sa)(), Q._crypto_kdf_hkdf_sha512_bytes_min = ()=>(Q._crypto_kdf_hkdf_sha512_bytes_min = X.Ta)(), Q._crypto_kdf_hkdf_sha512_bytes_max = ()=>(Q._crypto_kdf_hkdf_sha512_bytes_max = X.Ua)(), Q._crypto_kx_seed_keypair = (A, I, g)=>(Q._crypto_kx_seed_keypair = X.Va)(A, I, g), Q._crypto_kx_keypair = (A, I)=>(Q._crypto_kx_keypair = X.Wa)(A, I), Q._crypto_kx_client_session_keys = (A, I, g, C, B)=>(Q._crypto_kx_client_session_keys = X.Xa)(A, I, g, C, B), Q._crypto_kx_server_session_keys = (A, I, g, C, B)=>(Q._crypto_kx_server_session_keys = X.Ya)(A, I, g, C, B), Q._crypto_kx_publickeybytes = ()=>(Q._crypto_kx_publickeybytes = X.Za)(), Q._crypto_kx_secretkeybytes = ()=>(Q._crypto_kx_secretkeybytes = X._a)(), Q._crypto_kx_seedbytes = ()=>(Q._crypto_kx_seedbytes = X.$a)(), Q._crypto_kx_sessionkeybytes = ()=>(Q._crypto_kx_sessionkeybytes = X.ab)(), Q._crypto_scalarmult_base = (A, I)=>(Q._crypto_scalarmult_base = X.bb)(A, I), Q._crypto_scalarmult = (A, I, g)=>(Q._crypto_scalarmult = X.cb)(A, I, g), Q._crypto_scalarmult_bytes = ()=>(Q._crypto_scalarmult_bytes = X.db)(), Q._crypto_scalarmult_scalarbytes = ()=>(Q._crypto_scalarmult_scalarbytes = X.eb)(), Q._crypto_secretbox_keybytes = ()=>(Q._crypto_secretbox_keybytes = X.fb)(), Q._crypto_secretbox_noncebytes = ()=>(Q._crypto_secretbox_noncebytes = X.gb)(), Q._crypto_secretbox_macbytes = ()=>(Q._crypto_secretbox_macbytes = X.hb)(), Q._crypto_secretbox_messagebytes_max = ()=>(Q._crypto_secretbox_messagebytes_max = X.ib)(), Q._crypto_secretbox_keygen = (A)=>(Q._crypto_secretbox_keygen = X.jb)(A), Q._crypto_secretbox_detached = (A, I, g, C, B, i, E)=>(Q._crypto_secretbox_detached = X.kb)(A, I, g, C, B, i, E), Q._crypto_secretbox_easy = (A, I, g, C, B, i)=>(Q._crypto_secretbox_easy = X.lb)(A, I, g, C, B, i), Q._crypto_secretbox_open_detached = (A, I, g, C, B, i, E)=>(Q._crypto_secretbox_open_detached = X.mb)(A, I, g, C, B, i, E), Q._crypto_secretbox_open_easy = (A, I, g, C, B, i)=>(Q._crypto_secretbox_open_easy = X.nb)(A, I, g, C, B, i), Q._crypto_secretstream_xchacha20poly1305_keygen = (A)=>(Q._crypto_secretstream_xchacha20poly1305_keygen = X.ob)(A), Q._crypto_secretstream_xchacha20poly1305_init_push = (A, I, g)=>(Q._crypto_secretstream_xchacha20poly1305_init_push = X.pb)(A, I, g), Q._crypto_secretstream_xchacha20poly1305_init_pull = (A, I, g)=>(Q._crypto_secretstream_xchacha20poly1305_init_pull = X.qb)(A, I, g), Q._crypto_secretstream_xchacha20poly1305_rekey = (A)=>(Q._crypto_secretstream_xchacha20poly1305_rekey = X.rb)(A), Q._crypto_secretstream_xchacha20poly1305_push = (A, I, g, C, B, i, E, o, a, f)=>(Q._crypto_secretstream_xchacha20poly1305_push = X.sb)(A, I, g, C, B, i, E, o, a, f), Q._crypto_secretstream_xchacha20poly1305_pull = (A, I, g, C, B, i, E, o, a, f)=>(Q._crypto_secretstream_xchacha20poly1305_pull = X.tb)(A, I, g, C, B, i, E, o, a, f), Q._crypto_secretstream_xchacha20poly1305_statebytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_statebytes = X.ub)(), Q._crypto_secretstream_xchacha20poly1305_abytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_abytes = X.vb)(), Q._crypto_secretstream_xchacha20poly1305_headerbytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_headerbytes = X.wb)(), Q._crypto_secretstream_xchacha20poly1305_keybytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_keybytes = X.xb)(), Q._crypto_secretstream_xchacha20poly1305_messagebytes_max = ()=>(Q._crypto_secretstream_xchacha20poly1305_messagebytes_max = X.yb)(), Q._crypto_secretstream_xchacha20poly1305_tag_message = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_message = X.zb)(), Q._crypto_secretstream_xchacha20poly1305_tag_push = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_push = X.Ab)(), Q._crypto_secretstream_xchacha20poly1305_tag_rekey = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_rekey = X.Bb)(), Q._crypto_secretstream_xchacha20poly1305_tag_final = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_final = X.Cb)(), Q._crypto_shorthash_bytes = ()=>(Q._crypto_shorthash_bytes = X.Db)(), Q._crypto_shorthash_keybytes = ()=>(Q._crypto_shorthash_keybytes = X.Eb)(), Q._crypto_shorthash = (A, I, g, C, B)=>(Q._crypto_shorthash = X.Fb)(A, I, g, C, B), Q._crypto_shorthash_keygen = (A)=>(Q._crypto_shorthash_keygen = X.Gb)(A), Q._crypto_sign_statebytes = ()=>(Q._crypto_sign_statebytes = X.Hb)(), Q._crypto_sign_bytes = ()=>(Q._crypto_sign_bytes = X.Ib)(), Q._crypto_sign_seedbytes = ()=>(Q._crypto_sign_seedbytes = X.Jb)(), Q._crypto_sign_publickeybytes = ()=>(Q._crypto_sign_publickeybytes = X.Kb)(), Q._crypto_sign_secretkeybytes = ()=>(Q._crypto_sign_secretkeybytes = X.Lb)(), Q._crypto_sign_messagebytes_max = ()=>(Q._crypto_sign_messagebytes_max = X.Mb)(), Q._crypto_sign_seed_keypair = (A, I, g)=>(Q._crypto_sign_seed_keypair = X.Nb)(A, I, g), Q._crypto_sign_keypair = (A, I)=>(Q._crypto_sign_keypair = X.Ob)(A, I), Q._crypto_sign = (A, I, g, C, B, i)=>(Q._crypto_sign = X.Pb)(A, I, g, C, B, i), Q._crypto_sign_open = (A, I, g, C, B, i)=>(Q._crypto_sign_open = X.Qb)(A, I, g, C, B, i), Q._crypto_sign_detached = (A, I, g, C, B, i)=>(Q._crypto_sign_detached = X.Rb)(A, I, g, C, B, i), Q._crypto_sign_verify_detached = (A, I, g, C, B)=>(Q._crypto_sign_verify_detached = X.Sb)(A, I, g, C, B), Q._crypto_sign_init = (A)=>(Q._crypto_sign_init = X.Tb)(A), Q._crypto_sign_update = (A, I, g, C)=>(Q._crypto_sign_update = X.Ub)(A, I, g, C), Q._crypto_sign_final_create = (A, I, g, C)=>(Q._crypto_sign_final_create = X.Vb)(A, I, g, C), Q._crypto_sign_final_verify = (A, I, g)=>(Q._crypto_sign_final_verify = X.Wb)(A, I, g), Q._crypto_sign_ed25519_pk_to_curve25519 = (A, I)=>(Q._crypto_sign_ed25519_pk_to_curve25519 = X.Xb)(A, I), Q._crypto_sign_ed25519_sk_to_curve25519 = (A, I)=>(Q._crypto_sign_ed25519_sk_to_curve25519 = X.Yb)(A, I), Q._randombytes_random = ()=>(Q._randombytes_random = X.Zb)(), Q._randombytes_stir = ()=>(Q._randombytes_stir = X._b)(), Q._randombytes_uniform = (A)=>(Q._randombytes_uniform = X.$b)(A), Q._randombytes_buf = (A, I)=>(Q._randombytes_buf = X.ac)(A, I), Q._randombytes_buf_deterministic = (A, I, g)=>(Q._randombytes_buf_deterministic = X.bc)(A, I, g), Q._randombytes_seedbytes = ()=>(Q._randombytes_seedbytes = X.cc)(), Q._randombytes_close = ()=>(Q._randombytes_close = X.dc)(), Q._randombytes = (A, I, g)=>(Q._randombytes = X.ec)(A, I, g), Q._sodium_bin2hex = (A, I, g, C)=>(Q._sodium_bin2hex = X.fc)(A, I, g, C), Q._sodium_hex2bin = (A, I, g, C, B, i, E)=>(Q._sodium_hex2bin = X.gc)(A, I, g, C, B, i, E), Q._sodium_base64_encoded_len = (A, I)=>(Q._sodium_base64_encoded_len = X.hc)(A, I), Q._sodium_bin2base64 = (A, I, g, C, B)=>(Q._sodium_bin2base64 = X.ic)(A, I, g, C, B), Q._sodium_base642bin = (A, I, g, C, B, i, E, o)=>(Q._sodium_base642bin = X.jc)(A, I, g, C, B, i, E, o), Q._sodium_init = ()=>(Q._sodium_init = X.kc)(), Q._sodium_pad = (A, I, g, C, B)=>(Q._sodium_pad = X.lc)(A, I, g, C, B), Q._sodium_unpad = (A, I, g, C)=>(Q._sodium_unpad = X.mc)(A, I, g, C), Q._sodium_version_string = ()=>(Q._sodium_version_string = X.nc)(), Q._sodium_library_version_major = ()=>(Q._sodium_library_version_major = X.oc)(), Q._sodium_library_version_minor = ()=>(Q._sodium_library_version_minor = X.pc)(), Q._sodium_library_minimal = ()=>(Q._sodium_library_minimal = X.qc)(), Q._malloc = (A)=>(Q._malloc = X.rc)(A), Q._free = (A)=>(Q._free = X.sc)(A), Q.setValue = function(A, I, g = "i8") {
                        switch(g.endsWith("*") && (g = "*"), g){
                            case "i1":
                            case "i8":
                                w[A >> 0] = I;
                                break;
                            case "i16":
                                n[A >> 1] = I;
                                break;
                            case "i32":
                                s[A >> 2] = I;
                                break;
                            case "i64":
                                d("to do setValue(i64) use WASM_BIGINT");
                            case "float":
                                F[A >> 2] = I;
                                break;
                            case "double":
                                S[A >> 3] = I;
                                break;
                            case "*":
                                k[A >> 2] = I;
                                break;
                            default:
                                d(`invalid type for setValue: ${g}`);
                        }
                    }, Q.getValue = function(A, I = "i8") {
                        switch(I.endsWith("*") && (I = "*"), I){
                            case "i1":
                            case "i8":
                                return w[A >> 0];
                            case "i16":
                                return n[A >> 1];
                            case "i32":
                                return s[A >> 2];
                            case "i64":
                                d("to do getValue(i64) use WASM_BIGINT");
                            case "float":
                                return F[A >> 2];
                            case "double":
                                return S[A >> 3];
                            case "*":
                                return k[A >> 2];
                            default:
                                d(`invalid type for getValue: ${I}`);
                        }
                    }, Q.UTF8ToString = m, Y = function A() {
                        L || j(), L || (Y = A);
                    }, Q.preInit) for("function" == typeof Q.preInit && (Q.preInit = [
                        Q.preInit
                    ]); Q.preInit.length > 0;)Q.preInit.pop()();
                    j();
                });
            };
            var g, B, Q = void 0 !== Q ? Q : {}, i = Object.assign({}, Q), E = "object" == typeof window, o = "function" == typeof importScripts, a = "object" == typeof $a8i8g && "object" == typeof $a8i8g.versions && "string" == typeof $a8i8g.versions.node, f = "";
            if (a) {
                var c = (parcelRequire("aqbQf")), e = (parcelRequire("aqbQf"));
                f = o ? e.dirname(f) + "/" : $97810cacbb360566$var$__dirname + "/", g = (A, I)=>(A = function(A) {
                        return A.startsWith("file://");
                    }(A) ? new URL(A) : e.normalize(A), c.readFileSync(A, I ? void 0 : "utf8")), B = (A)=>{
                    var I = g(A, !0);
                    return I.buffer || (I = new Uint8Array(I)), I;
                }, !Q.thisProgram && $a8i8g.argv.length > 1 && $a8i8g.argv[1].replace(/\\/g, "/"), $a8i8g.argv.slice(2), module.exports = Q, Q.inspect = ()=>"[Emscripten Module object]";
            } else (E || o) && (o ? f = self.location.href : "undefined" != typeof document && document.currentScript && (f = document.currentScript.src), f = 0 !== f.indexOf("blob:") ? f.substr(0, f.replace(/[?#].*/, "").lastIndexOf("/") + 1) : "", g = (A)=>{
                var I = new XMLHttpRequest;
                return I.open("GET", A, !1), I.send(null), I.responseText;
            }, o && (B = (A)=>{
                var I = new XMLHttpRequest;
                return I.open("GET", A, !1), I.responseType = "arraybuffer", I.send(null), new Uint8Array(I.response);
            }));
            Q.print;
            var r, D, t = Q.printErr || void 0;
            Object.assign(Q, i), i = null, Q.arguments && Q.arguments, Q.thisProgram && Q.thisProgram, Q.quit && Q.quit, Q.wasmBinary && (r = Q.wasmBinary), Q.noExitRuntime, "object" != typeof WebAssembly && U("no native wasm support detected");
            var y, w, h, n, s, k, F, S = !1;
            function H() {
                var A = D.buffer;
                Q.HEAP8 = y = new Int8Array(A), Q.HEAP16 = h = new Int16Array(A), Q.HEAPU8 = w = new Uint8Array(A), Q.HEAPU16 = new Uint16Array(A), Q.HEAP32 = n = new Int32Array(A), Q.HEAPU32 = s = new Uint32Array(A), Q.HEAPF32 = k = new Float32Array(A), Q.HEAPF64 = F = new Float64Array(A);
            }
            var G = [], _ = [], M = [], p = 0, N = null, J = null;
            function U(A) {
                throw Q.onAbort && Q.onAbort(A), t(A = "Aborted(" + A + ")"), S = !0, A += ". Build with -sASSERTIONS for more info.", new WebAssembly.RuntimeError(A);
            }
            var Y, d, K = "data:application/octet-stream;base64,";
            function b(A) {
                return A.startsWith(K);
            }
            b(Y = "data:application/octet-stream;base64,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") || (d = Y, Y = Q.locateFile ? Q.locateFile(d, f) : f + d);
            var P, v = {
                35256: ()=>Q.getRandomValue(),
                35292: ()=>{
                    if (void 0 === Q.getRandomValue) try {
                        var A = "object" == typeof window ? window : self, I = void 0 !== A.crypto ? A.crypto : A.msCrypto, g = function() {
                            var A = new Uint32Array(1);
                            return I.getRandomValues(A), A[0] >>> 0;
                        };
                        g(), Q.getRandomValue = g;
                    } catch (A) {
                        try {
                            var C = (parcelRequire("7HCQr")), B = function() {
                                var A = C.randomBytes(4);
                                return (A[0] << 24 | A[1] << 16 | A[2] << 8 | A[3]) >>> 0;
                            };
                            B(), Q.getRandomValue = B;
                        } catch (A) {
                            throw "No secure random number generator found";
                        }
                    }
                }
            }, L = (A)=>{
                for(; A.length > 0;)A.shift()(Q);
            }, R = "undefined" != typeof TextDecoder ? new TextDecoder("utf8") : void 0, u = (A, I)=>A ? ((A, I, g)=>{
                    for(var C = I + g, B = I; A[B] && !(B >= C);)++B;
                    if (B - I > 16 && A.buffer && R) return R.decode(A.subarray(I, B));
                    for(var Q = ""; I < B;){
                        var i = A[I++];
                        if (128 & i) {
                            var E = 63 & A[I++];
                            if (192 != (224 & i)) {
                                var o = 63 & A[I++];
                                if ((i = 224 == (240 & i) ? (15 & i) << 12 | E << 6 | o : (7 & i) << 18 | E << 12 | o << 6 | 63 & A[I++]) < 65536) Q += String.fromCharCode(i);
                                else {
                                    var a = i - 65536;
                                    Q += String.fromCharCode(55296 | a >> 10, 56320 | 1023 & a);
                                }
                            } else Q += String.fromCharCode((31 & i) << 6 | E);
                        } else Q += String.fromCharCode(i);
                    }
                    return Q;
                })(w, A, I) : "", x = [], m = (A)=>{
                var I = (A - D.buffer.byteLength + 65535) / 65536;
                try {
                    return D.grow(I), H(), 1;
                } catch (A) {}
            }, l = {
                b: (A, I, g, C)=>{
                    U(`Assertion failed: ${u(A)}, at: ` + [
                        I ? u(I) : "unknown filename",
                        g,
                        C ? u(C) : "unknown function"
                    ]);
                },
                c: ()=>{
                    U("");
                },
                a: (A, I, g)=>((A, I, g)=>{
                        var C = ((A, I)=>{
                            var g;
                            for(x.length = 0; g = w[A++];)I += 105 != g && I % 8 ? 4 : 0, x.push(105 == g ? n[I >> 2] : F[I >> 3]), I += 105 == g ? 4 : 8;
                            return x;
                        })(I, g);
                        return v[A].apply(null, C);
                    })(A, I, g),
                d: (A, I, g)=>w.copyWithin(A, I, I + g),
                e: (A)=>{
                    var I = w.length, g = 2147483648;
                    if ((A >>>= 0) > g) return !1;
                    for(var C, B = 1; B <= 4; B *= 2){
                        var Q = I * (1 + .2 / B);
                        Q = Math.min(Q, A + 100663296);
                        var i = Math.min(g, (C = Math.max(A, Q)) + (65536 - C % 65536) % 65536);
                        if (m(i)) return !0;
                    }
                    return !1;
                }
            }, z = function() {
                var A, I, g = {
                    a: l
                };
                function C(A, I) {
                    var g = A.exports;
                    return D = (z = g).f, H(), z.tc, function(A) {
                        if (p--, Q.monitorRunDependencies && Q.monitorRunDependencies(p), 0 == p && (null !== N && (clearInterval(N), N = null), J)) {
                            var I = J;
                            J = null, I();
                        }
                    }(), g;
                }
                if (p++, Q.monitorRunDependencies && Q.monitorRunDependencies(p), Q.instantiateWasm) try {
                    return Q.instantiateWasm(g, C);
                } catch (A) {
                    return t(`Module.instantiateWasm callback failed with error: ${A}`), !1;
                }
                return A = g, I = function(A) {
                    C(A.instance);
                }, (function(A) {
                    return Promise.resolve().then(()=>(function(A) {
                            if (A == Y && r) return new Uint8Array(r);
                            var I = function(A) {
                                if (b(A)) return function(A) {
                                    if (void 0 !== a && a) {
                                        var I = $97810cacbb360566$require$Buffer.from(A, "base64");
                                        return new Uint8Array(I.buffer, I.byteOffset, I.length);
                                    }
                                    try {
                                        for(var g = atob(A), C = new Uint8Array(g.length), B = 0; B < g.length; ++B)C[B] = g.charCodeAt(B);
                                        return C;
                                    } catch (A) {
                                        throw new Error("Converting base64 string to bytes failed.");
                                    }
                                }(A.slice(K.length));
                            }(A);
                            if (I) return I;
                            if (B) return B(A);
                            throw "both async and sync fetching of the wasm failed";
                        })(A));
                })(Y).then((I)=>WebAssembly.instantiate(I, A)).then((A)=>A).then(I, (A)=>{
                    t(`failed to asynchronously prepare wasm: ${A}`), U(A);
                }), {};
            }();
            function q() {
                function A() {
                    P || (P = !0, Q.calledRun = !0, S || (L(_), Q.onRuntimeInitialized && Q.onRuntimeInitialized(), function() {
                        if (Q.postRun) for("function" == typeof Q.postRun && (Q.postRun = [
                            Q.postRun
                        ]); Q.postRun.length;)A = Q.postRun.shift(), M.unshift(A);
                        var A;
                        L(M);
                    }()));
                }
                p > 0 || (function() {
                    if (Q.preRun) for("function" == typeof Q.preRun && (Q.preRun = [
                        Q.preRun
                    ]); Q.preRun.length;)A = Q.preRun.shift(), G.unshift(A);
                    var A;
                    L(G);
                }(), p > 0 || (Q.setStatus ? (Q.setStatus("Running..."), setTimeout(function() {
                    setTimeout(function() {
                        Q.setStatus("");
                    }, 1), A();
                }, 1)) : A()));
            }
            if (Q._crypto_aead_chacha20poly1305_encrypt_detached = (A, I, g, C, B, i, E, o, a, f, c, e)=>(Q._crypto_aead_chacha20poly1305_encrypt_detached = z.g)(A, I, g, C, B, i, E, o, a, f, c, e), Q._crypto_aead_chacha20poly1305_encrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_encrypt = z.h)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_ietf_encrypt_detached = (A, I, g, C, B, i, E, o, a, f, c, e)=>(Q._crypto_aead_chacha20poly1305_ietf_encrypt_detached = z.i)(A, I, g, C, B, i, E, o, a, f, c, e), Q._crypto_aead_chacha20poly1305_ietf_encrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_ietf_encrypt = z.j)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_decrypt_detached = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_decrypt_detached = z.k)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_decrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_decrypt = z.l)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_ietf_decrypt_detached = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_ietf_decrypt_detached = z.m)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_ietf_decrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_ietf_decrypt = z.n)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_ietf_keybytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_keybytes = z.o)(), Q._crypto_aead_chacha20poly1305_ietf_npubbytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_npubbytes = z.p)(), Q._crypto_aead_chacha20poly1305_ietf_nsecbytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_nsecbytes = z.q)(), Q._crypto_aead_chacha20poly1305_ietf_abytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_abytes = z.r)(), Q._crypto_aead_chacha20poly1305_ietf_messagebytes_max = ()=>(Q._crypto_aead_chacha20poly1305_ietf_messagebytes_max = z.s)(), Q._crypto_aead_chacha20poly1305_ietf_keygen = (A)=>(Q._crypto_aead_chacha20poly1305_ietf_keygen = z.t)(A), Q._crypto_aead_chacha20poly1305_keybytes = ()=>(Q._crypto_aead_chacha20poly1305_keybytes = z.u)(), Q._crypto_aead_chacha20poly1305_npubbytes = ()=>(Q._crypto_aead_chacha20poly1305_npubbytes = z.v)(), Q._crypto_aead_chacha20poly1305_nsecbytes = ()=>(Q._crypto_aead_chacha20poly1305_nsecbytes = z.w)(), Q._crypto_aead_chacha20poly1305_abytes = ()=>(Q._crypto_aead_chacha20poly1305_abytes = z.x)(), Q._crypto_aead_chacha20poly1305_messagebytes_max = ()=>(Q._crypto_aead_chacha20poly1305_messagebytes_max = z.y)(), Q._crypto_aead_chacha20poly1305_keygen = (A)=>(Q._crypto_aead_chacha20poly1305_keygen = z.z)(A), Q._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = (A, I, g, C, B, i, E, o, a, f, c, e)=>(Q._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = z.A)(A, I, g, C, B, i, E, o, a, f, c, e), Q._crypto_aead_xchacha20poly1305_ietf_encrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_xchacha20poly1305_ietf_encrypt = z.B)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = z.C)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_xchacha20poly1305_ietf_decrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_xchacha20poly1305_ietf_decrypt = z.D)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_xchacha20poly1305_ietf_keybytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_keybytes = z.E)(), Q._crypto_aead_xchacha20poly1305_ietf_npubbytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_npubbytes = z.F)(), Q._crypto_aead_xchacha20poly1305_ietf_nsecbytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_nsecbytes = z.G)(), Q._crypto_aead_xchacha20poly1305_ietf_abytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_abytes = z.H)(), Q._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = z.I)(), Q._crypto_aead_xchacha20poly1305_ietf_keygen = (A)=>(Q._crypto_aead_xchacha20poly1305_ietf_keygen = z.J)(A), Q._crypto_auth_bytes = ()=>(Q._crypto_auth_bytes = z.K)(), Q._crypto_auth_keybytes = ()=>(Q._crypto_auth_keybytes = z.L)(), Q._crypto_auth = (A, I, g, C, B)=>(Q._crypto_auth = z.M)(A, I, g, C, B), Q._crypto_auth_verify = (A, I, g, C, B)=>(Q._crypto_auth_verify = z.N)(A, I, g, C, B), Q._crypto_auth_keygen = (A)=>(Q._crypto_auth_keygen = z.O)(A), Q._crypto_box_seedbytes = ()=>(Q._crypto_box_seedbytes = z.P)(), Q._crypto_box_publickeybytes = ()=>(Q._crypto_box_publickeybytes = z.Q)(), Q._crypto_box_secretkeybytes = ()=>(Q._crypto_box_secretkeybytes = z.R)(), Q._crypto_box_beforenmbytes = ()=>(Q._crypto_box_beforenmbytes = z.S)(), Q._crypto_box_noncebytes = ()=>(Q._crypto_box_noncebytes = z.T)(), Q._crypto_box_macbytes = ()=>(Q._crypto_box_macbytes = z.U)(), Q._crypto_box_messagebytes_max = ()=>(Q._crypto_box_messagebytes_max = z.V)(), Q._crypto_box_seed_keypair = (A, I, g)=>(Q._crypto_box_seed_keypair = z.W)(A, I, g), Q._crypto_box_keypair = (A, I)=>(Q._crypto_box_keypair = z.X)(A, I), Q._crypto_box_beforenm = (A, I, g)=>(Q._crypto_box_beforenm = z.Y)(A, I, g), Q._crypto_box_detached_afternm = (A, I, g, C, B, i, E)=>(Q._crypto_box_detached_afternm = z.Z)(A, I, g, C, B, i, E), Q._crypto_box_detached = (A, I, g, C, B, i, E, o)=>(Q._crypto_box_detached = z._)(A, I, g, C, B, i, E, o), Q._crypto_box_easy_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_easy_afternm = z.$)(A, I, g, C, B, i), Q._crypto_box_easy = (A, I, g, C, B, i, E)=>(Q._crypto_box_easy = z.aa)(A, I, g, C, B, i, E), Q._crypto_box_open_detached_afternm = (A, I, g, C, B, i, E)=>(Q._crypto_box_open_detached_afternm = z.ba)(A, I, g, C, B, i, E), Q._crypto_box_open_detached = (A, I, g, C, B, i, E, o)=>(Q._crypto_box_open_detached = z.ca)(A, I, g, C, B, i, E, o), Q._crypto_box_open_easy_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_open_easy_afternm = z.da)(A, I, g, C, B, i), Q._crypto_box_open_easy = (A, I, g, C, B, i, E)=>(Q._crypto_box_open_easy = z.ea)(A, I, g, C, B, i, E), Q._crypto_box_seal = (A, I, g, C, B)=>(Q._crypto_box_seal = z.fa)(A, I, g, C, B), Q._crypto_box_seal_open = (A, I, g, C, B, i)=>(Q._crypto_box_seal_open = z.ga)(A, I, g, C, B, i), Q._crypto_box_sealbytes = ()=>(Q._crypto_box_sealbytes = z.ha)(), Q._crypto_generichash_bytes_min = ()=>(Q._crypto_generichash_bytes_min = z.ia)(), Q._crypto_generichash_bytes_max = ()=>(Q._crypto_generichash_bytes_max = z.ja)(), Q._crypto_generichash_bytes = ()=>(Q._crypto_generichash_bytes = z.ka)(), Q._crypto_generichash_keybytes_min = ()=>(Q._crypto_generichash_keybytes_min = z.la)(), Q._crypto_generichash_keybytes_max = ()=>(Q._crypto_generichash_keybytes_max = z.ma)(), Q._crypto_generichash_keybytes = ()=>(Q._crypto_generichash_keybytes = z.na)(), Q._crypto_generichash_statebytes = ()=>(Q._crypto_generichash_statebytes = z.oa)(), Q._crypto_generichash = (A, I, g, C, B, i, E)=>(Q._crypto_generichash = z.pa)(A, I, g, C, B, i, E), Q._crypto_generichash_init = (A, I, g, C)=>(Q._crypto_generichash_init = z.qa)(A, I, g, C), Q._crypto_generichash_update = (A, I, g, C)=>(Q._crypto_generichash_update = z.ra)(A, I, g, C), Q._crypto_generichash_final = (A, I, g)=>(Q._crypto_generichash_final = z.sa)(A, I, g), Q._crypto_generichash_keygen = (A)=>(Q._crypto_generichash_keygen = z.ta)(A), Q._crypto_hash_bytes = ()=>(Q._crypto_hash_bytes = z.ua)(), Q._crypto_hash = (A, I, g, C)=>(Q._crypto_hash = z.va)(A, I, g, C), Q._crypto_kdf_bytes_min = ()=>(Q._crypto_kdf_bytes_min = z.wa)(), Q._crypto_kdf_bytes_max = ()=>(Q._crypto_kdf_bytes_max = z.xa)(), Q._crypto_kdf_contextbytes = ()=>(Q._crypto_kdf_contextbytes = z.ya)(), Q._crypto_kdf_keybytes = ()=>(Q._crypto_kdf_keybytes = z.za)(), Q._crypto_kdf_derive_from_key = (A, I, g, C, B, i)=>(Q._crypto_kdf_derive_from_key = z.Aa)(A, I, g, C, B, i), Q._crypto_kdf_keygen = (A)=>(Q._crypto_kdf_keygen = z.Ba)(A), Q._crypto_kdf_hkdf_sha256_extract_init = (A, I, g)=>(Q._crypto_kdf_hkdf_sha256_extract_init = z.Ca)(A, I, g), Q._crypto_kdf_hkdf_sha256_extract_update = (A, I, g)=>(Q._crypto_kdf_hkdf_sha256_extract_update = z.Da)(A, I, g), Q._crypto_kdf_hkdf_sha256_extract_final = (A, I)=>(Q._crypto_kdf_hkdf_sha256_extract_final = z.Ea)(A, I), Q._crypto_kdf_hkdf_sha256_extract = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha256_extract = z.Fa)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha256_keygen = (A)=>(Q._crypto_kdf_hkdf_sha256_keygen = z.Ga)(A), Q._crypto_kdf_hkdf_sha256_expand = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha256_expand = z.Ha)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha256_keybytes = ()=>(Q._crypto_kdf_hkdf_sha256_keybytes = z.Ia)(), Q._crypto_kdf_hkdf_sha256_bytes_min = ()=>(Q._crypto_kdf_hkdf_sha256_bytes_min = z.Ja)(), Q._crypto_kdf_hkdf_sha256_bytes_max = ()=>(Q._crypto_kdf_hkdf_sha256_bytes_max = z.Ka)(), Q._crypto_kdf_hkdf_sha256_statebytes = ()=>(Q._crypto_kdf_hkdf_sha256_statebytes = z.La)(), Q._crypto_kdf_hkdf_sha512_extract_init = (A, I, g)=>(Q._crypto_kdf_hkdf_sha512_extract_init = z.Ma)(A, I, g), Q._crypto_kdf_hkdf_sha512_extract_update = (A, I, g)=>(Q._crypto_kdf_hkdf_sha512_extract_update = z.Na)(A, I, g), Q._crypto_kdf_hkdf_sha512_extract_final = (A, I)=>(Q._crypto_kdf_hkdf_sha512_extract_final = z.Oa)(A, I), Q._crypto_kdf_hkdf_sha512_extract = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha512_extract = z.Pa)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha512_keygen = (A)=>(Q._crypto_kdf_hkdf_sha512_keygen = z.Qa)(A), Q._crypto_kdf_hkdf_sha512_expand = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha512_expand = z.Ra)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha512_keybytes = ()=>(Q._crypto_kdf_hkdf_sha512_keybytes = z.Sa)(), Q._crypto_kdf_hkdf_sha512_bytes_min = ()=>(Q._crypto_kdf_hkdf_sha512_bytes_min = z.Ta)(), Q._crypto_kdf_hkdf_sha512_bytes_max = ()=>(Q._crypto_kdf_hkdf_sha512_bytes_max = z.Ua)(), Q._crypto_kx_seed_keypair = (A, I, g)=>(Q._crypto_kx_seed_keypair = z.Va)(A, I, g), Q._crypto_kx_keypair = (A, I)=>(Q._crypto_kx_keypair = z.Wa)(A, I), Q._crypto_kx_client_session_keys = (A, I, g, C, B)=>(Q._crypto_kx_client_session_keys = z.Xa)(A, I, g, C, B), Q._crypto_kx_server_session_keys = (A, I, g, C, B)=>(Q._crypto_kx_server_session_keys = z.Ya)(A, I, g, C, B), Q._crypto_kx_publickeybytes = ()=>(Q._crypto_kx_publickeybytes = z.Za)(), Q._crypto_kx_secretkeybytes = ()=>(Q._crypto_kx_secretkeybytes = z._a)(), Q._crypto_kx_seedbytes = ()=>(Q._crypto_kx_seedbytes = z.$a)(), Q._crypto_kx_sessionkeybytes = ()=>(Q._crypto_kx_sessionkeybytes = z.ab)(), Q._crypto_scalarmult_base = (A, I)=>(Q._crypto_scalarmult_base = z.bb)(A, I), Q._crypto_scalarmult = (A, I, g)=>(Q._crypto_scalarmult = z.cb)(A, I, g), Q._crypto_scalarmult_bytes = ()=>(Q._crypto_scalarmult_bytes = z.db)(), Q._crypto_scalarmult_scalarbytes = ()=>(Q._crypto_scalarmult_scalarbytes = z.eb)(), Q._crypto_secretbox_keybytes = ()=>(Q._crypto_secretbox_keybytes = z.fb)(), Q._crypto_secretbox_noncebytes = ()=>(Q._crypto_secretbox_noncebytes = z.gb)(), Q._crypto_secretbox_macbytes = ()=>(Q._crypto_secretbox_macbytes = z.hb)(), Q._crypto_secretbox_messagebytes_max = ()=>(Q._crypto_secretbox_messagebytes_max = z.ib)(), Q._crypto_secretbox_keygen = (A)=>(Q._crypto_secretbox_keygen = z.jb)(A), Q._crypto_secretbox_detached = (A, I, g, C, B, i, E)=>(Q._crypto_secretbox_detached = z.kb)(A, I, g, C, B, i, E), Q._crypto_secretbox_easy = (A, I, g, C, B, i)=>(Q._crypto_secretbox_easy = z.lb)(A, I, g, C, B, i), Q._crypto_secretbox_open_detached = (A, I, g, C, B, i, E)=>(Q._crypto_secretbox_open_detached = z.mb)(A, I, g, C, B, i, E), Q._crypto_secretbox_open_easy = (A, I, g, C, B, i)=>(Q._crypto_secretbox_open_easy = z.nb)(A, I, g, C, B, i), Q._crypto_secretstream_xchacha20poly1305_keygen = (A)=>(Q._crypto_secretstream_xchacha20poly1305_keygen = z.ob)(A), Q._crypto_secretstream_xchacha20poly1305_init_push = (A, I, g)=>(Q._crypto_secretstream_xchacha20poly1305_init_push = z.pb)(A, I, g), Q._crypto_secretstream_xchacha20poly1305_init_pull = (A, I, g)=>(Q._crypto_secretstream_xchacha20poly1305_init_pull = z.qb)(A, I, g), Q._crypto_secretstream_xchacha20poly1305_rekey = (A)=>(Q._crypto_secretstream_xchacha20poly1305_rekey = z.rb)(A), Q._crypto_secretstream_xchacha20poly1305_push = (A, I, g, C, B, i, E, o, a, f)=>(Q._crypto_secretstream_xchacha20poly1305_push = z.sb)(A, I, g, C, B, i, E, o, a, f), Q._crypto_secretstream_xchacha20poly1305_pull = (A, I, g, C, B, i, E, o, a, f)=>(Q._crypto_secretstream_xchacha20poly1305_pull = z.tb)(A, I, g, C, B, i, E, o, a, f), Q._crypto_secretstream_xchacha20poly1305_statebytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_statebytes = z.ub)(), Q._crypto_secretstream_xchacha20poly1305_abytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_abytes = z.vb)(), Q._crypto_secretstream_xchacha20poly1305_headerbytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_headerbytes = z.wb)(), Q._crypto_secretstream_xchacha20poly1305_keybytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_keybytes = z.xb)(), Q._crypto_secretstream_xchacha20poly1305_messagebytes_max = ()=>(Q._crypto_secretstream_xchacha20poly1305_messagebytes_max = z.yb)(), Q._crypto_secretstream_xchacha20poly1305_tag_message = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_message = z.zb)(), Q._crypto_secretstream_xchacha20poly1305_tag_push = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_push = z.Ab)(), Q._crypto_secretstream_xchacha20poly1305_tag_rekey = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_rekey = z.Bb)(), Q._crypto_secretstream_xchacha20poly1305_tag_final = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_final = z.Cb)(), Q._crypto_shorthash_bytes = ()=>(Q._crypto_shorthash_bytes = z.Db)(), Q._crypto_shorthash_keybytes = ()=>(Q._crypto_shorthash_keybytes = z.Eb)(), Q._crypto_shorthash = (A, I, g, C, B)=>(Q._crypto_shorthash = z.Fb)(A, I, g, C, B), Q._crypto_shorthash_keygen = (A)=>(Q._crypto_shorthash_keygen = z.Gb)(A), Q._crypto_sign_statebytes = ()=>(Q._crypto_sign_statebytes = z.Hb)(), Q._crypto_sign_bytes = ()=>(Q._crypto_sign_bytes = z.Ib)(), Q._crypto_sign_seedbytes = ()=>(Q._crypto_sign_seedbytes = z.Jb)(), Q._crypto_sign_publickeybytes = ()=>(Q._crypto_sign_publickeybytes = z.Kb)(), Q._crypto_sign_secretkeybytes = ()=>(Q._crypto_sign_secretkeybytes = z.Lb)(), Q._crypto_sign_messagebytes_max = ()=>(Q._crypto_sign_messagebytes_max = z.Mb)(), Q._crypto_sign_seed_keypair = (A, I, g)=>(Q._crypto_sign_seed_keypair = z.Nb)(A, I, g), Q._crypto_sign_keypair = (A, I)=>(Q._crypto_sign_keypair = z.Ob)(A, I), Q._crypto_sign = (A, I, g, C, B, i)=>(Q._crypto_sign = z.Pb)(A, I, g, C, B, i), Q._crypto_sign_open = (A, I, g, C, B, i)=>(Q._crypto_sign_open = z.Qb)(A, I, g, C, B, i), Q._crypto_sign_detached = (A, I, g, C, B, i)=>(Q._crypto_sign_detached = z.Rb)(A, I, g, C, B, i), Q._crypto_sign_verify_detached = (A, I, g, C, B)=>(Q._crypto_sign_verify_detached = z.Sb)(A, I, g, C, B), Q._crypto_sign_init = (A)=>(Q._crypto_sign_init = z.Tb)(A), Q._crypto_sign_update = (A, I, g, C)=>(Q._crypto_sign_update = z.Ub)(A, I, g, C), Q._crypto_sign_final_create = (A, I, g, C)=>(Q._crypto_sign_final_create = z.Vb)(A, I, g, C), Q._crypto_sign_final_verify = (A, I, g)=>(Q._crypto_sign_final_verify = z.Wb)(A, I, g), Q._crypto_sign_ed25519_pk_to_curve25519 = (A, I)=>(Q._crypto_sign_ed25519_pk_to_curve25519 = z.Xb)(A, I), Q._crypto_sign_ed25519_sk_to_curve25519 = (A, I)=>(Q._crypto_sign_ed25519_sk_to_curve25519 = z.Yb)(A, I), Q._randombytes_random = ()=>(Q._randombytes_random = z.Zb)(), Q._randombytes_stir = ()=>(Q._randombytes_stir = z._b)(), Q._randombytes_uniform = (A)=>(Q._randombytes_uniform = z.$b)(A), Q._randombytes_buf = (A, I)=>(Q._randombytes_buf = z.ac)(A, I), Q._randombytes_buf_deterministic = (A, I, g)=>(Q._randombytes_buf_deterministic = z.bc)(A, I, g), Q._randombytes_seedbytes = ()=>(Q._randombytes_seedbytes = z.cc)(), Q._randombytes_close = ()=>(Q._randombytes_close = z.dc)(), Q._randombytes = (A, I, g)=>(Q._randombytes = z.ec)(A, I, g), Q._sodium_bin2hex = (A, I, g, C)=>(Q._sodium_bin2hex = z.fc)(A, I, g, C), Q._sodium_hex2bin = (A, I, g, C, B, i, E)=>(Q._sodium_hex2bin = z.gc)(A, I, g, C, B, i, E), Q._sodium_base64_encoded_len = (A, I)=>(Q._sodium_base64_encoded_len = z.hc)(A, I), Q._sodium_bin2base64 = (A, I, g, C, B)=>(Q._sodium_bin2base64 = z.ic)(A, I, g, C, B), Q._sodium_base642bin = (A, I, g, C, B, i, E, o)=>(Q._sodium_base642bin = z.jc)(A, I, g, C, B, i, E, o), Q._sodium_init = ()=>(Q._sodium_init = z.kc)(), Q._sodium_pad = (A, I, g, C, B)=>(Q._sodium_pad = z.lc)(A, I, g, C, B), Q._sodium_unpad = (A, I, g, C)=>(Q._sodium_unpad = z.mc)(A, I, g, C), Q._sodium_version_string = ()=>(Q._sodium_version_string = z.nc)(), Q._sodium_library_version_major = ()=>(Q._sodium_library_version_major = z.oc)(), Q._sodium_library_version_minor = ()=>(Q._sodium_library_version_minor = z.pc)(), Q._sodium_library_minimal = ()=>(Q._sodium_library_minimal = z.qc)(), Q._malloc = (A)=>(Q._malloc = z.rc)(A), Q._free = (A)=>(Q._free = z.sc)(A), Q.setValue = function(A, I, g = "i8") {
                switch(g.endsWith("*") && (g = "*"), g){
                    case "i1":
                    case "i8":
                        y[A >> 0] = I;
                        break;
                    case "i16":
                        h[A >> 1] = I;
                        break;
                    case "i32":
                        n[A >> 2] = I;
                        break;
                    case "i64":
                        U("to do setValue(i64) use WASM_BIGINT");
                    case "float":
                        k[A >> 2] = I;
                        break;
                    case "double":
                        F[A >> 3] = I;
                        break;
                    case "*":
                        s[A >> 2] = I;
                        break;
                    default:
                        U(`invalid type for setValue: ${g}`);
                }
            }, Q.getValue = function(A, I = "i8") {
                switch(I.endsWith("*") && (I = "*"), I){
                    case "i1":
                    case "i8":
                        return y[A >> 0];
                    case "i16":
                        return h[A >> 1];
                    case "i32":
                        return n[A >> 2];
                    case "i64":
                        U("to do getValue(i64) use WASM_BIGINT");
                    case "float":
                        return k[A >> 2];
                    case "double":
                        return F[A >> 3];
                    case "*":
                        return s[A >> 2];
                    default:
                        U(`invalid type for getValue: ${I}`);
                }
            }, Q.UTF8ToString = u, J = function A() {
                P || q(), P || (J = A);
            }, Q.preInit) for("function" == typeof Q.preInit && (Q.preInit = [
                Q.preInit
            ]); Q.preInit.length > 0;)Q.preInit.pop()();
            q();
        }).catch(function() {
            return C.useBackupModule();
        }), I;
    }
    "function" == typeof define && define.amd ? define([
        "exports"
    ], I) : "string" != typeof module.exports.nodeName ? I(module.exports) : A.libsodium = I(A.libsodium_mod || (A.commonJsStrict = {}));
}(module.exports);

});
parcelRegister("a8i8g", function(module, exports) {
// shim for using process in browser
var $7608b7726638efe3$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $7608b7726638efe3$var$cachedSetTimeout;
var $7608b7726638efe3$var$cachedClearTimeout;
function $7608b7726638efe3$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $7608b7726638efe3$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $7608b7726638efe3$var$cachedSetTimeout = setTimeout;
        else $7608b7726638efe3$var$cachedSetTimeout = $7608b7726638efe3$var$defaultSetTimout;
    } catch (e) {
        $7608b7726638efe3$var$cachedSetTimeout = $7608b7726638efe3$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $7608b7726638efe3$var$cachedClearTimeout = clearTimeout;
        else $7608b7726638efe3$var$cachedClearTimeout = $7608b7726638efe3$var$defaultClearTimeout;
    } catch (e) {
        $7608b7726638efe3$var$cachedClearTimeout = $7608b7726638efe3$var$defaultClearTimeout;
    }
})();
function $7608b7726638efe3$var$runTimeout(fun) {
    if ($7608b7726638efe3$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($7608b7726638efe3$var$cachedSetTimeout === $7608b7726638efe3$var$defaultSetTimout || !$7608b7726638efe3$var$cachedSetTimeout) && setTimeout) {
        $7608b7726638efe3$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $7608b7726638efe3$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $7608b7726638efe3$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $7608b7726638efe3$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $7608b7726638efe3$var$runClearTimeout(marker) {
    if ($7608b7726638efe3$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($7608b7726638efe3$var$cachedClearTimeout === $7608b7726638efe3$var$defaultClearTimeout || !$7608b7726638efe3$var$cachedClearTimeout) && clearTimeout) {
        $7608b7726638efe3$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $7608b7726638efe3$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $7608b7726638efe3$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $7608b7726638efe3$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $7608b7726638efe3$var$queue = [];
var $7608b7726638efe3$var$draining = false;
var $7608b7726638efe3$var$currentQueue;
var $7608b7726638efe3$var$queueIndex = -1;
function $7608b7726638efe3$var$cleanUpNextTick() {
    if (!$7608b7726638efe3$var$draining || !$7608b7726638efe3$var$currentQueue) return;
    $7608b7726638efe3$var$draining = false;
    if ($7608b7726638efe3$var$currentQueue.length) $7608b7726638efe3$var$queue = $7608b7726638efe3$var$currentQueue.concat($7608b7726638efe3$var$queue);
    else $7608b7726638efe3$var$queueIndex = -1;
    if ($7608b7726638efe3$var$queue.length) $7608b7726638efe3$var$drainQueue();
}
function $7608b7726638efe3$var$drainQueue() {
    if ($7608b7726638efe3$var$draining) return;
    var timeout = $7608b7726638efe3$var$runTimeout($7608b7726638efe3$var$cleanUpNextTick);
    $7608b7726638efe3$var$draining = true;
    var len = $7608b7726638efe3$var$queue.length;
    while(len){
        $7608b7726638efe3$var$currentQueue = $7608b7726638efe3$var$queue;
        $7608b7726638efe3$var$queue = [];
        while(++$7608b7726638efe3$var$queueIndex < len)if ($7608b7726638efe3$var$currentQueue) $7608b7726638efe3$var$currentQueue[$7608b7726638efe3$var$queueIndex].run();
        $7608b7726638efe3$var$queueIndex = -1;
        len = $7608b7726638efe3$var$queue.length;
    }
    $7608b7726638efe3$var$currentQueue = null;
    $7608b7726638efe3$var$draining = false;
    $7608b7726638efe3$var$runClearTimeout(timeout);
}
$7608b7726638efe3$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $7608b7726638efe3$var$queue.push(new $7608b7726638efe3$var$Item(fun, args));
    if ($7608b7726638efe3$var$queue.length === 1 && !$7608b7726638efe3$var$draining) $7608b7726638efe3$var$runTimeout($7608b7726638efe3$var$drainQueue);
};
// v8 likes predictible objects
function $7608b7726638efe3$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$7608b7726638efe3$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$7608b7726638efe3$var$process.title = "browser";
$7608b7726638efe3$var$process.browser = true;
$7608b7726638efe3$var$process.env = {};
$7608b7726638efe3$var$process.argv = [];
$7608b7726638efe3$var$process.version = ""; // empty string to avoid regexp issues
$7608b7726638efe3$var$process.versions = {};
function $7608b7726638efe3$var$noop() {}
$7608b7726638efe3$var$process.on = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.addListener = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.once = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.off = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.removeListener = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.removeAllListeners = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.emit = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.prependListener = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.prependOnceListener = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.listeners = function(name) {
    return [];
};
$7608b7726638efe3$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$7608b7726638efe3$var$process.cwd = function() {
    return "/";
};
$7608b7726638efe3$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$7608b7726638efe3$var$process.umask = function() {
    return 0;
};

});

parcelRegister("gzLuY", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $c114c26e12685207$export$a143d493d941bafc; }, function (v) { return $c114c26e12685207$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "SlowBuffer", function () { return $c114c26e12685207$export$e4cf37d7f6fb9e0a; }, function (v) { return $c114c26e12685207$export$e4cf37d7f6fb9e0a = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $c114c26e12685207$export$f99ded8fe4b79145; }, function (v) { return $c114c26e12685207$export$f99ded8fe4b79145 = v; });
$parcel$export(module.exports, "kMaxLength", function () { return $c114c26e12685207$export$599f31c3813fae4d; }, function (v) { return $c114c26e12685207$export$599f31c3813fae4d = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $c114c26e12685207$export$a143d493d941bafc;
var $c114c26e12685207$export$e4cf37d7f6fb9e0a;
var $c114c26e12685207$export$f99ded8fe4b79145;
var $c114c26e12685207$export$599f31c3813fae4d;
"use strict";

var $7LFKz = parcelRequire("7LFKz");

var $69U7b = parcelRequire("69U7b");
const $c114c26e12685207$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$c114c26e12685207$export$a143d493d941bafc = $c114c26e12685207$var$Buffer;
$c114c26e12685207$export$e4cf37d7f6fb9e0a = $c114c26e12685207$var$SlowBuffer;
$c114c26e12685207$export$f99ded8fe4b79145 = 50;
const $c114c26e12685207$var$K_MAX_LENGTH = 0x7fffffff;
$c114c26e12685207$export$599f31c3813fae4d = $c114c26e12685207$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $c114c26e12685207$var$Buffer.TYPED_ARRAY_SUPPORT = $c114c26e12685207$var$typedArraySupport();
if (!$c114c26e12685207$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $c114c26e12685207$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($c114c26e12685207$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$c114c26e12685207$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($c114c26e12685207$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$c114c26e12685207$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $c114c26e12685207$var$createBuffer(length) {
    if (length > $c114c26e12685207$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $c114c26e12685207$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $c114c26e12685207$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $c114c26e12685207$var$allocUnsafe(arg);
    }
    return $c114c26e12685207$var$from(arg, encodingOrOffset, length);
}
$c114c26e12685207$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $c114c26e12685207$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $c114c26e12685207$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $c114c26e12685207$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($c114c26e12685207$var$isInstance(value, ArrayBuffer) || value && $c114c26e12685207$var$isInstance(value.buffer, ArrayBuffer)) return $c114c26e12685207$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($c114c26e12685207$var$isInstance(value, SharedArrayBuffer) || value && $c114c26e12685207$var$isInstance(value.buffer, SharedArrayBuffer))) return $c114c26e12685207$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $c114c26e12685207$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $c114c26e12685207$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $c114c26e12685207$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $c114c26e12685207$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $c114c26e12685207$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($c114c26e12685207$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($c114c26e12685207$var$Buffer, Uint8Array);
function $c114c26e12685207$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $c114c26e12685207$var$alloc(size, fill, encoding) {
    $c114c26e12685207$var$assertSize(size);
    if (size <= 0) return $c114c26e12685207$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $c114c26e12685207$var$createBuffer(size).fill(fill, encoding) : $c114c26e12685207$var$createBuffer(size).fill(fill);
    return $c114c26e12685207$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $c114c26e12685207$var$Buffer.alloc = function(size, fill, encoding) {
    return $c114c26e12685207$var$alloc(size, fill, encoding);
};
function $c114c26e12685207$var$allocUnsafe(size) {
    $c114c26e12685207$var$assertSize(size);
    return $c114c26e12685207$var$createBuffer(size < 0 ? 0 : $c114c26e12685207$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $c114c26e12685207$var$Buffer.allocUnsafe = function(size) {
    return $c114c26e12685207$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $c114c26e12685207$var$Buffer.allocUnsafeSlow = function(size) {
    return $c114c26e12685207$var$allocUnsafe(size);
};
function $c114c26e12685207$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$c114c26e12685207$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $c114c26e12685207$var$byteLength(string, encoding) | 0;
    let buf = $c114c26e12685207$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $c114c26e12685207$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $c114c26e12685207$var$checked(array.length) | 0;
    const buf = $c114c26e12685207$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $c114c26e12685207$var$fromArrayView(arrayView) {
    if ($c114c26e12685207$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $c114c26e12685207$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $c114c26e12685207$var$fromArrayLike(arrayView);
}
function $c114c26e12685207$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $c114c26e12685207$var$Buffer.prototype);
    return buf;
}
function $c114c26e12685207$var$fromObject(obj) {
    if ($c114c26e12685207$var$Buffer.isBuffer(obj)) {
        const len = $c114c26e12685207$var$checked(obj.length) | 0;
        const buf = $c114c26e12685207$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $c114c26e12685207$var$numberIsNaN(obj.length)) return $c114c26e12685207$var$createBuffer(0);
        return $c114c26e12685207$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $c114c26e12685207$var$fromArrayLike(obj.data);
}
function $c114c26e12685207$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $c114c26e12685207$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $c114c26e12685207$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $c114c26e12685207$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $c114c26e12685207$var$Buffer.alloc(+length);
}
$c114c26e12685207$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $c114c26e12685207$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$c114c26e12685207$var$Buffer.compare = function compare(a, b) {
    if ($c114c26e12685207$var$isInstance(a, Uint8Array)) a = $c114c26e12685207$var$Buffer.from(a, a.offset, a.byteLength);
    if ($c114c26e12685207$var$isInstance(b, Uint8Array)) b = $c114c26e12685207$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$c114c26e12685207$var$Buffer.isBuffer(a) || !$c114c26e12685207$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$c114c26e12685207$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$c114c26e12685207$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $c114c26e12685207$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $c114c26e12685207$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($c114c26e12685207$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$c114c26e12685207$var$Buffer.isBuffer(buf)) buf = $c114c26e12685207$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$c114c26e12685207$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $c114c26e12685207$var$byteLength(string, encoding) {
    if ($c114c26e12685207$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $c114c26e12685207$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $c114c26e12685207$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $c114c26e12685207$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $c114c26e12685207$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$c114c26e12685207$var$Buffer.byteLength = $c114c26e12685207$var$byteLength;
function $c114c26e12685207$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $c114c26e12685207$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $c114c26e12685207$var$utf8Slice(this, start, end);
        case "ascii":
            return $c114c26e12685207$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $c114c26e12685207$var$latin1Slice(this, start, end);
        case "base64":
            return $c114c26e12685207$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $c114c26e12685207$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$c114c26e12685207$var$Buffer.prototype._isBuffer = true;
function $c114c26e12685207$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$c114c26e12685207$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$c114c26e12685207$var$swap(this, i, i + 1);
    return this;
};
$c114c26e12685207$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $c114c26e12685207$var$swap(this, i, i + 3);
        $c114c26e12685207$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$c114c26e12685207$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $c114c26e12685207$var$swap(this, i, i + 7);
        $c114c26e12685207$var$swap(this, i + 1, i + 6);
        $c114c26e12685207$var$swap(this, i + 2, i + 5);
        $c114c26e12685207$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$c114c26e12685207$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $c114c26e12685207$var$utf8Slice(this, 0, length);
    return $c114c26e12685207$var$slowToString.apply(this, arguments);
};
$c114c26e12685207$var$Buffer.prototype.toLocaleString = $c114c26e12685207$var$Buffer.prototype.toString;
$c114c26e12685207$var$Buffer.prototype.equals = function equals(b) {
    if (!$c114c26e12685207$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $c114c26e12685207$var$Buffer.compare(this, b) === 0;
};
$c114c26e12685207$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $c114c26e12685207$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($c114c26e12685207$var$customInspectSymbol) $c114c26e12685207$var$Buffer.prototype[$c114c26e12685207$var$customInspectSymbol] = $c114c26e12685207$var$Buffer.prototype.inspect;
$c114c26e12685207$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($c114c26e12685207$var$isInstance(target, Uint8Array)) target = $c114c26e12685207$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$c114c26e12685207$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $c114c26e12685207$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($c114c26e12685207$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $c114c26e12685207$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($c114c26e12685207$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $c114c26e12685207$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $c114c26e12685207$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $c114c26e12685207$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$c114c26e12685207$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$c114c26e12685207$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $c114c26e12685207$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$c114c26e12685207$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $c114c26e12685207$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $c114c26e12685207$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($c114c26e12685207$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $c114c26e12685207$var$utf8Write(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $c114c26e12685207$var$asciiWrite(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$asciiToBytes(string), buf, offset, length);
}
function $c114c26e12685207$var$base64Write(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$base64ToBytes(string), buf, offset, length);
}
function $c114c26e12685207$var$ucs2Write(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$c114c26e12685207$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $c114c26e12685207$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $c114c26e12685207$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $c114c26e12685207$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $c114c26e12685207$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $c114c26e12685207$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$c114c26e12685207$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $c114c26e12685207$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $7LFKz.fromByteArray(buf);
    else return $7LFKz.fromByteArray(buf.slice(start, end));
}
function $c114c26e12685207$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $c114c26e12685207$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $c114c26e12685207$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $c114c26e12685207$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $c114c26e12685207$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $c114c26e12685207$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $c114c26e12685207$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $c114c26e12685207$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $c114c26e12685207$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $c114c26e12685207$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $c114c26e12685207$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$c114c26e12685207$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $c114c26e12685207$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $c114c26e12685207$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$c114c26e12685207$var$Buffer.prototype.readUintLE = $c114c26e12685207$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readUintBE = $c114c26e12685207$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readUint8 = $c114c26e12685207$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$c114c26e12685207$var$Buffer.prototype.readUint16LE = $c114c26e12685207$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$c114c26e12685207$var$Buffer.prototype.readUint16BE = $c114c26e12685207$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$c114c26e12685207$var$Buffer.prototype.readUint32LE = $c114c26e12685207$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$c114c26e12685207$var$Buffer.prototype.readUint32BE = $c114c26e12685207$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$c114c26e12685207$var$Buffer.prototype.readBigUInt64LE = $c114c26e12685207$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $c114c26e12685207$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c114c26e12685207$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$c114c26e12685207$var$Buffer.prototype.readBigUInt64BE = $c114c26e12685207$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $c114c26e12685207$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c114c26e12685207$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$c114c26e12685207$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$c114c26e12685207$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$c114c26e12685207$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$c114c26e12685207$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$c114c26e12685207$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$c114c26e12685207$var$Buffer.prototype.readBigInt64LE = $c114c26e12685207$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $c114c26e12685207$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c114c26e12685207$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$c114c26e12685207$var$Buffer.prototype.readBigInt64BE = $c114c26e12685207$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $c114c26e12685207$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c114c26e12685207$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$c114c26e12685207$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return $69U7b.read(this, offset, true, 23, 4);
};
$c114c26e12685207$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return $69U7b.read(this, offset, false, 23, 4);
};
$c114c26e12685207$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 8, this.length);
    return $69U7b.read(this, offset, true, 52, 8);
};
$c114c26e12685207$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 8, this.length);
    return $69U7b.read(this, offset, false, 52, 8);
};
function $c114c26e12685207$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$c114c26e12685207$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$c114c26e12685207$var$Buffer.prototype.writeUintLE = $c114c26e12685207$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeUintBE = $c114c26e12685207$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeUint8 = $c114c26e12685207$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$c114c26e12685207$var$Buffer.prototype.writeUint16LE = $c114c26e12685207$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeUint16BE = $c114c26e12685207$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeUint32LE = $c114c26e12685207$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$c114c26e12685207$var$Buffer.prototype.writeUint32BE = $c114c26e12685207$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $c114c26e12685207$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $c114c26e12685207$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $c114c26e12685207$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $c114c26e12685207$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$c114c26e12685207$var$Buffer.prototype.writeBigUInt64LE = $c114c26e12685207$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $c114c26e12685207$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$c114c26e12685207$var$Buffer.prototype.writeBigUInt64BE = $c114c26e12685207$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $c114c26e12685207$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$c114c26e12685207$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$c114c26e12685207$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$c114c26e12685207$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$c114c26e12685207$var$Buffer.prototype.writeBigInt64LE = $c114c26e12685207$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $c114c26e12685207$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$c114c26e12685207$var$Buffer.prototype.writeBigInt64BE = $c114c26e12685207$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $c114c26e12685207$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $c114c26e12685207$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $c114c26e12685207$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $69U7b.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$c114c26e12685207$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeFloat(this, value, offset, true, noAssert);
};
$c114c26e12685207$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeFloat(this, value, offset, false, noAssert);
};
function $c114c26e12685207$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $69U7b.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$c114c26e12685207$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeDouble(this, value, offset, true, noAssert);
};
$c114c26e12685207$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$c114c26e12685207$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$c114c26e12685207$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$c114c26e12685207$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$c114c26e12685207$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $c114c26e12685207$var$Buffer.isBuffer(val) ? val : $c114c26e12685207$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $c114c26e12685207$var$errors = {};
function $c114c26e12685207$var$E(sym, getMessage, Base) {
    $c114c26e12685207$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$c114c26e12685207$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$c114c26e12685207$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$c114c26e12685207$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $c114c26e12685207$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $c114c26e12685207$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $c114c26e12685207$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $c114c26e12685207$var$checkBounds(buf, offset, byteLength) {
    $c114c26e12685207$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $c114c26e12685207$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $c114c26e12685207$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $c114c26e12685207$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $c114c26e12685207$var$checkBounds(buf, offset, byteLength);
}
function $c114c26e12685207$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $c114c26e12685207$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $c114c26e12685207$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $c114c26e12685207$var$validateNumber(value, type);
        throw new $c114c26e12685207$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $c114c26e12685207$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $c114c26e12685207$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $c114c26e12685207$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $c114c26e12685207$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($c114c26e12685207$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $c114c26e12685207$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $c114c26e12685207$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $c114c26e12685207$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $c114c26e12685207$var$base64ToBytes(str) {
    return $7LFKz.toByteArray($c114c26e12685207$var$base64clean(str));
}
function $c114c26e12685207$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $c114c26e12685207$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $c114c26e12685207$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $c114c26e12685207$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $c114c26e12685207$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $c114c26e12685207$var$BufferBigIntNotDefined : fn;
}
function $c114c26e12685207$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("69U7b", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $47bf1c92b6d3ec4f$export$aafa59e2e03f2942; }, function (v) { return $47bf1c92b6d3ec4f$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $47bf1c92b6d3ec4f$export$68d8715fc104d294; }, function (v) { return $47bf1c92b6d3ec4f$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $47bf1c92b6d3ec4f$export$aafa59e2e03f2942;
var $47bf1c92b6d3ec4f$export$68d8715fc104d294;
$47bf1c92b6d3ec4f$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$47bf1c92b6d3ec4f$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("7HCQr", function(module, exports) {

$parcel$export(module.exports, "randomBytes", function () { return $01727eaed9f6d092$export$5f828d93ff035aa8; }, function (v) { return $01727eaed9f6d092$export$5f828d93ff035aa8 = v; });
$parcel$export(module.exports, "rng", function () { return $01727eaed9f6d092$export$cd94982b18c6332c; }, function (v) { return $01727eaed9f6d092$export$cd94982b18c6332c = v; });
$parcel$export(module.exports, "pseudoRandomBytes", function () { return $01727eaed9f6d092$export$1d518568e4f529b0; }, function (v) { return $01727eaed9f6d092$export$1d518568e4f529b0 = v; });
$parcel$export(module.exports, "prng", function () { return $01727eaed9f6d092$export$5285b6d41c912b41; }, function (v) { return $01727eaed9f6d092$export$5285b6d41c912b41 = v; });
$parcel$export(module.exports, "createHash", function () { return $01727eaed9f6d092$export$2fb37efbf6ae0c0e; }, function (v) { return $01727eaed9f6d092$export$2fb37efbf6ae0c0e = v; });
$parcel$export(module.exports, "Hash", function () { return $01727eaed9f6d092$export$ab85ecd77ce6a5cd; }, function (v) { return $01727eaed9f6d092$export$ab85ecd77ce6a5cd = v; });
$parcel$export(module.exports, "createHmac", function () { return $01727eaed9f6d092$export$da39cf97e1eb7c91; }, function (v) { return $01727eaed9f6d092$export$da39cf97e1eb7c91 = v; });
$parcel$export(module.exports, "Hmac", function () { return $01727eaed9f6d092$export$52a9039d7177394f; }, function (v) { return $01727eaed9f6d092$export$52a9039d7177394f = v; });
$parcel$export(module.exports, "getHashes", function () { return $01727eaed9f6d092$export$f7201db400317331; }, function (v) { return $01727eaed9f6d092$export$f7201db400317331 = v; });
$parcel$export(module.exports, "pbkdf2", function () { return $01727eaed9f6d092$export$448fa22aedc9dbca; }, function (v) { return $01727eaed9f6d092$export$448fa22aedc9dbca = v; });
$parcel$export(module.exports, "pbkdf2Sync", function () { return $01727eaed9f6d092$export$b80c7ba289c8fa56; }, function (v) { return $01727eaed9f6d092$export$b80c7ba289c8fa56 = v; });
$parcel$export(module.exports, "Cipher", function () { return $01727eaed9f6d092$export$26e5786e8ac8e530; }, function (v) { return $01727eaed9f6d092$export$26e5786e8ac8e530 = v; });
$parcel$export(module.exports, "createCipher", function () { return $01727eaed9f6d092$export$bdd223f16383713e; }, function (v) { return $01727eaed9f6d092$export$bdd223f16383713e = v; });
$parcel$export(module.exports, "Cipheriv", function () { return $01727eaed9f6d092$export$20533d26f07f1ee0; }, function (v) { return $01727eaed9f6d092$export$20533d26f07f1ee0 = v; });
$parcel$export(module.exports, "createCipheriv", function () { return $01727eaed9f6d092$export$2f64596b8cbf08b4; }, function (v) { return $01727eaed9f6d092$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "Decipher", function () { return $01727eaed9f6d092$export$2ce6d8d0e8b04e1a; }, function (v) { return $01727eaed9f6d092$export$2ce6d8d0e8b04e1a = v; });
$parcel$export(module.exports, "createDecipher", function () { return $01727eaed9f6d092$export$12ada9414fbc594c; }, function (v) { return $01727eaed9f6d092$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "Decipheriv", function () { return $01727eaed9f6d092$export$f5e7e39d57cd9700; }, function (v) { return $01727eaed9f6d092$export$f5e7e39d57cd9700 = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $01727eaed9f6d092$export$36b6d6ef312eab39; }, function (v) { return $01727eaed9f6d092$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $01727eaed9f6d092$export$58a258485f1e49f6; }, function (v) { return $01727eaed9f6d092$export$58a258485f1e49f6 = v; });
$parcel$export(module.exports, "listCiphers", function () { return $01727eaed9f6d092$export$dedd8dc3dc62b370; }, function (v) { return $01727eaed9f6d092$export$dedd8dc3dc62b370 = v; });
$parcel$export(module.exports, "DiffieHellmanGroup", function () { return $01727eaed9f6d092$export$971862a2fcb1bb40; }, function (v) { return $01727eaed9f6d092$export$971862a2fcb1bb40 = v; });
$parcel$export(module.exports, "createDiffieHellmanGroup", function () { return $01727eaed9f6d092$export$c6ff6a88acbeaf40; }, function (v) { return $01727eaed9f6d092$export$c6ff6a88acbeaf40 = v; });
$parcel$export(module.exports, "getDiffieHellman", function () { return $01727eaed9f6d092$export$fdc27893e98845cc; }, function (v) { return $01727eaed9f6d092$export$fdc27893e98845cc = v; });
$parcel$export(module.exports, "createDiffieHellman", function () { return $01727eaed9f6d092$export$6671fb9a1323bed; }, function (v) { return $01727eaed9f6d092$export$6671fb9a1323bed = v; });
$parcel$export(module.exports, "DiffieHellman", function () { return $01727eaed9f6d092$export$d74daf141a551db; }, function (v) { return $01727eaed9f6d092$export$d74daf141a551db = v; });
$parcel$export(module.exports, "createSign", function () { return $01727eaed9f6d092$export$45df7cae684751af; }, function (v) { return $01727eaed9f6d092$export$45df7cae684751af = v; });
$parcel$export(module.exports, "Sign", function () { return $01727eaed9f6d092$export$1db683ad541682f6; }, function (v) { return $01727eaed9f6d092$export$1db683ad541682f6 = v; });
$parcel$export(module.exports, "createVerify", function () { return $01727eaed9f6d092$export$6f65485f87568e37; }, function (v) { return $01727eaed9f6d092$export$6f65485f87568e37 = v; });
$parcel$export(module.exports, "Verify", function () { return $01727eaed9f6d092$export$91a8e56769aeb334; }, function (v) { return $01727eaed9f6d092$export$91a8e56769aeb334 = v; });
$parcel$export(module.exports, "createECDH", function () { return $01727eaed9f6d092$export$2d4117e99c2179e4; }, function (v) { return $01727eaed9f6d092$export$2d4117e99c2179e4 = v; });
$parcel$export(module.exports, "publicEncrypt", function () { return $01727eaed9f6d092$export$512823e338ddb1b7; }, function (v) { return $01727eaed9f6d092$export$512823e338ddb1b7 = v; });
$parcel$export(module.exports, "privateEncrypt", function () { return $01727eaed9f6d092$export$9d0e0c0c4a8d30f3; }, function (v) { return $01727eaed9f6d092$export$9d0e0c0c4a8d30f3 = v; });
$parcel$export(module.exports, "publicDecrypt", function () { return $01727eaed9f6d092$export$b9d55ff329113abd; }, function (v) { return $01727eaed9f6d092$export$b9d55ff329113abd = v; });
$parcel$export(module.exports, "privateDecrypt", function () { return $01727eaed9f6d092$export$7efb24e2fddf99b9; }, function (v) { return $01727eaed9f6d092$export$7efb24e2fddf99b9 = v; });
$parcel$export(module.exports, "randomFill", function () { return $01727eaed9f6d092$export$bb1abf2ce84fc7e8; }, function (v) { return $01727eaed9f6d092$export$bb1abf2ce84fc7e8 = v; });
$parcel$export(module.exports, "randomFillSync", function () { return $01727eaed9f6d092$export$2f7171e78e524d5e; }, function (v) { return $01727eaed9f6d092$export$2f7171e78e524d5e = v; });
$parcel$export(module.exports, "createCredentials", function () { return $01727eaed9f6d092$export$e1d879b482f37d98; }, function (v) { return $01727eaed9f6d092$export$e1d879b482f37d98 = v; });
$parcel$export(module.exports, "constants", function () { return $01727eaed9f6d092$export$1a988e7317c65621; }, function (v) { return $01727eaed9f6d092$export$1a988e7317c65621 = v; });
var $01727eaed9f6d092$export$5f828d93ff035aa8;
var $01727eaed9f6d092$export$cd94982b18c6332c;
var $01727eaed9f6d092$export$1d518568e4f529b0;
var $01727eaed9f6d092$export$5285b6d41c912b41;
var $01727eaed9f6d092$export$2fb37efbf6ae0c0e;
var $01727eaed9f6d092$export$ab85ecd77ce6a5cd;
var $01727eaed9f6d092$export$da39cf97e1eb7c91;
var $01727eaed9f6d092$export$52a9039d7177394f;
var $01727eaed9f6d092$export$f7201db400317331;
var $01727eaed9f6d092$export$448fa22aedc9dbca;
var $01727eaed9f6d092$export$b80c7ba289c8fa56;
var $01727eaed9f6d092$export$26e5786e8ac8e530;
var $01727eaed9f6d092$export$bdd223f16383713e;
var $01727eaed9f6d092$export$20533d26f07f1ee0;
var $01727eaed9f6d092$export$2f64596b8cbf08b4;
var $01727eaed9f6d092$export$2ce6d8d0e8b04e1a;
var $01727eaed9f6d092$export$12ada9414fbc594c;
var $01727eaed9f6d092$export$f5e7e39d57cd9700;
var $01727eaed9f6d092$export$36b6d6ef312eab39;
var $01727eaed9f6d092$export$58a258485f1e49f6;
var $01727eaed9f6d092$export$dedd8dc3dc62b370;
var $01727eaed9f6d092$export$971862a2fcb1bb40;
var $01727eaed9f6d092$export$c6ff6a88acbeaf40;
var $01727eaed9f6d092$export$fdc27893e98845cc;
var $01727eaed9f6d092$export$6671fb9a1323bed;
var $01727eaed9f6d092$export$d74daf141a551db;
var $01727eaed9f6d092$export$45df7cae684751af;
var $01727eaed9f6d092$export$1db683ad541682f6;
var $01727eaed9f6d092$export$6f65485f87568e37;
var $01727eaed9f6d092$export$91a8e56769aeb334;
var $01727eaed9f6d092$export$2d4117e99c2179e4;
var $01727eaed9f6d092$export$512823e338ddb1b7;
var $01727eaed9f6d092$export$9d0e0c0c4a8d30f3;
var $01727eaed9f6d092$export$b9d55ff329113abd;
var $01727eaed9f6d092$export$7efb24e2fddf99b9;
var $01727eaed9f6d092$export$bb1abf2ce84fc7e8;
var $01727eaed9f6d092$export$2f7171e78e524d5e;
var $01727eaed9f6d092$export$e1d879b482f37d98;
var $01727eaed9f6d092$export$1a988e7317c65621;
"use strict";

$01727eaed9f6d092$export$5f828d93ff035aa8 = $01727eaed9f6d092$export$cd94982b18c6332c = $01727eaed9f6d092$export$1d518568e4f529b0 = $01727eaed9f6d092$export$5285b6d41c912b41 = (parcelRequire("dKHN6"));

$01727eaed9f6d092$export$2fb37efbf6ae0c0e = $01727eaed9f6d092$export$ab85ecd77ce6a5cd = (parcelRequire("j8bQA"));

$01727eaed9f6d092$export$da39cf97e1eb7c91 = $01727eaed9f6d092$export$52a9039d7177394f = (parcelRequire("l2ANw"));

var $dcgwh = parcelRequire("dcgwh");
var $01727eaed9f6d092$var$algoKeys = Object.keys($dcgwh);
var $01727eaed9f6d092$var$hashes = [
    "sha1",
    "sha224",
    "sha256",
    "sha384",
    "sha512",
    "md5",
    "rmd160"
].concat($01727eaed9f6d092$var$algoKeys);
$01727eaed9f6d092$export$f7201db400317331 = function() {
    return $01727eaed9f6d092$var$hashes;
};

var $2r16u = parcelRequire("2r16u");
$01727eaed9f6d092$export$448fa22aedc9dbca = $2r16u.pbkdf2;
$01727eaed9f6d092$export$b80c7ba289c8fa56 = $2r16u.pbkdf2Sync;

var $5Il2G = parcelRequire("5Il2G");
$01727eaed9f6d092$export$26e5786e8ac8e530 = $5Il2G.Cipher;
$01727eaed9f6d092$export$bdd223f16383713e = $5Il2G.createCipher;
$01727eaed9f6d092$export$20533d26f07f1ee0 = $5Il2G.Cipheriv;
$01727eaed9f6d092$export$2f64596b8cbf08b4 = $5Il2G.createCipheriv;
$01727eaed9f6d092$export$2ce6d8d0e8b04e1a = $5Il2G.Decipher;
$01727eaed9f6d092$export$12ada9414fbc594c = $5Il2G.createDecipher;
$01727eaed9f6d092$export$f5e7e39d57cd9700 = $5Il2G.Decipheriv;
$01727eaed9f6d092$export$36b6d6ef312eab39 = $5Il2G.createDecipheriv;
$01727eaed9f6d092$export$58a258485f1e49f6 = $5Il2G.getCiphers;
$01727eaed9f6d092$export$dedd8dc3dc62b370 = $5Il2G.listCiphers;

var $8cFrB = parcelRequire("8cFrB");
$01727eaed9f6d092$export$971862a2fcb1bb40 = $8cFrB.DiffieHellmanGroup;
$01727eaed9f6d092$export$c6ff6a88acbeaf40 = $8cFrB.createDiffieHellmanGroup;
$01727eaed9f6d092$export$fdc27893e98845cc = $8cFrB.getDiffieHellman;
$01727eaed9f6d092$export$6671fb9a1323bed = $8cFrB.createDiffieHellman;
$01727eaed9f6d092$export$d74daf141a551db = $8cFrB.DiffieHellman;

var $knJxN = parcelRequire("knJxN");
$01727eaed9f6d092$export$45df7cae684751af = $knJxN.createSign;
$01727eaed9f6d092$export$1db683ad541682f6 = $knJxN.Sign;
$01727eaed9f6d092$export$6f65485f87568e37 = $knJxN.createVerify;
$01727eaed9f6d092$export$91a8e56769aeb334 = $knJxN.Verify;

$01727eaed9f6d092$export$2d4117e99c2179e4 = (parcelRequire("5NdVi"));

var $0oOUq = parcelRequire("0oOUq");
$01727eaed9f6d092$export$512823e338ddb1b7 = $0oOUq.publicEncrypt;
$01727eaed9f6d092$export$9d0e0c0c4a8d30f3 = $0oOUq.privateEncrypt;
$01727eaed9f6d092$export$b9d55ff329113abd = $0oOUq.publicDecrypt;
$01727eaed9f6d092$export$7efb24e2fddf99b9 = $0oOUq.privateDecrypt;

var $7WGbB = parcelRequire("7WGbB");
$01727eaed9f6d092$export$bb1abf2ce84fc7e8 = $7WGbB.randomFill;
$01727eaed9f6d092$export$2f7171e78e524d5e = $7WGbB.randomFillSync;
$01727eaed9f6d092$export$e1d879b482f37d98 = function() {
    throw new Error([
        "sorry, createCredentials is not implemented yet",
        "we accept pull requests",
        "https://github.com/crypto-browserify/crypto-browserify"
    ].join("\n"));
};
$01727eaed9f6d092$export$1a988e7317c65621 = {
    "DH_CHECK_P_NOT_SAFE_PRIME": 2,
    "DH_CHECK_P_NOT_PRIME": 1,
    "DH_UNABLE_TO_CHECK_GENERATOR": 4,
    "DH_NOT_SUITABLE_GENERATOR": 8,
    "NPN_ENABLED": 1,
    "ALPN_ENABLED": 1,
    "RSA_PKCS1_PADDING": 1,
    "RSA_SSLV23_PADDING": 2,
    "RSA_NO_PADDING": 3,
    "RSA_PKCS1_OAEP_PADDING": 4,
    "RSA_X931_PADDING": 5,
    "RSA_PKCS1_PSS_PADDING": 6,
    "POINT_CONVERSION_COMPRESSED": 2,
    "POINT_CONVERSION_UNCOMPRESSED": 4,
    "POINT_CONVERSION_HYBRID": 6
};

});
parcelRegister("dKHN6", function(module, exports) {

var $a8i8g = parcelRequire("a8i8g");
"use strict";
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $a0318a35c8c657ac$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $a0318a35c8c657ac$var$MAX_UINT32 = 4294967295;
function $a0318a35c8c657ac$var$oldBrowser() {
    throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11");
}

var $eN0t8 = parcelRequire("eN0t8");
var $a0318a35c8c657ac$require$Buffer = $eN0t8.Buffer;
var $a0318a35c8c657ac$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
if ($a0318a35c8c657ac$var$crypto && $a0318a35c8c657ac$var$crypto.getRandomValues) module.exports = $a0318a35c8c657ac$var$randomBytes;
else module.exports = $a0318a35c8c657ac$var$oldBrowser;
function $a0318a35c8c657ac$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $a0318a35c8c657ac$var$MAX_UINT32) throw new RangeError("requested too many random bytes");
    var bytes = $a0318a35c8c657ac$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $a0318a35c8c657ac$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $a0318a35c8c657ac$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $a0318a35c8c657ac$var$crypto.getRandomValues(bytes.slice(generated, generated + $a0318a35c8c657ac$var$MAX_BYTES));
        else $a0318a35c8c657ac$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === "function") return $a8i8g.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});
parcelRegister("eN0t8", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $gzLuY = parcelRequire("gzLuY");
var $ac460165df72f91c$var$Buffer = $gzLuY.Buffer;
// alternative to using Object.keys for old browsers
function $ac460165df72f91c$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($ac460165df72f91c$var$Buffer.from && $ac460165df72f91c$var$Buffer.alloc && $ac460165df72f91c$var$Buffer.allocUnsafe && $ac460165df72f91c$var$Buffer.allocUnsafeSlow) module.exports = $gzLuY;
else {
    // Copy properties from require('buffer')
    $ac460165df72f91c$var$copyProps($gzLuY, module.exports);
    module.exports.Buffer = $ac460165df72f91c$var$SafeBuffer;
}
function $ac460165df72f91c$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $ac460165df72f91c$var$Buffer(arg, encodingOrOffset, length);
}
$ac460165df72f91c$var$SafeBuffer.prototype = Object.create($ac460165df72f91c$var$Buffer.prototype);
// Copy static methods from Buffer
$ac460165df72f91c$var$copyProps($ac460165df72f91c$var$Buffer, $ac460165df72f91c$var$SafeBuffer);
$ac460165df72f91c$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $ac460165df72f91c$var$Buffer(arg, encodingOrOffset, length);
};
$ac460165df72f91c$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $ac460165df72f91c$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$ac460165df72f91c$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $ac460165df72f91c$var$Buffer(size);
};
$ac460165df72f91c$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $gzLuY.SlowBuffer(size);
};

});


parcelRegister("j8bQA", function(module, exports) {
"use strict";

var $kvFQ5 = parcelRequire("kvFQ5");

var $dGbYv = parcelRequire("dGbYv");

var $6B3Qg = parcelRequire("6B3Qg");

var $cWKoG = parcelRequire("cWKoG");

var $61MIM = parcelRequire("61MIM");
function $ded7f442553c17da$var$Hash(hash) {
    $61MIM.call(this, "digest");
    this._hash = hash;
}
$kvFQ5($ded7f442553c17da$var$Hash, $61MIM);
$ded7f442553c17da$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$ded7f442553c17da$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === "md5") return new $dGbYv();
    if (alg === "rmd160" || alg === "ripemd160") return new $6B3Qg();
    return new $ded7f442553c17da$var$Hash($cWKoG(alg));
};

});
parcelRegister("kvFQ5", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("dGbYv", function(module, exports) {
"use strict";

var $kvFQ5 = parcelRequire("kvFQ5");

var $4E6hc = parcelRequire("4E6hc");

var $eN0t8 = parcelRequire("eN0t8");
var $9f587c92ce2bd6b7$require$Buffer = $eN0t8.Buffer;
var $9f587c92ce2bd6b7$var$ARRAY16 = new Array(16);
function $9f587c92ce2bd6b7$var$MD5() {
    $4E6hc.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$kvFQ5($9f587c92ce2bd6b7$var$MD5, $4E6hc);
$9f587c92ce2bd6b7$var$MD5.prototype._update = function() {
    var M = $9f587c92ce2bd6b7$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $9f587c92ce2bd6b7$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $9f587c92ce2bd6b7$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $9f587c92ce2bd6b7$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $9f587c92ce2bd6b7$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $9f587c92ce2bd6b7$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $9f587c92ce2bd6b7$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $9f587c92ce2bd6b7$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $9f587c92ce2bd6b7$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $9f587c92ce2bd6b7$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $9f587c92ce2bd6b7$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $9f587c92ce2bd6b7$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $9f587c92ce2bd6b7$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $9f587c92ce2bd6b7$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $9f587c92ce2bd6b7$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $9f587c92ce2bd6b7$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $9f587c92ce2bd6b7$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $9f587c92ce2bd6b7$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $9f587c92ce2bd6b7$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $9f587c92ce2bd6b7$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $9f587c92ce2bd6b7$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $9f587c92ce2bd6b7$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $9f587c92ce2bd6b7$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $9f587c92ce2bd6b7$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $9f587c92ce2bd6b7$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $9f587c92ce2bd6b7$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $9f587c92ce2bd6b7$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $9f587c92ce2bd6b7$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $9f587c92ce2bd6b7$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $9f587c92ce2bd6b7$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $9f587c92ce2bd6b7$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $9f587c92ce2bd6b7$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $9f587c92ce2bd6b7$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $9f587c92ce2bd6b7$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $9f587c92ce2bd6b7$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $9f587c92ce2bd6b7$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $9f587c92ce2bd6b7$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $9f587c92ce2bd6b7$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $9f587c92ce2bd6b7$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $9f587c92ce2bd6b7$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $9f587c92ce2bd6b7$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $9f587c92ce2bd6b7$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $9f587c92ce2bd6b7$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $9f587c92ce2bd6b7$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $9f587c92ce2bd6b7$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $9f587c92ce2bd6b7$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $9f587c92ce2bd6b7$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $9f587c92ce2bd6b7$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $9f587c92ce2bd6b7$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $9f587c92ce2bd6b7$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $9f587c92ce2bd6b7$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $9f587c92ce2bd6b7$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $9f587c92ce2bd6b7$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $9f587c92ce2bd6b7$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $9f587c92ce2bd6b7$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $9f587c92ce2bd6b7$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $9f587c92ce2bd6b7$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $9f587c92ce2bd6b7$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $9f587c92ce2bd6b7$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $9f587c92ce2bd6b7$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $9f587c92ce2bd6b7$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $9f587c92ce2bd6b7$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $9f587c92ce2bd6b7$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $9f587c92ce2bd6b7$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $9f587c92ce2bd6b7$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$9f587c92ce2bd6b7$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $9f587c92ce2bd6b7$require$Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $9f587c92ce2bd6b7$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $9f587c92ce2bd6b7$var$fnF(a, b, c, d, m, k, s) {
    return $9f587c92ce2bd6b7$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $9f587c92ce2bd6b7$var$fnG(a, b, c, d, m, k, s) {
    return $9f587c92ce2bd6b7$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $9f587c92ce2bd6b7$var$fnH(a, b, c, d, m, k, s) {
    return $9f587c92ce2bd6b7$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $9f587c92ce2bd6b7$var$fnI(a, b, c, d, m, k, s) {
    return $9f587c92ce2bd6b7$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $9f587c92ce2bd6b7$var$MD5;

});
parcelRegister("4E6hc", function(module, exports) {
"use strict";

var $eN0t8 = parcelRequire("eN0t8");
var $361fc43cbe8e0873$require$Buffer = $eN0t8.Buffer;

var $CyGSj = parcelRequire("CyGSj");
var $361fc43cbe8e0873$require$Transform = $CyGSj.Transform;

var $kvFQ5 = parcelRequire("kvFQ5");
function $361fc43cbe8e0873$var$throwIfNotStringOrBuffer(val, prefix) {
    if (!$361fc43cbe8e0873$require$Buffer.isBuffer(val) && typeof val !== "string") throw new TypeError(prefix + " must be a string or a buffer");
}
function $361fc43cbe8e0873$var$HashBase(blockSize) {
    $361fc43cbe8e0873$require$Transform.call(this);
    this._block = $361fc43cbe8e0873$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$kvFQ5($361fc43cbe8e0873$var$HashBase, $361fc43cbe8e0873$require$Transform);
$361fc43cbe8e0873$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$361fc43cbe8e0873$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$361fc43cbe8e0873$var$HashBase.prototype.update = function(data, encoding) {
    $361fc43cbe8e0873$var$throwIfNotStringOrBuffer(data, "Data");
    if (this._finalized) throw new Error("Digest already called");
    if (!$361fc43cbe8e0873$require$Buffer.isBuffer(data)) data = $361fc43cbe8e0873$require$Buffer.from(data, encoding);
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$361fc43cbe8e0873$var$HashBase.prototype._update = function() {
    throw new Error("_update is not implemented");
};
$361fc43cbe8e0873$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error("Digest already called");
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$361fc43cbe8e0873$var$HashBase.prototype._digest = function() {
    throw new Error("_digest is not implemented");
};
module.exports = $361fc43cbe8e0873$var$HashBase;

});
parcelRegister("CyGSj", function(module, exports) {

exports = module.exports = (parcelRequire("hJHBh"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("3AY6k"));

exports.Duplex = (parcelRequire("kTUB1"));

exports.Transform = (parcelRequire("9wbVx"));

exports.PassThrough = (parcelRequire("3Frfy"));

exports.finished = (parcelRequire("i1zMF"));

exports.pipeline = (parcelRequire("hI05B"));

});
parcelRegister("hJHBh", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $a8i8g = parcelRequire("a8i8g");
"use strict";
module.exports = $ce9875b997915245$var$Readable;
/*<replacement>*/ var $ce9875b997915245$var$Duplex;
/*</replacement>*/ $ce9875b997915245$var$Readable.ReadableState = $ce9875b997915245$var$ReadableState;

var $wvaTc = parcelRequire("wvaTc");
var $ce9875b997915245$require$EE = $wvaTc.EventEmitter;
var $ce9875b997915245$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $7GgdY = parcelRequire("7GgdY");

var $gzLuY = parcelRequire("gzLuY");
var $ce9875b997915245$require$Buffer = $gzLuY.Buffer;
var $ce9875b997915245$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $ce9875b997915245$var$_uint8ArrayToBuffer(chunk) {
    return $ce9875b997915245$require$Buffer.from(chunk);
}
function $ce9875b997915245$var$_isUint8Array(obj) {
    return $ce9875b997915245$require$Buffer.isBuffer(obj) || obj instanceof $ce9875b997915245$var$OurUint8Array;
}

var $aqbQf = parcelRequire("aqbQf");
var $ce9875b997915245$var$debug;
if ($aqbQf && $aqbQf.debuglog) $ce9875b997915245$var$debug = $aqbQf.debuglog("stream");
else $ce9875b997915245$var$debug = function debug() {};

var $9ZPuZ = parcelRequire("9ZPuZ");

var $g2D2d = parcelRequire("g2D2d");

var $hLWAy = parcelRequire("hLWAy");
var $ce9875b997915245$var$getHighWaterMark = $hLWAy.getHighWaterMark;

var $5qPK0 = parcelRequire("5qPK0");
var $ce9875b997915245$require$_require$codes = $5qPK0.codes;
var $ce9875b997915245$var$ERR_INVALID_ARG_TYPE = $ce9875b997915245$require$_require$codes.ERR_INVALID_ARG_TYPE, $ce9875b997915245$var$ERR_STREAM_PUSH_AFTER_EOF = $ce9875b997915245$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $ce9875b997915245$var$ERR_METHOD_NOT_IMPLEMENTED = $ce9875b997915245$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $ce9875b997915245$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $ce9875b997915245$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $ce9875b997915245$var$StringDecoder;
var $ce9875b997915245$var$createReadableStreamAsyncIterator;
var $ce9875b997915245$var$from;

(parcelRequire("kvFQ5"))($ce9875b997915245$var$Readable, $7GgdY);
var $ce9875b997915245$var$errorOrDestroy = $g2D2d.errorOrDestroy;
var $ce9875b997915245$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $ce9875b997915245$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $ce9875b997915245$var$ReadableState(options, stream, isDuplex) {
    $ce9875b997915245$var$Duplex = $ce9875b997915245$var$Duplex || (parcelRequire("kTUB1"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $ce9875b997915245$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $ce9875b997915245$var$getHighWaterMark(this, options, "readableHighWaterMark", isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $9ZPuZ();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$ce9875b997915245$var$StringDecoder) $ce9875b997915245$var$StringDecoder = (parcelRequire("hXidu")).StringDecoder;
        this.decoder = new $ce9875b997915245$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $ce9875b997915245$var$Readable(options) {
    $ce9875b997915245$var$Duplex = $ce9875b997915245$var$Duplex || (parcelRequire("kTUB1"));
    if (!(this instanceof $ce9875b997915245$var$Readable)) return new $ce9875b997915245$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $ce9875b997915245$var$Duplex;
    this._readableState = new $ce9875b997915245$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $7GgdY.call(this);
}
Object.defineProperty($ce9875b997915245$var$Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$ce9875b997915245$var$Readable.prototype.destroy = $g2D2d.destroy;
$ce9875b997915245$var$Readable.prototype._undestroy = $g2D2d.undestroy;
$ce9875b997915245$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$ce9875b997915245$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $ce9875b997915245$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $ce9875b997915245$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$ce9875b997915245$var$Readable.prototype.unshift = function(chunk) {
    return $ce9875b997915245$var$readableAddChunk(this, chunk, null, true, false);
};
function $ce9875b997915245$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $ce9875b997915245$var$debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $ce9875b997915245$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $ce9875b997915245$var$chunkInvalid(state, chunk);
        if (er) $ce9875b997915245$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $ce9875b997915245$require$Buffer.prototype) chunk = $ce9875b997915245$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $ce9875b997915245$var$errorOrDestroy(stream, new $ce9875b997915245$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $ce9875b997915245$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $ce9875b997915245$var$errorOrDestroy(stream, new $ce9875b997915245$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $ce9875b997915245$var$addChunk(stream, state, chunk, false);
                    else $ce9875b997915245$var$maybeReadMore(stream, state);
                } else $ce9875b997915245$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $ce9875b997915245$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $ce9875b997915245$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $ce9875b997915245$var$emitReadable(stream);
    }
    $ce9875b997915245$var$maybeReadMore(stream, state);
}
function $ce9875b997915245$var$chunkInvalid(state, chunk) {
    var er;
    if (!$ce9875b997915245$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new $ce9875b997915245$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
$ce9875b997915245$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$ce9875b997915245$var$Readable.prototype.setEncoding = function(enc) {
    if (!$ce9875b997915245$var$StringDecoder) $ce9875b997915245$var$StringDecoder = (parcelRequire("hXidu")).StringDecoder;
    var decoder = new $ce9875b997915245$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $ce9875b997915245$var$MAX_HWM = 0x40000000;
function $ce9875b997915245$var$computeNewHighWaterMark(n) {
    if (n >= $ce9875b997915245$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $ce9875b997915245$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $ce9875b997915245$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $ce9875b997915245$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$ce9875b997915245$var$Readable.prototype.read = function(n) {
    $ce9875b997915245$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $ce9875b997915245$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $ce9875b997915245$var$endReadable(this);
        else $ce9875b997915245$var$emitReadable(this);
        return null;
    }
    n = $ce9875b997915245$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $ce9875b997915245$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $ce9875b997915245$var$debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $ce9875b997915245$var$debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $ce9875b997915245$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $ce9875b997915245$var$debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $ce9875b997915245$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $ce9875b997915245$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $ce9875b997915245$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $ce9875b997915245$var$onEofChunk(stream, state) {
    $ce9875b997915245$var$debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $ce9875b997915245$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $ce9875b997915245$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $ce9875b997915245$var$emitReadable(stream) {
    var state = stream._readableState;
    $ce9875b997915245$var$debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $ce9875b997915245$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        $a8i8g.nextTick($ce9875b997915245$var$emitReadable_, stream);
    }
}
function $ce9875b997915245$var$emitReadable_(stream) {
    var state = stream._readableState;
    $ce9875b997915245$var$debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $ce9875b997915245$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $ce9875b997915245$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $a8i8g.nextTick($ce9875b997915245$var$maybeReadMore_, stream, state);
    }
}
function $ce9875b997915245$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $ce9875b997915245$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$ce9875b997915245$var$Readable.prototype._read = function(n) {
    $ce9875b997915245$var$errorOrDestroy(this, new $ce9875b997915245$var$ERR_METHOD_NOT_IMPLEMENTED("_read()"));
};
$ce9875b997915245$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $ce9875b997915245$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $a8i8g.stdout && dest !== $a8i8g.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $a8i8g.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $ce9875b997915245$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $ce9875b997915245$var$debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $ce9875b997915245$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $ce9875b997915245$var$debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        $ce9875b997915245$var$debug("ondata");
        var ret = dest.write(chunk);
        $ce9875b997915245$var$debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $ce9875b997915245$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $ce9875b997915245$var$debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $ce9875b997915245$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($ce9875b997915245$var$EElistenerCount(dest, "error") === 0) $ce9875b997915245$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $ce9875b997915245$var$prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $ce9875b997915245$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $ce9875b997915245$var$debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $ce9875b997915245$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $ce9875b997915245$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $ce9875b997915245$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $ce9875b997915245$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $ce9875b997915245$var$flow(src);
        }
    };
}
$ce9875b997915245$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $ce9875b997915245$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$ce9875b997915245$var$Readable.prototype.on = function(ev, fn) {
    var res = $7GgdY.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $ce9875b997915245$var$debug("on readable", state.length, state.reading);
            if (state.length) $ce9875b997915245$var$emitReadable(this);
            else if (!state.reading) $a8i8g.nextTick($ce9875b997915245$var$nReadingNextTick, this);
        }
    }
    return res;
};
$ce9875b997915245$var$Readable.prototype.addListener = $ce9875b997915245$var$Readable.prototype.on;
$ce9875b997915245$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $7GgdY.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $a8i8g.nextTick($ce9875b997915245$var$updateReadableListening, this);
    return res;
};
$ce9875b997915245$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $7GgdY.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $a8i8g.nextTick($ce9875b997915245$var$updateReadableListening, this);
    return res;
};
function $ce9875b997915245$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount("data") > 0) self1.resume();
}
function $ce9875b997915245$var$nReadingNextTick(self1) {
    $ce9875b997915245$var$debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$ce9875b997915245$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $ce9875b997915245$var$debug("resume");
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $ce9875b997915245$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $ce9875b997915245$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $a8i8g.nextTick($ce9875b997915245$var$resume_, stream, state);
    }
}
function $ce9875b997915245$var$resume_(stream, state) {
    $ce9875b997915245$var$debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    $ce9875b997915245$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$ce9875b997915245$var$Readable.prototype.pause = function() {
    $ce9875b997915245$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $ce9875b997915245$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function $ce9875b997915245$var$flow(stream) {
    var state = stream._readableState;
    $ce9875b997915245$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$ce9875b997915245$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $ce9875b997915245$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $ce9875b997915245$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $ce9875b997915245$var$kProxyEvents.length; n++)stream.on($ce9875b997915245$var$kProxyEvents[n], this.emit.bind(this, $ce9875b997915245$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $ce9875b997915245$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === "function") $ce9875b997915245$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($ce9875b997915245$var$createReadableStreamAsyncIterator === undefined) $ce9875b997915245$var$createReadableStreamAsyncIterator = (parcelRequire("1WvTd"));
    return $ce9875b997915245$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($ce9875b997915245$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($ce9875b997915245$var$Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($ce9875b997915245$var$Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$ce9875b997915245$var$Readable._fromList = $ce9875b997915245$var$fromList;
Object.defineProperty($ce9875b997915245$var$Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $ce9875b997915245$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $ce9875b997915245$var$endReadable(stream) {
    var state = stream._readableState;
    $ce9875b997915245$var$debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $a8i8g.nextTick($ce9875b997915245$var$endReadableNT, state, stream);
    }
}
function $ce9875b997915245$var$endReadableNT(state, stream) {
    $ce9875b997915245$var$debug("endReadableNT", state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === "function") $ce9875b997915245$var$Readable.from = function(iterable, opts) {
    if ($ce9875b997915245$var$from === undefined) $ce9875b997915245$var$from = (parcelRequire("1YZki"));
    return $ce9875b997915245$var$from($ce9875b997915245$var$Readable, iterable, opts);
};
function $ce9875b997915245$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("wvaTc", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $061b2be80523d29d$var$R = typeof Reflect === "object" ? Reflect : null;
var $061b2be80523d29d$var$ReflectApply = $061b2be80523d29d$var$R && typeof $061b2be80523d29d$var$R.apply === "function" ? $061b2be80523d29d$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $061b2be80523d29d$var$ReflectOwnKeys;
if ($061b2be80523d29d$var$R && typeof $061b2be80523d29d$var$R.ownKeys === "function") $061b2be80523d29d$var$ReflectOwnKeys = $061b2be80523d29d$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $061b2be80523d29d$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $061b2be80523d29d$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $061b2be80523d29d$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $061b2be80523d29d$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $061b2be80523d29d$var$EventEmitter() {
    $061b2be80523d29d$var$EventEmitter.init.call(this);
}
module.exports = $061b2be80523d29d$var$EventEmitter;
module.exports.once = $061b2be80523d29d$var$once;
// Backwards-compat with node 0.10.x
$061b2be80523d29d$var$EventEmitter.EventEmitter = $061b2be80523d29d$var$EventEmitter;
$061b2be80523d29d$var$EventEmitter.prototype._events = undefined;
$061b2be80523d29d$var$EventEmitter.prototype._eventsCount = 0;
$061b2be80523d29d$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $061b2be80523d29d$var$defaultMaxListeners = 10;
function $061b2be80523d29d$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($061b2be80523d29d$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $061b2be80523d29d$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $061b2be80523d29d$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $061b2be80523d29d$var$defaultMaxListeners = arg;
    }
});
$061b2be80523d29d$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$061b2be80523d29d$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $061b2be80523d29d$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $061b2be80523d29d$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $061b2be80523d29d$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$061b2be80523d29d$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $061b2be80523d29d$var$_getMaxListeners(this);
};
$061b2be80523d29d$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $061b2be80523d29d$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $061b2be80523d29d$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$061b2be80523d29d$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $061b2be80523d29d$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $061b2be80523d29d$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $061b2be80523d29d$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $061b2be80523d29d$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$061b2be80523d29d$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $061b2be80523d29d$var$_addListener(this, type, listener, false);
};
$061b2be80523d29d$var$EventEmitter.prototype.on = $061b2be80523d29d$var$EventEmitter.prototype.addListener;
$061b2be80523d29d$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $061b2be80523d29d$var$_addListener(this, type, listener, true);
};
function $061b2be80523d29d$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $061b2be80523d29d$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $061b2be80523d29d$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$061b2be80523d29d$var$EventEmitter.prototype.once = function once(type, listener) {
    $061b2be80523d29d$var$checkListener(listener);
    this.on(type, $061b2be80523d29d$var$_onceWrap(this, type, listener));
    return this;
};
$061b2be80523d29d$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $061b2be80523d29d$var$checkListener(listener);
    this.prependListener(type, $061b2be80523d29d$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$061b2be80523d29d$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $061b2be80523d29d$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $061b2be80523d29d$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$061b2be80523d29d$var$EventEmitter.prototype.off = $061b2be80523d29d$var$EventEmitter.prototype.removeListener;
$061b2be80523d29d$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $061b2be80523d29d$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $061b2be80523d29d$var$unwrapListeners(evlistener) : $061b2be80523d29d$var$arrayClone(evlistener, evlistener.length);
}
$061b2be80523d29d$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $061b2be80523d29d$var$_listeners(this, type, true);
};
$061b2be80523d29d$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $061b2be80523d29d$var$_listeners(this, type, false);
};
$061b2be80523d29d$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $061b2be80523d29d$var$listenerCount.call(emitter, type);
};
$061b2be80523d29d$var$EventEmitter.prototype.listenerCount = $061b2be80523d29d$var$listenerCount;
function $061b2be80523d29d$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$061b2be80523d29d$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $061b2be80523d29d$var$ReflectOwnKeys(this._events) : [];
};
function $061b2be80523d29d$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $061b2be80523d29d$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $061b2be80523d29d$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $061b2be80523d29d$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $061b2be80523d29d$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $061b2be80523d29d$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $061b2be80523d29d$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $061b2be80523d29d$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $061b2be80523d29d$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("7GgdY", function(module, exports) {

module.exports = (parcelRequire("wvaTc")).EventEmitter;

});

parcelRegister("9ZPuZ", function(module, exports) {
"use strict";
function $7471c22bb1509672$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7471c22bb1509672$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $7471c22bb1509672$var$ownKeys(Object(source), !0).forEach(function(key) {
            $7471c22bb1509672$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $7471c22bb1509672$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7471c22bb1509672$var$_defineProperty(obj, key, value) {
    key = $7471c22bb1509672$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7471c22bb1509672$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7471c22bb1509672$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $7471c22bb1509672$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $7471c22bb1509672$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7471c22bb1509672$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7471c22bb1509672$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $7471c22bb1509672$var$_toPropertyKey(arg) {
    var key = $7471c22bb1509672$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $7471c22bb1509672$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $gzLuY = parcelRequire("gzLuY");
var $7471c22bb1509672$var$Buffer = $gzLuY.Buffer;

var $aqbQf = parcelRequire("aqbQf");
var $7471c22bb1509672$var$inspect = $aqbQf.inspect;
var $7471c22bb1509672$var$custom = $7471c22bb1509672$var$inspect && $7471c22bb1509672$var$inspect.custom || "inspect";
function $7471c22bb1509672$var$copyBuffer(src, target, offset) {
    $7471c22bb1509672$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $7471c22bb1509672$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $7471c22bb1509672$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $7471c22bb1509672$var$Buffer.alloc(0);
                var ret = $7471c22bb1509672$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $7471c22bb1509672$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $7471c22bb1509672$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $7471c22bb1509672$var$custom,
            value: function value(_, options) {
                return $7471c22bb1509672$var$inspect(this, $7471c22bb1509672$var$_objectSpread($7471c22bb1509672$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("g2D2d", function(module, exports) {

var $a8i8g = parcelRequire("a8i8g");
"use strict";
// undocumented cb() API, needed for core, not for public API
function $badb1cb95d5d9905$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $a8i8g.nextTick($badb1cb95d5d9905$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $a8i8g.nextTick($badb1cb95d5d9905$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $a8i8g.nextTick($badb1cb95d5d9905$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $a8i8g.nextTick($badb1cb95d5d9905$var$emitErrorAndCloseNT, _this, err);
            } else $a8i8g.nextTick($badb1cb95d5d9905$var$emitCloseNT, _this);
        } else if (cb) {
            $a8i8g.nextTick($badb1cb95d5d9905$var$emitCloseNT, _this);
            cb(err);
        } else $a8i8g.nextTick($badb1cb95d5d9905$var$emitCloseNT, _this);
    });
    return this;
}
function $badb1cb95d5d9905$var$emitErrorAndCloseNT(self, err) {
    $badb1cb95d5d9905$var$emitErrorNT(self, err);
    $badb1cb95d5d9905$var$emitCloseNT(self);
}
function $badb1cb95d5d9905$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit("close");
}
function $badb1cb95d5d9905$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $badb1cb95d5d9905$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
function $badb1cb95d5d9905$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
module.exports = {
    destroy: $badb1cb95d5d9905$var$destroy,
    undestroy: $badb1cb95d5d9905$var$undestroy,
    errorOrDestroy: $badb1cb95d5d9905$var$errorOrDestroy
};

});

parcelRegister("hLWAy", function(module, exports) {
"use strict";

var $cf0445f13e49d7ed$var$ERR_INVALID_OPT_VALUE = (parcelRequire("5qPK0")).codes.ERR_INVALID_OPT_VALUE;
function $cf0445f13e49d7ed$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $cf0445f13e49d7ed$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $cf0445f13e49d7ed$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new $cf0445f13e49d7ed$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $cf0445f13e49d7ed$var$getHighWaterMark
};

});
parcelRegister("5qPK0", function(module, exports) {

$parcel$export(module.exports, "codes", function () { return $3f478427523a4e7d$export$e45cb6485273080e; }, function (v) { return $3f478427523a4e7d$export$e45cb6485273080e = v; });
var $3f478427523a4e7d$export$e45cb6485273080e;
"use strict";
function $3f478427523a4e7d$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $3f478427523a4e7d$var$codes = {};
function $3f478427523a4e7d$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $3f478427523a4e7d$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $3f478427523a4e7d$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $3f478427523a4e7d$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $3f478427523a4e7d$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $3f478427523a4e7d$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $3f478427523a4e7d$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$3f478427523a4e7d$var$createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$3f478427523a4e7d$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $3f478427523a4e7d$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($3f478427523a4e7d$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($3f478427523a4e7d$var$oneOf(expected, "type"));
    else {
        var type = $3f478427523a4e7d$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($3f478427523a4e7d$var$oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$3f478427523a4e7d$var$createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
$3f478427523a4e7d$var$createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
$3f478427523a4e7d$var$createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
$3f478427523a4e7d$var$createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
$3f478427523a4e7d$var$createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
$3f478427523a4e7d$var$createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
$3f478427523a4e7d$var$createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
$3f478427523a4e7d$var$createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
$3f478427523a4e7d$var$createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
$3f478427523a4e7d$var$createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
$3f478427523a4e7d$export$e45cb6485273080e = $3f478427523a4e7d$var$codes;

});


parcelRegister("kTUB1", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $a8i8g = parcelRequire("a8i8g");
"use strict";
/*<replacement>*/ var $f374d88020dc5730$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $f374d88020dc5730$var$Duplex;

var $hJHBh = parcelRequire("hJHBh");

var $3AY6k = parcelRequire("3AY6k");

(parcelRequire("kvFQ5"))($f374d88020dc5730$var$Duplex, $hJHBh);
// Allow the keys array to be GC'ed.
var $f374d88020dc5730$var$keys = $f374d88020dc5730$var$objectKeys($3AY6k.prototype);
for(var $f374d88020dc5730$var$v = 0; $f374d88020dc5730$var$v < $f374d88020dc5730$var$keys.length; $f374d88020dc5730$var$v++){
    var $f374d88020dc5730$var$method = $f374d88020dc5730$var$keys[$f374d88020dc5730$var$v];
    if (!$f374d88020dc5730$var$Duplex.prototype[$f374d88020dc5730$var$method]) $f374d88020dc5730$var$Duplex.prototype[$f374d88020dc5730$var$method] = $3AY6k.prototype[$f374d88020dc5730$var$method];
}
function $f374d88020dc5730$var$Duplex(options) {
    if (!(this instanceof $f374d88020dc5730$var$Duplex)) return new $f374d88020dc5730$var$Duplex(options);
    $hJHBh.call(this, options);
    $3AY6k.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", $f374d88020dc5730$var$onend);
        }
    }
}
Object.defineProperty($f374d88020dc5730$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($f374d88020dc5730$var$Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($f374d88020dc5730$var$Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $f374d88020dc5730$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $a8i8g.nextTick($f374d88020dc5730$var$onEndNT, this);
}
function $f374d88020dc5730$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($f374d88020dc5730$var$Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("3AY6k", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $a8i8g = parcelRequire("a8i8g");
"use strict";
module.exports = $29e35ab028f8b978$var$Writable;
/* <replacement> */ function $29e35ab028f8b978$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $29e35ab028f8b978$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $29e35ab028f8b978$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $29e35ab028f8b978$var$Duplex;
/*</replacement>*/ $29e35ab028f8b978$var$Writable.WritableState = $29e35ab028f8b978$var$WritableState;

/*<replacement>*/ var $29e35ab028f8b978$var$internalUtil = {
    deprecate: (parcelRequire("hPIqS"))
};

var $7GgdY = parcelRequire("7GgdY");

var $gzLuY = parcelRequire("gzLuY");
var $29e35ab028f8b978$require$Buffer = $gzLuY.Buffer;
var $29e35ab028f8b978$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $29e35ab028f8b978$var$_uint8ArrayToBuffer(chunk) {
    return $29e35ab028f8b978$require$Buffer.from(chunk);
}
function $29e35ab028f8b978$var$_isUint8Array(obj) {
    return $29e35ab028f8b978$require$Buffer.isBuffer(obj) || obj instanceof $29e35ab028f8b978$var$OurUint8Array;
}

var $g2D2d = parcelRequire("g2D2d");

var $hLWAy = parcelRequire("hLWAy");
var $29e35ab028f8b978$var$getHighWaterMark = $hLWAy.getHighWaterMark;

var $5qPK0 = parcelRequire("5qPK0");
var $29e35ab028f8b978$require$_require$codes = $5qPK0.codes;
var $29e35ab028f8b978$var$ERR_INVALID_ARG_TYPE = $29e35ab028f8b978$require$_require$codes.ERR_INVALID_ARG_TYPE, $29e35ab028f8b978$var$ERR_METHOD_NOT_IMPLEMENTED = $29e35ab028f8b978$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $29e35ab028f8b978$var$ERR_MULTIPLE_CALLBACK = $29e35ab028f8b978$require$_require$codes.ERR_MULTIPLE_CALLBACK, $29e35ab028f8b978$var$ERR_STREAM_CANNOT_PIPE = $29e35ab028f8b978$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $29e35ab028f8b978$var$ERR_STREAM_DESTROYED = $29e35ab028f8b978$require$_require$codes.ERR_STREAM_DESTROYED, $29e35ab028f8b978$var$ERR_STREAM_NULL_VALUES = $29e35ab028f8b978$require$_require$codes.ERR_STREAM_NULL_VALUES, $29e35ab028f8b978$var$ERR_STREAM_WRITE_AFTER_END = $29e35ab028f8b978$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $29e35ab028f8b978$var$ERR_UNKNOWN_ENCODING = $29e35ab028f8b978$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $29e35ab028f8b978$var$errorOrDestroy = $g2D2d.errorOrDestroy;

(parcelRequire("kvFQ5"))($29e35ab028f8b978$var$Writable, $7GgdY);
function $29e35ab028f8b978$var$nop() {}

function $29e35ab028f8b978$var$WritableState(options, stream, isDuplex) {
    $29e35ab028f8b978$var$Duplex = $29e35ab028f8b978$var$Duplex || (parcelRequire("kTUB1"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $29e35ab028f8b978$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $29e35ab028f8b978$var$getHighWaterMark(this, options, "writableHighWaterMark", isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $29e35ab028f8b978$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $29e35ab028f8b978$var$CorkedRequest(this);
}
$29e35ab028f8b978$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($29e35ab028f8b978$var$WritableState.prototype, "buffer", {
            get: $29e35ab028f8b978$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $29e35ab028f8b978$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $29e35ab028f8b978$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($29e35ab028f8b978$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($29e35ab028f8b978$var$realHasInstance.call(this, object)) return true;
            if (this !== $29e35ab028f8b978$var$Writable) return false;
            return object && object._writableState instanceof $29e35ab028f8b978$var$WritableState;
        }
    });
} else $29e35ab028f8b978$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $29e35ab028f8b978$var$Writable(options) {
    $29e35ab028f8b978$var$Duplex = $29e35ab028f8b978$var$Duplex || (parcelRequire("kTUB1"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $29e35ab028f8b978$var$Duplex;
    if (!isDuplex && !$29e35ab028f8b978$var$realHasInstance.call($29e35ab028f8b978$var$Writable, this)) return new $29e35ab028f8b978$var$Writable(options);
    this._writableState = new $29e35ab028f8b978$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $7GgdY.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$29e35ab028f8b978$var$Writable.prototype.pipe = function() {
    $29e35ab028f8b978$var$errorOrDestroy(this, new $29e35ab028f8b978$var$ERR_STREAM_CANNOT_PIPE());
};
function $29e35ab028f8b978$var$writeAfterEnd(stream, cb) {
    var er = new $29e35ab028f8b978$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $29e35ab028f8b978$var$errorOrDestroy(stream, er);
    $a8i8g.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $29e35ab028f8b978$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $29e35ab028f8b978$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new $29e35ab028f8b978$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        $29e35ab028f8b978$var$errorOrDestroy(stream, er);
        $a8i8g.nextTick(cb, er);
        return false;
    }
    return true;
}
$29e35ab028f8b978$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $29e35ab028f8b978$var$_isUint8Array(chunk);
    if (isBuf && !$29e35ab028f8b978$require$Buffer.isBuffer(chunk)) chunk = $29e35ab028f8b978$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $29e35ab028f8b978$var$nop;
    if (state.ending) $29e35ab028f8b978$var$writeAfterEnd(this, cb);
    else if (isBuf || $29e35ab028f8b978$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $29e35ab028f8b978$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$29e35ab028f8b978$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$29e35ab028f8b978$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $29e35ab028f8b978$var$clearBuffer(this, state);
    }
};
$29e35ab028f8b978$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new $29e35ab028f8b978$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($29e35ab028f8b978$var$Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $29e35ab028f8b978$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $29e35ab028f8b978$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($29e35ab028f8b978$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $29e35ab028f8b978$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $29e35ab028f8b978$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $29e35ab028f8b978$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $29e35ab028f8b978$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $29e35ab028f8b978$var$ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $29e35ab028f8b978$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $a8i8g.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $a8i8g.nextTick($29e35ab028f8b978$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $29e35ab028f8b978$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $29e35ab028f8b978$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $29e35ab028f8b978$var$finishMaybe(stream, state);
    }
}
function $29e35ab028f8b978$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $29e35ab028f8b978$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new $29e35ab028f8b978$var$ERR_MULTIPLE_CALLBACK();
    $29e35ab028f8b978$var$onwriteStateUpdate(state);
    if (er) $29e35ab028f8b978$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $29e35ab028f8b978$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $29e35ab028f8b978$var$clearBuffer(stream, state);
        if (sync) $a8i8g.nextTick($29e35ab028f8b978$var$afterWrite, stream, state, finished, cb);
        else $29e35ab028f8b978$var$afterWrite(stream, state, finished, cb);
    }
}
function $29e35ab028f8b978$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $29e35ab028f8b978$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $29e35ab028f8b978$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $29e35ab028f8b978$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function $29e35ab028f8b978$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $29e35ab028f8b978$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $29e35ab028f8b978$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $29e35ab028f8b978$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$29e35ab028f8b978$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $29e35ab028f8b978$var$ERR_METHOD_NOT_IMPLEMENTED("_write()"));
};
$29e35ab028f8b978$var$Writable.prototype._writev = null;
$29e35ab028f8b978$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $29e35ab028f8b978$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($29e35ab028f8b978$var$Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $29e35ab028f8b978$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $29e35ab028f8b978$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $29e35ab028f8b978$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        $29e35ab028f8b978$var$finishMaybe(stream, state);
    });
}
function $29e35ab028f8b978$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $a8i8g.nextTick($29e35ab028f8b978$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $29e35ab028f8b978$var$finishMaybe(stream, state) {
    var need = $29e35ab028f8b978$var$needFinish(state);
    if (need) {
        $29e35ab028f8b978$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $29e35ab028f8b978$var$endWritable(stream, state, cb) {
    state.ending = true;
    $29e35ab028f8b978$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $a8i8g.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $29e35ab028f8b978$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($29e35ab028f8b978$var$Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$29e35ab028f8b978$var$Writable.prototype.destroy = $g2D2d.destroy;
$29e35ab028f8b978$var$Writable.prototype._undestroy = $g2D2d.undestroy;
$29e35ab028f8b978$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("hPIqS", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $cfb9aa7327c7efa7$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $cfb9aa7327c7efa7$var$deprecate(fn, msg) {
    if ($cfb9aa7327c7efa7$var$config("noDeprecation")) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($cfb9aa7327c7efa7$var$config("throwDeprecation")) throw new Error(msg);
            else if ($cfb9aa7327c7efa7$var$config("traceDeprecation")) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $cfb9aa7327c7efa7$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === "true";
}

});



parcelRegister("hXidu", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", function () { return $d12613cfd4b43149$export$63a7aa211a91ed69; }, function (v) { return $d12613cfd4b43149$export$63a7aa211a91ed69 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $d12613cfd4b43149$export$63a7aa211a91ed69;
"use strict";

var $eN0t8 = parcelRequire("eN0t8");
var $d12613cfd4b43149$require$Buffer = $eN0t8.Buffer;
/*</replacement>*/ var $d12613cfd4b43149$var$isEncoding = $d12613cfd4b43149$require$Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function $d12613cfd4b43149$var$_normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $d12613cfd4b43149$var$normalizeEncoding(enc) {
    var nenc = $d12613cfd4b43149$var$_normalizeEncoding(enc);
    if (typeof nenc !== "string" && ($d12613cfd4b43149$require$Buffer.isEncoding === $d12613cfd4b43149$var$isEncoding || !$d12613cfd4b43149$var$isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
$d12613cfd4b43149$export$63a7aa211a91ed69 = $d12613cfd4b43149$var$StringDecoder;
function $d12613cfd4b43149$var$StringDecoder(encoding) {
    this.encoding = $d12613cfd4b43149$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = $d12613cfd4b43149$var$utf16Text;
            this.end = $d12613cfd4b43149$var$utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = $d12613cfd4b43149$var$utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = $d12613cfd4b43149$var$base64Text;
            this.end = $d12613cfd4b43149$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $d12613cfd4b43149$var$simpleWrite;
            this.end = $d12613cfd4b43149$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $d12613cfd4b43149$require$Buffer.allocUnsafe(nb);
}
$d12613cfd4b43149$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
$d12613cfd4b43149$var$StringDecoder.prototype.end = $d12613cfd4b43149$var$utf8End;
// Returns only complete characters in a Buffer
$d12613cfd4b43149$var$StringDecoder.prototype.text = $d12613cfd4b43149$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$d12613cfd4b43149$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $d12613cfd4b43149$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $d12613cfd4b43149$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $d12613cfd4b43149$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $d12613cfd4b43149$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $d12613cfd4b43149$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $d12613cfd4b43149$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "\uFFFD";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "\uFFFD";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "\uFFFD";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $d12613cfd4b43149$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $d12613cfd4b43149$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $d12613cfd4b43149$var$utf8Text(buf, i) {
    var total = $d12613cfd4b43149$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $d12613cfd4b43149$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "\uFFFD";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $d12613cfd4b43149$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $d12613cfd4b43149$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function $d12613cfd4b43149$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function $d12613cfd4b43149$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $d12613cfd4b43149$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $d12613cfd4b43149$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

});

parcelRegister("1WvTd", function(module, exports) {

var $a8i8g = parcelRequire("a8i8g");
"use strict";
var $16a3f1d8da6f8838$var$_Object$setPrototypeO;
function $16a3f1d8da6f8838$var$_defineProperty(obj, key, value) {
    key = $16a3f1d8da6f8838$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $16a3f1d8da6f8838$var$_toPropertyKey(arg) {
    var key = $16a3f1d8da6f8838$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $16a3f1d8da6f8838$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $i1zMF = parcelRequire("i1zMF");
var $16a3f1d8da6f8838$var$kLastResolve = Symbol("lastResolve");
var $16a3f1d8da6f8838$var$kLastReject = Symbol("lastReject");
var $16a3f1d8da6f8838$var$kError = Symbol("error");
var $16a3f1d8da6f8838$var$kEnded = Symbol("ended");
var $16a3f1d8da6f8838$var$kLastPromise = Symbol("lastPromise");
var $16a3f1d8da6f8838$var$kHandlePromise = Symbol("handlePromise");
var $16a3f1d8da6f8838$var$kStream = Symbol("stream");
function $16a3f1d8da6f8838$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $16a3f1d8da6f8838$var$readAndResolve(iter) {
    var resolve = iter[$16a3f1d8da6f8838$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$16a3f1d8da6f8838$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$16a3f1d8da6f8838$var$kLastPromise] = null;
            iter[$16a3f1d8da6f8838$var$kLastResolve] = null;
            iter[$16a3f1d8da6f8838$var$kLastReject] = null;
            resolve($16a3f1d8da6f8838$var$createIterResult(data, false));
        }
    }
}
function $16a3f1d8da6f8838$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $a8i8g.nextTick($16a3f1d8da6f8838$var$readAndResolve, iter);
}
function $16a3f1d8da6f8838$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$16a3f1d8da6f8838$var$kEnded]) {
                resolve($16a3f1d8da6f8838$var$createIterResult(undefined, true));
                return;
            }
            iter[$16a3f1d8da6f8838$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $16a3f1d8da6f8838$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $16a3f1d8da6f8838$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($16a3f1d8da6f8838$var$_Object$setPrototypeO = {
    get stream () {
        return this[$16a3f1d8da6f8838$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$16a3f1d8da6f8838$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$16a3f1d8da6f8838$var$kEnded]) return Promise.resolve($16a3f1d8da6f8838$var$createIterResult(undefined, true));
        if (this[$16a3f1d8da6f8838$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $a8i8g.nextTick(function() {
                if (_this[$16a3f1d8da6f8838$var$kError]) reject(_this[$16a3f1d8da6f8838$var$kError]);
                else resolve($16a3f1d8da6f8838$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$16a3f1d8da6f8838$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($16a3f1d8da6f8838$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$16a3f1d8da6f8838$var$kStream].read();
            if (data !== null) return Promise.resolve($16a3f1d8da6f8838$var$createIterResult(data, false));
            promise = new Promise(this[$16a3f1d8da6f8838$var$kHandlePromise]);
        }
        this[$16a3f1d8da6f8838$var$kLastPromise] = promise;
        return promise;
    }
}, $16a3f1d8da6f8838$var$_defineProperty($16a3f1d8da6f8838$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $16a3f1d8da6f8838$var$_defineProperty($16a3f1d8da6f8838$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$16a3f1d8da6f8838$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($16a3f1d8da6f8838$var$createIterResult(undefined, true));
        });
    });
}), $16a3f1d8da6f8838$var$_Object$setPrototypeO), $16a3f1d8da6f8838$var$AsyncIteratorPrototype);
var $16a3f1d8da6f8838$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($16a3f1d8da6f8838$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $16a3f1d8da6f8838$var$_defineProperty(_Object$create, $16a3f1d8da6f8838$var$kStream, {
        value: stream,
        writable: true
    }), $16a3f1d8da6f8838$var$_defineProperty(_Object$create, $16a3f1d8da6f8838$var$kLastResolve, {
        value: null,
        writable: true
    }), $16a3f1d8da6f8838$var$_defineProperty(_Object$create, $16a3f1d8da6f8838$var$kLastReject, {
        value: null,
        writable: true
    }), $16a3f1d8da6f8838$var$_defineProperty(_Object$create, $16a3f1d8da6f8838$var$kError, {
        value: null,
        writable: true
    }), $16a3f1d8da6f8838$var$_defineProperty(_Object$create, $16a3f1d8da6f8838$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $16a3f1d8da6f8838$var$_defineProperty(_Object$create, $16a3f1d8da6f8838$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$16a3f1d8da6f8838$var$kStream].read();
            if (data) {
                iterator[$16a3f1d8da6f8838$var$kLastPromise] = null;
                iterator[$16a3f1d8da6f8838$var$kLastResolve] = null;
                iterator[$16a3f1d8da6f8838$var$kLastReject] = null;
                resolve($16a3f1d8da6f8838$var$createIterResult(data, false));
            } else {
                iterator[$16a3f1d8da6f8838$var$kLastResolve] = resolve;
                iterator[$16a3f1d8da6f8838$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$16a3f1d8da6f8838$var$kLastPromise] = null;
    $i1zMF(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[$16a3f1d8da6f8838$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$16a3f1d8da6f8838$var$kLastPromise] = null;
                iterator[$16a3f1d8da6f8838$var$kLastResolve] = null;
                iterator[$16a3f1d8da6f8838$var$kLastReject] = null;
                reject(err);
            }
            iterator[$16a3f1d8da6f8838$var$kError] = err;
            return;
        }
        var resolve = iterator[$16a3f1d8da6f8838$var$kLastResolve];
        if (resolve !== null) {
            iterator[$16a3f1d8da6f8838$var$kLastPromise] = null;
            iterator[$16a3f1d8da6f8838$var$kLastResolve] = null;
            iterator[$16a3f1d8da6f8838$var$kLastReject] = null;
            resolve($16a3f1d8da6f8838$var$createIterResult(undefined, true));
        }
        iterator[$16a3f1d8da6f8838$var$kEnded] = true;
    });
    stream.on("readable", $16a3f1d8da6f8838$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $16a3f1d8da6f8838$var$createReadableStreamAsyncIterator;

});
parcelRegister("i1zMF", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";

var $d1f413f5b5c76170$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("5qPK0")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $d1f413f5b5c76170$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $d1f413f5b5c76170$var$noop() {}
function $d1f413f5b5c76170$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function $d1f413f5b5c76170$var$eos(stream, opts, callback) {
    if (typeof opts === "function") return $d1f413f5b5c76170$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $d1f413f5b5c76170$var$once(callback || $d1f413f5b5c76170$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $d1f413f5b5c76170$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $d1f413f5b5c76170$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if ($d1f413f5b5c76170$var$isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
module.exports = $d1f413f5b5c76170$var$eos;

});


parcelRegister("1YZki", function(module, exports) {
module.exports = function() {
    throw new Error("Readable.from is not available in the browser");
};

});


parcelRegister("9wbVx", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $6ee05aa7edc18bb2$var$Transform;

var $5qPK0 = parcelRequire("5qPK0");
var $6ee05aa7edc18bb2$require$_require$codes = $5qPK0.codes;
var $6ee05aa7edc18bb2$var$ERR_METHOD_NOT_IMPLEMENTED = $6ee05aa7edc18bb2$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $6ee05aa7edc18bb2$var$ERR_MULTIPLE_CALLBACK = $6ee05aa7edc18bb2$require$_require$codes.ERR_MULTIPLE_CALLBACK, $6ee05aa7edc18bb2$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $6ee05aa7edc18bb2$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $6ee05aa7edc18bb2$var$ERR_TRANSFORM_WITH_LENGTH_0 = $6ee05aa7edc18bb2$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $kTUB1 = parcelRequire("kTUB1");

(parcelRequire("kvFQ5"))($6ee05aa7edc18bb2$var$Transform, $kTUB1);
function $6ee05aa7edc18bb2$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new $6ee05aa7edc18bb2$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $6ee05aa7edc18bb2$var$Transform(options) {
    if (!(this instanceof $6ee05aa7edc18bb2$var$Transform)) return new $6ee05aa7edc18bb2$var$Transform(options);
    $kTUB1.call(this, options);
    this._transformState = {
        afterTransform: $6ee05aa7edc18bb2$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $6ee05aa7edc18bb2$var$prefinish);
}
function $6ee05aa7edc18bb2$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        $6ee05aa7edc18bb2$var$done(_this, er, data);
    });
    else $6ee05aa7edc18bb2$var$done(this, null, null);
}
$6ee05aa7edc18bb2$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $kTUB1.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$6ee05aa7edc18bb2$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $6ee05aa7edc18bb2$var$ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
$6ee05aa7edc18bb2$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$6ee05aa7edc18bb2$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$6ee05aa7edc18bb2$var$Transform.prototype._destroy = function(err, cb) {
    $kTUB1.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $6ee05aa7edc18bb2$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $6ee05aa7edc18bb2$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $6ee05aa7edc18bb2$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("3Frfy", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $2aba56adb8231771$var$PassThrough;

var $9wbVx = parcelRequire("9wbVx");

(parcelRequire("kvFQ5"))($2aba56adb8231771$var$PassThrough, $9wbVx);
function $2aba56adb8231771$var$PassThrough(options) {
    if (!(this instanceof $2aba56adb8231771$var$PassThrough)) return new $2aba56adb8231771$var$PassThrough(options);
    $9wbVx.call(this, options);
}
$2aba56adb8231771$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("hI05B", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var $ce469d7a6528ca9c$var$eos;
function $ce469d7a6528ca9c$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $5qPK0 = parcelRequire("5qPK0");
var $ce469d7a6528ca9c$require$_require$codes = $5qPK0.codes;
var $ce469d7a6528ca9c$var$ERR_MISSING_ARGS = $ce469d7a6528ca9c$require$_require$codes.ERR_MISSING_ARGS, $ce469d7a6528ca9c$var$ERR_STREAM_DESTROYED = $ce469d7a6528ca9c$require$_require$codes.ERR_STREAM_DESTROYED;
function $ce469d7a6528ca9c$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $ce469d7a6528ca9c$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}

function $ce469d7a6528ca9c$var$destroyer(stream, reading, writing, callback) {
    callback = $ce469d7a6528ca9c$var$once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if ($ce469d7a6528ca9c$var$eos === undefined) $ce469d7a6528ca9c$var$eos = (parcelRequire("i1zMF"));
    $ce469d7a6528ca9c$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($ce469d7a6528ca9c$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new $ce469d7a6528ca9c$var$ERR_STREAM_DESTROYED("pipe"));
    };
}
function $ce469d7a6528ca9c$var$call(fn) {
    fn();
}
function $ce469d7a6528ca9c$var$pipe(from, to) {
    return from.pipe(to);
}
function $ce469d7a6528ca9c$var$popCallback(streams) {
    if (!streams.length) return $ce469d7a6528ca9c$var$noop;
    if (typeof streams[streams.length - 1] !== "function") return $ce469d7a6528ca9c$var$noop;
    return streams.pop();
}
function $ce469d7a6528ca9c$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $ce469d7a6528ca9c$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $ce469d7a6528ca9c$var$ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $ce469d7a6528ca9c$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($ce469d7a6528ca9c$var$call);
            if (reading) return;
            destroys.forEach($ce469d7a6528ca9c$var$call);
            callback(error);
        });
    });
    return streams.reduce($ce469d7a6528ca9c$var$pipe);
}
module.exports = $ce469d7a6528ca9c$var$pipeline;

});




parcelRegister("6B3Qg", function(module, exports) {
"use strict";

var $gzLuY = parcelRequire("gzLuY");
var $4cd92db7ac4b15a3$require$Buffer = $gzLuY.Buffer;

var $kvFQ5 = parcelRequire("kvFQ5");

var $4E6hc = parcelRequire("4E6hc");
var $4cd92db7ac4b15a3$var$ARRAY16 = new Array(16);
var $4cd92db7ac4b15a3$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $4cd92db7ac4b15a3$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $4cd92db7ac4b15a3$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $4cd92db7ac4b15a3$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $4cd92db7ac4b15a3$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $4cd92db7ac4b15a3$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $4cd92db7ac4b15a3$var$RIPEMD160() {
    $4E6hc.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$kvFQ5($4cd92db7ac4b15a3$var$RIPEMD160, $4E6hc);
$4cd92db7ac4b15a3$var$RIPEMD160.prototype._update = function() {
    var words = $4cd92db7ac4b15a3$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $4cd92db7ac4b15a3$var$fn1(al, bl, cl, dl, el, words[$4cd92db7ac4b15a3$var$zl[i]], $4cd92db7ac4b15a3$var$hl[0], $4cd92db7ac4b15a3$var$sl[i]);
            tr = $4cd92db7ac4b15a3$var$fn5(ar, br, cr, dr, er, words[$4cd92db7ac4b15a3$var$zr[i]], $4cd92db7ac4b15a3$var$hr[0], $4cd92db7ac4b15a3$var$sr[i]);
        } else if (i < 32) {
            tl = $4cd92db7ac4b15a3$var$fn2(al, bl, cl, dl, el, words[$4cd92db7ac4b15a3$var$zl[i]], $4cd92db7ac4b15a3$var$hl[1], $4cd92db7ac4b15a3$var$sl[i]);
            tr = $4cd92db7ac4b15a3$var$fn4(ar, br, cr, dr, er, words[$4cd92db7ac4b15a3$var$zr[i]], $4cd92db7ac4b15a3$var$hr[1], $4cd92db7ac4b15a3$var$sr[i]);
        } else if (i < 48) {
            tl = $4cd92db7ac4b15a3$var$fn3(al, bl, cl, dl, el, words[$4cd92db7ac4b15a3$var$zl[i]], $4cd92db7ac4b15a3$var$hl[2], $4cd92db7ac4b15a3$var$sl[i]);
            tr = $4cd92db7ac4b15a3$var$fn3(ar, br, cr, dr, er, words[$4cd92db7ac4b15a3$var$zr[i]], $4cd92db7ac4b15a3$var$hr[2], $4cd92db7ac4b15a3$var$sr[i]);
        } else if (i < 64) {
            tl = $4cd92db7ac4b15a3$var$fn4(al, bl, cl, dl, el, words[$4cd92db7ac4b15a3$var$zl[i]], $4cd92db7ac4b15a3$var$hl[3], $4cd92db7ac4b15a3$var$sl[i]);
            tr = $4cd92db7ac4b15a3$var$fn2(ar, br, cr, dr, er, words[$4cd92db7ac4b15a3$var$zr[i]], $4cd92db7ac4b15a3$var$hr[3], $4cd92db7ac4b15a3$var$sr[i]);
        } else {
            tl = $4cd92db7ac4b15a3$var$fn5(al, bl, cl, dl, el, words[$4cd92db7ac4b15a3$var$zl[i]], $4cd92db7ac4b15a3$var$hl[4], $4cd92db7ac4b15a3$var$sl[i]);
            tr = $4cd92db7ac4b15a3$var$fn1(ar, br, cr, dr, er, words[$4cd92db7ac4b15a3$var$zr[i]], $4cd92db7ac4b15a3$var$hr[4], $4cd92db7ac4b15a3$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $4cd92db7ac4b15a3$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $4cd92db7ac4b15a3$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$4cd92db7ac4b15a3$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $4cd92db7ac4b15a3$require$Buffer.alloc ? $4cd92db7ac4b15a3$require$Buffer.alloc(20) : new $4cd92db7ac4b15a3$require$Buffer(20);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
function $4cd92db7ac4b15a3$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $4cd92db7ac4b15a3$var$fn1(a, b, c, d, e, m, k, s) {
    return $4cd92db7ac4b15a3$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $4cd92db7ac4b15a3$var$fn2(a, b, c, d, e, m, k, s) {
    return $4cd92db7ac4b15a3$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $4cd92db7ac4b15a3$var$fn3(a, b, c, d, e, m, k, s) {
    return $4cd92db7ac4b15a3$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $4cd92db7ac4b15a3$var$fn4(a, b, c, d, e, m, k, s) {
    return $4cd92db7ac4b15a3$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $4cd92db7ac4b15a3$var$fn5(a, b, c, d, e, m, k, s) {
    return $4cd92db7ac4b15a3$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
module.exports = $4cd92db7ac4b15a3$var$RIPEMD160;

});

parcelRegister("cWKoG", function(module, exports) {
var $96cee456979899bd$var$exports = module.exports = function SHA(algorithm) {
    algorithm = algorithm.toLowerCase();
    var Algorithm = $96cee456979899bd$var$exports[algorithm];
    if (!Algorithm) throw new Error(algorithm + " is not supported (we accept pull requests)");
    return new Algorithm();
};

$96cee456979899bd$var$exports.sha = (parcelRequire("9C2df"));

$96cee456979899bd$var$exports.sha1 = (parcelRequire("2pwhy"));

$96cee456979899bd$var$exports.sha224 = (parcelRequire("3zu8K"));

$96cee456979899bd$var$exports.sha256 = (parcelRequire("fxEaM"));

$96cee456979899bd$var$exports.sha384 = (parcelRequire("jgu7i"));

$96cee456979899bd$var$exports.sha512 = (parcelRequire("eieYH"));

});
parcelRegister("9C2df", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */ 
var $kvFQ5 = parcelRequire("kvFQ5");

var $jlMGX = parcelRequire("jlMGX");

var $eN0t8 = parcelRequire("eN0t8");
var $6ff9610bb83aff6e$require$Buffer = $eN0t8.Buffer;
var $6ff9610bb83aff6e$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $6ff9610bb83aff6e$var$W = new Array(80);
function $6ff9610bb83aff6e$var$Sha() {
    this.init();
    this._w = $6ff9610bb83aff6e$var$W;
    $jlMGX.call(this, 64, 56);
}
$kvFQ5($6ff9610bb83aff6e$var$Sha, $jlMGX);
$6ff9610bb83aff6e$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $6ff9610bb83aff6e$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $6ff9610bb83aff6e$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $6ff9610bb83aff6e$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$6ff9610bb83aff6e$var$Sha.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $6ff9610bb83aff6e$var$rotl5(a) + $6ff9610bb83aff6e$var$ft(s, b, c, d) + e + W[j] + $6ff9610bb83aff6e$var$K[s] | 0;
        e = d;
        d = c;
        c = $6ff9610bb83aff6e$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$6ff9610bb83aff6e$var$Sha.prototype._hash = function() {
    var H = $6ff9610bb83aff6e$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $6ff9610bb83aff6e$var$Sha;

});
parcelRegister("jlMGX", function(module, exports) {

var $eN0t8 = parcelRequire("eN0t8");
var $e165bfac2320c5ec$require$Buffer = $eN0t8.Buffer;
// prototype class for hash functions
function $e165bfac2320c5ec$var$Hash(blockSize, finalSize) {
    this._block = $e165bfac2320c5ec$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$e165bfac2320c5ec$var$Hash.prototype.update = function(data, enc) {
    if (typeof data === "string") {
        enc = enc || "utf8";
        data = $e165bfac2320c5ec$require$Buffer.from(data, enc);
    }
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$e165bfac2320c5ec$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
    // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
    this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$e165bfac2320c5ec$var$Hash.prototype._update = function() {
    throw new Error("_update must be implemented by subclass");
};
module.exports = $e165bfac2320c5ec$var$Hash;

});


parcelRegister("2pwhy", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */ 
var $kvFQ5 = parcelRequire("kvFQ5");

var $jlMGX = parcelRequire("jlMGX");

var $eN0t8 = parcelRequire("eN0t8");
var $1c16f51ebcd2407a$require$Buffer = $eN0t8.Buffer;
var $1c16f51ebcd2407a$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $1c16f51ebcd2407a$var$W = new Array(80);
function $1c16f51ebcd2407a$var$Sha1() {
    this.init();
    this._w = $1c16f51ebcd2407a$var$W;
    $jlMGX.call(this, 64, 56);
}
$kvFQ5($1c16f51ebcd2407a$var$Sha1, $jlMGX);
$1c16f51ebcd2407a$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $1c16f51ebcd2407a$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $1c16f51ebcd2407a$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $1c16f51ebcd2407a$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $1c16f51ebcd2407a$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$1c16f51ebcd2407a$var$Sha1.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = $1c16f51ebcd2407a$var$rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $1c16f51ebcd2407a$var$rotl5(a) + $1c16f51ebcd2407a$var$ft(s, b, c, d) + e + W[j] + $1c16f51ebcd2407a$var$K[s] | 0;
        e = d;
        d = c;
        c = $1c16f51ebcd2407a$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$1c16f51ebcd2407a$var$Sha1.prototype._hash = function() {
    var H = $1c16f51ebcd2407a$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $1c16f51ebcd2407a$var$Sha1;

});

parcelRegister("3zu8K", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $kvFQ5 = parcelRequire("kvFQ5");

var $fxEaM = parcelRequire("fxEaM");

var $jlMGX = parcelRequire("jlMGX");

var $eN0t8 = parcelRequire("eN0t8");
var $299c052ad24da244$require$Buffer = $eN0t8.Buffer;
var $299c052ad24da244$var$W = new Array(64);
function $299c052ad24da244$var$Sha224() {
    this.init();
    this._w = $299c052ad24da244$var$W // new Array(64)
    ;
    $jlMGX.call(this, 64, 56);
}
$kvFQ5($299c052ad24da244$var$Sha224, $fxEaM);
$299c052ad24da244$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$299c052ad24da244$var$Sha224.prototype._hash = function() {
    var H = $299c052ad24da244$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $299c052ad24da244$var$Sha224;

});
parcelRegister("fxEaM", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $kvFQ5 = parcelRequire("kvFQ5");

var $jlMGX = parcelRequire("jlMGX");

var $eN0t8 = parcelRequire("eN0t8");
var $b5091999693c4415$require$Buffer = $eN0t8.Buffer;
var $b5091999693c4415$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $b5091999693c4415$var$W = new Array(64);
function $b5091999693c4415$var$Sha256() {
    this.init();
    this._w = $b5091999693c4415$var$W // new Array(64)
    ;
    $jlMGX.call(this, 64, 56);
}
$kvFQ5($b5091999693c4415$var$Sha256, $jlMGX);
$b5091999693c4415$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $b5091999693c4415$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $b5091999693c4415$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $b5091999693c4415$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $b5091999693c4415$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $b5091999693c4415$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $b5091999693c4415$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$b5091999693c4415$var$Sha256.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)W[i] = $b5091999693c4415$var$gamma1(W[i - 2]) + W[i - 7] + $b5091999693c4415$var$gamma0(W[i - 15]) + W[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $b5091999693c4415$var$sigma1(e) + $b5091999693c4415$var$ch(e, f, g) + $b5091999693c4415$var$K[j] + W[j] | 0;
        var T2 = $b5091999693c4415$var$sigma0(a) + $b5091999693c4415$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$b5091999693c4415$var$Sha256.prototype._hash = function() {
    var H = $b5091999693c4415$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $b5091999693c4415$var$Sha256;

});


parcelRegister("jgu7i", function(module, exports) {

var $kvFQ5 = parcelRequire("kvFQ5");

var $eieYH = parcelRequire("eieYH");

var $jlMGX = parcelRequire("jlMGX");

var $eN0t8 = parcelRequire("eN0t8");
var $e066df821c998c38$require$Buffer = $eN0t8.Buffer;
var $e066df821c998c38$var$W = new Array(160);
function $e066df821c998c38$var$Sha384() {
    this.init();
    this._w = $e066df821c998c38$var$W;
    $jlMGX.call(this, 128, 112);
}
$kvFQ5($e066df821c998c38$var$Sha384, $eieYH);
$e066df821c998c38$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$e066df821c998c38$var$Sha384.prototype._hash = function() {
    var H = $e066df821c998c38$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $e066df821c998c38$var$Sha384;

});
parcelRegister("eieYH", function(module, exports) {

var $kvFQ5 = parcelRequire("kvFQ5");

var $jlMGX = parcelRequire("jlMGX");

var $eN0t8 = parcelRequire("eN0t8");
var $a67e5d6d788716bb$require$Buffer = $eN0t8.Buffer;
var $a67e5d6d788716bb$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $a67e5d6d788716bb$var$W = new Array(160);
function $a67e5d6d788716bb$var$Sha512() {
    this.init();
    this._w = $a67e5d6d788716bb$var$W;
    $jlMGX.call(this, 128, 112);
}
$kvFQ5($a67e5d6d788716bb$var$Sha512, $jlMGX);
$a67e5d6d788716bb$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $a67e5d6d788716bb$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $a67e5d6d788716bb$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $a67e5d6d788716bb$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $a67e5d6d788716bb$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $a67e5d6d788716bb$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $a67e5d6d788716bb$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $a67e5d6d788716bb$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $a67e5d6d788716bb$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $a67e5d6d788716bb$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$a67e5d6d788716bb$var$Sha512.prototype._update = function(M) {
    var W = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        W[i] = M.readInt32BE(i * 4);
        W[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = W[i - 30];
        var xl = W[i - 30 + 1];
        var gamma0 = $a67e5d6d788716bb$var$Gamma0(xh, xl);
        var gamma0l = $a67e5d6d788716bb$var$Gamma0l(xl, xh);
        xh = W[i - 4];
        xl = W[i - 4 + 1];
        var gamma1 = $a67e5d6d788716bb$var$Gamma1(xh, xl);
        var gamma1l = $a67e5d6d788716bb$var$Gamma1l(xl, xh);
        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
        var Wi7h = W[i - 14];
        var Wi7l = W[i - 14 + 1];
        var Wi16h = W[i - 32];
        var Wi16l = W[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $a67e5d6d788716bb$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $a67e5d6d788716bb$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $a67e5d6d788716bb$var$getCarry(Wil, Wi16l) | 0;
        W[i] = Wih;
        W[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = W[j];
        Wil = W[j + 1];
        var majh = $a67e5d6d788716bb$var$maj(ah, bh, ch);
        var majl = $a67e5d6d788716bb$var$maj(al, bl, cl);
        var sigma0h = $a67e5d6d788716bb$var$sigma0(ah, al);
        var sigma0l = $a67e5d6d788716bb$var$sigma0(al, ah);
        var sigma1h = $a67e5d6d788716bb$var$sigma1(eh, el);
        var sigma1l = $a67e5d6d788716bb$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + W[j]
        var Kih = $a67e5d6d788716bb$var$K[j];
        var Kil = $a67e5d6d788716bb$var$K[j + 1];
        var chh = $a67e5d6d788716bb$var$Ch(eh, fh, gh);
        var chl = $a67e5d6d788716bb$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $a67e5d6d788716bb$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $a67e5d6d788716bb$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $a67e5d6d788716bb$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $a67e5d6d788716bb$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $a67e5d6d788716bb$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $a67e5d6d788716bb$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $a67e5d6d788716bb$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $a67e5d6d788716bb$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $a67e5d6d788716bb$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $a67e5d6d788716bb$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $a67e5d6d788716bb$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $a67e5d6d788716bb$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $a67e5d6d788716bb$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $a67e5d6d788716bb$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $a67e5d6d788716bb$var$getCarry(this._hl, hl) | 0;
};
$a67e5d6d788716bb$var$Sha512.prototype._hash = function() {
    var H = $a67e5d6d788716bb$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $a67e5d6d788716bb$var$Sha512;

});



parcelRegister("61MIM", function(module, exports) {

var $eN0t8 = parcelRequire("eN0t8");
var $4638a1175229f183$require$Buffer = $eN0t8.Buffer;

var $b2J01 = parcelRequire("b2J01");
var $4638a1175229f183$require$Transform = $b2J01.Transform;

var $hXidu = parcelRequire("hXidu");
var $4638a1175229f183$require$StringDecoder = $hXidu.StringDecoder;

var $kvFQ5 = parcelRequire("kvFQ5");
function $4638a1175229f183$var$CipherBase(hashMode) {
    $4638a1175229f183$require$Transform.call(this);
    this.hashMode = typeof hashMode === "string";
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this.final = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$kvFQ5($4638a1175229f183$var$CipherBase, $4638a1175229f183$require$Transform);
$4638a1175229f183$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    if (typeof data === "string") data = $4638a1175229f183$require$Buffer.from(data, inputEnc);
    var outData = this._update(data);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$4638a1175229f183$var$CipherBase.prototype.setAutoPadding = function() {};
$4638a1175229f183$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error("trying to get auth tag in unsupported state");
};
$4638a1175229f183$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error("trying to set auth tag in unsupported state");
};
$4638a1175229f183$var$CipherBase.prototype.setAAD = function() {
    throw new Error("trying to set aad in unsupported state");
};
$4638a1175229f183$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$4638a1175229f183$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$4638a1175229f183$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $4638a1175229f183$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$4638a1175229f183$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $4638a1175229f183$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can't switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $4638a1175229f183$var$CipherBase;

});
parcelRegister("b2J01", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $80a2c98655d877d9$var$Stream;

var $wvaTc = parcelRequire("wvaTc");
var $80a2c98655d877d9$require$EE = $wvaTc.EventEmitter;

var $kvFQ5 = parcelRequire("kvFQ5");
$kvFQ5($80a2c98655d877d9$var$Stream, $80a2c98655d877d9$require$EE);

$80a2c98655d877d9$var$Stream.Readable = (parcelRequire("hJHBh"));

$80a2c98655d877d9$var$Stream.Writable = (parcelRequire("3AY6k"));

$80a2c98655d877d9$var$Stream.Duplex = (parcelRequire("kTUB1"));

$80a2c98655d877d9$var$Stream.Transform = (parcelRequire("9wbVx"));

$80a2c98655d877d9$var$Stream.PassThrough = (parcelRequire("3Frfy"));

$80a2c98655d877d9$var$Stream.finished = (parcelRequire("i1zMF"));

$80a2c98655d877d9$var$Stream.pipeline = (parcelRequire("hI05B"));
// Backwards-compat with node 0.4.x
$80a2c98655d877d9$var$Stream.Stream = $80a2c98655d877d9$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $80a2c98655d877d9$var$Stream() {
    $80a2c98655d877d9$require$EE.call(this);
}
$80a2c98655d877d9$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on("data", ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on("drain", ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on("end", onend);
        source.on("close", onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === "function") dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($80a2c98655d877d9$require$EE.listenerCount(this, "error") === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on("error", onerror);
    dest.on("error", onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener("data", ondata);
        dest.removeListener("drain", ondrain);
        source.removeListener("end", onend);
        source.removeListener("close", onclose);
        source.removeListener("error", onerror);
        dest.removeListener("error", onerror);
        source.removeListener("end", cleanup);
        source.removeListener("close", cleanup);
        dest.removeListener("close", cleanup);
    }
    source.on("end", cleanup);
    source.on("close", cleanup);
    dest.on("close", cleanup);
    dest.emit("pipe", source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});



parcelRegister("l2ANw", function(module, exports) {
"use strict";

var $kvFQ5 = parcelRequire("kvFQ5");

var $kpXJ9 = parcelRequire("kpXJ9");

var $61MIM = parcelRequire("61MIM");

var $eN0t8 = parcelRequire("eN0t8");
var $f5165421c703f446$require$Buffer = $eN0t8.Buffer;

var $2ltcv = parcelRequire("2ltcv");

var $6B3Qg = parcelRequire("6B3Qg");

var $cWKoG = parcelRequire("cWKoG");
var $f5165421c703f446$var$ZEROS = $f5165421c703f446$require$Buffer.alloc(128);
function $f5165421c703f446$var$Hmac(alg, key) {
    $61MIM.call(this, "digest");
    if (typeof key === "string") key = $f5165421c703f446$require$Buffer.from(key);
    var blocksize = alg === "sha512" || alg === "sha384" ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === "rmd160" ? new $6B3Qg() : $cWKoG(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $f5165421c703f446$require$Buffer.concat([
        key,
        $f5165421c703f446$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $f5165421c703f446$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $f5165421c703f446$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === "rmd160" ? new $6B3Qg() : $cWKoG(alg);
    this._hash.update(ipad);
}
$kvFQ5($f5165421c703f446$var$Hmac, $61MIM);
$f5165421c703f446$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$f5165421c703f446$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === "rmd160" ? new $6B3Qg() : $cWKoG(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === "rmd160" || alg === "ripemd160") return new $f5165421c703f446$var$Hmac("rmd160", key);
    if (alg === "md5") return new $kpXJ9($2ltcv, key);
    return new $f5165421c703f446$var$Hmac(alg, key);
};

});
parcelRegister("kpXJ9", function(module, exports) {
"use strict";

var $kvFQ5 = parcelRequire("kvFQ5");

var $eN0t8 = parcelRequire("eN0t8");
var $edd4790b80213788$require$Buffer = $eN0t8.Buffer;

var $61MIM = parcelRequire("61MIM");
var $edd4790b80213788$var$ZEROS = $edd4790b80213788$require$Buffer.alloc(128);
var $edd4790b80213788$var$blocksize = 64;
function $edd4790b80213788$var$Hmac(alg, key) {
    $61MIM.call(this, "digest");
    if (typeof key === "string") key = $edd4790b80213788$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $edd4790b80213788$var$blocksize) key = alg(key);
    else if (key.length < $edd4790b80213788$var$blocksize) key = $edd4790b80213788$require$Buffer.concat([
        key,
        $edd4790b80213788$var$ZEROS
    ], $edd4790b80213788$var$blocksize);
    var ipad = this._ipad = $edd4790b80213788$require$Buffer.allocUnsafe($edd4790b80213788$var$blocksize);
    var opad = this._opad = $edd4790b80213788$require$Buffer.allocUnsafe($edd4790b80213788$var$blocksize);
    for(var i = 0; i < $edd4790b80213788$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$kvFQ5($edd4790b80213788$var$Hmac, $61MIM);
$edd4790b80213788$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$edd4790b80213788$var$Hmac.prototype._final = function() {
    var h = this._alg($edd4790b80213788$require$Buffer.concat(this._hash));
    return this._alg($edd4790b80213788$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $edd4790b80213788$var$Hmac;

});

parcelRegister("2ltcv", function(module, exports) {

var $dGbYv = parcelRequire("dGbYv");
module.exports = function(buffer) {
    return new $dGbYv().update(buffer).digest();
};

});


parcelRegister("dcgwh", function(module, exports) {
"use strict";

module.exports = (parcelRequire("ggpby"));

});
parcelRegister("ggpby", function(module, exports) {
module.exports = JSON.parse('{"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}');

});


parcelRegister("2r16u", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", function () { return $1c5ef58ccb76778e$export$448fa22aedc9dbca; }, function (v) { return $1c5ef58ccb76778e$export$448fa22aedc9dbca = v; });
$parcel$export(module.exports, "pbkdf2Sync", function () { return $1c5ef58ccb76778e$export$b80c7ba289c8fa56; }, function (v) { return $1c5ef58ccb76778e$export$b80c7ba289c8fa56 = v; });
var $1c5ef58ccb76778e$export$448fa22aedc9dbca;
var $1c5ef58ccb76778e$export$b80c7ba289c8fa56;

$1c5ef58ccb76778e$export$448fa22aedc9dbca = (parcelRequire("dAOoN"));

$1c5ef58ccb76778e$export$b80c7ba289c8fa56 = (parcelRequire("iUG0Q"));

});
parcelRegister("dAOoN", function(module, exports) {

var $eN0t8 = parcelRequire("eN0t8");
var $9e55bb59acd987ab$require$Buffer = $eN0t8.Buffer;

var $a8w1O = parcelRequire("a8w1O");

var $26PHw = parcelRequire("26PHw");

var $iUG0Q = parcelRequire("iUG0Q");

var $kGazS = parcelRequire("kGazS");
var $9e55bb59acd987ab$var$ZERO_BUF;
var $9e55bb59acd987ab$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $9e55bb59acd987ab$var$toBrowser = {
    sha: "SHA-1",
    "sha-1": "SHA-1",
    sha1: "SHA-1",
    sha256: "SHA-256",
    "sha-256": "SHA-256",
    sha384: "SHA-384",
    "sha-384": "SHA-384",
    "sha-512": "SHA-512",
    sha512: "SHA-512"
};
var $9e55bb59acd987ab$var$checks = [];
function $9e55bb59acd987ab$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$9e55bb59acd987ab$var$subtle || !$9e55bb59acd987ab$var$subtle.importKey || !$9e55bb59acd987ab$var$subtle.deriveBits) return Promise.resolve(false);
    if ($9e55bb59acd987ab$var$checks[algo] !== undefined) return $9e55bb59acd987ab$var$checks[algo];
    $9e55bb59acd987ab$var$ZERO_BUF = $9e55bb59acd987ab$var$ZERO_BUF || $9e55bb59acd987ab$require$Buffer.alloc(8);
    var prom = $9e55bb59acd987ab$var$browserPbkdf2($9e55bb59acd987ab$var$ZERO_BUF, $9e55bb59acd987ab$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }).catch(function() {
        return false;
    });
    $9e55bb59acd987ab$var$checks[algo] = prom;
    return prom;
}
var $9e55bb59acd987ab$var$nextTick;
function $9e55bb59acd987ab$var$getNextTick() {
    if ($9e55bb59acd987ab$var$nextTick) return $9e55bb59acd987ab$var$nextTick;
    if ($parcel$global.process && $parcel$global.process.nextTick) $9e55bb59acd987ab$var$nextTick = $parcel$global.process.nextTick;
    else if ($parcel$global.queueMicrotask) $9e55bb59acd987ab$var$nextTick = $parcel$global.queueMicrotask;
    else if ($parcel$global.setImmediate) $9e55bb59acd987ab$var$nextTick = $parcel$global.setImmediate;
    else $9e55bb59acd987ab$var$nextTick = $parcel$global.setTimeout;
    return $9e55bb59acd987ab$var$nextTick;
}
function $9e55bb59acd987ab$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $9e55bb59acd987ab$var$subtle.importKey("raw", password, {
        name: "PBKDF2"
    }, false, [
        "deriveBits"
    ]).then(function(key) {
        return $9e55bb59acd987ab$var$subtle.deriveBits({
            name: "PBKDF2",
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $9e55bb59acd987ab$require$Buffer.from(res);
    });
}
function $9e55bb59acd987ab$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $9e55bb59acd987ab$var$getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        $9e55bb59acd987ab$var$getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === "function") {
        callback = digest;
        digest = undefined;
    }
    digest = digest || "sha1";
    var algo = $9e55bb59acd987ab$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== "function") {
        $9e55bb59acd987ab$var$getNextTick()(function() {
            var out;
            try {
                out = $iUG0Q(password, salt, iterations, keylen, digest);
            } catch (e) {
                return callback(e);
            }
            callback(null, out);
        });
        return;
    }
    $a8w1O(iterations, keylen);
    password = $kGazS(password, $26PHw, "Password");
    salt = $kGazS(salt, $26PHw, "Salt");
    if (typeof callback !== "function") throw new Error("No callback provided to pbkdf2");
    $9e55bb59acd987ab$var$resolvePromise($9e55bb59acd987ab$var$checkNative(algo).then(function(resp) {
        if (resp) return $9e55bb59acd987ab$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        return $iUG0Q(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRegister("a8w1O", function(module, exports) {
var $76137edb2e21374c$var$MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs
;
module.exports = function(iterations, keylen) {
    if (typeof iterations !== "number") throw new TypeError("Iterations not a number");
    if (iterations < 0) throw new TypeError("Bad iterations");
    if (typeof keylen !== "number") throw new TypeError("Key length not a number");
    if (keylen < 0 || keylen > $76137edb2e21374c$var$MAX_ALLOC || keylen !== keylen) throw new TypeError("Bad key length");
};

});

parcelRegister("26PHw", function(module, exports) {

var $a8i8g = parcelRequire("a8i8g");
var $18943f11206ac0c0$var$defaultEncoding;
/* istanbul ignore next */ if ($parcel$global.process && $parcel$global.process.browser) $18943f11206ac0c0$var$defaultEncoding = "utf-8";
else if ($parcel$global.process && $parcel$global.process.version) {
    var $18943f11206ac0c0$var$pVersionMajor = parseInt($a8i8g.version.split(".")[0].slice(1), 10);
    $18943f11206ac0c0$var$defaultEncoding = $18943f11206ac0c0$var$pVersionMajor >= 6 ? "utf-8" : "binary";
} else $18943f11206ac0c0$var$defaultEncoding = "utf-8";
module.exports = $18943f11206ac0c0$var$defaultEncoding;

});

parcelRegister("iUG0Q", function(module, exports) {

var $2ltcv = parcelRequire("2ltcv");

var $6B3Qg = parcelRequire("6B3Qg");

var $cWKoG = parcelRequire("cWKoG");

var $eN0t8 = parcelRequire("eN0t8");
var $dc4e0bc70f7259d3$require$Buffer = $eN0t8.Buffer;

var $a8w1O = parcelRequire("a8w1O");

var $26PHw = parcelRequire("26PHw");

var $kGazS = parcelRequire("kGazS");
var $dc4e0bc70f7259d3$var$ZEROS = $dc4e0bc70f7259d3$require$Buffer.alloc(128);
var $dc4e0bc70f7259d3$var$sizes = {
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    rmd160: 20,
    ripemd160: 20
};
function $dc4e0bc70f7259d3$var$Hmac(alg, key, saltLen) {
    var hash = $dc4e0bc70f7259d3$var$getDigest(alg);
    var blocksize = alg === "sha512" || alg === "sha384" ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $dc4e0bc70f7259d3$require$Buffer.concat([
        key,
        $dc4e0bc70f7259d3$var$ZEROS
    ], blocksize);
    var ipad = $dc4e0bc70f7259d3$require$Buffer.allocUnsafe(blocksize + $dc4e0bc70f7259d3$var$sizes[alg]);
    var opad = $dc4e0bc70f7259d3$require$Buffer.allocUnsafe(blocksize + $dc4e0bc70f7259d3$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $dc4e0bc70f7259d3$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $dc4e0bc70f7259d3$var$sizes[alg];
}
$dc4e0bc70f7259d3$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $dc4e0bc70f7259d3$var$getDigest(alg) {
    function shaFunc(data) {
        return $cWKoG(alg).update(data).digest();
    }
    function rmd160Func(data) {
        return new $6B3Qg().update(data).digest();
    }
    if (alg === "rmd160" || alg === "ripemd160") return rmd160Func;
    if (alg === "md5") return $2ltcv;
    return shaFunc;
}
function $dc4e0bc70f7259d3$var$pbkdf2(password, salt, iterations, keylen, digest) {
    $a8w1O(iterations, keylen);
    password = $kGazS(password, $26PHw, "Password");
    salt = $kGazS(salt, $26PHw, "Salt");
    digest = digest || "sha1";
    var hmac = new $dc4e0bc70f7259d3$var$Hmac(digest, password, salt.length);
    var DK = $dc4e0bc70f7259d3$require$Buffer.allocUnsafe(keylen);
    var block1 = $dc4e0bc70f7259d3$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = $dc4e0bc70f7259d3$var$sizes[digest];
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $dc4e0bc70f7259d3$var$pbkdf2;

});
parcelRegister("kGazS", function(module, exports) {

var $eN0t8 = parcelRequire("eN0t8");
var $f0dfef66b7976d7c$require$Buffer = $eN0t8.Buffer;
module.exports = function(thing, encoding, name) {
    if ($f0dfef66b7976d7c$require$Buffer.isBuffer(thing)) return thing;
    else if (typeof thing === "string") return $f0dfef66b7976d7c$require$Buffer.from(thing, encoding);
    else if (ArrayBuffer.isView(thing)) return $f0dfef66b7976d7c$require$Buffer.from(thing.buffer);
    else throw new TypeError(name + " must be a string, a Buffer, a typed array or a DataView");
};

});




parcelRegister("5Il2G", function(module, exports) {

$parcel$export(module.exports, "createCipher", function () { return $4291626505339b67$export$bdd223f16383713e; }, function (v) { return $4291626505339b67$export$bdd223f16383713e = v; });
$parcel$export(module.exports, "Cipher", function () { return $4291626505339b67$export$26e5786e8ac8e530; }, function (v) { return $4291626505339b67$export$26e5786e8ac8e530 = v; });
$parcel$export(module.exports, "createCipheriv", function () { return $4291626505339b67$export$2f64596b8cbf08b4; }, function (v) { return $4291626505339b67$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "Cipheriv", function () { return $4291626505339b67$export$20533d26f07f1ee0; }, function (v) { return $4291626505339b67$export$20533d26f07f1ee0 = v; });
$parcel$export(module.exports, "createDecipher", function () { return $4291626505339b67$export$12ada9414fbc594c; }, function (v) { return $4291626505339b67$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "Decipher", function () { return $4291626505339b67$export$2ce6d8d0e8b04e1a; }, function (v) { return $4291626505339b67$export$2ce6d8d0e8b04e1a = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $4291626505339b67$export$36b6d6ef312eab39; }, function (v) { return $4291626505339b67$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "Decipheriv", function () { return $4291626505339b67$export$f5e7e39d57cd9700; }, function (v) { return $4291626505339b67$export$f5e7e39d57cd9700 = v; });
$parcel$export(module.exports, "listCiphers", function () { return $4291626505339b67$export$dedd8dc3dc62b370; }, function (v) { return $4291626505339b67$export$dedd8dc3dc62b370 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $4291626505339b67$export$58a258485f1e49f6; }, function (v) { return $4291626505339b67$export$58a258485f1e49f6 = v; });
var $4291626505339b67$export$bdd223f16383713e;
var $4291626505339b67$export$26e5786e8ac8e530;
var $4291626505339b67$export$2f64596b8cbf08b4;
var $4291626505339b67$export$20533d26f07f1ee0;
var $4291626505339b67$export$12ada9414fbc594c;
var $4291626505339b67$export$2ce6d8d0e8b04e1a;
var $4291626505339b67$export$36b6d6ef312eab39;
var $4291626505339b67$export$f5e7e39d57cd9700;
var $4291626505339b67$export$dedd8dc3dc62b370;
var $4291626505339b67$export$58a258485f1e49f6;

var $6JKVP = parcelRequire("6JKVP");

var $X9qDO = parcelRequire("X9qDO");

var $E9Jyp = parcelRequire("E9Jyp");

var $ikXWd = parcelRequire("ikXWd");

var $bFXtK = parcelRequire("bFXtK");
function $4291626505339b67$var$createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($E9Jyp[suite]) {
        keyLen = $E9Jyp[suite].key;
        ivLen = $E9Jyp[suite].iv;
    } else if ($ikXWd[suite]) {
        keyLen = $ikXWd[suite].key * 8;
        ivLen = $ikXWd[suite].iv;
    } else throw new TypeError("invalid suite type");
    var keys = $bFXtK(password, false, keyLen, ivLen);
    return $4291626505339b67$var$createCipheriv(suite, keys.key, keys.iv);
}
function $4291626505339b67$var$createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($E9Jyp[suite]) {
        keyLen = $E9Jyp[suite].key;
        ivLen = $E9Jyp[suite].iv;
    } else if ($ikXWd[suite]) {
        keyLen = $ikXWd[suite].key * 8;
        ivLen = $ikXWd[suite].iv;
    } else throw new TypeError("invalid suite type");
    var keys = $bFXtK(password, false, keyLen, ivLen);
    return $4291626505339b67$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $4291626505339b67$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($E9Jyp[suite]) return $X9qDO.createCipheriv(suite, key, iv);
    if ($ikXWd[suite]) return new $6JKVP({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError("invalid suite type");
}
function $4291626505339b67$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($E9Jyp[suite]) return $X9qDO.createDecipheriv(suite, key, iv);
    if ($ikXWd[suite]) return new $6JKVP({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError("invalid suite type");
}
function $4291626505339b67$var$getCiphers() {
    return Object.keys($ikXWd).concat($X9qDO.getCiphers());
}
$4291626505339b67$export$bdd223f16383713e = $4291626505339b67$export$26e5786e8ac8e530 = $4291626505339b67$var$createCipher;
$4291626505339b67$export$2f64596b8cbf08b4 = $4291626505339b67$export$20533d26f07f1ee0 = $4291626505339b67$var$createCipheriv;
$4291626505339b67$export$12ada9414fbc594c = $4291626505339b67$export$2ce6d8d0e8b04e1a = $4291626505339b67$var$createDecipher;
$4291626505339b67$export$36b6d6ef312eab39 = $4291626505339b67$export$f5e7e39d57cd9700 = $4291626505339b67$var$createDecipheriv;
$4291626505339b67$export$dedd8dc3dc62b370 = $4291626505339b67$export$58a258485f1e49f6 = $4291626505339b67$var$getCiphers;

});
parcelRegister("6JKVP", function(module, exports) {

var $61MIM = parcelRequire("61MIM");

var $kARFm = parcelRequire("kARFm");

var $kvFQ5 = parcelRequire("kvFQ5");

var $eN0t8 = parcelRequire("eN0t8");
var $4e7b59b52c41db33$require$Buffer = $eN0t8.Buffer;
var $4e7b59b52c41db33$var$modes = {
    "des-ede3-cbc": $kARFm.CBC.instantiate($kARFm.EDE),
    "des-ede3": $kARFm.EDE,
    "des-ede-cbc": $kARFm.CBC.instantiate($kARFm.EDE),
    "des-ede": $kARFm.EDE,
    "des-cbc": $kARFm.CBC.instantiate($kARFm.DES),
    "des-ecb": $kARFm.DES
};
$4e7b59b52c41db33$var$modes.des = $4e7b59b52c41db33$var$modes["des-cbc"];
$4e7b59b52c41db33$var$modes.des3 = $4e7b59b52c41db33$var$modes["des-ede3-cbc"];
module.exports = $4e7b59b52c41db33$var$DES;
$kvFQ5($4e7b59b52c41db33$var$DES, $61MIM);
function $4e7b59b52c41db33$var$DES(opts) {
    $61MIM.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $4e7b59b52c41db33$var$modes[modeName];
    var type;
    if (opts.decrypt) type = "decrypt";
    else type = "encrypt";
    var key = opts.key;
    if (!$4e7b59b52c41db33$require$Buffer.isBuffer(key)) key = $4e7b59b52c41db33$require$Buffer.from(key);
    if (modeName === "des-ede" || modeName === "des-ede-cbc") key = $4e7b59b52c41db33$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!$4e7b59b52c41db33$require$Buffer.isBuffer(iv)) iv = $4e7b59b52c41db33$require$Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$4e7b59b52c41db33$var$DES.prototype._update = function(data) {
    return $4e7b59b52c41db33$require$Buffer.from(this._des.update(data));
};
$4e7b59b52c41db33$var$DES.prototype._final = function() {
    return $4e7b59b52c41db33$require$Buffer.from(this._des.final());
};

});
parcelRegister("kARFm", function(module, exports) {

$parcel$export(module.exports, "DES", function () { return $efe0cc6de85c3d9f$export$cc8859615686b300; }, function (v) { return $efe0cc6de85c3d9f$export$cc8859615686b300 = v; });
$parcel$export(module.exports, "CBC", function () { return $efe0cc6de85c3d9f$export$8ad3f227af08fcc5; }, function (v) { return $efe0cc6de85c3d9f$export$8ad3f227af08fcc5 = v; });
$parcel$export(module.exports, "EDE", function () { return $efe0cc6de85c3d9f$export$947646e34766044f; }, function (v) { return $efe0cc6de85c3d9f$export$947646e34766044f = v; });
var $efe0cc6de85c3d9f$export$eab97d15b1788b8d;
var $efe0cc6de85c3d9f$export$26e5786e8ac8e530;
var $efe0cc6de85c3d9f$export$cc8859615686b300;
var $efe0cc6de85c3d9f$export$8ad3f227af08fcc5;
var $efe0cc6de85c3d9f$export$947646e34766044f;
"use strict";

$efe0cc6de85c3d9f$export$eab97d15b1788b8d = (parcelRequire("aBLCl"));

$efe0cc6de85c3d9f$export$26e5786e8ac8e530 = (parcelRequire("ouHy4"));

$efe0cc6de85c3d9f$export$cc8859615686b300 = (parcelRequire("9Euae"));

$efe0cc6de85c3d9f$export$8ad3f227af08fcc5 = (parcelRequire("g6X0U"));

$efe0cc6de85c3d9f$export$947646e34766044f = (parcelRequire("jKeW6"));

});
parcelRegister("aBLCl", function(module, exports) {

$parcel$export(module.exports, "readUInt32BE", function () { return $7b924be9366471b4$export$cfaef8ed399428b0; }, function (v) { return $7b924be9366471b4$export$cfaef8ed399428b0 = v; });
$parcel$export(module.exports, "writeUInt32BE", function () { return $7b924be9366471b4$export$a80c7deaea7cbd80; }, function (v) { return $7b924be9366471b4$export$a80c7deaea7cbd80 = v; });
$parcel$export(module.exports, "ip", function () { return $7b924be9366471b4$export$ed7577ae6e1cd0ef; }, function (v) { return $7b924be9366471b4$export$ed7577ae6e1cd0ef = v; });
$parcel$export(module.exports, "rip", function () { return $7b924be9366471b4$export$5dcbef3aa594f567; }, function (v) { return $7b924be9366471b4$export$5dcbef3aa594f567 = v; });
$parcel$export(module.exports, "pc1", function () { return $7b924be9366471b4$export$5bc8001ca71ed9c5; }, function (v) { return $7b924be9366471b4$export$5bc8001ca71ed9c5 = v; });
$parcel$export(module.exports, "r28shl", function () { return $7b924be9366471b4$export$3e714e2c5d5d8cb2; }, function (v) { return $7b924be9366471b4$export$3e714e2c5d5d8cb2 = v; });
$parcel$export(module.exports, "pc2", function () { return $7b924be9366471b4$export$94c3e544fd062b7f; }, function (v) { return $7b924be9366471b4$export$94c3e544fd062b7f = v; });
$parcel$export(module.exports, "expand", function () { return $7b924be9366471b4$export$9f77e0932fb78f72; }, function (v) { return $7b924be9366471b4$export$9f77e0932fb78f72 = v; });
$parcel$export(module.exports, "substitute", function () { return $7b924be9366471b4$export$d865ce2836f5927f; }, function (v) { return $7b924be9366471b4$export$d865ce2836f5927f = v; });
$parcel$export(module.exports, "permute", function () { return $7b924be9366471b4$export$95e62ad65da8b7d2; }, function (v) { return $7b924be9366471b4$export$95e62ad65da8b7d2 = v; });
$parcel$export(module.exports, "padSplit", function () { return $7b924be9366471b4$export$209139ff098c441a; }, function (v) { return $7b924be9366471b4$export$209139ff098c441a = v; });
var $7b924be9366471b4$export$cfaef8ed399428b0;
var $7b924be9366471b4$export$a80c7deaea7cbd80;
var $7b924be9366471b4$export$ed7577ae6e1cd0ef;
var $7b924be9366471b4$export$5dcbef3aa594f567;
var $7b924be9366471b4$export$5bc8001ca71ed9c5;
var $7b924be9366471b4$export$3e714e2c5d5d8cb2;
var $7b924be9366471b4$export$94c3e544fd062b7f;
var $7b924be9366471b4$export$9f77e0932fb78f72;
var $7b924be9366471b4$export$d865ce2836f5927f;
var $7b924be9366471b4$export$95e62ad65da8b7d2;
var $7b924be9366471b4$export$209139ff098c441a;
"use strict";
$7b924be9366471b4$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$7b924be9366471b4$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$7b924be9366471b4$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$7b924be9366471b4$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$7b924be9366471b4$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$7b924be9366471b4$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $7b924be9366471b4$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$7b924be9366471b4$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $7b924be9366471b4$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $7b924be9366471b4$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $7b924be9366471b4$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $7b924be9366471b4$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$7b924be9366471b4$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $7b924be9366471b4$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$7b924be9366471b4$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $7b924be9366471b4$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $7b924be9366471b4$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $7b924be9366471b4$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$7b924be9366471b4$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $7b924be9366471b4$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $7b924be9366471b4$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$7b924be9366471b4$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = "0" + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(" ");
};

});

parcelRegister("ouHy4", function(module, exports) {
"use strict";

var $3210N = parcelRequire("3210N");
function $049a0ea9d0be8ab9$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
    this.padding = options.padding !== false;
}
module.exports = $049a0ea9d0be8ab9$var$Cipher;
$049a0ea9d0be8ab9$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$049a0ea9d0be8ab9$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === "decrypt") return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$049a0ea9d0be8ab9$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$049a0ea9d0be8ab9$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$049a0ea9d0be8ab9$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$049a0ea9d0be8ab9$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$049a0ea9d0be8ab9$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === "encrypt") last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$049a0ea9d0be8ab9$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$049a0ea9d0be8ab9$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$049a0ea9d0be8ab9$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$049a0ea9d0be8ab9$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $3210N.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});
parcelRegister("3210N", function(module, exports) {
module.exports = $235257eb35d12727$var$assert;
function $235257eb35d12727$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$235257eb35d12727$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};

});


parcelRegister("9Euae", function(module, exports) {
"use strict";

var $3210N = parcelRequire("3210N");

var $kvFQ5 = parcelRequire("kvFQ5");

var $aBLCl = parcelRequire("aBLCl");

var $ouHy4 = parcelRequire("ouHy4");
function $706f3f705553ad90$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $706f3f705553ad90$var$DES(options) {
    $ouHy4.call(this, options);
    var state = new $706f3f705553ad90$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$kvFQ5($706f3f705553ad90$var$DES, $ouHy4);
module.exports = $706f3f705553ad90$var$DES;
$706f3f705553ad90$var$DES.create = function create(options) {
    return new $706f3f705553ad90$var$DES(options);
};
var $706f3f705553ad90$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$706f3f705553ad90$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $3210N.equal(key.length, this.blockSize, "Invalid key length");
    var kL = $aBLCl.readUInt32BE(key, 0);
    var kR = $aBLCl.readUInt32BE(key, 4);
    $aBLCl.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $706f3f705553ad90$var$shiftTable[i >>> 1];
        kL = $aBLCl.r28shl(kL, shift);
        kR = $aBLCl.r28shl(kR, shift);
        $aBLCl.pc2(kL, kR, state.keys, i);
    }
};
$706f3f705553ad90$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $aBLCl.readUInt32BE(inp, inOff);
    var r = $aBLCl.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $aBLCl.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === "encrypt") this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $aBLCl.writeUInt32BE(out, l, outOff);
    $aBLCl.writeUInt32BE(out, r, outOff + 4);
};
$706f3f705553ad90$var$DES.prototype._pad = function _pad(buffer, off) {
    if (this.padding === false) return false;
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$706f3f705553ad90$var$DES.prototype._unpad = function _unpad(buffer) {
    if (this.padding === false) return buffer;
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$3210N.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$706f3f705553ad90$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $aBLCl.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $aBLCl.substitute(keyL, keyR);
        var f = $aBLCl.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $aBLCl.rip(r, l, out, off);
};
$706f3f705553ad90$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $aBLCl.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $aBLCl.substitute(keyL, keyR);
        var f = $aBLCl.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $aBLCl.rip(l, r, out, off);
};

});

parcelRegister("g6X0U", function(module, exports) {

$parcel$export(module.exports, "instantiate", function () { return $bbaafbc209442532$export$f9bb8d20ccc7477a; }, function (v) { return $bbaafbc209442532$export$f9bb8d20ccc7477a = v; });
var $bbaafbc209442532$export$f9bb8d20ccc7477a;
"use strict";

var $3210N = parcelRequire("3210N");

var $kvFQ5 = parcelRequire("kvFQ5");
var $bbaafbc209442532$var$proto = {};
function $bbaafbc209442532$var$CBCState(iv) {
    $3210N.equal(iv.length, 8, "Invalid IV length");
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $bbaafbc209442532$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $kvFQ5(CBC, Base);
    var keys = Object.keys($bbaafbc209442532$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $bbaafbc209442532$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$bbaafbc209442532$export$f9bb8d20ccc7477a = $bbaafbc209442532$var$instantiate;
$bbaafbc209442532$var$proto._cbcInit = function _cbcInit() {
    var state = new $bbaafbc209442532$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$bbaafbc209442532$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === "encrypt") {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRegister("jKeW6", function(module, exports) {
"use strict";

var $3210N = parcelRequire("3210N");

var $kvFQ5 = parcelRequire("kvFQ5");

var $ouHy4 = parcelRequire("ouHy4");

var $9Euae = parcelRequire("9Euae");
function $e5fde62e8948339f$var$EDEState(type, key) {
    $3210N.equal(key.length, 24, "Invalid key length");
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === "encrypt") this.ciphers = [
        $9Euae.create({
            type: "encrypt",
            key: k1
        }),
        $9Euae.create({
            type: "decrypt",
            key: k2
        }),
        $9Euae.create({
            type: "encrypt",
            key: k3
        })
    ];
    else this.ciphers = [
        $9Euae.create({
            type: "decrypt",
            key: k3
        }),
        $9Euae.create({
            type: "encrypt",
            key: k2
        }),
        $9Euae.create({
            type: "decrypt",
            key: k1
        })
    ];
}
function $e5fde62e8948339f$var$EDE(options) {
    $ouHy4.call(this, options);
    var state = new $e5fde62e8948339f$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$kvFQ5($e5fde62e8948339f$var$EDE, $ouHy4);
module.exports = $e5fde62e8948339f$var$EDE;
$e5fde62e8948339f$var$EDE.create = function create(options) {
    return new $e5fde62e8948339f$var$EDE(options);
};
$e5fde62e8948339f$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$e5fde62e8948339f$var$EDE.prototype._pad = $9Euae.prototype._pad;
$e5fde62e8948339f$var$EDE.prototype._unpad = $9Euae.prototype._unpad;

});



parcelRegister("X9qDO", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", function () { return $0b1cd32526c8486e$export$2f64596b8cbf08b4; }, function (v) { return $0b1cd32526c8486e$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $0b1cd32526c8486e$export$36b6d6ef312eab39; }, function (v) { return $0b1cd32526c8486e$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $0b1cd32526c8486e$export$58a258485f1e49f6; }, function (v) { return $0b1cd32526c8486e$export$58a258485f1e49f6 = v; });
var $0b1cd32526c8486e$export$bdd223f16383713e;
var $0b1cd32526c8486e$export$26e5786e8ac8e530;
var $0b1cd32526c8486e$export$2f64596b8cbf08b4;
var $0b1cd32526c8486e$export$20533d26f07f1ee0;
var $0b1cd32526c8486e$export$12ada9414fbc594c;
var $0b1cd32526c8486e$export$2ce6d8d0e8b04e1a;
var $0b1cd32526c8486e$export$36b6d6ef312eab39;
var $0b1cd32526c8486e$export$f5e7e39d57cd9700;
var $0b1cd32526c8486e$export$dedd8dc3dc62b370;
var $0b1cd32526c8486e$export$58a258485f1e49f6;

var $cxwy3 = parcelRequire("cxwy3");

var $kicDr = parcelRequire("kicDr");

var $6cI1N = parcelRequire("6cI1N");
function $0b1cd32526c8486e$var$getCiphers() {
    return Object.keys($6cI1N);
}
$0b1cd32526c8486e$export$bdd223f16383713e = $0b1cd32526c8486e$export$26e5786e8ac8e530 = $cxwy3.createCipher;
$0b1cd32526c8486e$export$2f64596b8cbf08b4 = $0b1cd32526c8486e$export$20533d26f07f1ee0 = $cxwy3.createCipheriv;
$0b1cd32526c8486e$export$12ada9414fbc594c = $0b1cd32526c8486e$export$2ce6d8d0e8b04e1a = $kicDr.createDecipher;
$0b1cd32526c8486e$export$36b6d6ef312eab39 = $0b1cd32526c8486e$export$f5e7e39d57cd9700 = $kicDr.createDecipheriv;
$0b1cd32526c8486e$export$dedd8dc3dc62b370 = $0b1cd32526c8486e$export$58a258485f1e49f6 = $0b1cd32526c8486e$var$getCiphers;

});
parcelRegister("cxwy3", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", function () { return $9211d07c2106ad4f$export$2f64596b8cbf08b4; }, function (v) { return $9211d07c2106ad4f$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "createCipher", function () { return $9211d07c2106ad4f$export$bdd223f16383713e; }, function (v) { return $9211d07c2106ad4f$export$bdd223f16383713e = v; });
var $9211d07c2106ad4f$export$2f64596b8cbf08b4;
var $9211d07c2106ad4f$export$bdd223f16383713e;

var $E9Jyp = parcelRequire("E9Jyp");

var $hnaP4 = parcelRequire("hnaP4");

var $eN0t8 = parcelRequire("eN0t8");
var $9211d07c2106ad4f$require$Buffer = $eN0t8.Buffer;

var $1kbe1 = parcelRequire("1kbe1");

var $61MIM = parcelRequire("61MIM");

var $eacX5 = parcelRequire("eacX5");

var $bFXtK = parcelRequire("bFXtK");

var $kvFQ5 = parcelRequire("kvFQ5");
function $9211d07c2106ad4f$var$Cipher(mode, key, iv) {
    $61MIM.call(this);
    this._cache = new $9211d07c2106ad4f$var$Splitter();
    this._cipher = new $eacX5.AES(key);
    this._prev = $9211d07c2106ad4f$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$kvFQ5($9211d07c2106ad4f$var$Cipher, $61MIM);
$9211d07c2106ad4f$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $9211d07c2106ad4f$require$Buffer.concat(out);
};
var $9211d07c2106ad4f$var$PADDING = $9211d07c2106ad4f$require$Buffer.alloc(16, 0x10);
$9211d07c2106ad4f$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($9211d07c2106ad4f$var$PADDING)) {
        this._cipher.scrub();
        throw new Error("data not multiple of block length");
    }
};
$9211d07c2106ad4f$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $9211d07c2106ad4f$var$Splitter() {
    this.cache = $9211d07c2106ad4f$require$Buffer.allocUnsafe(0);
}
$9211d07c2106ad4f$var$Splitter.prototype.add = function(data) {
    this.cache = $9211d07c2106ad4f$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$9211d07c2106ad4f$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$9211d07c2106ad4f$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $9211d07c2106ad4f$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $9211d07c2106ad4f$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $9211d07c2106ad4f$var$createCipheriv(suite, password, iv) {
    var config = $E9Jyp[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    if (typeof password === "string") password = $9211d07c2106ad4f$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError("invalid key length " + password.length);
    if (typeof iv === "string") iv = $9211d07c2106ad4f$require$Buffer.from(iv);
    if (config.mode !== "GCM" && iv.length !== config.iv) throw new TypeError("invalid iv length " + iv.length);
    if (config.type === "stream") return new $1kbe1(config.module, password, iv);
    else if (config.type === "auth") return new $hnaP4(config.module, password, iv);
    return new $9211d07c2106ad4f$var$Cipher(config.module, password, iv);
}
function $9211d07c2106ad4f$var$createCipher(suite, password) {
    var config = $E9Jyp[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    var keys = $bFXtK(password, false, config.key, config.iv);
    return $9211d07c2106ad4f$var$createCipheriv(suite, keys.key, keys.iv);
}
$9211d07c2106ad4f$export$2f64596b8cbf08b4 = $9211d07c2106ad4f$var$createCipheriv;
$9211d07c2106ad4f$export$bdd223f16383713e = $9211d07c2106ad4f$var$createCipher;

});
parcelRegister("E9Jyp", function(module, exports) {








var $078b4975cae973dd$var$modeModules = {
    ECB: (parcelRequire("1DWOT")),
    CBC: (parcelRequire("kwP8a")),
    CFB: (parcelRequire("3rKMV")),
    CFB8: (parcelRequire("kjrOo")),
    CFB1: (parcelRequire("e65kP")),
    OFB: (parcelRequire("4DRRs")),
    CTR: (parcelRequire("8mVCQ")),
    GCM: (parcelRequire("8mVCQ"))
};

var $6cI1N = parcelRequire("6cI1N");
for(var $078b4975cae973dd$var$key in $6cI1N)$6cI1N[$078b4975cae973dd$var$key].module = $078b4975cae973dd$var$modeModules[$6cI1N[$078b4975cae973dd$var$key].mode];
module.exports = $6cI1N;

});
parcelRegister("1DWOT", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $13270f5c36ac4dfa$export$5b0f6292f11d1d18; }, function (v) { return $13270f5c36ac4dfa$export$5b0f6292f11d1d18 = v; });
$parcel$export(module.exports, "decrypt", function () { return $13270f5c36ac4dfa$export$e85a0c9a1067c5d3; }, function (v) { return $13270f5c36ac4dfa$export$e85a0c9a1067c5d3 = v; });
var $13270f5c36ac4dfa$export$5b0f6292f11d1d18;
var $13270f5c36ac4dfa$export$e85a0c9a1067c5d3;
$13270f5c36ac4dfa$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$13270f5c36ac4dfa$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRegister("kwP8a", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $ef1e7553a5ab36ae$export$5b0f6292f11d1d18; }, function (v) { return $ef1e7553a5ab36ae$export$5b0f6292f11d1d18 = v; });
$parcel$export(module.exports, "decrypt", function () { return $ef1e7553a5ab36ae$export$e85a0c9a1067c5d3; }, function (v) { return $ef1e7553a5ab36ae$export$e85a0c9a1067c5d3 = v; });
var $ef1e7553a5ab36ae$export$5b0f6292f11d1d18;
var $ef1e7553a5ab36ae$export$e85a0c9a1067c5d3;

var $8tLxg = parcelRequire("8tLxg");
$ef1e7553a5ab36ae$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $8tLxg(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$ef1e7553a5ab36ae$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $8tLxg(out, pad);
};

});
parcelRegister("8tLxg", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $62c5e7b7f185e8a4$require$Buffer = $gzLuY.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $62c5e7b7f185e8a4$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRegister("3rKMV", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $28282fde8d0414c5$export$5b0f6292f11d1d18; }, function (v) { return $28282fde8d0414c5$export$5b0f6292f11d1d18 = v; });
var $28282fde8d0414c5$export$5b0f6292f11d1d18;

var $eN0t8 = parcelRequire("eN0t8");
var $28282fde8d0414c5$require$Buffer = $eN0t8.Buffer;

var $8tLxg = parcelRequire("8tLxg");
function $28282fde8d0414c5$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $8tLxg(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $28282fde8d0414c5$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$28282fde8d0414c5$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $28282fde8d0414c5$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $28282fde8d0414c5$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $28282fde8d0414c5$require$Buffer.concat([
                out,
                $28282fde8d0414c5$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $28282fde8d0414c5$require$Buffer.concat([
                out,
                $28282fde8d0414c5$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRegister("kjrOo", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $ec9b27dbf2455e83$export$5b0f6292f11d1d18; }, function (v) { return $ec9b27dbf2455e83$export$5b0f6292f11d1d18 = v; });
var $ec9b27dbf2455e83$export$5b0f6292f11d1d18;

var $eN0t8 = parcelRequire("eN0t8");
var $ec9b27dbf2455e83$require$Buffer = $eN0t8.Buffer;
function $ec9b27dbf2455e83$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $ec9b27dbf2455e83$require$Buffer.concat([
        self._prev.slice(1),
        $ec9b27dbf2455e83$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$ec9b27dbf2455e83$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $ec9b27dbf2455e83$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $ec9b27dbf2455e83$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("e65kP", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $a435c3a0404b3632$export$5b0f6292f11d1d18; }, function (v) { return $a435c3a0404b3632$export$5b0f6292f11d1d18 = v; });
var $a435c3a0404b3632$export$5b0f6292f11d1d18;

var $eN0t8 = parcelRequire("eN0t8");
var $a435c3a0404b3632$require$Buffer = $eN0t8.Buffer;
function $a435c3a0404b3632$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $a435c3a0404b3632$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $a435c3a0404b3632$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $a435c3a0404b3632$require$Buffer.allocUnsafe(buffer.length);
    buffer = $a435c3a0404b3632$require$Buffer.concat([
        buffer,
        $a435c3a0404b3632$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$a435c3a0404b3632$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $a435c3a0404b3632$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $a435c3a0404b3632$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("4DRRs", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $361495a46d8b3be3$export$5b0f6292f11d1d18; }, function (v) { return $361495a46d8b3be3$export$5b0f6292f11d1d18 = v; });
var $361495a46d8b3be3$export$5b0f6292f11d1d18;

var $gzLuY = parcelRequire("gzLuY");
var $361495a46d8b3be3$require$Buffer = $gzLuY.Buffer;

var $8tLxg = parcelRequire("8tLxg");
function $361495a46d8b3be3$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$361495a46d8b3be3$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $361495a46d8b3be3$require$Buffer.concat([
        self._cache,
        $361495a46d8b3be3$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $8tLxg(chunk, pad);
};

});

parcelRegister("8mVCQ", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $617d140dabb62cb7$export$5b0f6292f11d1d18; }, function (v) { return $617d140dabb62cb7$export$5b0f6292f11d1d18 = v; });
var $617d140dabb62cb7$export$5b0f6292f11d1d18;

var $8tLxg = parcelRequire("8tLxg");

var $eN0t8 = parcelRequire("eN0t8");
var $617d140dabb62cb7$require$Buffer = $eN0t8.Buffer;

var $2dknS = parcelRequire("2dknS");
function $617d140dabb62cb7$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $2dknS(self._prev);
    return out;
}
var $617d140dabb62cb7$var$blockSize = 16;
$617d140dabb62cb7$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $617d140dabb62cb7$var$blockSize);
    var start = self._cache.length;
    self._cache = $617d140dabb62cb7$require$Buffer.concat([
        self._cache,
        $617d140dabb62cb7$require$Buffer.allocUnsafe(chunkNum * $617d140dabb62cb7$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $617d140dabb62cb7$var$getBlock(self);
        var offset = start + i * $617d140dabb62cb7$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $8tLxg(chunk, pad);
};

});
parcelRegister("2dknS", function(module, exports) {
function $19cc9b8550c96272$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $19cc9b8550c96272$var$incr32;

});


parcelRegister("6cI1N", function(module, exports) {
module.exports = JSON.parse('{"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}');

});


parcelRegister("hnaP4", function(module, exports) {

var $eacX5 = parcelRequire("eacX5");

var $eN0t8 = parcelRequire("eN0t8");
var $ca5cfaca7b74a382$require$Buffer = $eN0t8.Buffer;

var $61MIM = parcelRequire("61MIM");

var $kvFQ5 = parcelRequire("kvFQ5");

var $7U3aN = parcelRequire("7U3aN");

var $8tLxg = parcelRequire("8tLxg");

var $2dknS = parcelRequire("2dknS");
function $ca5cfaca7b74a382$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $ca5cfaca7b74a382$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $ca5cfaca7b74a382$require$Buffer.concat([
            iv,
            $ca5cfaca7b74a382$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $ca5cfaca7b74a382$require$Buffer.concat([
            iv,
            $ca5cfaca7b74a382$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $7U3aN(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($ca5cfaca7b74a382$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($ca5cfaca7b74a382$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $ca5cfaca7b74a382$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $ca5cfaca7b74a382$require$Buffer.from(self._finID);
    $2dknS(out);
    return out;
}
function $ca5cfaca7b74a382$var$StreamCipher(mode, key, iv, decrypt) {
    $61MIM.call(this);
    var h = $ca5cfaca7b74a382$require$Buffer.alloc(4, 0);
    this._cipher = new $eacX5.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $7U3aN(ck);
    iv = $ca5cfaca7b74a382$var$calcIv(this, iv, ck);
    this._prev = $ca5cfaca7b74a382$require$Buffer.from(iv);
    this._cache = $ca5cfaca7b74a382$require$Buffer.allocUnsafe(0);
    this._secCache = $ca5cfaca7b74a382$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$kvFQ5($ca5cfaca7b74a382$var$StreamCipher, $61MIM);
$ca5cfaca7b74a382$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $ca5cfaca7b74a382$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$ca5cfaca7b74a382$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error("Unsupported state or unable to authenticate data");
    var tag = $8tLxg(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $ca5cfaca7b74a382$var$xorTest(tag, this._authTag)) throw new Error("Unsupported state or unable to authenticate data");
    this._authTag = tag;
    this._cipher.scrub();
};
$ca5cfaca7b74a382$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$ca5cfaca7b74a382$require$Buffer.isBuffer(this._authTag)) throw new Error("Attempting to get auth tag in unsupported state");
    return this._authTag;
};
$ca5cfaca7b74a382$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error("Attempting to set auth tag in unsupported state");
    this._authTag = tag;
};
$ca5cfaca7b74a382$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error("Attempting to set AAD in unsupported state");
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $ca5cfaca7b74a382$var$StreamCipher;

});
parcelRegister("eacX5", function(module, exports) {

$parcel$export(module.exports, "AES", function () { return $a4fc0bd8ebf9a67c$export$b80fbe1c3a2b92b5; }, function (v) { return $a4fc0bd8ebf9a67c$export$b80fbe1c3a2b92b5 = v; });
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $a4fc0bd8ebf9a67c$export$b80fbe1c3a2b92b5;

var $eN0t8 = parcelRequire("eN0t8");
var $a4fc0bd8ebf9a67c$require$Buffer = $eN0t8.Buffer;
function $a4fc0bd8ebf9a67c$var$asUInt32Array(buf) {
    if (!$a4fc0bd8ebf9a67c$require$Buffer.isBuffer(buf)) buf = $a4fc0bd8ebf9a67c$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $a4fc0bd8ebf9a67c$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $a4fc0bd8ebf9a67c$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $a4fc0bd8ebf9a67c$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $a4fc0bd8ebf9a67c$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $a4fc0bd8ebf9a67c$var$AES(key) {
    this._key = $a4fc0bd8ebf9a67c$var$asUInt32Array(key);
    this._reset();
}
$a4fc0bd8ebf9a67c$var$AES.blockSize = 16;
$a4fc0bd8ebf9a67c$var$AES.keySize = 32;
$a4fc0bd8ebf9a67c$var$AES.prototype.blockSize = $a4fc0bd8ebf9a67c$var$AES.blockSize;
$a4fc0bd8ebf9a67c$var$AES.prototype.keySize = $a4fc0bd8ebf9a67c$var$AES.keySize;
$a4fc0bd8ebf9a67c$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $a4fc0bd8ebf9a67c$var$G.SBOX[t >>> 24] << 24 | $a4fc0bd8ebf9a67c$var$G.SBOX[t >>> 16 & 0xff] << 16 | $a4fc0bd8ebf9a67c$var$G.SBOX[t >>> 8 & 0xff] << 8 | $a4fc0bd8ebf9a67c$var$G.SBOX[t & 0xff];
            t ^= $a4fc0bd8ebf9a67c$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $a4fc0bd8ebf9a67c$var$G.SBOX[t >>> 24] << 24 | $a4fc0bd8ebf9a67c$var$G.SBOX[t >>> 16 & 0xff] << 16 | $a4fc0bd8ebf9a67c$var$G.SBOX[t >>> 8 & 0xff] << 8 | $a4fc0bd8ebf9a67c$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $a4fc0bd8ebf9a67c$var$G.INV_SUB_MIX[0][$a4fc0bd8ebf9a67c$var$G.SBOX[tt >>> 24]] ^ $a4fc0bd8ebf9a67c$var$G.INV_SUB_MIX[1][$a4fc0bd8ebf9a67c$var$G.SBOX[tt >>> 16 & 0xff]] ^ $a4fc0bd8ebf9a67c$var$G.INV_SUB_MIX[2][$a4fc0bd8ebf9a67c$var$G.SBOX[tt >>> 8 & 0xff]] ^ $a4fc0bd8ebf9a67c$var$G.INV_SUB_MIX[3][$a4fc0bd8ebf9a67c$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$a4fc0bd8ebf9a67c$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $a4fc0bd8ebf9a67c$var$asUInt32Array(M);
    return $a4fc0bd8ebf9a67c$var$cryptBlock(M, this._keySchedule, $a4fc0bd8ebf9a67c$var$G.SUB_MIX, $a4fc0bd8ebf9a67c$var$G.SBOX, this._nRounds);
};
$a4fc0bd8ebf9a67c$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $a4fc0bd8ebf9a67c$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$a4fc0bd8ebf9a67c$var$AES.prototype.decryptBlock = function(M) {
    M = $a4fc0bd8ebf9a67c$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $a4fc0bd8ebf9a67c$var$cryptBlock(M, this._invKeySchedule, $a4fc0bd8ebf9a67c$var$G.INV_SUB_MIX, $a4fc0bd8ebf9a67c$var$G.INV_SBOX, this._nRounds);
    var buf = $a4fc0bd8ebf9a67c$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$a4fc0bd8ebf9a67c$var$AES.prototype.scrub = function() {
    $a4fc0bd8ebf9a67c$var$scrubVec(this._keySchedule);
    $a4fc0bd8ebf9a67c$var$scrubVec(this._invKeySchedule);
    $a4fc0bd8ebf9a67c$var$scrubVec(this._key);
};
$a4fc0bd8ebf9a67c$export$b80fbe1c3a2b92b5 = $a4fc0bd8ebf9a67c$var$AES;

});

parcelRegister("7U3aN", function(module, exports) {

var $eN0t8 = parcelRequire("eN0t8");
var $5c10397faf1b1732$require$Buffer = $eN0t8.Buffer;
var $5c10397faf1b1732$var$ZEROES = $5c10397faf1b1732$require$Buffer.alloc(16, 0);
function $5c10397faf1b1732$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $5c10397faf1b1732$var$fromArray(out) {
    var buf = $5c10397faf1b1732$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $5c10397faf1b1732$var$GHASH(key) {
    this.h = key;
    this.state = $5c10397faf1b1732$require$Buffer.alloc(16, 0);
    this.cache = $5c10397faf1b1732$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$5c10397faf1b1732$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$5c10397faf1b1732$var$GHASH.prototype._multiply = function() {
    var Vi = $5c10397faf1b1732$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $5c10397faf1b1732$var$fromArray(Zi);
};
$5c10397faf1b1732$var$GHASH.prototype.update = function(buf) {
    this.cache = $5c10397faf1b1732$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$5c10397faf1b1732$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($5c10397faf1b1732$require$Buffer.concat([
        this.cache,
        $5c10397faf1b1732$var$ZEROES
    ], 16));
    this.ghash($5c10397faf1b1732$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $5c10397faf1b1732$var$GHASH;

});


parcelRegister("1kbe1", function(module, exports) {

var $eacX5 = parcelRequire("eacX5");

var $eN0t8 = parcelRequire("eN0t8");
var $0f705dcd053f0d05$require$Buffer = $eN0t8.Buffer;

var $61MIM = parcelRequire("61MIM");

var $kvFQ5 = parcelRequire("kvFQ5");
function $0f705dcd053f0d05$var$StreamCipher(mode, key, iv, decrypt) {
    $61MIM.call(this);
    this._cipher = new $eacX5.AES(key);
    this._prev = $0f705dcd053f0d05$require$Buffer.from(iv);
    this._cache = $0f705dcd053f0d05$require$Buffer.allocUnsafe(0);
    this._secCache = $0f705dcd053f0d05$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$kvFQ5($0f705dcd053f0d05$var$StreamCipher, $61MIM);
$0f705dcd053f0d05$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$0f705dcd053f0d05$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $0f705dcd053f0d05$var$StreamCipher;

});

parcelRegister("bFXtK", function(module, exports) {

var $eN0t8 = parcelRequire("eN0t8");
var $8801a94c82eecd54$require$Buffer = $eN0t8.Buffer;

var $dGbYv = parcelRequire("dGbYv");
/* eslint-disable camelcase */ function $8801a94c82eecd54$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$8801a94c82eecd54$require$Buffer.isBuffer(password)) password = $8801a94c82eecd54$require$Buffer.from(password, "binary");
    if (salt) {
        if (!$8801a94c82eecd54$require$Buffer.isBuffer(salt)) salt = $8801a94c82eecd54$require$Buffer.from(salt, "binary");
        if (salt.length !== 8) throw new RangeError("salt should be Buffer with 8 byte length");
    }
    var keyLen = keyBits / 8;
    var key = $8801a94c82eecd54$require$Buffer.alloc(keyLen);
    var iv = $8801a94c82eecd54$require$Buffer.alloc(ivLen || 0);
    var tmp = $8801a94c82eecd54$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $dGbYv();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $8801a94c82eecd54$var$EVP_BytesToKey;

});


parcelRegister("kicDr", function(module, exports) {

$parcel$export(module.exports, "createDecipher", function () { return $ec5f4a2c957eed98$export$12ada9414fbc594c; }, function (v) { return $ec5f4a2c957eed98$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $ec5f4a2c957eed98$export$36b6d6ef312eab39; }, function (v) { return $ec5f4a2c957eed98$export$36b6d6ef312eab39 = v; });
var $ec5f4a2c957eed98$export$12ada9414fbc594c;
var $ec5f4a2c957eed98$export$36b6d6ef312eab39;

var $hnaP4 = parcelRequire("hnaP4");

var $eN0t8 = parcelRequire("eN0t8");
var $ec5f4a2c957eed98$require$Buffer = $eN0t8.Buffer;

var $E9Jyp = parcelRequire("E9Jyp");

var $1kbe1 = parcelRequire("1kbe1");

var $61MIM = parcelRequire("61MIM");

var $eacX5 = parcelRequire("eacX5");

var $bFXtK = parcelRequire("bFXtK");

var $kvFQ5 = parcelRequire("kvFQ5");
function $ec5f4a2c957eed98$var$Decipher(mode, key, iv) {
    $61MIM.call(this);
    this._cache = new $ec5f4a2c957eed98$var$Splitter();
    this._last = void 0;
    this._cipher = new $eacX5.AES(key);
    this._prev = $ec5f4a2c957eed98$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$kvFQ5($ec5f4a2c957eed98$var$Decipher, $61MIM);
$ec5f4a2c957eed98$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $ec5f4a2c957eed98$require$Buffer.concat(out);
};
$ec5f4a2c957eed98$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $ec5f4a2c957eed98$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error("data not multiple of block length");
};
$ec5f4a2c957eed98$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $ec5f4a2c957eed98$var$Splitter() {
    this.cache = $ec5f4a2c957eed98$require$Buffer.allocUnsafe(0);
}
$ec5f4a2c957eed98$var$Splitter.prototype.add = function(data) {
    this.cache = $ec5f4a2c957eed98$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$ec5f4a2c957eed98$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$ec5f4a2c957eed98$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $ec5f4a2c957eed98$var$unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error("unable to decrypt data");
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error("unable to decrypt data");
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $ec5f4a2c957eed98$var$createDecipheriv(suite, password, iv) {
    var config = $E9Jyp[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    if (typeof iv === "string") iv = $ec5f4a2c957eed98$require$Buffer.from(iv);
    if (config.mode !== "GCM" && iv.length !== config.iv) throw new TypeError("invalid iv length " + iv.length);
    if (typeof password === "string") password = $ec5f4a2c957eed98$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError("invalid key length " + password.length);
    if (config.type === "stream") return new $1kbe1(config.module, password, iv, true);
    else if (config.type === "auth") return new $hnaP4(config.module, password, iv, true);
    return new $ec5f4a2c957eed98$var$Decipher(config.module, password, iv);
}
function $ec5f4a2c957eed98$var$createDecipher(suite, password) {
    var config = $E9Jyp[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    var keys = $bFXtK(password, false, config.key, config.iv);
    return $ec5f4a2c957eed98$var$createDecipheriv(suite, keys.key, keys.iv);
}
$ec5f4a2c957eed98$export$12ada9414fbc594c = $ec5f4a2c957eed98$var$createDecipher;
$ec5f4a2c957eed98$export$36b6d6ef312eab39 = $ec5f4a2c957eed98$var$createDecipheriv;

});


parcelRegister("ikXWd", function(module, exports) {

$parcel$export(module.exports, "des-ecb", function () { return $d59896ab6aaf4a76$export$116f8a5cee447347; }, function (v) { return $d59896ab6aaf4a76$export$116f8a5cee447347 = v; });
$parcel$export(module.exports, "des-cbc", function () { return $d59896ab6aaf4a76$export$7483c4066bfb7ae9; }, function (v) { return $d59896ab6aaf4a76$export$7483c4066bfb7ae9 = v; });
$parcel$export(module.exports, "des", function () { return $d59896ab6aaf4a76$export$e7a565d2e588bb06; }, function (v) { return $d59896ab6aaf4a76$export$e7a565d2e588bb06 = v; });
$parcel$export(module.exports, "des-ede3-cbc", function () { return $d59896ab6aaf4a76$export$aaa2f54a426f3eb8; }, function (v) { return $d59896ab6aaf4a76$export$aaa2f54a426f3eb8 = v; });
$parcel$export(module.exports, "des3", function () { return $d59896ab6aaf4a76$export$eba20568dde4ada; }, function (v) { return $d59896ab6aaf4a76$export$eba20568dde4ada = v; });
$parcel$export(module.exports, "des-ede3", function () { return $d59896ab6aaf4a76$export$d3b5e5996938f5ae; }, function (v) { return $d59896ab6aaf4a76$export$d3b5e5996938f5ae = v; });
$parcel$export(module.exports, "des-ede-cbc", function () { return $d59896ab6aaf4a76$export$57c08356130bc99b; }, function (v) { return $d59896ab6aaf4a76$export$57c08356130bc99b = v; });
$parcel$export(module.exports, "des-ede", function () { return $d59896ab6aaf4a76$export$c7169791d5c1e65d; }, function (v) { return $d59896ab6aaf4a76$export$c7169791d5c1e65d = v; });
var $d59896ab6aaf4a76$export$116f8a5cee447347;
var $d59896ab6aaf4a76$export$7483c4066bfb7ae9;
var $d59896ab6aaf4a76$export$e7a565d2e588bb06;
var $d59896ab6aaf4a76$export$aaa2f54a426f3eb8;
var $d59896ab6aaf4a76$export$eba20568dde4ada;
var $d59896ab6aaf4a76$export$d3b5e5996938f5ae;
var $d59896ab6aaf4a76$export$57c08356130bc99b;
var $d59896ab6aaf4a76$export$c7169791d5c1e65d;
$d59896ab6aaf4a76$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$d59896ab6aaf4a76$export$7483c4066bfb7ae9 = $d59896ab6aaf4a76$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$d59896ab6aaf4a76$export$aaa2f54a426f3eb8 = $d59896ab6aaf4a76$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$d59896ab6aaf4a76$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$d59896ab6aaf4a76$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$d59896ab6aaf4a76$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};

});


parcelRegister("8cFrB", function(module, exports) {

$parcel$export(module.exports, "DiffieHellmanGroup", function () { return $5f8f97ac25e7a545$export$971862a2fcb1bb40; }, function (v) { return $5f8f97ac25e7a545$export$971862a2fcb1bb40 = v; });
$parcel$export(module.exports, "createDiffieHellmanGroup", function () { return $5f8f97ac25e7a545$export$c6ff6a88acbeaf40; }, function (v) { return $5f8f97ac25e7a545$export$c6ff6a88acbeaf40 = v; });
$parcel$export(module.exports, "getDiffieHellman", function () { return $5f8f97ac25e7a545$export$fdc27893e98845cc; }, function (v) { return $5f8f97ac25e7a545$export$fdc27893e98845cc = v; });
$parcel$export(module.exports, "createDiffieHellman", function () { return $5f8f97ac25e7a545$export$6671fb9a1323bed; }, function (v) { return $5f8f97ac25e7a545$export$6671fb9a1323bed = v; });
$parcel$export(module.exports, "DiffieHellman", function () { return $5f8f97ac25e7a545$export$d74daf141a551db; }, function (v) { return $5f8f97ac25e7a545$export$d74daf141a551db = v; });
var $5f8f97ac25e7a545$export$971862a2fcb1bb40;
var $5f8f97ac25e7a545$export$c6ff6a88acbeaf40;
var $5f8f97ac25e7a545$export$fdc27893e98845cc;
var $5f8f97ac25e7a545$export$6671fb9a1323bed;
var $5f8f97ac25e7a545$export$d74daf141a551db;

var $gzLuY = parcelRequire("gzLuY");
var $5f8f97ac25e7a545$require$Buffer = $gzLuY.Buffer;

var $bDFbr = parcelRequire("bDFbr");

var $5LOu8 = parcelRequire("5LOu8");

var $21XZH = parcelRequire("21XZH");
function $5f8f97ac25e7a545$var$getDiffieHellman(mod) {
    var prime = new $5f8f97ac25e7a545$require$Buffer($5LOu8[mod].prime, "hex");
    var gen = new $5f8f97ac25e7a545$require$Buffer($5LOu8[mod].gen, "hex");
    return new $21XZH(prime, gen);
}
var $5f8f97ac25e7a545$var$ENCODINGS = {
    "binary": true,
    "hex": true,
    "base64": true
};
function $5f8f97ac25e7a545$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($5f8f97ac25e7a545$require$Buffer.isBuffer(enc) || $5f8f97ac25e7a545$var$ENCODINGS[enc] === undefined) return $5f8f97ac25e7a545$var$createDiffieHellman(prime, "binary", enc, generator);
    enc = enc || "binary";
    genc = genc || "binary";
    generator = generator || new $5f8f97ac25e7a545$require$Buffer([
        2
    ]);
    if (!$5f8f97ac25e7a545$require$Buffer.isBuffer(generator)) generator = new $5f8f97ac25e7a545$require$Buffer(generator, genc);
    if (typeof prime === "number") return new $21XZH($bDFbr(prime, generator), generator, true);
    if (!$5f8f97ac25e7a545$require$Buffer.isBuffer(prime)) prime = new $5f8f97ac25e7a545$require$Buffer(prime, enc);
    return new $21XZH(prime, generator, true);
}
$5f8f97ac25e7a545$export$971862a2fcb1bb40 = $5f8f97ac25e7a545$export$c6ff6a88acbeaf40 = $5f8f97ac25e7a545$export$fdc27893e98845cc = $5f8f97ac25e7a545$var$getDiffieHellman;
$5f8f97ac25e7a545$export$6671fb9a1323bed = $5f8f97ac25e7a545$export$d74daf141a551db = $5f8f97ac25e7a545$var$createDiffieHellman;

});
parcelRegister("bDFbr", function(module, exports) {

var $dKHN6 = parcelRequire("dKHN6");
module.exports = $87934870d13ece7f$var$findPrime;
$87934870d13ece7f$var$findPrime.simpleSieve = $87934870d13ece7f$var$simpleSieve;
$87934870d13ece7f$var$findPrime.fermatTest = $87934870d13ece7f$var$fermatTest;

var $JVHwt = parcelRequire("JVHwt");
var $87934870d13ece7f$var$TWENTYFOUR = new $JVHwt(24);

var $8byPm = parcelRequire("8byPm");
var $87934870d13ece7f$var$millerRabin = new $8byPm();
var $87934870d13ece7f$var$ONE = new $JVHwt(1);
var $87934870d13ece7f$var$TWO = new $JVHwt(2);
var $87934870d13ece7f$var$FIVE = new $JVHwt(5);
var $87934870d13ece7f$var$SIXTEEN = new $JVHwt(16);
var $87934870d13ece7f$var$EIGHT = new $JVHwt(8);
var $87934870d13ece7f$var$TEN = new $JVHwt(10);
var $87934870d13ece7f$var$THREE = new $JVHwt(3);
var $87934870d13ece7f$var$SEVEN = new $JVHwt(7);
var $87934870d13ece7f$var$ELEVEN = new $JVHwt(11);
var $87934870d13ece7f$var$FOUR = new $JVHwt(4);
var $87934870d13ece7f$var$TWELVE = new $JVHwt(12);
var $87934870d13ece7f$var$primes = null;
function $87934870d13ece7f$var$_getPrimes() {
    if ($87934870d13ece7f$var$primes !== null) return $87934870d13ece7f$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $87934870d13ece7f$var$primes = res;
    return res;
}
function $87934870d13ece7f$var$simpleSieve(p) {
    var primes = $87934870d13ece7f$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $87934870d13ece7f$var$fermatTest(p) {
    var red = $JVHwt.mont(p);
    return $87934870d13ece7f$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $87934870d13ece7f$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $JVHwt([
            0x8c,
            0x7b
        ]);
        else return new $JVHwt([
            0x8c,
            0x27
        ]);
    }
    gen = new $JVHwt(gen);
    var num, n2;
    while(true){
        num = new $JVHwt($dKHN6(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($87934870d13ece7f$var$ONE);
        if (!num.testn(1)) num.iadd($87934870d13ece7f$var$TWO);
        if (!gen.cmp($87934870d13ece7f$var$TWO)) while(num.mod($87934870d13ece7f$var$TWENTYFOUR).cmp($87934870d13ece7f$var$ELEVEN))num.iadd($87934870d13ece7f$var$FOUR);
        else if (!gen.cmp($87934870d13ece7f$var$FIVE)) while(num.mod($87934870d13ece7f$var$TEN).cmp($87934870d13ece7f$var$THREE))num.iadd($87934870d13ece7f$var$FOUR);
        n2 = num.shrn(1);
        if ($87934870d13ece7f$var$simpleSieve(n2) && $87934870d13ece7f$var$simpleSieve(num) && $87934870d13ece7f$var$fermatTest(n2) && $87934870d13ece7f$var$fermatTest(num) && $87934870d13ece7f$var$millerRabin.test(n2) && $87934870d13ece7f$var$millerRabin.test(num)) return num;
    }
}

});
parcelRegister("JVHwt", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("aqbQf")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("8byPm", function(module, exports) {

var $eP07g = parcelRequire("eP07g");

var $8v4zB = parcelRequire("8v4zB");
function $0189b730b56b1c28$var$MillerRabin(rand) {
    this.rand = rand || new $8v4zB.Rand();
}
module.exports = $0189b730b56b1c28$var$MillerRabin;
$0189b730b56b1c28$var$MillerRabin.create = function create(rand) {
    return new $0189b730b56b1c28$var$MillerRabin(rand);
};
$0189b730b56b1c28$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $eP07g(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$0189b730b56b1c28$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$0189b730b56b1c28$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $eP07g.mont(n);
    var rone = new $eP07g(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $eP07g(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$0189b730b56b1c28$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $eP07g.mont(n);
    var rone = new $eP07g(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $eP07g(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};

});
parcelRegister("eP07g", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("aqbQf")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("8v4zB", function(module, exports) {
var $6304c41c38b6f174$var$r;
module.exports = function rand(len) {
    if (!$6304c41c38b6f174$var$r) $6304c41c38b6f174$var$r = new $6304c41c38b6f174$var$Rand(null);
    return $6304c41c38b6f174$var$r.generate(len);
};
function $6304c41c38b6f174$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $6304c41c38b6f174$var$Rand;
$6304c41c38b6f174$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$6304c41c38b6f174$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === "object") {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $6304c41c38b6f174$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $6304c41c38b6f174$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === "object") // Old junk
    $6304c41c38b6f174$var$Rand.prototype._rand = function() {
        throw new Error("Not implemented yet");
    };
} else // Node.js or Web worker with no crypto support
try {
    var $6304c41c38b6f174$var$crypto = (parcelRequire("aqbQf"));
    if (typeof $6304c41c38b6f174$var$crypto.randomBytes !== "function") throw new Error("Not supported");
    $6304c41c38b6f174$var$Rand.prototype._rand = function _rand(n) {
        return $6304c41c38b6f174$var$crypto.randomBytes(n);
    };
} catch (e) {}

});



parcelRegister("5LOu8", function(module, exports) {
module.exports = JSON.parse('{"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}');

});

parcelRegister("21XZH", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $17aa365fa91a3dcc$require$Buffer = $gzLuY.Buffer;

var $JVHwt = parcelRequire("JVHwt");

var $8byPm = parcelRequire("8byPm");
var $17aa365fa91a3dcc$var$millerRabin = new $8byPm();
var $17aa365fa91a3dcc$var$TWENTYFOUR = new $JVHwt(24);
var $17aa365fa91a3dcc$var$ELEVEN = new $JVHwt(11);
var $17aa365fa91a3dcc$var$TEN = new $JVHwt(10);
var $17aa365fa91a3dcc$var$THREE = new $JVHwt(3);
var $17aa365fa91a3dcc$var$SEVEN = new $JVHwt(7);

var $bDFbr = parcelRequire("bDFbr");

var $dKHN6 = parcelRequire("dKHN6");
module.exports = $17aa365fa91a3dcc$var$DH;
function $17aa365fa91a3dcc$var$setPublicKey(pub, enc) {
    enc = enc || "utf8";
    if (!$17aa365fa91a3dcc$require$Buffer.isBuffer(pub)) pub = new $17aa365fa91a3dcc$require$Buffer(pub, enc);
    this._pub = new $JVHwt(pub);
    return this;
}
function $17aa365fa91a3dcc$var$setPrivateKey(priv, enc) {
    enc = enc || "utf8";
    if (!$17aa365fa91a3dcc$require$Buffer.isBuffer(priv)) priv = new $17aa365fa91a3dcc$require$Buffer(priv, enc);
    this._priv = new $JVHwt(priv);
    return this;
}
var $17aa365fa91a3dcc$var$primeCache = {};
function $17aa365fa91a3dcc$var$checkPrime(prime, generator) {
    var gen = generator.toString("hex");
    var hex = [
        gen,
        prime.toString(16)
    ].join("_");
    if (hex in $17aa365fa91a3dcc$var$primeCache) return $17aa365fa91a3dcc$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$bDFbr.simpleSieve || !$bDFbr.fermatTest(prime) || !$17aa365fa91a3dcc$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === "02" || gen === "05") // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $17aa365fa91a3dcc$var$primeCache[hex] = error;
        return error;
    }
    if (!$17aa365fa91a3dcc$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case "02":
            if (prime.mod($17aa365fa91a3dcc$var$TWENTYFOUR).cmp($17aa365fa91a3dcc$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case "05":
            rem = prime.mod($17aa365fa91a3dcc$var$TEN);
            if (rem.cmp($17aa365fa91a3dcc$var$THREE) && rem.cmp($17aa365fa91a3dcc$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $17aa365fa91a3dcc$var$primeCache[hex] = error;
    return error;
}
function $17aa365fa91a3dcc$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $JVHwt(prime);
    this._prime = $JVHwt.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $17aa365fa91a3dcc$var$setPublicKey;
        this.setPrivateKey = $17aa365fa91a3dcc$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($17aa365fa91a3dcc$var$DH.prototype, "verifyError", {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== "number") this._primeCode = $17aa365fa91a3dcc$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$17aa365fa91a3dcc$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $JVHwt($dKHN6(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$17aa365fa91a3dcc$var$DH.prototype.computeSecret = function(other) {
    other = new $JVHwt(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $17aa365fa91a3dcc$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $17aa365fa91a3dcc$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $17aa365fa91a3dcc$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$17aa365fa91a3dcc$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $17aa365fa91a3dcc$var$formatReturnValue(this._pub, enc);
};
$17aa365fa91a3dcc$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $17aa365fa91a3dcc$var$formatReturnValue(this._priv, enc);
};
$17aa365fa91a3dcc$var$DH.prototype.getPrime = function(enc) {
    return $17aa365fa91a3dcc$var$formatReturnValue(this.__prime, enc);
};
$17aa365fa91a3dcc$var$DH.prototype.getGenerator = function(enc) {
    return $17aa365fa91a3dcc$var$formatReturnValue(this._gen, enc);
};
$17aa365fa91a3dcc$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || "utf8";
    if (!$17aa365fa91a3dcc$require$Buffer.isBuffer(gen)) gen = new $17aa365fa91a3dcc$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $JVHwt(gen);
    return this;
};
function $17aa365fa91a3dcc$var$formatReturnValue(bn, enc) {
    var buf = new $17aa365fa91a3dcc$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}

});


parcelRegister("knJxN", function(module, exports) {
"use strict";

var $eN0t8 = parcelRequire("eN0t8");
var $ed6948bfbd0d8ac6$require$Buffer = $eN0t8.Buffer;

var $j8bQA = parcelRequire("j8bQA");

var $CyGSj = parcelRequire("CyGSj");

var $kvFQ5 = parcelRequire("kvFQ5");

var $111e7 = parcelRequire("111e7");

var $bLWjI = parcelRequire("bLWjI");

var $ggpby = parcelRequire("ggpby");
Object.keys($ggpby).forEach(function(key) {
    $ggpby[key].id = $ed6948bfbd0d8ac6$require$Buffer.from($ggpby[key].id, "hex");
    $ggpby[key.toLowerCase()] = $ggpby[key];
});
function $ed6948bfbd0d8ac6$var$Sign(algorithm) {
    $CyGSj.Writable.call(this);
    var data = $ggpby[algorithm];
    if (!data) throw new Error("Unknown message digest");
    this._hashType = data.hash;
    this._hash = $j8bQA(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$kvFQ5($ed6948bfbd0d8ac6$var$Sign, $CyGSj.Writable);
$ed6948bfbd0d8ac6$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$ed6948bfbd0d8ac6$var$Sign.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === "string" ? $ed6948bfbd0d8ac6$require$Buffer.from(data, enc) : data);
    return this;
};
$ed6948bfbd0d8ac6$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $111e7(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $ed6948bfbd0d8ac6$var$Verify(algorithm) {
    $CyGSj.Writable.call(this);
    var data = $ggpby[algorithm];
    if (!data) throw new Error("Unknown message digest");
    this._hash = $j8bQA(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$kvFQ5($ed6948bfbd0d8ac6$var$Verify, $CyGSj.Writable);
$ed6948bfbd0d8ac6$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$ed6948bfbd0d8ac6$var$Verify.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === "string" ? $ed6948bfbd0d8ac6$require$Buffer.from(data, enc) : data);
    return this;
};
$ed6948bfbd0d8ac6$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    var sigBuffer = typeof sig === "string" ? $ed6948bfbd0d8ac6$require$Buffer.from(sig, enc) : sig;
    this.end();
    var hash = this._hash.digest();
    return $bLWjI(sigBuffer, hash, key, this._signType, this._tag);
};
function $ed6948bfbd0d8ac6$var$createSign(algorithm) {
    return new $ed6948bfbd0d8ac6$var$Sign(algorithm);
}
function $ed6948bfbd0d8ac6$var$createVerify(algorithm) {
    return new $ed6948bfbd0d8ac6$var$Verify(algorithm);
}
module.exports = {
    Sign: $ed6948bfbd0d8ac6$var$createSign,
    Verify: $ed6948bfbd0d8ac6$var$createVerify,
    createSign: $ed6948bfbd0d8ac6$var$createSign,
    createVerify: $ed6948bfbd0d8ac6$var$createVerify
};

});
parcelRegister("111e7", function(module, exports) {
"use strict";

var $eN0t8 = parcelRequire("eN0t8");
var $0bd6d60ea2b8775c$require$Buffer = $eN0t8.Buffer;

var $l2ANw = parcelRequire("l2ANw");

var $lp4ea = parcelRequire("lp4ea");

var $492wS = parcelRequire("492wS");
var $0bd6d60ea2b8775c$require$EC = $492wS.ec;

var $jlWHo = parcelRequire("jlWHo");

var $5nDla = parcelRequire("5nDla");

var $d3wjz = parcelRequire("d3wjz");
var $0bd6d60ea2b8775c$var$RSA_PKCS1_PADDING = 1;
function $0bd6d60ea2b8775c$var$sign(hash, key, hashType, signType, tag) {
    var priv = $5nDla(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== "ecdsa" && signType !== "ecdsa/rsa") throw new Error("wrong private key type");
        return $0bd6d60ea2b8775c$var$ecSign(hash, priv);
    } else if (priv.type === "dsa") {
        if (signType !== "dsa") throw new Error("wrong private key type");
        return $0bd6d60ea2b8775c$var$dsaSign(hash, priv, hashType);
    }
    if (signType !== "rsa" && signType !== "ecdsa/rsa") throw new Error("wrong private key type");
    if (key.padding !== undefined && key.padding !== $0bd6d60ea2b8775c$var$RSA_PKCS1_PADDING) throw new Error("illegal or unsupported padding mode");
    hash = $0bd6d60ea2b8775c$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $lp4ea(pad, priv);
    return out;
}
function $0bd6d60ea2b8775c$var$ecSign(hash, priv) {
    var curveId = $d3wjz[priv.curve.join(".")];
    if (!curveId) throw new Error("unknown curve " + priv.curve.join("."));
    var curve = new $0bd6d60ea2b8775c$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return $0bd6d60ea2b8775c$require$Buffer.from(out.toDER());
}
function $0bd6d60ea2b8775c$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $jlWHo(0);
    var k;
    var H = $0bd6d60ea2b8775c$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $0bd6d60ea2b8775c$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $0bd6d60ea2b8775c$var$makeKey(q, kv, algo);
        r = $0bd6d60ea2b8775c$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $jlWHo(0);
        }
    }
    return $0bd6d60ea2b8775c$var$toDER(r, s);
}
function $0bd6d60ea2b8775c$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return $0bd6d60ea2b8775c$require$Buffer.from(res);
}
function $0bd6d60ea2b8775c$var$getKey(x, q, hash, algo) {
    x = $0bd6d60ea2b8775c$require$Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = $0bd6d60ea2b8775c$require$Buffer.alloc(q.byteLength() - x.length);
        x = $0bd6d60ea2b8775c$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $0bd6d60ea2b8775c$var$bits2octets(hash, q);
    var v = $0bd6d60ea2b8775c$require$Buffer.alloc(hlen);
    v.fill(1);
    var k = $0bd6d60ea2b8775c$require$Buffer.alloc(hlen);
    k = $l2ANw(algo, k).update(v).update($0bd6d60ea2b8775c$require$Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = $l2ANw(algo, k).update(v).digest();
    k = $l2ANw(algo, k).update(v).update($0bd6d60ea2b8775c$require$Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = $l2ANw(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $0bd6d60ea2b8775c$var$bits2int(obits, q) {
    var bits = new $jlWHo(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $0bd6d60ea2b8775c$var$bits2octets(bits, q) {
    bits = $0bd6d60ea2b8775c$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = $0bd6d60ea2b8775c$require$Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = $0bd6d60ea2b8775c$require$Buffer.alloc(q.byteLength() - out.length);
        out = $0bd6d60ea2b8775c$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $0bd6d60ea2b8775c$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = $0bd6d60ea2b8775c$require$Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $l2ANw(algo, kv.k).update(kv.v).digest();
            t = $0bd6d60ea2b8775c$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $0bd6d60ea2b8775c$var$bits2int(t, q);
        kv.k = $l2ANw(algo, kv.k).update(kv.v).update($0bd6d60ea2b8775c$require$Buffer.from([
            0
        ])).digest();
        kv.v = $l2ANw(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $0bd6d60ea2b8775c$var$makeR(g, k, p, q) {
    return g.toRed($jlWHo.mont(p)).redPow(k).fromRed().mod(q);
}
module.exports = $0bd6d60ea2b8775c$var$sign;
module.exports.getKey = $0bd6d60ea2b8775c$var$getKey;
module.exports.makeKey = $0bd6d60ea2b8775c$var$makeKey;

});
parcelRegister("lp4ea", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $f94f3648911eb247$require$Buffer = $gzLuY.Buffer;

var $jlWHo = parcelRequire("jlWHo");

var $dKHN6 = parcelRequire("dKHN6");
function $f94f3648911eb247$var$blind(priv) {
    var r = $f94f3648911eb247$var$getr(priv);
    var blinder = r.toRed($jlWHo.mont(priv.modulus)).redPow(new $jlWHo(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $f94f3648911eb247$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new $jlWHo($dKHN6(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function $f94f3648911eb247$var$crt(msg, priv) {
    var blinds = $f94f3648911eb247$var$blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new $jlWHo(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($jlWHo.mont(priv.prime1));
    var c2 = blinded.toRed($jlWHo.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($f94f3648911eb247$require$Buffer, "be", len);
}
$f94f3648911eb247$var$crt.getr = $f94f3648911eb247$var$getr;
module.exports = $f94f3648911eb247$var$crt;

});

parcelRegister("492wS", function(module, exports) {
"use strict";
var $3049f6ef72b5b326$var$elliptic = module.exports;

$3049f6ef72b5b326$var$elliptic.version = (parcelRequire("3tGej")).version;

$3049f6ef72b5b326$var$elliptic.utils = (parcelRequire("boA1w"));

$3049f6ef72b5b326$var$elliptic.rand = (parcelRequire("8v4zB"));

$3049f6ef72b5b326$var$elliptic.curve = (parcelRequire("hbDhv"));

$3049f6ef72b5b326$var$elliptic.curves = (parcelRequire("kKmfE"));

// Protocols
$3049f6ef72b5b326$var$elliptic.ec = (parcelRequire("jA2EE"));

$3049f6ef72b5b326$var$elliptic.eddsa = (parcelRequire("51QPl"));

});
parcelRegister("3tGej", function(module, exports) {
module.exports = JSON.parse('{"name":"elliptic","version":"6.5.4","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"}}');

});

parcelRegister("boA1w", function(module, exports) {
"use strict";
var $84bde1233ebed9e4$var$utils = module.exports;

var $h0anJ = parcelRequire("h0anJ");

var $3210N = parcelRequire("3210N");

var $4YHS3 = parcelRequire("4YHS3");
$84bde1233ebed9e4$var$utils.assert = $3210N;
$84bde1233ebed9e4$var$utils.toArray = $4YHS3.toArray;
$84bde1233ebed9e4$var$utils.zero2 = $4YHS3.zero2;
$84bde1233ebed9e4$var$utils.toHex = $4YHS3.toHex;
$84bde1233ebed9e4$var$utils.encode = $4YHS3.encode;
// Represent num in a w-NAF form
function $84bde1233ebed9e4$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    naf.fill(0);
    var ws = 1 << w + 1;
    var k = num.clone();
    for(var i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$84bde1233ebed9e4$var$utils.getNAF = $84bde1233ebed9e4$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $84bde1233ebed9e4$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$84bde1233ebed9e4$var$utils.getJSF = $84bde1233ebed9e4$var$getJSF;
function $84bde1233ebed9e4$var$cachedProperty(obj, name, computer) {
    var key = "_" + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$84bde1233ebed9e4$var$utils.cachedProperty = $84bde1233ebed9e4$var$cachedProperty;
function $84bde1233ebed9e4$var$parseBytes(bytes) {
    return typeof bytes === "string" ? $84bde1233ebed9e4$var$utils.toArray(bytes, "hex") : bytes;
}
$84bde1233ebed9e4$var$utils.parseBytes = $84bde1233ebed9e4$var$parseBytes;
function $84bde1233ebed9e4$var$intFromLE(bytes) {
    return new $h0anJ(bytes, "hex", "le");
}
$84bde1233ebed9e4$var$utils.intFromLE = $84bde1233ebed9e4$var$intFromLE;

});
parcelRegister("h0anJ", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("aqbQf")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("4YHS3", function(module, exports) {
"use strict";
var $39fecbdfe326fb6f$var$utils = module.exports;
function $39fecbdfe326fb6f$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== "string") {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === "hex") {
        msg = msg.replace(/[^a-z0-9]+/ig, "");
        if (msg.length % 2 !== 0) msg = "0" + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$39fecbdfe326fb6f$var$utils.toArray = $39fecbdfe326fb6f$var$toArray;
function $39fecbdfe326fb6f$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$39fecbdfe326fb6f$var$utils.zero2 = $39fecbdfe326fb6f$var$zero2;
function $39fecbdfe326fb6f$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $39fecbdfe326fb6f$var$zero2(msg[i].toString(16));
    return res;
}
$39fecbdfe326fb6f$var$utils.toHex = $39fecbdfe326fb6f$var$toHex;
$39fecbdfe326fb6f$var$utils.encode = function encode(arr, enc) {
    if (enc === "hex") return $39fecbdfe326fb6f$var$toHex(arr);
    else return arr;
};

});


parcelRegister("hbDhv", function(module, exports) {
"use strict";
var $c831ef38bf9363e2$var$curve = module.exports;

$c831ef38bf9363e2$var$curve.base = (parcelRequire("3Ild8"));

$c831ef38bf9363e2$var$curve.short = (parcelRequire("l2gH1"));

$c831ef38bf9363e2$var$curve.mont = (parcelRequire("hWmH5"));

$c831ef38bf9363e2$var$curve.edwards = (parcelRequire("8SKTg"));

});
parcelRegister("3Ild8", function(module, exports) {
"use strict";

var $h0anJ = parcelRequire("h0anJ");

var $boA1w = parcelRequire("boA1w");
var $2b45ef357c32d9df$var$getNAF = $boA1w.getNAF;
var $2b45ef357c32d9df$var$getJSF = $boA1w.getJSF;
var $2b45ef357c32d9df$var$assert = $boA1w.assert;
function $2b45ef357c32d9df$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $h0anJ(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $h0anJ.red(conf.prime) : $h0anJ.mont(this.p);
    // Useful for many curves
    this.zero = new $h0anJ(0).toRed(this.red);
    this.one = new $h0anJ(1).toRed(this.red);
    this.two = new $h0anJ(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $h0anJ(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $2b45ef357c32d9df$var$BaseCurve;
$2b45ef357c32d9df$var$BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
$2b45ef357c32d9df$var$BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
$2b45ef357c32d9df$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $2b45ef357c32d9df$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $2b45ef357c32d9df$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$2b45ef357c32d9df$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $2b45ef357c32d9df$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $2b45ef357c32d9df$var$assert(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
$2b45ef357c32d9df$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $2b45ef357c32d9df$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $2b45ef357c32d9df$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $2b45ef357c32d9df$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $2b45ef357c32d9df$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$2b45ef357c32d9df$var$BaseCurve.BasePoint = $2b45ef357c32d9df$var$BasePoint;
$2b45ef357c32d9df$var$BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
$2b45ef357c32d9df$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$2b45ef357c32d9df$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $boA1w.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $2b45ef357c32d9df$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $2b45ef357c32d9df$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
$2b45ef357c32d9df$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$2b45ef357c32d9df$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
$2b45ef357c32d9df$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $boA1w.encode(this._encode(compact), enc);
};
$2b45ef357c32d9df$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$2b45ef357c32d9df$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$2b45ef357c32d9df$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$2b45ef357c32d9df$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$2b45ef357c32d9df$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$2b45ef357c32d9df$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("l2gH1", function(module, exports) {
"use strict";

var $boA1w = parcelRequire("boA1w");

var $h0anJ = parcelRequire("h0anJ");

var $kvFQ5 = parcelRequire("kvFQ5");

var $3Ild8 = parcelRequire("3Ild8");
var $f506bbbb5a8e71f9$var$assert = $boA1w.assert;
function $f506bbbb5a8e71f9$var$ShortCurve(conf) {
    $3Ild8.call(this, "short", conf);
    this.a = new $h0anJ(conf.a, 16).toRed(this.red);
    this.b = new $h0anJ(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$kvFQ5($f506bbbb5a8e71f9$var$ShortCurve, $3Ild8);
module.exports = $f506bbbb5a8e71f9$var$ShortCurve;
$f506bbbb5a8e71f9$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $h0anJ(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $h0anJ(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $f506bbbb5a8e71f9$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $h0anJ(vec.a, 16),
            b: new $h0anJ(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$f506bbbb5a8e71f9$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $h0anJ.mont(num);
    var tinv = new $h0anJ(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $h0anJ(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$f506bbbb5a8e71f9$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $h0anJ(1);
    var y1 = new $h0anJ(0);
    var x2 = new $h0anJ(0);
    var y2 = new $h0anJ(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$f506bbbb5a8e71f9$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$f506bbbb5a8e71f9$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $h0anJ(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$f506bbbb5a8e71f9$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$f506bbbb5a8e71f9$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $f506bbbb5a8e71f9$var$Point(curve, x, y, isRed) {
    $3Ild8.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $h0anJ(x, 16);
        this.y = new $h0anJ(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$kvFQ5($f506bbbb5a8e71f9$var$Point, $3Ild8.BasePoint);
$f506bbbb5a8e71f9$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $f506bbbb5a8e71f9$var$Point(this, x, y, isRed);
};
$f506bbbb5a8e71f9$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $f506bbbb5a8e71f9$var$Point.fromJSON(this, obj, red);
};
$f506bbbb5a8e71f9$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$f506bbbb5a8e71f9$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$f506bbbb5a8e71f9$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$f506bbbb5a8e71f9$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
$f506bbbb5a8e71f9$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$f506bbbb5a8e71f9$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$f506bbbb5a8e71f9$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$f506bbbb5a8e71f9$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$f506bbbb5a8e71f9$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$f506bbbb5a8e71f9$var$Point.prototype.mul = function mul(k) {
    k = new $h0anJ(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$f506bbbb5a8e71f9$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$f506bbbb5a8e71f9$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$f506bbbb5a8e71f9$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$f506bbbb5a8e71f9$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$f506bbbb5a8e71f9$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $f506bbbb5a8e71f9$var$JPoint(curve, x, y, z) {
    $3Ild8.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $h0anJ(0);
    } else {
        this.x = new $h0anJ(x, 16);
        this.y = new $h0anJ(y, 16);
        this.z = new $h0anJ(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$kvFQ5($f506bbbb5a8e71f9$var$JPoint, $3Ild8.BasePoint);
$f506bbbb5a8e71f9$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $f506bbbb5a8e71f9$var$JPoint(this, x, y, z);
};
$f506bbbb5a8e71f9$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$f506bbbb5a8e71f9$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$f506bbbb5a8e71f9$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$f506bbbb5a8e71f9$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$f506bbbb5a8e71f9$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$f506bbbb5a8e71f9$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$f506bbbb5a8e71f9$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$f506bbbb5a8e71f9$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$f506bbbb5a8e71f9$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$f506bbbb5a8e71f9$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$f506bbbb5a8e71f9$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $h0anJ(k, kbase);
    return this.curve._wnafMul(this, k);
};
$f506bbbb5a8e71f9$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$f506bbbb5a8e71f9$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$f506bbbb5a8e71f9$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
$f506bbbb5a8e71f9$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRegister("hWmH5", function(module, exports) {
"use strict";

var $h0anJ = parcelRequire("h0anJ");

var $kvFQ5 = parcelRequire("kvFQ5");

var $3Ild8 = parcelRequire("3Ild8");

var $boA1w = parcelRequire("boA1w");
function $d0f97501e3e6b182$var$MontCurve(conf) {
    $3Ild8.call(this, "mont", conf);
    this.a = new $h0anJ(conf.a, 16).toRed(this.red);
    this.b = new $h0anJ(conf.b, 16).toRed(this.red);
    this.i4 = new $h0anJ(4).toRed(this.red).redInvm();
    this.two = new $h0anJ(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$kvFQ5($d0f97501e3e6b182$var$MontCurve, $3Ild8);
module.exports = $d0f97501e3e6b182$var$MontCurve;
$d0f97501e3e6b182$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $d0f97501e3e6b182$var$Point(curve, x, z) {
    $3Ild8.BasePoint.call(this, curve, "projective");
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $h0anJ(x, 16);
        this.z = new $h0anJ(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$kvFQ5($d0f97501e3e6b182$var$Point, $3Ild8.BasePoint);
$d0f97501e3e6b182$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($boA1w.toArray(bytes, enc), 1);
};
$d0f97501e3e6b182$var$MontCurve.prototype.point = function point(x, z) {
    return new $d0f97501e3e6b182$var$Point(this, x, z);
};
$d0f97501e3e6b182$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $d0f97501e3e6b182$var$Point.fromJSON(this, obj);
};
$d0f97501e3e6b182$var$Point.prototype.precompute = function precompute() {
// No-op
};
$d0f97501e3e6b182$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray("be", this.curve.p.byteLength());
};
$d0f97501e3e6b182$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $d0f97501e3e6b182$var$Point(curve, obj[0], obj[1] || curve.one);
};
$d0f97501e3e6b182$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$d0f97501e3e6b182$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$d0f97501e3e6b182$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$d0f97501e3e6b182$var$Point.prototype.add = function add() {
    throw new Error("Not supported on Montgomery curve");
};
$d0f97501e3e6b182$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$d0f97501e3e6b182$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$d0f97501e3e6b182$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$d0f97501e3e6b182$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$d0f97501e3e6b182$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$d0f97501e3e6b182$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$d0f97501e3e6b182$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("8SKTg", function(module, exports) {
"use strict";

var $boA1w = parcelRequire("boA1w");

var $h0anJ = parcelRequire("h0anJ");

var $kvFQ5 = parcelRequire("kvFQ5");

var $3Ild8 = parcelRequire("3Ild8");
var $6777bd53b8a6130a$var$assert = $boA1w.assert;
function $6777bd53b8a6130a$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $3Ild8.call(this, "edwards", conf);
    this.a = new $h0anJ(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $h0anJ(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $h0anJ(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $6777bd53b8a6130a$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$kvFQ5($6777bd53b8a6130a$var$EdwardsCurve, $3Ild8);
module.exports = $6777bd53b8a6130a$var$EdwardsCurve;
$6777bd53b8a6130a$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$6777bd53b8a6130a$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$6777bd53b8a6130a$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$6777bd53b8a6130a$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $h0anJ(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$6777bd53b8a6130a$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $h0anJ(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error("invalid point");
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error("invalid point");
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$6777bd53b8a6130a$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $6777bd53b8a6130a$var$Point(curve, x, y, z, t) {
    $3Ild8.BasePoint.call(this, curve, "projective");
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $h0anJ(x, 16);
        this.y = new $h0anJ(y, 16);
        this.z = z ? new $h0anJ(z, 16) : this.curve.one;
        this.t = t && new $h0anJ(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$kvFQ5($6777bd53b8a6130a$var$Point, $3Ild8.BasePoint);
$6777bd53b8a6130a$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $6777bd53b8a6130a$var$Point.fromJSON(this, obj);
};
$6777bd53b8a6130a$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $6777bd53b8a6130a$var$Point(this, x, y, z, t);
};
$6777bd53b8a6130a$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $6777bd53b8a6130a$var$Point(curve, obj[0], obj[1], obj[2]);
};
$6777bd53b8a6130a$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$6777bd53b8a6130a$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$6777bd53b8a6130a$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$6777bd53b8a6130a$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$6777bd53b8a6130a$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$6777bd53b8a6130a$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$6777bd53b8a6130a$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$6777bd53b8a6130a$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$6777bd53b8a6130a$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$6777bd53b8a6130a$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$6777bd53b8a6130a$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$6777bd53b8a6130a$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$6777bd53b8a6130a$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$6777bd53b8a6130a$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$6777bd53b8a6130a$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$6777bd53b8a6130a$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$6777bd53b8a6130a$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$6777bd53b8a6130a$var$Point.prototype.toP = $6777bd53b8a6130a$var$Point.prototype.normalize;
$6777bd53b8a6130a$var$Point.prototype.mixedAdd = $6777bd53b8a6130a$var$Point.prototype.add;

});


parcelRegister("kKmfE", function(module, exports) {
"use strict";
var $f1a95d3133313cc8$var$curves = module.exports;

var $dMFrt = parcelRequire("dMFrt");

var $hbDhv = parcelRequire("hbDhv");

var $boA1w = parcelRequire("boA1w");
var $f1a95d3133313cc8$var$assert = $boA1w.assert;
function $f1a95d3133313cc8$var$PresetCurve(options) {
    if (options.type === "short") this.curve = new $hbDhv.short(options);
    else if (options.type === "edwards") this.curve = new $hbDhv.edwards(options);
    else this.curve = new $hbDhv.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $f1a95d3133313cc8$var$assert(this.g.validate(), "Invalid curve");
    $f1a95d3133313cc8$var$assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
}
$f1a95d3133313cc8$var$curves.PresetCurve = $f1a95d3133313cc8$var$PresetCurve;
function $f1a95d3133313cc8$var$defineCurve(name, options) {
    Object.defineProperty($f1a95d3133313cc8$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $f1a95d3133313cc8$var$PresetCurve(options);
            Object.defineProperty($f1a95d3133313cc8$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$f1a95d3133313cc8$var$defineCurve("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: $dMFrt.sha256,
    gRed: false,
    g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
});
$f1a95d3133313cc8$var$defineCurve("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: $dMFrt.sha256,
    gRed: false,
    g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
});
$f1a95d3133313cc8$var$defineCurve("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: $dMFrt.sha256,
    gRed: false,
    g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
});
$f1a95d3133313cc8$var$defineCurve("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $dMFrt.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$f1a95d3133313cc8$var$defineCurve("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $dMFrt.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$f1a95d3133313cc8$var$defineCurve("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $dMFrt.sha256,
    gRed: false,
    g: [
        "9"
    ]
});
$f1a95d3133313cc8$var$defineCurve("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    // -121665 * (121666^(-1)) (mod P)
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $dMFrt.sha256,
    gRed: false,
    g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
    ]
});
var $f1a95d3133313cc8$var$pre;

try {
    $f1a95d3133313cc8$var$pre = (parcelRequire("cBTAl"));
} catch (e) {
    $f1a95d3133313cc8$var$pre = undefined;
}
$f1a95d3133313cc8$var$defineCurve("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: $dMFrt.sha256,
    // Precomputed endomorphism
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
        {
            a: "3086d221a7d46bcde86c90e49284eb15",
            b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
            a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
            b: "3086d221a7d46bcde86c90e49284eb15"
        }
    ],
    gRed: false,
    g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        $f1a95d3133313cc8$var$pre
    ]
});

});
parcelRegister("dMFrt", function(module, exports) {
var $a08fe79466179a86$var$hash = module.exports;

$a08fe79466179a86$var$hash.utils = (parcelRequire("cYl7t"));

$a08fe79466179a86$var$hash.common = (parcelRequire("1pS1U"));

$a08fe79466179a86$var$hash.sha = (parcelRequire("imuzp"));

$a08fe79466179a86$var$hash.ripemd = (parcelRequire("jAZNy"));

$a08fe79466179a86$var$hash.hmac = (parcelRequire("hC4jp"));
// Proxy hash functions to the main object
$a08fe79466179a86$var$hash.sha1 = $a08fe79466179a86$var$hash.sha.sha1;
$a08fe79466179a86$var$hash.sha256 = $a08fe79466179a86$var$hash.sha.sha256;
$a08fe79466179a86$var$hash.sha224 = $a08fe79466179a86$var$hash.sha.sha224;
$a08fe79466179a86$var$hash.sha384 = $a08fe79466179a86$var$hash.sha.sha384;
$a08fe79466179a86$var$hash.sha512 = $a08fe79466179a86$var$hash.sha.sha512;
$a08fe79466179a86$var$hash.ripemd160 = $a08fe79466179a86$var$hash.ripemd.ripemd160;

});
parcelRegister("cYl7t", function(module, exports) {

$parcel$export(module.exports, "inherits", function () { return $971b7885424ac20e$export$69f1b2dcda23c5f8; }, function (v) { return $971b7885424ac20e$export$69f1b2dcda23c5f8 = v; });
$parcel$export(module.exports, "toArray", function () { return $971b7885424ac20e$export$45b10814cc054894; }, function (v) { return $971b7885424ac20e$export$45b10814cc054894 = v; });
$parcel$export(module.exports, "toHex", function () { return $971b7885424ac20e$export$7ea66e3774a60b67; }, function (v) { return $971b7885424ac20e$export$7ea66e3774a60b67 = v; });
$parcel$export(module.exports, "htonl", function () { return $971b7885424ac20e$export$34a52f00f601f6f1; }, function (v) { return $971b7885424ac20e$export$34a52f00f601f6f1 = v; });
$parcel$export(module.exports, "toHex32", function () { return $971b7885424ac20e$export$812b0cbd5e8a72ab; }, function (v) { return $971b7885424ac20e$export$812b0cbd5e8a72ab = v; });
$parcel$export(module.exports, "zero2", function () { return $971b7885424ac20e$export$f24f9e11d63bb314; }, function (v) { return $971b7885424ac20e$export$f24f9e11d63bb314 = v; });
$parcel$export(module.exports, "zero8", function () { return $971b7885424ac20e$export$b71357c7e07ca1f1; }, function (v) { return $971b7885424ac20e$export$b71357c7e07ca1f1 = v; });
$parcel$export(module.exports, "join32", function () { return $971b7885424ac20e$export$2e58a4b541fdcbe8; }, function (v) { return $971b7885424ac20e$export$2e58a4b541fdcbe8 = v; });
$parcel$export(module.exports, "split32", function () { return $971b7885424ac20e$export$183b950bde9faab8; }, function (v) { return $971b7885424ac20e$export$183b950bde9faab8 = v; });
$parcel$export(module.exports, "rotr32", function () { return $971b7885424ac20e$export$4785c77169fea59e; }, function (v) { return $971b7885424ac20e$export$4785c77169fea59e = v; });
$parcel$export(module.exports, "rotl32", function () { return $971b7885424ac20e$export$242a185dfcffac5b; }, function (v) { return $971b7885424ac20e$export$242a185dfcffac5b = v; });
$parcel$export(module.exports, "sum32", function () { return $971b7885424ac20e$export$58c04ae0ae31877d; }, function (v) { return $971b7885424ac20e$export$58c04ae0ae31877d = v; });
$parcel$export(module.exports, "sum32_3", function () { return $971b7885424ac20e$export$d058ca695f8c6f11; }, function (v) { return $971b7885424ac20e$export$d058ca695f8c6f11 = v; });
$parcel$export(module.exports, "sum32_4", function () { return $971b7885424ac20e$export$a1efd7fc3e986367; }, function (v) { return $971b7885424ac20e$export$a1efd7fc3e986367 = v; });
$parcel$export(module.exports, "sum32_5", function () { return $971b7885424ac20e$export$bbfea4a2b5abaab4; }, function (v) { return $971b7885424ac20e$export$bbfea4a2b5abaab4 = v; });
$parcel$export(module.exports, "sum64", function () { return $971b7885424ac20e$export$97ad4afc7de86152; }, function (v) { return $971b7885424ac20e$export$97ad4afc7de86152 = v; });
$parcel$export(module.exports, "sum64_hi", function () { return $971b7885424ac20e$export$ce4673d9a79f6a4b; }, function (v) { return $971b7885424ac20e$export$ce4673d9a79f6a4b = v; });
$parcel$export(module.exports, "sum64_lo", function () { return $971b7885424ac20e$export$786cc99fc6eedc0b; }, function (v) { return $971b7885424ac20e$export$786cc99fc6eedc0b = v; });
$parcel$export(module.exports, "sum64_4_hi", function () { return $971b7885424ac20e$export$45c59b9a1848dd0; }, function (v) { return $971b7885424ac20e$export$45c59b9a1848dd0 = v; });
$parcel$export(module.exports, "sum64_4_lo", function () { return $971b7885424ac20e$export$50d8f613e76d3034; }, function (v) { return $971b7885424ac20e$export$50d8f613e76d3034 = v; });
$parcel$export(module.exports, "sum64_5_hi", function () { return $971b7885424ac20e$export$b8e83683c60ee162; }, function (v) { return $971b7885424ac20e$export$b8e83683c60ee162 = v; });
$parcel$export(module.exports, "sum64_5_lo", function () { return $971b7885424ac20e$export$aeeb51790d1bcc4a; }, function (v) { return $971b7885424ac20e$export$aeeb51790d1bcc4a = v; });
$parcel$export(module.exports, "rotr64_hi", function () { return $971b7885424ac20e$export$bb7c616f719ad9c; }, function (v) { return $971b7885424ac20e$export$bb7c616f719ad9c = v; });
$parcel$export(module.exports, "rotr64_lo", function () { return $971b7885424ac20e$export$4d63290824f9d7df; }, function (v) { return $971b7885424ac20e$export$4d63290824f9d7df = v; });
$parcel$export(module.exports, "shr64_hi", function () { return $971b7885424ac20e$export$2f64ceb90ef28ea1; }, function (v) { return $971b7885424ac20e$export$2f64ceb90ef28ea1 = v; });
$parcel$export(module.exports, "shr64_lo", function () { return $971b7885424ac20e$export$8d2089d465f6d10d; }, function (v) { return $971b7885424ac20e$export$8d2089d465f6d10d = v; });
var $971b7885424ac20e$export$69f1b2dcda23c5f8;
var $971b7885424ac20e$export$45b10814cc054894;
var $971b7885424ac20e$export$7ea66e3774a60b67;
var $971b7885424ac20e$export$34a52f00f601f6f1;
var $971b7885424ac20e$export$812b0cbd5e8a72ab;
var $971b7885424ac20e$export$f24f9e11d63bb314;
var $971b7885424ac20e$export$b71357c7e07ca1f1;
var $971b7885424ac20e$export$2e58a4b541fdcbe8;
var $971b7885424ac20e$export$183b950bde9faab8;
var $971b7885424ac20e$export$4785c77169fea59e;
var $971b7885424ac20e$export$242a185dfcffac5b;
var $971b7885424ac20e$export$58c04ae0ae31877d;
var $971b7885424ac20e$export$d058ca695f8c6f11;
var $971b7885424ac20e$export$a1efd7fc3e986367;
var $971b7885424ac20e$export$bbfea4a2b5abaab4;
var $971b7885424ac20e$export$97ad4afc7de86152;
var $971b7885424ac20e$export$ce4673d9a79f6a4b;
var $971b7885424ac20e$export$786cc99fc6eedc0b;
var $971b7885424ac20e$export$45c59b9a1848dd0;
var $971b7885424ac20e$export$50d8f613e76d3034;
var $971b7885424ac20e$export$b8e83683c60ee162;
var $971b7885424ac20e$export$aeeb51790d1bcc4a;
var $971b7885424ac20e$export$bb7c616f719ad9c;
var $971b7885424ac20e$export$4d63290824f9d7df;
var $971b7885424ac20e$export$2f64ceb90ef28ea1;
var $971b7885424ac20e$export$8d2089d465f6d10d;
"use strict";

var $3210N = parcelRequire("3210N");

var $kvFQ5 = parcelRequire("kvFQ5");
$971b7885424ac20e$export$69f1b2dcda23c5f8 = $kvFQ5;
function $971b7885424ac20e$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $971b7885424ac20e$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === "string") {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($971b7885424ac20e$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$971b7885424ac20e$export$45b10814cc054894 = $971b7885424ac20e$var$toArray;
function $971b7885424ac20e$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $971b7885424ac20e$var$zero2(msg[i].toString(16));
    return res;
}
$971b7885424ac20e$export$7ea66e3774a60b67 = $971b7885424ac20e$var$toHex;
function $971b7885424ac20e$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$971b7885424ac20e$export$34a52f00f601f6f1 = $971b7885424ac20e$var$htonl;
function $971b7885424ac20e$var$toHex32(msg, endian) {
    var res = "";
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === "little") w = $971b7885424ac20e$var$htonl(w);
        res += $971b7885424ac20e$var$zero8(w.toString(16));
    }
    return res;
}
$971b7885424ac20e$export$812b0cbd5e8a72ab = $971b7885424ac20e$var$toHex32;
function $971b7885424ac20e$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$971b7885424ac20e$export$f24f9e11d63bb314 = $971b7885424ac20e$var$zero2;
function $971b7885424ac20e$var$zero8(word) {
    if (word.length === 7) return "0" + word;
    else if (word.length === 6) return "00" + word;
    else if (word.length === 5) return "000" + word;
    else if (word.length === 4) return "0000" + word;
    else if (word.length === 3) return "00000" + word;
    else if (word.length === 2) return "000000" + word;
    else if (word.length === 1) return "0000000" + word;
    else return word;
}
$971b7885424ac20e$export$b71357c7e07ca1f1 = $971b7885424ac20e$var$zero8;
function $971b7885424ac20e$var$join32(msg, start, end, endian) {
    var len = end - start;
    $3210N(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === "big") w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$971b7885424ac20e$export$2e58a4b541fdcbe8 = $971b7885424ac20e$var$join32;
function $971b7885424ac20e$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === "big") {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$971b7885424ac20e$export$183b950bde9faab8 = $971b7885424ac20e$var$split32;
function $971b7885424ac20e$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$971b7885424ac20e$export$4785c77169fea59e = $971b7885424ac20e$var$rotr32;
function $971b7885424ac20e$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$971b7885424ac20e$export$242a185dfcffac5b = $971b7885424ac20e$var$rotl32;
function $971b7885424ac20e$var$sum32(a, b) {
    return a + b >>> 0;
}
$971b7885424ac20e$export$58c04ae0ae31877d = $971b7885424ac20e$var$sum32;
function $971b7885424ac20e$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$971b7885424ac20e$export$d058ca695f8c6f11 = $971b7885424ac20e$var$sum32_3;
function $971b7885424ac20e$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$971b7885424ac20e$export$a1efd7fc3e986367 = $971b7885424ac20e$var$sum32_4;
function $971b7885424ac20e$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$971b7885424ac20e$export$bbfea4a2b5abaab4 = $971b7885424ac20e$var$sum32_5;
function $971b7885424ac20e$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$971b7885424ac20e$export$97ad4afc7de86152 = $971b7885424ac20e$var$sum64;
function $971b7885424ac20e$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$971b7885424ac20e$export$ce4673d9a79f6a4b = $971b7885424ac20e$var$sum64_hi;
function $971b7885424ac20e$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$971b7885424ac20e$export$786cc99fc6eedc0b = $971b7885424ac20e$var$sum64_lo;
function $971b7885424ac20e$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$971b7885424ac20e$export$45c59b9a1848dd0 = $971b7885424ac20e$var$sum64_4_hi;
function $971b7885424ac20e$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$971b7885424ac20e$export$50d8f613e76d3034 = $971b7885424ac20e$var$sum64_4_lo;
function $971b7885424ac20e$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$971b7885424ac20e$export$b8e83683c60ee162 = $971b7885424ac20e$var$sum64_5_hi;
function $971b7885424ac20e$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$971b7885424ac20e$export$aeeb51790d1bcc4a = $971b7885424ac20e$var$sum64_5_lo;
function $971b7885424ac20e$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$971b7885424ac20e$export$bb7c616f719ad9c = $971b7885424ac20e$var$rotr64_hi;
function $971b7885424ac20e$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$971b7885424ac20e$export$4d63290824f9d7df = $971b7885424ac20e$var$rotr64_lo;
function $971b7885424ac20e$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$971b7885424ac20e$export$2f64ceb90ef28ea1 = $971b7885424ac20e$var$shr64_hi;
function $971b7885424ac20e$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$971b7885424ac20e$export$8d2089d465f6d10d = $971b7885424ac20e$var$shr64_lo;

});

parcelRegister("1pS1U", function(module, exports) {

$parcel$export(module.exports, "BlockHash", function () { return $10820970b61d1a41$export$8687658379b577e6; }, function (v) { return $10820970b61d1a41$export$8687658379b577e6 = v; });
var $10820970b61d1a41$export$8687658379b577e6;
"use strict";

var $cYl7t = parcelRequire("cYl7t");

var $3210N = parcelRequire("3210N");
function $10820970b61d1a41$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = "big";
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$10820970b61d1a41$export$8687658379b577e6 = $10820970b61d1a41$var$BlockHash;
$10820970b61d1a41$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $cYl7t.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $cYl7t.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$10820970b61d1a41$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $3210N(this.pending === null);
    return this._digest(enc);
};
$10820970b61d1a41$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === "big") {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("imuzp", function(module, exports) {

$parcel$export(module.exports, "sha1", function () { return $d5e1fea904e0f988$export$5091bdda49ba90f5; }, function (v) { return $d5e1fea904e0f988$export$5091bdda49ba90f5 = v; });
$parcel$export(module.exports, "sha224", function () { return $d5e1fea904e0f988$export$97b70509d4e397ea; }, function (v) { return $d5e1fea904e0f988$export$97b70509d4e397ea = v; });
$parcel$export(module.exports, "sha256", function () { return $d5e1fea904e0f988$export$bced8d2aada2d1c9; }, function (v) { return $d5e1fea904e0f988$export$bced8d2aada2d1c9 = v; });
$parcel$export(module.exports, "sha384", function () { return $d5e1fea904e0f988$export$612d47d55dedde45; }, function (v) { return $d5e1fea904e0f988$export$612d47d55dedde45 = v; });
$parcel$export(module.exports, "sha512", function () { return $d5e1fea904e0f988$export$a888d2532e6dc7bb; }, function (v) { return $d5e1fea904e0f988$export$a888d2532e6dc7bb = v; });
var $d5e1fea904e0f988$export$5091bdda49ba90f5;
var $d5e1fea904e0f988$export$97b70509d4e397ea;
var $d5e1fea904e0f988$export$bced8d2aada2d1c9;
var $d5e1fea904e0f988$export$612d47d55dedde45;
var $d5e1fea904e0f988$export$a888d2532e6dc7bb;
"use strict";

$d5e1fea904e0f988$export$5091bdda49ba90f5 = (parcelRequire("2cerY"));

$d5e1fea904e0f988$export$97b70509d4e397ea = (parcelRequire("i5Q5x"));

$d5e1fea904e0f988$export$bced8d2aada2d1c9 = (parcelRequire("3HSKF"));

$d5e1fea904e0f988$export$612d47d55dedde45 = (parcelRequire("aWFyw"));

$d5e1fea904e0f988$export$a888d2532e6dc7bb = (parcelRequire("6bcDP"));

});
parcelRegister("2cerY", function(module, exports) {
"use strict";

var $cYl7t = parcelRequire("cYl7t");

var $1pS1U = parcelRequire("1pS1U");

var $bznKp = parcelRequire("bznKp");
var $1997e941b78c78de$var$rotl32 = $cYl7t.rotl32;
var $1997e941b78c78de$var$sum32 = $cYl7t.sum32;
var $1997e941b78c78de$var$sum32_5 = $cYl7t.sum32_5;
var $1997e941b78c78de$var$ft_1 = $bznKp.ft_1;
var $1997e941b78c78de$var$BlockHash = $1pS1U.BlockHash;
var $1997e941b78c78de$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $1997e941b78c78de$var$SHA1() {
    if (!(this instanceof $1997e941b78c78de$var$SHA1)) return new $1997e941b78c78de$var$SHA1();
    $1997e941b78c78de$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$cYl7t.inherits($1997e941b78c78de$var$SHA1, $1997e941b78c78de$var$BlockHash);
module.exports = $1997e941b78c78de$var$SHA1;
$1997e941b78c78de$var$SHA1.blockSize = 512;
$1997e941b78c78de$var$SHA1.outSize = 160;
$1997e941b78c78de$var$SHA1.hmacStrength = 80;
$1997e941b78c78de$var$SHA1.padLength = 64;
$1997e941b78c78de$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $1997e941b78c78de$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $1997e941b78c78de$var$sum32_5($1997e941b78c78de$var$rotl32(a, 5), $1997e941b78c78de$var$ft_1(s, b, c, d), e, W[i], $1997e941b78c78de$var$sha1_K[s]);
        e = d;
        d = c;
        c = $1997e941b78c78de$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $1997e941b78c78de$var$sum32(this.h[0], a);
    this.h[1] = $1997e941b78c78de$var$sum32(this.h[1], b);
    this.h[2] = $1997e941b78c78de$var$sum32(this.h[2], c);
    this.h[3] = $1997e941b78c78de$var$sum32(this.h[3], d);
    this.h[4] = $1997e941b78c78de$var$sum32(this.h[4], e);
};
$1997e941b78c78de$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === "hex") return $cYl7t.toHex32(this.h, "big");
    else return $cYl7t.split32(this.h, "big");
};

});
parcelRegister("bznKp", function(module, exports) {

$parcel$export(module.exports, "ft_1", function () { return $86c562611187daa4$export$5a92649d7ddb9f63; }, function (v) { return $86c562611187daa4$export$5a92649d7ddb9f63 = v; });
$parcel$export(module.exports, "ch32", function () { return $86c562611187daa4$export$c6d0d020c3a6269; }, function (v) { return $86c562611187daa4$export$c6d0d020c3a6269 = v; });
$parcel$export(module.exports, "maj32", function () { return $86c562611187daa4$export$eb90c27fca05f956; }, function (v) { return $86c562611187daa4$export$eb90c27fca05f956 = v; });
$parcel$export(module.exports, "s0_256", function () { return $86c562611187daa4$export$14a4a98e063b1999; }, function (v) { return $86c562611187daa4$export$14a4a98e063b1999 = v; });
$parcel$export(module.exports, "s1_256", function () { return $86c562611187daa4$export$d20cecfa1564c686; }, function (v) { return $86c562611187daa4$export$d20cecfa1564c686 = v; });
$parcel$export(module.exports, "g0_256", function () { return $86c562611187daa4$export$44fd472a12fc6db; }, function (v) { return $86c562611187daa4$export$44fd472a12fc6db = v; });
$parcel$export(module.exports, "g1_256", function () { return $86c562611187daa4$export$1ed238bb6ea1dd47; }, function (v) { return $86c562611187daa4$export$1ed238bb6ea1dd47 = v; });
var $86c562611187daa4$export$5a92649d7ddb9f63;
var $86c562611187daa4$export$c6d0d020c3a6269;
var $86c562611187daa4$export$eb90c27fca05f956;
var $86c562611187daa4$export$cc992891a14496a1;
var $86c562611187daa4$export$14a4a98e063b1999;
var $86c562611187daa4$export$d20cecfa1564c686;
var $86c562611187daa4$export$44fd472a12fc6db;
var $86c562611187daa4$export$1ed238bb6ea1dd47;
"use strict";

var $cYl7t = parcelRequire("cYl7t");
var $86c562611187daa4$var$rotr32 = $cYl7t.rotr32;
function $86c562611187daa4$var$ft_1(s, x, y, z) {
    if (s === 0) return $86c562611187daa4$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $86c562611187daa4$var$p32(x, y, z);
    if (s === 2) return $86c562611187daa4$var$maj32(x, y, z);
}
$86c562611187daa4$export$5a92649d7ddb9f63 = $86c562611187daa4$var$ft_1;
function $86c562611187daa4$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$86c562611187daa4$export$c6d0d020c3a6269 = $86c562611187daa4$var$ch32;
function $86c562611187daa4$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$86c562611187daa4$export$eb90c27fca05f956 = $86c562611187daa4$var$maj32;
function $86c562611187daa4$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$86c562611187daa4$export$cc992891a14496a1 = $86c562611187daa4$var$p32;
function $86c562611187daa4$var$s0_256(x) {
    return $86c562611187daa4$var$rotr32(x, 2) ^ $86c562611187daa4$var$rotr32(x, 13) ^ $86c562611187daa4$var$rotr32(x, 22);
}
$86c562611187daa4$export$14a4a98e063b1999 = $86c562611187daa4$var$s0_256;
function $86c562611187daa4$var$s1_256(x) {
    return $86c562611187daa4$var$rotr32(x, 6) ^ $86c562611187daa4$var$rotr32(x, 11) ^ $86c562611187daa4$var$rotr32(x, 25);
}
$86c562611187daa4$export$d20cecfa1564c686 = $86c562611187daa4$var$s1_256;
function $86c562611187daa4$var$g0_256(x) {
    return $86c562611187daa4$var$rotr32(x, 7) ^ $86c562611187daa4$var$rotr32(x, 18) ^ x >>> 3;
}
$86c562611187daa4$export$44fd472a12fc6db = $86c562611187daa4$var$g0_256;
function $86c562611187daa4$var$g1_256(x) {
    return $86c562611187daa4$var$rotr32(x, 17) ^ $86c562611187daa4$var$rotr32(x, 19) ^ x >>> 10;
}
$86c562611187daa4$export$1ed238bb6ea1dd47 = $86c562611187daa4$var$g1_256;

});


parcelRegister("i5Q5x", function(module, exports) {
"use strict";

var $cYl7t = parcelRequire("cYl7t");

var $3HSKF = parcelRequire("3HSKF");
function $d2c1194d6901331b$var$SHA224() {
    if (!(this instanceof $d2c1194d6901331b$var$SHA224)) return new $d2c1194d6901331b$var$SHA224();
    $3HSKF.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$cYl7t.inherits($d2c1194d6901331b$var$SHA224, $3HSKF);
module.exports = $d2c1194d6901331b$var$SHA224;
$d2c1194d6901331b$var$SHA224.blockSize = 512;
$d2c1194d6901331b$var$SHA224.outSize = 224;
$d2c1194d6901331b$var$SHA224.hmacStrength = 192;
$d2c1194d6901331b$var$SHA224.padLength = 64;
$d2c1194d6901331b$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === "hex") return $cYl7t.toHex32(this.h.slice(0, 7), "big");
    else return $cYl7t.split32(this.h.slice(0, 7), "big");
};

});
parcelRegister("3HSKF", function(module, exports) {
"use strict";

var $cYl7t = parcelRequire("cYl7t");

var $1pS1U = parcelRequire("1pS1U");

var $bznKp = parcelRequire("bznKp");

var $3210N = parcelRequire("3210N");
var $2b2fdbcd8fab6652$var$sum32 = $cYl7t.sum32;
var $2b2fdbcd8fab6652$var$sum32_4 = $cYl7t.sum32_4;
var $2b2fdbcd8fab6652$var$sum32_5 = $cYl7t.sum32_5;
var $2b2fdbcd8fab6652$var$ch32 = $bznKp.ch32;
var $2b2fdbcd8fab6652$var$maj32 = $bznKp.maj32;
var $2b2fdbcd8fab6652$var$s0_256 = $bznKp.s0_256;
var $2b2fdbcd8fab6652$var$s1_256 = $bznKp.s1_256;
var $2b2fdbcd8fab6652$var$g0_256 = $bznKp.g0_256;
var $2b2fdbcd8fab6652$var$g1_256 = $bznKp.g1_256;
var $2b2fdbcd8fab6652$var$BlockHash = $1pS1U.BlockHash;
var $2b2fdbcd8fab6652$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $2b2fdbcd8fab6652$var$SHA256() {
    if (!(this instanceof $2b2fdbcd8fab6652$var$SHA256)) return new $2b2fdbcd8fab6652$var$SHA256();
    $2b2fdbcd8fab6652$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $2b2fdbcd8fab6652$var$sha256_K;
    this.W = new Array(64);
}
$cYl7t.inherits($2b2fdbcd8fab6652$var$SHA256, $2b2fdbcd8fab6652$var$BlockHash);
module.exports = $2b2fdbcd8fab6652$var$SHA256;
$2b2fdbcd8fab6652$var$SHA256.blockSize = 512;
$2b2fdbcd8fab6652$var$SHA256.outSize = 256;
$2b2fdbcd8fab6652$var$SHA256.hmacStrength = 192;
$2b2fdbcd8fab6652$var$SHA256.padLength = 64;
$2b2fdbcd8fab6652$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $2b2fdbcd8fab6652$var$sum32_4($2b2fdbcd8fab6652$var$g1_256(W[i - 2]), W[i - 7], $2b2fdbcd8fab6652$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $3210N(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $2b2fdbcd8fab6652$var$sum32_5(h, $2b2fdbcd8fab6652$var$s1_256(e), $2b2fdbcd8fab6652$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $2b2fdbcd8fab6652$var$sum32($2b2fdbcd8fab6652$var$s0_256(a), $2b2fdbcd8fab6652$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $2b2fdbcd8fab6652$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $2b2fdbcd8fab6652$var$sum32(T1, T2);
    }
    this.h[0] = $2b2fdbcd8fab6652$var$sum32(this.h[0], a);
    this.h[1] = $2b2fdbcd8fab6652$var$sum32(this.h[1], b);
    this.h[2] = $2b2fdbcd8fab6652$var$sum32(this.h[2], c);
    this.h[3] = $2b2fdbcd8fab6652$var$sum32(this.h[3], d);
    this.h[4] = $2b2fdbcd8fab6652$var$sum32(this.h[4], e);
    this.h[5] = $2b2fdbcd8fab6652$var$sum32(this.h[5], f);
    this.h[6] = $2b2fdbcd8fab6652$var$sum32(this.h[6], g);
    this.h[7] = $2b2fdbcd8fab6652$var$sum32(this.h[7], h);
};
$2b2fdbcd8fab6652$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === "hex") return $cYl7t.toHex32(this.h, "big");
    else return $cYl7t.split32(this.h, "big");
};

});


parcelRegister("aWFyw", function(module, exports) {
"use strict";

var $cYl7t = parcelRequire("cYl7t");

var $6bcDP = parcelRequire("6bcDP");
function $7f7f8e474b2a977d$var$SHA384() {
    if (!(this instanceof $7f7f8e474b2a977d$var$SHA384)) return new $7f7f8e474b2a977d$var$SHA384();
    $6bcDP.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$cYl7t.inherits($7f7f8e474b2a977d$var$SHA384, $6bcDP);
module.exports = $7f7f8e474b2a977d$var$SHA384;
$7f7f8e474b2a977d$var$SHA384.blockSize = 1024;
$7f7f8e474b2a977d$var$SHA384.outSize = 384;
$7f7f8e474b2a977d$var$SHA384.hmacStrength = 192;
$7f7f8e474b2a977d$var$SHA384.padLength = 128;
$7f7f8e474b2a977d$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === "hex") return $cYl7t.toHex32(this.h.slice(0, 12), "big");
    else return $cYl7t.split32(this.h.slice(0, 12), "big");
};

});
parcelRegister("6bcDP", function(module, exports) {
"use strict";

var $cYl7t = parcelRequire("cYl7t");

var $1pS1U = parcelRequire("1pS1U");

var $3210N = parcelRequire("3210N");
var $47fd937a71a2450c$var$rotr64_hi = $cYl7t.rotr64_hi;
var $47fd937a71a2450c$var$rotr64_lo = $cYl7t.rotr64_lo;
var $47fd937a71a2450c$var$shr64_hi = $cYl7t.shr64_hi;
var $47fd937a71a2450c$var$shr64_lo = $cYl7t.shr64_lo;
var $47fd937a71a2450c$var$sum64 = $cYl7t.sum64;
var $47fd937a71a2450c$var$sum64_hi = $cYl7t.sum64_hi;
var $47fd937a71a2450c$var$sum64_lo = $cYl7t.sum64_lo;
var $47fd937a71a2450c$var$sum64_4_hi = $cYl7t.sum64_4_hi;
var $47fd937a71a2450c$var$sum64_4_lo = $cYl7t.sum64_4_lo;
var $47fd937a71a2450c$var$sum64_5_hi = $cYl7t.sum64_5_hi;
var $47fd937a71a2450c$var$sum64_5_lo = $cYl7t.sum64_5_lo;
var $47fd937a71a2450c$var$BlockHash = $1pS1U.BlockHash;
var $47fd937a71a2450c$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $47fd937a71a2450c$var$SHA512() {
    if (!(this instanceof $47fd937a71a2450c$var$SHA512)) return new $47fd937a71a2450c$var$SHA512();
    $47fd937a71a2450c$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $47fd937a71a2450c$var$sha512_K;
    this.W = new Array(160);
}
$cYl7t.inherits($47fd937a71a2450c$var$SHA512, $47fd937a71a2450c$var$BlockHash);
module.exports = $47fd937a71a2450c$var$SHA512;
$47fd937a71a2450c$var$SHA512.blockSize = 1024;
$47fd937a71a2450c$var$SHA512.outSize = 512;
$47fd937a71a2450c$var$SHA512.hmacStrength = 192;
$47fd937a71a2450c$var$SHA512.padLength = 128;
$47fd937a71a2450c$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $47fd937a71a2450c$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $47fd937a71a2450c$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $47fd937a71a2450c$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $47fd937a71a2450c$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $47fd937a71a2450c$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $47fd937a71a2450c$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$47fd937a71a2450c$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $3210N(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $47fd937a71a2450c$var$s1_512_hi(eh, el);
        var c1_lo = $47fd937a71a2450c$var$s1_512_lo(eh, el);
        var c2_hi = $47fd937a71a2450c$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $47fd937a71a2450c$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $47fd937a71a2450c$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $47fd937a71a2450c$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $47fd937a71a2450c$var$s0_512_hi(ah, al);
        c0_lo = $47fd937a71a2450c$var$s0_512_lo(ah, al);
        c1_hi = $47fd937a71a2450c$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $47fd937a71a2450c$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $47fd937a71a2450c$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $47fd937a71a2450c$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $47fd937a71a2450c$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $47fd937a71a2450c$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $47fd937a71a2450c$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $47fd937a71a2450c$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $47fd937a71a2450c$var$sum64(this.h, 0, ah, al);
    $47fd937a71a2450c$var$sum64(this.h, 2, bh, bl);
    $47fd937a71a2450c$var$sum64(this.h, 4, ch, cl);
    $47fd937a71a2450c$var$sum64(this.h, 6, dh, dl);
    $47fd937a71a2450c$var$sum64(this.h, 8, eh, el);
    $47fd937a71a2450c$var$sum64(this.h, 10, fh, fl);
    $47fd937a71a2450c$var$sum64(this.h, 12, gh, gl);
    $47fd937a71a2450c$var$sum64(this.h, 14, hh, hl);
};
$47fd937a71a2450c$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === "hex") return $cYl7t.toHex32(this.h, "big");
    else return $cYl7t.split32(this.h, "big");
};
function $47fd937a71a2450c$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $47fd937a71a2450c$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $47fd937a71a2450c$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $47fd937a71a2450c$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $47fd937a71a2450c$var$s0_512_hi(xh, xl) {
    var c0_hi = $47fd937a71a2450c$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $47fd937a71a2450c$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $47fd937a71a2450c$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $47fd937a71a2450c$var$s0_512_lo(xh, xl) {
    var c0_lo = $47fd937a71a2450c$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $47fd937a71a2450c$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $47fd937a71a2450c$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $47fd937a71a2450c$var$s1_512_hi(xh, xl) {
    var c0_hi = $47fd937a71a2450c$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $47fd937a71a2450c$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $47fd937a71a2450c$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $47fd937a71a2450c$var$s1_512_lo(xh, xl) {
    var c0_lo = $47fd937a71a2450c$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $47fd937a71a2450c$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $47fd937a71a2450c$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $47fd937a71a2450c$var$g0_512_hi(xh, xl) {
    var c0_hi = $47fd937a71a2450c$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $47fd937a71a2450c$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $47fd937a71a2450c$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $47fd937a71a2450c$var$g0_512_lo(xh, xl) {
    var c0_lo = $47fd937a71a2450c$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $47fd937a71a2450c$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $47fd937a71a2450c$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $47fd937a71a2450c$var$g1_512_hi(xh, xl) {
    var c0_hi = $47fd937a71a2450c$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $47fd937a71a2450c$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $47fd937a71a2450c$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $47fd937a71a2450c$var$g1_512_lo(xh, xl) {
    var c0_lo = $47fd937a71a2450c$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $47fd937a71a2450c$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $47fd937a71a2450c$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("jAZNy", function(module, exports) {

$parcel$export(module.exports, "ripemd160", function () { return $e44150fbd2160137$export$d1cea0ee4e3f0d3e; }, function (v) { return $e44150fbd2160137$export$d1cea0ee4e3f0d3e = v; });
var $e44150fbd2160137$export$d1cea0ee4e3f0d3e;
"use strict";

var $cYl7t = parcelRequire("cYl7t");

var $1pS1U = parcelRequire("1pS1U");
var $e44150fbd2160137$var$rotl32 = $cYl7t.rotl32;
var $e44150fbd2160137$var$sum32 = $cYl7t.sum32;
var $e44150fbd2160137$var$sum32_3 = $cYl7t.sum32_3;
var $e44150fbd2160137$var$sum32_4 = $cYl7t.sum32_4;
var $e44150fbd2160137$var$BlockHash = $1pS1U.BlockHash;
function $e44150fbd2160137$var$RIPEMD160() {
    if (!(this instanceof $e44150fbd2160137$var$RIPEMD160)) return new $e44150fbd2160137$var$RIPEMD160();
    $e44150fbd2160137$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = "little";
}
$cYl7t.inherits($e44150fbd2160137$var$RIPEMD160, $e44150fbd2160137$var$BlockHash);
$e44150fbd2160137$export$d1cea0ee4e3f0d3e = $e44150fbd2160137$var$RIPEMD160;
$e44150fbd2160137$var$RIPEMD160.blockSize = 512;
$e44150fbd2160137$var$RIPEMD160.outSize = 160;
$e44150fbd2160137$var$RIPEMD160.hmacStrength = 192;
$e44150fbd2160137$var$RIPEMD160.padLength = 64;
$e44150fbd2160137$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $e44150fbd2160137$var$sum32($e44150fbd2160137$var$rotl32($e44150fbd2160137$var$sum32_4(A, $e44150fbd2160137$var$f(j, B, C, D), msg[$e44150fbd2160137$var$r[j] + start], $e44150fbd2160137$var$K(j)), $e44150fbd2160137$var$s[j]), E);
        A = E;
        E = D;
        D = $e44150fbd2160137$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $e44150fbd2160137$var$sum32($e44150fbd2160137$var$rotl32($e44150fbd2160137$var$sum32_4(Ah, $e44150fbd2160137$var$f(79 - j, Bh, Ch, Dh), msg[$e44150fbd2160137$var$rh[j] + start], $e44150fbd2160137$var$Kh(j)), $e44150fbd2160137$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $e44150fbd2160137$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $e44150fbd2160137$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $e44150fbd2160137$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $e44150fbd2160137$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $e44150fbd2160137$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $e44150fbd2160137$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$e44150fbd2160137$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === "hex") return $cYl7t.toHex32(this.h, "little");
    else return $cYl7t.split32(this.h, "little");
};
function $e44150fbd2160137$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $e44150fbd2160137$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $e44150fbd2160137$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $e44150fbd2160137$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $e44150fbd2160137$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $e44150fbd2160137$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $e44150fbd2160137$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("hC4jp", function(module, exports) {
"use strict";

var $cYl7t = parcelRequire("cYl7t");

var $3210N = parcelRequire("3210N");
function $cd29549494435068$var$Hmac(hash, key, enc) {
    if (!(this instanceof $cd29549494435068$var$Hmac)) return new $cd29549494435068$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($cYl7t.toArray(key, enc));
}
module.exports = $cd29549494435068$var$Hmac;
$cd29549494435068$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $3210N(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$cd29549494435068$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$cd29549494435068$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRegister("cBTAl", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
                "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
            ],
            [
                "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
                "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
            ],
            [
                "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
                "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
            ],
            [
                "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
                "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
            ],
            [
                "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
                "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
            ],
            [
                "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
                "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
            ],
            [
                "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
                "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
            ],
            [
                "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
                "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
            ],
            [
                "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
                "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
            ],
            [
                "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
                "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
            ],
            [
                "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
                "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
            ],
            [
                "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
                "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
            ],
            [
                "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
                "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
            ],
            [
                "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
                "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
            ],
            [
                "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
                "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
            ],
            [
                "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
                "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
            ],
            [
                "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
                "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
            ],
            [
                "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
                "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
            ],
            [
                "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
                "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
            ],
            [
                "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
                "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
            ],
            [
                "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
                "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
            ],
            [
                "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
                "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
            ],
            [
                "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
                "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
            ],
            [
                "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
                "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
            ],
            [
                "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
                "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
            ],
            [
                "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
                "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
            ],
            [
                "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
                "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
            ],
            [
                "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
                "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
            ],
            [
                "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
                "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
            ],
            [
                "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
                "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
            ],
            [
                "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
                "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
            ],
            [
                "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
                "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
            ],
            [
                "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
                "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
            ],
            [
                "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
                "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
            ],
            [
                "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
                "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
            ],
            [
                "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
                "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
            ],
            [
                "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
                "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
            ],
            [
                "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
                "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
            ],
            [
                "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
                "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
            ],
            [
                "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
                "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
            ],
            [
                "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
                "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
            ],
            [
                "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
                "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
            ],
            [
                "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
                "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
            ],
            [
                "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
                "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
            ],
            [
                "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
                "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
            ],
            [
                "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
                "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
            ],
            [
                "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
                "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
            ],
            [
                "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
                "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
            ],
            [
                "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
                "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
            ],
            [
                "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
                "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
            ],
            [
                "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
                "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
            ],
            [
                "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
                "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
            ],
            [
                "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
                "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
            ],
            [
                "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
                "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
            ],
            [
                "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
                "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
            ],
            [
                "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
                "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
            ],
            [
                "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
                "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
            ],
            [
                "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
                "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
            ],
            [
                "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
                "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
            ],
            [
                "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
                "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
            ],
            [
                "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
                "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
            ],
            [
                "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
                "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
            ],
            [
                "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
                "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
            ],
            [
                "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
                "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
            ],
            [
                "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
                "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
                "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
            ],
            [
                "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
                "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
            ],
            [
                "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
                "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
            ],
            [
                "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
                "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
            ],
            [
                "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
                "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
            ],
            [
                "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
                "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
            ],
            [
                "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
                "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
            ],
            [
                "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
                "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
            ],
            [
                "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
                "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
            ],
            [
                "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
                "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
            ],
            [
                "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
                "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
            ],
            [
                "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
                "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
            ],
            [
                "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
                "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
            ],
            [
                "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
                "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
            ],
            [
                "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
                "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
            ],
            [
                "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
                "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
            ],
            [
                "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
                "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
            ],
            [
                "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
                "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
            ],
            [
                "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
                "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
            ],
            [
                "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
                "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
            ],
            [
                "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
                "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
            ],
            [
                "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
                "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
            ],
            [
                "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
                "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
            ],
            [
                "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
                "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
            ],
            [
                "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
                "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
            ],
            [
                "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
                "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
            ],
            [
                "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
                "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
            ],
            [
                "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
                "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
            ],
            [
                "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
                "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
            ],
            [
                "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
                "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
            ],
            [
                "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
                "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
            ],
            [
                "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
                "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
            ],
            [
                "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
                "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
            ],
            [
                "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
                "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
            ],
            [
                "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
                "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
            ],
            [
                "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
                "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
            ],
            [
                "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
                "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
            ],
            [
                "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
                "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
            ],
            [
                "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
                "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
            ],
            [
                "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
                "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
            ],
            [
                "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
                "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
            ],
            [
                "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
                "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
            ],
            [
                "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
                "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
            ],
            [
                "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
                "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
            ],
            [
                "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
                "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
            ],
            [
                "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
                "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
            ],
            [
                "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
                "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
            ],
            [
                "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
                "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
            ],
            [
                "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
                "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
            ],
            [
                "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
                "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
            ],
            [
                "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
                "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
            ],
            [
                "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
                "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
            ],
            [
                "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
                "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
            ],
            [
                "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
                "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
            ],
            [
                "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
                "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
            ],
            [
                "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
                "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
            ],
            [
                "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
                "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
            ],
            [
                "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
                "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
            ],
            [
                "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
                "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
            ],
            [
                "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
                "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
            ],
            [
                "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
                "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
            ],
            [
                "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
                "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
            ],
            [
                "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
                "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
            ],
            [
                "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
                "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
            ],
            [
                "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
                "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
            ],
            [
                "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
                "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
            ],
            [
                "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
                "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
            ],
            [
                "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
                "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
            ],
            [
                "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
                "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
            ],
            [
                "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
                "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
            ],
            [
                "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
                "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
            ],
            [
                "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
                "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
            ],
            [
                "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
                "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
            ],
            [
                "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
                "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
            ],
            [
                "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
                "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
            ],
            [
                "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
                "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
            ],
            [
                "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
                "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
            ],
            [
                "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
                "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
            ],
            [
                "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
                "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
            ],
            [
                "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
                "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
            ],
            [
                "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
                "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
            ],
            [
                "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
                "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
            ],
            [
                "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
                "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
            ],
            [
                "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
                "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
            ],
            [
                "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
                "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
            ],
            [
                "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
                "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
            ],
            [
                "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
                "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
            ],
            [
                "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
                "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
            ],
            [
                "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
                "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
            ],
            [
                "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
                "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
            ],
            [
                "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
                "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
            ],
            [
                "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
                "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
            ],
            [
                "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
                "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
            ],
            [
                "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
                "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
            ],
            [
                "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
                "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
            ],
            [
                "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
                "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
            ],
            [
                "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
                "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
            ],
            [
                "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
                "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
            ],
            [
                "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
                "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
            ],
            [
                "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
                "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
            ],
            [
                "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
                "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
            ],
            [
                "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
                "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
            ],
            [
                "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
                "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
            ],
            [
                "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
                "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
            ],
            [
                "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
                "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
            ],
            [
                "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
                "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
            ],
            [
                "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
                "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
            ],
            [
                "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
                "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
            ],
            [
                "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
                "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
            ],
            [
                "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
                "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
            ],
            [
                "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
                "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
            ],
            [
                "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
                "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
            ],
            [
                "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
                "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
            ],
            [
                "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
                "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
            ],
            [
                "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
                "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
            ],
            [
                "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
                "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
            ],
            [
                "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
                "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
            ],
            [
                "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
                "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
            ],
            [
                "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
                "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
            ],
            [
                "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
                "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
            ],
            [
                "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
                "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
            ],
            [
                "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
                "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
            ],
            [
                "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
                "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
            ],
            [
                "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
                "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
            ],
            [
                "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
                "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
            ],
            [
                "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
                "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
            ],
            [
                "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
                "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
            ]
        ]
    }
};

});


parcelRegister("jA2EE", function(module, exports) {
"use strict";

var $h0anJ = parcelRequire("h0anJ");

var $kNeip = parcelRequire("kNeip");

var $boA1w = parcelRequire("boA1w");

var $kKmfE = parcelRequire("kKmfE");

var $8v4zB = parcelRequire("8v4zB");
var $03adbb9dfc3c6eed$var$assert = $boA1w.assert;

var $6UxhE = parcelRequire("6UxhE");

var $3VM75 = parcelRequire("3VM75");
function $03adbb9dfc3c6eed$var$EC(options) {
    if (!(this instanceof $03adbb9dfc3c6eed$var$EC)) return new $03adbb9dfc3c6eed$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        $03adbb9dfc3c6eed$var$assert(Object.prototype.hasOwnProperty.call($kKmfE, options), "Unknown curve " + options);
        options = $kKmfE[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $kKmfE.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $03adbb9dfc3c6eed$var$EC;
$03adbb9dfc3c6eed$var$EC.prototype.keyPair = function keyPair(options) {
    return new $6UxhE(this, options);
};
$03adbb9dfc3c6eed$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $6UxhE.fromPrivate(this, priv, enc);
};
$03adbb9dfc3c6eed$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $6UxhE.fromPublic(this, pub, enc);
};
$03adbb9dfc3c6eed$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $kNeip({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || $8v4zB(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $h0anJ(2));
    for(;;){
        var priv = new $h0anJ(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$03adbb9dfc3c6eed$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$03adbb9dfc3c6eed$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new $h0anJ(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $kNeip({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $h0anJ(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $h0anJ(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $3VM75({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$03adbb9dfc3c6eed$var$EC.prototype.verify = function verify(msg, signature, key, enc) {
    msg = this._truncateToN(new $h0anJ(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature = new $3VM75(signature, "hex");
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$03adbb9dfc3c6eed$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $03adbb9dfc3c6eed$var$assert((3 & j) === j, "The recovery param is more than two bits");
    signature = new $3VM75(signature, enc);
    var n = this.n;
    var e = new $h0anJ(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$03adbb9dfc3c6eed$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $3VM75(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};

});
parcelRegister("kNeip", function(module, exports) {
"use strict";

var $dMFrt = parcelRequire("dMFrt");

var $4YHS3 = parcelRequire("4YHS3");

var $3210N = parcelRequire("3210N");
function $f2337925eb4d650c$var$HmacDRBG(options) {
    if (!(this instanceof $f2337925eb4d650c$var$HmacDRBG)) return new $f2337925eb4d650c$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $4YHS3.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = $4YHS3.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = $4YHS3.toArray(options.pers, options.persEnc || "hex");
    $3210N(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
module.exports = $f2337925eb4d650c$var$HmacDRBG;
$f2337925eb4d650c$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$f2337925eb4d650c$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $dMFrt.hmac(this.hash, this.K);
};
$f2337925eb4d650c$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$f2337925eb4d650c$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $4YHS3.toArray(entropy, entropyEnc);
    add = $4YHS3.toArray(add, addEnc);
    $3210N(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$f2337925eb4d650c$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $4YHS3.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $4YHS3.encode(res, enc);
};

});

parcelRegister("6UxhE", function(module, exports) {
"use strict";

var $h0anJ = parcelRequire("h0anJ");

var $boA1w = parcelRequire("boA1w");
var $5081ca7d72751237$var$assert = $boA1w.assert;
function $5081ca7d72751237$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $5081ca7d72751237$var$KeyPair;
$5081ca7d72751237$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $5081ca7d72751237$var$KeyPair) return pub;
    return new $5081ca7d72751237$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$5081ca7d72751237$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $5081ca7d72751237$var$KeyPair) return priv;
    return new $5081ca7d72751237$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$5081ca7d72751237$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
$5081ca7d72751237$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$5081ca7d72751237$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
$5081ca7d72751237$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $h0anJ(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$5081ca7d72751237$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") $5081ca7d72751237$var$assert(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") $5081ca7d72751237$var$assert(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$5081ca7d72751237$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $5081ca7d72751237$var$assert(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
$5081ca7d72751237$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$5081ca7d72751237$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$5081ca7d72751237$var$KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};

});

parcelRegister("3VM75", function(module, exports) {
"use strict";

var $h0anJ = parcelRequire("h0anJ");

var $boA1w = parcelRequire("boA1w");
var $2dcc0445c1412382$var$assert = $boA1w.assert;
function $2dcc0445c1412382$var$Signature(options, enc) {
    if (options instanceof $2dcc0445c1412382$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $2dcc0445c1412382$var$assert(options.r && options.s, "Signature without r or s");
    this.r = new $h0anJ(options.r, 16);
    this.s = new $h0anJ(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $2dcc0445c1412382$var$Signature;
function $2dcc0445c1412382$var$Position() {
    this.place = 0;
}
function $2dcc0445c1412382$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $2dcc0445c1412382$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$2dcc0445c1412382$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $boA1w.toArray(data, enc);
    var p = new $2dcc0445c1412382$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $2dcc0445c1412382$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $2dcc0445c1412382$var$getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $2dcc0445c1412382$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $h0anJ(r);
    this.s = new $h0anJ(s);
    this.recoveryParam = null;
    return true;
};
function $2dcc0445c1412382$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$2dcc0445c1412382$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $2dcc0445c1412382$var$rmPadding(r);
    s = $2dcc0445c1412382$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $2dcc0445c1412382$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $2dcc0445c1412382$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $2dcc0445c1412382$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $boA1w.encode(res, enc);
};

});


parcelRegister("51QPl", function(module, exports) {
"use strict";

var $dMFrt = parcelRequire("dMFrt");

var $kKmfE = parcelRequire("kKmfE");

var $boA1w = parcelRequire("boA1w");
var $3a960622930d64ef$var$assert = $boA1w.assert;
var $3a960622930d64ef$var$parseBytes = $boA1w.parseBytes;

var $l7DZZ = parcelRequire("l7DZZ");

var $dfflx = parcelRequire("dfflx");
function $3a960622930d64ef$var$EDDSA(curve) {
    $3a960622930d64ef$var$assert(curve === "ed25519", "only tested with ed25519 so far");
    if (!(this instanceof $3a960622930d64ef$var$EDDSA)) return new $3a960622930d64ef$var$EDDSA(curve);
    curve = $kKmfE[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $dMFrt.sha512;
}
module.exports = $3a960622930d64ef$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $3a960622930d64ef$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $3a960622930d64ef$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $3a960622930d64ef$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $3a960622930d64ef$var$parseBytes(message);
    sig = this.makeSignature(sig);
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$3a960622930d64ef$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $boA1w.intFromLE(hash.digest()).umod(this.curve.n);
};
$3a960622930d64ef$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $l7DZZ.fromPublic(this, pub);
};
$3a960622930d64ef$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $l7DZZ.fromSecret(this, secret);
};
$3a960622930d64ef$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $dfflx) return sig;
    return new $dfflx(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $3a960622930d64ef$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray("le", this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$3a960622930d64ef$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $boA1w.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $boA1w.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$3a960622930d64ef$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray("le", this.encodingLength);
};
$3a960622930d64ef$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $boA1w.intFromLE(bytes);
};
$3a960622930d64ef$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("l7DZZ", function(module, exports) {
"use strict";

var $boA1w = parcelRequire("boA1w");
var $f609475a1279c31c$var$assert = $boA1w.assert;
var $f609475a1279c31c$var$parseBytes = $boA1w.parseBytes;
var $f609475a1279c31c$var$cachedProperty = $boA1w.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $f609475a1279c31c$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $f609475a1279c31c$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $f609475a1279c31c$var$parseBytes(params.pub);
}
$f609475a1279c31c$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $f609475a1279c31c$var$KeyPair) return pub;
    return new $f609475a1279c31c$var$KeyPair(eddsa, {
        pub: pub
    });
};
$f609475a1279c31c$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $f609475a1279c31c$var$KeyPair) return secret;
    return new $f609475a1279c31c$var$KeyPair(eddsa, {
        secret: secret
    });
};
$f609475a1279c31c$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$f609475a1279c31c$var$cachedProperty($f609475a1279c31c$var$KeyPair, "pubBytes", function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$f609475a1279c31c$var$cachedProperty($f609475a1279c31c$var$KeyPair, "pub", function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$f609475a1279c31c$var$cachedProperty($f609475a1279c31c$var$KeyPair, "privBytes", function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$f609475a1279c31c$var$cachedProperty($f609475a1279c31c$var$KeyPair, "priv", function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$f609475a1279c31c$var$cachedProperty($f609475a1279c31c$var$KeyPair, "hash", function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$f609475a1279c31c$var$cachedProperty($f609475a1279c31c$var$KeyPair, "messagePrefix", function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$f609475a1279c31c$var$KeyPair.prototype.sign = function sign(message) {
    $f609475a1279c31c$var$assert(this._secret, "KeyPair can only verify");
    return this.eddsa.sign(message, this);
};
$f609475a1279c31c$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$f609475a1279c31c$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $f609475a1279c31c$var$assert(this._secret, "KeyPair is public only");
    return $boA1w.encode(this.secret(), enc);
};
$f609475a1279c31c$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $boA1w.encode(this.pubBytes(), enc);
};
module.exports = $f609475a1279c31c$var$KeyPair;

});

parcelRegister("dfflx", function(module, exports) {
"use strict";

var $h0anJ = parcelRequire("h0anJ");

var $boA1w = parcelRequire("boA1w");
var $9a4894875072ae55$var$assert = $boA1w.assert;
var $9a4894875072ae55$var$cachedProperty = $boA1w.cachedProperty;
var $9a4894875072ae55$var$parseBytes = $boA1w.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $9a4894875072ae55$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== "object") sig = $9a4894875072ae55$var$parseBytes(sig);
    if (Array.isArray(sig)) sig = {
        R: sig.slice(0, eddsa.encodingLength),
        S: sig.slice(eddsa.encodingLength)
    };
    $9a4894875072ae55$var$assert(sig.R && sig.S, "Signature without R or S");
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $h0anJ) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$9a4894875072ae55$var$cachedProperty($9a4894875072ae55$var$Signature, "S", function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$9a4894875072ae55$var$cachedProperty($9a4894875072ae55$var$Signature, "R", function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$9a4894875072ae55$var$cachedProperty($9a4894875072ae55$var$Signature, "Rencoded", function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$9a4894875072ae55$var$cachedProperty($9a4894875072ae55$var$Signature, "Sencoded", function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$9a4894875072ae55$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$9a4894875072ae55$var$Signature.prototype.toHex = function toHex() {
    return $boA1w.encode(this.toBytes(), "hex").toUpperCase();
};
module.exports = $9a4894875072ae55$var$Signature;

});



parcelRegister("5nDla", function(module, exports) {

var $6j2SI = parcelRequire("6j2SI");

var $l6piA = parcelRequire("l6piA");

var $lNx08 = parcelRequire("lNx08");

var $X9qDO = parcelRequire("X9qDO");

var $2r16u = parcelRequire("2r16u");

var $eN0t8 = parcelRequire("eN0t8");
var $3ead9de69cdfeb72$require$Buffer = $eN0t8.Buffer;
module.exports = $3ead9de69cdfeb72$var$parseKeys;
function $3ead9de69cdfeb72$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === "object" && !$3ead9de69cdfeb72$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === "string") buffer = $3ead9de69cdfeb72$require$Buffer.from(buffer);
    var stripped = $lNx08(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case "CERTIFICATE":
            ndata = $6j2SI.certificate.decode(data, "der").tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case "PUBLIC KEY":
            if (!ndata) ndata = $6j2SI.PublicKey.decode(data, "der");
            subtype = ndata.algorithm.algorithm.join(".");
            switch(subtype){
                case "1.2.840.113549.1.1.1":
                    return $6j2SI.RSAPublicKey.decode(ndata.subjectPublicKey.data, "der");
                case "1.2.840.10045.2.1":
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: "ec",
                        data: ndata
                    };
                case "1.2.840.10040.4.1":
                    ndata.algorithm.params.pub_key = $6j2SI.DSAparam.decode(ndata.subjectPublicKey.data, "der");
                    return {
                        type: "dsa",
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error("unknown key id " + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case "ENCRYPTED PRIVATE KEY":
            data = $6j2SI.EncryptedPrivateKey.decode(data, "der");
            data = $3ead9de69cdfeb72$var$decrypt(data, password);
        // falls through
        case "PRIVATE KEY":
            ndata = $6j2SI.PrivateKey.decode(data, "der");
            subtype = ndata.algorithm.algorithm.join(".");
            switch(subtype){
                case "1.2.840.113549.1.1.1":
                    return $6j2SI.RSAPrivateKey.decode(ndata.subjectPrivateKey, "der");
                case "1.2.840.10045.2.1":
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $6j2SI.ECPrivateKey.decode(ndata.subjectPrivateKey, "der").privateKey
                    };
                case "1.2.840.10040.4.1":
                    ndata.algorithm.params.priv_key = $6j2SI.DSAparam.decode(ndata.subjectPrivateKey, "der");
                    return {
                        type: "dsa",
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error("unknown key id " + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case "RSA PUBLIC KEY":
            return $6j2SI.RSAPublicKey.decode(data, "der");
        case "RSA PRIVATE KEY":
            return $6j2SI.RSAPrivateKey.decode(data, "der");
        case "DSA PRIVATE KEY":
            return {
                type: "dsa",
                params: $6j2SI.DSAPrivateKey.decode(data, "der")
            };
        case "EC PRIVATE KEY":
            data = $6j2SI.ECPrivateKey.decode(data, "der");
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error("unknown key type " + type);
    }
}
$3ead9de69cdfeb72$var$parseKeys.signature = $6j2SI.signature;
function $3ead9de69cdfeb72$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $l6piA[data.algorithm.decrypt.cipher.algo.join(".")];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split("-")[1], 10) / 8;
    var key = $2r16u.pbkdf2Sync(password, salt, iters, keylen, "sha1");
    var cipher = $X9qDO.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher.final());
    return $3ead9de69cdfeb72$require$Buffer.concat(out);
}

});
parcelRegister("6j2SI", function(module, exports) {

$parcel$export(module.exports, "certificate", function () { return $4976c09f65209dc1$export$c98397a6eb8d0678; }, function (v) { return $4976c09f65209dc1$export$c98397a6eb8d0678 = v; });
$parcel$export(module.exports, "RSAPrivateKey", function () { return $4976c09f65209dc1$export$f4aab6816f64fa6b; }, function (v) { return $4976c09f65209dc1$export$f4aab6816f64fa6b = v; });
$parcel$export(module.exports, "RSAPublicKey", function () { return $4976c09f65209dc1$export$4471f5c65d097c11; }, function (v) { return $4976c09f65209dc1$export$4471f5c65d097c11 = v; });
$parcel$export(module.exports, "PublicKey", function () { return $4976c09f65209dc1$export$ca8b6604d6ce14de; }, function (v) { return $4976c09f65209dc1$export$ca8b6604d6ce14de = v; });
$parcel$export(module.exports, "PrivateKey", function () { return $4976c09f65209dc1$export$8f54525b330fd87b; }, function (v) { return $4976c09f65209dc1$export$8f54525b330fd87b = v; });
$parcel$export(module.exports, "EncryptedPrivateKey", function () { return $4976c09f65209dc1$export$23cd2842b44ca3e7; }, function (v) { return $4976c09f65209dc1$export$23cd2842b44ca3e7 = v; });
$parcel$export(module.exports, "DSAPrivateKey", function () { return $4976c09f65209dc1$export$245c9aaa9f5ce4ce; }, function (v) { return $4976c09f65209dc1$export$245c9aaa9f5ce4ce = v; });
$parcel$export(module.exports, "DSAparam", function () { return $4976c09f65209dc1$export$8ad762e3e6399afe; }, function (v) { return $4976c09f65209dc1$export$8ad762e3e6399afe = v; });
$parcel$export(module.exports, "ECPrivateKey", function () { return $4976c09f65209dc1$export$32ef6f92e22c6ab0; }, function (v) { return $4976c09f65209dc1$export$32ef6f92e22c6ab0 = v; });
$parcel$export(module.exports, "signature", function () { return $4976c09f65209dc1$export$c9cd164b539ebb63; }, function (v) { return $4976c09f65209dc1$export$c9cd164b539ebb63 = v; });
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $4976c09f65209dc1$export$c98397a6eb8d0678;
var $4976c09f65209dc1$export$f4aab6816f64fa6b;
var $4976c09f65209dc1$export$4471f5c65d097c11;
var $4976c09f65209dc1$export$ca8b6604d6ce14de;
var $4976c09f65209dc1$export$8f54525b330fd87b;
var $4976c09f65209dc1$export$23cd2842b44ca3e7;
var $4976c09f65209dc1$export$245c9aaa9f5ce4ce;
var $4976c09f65209dc1$export$8ad762e3e6399afe;
var $4976c09f65209dc1$export$32ef6f92e22c6ab0;
var $4976c09f65209dc1$export$c9cd164b539ebb63;
"use strict";

var $72Zbf = parcelRequire("72Zbf");

$4976c09f65209dc1$export$c98397a6eb8d0678 = (parcelRequire("jOtxC"));
var $4976c09f65209dc1$var$RSAPrivateKey = $72Zbf.define("RSAPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("modulus").int(), this.key("publicExponent").int(), this.key("privateExponent").int(), this.key("prime1").int(), this.key("prime2").int(), this.key("exponent1").int(), this.key("exponent2").int(), this.key("coefficient").int());
});
$4976c09f65209dc1$export$f4aab6816f64fa6b = $4976c09f65209dc1$var$RSAPrivateKey;
var $4976c09f65209dc1$var$RSAPublicKey = $72Zbf.define("RSAPublicKey", function() {
    this.seq().obj(this.key("modulus").int(), this.key("publicExponent").int());
});
$4976c09f65209dc1$export$4471f5c65d097c11 = $4976c09f65209dc1$var$RSAPublicKey;
var $4976c09f65209dc1$var$PublicKey = $72Zbf.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(this.key("algorithm").use($4976c09f65209dc1$var$AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
$4976c09f65209dc1$export$ca8b6604d6ce14de = $4976c09f65209dc1$var$PublicKey;
var $4976c09f65209dc1$var$AlgorithmIdentifier = $72Zbf.define("AlgorithmIdentifier", function() {
    this.seq().obj(this.key("algorithm").objid(), this.key("none").null_().optional(), this.key("curve").objid().optional(), this.key("params").seq().obj(this.key("p").int(), this.key("q").int(), this.key("g").int()).optional());
});
var $4976c09f65209dc1$var$PrivateKeyInfo = $72Zbf.define("PrivateKeyInfo", function() {
    this.seq().obj(this.key("version").int(), this.key("algorithm").use($4976c09f65209dc1$var$AlgorithmIdentifier), this.key("subjectPrivateKey").octstr());
});
$4976c09f65209dc1$export$8f54525b330fd87b = $4976c09f65209dc1$var$PrivateKeyInfo;
var $4976c09f65209dc1$var$EncryptedPrivateKeyInfo = $72Zbf.define("EncryptedPrivateKeyInfo", function() {
    this.seq().obj(this.key("algorithm").seq().obj(this.key("id").objid(), this.key("decrypt").seq().obj(this.key("kde").seq().obj(this.key("id").objid(), this.key("kdeparams").seq().obj(this.key("salt").octstr(), this.key("iters").int())), this.key("cipher").seq().obj(this.key("algo").objid(), this.key("iv").octstr()))), this.key("subjectPrivateKey").octstr());
});
$4976c09f65209dc1$export$23cd2842b44ca3e7 = $4976c09f65209dc1$var$EncryptedPrivateKeyInfo;
var $4976c09f65209dc1$var$DSAPrivateKey = $72Zbf.define("DSAPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("p").int(), this.key("q").int(), this.key("g").int(), this.key("pub_key").int(), this.key("priv_key").int());
});
$4976c09f65209dc1$export$245c9aaa9f5ce4ce = $4976c09f65209dc1$var$DSAPrivateKey;
$4976c09f65209dc1$export$8ad762e3e6399afe = $72Zbf.define("DSAparam", function() {
    this.int();
});
var $4976c09f65209dc1$var$ECPrivateKey = $72Zbf.define("ECPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("privateKey").octstr(), this.key("parameters").optional().explicit(0).use($4976c09f65209dc1$var$ECParameters), this.key("publicKey").optional().explicit(1).bitstr());
});
$4976c09f65209dc1$export$32ef6f92e22c6ab0 = $4976c09f65209dc1$var$ECPrivateKey;
var $4976c09f65209dc1$var$ECParameters = $72Zbf.define("ECParameters", function() {
    this.choice({
        namedCurve: this.objid()
    });
});
$4976c09f65209dc1$export$c9cd164b539ebb63 = $72Zbf.define("signature", function() {
    this.seq().obj(this.key("r").int(), this.key("s").int());
});

});
parcelRegister("72Zbf", function(module, exports) {
"use strict";
const $52182d78a654c558$var$asn1 = module.exports;

$52182d78a654c558$var$asn1.bignum = (parcelRequire("l3iV2"));

$52182d78a654c558$var$asn1.define = (parcelRequire("byQ4w")).define;

$52182d78a654c558$var$asn1.base = (parcelRequire("bMHL7"));

$52182d78a654c558$var$asn1.constants = (parcelRequire("aySCC"));

$52182d78a654c558$var$asn1.decoders = (parcelRequire("b68Bf"));

$52182d78a654c558$var$asn1.encoders = (parcelRequire("gw2cK"));

});
parcelRegister("l3iV2", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("aqbQf")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("byQ4w", function(module, exports) {
"use strict";

var $gw2cK = parcelRequire("gw2cK");

var $b68Bf = parcelRequire("b68Bf");

var $kvFQ5 = parcelRequire("kvFQ5");
const $86ab4310e2e37424$var$api = module.exports;
$86ab4310e2e37424$var$api.define = function define(name, body) {
    return new $86ab4310e2e37424$var$Entity(name, body);
};
function $86ab4310e2e37424$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}
$86ab4310e2e37424$var$Entity.prototype._createNamed = function createNamed(Base) {
    const name = this.name;
    function Generated(entity) {
        this._initNamed(entity, name);
    }
    $kvFQ5(Generated, Base);
    Generated.prototype._initNamed = function _initNamed(entity, name) {
        Base.call(this, entity, name);
    };
    return new Generated(this);
};
$86ab4310e2e37424$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || "der";
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($b68Bf[enc]);
    return this.decoders[enc];
};
$86ab4310e2e37424$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$86ab4310e2e37424$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || "der";
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($gw2cK[enc]);
    return this.encoders[enc];
};
$86ab4310e2e37424$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRegister("gw2cK", function(module, exports) {
"use strict";
const $c061584bbfa81add$var$encoders = module.exports;

$c061584bbfa81add$var$encoders.der = (parcelRequire("h7Jar"));

$c061584bbfa81add$var$encoders.pem = (parcelRequire("WTsXi"));

});
parcelRegister("h7Jar", function(module, exports) {
"use strict";

var $kvFQ5 = parcelRequire("kvFQ5");

var $llyme = parcelRequire("llyme");
var $c776206fbdca9bf2$require$Buffer = $llyme.Buffer;

var $7QW6d = parcelRequire("7QW6d");

var $1P4FE = parcelRequire("1P4FE");
function $c776206fbdca9bf2$var$DEREncoder(entity) {
    this.enc = "der";
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $c776206fbdca9bf2$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $c776206fbdca9bf2$var$DEREncoder;
$c776206fbdca9bf2$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $c776206fbdca9bf2$var$DERNode(parent) {
    $7QW6d.call(this, "der", parent);
}
$kvFQ5($c776206fbdca9bf2$var$DERNode, $7QW6d);
$c776206fbdca9bf2$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    const encodedTag = $c776206fbdca9bf2$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        const header = $c776206fbdca9bf2$require$Buffer.alloc(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    let lenOctets = 1;
    for(let i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    const header = $c776206fbdca9bf2$require$Buffer.alloc(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(let i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$c776206fbdca9bf2$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === "bitstr") return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === "bmpstr") {
        const buf = $c776206fbdca9bf2$require$Buffer.alloc(str.length * 2);
        for(let i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === "numstr") {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === "printstr") {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === "objDesc") return this._createEncoderBuffer(str);
    else return this.reporter.error("Encoding of string type: " + tag + " unsupported");
};
$c776206fbdca9bf2$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === "string") {
        if (!values) return this.reporter.error("string objid given, but no values map found");
        if (!values.hasOwnProperty(id)) return this.reporter.error("objid not found in values map");
        id = values[id].split(/[\s.]+/g);
        for(let i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(let i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error("Second objid identifier OOB");
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    let size = 0;
    for(let i = 0; i < id.length; i++){
        let ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    const objid = $c776206fbdca9bf2$require$Buffer.alloc(size);
    let offset = objid.length - 1;
    for(let i = id.length - 1; i >= 0; i--){
        let ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $c776206fbdca9bf2$var$two(num) {
    if (num < 10) return "0" + num;
    else return num;
}
$c776206fbdca9bf2$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    let str;
    const date = new Date(time);
    if (tag === "gentime") str = [
        $c776206fbdca9bf2$var$two(date.getUTCFullYear()),
        $c776206fbdca9bf2$var$two(date.getUTCMonth() + 1),
        $c776206fbdca9bf2$var$two(date.getUTCDate()),
        $c776206fbdca9bf2$var$two(date.getUTCHours()),
        $c776206fbdca9bf2$var$two(date.getUTCMinutes()),
        $c776206fbdca9bf2$var$two(date.getUTCSeconds()),
        "Z"
    ].join("");
    else if (tag === "utctime") str = [
        $c776206fbdca9bf2$var$two(date.getUTCFullYear() % 100),
        $c776206fbdca9bf2$var$two(date.getUTCMonth() + 1),
        $c776206fbdca9bf2$var$two(date.getUTCDate()),
        $c776206fbdca9bf2$var$two(date.getUTCHours()),
        $c776206fbdca9bf2$var$two(date.getUTCMinutes()),
        $c776206fbdca9bf2$var$two(date.getUTCSeconds()),
        "Z"
    ].join("");
    else this.reporter.error("Encoding " + tag + " time is not supported yet");
    return this._encodeStr(str, "octstr");
};
$c776206fbdca9bf2$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer("");
};
$c776206fbdca9bf2$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === "string") {
        if (!values) return this.reporter.error("String int or enum given, but no values map");
        if (!values.hasOwnProperty(num)) return this.reporter.error("Values map doesn't contain: " + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== "number" && !$c776206fbdca9bf2$require$Buffer.isBuffer(num)) {
        const numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = $c776206fbdca9bf2$require$Buffer.from(numArray);
    }
    if ($c776206fbdca9bf2$require$Buffer.isBuffer(num)) {
        let size = num.length;
        if (num.length === 0) size++;
        const out = $c776206fbdca9bf2$require$Buffer.alloc(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    let size = 1;
    for(let i = num; i >= 0x100; i >>= 8)size++;
    const out = new Array(size);
    for(let i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer($c776206fbdca9bf2$require$Buffer.from(out));
};
$c776206fbdca9bf2$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$c776206fbdca9bf2$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === "function") entity = entity(obj);
    return entity._getEncoder("der").tree;
};
$c776206fbdca9bf2$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    const state = this._baseState;
    let i;
    if (state["default"] === null) return false;
    const data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state["default"], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $c776206fbdca9bf2$var$encodeTag(tag, primitive, cls, reporter) {
    let res;
    if (tag === "seqof") tag = "seq";
    else if (tag === "setof") tag = "set";
    if ($1P4FE.tagByName.hasOwnProperty(tag)) res = $1P4FE.tagByName[tag];
    else if (typeof tag === "number" && (tag | 0) === tag) res = tag;
    else return reporter.error("Unknown tag: " + tag);
    if (res >= 0x1f) return reporter.error("Multi-octet tag encoding unsupported");
    if (!primitive) res |= 0x20;
    res |= $1P4FE.tagClassByName[cls || "universal"] << 6;
    return res;
}

});
parcelRegister("llyme", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $a8i8g = parcelRequire("a8i8g");
"use strict";

var $gzLuY = parcelRequire("gzLuY");
var $f8a635d7da98a5fa$var$Buffer = $gzLuY.Buffer;
var $f8a635d7da98a5fa$var$safer = {};
var $f8a635d7da98a5fa$var$key;
for($f8a635d7da98a5fa$var$key in $gzLuY){
    if (!$gzLuY.hasOwnProperty($f8a635d7da98a5fa$var$key)) continue;
    if ($f8a635d7da98a5fa$var$key === "SlowBuffer" || $f8a635d7da98a5fa$var$key === "Buffer") continue;
    $f8a635d7da98a5fa$var$safer[$f8a635d7da98a5fa$var$key] = $gzLuY[$f8a635d7da98a5fa$var$key];
}
var $f8a635d7da98a5fa$var$Safer = $f8a635d7da98a5fa$var$safer.Buffer = {};
for($f8a635d7da98a5fa$var$key in $f8a635d7da98a5fa$var$Buffer){
    if (!$f8a635d7da98a5fa$var$Buffer.hasOwnProperty($f8a635d7da98a5fa$var$key)) continue;
    if ($f8a635d7da98a5fa$var$key === "allocUnsafe" || $f8a635d7da98a5fa$var$key === "allocUnsafeSlow") continue;
    $f8a635d7da98a5fa$var$Safer[$f8a635d7da98a5fa$var$key] = $f8a635d7da98a5fa$var$Buffer[$f8a635d7da98a5fa$var$key];
}
$f8a635d7da98a5fa$var$safer.Buffer.prototype = $f8a635d7da98a5fa$var$Buffer.prototype;
if (!$f8a635d7da98a5fa$var$Safer.from || $f8a635d7da98a5fa$var$Safer.from === Uint8Array.from) $f8a635d7da98a5fa$var$Safer.from = function(value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof value);
    if (value && typeof value.length === "undefined") throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    return $f8a635d7da98a5fa$var$Buffer(value, encodingOrOffset, length);
};
if (!$f8a635d7da98a5fa$var$Safer.alloc) $f8a635d7da98a5fa$var$Safer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError('The "size" argument must be of type number. Received type ' + typeof size);
    if (size < 0 || size >= 2 * 1073741824) throw new RangeError('The value "' + size + '" is invalid for option "size"');
    var buf = $f8a635d7da98a5fa$var$Buffer(size);
    if (!fill || fill.length === 0) buf.fill(0);
    else if (typeof encoding === "string") buf.fill(fill, encoding);
    else buf.fill(fill);
    return buf;
};
if (!$f8a635d7da98a5fa$var$safer.kStringMaxLength) try {
    $f8a635d7da98a5fa$var$safer.kStringMaxLength = $a8i8g.binding("buffer").kStringMaxLength;
} catch (e) {
// we can't determine kStringMaxLength in environments where process.binding
// is unsupported, so let's not set it
}
if (!$f8a635d7da98a5fa$var$safer.constants) {
    $f8a635d7da98a5fa$var$safer.constants = {
        MAX_LENGTH: $f8a635d7da98a5fa$var$safer.kMaxLength
    };
    if ($f8a635d7da98a5fa$var$safer.kStringMaxLength) $f8a635d7da98a5fa$var$safer.constants.MAX_STRING_LENGTH = $f8a635d7da98a5fa$var$safer.kStringMaxLength;
}
module.exports = $f8a635d7da98a5fa$var$safer;

});

parcelRegister("7QW6d", function(module, exports) {
"use strict";

var $ast52 = parcelRequire("ast52");
var $5b7a750945be0fbb$require$Reporter = $ast52.Reporter;

var $ihVF1 = parcelRequire("ihVF1");
var $5b7a750945be0fbb$require$EncoderBuffer = $ihVF1.EncoderBuffer;

var $ihVF1 = parcelRequire("ihVF1");
var $5b7a750945be0fbb$require$DecoderBuffer = $ihVF1.DecoderBuffer;

var $3210N = parcelRequire("3210N");
// Supported tags
const $5b7a750945be0fbb$var$tags = [
    "seq",
    "seqof",
    "set",
    "setof",
    "objid",
    "bool",
    "gentime",
    "utctime",
    "null_",
    "enum",
    "int",
    "objDesc",
    "bitstr",
    "bmpstr",
    "charstr",
    "genstr",
    "graphstr",
    "ia5str",
    "iso646str",
    "numstr",
    "octstr",
    "printstr",
    "t61str",
    "unistr",
    "utf8str",
    "videostr"
];
// Public methods list
const $5b7a750945be0fbb$var$methods = [
    "key",
    "obj",
    "use",
    "optional",
    "explicit",
    "implicit",
    "def",
    "choice",
    "any",
    "contains"
].concat($5b7a750945be0fbb$var$tags);
// Overrided methods list
const $5b7a750945be0fbb$var$overrided = [
    "_peekTag",
    "_decodeTag",
    "_use",
    "_decodeStr",
    "_decodeObjid",
    "_decodeTime",
    "_decodeNull",
    "_decodeInt",
    "_decodeBool",
    "_decodeList",
    "_encodeComposite",
    "_encodeStr",
    "_encodeObjid",
    "_encodeTime",
    "_encodeNull",
    "_encodeInt",
    "_encodeBool"
];
function $5b7a750945be0fbb$var$Node(enc, parent, name) {
    const state = {};
    this._baseState = state;
    state.name = name;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state["default"] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $5b7a750945be0fbb$var$Node;
const $5b7a750945be0fbb$var$stateProps = [
    "enc",
    "parent",
    "children",
    "tag",
    "args",
    "reverseArgs",
    "choice",
    "optional",
    "any",
    "obj",
    "use",
    "alteredUse",
    "key",
    "default",
    "explicit",
    "implicit",
    "contains"
];
$5b7a750945be0fbb$var$Node.prototype.clone = function clone() {
    const state = this._baseState;
    const cstate = {};
    $5b7a750945be0fbb$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    const res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$5b7a750945be0fbb$var$Node.prototype._wrap = function wrap() {
    const state = this._baseState;
    $5b7a750945be0fbb$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            const clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$5b7a750945be0fbb$var$Node.prototype._init = function init(body) {
    const state = this._baseState;
    $3210N(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $3210N.equal(state.children.length, 1, "Root node can have only one child");
};
$5b7a750945be0fbb$var$Node.prototype._useArgs = function useArgs(args) {
    const state = this._baseState;
    // Filter children and args
    const children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $3210N(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $3210N(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== "object" || arg.constructor !== Object) return arg;
            const res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                const value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$5b7a750945be0fbb$var$overrided.forEach(function(method) {
    $5b7a750945be0fbb$var$Node.prototype[method] = function _overrided() {
        const state = this._baseState;
        throw new Error(method + " not implemented for encoding: " + state.enc);
    };
});
//
// Public methods
//
$5b7a750945be0fbb$var$tags.forEach(function(tag) {
    $5b7a750945be0fbb$var$Node.prototype[tag] = function _tagMethod() {
        const state = this._baseState;
        const args = Array.prototype.slice.call(arguments);
        $3210N(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$5b7a750945be0fbb$var$Node.prototype.use = function use(item) {
    $3210N(item);
    const state = this._baseState;
    $3210N(state.use === null);
    state.use = item;
    return this;
};
$5b7a750945be0fbb$var$Node.prototype.optional = function optional() {
    const state = this._baseState;
    state.optional = true;
    return this;
};
$5b7a750945be0fbb$var$Node.prototype.def = function def(val) {
    const state = this._baseState;
    $3210N(state["default"] === null);
    state["default"] = val;
    state.optional = true;
    return this;
};
$5b7a750945be0fbb$var$Node.prototype.explicit = function explicit(num) {
    const state = this._baseState;
    $3210N(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$5b7a750945be0fbb$var$Node.prototype.implicit = function implicit(num) {
    const state = this._baseState;
    $3210N(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$5b7a750945be0fbb$var$Node.prototype.obj = function obj() {
    const state = this._baseState;
    const args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$5b7a750945be0fbb$var$Node.prototype.key = function key(newKey) {
    const state = this._baseState;
    $3210N(state.key === null);
    state.key = newKey;
    return this;
};
$5b7a750945be0fbb$var$Node.prototype.any = function any() {
    const state = this._baseState;
    state.any = true;
    return this;
};
$5b7a750945be0fbb$var$Node.prototype.choice = function choice(obj) {
    const state = this._baseState;
    $3210N(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$5b7a750945be0fbb$var$Node.prototype.contains = function contains(item) {
    const state = this._baseState;
    $3210N(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$5b7a750945be0fbb$var$Node.prototype._decode = function decode(input, options) {
    const state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    let result = state["default"];
    let present = true;
    let prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        let tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            const save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    let prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            const explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        const start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            let save;
            if (state.any) save = input.save();
            const body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, "tagged");
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, "content");
        // Select proper method for tag
        if (state.any) ;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === "octstr" || state.tag === "bitstr")) {
            const data = new $5b7a750945be0fbb$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$5b7a750945be0fbb$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    const state = this._baseState;
    if (tag === "seq" || tag === "set") return null;
    if (tag === "seqof" || tag === "setof") return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === "objid" && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === "objid") return this._decodeObjid(input, null, null, options);
    else if (tag === "gentime" || tag === "utctime") return this._decodeTime(input, tag, options);
    else if (tag === "null_") return this._decodeNull(input, options);
    else if (tag === "bool") return this._decodeBool(input, options);
    else if (tag === "objDesc") return this._decodeStr(input, tag, options);
    else if (tag === "int" || tag === "enum") return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error("unknown tag: " + tag);
};
$5b7a750945be0fbb$var$Node.prototype._getUse = function _getUse(entity, obj) {
    const state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $3210N(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$5b7a750945be0fbb$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    const state = this._baseState;
    let result = null;
    let match = false;
    Object.keys(state.choice).some(function(key) {
        const save = input.save();
        const node = state.choice[key];
        try {
            const value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error("Choice not matched");
    return result;
};
//
// Encoding
//
$5b7a750945be0fbb$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $5b7a750945be0fbb$require$EncoderBuffer(data, this.reporter);
};
$5b7a750945be0fbb$var$Node.prototype._encode = function encode(data, reporter, parent) {
    const state = this._baseState;
    if (state["default"] !== null && state["default"] === data) return;
    const result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$5b7a750945be0fbb$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    const state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $5b7a750945be0fbb$require$Reporter());
    let result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state["default"] !== null) data = state["default"];
        else return;
    }
    // Encode children first
    let content = null;
    let primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === "null_") return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error("Child should have a key");
            const prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== "object") return reporter.error("Child expected, but input is not object");
            const res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === "seqof" || state.tag === "setof") {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error("Too many args for : " + state.tag);
            if (!Array.isArray(data)) return reporter.error("seqof/setof, but data is not Array");
            const child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                const state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    if (!state.any && state.choice === null) {
        const tag = state.implicit !== null ? state.implicit : state.tag;
        const cls = state.implicit === null ? "universal" : "context";
        if (tag === null) {
            if (state.use === null) reporter.error("Tag could be omitted only for .use()");
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, "context", result);
    return result;
};
$5b7a750945be0fbb$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    const state = this._baseState;
    const node = state.choice[data.type];
    if (!node) $3210N(false, data.type + " not found in " + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$5b7a750945be0fbb$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    const state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === "objid" && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === "objid") return this._encodeObjid(data, null, null);
    else if (tag === "gentime" || tag === "utctime") return this._encodeTime(data, tag);
    else if (tag === "null_") return this._encodeNull();
    else if (tag === "int" || tag === "enum") return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === "bool") return this._encodeBool(data);
    else if (tag === "objDesc") return this._encodeStr(data, tag);
    else throw new Error("Unsupported tag: " + tag);
};
$5b7a750945be0fbb$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$5b7a750945be0fbb$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '()+,-./:=?]*$/.test(str);
};

});
parcelRegister("ast52", function(module, exports) {

$parcel$export(module.exports, "Reporter", function () { return $79d313a5b67b4e65$export$957313a2f485e5ed; }, function (v) { return $79d313a5b67b4e65$export$957313a2f485e5ed = v; });
var $79d313a5b67b4e65$export$957313a2f485e5ed;
"use strict";

var $kvFQ5 = parcelRequire("kvFQ5");
function $79d313a5b67b4e65$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$79d313a5b67b4e65$export$957313a2f485e5ed = $79d313a5b67b4e65$var$Reporter;
$79d313a5b67b4e65$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $79d313a5b67b4e65$var$ReporterError;
};
$79d313a5b67b4e65$var$Reporter.prototype.save = function save() {
    const state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$79d313a5b67b4e65$var$Reporter.prototype.restore = function restore(data) {
    const state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$79d313a5b67b4e65$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$79d313a5b67b4e65$var$Reporter.prototype.exitKey = function exitKey(index) {
    const state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$79d313a5b67b4e65$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    const state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$79d313a5b67b4e65$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join("/");
};
$79d313a5b67b4e65$var$Reporter.prototype.enterObject = function enterObject() {
    const state = this._reporterState;
    const prev = state.obj;
    state.obj = {};
    return prev;
};
$79d313a5b67b4e65$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    const state = this._reporterState;
    const now = state.obj;
    state.obj = prev;
    return now;
};
$79d313a5b67b4e65$var$Reporter.prototype.error = function error(msg) {
    let err;
    const state = this._reporterState;
    const inherited = msg instanceof $79d313a5b67b4e65$var$ReporterError;
    if (inherited) err = msg;
    else err = new $79d313a5b67b4e65$var$ReporterError(state.path.map(function(elem) {
        return "[" + JSON.stringify(elem) + "]";
    }).join(""), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$79d313a5b67b4e65$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    const state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $79d313a5b67b4e65$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$kvFQ5($79d313a5b67b4e65$var$ReporterError, Error);
$79d313a5b67b4e65$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + " at: " + (this.path || "(shallow)");
    if (Error.captureStackTrace) Error.captureStackTrace(this, $79d313a5b67b4e65$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRegister("ihVF1", function(module, exports) {

$parcel$export(module.exports, "DecoderBuffer", function () { return $d5068ab600a003c4$export$bf9f79cdc4a49163; }, function (v) { return $d5068ab600a003c4$export$bf9f79cdc4a49163 = v; });
$parcel$export(module.exports, "EncoderBuffer", function () { return $d5068ab600a003c4$export$8ff24f7760c7a78e; }, function (v) { return $d5068ab600a003c4$export$8ff24f7760c7a78e = v; });
var $d5068ab600a003c4$export$bf9f79cdc4a49163;
var $d5068ab600a003c4$export$8ff24f7760c7a78e;
"use strict";

var $kvFQ5 = parcelRequire("kvFQ5");

var $ast52 = parcelRequire("ast52");
var $d5068ab600a003c4$require$Reporter = $ast52.Reporter;

var $llyme = parcelRequire("llyme");
var $d5068ab600a003c4$require$Buffer = $llyme.Buffer;
function $d5068ab600a003c4$var$DecoderBuffer(base, options) {
    $d5068ab600a003c4$require$Reporter.call(this, options);
    if (!$d5068ab600a003c4$require$Buffer.isBuffer(base)) {
        this.error("Input not Buffer");
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$kvFQ5($d5068ab600a003c4$var$DecoderBuffer, $d5068ab600a003c4$require$Reporter);
$d5068ab600a003c4$export$bf9f79cdc4a49163 = $d5068ab600a003c4$var$DecoderBuffer;
$d5068ab600a003c4$var$DecoderBuffer.isDecoderBuffer = function isDecoderBuffer(data) {
    if (data instanceof $d5068ab600a003c4$var$DecoderBuffer) return true;
    // Or accept compatible API
    const isCompatible = typeof data === "object" && $d5068ab600a003c4$require$Buffer.isBuffer(data.base) && data.constructor.name === "DecoderBuffer" && typeof data.offset === "number" && typeof data.length === "number" && typeof data.save === "function" && typeof data.restore === "function" && typeof data.isEmpty === "function" && typeof data.readUInt8 === "function" && typeof data.skip === "function" && typeof data.raw === "function";
    return isCompatible;
};
$d5068ab600a003c4$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $d5068ab600a003c4$require$Reporter.prototype.save.call(this)
    };
};
$d5068ab600a003c4$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    const res = new $d5068ab600a003c4$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $d5068ab600a003c4$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$d5068ab600a003c4$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$d5068ab600a003c4$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || "DecoderBuffer overrun");
};
$d5068ab600a003c4$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || "DecoderBuffer overrun");
    const res = new $d5068ab600a003c4$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$d5068ab600a003c4$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $d5068ab600a003c4$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!$d5068ab600a003c4$var$EncoderBuffer.isEncoderBuffer(item)) item = new $d5068ab600a003c4$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === "number") {
        if (!(0 <= value && value <= 0xff)) return reporter.error("non-byte EncoderBuffer value");
        this.value = value;
        this.length = 1;
    } else if (typeof value === "string") {
        this.value = value;
        this.length = $d5068ab600a003c4$require$Buffer.byteLength(value);
    } else if ($d5068ab600a003c4$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error("Unsupported type: " + typeof value);
}
$d5068ab600a003c4$export$8ff24f7760c7a78e = $d5068ab600a003c4$var$EncoderBuffer;
$d5068ab600a003c4$var$EncoderBuffer.isEncoderBuffer = function isEncoderBuffer(data) {
    if (data instanceof $d5068ab600a003c4$var$EncoderBuffer) return true;
    // Or accept compatible API
    const isCompatible = typeof data === "object" && data.constructor.name === "EncoderBuffer" && typeof data.length === "number" && typeof data.join === "function";
    return isCompatible;
};
$d5068ab600a003c4$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = $d5068ab600a003c4$require$Buffer.alloc(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === "number") out[offset] = this.value;
        else if (typeof this.value === "string") out.write(this.value, offset);
        else if ($d5068ab600a003c4$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});


parcelRegister("1P4FE", function(module, exports) {

$parcel$export(module.exports, "tagClass", function () { return $153e2d5dec6f0c65$export$3584c46ed60baee8; }, function (v) { return $153e2d5dec6f0c65$export$3584c46ed60baee8 = v; });
$parcel$export(module.exports, "tagClassByName", function () { return $153e2d5dec6f0c65$export$f18596ef8d632e49; }, function (v) { return $153e2d5dec6f0c65$export$f18596ef8d632e49 = v; });
$parcel$export(module.exports, "tag", function () { return $153e2d5dec6f0c65$export$2b067c6666111485; }, function (v) { return $153e2d5dec6f0c65$export$2b067c6666111485 = v; });
$parcel$export(module.exports, "tagByName", function () { return $153e2d5dec6f0c65$export$f17df38a421ab9e3; }, function (v) { return $153e2d5dec6f0c65$export$f17df38a421ab9e3 = v; });
var $153e2d5dec6f0c65$export$3584c46ed60baee8;
var $153e2d5dec6f0c65$export$f18596ef8d632e49;
var $153e2d5dec6f0c65$export$2b067c6666111485;
var $153e2d5dec6f0c65$export$f17df38a421ab9e3;
"use strict";
// Helper
function $153e2d5dec6f0c65$var$reverse(map) {
    const res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        const value = map[key];
        res[value] = key;
    });
    return res;
}
$153e2d5dec6f0c65$export$3584c46ed60baee8 = {
    0: "universal",
    1: "application",
    2: "context",
    3: "private"
};
$153e2d5dec6f0c65$export$f18596ef8d632e49 = $153e2d5dec6f0c65$var$reverse($153e2d5dec6f0c65$export$3584c46ed60baee8);
$153e2d5dec6f0c65$export$2b067c6666111485 = {
    0x00: "end",
    0x01: "bool",
    0x02: "int",
    0x03: "bitstr",
    0x04: "octstr",
    0x05: "null_",
    0x06: "objid",
    0x07: "objDesc",
    0x08: "external",
    0x09: "real",
    0x0a: "enum",
    0x0b: "embed",
    0x0c: "utf8str",
    0x0d: "relativeOid",
    0x10: "seq",
    0x11: "set",
    0x12: "numstr",
    0x13: "printstr",
    0x14: "t61str",
    0x15: "videostr",
    0x16: "ia5str",
    0x17: "utctime",
    0x18: "gentime",
    0x19: "graphstr",
    0x1a: "iso646str",
    0x1b: "genstr",
    0x1c: "unistr",
    0x1d: "charstr",
    0x1e: "bmpstr"
};
$153e2d5dec6f0c65$export$f17df38a421ab9e3 = $153e2d5dec6f0c65$var$reverse($153e2d5dec6f0c65$export$2b067c6666111485);

});


parcelRegister("WTsXi", function(module, exports) {
"use strict";

var $kvFQ5 = parcelRequire("kvFQ5");

var $h7Jar = parcelRequire("h7Jar");
function $0b10714a982dfbe8$var$PEMEncoder(entity) {
    $h7Jar.call(this, entity);
    this.enc = "pem";
}
$kvFQ5($0b10714a982dfbe8$var$PEMEncoder, $h7Jar);
module.exports = $0b10714a982dfbe8$var$PEMEncoder;
$0b10714a982dfbe8$var$PEMEncoder.prototype.encode = function encode(data, options) {
    const buf = $h7Jar.prototype.encode.call(this, data);
    const p = buf.toString("base64");
    const out = [
        "-----BEGIN " + options.label + "-----"
    ];
    for(let i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push("-----END " + options.label + "-----");
    return out.join("\n");
};

});


parcelRegister("b68Bf", function(module, exports) {
"use strict";
const $8146ecfcca4b3b3d$var$decoders = module.exports;

$8146ecfcca4b3b3d$var$decoders.der = (parcelRequire("eCZe2"));

$8146ecfcca4b3b3d$var$decoders.pem = (parcelRequire("63ZJM"));

});
parcelRegister("eCZe2", function(module, exports) {
"use strict";

var $kvFQ5 = parcelRequire("kvFQ5");

var $l3iV2 = parcelRequire("l3iV2");

var $ihVF1 = parcelRequire("ihVF1");
var $aa641b60233548d4$require$DecoderBuffer = $ihVF1.DecoderBuffer;

var $7QW6d = parcelRequire("7QW6d");

var $1P4FE = parcelRequire("1P4FE");
function $aa641b60233548d4$var$DERDecoder(entity) {
    this.enc = "der";
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $aa641b60233548d4$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $aa641b60233548d4$var$DERDecoder;
$aa641b60233548d4$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!$aa641b60233548d4$require$DecoderBuffer.isDecoderBuffer(data)) data = new $aa641b60233548d4$require$DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $aa641b60233548d4$var$DERNode(parent) {
    $7QW6d.call(this, "der", parent);
}
$kvFQ5($aa641b60233548d4$var$DERNode, $7QW6d);
$aa641b60233548d4$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    const state = buffer.save();
    const decodedTag = $aa641b60233548d4$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + "of" === tag || any;
};
$aa641b60233548d4$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    const decodedTag = $aa641b60233548d4$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    let len = $aa641b60233548d4$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + "of" !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    const state = buffer.save();
    const res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$aa641b60233548d4$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    for(;;){
        const tag = $aa641b60233548d4$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        const len = $aa641b60233548d4$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        let res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === "end") break;
    }
};
$aa641b60233548d4$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    const result = [];
    while(!buffer.isEmpty()){
        const possibleEnd = this._peekTag(buffer, "end");
        if (buffer.isError(possibleEnd)) return possibleEnd;
        const res = decoder.decode(buffer, "der", options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$aa641b60233548d4$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === "bitstr") {
        const unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === "bmpstr") {
        const raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error("Decoding of string type: bmpstr length mismatch");
        let str = "";
        for(let i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === "numstr") {
        const numstr = buffer.raw().toString("ascii");
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === "octstr") return buffer.raw();
    else if (tag === "objDesc") return buffer.raw();
    else if (tag === "printstr") {
        const printstr = buffer.raw().toString("ascii");
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error("Decoding of string type: " + tag + " unsupported");
};
$aa641b60233548d4$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    let result;
    const identifiers = [];
    let ident = 0;
    let subident = 0;
    while(!buffer.isEmpty()){
        subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    const first = identifiers[0] / 40 | 0;
    const second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        let tmp = values[result.join(" ")];
        if (tmp === undefined) tmp = values[result.join(".")];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$aa641b60233548d4$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    const str = buffer.raw().toString();
    let year;
    let mon;
    let day;
    let hour;
    let min;
    let sec;
    if (tag === "gentime") {
        year = str.slice(0, 4) | 0;
        mon = str.slice(4, 6) | 0;
        day = str.slice(6, 8) | 0;
        hour = str.slice(8, 10) | 0;
        min = str.slice(10, 12) | 0;
        sec = str.slice(12, 14) | 0;
    } else if (tag === "utctime") {
        year = str.slice(0, 2) | 0;
        mon = str.slice(2, 4) | 0;
        day = str.slice(4, 6) | 0;
        hour = str.slice(6, 8) | 0;
        min = str.slice(8, 10) | 0;
        sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error("Decoding " + tag + " time is not supported yet");
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$aa641b60233548d4$var$DERNode.prototype._decodeNull = function decodeNull() {
    return null;
};
$aa641b60233548d4$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    const res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$aa641b60233548d4$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    const raw = buffer.raw();
    let res = new $l3iV2(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$aa641b60233548d4$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === "function") entity = entity(obj);
    return entity._getDecoder("der").tree;
};
// Utility methods
function $aa641b60233548d4$var$derDecodeTag(buf, fail) {
    let tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    const cls = $1P4FE.tagClass[tag >> 6];
    const primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        let oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    const tagStr = $1P4FE.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $aa641b60233548d4$var$derDecodeLen(buf, primitive, fail) {
    let len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    const num = len & 0x7f;
    if (num > 4) return buf.error("length octect is too long");
    len = 0;
    for(let i = 0; i < num; i++){
        len <<= 8;
        const j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRegister("63ZJM", function(module, exports) {
"use strict";

var $kvFQ5 = parcelRequire("kvFQ5");

var $llyme = parcelRequire("llyme");
var $46a2e9a1a8efddd7$require$Buffer = $llyme.Buffer;

var $eCZe2 = parcelRequire("eCZe2");
function $46a2e9a1a8efddd7$var$PEMDecoder(entity) {
    $eCZe2.call(this, entity);
    this.enc = "pem";
}
$kvFQ5($46a2e9a1a8efddd7$var$PEMDecoder, $eCZe2);
module.exports = $46a2e9a1a8efddd7$var$PEMDecoder;
$46a2e9a1a8efddd7$var$PEMDecoder.prototype.decode = function decode(data, options) {
    const lines = data.toString().split(/[\r\n]+/g);
    const label = options.label.toUpperCase();
    const re = /^-----(BEGIN|END) ([^-]+)-----$/;
    let start = -1;
    let end = -1;
    for(let i = 0; i < lines.length; i++){
        const match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== "BEGIN") break;
            start = i;
        } else {
            if (match[1] !== "END") break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error("PEM section not found for: " + label);
    const base64 = lines.slice(start + 1, end).join("");
    // Remove excessive symbols
    base64.replace(/[^a-z0-9+/=]+/gi, "");
    const input = $46a2e9a1a8efddd7$require$Buffer.from(base64, "base64");
    return $eCZe2.prototype.decode.call(this, input, options);
};

});



parcelRegister("bMHL7", function(module, exports) {
"use strict";
const $89461f04cb258e33$var$base = module.exports;

$89461f04cb258e33$var$base.Reporter = (parcelRequire("ast52")).Reporter;

$89461f04cb258e33$var$base.DecoderBuffer = (parcelRequire("ihVF1")).DecoderBuffer;

$89461f04cb258e33$var$base.EncoderBuffer = (parcelRequire("ihVF1")).EncoderBuffer;

$89461f04cb258e33$var$base.Node = (parcelRequire("7QW6d"));

});

parcelRegister("aySCC", function(module, exports) {
"use strict";
const $7b07732185da525c$var$constants = module.exports;
// Helper
$7b07732185da525c$var$constants._reverse = function reverse(map) {
    const res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        const value = map[key];
        res[value] = key;
    });
    return res;
};

$7b07732185da525c$var$constants.der = (parcelRequire("1P4FE"));

});


parcelRegister("jOtxC", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
"use strict";

var $72Zbf = parcelRequire("72Zbf");
var $e6c99a1ea7bbba53$var$Time = $72Zbf.define("Time", function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $e6c99a1ea7bbba53$var$AttributeTypeValue = $72Zbf.define("AttributeTypeValue", function() {
    this.seq().obj(this.key("type").objid(), this.key("value").any());
});
var $e6c99a1ea7bbba53$var$AlgorithmIdentifier = $72Zbf.define("AlgorithmIdentifier", function() {
    this.seq().obj(this.key("algorithm").objid(), this.key("parameters").optional(), this.key("curve").objid().optional());
});
var $e6c99a1ea7bbba53$var$SubjectPublicKeyInfo = $72Zbf.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(this.key("algorithm").use($e6c99a1ea7bbba53$var$AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
var $e6c99a1ea7bbba53$var$RelativeDistinguishedName = $72Zbf.define("RelativeDistinguishedName", function() {
    this.setof($e6c99a1ea7bbba53$var$AttributeTypeValue);
});
var $e6c99a1ea7bbba53$var$RDNSequence = $72Zbf.define("RDNSequence", function() {
    this.seqof($e6c99a1ea7bbba53$var$RelativeDistinguishedName);
});
var $e6c99a1ea7bbba53$var$Name = $72Zbf.define("Name", function() {
    this.choice({
        rdnSequence: this.use($e6c99a1ea7bbba53$var$RDNSequence)
    });
});
var $e6c99a1ea7bbba53$var$Validity = $72Zbf.define("Validity", function() {
    this.seq().obj(this.key("notBefore").use($e6c99a1ea7bbba53$var$Time), this.key("notAfter").use($e6c99a1ea7bbba53$var$Time));
});
var $e6c99a1ea7bbba53$var$Extension = $72Zbf.define("Extension", function() {
    this.seq().obj(this.key("extnID").objid(), this.key("critical").bool().def(false), this.key("extnValue").octstr());
});
var $e6c99a1ea7bbba53$var$TBSCertificate = $72Zbf.define("TBSCertificate", function() {
    this.seq().obj(this.key("version").explicit(0).int().optional(), this.key("serialNumber").int(), this.key("signature").use($e6c99a1ea7bbba53$var$AlgorithmIdentifier), this.key("issuer").use($e6c99a1ea7bbba53$var$Name), this.key("validity").use($e6c99a1ea7bbba53$var$Validity), this.key("subject").use($e6c99a1ea7bbba53$var$Name), this.key("subjectPublicKeyInfo").use($e6c99a1ea7bbba53$var$SubjectPublicKeyInfo), this.key("issuerUniqueID").implicit(1).bitstr().optional(), this.key("subjectUniqueID").implicit(2).bitstr().optional(), this.key("extensions").explicit(3).seqof($e6c99a1ea7bbba53$var$Extension).optional());
});
var $e6c99a1ea7bbba53$var$X509Certificate = $72Zbf.define("X509Certificate", function() {
    this.seq().obj(this.key("tbsCertificate").use($e6c99a1ea7bbba53$var$TBSCertificate), this.key("signatureAlgorithm").use($e6c99a1ea7bbba53$var$AlgorithmIdentifier), this.key("signatureValue").bitstr());
});
module.exports = $e6c99a1ea7bbba53$var$X509Certificate;

});


parcelRegister("l6piA", function(module, exports) {
module.exports = JSON.parse('{"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}');

});

parcelRegister("lNx08", function(module, exports) {
// adapted from https://github.com/apatil/pemstrip
var $fde7c5ea23ad27b4$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var $fde7c5ea23ad27b4$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var $fde7c5ea23ad27b4$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;

var $bFXtK = parcelRequire("bFXtK");

var $X9qDO = parcelRequire("X9qDO");

var $eN0t8 = parcelRequire("eN0t8");
var $fde7c5ea23ad27b4$require$Buffer = $eN0t8.Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($fde7c5ea23ad27b4$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($fde7c5ea23ad27b4$var$fullRegex);
        decrypted = $fde7c5ea23ad27b4$require$Buffer.from(match2[2].replace(/[\r\n]/g, ""), "base64");
    } else {
        var suite = "aes" + match[1];
        var iv = $fde7c5ea23ad27b4$require$Buffer.from(match[2], "hex");
        var cipherText = $fde7c5ea23ad27b4$require$Buffer.from(match[3].replace(/[\r\n]/g, ""), "base64");
        var cipherKey = $bFXtK(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $X9qDO.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher.final());
        decrypted = $fde7c5ea23ad27b4$require$Buffer.concat(out);
    }
    var tag = key.match($fde7c5ea23ad27b4$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});


parcelRegister("d3wjz", function(module, exports) {
module.exports = JSON.parse('{"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}');

});


parcelRegister("bLWjI", function(module, exports) {
"use strict";

var $eN0t8 = parcelRequire("eN0t8");
var $8921520de794f4c4$require$Buffer = $eN0t8.Buffer;

var $jlWHo = parcelRequire("jlWHo");

var $492wS = parcelRequire("492wS");
var $8921520de794f4c4$require$EC = $492wS.ec;

var $5nDla = parcelRequire("5nDla");

var $d3wjz = parcelRequire("d3wjz");
function $8921520de794f4c4$var$verify(sig, hash, key, signType, tag) {
    var pub = $5nDla(key);
    if (pub.type === "ec") {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== "ecdsa" && signType !== "ecdsa/rsa") throw new Error("wrong public key type");
        return $8921520de794f4c4$var$ecVerify(sig, hash, pub);
    } else if (pub.type === "dsa") {
        if (signType !== "dsa") throw new Error("wrong public key type");
        return $8921520de794f4c4$var$dsaVerify(sig, hash, pub);
    }
    if (signType !== "rsa" && signType !== "ecdsa/rsa") throw new Error("wrong public key type");
    hash = $8921520de794f4c4$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum += 1;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = $8921520de794f4c4$require$Buffer.from(pad);
    var red = $jlWHo.mont(pub.modulus);
    sig = new $jlWHo(sig).toRed(red);
    sig = sig.redPow(new $jlWHo(pub.publicExponent));
    sig = $8921520de794f4c4$require$Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $8921520de794f4c4$var$ecVerify(sig, hash, pub) {
    var curveId = $d3wjz[pub.data.algorithm.curve.join(".")];
    if (!curveId) throw new Error("unknown curve " + pub.data.algorithm.curve.join("."));
    var curve = new $8921520de794f4c4$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $8921520de794f4c4$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $5nDla.signature.decode(sig, "der");
    var s = unpacked.s;
    var r = unpacked.r;
    $8921520de794f4c4$var$checkValue(s, q);
    $8921520de794f4c4$var$checkValue(r, q);
    var montp = $jlWHo.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $jlWHo(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $8921520de794f4c4$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error("invalid sig");
    if (b.cmp(q) >= 0) throw new Error("invalid sig");
}
module.exports = $8921520de794f4c4$var$verify;

});


parcelRegister("5NdVi", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $437c543735380863$require$Buffer = $gzLuY.Buffer;

var $492wS = parcelRequire("492wS");

var $fxQnv = parcelRequire("fxQnv");
module.exports = function createECDH(curve) {
    return new $437c543735380863$var$ECDH(curve);
};
var $437c543735380863$var$aliases = {
    secp256k1: {
        name: "secp256k1",
        byteLength: 32
    },
    secp224r1: {
        name: "p224",
        byteLength: 28
    },
    prime256v1: {
        name: "p256",
        byteLength: 32
    },
    prime192v1: {
        name: "p192",
        byteLength: 24
    },
    ed25519: {
        name: "ed25519",
        byteLength: 32
    },
    secp384r1: {
        name: "p384",
        byteLength: 48
    },
    secp521r1: {
        name: "p521",
        byteLength: 66
    }
};
$437c543735380863$var$aliases.p224 = $437c543735380863$var$aliases.secp224r1;
$437c543735380863$var$aliases.p256 = $437c543735380863$var$aliases.secp256r1 = $437c543735380863$var$aliases.prime256v1;
$437c543735380863$var$aliases.p192 = $437c543735380863$var$aliases.secp192r1 = $437c543735380863$var$aliases.prime192v1;
$437c543735380863$var$aliases.p384 = $437c543735380863$var$aliases.secp384r1;
$437c543735380863$var$aliases.p521 = $437c543735380863$var$aliases.secp521r1;
function $437c543735380863$var$ECDH(curve) {
    this.curveType = $437c543735380863$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $492wS.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
$437c543735380863$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$437c543735380863$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || "utf8";
    if (!$437c543735380863$require$Buffer.isBuffer(other)) other = new $437c543735380863$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $437c543735380863$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$437c543735380863$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === "compressed", true);
    if (format === "hybrid") {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $437c543735380863$var$formatReturnValue(key, enc);
};
$437c543735380863$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $437c543735380863$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$437c543735380863$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || "utf8";
    if (!$437c543735380863$require$Buffer.isBuffer(pub)) pub = new $437c543735380863$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$437c543735380863$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || "utf8";
    if (!$437c543735380863$require$Buffer.isBuffer(priv)) priv = new $437c543735380863$require$Buffer(priv, enc);
    var _priv = new $fxQnv(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function $437c543735380863$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $437c543735380863$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $437c543735380863$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $437c543735380863$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});
parcelRegister("fxQnv", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("aqbQf")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("0oOUq", function(module, exports) {

$parcel$export(module.exports, "publicEncrypt", function () { return $001340f5b02c20b3$export$512823e338ddb1b7; }, function (v) { return $001340f5b02c20b3$export$512823e338ddb1b7 = v; });
$parcel$export(module.exports, "privateDecrypt", function () { return $001340f5b02c20b3$export$7efb24e2fddf99b9; }, function (v) { return $001340f5b02c20b3$export$7efb24e2fddf99b9 = v; });
$parcel$export(module.exports, "privateEncrypt", function () { return $001340f5b02c20b3$export$9d0e0c0c4a8d30f3; }, function (v) { return $001340f5b02c20b3$export$9d0e0c0c4a8d30f3 = v; });
$parcel$export(module.exports, "publicDecrypt", function () { return $001340f5b02c20b3$export$b9d55ff329113abd; }, function (v) { return $001340f5b02c20b3$export$b9d55ff329113abd = v; });
var $001340f5b02c20b3$export$512823e338ddb1b7;
var $001340f5b02c20b3$export$7efb24e2fddf99b9;
var $001340f5b02c20b3$export$9d0e0c0c4a8d30f3;
var $001340f5b02c20b3$export$b9d55ff329113abd;

$001340f5b02c20b3$export$512823e338ddb1b7 = (parcelRequire("gsjO5"));

$001340f5b02c20b3$export$7efb24e2fddf99b9 = (parcelRequire("jxvLt"));
$001340f5b02c20b3$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $001340f5b02c20b3$export$512823e338ddb1b7(key, buf, true);
};
$001340f5b02c20b3$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $001340f5b02c20b3$export$7efb24e2fddf99b9(key, buf, true);
};

});
parcelRegister("gsjO5", function(module, exports) {

var $5nDla = parcelRequire("5nDla");

var $dKHN6 = parcelRequire("dKHN6");

var $j8bQA = parcelRequire("j8bQA");

var $cENfq = parcelRequire("cENfq");

var $jjFgv = parcelRequire("jjFgv");

var $10Loz = parcelRequire("10Loz");

var $5Lq0b = parcelRequire("5Lq0b");

var $lp4ea = parcelRequire("lp4ea");

var $eN0t8 = parcelRequire("eN0t8");
var $bfaea013f2020bc9$require$Buffer = $eN0t8.Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $5nDla(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = $bfaea013f2020bc9$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $bfaea013f2020bc9$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $10Loz(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error("data too long for modulus");
    } else throw new Error("unknown padding");
    if (reverse) return $lp4ea(paddedMsg, key);
    else return $5Lq0b(paddedMsg, key);
};
function $bfaea013f2020bc9$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $j8bQA("sha1").update($bfaea013f2020bc9$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error("message too long");
    var ps = $bfaea013f2020bc9$require$Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = $dKHN6(hLen);
    var maskedDb = $jjFgv($bfaea013f2020bc9$require$Buffer.concat([
        iHash,
        ps,
        $bfaea013f2020bc9$require$Buffer.alloc(1, 1),
        msg
    ], dblen), $cENfq(seed, dblen));
    var maskedSeed = $jjFgv(seed, $cENfq(maskedDb, hLen));
    return new $10Loz($bfaea013f2020bc9$require$Buffer.concat([
        $bfaea013f2020bc9$require$Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function $bfaea013f2020bc9$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error("message too long");
    var ps;
    if (reverse) ps = $bfaea013f2020bc9$require$Buffer.alloc(k - mLen - 3, 0xff);
    else ps = $bfaea013f2020bc9$var$nonZero(k - mLen - 3);
    return new $10Loz($bfaea013f2020bc9$require$Buffer.concat([
        $bfaea013f2020bc9$require$Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        $bfaea013f2020bc9$require$Buffer.alloc(1),
        msg
    ], k));
}
function $bfaea013f2020bc9$var$nonZero(len) {
    var out = $bfaea013f2020bc9$require$Buffer.allocUnsafe(len);
    var i = 0;
    var cache = $dKHN6(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $dKHN6(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRegister("cENfq", function(module, exports) {

var $j8bQA = parcelRequire("j8bQA");

var $eN0t8 = parcelRequire("eN0t8");
var $936f6c09fcfea8b6$require$Buffer = $eN0t8.Buffer;
module.exports = function(seed, len) {
    var t = $936f6c09fcfea8b6$require$Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = $936f6c09fcfea8b6$var$i2ops(i++);
        t = $936f6c09fcfea8b6$require$Buffer.concat([
            t,
            $j8bQA("sha1").update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $936f6c09fcfea8b6$var$i2ops(c) {
    var out = $936f6c09fcfea8b6$require$Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRegister("jjFgv", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRegister("10Loz", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("aqbQf")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("5Lq0b", function(module, exports) {

var $10Loz = parcelRequire("10Loz");

var $eN0t8 = parcelRequire("eN0t8");
var $432582f90dfc1d58$require$Buffer = $eN0t8.Buffer;
function $432582f90dfc1d58$var$withPublic(paddedMsg, key) {
    return $432582f90dfc1d58$require$Buffer.from(paddedMsg.toRed($10Loz.mont(key.modulus)).redPow(new $10Loz(key.publicExponent)).fromRed().toArray());
}
module.exports = $432582f90dfc1d58$var$withPublic;

});


parcelRegister("jxvLt", function(module, exports) {

var $5nDla = parcelRequire("5nDla");

var $cENfq = parcelRequire("cENfq");

var $jjFgv = parcelRequire("jjFgv");

var $10Loz = parcelRequire("10Loz");

var $lp4ea = parcelRequire("lp4ea");

var $j8bQA = parcelRequire("j8bQA");

var $5Lq0b = parcelRequire("5Lq0b");

var $eN0t8 = parcelRequire("eN0t8");
var $e399bd346b5f538e$require$Buffer = $eN0t8.Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $5nDla(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $10Loz(enc).cmp(key.modulus) >= 0) throw new Error("decryption error");
    var msg;
    if (reverse) msg = $5Lq0b(new $10Loz(enc), key);
    else msg = $lp4ea(enc, key);
    var zBuffer = $e399bd346b5f538e$require$Buffer.alloc(k - msg.length);
    msg = $e399bd346b5f538e$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $e399bd346b5f538e$var$oaep(key, msg);
    else if (padding === 1) return $e399bd346b5f538e$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error("unknown padding");
};
function $e399bd346b5f538e$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = $j8bQA("sha1").update($e399bd346b5f538e$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error("decryption error");
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $jjFgv(maskedSeed, $cENfq(maskedDb, hLen));
    var db = $jjFgv(maskedDb, $cENfq(seed, k - hLen - 1));
    if ($e399bd346b5f538e$var$compare(iHash, db.slice(0, hLen))) throw new Error("decryption error");
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error("decryption error");
    return db.slice(i);
}
function $e399bd346b5f538e$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString("hex") !== "0002" && !reverse || p1.toString("hex") !== "0001" && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error("decryption error");
    return msg.slice(i);
}
function $e399bd346b5f538e$var$compare(a, b) {
    a = $e399bd346b5f538e$require$Buffer.from(a);
    b = $e399bd346b5f538e$require$Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});


parcelRegister("7WGbB", function(module, exports) {

$parcel$export(module.exports, "randomFill", function () { return $5c8eac7a23417e30$export$bb1abf2ce84fc7e8; }, function (v) { return $5c8eac7a23417e30$export$bb1abf2ce84fc7e8 = v; });
$parcel$export(module.exports, "randomFillSync", function () { return $5c8eac7a23417e30$export$2f7171e78e524d5e; }, function (v) { return $5c8eac7a23417e30$export$2f7171e78e524d5e = v; });
var $5c8eac7a23417e30$export$bb1abf2ce84fc7e8;
var $5c8eac7a23417e30$export$2f7171e78e524d5e;

var $a8i8g = parcelRequire("a8i8g");
"use strict";
function $5c8eac7a23417e30$var$oldBrowser() {
    throw new Error("secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11");
}

var $eN0t8 = parcelRequire("eN0t8");

var $dKHN6 = parcelRequire("dKHN6");
var $5c8eac7a23417e30$var$Buffer = $eN0t8.Buffer;
var $5c8eac7a23417e30$var$kBufferMaxLength = $eN0t8.kMaxLength;
var $5c8eac7a23417e30$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $5c8eac7a23417e30$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $5c8eac7a23417e30$var$assertOffset(offset, length) {
    if (typeof offset !== "number" || offset !== offset) throw new TypeError("offset must be a number");
    if (offset > $5c8eac7a23417e30$var$kMaxUint32 || offset < 0) throw new TypeError("offset must be a uint32");
    if (offset > $5c8eac7a23417e30$var$kBufferMaxLength || offset > length) throw new RangeError("offset out of range");
}
function $5c8eac7a23417e30$var$assertSize(size, offset, length) {
    if (typeof size !== "number" || size !== size) throw new TypeError("size must be a number");
    if (size > $5c8eac7a23417e30$var$kMaxUint32 || size < 0) throw new TypeError("size must be a uint32");
    if (size + offset > length || size > $5c8eac7a23417e30$var$kBufferMaxLength) throw new RangeError("buffer too small");
}
if ($5c8eac7a23417e30$var$crypto && $5c8eac7a23417e30$var$crypto.getRandomValues || false) {
    $5c8eac7a23417e30$export$bb1abf2ce84fc7e8 = $5c8eac7a23417e30$var$randomFill;
    $5c8eac7a23417e30$export$2f7171e78e524d5e = $5c8eac7a23417e30$var$randomFillSync;
} else {
    $5c8eac7a23417e30$export$bb1abf2ce84fc7e8 = $5c8eac7a23417e30$var$oldBrowser;
    $5c8eac7a23417e30$export$2f7171e78e524d5e = $5c8eac7a23417e30$var$oldBrowser;
}
function $5c8eac7a23417e30$var$randomFill(buf, offset, size, cb) {
    if (!$5c8eac7a23417e30$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === "function") {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === "function") {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== "function") throw new TypeError('"cb" argument must be a function');
    $5c8eac7a23417e30$var$assertOffset(offset, buf.length);
    $5c8eac7a23417e30$var$assertSize(size, offset, buf.length);
    return $5c8eac7a23417e30$var$actualFill(buf, offset, size, cb);
}
function $5c8eac7a23417e30$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $5c8eac7a23417e30$var$crypto.getRandomValues(uint);
    if (cb) {
        $a8i8g.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $dKHN6(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $dKHN6(size);
    bytes.copy(buf, offset);
    return buf;
}
function $5c8eac7a23417e30$var$randomFillSync(buf, offset, size) {
    if (typeof offset === "undefined") offset = 0;
    if (!$5c8eac7a23417e30$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $5c8eac7a23417e30$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $5c8eac7a23417e30$var$assertSize(size, offset, buf.length);
    return $5c8eac7a23417e30$var$actualFill(buf, offset, size);
}

});




parcelRegister("lubYL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.findAttribute = module.exports.parseRawLog = module.exports.parseLogs = module.exports.parseLog = module.exports.parseEvent = module.exports.parseAttribute = void 0;

var $F6P8J = parcelRequire("F6P8J");
function $fa45b117792c12b8$var$parseAttribute(input) {
    if (!(0, $F6P8J.isNonNullObject)(input)) throw new Error("Attribute must be a non-null object");
    const { key: key, value: value } = input;
    if (typeof key !== "string" || !key) throw new Error("Attribute's key must be a non-empty string");
    if (typeof value !== "string" && typeof value !== "undefined") throw new Error("Attribute's value must be a string or unset");
    return {
        key: key,
        value: value || ""
    };
}
module.exports.parseAttribute = $fa45b117792c12b8$var$parseAttribute;
function $fa45b117792c12b8$var$parseEvent(input) {
    if (!(0, $F6P8J.isNonNullObject)(input)) throw new Error("Event must be a non-null object");
    const { type: type, attributes: attributes } = input;
    if (typeof type !== "string" || type === "") throw new Error(`Event type must be a non-empty string`);
    if (!Array.isArray(attributes)) throw new Error("Event's attributes must be an array");
    return {
        type: type,
        attributes: attributes.map($fa45b117792c12b8$var$parseAttribute)
    };
}
module.exports.parseEvent = $fa45b117792c12b8$var$parseEvent;
function $fa45b117792c12b8$var$parseLog(input) {
    if (!(0, $F6P8J.isNonNullObject)(input)) throw new Error("Log must be a non-null object");
    const { msg_index: msg_index, log: log, events: events } = input;
    if (typeof msg_index !== "number") throw new Error("Log's msg_index must be a number");
    if (typeof log !== "string") throw new Error("Log's log must be a string");
    if (!Array.isArray(events)) throw new Error("Log's events must be an array");
    return {
        msg_index: msg_index,
        log: log,
        events: events.map($fa45b117792c12b8$var$parseEvent)
    };
}
module.exports.parseLog = $fa45b117792c12b8$var$parseLog;
function $fa45b117792c12b8$var$parseLogs(input) {
    if (!Array.isArray(input)) throw new Error("Logs must be an array");
    return input.map($fa45b117792c12b8$var$parseLog);
}
module.exports.parseLogs = $fa45b117792c12b8$var$parseLogs;
function $fa45b117792c12b8$var$parseRawLog(input = "[]") {
    const logsToParse = JSON.parse(input).map(({ events: events }, i)=>({
            msg_index: i,
            events: events,
            log: ""
        }));
    return $fa45b117792c12b8$var$parseLogs(logsToParse);
}
module.exports.parseRawLog = $fa45b117792c12b8$var$parseRawLog;
/**
 * Searches in logs for the first event of the given event type and in that event
 * for the first first attribute with the given attribute key.
 *
 * Throws if the attribute was not found.
 */ function $fa45b117792c12b8$var$findAttribute(logs, eventType, attrKey) {
    var _a;
    const firstLogs = logs.find(()=>true);
    const out = (_a = firstLogs === null || firstLogs === void 0 ? void 0 : firstLogs.events.find((event)=>event.type === eventType)) === null || _a === void 0 ? void 0 : _a.attributes.find((attr)=>attr.key === attrKey);
    if (!out) throw new Error(`Could not find attribute '${attrKey}' in first event of type '${eventType}' in first log.`);
    return out;
}
module.exports.findAttribute = $fa45b117792c12b8$var$findAttribute;

});
parcelRegister("F6P8J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isUint8Array = module.exports.isNonNullObject = module.exports.sleep = module.exports.assertDefinedAndNotNull = module.exports.assertDefined = module.exports.assert = module.exports.arrayContentStartsWith = module.exports.arrayContentEquals = void 0;

var $bqxvK = parcelRequire("bqxvK");
Object.defineProperty(module.exports, "arrayContentEquals", {
    enumerable: true,
    get: function() {
        return $bqxvK.arrayContentEquals;
    }
});
Object.defineProperty(module.exports, "arrayContentStartsWith", {
    enumerable: true,
    get: function() {
        return $bqxvK.arrayContentStartsWith;
    }
});

var $dTOjE = parcelRequire("dTOjE");
Object.defineProperty(module.exports, "assert", {
    enumerable: true,
    get: function() {
        return $dTOjE.assert;
    }
});
Object.defineProperty(module.exports, "assertDefined", {
    enumerable: true,
    get: function() {
        return $dTOjE.assertDefined;
    }
});
Object.defineProperty(module.exports, "assertDefinedAndNotNull", {
    enumerable: true,
    get: function() {
        return $dTOjE.assertDefinedAndNotNull;
    }
});

var $cpK86 = parcelRequire("cpK86");
Object.defineProperty(module.exports, "sleep", {
    enumerable: true,
    get: function() {
        return $cpK86.sleep;
    }
});

var $gjBW2 = parcelRequire("gjBW2");
Object.defineProperty(module.exports, "isNonNullObject", {
    enumerable: true,
    get: function() {
        return $gjBW2.isNonNullObject;
    }
});
Object.defineProperty(module.exports, "isUint8Array", {
    enumerable: true,
    get: function() {
        return $gjBW2.isUint8Array;
    }
});

});
parcelRegister("bqxvK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.arrayContentStartsWith = module.exports.arrayContentEquals = void 0;
/**
 * Compares the content of two arrays-like objects for equality.
 *
 * Equality is defined as having equal length and element values, where element equality means `===` returning `true`.
 *
 * This allows you to compare the content of a Buffer, Uint8Array or number[], ignoring the specific type.
 * As a consequence, this returns different results than Jasmine's `toEqual`, which ensures elements have the same type.
 */ function $851c1e06440e81d7$var$arrayContentEquals(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; ++i){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
module.exports.arrayContentEquals = $851c1e06440e81d7$var$arrayContentEquals;
/**
 * Checks if `a` starts with the contents of `b`.
 *
 * This requires equality of the element values, where element equality means `===` returning `true`.
 *
 * This allows you to compare the content of a Buffer, Uint8Array or number[], ignoring the specific type.
 * As a consequence, this returns different results than Jasmine's `toEqual`, which ensures elements have the same type.
 */ function $851c1e06440e81d7$var$arrayContentStartsWith(a, b) {
    if (a.length < b.length) return false;
    for(let i = 0; i < b.length; ++i){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
module.exports.arrayContentStartsWith = $851c1e06440e81d7$var$arrayContentStartsWith;

});

parcelRegister("dTOjE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertDefinedAndNotNull = module.exports.assertDefined = module.exports.assert = void 0;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $a1e7711dbab3f70f$var$assert(condition, msg) {
    if (!condition) throw new Error(msg || "condition is not truthy");
}
module.exports.assert = $a1e7711dbab3f70f$var$assert;
function $a1e7711dbab3f70f$var$assertDefined(value, msg) {
    if (value === undefined) throw new Error(msg !== null && msg !== void 0 ? msg : "value is undefined");
}
module.exports.assertDefined = $a1e7711dbab3f70f$var$assertDefined;
function $a1e7711dbab3f70f$var$assertDefinedAndNotNull(value, msg) {
    if (value === undefined || value === null) throw new Error(msg !== null && msg !== void 0 ? msg : "value is undefined or null");
}
module.exports.assertDefinedAndNotNull = $a1e7711dbab3f70f$var$assertDefinedAndNotNull;

});

parcelRegister("cpK86", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sleep = void 0;
async function $909b9a36af7bfa76$var$sleep(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
module.exports.sleep = $909b9a36af7bfa76$var$sleep;

});

parcelRegister("gjBW2", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $be0bd8d2f93458c9$require$Buffer = $gzLuY.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isUint8Array = module.exports.isNonNullObject = void 0;
/**
 * Checks if data is a non-null object (i.e. matches the TypeScript object type).
 *
 * Note: this returns true for arrays, which are objects in JavaScript
 * even though array and object are different types in JSON.
 *
 * @see https://www.typescriptlang.org/docs/handbook/basic-types.html#object
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $be0bd8d2f93458c9$var$isNonNullObject(data) {
    return typeof data === "object" && data !== null;
}
module.exports.isNonNullObject = $be0bd8d2f93458c9$var$isNonNullObject;
/**
 * Checks if data is an Uint8Array. Note: Buffer is treated as not a Uint8Array
 */ function $be0bd8d2f93458c9$var$isUint8Array(data) {
    if (!$be0bd8d2f93458c9$var$isNonNullObject(data)) return false;
    // Avoid instanceof check which is unreliable in some JS environments
    // https://medium.com/@simonwarta/limitations-of-the-instanceof-operator-f4bcdbe7a400
    // Use check that was discussed in https://github.com/crypto-browserify/pbkdf2/pull/81
    if (Object.prototype.toString.call(data) !== "[object Uint8Array]") return false;
    if (typeof $be0bd8d2f93458c9$require$Buffer !== "undefined" && typeof $be0bd8d2f93458c9$require$Buffer.isBuffer !== "undefined") {
        // Buffer.isBuffer is available at runtime
        if ($be0bd8d2f93458c9$require$Buffer.isBuffer(data)) return false;
    }
    return true;
}
module.exports.isUint8Array = $be0bd8d2f93458c9$var$isUint8Array;

});



parcelRegister("9kW08", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $6cc2f91f788ab464$var$symbolObservablePonyfill;
function $6cc2f91f788ab464$var$symbolObservablePonyfill(root) {
    var result;
    var _Symbol = root.Symbol;
    if (typeof _Symbol === "function") {
        if (_Symbol.observable) result = _Symbol.observable;
        else {
            // This just needs to be something that won't trample other user's Symbol.for use
            // It also will guide people to the source of their issues, if this is problematic.
            // META: It's a resource locator!
            result = _Symbol["for"]("https://github.com/benlesh/symbol-observable");
            try {
                _Symbol.observable = result;
            } catch (err) {
            // Do nothing. In some environments, users have frozen `Symbol` for security reasons,
            // if it is frozen assigning to it will throw. In this case, we don't care, because
            // they will need to use the returned value from the ponyfill.
            }
        }
    } else result = "@@observable";
    return result;
}

});

parcelRegister("2Z5w1", function(module, exports) {
"use strict";
var $22c58e8ec6c9864c$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $22c58e8ec6c9864c$var$toStr.call(value);
    var isArgs = str === "[object Arguments]";
    if (!isArgs) isArgs = str !== "[object Array]" && value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $22c58e8ec6c9864c$var$toStr.call(value.callee) === "[object Function]";
    return isArgs;
};

});

parcelRegister("3zxP0", function(module, exports) {
"use strict";
var $299ee041f06a3f7f$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $299ee041f06a3f7f$var$has = Object.prototype.hasOwnProperty;
    var $299ee041f06a3f7f$var$toStr = Object.prototype.toString;
    var $299ee041f06a3f7f$var$isArgs = (parcelRequire("2Z5w1")); // eslint-disable-line global-require
    var $299ee041f06a3f7f$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $299ee041f06a3f7f$var$hasDontEnumBug = !$299ee041f06a3f7f$var$isEnumerable.call({
        toString: null
    }, "toString");
    var $299ee041f06a3f7f$var$hasProtoEnumBug = $299ee041f06a3f7f$var$isEnumerable.call(function() {}, "prototype");
    var $299ee041f06a3f7f$var$dontEnums = [
        "toString",
        "toLocaleString",
        "valueOf",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "constructor"
    ];
    var $299ee041f06a3f7f$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $299ee041f06a3f7f$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $299ee041f06a3f7f$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === "undefined") return false;
        for(var k in window)try {
            if (!$299ee041f06a3f7f$var$excludedKeys["$" + k] && $299ee041f06a3f7f$var$has.call(window, k) && window[k] !== null && typeof window[k] === "object") try {
                $299ee041f06a3f7f$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $299ee041f06a3f7f$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === "undefined" || !$299ee041f06a3f7f$var$hasAutomationEqualityBug) return $299ee041f06a3f7f$var$equalsConstructorPrototype(o);
        try {
            return $299ee041f06a3f7f$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $299ee041f06a3f7f$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === "object";
        var isFunction = $299ee041f06a3f7f$var$toStr.call(object) === "[object Function]";
        var isArguments = $299ee041f06a3f7f$var$isArgs(object);
        var isString = isObject && $299ee041f06a3f7f$var$toStr.call(object) === "[object String]";
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError("Object.keys called on a non-object");
        var skipProto = $299ee041f06a3f7f$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$299ee041f06a3f7f$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === "prototype") && $299ee041f06a3f7f$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($299ee041f06a3f7f$var$hasDontEnumBug) {
            var skipConstructor = $299ee041f06a3f7f$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $299ee041f06a3f7f$var$dontEnums.length; ++k)if (!(skipConstructor && $299ee041f06a3f7f$var$dontEnums[k] === "constructor") && $299ee041f06a3f7f$var$has.call(object, $299ee041f06a3f7f$var$dontEnums[k])) theKeys.push($299ee041f06a3f7f$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $299ee041f06a3f7f$var$keysShim;

});

parcelRegister("jvnto", function(module, exports) {
"use strict";

var $kQEeW = parcelRequire("kQEeW");
var $e3331ed231f0d5e2$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$kQEeW;
};
$e3331ed231f0d5e2$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$kQEeW) return null;
    try {
        return $kQEeW([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $e3331ed231f0d5e2$var$hasPropertyDescriptors;

});
parcelRegister("kQEeW", function(module, exports) {
"use strict";

var $5KFGy = parcelRequire("5KFGy");
/** @type {import('.')} */ var $f2d7e0d267cd2189$var$$defineProperty = $5KFGy("%Object.defineProperty%", true) || false;
if ($f2d7e0d267cd2189$var$$defineProperty) try {
    $f2d7e0d267cd2189$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $f2d7e0d267cd2189$var$$defineProperty = false;
}
module.exports = $f2d7e0d267cd2189$var$$defineProperty;

});
parcelRegister("5KFGy", function(module, exports) {
"use strict";
var $43019574e681d1e0$var$undefined1;

var $gCRQ9 = parcelRequire("gCRQ9");

var $1DRb2 = parcelRequire("1DRb2");

var $1WBBC = parcelRequire("1WBBC");

var $9k8y8 = parcelRequire("9k8y8");

var $9RMU6 = parcelRequire("9RMU6");

var $hehTj = parcelRequire("hehTj");

var $8qxmR = parcelRequire("8qxmR");
var $43019574e681d1e0$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $43019574e681d1e0$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $43019574e681d1e0$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $43019574e681d1e0$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($43019574e681d1e0$var$$gOPD) try {
    $43019574e681d1e0$var$$gOPD({}, "");
} catch (e) {
    $43019574e681d1e0$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $43019574e681d1e0$var$throwTypeError = function() {
    throw new $hehTj();
};
var $43019574e681d1e0$var$ThrowTypeError = $43019574e681d1e0$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $43019574e681d1e0$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $43019574e681d1e0$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $43019574e681d1e0$var$throwTypeError;
        }
    }
}() : $43019574e681d1e0$var$throwTypeError;

var $43019574e681d1e0$var$hasSymbols = (parcelRequire("5r0Q9"))();

var $43019574e681d1e0$var$hasProto = (parcelRequire("bLAfM"))();
var $43019574e681d1e0$var$getProto = Object.getPrototypeOf || ($43019574e681d1e0$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $43019574e681d1e0$var$needsEval = {};
var $43019574e681d1e0$var$TypedArray = typeof Uint8Array === "undefined" || !$43019574e681d1e0$var$getProto ? undefined : $43019574e681d1e0$var$getProto(Uint8Array);
var $43019574e681d1e0$var$INTRINSICS = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $43019574e681d1e0$var$hasSymbols && $43019574e681d1e0$var$getProto ? $43019574e681d1e0$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $43019574e681d1e0$var$needsEval,
    "%AsyncGenerator%": $43019574e681d1e0$var$needsEval,
    "%AsyncGeneratorFunction%": $43019574e681d1e0$var$needsEval,
    "%AsyncIteratorPrototype%": $43019574e681d1e0$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": $gCRQ9,
    "%eval%": eval,
    "%EvalError%": $1DRb2,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $43019574e681d1e0$var$$Function,
    "%GeneratorFunction%": $43019574e681d1e0$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $43019574e681d1e0$var$hasSymbols && $43019574e681d1e0$var$getProto ? $43019574e681d1e0$var$getProto($43019574e681d1e0$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$43019574e681d1e0$var$hasSymbols || !$43019574e681d1e0$var$getProto ? undefined : $43019574e681d1e0$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": $1WBBC,
    "%ReferenceError%": $9k8y8,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$43019574e681d1e0$var$hasSymbols || !$43019574e681d1e0$var$getProto ? undefined : $43019574e681d1e0$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $43019574e681d1e0$var$hasSymbols && $43019574e681d1e0$var$getProto ? $43019574e681d1e0$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $43019574e681d1e0$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $9RMU6,
    "%ThrowTypeError%": $43019574e681d1e0$var$ThrowTypeError,
    "%TypedArray%": $43019574e681d1e0$var$TypedArray,
    "%TypeError%": $hehTj,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": $8qxmR,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if ($43019574e681d1e0$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $43019574e681d1e0$var$errorProto = $43019574e681d1e0$var$getProto($43019574e681d1e0$var$getProto(e));
    $43019574e681d1e0$var$INTRINSICS["%Error.prototype%"] = $43019574e681d1e0$var$errorProto;
}
var $43019574e681d1e0$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $43019574e681d1e0$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $43019574e681d1e0$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $43019574e681d1e0$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $43019574e681d1e0$var$getProto) value = $43019574e681d1e0$var$getProto(gen.prototype);
    }
    $43019574e681d1e0$var$INTRINSICS[name] = value;
    return value;
};
var $43019574e681d1e0$var$LEGACY_ALIASES = {
    __proto__: null,
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $1F3qt = parcelRequire("1F3qt");

var $2rT67 = parcelRequire("2rT67");
var $43019574e681d1e0$var$$concat = $1F3qt.call(Function.call, Array.prototype.concat);
var $43019574e681d1e0$var$$spliceApply = $1F3qt.call(Function.apply, Array.prototype.splice);
var $43019574e681d1e0$var$$replace = $1F3qt.call(Function.call, String.prototype.replace);
var $43019574e681d1e0$var$$strSlice = $1F3qt.call(Function.call, String.prototype.slice);
var $43019574e681d1e0$var$$exec = $1F3qt.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $43019574e681d1e0$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $43019574e681d1e0$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $43019574e681d1e0$var$stringToPath = function stringToPath(string) {
    var first = $43019574e681d1e0$var$$strSlice(string, 0, 1);
    var last = $43019574e681d1e0$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $9RMU6("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $9RMU6("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $43019574e681d1e0$var$$replace(string, $43019574e681d1e0$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $43019574e681d1e0$var$$replace(subString, $43019574e681d1e0$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $43019574e681d1e0$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($2rT67($43019574e681d1e0$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $43019574e681d1e0$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($2rT67($43019574e681d1e0$var$INTRINSICS, intrinsicName)) {
        var value = $43019574e681d1e0$var$INTRINSICS[intrinsicName];
        if (value === $43019574e681d1e0$var$needsEval) value = $43019574e681d1e0$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $hehTj("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $9RMU6("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $hehTj("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $hehTj('"allowMissing" argument must be a boolean');
    if ($43019574e681d1e0$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $9RMU6("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $43019574e681d1e0$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $43019574e681d1e0$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $43019574e681d1e0$var$$spliceApply(parts, $43019574e681d1e0$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $43019574e681d1e0$var$$strSlice(part, 0, 1);
        var last = $43019574e681d1e0$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $9RMU6("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($2rT67($43019574e681d1e0$var$INTRINSICS, intrinsicRealName)) value = $43019574e681d1e0$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $hehTj("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($43019574e681d1e0$var$$gOPD && i + 1 >= parts.length) {
                var desc = $43019574e681d1e0$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $2rT67(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $43019574e681d1e0$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("gCRQ9", function(module, exports) {
"use strict";
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("1DRb2", function(module, exports) {
"use strict";
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("1WBBC", function(module, exports) {
"use strict";
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("9k8y8", function(module, exports) {
"use strict";
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("9RMU6", function(module, exports) {
"use strict";
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("hehTj", function(module, exports) {
"use strict";
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("8qxmR", function(module, exports) {
"use strict";
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("5r0Q9", function(module, exports) {
"use strict";
var $3f50203680890d74$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $c2gQh = parcelRequire("c2gQh");
module.exports = function hasNativeSymbols() {
    if (typeof $3f50203680890d74$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $3f50203680890d74$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $c2gQh();
};

});
parcelRegister("c2gQh", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("bLAfM", function(module, exports) {
"use strict";
var $891034b66877f2be$var$test = {
    foo: {}
};
var $891034b66877f2be$var$$Object = Object;
module.exports = function hasProto() {
    return ({
        __proto__: $891034b66877f2be$var$test
    }).foo === $891034b66877f2be$var$test.foo && !(({
        __proto__: null
    }) instanceof $891034b66877f2be$var$$Object);
};

});

parcelRegister("1F3qt", function(module, exports) {
"use strict";

var $eovtQ = parcelRequire("eovtQ");
module.exports = Function.prototype.bind || $eovtQ;

});
parcelRegister("eovtQ", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $a7abb9ee5a94438d$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $a7abb9ee5a94438d$var$toStr = Object.prototype.toString;
var $a7abb9ee5a94438d$var$max = Math.max;
var $a7abb9ee5a94438d$var$funcType = "[object Function]";
var $a7abb9ee5a94438d$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $a7abb9ee5a94438d$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $a7abb9ee5a94438d$var$joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $a7abb9ee5a94438d$var$toStr.apply(target) !== $a7abb9ee5a94438d$var$funcType) throw new TypeError($a7abb9ee5a94438d$var$ERROR_MESSAGE + target);
    var args = $a7abb9ee5a94438d$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $a7abb9ee5a94438d$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $a7abb9ee5a94438d$var$concatty(args, arguments));
    };
    var boundLength = $a7abb9ee5a94438d$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + $a7abb9ee5a94438d$var$joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("2rT67", function(module, exports) {
"use strict";
var $1c88d79eb17b7c4d$var$call = Function.prototype.call;
var $1c88d79eb17b7c4d$var$$hasOwn = Object.prototype.hasOwnProperty;

var $1F3qt = parcelRequire("1F3qt");
/** @type {import('.')} */ module.exports = $1F3qt.call($1c88d79eb17b7c4d$var$call, $1c88d79eb17b7c4d$var$$hasOwn);

});




parcelRegister("jTpda", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.lastValue = module.exports.asArray = module.exports.countStream = module.exports.Reducer = void 0;
// Reducer takes a stream of events T and a ReducerFunc, that
// materializes a state of type U.
class $e7b6b5d2c4bd44f4$var$Reducer {
    // value returns current materialized state
    value() {
        return this.state;
    }
    // finished resolves on completed stream, rejects on stream error
    async finished() {
        return this.completed;
    }
    constructor(stream, reducer, initState){
        this.stream = stream;
        this.reducer = reducer;
        this.state = initState;
        this.completed = new Promise((resolve, reject)=>{
            const subscription = this.stream.subscribe({
                next: (evt)=>{
                    this.state = this.reducer(this.state, evt);
                },
                complete: ()=>{
                    resolve();
                    // this must happen after resolve, to ensure stream.subscribe() has finished
                    subscription.unsubscribe();
                },
                error: (err)=>{
                    reject(err);
                    // the stream already closed on error, but unsubscribe to be safe
                    subscription.unsubscribe();
                }
            });
        });
    }
}
module.exports.Reducer = $e7b6b5d2c4bd44f4$var$Reducer;
function $e7b6b5d2c4bd44f4$var$increment(sum, _) {
    return sum + 1;
}
// countStream returns a reducer that contains current count
// of events on the stream
function $e7b6b5d2c4bd44f4$var$countStream(stream) {
    return new $e7b6b5d2c4bd44f4$var$Reducer(stream, $e7b6b5d2c4bd44f4$var$increment, 0);
}
module.exports.countStream = $e7b6b5d2c4bd44f4$var$countStream;
function $e7b6b5d2c4bd44f4$var$append(list, evt) {
    return [
        ...list,
        evt
    ];
}
// asArray maintains an array containing all events that have
// occurred on the stream
function $e7b6b5d2c4bd44f4$var$asArray(stream) {
    return new $e7b6b5d2c4bd44f4$var$Reducer(stream, $e7b6b5d2c4bd44f4$var$append, []);
}
module.exports.asArray = $e7b6b5d2c4bd44f4$var$asArray;
function $e7b6b5d2c4bd44f4$var$last(_, event) {
    return event;
}
// lastValue returns the last value read from the stream, or undefined if no values sent
function $e7b6b5d2c4bd44f4$var$lastValue(stream) {
    return new $e7b6b5d2c4bd44f4$var$Reducer(stream, $e7b6b5d2c4bd44f4$var$last, undefined);
}
module.exports.lastValue = $e7b6b5d2c4bd44f4$var$lastValue;

});

parcelRegister("6kVcs", function(module, exports) {

module.exports = (parcelRequire("dDjcX"));

});
parcelRegister("dDjcX", function(module, exports) {
"use strict";

var $hVeI9 = parcelRequire("hVeI9");

var $8bLFp = parcelRequire("8bLFp");

var $bBIMf = parcelRequire("bBIMf");

var $5SIT9 = parcelRequire("5SIT9");

var $jzXAS = parcelRequire("jzXAS");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $9ecdd12c1183bd9d$var$createInstance(defaultConfig) {
    var context = new $bBIMf(defaultConfig);
    var instance = $8bLFp($bBIMf.prototype.request, context);
    // Copy axios.prototype to instance
    $hVeI9.extend(instance, $bBIMf.prototype, context);
    // Copy context to instance
    $hVeI9.extend(instance, context);
    return instance;
}
// Create the default instance to be exported
var $9ecdd12c1183bd9d$var$axios = $9ecdd12c1183bd9d$var$createInstance($jzXAS);
// Expose Axios class to allow class inheritance
$9ecdd12c1183bd9d$var$axios.Axios = $bBIMf;
// Factory for creating new instances
$9ecdd12c1183bd9d$var$axios.create = function create(instanceConfig) {
    return $9ecdd12c1183bd9d$var$createInstance($5SIT9($9ecdd12c1183bd9d$var$axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
$9ecdd12c1183bd9d$var$axios.Cancel = (parcelRequire("fowu1"));

$9ecdd12c1183bd9d$var$axios.CancelToken = (parcelRequire("c3t8J"));

$9ecdd12c1183bd9d$var$axios.isCancel = (parcelRequire("h1xX0"));
// Expose all/spread
$9ecdd12c1183bd9d$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$9ecdd12c1183bd9d$var$axios.spread = (parcelRequire("9Nvnt"));

// Expose isAxiosError
$9ecdd12c1183bd9d$var$axios.isAxiosError = (parcelRequire("35M7c"));
module.exports = $9ecdd12c1183bd9d$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $9ecdd12c1183bd9d$var$axios;

});
parcelRegister("hVeI9", function(module, exports) {
"use strict";

var $8bLFp = parcelRequire("8bLFp");
// utils is a library of generic helper functions non-specific to axios
var $d0c32bd7dd29d522$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $d0c32bd7dd29d522$var$isArray(val) {
    return $d0c32bd7dd29d522$var$toString.call(val) === "[object Array]";
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $d0c32bd7dd29d522$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $d0c32bd7dd29d522$var$isBuffer(val) {
    return val !== null && !$d0c32bd7dd29d522$var$isUndefined(val) && val.constructor !== null && !$d0c32bd7dd29d522$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $d0c32bd7dd29d522$var$isArrayBuffer(val) {
    return $d0c32bd7dd29d522$var$toString.call(val) === "[object ArrayBuffer]";
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $d0c32bd7dd29d522$var$isFormData(val) {
    return typeof FormData !== "undefined" && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $d0c32bd7dd29d522$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $d0c32bd7dd29d522$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $d0c32bd7dd29d522$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $d0c32bd7dd29d522$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $d0c32bd7dd29d522$var$isPlainObject(val) {
    if ($d0c32bd7dd29d522$var$toString.call(val) !== "[object Object]") return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $d0c32bd7dd29d522$var$isDate(val) {
    return $d0c32bd7dd29d522$var$toString.call(val) === "[object Date]";
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $d0c32bd7dd29d522$var$isFile(val) {
    return $d0c32bd7dd29d522$var$toString.call(val) === "[object File]";
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $d0c32bd7dd29d522$var$isBlob(val) {
    return $d0c32bd7dd29d522$var$toString.call(val) === "[object Blob]";
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $d0c32bd7dd29d522$var$isFunction(val) {
    return $d0c32bd7dd29d522$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $d0c32bd7dd29d522$var$isStream(val) {
    return $d0c32bd7dd29d522$var$isObject(val) && $d0c32bd7dd29d522$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $d0c32bd7dd29d522$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $d0c32bd7dd29d522$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $d0c32bd7dd29d522$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $d0c32bd7dd29d522$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($d0c32bd7dd29d522$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $d0c32bd7dd29d522$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($d0c32bd7dd29d522$var$isPlainObject(result[key]) && $d0c32bd7dd29d522$var$isPlainObject(val)) result[key] = $d0c32bd7dd29d522$var$merge(result[key], val);
        else if ($d0c32bd7dd29d522$var$isPlainObject(val)) result[key] = $d0c32bd7dd29d522$var$merge({}, val);
        else if ($d0c32bd7dd29d522$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$d0c32bd7dd29d522$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $d0c32bd7dd29d522$var$extend(a, b, thisArg) {
    $d0c32bd7dd29d522$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $8bLFp(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $d0c32bd7dd29d522$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $d0c32bd7dd29d522$var$isArray,
    isArrayBuffer: $d0c32bd7dd29d522$var$isArrayBuffer,
    isBuffer: $d0c32bd7dd29d522$var$isBuffer,
    isFormData: $d0c32bd7dd29d522$var$isFormData,
    isArrayBufferView: $d0c32bd7dd29d522$var$isArrayBufferView,
    isString: $d0c32bd7dd29d522$var$isString,
    isNumber: $d0c32bd7dd29d522$var$isNumber,
    isObject: $d0c32bd7dd29d522$var$isObject,
    isPlainObject: $d0c32bd7dd29d522$var$isPlainObject,
    isUndefined: $d0c32bd7dd29d522$var$isUndefined,
    isDate: $d0c32bd7dd29d522$var$isDate,
    isFile: $d0c32bd7dd29d522$var$isFile,
    isBlob: $d0c32bd7dd29d522$var$isBlob,
    isFunction: $d0c32bd7dd29d522$var$isFunction,
    isStream: $d0c32bd7dd29d522$var$isStream,
    isURLSearchParams: $d0c32bd7dd29d522$var$isURLSearchParams,
    isStandardBrowserEnv: $d0c32bd7dd29d522$var$isStandardBrowserEnv,
    forEach: $d0c32bd7dd29d522$var$forEach,
    merge: $d0c32bd7dd29d522$var$merge,
    extend: $d0c32bd7dd29d522$var$extend,
    trim: $d0c32bd7dd29d522$var$trim,
    stripBOM: $d0c32bd7dd29d522$var$stripBOM
};

});
parcelRegister("8bLFp", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("bBIMf", function(module, exports) {
"use strict";

var $hVeI9 = parcelRequire("hVeI9");

var $klASL = parcelRequire("klASL");

var $cAP2y = parcelRequire("cAP2y");

var $9BRjh = parcelRequire("9BRjh");

var $5SIT9 = parcelRequire("5SIT9");

var $dWDUF = parcelRequire("dWDUF");
var $8735e238b8e5c2f2$var$validators = $dWDUF.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $8735e238b8e5c2f2$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $cAP2y(),
        response: new $cAP2y()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $8735e238b8e5c2f2$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === "string") {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = $5SIT9(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    var transitional = config.transitional;
    if (transitional !== undefined) $dWDUF.assertOptions(transitional, {
        silentJSONParsing: $8735e238b8e5c2f2$var$validators.transitional($8735e238b8e5c2f2$var$validators.boolean, "1.0.0"),
        forcedJSONParsing: $8735e238b8e5c2f2$var$validators.transitional($8735e238b8e5c2f2$var$validators.boolean, "1.0.0"),
        clarifyTimeoutError: $8735e238b8e5c2f2$var$validators.transitional($8735e238b8e5c2f2$var$validators.boolean, "1.0.0")
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $9BRjh,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $9BRjh(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$8735e238b8e5c2f2$var$Axios.prototype.getUri = function getUri(config) {
    config = $5SIT9(this.defaults, config);
    return $klASL(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
// Provide aliases for supported request methods
$hVeI9.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $8735e238b8e5c2f2$var$Axios.prototype[method] = function(url, config) {
        return this.request($5SIT9(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$hVeI9.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $8735e238b8e5c2f2$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($5SIT9(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $8735e238b8e5c2f2$var$Axios;

});
parcelRegister("klASL", function(module, exports) {
"use strict";

var $hVeI9 = parcelRequire("hVeI9");
function $ed0260df09f15c57$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($hVeI9.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $hVeI9.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($hVeI9.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $hVeI9.forEach(val, function parseValue(v) {
                if ($hVeI9.isDate(v)) v = v.toISOString();
                else if ($hVeI9.isObject(v)) v = JSON.stringify(v);
                parts.push($ed0260df09f15c57$var$encode(key) + "=" + $ed0260df09f15c57$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

});

parcelRegister("cAP2y", function(module, exports) {
"use strict";

var $hVeI9 = parcelRequire("hVeI9");
function $92b07057890e2483$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $92b07057890e2483$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $92b07057890e2483$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $92b07057890e2483$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $hVeI9.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $92b07057890e2483$var$InterceptorManager;

});

parcelRegister("9BRjh", function(module, exports) {
"use strict";

var $hVeI9 = parcelRequire("hVeI9");

var $cGCCi = parcelRequire("cGCCi");

var $h1xX0 = parcelRequire("h1xX0");

var $jzXAS = parcelRequire("jzXAS");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $6ff0ec063f6fb753$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $6ff0ec063f6fb753$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $cGCCi.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $hVeI9.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $hVeI9.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $jzXAS.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $6ff0ec063f6fb753$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $cGCCi.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$h1xX0(reason)) {
            $6ff0ec063f6fb753$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $cGCCi.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("cGCCi", function(module, exports) {
"use strict";

var $hVeI9 = parcelRequire("hVeI9");

var $jzXAS = parcelRequire("jzXAS");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $jzXAS;
    /*eslint no-param-reassign:0*/ $hVeI9.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRegister("jzXAS", function(module, exports) {

var $a8i8g = parcelRequire("a8i8g");
"use strict";

var $hVeI9 = parcelRequire("hVeI9");

var $kJxas = parcelRequire("kJxas");

var $gUHJu = parcelRequire("gUHJu");
var $e40f834a07cb945e$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $e40f834a07cb945e$var$setContentTypeIfUnset(headers, value) {
    if (!$hVeI9.isUndefined(headers) && $hVeI9.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $e40f834a07cb945e$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("72oIO"));
    else if (typeof $a8i8g !== "undefined" && Object.prototype.toString.call($a8i8g) === "[object process]") // For node use HTTP adapter
    adapter = (parcelRequire("72oIO"));
    return adapter;
}
function $e40f834a07cb945e$var$stringifySafely(rawValue, parser, encoder) {
    if ($hVeI9.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $hVeI9.trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $e40f834a07cb945e$var$defaults = {
    transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
    },
    adapter: $e40f834a07cb945e$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $kJxas(headers, "Accept");
            $kJxas(headers, "Content-Type");
            if ($hVeI9.isFormData(data) || $hVeI9.isArrayBuffer(data) || $hVeI9.isBuffer(data) || $hVeI9.isStream(data) || $hVeI9.isFile(data) || $hVeI9.isBlob(data)) return data;
            if ($hVeI9.isArrayBufferView(data)) return data.buffer;
            if ($hVeI9.isURLSearchParams(data)) {
                $e40f834a07cb945e$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            if ($hVeI9.isObject(data) || headers && headers["Content-Type"] === "application/json") {
                $e40f834a07cb945e$var$setContentTypeIfUnset(headers, "application/json");
                return $e40f834a07cb945e$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
            if (strictJSONParsing || forcedJSONParsing && $hVeI9.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === "SyntaxError") throw $gUHJu(e, this, "E_JSON_PARSE");
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
$e40f834a07cb945e$var$defaults.headers = {
    common: {
        "Accept": "application/json, text/plain, */*"
    }
};
$hVeI9.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $e40f834a07cb945e$var$defaults.headers[method] = {};
});
$hVeI9.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $e40f834a07cb945e$var$defaults.headers[method] = $hVeI9.merge($e40f834a07cb945e$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $e40f834a07cb945e$var$defaults;

});
parcelRegister("kJxas", function(module, exports) {
"use strict";

var $hVeI9 = parcelRequire("hVeI9");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $hVeI9.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("gUHJu", function(module, exports) {
"use strict";
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code
        };
    };
    return error;
};

});

parcelRegister("72oIO", function(module, exports) {
"use strict";

var $hVeI9 = parcelRequire("hVeI9");

var $5tZdq = parcelRequire("5tZdq");

var $8OogZ = parcelRequire("8OogZ");

var $klASL = parcelRequire("klASL");

var $jqLXV = parcelRequire("jqLXV");

var $j5Fvi = parcelRequire("j5Fvi");

var $gLfwt = parcelRequire("gLfwt");

var $go9NK = parcelRequire("go9NK");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        if ($hVeI9.isFormData(requestData)) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = $jqLXV(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $klASL(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $j5Fvi(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $5tZdq(resolve, reject, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($go9NK("Request aborted", config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($go9NK("Network Error", config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = "timeout of " + config.timeout + "ms exceeded";
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($go9NK(timeoutErrorMessage, config, config.transitional && config.transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($hVeI9.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $gLfwt(fullPath)) && config.xsrfCookieName ? $8OogZ.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $hVeI9.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$hVeI9.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken) // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) return;
            request.abort();
            reject(cancel);
            // Clean up request
            request = null;
        });
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("5tZdq", function(module, exports) {
"use strict";

var $go9NK = parcelRequire("go9NK");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($go9NK("Request failed with status code " + response.status, response.config, null, response.request, response));
};

});
parcelRegister("go9NK", function(module, exports) {
"use strict";

var $gUHJu = parcelRequire("gUHJu");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $gUHJu(error, config, code, request, response);
};

});


parcelRegister("8OogZ", function(module, exports) {
"use strict";

var $hVeI9 = parcelRequire("hVeI9");
module.exports = $hVeI9.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($hVeI9.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($hVeI9.isString(path)) cookie.push("path=" + path);
            if ($hVeI9.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("jqLXV", function(module, exports) {
"use strict";

var $6GQsY = parcelRequire("6GQsY");

var $g5wpq = parcelRequire("g5wpq");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$6GQsY(requestedURL)) return $g5wpq(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("6GQsY", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRegister("g5wpq", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});


parcelRegister("j5Fvi", function(module, exports) {
"use strict";

var $hVeI9 = parcelRequire("hVeI9");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $de5eadbf2ceb98dd$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $hVeI9.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $hVeI9.trim(line.substr(0, i)).toLowerCase();
        val = $hVeI9.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $de5eadbf2ceb98dd$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("gLfwt", function(module, exports) {
"use strict";

var $hVeI9 = parcelRequire("hVeI9");
module.exports = $hVeI9.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $hVeI9.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});




parcelRegister("h1xX0", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRegister("5SIT9", function(module, exports) {
"use strict";

var $hVeI9 = parcelRequire("hVeI9");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    var valueFromConfig2Keys = [
        "url",
        "method",
        "data"
    ];
    var mergeDeepPropertiesKeys = [
        "headers",
        "auth",
        "proxy",
        "params"
    ];
    var defaultToConfig2Keys = [
        "baseURL",
        "transformRequest",
        "transformResponse",
        "paramsSerializer",
        "timeout",
        "timeoutMessage",
        "withCredentials",
        "adapter",
        "responseType",
        "xsrfCookieName",
        "xsrfHeaderName",
        "onUploadProgress",
        "onDownloadProgress",
        "decompress",
        "maxContentLength",
        "maxBodyLength",
        "maxRedirects",
        "transport",
        "httpAgent",
        "httpsAgent",
        "cancelToken",
        "socketPath",
        "responseEncoding"
    ];
    var directMergeKeys = [
        "validateStatus"
    ];
    function getMergedValue(target, source) {
        if ($hVeI9.isPlainObject(target) && $hVeI9.isPlainObject(source)) return $hVeI9.merge(target, source);
        else if ($hVeI9.isPlainObject(source)) return $hVeI9.merge({}, source);
        else if ($hVeI9.isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(prop) {
        if (!$hVeI9.isUndefined(config2[prop])) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (!$hVeI9.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    }
    $hVeI9.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
        if (!$hVeI9.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
    });
    $hVeI9.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
    $hVeI9.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
        if (!$hVeI9.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
        else if (!$hVeI9.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    $hVeI9.forEach(directMergeKeys, function merge(prop) {
        if (prop in config2) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
    var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
        return axiosKeys.indexOf(key) === -1;
    });
    $hVeI9.forEach(otherKeys, mergeDeepProperties);
    return config;
};

});

parcelRegister("dWDUF", function(module, exports) {
"use strict";

var $jKQQR = parcelRequire("jKQQR");
var $a26fa707d1747837$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach(function(type, i) {
    $a26fa707d1747837$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
var $a26fa707d1747837$var$deprecatedWarnings = {};
var $a26fa707d1747837$var$currentVerArr = $jKQQR.version.split(".");
/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */ function $a26fa707d1747837$var$isOlderVersion(version, thanVersion) {
    var pkgVersionArr = thanVersion ? thanVersion.split(".") : $a26fa707d1747837$var$currentVerArr;
    var destVer = version.split(".");
    for(var i = 0; i < 3; i++){
        if (pkgVersionArr[i] > destVer[i]) return true;
        else if (pkgVersionArr[i] < destVer[i]) return false;
    }
    return false;
}
/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */ $a26fa707d1747837$var$validators.transitional = function transitional(validator, version, message) {
    var isDeprecated = version && $a26fa707d1747837$var$isOlderVersion(version);
    function formatMessage(opt, desc) {
        return "[Axios v" + $jKQQR.version + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new Error(formatMessage(opt, " has been removed in " + version));
        if (isDeprecated && !$a26fa707d1747837$var$deprecatedWarnings[opt]) {
            $a26fa707d1747837$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $a26fa707d1747837$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new TypeError("options must be an object");
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new TypeError("option " + opt + " must be " + result);
            continue;
        }
        if (allowUnknown !== true) throw Error("Unknown option " + opt);
    }
}
module.exports = {
    isOlderVersion: $a26fa707d1747837$var$isOlderVersion,
    assertOptions: $a26fa707d1747837$var$assertOptions,
    validators: $a26fa707d1747837$var$validators
};

});
parcelRegister("jKQQR", function(module, exports) {
module.exports = JSON.parse('{"name":"axios","version":"0.21.4","description":"Promise based HTTP client for the browser and node.js","main":"index.js","scripts":{"test":"grunt test","start":"node ./sandbox/server.js","build":"NODE_ENV=production grunt build","preversion":"npm test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json","postversion":"git push && git push --tags","examples":"node ./examples/server.js","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","fix":"eslint --fix lib/**/*.js"},"repository":{"type":"git","url":"https://github.com/axios/axios.git"},"keywords":["xhr","http","ajax","promise","node"],"author":"Matt Zabriskie","license":"MIT","bugs":{"url":"https://github.com/axios/axios/issues"},"homepage":"https://axios-http.com","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"jsdelivr":"dist/axios.min.js","unpkg":"dist/axios.min.js","typings":"./index.d.ts","dependencies":{"follow-redirects":"^1.14.0"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}]}');

});



parcelRegister("fowu1", function(module, exports) {
"use strict";
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $b3524b6c16a5774b$var$Cancel(message) {
    this.message = message;
}
$b3524b6c16a5774b$var$Cancel.prototype.toString = function toString() {
    return "Cancel" + (this.message ? ": " + this.message : "");
};
$b3524b6c16a5774b$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $b3524b6c16a5774b$var$Cancel;

});

parcelRegister("c3t8J", function(module, exports) {
"use strict";

var $fowu1 = parcelRequire("fowu1");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $8c6c5e66418d29f6$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $fowu1(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $8c6c5e66418d29f6$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $8c6c5e66418d29f6$var$CancelToken.source = function source() {
    var cancel;
    var token = new $8c6c5e66418d29f6$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $8c6c5e66418d29f6$var$CancelToken;

});

parcelRegister("9Nvnt", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("35M7c", function(module, exports) {
"use strict";
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return typeof payload === "object" && payload.isAxiosError === true;
};

});



parcelRegister("lr6FU", function(module, exports) {
// https://github.com/maxogden/websocket-stream/blob/48dc3ddf943e5ada668c31ccd94e9186f02fafbd/ws-fallback.js
var $f9b14c1c4b7c4c67$var$ws = null;
if (typeof WebSocket !== "undefined") $f9b14c1c4b7c4c67$var$ws = WebSocket;
else if (typeof MozWebSocket !== "undefined") $f9b14c1c4b7c4c67$var$ws = MozWebSocket;
else if (typeof $parcel$global !== "undefined") $f9b14c1c4b7c4c67$var$ws = $parcel$global.WebSocket || $parcel$global.MozWebSocket;
else if (typeof window !== "undefined") $f9b14c1c4b7c4c67$var$ws = window.WebSocket || window.MozWebSocket;
else if (typeof self !== "undefined") $f9b14c1c4b7c4c67$var$ws = self.WebSocket || self.MozWebSocket;
module.exports = $f9b14c1c4b7c4c67$var$ws;

});

parcelRegister("3yx4f", function(module, exports) {
"use strict";
// Note: all exports in this module are publicly available via
// `import { tendermint34 } from "@cosmjs/tendermint-rpc"`
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Tendermint34Client = module.exports.VoteType = module.exports.broadcastTxSyncSuccess = module.exports.broadcastTxCommitSuccess = module.exports.SubscriptionEventType = module.exports.Method = void 0;

var $kFe1M = parcelRequire("kFe1M");
Object.defineProperty(module.exports, "Method", {
    enumerable: true,
    get: function() {
        return $kFe1M.Method;
    }
});
Object.defineProperty(module.exports, "SubscriptionEventType", {
    enumerable: true,
    get: function() {
        return $kFe1M.SubscriptionEventType;
    }
});

var $jU0w3 = parcelRequire("jU0w3");
Object.defineProperty(module.exports, "broadcastTxCommitSuccess", {
    enumerable: true,
    get: function() {
        return $jU0w3.broadcastTxCommitSuccess;
    }
});
Object.defineProperty(module.exports, "broadcastTxSyncSuccess", {
    enumerable: true,
    get: function() {
        return $jU0w3.broadcastTxSyncSuccess;
    }
});
Object.defineProperty(module.exports, "VoteType", {
    enumerable: true,
    get: function() {
        return $jU0w3.VoteType;
    }
});

var $29ydc = parcelRequire("29ydc");
Object.defineProperty(module.exports, "Tendermint34Client", {
    enumerable: true,
    get: function() {
        return $29ydc.Tendermint34Client;
    }
});

});
parcelRegister("kFe1M", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/naming-convention */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.buildQuery = module.exports.SubscriptionEventType = module.exports.Method = void 0;
/**
 * RPC methods as documented in https://docs.tendermint.com/master/rpc/
 *
 * Enum raw value must match the spelling in the "shell" example call (snake_case)
 */ var $f0b28493e9da22f9$var$Method;
(function(Method) {
    Method["AbciInfo"] = "abci_info";
    Method["AbciQuery"] = "abci_query";
    Method["Block"] = "block";
    /** Get block headers for minHeight <= height <= maxHeight. */ Method["Blockchain"] = "blockchain";
    Method["BlockResults"] = "block_results";
    Method["BlockSearch"] = "block_search";
    Method["BroadcastTxAsync"] = "broadcast_tx_async";
    Method["BroadcastTxSync"] = "broadcast_tx_sync";
    Method["BroadcastTxCommit"] = "broadcast_tx_commit";
    Method["Commit"] = "commit";
    Method["Genesis"] = "genesis";
    Method["Health"] = "health";
    Method["NumUnconfirmedTxs"] = "num_unconfirmed_txs";
    Method["Status"] = "status";
    Method["Subscribe"] = "subscribe";
    Method["Tx"] = "tx";
    Method["TxSearch"] = "tx_search";
    Method["Validators"] = "validators";
    Method["Unsubscribe"] = "unsubscribe";
})($f0b28493e9da22f9$var$Method = module.exports.Method || (module.exports.Method = {}));
/**
 * Raw values must match the tendermint event name
 *
 * @see https://godoc.org/github.com/tendermint/tendermint/types#pkg-constants
 */ var $f0b28493e9da22f9$var$SubscriptionEventType;
(function(SubscriptionEventType) {
    SubscriptionEventType["NewBlock"] = "NewBlock";
    SubscriptionEventType["NewBlockHeader"] = "NewBlockHeader";
    SubscriptionEventType["Tx"] = "Tx";
})($f0b28493e9da22f9$var$SubscriptionEventType = module.exports.SubscriptionEventType || (module.exports.SubscriptionEventType = {}));
function $f0b28493e9da22f9$var$buildQuery(components) {
    const tags = components.tags ? components.tags : [];
    const tagComponents = tags.map((tag)=>`${tag.key}='${tag.value}'`);
    const rawComponents = components.raw ? [
        components.raw
    ] : [];
    return [
        ...tagComponents,
        ...rawComponents
    ].join(" AND ");
}
module.exports.buildQuery = $f0b28493e9da22f9$var$buildQuery;

});

parcelRegister("jU0w3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoteType = module.exports.broadcastTxCommitSuccess = module.exports.broadcastTxSyncSuccess = void 0;
/**
 * Returns true iff transaction made it successfully into the transaction pool
 */ function $e7d3a5c4c5759ab5$var$broadcastTxSyncSuccess(res) {
    // code must be 0 on success
    return res.code === 0;
}
module.exports.broadcastTxSyncSuccess = $e7d3a5c4c5759ab5$var$broadcastTxSyncSuccess;
/**
 * Returns true iff transaction made it successfully into a block
 * (i.e. success in `check_tx` and `deliver_tx` field)
 */ function $e7d3a5c4c5759ab5$var$broadcastTxCommitSuccess(response) {
    // code must be 0 on success
    // deliverTx may be present but empty on failure
    return response.checkTx.code === 0 && !!response.deliverTx && response.deliverTx.code === 0;
}
module.exports.broadcastTxCommitSuccess = $e7d3a5c4c5759ab5$var$broadcastTxCommitSuccess;
/**
 * raw values from https://github.com/tendermint/tendermint/blob/dfa9a9a30a666132425b29454e90a472aa579a48/types/vote.go#L44
 */ var $e7d3a5c4c5759ab5$var$VoteType;
(function(VoteType) {
    VoteType[VoteType["PreVote"] = 1] = "PreVote";
    VoteType[VoteType["PreCommit"] = 2] = "PreCommit";
})($e7d3a5c4c5759ab5$var$VoteType = module.exports.VoteType || (module.exports.VoteType = {}));

});

parcelRegister("29ydc", function(module, exports) {
"use strict";
var $1916f5cc5e1b902f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1916f5cc5e1b902f$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $1916f5cc5e1b902f$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $1916f5cc5e1b902f$var$__createBinding(result, mod, k);
    }
    $1916f5cc5e1b902f$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Tendermint34Client = void 0;

var $8XYR9 = parcelRequire("8XYR9");

var $lqv7L = parcelRequire("lqv7L");

var $cu1uI = parcelRequire("cu1uI");

const $1916f5cc5e1b902f$var$requests = $1916f5cc5e1b902f$var$__importStar((parcelRequire("kFe1M")));
class $1916f5cc5e1b902f$var$Tendermint34Client {
    /**
     * Creates a new Tendermint client for the given endpoint.
     *
     * Uses HTTP when the URL schema is http or https. Uses WebSockets otherwise.
     */ static async connect(endpoint) {
        if (typeof endpoint === "object") return $1916f5cc5e1b902f$var$Tendermint34Client.create(new $lqv7L.HttpClient(endpoint));
        else {
            const useHttp = endpoint.startsWith("http://") || endpoint.startsWith("https://");
            const rpcClient = useHttp ? new $lqv7L.HttpClient(endpoint) : new $lqv7L.WebsocketClient(endpoint);
            return $1916f5cc5e1b902f$var$Tendermint34Client.create(rpcClient);
        }
    }
    /**
     * Creates a new Tendermint client given an RPC client.
     */ static async create(rpcClient) {
        // For some very strange reason I don't understand, tests start to fail on some systems
        // (our CI) when skipping the status call before doing other queries. Sleeping a little
        // while did not help. Thus we query the version as a way to say "hi" to the backend,
        // even in cases where we don't use the result.
        const _version = await this.detectVersion(rpcClient);
        return new $1916f5cc5e1b902f$var$Tendermint34Client(rpcClient);
    }
    static async detectVersion(client) {
        const req = (0, $8XYR9.createJsonRpcRequest)($1916f5cc5e1b902f$var$requests.Method.Status);
        const response = await client.execute(req);
        const result = response.result;
        if (!result || !result.node_info) throw new Error("Unrecognized format for status response");
        const version = result.node_info.version;
        if (typeof version !== "string") throw new Error("Unrecognized version format: must be string");
        return version;
    }
    disconnect() {
        this.client.disconnect();
    }
    async abciInfo() {
        const query = {
            method: $1916f5cc5e1b902f$var$requests.Method.AbciInfo
        };
        return this.doCall(query, this.p.encodeAbciInfo, this.r.decodeAbciInfo);
    }
    async abciQuery(params) {
        const query = {
            params: params,
            method: $1916f5cc5e1b902f$var$requests.Method.AbciQuery
        };
        return this.doCall(query, this.p.encodeAbciQuery, this.r.decodeAbciQuery);
    }
    async block(height) {
        const query = {
            method: $1916f5cc5e1b902f$var$requests.Method.Block,
            params: {
                height: height
            }
        };
        return this.doCall(query, this.p.encodeBlock, this.r.decodeBlock);
    }
    async blockResults(height) {
        const query = {
            method: $1916f5cc5e1b902f$var$requests.Method.BlockResults,
            params: {
                height: height
            }
        };
        return this.doCall(query, this.p.encodeBlockResults, this.r.decodeBlockResults);
    }
    /**
     * Search for events that are in a block.
     *
     * NOTE
     * This method will error on any node that is running a Tendermint version lower than 0.34.9.
     *
     * @see https://docs.tendermint.com/master/rpc/#/Info/block_search
     */ async blockSearch(params) {
        const query = {
            params: params,
            method: $1916f5cc5e1b902f$var$requests.Method.BlockSearch
        };
        const resp = await this.doCall(query, this.p.encodeBlockSearch, this.r.decodeBlockSearch);
        return {
            ...resp,
            // make sure we sort by height, as tendermint may be sorting by string value of the height
            blocks: [
                ...resp.blocks
            ].sort((a, b)=>a.block.header.height - b.block.header.height)
        };
    }
    // this should paginate through all blockSearch options to ensure it returns all results.
    // starts with page 1 or whatever was provided (eg. to start on page 7)
    //
    // NOTE
    // This method will error on any node that is running a Tendermint version lower than 0.34.9.
    async blockSearchAll(params) {
        let page = params.page || 1;
        const blocks = [];
        let done = false;
        while(!done){
            const resp = await this.blockSearch({
                ...params,
                page: page
            });
            blocks.push(...resp.blocks);
            if (blocks.length < resp.totalCount) page++;
            else done = true;
        }
        // make sure we sort by height, as tendermint may be sorting by string value of the height
        // and the earlier items may be in a higher page than the later items
        blocks.sort((a, b)=>a.block.header.height - b.block.header.height);
        return {
            totalCount: blocks.length,
            blocks: blocks
        };
    }
    /**
     * Queries block headers filtered by minHeight <= height <= maxHeight.
     *
     * @param minHeight The minimum height to be included in the result. Defaults to 0.
     * @param maxHeight The maximum height to be included in the result. Defaults to infinity.
     */ async blockchain(minHeight, maxHeight) {
        const query = {
            method: $1916f5cc5e1b902f$var$requests.Method.Blockchain,
            params: {
                minHeight: minHeight,
                maxHeight: maxHeight
            }
        };
        return this.doCall(query, this.p.encodeBlockchain, this.r.decodeBlockchain);
    }
    /**
     * Broadcast transaction to mempool and wait for response
     *
     * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_sync
     */ async broadcastTxSync(params) {
        const query = {
            params: params,
            method: $1916f5cc5e1b902f$var$requests.Method.BroadcastTxSync
        };
        return this.doCall(query, this.p.encodeBroadcastTx, this.r.decodeBroadcastTxSync);
    }
    /**
     * Broadcast transaction to mempool and do not wait for result
     *
     * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_async
     */ async broadcastTxAsync(params) {
        const query = {
            params: params,
            method: $1916f5cc5e1b902f$var$requests.Method.BroadcastTxAsync
        };
        return this.doCall(query, this.p.encodeBroadcastTx, this.r.decodeBroadcastTxAsync);
    }
    /**
     * Broadcast transaction to mempool and wait for block
     *
     * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_commit
     */ async broadcastTxCommit(params) {
        const query = {
            params: params,
            method: $1916f5cc5e1b902f$var$requests.Method.BroadcastTxCommit
        };
        return this.doCall(query, this.p.encodeBroadcastTx, this.r.decodeBroadcastTxCommit);
    }
    async commit(height) {
        const query = {
            method: $1916f5cc5e1b902f$var$requests.Method.Commit,
            params: {
                height: height
            }
        };
        return this.doCall(query, this.p.encodeCommit, this.r.decodeCommit);
    }
    async genesis() {
        const query = {
            method: $1916f5cc5e1b902f$var$requests.Method.Genesis
        };
        return this.doCall(query, this.p.encodeGenesis, this.r.decodeGenesis);
    }
    async health() {
        const query = {
            method: $1916f5cc5e1b902f$var$requests.Method.Health
        };
        return this.doCall(query, this.p.encodeHealth, this.r.decodeHealth);
    }
    async numUnconfirmedTxs() {
        const query = {
            method: $1916f5cc5e1b902f$var$requests.Method.NumUnconfirmedTxs
        };
        return this.doCall(query, this.p.encodeNumUnconfirmedTxs, this.r.decodeNumUnconfirmedTxs);
    }
    async status() {
        const query = {
            method: $1916f5cc5e1b902f$var$requests.Method.Status
        };
        return this.doCall(query, this.p.encodeStatus, this.r.decodeStatus);
    }
    subscribeNewBlock() {
        const request = {
            method: $1916f5cc5e1b902f$var$requests.Method.Subscribe,
            query: {
                type: $1916f5cc5e1b902f$var$requests.SubscriptionEventType.NewBlock
            }
        };
        return this.subscribe(request, this.r.decodeNewBlockEvent);
    }
    subscribeNewBlockHeader() {
        const request = {
            method: $1916f5cc5e1b902f$var$requests.Method.Subscribe,
            query: {
                type: $1916f5cc5e1b902f$var$requests.SubscriptionEventType.NewBlockHeader
            }
        };
        return this.subscribe(request, this.r.decodeNewBlockHeaderEvent);
    }
    subscribeTx(query) {
        const request = {
            method: $1916f5cc5e1b902f$var$requests.Method.Subscribe,
            query: {
                type: $1916f5cc5e1b902f$var$requests.SubscriptionEventType.Tx,
                raw: query
            }
        };
        return this.subscribe(request, this.r.decodeTxEvent);
    }
    /**
     * Get a single transaction by hash
     *
     * @see https://docs.tendermint.com/master/rpc/#/Info/tx
     */ async tx(params) {
        const query = {
            params: params,
            method: $1916f5cc5e1b902f$var$requests.Method.Tx
        };
        return this.doCall(query, this.p.encodeTx, this.r.decodeTx);
    }
    /**
     * Search for transactions that are in a block
     *
     * @see https://docs.tendermint.com/master/rpc/#/Info/tx_search
     */ async txSearch(params) {
        const query = {
            params: params,
            method: $1916f5cc5e1b902f$var$requests.Method.TxSearch
        };
        return this.doCall(query, this.p.encodeTxSearch, this.r.decodeTxSearch);
    }
    // this should paginate through all txSearch options to ensure it returns all results.
    // starts with page 1 or whatever was provided (eg. to start on page 7)
    async txSearchAll(params) {
        let page = params.page || 1;
        const txs = [];
        let done = false;
        while(!done){
            const resp = await this.txSearch({
                ...params,
                page: page
            });
            txs.push(...resp.txs);
            if (txs.length < resp.totalCount) page++;
            else done = true;
        }
        return {
            totalCount: txs.length,
            txs: txs
        };
    }
    async validators(params) {
        const query = {
            method: $1916f5cc5e1b902f$var$requests.Method.Validators,
            params: params
        };
        return this.doCall(query, this.p.encodeValidators, this.r.decodeValidators);
    }
    async validatorsAll(height) {
        const validators = [];
        let page = 1;
        let done = false;
        let blockHeight = height;
        while(!done){
            const response = await this.validators({
                per_page: 50,
                height: blockHeight,
                page: page
            });
            validators.push(...response.validators);
            blockHeight = blockHeight || response.blockHeight;
            if (validators.length < response.total) page++;
            else done = true;
        }
        return {
            // NOTE: Default value is for type safety but this should always be set
            blockHeight: blockHeight !== null && blockHeight !== void 0 ? blockHeight : 0,
            count: validators.length,
            total: validators.length,
            validators: validators
        };
    }
    // doCall is a helper to handle the encode/call/decode logic
    async doCall(request, encode, decode) {
        const req = encode(request);
        const result = await this.client.execute(req);
        return decode(result);
    }
    subscribe(request, decode) {
        if (!(0, $lqv7L.instanceOfRpcStreamingClient)(this.client)) throw new Error("This RPC client type cannot subscribe to events");
        const req = this.p.encodeSubscribe(request);
        const eventStream = this.client.listen(req);
        return eventStream.map((event)=>{
            return decode(event);
        });
    }
    /**
     * Use `Tendermint34Client.connect` or `Tendermint34Client.create` to create an instance.
     */ constructor(client){
        this.client = client;
        this.p = $cu1uI.adaptor34.params;
        this.r = $cu1uI.adaptor34.responses;
    }
}
module.exports.Tendermint34Client = $1916f5cc5e1b902f$var$Tendermint34Client;

});
parcelRegister("8XYR9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createJsonRpcRequest = void 0;
const $68730a32741ebc56$var$numbersWithoutZero = "123456789";
/** generates a random numeric character  */ function $68730a32741ebc56$var$randomNumericChar() {
    return $68730a32741ebc56$var$numbersWithoutZero[Math.floor(Math.random() * $68730a32741ebc56$var$numbersWithoutZero.length)];
}
/**
 * An (absolutely not cryptographically secure) random integer > 0.
 */ function $68730a32741ebc56$var$randomId() {
    return parseInt(Array.from({
        length: 12
    }).map(()=>$68730a32741ebc56$var$randomNumericChar()).join(""), 10);
}
/** Creates a JSON-RPC request with random ID */ // eslint-disable-next-line @typescript-eslint/ban-types
function $68730a32741ebc56$var$createJsonRpcRequest(method, params) {
    const paramsCopy = params ? {
        ...params
    } : {};
    return {
        jsonrpc: "2.0",
        id: $68730a32741ebc56$var$randomId(),
        method: method,
        params: paramsCopy
    };
}
module.exports.createJsonRpcRequest = $68730a32741ebc56$var$createJsonRpcRequest;

});

parcelRegister("lqv7L", function(module, exports) {
"use strict";
// This folder contains Tendermint-specific RPC clients
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WebsocketClient = module.exports.instanceOfRpcStreamingClient = module.exports.HttpClient = void 0;

var $85v01 = parcelRequire("85v01");
Object.defineProperty(module.exports, "HttpClient", {
    enumerable: true,
    get: function() {
        return $85v01.HttpClient;
    }
});

var $84BdO = parcelRequire("84BdO");
Object.defineProperty(module.exports, "instanceOfRpcStreamingClient", {
    enumerable: true,
    get: function() {
        return $84BdO.instanceOfRpcStreamingClient;
    }
});

var $5R6Vu = parcelRequire("5R6Vu");
Object.defineProperty(module.exports, "WebsocketClient", {
    enumerable: true,
    get: function() {
        return $5R6Vu.WebsocketClient;
    }
});

});
parcelRegister("85v01", function(module, exports) {
"use strict";
var $5e36d62d172a783b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HttpClient = module.exports.http = void 0;

var $8CzXL = parcelRequire("8CzXL");

const $5e36d62d172a783b$var$axios_1 = $5e36d62d172a783b$var$__importDefault((parcelRequire("6kVcs")));

var $84BdO = parcelRequire("84BdO");
function $5e36d62d172a783b$var$filterBadStatus(res) {
    if (res.status >= 400) throw new Error(`Bad status on response: ${res.status}`);
    return res;
}
/**
 * Helper to work around missing CORS support in Tendermint (https://github.com/tendermint/tendermint/pull/2800)
 *
 * For some reason, fetch does not complain about missing server-side CORS support.
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
async function $5e36d62d172a783b$var$http(method, url, headers, request) {
    if (typeof fetch !== "undefined") {
        const settings = {
            method: method,
            body: request ? JSON.stringify(request) : undefined,
            headers: {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                "Content-Type": "application/json",
                ...headers
            }
        };
        return fetch(url, settings).then($5e36d62d172a783b$var$filterBadStatus).then((res)=>res.json());
    } else return $5e36d62d172a783b$var$axios_1.default.request({
        url: url,
        method: method,
        data: request,
        headers: headers
    }).then((res)=>res.data);
}
module.exports.http = $5e36d62d172a783b$var$http;
class $5e36d62d172a783b$var$HttpClient {
    disconnect() {
    // nothing to be done
    }
    async execute(request) {
        const response = (0, $8CzXL.parseJsonRpcResponse)(await $5e36d62d172a783b$var$http("POST", this.url, this.headers, request));
        if ((0, $8CzXL.isJsonRpcErrorResponse)(response)) throw new Error(JSON.stringify(response.error));
        return response;
    }
    constructor(endpoint){
        if (typeof endpoint === "string") // accept host.name:port and assume http protocol
        this.url = (0, $84BdO.hasProtocol)(endpoint) ? endpoint : "http://" + endpoint;
        else {
            this.url = endpoint.url;
            this.headers = endpoint.headers;
        }
    }
}
module.exports.HttpClient = $5e36d62d172a783b$var$HttpClient;

});
parcelRegister("8CzXL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.jsonRpcCode = module.exports.isJsonRpcSuccessResponse = module.exports.isJsonRpcErrorResponse = module.exports.parseJsonRpcSuccessResponse = module.exports.parseJsonRpcResponse = module.exports.parseJsonRpcRequest = module.exports.parseJsonRpcId = module.exports.parseJsonRpcErrorResponse = module.exports.JsonRpcClient = module.exports.makeJsonRpcId = void 0;

var $hWQoA = parcelRequire("hWQoA");
Object.defineProperty(module.exports, "makeJsonRpcId", {
    enumerable: true,
    get: function() {
        return $hWQoA.makeJsonRpcId;
    }
});

var $k9o6U = parcelRequire("k9o6U");
Object.defineProperty(module.exports, "JsonRpcClient", {
    enumerable: true,
    get: function() {
        return $k9o6U.JsonRpcClient;
    }
});

var $3U7KU = parcelRequire("3U7KU");
Object.defineProperty(module.exports, "parseJsonRpcErrorResponse", {
    enumerable: true,
    get: function() {
        return $3U7KU.parseJsonRpcErrorResponse;
    }
});
Object.defineProperty(module.exports, "parseJsonRpcId", {
    enumerable: true,
    get: function() {
        return $3U7KU.parseJsonRpcId;
    }
});
Object.defineProperty(module.exports, "parseJsonRpcRequest", {
    enumerable: true,
    get: function() {
        return $3U7KU.parseJsonRpcRequest;
    }
});
Object.defineProperty(module.exports, "parseJsonRpcResponse", {
    enumerable: true,
    get: function() {
        return $3U7KU.parseJsonRpcResponse;
    }
});
Object.defineProperty(module.exports, "parseJsonRpcSuccessResponse", {
    enumerable: true,
    get: function() {
        return $3U7KU.parseJsonRpcSuccessResponse;
    }
});

var $4bhB4 = parcelRequire("4bhB4");
Object.defineProperty(module.exports, "isJsonRpcErrorResponse", {
    enumerable: true,
    get: function() {
        return $4bhB4.isJsonRpcErrorResponse;
    }
});
Object.defineProperty(module.exports, "isJsonRpcSuccessResponse", {
    enumerable: true,
    get: function() {
        return $4bhB4.isJsonRpcSuccessResponse;
    }
});
Object.defineProperty(module.exports, "jsonRpcCode", {
    enumerable: true,
    get: function() {
        return $4bhB4.jsonRpcCode;
    }
});

});
parcelRegister("hWQoA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.makeJsonRpcId = void 0;
// Start with 10001 to avoid possible collisions with all hand-selected values like e.g. 1,2,3,42,100
let $d1107f1979c58522$var$counter = 10000;
/**
 * Creates a new ID to be used for creating a JSON-RPC request.
 *
 * Multiple calls of this produce unique values.
 *
 * The output may be any value compatible to JSON-RPC request IDs with an undefined output format and generation logic.
 */ function $d1107f1979c58522$var$makeJsonRpcId() {
    return $d1107f1979c58522$var$counter += 1;
}
module.exports.makeJsonRpcId = $d1107f1979c58522$var$makeJsonRpcId;

});

parcelRegister("k9o6U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JsonRpcClient = void 0;

var $9XZPj = parcelRequire("9XZPj");

var $4bhB4 = parcelRequire("4bhB4");
/**
 * A thin wrapper that is used to bring together requests and responses by ID.
 *
 * Using this class is only advised for continous communication channels like
 * WebSockets or WebWorker messaging.
 */ class $eab759c02dee762d$var$JsonRpcClient {
    async run(request) {
        const filteredStream = this.connection.responseStream.filter((r)=>r.id === request.id);
        const pendingResponses = (0, $9XZPj.firstEvent)(filteredStream);
        this.connection.sendRequest(request);
        const response = await pendingResponses;
        if ((0, $4bhB4.isJsonRpcErrorResponse)(response)) {
            const error = response.error;
            throw new Error(`JSON RPC error: code=${error.code}; message='${error.message}'`);
        }
        return response;
    }
    constructor(connection){
        this.connection = connection;
    }
}
module.exports.JsonRpcClient = $eab759c02dee762d$var$JsonRpcClient;

});
parcelRegister("9XZPj", function(module, exports) {
"use strict";
var $7419953e2ab31f69$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7419953e2ab31f69$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $7419953e2ab31f69$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ValueAndUpdates = module.exports.toListPromise = module.exports.fromListPromise = module.exports.firstEvent = module.exports.dropDuplicates = module.exports.DefaultValueProducer = module.exports.concat = void 0;

var $dsaR2 = parcelRequire("dsaR2");
Object.defineProperty(module.exports, "concat", {
    enumerable: true,
    get: function() {
        return $dsaR2.concat;
    }
});

var $l01Ia = parcelRequire("l01Ia");
Object.defineProperty(module.exports, "DefaultValueProducer", {
    enumerable: true,
    get: function() {
        return $l01Ia.DefaultValueProducer;
    }
});

var $iCp6p = parcelRequire("iCp6p");
Object.defineProperty(module.exports, "dropDuplicates", {
    enumerable: true,
    get: function() {
        return $iCp6p.dropDuplicates;
    }
});

var $igMit = parcelRequire("igMit");
Object.defineProperty(module.exports, "firstEvent", {
    enumerable: true,
    get: function() {
        return $igMit.firstEvent;
    }
});
Object.defineProperty(module.exports, "fromListPromise", {
    enumerable: true,
    get: function() {
        return $igMit.fromListPromise;
    }
});
Object.defineProperty(module.exports, "toListPromise", {
    enumerable: true,
    get: function() {
        return $igMit.toListPromise;
    }
});

$7419953e2ab31f69$var$__exportStar((parcelRequire("jTpda")), module.exports);

var $e3MQD = parcelRequire("e3MQD");
Object.defineProperty(module.exports, "ValueAndUpdates", {
    enumerable: true,
    get: function() {
        return $e3MQD.ValueAndUpdates;
    }
});

});
parcelRegister("dsaR2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.concat = void 0;

var $kCwQy = parcelRequire("kCwQy");
/**
 * An implementation of concat that buffers all source stream events
 *
 * Marble diagram:
 *
 * ```text
 * --1--2---3---4-|
 * -a--b-c--d-|
 * --------X---------Y---------Z-
 *           concat
 * --1--2---3---4-abcdXY-------Z-
 * ```
 *
 * This is inspired by RxJS's concat as documented at http://rxmarbles.com/#concat and behaves
 * differently than xstream's concat as discussed in https://github.com/staltz/xstream/issues/170.
 *
 */ function $9cb64f5a348cdfaf$var$concat(...streams) {
    const subscriptions = new Array();
    const queues = new Array(); // one queue per stream
    const completedStreams = new Set();
    let activeStreamIndex = 0;
    function reset() {
        while(subscriptions.length > 0){
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const subscription = subscriptions.shift();
            subscription.unsubscribe();
        }
        queues.length = 0;
        completedStreams.clear();
        activeStreamIndex = 0;
    }
    const producer = {
        start: (listener)=>{
            streams.forEach((_)=>queues.push([]));
            function emitAllQueuesEvents(streamIndex) {
                // eslint-disable-next-line no-constant-condition
                while(true){
                    const element = queues[streamIndex].shift();
                    if (element === undefined) return;
                    listener.next(element);
                }
            }
            function isDone() {
                return activeStreamIndex >= streams.length;
            }
            if (isDone()) {
                listener.complete();
                return;
            }
            streams.forEach((stream, index)=>{
                subscriptions.push(stream.subscribe({
                    next: (value)=>{
                        if (index === activeStreamIndex) listener.next(value);
                        else queues[index].push(value);
                    },
                    complete: ()=>{
                        completedStreams.add(index);
                        while(completedStreams.has(activeStreamIndex)){
                            // this stream completed: emit all and move on
                            emitAllQueuesEvents(activeStreamIndex);
                            activeStreamIndex++;
                        }
                        if (isDone()) listener.complete();
                        else // now active stream can have some events queued but did not yet complete
                        emitAllQueuesEvents(activeStreamIndex);
                    },
                    error: (error)=>{
                        listener.error(error);
                        reset();
                    }
                }));
            });
        },
        stop: ()=>{
            reset();
        }
    };
    return $kCwQy.Stream.create(producer);
}
module.exports.concat = $9cb64f5a348cdfaf$var$concat;

});
parcelRegister("kCwQy", function(module, exports) {
"use strict";
var $f030d5e7d7e71b97$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NO_IL = module.exports.NO = module.exports.MemoryStream = module.exports.Stream = void 0;

var $lk3VL = parcelRequire("lk3VL");

var $2FvTv = parcelRequire("2FvTv");
var $f030d5e7d7e71b97$var$$$observable = $lk3VL.default($2FvTv.getPolyfill());
var $f030d5e7d7e71b97$var$NO = {};
module.exports.NO = $f030d5e7d7e71b97$var$NO;
function $f030d5e7d7e71b97$var$noop() {}
function $f030d5e7d7e71b97$var$cp(a) {
    var l = a.length;
    var b = Array(l);
    for(var i = 0; i < l; ++i)b[i] = a[i];
    return b;
}
function $f030d5e7d7e71b97$var$and(f1, f2) {
    return function andFn(t) {
        return f1(t) && f2(t);
    };
}
function $f030d5e7d7e71b97$var$_try(c, t, u) {
    try {
        return c.f(t);
    } catch (e) {
        u._e(e);
        return $f030d5e7d7e71b97$var$NO;
    }
}
var $f030d5e7d7e71b97$var$NO_IL = {
    _n: $f030d5e7d7e71b97$var$noop,
    _e: $f030d5e7d7e71b97$var$noop,
    _c: $f030d5e7d7e71b97$var$noop
};
module.exports.NO_IL = $f030d5e7d7e71b97$var$NO_IL;
// mutates the input
function $f030d5e7d7e71b97$var$internalizeProducer(producer) {
    producer._start = function _start(il) {
        il.next = il._n;
        il.error = il._e;
        il.complete = il._c;
        this.start(il);
    };
    producer._stop = producer.stop;
}
var $f030d5e7d7e71b97$var$StreamSub = /** @class */ function() {
    function StreamSub(_stream, _listener) {
        this._stream = _stream;
        this._listener = _listener;
    }
    StreamSub.prototype.unsubscribe = function() {
        this._stream._remove(this._listener);
    };
    return StreamSub;
}();
var $f030d5e7d7e71b97$var$Observer = /** @class */ function() {
    function Observer(_listener) {
        this._listener = _listener;
    }
    Observer.prototype.next = function(value) {
        this._listener._n(value);
    };
    Observer.prototype.error = function(err) {
        this._listener._e(err);
    };
    Observer.prototype.complete = function() {
        this._listener._c();
    };
    return Observer;
}();
var $f030d5e7d7e71b97$var$FromObservable = /** @class */ function() {
    function FromObservable(observable) {
        this.type = "fromObservable";
        this.ins = observable;
        this.active = false;
    }
    FromObservable.prototype._start = function(out) {
        this.out = out;
        this.active = true;
        this._sub = this.ins.subscribe(new $f030d5e7d7e71b97$var$Observer(out));
        if (!this.active) this._sub.unsubscribe();
    };
    FromObservable.prototype._stop = function() {
        if (this._sub) this._sub.unsubscribe();
        this.active = false;
    };
    return FromObservable;
}();
var $f030d5e7d7e71b97$var$Merge = /** @class */ function() {
    function Merge(insArr) {
        this.type = "merge";
        this.insArr = insArr;
        this.out = $f030d5e7d7e71b97$var$NO;
        this.ac = 0;
    }
    Merge.prototype._start = function(out) {
        this.out = out;
        var s = this.insArr;
        var L = s.length;
        this.ac = L;
        for(var i = 0; i < L; i++)s[i]._add(this);
    };
    Merge.prototype._stop = function() {
        var s = this.insArr;
        var L = s.length;
        for(var i = 0; i < L; i++)s[i]._remove(this);
        this.out = $f030d5e7d7e71b97$var$NO;
    };
    Merge.prototype._n = function(t) {
        var u = this.out;
        if (u === $f030d5e7d7e71b97$var$NO) return;
        u._n(t);
    };
    Merge.prototype._e = function(err) {
        var u = this.out;
        if (u === $f030d5e7d7e71b97$var$NO) return;
        u._e(err);
    };
    Merge.prototype._c = function() {
        if (--this.ac <= 0) {
            var u = this.out;
            if (u === $f030d5e7d7e71b97$var$NO) return;
            u._c();
        }
    };
    return Merge;
}();
var $f030d5e7d7e71b97$var$CombineListener = /** @class */ function() {
    function CombineListener(i, out, p) {
        this.i = i;
        this.out = out;
        this.p = p;
        p.ils.push(this);
    }
    CombineListener.prototype._n = function(t) {
        var p = this.p, out = this.out;
        if (out === $f030d5e7d7e71b97$var$NO) return;
        if (p.up(t, this.i)) {
            var b = $f030d5e7d7e71b97$var$cp(p.vals);
            out._n(b);
        }
    };
    CombineListener.prototype._e = function(err) {
        var out = this.out;
        if (out === $f030d5e7d7e71b97$var$NO) return;
        out._e(err);
    };
    CombineListener.prototype._c = function() {
        var p = this.p;
        if (p.out === $f030d5e7d7e71b97$var$NO) return;
        if (--p.Nc === 0) p.out._c();
    };
    return CombineListener;
}();
var $f030d5e7d7e71b97$var$Combine = /** @class */ function() {
    function Combine(insArr) {
        this.type = "combine";
        this.insArr = insArr;
        this.out = $f030d5e7d7e71b97$var$NO;
        this.ils = [];
        this.Nc = this.Nn = 0;
        this.vals = [];
    }
    Combine.prototype.up = function(t, i) {
        var v = this.vals[i];
        var Nn = !this.Nn ? 0 : v === $f030d5e7d7e71b97$var$NO ? --this.Nn : this.Nn;
        this.vals[i] = t;
        return Nn === 0;
    };
    Combine.prototype._start = function(out) {
        this.out = out;
        var s = this.insArr;
        var n = this.Nc = this.Nn = s.length;
        var vals = this.vals = new Array(n);
        if (n === 0) {
            out._n([]);
            out._c();
        } else for(var i = 0; i < n; i++){
            vals[i] = $f030d5e7d7e71b97$var$NO;
            s[i]._add(new $f030d5e7d7e71b97$var$CombineListener(i, out, this));
        }
    };
    Combine.prototype._stop = function() {
        var s = this.insArr;
        var n = s.length;
        var ils = this.ils;
        for(var i = 0; i < n; i++)s[i]._remove(ils[i]);
        this.out = $f030d5e7d7e71b97$var$NO;
        this.ils = [];
        this.vals = [];
    };
    return Combine;
}();
var $f030d5e7d7e71b97$var$FromArray = /** @class */ function() {
    function FromArray(a) {
        this.type = "fromArray";
        this.a = a;
    }
    FromArray.prototype._start = function(out) {
        var a = this.a;
        for(var i = 0, n = a.length; i < n; i++)out._n(a[i]);
        out._c();
    };
    FromArray.prototype._stop = function() {};
    return FromArray;
}();
var $f030d5e7d7e71b97$var$FromPromise = /** @class */ function() {
    function FromPromise(p) {
        this.type = "fromPromise";
        this.on = false;
        this.p = p;
    }
    FromPromise.prototype._start = function(out) {
        var prod = this;
        this.on = true;
        this.p.then(function(v) {
            if (prod.on) {
                out._n(v);
                out._c();
            }
        }, function(e) {
            out._e(e);
        }).then($f030d5e7d7e71b97$var$noop, function(err) {
            setTimeout(function() {
                throw err;
            });
        });
    };
    FromPromise.prototype._stop = function() {
        this.on = false;
    };
    return FromPromise;
}();
var $f030d5e7d7e71b97$var$Periodic = /** @class */ function() {
    function Periodic(period) {
        this.type = "periodic";
        this.period = period;
        this.intervalID = -1;
        this.i = 0;
    }
    Periodic.prototype._start = function(out) {
        var self = this;
        function intervalHandler() {
            out._n(self.i++);
        }
        this.intervalID = setInterval(intervalHandler, this.period);
    };
    Periodic.prototype._stop = function() {
        if (this.intervalID !== -1) clearInterval(this.intervalID);
        this.intervalID = -1;
        this.i = 0;
    };
    return Periodic;
}();
var $f030d5e7d7e71b97$var$Debug = /** @class */ function() {
    function Debug(ins, arg) {
        this.type = "debug";
        this.ins = ins;
        this.out = $f030d5e7d7e71b97$var$NO;
        this.s = $f030d5e7d7e71b97$var$noop;
        this.l = "";
        if (typeof arg === "string") this.l = arg;
        else if (typeof arg === "function") this.s = arg;
    }
    Debug.prototype._start = function(out) {
        this.out = out;
        this.ins._add(this);
    };
    Debug.prototype._stop = function() {
        this.ins._remove(this);
        this.out = $f030d5e7d7e71b97$var$NO;
    };
    Debug.prototype._n = function(t) {
        var u = this.out;
        if (u === $f030d5e7d7e71b97$var$NO) return;
        var s = this.s, l = this.l;
        if (s !== $f030d5e7d7e71b97$var$noop) try {
            s(t);
        } catch (e) {
            u._e(e);
        }
        else if (l) console.log(l + ":", t);
        else console.log(t);
        u._n(t);
    };
    Debug.prototype._e = function(err) {
        var u = this.out;
        if (u === $f030d5e7d7e71b97$var$NO) return;
        u._e(err);
    };
    Debug.prototype._c = function() {
        var u = this.out;
        if (u === $f030d5e7d7e71b97$var$NO) return;
        u._c();
    };
    return Debug;
}();
var $f030d5e7d7e71b97$var$Drop = /** @class */ function() {
    function Drop(max, ins) {
        this.type = "drop";
        this.ins = ins;
        this.out = $f030d5e7d7e71b97$var$NO;
        this.max = max;
        this.dropped = 0;
    }
    Drop.prototype._start = function(out) {
        this.out = out;
        this.dropped = 0;
        this.ins._add(this);
    };
    Drop.prototype._stop = function() {
        this.ins._remove(this);
        this.out = $f030d5e7d7e71b97$var$NO;
    };
    Drop.prototype._n = function(t) {
        var u = this.out;
        if (u === $f030d5e7d7e71b97$var$NO) return;
        if (this.dropped++ >= this.max) u._n(t);
    };
    Drop.prototype._e = function(err) {
        var u = this.out;
        if (u === $f030d5e7d7e71b97$var$NO) return;
        u._e(err);
    };
    Drop.prototype._c = function() {
        var u = this.out;
        if (u === $f030d5e7d7e71b97$var$NO) return;
        u._c();
    };
    return Drop;
}();
var $f030d5e7d7e71b97$var$EndWhenListener = /** @class */ function() {
    function EndWhenListener(out, op) {
        this.out = out;
        this.op = op;
    }
    EndWhenListener.prototype._n = function() {
        this.op.end();
    };
    EndWhenListener.prototype._e = function(err) {
        this.out._e(err);
    };
    EndWhenListener.prototype._c = function() {
        this.op.end();
    };
    return EndWhenListener;
}();
var $f030d5e7d7e71b97$var$EndWhen = /** @class */ function() {
    function EndWhen(o, ins) {
        this.type = "endWhen";
        this.ins = ins;
        this.out = $f030d5e7d7e71b97$var$NO;
        this.o = o;
        this.oil = $f030d5e7d7e71b97$var$NO_IL;
    }
    EndWhen.prototype._start = function(out) {
        this.out = out;
        this.o._add(this.oil = new $f030d5e7d7e71b97$var$EndWhenListener(out, this));
        this.ins._add(this);
    };
    EndWhen.prototype._stop = function() {
        this.ins._remove(this);
        this.o._remove(this.oil);
        this.out = $f030d5e7d7e71b97$var$NO;
        this.oil = $f030d5e7d7e71b97$var$NO_IL;
    };
    EndWhen.prototype.end = function() {
        var u = this.out;
        if (u === $f030d5e7d7e71b97$var$NO) return;
        u._c();
    };
    EndWhen.prototype._n = function(t) {
        var u = this.out;
        if (u === $f030d5e7d7e71b97$var$NO) return;
        u._n(t);
    };
    EndWhen.prototype._e = function(err) {
        var u = this.out;
        if (u === $f030d5e7d7e71b97$var$NO) return;
        u._e(err);
    };
    EndWhen.prototype._c = function() {
        this.end();
    };
    return EndWhen;
}();
var $f030d5e7d7e71b97$var$Filter = /** @class */ function() {
    function Filter(passes, ins) {
        this.type = "filter";
        this.ins = ins;
        this.out = $f030d5e7d7e71b97$var$NO;
        this.f = passes;
    }
    Filter.prototype._start = function(out) {
        this.out = out;
        this.ins._add(this);
    };
    Filter.prototype._stop = function() {
        this.ins._remove(this);
        this.out = $f030d5e7d7e71b97$var$NO;
    };
    Filter.prototype._n = function(t) {
        var u = this.out;
        if (u === $f030d5e7d7e71b97$var$NO) return;
        var r = $f030d5e7d7e71b97$var$_try(this, t, u);
        if (r === $f030d5e7d7e71b97$var$NO || !r) return;
        u._n(t);
    };
    Filter.prototype._e = function(err) {
        var u = this.out;
        if (u === $f030d5e7d7e71b97$var$NO) return;
        u._e(err);
    };
    Filter.prototype._c = function() {
        var u = this.out;
        if (u === $f030d5e7d7e71b97$var$NO) return;
        u._c();
    };
    return Filter;
}();
var $f030d5e7d7e71b97$var$FlattenListener = /** @class */ function() {
    function FlattenListener(out, op) {
        this.out = out;
        this.op = op;
    }
    FlattenListener.prototype._n = function(t) {
        this.out._n(t);
    };
    FlattenListener.prototype._e = function(err) {
        this.out._e(err);
    };
    FlattenListener.prototype._c = function() {
        this.op.inner = $f030d5e7d7e71b97$var$NO;
        this.op.less();
    };
    return FlattenListener;
}();
var $f030d5e7d7e71b97$var$Flatten = /** @class */ function() {
    function Flatten(ins) {
        this.type = "flatten";
        this.ins = ins;
        this.out = $f030d5e7d7e71b97$var$NO;
        this.open = true;
        this.inner = $f030d5e7d7e71b97$var$NO;
        this.il = $f030d5e7d7e71b97$var$NO_IL;
    }
    Flatten.prototype._start = function(out) {
        this.out = out;
        this.open = true;
        this.inner = $f030d5e7d7e71b97$var$NO;
        this.il = $f030d5e7d7e71b97$var$NO_IL;
        this.ins._add(this);
    };
    Flatten.prototype._stop = function() {
        this.ins._remove(this);
        if (this.inner !== $f030d5e7d7e71b97$var$NO) this.inner._remove(this.il);
        this.out = $f030d5e7d7e71b97$var$NO;
        this.open = true;
        this.inner = $f030d5e7d7e71b97$var$NO;
        this.il = $f030d5e7d7e71b97$var$NO_IL;
    };
    Flatten.prototype.less = function() {
        var u = this.out;
        if (u === $f030d5e7d7e71b97$var$NO) return;
        if (!this.open && this.inner === $f030d5e7d7e71b97$var$NO) u._c();
    };
    Flatten.prototype._n = function(s) {
        var u = this.out;
        if (u === $f030d5e7d7e71b97$var$NO) return;
        var _a = this, inner = _a.inner, il = _a.il;
        if (inner !== $f030d5e7d7e71b97$var$NO && il !== $f030d5e7d7e71b97$var$NO_IL) inner._remove(il);
        (this.inner = s)._add(this.il = new $f030d5e7d7e71b97$var$FlattenListener(u, this));
    };
    Flatten.prototype._e = function(err) {
        var u = this.out;
        if (u === $f030d5e7d7e71b97$var$NO) return;
        u._e(err);
    };
    Flatten.prototype._c = function() {
        this.open = false;
        this.less();
    };
    return Flatten;
}();
var $f030d5e7d7e71b97$var$Fold = /** @class */ function() {
    function Fold(f, seed, ins) {
        var _this = this;
        this.type = "fold";
        this.ins = ins;
        this.out = $f030d5e7d7e71b97$var$NO;
        this.f = function(t) {
            return f(_this.acc, t);
        };
        this.acc = this.seed = seed;
    }
    Fold.prototype._start = function(out) {
        this.out = out;
        this.acc = this.seed;
        out._n(this.acc);
        this.ins._add(this);
    };
    Fold.prototype._stop = function() {
        this.ins._remove(this);
        this.out = $f030d5e7d7e71b97$var$NO;
        this.acc = this.seed;
    };
    Fold.prototype._n = function(t) {
        var u = this.out;
        if (u === $f030d5e7d7e71b97$var$NO) return;
        var r = $f030d5e7d7e71b97$var$_try(this, t, u);
        if (r === $f030d5e7d7e71b97$var$NO) return;
        u._n(this.acc = r);
    };
    Fold.prototype._e = function(err) {
        var u = this.out;
        if (u === $f030d5e7d7e71b97$var$NO) return;
        u._e(err);
    };
    Fold.prototype._c = function() {
        var u = this.out;
        if (u === $f030d5e7d7e71b97$var$NO) return;
        u._c();
    };
    return Fold;
}();
var $f030d5e7d7e71b97$var$Last = /** @class */ function() {
    function Last(ins) {
        this.type = "last";
        this.ins = ins;
        this.out = $f030d5e7d7e71b97$var$NO;
        this.has = false;
        this.val = $f030d5e7d7e71b97$var$NO;
    }
    Last.prototype._start = function(out) {
        this.out = out;
        this.has = false;
        this.ins._add(this);
    };
    Last.prototype._stop = function() {
        this.ins._remove(this);
        this.out = $f030d5e7d7e71b97$var$NO;
        this.val = $f030d5e7d7e71b97$var$NO;
    };
    Last.prototype._n = function(t) {
        this.has = true;
        this.val = t;
    };
    Last.prototype._e = function(err) {
        var u = this.out;
        if (u === $f030d5e7d7e71b97$var$NO) return;
        u._e(err);
    };
    Last.prototype._c = function() {
        var u = this.out;
        if (u === $f030d5e7d7e71b97$var$NO) return;
        if (this.has) {
            u._n(this.val);
            u._c();
        } else u._e(new Error("last() failed because input stream completed"));
    };
    return Last;
}();
var $f030d5e7d7e71b97$var$MapOp = /** @class */ function() {
    function MapOp(project, ins) {
        this.type = "map";
        this.ins = ins;
        this.out = $f030d5e7d7e71b97$var$NO;
        this.f = project;
    }
    MapOp.prototype._start = function(out) {
        this.out = out;
        this.ins._add(this);
    };
    MapOp.prototype._stop = function() {
        this.ins._remove(this);
        this.out = $f030d5e7d7e71b97$var$NO;
    };
    MapOp.prototype._n = function(t) {
        var u = this.out;
        if (u === $f030d5e7d7e71b97$var$NO) return;
        var r = $f030d5e7d7e71b97$var$_try(this, t, u);
        if (r === $f030d5e7d7e71b97$var$NO) return;
        u._n(r);
    };
    MapOp.prototype._e = function(err) {
        var u = this.out;
        if (u === $f030d5e7d7e71b97$var$NO) return;
        u._e(err);
    };
    MapOp.prototype._c = function() {
        var u = this.out;
        if (u === $f030d5e7d7e71b97$var$NO) return;
        u._c();
    };
    return MapOp;
}();
var $f030d5e7d7e71b97$var$Remember = /** @class */ function() {
    function Remember(ins) {
        this.type = "remember";
        this.ins = ins;
        this.out = $f030d5e7d7e71b97$var$NO;
    }
    Remember.prototype._start = function(out) {
        this.out = out;
        this.ins._add(out);
    };
    Remember.prototype._stop = function() {
        this.ins._remove(this.out);
        this.out = $f030d5e7d7e71b97$var$NO;
    };
    return Remember;
}();
var $f030d5e7d7e71b97$var$ReplaceError = /** @class */ function() {
    function ReplaceError(replacer, ins) {
        this.type = "replaceError";
        this.ins = ins;
        this.out = $f030d5e7d7e71b97$var$NO;
        this.f = replacer;
    }
    ReplaceError.prototype._start = function(out) {
        this.out = out;
        this.ins._add(this);
    };
    ReplaceError.prototype._stop = function() {
        this.ins._remove(this);
        this.out = $f030d5e7d7e71b97$var$NO;
    };
    ReplaceError.prototype._n = function(t) {
        var u = this.out;
        if (u === $f030d5e7d7e71b97$var$NO) return;
        u._n(t);
    };
    ReplaceError.prototype._e = function(err) {
        var u = this.out;
        if (u === $f030d5e7d7e71b97$var$NO) return;
        try {
            this.ins._remove(this);
            (this.ins = this.f(err))._add(this);
        } catch (e) {
            u._e(e);
        }
    };
    ReplaceError.prototype._c = function() {
        var u = this.out;
        if (u === $f030d5e7d7e71b97$var$NO) return;
        u._c();
    };
    return ReplaceError;
}();
var $f030d5e7d7e71b97$var$StartWith = /** @class */ function() {
    function StartWith(ins, val) {
        this.type = "startWith";
        this.ins = ins;
        this.out = $f030d5e7d7e71b97$var$NO;
        this.val = val;
    }
    StartWith.prototype._start = function(out) {
        this.out = out;
        this.out._n(this.val);
        this.ins._add(out);
    };
    StartWith.prototype._stop = function() {
        this.ins._remove(this.out);
        this.out = $f030d5e7d7e71b97$var$NO;
    };
    return StartWith;
}();
var $f030d5e7d7e71b97$var$Take = /** @class */ function() {
    function Take(max, ins) {
        this.type = "take";
        this.ins = ins;
        this.out = $f030d5e7d7e71b97$var$NO;
        this.max = max;
        this.taken = 0;
    }
    Take.prototype._start = function(out) {
        this.out = out;
        this.taken = 0;
        if (this.max <= 0) out._c();
        else this.ins._add(this);
    };
    Take.prototype._stop = function() {
        this.ins._remove(this);
        this.out = $f030d5e7d7e71b97$var$NO;
    };
    Take.prototype._n = function(t) {
        var u = this.out;
        if (u === $f030d5e7d7e71b97$var$NO) return;
        var m = ++this.taken;
        if (m < this.max) u._n(t);
        else if (m === this.max) {
            u._n(t);
            u._c();
        }
    };
    Take.prototype._e = function(err) {
        var u = this.out;
        if (u === $f030d5e7d7e71b97$var$NO) return;
        u._e(err);
    };
    Take.prototype._c = function() {
        var u = this.out;
        if (u === $f030d5e7d7e71b97$var$NO) return;
        u._c();
    };
    return Take;
}();
var $f030d5e7d7e71b97$var$Stream = /** @class */ function() {
    function Stream(producer) {
        this._prod = producer || $f030d5e7d7e71b97$var$NO;
        this._ils = [];
        this._stopID = $f030d5e7d7e71b97$var$NO;
        this._dl = $f030d5e7d7e71b97$var$NO;
        this._d = false;
        this._target = null;
        this._err = $f030d5e7d7e71b97$var$NO;
    }
    Stream.prototype._n = function(t) {
        var a = this._ils;
        var L = a.length;
        if (this._d) this._dl._n(t);
        if (L == 1) a[0]._n(t);
        else if (L == 0) return;
        else {
            var b = $f030d5e7d7e71b97$var$cp(a);
            for(var i = 0; i < L; i++)b[i]._n(t);
        }
    };
    Stream.prototype._e = function(err) {
        if (this._err !== $f030d5e7d7e71b97$var$NO) return;
        this._err = err;
        var a = this._ils;
        var L = a.length;
        this._x();
        if (this._d) this._dl._e(err);
        if (L == 1) a[0]._e(err);
        else if (L == 0) return;
        else {
            var b = $f030d5e7d7e71b97$var$cp(a);
            for(var i = 0; i < L; i++)b[i]._e(err);
        }
        if (!this._d && L == 0) throw this._err;
    };
    Stream.prototype._c = function() {
        var a = this._ils;
        var L = a.length;
        this._x();
        if (this._d) this._dl._c();
        if (L == 1) a[0]._c();
        else if (L == 0) return;
        else {
            var b = $f030d5e7d7e71b97$var$cp(a);
            for(var i = 0; i < L; i++)b[i]._c();
        }
    };
    Stream.prototype._x = function() {
        if (this._ils.length === 0) return;
        if (this._prod !== $f030d5e7d7e71b97$var$NO) this._prod._stop();
        this._err = $f030d5e7d7e71b97$var$NO;
        this._ils = [];
    };
    Stream.prototype._stopNow = function() {
        // WARNING: code that calls this method should
        // first check if this._prod is valid (not `NO`)
        this._prod._stop();
        this._err = $f030d5e7d7e71b97$var$NO;
        this._stopID = $f030d5e7d7e71b97$var$NO;
    };
    Stream.prototype._add = function(il) {
        var ta = this._target;
        if (ta) return ta._add(il);
        var a = this._ils;
        a.push(il);
        if (a.length > 1) return;
        if (this._stopID !== $f030d5e7d7e71b97$var$NO) {
            clearTimeout(this._stopID);
            this._stopID = $f030d5e7d7e71b97$var$NO;
        } else {
            var p = this._prod;
            if (p !== $f030d5e7d7e71b97$var$NO) p._start(this);
        }
    };
    Stream.prototype._remove = function(il) {
        var _this = this;
        var ta = this._target;
        if (ta) return ta._remove(il);
        var a = this._ils;
        var i = a.indexOf(il);
        if (i > -1) {
            a.splice(i, 1);
            if (this._prod !== $f030d5e7d7e71b97$var$NO && a.length <= 0) {
                this._err = $f030d5e7d7e71b97$var$NO;
                this._stopID = setTimeout(function() {
                    return _this._stopNow();
                });
            } else if (a.length === 1) this._pruneCycles();
        }
    };
    // If all paths stemming from `this` stream eventually end at `this`
    // stream, then we remove the single listener of `this` stream, to
    // force it to end its execution and dispose resources. This method
    // assumes as a precondition that this._ils has just one listener.
    Stream.prototype._pruneCycles = function() {
        if (this._hasNoSinks(this, [])) this._remove(this._ils[0]);
    };
    // Checks whether *there is no* path starting from `x` that leads to an end
    // listener (sink) in the stream graph, following edges A->B where B is a
    // listener of A. This means these paths constitute a cycle somehow. Is given
    // a trace of all visited nodes so far.
    Stream.prototype._hasNoSinks = function(x, trace) {
        if (trace.indexOf(x) !== -1) return true;
        else if (x.out === this) return true;
        else if (x.out && x.out !== $f030d5e7d7e71b97$var$NO) return this._hasNoSinks(x.out, trace.concat(x));
        else if (x._ils) {
            for(var i = 0, N = x._ils.length; i < N; i++)if (!this._hasNoSinks(x._ils[i], trace.concat(x))) return false;
            return true;
        } else return false;
    };
    Stream.prototype.ctor = function() {
        return this instanceof $f030d5e7d7e71b97$var$MemoryStream ? $f030d5e7d7e71b97$var$MemoryStream : Stream;
    };
    /**
     * Adds a Listener to the Stream.
     *
     * @param {Listener} listener
     */ Stream.prototype.addListener = function(listener) {
        listener._n = listener.next || $f030d5e7d7e71b97$var$noop;
        listener._e = listener.error || $f030d5e7d7e71b97$var$noop;
        listener._c = listener.complete || $f030d5e7d7e71b97$var$noop;
        this._add(listener);
    };
    /**
     * Removes a Listener from the Stream, assuming the Listener was added to it.
     *
     * @param {Listener<T>} listener
     */ Stream.prototype.removeListener = function(listener) {
        this._remove(listener);
    };
    /**
     * Adds a Listener to the Stream returning a Subscription to remove that
     * listener.
     *
     * @param {Listener} listener
     * @returns {Subscription}
     */ Stream.prototype.subscribe = function(listener) {
        this.addListener(listener);
        return new $f030d5e7d7e71b97$var$StreamSub(this, listener);
    };
    /**
     * Add interop between most.js and RxJS 5
     *
     * @returns {Stream}
     */ Stream.prototype[$f030d5e7d7e71b97$var$$$observable] = function() {
        return this;
    };
    /**
     * Creates a new Stream given a Producer.
     *
     * @factory true
     * @param {Producer} producer An optional Producer that dictates how to
     * start, generate events, and stop the Stream.
     * @return {Stream}
     */ Stream.create = function(producer) {
        if (producer) {
            if (typeof producer.start !== "function" || typeof producer.stop !== "function") throw new Error("producer requires both start and stop functions");
            $f030d5e7d7e71b97$var$internalizeProducer(producer); // mutates the input
        }
        return new Stream(producer);
    };
    /**
     * Creates a new MemoryStream given a Producer.
     *
     * @factory true
     * @param {Producer} producer An optional Producer that dictates how to
     * start, generate events, and stop the Stream.
     * @return {MemoryStream}
     */ Stream.createWithMemory = function(producer) {
        if (producer) $f030d5e7d7e71b97$var$internalizeProducer(producer); // mutates the input
        return new $f030d5e7d7e71b97$var$MemoryStream(producer);
    };
    /**
     * Creates a Stream that does nothing when started. It never emits any event.
     *
     * Marble diagram:
     *
     * ```text
     *          never
     * -----------------------
     * ```
     *
     * @factory true
     * @return {Stream}
     */ Stream.never = function() {
        return new Stream({
            _start: $f030d5e7d7e71b97$var$noop,
            _stop: $f030d5e7d7e71b97$var$noop
        });
    };
    /**
     * Creates a Stream that immediately emits the "complete" notification when
     * started, and that's it.
     *
     * Marble diagram:
     *
     * ```text
     * empty
     * -|
     * ```
     *
     * @factory true
     * @return {Stream}
     */ Stream.empty = function() {
        return new Stream({
            _start: function(il) {
                il._c();
            },
            _stop: $f030d5e7d7e71b97$var$noop
        });
    };
    /**
     * Creates a Stream that immediately emits an "error" notification with the
     * value you passed as the `error` argument when the stream starts, and that's
     * it.
     *
     * Marble diagram:
     *
     * ```text
     * throw(X)
     * -X
     * ```
     *
     * @factory true
     * @param error The error event to emit on the created stream.
     * @return {Stream}
     */ Stream.throw = function(error) {
        return new Stream({
            _start: function(il) {
                il._e(error);
            },
            _stop: $f030d5e7d7e71b97$var$noop
        });
    };
    /**
     * Creates a stream from an Array, Promise, or an Observable.
     *
     * @factory true
     * @param {Array|PromiseLike|Observable} input The input to make a stream from.
     * @return {Stream}
     */ Stream.from = function(input) {
        if (typeof input[$f030d5e7d7e71b97$var$$$observable] === "function") return Stream.fromObservable(input);
        else if (typeof input.then === "function") return Stream.fromPromise(input);
        else if (Array.isArray(input)) return Stream.fromArray(input);
        throw new TypeError("Type of input to from() must be an Array, Promise, or Observable");
    };
    /**
     * Creates a Stream that immediately emits the arguments that you give to
     * *of*, then completes.
     *
     * Marble diagram:
     *
     * ```text
     * of(1,2,3)
     * 123|
     * ```
     *
     * @factory true
     * @param a The first value you want to emit as an event on the stream.
     * @param b The second value you want to emit as an event on the stream. One
     * or more of these values may be given as arguments.
     * @return {Stream}
     */ Stream.of = function() {
        var items = [];
        for(var _i = 0; _i < arguments.length; _i++)items[_i] = arguments[_i];
        return Stream.fromArray(items);
    };
    /**
     * Converts an array to a stream. The returned stream will emit synchronously
     * all the items in the array, and then complete.
     *
     * Marble diagram:
     *
     * ```text
     * fromArray([1,2,3])
     * 123|
     * ```
     *
     * @factory true
     * @param {Array} array The array to be converted as a stream.
     * @return {Stream}
     */ Stream.fromArray = function(array) {
        return new Stream(new $f030d5e7d7e71b97$var$FromArray(array));
    };
    /**
     * Converts a promise to a stream. The returned stream will emit the resolved
     * value of the promise, and then complete. However, if the promise is
     * rejected, the stream will emit the corresponding error.
     *
     * Marble diagram:
     *
     * ```text
     * fromPromise( ----42 )
     * -----------------42|
     * ```
     *
     * @factory true
     * @param {PromiseLike} promise The promise to be converted as a stream.
     * @return {Stream}
     */ Stream.fromPromise = function(promise) {
        return new Stream(new $f030d5e7d7e71b97$var$FromPromise(promise));
    };
    /**
     * Converts an Observable into a Stream.
     *
     * @factory true
     * @param {any} observable The observable to be converted as a stream.
     * @return {Stream}
     */ Stream.fromObservable = function(obs) {
        if (obs.endWhen !== undefined) return obs;
        var o = typeof obs[$f030d5e7d7e71b97$var$$$observable] === "function" ? obs[$f030d5e7d7e71b97$var$$$observable]() : obs;
        return new Stream(new $f030d5e7d7e71b97$var$FromObservable(o));
    };
    /**
     * Creates a stream that periodically emits incremental numbers, every
     * `period` milliseconds.
     *
     * Marble diagram:
     *
     * ```text
     *     periodic(1000)
     * ---0---1---2---3---4---...
     * ```
     *
     * @factory true
     * @param {number} period The interval in milliseconds to use as a rate of
     * emission.
     * @return {Stream}
     */ Stream.periodic = function(period) {
        return new Stream(new $f030d5e7d7e71b97$var$Periodic(period));
    };
    Stream.prototype._map = function(project) {
        return new (this.ctor())(new $f030d5e7d7e71b97$var$MapOp(project, this));
    };
    /**
     * Transforms each event from the input Stream through a `project` function,
     * to get a Stream that emits those transformed events.
     *
     * Marble diagram:
     *
     * ```text
     * --1---3--5-----7------
     *    map(i => i * 10)
     * --10--30-50----70-----
     * ```
     *
     * @param {Function} project A function of type `(t: T) => U` that takes event
     * `t` of type `T` from the input Stream and produces an event of type `U`, to
     * be emitted on the output Stream.
     * @return {Stream}
     */ Stream.prototype.map = function(project) {
        return this._map(project);
    };
    /**
     * It's like `map`, but transforms each input event to always the same
     * constant value on the output Stream.
     *
     * Marble diagram:
     *
     * ```text
     * --1---3--5-----7-----
     *       mapTo(10)
     * --10--10-10----10----
     * ```
     *
     * @param projectedValue A value to emit on the output Stream whenever the
     * input Stream emits any value.
     * @return {Stream}
     */ Stream.prototype.mapTo = function(projectedValue) {
        var s = this.map(function() {
            return projectedValue;
        });
        var op = s._prod;
        op.type = "mapTo";
        return s;
    };
    /**
     * Only allows events that pass the test given by the `passes` argument.
     *
     * Each event from the input stream is given to the `passes` function. If the
     * function returns `true`, the event is forwarded to the output stream,
     * otherwise it is ignored and not forwarded.
     *
     * Marble diagram:
     *
     * ```text
     * --1---2--3-----4-----5---6--7-8--
     *     filter(i => i % 2 === 0)
     * ------2--------4---------6----8--
     * ```
     *
     * @param {Function} passes A function of type `(t: T) => boolean` that takes
     * an event from the input stream and checks if it passes, by returning a
     * boolean.
     * @return {Stream}
     */ Stream.prototype.filter = function(passes) {
        var p = this._prod;
        if (p instanceof $f030d5e7d7e71b97$var$Filter) return new Stream(new $f030d5e7d7e71b97$var$Filter($f030d5e7d7e71b97$var$and(p.f, passes), p.ins));
        return new Stream(new $f030d5e7d7e71b97$var$Filter(passes, this));
    };
    /**
     * Lets the first `amount` many events from the input stream pass to the
     * output stream, then makes the output stream complete.
     *
     * Marble diagram:
     *
     * ```text
     * --a---b--c----d---e--
     *    take(3)
     * --a---b--c|
     * ```
     *
     * @param {number} amount How many events to allow from the input stream
     * before completing the output stream.
     * @return {Stream}
     */ Stream.prototype.take = function(amount) {
        return new (this.ctor())(new $f030d5e7d7e71b97$var$Take(amount, this));
    };
    /**
     * Ignores the first `amount` many events from the input stream, and then
     * after that starts forwarding events from the input stream to the output
     * stream.
     *
     * Marble diagram:
     *
     * ```text
     * --a---b--c----d---e--
     *       drop(3)
     * --------------d---e--
     * ```
     *
     * @param {number} amount How many events to ignore from the input stream
     * before forwarding all events from the input stream to the output stream.
     * @return {Stream}
     */ Stream.prototype.drop = function(amount) {
        return new Stream(new $f030d5e7d7e71b97$var$Drop(amount, this));
    };
    /**
     * When the input stream completes, the output stream will emit the last event
     * emitted by the input stream, and then will also complete.
     *
     * Marble diagram:
     *
     * ```text
     * --a---b--c--d----|
     *       last()
     * -----------------d|
     * ```
     *
     * @return {Stream}
     */ Stream.prototype.last = function() {
        return new Stream(new $f030d5e7d7e71b97$var$Last(this));
    };
    /**
     * Prepends the given `initial` value to the sequence of events emitted by the
     * input stream. The returned stream is a MemoryStream, which means it is
     * already `remember()`'d.
     *
     * Marble diagram:
     *
     * ```text
     * ---1---2-----3---
     *   startWith(0)
     * 0--1---2-----3---
     * ```
     *
     * @param initial The value or event to prepend.
     * @return {MemoryStream}
     */ Stream.prototype.startWith = function(initial) {
        return new $f030d5e7d7e71b97$var$MemoryStream(new $f030d5e7d7e71b97$var$StartWith(this, initial));
    };
    /**
     * Uses another stream to determine when to complete the current stream.
     *
     * When the given `other` stream emits an event or completes, the output
     * stream will complete. Before that happens, the output stream will behaves
     * like the input stream.
     *
     * Marble diagram:
     *
     * ```text
     * ---1---2-----3--4----5----6---
     *   endWhen( --------a--b--| )
     * ---1---2-----3--4--|
     * ```
     *
     * @param other Some other stream that is used to know when should the output
     * stream of this operator complete.
     * @return {Stream}
     */ Stream.prototype.endWhen = function(other) {
        return new (this.ctor())(new $f030d5e7d7e71b97$var$EndWhen(other, this));
    };
    /**
     * "Folds" the stream onto itself.
     *
     * Combines events from the past throughout
     * the entire execution of the input stream, allowing you to accumulate them
     * together. It's essentially like `Array.prototype.reduce`. The returned
     * stream is a MemoryStream, which means it is already `remember()`'d.
     *
     * The output stream starts by emitting the `seed` which you give as argument.
     * Then, when an event happens on the input stream, it is combined with that
     * seed value through the `accumulate` function, and the output value is
     * emitted on the output stream. `fold` remembers that output value as `acc`
     * ("accumulator"), and then when a new input event `t` happens, `acc` will be
     * combined with that to produce the new `acc` and so forth.
     *
     * Marble diagram:
     *
     * ```text
     * ------1-----1--2----1----1------
     *   fold((acc, x) => acc + x, 3)
     * 3-----4-----5--7----8----9------
     * ```
     *
     * @param {Function} accumulate A function of type `(acc: R, t: T) => R` that
     * takes the previous accumulated value `acc` and the incoming event from the
     * input stream and produces the new accumulated value.
     * @param seed The initial accumulated value, of type `R`.
     * @return {MemoryStream}
     */ Stream.prototype.fold = function(accumulate, seed) {
        return new $f030d5e7d7e71b97$var$MemoryStream(new $f030d5e7d7e71b97$var$Fold(accumulate, seed, this));
    };
    /**
     * Replaces an error with another stream.
     *
     * When (and if) an error happens on the input stream, instead of forwarding
     * that error to the output stream, *replaceError* will call the `replace`
     * function which returns the stream that the output stream will replicate.
     * And, in case that new stream also emits an error, `replace` will be called
     * again to get another stream to start replicating.
     *
     * Marble diagram:
     *
     * ```text
     * --1---2-----3--4-----X
     *   replaceError( () => --10--| )
     * --1---2-----3--4--------10--|
     * ```
     *
     * @param {Function} replace A function of type `(err) => Stream` that takes
     * the error that occurred on the input stream or on the previous replacement
     * stream and returns a new stream. The output stream will behave like the
     * stream that this function returns.
     * @return {Stream}
     */ Stream.prototype.replaceError = function(replace) {
        return new (this.ctor())(new $f030d5e7d7e71b97$var$ReplaceError(replace, this));
    };
    /**
     * Flattens a "stream of streams", handling only one nested stream at a time
     * (no concurrency).
     *
     * If the input stream is a stream that emits streams, then this operator will
     * return an output stream which is a flat stream: emits regular events. The
     * flattening happens without concurrency. It works like this: when the input
     * stream emits a nested stream, *flatten* will start imitating that nested
     * one. However, as soon as the next nested stream is emitted on the input
     * stream, *flatten* will forget the previous nested one it was imitating, and
     * will start imitating the new nested one.
     *
     * Marble diagram:
     *
     * ```text
     * --+--------+---------------
     *   \        \
     *    \       ----1----2---3--
     *    --a--b----c----d--------
     *           flatten
     * -----a--b------1----2---3--
     * ```
     *
     * @return {Stream}
     */ Stream.prototype.flatten = function() {
        return new Stream(new $f030d5e7d7e71b97$var$Flatten(this));
    };
    /**
     * Passes the input stream to a custom operator, to produce an output stream.
     *
     * *compose* is a handy way of using an existing function in a chained style.
     * Instead of writing `outStream = f(inStream)` you can write
     * `outStream = inStream.compose(f)`.
     *
     * @param {function} operator A function that takes a stream as input and
     * returns a stream as well.
     * @return {Stream}
     */ Stream.prototype.compose = function(operator) {
        return operator(this);
    };
    /**
     * Returns an output stream that behaves like the input stream, but also
     * remembers the most recent event that happens on the input stream, so that a
     * newly added listener will immediately receive that memorised event.
     *
     * @return {MemoryStream}
     */ Stream.prototype.remember = function() {
        return new $f030d5e7d7e71b97$var$MemoryStream(new $f030d5e7d7e71b97$var$Remember(this));
    };
    /**
     * Returns an output stream that identically behaves like the input stream,
     * but also runs a `spy` function for each event, to help you debug your app.
     *
     * *debug* takes a `spy` function as argument, and runs that for each event
     * happening on the input stream. If you don't provide the `spy` argument,
     * then *debug* will just `console.log` each event. This helps you to
     * understand the flow of events through some operator chain.
     *
     * Please note that if the output stream has no listeners, then it will not
     * start, which means `spy` will never run because no actual event happens in
     * that case.
     *
     * Marble diagram:
     *
     * ```text
     * --1----2-----3-----4--
     *         debug
     * --1----2-----3-----4--
     * ```
     *
     * @param {function} labelOrSpy A string to use as the label when printing
     * debug information on the console, or a 'spy' function that takes an event
     * as argument, and does not need to return anything.
     * @return {Stream}
     */ Stream.prototype.debug = function(labelOrSpy) {
        return new (this.ctor())(new $f030d5e7d7e71b97$var$Debug(this, labelOrSpy));
    };
    /**
     * *imitate* changes this current Stream to emit the same events that the
     * `other` given Stream does. This method returns nothing.
     *
     * This method exists to allow one thing: **circular dependency of streams**.
     * For instance, let's imagine that for some reason you need to create a
     * circular dependency where stream `first$` depends on stream `second$`
     * which in turn depends on `first$`:
     *
     * <!-- skip-example -->
     * ```js
     * import delay from 'xstream/extra/delay'
     *
     * var first$ = second$.map(x => x * 10).take(3);
     * var second$ = first$.map(x => x + 1).startWith(1).compose(delay(100));
     * ```
     *
     * However, that is invalid JavaScript, because `second$` is undefined
     * on the first line. This is how *imitate* can help solve it:
     *
     * ```js
     * import delay from 'xstream/extra/delay'
     *
     * var secondProxy$ = xs.create();
     * var first$ = secondProxy$.map(x => x * 10).take(3);
     * var second$ = first$.map(x => x + 1).startWith(1).compose(delay(100));
     * secondProxy$.imitate(second$);
     * ```
     *
     * We create `secondProxy$` before the others, so it can be used in the
     * declaration of `first$`. Then, after both `first$` and `second$` are
     * defined, we hook `secondProxy$` with `second$` with `imitate()` to tell
     * that they are "the same". `imitate` will not trigger the start of any
     * stream, it just binds `secondProxy$` and `second$` together.
     *
     * The following is an example where `imitate()` is important in Cycle.js
     * applications. A parent component contains some child components. A child
     * has an action stream which is given to the parent to define its state:
     *
     * <!-- skip-example -->
     * ```js
     * const childActionProxy$ = xs.create();
     * const parent = Parent({...sources, childAction$: childActionProxy$});
     * const childAction$ = parent.state$.map(s => s.child.action$).flatten();
     * childActionProxy$.imitate(childAction$);
     * ```
     *
     * Note, though, that **`imitate()` does not support MemoryStreams**. If we
     * would attempt to imitate a MemoryStream in a circular dependency, we would
     * either get a race condition (where the symptom would be "nothing happens")
     * or an infinite cyclic emission of values. It's useful to think about
     * MemoryStreams as cells in a spreadsheet. It doesn't make any sense to
     * define a spreadsheet cell `A1` with a formula that depends on `B1` and
     * cell `B1` defined with a formula that depends on `A1`.
     *
     * If you find yourself wanting to use `imitate()` with a
     * MemoryStream, you should rework your code around `imitate()` to use a
     * Stream instead. Look for the stream in the circular dependency that
     * represents an event stream, and that would be a candidate for creating a
     * proxy Stream which then imitates the target Stream.
     *
     * @param {Stream} target The other stream to imitate on the current one. Must
     * not be a MemoryStream.
     */ Stream.prototype.imitate = function(target) {
        if (target instanceof $f030d5e7d7e71b97$var$MemoryStream) throw new Error("A MemoryStream was given to imitate(), but it only supports a Stream. Read more about this restriction here: https://github.com/staltz/xstream#faq");
        this._target = target;
        for(var ils = this._ils, N = ils.length, i = 0; i < N; i++)target._add(ils[i]);
        this._ils = [];
    };
    /**
     * Forces the Stream to emit the given value to its listeners.
     *
     * As the name indicates, if you use this, you are most likely doing something
     * The Wrong Way. Please try to understand the reactive way before using this
     * method. Use it only when you know what you are doing.
     *
     * @param value The "next" value you want to broadcast to all listeners of
     * this Stream.
     */ Stream.prototype.shamefullySendNext = function(value) {
        this._n(value);
    };
    /**
     * Forces the Stream to emit the given error to its listeners.
     *
     * As the name indicates, if you use this, you are most likely doing something
     * The Wrong Way. Please try to understand the reactive way before using this
     * method. Use it only when you know what you are doing.
     *
     * @param {any} error The error you want to broadcast to all the listeners of
     * this Stream.
     */ Stream.prototype.shamefullySendError = function(error) {
        this._e(error);
    };
    /**
     * Forces the Stream to emit the "completed" event to its listeners.
     *
     * As the name indicates, if you use this, you are most likely doing something
     * The Wrong Way. Please try to understand the reactive way before using this
     * method. Use it only when you know what you are doing.
     */ Stream.prototype.shamefullySendComplete = function() {
        this._c();
    };
    /**
     * Adds a "debug" listener to the stream. There can only be one debug
     * listener, that's why this is 'setDebugListener'. To remove the debug
     * listener, just call setDebugListener(null).
     *
     * A debug listener is like any other listener. The only difference is that a
     * debug listener is "stealthy": its presence/absence does not trigger the
     * start/stop of the stream (or the producer inside the stream). This is
     * useful so you can inspect what is going on without changing the behavior
     * of the program. If you have an idle stream and you add a normal listener to
     * it, the stream will start executing. But if you set a debug listener on an
     * idle stream, it won't start executing (not until the first normal listener
     * is added).
     *
     * As the name indicates, we don't recommend using this method to build app
     * logic. In fact, in most cases the debug operator works just fine. Only use
     * this one if you know what you're doing.
     *
     * @param {Listener<T>} listener
     */ Stream.prototype.setDebugListener = function(listener) {
        if (!listener) {
            this._d = false;
            this._dl = $f030d5e7d7e71b97$var$NO;
        } else {
            this._d = true;
            listener._n = listener.next || $f030d5e7d7e71b97$var$noop;
            listener._e = listener.error || $f030d5e7d7e71b97$var$noop;
            listener._c = listener.complete || $f030d5e7d7e71b97$var$noop;
            this._dl = listener;
        }
    };
    /**
     * Blends multiple streams together, emitting events from all of them
     * concurrently.
     *
     * *merge* takes multiple streams as arguments, and creates a stream that
     * behaves like each of the argument streams, in parallel.
     *
     * Marble diagram:
     *
     * ```text
     * --1----2-----3--------4---
     * ----a-----b----c---d------
     *            merge
     * --1-a--2--b--3-c---d--4---
     * ```
     *
     * @factory true
     * @param {Stream} stream1 A stream to merge together with other streams.
     * @param {Stream} stream2 A stream to merge together with other streams. Two
     * or more streams may be given as arguments.
     * @return {Stream}
     */ Stream.merge = function merge() {
        var streams = [];
        for(var _i = 0; _i < arguments.length; _i++)streams[_i] = arguments[_i];
        return new Stream(new $f030d5e7d7e71b97$var$Merge(streams));
    };
    /**
     * Combines multiple input streams together to return a stream whose events
     * are arrays that collect the latest events from each input stream.
     *
     * *combine* internally remembers the most recent event from each of the input
     * streams. When any of the input streams emits an event, that event together
     * with all the other saved events are combined into an array. That array will
     * be emitted on the output stream. It's essentially a way of joining together
     * the events from multiple streams.
     *
     * Marble diagram:
     *
     * ```text
     * --1----2-----3--------4---
     * ----a-----b-----c--d------
     *          combine
     * ----1a-2a-2b-3b-3c-3d-4d--
     * ```
     *
     * @factory true
     * @param {Stream} stream1 A stream to combine together with other streams.
     * @param {Stream} stream2 A stream to combine together with other streams.
     * Multiple streams, not just two, may be given as arguments.
     * @return {Stream}
     */ Stream.combine = function combine() {
        var streams = [];
        for(var _i = 0; _i < arguments.length; _i++)streams[_i] = arguments[_i];
        return new Stream(new $f030d5e7d7e71b97$var$Combine(streams));
    };
    return Stream;
}();
module.exports.Stream = $f030d5e7d7e71b97$var$Stream;
var $f030d5e7d7e71b97$var$MemoryStream = /** @class */ function(_super) {
    $f030d5e7d7e71b97$var$__extends(MemoryStream, _super);
    function MemoryStream(producer) {
        var _this = _super.call(this, producer) || this;
        _this._has = false;
        return _this;
    }
    MemoryStream.prototype._n = function(x) {
        this._v = x;
        this._has = true;
        _super.prototype._n.call(this, x);
    };
    MemoryStream.prototype._add = function(il) {
        var ta = this._target;
        if (ta) return ta._add(il);
        var a = this._ils;
        a.push(il);
        if (a.length > 1) {
            if (this._has) il._n(this._v);
            return;
        }
        if (this._stopID !== $f030d5e7d7e71b97$var$NO) {
            if (this._has) il._n(this._v);
            clearTimeout(this._stopID);
            this._stopID = $f030d5e7d7e71b97$var$NO;
        } else if (this._has) il._n(this._v);
        else {
            var p = this._prod;
            if (p !== $f030d5e7d7e71b97$var$NO) p._start(this);
        }
    };
    MemoryStream.prototype._stopNow = function() {
        this._has = false;
        _super.prototype._stopNow.call(this);
    };
    MemoryStream.prototype._x = function() {
        this._has = false;
        _super.prototype._x.call(this);
    };
    MemoryStream.prototype.map = function(project) {
        return this._map(project);
    };
    MemoryStream.prototype.mapTo = function(projectedValue) {
        return _super.prototype.mapTo.call(this, projectedValue);
    };
    MemoryStream.prototype.take = function(amount) {
        return _super.prototype.take.call(this, amount);
    };
    MemoryStream.prototype.endWhen = function(other) {
        return _super.prototype.endWhen.call(this, other);
    };
    MemoryStream.prototype.replaceError = function(replace) {
        return _super.prototype.replaceError.call(this, replace);
    };
    MemoryStream.prototype.remember = function() {
        return this;
    };
    MemoryStream.prototype.debug = function(labelOrSpy) {
        return _super.prototype.debug.call(this, labelOrSpy);
    };
    return MemoryStream;
}($f030d5e7d7e71b97$var$Stream);
module.exports.MemoryStream = $f030d5e7d7e71b97$var$MemoryStream;
var $f030d5e7d7e71b97$var$xs = $f030d5e7d7e71b97$var$Stream;
module.exports.default = $f030d5e7d7e71b97$var$xs;

});
parcelRegister("lk3VL", function(module, exports) {

module.exports = (parcelRequire("9kW08"));

});

parcelRegister("2FvTv", function(module, exports) {
"use strict";

var $g6Lkv = parcelRequire("g6Lkv");

var $gMYQP = parcelRequire("gMYQP");

var $3rgMk = parcelRequire("3rgMk");

var $aprjD = parcelRequire("aprjD");
var $1f1826aa59ed6822$var$polyfill = $3rgMk();
var $1f1826aa59ed6822$var$getGlobal = function() {
    return $1f1826aa59ed6822$var$polyfill;
};
$g6Lkv($1f1826aa59ed6822$var$getGlobal, {
    getPolyfill: $3rgMk,
    implementation: $gMYQP,
    shim: $aprjD
});
module.exports = $1f1826aa59ed6822$var$getGlobal;

});
parcelRegister("g6Lkv", function(module, exports) {
"use strict";

var $h8j4e = parcelRequire("h8j4e");
var $bba1eb99e9d8db09$var$hasSymbols = typeof Symbol === "function" && typeof Symbol("foo") === "symbol";
var $bba1eb99e9d8db09$var$toStr = Object.prototype.toString;
var $bba1eb99e9d8db09$var$concat = Array.prototype.concat;

var $jTQbZ = parcelRequire("jTQbZ");
var $bba1eb99e9d8db09$var$isFunction = function(fn) {
    return typeof fn === "function" && $bba1eb99e9d8db09$var$toStr.call(fn) === "[object Function]";
};

var $bba1eb99e9d8db09$var$supportsDescriptors = (parcelRequire("jvnto"))();
var $bba1eb99e9d8db09$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$bba1eb99e9d8db09$var$isFunction(predicate) || !predicate()) return;
    }
    if ($bba1eb99e9d8db09$var$supportsDescriptors) $jTQbZ(object, name, value, true);
    else $jTQbZ(object, name, value);
};
var $bba1eb99e9d8db09$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $h8j4e(map);
    if ($bba1eb99e9d8db09$var$hasSymbols) props = $bba1eb99e9d8db09$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$bba1eb99e9d8db09$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$bba1eb99e9d8db09$var$defineProperties.supportsDescriptors = !!$bba1eb99e9d8db09$var$supportsDescriptors;
module.exports = $bba1eb99e9d8db09$var$defineProperties;

});
parcelRegister("h8j4e", function(module, exports) {
"use strict";
var $c791f9679a992e5c$var$slice = Array.prototype.slice;

var $2Z5w1 = parcelRequire("2Z5w1");
var $c791f9679a992e5c$var$origKeys = Object.keys;

var $c791f9679a992e5c$var$keysShim = $c791f9679a992e5c$var$origKeys ? function keys(o) {
    return $c791f9679a992e5c$var$origKeys(o);
} : (parcelRequire("3zxP0"));
var $c791f9679a992e5c$var$originalKeys = Object.keys;
$c791f9679a992e5c$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($2Z5w1(object)) return $c791f9679a992e5c$var$originalKeys($c791f9679a992e5c$var$slice.call(object));
            return $c791f9679a992e5c$var$originalKeys(object);
        };
    } else Object.keys = $c791f9679a992e5c$var$keysShim;
    return Object.keys || $c791f9679a992e5c$var$keysShim;
};
module.exports = $c791f9679a992e5c$var$keysShim;

});

parcelRegister("jTQbZ", function(module, exports) {
"use strict";

var $kQEeW = parcelRequire("kQEeW");

var $9RMU6 = parcelRequire("9RMU6");

var $hehTj = parcelRequire("hehTj");

var $lre78 = parcelRequire("lre78");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $hehTj("`obj` must be an object or a function`");
    if (typeof property !== "string" && typeof property !== "symbol") throw new $hehTj("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $hehTj("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $hehTj("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $hehTj("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $hehTj("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$lre78 && $lre78(obj, property);
    if ($kQEeW) $kQEeW(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $9RMU6("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};

});
parcelRegister("lre78", function(module, exports) {
"use strict";

var $5KFGy = parcelRequire("5KFGy");
var $f9b71159b329fd73$var$$gOPD = $5KFGy("%Object.getOwnPropertyDescriptor%", true);
if ($f9b71159b329fd73$var$$gOPD) try {
    $f9b71159b329fd73$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $f9b71159b329fd73$var$$gOPD = null;
}
module.exports = $f9b71159b329fd73$var$$gOPD;

});



parcelRegister("gMYQP", function(module, exports) {
/* eslint no-negated-condition: 0, no-new-func: 0 */ "use strict";
if (typeof self !== "undefined") module.exports = self;
else if (typeof window !== "undefined") module.exports = window;
else module.exports = Function("return this")();

});

parcelRegister("3rgMk", function(module, exports) {
"use strict";

var $gMYQP = parcelRequire("gMYQP");
module.exports = function getPolyfill() {
    if (typeof $parcel$global !== "object" || !$parcel$global || $parcel$global.Math !== Math || $parcel$global.Array !== Array) return $gMYQP;
    return $parcel$global;
};

});

parcelRegister("aprjD", function(module, exports) {
"use strict";

var $g6Lkv = parcelRequire("g6Lkv");

var $3rgMk = parcelRequire("3rgMk");
module.exports = function shimGlobal() {
    var polyfill = $3rgMk();
    if ($g6Lkv.supportsDescriptors) {
        var descriptor = Object.getOwnPropertyDescriptor(polyfill, "globalThis");
        if (!descriptor || descriptor.configurable && (descriptor.enumerable || !descriptor.writable || globalThis !== polyfill)) Object.defineProperty(polyfill, "globalThis", {
            configurable: true,
            enumerable: false,
            value: polyfill,
            writable: true
        });
    } else if (typeof globalThis !== "object" || globalThis !== polyfill) polyfill.globalThis = polyfill;
    return polyfill;
};

});




parcelRegister("l01Ia", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultValueProducer = void 0;
// allows pre-producing values before anyone is listening
class $f49aece2cefb70ae$var$DefaultValueProducer {
    get value() {
        return this.internalValue;
    }
    /**
     * Update the current value.
     *
     * If producer is active (i.e. someone is listening), this emits an event.
     * If not, just the current value is updated.
     */ update(value) {
        this.internalValue = value;
        if (this.listener) this.listener.next(value);
    }
    /**
     * Produce an error
     */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    error(error) {
        if (this.listener) this.listener.error(error);
    }
    /**
     * Called by the stream. Do not call this directly.
     */ start(listener) {
        this.listener = listener;
        listener.next(this.internalValue);
        if (this.callbacks) this.callbacks.onStarted();
    }
    /**
     * Called by the stream. Do not call this directly.
     */ stop() {
        if (this.callbacks) this.callbacks.onStop();
        this.listener = undefined;
    }
    constructor(value, callbacks){
        this.callbacks = callbacks;
        this.internalValue = value;
    }
}
module.exports.DefaultValueProducer = $f49aece2cefb70ae$var$DefaultValueProducer;

});

parcelRegister("iCp6p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dropDuplicates = void 0;
/**
 * Drops duplicate values in a stream.
 *
 * Marble diagram:
 *
 * ```text
 * -1-1-1-2-4-3-3-4--
 *   dropDuplicates
 * -1-----2-4-3------
 * ```
 *
 * Each value must be uniquely identified by a string given by
 * valueToKey(value).
 *
 * Internally this maintains a set of keys that have been processed already,
 * i.e. memory consumption and Set lookup times should be considered when
 * using this function.
 */ function $d8df3f6bb282ffef$var$dropDuplicates(valueToKey) {
    const operand = (instream)=>{
        const emittedKeys = new Set();
        const deduplicatedStream = instream.filter((value)=>!emittedKeys.has(valueToKey(value))).debug((value)=>emittedKeys.add(valueToKey(value)));
        return deduplicatedStream;
    };
    return operand;
}
module.exports.dropDuplicates = $d8df3f6bb282ffef$var$dropDuplicates;

});

parcelRegister("igMit", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.firstEvent = module.exports.toListPromise = module.exports.fromListPromise = void 0;

var $kCwQy = parcelRequire("kCwQy");
/**
 * Emits one event for each list element as soon as the promise resolves
 */ function $d4cf2f6754a5a889$var$fromListPromise(promise) {
    const producer = {
        start: (listener)=>{
            // the code in `start` runs as soon as anyone listens to the stream
            promise.then((iterable)=>{
                for (const element of iterable)listener.next(element);
                listener.complete();
            }).catch((error)=>listener.error(error));
        },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        stop: ()=>{}
    };
    return $kCwQy.Stream.create(producer);
}
module.exports.fromListPromise = $d4cf2f6754a5a889$var$fromListPromise;
/**
 * Listens to stream and collects events. When `count` events are collected,
 * the promise resolves with an array of events.
 *
 * Rejects if stream completes before `count` events are collected.
 */ async function $d4cf2f6754a5a889$var$toListPromise(stream, count) {
    return new Promise((resolve, reject)=>{
        if (count === 0) {
            resolve([]);
            return;
        }
        const events = new Array();
        // take() unsubscribes from source stream automatically
        stream.take(count).subscribe({
            next: (event)=>{
                events.push(event);
                if (events.length === count) resolve(events);
            },
            complete: ()=>{
                reject(`Stream completed before all events could be collected. ` + `Collected ${events.length}, expected ${count}`);
            },
            error: (error)=>reject(error)
        });
    });
}
module.exports.toListPromise = $d4cf2f6754a5a889$var$toListPromise;
/**
 * Listens to stream, collects one event and revolves.
 *
 * Rejects if stream completes before one event was fired.
 */ async function $d4cf2f6754a5a889$var$firstEvent(stream) {
    return (await $d4cf2f6754a5a889$var$toListPromise(stream, 1))[0];
}
module.exports.firstEvent = $d4cf2f6754a5a889$var$firstEvent;

});

parcelRegister("e3MQD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ValueAndUpdates = void 0;

var $kCwQy = parcelRequire("kCwQy");
/**
 * A read only wrapper around DefaultValueProducer that allows
 * to synchronously get the current value using the .value property
 * and listen to to updates by suscribing to the .updates stream
 */ class $a3c73cab70f0cc84$var$ValueAndUpdates {
    get value() {
        return this.producer.value;
    }
    /**
     * Resolves as soon as search value is found.
     *
     * @param search either a value or a function that must return true when found
     * @returns the value of the update that caused the search match
     */ async waitFor(search) {
        const searchImplementation = typeof search === "function" ? search : (value)=>value === search;
        return new Promise((resolve, reject)=>{
            const subscription = this.updates.subscribe({
                next: (newValue)=>{
                    if (searchImplementation(newValue)) {
                        resolve(newValue);
                        // MemoryStream.subscribe() calls next with the last value.
                        // Make async to ensure the subscription exists
                        setTimeout(()=>subscription.unsubscribe(), 0);
                    }
                },
                complete: ()=>{
                    subscription.unsubscribe();
                    reject("Update stream completed without expected value");
                },
                error: (error)=>{
                    reject(error);
                }
            });
        });
    }
    constructor(producer){
        this.producer = producer;
        this.updates = $kCwQy.MemoryStream.createWithMemory(this.producer);
    }
}
module.exports.ValueAndUpdates = $a3c73cab70f0cc84$var$ValueAndUpdates;

});


parcelRegister("4bhB4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.jsonRpcCode = module.exports.isJsonRpcSuccessResponse = module.exports.isJsonRpcErrorResponse = void 0;
function $30b5d6dc93f3e372$var$isJsonRpcErrorResponse(response) {
    return typeof response.error === "object";
}
module.exports.isJsonRpcErrorResponse = $30b5d6dc93f3e372$var$isJsonRpcErrorResponse;
function $30b5d6dc93f3e372$var$isJsonRpcSuccessResponse(response) {
    return !$30b5d6dc93f3e372$var$isJsonRpcErrorResponse(response);
}
module.exports.isJsonRpcSuccessResponse = $30b5d6dc93f3e372$var$isJsonRpcSuccessResponse;
/**
 * Error codes as specified in JSON-RPC 2.0
 *
 * @see https://www.jsonrpc.org/specification#error_object
 */ module.exports.jsonRpcCode = {
    parseError: -32700,
    invalidRequest: -32600,
    methodNotFound: -32601,
    invalidParams: -32602,
    internalError: -32603,
    // server error (Reserved for implementation-defined server-errors.):
    // -32000 to -32099
    serverError: {
        default: -32000
    }
};

});


parcelRegister("3U7KU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseJsonRpcResponse = module.exports.parseJsonRpcSuccessResponse = module.exports.parseJsonRpcErrorResponse = module.exports.parseJsonRpcRequest = module.exports.parseJsonRpcId = void 0;

var $59Tr1 = parcelRequire("59Tr1");
/**
 * Extracts ID field from request or response object.
 *
 * Returns `null` when no valid ID was found.
 */ function $2d7c9e2fa06620a3$var$parseJsonRpcId(data) {
    if (!(0, $59Tr1.isJsonCompatibleDictionary)(data)) throw new Error("Data must be JSON compatible dictionary");
    const id = data.id;
    if (typeof id !== "number" && typeof id !== "string") return null;
    return id;
}
module.exports.parseJsonRpcId = $2d7c9e2fa06620a3$var$parseJsonRpcId;
function $2d7c9e2fa06620a3$var$parseJsonRpcRequest(data) {
    if (!(0, $59Tr1.isJsonCompatibleDictionary)(data)) throw new Error("Data must be JSON compatible dictionary");
    if (data.jsonrpc !== "2.0") throw new Error(`Got unexpected jsonrpc version: ${data.jsonrpc}`);
    const id = $2d7c9e2fa06620a3$var$parseJsonRpcId(data);
    if (id === null) throw new Error("Invalid id field");
    const method = data.method;
    if (typeof method !== "string") throw new Error("Invalid method field");
    if (!(0, $59Tr1.isJsonCompatibleArray)(data.params) && !(0, $59Tr1.isJsonCompatibleDictionary)(data.params)) throw new Error("Invalid params field");
    return {
        jsonrpc: "2.0",
        id: id,
        method: method,
        params: data.params
    };
}
module.exports.parseJsonRpcRequest = $2d7c9e2fa06620a3$var$parseJsonRpcRequest;
function $2d7c9e2fa06620a3$var$parseError(error) {
    if (typeof error.code !== "number") throw new Error("Error property 'code' is not a number");
    if (typeof error.message !== "string") throw new Error("Error property 'message' is not a string");
    let maybeUndefinedData;
    if (error.data === undefined) maybeUndefinedData = undefined;
    else if ((0, $59Tr1.isJsonCompatibleValue)(error.data)) maybeUndefinedData = error.data;
    else throw new Error("Error property 'data' is defined but not a JSON compatible value.");
    return {
        code: error.code,
        message: error.message,
        ...maybeUndefinedData !== undefined ? {
            data: maybeUndefinedData
        } : {}
    };
}
/** Throws if data is not a JsonRpcErrorResponse */ function $2d7c9e2fa06620a3$var$parseJsonRpcErrorResponse(data) {
    if (!(0, $59Tr1.isJsonCompatibleDictionary)(data)) throw new Error("Data must be JSON compatible dictionary");
    if (data.jsonrpc !== "2.0") throw new Error(`Got unexpected jsonrpc version: ${JSON.stringify(data)}`);
    const id = data.id;
    if (typeof id !== "number" && typeof id !== "string" && id !== null) throw new Error("Invalid id field");
    if (typeof data.error === "undefined" || !(0, $59Tr1.isJsonCompatibleDictionary)(data.error)) throw new Error("Invalid error field");
    return {
        jsonrpc: "2.0",
        id: id,
        error: $2d7c9e2fa06620a3$var$parseError(data.error)
    };
}
module.exports.parseJsonRpcErrorResponse = $2d7c9e2fa06620a3$var$parseJsonRpcErrorResponse;
/** Throws if data is not a JsonRpcSuccessResponse */ function $2d7c9e2fa06620a3$var$parseJsonRpcSuccessResponse(data) {
    if (!(0, $59Tr1.isJsonCompatibleDictionary)(data)) throw new Error("Data must be JSON compatible dictionary");
    if (data.jsonrpc !== "2.0") throw new Error(`Got unexpected jsonrpc version: ${JSON.stringify(data)}`);
    const id = data.id;
    if (typeof id !== "number" && typeof id !== "string") throw new Error("Invalid id field");
    if (typeof data.result === "undefined") throw new Error("Invalid result field");
    const result = data.result;
    return {
        jsonrpc: "2.0",
        id: id,
        result: result
    };
}
module.exports.parseJsonRpcSuccessResponse = $2d7c9e2fa06620a3$var$parseJsonRpcSuccessResponse;
/**
 * Returns a JsonRpcErrorResponse if input can be parsed as a JSON-RPC error. Otherwise parses
 * input as JsonRpcSuccessResponse. Throws if input is neither a valid error nor success response.
 */ function $2d7c9e2fa06620a3$var$parseJsonRpcResponse(data) {
    let response;
    try {
        response = $2d7c9e2fa06620a3$var$parseJsonRpcErrorResponse(data);
    } catch (_) {
        response = $2d7c9e2fa06620a3$var$parseJsonRpcSuccessResponse(data);
    }
    return response;
}
module.exports.parseJsonRpcResponse = $2d7c9e2fa06620a3$var$parseJsonRpcResponse;

});
parcelRegister("59Tr1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isJsonCompatibleDictionary = module.exports.isJsonCompatibleArray = module.exports.isJsonCompatibleValue = void 0;
function $3c18cb3305501745$var$isJsonCompatibleValue(value) {
    if (typeof value === "string" || typeof value === "number" || typeof value === "boolean" || value === null || // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $3c18cb3305501745$var$isJsonCompatibleArray(value) || // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $3c18cb3305501745$var$isJsonCompatibleDictionary(value)) return true;
    else return false;
}
module.exports.isJsonCompatibleValue = $3c18cb3305501745$var$isJsonCompatibleValue;
function $3c18cb3305501745$var$isJsonCompatibleArray(value) {
    if (!Array.isArray(value)) return false;
    for (const item of value){
        if (!$3c18cb3305501745$var$isJsonCompatibleValue(item)) return false;
    }
    // all items okay
    return true;
}
module.exports.isJsonCompatibleArray = $3c18cb3305501745$var$isJsonCompatibleArray;
function $3c18cb3305501745$var$isJsonCompatibleDictionary(data) {
    if (typeof data !== "object" || data === null) // data must be a non-null object
    return false;
    // Exclude special kind of objects like Array, Date or Uint8Array
    // Object.prototype.toString() returns a specified value:
    // http://www.ecma-international.org/ecma-262/7.0/index.html#sec-object.prototype.tostring
    if (Object.prototype.toString.call(data) !== "[object Object]") return false;
    return Object.values(data).every($3c18cb3305501745$var$isJsonCompatibleValue);
}
module.exports.isJsonCompatibleDictionary = $3c18cb3305501745$var$isJsonCompatibleDictionary;

});



parcelRegister("84BdO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hasProtocol = module.exports.instanceOfRpcStreamingClient = void 0;
function $5e0b91ed65fa59f3$var$instanceOfRpcStreamingClient(client) {
    return typeof client.listen === "function";
}
module.exports.instanceOfRpcStreamingClient = $5e0b91ed65fa59f3$var$instanceOfRpcStreamingClient;
// Helpers for all RPC clients
function $5e0b91ed65fa59f3$var$hasProtocol(url) {
    return url.search("://") !== -1;
}
module.exports.hasProtocol = $5e0b91ed65fa59f3$var$hasProtocol;

});


parcelRegister("5R6Vu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WebsocketClient = void 0;

var $8CzXL = parcelRequire("8CzXL");

var $eGsV1 = parcelRequire("eGsV1");

var $9XZPj = parcelRequire("9XZPj");

var $kCwQy = parcelRequire("kCwQy");

var $84BdO = parcelRequire("84BdO");
function $44374663353127b9$var$defaultErrorHandler(error) {
    throw error;
}
function $44374663353127b9$var$toJsonRpcResponse(message) {
    // this should never happen, but I want an alert if it does
    if (message.type !== "message") throw new Error(`Unexcepted message type on websocket: ${message.type}`);
    const jsonRpcEvent = (0, $8CzXL.parseJsonRpcResponse)(JSON.parse(message.data));
    return jsonRpcEvent;
}
class $44374663353127b9$var$RpcEventProducer {
    /**
     * Implementation of Producer.start
     */ start(listener) {
        if (this.running) throw Error("Already started. Please stop first before restarting.");
        this.running = true;
        this.connectToClient(listener);
        this.socket.queueRequest(JSON.stringify(this.request));
    }
    /**
     * Implementation of Producer.stop
     *
     * Called by the stream when the stream's last listener stopped listening
     * or when the producer completed.
     */ stop() {
        this.running = false;
        // Tell the server we are done in order to save resources. We cannot wait for the result.
        // This may fail when socket connection is not open, thus ignore errors in queueRequest
        const endRequest = {
            ...this.request,
            method: "unsubscribe"
        };
        try {
            this.socket.queueRequest(JSON.stringify(endRequest));
        } catch (error) {
            if (error instanceof Error && error.message.match(/socket has disconnected/i)) ;
            else throw error;
        }
    }
    connectToClient(listener) {
        const responseStream = this.socket.events.map($44374663353127b9$var$toJsonRpcResponse);
        // this should unsubscribe itself, so doesn't need to be removed explicitly
        const idSubscription = responseStream.filter((response)=>response.id === this.request.id).subscribe({
            next: (response)=>{
                if ((0, $8CzXL.isJsonRpcErrorResponse)(response)) {
                    this.closeSubscriptions();
                    listener.error(JSON.stringify(response.error));
                }
                idSubscription.unsubscribe();
            }
        });
        // this will fire on a response (success or error)
        // Tendermint adds an "#event" suffix for events that follow a previous subscription
        // https://github.com/tendermint/tendermint/blob/v0.23.0/rpc/core/events.go#L107
        const idEventSubscription = responseStream.filter((response)=>response.id === this.request.id).subscribe({
            next: (response)=>{
                if ((0, $8CzXL.isJsonRpcErrorResponse)(response)) {
                    this.closeSubscriptions();
                    listener.error(JSON.stringify(response.error));
                } else listener.next(response.result);
            }
        });
        // this will fire in case the websocket disconnects cleanly
        const nonResponseSubscription = responseStream.subscribe({
            error: (error)=>{
                this.closeSubscriptions();
                listener.error(error);
            },
            complete: ()=>{
                this.closeSubscriptions();
                listener.complete();
            }
        });
        this.subscriptions.push(idSubscription, idEventSubscription, nonResponseSubscription);
    }
    closeSubscriptions() {
        for (const subscription of this.subscriptions)subscription.unsubscribe();
        // clear unused subscriptions
        this.subscriptions = [];
    }
    constructor(request, socket){
        this.running = false;
        this.subscriptions = [];
        this.request = request;
        this.socket = socket;
    }
}
class $44374663353127b9$var$WebsocketClient {
    async execute(request) {
        const pendingResponse = this.responseForRequestId(request.id);
        this.socket.queueRequest(JSON.stringify(request));
        const response = await pendingResponse;
        if ((0, $8CzXL.isJsonRpcErrorResponse)(response)) throw new Error(JSON.stringify(response.error));
        return response;
    }
    listen(request) {
        if (request.method !== "subscribe") throw new Error(`Request method must be "subscribe" to start event listening`);
        const query = request.params.query;
        if (typeof query !== "string") throw new Error("request.params.query must be a string");
        if (!this.subscriptionStreams.has(query)) {
            const producer = new $44374663353127b9$var$RpcEventProducer(request, this.socket);
            const stream = $kCwQy.Stream.create(producer);
            this.subscriptionStreams.set(query, stream);
        }
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return this.subscriptionStreams.get(query).filter((response)=>response.query !== undefined);
    }
    /**
     * Resolves as soon as websocket is connected. execute() queues requests automatically,
     * so this should be required for testing purposes only.
     */ async connected() {
        await this.socket.connectionStatus.waitFor($eGsV1.ConnectionStatus.Connected);
    }
    disconnect() {
        this.socket.disconnect();
    }
    async responseForRequestId(id) {
        return (0, $9XZPj.firstEvent)(this.jsonRpcResponseStream.filter((r)=>r.id === id));
    }
    constructor(baseUrl, onError = $44374663353127b9$var$defaultErrorHandler){
        // Lazily create streams and use the same stream when listening to the same query twice.
        //
        // Creating streams is cheap since producer is not started as long as nobody listens to events. Thus this
        // map is never cleared and there is no need to do so. But unsubscribe all the subscriptions!
        this.subscriptionStreams = new Map();
        // accept host.name:port and assume ws protocol
        // make sure we don't end up with ...//websocket
        const path = baseUrl.endsWith("/") ? "websocket" : "/websocket";
        const cleanBaseUrl = (0, $84BdO.hasProtocol)(baseUrl) ? baseUrl : "ws://" + baseUrl;
        this.url = cleanBaseUrl + path;
        this.socket = new $eGsV1.ReconnectingSocket(this.url);
        const errorSubscription = this.socket.events.subscribe({
            error: (error)=>{
                onError(error);
                errorSubscription.unsubscribe();
            }
        });
        this.jsonRpcResponseStream = this.socket.events.map($44374663353127b9$var$toJsonRpcResponse);
        this.socket.connect();
    }
}
module.exports.WebsocketClient = $44374663353127b9$var$WebsocketClient;

});
parcelRegister("eGsV1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StreamingSocket = module.exports.SocketWrapper = module.exports.ReconnectingSocket = module.exports.QueueingStreamingSocket = module.exports.ConnectionStatus = void 0;

var $ebCTq = parcelRequire("ebCTq");
Object.defineProperty(module.exports, "ConnectionStatus", {
    enumerable: true,
    get: function() {
        return $ebCTq.ConnectionStatus;
    }
});
Object.defineProperty(module.exports, "QueueingStreamingSocket", {
    enumerable: true,
    get: function() {
        return $ebCTq.QueueingStreamingSocket;
    }
});

var $flFKr = parcelRequire("flFKr");
Object.defineProperty(module.exports, "ReconnectingSocket", {
    enumerable: true,
    get: function() {
        return $flFKr.ReconnectingSocket;
    }
});

var $svNGA = parcelRequire("svNGA");
Object.defineProperty(module.exports, "SocketWrapper", {
    enumerable: true,
    get: function() {
        return $svNGA.SocketWrapper;
    }
});

var $hdXkM = parcelRequire("hdXkM");
Object.defineProperty(module.exports, "StreamingSocket", {
    enumerable: true,
    get: function() {
        return $hdXkM.StreamingSocket;
    }
});

});
parcelRegister("ebCTq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QueueingStreamingSocket = module.exports.ConnectionStatus = void 0;

var $9XZPj = parcelRequire("9XZPj");

var $kCwQy = parcelRequire("kCwQy");

var $hdXkM = parcelRequire("hdXkM");
var $a5404317e8d6344a$var$ConnectionStatus;
(function(ConnectionStatus) {
    ConnectionStatus[ConnectionStatus["Unconnected"] = 0] = "Unconnected";
    ConnectionStatus[ConnectionStatus["Connecting"] = 1] = "Connecting";
    ConnectionStatus[ConnectionStatus["Connected"] = 2] = "Connected";
    ConnectionStatus[ConnectionStatus["Disconnected"] = 3] = "Disconnected";
})($a5404317e8d6344a$var$ConnectionStatus = module.exports.ConnectionStatus || (module.exports.ConnectionStatus = {}));
/**
 * A wrapper around StreamingSocket that can queue requests.
 */ class $a5404317e8d6344a$var$QueueingStreamingSocket {
    connect() {
        this.connectionStatusProducer.update($a5404317e8d6344a$var$ConnectionStatus.Connecting);
        this.socket.connected.then(async ()=>{
            this.connectionStatusProducer.update($a5404317e8d6344a$var$ConnectionStatus.Connected);
            return this.processQueue();
        }, ()=>this.connectionStatusProducer.update($a5404317e8d6344a$var$ConnectionStatus.Disconnected));
        this.socket.connect();
    }
    disconnect() {
        this.connectionStatusProducer.update($a5404317e8d6344a$var$ConnectionStatus.Disconnected);
        this.socket.disconnect();
    }
    reconnect() {
        this.socket = new $hdXkM.StreamingSocket(this.url, this.timeout);
        this.socket.events.subscribe({
            next: (event)=>{
                if (!this.eventProducerListener) throw new Error("No event producer listener set");
                this.eventProducerListener.next(event);
            },
            error: ()=>this.connectionStatusProducer.update($a5404317e8d6344a$var$ConnectionStatus.Disconnected)
        });
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.socket.connected.then(()=>{
            if (this.reconnectedHandler) this.reconnectedHandler();
        });
        this.connect();
    }
    getQueueLength() {
        return this.queue.length;
    }
    queueRequest(request) {
        this.queue.push(request);
        // We don’t need to wait for the queue to be processed.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.processQueue();
    }
    async processQueue() {
        if (this.isProcessingQueue || this.connectionStatus.value !== $a5404317e8d6344a$var$ConnectionStatus.Connected) return;
        this.isProcessingQueue = true;
        let request;
        while(request = this.queue.shift())try {
            await this.socket.send(request);
            this.isProcessingQueue = false;
        } catch (error) {
            // Probably the connection is down; will try again automatically when reconnected.
            this.queue.unshift(request);
            this.isProcessingQueue = false;
            return;
        }
    }
    constructor(url, timeout = 10000, reconnectedHandler){
        this.queue = [];
        this.isProcessingQueue = false;
        this.url = url;
        this.timeout = timeout;
        this.reconnectedHandler = reconnectedHandler;
        const eventProducer = {
            start: (listener)=>this.eventProducerListener = listener,
            stop: ()=>this.eventProducerListener = undefined
        };
        this.events = $kCwQy.Stream.create(eventProducer);
        this.connectionStatusProducer = new $9XZPj.DefaultValueProducer($a5404317e8d6344a$var$ConnectionStatus.Unconnected);
        this.connectionStatus = new $9XZPj.ValueAndUpdates(this.connectionStatusProducer);
        this.socket = new $hdXkM.StreamingSocket(this.url, this.timeout);
        this.socket.events.subscribe({
            next: (event)=>{
                if (!this.eventProducerListener) throw new Error("No event producer listener set");
                this.eventProducerListener.next(event);
            },
            error: ()=>this.connectionStatusProducer.update($a5404317e8d6344a$var$ConnectionStatus.Disconnected)
        });
    }
}
module.exports.QueueingStreamingSocket = $a5404317e8d6344a$var$QueueingStreamingSocket;

});
parcelRegister("hdXkM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StreamingSocket = void 0;

var $kCwQy = parcelRequire("kCwQy");

var $svNGA = parcelRequire("svNGA");
/**
 * A WebSocket wrapper that exposes all events as a stream.
 *
 * This underlying socket will not be closed when the stream has no listeners
 */ class $c8a1ad1900214b84$var$StreamingSocket {
    connect() {
        this.socket.connect();
    }
    disconnect() {
        this.socket.disconnect();
    }
    async send(data) {
        return this.socket.send(data);
    }
    constructor(url, timeout = 10000){
        this.socket = new $svNGA.SocketWrapper(url, (event)=>{
            if (this.eventProducerListener) this.eventProducerListener.next(event);
        }, (errorEvent)=>{
            if (this.eventProducerListener) this.eventProducerListener.error(errorEvent);
        }, ()=>{
        // socket opened
        }, (closeEvent)=>{
            if (this.eventProducerListener) {
                if (closeEvent.wasClean) this.eventProducerListener.complete();
                else this.eventProducerListener.error("Socket was closed unclean");
            }
        }, timeout);
        this.connected = this.socket.connected;
        const eventProducer = {
            start: (listener)=>this.eventProducerListener = listener,
            stop: ()=>this.eventProducerListener = undefined
        };
        this.events = $kCwQy.Stream.create(eventProducer);
    }
}
module.exports.StreamingSocket = $c8a1ad1900214b84$var$StreamingSocket;

});
parcelRegister("svNGA", function(module, exports) {

var $a8i8g = parcelRequire("a8i8g");
"use strict";
var $055b48888bdca8bd$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SocketWrapper = void 0;

const $055b48888bdca8bd$var$isomorphic_ws_1 = $055b48888bdca8bd$var$__importDefault((parcelRequire("lr6FU")));
function $055b48888bdca8bd$var$environmentIsNodeJs() {
    return typeof $a8i8g !== "undefined" && typeof $a8i8g.versions !== "undefined" && typeof $a8i8g.versions.node !== "undefined";
}
/**
 * A thin wrapper around isomorphic-ws' WebSocket class that adds
 * - constant message/error/open/close handlers
 * - explict connection via a connect() method
 * - type support for events
 * - handling of corner cases in the open and close behaviour
 */ class $055b48888bdca8bd$var$SocketWrapper {
    /**
     * returns a promise that resolves when connection is open
     */ connect() {
        const socket = new $055b48888bdca8bd$var$isomorphic_ws_1.default(this.url);
        socket.onerror = (error)=>{
            this.clearTimeout();
            if (this.errorHandler) this.errorHandler(error);
        };
        socket.onmessage = (messageEvent)=>{
            this.messageHandler({
                type: messageEvent.type,
                data: messageEvent.data
            });
        };
        socket.onopen = (_)=>{
            this.clearTimeout();
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.connectedResolver();
            if (this.openHandler) this.openHandler();
        };
        socket.onclose = (closeEvent)=>{
            this.closed = true;
            if (this.closeHandler) this.closeHandler(closeEvent);
        };
        const started = Date.now();
        this.timeoutId = setTimeout(()=>{
            socket.onmessage = ()=>0;
            socket.onerror = ()=>0;
            socket.onopen = ()=>0;
            socket.onclose = ()=>0;
            socket.close();
            this.socket = undefined;
            const elapsed = Math.floor(Date.now() - started);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.connectedRejecter(`Connection attempt timed out after ${elapsed} ms`);
        }, this.timeout);
        this.socket = socket;
    }
    /**
     * Closes an established connection and aborts other connection states
     */ disconnect() {
        if (!this.socket) throw new Error("Socket undefined. This must be called after connecting.");
        this.clearTimeout();
        switch(this.socket.readyState){
            case $055b48888bdca8bd$var$isomorphic_ws_1.default.OPEN:
                this.socket.close(1000 /* Normal Closure */ );
                break;
            case $055b48888bdca8bd$var$isomorphic_ws_1.default.CLOSED:
                break;
            case $055b48888bdca8bd$var$isomorphic_ws_1.default.CONNECTING:
                // imitate missing abort API
                this.socket.onopen = ()=>0;
                this.socket.onclose = ()=>0;
                this.socket.onerror = ()=>0;
                this.socket.onmessage = ()=>0;
                this.socket = undefined;
                if (this.closeHandler) this.closeHandler({
                    wasClean: false,
                    code: 4001
                });
                break;
            case $055b48888bdca8bd$var$isomorphic_ws_1.default.CLOSING:
                break;
            default:
                throw new Error(`Unknown readyState: ${this.socket.readyState}`);
        }
    }
    async send(data) {
        return new Promise((resolve, reject)=>{
            if (!this.socket) throw new Error("Socket undefined. This must be called after connecting.");
            if (this.closed) throw new Error("Socket was closed, so no data can be sent anymore.");
            // this exception should be thrown by send() automatically according to
            // https://developer.mozilla.org/de/docs/Web/API/WebSocket#send() but it does not work in browsers
            if (this.socket.readyState !== $055b48888bdca8bd$var$isomorphic_ws_1.default.OPEN) throw new Error("Websocket is not open");
            if ($055b48888bdca8bd$var$environmentIsNodeJs()) this.socket.send(data, (err)=>err ? reject(err) : resolve());
            else {
                // Browser websocket send method does not accept a callback
                this.socket.send(data);
                resolve();
            }
        });
    }
    /**
     * Clears the timeout function, such that no timeout error will be raised anymore. This should be
     * called when the connection is established, a connection error occurred or the socket is disconnected.
     *
     * This method must not be called before `connect()`.
     * This method is idempotent.
     */ clearTimeout() {
        if (!this.timeoutId) throw new Error("Timeout ID not set. This should not happen and usually means connect() was not called.");
        // Note: do not unset this.timeoutId to allow multiple calls to this function
        clearTimeout(this.timeoutId);
    }
    constructor(url, messageHandler, errorHandler, openHandler, closeHandler, timeout = 10000){
        this.closed = false;
        this.connected = new Promise((resolve, reject)=>{
            this.connectedResolver = resolve;
            this.connectedRejecter = reject;
        });
        this.url = url;
        this.messageHandler = messageHandler;
        this.errorHandler = errorHandler;
        this.openHandler = openHandler;
        this.closeHandler = closeHandler;
        this.timeout = timeout;
    }
}
module.exports.SocketWrapper = $055b48888bdca8bd$var$SocketWrapper;

});



parcelRegister("flFKr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ReconnectingSocket = void 0;

var $kCwQy = parcelRequire("kCwQy");

var $ebCTq = parcelRequire("ebCTq");
/**
 * A wrapper around QueueingStreamingSocket that reconnects automatically.
 */ class $b2c9337a714b3fcf$var$ReconnectingSocket {
    /** Starts with a 0.1 second timeout, then doubles every attempt with a maximum timeout of 5 seconds. */ static calculateTimeout(index) {
        return Math.min(2 ** index * 100, 5000);
    }
    connect() {
        if (!this.unconnected) throw new Error("Cannot connect: socket has already connected");
        this.socket.connect();
        this.unconnected = false;
    }
    disconnect() {
        if (this.unconnected) throw new Error("Cannot disconnect: socket has not yet connected");
        this.socket.disconnect();
        if (this.eventProducerListener) this.eventProducerListener.complete();
        this.disconnected = true;
    }
    queueRequest(request) {
        if (this.disconnected) throw new Error("Cannot queue request: socket has disconnected");
        this.socket.queueRequest(request);
    }
    constructor(url, timeout = 10000, reconnectedHandler){
        this.unconnected = true;
        this.disconnected = false;
        this.timeoutIndex = 0;
        this.reconnectTimeout = null;
        const eventProducer = {
            start: (listener)=>this.eventProducerListener = listener,
            stop: ()=>this.eventProducerListener = undefined
        };
        this.events = $kCwQy.Stream.create(eventProducer);
        this.socket = new $ebCTq.QueueingStreamingSocket(url, timeout, reconnectedHandler);
        this.socket.events.subscribe({
            next: (event)=>{
                if (this.eventProducerListener) this.eventProducerListener.next(event);
            },
            error: (error)=>{
                if (this.eventProducerListener) this.eventProducerListener.error(error);
            }
        });
        this.connectionStatus = this.socket.connectionStatus;
        this.connectionStatus.updates.subscribe({
            next: (status)=>{
                if (status === $ebCTq.ConnectionStatus.Connected) this.timeoutIndex = 0;
                if (status === $ebCTq.ConnectionStatus.Disconnected) {
                    if (this.reconnectTimeout) {
                        clearTimeout(this.reconnectTimeout);
                        this.reconnectTimeout = null;
                    }
                    this.reconnectTimeout = setTimeout(()=>this.socket.reconnect(), $b2c9337a714b3fcf$var$ReconnectingSocket.calculateTimeout(this.timeoutIndex++));
                }
            }
        });
    }
}
module.exports.ReconnectingSocket = $b2c9337a714b3fcf$var$ReconnectingSocket;

});




parcelRegister("cu1uI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.adaptor34 = void 0;

var $i2CZI = parcelRequire("i2CZI");

var $50pA5 = parcelRequire("50pA5");

var $eyYDC = parcelRequire("eyYDC");
module.exports.adaptor34 = {
    params: $50pA5.Params,
    responses: $eyYDC.Responses,
    hashTx: $i2CZI.hashTx,
    hashBlock: $i2CZI.hashBlock
};

});
parcelRegister("i2CZI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hashBlock = module.exports.hashTx = void 0;

var $9Nqq4 = parcelRequire("9Nqq4");

var $75MVN = parcelRequire("75MVN");
// hash is sha256
// https://github.com/tendermint/tendermint/blob/master/UPGRADING.md#v0260
function $d226a961357810d8$var$hashTx(tx) {
    return (0, $9Nqq4.sha256)(tx);
}
module.exports.hashTx = $d226a961357810d8$var$hashTx;
function $d226a961357810d8$var$getSplitPoint(n) {
    if (n < 1) throw new Error("Cannot split an empty tree");
    const largestPowerOf2 = 2 ** Math.floor(Math.log2(n));
    return largestPowerOf2 < n ? largestPowerOf2 : largestPowerOf2 / 2;
}
function $d226a961357810d8$var$hashLeaf(leaf) {
    const hash = new $9Nqq4.Sha256(Uint8Array.from([
        0
    ]));
    hash.update(leaf);
    return hash.digest();
}
function $d226a961357810d8$var$hashInner(left, right) {
    const hash = new $9Nqq4.Sha256(Uint8Array.from([
        1
    ]));
    hash.update(left);
    hash.update(right);
    return hash.digest();
}
// See https://github.com/tendermint/tendermint/blob/v0.31.8/docs/spec/blockchain/encoding.md#merkleroot
// Note: the hashes input may not actually be hashes, especially before a recursive call
function $d226a961357810d8$var$hashTree(hashes) {
    switch(hashes.length){
        case 0:
            throw new Error("Cannot hash empty tree");
        case 1:
            return $d226a961357810d8$var$hashLeaf(hashes[0]);
        default:
            {
                const slicePoint = $d226a961357810d8$var$getSplitPoint(hashes.length);
                const left = $d226a961357810d8$var$hashTree(hashes.slice(0, slicePoint));
                const right = $d226a961357810d8$var$hashTree(hashes.slice(slicePoint));
                return $d226a961357810d8$var$hashInner(left, right);
            }
    }
}
function $d226a961357810d8$var$hashBlock(header) {
    if (!header.lastBlockId) throw new Error("Hashing a block header with no last block ID (i.e. header at height 1) is not supported. If you need this, contributions are welcome. Please add documentation and test vectors for this case.");
    const encodedFields = [
        (0, $75MVN.encodeVersion)(header.version),
        (0, $75MVN.encodeString)(header.chainId),
        (0, $75MVN.encodeInt)(header.height),
        (0, $75MVN.encodeTime)(header.time),
        (0, $75MVN.encodeBlockId)(header.lastBlockId),
        (0, $75MVN.encodeBytes)(header.lastCommitHash),
        (0, $75MVN.encodeBytes)(header.dataHash),
        (0, $75MVN.encodeBytes)(header.validatorsHash),
        (0, $75MVN.encodeBytes)(header.nextValidatorsHash),
        (0, $75MVN.encodeBytes)(header.consensusHash),
        (0, $75MVN.encodeBytes)(header.appHash),
        (0, $75MVN.encodeBytes)(header.lastResultsHash),
        (0, $75MVN.encodeBytes)(header.evidenceHash),
        (0, $75MVN.encodeBytes)(header.proposerAddress)
    ];
    return $d226a961357810d8$var$hashTree(encodedFields);
}
module.exports.hashBlock = $d226a961357810d8$var$hashBlock;

});
parcelRegister("9Nqq4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.stringToPath = module.exports.Slip10RawIndex = module.exports.slip10CurveFromString = module.exports.Slip10Curve = module.exports.Slip10 = module.exports.pathToString = module.exports.sha512 = module.exports.Sha512 = module.exports.sha256 = module.exports.Sha256 = module.exports.Secp256k1Signature = module.exports.ExtendedSecp256k1Signature = module.exports.Secp256k1 = module.exports.ripemd160 = module.exports.Ripemd160 = module.exports.Random = module.exports.Xchacha20poly1305Ietf = module.exports.xchacha20NonceLength = module.exports.isArgon2idOptions = module.exports.Ed25519Keypair = module.exports.Ed25519 = module.exports.Argon2id = module.exports.keccak256 = module.exports.Keccak256 = module.exports.Hmac = module.exports.EnglishMnemonic = module.exports.Bip39 = void 0;

var $fet7R = parcelRequire("fet7R");
Object.defineProperty(module.exports, "Bip39", {
    enumerable: true,
    get: function() {
        return $fet7R.Bip39;
    }
});
Object.defineProperty(module.exports, "EnglishMnemonic", {
    enumerable: true,
    get: function() {
        return $fet7R.EnglishMnemonic;
    }
});

var $6vFTM = parcelRequire("6vFTM");
Object.defineProperty(module.exports, "Hmac", {
    enumerable: true,
    get: function() {
        return $6vFTM.Hmac;
    }
});

var $eJL0q = parcelRequire("eJL0q");
Object.defineProperty(module.exports, "Keccak256", {
    enumerable: true,
    get: function() {
        return $eJL0q.Keccak256;
    }
});
Object.defineProperty(module.exports, "keccak256", {
    enumerable: true,
    get: function() {
        return $eJL0q.keccak256;
    }
});

var $3sl9s = parcelRequire("3sl9s");
Object.defineProperty(module.exports, "Argon2id", {
    enumerable: true,
    get: function() {
        return $3sl9s.Argon2id;
    }
});
Object.defineProperty(module.exports, "Ed25519", {
    enumerable: true,
    get: function() {
        return $3sl9s.Ed25519;
    }
});
Object.defineProperty(module.exports, "Ed25519Keypair", {
    enumerable: true,
    get: function() {
        return $3sl9s.Ed25519Keypair;
    }
});
Object.defineProperty(module.exports, "isArgon2idOptions", {
    enumerable: true,
    get: function() {
        return $3sl9s.isArgon2idOptions;
    }
});
Object.defineProperty(module.exports, "xchacha20NonceLength", {
    enumerable: true,
    get: function() {
        return $3sl9s.xchacha20NonceLength;
    }
});
Object.defineProperty(module.exports, "Xchacha20poly1305Ietf", {
    enumerable: true,
    get: function() {
        return $3sl9s.Xchacha20poly1305Ietf;
    }
});

var $aLEOL = parcelRequire("aLEOL");
Object.defineProperty(module.exports, "Random", {
    enumerable: true,
    get: function() {
        return $aLEOL.Random;
    }
});

var $byoZt = parcelRequire("byoZt");
Object.defineProperty(module.exports, "Ripemd160", {
    enumerable: true,
    get: function() {
        return $byoZt.Ripemd160;
    }
});
Object.defineProperty(module.exports, "ripemd160", {
    enumerable: true,
    get: function() {
        return $byoZt.ripemd160;
    }
});

var $ymcBJ = parcelRequire("ymcBJ");
Object.defineProperty(module.exports, "Secp256k1", {
    enumerable: true,
    get: function() {
        return $ymcBJ.Secp256k1;
    }
});

var $5xf6q = parcelRequire("5xf6q");
Object.defineProperty(module.exports, "ExtendedSecp256k1Signature", {
    enumerable: true,
    get: function() {
        return $5xf6q.ExtendedSecp256k1Signature;
    }
});
Object.defineProperty(module.exports, "Secp256k1Signature", {
    enumerable: true,
    get: function() {
        return $5xf6q.Secp256k1Signature;
    }
});

var $aMdHR = parcelRequire("aMdHR");
Object.defineProperty(module.exports, "Sha256", {
    enumerable: true,
    get: function() {
        return $aMdHR.Sha256;
    }
});
Object.defineProperty(module.exports, "sha256", {
    enumerable: true,
    get: function() {
        return $aMdHR.sha256;
    }
});
Object.defineProperty(module.exports, "Sha512", {
    enumerable: true,
    get: function() {
        return $aMdHR.Sha512;
    }
});
Object.defineProperty(module.exports, "sha512", {
    enumerable: true,
    get: function() {
        return $aMdHR.sha512;
    }
});

var $hhuH3 = parcelRequire("hhuH3");
Object.defineProperty(module.exports, "pathToString", {
    enumerable: true,
    get: function() {
        return $hhuH3.pathToString;
    }
});
Object.defineProperty(module.exports, "Slip10", {
    enumerable: true,
    get: function() {
        return $hhuH3.Slip10;
    }
});
Object.defineProperty(module.exports, "Slip10Curve", {
    enumerable: true,
    get: function() {
        return $hhuH3.Slip10Curve;
    }
});
Object.defineProperty(module.exports, "slip10CurveFromString", {
    enumerable: true,
    get: function() {
        return $hhuH3.slip10CurveFromString;
    }
});
Object.defineProperty(module.exports, "Slip10RawIndex", {
    enumerable: true,
    get: function() {
        return $hhuH3.Slip10RawIndex;
    }
});
Object.defineProperty(module.exports, "stringToPath", {
    enumerable: true,
    get: function() {
        return $hhuH3.stringToPath;
    }
});

});
parcelRegister("fet7R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Bip39 = module.exports.EnglishMnemonic = module.exports.mnemonicToEntropy = module.exports.entropyToMnemonic = void 0;

var $5zb9p = parcelRequire("5zb9p");

var $lr402 = parcelRequire("lr402");

var $aMdHR = parcelRequire("aMdHR");
const $b16ec198333abbe4$var$wordlist = [
    "abandon",
    "ability",
    "able",
    "about",
    "above",
    "absent",
    "absorb",
    "abstract",
    "absurd",
    "abuse",
    "access",
    "accident",
    "account",
    "accuse",
    "achieve",
    "acid",
    "acoustic",
    "acquire",
    "across",
    "act",
    "action",
    "actor",
    "actress",
    "actual",
    "adapt",
    "add",
    "addict",
    "address",
    "adjust",
    "admit",
    "adult",
    "advance",
    "advice",
    "aerobic",
    "affair",
    "afford",
    "afraid",
    "again",
    "age",
    "agent",
    "agree",
    "ahead",
    "aim",
    "air",
    "airport",
    "aisle",
    "alarm",
    "album",
    "alcohol",
    "alert",
    "alien",
    "all",
    "alley",
    "allow",
    "almost",
    "alone",
    "alpha",
    "already",
    "also",
    "alter",
    "always",
    "amateur",
    "amazing",
    "among",
    "amount",
    "amused",
    "analyst",
    "anchor",
    "ancient",
    "anger",
    "angle",
    "angry",
    "animal",
    "ankle",
    "announce",
    "annual",
    "another",
    "answer",
    "antenna",
    "antique",
    "anxiety",
    "any",
    "apart",
    "apology",
    "appear",
    "apple",
    "approve",
    "april",
    "arch",
    "arctic",
    "area",
    "arena",
    "argue",
    "arm",
    "armed",
    "armor",
    "army",
    "around",
    "arrange",
    "arrest",
    "arrive",
    "arrow",
    "art",
    "artefact",
    "artist",
    "artwork",
    "ask",
    "aspect",
    "assault",
    "asset",
    "assist",
    "assume",
    "asthma",
    "athlete",
    "atom",
    "attack",
    "attend",
    "attitude",
    "attract",
    "auction",
    "audit",
    "august",
    "aunt",
    "author",
    "auto",
    "autumn",
    "average",
    "avocado",
    "avoid",
    "awake",
    "aware",
    "away",
    "awesome",
    "awful",
    "awkward",
    "axis",
    "baby",
    "bachelor",
    "bacon",
    "badge",
    "bag",
    "balance",
    "balcony",
    "ball",
    "bamboo",
    "banana",
    "banner",
    "bar",
    "barely",
    "bargain",
    "barrel",
    "base",
    "basic",
    "basket",
    "battle",
    "beach",
    "bean",
    "beauty",
    "because",
    "become",
    "beef",
    "before",
    "begin",
    "behave",
    "behind",
    "believe",
    "below",
    "belt",
    "bench",
    "benefit",
    "best",
    "betray",
    "better",
    "between",
    "beyond",
    "bicycle",
    "bid",
    "bike",
    "bind",
    "biology",
    "bird",
    "birth",
    "bitter",
    "black",
    "blade",
    "blame",
    "blanket",
    "blast",
    "bleak",
    "bless",
    "blind",
    "blood",
    "blossom",
    "blouse",
    "blue",
    "blur",
    "blush",
    "board",
    "boat",
    "body",
    "boil",
    "bomb",
    "bone",
    "bonus",
    "book",
    "boost",
    "border",
    "boring",
    "borrow",
    "boss",
    "bottom",
    "bounce",
    "box",
    "boy",
    "bracket",
    "brain",
    "brand",
    "brass",
    "brave",
    "bread",
    "breeze",
    "brick",
    "bridge",
    "brief",
    "bright",
    "bring",
    "brisk",
    "broccoli",
    "broken",
    "bronze",
    "broom",
    "brother",
    "brown",
    "brush",
    "bubble",
    "buddy",
    "budget",
    "buffalo",
    "build",
    "bulb",
    "bulk",
    "bullet",
    "bundle",
    "bunker",
    "burden",
    "burger",
    "burst",
    "bus",
    "business",
    "busy",
    "butter",
    "buyer",
    "buzz",
    "cabbage",
    "cabin",
    "cable",
    "cactus",
    "cage",
    "cake",
    "call",
    "calm",
    "camera",
    "camp",
    "can",
    "canal",
    "cancel",
    "candy",
    "cannon",
    "canoe",
    "canvas",
    "canyon",
    "capable",
    "capital",
    "captain",
    "car",
    "carbon",
    "card",
    "cargo",
    "carpet",
    "carry",
    "cart",
    "case",
    "cash",
    "casino",
    "castle",
    "casual",
    "cat",
    "catalog",
    "catch",
    "category",
    "cattle",
    "caught",
    "cause",
    "caution",
    "cave",
    "ceiling",
    "celery",
    "cement",
    "census",
    "century",
    "cereal",
    "certain",
    "chair",
    "chalk",
    "champion",
    "change",
    "chaos",
    "chapter",
    "charge",
    "chase",
    "chat",
    "cheap",
    "check",
    "cheese",
    "chef",
    "cherry",
    "chest",
    "chicken",
    "chief",
    "child",
    "chimney",
    "choice",
    "choose",
    "chronic",
    "chuckle",
    "chunk",
    "churn",
    "cigar",
    "cinnamon",
    "circle",
    "citizen",
    "city",
    "civil",
    "claim",
    "clap",
    "clarify",
    "claw",
    "clay",
    "clean",
    "clerk",
    "clever",
    "click",
    "client",
    "cliff",
    "climb",
    "clinic",
    "clip",
    "clock",
    "clog",
    "close",
    "cloth",
    "cloud",
    "clown",
    "club",
    "clump",
    "cluster",
    "clutch",
    "coach",
    "coast",
    "coconut",
    "code",
    "coffee",
    "coil",
    "coin",
    "collect",
    "color",
    "column",
    "combine",
    "come",
    "comfort",
    "comic",
    "common",
    "company",
    "concert",
    "conduct",
    "confirm",
    "congress",
    "connect",
    "consider",
    "control",
    "convince",
    "cook",
    "cool",
    "copper",
    "copy",
    "coral",
    "core",
    "corn",
    "correct",
    "cost",
    "cotton",
    "couch",
    "country",
    "couple",
    "course",
    "cousin",
    "cover",
    "coyote",
    "crack",
    "cradle",
    "craft",
    "cram",
    "crane",
    "crash",
    "crater",
    "crawl",
    "crazy",
    "cream",
    "credit",
    "creek",
    "crew",
    "cricket",
    "crime",
    "crisp",
    "critic",
    "crop",
    "cross",
    "crouch",
    "crowd",
    "crucial",
    "cruel",
    "cruise",
    "crumble",
    "crunch",
    "crush",
    "cry",
    "crystal",
    "cube",
    "culture",
    "cup",
    "cupboard",
    "curious",
    "current",
    "curtain",
    "curve",
    "cushion",
    "custom",
    "cute",
    "cycle",
    "dad",
    "damage",
    "damp",
    "dance",
    "danger",
    "daring",
    "dash",
    "daughter",
    "dawn",
    "day",
    "deal",
    "debate",
    "debris",
    "decade",
    "december",
    "decide",
    "decline",
    "decorate",
    "decrease",
    "deer",
    "defense",
    "define",
    "defy",
    "degree",
    "delay",
    "deliver",
    "demand",
    "demise",
    "denial",
    "dentist",
    "deny",
    "depart",
    "depend",
    "deposit",
    "depth",
    "deputy",
    "derive",
    "describe",
    "desert",
    "design",
    "desk",
    "despair",
    "destroy",
    "detail",
    "detect",
    "develop",
    "device",
    "devote",
    "diagram",
    "dial",
    "diamond",
    "diary",
    "dice",
    "diesel",
    "diet",
    "differ",
    "digital",
    "dignity",
    "dilemma",
    "dinner",
    "dinosaur",
    "direct",
    "dirt",
    "disagree",
    "discover",
    "disease",
    "dish",
    "dismiss",
    "disorder",
    "display",
    "distance",
    "divert",
    "divide",
    "divorce",
    "dizzy",
    "doctor",
    "document",
    "dog",
    "doll",
    "dolphin",
    "domain",
    "donate",
    "donkey",
    "donor",
    "door",
    "dose",
    "double",
    "dove",
    "draft",
    "dragon",
    "drama",
    "drastic",
    "draw",
    "dream",
    "dress",
    "drift",
    "drill",
    "drink",
    "drip",
    "drive",
    "drop",
    "drum",
    "dry",
    "duck",
    "dumb",
    "dune",
    "during",
    "dust",
    "dutch",
    "duty",
    "dwarf",
    "dynamic",
    "eager",
    "eagle",
    "early",
    "earn",
    "earth",
    "easily",
    "east",
    "easy",
    "echo",
    "ecology",
    "economy",
    "edge",
    "edit",
    "educate",
    "effort",
    "egg",
    "eight",
    "either",
    "elbow",
    "elder",
    "electric",
    "elegant",
    "element",
    "elephant",
    "elevator",
    "elite",
    "else",
    "embark",
    "embody",
    "embrace",
    "emerge",
    "emotion",
    "employ",
    "empower",
    "empty",
    "enable",
    "enact",
    "end",
    "endless",
    "endorse",
    "enemy",
    "energy",
    "enforce",
    "engage",
    "engine",
    "enhance",
    "enjoy",
    "enlist",
    "enough",
    "enrich",
    "enroll",
    "ensure",
    "enter",
    "entire",
    "entry",
    "envelope",
    "episode",
    "equal",
    "equip",
    "era",
    "erase",
    "erode",
    "erosion",
    "error",
    "erupt",
    "escape",
    "essay",
    "essence",
    "estate",
    "eternal",
    "ethics",
    "evidence",
    "evil",
    "evoke",
    "evolve",
    "exact",
    "example",
    "excess",
    "exchange",
    "excite",
    "exclude",
    "excuse",
    "execute",
    "exercise",
    "exhaust",
    "exhibit",
    "exile",
    "exist",
    "exit",
    "exotic",
    "expand",
    "expect",
    "expire",
    "explain",
    "expose",
    "express",
    "extend",
    "extra",
    "eye",
    "eyebrow",
    "fabric",
    "face",
    "faculty",
    "fade",
    "faint",
    "faith",
    "fall",
    "false",
    "fame",
    "family",
    "famous",
    "fan",
    "fancy",
    "fantasy",
    "farm",
    "fashion",
    "fat",
    "fatal",
    "father",
    "fatigue",
    "fault",
    "favorite",
    "feature",
    "february",
    "federal",
    "fee",
    "feed",
    "feel",
    "female",
    "fence",
    "festival",
    "fetch",
    "fever",
    "few",
    "fiber",
    "fiction",
    "field",
    "figure",
    "file",
    "film",
    "filter",
    "final",
    "find",
    "fine",
    "finger",
    "finish",
    "fire",
    "firm",
    "first",
    "fiscal",
    "fish",
    "fit",
    "fitness",
    "fix",
    "flag",
    "flame",
    "flash",
    "flat",
    "flavor",
    "flee",
    "flight",
    "flip",
    "float",
    "flock",
    "floor",
    "flower",
    "fluid",
    "flush",
    "fly",
    "foam",
    "focus",
    "fog",
    "foil",
    "fold",
    "follow",
    "food",
    "foot",
    "force",
    "forest",
    "forget",
    "fork",
    "fortune",
    "forum",
    "forward",
    "fossil",
    "foster",
    "found",
    "fox",
    "fragile",
    "frame",
    "frequent",
    "fresh",
    "friend",
    "fringe",
    "frog",
    "front",
    "frost",
    "frown",
    "frozen",
    "fruit",
    "fuel",
    "fun",
    "funny",
    "furnace",
    "fury",
    "future",
    "gadget",
    "gain",
    "galaxy",
    "gallery",
    "game",
    "gap",
    "garage",
    "garbage",
    "garden",
    "garlic",
    "garment",
    "gas",
    "gasp",
    "gate",
    "gather",
    "gauge",
    "gaze",
    "general",
    "genius",
    "genre",
    "gentle",
    "genuine",
    "gesture",
    "ghost",
    "giant",
    "gift",
    "giggle",
    "ginger",
    "giraffe",
    "girl",
    "give",
    "glad",
    "glance",
    "glare",
    "glass",
    "glide",
    "glimpse",
    "globe",
    "gloom",
    "glory",
    "glove",
    "glow",
    "glue",
    "goat",
    "goddess",
    "gold",
    "good",
    "goose",
    "gorilla",
    "gospel",
    "gossip",
    "govern",
    "gown",
    "grab",
    "grace",
    "grain",
    "grant",
    "grape",
    "grass",
    "gravity",
    "great",
    "green",
    "grid",
    "grief",
    "grit",
    "grocery",
    "group",
    "grow",
    "grunt",
    "guard",
    "guess",
    "guide",
    "guilt",
    "guitar",
    "gun",
    "gym",
    "habit",
    "hair",
    "half",
    "hammer",
    "hamster",
    "hand",
    "happy",
    "harbor",
    "hard",
    "harsh",
    "harvest",
    "hat",
    "have",
    "hawk",
    "hazard",
    "head",
    "health",
    "heart",
    "heavy",
    "hedgehog",
    "height",
    "hello",
    "helmet",
    "help",
    "hen",
    "hero",
    "hidden",
    "high",
    "hill",
    "hint",
    "hip",
    "hire",
    "history",
    "hobby",
    "hockey",
    "hold",
    "hole",
    "holiday",
    "hollow",
    "home",
    "honey",
    "hood",
    "hope",
    "horn",
    "horror",
    "horse",
    "hospital",
    "host",
    "hotel",
    "hour",
    "hover",
    "hub",
    "huge",
    "human",
    "humble",
    "humor",
    "hundred",
    "hungry",
    "hunt",
    "hurdle",
    "hurry",
    "hurt",
    "husband",
    "hybrid",
    "ice",
    "icon",
    "idea",
    "identify",
    "idle",
    "ignore",
    "ill",
    "illegal",
    "illness",
    "image",
    "imitate",
    "immense",
    "immune",
    "impact",
    "impose",
    "improve",
    "impulse",
    "inch",
    "include",
    "income",
    "increase",
    "index",
    "indicate",
    "indoor",
    "industry",
    "infant",
    "inflict",
    "inform",
    "inhale",
    "inherit",
    "initial",
    "inject",
    "injury",
    "inmate",
    "inner",
    "innocent",
    "input",
    "inquiry",
    "insane",
    "insect",
    "inside",
    "inspire",
    "install",
    "intact",
    "interest",
    "into",
    "invest",
    "invite",
    "involve",
    "iron",
    "island",
    "isolate",
    "issue",
    "item",
    "ivory",
    "jacket",
    "jaguar",
    "jar",
    "jazz",
    "jealous",
    "jeans",
    "jelly",
    "jewel",
    "job",
    "join",
    "joke",
    "journey",
    "joy",
    "judge",
    "juice",
    "jump",
    "jungle",
    "junior",
    "junk",
    "just",
    "kangaroo",
    "keen",
    "keep",
    "ketchup",
    "key",
    "kick",
    "kid",
    "kidney",
    "kind",
    "kingdom",
    "kiss",
    "kit",
    "kitchen",
    "kite",
    "kitten",
    "kiwi",
    "knee",
    "knife",
    "knock",
    "know",
    "lab",
    "label",
    "labor",
    "ladder",
    "lady",
    "lake",
    "lamp",
    "language",
    "laptop",
    "large",
    "later",
    "latin",
    "laugh",
    "laundry",
    "lava",
    "law",
    "lawn",
    "lawsuit",
    "layer",
    "lazy",
    "leader",
    "leaf",
    "learn",
    "leave",
    "lecture",
    "left",
    "leg",
    "legal",
    "legend",
    "leisure",
    "lemon",
    "lend",
    "length",
    "lens",
    "leopard",
    "lesson",
    "letter",
    "level",
    "liar",
    "liberty",
    "library",
    "license",
    "life",
    "lift",
    "light",
    "like",
    "limb",
    "limit",
    "link",
    "lion",
    "liquid",
    "list",
    "little",
    "live",
    "lizard",
    "load",
    "loan",
    "lobster",
    "local",
    "lock",
    "logic",
    "lonely",
    "long",
    "loop",
    "lottery",
    "loud",
    "lounge",
    "love",
    "loyal",
    "lucky",
    "luggage",
    "lumber",
    "lunar",
    "lunch",
    "luxury",
    "lyrics",
    "machine",
    "mad",
    "magic",
    "magnet",
    "maid",
    "mail",
    "main",
    "major",
    "make",
    "mammal",
    "man",
    "manage",
    "mandate",
    "mango",
    "mansion",
    "manual",
    "maple",
    "marble",
    "march",
    "margin",
    "marine",
    "market",
    "marriage",
    "mask",
    "mass",
    "master",
    "match",
    "material",
    "math",
    "matrix",
    "matter",
    "maximum",
    "maze",
    "meadow",
    "mean",
    "measure",
    "meat",
    "mechanic",
    "medal",
    "media",
    "melody",
    "melt",
    "member",
    "memory",
    "mention",
    "menu",
    "mercy",
    "merge",
    "merit",
    "merry",
    "mesh",
    "message",
    "metal",
    "method",
    "middle",
    "midnight",
    "milk",
    "million",
    "mimic",
    "mind",
    "minimum",
    "minor",
    "minute",
    "miracle",
    "mirror",
    "misery",
    "miss",
    "mistake",
    "mix",
    "mixed",
    "mixture",
    "mobile",
    "model",
    "modify",
    "mom",
    "moment",
    "monitor",
    "monkey",
    "monster",
    "month",
    "moon",
    "moral",
    "more",
    "morning",
    "mosquito",
    "mother",
    "motion",
    "motor",
    "mountain",
    "mouse",
    "move",
    "movie",
    "much",
    "muffin",
    "mule",
    "multiply",
    "muscle",
    "museum",
    "mushroom",
    "music",
    "must",
    "mutual",
    "myself",
    "mystery",
    "myth",
    "naive",
    "name",
    "napkin",
    "narrow",
    "nasty",
    "nation",
    "nature",
    "near",
    "neck",
    "need",
    "negative",
    "neglect",
    "neither",
    "nephew",
    "nerve",
    "nest",
    "net",
    "network",
    "neutral",
    "never",
    "news",
    "next",
    "nice",
    "night",
    "noble",
    "noise",
    "nominee",
    "noodle",
    "normal",
    "north",
    "nose",
    "notable",
    "note",
    "nothing",
    "notice",
    "novel",
    "now",
    "nuclear",
    "number",
    "nurse",
    "nut",
    "oak",
    "obey",
    "object",
    "oblige",
    "obscure",
    "observe",
    "obtain",
    "obvious",
    "occur",
    "ocean",
    "october",
    "odor",
    "off",
    "offer",
    "office",
    "often",
    "oil",
    "okay",
    "old",
    "olive",
    "olympic",
    "omit",
    "once",
    "one",
    "onion",
    "online",
    "only",
    "open",
    "opera",
    "opinion",
    "oppose",
    "option",
    "orange",
    "orbit",
    "orchard",
    "order",
    "ordinary",
    "organ",
    "orient",
    "original",
    "orphan",
    "ostrich",
    "other",
    "outdoor",
    "outer",
    "output",
    "outside",
    "oval",
    "oven",
    "over",
    "own",
    "owner",
    "oxygen",
    "oyster",
    "ozone",
    "pact",
    "paddle",
    "page",
    "pair",
    "palace",
    "palm",
    "panda",
    "panel",
    "panic",
    "panther",
    "paper",
    "parade",
    "parent",
    "park",
    "parrot",
    "party",
    "pass",
    "patch",
    "path",
    "patient",
    "patrol",
    "pattern",
    "pause",
    "pave",
    "payment",
    "peace",
    "peanut",
    "pear",
    "peasant",
    "pelican",
    "pen",
    "penalty",
    "pencil",
    "people",
    "pepper",
    "perfect",
    "permit",
    "person",
    "pet",
    "phone",
    "photo",
    "phrase",
    "physical",
    "piano",
    "picnic",
    "picture",
    "piece",
    "pig",
    "pigeon",
    "pill",
    "pilot",
    "pink",
    "pioneer",
    "pipe",
    "pistol",
    "pitch",
    "pizza",
    "place",
    "planet",
    "plastic",
    "plate",
    "play",
    "please",
    "pledge",
    "pluck",
    "plug",
    "plunge",
    "poem",
    "poet",
    "point",
    "polar",
    "pole",
    "police",
    "pond",
    "pony",
    "pool",
    "popular",
    "portion",
    "position",
    "possible",
    "post",
    "potato",
    "pottery",
    "poverty",
    "powder",
    "power",
    "practice",
    "praise",
    "predict",
    "prefer",
    "prepare",
    "present",
    "pretty",
    "prevent",
    "price",
    "pride",
    "primary",
    "print",
    "priority",
    "prison",
    "private",
    "prize",
    "problem",
    "process",
    "produce",
    "profit",
    "program",
    "project",
    "promote",
    "proof",
    "property",
    "prosper",
    "protect",
    "proud",
    "provide",
    "public",
    "pudding",
    "pull",
    "pulp",
    "pulse",
    "pumpkin",
    "punch",
    "pupil",
    "puppy",
    "purchase",
    "purity",
    "purpose",
    "purse",
    "push",
    "put",
    "puzzle",
    "pyramid",
    "quality",
    "quantum",
    "quarter",
    "question",
    "quick",
    "quit",
    "quiz",
    "quote",
    "rabbit",
    "raccoon",
    "race",
    "rack",
    "radar",
    "radio",
    "rail",
    "rain",
    "raise",
    "rally",
    "ramp",
    "ranch",
    "random",
    "range",
    "rapid",
    "rare",
    "rate",
    "rather",
    "raven",
    "raw",
    "razor",
    "ready",
    "real",
    "reason",
    "rebel",
    "rebuild",
    "recall",
    "receive",
    "recipe",
    "record",
    "recycle",
    "reduce",
    "reflect",
    "reform",
    "refuse",
    "region",
    "regret",
    "regular",
    "reject",
    "relax",
    "release",
    "relief",
    "rely",
    "remain",
    "remember",
    "remind",
    "remove",
    "render",
    "renew",
    "rent",
    "reopen",
    "repair",
    "repeat",
    "replace",
    "report",
    "require",
    "rescue",
    "resemble",
    "resist",
    "resource",
    "response",
    "result",
    "retire",
    "retreat",
    "return",
    "reunion",
    "reveal",
    "review",
    "reward",
    "rhythm",
    "rib",
    "ribbon",
    "rice",
    "rich",
    "ride",
    "ridge",
    "rifle",
    "right",
    "rigid",
    "ring",
    "riot",
    "ripple",
    "risk",
    "ritual",
    "rival",
    "river",
    "road",
    "roast",
    "robot",
    "robust",
    "rocket",
    "romance",
    "roof",
    "rookie",
    "room",
    "rose",
    "rotate",
    "rough",
    "round",
    "route",
    "royal",
    "rubber",
    "rude",
    "rug",
    "rule",
    "run",
    "runway",
    "rural",
    "sad",
    "saddle",
    "sadness",
    "safe",
    "sail",
    "salad",
    "salmon",
    "salon",
    "salt",
    "salute",
    "same",
    "sample",
    "sand",
    "satisfy",
    "satoshi",
    "sauce",
    "sausage",
    "save",
    "say",
    "scale",
    "scan",
    "scare",
    "scatter",
    "scene",
    "scheme",
    "school",
    "science",
    "scissors",
    "scorpion",
    "scout",
    "scrap",
    "screen",
    "script",
    "scrub",
    "sea",
    "search",
    "season",
    "seat",
    "second",
    "secret",
    "section",
    "security",
    "seed",
    "seek",
    "segment",
    "select",
    "sell",
    "seminar",
    "senior",
    "sense",
    "sentence",
    "series",
    "service",
    "session",
    "settle",
    "setup",
    "seven",
    "shadow",
    "shaft",
    "shallow",
    "share",
    "shed",
    "shell",
    "sheriff",
    "shield",
    "shift",
    "shine",
    "ship",
    "shiver",
    "shock",
    "shoe",
    "shoot",
    "shop",
    "short",
    "shoulder",
    "shove",
    "shrimp",
    "shrug",
    "shuffle",
    "shy",
    "sibling",
    "sick",
    "side",
    "siege",
    "sight",
    "sign",
    "silent",
    "silk",
    "silly",
    "silver",
    "similar",
    "simple",
    "since",
    "sing",
    "siren",
    "sister",
    "situate",
    "six",
    "size",
    "skate",
    "sketch",
    "ski",
    "skill",
    "skin",
    "skirt",
    "skull",
    "slab",
    "slam",
    "sleep",
    "slender",
    "slice",
    "slide",
    "slight",
    "slim",
    "slogan",
    "slot",
    "slow",
    "slush",
    "small",
    "smart",
    "smile",
    "smoke",
    "smooth",
    "snack",
    "snake",
    "snap",
    "sniff",
    "snow",
    "soap",
    "soccer",
    "social",
    "sock",
    "soda",
    "soft",
    "solar",
    "soldier",
    "solid",
    "solution",
    "solve",
    "someone",
    "song",
    "soon",
    "sorry",
    "sort",
    "soul",
    "sound",
    "soup",
    "source",
    "south",
    "space",
    "spare",
    "spatial",
    "spawn",
    "speak",
    "special",
    "speed",
    "spell",
    "spend",
    "sphere",
    "spice",
    "spider",
    "spike",
    "spin",
    "spirit",
    "split",
    "spoil",
    "sponsor",
    "spoon",
    "sport",
    "spot",
    "spray",
    "spread",
    "spring",
    "spy",
    "square",
    "squeeze",
    "squirrel",
    "stable",
    "stadium",
    "staff",
    "stage",
    "stairs",
    "stamp",
    "stand",
    "start",
    "state",
    "stay",
    "steak",
    "steel",
    "stem",
    "step",
    "stereo",
    "stick",
    "still",
    "sting",
    "stock",
    "stomach",
    "stone",
    "stool",
    "story",
    "stove",
    "strategy",
    "street",
    "strike",
    "strong",
    "struggle",
    "student",
    "stuff",
    "stumble",
    "style",
    "subject",
    "submit",
    "subway",
    "success",
    "such",
    "sudden",
    "suffer",
    "sugar",
    "suggest",
    "suit",
    "summer",
    "sun",
    "sunny",
    "sunset",
    "super",
    "supply",
    "supreme",
    "sure",
    "surface",
    "surge",
    "surprise",
    "surround",
    "survey",
    "suspect",
    "sustain",
    "swallow",
    "swamp",
    "swap",
    "swarm",
    "swear",
    "sweet",
    "swift",
    "swim",
    "swing",
    "switch",
    "sword",
    "symbol",
    "symptom",
    "syrup",
    "system",
    "table",
    "tackle",
    "tag",
    "tail",
    "talent",
    "talk",
    "tank",
    "tape",
    "target",
    "task",
    "taste",
    "tattoo",
    "taxi",
    "teach",
    "team",
    "tell",
    "ten",
    "tenant",
    "tennis",
    "tent",
    "term",
    "test",
    "text",
    "thank",
    "that",
    "theme",
    "then",
    "theory",
    "there",
    "they",
    "thing",
    "this",
    "thought",
    "three",
    "thrive",
    "throw",
    "thumb",
    "thunder",
    "ticket",
    "tide",
    "tiger",
    "tilt",
    "timber",
    "time",
    "tiny",
    "tip",
    "tired",
    "tissue",
    "title",
    "toast",
    "tobacco",
    "today",
    "toddler",
    "toe",
    "together",
    "toilet",
    "token",
    "tomato",
    "tomorrow",
    "tone",
    "tongue",
    "tonight",
    "tool",
    "tooth",
    "top",
    "topic",
    "topple",
    "torch",
    "tornado",
    "tortoise",
    "toss",
    "total",
    "tourist",
    "toward",
    "tower",
    "town",
    "toy",
    "track",
    "trade",
    "traffic",
    "tragic",
    "train",
    "transfer",
    "trap",
    "trash",
    "travel",
    "tray",
    "treat",
    "tree",
    "trend",
    "trial",
    "tribe",
    "trick",
    "trigger",
    "trim",
    "trip",
    "trophy",
    "trouble",
    "truck",
    "true",
    "truly",
    "trumpet",
    "trust",
    "truth",
    "try",
    "tube",
    "tuition",
    "tumble",
    "tuna",
    "tunnel",
    "turkey",
    "turn",
    "turtle",
    "twelve",
    "twenty",
    "twice",
    "twin",
    "twist",
    "two",
    "type",
    "typical",
    "ugly",
    "umbrella",
    "unable",
    "unaware",
    "uncle",
    "uncover",
    "under",
    "undo",
    "unfair",
    "unfold",
    "unhappy",
    "uniform",
    "unique",
    "unit",
    "universe",
    "unknown",
    "unlock",
    "until",
    "unusual",
    "unveil",
    "update",
    "upgrade",
    "uphold",
    "upon",
    "upper",
    "upset",
    "urban",
    "urge",
    "usage",
    "use",
    "used",
    "useful",
    "useless",
    "usual",
    "utility",
    "vacant",
    "vacuum",
    "vague",
    "valid",
    "valley",
    "valve",
    "van",
    "vanish",
    "vapor",
    "various",
    "vast",
    "vault",
    "vehicle",
    "velvet",
    "vendor",
    "venture",
    "venue",
    "verb",
    "verify",
    "version",
    "very",
    "vessel",
    "veteran",
    "viable",
    "vibrant",
    "vicious",
    "victory",
    "video",
    "view",
    "village",
    "vintage",
    "violin",
    "virtual",
    "virus",
    "visa",
    "visit",
    "visual",
    "vital",
    "vivid",
    "vocal",
    "voice",
    "void",
    "volcano",
    "volume",
    "vote",
    "voyage",
    "wage",
    "wagon",
    "wait",
    "walk",
    "wall",
    "walnut",
    "want",
    "warfare",
    "warm",
    "warrior",
    "wash",
    "wasp",
    "waste",
    "water",
    "wave",
    "way",
    "wealth",
    "weapon",
    "wear",
    "weasel",
    "weather",
    "web",
    "wedding",
    "weekend",
    "weird",
    "welcome",
    "west",
    "wet",
    "whale",
    "what",
    "wheat",
    "wheel",
    "when",
    "where",
    "whip",
    "whisper",
    "wide",
    "width",
    "wife",
    "wild",
    "will",
    "win",
    "window",
    "wine",
    "wing",
    "wink",
    "winner",
    "winter",
    "wire",
    "wisdom",
    "wise",
    "wish",
    "witness",
    "wolf",
    "woman",
    "wonder",
    "wood",
    "wool",
    "word",
    "work",
    "world",
    "worry",
    "worth",
    "wrap",
    "wreck",
    "wrestle",
    "wrist",
    "write",
    "wrong",
    "yard",
    "year",
    "yellow",
    "you",
    "young",
    "youth",
    "zebra",
    "zero",
    "zone",
    "zoo"
];
function $b16ec198333abbe4$var$bytesToBitstring(bytes) {
    return Array.from(bytes).map((byte)=>byte.toString(2).padStart(8, "0")).join("");
}
function $b16ec198333abbe4$var$deriveChecksumBits(entropy) {
    const entropyLengthBits = entropy.length * 8; // "ENT" (in bits)
    const checksumLengthBits = entropyLengthBits / 32; // "CS" (in bits)
    const hash = (0, $aMdHR.sha256)(entropy);
    return $b16ec198333abbe4$var$bytesToBitstring(hash).slice(0, checksumLengthBits);
}
function $b16ec198333abbe4$var$bitstringToByte(bin) {
    return parseInt(bin, 2);
}
const $b16ec198333abbe4$var$allowedEntropyLengths = [
    16,
    20,
    24,
    28,
    32
];
const $b16ec198333abbe4$var$allowedWordLengths = [
    12,
    15,
    18,
    21,
    24
];
function $b16ec198333abbe4$var$entropyToMnemonic(entropy) {
    if ($b16ec198333abbe4$var$allowedEntropyLengths.indexOf(entropy.length) === -1) throw new Error("invalid input length");
    const entropyBits = $b16ec198333abbe4$var$bytesToBitstring(entropy);
    const checksumBits = $b16ec198333abbe4$var$deriveChecksumBits(entropy);
    const bits = entropyBits + checksumBits;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const chunks = bits.match(/(.{11})/g);
    const words = chunks.map((binary)=>{
        const index = $b16ec198333abbe4$var$bitstringToByte(binary);
        return $b16ec198333abbe4$var$wordlist[index];
    });
    return words.join(" ");
}
module.exports.entropyToMnemonic = $b16ec198333abbe4$var$entropyToMnemonic;
const $b16ec198333abbe4$var$invalidNumberOfWorks = "Invalid number of words";
const $b16ec198333abbe4$var$wordNotInWordlist = "Found word that is not in the wordlist";
const $b16ec198333abbe4$var$invalidEntropy = "Invalid entropy";
const $b16ec198333abbe4$var$invalidChecksum = "Invalid mnemonic checksum";
function $b16ec198333abbe4$var$normalize(str) {
    return str.normalize("NFKD");
}
function $b16ec198333abbe4$var$mnemonicToEntropy(mnemonic) {
    const words = $b16ec198333abbe4$var$normalize(mnemonic).split(" ");
    if (!$b16ec198333abbe4$var$allowedWordLengths.includes(words.length)) throw new Error($b16ec198333abbe4$var$invalidNumberOfWorks);
    // convert word indices to 11 bit binary strings
    const bits = words.map((word)=>{
        const index = $b16ec198333abbe4$var$wordlist.indexOf(word);
        if (index === -1) throw new Error($b16ec198333abbe4$var$wordNotInWordlist);
        return index.toString(2).padStart(11, "0");
    }).join("");
    // split the binary string into ENT/CS
    const dividerIndex = Math.floor(bits.length / 33) * 32;
    const entropyBits = bits.slice(0, dividerIndex);
    const checksumBits = bits.slice(dividerIndex);
    // calculate the checksum and compare
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const entropyBytes = entropyBits.match(/(.{1,8})/g).map($b16ec198333abbe4$var$bitstringToByte);
    if (entropyBytes.length < 16 || entropyBytes.length > 32 || entropyBytes.length % 4 !== 0) throw new Error($b16ec198333abbe4$var$invalidEntropy);
    const entropy = Uint8Array.from(entropyBytes);
    const newChecksum = $b16ec198333abbe4$var$deriveChecksumBits(entropy);
    if (newChecksum !== checksumBits) throw new Error($b16ec198333abbe4$var$invalidChecksum);
    return entropy;
}
module.exports.mnemonicToEntropy = $b16ec198333abbe4$var$mnemonicToEntropy;
class $b16ec198333abbe4$var$EnglishMnemonic {
    toString() {
        return this.data;
    }
    constructor(mnemonic){
        if (!$b16ec198333abbe4$var$EnglishMnemonic.mnemonicMatcher.test(mnemonic)) throw new Error("Invalid mnemonic format");
        const words = mnemonic.split(" ");
        const allowedWordsLengths = [
            12,
            15,
            18,
            21,
            24
        ];
        if (allowedWordsLengths.indexOf(words.length) === -1) throw new Error(`Invalid word count in mnemonic (allowed: ${allowedWordsLengths} got: ${words.length})`);
        for (const word of words){
            if ($b16ec198333abbe4$var$EnglishMnemonic.wordlist.indexOf(word) === -1) throw new Error("Mnemonic contains invalid word");
        }
        // Throws with informative error message if mnemonic is not valid
        $b16ec198333abbe4$var$mnemonicToEntropy(mnemonic);
        this.data = mnemonic;
    }
}
module.exports.EnglishMnemonic = $b16ec198333abbe4$var$EnglishMnemonic;
$b16ec198333abbe4$var$EnglishMnemonic.wordlist = $b16ec198333abbe4$var$wordlist;
// list of space separated lower case words (1 or more)
$b16ec198333abbe4$var$EnglishMnemonic.mnemonicMatcher = /^[a-z]+( [a-z]+)*$/;
class $b16ec198333abbe4$var$Bip39 {
    /**
     * Encodes raw entropy of length 16, 20, 24, 28 or 32 bytes as an English mnemonic between 12 and 24 words.
     *
     * | Entropy            | Words |
     * |--------------------|-------|
     * | 128 bit (16 bytes) |    12 |
     * | 160 bit (20 bytes) |    15 |
     * | 192 bit (24 bytes) |    18 |
     * | 224 bit (28 bytes) |    21 |
     * | 256 bit (32 bytes) |    24 |
     *
     *
     * @see https://github.com/bitcoin/bips/blob/master/bip-0039.mediawiki#generating-the-mnemonic
     * @param entropy The entropy to be encoded. This must be cryptographically secure.
     */ static encode(entropy) {
        return new $b16ec198333abbe4$var$EnglishMnemonic($b16ec198333abbe4$var$entropyToMnemonic(entropy));
    }
    static decode(mnemonic) {
        return $b16ec198333abbe4$var$mnemonicToEntropy(mnemonic.toString());
    }
    static async mnemonicToSeed(mnemonic, password) {
        const mnemonicBytes = (0, $5zb9p.toUtf8)($b16ec198333abbe4$var$normalize(mnemonic.toString()));
        const salt = "mnemonic" + (password ? $b16ec198333abbe4$var$normalize(password) : "");
        const saltBytes = (0, $5zb9p.toUtf8)(salt);
        return (0, $lr402.pbkdf2Sha512)(mnemonicBytes, saltBytes, 2048, 64);
    }
}
module.exports.Bip39 = $b16ec198333abbe4$var$Bip39;

});
parcelRegister("5zb9p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toUtf8 = module.exports.fromUtf8 = module.exports.toRfc3339 = module.exports.fromRfc3339 = module.exports.toHex = module.exports.fromHex = module.exports.toBech32 = module.exports.normalizeBech32 = module.exports.fromBech32 = module.exports.Bech32 = module.exports.toBase64 = module.exports.fromBase64 = module.exports.toAscii = module.exports.fromAscii = void 0;

var $lDKp6 = parcelRequire("lDKp6");
Object.defineProperty(module.exports, "fromAscii", {
    enumerable: true,
    get: function() {
        return $lDKp6.fromAscii;
    }
});
Object.defineProperty(module.exports, "toAscii", {
    enumerable: true,
    get: function() {
        return $lDKp6.toAscii;
    }
});

var $3uATo = parcelRequire("3uATo");
Object.defineProperty(module.exports, "fromBase64", {
    enumerable: true,
    get: function() {
        return $3uATo.fromBase64;
    }
});
Object.defineProperty(module.exports, "toBase64", {
    enumerable: true,
    get: function() {
        return $3uATo.toBase64;
    }
});

var $7l82i = parcelRequire("7l82i");
Object.defineProperty(module.exports, "Bech32", {
    enumerable: true,
    get: function() {
        return $7l82i.Bech32;
    }
});
Object.defineProperty(module.exports, "fromBech32", {
    enumerable: true,
    get: function() {
        return $7l82i.fromBech32;
    }
});
Object.defineProperty(module.exports, "normalizeBech32", {
    enumerable: true,
    get: function() {
        return $7l82i.normalizeBech32;
    }
});
Object.defineProperty(module.exports, "toBech32", {
    enumerable: true,
    get: function() {
        return $7l82i.toBech32;
    }
});

var $1lxFd = parcelRequire("1lxFd");
Object.defineProperty(module.exports, "fromHex", {
    enumerable: true,
    get: function() {
        return $1lxFd.fromHex;
    }
});
Object.defineProperty(module.exports, "toHex", {
    enumerable: true,
    get: function() {
        return $1lxFd.toHex;
    }
});

var $g6axK = parcelRequire("g6axK");
Object.defineProperty(module.exports, "fromRfc3339", {
    enumerable: true,
    get: function() {
        return $g6axK.fromRfc3339;
    }
});
Object.defineProperty(module.exports, "toRfc3339", {
    enumerable: true,
    get: function() {
        return $g6axK.toRfc3339;
    }
});

var $ejp8O = parcelRequire("ejp8O");
Object.defineProperty(module.exports, "fromUtf8", {
    enumerable: true,
    get: function() {
        return $ejp8O.fromUtf8;
    }
});
Object.defineProperty(module.exports, "toUtf8", {
    enumerable: true,
    get: function() {
        return $ejp8O.toUtf8;
    }
});

});
parcelRegister("lDKp6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromAscii = module.exports.toAscii = void 0;
function $fc113c5578d439cc$var$toAscii(input) {
    const toNums = (str)=>str.split("").map((x)=>{
            const charCode = x.charCodeAt(0);
            // 0x00–0x1F control characters
            // 0x20–0x7E printable characters
            // 0x7F delete character
            // 0x80–0xFF out of 7 bit ascii range
            if (charCode < 0x20 || charCode > 0x7e) throw new Error("Cannot encode character that is out of printable ASCII range: " + charCode);
            return charCode;
        });
    return Uint8Array.from(toNums(input));
}
module.exports.toAscii = $fc113c5578d439cc$var$toAscii;
function $fc113c5578d439cc$var$fromAscii(data) {
    const fromNums = (listOfNumbers)=>listOfNumbers.map((x)=>{
            // 0x00–0x1F control characters
            // 0x20–0x7E printable characters
            // 0x7F delete character
            // 0x80–0xFF out of 7 bit ascii range
            if (x < 0x20 || x > 0x7e) throw new Error("Cannot decode character that is out of printable ASCII range: " + x);
            return String.fromCharCode(x);
        });
    return fromNums(Array.from(data)).join("");
}
module.exports.fromAscii = $fc113c5578d439cc$var$fromAscii;

});

parcelRegister("3uATo", function(module, exports) {
"use strict";
var $28b0ca81e5d80c41$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $28b0ca81e5d80c41$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $28b0ca81e5d80c41$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $28b0ca81e5d80c41$var$__createBinding(result, mod, k);
    }
    $28b0ca81e5d80c41$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromBase64 = module.exports.toBase64 = void 0;

const $28b0ca81e5d80c41$var$base64js = $28b0ca81e5d80c41$var$__importStar((parcelRequire("7LFKz")));
function $28b0ca81e5d80c41$var$toBase64(data) {
    return $28b0ca81e5d80c41$var$base64js.fromByteArray(data);
}
module.exports.toBase64 = $28b0ca81e5d80c41$var$toBase64;
function $28b0ca81e5d80c41$var$fromBase64(base64String) {
    if (!base64String.match(/^[a-zA-Z0-9+/]*={0,2}$/)) throw new Error("Invalid base64 string format");
    return $28b0ca81e5d80c41$var$base64js.toByteArray(base64String);
}
module.exports.fromBase64 = $28b0ca81e5d80c41$var$fromBase64;

});

parcelRegister("7l82i", function(module, exports) {
"use strict";
var $5580ba589b5ffc8d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5580ba589b5ffc8d$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $5580ba589b5ffc8d$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5580ba589b5ffc8d$var$__createBinding(result, mod, k);
    }
    $5580ba589b5ffc8d$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Bech32 = module.exports.normalizeBech32 = module.exports.fromBech32 = module.exports.toBech32 = void 0;

const $5580ba589b5ffc8d$var$bech32 = $5580ba589b5ffc8d$var$__importStar((parcelRequire("guCs7")));
function $5580ba589b5ffc8d$var$toBech32(prefix, data, limit) {
    const address = $5580ba589b5ffc8d$var$bech32.encode(prefix, $5580ba589b5ffc8d$var$bech32.toWords(data), limit);
    return address;
}
module.exports.toBech32 = $5580ba589b5ffc8d$var$toBech32;
function $5580ba589b5ffc8d$var$fromBech32(address, limit = Infinity) {
    const decodedAddress = $5580ba589b5ffc8d$var$bech32.decode(address, limit);
    return {
        prefix: decodedAddress.prefix,
        data: new Uint8Array($5580ba589b5ffc8d$var$bech32.fromWords(decodedAddress.words))
    };
}
module.exports.fromBech32 = $5580ba589b5ffc8d$var$fromBech32;
/**
 * Takes a bech32 address and returns a normalized (i.e. lower case) representation of it.
 *
 * The input is validated along the way, which makes this significantly safer than
 * using `address.toLowerCase()`.
 */ function $5580ba589b5ffc8d$var$normalizeBech32(address) {
    const { prefix: prefix, data: data } = $5580ba589b5ffc8d$var$fromBech32(address);
    return $5580ba589b5ffc8d$var$toBech32(prefix, data);
}
module.exports.normalizeBech32 = $5580ba589b5ffc8d$var$normalizeBech32;
/**
 * @deprecated This class is deprecated and will be removed soon. Please use fromBech32() and toBech32() instead. For more details please refer to https://github.com/cosmos/cosmjs/issues/1053.
 */ class $5580ba589b5ffc8d$var$Bech32 {
    /**
     * @deprecated This class is deprecated and will be removed soon. Please use fromBech32() and toBech32() instead. For more details please refer to https://github.com/cosmos/cosmjs/issues/1053.
     */ static encode(prefix, data, limit) {
        return $5580ba589b5ffc8d$var$toBech32(prefix, data, limit);
    }
    /**
     * @deprecated This class is deprecated and will be removed soon. Please use fromBech32() and toBech32() instead. For more details please refer to https://github.com/cosmos/cosmjs/issues/1053.
     */ static decode(address, limit = Infinity) {
        return $5580ba589b5ffc8d$var$fromBech32(address, limit);
    }
}
module.exports.Bech32 = $5580ba589b5ffc8d$var$Bech32;

});

parcelRegister("1lxFd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromHex = module.exports.toHex = void 0;
function $0fb1dd82697b310e$var$toHex(data) {
    let out = "";
    for (const byte of data)out += ("0" + byte.toString(16)).slice(-2);
    return out;
}
module.exports.toHex = $0fb1dd82697b310e$var$toHex;
function $0fb1dd82697b310e$var$fromHex(hexstring) {
    if (hexstring.length % 2 !== 0) throw new Error("hex string length must be a multiple of 2");
    const out = new Uint8Array(hexstring.length / 2);
    for(let i = 0; i < out.length; i++){
        const j = 2 * i;
        const hexByteAsString = hexstring.slice(j, j + 2);
        if (!hexByteAsString.match(/[0-9a-f]{2}/i)) throw new Error("hex string contains invalid characters");
        out[i] = parseInt(hexByteAsString, 16);
    }
    return out;
}
module.exports.fromHex = $0fb1dd82697b310e$var$fromHex;

});

parcelRegister("g6axK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toRfc3339 = module.exports.fromRfc3339 = void 0;
const $bb85628b384f7359$var$rfc3339Matcher = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(\.\d{1,9})?((?:[+-]\d{2}:\d{2})|Z)$/;
function $bb85628b384f7359$var$padded(integer, length = 2) {
    const filled = "00000" + integer.toString();
    return filled.substring(filled.length - length);
}
function $bb85628b384f7359$var$fromRfc3339(str) {
    const matches = $bb85628b384f7359$var$rfc3339Matcher.exec(str);
    if (!matches) throw new Error("Date string is not in RFC3339 format");
    const year = +matches[1];
    const month = +matches[2];
    const day = +matches[3];
    const hour = +matches[4];
    const minute = +matches[5];
    const second = +matches[6];
    // fractional seconds match either undefined or a string like ".1", ".123456789"
    const milliSeconds = matches[7] ? Math.floor(+matches[7] * 1000) : 0;
    let tzOffsetSign;
    let tzOffsetHours;
    let tzOffsetMinutes;
    // if timezone is undefined, it must be Z or nothing (otherwise the group would have captured).
    if (matches[8] === "Z") {
        tzOffsetSign = 1;
        tzOffsetHours = 0;
        tzOffsetMinutes = 0;
    } else {
        tzOffsetSign = matches[8].substring(0, 1) === "-" ? -1 : 1;
        tzOffsetHours = +matches[8].substring(1, 3);
        tzOffsetMinutes = +matches[8].substring(4, 6);
    }
    const tzOffset = tzOffsetSign * (tzOffsetHours * 60 + tzOffsetMinutes) * 60; // seconds
    const timestamp = Date.UTC(year, month - 1, day, hour, minute, second, milliSeconds) - tzOffset * 1000;
    return new Date(timestamp);
}
module.exports.fromRfc3339 = $bb85628b384f7359$var$fromRfc3339;
function $bb85628b384f7359$var$toRfc3339(date) {
    const year = date.getUTCFullYear();
    const month = $bb85628b384f7359$var$padded(date.getUTCMonth() + 1);
    const day = $bb85628b384f7359$var$padded(date.getUTCDate());
    const hour = $bb85628b384f7359$var$padded(date.getUTCHours());
    const minute = $bb85628b384f7359$var$padded(date.getUTCMinutes());
    const second = $bb85628b384f7359$var$padded(date.getUTCSeconds());
    const ms = $bb85628b384f7359$var$padded(date.getUTCMilliseconds(), 3);
    return `${year}-${month}-${day}T${hour}:${minute}:${second}.${ms}Z`;
}
module.exports.toRfc3339 = $bb85628b384f7359$var$toRfc3339;

});

parcelRegister("ejp8O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromUtf8 = module.exports.toUtf8 = void 0;
function $a6b6578d5d03577e$var$toUtf8(str) {
    return new TextEncoder().encode(str);
}
module.exports.toUtf8 = $a6b6578d5d03577e$var$toUtf8;
function $a6b6578d5d03577e$var$fromUtf8(data) {
    return new TextDecoder("utf-8", {
        fatal: true
    }).decode(data);
}
module.exports.fromUtf8 = $a6b6578d5d03577e$var$fromUtf8;

});


parcelRegister("lr402", function(module, exports) {
"use strict";
var $f9af38d67b4358c8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f9af38d67b4358c8$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $f9af38d67b4358c8$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $f9af38d67b4358c8$var$__createBinding(result, mod, k);
    }
    $f9af38d67b4358c8$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pbkdf2Sha512 = module.exports.pbkdf2Sha512Noble = module.exports.pbkdf2Sha512Crypto = module.exports.pbkdf2Sha512Subtle = module.exports.getSubtle = module.exports.getCryptoModule = void 0;

var $F6P8J = parcelRequire("F6P8J");

var $5pPyY = parcelRequire("5pPyY");

var $8MCsS = parcelRequire("8MCsS");

/**
 * Returns the Node.js crypto module when available and `undefined`
 * otherwise.
 *
 * Detects an unimplemented fallback module from Webpack 5 and returns
 * `undefined` in that case.
 */ async function $f9af38d67b4358c8$var$getCryptoModule() {
    try {
        const crypto = await Promise.resolve().then(function() {
            return Promise.resolve((parcelRequire("7HCQr")));
        }).then((res)=>$f9af38d67b4358c8$var$__importStar(res));
        // We get `Object{default: Object{}}` as a fallback when using
        // `crypto: false` in Webpack 5, which we interprete as unavailable.
        if (typeof crypto === "object" && Object.keys(crypto).length <= 1) return undefined;
        return crypto;
    } catch (_a) {
        return undefined;
    }
}
module.exports.getCryptoModule = $f9af38d67b4358c8$var$getCryptoModule;
async function $f9af38d67b4358c8$var$getSubtle() {
    const g = globalThis;
    let subtle = g.crypto && g.crypto.subtle;
    if (!subtle) {
        const crypto = await $f9af38d67b4358c8$var$getCryptoModule();
        if (crypto && crypto.webcrypto && crypto.webcrypto.subtle) subtle = crypto.webcrypto.subtle;
    }
    return subtle;
}
module.exports.getSubtle = $f9af38d67b4358c8$var$getSubtle;
async function $f9af38d67b4358c8$var$pbkdf2Sha512Subtle(// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
subtle, secret, salt, iterations, keylen) {
    (0, $F6P8J.assert)(subtle, "Argument subtle is falsy");
    (0, $F6P8J.assert)(typeof subtle === "object", "Argument subtle is not of type object");
    (0, $F6P8J.assert)(typeof subtle.importKey === "function", "subtle.importKey is not a function");
    (0, $F6P8J.assert)(typeof subtle.deriveBits === "function", "subtle.deriveBits is not a function");
    return subtle.importKey("raw", secret, {
        name: "PBKDF2"
    }, false, [
        "deriveBits"
    ]).then((key)=>subtle.deriveBits({
            name: "PBKDF2",
            salt: salt,
            iterations: iterations,
            hash: {
                name: "SHA-512"
            }
        }, key, keylen * 8).then((buffer)=>new Uint8Array(buffer)));
}
module.exports.pbkdf2Sha512Subtle = $f9af38d67b4358c8$var$pbkdf2Sha512Subtle;
async function $f9af38d67b4358c8$var$pbkdf2Sha512Crypto(// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
crypto, secret, salt, iterations, keylen) {
    (0, $F6P8J.assert)(crypto, "Argument crypto is falsy");
    (0, $F6P8J.assert)(typeof crypto === "object", "Argument crypto is not of type object");
    (0, $F6P8J.assert)(typeof crypto.pbkdf2 === "function", "crypto.pbkdf2 is not a function");
    return new Promise((resolve, reject)=>{
        crypto.pbkdf2(secret, salt, iterations, keylen, "sha512", (error, result)=>{
            if (error) reject(error);
            else resolve(Uint8Array.from(result));
        });
    });
}
module.exports.pbkdf2Sha512Crypto = $f9af38d67b4358c8$var$pbkdf2Sha512Crypto;
async function $f9af38d67b4358c8$var$pbkdf2Sha512Noble(secret, salt, iterations, keylen) {
    return (0, $5pPyY.pbkdf2Async)($8MCsS.sha512, secret, salt, {
        c: iterations,
        dkLen: keylen
    });
}
module.exports.pbkdf2Sha512Noble = $f9af38d67b4358c8$var$pbkdf2Sha512Noble;
/**
 * A pbkdf2 implementation for BIP39. This is not exported at package level and thus a private API.
 */ async function $f9af38d67b4358c8$var$pbkdf2Sha512(secret, salt, iterations, keylen) {
    const subtle = await $f9af38d67b4358c8$var$getSubtle();
    if (subtle) return $f9af38d67b4358c8$var$pbkdf2Sha512Subtle(subtle, secret, salt, iterations, keylen);
    else {
        const crypto = await $f9af38d67b4358c8$var$getCryptoModule();
        if (crypto) return $f9af38d67b4358c8$var$pbkdf2Sha512Crypto(crypto, secret, salt, iterations, keylen);
        else return $f9af38d67b4358c8$var$pbkdf2Sha512Noble(secret, salt, iterations, keylen);
    }
}
module.exports.pbkdf2Sha512 = $f9af38d67b4358c8$var$pbkdf2Sha512;

});
parcelRegister("5pPyY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pbkdf2Async = module.exports.pbkdf2 = void 0;

var $4hg6I = parcelRequire("4hg6I");

var $a6NnD = parcelRequire("a6NnD");

var $bdetq = parcelRequire("bdetq");
// Common prologue and epilogue for sync/async functions
function $3f1748e746dff9d4$var$pbkdf2Init(hash, _password, _salt, _opts) {
    (0, $4hg6I.hash)(hash);
    const opts = (0, $bdetq.checkOpts)({
        dkLen: 32,
        asyncTick: 10
    }, _opts);
    const { c: c, dkLen: dkLen, asyncTick: asyncTick } = opts;
    (0, $4hg6I.number)(c);
    (0, $4hg6I.number)(dkLen);
    (0, $4hg6I.number)(asyncTick);
    if (c < 1) throw new Error("PBKDF2: iterations (c) should be >= 1");
    const password = (0, $bdetq.toBytes)(_password);
    const salt = (0, $bdetq.toBytes)(_salt);
    // DK = PBKDF2(PRF, Password, Salt, c, dkLen);
    const DK = new Uint8Array(dkLen);
    // U1 = PRF(Password, Salt + INT_32_BE(i))
    const PRF = $a6NnD.hmac.create(hash, password);
    const PRFSalt = PRF._cloneInto().update(salt);
    return {
        c: c,
        dkLen: dkLen,
        asyncTick: asyncTick,
        DK: DK,
        PRF: PRF,
        PRFSalt: PRFSalt
    };
}
function $3f1748e746dff9d4$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u) {
    PRF.destroy();
    PRFSalt.destroy();
    if (prfW) prfW.destroy();
    u.fill(0);
    return DK;
}
/**
 * PBKDF2-HMAC: RFC 2898 key derivation function
 * @param hash - hash function that would be used e.g. sha256
 * @param password - password from which a derived key is generated
 * @param salt - cryptographic salt
 * @param opts - {c, dkLen} where c is work factor and dkLen is output message size
 */ function $3f1748e746dff9d4$var$pbkdf2(hash, password, salt, opts) {
    const { c: c, dkLen: dkLen, DK: DK, PRF: PRF, PRFSalt: PRFSalt } = $3f1748e746dff9d4$var$pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, $bdetq.createView)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        for(let ui = 1; ui < c; ui++){
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(let i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        }
    }
    return $3f1748e746dff9d4$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}
module.exports.pbkdf2 = $3f1748e746dff9d4$var$pbkdf2;
async function $3f1748e746dff9d4$var$pbkdf2Async(hash, password, salt, opts) {
    const { c: c, dkLen: dkLen, asyncTick: asyncTick, DK: DK, PRF: PRF, PRFSalt: PRFSalt } = $3f1748e746dff9d4$var$pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, $bdetq.createView)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        await (0, $bdetq.asyncLoop)(c - 1, asyncTick, ()=>{
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(let i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        });
    }
    return $3f1748e746dff9d4$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}
module.exports.pbkdf2Async = $3f1748e746dff9d4$var$pbkdf2Async;

});
parcelRegister("4hg6I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.output = module.exports.exists = module.exports.hash = module.exports.bytes = module.exports.bool = module.exports.number = void 0;
function $31d53e86a08baf8f$var$number(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`Wrong positive integer: ${n}`);
}
module.exports.number = $31d53e86a08baf8f$var$number;
function $31d53e86a08baf8f$var$bool(b) {
    if (typeof b !== "boolean") throw new Error(`Expected boolean, not ${b}`);
}
module.exports.bool = $31d53e86a08baf8f$var$bool;
// copied from utils
function $31d53e86a08baf8f$var$isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
function $31d53e86a08baf8f$var$bytes(b, ...lengths) {
    if (!$31d53e86a08baf8f$var$isBytes(b)) throw new Error("Expected Uint8Array");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Expected Uint8Array of length ${lengths}, not of length=${b.length}`);
}
module.exports.bytes = $31d53e86a08baf8f$var$bytes;
function $31d53e86a08baf8f$var$hash(hash) {
    if (typeof hash !== "function" || typeof hash.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $31d53e86a08baf8f$var$number(hash.outputLen);
    $31d53e86a08baf8f$var$number(hash.blockLen);
}
module.exports.hash = $31d53e86a08baf8f$var$hash;
function $31d53e86a08baf8f$var$exists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
module.exports.exists = $31d53e86a08baf8f$var$exists;
function $31d53e86a08baf8f$var$output(out, instance) {
    $31d53e86a08baf8f$var$bytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
module.exports.output = $31d53e86a08baf8f$var$output;
const $31d53e86a08baf8f$var$assert = {
    number: $31d53e86a08baf8f$var$number,
    bool: $31d53e86a08baf8f$var$bool,
    bytes: $31d53e86a08baf8f$var$bytes,
    hash: $31d53e86a08baf8f$var$hash,
    exists: $31d53e86a08baf8f$var$exists,
    output: $31d53e86a08baf8f$var$output
};
module.exports.default = $31d53e86a08baf8f$var$assert;

});

parcelRegister("a6NnD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hmac = module.exports.HMAC = void 0;

var $4hg6I = parcelRequire("4hg6I");

var $bdetq = parcelRequire("bdetq");
// HMAC (RFC 2104)
class $75c0c4c6f45ed63f$var$HMAC extends $bdetq.Hash {
    update(buf) {
        (0, $4hg6I.exists)(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        (0, $4hg6I.exists)(this);
        (0, $4hg6I.bytes)(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: oHash, iHash: iHash, finished: finished, destroyed: destroyed, blockLen: blockLen, outputLen: outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
    constructor(hash, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        (0, $4hg6I.hash)(hash);
        const key = (0, $bdetq.toBytes)(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== "function") throw new Error("Expected instance of class which extends utils.Hash");
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        pad.fill(0);
    }
}
module.exports.HMAC = $75c0c4c6f45ed63f$var$HMAC;
/**
 * HMAC: RFC2104 message authentication code.
 * @param hash - function that would be used e.g. sha256
 * @param key - message key
 * @param message - message data
 */ const $75c0c4c6f45ed63f$var$hmac = (hash, key, message)=>new $75c0c4c6f45ed63f$var$HMAC(hash, key).update(message).digest();
module.exports.hmac = $75c0c4c6f45ed63f$var$hmac;
module.exports.hmac.create = (hash, key)=>new $75c0c4c6f45ed63f$var$HMAC(hash, key);

});
parcelRegister("bdetq", function(module, exports) {
"use strict";
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.randomBytes = module.exports.wrapXOFConstructorWithOpts = module.exports.wrapConstructorWithOpts = module.exports.wrapConstructor = module.exports.checkOpts = module.exports.Hash = module.exports.concatBytes = module.exports.toBytes = module.exports.utf8ToBytes = module.exports.asyncLoop = module.exports.nextTick = module.exports.hexToBytes = module.exports.bytesToHex = module.exports.isLE = module.exports.rotr = module.exports.createView = module.exports.u32 = module.exports.u8 = void 0;

var $4l7Pc = parcelRequire("4l7Pc");
// Cast array to different type
const $829c22c8ec251a06$var$u8 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
module.exports.u8 = $829c22c8ec251a06$var$u8;
const $829c22c8ec251a06$var$u32 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
module.exports.u32 = $829c22c8ec251a06$var$u32;
function $829c22c8ec251a06$var$isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
// Cast array to view
const $829c22c8ec251a06$var$createView = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
module.exports.createView = $829c22c8ec251a06$var$createView;
// The rotate right (circular right shift) operation for uint32
const $829c22c8ec251a06$var$rotr = (word, shift)=>word << 32 - shift | word >>> shift;
module.exports.rotr = $829c22c8ec251a06$var$rotr;
// big-endian hardware is rare. Just in case someone still decides to run hashes:
// early-throw an error because we don't support BE yet.
// Other libraries would silently corrupt the data instead of throwing an error,
// when they don't support it.
module.exports.isLE = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
if (!module.exports.isLE) throw new Error("Non little-endian hardware is not supported");
// Array where index 0xf0 (240) is mapped to string 'f0'
const $829c22c8ec251a06$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $829c22c8ec251a06$var$bytesToHex(bytes) {
    if (!$829c22c8ec251a06$var$isBytes(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $829c22c8ec251a06$var$hexes[bytes[i]];
    return hex;
}
module.exports.bytesToHex = $829c22c8ec251a06$var$bytesToHex;
// We use optimized technique to convert hex string to byte array
const $829c22c8ec251a06$var$asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function $829c22c8ec251a06$var$asciiToBase16(char) {
    if (char >= $829c22c8ec251a06$var$asciis._0 && char <= $829c22c8ec251a06$var$asciis._9) return char - $829c22c8ec251a06$var$asciis._0;
    if (char >= $829c22c8ec251a06$var$asciis._A && char <= $829c22c8ec251a06$var$asciis._F) return char - ($829c22c8ec251a06$var$asciis._A - 10);
    if (char >= $829c22c8ec251a06$var$asciis._a && char <= $829c22c8ec251a06$var$asciis._f) return char - ($829c22c8ec251a06$var$asciis._a - 10);
    return;
}
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $829c22c8ec251a06$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("padded hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $829c22c8ec251a06$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $829c22c8ec251a06$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
module.exports.hexToBytes = $829c22c8ec251a06$var$hexToBytes;
// There is no setImmediate in browser and setTimeout is slow.
// call of async fn will return Promise, which will be fullfiled only on
// next scheduler queue processing step and this is exactly what we need.
const $829c22c8ec251a06$var$nextTick = async ()=>{};
module.exports.nextTick = $829c22c8ec251a06$var$nextTick;
// Returns control to thread each 'tick' ms to avoid blocking
async function $829c22c8ec251a06$var$asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, module.exports.nextTick)();
        ts += diff;
    }
}
module.exports.asyncLoop = $829c22c8ec251a06$var$asyncLoop;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $829c22c8ec251a06$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
module.exports.utf8ToBytes = $829c22c8ec251a06$var$utf8ToBytes;
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function $829c22c8ec251a06$var$toBytes(data) {
    if (typeof data === "string") data = $829c22c8ec251a06$var$utf8ToBytes(data);
    if (!$829c22c8ec251a06$var$isBytes(data)) throw new Error(`expected Uint8Array, got ${typeof data}`);
    return data;
}
module.exports.toBytes = $829c22c8ec251a06$var$toBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function $829c22c8ec251a06$var$concatBytes(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        if (!$829c22c8ec251a06$var$isBytes(a)) throw new Error("Uint8Array expected");
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
module.exports.concatBytes = $829c22c8ec251a06$var$concatBytes;
// For runtime check if class implements interface
class $829c22c8ec251a06$var$Hash {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
module.exports.Hash = $829c22c8ec251a06$var$Hash;
const $829c22c8ec251a06$var$toStr = {}.toString;
function $829c22c8ec251a06$var$checkOpts(defaults, opts) {
    if (opts !== undefined && $829c22c8ec251a06$var$toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
module.exports.checkOpts = $829c22c8ec251a06$var$checkOpts;
function $829c22c8ec251a06$var$wrapConstructor(hashCons) {
    const hashC = (msg)=>hashCons().update($829c22c8ec251a06$var$toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
module.exports.wrapConstructor = $829c22c8ec251a06$var$wrapConstructor;
function $829c22c8ec251a06$var$wrapConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($829c22c8ec251a06$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapConstructorWithOpts = $829c22c8ec251a06$var$wrapConstructorWithOpts;
function $829c22c8ec251a06$var$wrapXOFConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($829c22c8ec251a06$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapXOFConstructorWithOpts = $829c22c8ec251a06$var$wrapXOFConstructorWithOpts;
/**
 * Secure PRNG. Uses `crypto.getRandomValues`, which defers to OS.
 */ function $829c22c8ec251a06$var$randomBytes(bytesLength = 32) {
    if ($4l7Pc.crypto && typeof $4l7Pc.crypto.getRandomValues === "function") return $4l7Pc.crypto.getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}
module.exports.randomBytes = $829c22c8ec251a06$var$randomBytes;

});
parcelRegister("4l7Pc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.crypto = void 0;
module.exports.crypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;

});




parcelRegister("8MCsS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha384 = module.exports.sha512_256 = module.exports.sha512_224 = module.exports.sha512 = module.exports.SHA512 = void 0;

var $jOnpb = parcelRequire("jOnpb");

var $4cMch = parcelRequire("4cMch");

var $bdetq = parcelRequire("bdetq");
// Round contants (first 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409):
// prettier-ignore
const [$6650a4bfbfa1d1d0$var$SHA512_Kh, $6650a4bfbfa1d1d0$var$SHA512_Kl] = /* @__PURE__ */ (()=>$4cMch.default.split([
        "0x428a2f98d728ae22",
        "0x7137449123ef65cd",
        "0xb5c0fbcfec4d3b2f",
        "0xe9b5dba58189dbbc",
        "0x3956c25bf348b538",
        "0x59f111f1b605d019",
        "0x923f82a4af194f9b",
        "0xab1c5ed5da6d8118",
        "0xd807aa98a3030242",
        "0x12835b0145706fbe",
        "0x243185be4ee4b28c",
        "0x550c7dc3d5ffb4e2",
        "0x72be5d74f27b896f",
        "0x80deb1fe3b1696b1",
        "0x9bdc06a725c71235",
        "0xc19bf174cf692694",
        "0xe49b69c19ef14ad2",
        "0xefbe4786384f25e3",
        "0x0fc19dc68b8cd5b5",
        "0x240ca1cc77ac9c65",
        "0x2de92c6f592b0275",
        "0x4a7484aa6ea6e483",
        "0x5cb0a9dcbd41fbd4",
        "0x76f988da831153b5",
        "0x983e5152ee66dfab",
        "0xa831c66d2db43210",
        "0xb00327c898fb213f",
        "0xbf597fc7beef0ee4",
        "0xc6e00bf33da88fc2",
        "0xd5a79147930aa725",
        "0x06ca6351e003826f",
        "0x142929670a0e6e70",
        "0x27b70a8546d22ffc",
        "0x2e1b21385c26c926",
        "0x4d2c6dfc5ac42aed",
        "0x53380d139d95b3df",
        "0x650a73548baf63de",
        "0x766a0abb3c77b2a8",
        "0x81c2c92e47edaee6",
        "0x92722c851482353b",
        "0xa2bfe8a14cf10364",
        "0xa81a664bbc423001",
        "0xc24b8b70d0f89791",
        "0xc76c51a30654be30",
        "0xd192e819d6ef5218",
        "0xd69906245565a910",
        "0xf40e35855771202a",
        "0x106aa07032bbd1b8",
        "0x19a4c116b8d2d0c8",
        "0x1e376c085141ab53",
        "0x2748774cdf8eeb99",
        "0x34b0bcb5e19b48a8",
        "0x391c0cb3c5c95a63",
        "0x4ed8aa4ae3418acb",
        "0x5b9cca4f7763e373",
        "0x682e6ff3d6b2b8a3",
        "0x748f82ee5defb2fc",
        "0x78a5636f43172f60",
        "0x84c87814a1f0ab72",
        "0x8cc702081a6439ec",
        "0x90befffa23631e28",
        "0xa4506cebde82bde9",
        "0xbef9a3f7b2c67915",
        "0xc67178f2e372532b",
        "0xca273eceea26619c",
        "0xd186b8c721c0c207",
        "0xeada7dd6cde0eb1e",
        "0xf57d4f7fee6ed178",
        "0x06f067aa72176fba",
        "0x0a637dc5a2c898a6",
        "0x113f9804bef90dae",
        "0x1b710b35131c471b",
        "0x28db77f523047d84",
        "0x32caab7b40c72493",
        "0x3c9ebe0a15c9bebc",
        "0x431d67c49c100d4c",
        "0x4cc5d4becb3e42b6",
        "0x597f299cfc657e2a",
        "0x5fcb6fab3ad6faec",
        "0x6c44198c4a475817"
    ].map((n)=>BigInt(n))))();
// Temporary buffer, not used to store anything between runs
const $6650a4bfbfa1d1d0$var$SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
const $6650a4bfbfa1d1d0$var$SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class $6650a4bfbfa1d1d0$var$SHA512 extends $jOnpb.SHA2 {
    // prettier-ignore
    get() {
        const { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4){
            $6650a4bfbfa1d1d0$var$SHA512_W_H[i] = view.getUint32(offset);
            $6650a4bfbfa1d1d0$var$SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = $6650a4bfbfa1d1d0$var$SHA512_W_H[i - 15] | 0;
            const W15l = $6650a4bfbfa1d1d0$var$SHA512_W_L[i - 15] | 0;
            const s0h = $4cMch.default.rotrSH(W15h, W15l, 1) ^ $4cMch.default.rotrSH(W15h, W15l, 8) ^ $4cMch.default.shrSH(W15h, W15l, 7);
            const s0l = $4cMch.default.rotrSL(W15h, W15l, 1) ^ $4cMch.default.rotrSL(W15h, W15l, 8) ^ $4cMch.default.shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = $6650a4bfbfa1d1d0$var$SHA512_W_H[i - 2] | 0;
            const W2l = $6650a4bfbfa1d1d0$var$SHA512_W_L[i - 2] | 0;
            const s1h = $4cMch.default.rotrSH(W2h, W2l, 19) ^ $4cMch.default.rotrBH(W2h, W2l, 61) ^ $4cMch.default.shrSH(W2h, W2l, 6);
            const s1l = $4cMch.default.rotrSL(W2h, W2l, 19) ^ $4cMch.default.rotrBL(W2h, W2l, 61) ^ $4cMch.default.shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = $4cMch.default.add4L(s0l, s1l, $6650a4bfbfa1d1d0$var$SHA512_W_L[i - 7], $6650a4bfbfa1d1d0$var$SHA512_W_L[i - 16]);
            const SUMh = $4cMch.default.add4H(SUMl, s0h, s1h, $6650a4bfbfa1d1d0$var$SHA512_W_H[i - 7], $6650a4bfbfa1d1d0$var$SHA512_W_H[i - 16]);
            $6650a4bfbfa1d1d0$var$SHA512_W_H[i] = SUMh | 0;
            $6650a4bfbfa1d1d0$var$SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        // Compression function main loop, 80 rounds
        for(let i = 0; i < 80; i++){
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = $4cMch.default.rotrSH(Eh, El, 14) ^ $4cMch.default.rotrSH(Eh, El, 18) ^ $4cMch.default.rotrBH(Eh, El, 41);
            const sigma1l = $4cMch.default.rotrSL(Eh, El, 14) ^ $4cMch.default.rotrSL(Eh, El, 18) ^ $4cMch.default.rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = $4cMch.default.add5L(Hl, sigma1l, CHIl, $6650a4bfbfa1d1d0$var$SHA512_Kl[i], $6650a4bfbfa1d1d0$var$SHA512_W_L[i]);
            const T1h = $4cMch.default.add5H(T1ll, Hh, sigma1h, CHIh, $6650a4bfbfa1d1d0$var$SHA512_Kh[i], $6650a4bfbfa1d1d0$var$SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = $4cMch.default.rotrSH(Ah, Al, 28) ^ $4cMch.default.rotrBH(Ah, Al, 34) ^ $4cMch.default.rotrBH(Ah, Al, 39);
            const sigma0l = $4cMch.default.rotrSL(Ah, Al, 28) ^ $4cMch.default.rotrBL(Ah, Al, 34) ^ $4cMch.default.rotrBL(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = $4cMch.default.add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = $4cMch.default.add3L(T1l, sigma0l, MAJl);
            Ah = $4cMch.default.add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = $4cMch.default.add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = $4cMch.default.add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = $4cMch.default.add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = $4cMch.default.add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = $4cMch.default.add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = $4cMch.default.add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = $4cMch.default.add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = $4cMch.default.add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        $6650a4bfbfa1d1d0$var$SHA512_W_H.fill(0);
        $6650a4bfbfa1d1d0$var$SHA512_W_L.fill(0);
    }
    destroy() {
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
    constructor(){
        super(128, 64, 16, false);
        // We cannot use array here since array allows indexing by variable which means optimizer/compiler cannot use registers.
        // Also looks cleaner and easier to verify with spec.
        // Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 1779033703;
        this.Al = -205731576;
        this.Bh = -1150833019;
        this.Bl = -2067093701;
        this.Ch = 1013904242;
        this.Cl = -23791573;
        this.Dh = -1521486534;
        this.Dl = 1595750129;
        this.Eh = 1359893119;
        this.El = -1377402159;
        this.Fh = -1694144372;
        this.Fl = 725511199;
        this.Gh = 528734635;
        this.Gl = -79577749;
        this.Hh = 1541459225;
        this.Hl = 327033209;
    }
}
module.exports.SHA512 = $6650a4bfbfa1d1d0$var$SHA512;
class $6650a4bfbfa1d1d0$var$SHA512_224 extends $6650a4bfbfa1d1d0$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -1942145080;
        this.Al = 424955298;
        this.Bh = 1944164710;
        this.Bl = -1982016298;
        this.Ch = 502970286;
        this.Cl = 855612546;
        this.Dh = 1738396948;
        this.Dl = 1479516111;
        this.Eh = 258812777;
        this.El = 2077511080;
        this.Fh = 2011393907;
        this.Fl = 79989058;
        this.Gh = 1067287976;
        this.Gl = 1780299464;
        this.Hh = 286451373;
        this.Hl = -1848208735;
        this.outputLen = 28;
    }
}
class $6650a4bfbfa1d1d0$var$SHA512_256 extends $6650a4bfbfa1d1d0$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 573645204;
        this.Al = -64227540;
        this.Bh = -1621794909;
        this.Bl = -934517566;
        this.Ch = 596883563;
        this.Cl = 1867755857;
        this.Dh = -1774684391;
        this.Dl = 1497426621;
        this.Eh = -1775747358;
        this.El = -1467023389;
        this.Fh = -1101128155;
        this.Fl = 1401305490;
        this.Gh = 721525244;
        this.Gl = 746961066;
        this.Hh = 246885852;
        this.Hl = -2117784414;
        this.outputLen = 32;
    }
}
class $6650a4bfbfa1d1d0$var$SHA384 extends $6650a4bfbfa1d1d0$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -876896931;
        this.Al = -1056596264;
        this.Bh = 1654270250;
        this.Bl = 914150663;
        this.Ch = -1856437926;
        this.Cl = 812702999;
        this.Dh = 355462360;
        this.Dl = -150054599;
        this.Eh = 1731405415;
        this.El = -4191439;
        this.Fh = -1900787065;
        this.Fl = 1750603025;
        this.Gh = -619958771;
        this.Gl = 1694076839;
        this.Hh = 1203062813;
        this.Hl = -1090891868;
        this.outputLen = 48;
    }
}
module.exports.sha512 = (0, $bdetq.wrapConstructor)(()=>new $6650a4bfbfa1d1d0$var$SHA512());
module.exports.sha512_224 = (0, $bdetq.wrapConstructor)(()=>new $6650a4bfbfa1d1d0$var$SHA512_224());
module.exports.sha512_256 = (0, $bdetq.wrapConstructor)(()=>new $6650a4bfbfa1d1d0$var$SHA512_256());
module.exports.sha384 = (0, $bdetq.wrapConstructor)(()=>new $6650a4bfbfa1d1d0$var$SHA384());

});
parcelRegister("jOnpb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SHA2 = void 0;

var $4hg6I = parcelRequire("4hg6I");

var $bdetq = parcelRequire("bdetq");
// Polyfill for Safari 14
function $e6c4d7978e8321d9$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
// Base SHA2 class (RFC 6234)
class $e6c4d7978e8321d9$var$SHA2 extends $bdetq.Hash {
    update(data) {
        (0, $4hg6I.exists)(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $bdetq.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $bdetq.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $4hg6I.exists)(this);
        (0, $4hg6I.output)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $e6c4d7978e8321d9$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $bdetq.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $bdetq.createView)(this.buffer);
    }
}
module.exports.SHA2 = $e6c4d7978e8321d9$var$SHA2;

});

parcelRegister("4cMch", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.add5L = module.exports.add5H = module.exports.add4H = module.exports.add4L = module.exports.add3H = module.exports.add3L = module.exports.add = module.exports.rotlBL = module.exports.rotlBH = module.exports.rotlSL = module.exports.rotlSH = module.exports.rotr32L = module.exports.rotr32H = module.exports.rotrBL = module.exports.rotrBH = module.exports.rotrSL = module.exports.rotrSH = module.exports.shrSL = module.exports.shrSH = module.exports.toBig = module.exports.split = module.exports.fromBig = void 0;
const $30fdab52992ac0ce$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $30fdab52992ac0ce$var$_32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $30fdab52992ac0ce$var$fromBig(n, le = false) {
    if (le) return {
        h: Number(n & $30fdab52992ac0ce$var$U32_MASK64),
        l: Number(n >> $30fdab52992ac0ce$var$_32n & $30fdab52992ac0ce$var$U32_MASK64)
    };
    return {
        h: Number(n >> $30fdab52992ac0ce$var$_32n & $30fdab52992ac0ce$var$U32_MASK64) | 0,
        l: Number(n & $30fdab52992ac0ce$var$U32_MASK64) | 0
    };
}
module.exports.fromBig = $30fdab52992ac0ce$var$fromBig;
function $30fdab52992ac0ce$var$split(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $30fdab52992ac0ce$var$fromBig(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
module.exports.split = $30fdab52992ac0ce$var$split;
const $30fdab52992ac0ce$var$toBig = (h, l)=>BigInt(h >>> 0) << $30fdab52992ac0ce$var$_32n | BigInt(l >>> 0);
module.exports.toBig = $30fdab52992ac0ce$var$toBig;
// for Shift in [0, 32)
const $30fdab52992ac0ce$var$shrSH = (h, _l, s)=>h >>> s;
module.exports.shrSH = $30fdab52992ac0ce$var$shrSH;
const $30fdab52992ac0ce$var$shrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.shrSL = $30fdab52992ac0ce$var$shrSL;
// Right rotate for Shift in [1, 32)
const $30fdab52992ac0ce$var$rotrSH = (h, l, s)=>h >>> s | l << 32 - s;
module.exports.rotrSH = $30fdab52992ac0ce$var$rotrSH;
const $30fdab52992ac0ce$var$rotrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.rotrSL = $30fdab52992ac0ce$var$rotrSL;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $30fdab52992ac0ce$var$rotrBH = (h, l, s)=>h << 64 - s | l >>> s - 32;
module.exports.rotrBH = $30fdab52992ac0ce$var$rotrBH;
const $30fdab52992ac0ce$var$rotrBL = (h, l, s)=>h >>> s - 32 | l << 64 - s;
module.exports.rotrBL = $30fdab52992ac0ce$var$rotrBL;
// Right rotate for shift===32 (just swaps l&h)
const $30fdab52992ac0ce$var$rotr32H = (_h, l)=>l;
module.exports.rotr32H = $30fdab52992ac0ce$var$rotr32H;
const $30fdab52992ac0ce$var$rotr32L = (h, _l)=>h;
module.exports.rotr32L = $30fdab52992ac0ce$var$rotr32L;
// Left rotate for Shift in [1, 32)
const $30fdab52992ac0ce$var$rotlSH = (h, l, s)=>h << s | l >>> 32 - s;
module.exports.rotlSH = $30fdab52992ac0ce$var$rotlSH;
const $30fdab52992ac0ce$var$rotlSL = (h, l, s)=>l << s | h >>> 32 - s;
module.exports.rotlSL = $30fdab52992ac0ce$var$rotlSL;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $30fdab52992ac0ce$var$rotlBH = (h, l, s)=>l << s - 32 | h >>> 64 - s;
module.exports.rotlBH = $30fdab52992ac0ce$var$rotlBH;
const $30fdab52992ac0ce$var$rotlBL = (h, l, s)=>h << s - 32 | l >>> 64 - s;
module.exports.rotlBL = $30fdab52992ac0ce$var$rotlBL;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $30fdab52992ac0ce$var$add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
module.exports.add = $30fdab52992ac0ce$var$add;
// Addition with more than 2 elements
const $30fdab52992ac0ce$var$add3L = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
module.exports.add3L = $30fdab52992ac0ce$var$add3L;
const $30fdab52992ac0ce$var$add3H = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
module.exports.add3H = $30fdab52992ac0ce$var$add3H;
const $30fdab52992ac0ce$var$add4L = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
module.exports.add4L = $30fdab52992ac0ce$var$add4L;
const $30fdab52992ac0ce$var$add4H = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
module.exports.add4H = $30fdab52992ac0ce$var$add4H;
const $30fdab52992ac0ce$var$add5L = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
module.exports.add5L = $30fdab52992ac0ce$var$add5L;
const $30fdab52992ac0ce$var$add5H = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
module.exports.add5H = $30fdab52992ac0ce$var$add5H;
// prettier-ignore
const $30fdab52992ac0ce$var$u64 = {
    fromBig: $30fdab52992ac0ce$var$fromBig,
    split: $30fdab52992ac0ce$var$split,
    toBig: $30fdab52992ac0ce$var$toBig,
    shrSH: $30fdab52992ac0ce$var$shrSH,
    shrSL: $30fdab52992ac0ce$var$shrSL,
    rotrSH: $30fdab52992ac0ce$var$rotrSH,
    rotrSL: $30fdab52992ac0ce$var$rotrSL,
    rotrBH: $30fdab52992ac0ce$var$rotrBH,
    rotrBL: $30fdab52992ac0ce$var$rotrBL,
    rotr32H: $30fdab52992ac0ce$var$rotr32H,
    rotr32L: $30fdab52992ac0ce$var$rotr32L,
    rotlSH: $30fdab52992ac0ce$var$rotlSH,
    rotlSL: $30fdab52992ac0ce$var$rotlSL,
    rotlBH: $30fdab52992ac0ce$var$rotlBH,
    rotlBL: $30fdab52992ac0ce$var$rotlBL,
    add: $30fdab52992ac0ce$var$add,
    add3L: $30fdab52992ac0ce$var$add3L,
    add3H: $30fdab52992ac0ce$var$add3H,
    add4L: $30fdab52992ac0ce$var$add4L,
    add4H: $30fdab52992ac0ce$var$add4H,
    add5H: $30fdab52992ac0ce$var$add5H,
    add5L: $30fdab52992ac0ce$var$add5L
};
module.exports.default = $30fdab52992ac0ce$var$u64;

});



parcelRegister("aMdHR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha512 = module.exports.Sha512 = module.exports.sha256 = module.exports.Sha256 = void 0;

var $HGYq1 = parcelRequire("HGYq1");

var $8MCsS = parcelRequire("8MCsS");

var $gxD9f = parcelRequire("gxD9f");
class $7d8904e0a32b3597$var$Sha256 {
    update(data) {
        this.impl.update((0, $gxD9f.toRealUint8Array)(data));
        return this;
    }
    digest() {
        return this.impl.digest();
    }
    constructor(firstData){
        this.blockSize = 64;
        this.impl = $HGYq1.sha256.create();
        if (firstData) this.update(firstData);
    }
}
module.exports.Sha256 = $7d8904e0a32b3597$var$Sha256;
/** Convenience function equivalent to `new Sha256(data).digest()` */ function $7d8904e0a32b3597$var$sha256(data) {
    return new $7d8904e0a32b3597$var$Sha256(data).digest();
}
module.exports.sha256 = $7d8904e0a32b3597$var$sha256;
class $7d8904e0a32b3597$var$Sha512 {
    update(data) {
        this.impl.update((0, $gxD9f.toRealUint8Array)(data));
        return this;
    }
    digest() {
        return this.impl.digest();
    }
    constructor(firstData){
        this.blockSize = 128;
        this.impl = $8MCsS.sha512.create();
        if (firstData) this.update(firstData);
    }
}
module.exports.Sha512 = $7d8904e0a32b3597$var$Sha512;
/** Convenience function equivalent to `new Sha512(data).digest()` */ function $7d8904e0a32b3597$var$sha512(data) {
    return new $7d8904e0a32b3597$var$Sha512(data).digest();
}
module.exports.sha512 = $7d8904e0a32b3597$var$sha512;

});
parcelRegister("HGYq1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha224 = module.exports.sha256 = void 0;

var $jOnpb = parcelRequire("jOnpb");

var $bdetq = parcelRequire("bdetq");
// SHA2-256 need to try 2^128 hashes to execute birthday attack.
// BTC network is doing 2^67 hashes/sec as per early 2023.
// Choice: a ? b : c
const $083559e8591830d8$var$Chi = (a, b, c)=>a & b ^ ~a & c;
// Majority function, true if any two inpust is true
const $083559e8591830d8$var$Maj = (a, b, c)=>a & b ^ a & c ^ b & c;
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
const $083559e8591830d8$var$SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
// prettier-ignore
const $083559e8591830d8$var$IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
const $083559e8591830d8$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $083559e8591830d8$var$SHA256 extends $jOnpb.SHA2 {
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$083559e8591830d8$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $083559e8591830d8$var$SHA256_W[i - 15];
            const W2 = $083559e8591830d8$var$SHA256_W[i - 2];
            const s0 = (0, $bdetq.rotr)(W15, 7) ^ (0, $bdetq.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $bdetq.rotr)(W2, 17) ^ (0, $bdetq.rotr)(W2, 19) ^ W2 >>> 10;
            $083559e8591830d8$var$SHA256_W[i] = s1 + $083559e8591830d8$var$SHA256_W[i - 7] + s0 + $083559e8591830d8$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $bdetq.rotr)(E, 6) ^ (0, $bdetq.rotr)(E, 11) ^ (0, $bdetq.rotr)(E, 25);
            const T1 = H + sigma1 + $083559e8591830d8$var$Chi(E, F, G) + $083559e8591830d8$var$SHA256_K[i] + $083559e8591830d8$var$SHA256_W[i] | 0;
            const sigma0 = (0, $bdetq.rotr)(A, 2) ^ (0, $bdetq.rotr)(A, 13) ^ (0, $bdetq.rotr)(A, 22);
            const T2 = sigma0 + $083559e8591830d8$var$Maj(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $083559e8591830d8$var$SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $083559e8591830d8$var$IV[0] | 0;
        this.B = $083559e8591830d8$var$IV[1] | 0;
        this.C = $083559e8591830d8$var$IV[2] | 0;
        this.D = $083559e8591830d8$var$IV[3] | 0;
        this.E = $083559e8591830d8$var$IV[4] | 0;
        this.F = $083559e8591830d8$var$IV[5] | 0;
        this.G = $083559e8591830d8$var$IV[6] | 0;
        this.H = $083559e8591830d8$var$IV[7] | 0;
    }
}
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
class $083559e8591830d8$var$SHA224 extends $083559e8591830d8$var$SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
/**
 * SHA2-256 hash function
 * @param message - data that would be hashed
 */ module.exports.sha256 = (0, $bdetq.wrapConstructor)(()=>new $083559e8591830d8$var$SHA256());
module.exports.sha224 = (0, $bdetq.wrapConstructor)(()=>new $083559e8591830d8$var$SHA224());

});

parcelRegister("gxD9f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toRealUint8Array = void 0;
// See https://github.com/paulmillr/noble-hashes/issues/25 for why this is needed
function $c0ae1865ad35da21$var$toRealUint8Array(data) {
    if (data instanceof Uint8Array) return data;
    else return Uint8Array.from(data);
}
module.exports.toRealUint8Array = $c0ae1865ad35da21$var$toRealUint8Array;

});



parcelRegister("6vFTM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hmac = void 0;
class $4bd6238e04c9764b$var$Hmac {
    update(data) {
        this.messageHasher.update(data);
        return this;
    }
    digest() {
        const innerHash = this.messageHasher.digest();
        return this.hash(new Uint8Array([
            ...this.oKeyPad,
            ...innerHash
        ]));
    }
    constructor(hashFunctionConstructor, originalKey){
        // This implementation is based on https://en.wikipedia.org/wiki/HMAC#Implementation
        // with the addition of incremental hashing support. Thus part of the algorithm
        // is in the constructor and the rest in digest().
        const blockSize = new hashFunctionConstructor().blockSize;
        this.hash = (data)=>new hashFunctionConstructor().update(data).digest();
        let key = originalKey;
        if (key.length > blockSize) key = this.hash(key);
        if (key.length < blockSize) {
            const zeroPadding = new Uint8Array(blockSize - key.length);
            key = new Uint8Array([
                ...key,
                ...zeroPadding
            ]);
        }
        // eslint-disable-next-line no-bitwise
        this.oKeyPad = key.map((keyByte)=>keyByte ^ 0x5c);
        // eslint-disable-next-line no-bitwise
        this.iKeyPad = key.map((keyByte)=>keyByte ^ 0x36);
        this.messageHasher = new hashFunctionConstructor();
        this.blockSize = blockSize;
        this.update(this.iKeyPad);
    }
}
module.exports.Hmac = $4bd6238e04c9764b$var$Hmac;

});

parcelRegister("eJL0q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.keccak256 = module.exports.Keccak256 = void 0;

var $dMfPH = parcelRequire("dMfPH");

var $gxD9f = parcelRequire("gxD9f");
class $aba9bb1043522254$var$Keccak256 {
    update(data) {
        this.impl.update((0, $gxD9f.toRealUint8Array)(data));
        return this;
    }
    digest() {
        return this.impl.digest();
    }
    constructor(firstData){
        this.blockSize = 64;
        this.impl = $dMfPH.keccak_256.create();
        if (firstData) this.update(firstData);
    }
}
module.exports.Keccak256 = $aba9bb1043522254$var$Keccak256;
/** Convenience function equivalent to `new Keccak256(data).digest()` */ function $aba9bb1043522254$var$keccak256(data) {
    return new $aba9bb1043522254$var$Keccak256(data).digest();
}
module.exports.keccak256 = $aba9bb1043522254$var$keccak256;

});
parcelRegister("dMfPH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shake256 = module.exports.shake128 = module.exports.keccak_512 = module.exports.keccak_384 = module.exports.keccak_256 = module.exports.keccak_224 = module.exports.sha3_512 = module.exports.sha3_384 = module.exports.sha3_256 = module.exports.sha3_224 = module.exports.Keccak = module.exports.keccakP = void 0;

var $4hg6I = parcelRequire("4hg6I");

var $4cMch = parcelRequire("4cMch");

var $bdetq = parcelRequire("bdetq");
// SHA3 (keccak) is based on a new design: basically, the internal state is bigger than output size.
// It's called a sponge function.
// Various per round constants calculations
const [$a07c0a27998e1113$var$SHA3_PI, $a07c0a27998e1113$var$SHA3_ROTL, $a07c0a27998e1113$var$_SHA3_IOTA] = [
    [],
    [],
    []
];
const $a07c0a27998e1113$var$_0n = /* @__PURE__ */ BigInt(0);
const $a07c0a27998e1113$var$_1n = /* @__PURE__ */ BigInt(1);
const $a07c0a27998e1113$var$_2n = /* @__PURE__ */ BigInt(2);
const $a07c0a27998e1113$var$_7n = /* @__PURE__ */ BigInt(7);
const $a07c0a27998e1113$var$_256n = /* @__PURE__ */ BigInt(256);
const $a07c0a27998e1113$var$_0x71n = /* @__PURE__ */ BigInt(0x71);
for(let round = 0, R = $a07c0a27998e1113$var$_1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    $a07c0a27998e1113$var$SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    $a07c0a27998e1113$var$SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = $a07c0a27998e1113$var$_0n;
    for(let j = 0; j < 7; j++){
        R = (R << $a07c0a27998e1113$var$_1n ^ (R >> $a07c0a27998e1113$var$_7n) * $a07c0a27998e1113$var$_0x71n) % $a07c0a27998e1113$var$_256n;
        if (R & $a07c0a27998e1113$var$_2n) t ^= $a07c0a27998e1113$var$_1n << ($a07c0a27998e1113$var$_1n << /* @__PURE__ */ BigInt(j)) - $a07c0a27998e1113$var$_1n;
    }
    $a07c0a27998e1113$var$_SHA3_IOTA.push(t);
}
const [$a07c0a27998e1113$var$SHA3_IOTA_H, $a07c0a27998e1113$var$SHA3_IOTA_L] = /* @__PURE__ */ (0, $4cMch.split)($a07c0a27998e1113$var$_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const $a07c0a27998e1113$var$rotlH = (h, l, s)=>s > 32 ? (0, $4cMch.rotlBH)(h, l, s) : (0, $4cMch.rotlSH)(h, l, s);
const $a07c0a27998e1113$var$rotlL = (h, l, s)=>s > 32 ? (0, $4cMch.rotlBL)(h, l, s) : (0, $4cMch.rotlSL)(h, l, s);
// Same as keccakf1600, but allows to skip some rounds
function $a07c0a27998e1113$var$keccakP(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = $a07c0a27998e1113$var$rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = $a07c0a27998e1113$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = $a07c0a27998e1113$var$SHA3_ROTL[t];
            const Th = $a07c0a27998e1113$var$rotlH(curH, curL, shift);
            const Tl = $a07c0a27998e1113$var$rotlL(curH, curL, shift);
            const PI = $a07c0a27998e1113$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $a07c0a27998e1113$var$SHA3_IOTA_H[round];
        s[1] ^= $a07c0a27998e1113$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
module.exports.keccakP = $a07c0a27998e1113$var$keccakP;
class $a07c0a27998e1113$var$Keccak extends $bdetq.Hash {
    keccak() {
        $a07c0a27998e1113$var$keccakP(this.state32, this.rounds);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, $4hg6I.exists)(this);
        const { blockLen: blockLen, state: state } = this;
        data = (0, $bdetq.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state: state, suffix: suffix, pos: pos, blockLen: blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, $4hg6I.exists)(this, false);
        (0, $4hg6I.bytes)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen: blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, $4hg6I.number)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, $4hg6I.output)(out, this);
        if (this.finished) throw new Error("digest() was already called");
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen: blockLen, suffix: suffix, outputLen: outputLen, rounds: rounds, enableXOF: enableXOF } = this;
        to || (to = new $a07c0a27998e1113$var$Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        (0, $4hg6I.number)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        this.state = new Uint8Array(200);
        this.state32 = (0, $bdetq.u32)(this.state);
    }
}
module.exports.Keccak = $a07c0a27998e1113$var$Keccak;
const $a07c0a27998e1113$var$gen = (suffix, blockLen, outputLen)=>(0, $bdetq.wrapConstructor)(()=>new $a07c0a27998e1113$var$Keccak(blockLen, suffix, outputLen));
module.exports.sha3_224 = $a07c0a27998e1113$var$gen(0x06, 144, 28);
/**
 * SHA3-256 hash function
 * @param message - that would be hashed
 */ module.exports.sha3_256 = $a07c0a27998e1113$var$gen(0x06, 136, 32);
module.exports.sha3_384 = $a07c0a27998e1113$var$gen(0x06, 104, 48);
module.exports.sha3_512 = $a07c0a27998e1113$var$gen(0x06, 72, 64);
module.exports.keccak_224 = $a07c0a27998e1113$var$gen(0x01, 144, 28);
/**
 * keccak-256 hash function. Different from SHA3-256.
 * @param message - that would be hashed
 */ module.exports.keccak_256 = $a07c0a27998e1113$var$gen(0x01, 136, 32);
module.exports.keccak_384 = $a07c0a27998e1113$var$gen(0x01, 104, 48);
module.exports.keccak_512 = $a07c0a27998e1113$var$gen(0x01, 72, 64);
const $a07c0a27998e1113$var$genShake = (suffix, blockLen, outputLen)=>(0, $bdetq.wrapXOFConstructorWithOpts)((opts = {})=>new $a07c0a27998e1113$var$Keccak(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
module.exports.shake128 = $a07c0a27998e1113$var$genShake(0x1f, 168, 16);
module.exports.shake256 = $a07c0a27998e1113$var$genShake(0x1f, 136, 32);

});


parcelRegister("3sl9s", function(module, exports) {
"use strict";
// Keep all classes requiring libsodium-js in one file as having multiple
// requiring of the libsodium-wrappers module currently crashes browsers
//
// libsodium.js API: https://gist.github.com/webmaster128/b2dbe6d54d36dd168c9fabf441b9b09c
var $284464e092b35a30$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Xchacha20poly1305Ietf = module.exports.xchacha20NonceLength = module.exports.Ed25519 = module.exports.Ed25519Keypair = module.exports.Argon2id = module.exports.isArgon2idOptions = void 0;

var $F6P8J = parcelRequire("F6P8J");

const $284464e092b35a30$var$libsodium_wrappers_1 = $284464e092b35a30$var$__importDefault((parcelRequire("l8YtI")));
function $284464e092b35a30$var$isArgon2idOptions(thing) {
    if (!(0, $F6P8J.isNonNullObject)(thing)) return false;
    if (typeof thing.outputLength !== "number") return false;
    if (typeof thing.opsLimit !== "number") return false;
    if (typeof thing.memLimitKib !== "number") return false;
    return true;
}
module.exports.isArgon2idOptions = $284464e092b35a30$var$isArgon2idOptions;
class $284464e092b35a30$var$Argon2id {
    static async execute(password, salt, options) {
        await $284464e092b35a30$var$libsodium_wrappers_1.default.ready;
        return $284464e092b35a30$var$libsodium_wrappers_1.default.crypto_pwhash(options.outputLength, password, salt, options.opsLimit, options.memLimitKib * 1024, $284464e092b35a30$var$libsodium_wrappers_1.default.crypto_pwhash_ALG_ARGON2ID13);
    }
}
module.exports.Argon2id = $284464e092b35a30$var$Argon2id;
class $284464e092b35a30$var$Ed25519Keypair {
    // a libsodium privkey has the format `<ed25519 privkey> + <ed25519 pubkey>`
    static fromLibsodiumPrivkey(libsodiumPrivkey) {
        if (libsodiumPrivkey.length !== 64) throw new Error(`Unexpected key length ${libsodiumPrivkey.length}. Must be 64.`);
        return new $284464e092b35a30$var$Ed25519Keypair(libsodiumPrivkey.slice(0, 32), libsodiumPrivkey.slice(32, 64));
    }
    toLibsodiumPrivkey() {
        return new Uint8Array([
            ...this.privkey,
            ...this.pubkey
        ]);
    }
    constructor(privkey, pubkey){
        this.privkey = privkey;
        this.pubkey = pubkey;
    }
}
module.exports.Ed25519Keypair = $284464e092b35a30$var$Ed25519Keypair;
class $284464e092b35a30$var$Ed25519 {
    /**
     * Generates a keypair deterministically from a given 32 bytes seed.
     *
     * This seed equals the Ed25519 private key.
     * For implementation details see crypto_sign_seed_keypair in
     * https://download.libsodium.org/doc/public-key_cryptography/public-key_signatures.html
     * and diagram on https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
     */ static async makeKeypair(seed) {
        await $284464e092b35a30$var$libsodium_wrappers_1.default.ready;
        const keypair = $284464e092b35a30$var$libsodium_wrappers_1.default.crypto_sign_seed_keypair(seed);
        return $284464e092b35a30$var$Ed25519Keypair.fromLibsodiumPrivkey(keypair.privateKey);
    }
    static async createSignature(message, keyPair) {
        await $284464e092b35a30$var$libsodium_wrappers_1.default.ready;
        return $284464e092b35a30$var$libsodium_wrappers_1.default.crypto_sign_detached(message, keyPair.toLibsodiumPrivkey());
    }
    static async verifySignature(signature, message, pubkey) {
        await $284464e092b35a30$var$libsodium_wrappers_1.default.ready;
        return $284464e092b35a30$var$libsodium_wrappers_1.default.crypto_sign_verify_detached(signature, message, pubkey);
    }
}
module.exports.Ed25519 = $284464e092b35a30$var$Ed25519;
/**
 * Nonce length in bytes for all flavours of XChaCha20.
 *
 * @see https://libsodium.gitbook.io/doc/advanced/stream_ciphers/xchacha20#notes
 */ module.exports.xchacha20NonceLength = 24;
class $284464e092b35a30$var$Xchacha20poly1305Ietf {
    static async encrypt(message, key, nonce) {
        await $284464e092b35a30$var$libsodium_wrappers_1.default.ready;
        const additionalData = null;
        return $284464e092b35a30$var$libsodium_wrappers_1.default.crypto_aead_xchacha20poly1305_ietf_encrypt(message, additionalData, null, nonce, key);
    }
    static async decrypt(ciphertext, key, nonce) {
        await $284464e092b35a30$var$libsodium_wrappers_1.default.ready;
        const additionalData = null;
        return $284464e092b35a30$var$libsodium_wrappers_1.default.crypto_aead_xchacha20poly1305_ietf_decrypt(null, ciphertext, additionalData, nonce, key);
    }
}
module.exports.Xchacha20poly1305Ietf = $284464e092b35a30$var$Xchacha20poly1305Ietf;

});

parcelRegister("aLEOL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Random = void 0;

class $7d6df4bfb7b5dd4d$var$Random {
    /**
     * Returns `count` cryptographically secure random bytes
     */ static getBytes(count) {
        try {
            const globalObject = typeof window === "object" ? window : self;
            const cryptoApi = typeof globalObject.crypto !== "undefined" ? globalObject.crypto : globalObject.msCrypto;
            const out = new Uint8Array(count);
            cryptoApi.getRandomValues(out);
            return out;
        } catch (_a) {
            try {
                // eslint-disable-next-line @typescript-eslint/no-var-requires
                const crypto = (parcelRequire("7HCQr"));
                return new Uint8Array([
                    ...crypto.randomBytes(count)
                ]);
            } catch (_b) {
                throw new Error("No secure random number generator found");
            }
        }
    }
}
module.exports.Random = $7d6df4bfb7b5dd4d$var$Random;

});

parcelRegister("byoZt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ripemd160 = module.exports.Ripemd160 = void 0;

var $dQbF2 = parcelRequire("dQbF2");

var $gxD9f = parcelRequire("gxD9f");
class $86964143ebf912fd$var$Ripemd160 {
    update(data) {
        this.impl.update((0, $gxD9f.toRealUint8Array)(data));
        return this;
    }
    digest() {
        return this.impl.digest();
    }
    constructor(firstData){
        this.blockSize = 64;
        this.impl = $dQbF2.ripemd160.create();
        if (firstData) this.update(firstData);
    }
}
module.exports.Ripemd160 = $86964143ebf912fd$var$Ripemd160;
/** Convenience function equivalent to `new Ripemd160(data).digest()` */ function $86964143ebf912fd$var$ripemd160(data) {
    return new $86964143ebf912fd$var$Ripemd160(data).digest();
}
module.exports.ripemd160 = $86964143ebf912fd$var$ripemd160;

});
parcelRegister("dQbF2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ripemd160 = module.exports.RIPEMD160 = void 0;

var $jOnpb = parcelRequire("jOnpb");

var $bdetq = parcelRequire("bdetq");
// https://homes.esat.kuleuven.be/~bosselae/ripemd160.html
// https://homes.esat.kuleuven.be/~bosselae/ripemd160/pdf/AB-9601/AB-9601.pdf
const $a1392d496f704884$var$Rho = /* @__PURE__ */ new Uint8Array([
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8
]);
const $a1392d496f704884$var$Id = /* @__PURE__ */ Uint8Array.from({
    length: 16
}, (_, i)=>i);
const $a1392d496f704884$var$Pi = /* @__PURE__ */ $a1392d496f704884$var$Id.map((i)=>(9 * i + 5) % 16);
let $a1392d496f704884$var$idxL = [
    $a1392d496f704884$var$Id
];
let $a1392d496f704884$var$idxR = [
    $a1392d496f704884$var$Pi
];
for(let i = 0; i < 4; i++)for (let j of [
    $a1392d496f704884$var$idxL,
    $a1392d496f704884$var$idxR
])j.push(j[i].map((k)=>$a1392d496f704884$var$Rho[k]));
const $a1392d496f704884$var$shifts = /* @__PURE__ */ [
    [
        11,
        14,
        15,
        12,
        5,
        8,
        7,
        9,
        11,
        13,
        14,
        15,
        6,
        7,
        9,
        8
    ],
    [
        12,
        13,
        11,
        15,
        6,
        9,
        9,
        7,
        12,
        15,
        11,
        13,
        7,
        8,
        7,
        7
    ],
    [
        13,
        15,
        14,
        11,
        7,
        7,
        6,
        8,
        13,
        14,
        13,
        12,
        5,
        5,
        6,
        9
    ],
    [
        14,
        11,
        12,
        14,
        8,
        6,
        5,
        5,
        15,
        12,
        15,
        14,
        9,
        9,
        8,
        6
    ],
    [
        15,
        12,
        13,
        13,
        9,
        5,
        8,
        6,
        14,
        11,
        12,
        11,
        8,
        6,
        5,
        5
    ]
].map((i)=>new Uint8Array(i));
const $a1392d496f704884$var$shiftsL = /* @__PURE__ */ $a1392d496f704884$var$idxL.map((idx, i)=>idx.map((j)=>$a1392d496f704884$var$shifts[i][j]));
const $a1392d496f704884$var$shiftsR = /* @__PURE__ */ $a1392d496f704884$var$idxR.map((idx, i)=>idx.map((j)=>$a1392d496f704884$var$shifts[i][j]));
const $a1392d496f704884$var$Kl = /* @__PURE__ */ new Uint32Array([
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
]);
const $a1392d496f704884$var$Kr = /* @__PURE__ */ new Uint32Array([
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
]);
// The rotate left (circular left shift) operation for uint32
const $a1392d496f704884$var$rotl = (word, shift)=>word << shift | word >>> 32 - shift;
// It's called f() in spec.
function $a1392d496f704884$var$f(group, x, y, z) {
    if (group === 0) return x ^ y ^ z;
    else if (group === 1) return x & y | ~x & z;
    else if (group === 2) return (x | ~y) ^ z;
    else if (group === 3) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
// Temporary buffer, not used to store anything between runs
const $a1392d496f704884$var$BUF = /* @__PURE__ */ new Uint32Array(16);
class $a1392d496f704884$var$RIPEMD160 extends $jOnpb.SHA2 {
    get() {
        const { h0: h0, h1: h1, h2: h2, h3: h3, h4: h4 } = this;
        return [
            h0,
            h1,
            h2,
            h3,
            h4
        ];
    }
    set(h0, h1, h2, h3, h4) {
        this.h0 = h0 | 0;
        this.h1 = h1 | 0;
        this.h2 = h2 | 0;
        this.h3 = h3 | 0;
        this.h4 = h4 | 0;
    }
    process(view, offset) {
        for(let i = 0; i < 16; i++, offset += 4)$a1392d496f704884$var$BUF[i] = view.getUint32(offset, true);
        // prettier-ignore
        let al = this.h0 | 0, ar = al, bl = this.h1 | 0, br = bl, cl = this.h2 | 0, cr = cl, dl = this.h3 | 0, dr = dl, el = this.h4 | 0, er = el;
        // Instead of iterating 0 to 80, we split it into 5 groups
        // And use the groups in constants, functions, etc. Much simpler
        for(let group = 0; group < 5; group++){
            const rGroup = 4 - group;
            const hbl = $a1392d496f704884$var$Kl[group], hbr = $a1392d496f704884$var$Kr[group]; // prettier-ignore
            const rl = $a1392d496f704884$var$idxL[group], rr = $a1392d496f704884$var$idxR[group]; // prettier-ignore
            const sl = $a1392d496f704884$var$shiftsL[group], sr = $a1392d496f704884$var$shiftsR[group]; // prettier-ignore
            for(let i = 0; i < 16; i++){
                const tl = $a1392d496f704884$var$rotl(al + $a1392d496f704884$var$f(group, bl, cl, dl) + $a1392d496f704884$var$BUF[rl[i]] + hbl, sl[i]) + el | 0;
                al = el, el = dl, dl = $a1392d496f704884$var$rotl(cl, 10) | 0, cl = bl, bl = tl; // prettier-ignore
            }
            // 2 loops are 10% faster
            for(let i = 0; i < 16; i++){
                const tr = $a1392d496f704884$var$rotl(ar + $a1392d496f704884$var$f(rGroup, br, cr, dr) + $a1392d496f704884$var$BUF[rr[i]] + hbr, sr[i]) + er | 0;
                ar = er, er = dr, dr = $a1392d496f704884$var$rotl(cr, 10) | 0, cr = br, br = tr; // prettier-ignore
            }
        }
        // Add the compressed chunk to the current hash value
        this.set(this.h1 + cl + dr | 0, this.h2 + dl + er | 0, this.h3 + el + ar | 0, this.h4 + al + br | 0, this.h0 + bl + cr | 0);
    }
    roundClean() {
        $a1392d496f704884$var$BUF.fill(0);
    }
    destroy() {
        this.destroyed = true;
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0);
    }
    constructor(){
        super(64, 20, 8, true);
        this.h0 = 1732584193;
        this.h1 = -271733879;
        this.h2 = -1732584194;
        this.h3 = 271733878;
        this.h4 = -1009589776;
    }
}
module.exports.RIPEMD160 = $a1392d496f704884$var$RIPEMD160;
/**
 * RIPEMD-160 - a hash function from 1990s.
 * @param message - msg that would be hashed
 */ module.exports.ripemd160 = (0, $bdetq.wrapConstructor)(()=>new $a1392d496f704884$var$RIPEMD160());

});


parcelRegister("ymcBJ", function(module, exports) {
"use strict";
var $06746603b53caf35$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Secp256k1 = void 0;

var $5zb9p = parcelRequire("5zb9p");

const $06746603b53caf35$var$bn_js_1 = $06746603b53caf35$var$__importDefault((parcelRequire("jlWHo")));

const $06746603b53caf35$var$elliptic_1 = $06746603b53caf35$var$__importDefault((parcelRequire("492wS")));

var $5xf6q = parcelRequire("5xf6q");
const $06746603b53caf35$var$secp256k1 = new $06746603b53caf35$var$elliptic_1.default.ec("secp256k1");
const $06746603b53caf35$var$secp256k1N = new $06746603b53caf35$var$bn_js_1.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", "hex");
class $06746603b53caf35$var$Secp256k1 {
    /**
     * Takes a 32 byte private key and returns a privkey/pubkey pair.
     *
     * The resulting pubkey is uncompressed. For the use in Cosmos it should
     * be compressed first using `Secp256k1.compressPubkey`.
     */ static async makeKeypair(privkey) {
        if (privkey.length !== 32) // is this check missing in secp256k1.validatePrivateKey?
        // https://github.com/bitjson/bitcoin-ts/issues/4
        throw new Error("input data is not a valid secp256k1 private key");
        const keypair = $06746603b53caf35$var$secp256k1.keyFromPrivate(privkey);
        if (keypair.validate().result !== true) throw new Error("input data is not a valid secp256k1 private key");
        // range test that is not part of the elliptic implementation
        const privkeyAsBigInteger = new $06746603b53caf35$var$bn_js_1.default(privkey);
        if (privkeyAsBigInteger.gte($06746603b53caf35$var$secp256k1N)) // not strictly smaller than N
        throw new Error("input data is not a valid secp256k1 private key");
        const out = {
            privkey: (0, $5zb9p.fromHex)(keypair.getPrivate("hex")),
            // encodes uncompressed as
            // - 1-byte prefix "04"
            // - 32-byte x coordinate
            // - 32-byte y coordinate
            pubkey: Uint8Array.from(keypair.getPublic("array"))
        };
        return out;
    }
    /**
     * Creates a signature that is
     * - deterministic (RFC 6979)
     * - lowS signature
     * - DER encoded
     */ static async createSignature(messageHash, privkey) {
        if (messageHash.length === 0) throw new Error("Message hash must not be empty");
        if (messageHash.length > 32) throw new Error("Message hash length must not exceed 32 bytes");
        const keypair = $06746603b53caf35$var$secp256k1.keyFromPrivate(privkey);
        // the `canonical` option ensures creation of lowS signature representations
        const { r: r, s: s, recoveryParam: recoveryParam } = keypair.sign(messageHash, {
            canonical: true
        });
        if (typeof recoveryParam !== "number") throw new Error("Recovery param missing");
        return new $5xf6q.ExtendedSecp256k1Signature(Uint8Array.from(r.toArray()), Uint8Array.from(s.toArray()), recoveryParam);
    }
    static async verifySignature(signature, messageHash, pubkey) {
        if (messageHash.length === 0) throw new Error("Message hash must not be empty");
        if (messageHash.length > 32) throw new Error("Message hash length must not exceed 32 bytes");
        const keypair = $06746603b53caf35$var$secp256k1.keyFromPublic(pubkey);
        // From https://github.com/indutny/elliptic:
        //
        //     Sign the message's hash (input must be an array, or a hex-string)
        //
        //     Signature MUST be either:
        //     1) DER-encoded signature as hex-string; or
        //     2) DER-encoded signature as buffer; or
        //     3) object with two hex-string properties (r and s); or
        //     4) object with two buffer properties (r and s)
        //
        // Uint8Array is not a Buffer, but elliptic seems to be happy with the interface
        // common to both types. Uint8Array is not an array of ints but the interface is
        // similar
        try {
            return keypair.verify(messageHash, signature.toDer());
        } catch (error) {
            return false;
        }
    }
    static recoverPubkey(signature, messageHash) {
        const signatureForElliptic = {
            r: (0, $5zb9p.toHex)(signature.r()),
            s: (0, $5zb9p.toHex)(signature.s())
        };
        const point = $06746603b53caf35$var$secp256k1.recoverPubKey(messageHash, signatureForElliptic, signature.recovery);
        const keypair = $06746603b53caf35$var$secp256k1.keyFromPublic(point);
        return (0, $5zb9p.fromHex)(keypair.getPublic(false, "hex"));
    }
    /**
     * Takes a compressed or uncompressed pubkey and return a compressed one.
     *
     * This function is idempotent.
     */ static compressPubkey(pubkey) {
        switch(pubkey.length){
            case 33:
                return pubkey;
            case 65:
                return Uint8Array.from($06746603b53caf35$var$secp256k1.keyFromPublic(pubkey).getPublic(true, "array"));
            default:
                throw new Error("Invalid pubkey length");
        }
    }
    /**
     * Takes a compressed or uncompressed pubkey and returns an uncompressed one.
     *
     * This function is idempotent.
     */ static uncompressPubkey(pubkey) {
        switch(pubkey.length){
            case 33:
                return Uint8Array.from($06746603b53caf35$var$secp256k1.keyFromPublic(pubkey).getPublic(false, "array"));
            case 65:
                return pubkey;
            default:
                throw new Error("Invalid pubkey length");
        }
    }
    static trimRecoveryByte(signature) {
        switch(signature.length){
            case 64:
                return signature;
            case 65:
                return signature.slice(0, 64);
            default:
                throw new Error("Invalid signature length");
        }
    }
}
module.exports.Secp256k1 = $06746603b53caf35$var$Secp256k1;

});
parcelRegister("5xf6q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExtendedSecp256k1Signature = module.exports.Secp256k1Signature = void 0;
function $407bbfe6e53cb21b$var$trimLeadingNullBytes(inData) {
    let numberOfLeadingNullBytes = 0;
    for (const byte of inData){
        if (byte === 0x00) numberOfLeadingNullBytes++;
        else break;
    }
    return inData.slice(numberOfLeadingNullBytes);
}
const $407bbfe6e53cb21b$var$derTagInteger = 0x02;
class $407bbfe6e53cb21b$var$Secp256k1Signature {
    /**
     * Takes the pair of integers (r, s) as 2x32 byte of binary data.
     *
     * Note: This is the format Cosmos SDK uses natively.
     *
     * @param data a 64 byte value containing integers r and s.
     */ static fromFixedLength(data) {
        if (data.length !== 64) throw new Error(`Got invalid data length: ${data.length}. Expected 2x 32 bytes for the pair (r, s)`);
        return new $407bbfe6e53cb21b$var$Secp256k1Signature($407bbfe6e53cb21b$var$trimLeadingNullBytes(data.slice(0, 32)), $407bbfe6e53cb21b$var$trimLeadingNullBytes(data.slice(32, 64)));
    }
    static fromDer(data) {
        let pos = 0;
        if (data[pos++] !== 0x30) throw new Error("Prefix 0x30 expected");
        const bodyLength = data[pos++];
        if (data.length - pos !== bodyLength) throw new Error("Data length mismatch detected");
        // r
        const rTag = data[pos++];
        if (rTag !== $407bbfe6e53cb21b$var$derTagInteger) throw new Error("INTEGER tag expected");
        const rLength = data[pos++];
        if (rLength >= 0x80) throw new Error("Decoding length values above 127 not supported");
        const rData = data.slice(pos, pos + rLength);
        pos += rLength;
        // s
        const sTag = data[pos++];
        if (sTag !== $407bbfe6e53cb21b$var$derTagInteger) throw new Error("INTEGER tag expected");
        const sLength = data[pos++];
        if (sLength >= 0x80) throw new Error("Decoding length values above 127 not supported");
        const sData = data.slice(pos, pos + sLength);
        pos += sLength;
        return new $407bbfe6e53cb21b$var$Secp256k1Signature(// r/s data can contain leading 0 bytes to express integers being non-negative in DER
        $407bbfe6e53cb21b$var$trimLeadingNullBytes(rData), $407bbfe6e53cb21b$var$trimLeadingNullBytes(sData));
    }
    r(length) {
        if (length === undefined) return this.data.r;
        else {
            const paddingLength = length - this.data.r.length;
            if (paddingLength < 0) throw new Error("Length too small to hold parameter r");
            const padding = new Uint8Array(paddingLength);
            return new Uint8Array([
                ...padding,
                ...this.data.r
            ]);
        }
    }
    s(length) {
        if (length === undefined) return this.data.s;
        else {
            const paddingLength = length - this.data.s.length;
            if (paddingLength < 0) throw new Error("Length too small to hold parameter s");
            const padding = new Uint8Array(paddingLength);
            return new Uint8Array([
                ...padding,
                ...this.data.s
            ]);
        }
    }
    toFixedLength() {
        return new Uint8Array([
            ...this.r(32),
            ...this.s(32)
        ]);
    }
    toDer() {
        // DER supports negative integers but our data is unsigned. Thus we need to prepend
        // a leading 0 byte when the higest bit is set to differentiate nagative values
        const rEncoded = this.data.r[0] >= 0x80 ? new Uint8Array([
            0,
            ...this.data.r
        ]) : this.data.r;
        const sEncoded = this.data.s[0] >= 0x80 ? new Uint8Array([
            0,
            ...this.data.s
        ]) : this.data.s;
        const rLength = rEncoded.length;
        const sLength = sEncoded.length;
        const data = new Uint8Array([
            $407bbfe6e53cb21b$var$derTagInteger,
            rLength,
            ...rEncoded,
            $407bbfe6e53cb21b$var$derTagInteger,
            sLength,
            ...sEncoded
        ]);
        return new Uint8Array([
            0x30,
            data.length,
            ...data
        ]);
    }
    constructor(r, s){
        if (r.length > 32 || r.length === 0 || r[0] === 0x00) throw new Error("Unsigned integer r must be encoded as unpadded big endian.");
        if (s.length > 32 || s.length === 0 || s[0] === 0x00) throw new Error("Unsigned integer s must be encoded as unpadded big endian.");
        this.data = {
            r: r,
            s: s
        };
    }
}
module.exports.Secp256k1Signature = $407bbfe6e53cb21b$var$Secp256k1Signature;
/**
 * A Secp256k1Signature plus the recovery parameter
 */ class $407bbfe6e53cb21b$var$ExtendedSecp256k1Signature extends $407bbfe6e53cb21b$var$Secp256k1Signature {
    /**
     * Decode extended signature from the simple fixed length encoding
     * described in toFixedLength().
     */ static fromFixedLength(data) {
        if (data.length !== 65) throw new Error(`Got invalid data length ${data.length}. Expected 32 + 32 + 1`);
        return new $407bbfe6e53cb21b$var$ExtendedSecp256k1Signature($407bbfe6e53cb21b$var$trimLeadingNullBytes(data.slice(0, 32)), $407bbfe6e53cb21b$var$trimLeadingNullBytes(data.slice(32, 64)), data[64]);
    }
    /**
     * A simple custom encoding that encodes the extended signature as
     * r (32 bytes) | s (32 bytes) | recovery param (1 byte)
     * where | denotes concatenation of bonary data.
     */ toFixedLength() {
        return new Uint8Array([
            ...this.r(32),
            ...this.s(32),
            this.recovery
        ]);
    }
    constructor(r, s, recovery){
        super(r, s);
        if (!Number.isInteger(recovery)) throw new Error("The recovery parameter must be an integer.");
        if (recovery < 0 || recovery > 4) throw new Error("The recovery parameter must be one of 0, 1, 2, 3.");
        this.recovery = recovery;
    }
}
module.exports.ExtendedSecp256k1Signature = $407bbfe6e53cb21b$var$ExtendedSecp256k1Signature;

});


parcelRegister("hhuH3", function(module, exports) {
"use strict";
var $c94bd54ac0abbdf2$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.stringToPath = module.exports.pathToString = module.exports.Slip10 = module.exports.Slip10RawIndex = module.exports.slip10CurveFromString = module.exports.Slip10Curve = void 0;

var $5zb9p = parcelRequire("5zb9p");

var $9YIif = parcelRequire("9YIif");

const $c94bd54ac0abbdf2$var$bn_js_1 = $c94bd54ac0abbdf2$var$__importDefault((parcelRequire("jlWHo")));

const $c94bd54ac0abbdf2$var$elliptic_1 = $c94bd54ac0abbdf2$var$__importDefault((parcelRequire("492wS")));

var $6vFTM = parcelRequire("6vFTM");

var $aMdHR = parcelRequire("aMdHR");
/**
 * Raw values must match the curve string in SLIP-0010 master key generation
 *
 * @see https://github.com/satoshilabs/slips/blob/master/slip-0010.md#master-key-generation
 */ var $c94bd54ac0abbdf2$var$Slip10Curve;
(function(Slip10Curve) {
    Slip10Curve["Secp256k1"] = "Bitcoin seed";
    Slip10Curve["Ed25519"] = "ed25519 seed";
})($c94bd54ac0abbdf2$var$Slip10Curve = module.exports.Slip10Curve || (module.exports.Slip10Curve = {}));
/**
 * Reverse mapping of Slip10Curve
 */ function $c94bd54ac0abbdf2$var$slip10CurveFromString(curveString) {
    switch(curveString){
        case $c94bd54ac0abbdf2$var$Slip10Curve.Ed25519:
            return $c94bd54ac0abbdf2$var$Slip10Curve.Ed25519;
        case $c94bd54ac0abbdf2$var$Slip10Curve.Secp256k1:
            return $c94bd54ac0abbdf2$var$Slip10Curve.Secp256k1;
        default:
            throw new Error(`Unknown curve string: '${curveString}'`);
    }
}
module.exports.slip10CurveFromString = $c94bd54ac0abbdf2$var$slip10CurveFromString;
class $c94bd54ac0abbdf2$var$Slip10RawIndex extends $9YIif.Uint32 {
    static hardened(hardenedIndex) {
        return new $c94bd54ac0abbdf2$var$Slip10RawIndex(hardenedIndex + 2 ** 31);
    }
    static normal(normalIndex) {
        return new $c94bd54ac0abbdf2$var$Slip10RawIndex(normalIndex);
    }
    isHardened() {
        return this.data >= 2 ** 31;
    }
}
module.exports.Slip10RawIndex = $c94bd54ac0abbdf2$var$Slip10RawIndex;
const $c94bd54ac0abbdf2$var$secp256k1 = new $c94bd54ac0abbdf2$var$elliptic_1.default.ec("secp256k1");
// Universal private key derivation accoring to
// https://github.com/satoshilabs/slips/blob/master/slip-0010.md
class $c94bd54ac0abbdf2$var$Slip10 {
    static derivePath(curve, seed, path) {
        let result = this.master(curve, seed);
        for (const rawIndex of path)result = this.child(curve, result.privkey, result.chainCode, rawIndex);
        return result;
    }
    static master(curve, seed) {
        const i = new $6vFTM.Hmac($aMdHR.Sha512, (0, $5zb9p.toAscii)(curve)).update(seed).digest();
        const il = i.slice(0, 32);
        const ir = i.slice(32, 64);
        if (curve !== $c94bd54ac0abbdf2$var$Slip10Curve.Ed25519 && (this.isZero(il) || this.isGteN(curve, il))) return this.master(curve, i);
        return {
            chainCode: ir,
            privkey: il
        };
    }
    static child(curve, parentPrivkey, parentChainCode, rawIndex) {
        let i;
        if (rawIndex.isHardened()) {
            const payload = new Uint8Array([
                0x00,
                ...parentPrivkey,
                ...rawIndex.toBytesBigEndian()
            ]);
            i = new $6vFTM.Hmac($aMdHR.Sha512, parentChainCode).update(payload).digest();
        } else {
            if (curve === $c94bd54ac0abbdf2$var$Slip10Curve.Ed25519) throw new Error("Normal keys are not allowed with ed25519");
            else {
                // Step 1 of https://github.com/satoshilabs/slips/blob/master/slip-0010.md#private-parent-key--private-child-key
                // Calculate I = HMAC-SHA512(Key = c_par, Data = ser_P(point(k_par)) || ser_32(i)).
                // where the functions point() and ser_p() are defined in BIP-0032
                const data = new Uint8Array([
                    ...$c94bd54ac0abbdf2$var$Slip10.serializedPoint(curve, new $c94bd54ac0abbdf2$var$bn_js_1.default(parentPrivkey)),
                    ...rawIndex.toBytesBigEndian()
                ]);
                i = new $6vFTM.Hmac($aMdHR.Sha512, parentChainCode).update(data).digest();
            }
        }
        return this.childImpl(curve, parentPrivkey, parentChainCode, rawIndex, i);
    }
    /**
     * Implementation of ser_P(point(k_par)) from BIP-0032
     *
     * @see https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki
     */ static serializedPoint(curve, p) {
        switch(curve){
            case $c94bd54ac0abbdf2$var$Slip10Curve.Secp256k1:
                return (0, $5zb9p.fromHex)($c94bd54ac0abbdf2$var$secp256k1.g.mul(p).encodeCompressed("hex"));
            default:
                throw new Error("curve not supported");
        }
    }
    static childImpl(curve, parentPrivkey, parentChainCode, rawIndex, i) {
        // step 2 (of the Private parent key → private child key algorithm)
        const il = i.slice(0, 32);
        const ir = i.slice(32, 64);
        // step 3
        const returnChainCode = ir;
        // step 4
        if (curve === $c94bd54ac0abbdf2$var$Slip10Curve.Ed25519) return {
            chainCode: returnChainCode,
            privkey: il
        };
        // step 5
        const n = this.n(curve);
        const returnChildKeyAsNumber = new $c94bd54ac0abbdf2$var$bn_js_1.default(il).add(new $c94bd54ac0abbdf2$var$bn_js_1.default(parentPrivkey)).mod(n);
        const returnChildKey = Uint8Array.from(returnChildKeyAsNumber.toArray("be", 32));
        // step 6
        if (this.isGteN(curve, il) || this.isZero(returnChildKey)) {
            const newI = new $6vFTM.Hmac($aMdHR.Sha512, parentChainCode).update(new Uint8Array([
                0x01,
                ...ir,
                ...rawIndex.toBytesBigEndian()
            ])).digest();
            return this.childImpl(curve, parentPrivkey, parentChainCode, rawIndex, newI);
        }
        // step 7
        return {
            chainCode: returnChainCode,
            privkey: returnChildKey
        };
    }
    static isZero(privkey) {
        return privkey.every((byte)=>byte === 0);
    }
    static isGteN(curve, privkey) {
        const keyAsNumber = new $c94bd54ac0abbdf2$var$bn_js_1.default(privkey);
        return keyAsNumber.gte(this.n(curve));
    }
    static n(curve) {
        switch(curve){
            case $c94bd54ac0abbdf2$var$Slip10Curve.Secp256k1:
                return new $c94bd54ac0abbdf2$var$bn_js_1.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", 16);
            default:
                throw new Error("curve not supported");
        }
    }
}
module.exports.Slip10 = $c94bd54ac0abbdf2$var$Slip10;
function $c94bd54ac0abbdf2$var$pathToString(path) {
    return path.reduce((current, component)=>{
        const componentString = component.isHardened() ? `${component.toNumber() - 2 ** 31}'` : component.toString();
        return current + "/" + componentString;
    }, "m");
}
module.exports.pathToString = $c94bd54ac0abbdf2$var$pathToString;
function $c94bd54ac0abbdf2$var$stringToPath(input) {
    if (!input.startsWith("m")) throw new Error("Path string must start with 'm'");
    let rest = input.slice(1);
    const out = new Array();
    while(rest){
        const match = rest.match(/^\/([0-9]+)('?)/);
        if (!match) throw new Error("Syntax error while reading path component");
        const [fullMatch, numberString, apostrophe] = match;
        const value = $9YIif.Uint53.fromString(numberString).toNumber();
        if (value >= 2 ** 31) throw new Error("Component value too high. Must not exceed 2**31-1.");
        if (apostrophe) out.push($c94bd54ac0abbdf2$var$Slip10RawIndex.hardened(value));
        else out.push($c94bd54ac0abbdf2$var$Slip10RawIndex.normal(value));
        rest = rest.slice(fullMatch.length);
    }
    return out;
}
module.exports.stringToPath = $c94bd54ac0abbdf2$var$stringToPath;

});
parcelRegister("9YIif", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Uint64 = module.exports.Uint53 = module.exports.Uint32 = module.exports.Int53 = module.exports.Decimal = void 0;

var $1CoYj = parcelRequire("1CoYj");
Object.defineProperty(module.exports, "Decimal", {
    enumerable: true,
    get: function() {
        return $1CoYj.Decimal;
    }
});

var $5tBh8 = parcelRequire("5tBh8");
Object.defineProperty(module.exports, "Int53", {
    enumerable: true,
    get: function() {
        return $5tBh8.Int53;
    }
});
Object.defineProperty(module.exports, "Uint32", {
    enumerable: true,
    get: function() {
        return $5tBh8.Uint32;
    }
});
Object.defineProperty(module.exports, "Uint53", {
    enumerable: true,
    get: function() {
        return $5tBh8.Uint53;
    }
});
Object.defineProperty(module.exports, "Uint64", {
    enumerable: true,
    get: function() {
        return $5tBh8.Uint64;
    }
});

});
parcelRegister("1CoYj", function(module, exports) {
"use strict";
var $12dcb5f29204db31$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Decimal = void 0;

const $12dcb5f29204db31$var$bn_js_1 = $12dcb5f29204db31$var$__importDefault((parcelRequire("jlWHo")));
// Too large values lead to massive memory usage. Limit to something sensible.
// The largest value we need is 18 (Ether).
const $12dcb5f29204db31$var$maxFractionalDigits = 100;
/**
 * A type for arbitrary precision, non-negative decimals.
 *
 * Instances of this class are immutable.
 */ class $12dcb5f29204db31$var$Decimal {
    static fromUserInput(input, fractionalDigits) {
        $12dcb5f29204db31$var$Decimal.verifyFractionalDigits(fractionalDigits);
        const badCharacter = input.match(/[^0-9.]/);
        if (badCharacter) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        throw new Error(`Invalid character at position ${badCharacter.index + 1}`);
        let whole;
        let fractional;
        if (input.search(/\./) === -1) {
            // integer format, no separator
            whole = input;
            fractional = "";
        } else {
            const parts = input.split(".");
            switch(parts.length){
                case 0:
                case 1:
                    throw new Error("Fewer than two elements in split result. This must not happen here.");
                case 2:
                    if (!parts[1]) throw new Error("Fractional part missing");
                    whole = parts[0];
                    fractional = parts[1].replace(/0+$/, "");
                    break;
                default:
                    throw new Error("More than one separator found");
            }
        }
        if (fractional.length > fractionalDigits) throw new Error("Got more fractional digits than supported");
        const quantity = `${whole}${fractional.padEnd(fractionalDigits, "0")}`;
        return new $12dcb5f29204db31$var$Decimal(quantity, fractionalDigits);
    }
    static fromAtomics(atomics, fractionalDigits) {
        $12dcb5f29204db31$var$Decimal.verifyFractionalDigits(fractionalDigits);
        return new $12dcb5f29204db31$var$Decimal(atomics, fractionalDigits);
    }
    /**
     * Creates a Decimal with value 0.0 and the given number of fractial digits.
     *
     * Fractional digits are not relevant for the value but needed to be able
     * to perform arithmetic operations with other decimals.
     */ static zero(fractionalDigits) {
        $12dcb5f29204db31$var$Decimal.verifyFractionalDigits(fractionalDigits);
        return new $12dcb5f29204db31$var$Decimal("0", fractionalDigits);
    }
    /**
     * Creates a Decimal with value 1.0 and the given number of fractial digits.
     *
     * Fractional digits are not relevant for the value but needed to be able
     * to perform arithmetic operations with other decimals.
     */ static one(fractionalDigits) {
        $12dcb5f29204db31$var$Decimal.verifyFractionalDigits(fractionalDigits);
        return new $12dcb5f29204db31$var$Decimal("1" + "0".repeat(fractionalDigits), fractionalDigits);
    }
    static verifyFractionalDigits(fractionalDigits) {
        if (!Number.isInteger(fractionalDigits)) throw new Error("Fractional digits is not an integer");
        if (fractionalDigits < 0) throw new Error("Fractional digits must not be negative");
        if (fractionalDigits > $12dcb5f29204db31$var$maxFractionalDigits) throw new Error(`Fractional digits must not exceed ${$12dcb5f29204db31$var$maxFractionalDigits}`);
    }
    static compare(a, b) {
        if (a.fractionalDigits !== b.fractionalDigits) throw new Error("Fractional digits do not match");
        return a.data.atomics.cmp(new $12dcb5f29204db31$var$bn_js_1.default(b.atomics));
    }
    get atomics() {
        return this.data.atomics.toString();
    }
    get fractionalDigits() {
        return this.data.fractionalDigits;
    }
    /** Creates a new instance with the same value */ clone() {
        return new $12dcb5f29204db31$var$Decimal(this.atomics, this.fractionalDigits);
    }
    /** Returns the greatest decimal <= this which has no fractional part (rounding down) */ floor() {
        const factor = new $12dcb5f29204db31$var$bn_js_1.default(10).pow(new $12dcb5f29204db31$var$bn_js_1.default(this.data.fractionalDigits));
        const whole = this.data.atomics.div(factor);
        const fractional = this.data.atomics.mod(factor);
        if (fractional.isZero()) return this.clone();
        else return $12dcb5f29204db31$var$Decimal.fromAtomics(whole.mul(factor).toString(), this.fractionalDigits);
    }
    /** Returns the smallest decimal >= this which has no fractional part (rounding up) */ ceil() {
        const factor = new $12dcb5f29204db31$var$bn_js_1.default(10).pow(new $12dcb5f29204db31$var$bn_js_1.default(this.data.fractionalDigits));
        const whole = this.data.atomics.div(factor);
        const fractional = this.data.atomics.mod(factor);
        if (fractional.isZero()) return this.clone();
        else return $12dcb5f29204db31$var$Decimal.fromAtomics(whole.addn(1).mul(factor).toString(), this.fractionalDigits);
    }
    toString() {
        const factor = new $12dcb5f29204db31$var$bn_js_1.default(10).pow(new $12dcb5f29204db31$var$bn_js_1.default(this.data.fractionalDigits));
        const whole = this.data.atomics.div(factor);
        const fractional = this.data.atomics.mod(factor);
        if (fractional.isZero()) return whole.toString();
        else {
            const fullFractionalPart = fractional.toString().padStart(this.data.fractionalDigits, "0");
            const trimmedFractionalPart = fullFractionalPart.replace(/0+$/, "");
            return `${whole.toString()}.${trimmedFractionalPart}`;
        }
    }
    /**
     * Returns an approximation as a float type. Only use this if no
     * exact calculation is required.
     */ toFloatApproximation() {
        const out = Number(this.toString());
        if (Number.isNaN(out)) throw new Error("Conversion to number failed");
        return out;
    }
    /**
     * a.plus(b) returns a+b.
     *
     * Both values need to have the same fractional digits.
     */ plus(b) {
        if (this.fractionalDigits !== b.fractionalDigits) throw new Error("Fractional digits do not match");
        const sum = this.data.atomics.add(new $12dcb5f29204db31$var$bn_js_1.default(b.atomics));
        return new $12dcb5f29204db31$var$Decimal(sum.toString(), this.fractionalDigits);
    }
    /**
     * a.minus(b) returns a-b.
     *
     * Both values need to have the same fractional digits.
     * The resulting difference needs to be non-negative.
     */ minus(b) {
        if (this.fractionalDigits !== b.fractionalDigits) throw new Error("Fractional digits do not match");
        const difference = this.data.atomics.sub(new $12dcb5f29204db31$var$bn_js_1.default(b.atomics));
        if (difference.ltn(0)) throw new Error("Difference must not be negative");
        return new $12dcb5f29204db31$var$Decimal(difference.toString(), this.fractionalDigits);
    }
    /**
     * a.multiply(b) returns a*b.
     *
     * We only allow multiplication by unsigned integers to avoid rounding errors.
     */ multiply(b) {
        const product = this.data.atomics.mul(new $12dcb5f29204db31$var$bn_js_1.default(b.toString()));
        return new $12dcb5f29204db31$var$Decimal(product.toString(), this.fractionalDigits);
    }
    equals(b) {
        return $12dcb5f29204db31$var$Decimal.compare(this, b) === 0;
    }
    isLessThan(b) {
        return $12dcb5f29204db31$var$Decimal.compare(this, b) < 0;
    }
    isLessThanOrEqual(b) {
        return $12dcb5f29204db31$var$Decimal.compare(this, b) <= 0;
    }
    isGreaterThan(b) {
        return $12dcb5f29204db31$var$Decimal.compare(this, b) > 0;
    }
    isGreaterThanOrEqual(b) {
        return $12dcb5f29204db31$var$Decimal.compare(this, b) >= 0;
    }
    constructor(atomics, fractionalDigits){
        this.data = {
            atomics: new $12dcb5f29204db31$var$bn_js_1.default(atomics),
            fractionalDigits: fractionalDigits
        };
    }
}
module.exports.Decimal = $12dcb5f29204db31$var$Decimal;

});

parcelRegister("5tBh8", function(module, exports) {
"use strict";
var $3fcc934cd80552f3$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Uint64 = module.exports.Uint53 = module.exports.Int53 = module.exports.Uint32 = void 0;

/* eslint-disable no-bitwise */ const $3fcc934cd80552f3$var$bn_js_1 = $3fcc934cd80552f3$var$__importDefault((parcelRequire("jlWHo")));
const $3fcc934cd80552f3$var$uint64MaxValue = new $3fcc934cd80552f3$var$bn_js_1.default("18446744073709551615", 10, "be");
class $3fcc934cd80552f3$var$Uint32 {
    /** @deprecated use Uint32.fromBytes */ static fromBigEndianBytes(bytes) {
        return $3fcc934cd80552f3$var$Uint32.fromBytes(bytes);
    }
    /**
     * Creates a Uint32 from a fixed length byte array.
     *
     * @param bytes a list of exactly 4 bytes
     * @param endianess defaults to big endian
     */ static fromBytes(bytes, endianess = "be") {
        if (bytes.length !== 4) throw new Error("Invalid input length. Expected 4 bytes.");
        for(let i = 0; i < bytes.length; ++i){
            if (!Number.isInteger(bytes[i]) || bytes[i] > 255 || bytes[i] < 0) throw new Error("Invalid value in byte. Found: " + bytes[i]);
        }
        const beBytes = endianess === "be" ? bytes : Array.from(bytes).reverse();
        // Use mulitiplication instead of shifting since bitwise operators are defined
        // on SIGNED int32 in JavaScript and we don't want to risk surprises
        return new $3fcc934cd80552f3$var$Uint32(beBytes[0] * 2 ** 24 + beBytes[1] * 2 ** 16 + beBytes[2] * 256 + beBytes[3]);
    }
    static fromString(str) {
        if (!str.match(/^[0-9]+$/)) throw new Error("Invalid string format");
        return new $3fcc934cd80552f3$var$Uint32(Number.parseInt(str, 10));
    }
    toBytesBigEndian() {
        // Use division instead of shifting since bitwise operators are defined
        // on SIGNED int32 in JavaScript and we don't want to risk surprises
        return new Uint8Array([
            Math.floor(this.data / 2 ** 24) & 0xff,
            Math.floor(this.data / 2 ** 16) & 0xff,
            Math.floor(this.data / 256) & 0xff,
            Math.floor(this.data / 1) & 0xff
        ]);
    }
    toBytesLittleEndian() {
        // Use division instead of shifting since bitwise operators are defined
        // on SIGNED int32 in JavaScript and we don't want to risk surprises
        return new Uint8Array([
            Math.floor(this.data / 1) & 0xff,
            Math.floor(this.data / 256) & 0xff,
            Math.floor(this.data / 2 ** 16) & 0xff,
            Math.floor(this.data / 2 ** 24) & 0xff
        ]);
    }
    toNumber() {
        return this.data;
    }
    toString() {
        return this.data.toString();
    }
    constructor(input){
        if (Number.isNaN(input)) throw new Error("Input is not a number");
        if (!Number.isInteger(input)) throw new Error("Input is not an integer");
        if (input < 0 || input > 4294967295) throw new Error("Input not in uint32 range: " + input.toString());
        this.data = input;
    }
}
module.exports.Uint32 = $3fcc934cd80552f3$var$Uint32;
class $3fcc934cd80552f3$var$Int53 {
    static fromString(str) {
        if (!str.match(/^-?[0-9]+$/)) throw new Error("Invalid string format");
        return new $3fcc934cd80552f3$var$Int53(Number.parseInt(str, 10));
    }
    toNumber() {
        return this.data;
    }
    toString() {
        return this.data.toString();
    }
    constructor(input){
        if (Number.isNaN(input)) throw new Error("Input is not a number");
        if (!Number.isInteger(input)) throw new Error("Input is not an integer");
        if (input < Number.MIN_SAFE_INTEGER || input > Number.MAX_SAFE_INTEGER) throw new Error("Input not in int53 range: " + input.toString());
        this.data = input;
    }
}
module.exports.Int53 = $3fcc934cd80552f3$var$Int53;
class $3fcc934cd80552f3$var$Uint53 {
    static fromString(str) {
        const signed = $3fcc934cd80552f3$var$Int53.fromString(str);
        return new $3fcc934cd80552f3$var$Uint53(signed.toNumber());
    }
    toNumber() {
        return this.data.toNumber();
    }
    toString() {
        return this.data.toString();
    }
    constructor(input){
        const signed = new $3fcc934cd80552f3$var$Int53(input);
        if (signed.toNumber() < 0) throw new Error("Input is negative");
        this.data = signed;
    }
}
module.exports.Uint53 = $3fcc934cd80552f3$var$Uint53;
class $3fcc934cd80552f3$var$Uint64 {
    /** @deprecated use Uint64.fromBytes */ static fromBytesBigEndian(bytes) {
        return $3fcc934cd80552f3$var$Uint64.fromBytes(bytes);
    }
    /**
     * Creates a Uint64 from a fixed length byte array.
     *
     * @param bytes a list of exactly 8 bytes
     * @param endianess defaults to big endian
     */ static fromBytes(bytes, endianess = "be") {
        if (bytes.length !== 8) throw new Error("Invalid input length. Expected 8 bytes.");
        for(let i = 0; i < bytes.length; ++i){
            if (!Number.isInteger(bytes[i]) || bytes[i] > 255 || bytes[i] < 0) throw new Error("Invalid value in byte. Found: " + bytes[i]);
        }
        const beBytes = endianess === "be" ? Array.from(bytes) : Array.from(bytes).reverse();
        return new $3fcc934cd80552f3$var$Uint64(new $3fcc934cd80552f3$var$bn_js_1.default(beBytes));
    }
    static fromString(str) {
        if (!str.match(/^[0-9]+$/)) throw new Error("Invalid string format");
        return new $3fcc934cd80552f3$var$Uint64(new $3fcc934cd80552f3$var$bn_js_1.default(str, 10, "be"));
    }
    static fromNumber(input) {
        if (Number.isNaN(input)) throw new Error("Input is not a number");
        if (!Number.isInteger(input)) throw new Error("Input is not an integer");
        let bigint;
        try {
            bigint = new $3fcc934cd80552f3$var$bn_js_1.default(input);
        } catch (_a) {
            throw new Error("Input is not a safe integer");
        }
        return new $3fcc934cd80552f3$var$Uint64(bigint);
    }
    toBytesBigEndian() {
        return Uint8Array.from(this.data.toArray("be", 8));
    }
    toBytesLittleEndian() {
        return Uint8Array.from(this.data.toArray("le", 8));
    }
    toString() {
        return this.data.toString(10);
    }
    toNumber() {
        return this.data.toNumber();
    }
    constructor(data){
        if (data.isNeg()) throw new Error("Input is negative");
        if (data.gt($3fcc934cd80552f3$var$uint64MaxValue)) throw new Error("Input exceeds uint64 range");
        this.data = data;
    }
}
module.exports.Uint64 = $3fcc934cd80552f3$var$Uint64;
// Assign classes to unused variables in order to verify static interface conformance at compile time.
// Workaround for https://github.com/microsoft/TypeScript/issues/33892
const $3fcc934cd80552f3$var$_int53Class = $3fcc934cd80552f3$var$Int53;
const $3fcc934cd80552f3$var$_uint53Class = $3fcc934cd80552f3$var$Uint53;
const $3fcc934cd80552f3$var$_uint32Class = $3fcc934cd80552f3$var$Uint32;
const $3fcc934cd80552f3$var$_uint64Class = $3fcc934cd80552f3$var$Uint64;

});




parcelRegister("75MVN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.encodeBlockId = module.exports.encodeVersion = module.exports.encodeBytes = module.exports.encodeTime = module.exports.encodeInt = module.exports.encodeString = module.exports.Integer = module.exports.dictionaryToStringMap = module.exports.may = module.exports.optional = module.exports.assertNotEmpty = module.exports.assertObject = module.exports.assertArray = module.exports.assertNumber = module.exports.assertString = module.exports.assertBoolean = module.exports.assertSet = void 0;

var $5zb9p = parcelRequire("5zb9p");

var $9YIif = parcelRequire("9YIif");
/**
 * A runtime checker that ensures a given value is set (i.e. not undefined or null)
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 */ function $529ef4c66f164fce$var$assertSet(value) {
    if (value === undefined) throw new Error("Value must not be undefined");
    if (value === null) throw new Error("Value must not be null");
    return value;
}
module.exports.assertSet = $529ef4c66f164fce$var$assertSet;
/**
 * A runtime checker that ensures a given value is a boolean
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $529ef4c66f164fce$var$assertBoolean(value) {
    $529ef4c66f164fce$var$assertSet(value);
    if (typeof value !== "boolean") throw new Error("Value must be a boolean");
    return value;
}
module.exports.assertBoolean = $529ef4c66f164fce$var$assertBoolean;
/**
 * A runtime checker that ensures a given value is a string.
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $529ef4c66f164fce$var$assertString(value) {
    $529ef4c66f164fce$var$assertSet(value);
    if (typeof value !== "string") throw new Error("Value must be a string");
    return value;
}
module.exports.assertString = $529ef4c66f164fce$var$assertString;
/**
 * A runtime checker that ensures a given value is a number
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $529ef4c66f164fce$var$assertNumber(value) {
    $529ef4c66f164fce$var$assertSet(value);
    if (typeof value !== "number") throw new Error("Value must be a number");
    return value;
}
module.exports.assertNumber = $529ef4c66f164fce$var$assertNumber;
/**
 * A runtime checker that ensures a given value is an array
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $529ef4c66f164fce$var$assertArray(value) {
    $529ef4c66f164fce$var$assertSet(value);
    if (!Array.isArray(value)) throw new Error("Value must be a an array");
    return value;
}
module.exports.assertArray = $529ef4c66f164fce$var$assertArray;
/**
 * A runtime checker that ensures a given value is an object in the sense of JSON
 * (an unordered collection of key–value pairs where the keys are strings)
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $529ef4c66f164fce$var$assertObject(value) {
    $529ef4c66f164fce$var$assertSet(value);
    if (typeof value !== "object") throw new Error("Value must be an object");
    // Exclude special kind of objects like Array, Date or Uint8Array
    // Object.prototype.toString() returns a specified value:
    // http://www.ecma-international.org/ecma-262/7.0/index.html#sec-object.prototype.tostring
    if (Object.prototype.toString.call(value) !== "[object Object]") throw new Error("Value must be a simple object");
    return value;
}
module.exports.assertObject = $529ef4c66f164fce$var$assertObject;
/**
 * Throws an error if value matches the empty value for the
 * given type (array/string of length 0, number of value 0, ...)
 *
 * Otherwise returns the value.
 *
 * This implies assertSet
 */ function $529ef4c66f164fce$var$assertNotEmpty(value) {
    $529ef4c66f164fce$var$assertSet(value);
    if (typeof value === "number" && value === 0) throw new Error("must provide a non-zero value");
    else if (value.length === 0) throw new Error("must provide a non-empty value");
    return value;
}
module.exports.assertNotEmpty = $529ef4c66f164fce$var$assertNotEmpty;
// optional uses the value or provides a default
function $529ef4c66f164fce$var$optional(value, fallback) {
    return value === undefined || value === null ? fallback : value;
}
module.exports.optional = $529ef4c66f164fce$var$optional;
// may will run the transform if value is defined, otherwise returns undefined
function $529ef4c66f164fce$var$may(transform, value) {
    return value === undefined || value === null ? undefined : transform(value);
}
module.exports.may = $529ef4c66f164fce$var$may;
function $529ef4c66f164fce$var$dictionaryToStringMap(obj) {
    const out = new Map();
    for (const key of Object.keys(obj)){
        const value = obj[key];
        if (typeof value !== "string") throw new Error("Found dictionary value of type other than string");
        out.set(key, value);
    }
    return out;
}
module.exports.dictionaryToStringMap = $529ef4c66f164fce$var$dictionaryToStringMap;
class $529ef4c66f164fce$var$Integer {
    static parse(input) {
        const asInt = typeof input === "number" ? new $9YIif.Int53(input) : $9YIif.Int53.fromString(input);
        return asInt.toNumber();
    }
    static encode(num) {
        return new $9YIif.Int53(num).toString();
    }
}
module.exports.Integer = $529ef4c66f164fce$var$Integer;
// Encodings needed for hashing block headers
// Several of these functions are inspired by https://github.com/nomic-io/js-tendermint/blob/tendermint-0.30/src/
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L193-L195
function $529ef4c66f164fce$var$encodeString(s) {
    const utf8 = (0, $5zb9p.toUtf8)(s);
    return Uint8Array.from([
        utf8.length,
        ...utf8
    ]);
}
module.exports.encodeString = $529ef4c66f164fce$var$encodeString;
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L79-L87
function $529ef4c66f164fce$var$encodeInt(n) {
    // eslint-disable-next-line no-bitwise
    return n >= 0x80 ? Uint8Array.from([
        n & 0xff | 0x80,
        ...$529ef4c66f164fce$var$encodeInt(n >> 7)
    ]) : Uint8Array.from([
        n & 0xff
    ]);
}
module.exports.encodeInt = $529ef4c66f164fce$var$encodeInt;
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L134-L178
function $529ef4c66f164fce$var$encodeTime(time) {
    const milliseconds = time.getTime();
    const seconds = Math.floor(milliseconds / 1000);
    const secondsArray = seconds ? [
        0x08,
        ...$529ef4c66f164fce$var$encodeInt(seconds)
    ] : new Uint8Array();
    const nanoseconds = (time.nanoseconds || 0) + milliseconds % 1000 * 1e6;
    const nanosecondsArray = nanoseconds ? [
        0x10,
        ...$529ef4c66f164fce$var$encodeInt(nanoseconds)
    ] : new Uint8Array();
    return Uint8Array.from([
        ...secondsArray,
        ...nanosecondsArray
    ]);
}
module.exports.encodeTime = $529ef4c66f164fce$var$encodeTime;
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L180-L187
function $529ef4c66f164fce$var$encodeBytes(bytes) {
    // Since we're only dealing with short byte arrays we don't need a full VarBuffer implementation yet
    if (bytes.length >= 0x80) throw new Error("Not implemented for byte arrays of length 128 or more");
    return bytes.length ? Uint8Array.from([
        bytes.length,
        ...bytes
    ]) : new Uint8Array();
}
module.exports.encodeBytes = $529ef4c66f164fce$var$encodeBytes;
function $529ef4c66f164fce$var$encodeVersion(version) {
    const blockArray = version.block ? Uint8Array.from([
        0x08,
        ...$529ef4c66f164fce$var$encodeInt(version.block)
    ]) : new Uint8Array();
    const appArray = version.app ? Uint8Array.from([
        0x10,
        ...$529ef4c66f164fce$var$encodeInt(version.app)
    ]) : new Uint8Array();
    return Uint8Array.from([
        ...blockArray,
        ...appArray
    ]);
}
module.exports.encodeVersion = $529ef4c66f164fce$var$encodeVersion;
function $529ef4c66f164fce$var$encodeBlockId(blockId) {
    return Uint8Array.from([
        0x0a,
        blockId.hash.length,
        ...blockId.hash,
        0x12,
        blockId.parts.hash.length + 4,
        0x08,
        blockId.parts.total,
        0x12,
        blockId.parts.hash.length,
        ...blockId.parts.hash
    ]);
}
module.exports.encodeBlockId = $529ef4c66f164fce$var$encodeBlockId;

});


parcelRegister("50pA5", function(module, exports) {
"use strict";
var $3a50cbae03752450$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3a50cbae03752450$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $3a50cbae03752450$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3a50cbae03752450$var$__createBinding(result, mod, k);
    }
    $3a50cbae03752450$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Params = void 0;

var $5zb9p = parcelRequire("5zb9p");

var $8XYR9 = parcelRequire("8XYR9");

var $75MVN = parcelRequire("75MVN");

const $3a50cbae03752450$var$requests = $3a50cbae03752450$var$__importStar((parcelRequire("kFe1M")));
function $3a50cbae03752450$var$encodeHeightParam(param) {
    return {
        height: (0, $75MVN.may)($75MVN.Integer.encode, param.height)
    };
}
function $3a50cbae03752450$var$encodeBlockchainRequestParams(param) {
    return {
        minHeight: (0, $75MVN.may)($75MVN.Integer.encode, param.minHeight),
        maxHeight: (0, $75MVN.may)($75MVN.Integer.encode, param.maxHeight)
    };
}
function $3a50cbae03752450$var$encodeBlockSearchParams(params) {
    return {
        query: params.query,
        page: (0, $75MVN.may)($75MVN.Integer.encode, params.page),
        per_page: (0, $75MVN.may)($75MVN.Integer.encode, params.per_page),
        order_by: params.order_by
    };
}
function $3a50cbae03752450$var$encodeAbciQueryParams(params) {
    return {
        path: (0, $75MVN.assertNotEmpty)(params.path),
        data: (0, $5zb9p.toHex)(params.data),
        height: (0, $75MVN.may)($75MVN.Integer.encode, params.height),
        prove: params.prove
    };
}
function $3a50cbae03752450$var$encodeBroadcastTxParams(params) {
    return {
        tx: (0, $5zb9p.toBase64)((0, $75MVN.assertNotEmpty)(params.tx))
    };
}
function $3a50cbae03752450$var$encodeTxParams(params) {
    return {
        hash: (0, $5zb9p.toBase64)((0, $75MVN.assertNotEmpty)(params.hash)),
        prove: params.prove
    };
}
function $3a50cbae03752450$var$encodeTxSearchParams(params) {
    return {
        query: params.query,
        prove: params.prove,
        page: (0, $75MVN.may)($75MVN.Integer.encode, params.page),
        per_page: (0, $75MVN.may)($75MVN.Integer.encode, params.per_page),
        order_by: params.order_by
    };
}
function $3a50cbae03752450$var$encodeValidatorsParams(params) {
    return {
        height: (0, $75MVN.may)($75MVN.Integer.encode, params.height),
        page: (0, $75MVN.may)($75MVN.Integer.encode, params.page),
        per_page: (0, $75MVN.may)($75MVN.Integer.encode, params.per_page)
    };
}
class $3a50cbae03752450$var$Params {
    static encodeAbciInfo(req) {
        return (0, $8XYR9.createJsonRpcRequest)(req.method);
    }
    static encodeAbciQuery(req) {
        return (0, $8XYR9.createJsonRpcRequest)(req.method, $3a50cbae03752450$var$encodeAbciQueryParams(req.params));
    }
    static encodeBlock(req) {
        return (0, $8XYR9.createJsonRpcRequest)(req.method, $3a50cbae03752450$var$encodeHeightParam(req.params));
    }
    static encodeBlockchain(req) {
        return (0, $8XYR9.createJsonRpcRequest)(req.method, $3a50cbae03752450$var$encodeBlockchainRequestParams(req.params));
    }
    static encodeBlockResults(req) {
        return (0, $8XYR9.createJsonRpcRequest)(req.method, $3a50cbae03752450$var$encodeHeightParam(req.params));
    }
    static encodeBlockSearch(req) {
        return (0, $8XYR9.createJsonRpcRequest)(req.method, $3a50cbae03752450$var$encodeBlockSearchParams(req.params));
    }
    static encodeBroadcastTx(req) {
        return (0, $8XYR9.createJsonRpcRequest)(req.method, $3a50cbae03752450$var$encodeBroadcastTxParams(req.params));
    }
    static encodeCommit(req) {
        return (0, $8XYR9.createJsonRpcRequest)(req.method, $3a50cbae03752450$var$encodeHeightParam(req.params));
    }
    static encodeGenesis(req) {
        return (0, $8XYR9.createJsonRpcRequest)(req.method);
    }
    static encodeHealth(req) {
        return (0, $8XYR9.createJsonRpcRequest)(req.method);
    }
    static encodeNumUnconfirmedTxs(req) {
        return (0, $8XYR9.createJsonRpcRequest)(req.method);
    }
    static encodeStatus(req) {
        return (0, $8XYR9.createJsonRpcRequest)(req.method);
    }
    static encodeSubscribe(req) {
        const eventTag = {
            key: "tm.event",
            value: req.query.type
        };
        const query = $3a50cbae03752450$var$requests.buildQuery({
            tags: [
                eventTag
            ],
            raw: req.query.raw
        });
        return (0, $8XYR9.createJsonRpcRequest)("subscribe", {
            query: query
        });
    }
    static encodeTx(req) {
        return (0, $8XYR9.createJsonRpcRequest)(req.method, $3a50cbae03752450$var$encodeTxParams(req.params));
    }
    // TODO: encode params for query string???
    static encodeTxSearch(req) {
        return (0, $8XYR9.createJsonRpcRequest)(req.method, $3a50cbae03752450$var$encodeTxSearchParams(req.params));
    }
    static encodeValidators(req) {
        return (0, $8XYR9.createJsonRpcRequest)(req.method, $3a50cbae03752450$var$encodeValidatorsParams(req.params));
    }
}
module.exports.Params = $3a50cbae03752450$var$Params;

});

parcelRegister("eyYDC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Responses = module.exports.decodeValidatorInfo = module.exports.decodeValidatorGenesis = module.exports.decodeValidatorUpdate = module.exports.decodeEvent = void 0;

var $5zb9p = parcelRequire("5zb9p");

var $F6P8J = parcelRequire("F6P8J");

var $aRP0Z = parcelRequire("aRP0Z");

var $lfB3U = parcelRequire("lfB3U");

var $75MVN = parcelRequire("75MVN");

var $i2CZI = parcelRequire("i2CZI");
function $a9a3471ed8124415$var$decodeAbciInfo(data) {
    return {
        data: data.data,
        lastBlockHeight: (0, $75MVN.may)($75MVN.Integer.parse, data.last_block_height),
        lastBlockAppHash: (0, $75MVN.may)($5zb9p.fromBase64, data.last_block_app_hash)
    };
}
function $a9a3471ed8124415$var$decodeQueryProof(data) {
    return {
        ops: data.ops.map((op)=>({
                type: op.type,
                key: (0, $5zb9p.fromBase64)(op.key),
                data: (0, $5zb9p.fromBase64)(op.data)
            }))
    };
}
function $a9a3471ed8124415$var$decodeAbciQuery(data) {
    return {
        key: (0, $5zb9p.fromBase64)((0, $75MVN.optional)(data.key, "")),
        value: (0, $5zb9p.fromBase64)((0, $75MVN.optional)(data.value, "")),
        proof: (0, $75MVN.may)($a9a3471ed8124415$var$decodeQueryProof, data.proofOps),
        height: (0, $75MVN.may)($75MVN.Integer.parse, data.height),
        code: (0, $75MVN.may)($75MVN.Integer.parse, data.code),
        index: (0, $75MVN.may)($75MVN.Integer.parse, data.index),
        log: data.log
    };
}
function $a9a3471ed8124415$var$decodeAttribute(attribute) {
    return {
        key: (0, $5zb9p.fromBase64)((0, $75MVN.assertNotEmpty)(attribute.key)),
        value: (0, $5zb9p.fromBase64)((0, $75MVN.optional)(attribute.value, ""))
    };
}
function $a9a3471ed8124415$var$decodeAttributes(attributes) {
    return (0, $75MVN.assertArray)(attributes).map($a9a3471ed8124415$var$decodeAttribute);
}
function $a9a3471ed8124415$var$decodeEvent(event) {
    return {
        type: event.type,
        attributes: event.attributes ? $a9a3471ed8124415$var$decodeAttributes(event.attributes) : []
    };
}
module.exports.decodeEvent = $a9a3471ed8124415$var$decodeEvent;
function $a9a3471ed8124415$var$decodeEvents(events) {
    return (0, $75MVN.assertArray)(events).map($a9a3471ed8124415$var$decodeEvent);
}
function $a9a3471ed8124415$var$decodeTxData(data) {
    return {
        code: $75MVN.Integer.parse((0, $75MVN.assertNumber)((0, $75MVN.optional)(data.code, 0))),
        codeSpace: data.codespace,
        log: data.log,
        data: (0, $75MVN.may)($5zb9p.fromBase64, data.data),
        events: data.events ? $a9a3471ed8124415$var$decodeEvents(data.events) : [],
        gasWanted: $75MVN.Integer.parse((0, $75MVN.optional)(data.gas_wanted, "0")),
        gasUsed: $75MVN.Integer.parse((0, $75MVN.optional)(data.gas_used, "0"))
    };
}
function $a9a3471ed8124415$var$decodePubkey(data) {
    if ("Sum" in data) {
        // we don't need to check type because we're checking algorithm
        const [[algorithm, value]] = Object.entries(data.Sum.value);
        (0, $F6P8J.assert)(algorithm === "ed25519" || algorithm === "secp256k1", `unknown pubkey type: ${algorithm}`);
        return {
            algorithm: algorithm,
            data: (0, $5zb9p.fromBase64)((0, $75MVN.assertNotEmpty)(value))
        };
    } else switch(data.type){
        // go-amino special code
        case "tendermint/PubKeyEd25519":
            return {
                algorithm: "ed25519",
                data: (0, $5zb9p.fromBase64)((0, $75MVN.assertNotEmpty)(data.value))
            };
        case "tendermint/PubKeySecp256k1":
            return {
                algorithm: "secp256k1",
                data: (0, $5zb9p.fromBase64)((0, $75MVN.assertNotEmpty)(data.value))
            };
        default:
            throw new Error(`unknown pubkey type: ${data.type}`);
    }
}
/**
 * Note: we do not parse block.time_iota_ms for now because of this CHANGELOG entry
 *
 * > Add time_iota_ms to block's consensus parameters (not exposed to the application)
 * https://github.com/tendermint/tendermint/blob/master/CHANGELOG.md#v0310
 */ function $a9a3471ed8124415$var$decodeBlockParams(data) {
    return {
        maxBytes: $75MVN.Integer.parse((0, $75MVN.assertNotEmpty)(data.max_bytes)),
        maxGas: $75MVN.Integer.parse((0, $75MVN.assertNotEmpty)(data.max_gas))
    };
}
function $a9a3471ed8124415$var$decodeEvidenceParams(data) {
    return {
        maxAgeNumBlocks: $75MVN.Integer.parse((0, $75MVN.assertNotEmpty)(data.max_age_num_blocks)),
        maxAgeDuration: $75MVN.Integer.parse((0, $75MVN.assertNotEmpty)(data.max_age_duration))
    };
}
function $a9a3471ed8124415$var$decodeConsensusParams(data) {
    return {
        block: $a9a3471ed8124415$var$decodeBlockParams((0, $75MVN.assertObject)(data.block)),
        evidence: $a9a3471ed8124415$var$decodeEvidenceParams((0, $75MVN.assertObject)(data.evidence))
    };
}
function $a9a3471ed8124415$var$decodeValidatorUpdate(data) {
    var _a;
    return {
        pubkey: $a9a3471ed8124415$var$decodePubkey((0, $75MVN.assertObject)(data.pub_key)),
        votingPower: $75MVN.Integer.parse((_a = data.power) !== null && _a !== void 0 ? _a : 0)
    };
}
module.exports.decodeValidatorUpdate = $a9a3471ed8124415$var$decodeValidatorUpdate;
function $a9a3471ed8124415$var$decodeBlockResults(data) {
    return {
        height: $75MVN.Integer.parse((0, $75MVN.assertNotEmpty)(data.height)),
        results: (data.txs_results || []).map($a9a3471ed8124415$var$decodeTxData),
        validatorUpdates: (data.validator_updates || []).map($a9a3471ed8124415$var$decodeValidatorUpdate),
        consensusUpdates: (0, $75MVN.may)($a9a3471ed8124415$var$decodeConsensusParams, data.consensus_param_updates),
        beginBlockEvents: $a9a3471ed8124415$var$decodeEvents(data.begin_block_events || []),
        endBlockEvents: $a9a3471ed8124415$var$decodeEvents(data.end_block_events || [])
    };
}
function $a9a3471ed8124415$var$decodeBlockId(data) {
    return {
        hash: (0, $5zb9p.fromHex)((0, $75MVN.assertNotEmpty)(data.hash)),
        parts: {
            total: (0, $75MVN.assertNotEmpty)(data.parts.total),
            hash: (0, $5zb9p.fromHex)((0, $75MVN.assertNotEmpty)(data.parts.hash))
        }
    };
}
function $a9a3471ed8124415$var$decodeBlockVersion(data) {
    var _a;
    return {
        block: $75MVN.Integer.parse(data.block),
        app: $75MVN.Integer.parse((_a = data.app) !== null && _a !== void 0 ? _a : 0)
    };
}
function $a9a3471ed8124415$var$decodeHeader(data) {
    return {
        version: $a9a3471ed8124415$var$decodeBlockVersion(data.version),
        chainId: (0, $75MVN.assertNotEmpty)(data.chain_id),
        height: $75MVN.Integer.parse((0, $75MVN.assertNotEmpty)(data.height)),
        time: (0, $aRP0Z.fromRfc3339WithNanoseconds)((0, $75MVN.assertNotEmpty)(data.time)),
        // When there is no last block ID (i.e. this block's height is 1), we get an empty structure like this:
        // { hash: '', parts: { total: 0, hash: '' } }
        lastBlockId: data.last_block_id.hash ? $a9a3471ed8124415$var$decodeBlockId(data.last_block_id) : null,
        lastCommitHash: (0, $5zb9p.fromHex)((0, $75MVN.assertSet)(data.last_commit_hash)),
        dataHash: (0, $5zb9p.fromHex)((0, $75MVN.assertSet)(data.data_hash)),
        validatorsHash: (0, $5zb9p.fromHex)((0, $75MVN.assertSet)(data.validators_hash)),
        nextValidatorsHash: (0, $5zb9p.fromHex)((0, $75MVN.assertSet)(data.next_validators_hash)),
        consensusHash: (0, $5zb9p.fromHex)((0, $75MVN.assertSet)(data.consensus_hash)),
        appHash: (0, $5zb9p.fromHex)((0, $75MVN.assertSet)(data.app_hash)),
        lastResultsHash: (0, $5zb9p.fromHex)((0, $75MVN.assertSet)(data.last_results_hash)),
        evidenceHash: (0, $5zb9p.fromHex)((0, $75MVN.assertSet)(data.evidence_hash)),
        proposerAddress: (0, $5zb9p.fromHex)((0, $75MVN.assertNotEmpty)(data.proposer_address))
    };
}
function $a9a3471ed8124415$var$decodeBlockMeta(data) {
    return {
        blockId: $a9a3471ed8124415$var$decodeBlockId(data.block_id),
        blockSize: $75MVN.Integer.parse((0, $75MVN.assertNotEmpty)(data.block_size)),
        header: $a9a3471ed8124415$var$decodeHeader(data.header),
        numTxs: $75MVN.Integer.parse((0, $75MVN.assertNotEmpty)(data.num_txs))
    };
}
function $a9a3471ed8124415$var$decodeBlockchain(data) {
    return {
        lastHeight: $75MVN.Integer.parse((0, $75MVN.assertNotEmpty)(data.last_height)),
        blockMetas: (0, $75MVN.assertArray)(data.block_metas).map($a9a3471ed8124415$var$decodeBlockMeta)
    };
}
function $a9a3471ed8124415$var$decodeBroadcastTxSync(data) {
    return {
        ...$a9a3471ed8124415$var$decodeTxData(data),
        hash: (0, $5zb9p.fromHex)((0, $75MVN.assertNotEmpty)(data.hash))
    };
}
function $a9a3471ed8124415$var$decodeBroadcastTxCommit(data) {
    return {
        height: $75MVN.Integer.parse(data.height),
        hash: (0, $5zb9p.fromHex)((0, $75MVN.assertNotEmpty)(data.hash)),
        checkTx: $a9a3471ed8124415$var$decodeTxData((0, $75MVN.assertObject)(data.check_tx)),
        deliverTx: (0, $75MVN.may)($a9a3471ed8124415$var$decodeTxData, data.deliver_tx)
    };
}
function $a9a3471ed8124415$var$decodeBlockIdFlag(blockIdFlag) {
    (0, $F6P8J.assert)(blockIdFlag in $lfB3U.BlockIdFlag);
    return blockIdFlag;
}
/**
 * In some cases a timestamp is optional and set to the value 0 in Go.
 * This can lead to strings like "0001-01-01T00:00:00Z" (see https://github.com/cosmos/cosmjs/issues/704#issuecomment-797122415).
 * This decoder tries to clean up such encoding from the API and turn them
 * into undefined values.
 */ function $a9a3471ed8124415$var$decodeOptionalTime(timestamp) {
    const nonZeroTime = timestamp && !timestamp.startsWith("0001-01-01");
    return nonZeroTime ? (0, $aRP0Z.fromRfc3339WithNanoseconds)(timestamp) : undefined;
}
function $a9a3471ed8124415$var$decodeCommitSignature(data) {
    return {
        blockIdFlag: $a9a3471ed8124415$var$decodeBlockIdFlag(data.block_id_flag),
        validatorAddress: data.validator_address ? (0, $5zb9p.fromHex)(data.validator_address) : undefined,
        timestamp: $a9a3471ed8124415$var$decodeOptionalTime(data.timestamp),
        signature: data.signature ? (0, $5zb9p.fromBase64)(data.signature) : undefined
    };
}
function $a9a3471ed8124415$var$decodeCommit(data) {
    return {
        blockId: $a9a3471ed8124415$var$decodeBlockId((0, $75MVN.assertObject)(data.block_id)),
        height: $75MVN.Integer.parse((0, $75MVN.assertNotEmpty)(data.height)),
        round: $75MVN.Integer.parse(data.round),
        signatures: (0, $75MVN.assertArray)(data.signatures).map($a9a3471ed8124415$var$decodeCommitSignature)
    };
}
function $a9a3471ed8124415$var$decodeCommitResponse(data) {
    return {
        canonical: (0, $75MVN.assertBoolean)(data.canonical),
        header: $a9a3471ed8124415$var$decodeHeader(data.signed_header.header),
        commit: $a9a3471ed8124415$var$decodeCommit(data.signed_header.commit)
    };
}
function $a9a3471ed8124415$var$decodeValidatorGenesis(data) {
    return {
        address: (0, $5zb9p.fromHex)((0, $75MVN.assertNotEmpty)(data.address)),
        pubkey: $a9a3471ed8124415$var$decodePubkey((0, $75MVN.assertObject)(data.pub_key)),
        votingPower: $75MVN.Integer.parse((0, $75MVN.assertNotEmpty)(data.power))
    };
}
module.exports.decodeValidatorGenesis = $a9a3471ed8124415$var$decodeValidatorGenesis;
function $a9a3471ed8124415$var$decodeGenesis(data) {
    return {
        genesisTime: (0, $aRP0Z.fromRfc3339WithNanoseconds)((0, $75MVN.assertNotEmpty)(data.genesis_time)),
        chainId: (0, $75MVN.assertNotEmpty)(data.chain_id),
        consensusParams: $a9a3471ed8124415$var$decodeConsensusParams(data.consensus_params),
        validators: data.validators ? (0, $75MVN.assertArray)(data.validators).map($a9a3471ed8124415$var$decodeValidatorGenesis) : [],
        appHash: (0, $5zb9p.fromHex)((0, $75MVN.assertSet)(data.app_hash)),
        appState: data.app_state
    };
}
function $a9a3471ed8124415$var$decodeValidatorInfo(data) {
    return {
        pubkey: $a9a3471ed8124415$var$decodePubkey((0, $75MVN.assertObject)(data.pub_key)),
        votingPower: $75MVN.Integer.parse((0, $75MVN.assertNotEmpty)(data.voting_power)),
        address: (0, $5zb9p.fromHex)((0, $75MVN.assertNotEmpty)(data.address)),
        proposerPriority: data.proposer_priority ? $75MVN.Integer.parse(data.proposer_priority) : undefined
    };
}
module.exports.decodeValidatorInfo = $a9a3471ed8124415$var$decodeValidatorInfo;
function $a9a3471ed8124415$var$decodeNodeInfo(data) {
    return {
        id: (0, $5zb9p.fromHex)((0, $75MVN.assertNotEmpty)(data.id)),
        listenAddr: (0, $75MVN.assertNotEmpty)(data.listen_addr),
        network: (0, $75MVN.assertNotEmpty)(data.network),
        version: (0, $75MVN.assertString)(data.version),
        channels: (0, $75MVN.assertNotEmpty)(data.channels),
        moniker: (0, $75MVN.assertNotEmpty)(data.moniker),
        other: (0, $75MVN.dictionaryToStringMap)(data.other),
        protocolVersion: {
            app: $75MVN.Integer.parse((0, $75MVN.assertNotEmpty)(data.protocol_version.app)),
            block: $75MVN.Integer.parse((0, $75MVN.assertNotEmpty)(data.protocol_version.block)),
            p2p: $75MVN.Integer.parse((0, $75MVN.assertNotEmpty)(data.protocol_version.p2p))
        }
    };
}
function $a9a3471ed8124415$var$decodeSyncInfo(data) {
    return {
        latestBlockHash: (0, $5zb9p.fromHex)((0, $75MVN.assertNotEmpty)(data.latest_block_hash)),
        latestAppHash: (0, $5zb9p.fromHex)((0, $75MVN.assertNotEmpty)(data.latest_app_hash)),
        latestBlockTime: (0, $aRP0Z.fromRfc3339WithNanoseconds)((0, $75MVN.assertNotEmpty)(data.latest_block_time)),
        latestBlockHeight: $75MVN.Integer.parse((0, $75MVN.assertNotEmpty)(data.latest_block_height)),
        catchingUp: (0, $75MVN.assertBoolean)(data.catching_up)
    };
}
function $a9a3471ed8124415$var$decodeStatus(data) {
    return {
        nodeInfo: $a9a3471ed8124415$var$decodeNodeInfo(data.node_info),
        syncInfo: $a9a3471ed8124415$var$decodeSyncInfo(data.sync_info),
        validatorInfo: $a9a3471ed8124415$var$decodeValidatorInfo(data.validator_info)
    };
}
function $a9a3471ed8124415$var$decodeTxProof(data) {
    return {
        data: (0, $5zb9p.fromBase64)((0, $75MVN.assertNotEmpty)(data.data)),
        rootHash: (0, $5zb9p.fromHex)((0, $75MVN.assertNotEmpty)(data.root_hash)),
        proof: {
            total: $75MVN.Integer.parse((0, $75MVN.assertNotEmpty)(data.proof.total)),
            index: $75MVN.Integer.parse((0, $75MVN.assertNotEmpty)(data.proof.index)),
            leafHash: (0, $5zb9p.fromBase64)((0, $75MVN.assertNotEmpty)(data.proof.leaf_hash)),
            aunts: (0, $75MVN.assertArray)(data.proof.aunts).map($5zb9p.fromBase64)
        }
    };
}
function $a9a3471ed8124415$var$decodeTxResponse(data) {
    return {
        tx: (0, $5zb9p.fromBase64)((0, $75MVN.assertNotEmpty)(data.tx)),
        result: $a9a3471ed8124415$var$decodeTxData((0, $75MVN.assertObject)(data.tx_result)),
        height: $75MVN.Integer.parse((0, $75MVN.assertNotEmpty)(data.height)),
        index: $75MVN.Integer.parse((0, $75MVN.assertNumber)(data.index)),
        hash: (0, $5zb9p.fromHex)((0, $75MVN.assertNotEmpty)(data.hash)),
        proof: (0, $75MVN.may)($a9a3471ed8124415$var$decodeTxProof, data.proof)
    };
}
function $a9a3471ed8124415$var$decodeTxSearch(data) {
    return {
        totalCount: $75MVN.Integer.parse((0, $75MVN.assertNotEmpty)(data.total_count)),
        txs: (0, $75MVN.assertArray)(data.txs).map($a9a3471ed8124415$var$decodeTxResponse)
    };
}
function $a9a3471ed8124415$var$decodeTxEvent(data) {
    const tx = (0, $5zb9p.fromBase64)((0, $75MVN.assertNotEmpty)(data.tx));
    return {
        tx: tx,
        hash: (0, $i2CZI.hashTx)(tx),
        result: $a9a3471ed8124415$var$decodeTxData(data.result),
        height: $75MVN.Integer.parse((0, $75MVN.assertNotEmpty)(data.height)),
        index: (0, $75MVN.may)($75MVN.Integer.parse, data.index)
    };
}
function $a9a3471ed8124415$var$decodeValidators(data) {
    return {
        blockHeight: $75MVN.Integer.parse((0, $75MVN.assertNotEmpty)(data.block_height)),
        validators: (0, $75MVN.assertArray)(data.validators).map($a9a3471ed8124415$var$decodeValidatorInfo),
        count: $75MVN.Integer.parse((0, $75MVN.assertNotEmpty)(data.count)),
        total: $75MVN.Integer.parse((0, $75MVN.assertNotEmpty)(data.total))
    };
}
function $a9a3471ed8124415$var$decodeBlock(data) {
    var _a, _b;
    return {
        header: $a9a3471ed8124415$var$decodeHeader((0, $75MVN.assertObject)(data.header)),
        // For the block at height 1, last commit is not set. This is represented in an empty object like this:
        // { height: '0', round: 0, block_id: { hash: '', parts: [Object] }, signatures: [] }
        lastCommit: data.last_commit.block_id.hash ? $a9a3471ed8124415$var$decodeCommit((0, $75MVN.assertObject)(data.last_commit)) : null,
        txs: data.data.txs ? (0, $75MVN.assertArray)(data.data.txs).map($5zb9p.fromBase64) : [],
        // Lift up .evidence.evidence to just .evidence
        // See https://github.com/tendermint/tendermint/issues/7697
        evidence: (_b = (_a = data.evidence) === null || _a === void 0 ? void 0 : _a.evidence) !== null && _b !== void 0 ? _b : []
    };
}
function $a9a3471ed8124415$var$decodeBlockResponse(data) {
    return {
        blockId: $a9a3471ed8124415$var$decodeBlockId(data.block_id),
        block: $a9a3471ed8124415$var$decodeBlock(data.block)
    };
}
function $a9a3471ed8124415$var$decodeBlockSearch(data) {
    return {
        totalCount: $75MVN.Integer.parse((0, $75MVN.assertNotEmpty)(data.total_count)),
        blocks: (0, $75MVN.assertArray)(data.blocks).map($a9a3471ed8124415$var$decodeBlockResponse)
    };
}
function $a9a3471ed8124415$var$decodeNumUnconfirmedTxs(data) {
    return {
        total: $75MVN.Integer.parse((0, $75MVN.assertNotEmpty)(data.total)),
        totalBytes: $75MVN.Integer.parse((0, $75MVN.assertNotEmpty)(data.total_bytes))
    };
}
class $a9a3471ed8124415$var$Responses {
    static decodeAbciInfo(response) {
        return $a9a3471ed8124415$var$decodeAbciInfo((0, $75MVN.assertObject)(response.result.response));
    }
    static decodeAbciQuery(response) {
        return $a9a3471ed8124415$var$decodeAbciQuery((0, $75MVN.assertObject)(response.result.response));
    }
    static decodeBlock(response) {
        return $a9a3471ed8124415$var$decodeBlockResponse(response.result);
    }
    static decodeBlockResults(response) {
        return $a9a3471ed8124415$var$decodeBlockResults(response.result);
    }
    static decodeBlockSearch(response) {
        return $a9a3471ed8124415$var$decodeBlockSearch(response.result);
    }
    static decodeBlockchain(response) {
        return $a9a3471ed8124415$var$decodeBlockchain(response.result);
    }
    static decodeBroadcastTxSync(response) {
        return $a9a3471ed8124415$var$decodeBroadcastTxSync(response.result);
    }
    static decodeBroadcastTxAsync(response) {
        return $a9a3471ed8124415$var$Responses.decodeBroadcastTxSync(response);
    }
    static decodeBroadcastTxCommit(response) {
        return $a9a3471ed8124415$var$decodeBroadcastTxCommit(response.result);
    }
    static decodeCommit(response) {
        return $a9a3471ed8124415$var$decodeCommitResponse(response.result);
    }
    static decodeGenesis(response) {
        return $a9a3471ed8124415$var$decodeGenesis((0, $75MVN.assertObject)(response.result.genesis));
    }
    static decodeHealth() {
        return null;
    }
    static decodeNumUnconfirmedTxs(response) {
        return $a9a3471ed8124415$var$decodeNumUnconfirmedTxs(response.result);
    }
    static decodeStatus(response) {
        return $a9a3471ed8124415$var$decodeStatus(response.result);
    }
    static decodeNewBlockEvent(event) {
        return $a9a3471ed8124415$var$decodeBlock(event.data.value.block);
    }
    static decodeNewBlockHeaderEvent(event) {
        return $a9a3471ed8124415$var$decodeHeader(event.data.value.header);
    }
    static decodeTxEvent(event) {
        return $a9a3471ed8124415$var$decodeTxEvent(event.data.value.TxResult);
    }
    static decodeTx(response) {
        return $a9a3471ed8124415$var$decodeTxResponse(response.result);
    }
    static decodeTxSearch(response) {
        return $a9a3471ed8124415$var$decodeTxSearch(response.result);
    }
    static decodeValidators(response) {
        return $a9a3471ed8124415$var$decodeValidators(response.result);
    }
}
module.exports.Responses = $a9a3471ed8124415$var$Responses;

});
parcelRegister("aRP0Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DateTime = module.exports.toSeconds = module.exports.fromSeconds = module.exports.toRfc3339WithNanoseconds = module.exports.fromRfc3339WithNanoseconds = void 0;

var $5zb9p = parcelRequire("5zb9p");

var $9YIif = parcelRequire("9YIif");
function $7e966d23ec530937$var$fromRfc3339WithNanoseconds(dateTimeString) {
    const out = (0, $5zb9p.fromRfc3339)(dateTimeString);
    const nanosecondsMatch = dateTimeString.match(/\.(\d+)Z$/);
    const nanoseconds = nanosecondsMatch ? nanosecondsMatch[1].slice(3) : "";
    out.nanoseconds = parseInt(nanoseconds.padEnd(6, "0"), 10);
    return out;
}
module.exports.fromRfc3339WithNanoseconds = $7e966d23ec530937$var$fromRfc3339WithNanoseconds;
function $7e966d23ec530937$var$toRfc3339WithNanoseconds(dateTime) {
    var _a, _b;
    const millisecondIso = dateTime.toISOString();
    const nanoseconds = (_b = (_a = dateTime.nanoseconds) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : "";
    return `${millisecondIso.slice(0, -1)}${nanoseconds.padStart(6, "0")}Z`;
}
module.exports.toRfc3339WithNanoseconds = $7e966d23ec530937$var$toRfc3339WithNanoseconds;
function $7e966d23ec530937$var$fromSeconds(seconds, nanos = 0) {
    const checkedNanos = new $9YIif.Uint32(nanos).toNumber();
    if (checkedNanos > 999999999) throw new Error("Nano seconds must not exceed 999999999");
    const out = new Date(seconds * 1000 + Math.floor(checkedNanos / 1000000));
    out.nanoseconds = checkedNanos % 1000000;
    return out;
}
module.exports.fromSeconds = $7e966d23ec530937$var$fromSeconds;
/**
 * Calculates the UNIX timestamp in seconds as well as the nanoseconds after the given second.
 *
 * This is useful when dealing with external systems like the protobuf type
 * [.google.protobuf.Timestamp](https://developers.google.com/protocol-buffers/docs/reference/google.protobuf#google.protobuf.Timestamp)
 * or any other system that does not use millisecond precision.
 */ function $7e966d23ec530937$var$toSeconds(date) {
    var _a;
    return {
        seconds: Math.floor(date.getTime() / 1000),
        nanos: date.getTime() % 1000 * 1000000 + ((_a = date.nanoseconds) !== null && _a !== void 0 ? _a : 0)
    };
}
module.exports.toSeconds = $7e966d23ec530937$var$toSeconds;
/** @deprecated Use fromRfc3339WithNanoseconds/toRfc3339WithNanoseconds instead */ class $7e966d23ec530937$var$DateTime {
    /** @deprecated Use fromRfc3339WithNanoseconds instead */ static decode(dateTimeString) {
        return $7e966d23ec530937$var$fromRfc3339WithNanoseconds(dateTimeString);
    }
    /** @deprecated Use toRfc3339WithNanoseconds instead */ static encode(dateTime) {
        return $7e966d23ec530937$var$toRfc3339WithNanoseconds(dateTime);
    }
}
module.exports.DateTime = $7e966d23ec530937$var$DateTime;

});

parcelRegister("lfB3U", function(module, exports) {
"use strict";
// Types in this file are exported outside of the @cosmjs/tendermint-rpc package,
// e.g. as part of a request or response
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlockIdFlag = void 0;
var $f787bf6f925e8aea$var$BlockIdFlag;
(function(BlockIdFlag) {
    BlockIdFlag[BlockIdFlag["Unknown"] = 0] = "Unknown";
    BlockIdFlag[BlockIdFlag["Absent"] = 1] = "Absent";
    BlockIdFlag[BlockIdFlag["Commit"] = 2] = "Commit";
    BlockIdFlag[BlockIdFlag["Nil"] = 3] = "Nil";
    BlockIdFlag[BlockIdFlag["Unrecognized"] = -1] = "Unrecognized";
})($f787bf6f925e8aea$var$BlockIdFlag = module.exports.BlockIdFlag || (module.exports.BlockIdFlag = {}));

});





parcelRegister("hjpZr", function(module, exports) {
"use strict";

var $5RN2x = parcelRequire("5RN2x");

var $fsZzp = parcelRequire("fsZzp");

var $i7HGk = parcelRequire("i7HGk");

var $1JsgI = parcelRequire("1JsgI");

var $l9ONg = parcelRequire("l9ONg");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $c9a85f19e57c70f8$var$createInstance(defaultConfig) {
    var context = new $i7HGk(defaultConfig);
    var instance = $fsZzp($i7HGk.prototype.request, context);
    // Copy axios.prototype to instance
    $5RN2x.extend(instance, $i7HGk.prototype, context);
    // Copy context to instance
    $5RN2x.extend(instance, context);
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $c9a85f19e57c70f8$var$createInstance($1JsgI(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $c9a85f19e57c70f8$var$axios = $c9a85f19e57c70f8$var$createInstance($l9ONg);
// Expose Axios class to allow class inheritance
$c9a85f19e57c70f8$var$axios.Axios = $i7HGk;

// Expose Cancel & CancelToken
$c9a85f19e57c70f8$var$axios.Cancel = (parcelRequire("kDIL6"));

$c9a85f19e57c70f8$var$axios.CancelToken = (parcelRequire("hku8v"));

$c9a85f19e57c70f8$var$axios.isCancel = (parcelRequire("89Krh"));

$c9a85f19e57c70f8$var$axios.VERSION = (parcelRequire("14YCA")).version;
// Expose all/spread
$c9a85f19e57c70f8$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$c9a85f19e57c70f8$var$axios.spread = (parcelRequire("hvvj9"));

// Expose isAxiosError
$c9a85f19e57c70f8$var$axios.isAxiosError = (parcelRequire("6bEux"));
module.exports = $c9a85f19e57c70f8$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $c9a85f19e57c70f8$var$axios;

});
parcelRegister("5RN2x", function(module, exports) {
"use strict";

var $fsZzp = parcelRequire("fsZzp");
// utils is a library of generic helper functions non-specific to axios
var $4457f145f4fd6a49$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $4457f145f4fd6a49$var$isArray(val) {
    return Array.isArray(val);
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $4457f145f4fd6a49$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $4457f145f4fd6a49$var$isBuffer(val) {
    return val !== null && !$4457f145f4fd6a49$var$isUndefined(val) && val.constructor !== null && !$4457f145f4fd6a49$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $4457f145f4fd6a49$var$isArrayBuffer(val) {
    return $4457f145f4fd6a49$var$toString.call(val) === "[object ArrayBuffer]";
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $4457f145f4fd6a49$var$isFormData(val) {
    return $4457f145f4fd6a49$var$toString.call(val) === "[object FormData]";
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $4457f145f4fd6a49$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $4457f145f4fd6a49$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $4457f145f4fd6a49$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $4457f145f4fd6a49$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $4457f145f4fd6a49$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $4457f145f4fd6a49$var$isPlainObject(val) {
    if ($4457f145f4fd6a49$var$toString.call(val) !== "[object Object]") return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $4457f145f4fd6a49$var$isDate(val) {
    return $4457f145f4fd6a49$var$toString.call(val) === "[object Date]";
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $4457f145f4fd6a49$var$isFile(val) {
    return $4457f145f4fd6a49$var$toString.call(val) === "[object File]";
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $4457f145f4fd6a49$var$isBlob(val) {
    return $4457f145f4fd6a49$var$toString.call(val) === "[object Blob]";
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $4457f145f4fd6a49$var$isFunction(val) {
    return $4457f145f4fd6a49$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $4457f145f4fd6a49$var$isStream(val) {
    return $4457f145f4fd6a49$var$isObject(val) && $4457f145f4fd6a49$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $4457f145f4fd6a49$var$isURLSearchParams(val) {
    return $4457f145f4fd6a49$var$toString.call(val) === "[object URLSearchParams]";
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $4457f145f4fd6a49$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $4457f145f4fd6a49$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $4457f145f4fd6a49$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($4457f145f4fd6a49$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $4457f145f4fd6a49$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($4457f145f4fd6a49$var$isPlainObject(result[key]) && $4457f145f4fd6a49$var$isPlainObject(val)) result[key] = $4457f145f4fd6a49$var$merge(result[key], val);
        else if ($4457f145f4fd6a49$var$isPlainObject(val)) result[key] = $4457f145f4fd6a49$var$merge({}, val);
        else if ($4457f145f4fd6a49$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$4457f145f4fd6a49$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $4457f145f4fd6a49$var$extend(a, b, thisArg) {
    $4457f145f4fd6a49$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $fsZzp(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $4457f145f4fd6a49$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $4457f145f4fd6a49$var$isArray,
    isArrayBuffer: $4457f145f4fd6a49$var$isArrayBuffer,
    isBuffer: $4457f145f4fd6a49$var$isBuffer,
    isFormData: $4457f145f4fd6a49$var$isFormData,
    isArrayBufferView: $4457f145f4fd6a49$var$isArrayBufferView,
    isString: $4457f145f4fd6a49$var$isString,
    isNumber: $4457f145f4fd6a49$var$isNumber,
    isObject: $4457f145f4fd6a49$var$isObject,
    isPlainObject: $4457f145f4fd6a49$var$isPlainObject,
    isUndefined: $4457f145f4fd6a49$var$isUndefined,
    isDate: $4457f145f4fd6a49$var$isDate,
    isFile: $4457f145f4fd6a49$var$isFile,
    isBlob: $4457f145f4fd6a49$var$isBlob,
    isFunction: $4457f145f4fd6a49$var$isFunction,
    isStream: $4457f145f4fd6a49$var$isStream,
    isURLSearchParams: $4457f145f4fd6a49$var$isURLSearchParams,
    isStandardBrowserEnv: $4457f145f4fd6a49$var$isStandardBrowserEnv,
    forEach: $4457f145f4fd6a49$var$forEach,
    merge: $4457f145f4fd6a49$var$merge,
    extend: $4457f145f4fd6a49$var$extend,
    trim: $4457f145f4fd6a49$var$trim,
    stripBOM: $4457f145f4fd6a49$var$stripBOM
};

});
parcelRegister("fsZzp", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("i7HGk", function(module, exports) {
"use strict";

var $5RN2x = parcelRequire("5RN2x");

var $1BRyf = parcelRequire("1BRyf");

var $hm5Wj = parcelRequire("hm5Wj");

var $2n9mB = parcelRequire("2n9mB");

var $1JsgI = parcelRequire("1JsgI");

var $1P3Mn = parcelRequire("1P3Mn");
var $d31ac3bc8d454bec$var$validators = $1P3Mn.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $d31ac3bc8d454bec$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $hm5Wj(),
        response: new $hm5Wj()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $d31ac3bc8d454bec$var$Axios.prototype.request = function request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === "string") {
        config = config || {};
        config.url = configOrUrl;
    } else config = configOrUrl || {};
    config = $1JsgI(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    var transitional = config.transitional;
    if (transitional !== undefined) $1P3Mn.assertOptions(transitional, {
        silentJSONParsing: $d31ac3bc8d454bec$var$validators.transitional($d31ac3bc8d454bec$var$validators.boolean),
        forcedJSONParsing: $d31ac3bc8d454bec$var$validators.transitional($d31ac3bc8d454bec$var$validators.boolean),
        clarifyTimeoutError: $d31ac3bc8d454bec$var$validators.transitional($d31ac3bc8d454bec$var$validators.boolean)
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $2n9mB,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $2n9mB(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$d31ac3bc8d454bec$var$Axios.prototype.getUri = function getUri(config) {
    config = $1JsgI(this.defaults, config);
    return $1BRyf(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
// Provide aliases for supported request methods
$5RN2x.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $d31ac3bc8d454bec$var$Axios.prototype[method] = function(url, config) {
        return this.request($1JsgI(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$5RN2x.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $d31ac3bc8d454bec$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($1JsgI(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $d31ac3bc8d454bec$var$Axios;

});
parcelRegister("1BRyf", function(module, exports) {
"use strict";

var $5RN2x = parcelRequire("5RN2x");
function $12c2c95c1ed3c980$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($5RN2x.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $5RN2x.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($5RN2x.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $5RN2x.forEach(val, function parseValue(v) {
                if ($5RN2x.isDate(v)) v = v.toISOString();
                else if ($5RN2x.isObject(v)) v = JSON.stringify(v);
                parts.push($12c2c95c1ed3c980$var$encode(key) + "=" + $12c2c95c1ed3c980$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

});

parcelRegister("hm5Wj", function(module, exports) {
"use strict";

var $5RN2x = parcelRequire("5RN2x");
function $ca291930ae00924d$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $ca291930ae00924d$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $ca291930ae00924d$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $ca291930ae00924d$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $5RN2x.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $ca291930ae00924d$var$InterceptorManager;

});

parcelRegister("2n9mB", function(module, exports) {
"use strict";

var $5RN2x = parcelRequire("5RN2x");

var $3HPYp = parcelRequire("3HPYp");

var $89Krh = parcelRequire("89Krh");

var $l9ONg = parcelRequire("l9ONg");

var $kDIL6 = parcelRequire("kDIL6");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $1ba4fe270146b4e2$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new $kDIL6("canceled");
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $1ba4fe270146b4e2$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $3HPYp.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $5RN2x.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $5RN2x.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $l9ONg.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $1ba4fe270146b4e2$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $3HPYp.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$89Krh(reason)) {
            $1ba4fe270146b4e2$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $3HPYp.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("3HPYp", function(module, exports) {
"use strict";

var $5RN2x = parcelRequire("5RN2x");

var $l9ONg = parcelRequire("l9ONg");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $l9ONg;
    /*eslint no-param-reassign:0*/ $5RN2x.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRegister("l9ONg", function(module, exports) {

var $a8i8g = parcelRequire("a8i8g");
"use strict";

var $5RN2x = parcelRequire("5RN2x");

var $2cvcr = parcelRequire("2cvcr");

var $kxKdp = parcelRequire("kxKdp");

var $aqkjV = parcelRequire("aqkjV");
var $f671d6c34fc96548$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $f671d6c34fc96548$var$setContentTypeIfUnset(headers, value) {
    if (!$5RN2x.isUndefined(headers) && $5RN2x.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $f671d6c34fc96548$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("JCH7L"));
    else if (typeof $a8i8g !== "undefined" && Object.prototype.toString.call($a8i8g) === "[object process]") // For node use HTTP adapter
    adapter = (parcelRequire("JCH7L"));
    return adapter;
}
function $f671d6c34fc96548$var$stringifySafely(rawValue, parser, encoder) {
    if ($5RN2x.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $5RN2x.trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $f671d6c34fc96548$var$defaults = {
    transitional: $aqkjV,
    adapter: $f671d6c34fc96548$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $2cvcr(headers, "Accept");
            $2cvcr(headers, "Content-Type");
            if ($5RN2x.isFormData(data) || $5RN2x.isArrayBuffer(data) || $5RN2x.isBuffer(data) || $5RN2x.isStream(data) || $5RN2x.isFile(data) || $5RN2x.isBlob(data)) return data;
            if ($5RN2x.isArrayBufferView(data)) return data.buffer;
            if ($5RN2x.isURLSearchParams(data)) {
                $f671d6c34fc96548$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            if ($5RN2x.isObject(data) || headers && headers["Content-Type"] === "application/json") {
                $f671d6c34fc96548$var$setContentTypeIfUnset(headers, "application/json");
                return $f671d6c34fc96548$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || $f671d6c34fc96548$var$defaults.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
            if (strictJSONParsing || forcedJSONParsing && $5RN2x.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === "SyntaxError") throw $kxKdp(e, this, "E_JSON_PARSE");
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*"
        }
    }
};
$5RN2x.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $f671d6c34fc96548$var$defaults.headers[method] = {};
});
$5RN2x.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $f671d6c34fc96548$var$defaults.headers[method] = $5RN2x.merge($f671d6c34fc96548$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $f671d6c34fc96548$var$defaults;

});
parcelRegister("2cvcr", function(module, exports) {
"use strict";

var $5RN2x = parcelRequire("5RN2x");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $5RN2x.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("kxKdp", function(module, exports) {
"use strict";
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    };
    return error;
};

});

parcelRegister("aqkjV", function(module, exports) {
"use strict";
module.exports = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRegister("JCH7L", function(module, exports) {
"use strict";

var $5RN2x = parcelRequire("5RN2x");

var $fhocg = parcelRequire("fhocg");

var $bd2wb = parcelRequire("bd2wb");

var $1BRyf = parcelRequire("1BRyf");

var $7lViM = parcelRequire("7lViM");

var $d9FXx = parcelRequire("d9FXx");

var $3TcEI = parcelRequire("3TcEI");

var $321Gd = parcelRequire("321Gd");

var $aqkjV = parcelRequire("aqkjV");

var $kDIL6 = parcelRequire("kDIL6");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        if ($5RN2x.isFormData(requestData)) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = $7lViM(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $1BRyf(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $d9FXx(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $fhocg(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($321Gd("Request aborted", config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($321Gd("Network Error", config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            var transitional = config.transitional || $aqkjV;
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($321Gd(timeoutErrorMessage, config, transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($5RN2x.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $3TcEI(fullPath)) && config.xsrfCookieName ? $bd2wb.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $5RN2x.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$5RN2x.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function(cancel) {
                if (!request) return;
                reject(!cancel || cancel && cancel.type ? new $kDIL6("canceled") : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("fhocg", function(module, exports) {
"use strict";

var $321Gd = parcelRequire("321Gd");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($321Gd("Request failed with status code " + response.status, response.config, null, response.request, response));
};

});
parcelRegister("321Gd", function(module, exports) {
"use strict";

var $kxKdp = parcelRequire("kxKdp");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $kxKdp(error, config, code, request, response);
};

});


parcelRegister("bd2wb", function(module, exports) {
"use strict";

var $5RN2x = parcelRequire("5RN2x");
module.exports = $5RN2x.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($5RN2x.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($5RN2x.isString(path)) cookie.push("path=" + path);
            if ($5RN2x.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("7lViM", function(module, exports) {
"use strict";

var $j3J1d = parcelRequire("j3J1d");

var $5G723 = parcelRequire("5G723");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$j3J1d(requestedURL)) return $5G723(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("j3J1d", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};

});

parcelRegister("5G723", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});


parcelRegister("d9FXx", function(module, exports) {
"use strict";

var $5RN2x = parcelRequire("5RN2x");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $993ca9e2d6767cd4$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $5RN2x.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $5RN2x.trim(line.substr(0, i)).toLowerCase();
        val = $5RN2x.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $993ca9e2d6767cd4$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("3TcEI", function(module, exports) {
"use strict";

var $5RN2x = parcelRequire("5RN2x");
module.exports = $5RN2x.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $5RN2x.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("kDIL6", function(module, exports) {
"use strict";
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $f06a2b4e99967635$var$Cancel(message) {
    this.message = message;
}
$f06a2b4e99967635$var$Cancel.prototype.toString = function toString() {
    return "Cancel" + (this.message ? ": " + this.message : "");
};
$f06a2b4e99967635$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $f06a2b4e99967635$var$Cancel;

});




parcelRegister("89Krh", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRegister("1JsgI", function(module, exports) {
"use strict";

var $5RN2x = parcelRequire("5RN2x");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    function getMergedValue(target, source) {
        if ($5RN2x.isPlainObject(target) && $5RN2x.isPlainObject(source)) return $5RN2x.merge(target, source);
        else if ($5RN2x.isPlainObject(source)) return $5RN2x.merge({}, source);
        else if ($5RN2x.isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(prop) {
        if (!$5RN2x.isUndefined(config2[prop])) return getMergedValue(config1[prop], config2[prop]);
        else if (!$5RN2x.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(prop) {
        if (!$5RN2x.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(prop) {
        if (!$5RN2x.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
        else if (!$5RN2x.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(prop) {
        if (prop in config2) return getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) return getMergedValue(undefined, config1[prop]);
    }
    var mergeMap = {
        "url": valueFromConfig2,
        "method": valueFromConfig2,
        "data": valueFromConfig2,
        "baseURL": defaultToConfig2,
        "transformRequest": defaultToConfig2,
        "transformResponse": defaultToConfig2,
        "paramsSerializer": defaultToConfig2,
        "timeout": defaultToConfig2,
        "timeoutMessage": defaultToConfig2,
        "withCredentials": defaultToConfig2,
        "adapter": defaultToConfig2,
        "responseType": defaultToConfig2,
        "xsrfCookieName": defaultToConfig2,
        "xsrfHeaderName": defaultToConfig2,
        "onUploadProgress": defaultToConfig2,
        "onDownloadProgress": defaultToConfig2,
        "decompress": defaultToConfig2,
        "maxContentLength": defaultToConfig2,
        "maxBodyLength": defaultToConfig2,
        "transport": defaultToConfig2,
        "httpAgent": defaultToConfig2,
        "httpsAgent": defaultToConfig2,
        "cancelToken": defaultToConfig2,
        "socketPath": defaultToConfig2,
        "responseEncoding": defaultToConfig2,
        "validateStatus": mergeDirectKeys
    };
    $5RN2x.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        $5RN2x.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
};

});

parcelRegister("1P3Mn", function(module, exports) {
"use strict";

var $14YCA = parcelRequire("14YCA");
var $153d7c57f809624c$require$VERSION = $14YCA.version;
var $153d7c57f809624c$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach(function(type, i) {
    $153d7c57f809624c$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
var $153d7c57f809624c$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */ $153d7c57f809624c$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + $153d7c57f809624c$require$VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new Error(formatMessage(opt, " has been removed" + (version ? " in " + version : "")));
        if (version && !$153d7c57f809624c$var$deprecatedWarnings[opt]) {
            $153d7c57f809624c$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $153d7c57f809624c$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new TypeError("options must be an object");
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new TypeError("option " + opt + " must be " + result);
            continue;
        }
        if (allowUnknown !== true) throw Error("Unknown option " + opt);
    }
}
module.exports = {
    assertOptions: $153d7c57f809624c$var$assertOptions,
    validators: $153d7c57f809624c$var$validators
};

});
parcelRegister("14YCA", function(module, exports) {
module.exports = {
    "version": "0.26.1"
};

});



parcelRegister("hku8v", function(module, exports) {
"use strict";

var $kDIL6 = parcelRequire("kDIL6");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $c9dbae5aa50ec7c7$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    // eslint-disable-next-line func-names
    this.promise.then(function(cancel) {
        if (!token._listeners) return;
        var i;
        var l = token._listeners.length;
        for(i = 0; i < l; i++)token._listeners[i](cancel);
        token._listeners = null;
    });
    // eslint-disable-next-line func-names
    this.promise.then = function(onfulfilled) {
        var _resolve;
        // eslint-disable-next-line func-names
        var promise = new Promise(function(resolve) {
            token.subscribe(resolve);
            _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
            token.unsubscribe(_resolve);
        };
        return promise;
    };
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $kDIL6(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $c9dbae5aa50ec7c7$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Subscribe to the cancel signal
 */ $c9dbae5aa50ec7c7$var$CancelToken.prototype.subscribe = function subscribe(listener) {
    if (this.reason) {
        listener(this.reason);
        return;
    }
    if (this._listeners) this._listeners.push(listener);
    else this._listeners = [
        listener
    ];
};
/**
 * Unsubscribe from the cancel signal
 */ $c9dbae5aa50ec7c7$var$CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
    if (!this._listeners) return;
    var index = this._listeners.indexOf(listener);
    if (index !== -1) this._listeners.splice(index, 1);
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $c9dbae5aa50ec7c7$var$CancelToken.source = function source() {
    var cancel;
    var token = new $c9dbae5aa50ec7c7$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $c9dbae5aa50ec7c7$var$CancelToken;

});

parcelRegister("hvvj9", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("6bEux", function(module, exports) {
"use strict";

var $5RN2x = parcelRequire("5RN2x");
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return $5RN2x.isObject(payload) && payload.isAxiosError === true;
};

});


parcelRegister("2KWqD", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = "";
                    if (typeof arguments[i] === "object") {
                        arg += "\n[" + i + "] ";
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
            return tok;
        }).join("");
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: "date",
        dates: "date",
        date: "date",
        d: "day",
        days: "day",
        day: "day",
        e: "weekday",
        weekdays: "weekday",
        weekday: "weekday",
        E: "isoWeekday",
        isoweekdays: "isoWeekday",
        isoweekday: "isoWeekday",
        DDD: "dayOfYear",
        dayofyears: "dayOfYear",
        dayofyear: "dayOfYear",
        h: "hour",
        hours: "hour",
        hour: "hour",
        ms: "millisecond",
        milliseconds: "millisecond",
        millisecond: "millisecond",
        m: "minute",
        minutes: "minute",
        minute: "minute",
        M: "month",
        months: "month",
        month: "month",
        Q: "quarter",
        quarters: "quarter",
        quarter: "quarter",
        s: "second",
        seconds: "second",
        second: "second",
        gg: "weekYear",
        weekyears: "weekYear",
        weekyear: "weekYear",
        GG: "isoWeekYear",
        isoweekyears: "isoWeekYear",
        isoweekyear: "isoWeekYear",
        w: "week",
        weeks: "week",
        week: "week",
        W: "isoWeek",
        isoweeks: "isoWeek",
        isoweek: "isoWeek",
        y: "year",
        years: "year",
        year: "year"
    };
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === "string") token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case "Seconds":
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case "Minutes":
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case "Hours":
                return isUTC ? d.getUTCHours() : d.getHours();
            case "Date":
                return isUTC ? d.getUTCDate() : d.getDate();
            case "Day":
                return isUTC ? d.getUTCDay() : d.getDay();
            case "Month":
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case "FullYear":
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case "Seconds":
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case "Minutes":
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case "Hours":
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case "Date":
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case "FullYear":
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken("M", match1to2, match1to2NoLeadingZero);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ""));
            longP = regexEscape(this.months(mom, ""));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // PARSING
    addRegexToken("w", match1to2, match1to2NoLeadingZero);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2, match1to2NoLeadingZero);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, "Day");
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ""));
            shortp = regexEscape(this.weekdaysShort(mom, ""));
            longp = regexEscape(this.weekdays(mom, ""));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2, match1to2HasZero);
    addRegexToken("h", match1to2, match1to2NoLeadingZero);
    addRegexToken("k", match1to2, match1to2NoLeadingZero);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "k",
        "kk"
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join("-"));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match("^[^/\\\\]*$"));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn("Locale " + key + " not found. Did you forget to load it?");
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            false
        ],
        [
            "YYYY",
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === "") return createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = "+";
            if (offset < 0) {
                offset = -offset;
                sign = "-";
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
        if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
        return typeof input === "string" || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "years",
            "year",
            "y",
            "months",
            "month",
            "M",
            "days",
            "day",
            "d",
            "dates",
            "date",
            "D",
            "hours",
            "hour",
            "h",
            "minutes",
            "minute",
            "m",
            "seconds",
            "second",
            "s",
            "milliseconds",
            "millisecond",
            "ms"
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "sameDay",
            "nextDay",
            "lastDay",
            "nextWeek",
            "lastWeek",
            "sameElse"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, "days", true);
        return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case "year":
                output = monthDiff(this, that) / 12;
                break;
            case "month":
                output = monthDiff(this, that);
                break;
            case "quarter":
                output = monthDiff(this, that) / 3;
                break;
            case "second":
                output = (this - that) / 1e3;
                break; // 1000
            case "minute":
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case "hour":
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case "day":
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case "week":
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
        }
        return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year(), 0, 1);
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case "hour":
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case "minute":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case "second":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case "minute":
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case "second":
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", [
        "y",
        1
    ], "yo", "eraYear");
    addFormatToken("y", [
        "yy",
        2
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyy",
        3
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyyy",
        4
    ], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], YEAR);
    addParseToken([
        "yo"
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case "string":
                    // truncate time
                    date = hooks(eras[i].since).startOf("day");
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case "undefined":
                    eras[i].until = Infinity;
                    break;
                case "string":
                    // truncate time
                    date = hooks(eras[i].until).startOf("day").valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case "N":
                case "NN":
                case "NNN":
                    if (abbr === eraName) return eras[i];
                    break;
                case "NNNN":
                    if (name === eraName) return eras[i];
                    break;
                case "NNNNN":
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return "";
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return "";
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return "";
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // PARSING
    addRegexToken("D", match1to2, match1to2NoLeadingZero);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // PARSING
    addRegexToken("m", match1to2, match1to2HasZero);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // PARSING
    addRegexToken("s", match1to2, match1to2HasZero);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return get$1(format, index, field, "month");
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, "day");
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
        eras: [
            {
                since: "0001-01-01",
                until: Infinity,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
    hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case "month":
                    return months;
                case "quarter":
                    return months / 3;
                case "year":
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y"), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
            "s",
            seconds
        ] || seconds < thresholds.s && [
            "ss",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            "w"
        ] || weeks < thresholds.w && [
            "ww",
            weeks
        ];
        a = a || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === "s") thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === "object") {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
        if (typeof argThresholds === "object") {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.30.1";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    };
    return hooks;
});

});

parcelRegister("lrct3", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $aGGuH = parcelRequire("aGGuH");
function $f9b5ca6aeff231cf$var$emptyFunction() {}
function $f9b5ca6aeff231cf$var$emptyFunctionWithReset() {}
$f9b5ca6aeff231cf$var$emptyFunctionWithReset.resetWarningCache = $f9b5ca6aeff231cf$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $aGGuH) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $f9b5ca6aeff231cf$var$emptyFunctionWithReset,
        resetWarningCache: $f9b5ca6aeff231cf$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("aGGuH", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $7c7eca1397927a3e$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $7c7eca1397927a3e$var$ReactPropTypesSecret;

});


parcelRegister("hFtc0", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $cdcce91081d78ae7$export$2b8d127b894957b9; }, function (v) { return $cdcce91081d78ae7$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $cdcce91081d78ae7$export$cea3a54a6425200c; }, function (v) { return $cdcce91081d78ae7$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $cdcce91081d78ae7$export$a7c73072b1a182ae; }, function (v) { return $cdcce91081d78ae7$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $cdcce91081d78ae7$export$9f27bc3417b4524d; }, function (v) { return $cdcce91081d78ae7$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $cdcce91081d78ae7$export$db77ccec0bb4ccac; }, function (v) { return $cdcce91081d78ae7$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $cdcce91081d78ae7$export$8392c0c9d3dcbd35; }, function (v) { return $cdcce91081d78ae7$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $cdcce91081d78ae7$export$ffb0004e005737fa; }, function (v) { return $cdcce91081d78ae7$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $cdcce91081d78ae7$export$b624eff549462981; }, function (v) { return $cdcce91081d78ae7$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $cdcce91081d78ae7$export$7897aa7841a5380c; }, function (v) { return $cdcce91081d78ae7$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $cdcce91081d78ae7$export$602eac185826482c; }, function (v) { return $cdcce91081d78ae7$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $cdcce91081d78ae7$export$e2c29f18771995cb; }, function (v) { return $cdcce91081d78ae7$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $cdcce91081d78ae7$export$5f8d39834fd61797; }, function (v) { return $cdcce91081d78ae7$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $cdcce91081d78ae7$export$74bf444e3cd11ea5; }, function (v) { return $cdcce91081d78ae7$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $cdcce91081d78ae7$export$92387174baf9b227; }, function (v) { return $cdcce91081d78ae7$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $cdcce91081d78ae7$export$ec112efeb987d9c6; }, function (v) { return $cdcce91081d78ae7$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $cdcce91081d78ae7$export$b706b080d889d2c9; }, function (v) { return $cdcce91081d78ae7$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $cdcce91081d78ae7$export$5be5a87408f70ddc; }, function (v) { return $cdcce91081d78ae7$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $cdcce91081d78ae7$export$45a5e7f76e0caa8d; }, function (v) { return $cdcce91081d78ae7$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $cdcce91081d78ae7$export$455c2e768291efa6; }, function (v) { return $cdcce91081d78ae7$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $cdcce91081d78ae7$export$9522e17588c12572; }, function (v) { return $cdcce91081d78ae7$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $cdcce91081d78ae7$export$2110ac352bb060b9; }, function (v) { return $cdcce91081d78ae7$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $cdcce91081d78ae7$export$56885ab8b9c456ab; }, function (v) { return $cdcce91081d78ae7$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $cdcce91081d78ae7$export$d927fcb6adf8f9de; }, function (v) { return $cdcce91081d78ae7$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $cdcce91081d78ae7$export$b82d16f27459e05a; }, function (v) { return $cdcce91081d78ae7$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $cdcce91081d78ae7$export$522c17b4f5e123e8; }, function (v) { return $cdcce91081d78ae7$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $cdcce91081d78ae7$export$1aabd8a0274ecfd6; }, function (v) { return $cdcce91081d78ae7$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $cdcce91081d78ae7$export$9b621391a187a31a; }, function (v) { return $cdcce91081d78ae7$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $cdcce91081d78ae7$export$f5bbd400c2f4426f; }, function (v) { return $cdcce91081d78ae7$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $cdcce91081d78ae7$export$2b8d127b894957b9;
var $cdcce91081d78ae7$export$cea3a54a6425200c;
var $cdcce91081d78ae7$export$a7c73072b1a182ae;
var $cdcce91081d78ae7$export$9f27bc3417b4524d;
var $cdcce91081d78ae7$export$db77ccec0bb4ccac;
var $cdcce91081d78ae7$export$8392c0c9d3dcbd35;
var $cdcce91081d78ae7$export$ffb0004e005737fa;
var $cdcce91081d78ae7$export$b624eff549462981;
var $cdcce91081d78ae7$export$7897aa7841a5380c;
var $cdcce91081d78ae7$export$602eac185826482c;
var $cdcce91081d78ae7$export$e2c29f18771995cb;
var $cdcce91081d78ae7$export$5f8d39834fd61797;
var $cdcce91081d78ae7$export$74bf444e3cd11ea5;
var $cdcce91081d78ae7$export$92387174baf9b227;
var $cdcce91081d78ae7$export$ec112efeb987d9c6;
var $cdcce91081d78ae7$export$b706b080d889d2c9;
var $cdcce91081d78ae7$export$5be5a87408f70ddc;
var $cdcce91081d78ae7$export$45a5e7f76e0caa8d;
var $cdcce91081d78ae7$export$455c2e768291efa6;
var $cdcce91081d78ae7$export$9522e17588c12572;
var $cdcce91081d78ae7$export$2110ac352bb060b9;
var $cdcce91081d78ae7$export$56885ab8b9c456ab;
var $cdcce91081d78ae7$export$d927fcb6adf8f9de;
var $cdcce91081d78ae7$export$b82d16f27459e05a;
var $cdcce91081d78ae7$export$522c17b4f5e123e8;
var $cdcce91081d78ae7$export$1aabd8a0274ecfd6;
var $cdcce91081d78ae7$export$9b621391a187a31a;
var $cdcce91081d78ae7$export$f5bbd400c2f4426f;
"use strict";
var $cdcce91081d78ae7$var$b = "function" === typeof Symbol && Symbol.for, $cdcce91081d78ae7$var$c = $cdcce91081d78ae7$var$b ? Symbol.for("react.element") : 60103, $cdcce91081d78ae7$var$d = $cdcce91081d78ae7$var$b ? Symbol.for("react.portal") : 60106, $cdcce91081d78ae7$var$e = $cdcce91081d78ae7$var$b ? Symbol.for("react.fragment") : 60107, $cdcce91081d78ae7$var$f = $cdcce91081d78ae7$var$b ? Symbol.for("react.strict_mode") : 60108, $cdcce91081d78ae7$var$g = $cdcce91081d78ae7$var$b ? Symbol.for("react.profiler") : 60114, $cdcce91081d78ae7$var$h = $cdcce91081d78ae7$var$b ? Symbol.for("react.provider") : 60109, $cdcce91081d78ae7$var$k = $cdcce91081d78ae7$var$b ? Symbol.for("react.context") : 60110, $cdcce91081d78ae7$var$l = $cdcce91081d78ae7$var$b ? Symbol.for("react.async_mode") : 60111, $cdcce91081d78ae7$var$m = $cdcce91081d78ae7$var$b ? Symbol.for("react.concurrent_mode") : 60111, $cdcce91081d78ae7$var$n = $cdcce91081d78ae7$var$b ? Symbol.for("react.forward_ref") : 60112, $cdcce91081d78ae7$var$p = $cdcce91081d78ae7$var$b ? Symbol.for("react.suspense") : 60113, $cdcce91081d78ae7$var$q = $cdcce91081d78ae7$var$b ? Symbol.for("react.suspense_list") : 60120, $cdcce91081d78ae7$var$r = $cdcce91081d78ae7$var$b ? Symbol.for("react.memo") : 60115, $cdcce91081d78ae7$var$t = $cdcce91081d78ae7$var$b ? Symbol.for("react.lazy") : 60116, $cdcce91081d78ae7$var$v = $cdcce91081d78ae7$var$b ? Symbol.for("react.block") : 60121, $cdcce91081d78ae7$var$w = $cdcce91081d78ae7$var$b ? Symbol.for("react.fundamental") : 60117, $cdcce91081d78ae7$var$x = $cdcce91081d78ae7$var$b ? Symbol.for("react.responder") : 60118, $cdcce91081d78ae7$var$y = $cdcce91081d78ae7$var$b ? Symbol.for("react.scope") : 60119;
function $cdcce91081d78ae7$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $cdcce91081d78ae7$var$c:
                switch(a = a.type, a){
                    case $cdcce91081d78ae7$var$l:
                    case $cdcce91081d78ae7$var$m:
                    case $cdcce91081d78ae7$var$e:
                    case $cdcce91081d78ae7$var$g:
                    case $cdcce91081d78ae7$var$f:
                    case $cdcce91081d78ae7$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $cdcce91081d78ae7$var$k:
                            case $cdcce91081d78ae7$var$n:
                            case $cdcce91081d78ae7$var$t:
                            case $cdcce91081d78ae7$var$r:
                            case $cdcce91081d78ae7$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $cdcce91081d78ae7$var$d:
                return u;
        }
    }
}
function $cdcce91081d78ae7$var$A(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$m;
}
$cdcce91081d78ae7$export$2b8d127b894957b9 = $cdcce91081d78ae7$var$l;
$cdcce91081d78ae7$export$cea3a54a6425200c = $cdcce91081d78ae7$var$m;
$cdcce91081d78ae7$export$a7c73072b1a182ae = $cdcce91081d78ae7$var$k;
$cdcce91081d78ae7$export$9f27bc3417b4524d = $cdcce91081d78ae7$var$h;
$cdcce91081d78ae7$export$db77ccec0bb4ccac = $cdcce91081d78ae7$var$c;
$cdcce91081d78ae7$export$8392c0c9d3dcbd35 = $cdcce91081d78ae7$var$n;
$cdcce91081d78ae7$export$ffb0004e005737fa = $cdcce91081d78ae7$var$e;
$cdcce91081d78ae7$export$b624eff549462981 = $cdcce91081d78ae7$var$t;
$cdcce91081d78ae7$export$7897aa7841a5380c = $cdcce91081d78ae7$var$r;
$cdcce91081d78ae7$export$602eac185826482c = $cdcce91081d78ae7$var$d;
$cdcce91081d78ae7$export$e2c29f18771995cb = $cdcce91081d78ae7$var$g;
$cdcce91081d78ae7$export$5f8d39834fd61797 = $cdcce91081d78ae7$var$f;
$cdcce91081d78ae7$export$74bf444e3cd11ea5 = $cdcce91081d78ae7$var$p;
$cdcce91081d78ae7$export$92387174baf9b227 = function(a) {
    return $cdcce91081d78ae7$var$A(a) || $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$l;
};
$cdcce91081d78ae7$export$ec112efeb987d9c6 = $cdcce91081d78ae7$var$A;
$cdcce91081d78ae7$export$b706b080d889d2c9 = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$k;
};
$cdcce91081d78ae7$export$5be5a87408f70ddc = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$h;
};
$cdcce91081d78ae7$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $cdcce91081d78ae7$var$c;
};
$cdcce91081d78ae7$export$455c2e768291efa6 = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$n;
};
$cdcce91081d78ae7$export$9522e17588c12572 = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$e;
};
$cdcce91081d78ae7$export$2110ac352bb060b9 = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$t;
};
$cdcce91081d78ae7$export$56885ab8b9c456ab = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$r;
};
$cdcce91081d78ae7$export$d927fcb6adf8f9de = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$d;
};
$cdcce91081d78ae7$export$b82d16f27459e05a = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$g;
};
$cdcce91081d78ae7$export$522c17b4f5e123e8 = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$f;
};
$cdcce91081d78ae7$export$1aabd8a0274ecfd6 = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$p;
};
$cdcce91081d78ae7$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $cdcce91081d78ae7$var$e || a === $cdcce91081d78ae7$var$m || a === $cdcce91081d78ae7$var$g || a === $cdcce91081d78ae7$var$f || a === $cdcce91081d78ae7$var$p || a === $cdcce91081d78ae7$var$q || "object" === typeof a && null !== a && (a.$$typeof === $cdcce91081d78ae7$var$t || a.$$typeof === $cdcce91081d78ae7$var$r || a.$$typeof === $cdcce91081d78ae7$var$h || a.$$typeof === $cdcce91081d78ae7$var$k || a.$$typeof === $cdcce91081d78ae7$var$n || a.$$typeof === $cdcce91081d78ae7$var$w || a.$$typeof === $cdcce91081d78ae7$var$x || a.$$typeof === $cdcce91081d78ae7$var$y || a.$$typeof === $cdcce91081d78ae7$var$v);
};
$cdcce91081d78ae7$export$f5bbd400c2f4426f = $cdcce91081d78ae7$var$z;

});

parcelRegister("1iAxI", function(module, exports) {
"use strict";

var $eTQO9 = parcelRequire("eTQO9");
var $0f23d1886f02ec64$var$clipboardToIE11Formatting = {
    "text/plain": "Text",
    "text/html": "Url",
    "default": "Text"
};
var $0f23d1886f02ec64$var$defaultMessage = "Copy to clipboard: #{key}, Enter";
function $0f23d1886f02ec64$var$format(message) {
    var copyKey = (/mac os x/i.test(navigator.userAgent) ? "\u2318" : "Ctrl") + "+C";
    return message.replace(/#{\s*key\s*}/g, copyKey);
}
function $0f23d1886f02ec64$var$copy(text, options) {
    var debug, message, reselectPrevious, range, selection, mark, success = false;
    if (!options) options = {};
    debug = options.debug || false;
    try {
        reselectPrevious = $eTQO9();
        range = document.createRange();
        selection = document.getSelection();
        mark = document.createElement("span");
        mark.textContent = text;
        // avoid screen readers from reading out loud the text
        mark.ariaHidden = "true";
        // reset user styles for span element
        mark.style.all = "unset";
        // prevents scrolling to the end of the page
        mark.style.position = "fixed";
        mark.style.top = 0;
        mark.style.clip = "rect(0, 0, 0, 0)";
        // used to preserve spaces and line breaks
        mark.style.whiteSpace = "pre";
        // do not inherit user-select (it may be `none`)
        mark.style.webkitUserSelect = "text";
        mark.style.MozUserSelect = "text";
        mark.style.msUserSelect = "text";
        mark.style.userSelect = "text";
        mark.addEventListener("copy", function(e) {
            e.stopPropagation();
            if (options.format) {
                e.preventDefault();
                if (typeof e.clipboardData === "undefined") {
                    debug && console.warn("unable to use e.clipboardData");
                    debug && console.warn("trying IE specific stuff");
                    window.clipboardData.clearData();
                    var format = $0f23d1886f02ec64$var$clipboardToIE11Formatting[options.format] || $0f23d1886f02ec64$var$clipboardToIE11Formatting["default"];
                    window.clipboardData.setData(format, text);
                } else {
                    e.clipboardData.clearData();
                    e.clipboardData.setData(options.format, text);
                }
            }
            if (options.onCopy) {
                e.preventDefault();
                options.onCopy(e.clipboardData);
            }
        });
        document.body.appendChild(mark);
        range.selectNodeContents(mark);
        selection.addRange(range);
        var successful = document.execCommand("copy");
        if (!successful) throw new Error("copy command was unsuccessful");
        success = true;
    } catch (err) {
        debug && console.error("unable to copy using execCommand: ", err);
        debug && console.warn("trying IE specific stuff");
        try {
            window.clipboardData.setData(options.format || "text", text);
            options.onCopy && options.onCopy(window.clipboardData);
            success = true;
        } catch (err) {
            debug && console.error("unable to copy using clipboardData: ", err);
            debug && console.error("falling back to prompt");
            message = $0f23d1886f02ec64$var$format("message" in options ? options.message : $0f23d1886f02ec64$var$defaultMessage);
            window.prompt(message, text);
        }
    } finally{
        if (selection) {
            if (typeof selection.removeRange == "function") selection.removeRange(range);
            else selection.removeAllRanges();
        }
        if (mark) document.body.removeChild(mark);
        reselectPrevious();
    }
    return success;
}
module.exports = $0f23d1886f02ec64$var$copy;

});
parcelRegister("eTQO9", function(module, exports) {
module.exports = function() {
    var selection = document.getSelection();
    if (!selection.rangeCount) return function() {};
    var active = document.activeElement;
    var ranges = [];
    for(var i = 0; i < selection.rangeCount; i++)ranges.push(selection.getRangeAt(i));
    switch(active.tagName.toUpperCase()){
        case "INPUT":
        case "TEXTAREA":
            active.blur();
            break;
        default:
            active = null;
            break;
    }
    selection.removeAllRanges();
    return function() {
        selection.type === "Caret" && selection.removeAllRanges();
        if (!selection.rangeCount) ranges.forEach(function(range) {
            selection.addRange(range);
        });
        active && active.focus();
    };
};

});


parcelRegister("aFk2u", function(module, exports) {

$parcel$export(module.exports, "zeroPad", function () { return zeroPad; });
$parcel$export(module.exports, "calcTimeDelta", function () { return calcTimeDelta; });
$parcel$export(module.exports, "formatTimeDelta", function () { return formatTimeDelta; });
$parcel$export(module.exports, "default", function () { return $7c3d4713e01ccd20$export$2e2bcd8739ae039; });

var $6cds3 = parcelRequire("6cds3");

var $aMJGV = parcelRequire("aMJGV");
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function zeroPad(value) {
    var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    var strValue = String(value);
    if (length === 0) return strValue;
    var match = strValue.match(/(.*?)([0-9]+)(.*)/);
    var prefix = match ? match[1] : "";
    var suffix = match ? match[3] : "";
    var strNo = match ? match[2] : strValue;
    var paddedNo = strNo.length >= length ? strNo : (_toConsumableArray(Array(length)).map(function() {
        return "0";
    }).join("") + strNo).slice(length * -1);
    return "".concat(prefix).concat(paddedNo).concat(suffix);
}
var timeDeltaFormatOptionsDefaults = {
    daysInHours: false,
    zeroPadTime: 2
};
function calcTimeDelta(date) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$now = options.now, now = _options$now === void 0 ? Date.now : _options$now, _options$precision = options.precision, precision = _options$precision === void 0 ? 0 : _options$precision, controlled = options.controlled, _options$offsetTime = options.offsetTime, offsetTime = _options$offsetTime === void 0 ? 0 : _options$offsetTime, overtime = options.overtime;
    var startTimestamp;
    if (typeof date === "string") startTimestamp = new Date(date).getTime();
    else if (date instanceof Date) startTimestamp = date.getTime();
    else startTimestamp = date;
    if (!controlled) startTimestamp += offsetTime;
    var timeLeft = controlled ? startTimestamp : startTimestamp - now();
    var clampedPrecision = Math.min(20, Math.max(0, precision));
    var total = Math.round(parseFloat(((overtime ? timeLeft : Math.max(0, timeLeft)) / 1000).toFixed(clampedPrecision)) * 1000);
    var seconds = Math.abs(total) / 1000;
    return {
        total: total,
        days: Math.floor(seconds / 86400),
        hours: Math.floor(seconds / 3600 % 24),
        minutes: Math.floor(seconds / 60 % 60),
        seconds: Math.floor(seconds % 60),
        milliseconds: Number((seconds % 1 * 1000).toFixed()),
        completed: total <= 0
    };
}
function formatTimeDelta(timeDelta, options) {
    var days = timeDelta.days, hours = timeDelta.hours, minutes = timeDelta.minutes, seconds = timeDelta.seconds;
    var _Object$assign = Object.assign(Object.assign({}, timeDeltaFormatOptionsDefaults), options), daysInHours = _Object$assign.daysInHours, zeroPadTime = _Object$assign.zeroPadTime, _Object$assign$zeroPa = _Object$assign.zeroPadDays, zeroPadDays = _Object$assign$zeroPa === void 0 ? zeroPadTime : _Object$assign$zeroPa;
    var zeroPadTimeLength = Math.min(2, zeroPadTime);
    var formattedHours = daysInHours ? zeroPad(hours + days * 24, zeroPadTime) : zeroPad(hours, zeroPadTimeLength);
    return {
        days: daysInHours ? "" : zeroPad(days, zeroPadDays),
        hours: formattedHours,
        minutes: zeroPad(minutes, zeroPadTimeLength),
        seconds: zeroPad(seconds, zeroPadTimeLength)
    };
}
var Countdown = function(_React$Component) {
    _inherits(Countdown, _React$Component);
    var _super = _createSuper(Countdown);
    function Countdown() {
        var _this;
        _classCallCheck(this, Countdown);
        _this = _super.apply(this, arguments);
        _this.state = {
            count: _this.props.count || 3
        };
        _this.startCountdown = function() {
            _this.interval = window.setInterval(function() {
                var count = _this.state.count - 1;
                if (count === 0) {
                    _this.stopCountdown();
                    _this.props.onComplete && _this.props.onComplete();
                } else _this.setState(function(prevState) {
                    return {
                        count: prevState.count - 1
                    };
                });
            }, 1000);
        };
        _this.stopCountdown = function() {
            clearInterval(_this.interval);
        };
        _this.addTime = function(seconds) {
            _this.stopCountdown();
            _this.setState(function(prevState) {
                return {
                    count: prevState.count + seconds
                };
            }, _this.startCountdown);
        };
        return _this;
    }
    _createClass(Countdown, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startCountdown();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                clearInterval(this.interval);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.props.children ? (0, $6cds3.cloneElement)(this.props.children, {
                    count: this.state.count
                }) : null;
            }
        }
    ]);
    return Countdown;
}((0, $6cds3.Component));
Countdown.propTypes = {
    count: (0, $aMJGV.number),
    children: (0, $aMJGV.element),
    onComplete: (0, $aMJGV.func)
};
var Countdown$1 = function(_React$Component) {
    _inherits(Countdown$1, _React$Component);
    var _super = _createSuper(Countdown$1);
    function Countdown$1(props) {
        var _this;
        _classCallCheck(this, Countdown$1);
        _this = _super.call(this, props);
        _this.mounted = false;
        _this.initialTimestamp = _this.calcOffsetStartTimestamp();
        _this.offsetStartTimestamp = _this.props.autoStart ? 0 : _this.initialTimestamp;
        _this.offsetTime = 0;
        _this.legacyMode = false;
        _this.legacyCountdownRef = (0, $6cds3.createRef)();
        _this.tick = function() {
            var timeDelta = _this.calcTimeDelta();
            var callback = timeDelta.completed && !_this.props.overtime ? undefined : _this.props.onTick;
            _this.setTimeDeltaState(timeDelta, undefined, callback);
        };
        _this.start = function() {
            if (_this.isStarted()) return;
            var prevOffsetStartTimestamp = _this.offsetStartTimestamp;
            _this.offsetStartTimestamp = 0;
            _this.offsetTime += prevOffsetStartTimestamp ? _this.calcOffsetStartTimestamp() - prevOffsetStartTimestamp : 0;
            var timeDelta = _this.calcTimeDelta();
            _this.setTimeDeltaState(timeDelta, "STARTED", _this.props.onStart);
            if (!_this.props.controlled && (!timeDelta.completed || _this.props.overtime)) {
                _this.clearTimer();
                _this.interval = window.setInterval(_this.tick, _this.props.intervalDelay);
            }
        };
        _this.pause = function() {
            if (_this.isPaused()) return;
            _this.clearTimer();
            _this.offsetStartTimestamp = _this.calcOffsetStartTimestamp();
            _this.setTimeDeltaState(_this.state.timeDelta, "PAUSED", _this.props.onPause);
        };
        _this.stop = function() {
            if (_this.isStopped()) return;
            _this.clearTimer();
            _this.offsetStartTimestamp = _this.calcOffsetStartTimestamp();
            _this.offsetTime = _this.offsetStartTimestamp - _this.initialTimestamp;
            _this.setTimeDeltaState(_this.calcTimeDelta(), "STOPPED", _this.props.onStop);
        };
        _this.isStarted = function() {
            return _this.isStatus("STARTED");
        };
        _this.isPaused = function() {
            return _this.isStatus("PAUSED");
        };
        _this.isStopped = function() {
            return _this.isStatus("STOPPED");
        };
        _this.isCompleted = function() {
            return _this.isStatus("COMPLETED");
        };
        if (props.date) {
            var timeDelta = _this.calcTimeDelta();
            _this.state = {
                timeDelta: timeDelta,
                status: timeDelta.completed ? "COMPLETED" : "STOPPED"
            };
        } else _this.legacyMode = true;
        return _this;
    }
    _createClass(Countdown$1, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.legacyMode) return;
                this.mounted = true;
                if (this.props.onMount) this.props.onMount(this.calcTimeDelta());
                if (this.props.autoStart) this.start();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (this.legacyMode) return;
                if (this.props.date !== prevProps.date) {
                    this.initialTimestamp = this.calcOffsetStartTimestamp();
                    this.offsetStartTimestamp = this.initialTimestamp;
                    this.offsetTime = 0;
                    this.setTimeDeltaState(this.calcTimeDelta());
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.legacyMode) return;
                this.mounted = false;
                this.clearTimer();
            }
        },
        {
            key: "calcTimeDelta",
            value: function calcTimeDelta$1() {
                var _this$props = this.props, date = _this$props.date, now = _this$props.now, precision = _this$props.precision, controlled = _this$props.controlled, overtime = _this$props.overtime;
                return calcTimeDelta(date, {
                    now: now,
                    precision: precision,
                    controlled: controlled,
                    offsetTime: this.offsetTime,
                    overtime: overtime
                });
            }
        },
        {
            key: "calcOffsetStartTimestamp",
            value: function calcOffsetStartTimestamp() {
                return Date.now();
            }
        },
        {
            key: "addTime",
            value: function addTime(seconds) {
                this.legacyCountdownRef.current.addTime(seconds);
            }
        },
        {
            key: "clearTimer",
            value: function clearTimer() {
                window.clearInterval(this.interval);
            }
        },
        {
            key: "isStatus",
            value: function isStatus(status) {
                return this.state.status === status;
            }
        },
        {
            key: "setTimeDeltaState",
            value: function setTimeDeltaState(timeDelta, status, callback) {
                var _this2 = this;
                if (!this.mounted) return;
                var completing = timeDelta.completed && !this.state.timeDelta.completed;
                var completedOnStart = timeDelta.completed && status === "STARTED";
                if (completing && !this.props.overtime) this.clearTimer();
                var onDone = function onDone() {
                    if (callback) callback(_this2.state.timeDelta);
                    if (_this2.props.onComplete && (completing || completedOnStart)) _this2.props.onComplete(timeDelta, completedOnStart);
                };
                return this.setState(function(prevState) {
                    var newStatus = status || prevState.status;
                    if (timeDelta.completed && !_this2.props.overtime) newStatus = "COMPLETED";
                    else if (!status && newStatus === "COMPLETED") newStatus = "STOPPED";
                    return {
                        timeDelta: timeDelta,
                        status: newStatus
                    };
                }, onDone);
            }
        },
        {
            key: "getApi",
            value: function getApi() {
                return this.api = this.api || {
                    start: this.start,
                    pause: this.pause,
                    stop: this.stop,
                    isStarted: this.isStarted,
                    isPaused: this.isPaused,
                    isStopped: this.isStopped,
                    isCompleted: this.isCompleted
                };
            }
        },
        {
            key: "getRenderProps",
            value: function getRenderProps() {
                var _this$props2 = this.props, daysInHours = _this$props2.daysInHours, zeroPadTime = _this$props2.zeroPadTime, zeroPadDays = _this$props2.zeroPadDays;
                var timeDelta = this.state.timeDelta;
                return Object.assign(Object.assign({}, timeDelta), {
                    api: this.getApi(),
                    props: this.props,
                    formatted: formatTimeDelta(timeDelta, {
                        daysInHours: daysInHours,
                        zeroPadTime: zeroPadTime,
                        zeroPadDays: zeroPadDays
                    })
                });
            }
        },
        {
            key: "render",
            value: function render() {
                if (this.legacyMode) {
                    var _this$props3 = this.props, count = _this$props3.count, _children = _this$props3.children, onComplete = _this$props3.onComplete;
                    return (0, $6cds3.createElement)(Countdown, {
                        ref: this.legacyCountdownRef,
                        count: count,
                        onComplete: onComplete
                    }, _children);
                }
                var _this$props4 = this.props, className = _this$props4.className, overtime = _this$props4.overtime, children = _this$props4.children, renderer = _this$props4.renderer;
                var renderProps = this.getRenderProps();
                if (renderer) return renderer(renderProps);
                if (children && this.state.timeDelta.completed && !overtime) return (0, $6cds3.cloneElement)(children, {
                    countdown: renderProps
                });
                var _renderProps$formatte = renderProps.formatted, days = _renderProps$formatte.days, hours = _renderProps$formatte.hours, minutes = _renderProps$formatte.minutes, seconds = _renderProps$formatte.seconds;
                return (0, $6cds3.createElement)("span", {
                    className: className
                }, renderProps.total < 0 ? "-" : "", days, days ? ":" : "", hours, ":", minutes, ":", seconds);
            }
        }
    ]);
    return Countdown$1;
}((0, $6cds3.Component));
Countdown$1.defaultProps = Object.assign(Object.assign({}, timeDeltaFormatOptionsDefaults), {
    controlled: false,
    intervalDelay: 1000,
    precision: 0,
    autoStart: true
});
Countdown$1.propTypes = {
    date: (0, $aMJGV.oneOfType)([
        (0, $aMJGV.instanceOf)(Date),
        (0, $aMJGV.string),
        (0, $aMJGV.number)
    ]),
    daysInHours: (0, $aMJGV.bool),
    zeroPadTime: (0, $aMJGV.number),
    zeroPadDays: (0, $aMJGV.number),
    controlled: (0, $aMJGV.bool),
    intervalDelay: (0, $aMJGV.number),
    precision: (0, $aMJGV.number),
    autoStart: (0, $aMJGV.bool),
    overtime: (0, $aMJGV.bool),
    className: (0, $aMJGV.string),
    children: (0, $aMJGV.element),
    renderer: (0, $aMJGV.func),
    now: (0, $aMJGV.func),
    onMount: (0, $aMJGV.func),
    onStart: (0, $aMJGV.func),
    onPause: (0, $aMJGV.func),
    onStop: (0, $aMJGV.func),
    onTick: (0, $aMJGV.func),
    onComplete: (0, $aMJGV.func)
};
var $7c3d4713e01ccd20$export$2e2bcd8739ae039 = Countdown$1;

});
parcelRegister("aMJGV", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7da1d47045483a0e$var$ReactIs, $7da1d47045483a0e$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("lrct3"))();

});


parcelRegister("1hqAq", function(module, exports) {


module.exports = (parcelRequire("9FZDf"))((parcelRequire("lGKbD")).resolve("8w90J")).then(()=>parcelRequire("1a7wU"));

});
parcelRegister("9FZDf", function(module, exports) {
"use strict";

var $9jW6n = parcelRequire("9jW6n");
module.exports = $9jW6n(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("9jW6n", function(module, exports) {
"use strict";
var $6c92f53da2785287$var$cachedBundles = {};
var $6c92f53da2785287$var$cachedPreloads = {};
var $6c92f53da2785287$var$cachedPrefetches = {};
function $6c92f53da2785287$var$getCache(type) {
    switch(type){
        case "preload":
            return $6c92f53da2785287$var$cachedPreloads;
        case "prefetch":
            return $6c92f53da2785287$var$cachedPrefetches;
        default:
            return $6c92f53da2785287$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $6c92f53da2785287$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("3aI4s", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $24f47dcfb45069ca$export$a7c73072b1a182ae; }, function (v) { return $24f47dcfb45069ca$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $24f47dcfb45069ca$export$9f27bc3417b4524d; }, function (v) { return $24f47dcfb45069ca$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $24f47dcfb45069ca$export$db77ccec0bb4ccac; }, function (v) { return $24f47dcfb45069ca$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $24f47dcfb45069ca$export$8392c0c9d3dcbd35; }, function (v) { return $24f47dcfb45069ca$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $24f47dcfb45069ca$export$ffb0004e005737fa; }, function (v) { return $24f47dcfb45069ca$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $24f47dcfb45069ca$export$b624eff549462981; }, function (v) { return $24f47dcfb45069ca$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $24f47dcfb45069ca$export$7897aa7841a5380c; }, function (v) { return $24f47dcfb45069ca$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $24f47dcfb45069ca$export$602eac185826482c; }, function (v) { return $24f47dcfb45069ca$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $24f47dcfb45069ca$export$e2c29f18771995cb; }, function (v) { return $24f47dcfb45069ca$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $24f47dcfb45069ca$export$5f8d39834fd61797; }, function (v) { return $24f47dcfb45069ca$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $24f47dcfb45069ca$export$74bf444e3cd11ea5; }, function (v) { return $24f47dcfb45069ca$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $24f47dcfb45069ca$export$998bcd577473dd93; }, function (v) { return $24f47dcfb45069ca$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $24f47dcfb45069ca$export$92387174baf9b227; }, function (v) { return $24f47dcfb45069ca$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $24f47dcfb45069ca$export$ec112efeb987d9c6; }, function (v) { return $24f47dcfb45069ca$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $24f47dcfb45069ca$export$b706b080d889d2c9; }, function (v) { return $24f47dcfb45069ca$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $24f47dcfb45069ca$export$5be5a87408f70ddc; }, function (v) { return $24f47dcfb45069ca$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $24f47dcfb45069ca$export$45a5e7f76e0caa8d; }, function (v) { return $24f47dcfb45069ca$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $24f47dcfb45069ca$export$455c2e768291efa6; }, function (v) { return $24f47dcfb45069ca$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $24f47dcfb45069ca$export$9522e17588c12572; }, function (v) { return $24f47dcfb45069ca$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $24f47dcfb45069ca$export$2110ac352bb060b9; }, function (v) { return $24f47dcfb45069ca$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $24f47dcfb45069ca$export$56885ab8b9c456ab; }, function (v) { return $24f47dcfb45069ca$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $24f47dcfb45069ca$export$d927fcb6adf8f9de; }, function (v) { return $24f47dcfb45069ca$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $24f47dcfb45069ca$export$b82d16f27459e05a; }, function (v) { return $24f47dcfb45069ca$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $24f47dcfb45069ca$export$522c17b4f5e123e8; }, function (v) { return $24f47dcfb45069ca$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $24f47dcfb45069ca$export$1aabd8a0274ecfd6; }, function (v) { return $24f47dcfb45069ca$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $24f47dcfb45069ca$export$3d6c20d97e46b957; }, function (v) { return $24f47dcfb45069ca$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $24f47dcfb45069ca$export$9b621391a187a31a; }, function (v) { return $24f47dcfb45069ca$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $24f47dcfb45069ca$export$f5bbd400c2f4426f; }, function (v) { return $24f47dcfb45069ca$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $24f47dcfb45069ca$export$a7c73072b1a182ae;
var $24f47dcfb45069ca$export$9f27bc3417b4524d;
var $24f47dcfb45069ca$export$db77ccec0bb4ccac;
var $24f47dcfb45069ca$export$8392c0c9d3dcbd35;
var $24f47dcfb45069ca$export$ffb0004e005737fa;
var $24f47dcfb45069ca$export$b624eff549462981;
var $24f47dcfb45069ca$export$7897aa7841a5380c;
var $24f47dcfb45069ca$export$602eac185826482c;
var $24f47dcfb45069ca$export$e2c29f18771995cb;
var $24f47dcfb45069ca$export$5f8d39834fd61797;
var $24f47dcfb45069ca$export$74bf444e3cd11ea5;
var $24f47dcfb45069ca$export$998bcd577473dd93;
var $24f47dcfb45069ca$export$92387174baf9b227;
var $24f47dcfb45069ca$export$ec112efeb987d9c6;
var $24f47dcfb45069ca$export$b706b080d889d2c9;
var $24f47dcfb45069ca$export$5be5a87408f70ddc;
var $24f47dcfb45069ca$export$45a5e7f76e0caa8d;
var $24f47dcfb45069ca$export$455c2e768291efa6;
var $24f47dcfb45069ca$export$9522e17588c12572;
var $24f47dcfb45069ca$export$2110ac352bb060b9;
var $24f47dcfb45069ca$export$56885ab8b9c456ab;
var $24f47dcfb45069ca$export$d927fcb6adf8f9de;
var $24f47dcfb45069ca$export$b82d16f27459e05a;
var $24f47dcfb45069ca$export$522c17b4f5e123e8;
var $24f47dcfb45069ca$export$1aabd8a0274ecfd6;
var $24f47dcfb45069ca$export$3d6c20d97e46b957;
var $24f47dcfb45069ca$export$9b621391a187a31a;
var $24f47dcfb45069ca$export$f5bbd400c2f4426f;
"use strict";
var $24f47dcfb45069ca$var$b = Symbol.for("react.element"), $24f47dcfb45069ca$var$c = Symbol.for("react.portal"), $24f47dcfb45069ca$var$d = Symbol.for("react.fragment"), $24f47dcfb45069ca$var$e = Symbol.for("react.strict_mode"), $24f47dcfb45069ca$var$f = Symbol.for("react.profiler"), $24f47dcfb45069ca$var$g = Symbol.for("react.provider"), $24f47dcfb45069ca$var$h = Symbol.for("react.context"), $24f47dcfb45069ca$var$k = Symbol.for("react.server_context"), $24f47dcfb45069ca$var$l = Symbol.for("react.forward_ref"), $24f47dcfb45069ca$var$m = Symbol.for("react.suspense"), $24f47dcfb45069ca$var$n = Symbol.for("react.suspense_list"), $24f47dcfb45069ca$var$p = Symbol.for("react.memo"), $24f47dcfb45069ca$var$q = Symbol.for("react.lazy"), $24f47dcfb45069ca$var$t = Symbol.for("react.offscreen"), $24f47dcfb45069ca$var$u;
$24f47dcfb45069ca$var$u = Symbol.for("react.module.reference");
function $24f47dcfb45069ca$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $24f47dcfb45069ca$var$b:
                switch(a = a.type, a){
                    case $24f47dcfb45069ca$var$d:
                    case $24f47dcfb45069ca$var$f:
                    case $24f47dcfb45069ca$var$e:
                    case $24f47dcfb45069ca$var$m:
                    case $24f47dcfb45069ca$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $24f47dcfb45069ca$var$k:
                            case $24f47dcfb45069ca$var$h:
                            case $24f47dcfb45069ca$var$l:
                            case $24f47dcfb45069ca$var$q:
                            case $24f47dcfb45069ca$var$p:
                            case $24f47dcfb45069ca$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $24f47dcfb45069ca$var$c:
                return r;
        }
    }
}
$24f47dcfb45069ca$export$a7c73072b1a182ae = $24f47dcfb45069ca$var$h;
$24f47dcfb45069ca$export$9f27bc3417b4524d = $24f47dcfb45069ca$var$g;
$24f47dcfb45069ca$export$db77ccec0bb4ccac = $24f47dcfb45069ca$var$b;
$24f47dcfb45069ca$export$8392c0c9d3dcbd35 = $24f47dcfb45069ca$var$l;
$24f47dcfb45069ca$export$ffb0004e005737fa = $24f47dcfb45069ca$var$d;
$24f47dcfb45069ca$export$b624eff549462981 = $24f47dcfb45069ca$var$q;
$24f47dcfb45069ca$export$7897aa7841a5380c = $24f47dcfb45069ca$var$p;
$24f47dcfb45069ca$export$602eac185826482c = $24f47dcfb45069ca$var$c;
$24f47dcfb45069ca$export$e2c29f18771995cb = $24f47dcfb45069ca$var$f;
$24f47dcfb45069ca$export$5f8d39834fd61797 = $24f47dcfb45069ca$var$e;
$24f47dcfb45069ca$export$74bf444e3cd11ea5 = $24f47dcfb45069ca$var$m;
$24f47dcfb45069ca$export$998bcd577473dd93 = $24f47dcfb45069ca$var$n;
$24f47dcfb45069ca$export$92387174baf9b227 = function() {
    return !1;
};
$24f47dcfb45069ca$export$ec112efeb987d9c6 = function() {
    return !1;
};
$24f47dcfb45069ca$export$b706b080d889d2c9 = function(a) {
    return $24f47dcfb45069ca$var$v(a) === $24f47dcfb45069ca$var$h;
};
$24f47dcfb45069ca$export$5be5a87408f70ddc = function(a) {
    return $24f47dcfb45069ca$var$v(a) === $24f47dcfb45069ca$var$g;
};
$24f47dcfb45069ca$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $24f47dcfb45069ca$var$b;
};
$24f47dcfb45069ca$export$455c2e768291efa6 = function(a) {
    return $24f47dcfb45069ca$var$v(a) === $24f47dcfb45069ca$var$l;
};
$24f47dcfb45069ca$export$9522e17588c12572 = function(a) {
    return $24f47dcfb45069ca$var$v(a) === $24f47dcfb45069ca$var$d;
};
$24f47dcfb45069ca$export$2110ac352bb060b9 = function(a) {
    return $24f47dcfb45069ca$var$v(a) === $24f47dcfb45069ca$var$q;
};
$24f47dcfb45069ca$export$56885ab8b9c456ab = function(a) {
    return $24f47dcfb45069ca$var$v(a) === $24f47dcfb45069ca$var$p;
};
$24f47dcfb45069ca$export$d927fcb6adf8f9de = function(a) {
    return $24f47dcfb45069ca$var$v(a) === $24f47dcfb45069ca$var$c;
};
$24f47dcfb45069ca$export$b82d16f27459e05a = function(a) {
    return $24f47dcfb45069ca$var$v(a) === $24f47dcfb45069ca$var$f;
};
$24f47dcfb45069ca$export$522c17b4f5e123e8 = function(a) {
    return $24f47dcfb45069ca$var$v(a) === $24f47dcfb45069ca$var$e;
};
$24f47dcfb45069ca$export$1aabd8a0274ecfd6 = function(a) {
    return $24f47dcfb45069ca$var$v(a) === $24f47dcfb45069ca$var$m;
};
$24f47dcfb45069ca$export$3d6c20d97e46b957 = function(a) {
    return $24f47dcfb45069ca$var$v(a) === $24f47dcfb45069ca$var$n;
};
$24f47dcfb45069ca$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $24f47dcfb45069ca$var$d || a === $24f47dcfb45069ca$var$f || a === $24f47dcfb45069ca$var$e || a === $24f47dcfb45069ca$var$m || a === $24f47dcfb45069ca$var$n || a === $24f47dcfb45069ca$var$t || "object" === typeof a && null !== a && (a.$$typeof === $24f47dcfb45069ca$var$q || a.$$typeof === $24f47dcfb45069ca$var$p || a.$$typeof === $24f47dcfb45069ca$var$g || a.$$typeof === $24f47dcfb45069ca$var$h || a.$$typeof === $24f47dcfb45069ca$var$l || a.$$typeof === $24f47dcfb45069ca$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$24f47dcfb45069ca$export$f5bbd400c2f4426f = $24f47dcfb45069ca$var$v;

});

parcelRegister("6cKfH", function(module, exports) {
"use strict";
var $4847bdd08a4db190$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4847bdd08a4db190$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $4847bdd08a4db190$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$4847bdd08a4db190$var$__exportStar((parcelRequire("4mnkV")), module.exports);

$4847bdd08a4db190$var$__exportStar((parcelRequire("7yVzo")), module.exports);

$4847bdd08a4db190$var$__exportStar((parcelRequire("kYslP")), module.exports);

$4847bdd08a4db190$var$__exportStar((parcelRequire("7ubjM")), module.exports);

$4847bdd08a4db190$var$__exportStar((parcelRequire("7ag45")), module.exports);

$4847bdd08a4db190$var$__exportStar((parcelRequire("5iXRZ")), module.exports);

$4847bdd08a4db190$var$__exportStar((parcelRequire("eVVZl")), module.exports);

$4847bdd08a4db190$var$__exportStar((parcelRequire("cqRmZ")), module.exports);

$4847bdd08a4db190$var$__exportStar((parcelRequire("mWGMO")), module.exports);

$4847bdd08a4db190$var$__exportStar((parcelRequire("exsS4")), module.exports);

$4847bdd08a4db190$var$__exportStar((parcelRequire("2Ie67")), module.exports);

$4847bdd08a4db190$var$__exportStar((parcelRequire("a2Isw")), module.exports);

$4847bdd08a4db190$var$__exportStar((parcelRequire("cK8Vm")), module.exports);

$4847bdd08a4db190$var$__exportStar((parcelRequire("9xHlz")), module.exports);

$4847bdd08a4db190$var$__exportStar((parcelRequire("4jidN")), module.exports);

// Auth
$4847bdd08a4db190$var$__exportStar((parcelRequire("4Z5HV")), module.exports);

$4847bdd08a4db190$var$__exportStar((parcelRequire("7K3x8")), module.exports);

$4847bdd08a4db190$var$__exportStar((parcelRequire("i1RoR")), module.exports);

$4847bdd08a4db190$var$__exportStar((parcelRequire("2Vnxc")), module.exports);

$4847bdd08a4db190$var$__exportStar((parcelRequire("3NwSV")), module.exports);

$4847bdd08a4db190$var$__exportStar((parcelRequire("9UGCn")), module.exports);

$4847bdd08a4db190$var$__exportStar((parcelRequire("h7Cpe")), module.exports);

// Bank
$4847bdd08a4db190$var$__exportStar((parcelRequire("8dOTK")), module.exports);

// Distribution
$4847bdd08a4db190$var$__exportStar((parcelRequire("jwuh5")), module.exports);

$4847bdd08a4db190$var$__exportStar((parcelRequire("jdAT4")), module.exports);

// FeeGrant
$4847bdd08a4db190$var$__exportStar((parcelRequire("kYRT2")), module.exports);

$4847bdd08a4db190$var$__exportStar((parcelRequire("cZl7P")), module.exports);

// Governance
$4847bdd08a4db190$var$__exportStar((parcelRequire("7CQub")), module.exports);

$4847bdd08a4db190$var$__exportStar((parcelRequire("4BeEE")), module.exports);

$4847bdd08a4db190$var$__exportStar((parcelRequire("eK1ja")), module.exports);

$4847bdd08a4db190$var$__exportStar((parcelRequire("gJKqv")), module.exports);

// Market
$4847bdd08a4db190$var$__exportStar((parcelRequire("kKox9")), module.exports);

// MsgAuth
$4847bdd08a4db190$var$__exportStar((parcelRequire("5qYvo")), module.exports);

$4847bdd08a4db190$var$__exportStar((parcelRequire("btOyI")), module.exports);

// Oracle
$4847bdd08a4db190$var$__exportStar((parcelRequire("HTVN1")), module.exports);

$4847bdd08a4db190$var$__exportStar((parcelRequire("9YhJA")), module.exports);

$4847bdd08a4db190$var$__exportStar((parcelRequire("hpFag")), module.exports);

// Parameters
$4847bdd08a4db190$var$__exportStar((parcelRequire("1ZQER")), module.exports);

$4847bdd08a4db190$var$__exportStar((parcelRequire("0239z")), module.exports);

// Slashing
$4847bdd08a4db190$var$__exportStar((parcelRequire("ivinb")), module.exports);

// Staking
$4847bdd08a4db190$var$__exportStar((parcelRequire("hg4M8")), module.exports);

$4847bdd08a4db190$var$__exportStar((parcelRequire("k32CU")), module.exports);

$4847bdd08a4db190$var$__exportStar((parcelRequire("Oysv5")), module.exports);

$4847bdd08a4db190$var$__exportStar((parcelRequire("iTcdG")), module.exports);

$4847bdd08a4db190$var$__exportStar((parcelRequire("56eXa")), module.exports);

// Treasury
$4847bdd08a4db190$var$__exportStar((parcelRequire("ijOp6")), module.exports);

// Vesting
$4847bdd08a4db190$var$__exportStar((parcelRequire("4WQ5t")), module.exports);

// Upgrade
$4847bdd08a4db190$var$__exportStar((parcelRequire("aFUf1")), module.exports);

// WASM
$4847bdd08a4db190$var$__exportStar((parcelRequire("47xVX")), module.exports);

$4847bdd08a4db190$var$__exportStar((parcelRequire("5W049")), module.exports);

$4847bdd08a4db190$var$__exportStar((parcelRequire("k0M3i")), module.exports);

// IBC
$4847bdd08a4db190$var$__exportStar((parcelRequire("dCZ8i")), module.exports);

$4847bdd08a4db190$var$__exportStar((parcelRequire("6zouD")), module.exports);

$4847bdd08a4db190$var$__exportStar((parcelRequire("1BC4v")), module.exports);

// IBC-transfer
$4847bdd08a4db190$var$__exportStar((parcelRequire("jxUNi")), module.exports);

// bech32 types
$4847bdd08a4db190$var$__exportStar((parcelRequire("kMjuM")), module.exports);

});
parcelRegister("4mnkV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("7yVzo", function(module, exports) {
"use strict";
var $58185d89662c8a61$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Coin = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $5iXRZ = parcelRequire("5iXRZ");

var $lPVUQ = parcelRequire("lPVUQ");
/**
 * Captures `sdk.Coin` and `sdk.DecCoin` from Cosmos SDK. A composite value that combines
 * a denomination with an amount value. Coins are immutable once created, and operations
 * that return Coin will return a new Coin. See [[Coins]] for a collection of Coin objects.
 */ var $58185d89662c8a61$var$Coin = /** @class */ function(_super) {
    $58185d89662c8a61$var$__extends(Coin, _super);
    /**
     * Creates a new coin. Depending on the type of amount, it will be converted to an
     * integer coin or decimal coin.
     *
     * @param denom denomination
     * @param amount coin's amount
     */ function Coin(denom, amount) {
        var _this = _super.call(this) || this;
        _this.denom = denom;
        _this.amount = $5iXRZ.Numeric.parse(amount);
        return _this;
    }
    /**
     * Checks whether the Coin is an Integer coin.
     */ Coin.prototype.isIntCoin = function() {
        // TODO: convert into typeguard
        return this.amount instanceof $5iXRZ.Int;
    };
    /**
     * Checks whether the Coin is a Decimal coin.
     */ Coin.prototype.isDecCoin = function() {
        return this.amount instanceof $5iXRZ.Dec;
    };
    /**
     * Turns the Coin into an Integer coin.
     */ Coin.prototype.toIntCoin = function() {
        return new Coin(this.denom, new $5iXRZ.Int(this.amount));
    };
    /**
     * Turns the Coin into an Integer coin with ceiling the amount.
     */ Coin.prototype.toIntCeilCoin = function() {
        return new Coin(this.denom, new $5iXRZ.Int(this.amount.ceil()));
    };
    /**
     * Turns the Coin into a Decimal coin.
     */ Coin.prototype.toDecCoin = function() {
        return new Coin(this.denom, new $5iXRZ.Dec(this.amount));
    };
    /**
     * Outputs `<amount><denom>`.
     *
     * Eg: `Coin('uluna', 1500) -> 1500uluna`
     */ Coin.prototype.toString = function() {
        var amount = this.amount.toFixed();
        if (this.isDecCoin() && amount.indexOf(".") === -1) return "".concat(amount, ".0").concat(this.denom);
        return "".concat(amount).concat(this.denom);
    };
    Coin.fromString = function(str) {
        var m = str.match(/^(-?[0-9]+(\.[0-9]+)?)([0-9a-zA-Z/]+)$/);
        if (m === null) throw new Error("failed to parse to Coin: ".concat(str));
        var amount = m[1];
        var denom = m[3];
        return new Coin(denom, amount);
    };
    /**
     * Creates a new Coin adding to the current value.
     *
     * @param other
     */ Coin.prototype.add = function(other) {
        var otherAmount;
        if (other instanceof Coin) {
            if (other.denom !== this.denom) throw new Coin.ArithmeticError("cannot add two Coins of different denoms: ".concat(this.denom, " and ").concat(other.denom));
            otherAmount = other.amount;
        } else otherAmount = other;
        otherAmount = $5iXRZ.Numeric.parse(otherAmount);
        return new Coin(this.denom, this.amount.add(otherAmount));
    };
    /**
     * Creates a new Coin subtracting from the current value.
     * @param other
     */ Coin.prototype.sub = function(other) {
        var otherAmount;
        if (other instanceof Coin) {
            if (other.denom !== this.denom) throw new Coin.ArithmeticError("cannot subtract two Coins of different denoms: ".concat(this.denom, " and ").concat(other.denom));
            otherAmount = other.amount;
        } else otherAmount = other;
        otherAmount = $5iXRZ.Numeric.parse(otherAmount);
        return new Coin(this.denom, this.amount.sub(otherAmount));
    };
    /**
     * Multiplies the current value with an amount.
     * @param other
     */ Coin.prototype.mul = function(other) {
        var otherAmount = $5iXRZ.Numeric.parse(other);
        return new Coin(this.denom, this.amount.mul(otherAmount));
    };
    /**
     * Divides the current value with an amount.
     * @param other
     */ Coin.prototype.div = function(other) {
        var otherAmount = $5iXRZ.Numeric.parse(other);
        return new Coin(this.denom, this.amount.div(otherAmount));
    };
    /**
     * Modulo the current value with an amount.
     * @param other
     */ Coin.prototype.mod = function(other) {
        var otherAmount = $5iXRZ.Numeric.parse(other);
        return new Coin(this.denom, this.amount.mod(otherAmount));
    };
    Coin.fromAmino = function(data) {
        var denom = data.denom, amount = data.amount;
        return new Coin(denom, amount);
    };
    Coin.prototype.toAmino = function() {
        var _a = this, denom = _a.denom, amount = _a.amount;
        return {
            denom: denom,
            amount: amount.toString()
        };
    };
    Coin.fromData = function(data) {
        var denom = data.denom, amount = data.amount;
        return new Coin(denom, amount);
    };
    Coin.prototype.toData = function() {
        var _a = this, denom = _a.denom, amount = _a.amount;
        return {
            denom: denom,
            amount: amount.toString()
        };
    };
    Coin.fromProto = function(proto) {
        return new Coin(proto.denom, $5iXRZ.Numeric.parse(proto.amount));
    };
    Coin.prototype.toProto = function() {
        return $lPVUQ.Coin.fromPartial({
            denom: this.denom,
            amount: this.amount.toString()
        });
    };
    return Coin;
}($26Eqx.JSONSerializable);
module.exports.Coin = $58185d89662c8a61$var$Coin;
(function(Coin) {
    var ArithmeticError = /** @class */ function() {
        function ArithmeticError(message) {
            this.message = message;
        }
        return ArithmeticError;
    }();
    Coin.ArithmeticError = ArithmeticError;
})($58185d89662c8a61$var$Coin = module.exports.Coin || (module.exports.Coin = {}));
module.exports.Coin = $58185d89662c8a61$var$Coin;

});
parcelRegister("26Eqx", function(module, exports) {
"use strict";
var $188b80440b652b17$var$__assign = module.exports && module.exports.__assign || function() {
    $188b80440b652b17$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $188b80440b652b17$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.removeNull = module.exports.JSONSerializable = module.exports.prepareSignBytes = void 0;
function $188b80440b652b17$var$prepareSignBytes(obj) {
    if (Array.isArray(obj)) return obj.map($188b80440b652b17$var$prepareSignBytes);
    // string, number, or null
    if (typeof obj !== "object" || obj === null) return obj;
    var sorted = {};
    Object.keys(obj).sort().forEach(function(key) {
        if (obj[key] === undefined || obj[key] === null) return;
        sorted[key] = $188b80440b652b17$var$prepareSignBytes(obj[key]);
    });
    return sorted;
}
module.exports.prepareSignBytes = $188b80440b652b17$var$prepareSignBytes;
var $188b80440b652b17$var$JSONSerializable = /** @class */ function() {
    function JSONSerializable() {}
    JSONSerializable.prototype.toJSON = function(isClassic) {
        return JSON.stringify($188b80440b652b17$var$prepareSignBytes(this.toData(isClassic)));
    };
    JSONSerializable.prototype.toAminoJSON = function(isClassic) {
        return JSON.stringify($188b80440b652b17$var$prepareSignBytes(this.toAmino(isClassic)));
    };
    return JSONSerializable;
}();
module.exports.JSONSerializable = $188b80440b652b17$var$JSONSerializable;
function $188b80440b652b17$var$removeNull(obj) {
    if (obj !== null && typeof obj === "object") return Object.entries(obj).filter(function(_a) {
        var v = _a[1];
        return v != null;
    }).reduce(function(acc, _a) {
        var _b;
        var k = _a[0], v = _a[1];
        return $188b80440b652b17$var$__assign($188b80440b652b17$var$__assign({}, acc), (_b = {}, _b[k] = v === Object(v) && !Array.isArray(v) ? $188b80440b652b17$var$removeNull(v) : v, _b));
    }, {});
    return obj;
}
module.exports.removeNull = $188b80440b652b17$var$removeNull;

});

parcelRegister("5iXRZ", function(module, exports) {
"use strict";
var $3dcd131a6ce6768e$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $3dcd131a6ce6768e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.int = module.exports.dec = module.exports.Int = module.exports.Dec = module.exports.Numeric = module.exports.DEC_PRECISION = void 0;

var $3dcd131a6ce6768e$var$decimal_js_1 = $3dcd131a6ce6768e$var$__importDefault((parcelRequire("4qPUL")));
module.exports.DEC_PRECISION = 18;
var $3dcd131a6ce6768e$var$Numeric;
(function(Numeric) {
    function parse(value) {
        if (value instanceof $3dcd131a6ce6768e$var$Dec) return value;
        else if (typeof value === "string") {
            if (value.includes(".")) return new $3dcd131a6ce6768e$var$Dec(value);
            else return new $3dcd131a6ce6768e$var$Int(value);
        } else {
            var _value = new $3dcd131a6ce6768e$var$decimal_js_1.default(value);
            if (_value.isInteger()) return new $3dcd131a6ce6768e$var$Int(_value);
            else return new $3dcd131a6ce6768e$var$Dec(_value.toString());
        }
    }
    Numeric.parse = parse;
})($3dcd131a6ce6768e$var$Numeric = module.exports.Numeric || (module.exports.Numeric = {}));
/**
 * Represents decimal values serialized with 18 digits of precision. This implementation
 * is based on the `decimal.js` library, and returns Dec values for only [[Dec.add]],
 * [[Dec.sub]], [[Dec.mul]], [[Dec.div]], and [[Dec.mod]]. For other methods inherited
 * from `Decimal`, you will need to convert back to `Dec` to remain compatible for
 * submitting information that requires `Dec` format back to the blockchain.
 *
 * Example:
 *
 * ```ts
 * const dec = new Dec(1.5);
 *
 * const decimal = dec.sqrt();
 * const dec2 = new Dec(decimal);
 */ var $3dcd131a6ce6768e$var$Dec = /** @class */ function(_super) {
    $3dcd131a6ce6768e$var$__extends(Dec, _super);
    function Dec(arg) {
        return _super.call(this, (arg !== null && arg !== void 0 ? arg : 0).toString()) || this;
    }
    Dec.prototype.toString = function() {
        return this.toFixed(module.exports.DEC_PRECISION);
    };
    Dec.withPrec = function(value, prec) {
        return new Dec(new Dec(value).div(Math.pow(10, prec)));
    };
    // type conversion
    Dec.prototype.toInt = function() {
        return new $3dcd131a6ce6768e$var$Int(this);
    };
    // arithmetic
    Dec.prototype.add = function(other) {
        var val = new Dec($3dcd131a6ce6768e$var$Numeric.parse(other));
        return new Dec(_super.prototype.add.call(this, val));
    };
    Dec.prototype.sub = function(other) {
        var val = new Dec($3dcd131a6ce6768e$var$Numeric.parse(other));
        return new Dec(_super.prototype.sub.call(this, val));
    };
    Dec.prototype.mul = function(other) {
        var val = new Dec($3dcd131a6ce6768e$var$Numeric.parse(other));
        return new Dec(_super.prototype.mul.call(this, val));
    };
    Dec.prototype.div = function(other) {
        var val = new Dec($3dcd131a6ce6768e$var$Numeric.parse(other));
        return new Dec(_super.prototype.div.call(this, val));
    };
    Dec.prototype.mod = function(other) {
        var val = new Dec($3dcd131a6ce6768e$var$Numeric.parse(other));
        return new Dec(_super.prototype.mod.call(this, val));
    };
    return Dec;
}($3dcd131a6ce6768e$var$decimal_js_1.default);
module.exports.Dec = $3dcd131a6ce6768e$var$Dec;
var $3dcd131a6ce6768e$var$_Int = $3dcd131a6ce6768e$var$decimal_js_1.default.clone();
/**
 * Represents Integer values. Used mainly to store integer values of [[Coin]] and [[Coins]].
 *
 * Note: Do not use to work with values greater than 9999999999999999999. This
 * implementation is based on the `decimal.js` library, and returns Int values for only
 * [[Int.add]], [[Int.sub]], [[Int.mul]], [[Int.div]], and [[Int.mod]]. For other
 * methods inherited from `Decimal`, you will need to convert back to `Int` to remain
 * compatible for submitting information that requires `Int` format back to the
 * blockchain.
 *
 * Example:
 *
 * ```ts
 * const int = new Int(1.5);
 *
 * const decimal = int.pow(3);
 * const int2 = new Int(decimal);
 */ var $3dcd131a6ce6768e$var$Int = /** @class */ function(_super) {
    $3dcd131a6ce6768e$var$__extends(Int, _super);
    function Int(arg) {
        var _arg = new $3dcd131a6ce6768e$var$decimal_js_1.default((arg !== null && arg !== void 0 ? arg : 0).toString());
        return _super.call(this, _arg.divToInt(1)) || this;
    }
    Int.prototype.toString = function() {
        return this.toFixed();
    };
    // type conversion
    Int.prototype.toDec = function() {
        return new $3dcd131a6ce6768e$var$Dec(this);
    };
    // artihmetic
    Int.prototype.add = function(other) {
        var val = $3dcd131a6ce6768e$var$Numeric.parse(other);
        if (val instanceof $3dcd131a6ce6768e$var$Dec) return new $3dcd131a6ce6768e$var$Dec(this).add(val);
        else return new Int(this.plus(val));
    };
    Int.prototype.sub = function(other) {
        var val = $3dcd131a6ce6768e$var$Numeric.parse(other);
        if (val instanceof $3dcd131a6ce6768e$var$Dec) return new $3dcd131a6ce6768e$var$Dec(this).sub(val);
        else return new Int(this.minus(val));
    };
    Int.prototype.mul = function(other) {
        var val = $3dcd131a6ce6768e$var$Numeric.parse(other);
        if (val instanceof $3dcd131a6ce6768e$var$Dec) return new $3dcd131a6ce6768e$var$Dec(this).mul(val);
        else return new Int(this.times(val));
    };
    Int.prototype.div = function(other) {
        var val = $3dcd131a6ce6768e$var$Numeric.parse(other);
        if (val instanceof $3dcd131a6ce6768e$var$Dec) return new $3dcd131a6ce6768e$var$Dec(this).div(val);
        else return new Int(_super.prototype.div.call(this, val));
    };
    Int.prototype.mod = function(other) {
        var val = $3dcd131a6ce6768e$var$Numeric.parse(other);
        if (val instanceof $3dcd131a6ce6768e$var$Dec) return new $3dcd131a6ce6768e$var$Dec(this).mod(val);
        else return new Int(_super.prototype.mod.call(this, val));
    };
    return Int;
}($3dcd131a6ce6768e$var$_Int);
module.exports.Int = $3dcd131a6ce6768e$var$Int;
/**
 * Template tagged literal for creating new Dec objects out of literal string.
 * This does not support literal string interpolation  with `${}`.
 *
 * Usage is:
 *
 * ```ts
 * import { dec } from "@terra-money/terra.js";
 *
 * const dec1 = dec`234.12312`;
 * const dec2 = new Dec("234.12312");
 *
 * dec1.equals(dec2);
 * ```
 * @param strings
 */ function $3dcd131a6ce6768e$var$dec(strings) {
    return new $3dcd131a6ce6768e$var$Dec(strings[0]);
}
module.exports.dec = $3dcd131a6ce6768e$var$dec;
/**
 * Template tagged literal for creating new Int objects out of literal string.
 * This does not support literal string interpolation  with `${}`.
 *
 * Usage is:
 *
 * ```ts
 * import { int } from "@terra-money/terra.js";
 *
 * const int1 = int`234`;
 * const int2 = new Int("234");
 *
 * int1.equals(int2);
 * ```
 * @param strings
 */ function $3dcd131a6ce6768e$var$int(strings) {
    return new $3dcd131a6ce6768e$var$Int(strings[0]);
}
module.exports.int = $3dcd131a6ce6768e$var$int;

});

parcelRegister("lPVUQ", function(module, exports) {
"use strict";
var $fe5b4942ffab0ebd$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DecProto = module.exports.IntProto = module.exports.DecCoin = module.exports.Coin = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $fe5b4942ffab0ebd$var$long_1 = $fe5b4942ffab0ebd$var$__importDefault((parcelRequire("9A55m")));

const $fe5b4942ffab0ebd$var$minimal_1 = $fe5b4942ffab0ebd$var$__importDefault((parcelRequire("i2pIU")));
module.exports.protobufPackage = "cosmos.base.v1beta1";
const $fe5b4942ffab0ebd$var$baseCoin = {
    denom: "",
    amount: ""
};
module.exports.Coin = {
    encode (message, writer = $fe5b4942ffab0ebd$var$minimal_1.default.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.amount !== "") writer.uint32(18).string(message.amount);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fe5b4942ffab0ebd$var$minimal_1.default.Reader ? input : new $fe5b4942ffab0ebd$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $fe5b4942ffab0ebd$var$baseCoin);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $fe5b4942ffab0ebd$var$baseCoin);
        if (object.denom !== undefined && object.denom !== null) message.denom = String(object.denom);
        else message.denom = "";
        if (object.amount !== undefined && object.amount !== null) message.amount = String(object.amount);
        else message.amount = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $fe5b4942ffab0ebd$var$baseCoin);
        if (object.denom !== undefined && object.denom !== null) message.denom = object.denom;
        else message.denom = "";
        if (object.amount !== undefined && object.amount !== null) message.amount = object.amount;
        else message.amount = "";
        return message;
    }
};
const $fe5b4942ffab0ebd$var$baseDecCoin = {
    denom: "",
    amount: ""
};
module.exports.DecCoin = {
    encode (message, writer = $fe5b4942ffab0ebd$var$minimal_1.default.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.amount !== "") writer.uint32(18).string(message.amount);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fe5b4942ffab0ebd$var$minimal_1.default.Reader ? input : new $fe5b4942ffab0ebd$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $fe5b4942ffab0ebd$var$baseDecCoin);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $fe5b4942ffab0ebd$var$baseDecCoin);
        if (object.denom !== undefined && object.denom !== null) message.denom = String(object.denom);
        else message.denom = "";
        if (object.amount !== undefined && object.amount !== null) message.amount = String(object.amount);
        else message.amount = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $fe5b4942ffab0ebd$var$baseDecCoin);
        if (object.denom !== undefined && object.denom !== null) message.denom = object.denom;
        else message.denom = "";
        if (object.amount !== undefined && object.amount !== null) message.amount = object.amount;
        else message.amount = "";
        return message;
    }
};
const $fe5b4942ffab0ebd$var$baseIntProto = {
    int: ""
};
module.exports.IntProto = {
    encode (message, writer = $fe5b4942ffab0ebd$var$minimal_1.default.Writer.create()) {
        if (message.int !== "") writer.uint32(10).string(message.int);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fe5b4942ffab0ebd$var$minimal_1.default.Reader ? input : new $fe5b4942ffab0ebd$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $fe5b4942ffab0ebd$var$baseIntProto);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.int = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $fe5b4942ffab0ebd$var$baseIntProto);
        if (object.int !== undefined && object.int !== null) message.int = String(object.int);
        else message.int = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.int !== undefined && (obj.int = message.int);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $fe5b4942ffab0ebd$var$baseIntProto);
        if (object.int !== undefined && object.int !== null) message.int = object.int;
        else message.int = "";
        return message;
    }
};
const $fe5b4942ffab0ebd$var$baseDecProto = {
    dec: ""
};
module.exports.DecProto = {
    encode (message, writer = $fe5b4942ffab0ebd$var$minimal_1.default.Writer.create()) {
        if (message.dec !== "") writer.uint32(10).string(message.dec);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fe5b4942ffab0ebd$var$minimal_1.default.Reader ? input : new $fe5b4942ffab0ebd$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $fe5b4942ffab0ebd$var$baseDecProto);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.dec = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $fe5b4942ffab0ebd$var$baseDecProto);
        if (object.dec !== undefined && object.dec !== null) message.dec = String(object.dec);
        else message.dec = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.dec !== undefined && (obj.dec = message.dec);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $fe5b4942ffab0ebd$var$baseDecProto);
        if (object.dec !== undefined && object.dec !== null) message.dec = object.dec;
        else message.dec = "";
        return message;
    }
};
if ($fe5b4942ffab0ebd$var$minimal_1.default.util.Long !== $fe5b4942ffab0ebd$var$long_1.default) {
    $fe5b4942ffab0ebd$var$minimal_1.default.util.Long = $fe5b4942ffab0ebd$var$long_1.default;
    $fe5b4942ffab0ebd$var$minimal_1.default.configure();
}

});


parcelRegister("kYslP", function(module, exports) {
"use strict";
var $f44f672c09dcf566$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $f44f672c09dcf566$var$__assign = module.exports && module.exports.__assign || function() {
    $f44f672c09dcf566$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f44f672c09dcf566$var$__assign.apply(this, arguments);
};
var $f44f672c09dcf566$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Coins = void 0;

var $7yVzo = parcelRequire("7yVzo");

var $26Eqx = parcelRequire("26Eqx");
/**
 * Analagous to `sdk.Coins` and `sdk.DecCoins` from Cosmos-SDK, and represents a collection
 * of [[Coin]] objects.
 *
 */ var $f44f672c09dcf566$var$Coins = /** @class */ function(_super) {
    $f44f672c09dcf566$var$__extends(Coins, _super);
    /**
     * @param arg coins to input
     */ function Coins(arg) {
        if (arg === void 0) arg = {};
        var _this = _super.call(this) || this;
        if (arg instanceof Coins) _this._coins = $f44f672c09dcf566$var$__assign({}, arg._coins);
        else if (typeof arg === "string") _this._coins = Coins.fromString(arg)._coins;
        else {
            _this._coins = {};
            var coins_2;
            if (!Array.isArray(arg)) {
                coins_2 = [];
                Object.keys(arg).forEach(function(denom) {
                    return coins_2.push(new $7yVzo.Coin(denom, arg[denom]));
                });
            } else coins_2 = arg;
            for(var _i = 0, coins_1 = coins_2; _i < coins_1.length; _i++){
                var coin = coins_1[_i];
                var denom = coin.denom;
                var x = _this._coins[denom];
                if (x !== undefined) _this._coins[denom] = x.add(coin);
                else _this._coins[denom] = coin;
            }
            // convert all coins to Dec if one is Dec
            if (!_this.toArray().every(function(c) {
                return c.isIntCoin();
            })) for(var _a = 0, _b = Object.keys(_this._coins); _a < _b.length; _a++){
                var denom = _b[_a];
                _this._coins[denom] = _this._coins[denom].toDecCoin();
            }
        }
        return _this;
    }
    // implement iterator interface for interop
    Coins.prototype[Symbol.iterator] = function() {
        var index = -1;
        var data = this.toArray();
        return {
            next: function() {
                return {
                    value: data[++index],
                    done: index === data.length
                };
            }
        };
    };
    /**
     * Converts the Coins information to a comma-separated list.
     *
     * Eg: `15000ukrw,12000uluna`
     */ Coins.prototype.toString = function() {
        return this.toArray().map(function(c) {
            return c.toString();
        }).join(",");
    };
    /**
     * Converts a comma-separated list of coins to a Coins object
     *
     * Eg. `1500ukrw,12302uluna`
     *
     * @param str comma-separated list of coins
     */ Coins.fromString = function(str) {
        var coin_strings = str.split(/,\s*/);
        var coins = coin_strings.map(function(s) {
            return $7yVzo.Coin.fromString(s);
        });
        return new Coins(coins);
    };
    /**
     * Gets the list of denominations
     */ Coins.prototype.denoms = function() {
        return this.map(function(c) {
            return c.denom;
        });
    };
    /**
     * Creates a new Coins object with all Decimal coins
     */ Coins.prototype.toDecCoins = function() {
        return new Coins(this.map(function(c) {
            return c.toDecCoin();
        }));
    };
    /**
     * Creates a new Coins object with all Integer coins
     */ Coins.prototype.toIntCoins = function() {
        return new Coins(this.map(function(c) {
            return c.toIntCoin();
        }));
    };
    /**
     * Creates a new Coins object with all Integer coins with ceiling the amount
     */ Coins.prototype.toIntCeilCoins = function() {
        return new Coins(this.map(function(c) {
            return c.toIntCeilCoin();
        }));
    };
    /**
     * Gets the Coin for denomination if it exists in the collection.
     * @param denom denomination to lookup
     */ Coins.prototype.get = function(denom) {
        return this._coins[denom];
    };
    /**
     * Sets the Coin value for a denomination.
     * @param denom denomination to set
     * @param value value to set
     */ Coins.prototype.set = function(denom, value) {
        var val;
        if (value instanceof $7yVzo.Coin) {
            if (value.denom != denom) throw new Error("Denoms must match when setting: ".concat(denom, ", ").concat(value.denom));
            val = value;
        } else val = new $7yVzo.Coin(denom, value);
        this._coins[denom] = val;
    };
    /**
     * Gets the individual elements of the collection.
     */ Coins.prototype.toArray = function() {
        return Object.values(this._coins).sort(function(a, b) {
            return a.denom.localeCompare(b.denom);
        });
    };
    /**
     * Adds a value from the elements of the collection. Coins of a similar denomination
     * will be clobbered into one value containing their sum.
     * @param other
     */ Coins.prototype.add = function(other) {
        if (other instanceof $7yVzo.Coin) return new Coins($f44f672c09dcf566$var$__spreadArray([
            other
        ], Object.values(this._coins), true));
        else return new Coins($f44f672c09dcf566$var$__spreadArray($f44f672c09dcf566$var$__spreadArray([], Object.values(other._coins), true), Object.values(this._coins), true));
    };
    /**
     * Subtracts a value from the elements of the collection.
     * @param other
     */ Coins.prototype.sub = function(other) {
        return this.add(other.mul(-1));
    };
    /**
     * Multiplies the elements of the collection by a value.
     * @param other
     */ Coins.prototype.mul = function(other) {
        return new Coins(this.map(function(c) {
            return c.mul(other);
        }));
    };
    /**
     * Divides the elements of the collection by a value.
     * @param other
     */ Coins.prototype.div = function(other) {
        return new Coins(this.map(function(c) {
            return c.div(other);
        }));
    };
    /**
     * Modulos the elements of the collection with a value.
     * @param other
     */ Coins.prototype.mod = function(other) {
        return new Coins(this.map(function(c) {
            return c.mod(other);
        }));
    };
    /**
     * Map a value onto the elements of the Coin collection.
     * @param fn
     */ Coins.prototype.map = function(fn) {
        return this.toArray().map(fn);
    };
    /**
     * Filters out the Coin objects that don't match the predicate
     * @param fn predicate
     */ Coins.prototype.filter = function(fn) {
        return new Coins(this.toArray().filter(fn));
    };
    Coins.fromAmino = function(data) {
        return new Coins((data !== null && data !== void 0 ? data : []).map($7yVzo.Coin.fromAmino));
    };
    Coins.prototype.toAmino = function() {
        return this.toArray().map(function(c) {
            return c.toAmino();
        });
    };
    Coins.fromData = function(data) {
        return new Coins((data !== null && data !== void 0 ? data : []).map($7yVzo.Coin.fromData));
    };
    Coins.prototype.toData = function() {
        return this.toArray().map(function(c) {
            return c.toData();
        });
    };
    Coins.fromProto = function(data) {
        return new Coins((data !== null && data !== void 0 ? data : []).map($7yVzo.Coin.fromProto));
    };
    Coins.prototype.toProto = function() {
        return this.toArray().map(function(c) {
            return c.toProto();
        });
    };
    return Coins;
}($26Eqx.JSONSerializable);
module.exports.Coins = $f44f672c09dcf566$var$Coins;

});

parcelRegister("7ubjM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("7ag45", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Msg = void 0;

var $8dOTK = parcelRequire("8dOTK");

var $jwuh5 = parcelRequire("jwuh5");

var $kYRT2 = parcelRequire("kYRT2");

var $7CQub = parcelRequire("7CQub");

var $kKox9 = parcelRequire("kKox9");

var $5qYvo = parcelRequire("5qYvo");

var $HTVN1 = parcelRequire("HTVN1");

var $ivinb = parcelRequire("ivinb");

var $hg4M8 = parcelRequire("hg4M8");

var $kpoM2 = parcelRequire("kpoM2");

var $5W049 = parcelRequire("5W049");

var $jxUNi = parcelRequire("jxUNi");

var $6zouD = parcelRequire("6zouD");

var $1BC4v = parcelRequire("1BC4v");

var $dCZ8i = parcelRequire("dCZ8i");

var $22QhG = parcelRequire("22QhG");
var $5375edb9f33f8983$var$Msg;
(function(Msg) {
    function fromAmino(data, isClassic) {
        switch(data.type){
            // bank
            case "bank/MsgSend":
            case "cosmos-sdk/MsgSend":
                return $8dOTK.MsgSend.fromAmino(data, isClassic);
            case "bank/MsgMultiSend":
            case "cosmos-sdk/MsgMultiSend":
                return $8dOTK.MsgMultiSend.fromAmino(data, isClassic);
            // distribution
            case "distribution/MsgModifyWithdrawAddress":
            case "cosmos-sdk/MsgModifyWithdrawAddress":
                return $jwuh5.MsgSetWithdrawAddress.fromAmino(data, isClassic);
            case "distribution/MsgWithdrawDelegationReward":
            case "cosmos-sdk/MsgWithdrawDelegationReward":
                return $jwuh5.MsgWithdrawDelegatorReward.fromAmino(data, isClassic);
            case "distribution/MsgWithdrawValidatorCommission":
            case "cosmos-sdk/MsgWithdrawValidatorCommission":
                return $jwuh5.MsgWithdrawValidatorCommission.fromAmino(data, isClassic);
            case "distribution/MsgFundCommunityPool":
            case "cosmos-sdk/MsgFundCommunityPool":
                return $jwuh5.MsgFundCommunityPool.fromAmino(data, isClassic);
            // feegrant
            case "feegrant/MsgGrantAllowance":
            case "cosmos-sdk/MsgGrantAllowance":
                return $kYRT2.MsgGrantAllowance.fromAmino(data, isClassic);
            case "feegrant/MsgRevokeAllowance":
            case "cosmos-sdk/MsgRevokeAllowance":
                return $kYRT2.MsgRevokeAllowance.fromAmino(data, isClassic);
            // gov
            case "gov/MsgDeposit":
            case "cosmos-sdk/MsgDeposit":
                return $7CQub.MsgDeposit.fromAmino(data, isClassic);
            case "gov/MsgSubmitProposal":
            case "cosmos-sdk/MsgSubmitProposal":
                return $7CQub.MsgSubmitProposal.fromAmino(data, isClassic);
            case "gov/MsgVote":
            case "cosmos-sdk/MsgVote":
                return $7CQub.MsgVote.fromAmino(data, isClassic);
            case "gov/MsgVoteWeighted":
            case "cosmos-sdk/MsgVoteWeighted":
                return $7CQub.MsgVoteWeighted.fromAmino(data, isClassic);
            // market
            case "market/MsgSwap":
                return $kKox9.MsgSwap.fromAmino(data, isClassic);
            case "market/MsgSwapSend":
                return $kKox9.MsgSwapSend.fromAmino(data, isClassic);
            // msgauth
            case "msgauth/MsgGrantAuthorization":
            case "cosmos-sdk/MsgGrant":
                return $5qYvo.MsgGrantAuthorization.fromAmino(data, isClassic);
            case "msgauth/MsgRevokeAuthorization":
            case "cosmos-sdk/MsgRevoke":
                return $5qYvo.MsgRevokeAuthorization.fromAmino(data, isClassic);
            case "msgauth/MsgExecAuthorized":
            case "cosmos-sdk/MsgExec":
                return $5qYvo.MsgExecAuthorized.fromAmino(data, isClassic);
            // oracle
            case "oracle/MsgDelegateFeedConsent":
                return $HTVN1.MsgDelegateFeedConsent.fromAmino(data, isClassic);
            case "oracle/MsgAggregateExchangeRatePrevote":
                return $HTVN1.MsgAggregateExchangeRatePrevote.fromAmino(data, isClassic);
            case "oracle/MsgAggregateExchangeRateVote":
                return $HTVN1.MsgAggregateExchangeRateVote.fromAmino(data, isClassic);
            // slashing
            case "slashing/MsgUnjail":
            case "cosmos-sdk/MsgUnjail":
                return $ivinb.MsgUnjail.fromAmino(data, isClassic);
            // staking
            case "staking/MsgDelegate":
            case "cosmos-sdk/MsgDelegate":
                return $hg4M8.MsgDelegate.fromAmino(data, isClassic);
            case "staking/MsgUndelegate":
            case "cosmos-sdk/MsgUndelegate":
                return $hg4M8.MsgUndelegate.fromAmino(data, isClassic);
            case "staking/MsgBeginRedelegate":
            case "cosmos-sdk/MsgBeginRedelegate":
                return $hg4M8.MsgBeginRedelegate.fromAmino(data, isClassic);
            case "staking/MsgCreateValidator":
            case "cosmos-sdk/MsgCreateValidator":
                return $hg4M8.MsgCreateValidator.fromAmino(data, isClassic);
            case "staking/MsgEditValidator":
            case "cosmos-sdk/MsgEditValidator":
                return $hg4M8.MsgEditValidator.fromAmino(data, isClassic);
            // vesting
            case "cosmos-sdk/MsgCreatePeriodicVestingAccount":
                return $kpoM2.MsgCreatePeriodicVestingAccount.fromAmino(data, isClassic);
            case "cosmos-sdk/MsgCreateVestingAccount":
                return $kpoM2.MsgCreateVestingAccount.fromAmino(data, isClassic);
            case "cosmos-sdk/MsgDonateAllVestingTokens":
                return $kpoM2.MsgDonateAllVestingTokens.fromAmino(data, isClassic);
            // wasm
            case "wasm/MsgStoreCode":
                return $5W049.MsgStoreCode.fromAmino(data, isClassic);
            case "wasm/MsgMigrateCode":
                return $5W049.MsgMigrateCode.fromAmino(data, isClassic);
            case "wasm/MsgInstantiateContract":
                return $5W049.MsgInstantiateContract.fromAmino(data, isClassic);
            case "wasm/MsgExecuteContract":
                return $5W049.MsgExecuteContract.fromAmino(data, isClassic);
            case "wasm/MsgMigrateContract":
                return $5W049.MsgMigrateContract.fromAmino(data, isClassic);
            case "wasm/MsgUpdateContractAdmin":
            case "wasm/MsgUpdateAdmin":
                return $5W049.MsgUpdateContractAdmin.fromAmino(data, isClassic);
            case "wasm/MsgClearContractAdmin":
            case "wasm/MsgClearAdmin":
                return $5W049.MsgClearContractAdmin.fromAmino(data, isClassic);
            // ibc-transfer
            case "cosmos-sdk/MsgTransfer":
                return $jxUNi.MsgTransfer.fromAmino(data, isClassic);
            // crisis
            case "crisis/MsgVerifyInvariant":
            case "cosmos-sdk/MsgVerifyInvariant":
                return $22QhG.MsgVerifyInvariant.fromAmino(data, isClassic);
        }
    }
    Msg.fromAmino = fromAmino;
    function fromData(data, isClassic) {
        switch(data["@type"]){
            // bank
            case "/cosmos.bank.v1beta1.MsgSend":
                return $8dOTK.MsgSend.fromData(data, isClassic);
            case "/cosmos.bank.v1beta1.MsgMultiSend":
                return $8dOTK.MsgMultiSend.fromData(data, isClassic);
            // distribution
            case "/cosmos.distribution.v1beta1.MsgSetWithdrawAddress":
                return $jwuh5.MsgSetWithdrawAddress.fromData(data, isClassic);
            case "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward":
                return $jwuh5.MsgWithdrawDelegatorReward.fromData(data, isClassic);
            case "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission":
                return $jwuh5.MsgWithdrawValidatorCommission.fromData(data, isClassic);
            case "/cosmos.distribution.v1beta1.MsgFundCommunityPool":
                return $jwuh5.MsgFundCommunityPool.fromData(data, isClassic);
            // feegrant
            case "/cosmos.feegrant.v1beta1.MsgGrantAllowance":
                return $kYRT2.MsgGrantAllowance.fromData(data, isClassic);
            case "/cosmos.feegrant.v1beta1.MsgRevokeAllowance":
                return $kYRT2.MsgRevokeAllowance.fromData(data, isClassic);
            // gov
            case "/cosmos.gov.v1beta1.MsgDeposit":
                return $7CQub.MsgDeposit.fromData(data, isClassic);
            case "/cosmos.gov.v1beta1.MsgSubmitProposal":
                return $7CQub.MsgSubmitProposal.fromData(data, isClassic);
            case "/cosmos.gov.v1beta1.MsgVote":
                return $7CQub.MsgVote.fromData(data, isClassic);
            case "/cosmos.gov.v1beta1.MsgVoteWeighted":
                return $7CQub.MsgVoteWeighted.fromData(data, isClassic);
            // market
            case "/terra.market.v1beta1.MsgSwap":
                return $kKox9.MsgSwap.fromData(data, isClassic);
            case "/terra.market.v1beta1.MsgSwapSend":
                return $kKox9.MsgSwapSend.fromData(data, isClassic);
            // authz
            case "/cosmos.authz.v1beta1.MsgGrant":
                return $5qYvo.MsgGrantAuthorization.fromData(data, isClassic);
            case "/cosmos.authz.v1beta1.MsgRevoke":
                return $5qYvo.MsgRevokeAuthorization.fromData(data, isClassic);
            case "/cosmos.authz.v1beta1.MsgExec":
                return $5qYvo.MsgExecAuthorized.fromData(data, isClassic);
            // oracle
            case "/terra.oracle.v1beta1.MsgDelegateFeedConsent":
                return $HTVN1.MsgDelegateFeedConsent.fromData(data, isClassic);
            case "/terra.oracle.v1beta1.MsgAggregateExchangeRatePrevote":
                return $HTVN1.MsgAggregateExchangeRatePrevote.fromData(data, isClassic);
            case "/terra.oracle.v1beta1.MsgAggregateExchangeRateVote":
                return $HTVN1.MsgAggregateExchangeRateVote.fromData(data, isClassic);
            // slashing
            case "/cosmos.slashing.v1beta1.MsgUnjail":
                return $ivinb.MsgUnjail.fromData(data, isClassic);
            // staking
            case "/cosmos.staking.v1beta1.MsgDelegate":
                return $hg4M8.MsgDelegate.fromData(data, isClassic);
            case "/cosmos.staking.v1beta1.MsgUndelegate":
                return $hg4M8.MsgUndelegate.fromData(data, isClassic);
            case "/cosmos.staking.v1beta1.MsgBeginRedelegate":
                return $hg4M8.MsgBeginRedelegate.fromData(data, isClassic);
            case "/cosmos.staking.v1beta1.MsgCreateValidator":
                return $hg4M8.MsgCreateValidator.fromData(data, isClassic);
            case "/cosmos.staking.v1beta1.MsgEditValidator":
                return $hg4M8.MsgEditValidator.fromData(data, isClassic);
            // vesting
            case "/cosmos.vesting.v1beta1.MsgCreatePeriodicVestingAccount":
                return $kpoM2.MsgCreatePeriodicVestingAccount.fromData(data, isClassic);
            case "/cosmos.vesting.v1beta1.MsgCreateVestingAccount":
                return $kpoM2.MsgCreateVestingAccount.fromData(data, isClassic);
            case "/cosmos.vesting.v1beta1.MsgDonateAllVestingTokens":
                return $kpoM2.MsgDonateAllVestingTokens.fromData(data, isClassic);
            // wasm
            case "/terra.wasm.v1beta1.MsgStoreCode":
            case "/cosmwasm.wasm.v1.MsgStoreCode":
                return $5W049.MsgStoreCode.fromData(data, isClassic);
            case "/terra.wasm.v1beta1.MsgMigrateCode":
                return $5W049.MsgMigrateCode.fromData(data, isClassic);
            case "/terra.wasm.v1beta1.MsgInstantiateContract":
            case "/cosmwasm.wasm.v1.MsgInstantiateContract":
                return $5W049.MsgInstantiateContract.fromData(data, isClassic);
            case "/terra.wasm.v1beta1.MsgExecuteContract":
            case "/cosmwasm.wasm.v1.MsgExecuteContract":
                return $5W049.MsgExecuteContract.fromData(data, isClassic);
            case "/terra.wasm.v1beta1.MsgMigrateContract":
            case "/cosmwasm.wasm.v1.MsgMigrateContract":
                return $5W049.MsgMigrateContract.fromData(data, isClassic);
            case "/terra.wasm.v1beta1.MsgUpdateContractAdmin":
            case "/cosmwasm.wasm.v1.MsgUpdateAdmin":
                return $5W049.MsgUpdateContractAdmin.fromData(data, isClassic);
            case "/terra.wasm.v1beta1.MsgClearContractAdmin":
            case "/cosmwasm.wasm.v1.MsgClearAdmin":
                return $5W049.MsgClearContractAdmin.fromData(data, isClassic);
            // ibc-transfer
            case "/ibc.applications.transfer.v1.MsgTransfer":
                return $jxUNi.MsgTransfer.fromData(data, isClassic);
            // ibc-client
            case "/ibc.core.client.v1.MsgCreateClient":
                return $6zouD.MsgCreateClient.fromData(data, isClassic);
            case "/ibc.core.client.v1.MsgUpdateClient":
                return $6zouD.MsgUpdateClient.fromData(data, isClassic);
            case "/ibc.core.client.v1.MsgUpgradeClient":
                return $6zouD.MsgUpgradeClient.fromData(data, isClassic);
            case "/ibc.core.client.v1.MsgSubmitMisbehaviour":
                return $6zouD.MsgSubmitMisbehaviour.fromData(data, isClassic);
            // ibc-connection
            case "/ibc.core.connection.v1.MsgConnectionOpenInit":
                return $1BC4v.MsgConnectionOpenInit.fromData(data, isClassic);
            case "/ibc.core.connection.v1.MsgConnectionOpenTry":
                return $1BC4v.MsgConnectionOpenTry.fromData(data, isClassic);
            case "/ibc.core.connection.v1.MsgConnectionOpenConfirm":
                return $1BC4v.MsgConnectionOpenConfirm.fromData(data, isClassic);
            case "/ibc.core.connection.v1.MsgConnectionOpenAck":
                return $1BC4v.MsgConnectionOpenAck.fromData(data, isClassic);
            // ibc-channel
            case "/ibc.core.channel.v1.MsgChannelOpenInit":
                return $dCZ8i.MsgChannelOpenInit.fromData(data, isClassic);
            case "/ibc.core.channel.v1.MsgChannelOpenTry":
                return $dCZ8i.MsgChannelOpenTry.fromData(data, isClassic);
            case "/ibc.core.channel.v1.MsgChannelOpenConfirm":
                return $dCZ8i.MsgChannelOpenConfirm.fromData(data, isClassic);
            case "/ibc.core.channel.v1.MsgChannelOpenAck":
                return $dCZ8i.MsgChannelOpenAck.fromData(data, isClassic);
            case "/ibc.core.channel.v1.MsgChannelCloseInit":
                return $dCZ8i.MsgChannelCloseInit.fromData(data, isClassic);
            case "/ibc.core.channel.v1.MsgChannelCloseConfirm":
                return $dCZ8i.MsgChannelCloseConfirm.fromData(data, isClassic);
            case "/ibc.core.channel.v1.MsgRecvPacket":
                return $dCZ8i.MsgRecvPacket.fromData(data, isClassic);
            case "/ibc.core.channel.v1.MsgAcknowledgement":
                return $dCZ8i.MsgAcknowledgement.fromData(data, isClassic);
            case "/ibc.core.channel.v1.MsgTimeout":
                return $dCZ8i.MsgTimeout.fromData(data, isClassic);
            case "/ibc.core.channel.v1.MsgTimeoutOnClose":
                return $dCZ8i.MsgTimeoutOnClose.fromData(data, isClassic);
            // crisis
            case "/cosmos.crisis.v1beta1.MsgVerifyInvariant":
                return $22QhG.MsgVerifyInvariant.fromData(data, isClassic);
            default:
                throw Error("not supported msg ".concat(data["@type"]));
        }
    }
    Msg.fromData = fromData;
    function fromProto(proto, isClassic) {
        switch(proto.typeUrl){
            // bank
            case "/cosmos.bank.v1beta1.MsgSend":
                return $8dOTK.MsgSend.unpackAny(proto, isClassic);
            case "/cosmos.bank.v1beta1.MsgMultiSend":
                return $8dOTK.MsgMultiSend.unpackAny(proto, isClassic);
            // distribution
            case "/cosmos.distribution.v1beta1.MsgSetWithdrawAddress":
                return $jwuh5.MsgSetWithdrawAddress.unpackAny(proto, isClassic);
            case "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward":
                return $jwuh5.MsgWithdrawDelegatorReward.unpackAny(proto, isClassic);
            case "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission":
                return $jwuh5.MsgWithdrawValidatorCommission.unpackAny(proto, isClassic);
            case "/cosmos.distribution.v1beta1.MsgFundCommunityPool":
                return $jwuh5.MsgFundCommunityPool.unpackAny(proto, isClassic);
            // feegrant
            case "/cosmos.feegrant.v1beta1.MsgGrantAllowance":
                return $kYRT2.MsgGrantAllowance.unpackAny(proto, isClassic);
            case "/cosmos.feegrant.v1beta1.MsgRevokeAllowance":
                return $kYRT2.MsgRevokeAllowance.unpackAny(proto, isClassic);
            // gov
            case "/cosmos.gov.v1beta1.MsgDeposit":
                return $7CQub.MsgDeposit.unpackAny(proto, isClassic);
            case "/cosmos.gov.v1beta1.MsgSubmitProposal":
                return $7CQub.MsgSubmitProposal.unpackAny(proto, isClassic);
            case "/cosmos.gov.v1beta1.MsgVote":
                return $7CQub.MsgVote.unpackAny(proto, isClassic);
            // market
            case "/terra.market.v1beta1.MsgSwap":
                return $kKox9.MsgSwap.unpackAny(proto, isClassic);
            case "/terra.market.v1beta1.MsgSwapSend":
                return $kKox9.MsgSwapSend.unpackAny(proto, isClassic);
            // authz
            case "/cosmos.authz.v1beta1.MsgGrant":
                return $5qYvo.MsgGrantAuthorization.unpackAny(proto, isClassic);
            case "/cosmos.authz.v1beta1.MsgRevoke":
                return $5qYvo.MsgRevokeAuthorization.unpackAny(proto, isClassic);
            case "/cosmos.authz.v1beta1.MsgExec":
                return $5qYvo.MsgExecAuthorized.unpackAny(proto, isClassic);
            // oracle
            case "/terra.oracle.v1beta1.MsgDelegateFeedConsent":
                return $HTVN1.MsgDelegateFeedConsent.unpackAny(proto, isClassic);
            case "/terra.oracle.v1beta1.MsgAggregateExchangeRatePrevote":
                return $HTVN1.MsgAggregateExchangeRatePrevote.unpackAny(proto, isClassic);
            case "/terra.oracle.v1beta1.MsgAggregateExchangeRateVote":
                return $HTVN1.MsgAggregateExchangeRateVote.unpackAny(proto, isClassic);
            // slashing
            case "/cosmos.slashing.v1beta1.MsgUnjail":
                return $ivinb.MsgUnjail.unpackAny(proto, isClassic);
            // staking
            case "/cosmos.staking.v1beta1.MsgDelegate":
                return $hg4M8.MsgDelegate.unpackAny(proto, isClassic);
            case "/cosmos.staking.v1beta1.MsgUndelegate":
                return $hg4M8.MsgUndelegate.unpackAny(proto, isClassic);
            case "/cosmos.staking.v1beta1.MsgBeginRedelegate":
                return $hg4M8.MsgBeginRedelegate.unpackAny(proto, isClassic);
            case "/cosmos.staking.v1beta1.MsgCreateValidator":
                return $hg4M8.MsgCreateValidator.unpackAny(proto, isClassic);
            case "/cosmos.staking.v1beta1.MsgEditValidator":
                return $hg4M8.MsgEditValidator.unpackAny(proto, isClassic);
            // vesting
            case "/cosmos.vesting.v1beta1.MsgCreatePeriodicVestingAccount":
                return $kpoM2.MsgCreatePeriodicVestingAccount.unpackAny(proto, isClassic);
            case "/cosmos.vesting.v1beta1.MsgCreateVestingAccount":
                return $kpoM2.MsgCreateVestingAccount.unpackAny(proto, isClassic);
            case "/cosmos.vesting.v1beta1.MsgDonateAllVestingTokens":
                return $kpoM2.MsgDonateAllVestingTokens.unpackAny(proto, isClassic);
            // wasm
            case "/terra.wasm.v1beta1.MsgStoreCode":
            case "/cosmwasm.wasm.v1.MsgStoreCode":
                return $5W049.MsgStoreCode.unpackAny(proto, isClassic);
            case "/terra.wasm.v1beta1.MsgMigrateCode":
                return $5W049.MsgMigrateCode.unpackAny(proto, isClassic);
            case "/terra.wasm.v1beta1.MsgInstantiateContract":
            case "/cosmwasm.wasm.v1.MsgInstantiateContract":
                return $5W049.MsgInstantiateContract.unpackAny(proto, isClassic);
            case "/terra.wasm.v1beta1.MsgExecuteContract":
            case "/cosmwasm.wasm.v1.MsgExecuteContract":
                return $5W049.MsgExecuteContract.unpackAny(proto, isClassic);
            case "/terra.wasm.v1beta1.MsgMigrateContract":
            case "/cosmwasm.wasm.v1beta1.MsgMigrateContract":
                return $5W049.MsgMigrateContract.unpackAny(proto, isClassic);
            case "/terra.wasm.v1beta1.MsgUpdateContractAdmin":
            case "/cosmwasm.wasm.v1beta1.MsgUpdateAdmin":
                return $5W049.MsgUpdateContractAdmin.unpackAny(proto, isClassic);
            case "/terra.wasm.v1beta1.MsgClearContractAdmin":
            case "/cosmwasm.wasm.v1.MsgClearAdmin":
                return $5W049.MsgClearContractAdmin.unpackAny(proto, isClassic);
            // ibc-transfer
            case "/ibc.applications.transfer.v1.MsgTransfer":
                return $jxUNi.MsgTransfer.unpackAny(proto, isClassic);
            // ibc-client
            case "/ibc.core.client.v1.MsgCreateClient":
                return $6zouD.MsgCreateClient.unpackAny(proto, isClassic);
            case "/ibc.core.client.v1.MsgUpdateClient":
                return $6zouD.MsgUpdateClient.unpackAny(proto, isClassic);
            case "/ibc.core.client.v1.MsgUpgradeClient":
                return $6zouD.MsgUpgradeClient.unpackAny(proto, isClassic);
            case "/ibc.core.client.v1.MsgSubmitMisbehaviour":
                return $6zouD.MsgSubmitMisbehaviour.unpackAny(proto, isClassic);
            // ibc-connection
            case "/ibc.core.connection.v1.MsgConnectionOpenInit":
                return $1BC4v.MsgConnectionOpenInit.unpackAny(proto, isClassic);
            case "/ibc.core.connection.v1.MsgConnectionOpenTry":
                return $1BC4v.MsgConnectionOpenTry.unpackAny(proto, isClassic);
            case "/ibc.core.connection.v1.MsgConnectionOpenConfirm":
                return $1BC4v.MsgConnectionOpenConfirm.unpackAny(proto, isClassic);
            case "/ibc.core.connection.v1.MsgConnectionOpenAck":
                return $1BC4v.MsgConnectionOpenAck.unpackAny(proto, isClassic);
            // ibc-channel
            case "/ibc.core.channel.v1.MsgChannelOpenInit":
                return $dCZ8i.MsgChannelOpenInit.unpackAny(proto, isClassic);
            case "/ibc.core.channel.v1.MsgChannelOpenTry":
                return $dCZ8i.MsgChannelOpenTry.unpackAny(proto, isClassic);
            case "/ibc.core.channel.v1.MsgChannelOpenConfirm":
                return $dCZ8i.MsgChannelOpenConfirm.unpackAny(proto, isClassic);
            case "/ibc.core.channel.v1.MsgChannelOpenAck":
                return $dCZ8i.MsgChannelOpenAck.unpackAny(proto, isClassic);
            case "/ibc.core.channel.v1.MsgChannelCloseInit":
                return $dCZ8i.MsgChannelCloseInit.unpackAny(proto, isClassic);
            case "/ibc.core.channel.v1.MsgChannelCloseConfirm":
                return $dCZ8i.MsgChannelCloseConfirm.unpackAny(proto, isClassic);
            case "/ibc.core.channel.v1.MsgRecvPacket":
                return $dCZ8i.MsgRecvPacket.unpackAny(proto, isClassic);
            case "/ibc.core.channel.v1.MsgAcknowledgement":
                return $dCZ8i.MsgAcknowledgement.unpackAny(proto, isClassic);
            case "/ibc.core.channel.v1.MsgTimeout":
                return $dCZ8i.MsgTimeout.unpackAny(proto, isClassic);
            case "/ibc.core.channel.v1.MsgTimeoutOnClose":
                return $dCZ8i.MsgTimeoutOnClose.unpackAny(proto, isClassic);
            // crisis
            case "/cosmos.crisis.v1beta1.MsgVerifyInvariant":
                return $22QhG.MsgVerifyInvariant.unpackAny(proto, isClassic);
            default:
                throw Error("not supported msg ".concat(proto.typeUrl));
        }
    }
    Msg.fromProto = fromProto;
})($5375edb9f33f8983$var$Msg = module.exports.Msg || (module.exports.Msg = {}));

});
parcelRegister("8dOTK", function(module, exports) {
"use strict";
var $5fc704ec50de9ee5$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5fc704ec50de9ee5$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $5fc704ec50de9ee5$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$5fc704ec50de9ee5$var$__exportStar((parcelRequire("jDYKn")), module.exports);

$5fc704ec50de9ee5$var$__exportStar((parcelRequire("7kPaS")), module.exports);

});
parcelRegister("jDYKn", function(module, exports) {
"use strict";
var $e4d0c7ef0d7107fb$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgSend = void 0;

var $kYslP = parcelRequire("kYslP");

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $5vZfe = parcelRequire("5vZfe");
/**
 * A basic message for sending [[Coins]] between Terra accounts.
 */ var $e4d0c7ef0d7107fb$var$MsgSend = /** @class */ function(_super) {
    $e4d0c7ef0d7107fb$var$__extends(MsgSend, _super);
    /**
     * @param from_address sender's address
     * @param to_address recipient's address
     * @param amount value of the transaction
     */ function MsgSend(from_address, to_address, amount) {
        var _this = _super.call(this) || this;
        _this.from_address = from_address;
        _this.to_address = to_address;
        _this.amount = new $kYslP.Coins(amount);
        return _this;
    }
    MsgSend.fromAmino = function(data, _) {
        _;
        var _a = data.value, from_address = _a.from_address, to_address = _a.to_address, amount = _a.amount;
        return new MsgSend(from_address, to_address, $kYslP.Coins.fromAmino(amount));
    };
    MsgSend.prototype.toAmino = function(isClassic) {
        var _a = this, from_address = _a.from_address, to_address = _a.to_address, amount = _a.amount;
        return {
            type: isClassic ? "bank/MsgSend" : "cosmos-sdk/MsgSend",
            value: {
                from_address: from_address,
                to_address: to_address,
                amount: amount.toAmino()
            }
        };
    };
    MsgSend.fromData = function(data, isClassic) {
        isClassic;
        var from_address = data.from_address, to_address = data.to_address, amount = data.amount;
        return new MsgSend(from_address, to_address, $kYslP.Coins.fromData(amount));
    };
    MsgSend.prototype.toData = function(_) {
        _;
        var _a = this, from_address = _a.from_address, to_address = _a.to_address, amount = _a.amount;
        return {
            "@type": "/cosmos.bank.v1beta1.MsgSend",
            from_address: from_address,
            to_address: to_address,
            amount: amount.toData()
        };
    };
    MsgSend.fromProto = function(proto, _) {
        _;
        return new MsgSend(proto.fromAddress, proto.toAddress, $kYslP.Coins.fromProto(proto.amount));
    };
    MsgSend.prototype.toProto = function(_) {
        _;
        var _a = this, from_address = _a.from_address, to_address = _a.to_address, amount = _a.amount;
        return $5vZfe.MsgSend.fromPartial({
            fromAddress: from_address,
            toAddress: to_address,
            amount: amount.toProto()
        });
    };
    MsgSend.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmos.bank.v1beta1.MsgSend",
            value: $5vZfe.MsgSend.encode(this.toProto(isClassic)).finish()
        });
    };
    MsgSend.unpackAny = function(msgAny, isClassic) {
        return MsgSend.fromProto($5vZfe.MsgSend.decode(msgAny.value), isClassic);
    };
    return MsgSend;
}($26Eqx.JSONSerializable);
module.exports.MsgSend = $e4d0c7ef0d7107fb$var$MsgSend;

});
parcelRegister("c5FxR", function(module, exports) {
"use strict";
var $8cd62da8cf1a5979$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Any = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $8cd62da8cf1a5979$var$long_1 = $8cd62da8cf1a5979$var$__importDefault((parcelRequire("9A55m")));

const $8cd62da8cf1a5979$var$minimal_1 = $8cd62da8cf1a5979$var$__importDefault((parcelRequire("i2pIU")));
module.exports.protobufPackage = "google.protobuf";
const $8cd62da8cf1a5979$var$baseAny = {
    typeUrl: ""
};
module.exports.Any = {
    encode (message, writer = $8cd62da8cf1a5979$var$minimal_1.default.Writer.create()) {
        if (message.typeUrl !== "") writer.uint32(10).string(message.typeUrl);
        if (message.value.length !== 0) writer.uint32(18).bytes(message.value);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8cd62da8cf1a5979$var$minimal_1.default.Reader ? input : new $8cd62da8cf1a5979$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $8cd62da8cf1a5979$var$baseAny);
        message.value = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.typeUrl = reader.string();
                    break;
                case 2:
                    message.value = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $8cd62da8cf1a5979$var$baseAny);
        message.value = new Uint8Array();
        if (object.typeUrl !== undefined && object.typeUrl !== null) message.typeUrl = String(object.typeUrl);
        else message.typeUrl = "";
        if (object.value !== undefined && object.value !== null) message.value = $8cd62da8cf1a5979$var$bytesFromBase64(object.value);
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.typeUrl !== undefined && (obj.typeUrl = message.typeUrl);
        message.value !== undefined && (obj.value = $8cd62da8cf1a5979$var$base64FromBytes(message.value !== undefined ? message.value : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $8cd62da8cf1a5979$var$baseAny);
        if (object.typeUrl !== undefined && object.typeUrl !== null) message.typeUrl = object.typeUrl;
        else message.typeUrl = "";
        if (object.value !== undefined && object.value !== null) message.value = object.value;
        else message.value = new Uint8Array();
        return message;
    }
};
var $8cd62da8cf1a5979$var$globalThis = (()=>{
    if (typeof $8cd62da8cf1a5979$var$globalThis !== "undefined") return $8cd62da8cf1a5979$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $8cd62da8cf1a5979$var$atob = $8cd62da8cf1a5979$var$globalThis.atob || ((b64)=>$8cd62da8cf1a5979$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $8cd62da8cf1a5979$var$bytesFromBase64(b64) {
    const bin = $8cd62da8cf1a5979$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $8cd62da8cf1a5979$var$btoa = $8cd62da8cf1a5979$var$globalThis.btoa || ((bin)=>$8cd62da8cf1a5979$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $8cd62da8cf1a5979$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $8cd62da8cf1a5979$var$btoa(bin.join(""));
}
if ($8cd62da8cf1a5979$var$minimal_1.default.util.Long !== $8cd62da8cf1a5979$var$long_1.default) {
    $8cd62da8cf1a5979$var$minimal_1.default.util.Long = $8cd62da8cf1a5979$var$long_1.default;
    $8cd62da8cf1a5979$var$minimal_1.default.configure();
}

});

parcelRegister("5vZfe", function(module, exports) {
"use strict";
var $403f5aedba69b5c1$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GrpcWebImpl = module.exports.MsgMultiSendDesc = module.exports.MsgSendDesc = module.exports.MsgDesc = module.exports.MsgClientImpl = module.exports.MsgMultiSendResponse = module.exports.MsgMultiSend = module.exports.MsgSendResponse = module.exports.MsgSend = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $403f5aedba69b5c1$var$long_1 = $403f5aedba69b5c1$var$__importDefault((parcelRequire("9A55m")));

var $jXVni = parcelRequire("jXVni");

const $403f5aedba69b5c1$var$minimal_1 = $403f5aedba69b5c1$var$__importDefault((parcelRequire("i2pIU")));

var $1pqjL = parcelRequire("1pqjL");

var $lPVUQ = parcelRequire("lPVUQ");

var $eVHa3 = parcelRequire("eVHa3");
module.exports.protobufPackage = "cosmos.bank.v1beta1";
const $403f5aedba69b5c1$var$baseMsgSend = {
    fromAddress: "",
    toAddress: ""
};
module.exports.MsgSend = {
    encode (message, writer = $403f5aedba69b5c1$var$minimal_1.default.Writer.create()) {
        if (message.fromAddress !== "") writer.uint32(10).string(message.fromAddress);
        if (message.toAddress !== "") writer.uint32(18).string(message.toAddress);
        for (const v of message.amount)$lPVUQ.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $403f5aedba69b5c1$var$minimal_1.default.Reader ? input : new $403f5aedba69b5c1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $403f5aedba69b5c1$var$baseMsgSend);
        message.amount = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.fromAddress = reader.string();
                    break;
                case 2:
                    message.toAddress = reader.string();
                    break;
                case 3:
                    message.amount.push($lPVUQ.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $403f5aedba69b5c1$var$baseMsgSend);
        message.amount = [];
        if (object.fromAddress !== undefined && object.fromAddress !== null) message.fromAddress = String(object.fromAddress);
        else message.fromAddress = "";
        if (object.toAddress !== undefined && object.toAddress !== null) message.toAddress = String(object.toAddress);
        else message.toAddress = "";
        if (object.amount !== undefined && object.amount !== null) for (const e of object.amount)message.amount.push($lPVUQ.Coin.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.fromAddress !== undefined && (obj.fromAddress = message.fromAddress);
        message.toAddress !== undefined && (obj.toAddress = message.toAddress);
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $lPVUQ.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $403f5aedba69b5c1$var$baseMsgSend);
        message.amount = [];
        if (object.fromAddress !== undefined && object.fromAddress !== null) message.fromAddress = object.fromAddress;
        else message.fromAddress = "";
        if (object.toAddress !== undefined && object.toAddress !== null) message.toAddress = object.toAddress;
        else message.toAddress = "";
        if (object.amount !== undefined && object.amount !== null) for (const e of object.amount)message.amount.push($lPVUQ.Coin.fromPartial(e));
        return message;
    }
};
const $403f5aedba69b5c1$var$baseMsgSendResponse = {};
module.exports.MsgSendResponse = {
    encode (_, writer = $403f5aedba69b5c1$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $403f5aedba69b5c1$var$minimal_1.default.Reader ? input : new $403f5aedba69b5c1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $403f5aedba69b5c1$var$baseMsgSendResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $403f5aedba69b5c1$var$baseMsgSendResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $403f5aedba69b5c1$var$baseMsgSendResponse);
        return message;
    }
};
const $403f5aedba69b5c1$var$baseMsgMultiSend = {};
module.exports.MsgMultiSend = {
    encode (message, writer = $403f5aedba69b5c1$var$minimal_1.default.Writer.create()) {
        for (const v of message.inputs)$eVHa3.Input.encode(v, writer.uint32(10).fork()).ldelim();
        for (const v of message.outputs)$eVHa3.Output.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $403f5aedba69b5c1$var$minimal_1.default.Reader ? input : new $403f5aedba69b5c1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $403f5aedba69b5c1$var$baseMsgMultiSend);
        message.inputs = [];
        message.outputs = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.inputs.push($eVHa3.Input.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.outputs.push($eVHa3.Output.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $403f5aedba69b5c1$var$baseMsgMultiSend);
        message.inputs = [];
        message.outputs = [];
        if (object.inputs !== undefined && object.inputs !== null) for (const e of object.inputs)message.inputs.push($eVHa3.Input.fromJSON(e));
        if (object.outputs !== undefined && object.outputs !== null) for (const e of object.outputs)message.outputs.push($eVHa3.Output.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.inputs) obj.inputs = message.inputs.map((e)=>e ? $eVHa3.Input.toJSON(e) : undefined);
        else obj.inputs = [];
        if (message.outputs) obj.outputs = message.outputs.map((e)=>e ? $eVHa3.Output.toJSON(e) : undefined);
        else obj.outputs = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $403f5aedba69b5c1$var$baseMsgMultiSend);
        message.inputs = [];
        message.outputs = [];
        if (object.inputs !== undefined && object.inputs !== null) for (const e of object.inputs)message.inputs.push($eVHa3.Input.fromPartial(e));
        if (object.outputs !== undefined && object.outputs !== null) for (const e of object.outputs)message.outputs.push($eVHa3.Output.fromPartial(e));
        return message;
    }
};
const $403f5aedba69b5c1$var$baseMsgMultiSendResponse = {};
module.exports.MsgMultiSendResponse = {
    encode (_, writer = $403f5aedba69b5c1$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $403f5aedba69b5c1$var$minimal_1.default.Reader ? input : new $403f5aedba69b5c1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $403f5aedba69b5c1$var$baseMsgMultiSendResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $403f5aedba69b5c1$var$baseMsgMultiSendResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $403f5aedba69b5c1$var$baseMsgMultiSendResponse);
        return message;
    }
};
class $403f5aedba69b5c1$var$MsgClientImpl {
    Send(request, metadata) {
        return this.rpc.unary(module.exports.MsgSendDesc, module.exports.MsgSend.fromPartial(request), metadata);
    }
    MultiSend(request, metadata) {
        return this.rpc.unary(module.exports.MsgMultiSendDesc, module.exports.MsgMultiSend.fromPartial(request), metadata);
    }
    constructor(rpc){
        this.rpc = rpc;
        this.Send = this.Send.bind(this);
        this.MultiSend = this.MultiSend.bind(this);
    }
}
module.exports.MsgClientImpl = $403f5aedba69b5c1$var$MsgClientImpl;
module.exports.MsgDesc = {
    serviceName: "cosmos.bank.v1beta1.Msg"
};
module.exports.MsgSendDesc = {
    methodName: "Send",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgSend.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgSendResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.MsgMultiSendDesc = {
    methodName: "MultiSend",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgMultiSend.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgMultiSendResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
class $403f5aedba69b5c1$var$GrpcWebImpl {
    unary(methodDesc, _request, metadata) {
        var _a;
        const request = Object.assign(Object.assign({}, _request), methodDesc.requestType);
        const maybeCombinedMetadata = metadata && this.options.metadata ? new $1pqjL.BrowserHeaders(Object.assign(Object.assign({}, (_a = this.options) === null || _a === void 0 ? void 0 : _a.metadata.headersMap), metadata === null || metadata === void 0 ? void 0 : metadata.headersMap)) : metadata || this.options.metadata;
        return new Promise((resolve, reject)=>{
            $jXVni.grpc.unary(methodDesc, {
                request: request,
                host: this.host,
                metadata: maybeCombinedMetadata,
                transport: this.options.transport,
                debug: this.options.debug,
                onEnd: function(response) {
                    if (response.status === $jXVni.grpc.Code.OK) resolve(response.message);
                    else {
                        const err = new Error(response.statusMessage);
                        err.code = response.status;
                        err.metadata = response.trailers;
                        reject(err);
                    }
                }
            });
        });
    }
    constructor(host, options){
        this.host = host;
        this.options = options;
    }
}
module.exports.GrpcWebImpl = $403f5aedba69b5c1$var$GrpcWebImpl;
if ($403f5aedba69b5c1$var$minimal_1.default.util.Long !== $403f5aedba69b5c1$var$long_1.default) {
    $403f5aedba69b5c1$var$minimal_1.default.util.Long = $403f5aedba69b5c1$var$long_1.default;
    $403f5aedba69b5c1$var$minimal_1.default.configure();
}

});
parcelRegister("jXVni", function(module, exports) {
!function(e, t) {
    var r, n;
    module.exports = t();
}(module.exports, function() {
    var e, t;
    return e = {
        418: function(e, t) {
            !function(e, t) {
                for(var r in t)e[r] = t[r];
            }(t, function(e) {
                var t = {};
                function r(n) {
                    if (t[n]) return t[n].exports;
                    var o = t[n] = {
                        i: n,
                        l: !1,
                        exports: {}
                    };
                    return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
                }
                return r.m = e, r.c = t, r.i = function(e) {
                    return e;
                }, r.d = function(e, t, n) {
                    r.o(e, t) || Object.defineProperty(e, t, {
                        configurable: !1,
                        enumerable: !0,
                        get: n
                    });
                }, r.n = function(e) {
                    var t = e && e.__esModule ? function() {
                        return e.default;
                    } : function() {
                        return e;
                    };
                    return r.d(t, "a", t), t;
                }, r.o = function(e, t) {
                    return Object.prototype.hasOwnProperty.call(e, t);
                }, r.p = "", r(r.s = 1);
            }([
                function(e, t, r) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var n = r(3), o = function() {
                        function e(e, t) {
                            void 0 === e && (e = {}), void 0 === t && (t = {
                                splitValues: !1
                            });
                            var r, o = this;
                            this.headersMap = {}, e && ("undefined" != typeof Headers && e instanceof Headers ? n.getHeaderKeys(e).forEach(function(r) {
                                n.getHeaderValues(e, r).forEach(function(e) {
                                    t.splitValues ? o.append(r, n.splitHeaderValue(e)) : o.append(r, e);
                                });
                            }) : "object" == typeof (r = e) && "object" == typeof r.headersMap && "function" == typeof r.forEach ? e.forEach(function(e, t) {
                                o.append(e, t);
                            }) : "undefined" != typeof Map && e instanceof Map ? e.forEach(function(e, t) {
                                o.append(t, e);
                            }) : "string" == typeof e ? this.appendFromString(e) : "object" == typeof e && Object.getOwnPropertyNames(e).forEach(function(t) {
                                var r = e[t];
                                Array.isArray(r) ? r.forEach(function(e) {
                                    o.append(t, e);
                                }) : o.append(t, r);
                            }));
                        }
                        return e.prototype.appendFromString = function(e) {
                            for(var t = e.split("\r\n"), r = 0; r < t.length; r++){
                                var n = t[r], o = n.indexOf(":");
                                if (o > 0) {
                                    var s = n.substring(0, o).trim(), i = n.substring(o + 1).trim();
                                    this.append(s, i);
                                }
                            }
                        }, e.prototype.delete = function(e, t) {
                            var r = n.normalizeName(e);
                            if (void 0 === t) delete this.headersMap[r];
                            else {
                                var o = this.headersMap[r];
                                if (o) {
                                    var s = o.indexOf(t);
                                    s >= 0 && o.splice(s, 1), 0 === o.length && delete this.headersMap[r];
                                }
                            }
                        }, e.prototype.append = function(e, t) {
                            var r = this, o = n.normalizeName(e);
                            Array.isArray(this.headersMap[o]) || (this.headersMap[o] = []), Array.isArray(t) ? t.forEach(function(e) {
                                r.headersMap[o].push(n.normalizeValue(e));
                            }) : this.headersMap[o].push(n.normalizeValue(t));
                        }, e.prototype.set = function(e, t) {
                            var r = n.normalizeName(e);
                            if (Array.isArray(t)) {
                                var o = [];
                                t.forEach(function(e) {
                                    o.push(n.normalizeValue(e));
                                }), this.headersMap[r] = o;
                            } else this.headersMap[r] = [
                                n.normalizeValue(t)
                            ];
                        }, e.prototype.has = function(e, t) {
                            var r = this.headersMap[n.normalizeName(e)];
                            if (!Array.isArray(r)) return !1;
                            if (void 0 !== t) {
                                var o = n.normalizeValue(t);
                                return r.indexOf(o) >= 0;
                            }
                            return !0;
                        }, e.prototype.get = function(e) {
                            var t = this.headersMap[n.normalizeName(e)];
                            return void 0 !== t ? t.concat() : [];
                        }, e.prototype.forEach = function(e) {
                            var t = this;
                            Object.getOwnPropertyNames(this.headersMap).forEach(function(r) {
                                e(r, t.headersMap[r]);
                            }, this);
                        }, e.prototype.toHeaders = function() {
                            if ("undefined" != typeof Headers) {
                                var e = new Headers;
                                return this.forEach(function(t, r) {
                                    r.forEach(function(r) {
                                        e.append(t, r);
                                    });
                                }), e;
                            }
                            throw new Error("Headers class is not defined");
                        }, e;
                    }();
                    t.BrowserHeaders = o;
                },
                function(e, t, r) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var n = r(0);
                    t.BrowserHeaders = n.BrowserHeaders;
                },
                function(e, t, r) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.iterateHeaders = function(e, t) {
                        for(var r = e[Symbol.iterator](), n = r.next(); !n.done;)t(n.value[0]), n = r.next();
                    }, t.iterateHeadersKeys = function(e, t) {
                        for(var r = e.keys(), n = r.next(); !n.done;)t(n.value), n = r.next();
                    };
                },
                function(e, t, r) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var n = r(2);
                    t.normalizeName = function(e) {
                        if ("string" != typeof e && (e = String(e)), /[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(e)) throw new TypeError("Invalid character in header field name");
                        return e.toLowerCase();
                    }, t.normalizeValue = function(e) {
                        return "string" != typeof e && (e = String(e)), e;
                    }, t.getHeaderValues = function(e, t) {
                        var r = e;
                        if (r instanceof Headers && r.getAll) return r.getAll(t);
                        var n = r.get(t);
                        return n && "string" == typeof n ? [
                            n
                        ] : n;
                    }, t.getHeaderKeys = function(e) {
                        var t = e, r = {}, o = [];
                        return t.keys ? n.iterateHeadersKeys(t, function(e) {
                            r[e] || (r[e] = !0, o.push(e));
                        }) : t.forEach ? t.forEach(function(e, t) {
                            r[t] || (r[t] = !0, o.push(t));
                        }) : n.iterateHeaders(t, function(e) {
                            var t = e[0];
                            r[t] || (r[t] = !0, o.push(t));
                        }), o;
                    }, t.splitHeaderValue = function(e) {
                        var t = [];
                        return e.split(", ").forEach(function(e) {
                            e.split(",").forEach(function(e) {
                                t.push(e);
                            });
                        }), t;
                    };
                }
            ]));
        },
        617: function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.ChunkParser = t.ChunkType = t.encodeASCII = t.decodeASCII = void 0;
            var n, o = r(65);
            function s(e) {
                var t;
                return 9 === (t = e) || 10 === t || 13 === t || e >= 32 && e <= 126;
            }
            function i(e) {
                for(var t = 0; t !== e.length; ++t)if (!s(e[t])) throw new Error("Metadata is not valid (printable) ASCII");
                return String.fromCharCode.apply(String, Array.prototype.slice.call(e));
            }
            function a(e) {
                return 128 == (128 & e.getUint8(0));
            }
            function u(e) {
                return e.getUint32(1, !1);
            }
            function d(e, t, r) {
                return e.byteLength - t >= r;
            }
            function c(e, t, r) {
                if (e.slice) return e.slice(t, r);
                var n = e.length;
                void 0 !== r && (n = r);
                for(var o = new Uint8Array(n - t), s = 0, i = t; i < n; i++)o[s++] = e[i];
                return o;
            }
            t.decodeASCII = i, t.encodeASCII = function(e) {
                for(var t = new Uint8Array(e.length), r = 0; r !== e.length; ++r){
                    var n = e.charCodeAt(r);
                    if (!s(n)) throw new Error("Metadata contains invalid ASCII");
                    t[r] = n;
                }
                return t;
            }, function(e) {
                e[e.MESSAGE = 1] = "MESSAGE", e[e.TRAILERS = 2] = "TRAILERS";
            }(n = t.ChunkType || (t.ChunkType = {}));
            var p = function() {
                function e() {
                    this.buffer = null, this.position = 0;
                }
                return e.prototype.parse = function(e, t) {
                    if (0 === e.length && t) return [];
                    var r, s = [];
                    if (null == this.buffer) this.buffer = e, this.position = 0;
                    else if (this.position === this.buffer.byteLength) this.buffer = e, this.position = 0;
                    else {
                        var p = this.buffer.byteLength - this.position, h = new Uint8Array(p + e.byteLength), f = c(this.buffer, this.position);
                        h.set(f, 0);
                        var l = new Uint8Array(e);
                        h.set(l, p), this.buffer = h, this.position = 0;
                    }
                    for(;;){
                        if (!d(this.buffer, this.position, 5)) return s;
                        var g = c(this.buffer, this.position, this.position + 5), b = new DataView(g.buffer, g.byteOffset, g.byteLength), y = u(b);
                        if (!d(this.buffer, this.position, 5 + y)) return s;
                        var v = c(this.buffer, this.position + 5, this.position + 5 + y);
                        if (this.position += 5 + y, a(b)) return s.push({
                            chunkType: n.TRAILERS,
                            trailers: (r = v, new o.Metadata(i(r)))
                        }), s;
                        s.push({
                            chunkType: n.MESSAGE,
                            data: v
                        });
                    }
                }, e;
            }();
            t.ChunkParser = p;
        },
        8: function(e, t) {
            "use strict";
            var r;
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.httpStatusToCode = t.Code = void 0, function(e) {
                e[e.OK = 0] = "OK", e[e.Canceled = 1] = "Canceled", e[e.Unknown = 2] = "Unknown", e[e.InvalidArgument = 3] = "InvalidArgument", e[e.DeadlineExceeded = 4] = "DeadlineExceeded", e[e.NotFound = 5] = "NotFound", e[e.AlreadyExists = 6] = "AlreadyExists", e[e.PermissionDenied = 7] = "PermissionDenied", e[e.ResourceExhausted = 8] = "ResourceExhausted", e[e.FailedPrecondition = 9] = "FailedPrecondition", e[e.Aborted = 10] = "Aborted", e[e.OutOfRange = 11] = "OutOfRange", e[e.Unimplemented = 12] = "Unimplemented", e[e.Internal = 13] = "Internal", e[e.Unavailable = 14] = "Unavailable", e[e.DataLoss = 15] = "DataLoss", e[e.Unauthenticated = 16] = "Unauthenticated";
            }(r = t.Code || (t.Code = {})), t.httpStatusToCode = function(e) {
                switch(e){
                    case 0:
                        return r.Internal;
                    case 200:
                        return r.OK;
                    case 400:
                        return r.InvalidArgument;
                    case 401:
                        return r.Unauthenticated;
                    case 403:
                        return r.PermissionDenied;
                    case 404:
                        return r.NotFound;
                    case 409:
                        return r.Aborted;
                    case 412:
                        return r.FailedPrecondition;
                    case 429:
                        return r.ResourceExhausted;
                    case 499:
                        return r.Canceled;
                    case 500:
                        return r.Unknown;
                    case 501:
                        return r.Unimplemented;
                    case 503:
                        return r.Unavailable;
                    case 504:
                        return r.DeadlineExceeded;
                    default:
                        return r.Unknown;
                }
            };
        },
        934: function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.client = void 0;
            var n = r(65), o = r(617), s = r(8), i = r(346), a = r(57), u = r(882);
            t.client = function(e, t) {
                return new d(e, t);
            };
            var d = function() {
                function e(e, t) {
                    this.started = !1, this.sentFirstMessage = !1, this.completed = !1, this.closed = !1, this.finishedSending = !1, this.onHeadersCallbacks = [], this.onMessageCallbacks = [], this.onEndCallbacks = [], this.parser = new o.ChunkParser, this.methodDefinition = e, this.props = t, this.createTransport();
                }
                return e.prototype.createTransport = function() {
                    var e = this.props.host + "/" + this.methodDefinition.service.serviceName + "/" + this.methodDefinition.methodName, t = {
                        methodDefinition: this.methodDefinition,
                        debug: this.props.debug || !1,
                        url: e,
                        onHeaders: this.onTransportHeaders.bind(this),
                        onChunk: this.onTransportChunk.bind(this),
                        onEnd: this.onTransportEnd.bind(this)
                    };
                    this.props.transport ? this.transport = this.props.transport(t) : this.transport = a.makeDefaultTransport(t);
                }, e.prototype.onTransportHeaders = function(e, t) {
                    if (this.props.debug && i.debug("onHeaders", e, t), this.closed) this.props.debug && i.debug("grpc.onHeaders received after request was closed - ignoring");
                    else if (0 === t) ;
                    else {
                        this.responseHeaders = e, this.props.debug && i.debug("onHeaders.responseHeaders", JSON.stringify(this.responseHeaders, null, 2));
                        var r = c(e);
                        this.props.debug && i.debug("onHeaders.gRPCStatus", r);
                        var n = r && r >= 0 ? r : s.httpStatusToCode(t);
                        this.props.debug && i.debug("onHeaders.code", n);
                        var o = e.get("grpc-message") || [];
                        if (this.props.debug && i.debug("onHeaders.gRPCMessage", o), this.rawOnHeaders(e), n !== s.Code.OK) {
                            var a = this.decodeGRPCStatus(o[0]);
                            this.rawOnError(n, a, e);
                        }
                    }
                }, e.prototype.onTransportChunk = function(e) {
                    var t = this;
                    if (this.closed) this.props.debug && i.debug("grpc.onChunk received after request was closed - ignoring");
                    else {
                        var r = [];
                        try {
                            r = this.parser.parse(e);
                        } catch (e) {
                            return this.props.debug && i.debug("onChunk.parsing error", e, e.message), void this.rawOnError(s.Code.Internal, "parsing error: " + e.message);
                        }
                        r.forEach(function(e) {
                            if (e.chunkType === o.ChunkType.MESSAGE) {
                                var r = t.methodDefinition.responseType.deserializeBinary(e.data);
                                t.rawOnMessage(r);
                            } else e.chunkType === o.ChunkType.TRAILERS && (t.responseHeaders ? (t.responseTrailers = new n.Metadata(e.trailers), t.props.debug && i.debug("onChunk.trailers", t.responseTrailers)) : (t.responseHeaders = new n.Metadata(e.trailers), t.rawOnHeaders(t.responseHeaders)));
                        });
                    }
                }, e.prototype.onTransportEnd = function() {
                    if (this.props.debug && i.debug("grpc.onEnd"), this.closed) this.props.debug && i.debug("grpc.onEnd received after request was closed - ignoring");
                    else if (void 0 !== this.responseTrailers) {
                        var e = c(this.responseTrailers);
                        if (null !== e) {
                            var t = this.responseTrailers.get("grpc-message"), r = this.decodeGRPCStatus(t[0]);
                            this.rawOnEnd(e, r, this.responseTrailers);
                        } else this.rawOnError(s.Code.Internal, "Response closed without grpc-status (Trailers provided)");
                    } else {
                        if (void 0 === this.responseHeaders) return void this.rawOnError(s.Code.Unknown, "Response closed without headers");
                        var n = c(this.responseHeaders), o = this.responseHeaders.get("grpc-message");
                        if (this.props.debug && i.debug("grpc.headers only response ", n, o), null === n) return void this.rawOnEnd(s.Code.Unknown, "Response closed without grpc-status (Headers only)", this.responseHeaders);
                        var a = this.decodeGRPCStatus(o[0]);
                        this.rawOnEnd(n, a, this.responseHeaders);
                    }
                }, e.prototype.decodeGRPCStatus = function(e) {
                    if (!e) return "";
                    try {
                        return decodeURIComponent(e);
                    } catch (t) {
                        return e;
                    }
                }, e.prototype.rawOnEnd = function(e, t, r) {
                    var n = this;
                    this.props.debug && i.debug("rawOnEnd", e, t, r), this.completed || (this.completed = !0, this.onEndCallbacks.forEach(function(o) {
                        if (!n.closed) try {
                            o(e, t, r);
                        } catch (e) {
                            setTimeout(function() {
                                throw e;
                            }, 0);
                        }
                    }));
                }, e.prototype.rawOnHeaders = function(e) {
                    this.props.debug && i.debug("rawOnHeaders", e), this.completed || this.onHeadersCallbacks.forEach(function(t) {
                        try {
                            t(e);
                        } catch (e) {
                            setTimeout(function() {
                                throw e;
                            }, 0);
                        }
                    });
                }, e.prototype.rawOnError = function(e, t, r) {
                    var o = this;
                    void 0 === r && (r = new n.Metadata), this.props.debug && i.debug("rawOnError", e, t), this.completed || (this.completed = !0, this.onEndCallbacks.forEach(function(n) {
                        if (!o.closed) try {
                            n(e, t, r);
                        } catch (e) {
                            setTimeout(function() {
                                throw e;
                            }, 0);
                        }
                    }));
                }, e.prototype.rawOnMessage = function(e) {
                    var t = this;
                    this.props.debug && i.debug("rawOnMessage", e.toObject()), this.completed || this.closed || this.onMessageCallbacks.forEach(function(r) {
                        if (!t.closed) try {
                            r(e);
                        } catch (e) {
                            setTimeout(function() {
                                throw e;
                            }, 0);
                        }
                    });
                }, e.prototype.onHeaders = function(e) {
                    this.onHeadersCallbacks.push(e);
                }, e.prototype.onMessage = function(e) {
                    this.onMessageCallbacks.push(e);
                }, e.prototype.onEnd = function(e) {
                    this.onEndCallbacks.push(e);
                }, e.prototype.start = function(e) {
                    if (this.started) throw new Error("Client already started - cannot .start()");
                    this.started = !0;
                    var t = new n.Metadata(e || {});
                    t.set("content-type", "application/grpc-web+proto"), t.set("x-grpc-web", "1"), this.transport.start(t);
                }, e.prototype.send = function(e) {
                    if (!this.started) throw new Error("Client not started - .start() must be called before .send()");
                    if (this.closed) throw new Error("Client already closed - cannot .send()");
                    if (this.finishedSending) throw new Error("Client already finished sending - cannot .send()");
                    if (!this.methodDefinition.requestStream && this.sentFirstMessage) throw new Error("Message already sent for non-client-streaming method - cannot .send()");
                    this.sentFirstMessage = !0;
                    var t = u.frameRequest(e);
                    this.transport.sendMessage(t);
                }, e.prototype.finishSend = function() {
                    if (!this.started) throw new Error("Client not started - .finishSend() must be called before .close()");
                    if (this.closed) throw new Error("Client already closed - cannot .send()");
                    if (this.finishedSending) throw new Error("Client already finished sending - cannot .finishSend()");
                    this.finishedSending = !0, this.transport.finishSend();
                }, e.prototype.close = function() {
                    if (!this.started) throw new Error("Client not started - .start() must be called before .close()");
                    if (this.closed) throw new Error("Client already closed - cannot .close()");
                    this.closed = !0, this.props.debug && i.debug("request.abort aborting request"), this.transport.cancel();
                }, e;
            }();
            function c(e) {
                var t = e.get("grpc-status") || [];
                if (t.length > 0) try {
                    var r = t[0];
                    return parseInt(r, 10);
                } catch (e) {
                    return null;
                }
                return null;
            }
        },
        346: function(e, t) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.debug = void 0, t.debug = function() {
                for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
                console.debug ? console.debug.apply(null, e) : console.log.apply(null, e);
            };
        },
        607: function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.grpc = void 0;
            var n, o = r(418), s = r(57), i = r(229), a = r(540), u = r(210), d = r(859), c = r(8), p = r(938), h = r(35), f = r(934);
            (n = t.grpc || (t.grpc = {})).setDefaultTransport = s.setDefaultTransportFactory, n.CrossBrowserHttpTransport = d.CrossBrowserHttpTransport, n.FetchReadableStreamTransport = i.FetchReadableStreamTransport, n.XhrTransport = u.XhrTransport, n.WebsocketTransport = a.WebsocketTransport, n.Code = c.Code, n.Metadata = o.BrowserHeaders, n.client = function(e, t) {
                return f.client(e, t);
            }, n.invoke = p.invoke, n.unary = h.unary;
        },
        938: function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.invoke = void 0;
            var n = r(934);
            t.invoke = function(e, t) {
                if (e.requestStream) throw new Error(".invoke cannot be used with client-streaming methods. Use .client instead.");
                var r = n.client(e, {
                    host: t.host,
                    transport: t.transport,
                    debug: t.debug
                });
                return t.onHeaders && r.onHeaders(t.onHeaders), t.onMessage && r.onMessage(t.onMessage), t.onEnd && r.onEnd(t.onEnd), r.start(t.metadata), r.send(t.request), r.finishSend(), {
                    close: function() {
                        r.close();
                    }
                };
            };
        },
        65: function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.Metadata = void 0;
            var n = r(418);
            Object.defineProperty(t, "Metadata", {
                enumerable: !0,
                get: function() {
                    return n.BrowserHeaders;
                }
            });
        },
        57: function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.makeDefaultTransport = t.setDefaultTransportFactory = void 0;
            var n = r(859), o = function(e) {
                return n.CrossBrowserHttpTransport({
                    withCredentials: !1
                })(e);
            };
            t.setDefaultTransportFactory = function(e) {
                o = e;
            }, t.makeDefaultTransport = function(e) {
                return o(e);
            };
        },
        229: function(e, t, r) {
            "use strict";
            var n = this && this.__assign || function() {
                return (n = Object.assign || function(e) {
                    for(var t, r = 1, n = arguments.length; r < n; r++)for(var o in t = arguments[r])Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                    return e;
                }).apply(this, arguments);
            };
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.detectFetchSupport = t.FetchReadableStreamTransport = void 0;
            var o = r(65), s = r(346);
            t.FetchReadableStreamTransport = function(e) {
                return function(t) {
                    return function(e, t) {
                        return e.debug && s.debug("fetchRequest", e), new i(e, t);
                    }(t, e);
                };
            };
            var i = function() {
                function e(e, t) {
                    this.cancelled = !1, this.controller = self.AbortController && new AbortController, this.options = e, this.init = t;
                }
                return e.prototype.pump = function(e, t) {
                    var r = this;
                    if (this.reader = e, this.cancelled) return this.options.debug && s.debug("Fetch.pump.cancel at first pump"), void this.reader.cancel().catch(function(e) {
                        r.options.debug && s.debug("Fetch.pump.reader.cancel exception", e);
                    });
                    this.reader.read().then(function(e) {
                        if (e.done) return r.options.onEnd(), t;
                        r.options.onChunk(e.value), r.pump(r.reader, t);
                    }).catch(function(e) {
                        r.cancelled ? r.options.debug && s.debug("Fetch.catch - request cancelled") : (r.cancelled = !0, r.options.debug && s.debug("Fetch.catch", e.message), r.options.onEnd(e));
                    });
                }, e.prototype.send = function(e) {
                    var t = this;
                    fetch(this.options.url, n(n({}, this.init), {
                        headers: this.metadata.toHeaders(),
                        method: "POST",
                        body: e,
                        signal: this.controller && this.controller.signal
                    })).then(function(e) {
                        if (t.options.debug && s.debug("Fetch.response", e), t.options.onHeaders(new o.Metadata(e.headers), e.status), !e.body) return e;
                        t.pump(e.body.getReader(), e);
                    }).catch(function(e) {
                        t.cancelled ? t.options.debug && s.debug("Fetch.catch - request cancelled") : (t.cancelled = !0, t.options.debug && s.debug("Fetch.catch", e.message), t.options.onEnd(e));
                    });
                }, e.prototype.sendMessage = function(e) {
                    this.send(e);
                }, e.prototype.finishSend = function() {}, e.prototype.start = function(e) {
                    this.metadata = e;
                }, e.prototype.cancel = function() {
                    var e = this;
                    this.cancelled ? this.options.debug && s.debug("Fetch.cancel already cancelled") : (this.cancelled = !0, this.controller ? (this.options.debug && s.debug("Fetch.cancel.controller.abort"), this.controller.abort()) : this.options.debug && s.debug("Fetch.cancel.missing abort controller"), this.reader ? (this.options.debug && s.debug("Fetch.cancel.reader.cancel"), this.reader.cancel().catch(function(t) {
                        e.options.debug && s.debug("Fetch.cancel.reader.cancel exception", t);
                    })) : this.options.debug && s.debug("Fetch.cancel before reader"));
                }, e;
            }();
            t.detectFetchSupport = function() {
                return "undefined" != typeof Response && Response.prototype.hasOwnProperty("body") && "function" == typeof Headers;
            };
        },
        859: function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.CrossBrowserHttpTransport = void 0;
            var n = r(229), o = r(210);
            t.CrossBrowserHttpTransport = function(e) {
                if (n.detectFetchSupport()) {
                    var t = {
                        credentials: e.withCredentials ? "include" : "same-origin"
                    };
                    return n.FetchReadableStreamTransport(t);
                }
                return o.XhrTransport({
                    withCredentials: e.withCredentials
                });
            };
        },
        210: function(e, t, r) {
            "use strict";
            var n, o = this && this.__extends || (n = function(e, t) {
                return (n = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(e, t) {
                    e.__proto__ = t;
                } || function(e, t) {
                    for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                })(e, t);
            }, function(e, t) {
                function r() {
                    this.constructor = e;
                }
                n(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
            });
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.stringToArrayBuffer = t.MozChunkedArrayBufferXHR = t.XHR = t.XhrTransport = void 0;
            var s = r(65), i = r(346), a = r(849);
            t.XhrTransport = function(e) {
                return function(t) {
                    if (a.detectMozXHRSupport()) return new d(t, e);
                    if (a.detectXHROverrideMimeTypeSupport()) return new u(t, e);
                    throw new Error("This environment's XHR implementation cannot support binary transfer.");
                };
            };
            var u = function() {
                function e(e, t) {
                    this.options = e, this.init = t;
                }
                return e.prototype.onProgressEvent = function() {
                    this.options.debug && i.debug("XHR.onProgressEvent.length: ", this.xhr.response.length);
                    var e = this.xhr.response.substr(this.index);
                    this.index = this.xhr.response.length;
                    var t = p(e);
                    this.options.onChunk(t);
                }, e.prototype.onLoadEvent = function() {
                    this.options.debug && i.debug("XHR.onLoadEvent"), this.options.onEnd();
                }, e.prototype.onStateChange = function() {
                    this.options.debug && i.debug("XHR.onStateChange", this.xhr.readyState), this.xhr.readyState === XMLHttpRequest.HEADERS_RECEIVED && this.options.onHeaders(new s.Metadata(this.xhr.getAllResponseHeaders()), this.xhr.status);
                }, e.prototype.sendMessage = function(e) {
                    this.xhr.send(e);
                }, e.prototype.finishSend = function() {}, e.prototype.start = function(e) {
                    var t = this;
                    this.metadata = e;
                    var r = new XMLHttpRequest;
                    this.xhr = r, r.open("POST", this.options.url), this.configureXhr(), this.metadata.forEach(function(e, t) {
                        r.setRequestHeader(e, t.join(", "));
                    }), r.withCredentials = Boolean(this.init.withCredentials), r.addEventListener("readystatechange", this.onStateChange.bind(this)), r.addEventListener("progress", this.onProgressEvent.bind(this)), r.addEventListener("loadend", this.onLoadEvent.bind(this)), r.addEventListener("error", function(e) {
                        t.options.debug && i.debug("XHR.error", e), t.options.onEnd(e.error);
                    });
                }, e.prototype.configureXhr = function() {
                    this.xhr.responseType = "text", this.xhr.overrideMimeType("text/plain; charset=x-user-defined");
                }, e.prototype.cancel = function() {
                    this.options.debug && i.debug("XHR.abort"), this.xhr.abort();
                }, e;
            }();
            t.XHR = u;
            var d = function(e) {
                function t() {
                    return null !== e && e.apply(this, arguments) || this;
                }
                return o(t, e), t.prototype.configureXhr = function() {
                    this.options.debug && i.debug("MozXHR.configureXhr: setting responseType to 'moz-chunked-arraybuffer'"), this.xhr.responseType = "moz-chunked-arraybuffer";
                }, t.prototype.onProgressEvent = function() {
                    var e = this.xhr.response;
                    this.options.debug && i.debug("MozXHR.onProgressEvent: ", new Uint8Array(e)), this.options.onChunk(new Uint8Array(e));
                }, t;
            }(u);
            function c(e, t) {
                var r = e.charCodeAt(t);
                if (r >= 55296 && r <= 56319) {
                    var n = e.charCodeAt(t + 1);
                    n >= 56320 && n <= 57343 && (r = 65536 + (r - 55296 << 10) + (n - 56320));
                }
                return r;
            }
            function p(e) {
                for(var t = new Uint8Array(e.length), r = 0, n = 0; n < e.length; n++){
                    var o = String.prototype.codePointAt ? e.codePointAt(n) : c(e, n);
                    t[r++] = 255 & o;
                }
                return t;
            }
            t.MozChunkedArrayBufferXHR = d, t.stringToArrayBuffer = p;
        },
        849: function(e, t) {
            "use strict";
            var r;
            function n() {
                if (void 0 !== r) return r;
                if (XMLHttpRequest) {
                    r = new XMLHttpRequest;
                    try {
                        r.open("GET", "https://localhost");
                    } catch (e) {}
                }
                return r;
            }
            function o(e) {
                var t = n();
                if (!t) return !1;
                try {
                    return t.responseType = e, t.responseType === e;
                } catch (e) {}
                return !1;
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.detectXHROverrideMimeTypeSupport = t.detectMozXHRSupport = t.xhrSupportsResponseType = void 0, t.xhrSupportsResponseType = o, t.detectMozXHRSupport = function() {
                return "undefined" != typeof XMLHttpRequest && o("moz-chunked-arraybuffer");
            }, t.detectXHROverrideMimeTypeSupport = function() {
                return "undefined" != typeof XMLHttpRequest && XMLHttpRequest.prototype.hasOwnProperty("overrideMimeType");
            };
        },
        540: function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.WebsocketTransport = void 0;
            var n, o = r(346), s = r(617);
            !function(e) {
                e[e.FINISH_SEND = 1] = "FINISH_SEND";
            }(n || (n = {}));
            var i = new Uint8Array([
                1
            ]);
            t.WebsocketTransport = function() {
                return function(e) {
                    return function(e) {
                        e.debug && o.debug("websocketRequest", e);
                        var t, r = function(e) {
                            if ("https://" === e.substr(0, 8)) return "wss://" + e.substr(8);
                            if ("http://" === e.substr(0, 7)) return "ws://" + e.substr(7);
                            throw new Error("Websocket transport constructed with non-https:// or http:// host.");
                        }(e.url), a = [];
                        function u(e) {
                            if (e === n.FINISH_SEND) t.send(i);
                            else {
                                var r = e, o = new Int8Array(r.byteLength + 1);
                                o.set(new Uint8Array([
                                    0
                                ])), o.set(r, 1), t.send(o);
                            }
                        }
                        return {
                            sendMessage: function(e) {
                                t && t.readyState !== t.CONNECTING ? u(e) : a.push(e);
                            },
                            finishSend: function() {
                                t && t.readyState !== t.CONNECTING ? u(n.FINISH_SEND) : a.push(n.FINISH_SEND);
                            },
                            start: function(n) {
                                (t = new WebSocket(r, [
                                    "grpc-websockets"
                                ])).binaryType = "arraybuffer", t.onopen = function() {
                                    var r;
                                    e.debug && o.debug("websocketRequest.onopen"), t.send((r = "", n.forEach(function(e, t) {
                                        r += e + ": " + t.join(", ") + "\r\n";
                                    }), s.encodeASCII(r))), a.forEach(function(e) {
                                        u(e);
                                    });
                                }, t.onclose = function(t) {
                                    e.debug && o.debug("websocketRequest.onclose", t), e.onEnd();
                                }, t.onerror = function(t) {
                                    e.debug && o.debug("websocketRequest.onerror", t);
                                }, t.onmessage = function(t) {
                                    e.onChunk(new Uint8Array(t.data));
                                };
                            },
                            cancel: function() {
                                e.debug && o.debug("websocket.abort"), t.close();
                            }
                        };
                    }(e);
                };
            };
        },
        35: function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.unary = void 0;
            var n = r(65), o = r(934);
            t.unary = function(e, t) {
                if (e.responseStream) throw new Error(".unary cannot be used with server-streaming methods. Use .invoke or .client instead.");
                if (e.requestStream) throw new Error(".unary cannot be used with client-streaming methods. Use .client instead.");
                var r = null, s = null, i = o.client(e, {
                    host: t.host,
                    transport: t.transport,
                    debug: t.debug
                });
                return i.onHeaders(function(e) {
                    r = e;
                }), i.onMessage(function(e) {
                    s = e;
                }), i.onEnd(function(e, o, i) {
                    t.onEnd({
                        status: e,
                        statusMessage: o,
                        headers: r || new n.Metadata,
                        message: s,
                        trailers: i
                    });
                }), i.start(t.metadata), i.send(t.request), i.finishSend(), {
                    close: function() {
                        i.close();
                    }
                };
            };
        },
        882: function(e, t) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.frameRequest = void 0, t.frameRequest = function(e) {
                var t = e.serializeBinary(), r = new ArrayBuffer(t.byteLength + 5);
                return new DataView(r, 1, 4).setUint32(0, t.length, !1), new Uint8Array(r, 5).set(t), new Uint8Array(r);
            };
        }
    }, t = {}, function r(n) {
        if (t[n]) return t[n].exports;
        var o = t[n] = {
            exports: {}
        };
        return e[n].call(o.exports, o, o.exports, r), o.exports;
    }(607);
});

});

parcelRegister("1pqjL", function(module, exports) {
(function webpackUniversalModuleDefinition(root, factory) {
    var a, i;
    module.exports = factory();
})(module.exports, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // identity function for calling harmony imports with the correct context
        /******/ __webpack_require__.i = function(value) {
            return value;
        };
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                /******/ configurable: false,
                /******/ enumerable: true,
                /******/ get: getter
            });
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1["default"];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, "a", getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 1);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var util_1 = __webpack_require__(3);
            function isBrowserHeaders(arg) {
                return typeof arg === "object" && typeof arg.headersMap === "object" && typeof arg.forEach === "function";
            }
            var BrowserHeaders = function() {
                function BrowserHeaders(init, options) {
                    if (init === void 0) init = {};
                    if (options === void 0) options = {
                        splitValues: false
                    };
                    var _this = this;
                    this.headersMap = {};
                    if (init) {
                        if (typeof Headers !== "undefined" && init instanceof Headers) {
                            var keys = util_1.getHeaderKeys(init);
                            keys.forEach(function(key) {
                                var values = util_1.getHeaderValues(init, key);
                                values.forEach(function(value) {
                                    if (options.splitValues) _this.append(key, util_1.splitHeaderValue(value));
                                    else _this.append(key, value);
                                });
                            });
                        } else if (isBrowserHeaders(init)) init.forEach(function(key, values) {
                            _this.append(key, values);
                        });
                        else if (typeof Map !== "undefined" && init instanceof Map) {
                            var asMap = init;
                            asMap.forEach(function(value, key) {
                                _this.append(key, value);
                            });
                        } else if (typeof init === "string") this.appendFromString(init);
                        else if (typeof init === "object") Object.getOwnPropertyNames(init).forEach(function(key) {
                            var asObject = init;
                            var values = asObject[key];
                            if (Array.isArray(values)) values.forEach(function(value) {
                                _this.append(key, value);
                            });
                            else _this.append(key, values);
                        });
                    }
                }
                BrowserHeaders.prototype.appendFromString = function(str) {
                    var pairs = str.split("\r\n");
                    for(var i = 0; i < pairs.length; i++){
                        var p = pairs[i];
                        var index = p.indexOf(":");
                        if (index > 0) {
                            var key = p.substring(0, index).trim();
                            var value = p.substring(index + 1).trim();
                            this.append(key, value);
                        }
                    }
                };
                BrowserHeaders.prototype.delete = function(key, value) {
                    var normalizedKey = util_1.normalizeName(key);
                    if (value === undefined) delete this.headersMap[normalizedKey];
                    else {
                        var existing = this.headersMap[normalizedKey];
                        if (existing) {
                            var index = existing.indexOf(value);
                            if (index >= 0) existing.splice(index, 1);
                            if (existing.length === 0) delete this.headersMap[normalizedKey];
                        }
                    }
                };
                BrowserHeaders.prototype.append = function(key, value) {
                    var _this = this;
                    var normalizedKey = util_1.normalizeName(key);
                    if (!Array.isArray(this.headersMap[normalizedKey])) this.headersMap[normalizedKey] = [];
                    if (Array.isArray(value)) value.forEach(function(arrayValue) {
                        _this.headersMap[normalizedKey].push(util_1.normalizeValue(arrayValue));
                    });
                    else this.headersMap[normalizedKey].push(util_1.normalizeValue(value));
                };
                BrowserHeaders.prototype.set = function(key, value) {
                    var normalizedKey = util_1.normalizeName(key);
                    if (Array.isArray(value)) {
                        var normalized_1 = [];
                        value.forEach(function(arrayValue) {
                            normalized_1.push(util_1.normalizeValue(arrayValue));
                        });
                        this.headersMap[normalizedKey] = normalized_1;
                    } else this.headersMap[normalizedKey] = [
                        util_1.normalizeValue(value)
                    ];
                };
                BrowserHeaders.prototype.has = function(key, value) {
                    var keyArray = this.headersMap[util_1.normalizeName(key)];
                    var keyExists = Array.isArray(keyArray);
                    if (!keyExists) return false;
                    if (value !== undefined) {
                        var normalizedValue = util_1.normalizeValue(value);
                        return keyArray.indexOf(normalizedValue) >= 0;
                    } else return true;
                };
                BrowserHeaders.prototype.get = function(key) {
                    var values = this.headersMap[util_1.normalizeName(key)];
                    if (values !== undefined) return values.concat();
                    return [];
                };
                BrowserHeaders.prototype.forEach = function(callback) {
                    var _this = this;
                    Object.getOwnPropertyNames(this.headersMap).forEach(function(key) {
                        callback(key, _this.headersMap[key]);
                    }, this);
                };
                BrowserHeaders.prototype.toHeaders = function() {
                    if (typeof Headers !== "undefined") {
                        var headers_1 = new Headers();
                        this.forEach(function(key, values) {
                            values.forEach(function(value) {
                                headers_1.append(key, value);
                            });
                        });
                        return headers_1;
                    } else throw new Error("Headers class is not defined");
                };
                return BrowserHeaders;
            }();
            exports.BrowserHeaders = BrowserHeaders;
        /***/ },
        /* 1 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var BrowserHeaders_1 = __webpack_require__(0);
            exports.BrowserHeaders = BrowserHeaders_1.BrowserHeaders;
        /***/ },
        /* 2 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            function iterateHeaders(headers, callback) {
                var iterator = headers[Symbol.iterator]();
                var entry = iterator.next();
                while(!entry.done){
                    callback(entry.value[0]);
                    entry = iterator.next();
                }
            }
            exports.iterateHeaders = iterateHeaders;
            function iterateHeadersKeys(headers, callback) {
                var iterator = headers.keys();
                var entry = iterator.next();
                while(!entry.done){
                    callback(entry.value);
                    entry = iterator.next();
                }
            }
            exports.iterateHeadersKeys = iterateHeadersKeys;
        /***/ },
        /* 3 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var iterateHeaders_1 = __webpack_require__(2);
            function normalizeName(name) {
                if (typeof name !== "string") name = String(name);
                if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) throw new TypeError("Invalid character in header field name");
                return name.toLowerCase();
            }
            exports.normalizeName = normalizeName;
            function normalizeValue(value) {
                if (typeof value !== "string") value = String(value);
                return value;
            }
            exports.normalizeValue = normalizeValue;
            function getHeaderValues(headersAsNative, key) {
                var headers = toWindowHeaders(headersAsNative);
                if (headers instanceof Headers && headers.getAll) return headers.getAll(key);
                var getValue = headers.get(key);
                if (getValue && typeof getValue === "string") return [
                    getValue
                ];
                return getValue;
            }
            exports.getHeaderValues = getHeaderValues;
            function toWindowHeaders(headersAsNative) {
                return headersAsNative;
            }
            function getHeaderKeys(headersAsNative) {
                var headers = toWindowHeaders(headersAsNative);
                var asMap = {};
                var keys = [];
                if (headers.keys) iterateHeaders_1.iterateHeadersKeys(headers, function(key) {
                    if (!asMap[key]) {
                        asMap[key] = true;
                        keys.push(key);
                    }
                });
                else if (headers.forEach) headers.forEach(function(_, key) {
                    if (!asMap[key]) {
                        asMap[key] = true;
                        keys.push(key);
                    }
                });
                else iterateHeaders_1.iterateHeaders(headers, function(entry) {
                    var key = entry[0];
                    if (!asMap[key]) {
                        asMap[key] = true;
                        keys.push(key);
                    }
                });
                return keys;
            }
            exports.getHeaderKeys = getHeaderKeys;
            function splitHeaderValue(str) {
                var values = [];
                var commaSpaceValues = str.split(", ");
                commaSpaceValues.forEach(function(commaSpaceValue) {
                    commaSpaceValue.split(",").forEach(function(commaValue) {
                        values.push(commaValue);
                    });
                });
                return values;
            }
            exports.splitHeaderValue = splitHeaderValue;
        /***/ }
    ]);
});

});

parcelRegister("eVHa3", function(module, exports) {
"use strict";
var $ade7de731a28f0e1$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Metadata = module.exports.DenomUnit = module.exports.Supply = module.exports.Output = module.exports.Input = module.exports.SendEnabled = module.exports.Params = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $ade7de731a28f0e1$var$long_1 = $ade7de731a28f0e1$var$__importDefault((parcelRequire("9A55m")));

const $ade7de731a28f0e1$var$minimal_1 = $ade7de731a28f0e1$var$__importDefault((parcelRequire("i2pIU")));

var $lPVUQ = parcelRequire("lPVUQ");
module.exports.protobufPackage = "cosmos.bank.v1beta1";
const $ade7de731a28f0e1$var$baseParams = {
    defaultSendEnabled: false
};
module.exports.Params = {
    encode (message, writer = $ade7de731a28f0e1$var$minimal_1.default.Writer.create()) {
        for (const v of message.sendEnabled)module.exports.SendEnabled.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.defaultSendEnabled === true) writer.uint32(16).bool(message.defaultSendEnabled);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ade7de731a28f0e1$var$minimal_1.default.Reader ? input : new $ade7de731a28f0e1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ade7de731a28f0e1$var$baseParams);
        message.sendEnabled = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sendEnabled.push(module.exports.SendEnabled.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.defaultSendEnabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ade7de731a28f0e1$var$baseParams);
        message.sendEnabled = [];
        if (object.sendEnabled !== undefined && object.sendEnabled !== null) for (const e of object.sendEnabled)message.sendEnabled.push(module.exports.SendEnabled.fromJSON(e));
        if (object.defaultSendEnabled !== undefined && object.defaultSendEnabled !== null) message.defaultSendEnabled = Boolean(object.defaultSendEnabled);
        else message.defaultSendEnabled = false;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.sendEnabled) obj.sendEnabled = message.sendEnabled.map((e)=>e ? module.exports.SendEnabled.toJSON(e) : undefined);
        else obj.sendEnabled = [];
        message.defaultSendEnabled !== undefined && (obj.defaultSendEnabled = message.defaultSendEnabled);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ade7de731a28f0e1$var$baseParams);
        message.sendEnabled = [];
        if (object.sendEnabled !== undefined && object.sendEnabled !== null) for (const e of object.sendEnabled)message.sendEnabled.push(module.exports.SendEnabled.fromPartial(e));
        if (object.defaultSendEnabled !== undefined && object.defaultSendEnabled !== null) message.defaultSendEnabled = object.defaultSendEnabled;
        else message.defaultSendEnabled = false;
        return message;
    }
};
const $ade7de731a28f0e1$var$baseSendEnabled = {
    denom: "",
    enabled: false
};
module.exports.SendEnabled = {
    encode (message, writer = $ade7de731a28f0e1$var$minimal_1.default.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.enabled === true) writer.uint32(16).bool(message.enabled);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ade7de731a28f0e1$var$minimal_1.default.Reader ? input : new $ade7de731a28f0e1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ade7de731a28f0e1$var$baseSendEnabled);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.enabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ade7de731a28f0e1$var$baseSendEnabled);
        if (object.denom !== undefined && object.denom !== null) message.denom = String(object.denom);
        else message.denom = "";
        if (object.enabled !== undefined && object.enabled !== null) message.enabled = Boolean(object.enabled);
        else message.enabled = false;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.enabled !== undefined && (obj.enabled = message.enabled);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ade7de731a28f0e1$var$baseSendEnabled);
        if (object.denom !== undefined && object.denom !== null) message.denom = object.denom;
        else message.denom = "";
        if (object.enabled !== undefined && object.enabled !== null) message.enabled = object.enabled;
        else message.enabled = false;
        return message;
    }
};
const $ade7de731a28f0e1$var$baseInput = {
    address: ""
};
module.exports.Input = {
    encode (message, writer = $ade7de731a28f0e1$var$minimal_1.default.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        for (const v of message.coins)$lPVUQ.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ade7de731a28f0e1$var$minimal_1.default.Reader ? input : new $ade7de731a28f0e1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ade7de731a28f0e1$var$baseInput);
        message.coins = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.coins.push($lPVUQ.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ade7de731a28f0e1$var$baseInput);
        message.coins = [];
        if (object.address !== undefined && object.address !== null) message.address = String(object.address);
        else message.address = "";
        if (object.coins !== undefined && object.coins !== null) for (const e of object.coins)message.coins.push($lPVUQ.Coin.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        if (message.coins) obj.coins = message.coins.map((e)=>e ? $lPVUQ.Coin.toJSON(e) : undefined);
        else obj.coins = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ade7de731a28f0e1$var$baseInput);
        message.coins = [];
        if (object.address !== undefined && object.address !== null) message.address = object.address;
        else message.address = "";
        if (object.coins !== undefined && object.coins !== null) for (const e of object.coins)message.coins.push($lPVUQ.Coin.fromPartial(e));
        return message;
    }
};
const $ade7de731a28f0e1$var$baseOutput = {
    address: ""
};
module.exports.Output = {
    encode (message, writer = $ade7de731a28f0e1$var$minimal_1.default.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        for (const v of message.coins)$lPVUQ.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ade7de731a28f0e1$var$minimal_1.default.Reader ? input : new $ade7de731a28f0e1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ade7de731a28f0e1$var$baseOutput);
        message.coins = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.coins.push($lPVUQ.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ade7de731a28f0e1$var$baseOutput);
        message.coins = [];
        if (object.address !== undefined && object.address !== null) message.address = String(object.address);
        else message.address = "";
        if (object.coins !== undefined && object.coins !== null) for (const e of object.coins)message.coins.push($lPVUQ.Coin.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        if (message.coins) obj.coins = message.coins.map((e)=>e ? $lPVUQ.Coin.toJSON(e) : undefined);
        else obj.coins = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ade7de731a28f0e1$var$baseOutput);
        message.coins = [];
        if (object.address !== undefined && object.address !== null) message.address = object.address;
        else message.address = "";
        if (object.coins !== undefined && object.coins !== null) for (const e of object.coins)message.coins.push($lPVUQ.Coin.fromPartial(e));
        return message;
    }
};
const $ade7de731a28f0e1$var$baseSupply = {};
module.exports.Supply = {
    encode (message, writer = $ade7de731a28f0e1$var$minimal_1.default.Writer.create()) {
        for (const v of message.total)$lPVUQ.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ade7de731a28f0e1$var$minimal_1.default.Reader ? input : new $ade7de731a28f0e1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ade7de731a28f0e1$var$baseSupply);
        message.total = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.total.push($lPVUQ.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ade7de731a28f0e1$var$baseSupply);
        message.total = [];
        if (object.total !== undefined && object.total !== null) for (const e of object.total)message.total.push($lPVUQ.Coin.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.total) obj.total = message.total.map((e)=>e ? $lPVUQ.Coin.toJSON(e) : undefined);
        else obj.total = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ade7de731a28f0e1$var$baseSupply);
        message.total = [];
        if (object.total !== undefined && object.total !== null) for (const e of object.total)message.total.push($lPVUQ.Coin.fromPartial(e));
        return message;
    }
};
const $ade7de731a28f0e1$var$baseDenomUnit = {
    denom: "",
    exponent: 0,
    aliases: ""
};
module.exports.DenomUnit = {
    encode (message, writer = $ade7de731a28f0e1$var$minimal_1.default.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.exponent !== 0) writer.uint32(16).uint32(message.exponent);
        for (const v of message.aliases)writer.uint32(26).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ade7de731a28f0e1$var$minimal_1.default.Reader ? input : new $ade7de731a28f0e1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ade7de731a28f0e1$var$baseDenomUnit);
        message.aliases = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.exponent = reader.uint32();
                    break;
                case 3:
                    message.aliases.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ade7de731a28f0e1$var$baseDenomUnit);
        message.aliases = [];
        if (object.denom !== undefined && object.denom !== null) message.denom = String(object.denom);
        else message.denom = "";
        if (object.exponent !== undefined && object.exponent !== null) message.exponent = Number(object.exponent);
        else message.exponent = 0;
        if (object.aliases !== undefined && object.aliases !== null) for (const e of object.aliases)message.aliases.push(String(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.exponent !== undefined && (obj.exponent = message.exponent);
        if (message.aliases) obj.aliases = message.aliases.map((e)=>e);
        else obj.aliases = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ade7de731a28f0e1$var$baseDenomUnit);
        message.aliases = [];
        if (object.denom !== undefined && object.denom !== null) message.denom = object.denom;
        else message.denom = "";
        if (object.exponent !== undefined && object.exponent !== null) message.exponent = object.exponent;
        else message.exponent = 0;
        if (object.aliases !== undefined && object.aliases !== null) for (const e of object.aliases)message.aliases.push(e);
        return message;
    }
};
const $ade7de731a28f0e1$var$baseMetadata = {
    description: "",
    base: "",
    display: "",
    name: "",
    symbol: ""
};
module.exports.Metadata = {
    encode (message, writer = $ade7de731a28f0e1$var$minimal_1.default.Writer.create()) {
        if (message.description !== "") writer.uint32(10).string(message.description);
        for (const v of message.denomUnits)module.exports.DenomUnit.encode(v, writer.uint32(18).fork()).ldelim();
        if (message.base !== "") writer.uint32(26).string(message.base);
        if (message.display !== "") writer.uint32(34).string(message.display);
        if (message.name !== "") writer.uint32(42).string(message.name);
        if (message.symbol !== "") writer.uint32(50).string(message.symbol);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ade7de731a28f0e1$var$minimal_1.default.Reader ? input : new $ade7de731a28f0e1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ade7de731a28f0e1$var$baseMetadata);
        message.denomUnits = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.description = reader.string();
                    break;
                case 2:
                    message.denomUnits.push(module.exports.DenomUnit.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.base = reader.string();
                    break;
                case 4:
                    message.display = reader.string();
                    break;
                case 5:
                    message.name = reader.string();
                    break;
                case 6:
                    message.symbol = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ade7de731a28f0e1$var$baseMetadata);
        message.denomUnits = [];
        if (object.description !== undefined && object.description !== null) message.description = String(object.description);
        else message.description = "";
        if (object.denomUnits !== undefined && object.denomUnits !== null) for (const e of object.denomUnits)message.denomUnits.push(module.exports.DenomUnit.fromJSON(e));
        if (object.base !== undefined && object.base !== null) message.base = String(object.base);
        else message.base = "";
        if (object.display !== undefined && object.display !== null) message.display = String(object.display);
        else message.display = "";
        if (object.name !== undefined && object.name !== null) message.name = String(object.name);
        else message.name = "";
        if (object.symbol !== undefined && object.symbol !== null) message.symbol = String(object.symbol);
        else message.symbol = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.description !== undefined && (obj.description = message.description);
        if (message.denomUnits) obj.denomUnits = message.denomUnits.map((e)=>e ? module.exports.DenomUnit.toJSON(e) : undefined);
        else obj.denomUnits = [];
        message.base !== undefined && (obj.base = message.base);
        message.display !== undefined && (obj.display = message.display);
        message.name !== undefined && (obj.name = message.name);
        message.symbol !== undefined && (obj.symbol = message.symbol);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ade7de731a28f0e1$var$baseMetadata);
        message.denomUnits = [];
        if (object.description !== undefined && object.description !== null) message.description = object.description;
        else message.description = "";
        if (object.denomUnits !== undefined && object.denomUnits !== null) for (const e of object.denomUnits)message.denomUnits.push(module.exports.DenomUnit.fromPartial(e));
        if (object.base !== undefined && object.base !== null) message.base = object.base;
        else message.base = "";
        if (object.display !== undefined && object.display !== null) message.display = object.display;
        else message.display = "";
        if (object.name !== undefined && object.name !== null) message.name = object.name;
        else message.name = "";
        if (object.symbol !== undefined && object.symbol !== null) message.symbol = object.symbol;
        else message.symbol = "";
        return message;
    }
};
if ($ade7de731a28f0e1$var$minimal_1.default.util.Long !== $ade7de731a28f0e1$var$long_1.default) {
    $ade7de731a28f0e1$var$minimal_1.default.util.Long = $ade7de731a28f0e1$var$long_1.default;
    $ade7de731a28f0e1$var$minimal_1.default.configure();
}

});



parcelRegister("7kPaS", function(module, exports) {
"use strict";
var $557218d4f43ad337$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgMultiSend = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $kYslP = parcelRequire("kYslP");

var $c5FxR = parcelRequire("c5FxR");

var $5vZfe = parcelRequire("5vZfe");

var $eVHa3 = parcelRequire("eVHa3");
/**
 * If you have multiple senders and/or multiple recipients, you can use MsgMultiSend,
 * which can batch together the senders and recipients in one message to save on gas
 * fees.
 *
 * Specify the senders and recipients and their corresponding deposit contribution /
 * receiving amounts with [[MsgMultiSend.Input]] or [[MsgMultiSend.Output]].
 *
 * Example:
 *
 * ```ts
 * import { MsgMultiSend } from "@terra-money/terra.js";
 *
 * const inputs: MsgMultiSend.Input[] = [
 *    new MsgMultiSend.Input(
 *      'terra105rz2q5a4w7nv7239tl9c4px5cjy7axx3axf6p',
 *      {
 *        ukrw: 123123,
 *      })
 *    ),
 *    new MsgMultiSend.Input('terra105rz2q5a4w7nv7239tl9c4px5cjy7axx3axfad', [
 *      new Coin('uluna', 123123),
 *    ]),
 *  ];
 *   const outputs: MsgMultiSend.Output[] = [
 *    new MsgMultiSend.Output(
 *      'terra105rz2q5a4w7nv7239tl9c4px5cjy7axx3axfad',
 *        {
 *          ukrw: 123123,
 *        }
 *    ),
 *    new MsgMultiSend.Output('terra105rz2q5a4w7nv7239tl9c4px5cjy7axx3axfga',
 *      {
 *        uluna: 123123,
 *      }
 *    ),
 *  ];
 *  const multisend = new MsgMultiSend(inputs, outputs);
 * ```
 */ var $557218d4f43ad337$var$MsgMultiSend = /** @class */ function(_super) {
    $557218d4f43ad337$var$__extends(MsgMultiSend, _super);
    /**
     * @param inputs inputs
     * @param outputs outputs
     */ function MsgMultiSend(inputs, outputs) {
        var _this = _super.call(this) || this;
        _this.inputs = inputs;
        _this.outputs = outputs;
        return _this;
    }
    MsgMultiSend.fromAmino = function(data, _) {
        _;
        var _a = data.value, inputs = _a.inputs, outputs = _a.outputs;
        return new MsgMultiSend(inputs.map(function(i) {
            return MsgMultiSend.Input.fromAmino(i);
        }), outputs.map(function(o) {
            return MsgMultiSend.Output.fromAmino(o);
        }));
    };
    MsgMultiSend.prototype.toAmino = function(isClassic) {
        var _a = this, inputs = _a.inputs, outputs = _a.outputs;
        return {
            type: isClassic ? "bank/MsgMultiSend" : "cosmos-sdk/MsgMultiSend",
            value: {
                inputs: inputs.map(function(i) {
                    return i.toAmino();
                }),
                outputs: outputs.map(function(o) {
                    return o.toAmino();
                })
            }
        };
    };
    MsgMultiSend.fromData = function(data, _) {
        _;
        var inputs = data.inputs, outputs = data.outputs;
        return new MsgMultiSend(inputs.map(function(i) {
            return MsgMultiSend.Input.fromData(i);
        }), outputs.map(function(o) {
            return MsgMultiSend.Output.fromData(o);
        }));
    };
    MsgMultiSend.prototype.toData = function(_) {
        _;
        var _a = this, inputs = _a.inputs, outputs = _a.outputs;
        return {
            "@type": "/cosmos.bank.v1beta1.MsgMultiSend",
            inputs: inputs.map(function(i) {
                return i.toData();
            }),
            outputs: outputs.map(function(o) {
                return o.toData();
            })
        };
    };
    MsgMultiSend.fromProto = function(proto, _) {
        _;
        return new MsgMultiSend(proto.inputs.map(function(i) {
            return MsgMultiSend.Input.fromProto(i);
        }), proto.outputs.map(function(o) {
            return MsgMultiSend.Output.fromProto(o);
        }));
    };
    MsgMultiSend.prototype.toProto = function(_) {
        _;
        var _a = this, inputs = _a.inputs, outputs = _a.outputs;
        return $5vZfe.MsgMultiSend.fromPartial({
            inputs: inputs.map(function(i) {
                return i.toProto();
            }),
            outputs: outputs.map(function(i) {
                return i.toProto();
            })
        });
    };
    MsgMultiSend.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmos.bank.v1beta1.MsgMultiSend",
            value: $5vZfe.MsgMultiSend.encode(this.toProto(isClassic)).finish()
        });
    };
    MsgMultiSend.unpackAny = function(msgAny, isClassic) {
        return MsgMultiSend.fromProto($5vZfe.MsgMultiSend.decode(msgAny.value), isClassic);
    };
    return MsgMultiSend;
}($26Eqx.JSONSerializable);
module.exports.MsgMultiSend = $557218d4f43ad337$var$MsgMultiSend;
(function(MsgMultiSend) {
    var Input = /** @class */ function(_super) {
        $557218d4f43ad337$var$__extends(Input, _super);
        /**
         * @param address address
         * @param coinsInput coins-compatible input
         */ function Input(address, coinsInput) {
            var _this = _super.call(this) || this;
            _this.address = address;
            _this.coins = new $kYslP.Coins(coinsInput);
            return _this;
        }
        Input.prototype.toAmino = function(_) {
            _;
            var _a = this, address = _a.address, coins = _a.coins;
            return {
                address: address,
                coins: coins.toAmino()
            };
        };
        Input.fromAmino = function(data, _) {
            _;
            var address = data.address, coins = data.coins;
            return new Input(address, $kYslP.Coins.fromAmino(coins));
        };
        Input.prototype.toData = function(_) {
            _;
            var _a = this, address = _a.address, coins = _a.coins;
            return {
                address: address,
                coins: coins.toData()
            };
        };
        Input.fromData = function(data, _) {
            _;
            var address = data.address, coins = data.coins;
            return new Input(address, $kYslP.Coins.fromData(coins));
        };
        Input.prototype.toProto = function(_) {
            _;
            var _a = this, address = _a.address, coins = _a.coins;
            return $eVHa3.Input.fromPartial({
                address: address,
                coins: coins.toProto()
            });
        };
        Input.fromProto = function(proto, _) {
            _;
            return new Input(proto.address, $kYslP.Coins.fromProto(proto.coins));
        };
        return Input;
    }($26Eqx.JSONSerializable);
    MsgMultiSend.Input = Input;
    var Output = /** @class */ function(_super) {
        $557218d4f43ad337$var$__extends(Output, _super);
        /**
         * @param address address
         * @param coinsOutput coins-compatible input
         */ function Output(address, coinsInput) {
            var _this = _super.call(this) || this;
            _this.address = address;
            _this.coins = new $kYslP.Coins(coinsInput);
            return _this;
        }
        Output.prototype.toAmino = function(_) {
            _;
            var _a = this, address = _a.address, coins = _a.coins;
            return {
                address: address,
                coins: coins.toAmino()
            };
        };
        Output.fromAmino = function(data, _) {
            _;
            var address = data.address, coins = data.coins;
            return new Output(address, $kYslP.Coins.fromAmino(coins));
        };
        Output.prototype.toData = function(_) {
            _;
            var _a = this, address = _a.address, coins = _a.coins;
            return {
                address: address,
                coins: coins.toData()
            };
        };
        Output.fromData = function(data, _) {
            _;
            var address = data.address, coins = data.coins;
            return new Output(address, $kYslP.Coins.fromData(coins));
        };
        Output.prototype.toProto = function(_) {
            _;
            var _a = this, address = _a.address, coins = _a.coins;
            return $eVHa3.Output.fromPartial({
                address: address,
                coins: coins.toProto()
            });
        };
        Output.fromProto = function(proto, _) {
            _;
            return new Output(proto.address, $kYslP.Coins.fromProto(proto.coins));
        };
        return Output;
    }($26Eqx.JSONSerializable);
    MsgMultiSend.Output = Output;
})($557218d4f43ad337$var$MsgMultiSend = module.exports.MsgMultiSend || (module.exports.MsgMultiSend = {}));
module.exports.MsgMultiSend = $557218d4f43ad337$var$MsgMultiSend;

});


parcelRegister("jwuh5", function(module, exports) {
"use strict";
var $e3687d5fd00371e4$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e3687d5fd00371e4$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e3687d5fd00371e4$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$e3687d5fd00371e4$var$__exportStar((parcelRequire("ePndw")), module.exports);

$e3687d5fd00371e4$var$__exportStar((parcelRequire("3Lwky")), module.exports);

$e3687d5fd00371e4$var$__exportStar((parcelRequire("jIohN")), module.exports);

$e3687d5fd00371e4$var$__exportStar((parcelRequire("6vlRx")), module.exports);

});
parcelRegister("ePndw", function(module, exports) {
"use strict";
var $acb7d6855cea8b05$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgSetWithdrawAddress = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $2OIQB = parcelRequire("2OIQB");
/**
 * A validator can withdraw their outstanding commission rewards accrued from all
 * delegations (not including its self-delegation) into their associated account's
 * withdraw address.
 */ var $acb7d6855cea8b05$var$MsgSetWithdrawAddress = /** @class */ function(_super) {
    $acb7d6855cea8b05$var$__extends(MsgSetWithdrawAddress, _super);
    /**
     * @param delegator_address delegator's account address
     * @param withdraw_address desired new withdraw address
     */ function MsgSetWithdrawAddress(delegator_address, withdraw_address) {
        var _this = _super.call(this) || this;
        _this.delegator_address = delegator_address;
        _this.withdraw_address = withdraw_address;
        return _this;
    }
    MsgSetWithdrawAddress.fromAmino = function(data, _) {
        _;
        var _a = data.value, delegator_address = _a.delegator_address, withdraw_address = _a.withdraw_address;
        return new MsgSetWithdrawAddress(delegator_address, withdraw_address);
    };
    MsgSetWithdrawAddress.prototype.toAmino = function(isClassic) {
        var _a = this, delegator_address = _a.delegator_address, withdraw_address = _a.withdraw_address;
        return {
            type: isClassic ? "distribution/MsgModifyWithdrawAddress" : "cosmos-sdk/MsgModifyWithdrawAddress",
            value: {
                delegator_address: delegator_address,
                withdraw_address: withdraw_address
            }
        };
    };
    MsgSetWithdrawAddress.fromData = function(data, _) {
        _;
        var delegator_address = data.delegator_address, withdraw_address = data.withdraw_address;
        return new MsgSetWithdrawAddress(delegator_address, withdraw_address);
    };
    MsgSetWithdrawAddress.prototype.toData = function(_) {
        _;
        var _a = this, delegator_address = _a.delegator_address, withdraw_address = _a.withdraw_address;
        return {
            "@type": "/cosmos.distribution.v1beta1.MsgSetWithdrawAddress",
            delegator_address: delegator_address,
            withdraw_address: withdraw_address
        };
    };
    MsgSetWithdrawAddress.fromProto = function(proto, _) {
        _;
        return new MsgSetWithdrawAddress(proto.delegatorAddress, proto.withdrawAddress);
    };
    MsgSetWithdrawAddress.prototype.toProto = function(_) {
        _;
        var _a = this, delegator_address = _a.delegator_address, withdraw_address = _a.withdraw_address;
        return $2OIQB.MsgSetWithdrawAddress.fromPartial({
            delegatorAddress: delegator_address,
            withdrawAddress: withdraw_address
        });
    };
    MsgSetWithdrawAddress.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmos.distribution.v1beta1.MsgSetWithdrawAddress",
            value: $2OIQB.MsgSetWithdrawAddress.encode(this.toProto(isClassic)).finish()
        });
    };
    MsgSetWithdrawAddress.unpackAny = function(msgAny, isClassic) {
        return MsgSetWithdrawAddress.fromProto($2OIQB.MsgSetWithdrawAddress.decode(msgAny.value), isClassic);
    };
    return MsgSetWithdrawAddress;
}($26Eqx.JSONSerializable);
module.exports.MsgSetWithdrawAddress = $acb7d6855cea8b05$var$MsgSetWithdrawAddress;

});
parcelRegister("2OIQB", function(module, exports) {
"use strict";
var $20d30a12967dfb35$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GrpcWebImpl = module.exports.MsgFundCommunityPoolDesc = module.exports.MsgWithdrawValidatorCommissionDesc = module.exports.MsgWithdrawDelegatorRewardDesc = module.exports.MsgSetWithdrawAddressDesc = module.exports.MsgDesc = module.exports.MsgClientImpl = module.exports.MsgFundCommunityPoolResponse = module.exports.MsgFundCommunityPool = module.exports.MsgWithdrawValidatorCommissionResponse = module.exports.MsgWithdrawValidatorCommission = module.exports.MsgWithdrawDelegatorRewardResponse = module.exports.MsgWithdrawDelegatorReward = module.exports.MsgSetWithdrawAddressResponse = module.exports.MsgSetWithdrawAddress = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $20d30a12967dfb35$var$long_1 = $20d30a12967dfb35$var$__importDefault((parcelRequire("9A55m")));

var $jXVni = parcelRequire("jXVni");

const $20d30a12967dfb35$var$minimal_1 = $20d30a12967dfb35$var$__importDefault((parcelRequire("i2pIU")));

var $1pqjL = parcelRequire("1pqjL");

var $lPVUQ = parcelRequire("lPVUQ");
module.exports.protobufPackage = "cosmos.distribution.v1beta1";
const $20d30a12967dfb35$var$baseMsgSetWithdrawAddress = {
    delegatorAddress: "",
    withdrawAddress: ""
};
module.exports.MsgSetWithdrawAddress = {
    encode (message, writer = $20d30a12967dfb35$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.withdrawAddress !== "") writer.uint32(18).string(message.withdrawAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $20d30a12967dfb35$var$minimal_1.default.Reader ? input : new $20d30a12967dfb35$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $20d30a12967dfb35$var$baseMsgSetWithdrawAddress);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.withdrawAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $20d30a12967dfb35$var$baseMsgSetWithdrawAddress);
        if (object.delegatorAddress !== undefined && object.delegatorAddress !== null) message.delegatorAddress = String(object.delegatorAddress);
        else message.delegatorAddress = "";
        if (object.withdrawAddress !== undefined && object.withdrawAddress !== null) message.withdrawAddress = String(object.withdrawAddress);
        else message.withdrawAddress = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.withdrawAddress !== undefined && (obj.withdrawAddress = message.withdrawAddress);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $20d30a12967dfb35$var$baseMsgSetWithdrawAddress);
        if (object.delegatorAddress !== undefined && object.delegatorAddress !== null) message.delegatorAddress = object.delegatorAddress;
        else message.delegatorAddress = "";
        if (object.withdrawAddress !== undefined && object.withdrawAddress !== null) message.withdrawAddress = object.withdrawAddress;
        else message.withdrawAddress = "";
        return message;
    }
};
const $20d30a12967dfb35$var$baseMsgSetWithdrawAddressResponse = {};
module.exports.MsgSetWithdrawAddressResponse = {
    encode (_, writer = $20d30a12967dfb35$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $20d30a12967dfb35$var$minimal_1.default.Reader ? input : new $20d30a12967dfb35$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $20d30a12967dfb35$var$baseMsgSetWithdrawAddressResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $20d30a12967dfb35$var$baseMsgSetWithdrawAddressResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $20d30a12967dfb35$var$baseMsgSetWithdrawAddressResponse);
        return message;
    }
};
const $20d30a12967dfb35$var$baseMsgWithdrawDelegatorReward = {
    delegatorAddress: "",
    validatorAddress: ""
};
module.exports.MsgWithdrawDelegatorReward = {
    encode (message, writer = $20d30a12967dfb35$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $20d30a12967dfb35$var$minimal_1.default.Reader ? input : new $20d30a12967dfb35$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $20d30a12967dfb35$var$baseMsgWithdrawDelegatorReward);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $20d30a12967dfb35$var$baseMsgWithdrawDelegatorReward);
        if (object.delegatorAddress !== undefined && object.delegatorAddress !== null) message.delegatorAddress = String(object.delegatorAddress);
        else message.delegatorAddress = "";
        if (object.validatorAddress !== undefined && object.validatorAddress !== null) message.validatorAddress = String(object.validatorAddress);
        else message.validatorAddress = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $20d30a12967dfb35$var$baseMsgWithdrawDelegatorReward);
        if (object.delegatorAddress !== undefined && object.delegatorAddress !== null) message.delegatorAddress = object.delegatorAddress;
        else message.delegatorAddress = "";
        if (object.validatorAddress !== undefined && object.validatorAddress !== null) message.validatorAddress = object.validatorAddress;
        else message.validatorAddress = "";
        return message;
    }
};
const $20d30a12967dfb35$var$baseMsgWithdrawDelegatorRewardResponse = {};
module.exports.MsgWithdrawDelegatorRewardResponse = {
    encode (_, writer = $20d30a12967dfb35$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $20d30a12967dfb35$var$minimal_1.default.Reader ? input : new $20d30a12967dfb35$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $20d30a12967dfb35$var$baseMsgWithdrawDelegatorRewardResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $20d30a12967dfb35$var$baseMsgWithdrawDelegatorRewardResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $20d30a12967dfb35$var$baseMsgWithdrawDelegatorRewardResponse);
        return message;
    }
};
const $20d30a12967dfb35$var$baseMsgWithdrawValidatorCommission = {
    validatorAddress: ""
};
module.exports.MsgWithdrawValidatorCommission = {
    encode (message, writer = $20d30a12967dfb35$var$minimal_1.default.Writer.create()) {
        if (message.validatorAddress !== "") writer.uint32(10).string(message.validatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $20d30a12967dfb35$var$minimal_1.default.Reader ? input : new $20d30a12967dfb35$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $20d30a12967dfb35$var$baseMsgWithdrawValidatorCommission);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $20d30a12967dfb35$var$baseMsgWithdrawValidatorCommission);
        if (object.validatorAddress !== undefined && object.validatorAddress !== null) message.validatorAddress = String(object.validatorAddress);
        else message.validatorAddress = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $20d30a12967dfb35$var$baseMsgWithdrawValidatorCommission);
        if (object.validatorAddress !== undefined && object.validatorAddress !== null) message.validatorAddress = object.validatorAddress;
        else message.validatorAddress = "";
        return message;
    }
};
const $20d30a12967dfb35$var$baseMsgWithdrawValidatorCommissionResponse = {};
module.exports.MsgWithdrawValidatorCommissionResponse = {
    encode (_, writer = $20d30a12967dfb35$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $20d30a12967dfb35$var$minimal_1.default.Reader ? input : new $20d30a12967dfb35$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $20d30a12967dfb35$var$baseMsgWithdrawValidatorCommissionResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $20d30a12967dfb35$var$baseMsgWithdrawValidatorCommissionResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $20d30a12967dfb35$var$baseMsgWithdrawValidatorCommissionResponse);
        return message;
    }
};
const $20d30a12967dfb35$var$baseMsgFundCommunityPool = {
    depositor: ""
};
module.exports.MsgFundCommunityPool = {
    encode (message, writer = $20d30a12967dfb35$var$minimal_1.default.Writer.create()) {
        for (const v of message.amount)$lPVUQ.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.depositor !== "") writer.uint32(18).string(message.depositor);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $20d30a12967dfb35$var$minimal_1.default.Reader ? input : new $20d30a12967dfb35$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $20d30a12967dfb35$var$baseMsgFundCommunityPool);
        message.amount = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.amount.push($lPVUQ.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $20d30a12967dfb35$var$baseMsgFundCommunityPool);
        message.amount = [];
        if (object.amount !== undefined && object.amount !== null) for (const e of object.amount)message.amount.push($lPVUQ.Coin.fromJSON(e));
        if (object.depositor !== undefined && object.depositor !== null) message.depositor = String(object.depositor);
        else message.depositor = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $lPVUQ.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        message.depositor !== undefined && (obj.depositor = message.depositor);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $20d30a12967dfb35$var$baseMsgFundCommunityPool);
        message.amount = [];
        if (object.amount !== undefined && object.amount !== null) for (const e of object.amount)message.amount.push($lPVUQ.Coin.fromPartial(e));
        if (object.depositor !== undefined && object.depositor !== null) message.depositor = object.depositor;
        else message.depositor = "";
        return message;
    }
};
const $20d30a12967dfb35$var$baseMsgFundCommunityPoolResponse = {};
module.exports.MsgFundCommunityPoolResponse = {
    encode (_, writer = $20d30a12967dfb35$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $20d30a12967dfb35$var$minimal_1.default.Reader ? input : new $20d30a12967dfb35$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $20d30a12967dfb35$var$baseMsgFundCommunityPoolResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $20d30a12967dfb35$var$baseMsgFundCommunityPoolResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $20d30a12967dfb35$var$baseMsgFundCommunityPoolResponse);
        return message;
    }
};
class $20d30a12967dfb35$var$MsgClientImpl {
    SetWithdrawAddress(request, metadata) {
        return this.rpc.unary(module.exports.MsgSetWithdrawAddressDesc, module.exports.MsgSetWithdrawAddress.fromPartial(request), metadata);
    }
    WithdrawDelegatorReward(request, metadata) {
        return this.rpc.unary(module.exports.MsgWithdrawDelegatorRewardDesc, module.exports.MsgWithdrawDelegatorReward.fromPartial(request), metadata);
    }
    WithdrawValidatorCommission(request, metadata) {
        return this.rpc.unary(module.exports.MsgWithdrawValidatorCommissionDesc, module.exports.MsgWithdrawValidatorCommission.fromPartial(request), metadata);
    }
    FundCommunityPool(request, metadata) {
        return this.rpc.unary(module.exports.MsgFundCommunityPoolDesc, module.exports.MsgFundCommunityPool.fromPartial(request), metadata);
    }
    constructor(rpc){
        this.rpc = rpc;
        this.SetWithdrawAddress = this.SetWithdrawAddress.bind(this);
        this.WithdrawDelegatorReward = this.WithdrawDelegatorReward.bind(this);
        this.WithdrawValidatorCommission = this.WithdrawValidatorCommission.bind(this);
        this.FundCommunityPool = this.FundCommunityPool.bind(this);
    }
}
module.exports.MsgClientImpl = $20d30a12967dfb35$var$MsgClientImpl;
module.exports.MsgDesc = {
    serviceName: "cosmos.distribution.v1beta1.Msg"
};
module.exports.MsgSetWithdrawAddressDesc = {
    methodName: "SetWithdrawAddress",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgSetWithdrawAddress.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgSetWithdrawAddressResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.MsgWithdrawDelegatorRewardDesc = {
    methodName: "WithdrawDelegatorReward",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgWithdrawDelegatorReward.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgWithdrawDelegatorRewardResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.MsgWithdrawValidatorCommissionDesc = {
    methodName: "WithdrawValidatorCommission",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgWithdrawValidatorCommission.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgWithdrawValidatorCommissionResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.MsgFundCommunityPoolDesc = {
    methodName: "FundCommunityPool",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgFundCommunityPool.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgFundCommunityPoolResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
class $20d30a12967dfb35$var$GrpcWebImpl {
    unary(methodDesc, _request, metadata) {
        var _a;
        const request = Object.assign(Object.assign({}, _request), methodDesc.requestType);
        const maybeCombinedMetadata = metadata && this.options.metadata ? new $1pqjL.BrowserHeaders(Object.assign(Object.assign({}, (_a = this.options) === null || _a === void 0 ? void 0 : _a.metadata.headersMap), metadata === null || metadata === void 0 ? void 0 : metadata.headersMap)) : metadata || this.options.metadata;
        return new Promise((resolve, reject)=>{
            $jXVni.grpc.unary(methodDesc, {
                request: request,
                host: this.host,
                metadata: maybeCombinedMetadata,
                transport: this.options.transport,
                debug: this.options.debug,
                onEnd: function(response) {
                    if (response.status === $jXVni.grpc.Code.OK) resolve(response.message);
                    else {
                        const err = new Error(response.statusMessage);
                        err.code = response.status;
                        err.metadata = response.trailers;
                        reject(err);
                    }
                }
            });
        });
    }
    constructor(host, options){
        this.host = host;
        this.options = options;
    }
}
module.exports.GrpcWebImpl = $20d30a12967dfb35$var$GrpcWebImpl;
if ($20d30a12967dfb35$var$minimal_1.default.util.Long !== $20d30a12967dfb35$var$long_1.default) {
    $20d30a12967dfb35$var$minimal_1.default.util.Long = $20d30a12967dfb35$var$long_1.default;
    $20d30a12967dfb35$var$minimal_1.default.configure();
}

});


parcelRegister("3Lwky", function(module, exports) {
"use strict";
var $2bded70d5bdc886f$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgWithdrawDelegatorReward = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $2OIQB = parcelRequire("2OIQB");
/**
 * A delegator can withdraw currently outstanding rewards accrued from their delegation
 * toward a validator by submitting the following message.
 *
 * The rewards will be deposited to their Withdraw Address.
 */ var $2bded70d5bdc886f$var$MsgWithdrawDelegatorReward = /** @class */ function(_super) {
    $2bded70d5bdc886f$var$__extends(MsgWithdrawDelegatorReward, _super);
    /**
     *
     * @param delegator_address delegator's account address
     * @param validator_address validator's operator address
     */ function MsgWithdrawDelegatorReward(delegator_address, validator_address) {
        var _this = _super.call(this) || this;
        _this.delegator_address = delegator_address;
        _this.validator_address = validator_address;
        return _this;
    }
    MsgWithdrawDelegatorReward.fromAmino = function(data, _) {
        _;
        var _a = data.value, delegator_address = _a.delegator_address, validator_address = _a.validator_address;
        return new MsgWithdrawDelegatorReward(delegator_address, validator_address);
    };
    MsgWithdrawDelegatorReward.prototype.toAmino = function(isClassic) {
        var _a = this, delegator_address = _a.delegator_address, validator_address = _a.validator_address;
        return {
            type: isClassic ? "distribution/MsgWithdrawDelegationReward" : "cosmos-sdk/MsgWithdrawDelegationReward",
            value: {
                delegator_address: delegator_address,
                validator_address: validator_address
            }
        };
    };
    MsgWithdrawDelegatorReward.fromData = function(proto, _) {
        _;
        var delegator_address = proto.delegator_address, validator_address = proto.validator_address;
        return new MsgWithdrawDelegatorReward(delegator_address, validator_address);
    };
    MsgWithdrawDelegatorReward.prototype.toData = function(_) {
        _;
        var _a = this, delegator_address = _a.delegator_address, validator_address = _a.validator_address;
        return {
            "@type": "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
            delegator_address: delegator_address,
            validator_address: validator_address
        };
    };
    MsgWithdrawDelegatorReward.fromProto = function(proto, _) {
        _;
        return new MsgWithdrawDelegatorReward(proto.delegatorAddress, proto.validatorAddress);
    };
    MsgWithdrawDelegatorReward.prototype.toProto = function(_) {
        _;
        var _a = this, delegator_address = _a.delegator_address, validator_address = _a.validator_address;
        return $2OIQB.MsgWithdrawDelegatorReward.fromPartial({
            delegatorAddress: delegator_address,
            validatorAddress: validator_address
        });
    };
    MsgWithdrawDelegatorReward.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
            value: $2OIQB.MsgWithdrawDelegatorReward.encode(this.toProto(isClassic)).finish()
        });
    };
    MsgWithdrawDelegatorReward.unpackAny = function(msgAny, isClassic) {
        return MsgWithdrawDelegatorReward.fromProto($2OIQB.MsgWithdrawDelegatorReward.decode(msgAny.value), isClassic);
    };
    return MsgWithdrawDelegatorReward;
}($26Eqx.JSONSerializable);
module.exports.MsgWithdrawDelegatorReward = $2bded70d5bdc886f$var$MsgWithdrawDelegatorReward;

});

parcelRegister("jIohN", function(module, exports) {
"use strict";
var $03b43588a57c43e4$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgWithdrawValidatorCommission = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $2OIQB = parcelRequire("2OIQB");
/**
 * A validator can withdraw their outstanding commission rewards accrued from all
 * delegations (not including its self-delegation) into their associated account's
 * withdraw address.
 */ var $03b43588a57c43e4$var$MsgWithdrawValidatorCommission = /** @class */ function(_super) {
    $03b43588a57c43e4$var$__extends(MsgWithdrawValidatorCommission, _super);
    /**
     * @param validator_address validator's operator address
     */ function MsgWithdrawValidatorCommission(validator_address) {
        var _this = _super.call(this) || this;
        _this.validator_address = validator_address;
        return _this;
    }
    MsgWithdrawValidatorCommission.fromAmino = function(data, _) {
        _;
        var validator_address = data.value.validator_address;
        return new MsgWithdrawValidatorCommission(validator_address);
    };
    MsgWithdrawValidatorCommission.prototype.toAmino = function(isClassic) {
        var validator_address = this.validator_address;
        return {
            type: isClassic ? "distribution/MsgWithdrawValidatorCommission" : "cosmos-sdk/MsgWithdrawValidatorCommission",
            value: {
                validator_address: validator_address
            }
        };
    };
    MsgWithdrawValidatorCommission.fromData = function(proto, _) {
        _;
        var validator_address = proto.validator_address;
        return new MsgWithdrawValidatorCommission(validator_address);
    };
    MsgWithdrawValidatorCommission.prototype.toData = function(_) {
        _;
        var validator_address = this.validator_address;
        return {
            "@type": "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission",
            validator_address: validator_address
        };
    };
    MsgWithdrawValidatorCommission.fromProto = function(proto, _) {
        _;
        return new MsgWithdrawValidatorCommission(proto.validatorAddress);
    };
    MsgWithdrawValidatorCommission.prototype.toProto = function(_) {
        _;
        var validator_address = this.validator_address;
        return $2OIQB.MsgWithdrawValidatorCommission.fromPartial({
            validatorAddress: validator_address
        });
    };
    MsgWithdrawValidatorCommission.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission",
            value: $2OIQB.MsgWithdrawValidatorCommission.encode(this.toProto(isClassic)).finish()
        });
    };
    MsgWithdrawValidatorCommission.unpackAny = function(msgAny, isClassic) {
        return MsgWithdrawValidatorCommission.fromProto($2OIQB.MsgWithdrawValidatorCommission.decode(msgAny.value), isClassic);
    };
    return MsgWithdrawValidatorCommission;
}($26Eqx.JSONSerializable);
module.exports.MsgWithdrawValidatorCommission = $03b43588a57c43e4$var$MsgWithdrawValidatorCommission;

});

parcelRegister("6vlRx", function(module, exports) {
"use strict";
var $4bc698bfa1e3cbe6$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgFundCommunityPool = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $kYslP = parcelRequire("kYslP");

var $c5FxR = parcelRequire("c5FxR");

var $2OIQB = parcelRequire("2OIQB");
var $4bc698bfa1e3cbe6$var$MsgFundCommunityPool = /** @class */ function(_super) {
    $4bc698bfa1e3cbe6$var$__extends(MsgFundCommunityPool, _super);
    /**
     * @param depositor depositor's account address
     * @param amount coins to fund the community pool
     */ function MsgFundCommunityPool(depositor, amount) {
        var _this = _super.call(this) || this;
        _this.depositor = depositor;
        _this.amount = new $kYslP.Coins(amount);
        return _this;
    }
    MsgFundCommunityPool.fromAmino = function(data, _) {
        var _a = data.value, depositor = _a.depositor, amount = _a.amount;
        _;
        return new MsgFundCommunityPool(depositor, $kYslP.Coins.fromAmino(amount));
    };
    MsgFundCommunityPool.prototype.toAmino = function(isClassic) {
        var _a = this, depositor = _a.depositor, amount = _a.amount;
        return {
            type: isClassic ? "distribution/MsgFundCommunityPool" : "cosmos-sdk/MsgFundCommunityPool",
            value: {
                depositor: depositor,
                amount: amount.toAmino()
            }
        };
    };
    MsgFundCommunityPool.fromData = function(proto, _) {
        _;
        var depositor = proto.depositor, amount = proto.amount;
        return new MsgFundCommunityPool(depositor, $kYslP.Coins.fromData(amount));
    };
    MsgFundCommunityPool.prototype.toData = function(_) {
        _;
        var _a = this, depositor = _a.depositor, amount = _a.amount;
        return {
            "@type": "/cosmos.distribution.v1beta1.MsgFundCommunityPool",
            depositor: depositor,
            amount: amount.toData()
        };
    };
    MsgFundCommunityPool.fromProto = function(proto, _) {
        _;
        return new MsgFundCommunityPool(proto.depositor, $kYslP.Coins.fromProto(proto.amount));
    };
    MsgFundCommunityPool.prototype.toProto = function(_) {
        _;
        var _a = this, depositor = _a.depositor, amount = _a.amount;
        return $2OIQB.MsgFundCommunityPool.fromPartial({
            amount: amount.toProto(),
            depositor: depositor
        });
    };
    MsgFundCommunityPool.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmos.distribution.v1beta1.MsgFundCommunityPool",
            value: $2OIQB.MsgFundCommunityPool.encode(this.toProto(isClassic)).finish()
        });
    };
    MsgFundCommunityPool.unpackAny = function(msgAny, isClassic) {
        return MsgFundCommunityPool.fromProto($2OIQB.MsgFundCommunityPool.decode(msgAny.value), isClassic);
    };
    return MsgFundCommunityPool;
}($26Eqx.JSONSerializable);
module.exports.MsgFundCommunityPool = $4bc698bfa1e3cbe6$var$MsgFundCommunityPool;

});


parcelRegister("kYRT2", function(module, exports) {
"use strict";
var $f4633609c471d382$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f4633609c471d382$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f4633609c471d382$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f4633609c471d382$var$__exportStar((parcelRequire("kJ49s")), module.exports);

$f4633609c471d382$var$__exportStar((parcelRequire("eETRy")), module.exports);

});
parcelRegister("kJ49s", function(module, exports) {
"use strict";
var $f16b3b0ab1b95bc8$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgGrantAllowance = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $cZl7P = parcelRequire("cZl7P");

var $c5FxR = parcelRequire("c5FxR");

var $459nJ = parcelRequire("459nJ");
/**
 * MsgGrantAllowance adds permission for Grantee to spend up to Allowance
 * of fees from the account of Granter.
 */ var $f16b3b0ab1b95bc8$var$MsgGrantAllowance = /** @class */ function(_super) {
    $f16b3b0ab1b95bc8$var$__extends(MsgGrantAllowance, _super);
    /**
     *
     * @param granter granter's account address
     * @param grantee grantee's account address
     * @param allowance allowance willing to grant
     */ function MsgGrantAllowance(granter, grantee, allowance) {
        var _this = _super.call(this) || this;
        _this.granter = granter;
        _this.grantee = grantee;
        _this.allowance = allowance;
        return _this;
    }
    MsgGrantAllowance.fromAmino = function(data, isClassic) {
        var _a = data.value, granter = _a.granter, grantee = _a.grantee, allowance = _a.allowance;
        return new MsgGrantAllowance(granter, grantee, $cZl7P.Allowance.fromAmino(allowance, isClassic));
    };
    MsgGrantAllowance.prototype.toAmino = function(isClassic) {
        var _a = this, granter = _a.granter, grantee = _a.grantee, allowance = _a.allowance;
        return {
            type: isClassic ? "feegrant/MsgGrantAllowance" : "cosmos-sdk/MsgGrantAllowance",
            value: {
                granter: granter,
                grantee: grantee,
                allowance: allowance.toAmino(isClassic)
            }
        };
    };
    MsgGrantAllowance.fromData = function(data, isClassic) {
        var granter = data.granter, grantee = data.grantee, allowance = data.allowance;
        return new MsgGrantAllowance(granter, grantee, $cZl7P.Allowance.fromData(allowance, isClassic));
    };
    MsgGrantAllowance.prototype.toData = function(isClassic) {
        var _a = this, granter = _a.granter, grantee = _a.grantee, allowance = _a.allowance;
        return {
            "@type": "/cosmos.feegrant.v1beta1.MsgGrantAllowance",
            granter: granter,
            grantee: grantee,
            allowance: allowance.toData(isClassic)
        };
    };
    MsgGrantAllowance.fromProto = function(proto, isClassic) {
        return new MsgGrantAllowance(proto.granter, proto.grantee, $cZl7P.Allowance.fromProto(proto.allowance, isClassic));
    };
    MsgGrantAllowance.prototype.toProto = function(isClassic) {
        var _a = this, granter = _a.granter, grantee = _a.grantee, allowance = _a.allowance;
        return $459nJ.MsgGrantAllowance.fromPartial({
            allowance: allowance.packAny(isClassic),
            grantee: grantee,
            granter: granter
        });
    };
    MsgGrantAllowance.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmos.feegrant.v1beta1.MsgGrantAllowance",
            value: $459nJ.MsgGrantAllowance.encode(this.toProto(isClassic)).finish()
        });
    };
    MsgGrantAllowance.unpackAny = function(msgAny, isClassic) {
        return MsgGrantAllowance.fromProto($459nJ.MsgGrantAllowance.decode(msgAny.value), isClassic);
    };
    return MsgGrantAllowance;
}($26Eqx.JSONSerializable);
module.exports.MsgGrantAllowance = $f16b3b0ab1b95bc8$var$MsgGrantAllowance;

});
parcelRegister("cZl7P", function(module, exports) {
"use strict";
var $974b91986534d6ee$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $974b91986534d6ee$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $974b91986534d6ee$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Allowance = void 0;




$974b91986534d6ee$var$__exportStar((parcelRequire("2NL8m")), module.exports);

$974b91986534d6ee$var$__exportStar((parcelRequire("cYRBb")), module.exports);

$974b91986534d6ee$var$__exportStar((parcelRequire("13aRy")), module.exports);
var $974b91986534d6ee$var$Allowance;
(function(Allowance) {
    function fromAmino(data, isClassic) {
        switch(data.type){
            case "feegrant/BasicAllowance":
            case "cosmos-sdk/BasicAllowance":
                return (parcelRequire("2NL8m")).BasicAllowance.fromAmino(data, isClassic);
            case "feegrant/PeriodicAllowance":
            case "cosmos-sdk/PeriodicAllowance":
                return (parcelRequire("cYRBb")).PeriodicAllowance.fromAmino(data, isClassic);
            case "feegrant/AllowedMsgAllowance":
            case "cosmos-sdk/AllowedMsgAllowance":
                return (parcelRequire("13aRy")).AllowedMsgAllowance.fromAmino(data, isClassic);
        }
    }
    Allowance.fromAmino = fromAmino;
    function fromData(data, isClassic) {
        switch(data["@type"]){
            case "/cosmos.feegrant.v1beta1.PeriodicAllowance":
                return (parcelRequire("cYRBb")).PeriodicAllowance.fromData(data, isClassic);
            case "/cosmos.feegrant.v1beta1.BasicAllowance":
                return (parcelRequire("2NL8m")).BasicAllowance.fromData(data, isClassic);
            case "/cosmos.feegrant.v1beta1.AllowedMsgAllowance":
                return (parcelRequire("13aRy")).AllowedMsgAllowance.fromData(data, isClassic);
        }
    }
    Allowance.fromData = fromData;
    function fromProto(proto, isClassic) {
        switch(proto.typeUrl){
            case "/cosmos.feegrant.v1beta1.PeriodicAllowance":
                return (parcelRequire("cYRBb")).PeriodicAllowance.unpackAny(proto, isClassic);
            case "/cosmos.feegrant.v1beta1.BasicAllowance":
                return (parcelRequire("2NL8m")).BasicAllowance.unpackAny(proto, isClassic);
            case "/cosmos.feegrant.v1beta1.AllowedMsgAllowance":
                return (parcelRequire("13aRy")).AllowedMsgAllowance.unpackAny(proto, isClassic);
        }
        throw new Error("not supported allowance ".concat(proto.typeUrl));
    }
    Allowance.fromProto = fromProto;
})($974b91986534d6ee$var$Allowance = module.exports.Allowance || (module.exports.Allowance = {}));

});
parcelRegister("2NL8m", function(module, exports) {
"use strict";
var $20a4b8283213136d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BasicAllowance = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $kYslP = parcelRequire("kYslP");

var $c5FxR = parcelRequire("c5FxR");

var $aqp6u = parcelRequire("aqp6u");
/**
 * BasicAllowance implements Allowance with a one-time grant of tokens
 * that optionally expires. The grantee can use up to SpendLimit to cover fees.
 */ var $20a4b8283213136d$var$BasicAllowance = /** @class */ function(_super) {
    $20a4b8283213136d$var$__extends(BasicAllowance, _super);
    /**
     * @param spend_limit spend_limit allowed to be spent as fee
     * @param expiration allowance's expiration
     */ function BasicAllowance(spend_limit, expiration) {
        var _this = _super.call(this) || this;
        _this.expiration = expiration;
        var hasNotPositive = false;
        if (spend_limit) {
            _this.spend_limit = new $kYslP.Coins(spend_limit);
            _this.spend_limit.map(function(c) {
                // isPositive() from decimal.js returns true when the amount is 0.
                // but Coins.IsAllPositive() from cosmos-sdk will return false in same case.
                // so we use lessThanorEquenTo(0) instead of isPositive() == false
                if (c.amount.lessThanOrEqualTo(0)) hasNotPositive = true;
            });
        }
        if (spend_limit && hasNotPositive) throw Error("spend_limit must be positive");
        return _this;
    }
    BasicAllowance.fromAmino = function(data, _) {
        _;
        var _a = data.value, spend_limit = _a.spend_limit, expiration = _a.expiration;
        return new BasicAllowance(spend_limit ? $kYslP.Coins.fromAmino(spend_limit) : undefined, expiration ? new Date(expiration) : undefined);
    };
    BasicAllowance.prototype.toAmino = function(isClassic) {
        var _a = this, spend_limit = _a.spend_limit, expiration = _a.expiration;
        return {
            type: isClassic ? "feegrant/BasicAllowance" : "cosmos-sdk/BasicAllowance",
            value: {
                spend_limit: (spend_limit === null || spend_limit === void 0 ? void 0 : spend_limit.toAmino()) || undefined,
                expiration: (expiration === null || expiration === void 0 ? void 0 : expiration.toISOString().replace(/\.000Z$/, "Z")) || undefined
            }
        };
    };
    BasicAllowance.fromData = function(proto, _) {
        _;
        var spend_limit = proto.spend_limit, expiration = proto.expiration;
        return new BasicAllowance(spend_limit ? $kYslP.Coins.fromData(spend_limit) : undefined, expiration ? new Date(expiration) : undefined);
    };
    BasicAllowance.prototype.toData = function(_) {
        _;
        var _a = this, spend_limit = _a.spend_limit, expiration = _a.expiration;
        return {
            "@type": "/cosmos.feegrant.v1beta1.BasicAllowance",
            spend_limit: (spend_limit === null || spend_limit === void 0 ? void 0 : spend_limit.toData()) || undefined,
            expiration: (expiration === null || expiration === void 0 ? void 0 : expiration.toISOString().replace(/\.000Z$/, "Z")) || undefined
        };
    };
    BasicAllowance.fromProto = function(proto, _) {
        _;
        return new BasicAllowance($kYslP.Coins.fromProto(proto.spendLimit), proto.expiration ? proto.expiration : undefined);
    };
    BasicAllowance.prototype.toProto = function(_) {
        _;
        var _a = this, spend_limit = _a.spend_limit, expiration = _a.expiration;
        return $aqp6u.BasicAllowance.fromPartial({
            expiration: expiration,
            spendLimit: (spend_limit === null || spend_limit === void 0 ? void 0 : spend_limit.toProto()) || undefined
        });
    };
    BasicAllowance.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmos.feegrant.v1beta1.BasicAllowance",
            value: $aqp6u.BasicAllowance.encode(this.toProto(isClassic)).finish()
        });
    };
    BasicAllowance.unpackAny = function(msgAny, isClassic) {
        return BasicAllowance.fromProto($aqp6u.BasicAllowance.decode(msgAny.value), isClassic);
    };
    return BasicAllowance;
}($26Eqx.JSONSerializable);
module.exports.BasicAllowance = $20a4b8283213136d$var$BasicAllowance;

});
parcelRegister("aqp6u", function(module, exports) {
"use strict";
var $796fce265adbb445$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Grant = module.exports.AllowedMsgAllowance = module.exports.PeriodicAllowance = module.exports.BasicAllowance = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $796fce265adbb445$var$long_1 = $796fce265adbb445$var$__importDefault((parcelRequire("9A55m")));

const $796fce265adbb445$var$minimal_1 = $796fce265adbb445$var$__importDefault((parcelRequire("i2pIU")));

var $dmomH = parcelRequire("dmomH");

var $c5FxR = parcelRequire("c5FxR");

var $5G2s6 = parcelRequire("5G2s6");

var $lPVUQ = parcelRequire("lPVUQ");
module.exports.protobufPackage = "cosmos.feegrant.v1beta1";
const $796fce265adbb445$var$baseBasicAllowance = {};
module.exports.BasicAllowance = {
    encode (message, writer = $796fce265adbb445$var$minimal_1.default.Writer.create()) {
        for (const v of message.spendLimit)$lPVUQ.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.expiration !== undefined) $5G2s6.Timestamp.encode($796fce265adbb445$var$toTimestamp(message.expiration), writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $796fce265adbb445$var$minimal_1.default.Reader ? input : new $796fce265adbb445$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $796fce265adbb445$var$baseBasicAllowance);
        message.spendLimit = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.spendLimit.push($lPVUQ.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.expiration = $796fce265adbb445$var$fromTimestamp($5G2s6.Timestamp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $796fce265adbb445$var$baseBasicAllowance);
        message.spendLimit = [];
        if (object.spendLimit !== undefined && object.spendLimit !== null) for (const e of object.spendLimit)message.spendLimit.push($lPVUQ.Coin.fromJSON(e));
        if (object.expiration !== undefined && object.expiration !== null) message.expiration = $796fce265adbb445$var$fromJsonTimestamp(object.expiration);
        else message.expiration = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.spendLimit) obj.spendLimit = message.spendLimit.map((e)=>e ? $lPVUQ.Coin.toJSON(e) : undefined);
        else obj.spendLimit = [];
        message.expiration !== undefined && (obj.expiration = message.expiration.toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $796fce265adbb445$var$baseBasicAllowance);
        message.spendLimit = [];
        if (object.spendLimit !== undefined && object.spendLimit !== null) for (const e of object.spendLimit)message.spendLimit.push($lPVUQ.Coin.fromPartial(e));
        if (object.expiration !== undefined && object.expiration !== null) message.expiration = object.expiration;
        else message.expiration = undefined;
        return message;
    }
};
const $796fce265adbb445$var$basePeriodicAllowance = {};
module.exports.PeriodicAllowance = {
    encode (message, writer = $796fce265adbb445$var$minimal_1.default.Writer.create()) {
        if (message.basic !== undefined) module.exports.BasicAllowance.encode(message.basic, writer.uint32(10).fork()).ldelim();
        if (message.period !== undefined) $dmomH.Duration.encode(message.period, writer.uint32(18).fork()).ldelim();
        for (const v of message.periodSpendLimit)$lPVUQ.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        for (const v of message.periodCanSpend)$lPVUQ.Coin.encode(v, writer.uint32(34).fork()).ldelim();
        if (message.periodReset !== undefined) $5G2s6.Timestamp.encode($796fce265adbb445$var$toTimestamp(message.periodReset), writer.uint32(42).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $796fce265adbb445$var$minimal_1.default.Reader ? input : new $796fce265adbb445$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $796fce265adbb445$var$basePeriodicAllowance);
        message.periodSpendLimit = [];
        message.periodCanSpend = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.basic = module.exports.BasicAllowance.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.period = $dmomH.Duration.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.periodSpendLimit.push($lPVUQ.Coin.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.periodCanSpend.push($lPVUQ.Coin.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.periodReset = $796fce265adbb445$var$fromTimestamp($5G2s6.Timestamp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $796fce265adbb445$var$basePeriodicAllowance);
        message.periodSpendLimit = [];
        message.periodCanSpend = [];
        if (object.basic !== undefined && object.basic !== null) message.basic = module.exports.BasicAllowance.fromJSON(object.basic);
        else message.basic = undefined;
        if (object.period !== undefined && object.period !== null) message.period = $dmomH.Duration.fromJSON(object.period);
        else message.period = undefined;
        if (object.periodSpendLimit !== undefined && object.periodSpendLimit !== null) for (const e of object.periodSpendLimit)message.periodSpendLimit.push($lPVUQ.Coin.fromJSON(e));
        if (object.periodCanSpend !== undefined && object.periodCanSpend !== null) for (const e of object.periodCanSpend)message.periodCanSpend.push($lPVUQ.Coin.fromJSON(e));
        if (object.periodReset !== undefined && object.periodReset !== null) message.periodReset = $796fce265adbb445$var$fromJsonTimestamp(object.periodReset);
        else message.periodReset = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.basic !== undefined && (obj.basic = message.basic ? module.exports.BasicAllowance.toJSON(message.basic) : undefined);
        message.period !== undefined && (obj.period = message.period ? $dmomH.Duration.toJSON(message.period) : undefined);
        if (message.periodSpendLimit) obj.periodSpendLimit = message.periodSpendLimit.map((e)=>e ? $lPVUQ.Coin.toJSON(e) : undefined);
        else obj.periodSpendLimit = [];
        if (message.periodCanSpend) obj.periodCanSpend = message.periodCanSpend.map((e)=>e ? $lPVUQ.Coin.toJSON(e) : undefined);
        else obj.periodCanSpend = [];
        message.periodReset !== undefined && (obj.periodReset = message.periodReset.toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $796fce265adbb445$var$basePeriodicAllowance);
        message.periodSpendLimit = [];
        message.periodCanSpend = [];
        if (object.basic !== undefined && object.basic !== null) message.basic = module.exports.BasicAllowance.fromPartial(object.basic);
        else message.basic = undefined;
        if (object.period !== undefined && object.period !== null) message.period = $dmomH.Duration.fromPartial(object.period);
        else message.period = undefined;
        if (object.periodSpendLimit !== undefined && object.periodSpendLimit !== null) for (const e of object.periodSpendLimit)message.periodSpendLimit.push($lPVUQ.Coin.fromPartial(e));
        if (object.periodCanSpend !== undefined && object.periodCanSpend !== null) for (const e of object.periodCanSpend)message.periodCanSpend.push($lPVUQ.Coin.fromPartial(e));
        if (object.periodReset !== undefined && object.periodReset !== null) message.periodReset = object.periodReset;
        else message.periodReset = undefined;
        return message;
    }
};
const $796fce265adbb445$var$baseAllowedMsgAllowance = {
    allowedMessages: ""
};
module.exports.AllowedMsgAllowance = {
    encode (message, writer = $796fce265adbb445$var$minimal_1.default.Writer.create()) {
        if (message.allowance !== undefined) $c5FxR.Any.encode(message.allowance, writer.uint32(10).fork()).ldelim();
        for (const v of message.allowedMessages)writer.uint32(18).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $796fce265adbb445$var$minimal_1.default.Reader ? input : new $796fce265adbb445$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $796fce265adbb445$var$baseAllowedMsgAllowance);
        message.allowedMessages = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.allowance = $c5FxR.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.allowedMessages.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $796fce265adbb445$var$baseAllowedMsgAllowance);
        message.allowedMessages = [];
        if (object.allowance !== undefined && object.allowance !== null) message.allowance = $c5FxR.Any.fromJSON(object.allowance);
        else message.allowance = undefined;
        if (object.allowedMessages !== undefined && object.allowedMessages !== null) for (const e of object.allowedMessages)message.allowedMessages.push(String(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.allowance !== undefined && (obj.allowance = message.allowance ? $c5FxR.Any.toJSON(message.allowance) : undefined);
        if (message.allowedMessages) obj.allowedMessages = message.allowedMessages.map((e)=>e);
        else obj.allowedMessages = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $796fce265adbb445$var$baseAllowedMsgAllowance);
        message.allowedMessages = [];
        if (object.allowance !== undefined && object.allowance !== null) message.allowance = $c5FxR.Any.fromPartial(object.allowance);
        else message.allowance = undefined;
        if (object.allowedMessages !== undefined && object.allowedMessages !== null) for (const e of object.allowedMessages)message.allowedMessages.push(e);
        return message;
    }
};
const $796fce265adbb445$var$baseGrant = {
    granter: "",
    grantee: ""
};
module.exports.Grant = {
    encode (message, writer = $796fce265adbb445$var$minimal_1.default.Writer.create()) {
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        if (message.allowance !== undefined) $c5FxR.Any.encode(message.allowance, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $796fce265adbb445$var$minimal_1.default.Reader ? input : new $796fce265adbb445$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $796fce265adbb445$var$baseGrant);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.allowance = $c5FxR.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $796fce265adbb445$var$baseGrant);
        if (object.granter !== undefined && object.granter !== null) message.granter = String(object.granter);
        else message.granter = "";
        if (object.grantee !== undefined && object.grantee !== null) message.grantee = String(object.grantee);
        else message.grantee = "";
        if (object.allowance !== undefined && object.allowance !== null) message.allowance = $c5FxR.Any.fromJSON(object.allowance);
        else message.allowance = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.allowance !== undefined && (obj.allowance = message.allowance ? $c5FxR.Any.toJSON(message.allowance) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $796fce265adbb445$var$baseGrant);
        if (object.granter !== undefined && object.granter !== null) message.granter = object.granter;
        else message.granter = "";
        if (object.grantee !== undefined && object.grantee !== null) message.grantee = object.grantee;
        else message.grantee = "";
        if (object.allowance !== undefined && object.allowance !== null) message.allowance = $c5FxR.Any.fromPartial(object.allowance);
        else message.allowance = undefined;
        return message;
    }
};
function $796fce265adbb445$var$toTimestamp(date) {
    const seconds = $796fce265adbb445$var$numberToLong(date.getTime() / 1000);
    const nanos = date.getTime() % 1000 * 1000000;
    return {
        seconds: seconds,
        nanos: nanos
    };
}
function $796fce265adbb445$var$fromTimestamp(t) {
    let millis = t.seconds.toNumber() * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function $796fce265adbb445$var$fromJsonTimestamp(o) {
    if (o instanceof Date) return o;
    else if (typeof o === "string") return new Date(o);
    else return $796fce265adbb445$var$fromTimestamp($5G2s6.Timestamp.fromJSON(o));
}
function $796fce265adbb445$var$numberToLong(number) {
    return $796fce265adbb445$var$long_1.default.fromNumber(number);
}
if ($796fce265adbb445$var$minimal_1.default.util.Long !== $796fce265adbb445$var$long_1.default) {
    $796fce265adbb445$var$minimal_1.default.util.Long = $796fce265adbb445$var$long_1.default;
    $796fce265adbb445$var$minimal_1.default.configure();
}

});
parcelRegister("dmomH", function(module, exports) {
"use strict";
var $9ba03ad589097ff4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Duration = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $9ba03ad589097ff4$var$long_1 = $9ba03ad589097ff4$var$__importDefault((parcelRequire("9A55m")));

const $9ba03ad589097ff4$var$minimal_1 = $9ba03ad589097ff4$var$__importDefault((parcelRequire("i2pIU")));
module.exports.protobufPackage = "google.protobuf";
const $9ba03ad589097ff4$var$baseDuration = {
    seconds: $9ba03ad589097ff4$var$long_1.default.ZERO,
    nanos: 0
};
module.exports.Duration = {
    encode (message, writer = $9ba03ad589097ff4$var$minimal_1.default.Writer.create()) {
        if (!message.seconds.isZero()) writer.uint32(8).int64(message.seconds);
        if (message.nanos !== 0) writer.uint32(16).int32(message.nanos);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9ba03ad589097ff4$var$minimal_1.default.Reader ? input : new $9ba03ad589097ff4$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9ba03ad589097ff4$var$baseDuration);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.seconds = reader.int64();
                    break;
                case 2:
                    message.nanos = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9ba03ad589097ff4$var$baseDuration);
        if (object.seconds !== undefined && object.seconds !== null) message.seconds = $9ba03ad589097ff4$var$long_1.default.fromString(object.seconds);
        else message.seconds = $9ba03ad589097ff4$var$long_1.default.ZERO;
        if (object.nanos !== undefined && object.nanos !== null) message.nanos = Number(object.nanos);
        else message.nanos = 0;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.seconds !== undefined && (obj.seconds = (message.seconds || $9ba03ad589097ff4$var$long_1.default.ZERO).toString());
        message.nanos !== undefined && (obj.nanos = message.nanos);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9ba03ad589097ff4$var$baseDuration);
        if (object.seconds !== undefined && object.seconds !== null) message.seconds = object.seconds;
        else message.seconds = $9ba03ad589097ff4$var$long_1.default.ZERO;
        if (object.nanos !== undefined && object.nanos !== null) message.nanos = object.nanos;
        else message.nanos = 0;
        return message;
    }
};
if ($9ba03ad589097ff4$var$minimal_1.default.util.Long !== $9ba03ad589097ff4$var$long_1.default) {
    $9ba03ad589097ff4$var$minimal_1.default.util.Long = $9ba03ad589097ff4$var$long_1.default;
    $9ba03ad589097ff4$var$minimal_1.default.configure();
}

});

parcelRegister("5G2s6", function(module, exports) {
"use strict";
var $4222c6fca67f1994$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Timestamp = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $4222c6fca67f1994$var$long_1 = $4222c6fca67f1994$var$__importDefault((parcelRequire("9A55m")));

const $4222c6fca67f1994$var$minimal_1 = $4222c6fca67f1994$var$__importDefault((parcelRequire("i2pIU")));
module.exports.protobufPackage = "google.protobuf";
const $4222c6fca67f1994$var$baseTimestamp = {
    seconds: $4222c6fca67f1994$var$long_1.default.ZERO,
    nanos: 0
};
module.exports.Timestamp = {
    encode (message, writer = $4222c6fca67f1994$var$minimal_1.default.Writer.create()) {
        if (!message.seconds.isZero()) writer.uint32(8).int64(message.seconds);
        if (message.nanos !== 0) writer.uint32(16).int32(message.nanos);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4222c6fca67f1994$var$minimal_1.default.Reader ? input : new $4222c6fca67f1994$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $4222c6fca67f1994$var$baseTimestamp);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.seconds = reader.int64();
                    break;
                case 2:
                    message.nanos = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $4222c6fca67f1994$var$baseTimestamp);
        if (object.seconds !== undefined && object.seconds !== null) message.seconds = $4222c6fca67f1994$var$long_1.default.fromString(object.seconds);
        else message.seconds = $4222c6fca67f1994$var$long_1.default.ZERO;
        if (object.nanos !== undefined && object.nanos !== null) message.nanos = Number(object.nanos);
        else message.nanos = 0;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.seconds !== undefined && (obj.seconds = (message.seconds || $4222c6fca67f1994$var$long_1.default.ZERO).toString());
        message.nanos !== undefined && (obj.nanos = message.nanos);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $4222c6fca67f1994$var$baseTimestamp);
        if (object.seconds !== undefined && object.seconds !== null) message.seconds = object.seconds;
        else message.seconds = $4222c6fca67f1994$var$long_1.default.ZERO;
        if (object.nanos !== undefined && object.nanos !== null) message.nanos = object.nanos;
        else message.nanos = 0;
        return message;
    }
};
if ($4222c6fca67f1994$var$minimal_1.default.util.Long !== $4222c6fca67f1994$var$long_1.default) {
    $4222c6fca67f1994$var$minimal_1.default.util.Long = $4222c6fca67f1994$var$long_1.default;
    $4222c6fca67f1994$var$minimal_1.default.configure();
}

});



parcelRegister("cYRBb", function(module, exports) {
"use strict";
var $9734aa3537763ec6$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $9734aa3537763ec6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9734aa3537763ec6$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $9734aa3537763ec6$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $9734aa3537763ec6$var$__createBinding(result, mod, k);
    }
    $9734aa3537763ec6$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PeriodicAllowance = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $kYslP = parcelRequire("kYslP");

var $2NL8m = parcelRequire("2NL8m");

var $c5FxR = parcelRequire("c5FxR");

var $aqp6u = parcelRequire("aqp6u");

var $9734aa3537763ec6$var$Long = $9734aa3537763ec6$var$__importStar((parcelRequire("9A55m")));
/**
 * PeriodicAllowance extends Allowance to allow for both a maximum cap,
 * as well as a limit per time period.
 */ var $9734aa3537763ec6$var$PeriodicAllowance = /** @class */ function(_super) {
    $9734aa3537763ec6$var$__extends(PeriodicAllowance, _super);
    /**
     * @param basic basic allowance given per period
     * @param period the time duration in which period_spend_limit coins can be spent before that allowance is reset
     * @param period_spend_limit the maximum number of coins that can be spent in the period
     * @param period_can_spend the number of coins left to be spent before the period_reset time
     * @param period_reset the time at which this period resets and a new one begins
     */ function PeriodicAllowance(basic, period, period_spend_limit, period_can_spend, period_reset) {
        var _this = _super.call(this) || this;
        _this.basic = basic;
        _this.period = period;
        _this.period_reset = period_reset;
        _this.period_spend_limit = new $kYslP.Coins(period_spend_limit);
        _this.period_can_spend = new $kYslP.Coins(period_can_spend);
        return _this;
    }
    PeriodicAllowance.fromAmino = function(data, isClassic) {
        var _a = data.value, basic = _a.basic, period = _a.period, period_spend_limit = _a.period_spend_limit, period_can_spend = _a.period_can_spend, period_reset = _a.period_reset;
        return new PeriodicAllowance($2NL8m.BasicAllowance.fromAmino(basic, isClassic), Number.parseInt(period), $kYslP.Coins.fromAmino(period_spend_limit), $kYslP.Coins.fromAmino(period_can_spend), new Date(period_reset));
    };
    PeriodicAllowance.prototype.toAmino = function(isClassic) {
        var _a = this, basic = _a.basic, period = _a.period, period_spend_limit = _a.period_spend_limit, period_can_spend = _a.period_can_spend, period_reset = _a.period_reset;
        return {
            type: isClassic ? "feegrant/PeriodicAllowance" : "cosmos-sdk/PeriodicAllowance",
            value: {
                basic: basic.toAmino(isClassic),
                period: period.toString(),
                period_spend_limit: period_spend_limit.toAmino(),
                period_can_spend: period_can_spend.toAmino(),
                period_reset: period_reset.toISOString().replace(/\.000Z$/, "Z")
            }
        };
    };
    PeriodicAllowance.fromData = function(proto, _) {
        _;
        var basic = proto.basic, period = proto.period, period_spend_limit = proto.period_spend_limit, period_can_spend = proto.period_can_spend, period_reset = proto.period_reset;
        return new PeriodicAllowance($2NL8m.BasicAllowance.fromData(basic), Number.parseInt(period), $kYslP.Coins.fromData(period_spend_limit), $kYslP.Coins.fromData(period_can_spend), new Date(period_reset));
    };
    PeriodicAllowance.prototype.toData = function(_) {
        _;
        var _a = this, basic = _a.basic, period = _a.period, period_spend_limit = _a.period_spend_limit, period_can_spend = _a.period_can_spend, period_reset = _a.period_reset;
        return {
            "@type": "/cosmos.feegrant.v1beta1.PeriodicAllowance",
            basic: basic.toData(),
            period: period.toString(),
            period_spend_limit: period_spend_limit.toData(),
            period_can_spend: period_can_spend.toData(),
            period_reset: period_reset.toISOString().replace(/\.000Z$/, "Z")
        };
    };
    PeriodicAllowance.fromProto = function(proto, _) {
        var _a;
        _;
        return new PeriodicAllowance($2NL8m.BasicAllowance.fromProto(proto.basic), (_a = proto.period) === null || _a === void 0 ? void 0 : _a.seconds.toNumber(), $kYslP.Coins.fromProto(proto.periodSpendLimit), $kYslP.Coins.fromProto(proto.periodCanSpend), proto.periodReset);
    };
    PeriodicAllowance.prototype.toProto = function(_) {
        _;
        var _a = this, basic = _a.basic, period = _a.period, period_spend_limit = _a.period_spend_limit, period_can_spend = _a.period_can_spend, period_reset = _a.period_reset;
        return $aqp6u.PeriodicAllowance.fromPartial({
            basic: basic,
            period: {
                seconds: $9734aa3537763ec6$var$Long.fromNumber(period)
            },
            periodCanSpend: period_can_spend.toProto(),
            periodReset: period_reset,
            periodSpendLimit: period_spend_limit.toProto()
        });
    };
    PeriodicAllowance.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmos.feegrant.v1beta1.PeriodicAllowance",
            value: $aqp6u.PeriodicAllowance.encode(this.toProto(isClassic)).finish()
        });
    };
    PeriodicAllowance.unpackAny = function(msgAny, isClassic) {
        return PeriodicAllowance.fromProto($aqp6u.PeriodicAllowance.decode(msgAny.value), isClassic);
    };
    return PeriodicAllowance;
}($26Eqx.JSONSerializable);
module.exports.PeriodicAllowance = $9734aa3537763ec6$var$PeriodicAllowance;

});

parcelRegister("13aRy", function(module, exports) {
"use strict";
var $0c3e7f5d9bc50558$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AllowedMsgAllowance = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $2NL8m = parcelRequire("2NL8m");

var $cYRBb = parcelRequire("cYRBb");

var $c5FxR = parcelRequire("c5FxR");

var $aqp6u = parcelRequire("aqp6u");
/**
 * AllowedMsgAllowance creates allowance only for specified message types.
 */ var $0c3e7f5d9bc50558$var$AllowedMsgAllowance = /** @class */ function(_super) {
    $0c3e7f5d9bc50558$var$__extends(AllowedMsgAllowance, _super);
    /**
     * @param allowance any of basic and periodic fee allowance.
     * @param allowed_messages the messages for which the grantee has the access.
     */ function AllowedMsgAllowance(allowance, allowed_messages) {
        var _this = _super.call(this) || this;
        _this.allowance = allowance;
        _this.allowed_messages = allowed_messages;
        return _this;
    }
    AllowedMsgAllowance.fromAmino = function(data, isClassic) {
        var _a = data.value, allowance = _a.allowance, allowed_messages = _a.allowed_messages;
        return new AllowedMsgAllowance(allowance.type === "feegrant/BasicAllowance" || allowance.type === "cosmos-sdk/BasicAllowance" ? $2NL8m.BasicAllowance.fromAmino(allowance, isClassic) : $cYRBb.PeriodicAllowance.fromAmino(allowance, isClassic), allowed_messages);
    };
    AllowedMsgAllowance.prototype.toAmino = function(isClassic) {
        var _a = this, allowance = _a.allowance, allowed_messages = _a.allowed_messages;
        return {
            type: isClassic ? "feegrant/AllowedMsgAllowance" : "cosmos-sdk/AllowedMsgAllowance",
            value: {
                allowance: allowance.toAmino(isClassic),
                allowed_messages: allowed_messages
            }
        };
    };
    AllowedMsgAllowance.fromData = function(proto, _) {
        _;
        var allowance = proto.allowance, allowed_messages = proto.allowed_messages;
        return new AllowedMsgAllowance(allowance["@type"] === "/cosmos.feegrant.v1beta1.BasicAllowance" ? $2NL8m.BasicAllowance.fromData(allowance) : $cYRBb.PeriodicAllowance.fromData(allowance), allowed_messages);
    };
    AllowedMsgAllowance.prototype.toData = function(_) {
        _;
        var _a = this, allowance = _a.allowance, allowed_messages = _a.allowed_messages;
        return {
            "@type": "/cosmos.feegrant.v1beta1.AllowedMsgAllowance",
            allowance: allowance.toData(),
            allowed_messages: allowed_messages
        };
    };
    AllowedMsgAllowance.fromProto = function(proto, isClassic) {
        var allowance = proto.allowance;
        return new AllowedMsgAllowance((allowance === null || allowance === void 0 ? void 0 : allowance.typeUrl) === "/cosmos.feegrant.v1beta1.BasicAllowance" ? $2NL8m.BasicAllowance.unpackAny(allowance, isClassic) : $cYRBb.PeriodicAllowance.unpackAny(allowance, isClassic), proto.allowedMessages);
    };
    AllowedMsgAllowance.prototype.toProto = function(isClassic) {
        var _a = this, allowance = _a.allowance, allowed_messages = _a.allowed_messages;
        return $aqp6u.AllowedMsgAllowance.fromPartial({
            allowance: allowance.packAny(isClassic),
            allowedMessages: allowed_messages
        });
    };
    AllowedMsgAllowance.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmos.feegrant.v1beta1.AllowedMsgAllowance",
            value: $aqp6u.AllowedMsgAllowance.encode(this.toProto(isClassic)).finish()
        });
    };
    AllowedMsgAllowance.unpackAny = function(msgAny, isClassic) {
        return AllowedMsgAllowance.fromProto($aqp6u.AllowedMsgAllowance.decode(msgAny.value), isClassic);
    };
    return AllowedMsgAllowance;
}($26Eqx.JSONSerializable);
module.exports.AllowedMsgAllowance = $0c3e7f5d9bc50558$var$AllowedMsgAllowance;

});


parcelRegister("459nJ", function(module, exports) {
"use strict";
var $2f8ee819e1306dc2$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GrpcWebImpl = module.exports.MsgRevokeAllowanceDesc = module.exports.MsgGrantAllowanceDesc = module.exports.MsgDesc = module.exports.MsgClientImpl = module.exports.MsgRevokeAllowanceResponse = module.exports.MsgRevokeAllowance = module.exports.MsgGrantAllowanceResponse = module.exports.MsgGrantAllowance = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $2f8ee819e1306dc2$var$long_1 = $2f8ee819e1306dc2$var$__importDefault((parcelRequire("9A55m")));

var $jXVni = parcelRequire("jXVni");

const $2f8ee819e1306dc2$var$minimal_1 = $2f8ee819e1306dc2$var$__importDefault((parcelRequire("i2pIU")));

var $c5FxR = parcelRequire("c5FxR");

var $1pqjL = parcelRequire("1pqjL");
module.exports.protobufPackage = "cosmos.feegrant.v1beta1";
const $2f8ee819e1306dc2$var$baseMsgGrantAllowance = {
    granter: "",
    grantee: ""
};
module.exports.MsgGrantAllowance = {
    encode (message, writer = $2f8ee819e1306dc2$var$minimal_1.default.Writer.create()) {
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        if (message.allowance !== undefined) $c5FxR.Any.encode(message.allowance, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2f8ee819e1306dc2$var$minimal_1.default.Reader ? input : new $2f8ee819e1306dc2$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $2f8ee819e1306dc2$var$baseMsgGrantAllowance);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.allowance = $c5FxR.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $2f8ee819e1306dc2$var$baseMsgGrantAllowance);
        if (object.granter !== undefined && object.granter !== null) message.granter = String(object.granter);
        else message.granter = "";
        if (object.grantee !== undefined && object.grantee !== null) message.grantee = String(object.grantee);
        else message.grantee = "";
        if (object.allowance !== undefined && object.allowance !== null) message.allowance = $c5FxR.Any.fromJSON(object.allowance);
        else message.allowance = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.allowance !== undefined && (obj.allowance = message.allowance ? $c5FxR.Any.toJSON(message.allowance) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $2f8ee819e1306dc2$var$baseMsgGrantAllowance);
        if (object.granter !== undefined && object.granter !== null) message.granter = object.granter;
        else message.granter = "";
        if (object.grantee !== undefined && object.grantee !== null) message.grantee = object.grantee;
        else message.grantee = "";
        if (object.allowance !== undefined && object.allowance !== null) message.allowance = $c5FxR.Any.fromPartial(object.allowance);
        else message.allowance = undefined;
        return message;
    }
};
const $2f8ee819e1306dc2$var$baseMsgGrantAllowanceResponse = {};
module.exports.MsgGrantAllowanceResponse = {
    encode (_, writer = $2f8ee819e1306dc2$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2f8ee819e1306dc2$var$minimal_1.default.Reader ? input : new $2f8ee819e1306dc2$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $2f8ee819e1306dc2$var$baseMsgGrantAllowanceResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $2f8ee819e1306dc2$var$baseMsgGrantAllowanceResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $2f8ee819e1306dc2$var$baseMsgGrantAllowanceResponse);
        return message;
    }
};
const $2f8ee819e1306dc2$var$baseMsgRevokeAllowance = {
    granter: "",
    grantee: ""
};
module.exports.MsgRevokeAllowance = {
    encode (message, writer = $2f8ee819e1306dc2$var$minimal_1.default.Writer.create()) {
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2f8ee819e1306dc2$var$minimal_1.default.Reader ? input : new $2f8ee819e1306dc2$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $2f8ee819e1306dc2$var$baseMsgRevokeAllowance);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $2f8ee819e1306dc2$var$baseMsgRevokeAllowance);
        if (object.granter !== undefined && object.granter !== null) message.granter = String(object.granter);
        else message.granter = "";
        if (object.grantee !== undefined && object.grantee !== null) message.grantee = String(object.grantee);
        else message.grantee = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $2f8ee819e1306dc2$var$baseMsgRevokeAllowance);
        if (object.granter !== undefined && object.granter !== null) message.granter = object.granter;
        else message.granter = "";
        if (object.grantee !== undefined && object.grantee !== null) message.grantee = object.grantee;
        else message.grantee = "";
        return message;
    }
};
const $2f8ee819e1306dc2$var$baseMsgRevokeAllowanceResponse = {};
module.exports.MsgRevokeAllowanceResponse = {
    encode (_, writer = $2f8ee819e1306dc2$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2f8ee819e1306dc2$var$minimal_1.default.Reader ? input : new $2f8ee819e1306dc2$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $2f8ee819e1306dc2$var$baseMsgRevokeAllowanceResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $2f8ee819e1306dc2$var$baseMsgRevokeAllowanceResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $2f8ee819e1306dc2$var$baseMsgRevokeAllowanceResponse);
        return message;
    }
};
class $2f8ee819e1306dc2$var$MsgClientImpl {
    GrantAllowance(request, metadata) {
        return this.rpc.unary(module.exports.MsgGrantAllowanceDesc, module.exports.MsgGrantAllowance.fromPartial(request), metadata);
    }
    RevokeAllowance(request, metadata) {
        return this.rpc.unary(module.exports.MsgRevokeAllowanceDesc, module.exports.MsgRevokeAllowance.fromPartial(request), metadata);
    }
    constructor(rpc){
        this.rpc = rpc;
        this.GrantAllowance = this.GrantAllowance.bind(this);
        this.RevokeAllowance = this.RevokeAllowance.bind(this);
    }
}
module.exports.MsgClientImpl = $2f8ee819e1306dc2$var$MsgClientImpl;
module.exports.MsgDesc = {
    serviceName: "cosmos.feegrant.v1beta1.Msg"
};
module.exports.MsgGrantAllowanceDesc = {
    methodName: "GrantAllowance",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgGrantAllowance.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgGrantAllowanceResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.MsgRevokeAllowanceDesc = {
    methodName: "RevokeAllowance",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgRevokeAllowance.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgRevokeAllowanceResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
class $2f8ee819e1306dc2$var$GrpcWebImpl {
    unary(methodDesc, _request, metadata) {
        var _a;
        const request = Object.assign(Object.assign({}, _request), methodDesc.requestType);
        const maybeCombinedMetadata = metadata && this.options.metadata ? new $1pqjL.BrowserHeaders(Object.assign(Object.assign({}, (_a = this.options) === null || _a === void 0 ? void 0 : _a.metadata.headersMap), metadata === null || metadata === void 0 ? void 0 : metadata.headersMap)) : metadata || this.options.metadata;
        return new Promise((resolve, reject)=>{
            $jXVni.grpc.unary(methodDesc, {
                request: request,
                host: this.host,
                metadata: maybeCombinedMetadata,
                transport: this.options.transport,
                debug: this.options.debug,
                onEnd: function(response) {
                    if (response.status === $jXVni.grpc.Code.OK) resolve(response.message);
                    else {
                        const err = new Error(response.statusMessage);
                        err.code = response.status;
                        err.metadata = response.trailers;
                        reject(err);
                    }
                }
            });
        });
    }
    constructor(host, options){
        this.host = host;
        this.options = options;
    }
}
module.exports.GrpcWebImpl = $2f8ee819e1306dc2$var$GrpcWebImpl;
if ($2f8ee819e1306dc2$var$minimal_1.default.util.Long !== $2f8ee819e1306dc2$var$long_1.default) {
    $2f8ee819e1306dc2$var$minimal_1.default.util.Long = $2f8ee819e1306dc2$var$long_1.default;
    $2f8ee819e1306dc2$var$minimal_1.default.configure();
}

});


parcelRegister("eETRy", function(module, exports) {
"use strict";
var $aac0224fb1f9abe8$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgRevokeAllowance = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $459nJ = parcelRequire("459nJ");
/**
 * MsgRevokeAllowance remove permission any existing Allowance from Granter to Grantee.
 */ var $aac0224fb1f9abe8$var$MsgRevokeAllowance = /** @class */ function(_super) {
    $aac0224fb1f9abe8$var$__extends(MsgRevokeAllowance, _super);
    /**
     *
     * @param granter granter's account address
     * @param grantee grantee's account address
     */ function MsgRevokeAllowance(granter, grantee) {
        var _this = _super.call(this) || this;
        _this.granter = granter;
        _this.grantee = grantee;
        return _this;
    }
    MsgRevokeAllowance.fromAmino = function(data, _) {
        _;
        var _a = data.value, granter = _a.granter, grantee = _a.grantee;
        return new MsgRevokeAllowance(granter, grantee);
    };
    MsgRevokeAllowance.prototype.toAmino = function(isClassic) {
        var _a = this, granter = _a.granter, grantee = _a.grantee;
        return {
            type: isClassic ? "feegrant/MsgRevokeAllowance" : "cosmos-sdk/MsgRevokeAllowance",
            value: {
                granter: granter,
                grantee: grantee
            }
        };
    };
    MsgRevokeAllowance.fromData = function(proto, _) {
        _;
        var granter = proto.granter, grantee = proto.grantee;
        return new MsgRevokeAllowance(granter, grantee);
    };
    MsgRevokeAllowance.prototype.toData = function(_) {
        _;
        var _a = this, granter = _a.granter, grantee = _a.grantee;
        return {
            "@type": "/cosmos.feegrant.v1beta1.MsgRevokeAllowance",
            granter: granter,
            grantee: grantee
        };
    };
    MsgRevokeAllowance.fromProto = function(proto, _) {
        _;
        return new MsgRevokeAllowance(proto.granter, proto.grantee);
    };
    MsgRevokeAllowance.prototype.toProto = function(_) {
        _;
        var _a = this, granter = _a.granter, grantee = _a.grantee;
        return $459nJ.MsgRevokeAllowance.fromPartial({
            grantee: grantee,
            granter: granter
        });
    };
    MsgRevokeAllowance.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmos.feegrant.v1beta1.MsgRevokeAllowance",
            value: $459nJ.MsgRevokeAllowance.encode(this.toProto(isClassic)).finish()
        });
    };
    MsgRevokeAllowance.unpackAny = function(msgAny, isClassic) {
        return MsgRevokeAllowance.fromProto($459nJ.MsgRevokeAllowance.decode(msgAny.value), isClassic);
    };
    return MsgRevokeAllowance;
}($26Eqx.JSONSerializable);
module.exports.MsgRevokeAllowance = $aac0224fb1f9abe8$var$MsgRevokeAllowance;

});


parcelRegister("7CQub", function(module, exports) {
"use strict";
var $58d4cb99b5f44e25$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $58d4cb99b5f44e25$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $58d4cb99b5f44e25$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$58d4cb99b5f44e25$var$__exportStar((parcelRequire("fmD6d")), module.exports);

$58d4cb99b5f44e25$var$__exportStar((parcelRequire("ijmkT")), module.exports);

$58d4cb99b5f44e25$var$__exportStar((parcelRequire("3EMj8")), module.exports);

$58d4cb99b5f44e25$var$__exportStar((parcelRequire("eFXUK")), module.exports);

});
parcelRegister("fmD6d", function(module, exports) {
"use strict";
var $b2f73d624e8214cd$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $b2f73d624e8214cd$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b2f73d624e8214cd$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $b2f73d624e8214cd$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $b2f73d624e8214cd$var$__createBinding(result, mod, k);
    }
    $b2f73d624e8214cd$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgDeposit = void 0;

var $kYslP = parcelRequire("kYslP");

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $br4pC = parcelRequire("br4pC");

var $b2f73d624e8214cd$var$Long = $b2f73d624e8214cd$var$__importStar((parcelRequire("9A55m")));
/**
 * Add a deposit for a proposal
 */ var $b2f73d624e8214cd$var$MsgDeposit = /** @class */ function(_super) {
    $b2f73d624e8214cd$var$__extends(MsgDeposit, _super);
    /**
     * @param proposal_id Id of porposal to deposit to
     * @param depositor depositor's account address
     * @param amount amount to deposit
     */ function MsgDeposit(proposal_id, depositor, amount) {
        var _this = _super.call(this) || this;
        _this.proposal_id = proposal_id;
        _this.depositor = depositor;
        _this.amount = new $kYslP.Coins(amount);
        return _this;
    }
    MsgDeposit.fromAmino = function(data, _) {
        _;
        var _a = data.value, proposal_id = _a.proposal_id, depositor = _a.depositor, amount = _a.amount;
        return new MsgDeposit(Number.parseInt(proposal_id), depositor, $kYslP.Coins.fromAmino(amount));
    };
    MsgDeposit.prototype.toAmino = function(isClassic) {
        var _a = this, proposal_id = _a.proposal_id, depositor = _a.depositor, amount = _a.amount;
        return {
            type: isClassic ? "gov/MsgDeposit" : "cosmos-sdk/MsgDeposit",
            value: {
                proposal_id: proposal_id.toString(),
                depositor: depositor,
                amount: amount.toAmino()
            }
        };
    };
    MsgDeposit.fromData = function(data, _) {
        _;
        var proposal_id = data.proposal_id, depositor = data.depositor, amount = data.amount;
        return new MsgDeposit(Number.parseInt(proposal_id), depositor, $kYslP.Coins.fromData(amount));
    };
    MsgDeposit.prototype.toData = function(_) {
        _;
        var _a = this, proposal_id = _a.proposal_id, depositor = _a.depositor, amount = _a.amount;
        return {
            "@type": "/cosmos.gov.v1beta1.MsgDeposit",
            proposal_id: proposal_id.toString(),
            depositor: depositor,
            amount: amount.toData()
        };
    };
    MsgDeposit.fromProto = function(proto, _) {
        _;
        return new MsgDeposit(proto.proposalId.toNumber(), proto.depositor, $kYslP.Coins.fromProto(proto.amount));
    };
    MsgDeposit.prototype.toProto = function(_) {
        _;
        var _a = this, proposal_id = _a.proposal_id, depositor = _a.depositor, amount = _a.amount;
        return $br4pC.MsgDeposit.fromPartial({
            amount: amount.toProto(),
            depositor: depositor,
            proposalId: $b2f73d624e8214cd$var$Long.fromNumber(proposal_id)
        });
    };
    MsgDeposit.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmos.gov.v1beta1.MsgDeposit",
            value: $br4pC.MsgDeposit.encode(this.toProto(isClassic)).finish()
        });
    };
    MsgDeposit.unpackAny = function(msgAny, isClassic) {
        return MsgDeposit.fromProto($br4pC.MsgDeposit.decode(msgAny.value), isClassic);
    };
    return MsgDeposit;
}($26Eqx.JSONSerializable);
module.exports.MsgDeposit = $b2f73d624e8214cd$var$MsgDeposit;

});
parcelRegister("br4pC", function(module, exports) {
"use strict";
var $8535a37d6cc52899$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GrpcWebImpl = module.exports.MsgDepositDesc = module.exports.MsgVoteWeightedDesc = module.exports.MsgVoteDesc = module.exports.MsgSubmitProposalDesc = module.exports.MsgDesc = module.exports.MsgClientImpl = module.exports.MsgDepositResponse = module.exports.MsgDeposit = module.exports.MsgVoteWeightedResponse = module.exports.MsgVoteWeighted = module.exports.MsgVoteResponse = module.exports.MsgVote = module.exports.MsgSubmitProposalResponse = module.exports.MsgSubmitProposal = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $8535a37d6cc52899$var$long_1 = $8535a37d6cc52899$var$__importDefault((parcelRequire("9A55m")));

var $jXVni = parcelRequire("jXVni");

const $8535a37d6cc52899$var$minimal_1 = $8535a37d6cc52899$var$__importDefault((parcelRequire("i2pIU")));

var $c5FxR = parcelRequire("c5FxR");

var $9q3yq = parcelRequire("9q3yq");

var $1pqjL = parcelRequire("1pqjL");

var $lPVUQ = parcelRequire("lPVUQ");
module.exports.protobufPackage = "cosmos.gov.v1beta1";
const $8535a37d6cc52899$var$baseMsgSubmitProposal = {
    proposer: ""
};
module.exports.MsgSubmitProposal = {
    encode (message, writer = $8535a37d6cc52899$var$minimal_1.default.Writer.create()) {
        if (message.content !== undefined) $c5FxR.Any.encode(message.content, writer.uint32(10).fork()).ldelim();
        for (const v of message.initialDeposit)$lPVUQ.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        if (message.proposer !== "") writer.uint32(26).string(message.proposer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8535a37d6cc52899$var$minimal_1.default.Reader ? input : new $8535a37d6cc52899$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $8535a37d6cc52899$var$baseMsgSubmitProposal);
        message.initialDeposit = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.content = $c5FxR.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.initialDeposit.push($lPVUQ.Coin.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.proposer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $8535a37d6cc52899$var$baseMsgSubmitProposal);
        message.initialDeposit = [];
        if (object.content !== undefined && object.content !== null) message.content = $c5FxR.Any.fromJSON(object.content);
        else message.content = undefined;
        if (object.initialDeposit !== undefined && object.initialDeposit !== null) for (const e of object.initialDeposit)message.initialDeposit.push($lPVUQ.Coin.fromJSON(e));
        if (object.proposer !== undefined && object.proposer !== null) message.proposer = String(object.proposer);
        else message.proposer = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.content !== undefined && (obj.content = message.content ? $c5FxR.Any.toJSON(message.content) : undefined);
        if (message.initialDeposit) obj.initialDeposit = message.initialDeposit.map((e)=>e ? $lPVUQ.Coin.toJSON(e) : undefined);
        else obj.initialDeposit = [];
        message.proposer !== undefined && (obj.proposer = message.proposer);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $8535a37d6cc52899$var$baseMsgSubmitProposal);
        message.initialDeposit = [];
        if (object.content !== undefined && object.content !== null) message.content = $c5FxR.Any.fromPartial(object.content);
        else message.content = undefined;
        if (object.initialDeposit !== undefined && object.initialDeposit !== null) for (const e of object.initialDeposit)message.initialDeposit.push($lPVUQ.Coin.fromPartial(e));
        if (object.proposer !== undefined && object.proposer !== null) message.proposer = object.proposer;
        else message.proposer = "";
        return message;
    }
};
const $8535a37d6cc52899$var$baseMsgSubmitProposalResponse = {
    proposalId: $8535a37d6cc52899$var$long_1.default.UZERO
};
module.exports.MsgSubmitProposalResponse = {
    encode (message, writer = $8535a37d6cc52899$var$minimal_1.default.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8535a37d6cc52899$var$minimal_1.default.Reader ? input : new $8535a37d6cc52899$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $8535a37d6cc52899$var$baseMsgSubmitProposalResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $8535a37d6cc52899$var$baseMsgSubmitProposalResponse);
        if (object.proposalId !== undefined && object.proposalId !== null) message.proposalId = $8535a37d6cc52899$var$long_1.default.fromString(object.proposalId);
        else message.proposalId = $8535a37d6cc52899$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $8535a37d6cc52899$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $8535a37d6cc52899$var$baseMsgSubmitProposalResponse);
        if (object.proposalId !== undefined && object.proposalId !== null) message.proposalId = object.proposalId;
        else message.proposalId = $8535a37d6cc52899$var$long_1.default.UZERO;
        return message;
    }
};
const $8535a37d6cc52899$var$baseMsgVote = {
    proposalId: $8535a37d6cc52899$var$long_1.default.UZERO,
    voter: "",
    option: 0
};
module.exports.MsgVote = {
    encode (message, writer = $8535a37d6cc52899$var$minimal_1.default.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        if (message.option !== 0) writer.uint32(24).int32(message.option);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8535a37d6cc52899$var$minimal_1.default.Reader ? input : new $8535a37d6cc52899$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $8535a37d6cc52899$var$baseMsgVote);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.option = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $8535a37d6cc52899$var$baseMsgVote);
        if (object.proposalId !== undefined && object.proposalId !== null) message.proposalId = $8535a37d6cc52899$var$long_1.default.fromString(object.proposalId);
        else message.proposalId = $8535a37d6cc52899$var$long_1.default.UZERO;
        if (object.voter !== undefined && object.voter !== null) message.voter = String(object.voter);
        else message.voter = "";
        if (object.option !== undefined && object.option !== null) message.option = $9q3yq.voteOptionFromJSON(object.option);
        else message.option = 0;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $8535a37d6cc52899$var$long_1.default.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        message.option !== undefined && (obj.option = $9q3yq.voteOptionToJSON(message.option));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $8535a37d6cc52899$var$baseMsgVote);
        if (object.proposalId !== undefined && object.proposalId !== null) message.proposalId = object.proposalId;
        else message.proposalId = $8535a37d6cc52899$var$long_1.default.UZERO;
        if (object.voter !== undefined && object.voter !== null) message.voter = object.voter;
        else message.voter = "";
        if (object.option !== undefined && object.option !== null) message.option = object.option;
        else message.option = 0;
        return message;
    }
};
const $8535a37d6cc52899$var$baseMsgVoteResponse = {};
module.exports.MsgVoteResponse = {
    encode (_, writer = $8535a37d6cc52899$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8535a37d6cc52899$var$minimal_1.default.Reader ? input : new $8535a37d6cc52899$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $8535a37d6cc52899$var$baseMsgVoteResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $8535a37d6cc52899$var$baseMsgVoteResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $8535a37d6cc52899$var$baseMsgVoteResponse);
        return message;
    }
};
const $8535a37d6cc52899$var$baseMsgVoteWeighted = {
    proposalId: $8535a37d6cc52899$var$long_1.default.UZERO,
    voter: ""
};
module.exports.MsgVoteWeighted = {
    encode (message, writer = $8535a37d6cc52899$var$minimal_1.default.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        for (const v of message.options)$9q3yq.WeightedVoteOption.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8535a37d6cc52899$var$minimal_1.default.Reader ? input : new $8535a37d6cc52899$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $8535a37d6cc52899$var$baseMsgVoteWeighted);
        message.options = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.options.push($9q3yq.WeightedVoteOption.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $8535a37d6cc52899$var$baseMsgVoteWeighted);
        message.options = [];
        if (object.proposalId !== undefined && object.proposalId !== null) message.proposalId = $8535a37d6cc52899$var$long_1.default.fromString(object.proposalId);
        else message.proposalId = $8535a37d6cc52899$var$long_1.default.UZERO;
        if (object.voter !== undefined && object.voter !== null) message.voter = String(object.voter);
        else message.voter = "";
        if (object.options !== undefined && object.options !== null) for (const e of object.options)message.options.push($9q3yq.WeightedVoteOption.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $8535a37d6cc52899$var$long_1.default.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        if (message.options) obj.options = message.options.map((e)=>e ? $9q3yq.WeightedVoteOption.toJSON(e) : undefined);
        else obj.options = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $8535a37d6cc52899$var$baseMsgVoteWeighted);
        message.options = [];
        if (object.proposalId !== undefined && object.proposalId !== null) message.proposalId = object.proposalId;
        else message.proposalId = $8535a37d6cc52899$var$long_1.default.UZERO;
        if (object.voter !== undefined && object.voter !== null) message.voter = object.voter;
        else message.voter = "";
        if (object.options !== undefined && object.options !== null) for (const e of object.options)message.options.push($9q3yq.WeightedVoteOption.fromPartial(e));
        return message;
    }
};
const $8535a37d6cc52899$var$baseMsgVoteWeightedResponse = {};
module.exports.MsgVoteWeightedResponse = {
    encode (_, writer = $8535a37d6cc52899$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8535a37d6cc52899$var$minimal_1.default.Reader ? input : new $8535a37d6cc52899$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $8535a37d6cc52899$var$baseMsgVoteWeightedResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $8535a37d6cc52899$var$baseMsgVoteWeightedResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $8535a37d6cc52899$var$baseMsgVoteWeightedResponse);
        return message;
    }
};
const $8535a37d6cc52899$var$baseMsgDeposit = {
    proposalId: $8535a37d6cc52899$var$long_1.default.UZERO,
    depositor: ""
};
module.exports.MsgDeposit = {
    encode (message, writer = $8535a37d6cc52899$var$minimal_1.default.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.depositor !== "") writer.uint32(18).string(message.depositor);
        for (const v of message.amount)$lPVUQ.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8535a37d6cc52899$var$minimal_1.default.Reader ? input : new $8535a37d6cc52899$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $8535a37d6cc52899$var$baseMsgDeposit);
        message.amount = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                case 3:
                    message.amount.push($lPVUQ.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $8535a37d6cc52899$var$baseMsgDeposit);
        message.amount = [];
        if (object.proposalId !== undefined && object.proposalId !== null) message.proposalId = $8535a37d6cc52899$var$long_1.default.fromString(object.proposalId);
        else message.proposalId = $8535a37d6cc52899$var$long_1.default.UZERO;
        if (object.depositor !== undefined && object.depositor !== null) message.depositor = String(object.depositor);
        else message.depositor = "";
        if (object.amount !== undefined && object.amount !== null) for (const e of object.amount)message.amount.push($lPVUQ.Coin.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $8535a37d6cc52899$var$long_1.default.UZERO).toString());
        message.depositor !== undefined && (obj.depositor = message.depositor);
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $lPVUQ.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $8535a37d6cc52899$var$baseMsgDeposit);
        message.amount = [];
        if (object.proposalId !== undefined && object.proposalId !== null) message.proposalId = object.proposalId;
        else message.proposalId = $8535a37d6cc52899$var$long_1.default.UZERO;
        if (object.depositor !== undefined && object.depositor !== null) message.depositor = object.depositor;
        else message.depositor = "";
        if (object.amount !== undefined && object.amount !== null) for (const e of object.amount)message.amount.push($lPVUQ.Coin.fromPartial(e));
        return message;
    }
};
const $8535a37d6cc52899$var$baseMsgDepositResponse = {};
module.exports.MsgDepositResponse = {
    encode (_, writer = $8535a37d6cc52899$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8535a37d6cc52899$var$minimal_1.default.Reader ? input : new $8535a37d6cc52899$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $8535a37d6cc52899$var$baseMsgDepositResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $8535a37d6cc52899$var$baseMsgDepositResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $8535a37d6cc52899$var$baseMsgDepositResponse);
        return message;
    }
};
class $8535a37d6cc52899$var$MsgClientImpl {
    SubmitProposal(request, metadata) {
        return this.rpc.unary(module.exports.MsgSubmitProposalDesc, module.exports.MsgSubmitProposal.fromPartial(request), metadata);
    }
    Vote(request, metadata) {
        return this.rpc.unary(module.exports.MsgVoteDesc, module.exports.MsgVote.fromPartial(request), metadata);
    }
    VoteWeighted(request, metadata) {
        return this.rpc.unary(module.exports.MsgVoteWeightedDesc, module.exports.MsgVoteWeighted.fromPartial(request), metadata);
    }
    Deposit(request, metadata) {
        return this.rpc.unary(module.exports.MsgDepositDesc, module.exports.MsgDeposit.fromPartial(request), metadata);
    }
    constructor(rpc){
        this.rpc = rpc;
        this.SubmitProposal = this.SubmitProposal.bind(this);
        this.Vote = this.Vote.bind(this);
        this.VoteWeighted = this.VoteWeighted.bind(this);
        this.Deposit = this.Deposit.bind(this);
    }
}
module.exports.MsgClientImpl = $8535a37d6cc52899$var$MsgClientImpl;
module.exports.MsgDesc = {
    serviceName: "cosmos.gov.v1beta1.Msg"
};
module.exports.MsgSubmitProposalDesc = {
    methodName: "SubmitProposal",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgSubmitProposal.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgSubmitProposalResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.MsgVoteDesc = {
    methodName: "Vote",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgVote.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgVoteResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.MsgVoteWeightedDesc = {
    methodName: "VoteWeighted",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgVoteWeighted.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgVoteWeightedResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.MsgDepositDesc = {
    methodName: "Deposit",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgDeposit.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgDepositResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
class $8535a37d6cc52899$var$GrpcWebImpl {
    unary(methodDesc, _request, metadata) {
        var _a;
        const request = Object.assign(Object.assign({}, _request), methodDesc.requestType);
        const maybeCombinedMetadata = metadata && this.options.metadata ? new $1pqjL.BrowserHeaders(Object.assign(Object.assign({}, (_a = this.options) === null || _a === void 0 ? void 0 : _a.metadata.headersMap), metadata === null || metadata === void 0 ? void 0 : metadata.headersMap)) : metadata || this.options.metadata;
        return new Promise((resolve, reject)=>{
            $jXVni.grpc.unary(methodDesc, {
                request: request,
                host: this.host,
                metadata: maybeCombinedMetadata,
                transport: this.options.transport,
                debug: this.options.debug,
                onEnd: function(response) {
                    if (response.status === $jXVni.grpc.Code.OK) resolve(response.message);
                    else {
                        const err = new Error(response.statusMessage);
                        err.code = response.status;
                        err.metadata = response.trailers;
                        reject(err);
                    }
                }
            });
        });
    }
    constructor(host, options){
        this.host = host;
        this.options = options;
    }
}
module.exports.GrpcWebImpl = $8535a37d6cc52899$var$GrpcWebImpl;
if ($8535a37d6cc52899$var$minimal_1.default.util.Long !== $8535a37d6cc52899$var$long_1.default) {
    $8535a37d6cc52899$var$minimal_1.default.util.Long = $8535a37d6cc52899$var$long_1.default;
    $8535a37d6cc52899$var$minimal_1.default.configure();
}

});
parcelRegister("9q3yq", function(module, exports) {
"use strict";
var $6db94c92719d86ea$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TallyParams = module.exports.VotingParams = module.exports.DepositParams = module.exports.Vote = module.exports.TallyResult = module.exports.Proposal = module.exports.Deposit = module.exports.TextProposal = module.exports.WeightedVoteOption = module.exports.proposalStatusToJSON = module.exports.proposalStatusFromJSON = module.exports.ProposalStatus = module.exports.voteOptionToJSON = module.exports.voteOptionFromJSON = module.exports.VoteOption = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $6db94c92719d86ea$var$long_1 = $6db94c92719d86ea$var$__importDefault((parcelRequire("9A55m")));

const $6db94c92719d86ea$var$minimal_1 = $6db94c92719d86ea$var$__importDefault((parcelRequire("i2pIU")));

var $c5FxR = parcelRequire("c5FxR");

var $dmomH = parcelRequire("dmomH");

var $5G2s6 = parcelRequire("5G2s6");

var $lPVUQ = parcelRequire("lPVUQ");
module.exports.protobufPackage = "cosmos.gov.v1beta1";
/** VoteOption enumerates the valid vote options for a given governance proposal. */ var $6db94c92719d86ea$var$VoteOption;
(function(VoteOption) {
    /** VOTE_OPTION_UNSPECIFIED - VOTE_OPTION_UNSPECIFIED defines a no-op vote option. */ VoteOption[VoteOption["VOTE_OPTION_UNSPECIFIED"] = 0] = "VOTE_OPTION_UNSPECIFIED";
    /** VOTE_OPTION_YES - VOTE_OPTION_YES defines a yes vote option. */ VoteOption[VoteOption["VOTE_OPTION_YES"] = 1] = "VOTE_OPTION_YES";
    /** VOTE_OPTION_ABSTAIN - VOTE_OPTION_ABSTAIN defines an abstain vote option. */ VoteOption[VoteOption["VOTE_OPTION_ABSTAIN"] = 2] = "VOTE_OPTION_ABSTAIN";
    /** VOTE_OPTION_NO - VOTE_OPTION_NO defines a no vote option. */ VoteOption[VoteOption["VOTE_OPTION_NO"] = 3] = "VOTE_OPTION_NO";
    /** VOTE_OPTION_NO_WITH_VETO - VOTE_OPTION_NO_WITH_VETO defines a no with veto vote option. */ VoteOption[VoteOption["VOTE_OPTION_NO_WITH_VETO"] = 4] = "VOTE_OPTION_NO_WITH_VETO";
    VoteOption[VoteOption["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($6db94c92719d86ea$var$VoteOption = module.exports.VoteOption || (module.exports.VoteOption = {}));
function $6db94c92719d86ea$var$voteOptionFromJSON(object) {
    switch(object){
        case 0:
        case "VOTE_OPTION_UNSPECIFIED":
            return $6db94c92719d86ea$var$VoteOption.VOTE_OPTION_UNSPECIFIED;
        case 1:
        case "VOTE_OPTION_YES":
            return $6db94c92719d86ea$var$VoteOption.VOTE_OPTION_YES;
        case 2:
        case "VOTE_OPTION_ABSTAIN":
            return $6db94c92719d86ea$var$VoteOption.VOTE_OPTION_ABSTAIN;
        case 3:
        case "VOTE_OPTION_NO":
            return $6db94c92719d86ea$var$VoteOption.VOTE_OPTION_NO;
        case 4:
        case "VOTE_OPTION_NO_WITH_VETO":
            return $6db94c92719d86ea$var$VoteOption.VOTE_OPTION_NO_WITH_VETO;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $6db94c92719d86ea$var$VoteOption.UNRECOGNIZED;
    }
}
module.exports.voteOptionFromJSON = $6db94c92719d86ea$var$voteOptionFromJSON;
function $6db94c92719d86ea$var$voteOptionToJSON(object) {
    switch(object){
        case $6db94c92719d86ea$var$VoteOption.VOTE_OPTION_UNSPECIFIED:
            return "VOTE_OPTION_UNSPECIFIED";
        case $6db94c92719d86ea$var$VoteOption.VOTE_OPTION_YES:
            return "VOTE_OPTION_YES";
        case $6db94c92719d86ea$var$VoteOption.VOTE_OPTION_ABSTAIN:
            return "VOTE_OPTION_ABSTAIN";
        case $6db94c92719d86ea$var$VoteOption.VOTE_OPTION_NO:
            return "VOTE_OPTION_NO";
        case $6db94c92719d86ea$var$VoteOption.VOTE_OPTION_NO_WITH_VETO:
            return "VOTE_OPTION_NO_WITH_VETO";
        default:
            return "UNKNOWN";
    }
}
module.exports.voteOptionToJSON = $6db94c92719d86ea$var$voteOptionToJSON;
/** ProposalStatus enumerates the valid statuses of a proposal. */ var $6db94c92719d86ea$var$ProposalStatus;
(function(ProposalStatus) {
    /** PROPOSAL_STATUS_UNSPECIFIED - PROPOSAL_STATUS_UNSPECIFIED defines the default propopsal status. */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_UNSPECIFIED"] = 0] = "PROPOSAL_STATUS_UNSPECIFIED";
    /**
     * PROPOSAL_STATUS_DEPOSIT_PERIOD - PROPOSAL_STATUS_DEPOSIT_PERIOD defines a proposal status during the deposit
     * period.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_DEPOSIT_PERIOD"] = 1] = "PROPOSAL_STATUS_DEPOSIT_PERIOD";
    /**
     * PROPOSAL_STATUS_VOTING_PERIOD - PROPOSAL_STATUS_VOTING_PERIOD defines a proposal status during the voting
     * period.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_VOTING_PERIOD"] = 2] = "PROPOSAL_STATUS_VOTING_PERIOD";
    /**
     * PROPOSAL_STATUS_PASSED - PROPOSAL_STATUS_PASSED defines a proposal status of a proposal that has
     * passed.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_PASSED"] = 3] = "PROPOSAL_STATUS_PASSED";
    /**
     * PROPOSAL_STATUS_REJECTED - PROPOSAL_STATUS_REJECTED defines a proposal status of a proposal that has
     * been rejected.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_REJECTED"] = 4] = "PROPOSAL_STATUS_REJECTED";
    /**
     * PROPOSAL_STATUS_FAILED - PROPOSAL_STATUS_FAILED defines a proposal status of a proposal that has
     * failed.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_FAILED"] = 5] = "PROPOSAL_STATUS_FAILED";
    ProposalStatus[ProposalStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($6db94c92719d86ea$var$ProposalStatus = module.exports.ProposalStatus || (module.exports.ProposalStatus = {}));
function $6db94c92719d86ea$var$proposalStatusFromJSON(object) {
    switch(object){
        case 0:
        case "PROPOSAL_STATUS_UNSPECIFIED":
            return $6db94c92719d86ea$var$ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED;
        case 1:
        case "PROPOSAL_STATUS_DEPOSIT_PERIOD":
            return $6db94c92719d86ea$var$ProposalStatus.PROPOSAL_STATUS_DEPOSIT_PERIOD;
        case 2:
        case "PROPOSAL_STATUS_VOTING_PERIOD":
            return $6db94c92719d86ea$var$ProposalStatus.PROPOSAL_STATUS_VOTING_PERIOD;
        case 3:
        case "PROPOSAL_STATUS_PASSED":
            return $6db94c92719d86ea$var$ProposalStatus.PROPOSAL_STATUS_PASSED;
        case 4:
        case "PROPOSAL_STATUS_REJECTED":
            return $6db94c92719d86ea$var$ProposalStatus.PROPOSAL_STATUS_REJECTED;
        case 5:
        case "PROPOSAL_STATUS_FAILED":
            return $6db94c92719d86ea$var$ProposalStatus.PROPOSAL_STATUS_FAILED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $6db94c92719d86ea$var$ProposalStatus.UNRECOGNIZED;
    }
}
module.exports.proposalStatusFromJSON = $6db94c92719d86ea$var$proposalStatusFromJSON;
function $6db94c92719d86ea$var$proposalStatusToJSON(object) {
    switch(object){
        case $6db94c92719d86ea$var$ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED:
            return "PROPOSAL_STATUS_UNSPECIFIED";
        case $6db94c92719d86ea$var$ProposalStatus.PROPOSAL_STATUS_DEPOSIT_PERIOD:
            return "PROPOSAL_STATUS_DEPOSIT_PERIOD";
        case $6db94c92719d86ea$var$ProposalStatus.PROPOSAL_STATUS_VOTING_PERIOD:
            return "PROPOSAL_STATUS_VOTING_PERIOD";
        case $6db94c92719d86ea$var$ProposalStatus.PROPOSAL_STATUS_PASSED:
            return "PROPOSAL_STATUS_PASSED";
        case $6db94c92719d86ea$var$ProposalStatus.PROPOSAL_STATUS_REJECTED:
            return "PROPOSAL_STATUS_REJECTED";
        case $6db94c92719d86ea$var$ProposalStatus.PROPOSAL_STATUS_FAILED:
            return "PROPOSAL_STATUS_FAILED";
        default:
            return "UNKNOWN";
    }
}
module.exports.proposalStatusToJSON = $6db94c92719d86ea$var$proposalStatusToJSON;
const $6db94c92719d86ea$var$baseWeightedVoteOption = {
    option: 0,
    weight: ""
};
module.exports.WeightedVoteOption = {
    encode (message, writer = $6db94c92719d86ea$var$minimal_1.default.Writer.create()) {
        if (message.option !== 0) writer.uint32(8).int32(message.option);
        if (message.weight !== "") writer.uint32(18).string(message.weight);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6db94c92719d86ea$var$minimal_1.default.Reader ? input : new $6db94c92719d86ea$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $6db94c92719d86ea$var$baseWeightedVoteOption);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.option = reader.int32();
                    break;
                case 2:
                    message.weight = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $6db94c92719d86ea$var$baseWeightedVoteOption);
        if (object.option !== undefined && object.option !== null) message.option = $6db94c92719d86ea$var$voteOptionFromJSON(object.option);
        else message.option = 0;
        if (object.weight !== undefined && object.weight !== null) message.weight = String(object.weight);
        else message.weight = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.option !== undefined && (obj.option = $6db94c92719d86ea$var$voteOptionToJSON(message.option));
        message.weight !== undefined && (obj.weight = message.weight);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $6db94c92719d86ea$var$baseWeightedVoteOption);
        if (object.option !== undefined && object.option !== null) message.option = object.option;
        else message.option = 0;
        if (object.weight !== undefined && object.weight !== null) message.weight = object.weight;
        else message.weight = "";
        return message;
    }
};
const $6db94c92719d86ea$var$baseTextProposal = {
    title: "",
    description: ""
};
module.exports.TextProposal = {
    encode (message, writer = $6db94c92719d86ea$var$minimal_1.default.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6db94c92719d86ea$var$minimal_1.default.Reader ? input : new $6db94c92719d86ea$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $6db94c92719d86ea$var$baseTextProposal);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $6db94c92719d86ea$var$baseTextProposal);
        if (object.title !== undefined && object.title !== null) message.title = String(object.title);
        else message.title = "";
        if (object.description !== undefined && object.description !== null) message.description = String(object.description);
        else message.description = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $6db94c92719d86ea$var$baseTextProposal);
        if (object.title !== undefined && object.title !== null) message.title = object.title;
        else message.title = "";
        if (object.description !== undefined && object.description !== null) message.description = object.description;
        else message.description = "";
        return message;
    }
};
const $6db94c92719d86ea$var$baseDeposit = {
    proposalId: $6db94c92719d86ea$var$long_1.default.UZERO,
    depositor: ""
};
module.exports.Deposit = {
    encode (message, writer = $6db94c92719d86ea$var$minimal_1.default.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.depositor !== "") writer.uint32(18).string(message.depositor);
        for (const v of message.amount)$lPVUQ.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6db94c92719d86ea$var$minimal_1.default.Reader ? input : new $6db94c92719d86ea$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $6db94c92719d86ea$var$baseDeposit);
        message.amount = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                case 3:
                    message.amount.push($lPVUQ.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $6db94c92719d86ea$var$baseDeposit);
        message.amount = [];
        if (object.proposalId !== undefined && object.proposalId !== null) message.proposalId = $6db94c92719d86ea$var$long_1.default.fromString(object.proposalId);
        else message.proposalId = $6db94c92719d86ea$var$long_1.default.UZERO;
        if (object.depositor !== undefined && object.depositor !== null) message.depositor = String(object.depositor);
        else message.depositor = "";
        if (object.amount !== undefined && object.amount !== null) for (const e of object.amount)message.amount.push($lPVUQ.Coin.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $6db94c92719d86ea$var$long_1.default.UZERO).toString());
        message.depositor !== undefined && (obj.depositor = message.depositor);
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $lPVUQ.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $6db94c92719d86ea$var$baseDeposit);
        message.amount = [];
        if (object.proposalId !== undefined && object.proposalId !== null) message.proposalId = object.proposalId;
        else message.proposalId = $6db94c92719d86ea$var$long_1.default.UZERO;
        if (object.depositor !== undefined && object.depositor !== null) message.depositor = object.depositor;
        else message.depositor = "";
        if (object.amount !== undefined && object.amount !== null) for (const e of object.amount)message.amount.push($lPVUQ.Coin.fromPartial(e));
        return message;
    }
};
const $6db94c92719d86ea$var$baseProposal = {
    proposalId: $6db94c92719d86ea$var$long_1.default.UZERO,
    status: 0
};
module.exports.Proposal = {
    encode (message, writer = $6db94c92719d86ea$var$minimal_1.default.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.content !== undefined) $c5FxR.Any.encode(message.content, writer.uint32(18).fork()).ldelim();
        if (message.status !== 0) writer.uint32(24).int32(message.status);
        if (message.finalTallyResult !== undefined) module.exports.TallyResult.encode(message.finalTallyResult, writer.uint32(34).fork()).ldelim();
        if (message.submitTime !== undefined) $5G2s6.Timestamp.encode($6db94c92719d86ea$var$toTimestamp(message.submitTime), writer.uint32(42).fork()).ldelim();
        if (message.depositEndTime !== undefined) $5G2s6.Timestamp.encode($6db94c92719d86ea$var$toTimestamp(message.depositEndTime), writer.uint32(50).fork()).ldelim();
        for (const v of message.totalDeposit)$lPVUQ.Coin.encode(v, writer.uint32(58).fork()).ldelim();
        if (message.votingStartTime !== undefined) $5G2s6.Timestamp.encode($6db94c92719d86ea$var$toTimestamp(message.votingStartTime), writer.uint32(66).fork()).ldelim();
        if (message.votingEndTime !== undefined) $5G2s6.Timestamp.encode($6db94c92719d86ea$var$toTimestamp(message.votingEndTime), writer.uint32(74).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6db94c92719d86ea$var$minimal_1.default.Reader ? input : new $6db94c92719d86ea$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $6db94c92719d86ea$var$baseProposal);
        message.totalDeposit = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.content = $c5FxR.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.status = reader.int32();
                    break;
                case 4:
                    message.finalTallyResult = module.exports.TallyResult.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.submitTime = $6db94c92719d86ea$var$fromTimestamp($5G2s6.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 6:
                    message.depositEndTime = $6db94c92719d86ea$var$fromTimestamp($5G2s6.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 7:
                    message.totalDeposit.push($lPVUQ.Coin.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.votingStartTime = $6db94c92719d86ea$var$fromTimestamp($5G2s6.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 9:
                    message.votingEndTime = $6db94c92719d86ea$var$fromTimestamp($5G2s6.Timestamp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $6db94c92719d86ea$var$baseProposal);
        message.totalDeposit = [];
        if (object.proposalId !== undefined && object.proposalId !== null) message.proposalId = $6db94c92719d86ea$var$long_1.default.fromString(object.proposalId);
        else message.proposalId = $6db94c92719d86ea$var$long_1.default.UZERO;
        if (object.content !== undefined && object.content !== null) message.content = $c5FxR.Any.fromJSON(object.content);
        else message.content = undefined;
        if (object.status !== undefined && object.status !== null) message.status = $6db94c92719d86ea$var$proposalStatusFromJSON(object.status);
        else message.status = 0;
        if (object.finalTallyResult !== undefined && object.finalTallyResult !== null) message.finalTallyResult = module.exports.TallyResult.fromJSON(object.finalTallyResult);
        else message.finalTallyResult = undefined;
        if (object.submitTime !== undefined && object.submitTime !== null) message.submitTime = $6db94c92719d86ea$var$fromJsonTimestamp(object.submitTime);
        else message.submitTime = undefined;
        if (object.depositEndTime !== undefined && object.depositEndTime !== null) message.depositEndTime = $6db94c92719d86ea$var$fromJsonTimestamp(object.depositEndTime);
        else message.depositEndTime = undefined;
        if (object.totalDeposit !== undefined && object.totalDeposit !== null) for (const e of object.totalDeposit)message.totalDeposit.push($lPVUQ.Coin.fromJSON(e));
        if (object.votingStartTime !== undefined && object.votingStartTime !== null) message.votingStartTime = $6db94c92719d86ea$var$fromJsonTimestamp(object.votingStartTime);
        else message.votingStartTime = undefined;
        if (object.votingEndTime !== undefined && object.votingEndTime !== null) message.votingEndTime = $6db94c92719d86ea$var$fromJsonTimestamp(object.votingEndTime);
        else message.votingEndTime = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $6db94c92719d86ea$var$long_1.default.UZERO).toString());
        message.content !== undefined && (obj.content = message.content ? $c5FxR.Any.toJSON(message.content) : undefined);
        message.status !== undefined && (obj.status = $6db94c92719d86ea$var$proposalStatusToJSON(message.status));
        message.finalTallyResult !== undefined && (obj.finalTallyResult = message.finalTallyResult ? module.exports.TallyResult.toJSON(message.finalTallyResult) : undefined);
        message.submitTime !== undefined && (obj.submitTime = message.submitTime.toISOString());
        message.depositEndTime !== undefined && (obj.depositEndTime = message.depositEndTime.toISOString());
        if (message.totalDeposit) obj.totalDeposit = message.totalDeposit.map((e)=>e ? $lPVUQ.Coin.toJSON(e) : undefined);
        else obj.totalDeposit = [];
        message.votingStartTime !== undefined && (obj.votingStartTime = message.votingStartTime.toISOString());
        message.votingEndTime !== undefined && (obj.votingEndTime = message.votingEndTime.toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $6db94c92719d86ea$var$baseProposal);
        message.totalDeposit = [];
        if (object.proposalId !== undefined && object.proposalId !== null) message.proposalId = object.proposalId;
        else message.proposalId = $6db94c92719d86ea$var$long_1.default.UZERO;
        if (object.content !== undefined && object.content !== null) message.content = $c5FxR.Any.fromPartial(object.content);
        else message.content = undefined;
        if (object.status !== undefined && object.status !== null) message.status = object.status;
        else message.status = 0;
        if (object.finalTallyResult !== undefined && object.finalTallyResult !== null) message.finalTallyResult = module.exports.TallyResult.fromPartial(object.finalTallyResult);
        else message.finalTallyResult = undefined;
        if (object.submitTime !== undefined && object.submitTime !== null) message.submitTime = object.submitTime;
        else message.submitTime = undefined;
        if (object.depositEndTime !== undefined && object.depositEndTime !== null) message.depositEndTime = object.depositEndTime;
        else message.depositEndTime = undefined;
        if (object.totalDeposit !== undefined && object.totalDeposit !== null) for (const e of object.totalDeposit)message.totalDeposit.push($lPVUQ.Coin.fromPartial(e));
        if (object.votingStartTime !== undefined && object.votingStartTime !== null) message.votingStartTime = object.votingStartTime;
        else message.votingStartTime = undefined;
        if (object.votingEndTime !== undefined && object.votingEndTime !== null) message.votingEndTime = object.votingEndTime;
        else message.votingEndTime = undefined;
        return message;
    }
};
const $6db94c92719d86ea$var$baseTallyResult = {
    yes: "",
    abstain: "",
    no: "",
    noWithVeto: ""
};
module.exports.TallyResult = {
    encode (message, writer = $6db94c92719d86ea$var$minimal_1.default.Writer.create()) {
        if (message.yes !== "") writer.uint32(10).string(message.yes);
        if (message.abstain !== "") writer.uint32(18).string(message.abstain);
        if (message.no !== "") writer.uint32(26).string(message.no);
        if (message.noWithVeto !== "") writer.uint32(34).string(message.noWithVeto);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6db94c92719d86ea$var$minimal_1.default.Reader ? input : new $6db94c92719d86ea$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $6db94c92719d86ea$var$baseTallyResult);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.yes = reader.string();
                    break;
                case 2:
                    message.abstain = reader.string();
                    break;
                case 3:
                    message.no = reader.string();
                    break;
                case 4:
                    message.noWithVeto = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $6db94c92719d86ea$var$baseTallyResult);
        if (object.yes !== undefined && object.yes !== null) message.yes = String(object.yes);
        else message.yes = "";
        if (object.abstain !== undefined && object.abstain !== null) message.abstain = String(object.abstain);
        else message.abstain = "";
        if (object.no !== undefined && object.no !== null) message.no = String(object.no);
        else message.no = "";
        if (object.noWithVeto !== undefined && object.noWithVeto !== null) message.noWithVeto = String(object.noWithVeto);
        else message.noWithVeto = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.yes !== undefined && (obj.yes = message.yes);
        message.abstain !== undefined && (obj.abstain = message.abstain);
        message.no !== undefined && (obj.no = message.no);
        message.noWithVeto !== undefined && (obj.noWithVeto = message.noWithVeto);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $6db94c92719d86ea$var$baseTallyResult);
        if (object.yes !== undefined && object.yes !== null) message.yes = object.yes;
        else message.yes = "";
        if (object.abstain !== undefined && object.abstain !== null) message.abstain = object.abstain;
        else message.abstain = "";
        if (object.no !== undefined && object.no !== null) message.no = object.no;
        else message.no = "";
        if (object.noWithVeto !== undefined && object.noWithVeto !== null) message.noWithVeto = object.noWithVeto;
        else message.noWithVeto = "";
        return message;
    }
};
const $6db94c92719d86ea$var$baseVote = {
    proposalId: $6db94c92719d86ea$var$long_1.default.UZERO,
    voter: "",
    option: 0
};
module.exports.Vote = {
    encode (message, writer = $6db94c92719d86ea$var$minimal_1.default.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        if (message.option !== 0) writer.uint32(24).int32(message.option);
        for (const v of message.options)module.exports.WeightedVoteOption.encode(v, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6db94c92719d86ea$var$minimal_1.default.Reader ? input : new $6db94c92719d86ea$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $6db94c92719d86ea$var$baseVote);
        message.options = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.option = reader.int32();
                    break;
                case 4:
                    message.options.push(module.exports.WeightedVoteOption.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $6db94c92719d86ea$var$baseVote);
        message.options = [];
        if (object.proposalId !== undefined && object.proposalId !== null) message.proposalId = $6db94c92719d86ea$var$long_1.default.fromString(object.proposalId);
        else message.proposalId = $6db94c92719d86ea$var$long_1.default.UZERO;
        if (object.voter !== undefined && object.voter !== null) message.voter = String(object.voter);
        else message.voter = "";
        if (object.option !== undefined && object.option !== null) message.option = $6db94c92719d86ea$var$voteOptionFromJSON(object.option);
        else message.option = 0;
        if (object.options !== undefined && object.options !== null) for (const e of object.options)message.options.push(module.exports.WeightedVoteOption.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $6db94c92719d86ea$var$long_1.default.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        message.option !== undefined && (obj.option = $6db94c92719d86ea$var$voteOptionToJSON(message.option));
        if (message.options) obj.options = message.options.map((e)=>e ? module.exports.WeightedVoteOption.toJSON(e) : undefined);
        else obj.options = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $6db94c92719d86ea$var$baseVote);
        message.options = [];
        if (object.proposalId !== undefined && object.proposalId !== null) message.proposalId = object.proposalId;
        else message.proposalId = $6db94c92719d86ea$var$long_1.default.UZERO;
        if (object.voter !== undefined && object.voter !== null) message.voter = object.voter;
        else message.voter = "";
        if (object.option !== undefined && object.option !== null) message.option = object.option;
        else message.option = 0;
        if (object.options !== undefined && object.options !== null) for (const e of object.options)message.options.push(module.exports.WeightedVoteOption.fromPartial(e));
        return message;
    }
};
const $6db94c92719d86ea$var$baseDepositParams = {};
module.exports.DepositParams = {
    encode (message, writer = $6db94c92719d86ea$var$minimal_1.default.Writer.create()) {
        for (const v of message.minDeposit)$lPVUQ.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.maxDepositPeriod !== undefined) $dmomH.Duration.encode(message.maxDepositPeriod, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6db94c92719d86ea$var$minimal_1.default.Reader ? input : new $6db94c92719d86ea$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $6db94c92719d86ea$var$baseDepositParams);
        message.minDeposit = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.minDeposit.push($lPVUQ.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.maxDepositPeriod = $dmomH.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $6db94c92719d86ea$var$baseDepositParams);
        message.minDeposit = [];
        if (object.minDeposit !== undefined && object.minDeposit !== null) for (const e of object.minDeposit)message.minDeposit.push($lPVUQ.Coin.fromJSON(e));
        if (object.maxDepositPeriod !== undefined && object.maxDepositPeriod !== null) message.maxDepositPeriod = $dmomH.Duration.fromJSON(object.maxDepositPeriod);
        else message.maxDepositPeriod = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.minDeposit) obj.minDeposit = message.minDeposit.map((e)=>e ? $lPVUQ.Coin.toJSON(e) : undefined);
        else obj.minDeposit = [];
        message.maxDepositPeriod !== undefined && (obj.maxDepositPeriod = message.maxDepositPeriod ? $dmomH.Duration.toJSON(message.maxDepositPeriod) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $6db94c92719d86ea$var$baseDepositParams);
        message.minDeposit = [];
        if (object.minDeposit !== undefined && object.minDeposit !== null) for (const e of object.minDeposit)message.minDeposit.push($lPVUQ.Coin.fromPartial(e));
        if (object.maxDepositPeriod !== undefined && object.maxDepositPeriod !== null) message.maxDepositPeriod = $dmomH.Duration.fromPartial(object.maxDepositPeriod);
        else message.maxDepositPeriod = undefined;
        return message;
    }
};
const $6db94c92719d86ea$var$baseVotingParams = {};
module.exports.VotingParams = {
    encode (message, writer = $6db94c92719d86ea$var$minimal_1.default.Writer.create()) {
        if (message.votingPeriod !== undefined) $dmomH.Duration.encode(message.votingPeriod, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6db94c92719d86ea$var$minimal_1.default.Reader ? input : new $6db94c92719d86ea$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $6db94c92719d86ea$var$baseVotingParams);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.votingPeriod = $dmomH.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $6db94c92719d86ea$var$baseVotingParams);
        if (object.votingPeriod !== undefined && object.votingPeriod !== null) message.votingPeriod = $dmomH.Duration.fromJSON(object.votingPeriod);
        else message.votingPeriod = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.votingPeriod !== undefined && (obj.votingPeriod = message.votingPeriod ? $dmomH.Duration.toJSON(message.votingPeriod) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $6db94c92719d86ea$var$baseVotingParams);
        if (object.votingPeriod !== undefined && object.votingPeriod !== null) message.votingPeriod = $dmomH.Duration.fromPartial(object.votingPeriod);
        else message.votingPeriod = undefined;
        return message;
    }
};
const $6db94c92719d86ea$var$baseTallyParams = {};
module.exports.TallyParams = {
    encode (message, writer = $6db94c92719d86ea$var$minimal_1.default.Writer.create()) {
        if (message.quorum.length !== 0) writer.uint32(10).bytes(message.quorum);
        if (message.threshold.length !== 0) writer.uint32(18).bytes(message.threshold);
        if (message.vetoThreshold.length !== 0) writer.uint32(26).bytes(message.vetoThreshold);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6db94c92719d86ea$var$minimal_1.default.Reader ? input : new $6db94c92719d86ea$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $6db94c92719d86ea$var$baseTallyParams);
        message.quorum = new Uint8Array();
        message.threshold = new Uint8Array();
        message.vetoThreshold = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.quorum = reader.bytes();
                    break;
                case 2:
                    message.threshold = reader.bytes();
                    break;
                case 3:
                    message.vetoThreshold = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $6db94c92719d86ea$var$baseTallyParams);
        message.quorum = new Uint8Array();
        message.threshold = new Uint8Array();
        message.vetoThreshold = new Uint8Array();
        if (object.quorum !== undefined && object.quorum !== null) message.quorum = $6db94c92719d86ea$var$bytesFromBase64(object.quorum);
        if (object.threshold !== undefined && object.threshold !== null) message.threshold = $6db94c92719d86ea$var$bytesFromBase64(object.threshold);
        if (object.vetoThreshold !== undefined && object.vetoThreshold !== null) message.vetoThreshold = $6db94c92719d86ea$var$bytesFromBase64(object.vetoThreshold);
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.quorum !== undefined && (obj.quorum = $6db94c92719d86ea$var$base64FromBytes(message.quorum !== undefined ? message.quorum : new Uint8Array()));
        message.threshold !== undefined && (obj.threshold = $6db94c92719d86ea$var$base64FromBytes(message.threshold !== undefined ? message.threshold : new Uint8Array()));
        message.vetoThreshold !== undefined && (obj.vetoThreshold = $6db94c92719d86ea$var$base64FromBytes(message.vetoThreshold !== undefined ? message.vetoThreshold : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $6db94c92719d86ea$var$baseTallyParams);
        if (object.quorum !== undefined && object.quorum !== null) message.quorum = object.quorum;
        else message.quorum = new Uint8Array();
        if (object.threshold !== undefined && object.threshold !== null) message.threshold = object.threshold;
        else message.threshold = new Uint8Array();
        if (object.vetoThreshold !== undefined && object.vetoThreshold !== null) message.vetoThreshold = object.vetoThreshold;
        else message.vetoThreshold = new Uint8Array();
        return message;
    }
};
var $6db94c92719d86ea$var$globalThis = (()=>{
    if (typeof $6db94c92719d86ea$var$globalThis !== "undefined") return $6db94c92719d86ea$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $6db94c92719d86ea$var$atob = $6db94c92719d86ea$var$globalThis.atob || ((b64)=>$6db94c92719d86ea$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $6db94c92719d86ea$var$bytesFromBase64(b64) {
    const bin = $6db94c92719d86ea$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $6db94c92719d86ea$var$btoa = $6db94c92719d86ea$var$globalThis.btoa || ((bin)=>$6db94c92719d86ea$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $6db94c92719d86ea$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $6db94c92719d86ea$var$btoa(bin.join(""));
}
function $6db94c92719d86ea$var$toTimestamp(date) {
    const seconds = $6db94c92719d86ea$var$numberToLong(date.getTime() / 1000);
    const nanos = date.getTime() % 1000 * 1000000;
    return {
        seconds: seconds,
        nanos: nanos
    };
}
function $6db94c92719d86ea$var$fromTimestamp(t) {
    let millis = t.seconds.toNumber() * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function $6db94c92719d86ea$var$fromJsonTimestamp(o) {
    if (o instanceof Date) return o;
    else if (typeof o === "string") return new Date(o);
    else return $6db94c92719d86ea$var$fromTimestamp($5G2s6.Timestamp.fromJSON(o));
}
function $6db94c92719d86ea$var$numberToLong(number) {
    return $6db94c92719d86ea$var$long_1.default.fromNumber(number);
}
if ($6db94c92719d86ea$var$minimal_1.default.util.Long !== $6db94c92719d86ea$var$long_1.default) {
    $6db94c92719d86ea$var$minimal_1.default.util.Long = $6db94c92719d86ea$var$long_1.default;
    $6db94c92719d86ea$var$minimal_1.default.configure();
}

});



parcelRegister("ijmkT", function(module, exports) {
"use strict";
var $d54b53cc1313fc03$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgSubmitProposal = void 0;

var $kYslP = parcelRequire("kYslP");

var $eK1ja = parcelRequire("eK1ja");

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $br4pC = parcelRequire("br4pC");
/**
 * Submit a proposal alongside an initial deposit.
 */ var $d54b53cc1313fc03$var$MsgSubmitProposal = /** @class */ function(_super) {
    $d54b53cc1313fc03$var$__extends(MsgSubmitProposal, _super);
    /**
     * @param content proposal content to submit
     * @param initial_deposit deposit provided
     * @param proposer proposer's account address
     */ function MsgSubmitProposal(content, initial_deposit, proposer) {
        var _this = _super.call(this) || this;
        _this.content = content;
        _this.proposer = proposer;
        _this.initial_deposit = new $kYslP.Coins(initial_deposit);
        return _this;
    }
    MsgSubmitProposal.fromAmino = function(data, isClassic) {
        var _a = data.value, content = _a.content, initial_deposit = _a.initial_deposit, proposer = _a.proposer;
        return new MsgSubmitProposal($eK1ja.Proposal.Content.fromAmino(content, isClassic), $kYslP.Coins.fromAmino(initial_deposit), proposer);
    };
    MsgSubmitProposal.prototype.toAmino = function(isClassic) {
        var _a = this, content = _a.content, initial_deposit = _a.initial_deposit, proposer = _a.proposer;
        return {
            type: isClassic ? "gov/MsgSubmitProposal" : "cosmos-sdk/MsgSubmitProposal",
            value: {
                content: content.toAmino(isClassic),
                initial_deposit: initial_deposit.toAmino(),
                proposer: proposer
            }
        };
    };
    MsgSubmitProposal.fromData = function(data, isClassic) {
        var content = data.content, initial_deposit = data.initial_deposit, proposer = data.proposer;
        return new MsgSubmitProposal($eK1ja.Proposal.Content.fromData(content, isClassic), $kYslP.Coins.fromData(initial_deposit), proposer);
    };
    MsgSubmitProposal.prototype.toData = function(isClassic) {
        var _a = this, content = _a.content, initial_deposit = _a.initial_deposit, proposer = _a.proposer;
        return {
            "@type": "/cosmos.gov.v1beta1.MsgSubmitProposal",
            content: content.toData(isClassic),
            initial_deposit: initial_deposit.toData(),
            proposer: proposer
        };
    };
    MsgSubmitProposal.fromProto = function(proto, isClassic) {
        return new MsgSubmitProposal($eK1ja.Proposal.Content.fromProto(proto.content, isClassic), $kYslP.Coins.fromProto(proto.initialDeposit), proto.proposer);
    };
    MsgSubmitProposal.prototype.toProto = function(isClassic) {
        var _a = this, content = _a.content, initial_deposit = _a.initial_deposit, proposer = _a.proposer;
        return $br4pC.MsgSubmitProposal.fromPartial({
            content: content.packAny(isClassic),
            initialDeposit: initial_deposit.toProto(),
            proposer: proposer
        });
    };
    MsgSubmitProposal.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmos.gov.v1beta1.MsgSubmitProposal",
            value: $br4pC.MsgSubmitProposal.encode(this.toProto(isClassic)).finish()
        });
    };
    MsgSubmitProposal.unpackAny = function(msgAny, isClassic) {
        return MsgSubmitProposal.fromProto($br4pC.MsgSubmitProposal.decode(msgAny.value), isClassic);
    };
    return MsgSubmitProposal;
}($26Eqx.JSONSerializable);
module.exports.MsgSubmitProposal = $d54b53cc1313fc03$var$MsgSubmitProposal;

});
parcelRegister("eK1ja", function(module, exports) {
"use strict";
var $abb6605b3a5d35cf$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $abb6605b3a5d35cf$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $abb6605b3a5d35cf$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $abb6605b3a5d35cf$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $abb6605b3a5d35cf$var$__createBinding(result, mod, k);
    }
    $abb6605b3a5d35cf$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Proposal = void 0;

var $kYslP = parcelRequire("kYslP");

var $5iXRZ = parcelRequire("5iXRZ");

var $26Eqx = parcelRequire("26Eqx");

var $jdAT4 = parcelRequire("jdAT4");

var $1ZQER = parcelRequire("1ZQER");

var $be54r = parcelRequire("be54r");

var $4BeEE = parcelRequire("4BeEE");

var $eTRTS = parcelRequire("eTRTS");

var $k0M3i = parcelRequire("k0M3i");

var $8pUAL = parcelRequire("8pUAL");

var $9q3yq = parcelRequire("9q3yq");

var $abb6605b3a5d35cf$var$Long = $abb6605b3a5d35cf$var$__importStar((parcelRequire("9A55m")));
/**
 * Stores information pertaining to a submitted proposal, such as its status and time of
 * the voting period
 */ var $abb6605b3a5d35cf$var$Proposal = /** @class */ function(_super) {
    $abb6605b3a5d35cf$var$__extends(Proposal, _super);
    /**
     *
     * @param id proposal's ID
     * @param content content of the proposal
     * @param status proposal's status
     * @param final_tally_result tally result
     * @param submit_time time proposal was submitted and deposit period started
     * @param deposit_end_time time deposit period will end
     * @param total_deposit amount of coins deposited by all users
     * @param voting_start_time time voting period will start
     * @param voting_end_time time voting period will end
     */ function Proposal(id, content, status, final_tally_result, submit_time, deposit_end_time, total_deposit, voting_start_time, voting_end_time) {
        var _this = _super.call(this) || this;
        _this.id = id;
        _this.content = content;
        _this.status = status;
        _this.final_tally_result = final_tally_result;
        _this.submit_time = submit_time;
        _this.deposit_end_time = deposit_end_time;
        _this.total_deposit = total_deposit;
        _this.voting_start_time = voting_start_time;
        _this.voting_end_time = voting_end_time;
        return _this;
    }
    Proposal.fromAmino = function(data, isClassic) {
        var id = data.id, content = data.content, status = data.status, final_tally_result = data.final_tally_result, submit_time = data.submit_time, deposit_end_time = data.deposit_end_time, total_deposit = data.total_deposit, voting_start_time = data.voting_start_time, voting_end_time = data.voting_end_time;
        return new Proposal(Number.parseInt(id), Proposal.Content.fromAmino(content, isClassic), status, {
            yes: new $5iXRZ.Int(final_tally_result.yes || 0),
            no: new $5iXRZ.Int(final_tally_result.no || 0),
            abstain: new $5iXRZ.Int(final_tally_result.abstain || 0),
            no_with_veto: new $5iXRZ.Int(final_tally_result.no_with_veto || 0)
        }, new Date(submit_time), new Date(deposit_end_time), $kYslP.Coins.fromAmino(total_deposit), new Date(voting_start_time), new Date(voting_end_time));
    };
    Proposal.prototype.toAmino = function(isClassic) {
        var _a = this, status = _a.status, final_tally_result = _a.final_tally_result;
        return {
            id: this.id.toFixed(),
            content: this.content.toAmino(isClassic),
            status: status,
            final_tally_result: {
                yes: final_tally_result.yes.toFixed(),
                no: final_tally_result.no.toFixed(),
                abstain: final_tally_result.abstain.toFixed(),
                no_with_veto: final_tally_result.no_with_veto.toFixed()
            },
            submit_time: this.submit_time.toISOString(),
            deposit_end_time: this.deposit_end_time.toISOString(),
            total_deposit: this.total_deposit.toAmino(),
            voting_start_time: this.voting_start_time.toISOString(),
            voting_end_time: this.voting_end_time.toISOString()
        };
    };
    Proposal.fromData = function(data, isClassic) {
        var proposal_id = data.proposal_id, content = data.content, status = data.status, final_tally_result = data.final_tally_result, submit_time = data.submit_time, deposit_end_time = data.deposit_end_time, total_deposit = data.total_deposit, voting_start_time = data.voting_start_time, voting_end_time = data.voting_end_time;
        return new Proposal(Number.parseInt(proposal_id), Proposal.Content.fromData(content, isClassic), (0, $9q3yq.proposalStatusFromJSON)(status), {
            yes: new $5iXRZ.Int((final_tally_result === null || final_tally_result === void 0 ? void 0 : final_tally_result.yes) || 0),
            no: new $5iXRZ.Int((final_tally_result === null || final_tally_result === void 0 ? void 0 : final_tally_result.no) || 0),
            abstain: new $5iXRZ.Int((final_tally_result === null || final_tally_result === void 0 ? void 0 : final_tally_result.abstain) || 0),
            no_with_veto: new $5iXRZ.Int((final_tally_result === null || final_tally_result === void 0 ? void 0 : final_tally_result.no_with_veto) || 0)
        }, new Date(submit_time), new Date(deposit_end_time), $kYslP.Coins.fromData(total_deposit), new Date(voting_start_time), new Date(voting_end_time));
    };
    Proposal.prototype.toData = function(isClassic) {
        var _a = this, status = _a.status, final_tally_result = _a.final_tally_result;
        return {
            proposal_id: this.id.toFixed(),
            content: this.content.toData(isClassic),
            status: (0, $9q3yq.proposalStatusToJSON)(status),
            final_tally_result: {
                yes: final_tally_result.yes.toString(),
                no: final_tally_result.no.toString(),
                abstain: final_tally_result.abstain.toString(),
                no_with_veto: final_tally_result.no_with_veto.toString()
            },
            submit_time: this.submit_time.toISOString(),
            deposit_end_time: this.deposit_end_time.toISOString(),
            total_deposit: this.total_deposit.toData(),
            voting_start_time: this.voting_start_time.toISOString(),
            voting_end_time: this.voting_end_time.toISOString()
        };
    };
    Proposal.fromProto = function(data, isClassic) {
        var id = data.proposalId;
        var content = data.content;
        var status = data.status;
        var final_tally_result = data.finalTallyResult;
        var submit_time = data.submitTime;
        var deposit_end_time = data.depositEndTime;
        var total_deposit = data.totalDeposit;
        var voting_start_time = data.votingStartTime;
        var voting_end_time = data.votingEndTime;
        return new Proposal(id.toNumber(), Proposal.Content.fromProto(content, isClassic), status, {
            yes: new $5iXRZ.Int((final_tally_result === null || final_tally_result === void 0 ? void 0 : final_tally_result.yes) || 0),
            no: new $5iXRZ.Int((final_tally_result === null || final_tally_result === void 0 ? void 0 : final_tally_result.no) || 0),
            abstain: new $5iXRZ.Int((final_tally_result === null || final_tally_result === void 0 ? void 0 : final_tally_result.abstain) || 0),
            no_with_veto: new $5iXRZ.Int((final_tally_result === null || final_tally_result === void 0 ? void 0 : final_tally_result.noWithVeto) || 0)
        }, submit_time, deposit_end_time, $kYslP.Coins.fromProto(total_deposit), voting_start_time, voting_end_time);
    };
    Proposal.prototype.toProto = function(isClassic) {
        var _a = this, status = _a.status, final_tally_result = _a.final_tally_result;
        var ftr;
        if (final_tally_result) ftr = $9q3yq.TallyResult.fromPartial({
            yes: final_tally_result.yes.toString(),
            no: final_tally_result.no.toString(),
            abstain: final_tally_result.abstain.toString(),
            noWithVeto: final_tally_result.no_with_veto.toString()
        });
        return $9q3yq.Proposal.fromPartial({
            proposalId: $abb6605b3a5d35cf$var$Long.fromNumber(this.id),
            content: this.content.packAny(isClassic),
            status: status,
            finalTallyResult: ftr,
            submitTime: this.submit_time,
            depositEndTime: this.deposit_end_time,
            totalDeposit: this.total_deposit.toProto(),
            votingEndTime: this.voting_end_time,
            votingStartTime: this.voting_start_time
        });
    };
    return Proposal;
}($26Eqx.JSONSerializable);
module.exports.Proposal = $abb6605b3a5d35cf$var$Proposal;
(function(Proposal) {
    Proposal.Status = $9q3yq.ProposalStatus;
    var Content;
    (function(Content) {
        function fromAmino(amino, isClassic) {
            switch(amino.type){
                case "gov/TextProposal":
                case "cosmos-sdk/TextProposal":
                    return $4BeEE.TextProposal.fromAmino(amino, isClassic);
                case "distribution/CommunityPoolSpendProposal":
                case "cosmos-sdk/CommunityPoolSpendProposal":
                    return $jdAT4.CommunityPoolSpendProposal.fromAmino(amino, isClassic);
                case "params/ParameterChangeProposal":
                case "cosmos-sdk/ParameterChangeProposal":
                    return $1ZQER.ParameterChangeProposal.fromAmino(amino, isClassic);
                case "upgrade/SoftwareUpgradeProposal":
                case "cosmos-sdk/SoftwareUpgradeProposal":
                    return $eTRTS.SoftwareUpgradeProposal.fromAmino(amino, isClassic);
                case "upgrade/CancelSoftwareUpgradeProposal":
                case "cosmos-sdk/CancelSoftwareUpgradeProposal":
                    return $eTRTS.CancelSoftwareUpgradeProposal.fromAmino(amino, isClassic);
                case "ibc/ClientUpdateProposal":
                    return $be54r.ClientUpdateProposal.fromAmino(amino, isClassic);
                case "wasm/ClearAdminProposal":
                    return $k0M3i.ClearAdminProposal.fromAmino(amino, isClassic);
                case "wasm/ExecuteContractProposal":
                    return $k0M3i.ExecuteContractProposal.fromAmino(amino, isClassic);
                case "wasm/InstantiateContractProposal":
                    return $k0M3i.InstantiateContractProposal.fromAmino(amino, isClassic);
                case "wasm/MigrateContractProposal":
                    return $k0M3i.MigrateContractProposal.fromAmino(amino, isClassic);
                case "wasm/PinCodesProposal":
                    return $k0M3i.PinCodesProposal.fromAmino(amino, isClassic);
                case "wasm/StoreCodeProposal":
                    return $k0M3i.StoreCodeProposal.fromAmino(amino, isClassic);
                case "wasm/SudoContractProposal":
                    return $k0M3i.SudoContractProposal.fromAmino(amino, isClassic);
                case "wasm/UnpinCodesProposal":
                    return $k0M3i.UnpinCodesProposal.fromAmino(amino, isClassic);
                case "wasm/UpdateAdminProposal":
                    return $k0M3i.UpdateAdminProposal.fromAmino(amino, isClassic);
                case "wasm/UpdateInstantiateConfigProposal":
                    return $k0M3i.UpdateInstantiateConfigProposal.fromAmino(amino, isClassic);
                case "treasury/AddBurnTaxExemptionAddressProposal":
                    return $8pUAL.AddBurnTaxExemptionAddressProposal.fromAmino(amino, isClassic);
                case "treasury/RemoveBurnTaxExemptionAddressProposal":
                    return $8pUAL.RemoveBurnTaxExemptionAddressProposal.fromAmino(amino, isClassic);
            }
        }
        Content.fromAmino = fromAmino;
        function fromData(data, isClassic) {
            switch(data["@type"]){
                case "/cosmos.gov.v1beta1.TextProposal":
                    return $4BeEE.TextProposal.fromData(data, isClassic);
                case "/cosmos.distribution.v1beta1.CommunityPoolSpendProposal":
                    return $jdAT4.CommunityPoolSpendProposal.fromData(data, isClassic);
                case "/cosmos.params.v1beta1.ParameterChangeProposal":
                    return $1ZQER.ParameterChangeProposal.fromData(data, isClassic);
                case "/cosmos.upgrade.v1beta1.SoftwareUpgradeProposal":
                    return $eTRTS.SoftwareUpgradeProposal.fromData(data, isClassic);
                case "/cosmos.upgrade.v1beta1.CancelSoftwareUpgradeProposal":
                    return $eTRTS.CancelSoftwareUpgradeProposal.fromData(data, isClassic);
                case "/ibc.core.client.v1.ClientUpdateProposal":
                    return $be54r.ClientUpdateProposal.fromData(data, isClassic);
                case "/cosmwasm.wasm.v1.ClearAdminProposal":
                    return $k0M3i.ClearAdminProposal.fromData(data, isClassic);
                case "/cosmwasm.wasm.v1.ExecuteContractProposal":
                    return $k0M3i.ExecuteContractProposal.fromData(data, isClassic);
                case "/cosmwasm.wasm.v1.InstantiateContractProposal":
                    return $k0M3i.InstantiateContractProposal.fromData(data, isClassic);
                case "/cosmwasm.wasm.v1.MigrateContractProposal":
                    return $k0M3i.MigrateContractProposal.fromData(data, isClassic);
                case "/cosmwasm.wasm.v1.PinCodesProposal":
                    return $k0M3i.PinCodesProposal.fromData(data, isClassic);
                case "/cosmwasm.wasm.v1.StoreCodeProposal":
                    return $k0M3i.StoreCodeProposal.fromData(data, isClassic);
                case "/cosmwasm.wasm.v1.SudoContractProposal":
                    return $k0M3i.SudoContractProposal.fromData(data, isClassic);
                case "/cosmwasm.wasm.v1.UnpinCodesProposal":
                    return $k0M3i.UnpinCodesProposal.fromData(data, isClassic);
                case "/cosmwasm.wasm.v1.UpdateAdminProposal":
                    return $k0M3i.UpdateAdminProposal.fromData(data, isClassic);
                case "/cosmwasm.wasm.v1.UpdateInstantiateConfigProposal":
                    return $k0M3i.UpdateInstantiateConfigProposal.fromData(data, isClassic);
                case "/terra.treasury.v1beta1.AddBurnTaxExemptionAddressProposal":
                    return $8pUAL.AddBurnTaxExemptionAddressProposal.fromData(data, isClassic);
                case "/terra.treasury.v1beta1.RemoveBurnTaxExemptionAddressProposal":
                    return $8pUAL.RemoveBurnTaxExemptionAddressProposal.fromData(data, isClassic);
            }
        }
        Content.fromData = fromData;
        function fromProto(anyProto, isClassic) {
            var typeUrl = anyProto.typeUrl;
            switch(typeUrl){
                case "/cosmos.gov.v1beta1.TextProposal":
                    return $4BeEE.TextProposal.unpackAny(anyProto, isClassic);
                case "/cosmos.distribution.v1beta1.CommunityPoolSpendProposal":
                    return $jdAT4.CommunityPoolSpendProposal.unpackAny(anyProto, isClassic);
                case "/cosmos.params.v1beta1.ParameterChangeProposal":
                    return $1ZQER.ParameterChangeProposal.unpackAny(anyProto, isClassic);
                case "/cosmos.upgrade.v1beta1.SoftwareUpgradeProposal":
                    return $eTRTS.SoftwareUpgradeProposal.unpackAny(anyProto, isClassic);
                case "/cosmos.upgrade.v1beta1.CancelSoftwareUpgradeProposal":
                    return $eTRTS.CancelSoftwareUpgradeProposal.unpackAny(anyProto, isClassic);
                case "/ibc.core.client.v1.ClientUpdateProposal":
                    return $be54r.ClientUpdateProposal.unpackAny(anyProto, isClassic);
                case "/cosmwasm.wasm.v1.ClearAdminProposal":
                    return $k0M3i.ClearAdminProposal.unpackAny(anyProto, isClassic);
                case "/cosmwasm.wasm.v1.ExecuteContractProposal":
                    return $k0M3i.ExecuteContractProposal.unpackAny(anyProto, isClassic);
                case "/cosmwasm.wasm.v1.InstantiateContractProposal":
                    return $k0M3i.InstantiateContractProposal.unpackAny(anyProto, isClassic);
                case "/cosmwasm.wasm.v1.MigrateContractProposal":
                    return $k0M3i.MigrateContractProposal.unpackAny(anyProto, isClassic);
                case "/cosmwasm.wasm.v1.PinCodesProposal":
                    return $k0M3i.PinCodesProposal.unpackAny(anyProto, isClassic);
                case "/cosmwasm.wasm.v1.StoreCodeProposal":
                    return $k0M3i.StoreCodeProposal.unpackAny(anyProto, isClassic);
                case "/cosmwasm.wasm.v1.SudoContractProposal":
                    return $k0M3i.SudoContractProposal.unpackAny(anyProto, isClassic);
                case "/cosmwasm.wasm.v1.UnpinCodesProposal":
                    return $k0M3i.UnpinCodesProposal.unpackAny(anyProto, isClassic);
                case "/cosmwasm.wasm.v1.UpdateAdminProposal":
                    return $k0M3i.UpdateAdminProposal.unpackAny(anyProto, isClassic);
                case "/cosmwasm.wasm.v1.UpdateInstantiateConfigProposal":
                    return $k0M3i.UpdateInstantiateConfigProposal.unpackAny(anyProto, isClassic);
                case "/terra.treasury.v1beta1.AddBurnTaxExemptionAddressProposal":
                    return $8pUAL.AddBurnTaxExemptionAddressProposal.unpackAny(anyProto, isClassic);
                case "/terra.treasury.v1beta1.RemoveBurnTaxExemptionAddressProposal":
                    return $8pUAL.RemoveBurnTaxExemptionAddressProposal.unpackAny(anyProto, isClassic);
            }
            throw "Proposal content ".concat(typeUrl, " not recognized");
        }
        Content.fromProto = fromProto;
    })(Content = Proposal.Content || (Proposal.Content = {}));
})($abb6605b3a5d35cf$var$Proposal = module.exports.Proposal || (module.exports.Proposal = {}));
module.exports.Proposal = $abb6605b3a5d35cf$var$Proposal;

});
parcelRegister("jdAT4", function(module, exports) {
"use strict";
var $dfdbd83fbdd46590$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $dfdbd83fbdd46590$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $dfdbd83fbdd46590$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$dfdbd83fbdd46590$var$__exportStar((parcelRequire("40rJ1")), module.exports);

});
parcelRegister("40rJ1", function(module, exports) {
"use strict";
var $2eacab2540872b52$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CommunityPoolSpendProposal = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $kYslP = parcelRequire("kYslP");

var $c5FxR = parcelRequire("c5FxR");

var $apFzi = parcelRequire("apFzi");
/**
 * Proposal that disburses funds from the Distribution module's community pool to the
 * specified recipient if passed.
 */ var $2eacab2540872b52$var$CommunityPoolSpendProposal = /** @class */ function(_super) {
    $2eacab2540872b52$var$__extends(CommunityPoolSpendProposal, _super);
    /**
     * @param title proposal's title
     * @param description proposal's description
     * @param recipient recipient address
     * @param amount amount to give recipient
     */ function CommunityPoolSpendProposal(title, description, recipient, amount) {
        var _this = _super.call(this) || this;
        _this.title = title;
        _this.description = description;
        _this.recipient = recipient;
        _this.amount = new $kYslP.Coins(amount);
        return _this;
    }
    CommunityPoolSpendProposal.fromAmino = function(data, _) {
        _;
        var _a = data.value, title = _a.title, description = _a.description, recipient = _a.recipient, amount = _a.amount;
        return new CommunityPoolSpendProposal(title, description, recipient, $kYslP.Coins.fromAmino(amount));
    };
    CommunityPoolSpendProposal.prototype.toAmino = function(isClassic) {
        var _a = this, title = _a.title, description = _a.description, recipient = _a.recipient, amount = _a.amount;
        return {
            type: isClassic ? "distribution/CommunityPoolSpendProposal" : "cosmos-sdk/CommunityPoolSpendProposal",
            value: {
                title: title,
                description: description,
                recipient: recipient,
                amount: amount.toAmino()
            }
        };
    };
    CommunityPoolSpendProposal.fromData = function(data, _) {
        _;
        var title = data.title, description = data.description, recipient = data.recipient, amount = data.amount;
        return new CommunityPoolSpendProposal(title, description, recipient, $kYslP.Coins.fromData(amount));
    };
    CommunityPoolSpendProposal.prototype.toData = function(_) {
        _;
        var _a = this, title = _a.title, description = _a.description, recipient = _a.recipient, amount = _a.amount;
        return {
            "@type": "/cosmos.distribution.v1beta1.CommunityPoolSpendProposal",
            title: title,
            description: description,
            recipient: recipient,
            amount: amount.toData()
        };
    };
    CommunityPoolSpendProposal.fromProto = function(proto, _) {
        _;
        return new CommunityPoolSpendProposal(proto.title, proto.description, proto.recipient, $kYslP.Coins.fromProto(proto.amount));
    };
    CommunityPoolSpendProposal.prototype.toProto = function(_) {
        _;
        var _a = this, title = _a.title, description = _a.description, recipient = _a.recipient, amount = _a.amount;
        return $apFzi.CommunityPoolSpendProposal.fromPartial({
            amount: amount.toProto(),
            description: description,
            recipient: recipient,
            title: title
        });
    };
    CommunityPoolSpendProposal.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmos.distribution.v1beta1.CommunityPoolSpendProposal",
            value: $apFzi.CommunityPoolSpendProposal.encode(this.toProto(isClassic)).finish()
        });
    };
    CommunityPoolSpendProposal.unpackAny = function(msgAny, isClassic) {
        return CommunityPoolSpendProposal.fromProto($apFzi.CommunityPoolSpendProposal.decode(msgAny.value), isClassic);
    };
    return CommunityPoolSpendProposal;
}($26Eqx.JSONSerializable);
module.exports.CommunityPoolSpendProposal = $2eacab2540872b52$var$CommunityPoolSpendProposal;

});
parcelRegister("apFzi", function(module, exports) {
"use strict";
var $794c7bc64553bf49$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CommunityPoolSpendProposalWithDeposit = module.exports.DelegationDelegatorReward = module.exports.DelegatorStartingInfo = module.exports.CommunityPoolSpendProposal = module.exports.FeePool = module.exports.ValidatorSlashEvents = module.exports.ValidatorSlashEvent = module.exports.ValidatorOutstandingRewards = module.exports.ValidatorAccumulatedCommission = module.exports.ValidatorCurrentRewards = module.exports.ValidatorHistoricalRewards = module.exports.Params = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $794c7bc64553bf49$var$long_1 = $794c7bc64553bf49$var$__importDefault((parcelRequire("9A55m")));

const $794c7bc64553bf49$var$minimal_1 = $794c7bc64553bf49$var$__importDefault((parcelRequire("i2pIU")));

var $lPVUQ = parcelRequire("lPVUQ");
module.exports.protobufPackage = "cosmos.distribution.v1beta1";
const $794c7bc64553bf49$var$baseParams = {
    communityTax: "",
    baseProposerReward: "",
    bonusProposerReward: "",
    withdrawAddrEnabled: false
};
module.exports.Params = {
    encode (message, writer = $794c7bc64553bf49$var$minimal_1.default.Writer.create()) {
        if (message.communityTax !== "") writer.uint32(10).string(message.communityTax);
        if (message.baseProposerReward !== "") writer.uint32(18).string(message.baseProposerReward);
        if (message.bonusProposerReward !== "") writer.uint32(26).string(message.bonusProposerReward);
        if (message.withdrawAddrEnabled === true) writer.uint32(32).bool(message.withdrawAddrEnabled);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $794c7bc64553bf49$var$minimal_1.default.Reader ? input : new $794c7bc64553bf49$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $794c7bc64553bf49$var$baseParams);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.communityTax = reader.string();
                    break;
                case 2:
                    message.baseProposerReward = reader.string();
                    break;
                case 3:
                    message.bonusProposerReward = reader.string();
                    break;
                case 4:
                    message.withdrawAddrEnabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $794c7bc64553bf49$var$baseParams);
        if (object.communityTax !== undefined && object.communityTax !== null) message.communityTax = String(object.communityTax);
        else message.communityTax = "";
        if (object.baseProposerReward !== undefined && object.baseProposerReward !== null) message.baseProposerReward = String(object.baseProposerReward);
        else message.baseProposerReward = "";
        if (object.bonusProposerReward !== undefined && object.bonusProposerReward !== null) message.bonusProposerReward = String(object.bonusProposerReward);
        else message.bonusProposerReward = "";
        if (object.withdrawAddrEnabled !== undefined && object.withdrawAddrEnabled !== null) message.withdrawAddrEnabled = Boolean(object.withdrawAddrEnabled);
        else message.withdrawAddrEnabled = false;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.communityTax !== undefined && (obj.communityTax = message.communityTax);
        message.baseProposerReward !== undefined && (obj.baseProposerReward = message.baseProposerReward);
        message.bonusProposerReward !== undefined && (obj.bonusProposerReward = message.bonusProposerReward);
        message.withdrawAddrEnabled !== undefined && (obj.withdrawAddrEnabled = message.withdrawAddrEnabled);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $794c7bc64553bf49$var$baseParams);
        if (object.communityTax !== undefined && object.communityTax !== null) message.communityTax = object.communityTax;
        else message.communityTax = "";
        if (object.baseProposerReward !== undefined && object.baseProposerReward !== null) message.baseProposerReward = object.baseProposerReward;
        else message.baseProposerReward = "";
        if (object.bonusProposerReward !== undefined && object.bonusProposerReward !== null) message.bonusProposerReward = object.bonusProposerReward;
        else message.bonusProposerReward = "";
        if (object.withdrawAddrEnabled !== undefined && object.withdrawAddrEnabled !== null) message.withdrawAddrEnabled = object.withdrawAddrEnabled;
        else message.withdrawAddrEnabled = false;
        return message;
    }
};
const $794c7bc64553bf49$var$baseValidatorHistoricalRewards = {
    referenceCount: 0
};
module.exports.ValidatorHistoricalRewards = {
    encode (message, writer = $794c7bc64553bf49$var$minimal_1.default.Writer.create()) {
        for (const v of message.cumulativeRewardRatio)$lPVUQ.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.referenceCount !== 0) writer.uint32(16).uint32(message.referenceCount);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $794c7bc64553bf49$var$minimal_1.default.Reader ? input : new $794c7bc64553bf49$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $794c7bc64553bf49$var$baseValidatorHistoricalRewards);
        message.cumulativeRewardRatio = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.cumulativeRewardRatio.push($lPVUQ.DecCoin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.referenceCount = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $794c7bc64553bf49$var$baseValidatorHistoricalRewards);
        message.cumulativeRewardRatio = [];
        if (object.cumulativeRewardRatio !== undefined && object.cumulativeRewardRatio !== null) for (const e of object.cumulativeRewardRatio)message.cumulativeRewardRatio.push($lPVUQ.DecCoin.fromJSON(e));
        if (object.referenceCount !== undefined && object.referenceCount !== null) message.referenceCount = Number(object.referenceCount);
        else message.referenceCount = 0;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.cumulativeRewardRatio) obj.cumulativeRewardRatio = message.cumulativeRewardRatio.map((e)=>e ? $lPVUQ.DecCoin.toJSON(e) : undefined);
        else obj.cumulativeRewardRatio = [];
        message.referenceCount !== undefined && (obj.referenceCount = message.referenceCount);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $794c7bc64553bf49$var$baseValidatorHistoricalRewards);
        message.cumulativeRewardRatio = [];
        if (object.cumulativeRewardRatio !== undefined && object.cumulativeRewardRatio !== null) for (const e of object.cumulativeRewardRatio)message.cumulativeRewardRatio.push($lPVUQ.DecCoin.fromPartial(e));
        if (object.referenceCount !== undefined && object.referenceCount !== null) message.referenceCount = object.referenceCount;
        else message.referenceCount = 0;
        return message;
    }
};
const $794c7bc64553bf49$var$baseValidatorCurrentRewards = {
    period: $794c7bc64553bf49$var$long_1.default.UZERO
};
module.exports.ValidatorCurrentRewards = {
    encode (message, writer = $794c7bc64553bf49$var$minimal_1.default.Writer.create()) {
        for (const v of message.rewards)$lPVUQ.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        if (!message.period.isZero()) writer.uint32(16).uint64(message.period);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $794c7bc64553bf49$var$minimal_1.default.Reader ? input : new $794c7bc64553bf49$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $794c7bc64553bf49$var$baseValidatorCurrentRewards);
        message.rewards = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.rewards.push($lPVUQ.DecCoin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.period = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $794c7bc64553bf49$var$baseValidatorCurrentRewards);
        message.rewards = [];
        if (object.rewards !== undefined && object.rewards !== null) for (const e of object.rewards)message.rewards.push($lPVUQ.DecCoin.fromJSON(e));
        if (object.period !== undefined && object.period !== null) message.period = $794c7bc64553bf49$var$long_1.default.fromString(object.period);
        else message.period = $794c7bc64553bf49$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.rewards) obj.rewards = message.rewards.map((e)=>e ? $lPVUQ.DecCoin.toJSON(e) : undefined);
        else obj.rewards = [];
        message.period !== undefined && (obj.period = (message.period || $794c7bc64553bf49$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $794c7bc64553bf49$var$baseValidatorCurrentRewards);
        message.rewards = [];
        if (object.rewards !== undefined && object.rewards !== null) for (const e of object.rewards)message.rewards.push($lPVUQ.DecCoin.fromPartial(e));
        if (object.period !== undefined && object.period !== null) message.period = object.period;
        else message.period = $794c7bc64553bf49$var$long_1.default.UZERO;
        return message;
    }
};
const $794c7bc64553bf49$var$baseValidatorAccumulatedCommission = {};
module.exports.ValidatorAccumulatedCommission = {
    encode (message, writer = $794c7bc64553bf49$var$minimal_1.default.Writer.create()) {
        for (const v of message.commission)$lPVUQ.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $794c7bc64553bf49$var$minimal_1.default.Reader ? input : new $794c7bc64553bf49$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $794c7bc64553bf49$var$baseValidatorAccumulatedCommission);
        message.commission = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.commission.push($lPVUQ.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $794c7bc64553bf49$var$baseValidatorAccumulatedCommission);
        message.commission = [];
        if (object.commission !== undefined && object.commission !== null) for (const e of object.commission)message.commission.push($lPVUQ.DecCoin.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.commission) obj.commission = message.commission.map((e)=>e ? $lPVUQ.DecCoin.toJSON(e) : undefined);
        else obj.commission = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $794c7bc64553bf49$var$baseValidatorAccumulatedCommission);
        message.commission = [];
        if (object.commission !== undefined && object.commission !== null) for (const e of object.commission)message.commission.push($lPVUQ.DecCoin.fromPartial(e));
        return message;
    }
};
const $794c7bc64553bf49$var$baseValidatorOutstandingRewards = {};
module.exports.ValidatorOutstandingRewards = {
    encode (message, writer = $794c7bc64553bf49$var$minimal_1.default.Writer.create()) {
        for (const v of message.rewards)$lPVUQ.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $794c7bc64553bf49$var$minimal_1.default.Reader ? input : new $794c7bc64553bf49$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $794c7bc64553bf49$var$baseValidatorOutstandingRewards);
        message.rewards = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.rewards.push($lPVUQ.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $794c7bc64553bf49$var$baseValidatorOutstandingRewards);
        message.rewards = [];
        if (object.rewards !== undefined && object.rewards !== null) for (const e of object.rewards)message.rewards.push($lPVUQ.DecCoin.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.rewards) obj.rewards = message.rewards.map((e)=>e ? $lPVUQ.DecCoin.toJSON(e) : undefined);
        else obj.rewards = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $794c7bc64553bf49$var$baseValidatorOutstandingRewards);
        message.rewards = [];
        if (object.rewards !== undefined && object.rewards !== null) for (const e of object.rewards)message.rewards.push($lPVUQ.DecCoin.fromPartial(e));
        return message;
    }
};
const $794c7bc64553bf49$var$baseValidatorSlashEvent = {
    validatorPeriod: $794c7bc64553bf49$var$long_1.default.UZERO,
    fraction: ""
};
module.exports.ValidatorSlashEvent = {
    encode (message, writer = $794c7bc64553bf49$var$minimal_1.default.Writer.create()) {
        if (!message.validatorPeriod.isZero()) writer.uint32(8).uint64(message.validatorPeriod);
        if (message.fraction !== "") writer.uint32(18).string(message.fraction);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $794c7bc64553bf49$var$minimal_1.default.Reader ? input : new $794c7bc64553bf49$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $794c7bc64553bf49$var$baseValidatorSlashEvent);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorPeriod = reader.uint64();
                    break;
                case 2:
                    message.fraction = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $794c7bc64553bf49$var$baseValidatorSlashEvent);
        if (object.validatorPeriod !== undefined && object.validatorPeriod !== null) message.validatorPeriod = $794c7bc64553bf49$var$long_1.default.fromString(object.validatorPeriod);
        else message.validatorPeriod = $794c7bc64553bf49$var$long_1.default.UZERO;
        if (object.fraction !== undefined && object.fraction !== null) message.fraction = String(object.fraction);
        else message.fraction = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.validatorPeriod !== undefined && (obj.validatorPeriod = (message.validatorPeriod || $794c7bc64553bf49$var$long_1.default.UZERO).toString());
        message.fraction !== undefined && (obj.fraction = message.fraction);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $794c7bc64553bf49$var$baseValidatorSlashEvent);
        if (object.validatorPeriod !== undefined && object.validatorPeriod !== null) message.validatorPeriod = object.validatorPeriod;
        else message.validatorPeriod = $794c7bc64553bf49$var$long_1.default.UZERO;
        if (object.fraction !== undefined && object.fraction !== null) message.fraction = object.fraction;
        else message.fraction = "";
        return message;
    }
};
const $794c7bc64553bf49$var$baseValidatorSlashEvents = {};
module.exports.ValidatorSlashEvents = {
    encode (message, writer = $794c7bc64553bf49$var$minimal_1.default.Writer.create()) {
        for (const v of message.validatorSlashEvents)module.exports.ValidatorSlashEvent.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $794c7bc64553bf49$var$minimal_1.default.Reader ? input : new $794c7bc64553bf49$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $794c7bc64553bf49$var$baseValidatorSlashEvents);
        message.validatorSlashEvents = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorSlashEvents.push(module.exports.ValidatorSlashEvent.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $794c7bc64553bf49$var$baseValidatorSlashEvents);
        message.validatorSlashEvents = [];
        if (object.validatorSlashEvents !== undefined && object.validatorSlashEvents !== null) for (const e of object.validatorSlashEvents)message.validatorSlashEvents.push(module.exports.ValidatorSlashEvent.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.validatorSlashEvents) obj.validatorSlashEvents = message.validatorSlashEvents.map((e)=>e ? module.exports.ValidatorSlashEvent.toJSON(e) : undefined);
        else obj.validatorSlashEvents = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $794c7bc64553bf49$var$baseValidatorSlashEvents);
        message.validatorSlashEvents = [];
        if (object.validatorSlashEvents !== undefined && object.validatorSlashEvents !== null) for (const e of object.validatorSlashEvents)message.validatorSlashEvents.push(module.exports.ValidatorSlashEvent.fromPartial(e));
        return message;
    }
};
const $794c7bc64553bf49$var$baseFeePool = {};
module.exports.FeePool = {
    encode (message, writer = $794c7bc64553bf49$var$minimal_1.default.Writer.create()) {
        for (const v of message.communityPool)$lPVUQ.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $794c7bc64553bf49$var$minimal_1.default.Reader ? input : new $794c7bc64553bf49$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $794c7bc64553bf49$var$baseFeePool);
        message.communityPool = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.communityPool.push($lPVUQ.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $794c7bc64553bf49$var$baseFeePool);
        message.communityPool = [];
        if (object.communityPool !== undefined && object.communityPool !== null) for (const e of object.communityPool)message.communityPool.push($lPVUQ.DecCoin.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.communityPool) obj.communityPool = message.communityPool.map((e)=>e ? $lPVUQ.DecCoin.toJSON(e) : undefined);
        else obj.communityPool = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $794c7bc64553bf49$var$baseFeePool);
        message.communityPool = [];
        if (object.communityPool !== undefined && object.communityPool !== null) for (const e of object.communityPool)message.communityPool.push($lPVUQ.DecCoin.fromPartial(e));
        return message;
    }
};
const $794c7bc64553bf49$var$baseCommunityPoolSpendProposal = {
    title: "",
    description: "",
    recipient: ""
};
module.exports.CommunityPoolSpendProposal = {
    encode (message, writer = $794c7bc64553bf49$var$minimal_1.default.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        if (message.recipient !== "") writer.uint32(26).string(message.recipient);
        for (const v of message.amount)$lPVUQ.Coin.encode(v, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $794c7bc64553bf49$var$minimal_1.default.Reader ? input : new $794c7bc64553bf49$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $794c7bc64553bf49$var$baseCommunityPoolSpendProposal);
        message.amount = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.recipient = reader.string();
                    break;
                case 4:
                    message.amount.push($lPVUQ.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $794c7bc64553bf49$var$baseCommunityPoolSpendProposal);
        message.amount = [];
        if (object.title !== undefined && object.title !== null) message.title = String(object.title);
        else message.title = "";
        if (object.description !== undefined && object.description !== null) message.description = String(object.description);
        else message.description = "";
        if (object.recipient !== undefined && object.recipient !== null) message.recipient = String(object.recipient);
        else message.recipient = "";
        if (object.amount !== undefined && object.amount !== null) for (const e of object.amount)message.amount.push($lPVUQ.Coin.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.recipient !== undefined && (obj.recipient = message.recipient);
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $lPVUQ.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $794c7bc64553bf49$var$baseCommunityPoolSpendProposal);
        message.amount = [];
        if (object.title !== undefined && object.title !== null) message.title = object.title;
        else message.title = "";
        if (object.description !== undefined && object.description !== null) message.description = object.description;
        else message.description = "";
        if (object.recipient !== undefined && object.recipient !== null) message.recipient = object.recipient;
        else message.recipient = "";
        if (object.amount !== undefined && object.amount !== null) for (const e of object.amount)message.amount.push($lPVUQ.Coin.fromPartial(e));
        return message;
    }
};
const $794c7bc64553bf49$var$baseDelegatorStartingInfo = {
    previousPeriod: $794c7bc64553bf49$var$long_1.default.UZERO,
    stake: "",
    height: $794c7bc64553bf49$var$long_1.default.UZERO
};
module.exports.DelegatorStartingInfo = {
    encode (message, writer = $794c7bc64553bf49$var$minimal_1.default.Writer.create()) {
        if (!message.previousPeriod.isZero()) writer.uint32(8).uint64(message.previousPeriod);
        if (message.stake !== "") writer.uint32(18).string(message.stake);
        if (!message.height.isZero()) writer.uint32(24).uint64(message.height);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $794c7bc64553bf49$var$minimal_1.default.Reader ? input : new $794c7bc64553bf49$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $794c7bc64553bf49$var$baseDelegatorStartingInfo);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.previousPeriod = reader.uint64();
                    break;
                case 2:
                    message.stake = reader.string();
                    break;
                case 3:
                    message.height = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $794c7bc64553bf49$var$baseDelegatorStartingInfo);
        if (object.previousPeriod !== undefined && object.previousPeriod !== null) message.previousPeriod = $794c7bc64553bf49$var$long_1.default.fromString(object.previousPeriod);
        else message.previousPeriod = $794c7bc64553bf49$var$long_1.default.UZERO;
        if (object.stake !== undefined && object.stake !== null) message.stake = String(object.stake);
        else message.stake = "";
        if (object.height !== undefined && object.height !== null) message.height = $794c7bc64553bf49$var$long_1.default.fromString(object.height);
        else message.height = $794c7bc64553bf49$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.previousPeriod !== undefined && (obj.previousPeriod = (message.previousPeriod || $794c7bc64553bf49$var$long_1.default.UZERO).toString());
        message.stake !== undefined && (obj.stake = message.stake);
        message.height !== undefined && (obj.height = (message.height || $794c7bc64553bf49$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $794c7bc64553bf49$var$baseDelegatorStartingInfo);
        if (object.previousPeriod !== undefined && object.previousPeriod !== null) message.previousPeriod = object.previousPeriod;
        else message.previousPeriod = $794c7bc64553bf49$var$long_1.default.UZERO;
        if (object.stake !== undefined && object.stake !== null) message.stake = object.stake;
        else message.stake = "";
        if (object.height !== undefined && object.height !== null) message.height = object.height;
        else message.height = $794c7bc64553bf49$var$long_1.default.UZERO;
        return message;
    }
};
const $794c7bc64553bf49$var$baseDelegationDelegatorReward = {
    validatorAddress: ""
};
module.exports.DelegationDelegatorReward = {
    encode (message, writer = $794c7bc64553bf49$var$minimal_1.default.Writer.create()) {
        if (message.validatorAddress !== "") writer.uint32(10).string(message.validatorAddress);
        for (const v of message.reward)$lPVUQ.DecCoin.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $794c7bc64553bf49$var$minimal_1.default.Reader ? input : new $794c7bc64553bf49$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $794c7bc64553bf49$var$baseDelegationDelegatorReward);
        message.reward = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                case 2:
                    message.reward.push($lPVUQ.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $794c7bc64553bf49$var$baseDelegationDelegatorReward);
        message.reward = [];
        if (object.validatorAddress !== undefined && object.validatorAddress !== null) message.validatorAddress = String(object.validatorAddress);
        else message.validatorAddress = "";
        if (object.reward !== undefined && object.reward !== null) for (const e of object.reward)message.reward.push($lPVUQ.DecCoin.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        if (message.reward) obj.reward = message.reward.map((e)=>e ? $lPVUQ.DecCoin.toJSON(e) : undefined);
        else obj.reward = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $794c7bc64553bf49$var$baseDelegationDelegatorReward);
        message.reward = [];
        if (object.validatorAddress !== undefined && object.validatorAddress !== null) message.validatorAddress = object.validatorAddress;
        else message.validatorAddress = "";
        if (object.reward !== undefined && object.reward !== null) for (const e of object.reward)message.reward.push($lPVUQ.DecCoin.fromPartial(e));
        return message;
    }
};
const $794c7bc64553bf49$var$baseCommunityPoolSpendProposalWithDeposit = {
    title: "",
    description: "",
    recipient: "",
    amount: "",
    deposit: ""
};
module.exports.CommunityPoolSpendProposalWithDeposit = {
    encode (message, writer = $794c7bc64553bf49$var$minimal_1.default.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        if (message.recipient !== "") writer.uint32(26).string(message.recipient);
        if (message.amount !== "") writer.uint32(34).string(message.amount);
        if (message.deposit !== "") writer.uint32(42).string(message.deposit);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $794c7bc64553bf49$var$minimal_1.default.Reader ? input : new $794c7bc64553bf49$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $794c7bc64553bf49$var$baseCommunityPoolSpendProposalWithDeposit);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.recipient = reader.string();
                    break;
                case 4:
                    message.amount = reader.string();
                    break;
                case 5:
                    message.deposit = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $794c7bc64553bf49$var$baseCommunityPoolSpendProposalWithDeposit);
        if (object.title !== undefined && object.title !== null) message.title = String(object.title);
        else message.title = "";
        if (object.description !== undefined && object.description !== null) message.description = String(object.description);
        else message.description = "";
        if (object.recipient !== undefined && object.recipient !== null) message.recipient = String(object.recipient);
        else message.recipient = "";
        if (object.amount !== undefined && object.amount !== null) message.amount = String(object.amount);
        else message.amount = "";
        if (object.deposit !== undefined && object.deposit !== null) message.deposit = String(object.deposit);
        else message.deposit = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.recipient !== undefined && (obj.recipient = message.recipient);
        message.amount !== undefined && (obj.amount = message.amount);
        message.deposit !== undefined && (obj.deposit = message.deposit);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $794c7bc64553bf49$var$baseCommunityPoolSpendProposalWithDeposit);
        if (object.title !== undefined && object.title !== null) message.title = object.title;
        else message.title = "";
        if (object.description !== undefined && object.description !== null) message.description = object.description;
        else message.description = "";
        if (object.recipient !== undefined && object.recipient !== null) message.recipient = object.recipient;
        else message.recipient = "";
        if (object.amount !== undefined && object.amount !== null) message.amount = object.amount;
        else message.amount = "";
        if (object.deposit !== undefined && object.deposit !== null) message.deposit = object.deposit;
        else message.deposit = "";
        return message;
    }
};
if ($794c7bc64553bf49$var$minimal_1.default.util.Long !== $794c7bc64553bf49$var$long_1.default) {
    $794c7bc64553bf49$var$minimal_1.default.util.Long = $794c7bc64553bf49$var$long_1.default;
    $794c7bc64553bf49$var$minimal_1.default.configure();
}

});



parcelRegister("1ZQER", function(module, exports) {
"use strict";
var $174455c3edc3520d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $174455c3edc3520d$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $174455c3edc3520d$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$174455c3edc3520d$var$__exportStar((parcelRequire("eA2d5")), module.exports);

});
parcelRegister("eA2d5", function(module, exports) {
"use strict";
var $a9d624554ed1ac54$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParameterChangeProposal = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $0239z = parcelRequire("0239z");

var $c5FxR = parcelRequire("c5FxR");

var $4XWKw = parcelRequire("4XWKw");
/**
 * Describes a proposal for directly altering the value of the module parameters.
 * If you want to select a couple parameters to change for your proposal, you'll first
 * include the subspace (module it belongs to, such as "oracle" or "distribution"), and
 * then just the specific keys that you want to include in your changes as items in a
 * JavaScript object.
 *
 * ```ts
 * import {
 *    Dec,
 *    MsgSubmitProposal,
 *    ParameterChangeProposal
 * } from "@terra-money/terra.js";
 *
 * const proposal = new ParameterChangeProposal("title", "description", {
 *    market: {
 *      minspread: new Dec(0.25),
 *      basepool: new Dec(10000000)
 *    },
 *    staking: {
 *      UnbondingTime: 15000000
 *    }
 * });
 *
 * const msg = new MsgSubmitProposal();
 * ```
 */ var $a9d624554ed1ac54$var$ParameterChangeProposal = /** @class */ function(_super) {
    $a9d624554ed1ac54$var$__extends(ParameterChangeProposal, _super);
    /**
     * @param title proposal's title
     * @param description proposal's description
     * @param changes an object whose keys are subspace names, and whose values are objects
     * with objects having for keys and values, the desired parameter changes.
     */ function ParameterChangeProposal(title, description, changes) {
        var _this = _super.call(this) || this;
        _this.title = title;
        _this.description = description;
        if (Array.isArray(changes)) _this.changes = $0239z.ParamChanges.fromData(changes);
        else _this.changes = changes;
        return _this;
    }
    ParameterChangeProposal.fromAmino = function(data, _) {
        _;
        var _a = data.value, title = _a.title, description = _a.description, changes = _a.changes;
        return new ParameterChangeProposal(title, description, $0239z.ParamChanges.fromAmino(changes));
    };
    ParameterChangeProposal.prototype.toAmino = function(isClassic) {
        var _a = this, title = _a.title, description = _a.description, changes = _a.changes;
        return {
            type: isClassic ? "params/ParameterChangeProposal" : "cosmos-sdk/ParameterChangeProposal",
            value: {
                title: title,
                description: description,
                changes: changes.toAmino()
            }
        };
    };
    ParameterChangeProposal.fromData = function(proto, _) {
        _;
        var title = proto.title, description = proto.description, changes = proto.changes;
        return new ParameterChangeProposal(title, description, $0239z.ParamChanges.fromData(changes));
    };
    ParameterChangeProposal.prototype.toData = function(_) {
        _;
        var _a = this, title = _a.title, description = _a.description, changes = _a.changes;
        return {
            "@type": "/cosmos.params.v1beta1.ParameterChangeProposal",
            title: title,
            description: description,
            changes: changes.toData()
        };
    };
    ParameterChangeProposal.fromProto = function(proto, _) {
        _;
        return new ParameterChangeProposal(proto.title, proto.description, $0239z.ParamChanges.fromProto(proto.changes));
    };
    ParameterChangeProposal.prototype.toProto = function(_) {
        _;
        var _a = this, title = _a.title, description = _a.description, changes = _a.changes;
        return $4XWKw.ParameterChangeProposal.fromPartial({
            changes: changes.toProto(),
            description: description,
            title: title
        });
    };
    ParameterChangeProposal.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmos.params.v1beta1.ParameterChangeProposal",
            value: $4XWKw.ParameterChangeProposal.encode(this.toProto(isClassic)).finish()
        });
    };
    ParameterChangeProposal.unpackAny = function(msgAny, isClassic) {
        return ParameterChangeProposal.fromProto($4XWKw.ParameterChangeProposal.decode(msgAny.value), isClassic);
    };
    return ParameterChangeProposal;
}($26Eqx.JSONSerializable);
module.exports.ParameterChangeProposal = $a9d624554ed1ac54$var$ParameterChangeProposal;

});
parcelRegister("0239z", function(module, exports) {
"use strict";
var $0062a239ed343810$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParamChange = module.exports.ParamChanges = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $4XWKw = parcelRequire("4XWKw");
var $0062a239ed343810$var$ParamChanges = /** @class */ function(_super) {
    $0062a239ed343810$var$__extends(ParamChanges, _super);
    function ParamChanges(paramChanges) {
        var _this = _super.call(this) || this;
        _this.paramChanges = paramChanges;
        return _this;
    }
    ParamChanges.fromAmino = function(proto) {
        return new ParamChanges((proto !== null && proto !== void 0 ? proto : []).map($0062a239ed343810$var$ParamChange.fromAmino));
    };
    ParamChanges.prototype.toAmino = function() {
        return this.paramChanges.map(function(c) {
            return c.toAmino();
        });
    };
    ParamChanges.fromData = function(proto) {
        return new ParamChanges((proto !== null && proto !== void 0 ? proto : []).map($0062a239ed343810$var$ParamChange.fromData));
    };
    ParamChanges.prototype.toData = function() {
        return this.paramChanges.map(function(c) {
            return c.toData();
        });
    };
    ParamChanges.fromProto = function(proto) {
        return new ParamChanges((proto !== null && proto !== void 0 ? proto : []).map($0062a239ed343810$var$ParamChange.fromProto));
    };
    ParamChanges.prototype.toProto = function() {
        return this.paramChanges.map(function(c) {
            return c.toProto();
        });
    };
    return ParamChanges;
}($26Eqx.JSONSerializable);
module.exports.ParamChanges = $0062a239ed343810$var$ParamChanges;
var $0062a239ed343810$var$ParamChange = /** @class */ function(_super) {
    $0062a239ed343810$var$__extends(ParamChange, _super);
    function ParamChange(subspace, key, value) {
        var _this = _super.call(this) || this;
        _this.subspace = subspace;
        _this.key = key;
        _this.value = value;
        return _this;
    }
    ParamChange.fromAmino = function(data) {
        var subspace = data.subspace, key = data.key, value = data.value;
        return new ParamChange(subspace, key, value);
    };
    ParamChange.prototype.toAmino = function() {
        var _a = this, subspace = _a.subspace, key = _a.key, value = _a.value;
        return {
            subspace: subspace,
            key: key,
            value: value
        };
    };
    ParamChange.fromData = function(data) {
        var subspace = data.subspace, key = data.key, value = data.value;
        return new ParamChange(subspace, key, value);
    };
    ParamChange.prototype.toData = function() {
        var _a = this, subspace = _a.subspace, key = _a.key, value = _a.value;
        return {
            subspace: subspace,
            key: key,
            value: value
        };
    };
    ParamChange.fromProto = function(proto) {
        return new ParamChange(proto.subspace, proto.key, proto.value);
    };
    ParamChange.prototype.toProto = function() {
        var _a = this, subspace = _a.subspace, key = _a.key, value = _a.value;
        return $4XWKw.ParamChange.fromPartial({
            key: key,
            subspace: subspace,
            value: value
        });
    };
    return ParamChange;
}($26Eqx.JSONSerializable);
module.exports.ParamChange = $0062a239ed343810$var$ParamChange;

});
parcelRegister("4XWKw", function(module, exports) {
"use strict";
var $39da3e856e3c7aab$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParamChange = module.exports.ParameterChangeProposal = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $39da3e856e3c7aab$var$long_1 = $39da3e856e3c7aab$var$__importDefault((parcelRequire("9A55m")));

const $39da3e856e3c7aab$var$minimal_1 = $39da3e856e3c7aab$var$__importDefault((parcelRequire("i2pIU")));
module.exports.protobufPackage = "cosmos.params.v1beta1";
const $39da3e856e3c7aab$var$baseParameterChangeProposal = {
    title: "",
    description: ""
};
module.exports.ParameterChangeProposal = {
    encode (message, writer = $39da3e856e3c7aab$var$minimal_1.default.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        for (const v of message.changes)module.exports.ParamChange.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $39da3e856e3c7aab$var$minimal_1.default.Reader ? input : new $39da3e856e3c7aab$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $39da3e856e3c7aab$var$baseParameterChangeProposal);
        message.changes = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.changes.push(module.exports.ParamChange.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $39da3e856e3c7aab$var$baseParameterChangeProposal);
        message.changes = [];
        if (object.title !== undefined && object.title !== null) message.title = String(object.title);
        else message.title = "";
        if (object.description !== undefined && object.description !== null) message.description = String(object.description);
        else message.description = "";
        if (object.changes !== undefined && object.changes !== null) for (const e of object.changes)message.changes.push(module.exports.ParamChange.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        if (message.changes) obj.changes = message.changes.map((e)=>e ? module.exports.ParamChange.toJSON(e) : undefined);
        else obj.changes = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $39da3e856e3c7aab$var$baseParameterChangeProposal);
        message.changes = [];
        if (object.title !== undefined && object.title !== null) message.title = object.title;
        else message.title = "";
        if (object.description !== undefined && object.description !== null) message.description = object.description;
        else message.description = "";
        if (object.changes !== undefined && object.changes !== null) for (const e of object.changes)message.changes.push(module.exports.ParamChange.fromPartial(e));
        return message;
    }
};
const $39da3e856e3c7aab$var$baseParamChange = {
    subspace: "",
    key: "",
    value: ""
};
module.exports.ParamChange = {
    encode (message, writer = $39da3e856e3c7aab$var$minimal_1.default.Writer.create()) {
        if (message.subspace !== "") writer.uint32(10).string(message.subspace);
        if (message.key !== "") writer.uint32(18).string(message.key);
        if (message.value !== "") writer.uint32(26).string(message.value);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $39da3e856e3c7aab$var$minimal_1.default.Reader ? input : new $39da3e856e3c7aab$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $39da3e856e3c7aab$var$baseParamChange);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.subspace = reader.string();
                    break;
                case 2:
                    message.key = reader.string();
                    break;
                case 3:
                    message.value = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $39da3e856e3c7aab$var$baseParamChange);
        if (object.subspace !== undefined && object.subspace !== null) message.subspace = String(object.subspace);
        else message.subspace = "";
        if (object.key !== undefined && object.key !== null) message.key = String(object.key);
        else message.key = "";
        if (object.value !== undefined && object.value !== null) message.value = String(object.value);
        else message.value = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.subspace !== undefined && (obj.subspace = message.subspace);
        message.key !== undefined && (obj.key = message.key);
        message.value !== undefined && (obj.value = message.value);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $39da3e856e3c7aab$var$baseParamChange);
        if (object.subspace !== undefined && object.subspace !== null) message.subspace = object.subspace;
        else message.subspace = "";
        if (object.key !== undefined && object.key !== null) message.key = object.key;
        else message.key = "";
        if (object.value !== undefined && object.value !== null) message.value = object.value;
        else message.value = "";
        return message;
    }
};
if ($39da3e856e3c7aab$var$minimal_1.default.util.Long !== $39da3e856e3c7aab$var$long_1.default) {
    $39da3e856e3c7aab$var$minimal_1.default.util.Long = $39da3e856e3c7aab$var$long_1.default;
    $39da3e856e3c7aab$var$minimal_1.default.configure();
}

});




parcelRegister("be54r", function(module, exports) {
"use strict";
var $82c4ef75bef5d301$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $82c4ef75bef5d301$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $82c4ef75bef5d301$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$82c4ef75bef5d301$var$__exportStar((parcelRequire("emzPa")), module.exports);

});
parcelRegister("emzPa", function(module, exports) {
"use strict";
var $a74ee8b3981b7b4e$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ClientUpdateProposal = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $yqmJM = parcelRequire("yqmJM");
/**
 * Proposal that allows updating IBC clients. If it passes, the substitute
 * client's latest consensus state is copied over to the subject client.
 */ var $a74ee8b3981b7b4e$var$ClientUpdateProposal = /** @class */ function(_super) {
    $a74ee8b3981b7b4e$var$__extends(ClientUpdateProposal, _super);
    /**
     * @param title proposal's title
     * @param description proposal's description
     * @param subjectClientId client to update
     * @param substituteClientId client to copy
     */ function ClientUpdateProposal(title, description, subjectClientId, substituteClientId) {
        var _this = _super.call(this) || this;
        _this.title = title;
        _this.description = description;
        _this.subjectClientId = subjectClientId;
        _this.substituteClientId = substituteClientId;
        return _this;
    }
    ClientUpdateProposal.fromAmino = function(data, _) {
        _;
        var _a = data.value, title = _a.title, description = _a.description, subjectClientId = _a.subjectClientId, substituteClientId = _a.substituteClientId;
        return new ClientUpdateProposal(title, description, subjectClientId, substituteClientId);
    };
    ClientUpdateProposal.prototype.toAmino = function(_) {
        _;
        var _a = this, title = _a.title, description = _a.description, subjectClientId = _a.subjectClientId, substituteClientId = _a.substituteClientId;
        return {
            type: "ibc/ClientUpdateProposal",
            value: {
                title: title,
                description: description,
                subjectClientId: subjectClientId,
                substituteClientId: substituteClientId
            }
        };
    };
    ClientUpdateProposal.fromData = function(data, _) {
        _;
        var title = data.title, description = data.description, subject_client_id = data.subject_client_id, substitute_client_id = data.substitute_client_id;
        return new ClientUpdateProposal(title, description, subject_client_id, substitute_client_id);
    };
    ClientUpdateProposal.prototype.toData = function(_) {
        _;
        var _a = this, title = _a.title, description = _a.description, subjectClientId = _a.subjectClientId, substituteClientId = _a.substituteClientId;
        return {
            "@type": "/ibc.core.client.v1.ClientUpdateProposal",
            title: title,
            description: description,
            subject_client_id: subjectClientId,
            substitute_client_id: substituteClientId
        };
    };
    ClientUpdateProposal.fromProto = function(proto, _) {
        _;
        return new ClientUpdateProposal(proto.title, proto.description, proto.subjectClientId, proto.substituteClientId);
    };
    ClientUpdateProposal.prototype.toProto = function(_) {
        _;
        var _a = this, title = _a.title, description = _a.description, subjectClientId = _a.subjectClientId, substituteClientId = _a.substituteClientId;
        return $yqmJM.ClientUpdateProposal.fromPartial({
            subjectClientId: subjectClientId,
            substituteClientId: substituteClientId,
            description: description,
            title: title
        });
    };
    ClientUpdateProposal.prototype.packAny = function(_) {
        _;
        return $c5FxR.Any.fromPartial({
            typeUrl: "/ibc.core.client.v1.ClientUpdateProposal",
            value: $yqmJM.ClientUpdateProposal.encode(this.toProto()).finish()
        });
    };
    ClientUpdateProposal.unpackAny = function(msgAny, _) {
        _;
        return ClientUpdateProposal.fromProto($yqmJM.ClientUpdateProposal.decode(msgAny.value));
    };
    return ClientUpdateProposal;
}($26Eqx.JSONSerializable);
module.exports.ClientUpdateProposal = $a74ee8b3981b7b4e$var$ClientUpdateProposal;

});
parcelRegister("yqmJM", function(module, exports) {
"use strict";
var $0677a0c68897ece8$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Params = module.exports.Height = module.exports.UpgradeProposal = module.exports.ClientUpdateProposal = module.exports.ClientConsensusStates = module.exports.ConsensusStateWithHeight = module.exports.IdentifiedClientState = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $0677a0c68897ece8$var$long_1 = $0677a0c68897ece8$var$__importDefault((parcelRequire("9A55m")));

const $0677a0c68897ece8$var$minimal_1 = $0677a0c68897ece8$var$__importDefault((parcelRequire("i2pIU")));

var $c5FxR = parcelRequire("c5FxR");

var $8MpMs = parcelRequire("8MpMs");
module.exports.protobufPackage = "ibc.core.client.v1";
const $0677a0c68897ece8$var$baseIdentifiedClientState = {
    clientId: ""
};
module.exports.IdentifiedClientState = {
    encode (message, writer = $0677a0c68897ece8$var$minimal_1.default.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.clientState !== undefined) $c5FxR.Any.encode(message.clientState, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0677a0c68897ece8$var$minimal_1.default.Reader ? input : new $0677a0c68897ece8$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $0677a0c68897ece8$var$baseIdentifiedClientState);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.clientState = $c5FxR.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $0677a0c68897ece8$var$baseIdentifiedClientState);
        if (object.clientId !== undefined && object.clientId !== null) message.clientId = String(object.clientId);
        else message.clientId = "";
        if (object.clientState !== undefined && object.clientState !== null) message.clientState = $c5FxR.Any.fromJSON(object.clientState);
        else message.clientState = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.clientState !== undefined && (obj.clientState = message.clientState ? $c5FxR.Any.toJSON(message.clientState) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $0677a0c68897ece8$var$baseIdentifiedClientState);
        if (object.clientId !== undefined && object.clientId !== null) message.clientId = object.clientId;
        else message.clientId = "";
        if (object.clientState !== undefined && object.clientState !== null) message.clientState = $c5FxR.Any.fromPartial(object.clientState);
        else message.clientState = undefined;
        return message;
    }
};
const $0677a0c68897ece8$var$baseConsensusStateWithHeight = {};
module.exports.ConsensusStateWithHeight = {
    encode (message, writer = $0677a0c68897ece8$var$minimal_1.default.Writer.create()) {
        if (message.height !== undefined) module.exports.Height.encode(message.height, writer.uint32(10).fork()).ldelim();
        if (message.consensusState !== undefined) $c5FxR.Any.encode(message.consensusState, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0677a0c68897ece8$var$minimal_1.default.Reader ? input : new $0677a0c68897ece8$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $0677a0c68897ece8$var$baseConsensusStateWithHeight);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = module.exports.Height.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.consensusState = $c5FxR.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $0677a0c68897ece8$var$baseConsensusStateWithHeight);
        if (object.height !== undefined && object.height !== null) message.height = module.exports.Height.fromJSON(object.height);
        else message.height = undefined;
        if (object.consensusState !== undefined && object.consensusState !== null) message.consensusState = $c5FxR.Any.fromJSON(object.consensusState);
        else message.consensusState = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = message.height ? module.exports.Height.toJSON(message.height) : undefined);
        message.consensusState !== undefined && (obj.consensusState = message.consensusState ? $c5FxR.Any.toJSON(message.consensusState) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $0677a0c68897ece8$var$baseConsensusStateWithHeight);
        if (object.height !== undefined && object.height !== null) message.height = module.exports.Height.fromPartial(object.height);
        else message.height = undefined;
        if (object.consensusState !== undefined && object.consensusState !== null) message.consensusState = $c5FxR.Any.fromPartial(object.consensusState);
        else message.consensusState = undefined;
        return message;
    }
};
const $0677a0c68897ece8$var$baseClientConsensusStates = {
    clientId: ""
};
module.exports.ClientConsensusStates = {
    encode (message, writer = $0677a0c68897ece8$var$minimal_1.default.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        for (const v of message.consensusStates)module.exports.ConsensusStateWithHeight.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0677a0c68897ece8$var$minimal_1.default.Reader ? input : new $0677a0c68897ece8$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $0677a0c68897ece8$var$baseClientConsensusStates);
        message.consensusStates = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.consensusStates.push(module.exports.ConsensusStateWithHeight.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $0677a0c68897ece8$var$baseClientConsensusStates);
        message.consensusStates = [];
        if (object.clientId !== undefined && object.clientId !== null) message.clientId = String(object.clientId);
        else message.clientId = "";
        if (object.consensusStates !== undefined && object.consensusStates !== null) for (const e of object.consensusStates)message.consensusStates.push(module.exports.ConsensusStateWithHeight.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        if (message.consensusStates) obj.consensusStates = message.consensusStates.map((e)=>e ? module.exports.ConsensusStateWithHeight.toJSON(e) : undefined);
        else obj.consensusStates = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $0677a0c68897ece8$var$baseClientConsensusStates);
        message.consensusStates = [];
        if (object.clientId !== undefined && object.clientId !== null) message.clientId = object.clientId;
        else message.clientId = "";
        if (object.consensusStates !== undefined && object.consensusStates !== null) for (const e of object.consensusStates)message.consensusStates.push(module.exports.ConsensusStateWithHeight.fromPartial(e));
        return message;
    }
};
const $0677a0c68897ece8$var$baseClientUpdateProposal = {
    title: "",
    description: "",
    subjectClientId: "",
    substituteClientId: ""
};
module.exports.ClientUpdateProposal = {
    encode (message, writer = $0677a0c68897ece8$var$minimal_1.default.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        if (message.subjectClientId !== "") writer.uint32(26).string(message.subjectClientId);
        if (message.substituteClientId !== "") writer.uint32(34).string(message.substituteClientId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0677a0c68897ece8$var$minimal_1.default.Reader ? input : new $0677a0c68897ece8$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $0677a0c68897ece8$var$baseClientUpdateProposal);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.subjectClientId = reader.string();
                    break;
                case 4:
                    message.substituteClientId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $0677a0c68897ece8$var$baseClientUpdateProposal);
        if (object.title !== undefined && object.title !== null) message.title = String(object.title);
        else message.title = "";
        if (object.description !== undefined && object.description !== null) message.description = String(object.description);
        else message.description = "";
        if (object.subjectClientId !== undefined && object.subjectClientId !== null) message.subjectClientId = String(object.subjectClientId);
        else message.subjectClientId = "";
        if (object.substituteClientId !== undefined && object.substituteClientId !== null) message.substituteClientId = String(object.substituteClientId);
        else message.substituteClientId = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.subjectClientId !== undefined && (obj.subjectClientId = message.subjectClientId);
        message.substituteClientId !== undefined && (obj.substituteClientId = message.substituteClientId);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $0677a0c68897ece8$var$baseClientUpdateProposal);
        if (object.title !== undefined && object.title !== null) message.title = object.title;
        else message.title = "";
        if (object.description !== undefined && object.description !== null) message.description = object.description;
        else message.description = "";
        if (object.subjectClientId !== undefined && object.subjectClientId !== null) message.subjectClientId = object.subjectClientId;
        else message.subjectClientId = "";
        if (object.substituteClientId !== undefined && object.substituteClientId !== null) message.substituteClientId = object.substituteClientId;
        else message.substituteClientId = "";
        return message;
    }
};
const $0677a0c68897ece8$var$baseUpgradeProposal = {
    title: "",
    description: ""
};
module.exports.UpgradeProposal = {
    encode (message, writer = $0677a0c68897ece8$var$minimal_1.default.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        if (message.plan !== undefined) $8MpMs.Plan.encode(message.plan, writer.uint32(26).fork()).ldelim();
        if (message.upgradedClientState !== undefined) $c5FxR.Any.encode(message.upgradedClientState, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0677a0c68897ece8$var$minimal_1.default.Reader ? input : new $0677a0c68897ece8$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $0677a0c68897ece8$var$baseUpgradeProposal);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.plan = $8MpMs.Plan.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.upgradedClientState = $c5FxR.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $0677a0c68897ece8$var$baseUpgradeProposal);
        if (object.title !== undefined && object.title !== null) message.title = String(object.title);
        else message.title = "";
        if (object.description !== undefined && object.description !== null) message.description = String(object.description);
        else message.description = "";
        if (object.plan !== undefined && object.plan !== null) message.plan = $8MpMs.Plan.fromJSON(object.plan);
        else message.plan = undefined;
        if (object.upgradedClientState !== undefined && object.upgradedClientState !== null) message.upgradedClientState = $c5FxR.Any.fromJSON(object.upgradedClientState);
        else message.upgradedClientState = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.plan !== undefined && (obj.plan = message.plan ? $8MpMs.Plan.toJSON(message.plan) : undefined);
        message.upgradedClientState !== undefined && (obj.upgradedClientState = message.upgradedClientState ? $c5FxR.Any.toJSON(message.upgradedClientState) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $0677a0c68897ece8$var$baseUpgradeProposal);
        if (object.title !== undefined && object.title !== null) message.title = object.title;
        else message.title = "";
        if (object.description !== undefined && object.description !== null) message.description = object.description;
        else message.description = "";
        if (object.plan !== undefined && object.plan !== null) message.plan = $8MpMs.Plan.fromPartial(object.plan);
        else message.plan = undefined;
        if (object.upgradedClientState !== undefined && object.upgradedClientState !== null) message.upgradedClientState = $c5FxR.Any.fromPartial(object.upgradedClientState);
        else message.upgradedClientState = undefined;
        return message;
    }
};
const $0677a0c68897ece8$var$baseHeight = {
    revisionNumber: $0677a0c68897ece8$var$long_1.default.UZERO,
    revisionHeight: $0677a0c68897ece8$var$long_1.default.UZERO
};
module.exports.Height = {
    encode (message, writer = $0677a0c68897ece8$var$minimal_1.default.Writer.create()) {
        if (!message.revisionNumber.isZero()) writer.uint32(8).uint64(message.revisionNumber);
        if (!message.revisionHeight.isZero()) writer.uint32(16).uint64(message.revisionHeight);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0677a0c68897ece8$var$minimal_1.default.Reader ? input : new $0677a0c68897ece8$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $0677a0c68897ece8$var$baseHeight);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.revisionNumber = reader.uint64();
                    break;
                case 2:
                    message.revisionHeight = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $0677a0c68897ece8$var$baseHeight);
        if (object.revisionNumber !== undefined && object.revisionNumber !== null) message.revisionNumber = $0677a0c68897ece8$var$long_1.default.fromString(object.revisionNumber);
        else message.revisionNumber = $0677a0c68897ece8$var$long_1.default.UZERO;
        if (object.revisionHeight !== undefined && object.revisionHeight !== null) message.revisionHeight = $0677a0c68897ece8$var$long_1.default.fromString(object.revisionHeight);
        else message.revisionHeight = $0677a0c68897ece8$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.revisionNumber !== undefined && (obj.revisionNumber = (message.revisionNumber || $0677a0c68897ece8$var$long_1.default.UZERO).toString());
        message.revisionHeight !== undefined && (obj.revisionHeight = (message.revisionHeight || $0677a0c68897ece8$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $0677a0c68897ece8$var$baseHeight);
        if (object.revisionNumber !== undefined && object.revisionNumber !== null) message.revisionNumber = object.revisionNumber;
        else message.revisionNumber = $0677a0c68897ece8$var$long_1.default.UZERO;
        if (object.revisionHeight !== undefined && object.revisionHeight !== null) message.revisionHeight = object.revisionHeight;
        else message.revisionHeight = $0677a0c68897ece8$var$long_1.default.UZERO;
        return message;
    }
};
const $0677a0c68897ece8$var$baseParams = {
    allowedClients: ""
};
module.exports.Params = {
    encode (message, writer = $0677a0c68897ece8$var$minimal_1.default.Writer.create()) {
        for (const v of message.allowedClients)writer.uint32(10).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0677a0c68897ece8$var$minimal_1.default.Reader ? input : new $0677a0c68897ece8$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $0677a0c68897ece8$var$baseParams);
        message.allowedClients = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.allowedClients.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $0677a0c68897ece8$var$baseParams);
        message.allowedClients = [];
        if (object.allowedClients !== undefined && object.allowedClients !== null) for (const e of object.allowedClients)message.allowedClients.push(String(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.allowedClients) obj.allowedClients = message.allowedClients.map((e)=>e);
        else obj.allowedClients = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $0677a0c68897ece8$var$baseParams);
        message.allowedClients = [];
        if (object.allowedClients !== undefined && object.allowedClients !== null) for (const e of object.allowedClients)message.allowedClients.push(e);
        return message;
    }
};
if ($0677a0c68897ece8$var$minimal_1.default.util.Long !== $0677a0c68897ece8$var$long_1.default) {
    $0677a0c68897ece8$var$minimal_1.default.util.Long = $0677a0c68897ece8$var$long_1.default;
    $0677a0c68897ece8$var$minimal_1.default.configure();
}

});
parcelRegister("8MpMs", function(module, exports) {
"use strict";
var $6646cdea0fece3f3$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ModuleVersion = module.exports.CancelSoftwareUpgradeProposal = module.exports.SoftwareUpgradeProposal = module.exports.Plan = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $6646cdea0fece3f3$var$long_1 = $6646cdea0fece3f3$var$__importDefault((parcelRequire("9A55m")));

const $6646cdea0fece3f3$var$minimal_1 = $6646cdea0fece3f3$var$__importDefault((parcelRequire("i2pIU")));

var $c5FxR = parcelRequire("c5FxR");

var $5G2s6 = parcelRequire("5G2s6");
module.exports.protobufPackage = "cosmos.upgrade.v1beta1";
const $6646cdea0fece3f3$var$basePlan = {
    name: "",
    height: $6646cdea0fece3f3$var$long_1.default.ZERO,
    info: ""
};
module.exports.Plan = {
    encode (message, writer = $6646cdea0fece3f3$var$minimal_1.default.Writer.create()) {
        if (message.name !== "") writer.uint32(10).string(message.name);
        if (message.time !== undefined) $5G2s6.Timestamp.encode($6646cdea0fece3f3$var$toTimestamp(message.time), writer.uint32(18).fork()).ldelim();
        if (!message.height.isZero()) writer.uint32(24).int64(message.height);
        if (message.info !== "") writer.uint32(34).string(message.info);
        if (message.upgradedClientState !== undefined) $c5FxR.Any.encode(message.upgradedClientState, writer.uint32(42).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6646cdea0fece3f3$var$minimal_1.default.Reader ? input : new $6646cdea0fece3f3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $6646cdea0fece3f3$var$basePlan);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.time = $6646cdea0fece3f3$var$fromTimestamp($5G2s6.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.height = reader.int64();
                    break;
                case 4:
                    message.info = reader.string();
                    break;
                case 5:
                    message.upgradedClientState = $c5FxR.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $6646cdea0fece3f3$var$basePlan);
        if (object.name !== undefined && object.name !== null) message.name = String(object.name);
        else message.name = "";
        if (object.time !== undefined && object.time !== null) message.time = $6646cdea0fece3f3$var$fromJsonTimestamp(object.time);
        else message.time = undefined;
        if (object.height !== undefined && object.height !== null) message.height = $6646cdea0fece3f3$var$long_1.default.fromString(object.height);
        else message.height = $6646cdea0fece3f3$var$long_1.default.ZERO;
        if (object.info !== undefined && object.info !== null) message.info = String(object.info);
        else message.info = "";
        if (object.upgradedClientState !== undefined && object.upgradedClientState !== null) message.upgradedClientState = $c5FxR.Any.fromJSON(object.upgradedClientState);
        else message.upgradedClientState = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.name !== undefined && (obj.name = message.name);
        message.time !== undefined && (obj.time = message.time.toISOString());
        message.height !== undefined && (obj.height = (message.height || $6646cdea0fece3f3$var$long_1.default.ZERO).toString());
        message.info !== undefined && (obj.info = message.info);
        message.upgradedClientState !== undefined && (obj.upgradedClientState = message.upgradedClientState ? $c5FxR.Any.toJSON(message.upgradedClientState) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $6646cdea0fece3f3$var$basePlan);
        if (object.name !== undefined && object.name !== null) message.name = object.name;
        else message.name = "";
        if (object.time !== undefined && object.time !== null) message.time = object.time;
        else message.time = undefined;
        if (object.height !== undefined && object.height !== null) message.height = object.height;
        else message.height = $6646cdea0fece3f3$var$long_1.default.ZERO;
        if (object.info !== undefined && object.info !== null) message.info = object.info;
        else message.info = "";
        if (object.upgradedClientState !== undefined && object.upgradedClientState !== null) message.upgradedClientState = $c5FxR.Any.fromPartial(object.upgradedClientState);
        else message.upgradedClientState = undefined;
        return message;
    }
};
const $6646cdea0fece3f3$var$baseSoftwareUpgradeProposal = {
    title: "",
    description: ""
};
module.exports.SoftwareUpgradeProposal = {
    encode (message, writer = $6646cdea0fece3f3$var$minimal_1.default.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        if (message.plan !== undefined) module.exports.Plan.encode(message.plan, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6646cdea0fece3f3$var$minimal_1.default.Reader ? input : new $6646cdea0fece3f3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $6646cdea0fece3f3$var$baseSoftwareUpgradeProposal);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.plan = module.exports.Plan.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $6646cdea0fece3f3$var$baseSoftwareUpgradeProposal);
        if (object.title !== undefined && object.title !== null) message.title = String(object.title);
        else message.title = "";
        if (object.description !== undefined && object.description !== null) message.description = String(object.description);
        else message.description = "";
        if (object.plan !== undefined && object.plan !== null) message.plan = module.exports.Plan.fromJSON(object.plan);
        else message.plan = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.plan !== undefined && (obj.plan = message.plan ? module.exports.Plan.toJSON(message.plan) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $6646cdea0fece3f3$var$baseSoftwareUpgradeProposal);
        if (object.title !== undefined && object.title !== null) message.title = object.title;
        else message.title = "";
        if (object.description !== undefined && object.description !== null) message.description = object.description;
        else message.description = "";
        if (object.plan !== undefined && object.plan !== null) message.plan = module.exports.Plan.fromPartial(object.plan);
        else message.plan = undefined;
        return message;
    }
};
const $6646cdea0fece3f3$var$baseCancelSoftwareUpgradeProposal = {
    title: "",
    description: ""
};
module.exports.CancelSoftwareUpgradeProposal = {
    encode (message, writer = $6646cdea0fece3f3$var$minimal_1.default.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6646cdea0fece3f3$var$minimal_1.default.Reader ? input : new $6646cdea0fece3f3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $6646cdea0fece3f3$var$baseCancelSoftwareUpgradeProposal);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $6646cdea0fece3f3$var$baseCancelSoftwareUpgradeProposal);
        if (object.title !== undefined && object.title !== null) message.title = String(object.title);
        else message.title = "";
        if (object.description !== undefined && object.description !== null) message.description = String(object.description);
        else message.description = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $6646cdea0fece3f3$var$baseCancelSoftwareUpgradeProposal);
        if (object.title !== undefined && object.title !== null) message.title = object.title;
        else message.title = "";
        if (object.description !== undefined && object.description !== null) message.description = object.description;
        else message.description = "";
        return message;
    }
};
const $6646cdea0fece3f3$var$baseModuleVersion = {
    name: "",
    version: $6646cdea0fece3f3$var$long_1.default.UZERO
};
module.exports.ModuleVersion = {
    encode (message, writer = $6646cdea0fece3f3$var$minimal_1.default.Writer.create()) {
        if (message.name !== "") writer.uint32(10).string(message.name);
        if (!message.version.isZero()) writer.uint32(16).uint64(message.version);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6646cdea0fece3f3$var$minimal_1.default.Reader ? input : new $6646cdea0fece3f3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $6646cdea0fece3f3$var$baseModuleVersion);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.version = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $6646cdea0fece3f3$var$baseModuleVersion);
        if (object.name !== undefined && object.name !== null) message.name = String(object.name);
        else message.name = "";
        if (object.version !== undefined && object.version !== null) message.version = $6646cdea0fece3f3$var$long_1.default.fromString(object.version);
        else message.version = $6646cdea0fece3f3$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.name !== undefined && (obj.name = message.name);
        message.version !== undefined && (obj.version = (message.version || $6646cdea0fece3f3$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $6646cdea0fece3f3$var$baseModuleVersion);
        if (object.name !== undefined && object.name !== null) message.name = object.name;
        else message.name = "";
        if (object.version !== undefined && object.version !== null) message.version = object.version;
        else message.version = $6646cdea0fece3f3$var$long_1.default.UZERO;
        return message;
    }
};
function $6646cdea0fece3f3$var$toTimestamp(date) {
    const seconds = $6646cdea0fece3f3$var$numberToLong(date.getTime() / 1000);
    const nanos = date.getTime() % 1000 * 1000000;
    return {
        seconds: seconds,
        nanos: nanos
    };
}
function $6646cdea0fece3f3$var$fromTimestamp(t) {
    let millis = t.seconds.toNumber() * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function $6646cdea0fece3f3$var$fromJsonTimestamp(o) {
    if (o instanceof Date) return o;
    else if (typeof o === "string") return new Date(o);
    else return $6646cdea0fece3f3$var$fromTimestamp($5G2s6.Timestamp.fromJSON(o));
}
function $6646cdea0fece3f3$var$numberToLong(number) {
    return $6646cdea0fece3f3$var$long_1.default.fromNumber(number);
}
if ($6646cdea0fece3f3$var$minimal_1.default.util.Long !== $6646cdea0fece3f3$var$long_1.default) {
    $6646cdea0fece3f3$var$minimal_1.default.util.Long = $6646cdea0fece3f3$var$long_1.default;
    $6646cdea0fece3f3$var$minimal_1.default.configure();
}

});




parcelRegister("4BeEE", function(module, exports) {
"use strict";
var $3595fc371c46fb8b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3595fc371c46fb8b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $3595fc371c46fb8b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$3595fc371c46fb8b$var$__exportStar((parcelRequire("7j1Ig")), module.exports);

});
parcelRegister("7j1Ig", function(module, exports) {
"use strict";
var $551ba2e8fd5eb1dd$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TextProposal = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $9q3yq = parcelRequire("9q3yq");
/**
 * Basic proposal which describes the candidate proposition that must be put into effect
 * manually if passed. Used as a general-purpose way of discovering community's
 * sentiment / interest for an arbitrary change.
 */ var $551ba2e8fd5eb1dd$var$TextProposal = /** @class */ function(_super) {
    $551ba2e8fd5eb1dd$var$__extends(TextProposal, _super);
    /**
     * @param title proposal's title
     * @param description proposal's description
     */ function TextProposal(title, description) {
        var _this = _super.call(this) || this;
        _this.title = title;
        _this.description = description;
        return _this;
    }
    TextProposal.fromAmino = function(data, _) {
        _;
        var _a = data.value, title = _a.title, description = _a.description;
        return new TextProposal(title, description);
    };
    TextProposal.prototype.toAmino = function(isClassic) {
        var _a = this, title = _a.title, description = _a.description;
        return {
            type: isClassic ? "gov/TextProposal" : "cosmos-sdk/TextProposal",
            value: {
                title: title,
                description: description
            }
        };
    };
    TextProposal.fromData = function(proto, _) {
        _;
        var title = proto.title, description = proto.description;
        return new TextProposal(title, description);
    };
    TextProposal.prototype.toData = function(_) {
        _;
        var _a = this, title = _a.title, description = _a.description;
        return {
            "@type": "/cosmos.gov.v1beta1.TextProposal",
            title: title,
            description: description
        };
    };
    TextProposal.fromProto = function(proto, _) {
        _;
        return new TextProposal(proto.title, proto.description);
    };
    TextProposal.prototype.toProto = function(_) {
        _;
        var _a = this, title = _a.title, description = _a.description;
        return $9q3yq.TextProposal.fromPartial({
            description: description,
            title: title
        });
    };
    TextProposal.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmos.gov.v1beta1.TextProposal",
            value: $9q3yq.TextProposal.encode(this.toProto(isClassic)).finish()
        });
    };
    TextProposal.unpackAny = function(msgAny, isClassic) {
        return TextProposal.fromProto($9q3yq.TextProposal.decode(msgAny.value), isClassic);
    };
    return TextProposal;
}($26Eqx.JSONSerializable);
module.exports.TextProposal = $551ba2e8fd5eb1dd$var$TextProposal;

});


parcelRegister("eTRTS", function(module, exports) {
"use strict";
var $ad90033a6e67e005$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ad90033a6e67e005$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ad90033a6e67e005$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$ad90033a6e67e005$var$__exportStar((parcelRequire("afnZx")), module.exports);

$ad90033a6e67e005$var$__exportStar((parcelRequire("12FhC")), module.exports);

});
parcelRegister("afnZx", function(module, exports) {
"use strict";
var $775dea5493650cb8$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SoftwareUpgradeProposal = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $8MpMs = parcelRequire("8MpMs");

var $5xVNE = parcelRequire("5xVNE");
/**
 * Softwareupgradeproposal is a gov Content type for initiating a software upgrade.
 */ var $775dea5493650cb8$var$SoftwareUpgradeProposal = /** @class */ function(_super) {
    $775dea5493650cb8$var$__extends(SoftwareUpgradeProposal, _super);
    /**
     *
     * @param title
     * @param description
     * @param plan
     */ function SoftwareUpgradeProposal(title, description, plan) {
        var _this = _super.call(this) || this;
        _this.title = title;
        _this.description = description;
        _this.plan = plan;
        return _this;
    }
    SoftwareUpgradeProposal.fromAmino = function(data, _) {
        _;
        var _a = data.value, title = _a.title, description = _a.description, plan = _a.plan;
        return new SoftwareUpgradeProposal(title, description, plan ? $5xVNE.Plan.fromAmino(plan) : undefined);
    };
    SoftwareUpgradeProposal.prototype.toAmino = function(isClassic) {
        var _a = this, title = _a.title, description = _a.description, plan = _a.plan;
        return {
            type: isClassic ? "upgrade/SoftwareUpgradeProposal" : "cosmos-sdk/SoftwareUpgradeProposal",
            value: {
                title: title,
                description: description,
                plan: plan ? plan.toAmino() : undefined
            }
        };
    };
    SoftwareUpgradeProposal.fromData = function(data, _) {
        _;
        var title = data.title, description = data.description, plan = data.plan;
        return new SoftwareUpgradeProposal(title, description, plan ? $5xVNE.Plan.fromData(plan) : undefined);
    };
    SoftwareUpgradeProposal.prototype.toData = function(_) {
        _;
        var _a = this, title = _a.title, description = _a.description, plan = _a.plan;
        return {
            "@type": "/cosmos.upgrade.v1beta1.SoftwareUpgradeProposal",
            title: title,
            description: description,
            plan: plan ? plan.toData() : undefined
        };
    };
    SoftwareUpgradeProposal.fromProto = function(proto, _) {
        _;
        return new SoftwareUpgradeProposal(proto.title, proto.description, proto.plan ? $5xVNE.Plan.fromProto(proto.plan) : undefined);
    };
    SoftwareUpgradeProposal.prototype.toProto = function(_) {
        _;
        var _a = this, title = _a.title, description = _a.description, plan = _a.plan;
        return $8MpMs.SoftwareUpgradeProposal.fromPartial({
            title: title,
            description: description,
            plan: plan ? plan.toProto() : undefined
        });
    };
    SoftwareUpgradeProposal.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmos.upgrade.v1beta1.SoftwareUpgradeProposal",
            value: $8MpMs.SoftwareUpgradeProposal.encode(this.toProto(isClassic)).finish()
        });
    };
    SoftwareUpgradeProposal.unpackAny = function(msgAny, isClassic) {
        return SoftwareUpgradeProposal.fromProto($8MpMs.SoftwareUpgradeProposal.decode(msgAny.value), isClassic);
    };
    return SoftwareUpgradeProposal;
}($26Eqx.JSONSerializable);
module.exports.SoftwareUpgradeProposal = $775dea5493650cb8$var$SoftwareUpgradeProposal;

});
parcelRegister("5xVNE", function(module, exports) {
"use strict";
var $409cdea83fc587d3$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $409cdea83fc587d3$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Plan = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $8MpMs = parcelRequire("8MpMs");

var $409cdea83fc587d3$var$long_1 = $409cdea83fc587d3$var$__importDefault((parcelRequire("9A55m")));
/*
 * Plan specifies information about a planned upgrade and when it should occur.
 */ var $409cdea83fc587d3$var$Plan = /** @class */ function(_super) {
    $409cdea83fc587d3$var$__extends(Plan, _super);
    /**
     * @param name This name will be used by the upgraded  version of the software to apply any special "on-upgrade" commands during the first BeginBlock method after the upgrade is applied.
     * @param time Deprecated
     * @param height  The height at which the upgrade must be performed. Only used if Time is not set.
     * @param info Any application specific upgrade info to be included on-chain such as a git commit that validators could automatically upgrade to
     * @param upgraded_client_state Deprecated
     */ function Plan(name, time, height, info, upgraded_client_state) {
        var _this = _super.call(this) || this;
        _this.name = name;
        _this.time = time;
        _this.height = height;
        _this.info = info;
        _this.upgraded_client_state = upgraded_client_state;
        return _this;
    }
    Plan.fromAmino = function(data) {
        var name = data.name, time = data.time, height = data.height, info = data.info, upgraded_client_state = data.upgraded_client_state;
        return new Plan(name, time ? new Date(time) : undefined, height, info, upgraded_client_state);
    };
    Plan.prototype.toAmino = function() {
        var _a = this, name = _a.name, time = _a.time, height = _a.height, info = _a.info, upgraded_client_state = _a.upgraded_client_state;
        var res = {
            name: name,
            time: time ? time.toISOString().replace(/\.000Z$/, "Z") : undefined,
            height: height,
            info: info,
            upgraded_client_state: upgraded_client_state
        };
        return res;
    };
    Plan.fromData = function(data) {
        var name = data.name, time = data.time, height = data.height, info = data.info, upgraded_client_state = data.upgraded_client_state;
        return new Plan(name, time ? new Date(time) : undefined, height, info, upgraded_client_state);
    };
    Plan.prototype.toData = function() {
        var _a = this, name = _a.name, time = _a.time, height = _a.height, info = _a.info, upgraded_client_state = _a.upgraded_client_state;
        var res = {
            name: name,
            time: time ? time.toISOString().replace(/\.000Z$/, "Z") : undefined,
            height: height,
            info: info,
            upgraded_client_state: upgraded_client_state
        };
        return res;
    };
    Plan.fromProto = function(proto) {
        return new Plan(proto.name, proto.time, proto.height.toString(), proto.info, proto.upgradedClientState);
    };
    Plan.prototype.toProto = function() {
        var _a = this, name = _a.name, time = _a.time, height = _a.height, info = _a.info, upgraded_client_state = _a.upgraded_client_state;
        return $8MpMs.Plan.fromPartial({
            name: name,
            time: time,
            height: $409cdea83fc587d3$var$long_1.default.fromString(height),
            info: info,
            upgradedClientState: upgraded_client_state
        });
    };
    return Plan;
}($26Eqx.JSONSerializable);
module.exports.Plan = $409cdea83fc587d3$var$Plan;

});


parcelRegister("12FhC", function(module, exports) {
"use strict";
var $0c2600533fd0f157$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CancelSoftwareUpgradeProposal = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $8MpMs = parcelRequire("8MpMs");
/**
 *  CancelSoftwareUpgradeProposal is a gov Content type for cancelling a software upgrade
 */ var $0c2600533fd0f157$var$CancelSoftwareUpgradeProposal = /** @class */ function(_super) {
    $0c2600533fd0f157$var$__extends(CancelSoftwareUpgradeProposal, _super);
    /**
     *
     * @param title
     * @param description
     */ function CancelSoftwareUpgradeProposal(title, description) {
        var _this = _super.call(this) || this;
        _this.title = title;
        _this.description = description;
        return _this;
    }
    CancelSoftwareUpgradeProposal.fromAmino = function(data, _) {
        _;
        var _a = data.value, title = _a.title, description = _a.description;
        return new CancelSoftwareUpgradeProposal(title, description);
    };
    CancelSoftwareUpgradeProposal.prototype.toAmino = function(isClassic) {
        var _a = this, title = _a.title, description = _a.description;
        return {
            type: isClassic ? "upgrade/CancelSoftwareUpgradeProposal" : "cosmos-sdk/CancelSoftwareUpgradeProposal",
            value: {
                title: title,
                description: description
            }
        };
    };
    CancelSoftwareUpgradeProposal.fromData = function(data, _) {
        _;
        var title = data.title, description = data.description;
        return new CancelSoftwareUpgradeProposal(title, description);
    };
    CancelSoftwareUpgradeProposal.prototype.toData = function(_) {
        _;
        var _a = this, title = _a.title, description = _a.description;
        return {
            "@type": "/cosmos.upgrade.v1beta1.CancelSoftwareUpgradeProposal",
            title: title,
            description: description
        };
    };
    CancelSoftwareUpgradeProposal.fromProto = function(proto, _) {
        _;
        return new CancelSoftwareUpgradeProposal(proto.title, proto.description);
    };
    CancelSoftwareUpgradeProposal.prototype.toProto = function(_) {
        _;
        var _a = this, title = _a.title, description = _a.description;
        return $8MpMs.CancelSoftwareUpgradeProposal.fromPartial({
            title: title,
            description: description
        });
    };
    CancelSoftwareUpgradeProposal.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmos.upgrade.v1beta1.CancelSoftwareUpgradeProposal",
            value: $8MpMs.CancelSoftwareUpgradeProposal.encode(this.toProto(isClassic)).finish()
        });
    };
    CancelSoftwareUpgradeProposal.unpackAny = function(msgAny, isClassic) {
        return CancelSoftwareUpgradeProposal.fromProto($8MpMs.CancelSoftwareUpgradeProposal.decode(msgAny.value), isClassic);
    };
    return CancelSoftwareUpgradeProposal;
}($26Eqx.JSONSerializable);
module.exports.CancelSoftwareUpgradeProposal = $0c2600533fd0f157$var$CancelSoftwareUpgradeProposal;

});


parcelRegister("k0M3i", function(module, exports) {
"use strict";
var $e91914e3dba57b85$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e91914e3dba57b85$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e91914e3dba57b85$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$e91914e3dba57b85$var$__exportStar((parcelRequire("kpAEt")), module.exports);

$e91914e3dba57b85$var$__exportStar((parcelRequire("2OYhI")), module.exports);

$e91914e3dba57b85$var$__exportStar((parcelRequire("c6QJW")), module.exports);

$e91914e3dba57b85$var$__exportStar((parcelRequire("dspMZ")), module.exports);

$e91914e3dba57b85$var$__exportStar((parcelRequire("8rxuM")), module.exports);

$e91914e3dba57b85$var$__exportStar((parcelRequire("1mqc3")), module.exports);

$e91914e3dba57b85$var$__exportStar((parcelRequire("eNZVt")), module.exports);

$e91914e3dba57b85$var$__exportStar((parcelRequire("bCCbj")), module.exports);

$e91914e3dba57b85$var$__exportStar((parcelRequire("9bzUa")), module.exports);

$e91914e3dba57b85$var$__exportStar((parcelRequire("3JSOZ")), module.exports);

});
parcelRegister("kpAEt", function(module, exports) {
"use strict";
var $edc292b823f9f920$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ClearAdminProposal = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $dnKf8 = parcelRequire("dnKf8");
/**
 * ClearAdminProposal gov proposal content type to clear the admin of a
 * contract.
 */ var $edc292b823f9f920$var$ClearAdminProposal = /** @class */ function(_super) {
    $edc292b823f9f920$var$__extends(ClearAdminProposal, _super);
    /**
     * @param title a short summary
     * @param description a human readable text
     * @param contract the address of the smart contract
     */ function ClearAdminProposal(title, description, contract) {
        var _this = _super.call(this) || this;
        _this.title = title;
        _this.description = description;
        _this.contract = contract;
        return _this;
    }
    ClearAdminProposal.fromAmino = function(data, _) {
        var _a = data.value, title = _a.title, description = _a.description, contract = _a.contract;
        return new ClearAdminProposal(title, description, contract);
    };
    ClearAdminProposal.prototype.toAmino = function(_) {
        var _a = this, title = _a.title, description = _a.description, contract = _a.contract;
        return {
            type: "wasm/ClearAdminProposal",
            value: {
                title: title,
                description: description,
                contract: contract
            }
        };
    };
    ClearAdminProposal.fromProto = function(proto, _) {
        return new ClearAdminProposal(proto.title, proto.description, proto.contract);
    };
    ClearAdminProposal.prototype.toProto = function(_) {
        var _a = this, title = _a.title, description = _a.description, contract = _a.contract;
        return $dnKf8.ClearAdminProposal.fromPartial({
            title: title,
            description: description,
            contract: contract
        });
    };
    ClearAdminProposal.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmwasm.wasm.v1.ClearAdminProposal",
            value: $dnKf8.ClearAdminProposal.encode(this.toProto(isClassic)).finish()
        });
    };
    ClearAdminProposal.unpackAny = function(msgAny, isClassic) {
        return ClearAdminProposal.fromProto($dnKf8.ClearAdminProposal.decode(msgAny.value), isClassic);
    };
    ClearAdminProposal.fromData = function(data, _) {
        var _a = data, title = _a.title, description = _a.description, contract = _a.contract;
        return new ClearAdminProposal(title, description, contract);
    };
    ClearAdminProposal.prototype.toData = function(_) {
        var _a = this, title = _a.title, description = _a.description, contract = _a.contract;
        return {
            "@type": "/cosmwasm.wasm.v1.ClearAdminProposal",
            title: title,
            description: description,
            contract: contract
        };
    };
    return ClearAdminProposal;
}($26Eqx.JSONSerializable);
module.exports.ClearAdminProposal = $edc292b823f9f920$var$ClearAdminProposal;

});
parcelRegister("dnKf8", function(module, exports) {
"use strict";
var $9be14b4116ccd2c2$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UpdateInstantiateConfigProposal = module.exports.AccessConfigUpdate = module.exports.UnpinCodesProposal = module.exports.PinCodesProposal = module.exports.ClearAdminProposal = module.exports.UpdateAdminProposal = module.exports.ExecuteContractProposal = module.exports.SudoContractProposal = module.exports.MigrateContractProposal = module.exports.InstantiateContractProposal = module.exports.StoreCodeProposal = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $9be14b4116ccd2c2$var$long_1 = $9be14b4116ccd2c2$var$__importDefault((parcelRequire("9A55m")));

const $9be14b4116ccd2c2$var$minimal_1 = $9be14b4116ccd2c2$var$__importDefault((parcelRequire("i2pIU")));

var $odsVG = parcelRequire("odsVG");

var $lPVUQ = parcelRequire("lPVUQ");
module.exports.protobufPackage = "cosmwasm.wasm.v1";
const $9be14b4116ccd2c2$var$baseStoreCodeProposal = {
    title: "",
    description: "",
    runAs: ""
};
module.exports.StoreCodeProposal = {
    encode (message, writer = $9be14b4116ccd2c2$var$minimal_1.default.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        if (message.runAs !== "") writer.uint32(26).string(message.runAs);
        if (message.wasmByteCode.length !== 0) writer.uint32(34).bytes(message.wasmByteCode);
        if (message.instantiatePermission !== undefined) $odsVG.AccessConfig.encode(message.instantiatePermission, writer.uint32(58).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9be14b4116ccd2c2$var$minimal_1.default.Reader ? input : new $9be14b4116ccd2c2$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9be14b4116ccd2c2$var$baseStoreCodeProposal);
        message.wasmByteCode = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.runAs = reader.string();
                    break;
                case 4:
                    message.wasmByteCode = reader.bytes();
                    break;
                case 7:
                    message.instantiatePermission = $odsVG.AccessConfig.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9be14b4116ccd2c2$var$baseStoreCodeProposal);
        message.wasmByteCode = new Uint8Array();
        if (object.title !== undefined && object.title !== null) message.title = String(object.title);
        else message.title = "";
        if (object.description !== undefined && object.description !== null) message.description = String(object.description);
        else message.description = "";
        if (object.runAs !== undefined && object.runAs !== null) message.runAs = String(object.runAs);
        else message.runAs = "";
        if (object.wasmByteCode !== undefined && object.wasmByteCode !== null) message.wasmByteCode = $9be14b4116ccd2c2$var$bytesFromBase64(object.wasmByteCode);
        if (object.instantiatePermission !== undefined && object.instantiatePermission !== null) message.instantiatePermission = $odsVG.AccessConfig.fromJSON(object.instantiatePermission);
        else message.instantiatePermission = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.runAs !== undefined && (obj.runAs = message.runAs);
        message.wasmByteCode !== undefined && (obj.wasmByteCode = $9be14b4116ccd2c2$var$base64FromBytes(message.wasmByteCode !== undefined ? message.wasmByteCode : new Uint8Array()));
        message.instantiatePermission !== undefined && (obj.instantiatePermission = message.instantiatePermission ? $odsVG.AccessConfig.toJSON(message.instantiatePermission) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9be14b4116ccd2c2$var$baseStoreCodeProposal);
        if (object.title !== undefined && object.title !== null) message.title = object.title;
        else message.title = "";
        if (object.description !== undefined && object.description !== null) message.description = object.description;
        else message.description = "";
        if (object.runAs !== undefined && object.runAs !== null) message.runAs = object.runAs;
        else message.runAs = "";
        if (object.wasmByteCode !== undefined && object.wasmByteCode !== null) message.wasmByteCode = object.wasmByteCode;
        else message.wasmByteCode = new Uint8Array();
        if (object.instantiatePermission !== undefined && object.instantiatePermission !== null) message.instantiatePermission = $odsVG.AccessConfig.fromPartial(object.instantiatePermission);
        else message.instantiatePermission = undefined;
        return message;
    }
};
const $9be14b4116ccd2c2$var$baseInstantiateContractProposal = {
    title: "",
    description: "",
    runAs: "",
    admin: "",
    codeId: $9be14b4116ccd2c2$var$long_1.default.UZERO,
    label: ""
};
module.exports.InstantiateContractProposal = {
    encode (message, writer = $9be14b4116ccd2c2$var$minimal_1.default.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        if (message.runAs !== "") writer.uint32(26).string(message.runAs);
        if (message.admin !== "") writer.uint32(34).string(message.admin);
        if (!message.codeId.isZero()) writer.uint32(40).uint64(message.codeId);
        if (message.label !== "") writer.uint32(50).string(message.label);
        if (message.msg.length !== 0) writer.uint32(58).bytes(message.msg);
        for (const v of message.funds)$lPVUQ.Coin.encode(v, writer.uint32(66).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9be14b4116ccd2c2$var$minimal_1.default.Reader ? input : new $9be14b4116ccd2c2$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9be14b4116ccd2c2$var$baseInstantiateContractProposal);
        message.funds = [];
        message.msg = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.runAs = reader.string();
                    break;
                case 4:
                    message.admin = reader.string();
                    break;
                case 5:
                    message.codeId = reader.uint64();
                    break;
                case 6:
                    message.label = reader.string();
                    break;
                case 7:
                    message.msg = reader.bytes();
                    break;
                case 8:
                    message.funds.push($lPVUQ.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9be14b4116ccd2c2$var$baseInstantiateContractProposal);
        message.funds = [];
        message.msg = new Uint8Array();
        if (object.title !== undefined && object.title !== null) message.title = String(object.title);
        else message.title = "";
        if (object.description !== undefined && object.description !== null) message.description = String(object.description);
        else message.description = "";
        if (object.runAs !== undefined && object.runAs !== null) message.runAs = String(object.runAs);
        else message.runAs = "";
        if (object.admin !== undefined && object.admin !== null) message.admin = String(object.admin);
        else message.admin = "";
        if (object.codeId !== undefined && object.codeId !== null) message.codeId = $9be14b4116ccd2c2$var$long_1.default.fromString(object.codeId);
        else message.codeId = $9be14b4116ccd2c2$var$long_1.default.UZERO;
        if (object.label !== undefined && object.label !== null) message.label = String(object.label);
        else message.label = "";
        if (object.msg !== undefined && object.msg !== null) message.msg = $9be14b4116ccd2c2$var$bytesFromBase64(object.msg);
        if (object.funds !== undefined && object.funds !== null) for (const e of object.funds)message.funds.push($lPVUQ.Coin.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.runAs !== undefined && (obj.runAs = message.runAs);
        message.admin !== undefined && (obj.admin = message.admin);
        message.codeId !== undefined && (obj.codeId = (message.codeId || $9be14b4116ccd2c2$var$long_1.default.UZERO).toString());
        message.label !== undefined && (obj.label = message.label);
        message.msg !== undefined && (obj.msg = $9be14b4116ccd2c2$var$base64FromBytes(message.msg !== undefined ? message.msg : new Uint8Array()));
        if (message.funds) obj.funds = message.funds.map((e)=>e ? $lPVUQ.Coin.toJSON(e) : undefined);
        else obj.funds = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9be14b4116ccd2c2$var$baseInstantiateContractProposal);
        message.funds = [];
        if (object.title !== undefined && object.title !== null) message.title = object.title;
        else message.title = "";
        if (object.description !== undefined && object.description !== null) message.description = object.description;
        else message.description = "";
        if (object.runAs !== undefined && object.runAs !== null) message.runAs = object.runAs;
        else message.runAs = "";
        if (object.admin !== undefined && object.admin !== null) message.admin = object.admin;
        else message.admin = "";
        if (object.codeId !== undefined && object.codeId !== null) message.codeId = object.codeId;
        else message.codeId = $9be14b4116ccd2c2$var$long_1.default.UZERO;
        if (object.label !== undefined && object.label !== null) message.label = object.label;
        else message.label = "";
        if (object.msg !== undefined && object.msg !== null) message.msg = object.msg;
        else message.msg = new Uint8Array();
        if (object.funds !== undefined && object.funds !== null) for (const e of object.funds)message.funds.push($lPVUQ.Coin.fromPartial(e));
        return message;
    }
};
const $9be14b4116ccd2c2$var$baseMigrateContractProposal = {
    title: "",
    description: "",
    contract: "",
    codeId: $9be14b4116ccd2c2$var$long_1.default.UZERO
};
module.exports.MigrateContractProposal = {
    encode (message, writer = $9be14b4116ccd2c2$var$minimal_1.default.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        if (message.contract !== "") writer.uint32(34).string(message.contract);
        if (!message.codeId.isZero()) writer.uint32(40).uint64(message.codeId);
        if (message.msg.length !== 0) writer.uint32(50).bytes(message.msg);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9be14b4116ccd2c2$var$minimal_1.default.Reader ? input : new $9be14b4116ccd2c2$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9be14b4116ccd2c2$var$baseMigrateContractProposal);
        message.msg = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 4:
                    message.contract = reader.string();
                    break;
                case 5:
                    message.codeId = reader.uint64();
                    break;
                case 6:
                    message.msg = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9be14b4116ccd2c2$var$baseMigrateContractProposal);
        message.msg = new Uint8Array();
        if (object.title !== undefined && object.title !== null) message.title = String(object.title);
        else message.title = "";
        if (object.description !== undefined && object.description !== null) message.description = String(object.description);
        else message.description = "";
        if (object.contract !== undefined && object.contract !== null) message.contract = String(object.contract);
        else message.contract = "";
        if (object.codeId !== undefined && object.codeId !== null) message.codeId = $9be14b4116ccd2c2$var$long_1.default.fromString(object.codeId);
        else message.codeId = $9be14b4116ccd2c2$var$long_1.default.UZERO;
        if (object.msg !== undefined && object.msg !== null) message.msg = $9be14b4116ccd2c2$var$bytesFromBase64(object.msg);
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.contract !== undefined && (obj.contract = message.contract);
        message.codeId !== undefined && (obj.codeId = (message.codeId || $9be14b4116ccd2c2$var$long_1.default.UZERO).toString());
        message.msg !== undefined && (obj.msg = $9be14b4116ccd2c2$var$base64FromBytes(message.msg !== undefined ? message.msg : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9be14b4116ccd2c2$var$baseMigrateContractProposal);
        if (object.title !== undefined && object.title !== null) message.title = object.title;
        else message.title = "";
        if (object.description !== undefined && object.description !== null) message.description = object.description;
        else message.description = "";
        if (object.contract !== undefined && object.contract !== null) message.contract = object.contract;
        else message.contract = "";
        if (object.codeId !== undefined && object.codeId !== null) message.codeId = object.codeId;
        else message.codeId = $9be14b4116ccd2c2$var$long_1.default.UZERO;
        if (object.msg !== undefined && object.msg !== null) message.msg = object.msg;
        else message.msg = new Uint8Array();
        return message;
    }
};
const $9be14b4116ccd2c2$var$baseSudoContractProposal = {
    title: "",
    description: "",
    contract: ""
};
module.exports.SudoContractProposal = {
    encode (message, writer = $9be14b4116ccd2c2$var$minimal_1.default.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        if (message.contract !== "") writer.uint32(26).string(message.contract);
        if (message.msg.length !== 0) writer.uint32(34).bytes(message.msg);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9be14b4116ccd2c2$var$minimal_1.default.Reader ? input : new $9be14b4116ccd2c2$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9be14b4116ccd2c2$var$baseSudoContractProposal);
        message.msg = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.contract = reader.string();
                    break;
                case 4:
                    message.msg = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9be14b4116ccd2c2$var$baseSudoContractProposal);
        message.msg = new Uint8Array();
        if (object.title !== undefined && object.title !== null) message.title = String(object.title);
        else message.title = "";
        if (object.description !== undefined && object.description !== null) message.description = String(object.description);
        else message.description = "";
        if (object.contract !== undefined && object.contract !== null) message.contract = String(object.contract);
        else message.contract = "";
        if (object.msg !== undefined && object.msg !== null) message.msg = $9be14b4116ccd2c2$var$bytesFromBase64(object.msg);
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.contract !== undefined && (obj.contract = message.contract);
        message.msg !== undefined && (obj.msg = $9be14b4116ccd2c2$var$base64FromBytes(message.msg !== undefined ? message.msg : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9be14b4116ccd2c2$var$baseSudoContractProposal);
        if (object.title !== undefined && object.title !== null) message.title = object.title;
        else message.title = "";
        if (object.description !== undefined && object.description !== null) message.description = object.description;
        else message.description = "";
        if (object.contract !== undefined && object.contract !== null) message.contract = object.contract;
        else message.contract = "";
        if (object.msg !== undefined && object.msg !== null) message.msg = object.msg;
        else message.msg = new Uint8Array();
        return message;
    }
};
const $9be14b4116ccd2c2$var$baseExecuteContractProposal = {
    title: "",
    description: "",
    runAs: "",
    contract: ""
};
module.exports.ExecuteContractProposal = {
    encode (message, writer = $9be14b4116ccd2c2$var$minimal_1.default.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        if (message.runAs !== "") writer.uint32(26).string(message.runAs);
        if (message.contract !== "") writer.uint32(34).string(message.contract);
        if (message.msg.length !== 0) writer.uint32(42).bytes(message.msg);
        for (const v of message.funds)$lPVUQ.Coin.encode(v, writer.uint32(50).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9be14b4116ccd2c2$var$minimal_1.default.Reader ? input : new $9be14b4116ccd2c2$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9be14b4116ccd2c2$var$baseExecuteContractProposal);
        message.funds = [];
        message.msg = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.runAs = reader.string();
                    break;
                case 4:
                    message.contract = reader.string();
                    break;
                case 5:
                    message.msg = reader.bytes();
                    break;
                case 6:
                    message.funds.push($lPVUQ.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9be14b4116ccd2c2$var$baseExecuteContractProposal);
        message.funds = [];
        message.msg = new Uint8Array();
        if (object.title !== undefined && object.title !== null) message.title = String(object.title);
        else message.title = "";
        if (object.description !== undefined && object.description !== null) message.description = String(object.description);
        else message.description = "";
        if (object.runAs !== undefined && object.runAs !== null) message.runAs = String(object.runAs);
        else message.runAs = "";
        if (object.contract !== undefined && object.contract !== null) message.contract = String(object.contract);
        else message.contract = "";
        if (object.msg !== undefined && object.msg !== null) message.msg = $9be14b4116ccd2c2$var$bytesFromBase64(object.msg);
        if (object.funds !== undefined && object.funds !== null) for (const e of object.funds)message.funds.push($lPVUQ.Coin.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.runAs !== undefined && (obj.runAs = message.runAs);
        message.contract !== undefined && (obj.contract = message.contract);
        message.msg !== undefined && (obj.msg = $9be14b4116ccd2c2$var$base64FromBytes(message.msg !== undefined ? message.msg : new Uint8Array()));
        if (message.funds) obj.funds = message.funds.map((e)=>e ? $lPVUQ.Coin.toJSON(e) : undefined);
        else obj.funds = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9be14b4116ccd2c2$var$baseExecuteContractProposal);
        message.funds = [];
        if (object.title !== undefined && object.title !== null) message.title = object.title;
        else message.title = "";
        if (object.description !== undefined && object.description !== null) message.description = object.description;
        else message.description = "";
        if (object.runAs !== undefined && object.runAs !== null) message.runAs = object.runAs;
        else message.runAs = "";
        if (object.contract !== undefined && object.contract !== null) message.contract = object.contract;
        else message.contract = "";
        if (object.msg !== undefined && object.msg !== null) message.msg = object.msg;
        else message.msg = new Uint8Array();
        if (object.funds !== undefined && object.funds !== null) for (const e of object.funds)message.funds.push($lPVUQ.Coin.fromPartial(e));
        return message;
    }
};
const $9be14b4116ccd2c2$var$baseUpdateAdminProposal = {
    title: "",
    description: "",
    newAdmin: "",
    contract: ""
};
module.exports.UpdateAdminProposal = {
    encode (message, writer = $9be14b4116ccd2c2$var$minimal_1.default.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        if (message.newAdmin !== "") writer.uint32(26).string(message.newAdmin);
        if (message.contract !== "") writer.uint32(34).string(message.contract);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9be14b4116ccd2c2$var$minimal_1.default.Reader ? input : new $9be14b4116ccd2c2$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9be14b4116ccd2c2$var$baseUpdateAdminProposal);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.newAdmin = reader.string();
                    break;
                case 4:
                    message.contract = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9be14b4116ccd2c2$var$baseUpdateAdminProposal);
        if (object.title !== undefined && object.title !== null) message.title = String(object.title);
        else message.title = "";
        if (object.description !== undefined && object.description !== null) message.description = String(object.description);
        else message.description = "";
        if (object.newAdmin !== undefined && object.newAdmin !== null) message.newAdmin = String(object.newAdmin);
        else message.newAdmin = "";
        if (object.contract !== undefined && object.contract !== null) message.contract = String(object.contract);
        else message.contract = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.newAdmin !== undefined && (obj.newAdmin = message.newAdmin);
        message.contract !== undefined && (obj.contract = message.contract);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9be14b4116ccd2c2$var$baseUpdateAdminProposal);
        if (object.title !== undefined && object.title !== null) message.title = object.title;
        else message.title = "";
        if (object.description !== undefined && object.description !== null) message.description = object.description;
        else message.description = "";
        if (object.newAdmin !== undefined && object.newAdmin !== null) message.newAdmin = object.newAdmin;
        else message.newAdmin = "";
        if (object.contract !== undefined && object.contract !== null) message.contract = object.contract;
        else message.contract = "";
        return message;
    }
};
const $9be14b4116ccd2c2$var$baseClearAdminProposal = {
    title: "",
    description: "",
    contract: ""
};
module.exports.ClearAdminProposal = {
    encode (message, writer = $9be14b4116ccd2c2$var$minimal_1.default.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        if (message.contract !== "") writer.uint32(26).string(message.contract);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9be14b4116ccd2c2$var$minimal_1.default.Reader ? input : new $9be14b4116ccd2c2$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9be14b4116ccd2c2$var$baseClearAdminProposal);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.contract = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9be14b4116ccd2c2$var$baseClearAdminProposal);
        if (object.title !== undefined && object.title !== null) message.title = String(object.title);
        else message.title = "";
        if (object.description !== undefined && object.description !== null) message.description = String(object.description);
        else message.description = "";
        if (object.contract !== undefined && object.contract !== null) message.contract = String(object.contract);
        else message.contract = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.contract !== undefined && (obj.contract = message.contract);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9be14b4116ccd2c2$var$baseClearAdminProposal);
        if (object.title !== undefined && object.title !== null) message.title = object.title;
        else message.title = "";
        if (object.description !== undefined && object.description !== null) message.description = object.description;
        else message.description = "";
        if (object.contract !== undefined && object.contract !== null) message.contract = object.contract;
        else message.contract = "";
        return message;
    }
};
const $9be14b4116ccd2c2$var$basePinCodesProposal = {
    title: "",
    description: "",
    codeIds: $9be14b4116ccd2c2$var$long_1.default.UZERO
};
module.exports.PinCodesProposal = {
    encode (message, writer = $9be14b4116ccd2c2$var$minimal_1.default.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        writer.uint32(26).fork();
        for (const v of message.codeIds)writer.uint64(v);
        writer.ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9be14b4116ccd2c2$var$minimal_1.default.Reader ? input : new $9be14b4116ccd2c2$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9be14b4116ccd2c2$var$basePinCodesProposal);
        message.codeIds = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.codeIds.push(reader.uint64());
                    } else message.codeIds.push(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9be14b4116ccd2c2$var$basePinCodesProposal);
        message.codeIds = [];
        if (object.title !== undefined && object.title !== null) message.title = String(object.title);
        else message.title = "";
        if (object.description !== undefined && object.description !== null) message.description = String(object.description);
        else message.description = "";
        if (object.codeIds !== undefined && object.codeIds !== null) for (const e of object.codeIds)message.codeIds.push($9be14b4116ccd2c2$var$long_1.default.fromString(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        if (message.codeIds) obj.codeIds = message.codeIds.map((e)=>(e || $9be14b4116ccd2c2$var$long_1.default.UZERO).toString());
        else obj.codeIds = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9be14b4116ccd2c2$var$basePinCodesProposal);
        message.codeIds = [];
        if (object.title !== undefined && object.title !== null) message.title = object.title;
        else message.title = "";
        if (object.description !== undefined && object.description !== null) message.description = object.description;
        else message.description = "";
        if (object.codeIds !== undefined && object.codeIds !== null) for (const e of object.codeIds)message.codeIds.push(e);
        return message;
    }
};
const $9be14b4116ccd2c2$var$baseUnpinCodesProposal = {
    title: "",
    description: "",
    codeIds: $9be14b4116ccd2c2$var$long_1.default.UZERO
};
module.exports.UnpinCodesProposal = {
    encode (message, writer = $9be14b4116ccd2c2$var$minimal_1.default.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        writer.uint32(26).fork();
        for (const v of message.codeIds)writer.uint64(v);
        writer.ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9be14b4116ccd2c2$var$minimal_1.default.Reader ? input : new $9be14b4116ccd2c2$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9be14b4116ccd2c2$var$baseUnpinCodesProposal);
        message.codeIds = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.codeIds.push(reader.uint64());
                    } else message.codeIds.push(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9be14b4116ccd2c2$var$baseUnpinCodesProposal);
        message.codeIds = [];
        if (object.title !== undefined && object.title !== null) message.title = String(object.title);
        else message.title = "";
        if (object.description !== undefined && object.description !== null) message.description = String(object.description);
        else message.description = "";
        if (object.codeIds !== undefined && object.codeIds !== null) for (const e of object.codeIds)message.codeIds.push($9be14b4116ccd2c2$var$long_1.default.fromString(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        if (message.codeIds) obj.codeIds = message.codeIds.map((e)=>(e || $9be14b4116ccd2c2$var$long_1.default.UZERO).toString());
        else obj.codeIds = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9be14b4116ccd2c2$var$baseUnpinCodesProposal);
        message.codeIds = [];
        if (object.title !== undefined && object.title !== null) message.title = object.title;
        else message.title = "";
        if (object.description !== undefined && object.description !== null) message.description = object.description;
        else message.description = "";
        if (object.codeIds !== undefined && object.codeIds !== null) for (const e of object.codeIds)message.codeIds.push(e);
        return message;
    }
};
const $9be14b4116ccd2c2$var$baseAccessConfigUpdate = {
    codeId: $9be14b4116ccd2c2$var$long_1.default.UZERO
};
module.exports.AccessConfigUpdate = {
    encode (message, writer = $9be14b4116ccd2c2$var$minimal_1.default.Writer.create()) {
        if (!message.codeId.isZero()) writer.uint32(8).uint64(message.codeId);
        if (message.instantiatePermission !== undefined) $odsVG.AccessConfig.encode(message.instantiatePermission, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9be14b4116ccd2c2$var$minimal_1.default.Reader ? input : new $9be14b4116ccd2c2$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9be14b4116ccd2c2$var$baseAccessConfigUpdate);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.codeId = reader.uint64();
                    break;
                case 2:
                    message.instantiatePermission = $odsVG.AccessConfig.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9be14b4116ccd2c2$var$baseAccessConfigUpdate);
        if (object.codeId !== undefined && object.codeId !== null) message.codeId = $9be14b4116ccd2c2$var$long_1.default.fromString(object.codeId);
        else message.codeId = $9be14b4116ccd2c2$var$long_1.default.UZERO;
        if (object.instantiatePermission !== undefined && object.instantiatePermission !== null) message.instantiatePermission = $odsVG.AccessConfig.fromJSON(object.instantiatePermission);
        else message.instantiatePermission = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.codeId !== undefined && (obj.codeId = (message.codeId || $9be14b4116ccd2c2$var$long_1.default.UZERO).toString());
        message.instantiatePermission !== undefined && (obj.instantiatePermission = message.instantiatePermission ? $odsVG.AccessConfig.toJSON(message.instantiatePermission) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9be14b4116ccd2c2$var$baseAccessConfigUpdate);
        if (object.codeId !== undefined && object.codeId !== null) message.codeId = object.codeId;
        else message.codeId = $9be14b4116ccd2c2$var$long_1.default.UZERO;
        if (object.instantiatePermission !== undefined && object.instantiatePermission !== null) message.instantiatePermission = $odsVG.AccessConfig.fromPartial(object.instantiatePermission);
        else message.instantiatePermission = undefined;
        return message;
    }
};
const $9be14b4116ccd2c2$var$baseUpdateInstantiateConfigProposal = {
    title: "",
    description: ""
};
module.exports.UpdateInstantiateConfigProposal = {
    encode (message, writer = $9be14b4116ccd2c2$var$minimal_1.default.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        for (const v of message.accessConfigUpdates)module.exports.AccessConfigUpdate.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9be14b4116ccd2c2$var$minimal_1.default.Reader ? input : new $9be14b4116ccd2c2$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9be14b4116ccd2c2$var$baseUpdateInstantiateConfigProposal);
        message.accessConfigUpdates = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.accessConfigUpdates.push(module.exports.AccessConfigUpdate.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9be14b4116ccd2c2$var$baseUpdateInstantiateConfigProposal);
        message.accessConfigUpdates = [];
        if (object.title !== undefined && object.title !== null) message.title = String(object.title);
        else message.title = "";
        if (object.description !== undefined && object.description !== null) message.description = String(object.description);
        else message.description = "";
        if (object.accessConfigUpdates !== undefined && object.accessConfigUpdates !== null) for (const e of object.accessConfigUpdates)message.accessConfigUpdates.push(module.exports.AccessConfigUpdate.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        if (message.accessConfigUpdates) obj.accessConfigUpdates = message.accessConfigUpdates.map((e)=>e ? module.exports.AccessConfigUpdate.toJSON(e) : undefined);
        else obj.accessConfigUpdates = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9be14b4116ccd2c2$var$baseUpdateInstantiateConfigProposal);
        message.accessConfigUpdates = [];
        if (object.title !== undefined && object.title !== null) message.title = object.title;
        else message.title = "";
        if (object.description !== undefined && object.description !== null) message.description = object.description;
        else message.description = "";
        if (object.accessConfigUpdates !== undefined && object.accessConfigUpdates !== null) for (const e of object.accessConfigUpdates)message.accessConfigUpdates.push(module.exports.AccessConfigUpdate.fromPartial(e));
        return message;
    }
};
var $9be14b4116ccd2c2$var$globalThis = (()=>{
    if (typeof $9be14b4116ccd2c2$var$globalThis !== "undefined") return $9be14b4116ccd2c2$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $9be14b4116ccd2c2$var$atob = $9be14b4116ccd2c2$var$globalThis.atob || ((b64)=>$9be14b4116ccd2c2$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $9be14b4116ccd2c2$var$bytesFromBase64(b64) {
    const bin = $9be14b4116ccd2c2$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $9be14b4116ccd2c2$var$btoa = $9be14b4116ccd2c2$var$globalThis.btoa || ((bin)=>$9be14b4116ccd2c2$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $9be14b4116ccd2c2$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $9be14b4116ccd2c2$var$btoa(bin.join(""));
}
if ($9be14b4116ccd2c2$var$minimal_1.default.util.Long !== $9be14b4116ccd2c2$var$long_1.default) {
    $9be14b4116ccd2c2$var$minimal_1.default.util.Long = $9be14b4116ccd2c2$var$long_1.default;
    $9be14b4116ccd2c2$var$minimal_1.default.configure();
}

});
parcelRegister("odsVG", function(module, exports) {
"use strict";
var $048caffe7ddf9a3b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Model = module.exports.AbsoluteTxPosition = module.exports.ContractCodeHistoryEntry = module.exports.ContractInfo = module.exports.CodeInfo = module.exports.Params = module.exports.AccessConfig = module.exports.AccessTypeParam = module.exports.contractCodeHistoryOperationTypeToJSON = module.exports.contractCodeHistoryOperationTypeFromJSON = module.exports.ContractCodeHistoryOperationType = module.exports.accessTypeToJSON = module.exports.accessTypeFromJSON = module.exports.AccessType = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $048caffe7ddf9a3b$var$long_1 = $048caffe7ddf9a3b$var$__importDefault((parcelRequire("9A55m")));

const $048caffe7ddf9a3b$var$minimal_1 = $048caffe7ddf9a3b$var$__importDefault((parcelRequire("i2pIU")));

var $c5FxR = parcelRequire("c5FxR");
module.exports.protobufPackage = "cosmwasm.wasm.v1";
/** AccessType permission types */ var $048caffe7ddf9a3b$var$AccessType;
(function(AccessType) {
    /** ACCESS_TYPE_UNSPECIFIED - AccessTypeUnspecified placeholder for empty value */ AccessType[AccessType["ACCESS_TYPE_UNSPECIFIED"] = 0] = "ACCESS_TYPE_UNSPECIFIED";
    /** ACCESS_TYPE_NOBODY - AccessTypeNobody forbidden */ AccessType[AccessType["ACCESS_TYPE_NOBODY"] = 1] = "ACCESS_TYPE_NOBODY";
    /** ACCESS_TYPE_ONLY_ADDRESS - AccessTypeOnlyAddress restricted to an address */ AccessType[AccessType["ACCESS_TYPE_ONLY_ADDRESS"] = 2] = "ACCESS_TYPE_ONLY_ADDRESS";
    /** ACCESS_TYPE_EVERYBODY - AccessTypeEverybody unrestricted */ AccessType[AccessType["ACCESS_TYPE_EVERYBODY"] = 3] = "ACCESS_TYPE_EVERYBODY";
    AccessType[AccessType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($048caffe7ddf9a3b$var$AccessType = module.exports.AccessType || (module.exports.AccessType = {}));
function $048caffe7ddf9a3b$var$accessTypeFromJSON(object) {
    switch(object){
        case 0:
        case "ACCESS_TYPE_UNSPECIFIED":
            return $048caffe7ddf9a3b$var$AccessType.ACCESS_TYPE_UNSPECIFIED;
        case 1:
        case "ACCESS_TYPE_NOBODY":
            return $048caffe7ddf9a3b$var$AccessType.ACCESS_TYPE_NOBODY;
        case 2:
        case "ACCESS_TYPE_ONLY_ADDRESS":
            return $048caffe7ddf9a3b$var$AccessType.ACCESS_TYPE_ONLY_ADDRESS;
        case 3:
        case "ACCESS_TYPE_EVERYBODY":
            return $048caffe7ddf9a3b$var$AccessType.ACCESS_TYPE_EVERYBODY;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $048caffe7ddf9a3b$var$AccessType.UNRECOGNIZED;
    }
}
module.exports.accessTypeFromJSON = $048caffe7ddf9a3b$var$accessTypeFromJSON;
function $048caffe7ddf9a3b$var$accessTypeToJSON(object) {
    switch(object){
        case $048caffe7ddf9a3b$var$AccessType.ACCESS_TYPE_UNSPECIFIED:
            return "ACCESS_TYPE_UNSPECIFIED";
        case $048caffe7ddf9a3b$var$AccessType.ACCESS_TYPE_NOBODY:
            return "ACCESS_TYPE_NOBODY";
        case $048caffe7ddf9a3b$var$AccessType.ACCESS_TYPE_ONLY_ADDRESS:
            return "ACCESS_TYPE_ONLY_ADDRESS";
        case $048caffe7ddf9a3b$var$AccessType.ACCESS_TYPE_EVERYBODY:
            return "ACCESS_TYPE_EVERYBODY";
        default:
            return "UNKNOWN";
    }
}
module.exports.accessTypeToJSON = $048caffe7ddf9a3b$var$accessTypeToJSON;
/** ContractCodeHistoryOperationType actions that caused a code change */ var $048caffe7ddf9a3b$var$ContractCodeHistoryOperationType;
(function(ContractCodeHistoryOperationType) {
    /** CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED - ContractCodeHistoryOperationTypeUnspecified placeholder for empty value */ ContractCodeHistoryOperationType[ContractCodeHistoryOperationType["CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED"] = 0] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED";
    /** CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT - ContractCodeHistoryOperationTypeInit on chain contract instantiation */ ContractCodeHistoryOperationType[ContractCodeHistoryOperationType["CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT"] = 1] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT";
    /** CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE - ContractCodeHistoryOperationTypeMigrate code migration */ ContractCodeHistoryOperationType[ContractCodeHistoryOperationType["CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE"] = 2] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE";
    /** CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS - ContractCodeHistoryOperationTypeGenesis based on genesis data */ ContractCodeHistoryOperationType[ContractCodeHistoryOperationType["CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS"] = 3] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS";
    ContractCodeHistoryOperationType[ContractCodeHistoryOperationType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($048caffe7ddf9a3b$var$ContractCodeHistoryOperationType = module.exports.ContractCodeHistoryOperationType || (module.exports.ContractCodeHistoryOperationType = {}));
function $048caffe7ddf9a3b$var$contractCodeHistoryOperationTypeFromJSON(object) {
    switch(object){
        case 0:
        case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED":
            return $048caffe7ddf9a3b$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED;
        case 1:
        case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT":
            return $048caffe7ddf9a3b$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT;
        case 2:
        case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE":
            return $048caffe7ddf9a3b$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE;
        case 3:
        case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS":
            return $048caffe7ddf9a3b$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $048caffe7ddf9a3b$var$ContractCodeHistoryOperationType.UNRECOGNIZED;
    }
}
module.exports.contractCodeHistoryOperationTypeFromJSON = $048caffe7ddf9a3b$var$contractCodeHistoryOperationTypeFromJSON;
function $048caffe7ddf9a3b$var$contractCodeHistoryOperationTypeToJSON(object) {
    switch(object){
        case $048caffe7ddf9a3b$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED:
            return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED";
        case $048caffe7ddf9a3b$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT:
            return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT";
        case $048caffe7ddf9a3b$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE:
            return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE";
        case $048caffe7ddf9a3b$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS:
            return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS";
        default:
            return "UNKNOWN";
    }
}
module.exports.contractCodeHistoryOperationTypeToJSON = $048caffe7ddf9a3b$var$contractCodeHistoryOperationTypeToJSON;
const $048caffe7ddf9a3b$var$baseAccessTypeParam = {
    value: 0
};
module.exports.AccessTypeParam = {
    encode (message, writer = $048caffe7ddf9a3b$var$minimal_1.default.Writer.create()) {
        if (message.value !== 0) writer.uint32(8).int32(message.value);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $048caffe7ddf9a3b$var$minimal_1.default.Reader ? input : new $048caffe7ddf9a3b$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $048caffe7ddf9a3b$var$baseAccessTypeParam);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.value = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $048caffe7ddf9a3b$var$baseAccessTypeParam);
        if (object.value !== undefined && object.value !== null) message.value = $048caffe7ddf9a3b$var$accessTypeFromJSON(object.value);
        else message.value = 0;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.value !== undefined && (obj.value = $048caffe7ddf9a3b$var$accessTypeToJSON(message.value));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $048caffe7ddf9a3b$var$baseAccessTypeParam);
        if (object.value !== undefined && object.value !== null) message.value = object.value;
        else message.value = 0;
        return message;
    }
};
const $048caffe7ddf9a3b$var$baseAccessConfig = {
    permission: 0,
    address: ""
};
module.exports.AccessConfig = {
    encode (message, writer = $048caffe7ddf9a3b$var$minimal_1.default.Writer.create()) {
        if (message.permission !== 0) writer.uint32(8).int32(message.permission);
        if (message.address !== "") writer.uint32(18).string(message.address);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $048caffe7ddf9a3b$var$minimal_1.default.Reader ? input : new $048caffe7ddf9a3b$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $048caffe7ddf9a3b$var$baseAccessConfig);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.permission = reader.int32();
                    break;
                case 2:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $048caffe7ddf9a3b$var$baseAccessConfig);
        if (object.permission !== undefined && object.permission !== null) message.permission = $048caffe7ddf9a3b$var$accessTypeFromJSON(object.permission);
        else message.permission = 0;
        if (object.address !== undefined && object.address !== null) message.address = String(object.address);
        else message.address = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.permission !== undefined && (obj.permission = $048caffe7ddf9a3b$var$accessTypeToJSON(message.permission));
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $048caffe7ddf9a3b$var$baseAccessConfig);
        if (object.permission !== undefined && object.permission !== null) message.permission = object.permission;
        else message.permission = 0;
        if (object.address !== undefined && object.address !== null) message.address = object.address;
        else message.address = "";
        return message;
    }
};
const $048caffe7ddf9a3b$var$baseParams = {
    instantiateDefaultPermission: 0
};
module.exports.Params = {
    encode (message, writer = $048caffe7ddf9a3b$var$minimal_1.default.Writer.create()) {
        if (message.codeUploadAccess !== undefined) module.exports.AccessConfig.encode(message.codeUploadAccess, writer.uint32(10).fork()).ldelim();
        if (message.instantiateDefaultPermission !== 0) writer.uint32(16).int32(message.instantiateDefaultPermission);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $048caffe7ddf9a3b$var$minimal_1.default.Reader ? input : new $048caffe7ddf9a3b$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $048caffe7ddf9a3b$var$baseParams);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.codeUploadAccess = module.exports.AccessConfig.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.instantiateDefaultPermission = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $048caffe7ddf9a3b$var$baseParams);
        if (object.codeUploadAccess !== undefined && object.codeUploadAccess !== null) message.codeUploadAccess = module.exports.AccessConfig.fromJSON(object.codeUploadAccess);
        else message.codeUploadAccess = undefined;
        if (object.instantiateDefaultPermission !== undefined && object.instantiateDefaultPermission !== null) message.instantiateDefaultPermission = $048caffe7ddf9a3b$var$accessTypeFromJSON(object.instantiateDefaultPermission);
        else message.instantiateDefaultPermission = 0;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.codeUploadAccess !== undefined && (obj.codeUploadAccess = message.codeUploadAccess ? module.exports.AccessConfig.toJSON(message.codeUploadAccess) : undefined);
        message.instantiateDefaultPermission !== undefined && (obj.instantiateDefaultPermission = $048caffe7ddf9a3b$var$accessTypeToJSON(message.instantiateDefaultPermission));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $048caffe7ddf9a3b$var$baseParams);
        if (object.codeUploadAccess !== undefined && object.codeUploadAccess !== null) message.codeUploadAccess = module.exports.AccessConfig.fromPartial(object.codeUploadAccess);
        else message.codeUploadAccess = undefined;
        if (object.instantiateDefaultPermission !== undefined && object.instantiateDefaultPermission !== null) message.instantiateDefaultPermission = object.instantiateDefaultPermission;
        else message.instantiateDefaultPermission = 0;
        return message;
    }
};
const $048caffe7ddf9a3b$var$baseCodeInfo = {
    creator: ""
};
module.exports.CodeInfo = {
    encode (message, writer = $048caffe7ddf9a3b$var$minimal_1.default.Writer.create()) {
        if (message.codeHash.length !== 0) writer.uint32(10).bytes(message.codeHash);
        if (message.creator !== "") writer.uint32(18).string(message.creator);
        if (message.instantiateConfig !== undefined) module.exports.AccessConfig.encode(message.instantiateConfig, writer.uint32(42).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $048caffe7ddf9a3b$var$minimal_1.default.Reader ? input : new $048caffe7ddf9a3b$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $048caffe7ddf9a3b$var$baseCodeInfo);
        message.codeHash = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.codeHash = reader.bytes();
                    break;
                case 2:
                    message.creator = reader.string();
                    break;
                case 5:
                    message.instantiateConfig = module.exports.AccessConfig.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $048caffe7ddf9a3b$var$baseCodeInfo);
        message.codeHash = new Uint8Array();
        if (object.codeHash !== undefined && object.codeHash !== null) message.codeHash = $048caffe7ddf9a3b$var$bytesFromBase64(object.codeHash);
        if (object.creator !== undefined && object.creator !== null) message.creator = String(object.creator);
        else message.creator = "";
        if (object.instantiateConfig !== undefined && object.instantiateConfig !== null) message.instantiateConfig = module.exports.AccessConfig.fromJSON(object.instantiateConfig);
        else message.instantiateConfig = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.codeHash !== undefined && (obj.codeHash = $048caffe7ddf9a3b$var$base64FromBytes(message.codeHash !== undefined ? message.codeHash : new Uint8Array()));
        message.creator !== undefined && (obj.creator = message.creator);
        message.instantiateConfig !== undefined && (obj.instantiateConfig = message.instantiateConfig ? module.exports.AccessConfig.toJSON(message.instantiateConfig) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $048caffe7ddf9a3b$var$baseCodeInfo);
        if (object.codeHash !== undefined && object.codeHash !== null) message.codeHash = object.codeHash;
        else message.codeHash = new Uint8Array();
        if (object.creator !== undefined && object.creator !== null) message.creator = object.creator;
        else message.creator = "";
        if (object.instantiateConfig !== undefined && object.instantiateConfig !== null) message.instantiateConfig = module.exports.AccessConfig.fromPartial(object.instantiateConfig);
        else message.instantiateConfig = undefined;
        return message;
    }
};
const $048caffe7ddf9a3b$var$baseContractInfo = {
    codeId: $048caffe7ddf9a3b$var$long_1.default.UZERO,
    creator: "",
    admin: "",
    label: "",
    ibcPortId: ""
};
module.exports.ContractInfo = {
    encode (message, writer = $048caffe7ddf9a3b$var$minimal_1.default.Writer.create()) {
        if (!message.codeId.isZero()) writer.uint32(8).uint64(message.codeId);
        if (message.creator !== "") writer.uint32(18).string(message.creator);
        if (message.admin !== "") writer.uint32(26).string(message.admin);
        if (message.label !== "") writer.uint32(34).string(message.label);
        if (message.created !== undefined) module.exports.AbsoluteTxPosition.encode(message.created, writer.uint32(42).fork()).ldelim();
        if (message.ibcPortId !== "") writer.uint32(50).string(message.ibcPortId);
        if (message.extension !== undefined) $c5FxR.Any.encode(message.extension, writer.uint32(58).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $048caffe7ddf9a3b$var$minimal_1.default.Reader ? input : new $048caffe7ddf9a3b$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $048caffe7ddf9a3b$var$baseContractInfo);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.codeId = reader.uint64();
                    break;
                case 2:
                    message.creator = reader.string();
                    break;
                case 3:
                    message.admin = reader.string();
                    break;
                case 4:
                    message.label = reader.string();
                    break;
                case 5:
                    message.created = module.exports.AbsoluteTxPosition.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.ibcPortId = reader.string();
                    break;
                case 7:
                    message.extension = $c5FxR.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $048caffe7ddf9a3b$var$baseContractInfo);
        if (object.codeId !== undefined && object.codeId !== null) message.codeId = $048caffe7ddf9a3b$var$long_1.default.fromString(object.codeId);
        else message.codeId = $048caffe7ddf9a3b$var$long_1.default.UZERO;
        if (object.creator !== undefined && object.creator !== null) message.creator = String(object.creator);
        else message.creator = "";
        if (object.admin !== undefined && object.admin !== null) message.admin = String(object.admin);
        else message.admin = "";
        if (object.label !== undefined && object.label !== null) message.label = String(object.label);
        else message.label = "";
        if (object.created !== undefined && object.created !== null) message.created = module.exports.AbsoluteTxPosition.fromJSON(object.created);
        else message.created = undefined;
        if (object.ibcPortId !== undefined && object.ibcPortId !== null) message.ibcPortId = String(object.ibcPortId);
        else message.ibcPortId = "";
        if (object.extension !== undefined && object.extension !== null) message.extension = $c5FxR.Any.fromJSON(object.extension);
        else message.extension = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.codeId !== undefined && (obj.codeId = (message.codeId || $048caffe7ddf9a3b$var$long_1.default.UZERO).toString());
        message.creator !== undefined && (obj.creator = message.creator);
        message.admin !== undefined && (obj.admin = message.admin);
        message.label !== undefined && (obj.label = message.label);
        message.created !== undefined && (obj.created = message.created ? module.exports.AbsoluteTxPosition.toJSON(message.created) : undefined);
        message.ibcPortId !== undefined && (obj.ibcPortId = message.ibcPortId);
        message.extension !== undefined && (obj.extension = message.extension ? $c5FxR.Any.toJSON(message.extension) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $048caffe7ddf9a3b$var$baseContractInfo);
        if (object.codeId !== undefined && object.codeId !== null) message.codeId = object.codeId;
        else message.codeId = $048caffe7ddf9a3b$var$long_1.default.UZERO;
        if (object.creator !== undefined && object.creator !== null) message.creator = object.creator;
        else message.creator = "";
        if (object.admin !== undefined && object.admin !== null) message.admin = object.admin;
        else message.admin = "";
        if (object.label !== undefined && object.label !== null) message.label = object.label;
        else message.label = "";
        if (object.created !== undefined && object.created !== null) message.created = module.exports.AbsoluteTxPosition.fromPartial(object.created);
        else message.created = undefined;
        if (object.ibcPortId !== undefined && object.ibcPortId !== null) message.ibcPortId = object.ibcPortId;
        else message.ibcPortId = "";
        if (object.extension !== undefined && object.extension !== null) message.extension = $c5FxR.Any.fromPartial(object.extension);
        else message.extension = undefined;
        return message;
    }
};
const $048caffe7ddf9a3b$var$baseContractCodeHistoryEntry = {
    operation: 0,
    codeId: $048caffe7ddf9a3b$var$long_1.default.UZERO
};
module.exports.ContractCodeHistoryEntry = {
    encode (message, writer = $048caffe7ddf9a3b$var$minimal_1.default.Writer.create()) {
        if (message.operation !== 0) writer.uint32(8).int32(message.operation);
        if (!message.codeId.isZero()) writer.uint32(16).uint64(message.codeId);
        if (message.updated !== undefined) module.exports.AbsoluteTxPosition.encode(message.updated, writer.uint32(26).fork()).ldelim();
        if (message.msg.length !== 0) writer.uint32(34).bytes(message.msg);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $048caffe7ddf9a3b$var$minimal_1.default.Reader ? input : new $048caffe7ddf9a3b$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $048caffe7ddf9a3b$var$baseContractCodeHistoryEntry);
        message.msg = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.operation = reader.int32();
                    break;
                case 2:
                    message.codeId = reader.uint64();
                    break;
                case 3:
                    message.updated = module.exports.AbsoluteTxPosition.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.msg = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $048caffe7ddf9a3b$var$baseContractCodeHistoryEntry);
        message.msg = new Uint8Array();
        if (object.operation !== undefined && object.operation !== null) message.operation = $048caffe7ddf9a3b$var$contractCodeHistoryOperationTypeFromJSON(object.operation);
        else message.operation = 0;
        if (object.codeId !== undefined && object.codeId !== null) message.codeId = $048caffe7ddf9a3b$var$long_1.default.fromString(object.codeId);
        else message.codeId = $048caffe7ddf9a3b$var$long_1.default.UZERO;
        if (object.updated !== undefined && object.updated !== null) message.updated = module.exports.AbsoluteTxPosition.fromJSON(object.updated);
        else message.updated = undefined;
        if (object.msg !== undefined && object.msg !== null) message.msg = $048caffe7ddf9a3b$var$bytesFromBase64(object.msg);
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.operation !== undefined && (obj.operation = $048caffe7ddf9a3b$var$contractCodeHistoryOperationTypeToJSON(message.operation));
        message.codeId !== undefined && (obj.codeId = (message.codeId || $048caffe7ddf9a3b$var$long_1.default.UZERO).toString());
        message.updated !== undefined && (obj.updated = message.updated ? module.exports.AbsoluteTxPosition.toJSON(message.updated) : undefined);
        message.msg !== undefined && (obj.msg = $048caffe7ddf9a3b$var$base64FromBytes(message.msg !== undefined ? message.msg : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $048caffe7ddf9a3b$var$baseContractCodeHistoryEntry);
        if (object.operation !== undefined && object.operation !== null) message.operation = object.operation;
        else message.operation = 0;
        if (object.codeId !== undefined && object.codeId !== null) message.codeId = object.codeId;
        else message.codeId = $048caffe7ddf9a3b$var$long_1.default.UZERO;
        if (object.updated !== undefined && object.updated !== null) message.updated = module.exports.AbsoluteTxPosition.fromPartial(object.updated);
        else message.updated = undefined;
        if (object.msg !== undefined && object.msg !== null) message.msg = object.msg;
        else message.msg = new Uint8Array();
        return message;
    }
};
const $048caffe7ddf9a3b$var$baseAbsoluteTxPosition = {
    blockHeight: $048caffe7ddf9a3b$var$long_1.default.UZERO,
    txIndex: $048caffe7ddf9a3b$var$long_1.default.UZERO
};
module.exports.AbsoluteTxPosition = {
    encode (message, writer = $048caffe7ddf9a3b$var$minimal_1.default.Writer.create()) {
        if (!message.blockHeight.isZero()) writer.uint32(8).uint64(message.blockHeight);
        if (!message.txIndex.isZero()) writer.uint32(16).uint64(message.txIndex);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $048caffe7ddf9a3b$var$minimal_1.default.Reader ? input : new $048caffe7ddf9a3b$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $048caffe7ddf9a3b$var$baseAbsoluteTxPosition);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.blockHeight = reader.uint64();
                    break;
                case 2:
                    message.txIndex = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $048caffe7ddf9a3b$var$baseAbsoluteTxPosition);
        if (object.blockHeight !== undefined && object.blockHeight !== null) message.blockHeight = $048caffe7ddf9a3b$var$long_1.default.fromString(object.blockHeight);
        else message.blockHeight = $048caffe7ddf9a3b$var$long_1.default.UZERO;
        if (object.txIndex !== undefined && object.txIndex !== null) message.txIndex = $048caffe7ddf9a3b$var$long_1.default.fromString(object.txIndex);
        else message.txIndex = $048caffe7ddf9a3b$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.blockHeight !== undefined && (obj.blockHeight = (message.blockHeight || $048caffe7ddf9a3b$var$long_1.default.UZERO).toString());
        message.txIndex !== undefined && (obj.txIndex = (message.txIndex || $048caffe7ddf9a3b$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $048caffe7ddf9a3b$var$baseAbsoluteTxPosition);
        if (object.blockHeight !== undefined && object.blockHeight !== null) message.blockHeight = object.blockHeight;
        else message.blockHeight = $048caffe7ddf9a3b$var$long_1.default.UZERO;
        if (object.txIndex !== undefined && object.txIndex !== null) message.txIndex = object.txIndex;
        else message.txIndex = $048caffe7ddf9a3b$var$long_1.default.UZERO;
        return message;
    }
};
const $048caffe7ddf9a3b$var$baseModel = {};
module.exports.Model = {
    encode (message, writer = $048caffe7ddf9a3b$var$minimal_1.default.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (message.value.length !== 0) writer.uint32(18).bytes(message.value);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $048caffe7ddf9a3b$var$minimal_1.default.Reader ? input : new $048caffe7ddf9a3b$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $048caffe7ddf9a3b$var$baseModel);
        message.key = new Uint8Array();
        message.value = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.value = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $048caffe7ddf9a3b$var$baseModel);
        message.key = new Uint8Array();
        message.value = new Uint8Array();
        if (object.key !== undefined && object.key !== null) message.key = $048caffe7ddf9a3b$var$bytesFromBase64(object.key);
        if (object.value !== undefined && object.value !== null) message.value = $048caffe7ddf9a3b$var$bytesFromBase64(object.value);
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = $048caffe7ddf9a3b$var$base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        message.value !== undefined && (obj.value = $048caffe7ddf9a3b$var$base64FromBytes(message.value !== undefined ? message.value : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $048caffe7ddf9a3b$var$baseModel);
        if (object.key !== undefined && object.key !== null) message.key = object.key;
        else message.key = new Uint8Array();
        if (object.value !== undefined && object.value !== null) message.value = object.value;
        else message.value = new Uint8Array();
        return message;
    }
};
var $048caffe7ddf9a3b$var$globalThis = (()=>{
    if (typeof $048caffe7ddf9a3b$var$globalThis !== "undefined") return $048caffe7ddf9a3b$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $048caffe7ddf9a3b$var$atob = $048caffe7ddf9a3b$var$globalThis.atob || ((b64)=>$048caffe7ddf9a3b$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $048caffe7ddf9a3b$var$bytesFromBase64(b64) {
    const bin = $048caffe7ddf9a3b$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $048caffe7ddf9a3b$var$btoa = $048caffe7ddf9a3b$var$globalThis.btoa || ((bin)=>$048caffe7ddf9a3b$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $048caffe7ddf9a3b$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $048caffe7ddf9a3b$var$btoa(bin.join(""));
}
if ($048caffe7ddf9a3b$var$minimal_1.default.util.Long !== $048caffe7ddf9a3b$var$long_1.default) {
    $048caffe7ddf9a3b$var$minimal_1.default.util.Long = $048caffe7ddf9a3b$var$long_1.default;
    $048caffe7ddf9a3b$var$minimal_1.default.configure();
}

});



parcelRegister("2OYhI", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $20df038d7e8549e2$require$Buffer = $gzLuY.Buffer;
"use strict";
var $20df038d7e8549e2$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExecuteContractProposal = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $kYslP = parcelRequire("kYslP");

var $c5FxR = parcelRequire("c5FxR");

var $dnKf8 = parcelRequire("dnKf8");
/**
 * ExecuteContractProposal gov proposal content type to call execute on a
 * contract.
 */ var $20df038d7e8549e2$var$ExecuteContractProposal = /** @class */ function(_super) {
    $20df038d7e8549e2$var$__extends(ExecuteContractProposal, _super);
    /**
     * @param title a short summary
     * @param description a human readable text
     * @param run_as contract user
     * @param contract contract address
     * @param execute_msg HandleMsg to pass as arguments for contract invocation
     * @param coins coins to be sent to contract
     */ function ExecuteContractProposal(title, description, run_as, contract, execute_msg, coins) {
        if (coins === void 0) coins = {};
        var _this = _super.call(this) || this;
        _this.title = title;
        _this.description = description;
        _this.run_as = run_as;
        _this.contract = contract;
        _this.execute_msg = execute_msg;
        _this.coins = new $kYslP.Coins(coins);
        return _this;
    }
    ExecuteContractProposal.fromAmino = function(data, _) {
        var _a = data.value, title = _a.title, description = _a.description, run_as = _a.run_as, contract = _a.contract, msg = _a.msg, funds = _a.funds;
        return new ExecuteContractProposal(title, description, run_as, contract, msg, $kYslP.Coins.fromAmino(funds));
    };
    ExecuteContractProposal.prototype.toAmino = function(_) {
        var _a = this, title = _a.title, description = _a.description, run_as = _a.run_as, contract = _a.contract, execute_msg = _a.execute_msg, coins = _a.coins;
        return {
            type: "wasm/ExecuteContractProposal",
            value: {
                title: title,
                description: description,
                run_as: run_as,
                contract: contract,
                msg: (0, $26Eqx.removeNull)(execute_msg),
                funds: coins.toAmino()
            }
        };
    };
    ExecuteContractProposal.fromProto = function(proto, _) {
        return new ExecuteContractProposal(proto.title, proto.description, proto.runAs, proto.contract, JSON.parse($20df038d7e8549e2$require$Buffer.from(proto.msg).toString("utf-8")), $kYslP.Coins.fromProto(proto.funds));
    };
    ExecuteContractProposal.prototype.toProto = function(_) {
        var _a = this, title = _a.title, description = _a.description, run_as = _a.run_as, contract = _a.contract, execute_msg = _a.execute_msg, coins = _a.coins;
        return $dnKf8.ExecuteContractProposal.fromPartial({
            title: title,
            description: description,
            funds: coins.toProto(),
            contract: contract,
            runAs: run_as,
            msg: $20df038d7e8549e2$require$Buffer.from(JSON.stringify((0, $26Eqx.removeNull)(execute_msg)), "utf-8")
        });
    };
    ExecuteContractProposal.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmwasm.wasm.v1.ExecuteContractProposal",
            value: $dnKf8.ExecuteContractProposal.encode(this.toProto(isClassic)).finish()
        });
    };
    ExecuteContractProposal.unpackAny = function(msgAny, isClassic) {
        return ExecuteContractProposal.fromProto($dnKf8.ExecuteContractProposal.decode(msgAny.value), isClassic);
    };
    ExecuteContractProposal.fromData = function(data, _) {
        var _a = data, title = _a.title, description = _a.description, run_as = _a.run_as, contract = _a.contract, msg = _a.msg, funds = _a.funds;
        return new ExecuteContractProposal(title, description, run_as, contract, msg, $kYslP.Coins.fromData(funds));
    };
    ExecuteContractProposal.prototype.toData = function(_) {
        var _a = this, title = _a.title, description = _a.description, run_as = _a.run_as, contract = _a.contract, execute_msg = _a.execute_msg, coins = _a.coins;
        return {
            "@type": "/cosmwasm.wasm.v1.ExecuteContractProposal",
            title: title,
            description: description,
            run_as: run_as,
            contract: contract,
            msg: execute_msg,
            funds: coins.toData()
        };
    };
    return ExecuteContractProposal;
}($26Eqx.JSONSerializable);
module.exports.ExecuteContractProposal = $20df038d7e8549e2$var$ExecuteContractProposal;

});

parcelRegister("c6QJW", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $02466f4cd984d81a$require$Buffer = $gzLuY.Buffer;
"use strict";
var $02466f4cd984d81a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $02466f4cd984d81a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $02466f4cd984d81a$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $02466f4cd984d81a$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $02466f4cd984d81a$var$__createBinding(result, mod, k);
    }
    $02466f4cd984d81a$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InstantiateContractProposal = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $kYslP = parcelRequire("kYslP");

var $c5FxR = parcelRequire("c5FxR");

var $dnKf8 = parcelRequire("dnKf8");

var $02466f4cd984d81a$var$Long = $02466f4cd984d81a$var$__importStar((parcelRequire("9A55m")));
/**
 * InstantiateContractProposal gov proposal content type to instantiate a
 * contract.
 */ var $02466f4cd984d81a$var$InstantiateContractProposal = /** @class */ function(_super) {
    $02466f4cd984d81a$var$__extends(InstantiateContractProposal, _super);
    /**
     * @param title a short summary
     * @param description a human readable text
     * @param run_as is a run_as address
     * @param admin is an optional contract admin address who can migrate the contract, put empty string to disable migration
     * @param code_id is the reference to the stored WASM code
     * @param init_msg json encoded message to be passed to the contract on instantiation
     * @param init_coins are transferred to the contract on execution
     * @param label label for the contract. v2 supported only
     */ function InstantiateContractProposal(title, description, run_as, admin, code_id, init_msg, init_coins, label) {
        if (init_coins === void 0) init_coins = {};
        var _this = _super.call(this) || this;
        _this.title = title;
        _this.description = description;
        _this.run_as = run_as;
        _this.admin = admin;
        _this.code_id = code_id;
        _this.init_msg = init_msg;
        _this.label = label;
        _this.init_coins = new $kYslP.Coins(init_coins);
        return _this;
    }
    InstantiateContractProposal.fromAmino = function(data, _) {
        var _a = data.value, title = _a.title, description = _a.description, run_as = _a.run_as, admin = _a.admin, code_id = _a.code_id, msg = _a.msg, funds = _a.funds, label = _a.label;
        return new InstantiateContractProposal(title, description, run_as, admin, Number.parseInt(code_id), msg, $kYslP.Coins.fromAmino(funds), label);
    };
    InstantiateContractProposal.prototype.toAmino = function(_) {
        var _a = this, title = _a.title, description = _a.description, run_as = _a.run_as, admin = _a.admin, code_id = _a.code_id, init_msg = _a.init_msg, init_coins = _a.init_coins, label = _a.label;
        return {
            type: "wasm/InstantiateContractProposal",
            value: {
                title: title,
                description: description,
                run_as: run_as,
                admin: admin,
                code_id: code_id.toFixed(),
                label: label,
                msg: (0, $26Eqx.removeNull)(init_msg),
                funds: init_coins.toAmino()
            }
        };
    };
    InstantiateContractProposal.fromProto = function(proto, _) {
        return new InstantiateContractProposal(proto.title, proto.description, proto.runAs, proto.admin !== "" ? proto.admin : undefined, proto.codeId.toNumber(), JSON.parse($02466f4cd984d81a$require$Buffer.from(proto.msg).toString("utf-8")), $kYslP.Coins.fromProto(proto.funds), proto.label);
    };
    InstantiateContractProposal.prototype.toProto = function(_) {
        var _a = this, title = _a.title, description = _a.description, run_as = _a.run_as, admin = _a.admin, code_id = _a.code_id, init_msg = _a.init_msg, init_coins = _a.init_coins, label = _a.label;
        return $dnKf8.InstantiateContractProposal.fromPartial({
            title: title,
            description: description,
            runAs: run_as,
            admin: admin,
            codeId: $02466f4cd984d81a$var$Long.fromNumber(code_id),
            funds: init_coins.toProto(),
            msg: $02466f4cd984d81a$require$Buffer.from(JSON.stringify(init_msg), "utf-8"),
            label: label
        });
    };
    InstantiateContractProposal.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmwasm.wasm.v1.InstantiateContractProposal",
            value: $dnKf8.InstantiateContractProposal.encode(this.toProto(isClassic)).finish()
        });
    };
    InstantiateContractProposal.unpackAny = function(msgAny, isClassic) {
        return InstantiateContractProposal.fromProto($dnKf8.InstantiateContractProposal.decode(msgAny.value), isClassic);
    };
    InstantiateContractProposal.fromData = function(data, _) {
        var _a = data, title = _a.title, description = _a.description, run_as = _a.run_as, admin = _a.admin, code_id = _a.code_id, label = _a.label, msg = _a.msg, funds = _a.funds;
        return new InstantiateContractProposal(title, description, run_as, admin !== "" ? admin : undefined, Number.parseInt(code_id), msg, $kYslP.Coins.fromData(funds), label);
    };
    InstantiateContractProposal.prototype.toData = function(_) {
        var _a = this, title = _a.title, description = _a.description, run_as = _a.run_as, admin = _a.admin, code_id = _a.code_id, label = _a.label, init_msg = _a.init_msg, init_coins = _a.init_coins;
        return {
            "@type": "/cosmwasm.wasm.v1.InstantiateContractProposal",
            title: title,
            description: description,
            run_as: run_as,
            admin: admin || "",
            code_id: code_id.toFixed(),
            label: label,
            msg: (0, $26Eqx.removeNull)(init_msg),
            funds: init_coins.toData()
        };
    };
    return InstantiateContractProposal;
}($26Eqx.JSONSerializable);
module.exports.InstantiateContractProposal = $02466f4cd984d81a$var$InstantiateContractProposal;

});

parcelRegister("dspMZ", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $9cc1e516fea051df$require$Buffer = $gzLuY.Buffer;
"use strict";
var $9cc1e516fea051df$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $9cc1e516fea051df$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9cc1e516fea051df$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $9cc1e516fea051df$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $9cc1e516fea051df$var$__createBinding(result, mod, k);
    }
    $9cc1e516fea051df$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MigrateContractProposal = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $dnKf8 = parcelRequire("dnKf8");

var $9cc1e516fea051df$var$Long = $9cc1e516fea051df$var$__importStar((parcelRequire("9A55m")));
/** MigrateContractProposal gov proposal content type to migrate a contract. */ var $9cc1e516fea051df$var$MigrateContractProposal = /** @class */ function(_super) {
    $9cc1e516fea051df$var$__extends(MigrateContractProposal, _super);
    /**
     * @param title a short summary
     * @param description a human readable text
     * @param contract contract address to be migrated from
     * @param new_code_id reference to the new code on the blockchain
     * @param migrate_msg JSON message to configure the migrate state of the contract
     */ function MigrateContractProposal(title, description, contract, new_code_id, migrate_msg // json object or string
    ) {
        var _this = _super.call(this) || this;
        _this.title = title;
        _this.description = description;
        _this.contract = contract;
        _this.new_code_id = new_code_id;
        _this.migrate_msg = migrate_msg;
        return _this;
    }
    MigrateContractProposal.fromAmino = function(data, _) {
        var _a = data.value, title = _a.title, description = _a.description, contract = _a.contract, code_id = _a.code_id, msg = _a.msg;
        return new MigrateContractProposal(title, description, contract, Number.parseInt(code_id), msg);
    };
    MigrateContractProposal.prototype.toAmino = function(_) {
        var _a = this, title = _a.title, description = _a.description, contract = _a.contract, new_code_id = _a.new_code_id, migrate_msg = _a.migrate_msg;
        return {
            type: "wasm/MigrateContractProposal",
            value: {
                title: title,
                description: description,
                contract: contract,
                code_id: new_code_id.toFixed(),
                msg: (0, $26Eqx.removeNull)(migrate_msg)
            }
        };
    };
    MigrateContractProposal.fromProto = function(proto, _) {
        return new MigrateContractProposal(proto.title, proto.description, proto.contract, proto.codeId.toNumber(), JSON.parse($9cc1e516fea051df$require$Buffer.from(proto.msg).toString("utf-8")));
    };
    MigrateContractProposal.prototype.toProto = function(_) {
        var _a = this, title = _a.title, description = _a.description, contract = _a.contract, new_code_id = _a.new_code_id, migrate_msg = _a.migrate_msg;
        return $dnKf8.MigrateContractProposal.fromPartial({
            title: title,
            description: description,
            contract: contract,
            codeId: $9cc1e516fea051df$var$Long.fromNumber(new_code_id),
            msg: $9cc1e516fea051df$require$Buffer.from(JSON.stringify(migrate_msg), "utf-8")
        });
    };
    MigrateContractProposal.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmwasm.wasm.v1.MigrateContractProposal",
            value: $dnKf8.MigrateContractProposal.encode(this.toProto(isClassic)).finish()
        });
    };
    MigrateContractProposal.unpackAny = function(msgAny, isClassic) {
        return MigrateContractProposal.fromProto($dnKf8.MigrateContractProposal.decode(msgAny.value), isClassic);
    };
    MigrateContractProposal.fromData = function(data, _) {
        var _a = data, title = _a.title, description = _a.description, contract = _a.contract, code_id = _a.code_id, msg = _a.msg;
        return new MigrateContractProposal(title, description, contract, Number.parseInt(code_id), msg);
    };
    MigrateContractProposal.prototype.toData = function(_) {
        var _a = this, title = _a.title, description = _a.description, contract = _a.contract, new_code_id = _a.new_code_id, migrate_msg = _a.migrate_msg;
        return {
            "@type": "/cosmwasm.wasm.v1.MigrateContractProposal",
            title: title,
            description: description,
            contract: contract,
            code_id: new_code_id.toFixed(),
            msg: (0, $26Eqx.removeNull)(migrate_msg)
        };
    };
    return MigrateContractProposal;
}($26Eqx.JSONSerializable);
module.exports.MigrateContractProposal = $9cc1e516fea051df$var$MigrateContractProposal;

});

parcelRegister("8rxuM", function(module, exports) {
"use strict";
var $625ad3d56443ad66$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $625ad3d56443ad66$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $625ad3d56443ad66$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $625ad3d56443ad66$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $625ad3d56443ad66$var$__createBinding(result, mod, k);
    }
    $625ad3d56443ad66$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PinCodesProposal = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $dnKf8 = parcelRequire("dnKf8");

var $625ad3d56443ad66$var$Long = $625ad3d56443ad66$var$__importStar((parcelRequire("9A55m")));
/**
 * PinCodesProposal gov proposal content type to pin a set of code ids in the
 * wasmvm cache.
 */ var $625ad3d56443ad66$var$PinCodesProposal = /** @class */ function(_super) {
    $625ad3d56443ad66$var$__extends(PinCodesProposal, _super);
    /**
     * @param title a short summary
     * @param description a human readable text
     * @param code_ids the address of the smart code_ids
     */ function PinCodesProposal(title, description, code_ids) {
        var _this = _super.call(this) || this;
        _this.title = title;
        _this.description = description;
        _this.code_ids = code_ids;
        return _this;
    }
    PinCodesProposal.fromAmino = function(data, _) {
        var _a = data.value, title = _a.title, description = _a.description, code_ids = _a.code_ids;
        return new PinCodesProposal(title, description, code_ids.map(function(cid) {
            return Number.parseInt(cid);
        }));
    };
    PinCodesProposal.prototype.toAmino = function(_) {
        var _a = this, title = _a.title, description = _a.description, code_ids = _a.code_ids;
        return {
            type: "wasm/PinCodesProposal",
            value: {
                title: title,
                description: description,
                code_ids: code_ids.map(function(cid) {
                    return cid.toFixed();
                })
            }
        };
    };
    PinCodesProposal.fromProto = function(proto, _) {
        return new PinCodesProposal(proto.title, proto.description, proto.codeIds.map(function(codeId) {
            return codeId.toNumber();
        }));
    };
    PinCodesProposal.prototype.toProto = function(_) {
        var _a = this, title = _a.title, description = _a.description, code_ids = _a.code_ids;
        return $dnKf8.PinCodesProposal.fromPartial({
            title: title,
            description: description,
            codeIds: code_ids.map(function(cid) {
                return $625ad3d56443ad66$var$Long.fromNumber(cid);
            })
        });
    };
    PinCodesProposal.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmwasm.wasm.v1.PinCodesProposal",
            value: $dnKf8.PinCodesProposal.encode(this.toProto(isClassic)).finish()
        });
    };
    PinCodesProposal.unpackAny = function(msgAny, isClassic) {
        return PinCodesProposal.fromProto($dnKf8.PinCodesProposal.decode(msgAny.value), isClassic);
    };
    PinCodesProposal.fromData = function(data, _) {
        var _a = data, title = _a.title, description = _a.description, code_ids = _a.code_ids;
        return new PinCodesProposal(title, description, code_ids.map(function(cid) {
            return Number.parseInt(cid);
        }));
    };
    PinCodesProposal.prototype.toData = function(_) {
        var _a = this, title = _a.title, description = _a.description, code_ids = _a.code_ids;
        return {
            "@type": "/cosmwasm.wasm.v1.PinCodesProposal",
            title: title,
            description: description,
            code_ids: code_ids.map(function(cid) {
                return cid.toFixed();
            })
        };
    };
    return PinCodesProposal;
}($26Eqx.JSONSerializable);
module.exports.PinCodesProposal = $625ad3d56443ad66$var$PinCodesProposal;

});

parcelRegister("1mqc3", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $0fdc29fc618cb3f0$require$Buffer = $gzLuY.Buffer;
"use strict";
var $0fdc29fc618cb3f0$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StoreCodeProposal = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $dnKf8 = parcelRequire("dnKf8");

var $5SZLi = parcelRequire("5SZLi");
/**
 * StoreCodeProposal gov proposal content type to submit WASM code to the system
 */ var $0fdc29fc618cb3f0$var$StoreCodeProposal = /** @class */ function(_super) {
    $0fdc29fc618cb3f0$var$__extends(StoreCodeProposal, _super);
    /**
     * @param title a short summary
     * @param description a human readable text
     * @param run_as the address that is passed to the contract's environment as sender
     * @param wasm_byte_code can be raw or gzip compressed
     * @param instantiate_permission to apply on contract creation, optional
     */ function StoreCodeProposal(title, description, run_as, wasm_byte_code, instantiate_permission) {
        var _this = _super.call(this) || this;
        _this.title = title;
        _this.description = description;
        _this.run_as = run_as;
        _this.wasm_byte_code = wasm_byte_code;
        _this.instantiate_permission = instantiate_permission;
        return _this;
    }
    StoreCodeProposal.fromAmino = function(data, _) {
        var _a = data.value, title = _a.title, description = _a.description, run_as = _a.run_as, wasm_byte_code = _a.wasm_byte_code, instantiate_permission = _a.instantiate_permission;
        return new StoreCodeProposal(title, description, run_as, wasm_byte_code, instantiate_permission ? $5SZLi.AccessConfig.fromAmino(instantiate_permission) : undefined);
    };
    StoreCodeProposal.prototype.toAmino = function(_) {
        var _a = this, title = _a.title, description = _a.description, run_as = _a.run_as, wasm_byte_code = _a.wasm_byte_code, instantiate_permission = _a.instantiate_permission;
        return {
            type: "wasm/StoreCodeProposal",
            value: {
                title: title,
                description: description,
                run_as: run_as,
                wasm_byte_code: wasm_byte_code,
                instantiate_permission: instantiate_permission === null || instantiate_permission === void 0 ? void 0 : instantiate_permission.toAmino()
            }
        };
    };
    StoreCodeProposal.fromData = function(data, _) {
        var title = data.title, description = data.description, run_as = data.run_as, wasm_byte_code = data.wasm_byte_code, instantiate_permission = data.instantiate_permission;
        return new StoreCodeProposal(title, description, run_as, wasm_byte_code, instantiate_permission ? $5SZLi.AccessConfig.fromData(instantiate_permission) : undefined);
    };
    StoreCodeProposal.prototype.toData = function(_) {
        var _a = this, title = _a.title, description = _a.description, run_as = _a.run_as, wasm_byte_code = _a.wasm_byte_code, instantiate_permission = _a.instantiate_permission;
        return {
            "@type": "/cosmwasm.wasm.v1.StoreCodeProposal",
            title: title,
            description: description,
            run_as: run_as,
            wasm_byte_code: wasm_byte_code,
            instantiate_permission: instantiate_permission === null || instantiate_permission === void 0 ? void 0 : instantiate_permission.toData()
        };
    };
    StoreCodeProposal.fromProto = function(proto, _) {
        return new StoreCodeProposal(proto.title, proto.description, proto.runAs, $0fdc29fc618cb3f0$require$Buffer.from(proto.wasmByteCode).toString("base64"), proto.instantiatePermission ? $5SZLi.AccessConfig.fromProto(proto.instantiatePermission) : undefined);
    };
    StoreCodeProposal.prototype.toProto = function(_) {
        var _a = this, title = _a.title, description = _a.description, run_as = _a.run_as, wasm_byte_code = _a.wasm_byte_code, instantiate_permission = _a.instantiate_permission;
        return $dnKf8.StoreCodeProposal.fromPartial({
            title: title,
            description: description,
            runAs: run_as,
            wasmByteCode: $0fdc29fc618cb3f0$require$Buffer.from(wasm_byte_code, "base64"),
            instantiatePermission: instantiate_permission === null || instantiate_permission === void 0 ? void 0 : instantiate_permission.toProto()
        });
    };
    StoreCodeProposal.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmwasm.wasm.v1.StoreCodeProposal",
            value: $dnKf8.StoreCodeProposal.encode(this.toProto(isClassic)).finish()
        });
    };
    StoreCodeProposal.unpackAny = function(msgAny, isClassic) {
        return StoreCodeProposal.fromProto($dnKf8.StoreCodeProposal.decode(msgAny.value), isClassic);
    };
    return StoreCodeProposal;
}($26Eqx.JSONSerializable);
module.exports.StoreCodeProposal = $0fdc29fc618cb3f0$var$StoreCodeProposal;

});
parcelRegister("5SZLi", function(module, exports) {
"use strict";
var $4491e78933695a20$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AccessConfig = module.exports.AccessType = void 0;

var $odsVG = parcelRequire("odsVG");
Object.defineProperty(module.exports, "AccessType", {
    enumerable: true,
    get: function() {
        return $odsVG.AccessType;
    }
});

var $26Eqx = parcelRequire("26Eqx");

var $8MEJi = parcelRequire("8MEJi");
/**
 *
 */ var $4491e78933695a20$var$AccessConfig = /** @class */ function(_super) {
    $4491e78933695a20$var$__extends(AccessConfig, _super);
    /**
     * @param permission access type
     * @param address
     */ function AccessConfig(permission, address) {
        var _this = _super.call(this) || this;
        _this.permission = permission;
        _this.address = address;
        return _this;
    }
    AccessConfig.fromAmino = function(data) {
        return new AccessConfig((0, $8MEJi.convertAccessTypeFromJSON)(data.permission), data.address);
    };
    AccessConfig.prototype.toAmino = function() {
        var res = {
            permission: (0, $odsVG.accessTypeToJSON)(this.permission),
            address: this.address
        };
        return res;
    };
    AccessConfig.fromData = function(data) {
        // FIXME: new core returns human-friendly string like 'Everybody'.
        // but convertAccessTypeFromJSON requires "ACCESS_TYPE_EVERYBODY"
        // TODO: find out why the strings arent't matching
        return new AccessConfig((0, $8MEJi.convertAccessTypeFromJSON)(data.permission), data.address);
    };
    AccessConfig.prototype.toData = function() {
        var res = {
            permission: (0, $odsVG.accessTypeToJSON)(this.permission),
            address: this.address
        };
        return res;
    };
    AccessConfig.fromProto = function(proto) {
        return new AccessConfig(proto.permission, proto.address);
    };
    AccessConfig.prototype.toProto = function() {
        return $odsVG.AccessConfig.fromPartial({
            permission: this.permission,
            address: this.address
        });
    };
    return AccessConfig;
}($26Eqx.JSONSerializable);
module.exports.AccessConfig = $4491e78933695a20$var$AccessConfig;

});
parcelRegister("8MEJi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.convertAccessTypeFromJSON = void 0;

var $odsVG = parcelRequire("odsVG");
// core v2 returns human-friendly string like 'Everybody' by wasm/type/params.go
// but accessTypeFromJSON requires "ACCESS_TYPE_EVERYBODY"
// this function is a wrapper to get AccessType from JSON
function $665266758c79fb1e$var$convertAccessTypeFromJSON(accessType) {
    var converted = accessType;
    switch(accessType){
        case "Everybody":
            converted = "ACCESS_TYPE_EVERYBODY";
            break;
        case "Nobody":
            converted = "ACCESS_TYPE_NOBODY";
            break;
        case "OnlyAddress":
            converted = "ACCESS_TYPE_ONLY_ADDRESS";
            break;
        case "Unspecified":
            converted = "ACCESS_TYPE_UNSPECIFIED";
            break;
    }
    return (0, $odsVG.accessTypeFromJSON)(converted);
}
module.exports.convertAccessTypeFromJSON = $665266758c79fb1e$var$convertAccessTypeFromJSON;

});



parcelRegister("eNZVt", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $ac75ad7fa8320d6a$require$Buffer = $gzLuY.Buffer;
"use strict";
var $ac75ad7fa8320d6a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SudoContractProposal = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $dnKf8 = parcelRequire("dnKf8");
var $ac75ad7fa8320d6a$var$SudoContractProposal = /** @class */ function(_super) {
    $ac75ad7fa8320d6a$var$__extends(SudoContractProposal, _super);
    /**
     * @param title a short summary
     * @param description a human readable text
     * @param contract contract address to be migrated from
     * @param msg JSON message to configure the migrate state of the contract
     */ function SudoContractProposal(title, description, contract, msg // json object or string
    ) {
        var _this = _super.call(this) || this;
        _this.title = title;
        _this.description = description;
        _this.contract = contract;
        _this.msg = msg;
        return _this;
    }
    SudoContractProposal.fromAmino = function(data, _) {
        var _a = data.value, title = _a.title, description = _a.description, contract = _a.contract, msg = _a.msg;
        return new SudoContractProposal(title, description, contract, msg);
    };
    SudoContractProposal.prototype.toAmino = function(_) {
        var _a = this, title = _a.title, description = _a.description, contract = _a.contract, msg = _a.msg;
        return {
            type: "wasm/SudoContractProposal",
            value: {
                title: title,
                description: description,
                contract: contract,
                msg: (0, $26Eqx.removeNull)(msg)
            }
        };
    };
    SudoContractProposal.fromProto = function(proto, _) {
        return new SudoContractProposal(proto.title, proto.description, proto.contract, JSON.parse($ac75ad7fa8320d6a$require$Buffer.from(proto.msg).toString("utf-8")));
    };
    SudoContractProposal.prototype.toProto = function(_) {
        var _a = this, title = _a.title, description = _a.description, contract = _a.contract, msg = _a.msg;
        return $dnKf8.SudoContractProposal.fromPartial({
            title: title,
            description: description,
            contract: contract,
            msg: $ac75ad7fa8320d6a$require$Buffer.from(JSON.stringify(msg), "utf-8")
        });
    };
    SudoContractProposal.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmwasm.wasm.v1.SudoContractProposal",
            value: $dnKf8.SudoContractProposal.encode(this.toProto(isClassic)).finish()
        });
    };
    SudoContractProposal.unpackAny = function(msgAny, isClassic) {
        return SudoContractProposal.fromProto($dnKf8.SudoContractProposal.decode(msgAny.value), isClassic);
    };
    SudoContractProposal.fromData = function(data, _) {
        var _a = data, title = _a.title, description = _a.description, contract = _a.contract, msg = _a.msg;
        return new SudoContractProposal(title, description, contract, msg);
    };
    SudoContractProposal.prototype.toData = function(_) {
        var _a = this, title = _a.title, description = _a.description, contract = _a.contract, msg = _a.msg;
        return {
            "@type": "/cosmwasm.wasm.v1.SudoContractProposal",
            title: title,
            description: description,
            contract: contract,
            msg: (0, $26Eqx.removeNull)(msg)
        };
    };
    return SudoContractProposal;
}($26Eqx.JSONSerializable);
module.exports.SudoContractProposal = $ac75ad7fa8320d6a$var$SudoContractProposal;

});

parcelRegister("bCCbj", function(module, exports) {
"use strict";
var $8760dc56f1b63421$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $8760dc56f1b63421$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8760dc56f1b63421$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $8760dc56f1b63421$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $8760dc56f1b63421$var$__createBinding(result, mod, k);
    }
    $8760dc56f1b63421$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UnpinCodesProposal = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $dnKf8 = parcelRequire("dnKf8");

var $8760dc56f1b63421$var$Long = $8760dc56f1b63421$var$__importStar((parcelRequire("9A55m")));
/**
 * UnpinCodesProposal gov proposal content type to unpin a set of code ids in
 * the wasmvm cache.
 */ var $8760dc56f1b63421$var$UnpinCodesProposal = /** @class */ function(_super) {
    $8760dc56f1b63421$var$__extends(UnpinCodesProposal, _super);
    /**
     * @param title a short summary
     * @param description a human readable text
     * @param code_ids the address of the smart code_ids
     */ function UnpinCodesProposal(title, description, code_ids) {
        var _this = _super.call(this) || this;
        _this.title = title;
        _this.description = description;
        _this.code_ids = code_ids;
        return _this;
    }
    UnpinCodesProposal.fromAmino = function(data, _) {
        var _a = data.value, title = _a.title, description = _a.description, code_ids = _a.code_ids;
        return new UnpinCodesProposal(title, description, code_ids.map(function(cid) {
            return Number.parseInt(cid);
        }));
    };
    UnpinCodesProposal.prototype.toAmino = function(_) {
        var _a = this, title = _a.title, description = _a.description, code_ids = _a.code_ids;
        return {
            type: "wasm/UnpinCodesProposal",
            value: {
                title: title,
                description: description,
                code_ids: code_ids.map(function(cid) {
                    return cid.toFixed();
                })
            }
        };
    };
    UnpinCodesProposal.fromProto = function(proto, _) {
        return new UnpinCodesProposal(proto.title, proto.description, proto.codeIds.map(function(codeId) {
            return codeId.toNumber();
        }));
    };
    UnpinCodesProposal.prototype.toProto = function(_) {
        var _a = this, title = _a.title, description = _a.description, code_ids = _a.code_ids;
        return $dnKf8.UnpinCodesProposal.fromPartial({
            title: title,
            description: description,
            codeIds: code_ids.map(function(cid) {
                return $8760dc56f1b63421$var$Long.fromNumber(cid);
            })
        });
    };
    UnpinCodesProposal.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmwasm.wasm.v1.UnpinCodesProposal",
            value: $dnKf8.UnpinCodesProposal.encode(this.toProto(isClassic)).finish()
        });
    };
    UnpinCodesProposal.unpackAny = function(msgAny, isClassic) {
        return UnpinCodesProposal.fromProto($dnKf8.UnpinCodesProposal.decode(msgAny.value), isClassic);
    };
    UnpinCodesProposal.fromData = function(data, _) {
        var _a = data, title = _a.title, description = _a.description, code_ids = _a.code_ids;
        return new UnpinCodesProposal(title, description, code_ids.map(function(cid) {
            return Number.parseInt(cid);
        }));
    };
    UnpinCodesProposal.prototype.toData = function(_) {
        var _a = this, title = _a.title, description = _a.description, code_ids = _a.code_ids;
        return {
            "@type": "/cosmwasm.wasm.v1.UnpinCodesProposal",
            title: title,
            description: description,
            code_ids: code_ids.map(function(cid) {
                return cid.toFixed();
            })
        };
    };
    return UnpinCodesProposal;
}($26Eqx.JSONSerializable);
module.exports.UnpinCodesProposal = $8760dc56f1b63421$var$UnpinCodesProposal;

});

parcelRegister("9bzUa", function(module, exports) {
"use strict";
var $6b00fe166ebb4897$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UpdateAdminProposal = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $dnKf8 = parcelRequire("dnKf8");
/** UpdateAdminProposal gov proposal content type to set an admin for a contract. */ var $6b00fe166ebb4897$var$UpdateAdminProposal = /** @class */ function(_super) {
    $6b00fe166ebb4897$var$__extends(UpdateAdminProposal, _super);
    /**
     * @param title a short summary
     * @param description a human readable text
     * @param contract the address of the smart contract
     * @param new_admin address to be set
     */ function UpdateAdminProposal(title, description, contract, new_admin) {
        var _this = _super.call(this) || this;
        _this.title = title;
        _this.description = description;
        _this.contract = contract;
        _this.new_admin = new_admin;
        return _this;
    }
    UpdateAdminProposal.fromAmino = function(data, _) {
        var _a = data.value, title = _a.title, description = _a.description, contract = _a.contract, new_admin = _a.new_admin;
        return new UpdateAdminProposal(title, description, contract, new_admin);
    };
    UpdateAdminProposal.prototype.toAmino = function(_) {
        var _a = this, title = _a.title, description = _a.description, contract = _a.contract, new_admin = _a.new_admin;
        return {
            type: "wasm/UpdateAdminProposal",
            value: {
                title: title,
                description: description,
                contract: contract,
                new_admin: new_admin
            }
        };
    };
    UpdateAdminProposal.fromProto = function(proto, _) {
        return new UpdateAdminProposal(proto.title, proto.description, proto.contract, proto.newAdmin);
    };
    UpdateAdminProposal.prototype.toProto = function(_) {
        var _a = this, title = _a.title, description = _a.description, contract = _a.contract, new_admin = _a.new_admin;
        return $dnKf8.UpdateAdminProposal.fromPartial({
            title: title,
            description: description,
            contract: contract,
            newAdmin: new_admin
        });
    };
    UpdateAdminProposal.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmwasm.wasm.v1.UpdateAdminProposal",
            value: $dnKf8.UpdateAdminProposal.encode(this.toProto(isClassic)).finish()
        });
    };
    UpdateAdminProposal.unpackAny = function(msgAny, isClassic) {
        return UpdateAdminProposal.fromProto($dnKf8.UpdateAdminProposal.decode(msgAny.value), isClassic);
    };
    UpdateAdminProposal.fromData = function(data, _) {
        var _a = data, title = _a.title, description = _a.description, contract = _a.contract, new_admin = _a.new_admin;
        return new UpdateAdminProposal(title, description, contract, new_admin);
    };
    UpdateAdminProposal.prototype.toData = function(_) {
        var _a = this, title = _a.title, description = _a.description, contract = _a.contract, new_admin = _a.new_admin;
        return {
            "@type": "/cosmwasm.wasm.v1.UpdateAdminProposal",
            title: title,
            description: description,
            contract: contract,
            new_admin: new_admin
        };
    };
    return UpdateAdminProposal;
}($26Eqx.JSONSerializable);
module.exports.UpdateAdminProposal = $6b00fe166ebb4897$var$UpdateAdminProposal;

});

parcelRegister("3JSOZ", function(module, exports) {
"use strict";
var $2b90197944e176b2$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UpdateInstantiateConfigProposal = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $dnKf8 = parcelRequire("dnKf8");

var $4QTyo = parcelRequire("4QTyo");
/**
 * UpdateInstantiateConfigProposal gov proposal content type to pin a set of code ids in the
 * wasmvm cache.
 */ var $2b90197944e176b2$var$UpdateInstantiateConfigProposal = /** @class */ function(_super) {
    $2b90197944e176b2$var$__extends(UpdateInstantiateConfigProposal, _super);
    /**
     * @param title a short summary
     * @param description a human readable text
     * @param access_config_updates the address of the smart access_config_updates
     */ function UpdateInstantiateConfigProposal(title, description, access_config_updates) {
        var _this = _super.call(this) || this;
        _this.title = title;
        _this.description = description;
        _this.access_config_updates = access_config_updates;
        return _this;
    }
    UpdateInstantiateConfigProposal.fromAmino = function(data, _) {
        var _a = data.value, title = _a.title, description = _a.description, access_config_updates = _a.access_config_updates;
        return new UpdateInstantiateConfigProposal(title, description, access_config_updates.map(function(acu) {
            return $4QTyo.AccessConfigUpdate.fromAmino(acu);
        }));
    };
    UpdateInstantiateConfigProposal.prototype.toAmino = function(_) {
        var _a = this, title = _a.title, description = _a.description, access_config_updates = _a.access_config_updates;
        return {
            type: "wasm/UpdateInstantiateConfigProposal",
            value: {
                title: title,
                description: description,
                access_config_updates: access_config_updates.map(function(acu) {
                    return acu.toAmino();
                })
            }
        };
    };
    UpdateInstantiateConfigProposal.fromProto = function(proto, _) {
        return new UpdateInstantiateConfigProposal(proto.title, proto.description, proto.accessConfigUpdates.map(function(acu) {
            return $4QTyo.AccessConfigUpdate.fromProto(acu);
        }));
    };
    UpdateInstantiateConfigProposal.prototype.toProto = function(_) {
        var _a = this, title = _a.title, description = _a.description, access_config_updates = _a.access_config_updates;
        return $dnKf8.UpdateInstantiateConfigProposal.fromPartial({
            title: title,
            description: description,
            accessConfigUpdates: access_config_updates.map(function(acu) {
                return acu.toProto();
            })
        });
    };
    UpdateInstantiateConfigProposal.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmwasm.wasm.v1.UpdateInstantiateConfigProposal",
            value: $dnKf8.UpdateInstantiateConfigProposal.encode(this.toProto(isClassic)).finish()
        });
    };
    UpdateInstantiateConfigProposal.unpackAny = function(msgAny, isClassic) {
        return UpdateInstantiateConfigProposal.fromProto($dnKf8.UpdateInstantiateConfigProposal.decode(msgAny.value), isClassic);
    };
    UpdateInstantiateConfigProposal.fromData = function(data, _) {
        var _a = data, title = _a.title, description = _a.description, access_config_updates = _a.access_config_updates;
        return new UpdateInstantiateConfigProposal(title, description, access_config_updates.map(function(acu) {
            return $4QTyo.AccessConfigUpdate.fromData(acu);
        }));
    };
    UpdateInstantiateConfigProposal.prototype.toData = function(_) {
        var _a = this, title = _a.title, description = _a.description, access_config_updates = _a.access_config_updates;
        return {
            "@type": "/cosmwasm.wasm.v1.UpdateInstantiateConfigProposal",
            title: title,
            description: description,
            access_config_updates: access_config_updates.map(function(acu) {
                return acu.toData();
            })
        };
    };
    return UpdateInstantiateConfigProposal;
}($26Eqx.JSONSerializable);
module.exports.UpdateInstantiateConfigProposal = $2b90197944e176b2$var$UpdateInstantiateConfigProposal;

});
parcelRegister("4QTyo", function(module, exports) {
"use strict";
var $38871c96cb0c17e8$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $38871c96cb0c17e8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $38871c96cb0c17e8$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $38871c96cb0c17e8$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $38871c96cb0c17e8$var$__createBinding(result, mod, k);
    }
    $38871c96cb0c17e8$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AccessConfigUpdate = void 0;

var $dnKf8 = parcelRequire("dnKf8");

var $26Eqx = parcelRequire("26Eqx");

var $5SZLi = parcelRequire("5SZLi");

var $38871c96cb0c17e8$var$Long = $38871c96cb0c17e8$var$__importStar((parcelRequire("9A55m")));
/**
 *
 */ var $38871c96cb0c17e8$var$AccessConfigUpdate = /** @class */ function(_super) {
    $38871c96cb0c17e8$var$__extends(AccessConfigUpdate, _super);
    /**
     * @param code_id the reference to the stored WASM code to be updated
     * @param instantiate_permission to apply to the set of code ids
     */ function AccessConfigUpdate(code_id, instantiate_permission) {
        var _this = _super.call(this) || this;
        _this.code_id = code_id;
        _this.instantiate_permission = instantiate_permission;
        return _this;
    }
    AccessConfigUpdate.fromAmino = function(data) {
        return new AccessConfigUpdate(Number.parseInt(data.code_id), data.instantiate_permission ? $5SZLi.AccessConfig.fromAmino(data.instantiate_permission) : undefined);
    };
    AccessConfigUpdate.prototype.toAmino = function() {
        var _a;
        var res = {
            code_id: this.code_id.toFixed(),
            instantiate_permission: (_a = this.instantiate_permission) === null || _a === void 0 ? void 0 : _a.toAmino()
        };
        return res;
    };
    AccessConfigUpdate.fromData = function(data) {
        return new AccessConfigUpdate(Number.parseInt(data.code_id), data.instantiate_permission ? $5SZLi.AccessConfig.fromData(data.instantiate_permission) : undefined);
    };
    AccessConfigUpdate.prototype.toData = function() {
        var _a;
        var res = {
            code_id: this.code_id.toFixed(),
            instantiate_permission: (_a = this.instantiate_permission) === null || _a === void 0 ? void 0 : _a.toData()
        };
        return res;
    };
    AccessConfigUpdate.fromProto = function(proto) {
        return new AccessConfigUpdate(proto.codeId.toNumber(), proto.instantiatePermission ? $5SZLi.AccessConfig.fromProto(proto.instantiatePermission) : undefined);
    };
    AccessConfigUpdate.prototype.toProto = function() {
        var _a;
        return $dnKf8.AccessConfigUpdate.fromPartial({
            codeId: $38871c96cb0c17e8$var$Long.fromNumber(this.code_id),
            instantiatePermission: (_a = this.instantiate_permission) === null || _a === void 0 ? void 0 : _a.toProto()
        });
    };
    return AccessConfigUpdate;
}($26Eqx.JSONSerializable);
module.exports.AccessConfigUpdate = $38871c96cb0c17e8$var$AccessConfigUpdate;

});



parcelRegister("8pUAL", function(module, exports) {
"use strict";
var $620c8e88f8f03002$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $620c8e88f8f03002$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $620c8e88f8f03002$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$620c8e88f8f03002$var$__exportStar((parcelRequire("fcJaW")), module.exports);

$620c8e88f8f03002$var$__exportStar((parcelRequire("ejUp8")), module.exports);

});
parcelRegister("fcJaW", function(module, exports) {
"use strict";
var $b11b04eb31bc90d4$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AddBurnTaxExemptionAddressProposal = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $l6Rvy = parcelRequire("l6Rvy");
/**
 * AddBurnTaxExemptionAddressProposal gov proposal content type to submit exemption address for burn tax
 */ var $b11b04eb31bc90d4$var$AddBurnTaxExemptionAddressProposal = /** @class */ function(_super) {
    $b11b04eb31bc90d4$var$__extends(AddBurnTaxExemptionAddressProposal, _super);
    /**
     * @param title a short summary
     * @param description a human readable text
     * @param addresses the address that are exempt
     */ function AddBurnTaxExemptionAddressProposal(title, description, addresses) {
        var _this = _super.call(this) || this;
        _this.title = title;
        _this.description = description;
        _this.addresses = addresses;
        return _this;
    }
    AddBurnTaxExemptionAddressProposal.fromAmino = function(data, isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        var _a = data.value, title = _a.title, description = _a.description, addresses = _a.addresses;
        return new AddBurnTaxExemptionAddressProposal(title, description, addresses);
    };
    AddBurnTaxExemptionAddressProposal.prototype.toAmino = function(isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        var _a = this, title = _a.title, description = _a.description, addresses = _a.addresses;
        return {
            type: "treasury/AddBurnTaxExemptionAddressProposal",
            value: {
                title: title,
                description: description,
                addresses: addresses
            }
        };
    };
    AddBurnTaxExemptionAddressProposal.fromData = function(data, isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        var title = data.title, description = data.description, addresses = data.addresses;
        return new AddBurnTaxExemptionAddressProposal(title, description, addresses);
    };
    AddBurnTaxExemptionAddressProposal.prototype.toData = function(isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        var _a = this, title = _a.title, description = _a.description, addresses = _a.addresses;
        return {
            "@type": "/terra.treasury.v1beta1.AddBurnTaxExemptionAddressProposal",
            title: title,
            description: description,
            addresses: addresses
        };
    };
    AddBurnTaxExemptionAddressProposal.fromProto = function(proto, isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        return new AddBurnTaxExemptionAddressProposal(proto.title, proto.description, proto.addresses);
    };
    AddBurnTaxExemptionAddressProposal.prototype.toProto = function(isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        var _a = this, title = _a.title, description = _a.description, addresses = _a.addresses;
        return $l6Rvy.AddBurnTaxExemptionAddressProposal.fromPartial({
            title: title,
            description: description,
            addresses: addresses
        });
    };
    AddBurnTaxExemptionAddressProposal.prototype.packAny = function(isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        return $c5FxR.Any.fromPartial({
            typeUrl: "/terra.treasury.v1beta1.AddBurnTaxExemptionAddressProposal",
            value: $l6Rvy.AddBurnTaxExemptionAddressProposal.encode(this.toProto(isClassic)).finish()
        });
    };
    AddBurnTaxExemptionAddressProposal.unpackAny = function(msgAny, isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        return AddBurnTaxExemptionAddressProposal.fromProto($l6Rvy.AddBurnTaxExemptionAddressProposal.decode(msgAny.value), isClassic);
    };
    return AddBurnTaxExemptionAddressProposal;
}($26Eqx.JSONSerializable);
module.exports.AddBurnTaxExemptionAddressProposal = $b11b04eb31bc90d4$var$AddBurnTaxExemptionAddressProposal;

});
parcelRegister("l6Rvy", function(module, exports) {
"use strict";
var $f5e3aa1325c50184$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RemoveBurnTaxExemptionAddressProposal = module.exports.AddBurnTaxExemptionAddressProposal = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $f5e3aa1325c50184$var$long_1 = $f5e3aa1325c50184$var$__importDefault((parcelRequire("9A55m")));

const $f5e3aa1325c50184$var$minimal_1 = $f5e3aa1325c50184$var$__importDefault((parcelRequire("i2pIU")));
module.exports.protobufPackage = "terra.treasury.v1beta1";
const $f5e3aa1325c50184$var$baseAddBurnTaxExemptionAddressProposal = {
    title: "",
    description: "",
    addresses: ""
};
module.exports.AddBurnTaxExemptionAddressProposal = {
    encode (message, writer = $f5e3aa1325c50184$var$minimal_1.default.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        for (const v of message.addresses)writer.uint32(26).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f5e3aa1325c50184$var$minimal_1.default.Reader ? input : new $f5e3aa1325c50184$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $f5e3aa1325c50184$var$baseAddBurnTaxExemptionAddressProposal);
        message.addresses = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.addresses.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $f5e3aa1325c50184$var$baseAddBurnTaxExemptionAddressProposal);
        message.addresses = [];
        if (object.title !== undefined && object.title !== null) message.title = String(object.title);
        else message.title = "";
        if (object.description !== undefined && object.description !== null) message.description = String(object.description);
        else message.description = "";
        if (object.addresses !== undefined && object.addresses !== null) for (const e of object.addresses)message.addresses.push(String(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        if (message.addresses) obj.addresses = message.addresses.map((e)=>e);
        else obj.addresses = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $f5e3aa1325c50184$var$baseAddBurnTaxExemptionAddressProposal);
        message.addresses = [];
        if (object.title !== undefined && object.title !== null) message.title = object.title;
        else message.title = "";
        if (object.description !== undefined && object.description !== null) message.description = object.description;
        else message.description = "";
        if (object.addresses !== undefined && object.addresses !== null) for (const e of object.addresses)message.addresses.push(e);
        return message;
    }
};
const $f5e3aa1325c50184$var$baseRemoveBurnTaxExemptionAddressProposal = {
    title: "",
    description: "",
    addresses: ""
};
module.exports.RemoveBurnTaxExemptionAddressProposal = {
    encode (message, writer = $f5e3aa1325c50184$var$minimal_1.default.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        for (const v of message.addresses)writer.uint32(26).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f5e3aa1325c50184$var$minimal_1.default.Reader ? input : new $f5e3aa1325c50184$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $f5e3aa1325c50184$var$baseRemoveBurnTaxExemptionAddressProposal);
        message.addresses = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.addresses.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $f5e3aa1325c50184$var$baseRemoveBurnTaxExemptionAddressProposal);
        message.addresses = [];
        if (object.title !== undefined && object.title !== null) message.title = String(object.title);
        else message.title = "";
        if (object.description !== undefined && object.description !== null) message.description = String(object.description);
        else message.description = "";
        if (object.addresses !== undefined && object.addresses !== null) for (const e of object.addresses)message.addresses.push(String(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        if (message.addresses) obj.addresses = message.addresses.map((e)=>e);
        else obj.addresses = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $f5e3aa1325c50184$var$baseRemoveBurnTaxExemptionAddressProposal);
        message.addresses = [];
        if (object.title !== undefined && object.title !== null) message.title = object.title;
        else message.title = "";
        if (object.description !== undefined && object.description !== null) message.description = object.description;
        else message.description = "";
        if (object.addresses !== undefined && object.addresses !== null) for (const e of object.addresses)message.addresses.push(e);
        return message;
    }
};
if ($f5e3aa1325c50184$var$minimal_1.default.util.Long !== $f5e3aa1325c50184$var$long_1.default) {
    $f5e3aa1325c50184$var$minimal_1.default.util.Long = $f5e3aa1325c50184$var$long_1.default;
    $f5e3aa1325c50184$var$minimal_1.default.configure();
}

});


parcelRegister("ejUp8", function(module, exports) {
"use strict";
var $a6ce97c1ade60b5a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RemoveBurnTaxExemptionAddressProposal = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $l6Rvy = parcelRequire("l6Rvy");
/**
 * RemoveBurnTaxExemptionAddressProposal gov proposal content type to remove exemption address for burn tax
 */ var $a6ce97c1ade60b5a$var$RemoveBurnTaxExemptionAddressProposal = /** @class */ function(_super) {
    $a6ce97c1ade60b5a$var$__extends(RemoveBurnTaxExemptionAddressProposal, _super);
    /**
     * @param title a short summary
     * @param description a human readable text
     * @param addresses the address that are exempt
     */ function RemoveBurnTaxExemptionAddressProposal(title, description, addresses) {
        var _this = _super.call(this) || this;
        _this.title = title;
        _this.description = description;
        _this.addresses = addresses;
        return _this;
    }
    RemoveBurnTaxExemptionAddressProposal.fromAmino = function(data, isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        var _a = data.value, title = _a.title, description = _a.description, addresses = _a.addresses;
        return new RemoveBurnTaxExemptionAddressProposal(title, description, addresses);
    };
    RemoveBurnTaxExemptionAddressProposal.prototype.toAmino = function(isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        var _a = this, title = _a.title, description = _a.description, addresses = _a.addresses;
        return {
            type: "treasury/RemoveBurnTaxExemptionAddressProposal",
            value: {
                title: title,
                description: description,
                addresses: addresses
            }
        };
    };
    RemoveBurnTaxExemptionAddressProposal.fromData = function(data, isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        var title = data.title, description = data.description, addresses = data.addresses;
        return new RemoveBurnTaxExemptionAddressProposal(title, description, addresses);
    };
    RemoveBurnTaxExemptionAddressProposal.prototype.toData = function(isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        var _a = this, title = _a.title, description = _a.description, addresses = _a.addresses;
        return {
            "@type": "/terra.treasury.v1beta1.RemoveBurnTaxExemptionAddressProposal",
            title: title,
            description: description,
            addresses: addresses
        };
    };
    RemoveBurnTaxExemptionAddressProposal.fromProto = function(proto, isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        return new RemoveBurnTaxExemptionAddressProposal(proto.title, proto.description, proto.addresses);
    };
    RemoveBurnTaxExemptionAddressProposal.prototype.toProto = function(isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        var _a = this, title = _a.title, description = _a.description, addresses = _a.addresses;
        return $l6Rvy.RemoveBurnTaxExemptionAddressProposal.fromPartial({
            title: title,
            description: description,
            addresses: addresses
        });
    };
    RemoveBurnTaxExemptionAddressProposal.prototype.packAny = function(isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        return $c5FxR.Any.fromPartial({
            typeUrl: "/terra.treasury.v1beta1.RemoveBurnTaxExemptionAddressProposal",
            value: $l6Rvy.RemoveBurnTaxExemptionAddressProposal.encode(this.toProto(isClassic)).finish()
        });
    };
    RemoveBurnTaxExemptionAddressProposal.unpackAny = function(msgAny, isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        return RemoveBurnTaxExemptionAddressProposal.fromProto($l6Rvy.RemoveBurnTaxExemptionAddressProposal.decode(msgAny.value), isClassic);
    };
    return RemoveBurnTaxExemptionAddressProposal;
}($26Eqx.JSONSerializable);
module.exports.RemoveBurnTaxExemptionAddressProposal = $a6ce97c1ade60b5a$var$RemoveBurnTaxExemptionAddressProposal;

});




parcelRegister("3EMj8", function(module, exports) {
"use strict";
var $2a9a946d2fadbb28$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $2a9a946d2fadbb28$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2a9a946d2fadbb28$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $2a9a946d2fadbb28$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $2a9a946d2fadbb28$var$__createBinding(result, mod, k);
    }
    $2a9a946d2fadbb28$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgVote = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $br4pC = parcelRequire("br4pC");

var $9q3yq = parcelRequire("9q3yq");

var $2a9a946d2fadbb28$var$Long = $2a9a946d2fadbb28$var$__importStar((parcelRequire("9A55m")));
/**
 * Vote for a proposal
 */ var $2a9a946d2fadbb28$var$MsgVote = /** @class */ function(_super) {
    $2a9a946d2fadbb28$var$__extends(MsgVote, _super);
    /**
     * @param proposal_id ID of proposal to vote on
     * @param voter voter's account address
     * @param option one of voting options
     */ function MsgVote(proposal_id, voter, option) {
        var _this = _super.call(this) || this;
        _this.proposal_id = proposal_id;
        _this.voter = voter;
        _this.option = option;
        return _this;
    }
    MsgVote.fromAmino = function(data, _) {
        _;
        var _a = data.value, proposal_id = _a.proposal_id, voter = _a.voter, option = _a.option;
        return new MsgVote(Number.parseInt(proposal_id), voter, option);
    };
    MsgVote.prototype.toAmino = function(isClassic) {
        var _a = this, proposal_id = _a.proposal_id, voter = _a.voter, option = _a.option;
        return {
            type: isClassic ? "gov/MsgVote" : "cosmos-sdk/MsgVote",
            value: {
                proposal_id: proposal_id.toFixed(),
                voter: voter,
                option: option
            }
        };
    };
    MsgVote.fromData = function(data, _) {
        _;
        var proposal_id = data.proposal_id, voter = data.voter, option = data.option;
        return new MsgVote(Number.parseInt(proposal_id), voter, option);
    };
    MsgVote.prototype.toData = function(_) {
        _;
        var _a = this, proposal_id = _a.proposal_id, voter = _a.voter, option = _a.option;
        return {
            "@type": "/cosmos.gov.v1beta1.MsgVote",
            proposal_id: proposal_id.toFixed(),
            voter: voter,
            option: option
        };
    };
    MsgVote.fromProto = function(proto, _) {
        _;
        return new MsgVote(proto.proposalId.toNumber(), proto.voter, proto.option);
    };
    MsgVote.prototype.toProto = function(_) {
        _;
        var _a = this, proposal_id = _a.proposal_id, voter = _a.voter, option = _a.option;
        return $br4pC.MsgVote.fromPartial({
            option: option,
            proposalId: $2a9a946d2fadbb28$var$Long.fromNumber(proposal_id),
            voter: voter
        });
    };
    MsgVote.prototype.packAny = function(_) {
        _;
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmos.gov.v1beta1.MsgVote",
            value: $br4pC.MsgVote.encode(this.toProto()).finish()
        });
    };
    MsgVote.unpackAny = function(msgAny, _) {
        _;
        return MsgVote.fromProto($br4pC.MsgVote.decode(msgAny.value));
    };
    return MsgVote;
}($26Eqx.JSONSerializable);
module.exports.MsgVote = $2a9a946d2fadbb28$var$MsgVote;
(function(MsgVote) {
    MsgVote.Option = $9q3yq.VoteOption;
})($2a9a946d2fadbb28$var$MsgVote = module.exports.MsgVote || (module.exports.MsgVote = {}));
module.exports.MsgVote = $2a9a946d2fadbb28$var$MsgVote;

});

parcelRegister("eFXUK", function(module, exports) {
"use strict";
var $aaf35ebfd4025c64$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $aaf35ebfd4025c64$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $aaf35ebfd4025c64$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $aaf35ebfd4025c64$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $aaf35ebfd4025c64$var$__createBinding(result, mod, k);
    }
    $aaf35ebfd4025c64$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgVoteWeighted = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $gJKqv = parcelRequire("gJKqv");

var $c5FxR = parcelRequire("c5FxR");

var $br4pC = parcelRequire("br4pC");

var $aaf35ebfd4025c64$var$Long = $aaf35ebfd4025c64$var$__importStar((parcelRequire("9A55m")));
/**
 * Weighted vote for a proposal
 */ var $aaf35ebfd4025c64$var$MsgVoteWeighted = /** @class */ function(_super) {
    $aaf35ebfd4025c64$var$__extends(MsgVoteWeighted, _super);
    /**
     * @param proposal_id ID of proposal to vote on
     * @param voter voter's account address
     * @param option one of voting options
     */ function MsgVoteWeighted(proposal_id, voter, options) {
        var _this = _super.call(this) || this;
        _this.proposal_id = proposal_id;
        _this.voter = voter;
        _this.options = options;
        return _this;
    }
    MsgVoteWeighted.fromAmino = function(data, _) {
        _;
        var _a = data.value, proposal_id = _a.proposal_id, voter = _a.voter, options = _a.options;
        return new MsgVoteWeighted(Number.parseInt(proposal_id), voter, options.map(function(o) {
            return $gJKqv.WeightedVoteOption.fromAmino(o);
        }));
    };
    MsgVoteWeighted.prototype.toAmino = function(isClassic) {
        var _a = this, proposal_id = _a.proposal_id, voter = _a.voter, options = _a.options;
        return {
            type: isClassic ? "gov/MsgVoteWeighted" : "cosmos-sdk/MsgVoteWeighted",
            value: {
                proposal_id: proposal_id.toFixed(),
                voter: voter,
                options: options.map(function(o) {
                    return o.toAmino();
                })
            }
        };
    };
    MsgVoteWeighted.fromData = function(data, _) {
        _;
        var proposal_id = data.proposal_id, voter = data.voter, options = data.options;
        return new MsgVoteWeighted(Number.parseInt(proposal_id), voter, options.map(function(o) {
            return $gJKqv.WeightedVoteOption.fromData(o);
        }));
    };
    MsgVoteWeighted.prototype.toData = function(_) {
        _;
        var _a = this, proposal_id = _a.proposal_id, voter = _a.voter, options = _a.options;
        return {
            "@type": "/cosmos.gov.v1beta1.MsgVoteWeighted",
            proposal_id: proposal_id.toFixed(),
            voter: voter,
            options: options.map(function(o) {
                return o.toData();
            })
        };
    };
    MsgVoteWeighted.fromProto = function(proto, _) {
        _;
        return new MsgVoteWeighted(proto.proposalId.toNumber(), proto.voter, proto.options.map(function(o) {
            return $gJKqv.WeightedVoteOption.fromProto(o);
        }));
    };
    MsgVoteWeighted.prototype.toProto = function(_) {
        _;
        var _a = this, proposal_id = _a.proposal_id, voter = _a.voter, options = _a.options;
        return $br4pC.MsgVoteWeighted.fromPartial({
            options: options.map(function(o) {
                return o.toProto();
            }),
            proposalId: $aaf35ebfd4025c64$var$Long.fromNumber(proposal_id),
            voter: voter
        });
    };
    MsgVoteWeighted.prototype.packAny = function(_) {
        _;
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmos.gov.v1beta1.MsgVoteWeighted",
            value: $br4pC.MsgVoteWeighted.encode(this.toProto()).finish()
        });
    };
    MsgVoteWeighted.unpackAny = function(msgAny, _) {
        _;
        return MsgVoteWeighted.fromProto($br4pC.MsgVoteWeighted.decode(msgAny.value));
    };
    return MsgVoteWeighted;
}($26Eqx.JSONSerializable);
module.exports.MsgVoteWeighted = $aaf35ebfd4025c64$var$MsgVoteWeighted;

});
parcelRegister("gJKqv", function(module, exports) {
"use strict";
var $c2f4dcaa02c2c158$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $c2f4dcaa02c2c158$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c2f4dcaa02c2c158$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $c2f4dcaa02c2c158$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c2f4dcaa02c2c158$var$__createBinding(result, mod, k);
    }
    $c2f4dcaa02c2c158$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WeightedVoteOption = module.exports.Vote = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $9q3yq = parcelRequire("9q3yq");

var $5iXRZ = parcelRequire("5iXRZ");

var $c2f4dcaa02c2c158$var$Long = $c2f4dcaa02c2c158$var$__importStar((parcelRequire("9A55m")));
/**
 * Stores vote information for a proposal
 */ var $c2f4dcaa02c2c158$var$Vote = /** @class */ function(_super) {
    $c2f4dcaa02c2c158$var$__extends(Vote, _super);
    /**
     * @param proposal_id ID of proposal to vote on
     * @param voter voter's account address
     * @param options voting options
     */ function Vote(proposal_id, voter, options) {
        var _this = _super.call(this) || this;
        _this.proposal_id = proposal_id;
        _this.voter = voter;
        _this.options = options;
        _this.Option = $9q3yq.VoteOption;
        return _this;
    }
    Vote.fromAmino = function(data, _) {
        _;
        var proposal_id = data.proposal_id, voter = data.voter, options = data.options;
        return new Vote(Number.parseInt(proposal_id), voter, options.map(function(v) {
            return $c2f4dcaa02c2c158$var$WeightedVoteOption.fromAmino(v);
        }));
    };
    Vote.prototype.toAmino = function(_) {
        _;
        var _a = this, proposal_id = _a.proposal_id, voter = _a.voter, options = _a.options;
        var res = {
            proposal_id: proposal_id.toFixed(),
            voter: voter,
            options: options.map(function(v) {
                return v.toAmino();
            })
        };
        return res;
    };
    Vote.fromData = function(data, _) {
        _;
        var proposal_id = data.proposal_id, voter = data.voter, options = data.options;
        return new Vote(Number.parseInt(proposal_id), voter, options.map(function(v) {
            return $c2f4dcaa02c2c158$var$WeightedVoteOption.fromData(v);
        }));
    };
    Vote.prototype.toData = function(_) {
        _;
        var _a = this, proposal_id = _a.proposal_id, voter = _a.voter, options = _a.options;
        var res = {
            proposal_id: proposal_id.toFixed(),
            voter: voter,
            options: options.map(function(v) {
                return v.toData();
            })
        };
        return res;
    };
    Vote.fromProto = function(proto, _) {
        _;
        return new Vote(proto.proposalId.toNumber(), proto.voter, proto.options.map(function(o) {
            return $c2f4dcaa02c2c158$var$WeightedVoteOption.fromProto(o);
        }));
    };
    Vote.prototype.toProto = function(_) {
        _;
        var _a = this, proposal_id = _a.proposal_id, voter = _a.voter, options = _a.options;
        return $9q3yq.Vote.fromPartial({
            options: options.map(function(o) {
                return o.toProto();
            }),
            proposalId: $c2f4dcaa02c2c158$var$Long.fromNumber(proposal_id),
            voter: voter
        });
    };
    return Vote;
}($26Eqx.JSONSerializable);
module.exports.Vote = $c2f4dcaa02c2c158$var$Vote;
(function(Vote) {
    Vote.Option = $9q3yq.VoteOption;
})($c2f4dcaa02c2c158$var$Vote = module.exports.Vote || (module.exports.Vote = {}));
module.exports.Vote = $c2f4dcaa02c2c158$var$Vote;
var $c2f4dcaa02c2c158$var$WeightedVoteOption = /** @class */ function(_super) {
    $c2f4dcaa02c2c158$var$__extends(WeightedVoteOption, _super);
    function WeightedVoteOption(option, weight) {
        var _this = _super.call(this) || this;
        _this.option = option;
        _this.weight = new $5iXRZ.Dec(weight);
        return _this;
    }
    WeightedVoteOption.fromAmino = function(data, _) {
        _;
        var option = data.option, weight = data.weight;
        return new WeightedVoteOption(option, weight);
    };
    WeightedVoteOption.prototype.toAmino = function(_) {
        _;
        var _a = this, option = _a.option, weight = _a.weight;
        return {
            option: option,
            weight: weight.toString()
        };
    };
    WeightedVoteOption.fromData = function(data, _) {
        _;
        var option = data.option, weight = data.weight;
        return new WeightedVoteOption(option, weight);
    };
    WeightedVoteOption.prototype.toData = function(_) {
        _;
        var _a = this, option = _a.option, weight = _a.weight;
        return {
            option: option,
            weight: weight.toString()
        };
    };
    WeightedVoteOption.fromProto = function(proto, _) {
        _;
        return new WeightedVoteOption(proto.option, proto.weight);
    };
    WeightedVoteOption.prototype.toProto = function(_) {
        _;
        var _a = this, option = _a.option, weight = _a.weight;
        return $9q3yq.WeightedVoteOption.fromPartial({
            option: option,
            weight: weight.toString()
        });
    };
    return WeightedVoteOption;
}($26Eqx.JSONSerializable);
module.exports.WeightedVoteOption = $c2f4dcaa02c2c158$var$WeightedVoteOption;

});



parcelRegister("kKox9", function(module, exports) {
"use strict";
var $f1ab22685cb9e2a7$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f1ab22685cb9e2a7$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f1ab22685cb9e2a7$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f1ab22685cb9e2a7$var$__exportStar((parcelRequire("bn7XF")), module.exports);

$f1ab22685cb9e2a7$var$__exportStar((parcelRequire("iWiOC")), module.exports);

});
parcelRegister("bn7XF", function(module, exports) {
"use strict";
var $847804ad993c56a0$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgSwap = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $7yVzo = parcelRequire("7yVzo");

var $5AYHU = parcelRequire("5AYHU");

var $c5FxR = parcelRequire("c5FxR");
/**
 * Executes a market swap between 2 denominations at the exchange rate registered by the
 * Oracle module. The account will lose the amount of coins offered, and receive funds
 * in the requested denomination after a swap fee has been applied.
 */ var $847804ad993c56a0$var$MsgSwap = /** @class */ function(_super) {
    $847804ad993c56a0$var$__extends(MsgSwap, _super);
    /**
     * @param trader trader's account address
     * @param offer_coin coin to be swapped (from)
     * @param ask_denom desired denomination (to)
     */ function MsgSwap(trader, offer_coin, ask_denom) {
        var _this = _super.call(this) || this;
        _this.trader = trader;
        _this.offer_coin = offer_coin;
        _this.ask_denom = ask_denom;
        return _this;
    }
    MsgSwap.fromAmino = function(data, isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        var _a = data.value, trader = _a.trader, offer_coin = _a.offer_coin, ask_denom = _a.ask_denom;
        return new MsgSwap(trader, $7yVzo.Coin.fromAmino(offer_coin), ask_denom);
    };
    MsgSwap.prototype.toAmino = function(isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        var _a = this, trader = _a.trader, offer_coin = _a.offer_coin, ask_denom = _a.ask_denom;
        return {
            type: "market/MsgSwap",
            value: {
                trader: trader,
                offer_coin: offer_coin.toAmino(),
                ask_denom: ask_denom
            }
        };
    };
    MsgSwap.fromProto = function(proto, isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        return new MsgSwap(proto.trader, $7yVzo.Coin.fromProto(proto.offerCoin), proto.askDenom);
    };
    MsgSwap.prototype.toProto = function(isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        var _a = this, trader = _a.trader, offer_coin = _a.offer_coin, ask_denom = _a.ask_denom;
        return $5AYHU.MsgSwap.fromPartial({
            askDenom: ask_denom,
            offerCoin: offer_coin.toProto(),
            trader: trader
        });
    };
    MsgSwap.prototype.packAny = function(isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        return $c5FxR.Any.fromPartial({
            typeUrl: "/terra.market.v1beta1.MsgSwap",
            value: $5AYHU.MsgSwap.encode(this.toProto(isClassic)).finish()
        });
    };
    MsgSwap.unpackAny = function(msgAny, isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        return MsgSwap.fromProto($5AYHU.MsgSwap.decode(msgAny.value), isClassic);
    };
    MsgSwap.fromData = function(data, isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        var trader = data.trader, offer_coin = data.offer_coin, ask_denom = data.ask_denom;
        return new MsgSwap(trader, $7yVzo.Coin.fromData(offer_coin), ask_denom);
    };
    MsgSwap.prototype.toData = function(isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        var _a = this, trader = _a.trader, offer_coin = _a.offer_coin, ask_denom = _a.ask_denom;
        return {
            "@type": "/terra.market.v1beta1.MsgSwap",
            trader: trader,
            offer_coin: offer_coin.toData(),
            ask_denom: ask_denom
        };
    };
    return MsgSwap;
}($26Eqx.JSONSerializable);
module.exports.MsgSwap = $847804ad993c56a0$var$MsgSwap;

});
parcelRegister("5AYHU", function(module, exports) {
"use strict";
var $412f67b778039f13$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GrpcWebImpl = module.exports.MsgSwapSendDesc = module.exports.MsgSwapDesc = module.exports.MsgDesc = module.exports.MsgClientImpl = module.exports.MsgSwapSendResponse = module.exports.MsgSwapSend = module.exports.MsgSwapResponse = module.exports.MsgSwap = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $412f67b778039f13$var$long_1 = $412f67b778039f13$var$__importDefault((parcelRequire("9A55m")));

var $jXVni = parcelRequire("jXVni");

const $412f67b778039f13$var$minimal_1 = $412f67b778039f13$var$__importDefault((parcelRequire("i2pIU")));

var $8K62q = parcelRequire("8K62q");

var $1pqjL = parcelRequire("1pqjL");
module.exports.protobufPackage = "terra.market.v1beta1";
const $412f67b778039f13$var$baseMsgSwap = {
    trader: "",
    askDenom: ""
};
module.exports.MsgSwap = {
    encode (message, writer = $412f67b778039f13$var$minimal_1.default.Writer.create()) {
        if (message.trader !== "") writer.uint32(10).string(message.trader);
        if (message.offerCoin !== undefined) $8K62q.Coin.encode(message.offerCoin, writer.uint32(18).fork()).ldelim();
        if (message.askDenom !== "") writer.uint32(26).string(message.askDenom);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $412f67b778039f13$var$minimal_1.default.Reader ? input : new $412f67b778039f13$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $412f67b778039f13$var$baseMsgSwap);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.trader = reader.string();
                    break;
                case 2:
                    message.offerCoin = $8K62q.Coin.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.askDenom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $412f67b778039f13$var$baseMsgSwap);
        if (object.trader !== undefined && object.trader !== null) message.trader = String(object.trader);
        else message.trader = "";
        if (object.offerCoin !== undefined && object.offerCoin !== null) message.offerCoin = $8K62q.Coin.fromJSON(object.offerCoin);
        else message.offerCoin = undefined;
        if (object.askDenom !== undefined && object.askDenom !== null) message.askDenom = String(object.askDenom);
        else message.askDenom = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.trader !== undefined && (obj.trader = message.trader);
        message.offerCoin !== undefined && (obj.offerCoin = message.offerCoin ? $8K62q.Coin.toJSON(message.offerCoin) : undefined);
        message.askDenom !== undefined && (obj.askDenom = message.askDenom);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $412f67b778039f13$var$baseMsgSwap);
        if (object.trader !== undefined && object.trader !== null) message.trader = object.trader;
        else message.trader = "";
        if (object.offerCoin !== undefined && object.offerCoin !== null) message.offerCoin = $8K62q.Coin.fromPartial(object.offerCoin);
        else message.offerCoin = undefined;
        if (object.askDenom !== undefined && object.askDenom !== null) message.askDenom = object.askDenom;
        else message.askDenom = "";
        return message;
    }
};
const $412f67b778039f13$var$baseMsgSwapResponse = {};
module.exports.MsgSwapResponse = {
    encode (message, writer = $412f67b778039f13$var$minimal_1.default.Writer.create()) {
        if (message.swapCoin !== undefined) $8K62q.Coin.encode(message.swapCoin, writer.uint32(10).fork()).ldelim();
        if (message.swapFee !== undefined) $8K62q.Coin.encode(message.swapFee, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $412f67b778039f13$var$minimal_1.default.Reader ? input : new $412f67b778039f13$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $412f67b778039f13$var$baseMsgSwapResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.swapCoin = $8K62q.Coin.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.swapFee = $8K62q.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $412f67b778039f13$var$baseMsgSwapResponse);
        if (object.swapCoin !== undefined && object.swapCoin !== null) message.swapCoin = $8K62q.Coin.fromJSON(object.swapCoin);
        else message.swapCoin = undefined;
        if (object.swapFee !== undefined && object.swapFee !== null) message.swapFee = $8K62q.Coin.fromJSON(object.swapFee);
        else message.swapFee = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.swapCoin !== undefined && (obj.swapCoin = message.swapCoin ? $8K62q.Coin.toJSON(message.swapCoin) : undefined);
        message.swapFee !== undefined && (obj.swapFee = message.swapFee ? $8K62q.Coin.toJSON(message.swapFee) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $412f67b778039f13$var$baseMsgSwapResponse);
        if (object.swapCoin !== undefined && object.swapCoin !== null) message.swapCoin = $8K62q.Coin.fromPartial(object.swapCoin);
        else message.swapCoin = undefined;
        if (object.swapFee !== undefined && object.swapFee !== null) message.swapFee = $8K62q.Coin.fromPartial(object.swapFee);
        else message.swapFee = undefined;
        return message;
    }
};
const $412f67b778039f13$var$baseMsgSwapSend = {
    fromAddress: "",
    toAddress: "",
    askDenom: ""
};
module.exports.MsgSwapSend = {
    encode (message, writer = $412f67b778039f13$var$minimal_1.default.Writer.create()) {
        if (message.fromAddress !== "") writer.uint32(10).string(message.fromAddress);
        if (message.toAddress !== "") writer.uint32(18).string(message.toAddress);
        if (message.offerCoin !== undefined) $8K62q.Coin.encode(message.offerCoin, writer.uint32(26).fork()).ldelim();
        if (message.askDenom !== "") writer.uint32(34).string(message.askDenom);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $412f67b778039f13$var$minimal_1.default.Reader ? input : new $412f67b778039f13$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $412f67b778039f13$var$baseMsgSwapSend);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.fromAddress = reader.string();
                    break;
                case 2:
                    message.toAddress = reader.string();
                    break;
                case 3:
                    message.offerCoin = $8K62q.Coin.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.askDenom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $412f67b778039f13$var$baseMsgSwapSend);
        if (object.fromAddress !== undefined && object.fromAddress !== null) message.fromAddress = String(object.fromAddress);
        else message.fromAddress = "";
        if (object.toAddress !== undefined && object.toAddress !== null) message.toAddress = String(object.toAddress);
        else message.toAddress = "";
        if (object.offerCoin !== undefined && object.offerCoin !== null) message.offerCoin = $8K62q.Coin.fromJSON(object.offerCoin);
        else message.offerCoin = undefined;
        if (object.askDenom !== undefined && object.askDenom !== null) message.askDenom = String(object.askDenom);
        else message.askDenom = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.fromAddress !== undefined && (obj.fromAddress = message.fromAddress);
        message.toAddress !== undefined && (obj.toAddress = message.toAddress);
        message.offerCoin !== undefined && (obj.offerCoin = message.offerCoin ? $8K62q.Coin.toJSON(message.offerCoin) : undefined);
        message.askDenom !== undefined && (obj.askDenom = message.askDenom);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $412f67b778039f13$var$baseMsgSwapSend);
        if (object.fromAddress !== undefined && object.fromAddress !== null) message.fromAddress = object.fromAddress;
        else message.fromAddress = "";
        if (object.toAddress !== undefined && object.toAddress !== null) message.toAddress = object.toAddress;
        else message.toAddress = "";
        if (object.offerCoin !== undefined && object.offerCoin !== null) message.offerCoin = $8K62q.Coin.fromPartial(object.offerCoin);
        else message.offerCoin = undefined;
        if (object.askDenom !== undefined && object.askDenom !== null) message.askDenom = object.askDenom;
        else message.askDenom = "";
        return message;
    }
};
const $412f67b778039f13$var$baseMsgSwapSendResponse = {};
module.exports.MsgSwapSendResponse = {
    encode (message, writer = $412f67b778039f13$var$minimal_1.default.Writer.create()) {
        if (message.swapCoin !== undefined) $8K62q.Coin.encode(message.swapCoin, writer.uint32(10).fork()).ldelim();
        if (message.swapFee !== undefined) $8K62q.Coin.encode(message.swapFee, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $412f67b778039f13$var$minimal_1.default.Reader ? input : new $412f67b778039f13$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $412f67b778039f13$var$baseMsgSwapSendResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.swapCoin = $8K62q.Coin.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.swapFee = $8K62q.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $412f67b778039f13$var$baseMsgSwapSendResponse);
        if (object.swapCoin !== undefined && object.swapCoin !== null) message.swapCoin = $8K62q.Coin.fromJSON(object.swapCoin);
        else message.swapCoin = undefined;
        if (object.swapFee !== undefined && object.swapFee !== null) message.swapFee = $8K62q.Coin.fromJSON(object.swapFee);
        else message.swapFee = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.swapCoin !== undefined && (obj.swapCoin = message.swapCoin ? $8K62q.Coin.toJSON(message.swapCoin) : undefined);
        message.swapFee !== undefined && (obj.swapFee = message.swapFee ? $8K62q.Coin.toJSON(message.swapFee) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $412f67b778039f13$var$baseMsgSwapSendResponse);
        if (object.swapCoin !== undefined && object.swapCoin !== null) message.swapCoin = $8K62q.Coin.fromPartial(object.swapCoin);
        else message.swapCoin = undefined;
        if (object.swapFee !== undefined && object.swapFee !== null) message.swapFee = $8K62q.Coin.fromPartial(object.swapFee);
        else message.swapFee = undefined;
        return message;
    }
};
class $412f67b778039f13$var$MsgClientImpl {
    Swap(request, metadata) {
        return this.rpc.unary(module.exports.MsgSwapDesc, module.exports.MsgSwap.fromPartial(request), metadata);
    }
    SwapSend(request, metadata) {
        return this.rpc.unary(module.exports.MsgSwapSendDesc, module.exports.MsgSwapSend.fromPartial(request), metadata);
    }
    constructor(rpc){
        this.rpc = rpc;
        this.Swap = this.Swap.bind(this);
        this.SwapSend = this.SwapSend.bind(this);
    }
}
module.exports.MsgClientImpl = $412f67b778039f13$var$MsgClientImpl;
module.exports.MsgDesc = {
    serviceName: "terra.market.v1beta1.Msg"
};
module.exports.MsgSwapDesc = {
    methodName: "Swap",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgSwap.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgSwapResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.MsgSwapSendDesc = {
    methodName: "SwapSend",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgSwapSend.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgSwapSendResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
class $412f67b778039f13$var$GrpcWebImpl {
    unary(methodDesc, _request, metadata) {
        var _a;
        const request = Object.assign(Object.assign({}, _request), methodDesc.requestType);
        const maybeCombinedMetadata = metadata && this.options.metadata ? new $1pqjL.BrowserHeaders(Object.assign(Object.assign({}, (_a = this.options) === null || _a === void 0 ? void 0 : _a.metadata.headersMap), metadata === null || metadata === void 0 ? void 0 : metadata.headersMap)) : metadata || this.options.metadata;
        return new Promise((resolve, reject)=>{
            $jXVni.grpc.unary(methodDesc, {
                request: request,
                host: this.host,
                metadata: maybeCombinedMetadata,
                transport: this.options.transport,
                debug: this.options.debug,
                onEnd: function(response) {
                    if (response.status === $jXVni.grpc.Code.OK) resolve(response.message);
                    else {
                        const err = new Error(response.statusMessage);
                        err.code = response.status;
                        err.metadata = response.trailers;
                        reject(err);
                    }
                }
            });
        });
    }
    constructor(host, options){
        this.host = host;
        this.options = options;
    }
}
module.exports.GrpcWebImpl = $412f67b778039f13$var$GrpcWebImpl;
if ($412f67b778039f13$var$minimal_1.default.util.Long !== $412f67b778039f13$var$long_1.default) {
    $412f67b778039f13$var$minimal_1.default.util.Long = $412f67b778039f13$var$long_1.default;
    $412f67b778039f13$var$minimal_1.default.configure();
}

});
parcelRegister("8K62q", function(module, exports) {
"use strict";
var $65d74da3b6c072ec$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DecProto = module.exports.IntProto = module.exports.DecCoin = module.exports.Coin = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $65d74da3b6c072ec$var$long_1 = $65d74da3b6c072ec$var$__importDefault((parcelRequire("9A55m")));

const $65d74da3b6c072ec$var$minimal_1 = $65d74da3b6c072ec$var$__importDefault((parcelRequire("i2pIU")));
module.exports.protobufPackage = "cosmos.base.v1beta1";
const $65d74da3b6c072ec$var$baseCoin = {
    denom: "",
    amount: ""
};
module.exports.Coin = {
    encode (message, writer = $65d74da3b6c072ec$var$minimal_1.default.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.amount !== "") writer.uint32(18).string(message.amount);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $65d74da3b6c072ec$var$minimal_1.default.Reader ? input : new $65d74da3b6c072ec$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $65d74da3b6c072ec$var$baseCoin);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $65d74da3b6c072ec$var$baseCoin);
        if (object.denom !== undefined && object.denom !== null) message.denom = String(object.denom);
        else message.denom = "";
        if (object.amount !== undefined && object.amount !== null) message.amount = String(object.amount);
        else message.amount = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $65d74da3b6c072ec$var$baseCoin);
        if (object.denom !== undefined && object.denom !== null) message.denom = object.denom;
        else message.denom = "";
        if (object.amount !== undefined && object.amount !== null) message.amount = object.amount;
        else message.amount = "";
        return message;
    }
};
const $65d74da3b6c072ec$var$baseDecCoin = {
    denom: "",
    amount: ""
};
module.exports.DecCoin = {
    encode (message, writer = $65d74da3b6c072ec$var$minimal_1.default.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.amount !== "") writer.uint32(18).string(message.amount);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $65d74da3b6c072ec$var$minimal_1.default.Reader ? input : new $65d74da3b6c072ec$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $65d74da3b6c072ec$var$baseDecCoin);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $65d74da3b6c072ec$var$baseDecCoin);
        if (object.denom !== undefined && object.denom !== null) message.denom = String(object.denom);
        else message.denom = "";
        if (object.amount !== undefined && object.amount !== null) message.amount = String(object.amount);
        else message.amount = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $65d74da3b6c072ec$var$baseDecCoin);
        if (object.denom !== undefined && object.denom !== null) message.denom = object.denom;
        else message.denom = "";
        if (object.amount !== undefined && object.amount !== null) message.amount = object.amount;
        else message.amount = "";
        return message;
    }
};
const $65d74da3b6c072ec$var$baseIntProto = {
    int: ""
};
module.exports.IntProto = {
    encode (message, writer = $65d74da3b6c072ec$var$minimal_1.default.Writer.create()) {
        if (message.int !== "") writer.uint32(10).string(message.int);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $65d74da3b6c072ec$var$minimal_1.default.Reader ? input : new $65d74da3b6c072ec$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $65d74da3b6c072ec$var$baseIntProto);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.int = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $65d74da3b6c072ec$var$baseIntProto);
        if (object.int !== undefined && object.int !== null) message.int = String(object.int);
        else message.int = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.int !== undefined && (obj.int = message.int);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $65d74da3b6c072ec$var$baseIntProto);
        if (object.int !== undefined && object.int !== null) message.int = object.int;
        else message.int = "";
        return message;
    }
};
const $65d74da3b6c072ec$var$baseDecProto = {
    dec: ""
};
module.exports.DecProto = {
    encode (message, writer = $65d74da3b6c072ec$var$minimal_1.default.Writer.create()) {
        if (message.dec !== "") writer.uint32(10).string(message.dec);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $65d74da3b6c072ec$var$minimal_1.default.Reader ? input : new $65d74da3b6c072ec$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $65d74da3b6c072ec$var$baseDecProto);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.dec = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $65d74da3b6c072ec$var$baseDecProto);
        if (object.dec !== undefined && object.dec !== null) message.dec = String(object.dec);
        else message.dec = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.dec !== undefined && (obj.dec = message.dec);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $65d74da3b6c072ec$var$baseDecProto);
        if (object.dec !== undefined && object.dec !== null) message.dec = object.dec;
        else message.dec = "";
        return message;
    }
};
if ($65d74da3b6c072ec$var$minimal_1.default.util.Long !== $65d74da3b6c072ec$var$long_1.default) {
    $65d74da3b6c072ec$var$minimal_1.default.util.Long = $65d74da3b6c072ec$var$long_1.default;
    $65d74da3b6c072ec$var$minimal_1.default.configure();
}

});



parcelRegister("iWiOC", function(module, exports) {
"use strict";
var $dc9c3d219b511f0f$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgSwapSend = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $7yVzo = parcelRequire("7yVzo");

var $c5FxR = parcelRequire("c5FxR");

var $5AYHU = parcelRequire("5AYHU");
/**
 * Executes a market swap send between 2 denominations at the exchange rate registered by the
 * Oracle module. The sender account will lose the amount of coins offered, and receiver will receive funds
 * in the requested denomination after a swap and send fee has been applied.
 */ var $dc9c3d219b511f0f$var$MsgSwapSend = /** @class */ function(_super) {
    $dc9c3d219b511f0f$var$__extends(MsgSwapSend, _super);
    /**
     * @param from_address sender's account address
     * @param to_address receiver's account address
     * @param offer_coin coin to be swapped (from)
     * @param ask_denom desired denomination (to)
     */ function MsgSwapSend(from_address, to_address, offer_coin, ask_denom) {
        var _this = _super.call(this) || this;
        _this.from_address = from_address;
        _this.to_address = to_address;
        _this.offer_coin = offer_coin;
        _this.ask_denom = ask_denom;
        return _this;
    }
    MsgSwapSend.fromAmino = function(data, isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        var _a = data.value, from_address = _a.from_address, to_address = _a.to_address, offer_coin = _a.offer_coin, ask_denom = _a.ask_denom;
        return new MsgSwapSend(from_address, to_address, $7yVzo.Coin.fromAmino(offer_coin), ask_denom);
    };
    MsgSwapSend.prototype.toAmino = function(isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        var _a = this, from_address = _a.from_address, to_address = _a.to_address, offer_coin = _a.offer_coin, ask_denom = _a.ask_denom;
        return {
            type: "market/MsgSwapSend",
            value: {
                from_address: from_address,
                to_address: to_address,
                offer_coin: offer_coin.toAmino(),
                ask_denom: ask_denom
            }
        };
    };
    MsgSwapSend.fromProto = function(proto, isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        return new MsgSwapSend(proto.fromAddress, proto.toAddress, $7yVzo.Coin.fromProto(proto.offerCoin), proto.askDenom);
    };
    MsgSwapSend.prototype.toProto = function(isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        var _a = this, from_address = _a.from_address, to_address = _a.to_address, offer_coin = _a.offer_coin, ask_denom = _a.ask_denom;
        return $5AYHU.MsgSwapSend.fromPartial({
            askDenom: ask_denom,
            fromAddress: from_address,
            offerCoin: offer_coin.toProto(),
            toAddress: to_address
        });
    };
    MsgSwapSend.prototype.packAny = function(isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        return $c5FxR.Any.fromPartial({
            typeUrl: "/terra.market.v1beta1.MsgSwapSend",
            value: $5AYHU.MsgSwapSend.encode(this.toProto(isClassic)).finish()
        });
    };
    MsgSwapSend.unpackAny = function(msgAny, isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        return MsgSwapSend.fromProto($5AYHU.MsgSwapSend.decode(msgAny.value), isClassic);
    };
    MsgSwapSend.fromData = function(data, isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        var from_address = data.from_address, to_address = data.to_address, offer_coin = data.offer_coin, ask_denom = data.ask_denom;
        return new MsgSwapSend(from_address, to_address, $7yVzo.Coin.fromData(offer_coin), ask_denom);
    };
    MsgSwapSend.prototype.toData = function(isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        var _a = this, from_address = _a.from_address, to_address = _a.to_address, offer_coin = _a.offer_coin, ask_denom = _a.ask_denom;
        return {
            "@type": "/terra.market.v1beta1.MsgSwapSend",
            from_address: from_address,
            to_address: to_address,
            offer_coin: offer_coin.toData(),
            ask_denom: ask_denom
        };
    };
    return MsgSwapSend;
}($26Eqx.JSONSerializable);
module.exports.MsgSwapSend = $dc9c3d219b511f0f$var$MsgSwapSend;

});


parcelRegister("5qYvo", function(module, exports) {
"use strict";
var $3f4e508f0c694680$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3f4e508f0c694680$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $3f4e508f0c694680$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$3f4e508f0c694680$var$__exportStar((parcelRequire("c5doZ")), module.exports);

$3f4e508f0c694680$var$__exportStar((parcelRequire("jV9g7")), module.exports);

$3f4e508f0c694680$var$__exportStar((parcelRequire("21shp")), module.exports);

});
parcelRegister("c5doZ", function(module, exports) {
"use strict";
var $8cc0590d4814a92a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgGrantAuthorization = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $btOyI = parcelRequire("btOyI");

var $cEC6O = parcelRequire("cEC6O");

var $c5FxR = parcelRequire("c5FxR");
var $8cc0590d4814a92a$var$MsgGrantAuthorization = /** @class */ function(_super) {
    $8cc0590d4814a92a$var$__extends(MsgGrantAuthorization, _super);
    /**
     * @param depositor depositor's account address
     * @param amount coins to fund the community pool
     */ function MsgGrantAuthorization(granter, grantee, grant) {
        var _this = _super.call(this) || this;
        _this.granter = granter;
        _this.grantee = grantee;
        _this.grant = grant;
        return _this;
    }
    MsgGrantAuthorization.fromAmino = function(data, isClassic) {
        var _a = data.value, granter = _a.granter, grantee = _a.grantee, grant = _a.grant;
        return new MsgGrantAuthorization(granter, grantee, $btOyI.AuthorizationGrant.fromAmino(grant, isClassic));
    };
    MsgGrantAuthorization.prototype.toAmino = function(isClassic) {
        var _a = this, granter = _a.granter, grantee = _a.grantee, grant = _a.grant;
        return {
            type: isClassic ? "msgauth/MsgGrantAuthorization" : "cosmos-sdk/MsgGrant",
            value: {
                granter: granter,
                grantee: grantee,
                grant: grant.toAmino(isClassic)
            }
        };
    };
    MsgGrantAuthorization.fromData = function(data, isClassic) {
        var granter = data.granter, grantee = data.grantee, grant = data.grant;
        return new MsgGrantAuthorization(granter, grantee, $btOyI.AuthorizationGrant.fromData(grant, isClassic));
    };
    MsgGrantAuthorization.prototype.toData = function(isClassic) {
        var _a = this, granter = _a.granter, grantee = _a.grantee, grant = _a.grant;
        return {
            "@type": "/cosmos.authz.v1beta1.MsgGrant",
            granter: granter,
            grantee: grantee,
            grant: grant.toData(isClassic)
        };
    };
    MsgGrantAuthorization.fromProto = function(data, isClassic) {
        return new MsgGrantAuthorization(data.granter, data.grantee, $btOyI.AuthorizationGrant.fromProto(data.grant, isClassic));
    };
    MsgGrantAuthorization.prototype.toProto = function(isClassic) {
        var _a = this, grant = _a.grant, granter = _a.granter, grantee = _a.grantee;
        return $cEC6O.MsgGrant.fromPartial({
            grant: grant.toProto(isClassic),
            grantee: grantee,
            granter: granter
        });
    };
    MsgGrantAuthorization.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmos.authz.v1beta1.MsgGrant",
            value: $cEC6O.MsgGrant.encode(this.toProto(isClassic)).finish()
        });
    };
    MsgGrantAuthorization.unpackAny = function(msgAny, isClassic) {
        return MsgGrantAuthorization.fromProto($cEC6O.MsgGrant.decode(msgAny.value), isClassic);
    };
    return MsgGrantAuthorization;
}($26Eqx.JSONSerializable);
module.exports.MsgGrantAuthorization = $8cc0590d4814a92a$var$MsgGrantAuthorization;

});
parcelRegister("btOyI", function(module, exports) {
"use strict";
var $85b99f1b7dd797e7$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $85b99f1b7dd797e7$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $85b99f1b7dd797e7$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$85b99f1b7dd797e7$var$__exportStar((parcelRequire("MVJjb")), module.exports);

$85b99f1b7dd797e7$var$__exportStar((parcelRequire("cz8PY")), module.exports);

$85b99f1b7dd797e7$var$__exportStar((parcelRequire("6mYwU")), module.exports);

$85b99f1b7dd797e7$var$__exportStar((parcelRequire("7Ufxn")), module.exports);

});
parcelRegister("MVJjb", function(module, exports) {
"use strict";
var $093143bdc7e07776$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StakeAuthorizationValidators = module.exports.StakeAuthorization = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $7yVzo = parcelRequire("7yVzo");

var $9FgrX = parcelRequire("9FgrX");

var $c5FxR = parcelRequire("c5FxR");
var $093143bdc7e07776$var$StakeAuthorization = /** @class */ function(_super) {
    $093143bdc7e07776$var$__extends(StakeAuthorization, _super);
    function StakeAuthorization(authorization_type, max_tokens, allow_list, deny_list) {
        var _this = _super.call(this) || this;
        _this.authorization_type = authorization_type;
        _this.max_tokens = max_tokens;
        _this.allow_list = allow_list;
        _this.deny_list = deny_list;
        return _this;
    }
    StakeAuthorization.fromAmino = function(_, isClassic) {
        _;
        isClassic;
        throw new Error("Amino not supported");
    };
    StakeAuthorization.prototype.toAmino = function(_) {
        _;
        throw new Error("Amino not supported");
    };
    StakeAuthorization.fromData = function(data, isClassic) {
        return new StakeAuthorization((0, $9FgrX.authorizationTypeFromJSON)(data.authorization_type), data.max_tokens ? $7yVzo.Coin.fromProto(data.max_tokens) : undefined, data.allow_list ? $093143bdc7e07776$var$StakeAuthorizationValidators.fromData(data.allow_list, isClassic) : undefined, data.deny_list ? $093143bdc7e07776$var$StakeAuthorizationValidators.fromData(data.deny_list, isClassic) : undefined);
    };
    StakeAuthorization.prototype.toData = function(isClassic) {
        var _a = this, max_tokens = _a.max_tokens, allow_list = _a.allow_list, deny_list = _a.deny_list, authorization_type = _a.authorization_type;
        return {
            "@type": "/cosmos.staking.v1beta1.StakeAuthorization",
            authorization_type: (0, $9FgrX.authorizationTypeToJSON)(authorization_type),
            max_tokens: max_tokens === null || max_tokens === void 0 ? void 0 : max_tokens.toData(),
            allow_list: allow_list === null || allow_list === void 0 ? void 0 : allow_list.toData(isClassic),
            deny_list: deny_list === null || deny_list === void 0 ? void 0 : deny_list.toData(isClassic)
        };
    };
    StakeAuthorization.fromProto = function(proto, isClassic) {
        return new StakeAuthorization(proto.authorizationType, proto.maxTokens ? $7yVzo.Coin.fromProto(proto.maxTokens) : undefined, proto.allowList ? $093143bdc7e07776$var$StakeAuthorizationValidators.fromProto(proto.allowList, isClassic) : undefined, proto.denyList ? $093143bdc7e07776$var$StakeAuthorizationValidators.fromProto(proto.denyList, isClassic) : undefined);
    };
    StakeAuthorization.prototype.toProto = function(isClassic) {
        var _a = this, max_tokens = _a.max_tokens, allow_list = _a.allow_list, deny_list = _a.deny_list, authorization_type = _a.authorization_type;
        return $9FgrX.StakeAuthorization.fromPartial({
            allowList: allow_list === null || allow_list === void 0 ? void 0 : allow_list.toProto(isClassic),
            authorizationType: authorization_type,
            denyList: deny_list === null || deny_list === void 0 ? void 0 : deny_list.toProto(isClassic),
            maxTokens: max_tokens === null || max_tokens === void 0 ? void 0 : max_tokens.toProto()
        });
    };
    StakeAuthorization.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmos.staking.v1beta1.StakeAuthorization",
            value: $9FgrX.StakeAuthorization.encode(this.toProto(isClassic)).finish()
        });
    };
    StakeAuthorization.unpackAny = function(msgAny, isClassic) {
        return StakeAuthorization.fromProto($9FgrX.StakeAuthorization.decode(msgAny.value), isClassic);
    };
    return StakeAuthorization;
}($26Eqx.JSONSerializable);
module.exports.StakeAuthorization = $093143bdc7e07776$var$StakeAuthorization;
var $093143bdc7e07776$var$StakeAuthorizationValidators = /** @class */ function(_super) {
    $093143bdc7e07776$var$__extends(StakeAuthorizationValidators, _super);
    function StakeAuthorizationValidators(address) {
        var _this = _super.call(this) || this;
        _this.address = address;
        return _this;
    }
    StakeAuthorizationValidators.fromAmino = function(_, isClassic) {
        _;
        isClassic;
        throw new Error("Amino not supported");
    };
    StakeAuthorizationValidators.prototype.toAmino = function(_) {
        _;
        throw new Error("Amino not supported");
    };
    StakeAuthorizationValidators.fromData = function(data, _) {
        _;
        return new StakeAuthorizationValidators(data.address);
    };
    StakeAuthorizationValidators.prototype.toData = function(_) {
        _;
        return {
            address: this.address
        };
    };
    StakeAuthorizationValidators.fromProto = function(proto, _) {
        _;
        return new StakeAuthorizationValidators(proto.address);
    };
    StakeAuthorizationValidators.prototype.toProto = function(_) {
        _;
        return $9FgrX.StakeAuthorization_Validators.fromPartial({
            address: this.address
        });
    };
    return StakeAuthorizationValidators;
}($26Eqx.JSONSerializable);
module.exports.StakeAuthorizationValidators = $093143bdc7e07776$var$StakeAuthorizationValidators;
(function(StakeAuthorization) {
    StakeAuthorization.Type = $9FgrX.AuthorizationType;
})($093143bdc7e07776$var$StakeAuthorization = module.exports.StakeAuthorization || (module.exports.StakeAuthorization = {}));
module.exports.StakeAuthorization = $093143bdc7e07776$var$StakeAuthorization;

});
parcelRegister("9FgrX", function(module, exports) {
"use strict";
var $7094b406391acb4a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StakeAuthorization_Validators = module.exports.StakeAuthorization = module.exports.authorizationTypeToJSON = module.exports.authorizationTypeFromJSON = module.exports.AuthorizationType = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $7094b406391acb4a$var$long_1 = $7094b406391acb4a$var$__importDefault((parcelRequire("9A55m")));

const $7094b406391acb4a$var$minimal_1 = $7094b406391acb4a$var$__importDefault((parcelRequire("i2pIU")));

var $lPVUQ = parcelRequire("lPVUQ");
module.exports.protobufPackage = "cosmos.staking.v1beta1";
/**
 * AuthorizationType defines the type of staking module authorization type
 *
 * Since: cosmos-sdk 0.43
 */ var $7094b406391acb4a$var$AuthorizationType;
(function(AuthorizationType) {
    /** AUTHORIZATION_TYPE_UNSPECIFIED - AUTHORIZATION_TYPE_UNSPECIFIED specifies an unknown authorization type */ AuthorizationType[AuthorizationType["AUTHORIZATION_TYPE_UNSPECIFIED"] = 0] = "AUTHORIZATION_TYPE_UNSPECIFIED";
    /** AUTHORIZATION_TYPE_DELEGATE - AUTHORIZATION_TYPE_DELEGATE defines an authorization type for Msg/Delegate */ AuthorizationType[AuthorizationType["AUTHORIZATION_TYPE_DELEGATE"] = 1] = "AUTHORIZATION_TYPE_DELEGATE";
    /** AUTHORIZATION_TYPE_UNDELEGATE - AUTHORIZATION_TYPE_UNDELEGATE defines an authorization type for Msg/Undelegate */ AuthorizationType[AuthorizationType["AUTHORIZATION_TYPE_UNDELEGATE"] = 2] = "AUTHORIZATION_TYPE_UNDELEGATE";
    /** AUTHORIZATION_TYPE_REDELEGATE - AUTHORIZATION_TYPE_REDELEGATE defines an authorization type for Msg/BeginRedelegate */ AuthorizationType[AuthorizationType["AUTHORIZATION_TYPE_REDELEGATE"] = 3] = "AUTHORIZATION_TYPE_REDELEGATE";
    AuthorizationType[AuthorizationType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($7094b406391acb4a$var$AuthorizationType = module.exports.AuthorizationType || (module.exports.AuthorizationType = {}));
function $7094b406391acb4a$var$authorizationTypeFromJSON(object) {
    switch(object){
        case 0:
        case "AUTHORIZATION_TYPE_UNSPECIFIED":
            return $7094b406391acb4a$var$AuthorizationType.AUTHORIZATION_TYPE_UNSPECIFIED;
        case 1:
        case "AUTHORIZATION_TYPE_DELEGATE":
            return $7094b406391acb4a$var$AuthorizationType.AUTHORIZATION_TYPE_DELEGATE;
        case 2:
        case "AUTHORIZATION_TYPE_UNDELEGATE":
            return $7094b406391acb4a$var$AuthorizationType.AUTHORIZATION_TYPE_UNDELEGATE;
        case 3:
        case "AUTHORIZATION_TYPE_REDELEGATE":
            return $7094b406391acb4a$var$AuthorizationType.AUTHORIZATION_TYPE_REDELEGATE;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $7094b406391acb4a$var$AuthorizationType.UNRECOGNIZED;
    }
}
module.exports.authorizationTypeFromJSON = $7094b406391acb4a$var$authorizationTypeFromJSON;
function $7094b406391acb4a$var$authorizationTypeToJSON(object) {
    switch(object){
        case $7094b406391acb4a$var$AuthorizationType.AUTHORIZATION_TYPE_UNSPECIFIED:
            return "AUTHORIZATION_TYPE_UNSPECIFIED";
        case $7094b406391acb4a$var$AuthorizationType.AUTHORIZATION_TYPE_DELEGATE:
            return "AUTHORIZATION_TYPE_DELEGATE";
        case $7094b406391acb4a$var$AuthorizationType.AUTHORIZATION_TYPE_UNDELEGATE:
            return "AUTHORIZATION_TYPE_UNDELEGATE";
        case $7094b406391acb4a$var$AuthorizationType.AUTHORIZATION_TYPE_REDELEGATE:
            return "AUTHORIZATION_TYPE_REDELEGATE";
        default:
            return "UNKNOWN";
    }
}
module.exports.authorizationTypeToJSON = $7094b406391acb4a$var$authorizationTypeToJSON;
const $7094b406391acb4a$var$baseStakeAuthorization = {
    authorizationType: 0
};
module.exports.StakeAuthorization = {
    encode (message, writer = $7094b406391acb4a$var$minimal_1.default.Writer.create()) {
        if (message.maxTokens !== undefined) $lPVUQ.Coin.encode(message.maxTokens, writer.uint32(10).fork()).ldelim();
        if (message.allowList !== undefined) module.exports.StakeAuthorization_Validators.encode(message.allowList, writer.uint32(18).fork()).ldelim();
        if (message.denyList !== undefined) module.exports.StakeAuthorization_Validators.encode(message.denyList, writer.uint32(26).fork()).ldelim();
        if (message.authorizationType !== 0) writer.uint32(32).int32(message.authorizationType);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7094b406391acb4a$var$minimal_1.default.Reader ? input : new $7094b406391acb4a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $7094b406391acb4a$var$baseStakeAuthorization);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.maxTokens = $lPVUQ.Coin.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.allowList = module.exports.StakeAuthorization_Validators.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.denyList = module.exports.StakeAuthorization_Validators.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.authorizationType = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $7094b406391acb4a$var$baseStakeAuthorization);
        if (object.maxTokens !== undefined && object.maxTokens !== null) message.maxTokens = $lPVUQ.Coin.fromJSON(object.maxTokens);
        else message.maxTokens = undefined;
        if (object.allowList !== undefined && object.allowList !== null) message.allowList = module.exports.StakeAuthorization_Validators.fromJSON(object.allowList);
        else message.allowList = undefined;
        if (object.denyList !== undefined && object.denyList !== null) message.denyList = module.exports.StakeAuthorization_Validators.fromJSON(object.denyList);
        else message.denyList = undefined;
        if (object.authorizationType !== undefined && object.authorizationType !== null) message.authorizationType = $7094b406391acb4a$var$authorizationTypeFromJSON(object.authorizationType);
        else message.authorizationType = 0;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.maxTokens !== undefined && (obj.maxTokens = message.maxTokens ? $lPVUQ.Coin.toJSON(message.maxTokens) : undefined);
        message.allowList !== undefined && (obj.allowList = message.allowList ? module.exports.StakeAuthorization_Validators.toJSON(message.allowList) : undefined);
        message.denyList !== undefined && (obj.denyList = message.denyList ? module.exports.StakeAuthorization_Validators.toJSON(message.denyList) : undefined);
        message.authorizationType !== undefined && (obj.authorizationType = $7094b406391acb4a$var$authorizationTypeToJSON(message.authorizationType));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $7094b406391acb4a$var$baseStakeAuthorization);
        if (object.maxTokens !== undefined && object.maxTokens !== null) message.maxTokens = $lPVUQ.Coin.fromPartial(object.maxTokens);
        else message.maxTokens = undefined;
        if (object.allowList !== undefined && object.allowList !== null) message.allowList = module.exports.StakeAuthorization_Validators.fromPartial(object.allowList);
        else message.allowList = undefined;
        if (object.denyList !== undefined && object.denyList !== null) message.denyList = module.exports.StakeAuthorization_Validators.fromPartial(object.denyList);
        else message.denyList = undefined;
        if (object.authorizationType !== undefined && object.authorizationType !== null) message.authorizationType = object.authorizationType;
        else message.authorizationType = 0;
        return message;
    }
};
const $7094b406391acb4a$var$baseStakeAuthorization_Validators = {
    address: ""
};
module.exports.StakeAuthorization_Validators = {
    encode (message, writer = $7094b406391acb4a$var$minimal_1.default.Writer.create()) {
        for (const v of message.address)writer.uint32(10).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7094b406391acb4a$var$minimal_1.default.Reader ? input : new $7094b406391acb4a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $7094b406391acb4a$var$baseStakeAuthorization_Validators);
        message.address = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $7094b406391acb4a$var$baseStakeAuthorization_Validators);
        message.address = [];
        if (object.address !== undefined && object.address !== null) for (const e of object.address)message.address.push(String(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.address) obj.address = message.address.map((e)=>e);
        else obj.address = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $7094b406391acb4a$var$baseStakeAuthorization_Validators);
        message.address = [];
        if (object.address !== undefined && object.address !== null) for (const e of object.address)message.address.push(e);
        return message;
    }
};
if ($7094b406391acb4a$var$minimal_1.default.util.Long !== $7094b406391acb4a$var$long_1.default) {
    $7094b406391acb4a$var$minimal_1.default.util.Long = $7094b406391acb4a$var$long_1.default;
    $7094b406391acb4a$var$minimal_1.default.configure();
}

});


parcelRegister("cz8PY", function(module, exports) {
"use strict";
var $925f9bcba4c53f19$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SendAuthorization = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $kYslP = parcelRequire("kYslP");

var $jXXUV = parcelRequire("jXXUV");

var $c5FxR = parcelRequire("c5FxR");
var $925f9bcba4c53f19$var$SendAuthorization = /** @class */ function(_super) {
    $925f9bcba4c53f19$var$__extends(SendAuthorization, _super);
    function SendAuthorization(spend_limit) {
        var _this = _super.call(this) || this;
        _this.spend_limit = new $kYslP.Coins(spend_limit);
        return _this;
    }
    SendAuthorization.fromAmino = function(data, _) {
        _;
        return new SendAuthorization($kYslP.Coins.fromAmino(data.value.spend_limit));
    };
    SendAuthorization.prototype.toAmino = function(isClassic) {
        var spend_limit = this.spend_limit;
        return {
            type: isClassic ? "msgauth/SendAuthorization" : "cosmos-sdk/SendAuthorization",
            value: {
                spend_limit: spend_limit.toAmino()
            }
        };
    };
    SendAuthorization.fromData = function(data, _) {
        _;
        return new SendAuthorization($kYslP.Coins.fromData(data.spend_limit));
    };
    SendAuthorization.prototype.toData = function(_) {
        _;
        var spend_limit = this.spend_limit;
        return {
            "@type": "/cosmos.bank.v1beta1.SendAuthorization",
            spend_limit: spend_limit.toAmino()
        };
    };
    SendAuthorization.fromProto = function(proto, _) {
        _;
        return new SendAuthorization($kYslP.Coins.fromProto(proto.spendLimit));
    };
    SendAuthorization.prototype.toProto = function(_) {
        _;
        return $jXXUV.SendAuthorization.fromPartial({
            spendLimit: this.spend_limit.toProto()
        });
    };
    SendAuthorization.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmos.bank.v1beta1.SendAuthorization",
            value: $jXXUV.SendAuthorization.encode(this.toProto(isClassic)).finish()
        });
    };
    SendAuthorization.unpackAny = function(msgAny, isClassic) {
        return SendAuthorization.fromProto($jXXUV.SendAuthorization.decode(msgAny.value), isClassic);
    };
    return SendAuthorization;
}($26Eqx.JSONSerializable);
module.exports.SendAuthorization = $925f9bcba4c53f19$var$SendAuthorization;

});
parcelRegister("jXXUV", function(module, exports) {
"use strict";
var $e89201551257fec6$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SendAuthorization = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $e89201551257fec6$var$long_1 = $e89201551257fec6$var$__importDefault((parcelRequire("9A55m")));

const $e89201551257fec6$var$minimal_1 = $e89201551257fec6$var$__importDefault((parcelRequire("i2pIU")));

var $lPVUQ = parcelRequire("lPVUQ");
module.exports.protobufPackage = "cosmos.bank.v1beta1";
const $e89201551257fec6$var$baseSendAuthorization = {};
module.exports.SendAuthorization = {
    encode (message, writer = $e89201551257fec6$var$minimal_1.default.Writer.create()) {
        for (const v of message.spendLimit)$lPVUQ.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e89201551257fec6$var$minimal_1.default.Reader ? input : new $e89201551257fec6$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $e89201551257fec6$var$baseSendAuthorization);
        message.spendLimit = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.spendLimit.push($lPVUQ.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $e89201551257fec6$var$baseSendAuthorization);
        message.spendLimit = [];
        if (object.spendLimit !== undefined && object.spendLimit !== null) for (const e of object.spendLimit)message.spendLimit.push($lPVUQ.Coin.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.spendLimit) obj.spendLimit = message.spendLimit.map((e)=>e ? $lPVUQ.Coin.toJSON(e) : undefined);
        else obj.spendLimit = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $e89201551257fec6$var$baseSendAuthorization);
        message.spendLimit = [];
        if (object.spendLimit !== undefined && object.spendLimit !== null) for (const e of object.spendLimit)message.spendLimit.push($lPVUQ.Coin.fromPartial(e));
        return message;
    }
};
if ($e89201551257fec6$var$minimal_1.default.util.Long !== $e89201551257fec6$var$long_1.default) {
    $e89201551257fec6$var$minimal_1.default.util.Long = $e89201551257fec6$var$long_1.default;
    $e89201551257fec6$var$minimal_1.default.configure();
}

});


parcelRegister("6mYwU", function(module, exports) {
"use strict";
var $4a33c016fc3f4ba5$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GenericAuthorization = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $j1HxC = parcelRequire("j1HxC");

var $c5FxR = parcelRequire("c5FxR");
var $4a33c016fc3f4ba5$var$GenericAuthorization = /** @class */ function(_super) {
    $4a33c016fc3f4ba5$var$__extends(GenericAuthorization, _super);
    function GenericAuthorization(msg) {
        var _this = _super.call(this) || this;
        _this.msg = msg;
        return _this;
    }
    GenericAuthorization.fromAmino = function(data, _) {
        _;
        return new GenericAuthorization(data.value.msg);
    };
    GenericAuthorization.prototype.toAmino = function(isClassic) {
        var msg = this.msg;
        return {
            type: isClassic ? "msgauth/GenericAuthorization" : "cosmos-sdk/GenericAuthorization",
            value: {
                msg: msg
            }
        };
    };
    GenericAuthorization.fromData = function(data, _) {
        _;
        return new GenericAuthorization(data.msg);
    };
    GenericAuthorization.prototype.toData = function(_) {
        _;
        var msg = this.msg;
        return {
            "@type": "/cosmos.authz.v1beta1.GenericAuthorization",
            msg: msg
        };
    };
    GenericAuthorization.fromProto = function(data, _) {
        _;
        return new GenericAuthorization(data.msg);
    };
    GenericAuthorization.prototype.toProto = function(_) {
        _;
        return $j1HxC.GenericAuthorization.fromPartial({
            msg: this.msg
        });
    };
    GenericAuthorization.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmos.authz.v1beta1.GenericAuthorization",
            value: $j1HxC.GenericAuthorization.encode(this.toProto(isClassic)).finish()
        });
    };
    GenericAuthorization.unpackAny = function(msgAny, isClassic) {
        return GenericAuthorization.fromProto($j1HxC.GenericAuthorization.decode(msgAny.value), isClassic);
    };
    return GenericAuthorization;
}($26Eqx.JSONSerializable);
module.exports.GenericAuthorization = $4a33c016fc3f4ba5$var$GenericAuthorization;

});
parcelRegister("j1HxC", function(module, exports) {
"use strict";
var $dd9fe2b01844108e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GrantAuthorization = module.exports.Grant = module.exports.GenericAuthorization = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $dd9fe2b01844108e$var$long_1 = $dd9fe2b01844108e$var$__importDefault((parcelRequire("9A55m")));

const $dd9fe2b01844108e$var$minimal_1 = $dd9fe2b01844108e$var$__importDefault((parcelRequire("i2pIU")));

var $c5FxR = parcelRequire("c5FxR");

var $5G2s6 = parcelRequire("5G2s6");
module.exports.protobufPackage = "cosmos.authz.v1beta1";
const $dd9fe2b01844108e$var$baseGenericAuthorization = {
    msg: ""
};
module.exports.GenericAuthorization = {
    encode (message, writer = $dd9fe2b01844108e$var$minimal_1.default.Writer.create()) {
        if (message.msg !== "") writer.uint32(10).string(message.msg);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $dd9fe2b01844108e$var$minimal_1.default.Reader ? input : new $dd9fe2b01844108e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $dd9fe2b01844108e$var$baseGenericAuthorization);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.msg = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $dd9fe2b01844108e$var$baseGenericAuthorization);
        if (object.msg !== undefined && object.msg !== null) message.msg = String(object.msg);
        else message.msg = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.msg !== undefined && (obj.msg = message.msg);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $dd9fe2b01844108e$var$baseGenericAuthorization);
        if (object.msg !== undefined && object.msg !== null) message.msg = object.msg;
        else message.msg = "";
        return message;
    }
};
const $dd9fe2b01844108e$var$baseGrant = {};
module.exports.Grant = {
    encode (message, writer = $dd9fe2b01844108e$var$minimal_1.default.Writer.create()) {
        if (message.authorization !== undefined) $c5FxR.Any.encode(message.authorization, writer.uint32(10).fork()).ldelim();
        if (message.expiration !== undefined) $5G2s6.Timestamp.encode($dd9fe2b01844108e$var$toTimestamp(message.expiration), writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $dd9fe2b01844108e$var$minimal_1.default.Reader ? input : new $dd9fe2b01844108e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $dd9fe2b01844108e$var$baseGrant);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.authorization = $c5FxR.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.expiration = $dd9fe2b01844108e$var$fromTimestamp($5G2s6.Timestamp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $dd9fe2b01844108e$var$baseGrant);
        if (object.authorization !== undefined && object.authorization !== null) message.authorization = $c5FxR.Any.fromJSON(object.authorization);
        else message.authorization = undefined;
        if (object.expiration !== undefined && object.expiration !== null) message.expiration = $dd9fe2b01844108e$var$fromJsonTimestamp(object.expiration);
        else message.expiration = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.authorization !== undefined && (obj.authorization = message.authorization ? $c5FxR.Any.toJSON(message.authorization) : undefined);
        message.expiration !== undefined && (obj.expiration = message.expiration.toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $dd9fe2b01844108e$var$baseGrant);
        if (object.authorization !== undefined && object.authorization !== null) message.authorization = $c5FxR.Any.fromPartial(object.authorization);
        else message.authorization = undefined;
        if (object.expiration !== undefined && object.expiration !== null) message.expiration = object.expiration;
        else message.expiration = undefined;
        return message;
    }
};
const $dd9fe2b01844108e$var$baseGrantAuthorization = {
    granter: "",
    grantee: ""
};
module.exports.GrantAuthorization = {
    encode (message, writer = $dd9fe2b01844108e$var$minimal_1.default.Writer.create()) {
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        if (message.authorization !== undefined) $c5FxR.Any.encode(message.authorization, writer.uint32(26).fork()).ldelim();
        if (message.expiration !== undefined) $5G2s6.Timestamp.encode($dd9fe2b01844108e$var$toTimestamp(message.expiration), writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $dd9fe2b01844108e$var$minimal_1.default.Reader ? input : new $dd9fe2b01844108e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $dd9fe2b01844108e$var$baseGrantAuthorization);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.authorization = $c5FxR.Any.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.expiration = $dd9fe2b01844108e$var$fromTimestamp($5G2s6.Timestamp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $dd9fe2b01844108e$var$baseGrantAuthorization);
        if (object.granter !== undefined && object.granter !== null) message.granter = String(object.granter);
        else message.granter = "";
        if (object.grantee !== undefined && object.grantee !== null) message.grantee = String(object.grantee);
        else message.grantee = "";
        if (object.authorization !== undefined && object.authorization !== null) message.authorization = $c5FxR.Any.fromJSON(object.authorization);
        else message.authorization = undefined;
        if (object.expiration !== undefined && object.expiration !== null) message.expiration = $dd9fe2b01844108e$var$fromJsonTimestamp(object.expiration);
        else message.expiration = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.authorization !== undefined && (obj.authorization = message.authorization ? $c5FxR.Any.toJSON(message.authorization) : undefined);
        message.expiration !== undefined && (obj.expiration = message.expiration.toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $dd9fe2b01844108e$var$baseGrantAuthorization);
        if (object.granter !== undefined && object.granter !== null) message.granter = object.granter;
        else message.granter = "";
        if (object.grantee !== undefined && object.grantee !== null) message.grantee = object.grantee;
        else message.grantee = "";
        if (object.authorization !== undefined && object.authorization !== null) message.authorization = $c5FxR.Any.fromPartial(object.authorization);
        else message.authorization = undefined;
        if (object.expiration !== undefined && object.expiration !== null) message.expiration = object.expiration;
        else message.expiration = undefined;
        return message;
    }
};
function $dd9fe2b01844108e$var$toTimestamp(date) {
    const seconds = $dd9fe2b01844108e$var$numberToLong(date.getTime() / 1000);
    const nanos = date.getTime() % 1000 * 1000000;
    return {
        seconds: seconds,
        nanos: nanos
    };
}
function $dd9fe2b01844108e$var$fromTimestamp(t) {
    let millis = t.seconds.toNumber() * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function $dd9fe2b01844108e$var$fromJsonTimestamp(o) {
    if (o instanceof Date) return o;
    else if (typeof o === "string") return new Date(o);
    else return $dd9fe2b01844108e$var$fromTimestamp($5G2s6.Timestamp.fromJSON(o));
}
function $dd9fe2b01844108e$var$numberToLong(number) {
    return $dd9fe2b01844108e$var$long_1.default.fromNumber(number);
}
if ($dd9fe2b01844108e$var$minimal_1.default.util.Long !== $dd9fe2b01844108e$var$long_1.default) {
    $dd9fe2b01844108e$var$minimal_1.default.util.Long = $dd9fe2b01844108e$var$long_1.default;
    $dd9fe2b01844108e$var$minimal_1.default.configure();
}

});


parcelRegister("7Ufxn", function(module, exports) {
"use strict";
var $5c19d0bc1f1ca55e$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Authorization = module.exports.AuthorizationGrant = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $6mYwU = parcelRequire("6mYwU");

var $cz8PY = parcelRequire("cz8PY");

var $MVJjb = parcelRequire("MVJjb");

var $j1HxC = parcelRequire("j1HxC");
var $5c19d0bc1f1ca55e$var$AuthorizationGrant = /** @class */ function(_super) {
    $5c19d0bc1f1ca55e$var$__extends(AuthorizationGrant, _super);
    function AuthorizationGrant(authorization, expiration) {
        var _this = _super.call(this) || this;
        _this.authorization = authorization;
        _this.expiration = expiration;
        return _this;
    }
    AuthorizationGrant.fromAmino = function(amino, isClassic) {
        var authorization = amino.authorization, expiration = amino.expiration;
        return new AuthorizationGrant($5c19d0bc1f1ca55e$var$Authorization.fromAmino(authorization, isClassic), new Date(expiration));
    };
    AuthorizationGrant.prototype.toAmino = function(isClassic) {
        var _a = this, authorization = _a.authorization, expiration = _a.expiration;
        return {
            authorization: authorization.toAmino(isClassic),
            expiration: expiration.toISOString().replace(/\.000Z$/, "Z")
        };
    };
    AuthorizationGrant.fromData = function(data, isClassic) {
        var authorization = data.authorization, expiration = data.expiration;
        return new AuthorizationGrant($5c19d0bc1f1ca55e$var$Authorization.fromData(authorization, isClassic), new Date(expiration));
    };
    AuthorizationGrant.prototype.toData = function(isClassic) {
        var _a = this, authorization = _a.authorization, expiration = _a.expiration;
        return {
            authorization: authorization.toData(isClassic),
            expiration: expiration.toISOString().replace(/\.000Z$/, "Z")
        };
    };
    AuthorizationGrant.fromProto = function(proto, isClassic) {
        return new AuthorizationGrant($5c19d0bc1f1ca55e$var$Authorization.fromProto(proto.authorization, isClassic), proto.expiration);
    };
    AuthorizationGrant.prototype.toProto = function(isClassic) {
        var _a = this, authorization = _a.authorization, expiration = _a.expiration;
        return $j1HxC.Grant.fromPartial({
            authorization: authorization.packAny(isClassic),
            expiration: expiration
        });
    };
    return AuthorizationGrant;
}($26Eqx.JSONSerializable);
module.exports.AuthorizationGrant = $5c19d0bc1f1ca55e$var$AuthorizationGrant;
var $5c19d0bc1f1ca55e$var$Authorization;
(function(Authorization) {
    function fromAmino(data, isClassic) {
        switch(data.type){
            case "msgauth/SendAuthorization":
            case "cosmos-sdk/SendAuthorization":
                return $cz8PY.SendAuthorization.fromAmino(data, isClassic);
            case "msgauth/GenericAuthorization":
            case "cosmos-sdk/GenericAuthorization":
                return $6mYwU.GenericAuthorization.fromAmino(data, isClassic);
        }
    }
    Authorization.fromAmino = fromAmino;
    function fromData(data, isClassic) {
        switch(data["@type"]){
            case "/cosmos.authz.v1beta1.GenericAuthorization":
                return $6mYwU.GenericAuthorization.fromData(data, isClassic);
            case "/cosmos.bank.v1beta1.SendAuthorization":
                return $cz8PY.SendAuthorization.fromData(data, isClassic);
            case "/cosmos.staking.v1beta1.StakeAuthorization":
                return $MVJjb.StakeAuthorization.fromData(data, isClassic);
        }
    }
    Authorization.fromData = fromData;
    function fromProto(proto, isClassic) {
        var typeUrl = proto.typeUrl;
        switch(typeUrl){
            case "/cosmos.authz.v1beta1.GenericAuthorization":
                return $6mYwU.GenericAuthorization.unpackAny(proto, isClassic);
            case "/cosmos.bank.v1beta1.SendAuthorization":
                return $cz8PY.SendAuthorization.unpackAny(proto, isClassic);
            case "/cosmos.staking.v1beta1.StakeAuthorization":
                return $MVJjb.StakeAuthorization.unpackAny(proto, isClassic);
        }
        throw new Error("Authorization type ".concat(typeUrl, " not recognized"));
    }
    Authorization.fromProto = fromProto;
})($5c19d0bc1f1ca55e$var$Authorization = module.exports.Authorization || (module.exports.Authorization = {}));

});


parcelRegister("cEC6O", function(module, exports) {
"use strict";
var $9366c814804fd2b9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GrpcWebImpl = module.exports.MsgRevokeDesc = module.exports.MsgExecDesc = module.exports.MsgGrantDesc = module.exports.MsgDesc = module.exports.MsgClientImpl = module.exports.MsgRevokeResponse = module.exports.MsgRevoke = module.exports.MsgGrantResponse = module.exports.MsgExec = module.exports.MsgExecResponse = module.exports.MsgGrant = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $9366c814804fd2b9$var$long_1 = $9366c814804fd2b9$var$__importDefault((parcelRequire("9A55m")));

var $jXVni = parcelRequire("jXVni");

const $9366c814804fd2b9$var$minimal_1 = $9366c814804fd2b9$var$__importDefault((parcelRequire("i2pIU")));

var $j1HxC = parcelRequire("j1HxC");

var $1pqjL = parcelRequire("1pqjL");

var $c5FxR = parcelRequire("c5FxR");
module.exports.protobufPackage = "cosmos.authz.v1beta1";
const $9366c814804fd2b9$var$baseMsgGrant = {
    granter: "",
    grantee: ""
};
module.exports.MsgGrant = {
    encode (message, writer = $9366c814804fd2b9$var$minimal_1.default.Writer.create()) {
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        if (message.grant !== undefined) $j1HxC.Grant.encode(message.grant, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9366c814804fd2b9$var$minimal_1.default.Reader ? input : new $9366c814804fd2b9$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9366c814804fd2b9$var$baseMsgGrant);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.grant = $j1HxC.Grant.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9366c814804fd2b9$var$baseMsgGrant);
        if (object.granter !== undefined && object.granter !== null) message.granter = String(object.granter);
        else message.granter = "";
        if (object.grantee !== undefined && object.grantee !== null) message.grantee = String(object.grantee);
        else message.grantee = "";
        if (object.grant !== undefined && object.grant !== null) message.grant = $j1HxC.Grant.fromJSON(object.grant);
        else message.grant = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.grant !== undefined && (obj.grant = message.grant ? $j1HxC.Grant.toJSON(message.grant) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9366c814804fd2b9$var$baseMsgGrant);
        if (object.granter !== undefined && object.granter !== null) message.granter = object.granter;
        else message.granter = "";
        if (object.grantee !== undefined && object.grantee !== null) message.grantee = object.grantee;
        else message.grantee = "";
        if (object.grant !== undefined && object.grant !== null) message.grant = $j1HxC.Grant.fromPartial(object.grant);
        else message.grant = undefined;
        return message;
    }
};
const $9366c814804fd2b9$var$baseMsgExecResponse = {};
module.exports.MsgExecResponse = {
    encode (message, writer = $9366c814804fd2b9$var$minimal_1.default.Writer.create()) {
        for (const v of message.results)writer.uint32(10).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9366c814804fd2b9$var$minimal_1.default.Reader ? input : new $9366c814804fd2b9$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9366c814804fd2b9$var$baseMsgExecResponse);
        message.results = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.results.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9366c814804fd2b9$var$baseMsgExecResponse);
        message.results = [];
        if (object.results !== undefined && object.results !== null) for (const e of object.results)message.results.push($9366c814804fd2b9$var$bytesFromBase64(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.results) obj.results = message.results.map((e)=>$9366c814804fd2b9$var$base64FromBytes(e !== undefined ? e : new Uint8Array()));
        else obj.results = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9366c814804fd2b9$var$baseMsgExecResponse);
        message.results = [];
        if (object.results !== undefined && object.results !== null) for (const e of object.results)message.results.push(e);
        return message;
    }
};
const $9366c814804fd2b9$var$baseMsgExec = {
    grantee: ""
};
module.exports.MsgExec = {
    encode (message, writer = $9366c814804fd2b9$var$minimal_1.default.Writer.create()) {
        if (message.grantee !== "") writer.uint32(10).string(message.grantee);
        for (const v of message.msgs)$c5FxR.Any.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9366c814804fd2b9$var$minimal_1.default.Reader ? input : new $9366c814804fd2b9$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9366c814804fd2b9$var$baseMsgExec);
        message.msgs = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.grantee = reader.string();
                    break;
                case 2:
                    message.msgs.push($c5FxR.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9366c814804fd2b9$var$baseMsgExec);
        message.msgs = [];
        if (object.grantee !== undefined && object.grantee !== null) message.grantee = String(object.grantee);
        else message.grantee = "";
        if (object.msgs !== undefined && object.msgs !== null) for (const e of object.msgs)message.msgs.push($c5FxR.Any.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.grantee !== undefined && (obj.grantee = message.grantee);
        if (message.msgs) obj.msgs = message.msgs.map((e)=>e ? $c5FxR.Any.toJSON(e) : undefined);
        else obj.msgs = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9366c814804fd2b9$var$baseMsgExec);
        message.msgs = [];
        if (object.grantee !== undefined && object.grantee !== null) message.grantee = object.grantee;
        else message.grantee = "";
        if (object.msgs !== undefined && object.msgs !== null) for (const e of object.msgs)message.msgs.push($c5FxR.Any.fromPartial(e));
        return message;
    }
};
const $9366c814804fd2b9$var$baseMsgGrantResponse = {};
module.exports.MsgGrantResponse = {
    encode (_, writer = $9366c814804fd2b9$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9366c814804fd2b9$var$minimal_1.default.Reader ? input : new $9366c814804fd2b9$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9366c814804fd2b9$var$baseMsgGrantResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $9366c814804fd2b9$var$baseMsgGrantResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $9366c814804fd2b9$var$baseMsgGrantResponse);
        return message;
    }
};
const $9366c814804fd2b9$var$baseMsgRevoke = {
    granter: "",
    grantee: "",
    msgTypeUrl: ""
};
module.exports.MsgRevoke = {
    encode (message, writer = $9366c814804fd2b9$var$minimal_1.default.Writer.create()) {
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        if (message.msgTypeUrl !== "") writer.uint32(26).string(message.msgTypeUrl);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9366c814804fd2b9$var$minimal_1.default.Reader ? input : new $9366c814804fd2b9$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9366c814804fd2b9$var$baseMsgRevoke);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.msgTypeUrl = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9366c814804fd2b9$var$baseMsgRevoke);
        if (object.granter !== undefined && object.granter !== null) message.granter = String(object.granter);
        else message.granter = "";
        if (object.grantee !== undefined && object.grantee !== null) message.grantee = String(object.grantee);
        else message.grantee = "";
        if (object.msgTypeUrl !== undefined && object.msgTypeUrl !== null) message.msgTypeUrl = String(object.msgTypeUrl);
        else message.msgTypeUrl = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.msgTypeUrl !== undefined && (obj.msgTypeUrl = message.msgTypeUrl);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9366c814804fd2b9$var$baseMsgRevoke);
        if (object.granter !== undefined && object.granter !== null) message.granter = object.granter;
        else message.granter = "";
        if (object.grantee !== undefined && object.grantee !== null) message.grantee = object.grantee;
        else message.grantee = "";
        if (object.msgTypeUrl !== undefined && object.msgTypeUrl !== null) message.msgTypeUrl = object.msgTypeUrl;
        else message.msgTypeUrl = "";
        return message;
    }
};
const $9366c814804fd2b9$var$baseMsgRevokeResponse = {};
module.exports.MsgRevokeResponse = {
    encode (_, writer = $9366c814804fd2b9$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9366c814804fd2b9$var$minimal_1.default.Reader ? input : new $9366c814804fd2b9$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9366c814804fd2b9$var$baseMsgRevokeResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $9366c814804fd2b9$var$baseMsgRevokeResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $9366c814804fd2b9$var$baseMsgRevokeResponse);
        return message;
    }
};
class $9366c814804fd2b9$var$MsgClientImpl {
    Grant(request, metadata) {
        return this.rpc.unary(module.exports.MsgGrantDesc, module.exports.MsgGrant.fromPartial(request), metadata);
    }
    Exec(request, metadata) {
        return this.rpc.unary(module.exports.MsgExecDesc, module.exports.MsgExec.fromPartial(request), metadata);
    }
    Revoke(request, metadata) {
        return this.rpc.unary(module.exports.MsgRevokeDesc, module.exports.MsgRevoke.fromPartial(request), metadata);
    }
    constructor(rpc){
        this.rpc = rpc;
        this.Grant = this.Grant.bind(this);
        this.Exec = this.Exec.bind(this);
        this.Revoke = this.Revoke.bind(this);
    }
}
module.exports.MsgClientImpl = $9366c814804fd2b9$var$MsgClientImpl;
module.exports.MsgDesc = {
    serviceName: "cosmos.authz.v1beta1.Msg"
};
module.exports.MsgGrantDesc = {
    methodName: "Grant",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgGrant.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgGrantResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.MsgExecDesc = {
    methodName: "Exec",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgExec.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgExecResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.MsgRevokeDesc = {
    methodName: "Revoke",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgRevoke.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgRevokeResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
class $9366c814804fd2b9$var$GrpcWebImpl {
    unary(methodDesc, _request, metadata) {
        var _a;
        const request = Object.assign(Object.assign({}, _request), methodDesc.requestType);
        const maybeCombinedMetadata = metadata && this.options.metadata ? new $1pqjL.BrowserHeaders(Object.assign(Object.assign({}, (_a = this.options) === null || _a === void 0 ? void 0 : _a.metadata.headersMap), metadata === null || metadata === void 0 ? void 0 : metadata.headersMap)) : metadata || this.options.metadata;
        return new Promise((resolve, reject)=>{
            $jXVni.grpc.unary(methodDesc, {
                request: request,
                host: this.host,
                metadata: maybeCombinedMetadata,
                transport: this.options.transport,
                debug: this.options.debug,
                onEnd: function(response) {
                    if (response.status === $jXVni.grpc.Code.OK) resolve(response.message);
                    else {
                        const err = new Error(response.statusMessage);
                        err.code = response.status;
                        err.metadata = response.trailers;
                        reject(err);
                    }
                }
            });
        });
    }
    constructor(host, options){
        this.host = host;
        this.options = options;
    }
}
module.exports.GrpcWebImpl = $9366c814804fd2b9$var$GrpcWebImpl;
var $9366c814804fd2b9$var$globalThis = (()=>{
    if (typeof $9366c814804fd2b9$var$globalThis !== "undefined") return $9366c814804fd2b9$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $9366c814804fd2b9$var$atob = $9366c814804fd2b9$var$globalThis.atob || ((b64)=>$9366c814804fd2b9$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $9366c814804fd2b9$var$bytesFromBase64(b64) {
    const bin = $9366c814804fd2b9$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $9366c814804fd2b9$var$btoa = $9366c814804fd2b9$var$globalThis.btoa || ((bin)=>$9366c814804fd2b9$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $9366c814804fd2b9$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $9366c814804fd2b9$var$btoa(bin.join(""));
}
if ($9366c814804fd2b9$var$minimal_1.default.util.Long !== $9366c814804fd2b9$var$long_1.default) {
    $9366c814804fd2b9$var$minimal_1.default.util.Long = $9366c814804fd2b9$var$long_1.default;
    $9366c814804fd2b9$var$minimal_1.default.configure();
}

});


parcelRegister("jV9g7", function(module, exports) {
"use strict";
var $e80a85d399ce52ae$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgRevokeAuthorization = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $cEC6O = parcelRequire("cEC6O");

var $c5FxR = parcelRequire("c5FxR");
var $e80a85d399ce52ae$var$MsgRevokeAuthorization = /** @class */ function(_super) {
    $e80a85d399ce52ae$var$__extends(MsgRevokeAuthorization, _super);
    /**
     * @param granter authorization granter
     * @param grantee authorization grantee
     * @param authorization_msg_type type of message to revoke
     */ function MsgRevokeAuthorization(granter, grantee, msg_type_url) {
        var _this = _super.call(this) || this;
        _this.granter = granter;
        _this.grantee = grantee;
        _this.msg_type_url = msg_type_url;
        return _this;
    }
    MsgRevokeAuthorization.fromAmino = function(data, _) {
        _;
        var _a = data.value, granter = _a.granter, grantee = _a.grantee, msg_type_url = _a.msg_type_url;
        return new MsgRevokeAuthorization(granter, grantee, msg_type_url);
    };
    MsgRevokeAuthorization.prototype.toAmino = function(isClassic) {
        var _a = this, granter = _a.granter, grantee = _a.grantee, msg_type_url = _a.msg_type_url;
        return {
            type: isClassic ? "msgauth/MsgRevokeAuthorization" : "cosmos-sdk/MsgRevoke",
            value: {
                granter: granter,
                grantee: grantee,
                msg_type_url: msg_type_url
            }
        };
    };
    MsgRevokeAuthorization.fromData = function(data, _) {
        _;
        var granter = data.granter, grantee = data.grantee, msg_type_url = data.msg_type_url;
        return new MsgRevokeAuthorization(granter, grantee, msg_type_url);
    };
    MsgRevokeAuthorization.prototype.toData = function(_) {
        _;
        var _a = this, granter = _a.granter, grantee = _a.grantee, msg_type_url = _a.msg_type_url;
        return {
            "@type": "/cosmos.authz.v1beta1.MsgRevoke",
            granter: granter,
            grantee: grantee,
            msg_type_url: msg_type_url
        };
    };
    MsgRevokeAuthorization.fromProto = function(proto, _) {
        _;
        return new MsgRevokeAuthorization(proto.granter, proto.grantee, proto.msgTypeUrl);
    };
    MsgRevokeAuthorization.prototype.toProto = function(_) {
        _;
        var _a = this, granter = _a.granter, grantee = _a.grantee, msg_type_url = _a.msg_type_url;
        return $cEC6O.MsgRevoke.fromPartial({
            grantee: grantee,
            granter: granter,
            msgTypeUrl: msg_type_url
        });
    };
    MsgRevokeAuthorization.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmos.authz.v1beta1.MsgRevoke",
            value: $cEC6O.MsgRevoke.encode(this.toProto(isClassic)).finish()
        });
    };
    MsgRevokeAuthorization.unpackAny = function(msgAny, isClassic) {
        return MsgRevokeAuthorization.fromProto($cEC6O.MsgRevoke.decode(msgAny.value), isClassic);
    };
    return MsgRevokeAuthorization;
}($26Eqx.JSONSerializable);
module.exports.MsgRevokeAuthorization = $e80a85d399ce52ae$var$MsgRevokeAuthorization;

});

parcelRegister("21shp", function(module, exports) {
"use strict";
var $17919c8e7d8fc051$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgExecAuthorized = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $7ag45 = parcelRequire("7ag45");

var $cEC6O = parcelRequire("cEC6O");

var $c5FxR = parcelRequire("c5FxR");
var $17919c8e7d8fc051$var$MsgExecAuthorized = /** @class */ function(_super) {
    $17919c8e7d8fc051$var$__extends(MsgExecAuthorized, _super);
    /**
     * @param grantee authorization grantee
     * @param msgs list of messages to execute
     */ function MsgExecAuthorized(grantee, msgs) {
        var _this = _super.call(this) || this;
        _this.grantee = grantee;
        _this.msgs = msgs;
        return _this;
    }
    MsgExecAuthorized.fromAmino = function(data, isClassic) {
        var _a = data.value, grantee = _a.grantee, msgs = _a.msgs;
        return new MsgExecAuthorized(grantee, msgs.map(function(x) {
            return $7ag45.Msg.fromAmino(x, isClassic);
        }));
    };
    MsgExecAuthorized.prototype.toAmino = function(isClassic) {
        var _a = this, grantee = _a.grantee, msgs = _a.msgs;
        return {
            type: isClassic ? "msgauth/MsgExecAuthorized" : "cosmos-sdk/MsgExec",
            value: {
                grantee: grantee,
                msgs: msgs.map(function(msg) {
                    return msg.toAmino(isClassic);
                })
            }
        };
    };
    MsgExecAuthorized.fromData = function(proto, isClassic) {
        var grantee = proto.grantee, msgs = proto.msgs;
        return new MsgExecAuthorized(grantee, msgs.map(function(x) {
            return $7ag45.Msg.fromData(x, isClassic);
        }));
    };
    MsgExecAuthorized.prototype.toData = function(isClassic) {
        var _a = this, grantee = _a.grantee, msgs = _a.msgs;
        return {
            "@type": "/cosmos.authz.v1beta1.MsgExec",
            grantee: grantee,
            msgs: msgs.map(function(msg) {
                return msg.toData(isClassic);
            })
        };
    };
    MsgExecAuthorized.fromProto = function(proto, isClassic) {
        return new MsgExecAuthorized(proto.grantee, proto.msgs.map(function(x) {
            return $7ag45.Msg.fromProto(x, isClassic);
        }));
    };
    MsgExecAuthorized.prototype.toProto = function(isClassic) {
        var _a = this, grantee = _a.grantee, msgs = _a.msgs;
        return $cEC6O.MsgExec.fromPartial({
            grantee: grantee,
            msgs: msgs.map(function(m) {
                return m.packAny(isClassic);
            })
        });
    };
    MsgExecAuthorized.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmos.authz.v1beta1.MsgExec",
            value: $cEC6O.MsgExec.encode(this.toProto(isClassic)).finish()
        });
    };
    MsgExecAuthorized.unpackAny = function(msgAny, isClassic) {
        return MsgExecAuthorized.fromProto($cEC6O.MsgExec.decode(msgAny.value), isClassic);
    };
    return MsgExecAuthorized;
}($26Eqx.JSONSerializable);
module.exports.MsgExecAuthorized = $17919c8e7d8fc051$var$MsgExecAuthorized;

});


parcelRegister("HTVN1", function(module, exports) {
"use strict";
var $083f67045fac4dae$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $083f67045fac4dae$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $083f67045fac4dae$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$083f67045fac4dae$var$__exportStar((parcelRequire("aqgNo")), module.exports);

$083f67045fac4dae$var$__exportStar((parcelRequire("gLyyx")), module.exports);

$083f67045fac4dae$var$__exportStar((parcelRequire("ijsFb")), module.exports);

});
parcelRegister("aqgNo", function(module, exports) {
"use strict";
var $79695c5992803fcd$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgDelegateFeedConsent = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $eX5Mq = parcelRequire("eX5Mq");
/**
 * A **feeeder** is an account which is responsible for signing transactions with Oracle vote
 * and prevote messages on behalf of the validator. The blockchain will reject
 * [[MsgExchangeRateVote]] and [[MsgExchangeRatePrevote]] messages in transactions
 * signed by an
 * account different than the registered feeder.
 *
 * The following message registers a validator's feeder address.
 */ var $79695c5992803fcd$var$MsgDelegateFeedConsent = /** @class */ function(_super) {
    $79695c5992803fcd$var$__extends(MsgDelegateFeedConsent, _super);
    /**
     * @param operator validator's operator address
     * @param delegate account address to set to feeder
     */ function MsgDelegateFeedConsent(operator, delegate) {
        var _this = _super.call(this) || this;
        _this.operator = operator;
        _this.delegate = delegate;
        return _this;
    }
    MsgDelegateFeedConsent.fromAmino = function(data, isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        var _a = data.value, operator = _a.operator, delegate = _a.delegate;
        return new MsgDelegateFeedConsent(operator, delegate);
    };
    MsgDelegateFeedConsent.prototype.toAmino = function(isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        var _a = this, operator = _a.operator, delegate = _a.delegate;
        return {
            type: "oracle/MsgDelegateFeedConsent",
            value: {
                operator: operator,
                delegate: delegate
            }
        };
    };
    MsgDelegateFeedConsent.fromData = function(data, isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        var operator = data.operator, delegate = data.delegate;
        return new MsgDelegateFeedConsent(operator, delegate);
    };
    MsgDelegateFeedConsent.prototype.toData = function(isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        var _a = this, operator = _a.operator, delegate = _a.delegate;
        return {
            "@type": "/terra.oracle.v1beta1.MsgDelegateFeedConsent",
            operator: operator,
            delegate: delegate
        };
    };
    MsgDelegateFeedConsent.fromProto = function(proto, isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        return new MsgDelegateFeedConsent(proto.operator, proto.delegate);
    };
    MsgDelegateFeedConsent.prototype.toProto = function(isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        var _a = this, operator = _a.operator, delegate = _a.delegate;
        return $eX5Mq.MsgDelegateFeedConsent.fromPartial({
            delegate: delegate,
            operator: operator
        });
    };
    MsgDelegateFeedConsent.prototype.packAny = function(isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        return $c5FxR.Any.fromPartial({
            typeUrl: "/terra.oracle.v1beta1.MsgDelegateFeedConsent",
            value: $eX5Mq.MsgDelegateFeedConsent.encode(this.toProto(isClassic)).finish()
        });
    };
    MsgDelegateFeedConsent.unpackAny = function(msgAny, isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        return MsgDelegateFeedConsent.fromProto($eX5Mq.MsgDelegateFeedConsent.decode(msgAny.value), isClassic);
    };
    return MsgDelegateFeedConsent;
}($26Eqx.JSONSerializable);
module.exports.MsgDelegateFeedConsent = $79695c5992803fcd$var$MsgDelegateFeedConsent;

});
parcelRegister("eX5Mq", function(module, exports) {
"use strict";
var $ae2b0f2c826aec0c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GrpcWebImpl = module.exports.MsgDelegateFeedConsentDesc = module.exports.MsgAggregateExchangeRateVoteDesc = module.exports.MsgAggregateExchangeRatePrevoteDesc = module.exports.MsgDesc = module.exports.MsgClientImpl = module.exports.MsgDelegateFeedConsentResponse = module.exports.MsgDelegateFeedConsent = module.exports.MsgAggregateExchangeRateVoteResponse = module.exports.MsgAggregateExchangeRateVote = module.exports.MsgAggregateExchangeRatePrevoteResponse = module.exports.MsgAggregateExchangeRatePrevote = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $ae2b0f2c826aec0c$var$long_1 = $ae2b0f2c826aec0c$var$__importDefault((parcelRequire("9A55m")));

var $jXVni = parcelRequire("jXVni");

const $ae2b0f2c826aec0c$var$minimal_1 = $ae2b0f2c826aec0c$var$__importDefault((parcelRequire("i2pIU")));

var $1pqjL = parcelRequire("1pqjL");
module.exports.protobufPackage = "terra.oracle.v1beta1";
const $ae2b0f2c826aec0c$var$baseMsgAggregateExchangeRatePrevote = {
    hash: "",
    feeder: "",
    validator: ""
};
module.exports.MsgAggregateExchangeRatePrevote = {
    encode (message, writer = $ae2b0f2c826aec0c$var$minimal_1.default.Writer.create()) {
        if (message.hash !== "") writer.uint32(10).string(message.hash);
        if (message.feeder !== "") writer.uint32(18).string(message.feeder);
        if (message.validator !== "") writer.uint32(26).string(message.validator);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ae2b0f2c826aec0c$var$minimal_1.default.Reader ? input : new $ae2b0f2c826aec0c$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ae2b0f2c826aec0c$var$baseMsgAggregateExchangeRatePrevote);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.string();
                    break;
                case 2:
                    message.feeder = reader.string();
                    break;
                case 3:
                    message.validator = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ae2b0f2c826aec0c$var$baseMsgAggregateExchangeRatePrevote);
        if (object.hash !== undefined && object.hash !== null) message.hash = String(object.hash);
        else message.hash = "";
        if (object.feeder !== undefined && object.feeder !== null) message.feeder = String(object.feeder);
        else message.feeder = "";
        if (object.validator !== undefined && object.validator !== null) message.validator = String(object.validator);
        else message.validator = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = message.hash);
        message.feeder !== undefined && (obj.feeder = message.feeder);
        message.validator !== undefined && (obj.validator = message.validator);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ae2b0f2c826aec0c$var$baseMsgAggregateExchangeRatePrevote);
        if (object.hash !== undefined && object.hash !== null) message.hash = object.hash;
        else message.hash = "";
        if (object.feeder !== undefined && object.feeder !== null) message.feeder = object.feeder;
        else message.feeder = "";
        if (object.validator !== undefined && object.validator !== null) message.validator = object.validator;
        else message.validator = "";
        return message;
    }
};
const $ae2b0f2c826aec0c$var$baseMsgAggregateExchangeRatePrevoteResponse = {};
module.exports.MsgAggregateExchangeRatePrevoteResponse = {
    encode (_, writer = $ae2b0f2c826aec0c$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ae2b0f2c826aec0c$var$minimal_1.default.Reader ? input : new $ae2b0f2c826aec0c$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ae2b0f2c826aec0c$var$baseMsgAggregateExchangeRatePrevoteResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $ae2b0f2c826aec0c$var$baseMsgAggregateExchangeRatePrevoteResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $ae2b0f2c826aec0c$var$baseMsgAggregateExchangeRatePrevoteResponse);
        return message;
    }
};
const $ae2b0f2c826aec0c$var$baseMsgAggregateExchangeRateVote = {
    salt: "",
    exchangeRates: "",
    feeder: "",
    validator: ""
};
module.exports.MsgAggregateExchangeRateVote = {
    encode (message, writer = $ae2b0f2c826aec0c$var$minimal_1.default.Writer.create()) {
        if (message.salt !== "") writer.uint32(10).string(message.salt);
        if (message.exchangeRates !== "") writer.uint32(18).string(message.exchangeRates);
        if (message.feeder !== "") writer.uint32(26).string(message.feeder);
        if (message.validator !== "") writer.uint32(34).string(message.validator);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ae2b0f2c826aec0c$var$minimal_1.default.Reader ? input : new $ae2b0f2c826aec0c$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ae2b0f2c826aec0c$var$baseMsgAggregateExchangeRateVote);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.salt = reader.string();
                    break;
                case 2:
                    message.exchangeRates = reader.string();
                    break;
                case 3:
                    message.feeder = reader.string();
                    break;
                case 4:
                    message.validator = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ae2b0f2c826aec0c$var$baseMsgAggregateExchangeRateVote);
        if (object.salt !== undefined && object.salt !== null) message.salt = String(object.salt);
        else message.salt = "";
        if (object.exchangeRates !== undefined && object.exchangeRates !== null) message.exchangeRates = String(object.exchangeRates);
        else message.exchangeRates = "";
        if (object.feeder !== undefined && object.feeder !== null) message.feeder = String(object.feeder);
        else message.feeder = "";
        if (object.validator !== undefined && object.validator !== null) message.validator = String(object.validator);
        else message.validator = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.salt !== undefined && (obj.salt = message.salt);
        message.exchangeRates !== undefined && (obj.exchangeRates = message.exchangeRates);
        message.feeder !== undefined && (obj.feeder = message.feeder);
        message.validator !== undefined && (obj.validator = message.validator);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ae2b0f2c826aec0c$var$baseMsgAggregateExchangeRateVote);
        if (object.salt !== undefined && object.salt !== null) message.salt = object.salt;
        else message.salt = "";
        if (object.exchangeRates !== undefined && object.exchangeRates !== null) message.exchangeRates = object.exchangeRates;
        else message.exchangeRates = "";
        if (object.feeder !== undefined && object.feeder !== null) message.feeder = object.feeder;
        else message.feeder = "";
        if (object.validator !== undefined && object.validator !== null) message.validator = object.validator;
        else message.validator = "";
        return message;
    }
};
const $ae2b0f2c826aec0c$var$baseMsgAggregateExchangeRateVoteResponse = {};
module.exports.MsgAggregateExchangeRateVoteResponse = {
    encode (_, writer = $ae2b0f2c826aec0c$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ae2b0f2c826aec0c$var$minimal_1.default.Reader ? input : new $ae2b0f2c826aec0c$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ae2b0f2c826aec0c$var$baseMsgAggregateExchangeRateVoteResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $ae2b0f2c826aec0c$var$baseMsgAggregateExchangeRateVoteResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $ae2b0f2c826aec0c$var$baseMsgAggregateExchangeRateVoteResponse);
        return message;
    }
};
const $ae2b0f2c826aec0c$var$baseMsgDelegateFeedConsent = {
    operator: "",
    delegate: ""
};
module.exports.MsgDelegateFeedConsent = {
    encode (message, writer = $ae2b0f2c826aec0c$var$minimal_1.default.Writer.create()) {
        if (message.operator !== "") writer.uint32(10).string(message.operator);
        if (message.delegate !== "") writer.uint32(18).string(message.delegate);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ae2b0f2c826aec0c$var$minimal_1.default.Reader ? input : new $ae2b0f2c826aec0c$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ae2b0f2c826aec0c$var$baseMsgDelegateFeedConsent);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.operator = reader.string();
                    break;
                case 2:
                    message.delegate = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ae2b0f2c826aec0c$var$baseMsgDelegateFeedConsent);
        if (object.operator !== undefined && object.operator !== null) message.operator = String(object.operator);
        else message.operator = "";
        if (object.delegate !== undefined && object.delegate !== null) message.delegate = String(object.delegate);
        else message.delegate = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.operator !== undefined && (obj.operator = message.operator);
        message.delegate !== undefined && (obj.delegate = message.delegate);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ae2b0f2c826aec0c$var$baseMsgDelegateFeedConsent);
        if (object.operator !== undefined && object.operator !== null) message.operator = object.operator;
        else message.operator = "";
        if (object.delegate !== undefined && object.delegate !== null) message.delegate = object.delegate;
        else message.delegate = "";
        return message;
    }
};
const $ae2b0f2c826aec0c$var$baseMsgDelegateFeedConsentResponse = {};
module.exports.MsgDelegateFeedConsentResponse = {
    encode (_, writer = $ae2b0f2c826aec0c$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ae2b0f2c826aec0c$var$minimal_1.default.Reader ? input : new $ae2b0f2c826aec0c$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ae2b0f2c826aec0c$var$baseMsgDelegateFeedConsentResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $ae2b0f2c826aec0c$var$baseMsgDelegateFeedConsentResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $ae2b0f2c826aec0c$var$baseMsgDelegateFeedConsentResponse);
        return message;
    }
};
class $ae2b0f2c826aec0c$var$MsgClientImpl {
    AggregateExchangeRatePrevote(request, metadata) {
        return this.rpc.unary(module.exports.MsgAggregateExchangeRatePrevoteDesc, module.exports.MsgAggregateExchangeRatePrevote.fromPartial(request), metadata);
    }
    AggregateExchangeRateVote(request, metadata) {
        return this.rpc.unary(module.exports.MsgAggregateExchangeRateVoteDesc, module.exports.MsgAggregateExchangeRateVote.fromPartial(request), metadata);
    }
    DelegateFeedConsent(request, metadata) {
        return this.rpc.unary(module.exports.MsgDelegateFeedConsentDesc, module.exports.MsgDelegateFeedConsent.fromPartial(request), metadata);
    }
    constructor(rpc){
        this.rpc = rpc;
        this.AggregateExchangeRatePrevote = this.AggregateExchangeRatePrevote.bind(this);
        this.AggregateExchangeRateVote = this.AggregateExchangeRateVote.bind(this);
        this.DelegateFeedConsent = this.DelegateFeedConsent.bind(this);
    }
}
module.exports.MsgClientImpl = $ae2b0f2c826aec0c$var$MsgClientImpl;
module.exports.MsgDesc = {
    serviceName: "terra.oracle.v1beta1.Msg"
};
module.exports.MsgAggregateExchangeRatePrevoteDesc = {
    methodName: "AggregateExchangeRatePrevote",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgAggregateExchangeRatePrevote.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgAggregateExchangeRatePrevoteResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.MsgAggregateExchangeRateVoteDesc = {
    methodName: "AggregateExchangeRateVote",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgAggregateExchangeRateVote.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgAggregateExchangeRateVoteResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.MsgDelegateFeedConsentDesc = {
    methodName: "DelegateFeedConsent",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgDelegateFeedConsent.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgDelegateFeedConsentResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
class $ae2b0f2c826aec0c$var$GrpcWebImpl {
    unary(methodDesc, _request, metadata) {
        var _a;
        const request = Object.assign(Object.assign({}, _request), methodDesc.requestType);
        const maybeCombinedMetadata = metadata && this.options.metadata ? new $1pqjL.BrowserHeaders(Object.assign(Object.assign({}, (_a = this.options) === null || _a === void 0 ? void 0 : _a.metadata.headersMap), metadata === null || metadata === void 0 ? void 0 : metadata.headersMap)) : metadata || this.options.metadata;
        return new Promise((resolve, reject)=>{
            $jXVni.grpc.unary(methodDesc, {
                request: request,
                host: this.host,
                metadata: maybeCombinedMetadata,
                transport: this.options.transport,
                debug: this.options.debug,
                onEnd: function(response) {
                    if (response.status === $jXVni.grpc.Code.OK) resolve(response.message);
                    else {
                        const err = new Error(response.statusMessage);
                        err.code = response.status;
                        err.metadata = response.trailers;
                        reject(err);
                    }
                }
            });
        });
    }
    constructor(host, options){
        this.host = host;
        this.options = options;
    }
}
module.exports.GrpcWebImpl = $ae2b0f2c826aec0c$var$GrpcWebImpl;
if ($ae2b0f2c826aec0c$var$minimal_1.default.util.Long !== $ae2b0f2c826aec0c$var$long_1.default) {
    $ae2b0f2c826aec0c$var$minimal_1.default.util.Long = $ae2b0f2c826aec0c$var$long_1.default;
    $ae2b0f2c826aec0c$var$minimal_1.default.configure();
}

});


parcelRegister("gLyyx", function(module, exports) {
"use strict";
var $c34bd73cc82e4500$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgAggregateExchangeRateVote = module.exports.aggregateVoteHash = void 0;

var $bKarv = parcelRequire("bKarv");

var $26Eqx = parcelRequire("26Eqx");

var $ijsFb = parcelRequire("ijsFb");

var $kYslP = parcelRequire("kYslP");

var $c5FxR = parcelRequire("c5FxR");

var $eX5Mq = parcelRequire("eX5Mq");
/**
 * Calculates the aggregate vote hash
 * @param exchangeRates exchange rates
 * @param salt salt
 * @param validator validator operator address
 */ function $c34bd73cc82e4500$var$aggregateVoteHash(exchangeRates, salt, validator) {
    var payload = "".concat(salt, ":").concat(exchangeRates.toDecCoins().toString(), ":").concat(validator);
    return $bKarv.SHA256.hash(payload).toString().substring(0, 40);
}
module.exports.aggregateVoteHash = $c34bd73cc82e4500$var$aggregateVoteHash;
/**
 * Aggregate analog of MsgExchangeRateVote: submits an oracle vote for multiple denominations
 * through a single message rather than multiple messages.
 */ var $c34bd73cc82e4500$var$MsgAggregateExchangeRateVote = /** @class */ function(_super) {
    $c34bd73cc82e4500$var$__extends(MsgAggregateExchangeRateVote, _super);
    /**
     * @param exchange_rate exchange rates
     * @param salt salt
     * @param feeder feeder address
     * @param validator validator operator address
     */ function MsgAggregateExchangeRateVote(exchange_rates, salt, feeder, validator) {
        var _this = _super.call(this) || this;
        _this.salt = salt;
        _this.feeder = feeder;
        _this.validator = validator;
        _this.exchange_rates = new $kYslP.Coins(exchange_rates).toDecCoins();
        return _this;
    }
    MsgAggregateExchangeRateVote.fromAmino = function(data, isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        var _a = data.value, exchange_rates = _a.exchange_rates, salt = _a.salt, feeder = _a.feeder, validator = _a.validator;
        var xrs = $kYslP.Coins.fromString(exchange_rates);
        return new MsgAggregateExchangeRateVote(xrs, salt, feeder, validator);
    };
    MsgAggregateExchangeRateVote.prototype.toAmino = function(isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        var _a = this, exchange_rates = _a.exchange_rates, salt = _a.salt, feeder = _a.feeder, validator = _a.validator;
        return {
            type: "oracle/MsgAggregateExchangeRateVote",
            value: {
                exchange_rates: exchange_rates.toDecCoins().toString(),
                salt: salt,
                feeder: feeder,
                validator: validator
            }
        };
    };
    MsgAggregateExchangeRateVote.fromData = function(proto, isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        var exchange_rates = proto.exchange_rates, salt = proto.salt, feeder = proto.feeder, validator = proto.validator;
        var xrs = $kYslP.Coins.fromString(exchange_rates);
        return new MsgAggregateExchangeRateVote(xrs, salt, feeder, validator);
    };
    MsgAggregateExchangeRateVote.prototype.toData = function(isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        var _a = this, exchange_rates = _a.exchange_rates, salt = _a.salt, feeder = _a.feeder, validator = _a.validator;
        return {
            "@type": "/terra.oracle.v1beta1.MsgAggregateExchangeRateVote",
            exchange_rates: exchange_rates.toDecCoins().toString(),
            salt: salt,
            feeder: feeder,
            validator: validator
        };
    };
    MsgAggregateExchangeRateVote.fromProto = function(proto, isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        var xrs = $kYslP.Coins.fromString(proto.exchangeRates);
        return new MsgAggregateExchangeRateVote(xrs, proto.salt, proto.feeder, proto.validator);
    };
    MsgAggregateExchangeRateVote.prototype.toProto = function(isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        var _a = this, exchange_rates = _a.exchange_rates, salt = _a.salt, feeder = _a.feeder, validator = _a.validator;
        return $eX5Mq.MsgAggregateExchangeRateVote.fromPartial({
            exchangeRates: exchange_rates.toString(),
            feeder: feeder,
            salt: salt,
            validator: validator
        });
    };
    /**
     * Gets the aggregate vote hash for the MsgAggregateExchangeRateVote, for the creation of
     *  the corresponding prevote message.
     */ MsgAggregateExchangeRateVote.prototype.getAggregateVoteHash = function() {
        return $c34bd73cc82e4500$var$aggregateVoteHash(this.exchange_rates, this.salt, this.validator);
    };
    /**
     * You can generate the corresponding aggregate prevote message.
     * This will return a [[MsgAggregateExchangeRatePrevote]] with the proper vote hash and values,
     * determined by the current attributes of the object.
     *
     * @returns the corresponding prevote message to send
     */ MsgAggregateExchangeRateVote.prototype.getPrevote = function() {
        return new $ijsFb.MsgAggregateExchangeRatePrevote(this.getAggregateVoteHash(), this.feeder, this.validator);
    };
    MsgAggregateExchangeRateVote.prototype.packAny = function(isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        return $c5FxR.Any.fromPartial({
            typeUrl: "/terra.oracle.v1beta1.MsgAggregateExchangeRateVote",
            value: $eX5Mq.MsgAggregateExchangeRateVote.encode(this.toProto(isClassic)).finish()
        });
    };
    MsgAggregateExchangeRateVote.unpackAny = function(msgAny, isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        return MsgAggregateExchangeRateVote.fromProto($eX5Mq.MsgAggregateExchangeRateVote.decode(msgAny.value), isClassic);
    };
    return MsgAggregateExchangeRateVote;
}($26Eqx.JSONSerializable);
module.exports.MsgAggregateExchangeRateVote = $c34bd73cc82e4500$var$MsgAggregateExchangeRateVote;

});
parcelRegister("bKarv", function(module, exports) {

!function(n, t) {
    var r, i;
    module.exports = t();
}(module.exports, function() {
    return function() {
        "use strict";
        var n = {
            3354: function(n, t, r) {
                r.d(t, {
                    e: function() {
                        return o;
                    }
                });
                var i = r(5720), e = r(9054), o = function() {
                    function n(t, r) {
                        if (Array.isArray(t) || !t) return this.t = Array.isArray(t) ? t : [], void (this.i = "number" == typeof r ? r : 4 * this.t.length);
                        if (t instanceof n) return this.t = t.words.slice(), void (this.i = t.nSigBytes);
                        var i;
                        try {
                            t instanceof ArrayBuffer ? i = new Uint8Array(t) : (t instanceof Uint8Array || t instanceof Int8Array || t instanceof Uint8ClampedArray || t instanceof Int16Array || t instanceof Uint16Array || t instanceof Int32Array || t instanceof Uint32Array || t instanceof Float32Array || t instanceof Float64Array) && (i = new Uint8Array(t.buffer, t.byteOffset, t.byteLength));
                        } catch (n) {
                            throw new Error("Invalid argument");
                        }
                        if (!i) throw new Error("Invalid argument");
                        for(var e = i.byteLength, o = [], u = 0; u < e; u++)o[u >>> 2] |= i[u] << 24 - u % 4 * 8;
                        this.t = o, this.i = e;
                    }
                    return Object.defineProperty(n.prototype, "nSigBytes", {
                        get: function() {
                            return this.i;
                        },
                        set: function(n) {
                            this.i = n;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(n.prototype, "words", {
                        get: function() {
                            return this.t;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), n.prototype.toString = function(n) {
                        return n ? n.stringify(this) : i.p.stringify(this);
                    }, n.prototype.toUint8Array = function() {
                        for(var n = this.t, t = this.i, r = new Uint8Array(t), i = 0; i < t; i++)r[i] = n[i >>> 2] >>> 24 - i % 4 * 8 & 255;
                        return r;
                    }, n.prototype.concat = function(n) {
                        var t = n.words.slice(), r = n.nSigBytes;
                        if (this.clamp(), this.i % 4) for(var i = 0; i < r; i++){
                            var e = t[i >>> 2] >>> 24 - i % 4 * 8 & 255;
                            this.t[this.i + i >>> 2] |= e << 24 - (this.i + i) % 4 * 8;
                        }
                        else for(i = 0; i < r; i += 4)this.t[this.i + i >>> 2] = t[i >>> 2];
                        return this.i += r, this;
                    }, n.prototype.clamp = function() {
                        var n = this.i;
                        this.t[n >>> 2] &= 4294967295 << 32 - n % 4 * 8, this.t.length = Math.ceil(n / 4);
                    }, n.prototype.clone = function() {
                        return new n(this.t.slice(), this.i);
                    }, n.random = function(t) {
                        for(var r = [], i = 0; i < t; i += 4)r.push((0, e.M)());
                        return new n(r, t);
                    }, n;
                }();
            },
            7211: function(n, t, r) {
                r.d(t, {
                    C: function() {
                        return o;
                    }
                });
                var i = r(3354), e = r(4768), o = function() {
                    function n(n) {
                        this.u = 0, this.h = 0, this.v = n, this.l = n && void 0 !== n.data ? n.data.clone() : new i.e, this.A = n && "number" == typeof n.nBytes ? n.nBytes : 0;
                    }
                    return Object.defineProperty(n.prototype, "blockSize", {
                        get: function() {
                            return this.h;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), n.prototype.reset = function(n, t) {
                        this.l = void 0 !== n ? n.clone() : new i.e, this.A = "number" == typeof t ? t : 0;
                    }, n.prototype.j = function(n) {
                        var t = "string" == typeof n ? e.d.parse(n) : n;
                        this.l.concat(t), this.A += t.nSigBytes;
                    }, n.prototype.O = function(n) {
                        var t, r = this.l.words, e = this.l.nSigBytes, o = this.h, u = e / (4 * this.h), f = (u = n ? Math.ceil(u) : Math.max((0 | u) - this.u, 0)) * o, c = Math.min(4 * f, e);
                        if (f) {
                            for(var a = 0; a < f; a += o)this.I(r, a);
                            t = r.splice(0, f), this.l.nSigBytes -= c;
                        }
                        return new i.e(t, c);
                    }, n.prototype.I = function(n, t) {
                        throw new Error("Not implemented");
                    }, n;
                }();
            },
            1868: function(n, t, r) {
                r.d(t, {
                    P: function() {
                        return u;
                    }
                });
                var i, e = r(7211), o = (i = function(n, t) {
                    return (i = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(n, t) {
                        n.__proto__ = t;
                    } || function(n, t) {
                        for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
                    })(n, t);
                }, function(n, t) {
                    function r() {
                        this.constructor = n;
                    }
                    i(n, t), n.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
                }), u = function(n) {
                    function t(t) {
                        var r = n.call(this, t) || this;
                        return r.h = 16, r.v = t, t && "number" == typeof t.blockSize && (r.h = t.blockSize), r.reset(t ? t.data : void 0, t ? t.nBytes : void 0), r;
                    }
                    return o(t, n), Object.defineProperty(t.prototype, "blockSize", {
                        get: function() {
                            return this.h;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), t.prototype.reset = function(t, r) {
                        n.prototype.reset.call(this, t, r), this.U();
                    }, t.prototype.update = function(n) {
                        return this.j(n), this.O(), this;
                    }, t.prototype.finalize = function(n) {
                        return n && this.j(n), this._();
                    }, t.prototype.U = function() {
                        throw new Error("Not implemented");
                    }, t.prototype._ = function() {
                        throw new Error("Not implemented");
                    }, t;
                }(e.C);
            },
            1756: function(n, t, r) {
                r.d(t, {
                    w: function() {
                        return u;
                    }
                });
                var i, e = "undefined" != typeof navigator && navigator.userAgent ? navigator.userAgent.toLowerCase() : "", o = (i = parseInt((/msie (\d+)/.exec(e) || [])[1], 10), isNaN(i) ? (i = parseInt((/trident\/.*; rv:(\d+)/.exec(e) || [])[1], 10), !isNaN(i) && i) : i);
                function u(n, t) {
                    return !1 !== o && (!t || ("<" === n ? o < t : "<=" === n ? o <= t : ">" === n ? o > t : ">=" === n ? o >= t : o === t));
                }
            },
            5720: function(n, t, r) {
                r.d(t, {
                    p: function() {
                        return e;
                    }
                });
                var i = r(3354), e = {
                    stringify: function(n) {
                        for(var t = n.nSigBytes, r = n.words, i = [], e = 0; e < t; e++){
                            var o = r[e >>> 2] >>> 24 - e % 4 * 8 & 255;
                            i.push((o >>> 4).toString(16)), i.push((15 & o).toString(16));
                        }
                        return i.join("");
                    },
                    parse: function(n) {
                        var t = n.length;
                        if (t % 2 != 0) throw new Error("Hex string count must be even");
                        if (!/^[a-fA-F0-9]+$/.test(n)) throw new Error("Invalid Hex string: " + n);
                        for(var r = [], e = 0; e < t; e += 2)r[e >>> 3] |= parseInt(n.substr(e, 2), 16) << 24 - e % 8 * 4;
                        return new i.e(r, t / 2);
                    }
                };
            },
            8702: function(n, t, r) {
                r.d(t, {
                    m: function() {
                        return e;
                    }
                });
                var i = r(3354), e = {
                    stringify: function(n) {
                        for(var t = n.nSigBytes, r = n.words, i = [], e = 0; e < t; e++){
                            var o = r[e >>> 2] >>> 24 - e % 4 * 8 & 255;
                            i.push(String.fromCharCode(o));
                        }
                        return i.join("");
                    },
                    parse: function(n) {
                        for(var t = n.length, r = [], e = 0; e < t; e++)r[e >>> 2] |= (255 & n.charCodeAt(e)) << 24 - e % 4 * 8;
                        return new i.e(r, t);
                    }
                };
            },
            4768: function(n, t, r) {
                r.d(t, {
                    d: function() {
                        return e;
                    }
                });
                var i = r(8702), e = {
                    stringify: function(n) {
                        try {
                            return decodeURIComponent(escape(i.m.stringify(n)));
                        } catch (n) {
                            throw new Error("Malformed UTF-8 data");
                        }
                    },
                    parse: function(n) {
                        return i.m.parse(unescape(encodeURIComponent(n)));
                    }
                };
            },
            9054: function(n, t, r) {
                r.d(t, {
                    M: function() {
                        return e;
                    }
                });
                var i = r(1756);
                var e = function() {
                    if ("undefined" != typeof window) {
                        var n = window.crypto || window.msCrypto;
                        if (!n) {
                            if ((0, i.w)("<", 11)) return console.warn("IE <= 10 uses insecure random generator. Please consider to use IE11 or another modern browser"), function() {
                                return Math.floor(512 * Math.random()) % 256;
                            };
                            throw new Error("Crypto module not found");
                        }
                        return function() {
                            return n.getRandomValues(new Uint32Array(1))[0];
                        };
                    }
                    return void 0 !== r.g && r.g.crypto ? function() {
                        return r.g.crypto.randomBytes(4).readInt32LE();
                    } : function() {
                        return (parcelRequire("aqbQf")).randomBytes(4).readInt32LE();
                    };
                }();
            }
        }, t = {};
        function r(i) {
            var e = t[i];
            if (void 0 !== e) return e.exports;
            var o = t[i] = {
                exports: {}
            };
            return n[i](o, o.exports, r), o.exports;
        }
        r.d = function(n, t) {
            for(var i in t)r.o(t, i) && !r.o(n, i) && Object.defineProperty(n, i, {
                enumerable: !0,
                get: t[i]
            });
        }, r.g = function() {
            if ("object" == typeof globalThis) return globalThis;
            try {
                return this || new Function("return this")();
            } catch (n) {
                if ("object" == typeof window) return window;
            }
        }(), r.o = function(n, t) {
            return Object.prototype.hasOwnProperty.call(n, t);
        }, r.r = function(n) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(n, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(n, "S", {
                value: !0
            });
        };
        var i = {};
        return function() {
            r.r(i), r.d(i, {
                SHA256: function() {
                    return h;
                }
            });
            var n, t = r(1868), e = r(3354), o = (n = function(t, r) {
                return (n = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(n, t) {
                    n.__proto__ = t;
                } || function(n, t) {
                    for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
                })(t, r);
            }, function(t, r) {
                function i() {
                    this.constructor = t;
                }
                n(t, r), t.prototype = null === r ? Object.create(r) : (i.prototype = r.prototype, new i);
            }), u = [], f = [];
            function c(n) {
                for(var t = Math.sqrt(n), r = 2; r <= t; r++)if (!(n % r)) return !1;
                return !0;
            }
            function a(n) {
                return 4294967296 * (n - (0 | n)) | 0;
            }
            !function() {
                for(var n = 2, t = 0; t < 64;)c(n) && (t < 8 && (u[t] = a(Math.pow(n, .5))), f[t] = a(Math.pow(n, 1 / 3)), t++), n++;
            }();
            var s = [], h = function(n) {
                function t(t) {
                    var r = n.call(this, t) || this;
                    return r.N = new e.e(u.slice(0)), r.v = t, t && void 0 !== t.hash && (r.N = t.hash.clone()), r;
                }
                return o(t, n), t.prototype.U = function() {
                    this.N = new e.e(u.slice(0));
                }, t.prototype.I = function(n, t) {
                    for(var r = this.N.words, i = r[0], e = r[1], o = r[2], u = r[3], c = r[4], a = r[5], h = r[6], v = r[7], d = 0; d < 64; d++){
                        if (d < 16) s[d] = 0 | n[t + d];
                        else {
                            var w = s[d - 15], l = (w << 25 | w >>> 7) ^ (w << 14 | w >>> 18) ^ w >>> 3, y = s[d - 2], b = (y << 15 | y >>> 17) ^ (y << 13 | y >>> 19) ^ y >>> 10;
                            s[d] = l + s[d - 7] + b + s[d - 16];
                        }
                        var p = i & e ^ i & o ^ e & o, m = (i << 30 | i >>> 2) ^ (i << 19 | i >>> 13) ^ (i << 10 | i >>> 22), g = v + ((c << 26 | c >>> 6) ^ (c << 21 | c >>> 11) ^ (c << 7 | c >>> 25)) + (c & a ^ ~c & h) + f[d] + s[d];
                        v = h, h = a, a = c, c = u + g | 0, u = o, o = e, e = i, i = g + (m + p) | 0;
                    }
                    r[0] = r[0] + i | 0, r[1] = r[1] + e | 0, r[2] = r[2] + o | 0, r[3] = r[3] + u | 0, r[4] = r[4] + c | 0, r[5] = r[5] + a | 0, r[6] = r[6] + h | 0, r[7] = r[7] + v | 0;
                }, t.prototype._ = function() {
                    var n = this.l.words, t = 8 * this.A, r = 8 * this.l.nSigBytes;
                    return n[r >>> 5] |= 128 << 24 - r % 32, n[14 + (r + 64 >>> 9 << 4)] = Math.floor(t / 4294967296), n[15 + (r + 64 >>> 9 << 4)] = t, this.l.nSigBytes = 4 * n.length, this.O(), this.N;
                }, t.prototype.clone = function() {
                    return new t({
                        hash: this.N,
                        blockSize: this.h,
                        data: this.l,
                        nBytes: this.A
                    });
                }, t.hash = function(n, r) {
                    return new t(r).finalize(n);
                }, t;
            }(t.P);
        }(), i;
    }();
});

});

parcelRegister("ijsFb", function(module, exports) {
"use strict";
var $d5503c427cb502da$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgAggregateExchangeRatePrevote = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $eX5Mq = parcelRequire("eX5Mq");
/**
 * Aggregate analog of MsgExchangeRatePrevote
 */ var $d5503c427cb502da$var$MsgAggregateExchangeRatePrevote = /** @class */ function(_super) {
    $d5503c427cb502da$var$__extends(MsgAggregateExchangeRatePrevote, _super);
    /**
     * @param hash vote hash
     * @param feeder validator's feeder account address
     * @param validator validator's operator address
     */ function MsgAggregateExchangeRatePrevote(hash, feeder, validator) {
        var _this = _super.call(this) || this;
        _this.hash = hash;
        _this.feeder = feeder;
        _this.validator = validator;
        return _this;
    }
    MsgAggregateExchangeRatePrevote.fromAmino = function(data, isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        var _a = data.value, hash = _a.hash, feeder = _a.feeder, validator = _a.validator;
        return new MsgAggregateExchangeRatePrevote(hash, feeder, validator);
    };
    MsgAggregateExchangeRatePrevote.prototype.toAmino = function(isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        var _a = this, hash = _a.hash, feeder = _a.feeder, validator = _a.validator;
        return {
            type: "oracle/MsgAggregateExchangeRatePrevote",
            value: {
                hash: hash,
                feeder: feeder,
                validator: validator
            }
        };
    };
    MsgAggregateExchangeRatePrevote.fromData = function(data, isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        var hash = data.hash, feeder = data.feeder, validator = data.validator;
        return new MsgAggregateExchangeRatePrevote(hash, feeder, validator);
    };
    MsgAggregateExchangeRatePrevote.prototype.toData = function(isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        var _a = this, hash = _a.hash, feeder = _a.feeder, validator = _a.validator;
        return {
            "@type": "/terra.oracle.v1beta1.MsgAggregateExchangeRatePrevote",
            hash: hash,
            feeder: feeder,
            validator: validator
        };
    };
    MsgAggregateExchangeRatePrevote.fromProto = function(proto, isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        return new MsgAggregateExchangeRatePrevote(proto.hash, proto.feeder, proto.validator);
    };
    MsgAggregateExchangeRatePrevote.prototype.toProto = function(isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        var _a = this, hash = _a.hash, feeder = _a.feeder, validator = _a.validator;
        return $eX5Mq.MsgAggregateExchangeRatePrevote.fromPartial({
            hash: hash,
            feeder: feeder,
            validator: validator
        });
    };
    MsgAggregateExchangeRatePrevote.prototype.packAny = function(isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        return $c5FxR.Any.fromPartial({
            typeUrl: "/terra.oracle.v1beta1.MsgAggregateExchangeRatePrevote",
            value: $eX5Mq.MsgAggregateExchangeRatePrevote.encode(this.toProto(isClassic)).finish()
        });
    };
    MsgAggregateExchangeRatePrevote.unpackAny = function(msgAny, isClassic) {
        if (!isClassic) throw new Error("Not supported for the network");
        return MsgAggregateExchangeRatePrevote.fromProto($eX5Mq.MsgAggregateExchangeRatePrevote.decode(msgAny.value), isClassic);
    };
    return MsgAggregateExchangeRatePrevote;
}($26Eqx.JSONSerializable);
module.exports.MsgAggregateExchangeRatePrevote = $d5503c427cb502da$var$MsgAggregateExchangeRatePrevote;

});



parcelRegister("ivinb", function(module, exports) {
"use strict";
var $d7895fbe451004e9$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d7895fbe451004e9$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d7895fbe451004e9$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$d7895fbe451004e9$var$__exportStar((parcelRequire("5v2zB")), module.exports);

});
parcelRegister("5v2zB", function(module, exports) {
"use strict";
var $4011d8009c0c35cb$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgUnjail = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $luSz5 = parcelRequire("luSz5");
/**
 * A validator can be jailed by the blockchain if misbehavior is detected, such as
 * double-signing or having missed too many vote periods in the Oracle ballot.
 *
 * This is done to protect delegators' funds from getting slashed further, until the
 * validator's issues have been addressed. A jailed validator cannot participate in
 * block rewards, and must be manually unjailed by submitting this message.
 */ var $4011d8009c0c35cb$var$MsgUnjail = /** @class */ function(_super) {
    $4011d8009c0c35cb$var$__extends(MsgUnjail, _super);
    /**
     * @param address validator's operator address
     */ function MsgUnjail(address) {
        var _this = _super.call(this) || this;
        _this.address = address;
        return _this;
    }
    MsgUnjail.fromAmino = function(data, _) {
        _;
        var address = data.value.address;
        return new MsgUnjail(address);
    };
    MsgUnjail.prototype.toAmino = function(isClassic) {
        var address = this.address;
        return {
            type: isClassic ? "slashing/MsgUnjail" : "cosmos-sdk/MsgUnjail",
            value: {
                address: address
            }
        };
    };
    MsgUnjail.fromData = function(proto, _) {
        _;
        var address = proto.address;
        return new MsgUnjail(address);
    };
    MsgUnjail.prototype.toData = function(_) {
        _;
        var address = this.address;
        return {
            "@type": "/cosmos.slashing.v1beta1.MsgUnjail",
            address: address
        };
    };
    MsgUnjail.fromProto = function(proto, _) {
        _;
        return new MsgUnjail(proto.validatorAddr);
    };
    MsgUnjail.prototype.toProto = function(_) {
        _;
        var address = this.address;
        return $luSz5.MsgUnjail.fromPartial({
            validatorAddr: address
        });
    };
    MsgUnjail.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmos.slashing.v1beta1.MsgUnjail",
            value: $luSz5.MsgUnjail.encode(this.toProto(isClassic)).finish()
        });
    };
    MsgUnjail.unpackAny = function(msgAny, isClassic) {
        return MsgUnjail.fromProto($luSz5.MsgUnjail.decode(msgAny.value), isClassic);
    };
    return MsgUnjail;
}($26Eqx.JSONSerializable);
module.exports.MsgUnjail = $4011d8009c0c35cb$var$MsgUnjail;

});
parcelRegister("luSz5", function(module, exports) {
"use strict";
var $fa66b9c7f8f34137$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GrpcWebImpl = module.exports.MsgUnjailDesc = module.exports.MsgDesc = module.exports.MsgClientImpl = module.exports.MsgUnjailResponse = module.exports.MsgUnjail = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $fa66b9c7f8f34137$var$long_1 = $fa66b9c7f8f34137$var$__importDefault((parcelRequire("9A55m")));

var $jXVni = parcelRequire("jXVni");

const $fa66b9c7f8f34137$var$minimal_1 = $fa66b9c7f8f34137$var$__importDefault((parcelRequire("i2pIU")));

var $1pqjL = parcelRequire("1pqjL");
module.exports.protobufPackage = "cosmos.slashing.v1beta1";
const $fa66b9c7f8f34137$var$baseMsgUnjail = {
    validatorAddr: ""
};
module.exports.MsgUnjail = {
    encode (message, writer = $fa66b9c7f8f34137$var$minimal_1.default.Writer.create()) {
        if (message.validatorAddr !== "") writer.uint32(10).string(message.validatorAddr);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fa66b9c7f8f34137$var$minimal_1.default.Reader ? input : new $fa66b9c7f8f34137$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $fa66b9c7f8f34137$var$baseMsgUnjail);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddr = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $fa66b9c7f8f34137$var$baseMsgUnjail);
        if (object.validatorAddr !== undefined && object.validatorAddr !== null) message.validatorAddr = String(object.validatorAddr);
        else message.validatorAddr = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.validatorAddr !== undefined && (obj.validatorAddr = message.validatorAddr);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $fa66b9c7f8f34137$var$baseMsgUnjail);
        if (object.validatorAddr !== undefined && object.validatorAddr !== null) message.validatorAddr = object.validatorAddr;
        else message.validatorAddr = "";
        return message;
    }
};
const $fa66b9c7f8f34137$var$baseMsgUnjailResponse = {};
module.exports.MsgUnjailResponse = {
    encode (_, writer = $fa66b9c7f8f34137$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fa66b9c7f8f34137$var$minimal_1.default.Reader ? input : new $fa66b9c7f8f34137$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $fa66b9c7f8f34137$var$baseMsgUnjailResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $fa66b9c7f8f34137$var$baseMsgUnjailResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $fa66b9c7f8f34137$var$baseMsgUnjailResponse);
        return message;
    }
};
class $fa66b9c7f8f34137$var$MsgClientImpl {
    Unjail(request, metadata) {
        return this.rpc.unary(module.exports.MsgUnjailDesc, module.exports.MsgUnjail.fromPartial(request), metadata);
    }
    constructor(rpc){
        this.rpc = rpc;
        this.Unjail = this.Unjail.bind(this);
    }
}
module.exports.MsgClientImpl = $fa66b9c7f8f34137$var$MsgClientImpl;
module.exports.MsgDesc = {
    serviceName: "cosmos.slashing.v1beta1.Msg"
};
module.exports.MsgUnjailDesc = {
    methodName: "Unjail",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgUnjail.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgUnjailResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
class $fa66b9c7f8f34137$var$GrpcWebImpl {
    unary(methodDesc, _request, metadata) {
        var _a;
        const request = Object.assign(Object.assign({}, _request), methodDesc.requestType);
        const maybeCombinedMetadata = metadata && this.options.metadata ? new $1pqjL.BrowserHeaders(Object.assign(Object.assign({}, (_a = this.options) === null || _a === void 0 ? void 0 : _a.metadata.headersMap), metadata === null || metadata === void 0 ? void 0 : metadata.headersMap)) : metadata || this.options.metadata;
        return new Promise((resolve, reject)=>{
            $jXVni.grpc.unary(methodDesc, {
                request: request,
                host: this.host,
                metadata: maybeCombinedMetadata,
                transport: this.options.transport,
                debug: this.options.debug,
                onEnd: function(response) {
                    if (response.status === $jXVni.grpc.Code.OK) resolve(response.message);
                    else {
                        const err = new Error(response.statusMessage);
                        err.code = response.status;
                        err.metadata = response.trailers;
                        reject(err);
                    }
                }
            });
        });
    }
    constructor(host, options){
        this.host = host;
        this.options = options;
    }
}
module.exports.GrpcWebImpl = $fa66b9c7f8f34137$var$GrpcWebImpl;
if ($fa66b9c7f8f34137$var$minimal_1.default.util.Long !== $fa66b9c7f8f34137$var$long_1.default) {
    $fa66b9c7f8f34137$var$minimal_1.default.util.Long = $fa66b9c7f8f34137$var$long_1.default;
    $fa66b9c7f8f34137$var$minimal_1.default.configure();
}

});



parcelRegister("hg4M8", function(module, exports) {
"use strict";
var $c907a2929da32025$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c907a2929da32025$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c907a2929da32025$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$c907a2929da32025$var$__exportStar((parcelRequire("bmMgR")), module.exports);

$c907a2929da32025$var$__exportStar((parcelRequire("1n8so")), module.exports);

$c907a2929da32025$var$__exportStar((parcelRequire("5TsZK")), module.exports);

$c907a2929da32025$var$__exportStar((parcelRequire("2PDID")), module.exports);

$c907a2929da32025$var$__exportStar((parcelRequire("9rvTx")), module.exports);

});
parcelRegister("bmMgR", function(module, exports) {
"use strict";
var $8467315d1cdcf61f$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgDelegate = void 0;

var $7yVzo = parcelRequire("7yVzo");

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $84C3k = parcelRequire("84C3k");
/**
 * A delegator can submit this message to send more Luna to be staked through a
 * validator delegate.
 */ var $8467315d1cdcf61f$var$MsgDelegate = /** @class */ function(_super) {
    $8467315d1cdcf61f$var$__extends(MsgDelegate, _super);
    /**
     *
     * @param delegator_address delegator's account address
     * @param validator_address validator's operator address
     * @param amount amount of LUNA to be sent for delegation
     */ function MsgDelegate(delegator_address, validator_address, amount) {
        var _this = _super.call(this) || this;
        _this.delegator_address = delegator_address;
        _this.validator_address = validator_address;
        _this.amount = amount;
        return _this;
    }
    MsgDelegate.fromAmino = function(data, _) {
        _;
        var _a = data.value, delegator_address = _a.delegator_address, validator_address = _a.validator_address, amount = _a.amount;
        return new MsgDelegate(delegator_address, validator_address, $7yVzo.Coin.fromAmino(amount));
    };
    MsgDelegate.prototype.toAmino = function(isClassic) {
        var _a = this, delegator_address = _a.delegator_address, validator_address = _a.validator_address, amount = _a.amount;
        return {
            type: isClassic ? "staking/MsgDelegate" : "cosmos-sdk/MsgDelegate",
            value: {
                delegator_address: delegator_address,
                validator_address: validator_address,
                amount: amount.toAmino()
            }
        };
    };
    MsgDelegate.fromProto = function(proto, _) {
        _;
        return new MsgDelegate(proto.delegatorAddress, proto.validatorAddress, $7yVzo.Coin.fromProto(proto.amount));
    };
    MsgDelegate.prototype.toProto = function(_) {
        _;
        var _a = this, delegator_address = _a.delegator_address, validator_address = _a.validator_address, amount = _a.amount;
        return $84C3k.MsgDelegate.fromPartial({
            amount: amount.toProto(),
            delegatorAddress: delegator_address,
            validatorAddress: validator_address
        });
    };
    MsgDelegate.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmos.staking.v1beta1.MsgDelegate",
            value: $84C3k.MsgDelegate.encode(this.toProto(isClassic)).finish()
        });
    };
    MsgDelegate.unpackAny = function(msgAny, isClassic) {
        return MsgDelegate.fromProto($84C3k.MsgDelegate.decode(msgAny.value), isClassic);
    };
    MsgDelegate.fromData = function(data, _) {
        _;
        var delegator_address = data.delegator_address, validator_address = data.validator_address, amount = data.amount;
        return new MsgDelegate(delegator_address, validator_address, $7yVzo.Coin.fromData(amount));
    };
    MsgDelegate.prototype.toData = function(_) {
        _;
        var _a = this, delegator_address = _a.delegator_address, validator_address = _a.validator_address, amount = _a.amount;
        return {
            "@type": "/cosmos.staking.v1beta1.MsgDelegate",
            delegator_address: delegator_address,
            validator_address: validator_address,
            amount: amount.toData()
        };
    };
    return MsgDelegate;
}($26Eqx.JSONSerializable);
module.exports.MsgDelegate = $8467315d1cdcf61f$var$MsgDelegate;

});
parcelRegister("84C3k", function(module, exports) {
"use strict";
var $5e0c36e67d5253a3$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GrpcWebImpl = module.exports.MsgUndelegateDesc = module.exports.MsgBeginRedelegateDesc = module.exports.MsgDelegateDesc = module.exports.MsgEditValidatorDesc = module.exports.MsgCreateValidatorDesc = module.exports.MsgDesc = module.exports.MsgClientImpl = module.exports.MsgUndelegateResponse = module.exports.MsgUndelegate = module.exports.MsgBeginRedelegateResponse = module.exports.MsgBeginRedelegate = module.exports.MsgDelegateResponse = module.exports.MsgDelegate = module.exports.MsgEditValidatorResponse = module.exports.MsgEditValidator = module.exports.MsgCreateValidatorResponse = module.exports.MsgCreateValidator = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $5e0c36e67d5253a3$var$long_1 = $5e0c36e67d5253a3$var$__importDefault((parcelRequire("9A55m")));

var $jXVni = parcelRequire("jXVni");

const $5e0c36e67d5253a3$var$minimal_1 = $5e0c36e67d5253a3$var$__importDefault((parcelRequire("i2pIU")));

var $dbzoH = parcelRequire("dbzoH");

var $c5FxR = parcelRequire("c5FxR");

var $lPVUQ = parcelRequire("lPVUQ");

var $1pqjL = parcelRequire("1pqjL");

var $5G2s6 = parcelRequire("5G2s6");
module.exports.protobufPackage = "cosmos.staking.v1beta1";
const $5e0c36e67d5253a3$var$baseMsgCreateValidator = {
    minSelfDelegation: "",
    delegatorAddress: "",
    validatorAddress: ""
};
module.exports.MsgCreateValidator = {
    encode (message, writer = $5e0c36e67d5253a3$var$minimal_1.default.Writer.create()) {
        if (message.description !== undefined) $dbzoH.Description.encode(message.description, writer.uint32(10).fork()).ldelim();
        if (message.commission !== undefined) $dbzoH.CommissionRates.encode(message.commission, writer.uint32(18).fork()).ldelim();
        if (message.minSelfDelegation !== "") writer.uint32(26).string(message.minSelfDelegation);
        if (message.delegatorAddress !== "") writer.uint32(34).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(42).string(message.validatorAddress);
        if (message.pubkey !== undefined) $c5FxR.Any.encode(message.pubkey, writer.uint32(50).fork()).ldelim();
        if (message.value !== undefined) $lPVUQ.Coin.encode(message.value, writer.uint32(58).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5e0c36e67d5253a3$var$minimal_1.default.Reader ? input : new $5e0c36e67d5253a3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $5e0c36e67d5253a3$var$baseMsgCreateValidator);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.description = $dbzoH.Description.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.commission = $dbzoH.CommissionRates.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.minSelfDelegation = reader.string();
                    break;
                case 4:
                    message.delegatorAddress = reader.string();
                    break;
                case 5:
                    message.validatorAddress = reader.string();
                    break;
                case 6:
                    message.pubkey = $c5FxR.Any.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.value = $lPVUQ.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $5e0c36e67d5253a3$var$baseMsgCreateValidator);
        if (object.description !== undefined && object.description !== null) message.description = $dbzoH.Description.fromJSON(object.description);
        else message.description = undefined;
        if (object.commission !== undefined && object.commission !== null) message.commission = $dbzoH.CommissionRates.fromJSON(object.commission);
        else message.commission = undefined;
        if (object.minSelfDelegation !== undefined && object.minSelfDelegation !== null) message.minSelfDelegation = String(object.minSelfDelegation);
        else message.minSelfDelegation = "";
        if (object.delegatorAddress !== undefined && object.delegatorAddress !== null) message.delegatorAddress = String(object.delegatorAddress);
        else message.delegatorAddress = "";
        if (object.validatorAddress !== undefined && object.validatorAddress !== null) message.validatorAddress = String(object.validatorAddress);
        else message.validatorAddress = "";
        if (object.pubkey !== undefined && object.pubkey !== null) message.pubkey = $c5FxR.Any.fromJSON(object.pubkey);
        else message.pubkey = undefined;
        if (object.value !== undefined && object.value !== null) message.value = $lPVUQ.Coin.fromJSON(object.value);
        else message.value = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.description !== undefined && (obj.description = message.description ? $dbzoH.Description.toJSON(message.description) : undefined);
        message.commission !== undefined && (obj.commission = message.commission ? $dbzoH.CommissionRates.toJSON(message.commission) : undefined);
        message.minSelfDelegation !== undefined && (obj.minSelfDelegation = message.minSelfDelegation);
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.pubkey !== undefined && (obj.pubkey = message.pubkey ? $c5FxR.Any.toJSON(message.pubkey) : undefined);
        message.value !== undefined && (obj.value = message.value ? $lPVUQ.Coin.toJSON(message.value) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $5e0c36e67d5253a3$var$baseMsgCreateValidator);
        if (object.description !== undefined && object.description !== null) message.description = $dbzoH.Description.fromPartial(object.description);
        else message.description = undefined;
        if (object.commission !== undefined && object.commission !== null) message.commission = $dbzoH.CommissionRates.fromPartial(object.commission);
        else message.commission = undefined;
        if (object.minSelfDelegation !== undefined && object.minSelfDelegation !== null) message.minSelfDelegation = object.minSelfDelegation;
        else message.minSelfDelegation = "";
        if (object.delegatorAddress !== undefined && object.delegatorAddress !== null) message.delegatorAddress = object.delegatorAddress;
        else message.delegatorAddress = "";
        if (object.validatorAddress !== undefined && object.validatorAddress !== null) message.validatorAddress = object.validatorAddress;
        else message.validatorAddress = "";
        if (object.pubkey !== undefined && object.pubkey !== null) message.pubkey = $c5FxR.Any.fromPartial(object.pubkey);
        else message.pubkey = undefined;
        if (object.value !== undefined && object.value !== null) message.value = $lPVUQ.Coin.fromPartial(object.value);
        else message.value = undefined;
        return message;
    }
};
const $5e0c36e67d5253a3$var$baseMsgCreateValidatorResponse = {};
module.exports.MsgCreateValidatorResponse = {
    encode (_, writer = $5e0c36e67d5253a3$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5e0c36e67d5253a3$var$minimal_1.default.Reader ? input : new $5e0c36e67d5253a3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $5e0c36e67d5253a3$var$baseMsgCreateValidatorResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $5e0c36e67d5253a3$var$baseMsgCreateValidatorResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $5e0c36e67d5253a3$var$baseMsgCreateValidatorResponse);
        return message;
    }
};
const $5e0c36e67d5253a3$var$baseMsgEditValidator = {
    validatorAddress: "",
    commissionRate: "",
    minSelfDelegation: ""
};
module.exports.MsgEditValidator = {
    encode (message, writer = $5e0c36e67d5253a3$var$minimal_1.default.Writer.create()) {
        if (message.description !== undefined) $dbzoH.Description.encode(message.description, writer.uint32(10).fork()).ldelim();
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        if (message.commissionRate !== "") writer.uint32(26).string(message.commissionRate);
        if (message.minSelfDelegation !== "") writer.uint32(34).string(message.minSelfDelegation);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5e0c36e67d5253a3$var$minimal_1.default.Reader ? input : new $5e0c36e67d5253a3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $5e0c36e67d5253a3$var$baseMsgEditValidator);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.description = $dbzoH.Description.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.commissionRate = reader.string();
                    break;
                case 4:
                    message.minSelfDelegation = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $5e0c36e67d5253a3$var$baseMsgEditValidator);
        if (object.description !== undefined && object.description !== null) message.description = $dbzoH.Description.fromJSON(object.description);
        else message.description = undefined;
        if (object.validatorAddress !== undefined && object.validatorAddress !== null) message.validatorAddress = String(object.validatorAddress);
        else message.validatorAddress = "";
        if (object.commissionRate !== undefined && object.commissionRate !== null) message.commissionRate = String(object.commissionRate);
        else message.commissionRate = "";
        if (object.minSelfDelegation !== undefined && object.minSelfDelegation !== null) message.minSelfDelegation = String(object.minSelfDelegation);
        else message.minSelfDelegation = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.description !== undefined && (obj.description = message.description ? $dbzoH.Description.toJSON(message.description) : undefined);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.commissionRate !== undefined && (obj.commissionRate = message.commissionRate);
        message.minSelfDelegation !== undefined && (obj.minSelfDelegation = message.minSelfDelegation);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $5e0c36e67d5253a3$var$baseMsgEditValidator);
        if (object.description !== undefined && object.description !== null) message.description = $dbzoH.Description.fromPartial(object.description);
        else message.description = undefined;
        if (object.validatorAddress !== undefined && object.validatorAddress !== null) message.validatorAddress = object.validatorAddress;
        else message.validatorAddress = "";
        if (object.commissionRate !== undefined && object.commissionRate !== null) message.commissionRate = object.commissionRate;
        else message.commissionRate = "";
        if (object.minSelfDelegation !== undefined && object.minSelfDelegation !== null) message.minSelfDelegation = object.minSelfDelegation;
        else message.minSelfDelegation = "";
        return message;
    }
};
const $5e0c36e67d5253a3$var$baseMsgEditValidatorResponse = {};
module.exports.MsgEditValidatorResponse = {
    encode (_, writer = $5e0c36e67d5253a3$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5e0c36e67d5253a3$var$minimal_1.default.Reader ? input : new $5e0c36e67d5253a3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $5e0c36e67d5253a3$var$baseMsgEditValidatorResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $5e0c36e67d5253a3$var$baseMsgEditValidatorResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $5e0c36e67d5253a3$var$baseMsgEditValidatorResponse);
        return message;
    }
};
const $5e0c36e67d5253a3$var$baseMsgDelegate = {
    delegatorAddress: "",
    validatorAddress: ""
};
module.exports.MsgDelegate = {
    encode (message, writer = $5e0c36e67d5253a3$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        if (message.amount !== undefined) $lPVUQ.Coin.encode(message.amount, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5e0c36e67d5253a3$var$minimal_1.default.Reader ? input : new $5e0c36e67d5253a3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $5e0c36e67d5253a3$var$baseMsgDelegate);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.amount = $lPVUQ.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $5e0c36e67d5253a3$var$baseMsgDelegate);
        if (object.delegatorAddress !== undefined && object.delegatorAddress !== null) message.delegatorAddress = String(object.delegatorAddress);
        else message.delegatorAddress = "";
        if (object.validatorAddress !== undefined && object.validatorAddress !== null) message.validatorAddress = String(object.validatorAddress);
        else message.validatorAddress = "";
        if (object.amount !== undefined && object.amount !== null) message.amount = $lPVUQ.Coin.fromJSON(object.amount);
        else message.amount = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.amount !== undefined && (obj.amount = message.amount ? $lPVUQ.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $5e0c36e67d5253a3$var$baseMsgDelegate);
        if (object.delegatorAddress !== undefined && object.delegatorAddress !== null) message.delegatorAddress = object.delegatorAddress;
        else message.delegatorAddress = "";
        if (object.validatorAddress !== undefined && object.validatorAddress !== null) message.validatorAddress = object.validatorAddress;
        else message.validatorAddress = "";
        if (object.amount !== undefined && object.amount !== null) message.amount = $lPVUQ.Coin.fromPartial(object.amount);
        else message.amount = undefined;
        return message;
    }
};
const $5e0c36e67d5253a3$var$baseMsgDelegateResponse = {};
module.exports.MsgDelegateResponse = {
    encode (_, writer = $5e0c36e67d5253a3$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5e0c36e67d5253a3$var$minimal_1.default.Reader ? input : new $5e0c36e67d5253a3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $5e0c36e67d5253a3$var$baseMsgDelegateResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $5e0c36e67d5253a3$var$baseMsgDelegateResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $5e0c36e67d5253a3$var$baseMsgDelegateResponse);
        return message;
    }
};
const $5e0c36e67d5253a3$var$baseMsgBeginRedelegate = {
    delegatorAddress: "",
    validatorSrcAddress: "",
    validatorDstAddress: ""
};
module.exports.MsgBeginRedelegate = {
    encode (message, writer = $5e0c36e67d5253a3$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorSrcAddress !== "") writer.uint32(18).string(message.validatorSrcAddress);
        if (message.validatorDstAddress !== "") writer.uint32(26).string(message.validatorDstAddress);
        if (message.amount !== undefined) $lPVUQ.Coin.encode(message.amount, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5e0c36e67d5253a3$var$minimal_1.default.Reader ? input : new $5e0c36e67d5253a3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $5e0c36e67d5253a3$var$baseMsgBeginRedelegate);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorSrcAddress = reader.string();
                    break;
                case 3:
                    message.validatorDstAddress = reader.string();
                    break;
                case 4:
                    message.amount = $lPVUQ.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $5e0c36e67d5253a3$var$baseMsgBeginRedelegate);
        if (object.delegatorAddress !== undefined && object.delegatorAddress !== null) message.delegatorAddress = String(object.delegatorAddress);
        else message.delegatorAddress = "";
        if (object.validatorSrcAddress !== undefined && object.validatorSrcAddress !== null) message.validatorSrcAddress = String(object.validatorSrcAddress);
        else message.validatorSrcAddress = "";
        if (object.validatorDstAddress !== undefined && object.validatorDstAddress !== null) message.validatorDstAddress = String(object.validatorDstAddress);
        else message.validatorDstAddress = "";
        if (object.amount !== undefined && object.amount !== null) message.amount = $lPVUQ.Coin.fromJSON(object.amount);
        else message.amount = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorSrcAddress !== undefined && (obj.validatorSrcAddress = message.validatorSrcAddress);
        message.validatorDstAddress !== undefined && (obj.validatorDstAddress = message.validatorDstAddress);
        message.amount !== undefined && (obj.amount = message.amount ? $lPVUQ.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $5e0c36e67d5253a3$var$baseMsgBeginRedelegate);
        if (object.delegatorAddress !== undefined && object.delegatorAddress !== null) message.delegatorAddress = object.delegatorAddress;
        else message.delegatorAddress = "";
        if (object.validatorSrcAddress !== undefined && object.validatorSrcAddress !== null) message.validatorSrcAddress = object.validatorSrcAddress;
        else message.validatorSrcAddress = "";
        if (object.validatorDstAddress !== undefined && object.validatorDstAddress !== null) message.validatorDstAddress = object.validatorDstAddress;
        else message.validatorDstAddress = "";
        if (object.amount !== undefined && object.amount !== null) message.amount = $lPVUQ.Coin.fromPartial(object.amount);
        else message.amount = undefined;
        return message;
    }
};
const $5e0c36e67d5253a3$var$baseMsgBeginRedelegateResponse = {};
module.exports.MsgBeginRedelegateResponse = {
    encode (message, writer = $5e0c36e67d5253a3$var$minimal_1.default.Writer.create()) {
        if (message.completionTime !== undefined) $5G2s6.Timestamp.encode($5e0c36e67d5253a3$var$toTimestamp(message.completionTime), writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5e0c36e67d5253a3$var$minimal_1.default.Reader ? input : new $5e0c36e67d5253a3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $5e0c36e67d5253a3$var$baseMsgBeginRedelegateResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.completionTime = $5e0c36e67d5253a3$var$fromTimestamp($5G2s6.Timestamp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $5e0c36e67d5253a3$var$baseMsgBeginRedelegateResponse);
        if (object.completionTime !== undefined && object.completionTime !== null) message.completionTime = $5e0c36e67d5253a3$var$fromJsonTimestamp(object.completionTime);
        else message.completionTime = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.completionTime !== undefined && (obj.completionTime = message.completionTime.toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $5e0c36e67d5253a3$var$baseMsgBeginRedelegateResponse);
        if (object.completionTime !== undefined && object.completionTime !== null) message.completionTime = object.completionTime;
        else message.completionTime = undefined;
        return message;
    }
};
const $5e0c36e67d5253a3$var$baseMsgUndelegate = {
    delegatorAddress: "",
    validatorAddress: ""
};
module.exports.MsgUndelegate = {
    encode (message, writer = $5e0c36e67d5253a3$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        if (message.amount !== undefined) $lPVUQ.Coin.encode(message.amount, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5e0c36e67d5253a3$var$minimal_1.default.Reader ? input : new $5e0c36e67d5253a3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $5e0c36e67d5253a3$var$baseMsgUndelegate);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.amount = $lPVUQ.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $5e0c36e67d5253a3$var$baseMsgUndelegate);
        if (object.delegatorAddress !== undefined && object.delegatorAddress !== null) message.delegatorAddress = String(object.delegatorAddress);
        else message.delegatorAddress = "";
        if (object.validatorAddress !== undefined && object.validatorAddress !== null) message.validatorAddress = String(object.validatorAddress);
        else message.validatorAddress = "";
        if (object.amount !== undefined && object.amount !== null) message.amount = $lPVUQ.Coin.fromJSON(object.amount);
        else message.amount = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.amount !== undefined && (obj.amount = message.amount ? $lPVUQ.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $5e0c36e67d5253a3$var$baseMsgUndelegate);
        if (object.delegatorAddress !== undefined && object.delegatorAddress !== null) message.delegatorAddress = object.delegatorAddress;
        else message.delegatorAddress = "";
        if (object.validatorAddress !== undefined && object.validatorAddress !== null) message.validatorAddress = object.validatorAddress;
        else message.validatorAddress = "";
        if (object.amount !== undefined && object.amount !== null) message.amount = $lPVUQ.Coin.fromPartial(object.amount);
        else message.amount = undefined;
        return message;
    }
};
const $5e0c36e67d5253a3$var$baseMsgUndelegateResponse = {};
module.exports.MsgUndelegateResponse = {
    encode (message, writer = $5e0c36e67d5253a3$var$minimal_1.default.Writer.create()) {
        if (message.completionTime !== undefined) $5G2s6.Timestamp.encode($5e0c36e67d5253a3$var$toTimestamp(message.completionTime), writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5e0c36e67d5253a3$var$minimal_1.default.Reader ? input : new $5e0c36e67d5253a3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $5e0c36e67d5253a3$var$baseMsgUndelegateResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.completionTime = $5e0c36e67d5253a3$var$fromTimestamp($5G2s6.Timestamp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $5e0c36e67d5253a3$var$baseMsgUndelegateResponse);
        if (object.completionTime !== undefined && object.completionTime !== null) message.completionTime = $5e0c36e67d5253a3$var$fromJsonTimestamp(object.completionTime);
        else message.completionTime = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.completionTime !== undefined && (obj.completionTime = message.completionTime.toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $5e0c36e67d5253a3$var$baseMsgUndelegateResponse);
        if (object.completionTime !== undefined && object.completionTime !== null) message.completionTime = object.completionTime;
        else message.completionTime = undefined;
        return message;
    }
};
class $5e0c36e67d5253a3$var$MsgClientImpl {
    CreateValidator(request, metadata) {
        return this.rpc.unary(module.exports.MsgCreateValidatorDesc, module.exports.MsgCreateValidator.fromPartial(request), metadata);
    }
    EditValidator(request, metadata) {
        return this.rpc.unary(module.exports.MsgEditValidatorDesc, module.exports.MsgEditValidator.fromPartial(request), metadata);
    }
    Delegate(request, metadata) {
        return this.rpc.unary(module.exports.MsgDelegateDesc, module.exports.MsgDelegate.fromPartial(request), metadata);
    }
    BeginRedelegate(request, metadata) {
        return this.rpc.unary(module.exports.MsgBeginRedelegateDesc, module.exports.MsgBeginRedelegate.fromPartial(request), metadata);
    }
    Undelegate(request, metadata) {
        return this.rpc.unary(module.exports.MsgUndelegateDesc, module.exports.MsgUndelegate.fromPartial(request), metadata);
    }
    constructor(rpc){
        this.rpc = rpc;
        this.CreateValidator = this.CreateValidator.bind(this);
        this.EditValidator = this.EditValidator.bind(this);
        this.Delegate = this.Delegate.bind(this);
        this.BeginRedelegate = this.BeginRedelegate.bind(this);
        this.Undelegate = this.Undelegate.bind(this);
    }
}
module.exports.MsgClientImpl = $5e0c36e67d5253a3$var$MsgClientImpl;
module.exports.MsgDesc = {
    serviceName: "cosmos.staking.v1beta1.Msg"
};
module.exports.MsgCreateValidatorDesc = {
    methodName: "CreateValidator",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgCreateValidator.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgCreateValidatorResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.MsgEditValidatorDesc = {
    methodName: "EditValidator",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgEditValidator.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgEditValidatorResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.MsgDelegateDesc = {
    methodName: "Delegate",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgDelegate.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgDelegateResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.MsgBeginRedelegateDesc = {
    methodName: "BeginRedelegate",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgBeginRedelegate.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgBeginRedelegateResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.MsgUndelegateDesc = {
    methodName: "Undelegate",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgUndelegate.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgUndelegateResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
class $5e0c36e67d5253a3$var$GrpcWebImpl {
    unary(methodDesc, _request, metadata) {
        var _a;
        const request = Object.assign(Object.assign({}, _request), methodDesc.requestType);
        const maybeCombinedMetadata = metadata && this.options.metadata ? new $1pqjL.BrowserHeaders(Object.assign(Object.assign({}, (_a = this.options) === null || _a === void 0 ? void 0 : _a.metadata.headersMap), metadata === null || metadata === void 0 ? void 0 : metadata.headersMap)) : metadata || this.options.metadata;
        return new Promise((resolve, reject)=>{
            $jXVni.grpc.unary(methodDesc, {
                request: request,
                host: this.host,
                metadata: maybeCombinedMetadata,
                transport: this.options.transport,
                debug: this.options.debug,
                onEnd: function(response) {
                    if (response.status === $jXVni.grpc.Code.OK) resolve(response.message);
                    else {
                        const err = new Error(response.statusMessage);
                        err.code = response.status;
                        err.metadata = response.trailers;
                        reject(err);
                    }
                }
            });
        });
    }
    constructor(host, options){
        this.host = host;
        this.options = options;
    }
}
module.exports.GrpcWebImpl = $5e0c36e67d5253a3$var$GrpcWebImpl;
function $5e0c36e67d5253a3$var$toTimestamp(date) {
    const seconds = $5e0c36e67d5253a3$var$numberToLong(date.getTime() / 1000);
    const nanos = date.getTime() % 1000 * 1000000;
    return {
        seconds: seconds,
        nanos: nanos
    };
}
function $5e0c36e67d5253a3$var$fromTimestamp(t) {
    let millis = t.seconds.toNumber() * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function $5e0c36e67d5253a3$var$fromJsonTimestamp(o) {
    if (o instanceof Date) return o;
    else if (typeof o === "string") return new Date(o);
    else return $5e0c36e67d5253a3$var$fromTimestamp($5G2s6.Timestamp.fromJSON(o));
}
function $5e0c36e67d5253a3$var$numberToLong(number) {
    return $5e0c36e67d5253a3$var$long_1.default.fromNumber(number);
}
if ($5e0c36e67d5253a3$var$minimal_1.default.util.Long !== $5e0c36e67d5253a3$var$long_1.default) {
    $5e0c36e67d5253a3$var$minimal_1.default.util.Long = $5e0c36e67d5253a3$var$long_1.default;
    $5e0c36e67d5253a3$var$minimal_1.default.configure();
}

});
parcelRegister("dbzoH", function(module, exports) {
"use strict";
var $9997c29ea4520387$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Pool = module.exports.RedelegationResponse = module.exports.RedelegationEntryResponse = module.exports.DelegationResponse = module.exports.Params = module.exports.Redelegation = module.exports.RedelegationEntry = module.exports.UnbondingDelegationEntry = module.exports.UnbondingDelegation = module.exports.Delegation = module.exports.DVVTriplets = module.exports.DVVTriplet = module.exports.DVPairs = module.exports.DVPair = module.exports.ValAddresses = module.exports.Validator = module.exports.Description = module.exports.Commission = module.exports.CommissionRates = module.exports.HistoricalInfo = module.exports.bondStatusToJSON = module.exports.bondStatusFromJSON = module.exports.BondStatus = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $9997c29ea4520387$var$long_1 = $9997c29ea4520387$var$__importDefault((parcelRequire("9A55m")));

const $9997c29ea4520387$var$minimal_1 = $9997c29ea4520387$var$__importDefault((parcelRequire("i2pIU")));

var $djDW6 = parcelRequire("djDW6");

var $c5FxR = parcelRequire("c5FxR");

var $dmomH = parcelRequire("dmomH");

var $lPVUQ = parcelRequire("lPVUQ");

var $5G2s6 = parcelRequire("5G2s6");
module.exports.protobufPackage = "cosmos.staking.v1beta1";
/** BondStatus is the status of a validator. */ var $9997c29ea4520387$var$BondStatus;
(function(BondStatus) {
    /** BOND_STATUS_UNSPECIFIED - UNSPECIFIED defines an invalid validator status. */ BondStatus[BondStatus["BOND_STATUS_UNSPECIFIED"] = 0] = "BOND_STATUS_UNSPECIFIED";
    /** BOND_STATUS_UNBONDED - UNBONDED defines a validator that is not bonded. */ BondStatus[BondStatus["BOND_STATUS_UNBONDED"] = 1] = "BOND_STATUS_UNBONDED";
    /** BOND_STATUS_UNBONDING - UNBONDING defines a validator that is unbonding. */ BondStatus[BondStatus["BOND_STATUS_UNBONDING"] = 2] = "BOND_STATUS_UNBONDING";
    /** BOND_STATUS_BONDED - BONDED defines a validator that is bonded. */ BondStatus[BondStatus["BOND_STATUS_BONDED"] = 3] = "BOND_STATUS_BONDED";
    BondStatus[BondStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($9997c29ea4520387$var$BondStatus = module.exports.BondStatus || (module.exports.BondStatus = {}));
function $9997c29ea4520387$var$bondStatusFromJSON(object) {
    switch(object){
        case 0:
        case "BOND_STATUS_UNSPECIFIED":
            return $9997c29ea4520387$var$BondStatus.BOND_STATUS_UNSPECIFIED;
        case 1:
        case "BOND_STATUS_UNBONDED":
            return $9997c29ea4520387$var$BondStatus.BOND_STATUS_UNBONDED;
        case 2:
        case "BOND_STATUS_UNBONDING":
            return $9997c29ea4520387$var$BondStatus.BOND_STATUS_UNBONDING;
        case 3:
        case "BOND_STATUS_BONDED":
            return $9997c29ea4520387$var$BondStatus.BOND_STATUS_BONDED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $9997c29ea4520387$var$BondStatus.UNRECOGNIZED;
    }
}
module.exports.bondStatusFromJSON = $9997c29ea4520387$var$bondStatusFromJSON;
function $9997c29ea4520387$var$bondStatusToJSON(object) {
    switch(object){
        case $9997c29ea4520387$var$BondStatus.BOND_STATUS_UNSPECIFIED:
            return "BOND_STATUS_UNSPECIFIED";
        case $9997c29ea4520387$var$BondStatus.BOND_STATUS_UNBONDED:
            return "BOND_STATUS_UNBONDED";
        case $9997c29ea4520387$var$BondStatus.BOND_STATUS_UNBONDING:
            return "BOND_STATUS_UNBONDING";
        case $9997c29ea4520387$var$BondStatus.BOND_STATUS_BONDED:
            return "BOND_STATUS_BONDED";
        default:
            return "UNKNOWN";
    }
}
module.exports.bondStatusToJSON = $9997c29ea4520387$var$bondStatusToJSON;
const $9997c29ea4520387$var$baseHistoricalInfo = {};
module.exports.HistoricalInfo = {
    encode (message, writer = $9997c29ea4520387$var$minimal_1.default.Writer.create()) {
        if (message.header !== undefined) $djDW6.Header.encode(message.header, writer.uint32(10).fork()).ldelim();
        for (const v of message.valset)module.exports.Validator.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9997c29ea4520387$var$minimal_1.default.Reader ? input : new $9997c29ea4520387$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9997c29ea4520387$var$baseHistoricalInfo);
        message.valset = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.header = $djDW6.Header.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.valset.push(module.exports.Validator.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9997c29ea4520387$var$baseHistoricalInfo);
        message.valset = [];
        if (object.header !== undefined && object.header !== null) message.header = $djDW6.Header.fromJSON(object.header);
        else message.header = undefined;
        if (object.valset !== undefined && object.valset !== null) for (const e of object.valset)message.valset.push(module.exports.Validator.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.header !== undefined && (obj.header = message.header ? $djDW6.Header.toJSON(message.header) : undefined);
        if (message.valset) obj.valset = message.valset.map((e)=>e ? module.exports.Validator.toJSON(e) : undefined);
        else obj.valset = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9997c29ea4520387$var$baseHistoricalInfo);
        message.valset = [];
        if (object.header !== undefined && object.header !== null) message.header = $djDW6.Header.fromPartial(object.header);
        else message.header = undefined;
        if (object.valset !== undefined && object.valset !== null) for (const e of object.valset)message.valset.push(module.exports.Validator.fromPartial(e));
        return message;
    }
};
const $9997c29ea4520387$var$baseCommissionRates = {
    rate: "",
    maxRate: "",
    maxChangeRate: ""
};
module.exports.CommissionRates = {
    encode (message, writer = $9997c29ea4520387$var$minimal_1.default.Writer.create()) {
        if (message.rate !== "") writer.uint32(10).string(message.rate);
        if (message.maxRate !== "") writer.uint32(18).string(message.maxRate);
        if (message.maxChangeRate !== "") writer.uint32(26).string(message.maxChangeRate);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9997c29ea4520387$var$minimal_1.default.Reader ? input : new $9997c29ea4520387$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9997c29ea4520387$var$baseCommissionRates);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.rate = reader.string();
                    break;
                case 2:
                    message.maxRate = reader.string();
                    break;
                case 3:
                    message.maxChangeRate = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9997c29ea4520387$var$baseCommissionRates);
        if (object.rate !== undefined && object.rate !== null) message.rate = String(object.rate);
        else message.rate = "";
        if (object.maxRate !== undefined && object.maxRate !== null) message.maxRate = String(object.maxRate);
        else message.maxRate = "";
        if (object.maxChangeRate !== undefined && object.maxChangeRate !== null) message.maxChangeRate = String(object.maxChangeRate);
        else message.maxChangeRate = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.rate !== undefined && (obj.rate = message.rate);
        message.maxRate !== undefined && (obj.maxRate = message.maxRate);
        message.maxChangeRate !== undefined && (obj.maxChangeRate = message.maxChangeRate);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9997c29ea4520387$var$baseCommissionRates);
        if (object.rate !== undefined && object.rate !== null) message.rate = object.rate;
        else message.rate = "";
        if (object.maxRate !== undefined && object.maxRate !== null) message.maxRate = object.maxRate;
        else message.maxRate = "";
        if (object.maxChangeRate !== undefined && object.maxChangeRate !== null) message.maxChangeRate = object.maxChangeRate;
        else message.maxChangeRate = "";
        return message;
    }
};
const $9997c29ea4520387$var$baseCommission = {};
module.exports.Commission = {
    encode (message, writer = $9997c29ea4520387$var$minimal_1.default.Writer.create()) {
        if (message.commissionRates !== undefined) module.exports.CommissionRates.encode(message.commissionRates, writer.uint32(10).fork()).ldelim();
        if (message.updateTime !== undefined) $5G2s6.Timestamp.encode($9997c29ea4520387$var$toTimestamp(message.updateTime), writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9997c29ea4520387$var$minimal_1.default.Reader ? input : new $9997c29ea4520387$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9997c29ea4520387$var$baseCommission);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.commissionRates = module.exports.CommissionRates.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.updateTime = $9997c29ea4520387$var$fromTimestamp($5G2s6.Timestamp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9997c29ea4520387$var$baseCommission);
        if (object.commissionRates !== undefined && object.commissionRates !== null) message.commissionRates = module.exports.CommissionRates.fromJSON(object.commissionRates);
        else message.commissionRates = undefined;
        if (object.updateTime !== undefined && object.updateTime !== null) message.updateTime = $9997c29ea4520387$var$fromJsonTimestamp(object.updateTime);
        else message.updateTime = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.commissionRates !== undefined && (obj.commissionRates = message.commissionRates ? module.exports.CommissionRates.toJSON(message.commissionRates) : undefined);
        message.updateTime !== undefined && (obj.updateTime = message.updateTime.toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9997c29ea4520387$var$baseCommission);
        if (object.commissionRates !== undefined && object.commissionRates !== null) message.commissionRates = module.exports.CommissionRates.fromPartial(object.commissionRates);
        else message.commissionRates = undefined;
        if (object.updateTime !== undefined && object.updateTime !== null) message.updateTime = object.updateTime;
        else message.updateTime = undefined;
        return message;
    }
};
const $9997c29ea4520387$var$baseDescription = {
    moniker: "",
    identity: "",
    website: "",
    securityContact: "",
    details: ""
};
module.exports.Description = {
    encode (message, writer = $9997c29ea4520387$var$minimal_1.default.Writer.create()) {
        if (message.moniker !== "") writer.uint32(10).string(message.moniker);
        if (message.identity !== "") writer.uint32(18).string(message.identity);
        if (message.website !== "") writer.uint32(26).string(message.website);
        if (message.securityContact !== "") writer.uint32(34).string(message.securityContact);
        if (message.details !== "") writer.uint32(42).string(message.details);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9997c29ea4520387$var$minimal_1.default.Reader ? input : new $9997c29ea4520387$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9997c29ea4520387$var$baseDescription);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.moniker = reader.string();
                    break;
                case 2:
                    message.identity = reader.string();
                    break;
                case 3:
                    message.website = reader.string();
                    break;
                case 4:
                    message.securityContact = reader.string();
                    break;
                case 5:
                    message.details = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9997c29ea4520387$var$baseDescription);
        if (object.moniker !== undefined && object.moniker !== null) message.moniker = String(object.moniker);
        else message.moniker = "";
        if (object.identity !== undefined && object.identity !== null) message.identity = String(object.identity);
        else message.identity = "";
        if (object.website !== undefined && object.website !== null) message.website = String(object.website);
        else message.website = "";
        if (object.securityContact !== undefined && object.securityContact !== null) message.securityContact = String(object.securityContact);
        else message.securityContact = "";
        if (object.details !== undefined && object.details !== null) message.details = String(object.details);
        else message.details = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.moniker !== undefined && (obj.moniker = message.moniker);
        message.identity !== undefined && (obj.identity = message.identity);
        message.website !== undefined && (obj.website = message.website);
        message.securityContact !== undefined && (obj.securityContact = message.securityContact);
        message.details !== undefined && (obj.details = message.details);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9997c29ea4520387$var$baseDescription);
        if (object.moniker !== undefined && object.moniker !== null) message.moniker = object.moniker;
        else message.moniker = "";
        if (object.identity !== undefined && object.identity !== null) message.identity = object.identity;
        else message.identity = "";
        if (object.website !== undefined && object.website !== null) message.website = object.website;
        else message.website = "";
        if (object.securityContact !== undefined && object.securityContact !== null) message.securityContact = object.securityContact;
        else message.securityContact = "";
        if (object.details !== undefined && object.details !== null) message.details = object.details;
        else message.details = "";
        return message;
    }
};
const $9997c29ea4520387$var$baseValidator = {
    operatorAddress: "",
    jailed: false,
    status: 0,
    tokens: "",
    delegatorShares: "",
    unbondingHeight: $9997c29ea4520387$var$long_1.default.ZERO,
    minSelfDelegation: ""
};
module.exports.Validator = {
    encode (message, writer = $9997c29ea4520387$var$minimal_1.default.Writer.create()) {
        if (message.operatorAddress !== "") writer.uint32(10).string(message.operatorAddress);
        if (message.consensusPubkey !== undefined) $c5FxR.Any.encode(message.consensusPubkey, writer.uint32(18).fork()).ldelim();
        if (message.jailed === true) writer.uint32(24).bool(message.jailed);
        if (message.status !== 0) writer.uint32(32).int32(message.status);
        if (message.tokens !== "") writer.uint32(42).string(message.tokens);
        if (message.delegatorShares !== "") writer.uint32(50).string(message.delegatorShares);
        if (message.description !== undefined) module.exports.Description.encode(message.description, writer.uint32(58).fork()).ldelim();
        if (!message.unbondingHeight.isZero()) writer.uint32(64).int64(message.unbondingHeight);
        if (message.unbondingTime !== undefined) $5G2s6.Timestamp.encode($9997c29ea4520387$var$toTimestamp(message.unbondingTime), writer.uint32(74).fork()).ldelim();
        if (message.commission !== undefined) module.exports.Commission.encode(message.commission, writer.uint32(82).fork()).ldelim();
        if (message.minSelfDelegation !== "") writer.uint32(90).string(message.minSelfDelegation);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9997c29ea4520387$var$minimal_1.default.Reader ? input : new $9997c29ea4520387$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9997c29ea4520387$var$baseValidator);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.operatorAddress = reader.string();
                    break;
                case 2:
                    message.consensusPubkey = $c5FxR.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.jailed = reader.bool();
                    break;
                case 4:
                    message.status = reader.int32();
                    break;
                case 5:
                    message.tokens = reader.string();
                    break;
                case 6:
                    message.delegatorShares = reader.string();
                    break;
                case 7:
                    message.description = module.exports.Description.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.unbondingHeight = reader.int64();
                    break;
                case 9:
                    message.unbondingTime = $9997c29ea4520387$var$fromTimestamp($5G2s6.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 10:
                    message.commission = module.exports.Commission.decode(reader, reader.uint32());
                    break;
                case 11:
                    message.minSelfDelegation = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9997c29ea4520387$var$baseValidator);
        if (object.operatorAddress !== undefined && object.operatorAddress !== null) message.operatorAddress = String(object.operatorAddress);
        else message.operatorAddress = "";
        if (object.consensusPubkey !== undefined && object.consensusPubkey !== null) message.consensusPubkey = $c5FxR.Any.fromJSON(object.consensusPubkey);
        else message.consensusPubkey = undefined;
        if (object.jailed !== undefined && object.jailed !== null) message.jailed = Boolean(object.jailed);
        else message.jailed = false;
        if (object.status !== undefined && object.status !== null) message.status = $9997c29ea4520387$var$bondStatusFromJSON(object.status);
        else message.status = 0;
        if (object.tokens !== undefined && object.tokens !== null) message.tokens = String(object.tokens);
        else message.tokens = "";
        if (object.delegatorShares !== undefined && object.delegatorShares !== null) message.delegatorShares = String(object.delegatorShares);
        else message.delegatorShares = "";
        if (object.description !== undefined && object.description !== null) message.description = module.exports.Description.fromJSON(object.description);
        else message.description = undefined;
        if (object.unbondingHeight !== undefined && object.unbondingHeight !== null) message.unbondingHeight = $9997c29ea4520387$var$long_1.default.fromString(object.unbondingHeight);
        else message.unbondingHeight = $9997c29ea4520387$var$long_1.default.ZERO;
        if (object.unbondingTime !== undefined && object.unbondingTime !== null) message.unbondingTime = $9997c29ea4520387$var$fromJsonTimestamp(object.unbondingTime);
        else message.unbondingTime = undefined;
        if (object.commission !== undefined && object.commission !== null) message.commission = module.exports.Commission.fromJSON(object.commission);
        else message.commission = undefined;
        if (object.minSelfDelegation !== undefined && object.minSelfDelegation !== null) message.minSelfDelegation = String(object.minSelfDelegation);
        else message.minSelfDelegation = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.operatorAddress !== undefined && (obj.operatorAddress = message.operatorAddress);
        message.consensusPubkey !== undefined && (obj.consensusPubkey = message.consensusPubkey ? $c5FxR.Any.toJSON(message.consensusPubkey) : undefined);
        message.jailed !== undefined && (obj.jailed = message.jailed);
        message.status !== undefined && (obj.status = $9997c29ea4520387$var$bondStatusToJSON(message.status));
        message.tokens !== undefined && (obj.tokens = message.tokens);
        message.delegatorShares !== undefined && (obj.delegatorShares = message.delegatorShares);
        message.description !== undefined && (obj.description = message.description ? module.exports.Description.toJSON(message.description) : undefined);
        message.unbondingHeight !== undefined && (obj.unbondingHeight = (message.unbondingHeight || $9997c29ea4520387$var$long_1.default.ZERO).toString());
        message.unbondingTime !== undefined && (obj.unbondingTime = message.unbondingTime.toISOString());
        message.commission !== undefined && (obj.commission = message.commission ? module.exports.Commission.toJSON(message.commission) : undefined);
        message.minSelfDelegation !== undefined && (obj.minSelfDelegation = message.minSelfDelegation);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9997c29ea4520387$var$baseValidator);
        if (object.operatorAddress !== undefined && object.operatorAddress !== null) message.operatorAddress = object.operatorAddress;
        else message.operatorAddress = "";
        if (object.consensusPubkey !== undefined && object.consensusPubkey !== null) message.consensusPubkey = $c5FxR.Any.fromPartial(object.consensusPubkey);
        else message.consensusPubkey = undefined;
        if (object.jailed !== undefined && object.jailed !== null) message.jailed = object.jailed;
        else message.jailed = false;
        if (object.status !== undefined && object.status !== null) message.status = object.status;
        else message.status = 0;
        if (object.tokens !== undefined && object.tokens !== null) message.tokens = object.tokens;
        else message.tokens = "";
        if (object.delegatorShares !== undefined && object.delegatorShares !== null) message.delegatorShares = object.delegatorShares;
        else message.delegatorShares = "";
        if (object.description !== undefined && object.description !== null) message.description = module.exports.Description.fromPartial(object.description);
        else message.description = undefined;
        if (object.unbondingHeight !== undefined && object.unbondingHeight !== null) message.unbondingHeight = object.unbondingHeight;
        else message.unbondingHeight = $9997c29ea4520387$var$long_1.default.ZERO;
        if (object.unbondingTime !== undefined && object.unbondingTime !== null) message.unbondingTime = object.unbondingTime;
        else message.unbondingTime = undefined;
        if (object.commission !== undefined && object.commission !== null) message.commission = module.exports.Commission.fromPartial(object.commission);
        else message.commission = undefined;
        if (object.minSelfDelegation !== undefined && object.minSelfDelegation !== null) message.minSelfDelegation = object.minSelfDelegation;
        else message.minSelfDelegation = "";
        return message;
    }
};
const $9997c29ea4520387$var$baseValAddresses = {
    addresses: ""
};
module.exports.ValAddresses = {
    encode (message, writer = $9997c29ea4520387$var$minimal_1.default.Writer.create()) {
        for (const v of message.addresses)writer.uint32(10).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9997c29ea4520387$var$minimal_1.default.Reader ? input : new $9997c29ea4520387$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9997c29ea4520387$var$baseValAddresses);
        message.addresses = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.addresses.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9997c29ea4520387$var$baseValAddresses);
        message.addresses = [];
        if (object.addresses !== undefined && object.addresses !== null) for (const e of object.addresses)message.addresses.push(String(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.addresses) obj.addresses = message.addresses.map((e)=>e);
        else obj.addresses = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9997c29ea4520387$var$baseValAddresses);
        message.addresses = [];
        if (object.addresses !== undefined && object.addresses !== null) for (const e of object.addresses)message.addresses.push(e);
        return message;
    }
};
const $9997c29ea4520387$var$baseDVPair = {
    delegatorAddress: "",
    validatorAddress: ""
};
module.exports.DVPair = {
    encode (message, writer = $9997c29ea4520387$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9997c29ea4520387$var$minimal_1.default.Reader ? input : new $9997c29ea4520387$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9997c29ea4520387$var$baseDVPair);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9997c29ea4520387$var$baseDVPair);
        if (object.delegatorAddress !== undefined && object.delegatorAddress !== null) message.delegatorAddress = String(object.delegatorAddress);
        else message.delegatorAddress = "";
        if (object.validatorAddress !== undefined && object.validatorAddress !== null) message.validatorAddress = String(object.validatorAddress);
        else message.validatorAddress = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9997c29ea4520387$var$baseDVPair);
        if (object.delegatorAddress !== undefined && object.delegatorAddress !== null) message.delegatorAddress = object.delegatorAddress;
        else message.delegatorAddress = "";
        if (object.validatorAddress !== undefined && object.validatorAddress !== null) message.validatorAddress = object.validatorAddress;
        else message.validatorAddress = "";
        return message;
    }
};
const $9997c29ea4520387$var$baseDVPairs = {};
module.exports.DVPairs = {
    encode (message, writer = $9997c29ea4520387$var$minimal_1.default.Writer.create()) {
        for (const v of message.pairs)module.exports.DVPair.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9997c29ea4520387$var$minimal_1.default.Reader ? input : new $9997c29ea4520387$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9997c29ea4520387$var$baseDVPairs);
        message.pairs = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pairs.push(module.exports.DVPair.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9997c29ea4520387$var$baseDVPairs);
        message.pairs = [];
        if (object.pairs !== undefined && object.pairs !== null) for (const e of object.pairs)message.pairs.push(module.exports.DVPair.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.pairs) obj.pairs = message.pairs.map((e)=>e ? module.exports.DVPair.toJSON(e) : undefined);
        else obj.pairs = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9997c29ea4520387$var$baseDVPairs);
        message.pairs = [];
        if (object.pairs !== undefined && object.pairs !== null) for (const e of object.pairs)message.pairs.push(module.exports.DVPair.fromPartial(e));
        return message;
    }
};
const $9997c29ea4520387$var$baseDVVTriplet = {
    delegatorAddress: "",
    validatorSrcAddress: "",
    validatorDstAddress: ""
};
module.exports.DVVTriplet = {
    encode (message, writer = $9997c29ea4520387$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorSrcAddress !== "") writer.uint32(18).string(message.validatorSrcAddress);
        if (message.validatorDstAddress !== "") writer.uint32(26).string(message.validatorDstAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9997c29ea4520387$var$minimal_1.default.Reader ? input : new $9997c29ea4520387$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9997c29ea4520387$var$baseDVVTriplet);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorSrcAddress = reader.string();
                    break;
                case 3:
                    message.validatorDstAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9997c29ea4520387$var$baseDVVTriplet);
        if (object.delegatorAddress !== undefined && object.delegatorAddress !== null) message.delegatorAddress = String(object.delegatorAddress);
        else message.delegatorAddress = "";
        if (object.validatorSrcAddress !== undefined && object.validatorSrcAddress !== null) message.validatorSrcAddress = String(object.validatorSrcAddress);
        else message.validatorSrcAddress = "";
        if (object.validatorDstAddress !== undefined && object.validatorDstAddress !== null) message.validatorDstAddress = String(object.validatorDstAddress);
        else message.validatorDstAddress = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorSrcAddress !== undefined && (obj.validatorSrcAddress = message.validatorSrcAddress);
        message.validatorDstAddress !== undefined && (obj.validatorDstAddress = message.validatorDstAddress);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9997c29ea4520387$var$baseDVVTriplet);
        if (object.delegatorAddress !== undefined && object.delegatorAddress !== null) message.delegatorAddress = object.delegatorAddress;
        else message.delegatorAddress = "";
        if (object.validatorSrcAddress !== undefined && object.validatorSrcAddress !== null) message.validatorSrcAddress = object.validatorSrcAddress;
        else message.validatorSrcAddress = "";
        if (object.validatorDstAddress !== undefined && object.validatorDstAddress !== null) message.validatorDstAddress = object.validatorDstAddress;
        else message.validatorDstAddress = "";
        return message;
    }
};
const $9997c29ea4520387$var$baseDVVTriplets = {};
module.exports.DVVTriplets = {
    encode (message, writer = $9997c29ea4520387$var$minimal_1.default.Writer.create()) {
        for (const v of message.triplets)module.exports.DVVTriplet.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9997c29ea4520387$var$minimal_1.default.Reader ? input : new $9997c29ea4520387$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9997c29ea4520387$var$baseDVVTriplets);
        message.triplets = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.triplets.push(module.exports.DVVTriplet.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9997c29ea4520387$var$baseDVVTriplets);
        message.triplets = [];
        if (object.triplets !== undefined && object.triplets !== null) for (const e of object.triplets)message.triplets.push(module.exports.DVVTriplet.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.triplets) obj.triplets = message.triplets.map((e)=>e ? module.exports.DVVTriplet.toJSON(e) : undefined);
        else obj.triplets = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9997c29ea4520387$var$baseDVVTriplets);
        message.triplets = [];
        if (object.triplets !== undefined && object.triplets !== null) for (const e of object.triplets)message.triplets.push(module.exports.DVVTriplet.fromPartial(e));
        return message;
    }
};
const $9997c29ea4520387$var$baseDelegation = {
    delegatorAddress: "",
    validatorAddress: "",
    shares: ""
};
module.exports.Delegation = {
    encode (message, writer = $9997c29ea4520387$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        if (message.shares !== "") writer.uint32(26).string(message.shares);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9997c29ea4520387$var$minimal_1.default.Reader ? input : new $9997c29ea4520387$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9997c29ea4520387$var$baseDelegation);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.shares = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9997c29ea4520387$var$baseDelegation);
        if (object.delegatorAddress !== undefined && object.delegatorAddress !== null) message.delegatorAddress = String(object.delegatorAddress);
        else message.delegatorAddress = "";
        if (object.validatorAddress !== undefined && object.validatorAddress !== null) message.validatorAddress = String(object.validatorAddress);
        else message.validatorAddress = "";
        if (object.shares !== undefined && object.shares !== null) message.shares = String(object.shares);
        else message.shares = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.shares !== undefined && (obj.shares = message.shares);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9997c29ea4520387$var$baseDelegation);
        if (object.delegatorAddress !== undefined && object.delegatorAddress !== null) message.delegatorAddress = object.delegatorAddress;
        else message.delegatorAddress = "";
        if (object.validatorAddress !== undefined && object.validatorAddress !== null) message.validatorAddress = object.validatorAddress;
        else message.validatorAddress = "";
        if (object.shares !== undefined && object.shares !== null) message.shares = object.shares;
        else message.shares = "";
        return message;
    }
};
const $9997c29ea4520387$var$baseUnbondingDelegation = {
    delegatorAddress: "",
    validatorAddress: ""
};
module.exports.UnbondingDelegation = {
    encode (message, writer = $9997c29ea4520387$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        for (const v of message.entries)module.exports.UnbondingDelegationEntry.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9997c29ea4520387$var$minimal_1.default.Reader ? input : new $9997c29ea4520387$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9997c29ea4520387$var$baseUnbondingDelegation);
        message.entries = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.entries.push(module.exports.UnbondingDelegationEntry.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9997c29ea4520387$var$baseUnbondingDelegation);
        message.entries = [];
        if (object.delegatorAddress !== undefined && object.delegatorAddress !== null) message.delegatorAddress = String(object.delegatorAddress);
        else message.delegatorAddress = "";
        if (object.validatorAddress !== undefined && object.validatorAddress !== null) message.validatorAddress = String(object.validatorAddress);
        else message.validatorAddress = "";
        if (object.entries !== undefined && object.entries !== null) for (const e of object.entries)message.entries.push(module.exports.UnbondingDelegationEntry.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        if (message.entries) obj.entries = message.entries.map((e)=>e ? module.exports.UnbondingDelegationEntry.toJSON(e) : undefined);
        else obj.entries = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9997c29ea4520387$var$baseUnbondingDelegation);
        message.entries = [];
        if (object.delegatorAddress !== undefined && object.delegatorAddress !== null) message.delegatorAddress = object.delegatorAddress;
        else message.delegatorAddress = "";
        if (object.validatorAddress !== undefined && object.validatorAddress !== null) message.validatorAddress = object.validatorAddress;
        else message.validatorAddress = "";
        if (object.entries !== undefined && object.entries !== null) for (const e of object.entries)message.entries.push(module.exports.UnbondingDelegationEntry.fromPartial(e));
        return message;
    }
};
const $9997c29ea4520387$var$baseUnbondingDelegationEntry = {
    creationHeight: $9997c29ea4520387$var$long_1.default.ZERO,
    initialBalance: "",
    balance: ""
};
module.exports.UnbondingDelegationEntry = {
    encode (message, writer = $9997c29ea4520387$var$minimal_1.default.Writer.create()) {
        if (!message.creationHeight.isZero()) writer.uint32(8).int64(message.creationHeight);
        if (message.completionTime !== undefined) $5G2s6.Timestamp.encode($9997c29ea4520387$var$toTimestamp(message.completionTime), writer.uint32(18).fork()).ldelim();
        if (message.initialBalance !== "") writer.uint32(26).string(message.initialBalance);
        if (message.balance !== "") writer.uint32(34).string(message.balance);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9997c29ea4520387$var$minimal_1.default.Reader ? input : new $9997c29ea4520387$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9997c29ea4520387$var$baseUnbondingDelegationEntry);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.creationHeight = reader.int64();
                    break;
                case 2:
                    message.completionTime = $9997c29ea4520387$var$fromTimestamp($5G2s6.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.initialBalance = reader.string();
                    break;
                case 4:
                    message.balance = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9997c29ea4520387$var$baseUnbondingDelegationEntry);
        if (object.creationHeight !== undefined && object.creationHeight !== null) message.creationHeight = $9997c29ea4520387$var$long_1.default.fromString(object.creationHeight);
        else message.creationHeight = $9997c29ea4520387$var$long_1.default.ZERO;
        if (object.completionTime !== undefined && object.completionTime !== null) message.completionTime = $9997c29ea4520387$var$fromJsonTimestamp(object.completionTime);
        else message.completionTime = undefined;
        if (object.initialBalance !== undefined && object.initialBalance !== null) message.initialBalance = String(object.initialBalance);
        else message.initialBalance = "";
        if (object.balance !== undefined && object.balance !== null) message.balance = String(object.balance);
        else message.balance = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.creationHeight !== undefined && (obj.creationHeight = (message.creationHeight || $9997c29ea4520387$var$long_1.default.ZERO).toString());
        message.completionTime !== undefined && (obj.completionTime = message.completionTime.toISOString());
        message.initialBalance !== undefined && (obj.initialBalance = message.initialBalance);
        message.balance !== undefined && (obj.balance = message.balance);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9997c29ea4520387$var$baseUnbondingDelegationEntry);
        if (object.creationHeight !== undefined && object.creationHeight !== null) message.creationHeight = object.creationHeight;
        else message.creationHeight = $9997c29ea4520387$var$long_1.default.ZERO;
        if (object.completionTime !== undefined && object.completionTime !== null) message.completionTime = object.completionTime;
        else message.completionTime = undefined;
        if (object.initialBalance !== undefined && object.initialBalance !== null) message.initialBalance = object.initialBalance;
        else message.initialBalance = "";
        if (object.balance !== undefined && object.balance !== null) message.balance = object.balance;
        else message.balance = "";
        return message;
    }
};
const $9997c29ea4520387$var$baseRedelegationEntry = {
    creationHeight: $9997c29ea4520387$var$long_1.default.ZERO,
    initialBalance: "",
    sharesDst: ""
};
module.exports.RedelegationEntry = {
    encode (message, writer = $9997c29ea4520387$var$minimal_1.default.Writer.create()) {
        if (!message.creationHeight.isZero()) writer.uint32(8).int64(message.creationHeight);
        if (message.completionTime !== undefined) $5G2s6.Timestamp.encode($9997c29ea4520387$var$toTimestamp(message.completionTime), writer.uint32(18).fork()).ldelim();
        if (message.initialBalance !== "") writer.uint32(26).string(message.initialBalance);
        if (message.sharesDst !== "") writer.uint32(34).string(message.sharesDst);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9997c29ea4520387$var$minimal_1.default.Reader ? input : new $9997c29ea4520387$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9997c29ea4520387$var$baseRedelegationEntry);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.creationHeight = reader.int64();
                    break;
                case 2:
                    message.completionTime = $9997c29ea4520387$var$fromTimestamp($5G2s6.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.initialBalance = reader.string();
                    break;
                case 4:
                    message.sharesDst = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9997c29ea4520387$var$baseRedelegationEntry);
        if (object.creationHeight !== undefined && object.creationHeight !== null) message.creationHeight = $9997c29ea4520387$var$long_1.default.fromString(object.creationHeight);
        else message.creationHeight = $9997c29ea4520387$var$long_1.default.ZERO;
        if (object.completionTime !== undefined && object.completionTime !== null) message.completionTime = $9997c29ea4520387$var$fromJsonTimestamp(object.completionTime);
        else message.completionTime = undefined;
        if (object.initialBalance !== undefined && object.initialBalance !== null) message.initialBalance = String(object.initialBalance);
        else message.initialBalance = "";
        if (object.sharesDst !== undefined && object.sharesDst !== null) message.sharesDst = String(object.sharesDst);
        else message.sharesDst = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.creationHeight !== undefined && (obj.creationHeight = (message.creationHeight || $9997c29ea4520387$var$long_1.default.ZERO).toString());
        message.completionTime !== undefined && (obj.completionTime = message.completionTime.toISOString());
        message.initialBalance !== undefined && (obj.initialBalance = message.initialBalance);
        message.sharesDst !== undefined && (obj.sharesDst = message.sharesDst);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9997c29ea4520387$var$baseRedelegationEntry);
        if (object.creationHeight !== undefined && object.creationHeight !== null) message.creationHeight = object.creationHeight;
        else message.creationHeight = $9997c29ea4520387$var$long_1.default.ZERO;
        if (object.completionTime !== undefined && object.completionTime !== null) message.completionTime = object.completionTime;
        else message.completionTime = undefined;
        if (object.initialBalance !== undefined && object.initialBalance !== null) message.initialBalance = object.initialBalance;
        else message.initialBalance = "";
        if (object.sharesDst !== undefined && object.sharesDst !== null) message.sharesDst = object.sharesDst;
        else message.sharesDst = "";
        return message;
    }
};
const $9997c29ea4520387$var$baseRedelegation = {
    delegatorAddress: "",
    validatorSrcAddress: "",
    validatorDstAddress: ""
};
module.exports.Redelegation = {
    encode (message, writer = $9997c29ea4520387$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorSrcAddress !== "") writer.uint32(18).string(message.validatorSrcAddress);
        if (message.validatorDstAddress !== "") writer.uint32(26).string(message.validatorDstAddress);
        for (const v of message.entries)module.exports.RedelegationEntry.encode(v, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9997c29ea4520387$var$minimal_1.default.Reader ? input : new $9997c29ea4520387$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9997c29ea4520387$var$baseRedelegation);
        message.entries = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorSrcAddress = reader.string();
                    break;
                case 3:
                    message.validatorDstAddress = reader.string();
                    break;
                case 4:
                    message.entries.push(module.exports.RedelegationEntry.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9997c29ea4520387$var$baseRedelegation);
        message.entries = [];
        if (object.delegatorAddress !== undefined && object.delegatorAddress !== null) message.delegatorAddress = String(object.delegatorAddress);
        else message.delegatorAddress = "";
        if (object.validatorSrcAddress !== undefined && object.validatorSrcAddress !== null) message.validatorSrcAddress = String(object.validatorSrcAddress);
        else message.validatorSrcAddress = "";
        if (object.validatorDstAddress !== undefined && object.validatorDstAddress !== null) message.validatorDstAddress = String(object.validatorDstAddress);
        else message.validatorDstAddress = "";
        if (object.entries !== undefined && object.entries !== null) for (const e of object.entries)message.entries.push(module.exports.RedelegationEntry.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorSrcAddress !== undefined && (obj.validatorSrcAddress = message.validatorSrcAddress);
        message.validatorDstAddress !== undefined && (obj.validatorDstAddress = message.validatorDstAddress);
        if (message.entries) obj.entries = message.entries.map((e)=>e ? module.exports.RedelegationEntry.toJSON(e) : undefined);
        else obj.entries = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9997c29ea4520387$var$baseRedelegation);
        message.entries = [];
        if (object.delegatorAddress !== undefined && object.delegatorAddress !== null) message.delegatorAddress = object.delegatorAddress;
        else message.delegatorAddress = "";
        if (object.validatorSrcAddress !== undefined && object.validatorSrcAddress !== null) message.validatorSrcAddress = object.validatorSrcAddress;
        else message.validatorSrcAddress = "";
        if (object.validatorDstAddress !== undefined && object.validatorDstAddress !== null) message.validatorDstAddress = object.validatorDstAddress;
        else message.validatorDstAddress = "";
        if (object.entries !== undefined && object.entries !== null) for (const e of object.entries)message.entries.push(module.exports.RedelegationEntry.fromPartial(e));
        return message;
    }
};
const $9997c29ea4520387$var$baseParams = {
    maxValidators: 0,
    maxEntries: 0,
    historicalEntries: 0,
    bondDenom: ""
};
module.exports.Params = {
    encode (message, writer = $9997c29ea4520387$var$minimal_1.default.Writer.create()) {
        if (message.unbondingTime !== undefined) $dmomH.Duration.encode(message.unbondingTime, writer.uint32(10).fork()).ldelim();
        if (message.maxValidators !== 0) writer.uint32(16).uint32(message.maxValidators);
        if (message.maxEntries !== 0) writer.uint32(24).uint32(message.maxEntries);
        if (message.historicalEntries !== 0) writer.uint32(32).uint32(message.historicalEntries);
        if (message.bondDenom !== "") writer.uint32(42).string(message.bondDenom);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9997c29ea4520387$var$minimal_1.default.Reader ? input : new $9997c29ea4520387$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9997c29ea4520387$var$baseParams);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.unbondingTime = $dmomH.Duration.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.maxValidators = reader.uint32();
                    break;
                case 3:
                    message.maxEntries = reader.uint32();
                    break;
                case 4:
                    message.historicalEntries = reader.uint32();
                    break;
                case 5:
                    message.bondDenom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9997c29ea4520387$var$baseParams);
        if (object.unbondingTime !== undefined && object.unbondingTime !== null) message.unbondingTime = $dmomH.Duration.fromJSON(object.unbondingTime);
        else message.unbondingTime = undefined;
        if (object.maxValidators !== undefined && object.maxValidators !== null) message.maxValidators = Number(object.maxValidators);
        else message.maxValidators = 0;
        if (object.maxEntries !== undefined && object.maxEntries !== null) message.maxEntries = Number(object.maxEntries);
        else message.maxEntries = 0;
        if (object.historicalEntries !== undefined && object.historicalEntries !== null) message.historicalEntries = Number(object.historicalEntries);
        else message.historicalEntries = 0;
        if (object.bondDenom !== undefined && object.bondDenom !== null) message.bondDenom = String(object.bondDenom);
        else message.bondDenom = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.unbondingTime !== undefined && (obj.unbondingTime = message.unbondingTime ? $dmomH.Duration.toJSON(message.unbondingTime) : undefined);
        message.maxValidators !== undefined && (obj.maxValidators = message.maxValidators);
        message.maxEntries !== undefined && (obj.maxEntries = message.maxEntries);
        message.historicalEntries !== undefined && (obj.historicalEntries = message.historicalEntries);
        message.bondDenom !== undefined && (obj.bondDenom = message.bondDenom);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9997c29ea4520387$var$baseParams);
        if (object.unbondingTime !== undefined && object.unbondingTime !== null) message.unbondingTime = $dmomH.Duration.fromPartial(object.unbondingTime);
        else message.unbondingTime = undefined;
        if (object.maxValidators !== undefined && object.maxValidators !== null) message.maxValidators = object.maxValidators;
        else message.maxValidators = 0;
        if (object.maxEntries !== undefined && object.maxEntries !== null) message.maxEntries = object.maxEntries;
        else message.maxEntries = 0;
        if (object.historicalEntries !== undefined && object.historicalEntries !== null) message.historicalEntries = object.historicalEntries;
        else message.historicalEntries = 0;
        if (object.bondDenom !== undefined && object.bondDenom !== null) message.bondDenom = object.bondDenom;
        else message.bondDenom = "";
        return message;
    }
};
const $9997c29ea4520387$var$baseDelegationResponse = {};
module.exports.DelegationResponse = {
    encode (message, writer = $9997c29ea4520387$var$minimal_1.default.Writer.create()) {
        if (message.delegation !== undefined) module.exports.Delegation.encode(message.delegation, writer.uint32(10).fork()).ldelim();
        if (message.balance !== undefined) $lPVUQ.Coin.encode(message.balance, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9997c29ea4520387$var$minimal_1.default.Reader ? input : new $9997c29ea4520387$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9997c29ea4520387$var$baseDelegationResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegation = module.exports.Delegation.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.balance = $lPVUQ.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9997c29ea4520387$var$baseDelegationResponse);
        if (object.delegation !== undefined && object.delegation !== null) message.delegation = module.exports.Delegation.fromJSON(object.delegation);
        else message.delegation = undefined;
        if (object.balance !== undefined && object.balance !== null) message.balance = $lPVUQ.Coin.fromJSON(object.balance);
        else message.balance = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.delegation !== undefined && (obj.delegation = message.delegation ? module.exports.Delegation.toJSON(message.delegation) : undefined);
        message.balance !== undefined && (obj.balance = message.balance ? $lPVUQ.Coin.toJSON(message.balance) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9997c29ea4520387$var$baseDelegationResponse);
        if (object.delegation !== undefined && object.delegation !== null) message.delegation = module.exports.Delegation.fromPartial(object.delegation);
        else message.delegation = undefined;
        if (object.balance !== undefined && object.balance !== null) message.balance = $lPVUQ.Coin.fromPartial(object.balance);
        else message.balance = undefined;
        return message;
    }
};
const $9997c29ea4520387$var$baseRedelegationEntryResponse = {
    balance: ""
};
module.exports.RedelegationEntryResponse = {
    encode (message, writer = $9997c29ea4520387$var$minimal_1.default.Writer.create()) {
        if (message.redelegationEntry !== undefined) module.exports.RedelegationEntry.encode(message.redelegationEntry, writer.uint32(10).fork()).ldelim();
        if (message.balance !== "") writer.uint32(34).string(message.balance);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9997c29ea4520387$var$minimal_1.default.Reader ? input : new $9997c29ea4520387$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9997c29ea4520387$var$baseRedelegationEntryResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.redelegationEntry = module.exports.RedelegationEntry.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.balance = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9997c29ea4520387$var$baseRedelegationEntryResponse);
        if (object.redelegationEntry !== undefined && object.redelegationEntry !== null) message.redelegationEntry = module.exports.RedelegationEntry.fromJSON(object.redelegationEntry);
        else message.redelegationEntry = undefined;
        if (object.balance !== undefined && object.balance !== null) message.balance = String(object.balance);
        else message.balance = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.redelegationEntry !== undefined && (obj.redelegationEntry = message.redelegationEntry ? module.exports.RedelegationEntry.toJSON(message.redelegationEntry) : undefined);
        message.balance !== undefined && (obj.balance = message.balance);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9997c29ea4520387$var$baseRedelegationEntryResponse);
        if (object.redelegationEntry !== undefined && object.redelegationEntry !== null) message.redelegationEntry = module.exports.RedelegationEntry.fromPartial(object.redelegationEntry);
        else message.redelegationEntry = undefined;
        if (object.balance !== undefined && object.balance !== null) message.balance = object.balance;
        else message.balance = "";
        return message;
    }
};
const $9997c29ea4520387$var$baseRedelegationResponse = {};
module.exports.RedelegationResponse = {
    encode (message, writer = $9997c29ea4520387$var$minimal_1.default.Writer.create()) {
        if (message.redelegation !== undefined) module.exports.Redelegation.encode(message.redelegation, writer.uint32(10).fork()).ldelim();
        for (const v of message.entries)module.exports.RedelegationEntryResponse.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9997c29ea4520387$var$minimal_1.default.Reader ? input : new $9997c29ea4520387$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9997c29ea4520387$var$baseRedelegationResponse);
        message.entries = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.redelegation = module.exports.Redelegation.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.entries.push(module.exports.RedelegationEntryResponse.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9997c29ea4520387$var$baseRedelegationResponse);
        message.entries = [];
        if (object.redelegation !== undefined && object.redelegation !== null) message.redelegation = module.exports.Redelegation.fromJSON(object.redelegation);
        else message.redelegation = undefined;
        if (object.entries !== undefined && object.entries !== null) for (const e of object.entries)message.entries.push(module.exports.RedelegationEntryResponse.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.redelegation !== undefined && (obj.redelegation = message.redelegation ? module.exports.Redelegation.toJSON(message.redelegation) : undefined);
        if (message.entries) obj.entries = message.entries.map((e)=>e ? module.exports.RedelegationEntryResponse.toJSON(e) : undefined);
        else obj.entries = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9997c29ea4520387$var$baseRedelegationResponse);
        message.entries = [];
        if (object.redelegation !== undefined && object.redelegation !== null) message.redelegation = module.exports.Redelegation.fromPartial(object.redelegation);
        else message.redelegation = undefined;
        if (object.entries !== undefined && object.entries !== null) for (const e of object.entries)message.entries.push(module.exports.RedelegationEntryResponse.fromPartial(e));
        return message;
    }
};
const $9997c29ea4520387$var$basePool = {
    notBondedTokens: "",
    bondedTokens: ""
};
module.exports.Pool = {
    encode (message, writer = $9997c29ea4520387$var$minimal_1.default.Writer.create()) {
        if (message.notBondedTokens !== "") writer.uint32(10).string(message.notBondedTokens);
        if (message.bondedTokens !== "") writer.uint32(18).string(message.bondedTokens);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9997c29ea4520387$var$minimal_1.default.Reader ? input : new $9997c29ea4520387$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9997c29ea4520387$var$basePool);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.notBondedTokens = reader.string();
                    break;
                case 2:
                    message.bondedTokens = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9997c29ea4520387$var$basePool);
        if (object.notBondedTokens !== undefined && object.notBondedTokens !== null) message.notBondedTokens = String(object.notBondedTokens);
        else message.notBondedTokens = "";
        if (object.bondedTokens !== undefined && object.bondedTokens !== null) message.bondedTokens = String(object.bondedTokens);
        else message.bondedTokens = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.notBondedTokens !== undefined && (obj.notBondedTokens = message.notBondedTokens);
        message.bondedTokens !== undefined && (obj.bondedTokens = message.bondedTokens);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9997c29ea4520387$var$basePool);
        if (object.notBondedTokens !== undefined && object.notBondedTokens !== null) message.notBondedTokens = object.notBondedTokens;
        else message.notBondedTokens = "";
        if (object.bondedTokens !== undefined && object.bondedTokens !== null) message.bondedTokens = object.bondedTokens;
        else message.bondedTokens = "";
        return message;
    }
};
function $9997c29ea4520387$var$toTimestamp(date) {
    const seconds = $9997c29ea4520387$var$numberToLong(date.getTime() / 1000);
    const nanos = date.getTime() % 1000 * 1000000;
    return {
        seconds: seconds,
        nanos: nanos
    };
}
function $9997c29ea4520387$var$fromTimestamp(t) {
    let millis = t.seconds.toNumber() * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function $9997c29ea4520387$var$fromJsonTimestamp(o) {
    if (o instanceof Date) return o;
    else if (typeof o === "string") return new Date(o);
    else return $9997c29ea4520387$var$fromTimestamp($5G2s6.Timestamp.fromJSON(o));
}
function $9997c29ea4520387$var$numberToLong(number) {
    return $9997c29ea4520387$var$long_1.default.fromNumber(number);
}
if ($9997c29ea4520387$var$minimal_1.default.util.Long !== $9997c29ea4520387$var$long_1.default) {
    $9997c29ea4520387$var$minimal_1.default.util.Long = $9997c29ea4520387$var$long_1.default;
    $9997c29ea4520387$var$minimal_1.default.configure();
}

});
parcelRegister("djDW6", function(module, exports) {
"use strict";
var $9b1c0733bff72dcb$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TxProof = module.exports.BlockMeta = module.exports.LightBlock = module.exports.SignedHeader = module.exports.Proposal = module.exports.CommitSig = module.exports.Commit = module.exports.Vote = module.exports.Data = module.exports.Header = module.exports.BlockID = module.exports.Part = module.exports.PartSetHeader = module.exports.signedMsgTypeToJSON = module.exports.signedMsgTypeFromJSON = module.exports.SignedMsgType = module.exports.blockIDFlagToJSON = module.exports.blockIDFlagFromJSON = module.exports.BlockIDFlag = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $9b1c0733bff72dcb$var$long_1 = $9b1c0733bff72dcb$var$__importDefault((parcelRequire("9A55m")));

const $9b1c0733bff72dcb$var$minimal_1 = $9b1c0733bff72dcb$var$__importDefault((parcelRequire("i2pIU")));

var $eIxyR = parcelRequire("eIxyR");

var $liJvN = parcelRequire("liJvN");

var $j77DS = parcelRequire("j77DS");

var $5G2s6 = parcelRequire("5G2s6");
module.exports.protobufPackage = "tendermint.types";
/** BlockIdFlag indicates which BlcokID the signature is for */ var $9b1c0733bff72dcb$var$BlockIDFlag;
(function(BlockIDFlag) {
    BlockIDFlag[BlockIDFlag["BLOCK_ID_FLAG_UNKNOWN"] = 0] = "BLOCK_ID_FLAG_UNKNOWN";
    BlockIDFlag[BlockIDFlag["BLOCK_ID_FLAG_ABSENT"] = 1] = "BLOCK_ID_FLAG_ABSENT";
    BlockIDFlag[BlockIDFlag["BLOCK_ID_FLAG_COMMIT"] = 2] = "BLOCK_ID_FLAG_COMMIT";
    BlockIDFlag[BlockIDFlag["BLOCK_ID_FLAG_NIL"] = 3] = "BLOCK_ID_FLAG_NIL";
    BlockIDFlag[BlockIDFlag["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($9b1c0733bff72dcb$var$BlockIDFlag = module.exports.BlockIDFlag || (module.exports.BlockIDFlag = {}));
function $9b1c0733bff72dcb$var$blockIDFlagFromJSON(object) {
    switch(object){
        case 0:
        case "BLOCK_ID_FLAG_UNKNOWN":
            return $9b1c0733bff72dcb$var$BlockIDFlag.BLOCK_ID_FLAG_UNKNOWN;
        case 1:
        case "BLOCK_ID_FLAG_ABSENT":
            return $9b1c0733bff72dcb$var$BlockIDFlag.BLOCK_ID_FLAG_ABSENT;
        case 2:
        case "BLOCK_ID_FLAG_COMMIT":
            return $9b1c0733bff72dcb$var$BlockIDFlag.BLOCK_ID_FLAG_COMMIT;
        case 3:
        case "BLOCK_ID_FLAG_NIL":
            return $9b1c0733bff72dcb$var$BlockIDFlag.BLOCK_ID_FLAG_NIL;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $9b1c0733bff72dcb$var$BlockIDFlag.UNRECOGNIZED;
    }
}
module.exports.blockIDFlagFromJSON = $9b1c0733bff72dcb$var$blockIDFlagFromJSON;
function $9b1c0733bff72dcb$var$blockIDFlagToJSON(object) {
    switch(object){
        case $9b1c0733bff72dcb$var$BlockIDFlag.BLOCK_ID_FLAG_UNKNOWN:
            return "BLOCK_ID_FLAG_UNKNOWN";
        case $9b1c0733bff72dcb$var$BlockIDFlag.BLOCK_ID_FLAG_ABSENT:
            return "BLOCK_ID_FLAG_ABSENT";
        case $9b1c0733bff72dcb$var$BlockIDFlag.BLOCK_ID_FLAG_COMMIT:
            return "BLOCK_ID_FLAG_COMMIT";
        case $9b1c0733bff72dcb$var$BlockIDFlag.BLOCK_ID_FLAG_NIL:
            return "BLOCK_ID_FLAG_NIL";
        default:
            return "UNKNOWN";
    }
}
module.exports.blockIDFlagToJSON = $9b1c0733bff72dcb$var$blockIDFlagToJSON;
/** SignedMsgType is a type of signed message in the consensus. */ var $9b1c0733bff72dcb$var$SignedMsgType;
(function(SignedMsgType) {
    SignedMsgType[SignedMsgType["SIGNED_MSG_TYPE_UNKNOWN"] = 0] = "SIGNED_MSG_TYPE_UNKNOWN";
    /** SIGNED_MSG_TYPE_PREVOTE - Votes */ SignedMsgType[SignedMsgType["SIGNED_MSG_TYPE_PREVOTE"] = 1] = "SIGNED_MSG_TYPE_PREVOTE";
    SignedMsgType[SignedMsgType["SIGNED_MSG_TYPE_PRECOMMIT"] = 2] = "SIGNED_MSG_TYPE_PRECOMMIT";
    /** SIGNED_MSG_TYPE_PROPOSAL - Proposals */ SignedMsgType[SignedMsgType["SIGNED_MSG_TYPE_PROPOSAL"] = 32] = "SIGNED_MSG_TYPE_PROPOSAL";
    SignedMsgType[SignedMsgType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($9b1c0733bff72dcb$var$SignedMsgType = module.exports.SignedMsgType || (module.exports.SignedMsgType = {}));
function $9b1c0733bff72dcb$var$signedMsgTypeFromJSON(object) {
    switch(object){
        case 0:
        case "SIGNED_MSG_TYPE_UNKNOWN":
            return $9b1c0733bff72dcb$var$SignedMsgType.SIGNED_MSG_TYPE_UNKNOWN;
        case 1:
        case "SIGNED_MSG_TYPE_PREVOTE":
            return $9b1c0733bff72dcb$var$SignedMsgType.SIGNED_MSG_TYPE_PREVOTE;
        case 2:
        case "SIGNED_MSG_TYPE_PRECOMMIT":
            return $9b1c0733bff72dcb$var$SignedMsgType.SIGNED_MSG_TYPE_PRECOMMIT;
        case 32:
        case "SIGNED_MSG_TYPE_PROPOSAL":
            return $9b1c0733bff72dcb$var$SignedMsgType.SIGNED_MSG_TYPE_PROPOSAL;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $9b1c0733bff72dcb$var$SignedMsgType.UNRECOGNIZED;
    }
}
module.exports.signedMsgTypeFromJSON = $9b1c0733bff72dcb$var$signedMsgTypeFromJSON;
function $9b1c0733bff72dcb$var$signedMsgTypeToJSON(object) {
    switch(object){
        case $9b1c0733bff72dcb$var$SignedMsgType.SIGNED_MSG_TYPE_UNKNOWN:
            return "SIGNED_MSG_TYPE_UNKNOWN";
        case $9b1c0733bff72dcb$var$SignedMsgType.SIGNED_MSG_TYPE_PREVOTE:
            return "SIGNED_MSG_TYPE_PREVOTE";
        case $9b1c0733bff72dcb$var$SignedMsgType.SIGNED_MSG_TYPE_PRECOMMIT:
            return "SIGNED_MSG_TYPE_PRECOMMIT";
        case $9b1c0733bff72dcb$var$SignedMsgType.SIGNED_MSG_TYPE_PROPOSAL:
            return "SIGNED_MSG_TYPE_PROPOSAL";
        default:
            return "UNKNOWN";
    }
}
module.exports.signedMsgTypeToJSON = $9b1c0733bff72dcb$var$signedMsgTypeToJSON;
const $9b1c0733bff72dcb$var$basePartSetHeader = {
    total: 0
};
module.exports.PartSetHeader = {
    encode (message, writer = $9b1c0733bff72dcb$var$minimal_1.default.Writer.create()) {
        if (message.total !== 0) writer.uint32(8).uint32(message.total);
        if (message.hash.length !== 0) writer.uint32(18).bytes(message.hash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9b1c0733bff72dcb$var$minimal_1.default.Reader ? input : new $9b1c0733bff72dcb$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9b1c0733bff72dcb$var$basePartSetHeader);
        message.hash = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.total = reader.uint32();
                    break;
                case 2:
                    message.hash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9b1c0733bff72dcb$var$basePartSetHeader);
        message.hash = new Uint8Array();
        if (object.total !== undefined && object.total !== null) message.total = Number(object.total);
        else message.total = 0;
        if (object.hash !== undefined && object.hash !== null) message.hash = $9b1c0733bff72dcb$var$bytesFromBase64(object.hash);
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.total !== undefined && (obj.total = message.total);
        message.hash !== undefined && (obj.hash = $9b1c0733bff72dcb$var$base64FromBytes(message.hash !== undefined ? message.hash : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9b1c0733bff72dcb$var$basePartSetHeader);
        if (object.total !== undefined && object.total !== null) message.total = object.total;
        else message.total = 0;
        if (object.hash !== undefined && object.hash !== null) message.hash = object.hash;
        else message.hash = new Uint8Array();
        return message;
    }
};
const $9b1c0733bff72dcb$var$basePart = {
    index: 0
};
module.exports.Part = {
    encode (message, writer = $9b1c0733bff72dcb$var$minimal_1.default.Writer.create()) {
        if (message.index !== 0) writer.uint32(8).uint32(message.index);
        if (message.bytes.length !== 0) writer.uint32(18).bytes(message.bytes);
        if (message.proof !== undefined) $eIxyR.Proof.encode(message.proof, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9b1c0733bff72dcb$var$minimal_1.default.Reader ? input : new $9b1c0733bff72dcb$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9b1c0733bff72dcb$var$basePart);
        message.bytes = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.index = reader.uint32();
                    break;
                case 2:
                    message.bytes = reader.bytes();
                    break;
                case 3:
                    message.proof = $eIxyR.Proof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9b1c0733bff72dcb$var$basePart);
        message.bytes = new Uint8Array();
        if (object.index !== undefined && object.index !== null) message.index = Number(object.index);
        else message.index = 0;
        if (object.bytes !== undefined && object.bytes !== null) message.bytes = $9b1c0733bff72dcb$var$bytesFromBase64(object.bytes);
        if (object.proof !== undefined && object.proof !== null) message.proof = $eIxyR.Proof.fromJSON(object.proof);
        else message.proof = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.index !== undefined && (obj.index = message.index);
        message.bytes !== undefined && (obj.bytes = $9b1c0733bff72dcb$var$base64FromBytes(message.bytes !== undefined ? message.bytes : new Uint8Array()));
        message.proof !== undefined && (obj.proof = message.proof ? $eIxyR.Proof.toJSON(message.proof) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9b1c0733bff72dcb$var$basePart);
        if (object.index !== undefined && object.index !== null) message.index = object.index;
        else message.index = 0;
        if (object.bytes !== undefined && object.bytes !== null) message.bytes = object.bytes;
        else message.bytes = new Uint8Array();
        if (object.proof !== undefined && object.proof !== null) message.proof = $eIxyR.Proof.fromPartial(object.proof);
        else message.proof = undefined;
        return message;
    }
};
const $9b1c0733bff72dcb$var$baseBlockID = {};
module.exports.BlockID = {
    encode (message, writer = $9b1c0733bff72dcb$var$minimal_1.default.Writer.create()) {
        if (message.hash.length !== 0) writer.uint32(10).bytes(message.hash);
        if (message.partSetHeader !== undefined) module.exports.PartSetHeader.encode(message.partSetHeader, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9b1c0733bff72dcb$var$minimal_1.default.Reader ? input : new $9b1c0733bff72dcb$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9b1c0733bff72dcb$var$baseBlockID);
        message.hash = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.bytes();
                    break;
                case 2:
                    message.partSetHeader = module.exports.PartSetHeader.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9b1c0733bff72dcb$var$baseBlockID);
        message.hash = new Uint8Array();
        if (object.hash !== undefined && object.hash !== null) message.hash = $9b1c0733bff72dcb$var$bytesFromBase64(object.hash);
        if (object.partSetHeader !== undefined && object.partSetHeader !== null) message.partSetHeader = module.exports.PartSetHeader.fromJSON(object.partSetHeader);
        else message.partSetHeader = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = $9b1c0733bff72dcb$var$base64FromBytes(message.hash !== undefined ? message.hash : new Uint8Array()));
        message.partSetHeader !== undefined && (obj.partSetHeader = message.partSetHeader ? module.exports.PartSetHeader.toJSON(message.partSetHeader) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9b1c0733bff72dcb$var$baseBlockID);
        if (object.hash !== undefined && object.hash !== null) message.hash = object.hash;
        else message.hash = new Uint8Array();
        if (object.partSetHeader !== undefined && object.partSetHeader !== null) message.partSetHeader = module.exports.PartSetHeader.fromPartial(object.partSetHeader);
        else message.partSetHeader = undefined;
        return message;
    }
};
const $9b1c0733bff72dcb$var$baseHeader = {
    chainId: "",
    height: $9b1c0733bff72dcb$var$long_1.default.ZERO
};
module.exports.Header = {
    encode (message, writer = $9b1c0733bff72dcb$var$minimal_1.default.Writer.create()) {
        if (message.version !== undefined) $liJvN.Consensus.encode(message.version, writer.uint32(10).fork()).ldelim();
        if (message.chainId !== "") writer.uint32(18).string(message.chainId);
        if (!message.height.isZero()) writer.uint32(24).int64(message.height);
        if (message.time !== undefined) $5G2s6.Timestamp.encode($9b1c0733bff72dcb$var$toTimestamp(message.time), writer.uint32(34).fork()).ldelim();
        if (message.lastBlockId !== undefined) module.exports.BlockID.encode(message.lastBlockId, writer.uint32(42).fork()).ldelim();
        if (message.lastCommitHash.length !== 0) writer.uint32(50).bytes(message.lastCommitHash);
        if (message.dataHash.length !== 0) writer.uint32(58).bytes(message.dataHash);
        if (message.validatorsHash.length !== 0) writer.uint32(66).bytes(message.validatorsHash);
        if (message.nextValidatorsHash.length !== 0) writer.uint32(74).bytes(message.nextValidatorsHash);
        if (message.consensusHash.length !== 0) writer.uint32(82).bytes(message.consensusHash);
        if (message.appHash.length !== 0) writer.uint32(90).bytes(message.appHash);
        if (message.lastResultsHash.length !== 0) writer.uint32(98).bytes(message.lastResultsHash);
        if (message.evidenceHash.length !== 0) writer.uint32(106).bytes(message.evidenceHash);
        if (message.proposerAddress.length !== 0) writer.uint32(114).bytes(message.proposerAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9b1c0733bff72dcb$var$minimal_1.default.Reader ? input : new $9b1c0733bff72dcb$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9b1c0733bff72dcb$var$baseHeader);
        message.lastCommitHash = new Uint8Array();
        message.dataHash = new Uint8Array();
        message.validatorsHash = new Uint8Array();
        message.nextValidatorsHash = new Uint8Array();
        message.consensusHash = new Uint8Array();
        message.appHash = new Uint8Array();
        message.lastResultsHash = new Uint8Array();
        message.evidenceHash = new Uint8Array();
        message.proposerAddress = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.version = $liJvN.Consensus.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.chainId = reader.string();
                    break;
                case 3:
                    message.height = reader.int64();
                    break;
                case 4:
                    message.time = $9b1c0733bff72dcb$var$fromTimestamp($5G2s6.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.lastBlockId = module.exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.lastCommitHash = reader.bytes();
                    break;
                case 7:
                    message.dataHash = reader.bytes();
                    break;
                case 8:
                    message.validatorsHash = reader.bytes();
                    break;
                case 9:
                    message.nextValidatorsHash = reader.bytes();
                    break;
                case 10:
                    message.consensusHash = reader.bytes();
                    break;
                case 11:
                    message.appHash = reader.bytes();
                    break;
                case 12:
                    message.lastResultsHash = reader.bytes();
                    break;
                case 13:
                    message.evidenceHash = reader.bytes();
                    break;
                case 14:
                    message.proposerAddress = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9b1c0733bff72dcb$var$baseHeader);
        message.lastCommitHash = new Uint8Array();
        message.dataHash = new Uint8Array();
        message.validatorsHash = new Uint8Array();
        message.nextValidatorsHash = new Uint8Array();
        message.consensusHash = new Uint8Array();
        message.appHash = new Uint8Array();
        message.lastResultsHash = new Uint8Array();
        message.evidenceHash = new Uint8Array();
        message.proposerAddress = new Uint8Array();
        if (object.version !== undefined && object.version !== null) message.version = $liJvN.Consensus.fromJSON(object.version);
        else message.version = undefined;
        if (object.chainId !== undefined && object.chainId !== null) message.chainId = String(object.chainId);
        else message.chainId = "";
        if (object.height !== undefined && object.height !== null) message.height = $9b1c0733bff72dcb$var$long_1.default.fromString(object.height);
        else message.height = $9b1c0733bff72dcb$var$long_1.default.ZERO;
        if (object.time !== undefined && object.time !== null) message.time = $9b1c0733bff72dcb$var$fromJsonTimestamp(object.time);
        else message.time = undefined;
        if (object.lastBlockId !== undefined && object.lastBlockId !== null) message.lastBlockId = module.exports.BlockID.fromJSON(object.lastBlockId);
        else message.lastBlockId = undefined;
        if (object.lastCommitHash !== undefined && object.lastCommitHash !== null) message.lastCommitHash = $9b1c0733bff72dcb$var$bytesFromBase64(object.lastCommitHash);
        if (object.dataHash !== undefined && object.dataHash !== null) message.dataHash = $9b1c0733bff72dcb$var$bytesFromBase64(object.dataHash);
        if (object.validatorsHash !== undefined && object.validatorsHash !== null) message.validatorsHash = $9b1c0733bff72dcb$var$bytesFromBase64(object.validatorsHash);
        if (object.nextValidatorsHash !== undefined && object.nextValidatorsHash !== null) message.nextValidatorsHash = $9b1c0733bff72dcb$var$bytesFromBase64(object.nextValidatorsHash);
        if (object.consensusHash !== undefined && object.consensusHash !== null) message.consensusHash = $9b1c0733bff72dcb$var$bytesFromBase64(object.consensusHash);
        if (object.appHash !== undefined && object.appHash !== null) message.appHash = $9b1c0733bff72dcb$var$bytesFromBase64(object.appHash);
        if (object.lastResultsHash !== undefined && object.lastResultsHash !== null) message.lastResultsHash = $9b1c0733bff72dcb$var$bytesFromBase64(object.lastResultsHash);
        if (object.evidenceHash !== undefined && object.evidenceHash !== null) message.evidenceHash = $9b1c0733bff72dcb$var$bytesFromBase64(object.evidenceHash);
        if (object.proposerAddress !== undefined && object.proposerAddress !== null) message.proposerAddress = $9b1c0733bff72dcb$var$bytesFromBase64(object.proposerAddress);
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.version !== undefined && (obj.version = message.version ? $liJvN.Consensus.toJSON(message.version) : undefined);
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.height !== undefined && (obj.height = (message.height || $9b1c0733bff72dcb$var$long_1.default.ZERO).toString());
        message.time !== undefined && (obj.time = message.time.toISOString());
        message.lastBlockId !== undefined && (obj.lastBlockId = message.lastBlockId ? module.exports.BlockID.toJSON(message.lastBlockId) : undefined);
        message.lastCommitHash !== undefined && (obj.lastCommitHash = $9b1c0733bff72dcb$var$base64FromBytes(message.lastCommitHash !== undefined ? message.lastCommitHash : new Uint8Array()));
        message.dataHash !== undefined && (obj.dataHash = $9b1c0733bff72dcb$var$base64FromBytes(message.dataHash !== undefined ? message.dataHash : new Uint8Array()));
        message.validatorsHash !== undefined && (obj.validatorsHash = $9b1c0733bff72dcb$var$base64FromBytes(message.validatorsHash !== undefined ? message.validatorsHash : new Uint8Array()));
        message.nextValidatorsHash !== undefined && (obj.nextValidatorsHash = $9b1c0733bff72dcb$var$base64FromBytes(message.nextValidatorsHash !== undefined ? message.nextValidatorsHash : new Uint8Array()));
        message.consensusHash !== undefined && (obj.consensusHash = $9b1c0733bff72dcb$var$base64FromBytes(message.consensusHash !== undefined ? message.consensusHash : new Uint8Array()));
        message.appHash !== undefined && (obj.appHash = $9b1c0733bff72dcb$var$base64FromBytes(message.appHash !== undefined ? message.appHash : new Uint8Array()));
        message.lastResultsHash !== undefined && (obj.lastResultsHash = $9b1c0733bff72dcb$var$base64FromBytes(message.lastResultsHash !== undefined ? message.lastResultsHash : new Uint8Array()));
        message.evidenceHash !== undefined && (obj.evidenceHash = $9b1c0733bff72dcb$var$base64FromBytes(message.evidenceHash !== undefined ? message.evidenceHash : new Uint8Array()));
        message.proposerAddress !== undefined && (obj.proposerAddress = $9b1c0733bff72dcb$var$base64FromBytes(message.proposerAddress !== undefined ? message.proposerAddress : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9b1c0733bff72dcb$var$baseHeader);
        if (object.version !== undefined && object.version !== null) message.version = $liJvN.Consensus.fromPartial(object.version);
        else message.version = undefined;
        if (object.chainId !== undefined && object.chainId !== null) message.chainId = object.chainId;
        else message.chainId = "";
        if (object.height !== undefined && object.height !== null) message.height = object.height;
        else message.height = $9b1c0733bff72dcb$var$long_1.default.ZERO;
        if (object.time !== undefined && object.time !== null) message.time = object.time;
        else message.time = undefined;
        if (object.lastBlockId !== undefined && object.lastBlockId !== null) message.lastBlockId = module.exports.BlockID.fromPartial(object.lastBlockId);
        else message.lastBlockId = undefined;
        if (object.lastCommitHash !== undefined && object.lastCommitHash !== null) message.lastCommitHash = object.lastCommitHash;
        else message.lastCommitHash = new Uint8Array();
        if (object.dataHash !== undefined && object.dataHash !== null) message.dataHash = object.dataHash;
        else message.dataHash = new Uint8Array();
        if (object.validatorsHash !== undefined && object.validatorsHash !== null) message.validatorsHash = object.validatorsHash;
        else message.validatorsHash = new Uint8Array();
        if (object.nextValidatorsHash !== undefined && object.nextValidatorsHash !== null) message.nextValidatorsHash = object.nextValidatorsHash;
        else message.nextValidatorsHash = new Uint8Array();
        if (object.consensusHash !== undefined && object.consensusHash !== null) message.consensusHash = object.consensusHash;
        else message.consensusHash = new Uint8Array();
        if (object.appHash !== undefined && object.appHash !== null) message.appHash = object.appHash;
        else message.appHash = new Uint8Array();
        if (object.lastResultsHash !== undefined && object.lastResultsHash !== null) message.lastResultsHash = object.lastResultsHash;
        else message.lastResultsHash = new Uint8Array();
        if (object.evidenceHash !== undefined && object.evidenceHash !== null) message.evidenceHash = object.evidenceHash;
        else message.evidenceHash = new Uint8Array();
        if (object.proposerAddress !== undefined && object.proposerAddress !== null) message.proposerAddress = object.proposerAddress;
        else message.proposerAddress = new Uint8Array();
        return message;
    }
};
const $9b1c0733bff72dcb$var$baseData = {};
module.exports.Data = {
    encode (message, writer = $9b1c0733bff72dcb$var$minimal_1.default.Writer.create()) {
        for (const v of message.txs)writer.uint32(10).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9b1c0733bff72dcb$var$minimal_1.default.Reader ? input : new $9b1c0733bff72dcb$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9b1c0733bff72dcb$var$baseData);
        message.txs = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txs.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9b1c0733bff72dcb$var$baseData);
        message.txs = [];
        if (object.txs !== undefined && object.txs !== null) for (const e of object.txs)message.txs.push($9b1c0733bff72dcb$var$bytesFromBase64(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.txs) obj.txs = message.txs.map((e)=>$9b1c0733bff72dcb$var$base64FromBytes(e !== undefined ? e : new Uint8Array()));
        else obj.txs = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9b1c0733bff72dcb$var$baseData);
        message.txs = [];
        if (object.txs !== undefined && object.txs !== null) for (const e of object.txs)message.txs.push(e);
        return message;
    }
};
const $9b1c0733bff72dcb$var$baseVote = {
    type: 0,
    height: $9b1c0733bff72dcb$var$long_1.default.ZERO,
    round: 0,
    validatorIndex: 0
};
module.exports.Vote = {
    encode (message, writer = $9b1c0733bff72dcb$var$minimal_1.default.Writer.create()) {
        if (message.type !== 0) writer.uint32(8).int32(message.type);
        if (!message.height.isZero()) writer.uint32(16).int64(message.height);
        if (message.round !== 0) writer.uint32(24).int32(message.round);
        if (message.blockId !== undefined) module.exports.BlockID.encode(message.blockId, writer.uint32(34).fork()).ldelim();
        if (message.timestamp !== undefined) $5G2s6.Timestamp.encode($9b1c0733bff72dcb$var$toTimestamp(message.timestamp), writer.uint32(42).fork()).ldelim();
        if (message.validatorAddress.length !== 0) writer.uint32(50).bytes(message.validatorAddress);
        if (message.validatorIndex !== 0) writer.uint32(56).int32(message.validatorIndex);
        if (message.signature.length !== 0) writer.uint32(66).bytes(message.signature);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9b1c0733bff72dcb$var$minimal_1.default.Reader ? input : new $9b1c0733bff72dcb$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9b1c0733bff72dcb$var$baseVote);
        message.validatorAddress = new Uint8Array();
        message.signature = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.int32();
                    break;
                case 2:
                    message.height = reader.int64();
                    break;
                case 3:
                    message.round = reader.int32();
                    break;
                case 4:
                    message.blockId = module.exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.timestamp = $9b1c0733bff72dcb$var$fromTimestamp($5G2s6.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 6:
                    message.validatorAddress = reader.bytes();
                    break;
                case 7:
                    message.validatorIndex = reader.int32();
                    break;
                case 8:
                    message.signature = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9b1c0733bff72dcb$var$baseVote);
        message.validatorAddress = new Uint8Array();
        message.signature = new Uint8Array();
        if (object.type !== undefined && object.type !== null) message.type = $9b1c0733bff72dcb$var$signedMsgTypeFromJSON(object.type);
        else message.type = 0;
        if (object.height !== undefined && object.height !== null) message.height = $9b1c0733bff72dcb$var$long_1.default.fromString(object.height);
        else message.height = $9b1c0733bff72dcb$var$long_1.default.ZERO;
        if (object.round !== undefined && object.round !== null) message.round = Number(object.round);
        else message.round = 0;
        if (object.blockId !== undefined && object.blockId !== null) message.blockId = module.exports.BlockID.fromJSON(object.blockId);
        else message.blockId = undefined;
        if (object.timestamp !== undefined && object.timestamp !== null) message.timestamp = $9b1c0733bff72dcb$var$fromJsonTimestamp(object.timestamp);
        else message.timestamp = undefined;
        if (object.validatorAddress !== undefined && object.validatorAddress !== null) message.validatorAddress = $9b1c0733bff72dcb$var$bytesFromBase64(object.validatorAddress);
        if (object.validatorIndex !== undefined && object.validatorIndex !== null) message.validatorIndex = Number(object.validatorIndex);
        else message.validatorIndex = 0;
        if (object.signature !== undefined && object.signature !== null) message.signature = $9b1c0733bff72dcb$var$bytesFromBase64(object.signature);
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.type !== undefined && (obj.type = $9b1c0733bff72dcb$var$signedMsgTypeToJSON(message.type));
        message.height !== undefined && (obj.height = (message.height || $9b1c0733bff72dcb$var$long_1.default.ZERO).toString());
        message.round !== undefined && (obj.round = message.round);
        message.blockId !== undefined && (obj.blockId = message.blockId ? module.exports.BlockID.toJSON(message.blockId) : undefined);
        message.timestamp !== undefined && (obj.timestamp = message.timestamp.toISOString());
        message.validatorAddress !== undefined && (obj.validatorAddress = $9b1c0733bff72dcb$var$base64FromBytes(message.validatorAddress !== undefined ? message.validatorAddress : new Uint8Array()));
        message.validatorIndex !== undefined && (obj.validatorIndex = message.validatorIndex);
        message.signature !== undefined && (obj.signature = $9b1c0733bff72dcb$var$base64FromBytes(message.signature !== undefined ? message.signature : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9b1c0733bff72dcb$var$baseVote);
        if (object.type !== undefined && object.type !== null) message.type = object.type;
        else message.type = 0;
        if (object.height !== undefined && object.height !== null) message.height = object.height;
        else message.height = $9b1c0733bff72dcb$var$long_1.default.ZERO;
        if (object.round !== undefined && object.round !== null) message.round = object.round;
        else message.round = 0;
        if (object.blockId !== undefined && object.blockId !== null) message.blockId = module.exports.BlockID.fromPartial(object.blockId);
        else message.blockId = undefined;
        if (object.timestamp !== undefined && object.timestamp !== null) message.timestamp = object.timestamp;
        else message.timestamp = undefined;
        if (object.validatorAddress !== undefined && object.validatorAddress !== null) message.validatorAddress = object.validatorAddress;
        else message.validatorAddress = new Uint8Array();
        if (object.validatorIndex !== undefined && object.validatorIndex !== null) message.validatorIndex = object.validatorIndex;
        else message.validatorIndex = 0;
        if (object.signature !== undefined && object.signature !== null) message.signature = object.signature;
        else message.signature = new Uint8Array();
        return message;
    }
};
const $9b1c0733bff72dcb$var$baseCommit = {
    height: $9b1c0733bff72dcb$var$long_1.default.ZERO,
    round: 0
};
module.exports.Commit = {
    encode (message, writer = $9b1c0733bff72dcb$var$minimal_1.default.Writer.create()) {
        if (!message.height.isZero()) writer.uint32(8).int64(message.height);
        if (message.round !== 0) writer.uint32(16).int32(message.round);
        if (message.blockId !== undefined) module.exports.BlockID.encode(message.blockId, writer.uint32(26).fork()).ldelim();
        for (const v of message.signatures)module.exports.CommitSig.encode(v, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9b1c0733bff72dcb$var$minimal_1.default.Reader ? input : new $9b1c0733bff72dcb$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9b1c0733bff72dcb$var$baseCommit);
        message.signatures = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.int64();
                    break;
                case 2:
                    message.round = reader.int32();
                    break;
                case 3:
                    message.blockId = module.exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.signatures.push(module.exports.CommitSig.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9b1c0733bff72dcb$var$baseCommit);
        message.signatures = [];
        if (object.height !== undefined && object.height !== null) message.height = $9b1c0733bff72dcb$var$long_1.default.fromString(object.height);
        else message.height = $9b1c0733bff72dcb$var$long_1.default.ZERO;
        if (object.round !== undefined && object.round !== null) message.round = Number(object.round);
        else message.round = 0;
        if (object.blockId !== undefined && object.blockId !== null) message.blockId = module.exports.BlockID.fromJSON(object.blockId);
        else message.blockId = undefined;
        if (object.signatures !== undefined && object.signatures !== null) for (const e of object.signatures)message.signatures.push(module.exports.CommitSig.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || $9b1c0733bff72dcb$var$long_1.default.ZERO).toString());
        message.round !== undefined && (obj.round = message.round);
        message.blockId !== undefined && (obj.blockId = message.blockId ? module.exports.BlockID.toJSON(message.blockId) : undefined);
        if (message.signatures) obj.signatures = message.signatures.map((e)=>e ? module.exports.CommitSig.toJSON(e) : undefined);
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9b1c0733bff72dcb$var$baseCommit);
        message.signatures = [];
        if (object.height !== undefined && object.height !== null) message.height = object.height;
        else message.height = $9b1c0733bff72dcb$var$long_1.default.ZERO;
        if (object.round !== undefined && object.round !== null) message.round = object.round;
        else message.round = 0;
        if (object.blockId !== undefined && object.blockId !== null) message.blockId = module.exports.BlockID.fromPartial(object.blockId);
        else message.blockId = undefined;
        if (object.signatures !== undefined && object.signatures !== null) for (const e of object.signatures)message.signatures.push(module.exports.CommitSig.fromPartial(e));
        return message;
    }
};
const $9b1c0733bff72dcb$var$baseCommitSig = {
    blockIdFlag: 0
};
module.exports.CommitSig = {
    encode (message, writer = $9b1c0733bff72dcb$var$minimal_1.default.Writer.create()) {
        if (message.blockIdFlag !== 0) writer.uint32(8).int32(message.blockIdFlag);
        if (message.validatorAddress.length !== 0) writer.uint32(18).bytes(message.validatorAddress);
        if (message.timestamp !== undefined) $5G2s6.Timestamp.encode($9b1c0733bff72dcb$var$toTimestamp(message.timestamp), writer.uint32(26).fork()).ldelim();
        if (message.signature.length !== 0) writer.uint32(34).bytes(message.signature);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9b1c0733bff72dcb$var$minimal_1.default.Reader ? input : new $9b1c0733bff72dcb$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9b1c0733bff72dcb$var$baseCommitSig);
        message.validatorAddress = new Uint8Array();
        message.signature = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.blockIdFlag = reader.int32();
                    break;
                case 2:
                    message.validatorAddress = reader.bytes();
                    break;
                case 3:
                    message.timestamp = $9b1c0733bff72dcb$var$fromTimestamp($5G2s6.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.signature = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9b1c0733bff72dcb$var$baseCommitSig);
        message.validatorAddress = new Uint8Array();
        message.signature = new Uint8Array();
        if (object.blockIdFlag !== undefined && object.blockIdFlag !== null) message.blockIdFlag = $9b1c0733bff72dcb$var$blockIDFlagFromJSON(object.blockIdFlag);
        else message.blockIdFlag = 0;
        if (object.validatorAddress !== undefined && object.validatorAddress !== null) message.validatorAddress = $9b1c0733bff72dcb$var$bytesFromBase64(object.validatorAddress);
        if (object.timestamp !== undefined && object.timestamp !== null) message.timestamp = $9b1c0733bff72dcb$var$fromJsonTimestamp(object.timestamp);
        else message.timestamp = undefined;
        if (object.signature !== undefined && object.signature !== null) message.signature = $9b1c0733bff72dcb$var$bytesFromBase64(object.signature);
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.blockIdFlag !== undefined && (obj.blockIdFlag = $9b1c0733bff72dcb$var$blockIDFlagToJSON(message.blockIdFlag));
        message.validatorAddress !== undefined && (obj.validatorAddress = $9b1c0733bff72dcb$var$base64FromBytes(message.validatorAddress !== undefined ? message.validatorAddress : new Uint8Array()));
        message.timestamp !== undefined && (obj.timestamp = message.timestamp.toISOString());
        message.signature !== undefined && (obj.signature = $9b1c0733bff72dcb$var$base64FromBytes(message.signature !== undefined ? message.signature : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9b1c0733bff72dcb$var$baseCommitSig);
        if (object.blockIdFlag !== undefined && object.blockIdFlag !== null) message.blockIdFlag = object.blockIdFlag;
        else message.blockIdFlag = 0;
        if (object.validatorAddress !== undefined && object.validatorAddress !== null) message.validatorAddress = object.validatorAddress;
        else message.validatorAddress = new Uint8Array();
        if (object.timestamp !== undefined && object.timestamp !== null) message.timestamp = object.timestamp;
        else message.timestamp = undefined;
        if (object.signature !== undefined && object.signature !== null) message.signature = object.signature;
        else message.signature = new Uint8Array();
        return message;
    }
};
const $9b1c0733bff72dcb$var$baseProposal = {
    type: 0,
    height: $9b1c0733bff72dcb$var$long_1.default.ZERO,
    round: 0,
    polRound: 0
};
module.exports.Proposal = {
    encode (message, writer = $9b1c0733bff72dcb$var$minimal_1.default.Writer.create()) {
        if (message.type !== 0) writer.uint32(8).int32(message.type);
        if (!message.height.isZero()) writer.uint32(16).int64(message.height);
        if (message.round !== 0) writer.uint32(24).int32(message.round);
        if (message.polRound !== 0) writer.uint32(32).int32(message.polRound);
        if (message.blockId !== undefined) module.exports.BlockID.encode(message.blockId, writer.uint32(42).fork()).ldelim();
        if (message.timestamp !== undefined) $5G2s6.Timestamp.encode($9b1c0733bff72dcb$var$toTimestamp(message.timestamp), writer.uint32(50).fork()).ldelim();
        if (message.signature.length !== 0) writer.uint32(58).bytes(message.signature);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9b1c0733bff72dcb$var$minimal_1.default.Reader ? input : new $9b1c0733bff72dcb$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9b1c0733bff72dcb$var$baseProposal);
        message.signature = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.int32();
                    break;
                case 2:
                    message.height = reader.int64();
                    break;
                case 3:
                    message.round = reader.int32();
                    break;
                case 4:
                    message.polRound = reader.int32();
                    break;
                case 5:
                    message.blockId = module.exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.timestamp = $9b1c0733bff72dcb$var$fromTimestamp($5G2s6.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 7:
                    message.signature = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9b1c0733bff72dcb$var$baseProposal);
        message.signature = new Uint8Array();
        if (object.type !== undefined && object.type !== null) message.type = $9b1c0733bff72dcb$var$signedMsgTypeFromJSON(object.type);
        else message.type = 0;
        if (object.height !== undefined && object.height !== null) message.height = $9b1c0733bff72dcb$var$long_1.default.fromString(object.height);
        else message.height = $9b1c0733bff72dcb$var$long_1.default.ZERO;
        if (object.round !== undefined && object.round !== null) message.round = Number(object.round);
        else message.round = 0;
        if (object.polRound !== undefined && object.polRound !== null) message.polRound = Number(object.polRound);
        else message.polRound = 0;
        if (object.blockId !== undefined && object.blockId !== null) message.blockId = module.exports.BlockID.fromJSON(object.blockId);
        else message.blockId = undefined;
        if (object.timestamp !== undefined && object.timestamp !== null) message.timestamp = $9b1c0733bff72dcb$var$fromJsonTimestamp(object.timestamp);
        else message.timestamp = undefined;
        if (object.signature !== undefined && object.signature !== null) message.signature = $9b1c0733bff72dcb$var$bytesFromBase64(object.signature);
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.type !== undefined && (obj.type = $9b1c0733bff72dcb$var$signedMsgTypeToJSON(message.type));
        message.height !== undefined && (obj.height = (message.height || $9b1c0733bff72dcb$var$long_1.default.ZERO).toString());
        message.round !== undefined && (obj.round = message.round);
        message.polRound !== undefined && (obj.polRound = message.polRound);
        message.blockId !== undefined && (obj.blockId = message.blockId ? module.exports.BlockID.toJSON(message.blockId) : undefined);
        message.timestamp !== undefined && (obj.timestamp = message.timestamp.toISOString());
        message.signature !== undefined && (obj.signature = $9b1c0733bff72dcb$var$base64FromBytes(message.signature !== undefined ? message.signature : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9b1c0733bff72dcb$var$baseProposal);
        if (object.type !== undefined && object.type !== null) message.type = object.type;
        else message.type = 0;
        if (object.height !== undefined && object.height !== null) message.height = object.height;
        else message.height = $9b1c0733bff72dcb$var$long_1.default.ZERO;
        if (object.round !== undefined && object.round !== null) message.round = object.round;
        else message.round = 0;
        if (object.polRound !== undefined && object.polRound !== null) message.polRound = object.polRound;
        else message.polRound = 0;
        if (object.blockId !== undefined && object.blockId !== null) message.blockId = module.exports.BlockID.fromPartial(object.blockId);
        else message.blockId = undefined;
        if (object.timestamp !== undefined && object.timestamp !== null) message.timestamp = object.timestamp;
        else message.timestamp = undefined;
        if (object.signature !== undefined && object.signature !== null) message.signature = object.signature;
        else message.signature = new Uint8Array();
        return message;
    }
};
const $9b1c0733bff72dcb$var$baseSignedHeader = {};
module.exports.SignedHeader = {
    encode (message, writer = $9b1c0733bff72dcb$var$minimal_1.default.Writer.create()) {
        if (message.header !== undefined) module.exports.Header.encode(message.header, writer.uint32(10).fork()).ldelim();
        if (message.commit !== undefined) module.exports.Commit.encode(message.commit, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9b1c0733bff72dcb$var$minimal_1.default.Reader ? input : new $9b1c0733bff72dcb$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9b1c0733bff72dcb$var$baseSignedHeader);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.header = module.exports.Header.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.commit = module.exports.Commit.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9b1c0733bff72dcb$var$baseSignedHeader);
        if (object.header !== undefined && object.header !== null) message.header = module.exports.Header.fromJSON(object.header);
        else message.header = undefined;
        if (object.commit !== undefined && object.commit !== null) message.commit = module.exports.Commit.fromJSON(object.commit);
        else message.commit = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.header !== undefined && (obj.header = message.header ? module.exports.Header.toJSON(message.header) : undefined);
        message.commit !== undefined && (obj.commit = message.commit ? module.exports.Commit.toJSON(message.commit) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9b1c0733bff72dcb$var$baseSignedHeader);
        if (object.header !== undefined && object.header !== null) message.header = module.exports.Header.fromPartial(object.header);
        else message.header = undefined;
        if (object.commit !== undefined && object.commit !== null) message.commit = module.exports.Commit.fromPartial(object.commit);
        else message.commit = undefined;
        return message;
    }
};
const $9b1c0733bff72dcb$var$baseLightBlock = {};
module.exports.LightBlock = {
    encode (message, writer = $9b1c0733bff72dcb$var$minimal_1.default.Writer.create()) {
        if (message.signedHeader !== undefined) module.exports.SignedHeader.encode(message.signedHeader, writer.uint32(10).fork()).ldelim();
        if (message.validatorSet !== undefined) $j77DS.ValidatorSet.encode(message.validatorSet, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9b1c0733bff72dcb$var$minimal_1.default.Reader ? input : new $9b1c0733bff72dcb$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9b1c0733bff72dcb$var$baseLightBlock);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signedHeader = module.exports.SignedHeader.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.validatorSet = $j77DS.ValidatorSet.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9b1c0733bff72dcb$var$baseLightBlock);
        if (object.signedHeader !== undefined && object.signedHeader !== null) message.signedHeader = module.exports.SignedHeader.fromJSON(object.signedHeader);
        else message.signedHeader = undefined;
        if (object.validatorSet !== undefined && object.validatorSet !== null) message.validatorSet = $j77DS.ValidatorSet.fromJSON(object.validatorSet);
        else message.validatorSet = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.signedHeader !== undefined && (obj.signedHeader = message.signedHeader ? module.exports.SignedHeader.toJSON(message.signedHeader) : undefined);
        message.validatorSet !== undefined && (obj.validatorSet = message.validatorSet ? $j77DS.ValidatorSet.toJSON(message.validatorSet) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9b1c0733bff72dcb$var$baseLightBlock);
        if (object.signedHeader !== undefined && object.signedHeader !== null) message.signedHeader = module.exports.SignedHeader.fromPartial(object.signedHeader);
        else message.signedHeader = undefined;
        if (object.validatorSet !== undefined && object.validatorSet !== null) message.validatorSet = $j77DS.ValidatorSet.fromPartial(object.validatorSet);
        else message.validatorSet = undefined;
        return message;
    }
};
const $9b1c0733bff72dcb$var$baseBlockMeta = {
    blockSize: $9b1c0733bff72dcb$var$long_1.default.ZERO,
    numTxs: $9b1c0733bff72dcb$var$long_1.default.ZERO
};
module.exports.BlockMeta = {
    encode (message, writer = $9b1c0733bff72dcb$var$minimal_1.default.Writer.create()) {
        if (message.blockId !== undefined) module.exports.BlockID.encode(message.blockId, writer.uint32(10).fork()).ldelim();
        if (!message.blockSize.isZero()) writer.uint32(16).int64(message.blockSize);
        if (message.header !== undefined) module.exports.Header.encode(message.header, writer.uint32(26).fork()).ldelim();
        if (!message.numTxs.isZero()) writer.uint32(32).int64(message.numTxs);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9b1c0733bff72dcb$var$minimal_1.default.Reader ? input : new $9b1c0733bff72dcb$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9b1c0733bff72dcb$var$baseBlockMeta);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.blockId = module.exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.blockSize = reader.int64();
                    break;
                case 3:
                    message.header = module.exports.Header.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.numTxs = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9b1c0733bff72dcb$var$baseBlockMeta);
        if (object.blockId !== undefined && object.blockId !== null) message.blockId = module.exports.BlockID.fromJSON(object.blockId);
        else message.blockId = undefined;
        if (object.blockSize !== undefined && object.blockSize !== null) message.blockSize = $9b1c0733bff72dcb$var$long_1.default.fromString(object.blockSize);
        else message.blockSize = $9b1c0733bff72dcb$var$long_1.default.ZERO;
        if (object.header !== undefined && object.header !== null) message.header = module.exports.Header.fromJSON(object.header);
        else message.header = undefined;
        if (object.numTxs !== undefined && object.numTxs !== null) message.numTxs = $9b1c0733bff72dcb$var$long_1.default.fromString(object.numTxs);
        else message.numTxs = $9b1c0733bff72dcb$var$long_1.default.ZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.blockId !== undefined && (obj.blockId = message.blockId ? module.exports.BlockID.toJSON(message.blockId) : undefined);
        message.blockSize !== undefined && (obj.blockSize = (message.blockSize || $9b1c0733bff72dcb$var$long_1.default.ZERO).toString());
        message.header !== undefined && (obj.header = message.header ? module.exports.Header.toJSON(message.header) : undefined);
        message.numTxs !== undefined && (obj.numTxs = (message.numTxs || $9b1c0733bff72dcb$var$long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9b1c0733bff72dcb$var$baseBlockMeta);
        if (object.blockId !== undefined && object.blockId !== null) message.blockId = module.exports.BlockID.fromPartial(object.blockId);
        else message.blockId = undefined;
        if (object.blockSize !== undefined && object.blockSize !== null) message.blockSize = object.blockSize;
        else message.blockSize = $9b1c0733bff72dcb$var$long_1.default.ZERO;
        if (object.header !== undefined && object.header !== null) message.header = module.exports.Header.fromPartial(object.header);
        else message.header = undefined;
        if (object.numTxs !== undefined && object.numTxs !== null) message.numTxs = object.numTxs;
        else message.numTxs = $9b1c0733bff72dcb$var$long_1.default.ZERO;
        return message;
    }
};
const $9b1c0733bff72dcb$var$baseTxProof = {};
module.exports.TxProof = {
    encode (message, writer = $9b1c0733bff72dcb$var$minimal_1.default.Writer.create()) {
        if (message.rootHash.length !== 0) writer.uint32(10).bytes(message.rootHash);
        if (message.data.length !== 0) writer.uint32(18).bytes(message.data);
        if (message.proof !== undefined) $eIxyR.Proof.encode(message.proof, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9b1c0733bff72dcb$var$minimal_1.default.Reader ? input : new $9b1c0733bff72dcb$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9b1c0733bff72dcb$var$baseTxProof);
        message.rootHash = new Uint8Array();
        message.data = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.rootHash = reader.bytes();
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                case 3:
                    message.proof = $eIxyR.Proof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9b1c0733bff72dcb$var$baseTxProof);
        message.rootHash = new Uint8Array();
        message.data = new Uint8Array();
        if (object.rootHash !== undefined && object.rootHash !== null) message.rootHash = $9b1c0733bff72dcb$var$bytesFromBase64(object.rootHash);
        if (object.data !== undefined && object.data !== null) message.data = $9b1c0733bff72dcb$var$bytesFromBase64(object.data);
        if (object.proof !== undefined && object.proof !== null) message.proof = $eIxyR.Proof.fromJSON(object.proof);
        else message.proof = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.rootHash !== undefined && (obj.rootHash = $9b1c0733bff72dcb$var$base64FromBytes(message.rootHash !== undefined ? message.rootHash : new Uint8Array()));
        message.data !== undefined && (obj.data = $9b1c0733bff72dcb$var$base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        message.proof !== undefined && (obj.proof = message.proof ? $eIxyR.Proof.toJSON(message.proof) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9b1c0733bff72dcb$var$baseTxProof);
        if (object.rootHash !== undefined && object.rootHash !== null) message.rootHash = object.rootHash;
        else message.rootHash = new Uint8Array();
        if (object.data !== undefined && object.data !== null) message.data = object.data;
        else message.data = new Uint8Array();
        if (object.proof !== undefined && object.proof !== null) message.proof = $eIxyR.Proof.fromPartial(object.proof);
        else message.proof = undefined;
        return message;
    }
};
var $9b1c0733bff72dcb$var$globalThis = (()=>{
    if (typeof $9b1c0733bff72dcb$var$globalThis !== "undefined") return $9b1c0733bff72dcb$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $9b1c0733bff72dcb$var$atob = $9b1c0733bff72dcb$var$globalThis.atob || ((b64)=>$9b1c0733bff72dcb$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $9b1c0733bff72dcb$var$bytesFromBase64(b64) {
    const bin = $9b1c0733bff72dcb$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $9b1c0733bff72dcb$var$btoa = $9b1c0733bff72dcb$var$globalThis.btoa || ((bin)=>$9b1c0733bff72dcb$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $9b1c0733bff72dcb$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $9b1c0733bff72dcb$var$btoa(bin.join(""));
}
function $9b1c0733bff72dcb$var$toTimestamp(date) {
    const seconds = $9b1c0733bff72dcb$var$numberToLong(date.getTime() / 1000);
    const nanos = date.getTime() % 1000 * 1000000;
    return {
        seconds: seconds,
        nanos: nanos
    };
}
function $9b1c0733bff72dcb$var$fromTimestamp(t) {
    let millis = t.seconds.toNumber() * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function $9b1c0733bff72dcb$var$fromJsonTimestamp(o) {
    if (o instanceof Date) return o;
    else if (typeof o === "string") return new Date(o);
    else return $9b1c0733bff72dcb$var$fromTimestamp($5G2s6.Timestamp.fromJSON(o));
}
function $9b1c0733bff72dcb$var$numberToLong(number) {
    return $9b1c0733bff72dcb$var$long_1.default.fromNumber(number);
}
if ($9b1c0733bff72dcb$var$minimal_1.default.util.Long !== $9b1c0733bff72dcb$var$long_1.default) {
    $9b1c0733bff72dcb$var$minimal_1.default.util.Long = $9b1c0733bff72dcb$var$long_1.default;
    $9b1c0733bff72dcb$var$minimal_1.default.configure();
}

});
parcelRegister("eIxyR", function(module, exports) {
"use strict";
var $ab6f35568b4389e9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProofOps = module.exports.ProofOp = module.exports.DominoOp = module.exports.ValueOp = module.exports.Proof = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $ab6f35568b4389e9$var$long_1 = $ab6f35568b4389e9$var$__importDefault((parcelRequire("9A55m")));

const $ab6f35568b4389e9$var$minimal_1 = $ab6f35568b4389e9$var$__importDefault((parcelRequire("i2pIU")));
module.exports.protobufPackage = "tendermint.crypto";
const $ab6f35568b4389e9$var$baseProof = {
    total: $ab6f35568b4389e9$var$long_1.default.ZERO,
    index: $ab6f35568b4389e9$var$long_1.default.ZERO
};
module.exports.Proof = {
    encode (message, writer = $ab6f35568b4389e9$var$minimal_1.default.Writer.create()) {
        if (!message.total.isZero()) writer.uint32(8).int64(message.total);
        if (!message.index.isZero()) writer.uint32(16).int64(message.index);
        if (message.leafHash.length !== 0) writer.uint32(26).bytes(message.leafHash);
        for (const v of message.aunts)writer.uint32(34).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ab6f35568b4389e9$var$minimal_1.default.Reader ? input : new $ab6f35568b4389e9$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ab6f35568b4389e9$var$baseProof);
        message.aunts = [];
        message.leafHash = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.total = reader.int64();
                    break;
                case 2:
                    message.index = reader.int64();
                    break;
                case 3:
                    message.leafHash = reader.bytes();
                    break;
                case 4:
                    message.aunts.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ab6f35568b4389e9$var$baseProof);
        message.aunts = [];
        message.leafHash = new Uint8Array();
        if (object.total !== undefined && object.total !== null) message.total = $ab6f35568b4389e9$var$long_1.default.fromString(object.total);
        else message.total = $ab6f35568b4389e9$var$long_1.default.ZERO;
        if (object.index !== undefined && object.index !== null) message.index = $ab6f35568b4389e9$var$long_1.default.fromString(object.index);
        else message.index = $ab6f35568b4389e9$var$long_1.default.ZERO;
        if (object.leafHash !== undefined && object.leafHash !== null) message.leafHash = $ab6f35568b4389e9$var$bytesFromBase64(object.leafHash);
        if (object.aunts !== undefined && object.aunts !== null) for (const e of object.aunts)message.aunts.push($ab6f35568b4389e9$var$bytesFromBase64(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.total !== undefined && (obj.total = (message.total || $ab6f35568b4389e9$var$long_1.default.ZERO).toString());
        message.index !== undefined && (obj.index = (message.index || $ab6f35568b4389e9$var$long_1.default.ZERO).toString());
        message.leafHash !== undefined && (obj.leafHash = $ab6f35568b4389e9$var$base64FromBytes(message.leafHash !== undefined ? message.leafHash : new Uint8Array()));
        if (message.aunts) obj.aunts = message.aunts.map((e)=>$ab6f35568b4389e9$var$base64FromBytes(e !== undefined ? e : new Uint8Array()));
        else obj.aunts = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ab6f35568b4389e9$var$baseProof);
        message.aunts = [];
        if (object.total !== undefined && object.total !== null) message.total = object.total;
        else message.total = $ab6f35568b4389e9$var$long_1.default.ZERO;
        if (object.index !== undefined && object.index !== null) message.index = object.index;
        else message.index = $ab6f35568b4389e9$var$long_1.default.ZERO;
        if (object.leafHash !== undefined && object.leafHash !== null) message.leafHash = object.leafHash;
        else message.leafHash = new Uint8Array();
        if (object.aunts !== undefined && object.aunts !== null) for (const e of object.aunts)message.aunts.push(e);
        return message;
    }
};
const $ab6f35568b4389e9$var$baseValueOp = {};
module.exports.ValueOp = {
    encode (message, writer = $ab6f35568b4389e9$var$minimal_1.default.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (message.proof !== undefined) module.exports.Proof.encode(message.proof, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ab6f35568b4389e9$var$minimal_1.default.Reader ? input : new $ab6f35568b4389e9$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ab6f35568b4389e9$var$baseValueOp);
        message.key = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.proof = module.exports.Proof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ab6f35568b4389e9$var$baseValueOp);
        message.key = new Uint8Array();
        if (object.key !== undefined && object.key !== null) message.key = $ab6f35568b4389e9$var$bytesFromBase64(object.key);
        if (object.proof !== undefined && object.proof !== null) message.proof = module.exports.Proof.fromJSON(object.proof);
        else message.proof = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = $ab6f35568b4389e9$var$base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        message.proof !== undefined && (obj.proof = message.proof ? module.exports.Proof.toJSON(message.proof) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ab6f35568b4389e9$var$baseValueOp);
        if (object.key !== undefined && object.key !== null) message.key = object.key;
        else message.key = new Uint8Array();
        if (object.proof !== undefined && object.proof !== null) message.proof = module.exports.Proof.fromPartial(object.proof);
        else message.proof = undefined;
        return message;
    }
};
const $ab6f35568b4389e9$var$baseDominoOp = {
    key: "",
    input: "",
    output: ""
};
module.exports.DominoOp = {
    encode (message, writer = $ab6f35568b4389e9$var$minimal_1.default.Writer.create()) {
        if (message.key !== "") writer.uint32(10).string(message.key);
        if (message.input !== "") writer.uint32(18).string(message.input);
        if (message.output !== "") writer.uint32(26).string(message.output);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ab6f35568b4389e9$var$minimal_1.default.Reader ? input : new $ab6f35568b4389e9$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ab6f35568b4389e9$var$baseDominoOp);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.input = reader.string();
                    break;
                case 3:
                    message.output = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ab6f35568b4389e9$var$baseDominoOp);
        if (object.key !== undefined && object.key !== null) message.key = String(object.key);
        else message.key = "";
        if (object.input !== undefined && object.input !== null) message.input = String(object.input);
        else message.input = "";
        if (object.output !== undefined && object.output !== null) message.output = String(object.output);
        else message.output = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = message.key);
        message.input !== undefined && (obj.input = message.input);
        message.output !== undefined && (obj.output = message.output);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ab6f35568b4389e9$var$baseDominoOp);
        if (object.key !== undefined && object.key !== null) message.key = object.key;
        else message.key = "";
        if (object.input !== undefined && object.input !== null) message.input = object.input;
        else message.input = "";
        if (object.output !== undefined && object.output !== null) message.output = object.output;
        else message.output = "";
        return message;
    }
};
const $ab6f35568b4389e9$var$baseProofOp = {
    type: ""
};
module.exports.ProofOp = {
    encode (message, writer = $ab6f35568b4389e9$var$minimal_1.default.Writer.create()) {
        if (message.type !== "") writer.uint32(10).string(message.type);
        if (message.key.length !== 0) writer.uint32(18).bytes(message.key);
        if (message.data.length !== 0) writer.uint32(26).bytes(message.data);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ab6f35568b4389e9$var$minimal_1.default.Reader ? input : new $ab6f35568b4389e9$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ab6f35568b4389e9$var$baseProofOp);
        message.key = new Uint8Array();
        message.data = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.string();
                    break;
                case 2:
                    message.key = reader.bytes();
                    break;
                case 3:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ab6f35568b4389e9$var$baseProofOp);
        message.key = new Uint8Array();
        message.data = new Uint8Array();
        if (object.type !== undefined && object.type !== null) message.type = String(object.type);
        else message.type = "";
        if (object.key !== undefined && object.key !== null) message.key = $ab6f35568b4389e9$var$bytesFromBase64(object.key);
        if (object.data !== undefined && object.data !== null) message.data = $ab6f35568b4389e9$var$bytesFromBase64(object.data);
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.type !== undefined && (obj.type = message.type);
        message.key !== undefined && (obj.key = $ab6f35568b4389e9$var$base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        message.data !== undefined && (obj.data = $ab6f35568b4389e9$var$base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ab6f35568b4389e9$var$baseProofOp);
        if (object.type !== undefined && object.type !== null) message.type = object.type;
        else message.type = "";
        if (object.key !== undefined && object.key !== null) message.key = object.key;
        else message.key = new Uint8Array();
        if (object.data !== undefined && object.data !== null) message.data = object.data;
        else message.data = new Uint8Array();
        return message;
    }
};
const $ab6f35568b4389e9$var$baseProofOps = {};
module.exports.ProofOps = {
    encode (message, writer = $ab6f35568b4389e9$var$minimal_1.default.Writer.create()) {
        for (const v of message.ops)module.exports.ProofOp.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ab6f35568b4389e9$var$minimal_1.default.Reader ? input : new $ab6f35568b4389e9$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ab6f35568b4389e9$var$baseProofOps);
        message.ops = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.ops.push(module.exports.ProofOp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ab6f35568b4389e9$var$baseProofOps);
        message.ops = [];
        if (object.ops !== undefined && object.ops !== null) for (const e of object.ops)message.ops.push(module.exports.ProofOp.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.ops) obj.ops = message.ops.map((e)=>e ? module.exports.ProofOp.toJSON(e) : undefined);
        else obj.ops = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ab6f35568b4389e9$var$baseProofOps);
        message.ops = [];
        if (object.ops !== undefined && object.ops !== null) for (const e of object.ops)message.ops.push(module.exports.ProofOp.fromPartial(e));
        return message;
    }
};
var $ab6f35568b4389e9$var$globalThis = (()=>{
    if (typeof $ab6f35568b4389e9$var$globalThis !== "undefined") return $ab6f35568b4389e9$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $ab6f35568b4389e9$var$atob = $ab6f35568b4389e9$var$globalThis.atob || ((b64)=>$ab6f35568b4389e9$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $ab6f35568b4389e9$var$bytesFromBase64(b64) {
    const bin = $ab6f35568b4389e9$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $ab6f35568b4389e9$var$btoa = $ab6f35568b4389e9$var$globalThis.btoa || ((bin)=>$ab6f35568b4389e9$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $ab6f35568b4389e9$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $ab6f35568b4389e9$var$btoa(bin.join(""));
}
if ($ab6f35568b4389e9$var$minimal_1.default.util.Long !== $ab6f35568b4389e9$var$long_1.default) {
    $ab6f35568b4389e9$var$minimal_1.default.util.Long = $ab6f35568b4389e9$var$long_1.default;
    $ab6f35568b4389e9$var$minimal_1.default.configure();
}

});

parcelRegister("liJvN", function(module, exports) {
"use strict";
var $f81e9521ef702486$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Consensus = module.exports.App = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $f81e9521ef702486$var$long_1 = $f81e9521ef702486$var$__importDefault((parcelRequire("9A55m")));

const $f81e9521ef702486$var$minimal_1 = $f81e9521ef702486$var$__importDefault((parcelRequire("i2pIU")));
module.exports.protobufPackage = "tendermint.version";
const $f81e9521ef702486$var$baseApp = {
    protocol: $f81e9521ef702486$var$long_1.default.UZERO,
    software: ""
};
module.exports.App = {
    encode (message, writer = $f81e9521ef702486$var$minimal_1.default.Writer.create()) {
        if (!message.protocol.isZero()) writer.uint32(8).uint64(message.protocol);
        if (message.software !== "") writer.uint32(18).string(message.software);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f81e9521ef702486$var$minimal_1.default.Reader ? input : new $f81e9521ef702486$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $f81e9521ef702486$var$baseApp);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.protocol = reader.uint64();
                    break;
                case 2:
                    message.software = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $f81e9521ef702486$var$baseApp);
        if (object.protocol !== undefined && object.protocol !== null) message.protocol = $f81e9521ef702486$var$long_1.default.fromString(object.protocol);
        else message.protocol = $f81e9521ef702486$var$long_1.default.UZERO;
        if (object.software !== undefined && object.software !== null) message.software = String(object.software);
        else message.software = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.protocol !== undefined && (obj.protocol = (message.protocol || $f81e9521ef702486$var$long_1.default.UZERO).toString());
        message.software !== undefined && (obj.software = message.software);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $f81e9521ef702486$var$baseApp);
        if (object.protocol !== undefined && object.protocol !== null) message.protocol = object.protocol;
        else message.protocol = $f81e9521ef702486$var$long_1.default.UZERO;
        if (object.software !== undefined && object.software !== null) message.software = object.software;
        else message.software = "";
        return message;
    }
};
const $f81e9521ef702486$var$baseConsensus = {
    block: $f81e9521ef702486$var$long_1.default.UZERO,
    app: $f81e9521ef702486$var$long_1.default.UZERO
};
module.exports.Consensus = {
    encode (message, writer = $f81e9521ef702486$var$minimal_1.default.Writer.create()) {
        if (!message.block.isZero()) writer.uint32(8).uint64(message.block);
        if (!message.app.isZero()) writer.uint32(16).uint64(message.app);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f81e9521ef702486$var$minimal_1.default.Reader ? input : new $f81e9521ef702486$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $f81e9521ef702486$var$baseConsensus);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.block = reader.uint64();
                    break;
                case 2:
                    message.app = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $f81e9521ef702486$var$baseConsensus);
        if (object.block !== undefined && object.block !== null) message.block = $f81e9521ef702486$var$long_1.default.fromString(object.block);
        else message.block = $f81e9521ef702486$var$long_1.default.UZERO;
        if (object.app !== undefined && object.app !== null) message.app = $f81e9521ef702486$var$long_1.default.fromString(object.app);
        else message.app = $f81e9521ef702486$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.block !== undefined && (obj.block = (message.block || $f81e9521ef702486$var$long_1.default.UZERO).toString());
        message.app !== undefined && (obj.app = (message.app || $f81e9521ef702486$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $f81e9521ef702486$var$baseConsensus);
        if (object.block !== undefined && object.block !== null) message.block = object.block;
        else message.block = $f81e9521ef702486$var$long_1.default.UZERO;
        if (object.app !== undefined && object.app !== null) message.app = object.app;
        else message.app = $f81e9521ef702486$var$long_1.default.UZERO;
        return message;
    }
};
if ($f81e9521ef702486$var$minimal_1.default.util.Long !== $f81e9521ef702486$var$long_1.default) {
    $f81e9521ef702486$var$minimal_1.default.util.Long = $f81e9521ef702486$var$long_1.default;
    $f81e9521ef702486$var$minimal_1.default.configure();
}

});

parcelRegister("j77DS", function(module, exports) {
"use strict";
var $dea499551e7ab724$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SimpleValidator = module.exports.Validator = module.exports.ValidatorSet = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $dea499551e7ab724$var$long_1 = $dea499551e7ab724$var$__importDefault((parcelRequire("9A55m")));

const $dea499551e7ab724$var$minimal_1 = $dea499551e7ab724$var$__importDefault((parcelRequire("i2pIU")));

var $a0zXC = parcelRequire("a0zXC");
module.exports.protobufPackage = "tendermint.types";
const $dea499551e7ab724$var$baseValidatorSet = {
    totalVotingPower: $dea499551e7ab724$var$long_1.default.ZERO
};
module.exports.ValidatorSet = {
    encode (message, writer = $dea499551e7ab724$var$minimal_1.default.Writer.create()) {
        for (const v of message.validators)module.exports.Validator.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.proposer !== undefined) module.exports.Validator.encode(message.proposer, writer.uint32(18).fork()).ldelim();
        if (!message.totalVotingPower.isZero()) writer.uint32(24).int64(message.totalVotingPower);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $dea499551e7ab724$var$minimal_1.default.Reader ? input : new $dea499551e7ab724$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $dea499551e7ab724$var$baseValidatorSet);
        message.validators = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validators.push(module.exports.Validator.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.proposer = module.exports.Validator.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.totalVotingPower = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $dea499551e7ab724$var$baseValidatorSet);
        message.validators = [];
        if (object.validators !== undefined && object.validators !== null) for (const e of object.validators)message.validators.push(module.exports.Validator.fromJSON(e));
        if (object.proposer !== undefined && object.proposer !== null) message.proposer = module.exports.Validator.fromJSON(object.proposer);
        else message.proposer = undefined;
        if (object.totalVotingPower !== undefined && object.totalVotingPower !== null) message.totalVotingPower = $dea499551e7ab724$var$long_1.default.fromString(object.totalVotingPower);
        else message.totalVotingPower = $dea499551e7ab724$var$long_1.default.ZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.validators) obj.validators = message.validators.map((e)=>e ? module.exports.Validator.toJSON(e) : undefined);
        else obj.validators = [];
        message.proposer !== undefined && (obj.proposer = message.proposer ? module.exports.Validator.toJSON(message.proposer) : undefined);
        message.totalVotingPower !== undefined && (obj.totalVotingPower = (message.totalVotingPower || $dea499551e7ab724$var$long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $dea499551e7ab724$var$baseValidatorSet);
        message.validators = [];
        if (object.validators !== undefined && object.validators !== null) for (const e of object.validators)message.validators.push(module.exports.Validator.fromPartial(e));
        if (object.proposer !== undefined && object.proposer !== null) message.proposer = module.exports.Validator.fromPartial(object.proposer);
        else message.proposer = undefined;
        if (object.totalVotingPower !== undefined && object.totalVotingPower !== null) message.totalVotingPower = object.totalVotingPower;
        else message.totalVotingPower = $dea499551e7ab724$var$long_1.default.ZERO;
        return message;
    }
};
const $dea499551e7ab724$var$baseValidator = {
    votingPower: $dea499551e7ab724$var$long_1.default.ZERO,
    proposerPriority: $dea499551e7ab724$var$long_1.default.ZERO
};
module.exports.Validator = {
    encode (message, writer = $dea499551e7ab724$var$minimal_1.default.Writer.create()) {
        if (message.address.length !== 0) writer.uint32(10).bytes(message.address);
        if (message.pubKey !== undefined) $a0zXC.PublicKey.encode(message.pubKey, writer.uint32(18).fork()).ldelim();
        if (!message.votingPower.isZero()) writer.uint32(24).int64(message.votingPower);
        if (!message.proposerPriority.isZero()) writer.uint32(32).int64(message.proposerPriority);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $dea499551e7ab724$var$minimal_1.default.Reader ? input : new $dea499551e7ab724$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $dea499551e7ab724$var$baseValidator);
        message.address = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.bytes();
                    break;
                case 2:
                    message.pubKey = $a0zXC.PublicKey.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.votingPower = reader.int64();
                    break;
                case 4:
                    message.proposerPriority = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $dea499551e7ab724$var$baseValidator);
        message.address = new Uint8Array();
        if (object.address !== undefined && object.address !== null) message.address = $dea499551e7ab724$var$bytesFromBase64(object.address);
        if (object.pubKey !== undefined && object.pubKey !== null) message.pubKey = $a0zXC.PublicKey.fromJSON(object.pubKey);
        else message.pubKey = undefined;
        if (object.votingPower !== undefined && object.votingPower !== null) message.votingPower = $dea499551e7ab724$var$long_1.default.fromString(object.votingPower);
        else message.votingPower = $dea499551e7ab724$var$long_1.default.ZERO;
        if (object.proposerPriority !== undefined && object.proposerPriority !== null) message.proposerPriority = $dea499551e7ab724$var$long_1.default.fromString(object.proposerPriority);
        else message.proposerPriority = $dea499551e7ab724$var$long_1.default.ZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = $dea499551e7ab724$var$base64FromBytes(message.address !== undefined ? message.address : new Uint8Array()));
        message.pubKey !== undefined && (obj.pubKey = message.pubKey ? $a0zXC.PublicKey.toJSON(message.pubKey) : undefined);
        message.votingPower !== undefined && (obj.votingPower = (message.votingPower || $dea499551e7ab724$var$long_1.default.ZERO).toString());
        message.proposerPriority !== undefined && (obj.proposerPriority = (message.proposerPriority || $dea499551e7ab724$var$long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $dea499551e7ab724$var$baseValidator);
        if (object.address !== undefined && object.address !== null) message.address = object.address;
        else message.address = new Uint8Array();
        if (object.pubKey !== undefined && object.pubKey !== null) message.pubKey = $a0zXC.PublicKey.fromPartial(object.pubKey);
        else message.pubKey = undefined;
        if (object.votingPower !== undefined && object.votingPower !== null) message.votingPower = object.votingPower;
        else message.votingPower = $dea499551e7ab724$var$long_1.default.ZERO;
        if (object.proposerPriority !== undefined && object.proposerPriority !== null) message.proposerPriority = object.proposerPriority;
        else message.proposerPriority = $dea499551e7ab724$var$long_1.default.ZERO;
        return message;
    }
};
const $dea499551e7ab724$var$baseSimpleValidator = {
    votingPower: $dea499551e7ab724$var$long_1.default.ZERO
};
module.exports.SimpleValidator = {
    encode (message, writer = $dea499551e7ab724$var$minimal_1.default.Writer.create()) {
        if (message.pubKey !== undefined) $a0zXC.PublicKey.encode(message.pubKey, writer.uint32(10).fork()).ldelim();
        if (!message.votingPower.isZero()) writer.uint32(16).int64(message.votingPower);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $dea499551e7ab724$var$minimal_1.default.Reader ? input : new $dea499551e7ab724$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $dea499551e7ab724$var$baseSimpleValidator);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pubKey = $a0zXC.PublicKey.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.votingPower = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $dea499551e7ab724$var$baseSimpleValidator);
        if (object.pubKey !== undefined && object.pubKey !== null) message.pubKey = $a0zXC.PublicKey.fromJSON(object.pubKey);
        else message.pubKey = undefined;
        if (object.votingPower !== undefined && object.votingPower !== null) message.votingPower = $dea499551e7ab724$var$long_1.default.fromString(object.votingPower);
        else message.votingPower = $dea499551e7ab724$var$long_1.default.ZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.pubKey !== undefined && (obj.pubKey = message.pubKey ? $a0zXC.PublicKey.toJSON(message.pubKey) : undefined);
        message.votingPower !== undefined && (obj.votingPower = (message.votingPower || $dea499551e7ab724$var$long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $dea499551e7ab724$var$baseSimpleValidator);
        if (object.pubKey !== undefined && object.pubKey !== null) message.pubKey = $a0zXC.PublicKey.fromPartial(object.pubKey);
        else message.pubKey = undefined;
        if (object.votingPower !== undefined && object.votingPower !== null) message.votingPower = object.votingPower;
        else message.votingPower = $dea499551e7ab724$var$long_1.default.ZERO;
        return message;
    }
};
var $dea499551e7ab724$var$globalThis = (()=>{
    if (typeof $dea499551e7ab724$var$globalThis !== "undefined") return $dea499551e7ab724$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $dea499551e7ab724$var$atob = $dea499551e7ab724$var$globalThis.atob || ((b64)=>$dea499551e7ab724$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $dea499551e7ab724$var$bytesFromBase64(b64) {
    const bin = $dea499551e7ab724$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $dea499551e7ab724$var$btoa = $dea499551e7ab724$var$globalThis.btoa || ((bin)=>$dea499551e7ab724$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $dea499551e7ab724$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $dea499551e7ab724$var$btoa(bin.join(""));
}
if ($dea499551e7ab724$var$minimal_1.default.util.Long !== $dea499551e7ab724$var$long_1.default) {
    $dea499551e7ab724$var$minimal_1.default.util.Long = $dea499551e7ab724$var$long_1.default;
    $dea499551e7ab724$var$minimal_1.default.configure();
}

});
parcelRegister("a0zXC", function(module, exports) {
"use strict";
var $7495cc7e4c192b2b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PublicKey = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $7495cc7e4c192b2b$var$long_1 = $7495cc7e4c192b2b$var$__importDefault((parcelRequire("9A55m")));

const $7495cc7e4c192b2b$var$minimal_1 = $7495cc7e4c192b2b$var$__importDefault((parcelRequire("i2pIU")));
module.exports.protobufPackage = "tendermint.crypto";
const $7495cc7e4c192b2b$var$basePublicKey = {};
module.exports.PublicKey = {
    encode (message, writer = $7495cc7e4c192b2b$var$minimal_1.default.Writer.create()) {
        if (message.ed25519 !== undefined) writer.uint32(10).bytes(message.ed25519);
        if (message.secp256k1 !== undefined) writer.uint32(18).bytes(message.secp256k1);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7495cc7e4c192b2b$var$minimal_1.default.Reader ? input : new $7495cc7e4c192b2b$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $7495cc7e4c192b2b$var$basePublicKey);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.ed25519 = reader.bytes();
                    break;
                case 2:
                    message.secp256k1 = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $7495cc7e4c192b2b$var$basePublicKey);
        if (object.ed25519 !== undefined && object.ed25519 !== null) message.ed25519 = $7495cc7e4c192b2b$var$bytesFromBase64(object.ed25519);
        if (object.secp256k1 !== undefined && object.secp256k1 !== null) message.secp256k1 = $7495cc7e4c192b2b$var$bytesFromBase64(object.secp256k1);
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.ed25519 !== undefined && (obj.ed25519 = message.ed25519 !== undefined ? $7495cc7e4c192b2b$var$base64FromBytes(message.ed25519) : undefined);
        message.secp256k1 !== undefined && (obj.secp256k1 = message.secp256k1 !== undefined ? $7495cc7e4c192b2b$var$base64FromBytes(message.secp256k1) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $7495cc7e4c192b2b$var$basePublicKey);
        if (object.ed25519 !== undefined && object.ed25519 !== null) message.ed25519 = object.ed25519;
        else message.ed25519 = undefined;
        if (object.secp256k1 !== undefined && object.secp256k1 !== null) message.secp256k1 = object.secp256k1;
        else message.secp256k1 = undefined;
        return message;
    }
};
var $7495cc7e4c192b2b$var$globalThis = (()=>{
    if (typeof $7495cc7e4c192b2b$var$globalThis !== "undefined") return $7495cc7e4c192b2b$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $7495cc7e4c192b2b$var$atob = $7495cc7e4c192b2b$var$globalThis.atob || ((b64)=>$7495cc7e4c192b2b$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $7495cc7e4c192b2b$var$bytesFromBase64(b64) {
    const bin = $7495cc7e4c192b2b$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $7495cc7e4c192b2b$var$btoa = $7495cc7e4c192b2b$var$globalThis.btoa || ((bin)=>$7495cc7e4c192b2b$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $7495cc7e4c192b2b$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $7495cc7e4c192b2b$var$btoa(bin.join(""));
}
if ($7495cc7e4c192b2b$var$minimal_1.default.util.Long !== $7495cc7e4c192b2b$var$long_1.default) {
    $7495cc7e4c192b2b$var$minimal_1.default.util.Long = $7495cc7e4c192b2b$var$long_1.default;
    $7495cc7e4c192b2b$var$minimal_1.default.configure();
}

});






parcelRegister("1n8so", function(module, exports) {
"use strict";
var $0ffe7fc83fe21050$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgUndelegate = void 0;

var $7yVzo = parcelRequire("7yVzo");

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $84C3k = parcelRequire("84C3k");
/**
 * A delegator can undelegate an amount of bonded Luna, and will begin the unbonding
 * process for those funds. The unbonding process takes 21 days to complete, during
 * which the Luna cannot be transacted or swapped.
 */ var $0ffe7fc83fe21050$var$MsgUndelegate = /** @class */ function(_super) {
    $0ffe7fc83fe21050$var$__extends(MsgUndelegate, _super);
    /**
     * @param delegator_address delegator's account address
     * @param validator_address validator's operator address
     * @param amount Luna to be undelegated
     */ function MsgUndelegate(delegator_address, validator_address, amount) {
        var _this = _super.call(this) || this;
        _this.delegator_address = delegator_address;
        _this.validator_address = validator_address;
        _this.amount = amount;
        return _this;
    }
    MsgUndelegate.fromAmino = function(data, _) {
        _;
        var _a = data.value, delegator_address = _a.delegator_address, validator_address = _a.validator_address, amount = _a.amount;
        return new MsgUndelegate(delegator_address, validator_address, $7yVzo.Coin.fromAmino(amount));
    };
    MsgUndelegate.prototype.toAmino = function(isClassic) {
        var _a = this, delegator_address = _a.delegator_address, validator_address = _a.validator_address, amount = _a.amount;
        return {
            type: isClassic ? "staking/MsgUndelegate" : "cosmos-sdk/MsgUndelegate",
            value: {
                delegator_address: delegator_address,
                validator_address: validator_address,
                amount: amount.toAmino()
            }
        };
    };
    MsgUndelegate.fromProto = function(proto, _) {
        _;
        return new MsgUndelegate(proto.delegatorAddress, proto.validatorAddress, $7yVzo.Coin.fromProto(proto.amount));
    };
    MsgUndelegate.prototype.toProto = function(_) {
        _;
        var _a = this, delegator_address = _a.delegator_address, validator_address = _a.validator_address, amount = _a.amount;
        return $84C3k.MsgUndelegate.fromPartial({
            amount: amount.toProto(),
            delegatorAddress: delegator_address,
            validatorAddress: validator_address
        });
    };
    MsgUndelegate.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmos.staking.v1beta1.MsgUndelegate",
            value: $84C3k.MsgUndelegate.encode(this.toProto(isClassic)).finish()
        });
    };
    MsgUndelegate.unpackAny = function(msgAny, isClassic) {
        return MsgUndelegate.fromProto($84C3k.MsgUndelegate.decode(msgAny.value), isClassic);
    };
    MsgUndelegate.fromData = function(data, _) {
        _;
        var delegator_address = data.delegator_address, validator_address = data.validator_address, amount = data.amount;
        return new MsgUndelegate(delegator_address, validator_address, $7yVzo.Coin.fromData(amount));
    };
    MsgUndelegate.prototype.toData = function(_) {
        _;
        var _a = this, delegator_address = _a.delegator_address, validator_address = _a.validator_address, amount = _a.amount;
        return {
            "@type": "/cosmos.staking.v1beta1.MsgUndelegate",
            delegator_address: delegator_address,
            validator_address: validator_address,
            amount: amount.toData()
        };
    };
    return MsgUndelegate;
}($26Eqx.JSONSerializable);
module.exports.MsgUndelegate = $0ffe7fc83fe21050$var$MsgUndelegate;

});

parcelRegister("5TsZK", function(module, exports) {
"use strict";
var $44a89497aba29aea$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgBeginRedelegate = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $7yVzo = parcelRequire("7yVzo");

var $c5FxR = parcelRequire("c5FxR");

var $84C3k = parcelRequire("84C3k");
/**
 * A delegator can choose to redelegate their bonded Luna and transfer a delegation
 * amount from one validator to another. Unlike undelegating, redelegations do not incur
 * a 21-day unbonding period and happen immediately.
 */ var $44a89497aba29aea$var$MsgBeginRedelegate = /** @class */ function(_super) {
    $44a89497aba29aea$var$__extends(MsgBeginRedelegate, _super);
    /**
     *
     * @param delegator_address delegator's account address
     * @param validator_src_address validator to undelegate from
     * @param validator_dst_address validator to delegate to
     * @param amount LUNA to be redelegated
     */ function MsgBeginRedelegate(delegator_address, validator_src_address, validator_dst_address, amount) {
        var _this = _super.call(this) || this;
        _this.delegator_address = delegator_address;
        _this.validator_src_address = validator_src_address;
        _this.validator_dst_address = validator_dst_address;
        _this.amount = amount;
        return _this;
    }
    MsgBeginRedelegate.fromAmino = function(data, _) {
        _;
        var _a = data.value, delegator_address = _a.delegator_address, validator_src_address = _a.validator_src_address, validator_dst_address = _a.validator_dst_address, amount = _a.amount;
        return new MsgBeginRedelegate(delegator_address, validator_src_address, validator_dst_address, $7yVzo.Coin.fromAmino(amount));
    };
    MsgBeginRedelegate.prototype.toAmino = function(isClassic) {
        var _a = this, delegator_address = _a.delegator_address, validator_src_address = _a.validator_src_address, validator_dst_address = _a.validator_dst_address, amount = _a.amount;
        return {
            type: isClassic ? "staking/MsgBeginRedelegate" : "cosmos-sdk/MsgBeginRedelegate",
            value: {
                delegator_address: delegator_address,
                validator_src_address: validator_src_address,
                validator_dst_address: validator_dst_address,
                amount: amount.toAmino()
            }
        };
    };
    MsgBeginRedelegate.fromData = function(data, _) {
        _;
        var delegator_address = data.delegator_address, validator_src_address = data.validator_src_address, validator_dst_address = data.validator_dst_address, amount = data.amount;
        return new MsgBeginRedelegate(delegator_address, validator_src_address, validator_dst_address, $7yVzo.Coin.fromData(amount));
    };
    MsgBeginRedelegate.prototype.toData = function(_) {
        _;
        var _a = this, delegator_address = _a.delegator_address, validator_src_address = _a.validator_src_address, validator_dst_address = _a.validator_dst_address, amount = _a.amount;
        return {
            "@type": "/cosmos.staking.v1beta1.MsgBeginRedelegate",
            delegator_address: delegator_address,
            validator_src_address: validator_src_address,
            validator_dst_address: validator_dst_address,
            amount: amount.toData()
        };
    };
    MsgBeginRedelegate.fromProto = function(proto, _) {
        _;
        return new MsgBeginRedelegate(proto.delegatorAddress, proto.validatorSrcAddress, proto.validatorDstAddress, $7yVzo.Coin.fromProto(proto.amount));
    };
    MsgBeginRedelegate.prototype.toProto = function(_) {
        _;
        var _a = this, delegator_address = _a.delegator_address, validator_src_address = _a.validator_src_address, validator_dst_address = _a.validator_dst_address, amount = _a.amount;
        return $84C3k.MsgBeginRedelegate.fromPartial({
            amount: amount.toProto(),
            delegatorAddress: delegator_address,
            validatorDstAddress: validator_dst_address,
            validatorSrcAddress: validator_src_address
        });
    };
    MsgBeginRedelegate.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmos.staking.v1beta1.MsgBeginRedelegate",
            value: $84C3k.MsgBeginRedelegate.encode(this.toProto(isClassic)).finish()
        });
    };
    MsgBeginRedelegate.unpackAny = function(msgAny, isClassic) {
        return MsgBeginRedelegate.fromProto($84C3k.MsgBeginRedelegate.decode(msgAny.value), isClassic);
    };
    return MsgBeginRedelegate;
}($26Eqx.JSONSerializable);
module.exports.MsgBeginRedelegate = $44a89497aba29aea$var$MsgBeginRedelegate;

});

parcelRegister("2PDID", function(module, exports) {
"use strict";
var $20ff278e907d6a78$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgCreateValidator = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $7yVzo = parcelRequire("7yVzo");

var $5iXRZ = parcelRequire("5iXRZ");

var $56eXa = parcelRequire("56eXa");

var $c5FxR = parcelRequire("c5FxR");

var $84C3k = parcelRequire("84C3k");

var $eVVZl = parcelRequire("eVVZl");
/**
 * For new validators, this message registers a validator address to be a delegate on
 * the blockchain.
 */ var $20ff278e907d6a78$var$MsgCreateValidator = /** @class */ function(_super) {
    $20ff278e907d6a78$var$__extends(MsgCreateValidator, _super);
    /**
     *
     * @param description validator's delegate information
     * @param commission validator's commission policy
     * @param min_self_delegation minimum self delegation
     * @param delegator_address validator's account address
     * @param validator_address validator's operator address
     * @param pubkey validator's consensus public key
     * @param value amount to use for self-delegation
     */ function MsgCreateValidator(description, commission, min_self_delegation, delegator_address, validator_address, pubkey, value) {
        var _this = _super.call(this) || this;
        _this.description = description;
        _this.commission = commission;
        _this.min_self_delegation = min_self_delegation;
        _this.delegator_address = delegator_address;
        _this.validator_address = validator_address;
        _this.pubkey = pubkey;
        _this.value = value;
        return _this;
    }
    MsgCreateValidator.fromAmino = function(data, _) {
        _;
        var _a = data.value, description = _a.description, commission = _a.commission, min_self_delegation = _a.min_self_delegation, delegator_address = _a.delegator_address, validator_address = _a.validator_address, pubkey = _a.pubkey, value = _a.value;
        return new MsgCreateValidator(description, $56eXa.Validator.CommissionRates.fromAmino(commission), new $5iXRZ.Int(min_self_delegation), delegator_address, validator_address, $eVVZl.ValConsPublicKey.fromAmino(pubkey), $7yVzo.Coin.fromAmino(value));
    };
    MsgCreateValidator.prototype.toAmino = function(isClassic) {
        var _a = this, description = _a.description, commission = _a.commission, min_self_delegation = _a.min_self_delegation, delegator_address = _a.delegator_address, validator_address = _a.validator_address, pubkey = _a.pubkey, value = _a.value;
        return {
            type: isClassic ? "staking/MsgCreateValidator" : "cosmos-sdk/MsgCreateValidator",
            value: {
                description: description,
                commission: commission.toAmino(),
                min_self_delegation: min_self_delegation.toString(),
                delegator_address: delegator_address,
                validator_address: validator_address,
                pubkey: pubkey.toAmino(),
                value: value.toAmino()
            }
        };
    };
    MsgCreateValidator.fromData = function(data, _) {
        _;
        var description = data.description, commission = data.commission, min_self_delegation = data.min_self_delegation, delegator_address = data.delegator_address, validator_address = data.validator_address, pubkey = data.pubkey, value = data.value;
        return new MsgCreateValidator(description, $56eXa.Validator.CommissionRates.fromData(commission), new $5iXRZ.Int(min_self_delegation), delegator_address, validator_address, $eVVZl.ValConsPublicKey.fromData(pubkey), $7yVzo.Coin.fromData(value));
    };
    MsgCreateValidator.prototype.toData = function(_) {
        _;
        var _a = this, description = _a.description, commission = _a.commission, min_self_delegation = _a.min_self_delegation, delegator_address = _a.delegator_address, validator_address = _a.validator_address, pubkey = _a.pubkey, value = _a.value;
        return {
            "@type": "/cosmos.staking.v1beta1.MsgCreateValidator",
            description: description,
            commission: commission.toData(),
            min_self_delegation: min_self_delegation.toString(),
            delegator_address: delegator_address,
            validator_address: validator_address,
            pubkey: pubkey.toData(),
            value: value.toData()
        };
    };
    MsgCreateValidator.fromProto = function(proto, _) {
        _;
        return new MsgCreateValidator($56eXa.Validator.Description.fromProto(proto.description), $56eXa.Validator.CommissionRates.fromProto(proto.commission), new $5iXRZ.Int(proto.minSelfDelegation), proto.delegatorAddress, proto.validatorAddress, $eVVZl.PublicKey.fromProto(proto.pubkey), $7yVzo.Coin.fromProto(proto.value));
    };
    MsgCreateValidator.prototype.toProto = function(_) {
        _;
        var _a = this, description = _a.description, commission = _a.commission, min_self_delegation = _a.min_self_delegation, delegator_address = _a.delegator_address, validator_address = _a.validator_address, pubkey = _a.pubkey, value = _a.value;
        return $84C3k.MsgCreateValidator.fromPartial({
            commission: commission.toProto(),
            delegatorAddress: delegator_address,
            description: description.toProto(),
            minSelfDelegation: min_self_delegation.toString(),
            pubkey: pubkey.packAny(),
            validatorAddress: validator_address,
            value: value.toProto()
        });
    };
    MsgCreateValidator.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmos.staking.v1beta1.MsgCreateValidator",
            value: $84C3k.MsgCreateValidator.encode(this.toProto(isClassic)).finish()
        });
    };
    MsgCreateValidator.unpackAny = function(msgAny, isClassic) {
        return MsgCreateValidator.fromProto($84C3k.MsgCreateValidator.decode(msgAny.value), isClassic);
    };
    return MsgCreateValidator;
}($26Eqx.JSONSerializable);
module.exports.MsgCreateValidator = $20ff278e907d6a78$var$MsgCreateValidator;

});
parcelRegister("56eXa", function(module, exports) {
"use strict";
var $3b691cb8661dfc1b$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $3b691cb8661dfc1b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3b691cb8661dfc1b$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $3b691cb8661dfc1b$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3b691cb8661dfc1b$var$__createBinding(result, mod, k);
    }
    $3b691cb8661dfc1b$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Validator = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $5iXRZ = parcelRequire("5iXRZ");

var $eVVZl = parcelRequire("eVVZl");

var $dbzoH = parcelRequire("dbzoH");

var $3b691cb8661dfc1b$var$Long = $3b691cb8661dfc1b$var$__importStar((parcelRequire("9A55m")));
/**
 * Stores information fetched from the blockchain about the current status of a validator.
 * As an end user, you will not have to create an instance of this class, one will be
 * generated for you to store information about a validator polled from the API functions
 * in [[StakingAPI]].
 */ var $3b691cb8661dfc1b$var$Validator = /** @class */ function(_super) {
    $3b691cb8661dfc1b$var$__extends(Validator, _super);
    /**
     *
     * @param operator_address validator's operator address
     * @param consensus_pubkey validator's consensus public key
     * @param jailed whether the current validator is jailed
     * @param status unbonded `0`, unbonding `1`, bonded `2`
     * @param tokens total Luna from all delegations (including self)
     * @param delegator_shares total shares of all delegators
     * @param description validator's delegate description
     * @param unbonding_height if unbonding, height at which this validator began unbonding
     * @param unbonding_time if unbonding, min time for the validator to complete unbonding
     * @param commission validator commission
     * @param min_self_delegation minimum self delegation
     */ function Validator(operator_address, consensus_pubkey, jailed, status, tokens, delegator_shares, description, unbonding_height, unbonding_time, commission, min_self_delegation) {
        var _this = _super.call(this) || this;
        _this.operator_address = operator_address;
        _this.consensus_pubkey = consensus_pubkey;
        _this.jailed = jailed;
        _this.status = status;
        _this.tokens = tokens;
        _this.delegator_shares = delegator_shares;
        _this.description = description;
        _this.unbonding_height = unbonding_height;
        _this.unbonding_time = unbonding_time;
        _this.commission = commission;
        _this.min_self_delegation = min_self_delegation;
        return _this;
    }
    Validator.prototype.toAmino = function() {
        return {
            operator_address: this.operator_address,
            consensus_pubkey: this.consensus_pubkey.toAmino(),
            jailed: this.jailed,
            status: this.status,
            tokens: this.tokens.toString(),
            delegator_shares: this.delegator_shares.toString(),
            description: this.description,
            unbonding_height: this.unbonding_height.toFixed(),
            unbonding_time: this.unbonding_time.toISOString(),
            commission: this.commission.toAmino(),
            min_self_delegation: this.min_self_delegation.toString()
        };
    };
    Validator.fromAmino = function(data) {
        return new Validator(data.operator_address, $eVVZl.ValConsPublicKey.fromAmino(data.consensus_pubkey), data.jailed || false, data.status || 0, new $5iXRZ.Int(data.tokens), new $5iXRZ.Dec(data.delegator_shares), Validator.Description.fromAmino(data.description), Number.parseInt(data.unbonding_height), new Date(data.unbonding_time), Validator.Commission.fromAmino(data.commission), new $5iXRZ.Int(data.min_self_delegation));
    };
    Validator.prototype.toData = function() {
        return {
            operator_address: this.operator_address,
            consensus_pubkey: this.consensus_pubkey.toData(),
            jailed: this.jailed,
            status: this.status,
            tokens: this.tokens.toString(),
            delegator_shares: this.delegator_shares.toString(),
            description: this.description,
            unbonding_height: this.unbonding_height.toFixed(),
            unbonding_time: this.unbonding_time.toISOString(),
            commission: this.commission.toData(),
            min_self_delegation: this.min_self_delegation.toString()
        };
    };
    Validator.fromData = function(data) {
        return new Validator(data.operator_address, $eVVZl.ValConsPublicKey.fromData(data.consensus_pubkey), data.jailed || false, data.status || 0, new $5iXRZ.Int(data.tokens), new $5iXRZ.Dec(data.delegator_shares), Validator.Description.fromData(data.description), Number.parseInt(data.unbonding_height), new Date(data.unbonding_time), Validator.Commission.fromData(data.commission), new $5iXRZ.Int(data.min_self_delegation));
    };
    Validator.prototype.toProto = function() {
        var _a = this, operator_address = _a.operator_address, consensus_pubkey = _a.consensus_pubkey, jailed = _a.jailed, status = _a.status, tokens = _a.tokens, delegator_shares = _a.delegator_shares, description = _a.description, unbonding_height = _a.unbonding_height, unbonding_time = _a.unbonding_time, commission = _a.commission, min_self_delegation = _a.min_self_delegation;
        return $dbzoH.Validator.fromPartial({
            commission: commission.toProto(),
            consensusPubkey: consensus_pubkey.packAny(),
            delegatorShares: delegator_shares.toString(),
            description: description.toProto(),
            jailed: jailed,
            minSelfDelegation: min_self_delegation.toString(),
            operatorAddress: operator_address,
            status: status,
            tokens: tokens.toString(),
            unbondingHeight: $3b691cb8661dfc1b$var$Long.fromNumber(unbonding_height),
            unbondingTime: unbonding_time
        });
    };
    Validator.fromProto = function(data) {
        return new Validator(data.operatorAddress, $eVVZl.ValConsPublicKey.unpackAny(data.consensusPubkey), data.jailed, data.status, new $5iXRZ.Int(data.tokens), new $5iXRZ.Dec(data.delegatorShares), Validator.Description.fromProto(data.description), data.unbondingHeight.toNumber(), data.unbondingTime, Validator.Commission.fromProto(data.commission), new $5iXRZ.Int(data.minSelfDelegation));
    };
    return Validator;
}($26Eqx.JSONSerializable);
module.exports.Validator = $3b691cb8661dfc1b$var$Validator;
(function(Validator) {
    Validator.Status = $dbzoH.BondStatus;
    var Description = /** @class */ function(_super) {
        $3b691cb8661dfc1b$var$__extends(Description, _super);
        /**
         * @param moniker Identifying name, e.g. "Hashed"
         * @param identity time at which commission was last updated
         * @param website validator's website
         * @param details long description
         * @param security_contact validator's contact
         */ function Description(moniker, identity, website, details, security_contact) {
            var _this = _super.call(this) || this;
            _this.moniker = moniker;
            _this.identity = identity;
            _this.website = website;
            _this.details = details;
            _this.security_contact = security_contact;
            return _this;
        }
        Description.prototype.toAmino = function() {
            return {
                moniker: this.moniker,
                identity: this.identity,
                website: this.website,
                details: this.details,
                security_contact: this.security_contact
            };
        };
        Description.fromAmino = function(data) {
            return new Description(data.moniker, data.identity || "", data.website || "", data.details || "", data.security_contact || "");
        };
        Description.prototype.toData = function() {
            return {
                moniker: this.moniker,
                identity: this.identity,
                website: this.website,
                details: this.details,
                security_contact: this.security_contact
            };
        };
        Description.fromData = function(data) {
            return new Description(data.moniker, data.identity || "", data.website || "", data.details || "", data.security_contact || "");
        };
        Description.prototype.toProto = function() {
            var _a = this, moniker = _a.moniker, identity = _a.identity, website = _a.website, details = _a.details, security_contact = _a.security_contact;
            return $dbzoH.Description.fromPartial({
                details: details,
                identity: identity,
                moniker: moniker,
                securityContact: security_contact,
                website: website
            });
        };
        Description.fromProto = function(proto) {
            return new Description(proto.moniker, proto.identity, proto.website, proto.details, proto.securityContact);
        };
        return Description;
    }($26Eqx.JSONSerializable);
    Validator.Description = Description;
    var CommissionRates = /** @class */ function(_super) {
        $3b691cb8661dfc1b$var$__extends(CommissionRates, _super);
        /**
         * @param rate current commission rate
         * @param max_rate max commission rate
         * @param max_change_rate max percentage commission can change in 24hrs
         */ function CommissionRates(rate, max_rate, max_change_rate) {
            var _this = _super.call(this) || this;
            _this.rate = rate;
            _this.max_rate = max_rate;
            _this.max_change_rate = max_change_rate;
            return _this;
        }
        CommissionRates.fromAmino = function(data) {
            var rate = data.rate, max_rate = data.max_rate, max_change_rate = data.max_change_rate;
            return new CommissionRates(new $5iXRZ.Dec(rate), new $5iXRZ.Dec(max_rate), new $5iXRZ.Dec(max_change_rate));
        };
        CommissionRates.prototype.toAmino = function() {
            var _a = this, rate = _a.rate, max_rate = _a.max_rate, max_change_rate = _a.max_change_rate;
            return {
                rate: rate.toString(),
                max_rate: max_rate.toString(),
                max_change_rate: max_change_rate.toString()
            };
        };
        CommissionRates.fromData = function(data) {
            var rate = data.rate, max_rate = data.max_rate, max_change_rate = data.max_change_rate;
            return new CommissionRates(new $5iXRZ.Dec(rate), new $5iXRZ.Dec(max_rate), new $5iXRZ.Dec(max_change_rate));
        };
        CommissionRates.prototype.toData = function() {
            var _a = this, rate = _a.rate, max_rate = _a.max_rate, max_change_rate = _a.max_change_rate;
            return {
                rate: rate.toString(),
                max_rate: max_rate.toString(),
                max_change_rate: max_change_rate.toString()
            };
        };
        CommissionRates.fromProto = function(proto) {
            return new CommissionRates(new $5iXRZ.Dec(proto.rate), new $5iXRZ.Dec(proto.maxRate), new $5iXRZ.Dec(proto.maxChangeRate));
        };
        CommissionRates.prototype.toProto = function() {
            var _a = this, rate = _a.rate, max_rate = _a.max_rate, max_change_rate = _a.max_change_rate;
            return $dbzoH.CommissionRates.fromPartial({
                maxChangeRate: max_change_rate.toString(),
                maxRate: max_rate.toString(),
                rate: rate.toString()
            });
        };
        return CommissionRates;
    }($26Eqx.JSONSerializable);
    Validator.CommissionRates = CommissionRates;
    var Commission = /** @class */ function(_super) {
        $3b691cb8661dfc1b$var$__extends(Commission, _super);
        /**
         * @param commission_rates commission rates
         * @param update_time time at which commission was last updated
         */ function Commission(commission_rates, update_time) {
            var _this = _super.call(this) || this;
            _this.commission_rates = commission_rates;
            _this.update_time = update_time;
            return _this;
        }
        Commission.prototype.toAmino = function() {
            return {
                commission_rates: this.commission_rates.toAmino(),
                update_time: this.update_time.toISOString()
            };
        };
        Commission.fromAmino = function(data) {
            return new Commission(CommissionRates.fromAmino(data.commission_rates), new Date(data.update_time));
        };
        Commission.prototype.toData = function() {
            return {
                commission_rates: this.commission_rates.toData(),
                update_time: this.update_time.toISOString()
            };
        };
        Commission.fromData = function(data) {
            return new Commission(CommissionRates.fromData(data.commission_rates), new Date(data.update_time));
        };
        Commission.prototype.toProto = function() {
            var _a = this, commission_rates = _a.commission_rates, update_time = _a.update_time;
            return $dbzoH.Commission.fromPartial({
                commissionRates: commission_rates.toProto(),
                updateTime: update_time
            });
        };
        Commission.fromProto = function(proto) {
            return new Commission(CommissionRates.fromProto(proto.commissionRates), proto.updateTime);
        };
        return Commission;
    }($26Eqx.JSONSerializable);
    Validator.Commission = Commission;
})($3b691cb8661dfc1b$var$Validator = module.exports.Validator || (module.exports.Validator = {}));
module.exports.Validator = $3b691cb8661dfc1b$var$Validator;

});
parcelRegister("eVVZl", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $adf35ed82784bf41$require$Buffer = $gzLuY.Buffer;
"use strict";
var $adf35ed82784bf41$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ValConsPublicKey = module.exports.LegacyAminoMultisigPublicKey = module.exports.SimplePublicKey = module.exports.PublicKey = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $4OXyF = parcelRequire("4OXyF");

var $ctODC = parcelRequire("ctODC");

var $c5FxR = parcelRequire("c5FxR");

var $7yr5m = parcelRequire("7yr5m");

var $e7zJu = parcelRequire("e7zJu");

var $chCai = parcelRequire("chCai");
// As discussed in https://github.com/binance-chain/javascript-sdk/issues/163
// Prefixes listed here: https://github.com/tendermint/tendermint/blob/d419fffe18531317c28c29a292ad7d253f6cafdf/docs/spec/blockchain/encoding.md#public-key-cryptography
// Last bytes is varint-encoded length prefix
var $adf35ed82784bf41$var$pubkeyAminoPrefixSecp256k1 = $adf35ed82784bf41$require$Buffer.from("eb5ae98721" /* fixed length */ , "hex");
var $adf35ed82784bf41$var$pubkeyAminoPrefixEd25519 = $adf35ed82784bf41$require$Buffer.from("1624de6420" /* fixed length */ , "hex");
/** See https://github.com/tendermint/tendermint/commit/38b401657e4ad7a7eeb3c30a3cbf512037df3740 */ var $adf35ed82784bf41$var$pubkeyAminoPrefixMultisigThreshold = $adf35ed82784bf41$require$Buffer.from("22c1f7e2" /* variable length not included */ , "hex");
var $adf35ed82784bf41$var$encodeUvarint = function(value) {
    var checked = Number.parseInt(value.toString());
    if (checked > 127) throw new Error("Encoding numbers > 127 is not supported here. Please tell those lazy CosmJS maintainers to port the binary.PutUvarint implementation from the Go standard library and write some tests.");
    return [
        checked
    ];
};
var $adf35ed82784bf41$var$PublicKey;
(function(PublicKey) {
    function fromAmino(data) {
        switch(data.type){
            case "tendermint/PubKeySecp256k1":
                return $adf35ed82784bf41$var$SimplePublicKey.fromAmino(data);
            case "tendermint/PubKeyMultisigThreshold":
                return $adf35ed82784bf41$var$LegacyAminoMultisigPublicKey.fromAmino(data);
            case "tendermint/PubKeyEd25519":
                return $adf35ed82784bf41$var$ValConsPublicKey.fromAmino(data);
        }
    }
    PublicKey.fromAmino = fromAmino;
    function fromData(data) {
        switch(data["@type"]){
            case "/cosmos.crypto.secp256k1.PubKey":
                return $adf35ed82784bf41$var$SimplePublicKey.fromData(data);
            case "/cosmos.crypto.multisig.LegacyAminoPubKey":
                return $adf35ed82784bf41$var$LegacyAminoMultisigPublicKey.fromData(data);
            case "/cosmos.crypto.ed25519.PubKey":
                return $adf35ed82784bf41$var$ValConsPublicKey.fromData(data);
        }
    }
    PublicKey.fromData = fromData;
    function fromProto(pubkeyAny) {
        var typeUrl = pubkeyAny.typeUrl;
        if (typeUrl === "/cosmos.crypto.secp256k1.PubKey") return $adf35ed82784bf41$var$SimplePublicKey.unpackAny(pubkeyAny);
        else if (typeUrl === "/cosmos.crypto.multisig.LegacyAminoPubKey") return $adf35ed82784bf41$var$LegacyAminoMultisigPublicKey.unpackAny(pubkeyAny);
        else if (typeUrl === "/cosmos.crypto.ed25519.PubKey") return $adf35ed82784bf41$var$ValConsPublicKey.unpackAny(pubkeyAny);
        throw new Error("Pubkey type ".concat(typeUrl, " not recognized"));
    }
    PublicKey.fromProto = fromProto;
})($adf35ed82784bf41$var$PublicKey = module.exports.PublicKey || (module.exports.PublicKey = {}));
var $adf35ed82784bf41$var$SimplePublicKey = /** @class */ function(_super) {
    $adf35ed82784bf41$var$__extends(SimplePublicKey, _super);
    function SimplePublicKey(key) {
        var _this = _super.call(this) || this;
        _this.key = key;
        return _this;
    }
    SimplePublicKey.fromAmino = function(data) {
        return new SimplePublicKey(data.value);
    };
    SimplePublicKey.prototype.toAmino = function() {
        return {
            type: "tendermint/PubKeySecp256k1",
            value: this.key
        };
    };
    SimplePublicKey.fromData = function(data) {
        return new SimplePublicKey(data.key);
    };
    SimplePublicKey.prototype.toData = function() {
        return {
            "@type": "/cosmos.crypto.secp256k1.PubKey",
            key: this.key
        };
    };
    SimplePublicKey.fromProto = function(pubkeyProto) {
        return new SimplePublicKey($adf35ed82784bf41$require$Buffer.from(pubkeyProto.key).toString("base64"));
    };
    SimplePublicKey.prototype.toProto = function() {
        return $7yr5m.PubKey.fromPartial({
            key: $adf35ed82784bf41$require$Buffer.from(this.key, "base64")
        });
    };
    SimplePublicKey.prototype.packAny = function() {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmos.crypto.secp256k1.PubKey",
            value: $7yr5m.PubKey.encode(this.toProto()).finish()
        });
    };
    SimplePublicKey.unpackAny = function(pubkeyAny) {
        return SimplePublicKey.fromProto($7yr5m.PubKey.decode(pubkeyAny.value));
    };
    SimplePublicKey.prototype.encodeAminoPubkey = function() {
        return $adf35ed82784bf41$require$Buffer.concat([
            $adf35ed82784bf41$var$pubkeyAminoPrefixSecp256k1,
            $adf35ed82784bf41$require$Buffer.from(this.key, "base64")
        ]);
    };
    SimplePublicKey.prototype.rawAddress = function() {
        var pubkeyData = $adf35ed82784bf41$require$Buffer.from(this.key, "base64");
        return (0, $4OXyF.ripemd160)((0, $4OXyF.sha256)(pubkeyData));
    };
    SimplePublicKey.prototype.address = function() {
        return $chCai.bech32.encode("terra", $chCai.bech32.toWords(this.rawAddress()));
    };
    SimplePublicKey.prototype.pubkeyAddress = function() {
        return $chCai.bech32.encode("terrapub", $chCai.bech32.toWords(this.encodeAminoPubkey()));
    };
    return SimplePublicKey;
}($26Eqx.JSONSerializable);
module.exports.SimplePublicKey = $adf35ed82784bf41$var$SimplePublicKey;
var $adf35ed82784bf41$var$LegacyAminoMultisigPublicKey = /** @class */ function(_super) {
    $adf35ed82784bf41$var$__extends(LegacyAminoMultisigPublicKey, _super);
    function LegacyAminoMultisigPublicKey(threshold, pubkeys) {
        var _this = _super.call(this) || this;
        _this.threshold = threshold;
        _this.pubkeys = pubkeys;
        return _this;
    }
    LegacyAminoMultisigPublicKey.prototype.encodeAminoPubkey = function() {
        var out = Array.from($adf35ed82784bf41$var$pubkeyAminoPrefixMultisigThreshold);
        out.push(0x08);
        out.push.apply(out, $adf35ed82784bf41$var$encodeUvarint(this.threshold));
        for(var _i = 0, _a = this.pubkeys.map(function(p) {
            return p.encodeAminoPubkey();
        }); _i < _a.length; _i++){
            var pubkeyData = _a[_i];
            out.push(0x12);
            out.push.apply(out, $adf35ed82784bf41$var$encodeUvarint(pubkeyData.length));
            out.push.apply(out, Array.from(pubkeyData));
        }
        return new Uint8Array(out);
    };
    LegacyAminoMultisigPublicKey.prototype.rawAddress = function() {
        var pubkeyData = this.encodeAminoPubkey();
        return (0, $4OXyF.sha256)(pubkeyData).slice(0, 20);
    };
    LegacyAminoMultisigPublicKey.prototype.address = function() {
        return $chCai.bech32.encode("terra", $chCai.bech32.toWords(this.rawAddress()));
    };
    LegacyAminoMultisigPublicKey.prototype.pubkeyAddress = function() {
        return $chCai.bech32.encode("terrapub", $chCai.bech32.toWords(this.encodeAminoPubkey()));
    };
    LegacyAminoMultisigPublicKey.fromAmino = function(data) {
        return new LegacyAminoMultisigPublicKey(Number.parseInt(data.value.threshold), data.value.pubkeys.map(function(p) {
            return $adf35ed82784bf41$var$SimplePublicKey.fromAmino(p);
        }));
    };
    LegacyAminoMultisigPublicKey.prototype.toAmino = function() {
        return {
            type: "tendermint/PubKeyMultisigThreshold",
            value: {
                threshold: this.threshold.toFixed(),
                pubkeys: this.pubkeys.map(function(p) {
                    return p.toAmino();
                })
            }
        };
    };
    LegacyAminoMultisigPublicKey.fromData = function(data) {
        return new LegacyAminoMultisigPublicKey(Number.parseInt(data.threshold), data.public_keys.map(function(v) {
            return $adf35ed82784bf41$var$SimplePublicKey.fromData(v);
        }));
    };
    LegacyAminoMultisigPublicKey.prototype.toData = function() {
        return {
            "@type": "/cosmos.crypto.multisig.LegacyAminoPubKey",
            threshold: this.threshold.toFixed(),
            public_keys: this.pubkeys.map(function(p) {
                return p.toData();
            })
        };
    };
    LegacyAminoMultisigPublicKey.fromProto = function(pubkeyProto) {
        return new LegacyAminoMultisigPublicKey(pubkeyProto.threshold, pubkeyProto.publicKeys.map(function(v) {
            return $adf35ed82784bf41$var$SimplePublicKey.unpackAny(v);
        }));
    };
    LegacyAminoMultisigPublicKey.prototype.toProto = function() {
        return $ctODC.LegacyAminoPubKey.fromPartial({
            threshold: this.threshold,
            publicKeys: this.pubkeys.map(function(v) {
                return v.packAny();
            })
        });
    };
    LegacyAminoMultisigPublicKey.prototype.packAny = function() {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmos.crypto.multisig.LegacyAminoPubKey",
            value: $ctODC.LegacyAminoPubKey.encode(this.toProto()).finish()
        });
    };
    LegacyAminoMultisigPublicKey.unpackAny = function(pubkeyAny) {
        return LegacyAminoMultisigPublicKey.fromProto($ctODC.LegacyAminoPubKey.decode(pubkeyAny.value));
    };
    return LegacyAminoMultisigPublicKey;
}($26Eqx.JSONSerializable);
module.exports.LegacyAminoMultisigPublicKey = $adf35ed82784bf41$var$LegacyAminoMultisigPublicKey;
var $adf35ed82784bf41$var$ValConsPublicKey = /** @class */ function(_super) {
    $adf35ed82784bf41$var$__extends(ValConsPublicKey, _super);
    function ValConsPublicKey(key) {
        var _this = _super.call(this) || this;
        _this.key = key;
        return _this;
    }
    ValConsPublicKey.fromAmino = function(data) {
        return new ValConsPublicKey(data.value);
    };
    ValConsPublicKey.prototype.toAmino = function() {
        return {
            type: "tendermint/PubKeyEd25519",
            value: this.key
        };
    };
    ValConsPublicKey.fromData = function(data) {
        return new ValConsPublicKey(data.key);
    };
    ValConsPublicKey.prototype.toData = function() {
        return {
            "@type": "/cosmos.crypto.ed25519.PubKey",
            key: this.key
        };
    };
    ValConsPublicKey.fromProto = function(pubkeyProto) {
        return new ValConsPublicKey($adf35ed82784bf41$require$Buffer.from(pubkeyProto.key).toString("base64"));
    };
    ValConsPublicKey.prototype.toProto = function() {
        return $7yr5m.PubKey.fromPartial({
            key: $adf35ed82784bf41$require$Buffer.from(this.key, "base64")
        });
    };
    ValConsPublicKey.prototype.packAny = function() {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmos.crypto.ed25519.PubKey",
            value: $e7zJu.PubKey.encode(this.toProto()).finish()
        });
    };
    ValConsPublicKey.unpackAny = function(pubkeyAny) {
        return ValConsPublicKey.fromProto($e7zJu.PubKey.decode(pubkeyAny.value));
    };
    ValConsPublicKey.prototype.encodeAminoPubkey = function() {
        return $adf35ed82784bf41$require$Buffer.concat([
            $adf35ed82784bf41$var$pubkeyAminoPrefixEd25519,
            $adf35ed82784bf41$require$Buffer.from(this.key, "base64")
        ]);
    };
    ValConsPublicKey.prototype.rawAddress = function() {
        var pubkeyData = $adf35ed82784bf41$require$Buffer.from(this.key, "base64");
        return (0, $4OXyF.sha256)(pubkeyData).slice(0, 20);
    };
    ValConsPublicKey.prototype.address = function() {
        return $chCai.bech32.encode("terravalcons", $chCai.bech32.toWords(this.rawAddress()));
    };
    ValConsPublicKey.prototype.pubkeyAddress = function() {
        return $chCai.bech32.encode("terravalconspub", $chCai.bech32.toWords(this.encodeAminoPubkey()));
    };
    return ValConsPublicKey;
}($26Eqx.JSONSerializable);
module.exports.ValConsPublicKey = $adf35ed82784bf41$var$ValConsPublicKey;

});
parcelRegister("4OXyF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ripemd160 = module.exports.sha256 = module.exports.hashToHex = void 0;

var $bKarv = parcelRequire("bKarv");

var $eC4ja = parcelRequire("eC4ja");

var $4VvZZ = parcelRequire("4VvZZ");

var $lzOVk = parcelRequire("lzOVk");
/*
DEPRECATED (was used by crypto-js)
function byteArrayToWordArray(ba: Uint8Array): CryptoJS.LibWordArray {
  const wa: number[] = [];
  for (let i = 0; i < ba.length; i += 1) {
    wa[(i / 4) | 0] |= ba[i] << (24 - 8 * i);
  }
  return crypto.lib.WordArray.create(wa);
}*/ /**
 * Calculates the transaction hash from Amino-encoded string.
 * @param data Amino-encoded string (base64)
 */ function $382a07f161b954f1$var$hashToHex(data) {
    return $bKarv.SHA256.hash($4VvZZ.Base64.parse(data)).toString().toUpperCase();
}
module.exports.hashToHex = $382a07f161b954f1$var$hashToHex;
/**
 * Calculates the transaction hash from Amino-encoded string.
 * @param data raw bytes
 */ function $382a07f161b954f1$var$sha256(data) {
    return $bKarv.SHA256.hash(new $lzOVk.Word32Array(data)).toUint8Array();
}
module.exports.sha256 = $382a07f161b954f1$var$sha256;
function $382a07f161b954f1$var$ripemd160(data) {
    return $eC4ja.RIPEMD160.hash(new $lzOVk.Word32Array(data)).toUint8Array();
}
module.exports.ripemd160 = $382a07f161b954f1$var$ripemd160;

});
parcelRegister("eC4ja", function(module, exports) {

!function(n, t) {
    var r, e;
    module.exports = t();
}(module.exports, function() {
    return function() {
        "use strict";
        var n = {
            3354: function(n, t, r) {
                r.d(t, {
                    e: function() {
                        return o;
                    }
                });
                var e = r(5720), i = r(9054), o = function() {
                    function n(t, r) {
                        if (Array.isArray(t) || !t) return this.t = Array.isArray(t) ? t : [], void (this.i = "number" == typeof r ? r : 4 * this.t.length);
                        if (t instanceof n) return this.t = t.words.slice(), void (this.i = t.nSigBytes);
                        var e;
                        try {
                            t instanceof ArrayBuffer ? e = new Uint8Array(t) : (t instanceof Uint8Array || t instanceof Int8Array || t instanceof Uint8ClampedArray || t instanceof Int16Array || t instanceof Uint16Array || t instanceof Int32Array || t instanceof Uint32Array || t instanceof Float32Array || t instanceof Float64Array) && (e = new Uint8Array(t.buffer, t.byteOffset, t.byteLength));
                        } catch (n) {
                            throw new Error("Invalid argument");
                        }
                        if (!e) throw new Error("Invalid argument");
                        for(var i = e.byteLength, o = [], u = 0; u < i; u++)o[u >>> 2] |= e[u] << 24 - u % 4 * 8;
                        this.t = o, this.i = i;
                    }
                    return Object.defineProperty(n.prototype, "nSigBytes", {
                        get: function() {
                            return this.i;
                        },
                        set: function(n) {
                            this.i = n;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(n.prototype, "words", {
                        get: function() {
                            return this.t;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), n.prototype.toString = function(n) {
                        return n ? n.stringify(this) : e.p.stringify(this);
                    }, n.prototype.toUint8Array = function() {
                        for(var n = this.t, t = this.i, r = new Uint8Array(t), e = 0; e < t; e++)r[e] = n[e >>> 2] >>> 24 - e % 4 * 8 & 255;
                        return r;
                    }, n.prototype.concat = function(n) {
                        var t = n.words.slice(), r = n.nSigBytes;
                        if (this.clamp(), this.i % 4) for(var e = 0; e < r; e++){
                            var i = t[e >>> 2] >>> 24 - e % 4 * 8 & 255;
                            this.t[this.i + e >>> 2] |= i << 24 - (this.i + e) % 4 * 8;
                        }
                        else for(e = 0; e < r; e += 4)this.t[this.i + e >>> 2] = t[e >>> 2];
                        return this.i += r, this;
                    }, n.prototype.clamp = function() {
                        var n = this.i;
                        this.t[n >>> 2] &= 4294967295 << 32 - n % 4 * 8, this.t.length = Math.ceil(n / 4);
                    }, n.prototype.clone = function() {
                        return new n(this.t.slice(), this.i);
                    }, n.random = function(t) {
                        for(var r = [], e = 0; e < t; e += 4)r.push((0, i.M)());
                        return new n(r, t);
                    }, n;
                }();
            },
            7211: function(n, t, r) {
                r.d(t, {
                    C: function() {
                        return o;
                    }
                });
                var e = r(3354), i = r(4768), o = function() {
                    function n(n) {
                        this.u = 0, this.h = 0, this.v = n, this.l = n && void 0 !== n.data ? n.data.clone() : new e.e, this.j = n && "number" == typeof n.nBytes ? n.nBytes : 0;
                    }
                    return Object.defineProperty(n.prototype, "blockSize", {
                        get: function() {
                            return this.h;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), n.prototype.reset = function(n, t) {
                        this.l = void 0 !== n ? n.clone() : new e.e, this.j = "number" == typeof t ? t : 0;
                    }, n.prototype.A = function(n) {
                        var t = "string" == typeof n ? i.d.parse(n) : n;
                        this.l.concat(t), this.j += t.nSigBytes;
                    }, n.prototype.I = function(n) {
                        var t, r = this.l.words, i = this.l.nSigBytes, o = this.h, u = i / (4 * this.h), f = (u = n ? Math.ceil(u) : Math.max((0 | u) - this.u, 0)) * o, c = Math.min(4 * f, i);
                        if (f) {
                            for(var a = 0; a < f; a += o)this.O(r, a);
                            t = r.splice(0, f), this.l.nSigBytes -= c;
                        }
                        return new e.e(t, c);
                    }, n.prototype.O = function(n, t) {
                        throw new Error("Not implemented");
                    }, n;
                }();
            },
            1868: function(n, t, r) {
                r.d(t, {
                    P: function() {
                        return u;
                    }
                });
                var e, i = r(7211), o = (e = function(n, t) {
                    return (e = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(n, t) {
                        n.__proto__ = t;
                    } || function(n, t) {
                        for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
                    })(n, t);
                }, function(n, t) {
                    function r() {
                        this.constructor = n;
                    }
                    e(n, t), n.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
                }), u = function(n) {
                    function t(t) {
                        var r = n.call(this, t) || this;
                        return r.h = 16, r.v = t, t && "number" == typeof t.blockSize && (r.h = t.blockSize), r.reset(t ? t.data : void 0, t ? t.nBytes : void 0), r;
                    }
                    return o(t, n), Object.defineProperty(t.prototype, "blockSize", {
                        get: function() {
                            return this.h;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), t.prototype.reset = function(t, r) {
                        n.prototype.reset.call(this, t, r), this.U();
                    }, t.prototype.update = function(n) {
                        return this.A(n), this.I(), this;
                    }, t.prototype.finalize = function(n) {
                        return n && this.A(n), this._();
                    }, t.prototype.U = function() {
                        throw new Error("Not implemented");
                    }, t.prototype._ = function() {
                        throw new Error("Not implemented");
                    }, t;
                }(i.C);
            },
            1756: function(n, t, r) {
                r.d(t, {
                    w: function() {
                        return u;
                    }
                });
                var e, i = "undefined" != typeof navigator && navigator.userAgent ? navigator.userAgent.toLowerCase() : "", o = (e = parseInt((/msie (\d+)/.exec(i) || [])[1], 10), isNaN(e) ? (e = parseInt((/trident\/.*; rv:(\d+)/.exec(i) || [])[1], 10), !isNaN(e) && e) : e);
                function u(n, t) {
                    return !1 !== o && (!t || ("<" === n ? o < t : "<=" === n ? o <= t : ">" === n ? o > t : ">=" === n ? o >= t : o === t));
                }
            },
            5720: function(n, t, r) {
                r.d(t, {
                    p: function() {
                        return i;
                    }
                });
                var e = r(3354), i = {
                    stringify: function(n) {
                        for(var t = n.nSigBytes, r = n.words, e = [], i = 0; i < t; i++){
                            var o = r[i >>> 2] >>> 24 - i % 4 * 8 & 255;
                            e.push((o >>> 4).toString(16)), e.push((15 & o).toString(16));
                        }
                        return e.join("");
                    },
                    parse: function(n) {
                        var t = n.length;
                        if (t % 2 != 0) throw new Error("Hex string count must be even");
                        if (!/^[a-fA-F0-9]+$/.test(n)) throw new Error("Invalid Hex string: " + n);
                        for(var r = [], i = 0; i < t; i += 2)r[i >>> 3] |= parseInt(n.substr(i, 2), 16) << 24 - i % 8 * 4;
                        return new e.e(r, t / 2);
                    }
                };
            },
            8702: function(n, t, r) {
                r.d(t, {
                    m: function() {
                        return i;
                    }
                });
                var e = r(3354), i = {
                    stringify: function(n) {
                        for(var t = n.nSigBytes, r = n.words, e = [], i = 0; i < t; i++){
                            var o = r[i >>> 2] >>> 24 - i % 4 * 8 & 255;
                            e.push(String.fromCharCode(o));
                        }
                        return e.join("");
                    },
                    parse: function(n) {
                        for(var t = n.length, r = [], i = 0; i < t; i++)r[i >>> 2] |= (255 & n.charCodeAt(i)) << 24 - i % 4 * 8;
                        return new e.e(r, t);
                    }
                };
            },
            4768: function(n, t, r) {
                r.d(t, {
                    d: function() {
                        return i;
                    }
                });
                var e = r(8702), i = {
                    stringify: function(n) {
                        try {
                            return decodeURIComponent(escape(e.m.stringify(n)));
                        } catch (n) {
                            throw new Error("Malformed UTF-8 data");
                        }
                    },
                    parse: function(n) {
                        return e.m.parse(unescape(encodeURIComponent(n)));
                    }
                };
            },
            9054: function(n, t, r) {
                r.d(t, {
                    M: function() {
                        return i;
                    }
                });
                var e = r(1756);
                var i = function() {
                    if ("undefined" != typeof window) {
                        var n = window.crypto || window.msCrypto;
                        if (!n) {
                            if ((0, e.w)("<", 11)) return console.warn("IE <= 10 uses insecure random generator. Please consider to use IE11 or another modern browser"), function() {
                                return Math.floor(512 * Math.random()) % 256;
                            };
                            throw new Error("Crypto module not found");
                        }
                        return function() {
                            return n.getRandomValues(new Uint32Array(1))[0];
                        };
                    }
                    return void 0 !== r.g && r.g.crypto ? function() {
                        return r.g.crypto.randomBytes(4).readInt32LE();
                    } : function() {
                        return (parcelRequire("aqbQf")).randomBytes(4).readInt32LE();
                    };
                }();
            }
        }, t = {};
        function r(e) {
            var i = t[e];
            if (void 0 !== i) return i.exports;
            var o = t[e] = {
                exports: {}
            };
            return n[e](o, o.exports, r), o.exports;
        }
        r.d = function(n, t) {
            for(var e in t)r.o(t, e) && !r.o(n, e) && Object.defineProperty(n, e, {
                enumerable: !0,
                get: t[e]
            });
        }, r.g = function() {
            if ("object" == typeof globalThis) return globalThis;
            try {
                return this || new Function("return this")();
            } catch (n) {
                if ("object" == typeof window) return window;
            }
        }(), r.o = function(n, t) {
            return Object.prototype.hasOwnProperty.call(n, t);
        }, r.r = function(n) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(n, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(n, "S", {
                value: !0
            });
        };
        var e = {};
        return function() {
            r.r(e), r.d(e, {
                RIPEMD160: function() {
                    return p;
                }
            });
            var n, t = r(1868), i = r(3354), o = (n = function(t, r) {
                return (n = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(n, t) {
                    n.__proto__ = t;
                } || function(n, t) {
                    for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
                })(t, r);
            }, function(t, r) {
                function e() {
                    this.constructor = t;
                }
                n(t, r), t.prototype = null === r ? Object.create(r) : (e.prototype = r.prototype, new e);
            }), u = new i.e([
                0,
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                7,
                4,
                13,
                1,
                10,
                6,
                15,
                3,
                12,
                0,
                9,
                5,
                2,
                14,
                11,
                8,
                3,
                10,
                14,
                4,
                9,
                15,
                8,
                1,
                2,
                7,
                0,
                6,
                13,
                11,
                5,
                12,
                1,
                9,
                11,
                10,
                0,
                8,
                12,
                4,
                13,
                3,
                7,
                15,
                14,
                5,
                6,
                2,
                4,
                0,
                5,
                9,
                7,
                12,
                2,
                10,
                14,
                1,
                3,
                8,
                11,
                6,
                15,
                13
            ]), f = new i.e([
                5,
                14,
                7,
                0,
                9,
                2,
                11,
                4,
                13,
                6,
                15,
                8,
                1,
                10,
                3,
                12,
                6,
                11,
                3,
                7,
                0,
                13,
                5,
                10,
                14,
                15,
                8,
                12,
                4,
                9,
                1,
                2,
                15,
                5,
                1,
                3,
                7,
                14,
                6,
                9,
                11,
                8,
                12,
                2,
                10,
                0,
                4,
                13,
                8,
                6,
                4,
                1,
                3,
                11,
                15,
                0,
                5,
                12,
                2,
                13,
                9,
                7,
                10,
                14,
                12,
                15,
                10,
                4,
                1,
                5,
                8,
                7,
                6,
                2,
                13,
                14,
                0,
                3,
                9,
                11
            ]), c = new i.e([
                11,
                14,
                15,
                12,
                5,
                8,
                7,
                9,
                11,
                13,
                14,
                15,
                6,
                7,
                9,
                8,
                7,
                6,
                8,
                13,
                11,
                9,
                7,
                15,
                7,
                12,
                15,
                9,
                11,
                7,
                13,
                12,
                11,
                13,
                6,
                7,
                14,
                9,
                13,
                15,
                14,
                8,
                13,
                6,
                5,
                12,
                7,
                5,
                11,
                12,
                14,
                15,
                14,
                15,
                9,
                8,
                9,
                14,
                5,
                6,
                8,
                6,
                5,
                12,
                9,
                15,
                5,
                11,
                6,
                8,
                13,
                12,
                5,
                12,
                13,
                14,
                11,
                8,
                5,
                6
            ]), a = new i.e([
                8,
                9,
                9,
                11,
                13,
                15,
                15,
                5,
                7,
                7,
                8,
                11,
                14,
                14,
                12,
                6,
                9,
                13,
                15,
                7,
                12,
                8,
                9,
                11,
                7,
                7,
                12,
                7,
                6,
                15,
                13,
                11,
                9,
                7,
                15,
                11,
                8,
                6,
                6,
                14,
                12,
                13,
                5,
                14,
                13,
                13,
                7,
                5,
                15,
                5,
                8,
                11,
                14,
                14,
                6,
                14,
                6,
                9,
                12,
                9,
                12,
                5,
                15,
                8,
                8,
                5,
                12,
                9,
                12,
                5,
                14,
                6,
                8,
                13,
                6,
                5,
                15,
                13,
                11,
                11
            ]), s = new i.e([
                0,
                1518500249,
                1859775393,
                2400959708,
                2840853838
            ]), h = new i.e([
                1352829926,
                1548603684,
                1836072691,
                2053994217,
                0
            ]);
            function v(n, t, r) {
                return n ^ t ^ r;
            }
            function w(n, t, r) {
                return n & t | ~n & r;
            }
            function d(n, t, r) {
                return (n | ~t) ^ r;
            }
            function l(n, t, r) {
                return n & r | t & ~r;
            }
            function y(n, t, r) {
                return n ^ (t | ~r);
            }
            function b(n, t) {
                return n << t | n >>> 32 - t;
            }
            var p = function(n) {
                function t(t) {
                    var r = n.call(this, t) || this;
                    return r.N = new i.e([
                        1732584193,
                        4023233417,
                        2562383102,
                        271733878,
                        3285377520
                    ]), r.v = t, t && void 0 !== t.hash && (r.N = t.hash.clone()), r;
                }
                return o(t, n), t.prototype.U = function() {
                    this.N = new i.e([
                        1732584193,
                        4023233417,
                        2562383102,
                        271733878,
                        3285377520
                    ]);
                }, t.prototype.O = function(n, t) {
                    for(var r = 0; r < 16; r++){
                        var e = t + r, i = n[e];
                        n[e] = 16711935 & (i << 8 | i >>> 24) | 4278255360 & (i << 24 | i >>> 8);
                    }
                    var o, p, m, g, j, A, I, O, E, M, U, _ = this.N.words, S = s.words, N = h.words, x = u.words, C = f.words, F = c.words, k = a.words;
                    A = o = _[0], I = p = _[1], O = m = _[2], E = g = _[3], M = j = _[4];
                    for(r = 0; r < 80; r += 1)U = o + n[t + x[r]] | 0, U += r < 16 ? v(p, m, g) + S[0] : r < 32 ? w(p, m, g) + S[1] : r < 48 ? d(p, m, g) + S[2] : r < 64 ? l(p, m, g) + S[3] : y(p, m, g) + S[4], U = (U = b(U |= 0, F[r])) + j | 0, o = j, j = g, g = b(m, 10), m = p, p = U, U = A + n[t + C[r]] | 0, U += r < 16 ? y(I, O, E) + N[0] : r < 32 ? l(I, O, E) + N[1] : r < 48 ? d(I, O, E) + N[2] : r < 64 ? w(I, O, E) + N[3] : v(I, O, E) + N[4], U = (U = b(U |= 0, k[r])) + M | 0, A = M, M = E, E = b(O, 10), O = I, I = U;
                    U = _[1] + m + E | 0, _[1] = _[2] + g + M | 0, _[2] = _[3] + j + A | 0, _[3] = _[4] + o + I | 0, _[4] = _[0] + p + O | 0, _[0] = U;
                }, t.prototype._ = function() {
                    var n = this.l, t = n.words, r = 8 * this.j, e = 8 * n.nSigBytes;
                    t[e >>> 5] |= 128 << 24 - e % 32, t[14 + (e + 64 >>> 9 << 4)] = 16711935 & (r << 8 | r >>> 24) | 4278255360 & (r << 24 | r >>> 8), n.nSigBytes = 4 * (t.length + 1), this.I();
                    for(var i = this.N, o = i.words, u = 0; u < 5; u++){
                        var f = o[u];
                        o[u] = 16711935 & (f << 8 | f >>> 24) | 4278255360 & (f << 24 | f >>> 8);
                    }
                    return i;
                }, t.prototype.clone = function() {
                    return new t({
                        hash: this.N,
                        blockSize: this.h,
                        data: this.l,
                        nBytes: this.j
                    });
                }, t.hash = function(n, r) {
                    return new t(r).finalize(n);
                }, t;
            }(t.P);
        }(), e;
    }();
});

});

parcelRegister("4VvZZ", function(module, exports) {

!function(r, n) {
    var t, e;
    module.exports = n();
}(module.exports, function() {
    return function() {
        "use strict";
        var r = {
            d: function(n, t) {
                for(var e in t)r.o(t, e) && !r.o(n, e) && Object.defineProperty(n, e, {
                    enumerable: !0,
                    get: t[e]
                });
            }
        };
        r.g = function() {
            if ("object" == typeof globalThis) return globalThis;
            try {
                return this || new Function("return this")();
            } catch (r) {
                if ("object" == typeof window) return window;
            }
        }(), r.o = function(r, n) {
            return Object.prototype.hasOwnProperty.call(r, n);
        }, r.r = function(r) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(r, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(r, "t", {
                value: !0
            });
        };
        var n = {};
        r.r(n), r.d(n, {
            Base64: function() {
                return h;
            }
        });
        var t, e = function(r) {
            for(var n = r.nSigBytes, t = r.words, e = [], i = 0; i < n; i++){
                var o = t[i >>> 2] >>> 24 - i % 4 * 8 & 255;
                e.push((o >>> 4).toString(16)), e.push((15 & o).toString(16));
            }
            return e.join("");
        }, i = "undefined" != typeof navigator && navigator.userAgent ? navigator.userAgent.toLowerCase() : "", o = (t = parseInt((/msie (\d+)/.exec(i) || [])[1], 10), isNaN(t) ? (t = parseInt((/trident\/.*; rv:(\d+)/.exec(i) || [])[1], 10), !isNaN(t) && t) : t);
        for(var a = function() {
            if ("undefined" != typeof window) {
                var n = window.crypto || window.msCrypto;
                if (!n) {
                    if (function(r, n) {
                        return !1 !== o && (!n || ("<" === r ? o < n : "<=" === r ? o <= n : ">" === r ? o > n : ">=" === r ? o >= n : o === n));
                    }("<", 11)) return console.warn("IE <= 10 uses insecure random generator. Please consider to use IE11 or another modern browser"), function() {
                        return Math.floor(512 * Math.random()) % 256;
                    };
                    throw new Error("Crypto module not found");
                }
                return function() {
                    return n.getRandomValues(new Uint32Array(1))[0];
                };
            }
            return void 0 !== r.g && r.g.crypto ? function() {
                return r.g.crypto.randomBytes(4).readInt32LE();
            } : function() {
                return (parcelRequire("aqbQf")).randomBytes(4).readInt32LE();
            };
        }(), f = function() {
            function r(n, t) {
                if (Array.isArray(n) || !n) return this.i = Array.isArray(n) ? n : [], void (this.u = "number" == typeof t ? t : 4 * this.i.length);
                if (n instanceof r) return this.i = n.words.slice(), void (this.u = n.nSigBytes);
                var e;
                try {
                    n instanceof ArrayBuffer ? e = new Uint8Array(n) : (n instanceof Uint8Array || n instanceof Int8Array || n instanceof Uint8ClampedArray || n instanceof Int16Array || n instanceof Uint16Array || n instanceof Int32Array || n instanceof Uint32Array || n instanceof Float32Array || n instanceof Float64Array) && (e = new Uint8Array(n.buffer, n.byteOffset, n.byteLength));
                } catch (r) {
                    throw new Error("Invalid argument");
                }
                if (!e) throw new Error("Invalid argument");
                for(var i = e.byteLength, o = [], a = 0; a < i; a++)o[a >>> 2] |= e[a] << 24 - a % 4 * 8;
                this.i = o, this.u = i;
            }
            return Object.defineProperty(r.prototype, "nSigBytes", {
                get: function() {
                    return this.u;
                },
                set: function(r) {
                    this.u = r;
                },
                enumerable: !1,
                configurable: !0
            }), Object.defineProperty(r.prototype, "words", {
                get: function() {
                    return this.i;
                },
                enumerable: !1,
                configurable: !0
            }), r.prototype.toString = function(r) {
                return r ? r.stringify(this) : e(this);
            }, r.prototype.toUint8Array = function() {
                for(var r = this.i, n = this.u, t = new Uint8Array(n), e = 0; e < n; e++)t[e] = r[e >>> 2] >>> 24 - e % 4 * 8 & 255;
                return t;
            }, r.prototype.concat = function(r) {
                var n = r.words.slice(), t = r.nSigBytes;
                if (this.clamp(), this.u % 4) for(var e = 0; e < t; e++){
                    var i = n[e >>> 2] >>> 24 - e % 4 * 8 & 255;
                    this.i[this.u + e >>> 2] |= i << 24 - (this.u + e) % 4 * 8;
                }
                else for(e = 0; e < t; e += 4)this.i[this.u + e >>> 2] = n[e >>> 2];
                return this.u += t, this;
            }, r.prototype.clamp = function() {
                var r = this.u;
                this.i[r >>> 2] &= 4294967295 << 32 - r % 4 * 8, this.i.length = Math.ceil(r / 4);
            }, r.prototype.clone = function() {
                return new r(this.i.slice(), this.u);
            }, r.random = function(n) {
                for(var t = [], e = 0; e < n; e += 4)t.push(a());
                return new r(t, n);
            }, r;
        }(), u = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", s = [], c = 0; c < u.length; c++)s[u.charCodeAt(c)] = c;
        var h = {
            stringify: function(r) {
                var n = r.words, t = r.nSigBytes;
                r.clamp();
                for(var e = [], i = 0; i < t; i += 3)for(var o = (n[i >>> 2] >>> 24 - i % 4 * 8 & 255) << 16 | (n[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 255) << 8 | n[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 255, a = 0; a < 4 && i + .75 * a < t; a++)e.push(u.charAt(o >>> 6 * (3 - a) & 63));
                var f = u.charAt(64);
                if (f) for(; e.length % 4;)e.push(f);
                return e.join("");
            },
            parse: function(r) {
                var n = r.length, t = u.charAt(64);
                if (t) {
                    var e = r.indexOf(t);
                    -1 !== e && (n = e);
                }
                for(var i = [], o = 0, a = 0; a < n; a++)if (a % 4) {
                    var c = s[r.charCodeAt(a - 1)] << a % 4 * 2 | s[r.charCodeAt(a)] >>> 6 - a % 4 * 2;
                    i[o >>> 2] |= c << 24 - o % 4 * 8, o++;
                }
                return new f(i, o);
            }
        };
        return n;
    }();
});

});

parcelRegister("lzOVk", function(module, exports) {

!function(n, t) {
    var r, i;
    module.exports = t();
}(module.exports, function() {
    return function() {
        "use strict";
        var n = {
            9691: function(n, t, r) {
                r.d(t, {
                    AES: function() {
                        return _;
                    }
                });
                var i, e = r(9456), o = r(787), u = r(5693), f = r(9109), c = (i = function(n, t) {
                    return (i = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(n, t) {
                        n.__proto__ = t;
                    } || function(n, t) {
                        for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
                    })(n, t);
                }, function(n, t) {
                    function r() {
                        this.constructor = n;
                    }
                    i(n, t), n.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
                }), s = function() {
                    return (s = Object.assign || function(n) {
                        for(var t, r = 1, i = arguments.length; r < i; r++)for(var e in t = arguments[r])Object.prototype.hasOwnProperty.call(t, e) && (n[e] = t[e]);
                        return n;
                    }).apply(this, arguments);
                }, a = [], h = [], v = [], w = [], l = [], b = [], d = [], y = [], p = [], O = [];
                !function() {
                    for(var n = [], t = 0; t < 256; t++)n[t] = t < 128 ? t << 1 : t << 1 ^ 283;
                    var r = 0, i = 0;
                    for(t = 0; t < 256; t++){
                        var e = i ^ i << 1 ^ i << 2 ^ i << 3 ^ i << 4;
                        e = e >>> 8 ^ 255 & e ^ 99, a[r] = e, h[e] = r;
                        var o = n[r], u = n[o], f = n[u], c = 257 * n[e] ^ 16843008 * e;
                        v[r] = c << 24 | c >>> 8, w[r] = c << 16 | c >>> 16, l[r] = c << 8 | c >>> 24, b[r] = c, c = 16843009 * f ^ 65537 * u ^ 257 * o ^ 16843008 * r, d[e] = c << 24 | c >>> 8, y[e] = c << 16 | c >>> 16, p[e] = c << 8 | c >>> 24, O[e] = c, r ? (r = o ^ n[n[n[f ^ o]]], i ^= n[n[i]]) : r = i = 1;
                    }
                }();
                var j = [
                    0,
                    1,
                    2,
                    4,
                    8,
                    16,
                    32,
                    64,
                    128,
                    27,
                    54
                ], _ = function(n) {
                    function t(t) {
                        var r = n.call(this, t) || this;
                        return r.u = 0, r.h = [], r.v = [], r.O = t, r.A(), r;
                    }
                    return c(t, n), t.prototype.A = function() {
                        var n;
                        if (!this.u || this.k !== this.H) {
                            for(var t = this.k = this.H, r = t.words, i = t.nSigBytes / 4, e = 4 * ((this.u = i + 6) + 1), o = this.h = [], u = 0; u < e; u++)u < i ? o[u] = r[u] : (n = o[u - 1], u % i ? i > 6 && u % i == 4 && (n = a[n >>> 24] << 24 | a[n >>> 16 & 255] << 16 | a[n >>> 8 & 255] << 8 | a[255 & n]) : (n = a[(n = n << 8 | n >>> 24) >>> 24] << 24 | a[n >>> 16 & 255] << 16 | a[n >>> 8 & 255] << 8 | a[255 & n], n ^= j[u / i | 0] << 24), o[u] = o[u - i] ^ n);
                            this.v = [];
                            for(var f = 0; f < e; f++){
                                u = e - f;
                                n = f % 4 ? o[u] : o[u - 4], this.v[f] = f < 4 || u <= 4 ? n : d[a[n >>> 24]] ^ y[a[n >>> 16 & 255]] ^ p[a[n >>> 8 & 255]] ^ O[a[255 & n]];
                            }
                        }
                    }, t.prototype.encryptBlock = function(n, t) {
                        this.B(n, t, this.h, v, w, l, b, a);
                    }, t.prototype.decryptBlock = function(n, t) {
                        var r = n[t + 1];
                        n[t + 1] = n[t + 3], n[t + 3] = r, this.B(n, t, this.v, d, y, p, O, h), r = n[t + 1], n[t + 1] = n[t + 3], n[t + 3] = r;
                    }, t.prototype.B = function(n, t, r, i, e, o, u, f) {
                        for(var c = this.u, s = n[t] ^ r[0], a = n[t + 1] ^ r[1], h = n[t + 2] ^ r[2], v = n[t + 3] ^ r[3], w = 4, l = 1; l < c; l++){
                            var b = i[s >>> 24] ^ e[a >>> 16 & 255] ^ o[h >>> 8 & 255] ^ u[255 & v] ^ r[w++], d = i[a >>> 24] ^ e[h >>> 16 & 255] ^ o[v >>> 8 & 255] ^ u[255 & s] ^ r[w++], y = i[h >>> 24] ^ e[v >>> 16 & 255] ^ o[s >>> 8 & 255] ^ u[255 & a] ^ r[w++], p = i[v >>> 24] ^ e[s >>> 16 & 255] ^ o[a >>> 8 & 255] ^ u[255 & h] ^ r[w++];
                            s = b, a = d, h = y, v = p;
                        }
                        var O = (f[s >>> 24] << 24 | f[a >>> 16 & 255] << 16 | f[h >>> 8 & 255] << 8 | f[255 & v]) ^ r[w++], j = (f[a >>> 24] << 24 | f[h >>> 16 & 255] << 16 | f[v >>> 8 & 255] << 8 | f[255 & s]) ^ r[w++], _ = (f[h >>> 24] << 24 | f[v >>> 16 & 255] << 16 | f[s >>> 8 & 255] << 8 | f[255 & a]) ^ r[w++], m = (f[v >>> 24] << 24 | f[s >>> 16 & 255] << 16 | f[a >>> 8 & 255] << 8 | f[255 & h]) ^ r[w++];
                        n[t] = O, n[t + 1] = j, n[t + 2] = _, n[t + 3] = m;
                    }, t.createEncryptor = function(n, r) {
                        return new t(s(s({}, r = void 0 === r ? {} : r), {
                            key: n,
                            transformMode: e.t.ENC_TRANSFORM_MODE
                        }));
                    }, t.createDecryptor = function(n, r) {
                        return new t(s(s({}, r = void 0 === r ? {} : r), {
                            key: n,
                            transformMode: e.t.DEC_TRANSFORM_MODE
                        }));
                    }, t.encrypt = function(n, r, i) {
                        if ("string" == typeof r) return u.E.encrypt(t, n, r, i);
                        if (r.nSigBytes % 4 != 0) throw new Error("Key size must be multiple of 32bit/4byte/1word");
                        return f.D.encrypt(t, n, r, i);
                    }, t.decrypt = function(n, r, i) {
                        if ("string" == typeof r) return u.E.decrypt(t, n, r, i);
                        if (r.nSigBytes % 4 != 0) throw new Error("Key size must be multiple of 32bit/4byte/1word");
                        return f.D.decrypt(t, n, r, i);
                    }, t.keySize = 8, t;
                }(o.G);
            },
            3967: function(n, t, r) {
                r.d(t, {
                    CBCMAC: function() {
                        return f;
                    }
                });
                var i = r(4768), e = r(3354), o = r(9691), u = r(3664);
                function f(n, t, r, f, c, s) {
                    var a = s && s.Cipher ? s.Cipher : o.AES, h = "string" == typeof r ? i.d.parse(r) : r, v = f || new e.e([
                        0,
                        0
                    ]), w = "string" == typeof t ? i.d.parse(t) : t, l = "string" == typeof n ? i.d.parse(n) : n, b = c || 16;
                    return u.K.mac(a, h, v, w, l, b);
                }
            },
            9910: function(n, t, r) {
                r.d(t, {
                    DES: function() {
                        return b;
                    }
                });
                var i, e = r(787), o = r(9456), u = r(5693), f = r(9109), c = (i = function(n, t) {
                    return (i = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(n, t) {
                        n.__proto__ = t;
                    } || function(n, t) {
                        for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
                    })(n, t);
                }, function(n, t) {
                    function r() {
                        this.constructor = n;
                    }
                    i(n, t), n.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
                }), s = function() {
                    return (s = Object.assign || function(n) {
                        for(var t, r = 1, i = arguments.length; r < i; r++)for(var e in t = arguments[r])Object.prototype.hasOwnProperty.call(t, e) && (n[e] = t[e]);
                        return n;
                    }).apply(this, arguments);
                }, a = [
                    57,
                    49,
                    41,
                    33,
                    25,
                    17,
                    9,
                    1,
                    58,
                    50,
                    42,
                    34,
                    26,
                    18,
                    10,
                    2,
                    59,
                    51,
                    43,
                    35,
                    27,
                    19,
                    11,
                    3,
                    60,
                    52,
                    44,
                    36,
                    63,
                    55,
                    47,
                    39,
                    31,
                    23,
                    15,
                    7,
                    62,
                    54,
                    46,
                    38,
                    30,
                    22,
                    14,
                    6,
                    61,
                    53,
                    45,
                    37,
                    29,
                    21,
                    13,
                    5,
                    28,
                    20,
                    12,
                    4
                ], h = [
                    14,
                    17,
                    11,
                    24,
                    1,
                    5,
                    3,
                    28,
                    15,
                    6,
                    21,
                    10,
                    23,
                    19,
                    12,
                    4,
                    26,
                    8,
                    16,
                    7,
                    27,
                    20,
                    13,
                    2,
                    41,
                    52,
                    31,
                    37,
                    47,
                    55,
                    30,
                    40,
                    51,
                    45,
                    33,
                    48,
                    44,
                    49,
                    39,
                    56,
                    34,
                    53,
                    46,
                    42,
                    50,
                    36,
                    29,
                    32
                ], v = [
                    1,
                    2,
                    4,
                    6,
                    8,
                    10,
                    12,
                    14,
                    15,
                    17,
                    19,
                    21,
                    23,
                    25,
                    27,
                    28
                ], w = [
                    {
                        0: 8421888,
                        268435456: 32768,
                        536870912: 8421378,
                        805306368: 2,
                        1073741824: 512,
                        1342177280: 8421890,
                        1610612736: 8389122,
                        1879048192: 8388608,
                        2147483648: 514,
                        2415919104: 8389120,
                        2684354560: 33280,
                        2952790016: 8421376,
                        3221225472: 32770,
                        3489660928: 8388610,
                        3758096384: 0,
                        4026531840: 33282,
                        134217728: 0,
                        402653184: 8421890,
                        671088640: 33282,
                        939524096: 32768,
                        1207959552: 8421888,
                        1476395008: 512,
                        1744830464: 8421378,
                        2013265920: 2,
                        2281701376: 8389120,
                        2550136832: 33280,
                        2818572288: 8421376,
                        3087007744: 8389122,
                        3355443200: 8388610,
                        3623878656: 32770,
                        3892314112: 514,
                        4160749568: 8388608,
                        1: 32768,
                        268435457: 2,
                        536870913: 8421888,
                        805306369: 8388608,
                        1073741825: 8421378,
                        1342177281: 33280,
                        1610612737: 512,
                        1879048193: 8389122,
                        2147483649: 8421890,
                        2415919105: 8421376,
                        2684354561: 8388610,
                        2952790017: 33282,
                        3221225473: 514,
                        3489660929: 8389120,
                        3758096385: 32770,
                        4026531841: 0,
                        134217729: 8421890,
                        402653185: 8421376,
                        671088641: 8388608,
                        939524097: 512,
                        1207959553: 32768,
                        1476395009: 8388610,
                        1744830465: 2,
                        2013265921: 33282,
                        2281701377: 32770,
                        2550136833: 8389122,
                        2818572289: 514,
                        3087007745: 8421888,
                        3355443201: 8389120,
                        3623878657: 0,
                        3892314113: 33280,
                        4160749569: 8421378
                    },
                    {
                        0: 1074282512,
                        16777216: 16384,
                        33554432: 524288,
                        50331648: 1074266128,
                        67108864: 1073741840,
                        83886080: 1074282496,
                        100663296: 1073758208,
                        117440512: 16,
                        134217728: 540672,
                        150994944: 1073758224,
                        167772160: 1073741824,
                        184549376: 540688,
                        201326592: 524304,
                        218103808: 0,
                        234881024: 16400,
                        251658240: 1074266112,
                        8388608: 1073758208,
                        25165824: 540688,
                        41943040: 16,
                        58720256: 1073758224,
                        75497472: 1074282512,
                        92274688: 1073741824,
                        109051904: 524288,
                        125829120: 1074266128,
                        142606336: 524304,
                        159383552: 0,
                        176160768: 16384,
                        192937984: 1074266112,
                        209715200: 1073741840,
                        226492416: 540672,
                        243269632: 1074282496,
                        260046848: 16400,
                        268435456: 0,
                        285212672: 1074266128,
                        301989888: 1073758224,
                        318767104: 1074282496,
                        335544320: 1074266112,
                        352321536: 16,
                        369098752: 540688,
                        385875968: 16384,
                        402653184: 16400,
                        419430400: 524288,
                        436207616: 524304,
                        452984832: 1073741840,
                        469762048: 540672,
                        486539264: 1073758208,
                        503316480: 1073741824,
                        520093696: 1074282512,
                        276824064: 540688,
                        293601280: 524288,
                        310378496: 1074266112,
                        327155712: 16384,
                        343932928: 1073758208,
                        360710144: 1074282512,
                        377487360: 16,
                        394264576: 1073741824,
                        411041792: 1074282496,
                        427819008: 1073741840,
                        444596224: 1073758224,
                        461373440: 524304,
                        478150656: 0,
                        494927872: 16400,
                        511705088: 1074266128,
                        528482304: 540672
                    },
                    {
                        0: 260,
                        1048576: 0,
                        2097152: 67109120,
                        3145728: 65796,
                        4194304: 65540,
                        5242880: 67108868,
                        6291456: 67174660,
                        7340032: 67174400,
                        8388608: 67108864,
                        9437184: 67174656,
                        10485760: 65792,
                        11534336: 67174404,
                        12582912: 67109124,
                        13631488: 65536,
                        14680064: 4,
                        15728640: 256,
                        524288: 67174656,
                        1572864: 67174404,
                        2621440: 0,
                        3670016: 67109120,
                        4718592: 67108868,
                        5767168: 65536,
                        6815744: 65540,
                        7864320: 260,
                        8912896: 4,
                        9961472: 256,
                        11010048: 67174400,
                        12058624: 65796,
                        13107200: 65792,
                        14155776: 67109124,
                        15204352: 67174660,
                        16252928: 67108864,
                        16777216: 67174656,
                        17825792: 65540,
                        18874368: 65536,
                        19922944: 67109120,
                        20971520: 256,
                        22020096: 67174660,
                        23068672: 67108868,
                        24117248: 0,
                        25165824: 67109124,
                        26214400: 67108864,
                        27262976: 4,
                        28311552: 65792,
                        29360128: 67174400,
                        30408704: 260,
                        31457280: 65796,
                        32505856: 67174404,
                        17301504: 67108864,
                        18350080: 260,
                        19398656: 67174656,
                        20447232: 0,
                        21495808: 65540,
                        22544384: 67109120,
                        23592960: 256,
                        24641536: 67174404,
                        25690112: 65536,
                        26738688: 67174660,
                        27787264: 65796,
                        28835840: 67108868,
                        29884416: 67109124,
                        30932992: 67174400,
                        31981568: 4,
                        33030144: 65792
                    },
                    {
                        0: 2151682048,
                        65536: 2147487808,
                        131072: 4198464,
                        196608: 2151677952,
                        262144: 0,
                        327680: 4198400,
                        393216: 2147483712,
                        458752: 4194368,
                        524288: 2147483648,
                        589824: 4194304,
                        655360: 64,
                        720896: 2147487744,
                        786432: 2151678016,
                        851968: 4160,
                        917504: 4096,
                        983040: 2151682112,
                        32768: 2147487808,
                        98304: 64,
                        163840: 2151678016,
                        229376: 2147487744,
                        294912: 4198400,
                        360448: 2151682112,
                        425984: 0,
                        491520: 2151677952,
                        557056: 4096,
                        622592: 2151682048,
                        688128: 4194304,
                        753664: 4160,
                        819200: 2147483648,
                        884736: 4194368,
                        950272: 4198464,
                        1015808: 2147483712,
                        1048576: 4194368,
                        1114112: 4198400,
                        1179648: 2147483712,
                        1245184: 0,
                        1310720: 4160,
                        1376256: 2151678016,
                        1441792: 2151682048,
                        1507328: 2147487808,
                        1572864: 2151682112,
                        1638400: 2147483648,
                        1703936: 2151677952,
                        1769472: 4198464,
                        1835008: 2147487744,
                        1900544: 4194304,
                        1966080: 64,
                        2031616: 4096,
                        1081344: 2151677952,
                        1146880: 2151682112,
                        1212416: 0,
                        1277952: 4198400,
                        1343488: 4194368,
                        1409024: 2147483648,
                        1474560: 2147487808,
                        1540096: 64,
                        1605632: 2147483712,
                        1671168: 4096,
                        1736704: 2147487744,
                        1802240: 2151678016,
                        1867776: 4160,
                        1933312: 2151682048,
                        1998848: 4194304,
                        2064384: 4198464
                    },
                    {
                        0: 128,
                        4096: 17039360,
                        8192: 262144,
                        12288: 536870912,
                        16384: 537133184,
                        20480: 16777344,
                        24576: 553648256,
                        28672: 262272,
                        32768: 16777216,
                        36864: 537133056,
                        40960: 536871040,
                        45056: 553910400,
                        49152: 553910272,
                        53248: 0,
                        57344: 17039488,
                        61440: 553648128,
                        2048: 17039488,
                        6144: 553648256,
                        10240: 128,
                        14336: 17039360,
                        18432: 262144,
                        22528: 537133184,
                        26624: 553910272,
                        30720: 536870912,
                        34816: 537133056,
                        38912: 0,
                        43008: 553910400,
                        47104: 16777344,
                        51200: 536871040,
                        55296: 553648128,
                        59392: 16777216,
                        63488: 262272,
                        65536: 262144,
                        69632: 128,
                        73728: 536870912,
                        77824: 553648256,
                        81920: 16777344,
                        86016: 553910272,
                        90112: 537133184,
                        94208: 16777216,
                        98304: 553910400,
                        102400: 553648128,
                        106496: 17039360,
                        110592: 537133056,
                        114688: 262272,
                        118784: 536871040,
                        122880: 0,
                        126976: 17039488,
                        67584: 553648256,
                        71680: 16777216,
                        75776: 17039360,
                        79872: 537133184,
                        83968: 536870912,
                        88064: 17039488,
                        92160: 128,
                        96256: 553910272,
                        100352: 262272,
                        104448: 553910400,
                        108544: 0,
                        112640: 553648128,
                        116736: 16777344,
                        120832: 262144,
                        124928: 537133056,
                        129024: 536871040
                    },
                    {
                        0: 268435464,
                        256: 8192,
                        512: 270532608,
                        768: 270540808,
                        1024: 268443648,
                        1280: 2097152,
                        1536: 2097160,
                        1792: 268435456,
                        2048: 0,
                        2304: 268443656,
                        2560: 2105344,
                        2816: 8,
                        3072: 270532616,
                        3328: 2105352,
                        3584: 8200,
                        3840: 270540800,
                        128: 270532608,
                        384: 270540808,
                        640: 8,
                        896: 2097152,
                        1152: 2105352,
                        1408: 268435464,
                        1664: 268443648,
                        1920: 8200,
                        2176: 2097160,
                        2432: 8192,
                        2688: 268443656,
                        2944: 270532616,
                        3200: 0,
                        3456: 270540800,
                        3712: 2105344,
                        3968: 268435456,
                        4096: 268443648,
                        4352: 270532616,
                        4608: 270540808,
                        4864: 8200,
                        5120: 2097152,
                        5376: 268435456,
                        5632: 268435464,
                        5888: 2105344,
                        6144: 2105352,
                        6400: 0,
                        6656: 8,
                        6912: 270532608,
                        7168: 8192,
                        7424: 268443656,
                        7680: 270540800,
                        7936: 2097160,
                        4224: 8,
                        4480: 2105344,
                        4736: 2097152,
                        4992: 268435464,
                        5248: 268443648,
                        5504: 8200,
                        5760: 270540808,
                        6016: 270532608,
                        6272: 270540800,
                        6528: 270532616,
                        6784: 8192,
                        7040: 2105352,
                        7296: 2097160,
                        7552: 0,
                        7808: 268435456,
                        8064: 268443656
                    },
                    {
                        0: 1048576,
                        16: 33555457,
                        32: 1024,
                        48: 1049601,
                        64: 34604033,
                        80: 0,
                        96: 1,
                        112: 34603009,
                        128: 33555456,
                        144: 1048577,
                        160: 33554433,
                        176: 34604032,
                        192: 34603008,
                        208: 1025,
                        224: 1049600,
                        240: 33554432,
                        8: 34603009,
                        24: 0,
                        40: 33555457,
                        56: 34604032,
                        72: 1048576,
                        88: 33554433,
                        104: 33554432,
                        120: 1025,
                        136: 1049601,
                        152: 33555456,
                        168: 34603008,
                        184: 1048577,
                        200: 1024,
                        216: 34604033,
                        232: 1,
                        248: 1049600,
                        256: 33554432,
                        272: 1048576,
                        288: 33555457,
                        304: 34603009,
                        320: 1048577,
                        336: 33555456,
                        352: 34604032,
                        368: 1049601,
                        384: 1025,
                        400: 34604033,
                        416: 1049600,
                        432: 1,
                        448: 0,
                        464: 34603008,
                        480: 33554433,
                        496: 1024,
                        264: 1049600,
                        280: 33555457,
                        296: 34603009,
                        312: 1,
                        328: 33554432,
                        344: 1048576,
                        360: 1025,
                        376: 34604032,
                        392: 33554433,
                        408: 34603008,
                        424: 0,
                        440: 34604033,
                        456: 1049601,
                        472: 1024,
                        488: 33555456,
                        504: 1048577
                    },
                    {
                        0: 134219808,
                        1: 131072,
                        2: 134217728,
                        3: 32,
                        4: 131104,
                        5: 134350880,
                        6: 134350848,
                        7: 2048,
                        8: 134348800,
                        9: 134219776,
                        10: 133120,
                        11: 134348832,
                        12: 2080,
                        13: 0,
                        14: 134217760,
                        15: 133152,
                        2147483648: 2048,
                        2147483649: 134350880,
                        2147483650: 134219808,
                        2147483651: 134217728,
                        2147483652: 134348800,
                        2147483653: 133120,
                        2147483654: 133152,
                        2147483655: 32,
                        2147483656: 134217760,
                        2147483657: 2080,
                        2147483658: 131104,
                        2147483659: 134350848,
                        2147483660: 0,
                        2147483661: 134348832,
                        2147483662: 134219776,
                        2147483663: 131072,
                        16: 133152,
                        17: 134350848,
                        18: 32,
                        19: 2048,
                        20: 134219776,
                        21: 134217760,
                        22: 134348832,
                        23: 131072,
                        24: 0,
                        25: 131104,
                        26: 134348800,
                        27: 134219808,
                        28: 134350880,
                        29: 133120,
                        30: 2080,
                        31: 134217728,
                        2147483664: 131072,
                        2147483665: 2048,
                        2147483666: 134348832,
                        2147483667: 133152,
                        2147483668: 32,
                        2147483669: 134348800,
                        2147483670: 134217728,
                        2147483671: 134219808,
                        2147483672: 134350880,
                        2147483673: 134217760,
                        2147483674: 134219776,
                        2147483675: 0,
                        2147483676: 133120,
                        2147483677: 2080,
                        2147483678: 131104,
                        2147483679: 134350848
                    }
                ], l = [
                    4160749569,
                    528482304,
                    33030144,
                    2064384,
                    129024,
                    8064,
                    504,
                    2147483679
                ], b = function(n) {
                    function t(t) {
                        var r = n.call(this, t) || this;
                        return r.N = 2, r.I = [], r.U = [], r.L = 0, r.F = 0, r.O = t, r.A(), r;
                    }
                    return c(t, n), t.prototype.A = function() {
                        for(var n = this.H.words, t = [], r = 0; r < 56; r++){
                            var i = a[r] - 1;
                            t[r] = n[i >>> 5] >>> 31 - i % 32 & 1;
                        }
                        for(var e = this.I = [], o = 0; o < 16; o++){
                            var u = e[o] = [], f = v[o];
                            for(r = 0; r < 24; r++)u[r / 6 | 0] |= t[(h[r] - 1 + f) % 28] << 31 - r % 6, u[4 + (r / 6 | 0)] |= t[28 + (h[r + 24] - 1 + f) % 28] << 31 - r % 6;
                            u[0] = u[0] << 1 | u[0] >>> 31;
                            for(r = 1; r < 7; r++)u[r] = u[r] >>> 4 * (r - 1) + 3;
                            u[7] = u[7] << 5 | u[7] >>> 27;
                        }
                        this.U = [];
                        for(r = 0; r < 16; r++)this.U[r] = e[15 - r];
                    }, t.prototype.encryptBlock = function(n, t) {
                        this.R(n, t, this.I);
                    }, t.prototype.decryptBlock = function(n, t) {
                        this.R(n, t, this.U);
                    }, t.prototype.R = function(n, t, r) {
                        this.L = n[t], this.F = n[t + 1], this.X(4, 252645135), this.X(16, 65535), this.Z(2, 858993459), this.Z(8, 16711935), this.X(1, 1431655765);
                        for(var i = 0; i < 16; i++){
                            for(var e = r[i], o = this.L, u = this.F, f = 0, c = 0; c < 8; c++){
                                var s = (u ^ e[c]) & l[c];
                                f |= w[c][s >>> 0];
                            }
                            this.L = u, this.F = o ^ f;
                        }
                        var a = this.L;
                        this.L = this.F, this.F = a, this.X(1, 1431655765), this.Z(8, 16711935), this.Z(2, 858993459), this.X(16, 65535), this.X(4, 252645135), n[t] = this.L, n[t + 1] = this.F;
                    }, t.prototype.X = function(n, t) {
                        var r = (this.L >>> n ^ this.F) & t;
                        this.F ^= r, this.L ^= r << n;
                    }, t.prototype.Z = function(n, t) {
                        var r = (this.F >>> n ^ this.L) & t;
                        this.L ^= r, this.F ^= r << n;
                    }, t.createEncryptor = function(n, r) {
                        return new t(s(s({}, r = void 0 === r ? {} : r), {
                            key: n,
                            transformMode: o.t.ENC_TRANSFORM_MODE
                        }));
                    }, t.createDecryptor = function(n, r) {
                        return new t(s(s({}, r = void 0 === r ? {} : r), {
                            key: n,
                            transformMode: o.t.DEC_TRANSFORM_MODE
                        }));
                    }, t.encrypt = function(n, r, i) {
                        return "string" == typeof r ? u.E.encrypt(t, n, r, i) : f.D.encrypt(t, n, r, i);
                    }, t.decrypt = function(n, r, i) {
                        return "string" == typeof r ? u.E.decrypt(t, n, r, i) : f.D.decrypt(t, n, r, i);
                    }, t.keySize = 2, t.ivSize = 2, t;
                }(e.G);
            },
            6739: function(n, t, r) {
                r.d(t, {
                    DES3: function() {
                        return v;
                    }
                });
                var i, e = r(9109), o = r(787), u = r(9456), f = r(9910), c = r(3354), s = r(5693), a = (i = function(n, t) {
                    return (i = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(n, t) {
                        n.__proto__ = t;
                    } || function(n, t) {
                        for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
                    })(n, t);
                }, function(n, t) {
                    function r() {
                        this.constructor = n;
                    }
                    i(n, t), n.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
                }), h = function() {
                    return (h = Object.assign || function(n) {
                        for(var t, r = 1, i = arguments.length; r < i; r++)for(var e in t = arguments[r])Object.prototype.hasOwnProperty.call(t, e) && (n[e] = t[e]);
                        return n;
                    }).apply(this, arguments);
                }, v = function(n) {
                    function t(t) {
                        var r = n.call(this, t) || this;
                        r.N = 2, r.O = t;
                        var i = r.J();
                        return r.Y = i[0], r.$ = i[1], r.nn = i[2], r;
                    }
                    return a(t, n), t.prototype.J = function() {
                        var n = this.H.words;
                        if (2 !== n.length && 4 !== n.length && n.length < 6) throw new Error("Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.");
                        var t = n.slice(0, 2), r = n.length < 4 ? n.slice(0, 2) : n.slice(2, 4), i = n.length < 6 ? n.slice(0, 2) : n.slice(4, 6);
                        return [
                            f.DES.createEncryptor(new c.e(t)),
                            f.DES.createEncryptor(new c.e(r)),
                            f.DES.createEncryptor(new c.e(i))
                        ];
                    }, t.prototype.A = function() {
                        var n = this.J();
                        this.Y = n[0], this.$ = n[1], this.nn = n[2];
                    }, t.prototype.encryptBlock = function(n, t) {
                        this.Y.encryptBlock(n, t), this.$.decryptBlock(n, t), this.nn.encryptBlock(n, t);
                    }, t.prototype.decryptBlock = function(n, t) {
                        this.nn.decryptBlock(n, t), this.$.encryptBlock(n, t), this.Y.decryptBlock(n, t);
                    }, t.createEncryptor = function(n, r) {
                        return new t(h(h({}, r = void 0 === r ? {} : r), {
                            key: n,
                            transformMode: u.t.ENC_TRANSFORM_MODE
                        }));
                    }, t.createDecryptor = function(n, r) {
                        return new t(h(h({}, r = void 0 === r ? {} : r), {
                            key: n,
                            transformMode: u.t.DEC_TRANSFORM_MODE
                        }));
                    }, t.encrypt = function(n, r, i) {
                        return "string" == typeof r ? s.E.encrypt(t, n, r, i) : e.D.encrypt(t, n, r, i);
                    }, t.decrypt = function(n, r, i) {
                        return "string" == typeof r ? s.E.decrypt(t, n, r, i) : e.D.decrypt(t, n, r, i);
                    }, t.keySize = 6, t.ivSize = 2, t;
                }(o.G);
            },
            7753: function(n, t, r) {
                r.d(t, {
                    GMAC: function() {
                        return f;
                    }
                });
                var i = r(4768), e = r(3354), o = r(9691), u = r(5607);
                function f(n, t, r, f, c) {
                    var s = "string" == typeof n ? i.d.parse(n) : n, a = r || new e.e([
                        0,
                        0,
                        0,
                        0
                    ]), h = c && c.Cipher ? c.Cipher : o.AES, v = "string" == typeof t ? i.d.parse(t) : t, w = f || 16;
                    return u.V.mac(h, v, a, s, void 0, w);
                }
            },
            6367: function(n, t, r) {
                r.d(t, {
                    Hmac: function() {
                        return e;
                    }
                });
                var i = r(4768), e = function() {
                    function n(n, t) {
                        this.tn = n, "string" == typeof t && (t = i.d.parse(t));
                        var r = n.blockSize, e = 4 * r;
                        t.nSigBytes > e && (t = n.finalize(t)), t.clamp();
                        for(var o = this.rn = t.clone(), u = this.en = t.clone(), f = o.words, c = u.words, s = 0; s < r; s++)f[s] ^= 1549556828, c[s] ^= 909522486;
                        u.nSigBytes = e, o.nSigBytes = e, this.reset();
                    }
                    return n.prototype.reset = function() {
                        this.tn.reset(), this.tn.update(this.en);
                    }, n.prototype.update = function(n) {
                        return this.tn.update(n), this;
                    }, n.prototype.finalize = function(n) {
                        var t = this.tn.finalize(n);
                        return this.tn.reset(), this.tn.finalize(this.rn.clone().concat(t));
                    }, n;
                }();
            },
            3027: function(n, t, r) {
                r.d(t, {
                    HmacMD5: function() {
                        return o;
                    }
                });
                var i = r(6367), e = r(670);
                function o(n, t) {
                    return new i.Hmac(new e.MD5, t).finalize(n);
                }
            },
            149: function(n, t, r) {
                r.d(t, {
                    HmacSHA1: function() {
                        return o;
                    }
                });
                var i = r(6367), e = r(3173);
                function o(n, t) {
                    return new i.Hmac(new e.SHA1, t).finalize(n);
                }
            },
            4105: function(n, t, r) {
                r.d(t, {
                    HmacSHA224: function() {
                        return o;
                    }
                });
                var i = r(6367), e = r(766);
                function o(n, t) {
                    return new i.Hmac(new e.SHA224, t).finalize(n);
                }
            },
            980: function(n, t, r) {
                r.d(t, {
                    HmacSHA256: function() {
                        return o;
                    }
                });
                var i = r(6367), e = r(5561);
                function o(n, t) {
                    return new i.Hmac(new e.SHA256, t).finalize(n);
                }
            },
            5838: function(n, t, r) {
                r.d(t, {
                    HmacSHA384: function() {
                        return o;
                    }
                });
                var i = r(6367), e = r(6324);
                function o(n, t) {
                    return new i.Hmac(new e.SHA384, t).finalize(n);
                }
            },
            9902: function(n, t, r) {
                r.d(t, {
                    HmacSHA512: function() {
                        return o;
                    }
                });
                var i = r(6367), e = r(7491);
                function o(n, t) {
                    return new i.Hmac(new e.SHA512, t).finalize(n);
                }
            },
            670: function(n, t, r) {
                r.d(t, {
                    MD5: function() {
                        return v;
                    }
                });
                var i, e = r(3354), o = r(1868), u = (i = function(n, t) {
                    return (i = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(n, t) {
                        n.__proto__ = t;
                    } || function(n, t) {
                        for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
                    })(n, t);
                }, function(n, t) {
                    function r() {
                        this.constructor = n;
                    }
                    i(n, t), n.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
                }), f = [];
                function c(n, t, r, i, e, o, u) {
                    var f = n + (t & r | ~t & i) + e + u;
                    return (f << o | f >>> 32 - o) + t;
                }
                function s(n, t, r, i, e, o, u) {
                    var f = n + (t & i | r & ~i) + e + u;
                    return (f << o | f >>> 32 - o) + t;
                }
                function a(n, t, r, i, e, o, u) {
                    var f = n + (t ^ r ^ i) + e + u;
                    return (f << o | f >>> 32 - o) + t;
                }
                function h(n, t, r, i, e, o, u) {
                    var f = n + (r ^ (t | ~i)) + e + u;
                    return (f << o | f >>> 32 - o) + t;
                }
                !function() {
                    for(var n = 0; n < 64; n++)f[n] = 4294967296 * Math.abs(Math.sin(n + 1)) | 0;
                }();
                var v = function(n) {
                    function t(t) {
                        var r = n.call(this, t) || this;
                        return r.on = new e.e([
                            1732584193,
                            4023233417,
                            2562383102,
                            271733878
                        ]), t && void 0 !== t.hash && (r.on = t.hash.clone()), r;
                    }
                    return u(t, n), t.prototype.A = function() {
                        this.on = new e.e([
                            1732584193,
                            4023233417,
                            2562383102,
                            271733878
                        ]);
                    }, t.prototype.un = function(n, t) {
                        for(var r = 0; r < 16; r++){
                            var i = t + r, e = n[i];
                            n[i] = 16711935 & (e << 8 | e >>> 24) | 4278255360 & (e << 24 | e >>> 8);
                        }
                        var o = this.on.words, u = n[t], v = n[t + 1], w = n[t + 2], l = n[t + 3], b = n[t + 4], d = n[t + 5], y = n[t + 6], p = n[t + 7], O = n[t + 8], j = n[t + 9], _ = n[t + 10], m = n[t + 11], A = n[t + 12], g = n[t + 13], E = n[t + 14], S = n[t + 15], M = o[0], k = o[1], H = o[2], C = o[3];
                        M = c(M, k, H, C, u, 7, f[0]), C = c(C, M, k, H, v, 12, f[1]), H = c(H, C, M, k, w, 17, f[2]), k = c(k, H, C, M, l, 22, f[3]), M = c(M, k, H, C, b, 7, f[4]), C = c(C, M, k, H, d, 12, f[5]), H = c(H, C, M, k, y, 17, f[6]), k = c(k, H, C, M, p, 22, f[7]), M = c(M, k, H, C, O, 7, f[8]), C = c(C, M, k, H, j, 12, f[9]), H = c(H, C, M, k, _, 17, f[10]), k = c(k, H, C, M, m, 22, f[11]), M = c(M, k, H, C, A, 7, f[12]), C = c(C, M, k, H, g, 12, f[13]), H = c(H, C, M, k, E, 17, f[14]), M = s(M, k = c(k, H, C, M, S, 22, f[15]), H, C, v, 5, f[16]), C = s(C, M, k, H, y, 9, f[17]), H = s(H, C, M, k, m, 14, f[18]), k = s(k, H, C, M, u, 20, f[19]), M = s(M, k, H, C, d, 5, f[20]), C = s(C, M, k, H, _, 9, f[21]), H = s(H, C, M, k, S, 14, f[22]), k = s(k, H, C, M, b, 20, f[23]), M = s(M, k, H, C, j, 5, f[24]), C = s(C, M, k, H, E, 9, f[25]), H = s(H, C, M, k, l, 14, f[26]), k = s(k, H, C, M, O, 20, f[27]), M = s(M, k, H, C, g, 5, f[28]), C = s(C, M, k, H, w, 9, f[29]), H = s(H, C, M, k, p, 14, f[30]), M = a(M, k = s(k, H, C, M, A, 20, f[31]), H, C, d, 4, f[32]), C = a(C, M, k, H, O, 11, f[33]), H = a(H, C, M, k, m, 16, f[34]), k = a(k, H, C, M, E, 23, f[35]), M = a(M, k, H, C, v, 4, f[36]), C = a(C, M, k, H, b, 11, f[37]), H = a(H, C, M, k, p, 16, f[38]), k = a(k, H, C, M, _, 23, f[39]), M = a(M, k, H, C, g, 4, f[40]), C = a(C, M, k, H, u, 11, f[41]), H = a(H, C, M, k, l, 16, f[42]), k = a(k, H, C, M, y, 23, f[43]), M = a(M, k, H, C, j, 4, f[44]), C = a(C, M, k, H, A, 11, f[45]), H = a(H, C, M, k, S, 16, f[46]), M = h(M, k = a(k, H, C, M, w, 23, f[47]), H, C, u, 6, f[48]), C = h(C, M, k, H, p, 10, f[49]), H = h(H, C, M, k, E, 15, f[50]), k = h(k, H, C, M, d, 21, f[51]), M = h(M, k, H, C, A, 6, f[52]), C = h(C, M, k, H, l, 10, f[53]), H = h(H, C, M, k, _, 15, f[54]), k = h(k, H, C, M, v, 21, f[55]), M = h(M, k, H, C, O, 6, f[56]), C = h(C, M, k, H, S, 10, f[57]), H = h(H, C, M, k, y, 15, f[58]), k = h(k, H, C, M, g, 21, f[59]), M = h(M, k, H, C, b, 6, f[60]), C = h(C, M, k, H, m, 10, f[61]), H = h(H, C, M, k, w, 15, f[62]), k = h(k, H, C, M, j, 21, f[63]), o[0] = o[0] + M | 0, o[1] = o[1] + k | 0, o[2] = o[2] + H | 0, o[3] = o[3] + C | 0;
                    }, t.prototype.fn = function() {
                        var n = this.cn, t = n.words, r = 8 * this.sn, i = 8 * n.nSigBytes;
                        t[i >>> 5] |= 128 << 24 - i % 32;
                        var e = Math.floor(r / 4294967296), o = r;
                        t[15 + (i + 64 >>> 9 << 4)] = 16711935 & (e << 8 | e >>> 24) | 4278255360 & (e << 24 | e >>> 8), t[14 + (i + 64 >>> 9 << 4)] = 16711935 & (o << 8 | o >>> 24) | 4278255360 & (o << 24 | o >>> 8), n.nSigBytes = 4 * (t.length + 1), this.an();
                        for(var u = this.on, f = u.words, c = 0; c < 4; c++){
                            var s = f[c];
                            f[c] = 16711935 & (s << 8 | s >>> 24) | 4278255360 & (s << 24 | s >>> 8);
                        }
                        return u;
                    }, t.prototype.clone = function() {
                        return new t({
                            hash: this.on,
                            blockSize: this.N,
                            data: this.cn,
                            nBytes: this.sn
                        });
                    }, t.hash = function(n) {
                        return (new t).finalize(n);
                    }, t;
                }(o.P);
            },
            4615: function(n, t, r) {
                r.d(t, {
                    RC4: function() {
                        return s;
                    }
                });
                var i, e = r(30), o = r(5693), u = r(9109), f = (i = function(n, t) {
                    return (i = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(n, t) {
                        n.__proto__ = t;
                    } || function(n, t) {
                        for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
                    })(n, t);
                }, function(n, t) {
                    function r() {
                        this.constructor = n;
                    }
                    i(n, t), n.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
                }), c = function() {
                    return (c = Object.assign || function(n) {
                        for(var t, r = 1, i = arguments.length; r < i; r++)for(var e in t = arguments[r])Object.prototype.hasOwnProperty.call(t, e) && (n[e] = t[e]);
                        return n;
                    }).apply(this, arguments);
                }, s = function(n) {
                    function t(t) {
                        var r = n.call(this, t) || this;
                        return r.S = [], r.i = 0, r.j = 0, r.O = t, r.A(), r;
                    }
                    return f(t, n), t.prototype.A = function() {
                        var n = this.H, t = n.words, r = n.nSigBytes;
                        this.S = [];
                        for(var i = 0; i < 256; i++)this.S[i] = i;
                        i = 0;
                        for(var e = 0; i < 256; i++){
                            var o = i % r, u = t[o >>> 2] >>> 24 - o % 4 * 8 & 255;
                            e = (e + this.S[i] + u) % 256;
                            var f = this.S[i];
                            this.S[i] = this.S[e], this.S[e] = f;
                        }
                        this.i = this.j = 0;
                    }, t.prototype.un = function(n, t) {
                        n[t] ^= this.generateKeyStreamWord();
                    }, t.prototype.generateKeyStreamWord = function() {
                        for(var n = this.S, t = this.i, r = this.j, i = 0, e = 0; e < 4; e++){
                            r = (r + n[t = (t + 1) % 256]) % 256;
                            var o = n[t];
                            n[t] = n[r], n[r] = o, i |= n[(n[t] + n[r]) % 256] << 24 - 8 * e;
                        }
                        return this.i = t, this.j = r, i;
                    }, t.createEncryptor = function(n, r) {
                        return new t(c(c({}, r = void 0 === r ? {} : r), {
                            key: n
                        }));
                    }, t.createDecryptor = function(n, r) {
                        return new t(c(c({}, r = void 0 === r ? {} : r), {
                            key: n
                        }));
                    }, t.encrypt = function(n, r, i) {
                        return "string" == typeof r ? o.E.encrypt(t, n, r, i) : u.D.encrypt(t, n, r, i);
                    }, t.decrypt = function(n, r, i) {
                        return "string" == typeof r ? o.E.decrypt(t, n, r, i) : u.D.decrypt(t, n, r, i);
                    }, t.ivSize = 0, t.keySize = 8, t;
                }(e.q);
            },
            9639: function(n, t, r) {
                r.d(t, {
                    RC4Drop: function() {
                        return s;
                    }
                });
                var i, e = r(5693), o = r(9109), u = r(4615), f = (i = function(n, t) {
                    return (i = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(n, t) {
                        n.__proto__ = t;
                    } || function(n, t) {
                        for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
                    })(n, t);
                }, function(n, t) {
                    function r() {
                        this.constructor = n;
                    }
                    i(n, t), n.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
                }), c = function() {
                    return (c = Object.assign || function(n) {
                        for(var t, r = 1, i = arguments.length; r < i; r++)for(var e in t = arguments[r])Object.prototype.hasOwnProperty.call(t, e) && (n[e] = t[e]);
                        return n;
                    }).apply(this, arguments);
                }, s = function(n) {
                    function t(t) {
                        var r = n.call(this, t) || this;
                        return r.drop = 192, r.O = t, t && "number" == typeof t.drop && (r.drop = t.drop), r.A(), r;
                    }
                    return f(t, n), t.prototype.A = function() {
                        n.prototype.A.call(this);
                        for(var t = this.drop; t > 0; t--)this.generateKeyStreamWord();
                    }, t.createEncryptor = function(n, r) {
                        return new t(c(c({}, r = void 0 === r ? {} : r), {
                            key: n
                        }));
                    }, t.createDecryptor = function(n, r) {
                        return new t(c(c({}, r = void 0 === r ? {} : r), {
                            key: n
                        }));
                    }, t.encrypt = function(n, r, i) {
                        return "string" == typeof r ? e.E.encrypt(t, n, r, i) : o.D.encrypt(t, n, r, i);
                    }, t.decrypt = function(n, r, i) {
                        return "string" == typeof r ? e.E.decrypt(t, n, r, i) : o.D.decrypt(t, n, r, i);
                    }, t;
                }(u.RC4);
            },
            7104: function(n, t, r) {
                r.d(t, {
                    RIPEMD160: function() {
                        return O;
                    }
                });
                var i, e = r(1868), o = r(3354), u = (i = function(n, t) {
                    return (i = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(n, t) {
                        n.__proto__ = t;
                    } || function(n, t) {
                        for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
                    })(n, t);
                }, function(n, t) {
                    function r() {
                        this.constructor = n;
                    }
                    i(n, t), n.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
                }), f = new o.e([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    7,
                    4,
                    13,
                    1,
                    10,
                    6,
                    15,
                    3,
                    12,
                    0,
                    9,
                    5,
                    2,
                    14,
                    11,
                    8,
                    3,
                    10,
                    14,
                    4,
                    9,
                    15,
                    8,
                    1,
                    2,
                    7,
                    0,
                    6,
                    13,
                    11,
                    5,
                    12,
                    1,
                    9,
                    11,
                    10,
                    0,
                    8,
                    12,
                    4,
                    13,
                    3,
                    7,
                    15,
                    14,
                    5,
                    6,
                    2,
                    4,
                    0,
                    5,
                    9,
                    7,
                    12,
                    2,
                    10,
                    14,
                    1,
                    3,
                    8,
                    11,
                    6,
                    15,
                    13
                ]), c = new o.e([
                    5,
                    14,
                    7,
                    0,
                    9,
                    2,
                    11,
                    4,
                    13,
                    6,
                    15,
                    8,
                    1,
                    10,
                    3,
                    12,
                    6,
                    11,
                    3,
                    7,
                    0,
                    13,
                    5,
                    10,
                    14,
                    15,
                    8,
                    12,
                    4,
                    9,
                    1,
                    2,
                    15,
                    5,
                    1,
                    3,
                    7,
                    14,
                    6,
                    9,
                    11,
                    8,
                    12,
                    2,
                    10,
                    0,
                    4,
                    13,
                    8,
                    6,
                    4,
                    1,
                    3,
                    11,
                    15,
                    0,
                    5,
                    12,
                    2,
                    13,
                    9,
                    7,
                    10,
                    14,
                    12,
                    15,
                    10,
                    4,
                    1,
                    5,
                    8,
                    7,
                    6,
                    2,
                    13,
                    14,
                    0,
                    3,
                    9,
                    11
                ]), s = new o.e([
                    11,
                    14,
                    15,
                    12,
                    5,
                    8,
                    7,
                    9,
                    11,
                    13,
                    14,
                    15,
                    6,
                    7,
                    9,
                    8,
                    7,
                    6,
                    8,
                    13,
                    11,
                    9,
                    7,
                    15,
                    7,
                    12,
                    15,
                    9,
                    11,
                    7,
                    13,
                    12,
                    11,
                    13,
                    6,
                    7,
                    14,
                    9,
                    13,
                    15,
                    14,
                    8,
                    13,
                    6,
                    5,
                    12,
                    7,
                    5,
                    11,
                    12,
                    14,
                    15,
                    14,
                    15,
                    9,
                    8,
                    9,
                    14,
                    5,
                    6,
                    8,
                    6,
                    5,
                    12,
                    9,
                    15,
                    5,
                    11,
                    6,
                    8,
                    13,
                    12,
                    5,
                    12,
                    13,
                    14,
                    11,
                    8,
                    5,
                    6
                ]), a = new o.e([
                    8,
                    9,
                    9,
                    11,
                    13,
                    15,
                    15,
                    5,
                    7,
                    7,
                    8,
                    11,
                    14,
                    14,
                    12,
                    6,
                    9,
                    13,
                    15,
                    7,
                    12,
                    8,
                    9,
                    11,
                    7,
                    7,
                    12,
                    7,
                    6,
                    15,
                    13,
                    11,
                    9,
                    7,
                    15,
                    11,
                    8,
                    6,
                    6,
                    14,
                    12,
                    13,
                    5,
                    14,
                    13,
                    13,
                    7,
                    5,
                    15,
                    5,
                    8,
                    11,
                    14,
                    14,
                    6,
                    14,
                    6,
                    9,
                    12,
                    9,
                    12,
                    5,
                    15,
                    8,
                    8,
                    5,
                    12,
                    9,
                    12,
                    5,
                    14,
                    6,
                    8,
                    13,
                    6,
                    5,
                    15,
                    13,
                    11,
                    11
                ]), h = new o.e([
                    0,
                    1518500249,
                    1859775393,
                    2400959708,
                    2840853838
                ]), v = new o.e([
                    1352829926,
                    1548603684,
                    1836072691,
                    2053994217,
                    0
                ]);
                function w(n, t, r) {
                    return n ^ t ^ r;
                }
                function l(n, t, r) {
                    return n & t | ~n & r;
                }
                function b(n, t, r) {
                    return (n | ~t) ^ r;
                }
                function d(n, t, r) {
                    return n & r | t & ~r;
                }
                function y(n, t, r) {
                    return n ^ (t | ~r);
                }
                function p(n, t) {
                    return n << t | n >>> 32 - t;
                }
                var O = function(n) {
                    function t(t) {
                        var r = n.call(this, t) || this;
                        return r.on = new o.e([
                            1732584193,
                            4023233417,
                            2562383102,
                            271733878,
                            3285377520
                        ]), r.O = t, t && void 0 !== t.hash && (r.on = t.hash.clone()), r;
                    }
                    return u(t, n), t.prototype.A = function() {
                        this.on = new o.e([
                            1732584193,
                            4023233417,
                            2562383102,
                            271733878,
                            3285377520
                        ]);
                    }, t.prototype.un = function(n, t) {
                        for(var r = 0; r < 16; r++){
                            var i = t + r, e = n[i];
                            n[i] = 16711935 & (e << 8 | e >>> 24) | 4278255360 & (e << 24 | e >>> 8);
                        }
                        var o, u, O, j, _, m, A, g, E, S, M, k = this.on.words, H = h.words, C = v.words, B = f.words, N = c.words, I = s.words, z = a.words;
                        m = o = k[0], A = u = k[1], g = O = k[2], E = j = k[3], S = _ = k[4];
                        for(r = 0; r < 80; r += 1)M = o + n[t + B[r]] | 0, M += r < 16 ? w(u, O, j) + H[0] : r < 32 ? l(u, O, j) + H[1] : r < 48 ? b(u, O, j) + H[2] : r < 64 ? d(u, O, j) + H[3] : y(u, O, j) + H[4], M = (M = p(M |= 0, I[r])) + _ | 0, o = _, _ = j, j = p(O, 10), O = u, u = M, M = m + n[t + N[r]] | 0, M += r < 16 ? y(A, g, E) + C[0] : r < 32 ? d(A, g, E) + C[1] : r < 48 ? b(A, g, E) + C[2] : r < 64 ? l(A, g, E) + C[3] : w(A, g, E) + C[4], M = (M = p(M |= 0, z[r])) + S | 0, m = S, S = E, E = p(g, 10), g = A, A = M;
                        M = k[1] + O + E | 0, k[1] = k[2] + j + S | 0, k[2] = k[3] + _ + m | 0, k[3] = k[4] + o + A | 0, k[4] = k[0] + u + g | 0, k[0] = M;
                    }, t.prototype.fn = function() {
                        var n = this.cn, t = n.words, r = 8 * this.sn, i = 8 * n.nSigBytes;
                        t[i >>> 5] |= 128 << 24 - i % 32, t[14 + (i + 64 >>> 9 << 4)] = 16711935 & (r << 8 | r >>> 24) | 4278255360 & (r << 24 | r >>> 8), n.nSigBytes = 4 * (t.length + 1), this.an();
                        for(var e = this.on, o = e.words, u = 0; u < 5; u++){
                            var f = o[u];
                            o[u] = 16711935 & (f << 8 | f >>> 24) | 4278255360 & (f << 24 | f >>> 8);
                        }
                        return e;
                    }, t.prototype.clone = function() {
                        return new t({
                            hash: this.on,
                            blockSize: this.N,
                            data: this.cn,
                            nBytes: this.sn
                        });
                    }, t.hash = function(n, r) {
                        return new t(r).finalize(n);
                    }, t;
                }(e.P);
            },
            5187: function(n, t, r) {
                r.d(t, {
                    Rabbit: function() {
                        return s;
                    }
                });
                var i, e = r(30), o = r(5693), u = r(9109), f = (i = function(n, t) {
                    return (i = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(n, t) {
                        n.__proto__ = t;
                    } || function(n, t) {
                        for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
                    })(n, t);
                }, function(n, t) {
                    function r() {
                        this.constructor = n;
                    }
                    i(n, t), n.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
                }), c = function() {
                    return (c = Object.assign || function(n) {
                        for(var t, r = 1, i = arguments.length; r < i; r++)for(var e in t = arguments[r])Object.prototype.hasOwnProperty.call(t, e) && (n[e] = t[e]);
                        return n;
                    }).apply(this, arguments);
                }, s = function(n) {
                    function t(t) {
                        var r = n.call(this, t) || this;
                        return r.N = 4, r.S = [], r.C = [], r.G = [], r.hn = [], r.vn = [], r.wn = 0, r.O = t, r.A(), r;
                    }
                    return f(t, n), t.prototype.A = function() {
                        for(var n = this.H.words, t = this.ln, r = 0; r < 4; r++)n[r] = 16711935 & (n[r] << 8 | n[r] >>> 24) | 4278255360 & (n[r] << 24 | n[r] >>> 8);
                        var i = this.hn = [
                            n[0],
                            n[3] << 16 | n[2] >>> 16,
                            n[1],
                            n[0] << 16 | n[3] >>> 16,
                            n[2],
                            n[1] << 16 | n[0] >>> 16,
                            n[3],
                            n[2] << 16 | n[1] >>> 16
                        ], e = this.vn = [
                            n[2] << 16 | n[2] >>> 16,
                            4294901760 & n[0] | 65535 & n[1],
                            n[3] << 16 | n[3] >>> 16,
                            4294901760 & n[1] | 65535 & n[2],
                            n[0] << 16 | n[0] >>> 16,
                            4294901760 & n[2] | 65535 & n[3],
                            n[1] << 16 | n[1] >>> 16,
                            4294901760 & n[3] | 65535 & n[0]
                        ];
                        this.wn = 0;
                        for(r = 0; r < 4; r++)this.nextState();
                        for(r = 0; r < 8; r++)e[r] ^= i[r + 4 & 7];
                        if (t) {
                            var o = t.words, u = o[0], f = o[1], c = 16711935 & (u << 8 | u >>> 24) | 4278255360 & (u << 24 | u >>> 8), s = 16711935 & (f << 8 | f >>> 24) | 4278255360 & (f << 24 | f >>> 8), a = c >>> 16 | 4294901760 & s, h = s << 16 | 65535 & c;
                            e[0] ^= c, e[1] ^= a, e[2] ^= s, e[3] ^= h, e[4] ^= c, e[5] ^= a, e[6] ^= s, e[7] ^= h;
                            for(r = 0; r < 4; r++)this.nextState();
                        }
                    }, t.prototype.un = function(n, t) {
                        var r = this.hn;
                        this.nextState(), this.S[0] = r[0] ^ r[5] >>> 16 ^ r[3] << 16, this.S[1] = r[2] ^ r[7] >>> 16 ^ r[5] << 16, this.S[2] = r[4] ^ r[1] >>> 16 ^ r[7] << 16, this.S[3] = r[6] ^ r[3] >>> 16 ^ r[1] << 16;
                        for(var i = 0; i < 4; i++)this.S[i] = 16711935 & (this.S[i] << 8 | this.S[i] >>> 24) | 4278255360 & (this.S[i] << 24 | this.S[i] >>> 8), n[t + i] ^= this.S[i];
                    }, t.prototype.nextState = function() {
                        for(var n = this.hn, t = this.vn, r = 0; r < 8; r++)this.C[r] = t[r];
                        t[0] = t[0] + 1295307597 + this.wn | 0, t[1] = t[1] + 3545052371 + (t[0] >>> 0 < this.C[0] >>> 0 ? 1 : 0) | 0, t[2] = t[2] + 886263092 + (t[1] >>> 0 < this.C[1] >>> 0 ? 1 : 0) | 0, t[3] = t[3] + 1295307597 + (t[2] >>> 0 < this.C[2] >>> 0 ? 1 : 0) | 0, t[4] = t[4] + 3545052371 + (t[3] >>> 0 < this.C[3] >>> 0 ? 1 : 0) | 0, t[5] = t[5] + 886263092 + (t[4] >>> 0 < this.C[4] >>> 0 ? 1 : 0) | 0, t[6] = t[6] + 1295307597 + (t[5] >>> 0 < this.C[5] >>> 0 ? 1 : 0) | 0, t[7] = t[7] + 3545052371 + (t[6] >>> 0 < this.C[6] >>> 0 ? 1 : 0) | 0, this.wn = t[7] >>> 0 < this.C[7] >>> 0 ? 1 : 0;
                        for(r = 0; r < 8; r++){
                            var i = n[r] + t[r], e = 65535 & i, o = i >>> 16, u = ((e * e >>> 17) + e * o >>> 15) + o * o, f = ((4294901760 & i) * i | 0) + ((65535 & i) * i | 0);
                            this.G[r] = u ^ f;
                        }
                        var c = this.G;
                        n[0] = c[0] + (c[7] << 16 | c[7] >>> 16) + (c[6] << 16 | c[6] >>> 16) | 0, n[1] = c[1] + (c[0] << 8 | c[0] >>> 24) + c[7] | 0, n[2] = c[2] + (c[1] << 16 | c[1] >>> 16) + (c[0] << 16 | c[0] >>> 16) | 0, n[3] = c[3] + (c[2] << 8 | c[2] >>> 24) + c[1] | 0, n[4] = c[4] + (c[3] << 16 | c[3] >>> 16) + (c[2] << 16 | c[2] >>> 16) | 0, n[5] = c[5] + (c[4] << 8 | c[4] >>> 24) + c[3] | 0, n[6] = c[6] + (c[5] << 16 | c[5] >>> 16) + (c[4] << 16 | c[4] >>> 16) | 0, n[7] = c[7] + (c[6] << 8 | c[6] >>> 24) + c[5] | 0;
                    }, t.createEncryptor = function(n, r) {
                        return new t(c(c({}, r = void 0 === r ? {} : r), {
                            key: n
                        }));
                    }, t.createDecryptor = function(n, r) {
                        return new t(c(c({}, r = void 0 === r ? {} : r), {
                            key: n
                        }));
                    }, t.encrypt = function(n, r, i) {
                        return "string" == typeof r ? o.E.encrypt(t, n, r, i) : u.D.encrypt(t, n, r, i);
                    }, t.decrypt = function(n, r, i) {
                        return "string" == typeof r ? o.E.decrypt(t, n, r, i) : u.D.decrypt(t, n, r, i);
                    }, t.ivSize = 4, t;
                }(e.q);
            },
            3173: function(n, t, r) {
                r.d(t, {
                    SHA1: function() {
                        return c;
                    }
                });
                var i, e = r(1868), o = r(3354), u = (i = function(n, t) {
                    return (i = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(n, t) {
                        n.__proto__ = t;
                    } || function(n, t) {
                        for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
                    })(n, t);
                }, function(n, t) {
                    function r() {
                        this.constructor = n;
                    }
                    i(n, t), n.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
                }), f = [], c = function(n) {
                    function t(t) {
                        var r = n.call(this, t) || this;
                        return r.on = new o.e([
                            1732584193,
                            4023233417,
                            2562383102,
                            271733878,
                            3285377520
                        ]), r.O = t, t && void 0 !== t.hash && (r.on = t.hash.clone()), r;
                    }
                    return u(t, n), t.prototype.A = function() {
                        this.on = new o.e([
                            1732584193,
                            4023233417,
                            2562383102,
                            271733878,
                            3285377520
                        ]);
                    }, t.prototype.un = function(n, t) {
                        for(var r = this.on.words, i = r[0], e = r[1], o = r[2], u = r[3], c = r[4], s = 0; s < 80; s++){
                            if (s < 16) f[s] = 0 | n[t + s];
                            else {
                                var a = f[s - 3] ^ f[s - 8] ^ f[s - 14] ^ f[s - 16];
                                f[s] = a << 1 | a >>> 31;
                            }
                            var h = (i << 5 | i >>> 27) + c + f[s];
                            h += s < 20 ? 1518500249 + (e & o | ~e & u) : s < 40 ? 1859775393 + (e ^ o ^ u) : s < 60 ? (e & o | e & u | o & u) - 1894007588 : (e ^ o ^ u) - 899497514, c = u, u = o, o = e << 30 | e >>> 2, e = i, i = h;
                        }
                        r[0] = r[0] + i | 0, r[1] = r[1] + e | 0, r[2] = r[2] + o | 0, r[3] = r[3] + u | 0, r[4] = r[4] + c | 0;
                    }, t.prototype.fn = function() {
                        var n = this.cn.words, t = 8 * this.sn, r = 8 * this.cn.nSigBytes;
                        return n[r >>> 5] |= 128 << 24 - r % 32, n[14 + (r + 64 >>> 9 << 4)] = Math.floor(t / 4294967296), n[15 + (r + 64 >>> 9 << 4)] = t, this.cn.nSigBytes = 4 * n.length, this.an(), this.on;
                    }, t.prototype.clone = function() {
                        return new t({
                            hash: this.on,
                            blockSize: this.N,
                            data: this.cn,
                            nBytes: this.sn
                        });
                    }, t.hash = function(n, r) {
                        return new t(r).finalize(n);
                    }, t;
                }(e.P);
            },
            766: function(n, t, r) {
                r.d(t, {
                    SHA224: function() {
                        return f;
                    }
                });
                var i, e = r(3354), o = r(5561), u = (i = function(n, t) {
                    return (i = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(n, t) {
                        n.__proto__ = t;
                    } || function(n, t) {
                        for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
                    })(n, t);
                }, function(n, t) {
                    function r() {
                        this.constructor = n;
                    }
                    i(n, t), n.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
                }), f = function(n) {
                    function t(t) {
                        var r = n.call(this, t) || this;
                        return r.on = new e.e([
                            3238371032,
                            914150663,
                            812702999,
                            4144912697,
                            4290775857,
                            1750603025,
                            1694076839,
                            3204075428
                        ]), r.O = t, t && void 0 !== t.hash && (r.on = t.hash.clone()), r;
                    }
                    return u(t, n), t.prototype.A = function() {
                        this.on = new e.e([
                            3238371032,
                            914150663,
                            812702999,
                            4144912697,
                            4290775857,
                            1750603025,
                            1694076839,
                            3204075428
                        ]);
                    }, t.prototype.fn = function() {
                        var t = n.prototype.fn.call(this);
                        return t.nSigBytes -= 4, t;
                    }, t.prototype.clone = function() {
                        return new t({
                            hash: this.on,
                            blockSize: this.N,
                            data: this.cn,
                            nBytes: this.sn
                        });
                    }, t.hash = function(n, r) {
                        return new t(r).finalize(n);
                    }, t;
                }(o.SHA256);
            },
            5561: function(n, t, r) {
                r.d(t, {
                    SHA256: function() {
                        return v;
                    }
                });
                var i, e = r(1868), o = r(3354), u = (i = function(n, t) {
                    return (i = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(n, t) {
                        n.__proto__ = t;
                    } || function(n, t) {
                        for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
                    })(n, t);
                }, function(n, t) {
                    function r() {
                        this.constructor = n;
                    }
                    i(n, t), n.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
                }), f = [], c = [];
                function s(n) {
                    for(var t = Math.sqrt(n), r = 2; r <= t; r++)if (!(n % r)) return !1;
                    return !0;
                }
                function a(n) {
                    return 4294967296 * (n - (0 | n)) | 0;
                }
                !function() {
                    for(var n = 2, t = 0; t < 64;)s(n) && (t < 8 && (f[t] = a(Math.pow(n, .5))), c[t] = a(Math.pow(n, 1 / 3)), t++), n++;
                }();
                var h = [], v = function(n) {
                    function t(t) {
                        var r = n.call(this, t) || this;
                        return r.on = new o.e(f.slice(0)), r.O = t, t && void 0 !== t.hash && (r.on = t.hash.clone()), r;
                    }
                    return u(t, n), t.prototype.A = function() {
                        this.on = new o.e(f.slice(0));
                    }, t.prototype.un = function(n, t) {
                        for(var r = this.on.words, i = r[0], e = r[1], o = r[2], u = r[3], f = r[4], s = r[5], a = r[6], v = r[7], w = 0; w < 64; w++){
                            if (w < 16) h[w] = 0 | n[t + w];
                            else {
                                var l = h[w - 15], b = (l << 25 | l >>> 7) ^ (l << 14 | l >>> 18) ^ l >>> 3, d = h[w - 2], y = (d << 15 | d >>> 17) ^ (d << 13 | d >>> 19) ^ d >>> 10;
                                h[w] = b + h[w - 7] + y + h[w - 16];
                            }
                            var p = i & e ^ i & o ^ e & o, O = (i << 30 | i >>> 2) ^ (i << 19 | i >>> 13) ^ (i << 10 | i >>> 22), j = v + ((f << 26 | f >>> 6) ^ (f << 21 | f >>> 11) ^ (f << 7 | f >>> 25)) + (f & s ^ ~f & a) + c[w] + h[w];
                            v = a, a = s, s = f, f = u + j | 0, u = o, o = e, e = i, i = j + (O + p) | 0;
                        }
                        r[0] = r[0] + i | 0, r[1] = r[1] + e | 0, r[2] = r[2] + o | 0, r[3] = r[3] + u | 0, r[4] = r[4] + f | 0, r[5] = r[5] + s | 0, r[6] = r[6] + a | 0, r[7] = r[7] + v | 0;
                    }, t.prototype.fn = function() {
                        var n = this.cn.words, t = 8 * this.sn, r = 8 * this.cn.nSigBytes;
                        return n[r >>> 5] |= 128 << 24 - r % 32, n[14 + (r + 64 >>> 9 << 4)] = Math.floor(t / 4294967296), n[15 + (r + 64 >>> 9 << 4)] = t, this.cn.nSigBytes = 4 * n.length, this.an(), this.on;
                    }, t.prototype.clone = function() {
                        return new t({
                            hash: this.on,
                            blockSize: this.N,
                            data: this.cn,
                            nBytes: this.sn
                        });
                    }, t.hash = function(n, r) {
                        return new t(r).finalize(n);
                    }, t;
                }(e.P);
            },
            3408: function(n, t, r) {
                r.d(t, {
                    SHA3: function() {
                        return v;
                    }
                });
                var i, e = r(6957), o = r(1868), u = r(3354), f = (i = function(n, t) {
                    return (i = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(n, t) {
                        n.__proto__ = t;
                    } || function(n, t) {
                        for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
                    })(n, t);
                }, function(n, t) {
                    function r() {
                        this.constructor = n;
                    }
                    i(n, t), n.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
                }), c = [], s = [], a = [];
                !function() {
                    for(var n = 1, t = 0, r = 0; r < 24; r++){
                        c[n + 5 * t] = (r + 1) * (r + 2) / 2 % 64;
                        var i = (2 * n + 3 * t) % 5;
                        n = t % 5, t = i;
                    }
                    for(var o = 0; o < 5; o++)for(var u = 0; u < 5; u++)s[o + 5 * u] = u + (2 * o + 3 * u) % 5 * 5;
                    for(var f = 1, h = 0; h < 24; h++){
                        for(var v = 0, w = 0, l = 0; l < 7; l++){
                            if (1 & f) {
                                var b = (1 << l) - 1;
                                b < 32 ? w ^= 1 << b : v ^= 1 << b - 32;
                            }
                            128 & f ? f = f << 1 ^ 113 : f <<= 1;
                        }
                        a[h] = new e.r(v, w);
                    }
                }();
                var h = [];
                !function() {
                    for(var n = 0; n < 25; n++)h[n] = new e.r(0, 0);
                }();
                var v = function(n) {
                    function t(t) {
                        var r = n.call(this, t) || this;
                        if (r.N = 32, r.bn = [], r.dn = 512, r.O = t, t) {
                            if (void 0 !== t.outputLength) {
                                if (![
                                    224,
                                    256,
                                    384,
                                    512
                                ].includes(t.outputLength)) throw new Error("Unsupported output length.");
                                r.dn = t.outputLength;
                            }
                            void 0 !== t.state && (r.bn = t.state.map(function(n) {
                                return n.clone();
                            }));
                        }
                        if (0 === r.bn.length) for(var i = 0; i < 25; i++)r.bn[i] = new e.r(0, 0);
                        return r.N = (1600 - 2 * r.dn) / 32, r;
                    }
                    return f(t, n), t.prototype.A = function() {
                        this.bn = [];
                        for(var n = 0; n < 25; n++)this.bn[n] = new e.r(0, 0);
                        this.N = (1600 - 2 * this.dn) / 32;
                    }, t.prototype.un = function(n, t) {
                        for(var r = this.bn, i = this.N / 2, e = 0; e < i; e++){
                            var o = n[t + 2 * e], u = n[t + 2 * e + 1];
                            o = 16711935 & (o << 8 | o >>> 24) | 4278255360 & (o << 24 | o >>> 8), u = 16711935 & (u << 8 | u >>> 24) | 4278255360 & (u << 24 | u >>> 8), r[e].high ^= u, r[e].low ^= o;
                        }
                        for(var f = 0; f < 24; f++){
                            for(var v = 0; v < 5; v++){
                                for(var w = 0, l = 0, b = 0; b < 5; b++)w ^= (k = r[v + 5 * b]).high, l ^= k.low;
                                var d = h[v];
                                d.high = w, d.low = l;
                            }
                            for(v = 0; v < 5; v++){
                                var y = h[(v + 4) % 5], p = h[(v + 1) % 5], O = p.high, j = p.low;
                                for(w = y.high ^ (O << 1 | j >>> 31), l = y.low ^ (j << 1 | O >>> 31), b = 0; b < 5; b++)(k = r[v + 5 * b]).high ^= w, k.low ^= l;
                            }
                            for(var _ = 1; _ < 25; _++){
                                w = void 0, l = void 0;
                                var m = r[_].high, A = r[_].low, g = c[_];
                                g < 32 ? (w = m << g | A >>> 32 - g, l = A << g | m >>> 32 - g) : (w = A << g - 32 | m >>> 64 - g, l = m << g - 32 | A >>> 64 - g);
                                var E = h[s[_]];
                                E.high = w, E.low = l;
                            }
                            var S = h[0], M = r[0];
                            S.high = M.high, S.low = M.low;
                            for(v = 0; v < 5; v++)for(b = 0; b < 5; b++){
                                var k = r[_ = v + 5 * b], H = h[_], C = h[(v + 1) % 5 + 5 * b], B = h[(v + 2) % 5 + 5 * b];
                                k.high = H.high ^ ~C.high & B.high, k.low = H.low ^ ~C.low & B.low;
                            }
                            var N = r[0], I = a[f];
                            N.high ^= I.high, N.low ^= I.low;
                        }
                    }, t.prototype.fn = function() {
                        var n = this.cn, t = n.words, r = 8 * n.nSigBytes, i = 32 * this.blockSize;
                        t[r >>> 5] |= 1 << 24 - r % 32, t[(Math.ceil((r + 1) / i) * i >>> 5) - 1] |= 128, n.nSigBytes = 4 * t.length, this.an();
                        for(var e = this.bn, o = this.dn / 8, f = o / 8, c = [], s = 0; s < f; s++){
                            var a = e[s], h = a.high, v = a.low;
                            h = 16711935 & (h << 8 | h >>> 24) | 4278255360 & (h << 24 | h >>> 8), v = 16711935 & (v << 8 | v >>> 24) | 4278255360 & (v << 24 | v >>> 8), c.push(v), c.push(h);
                        }
                        return new u.e(c, o);
                    }, t.prototype.clone = function() {
                        return new t({
                            outputLength: this.dn,
                            state: this.bn,
                            blockSize: this.N,
                            data: this.cn,
                            nBytes: this.sn
                        });
                    }, t.hash = function(n, r) {
                        return new t(r).finalize(n);
                    }, t;
                }(o.P);
            },
            6324: function(n, t, r) {
                r.d(t, {
                    SHA384: function() {
                        return f;
                    }
                });
                var i, e = r(6957), o = r(7491), u = (i = function(n, t) {
                    return (i = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(n, t) {
                        n.__proto__ = t;
                    } || function(n, t) {
                        for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
                    })(n, t);
                }, function(n, t) {
                    function r() {
                        this.constructor = n;
                    }
                    i(n, t), n.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
                }), f = function(n) {
                    function t(t) {
                        var r = n.call(this, t) || this;
                        return r.on = new e.m([
                            new e.r(3418070365, 3238371032),
                            new e.r(1654270250, 914150663),
                            new e.r(2438529370, 812702999),
                            new e.r(355462360, 4144912697),
                            new e.r(1731405415, 4290775857),
                            new e.r(2394180231, 1750603025),
                            new e.r(3675008525, 1694076839),
                            new e.r(1203062813, 3204075428)
                        ]), r.O = t, t && void 0 !== t.hash && (r.on = t.hash.clone()), r;
                    }
                    return u(t, n), t.prototype.A = function() {
                        this.on = new e.m([
                            new e.r(3418070365, 3238371032),
                            new e.r(1654270250, 914150663),
                            new e.r(2438529370, 812702999),
                            new e.r(355462360, 4144912697),
                            new e.r(1731405415, 4290775857),
                            new e.r(2394180231, 1750603025),
                            new e.r(3675008525, 1694076839),
                            new e.r(1203062813, 3204075428)
                        ]);
                    }, t.prototype.fn = function() {
                        var t = n.prototype.fn.call(this);
                        return t.nSigBytes -= 16, t;
                    }, t.prototype.clone = function() {
                        return new t({
                            hash: this.on,
                            blockSize: this.N,
                            data: this.cn,
                            nBytes: this.sn
                        });
                    }, t.hash = function(n, r) {
                        return new t(r).finalize(n);
                    }, t;
                }(o.SHA512);
            },
            7491: function(n, t, r) {
                r.d(t, {
                    SHA512: function() {
                        return s;
                    }
                });
                var i, e = r(1868), o = r(6957), u = (i = function(n, t) {
                    return (i = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(n, t) {
                        n.__proto__ = t;
                    } || function(n, t) {
                        for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
                    })(n, t);
                }, function(n, t) {
                    function r() {
                        this.constructor = n;
                    }
                    i(n, t), n.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
                }), f = [
                    new o.r(1116352408, 3609767458),
                    new o.r(1899447441, 602891725),
                    new o.r(3049323471, 3964484399),
                    new o.r(3921009573, 2173295548),
                    new o.r(961987163, 4081628472),
                    new o.r(1508970993, 3053834265),
                    new o.r(2453635748, 2937671579),
                    new o.r(2870763221, 3664609560),
                    new o.r(3624381080, 2734883394),
                    new o.r(310598401, 1164996542),
                    new o.r(607225278, 1323610764),
                    new o.r(1426881987, 3590304994),
                    new o.r(1925078388, 4068182383),
                    new o.r(2162078206, 991336113),
                    new o.r(2614888103, 633803317),
                    new o.r(3248222580, 3479774868),
                    new o.r(3835390401, 2666613458),
                    new o.r(4022224774, 944711139),
                    new o.r(264347078, 2341262773),
                    new o.r(604807628, 2007800933),
                    new o.r(770255983, 1495990901),
                    new o.r(1249150122, 1856431235),
                    new o.r(1555081692, 3175218132),
                    new o.r(1996064986, 2198950837),
                    new o.r(2554220882, 3999719339),
                    new o.r(2821834349, 766784016),
                    new o.r(2952996808, 2566594879),
                    new o.r(3210313671, 3203337956),
                    new o.r(3336571891, 1034457026),
                    new o.r(3584528711, 2466948901),
                    new o.r(113926993, 3758326383),
                    new o.r(338241895, 168717936),
                    new o.r(666307205, 1188179964),
                    new o.r(773529912, 1546045734),
                    new o.r(1294757372, 1522805485),
                    new o.r(1396182291, 2643833823),
                    new o.r(1695183700, 2343527390),
                    new o.r(1986661051, 1014477480),
                    new o.r(2177026350, 1206759142),
                    new o.r(2456956037, 344077627),
                    new o.r(2730485921, 1290863460),
                    new o.r(2820302411, 3158454273),
                    new o.r(3259730800, 3505952657),
                    new o.r(3345764771, 106217008),
                    new o.r(3516065817, 3606008344),
                    new o.r(3600352804, 1432725776),
                    new o.r(4094571909, 1467031594),
                    new o.r(275423344, 851169720),
                    new o.r(430227734, 3100823752),
                    new o.r(506948616, 1363258195),
                    new o.r(659060556, 3750685593),
                    new o.r(883997877, 3785050280),
                    new o.r(958139571, 3318307427),
                    new o.r(1322822218, 3812723403),
                    new o.r(1537002063, 2003034995),
                    new o.r(1747873779, 3602036899),
                    new o.r(1955562222, 1575990012),
                    new o.r(2024104815, 1125592928),
                    new o.r(2227730452, 2716904306),
                    new o.r(2361852424, 442776044),
                    new o.r(2428436474, 593698344),
                    new o.r(2756734187, 3733110249),
                    new o.r(3204031479, 2999351573),
                    new o.r(3329325298, 3815920427),
                    new o.r(3391569614, 3928383900),
                    new o.r(3515267271, 566280711),
                    new o.r(3940187606, 3454069534),
                    new o.r(4118630271, 4000239992),
                    new o.r(116418474, 1914138554),
                    new o.r(174292421, 2731055270),
                    new o.r(289380356, 3203993006),
                    new o.r(460393269, 320620315),
                    new o.r(685471733, 587496836),
                    new o.r(852142971, 1086792851),
                    new o.r(1017036298, 365543100),
                    new o.r(1126000580, 2618297676),
                    new o.r(1288033470, 3409855158),
                    new o.r(1501505948, 4234509866),
                    new o.r(1607167915, 987167468),
                    new o.r(1816402316, 1246189591)
                ], c = [];
                !function() {
                    for(var n = 0; n < 80; n++)c[n] = new o.r(0, 0);
                }();
                var s = function(n) {
                    function t(t) {
                        var r = n.call(this, t) || this;
                        return r.N = 32, r.on = new o.m([
                            new o.r(1779033703, 4089235720),
                            new o.r(3144134277, 2227873595),
                            new o.r(1013904242, 4271175723),
                            new o.r(2773480762, 1595750129),
                            new o.r(1359893119, 2917565137),
                            new o.r(2600822924, 725511199),
                            new o.r(528734635, 4215389547),
                            new o.r(1541459225, 327033209)
                        ]), r.O = t, t && void 0 !== t.hash && (r.on = t.hash.clone()), r;
                    }
                    return u(t, n), t.prototype.A = function() {
                        this.on = new o.m([
                            new o.r(1779033703, 4089235720),
                            new o.r(3144134277, 2227873595),
                            new o.r(1013904242, 4271175723),
                            new o.r(2773480762, 1595750129),
                            new o.r(1359893119, 2917565137),
                            new o.r(2600822924, 725511199),
                            new o.r(528734635, 4215389547),
                            new o.r(1541459225, 327033209)
                        ]);
                    }, t.prototype.un = function(n, t) {
                        for(var r = this.on.words, i = r[0], e = r[1], o = r[2], u = r[3], s = r[4], a = r[5], h = r[6], v = r[7], w = i.high, l = i.low, b = e.high, d = e.low, y = o.high, p = o.low, O = u.high, j = u.low, _ = s.high, m = s.low, A = a.high, g = a.low, E = h.high, S = h.low, M = v.high, k = v.low, H = w, C = l, B = b, N = d, I = y, z = p, D = O, U = j, L = _, F = m, x = A, P = g, R = E, T = S, K = M, W = k, G = 0; G < 80; G++){
                            var q = void 0, Q = void 0, X = c[G];
                            if (G < 16) Q = X.high = 0 | n[t + 2 * G], q = X.low = 0 | n[t + 2 * G + 1];
                            else {
                                var V = c[G - 15], Z = V.high, J = V.low, Y = (Z >>> 1 | J << 31) ^ (Z >>> 8 | J << 24) ^ Z >>> 7, $ = (J >>> 1 | Z << 31) ^ (J >>> 8 | Z << 24) ^ (J >>> 7 | Z << 25), nn = c[G - 2], tn = nn.high, rn = nn.low, en = (tn >>> 19 | rn << 13) ^ (tn << 3 | rn >>> 29) ^ tn >>> 6, on = (rn >>> 19 | tn << 13) ^ (rn << 3 | tn >>> 29) ^ (rn >>> 6 | tn << 26), un = c[G - 7], fn = un.high, cn = un.low, sn = c[G - 16], an = sn.high, hn = sn.low;
                                Q = (Q = (Q = Y + fn + ((q = $ + cn) >>> 0 < $ >>> 0 ? 1 : 0)) + en + ((q += on) >>> 0 < on >>> 0 ? 1 : 0)) + an + ((q += hn) >>> 0 < hn >>> 0 ? 1 : 0), X.high = Q, X.low = q;
                            }
                            var vn = L & x ^ ~L & R, wn = F & P ^ ~F & T, ln = H & B ^ H & I ^ B & I, bn = C & N ^ C & z ^ N & z, dn = (H >>> 28 | C << 4) ^ (H << 30 | C >>> 2) ^ (H << 25 | C >>> 7), yn = (C >>> 28 | H << 4) ^ (C << 30 | H >>> 2) ^ (C << 25 | H >>> 7), pn = (L >>> 14 | F << 18) ^ (L >>> 18 | F << 14) ^ (L << 23 | F >>> 9), On = (F >>> 14 | L << 18) ^ (F >>> 18 | L << 14) ^ (F << 23 | L >>> 9), jn = f[G], _n = jn.high, mn = jn.low, An = W + On, gn = K + pn + (An >>> 0 < W >>> 0 ? 1 : 0), En = yn + bn;
                            K = R, W = T, R = x, T = P, x = L, P = F, L = D + (gn = (gn = (gn = gn + vn + ((An += wn) >>> 0 < wn >>> 0 ? 1 : 0)) + _n + ((An += mn) >>> 0 < mn >>> 0 ? 1 : 0)) + Q + ((An += q) >>> 0 < q >>> 0 ? 1 : 0)) + ((F = U + An | 0) >>> 0 < U >>> 0 ? 1 : 0) | 0, D = I, U = z, I = B, z = N, B = H, N = C, H = gn + (dn + ln + (En >>> 0 < yn >>> 0 ? 1 : 0)) + ((C = An + En | 0) >>> 0 < An >>> 0 ? 1 : 0) | 0;
                        }
                        l = i.low = l + C, i.high = w + H + (l >>> 0 < C >>> 0 ? 1 : 0), d = e.low = d + N, e.high = b + B + (d >>> 0 < N >>> 0 ? 1 : 0), p = o.low = p + z, o.high = y + I + (p >>> 0 < z >>> 0 ? 1 : 0), j = u.low = j + U, u.high = O + D + (j >>> 0 < U >>> 0 ? 1 : 0), m = s.low = m + F, s.high = _ + L + (m >>> 0 < F >>> 0 ? 1 : 0), g = a.low = g + P, a.high = A + x + (g >>> 0 < P >>> 0 ? 1 : 0), S = h.low = S + T, h.high = E + R + (S >>> 0 < T >>> 0 ? 1 : 0), k = v.low = k + W, v.high = M + K + (k >>> 0 < W >>> 0 ? 1 : 0);
                    }, t.prototype.fn = function() {
                        var n = this.cn, t = n.words, r = 8 * this.sn, i = 8 * n.nSigBytes;
                        return t[i >>> 5] |= 128 << 24 - i % 32, t[30 + (i + 128 >>> 10 << 5)] = Math.floor(r / 4294967296), t[31 + (i + 128 >>> 10 << 5)] = r, n.nSigBytes = 4 * t.length, this.an(), this.on.to32();
                    }, t.prototype.clone = function() {
                        return new t({
                            hash: this.on,
                            blockSize: this.N,
                            data: this.cn,
                            nBytes: this.sn
                        });
                    }, t.hash = function(n, r) {
                        return new t(r).finalize(n);
                    }, t;
                }(e.P);
            },
            3354: function(n, t, r) {
                r.d(t, {
                    e: function() {
                        return o;
                    }
                });
                var i = r(5720), e = r(9054), o = function() {
                    function n(t, r) {
                        if (Array.isArray(t) || !t) return this.yn = Array.isArray(t) ? t : [], void (this.pn = "number" == typeof r ? r : 4 * this.yn.length);
                        if (t instanceof n) return this.yn = t.words.slice(), void (this.pn = t.nSigBytes);
                        var i;
                        try {
                            t instanceof ArrayBuffer ? i = new Uint8Array(t) : (t instanceof Uint8Array || t instanceof Int8Array || t instanceof Uint8ClampedArray || t instanceof Int16Array || t instanceof Uint16Array || t instanceof Int32Array || t instanceof Uint32Array || t instanceof Float32Array || t instanceof Float64Array) && (i = new Uint8Array(t.buffer, t.byteOffset, t.byteLength));
                        } catch (n) {
                            throw new Error("Invalid argument");
                        }
                        if (!i) throw new Error("Invalid argument");
                        for(var e = i.byteLength, o = [], u = 0; u < e; u++)o[u >>> 2] |= i[u] << 24 - u % 4 * 8;
                        this.yn = o, this.pn = e;
                    }
                    return Object.defineProperty(n.prototype, "nSigBytes", {
                        get: function() {
                            return this.pn;
                        },
                        set: function(n) {
                            this.pn = n;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(n.prototype, "words", {
                        get: function() {
                            return this.yn;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), n.prototype.toString = function(n) {
                        return n ? n.stringify(this) : i.p.stringify(this);
                    }, n.prototype.toUint8Array = function() {
                        for(var n = this.yn, t = this.pn, r = new Uint8Array(t), i = 0; i < t; i++)r[i] = n[i >>> 2] >>> 24 - i % 4 * 8 & 255;
                        return r;
                    }, n.prototype.concat = function(n) {
                        var t = n.words.slice(), r = n.nSigBytes;
                        if (this.clamp(), this.pn % 4) for(var i = 0; i < r; i++){
                            var e = t[i >>> 2] >>> 24 - i % 4 * 8 & 255;
                            this.yn[this.pn + i >>> 2] |= e << 24 - (this.pn + i) % 4 * 8;
                        }
                        else for(i = 0; i < r; i += 4)this.yn[this.pn + i >>> 2] = t[i >>> 2];
                        return this.pn += r, this;
                    }, n.prototype.clamp = function() {
                        var n = this.pn;
                        this.yn[n >>> 2] &= 4294967295 << 32 - n % 4 * 8, this.yn.length = Math.ceil(n / 4);
                    }, n.prototype.clone = function() {
                        return new n(this.yn.slice(), this.pn);
                    }, n.random = function(t) {
                        for(var r = [], i = 0; i < t; i += 4)r.push((0, e.M)());
                        return new n(r, t);
                    }, n;
                }();
            },
            6957: function(n, t, r) {
                r.d(t, {
                    r: function() {
                        return o;
                    },
                    m: function() {
                        return u;
                    }
                });
                var i = r(5720), e = r(3354), o = function() {
                    function n(n, t) {
                        this.high = n, this.low = t;
                    }
                    return n.prototype.clone = function() {
                        return new n(this.high, this.low);
                    }, n;
                }(), u = function() {
                    function n(n, t) {
                        this.yn = n || [], this.pn = "number" == typeof t ? t : 8 * this.yn.length;
                    }
                    return Object.defineProperty(n.prototype, "nSigBytes", {
                        get: function() {
                            return this.pn;
                        },
                        set: function(n) {
                            this.pn = n;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(n.prototype, "words", {
                        get: function() {
                            return this.yn;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), n.prototype.to32 = function() {
                        for(var n = [], t = 0; t < this.yn.length; t++){
                            var r = this.yn[t];
                            n.push(r.high), n.push(r.low);
                        }
                        return new e.e(n, this.pn);
                    }, n.prototype.toString = function(n) {
                        return n ? n.stringify(this.to32()) : i.p.stringify(this.to32());
                    }, n.prototype.clone = function() {
                        for(var t = this.yn.slice(), r = 0; r < t.length; r++)t[r] = t[r].clone();
                        return new n(t, this.pn);
                    }, n;
                }();
            },
            7211: function(n, t, r) {
                r.d(t, {
                    C: function() {
                        return o;
                    }
                });
                var i = r(3354), e = r(4768), o = function() {
                    function n(n) {
                        this.On = 0, this.N = 0, this.O = n, this.cn = n && void 0 !== n.data ? n.data.clone() : new i.e, this.sn = n && "number" == typeof n.nBytes ? n.nBytes : 0;
                    }
                    return Object.defineProperty(n.prototype, "blockSize", {
                        get: function() {
                            return this.N;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), n.prototype.reset = function(n, t) {
                        this.cn = void 0 !== n ? n.clone() : new i.e, this.sn = "number" == typeof t ? t : 0;
                    }, n.prototype.jn = function(n) {
                        var t = "string" == typeof n ? e.d.parse(n) : n;
                        this.cn.concat(t), this.sn += t.nSigBytes;
                    }, n.prototype.an = function(n) {
                        var t, r = this.cn.words, e = this.cn.nSigBytes, o = this.N, u = e / (4 * this.N), f = (u = n ? Math.ceil(u) : Math.max((0 | u) - this.On, 0)) * o, c = Math.min(4 * f, e);
                        if (f) {
                            for(var s = 0; s < f; s += o)this.un(r, s);
                            t = r.splice(0, f), this.cn.nSigBytes -= c;
                        }
                        return new i.e(t, c);
                    }, n.prototype.un = function(n, t) {
                        throw new Error("Not implemented");
                    }, n;
                }();
            },
            1868: function(n, t, r) {
                r.d(t, {
                    P: function() {
                        return u;
                    }
                });
                var i, e = r(7211), o = (i = function(n, t) {
                    return (i = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(n, t) {
                        n.__proto__ = t;
                    } || function(n, t) {
                        for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
                    })(n, t);
                }, function(n, t) {
                    function r() {
                        this.constructor = n;
                    }
                    i(n, t), n.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
                }), u = function(n) {
                    function t(t) {
                        var r = n.call(this, t) || this;
                        return r.N = 16, r.O = t, t && "number" == typeof t.blockSize && (r.N = t.blockSize), r.reset(t ? t.data : void 0, t ? t.nBytes : void 0), r;
                    }
                    return o(t, n), Object.defineProperty(t.prototype, "blockSize", {
                        get: function() {
                            return this.N;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), t.prototype.reset = function(t, r) {
                        n.prototype.reset.call(this, t, r), this.A();
                    }, t.prototype.update = function(n) {
                        return this.jn(n), this.an(), this;
                    }, t.prototype.finalize = function(n) {
                        return n && this.jn(n), this.fn();
                    }, t.prototype.A = function() {
                        throw new Error("Not implemented");
                    }, t.prototype.fn = function() {
                        throw new Error("Not implemented");
                    }, t;
                }(e.C);
            },
            787: function(n, t, r) {
                r.d(t, {
                    G: function() {
                        return s;
                    }
                });
                var i, e = r(9456), o = r(4344), u = r(7919), f = (i = function(n, t) {
                    return (i = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(n, t) {
                        n.__proto__ = t;
                    } || function(n, t) {
                        for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
                    })(n, t);
                }, function(n, t) {
                    function r() {
                        this.constructor = n;
                    }
                    i(n, t), n.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
                }), c = function() {
                    return (c = Object.assign || function(n) {
                        for(var t, r = 1, i = arguments.length; r < i; r++)for(var e in t = arguments[r])Object.prototype.hasOwnProperty.call(t, e) && (n[e] = t[e]);
                        return n;
                    }).apply(this, arguments);
                }, s = function(n) {
                    function t(t) {
                        var r = n.call(this, t) || this;
                        return r.N = 4, r._n = o.n, r.mn = u.l, r.O = t, r._n = void 0 !== t.mode ? t.mode : r._n, r.mn = void 0 !== t.padding ? t.padding : r.mn, r.reset(null == t ? void 0 : t.data, null == t ? void 0 : t.nBytes), r;
                    }
                    return f(t, n), Object.defineProperty(t.prototype, "mode", {
                        get: function() {
                            return this.An;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(t.prototype, "padding", {
                        get: function() {
                            return this.mn;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), t.prototype.reset = function(t, r) {
                        var i;
                        n.prototype.reset.call(this, t, r), this.gn === e.t.ENC_TRANSFORM_MODE ? i = this._n.createEncryptor : (i = this._n.createDecryptor, this.On = 1), this._n && this.En === i ? this.An = new this._n({
                            cipher: this,
                            iv: this.ln
                        }) : (this.An = i.call(this._n, {
                            cipher: this,
                            iv: this.ln
                        }), this.En = i);
                    }, t.prototype.un = function(n, t) {
                        var r;
                        null === (r = this.An) || void 0 === r || r.processBlock(n, t);
                    }, t.prototype.fn = function() {
                        var n, t = this.mn;
                        return this.gn === e.t.ENC_TRANSFORM_MODE ? (t.pad(this.cn, this.blockSize), n = this.an(!0)) : (n = this.an(!0), t.unpad(n)), n;
                    }, t.prototype.encryptBlock = function(n, t) {
                        throw new Error("Not implemented");
                    }, t.prototype.decryptBlock = function(n, t) {
                        throw new Error("Not implemented");
                    }, t.createEncryptor = function(n, r) {
                        return new t(c(c({}, r = void 0 === r ? {} : r), {
                            key: n,
                            transformMode: e.t.ENC_TRANSFORM_MODE
                        }));
                    }, t.createDecryptor = function(n, r) {
                        return new t(c(c({}, r = void 0 === r ? {} : r), {
                            key: n,
                            transformMode: e.t.DEC_TRANSFORM_MODE
                        }));
                    }, t;
                }(e.t);
            },
            9456: function(n, t, r) {
                r.d(t, {
                    t: function() {
                        return f;
                    }
                });
                var i, e = r(7211), o = (i = function(n, t) {
                    return (i = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(n, t) {
                        n.__proto__ = t;
                    } || function(n, t) {
                        for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
                    })(n, t);
                }, function(n, t) {
                    function r() {
                        this.constructor = n;
                    }
                    i(n, t), n.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
                }), u = function() {
                    return (u = Object.assign || function(n) {
                        for(var t, r = 1, i = arguments.length; r < i; r++)for(var e in t = arguments[r])Object.prototype.hasOwnProperty.call(t, e) && (n[e] = t[e]);
                        return n;
                    }).apply(this, arguments);
                }, f = function(n) {
                    function t(t) {
                        var r = n.call(this, t) || this;
                        return r.gn = 1, r.O = t, r.H = t.key, r.ln = void 0 !== t.iv ? t.iv : r.ln, r.gn = void 0 !== t.transformMode ? t.transformMode : r.gn, r;
                    }
                    return o(t, n), Object.defineProperty(t.prototype, "iv", {
                        get: function() {
                            return this.ln;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), t.prototype.reset = function(t, r) {
                        n.prototype.reset.call(this, t, r), this.A();
                    }, t.prototype.process = function(n) {
                        return this.jn(n), this.an();
                    }, t.prototype.finalize = function(n) {
                        return n && this.jn(n), this.fn();
                    }, t.prototype.A = function() {
                        throw new Error("Not implemented");
                    }, t.prototype.un = function(n, t) {
                        throw new Error("Not implemented");
                    }, t.prototype.fn = function() {
                        throw new Error("Not implemented");
                    }, t.createEncryptor = function(n, r) {
                        return new t(u(u({}, r = void 0 === r ? {} : r), {
                            key: n,
                            transformMode: t.ENC_TRANSFORM_MODE
                        }));
                    }, t.createDecryptor = function(n, r) {
                        return new t(u(u({}, r = void 0 === r ? {} : r), {
                            key: n,
                            transformMode: t.DEC_TRANSFORM_MODE
                        }));
                    }, t.ENC_TRANSFORM_MODE = 1, t.DEC_TRANSFORM_MODE = 2, t.keySize = 4, t.ivSize = 4, t;
                }(e.C);
            },
            2505: function(n, t, r) {
                r.d(t, {
                    Q: function() {
                        return e;
                    }
                });
                var i = r(1232), e = function() {
                    function n(n) {
                        this.formatter = i.w, n && (this.cipherText = n.cipherText, this.key = n.key, this.iv = n.iv, this.salt = n.salt, this.Algorithm = n.Algorithm, this.mode = n.mode, this.padding = n.padding, this.blockSize = n.blockSize, this.formatter = n.formatter || i.w);
                    }
                    return n.prototype.toString = function(n) {
                        return (n || this.formatter).stringify(this);
                    }, n;
                }();
            },
            5693: function(n, t, r) {
                r.d(t, {
                    E: function() {
                        return c;
                    }
                });
                var i = r(9109), e = r(2214), o = r(2505), u = r(1232), f = function() {
                    return (f = Object.assign || function(n) {
                        for(var t, r = 1, i = arguments.length; r < i; r++)for(var e in t = arguments[r])Object.prototype.hasOwnProperty.call(t, e) && (n[e] = t[e]);
                        return n;
                    }).apply(this, arguments);
                }, c = {
                    encrypt: function(n, t, r, u) {
                        var c = u ? f({}, u) : {}, s = u && u.KDF ? u.KDF : e.s, a = {};
                        u && u.kdfHasher && (a.kdfHasher = u.kdfHasher), u && u.kdfIterations && (a.kdfIterations = u.kdfIterations), u && u.kdfModule && (a.kdfModule = u.kdfModule);
                        var h = s.execute(r, n.keySize, n.ivSize, c.kdfSalt, a);
                        c.iv = h.iv;
                        var v = i.D.encrypt(n, t, h.key, c);
                        return new o.Q(f(f({}, v), {
                            key: h.key,
                            iv: h.iv,
                            salt: h.salt
                        }));
                    },
                    decrypt: function(n, t, r, o) {
                        var c = o ? f({}, o) : {}, s = c.KDF ? c.KDF : e.s, a = c.formatter ? c.formatter : u.w, h = (0, i.W)(t, a), v = {};
                        o && o.kdfHasher && (v.kdfHasher = o.kdfHasher), o && o.kdfIterations && (v.kdfIterations = o.kdfIterations), o && o.kdfModule && (v.kdfModule = o.kdfModule);
                        var w = s.execute(r, n.keySize, n.ivSize, h.salt, v);
                        return c.iv = w.iv, i.D.decrypt(n, h, w.key, c);
                    }
                };
            },
            9109: function(n, t, r) {
                r.d(t, {
                    W: function() {
                        return o;
                    },
                    D: function() {
                        return u;
                    }
                });
                var i = r(1232), e = r(2505);
                function o(n, t) {
                    return "string" == typeof n ? t.parse(n) : n;
                }
                var u = {
                    encrypt: function(n, t, r, o) {
                        var u = n.createEncryptor(r, o), f = u.finalize(t);
                        return new e.Q({
                            cipherText: f,
                            key: r,
                            iv: u.iv,
                            Algorithm: n,
                            mode: u.mode,
                            padding: u.padding,
                            blockSize: u.blockSize,
                            formatter: (null == o ? void 0 : o.formatter) || i.w
                        });
                    },
                    decrypt: function(n, t, r, e) {
                        var u = n.createDecryptor(r, e), f = o(t, (null == e ? void 0 : e.formatter) || i.w);
                        return u.finalize(f.cipherText || "");
                    }
                };
            },
            30: function(n, t, r) {
                r.d(t, {
                    q: function() {
                        return u;
                    }
                });
                var i, e = r(9456), o = (i = function(n, t) {
                    return (i = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(n, t) {
                        n.__proto__ = t;
                    } || function(n, t) {
                        for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
                    })(n, t);
                }, function(n, t) {
                    function r() {
                        this.constructor = n;
                    }
                    i(n, t), n.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
                }), u = function(n) {
                    function t(t) {
                        var r = n.call(this, t) || this;
                        return r.N = 1, r;
                    }
                    return o(t, n), t.prototype.fn = function() {
                        return this.an(!0);
                    }, t;
                }(e.t);
            },
            1232: function(n, t, r) {
                r.d(t, {
                    w: function() {
                        return u;
                    }
                });
                var i = r(2505), e = r(3354), o = r(1773), u = {
                    stringify: function(n) {
                        var t = n.cipherText, r = n.salt;
                        return t ? r ? new e.e([
                            1398893684,
                            1701076831
                        ]).concat(r).concat(t).toString(o.D) : t.toString(o.D) : "";
                    },
                    parse: function(n) {
                        var t, r = o.D.parse(n), u = r.words;
                        return 1398893684 === u[0] && 1701076831 === u[1] && (t = new e.e(u.slice(2, 4)), u.splice(0, 4), r.nSigBytes -= 16), new i.Q({
                            cipherText: r,
                            salt: t
                        });
                    }
                };
            },
            2214: function(n, t, r) {
                r.d(t, {
                    s: function() {
                        return f;
                    }
                });
                var i = r(3354), e = r(2505), o = r(7008), u = function() {
                    return (u = Object.assign || function(n) {
                        for(var t, r = 1, i = arguments.length; r < i; r++)for(var e in t = arguments[r])Object.prototype.hasOwnProperty.call(t, e) && (n[e] = t[e]);
                        return n;
                    }).apply(this, arguments);
                }, f = {
                    execute: function(n, t, r, f, c) {
                        f || (f = i.e.random(8));
                        var s = c && c.kdfModule || o.E, a = c ? {
                            Hasher: c.kdfHasher,
                            iterations: c.kdfIterations
                        } : {}, h = s.getKey(n, f, u(u({}, a), {
                            keySize: t + r
                        })), v = new i.e(h.words.slice(t), 4 * r);
                        return h.nSigBytes = 4 * t, new e.Q({
                            key: h,
                            iv: v,
                            salt: f
                        });
                    }
                };
            },
            7008: function(n, t, r) {
                r.d(t, {
                    E: function() {
                        return s;
                    }
                });
                var i, e = r(5561), o = r(6367), u = r(3354), f = r(9541), c = (i = function(n, t) {
                    return (i = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(n, t) {
                        n.__proto__ = t;
                    } || function(n, t) {
                        for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
                    })(n, t);
                }, function(n, t) {
                    function r() {
                        this.constructor = n;
                    }
                    i(n, t), n.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
                }), s = function(n) {
                    function t(t) {
                        var r = n.call(this, t) || this;
                        return r.Sn = 4, r.Mn = e.SHA256, r.kn = 1e4, t && (r.Sn = void 0 !== t.keySize ? t.keySize : r.Sn, r.Mn = void 0 !== t.Hasher ? t.Hasher : r.Mn, r.kn = void 0 !== t.iterations ? t.iterations : r.kn), r;
                    }
                    return c(t, n), t.prototype.compute = function(n, t) {
                        for(var r = new o.Hmac(new this.Mn, n), i = new u.e, e = new u.e([
                            1
                        ]), f = i.words, c = e.words, s = this.Sn, a = this.kn; f.length < s;){
                            var h = r.update(t).finalize(e);
                            r.reset();
                            for(var v = h.words, w = v.length, l = h, b = 1; b < a; b++){
                                l = r.finalize(l), r.reset();
                                for(var d = l.words, y = 0; y < w; y++)v[y] ^= d[y];
                            }
                            i.concat(h), c[0]++;
                        }
                        return i.nSigBytes = 4 * s, i;
                    }, t.getKey = function(n, r, i) {
                        return new t(i).compute(n, r);
                    }, t;
                }(f._);
            },
            9541: function(n, t, r) {
                r.d(t, {
                    _: function() {
                        return i;
                    }
                });
                var i = function() {
                    function n(n) {
                        this.O = n;
                    }
                    return n.prototype.compute = function(n, t) {
                        throw new Error("Not implemented");
                    }, n.getKey = function(n, t, r) {
                        throw new Error("Not implemented");
                    }, n;
                }();
            },
            1863: function(n, t, r) {
                r.d(t, {
                    T: function() {
                        return i;
                    }
                });
                var i = function() {
                    function n(n) {
                        this.O = n, this.Hn = n.cipher, this.ln = n.iv;
                    }
                    return n.prototype.processBlock = function(n, t) {}, n.createEncryptor = function(n) {
                        throw new Error("Not implemented yet");
                    }, n.createDecryptor = function(n) {
                        throw new Error("Not implemented yet");
                    }, n;
                }();
            },
            4344: function(n, t, r) {
                r.d(t, {
                    n: function() {
                        return u;
                    }
                });
                var i, e = r(1863), o = (i = function(n, t) {
                    return (i = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(n, t) {
                        n.__proto__ = t;
                    } || function(n, t) {
                        for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
                    })(n, t);
                }, function(n, t) {
                    function r() {
                        this.constructor = n;
                    }
                    i(n, t), n.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
                }), u = function(n) {
                    function t(t) {
                        var r = n.call(this, t) || this;
                        return r.Cn = [], r;
                    }
                    return o(t, n), t.prototype.xorBlock = function(n, t, r) {
                        var i, e = this.ln;
                        e ? (i = e.words, this.ln = void 0) : i = this.Cn;
                        for(var o = 0; o < r; o++)n[t + o] ^= i[o];
                    }, t.createEncryptor = function(n) {
                        return new t.Encryptor(n);
                    }, t.createDecryptor = function(n) {
                        return new t.Decryptor(n);
                    }, t.Encryptor = function(n) {
                        function t() {
                            return null !== n && n.apply(this, arguments) || this;
                        }
                        return o(t, n), t.prototype.processBlock = function(n, t) {
                            var r = this.Hn, i = r.blockSize;
                            this.xorBlock(n, t, i), r.encryptBlock(n, t), this.Cn = n.slice(t, t + i);
                        }, t;
                    }(t), t.Decryptor = function(n) {
                        function t() {
                            return null !== n && n.apply(this, arguments) || this;
                        }
                        return o(t, n), t.prototype.processBlock = function(n, t) {
                            var r = this.Hn, i = r.blockSize, e = n.slice(t, t + i);
                            r.decryptBlock(n, t), this.xorBlock(n, t, i), this.Cn = e;
                        }, t;
                    }(t), t;
                }(e.T);
            },
            4055: function(n, t, r) {
                r.d(t, {
                    I4: function() {
                        return e;
                    },
                    z6: function() {
                        return o;
                    },
                    ur: function() {
                        return u;
                    }
                });
                var i = r(3354);
                function e(n) {
                    var t = n.nSigBytes % 16;
                    if (0 !== t) {
                        for(var r = 16 - t, e = [], o = Math.floor(r / 4), u = 0; u < o; u++)e.push(0);
                        r % 4 > 0 && e.push(0), n.concat(new i.e(e, r));
                    }
                }
                function o(n, t) {
                    return new i.e(n.words.slice(), t);
                }
                function u(n, t) {
                    for(var r = n.nSigBytes - t, e = [], o = 0; o < t; o++){
                        var u = o >>> 2, f = r + o, c = f >>> 2, s = n.words[c] >>> 24 - f % 4 * 8 & 255;
                        e[u] = 0 | e[u] | s << 24 - o % 4 * 8;
                    }
                    var a = new i.e(e, t);
                    return a.clamp(), a;
                }
            },
            7919: function(n, t, r) {
                r.d(t, {
                    l: function() {
                        return e;
                    }
                });
                var i = r(3354);
                var e = {
                    pad: function(n, t) {
                        for(var r = 4 * t, e = r - n.nSigBytes % r, o = e << 24 | e << 16 | e << 8 | e, u = [], f = 0; f < e; f += 4)u.push(o);
                        var c = new i.e(u, e);
                        n.concat(c);
                    },
                    unpad: function(n) {
                        var t = 255 & n.words[n.nSigBytes - 1 >>> 2];
                        n.nSigBytes -= t;
                    }
                };
            },
            1756: function(n, t, r) {
                r.d(t, {
                    w: function() {
                        return u;
                    }
                });
                var i, e = "undefined" != typeof navigator && navigator.userAgent ? navigator.userAgent.toLowerCase() : "", o = (i = parseInt((/msie (\d+)/.exec(e) || [])[1], 10), isNaN(i) ? (i = parseInt((/trident\/.*; rv:(\d+)/.exec(e) || [])[1], 10), !isNaN(i) && i) : i);
                function u(n, t) {
                    return !1 !== o && (!t || ("<" === n ? o < t : "<=" === n ? o <= t : ">" === n ? o > t : ">=" === n ? o >= t : o === t));
                }
            },
            1773: function(n, t, r) {
                r.d(t, {
                    D: function() {
                        return f;
                    }
                });
                for(var i = r(3354), e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", o = [], u = 0; u < e.length; u++)o[e.charCodeAt(u)] = u;
                var f = {
                    stringify: function(n) {
                        var t = n.words, r = n.nSigBytes;
                        n.clamp();
                        for(var i = [], o = 0; o < r; o += 3)for(var u = (t[o >>> 2] >>> 24 - o % 4 * 8 & 255) << 16 | (t[o + 1 >>> 2] >>> 24 - (o + 1) % 4 * 8 & 255) << 8 | t[o + 2 >>> 2] >>> 24 - (o + 2) % 4 * 8 & 255, f = 0; f < 4 && o + .75 * f < r; f++)i.push(e.charAt(u >>> 6 * (3 - f) & 63));
                        var c = e.charAt(64);
                        if (c) for(; i.length % 4;)i.push(c);
                        return i.join("");
                    },
                    parse: function(n) {
                        var t = n.length, r = e.charAt(64);
                        if (r) {
                            var u = n.indexOf(r);
                            -1 !== u && (t = u);
                        }
                        for(var f = [], c = 0, s = 0; s < t; s++)if (s % 4) {
                            var a = o[n.charCodeAt(s - 1)] << s % 4 * 2 | o[n.charCodeAt(s)] >>> 6 - s % 4 * 2;
                            f[c >>> 2] |= a << 24 - c % 4 * 8, c++;
                        }
                        return new i.e(f, c);
                    }
                };
            },
            5720: function(n, t, r) {
                r.d(t, {
                    p: function() {
                        return e;
                    }
                });
                var i = r(3354), e = {
                    stringify: function(n) {
                        for(var t = n.nSigBytes, r = n.words, i = [], e = 0; e < t; e++){
                            var o = r[e >>> 2] >>> 24 - e % 4 * 8 & 255;
                            i.push((o >>> 4).toString(16)), i.push((15 & o).toString(16));
                        }
                        return i.join("");
                    },
                    parse: function(n) {
                        var t = n.length;
                        if (t % 2 != 0) throw new Error("Hex string count must be even");
                        if (!/^[a-fA-F0-9]+$/.test(n)) throw new Error("Invalid Hex string: " + n);
                        for(var r = [], e = 0; e < t; e += 2)r[e >>> 3] |= parseInt(n.substr(e, 2), 16) << 24 - e % 8 * 4;
                        return new i.e(r, t / 2);
                    }
                };
            },
            8702: function(n, t, r) {
                r.d(t, {
                    m: function() {
                        return e;
                    }
                });
                var i = r(3354), e = {
                    stringify: function(n) {
                        for(var t = n.nSigBytes, r = n.words, i = [], e = 0; e < t; e++){
                            var o = r[e >>> 2] >>> 24 - e % 4 * 8 & 255;
                            i.push(String.fromCharCode(o));
                        }
                        return i.join("");
                    },
                    parse: function(n) {
                        for(var t = n.length, r = [], e = 0; e < t; e++)r[e >>> 2] |= (255 & n.charCodeAt(e)) << 24 - e % 4 * 8;
                        return new i.e(r, t);
                    }
                };
            },
            4768: function(n, t, r) {
                r.d(t, {
                    d: function() {
                        return e;
                    }
                });
                var i = r(8702), e = {
                    stringify: function(n) {
                        try {
                            return decodeURIComponent(escape(i.m.stringify(n)));
                        } catch (n) {
                            throw new Error("Malformed UTF-8 data");
                        }
                    },
                    parse: function(n) {
                        return i.m.parse(unescape(encodeURIComponent(n)));
                    }
                };
            },
            2688: function(n, t, r) {
                r.d(t, {
                    Base64: function() {
                        return o.D;
                    },
                    EvpKDF: function() {
                        return O;
                    },
                    Hex: function() {
                        return c.p;
                    },
                    Latin1: function() {
                        return f.m;
                    },
                    OpenSSLKDF: function() {
                        return l.s;
                    },
                    PBKDF2: function() {
                        return b.E;
                    },
                    Utf16: function() {
                        return w;
                    },
                    Utf16BE: function() {
                        return s;
                    },
                    Utf16LE: function() {
                        return v;
                    },
                    Utf8: function() {
                        return u.d;
                    },
                    Word32Array: function() {
                        return i.e;
                    },
                    Word64: function() {
                        return e.r;
                    },
                    Word64Array: function() {
                        return e.m;
                    }
                });
                r(9054);
                var i = r(3354), e = r(6957), o = (r(1756), r(1773)), u = r(4768), f = r(8702), c = r(5720), s = {
                    stringify: function(n) {
                        for(var t = n.words, r = n.nSigBytes, i = [], e = 0; e < r; e += 2){
                            var o = t[e >>> 2] >>> 16 - e % 4 * 8 & 65535;
                            i.push(String.fromCharCode(o));
                        }
                        return i.join("");
                    },
                    parse: function(n) {
                        for(var t = n.length, r = [], e = 0; e < t; e++)r[e >>> 1] |= n.charCodeAt(e) << 16 - e % 2 * 16;
                        return new i.e(r, 2 * t);
                    }
                };
                function a(n) {
                    return n << 8 & 4278255360 | n >>> 8 & 16711935;
                }
                var h, v = {
                    stringify: function(n) {
                        for(var t = n.words, r = n.nSigBytes, i = [], e = 0; e < r; e += 2){
                            var o = a(t[e >>> 2] >>> 16 - e % 4 * 8 & 65535);
                            i.push(String.fromCharCode(o));
                        }
                        return i.join("");
                    },
                    parse: function(n) {
                        for(var t = n.length, r = [], e = 0; e < t; e++)r[e >>> 1] |= a(n.charCodeAt(e) << 16 - e % 2 * 16);
                        return new i.e(r, 2 * t);
                    }
                }, w = s, l = r(2214), b = r(7008), d = r(670), y = r(9541), p = (h = function(n, t) {
                    return (h = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(n, t) {
                        n.__proto__ = t;
                    } || function(n, t) {
                        for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
                    })(n, t);
                }, function(n, t) {
                    function r() {
                        this.constructor = n;
                    }
                    h(n, t), n.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
                }), O = function(n) {
                    function t(t) {
                        var r = n.call(this, t) || this;
                        return r.Sn = 4, r.Mn = d.MD5, r.kn = 1, t && (r.Sn = void 0 !== t.keySize ? t.keySize : r.Sn, r.Mn = void 0 !== t.Hasher ? t.Hasher : r.Mn, r.kn = void 0 !== t.iterations ? t.iterations : r.kn), r;
                    }
                    return p(t, n), t.prototype.compute = function(n, t) {
                        for(var r, e = new this.Mn, o = new i.e, u = o.words, f = this.Sn, c = this.kn; u.length < f;){
                            r && e.update(r), r = e.update(n).finalize(t), e.reset();
                            for(var s = 1; s < c; s++)r = e.finalize(r), e.reset();
                            o.concat(r);
                        }
                        return o.nSigBytes = 4 * f, o;
                    }, t.getKey = function(n, r, i) {
                        return new t(i).compute(n, r);
                    }, t;
                }(y._);
            },
            9054: function(n, t, r) {
                r.d(t, {
                    M: function() {
                        return e;
                    }
                });
                var i = r(1756);
                var e = function() {
                    if ("undefined" != typeof window) {
                        var n = window.crypto || window.msCrypto;
                        if (!n) {
                            if ((0, i.w)("<", 11)) return console.warn("IE <= 10 uses insecure random generator. Please consider to use IE11 or another modern browser"), function() {
                                return Math.floor(512 * Math.random()) % 256;
                            };
                            throw new Error("Crypto module not found");
                        }
                        return function() {
                            return n.getRandomValues(new Uint32Array(1))[0];
                        };
                    }
                    return void 0 !== r.g && r.g.crypto ? function() {
                        return r.g.crypto.randomBytes(4).readInt32LE();
                    } : function() {
                        return (parcelRequire("aqbQf")).randomBytes(4).readInt32LE();
                    };
                }();
            },
            3664: function(n, t, r) {
                r.d(t, {
                    K: function() {
                        return c;
                    }
                });
                var i, e = r(1863), o = r(3354), u = r(4055), f = (i = function(n, t) {
                    return (i = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(n, t) {
                        n.__proto__ = t;
                    } || function(n, t) {
                        for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
                    })(n, t);
                }, function(n, t) {
                    function r() {
                        this.constructor = n;
                    }
                    i(n, t), n.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
                }), c = function(n) {
                    function t(t) {
                        var r = n.call(this, t) || this;
                        r.Bn = 1;
                        var i = t.cipher, e = t.iv;
                        if (4 !== i.blockSize) throw new Error("In CCM, cipher block size must be 128bit");
                        if (e && (e.nSigBytes > 13 || e.nSigBytes < 7)) throw new Error("Byte size of iv must be between 7 and 13");
                        return r.Nn = e || new o.e([
                            0,
                            0
                        ], 8), r.In = 15 - r.Nn.nSigBytes, r;
                    }
                    return f(t, n), t.getB0 = function(n, t, r, i) {
                        if (r.nSigBytes + i.nSigBytes !== 15) throw new Error("LEN(Q)+LEN(N) must be 15");
                        var e = 255 & (0 | (n ? 1 : 0) << 6 | (t - 2) / 2 << 3 | r.nSigBytes - 1), u = i.clone().concat(r);
                        return new o.e([
                            e << 24
                        ], 1).concat(u);
                    }, t.formatAssociatedDataAndPayload = function(n, t) {
                        var r, i = n.nSigBytes;
                        if (0 === i) r = new o.e([
                            0
                        ], 0);
                        else if (i < Math.pow(2, 16) - Math.pow(2, 8)) r = new o.e([
                            i << 16
                        ], 2);
                        else {
                            if (!(i < Math.pow(2, 32))) throw new Error("LEN(A) larger than 2**32-1 is not supported");
                            r = new o.e([
                                4294836224
                            ], 2).concat(new o.e([
                                i
                            ], 4));
                        }
                        for(var e = Math.floor(n.nSigBytes / 4), u = 0; u < e; u++)r.concat(new o.e([
                            n.words[u]
                        ], 4));
                        n.nSigBytes % 4 && (r.concat(new o.e([
                            n.words[e]
                        ], n.nSigBytes % 4)), r.concat(new o.e([
                            0
                        ], 4 - n.nSigBytes % 4))), r.nSigBytes % 16 && r.concat(new o.e([
                            0
                        ], 16 - r.nSigBytes % 16));
                        var f = Math.floor(t.nSigBytes / 4);
                        for(u = 0; u < f; u++)r.concat(new o.e([
                            t.words[u]
                        ], 4));
                        return t.nSigBytes % 4 && (r.concat(new o.e([
                            t.words[f]
                        ], t.nSigBytes % 4)), r.concat(new o.e([
                            0
                        ], 4 - t.nSigBytes % 4))), r.nSigBytes % 16 && r.concat(new o.e([
                            0
                        ], 16 - r.nSigBytes % 16)), r;
                    }, t.genCtr = function(n, t, r) {
                        if (t.nSigBytes + n !== 15) throw new Error("LEN(Q)+LEN(N) must be 15");
                        for(var i = new o.e([
                            (n - 1 & 7) << 24
                        ], 1), e = new o.e([], 0), u = Math.floor(n / 4), f = 0; f < u - 1; f++)e.concat(new o.e([
                            0
                        ], 4));
                        return n % 4 ? n > 4 ? (e.concat(new o.e([
                            0
                        ], n % 4)), e.concat(new o.e([
                            r
                        ], 4))) : e.concat(new o.e([
                            r << 32 - 8 * n
                        ], n)) : e.concat(new o.e([
                            r
                        ], 4)), i.concat(t).concat(e);
                    }, t.mac = function(n, r, i, e, f, c) {
                        var s = new n({
                            key: r,
                            iv: i
                        });
                        if (4 !== s.blockSize) throw new Error("In CCM, cipher block size must be 128bit");
                        if (i && (i.nSigBytes > 13 || i.nSigBytes < 7)) throw new Error("Byte size of iv must be between 7 and 13");
                        var a = i || new o.e([
                            0,
                            0
                        ], 8), h = (null == e ? void 0 : e.clone()) || new o.e, v = h.nSigBytes, w = (null == f ? void 0 : f.clone()) || new o.e, l = w.nSigBytes;
                        if (l >>> 0 > 4294967295) throw new Error("Byte length of Payload(plainText) larger than 2^32-1 (4,294,967,295byte) is not supported at this time.");
                        var b = 15 - a.nSigBytes, d = (0, u.ur)(new o.e([
                            0,
                            l
                        ], 8), b), y = c || 16, p = t.getB0(Boolean(v), y, d, a), O = t.formatAssociatedDataAndPayload(h, w), j = p.words.slice();
                        s.encryptBlock(j, 0);
                        for(var _ = O.nSigBytes / 16, m = O.words, A = j, g = 0; g < _; g++){
                            var E = [
                                m[4 * g] ^ A[0],
                                m[4 * g + 1] ^ A[1],
                                m[4 * g + 2] ^ A[2],
                                m[4 * g + 3] ^ A[3]
                            ];
                            s.encryptBlock(E, 0), A = E;
                        }
                        var S = new o.e(A, y), M = t.genCtr(b, a, 0);
                        s.encryptBlock(M.words, 0);
                        for(g = 0; g < 4; g++)S.words[g] ^= M.words[g];
                        return S.clamp(), S;
                    }, t.combineCipherTextAndAuthTag = function(n, t) {
                        return n.clone().concat(t);
                    }, t.splitCipherTextAndAuthTag = function(n, t) {
                        var r = t || 16;
                        return {
                            cipherText: (0, u.z6)(n, n.nSigBytes - r),
                            authTag: (0, u.ur)(n, r)
                        };
                    }, t.createEncryptor = function(n) {
                        return new t.Encryptor(n);
                    }, t.createDecryptor = function(n) {
                        return new t.Decryptor(n);
                    }, t.Encryptor = function(n) {
                        function r() {
                            return null !== n && n.apply(this, arguments) || this;
                        }
                        return f(r, n), r.prototype.processBlock = function(n, r) {
                            var i = this.Hn, e = i.blockSize, o = t.genCtr(this.In, this.Nn, this.Bn);
                            i.encryptBlock(o.words, 0);
                            for(var u = 0; u < e; u++)n[r + u] ^= o.words[u];
                            this.Bn++;
                        }, r;
                    }(t), t.Decryptor = function(n) {
                        function r() {
                            return null !== n && n.apply(this, arguments) || this;
                        }
                        return f(r, n), r.prototype.processBlock = function(n, r) {
                            var i = this.Hn, e = i.blockSize, o = t.genCtr(this.In, this.Nn, this.Bn);
                            i.encryptBlock(o.words, 0);
                            for(var u = 0; u < e; u++)n[r + u] ^= o.words[u];
                            this.Bn++;
                        }, r;
                    }(t), t;
                }(e.T);
            },
            5607: function(n, t, r) {
                r.d(t, {
                    V: function() {
                        return c;
                    }
                });
                var i, e = r(1863), o = r(3354), u = r(4055), f = (i = function(n, t) {
                    return (i = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(n, t) {
                        n.__proto__ = t;
                    } || function(n, t) {
                        for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
                    })(n, t);
                }, function(n, t) {
                    function r() {
                        this.constructor = n;
                    }
                    i(n, t), n.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
                }), c = function(n) {
                    function t(r) {
                        var i = n.call(this, r) || this;
                        if (i.zn = [], i.Dn = [], i.Un = [], 4 !== r.cipher.blockSize) throw new Error("In GCM block cipher mode, cipher block size must be 128bit");
                        var e = r.cipher, o = r.iv, u = [
                            0,
                            0,
                            0,
                            0
                        ];
                        return e.encryptBlock(u, 0), i.zn = u, i.Dn = t.getJ0(u, null == o ? void 0 : o.words), i.Un = i.Dn.slice(), i;
                    }
                    return f(t, n), t.getJ0 = function(n, r) {
                        var i;
                        if (r && 0 !== r.length) {
                            if (3 === r.length) i = [
                                r[0],
                                r[1],
                                r[2],
                                1
                            ];
                            else {
                                for(var e = r.length % 4 > 0 ? 4 - r.length % 4 : 0, o = r.slice(), u = 0; u < e + 2; u++)o.push(0);
                                o.push(0), o.push(32 * r.length), i = t.GHASH(n, o);
                            }
                        } else i = [
                            0,
                            0,
                            0,
                            1
                        ];
                        return i;
                    }, t.inc32 = function(n) {
                        var t = n.slice(), r = t[3] >>> 0, i = r + 1 >>> 0 < r;
                        if (t[3] = t[3] + 1 | 0, i) {
                            var e = t[2] >>> 0, o = e + 1 >>> 0 < e;
                            t[2] = t[2] + 1 | 0, o && (t[1] = t[1] + 1 | 0);
                        }
                        return t;
                    }, t.mul = function(n, t) {
                        for(var r = [
                            3774873600,
                            0,
                            0,
                            0
                        ], i = [
                            0,
                            0,
                            0,
                            0
                        ], e = t.slice(), o = 0; o < 128; o++){
                            (n[o >>> 5] >>> 31 - o % 32 & 1) > 0 && (i[0] = i[0] ^ e[0], i[1] = i[1] ^ e[1], i[2] = i[2] ^ e[2], i[3] = i[3] ^ e[3]);
                            var u = (1 & e[3]) >>> 0, f = (1 & e[0]) >>> 0, c = (1 & e[1]) >>> 0, s = (1 & e[2]) >>> 0;
                            e[0] = e[0] >>> 1, e[1] = e[1] >>> 1 | (f ? 2147483648 : 0), e[2] = e[2] >>> 1 | (c ? 2147483648 : 0), e[3] = e[3] >>> 1 | (s ? 2147483648 : 0), u > 0 && (e[0] ^= r[0], e[1] ^= r[1], e[2] ^= r[2], e[3] ^= r[3]);
                        }
                        return i;
                    }, t.GHASH = function(n, r) {
                        if (n.length % 4 != 0) throw new Error("Length of 32bit word array 'H' must be multiple of 4(128bit)");
                        if (r.length % 4 != 0) throw new Error("Length of 32bit word array 'X' must be multiple of 4(128bit)");
                        for(var i = r.length, e = [
                            0,
                            0,
                            0,
                            0
                        ], o = 0; o < i; o += 4)e[0] = e[0] ^ r[o], e[1] = e[1] ^ r[o + 1], e[2] = e[2] ^ r[o + 2], e[3] = e[3] ^ r[o + 3], e = t.mul(e, n);
                        return e;
                    }, t.GCTR = function(n, r, i) {
                        if (0 === i.nSigBytes) return i.clone();
                        if (4 !== r.length) throw new Error("Initial Counter Block size must be 128bit");
                        for(var e = i.words, u = Math.ceil(i.nSigBytes / 16), f = [
                            r.slice()
                        ], c = 1; c < u; c++){
                            var s = t.inc32(f[c - 1]);
                            f.push(s);
                        }
                        var a = new o.e;
                        for(c = 0; c < u; c++){
                            n.encryptBlock(f[c], 0);
                            var h = i.nSigBytes % 16;
                            if (c < u - 1 || 0 === h) {
                                var v = e[4 * c] ^ f[c][0], w = e[4 * c + 1] ^ f[c][1], l = e[4 * c + 2] ^ f[c][2], b = e[4 * c + 3] ^ f[c][3], d = new o.e([
                                    v,
                                    w,
                                    l,
                                    b
                                ]);
                                a.concat(d);
                            } else {
                                for(var y = [], p = 0, O = Math.floor(h / 4), j = 0; j < O; j++){
                                    var _ = e[4 * c + j] ^ f[c][j];
                                    y.push(_), p += 4;
                                }
                                var m = h % 4;
                                if (m > 0) {
                                    var A = e[4 * c + O] << 32 - 8 * m ^ f[c][O];
                                    y.push(A), p += m;
                                }
                                var g = new o.e(y, p);
                                a.concat(g);
                            }
                        }
                        return a.nSigBytes = i.nSigBytes, a.clamp(), a;
                    }, t.mac = function(n, r, i, e, f, c) {
                        var s = new n({
                            key: r,
                            iv: i
                        }), a = [
                            0,
                            0,
                            0,
                            0
                        ];
                        s.encryptBlock(a, 0);
                        var h = t.getJ0(a, i.words), v = (null == e ? void 0 : e.clone()) || new o.e, w = [
                            0,
                            8 * v.nSigBytes
                        ], l = (null == f ? void 0 : f.clone()) || new o.e, b = [
                            0,
                            8 * l.nSigBytes
                        ], d = c || 16;
                        (0, u.I4)(v), (0, u.I4)(l);
                        var y = v.words.concat(l.words).concat(w).concat(b), p = t.GHASH(a, y), O = t.GCTR(s, h, new o.e(p));
                        return (0, u.z6)(O, d);
                    }, t.createEncryptor = function(n) {
                        return new t.Encryptor(n);
                    }, t.createDecryptor = function(n) {
                        return new t.Decryptor(n);
                    }, t.Encryptor = function(n) {
                        function r() {
                            return null !== n && n.apply(this, arguments) || this;
                        }
                        return f(r, n), r.prototype.processBlock = function(n, r) {
                            var i = this.Hn.blockSize;
                            this.Un = t.inc32(this.Un);
                            for(var e = new o.e(n.slice(r, r + i)), u = t.GCTR(this.Hn, this.Un, e), f = 0; f < i; f++)n[r + f] = u.words[f];
                        }, r;
                    }(t), t.Decryptor = function(n) {
                        function r() {
                            return null !== n && n.apply(this, arguments) || this;
                        }
                        return f(r, n), r.prototype.processBlock = function(n, r) {
                            var i = this.Hn.blockSize;
                            this.Un = t.inc32(this.Un);
                            for(var e = new o.e(n.slice(r, r + i)), u = t.GCTR(this.Hn, this.Un, e), f = 0; f < i; f++)n[r + f] = u.words[f];
                        }, r;
                    }(t), t;
                }(e.T);
            }
        }, t = {};
        function r(i) {
            var e = t[i];
            if (void 0 !== e) return e.exports;
            var o = t[i] = {
                exports: {}
            };
            return n[i](o, o.exports, r), o.exports;
        }
        r.d = function(n, t) {
            for(var i in t)r.o(t, i) && !r.o(n, i) && Object.defineProperty(n, i, {
                enumerable: !0,
                get: t[i]
            });
        }, r.g = function() {
            if ("object" == typeof globalThis) return globalThis;
            try {
                return this || new Function("return this")();
            } catch (n) {
                if ("object" == typeof window) return window;
            }
        }(), r.o = function(n, t) {
            return Object.prototype.hasOwnProperty.call(n, t);
        }, r.r = function(n) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(n, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(n, "Ln", {
                value: !0
            });
        };
        var i = {};
        return function() {
            r.r(i), r.d(i, {
                AES: function() {
                    return A.AES;
                },
                Base64: function() {
                    return t.Base64;
                },
                CBCMAC: function() {
                    return b.CBCMAC;
                },
                CipherParams: function() {
                    return u.Q;
                },
                DES: function() {
                    return g.DES;
                },
                DES3: function() {
                    return E.DES3;
                },
                EvpKDF: function() {
                    return t.EvpKDF;
                },
                GMAC: function() {
                    return l.GMAC;
                },
                Hex: function() {
                    return t.Hex;
                },
                Hmac: function() {
                    return f.Hmac;
                },
                HmacMD5: function() {
                    return c.HmacMD5;
                },
                HmacSHA1: function() {
                    return s.HmacSHA1;
                },
                HmacSHA224: function() {
                    return a.HmacSHA224;
                },
                HmacSHA256: function() {
                    return h.HmacSHA256;
                },
                HmacSHA384: function() {
                    return v.HmacSHA384;
                },
                HmacSHA512: function() {
                    return w.HmacSHA512;
                },
                Latin1: function() {
                    return t.Latin1;
                },
                MD5: function() {
                    return d.MD5;
                },
                OpenSSLKDF: function() {
                    return t.OpenSSLKDF;
                },
                PBKDF2: function() {
                    return t.PBKDF2;
                },
                PasswordBasedCipher: function() {
                    return o.E;
                },
                RC4: function() {
                    return k.RC4;
                },
                RC4Drop: function() {
                    return H.RC4Drop;
                },
                RIPEMD160: function() {
                    return S.RIPEMD160;
                },
                Rabbit: function() {
                    return M.Rabbit;
                },
                SHA1: function() {
                    return y.SHA1;
                },
                SHA224: function() {
                    return p.SHA224;
                },
                SHA256: function() {
                    return O.SHA256;
                },
                SHA3: function() {
                    return m.SHA3;
                },
                SHA384: function() {
                    return j.SHA384;
                },
                SHA512: function() {
                    return _.SHA512;
                },
                SerializableCipher: function() {
                    return e.D;
                },
                Utf16: function() {
                    return t.Utf16;
                },
                Utf16BE: function() {
                    return t.Utf16BE;
                },
                Utf16LE: function() {
                    return t.Utf16LE;
                },
                Utf8: function() {
                    return t.Utf8;
                },
                Word32Array: function() {
                    return t.Word32Array;
                },
                Word64: function() {
                    return t.Word64;
                },
                Word64Array: function() {
                    return t.Word64Array;
                },
                formatter: function() {
                    return Y;
                },
                mode: function() {
                    return Z;
                },
                pad: function() {
                    return J;
                }
            });
            var n, t = r(2688), e = r(9109), o = r(5693), u = r(2505), f = r(6367), c = r(3027), s = r(149), a = r(4105), h = r(980), v = r(5838), w = r(9902), l = r(7753), b = r(3967), d = r(670), y = r(3173), p = r(766), O = r(5561), j = r(6324), _ = r(7491), m = r(3408), A = r(9691), g = r(9910), E = r(6739), S = r(7104), M = r(5187), k = r(4615), H = r(9639), C = r(4344), B = r(1863), N = (n = function(t, r) {
                return (n = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(n, t) {
                    n.__proto__ = t;
                } || function(n, t) {
                    for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
                })(t, r);
            }, function(t, r) {
                function i() {
                    this.constructor = t;
                }
                n(t, r), t.prototype = null === r ? Object.create(r) : (i.prototype = r.prototype, new i);
            }), I = function(n) {
                function t(t) {
                    var r = n.call(this, t) || this;
                    return r.Cn = [], r;
                }
                return N(t, n), t.prototype.generateKeyStreamAndEncrypt = function(n, t, r, i) {
                    var e, o = this.ln;
                    o ? (e = o.words.slice(0), this.ln = void 0) : e = this.Cn, i.encryptBlock(e, 0);
                    for(var u = 0; u < r; u++)n[t + u] ^= e[u];
                }, t.createEncryptor = function(n) {
                    return new t.Encryptor(n);
                }, t.createDecryptor = function(n) {
                    return new t.Decryptor(n);
                }, t.Encryptor = function(n) {
                    function t() {
                        return null !== n && n.apply(this, arguments) || this;
                    }
                    return N(t, n), t.prototype.processBlock = function(n, t) {
                        this.generateKeyStreamAndEncrypt(n, t, this.Hn.blockSize, this.Hn), this.Cn = n.slice(t, t + this.Hn.blockSize);
                    }, t;
                }(t), t.Decryptor = function(n) {
                    function t() {
                        return null !== n && n.apply(this, arguments) || this;
                    }
                    return N(t, n), t.prototype.processBlock = function(n, t) {
                        var r = n.slice(t, t + this.Hn.blockSize);
                        this.generateKeyStreamAndEncrypt(n, t, this.Hn.blockSize, this.Hn), this.Cn = r;
                    }, t;
                }(t), t;
            }(B.T), z = function() {
                var n = function(t, r) {
                    return (n = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(n, t) {
                        n.__proto__ = t;
                    } || function(n, t) {
                        for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
                    })(t, r);
                };
                return function(t, r) {
                    function i() {
                        this.constructor = t;
                    }
                    n(t, r), t.prototype = null === r ? Object.create(r) : (i.prototype = r.prototype, new i);
                };
            }(), D = function(n) {
                function t(t) {
                    var r = n.call(this, t) || this;
                    return r.Fn = [], r;
                }
                return z(t, n), t.createEncryptor = function(n) {
                    return new t.Encryptor(n);
                }, t.createDecryptor = function(n) {
                    return new t.Decryptor(n);
                }, t.Encryptor = function(n) {
                    function t() {
                        return null !== n && n.apply(this, arguments) || this;
                    }
                    return z(t, n), t.prototype.processBlock = function(n, t) {
                        var r = this.Hn, i = r.blockSize, e = this.ln, o = this.Fn;
                        e && (o = this.Fn = e.words.slice(0), this.ln = void 0);
                        var u = o.slice(0);
                        r.encryptBlock(u, 0), o[i - 1] = o[i - 1] + 1 | 0;
                        for(var f = 0; f < i; f++)n[t + f] ^= u[f];
                    }, t;
                }(t), t.Decryptor = t.Encryptor, t;
            }(B.T), U = function() {
                var n = function(t, r) {
                    return (n = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(n, t) {
                        n.__proto__ = t;
                    } || function(n, t) {
                        for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
                    })(t, r);
                };
                return function(t, r) {
                    function i() {
                        this.constructor = t;
                    }
                    n(t, r), t.prototype = null === r ? Object.create(r) : (i.prototype = r.prototype, new i);
                };
            }(), L = function(n) {
                function t(t) {
                    return n.call(this, t) || this;
                }
                return U(t, n), t.createEncryptor = function(n) {
                    return new t.Encryptor(n);
                }, t.createDecryptor = function(n) {
                    return new t.Decryptor(n);
                }, t.Encryptor = function(n) {
                    function t() {
                        return null !== n && n.apply(this, arguments) || this;
                    }
                    return U(t, n), t.prototype.processBlock = function(n, t) {
                        this.Hn.encryptBlock(n, t);
                    }, t;
                }(t), t.Decryptor = function(n) {
                    function t() {
                        return null !== n && n.apply(this, arguments) || this;
                    }
                    return U(t, n), t.prototype.processBlock = function(n, t) {
                        this.Hn.decryptBlock(n, t);
                    }, t;
                }(t), t;
            }(B.T), F = function() {
                var n = function(t, r) {
                    return (n = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(n, t) {
                        n.__proto__ = t;
                    } || function(n, t) {
                        for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
                    })(t, r);
                };
                return function(t, r) {
                    function i() {
                        this.constructor = t;
                    }
                    n(t, r), t.prototype = null === r ? Object.create(r) : (i.prototype = r.prototype, new i);
                };
            }(), x = function(n) {
                function t(t) {
                    var r = n.call(this, t) || this;
                    return r.xn = [], r;
                }
                return F(t, n), t.createEncryptor = function(n) {
                    return new t.Encryptor(n);
                }, t.createDecryptor = function(n) {
                    return new t.Decryptor(n);
                }, t.Encryptor = function(n) {
                    function t() {
                        return null !== n && n.apply(this, arguments) || this;
                    }
                    return F(t, n), t.prototype.processBlock = function(n, t) {
                        var r = this.Hn, i = r.blockSize, e = this.ln, o = this.xn;
                        e && (o = this.xn = e.words.slice(0), this.ln = void 0), r.encryptBlock(o, 0);
                        for(var u = 0; u < i; u++)n[t + u] ^= o[u];
                    }, t;
                }(t), t.Decryptor = t.Encryptor, t;
            }(B.T), P = r(5607), R = r(3664);
            var T = {
                pad: function(n, t) {
                    var r = n.nSigBytes, i = 4 * t, e = i - r % i, o = r + e - 1;
                    n.clamp(), n.words[o >>> 2] |= e << 24 - o % 4 * 8, n.nSigBytes += e;
                },
                unpad: function(n) {
                    var t = 255 & n.words[n.nSigBytes - 1 >>> 2];
                    n.nSigBytes -= t;
                }
            }, K = r(3354);
            var W = {
                pad: function(n, t) {
                    var r = 4 * t, i = r - n.nSigBytes % r;
                    n.concat(K.e.random(i - 1)).concat(new K.e([
                        i << 24
                    ], 1));
                },
                unpad: function(n) {
                    var t = 255 & n.words[n.nSigBytes - 1 >>> 2];
                    n.nSigBytes -= t;
                }
            };
            var G = {
                pad: function(n, t) {
                    var r = 4 * t;
                    n.clamp(), n.nSigBytes += r - (n.nSigBytes % r || r);
                },
                unpad: function(n) {
                    for(var t = n.words, r = n.nSigBytes - 1; r >= 0; r--)if (t[r >>> 2] >>> 24 - r % 4 * 8 & 255) {
                        n.nSigBytes = r + 1;
                        break;
                    }
                }
            };
            var q = {
                pad: function(n, t) {
                    n.concat(new K.e([
                        2147483648
                    ], 1)), G.pad(n, t);
                },
                unpad: function(n) {
                    G.unpad(n), n.nSigBytes -= 1;
                }
            }, Q = r(7919);
            var X = {
                pad: function(n, t) {},
                unpad: function(n) {}
            }, V = r(1232), Z = {
                CBC: C.n,
                CFB: I,
                CTR: D,
                ECB: L,
                OFB: x,
                GCM: P.V,
                CCM: R.K
            }, J = {
                AnsiX923: T,
                ISO10126: W,
                ISO97971: q,
                Pkcs7: Q.l,
                NoPadding: X,
                Zero: G
            }, Y = {
                OpenSSLFormatter: V.w
            };
        }(), i;
    }();
});

});


parcelRegister("ctODC", function(module, exports) {
"use strict";
var $915f791ffb48cc5d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LegacyAminoPubKey = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $915f791ffb48cc5d$var$long_1 = $915f791ffb48cc5d$var$__importDefault((parcelRequire("9A55m")));

const $915f791ffb48cc5d$var$minimal_1 = $915f791ffb48cc5d$var$__importDefault((parcelRequire("i2pIU")));

var $c5FxR = parcelRequire("c5FxR");
module.exports.protobufPackage = "cosmos.crypto.multisig";
const $915f791ffb48cc5d$var$baseLegacyAminoPubKey = {
    threshold: 0
};
module.exports.LegacyAminoPubKey = {
    encode (message, writer = $915f791ffb48cc5d$var$minimal_1.default.Writer.create()) {
        if (message.threshold !== 0) writer.uint32(8).uint32(message.threshold);
        for (const v of message.publicKeys)$c5FxR.Any.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $915f791ffb48cc5d$var$minimal_1.default.Reader ? input : new $915f791ffb48cc5d$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $915f791ffb48cc5d$var$baseLegacyAminoPubKey);
        message.publicKeys = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.threshold = reader.uint32();
                    break;
                case 2:
                    message.publicKeys.push($c5FxR.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $915f791ffb48cc5d$var$baseLegacyAminoPubKey);
        message.publicKeys = [];
        if (object.threshold !== undefined && object.threshold !== null) message.threshold = Number(object.threshold);
        else message.threshold = 0;
        if (object.publicKeys !== undefined && object.publicKeys !== null) for (const e of object.publicKeys)message.publicKeys.push($c5FxR.Any.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.threshold !== undefined && (obj.threshold = message.threshold);
        if (message.publicKeys) obj.publicKeys = message.publicKeys.map((e)=>e ? $c5FxR.Any.toJSON(e) : undefined);
        else obj.publicKeys = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $915f791ffb48cc5d$var$baseLegacyAminoPubKey);
        message.publicKeys = [];
        if (object.threshold !== undefined && object.threshold !== null) message.threshold = object.threshold;
        else message.threshold = 0;
        if (object.publicKeys !== undefined && object.publicKeys !== null) for (const e of object.publicKeys)message.publicKeys.push($c5FxR.Any.fromPartial(e));
        return message;
    }
};
if ($915f791ffb48cc5d$var$minimal_1.default.util.Long !== $915f791ffb48cc5d$var$long_1.default) {
    $915f791ffb48cc5d$var$minimal_1.default.util.Long = $915f791ffb48cc5d$var$long_1.default;
    $915f791ffb48cc5d$var$minimal_1.default.configure();
}

});

parcelRegister("7yr5m", function(module, exports) {
"use strict";
var $5800b7fc659d5918$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PrivKey = module.exports.PubKey = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $5800b7fc659d5918$var$long_1 = $5800b7fc659d5918$var$__importDefault((parcelRequire("9A55m")));

const $5800b7fc659d5918$var$minimal_1 = $5800b7fc659d5918$var$__importDefault((parcelRequire("i2pIU")));
module.exports.protobufPackage = "cosmos.crypto.secp256k1";
const $5800b7fc659d5918$var$basePubKey = {};
module.exports.PubKey = {
    encode (message, writer = $5800b7fc659d5918$var$minimal_1.default.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5800b7fc659d5918$var$minimal_1.default.Reader ? input : new $5800b7fc659d5918$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $5800b7fc659d5918$var$basePubKey);
        message.key = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $5800b7fc659d5918$var$basePubKey);
        message.key = new Uint8Array();
        if (object.key !== undefined && object.key !== null) message.key = $5800b7fc659d5918$var$bytesFromBase64(object.key);
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = $5800b7fc659d5918$var$base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $5800b7fc659d5918$var$basePubKey);
        if (object.key !== undefined && object.key !== null) message.key = object.key;
        else message.key = new Uint8Array();
        return message;
    }
};
const $5800b7fc659d5918$var$basePrivKey = {};
module.exports.PrivKey = {
    encode (message, writer = $5800b7fc659d5918$var$minimal_1.default.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5800b7fc659d5918$var$minimal_1.default.Reader ? input : new $5800b7fc659d5918$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $5800b7fc659d5918$var$basePrivKey);
        message.key = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $5800b7fc659d5918$var$basePrivKey);
        message.key = new Uint8Array();
        if (object.key !== undefined && object.key !== null) message.key = $5800b7fc659d5918$var$bytesFromBase64(object.key);
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = $5800b7fc659d5918$var$base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $5800b7fc659d5918$var$basePrivKey);
        if (object.key !== undefined && object.key !== null) message.key = object.key;
        else message.key = new Uint8Array();
        return message;
    }
};
var $5800b7fc659d5918$var$globalThis = (()=>{
    if (typeof $5800b7fc659d5918$var$globalThis !== "undefined") return $5800b7fc659d5918$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $5800b7fc659d5918$var$atob = $5800b7fc659d5918$var$globalThis.atob || ((b64)=>$5800b7fc659d5918$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $5800b7fc659d5918$var$bytesFromBase64(b64) {
    const bin = $5800b7fc659d5918$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $5800b7fc659d5918$var$btoa = $5800b7fc659d5918$var$globalThis.btoa || ((bin)=>$5800b7fc659d5918$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $5800b7fc659d5918$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $5800b7fc659d5918$var$btoa(bin.join(""));
}
if ($5800b7fc659d5918$var$minimal_1.default.util.Long !== $5800b7fc659d5918$var$long_1.default) {
    $5800b7fc659d5918$var$minimal_1.default.util.Long = $5800b7fc659d5918$var$long_1.default;
    $5800b7fc659d5918$var$minimal_1.default.configure();
}

});

parcelRegister("e7zJu", function(module, exports) {
"use strict";
var $a47d6fe32ded49f7$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PrivKey = module.exports.PubKey = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $a47d6fe32ded49f7$var$long_1 = $a47d6fe32ded49f7$var$__importDefault((parcelRequire("9A55m")));

const $a47d6fe32ded49f7$var$minimal_1 = $a47d6fe32ded49f7$var$__importDefault((parcelRequire("i2pIU")));
module.exports.protobufPackage = "cosmos.crypto.ed25519";
const $a47d6fe32ded49f7$var$basePubKey = {};
module.exports.PubKey = {
    encode (message, writer = $a47d6fe32ded49f7$var$minimal_1.default.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a47d6fe32ded49f7$var$minimal_1.default.Reader ? input : new $a47d6fe32ded49f7$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $a47d6fe32ded49f7$var$basePubKey);
        message.key = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $a47d6fe32ded49f7$var$basePubKey);
        message.key = new Uint8Array();
        if (object.key !== undefined && object.key !== null) message.key = $a47d6fe32ded49f7$var$bytesFromBase64(object.key);
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = $a47d6fe32ded49f7$var$base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $a47d6fe32ded49f7$var$basePubKey);
        if (object.key !== undefined && object.key !== null) message.key = object.key;
        else message.key = new Uint8Array();
        return message;
    }
};
const $a47d6fe32ded49f7$var$basePrivKey = {};
module.exports.PrivKey = {
    encode (message, writer = $a47d6fe32ded49f7$var$minimal_1.default.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a47d6fe32ded49f7$var$minimal_1.default.Reader ? input : new $a47d6fe32ded49f7$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $a47d6fe32ded49f7$var$basePrivKey);
        message.key = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $a47d6fe32ded49f7$var$basePrivKey);
        message.key = new Uint8Array();
        if (object.key !== undefined && object.key !== null) message.key = $a47d6fe32ded49f7$var$bytesFromBase64(object.key);
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = $a47d6fe32ded49f7$var$base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $a47d6fe32ded49f7$var$basePrivKey);
        if (object.key !== undefined && object.key !== null) message.key = object.key;
        else message.key = new Uint8Array();
        return message;
    }
};
var $a47d6fe32ded49f7$var$globalThis = (()=>{
    if (typeof $a47d6fe32ded49f7$var$globalThis !== "undefined") return $a47d6fe32ded49f7$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $a47d6fe32ded49f7$var$atob = $a47d6fe32ded49f7$var$globalThis.atob || ((b64)=>$a47d6fe32ded49f7$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $a47d6fe32ded49f7$var$bytesFromBase64(b64) {
    const bin = $a47d6fe32ded49f7$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $a47d6fe32ded49f7$var$btoa = $a47d6fe32ded49f7$var$globalThis.btoa || ((bin)=>$a47d6fe32ded49f7$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $a47d6fe32ded49f7$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $a47d6fe32ded49f7$var$btoa(bin.join(""));
}
if ($a47d6fe32ded49f7$var$minimal_1.default.util.Long !== $a47d6fe32ded49f7$var$long_1.default) {
    $a47d6fe32ded49f7$var$minimal_1.default.util.Long = $a47d6fe32ded49f7$var$long_1.default;
    $a47d6fe32ded49f7$var$minimal_1.default.configure();
}

});

parcelRegister("chCai", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bech32m = module.exports.bech32 = void 0;
const $8f14ad5f9e88d043$var$ALPHABET = "qpzry9x8gf2tvdw0s3jn54khce6mua7l";
const $8f14ad5f9e88d043$var$ALPHABET_MAP = {};
for(let z = 0; z < $8f14ad5f9e88d043$var$ALPHABET.length; z++){
    const x = $8f14ad5f9e88d043$var$ALPHABET.charAt(z);
    $8f14ad5f9e88d043$var$ALPHABET_MAP[x] = z;
}
function $8f14ad5f9e88d043$var$polymodStep(pre) {
    const b = pre >> 25;
    return (pre & 0x1ffffff) << 5 ^ -(b >> 0 & 1) & 0x3b6a57b2 ^ -(b >> 1 & 1) & 0x26508e6d ^ -(b >> 2 & 1) & 0x1ea119fa ^ -(b >> 3 & 1) & 0x3d4233dd ^ -(b >> 4 & 1) & 0x2a1462b3;
}
function $8f14ad5f9e88d043$var$prefixChk(prefix) {
    let chk = 1;
    for(let i = 0; i < prefix.length; ++i){
        const c = prefix.charCodeAt(i);
        if (c < 33 || c > 126) return "Invalid prefix (" + prefix + ")";
        chk = $8f14ad5f9e88d043$var$polymodStep(chk) ^ c >> 5;
    }
    chk = $8f14ad5f9e88d043$var$polymodStep(chk);
    for(let i = 0; i < prefix.length; ++i){
        const v = prefix.charCodeAt(i);
        chk = $8f14ad5f9e88d043$var$polymodStep(chk) ^ v & 0x1f;
    }
    return chk;
}
function $8f14ad5f9e88d043$var$convert(data, inBits, outBits, pad) {
    let value = 0;
    let bits = 0;
    const maxV = (1 << outBits) - 1;
    const result = [];
    for(let i = 0; i < data.length; ++i){
        value = value << inBits | data[i];
        bits += inBits;
        while(bits >= outBits){
            bits -= outBits;
            result.push(value >> bits & maxV);
        }
    }
    if (pad) {
        if (bits > 0) result.push(value << outBits - bits & maxV);
    } else {
        if (bits >= inBits) return "Excess padding";
        if (value << outBits - bits & maxV) return "Non-zero padding";
    }
    return result;
}
function $8f14ad5f9e88d043$var$toWords(bytes) {
    return $8f14ad5f9e88d043$var$convert(bytes, 8, 5, true);
}
function $8f14ad5f9e88d043$var$fromWordsUnsafe(words) {
    const res = $8f14ad5f9e88d043$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
}
function $8f14ad5f9e88d043$var$fromWords(words) {
    const res = $8f14ad5f9e88d043$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
function $8f14ad5f9e88d043$var$getLibraryFromEncoding(encoding) {
    let ENCODING_CONST;
    if (encoding === "bech32") ENCODING_CONST = 1;
    else ENCODING_CONST = 0x2bc830a3;
    function encode(prefix, words, LIMIT) {
        LIMIT = LIMIT || 90;
        if (prefix.length + 7 + words.length > LIMIT) throw new TypeError("Exceeds length limit");
        prefix = prefix.toLowerCase();
        // determine chk mod
        let chk = $8f14ad5f9e88d043$var$prefixChk(prefix);
        if (typeof chk === "string") throw new Error(chk);
        let result = prefix + "1";
        for(let i = 0; i < words.length; ++i){
            const x = words[i];
            if (x >> 5 !== 0) throw new Error("Non 5-bit word");
            chk = $8f14ad5f9e88d043$var$polymodStep(chk) ^ x;
            result += $8f14ad5f9e88d043$var$ALPHABET.charAt(x);
        }
        for(let i = 0; i < 6; ++i)chk = $8f14ad5f9e88d043$var$polymodStep(chk);
        chk ^= ENCODING_CONST;
        for(let i = 0; i < 6; ++i){
            const v = chk >> (5 - i) * 5 & 0x1f;
            result += $8f14ad5f9e88d043$var$ALPHABET.charAt(v);
        }
        return result;
    }
    function __decode(str, LIMIT) {
        LIMIT = LIMIT || 90;
        if (str.length < 8) return str + " too short";
        if (str.length > LIMIT) return "Exceeds length limit";
        // don't allow mixed case
        const lowered = str.toLowerCase();
        const uppered = str.toUpperCase();
        if (str !== lowered && str !== uppered) return "Mixed-case string " + str;
        str = lowered;
        const split = str.lastIndexOf("1");
        if (split === -1) return "No separator character for " + str;
        if (split === 0) return "Missing prefix for " + str;
        const prefix = str.slice(0, split);
        const wordChars = str.slice(split + 1);
        if (wordChars.length < 6) return "Data too short";
        let chk = $8f14ad5f9e88d043$var$prefixChk(prefix);
        if (typeof chk === "string") return chk;
        const words = [];
        for(let i = 0; i < wordChars.length; ++i){
            const c = wordChars.charAt(i);
            const v = $8f14ad5f9e88d043$var$ALPHABET_MAP[c];
            if (v === undefined) return "Unknown character " + c;
            chk = $8f14ad5f9e88d043$var$polymodStep(chk) ^ v;
            // not in the checksum?
            if (i + 6 >= wordChars.length) continue;
            words.push(v);
        }
        if (chk !== ENCODING_CONST) return "Invalid checksum for " + str;
        return {
            prefix: prefix,
            words: words
        };
    }
    function decodeUnsafe(str, LIMIT) {
        const res = __decode(str, LIMIT);
        if (typeof res === "object") return res;
    }
    function decode(str, LIMIT) {
        const res = __decode(str, LIMIT);
        if (typeof res === "object") return res;
        throw new Error(res);
    }
    return {
        decodeUnsafe: decodeUnsafe,
        decode: decode,
        encode: encode,
        toWords: $8f14ad5f9e88d043$var$toWords,
        fromWordsUnsafe: $8f14ad5f9e88d043$var$fromWordsUnsafe,
        fromWords: $8f14ad5f9e88d043$var$fromWords
    };
}
module.exports.bech32 = $8f14ad5f9e88d043$var$getLibraryFromEncoding("bech32");
module.exports.bech32m = $8f14ad5f9e88d043$var$getLibraryFromEncoding("bech32m");

});




parcelRegister("9rvTx", function(module, exports) {
"use strict";
var $6dff604e751269e3$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgEditValidator = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $5iXRZ = parcelRequire("5iXRZ");

var $56eXa = parcelRequire("56eXa");

var $c5FxR = parcelRequire("c5FxR");

var $84C3k = parcelRequire("84C3k");
/**
 * A validator can edit its delegate information, such as moniker, website, commission
 * rate, etc.
 *
 * You must use special or sentinel values to inform that you want to leave the current
 * field untouched. For `Description`,` you should start with [[MsgEditValidator.DESC_DO_NOT_MODIFY]] and
 * change each field you wish to modify individually.
 */ var $6dff604e751269e3$var$MsgEditValidator = /** @class */ function(_super) {
    $6dff604e751269e3$var$__extends(MsgEditValidator, _super);
    /**
     * @param Description new description to apply
     * @param address new address to apply
     * @param commission_rate new commission rates to apply
     * @param min_self_delegation new min self delegation
     */ function MsgEditValidator(description, validator_address, commission_rate, min_self_delegation) {
        var _this = _super.call(this) || this;
        _this.description = description;
        _this.validator_address = validator_address;
        _this.commission_rate = commission_rate;
        _this.min_self_delegation = min_self_delegation;
        return _this;
    }
    MsgEditValidator.fromAmino = function(data, _) {
        _;
        var _a = data.value, description = _a.description, validator_address = _a.validator_address, commission_rate = _a.commission_rate, min_self_delegation = _a.min_self_delegation;
        return new MsgEditValidator($56eXa.Validator.Description.fromAmino(description), validator_address, commission_rate ? new $5iXRZ.Dec(commission_rate) : undefined, min_self_delegation ? new $5iXRZ.Int(min_self_delegation) : undefined);
    };
    MsgEditValidator.prototype.toAmino = function(isClassic) {
        var _a = this, description = _a.description, validator_address = _a.validator_address, commission_rate = _a.commission_rate, min_self_delegation = _a.min_self_delegation;
        return {
            type: isClassic ? "staking/MsgEditValidator" : "cosmos-sdk/MsgEditValidator",
            value: {
                description: description,
                validator_address: validator_address,
                commission_rate: commission_rate ? commission_rate.toString() : undefined,
                min_self_delegation: min_self_delegation ? min_self_delegation.toString() : undefined
            }
        };
    };
    MsgEditValidator.fromProto = function(data, _) {
        _;
        return new MsgEditValidator($56eXa.Validator.Description.fromProto(data.description), data.validatorAddress, data.commissionRate !== "" ? new $5iXRZ.Dec(data.commissionRate) : undefined, data.minSelfDelegation !== "" ? new $5iXRZ.Int(data.minSelfDelegation) : undefined);
    };
    MsgEditValidator.prototype.toProto = function(_) {
        _;
        var _a = this, description = _a.description, validator_address = _a.validator_address, commission_rate = _a.commission_rate, min_self_delegation = _a.min_self_delegation;
        return $84C3k.MsgEditValidator.fromPartial({
            description: description.toProto(),
            commissionRate: (commission_rate === null || commission_rate === void 0 ? void 0 : commission_rate.toString()) || "",
            minSelfDelegation: (min_self_delegation === null || min_self_delegation === void 0 ? void 0 : min_self_delegation.toString()) || "",
            validatorAddress: validator_address
        });
    };
    MsgEditValidator.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmos.staking.v1beta1.MsgEditValidator",
            value: $84C3k.MsgEditValidator.encode(this.toProto(isClassic)).finish()
        });
    };
    MsgEditValidator.unpackAny = function(msgAny, isClassic) {
        return MsgEditValidator.fromProto($84C3k.MsgEditValidator.decode(msgAny.value), isClassic);
    };
    MsgEditValidator.fromData = function(data, _) {
        _;
        var description = data.description, validator_address = data.validator_address, commission_rate = data.commission_rate, min_self_delegation = data.min_self_delegation;
        return new MsgEditValidator($56eXa.Validator.Description.fromData(description), validator_address, commission_rate ? new $5iXRZ.Dec(commission_rate) : undefined, min_self_delegation ? new $5iXRZ.Int(min_self_delegation) : undefined);
    };
    MsgEditValidator.prototype.toData = function(_) {
        _;
        var _a = this, description = _a.description, validator_address = _a.validator_address, commission_rate = _a.commission_rate, min_self_delegation = _a.min_self_delegation;
        return {
            "@type": "/cosmos.staking.v1beta1.MsgEditValidator",
            description: description,
            validator_address: validator_address,
            commission_rate: commission_rate ? commission_rate.toString() : undefined,
            min_self_delegation: min_self_delegation ? min_self_delegation.toString() : undefined
        };
    };
    return MsgEditValidator;
}($26Eqx.JSONSerializable);
module.exports.MsgEditValidator = $6dff604e751269e3$var$MsgEditValidator;
(function(MsgEditValidator) {
    MsgEditValidator.DESC_DO_NOT_MODIFY = {
        moniker: "[do-not-modify]",
        website: "[do-not-modify]",
        identity: "[do-not-modify]",
        details: "[do-not-modify]",
        security_contact: "[do-not-modify]"
    };
})($6dff604e751269e3$var$MsgEditValidator = module.exports.MsgEditValidator || (module.exports.MsgEditValidator = {}));
module.exports.MsgEditValidator = $6dff604e751269e3$var$MsgEditValidator;

});


parcelRegister("kpoM2", function(module, exports) {
"use strict";
var $edb95c07a76a7a64$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $edb95c07a76a7a64$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $edb95c07a76a7a64$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$edb95c07a76a7a64$var$__exportStar((parcelRequire("aoaIz")), module.exports);

$edb95c07a76a7a64$var$__exportStar((parcelRequire("ghnmf")), module.exports);

$edb95c07a76a7a64$var$__exportStar((parcelRequire("1ncEP")), module.exports);

});
parcelRegister("aoaIz", function(module, exports) {
"use strict";
var $790475a056e1e38c$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $790475a056e1e38c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgCreatePeriodicVestingAccount = void 0;

var $efWAQ = parcelRequire("efWAQ");

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $5hbbY = parcelRequire("5hbbY");

var $790475a056e1e38c$var$long_1 = $790475a056e1e38c$var$__importDefault((parcelRequire("9A55m")));
/**
 * CreatePeriodicVestingAccount defines a method that enables creating a periodic vesting account.
 */ var $790475a056e1e38c$var$MsgCreatePeriodicVestingAccount = /** @class */ function(_super) {
    $790475a056e1e38c$var$__extends(MsgCreatePeriodicVestingAccount, _super);
    /**
     * @param from_address sender's address
     * @param to_address recipient's address
     */ function MsgCreatePeriodicVestingAccount(from_address, to_address, start_time, vesting_periods) {
        var _this = _super.call(this) || this;
        _this.from_address = from_address;
        _this.to_address = to_address;
        _this.start_time = start_time;
        _this.vesting_periods = vesting_periods;
        return _this;
    }
    MsgCreatePeriodicVestingAccount.fromAmino = function(data, isClassic) {
        if (isClassic) throw new Error("Not supported for the network");
        var _a = data.value, from_address = _a.from_address, to_address = _a.to_address, start_time = _a.start_time, vesting_periods = _a.vesting_periods;
        return new MsgCreatePeriodicVestingAccount(from_address, to_address, Number.parseInt(start_time), vesting_periods.map(function(p) {
            return $efWAQ.Period.fromAmino(p, isClassic);
        }));
    };
    MsgCreatePeriodicVestingAccount.prototype.toAmino = function(isClassic) {
        if (isClassic) throw new Error("Not supported for the network");
        var _a = this, from_address = _a.from_address, to_address = _a.to_address, start_time = _a.start_time, vesting_periods = _a.vesting_periods;
        return {
            type: "cosmos-sdk/MsgCreatePeriodicVestingAccount",
            value: {
                from_address: from_address,
                to_address: to_address,
                start_time: start_time.toFixed(),
                vesting_periods: vesting_periods.map(function(p) {
                    return p.toAmino(isClassic);
                })
            }
        };
    };
    MsgCreatePeriodicVestingAccount.fromData = function(data, isClassic) {
        if (isClassic) throw new Error("Not supported for the network");
        var from_address = data.from_address, to_address = data.to_address, start_time = data.start_time, vesting_periods = data.vesting_periods;
        return new MsgCreatePeriodicVestingAccount(from_address, to_address, Number.parseInt(start_time), vesting_periods.map(function(p) {
            return $efWAQ.Period.fromData(p, isClassic);
        }));
    };
    MsgCreatePeriodicVestingAccount.prototype.toData = function(isClassic) {
        if (isClassic) throw new Error("Not supported for the network");
        var _a = this, from_address = _a.from_address, to_address = _a.to_address, start_time = _a.start_time, vesting_periods = _a.vesting_periods;
        return {
            "@type": "/cosmos.vesting.v1beta1.MsgCreatePeriodicVestingAccount",
            from_address: from_address,
            to_address: to_address,
            start_time: start_time.toFixed(),
            vesting_periods: vesting_periods.map(function(p) {
                return p.toData(isClassic);
            })
        };
    };
    MsgCreatePeriodicVestingAccount.fromProto = function(proto, isClassic) {
        if (isClassic) throw new Error("Not supported for the network");
        return new MsgCreatePeriodicVestingAccount(proto.fromAddress, proto.toAddress, proto.startTime.toNumber(), proto.vestingPeriods.map(function(p) {
            return $efWAQ.Period.fromProto(p, isClassic);
        }));
    };
    MsgCreatePeriodicVestingAccount.prototype.toProto = function(isClassic) {
        if (isClassic) throw new Error("Not supported for the network");
        var _a = this, from_address = _a.from_address, to_address = _a.to_address, start_time = _a.start_time, vesting_periods = _a.vesting_periods;
        return $5hbbY.MsgCreatePeriodicVestingAccount.fromPartial({
            fromAddress: from_address,
            toAddress: to_address,
            startTime: $790475a056e1e38c$var$long_1.default.fromNumber(start_time),
            vestingPeriods: vesting_periods.map(function(p) {
                return p.toProto(isClassic);
            })
        });
    };
    MsgCreatePeriodicVestingAccount.prototype.packAny = function(isClassic) {
        if (isClassic) throw new Error("Not supported for the network");
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmos.vesting.v1beta1.MsgCreatePeriodicVestingAccount",
            value: $5hbbY.MsgCreatePeriodicVestingAccount.encode(this.toProto(isClassic)).finish()
        });
    };
    MsgCreatePeriodicVestingAccount.unpackAny = function(msgAny, isClassic) {
        if (isClassic) throw new Error("Not supported for the network");
        return MsgCreatePeriodicVestingAccount.fromProto($5hbbY.MsgCreatePeriodicVestingAccount.decode(msgAny.value), isClassic);
    };
    return MsgCreatePeriodicVestingAccount;
}($26Eqx.JSONSerializable);
module.exports.MsgCreatePeriodicVestingAccount = $790475a056e1e38c$var$MsgCreatePeriodicVestingAccount;

});
parcelRegister("efWAQ", function(module, exports) {
"use strict";
var $a60fead04d763dda$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $a60fead04d763dda$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a60fead04d763dda$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $a60fead04d763dda$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a60fead04d763dda$var$__createBinding(result, mod, k);
    }
    $a60fead04d763dda$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Period = void 0;

var $kYslP = parcelRequire("kYslP");

var $b4dli = parcelRequire("b4dli");

var $26Eqx = parcelRequire("26Eqx");

var $a60fead04d763dda$var$Long = $a60fead04d763dda$var$__importStar((parcelRequire("9A55m")));
/**
 * Period defines a length of time and amount of coins that will vest.
 */ var $a60fead04d763dda$var$Period = /** @class */ function(_super) {
    $a60fead04d763dda$var$__extends(Period, _super);
    /**
     * @param length
     * @param amount
     */ function Period(length, amount) {
        var _this = _super.call(this) || this;
        _this.length = length;
        _this.amount = new $kYslP.Coins(amount);
        return _this;
    }
    Period.fromAmino = function(data, _) {
        _;
        var length = data.length, amount = data.amount;
        return new Period(Number.parseInt(length), $kYslP.Coins.fromAmino(amount));
    };
    Period.prototype.toAmino = function(_) {
        _;
        var _a = this, length = _a.length, amount = _a.amount;
        var res = {
            length: length.toFixed(),
            amount: amount.toAmino()
        };
        return res;
    };
    Period.fromData = function(data, _) {
        _;
        var length = data.length, amount = data.amount;
        return new Period(Number.parseInt(length), $kYslP.Coins.fromData(amount));
    };
    Period.prototype.toData = function(_) {
        _;
        var _a = this, length = _a.length, amount = _a.amount;
        var res = {
            length: length.toFixed(),
            amount: amount.toData()
        };
        return res;
    };
    Period.fromProto = function(proto, _) {
        _;
        return new Period(proto.length.toNumber(), $kYslP.Coins.fromProto(proto.amount));
    };
    Period.prototype.toProto = function(_) {
        _;
        var _a = this, length = _a.length, amount = _a.amount;
        return $b4dli.Period.fromPartial({
            length: $a60fead04d763dda$var$Long.fromNumber(length),
            amount: amount.toProto()
        });
    };
    return Period;
}($26Eqx.JSONSerializable);
module.exports.Period = $a60fead04d763dda$var$Period;

});
parcelRegister("b4dli", function(module, exports) {
"use strict";
var $80ea6af7998c3f4f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PermanentLockedAccount = module.exports.PeriodicVestingAccount = module.exports.Period = module.exports.DelayedVestingAccount = module.exports.ContinuousVestingAccount = module.exports.BaseVestingAccount = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $80ea6af7998c3f4f$var$long_1 = $80ea6af7998c3f4f$var$__importDefault((parcelRequire("9A55m")));

const $80ea6af7998c3f4f$var$minimal_1 = $80ea6af7998c3f4f$var$__importDefault((parcelRequire("i2pIU")));

var $8Ali1 = parcelRequire("8Ali1");

var $lPVUQ = parcelRequire("lPVUQ");
module.exports.protobufPackage = "cosmos.vesting.v1beta1";
const $80ea6af7998c3f4f$var$baseBaseVestingAccount = {
    endTime: $80ea6af7998c3f4f$var$long_1.default.ZERO
};
module.exports.BaseVestingAccount = {
    encode (message, writer = $80ea6af7998c3f4f$var$minimal_1.default.Writer.create()) {
        if (message.baseAccount !== undefined) $8Ali1.BaseAccount.encode(message.baseAccount, writer.uint32(10).fork()).ldelim();
        for (const v of message.originalVesting)$lPVUQ.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        for (const v of message.delegatedFree)$lPVUQ.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        for (const v of message.delegatedVesting)$lPVUQ.Coin.encode(v, writer.uint32(34).fork()).ldelim();
        if (!message.endTime.isZero()) writer.uint32(40).int64(message.endTime);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $80ea6af7998c3f4f$var$minimal_1.default.Reader ? input : new $80ea6af7998c3f4f$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $80ea6af7998c3f4f$var$baseBaseVestingAccount);
        message.originalVesting = [];
        message.delegatedFree = [];
        message.delegatedVesting = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.baseAccount = $8Ali1.BaseAccount.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.originalVesting.push($lPVUQ.Coin.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.delegatedFree.push($lPVUQ.Coin.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.delegatedVesting.push($lPVUQ.Coin.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.endTime = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $80ea6af7998c3f4f$var$baseBaseVestingAccount);
        message.originalVesting = [];
        message.delegatedFree = [];
        message.delegatedVesting = [];
        if (object.baseAccount !== undefined && object.baseAccount !== null) message.baseAccount = $8Ali1.BaseAccount.fromJSON(object.baseAccount);
        else message.baseAccount = undefined;
        if (object.originalVesting !== undefined && object.originalVesting !== null) for (const e of object.originalVesting)message.originalVesting.push($lPVUQ.Coin.fromJSON(e));
        if (object.delegatedFree !== undefined && object.delegatedFree !== null) for (const e of object.delegatedFree)message.delegatedFree.push($lPVUQ.Coin.fromJSON(e));
        if (object.delegatedVesting !== undefined && object.delegatedVesting !== null) for (const e of object.delegatedVesting)message.delegatedVesting.push($lPVUQ.Coin.fromJSON(e));
        if (object.endTime !== undefined && object.endTime !== null) message.endTime = $80ea6af7998c3f4f$var$long_1.default.fromString(object.endTime);
        else message.endTime = $80ea6af7998c3f4f$var$long_1.default.ZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.baseAccount !== undefined && (obj.baseAccount = message.baseAccount ? $8Ali1.BaseAccount.toJSON(message.baseAccount) : undefined);
        if (message.originalVesting) obj.originalVesting = message.originalVesting.map((e)=>e ? $lPVUQ.Coin.toJSON(e) : undefined);
        else obj.originalVesting = [];
        if (message.delegatedFree) obj.delegatedFree = message.delegatedFree.map((e)=>e ? $lPVUQ.Coin.toJSON(e) : undefined);
        else obj.delegatedFree = [];
        if (message.delegatedVesting) obj.delegatedVesting = message.delegatedVesting.map((e)=>e ? $lPVUQ.Coin.toJSON(e) : undefined);
        else obj.delegatedVesting = [];
        message.endTime !== undefined && (obj.endTime = (message.endTime || $80ea6af7998c3f4f$var$long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $80ea6af7998c3f4f$var$baseBaseVestingAccount);
        message.originalVesting = [];
        message.delegatedFree = [];
        message.delegatedVesting = [];
        if (object.baseAccount !== undefined && object.baseAccount !== null) message.baseAccount = $8Ali1.BaseAccount.fromPartial(object.baseAccount);
        else message.baseAccount = undefined;
        if (object.originalVesting !== undefined && object.originalVesting !== null) for (const e of object.originalVesting)message.originalVesting.push($lPVUQ.Coin.fromPartial(e));
        if (object.delegatedFree !== undefined && object.delegatedFree !== null) for (const e of object.delegatedFree)message.delegatedFree.push($lPVUQ.Coin.fromPartial(e));
        if (object.delegatedVesting !== undefined && object.delegatedVesting !== null) for (const e of object.delegatedVesting)message.delegatedVesting.push($lPVUQ.Coin.fromPartial(e));
        if (object.endTime !== undefined && object.endTime !== null) message.endTime = object.endTime;
        else message.endTime = $80ea6af7998c3f4f$var$long_1.default.ZERO;
        return message;
    }
};
const $80ea6af7998c3f4f$var$baseContinuousVestingAccount = {
    startTime: $80ea6af7998c3f4f$var$long_1.default.ZERO
};
module.exports.ContinuousVestingAccount = {
    encode (message, writer = $80ea6af7998c3f4f$var$minimal_1.default.Writer.create()) {
        if (message.baseVestingAccount !== undefined) module.exports.BaseVestingAccount.encode(message.baseVestingAccount, writer.uint32(10).fork()).ldelim();
        if (!message.startTime.isZero()) writer.uint32(16).int64(message.startTime);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $80ea6af7998c3f4f$var$minimal_1.default.Reader ? input : new $80ea6af7998c3f4f$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $80ea6af7998c3f4f$var$baseContinuousVestingAccount);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.baseVestingAccount = module.exports.BaseVestingAccount.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.startTime = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $80ea6af7998c3f4f$var$baseContinuousVestingAccount);
        if (object.baseVestingAccount !== undefined && object.baseVestingAccount !== null) message.baseVestingAccount = module.exports.BaseVestingAccount.fromJSON(object.baseVestingAccount);
        else message.baseVestingAccount = undefined;
        if (object.startTime !== undefined && object.startTime !== null) message.startTime = $80ea6af7998c3f4f$var$long_1.default.fromString(object.startTime);
        else message.startTime = $80ea6af7998c3f4f$var$long_1.default.ZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.baseVestingAccount !== undefined && (obj.baseVestingAccount = message.baseVestingAccount ? module.exports.BaseVestingAccount.toJSON(message.baseVestingAccount) : undefined);
        message.startTime !== undefined && (obj.startTime = (message.startTime || $80ea6af7998c3f4f$var$long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $80ea6af7998c3f4f$var$baseContinuousVestingAccount);
        if (object.baseVestingAccount !== undefined && object.baseVestingAccount !== null) message.baseVestingAccount = module.exports.BaseVestingAccount.fromPartial(object.baseVestingAccount);
        else message.baseVestingAccount = undefined;
        if (object.startTime !== undefined && object.startTime !== null) message.startTime = object.startTime;
        else message.startTime = $80ea6af7998c3f4f$var$long_1.default.ZERO;
        return message;
    }
};
const $80ea6af7998c3f4f$var$baseDelayedVestingAccount = {};
module.exports.DelayedVestingAccount = {
    encode (message, writer = $80ea6af7998c3f4f$var$minimal_1.default.Writer.create()) {
        if (message.baseVestingAccount !== undefined) module.exports.BaseVestingAccount.encode(message.baseVestingAccount, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $80ea6af7998c3f4f$var$minimal_1.default.Reader ? input : new $80ea6af7998c3f4f$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $80ea6af7998c3f4f$var$baseDelayedVestingAccount);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.baseVestingAccount = module.exports.BaseVestingAccount.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $80ea6af7998c3f4f$var$baseDelayedVestingAccount);
        if (object.baseVestingAccount !== undefined && object.baseVestingAccount !== null) message.baseVestingAccount = module.exports.BaseVestingAccount.fromJSON(object.baseVestingAccount);
        else message.baseVestingAccount = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.baseVestingAccount !== undefined && (obj.baseVestingAccount = message.baseVestingAccount ? module.exports.BaseVestingAccount.toJSON(message.baseVestingAccount) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $80ea6af7998c3f4f$var$baseDelayedVestingAccount);
        if (object.baseVestingAccount !== undefined && object.baseVestingAccount !== null) message.baseVestingAccount = module.exports.BaseVestingAccount.fromPartial(object.baseVestingAccount);
        else message.baseVestingAccount = undefined;
        return message;
    }
};
const $80ea6af7998c3f4f$var$basePeriod = {
    length: $80ea6af7998c3f4f$var$long_1.default.ZERO
};
module.exports.Period = {
    encode (message, writer = $80ea6af7998c3f4f$var$minimal_1.default.Writer.create()) {
        if (!message.length.isZero()) writer.uint32(8).int64(message.length);
        for (const v of message.amount)$lPVUQ.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $80ea6af7998c3f4f$var$minimal_1.default.Reader ? input : new $80ea6af7998c3f4f$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $80ea6af7998c3f4f$var$basePeriod);
        message.amount = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.length = reader.int64();
                    break;
                case 2:
                    message.amount.push($lPVUQ.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $80ea6af7998c3f4f$var$basePeriod);
        message.amount = [];
        if (object.length !== undefined && object.length !== null) message.length = $80ea6af7998c3f4f$var$long_1.default.fromString(object.length);
        else message.length = $80ea6af7998c3f4f$var$long_1.default.ZERO;
        if (object.amount !== undefined && object.amount !== null) for (const e of object.amount)message.amount.push($lPVUQ.Coin.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.length !== undefined && (obj.length = (message.length || $80ea6af7998c3f4f$var$long_1.default.ZERO).toString());
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $lPVUQ.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $80ea6af7998c3f4f$var$basePeriod);
        message.amount = [];
        if (object.length !== undefined && object.length !== null) message.length = object.length;
        else message.length = $80ea6af7998c3f4f$var$long_1.default.ZERO;
        if (object.amount !== undefined && object.amount !== null) for (const e of object.amount)message.amount.push($lPVUQ.Coin.fromPartial(e));
        return message;
    }
};
const $80ea6af7998c3f4f$var$basePeriodicVestingAccount = {
    startTime: $80ea6af7998c3f4f$var$long_1.default.ZERO
};
module.exports.PeriodicVestingAccount = {
    encode (message, writer = $80ea6af7998c3f4f$var$minimal_1.default.Writer.create()) {
        if (message.baseVestingAccount !== undefined) module.exports.BaseVestingAccount.encode(message.baseVestingAccount, writer.uint32(10).fork()).ldelim();
        if (!message.startTime.isZero()) writer.uint32(16).int64(message.startTime);
        for (const v of message.vestingPeriods)module.exports.Period.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $80ea6af7998c3f4f$var$minimal_1.default.Reader ? input : new $80ea6af7998c3f4f$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $80ea6af7998c3f4f$var$basePeriodicVestingAccount);
        message.vestingPeriods = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.baseVestingAccount = module.exports.BaseVestingAccount.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.startTime = reader.int64();
                    break;
                case 3:
                    message.vestingPeriods.push(module.exports.Period.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $80ea6af7998c3f4f$var$basePeriodicVestingAccount);
        message.vestingPeriods = [];
        if (object.baseVestingAccount !== undefined && object.baseVestingAccount !== null) message.baseVestingAccount = module.exports.BaseVestingAccount.fromJSON(object.baseVestingAccount);
        else message.baseVestingAccount = undefined;
        if (object.startTime !== undefined && object.startTime !== null) message.startTime = $80ea6af7998c3f4f$var$long_1.default.fromString(object.startTime);
        else message.startTime = $80ea6af7998c3f4f$var$long_1.default.ZERO;
        if (object.vestingPeriods !== undefined && object.vestingPeriods !== null) for (const e of object.vestingPeriods)message.vestingPeriods.push(module.exports.Period.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.baseVestingAccount !== undefined && (obj.baseVestingAccount = message.baseVestingAccount ? module.exports.BaseVestingAccount.toJSON(message.baseVestingAccount) : undefined);
        message.startTime !== undefined && (obj.startTime = (message.startTime || $80ea6af7998c3f4f$var$long_1.default.ZERO).toString());
        if (message.vestingPeriods) obj.vestingPeriods = message.vestingPeriods.map((e)=>e ? module.exports.Period.toJSON(e) : undefined);
        else obj.vestingPeriods = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $80ea6af7998c3f4f$var$basePeriodicVestingAccount);
        message.vestingPeriods = [];
        if (object.baseVestingAccount !== undefined && object.baseVestingAccount !== null) message.baseVestingAccount = module.exports.BaseVestingAccount.fromPartial(object.baseVestingAccount);
        else message.baseVestingAccount = undefined;
        if (object.startTime !== undefined && object.startTime !== null) message.startTime = object.startTime;
        else message.startTime = $80ea6af7998c3f4f$var$long_1.default.ZERO;
        if (object.vestingPeriods !== undefined && object.vestingPeriods !== null) for (const e of object.vestingPeriods)message.vestingPeriods.push(module.exports.Period.fromPartial(e));
        return message;
    }
};
const $80ea6af7998c3f4f$var$basePermanentLockedAccount = {};
module.exports.PermanentLockedAccount = {
    encode (message, writer = $80ea6af7998c3f4f$var$minimal_1.default.Writer.create()) {
        if (message.baseVestingAccount !== undefined) module.exports.BaseVestingAccount.encode(message.baseVestingAccount, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $80ea6af7998c3f4f$var$minimal_1.default.Reader ? input : new $80ea6af7998c3f4f$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $80ea6af7998c3f4f$var$basePermanentLockedAccount);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.baseVestingAccount = module.exports.BaseVestingAccount.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $80ea6af7998c3f4f$var$basePermanentLockedAccount);
        if (object.baseVestingAccount !== undefined && object.baseVestingAccount !== null) message.baseVestingAccount = module.exports.BaseVestingAccount.fromJSON(object.baseVestingAccount);
        else message.baseVestingAccount = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.baseVestingAccount !== undefined && (obj.baseVestingAccount = message.baseVestingAccount ? module.exports.BaseVestingAccount.toJSON(message.baseVestingAccount) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $80ea6af7998c3f4f$var$basePermanentLockedAccount);
        if (object.baseVestingAccount !== undefined && object.baseVestingAccount !== null) message.baseVestingAccount = module.exports.BaseVestingAccount.fromPartial(object.baseVestingAccount);
        else message.baseVestingAccount = undefined;
        return message;
    }
};
if ($80ea6af7998c3f4f$var$minimal_1.default.util.Long !== $80ea6af7998c3f4f$var$long_1.default) {
    $80ea6af7998c3f4f$var$minimal_1.default.util.Long = $80ea6af7998c3f4f$var$long_1.default;
    $80ea6af7998c3f4f$var$minimal_1.default.configure();
}

});
parcelRegister("8Ali1", function(module, exports) {
"use strict";
var $6402332f5a0a7cce$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Params = module.exports.ModuleAccount = module.exports.BaseAccount = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $6402332f5a0a7cce$var$long_1 = $6402332f5a0a7cce$var$__importDefault((parcelRequire("9A55m")));

const $6402332f5a0a7cce$var$minimal_1 = $6402332f5a0a7cce$var$__importDefault((parcelRequire("i2pIU")));

var $c5FxR = parcelRequire("c5FxR");
module.exports.protobufPackage = "cosmos.auth.v1beta1";
const $6402332f5a0a7cce$var$baseBaseAccount = {
    address: "",
    accountNumber: $6402332f5a0a7cce$var$long_1.default.UZERO,
    sequence: $6402332f5a0a7cce$var$long_1.default.UZERO
};
module.exports.BaseAccount = {
    encode (message, writer = $6402332f5a0a7cce$var$minimal_1.default.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.pubKey !== undefined) $c5FxR.Any.encode(message.pubKey, writer.uint32(18).fork()).ldelim();
        if (!message.accountNumber.isZero()) writer.uint32(24).uint64(message.accountNumber);
        if (!message.sequence.isZero()) writer.uint32(32).uint64(message.sequence);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6402332f5a0a7cce$var$minimal_1.default.Reader ? input : new $6402332f5a0a7cce$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $6402332f5a0a7cce$var$baseBaseAccount);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.pubKey = $c5FxR.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.accountNumber = reader.uint64();
                    break;
                case 4:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $6402332f5a0a7cce$var$baseBaseAccount);
        if (object.address !== undefined && object.address !== null) message.address = String(object.address);
        else message.address = "";
        if (object.pubKey !== undefined && object.pubKey !== null) message.pubKey = $c5FxR.Any.fromJSON(object.pubKey);
        else message.pubKey = undefined;
        if (object.accountNumber !== undefined && object.accountNumber !== null) message.accountNumber = $6402332f5a0a7cce$var$long_1.default.fromString(object.accountNumber);
        else message.accountNumber = $6402332f5a0a7cce$var$long_1.default.UZERO;
        if (object.sequence !== undefined && object.sequence !== null) message.sequence = $6402332f5a0a7cce$var$long_1.default.fromString(object.sequence);
        else message.sequence = $6402332f5a0a7cce$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.pubKey !== undefined && (obj.pubKey = message.pubKey ? $c5FxR.Any.toJSON(message.pubKey) : undefined);
        message.accountNumber !== undefined && (obj.accountNumber = (message.accountNumber || $6402332f5a0a7cce$var$long_1.default.UZERO).toString());
        message.sequence !== undefined && (obj.sequence = (message.sequence || $6402332f5a0a7cce$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $6402332f5a0a7cce$var$baseBaseAccount);
        if (object.address !== undefined && object.address !== null) message.address = object.address;
        else message.address = "";
        if (object.pubKey !== undefined && object.pubKey !== null) message.pubKey = $c5FxR.Any.fromPartial(object.pubKey);
        else message.pubKey = undefined;
        if (object.accountNumber !== undefined && object.accountNumber !== null) message.accountNumber = object.accountNumber;
        else message.accountNumber = $6402332f5a0a7cce$var$long_1.default.UZERO;
        if (object.sequence !== undefined && object.sequence !== null) message.sequence = object.sequence;
        else message.sequence = $6402332f5a0a7cce$var$long_1.default.UZERO;
        return message;
    }
};
const $6402332f5a0a7cce$var$baseModuleAccount = {
    name: "",
    permissions: ""
};
module.exports.ModuleAccount = {
    encode (message, writer = $6402332f5a0a7cce$var$minimal_1.default.Writer.create()) {
        if (message.baseAccount !== undefined) module.exports.BaseAccount.encode(message.baseAccount, writer.uint32(10).fork()).ldelim();
        if (message.name !== "") writer.uint32(18).string(message.name);
        for (const v of message.permissions)writer.uint32(26).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6402332f5a0a7cce$var$minimal_1.default.Reader ? input : new $6402332f5a0a7cce$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $6402332f5a0a7cce$var$baseModuleAccount);
        message.permissions = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.baseAccount = module.exports.BaseAccount.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.name = reader.string();
                    break;
                case 3:
                    message.permissions.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $6402332f5a0a7cce$var$baseModuleAccount);
        message.permissions = [];
        if (object.baseAccount !== undefined && object.baseAccount !== null) message.baseAccount = module.exports.BaseAccount.fromJSON(object.baseAccount);
        else message.baseAccount = undefined;
        if (object.name !== undefined && object.name !== null) message.name = String(object.name);
        else message.name = "";
        if (object.permissions !== undefined && object.permissions !== null) for (const e of object.permissions)message.permissions.push(String(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.baseAccount !== undefined && (obj.baseAccount = message.baseAccount ? module.exports.BaseAccount.toJSON(message.baseAccount) : undefined);
        message.name !== undefined && (obj.name = message.name);
        if (message.permissions) obj.permissions = message.permissions.map((e)=>e);
        else obj.permissions = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $6402332f5a0a7cce$var$baseModuleAccount);
        message.permissions = [];
        if (object.baseAccount !== undefined && object.baseAccount !== null) message.baseAccount = module.exports.BaseAccount.fromPartial(object.baseAccount);
        else message.baseAccount = undefined;
        if (object.name !== undefined && object.name !== null) message.name = object.name;
        else message.name = "";
        if (object.permissions !== undefined && object.permissions !== null) for (const e of object.permissions)message.permissions.push(e);
        return message;
    }
};
const $6402332f5a0a7cce$var$baseParams = {
    maxMemoCharacters: $6402332f5a0a7cce$var$long_1.default.UZERO,
    txSigLimit: $6402332f5a0a7cce$var$long_1.default.UZERO,
    txSizeCostPerByte: $6402332f5a0a7cce$var$long_1.default.UZERO,
    sigVerifyCostEd25519: $6402332f5a0a7cce$var$long_1.default.UZERO,
    sigVerifyCostSecp256k1: $6402332f5a0a7cce$var$long_1.default.UZERO
};
module.exports.Params = {
    encode (message, writer = $6402332f5a0a7cce$var$minimal_1.default.Writer.create()) {
        if (!message.maxMemoCharacters.isZero()) writer.uint32(8).uint64(message.maxMemoCharacters);
        if (!message.txSigLimit.isZero()) writer.uint32(16).uint64(message.txSigLimit);
        if (!message.txSizeCostPerByte.isZero()) writer.uint32(24).uint64(message.txSizeCostPerByte);
        if (!message.sigVerifyCostEd25519.isZero()) writer.uint32(32).uint64(message.sigVerifyCostEd25519);
        if (!message.sigVerifyCostSecp256k1.isZero()) writer.uint32(40).uint64(message.sigVerifyCostSecp256k1);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6402332f5a0a7cce$var$minimal_1.default.Reader ? input : new $6402332f5a0a7cce$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $6402332f5a0a7cce$var$baseParams);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.maxMemoCharacters = reader.uint64();
                    break;
                case 2:
                    message.txSigLimit = reader.uint64();
                    break;
                case 3:
                    message.txSizeCostPerByte = reader.uint64();
                    break;
                case 4:
                    message.sigVerifyCostEd25519 = reader.uint64();
                    break;
                case 5:
                    message.sigVerifyCostSecp256k1 = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $6402332f5a0a7cce$var$baseParams);
        if (object.maxMemoCharacters !== undefined && object.maxMemoCharacters !== null) message.maxMemoCharacters = $6402332f5a0a7cce$var$long_1.default.fromString(object.maxMemoCharacters);
        else message.maxMemoCharacters = $6402332f5a0a7cce$var$long_1.default.UZERO;
        if (object.txSigLimit !== undefined && object.txSigLimit !== null) message.txSigLimit = $6402332f5a0a7cce$var$long_1.default.fromString(object.txSigLimit);
        else message.txSigLimit = $6402332f5a0a7cce$var$long_1.default.UZERO;
        if (object.txSizeCostPerByte !== undefined && object.txSizeCostPerByte !== null) message.txSizeCostPerByte = $6402332f5a0a7cce$var$long_1.default.fromString(object.txSizeCostPerByte);
        else message.txSizeCostPerByte = $6402332f5a0a7cce$var$long_1.default.UZERO;
        if (object.sigVerifyCostEd25519 !== undefined && object.sigVerifyCostEd25519 !== null) message.sigVerifyCostEd25519 = $6402332f5a0a7cce$var$long_1.default.fromString(object.sigVerifyCostEd25519);
        else message.sigVerifyCostEd25519 = $6402332f5a0a7cce$var$long_1.default.UZERO;
        if (object.sigVerifyCostSecp256k1 !== undefined && object.sigVerifyCostSecp256k1 !== null) message.sigVerifyCostSecp256k1 = $6402332f5a0a7cce$var$long_1.default.fromString(object.sigVerifyCostSecp256k1);
        else message.sigVerifyCostSecp256k1 = $6402332f5a0a7cce$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.maxMemoCharacters !== undefined && (obj.maxMemoCharacters = (message.maxMemoCharacters || $6402332f5a0a7cce$var$long_1.default.UZERO).toString());
        message.txSigLimit !== undefined && (obj.txSigLimit = (message.txSigLimit || $6402332f5a0a7cce$var$long_1.default.UZERO).toString());
        message.txSizeCostPerByte !== undefined && (obj.txSizeCostPerByte = (message.txSizeCostPerByte || $6402332f5a0a7cce$var$long_1.default.UZERO).toString());
        message.sigVerifyCostEd25519 !== undefined && (obj.sigVerifyCostEd25519 = (message.sigVerifyCostEd25519 || $6402332f5a0a7cce$var$long_1.default.UZERO).toString());
        message.sigVerifyCostSecp256k1 !== undefined && (obj.sigVerifyCostSecp256k1 = (message.sigVerifyCostSecp256k1 || $6402332f5a0a7cce$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $6402332f5a0a7cce$var$baseParams);
        if (object.maxMemoCharacters !== undefined && object.maxMemoCharacters !== null) message.maxMemoCharacters = object.maxMemoCharacters;
        else message.maxMemoCharacters = $6402332f5a0a7cce$var$long_1.default.UZERO;
        if (object.txSigLimit !== undefined && object.txSigLimit !== null) message.txSigLimit = object.txSigLimit;
        else message.txSigLimit = $6402332f5a0a7cce$var$long_1.default.UZERO;
        if (object.txSizeCostPerByte !== undefined && object.txSizeCostPerByte !== null) message.txSizeCostPerByte = object.txSizeCostPerByte;
        else message.txSizeCostPerByte = $6402332f5a0a7cce$var$long_1.default.UZERO;
        if (object.sigVerifyCostEd25519 !== undefined && object.sigVerifyCostEd25519 !== null) message.sigVerifyCostEd25519 = object.sigVerifyCostEd25519;
        else message.sigVerifyCostEd25519 = $6402332f5a0a7cce$var$long_1.default.UZERO;
        if (object.sigVerifyCostSecp256k1 !== undefined && object.sigVerifyCostSecp256k1 !== null) message.sigVerifyCostSecp256k1 = object.sigVerifyCostSecp256k1;
        else message.sigVerifyCostSecp256k1 = $6402332f5a0a7cce$var$long_1.default.UZERO;
        return message;
    }
};
if ($6402332f5a0a7cce$var$minimal_1.default.util.Long !== $6402332f5a0a7cce$var$long_1.default) {
    $6402332f5a0a7cce$var$minimal_1.default.util.Long = $6402332f5a0a7cce$var$long_1.default;
    $6402332f5a0a7cce$var$minimal_1.default.configure();
}

});



parcelRegister("5hbbY", function(module, exports) {
"use strict";
var $3d7738cba0a96e88$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GrpcWebImpl = module.exports.MsgDonateAllVestingTokensDesc = module.exports.MsgCreatePeriodicVestingAccountDesc = module.exports.MsgCreateVestingAccountDesc = module.exports.MsgDesc = module.exports.MsgClientImpl = module.exports.MsgDonateAllVestingTokensResponse = module.exports.MsgDonateAllVestingTokens = module.exports.MsgCreatePeriodicVestingAccountResponse = module.exports.MsgCreatePeriodicVestingAccount = module.exports.MsgCreateVestingAccountResponse = module.exports.MsgCreateVestingAccount = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $3d7738cba0a96e88$var$long_1 = $3d7738cba0a96e88$var$__importDefault((parcelRequire("9A55m")));

var $jXVni = parcelRequire("jXVni");

const $3d7738cba0a96e88$var$minimal_1 = $3d7738cba0a96e88$var$__importDefault((parcelRequire("i2pIU")));

var $1pqjL = parcelRequire("1pqjL");

var $lPVUQ = parcelRequire("lPVUQ");

var $b4dli = parcelRequire("b4dli");
module.exports.protobufPackage = "cosmos.vesting.v1beta1";
const $3d7738cba0a96e88$var$baseMsgCreateVestingAccount = {
    fromAddress: "",
    toAddress: "",
    endTime: $3d7738cba0a96e88$var$long_1.default.ZERO,
    delayed: false
};
module.exports.MsgCreateVestingAccount = {
    encode (message, writer = $3d7738cba0a96e88$var$minimal_1.default.Writer.create()) {
        if (message.fromAddress !== "") writer.uint32(10).string(message.fromAddress);
        if (message.toAddress !== "") writer.uint32(18).string(message.toAddress);
        for (const v of message.amount)$lPVUQ.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        if (!message.endTime.isZero()) writer.uint32(32).int64(message.endTime);
        if (message.delayed === true) writer.uint32(40).bool(message.delayed);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3d7738cba0a96e88$var$minimal_1.default.Reader ? input : new $3d7738cba0a96e88$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $3d7738cba0a96e88$var$baseMsgCreateVestingAccount);
        message.amount = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.fromAddress = reader.string();
                    break;
                case 2:
                    message.toAddress = reader.string();
                    break;
                case 3:
                    message.amount.push($lPVUQ.Coin.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.endTime = reader.int64();
                    break;
                case 5:
                    message.delayed = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $3d7738cba0a96e88$var$baseMsgCreateVestingAccount);
        message.amount = [];
        if (object.fromAddress !== undefined && object.fromAddress !== null) message.fromAddress = String(object.fromAddress);
        else message.fromAddress = "";
        if (object.toAddress !== undefined && object.toAddress !== null) message.toAddress = String(object.toAddress);
        else message.toAddress = "";
        if (object.amount !== undefined && object.amount !== null) for (const e of object.amount)message.amount.push($lPVUQ.Coin.fromJSON(e));
        if (object.endTime !== undefined && object.endTime !== null) message.endTime = $3d7738cba0a96e88$var$long_1.default.fromString(object.endTime);
        else message.endTime = $3d7738cba0a96e88$var$long_1.default.ZERO;
        if (object.delayed !== undefined && object.delayed !== null) message.delayed = Boolean(object.delayed);
        else message.delayed = false;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.fromAddress !== undefined && (obj.fromAddress = message.fromAddress);
        message.toAddress !== undefined && (obj.toAddress = message.toAddress);
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $lPVUQ.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        message.endTime !== undefined && (obj.endTime = (message.endTime || $3d7738cba0a96e88$var$long_1.default.ZERO).toString());
        message.delayed !== undefined && (obj.delayed = message.delayed);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $3d7738cba0a96e88$var$baseMsgCreateVestingAccount);
        message.amount = [];
        if (object.fromAddress !== undefined && object.fromAddress !== null) message.fromAddress = object.fromAddress;
        else message.fromAddress = "";
        if (object.toAddress !== undefined && object.toAddress !== null) message.toAddress = object.toAddress;
        else message.toAddress = "";
        if (object.amount !== undefined && object.amount !== null) for (const e of object.amount)message.amount.push($lPVUQ.Coin.fromPartial(e));
        if (object.endTime !== undefined && object.endTime !== null) message.endTime = object.endTime;
        else message.endTime = $3d7738cba0a96e88$var$long_1.default.ZERO;
        if (object.delayed !== undefined && object.delayed !== null) message.delayed = object.delayed;
        else message.delayed = false;
        return message;
    }
};
const $3d7738cba0a96e88$var$baseMsgCreateVestingAccountResponse = {};
module.exports.MsgCreateVestingAccountResponse = {
    encode (_, writer = $3d7738cba0a96e88$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3d7738cba0a96e88$var$minimal_1.default.Reader ? input : new $3d7738cba0a96e88$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $3d7738cba0a96e88$var$baseMsgCreateVestingAccountResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $3d7738cba0a96e88$var$baseMsgCreateVestingAccountResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $3d7738cba0a96e88$var$baseMsgCreateVestingAccountResponse);
        return message;
    }
};
const $3d7738cba0a96e88$var$baseMsgCreatePeriodicVestingAccount = {
    fromAddress: "",
    toAddress: "",
    startTime: $3d7738cba0a96e88$var$long_1.default.ZERO
};
module.exports.MsgCreatePeriodicVestingAccount = {
    encode (message, writer = $3d7738cba0a96e88$var$minimal_1.default.Writer.create()) {
        if (message.fromAddress !== "") writer.uint32(10).string(message.fromAddress);
        if (message.toAddress !== "") writer.uint32(18).string(message.toAddress);
        if (!message.startTime.isZero()) writer.uint32(24).int64(message.startTime);
        for (const v of message.vestingPeriods)$b4dli.Period.encode(v, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3d7738cba0a96e88$var$minimal_1.default.Reader ? input : new $3d7738cba0a96e88$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $3d7738cba0a96e88$var$baseMsgCreatePeriodicVestingAccount);
        message.vestingPeriods = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.fromAddress = reader.string();
                    break;
                case 2:
                    message.toAddress = reader.string();
                    break;
                case 3:
                    message.startTime = reader.int64();
                    break;
                case 4:
                    message.vestingPeriods.push($b4dli.Period.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $3d7738cba0a96e88$var$baseMsgCreatePeriodicVestingAccount);
        message.vestingPeriods = [];
        if (object.fromAddress !== undefined && object.fromAddress !== null) message.fromAddress = String(object.fromAddress);
        else message.fromAddress = "";
        if (object.toAddress !== undefined && object.toAddress !== null) message.toAddress = String(object.toAddress);
        else message.toAddress = "";
        if (object.startTime !== undefined && object.startTime !== null) message.startTime = $3d7738cba0a96e88$var$long_1.default.fromString(object.startTime);
        else message.startTime = $3d7738cba0a96e88$var$long_1.default.ZERO;
        if (object.vestingPeriods !== undefined && object.vestingPeriods !== null) for (const e of object.vestingPeriods)message.vestingPeriods.push($b4dli.Period.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.fromAddress !== undefined && (obj.fromAddress = message.fromAddress);
        message.toAddress !== undefined && (obj.toAddress = message.toAddress);
        message.startTime !== undefined && (obj.startTime = (message.startTime || $3d7738cba0a96e88$var$long_1.default.ZERO).toString());
        if (message.vestingPeriods) obj.vestingPeriods = message.vestingPeriods.map((e)=>e ? $b4dli.Period.toJSON(e) : undefined);
        else obj.vestingPeriods = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $3d7738cba0a96e88$var$baseMsgCreatePeriodicVestingAccount);
        message.vestingPeriods = [];
        if (object.fromAddress !== undefined && object.fromAddress !== null) message.fromAddress = object.fromAddress;
        else message.fromAddress = "";
        if (object.toAddress !== undefined && object.toAddress !== null) message.toAddress = object.toAddress;
        else message.toAddress = "";
        if (object.startTime !== undefined && object.startTime !== null) message.startTime = object.startTime;
        else message.startTime = $3d7738cba0a96e88$var$long_1.default.ZERO;
        if (object.vestingPeriods !== undefined && object.vestingPeriods !== null) for (const e of object.vestingPeriods)message.vestingPeriods.push($b4dli.Period.fromPartial(e));
        return message;
    }
};
const $3d7738cba0a96e88$var$baseMsgCreatePeriodicVestingAccountResponse = {};
module.exports.MsgCreatePeriodicVestingAccountResponse = {
    encode (_, writer = $3d7738cba0a96e88$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3d7738cba0a96e88$var$minimal_1.default.Reader ? input : new $3d7738cba0a96e88$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $3d7738cba0a96e88$var$baseMsgCreatePeriodicVestingAccountResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $3d7738cba0a96e88$var$baseMsgCreatePeriodicVestingAccountResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $3d7738cba0a96e88$var$baseMsgCreatePeriodicVestingAccountResponse);
        return message;
    }
};
const $3d7738cba0a96e88$var$baseMsgDonateAllVestingTokens = {
    fromAddress: ""
};
module.exports.MsgDonateAllVestingTokens = {
    encode (message, writer = $3d7738cba0a96e88$var$minimal_1.default.Writer.create()) {
        if (message.fromAddress !== "") writer.uint32(10).string(message.fromAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3d7738cba0a96e88$var$minimal_1.default.Reader ? input : new $3d7738cba0a96e88$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $3d7738cba0a96e88$var$baseMsgDonateAllVestingTokens);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.fromAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $3d7738cba0a96e88$var$baseMsgDonateAllVestingTokens);
        if (object.fromAddress !== undefined && object.fromAddress !== null) message.fromAddress = String(object.fromAddress);
        else message.fromAddress = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.fromAddress !== undefined && (obj.fromAddress = message.fromAddress);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $3d7738cba0a96e88$var$baseMsgDonateAllVestingTokens);
        if (object.fromAddress !== undefined && object.fromAddress !== null) message.fromAddress = object.fromAddress;
        else message.fromAddress = "";
        return message;
    }
};
const $3d7738cba0a96e88$var$baseMsgDonateAllVestingTokensResponse = {};
module.exports.MsgDonateAllVestingTokensResponse = {
    encode (_, writer = $3d7738cba0a96e88$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3d7738cba0a96e88$var$minimal_1.default.Reader ? input : new $3d7738cba0a96e88$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $3d7738cba0a96e88$var$baseMsgDonateAllVestingTokensResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $3d7738cba0a96e88$var$baseMsgDonateAllVestingTokensResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $3d7738cba0a96e88$var$baseMsgDonateAllVestingTokensResponse);
        return message;
    }
};
class $3d7738cba0a96e88$var$MsgClientImpl {
    CreateVestingAccount(request, metadata) {
        return this.rpc.unary(module.exports.MsgCreateVestingAccountDesc, module.exports.MsgCreateVestingAccount.fromPartial(request), metadata);
    }
    CreatePeriodicVestingAccount(request, metadata) {
        return this.rpc.unary(module.exports.MsgCreatePeriodicVestingAccountDesc, module.exports.MsgCreatePeriodicVestingAccount.fromPartial(request), metadata);
    }
    DonateAllVestingTokens(request, metadata) {
        return this.rpc.unary(module.exports.MsgDonateAllVestingTokensDesc, module.exports.MsgDonateAllVestingTokens.fromPartial(request), metadata);
    }
    constructor(rpc){
        this.rpc = rpc;
        this.CreateVestingAccount = this.CreateVestingAccount.bind(this);
        this.CreatePeriodicVestingAccount = this.CreatePeriodicVestingAccount.bind(this);
        this.DonateAllVestingTokens = this.DonateAllVestingTokens.bind(this);
    }
}
module.exports.MsgClientImpl = $3d7738cba0a96e88$var$MsgClientImpl;
module.exports.MsgDesc = {
    serviceName: "cosmos.vesting.v1beta1.Msg"
};
module.exports.MsgCreateVestingAccountDesc = {
    methodName: "CreateVestingAccount",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgCreateVestingAccount.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgCreateVestingAccountResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.MsgCreatePeriodicVestingAccountDesc = {
    methodName: "CreatePeriodicVestingAccount",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgCreatePeriodicVestingAccount.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgCreatePeriodicVestingAccountResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.MsgDonateAllVestingTokensDesc = {
    methodName: "DonateAllVestingTokens",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgDonateAllVestingTokens.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgDonateAllVestingTokensResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
class $3d7738cba0a96e88$var$GrpcWebImpl {
    unary(methodDesc, _request, metadata) {
        var _a;
        const request = Object.assign(Object.assign({}, _request), methodDesc.requestType);
        const maybeCombinedMetadata = metadata && this.options.metadata ? new $1pqjL.BrowserHeaders(Object.assign(Object.assign({}, (_a = this.options) === null || _a === void 0 ? void 0 : _a.metadata.headersMap), metadata === null || metadata === void 0 ? void 0 : metadata.headersMap)) : metadata || this.options.metadata;
        return new Promise((resolve, reject)=>{
            $jXVni.grpc.unary(methodDesc, {
                request: request,
                host: this.host,
                metadata: maybeCombinedMetadata,
                transport: this.options.transport,
                debug: this.options.debug,
                onEnd: function(response) {
                    if (response.status === $jXVni.grpc.Code.OK) resolve(response.message);
                    else {
                        const err = new Error(response.statusMessage);
                        err.code = response.status;
                        err.metadata = response.trailers;
                        reject(err);
                    }
                }
            });
        });
    }
    constructor(host, options){
        this.host = host;
        this.options = options;
    }
}
module.exports.GrpcWebImpl = $3d7738cba0a96e88$var$GrpcWebImpl;
if ($3d7738cba0a96e88$var$minimal_1.default.util.Long !== $3d7738cba0a96e88$var$long_1.default) {
    $3d7738cba0a96e88$var$minimal_1.default.util.Long = $3d7738cba0a96e88$var$long_1.default;
    $3d7738cba0a96e88$var$minimal_1.default.configure();
}

});


parcelRegister("ghnmf", function(module, exports) {
"use strict";
var $bda05a3ff3bc9ad1$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $bda05a3ff3bc9ad1$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgCreateVestingAccount = void 0;

var $kYslP = parcelRequire("kYslP");

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $5hbbY = parcelRequire("5hbbY");

var $bda05a3ff3bc9ad1$var$long_1 = $bda05a3ff3bc9ad1$var$__importDefault((parcelRequire("9A55m")));
/**
 * MsgCreateVestingAccount defines a message that enables creating a vesting account.
 */ var $bda05a3ff3bc9ad1$var$MsgCreateVestingAccount = /** @class */ function(_super) {
    $bda05a3ff3bc9ad1$var$__extends(MsgCreateVestingAccount, _super);
    /**
     * @param from_address sender's address
     * @param to_address recipient's address
     * @param amount value of the transaction
     */ function MsgCreateVestingAccount(from_address, to_address, amount, end_time, delayed) {
        var _this = _super.call(this) || this;
        _this.from_address = from_address;
        _this.to_address = to_address;
        _this.end_time = end_time;
        _this.delayed = delayed;
        _this.amount = new $kYslP.Coins(amount);
        return _this;
    }
    MsgCreateVestingAccount.fromAmino = function(data, isClassic) {
        if (isClassic) throw new Error("Not supported for the network");
        var _a = data.value, from_address = _a.from_address, to_address = _a.to_address, amount = _a.amount, end_time = _a.end_time, delayed = _a.delayed;
        return new MsgCreateVestingAccount(from_address, to_address, $kYslP.Coins.fromAmino(amount), Number.parseInt(end_time), delayed);
    };
    MsgCreateVestingAccount.prototype.toAmino = function(isClassic) {
        if (isClassic) throw new Error("Not supported for the network");
        var _a = this, from_address = _a.from_address, to_address = _a.to_address, amount = _a.amount, end_time = _a.end_time, delayed = _a.delayed;
        return {
            type: "cosmos-sdk/MsgCreateVestingAccount",
            value: {
                from_address: from_address,
                to_address: to_address,
                amount: amount.toAmino(),
                end_time: end_time.toFixed(),
                delayed: delayed
            }
        };
    };
    MsgCreateVestingAccount.fromData = function(data, isClassic) {
        if (isClassic) throw new Error("Not supported for the network");
        var from_address = data.from_address, to_address = data.to_address, amount = data.amount, end_time = data.end_time, delayed = data.delayed;
        return new MsgCreateVestingAccount(from_address, to_address, $kYslP.Coins.fromData(amount), Number.parseInt(end_time), delayed);
    };
    MsgCreateVestingAccount.prototype.toData = function(isClassic) {
        if (isClassic) throw new Error("Not supported for the network");
        var _a = this, from_address = _a.from_address, to_address = _a.to_address, amount = _a.amount, end_time = _a.end_time, delayed = _a.delayed;
        return {
            "@type": "/cosmos.vesting.v1beta1.MsgCreateVestingAccount",
            from_address: from_address,
            to_address: to_address,
            amount: amount.toData(),
            end_time: end_time.toFixed(),
            delayed: delayed
        };
    };
    MsgCreateVestingAccount.fromProto = function(proto, isClassic) {
        if (isClassic) throw new Error("Not supported for the network");
        return new MsgCreateVestingAccount(proto.fromAddress, proto.toAddress, $kYslP.Coins.fromProto(proto.amount), proto.endTime.toNumber(), proto.delayed);
    };
    MsgCreateVestingAccount.prototype.toProto = function(isClassic) {
        if (isClassic) throw new Error("Not supported for the network");
        var _a = this, from_address = _a.from_address, to_address = _a.to_address, amount = _a.amount, end_time = _a.end_time, delayed = _a.delayed;
        return $5hbbY.MsgCreateVestingAccount.fromPartial({
            fromAddress: from_address,
            toAddress: to_address,
            amount: amount.toProto(),
            endTime: $bda05a3ff3bc9ad1$var$long_1.default.fromNumber(end_time),
            delayed: delayed
        });
    };
    MsgCreateVestingAccount.prototype.packAny = function(isClassic) {
        if (isClassic) throw new Error("Not supported for the network");
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmos.vesting.v1beta1.MsgCreateVestingAccount",
            value: $5hbbY.MsgCreateVestingAccount.encode(this.toProto(isClassic)).finish()
        });
    };
    MsgCreateVestingAccount.unpackAny = function(msgAny, isClassic) {
        if (isClassic) throw new Error("Not supported for the network");
        return MsgCreateVestingAccount.fromProto($5hbbY.MsgCreateVestingAccount.decode(msgAny.value), isClassic);
    };
    return MsgCreateVestingAccount;
}($26Eqx.JSONSerializable);
module.exports.MsgCreateVestingAccount = $bda05a3ff3bc9ad1$var$MsgCreateVestingAccount;

});

parcelRegister("1ncEP", function(module, exports) {
"use strict";
var $1001c1eeae64f8d9$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgDonateAllVestingTokens = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $5hbbY = parcelRequire("5hbbY");
/**
 * DonateAllVestingTokens defines a method that enables donating all vesting
 */ var $1001c1eeae64f8d9$var$MsgDonateAllVestingTokens = /** @class */ function(_super) {
    $1001c1eeae64f8d9$var$__extends(MsgDonateAllVestingTokens, _super);
    /**
     * @param from_address donor's address
     */ function MsgDonateAllVestingTokens(from_address) {
        var _this = _super.call(this) || this;
        _this.from_address = from_address;
        return _this;
    }
    MsgDonateAllVestingTokens.fromAmino = function(data, isClassic) {
        if (isClassic) throw new Error("Not supported for the network");
        return new MsgDonateAllVestingTokens(data.value.from_address);
    };
    MsgDonateAllVestingTokens.prototype.toAmino = function(isClassic) {
        if (isClassic) throw new Error("Not supported for the network");
        return {
            type: "cosmos-sdk/MsgDonateAllVestingTokens",
            value: {
                from_address: this.from_address
            }
        };
    };
    MsgDonateAllVestingTokens.fromData = function(data, isClassic) {
        if (isClassic) throw new Error("Not supported for the network");
        return new MsgDonateAllVestingTokens(data.from_address);
    };
    MsgDonateAllVestingTokens.prototype.toData = function(isClassic) {
        if (isClassic) throw new Error("Not supported for the network");
        return {
            "@type": "/cosmos.vesting.v1beta1.MsgDonateAllVestingTokens",
            from_address: this.from_address
        };
    };
    MsgDonateAllVestingTokens.fromProto = function(proto, isClassic) {
        if (isClassic) throw new Error("Not supported for the network");
        return new MsgDonateAllVestingTokens(proto.fromAddress);
    };
    MsgDonateAllVestingTokens.prototype.toProto = function(isClassic) {
        if (isClassic) throw new Error("Not supported for the network");
        return $5hbbY.MsgDonateAllVestingTokens.fromPartial({
            fromAddress: this.from_address
        });
    };
    MsgDonateAllVestingTokens.prototype.packAny = function(isClassic) {
        if (isClassic) throw new Error("Not supported for the network");
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmos.vesting.v1beta1.MsgDonateAllVestingTokens",
            value: $5hbbY.MsgDonateAllVestingTokens.encode(this.toProto(isClassic)).finish()
        });
    };
    MsgDonateAllVestingTokens.unpackAny = function(msgAny, isClassic) {
        if (isClassic) throw new Error("Not supported for the network");
        return MsgDonateAllVestingTokens.fromProto($5hbbY.MsgDonateAllVestingTokens.decode(msgAny.value), isClassic);
    };
    return MsgDonateAllVestingTokens;
}($26Eqx.JSONSerializable);
module.exports.MsgDonateAllVestingTokens = $1001c1eeae64f8d9$var$MsgDonateAllVestingTokens;

});


parcelRegister("5W049", function(module, exports) {
"use strict";
var $45226b9d2bdfc3ca$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $45226b9d2bdfc3ca$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $45226b9d2bdfc3ca$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$45226b9d2bdfc3ca$var$__exportStar((parcelRequire("4mhUr")), module.exports);

$45226b9d2bdfc3ca$var$__exportStar((parcelRequire("25WEY")), module.exports);

$45226b9d2bdfc3ca$var$__exportStar((parcelRequire("6N9Mg")), module.exports);

$45226b9d2bdfc3ca$var$__exportStar((parcelRequire("w8Dxr")), module.exports);

$45226b9d2bdfc3ca$var$__exportStar((parcelRequire("4iRNT")), module.exports);

$45226b9d2bdfc3ca$var$__exportStar((parcelRequire("4QLJR")), module.exports);

$45226b9d2bdfc3ca$var$__exportStar((parcelRequire("kqVZy")), module.exports);

});
parcelRegister("4mhUr", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $32c71be6d2bcd9cc$require$Buffer = $gzLuY.Buffer;
"use strict";
var $32c71be6d2bcd9cc$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgStoreCode = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $lCmWj = parcelRequire("lCmWj");

var $5SZLi = parcelRequire("5SZLi");
var $32c71be6d2bcd9cc$var$MsgStoreCode = /** @class */ function(_super) {
    $32c71be6d2bcd9cc$var$__extends(MsgStoreCode, _super);
    /**
     * @param sender code creator
     * @param wasm_byte_code base64-encoded bytecode contents
     * @param instantiate_permission  InstantiatePermission access control to apply on contract creation, optional. v2 supported only
     */ function MsgStoreCode(sender, wasm_byte_code, instantiate_permission) {
        var _this = _super.call(this) || this;
        _this.sender = sender;
        _this.wasm_byte_code = wasm_byte_code;
        _this.instantiate_permission = instantiate_permission;
        return _this;
    }
    MsgStoreCode.fromAmino = function(data, _) {
        var _a = data.value, sender = _a.sender, wasm_byte_code = _a.wasm_byte_code, instantiate_permission = _a.instantiate_permission;
        return new MsgStoreCode(sender, wasm_byte_code, instantiate_permission ? $5SZLi.AccessConfig.fromAmino(instantiate_permission) : undefined);
    };
    MsgStoreCode.prototype.toAmino = function(_) {
        var _a = this, sender = _a.sender, wasm_byte_code = _a.wasm_byte_code, instantiate_permission = _a.instantiate_permission;
        return {
            type: "wasm/MsgStoreCode",
            value: {
                sender: sender,
                wasm_byte_code: wasm_byte_code,
                instantiate_permission: instantiate_permission === null || instantiate_permission === void 0 ? void 0 : instantiate_permission.toAmino()
            }
        };
    };
    MsgStoreCode.fromProto = function(proto, _) {
        var p = proto;
        return new MsgStoreCode(p.sender, $32c71be6d2bcd9cc$require$Buffer.from(p.wasmByteCode).toString("base64"), p.instantiatePermission ? $5SZLi.AccessConfig.fromProto(p.instantiatePermission) : undefined);
    };
    MsgStoreCode.prototype.toProto = function(_) {
        var _a = this, sender = _a.sender, wasm_byte_code = _a.wasm_byte_code, instantiate_permission = _a.instantiate_permission;
        return $lCmWj.MsgStoreCode.fromPartial({
            sender: sender,
            wasmByteCode: $32c71be6d2bcd9cc$require$Buffer.from(wasm_byte_code, "base64"),
            instantiatePermission: instantiate_permission === null || instantiate_permission === void 0 ? void 0 : instantiate_permission.toProto()
        });
    };
    MsgStoreCode.prototype.packAny = function(isClassic) {
        var any = $c5FxR.Any.fromPartial({
            typeUrl: "/cosmwasm.wasm.v1.MsgStoreCode",
            value: $lCmWj.MsgStoreCode.encode(this.toProto(isClassic)).finish()
        });
        return any;
    };
    MsgStoreCode.unpackAny = function(msgAny, isClassic) {
        return MsgStoreCode.fromProto($lCmWj.MsgStoreCode.decode(msgAny.value), isClassic);
    };
    MsgStoreCode.fromData = function(data, _) {
        var _a = data, sender = _a.sender, wasm_byte_code = _a.wasm_byte_code, instantiate_permission = _a.instantiate_permission;
        return new MsgStoreCode(sender, wasm_byte_code, instantiate_permission ? $5SZLi.AccessConfig.fromData(instantiate_permission) : undefined);
    };
    MsgStoreCode.prototype.toData = function(_) {
        var _a = this, sender = _a.sender, wasm_byte_code = _a.wasm_byte_code, instantiate_permission = _a.instantiate_permission;
        return {
            "@type": "/cosmwasm.wasm.v1.MsgStoreCode",
            sender: sender,
            wasm_byte_code: wasm_byte_code,
            instantiate_permission: instantiate_permission === null || instantiate_permission === void 0 ? void 0 : instantiate_permission.toData()
        };
    };
    return MsgStoreCode;
}($26Eqx.JSONSerializable);
module.exports.MsgStoreCode = $32c71be6d2bcd9cc$var$MsgStoreCode;

});
parcelRegister("lCmWj", function(module, exports) {
"use strict";
var $fbcef0deec16be39$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GrpcWebImpl = module.exports.MsgClearAdminDesc = module.exports.MsgUpdateAdminDesc = module.exports.MsgMigrateContractDesc = module.exports.MsgExecuteContractDesc = module.exports.MsgInstantiateContractDesc = module.exports.MsgStoreCodeDesc = module.exports.MsgDesc = module.exports.MsgClientImpl = module.exports.MsgClearAdminResponse = module.exports.MsgClearAdmin = module.exports.MsgUpdateAdminResponse = module.exports.MsgUpdateAdmin = module.exports.MsgMigrateContractResponse = module.exports.MsgMigrateContract = module.exports.MsgExecuteContractResponse = module.exports.MsgExecuteContract = module.exports.MsgInstantiateContractResponse = module.exports.MsgInstantiateContract = module.exports.MsgStoreCodeResponse = module.exports.MsgStoreCode = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $fbcef0deec16be39$var$long_1 = $fbcef0deec16be39$var$__importDefault((parcelRequire("9A55m")));

var $jXVni = parcelRequire("jXVni");

const $fbcef0deec16be39$var$minimal_1 = $fbcef0deec16be39$var$__importDefault((parcelRequire("i2pIU")));

var $odsVG = parcelRequire("odsVG");

var $1pqjL = parcelRequire("1pqjL");

var $lPVUQ = parcelRequire("lPVUQ");
module.exports.protobufPackage = "cosmwasm.wasm.v1";
const $fbcef0deec16be39$var$baseMsgStoreCode = {
    sender: ""
};
module.exports.MsgStoreCode = {
    encode (message, writer = $fbcef0deec16be39$var$minimal_1.default.Writer.create()) {
        if (message.sender !== "") writer.uint32(10).string(message.sender);
        if (message.wasmByteCode.length !== 0) writer.uint32(18).bytes(message.wasmByteCode);
        if (message.instantiatePermission !== undefined) $odsVG.AccessConfig.encode(message.instantiatePermission, writer.uint32(42).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fbcef0deec16be39$var$minimal_1.default.Reader ? input : new $fbcef0deec16be39$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $fbcef0deec16be39$var$baseMsgStoreCode);
        message.wasmByteCode = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.wasmByteCode = reader.bytes();
                    break;
                case 5:
                    message.instantiatePermission = $odsVG.AccessConfig.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $fbcef0deec16be39$var$baseMsgStoreCode);
        message.wasmByteCode = new Uint8Array();
        if (object.sender !== undefined && object.sender !== null) message.sender = String(object.sender);
        else message.sender = "";
        if (object.wasmByteCode !== undefined && object.wasmByteCode !== null) message.wasmByteCode = $fbcef0deec16be39$var$bytesFromBase64(object.wasmByteCode);
        if (object.instantiatePermission !== undefined && object.instantiatePermission !== null) message.instantiatePermission = $odsVG.AccessConfig.fromJSON(object.instantiatePermission);
        else message.instantiatePermission = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.wasmByteCode !== undefined && (obj.wasmByteCode = $fbcef0deec16be39$var$base64FromBytes(message.wasmByteCode !== undefined ? message.wasmByteCode : new Uint8Array()));
        message.instantiatePermission !== undefined && (obj.instantiatePermission = message.instantiatePermission ? $odsVG.AccessConfig.toJSON(message.instantiatePermission) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $fbcef0deec16be39$var$baseMsgStoreCode);
        if (object.sender !== undefined && object.sender !== null) message.sender = object.sender;
        else message.sender = "";
        if (object.wasmByteCode !== undefined && object.wasmByteCode !== null) message.wasmByteCode = object.wasmByteCode;
        else message.wasmByteCode = new Uint8Array();
        if (object.instantiatePermission !== undefined && object.instantiatePermission !== null) message.instantiatePermission = $odsVG.AccessConfig.fromPartial(object.instantiatePermission);
        else message.instantiatePermission = undefined;
        return message;
    }
};
const $fbcef0deec16be39$var$baseMsgStoreCodeResponse = {
    codeId: $fbcef0deec16be39$var$long_1.default.UZERO
};
module.exports.MsgStoreCodeResponse = {
    encode (message, writer = $fbcef0deec16be39$var$minimal_1.default.Writer.create()) {
        if (!message.codeId.isZero()) writer.uint32(8).uint64(message.codeId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fbcef0deec16be39$var$minimal_1.default.Reader ? input : new $fbcef0deec16be39$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $fbcef0deec16be39$var$baseMsgStoreCodeResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.codeId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $fbcef0deec16be39$var$baseMsgStoreCodeResponse);
        if (object.codeId !== undefined && object.codeId !== null) message.codeId = $fbcef0deec16be39$var$long_1.default.fromString(object.codeId);
        else message.codeId = $fbcef0deec16be39$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.codeId !== undefined && (obj.codeId = (message.codeId || $fbcef0deec16be39$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $fbcef0deec16be39$var$baseMsgStoreCodeResponse);
        if (object.codeId !== undefined && object.codeId !== null) message.codeId = object.codeId;
        else message.codeId = $fbcef0deec16be39$var$long_1.default.UZERO;
        return message;
    }
};
const $fbcef0deec16be39$var$baseMsgInstantiateContract = {
    sender: "",
    admin: "",
    codeId: $fbcef0deec16be39$var$long_1.default.UZERO,
    label: ""
};
module.exports.MsgInstantiateContract = {
    encode (message, writer = $fbcef0deec16be39$var$minimal_1.default.Writer.create()) {
        if (message.sender !== "") writer.uint32(10).string(message.sender);
        if (message.admin !== "") writer.uint32(18).string(message.admin);
        if (!message.codeId.isZero()) writer.uint32(24).uint64(message.codeId);
        if (message.label !== "") writer.uint32(34).string(message.label);
        if (message.msg.length !== 0) writer.uint32(42).bytes(message.msg);
        for (const v of message.funds)$lPVUQ.Coin.encode(v, writer.uint32(50).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fbcef0deec16be39$var$minimal_1.default.Reader ? input : new $fbcef0deec16be39$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $fbcef0deec16be39$var$baseMsgInstantiateContract);
        message.funds = [];
        message.msg = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.admin = reader.string();
                    break;
                case 3:
                    message.codeId = reader.uint64();
                    break;
                case 4:
                    message.label = reader.string();
                    break;
                case 5:
                    message.msg = reader.bytes();
                    break;
                case 6:
                    message.funds.push($lPVUQ.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $fbcef0deec16be39$var$baseMsgInstantiateContract);
        message.funds = [];
        message.msg = new Uint8Array();
        if (object.sender !== undefined && object.sender !== null) message.sender = String(object.sender);
        else message.sender = "";
        if (object.admin !== undefined && object.admin !== null) message.admin = String(object.admin);
        else message.admin = "";
        if (object.codeId !== undefined && object.codeId !== null) message.codeId = $fbcef0deec16be39$var$long_1.default.fromString(object.codeId);
        else message.codeId = $fbcef0deec16be39$var$long_1.default.UZERO;
        if (object.label !== undefined && object.label !== null) message.label = String(object.label);
        else message.label = "";
        if (object.msg !== undefined && object.msg !== null) message.msg = $fbcef0deec16be39$var$bytesFromBase64(object.msg);
        if (object.funds !== undefined && object.funds !== null) for (const e of object.funds)message.funds.push($lPVUQ.Coin.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.admin !== undefined && (obj.admin = message.admin);
        message.codeId !== undefined && (obj.codeId = (message.codeId || $fbcef0deec16be39$var$long_1.default.UZERO).toString());
        message.label !== undefined && (obj.label = message.label);
        message.msg !== undefined && (obj.msg = $fbcef0deec16be39$var$base64FromBytes(message.msg !== undefined ? message.msg : new Uint8Array()));
        if (message.funds) obj.funds = message.funds.map((e)=>e ? $lPVUQ.Coin.toJSON(e) : undefined);
        else obj.funds = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $fbcef0deec16be39$var$baseMsgInstantiateContract);
        message.funds = [];
        if (object.sender !== undefined && object.sender !== null) message.sender = object.sender;
        else message.sender = "";
        if (object.admin !== undefined && object.admin !== null) message.admin = object.admin;
        else message.admin = "";
        if (object.codeId !== undefined && object.codeId !== null) message.codeId = object.codeId;
        else message.codeId = $fbcef0deec16be39$var$long_1.default.UZERO;
        if (object.label !== undefined && object.label !== null) message.label = object.label;
        else message.label = "";
        if (object.msg !== undefined && object.msg !== null) message.msg = object.msg;
        else message.msg = new Uint8Array();
        if (object.funds !== undefined && object.funds !== null) for (const e of object.funds)message.funds.push($lPVUQ.Coin.fromPartial(e));
        return message;
    }
};
const $fbcef0deec16be39$var$baseMsgInstantiateContractResponse = {
    address: ""
};
module.exports.MsgInstantiateContractResponse = {
    encode (message, writer = $fbcef0deec16be39$var$minimal_1.default.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.data.length !== 0) writer.uint32(18).bytes(message.data);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fbcef0deec16be39$var$minimal_1.default.Reader ? input : new $fbcef0deec16be39$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $fbcef0deec16be39$var$baseMsgInstantiateContractResponse);
        message.data = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $fbcef0deec16be39$var$baseMsgInstantiateContractResponse);
        message.data = new Uint8Array();
        if (object.address !== undefined && object.address !== null) message.address = String(object.address);
        else message.address = "";
        if (object.data !== undefined && object.data !== null) message.data = $fbcef0deec16be39$var$bytesFromBase64(object.data);
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.data !== undefined && (obj.data = $fbcef0deec16be39$var$base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $fbcef0deec16be39$var$baseMsgInstantiateContractResponse);
        if (object.address !== undefined && object.address !== null) message.address = object.address;
        else message.address = "";
        if (object.data !== undefined && object.data !== null) message.data = object.data;
        else message.data = new Uint8Array();
        return message;
    }
};
const $fbcef0deec16be39$var$baseMsgExecuteContract = {
    sender: "",
    contract: ""
};
module.exports.MsgExecuteContract = {
    encode (message, writer = $fbcef0deec16be39$var$minimal_1.default.Writer.create()) {
        if (message.sender !== "") writer.uint32(10).string(message.sender);
        if (message.contract !== "") writer.uint32(18).string(message.contract);
        if (message.msg.length !== 0) writer.uint32(26).bytes(message.msg);
        for (const v of message.funds)$lPVUQ.Coin.encode(v, writer.uint32(42).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fbcef0deec16be39$var$minimal_1.default.Reader ? input : new $fbcef0deec16be39$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $fbcef0deec16be39$var$baseMsgExecuteContract);
        message.funds = [];
        message.msg = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.contract = reader.string();
                    break;
                case 3:
                    message.msg = reader.bytes();
                    break;
                case 5:
                    message.funds.push($lPVUQ.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $fbcef0deec16be39$var$baseMsgExecuteContract);
        message.funds = [];
        message.msg = new Uint8Array();
        if (object.sender !== undefined && object.sender !== null) message.sender = String(object.sender);
        else message.sender = "";
        if (object.contract !== undefined && object.contract !== null) message.contract = String(object.contract);
        else message.contract = "";
        if (object.msg !== undefined && object.msg !== null) message.msg = $fbcef0deec16be39$var$bytesFromBase64(object.msg);
        if (object.funds !== undefined && object.funds !== null) for (const e of object.funds)message.funds.push($lPVUQ.Coin.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.contract !== undefined && (obj.contract = message.contract);
        message.msg !== undefined && (obj.msg = $fbcef0deec16be39$var$base64FromBytes(message.msg !== undefined ? message.msg : new Uint8Array()));
        if (message.funds) obj.funds = message.funds.map((e)=>e ? $lPVUQ.Coin.toJSON(e) : undefined);
        else obj.funds = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $fbcef0deec16be39$var$baseMsgExecuteContract);
        message.funds = [];
        if (object.sender !== undefined && object.sender !== null) message.sender = object.sender;
        else message.sender = "";
        if (object.contract !== undefined && object.contract !== null) message.contract = object.contract;
        else message.contract = "";
        if (object.msg !== undefined && object.msg !== null) message.msg = object.msg;
        else message.msg = new Uint8Array();
        if (object.funds !== undefined && object.funds !== null) for (const e of object.funds)message.funds.push($lPVUQ.Coin.fromPartial(e));
        return message;
    }
};
const $fbcef0deec16be39$var$baseMsgExecuteContractResponse = {};
module.exports.MsgExecuteContractResponse = {
    encode (message, writer = $fbcef0deec16be39$var$minimal_1.default.Writer.create()) {
        if (message.data.length !== 0) writer.uint32(10).bytes(message.data);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fbcef0deec16be39$var$minimal_1.default.Reader ? input : new $fbcef0deec16be39$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $fbcef0deec16be39$var$baseMsgExecuteContractResponse);
        message.data = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $fbcef0deec16be39$var$baseMsgExecuteContractResponse);
        message.data = new Uint8Array();
        if (object.data !== undefined && object.data !== null) message.data = $fbcef0deec16be39$var$bytesFromBase64(object.data);
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.data !== undefined && (obj.data = $fbcef0deec16be39$var$base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $fbcef0deec16be39$var$baseMsgExecuteContractResponse);
        if (object.data !== undefined && object.data !== null) message.data = object.data;
        else message.data = new Uint8Array();
        return message;
    }
};
const $fbcef0deec16be39$var$baseMsgMigrateContract = {
    sender: "",
    contract: "",
    codeId: $fbcef0deec16be39$var$long_1.default.UZERO
};
module.exports.MsgMigrateContract = {
    encode (message, writer = $fbcef0deec16be39$var$minimal_1.default.Writer.create()) {
        if (message.sender !== "") writer.uint32(10).string(message.sender);
        if (message.contract !== "") writer.uint32(18).string(message.contract);
        if (!message.codeId.isZero()) writer.uint32(24).uint64(message.codeId);
        if (message.msg.length !== 0) writer.uint32(34).bytes(message.msg);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fbcef0deec16be39$var$minimal_1.default.Reader ? input : new $fbcef0deec16be39$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $fbcef0deec16be39$var$baseMsgMigrateContract);
        message.msg = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.contract = reader.string();
                    break;
                case 3:
                    message.codeId = reader.uint64();
                    break;
                case 4:
                    message.msg = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $fbcef0deec16be39$var$baseMsgMigrateContract);
        message.msg = new Uint8Array();
        if (object.sender !== undefined && object.sender !== null) message.sender = String(object.sender);
        else message.sender = "";
        if (object.contract !== undefined && object.contract !== null) message.contract = String(object.contract);
        else message.contract = "";
        if (object.codeId !== undefined && object.codeId !== null) message.codeId = $fbcef0deec16be39$var$long_1.default.fromString(object.codeId);
        else message.codeId = $fbcef0deec16be39$var$long_1.default.UZERO;
        if (object.msg !== undefined && object.msg !== null) message.msg = $fbcef0deec16be39$var$bytesFromBase64(object.msg);
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.contract !== undefined && (obj.contract = message.contract);
        message.codeId !== undefined && (obj.codeId = (message.codeId || $fbcef0deec16be39$var$long_1.default.UZERO).toString());
        message.msg !== undefined && (obj.msg = $fbcef0deec16be39$var$base64FromBytes(message.msg !== undefined ? message.msg : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $fbcef0deec16be39$var$baseMsgMigrateContract);
        if (object.sender !== undefined && object.sender !== null) message.sender = object.sender;
        else message.sender = "";
        if (object.contract !== undefined && object.contract !== null) message.contract = object.contract;
        else message.contract = "";
        if (object.codeId !== undefined && object.codeId !== null) message.codeId = object.codeId;
        else message.codeId = $fbcef0deec16be39$var$long_1.default.UZERO;
        if (object.msg !== undefined && object.msg !== null) message.msg = object.msg;
        else message.msg = new Uint8Array();
        return message;
    }
};
const $fbcef0deec16be39$var$baseMsgMigrateContractResponse = {};
module.exports.MsgMigrateContractResponse = {
    encode (message, writer = $fbcef0deec16be39$var$minimal_1.default.Writer.create()) {
        if (message.data.length !== 0) writer.uint32(10).bytes(message.data);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fbcef0deec16be39$var$minimal_1.default.Reader ? input : new $fbcef0deec16be39$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $fbcef0deec16be39$var$baseMsgMigrateContractResponse);
        message.data = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $fbcef0deec16be39$var$baseMsgMigrateContractResponse);
        message.data = new Uint8Array();
        if (object.data !== undefined && object.data !== null) message.data = $fbcef0deec16be39$var$bytesFromBase64(object.data);
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.data !== undefined && (obj.data = $fbcef0deec16be39$var$base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $fbcef0deec16be39$var$baseMsgMigrateContractResponse);
        if (object.data !== undefined && object.data !== null) message.data = object.data;
        else message.data = new Uint8Array();
        return message;
    }
};
const $fbcef0deec16be39$var$baseMsgUpdateAdmin = {
    sender: "",
    newAdmin: "",
    contract: ""
};
module.exports.MsgUpdateAdmin = {
    encode (message, writer = $fbcef0deec16be39$var$minimal_1.default.Writer.create()) {
        if (message.sender !== "") writer.uint32(10).string(message.sender);
        if (message.newAdmin !== "") writer.uint32(18).string(message.newAdmin);
        if (message.contract !== "") writer.uint32(26).string(message.contract);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fbcef0deec16be39$var$minimal_1.default.Reader ? input : new $fbcef0deec16be39$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $fbcef0deec16be39$var$baseMsgUpdateAdmin);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.newAdmin = reader.string();
                    break;
                case 3:
                    message.contract = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $fbcef0deec16be39$var$baseMsgUpdateAdmin);
        if (object.sender !== undefined && object.sender !== null) message.sender = String(object.sender);
        else message.sender = "";
        if (object.newAdmin !== undefined && object.newAdmin !== null) message.newAdmin = String(object.newAdmin);
        else message.newAdmin = "";
        if (object.contract !== undefined && object.contract !== null) message.contract = String(object.contract);
        else message.contract = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.newAdmin !== undefined && (obj.newAdmin = message.newAdmin);
        message.contract !== undefined && (obj.contract = message.contract);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $fbcef0deec16be39$var$baseMsgUpdateAdmin);
        if (object.sender !== undefined && object.sender !== null) message.sender = object.sender;
        else message.sender = "";
        if (object.newAdmin !== undefined && object.newAdmin !== null) message.newAdmin = object.newAdmin;
        else message.newAdmin = "";
        if (object.contract !== undefined && object.contract !== null) message.contract = object.contract;
        else message.contract = "";
        return message;
    }
};
const $fbcef0deec16be39$var$baseMsgUpdateAdminResponse = {};
module.exports.MsgUpdateAdminResponse = {
    encode (_, writer = $fbcef0deec16be39$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fbcef0deec16be39$var$minimal_1.default.Reader ? input : new $fbcef0deec16be39$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $fbcef0deec16be39$var$baseMsgUpdateAdminResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $fbcef0deec16be39$var$baseMsgUpdateAdminResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $fbcef0deec16be39$var$baseMsgUpdateAdminResponse);
        return message;
    }
};
const $fbcef0deec16be39$var$baseMsgClearAdmin = {
    sender: "",
    contract: ""
};
module.exports.MsgClearAdmin = {
    encode (message, writer = $fbcef0deec16be39$var$minimal_1.default.Writer.create()) {
        if (message.sender !== "") writer.uint32(10).string(message.sender);
        if (message.contract !== "") writer.uint32(26).string(message.contract);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fbcef0deec16be39$var$minimal_1.default.Reader ? input : new $fbcef0deec16be39$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $fbcef0deec16be39$var$baseMsgClearAdmin);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sender = reader.string();
                    break;
                case 3:
                    message.contract = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $fbcef0deec16be39$var$baseMsgClearAdmin);
        if (object.sender !== undefined && object.sender !== null) message.sender = String(object.sender);
        else message.sender = "";
        if (object.contract !== undefined && object.contract !== null) message.contract = String(object.contract);
        else message.contract = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.contract !== undefined && (obj.contract = message.contract);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $fbcef0deec16be39$var$baseMsgClearAdmin);
        if (object.sender !== undefined && object.sender !== null) message.sender = object.sender;
        else message.sender = "";
        if (object.contract !== undefined && object.contract !== null) message.contract = object.contract;
        else message.contract = "";
        return message;
    }
};
const $fbcef0deec16be39$var$baseMsgClearAdminResponse = {};
module.exports.MsgClearAdminResponse = {
    encode (_, writer = $fbcef0deec16be39$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fbcef0deec16be39$var$minimal_1.default.Reader ? input : new $fbcef0deec16be39$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $fbcef0deec16be39$var$baseMsgClearAdminResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $fbcef0deec16be39$var$baseMsgClearAdminResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $fbcef0deec16be39$var$baseMsgClearAdminResponse);
        return message;
    }
};
class $fbcef0deec16be39$var$MsgClientImpl {
    StoreCode(request, metadata) {
        return this.rpc.unary(module.exports.MsgStoreCodeDesc, module.exports.MsgStoreCode.fromPartial(request), metadata);
    }
    InstantiateContract(request, metadata) {
        return this.rpc.unary(module.exports.MsgInstantiateContractDesc, module.exports.MsgInstantiateContract.fromPartial(request), metadata);
    }
    ExecuteContract(request, metadata) {
        return this.rpc.unary(module.exports.MsgExecuteContractDesc, module.exports.MsgExecuteContract.fromPartial(request), metadata);
    }
    MigrateContract(request, metadata) {
        return this.rpc.unary(module.exports.MsgMigrateContractDesc, module.exports.MsgMigrateContract.fromPartial(request), metadata);
    }
    UpdateAdmin(request, metadata) {
        return this.rpc.unary(module.exports.MsgUpdateAdminDesc, module.exports.MsgUpdateAdmin.fromPartial(request), metadata);
    }
    ClearAdmin(request, metadata) {
        return this.rpc.unary(module.exports.MsgClearAdminDesc, module.exports.MsgClearAdmin.fromPartial(request), metadata);
    }
    constructor(rpc){
        this.rpc = rpc;
        this.StoreCode = this.StoreCode.bind(this);
        this.InstantiateContract = this.InstantiateContract.bind(this);
        this.ExecuteContract = this.ExecuteContract.bind(this);
        this.MigrateContract = this.MigrateContract.bind(this);
        this.UpdateAdmin = this.UpdateAdmin.bind(this);
        this.ClearAdmin = this.ClearAdmin.bind(this);
    }
}
module.exports.MsgClientImpl = $fbcef0deec16be39$var$MsgClientImpl;
module.exports.MsgDesc = {
    serviceName: "cosmwasm.wasm.v1.Msg"
};
module.exports.MsgStoreCodeDesc = {
    methodName: "StoreCode",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgStoreCode.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgStoreCodeResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.MsgInstantiateContractDesc = {
    methodName: "InstantiateContract",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgInstantiateContract.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgInstantiateContractResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.MsgExecuteContractDesc = {
    methodName: "ExecuteContract",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgExecuteContract.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgExecuteContractResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.MsgMigrateContractDesc = {
    methodName: "MigrateContract",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgMigrateContract.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgMigrateContractResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.MsgUpdateAdminDesc = {
    methodName: "UpdateAdmin",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgUpdateAdmin.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgUpdateAdminResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.MsgClearAdminDesc = {
    methodName: "ClearAdmin",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgClearAdmin.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgClearAdminResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
class $fbcef0deec16be39$var$GrpcWebImpl {
    unary(methodDesc, _request, metadata) {
        var _a;
        const request = Object.assign(Object.assign({}, _request), methodDesc.requestType);
        const maybeCombinedMetadata = metadata && this.options.metadata ? new $1pqjL.BrowserHeaders(Object.assign(Object.assign({}, (_a = this.options) === null || _a === void 0 ? void 0 : _a.metadata.headersMap), metadata === null || metadata === void 0 ? void 0 : metadata.headersMap)) : metadata || this.options.metadata;
        return new Promise((resolve, reject)=>{
            $jXVni.grpc.unary(methodDesc, {
                request: request,
                host: this.host,
                metadata: maybeCombinedMetadata,
                transport: this.options.transport,
                debug: this.options.debug,
                onEnd: function(response) {
                    if (response.status === $jXVni.grpc.Code.OK) resolve(response.message);
                    else {
                        const err = new Error(response.statusMessage);
                        err.code = response.status;
                        err.metadata = response.trailers;
                        reject(err);
                    }
                }
            });
        });
    }
    constructor(host, options){
        this.host = host;
        this.options = options;
    }
}
module.exports.GrpcWebImpl = $fbcef0deec16be39$var$GrpcWebImpl;
var $fbcef0deec16be39$var$globalThis = (()=>{
    if (typeof $fbcef0deec16be39$var$globalThis !== "undefined") return $fbcef0deec16be39$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $fbcef0deec16be39$var$atob = $fbcef0deec16be39$var$globalThis.atob || ((b64)=>$fbcef0deec16be39$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $fbcef0deec16be39$var$bytesFromBase64(b64) {
    const bin = $fbcef0deec16be39$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $fbcef0deec16be39$var$btoa = $fbcef0deec16be39$var$globalThis.btoa || ((bin)=>$fbcef0deec16be39$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $fbcef0deec16be39$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $fbcef0deec16be39$var$btoa(bin.join(""));
}
if ($fbcef0deec16be39$var$minimal_1.default.util.Long !== $fbcef0deec16be39$var$long_1.default) {
    $fbcef0deec16be39$var$minimal_1.default.util.Long = $fbcef0deec16be39$var$long_1.default;
    $fbcef0deec16be39$var$minimal_1.default.configure();
}

});


parcelRegister("25WEY", function(module, exports) {
"use strict";
var $18698d0435a2456f$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgMigrateCode = void 0;

var $26Eqx = parcelRequire("26Eqx");
var $18698d0435a2456f$var$MsgMigrateCode = /** @class */ function(_super) {
    $18698d0435a2456f$var$__extends(MsgMigrateCode, _super);
    /**
     * @param sender code migrator address
     * @param code_id reference to the code on the blockchain
     * @param wasm_byte_code base64-encoded bytecode contents
     */ function MsgMigrateCode(sender, code_id, wasm_byte_code) {
        var _this = _super.call(this) || this;
        _this.sender = sender;
        _this.code_id = code_id;
        _this.wasm_byte_code = wasm_byte_code;
        return _this;
    }
    MsgMigrateCode.fromAmino = function(_data, _) {
        throw new Error("Not supported for the network");
    };
    MsgMigrateCode.prototype.toAmino = function(_) {
        throw new Error("Not supported for the network");
    };
    MsgMigrateCode.fromProto = function(_proto, _) {
        throw new Error("Not supported for the network");
    };
    MsgMigrateCode.prototype.toProto = function(_) {
        throw new Error("Not supported for the network");
    };
    MsgMigrateCode.prototype.packAny = function(_) {
        throw new Error("Not supported for the network");
    };
    MsgMigrateCode.unpackAny = function(_msgAny, _) {
        throw new Error("Not supported for the network");
    };
    MsgMigrateCode.fromData = function(_data, _) {
        throw new Error("Not supported for the network");
    };
    MsgMigrateCode.prototype.toData = function(_) {
        throw new Error("Not supported for the network");
    };
    return MsgMigrateCode;
}($26Eqx.JSONSerializable);
module.exports.MsgMigrateCode = $18698d0435a2456f$var$MsgMigrateCode;

});

parcelRegister("6N9Mg", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $4f1ee74410028e35$require$Buffer = $gzLuY.Buffer;
"use strict";
var $4f1ee74410028e35$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $4f1ee74410028e35$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4f1ee74410028e35$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $4f1ee74410028e35$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $4f1ee74410028e35$var$__createBinding(result, mod, k);
    }
    $4f1ee74410028e35$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgInstantiateContract = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $kYslP = parcelRequire("kYslP");

var $c5FxR = parcelRequire("c5FxR");

var $lCmWj = parcelRequire("lCmWj");

var $4f1ee74410028e35$var$Long = $4f1ee74410028e35$var$__importStar((parcelRequire("9A55m")));
var $4f1ee74410028e35$var$MsgInstantiateContract = /** @class */ function(_super) {
    $4f1ee74410028e35$var$__extends(MsgInstantiateContract, _super);
    /**
     * @param sender is a sender address
     * @param admin is an optional contract admin address who can migrate the contract, put empty string to disable migration
     * @param code_id is the reference to the stored WASM code
     * @param init_msg json encoded message to be passed to the contract on instantiation
     * @param init_coins are transferred to the contract on execution
     * @param label label for the contract. v2 supported only
     */ function MsgInstantiateContract(sender, admin, code_id, init_msg, init_coins, label) {
        if (init_coins === void 0) init_coins = {};
        var _this = _super.call(this) || this;
        _this.sender = sender;
        _this.admin = admin;
        _this.code_id = code_id;
        _this.init_msg = init_msg;
        _this.label = label;
        _this.init_coins = new $kYslP.Coins(init_coins);
        return _this;
    }
    MsgInstantiateContract.fromAmino = function(data, _) {
        var _a = data.value, sender = _a.sender, admin = _a.admin, code_id = _a.code_id, msg = _a.msg, funds = _a.funds, label = _a.label;
        return new MsgInstantiateContract(sender, admin, Number.parseInt(code_id), msg, $kYslP.Coins.fromAmino(funds), label);
    };
    MsgInstantiateContract.prototype.toAmino = function(_) {
        var _a = this, sender = _a.sender, admin = _a.admin, code_id = _a.code_id, init_msg = _a.init_msg, init_coins = _a.init_coins, label = _a.label;
        return {
            type: "wasm/MsgInstantiateContract",
            value: {
                sender: sender,
                admin: admin,
                code_id: code_id.toFixed(),
                label: label,
                msg: (0, $26Eqx.removeNull)(init_msg),
                funds: init_coins.toAmino()
            }
        };
    };
    MsgInstantiateContract.fromProto = function(proto, _) {
        var p = proto;
        return new MsgInstantiateContract(p.sender, p.admin !== "" ? p.admin : undefined, p.codeId.toNumber(), JSON.parse($4f1ee74410028e35$require$Buffer.from(p.msg).toString("utf-8")), $kYslP.Coins.fromProto(p.funds), p.label !== "" ? p.label : undefined);
    };
    MsgInstantiateContract.prototype.toProto = function(_) {
        var _a = this, sender = _a.sender, admin = _a.admin, code_id = _a.code_id, init_msg = _a.init_msg, init_coins = _a.init_coins, label = _a.label;
        return $lCmWj.MsgInstantiateContract.fromPartial({
            admin: admin,
            codeId: $4f1ee74410028e35$var$Long.fromNumber(code_id),
            funds: init_coins.toProto(),
            msg: $4f1ee74410028e35$require$Buffer.from(JSON.stringify(init_msg), "utf-8"),
            sender: sender,
            label: label
        });
    };
    MsgInstantiateContract.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmwasm.wasm.v1.MsgInstantiateContract",
            value: $lCmWj.MsgInstantiateContract.encode(this.toProto(isClassic)).finish()
        });
    };
    MsgInstantiateContract.unpackAny = function(msgAny, isClassic) {
        return MsgInstantiateContract.fromProto($lCmWj.MsgInstantiateContract.decode(msgAny.value), isClassic);
    };
    MsgInstantiateContract.fromData = function(data, _) {
        var _a = data, sender = _a.sender, admin = _a.admin, code_id = _a.code_id, label = _a.label, msg = _a.msg, funds = _a.funds;
        return new MsgInstantiateContract(sender, admin !== "" ? admin : undefined, Number.parseInt(code_id), msg, $kYslP.Coins.fromData(funds), label);
    };
    MsgInstantiateContract.prototype.toData = function(_) {
        var _a = this, sender = _a.sender, admin = _a.admin, code_id = _a.code_id, label = _a.label, init_msg = _a.init_msg, init_coins = _a.init_coins;
        return {
            "@type": "/cosmwasm.wasm.v1.MsgInstantiateContract",
            sender: sender,
            admin: admin || "",
            code_id: code_id.toFixed(),
            label: label,
            msg: (0, $26Eqx.removeNull)(init_msg),
            funds: init_coins.toData()
        };
    };
    return MsgInstantiateContract;
}($26Eqx.JSONSerializable);
module.exports.MsgInstantiateContract = $4f1ee74410028e35$var$MsgInstantiateContract;

});

parcelRegister("w8Dxr", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $0609b0586dcc34f4$require$Buffer = $gzLuY.Buffer;
"use strict";
var $0609b0586dcc34f4$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgExecuteContract = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $kYslP = parcelRequire("kYslP");

var $c5FxR = parcelRequire("c5FxR");

var $lCmWj = parcelRequire("lCmWj");
var $0609b0586dcc34f4$var$MsgExecuteContract = /** @class */ function(_super) {
    $0609b0586dcc34f4$var$__extends(MsgExecuteContract, _super);
    /**
     * @param sender contract user
     * @param contract contract address
     * @param execute_msg HandleMsg to pass as arguments for contract invocation
     * @param coins coins to be sent to contract
     */ function MsgExecuteContract(sender, contract, execute_msg, coins) {
        if (coins === void 0) coins = {};
        var _this = _super.call(this) || this;
        _this.sender = sender;
        _this.contract = contract;
        _this.execute_msg = execute_msg;
        _this.coins = new $kYslP.Coins(coins);
        return _this;
    }
    MsgExecuteContract.fromAmino = function(data, _) {
        var _a = data.value, sender = _a.sender, contract = _a.contract, msg = _a.msg, funds = _a.funds;
        return new MsgExecuteContract(sender, contract, msg, $kYslP.Coins.fromAmino(funds));
    };
    MsgExecuteContract.prototype.toAmino = function(_) {
        var _a = this, sender = _a.sender, contract = _a.contract, execute_msg = _a.execute_msg, coins = _a.coins;
        return {
            type: "wasm/MsgExecuteContract",
            value: {
                sender: sender,
                contract: contract,
                msg: (0, $26Eqx.removeNull)(execute_msg),
                funds: coins.toAmino()
            }
        };
    };
    MsgExecuteContract.fromProto = function(proto, _) {
        var p = proto;
        return new MsgExecuteContract(p.sender, p.contract, JSON.parse($0609b0586dcc34f4$require$Buffer.from(p.msg).toString("utf-8")), $kYslP.Coins.fromProto(p.funds));
    };
    MsgExecuteContract.prototype.toProto = function(_) {
        var _a = this, sender = _a.sender, contract = _a.contract, execute_msg = _a.execute_msg, coins = _a.coins;
        return $lCmWj.MsgExecuteContract.fromPartial({
            funds: coins.toProto(),
            contract: contract,
            sender: sender,
            msg: $0609b0586dcc34f4$require$Buffer.from(JSON.stringify((0, $26Eqx.removeNull)(execute_msg)), "utf-8")
        });
    };
    MsgExecuteContract.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmwasm.wasm.v1.MsgExecuteContract",
            value: $lCmWj.MsgExecuteContract.encode(this.toProto(isClassic)).finish()
        });
    };
    MsgExecuteContract.unpackAny = function(msgAny, isClassic) {
        return MsgExecuteContract.fromProto($lCmWj.MsgExecuteContract.decode(msgAny.value), isClassic);
    };
    MsgExecuteContract.fromData = function(data, _) {
        var _a = data, sender = _a.sender, contract = _a.contract, msg = _a.msg, funds = _a.funds;
        return new MsgExecuteContract(sender, contract, msg, $kYslP.Coins.fromData(funds));
    };
    MsgExecuteContract.prototype.toData = function(_) {
        var _a = this, sender = _a.sender, contract = _a.contract, execute_msg = _a.execute_msg, coins = _a.coins;
        return {
            "@type": "/cosmwasm.wasm.v1.MsgExecuteContract",
            sender: sender,
            contract: contract,
            msg: execute_msg,
            funds: coins.toData()
        };
    };
    return MsgExecuteContract;
}($26Eqx.JSONSerializable);
module.exports.MsgExecuteContract = $0609b0586dcc34f4$var$MsgExecuteContract;

});

parcelRegister("4iRNT", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $3222942c42f5e722$require$Buffer = $gzLuY.Buffer;
"use strict";
var $3222942c42f5e722$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $3222942c42f5e722$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3222942c42f5e722$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $3222942c42f5e722$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3222942c42f5e722$var$__createBinding(result, mod, k);
    }
    $3222942c42f5e722$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgMigrateContract = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $lCmWj = parcelRequire("lCmWj");

var $3222942c42f5e722$var$Long = $3222942c42f5e722$var$__importStar((parcelRequire("9A55m")));
var $3222942c42f5e722$var$MsgMigrateContract = /** @class */ function(_super) {
    $3222942c42f5e722$var$__extends(MsgMigrateContract, _super);
    /**
     * @param admin contract admin
     * @param contract contract address to be migrated from
     * @param new_code_id reference to the new code on the blockchain
     * @param migrate_msg JSON message to configure the migrate state of the contract
     */ function MsgMigrateContract(admin, contract, new_code_id, migrate_msg // json object or string
    ) {
        var _this = _super.call(this) || this;
        _this.admin = admin;
        _this.contract = contract;
        _this.new_code_id = new_code_id;
        _this.migrate_msg = migrate_msg;
        return _this;
    }
    MsgMigrateContract.fromAmino = function(data, _) {
        var _a = data.value, sender = _a.sender, contract = _a.contract, code_id = _a.code_id, msg = _a.msg;
        return new MsgMigrateContract(sender, contract, Number.parseInt(code_id), msg);
    };
    MsgMigrateContract.prototype.toAmino = function(_) {
        var _a = this, admin = _a.admin, contract = _a.contract, new_code_id = _a.new_code_id, migrate_msg = _a.migrate_msg;
        return {
            type: "wasm/MsgMigrateContract",
            value: {
                sender: admin,
                contract: contract,
                code_id: new_code_id.toFixed(),
                msg: (0, $26Eqx.removeNull)(migrate_msg)
            }
        };
    };
    MsgMigrateContract.fromProto = function(proto, _) {
        var p = proto;
        return new MsgMigrateContract(p.sender, p.contract, p.codeId.toNumber(), JSON.parse($3222942c42f5e722$require$Buffer.from(p.msg).toString("utf-8")));
    };
    MsgMigrateContract.prototype.toProto = function(_) {
        var _a = this, admin = _a.admin, contract = _a.contract, new_code_id = _a.new_code_id, migrate_msg = _a.migrate_msg;
        return $lCmWj.MsgMigrateContract.fromPartial({
            sender: admin,
            contract: contract,
            codeId: $3222942c42f5e722$var$Long.fromNumber(new_code_id),
            msg: $3222942c42f5e722$require$Buffer.from(JSON.stringify(migrate_msg), "utf-8")
        });
    };
    MsgMigrateContract.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmwasm.wasm.v1.MsgMigrateContract",
            value: $lCmWj.MsgMigrateContract.encode(this.toProto(isClassic)).finish()
        });
    };
    MsgMigrateContract.unpackAny = function(msgAny, isClassic) {
        return MsgMigrateContract.fromProto($lCmWj.MsgMigrateContract.decode(msgAny.value), isClassic);
    };
    MsgMigrateContract.fromData = function(data, _) {
        var _a = data, sender = _a.sender, contract = _a.contract, code_id = _a.code_id, msg = _a.msg;
        return new MsgMigrateContract(sender, contract, Number.parseInt(code_id), msg);
    };
    MsgMigrateContract.prototype.toData = function(_) {
        var _a = this, admin = _a.admin, contract = _a.contract, new_code_id = _a.new_code_id, migrate_msg = _a.migrate_msg;
        return {
            "@type": "/cosmwasm.wasm.v1.MsgMigrateContract",
            sender: admin,
            contract: contract,
            code_id: new_code_id.toFixed(),
            msg: (0, $26Eqx.removeNull)(migrate_msg)
        };
    };
    return MsgMigrateContract;
}($26Eqx.JSONSerializable);
module.exports.MsgMigrateContract = $3222942c42f5e722$var$MsgMigrateContract;

});

parcelRegister("4QLJR", function(module, exports) {
"use strict";
var $38810caf3646d399$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgUpdateContractAdmin = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $lCmWj = parcelRequire("lCmWj");
var $38810caf3646d399$var$MsgUpdateContractAdmin = /** @class */ function(_super) {
    $38810caf3646d399$var$__extends(MsgUpdateContractAdmin, _super);
    /**
     * @param admin contract admin
     * @param new_admin new admin
     * @param contract contract address
     */ function MsgUpdateContractAdmin(admin, new_admin, contract) {
        var _this = _super.call(this) || this;
        _this.admin = admin;
        _this.new_admin = new_admin;
        _this.contract = contract;
        return _this;
    }
    MsgUpdateContractAdmin.fromAmino = function(data, _) {
        var _a = data.value, sender = _a.sender, new_admin = _a.new_admin, contract = _a.contract;
        return new MsgUpdateContractAdmin(sender, new_admin, contract);
    };
    MsgUpdateContractAdmin.prototype.toAmino = function(_) {
        var _a = this, admin = _a.admin, new_admin = _a.new_admin, contract = _a.contract;
        return {
            type: "wasm/MsgUpdateAdmin",
            value: {
                sender: admin,
                new_admin: new_admin,
                contract: contract
            }
        };
    };
    MsgUpdateContractAdmin.fromProto = function(proto, _) {
        var p = proto;
        return new MsgUpdateContractAdmin(p.sender, p.newAdmin, p.contract);
    };
    MsgUpdateContractAdmin.prototype.toProto = function(_) {
        var _a = this, admin = _a.admin, new_admin = _a.new_admin, contract = _a.contract;
        return $lCmWj.MsgUpdateAdmin.fromPartial({
            sender: admin,
            contract: contract,
            newAdmin: new_admin
        });
    };
    MsgUpdateContractAdmin.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmwasm.wasm.v1.MsgUpdateAdmin",
            value: $lCmWj.MsgUpdateAdmin.encode(this.toProto(isClassic)).finish()
        });
    };
    MsgUpdateContractAdmin.unpackAny = function(msgAny, isClassic) {
        return MsgUpdateContractAdmin.fromProto($lCmWj.MsgUpdateAdmin.decode(msgAny.value), isClassic);
    };
    MsgUpdateContractAdmin.fromData = function(data, isClassic) {
        if (isClassic) {
            var _a = data, admin = _a.admin, new_admin = _a.new_admin, contract = _a.contract;
            return new MsgUpdateContractAdmin(admin, new_admin, contract);
        } else {
            var _b = data, sender = _b.sender, new_admin = _b.new_admin, contract = _b.contract;
            return new MsgUpdateContractAdmin(sender, new_admin, contract);
        }
    };
    MsgUpdateContractAdmin.prototype.toData = function(isClassic) {
        var _a = this, admin = _a.admin, new_admin = _a.new_admin, contract = _a.contract;
        if (isClassic) return {
            "@type": "/terra.wasm.v1beta1.MsgUpdateContractAdmin",
            admin: admin,
            new_admin: new_admin,
            contract: contract
        };
        else return {
            "@type": "/cosmwasm.wasm.v1.MsgUpdateAdmin",
            sender: admin,
            new_admin: new_admin,
            contract: contract
        };
    };
    return MsgUpdateContractAdmin;
}($26Eqx.JSONSerializable);
module.exports.MsgUpdateContractAdmin = $38810caf3646d399$var$MsgUpdateContractAdmin;

});

parcelRegister("kqVZy", function(module, exports) {
"use strict";
var $ee0338532cedae9b$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgClearContractAdmin = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $lCmWj = parcelRequire("lCmWj");
var $ee0338532cedae9b$var$MsgClearContractAdmin = /** @class */ function(_super) {
    $ee0338532cedae9b$var$__extends(MsgClearContractAdmin, _super);
    /**
     * @param admin contract admin
     * @param contract contract address
     */ function MsgClearContractAdmin(admin, contract) {
        var _this = _super.call(this) || this;
        _this.admin = admin;
        _this.contract = contract;
        return _this;
    }
    MsgClearContractAdmin.fromAmino = function(data, _) {
        var _a = data.value, sender = _a.sender, contract = _a.contract;
        return new MsgClearContractAdmin(sender, contract);
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    MsgClearContractAdmin.prototype.toAmino = function(_) {
        var _a = this, admin = _a.admin, contract = _a.contract;
        return {
            type: "wasm/MsgClearAdmin",
            value: {
                sender: admin,
                contract: contract
            }
        };
    };
    MsgClearContractAdmin.fromProto = function(data, _) {
        var _a = data, sender = _a.sender, contract = _a.contract;
        return new MsgClearContractAdmin(sender, contract);
    };
    MsgClearContractAdmin.prototype.toProto = function(_) {
        return $lCmWj.MsgClearAdmin.fromPartial({
            sender: this.admin,
            contract: this.contract
        });
    };
    MsgClearContractAdmin.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmwasm.wasm.v1.MsgClearAdmin",
            value: $lCmWj.MsgClearAdmin.encode(this.toProto(isClassic)).finish()
        });
    };
    MsgClearContractAdmin.unpackAny = function(msgAny, isClassic) {
        return MsgClearContractAdmin.fromProto($lCmWj.MsgClearAdmin.decode(msgAny.value), isClassic);
    };
    MsgClearContractAdmin.fromData = function(data, _) {
        var _a = data, sender = _a.sender, contract = _a.contract;
        return new MsgClearContractAdmin(sender, contract);
    };
    MsgClearContractAdmin.prototype.toData = function(_) {
        return {
            "@type": "/cosmwasm.wasm.v1.MsgClearAdmin",
            sender: this.admin,
            contract: this.contract
        };
    };
    return MsgClearContractAdmin;
}($26Eqx.JSONSerializable);
module.exports.MsgClearContractAdmin = $ee0338532cedae9b$var$MsgClearContractAdmin;

});


parcelRegister("jxUNi", function(module, exports) {
"use strict";
var $e3ad278033f9462b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e3ad278033f9462b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e3ad278033f9462b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$e3ad278033f9462b$var$__exportStar((parcelRequire("a8Co6")), module.exports);

$e3ad278033f9462b$var$__exportStar((parcelRequire("bH2no")), module.exports);

$e3ad278033f9462b$var$__exportStar((parcelRequire("lqRDX")), module.exports);

});
parcelRegister("a8Co6", function(module, exports) {
"use strict";
var $76186dc3dce52017$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $76186dc3dce52017$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $76186dc3dce52017$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $76186dc3dce52017$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $76186dc3dce52017$var$__createBinding(result, mod, k);
    }
    $76186dc3dce52017$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgTransfer = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $7yVzo = parcelRequire("7yVzo");

var $76186dc3dce52017$var$Long = $76186dc3dce52017$var$__importStar((parcelRequire("9A55m")));

var $c5FxR = parcelRequire("c5FxR");

var $gYi1B = parcelRequire("gYi1B");

var $cz9KI = parcelRequire("cz9KI");

var $5iXRZ = parcelRequire("5iXRZ");
/**
 * A basic message for transfer [[Coin]] via IBC.
 */ var $76186dc3dce52017$var$MsgTransfer = /** @class */ function(_super) {
    $76186dc3dce52017$var$__extends(MsgTransfer, _super);
    /**
     * @param source_port the port on which the packet will be sent
     * @param source_channel  the channel by which the packet will be sent
     * @param token the tokens to be transferred
     * @param sender the sender address
     * @param receiver the recipient address on the destination chain
     * @param timeout_height Timeout height relative to the current block height. (0 to disable)
     * @param timeout_timestamp Timeout timestamp (in nanoseconds) relative to the current block timestamp. (0 to disable)
     */ function MsgTransfer(source_port, source_channel, token, sender, receiver, timeout_height, timeout_timestamp) {
        var _this = _super.call(this) || this;
        if (!timeout_height && !timeout_timestamp) throw "both of timeout_height and timeout_timestamp are undefined";
        _this.source_port = source_port;
        _this.source_channel = source_channel;
        _this.token = token;
        _this.sender = sender;
        _this.receiver = receiver;
        _this.timeout_height = timeout_height;
        _this.timeout_timestamp = timeout_timestamp ? $5iXRZ.Numeric.parse(timeout_timestamp) : undefined;
        return _this;
    }
    MsgTransfer.fromAmino = function(data, _) {
        _;
        var _a = data.value, source_port = _a.source_port, source_channel = _a.source_channel, token = _a.token, sender = _a.sender, receiver = _a.receiver, timeout_height = _a.timeout_height, timeout_timestamp = _a.timeout_timestamp;
        if (!timeout_height && !timeout_timestamp) throw "both of timeout_height and timeout_timestamp are undefined";
        return new MsgTransfer(source_port, source_channel, token ? $7yVzo.Coin.fromAmino(token) : undefined, sender, receiver, timeout_height ? $cz9KI.Height.fromAmino(timeout_height) : undefined, timeout_timestamp ? $5iXRZ.Numeric.parse(timeout_timestamp) : undefined);
    };
    MsgTransfer.prototype.toAmino = function(_) {
        _;
        var _a = this, source_port = _a.source_port, source_channel = _a.source_channel, token = _a.token, sender = _a.sender, receiver = _a.receiver, timeout_height = _a.timeout_height, timeout_timestamp = _a.timeout_timestamp;
        return {
            type: "cosmos-sdk/MsgTransfer",
            value: {
                source_port: source_port,
                source_channel: source_channel,
                token: token ? token.toAmino() : undefined,
                sender: sender,
                receiver: receiver,
                timeout_height: (timeout_height === null || timeout_height === void 0 ? void 0 : timeout_height.toAmino()) || {},
                timeout_timestamp: (timeout_timestamp === null || timeout_timestamp === void 0 ? void 0 : timeout_timestamp.toFixed()) || undefined
            }
        };
    };
    MsgTransfer.fromData = function(data, _) {
        _;
        var source_port = data.source_port, source_channel = data.source_channel, token = data.token, sender = data.sender, receiver = data.receiver, timeout_timestamp = data.timeout_timestamp, timeout_height = data.timeout_height;
        if (!timeout_height && !timeout_timestamp) throw "both of timeout_height and timeout_timestamp are undefined";
        return new MsgTransfer(source_port, source_channel, token ? $7yVzo.Coin.fromData(token) : undefined, sender, receiver, timeout_height ? $cz9KI.Height.fromData(timeout_height) : undefined, timeout_timestamp ? Number.parseInt(timeout_timestamp) : undefined);
    };
    MsgTransfer.prototype.toData = function(_) {
        _;
        var _a = this, source_port = _a.source_port, source_channel = _a.source_channel, token = _a.token, sender = _a.sender, receiver = _a.receiver, timeout_height = _a.timeout_height, timeout_timestamp = _a.timeout_timestamp;
        return {
            "@type": "/ibc.applications.transfer.v1.MsgTransfer",
            source_port: source_port,
            source_channel: source_channel,
            token: token ? token.toData() : undefined,
            sender: sender,
            receiver: receiver,
            timeout_height: timeout_height ? timeout_height.toData() : new $cz9KI.Height(0, 0).toData(),
            timeout_timestamp: (timeout_timestamp === null || timeout_timestamp === void 0 ? void 0 : timeout_timestamp.toFixed()) || "0"
        };
    };
    MsgTransfer.fromProto = function(proto, _) {
        _;
        if (!proto.timeoutHeight && proto.timeoutTimestamp.toNumber() == 0) throw "both of timeout_height and timeout_timestamp are empty";
        return new MsgTransfer(proto.sourcePort, proto.sourceChannel, proto.token ? $7yVzo.Coin.fromProto(proto.token) : undefined, proto.sender, proto.receiver, proto.timeoutHeight ? $cz9KI.Height.fromProto(proto.timeoutHeight) : undefined, proto.timeoutTimestamp.toNumber());
    };
    MsgTransfer.prototype.toProto = function(_) {
        _;
        var _a = this, source_port = _a.source_port, source_channel = _a.source_channel, token = _a.token, sender = _a.sender, receiver = _a.receiver, timeout_height = _a.timeout_height, timeout_timestamp = _a.timeout_timestamp;
        return $gYi1B.MsgTransfer.fromPartial({
            sourcePort: source_port,
            sourceChannel: source_channel,
            token: token ? token.toProto() : undefined,
            sender: sender,
            receiver: receiver,
            timeoutHeight: timeout_height ? timeout_height.toProto() : undefined,
            timeoutTimestamp: $76186dc3dce52017$var$Long.fromString((timeout_timestamp === null || timeout_timestamp === void 0 ? void 0 : timeout_timestamp.toFixed()) || "0")
        });
    };
    MsgTransfer.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/ibc.applications.transfer.v1.MsgTransfer",
            value: $gYi1B.MsgTransfer.encode(this.toProto(isClassic)).finish()
        });
    };
    MsgTransfer.unpackAny = function(msgAny, isClassic) {
        return MsgTransfer.fromProto($gYi1B.MsgTransfer.decode(msgAny.value), isClassic);
    };
    return MsgTransfer;
}($26Eqx.JSONSerializable);
module.exports.MsgTransfer = $76186dc3dce52017$var$MsgTransfer;

});
parcelRegister("gYi1B", function(module, exports) {
"use strict";
var $c5b03b4d33f52909$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GrpcWebImpl = module.exports.MsgTransferDesc = module.exports.MsgDesc = module.exports.MsgClientImpl = module.exports.MsgTransferResponse = module.exports.MsgTransfer = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $c5b03b4d33f52909$var$long_1 = $c5b03b4d33f52909$var$__importDefault((parcelRequire("9A55m")));

var $jXVni = parcelRequire("jXVni");

const $c5b03b4d33f52909$var$minimal_1 = $c5b03b4d33f52909$var$__importDefault((parcelRequire("i2pIU")));

var $lPVUQ = parcelRequire("lPVUQ");

var $yqmJM = parcelRequire("yqmJM");

var $1pqjL = parcelRequire("1pqjL");
module.exports.protobufPackage = "ibc.applications.transfer.v1";
const $c5b03b4d33f52909$var$baseMsgTransfer = {
    sourcePort: "",
    sourceChannel: "",
    sender: "",
    receiver: "",
    timeoutTimestamp: $c5b03b4d33f52909$var$long_1.default.UZERO
};
module.exports.MsgTransfer = {
    encode (message, writer = $c5b03b4d33f52909$var$minimal_1.default.Writer.create()) {
        if (message.sourcePort !== "") writer.uint32(10).string(message.sourcePort);
        if (message.sourceChannel !== "") writer.uint32(18).string(message.sourceChannel);
        if (message.token !== undefined) $lPVUQ.Coin.encode(message.token, writer.uint32(26).fork()).ldelim();
        if (message.sender !== "") writer.uint32(34).string(message.sender);
        if (message.receiver !== "") writer.uint32(42).string(message.receiver);
        if (message.timeoutHeight !== undefined) $yqmJM.Height.encode(message.timeoutHeight, writer.uint32(50).fork()).ldelim();
        if (!message.timeoutTimestamp.isZero()) writer.uint32(56).uint64(message.timeoutTimestamp);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c5b03b4d33f52909$var$minimal_1.default.Reader ? input : new $c5b03b4d33f52909$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $c5b03b4d33f52909$var$baseMsgTransfer);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sourcePort = reader.string();
                    break;
                case 2:
                    message.sourceChannel = reader.string();
                    break;
                case 3:
                    message.token = $lPVUQ.Coin.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.sender = reader.string();
                    break;
                case 5:
                    message.receiver = reader.string();
                    break;
                case 6:
                    message.timeoutHeight = $yqmJM.Height.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.timeoutTimestamp = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $c5b03b4d33f52909$var$baseMsgTransfer);
        if (object.sourcePort !== undefined && object.sourcePort !== null) message.sourcePort = String(object.sourcePort);
        else message.sourcePort = "";
        if (object.sourceChannel !== undefined && object.sourceChannel !== null) message.sourceChannel = String(object.sourceChannel);
        else message.sourceChannel = "";
        if (object.token !== undefined && object.token !== null) message.token = $lPVUQ.Coin.fromJSON(object.token);
        else message.token = undefined;
        if (object.sender !== undefined && object.sender !== null) message.sender = String(object.sender);
        else message.sender = "";
        if (object.receiver !== undefined && object.receiver !== null) message.receiver = String(object.receiver);
        else message.receiver = "";
        if (object.timeoutHeight !== undefined && object.timeoutHeight !== null) message.timeoutHeight = $yqmJM.Height.fromJSON(object.timeoutHeight);
        else message.timeoutHeight = undefined;
        if (object.timeoutTimestamp !== undefined && object.timeoutTimestamp !== null) message.timeoutTimestamp = $c5b03b4d33f52909$var$long_1.default.fromString(object.timeoutTimestamp);
        else message.timeoutTimestamp = $c5b03b4d33f52909$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.sourcePort !== undefined && (obj.sourcePort = message.sourcePort);
        message.sourceChannel !== undefined && (obj.sourceChannel = message.sourceChannel);
        message.token !== undefined && (obj.token = message.token ? $lPVUQ.Coin.toJSON(message.token) : undefined);
        message.sender !== undefined && (obj.sender = message.sender);
        message.receiver !== undefined && (obj.receiver = message.receiver);
        message.timeoutHeight !== undefined && (obj.timeoutHeight = message.timeoutHeight ? $yqmJM.Height.toJSON(message.timeoutHeight) : undefined);
        message.timeoutTimestamp !== undefined && (obj.timeoutTimestamp = (message.timeoutTimestamp || $c5b03b4d33f52909$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $c5b03b4d33f52909$var$baseMsgTransfer);
        if (object.sourcePort !== undefined && object.sourcePort !== null) message.sourcePort = object.sourcePort;
        else message.sourcePort = "";
        if (object.sourceChannel !== undefined && object.sourceChannel !== null) message.sourceChannel = object.sourceChannel;
        else message.sourceChannel = "";
        if (object.token !== undefined && object.token !== null) message.token = $lPVUQ.Coin.fromPartial(object.token);
        else message.token = undefined;
        if (object.sender !== undefined && object.sender !== null) message.sender = object.sender;
        else message.sender = "";
        if (object.receiver !== undefined && object.receiver !== null) message.receiver = object.receiver;
        else message.receiver = "";
        if (object.timeoutHeight !== undefined && object.timeoutHeight !== null) message.timeoutHeight = $yqmJM.Height.fromPartial(object.timeoutHeight);
        else message.timeoutHeight = undefined;
        if (object.timeoutTimestamp !== undefined && object.timeoutTimestamp !== null) message.timeoutTimestamp = object.timeoutTimestamp;
        else message.timeoutTimestamp = $c5b03b4d33f52909$var$long_1.default.UZERO;
        return message;
    }
};
const $c5b03b4d33f52909$var$baseMsgTransferResponse = {};
module.exports.MsgTransferResponse = {
    encode (_, writer = $c5b03b4d33f52909$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c5b03b4d33f52909$var$minimal_1.default.Reader ? input : new $c5b03b4d33f52909$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $c5b03b4d33f52909$var$baseMsgTransferResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $c5b03b4d33f52909$var$baseMsgTransferResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $c5b03b4d33f52909$var$baseMsgTransferResponse);
        return message;
    }
};
class $c5b03b4d33f52909$var$MsgClientImpl {
    Transfer(request, metadata) {
        return this.rpc.unary(module.exports.MsgTransferDesc, module.exports.MsgTransfer.fromPartial(request), metadata);
    }
    constructor(rpc){
        this.rpc = rpc;
        this.Transfer = this.Transfer.bind(this);
    }
}
module.exports.MsgClientImpl = $c5b03b4d33f52909$var$MsgClientImpl;
module.exports.MsgDesc = {
    serviceName: "ibc.applications.transfer.v1.Msg"
};
module.exports.MsgTransferDesc = {
    methodName: "Transfer",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgTransfer.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgTransferResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
class $c5b03b4d33f52909$var$GrpcWebImpl {
    unary(methodDesc, _request, metadata) {
        var _a;
        const request = Object.assign(Object.assign({}, _request), methodDesc.requestType);
        const maybeCombinedMetadata = metadata && this.options.metadata ? new $1pqjL.BrowserHeaders(Object.assign(Object.assign({}, (_a = this.options) === null || _a === void 0 ? void 0 : _a.metadata.headersMap), metadata === null || metadata === void 0 ? void 0 : metadata.headersMap)) : metadata || this.options.metadata;
        return new Promise((resolve, reject)=>{
            $jXVni.grpc.unary(methodDesc, {
                request: request,
                host: this.host,
                metadata: maybeCombinedMetadata,
                transport: this.options.transport,
                debug: this.options.debug,
                onEnd: function(response) {
                    if (response.status === $jXVni.grpc.Code.OK) resolve(response.message);
                    else {
                        const err = new Error(response.statusMessage);
                        err.code = response.status;
                        err.metadata = response.trailers;
                        reject(err);
                    }
                }
            });
        });
    }
    constructor(host, options){
        this.host = host;
        this.options = options;
    }
}
module.exports.GrpcWebImpl = $c5b03b4d33f52909$var$GrpcWebImpl;
if ($c5b03b4d33f52909$var$minimal_1.default.util.Long !== $c5b03b4d33f52909$var$long_1.default) {
    $c5b03b4d33f52909$var$minimal_1.default.util.Long = $c5b03b4d33f52909$var$long_1.default;
    $c5b03b4d33f52909$var$minimal_1.default.configure();
}

});

parcelRegister("cz9KI", function(module, exports) {
"use strict";
var $9260519197d97a88$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $9260519197d97a88$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9260519197d97a88$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $9260519197d97a88$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $9260519197d97a88$var$__createBinding(result, mod, k);
    }
    $9260519197d97a88$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Height = void 0;

var $yqmJM = parcelRequire("yqmJM");

var $9260519197d97a88$var$Long = $9260519197d97a88$var$__importStar((parcelRequire("9A55m")));

var $26Eqx = parcelRequire("26Eqx");
/**
 * Height is a monotonically increasing data type
 * that can be compared against another Height for the purposes of updating and
 * freezing clients
 *
 * Normally the RevisionHeight is incremented at each height while keeping
 * RevisionNumber the same. However some consensus algorithms may choose to
 * reset the height in certain conditions e.g. hard forks, state-machine
 * breaking changes In these cases, the RevisionNumber is incremented so that
 * height continues to be monitonically increasing even as the RevisionHeight
 * gets reset
 */ var $9260519197d97a88$var$Height = /** @class */ function(_super) {
    $9260519197d97a88$var$__extends(Height, _super);
    /**
     * @param revision_number the revision that the client is currently on
     * @param revision_height the height within the given revision
     */ function Height(revision_number, revision_height) {
        var _this = _super.call(this) || this;
        _this.revision_number = revision_number;
        _this.revision_height = revision_height;
        return _this;
    }
    Height.fromAmino = function(data) {
        var revision_number = data.revision_number, revision_height = data.revision_height;
        return new Height(parseInt(revision_number || "0"), parseInt(revision_height || "0"));
    };
    Height.prototype.toAmino = function() {
        var _a = this, revision_number = _a.revision_number, revision_height = _a.revision_height;
        var res = {
            revision_number: revision_number > 0 ? revision_number.toFixed() : undefined,
            revision_height: revision_height > 0 ? revision_height.toFixed() : undefined
        };
        return res;
    };
    Height.fromData = function(data) {
        var revision_number = data.revision_number, revision_height = data.revision_height;
        return new Height(Number.parseInt(revision_number), Number.parseInt(revision_height));
    };
    Height.prototype.toData = function() {
        var _a = this, revision_number = _a.revision_number, revision_height = _a.revision_height;
        var res = {
            revision_number: revision_number.toFixed(),
            revision_height: revision_height.toFixed()
        };
        return res;
    };
    Height.fromProto = function(proto) {
        return new Height(proto.revisionNumber.toNumber(), proto.revisionHeight.toNumber());
    };
    Height.prototype.toProto = function() {
        var _a = this, revision_number = _a.revision_number, revision_height = _a.revision_height;
        return $yqmJM.Height.fromPartial({
            revisionNumber: $9260519197d97a88$var$Long.fromNumber(revision_number),
            revisionHeight: $9260519197d97a88$var$Long.fromNumber(revision_height)
        });
    };
    return Height;
}($26Eqx.JSONSerializable);
module.exports.Height = $9260519197d97a88$var$Height;

});


parcelRegister("bH2no", function(module, exports) {
"use strict";
var $88358dc4eb25fdd0$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FungibleTokenPacketData = void 0;

var $8TKI2 = parcelRequire("8TKI2");

var $26Eqx = parcelRequire("26Eqx");
/**
 *  FungibleTokenPacketData defines a struct for the packet payload
 * See FungibleTokenPacketData spec:
 * https://github.com/cosmos/ibc/tree/master/spec/app/ics-020-fungible-token-transfer#data-structures
 */ var $88358dc4eb25fdd0$var$FungibleTokenPacketData = /** @class */ function(_super) {
    $88358dc4eb25fdd0$var$__extends(FungibleTokenPacketData, _super);
    /**
     * @param denom the token denomination to be transferred
     * @param amount the token amount to be transferred
     * @param sender the sender address
     * @param receiver the recipient address on the destination chain
     */ function FungibleTokenPacketData(denom, amount, sender, receiver) {
        var _this = _super.call(this) || this;
        _this.denom = denom;
        _this.amount = amount;
        _this.sender = sender;
        _this.receiver = receiver;
        return _this;
    }
    FungibleTokenPacketData.fromAmino = function(data) {
        var denom = data.denom, amount = data.amount, sender = data.sender, receiver = data.receiver;
        return new FungibleTokenPacketData(denom, amount, sender, receiver);
    };
    FungibleTokenPacketData.prototype.toAmino = function() {
        var _a = this, denom = _a.denom, amount = _a.amount, sender = _a.sender, receiver = _a.receiver;
        var res = {
            denom: denom,
            amount: amount,
            sender: sender,
            receiver: receiver
        };
        return res;
    };
    FungibleTokenPacketData.fromData = function(data) {
        var denom = data.denom, amount = data.amount, sender = data.sender, receiver = data.receiver;
        return new FungibleTokenPacketData(denom, amount, sender, receiver);
    };
    FungibleTokenPacketData.prototype.toData = function() {
        var _a = this, denom = _a.denom, amount = _a.amount, sender = _a.sender, receiver = _a.receiver;
        var res = {
            denom: denom,
            amount: amount,
            sender: sender,
            receiver: receiver
        };
        return res;
    };
    FungibleTokenPacketData.fromProto = function(proto) {
        return new FungibleTokenPacketData(proto.denom, proto.amount, proto.sender, proto.receiver);
    };
    FungibleTokenPacketData.prototype.toProto = function() {
        var _a = this, denom = _a.denom, amount = _a.amount, sender = _a.sender, receiver = _a.receiver;
        return $8TKI2.FungibleTokenPacketData.fromPartial({
            denom: denom,
            amount: amount,
            sender: sender,
            receiver: receiver
        });
    };
    return FungibleTokenPacketData;
}($26Eqx.JSONSerializable);
module.exports.FungibleTokenPacketData = $88358dc4eb25fdd0$var$FungibleTokenPacketData;

});
parcelRegister("8TKI2", function(module, exports) {
"use strict";
var $67a7b14a1303b88d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FungibleTokenPacketData = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $67a7b14a1303b88d$var$long_1 = $67a7b14a1303b88d$var$__importDefault((parcelRequire("9A55m")));

const $67a7b14a1303b88d$var$minimal_1 = $67a7b14a1303b88d$var$__importDefault((parcelRequire("i2pIU")));
module.exports.protobufPackage = "ibc.applications.transfer.v2";
const $67a7b14a1303b88d$var$baseFungibleTokenPacketData = {
    denom: "",
    amount: "",
    sender: "",
    receiver: ""
};
module.exports.FungibleTokenPacketData = {
    encode (message, writer = $67a7b14a1303b88d$var$minimal_1.default.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.amount !== "") writer.uint32(18).string(message.amount);
        if (message.sender !== "") writer.uint32(26).string(message.sender);
        if (message.receiver !== "") writer.uint32(34).string(message.receiver);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $67a7b14a1303b88d$var$minimal_1.default.Reader ? input : new $67a7b14a1303b88d$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $67a7b14a1303b88d$var$baseFungibleTokenPacketData);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.amount = reader.string();
                    break;
                case 3:
                    message.sender = reader.string();
                    break;
                case 4:
                    message.receiver = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $67a7b14a1303b88d$var$baseFungibleTokenPacketData);
        if (object.denom !== undefined && object.denom !== null) message.denom = String(object.denom);
        else message.denom = "";
        if (object.amount !== undefined && object.amount !== null) message.amount = String(object.amount);
        else message.amount = "";
        if (object.sender !== undefined && object.sender !== null) message.sender = String(object.sender);
        else message.sender = "";
        if (object.receiver !== undefined && object.receiver !== null) message.receiver = String(object.receiver);
        else message.receiver = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.amount !== undefined && (obj.amount = message.amount);
        message.sender !== undefined && (obj.sender = message.sender);
        message.receiver !== undefined && (obj.receiver = message.receiver);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $67a7b14a1303b88d$var$baseFungibleTokenPacketData);
        if (object.denom !== undefined && object.denom !== null) message.denom = object.denom;
        else message.denom = "";
        if (object.amount !== undefined && object.amount !== null) message.amount = object.amount;
        else message.amount = "";
        if (object.sender !== undefined && object.sender !== null) message.sender = object.sender;
        else message.sender = "";
        if (object.receiver !== undefined && object.receiver !== null) message.receiver = object.receiver;
        else message.receiver = "";
        return message;
    }
};
if ($67a7b14a1303b88d$var$minimal_1.default.util.Long !== $67a7b14a1303b88d$var$long_1.default) {
    $67a7b14a1303b88d$var$minimal_1.default.util.Long = $67a7b14a1303b88d$var$long_1.default;
    $67a7b14a1303b88d$var$minimal_1.default.configure();
}

});


parcelRegister("lqRDX", function(module, exports) {
"use strict";
var $f9a5a329cd0ad5f8$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DenomTrace = void 0;

var $dmHZn = parcelRequire("dmHZn");

var $26Eqx = parcelRequire("26Eqx");
/**
 * DenomTrace is a monotonically increasing data type
 * that can be compared against another DenomTrace for the purposes of updating and
 * freezing clients
 *
 * Normally the RevisionDenomTrace is incremented at each height while keeping
 * RevisionNumber the same. However some consensus algorithms may choose to
 * reset the height in certain conditions e.g. hard forks, state-machine
 * breaking changes In these cases, the RevisionNumber is incremented so that
 * height continues to be monitonically increasing even as the RevisionDenomTrace
 * gets reset
 */ var $f9a5a329cd0ad5f8$var$DenomTrace = /** @class */ function(_super) {
    $f9a5a329cd0ad5f8$var$__extends(DenomTrace, _super);
    /**
     * @param path the revision that the client is currently on
     * @param base_denom the height within the given revision
     */ function DenomTrace(path, base_denom) {
        var _this = _super.call(this) || this;
        _this.path = path;
        _this.base_denom = base_denom;
        return _this;
    }
    DenomTrace.fromAmino = function(data) {
        var path = data.path, base_denom = data.base_denom;
        return new DenomTrace(path, base_denom);
    };
    DenomTrace.prototype.toAmino = function() {
        var _a = this, path = _a.path, base_denom = _a.base_denom;
        var res = {
            path: path,
            base_denom: base_denom
        };
        return res;
    };
    DenomTrace.fromData = function(data) {
        var path = data.path, base_denom = data.base_denom;
        return new DenomTrace(path, base_denom);
    };
    DenomTrace.prototype.toData = function() {
        var _a = this, path = _a.path, base_denom = _a.base_denom;
        var res = {
            path: path,
            base_denom: base_denom
        };
        return res;
    };
    DenomTrace.fromProto = function(proto) {
        return new DenomTrace(proto.path, proto.baseDenom);
    };
    DenomTrace.prototype.toProto = function() {
        var _a = this, path = _a.path, base_denom = _a.base_denom;
        return $dmHZn.DenomTrace.fromPartial({
            path: path,
            baseDenom: base_denom
        });
    };
    return DenomTrace;
}($26Eqx.JSONSerializable);
module.exports.DenomTrace = $f9a5a329cd0ad5f8$var$DenomTrace;

});
parcelRegister("dmHZn", function(module, exports) {
"use strict";
var $9baf73bf0151ec5c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Params = module.exports.DenomTrace = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $9baf73bf0151ec5c$var$long_1 = $9baf73bf0151ec5c$var$__importDefault((parcelRequire("9A55m")));

const $9baf73bf0151ec5c$var$minimal_1 = $9baf73bf0151ec5c$var$__importDefault((parcelRequire("i2pIU")));
module.exports.protobufPackage = "ibc.applications.transfer.v1";
const $9baf73bf0151ec5c$var$baseDenomTrace = {
    path: "",
    baseDenom: ""
};
module.exports.DenomTrace = {
    encode (message, writer = $9baf73bf0151ec5c$var$minimal_1.default.Writer.create()) {
        if (message.path !== "") writer.uint32(10).string(message.path);
        if (message.baseDenom !== "") writer.uint32(18).string(message.baseDenom);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9baf73bf0151ec5c$var$minimal_1.default.Reader ? input : new $9baf73bf0151ec5c$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9baf73bf0151ec5c$var$baseDenomTrace);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.path = reader.string();
                    break;
                case 2:
                    message.baseDenom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9baf73bf0151ec5c$var$baseDenomTrace);
        if (object.path !== undefined && object.path !== null) message.path = String(object.path);
        else message.path = "";
        if (object.baseDenom !== undefined && object.baseDenom !== null) message.baseDenom = String(object.baseDenom);
        else message.baseDenom = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.path !== undefined && (obj.path = message.path);
        message.baseDenom !== undefined && (obj.baseDenom = message.baseDenom);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9baf73bf0151ec5c$var$baseDenomTrace);
        if (object.path !== undefined && object.path !== null) message.path = object.path;
        else message.path = "";
        if (object.baseDenom !== undefined && object.baseDenom !== null) message.baseDenom = object.baseDenom;
        else message.baseDenom = "";
        return message;
    }
};
const $9baf73bf0151ec5c$var$baseParams = {
    sendEnabled: false,
    receiveEnabled: false
};
module.exports.Params = {
    encode (message, writer = $9baf73bf0151ec5c$var$minimal_1.default.Writer.create()) {
        if (message.sendEnabled === true) writer.uint32(8).bool(message.sendEnabled);
        if (message.receiveEnabled === true) writer.uint32(16).bool(message.receiveEnabled);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9baf73bf0151ec5c$var$minimal_1.default.Reader ? input : new $9baf73bf0151ec5c$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9baf73bf0151ec5c$var$baseParams);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sendEnabled = reader.bool();
                    break;
                case 2:
                    message.receiveEnabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9baf73bf0151ec5c$var$baseParams);
        if (object.sendEnabled !== undefined && object.sendEnabled !== null) message.sendEnabled = Boolean(object.sendEnabled);
        else message.sendEnabled = false;
        if (object.receiveEnabled !== undefined && object.receiveEnabled !== null) message.receiveEnabled = Boolean(object.receiveEnabled);
        else message.receiveEnabled = false;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.sendEnabled !== undefined && (obj.sendEnabled = message.sendEnabled);
        message.receiveEnabled !== undefined && (obj.receiveEnabled = message.receiveEnabled);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9baf73bf0151ec5c$var$baseParams);
        if (object.sendEnabled !== undefined && object.sendEnabled !== null) message.sendEnabled = object.sendEnabled;
        else message.sendEnabled = false;
        if (object.receiveEnabled !== undefined && object.receiveEnabled !== null) message.receiveEnabled = object.receiveEnabled;
        else message.receiveEnabled = false;
        return message;
    }
};
if ($9baf73bf0151ec5c$var$minimal_1.default.util.Long !== $9baf73bf0151ec5c$var$long_1.default) {
    $9baf73bf0151ec5c$var$minimal_1.default.util.Long = $9baf73bf0151ec5c$var$long_1.default;
    $9baf73bf0151ec5c$var$minimal_1.default.configure();
}

});



parcelRegister("6zouD", function(module, exports) {
"use strict";
var $4c8902cba7342a99$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4c8902cba7342a99$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $4c8902cba7342a99$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$4c8902cba7342a99$var$__exportStar((parcelRequire("7wXqJ")), module.exports);

$4c8902cba7342a99$var$__exportStar((parcelRequire("dzhcZ")), module.exports);

$4c8902cba7342a99$var$__exportStar((parcelRequire("1PxjS")), module.exports);

$4c8902cba7342a99$var$__exportStar((parcelRequire("e3haD")), module.exports);

});
parcelRegister("7wXqJ", function(module, exports) {
"use strict";
var $57b99f261d275752$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgCreateClient = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $lCsl4 = parcelRequire("lCsl4");
/**
 * MsgCreateClient defines a message to create an IBC client
 */ var $57b99f261d275752$var$MsgCreateClient = /** @class */ function(_super) {
    $57b99f261d275752$var$__extends(MsgCreateClient, _super);
    /**
     * @param client_state light client state
     * @param consensus_state consensus state associated with the client that corresponds to a given
     * @param signer signer address
     */ function MsgCreateClient(client_state, consensus_state, signer) {
        var _this = _super.call(this) || this;
        _this.client_state = client_state;
        _this.consensus_state = consensus_state;
        _this.signer = signer;
        return _this;
    }
    MsgCreateClient.fromAmino = function(_, isClassic) {
        _;
        isClassic;
        throw new Error("Amino not supported");
    };
    MsgCreateClient.prototype.toAmino = function(_) {
        _;
        throw new Error("Amino not supported");
    };
    MsgCreateClient.fromData = function(data, _) {
        _;
        var client_state = data.client_state, consensus_state = data.consensus_state, signer = data.signer;
        return new MsgCreateClient(client_state, consensus_state, signer);
    };
    MsgCreateClient.prototype.toData = function(_) {
        _;
        var _a = this, client_state = _a.client_state, consensus_state = _a.consensus_state, signer = _a.signer;
        return {
            "@type": "/ibc.core.client.v1.MsgCreateClient",
            client_state: client_state,
            consensus_state: consensus_state,
            signer: signer
        };
    };
    MsgCreateClient.fromProto = function(proto, _) {
        _;
        return new MsgCreateClient(proto.clientState, proto.consensusState, proto.signer);
    };
    MsgCreateClient.prototype.toProto = function(_) {
        _;
        var _a = this, client_state = _a.client_state, consensus_state = _a.consensus_state, signer = _a.signer;
        return $lCsl4.MsgCreateClient.fromPartial({
            clientState: client_state,
            consensusState: consensus_state,
            signer: signer
        });
    };
    MsgCreateClient.prototype.packAny = function(_) {
        _;
        return $c5FxR.Any.fromPartial({
            typeUrl: "/ibc.core.client.v1.MsgCreateClient",
            value: $lCsl4.MsgCreateClient.encode(this.toProto()).finish()
        });
    };
    MsgCreateClient.unpackAny = function(msgAny, _) {
        _;
        return MsgCreateClient.fromProto($lCsl4.MsgCreateClient.decode(msgAny.value));
    };
    return MsgCreateClient;
}($26Eqx.JSONSerializable);
module.exports.MsgCreateClient = $57b99f261d275752$var$MsgCreateClient;

});
parcelRegister("lCsl4", function(module, exports) {
"use strict";
var $fbd3211cf51acfc7$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GrpcWebImpl = module.exports.MsgSubmitMisbehaviourDesc = module.exports.MsgUpgradeClientDesc = module.exports.MsgUpdateClientDesc = module.exports.MsgCreateClientDesc = module.exports.MsgDesc = module.exports.MsgClientImpl = module.exports.MsgSubmitMisbehaviourResponse = module.exports.MsgSubmitMisbehaviour = module.exports.MsgUpgradeClientResponse = module.exports.MsgUpgradeClient = module.exports.MsgUpdateClientResponse = module.exports.MsgUpdateClient = module.exports.MsgCreateClientResponse = module.exports.MsgCreateClient = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $fbd3211cf51acfc7$var$long_1 = $fbd3211cf51acfc7$var$__importDefault((parcelRequire("9A55m")));

var $jXVni = parcelRequire("jXVni");

const $fbd3211cf51acfc7$var$minimal_1 = $fbd3211cf51acfc7$var$__importDefault((parcelRequire("i2pIU")));

var $c5FxR = parcelRequire("c5FxR");

var $1pqjL = parcelRequire("1pqjL");
module.exports.protobufPackage = "ibc.core.client.v1";
const $fbd3211cf51acfc7$var$baseMsgCreateClient = {
    signer: ""
};
module.exports.MsgCreateClient = {
    encode (message, writer = $fbd3211cf51acfc7$var$minimal_1.default.Writer.create()) {
        if (message.clientState !== undefined) $c5FxR.Any.encode(message.clientState, writer.uint32(10).fork()).ldelim();
        if (message.consensusState !== undefined) $c5FxR.Any.encode(message.consensusState, writer.uint32(18).fork()).ldelim();
        if (message.signer !== "") writer.uint32(26).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fbd3211cf51acfc7$var$minimal_1.default.Reader ? input : new $fbd3211cf51acfc7$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $fbd3211cf51acfc7$var$baseMsgCreateClient);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientState = $c5FxR.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.consensusState = $c5FxR.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $fbd3211cf51acfc7$var$baseMsgCreateClient);
        if (object.clientState !== undefined && object.clientState !== null) message.clientState = $c5FxR.Any.fromJSON(object.clientState);
        else message.clientState = undefined;
        if (object.consensusState !== undefined && object.consensusState !== null) message.consensusState = $c5FxR.Any.fromJSON(object.consensusState);
        else message.consensusState = undefined;
        if (object.signer !== undefined && object.signer !== null) message.signer = String(object.signer);
        else message.signer = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.clientState !== undefined && (obj.clientState = message.clientState ? $c5FxR.Any.toJSON(message.clientState) : undefined);
        message.consensusState !== undefined && (obj.consensusState = message.consensusState ? $c5FxR.Any.toJSON(message.consensusState) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $fbd3211cf51acfc7$var$baseMsgCreateClient);
        if (object.clientState !== undefined && object.clientState !== null) message.clientState = $c5FxR.Any.fromPartial(object.clientState);
        else message.clientState = undefined;
        if (object.consensusState !== undefined && object.consensusState !== null) message.consensusState = $c5FxR.Any.fromPartial(object.consensusState);
        else message.consensusState = undefined;
        if (object.signer !== undefined && object.signer !== null) message.signer = object.signer;
        else message.signer = "";
        return message;
    }
};
const $fbd3211cf51acfc7$var$baseMsgCreateClientResponse = {};
module.exports.MsgCreateClientResponse = {
    encode (_, writer = $fbd3211cf51acfc7$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fbd3211cf51acfc7$var$minimal_1.default.Reader ? input : new $fbd3211cf51acfc7$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $fbd3211cf51acfc7$var$baseMsgCreateClientResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $fbd3211cf51acfc7$var$baseMsgCreateClientResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $fbd3211cf51acfc7$var$baseMsgCreateClientResponse);
        return message;
    }
};
const $fbd3211cf51acfc7$var$baseMsgUpdateClient = {
    clientId: "",
    signer: ""
};
module.exports.MsgUpdateClient = {
    encode (message, writer = $fbd3211cf51acfc7$var$minimal_1.default.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.header !== undefined) $c5FxR.Any.encode(message.header, writer.uint32(18).fork()).ldelim();
        if (message.signer !== "") writer.uint32(26).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fbd3211cf51acfc7$var$minimal_1.default.Reader ? input : new $fbd3211cf51acfc7$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $fbd3211cf51acfc7$var$baseMsgUpdateClient);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.header = $c5FxR.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $fbd3211cf51acfc7$var$baseMsgUpdateClient);
        if (object.clientId !== undefined && object.clientId !== null) message.clientId = String(object.clientId);
        else message.clientId = "";
        if (object.header !== undefined && object.header !== null) message.header = $c5FxR.Any.fromJSON(object.header);
        else message.header = undefined;
        if (object.signer !== undefined && object.signer !== null) message.signer = String(object.signer);
        else message.signer = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.header !== undefined && (obj.header = message.header ? $c5FxR.Any.toJSON(message.header) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $fbd3211cf51acfc7$var$baseMsgUpdateClient);
        if (object.clientId !== undefined && object.clientId !== null) message.clientId = object.clientId;
        else message.clientId = "";
        if (object.header !== undefined && object.header !== null) message.header = $c5FxR.Any.fromPartial(object.header);
        else message.header = undefined;
        if (object.signer !== undefined && object.signer !== null) message.signer = object.signer;
        else message.signer = "";
        return message;
    }
};
const $fbd3211cf51acfc7$var$baseMsgUpdateClientResponse = {};
module.exports.MsgUpdateClientResponse = {
    encode (_, writer = $fbd3211cf51acfc7$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fbd3211cf51acfc7$var$minimal_1.default.Reader ? input : new $fbd3211cf51acfc7$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $fbd3211cf51acfc7$var$baseMsgUpdateClientResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $fbd3211cf51acfc7$var$baseMsgUpdateClientResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $fbd3211cf51acfc7$var$baseMsgUpdateClientResponse);
        return message;
    }
};
const $fbd3211cf51acfc7$var$baseMsgUpgradeClient = {
    clientId: "",
    signer: ""
};
module.exports.MsgUpgradeClient = {
    encode (message, writer = $fbd3211cf51acfc7$var$minimal_1.default.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.clientState !== undefined) $c5FxR.Any.encode(message.clientState, writer.uint32(18).fork()).ldelim();
        if (message.consensusState !== undefined) $c5FxR.Any.encode(message.consensusState, writer.uint32(26).fork()).ldelim();
        if (message.proofUpgradeClient.length !== 0) writer.uint32(34).bytes(message.proofUpgradeClient);
        if (message.proofUpgradeConsensusState.length !== 0) writer.uint32(42).bytes(message.proofUpgradeConsensusState);
        if (message.signer !== "") writer.uint32(50).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fbd3211cf51acfc7$var$minimal_1.default.Reader ? input : new $fbd3211cf51acfc7$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $fbd3211cf51acfc7$var$baseMsgUpgradeClient);
        message.proofUpgradeClient = new Uint8Array();
        message.proofUpgradeConsensusState = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.clientState = $c5FxR.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.consensusState = $c5FxR.Any.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.proofUpgradeClient = reader.bytes();
                    break;
                case 5:
                    message.proofUpgradeConsensusState = reader.bytes();
                    break;
                case 6:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $fbd3211cf51acfc7$var$baseMsgUpgradeClient);
        message.proofUpgradeClient = new Uint8Array();
        message.proofUpgradeConsensusState = new Uint8Array();
        if (object.clientId !== undefined && object.clientId !== null) message.clientId = String(object.clientId);
        else message.clientId = "";
        if (object.clientState !== undefined && object.clientState !== null) message.clientState = $c5FxR.Any.fromJSON(object.clientState);
        else message.clientState = undefined;
        if (object.consensusState !== undefined && object.consensusState !== null) message.consensusState = $c5FxR.Any.fromJSON(object.consensusState);
        else message.consensusState = undefined;
        if (object.proofUpgradeClient !== undefined && object.proofUpgradeClient !== null) message.proofUpgradeClient = $fbd3211cf51acfc7$var$bytesFromBase64(object.proofUpgradeClient);
        if (object.proofUpgradeConsensusState !== undefined && object.proofUpgradeConsensusState !== null) message.proofUpgradeConsensusState = $fbd3211cf51acfc7$var$bytesFromBase64(object.proofUpgradeConsensusState);
        if (object.signer !== undefined && object.signer !== null) message.signer = String(object.signer);
        else message.signer = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.clientState !== undefined && (obj.clientState = message.clientState ? $c5FxR.Any.toJSON(message.clientState) : undefined);
        message.consensusState !== undefined && (obj.consensusState = message.consensusState ? $c5FxR.Any.toJSON(message.consensusState) : undefined);
        message.proofUpgradeClient !== undefined && (obj.proofUpgradeClient = $fbd3211cf51acfc7$var$base64FromBytes(message.proofUpgradeClient !== undefined ? message.proofUpgradeClient : new Uint8Array()));
        message.proofUpgradeConsensusState !== undefined && (obj.proofUpgradeConsensusState = $fbd3211cf51acfc7$var$base64FromBytes(message.proofUpgradeConsensusState !== undefined ? message.proofUpgradeConsensusState : new Uint8Array()));
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $fbd3211cf51acfc7$var$baseMsgUpgradeClient);
        if (object.clientId !== undefined && object.clientId !== null) message.clientId = object.clientId;
        else message.clientId = "";
        if (object.clientState !== undefined && object.clientState !== null) message.clientState = $c5FxR.Any.fromPartial(object.clientState);
        else message.clientState = undefined;
        if (object.consensusState !== undefined && object.consensusState !== null) message.consensusState = $c5FxR.Any.fromPartial(object.consensusState);
        else message.consensusState = undefined;
        if (object.proofUpgradeClient !== undefined && object.proofUpgradeClient !== null) message.proofUpgradeClient = object.proofUpgradeClient;
        else message.proofUpgradeClient = new Uint8Array();
        if (object.proofUpgradeConsensusState !== undefined && object.proofUpgradeConsensusState !== null) message.proofUpgradeConsensusState = object.proofUpgradeConsensusState;
        else message.proofUpgradeConsensusState = new Uint8Array();
        if (object.signer !== undefined && object.signer !== null) message.signer = object.signer;
        else message.signer = "";
        return message;
    }
};
const $fbd3211cf51acfc7$var$baseMsgUpgradeClientResponse = {};
module.exports.MsgUpgradeClientResponse = {
    encode (_, writer = $fbd3211cf51acfc7$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fbd3211cf51acfc7$var$minimal_1.default.Reader ? input : new $fbd3211cf51acfc7$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $fbd3211cf51acfc7$var$baseMsgUpgradeClientResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $fbd3211cf51acfc7$var$baseMsgUpgradeClientResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $fbd3211cf51acfc7$var$baseMsgUpgradeClientResponse);
        return message;
    }
};
const $fbd3211cf51acfc7$var$baseMsgSubmitMisbehaviour = {
    clientId: "",
    signer: ""
};
module.exports.MsgSubmitMisbehaviour = {
    encode (message, writer = $fbd3211cf51acfc7$var$minimal_1.default.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.misbehaviour !== undefined) $c5FxR.Any.encode(message.misbehaviour, writer.uint32(18).fork()).ldelim();
        if (message.signer !== "") writer.uint32(26).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fbd3211cf51acfc7$var$minimal_1.default.Reader ? input : new $fbd3211cf51acfc7$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $fbd3211cf51acfc7$var$baseMsgSubmitMisbehaviour);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.misbehaviour = $c5FxR.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $fbd3211cf51acfc7$var$baseMsgSubmitMisbehaviour);
        if (object.clientId !== undefined && object.clientId !== null) message.clientId = String(object.clientId);
        else message.clientId = "";
        if (object.misbehaviour !== undefined && object.misbehaviour !== null) message.misbehaviour = $c5FxR.Any.fromJSON(object.misbehaviour);
        else message.misbehaviour = undefined;
        if (object.signer !== undefined && object.signer !== null) message.signer = String(object.signer);
        else message.signer = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.misbehaviour !== undefined && (obj.misbehaviour = message.misbehaviour ? $c5FxR.Any.toJSON(message.misbehaviour) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $fbd3211cf51acfc7$var$baseMsgSubmitMisbehaviour);
        if (object.clientId !== undefined && object.clientId !== null) message.clientId = object.clientId;
        else message.clientId = "";
        if (object.misbehaviour !== undefined && object.misbehaviour !== null) message.misbehaviour = $c5FxR.Any.fromPartial(object.misbehaviour);
        else message.misbehaviour = undefined;
        if (object.signer !== undefined && object.signer !== null) message.signer = object.signer;
        else message.signer = "";
        return message;
    }
};
const $fbd3211cf51acfc7$var$baseMsgSubmitMisbehaviourResponse = {};
module.exports.MsgSubmitMisbehaviourResponse = {
    encode (_, writer = $fbd3211cf51acfc7$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fbd3211cf51acfc7$var$minimal_1.default.Reader ? input : new $fbd3211cf51acfc7$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $fbd3211cf51acfc7$var$baseMsgSubmitMisbehaviourResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $fbd3211cf51acfc7$var$baseMsgSubmitMisbehaviourResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $fbd3211cf51acfc7$var$baseMsgSubmitMisbehaviourResponse);
        return message;
    }
};
class $fbd3211cf51acfc7$var$MsgClientImpl {
    CreateClient(request, metadata) {
        return this.rpc.unary(module.exports.MsgCreateClientDesc, module.exports.MsgCreateClient.fromPartial(request), metadata);
    }
    UpdateClient(request, metadata) {
        return this.rpc.unary(module.exports.MsgUpdateClientDesc, module.exports.MsgUpdateClient.fromPartial(request), metadata);
    }
    UpgradeClient(request, metadata) {
        return this.rpc.unary(module.exports.MsgUpgradeClientDesc, module.exports.MsgUpgradeClient.fromPartial(request), metadata);
    }
    SubmitMisbehaviour(request, metadata) {
        return this.rpc.unary(module.exports.MsgSubmitMisbehaviourDesc, module.exports.MsgSubmitMisbehaviour.fromPartial(request), metadata);
    }
    constructor(rpc){
        this.rpc = rpc;
        this.CreateClient = this.CreateClient.bind(this);
        this.UpdateClient = this.UpdateClient.bind(this);
        this.UpgradeClient = this.UpgradeClient.bind(this);
        this.SubmitMisbehaviour = this.SubmitMisbehaviour.bind(this);
    }
}
module.exports.MsgClientImpl = $fbd3211cf51acfc7$var$MsgClientImpl;
module.exports.MsgDesc = {
    serviceName: "ibc.core.client.v1.Msg"
};
module.exports.MsgCreateClientDesc = {
    methodName: "CreateClient",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgCreateClient.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgCreateClientResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.MsgUpdateClientDesc = {
    methodName: "UpdateClient",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgUpdateClient.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgUpdateClientResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.MsgUpgradeClientDesc = {
    methodName: "UpgradeClient",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgUpgradeClient.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgUpgradeClientResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.MsgSubmitMisbehaviourDesc = {
    methodName: "SubmitMisbehaviour",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgSubmitMisbehaviour.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgSubmitMisbehaviourResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
class $fbd3211cf51acfc7$var$GrpcWebImpl {
    unary(methodDesc, _request, metadata) {
        var _a;
        const request = Object.assign(Object.assign({}, _request), methodDesc.requestType);
        const maybeCombinedMetadata = metadata && this.options.metadata ? new $1pqjL.BrowserHeaders(Object.assign(Object.assign({}, (_a = this.options) === null || _a === void 0 ? void 0 : _a.metadata.headersMap), metadata === null || metadata === void 0 ? void 0 : metadata.headersMap)) : metadata || this.options.metadata;
        return new Promise((resolve, reject)=>{
            $jXVni.grpc.unary(methodDesc, {
                request: request,
                host: this.host,
                metadata: maybeCombinedMetadata,
                transport: this.options.transport,
                debug: this.options.debug,
                onEnd: function(response) {
                    if (response.status === $jXVni.grpc.Code.OK) resolve(response.message);
                    else {
                        const err = new Error(response.statusMessage);
                        err.code = response.status;
                        err.metadata = response.trailers;
                        reject(err);
                    }
                }
            });
        });
    }
    constructor(host, options){
        this.host = host;
        this.options = options;
    }
}
module.exports.GrpcWebImpl = $fbd3211cf51acfc7$var$GrpcWebImpl;
var $fbd3211cf51acfc7$var$globalThis = (()=>{
    if (typeof $fbd3211cf51acfc7$var$globalThis !== "undefined") return $fbd3211cf51acfc7$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $fbd3211cf51acfc7$var$atob = $fbd3211cf51acfc7$var$globalThis.atob || ((b64)=>$fbd3211cf51acfc7$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $fbd3211cf51acfc7$var$bytesFromBase64(b64) {
    const bin = $fbd3211cf51acfc7$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $fbd3211cf51acfc7$var$btoa = $fbd3211cf51acfc7$var$globalThis.btoa || ((bin)=>$fbd3211cf51acfc7$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $fbd3211cf51acfc7$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $fbd3211cf51acfc7$var$btoa(bin.join(""));
}
if ($fbd3211cf51acfc7$var$minimal_1.default.util.Long !== $fbd3211cf51acfc7$var$long_1.default) {
    $fbd3211cf51acfc7$var$minimal_1.default.util.Long = $fbd3211cf51acfc7$var$long_1.default;
    $fbd3211cf51acfc7$var$minimal_1.default.configure();
}

});


parcelRegister("dzhcZ", function(module, exports) {
"use strict";
var $9e0be48413a080f7$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgUpdateClient = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $lCsl4 = parcelRequire("lCsl4");

var $aLRl6 = parcelRequire("aLRl6");
/**
 * MsgUpdateClient defines an sdk.Msg to update a IBC client state using the given header
 */ var $9e0be48413a080f7$var$MsgUpdateClient = /** @class */ function(_super) {
    $9e0be48413a080f7$var$__extends(MsgUpdateClient, _super);
    /**
     * @param client_id client unique identifier
     * @param header header to update the light client
     * @param signer signer address
     */ function MsgUpdateClient(client_id, header, signer) {
        var _this = _super.call(this) || this;
        _this.client_id = client_id;
        _this.header = header;
        _this.signer = signer;
        return _this;
    }
    MsgUpdateClient.fromAmino = function(_, isClassic) {
        _;
        isClassic;
        throw new Error("Amino not supported");
    };
    MsgUpdateClient.prototype.toAmino = function() {
        throw new Error("Amino not supported");
    };
    MsgUpdateClient.fromData = function(data, _) {
        _;
        var client_id = data.client_id, header = data.header, signer = data.signer;
        return new MsgUpdateClient(client_id, header ? $aLRl6.Header.fromData(header) : undefined, signer);
    };
    MsgUpdateClient.prototype.toData = function(_) {
        _;
        var _a = this, client_id = _a.client_id, header = _a.header, signer = _a.signer;
        return {
            "@type": "/ibc.core.client.v1.MsgUpdateClient",
            client_id: client_id,
            header: (header === null || header === void 0 ? void 0 : header.toData()) || undefined,
            signer: signer
        };
    };
    MsgUpdateClient.fromProto = function(proto, _) {
        _;
        return new MsgUpdateClient(proto.clientId, proto.header ? $aLRl6.Header.unpackAny(proto.header) : undefined, proto.signer);
    };
    MsgUpdateClient.prototype.toProto = function(_) {
        _;
        var _a = this, client_id = _a.client_id, header = _a.header, signer = _a.signer;
        return $lCsl4.MsgUpdateClient.fromPartial({
            clientId: client_id,
            header: (header === null || header === void 0 ? void 0 : header.packAny()) || undefined,
            signer: signer
        });
    };
    MsgUpdateClient.prototype.packAny = function(_) {
        _;
        return $c5FxR.Any.fromPartial({
            typeUrl: "/ibc.core.client.v1.MsgUpdateClient",
            value: $lCsl4.MsgUpdateClient.encode(this.toProto()).finish()
        });
    };
    MsgUpdateClient.unpackAny = function(msgAny, _) {
        _;
        return MsgUpdateClient.fromProto($lCsl4.MsgUpdateClient.decode(msgAny.value));
    };
    return MsgUpdateClient;
}($26Eqx.JSONSerializable);
module.exports.MsgUpdateClient = $9e0be48413a080f7$var$MsgUpdateClient;

});
parcelRegister("aLRl6", function(module, exports) {
"use strict";
var $7d77ab3f4b92af69$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Header = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $dE4kO = parcelRequire("dE4kO");

var $cz9KI = parcelRequire("cz9KI");

var $ec3qw = parcelRequire("ec3qw");

var $c5FxR = parcelRequire("c5FxR");
/**
 * Header defines the Tendermint client consensus Header.
 * It encapsulates all the information necessary to update from a trusted
 * Tendermint ConsensusState. The inclusion of TrustedHeight and
 * TrustedValidators allows this update to process correctly, so long as the
 * ConsensusState for the TrustedHeight exists, this removes race conditions
 * among relayers The SignedHeader and ValidatorSet are the new untrusted update
 * fields for the client. The TrustedHeight is the height of a stored
 * ConsensusState on the client that will be used to verify the new untrusted
 * header. The Trusted ConsensusState must be within the unbonding period of
 * current time in order to correctly verify, and the TrustedValidators must
 * hash to TrustedConsensusState.NextValidatorsHash since that is the last
 * trusted validator set at the TrustedHeight.
 */ var $7d77ab3f4b92af69$var$Header = /** @class */ function(_super) {
    $7d77ab3f4b92af69$var$__extends(Header, _super);
    /**
     * @param signedHeader
     * @param validatorSet
     * @param trustedHeight
     * @param trustedValidators
     */ function Header(signedHeader, validatorSet, trustedHeight, trustedValidators) {
        var _this = _super.call(this) || this;
        _this.signedHeader = signedHeader;
        _this.validatorSet = validatorSet;
        _this.trustedHeight = trustedHeight;
        _this.trustedValidators = trustedValidators;
        return _this;
    }
    Header.fromAmino = function(_) {
        _;
        throw new Error("Amino not supported");
    };
    Header.prototype.toAmino = function() {
        throw new Error("Amino not supported");
    };
    Header.fromData = function(data) {
        var signedHeader = data.signed_header, validatorSet = data.validator_set, trustedHeight = data.trusted_height, trustedValidators = data.trusted_validators;
        return new Header(signedHeader ? $ec3qw.SignedHeader.fromData(signedHeader) : undefined, validatorSet ? $ec3qw.ValidatorSet.fromData(validatorSet) : undefined, trustedHeight ? $cz9KI.Height.fromData(trustedHeight) : undefined, trustedValidators ? $ec3qw.ValidatorSet.fromData(trustedValidators) : undefined);
    };
    Header.prototype.toData = function() {
        var _a = this, signedHeader = _a.signedHeader, validatorSet = _a.validatorSet, trustedHeight = _a.trustedHeight, trustedValidators = _a.trustedValidators;
        return {
            signed_header: (signedHeader === null || signedHeader === void 0 ? void 0 : signedHeader.toData()) || undefined,
            validator_set: (validatorSet === null || validatorSet === void 0 ? void 0 : validatorSet.toData()) || undefined,
            trusted_height: (trustedHeight === null || trustedHeight === void 0 ? void 0 : trustedHeight.toData()) || undefined,
            trusted_validators: (trustedValidators === null || trustedValidators === void 0 ? void 0 : trustedValidators.toData()) || undefined
        };
    };
    Header.fromProto = function(proto) {
        var signedHeader = proto.signedHeader, validatorSet = proto.validatorSet, trustedHeight = proto.trustedHeight, trustedValidators = proto.trustedValidators;
        return new Header(signedHeader ? $ec3qw.SignedHeader.fromProto(signedHeader) : undefined, validatorSet ? $ec3qw.ValidatorSet.fromProto(validatorSet) : undefined, trustedHeight ? $cz9KI.Height.fromProto(trustedHeight) : undefined, trustedValidators ? $ec3qw.ValidatorSet.fromProto(trustedValidators) : undefined);
    };
    Header.prototype.toProto = function() {
        var _a = this, signedHeader = _a.signedHeader, validatorSet = _a.validatorSet, trustedHeight = _a.trustedHeight, trustedValidators = _a.trustedValidators;
        return $dE4kO.Header.fromPartial({
            signedHeader: (signedHeader === null || signedHeader === void 0 ? void 0 : signedHeader.toProto()) || undefined,
            validatorSet: (validatorSet === null || validatorSet === void 0 ? void 0 : validatorSet.toProto()) || undefined,
            trustedHeight: (trustedHeight === null || trustedHeight === void 0 ? void 0 : trustedHeight.toProto()) || undefined,
            trustedValidators: (trustedValidators === null || trustedValidators === void 0 ? void 0 : trustedValidators.toProto()) || undefined
        });
    };
    Header.prototype.packAny = function() {
        return $c5FxR.Any.fromPartial({
            typeUrl: "ibc.lightclients.tendermint.v1.Header",
            value: $dE4kO.Header.encode(this.toProto()).finish()
        });
    };
    Header.unpackAny = function(msgAny) {
        return Header.fromProto($dE4kO.Header.decode(msgAny.value));
    };
    return Header;
}($26Eqx.JSONSerializable);
module.exports.Header = $7d77ab3f4b92af69$var$Header;

});
parcelRegister("dE4kO", function(module, exports) {
"use strict";
var $9ef25f8c84398450$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Fraction = module.exports.Header = module.exports.Misbehaviour = module.exports.ConsensusState = module.exports.ClientState = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $9ef25f8c84398450$var$long_1 = $9ef25f8c84398450$var$__importDefault((parcelRequire("9A55m")));

const $9ef25f8c84398450$var$minimal_1 = $9ef25f8c84398450$var$__importDefault((parcelRequire("i2pIU")));

var $dmomH = parcelRequire("dmomH");

var $yqmJM = parcelRequire("yqmJM");

var $8k8Xg = parcelRequire("8k8Xg");

var $djDW6 = parcelRequire("djDW6");

var $j77DS = parcelRequire("j77DS");

var $5G2s6 = parcelRequire("5G2s6");

var $9nV5P = parcelRequire("9nV5P");
module.exports.protobufPackage = "ibc.lightclients.tendermint.v1";
const $9ef25f8c84398450$var$baseClientState = {
    chainId: "",
    upgradePath: "",
    allowUpdateAfterExpiry: false,
    allowUpdateAfterMisbehaviour: false
};
module.exports.ClientState = {
    encode (message, writer = $9ef25f8c84398450$var$minimal_1.default.Writer.create()) {
        if (message.chainId !== "") writer.uint32(10).string(message.chainId);
        if (message.trustLevel !== undefined) module.exports.Fraction.encode(message.trustLevel, writer.uint32(18).fork()).ldelim();
        if (message.trustingPeriod !== undefined) $dmomH.Duration.encode(message.trustingPeriod, writer.uint32(26).fork()).ldelim();
        if (message.unbondingPeriod !== undefined) $dmomH.Duration.encode(message.unbondingPeriod, writer.uint32(34).fork()).ldelim();
        if (message.maxClockDrift !== undefined) $dmomH.Duration.encode(message.maxClockDrift, writer.uint32(42).fork()).ldelim();
        if (message.frozenHeight !== undefined) $yqmJM.Height.encode(message.frozenHeight, writer.uint32(50).fork()).ldelim();
        if (message.latestHeight !== undefined) $yqmJM.Height.encode(message.latestHeight, writer.uint32(58).fork()).ldelim();
        for (const v of message.proofSpecs)$9nV5P.ProofSpec.encode(v, writer.uint32(66).fork()).ldelim();
        for (const v of message.upgradePath)writer.uint32(74).string(v);
        if (message.allowUpdateAfterExpiry === true) writer.uint32(80).bool(message.allowUpdateAfterExpiry);
        if (message.allowUpdateAfterMisbehaviour === true) writer.uint32(88).bool(message.allowUpdateAfterMisbehaviour);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9ef25f8c84398450$var$minimal_1.default.Reader ? input : new $9ef25f8c84398450$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9ef25f8c84398450$var$baseClientState);
        message.proofSpecs = [];
        message.upgradePath = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.chainId = reader.string();
                    break;
                case 2:
                    message.trustLevel = module.exports.Fraction.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.trustingPeriod = $dmomH.Duration.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.unbondingPeriod = $dmomH.Duration.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.maxClockDrift = $dmomH.Duration.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.frozenHeight = $yqmJM.Height.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.latestHeight = $yqmJM.Height.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.proofSpecs.push($9nV5P.ProofSpec.decode(reader, reader.uint32()));
                    break;
                case 9:
                    message.upgradePath.push(reader.string());
                    break;
                case 10:
                    message.allowUpdateAfterExpiry = reader.bool();
                    break;
                case 11:
                    message.allowUpdateAfterMisbehaviour = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9ef25f8c84398450$var$baseClientState);
        message.proofSpecs = [];
        message.upgradePath = [];
        if (object.chainId !== undefined && object.chainId !== null) message.chainId = String(object.chainId);
        else message.chainId = "";
        if (object.trustLevel !== undefined && object.trustLevel !== null) message.trustLevel = module.exports.Fraction.fromJSON(object.trustLevel);
        else message.trustLevel = undefined;
        if (object.trustingPeriod !== undefined && object.trustingPeriod !== null) message.trustingPeriod = $dmomH.Duration.fromJSON(object.trustingPeriod);
        else message.trustingPeriod = undefined;
        if (object.unbondingPeriod !== undefined && object.unbondingPeriod !== null) message.unbondingPeriod = $dmomH.Duration.fromJSON(object.unbondingPeriod);
        else message.unbondingPeriod = undefined;
        if (object.maxClockDrift !== undefined && object.maxClockDrift !== null) message.maxClockDrift = $dmomH.Duration.fromJSON(object.maxClockDrift);
        else message.maxClockDrift = undefined;
        if (object.frozenHeight !== undefined && object.frozenHeight !== null) message.frozenHeight = $yqmJM.Height.fromJSON(object.frozenHeight);
        else message.frozenHeight = undefined;
        if (object.latestHeight !== undefined && object.latestHeight !== null) message.latestHeight = $yqmJM.Height.fromJSON(object.latestHeight);
        else message.latestHeight = undefined;
        if (object.proofSpecs !== undefined && object.proofSpecs !== null) for (const e of object.proofSpecs)message.proofSpecs.push($9nV5P.ProofSpec.fromJSON(e));
        if (object.upgradePath !== undefined && object.upgradePath !== null) for (const e of object.upgradePath)message.upgradePath.push(String(e));
        if (object.allowUpdateAfterExpiry !== undefined && object.allowUpdateAfterExpiry !== null) message.allowUpdateAfterExpiry = Boolean(object.allowUpdateAfterExpiry);
        else message.allowUpdateAfterExpiry = false;
        if (object.allowUpdateAfterMisbehaviour !== undefined && object.allowUpdateAfterMisbehaviour !== null) message.allowUpdateAfterMisbehaviour = Boolean(object.allowUpdateAfterMisbehaviour);
        else message.allowUpdateAfterMisbehaviour = false;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.trustLevel !== undefined && (obj.trustLevel = message.trustLevel ? module.exports.Fraction.toJSON(message.trustLevel) : undefined);
        message.trustingPeriod !== undefined && (obj.trustingPeriod = message.trustingPeriod ? $dmomH.Duration.toJSON(message.trustingPeriod) : undefined);
        message.unbondingPeriod !== undefined && (obj.unbondingPeriod = message.unbondingPeriod ? $dmomH.Duration.toJSON(message.unbondingPeriod) : undefined);
        message.maxClockDrift !== undefined && (obj.maxClockDrift = message.maxClockDrift ? $dmomH.Duration.toJSON(message.maxClockDrift) : undefined);
        message.frozenHeight !== undefined && (obj.frozenHeight = message.frozenHeight ? $yqmJM.Height.toJSON(message.frozenHeight) : undefined);
        message.latestHeight !== undefined && (obj.latestHeight = message.latestHeight ? $yqmJM.Height.toJSON(message.latestHeight) : undefined);
        if (message.proofSpecs) obj.proofSpecs = message.proofSpecs.map((e)=>e ? $9nV5P.ProofSpec.toJSON(e) : undefined);
        else obj.proofSpecs = [];
        if (message.upgradePath) obj.upgradePath = message.upgradePath.map((e)=>e);
        else obj.upgradePath = [];
        message.allowUpdateAfterExpiry !== undefined && (obj.allowUpdateAfterExpiry = message.allowUpdateAfterExpiry);
        message.allowUpdateAfterMisbehaviour !== undefined && (obj.allowUpdateAfterMisbehaviour = message.allowUpdateAfterMisbehaviour);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9ef25f8c84398450$var$baseClientState);
        message.proofSpecs = [];
        message.upgradePath = [];
        if (object.chainId !== undefined && object.chainId !== null) message.chainId = object.chainId;
        else message.chainId = "";
        if (object.trustLevel !== undefined && object.trustLevel !== null) message.trustLevel = module.exports.Fraction.fromPartial(object.trustLevel);
        else message.trustLevel = undefined;
        if (object.trustingPeriod !== undefined && object.trustingPeriod !== null) message.trustingPeriod = $dmomH.Duration.fromPartial(object.trustingPeriod);
        else message.trustingPeriod = undefined;
        if (object.unbondingPeriod !== undefined && object.unbondingPeriod !== null) message.unbondingPeriod = $dmomH.Duration.fromPartial(object.unbondingPeriod);
        else message.unbondingPeriod = undefined;
        if (object.maxClockDrift !== undefined && object.maxClockDrift !== null) message.maxClockDrift = $dmomH.Duration.fromPartial(object.maxClockDrift);
        else message.maxClockDrift = undefined;
        if (object.frozenHeight !== undefined && object.frozenHeight !== null) message.frozenHeight = $yqmJM.Height.fromPartial(object.frozenHeight);
        else message.frozenHeight = undefined;
        if (object.latestHeight !== undefined && object.latestHeight !== null) message.latestHeight = $yqmJM.Height.fromPartial(object.latestHeight);
        else message.latestHeight = undefined;
        if (object.proofSpecs !== undefined && object.proofSpecs !== null) for (const e of object.proofSpecs)message.proofSpecs.push($9nV5P.ProofSpec.fromPartial(e));
        if (object.upgradePath !== undefined && object.upgradePath !== null) for (const e of object.upgradePath)message.upgradePath.push(e);
        if (object.allowUpdateAfterExpiry !== undefined && object.allowUpdateAfterExpiry !== null) message.allowUpdateAfterExpiry = object.allowUpdateAfterExpiry;
        else message.allowUpdateAfterExpiry = false;
        if (object.allowUpdateAfterMisbehaviour !== undefined && object.allowUpdateAfterMisbehaviour !== null) message.allowUpdateAfterMisbehaviour = object.allowUpdateAfterMisbehaviour;
        else message.allowUpdateAfterMisbehaviour = false;
        return message;
    }
};
const $9ef25f8c84398450$var$baseConsensusState = {};
module.exports.ConsensusState = {
    encode (message, writer = $9ef25f8c84398450$var$minimal_1.default.Writer.create()) {
        if (message.timestamp !== undefined) $5G2s6.Timestamp.encode($9ef25f8c84398450$var$toTimestamp(message.timestamp), writer.uint32(10).fork()).ldelim();
        if (message.root !== undefined) $8k8Xg.MerkleRoot.encode(message.root, writer.uint32(18).fork()).ldelim();
        if (message.nextValidatorsHash.length !== 0) writer.uint32(26).bytes(message.nextValidatorsHash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9ef25f8c84398450$var$minimal_1.default.Reader ? input : new $9ef25f8c84398450$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9ef25f8c84398450$var$baseConsensusState);
        message.nextValidatorsHash = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.timestamp = $9ef25f8c84398450$var$fromTimestamp($5G2s6.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.root = $8k8Xg.MerkleRoot.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.nextValidatorsHash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9ef25f8c84398450$var$baseConsensusState);
        message.nextValidatorsHash = new Uint8Array();
        if (object.timestamp !== undefined && object.timestamp !== null) message.timestamp = $9ef25f8c84398450$var$fromJsonTimestamp(object.timestamp);
        else message.timestamp = undefined;
        if (object.root !== undefined && object.root !== null) message.root = $8k8Xg.MerkleRoot.fromJSON(object.root);
        else message.root = undefined;
        if (object.nextValidatorsHash !== undefined && object.nextValidatorsHash !== null) message.nextValidatorsHash = $9ef25f8c84398450$var$bytesFromBase64(object.nextValidatorsHash);
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.timestamp !== undefined && (obj.timestamp = message.timestamp.toISOString());
        message.root !== undefined && (obj.root = message.root ? $8k8Xg.MerkleRoot.toJSON(message.root) : undefined);
        message.nextValidatorsHash !== undefined && (obj.nextValidatorsHash = $9ef25f8c84398450$var$base64FromBytes(message.nextValidatorsHash !== undefined ? message.nextValidatorsHash : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9ef25f8c84398450$var$baseConsensusState);
        if (object.timestamp !== undefined && object.timestamp !== null) message.timestamp = object.timestamp;
        else message.timestamp = undefined;
        if (object.root !== undefined && object.root !== null) message.root = $8k8Xg.MerkleRoot.fromPartial(object.root);
        else message.root = undefined;
        if (object.nextValidatorsHash !== undefined && object.nextValidatorsHash !== null) message.nextValidatorsHash = object.nextValidatorsHash;
        else message.nextValidatorsHash = new Uint8Array();
        return message;
    }
};
const $9ef25f8c84398450$var$baseMisbehaviour = {
    clientId: ""
};
module.exports.Misbehaviour = {
    encode (message, writer = $9ef25f8c84398450$var$minimal_1.default.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.header1 !== undefined) module.exports.Header.encode(message.header1, writer.uint32(18).fork()).ldelim();
        if (message.header2 !== undefined) module.exports.Header.encode(message.header2, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9ef25f8c84398450$var$minimal_1.default.Reader ? input : new $9ef25f8c84398450$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9ef25f8c84398450$var$baseMisbehaviour);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.header1 = module.exports.Header.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.header2 = module.exports.Header.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9ef25f8c84398450$var$baseMisbehaviour);
        if (object.clientId !== undefined && object.clientId !== null) message.clientId = String(object.clientId);
        else message.clientId = "";
        if (object.header1 !== undefined && object.header1 !== null) message.header1 = module.exports.Header.fromJSON(object.header1);
        else message.header1 = undefined;
        if (object.header2 !== undefined && object.header2 !== null) message.header2 = module.exports.Header.fromJSON(object.header2);
        else message.header2 = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.header1 !== undefined && (obj.header1 = message.header1 ? module.exports.Header.toJSON(message.header1) : undefined);
        message.header2 !== undefined && (obj.header2 = message.header2 ? module.exports.Header.toJSON(message.header2) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9ef25f8c84398450$var$baseMisbehaviour);
        if (object.clientId !== undefined && object.clientId !== null) message.clientId = object.clientId;
        else message.clientId = "";
        if (object.header1 !== undefined && object.header1 !== null) message.header1 = module.exports.Header.fromPartial(object.header1);
        else message.header1 = undefined;
        if (object.header2 !== undefined && object.header2 !== null) message.header2 = module.exports.Header.fromPartial(object.header2);
        else message.header2 = undefined;
        return message;
    }
};
const $9ef25f8c84398450$var$baseHeader = {};
module.exports.Header = {
    encode (message, writer = $9ef25f8c84398450$var$minimal_1.default.Writer.create()) {
        if (message.signedHeader !== undefined) $djDW6.SignedHeader.encode(message.signedHeader, writer.uint32(10).fork()).ldelim();
        if (message.validatorSet !== undefined) $j77DS.ValidatorSet.encode(message.validatorSet, writer.uint32(18).fork()).ldelim();
        if (message.trustedHeight !== undefined) $yqmJM.Height.encode(message.trustedHeight, writer.uint32(26).fork()).ldelim();
        if (message.trustedValidators !== undefined) $j77DS.ValidatorSet.encode(message.trustedValidators, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9ef25f8c84398450$var$minimal_1.default.Reader ? input : new $9ef25f8c84398450$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9ef25f8c84398450$var$baseHeader);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signedHeader = $djDW6.SignedHeader.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.validatorSet = $j77DS.ValidatorSet.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.trustedHeight = $yqmJM.Height.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.trustedValidators = $j77DS.ValidatorSet.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9ef25f8c84398450$var$baseHeader);
        if (object.signedHeader !== undefined && object.signedHeader !== null) message.signedHeader = $djDW6.SignedHeader.fromJSON(object.signedHeader);
        else message.signedHeader = undefined;
        if (object.validatorSet !== undefined && object.validatorSet !== null) message.validatorSet = $j77DS.ValidatorSet.fromJSON(object.validatorSet);
        else message.validatorSet = undefined;
        if (object.trustedHeight !== undefined && object.trustedHeight !== null) message.trustedHeight = $yqmJM.Height.fromJSON(object.trustedHeight);
        else message.trustedHeight = undefined;
        if (object.trustedValidators !== undefined && object.trustedValidators !== null) message.trustedValidators = $j77DS.ValidatorSet.fromJSON(object.trustedValidators);
        else message.trustedValidators = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.signedHeader !== undefined && (obj.signedHeader = message.signedHeader ? $djDW6.SignedHeader.toJSON(message.signedHeader) : undefined);
        message.validatorSet !== undefined && (obj.validatorSet = message.validatorSet ? $j77DS.ValidatorSet.toJSON(message.validatorSet) : undefined);
        message.trustedHeight !== undefined && (obj.trustedHeight = message.trustedHeight ? $yqmJM.Height.toJSON(message.trustedHeight) : undefined);
        message.trustedValidators !== undefined && (obj.trustedValidators = message.trustedValidators ? $j77DS.ValidatorSet.toJSON(message.trustedValidators) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9ef25f8c84398450$var$baseHeader);
        if (object.signedHeader !== undefined && object.signedHeader !== null) message.signedHeader = $djDW6.SignedHeader.fromPartial(object.signedHeader);
        else message.signedHeader = undefined;
        if (object.validatorSet !== undefined && object.validatorSet !== null) message.validatorSet = $j77DS.ValidatorSet.fromPartial(object.validatorSet);
        else message.validatorSet = undefined;
        if (object.trustedHeight !== undefined && object.trustedHeight !== null) message.trustedHeight = $yqmJM.Height.fromPartial(object.trustedHeight);
        else message.trustedHeight = undefined;
        if (object.trustedValidators !== undefined && object.trustedValidators !== null) message.trustedValidators = $j77DS.ValidatorSet.fromPartial(object.trustedValidators);
        else message.trustedValidators = undefined;
        return message;
    }
};
const $9ef25f8c84398450$var$baseFraction = {
    numerator: $9ef25f8c84398450$var$long_1.default.UZERO,
    denominator: $9ef25f8c84398450$var$long_1.default.UZERO
};
module.exports.Fraction = {
    encode (message, writer = $9ef25f8c84398450$var$minimal_1.default.Writer.create()) {
        if (!message.numerator.isZero()) writer.uint32(8).uint64(message.numerator);
        if (!message.denominator.isZero()) writer.uint32(16).uint64(message.denominator);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9ef25f8c84398450$var$minimal_1.default.Reader ? input : new $9ef25f8c84398450$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9ef25f8c84398450$var$baseFraction);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.numerator = reader.uint64();
                    break;
                case 2:
                    message.denominator = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9ef25f8c84398450$var$baseFraction);
        if (object.numerator !== undefined && object.numerator !== null) message.numerator = $9ef25f8c84398450$var$long_1.default.fromString(object.numerator);
        else message.numerator = $9ef25f8c84398450$var$long_1.default.UZERO;
        if (object.denominator !== undefined && object.denominator !== null) message.denominator = $9ef25f8c84398450$var$long_1.default.fromString(object.denominator);
        else message.denominator = $9ef25f8c84398450$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.numerator !== undefined && (obj.numerator = (message.numerator || $9ef25f8c84398450$var$long_1.default.UZERO).toString());
        message.denominator !== undefined && (obj.denominator = (message.denominator || $9ef25f8c84398450$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9ef25f8c84398450$var$baseFraction);
        if (object.numerator !== undefined && object.numerator !== null) message.numerator = object.numerator;
        else message.numerator = $9ef25f8c84398450$var$long_1.default.UZERO;
        if (object.denominator !== undefined && object.denominator !== null) message.denominator = object.denominator;
        else message.denominator = $9ef25f8c84398450$var$long_1.default.UZERO;
        return message;
    }
};
var $9ef25f8c84398450$var$globalThis = (()=>{
    if (typeof $9ef25f8c84398450$var$globalThis !== "undefined") return $9ef25f8c84398450$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $9ef25f8c84398450$var$atob = $9ef25f8c84398450$var$globalThis.atob || ((b64)=>$9ef25f8c84398450$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $9ef25f8c84398450$var$bytesFromBase64(b64) {
    const bin = $9ef25f8c84398450$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $9ef25f8c84398450$var$btoa = $9ef25f8c84398450$var$globalThis.btoa || ((bin)=>$9ef25f8c84398450$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $9ef25f8c84398450$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $9ef25f8c84398450$var$btoa(bin.join(""));
}
function $9ef25f8c84398450$var$toTimestamp(date) {
    const seconds = $9ef25f8c84398450$var$numberToLong(date.getTime() / 1000);
    const nanos = date.getTime() % 1000 * 1000000;
    return {
        seconds: seconds,
        nanos: nanos
    };
}
function $9ef25f8c84398450$var$fromTimestamp(t) {
    let millis = t.seconds.toNumber() * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function $9ef25f8c84398450$var$fromJsonTimestamp(o) {
    if (o instanceof Date) return o;
    else if (typeof o === "string") return new Date(o);
    else return $9ef25f8c84398450$var$fromTimestamp($5G2s6.Timestamp.fromJSON(o));
}
function $9ef25f8c84398450$var$numberToLong(number) {
    return $9ef25f8c84398450$var$long_1.default.fromNumber(number);
}
if ($9ef25f8c84398450$var$minimal_1.default.util.Long !== $9ef25f8c84398450$var$long_1.default) {
    $9ef25f8c84398450$var$minimal_1.default.util.Long = $9ef25f8c84398450$var$long_1.default;
    $9ef25f8c84398450$var$minimal_1.default.configure();
}

});
parcelRegister("8k8Xg", function(module, exports) {
"use strict";
var $60f7233719a1902c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MerkleProof = module.exports.MerklePath = module.exports.MerklePrefix = module.exports.MerkleRoot = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $60f7233719a1902c$var$long_1 = $60f7233719a1902c$var$__importDefault((parcelRequire("9A55m")));

const $60f7233719a1902c$var$minimal_1 = $60f7233719a1902c$var$__importDefault((parcelRequire("i2pIU")));

var $9nV5P = parcelRequire("9nV5P");
module.exports.protobufPackage = "ibc.core.commitment.v1";
const $60f7233719a1902c$var$baseMerkleRoot = {};
module.exports.MerkleRoot = {
    encode (message, writer = $60f7233719a1902c$var$minimal_1.default.Writer.create()) {
        if (message.hash.length !== 0) writer.uint32(10).bytes(message.hash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $60f7233719a1902c$var$minimal_1.default.Reader ? input : new $60f7233719a1902c$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $60f7233719a1902c$var$baseMerkleRoot);
        message.hash = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $60f7233719a1902c$var$baseMerkleRoot);
        message.hash = new Uint8Array();
        if (object.hash !== undefined && object.hash !== null) message.hash = $60f7233719a1902c$var$bytesFromBase64(object.hash);
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = $60f7233719a1902c$var$base64FromBytes(message.hash !== undefined ? message.hash : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $60f7233719a1902c$var$baseMerkleRoot);
        if (object.hash !== undefined && object.hash !== null) message.hash = object.hash;
        else message.hash = new Uint8Array();
        return message;
    }
};
const $60f7233719a1902c$var$baseMerklePrefix = {};
module.exports.MerklePrefix = {
    encode (message, writer = $60f7233719a1902c$var$minimal_1.default.Writer.create()) {
        if (message.keyPrefix.length !== 0) writer.uint32(10).bytes(message.keyPrefix);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $60f7233719a1902c$var$minimal_1.default.Reader ? input : new $60f7233719a1902c$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $60f7233719a1902c$var$baseMerklePrefix);
        message.keyPrefix = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.keyPrefix = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $60f7233719a1902c$var$baseMerklePrefix);
        message.keyPrefix = new Uint8Array();
        if (object.keyPrefix !== undefined && object.keyPrefix !== null) message.keyPrefix = $60f7233719a1902c$var$bytesFromBase64(object.keyPrefix);
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.keyPrefix !== undefined && (obj.keyPrefix = $60f7233719a1902c$var$base64FromBytes(message.keyPrefix !== undefined ? message.keyPrefix : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $60f7233719a1902c$var$baseMerklePrefix);
        if (object.keyPrefix !== undefined && object.keyPrefix !== null) message.keyPrefix = object.keyPrefix;
        else message.keyPrefix = new Uint8Array();
        return message;
    }
};
const $60f7233719a1902c$var$baseMerklePath = {
    keyPath: ""
};
module.exports.MerklePath = {
    encode (message, writer = $60f7233719a1902c$var$minimal_1.default.Writer.create()) {
        for (const v of message.keyPath)writer.uint32(10).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $60f7233719a1902c$var$minimal_1.default.Reader ? input : new $60f7233719a1902c$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $60f7233719a1902c$var$baseMerklePath);
        message.keyPath = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.keyPath.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $60f7233719a1902c$var$baseMerklePath);
        message.keyPath = [];
        if (object.keyPath !== undefined && object.keyPath !== null) for (const e of object.keyPath)message.keyPath.push(String(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.keyPath) obj.keyPath = message.keyPath.map((e)=>e);
        else obj.keyPath = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $60f7233719a1902c$var$baseMerklePath);
        message.keyPath = [];
        if (object.keyPath !== undefined && object.keyPath !== null) for (const e of object.keyPath)message.keyPath.push(e);
        return message;
    }
};
const $60f7233719a1902c$var$baseMerkleProof = {};
module.exports.MerkleProof = {
    encode (message, writer = $60f7233719a1902c$var$minimal_1.default.Writer.create()) {
        for (const v of message.proofs)$9nV5P.CommitmentProof.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $60f7233719a1902c$var$minimal_1.default.Reader ? input : new $60f7233719a1902c$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $60f7233719a1902c$var$baseMerkleProof);
        message.proofs = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proofs.push($9nV5P.CommitmentProof.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $60f7233719a1902c$var$baseMerkleProof);
        message.proofs = [];
        if (object.proofs !== undefined && object.proofs !== null) for (const e of object.proofs)message.proofs.push($9nV5P.CommitmentProof.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.proofs) obj.proofs = message.proofs.map((e)=>e ? $9nV5P.CommitmentProof.toJSON(e) : undefined);
        else obj.proofs = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $60f7233719a1902c$var$baseMerkleProof);
        message.proofs = [];
        if (object.proofs !== undefined && object.proofs !== null) for (const e of object.proofs)message.proofs.push($9nV5P.CommitmentProof.fromPartial(e));
        return message;
    }
};
var $60f7233719a1902c$var$globalThis = (()=>{
    if (typeof $60f7233719a1902c$var$globalThis !== "undefined") return $60f7233719a1902c$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $60f7233719a1902c$var$atob = $60f7233719a1902c$var$globalThis.atob || ((b64)=>$60f7233719a1902c$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $60f7233719a1902c$var$bytesFromBase64(b64) {
    const bin = $60f7233719a1902c$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $60f7233719a1902c$var$btoa = $60f7233719a1902c$var$globalThis.btoa || ((bin)=>$60f7233719a1902c$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $60f7233719a1902c$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $60f7233719a1902c$var$btoa(bin.join(""));
}
if ($60f7233719a1902c$var$minimal_1.default.util.Long !== $60f7233719a1902c$var$long_1.default) {
    $60f7233719a1902c$var$minimal_1.default.util.Long = $60f7233719a1902c$var$long_1.default;
    $60f7233719a1902c$var$minimal_1.default.configure();
}

});
parcelRegister("9nV5P", function(module, exports) {
"use strict";
var $6d528c824c1b43cf$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CompressedNonExistenceProof = module.exports.CompressedExistenceProof = module.exports.CompressedBatchEntry = module.exports.CompressedBatchProof = module.exports.BatchEntry = module.exports.BatchProof = module.exports.InnerSpec = module.exports.ProofSpec = module.exports.InnerOp = module.exports.LeafOp = module.exports.CommitmentProof = module.exports.NonExistenceProof = module.exports.ExistenceProof = module.exports.lengthOpToJSON = module.exports.lengthOpFromJSON = module.exports.LengthOp = module.exports.hashOpToJSON = module.exports.hashOpFromJSON = module.exports.HashOp = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $6d528c824c1b43cf$var$long_1 = $6d528c824c1b43cf$var$__importDefault((parcelRequire("9A55m")));

const $6d528c824c1b43cf$var$minimal_1 = $6d528c824c1b43cf$var$__importDefault((parcelRequire("i2pIU")));
module.exports.protobufPackage = "ics23";
var $6d528c824c1b43cf$var$HashOp;
(function(HashOp) {
    /** NO_HASH - NO_HASH is the default if no data passed. Note this is an illegal argument some places. */ HashOp[HashOp["NO_HASH"] = 0] = "NO_HASH";
    HashOp[HashOp["SHA256"] = 1] = "SHA256";
    HashOp[HashOp["SHA512"] = 2] = "SHA512";
    HashOp[HashOp["KECCAK"] = 3] = "KECCAK";
    HashOp[HashOp["RIPEMD160"] = 4] = "RIPEMD160";
    /** BITCOIN - ripemd160(sha256(x)) */ HashOp[HashOp["BITCOIN"] = 5] = "BITCOIN";
    HashOp[HashOp["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($6d528c824c1b43cf$var$HashOp = module.exports.HashOp || (module.exports.HashOp = {}));
function $6d528c824c1b43cf$var$hashOpFromJSON(object) {
    switch(object){
        case 0:
        case "NO_HASH":
            return $6d528c824c1b43cf$var$HashOp.NO_HASH;
        case 1:
        case "SHA256":
            return $6d528c824c1b43cf$var$HashOp.SHA256;
        case 2:
        case "SHA512":
            return $6d528c824c1b43cf$var$HashOp.SHA512;
        case 3:
        case "KECCAK":
            return $6d528c824c1b43cf$var$HashOp.KECCAK;
        case 4:
        case "RIPEMD160":
            return $6d528c824c1b43cf$var$HashOp.RIPEMD160;
        case 5:
        case "BITCOIN":
            return $6d528c824c1b43cf$var$HashOp.BITCOIN;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $6d528c824c1b43cf$var$HashOp.UNRECOGNIZED;
    }
}
module.exports.hashOpFromJSON = $6d528c824c1b43cf$var$hashOpFromJSON;
function $6d528c824c1b43cf$var$hashOpToJSON(object) {
    switch(object){
        case $6d528c824c1b43cf$var$HashOp.NO_HASH:
            return "NO_HASH";
        case $6d528c824c1b43cf$var$HashOp.SHA256:
            return "SHA256";
        case $6d528c824c1b43cf$var$HashOp.SHA512:
            return "SHA512";
        case $6d528c824c1b43cf$var$HashOp.KECCAK:
            return "KECCAK";
        case $6d528c824c1b43cf$var$HashOp.RIPEMD160:
            return "RIPEMD160";
        case $6d528c824c1b43cf$var$HashOp.BITCOIN:
            return "BITCOIN";
        default:
            return "UNKNOWN";
    }
}
module.exports.hashOpToJSON = $6d528c824c1b43cf$var$hashOpToJSON;
/**
 * LengthOp defines how to process the key and value of the LeafOp
 * to include length information. After encoding the length with the given
 * algorithm, the length will be prepended to the key and value bytes.
 * (Each one with it's own encoded length)
 */ var $6d528c824c1b43cf$var$LengthOp;
(function(LengthOp) {
    /** NO_PREFIX - NO_PREFIX don't include any length info */ LengthOp[LengthOp["NO_PREFIX"] = 0] = "NO_PREFIX";
    /** VAR_PROTO - VAR_PROTO uses protobuf (and go-amino) varint encoding of the length */ LengthOp[LengthOp["VAR_PROTO"] = 1] = "VAR_PROTO";
    /** VAR_RLP - VAR_RLP uses rlp int encoding of the length */ LengthOp[LengthOp["VAR_RLP"] = 2] = "VAR_RLP";
    /** FIXED32_BIG - FIXED32_BIG uses big-endian encoding of the length as a 32 bit integer */ LengthOp[LengthOp["FIXED32_BIG"] = 3] = "FIXED32_BIG";
    /** FIXED32_LITTLE - FIXED32_LITTLE uses little-endian encoding of the length as a 32 bit integer */ LengthOp[LengthOp["FIXED32_LITTLE"] = 4] = "FIXED32_LITTLE";
    /** FIXED64_BIG - FIXED64_BIG uses big-endian encoding of the length as a 64 bit integer */ LengthOp[LengthOp["FIXED64_BIG"] = 5] = "FIXED64_BIG";
    /** FIXED64_LITTLE - FIXED64_LITTLE uses little-endian encoding of the length as a 64 bit integer */ LengthOp[LengthOp["FIXED64_LITTLE"] = 6] = "FIXED64_LITTLE";
    /** REQUIRE_32_BYTES - REQUIRE_32_BYTES is like NONE, but will fail if the input is not exactly 32 bytes (sha256 output) */ LengthOp[LengthOp["REQUIRE_32_BYTES"] = 7] = "REQUIRE_32_BYTES";
    /** REQUIRE_64_BYTES - REQUIRE_64_BYTES is like NONE, but will fail if the input is not exactly 64 bytes (sha512 output) */ LengthOp[LengthOp["REQUIRE_64_BYTES"] = 8] = "REQUIRE_64_BYTES";
    LengthOp[LengthOp["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($6d528c824c1b43cf$var$LengthOp = module.exports.LengthOp || (module.exports.LengthOp = {}));
function $6d528c824c1b43cf$var$lengthOpFromJSON(object) {
    switch(object){
        case 0:
        case "NO_PREFIX":
            return $6d528c824c1b43cf$var$LengthOp.NO_PREFIX;
        case 1:
        case "VAR_PROTO":
            return $6d528c824c1b43cf$var$LengthOp.VAR_PROTO;
        case 2:
        case "VAR_RLP":
            return $6d528c824c1b43cf$var$LengthOp.VAR_RLP;
        case 3:
        case "FIXED32_BIG":
            return $6d528c824c1b43cf$var$LengthOp.FIXED32_BIG;
        case 4:
        case "FIXED32_LITTLE":
            return $6d528c824c1b43cf$var$LengthOp.FIXED32_LITTLE;
        case 5:
        case "FIXED64_BIG":
            return $6d528c824c1b43cf$var$LengthOp.FIXED64_BIG;
        case 6:
        case "FIXED64_LITTLE":
            return $6d528c824c1b43cf$var$LengthOp.FIXED64_LITTLE;
        case 7:
        case "REQUIRE_32_BYTES":
            return $6d528c824c1b43cf$var$LengthOp.REQUIRE_32_BYTES;
        case 8:
        case "REQUIRE_64_BYTES":
            return $6d528c824c1b43cf$var$LengthOp.REQUIRE_64_BYTES;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $6d528c824c1b43cf$var$LengthOp.UNRECOGNIZED;
    }
}
module.exports.lengthOpFromJSON = $6d528c824c1b43cf$var$lengthOpFromJSON;
function $6d528c824c1b43cf$var$lengthOpToJSON(object) {
    switch(object){
        case $6d528c824c1b43cf$var$LengthOp.NO_PREFIX:
            return "NO_PREFIX";
        case $6d528c824c1b43cf$var$LengthOp.VAR_PROTO:
            return "VAR_PROTO";
        case $6d528c824c1b43cf$var$LengthOp.VAR_RLP:
            return "VAR_RLP";
        case $6d528c824c1b43cf$var$LengthOp.FIXED32_BIG:
            return "FIXED32_BIG";
        case $6d528c824c1b43cf$var$LengthOp.FIXED32_LITTLE:
            return "FIXED32_LITTLE";
        case $6d528c824c1b43cf$var$LengthOp.FIXED64_BIG:
            return "FIXED64_BIG";
        case $6d528c824c1b43cf$var$LengthOp.FIXED64_LITTLE:
            return "FIXED64_LITTLE";
        case $6d528c824c1b43cf$var$LengthOp.REQUIRE_32_BYTES:
            return "REQUIRE_32_BYTES";
        case $6d528c824c1b43cf$var$LengthOp.REQUIRE_64_BYTES:
            return "REQUIRE_64_BYTES";
        default:
            return "UNKNOWN";
    }
}
module.exports.lengthOpToJSON = $6d528c824c1b43cf$var$lengthOpToJSON;
const $6d528c824c1b43cf$var$baseExistenceProof = {};
module.exports.ExistenceProof = {
    encode (message, writer = $6d528c824c1b43cf$var$minimal_1.default.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (message.value.length !== 0) writer.uint32(18).bytes(message.value);
        if (message.leaf !== undefined) module.exports.LeafOp.encode(message.leaf, writer.uint32(26).fork()).ldelim();
        for (const v of message.path)module.exports.InnerOp.encode(v, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6d528c824c1b43cf$var$minimal_1.default.Reader ? input : new $6d528c824c1b43cf$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $6d528c824c1b43cf$var$baseExistenceProof);
        message.path = [];
        message.key = new Uint8Array();
        message.value = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.value = reader.bytes();
                    break;
                case 3:
                    message.leaf = module.exports.LeafOp.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.path.push(module.exports.InnerOp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $6d528c824c1b43cf$var$baseExistenceProof);
        message.path = [];
        message.key = new Uint8Array();
        message.value = new Uint8Array();
        if (object.key !== undefined && object.key !== null) message.key = $6d528c824c1b43cf$var$bytesFromBase64(object.key);
        if (object.value !== undefined && object.value !== null) message.value = $6d528c824c1b43cf$var$bytesFromBase64(object.value);
        if (object.leaf !== undefined && object.leaf !== null) message.leaf = module.exports.LeafOp.fromJSON(object.leaf);
        else message.leaf = undefined;
        if (object.path !== undefined && object.path !== null) for (const e of object.path)message.path.push(module.exports.InnerOp.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = $6d528c824c1b43cf$var$base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        message.value !== undefined && (obj.value = $6d528c824c1b43cf$var$base64FromBytes(message.value !== undefined ? message.value : new Uint8Array()));
        message.leaf !== undefined && (obj.leaf = message.leaf ? module.exports.LeafOp.toJSON(message.leaf) : undefined);
        if (message.path) obj.path = message.path.map((e)=>e ? module.exports.InnerOp.toJSON(e) : undefined);
        else obj.path = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $6d528c824c1b43cf$var$baseExistenceProof);
        message.path = [];
        if (object.key !== undefined && object.key !== null) message.key = object.key;
        else message.key = new Uint8Array();
        if (object.value !== undefined && object.value !== null) message.value = object.value;
        else message.value = new Uint8Array();
        if (object.leaf !== undefined && object.leaf !== null) message.leaf = module.exports.LeafOp.fromPartial(object.leaf);
        else message.leaf = undefined;
        if (object.path !== undefined && object.path !== null) for (const e of object.path)message.path.push(module.exports.InnerOp.fromPartial(e));
        return message;
    }
};
const $6d528c824c1b43cf$var$baseNonExistenceProof = {};
module.exports.NonExistenceProof = {
    encode (message, writer = $6d528c824c1b43cf$var$minimal_1.default.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (message.left !== undefined) module.exports.ExistenceProof.encode(message.left, writer.uint32(18).fork()).ldelim();
        if (message.right !== undefined) module.exports.ExistenceProof.encode(message.right, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6d528c824c1b43cf$var$minimal_1.default.Reader ? input : new $6d528c824c1b43cf$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $6d528c824c1b43cf$var$baseNonExistenceProof);
        message.key = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.left = module.exports.ExistenceProof.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.right = module.exports.ExistenceProof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $6d528c824c1b43cf$var$baseNonExistenceProof);
        message.key = new Uint8Array();
        if (object.key !== undefined && object.key !== null) message.key = $6d528c824c1b43cf$var$bytesFromBase64(object.key);
        if (object.left !== undefined && object.left !== null) message.left = module.exports.ExistenceProof.fromJSON(object.left);
        else message.left = undefined;
        if (object.right !== undefined && object.right !== null) message.right = module.exports.ExistenceProof.fromJSON(object.right);
        else message.right = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = $6d528c824c1b43cf$var$base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        message.left !== undefined && (obj.left = message.left ? module.exports.ExistenceProof.toJSON(message.left) : undefined);
        message.right !== undefined && (obj.right = message.right ? module.exports.ExistenceProof.toJSON(message.right) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $6d528c824c1b43cf$var$baseNonExistenceProof);
        if (object.key !== undefined && object.key !== null) message.key = object.key;
        else message.key = new Uint8Array();
        if (object.left !== undefined && object.left !== null) message.left = module.exports.ExistenceProof.fromPartial(object.left);
        else message.left = undefined;
        if (object.right !== undefined && object.right !== null) message.right = module.exports.ExistenceProof.fromPartial(object.right);
        else message.right = undefined;
        return message;
    }
};
const $6d528c824c1b43cf$var$baseCommitmentProof = {};
module.exports.CommitmentProof = {
    encode (message, writer = $6d528c824c1b43cf$var$minimal_1.default.Writer.create()) {
        if (message.exist !== undefined) module.exports.ExistenceProof.encode(message.exist, writer.uint32(10).fork()).ldelim();
        if (message.nonexist !== undefined) module.exports.NonExistenceProof.encode(message.nonexist, writer.uint32(18).fork()).ldelim();
        if (message.batch !== undefined) module.exports.BatchProof.encode(message.batch, writer.uint32(26).fork()).ldelim();
        if (message.compressed !== undefined) module.exports.CompressedBatchProof.encode(message.compressed, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6d528c824c1b43cf$var$minimal_1.default.Reader ? input : new $6d528c824c1b43cf$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $6d528c824c1b43cf$var$baseCommitmentProof);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.exist = module.exports.ExistenceProof.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.nonexist = module.exports.NonExistenceProof.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.batch = module.exports.BatchProof.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.compressed = module.exports.CompressedBatchProof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $6d528c824c1b43cf$var$baseCommitmentProof);
        if (object.exist !== undefined && object.exist !== null) message.exist = module.exports.ExistenceProof.fromJSON(object.exist);
        else message.exist = undefined;
        if (object.nonexist !== undefined && object.nonexist !== null) message.nonexist = module.exports.NonExistenceProof.fromJSON(object.nonexist);
        else message.nonexist = undefined;
        if (object.batch !== undefined && object.batch !== null) message.batch = module.exports.BatchProof.fromJSON(object.batch);
        else message.batch = undefined;
        if (object.compressed !== undefined && object.compressed !== null) message.compressed = module.exports.CompressedBatchProof.fromJSON(object.compressed);
        else message.compressed = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.exist !== undefined && (obj.exist = message.exist ? module.exports.ExistenceProof.toJSON(message.exist) : undefined);
        message.nonexist !== undefined && (obj.nonexist = message.nonexist ? module.exports.NonExistenceProof.toJSON(message.nonexist) : undefined);
        message.batch !== undefined && (obj.batch = message.batch ? module.exports.BatchProof.toJSON(message.batch) : undefined);
        message.compressed !== undefined && (obj.compressed = message.compressed ? module.exports.CompressedBatchProof.toJSON(message.compressed) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $6d528c824c1b43cf$var$baseCommitmentProof);
        if (object.exist !== undefined && object.exist !== null) message.exist = module.exports.ExistenceProof.fromPartial(object.exist);
        else message.exist = undefined;
        if (object.nonexist !== undefined && object.nonexist !== null) message.nonexist = module.exports.NonExistenceProof.fromPartial(object.nonexist);
        else message.nonexist = undefined;
        if (object.batch !== undefined && object.batch !== null) message.batch = module.exports.BatchProof.fromPartial(object.batch);
        else message.batch = undefined;
        if (object.compressed !== undefined && object.compressed !== null) message.compressed = module.exports.CompressedBatchProof.fromPartial(object.compressed);
        else message.compressed = undefined;
        return message;
    }
};
const $6d528c824c1b43cf$var$baseLeafOp = {
    hash: 0,
    prehashKey: 0,
    prehashValue: 0,
    length: 0
};
module.exports.LeafOp = {
    encode (message, writer = $6d528c824c1b43cf$var$minimal_1.default.Writer.create()) {
        if (message.hash !== 0) writer.uint32(8).int32(message.hash);
        if (message.prehashKey !== 0) writer.uint32(16).int32(message.prehashKey);
        if (message.prehashValue !== 0) writer.uint32(24).int32(message.prehashValue);
        if (message.length !== 0) writer.uint32(32).int32(message.length);
        if (message.prefix.length !== 0) writer.uint32(42).bytes(message.prefix);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6d528c824c1b43cf$var$minimal_1.default.Reader ? input : new $6d528c824c1b43cf$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $6d528c824c1b43cf$var$baseLeafOp);
        message.prefix = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.int32();
                    break;
                case 2:
                    message.prehashKey = reader.int32();
                    break;
                case 3:
                    message.prehashValue = reader.int32();
                    break;
                case 4:
                    message.length = reader.int32();
                    break;
                case 5:
                    message.prefix = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $6d528c824c1b43cf$var$baseLeafOp);
        message.prefix = new Uint8Array();
        if (object.hash !== undefined && object.hash !== null) message.hash = $6d528c824c1b43cf$var$hashOpFromJSON(object.hash);
        else message.hash = 0;
        if (object.prehashKey !== undefined && object.prehashKey !== null) message.prehashKey = $6d528c824c1b43cf$var$hashOpFromJSON(object.prehashKey);
        else message.prehashKey = 0;
        if (object.prehashValue !== undefined && object.prehashValue !== null) message.prehashValue = $6d528c824c1b43cf$var$hashOpFromJSON(object.prehashValue);
        else message.prehashValue = 0;
        if (object.length !== undefined && object.length !== null) message.length = $6d528c824c1b43cf$var$lengthOpFromJSON(object.length);
        else message.length = 0;
        if (object.prefix !== undefined && object.prefix !== null) message.prefix = $6d528c824c1b43cf$var$bytesFromBase64(object.prefix);
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = $6d528c824c1b43cf$var$hashOpToJSON(message.hash));
        message.prehashKey !== undefined && (obj.prehashKey = $6d528c824c1b43cf$var$hashOpToJSON(message.prehashKey));
        message.prehashValue !== undefined && (obj.prehashValue = $6d528c824c1b43cf$var$hashOpToJSON(message.prehashValue));
        message.length !== undefined && (obj.length = $6d528c824c1b43cf$var$lengthOpToJSON(message.length));
        message.prefix !== undefined && (obj.prefix = $6d528c824c1b43cf$var$base64FromBytes(message.prefix !== undefined ? message.prefix : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $6d528c824c1b43cf$var$baseLeafOp);
        if (object.hash !== undefined && object.hash !== null) message.hash = object.hash;
        else message.hash = 0;
        if (object.prehashKey !== undefined && object.prehashKey !== null) message.prehashKey = object.prehashKey;
        else message.prehashKey = 0;
        if (object.prehashValue !== undefined && object.prehashValue !== null) message.prehashValue = object.prehashValue;
        else message.prehashValue = 0;
        if (object.length !== undefined && object.length !== null) message.length = object.length;
        else message.length = 0;
        if (object.prefix !== undefined && object.prefix !== null) message.prefix = object.prefix;
        else message.prefix = new Uint8Array();
        return message;
    }
};
const $6d528c824c1b43cf$var$baseInnerOp = {
    hash: 0
};
module.exports.InnerOp = {
    encode (message, writer = $6d528c824c1b43cf$var$minimal_1.default.Writer.create()) {
        if (message.hash !== 0) writer.uint32(8).int32(message.hash);
        if (message.prefix.length !== 0) writer.uint32(18).bytes(message.prefix);
        if (message.suffix.length !== 0) writer.uint32(26).bytes(message.suffix);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6d528c824c1b43cf$var$minimal_1.default.Reader ? input : new $6d528c824c1b43cf$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $6d528c824c1b43cf$var$baseInnerOp);
        message.prefix = new Uint8Array();
        message.suffix = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.int32();
                    break;
                case 2:
                    message.prefix = reader.bytes();
                    break;
                case 3:
                    message.suffix = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $6d528c824c1b43cf$var$baseInnerOp);
        message.prefix = new Uint8Array();
        message.suffix = new Uint8Array();
        if (object.hash !== undefined && object.hash !== null) message.hash = $6d528c824c1b43cf$var$hashOpFromJSON(object.hash);
        else message.hash = 0;
        if (object.prefix !== undefined && object.prefix !== null) message.prefix = $6d528c824c1b43cf$var$bytesFromBase64(object.prefix);
        if (object.suffix !== undefined && object.suffix !== null) message.suffix = $6d528c824c1b43cf$var$bytesFromBase64(object.suffix);
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = $6d528c824c1b43cf$var$hashOpToJSON(message.hash));
        message.prefix !== undefined && (obj.prefix = $6d528c824c1b43cf$var$base64FromBytes(message.prefix !== undefined ? message.prefix : new Uint8Array()));
        message.suffix !== undefined && (obj.suffix = $6d528c824c1b43cf$var$base64FromBytes(message.suffix !== undefined ? message.suffix : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $6d528c824c1b43cf$var$baseInnerOp);
        if (object.hash !== undefined && object.hash !== null) message.hash = object.hash;
        else message.hash = 0;
        if (object.prefix !== undefined && object.prefix !== null) message.prefix = object.prefix;
        else message.prefix = new Uint8Array();
        if (object.suffix !== undefined && object.suffix !== null) message.suffix = object.suffix;
        else message.suffix = new Uint8Array();
        return message;
    }
};
const $6d528c824c1b43cf$var$baseProofSpec = {
    maxDepth: 0,
    minDepth: 0
};
module.exports.ProofSpec = {
    encode (message, writer = $6d528c824c1b43cf$var$minimal_1.default.Writer.create()) {
        if (message.leafSpec !== undefined) module.exports.LeafOp.encode(message.leafSpec, writer.uint32(10).fork()).ldelim();
        if (message.innerSpec !== undefined) module.exports.InnerSpec.encode(message.innerSpec, writer.uint32(18).fork()).ldelim();
        if (message.maxDepth !== 0) writer.uint32(24).int32(message.maxDepth);
        if (message.minDepth !== 0) writer.uint32(32).int32(message.minDepth);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6d528c824c1b43cf$var$minimal_1.default.Reader ? input : new $6d528c824c1b43cf$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $6d528c824c1b43cf$var$baseProofSpec);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.leafSpec = module.exports.LeafOp.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.innerSpec = module.exports.InnerSpec.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.maxDepth = reader.int32();
                    break;
                case 4:
                    message.minDepth = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $6d528c824c1b43cf$var$baseProofSpec);
        if (object.leafSpec !== undefined && object.leafSpec !== null) message.leafSpec = module.exports.LeafOp.fromJSON(object.leafSpec);
        else message.leafSpec = undefined;
        if (object.innerSpec !== undefined && object.innerSpec !== null) message.innerSpec = module.exports.InnerSpec.fromJSON(object.innerSpec);
        else message.innerSpec = undefined;
        if (object.maxDepth !== undefined && object.maxDepth !== null) message.maxDepth = Number(object.maxDepth);
        else message.maxDepth = 0;
        if (object.minDepth !== undefined && object.minDepth !== null) message.minDepth = Number(object.minDepth);
        else message.minDepth = 0;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.leafSpec !== undefined && (obj.leafSpec = message.leafSpec ? module.exports.LeafOp.toJSON(message.leafSpec) : undefined);
        message.innerSpec !== undefined && (obj.innerSpec = message.innerSpec ? module.exports.InnerSpec.toJSON(message.innerSpec) : undefined);
        message.maxDepth !== undefined && (obj.maxDepth = message.maxDepth);
        message.minDepth !== undefined && (obj.minDepth = message.minDepth);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $6d528c824c1b43cf$var$baseProofSpec);
        if (object.leafSpec !== undefined && object.leafSpec !== null) message.leafSpec = module.exports.LeafOp.fromPartial(object.leafSpec);
        else message.leafSpec = undefined;
        if (object.innerSpec !== undefined && object.innerSpec !== null) message.innerSpec = module.exports.InnerSpec.fromPartial(object.innerSpec);
        else message.innerSpec = undefined;
        if (object.maxDepth !== undefined && object.maxDepth !== null) message.maxDepth = object.maxDepth;
        else message.maxDepth = 0;
        if (object.minDepth !== undefined && object.minDepth !== null) message.minDepth = object.minDepth;
        else message.minDepth = 0;
        return message;
    }
};
const $6d528c824c1b43cf$var$baseInnerSpec = {
    childOrder: 0,
    childSize: 0,
    minPrefixLength: 0,
    maxPrefixLength: 0,
    hash: 0
};
module.exports.InnerSpec = {
    encode (message, writer = $6d528c824c1b43cf$var$minimal_1.default.Writer.create()) {
        writer.uint32(10).fork();
        for (const v of message.childOrder)writer.int32(v);
        writer.ldelim();
        if (message.childSize !== 0) writer.uint32(16).int32(message.childSize);
        if (message.minPrefixLength !== 0) writer.uint32(24).int32(message.minPrefixLength);
        if (message.maxPrefixLength !== 0) writer.uint32(32).int32(message.maxPrefixLength);
        if (message.emptyChild.length !== 0) writer.uint32(42).bytes(message.emptyChild);
        if (message.hash !== 0) writer.uint32(48).int32(message.hash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6d528c824c1b43cf$var$minimal_1.default.Reader ? input : new $6d528c824c1b43cf$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $6d528c824c1b43cf$var$baseInnerSpec);
        message.childOrder = [];
        message.emptyChild = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.childOrder.push(reader.int32());
                    } else message.childOrder.push(reader.int32());
                    break;
                case 2:
                    message.childSize = reader.int32();
                    break;
                case 3:
                    message.minPrefixLength = reader.int32();
                    break;
                case 4:
                    message.maxPrefixLength = reader.int32();
                    break;
                case 5:
                    message.emptyChild = reader.bytes();
                    break;
                case 6:
                    message.hash = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $6d528c824c1b43cf$var$baseInnerSpec);
        message.childOrder = [];
        message.emptyChild = new Uint8Array();
        if (object.childOrder !== undefined && object.childOrder !== null) for (const e of object.childOrder)message.childOrder.push(Number(e));
        if (object.childSize !== undefined && object.childSize !== null) message.childSize = Number(object.childSize);
        else message.childSize = 0;
        if (object.minPrefixLength !== undefined && object.minPrefixLength !== null) message.minPrefixLength = Number(object.minPrefixLength);
        else message.minPrefixLength = 0;
        if (object.maxPrefixLength !== undefined && object.maxPrefixLength !== null) message.maxPrefixLength = Number(object.maxPrefixLength);
        else message.maxPrefixLength = 0;
        if (object.emptyChild !== undefined && object.emptyChild !== null) message.emptyChild = $6d528c824c1b43cf$var$bytesFromBase64(object.emptyChild);
        if (object.hash !== undefined && object.hash !== null) message.hash = $6d528c824c1b43cf$var$hashOpFromJSON(object.hash);
        else message.hash = 0;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.childOrder) obj.childOrder = message.childOrder.map((e)=>e);
        else obj.childOrder = [];
        message.childSize !== undefined && (obj.childSize = message.childSize);
        message.minPrefixLength !== undefined && (obj.minPrefixLength = message.minPrefixLength);
        message.maxPrefixLength !== undefined && (obj.maxPrefixLength = message.maxPrefixLength);
        message.emptyChild !== undefined && (obj.emptyChild = $6d528c824c1b43cf$var$base64FromBytes(message.emptyChild !== undefined ? message.emptyChild : new Uint8Array()));
        message.hash !== undefined && (obj.hash = $6d528c824c1b43cf$var$hashOpToJSON(message.hash));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $6d528c824c1b43cf$var$baseInnerSpec);
        message.childOrder = [];
        if (object.childOrder !== undefined && object.childOrder !== null) for (const e of object.childOrder)message.childOrder.push(e);
        if (object.childSize !== undefined && object.childSize !== null) message.childSize = object.childSize;
        else message.childSize = 0;
        if (object.minPrefixLength !== undefined && object.minPrefixLength !== null) message.minPrefixLength = object.minPrefixLength;
        else message.minPrefixLength = 0;
        if (object.maxPrefixLength !== undefined && object.maxPrefixLength !== null) message.maxPrefixLength = object.maxPrefixLength;
        else message.maxPrefixLength = 0;
        if (object.emptyChild !== undefined && object.emptyChild !== null) message.emptyChild = object.emptyChild;
        else message.emptyChild = new Uint8Array();
        if (object.hash !== undefined && object.hash !== null) message.hash = object.hash;
        else message.hash = 0;
        return message;
    }
};
const $6d528c824c1b43cf$var$baseBatchProof = {};
module.exports.BatchProof = {
    encode (message, writer = $6d528c824c1b43cf$var$minimal_1.default.Writer.create()) {
        for (const v of message.entries)module.exports.BatchEntry.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6d528c824c1b43cf$var$minimal_1.default.Reader ? input : new $6d528c824c1b43cf$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $6d528c824c1b43cf$var$baseBatchProof);
        message.entries = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.entries.push(module.exports.BatchEntry.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $6d528c824c1b43cf$var$baseBatchProof);
        message.entries = [];
        if (object.entries !== undefined && object.entries !== null) for (const e of object.entries)message.entries.push(module.exports.BatchEntry.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.entries) obj.entries = message.entries.map((e)=>e ? module.exports.BatchEntry.toJSON(e) : undefined);
        else obj.entries = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $6d528c824c1b43cf$var$baseBatchProof);
        message.entries = [];
        if (object.entries !== undefined && object.entries !== null) for (const e of object.entries)message.entries.push(module.exports.BatchEntry.fromPartial(e));
        return message;
    }
};
const $6d528c824c1b43cf$var$baseBatchEntry = {};
module.exports.BatchEntry = {
    encode (message, writer = $6d528c824c1b43cf$var$minimal_1.default.Writer.create()) {
        if (message.exist !== undefined) module.exports.ExistenceProof.encode(message.exist, writer.uint32(10).fork()).ldelim();
        if (message.nonexist !== undefined) module.exports.NonExistenceProof.encode(message.nonexist, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6d528c824c1b43cf$var$minimal_1.default.Reader ? input : new $6d528c824c1b43cf$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $6d528c824c1b43cf$var$baseBatchEntry);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.exist = module.exports.ExistenceProof.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.nonexist = module.exports.NonExistenceProof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $6d528c824c1b43cf$var$baseBatchEntry);
        if (object.exist !== undefined && object.exist !== null) message.exist = module.exports.ExistenceProof.fromJSON(object.exist);
        else message.exist = undefined;
        if (object.nonexist !== undefined && object.nonexist !== null) message.nonexist = module.exports.NonExistenceProof.fromJSON(object.nonexist);
        else message.nonexist = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.exist !== undefined && (obj.exist = message.exist ? module.exports.ExistenceProof.toJSON(message.exist) : undefined);
        message.nonexist !== undefined && (obj.nonexist = message.nonexist ? module.exports.NonExistenceProof.toJSON(message.nonexist) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $6d528c824c1b43cf$var$baseBatchEntry);
        if (object.exist !== undefined && object.exist !== null) message.exist = module.exports.ExistenceProof.fromPartial(object.exist);
        else message.exist = undefined;
        if (object.nonexist !== undefined && object.nonexist !== null) message.nonexist = module.exports.NonExistenceProof.fromPartial(object.nonexist);
        else message.nonexist = undefined;
        return message;
    }
};
const $6d528c824c1b43cf$var$baseCompressedBatchProof = {};
module.exports.CompressedBatchProof = {
    encode (message, writer = $6d528c824c1b43cf$var$minimal_1.default.Writer.create()) {
        for (const v of message.entries)module.exports.CompressedBatchEntry.encode(v, writer.uint32(10).fork()).ldelim();
        for (const v of message.lookupInners)module.exports.InnerOp.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6d528c824c1b43cf$var$minimal_1.default.Reader ? input : new $6d528c824c1b43cf$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $6d528c824c1b43cf$var$baseCompressedBatchProof);
        message.entries = [];
        message.lookupInners = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.entries.push(module.exports.CompressedBatchEntry.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.lookupInners.push(module.exports.InnerOp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $6d528c824c1b43cf$var$baseCompressedBatchProof);
        message.entries = [];
        message.lookupInners = [];
        if (object.entries !== undefined && object.entries !== null) for (const e of object.entries)message.entries.push(module.exports.CompressedBatchEntry.fromJSON(e));
        if (object.lookupInners !== undefined && object.lookupInners !== null) for (const e of object.lookupInners)message.lookupInners.push(module.exports.InnerOp.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.entries) obj.entries = message.entries.map((e)=>e ? module.exports.CompressedBatchEntry.toJSON(e) : undefined);
        else obj.entries = [];
        if (message.lookupInners) obj.lookupInners = message.lookupInners.map((e)=>e ? module.exports.InnerOp.toJSON(e) : undefined);
        else obj.lookupInners = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $6d528c824c1b43cf$var$baseCompressedBatchProof);
        message.entries = [];
        message.lookupInners = [];
        if (object.entries !== undefined && object.entries !== null) for (const e of object.entries)message.entries.push(module.exports.CompressedBatchEntry.fromPartial(e));
        if (object.lookupInners !== undefined && object.lookupInners !== null) for (const e of object.lookupInners)message.lookupInners.push(module.exports.InnerOp.fromPartial(e));
        return message;
    }
};
const $6d528c824c1b43cf$var$baseCompressedBatchEntry = {};
module.exports.CompressedBatchEntry = {
    encode (message, writer = $6d528c824c1b43cf$var$minimal_1.default.Writer.create()) {
        if (message.exist !== undefined) module.exports.CompressedExistenceProof.encode(message.exist, writer.uint32(10).fork()).ldelim();
        if (message.nonexist !== undefined) module.exports.CompressedNonExistenceProof.encode(message.nonexist, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6d528c824c1b43cf$var$minimal_1.default.Reader ? input : new $6d528c824c1b43cf$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $6d528c824c1b43cf$var$baseCompressedBatchEntry);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.exist = module.exports.CompressedExistenceProof.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.nonexist = module.exports.CompressedNonExistenceProof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $6d528c824c1b43cf$var$baseCompressedBatchEntry);
        if (object.exist !== undefined && object.exist !== null) message.exist = module.exports.CompressedExistenceProof.fromJSON(object.exist);
        else message.exist = undefined;
        if (object.nonexist !== undefined && object.nonexist !== null) message.nonexist = module.exports.CompressedNonExistenceProof.fromJSON(object.nonexist);
        else message.nonexist = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.exist !== undefined && (obj.exist = message.exist ? module.exports.CompressedExistenceProof.toJSON(message.exist) : undefined);
        message.nonexist !== undefined && (obj.nonexist = message.nonexist ? module.exports.CompressedNonExistenceProof.toJSON(message.nonexist) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $6d528c824c1b43cf$var$baseCompressedBatchEntry);
        if (object.exist !== undefined && object.exist !== null) message.exist = module.exports.CompressedExistenceProof.fromPartial(object.exist);
        else message.exist = undefined;
        if (object.nonexist !== undefined && object.nonexist !== null) message.nonexist = module.exports.CompressedNonExistenceProof.fromPartial(object.nonexist);
        else message.nonexist = undefined;
        return message;
    }
};
const $6d528c824c1b43cf$var$baseCompressedExistenceProof = {
    path: 0
};
module.exports.CompressedExistenceProof = {
    encode (message, writer = $6d528c824c1b43cf$var$minimal_1.default.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (message.value.length !== 0) writer.uint32(18).bytes(message.value);
        if (message.leaf !== undefined) module.exports.LeafOp.encode(message.leaf, writer.uint32(26).fork()).ldelim();
        writer.uint32(34).fork();
        for (const v of message.path)writer.int32(v);
        writer.ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6d528c824c1b43cf$var$minimal_1.default.Reader ? input : new $6d528c824c1b43cf$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $6d528c824c1b43cf$var$baseCompressedExistenceProof);
        message.path = [];
        message.key = new Uint8Array();
        message.value = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.value = reader.bytes();
                    break;
                case 3:
                    message.leaf = module.exports.LeafOp.decode(reader, reader.uint32());
                    break;
                case 4:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.path.push(reader.int32());
                    } else message.path.push(reader.int32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $6d528c824c1b43cf$var$baseCompressedExistenceProof);
        message.path = [];
        message.key = new Uint8Array();
        message.value = new Uint8Array();
        if (object.key !== undefined && object.key !== null) message.key = $6d528c824c1b43cf$var$bytesFromBase64(object.key);
        if (object.value !== undefined && object.value !== null) message.value = $6d528c824c1b43cf$var$bytesFromBase64(object.value);
        if (object.leaf !== undefined && object.leaf !== null) message.leaf = module.exports.LeafOp.fromJSON(object.leaf);
        else message.leaf = undefined;
        if (object.path !== undefined && object.path !== null) for (const e of object.path)message.path.push(Number(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = $6d528c824c1b43cf$var$base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        message.value !== undefined && (obj.value = $6d528c824c1b43cf$var$base64FromBytes(message.value !== undefined ? message.value : new Uint8Array()));
        message.leaf !== undefined && (obj.leaf = message.leaf ? module.exports.LeafOp.toJSON(message.leaf) : undefined);
        if (message.path) obj.path = message.path.map((e)=>e);
        else obj.path = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $6d528c824c1b43cf$var$baseCompressedExistenceProof);
        message.path = [];
        if (object.key !== undefined && object.key !== null) message.key = object.key;
        else message.key = new Uint8Array();
        if (object.value !== undefined && object.value !== null) message.value = object.value;
        else message.value = new Uint8Array();
        if (object.leaf !== undefined && object.leaf !== null) message.leaf = module.exports.LeafOp.fromPartial(object.leaf);
        else message.leaf = undefined;
        if (object.path !== undefined && object.path !== null) for (const e of object.path)message.path.push(e);
        return message;
    }
};
const $6d528c824c1b43cf$var$baseCompressedNonExistenceProof = {};
module.exports.CompressedNonExistenceProof = {
    encode (message, writer = $6d528c824c1b43cf$var$minimal_1.default.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (message.left !== undefined) module.exports.CompressedExistenceProof.encode(message.left, writer.uint32(18).fork()).ldelim();
        if (message.right !== undefined) module.exports.CompressedExistenceProof.encode(message.right, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6d528c824c1b43cf$var$minimal_1.default.Reader ? input : new $6d528c824c1b43cf$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $6d528c824c1b43cf$var$baseCompressedNonExistenceProof);
        message.key = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.left = module.exports.CompressedExistenceProof.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.right = module.exports.CompressedExistenceProof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $6d528c824c1b43cf$var$baseCompressedNonExistenceProof);
        message.key = new Uint8Array();
        if (object.key !== undefined && object.key !== null) message.key = $6d528c824c1b43cf$var$bytesFromBase64(object.key);
        if (object.left !== undefined && object.left !== null) message.left = module.exports.CompressedExistenceProof.fromJSON(object.left);
        else message.left = undefined;
        if (object.right !== undefined && object.right !== null) message.right = module.exports.CompressedExistenceProof.fromJSON(object.right);
        else message.right = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = $6d528c824c1b43cf$var$base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        message.left !== undefined && (obj.left = message.left ? module.exports.CompressedExistenceProof.toJSON(message.left) : undefined);
        message.right !== undefined && (obj.right = message.right ? module.exports.CompressedExistenceProof.toJSON(message.right) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $6d528c824c1b43cf$var$baseCompressedNonExistenceProof);
        if (object.key !== undefined && object.key !== null) message.key = object.key;
        else message.key = new Uint8Array();
        if (object.left !== undefined && object.left !== null) message.left = module.exports.CompressedExistenceProof.fromPartial(object.left);
        else message.left = undefined;
        if (object.right !== undefined && object.right !== null) message.right = module.exports.CompressedExistenceProof.fromPartial(object.right);
        else message.right = undefined;
        return message;
    }
};
var $6d528c824c1b43cf$var$globalThis = (()=>{
    if (typeof $6d528c824c1b43cf$var$globalThis !== "undefined") return $6d528c824c1b43cf$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $6d528c824c1b43cf$var$atob = $6d528c824c1b43cf$var$globalThis.atob || ((b64)=>$6d528c824c1b43cf$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $6d528c824c1b43cf$var$bytesFromBase64(b64) {
    const bin = $6d528c824c1b43cf$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $6d528c824c1b43cf$var$btoa = $6d528c824c1b43cf$var$globalThis.btoa || ((bin)=>$6d528c824c1b43cf$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $6d528c824c1b43cf$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $6d528c824c1b43cf$var$btoa(bin.join(""));
}
if ($6d528c824c1b43cf$var$minimal_1.default.util.Long !== $6d528c824c1b43cf$var$long_1.default) {
    $6d528c824c1b43cf$var$minimal_1.default.util.Long = $6d528c824c1b43cf$var$long_1.default;
    $6d528c824c1b43cf$var$minimal_1.default.configure();
}

});



parcelRegister("ec3qw", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $a554d82d6a9cef5f$require$Buffer = $gzLuY.Buffer;
"use strict";
var $a554d82d6a9cef5f$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $a554d82d6a9cef5f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a554d82d6a9cef5f$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $a554d82d6a9cef5f$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a554d82d6a9cef5f$var$__createBinding(result, mod, k);
    }
    $a554d82d6a9cef5f$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Validator = module.exports.ValidatorSet = module.exports.CommitSig = module.exports.Commit = module.exports.PartSetHeader = module.exports.BlockID = module.exports.SignedHeader = module.exports.Header = void 0;

var $djDW6 = parcelRequire("djDW6");

var $j77DS = parcelRequire("j77DS");

var $a554d82d6a9cef5f$var$Long = $a554d82d6a9cef5f$var$__importStar((parcelRequire("9A55m")));

var $26Eqx = parcelRequire("26Eqx");

var $l509C = parcelRequire("l509C");

var $bklFR = parcelRequire("bklFR");
/** Header defines the structure of a Tendermint block header. */ var $a554d82d6a9cef5f$var$Header = /** @class */ function(_super) {
    $a554d82d6a9cef5f$var$__extends(Header, _super);
    /**
     * @param total
     * @param hash
     */ function Header(version, chainId, height, time, lastBlockId, lastCommitHash, dataHash, validatorsHash, nextValidatorsHash, consensusHash, appHash, lastResultsHash, evidenceHash, proposerAddress) {
        var _this = _super.call(this) || this;
        _this.version = version;
        _this.chainId = chainId;
        _this.height = height;
        _this.time = time;
        _this.lastBlockId = lastBlockId;
        _this.lastCommitHash = lastCommitHash;
        _this.dataHash = dataHash;
        _this.validatorsHash = validatorsHash;
        _this.nextValidatorsHash = nextValidatorsHash;
        _this.consensusHash = consensusHash;
        _this.appHash = appHash;
        _this.lastResultsHash = lastResultsHash;
        _this.evidenceHash = evidenceHash;
        _this.proposerAddress = proposerAddress;
        return _this;
    }
    Header.fromAmino = function(_) {
        _;
        throw new Error("Amino not supported");
    };
    Header.prototype.toAmino = function() {
        throw new Error("Amino not supported");
    };
    Header.fromData = function(data) {
        var version = data.version, chainId = data.chain_id, height = data.height, time = data.time, lastBlockId = data.last_block_id, lastCommitHash = data.last_commit_hash, dataHash = data.data_hash, validatorsHash = data.validators_hash, nextValidatorsHash = data.next_validators_hash, consensusHash = data.consensus_hash, appHash = data.app_hash, lastResultsHash = data.last_results_hash, evidenceHash = data.evidence_hash, proposerAddress = data.proposer_address;
        return new Header(version ? $l509C.Consensus.fromData(version) : undefined, chainId, height, time ? new Date(time) : undefined, lastBlockId ? $a554d82d6a9cef5f$var$BlockID.fromData(lastBlockId) : undefined, lastCommitHash, dataHash, validatorsHash, nextValidatorsHash, consensusHash, appHash, lastResultsHash, evidenceHash, proposerAddress);
    };
    Header.prototype.toData = function() {
        var _a = this, version = _a.version, chainId = _a.chainId, height = _a.height, time = _a.time, lastBlockId = _a.lastBlockId, lastCommitHash = _a.lastCommitHash, dataHash = _a.dataHash, validatorsHash = _a.validatorsHash, nextValidatorsHash = _a.nextValidatorsHash, consensusHash = _a.consensusHash, appHash = _a.appHash, lastResultsHash = _a.lastResultsHash, evidenceHash = _a.evidenceHash, proposerAddress = _a.proposerAddress;
        var res = {
            version: version === null || version === void 0 ? void 0 : version.toData(),
            chain_id: chainId,
            height: height,
            time: time ? time.toISOString().replace(/\.000Z$/, "Z") : undefined,
            last_block_id: lastBlockId ? lastBlockId.toData() : undefined,
            last_commit_hash: lastCommitHash,
            data_hash: dataHash,
            validators_hash: validatorsHash,
            next_validators_hash: nextValidatorsHash,
            consensus_hash: consensusHash,
            app_hash: appHash,
            last_results_hash: lastResultsHash,
            evidence_hash: evidenceHash,
            proposer_address: proposerAddress
        };
        return res;
    };
    Header.fromProto = function(proto) {
        var version = proto.version, chainId = proto.chainId, height = proto.height, time = proto.time, lastBlockId = proto.lastBlockId, lastCommitHash = proto.lastCommitHash, dataHash = proto.dataHash, validatorsHash = proto.validatorsHash, nextValidatorsHash = proto.nextValidatorsHash, consensusHash = proto.consensusHash, appHash = proto.appHash, lastResultsHash = proto.lastResultsHash, evidenceHash = proto.evidenceHash, proposerAddress = proto.proposerAddress;
        return new Header(version ? $l509C.Consensus.fromProto(version) : undefined, chainId, height.toString(), time, lastBlockId ? $a554d82d6a9cef5f$var$BlockID.fromProto(lastBlockId) : undefined, $a554d82d6a9cef5f$require$Buffer.from(lastCommitHash).toString("base64"), $a554d82d6a9cef5f$require$Buffer.from(dataHash).toString("base64"), $a554d82d6a9cef5f$require$Buffer.from(validatorsHash).toString("base64"), $a554d82d6a9cef5f$require$Buffer.from(nextValidatorsHash).toString("base64"), $a554d82d6a9cef5f$require$Buffer.from(consensusHash).toString("base64"), $a554d82d6a9cef5f$require$Buffer.from(appHash).toString("base64"), $a554d82d6a9cef5f$require$Buffer.from(lastResultsHash).toString("base64"), $a554d82d6a9cef5f$require$Buffer.from(evidenceHash).toString("base64"), proposerAddress.toString());
    };
    Header.prototype.toProto = function() {
        var _a = this, version = _a.version, chainId = _a.chainId, height = _a.height, time = _a.time, lastBlockId = _a.lastBlockId, lastCommitHash = _a.lastCommitHash, dataHash = _a.dataHash, validatorsHash = _a.validatorsHash, nextValidatorsHash = _a.nextValidatorsHash, consensusHash = _a.consensusHash, appHash = _a.appHash, lastResultsHash = _a.lastResultsHash, evidenceHash = _a.evidenceHash, proposerAddress = _a.proposerAddress;
        return $djDW6.Header.fromPartial({
            version: version === null || version === void 0 ? void 0 : version.toProto(),
            chainId: chainId,
            height: $a554d82d6a9cef5f$var$Long.fromString(height),
            time: time,
            lastBlockId: lastBlockId === null || lastBlockId === void 0 ? void 0 : lastBlockId.toProto(),
            lastCommitHash: $a554d82d6a9cef5f$require$Buffer.from(lastCommitHash, "base64"),
            dataHash: $a554d82d6a9cef5f$require$Buffer.from(dataHash, "base64"),
            validatorsHash: $a554d82d6a9cef5f$require$Buffer.from(validatorsHash, "base64"),
            nextValidatorsHash: $a554d82d6a9cef5f$require$Buffer.from(nextValidatorsHash, "base64"),
            consensusHash: $a554d82d6a9cef5f$require$Buffer.from(consensusHash, "base64"),
            appHash: $a554d82d6a9cef5f$require$Buffer.from(appHash, "base64"),
            lastResultsHash: $a554d82d6a9cef5f$require$Buffer.from(lastResultsHash, "base64"),
            evidenceHash: $a554d82d6a9cef5f$require$Buffer.from(evidenceHash, "base64"),
            proposerAddress: $a554d82d6a9cef5f$require$Buffer.from(proposerAddress)
        });
    };
    return Header;
}($26Eqx.JSONSerializable);
module.exports.Header = $a554d82d6a9cef5f$var$Header;
var $a554d82d6a9cef5f$var$SignedHeader = /** @class */ function(_super) {
    $a554d82d6a9cef5f$var$__extends(SignedHeader, _super);
    /**
     * @param header
     * @param commit
     */ function SignedHeader(header, commit) {
        var _this = _super.call(this) || this;
        _this.header = header;
        _this.commit = commit;
        return _this;
    }
    SignedHeader.fromAmino = function(_) {
        _;
        throw new Error("Amino not supported");
    };
    SignedHeader.prototype.toAmino = function() {
        throw new Error("Amino not supported");
    };
    SignedHeader.fromData = function(data) {
        var header = data.header, commit = data.commit;
        return new SignedHeader(header ? $a554d82d6a9cef5f$var$Header.fromData(header) : undefined, commit ? $a554d82d6a9cef5f$var$Commit.fromData(commit) : undefined);
    };
    SignedHeader.prototype.toData = function() {
        var _a = this, header = _a.header, commit = _a.commit;
        var res = {
            header: header === null || header === void 0 ? void 0 : header.toData(),
            commit: commit === null || commit === void 0 ? void 0 : commit.toData()
        };
        return res;
    };
    SignedHeader.fromProto = function(proto) {
        return new SignedHeader(proto.header ? $a554d82d6a9cef5f$var$Header.fromProto(proto.header) : undefined, proto.commit ? $a554d82d6a9cef5f$var$Commit.fromProto(proto.commit) : undefined);
    };
    SignedHeader.prototype.toProto = function() {
        var _a = this, header = _a.header, commit = _a.commit;
        return $djDW6.SignedHeader.fromPartial({
            header: header === null || header === void 0 ? void 0 : header.toProto(),
            commit: commit === null || commit === void 0 ? void 0 : commit.toProto()
        });
    };
    return SignedHeader;
}($26Eqx.JSONSerializable);
module.exports.SignedHeader = $a554d82d6a9cef5f$var$SignedHeader;
/** BlockID */ var $a554d82d6a9cef5f$var$BlockID = /** @class */ function(_super) {
    $a554d82d6a9cef5f$var$__extends(BlockID, _super);
    /**
     * @param hash
     * @param partSetHeader
     */ function BlockID(hash, partSetHeader) {
        var _this = _super.call(this) || this;
        _this.hash = hash;
        _this.partSetHeader = partSetHeader;
        return _this;
    }
    BlockID.fromAmino = function(_) {
        _;
        throw new Error("Amino not supported");
    };
    BlockID.prototype.toAmino = function() {
        throw new Error("Amino not supported");
    };
    BlockID.fromData = function(data) {
        var hash = data.hash, partSetHeader = data.part_set_header;
        return new BlockID(hash, partSetHeader ? $a554d82d6a9cef5f$var$PartSetHeader.fromData(partSetHeader) : undefined);
    };
    BlockID.prototype.toData = function() {
        var _a = this, hash = _a.hash, partSetHeader = _a.partSetHeader;
        var res = {
            hash: hash,
            part_set_header: partSetHeader === null || partSetHeader === void 0 ? void 0 : partSetHeader.toData()
        };
        return res;
    };
    BlockID.fromProto = function(proto) {
        return new BlockID($a554d82d6a9cef5f$require$Buffer.from(proto.hash).toString("base64"), proto.partSetHeader ? $a554d82d6a9cef5f$var$PartSetHeader.fromProto(proto.partSetHeader) : undefined);
    };
    BlockID.prototype.toProto = function() {
        var _a = this, hash = _a.hash, partSetHeader = _a.partSetHeader;
        return $djDW6.BlockID.fromPartial({
            hash: $a554d82d6a9cef5f$require$Buffer.from(hash, "base64"),
            partSetHeader: partSetHeader ? partSetHeader.toProto() : undefined
        });
    };
    return BlockID;
}($26Eqx.JSONSerializable);
module.exports.BlockID = $a554d82d6a9cef5f$var$BlockID;
/** PartsetHeader */ var $a554d82d6a9cef5f$var$PartSetHeader = /** @class */ function(_super) {
    $a554d82d6a9cef5f$var$__extends(PartSetHeader, _super);
    /**
     * @param total
     * @param hash
     */ function PartSetHeader(total, hash) {
        var _this = _super.call(this) || this;
        _this.total = total;
        _this.hash = hash;
        return _this;
    }
    PartSetHeader.fromAmino = function(_) {
        _;
        throw new Error("Amino not supported");
    };
    PartSetHeader.prototype.toAmino = function() {
        throw new Error("Amino not supported");
    };
    PartSetHeader.fromData = function(data) {
        var total = data.total, hash = data.hash;
        return new PartSetHeader(parseInt(total), hash);
    };
    PartSetHeader.prototype.toData = function() {
        var _a = this, total = _a.total, hash = _a.hash;
        var res = {
            total: total.toFixed(),
            hash: hash
        };
        return res;
    };
    PartSetHeader.fromProto = function(proto) {
        return new PartSetHeader(proto.total, $a554d82d6a9cef5f$require$Buffer.from(proto.hash).toString("base64"));
    };
    PartSetHeader.prototype.toProto = function() {
        var _a = this, total = _a.total, hash = _a.hash;
        return $djDW6.PartSetHeader.fromPartial({
            total: total,
            hash: $a554d82d6a9cef5f$require$Buffer.from(hash, "base64")
        });
    };
    return PartSetHeader;
}($26Eqx.JSONSerializable);
module.exports.PartSetHeader = $a554d82d6a9cef5f$var$PartSetHeader;
/** Commit contains the evidence that a block was committed by a set of validators. */ var $a554d82d6a9cef5f$var$Commit = /** @class */ function(_super) {
    $a554d82d6a9cef5f$var$__extends(Commit, _super);
    /**
     * @param height
     * @param round
     * @param blockId
     * @param signatures
     */ function Commit(height, round, blockId, signatures) {
        var _this = _super.call(this) || this;
        _this.height = height;
        _this.round = round;
        _this.blockId = blockId;
        _this.signatures = signatures;
        return _this;
    }
    Commit.fromAmino = function(_) {
        _;
        throw new Error("Amino not supported");
    };
    Commit.prototype.toAmino = function() {
        throw new Error("Amino not supported");
    };
    Commit.fromData = function(data) {
        var height = data.height, round = data.round, blockId = data.block_id, signatures = data.signatures;
        return new Commit($a554d82d6a9cef5f$var$Long.fromString(height), Number.parseInt(round), blockId ? $a554d82d6a9cef5f$var$BlockID.fromData(blockId) : undefined, signatures.map(function(sig) {
            return $a554d82d6a9cef5f$var$CommitSig.fromData(sig);
        }));
    };
    Commit.prototype.toData = function() {
        var _a = this, height = _a.height, round = _a.round, blockId = _a.blockId, signatures = _a.signatures;
        var res = {
            height: height.toString(),
            round: round.toFixed(),
            block_id: blockId === null || blockId === void 0 ? void 0 : blockId.toData(),
            signatures: signatures.map(function(sig) {
                return sig.toData();
            })
        };
        return res;
    };
    Commit.fromProto = function(proto) {
        var height = proto.height, round = proto.round, blockId = proto.blockId, signatures = proto.signatures;
        return new Commit(height, round, blockId ? $a554d82d6a9cef5f$var$BlockID.fromProto(blockId) : undefined, signatures.map(function(sig) {
            return $a554d82d6a9cef5f$var$CommitSig.fromProto(sig);
        }));
    };
    Commit.prototype.toProto = function() {
        var _a = this, height = _a.height, round = _a.round, blockId = _a.blockId, signatures = _a.signatures;
        return $djDW6.Commit.fromPartial({
            height: height,
            round: round,
            blockId: blockId === null || blockId === void 0 ? void 0 : blockId.toProto(),
            signatures: signatures.map(function(sig) {
                return sig.toProto();
            })
        });
    };
    return Commit;
}($26Eqx.JSONSerializable);
module.exports.Commit = $a554d82d6a9cef5f$var$Commit;
/** CommitSig is a part of the Vote included in a Commit. */ var $a554d82d6a9cef5f$var$CommitSig = /** @class */ function(_super) {
    $a554d82d6a9cef5f$var$__extends(CommitSig, _super);
    /**
     * @param blockIdFlag
     * @param validatorAddress
     * @param timestamp
     * @param signature
     */ function CommitSig(blockIdFlag, validatorAddress, timestamp, signature) {
        var _this = _super.call(this) || this;
        _this.blockIdFlag = blockIdFlag;
        _this.validatorAddress = validatorAddress;
        _this.timestamp = timestamp;
        _this.signature = signature;
        return _this;
    }
    CommitSig.fromAmino = function(_) {
        _;
        throw new Error("Amino not supported");
    };
    CommitSig.prototype.toAmino = function() {
        throw new Error("Amino not supported");
    };
    CommitSig.fromData = function(data) {
        var block_id_flag = data.block_id_flag, validator_address = data.validator_address, timestamp = data.timestamp, signature = data.signature;
        return new CommitSig((0, $djDW6.blockIDFlagFromJSON)(block_id_flag), validator_address, timestamp ? new Date(timestamp) : undefined, signature);
    };
    CommitSig.prototype.toData = function() {
        var _a = this, blockIdFlag = _a.blockIdFlag, validatorAddress = _a.validatorAddress, timestamp = _a.timestamp, signature = _a.signature;
        var res = {
            block_id_flag: (0, $djDW6.blockIDFlagToJSON)(blockIdFlag),
            validator_address: validatorAddress || "",
            timestamp: timestamp ? timestamp.toISOString().replace(/\.000Z$/, "Z") : undefined,
            signature: signature || ""
        };
        return res;
    };
    CommitSig.fromProto = function(proto) {
        var blockIdFlag = proto.blockIdFlag, validatorAddress = proto.validatorAddress, timestamp = proto.timestamp, signature = proto.signature;
        return new CommitSig(blockIdFlag, $a554d82d6a9cef5f$require$Buffer.from(validatorAddress).toString("base64"), timestamp, $a554d82d6a9cef5f$require$Buffer.from(signature).toString("base64"));
    };
    CommitSig.prototype.toProto = function() {
        var _a = this, blockIdFlag = _a.blockIdFlag, validatorAddress = _a.validatorAddress, timestamp = _a.timestamp, signature = _a.signature;
        return $djDW6.CommitSig.fromPartial({
            blockIdFlag: blockIdFlag,
            validatorAddress: validatorAddress ? $a554d82d6a9cef5f$require$Buffer.from(validatorAddress, "base64") : undefined,
            timestamp: timestamp,
            signature: signature ? $a554d82d6a9cef5f$require$Buffer.from(signature, "base64") : undefined
        });
    };
    return CommitSig;
}($26Eqx.JSONSerializable);
module.exports.CommitSig = $a554d82d6a9cef5f$var$CommitSig;
var $a554d82d6a9cef5f$var$ValidatorSet = /** @class */ function(_super) {
    $a554d82d6a9cef5f$var$__extends(ValidatorSet, _super);
    /**
     * @param validators
     * @param proposer
     * @param totalVotingPower
     */ function ValidatorSet(validators, proposer, totalVotingPower) {
        var _this = _super.call(this) || this;
        _this.validators = validators;
        _this.proposer = proposer;
        _this.totalVotingPower = totalVotingPower;
        return _this;
    }
    ValidatorSet.fromAmino = function(_) {
        _;
        throw new Error("Amino not supported");
    };
    ValidatorSet.prototype.toAmino = function() {
        throw new Error("Amino not supported");
    };
    ValidatorSet.fromData = function(data) {
        var validators = data.validators, proposer = data.proposer, total_voting_power = data.total_voting_power;
        return new ValidatorSet(validators.map(function(val) {
            return $a554d82d6a9cef5f$var$Validator.fromData(val);
        }), proposer ? $a554d82d6a9cef5f$var$Validator.fromData(proposer) : undefined, $a554d82d6a9cef5f$var$Long.fromString(total_voting_power));
    };
    ValidatorSet.prototype.toData = function() {
        var _a = this, validators = _a.validators, proposer = _a.proposer, totalVotingPower = _a.totalVotingPower;
        var res = {
            validators: validators.map(function(val) {
                return val.toData();
            }),
            proposer: proposer === null || proposer === void 0 ? void 0 : proposer.toData(),
            total_voting_power: totalVotingPower.toString()
        };
        return res;
    };
    ValidatorSet.fromProto = function(proto) {
        var validators = proto.validators, proposer = proto.proposer, totalVotingPower = proto.totalVotingPower;
        return new ValidatorSet(validators.map(function(val) {
            return $a554d82d6a9cef5f$var$Validator.fromProto(val);
        }), proposer ? $a554d82d6a9cef5f$var$Validator.fromProto(proposer) : undefined, totalVotingPower);
    };
    ValidatorSet.prototype.toProto = function() {
        var _a = this, validators = _a.validators, proposer = _a.proposer, totalVotingPower = _a.totalVotingPower;
        return $j77DS.ValidatorSet.fromPartial({
            validators: validators.map(function(val) {
                return val.toProto();
            }),
            proposer: (proposer === null || proposer === void 0 ? void 0 : proposer.toProto()) || undefined,
            totalVotingPower: totalVotingPower
        });
    };
    return ValidatorSet;
}($26Eqx.JSONSerializable);
module.exports.ValidatorSet = $a554d82d6a9cef5f$var$ValidatorSet;
var $a554d82d6a9cef5f$var$Validator = /** @class */ function(_super) {
    $a554d82d6a9cef5f$var$__extends(Validator, _super);
    /**
     * @param address
     * @param pubKey
     * @param votingPower
     * @param proposerPriority
     */ function Validator(address, pubKey, votingPower, proposerPriority) {
        var _this = _super.call(this) || this;
        _this.address = address;
        _this.pubKey = pubKey;
        _this.votingPower = votingPower;
        _this.proposerPriority = proposerPriority;
        return _this;
    }
    Validator.fromAmino = function(_) {
        _;
        throw new Error("Amino not supported");
    };
    Validator.prototype.toAmino = function() {
        throw new Error("Amino not supported");
    };
    Validator.fromData = function(data) {
        var address = data.address, pubKey = data.pub_key, votingPower = data.voting_power, proposerPriority = data.proposer_priority;
        return new Validator(address, pubKey ? $bklFR.PublicKey.fromData(pubKey) : undefined, $a554d82d6a9cef5f$var$Long.fromString(votingPower), $a554d82d6a9cef5f$var$Long.fromString(proposerPriority));
    };
    Validator.prototype.toData = function() {
        var _a = this, address = _a.address, pubKey = _a.pubKey, votingPower = _a.votingPower, proposerPriority = _a.proposerPriority;
        var res = {
            address: address,
            pub_key: pubKey === null || pubKey === void 0 ? void 0 : pubKey.toData(),
            voting_power: votingPower.toString(),
            proposer_priority: proposerPriority.toString()
        };
        return res;
    };
    Validator.fromProto = function(proto) {
        var address = proto.address, pubKey = proto.pubKey, votingPower = proto.votingPower, proposerPriority = proto.proposerPriority;
        return new Validator($a554d82d6a9cef5f$require$Buffer.from(address).toString("base64"), pubKey ? $bklFR.PublicKey.fromProto(pubKey) : undefined, votingPower, proposerPriority);
    };
    Validator.prototype.toProto = function() {
        var _a = this, address = _a.address, pubKey = _a.pubKey, votingPower = _a.votingPower, proposerPriority = _a.proposerPriority;
        return $j77DS.Validator.fromPartial({
            address: $a554d82d6a9cef5f$require$Buffer.from(address, "base64"),
            pubKey: (pubKey === null || pubKey === void 0 ? void 0 : pubKey.toProto()) || undefined,
            votingPower: votingPower,
            proposerPriority: proposerPriority
        });
    };
    return Validator;
}($26Eqx.JSONSerializable);
module.exports.Validator = $a554d82d6a9cef5f$var$Validator;

});
parcelRegister("l509C", function(module, exports) {
"use strict";
var $f58a2f3205173589$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $f58a2f3205173589$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f58a2f3205173589$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $f58a2f3205173589$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $f58a2f3205173589$var$__createBinding(result, mod, k);
    }
    $f58a2f3205173589$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.App = module.exports.Consensus = void 0;

var $liJvN = parcelRequire("liJvN");

var $liJvN = parcelRequire("liJvN");

var $f58a2f3205173589$var$Long = $f58a2f3205173589$var$__importStar((parcelRequire("9A55m")));

var $26Eqx = parcelRequire("26Eqx");
/**
 * Consensus captures the consensus rules for processing a block in the blockchain,
 * including all blockchain data structures and the rules of the application's
 * state transition machine.
 */ var $f58a2f3205173589$var$Consensus = /** @class */ function(_super) {
    $f58a2f3205173589$var$__extends(Consensus, _super);
    /**
     * @param block
     * @param app
     */ function Consensus(block, app) {
        var _this = _super.call(this) || this;
        _this.block = block;
        _this.app = app;
        return _this;
    }
    Consensus.fromAmino = function(_) {
        _;
        throw new Error("Amino not supported");
    };
    Consensus.prototype.toAmino = function() {
        throw new Error("Amino not supported");
    };
    Consensus.fromData = function(data) {
        var block = data.block, app = data.app;
        return new Consensus(Number.parseInt(block), Number.parseInt(app));
    };
    Consensus.prototype.toData = function() {
        var _a = this, block = _a.block, app = _a.app;
        var res = {
            block: block.toFixed(),
            app: app.toFixed()
        };
        return res;
    };
    Consensus.fromProto = function(proto) {
        return new Consensus(proto.block.toNumber(), proto.app.toNumber());
    };
    Consensus.prototype.toProto = function() {
        var _a = this, block = _a.block, app = _a.app;
        return $liJvN.Consensus.fromPartial({
            block: $f58a2f3205173589$var$Long.fromNumber(block),
            app: $f58a2f3205173589$var$Long.fromNumber(app)
        });
    };
    return Consensus;
}($26Eqx.JSONSerializable);
module.exports.Consensus = $f58a2f3205173589$var$Consensus;
/**
 * App captures the consensus rules for processing a block in the blockchain,
 * including all blockchain data structures and the rules of the application's
 * state transition machine.
 */ var $f58a2f3205173589$var$App = /** @class */ function(_super) {
    $f58a2f3205173589$var$__extends(App, _super);
    /**
     * @param protocol
     * @param software
     */ function App(protocol, software) {
        var _this = _super.call(this) || this;
        _this.protocol = protocol;
        _this.software = software;
        return _this;
    }
    App.fromAmino = function(_) {
        _;
        throw new Error("Amino not supported");
    };
    App.prototype.toAmino = function() {
        throw new Error("Amino not supported");
    };
    App.fromData = function(data) {
        var protocol = data.protocol, software = data.software;
        return new App(Number.parseInt(protocol), software);
    };
    App.prototype.toData = function() {
        var _a = this, protocol = _a.protocol, software = _a.software;
        var res = {
            protocol: protocol.toFixed(),
            software: software
        };
        return res;
    };
    App.fromProto = function(proto) {
        return new App(proto.protocol.toNumber(), proto.software);
    };
    App.prototype.toProto = function() {
        var _a = this, protocol = _a.protocol, software = _a.software;
        return $liJvN.App.fromPartial({
            protocol: $f58a2f3205173589$var$Long.fromNumber(protocol),
            software: software
        });
    };
    return App;
}($26Eqx.JSONSerializable);
module.exports.App = $f58a2f3205173589$var$App;

});

parcelRegister("bklFR", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $83f25ffe164bd0c9$require$Buffer = $gzLuY.Buffer;
"use strict";
var $83f25ffe164bd0c9$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $83f25ffe164bd0c9$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $83f25ffe164bd0c9$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $83f25ffe164bd0c9$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $83f25ffe164bd0c9$var$__createBinding(result, mod, k);
    }
    $83f25ffe164bd0c9$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PublicKey = module.exports.Proof = void 0;

var $eIxyR = parcelRequire("eIxyR");

var $a0zXC = parcelRequire("a0zXC");

var $83f25ffe164bd0c9$var$Long = $83f25ffe164bd0c9$var$__importStar((parcelRequire("9A55m")));

var $26Eqx = parcelRequire("26Eqx");
var $83f25ffe164bd0c9$var$Proof = /** @class */ function(_super) {
    $83f25ffe164bd0c9$var$__extends(Proof, _super);
    /**
     * @param total
     * @param index
     * @param leafHash
     * @param aunts
     */ function Proof(total, index, leafHash, aunts) {
        var _this = _super.call(this) || this;
        _this.total = total;
        _this.index = index;
        _this.leafHash = leafHash;
        _this.aunts = aunts;
        return _this;
    }
    Proof.fromAmino = function(_) {
        _;
        throw new Error("Amino not supported");
    };
    Proof.prototype.toAmino = function() {
        throw new Error("Amino not supported");
    };
    Proof.fromData = function(data) {
        var total = data.total, index = data.index, leafHash = data.leaf_hash, aunts = data.aunts;
        return new Proof(Number.parseInt(total), Number.parseInt(index), leafHash, aunts);
    };
    Proof.prototype.toData = function() {
        var _a = this, total = _a.total, index = _a.index, leafHash = _a.leafHash, aunts = _a.aunts;
        var res = {
            total: total.toFixed(),
            index: index.toFixed(),
            leaf_hash: leafHash,
            aunts: aunts
        };
        return res;
    };
    Proof.fromProto = function(proto) {
        return new Proof(proto.total.toNumber(), proto.index.toNumber(), $83f25ffe164bd0c9$require$Buffer.from(proto.leafHash).toString("base64"), proto.aunts.map(function(aunt) {
            return $83f25ffe164bd0c9$require$Buffer.from(aunt).toString("base64");
        }));
    };
    Proof.prototype.toProto = function() {
        var _a = this, total = _a.total, index = _a.index, leafHash = _a.leafHash, aunts = _a.aunts;
        return $eIxyR.Proof.fromPartial({
            total: $83f25ffe164bd0c9$var$Long.fromNumber(total),
            index: $83f25ffe164bd0c9$var$Long.fromNumber(index),
            leafHash: $83f25ffe164bd0c9$require$Buffer.from(leafHash, "base64"),
            aunts: aunts.map(function(aunt) {
                return $83f25ffe164bd0c9$require$Buffer.from(aunt, "base64");
            })
        });
    };
    return Proof;
}($26Eqx.JSONSerializable);
module.exports.Proof = $83f25ffe164bd0c9$var$Proof;
/** PublicKey defines the keys available for use with Tendermint Validators */ var $83f25ffe164bd0c9$var$PublicKey = /** @class */ function(_super) {
    $83f25ffe164bd0c9$var$__extends(PublicKey, _super);
    /**
     * @param ed25519
     * @param secp256k1
     */ function PublicKey(ed25519, secp256k1) {
        var _this = _super.call(this) || this;
        _this.ed25519 = ed25519;
        _this.secp256k1 = secp256k1;
        return _this;
    }
    PublicKey.fromAmino = function(_) {
        _;
        throw new Error("Amino not supported");
    };
    PublicKey.prototype.toAmino = function() {
        throw new Error("Amino not supported");
    };
    PublicKey.fromData = function(data) {
        var ed25519 = data.ed25519, secp256k1 = data.secp256k1;
        return new PublicKey(ed25519, secp256k1);
    };
    PublicKey.prototype.toData = function() {
        var _a = this, ed25519 = _a.ed25519, secp256k1 = _a.secp256k1;
        var res = {
            ed25519: ed25519,
            secp256k1: secp256k1
        };
        return res;
    };
    PublicKey.fromProto = function(proto) {
        var ed25519 = proto.ed25519, secp256k1 = proto.secp256k1;
        return new PublicKey(ed25519 ? $83f25ffe164bd0c9$require$Buffer.from(ed25519).toString("base64") : undefined, secp256k1 ? $83f25ffe164bd0c9$require$Buffer.from(secp256k1).toString("base64") : undefined);
    };
    PublicKey.prototype.toProto = function() {
        var _a = this, ed25519 = _a.ed25519, secp256k1 = _a.secp256k1;
        return $a0zXC.PublicKey.fromPartial({
            ed25519: ed25519 ? $83f25ffe164bd0c9$require$Buffer.from(ed25519, "base64") : undefined,
            secp256k1: secp256k1 ? $83f25ffe164bd0c9$require$Buffer.from(secp256k1, "base64") : undefined
        });
    };
    return PublicKey;
}($26Eqx.JSONSerializable);
module.exports.PublicKey = $83f25ffe164bd0c9$var$PublicKey;

});




parcelRegister("1PxjS", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $1554666d3d935db3$require$Buffer = $gzLuY.Buffer;
"use strict";
var $1554666d3d935db3$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgUpgradeClient = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $lCsl4 = parcelRequire("lCsl4");
/**
 * MsgUpgradeClient defines an sdk.Msg to upgrade an IBC client to a new client state
 */ var $1554666d3d935db3$var$MsgUpgradeClient = /** @class */ function(_super) {
    $1554666d3d935db3$var$__extends(MsgUpgradeClient, _super);
    /**
     * @param client_id client unique identifier
     * @param client_state  upgraded client state
     * @param consensus_state upgraded consensus state, only contains enough information to serve as a basis of trust in update logic
     * @param proof_upgrade_client proof that old chain committed to new client
     * @param proof_upgrade_consensus_state  proof that old chain committed to new consensus state
     * @param signer signer address
     */ function MsgUpgradeClient(client_id, client_state, consensus_state, proof_upgrade_client, proof_upgrade_consensus_state, signer) {
        var _this = _super.call(this) || this;
        _this.client_id = client_id;
        _this.client_state = client_state;
        _this.consensus_state = consensus_state;
        _this.proof_upgrade_client = proof_upgrade_client;
        _this.proof_upgrade_consensus_state = proof_upgrade_consensus_state;
        _this.signer = signer;
        return _this;
    }
    MsgUpgradeClient.fromAmino = function(_, isClassic) {
        _;
        isClassic;
        throw new Error("Amino not supported");
    };
    MsgUpgradeClient.prototype.toAmino = function(_) {
        _;
        throw new Error("Amino not supported");
    };
    MsgUpgradeClient.fromData = function(data, _) {
        _;
        var client_id = data.client_id, client_state = data.client_state, consensus_state = data.consensus_state, proof_upgrade_client = data.proof_upgrade_client, proof_upgrade_consensus_state = data.proof_upgrade_consensus_state, signer = data.signer;
        return new MsgUpgradeClient(client_id, client_state, consensus_state, proof_upgrade_client, proof_upgrade_consensus_state, signer);
    };
    MsgUpgradeClient.prototype.toData = function(_) {
        _;
        var _a = this, client_id = _a.client_id, client_state = _a.client_state, consensus_state = _a.consensus_state, proof_upgrade_client = _a.proof_upgrade_client, proof_upgrade_consensus_state = _a.proof_upgrade_consensus_state, signer = _a.signer;
        return {
            "@type": "/ibc.core.client.v1.MsgUpgradeClient",
            client_id: client_id,
            client_state: client_state,
            consensus_state: consensus_state,
            proof_upgrade_client: proof_upgrade_client,
            proof_upgrade_consensus_state: proof_upgrade_consensus_state,
            signer: signer
        };
    };
    MsgUpgradeClient.fromProto = function(proto, _) {
        _;
        return new MsgUpgradeClient(proto.clientId, proto.clientState, proto.consensusState, $1554666d3d935db3$require$Buffer.from(proto.proofUpgradeClient).toString("base64"), $1554666d3d935db3$require$Buffer.from(proto.proofUpgradeConsensusState).toString("base64"), proto.signer);
    };
    MsgUpgradeClient.prototype.toProto = function(_) {
        _;
        var _a = this, client_id = _a.client_id, client_state = _a.client_state, consensus_state = _a.consensus_state, proof_upgrade_client = _a.proof_upgrade_client, proof_upgrade_consensus_state = _a.proof_upgrade_consensus_state, signer = _a.signer;
        return $lCsl4.MsgUpgradeClient.fromPartial({
            clientId: client_id,
            clientState: client_state,
            consensusState: consensus_state,
            proofUpgradeClient: $1554666d3d935db3$require$Buffer.from(proof_upgrade_client, "base64"),
            proofUpgradeConsensusState: $1554666d3d935db3$require$Buffer.from(proof_upgrade_consensus_state, "base64"),
            signer: signer
        });
    };
    MsgUpgradeClient.prototype.packAny = function(_) {
        _;
        return $c5FxR.Any.fromPartial({
            typeUrl: "/ibc.core.client.v1.MsgUpgradeClient",
            value: $lCsl4.MsgUpgradeClient.encode(this.toProto()).finish()
        });
    };
    MsgUpgradeClient.unpackAny = function(msgAny, _) {
        _;
        return MsgUpgradeClient.fromProto($lCsl4.MsgUpgradeClient.decode(msgAny.value));
    };
    return MsgUpgradeClient;
}($26Eqx.JSONSerializable);
module.exports.MsgUpgradeClient = $1554666d3d935db3$var$MsgUpgradeClient;

});

parcelRegister("e3haD", function(module, exports) {
"use strict";
var $a3aeaa37ad21f5fe$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgSubmitMisbehaviour = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $lCsl4 = parcelRequire("lCsl4");
/**
 *  MsgSubmitMisbehaviour defines an sdk.Msg type that submits Evidence for light client misbehaviour.
 */ var $a3aeaa37ad21f5fe$var$MsgSubmitMisbehaviour = /** @class */ function(_super) {
    $a3aeaa37ad21f5fe$var$__extends(MsgSubmitMisbehaviour, _super);
    /**
     * @param client_id client unique identifier
     * @param misbehaviour misbehaviour used for freezing the light client
     * @param signer signer address
     */ function MsgSubmitMisbehaviour(client_id, misbehaviour, signer) {
        var _this = _super.call(this) || this;
        _this.client_id = client_id;
        _this.misbehaviour = misbehaviour;
        _this.signer = signer;
        return _this;
    }
    MsgSubmitMisbehaviour.fromAmino = function(_, isClassic) {
        _;
        isClassic;
        throw new Error("Amino not supported");
    };
    MsgSubmitMisbehaviour.prototype.toAmino = function(_) {
        _;
        throw new Error("Amino not supported");
    };
    MsgSubmitMisbehaviour.fromData = function(data, _) {
        _;
        var client_id = data.client_id, misbehaviour = data.misbehaviour, signer = data.signer;
        return new MsgSubmitMisbehaviour(client_id, misbehaviour, signer);
    };
    MsgSubmitMisbehaviour.prototype.toData = function(_) {
        _;
        var _a = this, client_id = _a.client_id, misbehaviour = _a.misbehaviour, signer = _a.signer;
        return {
            "@type": "/ibc.core.client.v1.MsgSubmitMisbehaviour",
            client_id: client_id,
            misbehaviour: misbehaviour,
            signer: signer
        };
    };
    MsgSubmitMisbehaviour.fromProto = function(proto, _) {
        _;
        return new MsgSubmitMisbehaviour(proto.clientId, proto.misbehaviour, proto.signer);
    };
    MsgSubmitMisbehaviour.prototype.toProto = function(_) {
        _;
        var _a = this, client_id = _a.client_id, misbehaviour = _a.misbehaviour, signer = _a.signer;
        return $lCsl4.MsgSubmitMisbehaviour.fromPartial({
            clientId: client_id,
            misbehaviour: misbehaviour,
            signer: signer
        });
    };
    MsgSubmitMisbehaviour.prototype.packAny = function(_) {
        _;
        return $c5FxR.Any.fromPartial({
            typeUrl: "/ibc.core.client.v1.MsgSubmitMisbehaviour",
            value: $lCsl4.MsgSubmitMisbehaviour.encode(this.toProto()).finish()
        });
    };
    MsgSubmitMisbehaviour.unpackAny = function(msgAny, _) {
        _;
        return MsgSubmitMisbehaviour.fromProto($lCsl4.MsgSubmitMisbehaviour.decode(msgAny.value));
    };
    return MsgSubmitMisbehaviour;
}($26Eqx.JSONSerializable);
module.exports.MsgSubmitMisbehaviour = $a3aeaa37ad21f5fe$var$MsgSubmitMisbehaviour;

});


parcelRegister("1BC4v", function(module, exports) {
"use strict";
var $12b6c7636be07d59$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $12b6c7636be07d59$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $12b6c7636be07d59$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$12b6c7636be07d59$var$__exportStar((parcelRequire("ileil")), module.exports);

$12b6c7636be07d59$var$__exportStar((parcelRequire("gFSLT")), module.exports);

$12b6c7636be07d59$var$__exportStar((parcelRequire("i3E9N")), module.exports);

$12b6c7636be07d59$var$__exportStar((parcelRequire("1k2Pt")), module.exports);

});
parcelRegister("ileil", function(module, exports) {
"use strict";
var $d5a546d6102c69f9$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $d5a546d6102c69f9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgConnectionOpenInit = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $6pjkd = parcelRequire("6pjkd");

var $gwXuB = parcelRequire("gwXuB");

var $4b2iF = parcelRequire("4b2iF");

var $d5a546d6102c69f9$var$long_1 = $d5a546d6102c69f9$var$__importDefault((parcelRequire("9A55m")));
/**
 * MsgConnectionOpenInit defines the msg sent by an account on Chain A to initialize a connection with Chain B.
 */ var $d5a546d6102c69f9$var$MsgConnectionOpenInit = /** @class */ function(_super) {
    $d5a546d6102c69f9$var$__extends(MsgConnectionOpenInit, _super);
    /**
     * @param client_id identifier of the port to use
     * @param counterparty
     * @param version
     * @param delay_period
     * @param signer signer address
     */ function MsgConnectionOpenInit(client_id, delay_period, signer, counterparty, version) {
        var _this = _super.call(this) || this;
        _this.client_id = client_id;
        _this.delay_period = delay_period;
        _this.signer = signer;
        _this.counterparty = counterparty;
        _this.version = version;
        return _this;
    }
    MsgConnectionOpenInit.fromAmino = function(_, isClassic) {
        _;
        isClassic;
        throw new Error("Amino not supported");
    };
    MsgConnectionOpenInit.prototype.toAmino = function(_) {
        _;
        throw new Error("Amino not supported");
    };
    MsgConnectionOpenInit.fromData = function(data, _) {
        _;
        var client_id = data.client_id, counterparty = data.counterparty, version = data.version, delay_period = data.delay_period, signer = data.signer;
        return new MsgConnectionOpenInit(client_id, Number.parseInt(delay_period), signer, counterparty ? $6pjkd.Counterparty.fromData(counterparty) : undefined, version ? $gwXuB.Version.fromData(version) : undefined);
    };
    MsgConnectionOpenInit.prototype.toData = function(_) {
        _;
        var _a = this, client_id = _a.client_id, counterparty = _a.counterparty, version = _a.version, delay_period = _a.delay_period, signer = _a.signer;
        return {
            "@type": "/ibc.core.connection.v1.MsgConnectionOpenInit",
            client_id: client_id,
            delay_period: delay_period.toFixed(),
            signer: signer,
            counterparty: counterparty ? counterparty.toData() : undefined,
            version: version ? version.toData() : undefined
        };
    };
    MsgConnectionOpenInit.fromProto = function(proto, _) {
        _;
        return new MsgConnectionOpenInit(proto.clientId, proto.delayPeriod.toNumber(), proto.signer, proto.counterparty ? $6pjkd.Counterparty.fromProto(proto.counterparty) : undefined, proto.version ? $gwXuB.Version.fromProto(proto.version) : undefined);
    };
    MsgConnectionOpenInit.prototype.toProto = function(_) {
        _;
        var _a = this, client_id = _a.client_id, counterparty = _a.counterparty, version = _a.version, delay_period = _a.delay_period, signer = _a.signer;
        return $4b2iF.MsgConnectionOpenInit.fromPartial({
            clientId: client_id,
            delayPeriod: $d5a546d6102c69f9$var$long_1.default.fromNumber(delay_period),
            signer: signer,
            counterparty: counterparty ? counterparty.toProto() : undefined,
            version: version ? version.toProto() : undefined
        });
    };
    MsgConnectionOpenInit.prototype.packAny = function(_) {
        _;
        return $c5FxR.Any.fromPartial({
            typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenInit",
            value: $4b2iF.MsgConnectionOpenInit.encode(this.toProto()).finish()
        });
    };
    MsgConnectionOpenInit.unpackAny = function(msgAny, _) {
        _;
        return MsgConnectionOpenInit.fromProto($4b2iF.MsgConnectionOpenInit.decode(msgAny.value));
    };
    return MsgConnectionOpenInit;
}($26Eqx.JSONSerializable);
module.exports.MsgConnectionOpenInit = $d5a546d6102c69f9$var$MsgConnectionOpenInit;

});
parcelRegister("6pjkd", function(module, exports) {
"use strict";
var $4aa4116cfeccd781$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Counterparty = void 0;

var $8WoN3 = parcelRequire("8WoN3");

var $26Eqx = parcelRequire("26Eqx");

var $6eJRA = parcelRequire("6eJRA");
/** Counterparty defines a channel end counterparty */ var $4aa4116cfeccd781$var$Counterparty = /** @class */ function(_super) {
    $4aa4116cfeccd781$var$__extends(Counterparty, _super);
    /**
     * @param client_id identifies the client on the counterparty chain associated with a given connection.
     * @param connection_id identifies the connection end on the counterparty chain associated with a given connection.
     * @param prefix commitment merkle prefix of the counterparty chain.
     */ function Counterparty(client_id, connection_id, prefix) {
        var _this = _super.call(this) || this;
        _this.client_id = client_id;
        _this.connection_id = connection_id;
        _this.prefix = prefix;
        return _this;
    }
    Counterparty.fromAmino = function(data) {
        var client_id = data.client_id, connection_id = data.connection_id, prefix = data.prefix;
        return new Counterparty(client_id, connection_id, prefix ? $6eJRA.MerklePrefix.fromAmino(prefix) : undefined);
    };
    Counterparty.prototype.toAmino = function() {
        var _a = this, client_id = _a.client_id, connection_id = _a.connection_id, prefix = _a.prefix;
        var res = {
            client_id: client_id,
            connection_id: connection_id,
            prefix: prefix
        };
        return res;
    };
    Counterparty.fromData = function(data) {
        var client_id = data.client_id, connection_id = data.connection_id, prefix = data.prefix;
        return new Counterparty(client_id, connection_id, prefix ? $6eJRA.MerklePrefix.fromData(prefix) : undefined);
    };
    Counterparty.prototype.toData = function() {
        var _a = this, client_id = _a.client_id, connection_id = _a.connection_id, prefix = _a.prefix;
        var res = {
            client_id: client_id,
            connection_id: connection_id,
            prefix: prefix ? prefix.toData() : undefined
        };
        return res;
    };
    Counterparty.fromProto = function(proto) {
        return new Counterparty(proto.clientId, proto.connectionId, proto.prefix ? $6eJRA.MerklePrefix.fromProto(proto.prefix) : undefined);
    };
    Counterparty.prototype.toProto = function() {
        var _a = this, client_id = _a.client_id, connection_id = _a.connection_id, prefix = _a.prefix;
        return $8WoN3.Counterparty.fromPartial({
            clientId: client_id,
            connectionId: connection_id,
            prefix: prefix ? prefix.toProto() : undefined
        });
    };
    return Counterparty;
}($26Eqx.JSONSerializable);
module.exports.Counterparty = $4aa4116cfeccd781$var$Counterparty;

});
parcelRegister("8WoN3", function(module, exports) {
"use strict";
var $6826f853a1d4f8cf$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Params = module.exports.Version = module.exports.ConnectionPaths = module.exports.ClientPaths = module.exports.Counterparty = module.exports.IdentifiedConnection = module.exports.ConnectionEnd = module.exports.stateToJSON = module.exports.stateFromJSON = module.exports.State = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $6826f853a1d4f8cf$var$long_1 = $6826f853a1d4f8cf$var$__importDefault((parcelRequire("9A55m")));

const $6826f853a1d4f8cf$var$minimal_1 = $6826f853a1d4f8cf$var$__importDefault((parcelRequire("i2pIU")));

var $8k8Xg = parcelRequire("8k8Xg");
module.exports.protobufPackage = "ibc.core.connection.v1";
/**
 * State defines if a connection is in one of the following states:
 * INIT, TRYOPEN, OPEN or UNINITIALIZED.
 */ var $6826f853a1d4f8cf$var$State;
(function(State) {
    /** STATE_UNINITIALIZED_UNSPECIFIED - Default State */ State[State["STATE_UNINITIALIZED_UNSPECIFIED"] = 0] = "STATE_UNINITIALIZED_UNSPECIFIED";
    /** STATE_INIT - A connection end has just started the opening handshake. */ State[State["STATE_INIT"] = 1] = "STATE_INIT";
    /**
     * STATE_TRYOPEN - A connection end has acknowledged the handshake step on the counterparty
     * chain.
     */ State[State["STATE_TRYOPEN"] = 2] = "STATE_TRYOPEN";
    /** STATE_OPEN - A connection end has completed the handshake. */ State[State["STATE_OPEN"] = 3] = "STATE_OPEN";
    State[State["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($6826f853a1d4f8cf$var$State = module.exports.State || (module.exports.State = {}));
function $6826f853a1d4f8cf$var$stateFromJSON(object) {
    switch(object){
        case 0:
        case "STATE_UNINITIALIZED_UNSPECIFIED":
            return $6826f853a1d4f8cf$var$State.STATE_UNINITIALIZED_UNSPECIFIED;
        case 1:
        case "STATE_INIT":
            return $6826f853a1d4f8cf$var$State.STATE_INIT;
        case 2:
        case "STATE_TRYOPEN":
            return $6826f853a1d4f8cf$var$State.STATE_TRYOPEN;
        case 3:
        case "STATE_OPEN":
            return $6826f853a1d4f8cf$var$State.STATE_OPEN;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $6826f853a1d4f8cf$var$State.UNRECOGNIZED;
    }
}
module.exports.stateFromJSON = $6826f853a1d4f8cf$var$stateFromJSON;
function $6826f853a1d4f8cf$var$stateToJSON(object) {
    switch(object){
        case $6826f853a1d4f8cf$var$State.STATE_UNINITIALIZED_UNSPECIFIED:
            return "STATE_UNINITIALIZED_UNSPECIFIED";
        case $6826f853a1d4f8cf$var$State.STATE_INIT:
            return "STATE_INIT";
        case $6826f853a1d4f8cf$var$State.STATE_TRYOPEN:
            return "STATE_TRYOPEN";
        case $6826f853a1d4f8cf$var$State.STATE_OPEN:
            return "STATE_OPEN";
        default:
            return "UNKNOWN";
    }
}
module.exports.stateToJSON = $6826f853a1d4f8cf$var$stateToJSON;
const $6826f853a1d4f8cf$var$baseConnectionEnd = {
    clientId: "",
    state: 0,
    delayPeriod: $6826f853a1d4f8cf$var$long_1.default.UZERO
};
module.exports.ConnectionEnd = {
    encode (message, writer = $6826f853a1d4f8cf$var$minimal_1.default.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        for (const v of message.versions)module.exports.Version.encode(v, writer.uint32(18).fork()).ldelim();
        if (message.state !== 0) writer.uint32(24).int32(message.state);
        if (message.counterparty !== undefined) module.exports.Counterparty.encode(message.counterparty, writer.uint32(34).fork()).ldelim();
        if (!message.delayPeriod.isZero()) writer.uint32(40).uint64(message.delayPeriod);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6826f853a1d4f8cf$var$minimal_1.default.Reader ? input : new $6826f853a1d4f8cf$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $6826f853a1d4f8cf$var$baseConnectionEnd);
        message.versions = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.versions.push(module.exports.Version.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.state = reader.int32();
                    break;
                case 4:
                    message.counterparty = module.exports.Counterparty.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.delayPeriod = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $6826f853a1d4f8cf$var$baseConnectionEnd);
        message.versions = [];
        if (object.clientId !== undefined && object.clientId !== null) message.clientId = String(object.clientId);
        else message.clientId = "";
        if (object.versions !== undefined && object.versions !== null) for (const e of object.versions)message.versions.push(module.exports.Version.fromJSON(e));
        if (object.state !== undefined && object.state !== null) message.state = $6826f853a1d4f8cf$var$stateFromJSON(object.state);
        else message.state = 0;
        if (object.counterparty !== undefined && object.counterparty !== null) message.counterparty = module.exports.Counterparty.fromJSON(object.counterparty);
        else message.counterparty = undefined;
        if (object.delayPeriod !== undefined && object.delayPeriod !== null) message.delayPeriod = $6826f853a1d4f8cf$var$long_1.default.fromString(object.delayPeriod);
        else message.delayPeriod = $6826f853a1d4f8cf$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        if (message.versions) obj.versions = message.versions.map((e)=>e ? module.exports.Version.toJSON(e) : undefined);
        else obj.versions = [];
        message.state !== undefined && (obj.state = $6826f853a1d4f8cf$var$stateToJSON(message.state));
        message.counterparty !== undefined && (obj.counterparty = message.counterparty ? module.exports.Counterparty.toJSON(message.counterparty) : undefined);
        message.delayPeriod !== undefined && (obj.delayPeriod = (message.delayPeriod || $6826f853a1d4f8cf$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $6826f853a1d4f8cf$var$baseConnectionEnd);
        message.versions = [];
        if (object.clientId !== undefined && object.clientId !== null) message.clientId = object.clientId;
        else message.clientId = "";
        if (object.versions !== undefined && object.versions !== null) for (const e of object.versions)message.versions.push(module.exports.Version.fromPartial(e));
        if (object.state !== undefined && object.state !== null) message.state = object.state;
        else message.state = 0;
        if (object.counterparty !== undefined && object.counterparty !== null) message.counterparty = module.exports.Counterparty.fromPartial(object.counterparty);
        else message.counterparty = undefined;
        if (object.delayPeriod !== undefined && object.delayPeriod !== null) message.delayPeriod = object.delayPeriod;
        else message.delayPeriod = $6826f853a1d4f8cf$var$long_1.default.UZERO;
        return message;
    }
};
const $6826f853a1d4f8cf$var$baseIdentifiedConnection = {
    id: "",
    clientId: "",
    state: 0,
    delayPeriod: $6826f853a1d4f8cf$var$long_1.default.UZERO
};
module.exports.IdentifiedConnection = {
    encode (message, writer = $6826f853a1d4f8cf$var$minimal_1.default.Writer.create()) {
        if (message.id !== "") writer.uint32(10).string(message.id);
        if (message.clientId !== "") writer.uint32(18).string(message.clientId);
        for (const v of message.versions)module.exports.Version.encode(v, writer.uint32(26).fork()).ldelim();
        if (message.state !== 0) writer.uint32(32).int32(message.state);
        if (message.counterparty !== undefined) module.exports.Counterparty.encode(message.counterparty, writer.uint32(42).fork()).ldelim();
        if (!message.delayPeriod.isZero()) writer.uint32(48).uint64(message.delayPeriod);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6826f853a1d4f8cf$var$minimal_1.default.Reader ? input : new $6826f853a1d4f8cf$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $6826f853a1d4f8cf$var$baseIdentifiedConnection);
        message.versions = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.clientId = reader.string();
                    break;
                case 3:
                    message.versions.push(module.exports.Version.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.state = reader.int32();
                    break;
                case 5:
                    message.counterparty = module.exports.Counterparty.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.delayPeriod = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $6826f853a1d4f8cf$var$baseIdentifiedConnection);
        message.versions = [];
        if (object.id !== undefined && object.id !== null) message.id = String(object.id);
        else message.id = "";
        if (object.clientId !== undefined && object.clientId !== null) message.clientId = String(object.clientId);
        else message.clientId = "";
        if (object.versions !== undefined && object.versions !== null) for (const e of object.versions)message.versions.push(module.exports.Version.fromJSON(e));
        if (object.state !== undefined && object.state !== null) message.state = $6826f853a1d4f8cf$var$stateFromJSON(object.state);
        else message.state = 0;
        if (object.counterparty !== undefined && object.counterparty !== null) message.counterparty = module.exports.Counterparty.fromJSON(object.counterparty);
        else message.counterparty = undefined;
        if (object.delayPeriod !== undefined && object.delayPeriod !== null) message.delayPeriod = $6826f853a1d4f8cf$var$long_1.default.fromString(object.delayPeriod);
        else message.delayPeriod = $6826f853a1d4f8cf$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.id !== undefined && (obj.id = message.id);
        message.clientId !== undefined && (obj.clientId = message.clientId);
        if (message.versions) obj.versions = message.versions.map((e)=>e ? module.exports.Version.toJSON(e) : undefined);
        else obj.versions = [];
        message.state !== undefined && (obj.state = $6826f853a1d4f8cf$var$stateToJSON(message.state));
        message.counterparty !== undefined && (obj.counterparty = message.counterparty ? module.exports.Counterparty.toJSON(message.counterparty) : undefined);
        message.delayPeriod !== undefined && (obj.delayPeriod = (message.delayPeriod || $6826f853a1d4f8cf$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $6826f853a1d4f8cf$var$baseIdentifiedConnection);
        message.versions = [];
        if (object.id !== undefined && object.id !== null) message.id = object.id;
        else message.id = "";
        if (object.clientId !== undefined && object.clientId !== null) message.clientId = object.clientId;
        else message.clientId = "";
        if (object.versions !== undefined && object.versions !== null) for (const e of object.versions)message.versions.push(module.exports.Version.fromPartial(e));
        if (object.state !== undefined && object.state !== null) message.state = object.state;
        else message.state = 0;
        if (object.counterparty !== undefined && object.counterparty !== null) message.counterparty = module.exports.Counterparty.fromPartial(object.counterparty);
        else message.counterparty = undefined;
        if (object.delayPeriod !== undefined && object.delayPeriod !== null) message.delayPeriod = object.delayPeriod;
        else message.delayPeriod = $6826f853a1d4f8cf$var$long_1.default.UZERO;
        return message;
    }
};
const $6826f853a1d4f8cf$var$baseCounterparty = {
    clientId: "",
    connectionId: ""
};
module.exports.Counterparty = {
    encode (message, writer = $6826f853a1d4f8cf$var$minimal_1.default.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.connectionId !== "") writer.uint32(18).string(message.connectionId);
        if (message.prefix !== undefined) $8k8Xg.MerklePrefix.encode(message.prefix, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6826f853a1d4f8cf$var$minimal_1.default.Reader ? input : new $6826f853a1d4f8cf$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $6826f853a1d4f8cf$var$baseCounterparty);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.connectionId = reader.string();
                    break;
                case 3:
                    message.prefix = $8k8Xg.MerklePrefix.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $6826f853a1d4f8cf$var$baseCounterparty);
        if (object.clientId !== undefined && object.clientId !== null) message.clientId = String(object.clientId);
        else message.clientId = "";
        if (object.connectionId !== undefined && object.connectionId !== null) message.connectionId = String(object.connectionId);
        else message.connectionId = "";
        if (object.prefix !== undefined && object.prefix !== null) message.prefix = $8k8Xg.MerklePrefix.fromJSON(object.prefix);
        else message.prefix = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        message.prefix !== undefined && (obj.prefix = message.prefix ? $8k8Xg.MerklePrefix.toJSON(message.prefix) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $6826f853a1d4f8cf$var$baseCounterparty);
        if (object.clientId !== undefined && object.clientId !== null) message.clientId = object.clientId;
        else message.clientId = "";
        if (object.connectionId !== undefined && object.connectionId !== null) message.connectionId = object.connectionId;
        else message.connectionId = "";
        if (object.prefix !== undefined && object.prefix !== null) message.prefix = $8k8Xg.MerklePrefix.fromPartial(object.prefix);
        else message.prefix = undefined;
        return message;
    }
};
const $6826f853a1d4f8cf$var$baseClientPaths = {
    paths: ""
};
module.exports.ClientPaths = {
    encode (message, writer = $6826f853a1d4f8cf$var$minimal_1.default.Writer.create()) {
        for (const v of message.paths)writer.uint32(10).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6826f853a1d4f8cf$var$minimal_1.default.Reader ? input : new $6826f853a1d4f8cf$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $6826f853a1d4f8cf$var$baseClientPaths);
        message.paths = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $6826f853a1d4f8cf$var$baseClientPaths);
        message.paths = [];
        if (object.paths !== undefined && object.paths !== null) for (const e of object.paths)message.paths.push(String(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.paths) obj.paths = message.paths.map((e)=>e);
        else obj.paths = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $6826f853a1d4f8cf$var$baseClientPaths);
        message.paths = [];
        if (object.paths !== undefined && object.paths !== null) for (const e of object.paths)message.paths.push(e);
        return message;
    }
};
const $6826f853a1d4f8cf$var$baseConnectionPaths = {
    clientId: "",
    paths: ""
};
module.exports.ConnectionPaths = {
    encode (message, writer = $6826f853a1d4f8cf$var$minimal_1.default.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        for (const v of message.paths)writer.uint32(18).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6826f853a1d4f8cf$var$minimal_1.default.Reader ? input : new $6826f853a1d4f8cf$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $6826f853a1d4f8cf$var$baseConnectionPaths);
        message.paths = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.paths.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $6826f853a1d4f8cf$var$baseConnectionPaths);
        message.paths = [];
        if (object.clientId !== undefined && object.clientId !== null) message.clientId = String(object.clientId);
        else message.clientId = "";
        if (object.paths !== undefined && object.paths !== null) for (const e of object.paths)message.paths.push(String(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        if (message.paths) obj.paths = message.paths.map((e)=>e);
        else obj.paths = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $6826f853a1d4f8cf$var$baseConnectionPaths);
        message.paths = [];
        if (object.clientId !== undefined && object.clientId !== null) message.clientId = object.clientId;
        else message.clientId = "";
        if (object.paths !== undefined && object.paths !== null) for (const e of object.paths)message.paths.push(e);
        return message;
    }
};
const $6826f853a1d4f8cf$var$baseVersion = {
    identifier: "",
    features: ""
};
module.exports.Version = {
    encode (message, writer = $6826f853a1d4f8cf$var$minimal_1.default.Writer.create()) {
        if (message.identifier !== "") writer.uint32(10).string(message.identifier);
        for (const v of message.features)writer.uint32(18).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6826f853a1d4f8cf$var$minimal_1.default.Reader ? input : new $6826f853a1d4f8cf$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $6826f853a1d4f8cf$var$baseVersion);
        message.features = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.identifier = reader.string();
                    break;
                case 2:
                    message.features.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $6826f853a1d4f8cf$var$baseVersion);
        message.features = [];
        if (object.identifier !== undefined && object.identifier !== null) message.identifier = String(object.identifier);
        else message.identifier = "";
        if (object.features !== undefined && object.features !== null) for (const e of object.features)message.features.push(String(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.identifier !== undefined && (obj.identifier = message.identifier);
        if (message.features) obj.features = message.features.map((e)=>e);
        else obj.features = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $6826f853a1d4f8cf$var$baseVersion);
        message.features = [];
        if (object.identifier !== undefined && object.identifier !== null) message.identifier = object.identifier;
        else message.identifier = "";
        if (object.features !== undefined && object.features !== null) for (const e of object.features)message.features.push(e);
        return message;
    }
};
const $6826f853a1d4f8cf$var$baseParams = {
    maxExpectedTimePerBlock: $6826f853a1d4f8cf$var$long_1.default.UZERO
};
module.exports.Params = {
    encode (message, writer = $6826f853a1d4f8cf$var$minimal_1.default.Writer.create()) {
        if (!message.maxExpectedTimePerBlock.isZero()) writer.uint32(8).uint64(message.maxExpectedTimePerBlock);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6826f853a1d4f8cf$var$minimal_1.default.Reader ? input : new $6826f853a1d4f8cf$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $6826f853a1d4f8cf$var$baseParams);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.maxExpectedTimePerBlock = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $6826f853a1d4f8cf$var$baseParams);
        if (object.maxExpectedTimePerBlock !== undefined && object.maxExpectedTimePerBlock !== null) message.maxExpectedTimePerBlock = $6826f853a1d4f8cf$var$long_1.default.fromString(object.maxExpectedTimePerBlock);
        else message.maxExpectedTimePerBlock = $6826f853a1d4f8cf$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.maxExpectedTimePerBlock !== undefined && (obj.maxExpectedTimePerBlock = (message.maxExpectedTimePerBlock || $6826f853a1d4f8cf$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $6826f853a1d4f8cf$var$baseParams);
        if (object.maxExpectedTimePerBlock !== undefined && object.maxExpectedTimePerBlock !== null) message.maxExpectedTimePerBlock = object.maxExpectedTimePerBlock;
        else message.maxExpectedTimePerBlock = $6826f853a1d4f8cf$var$long_1.default.UZERO;
        return message;
    }
};
if ($6826f853a1d4f8cf$var$minimal_1.default.util.Long !== $6826f853a1d4f8cf$var$long_1.default) {
    $6826f853a1d4f8cf$var$minimal_1.default.util.Long = $6826f853a1d4f8cf$var$long_1.default;
    $6826f853a1d4f8cf$var$minimal_1.default.configure();
}

});

parcelRegister("6eJRA", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $48a7a066f316f984$require$Buffer = $gzLuY.Buffer;
"use strict";
var $48a7a066f316f984$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MerklePrefix = void 0;

var $8k8Xg = parcelRequire("8k8Xg");

var $26Eqx = parcelRequire("26Eqx");
/*
 * MerklePrefix is merkle path prefixed to the key.
 * The constructed key from the Path and the key will be append(Path.KeyPath,
 * append(Path.KeyPrefix, key...))
 */ var $48a7a066f316f984$var$MerklePrefix = /** @class */ function(_super) {
    $48a7a066f316f984$var$__extends(MerklePrefix, _super);
    /**
     * @param key_prefix
     */ function MerklePrefix(key_prefix) {
        var _this = _super.call(this) || this;
        _this.key_prefix = key_prefix;
        return _this;
    }
    MerklePrefix.fromAmino = function(data) {
        var key_prefix = data.key_prefix;
        return new MerklePrefix(key_prefix);
    };
    MerklePrefix.prototype.toAmino = function() {
        var key_prefix = this.key_prefix;
        var res = {
            key_prefix: key_prefix
        };
        return res;
    };
    MerklePrefix.fromData = function(data) {
        var key_prefix = data.key_prefix;
        return new MerklePrefix(key_prefix);
    };
    MerklePrefix.prototype.toData = function() {
        var key_prefix = this.key_prefix;
        var res = {
            key_prefix: key_prefix
        };
        return res;
    };
    MerklePrefix.fromProto = function(proto) {
        return new MerklePrefix($48a7a066f316f984$require$Buffer.from(proto.keyPrefix).toString("base64"));
    };
    MerklePrefix.prototype.toProto = function() {
        var key_prefix = this.key_prefix;
        return $8k8Xg.MerklePrefix.fromPartial({
            keyPrefix: $48a7a066f316f984$require$Buffer.from(key_prefix, "base64")
        });
    };
    return MerklePrefix;
}($26Eqx.JSONSerializable);
module.exports.MerklePrefix = $48a7a066f316f984$var$MerklePrefix;

});


parcelRegister("gwXuB", function(module, exports) {
"use strict";
var $c08dc878b845318d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Version = void 0;

var $8WoN3 = parcelRequire("8WoN3");

var $26Eqx = parcelRequire("26Eqx");
/*
 * Version defines the versioning scheme used to negotiate the IBC verison in the connection handshake.
 */ var $c08dc878b845318d$var$Version = /** @class */ function(_super) {
    $c08dc878b845318d$var$__extends(Version, _super);
    /**
     * @param identifier unique version identifier
     * @param features list of features compatible with the specified identifier
     */ function Version(identifier, features) {
        var _this = _super.call(this) || this;
        _this.identifier = identifier;
        _this.features = features;
        return _this;
    }
    Version.fromAmino = function(data) {
        var identifier = data.identifier, features = data.features;
        return new Version(identifier, features);
    };
    Version.prototype.toAmino = function() {
        var _a = this, identifier = _a.identifier, features = _a.features;
        var res = {
            identifier: identifier,
            features: features
        };
        return res;
    };
    Version.fromData = function(data) {
        var identifier = data.identifier, features = data.features;
        return new Version(identifier, features);
    };
    Version.prototype.toData = function() {
        var _a = this, identifier = _a.identifier, features = _a.features;
        var res = {
            identifier: identifier,
            features: features
        };
        return res;
    };
    Version.fromProto = function(proto) {
        return new Version(proto.identifier, proto.features);
    };
    Version.prototype.toProto = function() {
        var _a = this, identifier = _a.identifier, features = _a.features;
        return $8WoN3.Version.fromPartial({
            identifier: identifier,
            features: features
        });
    };
    return Version;
}($26Eqx.JSONSerializable);
module.exports.Version = $c08dc878b845318d$var$Version;

});

parcelRegister("4b2iF", function(module, exports) {
"use strict";
var $30a9f93e06c9cff5$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GrpcWebImpl = module.exports.MsgConnectionOpenConfirmDesc = module.exports.MsgConnectionOpenAckDesc = module.exports.MsgConnectionOpenTryDesc = module.exports.MsgConnectionOpenInitDesc = module.exports.MsgDesc = module.exports.MsgClientImpl = module.exports.MsgConnectionOpenConfirmResponse = module.exports.MsgConnectionOpenConfirm = module.exports.MsgConnectionOpenAckResponse = module.exports.MsgConnectionOpenAck = module.exports.MsgConnectionOpenTryResponse = module.exports.MsgConnectionOpenTry = module.exports.MsgConnectionOpenInitResponse = module.exports.MsgConnectionOpenInit = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $30a9f93e06c9cff5$var$long_1 = $30a9f93e06c9cff5$var$__importDefault((parcelRequire("9A55m")));

var $jXVni = parcelRequire("jXVni");

const $30a9f93e06c9cff5$var$minimal_1 = $30a9f93e06c9cff5$var$__importDefault((parcelRequire("i2pIU")));

var $8WoN3 = parcelRequire("8WoN3");

var $c5FxR = parcelRequire("c5FxR");

var $yqmJM = parcelRequire("yqmJM");

var $1pqjL = parcelRequire("1pqjL");
module.exports.protobufPackage = "ibc.core.connection.v1";
const $30a9f93e06c9cff5$var$baseMsgConnectionOpenInit = {
    clientId: "",
    delayPeriod: $30a9f93e06c9cff5$var$long_1.default.UZERO,
    signer: ""
};
module.exports.MsgConnectionOpenInit = {
    encode (message, writer = $30a9f93e06c9cff5$var$minimal_1.default.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.counterparty !== undefined) $8WoN3.Counterparty.encode(message.counterparty, writer.uint32(18).fork()).ldelim();
        if (message.version !== undefined) $8WoN3.Version.encode(message.version, writer.uint32(26).fork()).ldelim();
        if (!message.delayPeriod.isZero()) writer.uint32(32).uint64(message.delayPeriod);
        if (message.signer !== "") writer.uint32(42).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $30a9f93e06c9cff5$var$minimal_1.default.Reader ? input : new $30a9f93e06c9cff5$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $30a9f93e06c9cff5$var$baseMsgConnectionOpenInit);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.counterparty = $8WoN3.Counterparty.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.version = $8WoN3.Version.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.delayPeriod = reader.uint64();
                    break;
                case 5:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $30a9f93e06c9cff5$var$baseMsgConnectionOpenInit);
        if (object.clientId !== undefined && object.clientId !== null) message.clientId = String(object.clientId);
        else message.clientId = "";
        if (object.counterparty !== undefined && object.counterparty !== null) message.counterparty = $8WoN3.Counterparty.fromJSON(object.counterparty);
        else message.counterparty = undefined;
        if (object.version !== undefined && object.version !== null) message.version = $8WoN3.Version.fromJSON(object.version);
        else message.version = undefined;
        if (object.delayPeriod !== undefined && object.delayPeriod !== null) message.delayPeriod = $30a9f93e06c9cff5$var$long_1.default.fromString(object.delayPeriod);
        else message.delayPeriod = $30a9f93e06c9cff5$var$long_1.default.UZERO;
        if (object.signer !== undefined && object.signer !== null) message.signer = String(object.signer);
        else message.signer = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.counterparty !== undefined && (obj.counterparty = message.counterparty ? $8WoN3.Counterparty.toJSON(message.counterparty) : undefined);
        message.version !== undefined && (obj.version = message.version ? $8WoN3.Version.toJSON(message.version) : undefined);
        message.delayPeriod !== undefined && (obj.delayPeriod = (message.delayPeriod || $30a9f93e06c9cff5$var$long_1.default.UZERO).toString());
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $30a9f93e06c9cff5$var$baseMsgConnectionOpenInit);
        if (object.clientId !== undefined && object.clientId !== null) message.clientId = object.clientId;
        else message.clientId = "";
        if (object.counterparty !== undefined && object.counterparty !== null) message.counterparty = $8WoN3.Counterparty.fromPartial(object.counterparty);
        else message.counterparty = undefined;
        if (object.version !== undefined && object.version !== null) message.version = $8WoN3.Version.fromPartial(object.version);
        else message.version = undefined;
        if (object.delayPeriod !== undefined && object.delayPeriod !== null) message.delayPeriod = object.delayPeriod;
        else message.delayPeriod = $30a9f93e06c9cff5$var$long_1.default.UZERO;
        if (object.signer !== undefined && object.signer !== null) message.signer = object.signer;
        else message.signer = "";
        return message;
    }
};
const $30a9f93e06c9cff5$var$baseMsgConnectionOpenInitResponse = {};
module.exports.MsgConnectionOpenInitResponse = {
    encode (_, writer = $30a9f93e06c9cff5$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $30a9f93e06c9cff5$var$minimal_1.default.Reader ? input : new $30a9f93e06c9cff5$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $30a9f93e06c9cff5$var$baseMsgConnectionOpenInitResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $30a9f93e06c9cff5$var$baseMsgConnectionOpenInitResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $30a9f93e06c9cff5$var$baseMsgConnectionOpenInitResponse);
        return message;
    }
};
const $30a9f93e06c9cff5$var$baseMsgConnectionOpenTry = {
    clientId: "",
    previousConnectionId: "",
    delayPeriod: $30a9f93e06c9cff5$var$long_1.default.UZERO,
    signer: ""
};
module.exports.MsgConnectionOpenTry = {
    encode (message, writer = $30a9f93e06c9cff5$var$minimal_1.default.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.previousConnectionId !== "") writer.uint32(18).string(message.previousConnectionId);
        if (message.clientState !== undefined) $c5FxR.Any.encode(message.clientState, writer.uint32(26).fork()).ldelim();
        if (message.counterparty !== undefined) $8WoN3.Counterparty.encode(message.counterparty, writer.uint32(34).fork()).ldelim();
        if (!message.delayPeriod.isZero()) writer.uint32(40).uint64(message.delayPeriod);
        for (const v of message.counterpartyVersions)$8WoN3.Version.encode(v, writer.uint32(50).fork()).ldelim();
        if (message.proofHeight !== undefined) $yqmJM.Height.encode(message.proofHeight, writer.uint32(58).fork()).ldelim();
        if (message.proofInit.length !== 0) writer.uint32(66).bytes(message.proofInit);
        if (message.proofClient.length !== 0) writer.uint32(74).bytes(message.proofClient);
        if (message.proofConsensus.length !== 0) writer.uint32(82).bytes(message.proofConsensus);
        if (message.consensusHeight !== undefined) $yqmJM.Height.encode(message.consensusHeight, writer.uint32(90).fork()).ldelim();
        if (message.signer !== "") writer.uint32(98).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $30a9f93e06c9cff5$var$minimal_1.default.Reader ? input : new $30a9f93e06c9cff5$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $30a9f93e06c9cff5$var$baseMsgConnectionOpenTry);
        message.counterpartyVersions = [];
        message.proofInit = new Uint8Array();
        message.proofClient = new Uint8Array();
        message.proofConsensus = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.previousConnectionId = reader.string();
                    break;
                case 3:
                    message.clientState = $c5FxR.Any.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.counterparty = $8WoN3.Counterparty.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.delayPeriod = reader.uint64();
                    break;
                case 6:
                    message.counterpartyVersions.push($8WoN3.Version.decode(reader, reader.uint32()));
                    break;
                case 7:
                    message.proofHeight = $yqmJM.Height.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.proofInit = reader.bytes();
                    break;
                case 9:
                    message.proofClient = reader.bytes();
                    break;
                case 10:
                    message.proofConsensus = reader.bytes();
                    break;
                case 11:
                    message.consensusHeight = $yqmJM.Height.decode(reader, reader.uint32());
                    break;
                case 12:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $30a9f93e06c9cff5$var$baseMsgConnectionOpenTry);
        message.counterpartyVersions = [];
        message.proofInit = new Uint8Array();
        message.proofClient = new Uint8Array();
        message.proofConsensus = new Uint8Array();
        if (object.clientId !== undefined && object.clientId !== null) message.clientId = String(object.clientId);
        else message.clientId = "";
        if (object.previousConnectionId !== undefined && object.previousConnectionId !== null) message.previousConnectionId = String(object.previousConnectionId);
        else message.previousConnectionId = "";
        if (object.clientState !== undefined && object.clientState !== null) message.clientState = $c5FxR.Any.fromJSON(object.clientState);
        else message.clientState = undefined;
        if (object.counterparty !== undefined && object.counterparty !== null) message.counterparty = $8WoN3.Counterparty.fromJSON(object.counterparty);
        else message.counterparty = undefined;
        if (object.delayPeriod !== undefined && object.delayPeriod !== null) message.delayPeriod = $30a9f93e06c9cff5$var$long_1.default.fromString(object.delayPeriod);
        else message.delayPeriod = $30a9f93e06c9cff5$var$long_1.default.UZERO;
        if (object.counterpartyVersions !== undefined && object.counterpartyVersions !== null) for (const e of object.counterpartyVersions)message.counterpartyVersions.push($8WoN3.Version.fromJSON(e));
        if (object.proofHeight !== undefined && object.proofHeight !== null) message.proofHeight = $yqmJM.Height.fromJSON(object.proofHeight);
        else message.proofHeight = undefined;
        if (object.proofInit !== undefined && object.proofInit !== null) message.proofInit = $30a9f93e06c9cff5$var$bytesFromBase64(object.proofInit);
        if (object.proofClient !== undefined && object.proofClient !== null) message.proofClient = $30a9f93e06c9cff5$var$bytesFromBase64(object.proofClient);
        if (object.proofConsensus !== undefined && object.proofConsensus !== null) message.proofConsensus = $30a9f93e06c9cff5$var$bytesFromBase64(object.proofConsensus);
        if (object.consensusHeight !== undefined && object.consensusHeight !== null) message.consensusHeight = $yqmJM.Height.fromJSON(object.consensusHeight);
        else message.consensusHeight = undefined;
        if (object.signer !== undefined && object.signer !== null) message.signer = String(object.signer);
        else message.signer = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.previousConnectionId !== undefined && (obj.previousConnectionId = message.previousConnectionId);
        message.clientState !== undefined && (obj.clientState = message.clientState ? $c5FxR.Any.toJSON(message.clientState) : undefined);
        message.counterparty !== undefined && (obj.counterparty = message.counterparty ? $8WoN3.Counterparty.toJSON(message.counterparty) : undefined);
        message.delayPeriod !== undefined && (obj.delayPeriod = (message.delayPeriod || $30a9f93e06c9cff5$var$long_1.default.UZERO).toString());
        if (message.counterpartyVersions) obj.counterpartyVersions = message.counterpartyVersions.map((e)=>e ? $8WoN3.Version.toJSON(e) : undefined);
        else obj.counterpartyVersions = [];
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $yqmJM.Height.toJSON(message.proofHeight) : undefined);
        message.proofInit !== undefined && (obj.proofInit = $30a9f93e06c9cff5$var$base64FromBytes(message.proofInit !== undefined ? message.proofInit : new Uint8Array()));
        message.proofClient !== undefined && (obj.proofClient = $30a9f93e06c9cff5$var$base64FromBytes(message.proofClient !== undefined ? message.proofClient : new Uint8Array()));
        message.proofConsensus !== undefined && (obj.proofConsensus = $30a9f93e06c9cff5$var$base64FromBytes(message.proofConsensus !== undefined ? message.proofConsensus : new Uint8Array()));
        message.consensusHeight !== undefined && (obj.consensusHeight = message.consensusHeight ? $yqmJM.Height.toJSON(message.consensusHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $30a9f93e06c9cff5$var$baseMsgConnectionOpenTry);
        message.counterpartyVersions = [];
        if (object.clientId !== undefined && object.clientId !== null) message.clientId = object.clientId;
        else message.clientId = "";
        if (object.previousConnectionId !== undefined && object.previousConnectionId !== null) message.previousConnectionId = object.previousConnectionId;
        else message.previousConnectionId = "";
        if (object.clientState !== undefined && object.clientState !== null) message.clientState = $c5FxR.Any.fromPartial(object.clientState);
        else message.clientState = undefined;
        if (object.counterparty !== undefined && object.counterparty !== null) message.counterparty = $8WoN3.Counterparty.fromPartial(object.counterparty);
        else message.counterparty = undefined;
        if (object.delayPeriod !== undefined && object.delayPeriod !== null) message.delayPeriod = object.delayPeriod;
        else message.delayPeriod = $30a9f93e06c9cff5$var$long_1.default.UZERO;
        if (object.counterpartyVersions !== undefined && object.counterpartyVersions !== null) for (const e of object.counterpartyVersions)message.counterpartyVersions.push($8WoN3.Version.fromPartial(e));
        if (object.proofHeight !== undefined && object.proofHeight !== null) message.proofHeight = $yqmJM.Height.fromPartial(object.proofHeight);
        else message.proofHeight = undefined;
        if (object.proofInit !== undefined && object.proofInit !== null) message.proofInit = object.proofInit;
        else message.proofInit = new Uint8Array();
        if (object.proofClient !== undefined && object.proofClient !== null) message.proofClient = object.proofClient;
        else message.proofClient = new Uint8Array();
        if (object.proofConsensus !== undefined && object.proofConsensus !== null) message.proofConsensus = object.proofConsensus;
        else message.proofConsensus = new Uint8Array();
        if (object.consensusHeight !== undefined && object.consensusHeight !== null) message.consensusHeight = $yqmJM.Height.fromPartial(object.consensusHeight);
        else message.consensusHeight = undefined;
        if (object.signer !== undefined && object.signer !== null) message.signer = object.signer;
        else message.signer = "";
        return message;
    }
};
const $30a9f93e06c9cff5$var$baseMsgConnectionOpenTryResponse = {};
module.exports.MsgConnectionOpenTryResponse = {
    encode (_, writer = $30a9f93e06c9cff5$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $30a9f93e06c9cff5$var$minimal_1.default.Reader ? input : new $30a9f93e06c9cff5$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $30a9f93e06c9cff5$var$baseMsgConnectionOpenTryResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $30a9f93e06c9cff5$var$baseMsgConnectionOpenTryResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $30a9f93e06c9cff5$var$baseMsgConnectionOpenTryResponse);
        return message;
    }
};
const $30a9f93e06c9cff5$var$baseMsgConnectionOpenAck = {
    connectionId: "",
    counterpartyConnectionId: "",
    signer: ""
};
module.exports.MsgConnectionOpenAck = {
    encode (message, writer = $30a9f93e06c9cff5$var$minimal_1.default.Writer.create()) {
        if (message.connectionId !== "") writer.uint32(10).string(message.connectionId);
        if (message.counterpartyConnectionId !== "") writer.uint32(18).string(message.counterpartyConnectionId);
        if (message.version !== undefined) $8WoN3.Version.encode(message.version, writer.uint32(26).fork()).ldelim();
        if (message.clientState !== undefined) $c5FxR.Any.encode(message.clientState, writer.uint32(34).fork()).ldelim();
        if (message.proofHeight !== undefined) $yqmJM.Height.encode(message.proofHeight, writer.uint32(42).fork()).ldelim();
        if (message.proofTry.length !== 0) writer.uint32(50).bytes(message.proofTry);
        if (message.proofClient.length !== 0) writer.uint32(58).bytes(message.proofClient);
        if (message.proofConsensus.length !== 0) writer.uint32(66).bytes(message.proofConsensus);
        if (message.consensusHeight !== undefined) $yqmJM.Height.encode(message.consensusHeight, writer.uint32(74).fork()).ldelim();
        if (message.signer !== "") writer.uint32(82).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $30a9f93e06c9cff5$var$minimal_1.default.Reader ? input : new $30a9f93e06c9cff5$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $30a9f93e06c9cff5$var$baseMsgConnectionOpenAck);
        message.proofTry = new Uint8Array();
        message.proofClient = new Uint8Array();
        message.proofConsensus = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connectionId = reader.string();
                    break;
                case 2:
                    message.counterpartyConnectionId = reader.string();
                    break;
                case 3:
                    message.version = $8WoN3.Version.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.clientState = $c5FxR.Any.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.proofHeight = $yqmJM.Height.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.proofTry = reader.bytes();
                    break;
                case 7:
                    message.proofClient = reader.bytes();
                    break;
                case 8:
                    message.proofConsensus = reader.bytes();
                    break;
                case 9:
                    message.consensusHeight = $yqmJM.Height.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $30a9f93e06c9cff5$var$baseMsgConnectionOpenAck);
        message.proofTry = new Uint8Array();
        message.proofClient = new Uint8Array();
        message.proofConsensus = new Uint8Array();
        if (object.connectionId !== undefined && object.connectionId !== null) message.connectionId = String(object.connectionId);
        else message.connectionId = "";
        if (object.counterpartyConnectionId !== undefined && object.counterpartyConnectionId !== null) message.counterpartyConnectionId = String(object.counterpartyConnectionId);
        else message.counterpartyConnectionId = "";
        if (object.version !== undefined && object.version !== null) message.version = $8WoN3.Version.fromJSON(object.version);
        else message.version = undefined;
        if (object.clientState !== undefined && object.clientState !== null) message.clientState = $c5FxR.Any.fromJSON(object.clientState);
        else message.clientState = undefined;
        if (object.proofHeight !== undefined && object.proofHeight !== null) message.proofHeight = $yqmJM.Height.fromJSON(object.proofHeight);
        else message.proofHeight = undefined;
        if (object.proofTry !== undefined && object.proofTry !== null) message.proofTry = $30a9f93e06c9cff5$var$bytesFromBase64(object.proofTry);
        if (object.proofClient !== undefined && object.proofClient !== null) message.proofClient = $30a9f93e06c9cff5$var$bytesFromBase64(object.proofClient);
        if (object.proofConsensus !== undefined && object.proofConsensus !== null) message.proofConsensus = $30a9f93e06c9cff5$var$bytesFromBase64(object.proofConsensus);
        if (object.consensusHeight !== undefined && object.consensusHeight !== null) message.consensusHeight = $yqmJM.Height.fromJSON(object.consensusHeight);
        else message.consensusHeight = undefined;
        if (object.signer !== undefined && object.signer !== null) message.signer = String(object.signer);
        else message.signer = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        message.counterpartyConnectionId !== undefined && (obj.counterpartyConnectionId = message.counterpartyConnectionId);
        message.version !== undefined && (obj.version = message.version ? $8WoN3.Version.toJSON(message.version) : undefined);
        message.clientState !== undefined && (obj.clientState = message.clientState ? $c5FxR.Any.toJSON(message.clientState) : undefined);
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $yqmJM.Height.toJSON(message.proofHeight) : undefined);
        message.proofTry !== undefined && (obj.proofTry = $30a9f93e06c9cff5$var$base64FromBytes(message.proofTry !== undefined ? message.proofTry : new Uint8Array()));
        message.proofClient !== undefined && (obj.proofClient = $30a9f93e06c9cff5$var$base64FromBytes(message.proofClient !== undefined ? message.proofClient : new Uint8Array()));
        message.proofConsensus !== undefined && (obj.proofConsensus = $30a9f93e06c9cff5$var$base64FromBytes(message.proofConsensus !== undefined ? message.proofConsensus : new Uint8Array()));
        message.consensusHeight !== undefined && (obj.consensusHeight = message.consensusHeight ? $yqmJM.Height.toJSON(message.consensusHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $30a9f93e06c9cff5$var$baseMsgConnectionOpenAck);
        if (object.connectionId !== undefined && object.connectionId !== null) message.connectionId = object.connectionId;
        else message.connectionId = "";
        if (object.counterpartyConnectionId !== undefined && object.counterpartyConnectionId !== null) message.counterpartyConnectionId = object.counterpartyConnectionId;
        else message.counterpartyConnectionId = "";
        if (object.version !== undefined && object.version !== null) message.version = $8WoN3.Version.fromPartial(object.version);
        else message.version = undefined;
        if (object.clientState !== undefined && object.clientState !== null) message.clientState = $c5FxR.Any.fromPartial(object.clientState);
        else message.clientState = undefined;
        if (object.proofHeight !== undefined && object.proofHeight !== null) message.proofHeight = $yqmJM.Height.fromPartial(object.proofHeight);
        else message.proofHeight = undefined;
        if (object.proofTry !== undefined && object.proofTry !== null) message.proofTry = object.proofTry;
        else message.proofTry = new Uint8Array();
        if (object.proofClient !== undefined && object.proofClient !== null) message.proofClient = object.proofClient;
        else message.proofClient = new Uint8Array();
        if (object.proofConsensus !== undefined && object.proofConsensus !== null) message.proofConsensus = object.proofConsensus;
        else message.proofConsensus = new Uint8Array();
        if (object.consensusHeight !== undefined && object.consensusHeight !== null) message.consensusHeight = $yqmJM.Height.fromPartial(object.consensusHeight);
        else message.consensusHeight = undefined;
        if (object.signer !== undefined && object.signer !== null) message.signer = object.signer;
        else message.signer = "";
        return message;
    }
};
const $30a9f93e06c9cff5$var$baseMsgConnectionOpenAckResponse = {};
module.exports.MsgConnectionOpenAckResponse = {
    encode (_, writer = $30a9f93e06c9cff5$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $30a9f93e06c9cff5$var$minimal_1.default.Reader ? input : new $30a9f93e06c9cff5$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $30a9f93e06c9cff5$var$baseMsgConnectionOpenAckResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $30a9f93e06c9cff5$var$baseMsgConnectionOpenAckResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $30a9f93e06c9cff5$var$baseMsgConnectionOpenAckResponse);
        return message;
    }
};
const $30a9f93e06c9cff5$var$baseMsgConnectionOpenConfirm = {
    connectionId: "",
    signer: ""
};
module.exports.MsgConnectionOpenConfirm = {
    encode (message, writer = $30a9f93e06c9cff5$var$minimal_1.default.Writer.create()) {
        if (message.connectionId !== "") writer.uint32(10).string(message.connectionId);
        if (message.proofAck.length !== 0) writer.uint32(18).bytes(message.proofAck);
        if (message.proofHeight !== undefined) $yqmJM.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        if (message.signer !== "") writer.uint32(34).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $30a9f93e06c9cff5$var$minimal_1.default.Reader ? input : new $30a9f93e06c9cff5$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $30a9f93e06c9cff5$var$baseMsgConnectionOpenConfirm);
        message.proofAck = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connectionId = reader.string();
                    break;
                case 2:
                    message.proofAck = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $yqmJM.Height.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $30a9f93e06c9cff5$var$baseMsgConnectionOpenConfirm);
        message.proofAck = new Uint8Array();
        if (object.connectionId !== undefined && object.connectionId !== null) message.connectionId = String(object.connectionId);
        else message.connectionId = "";
        if (object.proofAck !== undefined && object.proofAck !== null) message.proofAck = $30a9f93e06c9cff5$var$bytesFromBase64(object.proofAck);
        if (object.proofHeight !== undefined && object.proofHeight !== null) message.proofHeight = $yqmJM.Height.fromJSON(object.proofHeight);
        else message.proofHeight = undefined;
        if (object.signer !== undefined && object.signer !== null) message.signer = String(object.signer);
        else message.signer = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        message.proofAck !== undefined && (obj.proofAck = $30a9f93e06c9cff5$var$base64FromBytes(message.proofAck !== undefined ? message.proofAck : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $yqmJM.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $30a9f93e06c9cff5$var$baseMsgConnectionOpenConfirm);
        if (object.connectionId !== undefined && object.connectionId !== null) message.connectionId = object.connectionId;
        else message.connectionId = "";
        if (object.proofAck !== undefined && object.proofAck !== null) message.proofAck = object.proofAck;
        else message.proofAck = new Uint8Array();
        if (object.proofHeight !== undefined && object.proofHeight !== null) message.proofHeight = $yqmJM.Height.fromPartial(object.proofHeight);
        else message.proofHeight = undefined;
        if (object.signer !== undefined && object.signer !== null) message.signer = object.signer;
        else message.signer = "";
        return message;
    }
};
const $30a9f93e06c9cff5$var$baseMsgConnectionOpenConfirmResponse = {};
module.exports.MsgConnectionOpenConfirmResponse = {
    encode (_, writer = $30a9f93e06c9cff5$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $30a9f93e06c9cff5$var$minimal_1.default.Reader ? input : new $30a9f93e06c9cff5$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $30a9f93e06c9cff5$var$baseMsgConnectionOpenConfirmResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $30a9f93e06c9cff5$var$baseMsgConnectionOpenConfirmResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $30a9f93e06c9cff5$var$baseMsgConnectionOpenConfirmResponse);
        return message;
    }
};
class $30a9f93e06c9cff5$var$MsgClientImpl {
    ConnectionOpenInit(request, metadata) {
        return this.rpc.unary(module.exports.MsgConnectionOpenInitDesc, module.exports.MsgConnectionOpenInit.fromPartial(request), metadata);
    }
    ConnectionOpenTry(request, metadata) {
        return this.rpc.unary(module.exports.MsgConnectionOpenTryDesc, module.exports.MsgConnectionOpenTry.fromPartial(request), metadata);
    }
    ConnectionOpenAck(request, metadata) {
        return this.rpc.unary(module.exports.MsgConnectionOpenAckDesc, module.exports.MsgConnectionOpenAck.fromPartial(request), metadata);
    }
    ConnectionOpenConfirm(request, metadata) {
        return this.rpc.unary(module.exports.MsgConnectionOpenConfirmDesc, module.exports.MsgConnectionOpenConfirm.fromPartial(request), metadata);
    }
    constructor(rpc){
        this.rpc = rpc;
        this.ConnectionOpenInit = this.ConnectionOpenInit.bind(this);
        this.ConnectionOpenTry = this.ConnectionOpenTry.bind(this);
        this.ConnectionOpenAck = this.ConnectionOpenAck.bind(this);
        this.ConnectionOpenConfirm = this.ConnectionOpenConfirm.bind(this);
    }
}
module.exports.MsgClientImpl = $30a9f93e06c9cff5$var$MsgClientImpl;
module.exports.MsgDesc = {
    serviceName: "ibc.core.connection.v1.Msg"
};
module.exports.MsgConnectionOpenInitDesc = {
    methodName: "ConnectionOpenInit",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgConnectionOpenInit.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgConnectionOpenInitResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.MsgConnectionOpenTryDesc = {
    methodName: "ConnectionOpenTry",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgConnectionOpenTry.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgConnectionOpenTryResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.MsgConnectionOpenAckDesc = {
    methodName: "ConnectionOpenAck",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgConnectionOpenAck.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgConnectionOpenAckResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.MsgConnectionOpenConfirmDesc = {
    methodName: "ConnectionOpenConfirm",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgConnectionOpenConfirm.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgConnectionOpenConfirmResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
class $30a9f93e06c9cff5$var$GrpcWebImpl {
    unary(methodDesc, _request, metadata) {
        var _a;
        const request = Object.assign(Object.assign({}, _request), methodDesc.requestType);
        const maybeCombinedMetadata = metadata && this.options.metadata ? new $1pqjL.BrowserHeaders(Object.assign(Object.assign({}, (_a = this.options) === null || _a === void 0 ? void 0 : _a.metadata.headersMap), metadata === null || metadata === void 0 ? void 0 : metadata.headersMap)) : metadata || this.options.metadata;
        return new Promise((resolve, reject)=>{
            $jXVni.grpc.unary(methodDesc, {
                request: request,
                host: this.host,
                metadata: maybeCombinedMetadata,
                transport: this.options.transport,
                debug: this.options.debug,
                onEnd: function(response) {
                    if (response.status === $jXVni.grpc.Code.OK) resolve(response.message);
                    else {
                        const err = new Error(response.statusMessage);
                        err.code = response.status;
                        err.metadata = response.trailers;
                        reject(err);
                    }
                }
            });
        });
    }
    constructor(host, options){
        this.host = host;
        this.options = options;
    }
}
module.exports.GrpcWebImpl = $30a9f93e06c9cff5$var$GrpcWebImpl;
var $30a9f93e06c9cff5$var$globalThis = (()=>{
    if (typeof $30a9f93e06c9cff5$var$globalThis !== "undefined") return $30a9f93e06c9cff5$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $30a9f93e06c9cff5$var$atob = $30a9f93e06c9cff5$var$globalThis.atob || ((b64)=>$30a9f93e06c9cff5$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $30a9f93e06c9cff5$var$bytesFromBase64(b64) {
    const bin = $30a9f93e06c9cff5$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $30a9f93e06c9cff5$var$btoa = $30a9f93e06c9cff5$var$globalThis.btoa || ((bin)=>$30a9f93e06c9cff5$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $30a9f93e06c9cff5$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $30a9f93e06c9cff5$var$btoa(bin.join(""));
}
if ($30a9f93e06c9cff5$var$minimal_1.default.util.Long !== $30a9f93e06c9cff5$var$long_1.default) {
    $30a9f93e06c9cff5$var$minimal_1.default.util.Long = $30a9f93e06c9cff5$var$long_1.default;
    $30a9f93e06c9cff5$var$minimal_1.default.configure();
}

});


parcelRegister("gFSLT", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $c23af629f91327af$require$Buffer = $gzLuY.Buffer;
"use strict";
var $c23af629f91327af$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $c23af629f91327af$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgConnectionOpenTry = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $6pjkd = parcelRequire("6pjkd");

var $gwXuB = parcelRequire("gwXuB");

var $4b2iF = parcelRequire("4b2iF");

var $c23af629f91327af$var$long_1 = $c23af629f91327af$var$__importDefault((parcelRequire("9A55m")));

var $cz9KI = parcelRequire("cz9KI");
/**
 *  MsgConnectionOpenTry defines a msg sent by a Relayer to try to open a connection on Chain B.
 */ var $c23af629f91327af$var$MsgConnectionOpenTry = /** @class */ function(_super) {
    $c23af629f91327af$var$__extends(MsgConnectionOpenTry, _super);
    /**
     * @param client_id in the case of crossing hello's, when both chains call OpenInit, we need the connection identifier of the previous connection in state INIT
     * @param previous_connection_id
     * @param client_state
     * @param counterparty
     * @param delay_period
     * @param counterparty_versions
     * @param proof_height proof of the initialization the connection on Chain A: `UNITIALIZED -> INIT`
     * @param proof_init proof of client state included in message
     * @param proof_client proof of client consensus state
     * @param proof_consensus
     * @param consensus_height
     * @param signer signer address
     */ function MsgConnectionOpenTry(client_id, previous_connection_id, client_state, counterparty, delay_period, counterparty_versions, proof_height, proof_init, proof_client, proof_consensus, consensus_height, signer) {
        var _this = _super.call(this) || this;
        _this.client_id = client_id;
        _this.previous_connection_id = previous_connection_id;
        _this.client_state = client_state;
        _this.counterparty = counterparty;
        _this.delay_period = delay_period;
        _this.counterparty_versions = counterparty_versions;
        _this.proof_height = proof_height;
        _this.proof_init = proof_init;
        _this.proof_client = proof_client;
        _this.proof_consensus = proof_consensus;
        _this.consensus_height = consensus_height;
        _this.signer = signer;
        return _this;
    }
    MsgConnectionOpenTry.fromAmino = function(_, isClassic) {
        _;
        isClassic;
        throw new Error("Amino not supported");
    };
    MsgConnectionOpenTry.prototype.toAmino = function(_) {
        _;
        throw new Error("Amino not supported");
    };
    MsgConnectionOpenTry.fromData = function(data, _) {
        _;
        var client_id = data.client_id, previous_connection_id = data.previous_connection_id, client_state = data.client_state, counterparty = data.counterparty, delay_period = data.delay_period, counterparty_versions = data.counterparty_versions, proof_height = data.proof_height, proof_init = data.proof_init, proof_client = data.proof_client, proof_consensus = data.proof_consensus, consensus_height = data.consensus_height, signer = data.signer;
        return new MsgConnectionOpenTry(client_id, previous_connection_id, client_state, counterparty ? $6pjkd.Counterparty.fromData(counterparty) : undefined, Number.parseInt(delay_period), counterparty_versions.length > 0 ? counterparty_versions.map(function(cv) {
            return $gwXuB.Version.fromData(cv);
        }) : [], proof_height ? $cz9KI.Height.fromData(proof_height) : undefined, $c23af629f91327af$require$Buffer.from(proof_init).toString("base64"), $c23af629f91327af$require$Buffer.from(proof_client).toString("base64"), $c23af629f91327af$require$Buffer.from(proof_consensus).toString("base64"), consensus_height ? $cz9KI.Height.fromData(consensus_height) : undefined, signer);
    };
    MsgConnectionOpenTry.prototype.toData = function(_) {
        _;
        var _a = this, client_id = _a.client_id, previous_connection_id = _a.previous_connection_id, client_state = _a.client_state, counterparty = _a.counterparty, delay_period = _a.delay_period, counterparty_versions = _a.counterparty_versions, proof_height = _a.proof_height, proof_init = _a.proof_init, proof_client = _a.proof_client, proof_consensus = _a.proof_consensus, consensus_height = _a.consensus_height, signer = _a.signer;
        return {
            "@type": "/ibc.core.connection.v1.MsgConnectionOpenTry",
            client_id: client_id,
            previous_connection_id: previous_connection_id,
            client_state: client_state,
            counterparty: counterparty ? counterparty.toData() : undefined,
            delay_period: delay_period.toFixed(),
            counterparty_versions: counterparty_versions.length > 0 ? counterparty_versions.map(function(cv) {
                return cv.toData();
            }) : [],
            proof_height: proof_height ? proof_height.toData() : undefined,
            proof_init: proof_init,
            proof_client: proof_client,
            proof_consensus: proof_consensus,
            consensus_height: consensus_height ? consensus_height.toData() : undefined,
            signer: signer
        };
    };
    MsgConnectionOpenTry.fromProto = function(proto, _) {
        _;
        return new MsgConnectionOpenTry(proto.clientId, proto.previousConnectionId, proto.clientState, proto.counterparty ? $6pjkd.Counterparty.fromProto(proto.counterparty) : undefined, proto.delayPeriod.toNumber(), proto.counterpartyVersions.length > 0 ? proto.counterpartyVersions.map(function(cv) {
            return $gwXuB.Version.fromProto(cv);
        }) : [], proto.proofHeight ? $cz9KI.Height.fromProto(proto.proofHeight) : undefined, $c23af629f91327af$require$Buffer.from(proto.proofInit).toString("base64"), $c23af629f91327af$require$Buffer.from(proto.proofClient).toString("base64"), $c23af629f91327af$require$Buffer.from(proto.proofConsensus).toString("base64"), proto.consensusHeight ? $cz9KI.Height.fromProto(proto.consensusHeight) : undefined, proto.signer);
    };
    MsgConnectionOpenTry.prototype.toProto = function(_) {
        _;
        var _a = this, client_id = _a.client_id, previous_connection_id = _a.previous_connection_id, client_state = _a.client_state, counterparty = _a.counterparty, delay_period = _a.delay_period, counterparty_versions = _a.counterparty_versions, proof_height = _a.proof_height, proof_init = _a.proof_init, proof_client = _a.proof_client, proof_consensus = _a.proof_consensus, consensus_height = _a.consensus_height, signer = _a.signer;
        return $4b2iF.MsgConnectionOpenTry.fromPartial({
            clientId: client_id,
            previousConnectionId: previous_connection_id,
            clientState: client_state.toProto(),
            counterparty: counterparty ? counterparty.toProto() : undefined,
            delayPeriod: $c23af629f91327af$var$long_1.default.fromNumber(delay_period),
            counterpartyVersions: counterparty_versions.length > 0 ? counterparty_versions.map(function(cv) {
                return cv.toProto();
            }) : [],
            proofHeight: proof_height ? proof_height.toProto() : undefined,
            proofInit: $c23af629f91327af$require$Buffer.from(proof_init, "base64"),
            proofClient: $c23af629f91327af$require$Buffer.from(proof_client, "base64"),
            proofConsensus: $c23af629f91327af$require$Buffer.from(proof_consensus, "base64"),
            consensusHeight: consensus_height ? consensus_height.toProto() : undefined,
            signer: signer
        });
    };
    MsgConnectionOpenTry.prototype.packAny = function(_) {
        _;
        return $c5FxR.Any.fromPartial({
            typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenTry",
            value: $4b2iF.MsgConnectionOpenTry.encode(this.toProto()).finish()
        });
    };
    MsgConnectionOpenTry.unpackAny = function(msgAny, _) {
        _;
        return MsgConnectionOpenTry.fromProto($4b2iF.MsgConnectionOpenTry.decode(msgAny.value));
    };
    return MsgConnectionOpenTry;
}($26Eqx.JSONSerializable);
module.exports.MsgConnectionOpenTry = $c23af629f91327af$var$MsgConnectionOpenTry;

});

parcelRegister("i3E9N", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $d257a82758534007$require$Buffer = $gzLuY.Buffer;
"use strict";
var $d257a82758534007$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgConnectionOpenConfirm = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $4b2iF = parcelRequire("4b2iF");

var $cz9KI = parcelRequire("cz9KI");
/**
 * MsgConnectionOpenConfirm defines a msg sent by a Relayer to Chain B to
 * acknowledge the change of connection state to OPEN on Chain A.
 */ var $d257a82758534007$var$MsgConnectionOpenConfirm = /** @class */ function(_super) {
    $d257a82758534007$var$__extends(MsgConnectionOpenConfirm, _super);
    /**
     * @param connection_id
     * @param proof_ack proof for the change of the connection state on Chain A: `INIT -> OPEN`
     * @param proof_height
     * @param signer signer address
     */ function MsgConnectionOpenConfirm(connection_id, proof_ack, proof_height, signer) {
        var _this = _super.call(this) || this;
        _this.connection_id = connection_id;
        _this.proof_ack = proof_ack;
        _this.proof_height = proof_height;
        _this.signer = signer;
        return _this;
    }
    MsgConnectionOpenConfirm.fromAmino = function(_, isClassic) {
        _;
        isClassic;
        throw new Error("Amino not supported");
    };
    MsgConnectionOpenConfirm.prototype.toAmino = function(_) {
        _;
        throw new Error("Amino not supported");
    };
    MsgConnectionOpenConfirm.fromData = function(data, _) {
        _;
        var connection_id = data.connection_id, proof_ack = data.proof_ack, proof_height = data.proof_height, signer = data.signer;
        return new MsgConnectionOpenConfirm(connection_id, proof_ack, proof_height ? $cz9KI.Height.fromData(proof_height) : undefined, signer);
    };
    MsgConnectionOpenConfirm.prototype.toData = function(_) {
        _;
        var _a = this, connection_id = _a.connection_id, proof_ack = _a.proof_ack, proof_height = _a.proof_height, signer = _a.signer;
        return {
            "@type": "/ibc.core.connection.v1.MsgConnectionOpenConfirm",
            connection_id: connection_id,
            proof_ack: proof_ack,
            proof_height: proof_height ? proof_height.toData() : undefined,
            signer: signer
        };
    };
    MsgConnectionOpenConfirm.fromProto = function(proto, _) {
        _;
        return new MsgConnectionOpenConfirm(proto.connectionId, $d257a82758534007$require$Buffer.from(proto.proofAck).toString("base64"), proto.proofHeight ? $cz9KI.Height.fromProto(proto.proofHeight) : undefined, proto.signer);
    };
    MsgConnectionOpenConfirm.prototype.toProto = function(_) {
        _;
        var _a = this, connection_id = _a.connection_id, proof_ack = _a.proof_ack, proof_height = _a.proof_height, signer = _a.signer;
        return $4b2iF.MsgConnectionOpenConfirm.fromPartial({
            connectionId: connection_id,
            proofAck: $d257a82758534007$require$Buffer.from(proof_ack, "base64"),
            proofHeight: proof_height ? proof_height.toProto() : undefined,
            signer: signer
        });
    };
    MsgConnectionOpenConfirm.prototype.packAny = function(_) {
        _;
        return $c5FxR.Any.fromPartial({
            typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenConfirm",
            value: $4b2iF.MsgConnectionOpenConfirm.encode(this.toProto()).finish()
        });
    };
    MsgConnectionOpenConfirm.unpackAny = function(msgAny, _) {
        _;
        return MsgConnectionOpenConfirm.fromProto($4b2iF.MsgConnectionOpenConfirm.decode(msgAny.value));
    };
    return MsgConnectionOpenConfirm;
}($26Eqx.JSONSerializable);
module.exports.MsgConnectionOpenConfirm = $d257a82758534007$var$MsgConnectionOpenConfirm;

});

parcelRegister("1k2Pt", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $0f69da8d3f3bf5e8$require$Buffer = $gzLuY.Buffer;
"use strict";
var $0f69da8d3f3bf5e8$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgConnectionOpenAck = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $gwXuB = parcelRequire("gwXuB");

var $4b2iF = parcelRequire("4b2iF");

var $cz9KI = parcelRequire("cz9KI");
/**
 * MsgConnectionOpenAck defines a msg sent by a Relayer to Chain A to
 * acknowledge the change of connection state to TRYOPEN on Chain B.
 */ var $0f69da8d3f3bf5e8$var$MsgConnectionOpenAck = /** @class */ function(_super) {
    $0f69da8d3f3bf5e8$var$__extends(MsgConnectionOpenAck, _super);
    /**
     * @param connection_id
     * @param counterparty_connection_id
     * @param version
     * @param client_state
     * @param proof_height proof of the initialization the connection on Chain B: `UNITIALIZED -> TRYOPEN`
     * @param proof_try proof of client state included in message
     * @param proof_client proof of client consensus state
     * @param proof_consensus
     * @param consenesus_height
     * @param signer signer address
     */ function MsgConnectionOpenAck(connection_id, counterparty_connection_id, version, client_state, proof_height, proof_try, proof_client, proof_consensus, consensus_height, signer) {
        var _this = _super.call(this) || this;
        _this.connection_id = connection_id;
        _this.counterparty_connection_id = counterparty_connection_id;
        _this.version = version;
        _this.client_state = client_state;
        _this.proof_height = proof_height;
        _this.proof_try = proof_try;
        _this.proof_client = proof_client;
        _this.proof_consensus = proof_consensus;
        _this.consensus_height = consensus_height;
        _this.signer = signer;
        return _this;
    }
    MsgConnectionOpenAck.fromAmino = function(_, isClassic) {
        _;
        isClassic;
        throw new Error("Amino not supported");
    };
    MsgConnectionOpenAck.prototype.toAmino = function(_) {
        _;
        throw new Error("Amino not supported");
    };
    MsgConnectionOpenAck.fromData = function(data, _) {
        _;
        var connection_id = data.connection_id, counterparty_connection_id = data.counterparty_connection_id, version = data.version, client_state = data.client_state, proof_height = data.proof_height, proof_try = data.proof_try, proof_client = data.proof_client, proof_consensus = data.proof_consensus, consensus_height = data.consensus_height, signer = data.signer;
        return new MsgConnectionOpenAck(connection_id, counterparty_connection_id, version ? $gwXuB.Version.fromData(version) : undefined, client_state, proof_height ? $cz9KI.Height.fromData(proof_height) : undefined, proof_try, proof_client, proof_consensus, consensus_height ? $cz9KI.Height.fromData(consensus_height) : undefined, signer);
    };
    MsgConnectionOpenAck.prototype.toData = function(_) {
        _;
        var _a = this, connection_id = _a.connection_id, counterparty_connection_id = _a.counterparty_connection_id, version = _a.version, client_state = _a.client_state, proof_height = _a.proof_height, proof_try = _a.proof_try, proof_client = _a.proof_client, proof_consensus = _a.proof_consensus, consensus_height = _a.consensus_height, signer = _a.signer;
        return {
            "@type": "/ibc.core.connection.v1.MsgConnectionOpenAck",
            connection_id: connection_id,
            counterparty_connection_id: counterparty_connection_id,
            version: version ? version.toData() : undefined,
            client_state: client_state,
            proof_height: proof_height ? proof_height.toData() : undefined,
            proof_try: proof_try,
            proof_client: proof_client,
            proof_consensus: proof_consensus,
            consensus_height: consensus_height ? consensus_height.toData() : undefined,
            signer: signer
        };
    };
    MsgConnectionOpenAck.fromProto = function(proto, _) {
        _;
        return new MsgConnectionOpenAck(proto.connectionId, proto.counterpartyConnectionId, proto.version ? $gwXuB.Version.fromProto(proto.version) : undefined, proto.clientState, proto.proofHeight ? $cz9KI.Height.fromProto(proto.proofHeight) : undefined, $0f69da8d3f3bf5e8$require$Buffer.from(proto.proofTry).toString("base64"), $0f69da8d3f3bf5e8$require$Buffer.from(proto.proofClient).toString("base64"), $0f69da8d3f3bf5e8$require$Buffer.from(proto.proofConsensus).toString("base64"), proto.consensusHeight ? $cz9KI.Height.fromProto(proto.consensusHeight) : undefined, proto.signer);
    };
    MsgConnectionOpenAck.prototype.toProto = function(_) {
        _;
        var _a = this, connection_id = _a.connection_id, counterparty_connection_id = _a.counterparty_connection_id, version = _a.version, client_state = _a.client_state, proof_height = _a.proof_height, proof_try = _a.proof_try, proof_client = _a.proof_client, proof_consensus = _a.proof_consensus, consensus_height = _a.consensus_height, signer = _a.signer;
        return $4b2iF.MsgConnectionOpenAck.fromPartial({
            connectionId: connection_id,
            counterpartyConnectionId: counterparty_connection_id,
            version: version ? version.toProto() : undefined,
            clientState: client_state,
            proofHeight: proof_height ? proof_height.toProto() : undefined,
            proofTry: $0f69da8d3f3bf5e8$require$Buffer.from(proof_try, "base64"),
            proofClient: $0f69da8d3f3bf5e8$require$Buffer.from(proof_client, "base64"),
            proofConsensus: $0f69da8d3f3bf5e8$require$Buffer.from(proof_consensus, "base64"),
            consensusHeight: consensus_height ? consensus_height.toProto() : undefined,
            signer: signer
        });
    };
    MsgConnectionOpenAck.prototype.packAny = function(_) {
        _;
        return $c5FxR.Any.fromPartial({
            typeUrl: "/ibc.core.connection.v1.MsgConnectionOpenAck",
            value: $4b2iF.MsgConnectionOpenAck.encode(this.toProto()).finish()
        });
    };
    MsgConnectionOpenAck.unpackAny = function(msgAny, _) {
        _;
        return MsgConnectionOpenAck.fromProto($4b2iF.MsgConnectionOpenAck.decode(msgAny.value));
    };
    return MsgConnectionOpenAck;
}($26Eqx.JSONSerializable);
module.exports.MsgConnectionOpenAck = $0f69da8d3f3bf5e8$var$MsgConnectionOpenAck;

});


parcelRegister("dCZ8i", function(module, exports) {
"use strict";
var $028f749faa2db87d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $028f749faa2db87d$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $028f749faa2db87d$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$028f749faa2db87d$var$__exportStar((parcelRequire("il5i2")), module.exports);

$028f749faa2db87d$var$__exportStar((parcelRequire("65TVN")), module.exports);

$028f749faa2db87d$var$__exportStar((parcelRequire("3T6en")), module.exports);

$028f749faa2db87d$var$__exportStar((parcelRequire("cLeDn")), module.exports);

$028f749faa2db87d$var$__exportStar((parcelRequire("jSv1Y")), module.exports);

$028f749faa2db87d$var$__exportStar((parcelRequire("hcH1f")), module.exports);

$028f749faa2db87d$var$__exportStar((parcelRequire("kKAdJ")), module.exports);

$028f749faa2db87d$var$__exportStar((parcelRequire("lNVZx")), module.exports);

$028f749faa2db87d$var$__exportStar((parcelRequire("frrk3")), module.exports);

$028f749faa2db87d$var$__exportStar((parcelRequire("6Hry4")), module.exports);

});
parcelRegister("il5i2", function(module, exports) {
"use strict";
var $d59e4aa076621502$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgChannelOpenInit = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $2JCWf = parcelRequire("2JCWf");

var $hjcrP = parcelRequire("hjcrP");
/**
 * MsgChannelOpenInit defines an sdk.Msg to initialize a channel handshake. It is called by a relayer on Chain A.
 */ var $d59e4aa076621502$var$MsgChannelOpenInit = /** @class */ function(_super) {
    $d59e4aa076621502$var$__extends(MsgChannelOpenInit, _super);
    /**
     * @param port_id identifier of the port to use
     * @param channel channel info
     * @param signer signer address
     */ function MsgChannelOpenInit(port_id, channel, signer) {
        var _this = _super.call(this) || this;
        _this.port_id = port_id;
        _this.channel = channel;
        _this.signer = signer;
        return _this;
    }
    MsgChannelOpenInit.fromAmino = function(_, isClassic) {
        _;
        isClassic;
        throw new Error("Amino not supported");
    };
    MsgChannelOpenInit.prototype.toAmino = function(_) {
        _;
        throw new Error("Amino not supported");
    };
    MsgChannelOpenInit.fromData = function(data, _) {
        _;
        var port_id = data.port_id, channel = data.channel, signer = data.signer;
        return new MsgChannelOpenInit(port_id, channel ? $2JCWf.Channel.fromData(channel) : undefined, signer);
    };
    MsgChannelOpenInit.prototype.toData = function(_) {
        _;
        var _a = this, port_id = _a.port_id, channel = _a.channel, signer = _a.signer;
        return {
            "@type": "/ibc.core.channel.v1.MsgChannelOpenInit",
            port_id: port_id,
            channel: channel ? channel.toData() : undefined,
            signer: signer
        };
    };
    MsgChannelOpenInit.fromProto = function(proto, _) {
        _;
        return new MsgChannelOpenInit(proto.portId, proto.channel ? $2JCWf.Channel.fromProto(proto.channel) : undefined, proto.signer);
    };
    MsgChannelOpenInit.prototype.toProto = function(_) {
        _;
        var _a = this, port_id = _a.port_id, channel = _a.channel, signer = _a.signer;
        return $hjcrP.MsgChannelOpenInit.fromPartial({
            portId: port_id,
            channel: channel ? channel.toProto() : undefined,
            signer: signer
        });
    };
    MsgChannelOpenInit.prototype.packAny = function(_) {
        _;
        return $c5FxR.Any.fromPartial({
            typeUrl: "/ibc.core.channel.v1.MsgChannelOpenInit",
            value: $hjcrP.MsgChannelOpenInit.encode(this.toProto()).finish()
        });
    };
    MsgChannelOpenInit.unpackAny = function(msgAny, _) {
        _;
        return MsgChannelOpenInit.fromProto($hjcrP.MsgChannelOpenInit.decode(msgAny.value));
    };
    return MsgChannelOpenInit;
}($26Eqx.JSONSerializable);
module.exports.MsgChannelOpenInit = $d59e4aa076621502$var$MsgChannelOpenInit;

});
parcelRegister("2JCWf", function(module, exports) {
"use strict";
var $1fddfd16bb7a1d9d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Channel = void 0;

var $cKsix = parcelRequire("cKsix");

var $26Eqx = parcelRequire("26Eqx");

var $kDevM = parcelRequire("kDevM");
/**
 * Channel is a monotonically increasing data type
 * that can be compared against another Channel for the purposes of updating and
 * freezing clients
 *
 * Normally the RevisionChannel is incremented at each height while keeping
 * RevisionNumber the same. However some consensus algorithms may choose to
 * reset the height in certain conditions e.g. hard forks, state-machine
 * breaking changes In these cases, the RevisionNumber is incremented so that
 * height continues to be monitonically increasing even as the RevisionChannel
 * gets reset
 */ var $1fddfd16bb7a1d9d$var$Channel = /** @class */ function(_super) {
    $1fddfd16bb7a1d9d$var$__extends(Channel, _super);
    /**
     * @param state current state of the channel end
     * @param ordering  whether the channel is ordered or unordered
     * @param counterparty counterparty channel end
     * @param connection_hops list of connection identifiers, in order, along which packets sent on this channel will travel
     * @param version opaque channel version, which is agreed upon during the handshake
     */ function Channel(state, ordering, counterparty, connection_hops, version) {
        var _this = _super.call(this) || this;
        _this.state = state;
        _this.ordering = ordering;
        _this.counterparty = counterparty;
        _this.connection_hops = connection_hops;
        _this.version = version;
        return _this;
    }
    Channel.fromAmino = function(data) {
        var state = data.state, ordering = data.ordering, counterparty = data.counterparty, connection_hops = data.connection_hops, version = data.version;
        return new Channel(state, ordering, counterparty ? $kDevM.Counterparty.fromAmino(counterparty) : undefined, connection_hops, version);
    };
    Channel.prototype.toAmino = function() {
        var _a = this, state = _a.state, ordering = _a.ordering, counterparty = _a.counterparty, connection_hops = _a.connection_hops, version = _a.version;
        var res = {
            state: state,
            ordering: ordering,
            counterparty: counterparty ? counterparty.toAmino() : undefined,
            connection_hops: connection_hops,
            version: version
        };
        return res;
    };
    Channel.fromData = function(data) {
        var state = data.state, ordering = data.ordering, counterparty = data.counterparty, connection_hops = data.connection_hops, version = data.version;
        return new Channel(state, ordering, counterparty ? $kDevM.Counterparty.fromData(counterparty) : undefined, connection_hops, version);
    };
    Channel.prototype.toData = function() {
        var _a = this, state = _a.state, ordering = _a.ordering, counterparty = _a.counterparty, connection_hops = _a.connection_hops, version = _a.version;
        var res = {
            state: state,
            ordering: ordering,
            counterparty: counterparty ? counterparty.toData() : undefined,
            connection_hops: connection_hops,
            version: version
        };
        return res;
    };
    Channel.fromProto = function(proto) {
        return new Channel(proto.state, proto.ordering, proto.counterparty ? $kDevM.Counterparty.fromProto(proto.counterparty) : undefined, proto.connectionHops, proto.version);
    };
    Channel.prototype.toProto = function() {
        var _a = this, state = _a.state, ordering = _a.ordering, counterparty = _a.counterparty, connection_hops = _a.connection_hops, version = _a.version;
        return $cKsix.Channel.fromPartial({
            state: state,
            ordering: ordering,
            counterparty: counterparty ? counterparty.toProto() : undefined,
            connectionHops: connection_hops,
            version: version
        });
    };
    return Channel;
}($26Eqx.JSONSerializable);
module.exports.Channel = $1fddfd16bb7a1d9d$var$Channel;

});
parcelRegister("cKsix", function(module, exports) {
"use strict";
var $947fbb485c3b8b97$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Acknowledgement = module.exports.PacketId = module.exports.PacketState = module.exports.Packet = module.exports.Counterparty = module.exports.IdentifiedChannel = module.exports.Channel = module.exports.orderToJSON = module.exports.orderFromJSON = module.exports.Order = module.exports.stateToJSON = module.exports.stateFromJSON = module.exports.State = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $947fbb485c3b8b97$var$long_1 = $947fbb485c3b8b97$var$__importDefault((parcelRequire("9A55m")));

const $947fbb485c3b8b97$var$minimal_1 = $947fbb485c3b8b97$var$__importDefault((parcelRequire("i2pIU")));

var $yqmJM = parcelRequire("yqmJM");
module.exports.protobufPackage = "ibc.core.channel.v1";
/**
 * State defines if a channel is in one of the following states:
 * CLOSED, INIT, TRYOPEN, OPEN or UNINITIALIZED.
 */ var $947fbb485c3b8b97$var$State;
(function(State) {
    /** STATE_UNINITIALIZED_UNSPECIFIED - Default State */ State[State["STATE_UNINITIALIZED_UNSPECIFIED"] = 0] = "STATE_UNINITIALIZED_UNSPECIFIED";
    /** STATE_INIT - A channel has just started the opening handshake. */ State[State["STATE_INIT"] = 1] = "STATE_INIT";
    /** STATE_TRYOPEN - A channel has acknowledged the handshake step on the counterparty chain. */ State[State["STATE_TRYOPEN"] = 2] = "STATE_TRYOPEN";
    /**
     * STATE_OPEN - A channel has completed the handshake. Open channels are
     * ready to send and receive packets.
     */ State[State["STATE_OPEN"] = 3] = "STATE_OPEN";
    /**
     * STATE_CLOSED - A channel has been closed and can no longer be used to send or receive
     * packets.
     */ State[State["STATE_CLOSED"] = 4] = "STATE_CLOSED";
    State[State["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($947fbb485c3b8b97$var$State = module.exports.State || (module.exports.State = {}));
function $947fbb485c3b8b97$var$stateFromJSON(object) {
    switch(object){
        case 0:
        case "STATE_UNINITIALIZED_UNSPECIFIED":
            return $947fbb485c3b8b97$var$State.STATE_UNINITIALIZED_UNSPECIFIED;
        case 1:
        case "STATE_INIT":
            return $947fbb485c3b8b97$var$State.STATE_INIT;
        case 2:
        case "STATE_TRYOPEN":
            return $947fbb485c3b8b97$var$State.STATE_TRYOPEN;
        case 3:
        case "STATE_OPEN":
            return $947fbb485c3b8b97$var$State.STATE_OPEN;
        case 4:
        case "STATE_CLOSED":
            return $947fbb485c3b8b97$var$State.STATE_CLOSED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $947fbb485c3b8b97$var$State.UNRECOGNIZED;
    }
}
module.exports.stateFromJSON = $947fbb485c3b8b97$var$stateFromJSON;
function $947fbb485c3b8b97$var$stateToJSON(object) {
    switch(object){
        case $947fbb485c3b8b97$var$State.STATE_UNINITIALIZED_UNSPECIFIED:
            return "STATE_UNINITIALIZED_UNSPECIFIED";
        case $947fbb485c3b8b97$var$State.STATE_INIT:
            return "STATE_INIT";
        case $947fbb485c3b8b97$var$State.STATE_TRYOPEN:
            return "STATE_TRYOPEN";
        case $947fbb485c3b8b97$var$State.STATE_OPEN:
            return "STATE_OPEN";
        case $947fbb485c3b8b97$var$State.STATE_CLOSED:
            return "STATE_CLOSED";
        default:
            return "UNKNOWN";
    }
}
module.exports.stateToJSON = $947fbb485c3b8b97$var$stateToJSON;
/** Order defines if a channel is ORDERED or UNORDERED */ var $947fbb485c3b8b97$var$Order;
(function(Order) {
    /** ORDER_NONE_UNSPECIFIED - zero-value for channel ordering */ Order[Order["ORDER_NONE_UNSPECIFIED"] = 0] = "ORDER_NONE_UNSPECIFIED";
    /**
     * ORDER_UNORDERED - packets can be delivered in any order, which may differ from the order in
     * which they were sent.
     */ Order[Order["ORDER_UNORDERED"] = 1] = "ORDER_UNORDERED";
    /** ORDER_ORDERED - packets are delivered exactly in the order which they were sent */ Order[Order["ORDER_ORDERED"] = 2] = "ORDER_ORDERED";
    Order[Order["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($947fbb485c3b8b97$var$Order = module.exports.Order || (module.exports.Order = {}));
function $947fbb485c3b8b97$var$orderFromJSON(object) {
    switch(object){
        case 0:
        case "ORDER_NONE_UNSPECIFIED":
            return $947fbb485c3b8b97$var$Order.ORDER_NONE_UNSPECIFIED;
        case 1:
        case "ORDER_UNORDERED":
            return $947fbb485c3b8b97$var$Order.ORDER_UNORDERED;
        case 2:
        case "ORDER_ORDERED":
            return $947fbb485c3b8b97$var$Order.ORDER_ORDERED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $947fbb485c3b8b97$var$Order.UNRECOGNIZED;
    }
}
module.exports.orderFromJSON = $947fbb485c3b8b97$var$orderFromJSON;
function $947fbb485c3b8b97$var$orderToJSON(object) {
    switch(object){
        case $947fbb485c3b8b97$var$Order.ORDER_NONE_UNSPECIFIED:
            return "ORDER_NONE_UNSPECIFIED";
        case $947fbb485c3b8b97$var$Order.ORDER_UNORDERED:
            return "ORDER_UNORDERED";
        case $947fbb485c3b8b97$var$Order.ORDER_ORDERED:
            return "ORDER_ORDERED";
        default:
            return "UNKNOWN";
    }
}
module.exports.orderToJSON = $947fbb485c3b8b97$var$orderToJSON;
const $947fbb485c3b8b97$var$baseChannel = {
    state: 0,
    ordering: 0,
    connectionHops: "",
    version: ""
};
module.exports.Channel = {
    encode (message, writer = $947fbb485c3b8b97$var$minimal_1.default.Writer.create()) {
        if (message.state !== 0) writer.uint32(8).int32(message.state);
        if (message.ordering !== 0) writer.uint32(16).int32(message.ordering);
        if (message.counterparty !== undefined) module.exports.Counterparty.encode(message.counterparty, writer.uint32(26).fork()).ldelim();
        for (const v of message.connectionHops)writer.uint32(34).string(v);
        if (message.version !== "") writer.uint32(42).string(message.version);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $947fbb485c3b8b97$var$minimal_1.default.Reader ? input : new $947fbb485c3b8b97$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $947fbb485c3b8b97$var$baseChannel);
        message.connectionHops = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.state = reader.int32();
                    break;
                case 2:
                    message.ordering = reader.int32();
                    break;
                case 3:
                    message.counterparty = module.exports.Counterparty.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.connectionHops.push(reader.string());
                    break;
                case 5:
                    message.version = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $947fbb485c3b8b97$var$baseChannel);
        message.connectionHops = [];
        if (object.state !== undefined && object.state !== null) message.state = $947fbb485c3b8b97$var$stateFromJSON(object.state);
        else message.state = 0;
        if (object.ordering !== undefined && object.ordering !== null) message.ordering = $947fbb485c3b8b97$var$orderFromJSON(object.ordering);
        else message.ordering = 0;
        if (object.counterparty !== undefined && object.counterparty !== null) message.counterparty = module.exports.Counterparty.fromJSON(object.counterparty);
        else message.counterparty = undefined;
        if (object.connectionHops !== undefined && object.connectionHops !== null) for (const e of object.connectionHops)message.connectionHops.push(String(e));
        if (object.version !== undefined && object.version !== null) message.version = String(object.version);
        else message.version = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.state !== undefined && (obj.state = $947fbb485c3b8b97$var$stateToJSON(message.state));
        message.ordering !== undefined && (obj.ordering = $947fbb485c3b8b97$var$orderToJSON(message.ordering));
        message.counterparty !== undefined && (obj.counterparty = message.counterparty ? module.exports.Counterparty.toJSON(message.counterparty) : undefined);
        if (message.connectionHops) obj.connectionHops = message.connectionHops.map((e)=>e);
        else obj.connectionHops = [];
        message.version !== undefined && (obj.version = message.version);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $947fbb485c3b8b97$var$baseChannel);
        message.connectionHops = [];
        if (object.state !== undefined && object.state !== null) message.state = object.state;
        else message.state = 0;
        if (object.ordering !== undefined && object.ordering !== null) message.ordering = object.ordering;
        else message.ordering = 0;
        if (object.counterparty !== undefined && object.counterparty !== null) message.counterparty = module.exports.Counterparty.fromPartial(object.counterparty);
        else message.counterparty = undefined;
        if (object.connectionHops !== undefined && object.connectionHops !== null) for (const e of object.connectionHops)message.connectionHops.push(e);
        if (object.version !== undefined && object.version !== null) message.version = object.version;
        else message.version = "";
        return message;
    }
};
const $947fbb485c3b8b97$var$baseIdentifiedChannel = {
    state: 0,
    ordering: 0,
    connectionHops: "",
    version: "",
    portId: "",
    channelId: ""
};
module.exports.IdentifiedChannel = {
    encode (message, writer = $947fbb485c3b8b97$var$minimal_1.default.Writer.create()) {
        if (message.state !== 0) writer.uint32(8).int32(message.state);
        if (message.ordering !== 0) writer.uint32(16).int32(message.ordering);
        if (message.counterparty !== undefined) module.exports.Counterparty.encode(message.counterparty, writer.uint32(26).fork()).ldelim();
        for (const v of message.connectionHops)writer.uint32(34).string(v);
        if (message.version !== "") writer.uint32(42).string(message.version);
        if (message.portId !== "") writer.uint32(50).string(message.portId);
        if (message.channelId !== "") writer.uint32(58).string(message.channelId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $947fbb485c3b8b97$var$minimal_1.default.Reader ? input : new $947fbb485c3b8b97$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $947fbb485c3b8b97$var$baseIdentifiedChannel);
        message.connectionHops = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.state = reader.int32();
                    break;
                case 2:
                    message.ordering = reader.int32();
                    break;
                case 3:
                    message.counterparty = module.exports.Counterparty.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.connectionHops.push(reader.string());
                    break;
                case 5:
                    message.version = reader.string();
                    break;
                case 6:
                    message.portId = reader.string();
                    break;
                case 7:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $947fbb485c3b8b97$var$baseIdentifiedChannel);
        message.connectionHops = [];
        if (object.state !== undefined && object.state !== null) message.state = $947fbb485c3b8b97$var$stateFromJSON(object.state);
        else message.state = 0;
        if (object.ordering !== undefined && object.ordering !== null) message.ordering = $947fbb485c3b8b97$var$orderFromJSON(object.ordering);
        else message.ordering = 0;
        if (object.counterparty !== undefined && object.counterparty !== null) message.counterparty = module.exports.Counterparty.fromJSON(object.counterparty);
        else message.counterparty = undefined;
        if (object.connectionHops !== undefined && object.connectionHops !== null) for (const e of object.connectionHops)message.connectionHops.push(String(e));
        if (object.version !== undefined && object.version !== null) message.version = String(object.version);
        else message.version = "";
        if (object.portId !== undefined && object.portId !== null) message.portId = String(object.portId);
        else message.portId = "";
        if (object.channelId !== undefined && object.channelId !== null) message.channelId = String(object.channelId);
        else message.channelId = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.state !== undefined && (obj.state = $947fbb485c3b8b97$var$stateToJSON(message.state));
        message.ordering !== undefined && (obj.ordering = $947fbb485c3b8b97$var$orderToJSON(message.ordering));
        message.counterparty !== undefined && (obj.counterparty = message.counterparty ? module.exports.Counterparty.toJSON(message.counterparty) : undefined);
        if (message.connectionHops) obj.connectionHops = message.connectionHops.map((e)=>e);
        else obj.connectionHops = [];
        message.version !== undefined && (obj.version = message.version);
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $947fbb485c3b8b97$var$baseIdentifiedChannel);
        message.connectionHops = [];
        if (object.state !== undefined && object.state !== null) message.state = object.state;
        else message.state = 0;
        if (object.ordering !== undefined && object.ordering !== null) message.ordering = object.ordering;
        else message.ordering = 0;
        if (object.counterparty !== undefined && object.counterparty !== null) message.counterparty = module.exports.Counterparty.fromPartial(object.counterparty);
        else message.counterparty = undefined;
        if (object.connectionHops !== undefined && object.connectionHops !== null) for (const e of object.connectionHops)message.connectionHops.push(e);
        if (object.version !== undefined && object.version !== null) message.version = object.version;
        else message.version = "";
        if (object.portId !== undefined && object.portId !== null) message.portId = object.portId;
        else message.portId = "";
        if (object.channelId !== undefined && object.channelId !== null) message.channelId = object.channelId;
        else message.channelId = "";
        return message;
    }
};
const $947fbb485c3b8b97$var$baseCounterparty = {
    portId: "",
    channelId: ""
};
module.exports.Counterparty = {
    encode (message, writer = $947fbb485c3b8b97$var$minimal_1.default.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $947fbb485c3b8b97$var$minimal_1.default.Reader ? input : new $947fbb485c3b8b97$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $947fbb485c3b8b97$var$baseCounterparty);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $947fbb485c3b8b97$var$baseCounterparty);
        if (object.portId !== undefined && object.portId !== null) message.portId = String(object.portId);
        else message.portId = "";
        if (object.channelId !== undefined && object.channelId !== null) message.channelId = String(object.channelId);
        else message.channelId = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $947fbb485c3b8b97$var$baseCounterparty);
        if (object.portId !== undefined && object.portId !== null) message.portId = object.portId;
        else message.portId = "";
        if (object.channelId !== undefined && object.channelId !== null) message.channelId = object.channelId;
        else message.channelId = "";
        return message;
    }
};
const $947fbb485c3b8b97$var$basePacket = {
    sequence: $947fbb485c3b8b97$var$long_1.default.UZERO,
    sourcePort: "",
    sourceChannel: "",
    destinationPort: "",
    destinationChannel: "",
    timeoutTimestamp: $947fbb485c3b8b97$var$long_1.default.UZERO
};
module.exports.Packet = {
    encode (message, writer = $947fbb485c3b8b97$var$minimal_1.default.Writer.create()) {
        if (!message.sequence.isZero()) writer.uint32(8).uint64(message.sequence);
        if (message.sourcePort !== "") writer.uint32(18).string(message.sourcePort);
        if (message.sourceChannel !== "") writer.uint32(26).string(message.sourceChannel);
        if (message.destinationPort !== "") writer.uint32(34).string(message.destinationPort);
        if (message.destinationChannel !== "") writer.uint32(42).string(message.destinationChannel);
        if (message.data.length !== 0) writer.uint32(50).bytes(message.data);
        if (message.timeoutHeight !== undefined) $yqmJM.Height.encode(message.timeoutHeight, writer.uint32(58).fork()).ldelim();
        if (!message.timeoutTimestamp.isZero()) writer.uint32(64).uint64(message.timeoutTimestamp);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $947fbb485c3b8b97$var$minimal_1.default.Reader ? input : new $947fbb485c3b8b97$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $947fbb485c3b8b97$var$basePacket);
        message.data = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sequence = reader.uint64();
                    break;
                case 2:
                    message.sourcePort = reader.string();
                    break;
                case 3:
                    message.sourceChannel = reader.string();
                    break;
                case 4:
                    message.destinationPort = reader.string();
                    break;
                case 5:
                    message.destinationChannel = reader.string();
                    break;
                case 6:
                    message.data = reader.bytes();
                    break;
                case 7:
                    message.timeoutHeight = $yqmJM.Height.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.timeoutTimestamp = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $947fbb485c3b8b97$var$basePacket);
        message.data = new Uint8Array();
        if (object.sequence !== undefined && object.sequence !== null) message.sequence = $947fbb485c3b8b97$var$long_1.default.fromString(object.sequence);
        else message.sequence = $947fbb485c3b8b97$var$long_1.default.UZERO;
        if (object.sourcePort !== undefined && object.sourcePort !== null) message.sourcePort = String(object.sourcePort);
        else message.sourcePort = "";
        if (object.sourceChannel !== undefined && object.sourceChannel !== null) message.sourceChannel = String(object.sourceChannel);
        else message.sourceChannel = "";
        if (object.destinationPort !== undefined && object.destinationPort !== null) message.destinationPort = String(object.destinationPort);
        else message.destinationPort = "";
        if (object.destinationChannel !== undefined && object.destinationChannel !== null) message.destinationChannel = String(object.destinationChannel);
        else message.destinationChannel = "";
        if (object.data !== undefined && object.data !== null) message.data = $947fbb485c3b8b97$var$bytesFromBase64(object.data);
        if (object.timeoutHeight !== undefined && object.timeoutHeight !== null) message.timeoutHeight = $yqmJM.Height.fromJSON(object.timeoutHeight);
        else message.timeoutHeight = undefined;
        if (object.timeoutTimestamp !== undefined && object.timeoutTimestamp !== null) message.timeoutTimestamp = $947fbb485c3b8b97$var$long_1.default.fromString(object.timeoutTimestamp);
        else message.timeoutTimestamp = $947fbb485c3b8b97$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.sequence !== undefined && (obj.sequence = (message.sequence || $947fbb485c3b8b97$var$long_1.default.UZERO).toString());
        message.sourcePort !== undefined && (obj.sourcePort = message.sourcePort);
        message.sourceChannel !== undefined && (obj.sourceChannel = message.sourceChannel);
        message.destinationPort !== undefined && (obj.destinationPort = message.destinationPort);
        message.destinationChannel !== undefined && (obj.destinationChannel = message.destinationChannel);
        message.data !== undefined && (obj.data = $947fbb485c3b8b97$var$base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        message.timeoutHeight !== undefined && (obj.timeoutHeight = message.timeoutHeight ? $yqmJM.Height.toJSON(message.timeoutHeight) : undefined);
        message.timeoutTimestamp !== undefined && (obj.timeoutTimestamp = (message.timeoutTimestamp || $947fbb485c3b8b97$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $947fbb485c3b8b97$var$basePacket);
        if (object.sequence !== undefined && object.sequence !== null) message.sequence = object.sequence;
        else message.sequence = $947fbb485c3b8b97$var$long_1.default.UZERO;
        if (object.sourcePort !== undefined && object.sourcePort !== null) message.sourcePort = object.sourcePort;
        else message.sourcePort = "";
        if (object.sourceChannel !== undefined && object.sourceChannel !== null) message.sourceChannel = object.sourceChannel;
        else message.sourceChannel = "";
        if (object.destinationPort !== undefined && object.destinationPort !== null) message.destinationPort = object.destinationPort;
        else message.destinationPort = "";
        if (object.destinationChannel !== undefined && object.destinationChannel !== null) message.destinationChannel = object.destinationChannel;
        else message.destinationChannel = "";
        if (object.data !== undefined && object.data !== null) message.data = object.data;
        else message.data = new Uint8Array();
        if (object.timeoutHeight !== undefined && object.timeoutHeight !== null) message.timeoutHeight = $yqmJM.Height.fromPartial(object.timeoutHeight);
        else message.timeoutHeight = undefined;
        if (object.timeoutTimestamp !== undefined && object.timeoutTimestamp !== null) message.timeoutTimestamp = object.timeoutTimestamp;
        else message.timeoutTimestamp = $947fbb485c3b8b97$var$long_1.default.UZERO;
        return message;
    }
};
const $947fbb485c3b8b97$var$basePacketState = {
    portId: "",
    channelId: "",
    sequence: $947fbb485c3b8b97$var$long_1.default.UZERO
};
module.exports.PacketState = {
    encode (message, writer = $947fbb485c3b8b97$var$minimal_1.default.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (!message.sequence.isZero()) writer.uint32(24).uint64(message.sequence);
        if (message.data.length !== 0) writer.uint32(34).bytes(message.data);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $947fbb485c3b8b97$var$minimal_1.default.Reader ? input : new $947fbb485c3b8b97$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $947fbb485c3b8b97$var$basePacketState);
        message.data = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                case 4:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $947fbb485c3b8b97$var$basePacketState);
        message.data = new Uint8Array();
        if (object.portId !== undefined && object.portId !== null) message.portId = String(object.portId);
        else message.portId = "";
        if (object.channelId !== undefined && object.channelId !== null) message.channelId = String(object.channelId);
        else message.channelId = "";
        if (object.sequence !== undefined && object.sequence !== null) message.sequence = $947fbb485c3b8b97$var$long_1.default.fromString(object.sequence);
        else message.sequence = $947fbb485c3b8b97$var$long_1.default.UZERO;
        if (object.data !== undefined && object.data !== null) message.data = $947fbb485c3b8b97$var$bytesFromBase64(object.data);
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.sequence !== undefined && (obj.sequence = (message.sequence || $947fbb485c3b8b97$var$long_1.default.UZERO).toString());
        message.data !== undefined && (obj.data = $947fbb485c3b8b97$var$base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $947fbb485c3b8b97$var$basePacketState);
        if (object.portId !== undefined && object.portId !== null) message.portId = object.portId;
        else message.portId = "";
        if (object.channelId !== undefined && object.channelId !== null) message.channelId = object.channelId;
        else message.channelId = "";
        if (object.sequence !== undefined && object.sequence !== null) message.sequence = object.sequence;
        else message.sequence = $947fbb485c3b8b97$var$long_1.default.UZERO;
        if (object.data !== undefined && object.data !== null) message.data = object.data;
        else message.data = new Uint8Array();
        return message;
    }
};
const $947fbb485c3b8b97$var$basePacketId = {
    portId: "",
    channelId: "",
    sequence: $947fbb485c3b8b97$var$long_1.default.UZERO
};
module.exports.PacketId = {
    encode (message, writer = $947fbb485c3b8b97$var$minimal_1.default.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (!message.sequence.isZero()) writer.uint32(24).uint64(message.sequence);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $947fbb485c3b8b97$var$minimal_1.default.Reader ? input : new $947fbb485c3b8b97$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $947fbb485c3b8b97$var$basePacketId);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $947fbb485c3b8b97$var$basePacketId);
        if (object.portId !== undefined && object.portId !== null) message.portId = String(object.portId);
        else message.portId = "";
        if (object.channelId !== undefined && object.channelId !== null) message.channelId = String(object.channelId);
        else message.channelId = "";
        if (object.sequence !== undefined && object.sequence !== null) message.sequence = $947fbb485c3b8b97$var$long_1.default.fromString(object.sequence);
        else message.sequence = $947fbb485c3b8b97$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.sequence !== undefined && (obj.sequence = (message.sequence || $947fbb485c3b8b97$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $947fbb485c3b8b97$var$basePacketId);
        if (object.portId !== undefined && object.portId !== null) message.portId = object.portId;
        else message.portId = "";
        if (object.channelId !== undefined && object.channelId !== null) message.channelId = object.channelId;
        else message.channelId = "";
        if (object.sequence !== undefined && object.sequence !== null) message.sequence = object.sequence;
        else message.sequence = $947fbb485c3b8b97$var$long_1.default.UZERO;
        return message;
    }
};
const $947fbb485c3b8b97$var$baseAcknowledgement = {};
module.exports.Acknowledgement = {
    encode (message, writer = $947fbb485c3b8b97$var$minimal_1.default.Writer.create()) {
        if (message.result !== undefined) writer.uint32(170).bytes(message.result);
        if (message.error !== undefined) writer.uint32(178).string(message.error);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $947fbb485c3b8b97$var$minimal_1.default.Reader ? input : new $947fbb485c3b8b97$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $947fbb485c3b8b97$var$baseAcknowledgement);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 21:
                    message.result = reader.bytes();
                    break;
                case 22:
                    message.error = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $947fbb485c3b8b97$var$baseAcknowledgement);
        if (object.result !== undefined && object.result !== null) message.result = $947fbb485c3b8b97$var$bytesFromBase64(object.result);
        if (object.error !== undefined && object.error !== null) message.error = String(object.error);
        else message.error = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.result !== undefined && (obj.result = message.result !== undefined ? $947fbb485c3b8b97$var$base64FromBytes(message.result) : undefined);
        message.error !== undefined && (obj.error = message.error);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $947fbb485c3b8b97$var$baseAcknowledgement);
        if (object.result !== undefined && object.result !== null) message.result = object.result;
        else message.result = undefined;
        if (object.error !== undefined && object.error !== null) message.error = object.error;
        else message.error = undefined;
        return message;
    }
};
var $947fbb485c3b8b97$var$globalThis = (()=>{
    if (typeof $947fbb485c3b8b97$var$globalThis !== "undefined") return $947fbb485c3b8b97$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $947fbb485c3b8b97$var$atob = $947fbb485c3b8b97$var$globalThis.atob || ((b64)=>$947fbb485c3b8b97$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $947fbb485c3b8b97$var$bytesFromBase64(b64) {
    const bin = $947fbb485c3b8b97$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $947fbb485c3b8b97$var$btoa = $947fbb485c3b8b97$var$globalThis.btoa || ((bin)=>$947fbb485c3b8b97$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $947fbb485c3b8b97$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $947fbb485c3b8b97$var$btoa(bin.join(""));
}
if ($947fbb485c3b8b97$var$minimal_1.default.util.Long !== $947fbb485c3b8b97$var$long_1.default) {
    $947fbb485c3b8b97$var$minimal_1.default.util.Long = $947fbb485c3b8b97$var$long_1.default;
    $947fbb485c3b8b97$var$minimal_1.default.configure();
}

});

parcelRegister("kDevM", function(module, exports) {
"use strict";
var $f052b4d74761f3b4$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Counterparty = void 0;

var $cKsix = parcelRequire("cKsix");

var $26Eqx = parcelRequire("26Eqx");
/** Counterparty defines a channel end counterparty */ var $f052b4d74761f3b4$var$Counterparty = /** @class */ function(_super) {
    $f052b4d74761f3b4$var$__extends(Counterparty, _super);
    /**
     * @param port_id port on the counterparty chain which owns the other end of the channel.
     * @param channel_id channel end on the counterparty chain
     */ function Counterparty(port_id, channel_id) {
        var _this = _super.call(this) || this;
        _this.port_id = port_id;
        _this.channel_id = channel_id;
        return _this;
    }
    Counterparty.fromAmino = function(data) {
        var port_id = data.port_id, channel_id = data.channel_id;
        return new Counterparty(port_id, channel_id);
    };
    Counterparty.prototype.toAmino = function() {
        var _a = this, port_id = _a.port_id, channel_id = _a.channel_id;
        var res = {
            port_id: port_id,
            channel_id: channel_id
        };
        return res;
    };
    Counterparty.fromData = function(data) {
        var port_id = data.port_id, channel_id = data.channel_id;
        return new Counterparty(port_id, channel_id);
    };
    Counterparty.prototype.toData = function() {
        var _a = this, port_id = _a.port_id, channel_id = _a.channel_id;
        var res = {
            port_id: port_id,
            channel_id: channel_id
        };
        return res;
    };
    Counterparty.fromProto = function(proto) {
        return new Counterparty(proto.portId, proto.channelId);
    };
    Counterparty.prototype.toProto = function() {
        var _a = this, port_id = _a.port_id, channel_id = _a.channel_id;
        return $cKsix.Counterparty.fromPartial({
            portId: port_id,
            channelId: channel_id
        });
    };
    return Counterparty;
}($26Eqx.JSONSerializable);
module.exports.Counterparty = $f052b4d74761f3b4$var$Counterparty;

});


parcelRegister("hjcrP", function(module, exports) {
"use strict";
var $c99ddde25849173f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GrpcWebImpl = module.exports.MsgAcknowledgementDesc = module.exports.MsgTimeoutOnCloseDesc = module.exports.MsgTimeoutDesc = module.exports.MsgRecvPacketDesc = module.exports.MsgChannelCloseConfirmDesc = module.exports.MsgChannelCloseInitDesc = module.exports.MsgChannelOpenConfirmDesc = module.exports.MsgChannelOpenAckDesc = module.exports.MsgChannelOpenTryDesc = module.exports.MsgChannelOpenInitDesc = module.exports.MsgDesc = module.exports.MsgClientImpl = module.exports.MsgAcknowledgementResponse = module.exports.MsgAcknowledgement = module.exports.MsgTimeoutOnCloseResponse = module.exports.MsgTimeoutOnClose = module.exports.MsgTimeoutResponse = module.exports.MsgTimeout = module.exports.MsgRecvPacketResponse = module.exports.MsgRecvPacket = module.exports.MsgChannelCloseConfirmResponse = module.exports.MsgChannelCloseConfirm = module.exports.MsgChannelCloseInitResponse = module.exports.MsgChannelCloseInit = module.exports.MsgChannelOpenConfirmResponse = module.exports.MsgChannelOpenConfirm = module.exports.MsgChannelOpenAckResponse = module.exports.MsgChannelOpenAck = module.exports.MsgChannelOpenTryResponse = module.exports.MsgChannelOpenTry = module.exports.MsgChannelOpenInitResponse = module.exports.MsgChannelOpenInit = module.exports.responseResultTypeToJSON = module.exports.responseResultTypeFromJSON = module.exports.ResponseResultType = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $c99ddde25849173f$var$long_1 = $c99ddde25849173f$var$__importDefault((parcelRequire("9A55m")));

var $jXVni = parcelRequire("jXVni");

const $c99ddde25849173f$var$minimal_1 = $c99ddde25849173f$var$__importDefault((parcelRequire("i2pIU")));

var $cKsix = parcelRequire("cKsix");

var $yqmJM = parcelRequire("yqmJM");

var $1pqjL = parcelRequire("1pqjL");
module.exports.protobufPackage = "ibc.core.channel.v1";
/** ResponseResultType defines the possible outcomes of the execution of a message */ var $c99ddde25849173f$var$ResponseResultType;
(function(ResponseResultType) {
    /** RESPONSE_RESULT_TYPE_UNSPECIFIED - Default zero value enumeration */ ResponseResultType[ResponseResultType["RESPONSE_RESULT_TYPE_UNSPECIFIED"] = 0] = "RESPONSE_RESULT_TYPE_UNSPECIFIED";
    /** RESPONSE_RESULT_TYPE_NOOP - The message did not call the IBC application callbacks (because, for example, the packet had already been relayed) */ ResponseResultType[ResponseResultType["RESPONSE_RESULT_TYPE_NOOP"] = 1] = "RESPONSE_RESULT_TYPE_NOOP";
    /** RESPONSE_RESULT_TYPE_SUCCESS - The message was executed successfully */ ResponseResultType[ResponseResultType["RESPONSE_RESULT_TYPE_SUCCESS"] = 2] = "RESPONSE_RESULT_TYPE_SUCCESS";
    ResponseResultType[ResponseResultType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($c99ddde25849173f$var$ResponseResultType = module.exports.ResponseResultType || (module.exports.ResponseResultType = {}));
function $c99ddde25849173f$var$responseResultTypeFromJSON(object) {
    switch(object){
        case 0:
        case "RESPONSE_RESULT_TYPE_UNSPECIFIED":
            return $c99ddde25849173f$var$ResponseResultType.RESPONSE_RESULT_TYPE_UNSPECIFIED;
        case 1:
        case "RESPONSE_RESULT_TYPE_NOOP":
            return $c99ddde25849173f$var$ResponseResultType.RESPONSE_RESULT_TYPE_NOOP;
        case 2:
        case "RESPONSE_RESULT_TYPE_SUCCESS":
            return $c99ddde25849173f$var$ResponseResultType.RESPONSE_RESULT_TYPE_SUCCESS;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $c99ddde25849173f$var$ResponseResultType.UNRECOGNIZED;
    }
}
module.exports.responseResultTypeFromJSON = $c99ddde25849173f$var$responseResultTypeFromJSON;
function $c99ddde25849173f$var$responseResultTypeToJSON(object) {
    switch(object){
        case $c99ddde25849173f$var$ResponseResultType.RESPONSE_RESULT_TYPE_UNSPECIFIED:
            return "RESPONSE_RESULT_TYPE_UNSPECIFIED";
        case $c99ddde25849173f$var$ResponseResultType.RESPONSE_RESULT_TYPE_NOOP:
            return "RESPONSE_RESULT_TYPE_NOOP";
        case $c99ddde25849173f$var$ResponseResultType.RESPONSE_RESULT_TYPE_SUCCESS:
            return "RESPONSE_RESULT_TYPE_SUCCESS";
        default:
            return "UNKNOWN";
    }
}
module.exports.responseResultTypeToJSON = $c99ddde25849173f$var$responseResultTypeToJSON;
const $c99ddde25849173f$var$baseMsgChannelOpenInit = {
    portId: "",
    signer: ""
};
module.exports.MsgChannelOpenInit = {
    encode (message, writer = $c99ddde25849173f$var$minimal_1.default.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channel !== undefined) $cKsix.Channel.encode(message.channel, writer.uint32(18).fork()).ldelim();
        if (message.signer !== "") writer.uint32(26).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c99ddde25849173f$var$minimal_1.default.Reader ? input : new $c99ddde25849173f$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgChannelOpenInit);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channel = $cKsix.Channel.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgChannelOpenInit);
        if (object.portId !== undefined && object.portId !== null) message.portId = String(object.portId);
        else message.portId = "";
        if (object.channel !== undefined && object.channel !== null) message.channel = $cKsix.Channel.fromJSON(object.channel);
        else message.channel = undefined;
        if (object.signer !== undefined && object.signer !== null) message.signer = String(object.signer);
        else message.signer = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channel !== undefined && (obj.channel = message.channel ? $cKsix.Channel.toJSON(message.channel) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgChannelOpenInit);
        if (object.portId !== undefined && object.portId !== null) message.portId = object.portId;
        else message.portId = "";
        if (object.channel !== undefined && object.channel !== null) message.channel = $cKsix.Channel.fromPartial(object.channel);
        else message.channel = undefined;
        if (object.signer !== undefined && object.signer !== null) message.signer = object.signer;
        else message.signer = "";
        return message;
    }
};
const $c99ddde25849173f$var$baseMsgChannelOpenInitResponse = {
    channelId: ""
};
module.exports.MsgChannelOpenInitResponse = {
    encode (message, writer = $c99ddde25849173f$var$minimal_1.default.Writer.create()) {
        if (message.channelId !== "") writer.uint32(10).string(message.channelId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c99ddde25849173f$var$minimal_1.default.Reader ? input : new $c99ddde25849173f$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgChannelOpenInitResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgChannelOpenInitResponse);
        if (object.channelId !== undefined && object.channelId !== null) message.channelId = String(object.channelId);
        else message.channelId = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgChannelOpenInitResponse);
        if (object.channelId !== undefined && object.channelId !== null) message.channelId = object.channelId;
        else message.channelId = "";
        return message;
    }
};
const $c99ddde25849173f$var$baseMsgChannelOpenTry = {
    portId: "",
    previousChannelId: "",
    counterpartyVersion: "",
    signer: ""
};
module.exports.MsgChannelOpenTry = {
    encode (message, writer = $c99ddde25849173f$var$minimal_1.default.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.previousChannelId !== "") writer.uint32(18).string(message.previousChannelId);
        if (message.channel !== undefined) $cKsix.Channel.encode(message.channel, writer.uint32(26).fork()).ldelim();
        if (message.counterpartyVersion !== "") writer.uint32(34).string(message.counterpartyVersion);
        if (message.proofInit.length !== 0) writer.uint32(42).bytes(message.proofInit);
        if (message.proofHeight !== undefined) $yqmJM.Height.encode(message.proofHeight, writer.uint32(50).fork()).ldelim();
        if (message.signer !== "") writer.uint32(58).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c99ddde25849173f$var$minimal_1.default.Reader ? input : new $c99ddde25849173f$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgChannelOpenTry);
        message.proofInit = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.previousChannelId = reader.string();
                    break;
                case 3:
                    message.channel = $cKsix.Channel.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.counterpartyVersion = reader.string();
                    break;
                case 5:
                    message.proofInit = reader.bytes();
                    break;
                case 6:
                    message.proofHeight = $yqmJM.Height.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgChannelOpenTry);
        message.proofInit = new Uint8Array();
        if (object.portId !== undefined && object.portId !== null) message.portId = String(object.portId);
        else message.portId = "";
        if (object.previousChannelId !== undefined && object.previousChannelId !== null) message.previousChannelId = String(object.previousChannelId);
        else message.previousChannelId = "";
        if (object.channel !== undefined && object.channel !== null) message.channel = $cKsix.Channel.fromJSON(object.channel);
        else message.channel = undefined;
        if (object.counterpartyVersion !== undefined && object.counterpartyVersion !== null) message.counterpartyVersion = String(object.counterpartyVersion);
        else message.counterpartyVersion = "";
        if (object.proofInit !== undefined && object.proofInit !== null) message.proofInit = $c99ddde25849173f$var$bytesFromBase64(object.proofInit);
        if (object.proofHeight !== undefined && object.proofHeight !== null) message.proofHeight = $yqmJM.Height.fromJSON(object.proofHeight);
        else message.proofHeight = undefined;
        if (object.signer !== undefined && object.signer !== null) message.signer = String(object.signer);
        else message.signer = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.previousChannelId !== undefined && (obj.previousChannelId = message.previousChannelId);
        message.channel !== undefined && (obj.channel = message.channel ? $cKsix.Channel.toJSON(message.channel) : undefined);
        message.counterpartyVersion !== undefined && (obj.counterpartyVersion = message.counterpartyVersion);
        message.proofInit !== undefined && (obj.proofInit = $c99ddde25849173f$var$base64FromBytes(message.proofInit !== undefined ? message.proofInit : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $yqmJM.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgChannelOpenTry);
        if (object.portId !== undefined && object.portId !== null) message.portId = object.portId;
        else message.portId = "";
        if (object.previousChannelId !== undefined && object.previousChannelId !== null) message.previousChannelId = object.previousChannelId;
        else message.previousChannelId = "";
        if (object.channel !== undefined && object.channel !== null) message.channel = $cKsix.Channel.fromPartial(object.channel);
        else message.channel = undefined;
        if (object.counterpartyVersion !== undefined && object.counterpartyVersion !== null) message.counterpartyVersion = object.counterpartyVersion;
        else message.counterpartyVersion = "";
        if (object.proofInit !== undefined && object.proofInit !== null) message.proofInit = object.proofInit;
        else message.proofInit = new Uint8Array();
        if (object.proofHeight !== undefined && object.proofHeight !== null) message.proofHeight = $yqmJM.Height.fromPartial(object.proofHeight);
        else message.proofHeight = undefined;
        if (object.signer !== undefined && object.signer !== null) message.signer = object.signer;
        else message.signer = "";
        return message;
    }
};
const $c99ddde25849173f$var$baseMsgChannelOpenTryResponse = {};
module.exports.MsgChannelOpenTryResponse = {
    encode (_, writer = $c99ddde25849173f$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c99ddde25849173f$var$minimal_1.default.Reader ? input : new $c99ddde25849173f$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgChannelOpenTryResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgChannelOpenTryResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgChannelOpenTryResponse);
        return message;
    }
};
const $c99ddde25849173f$var$baseMsgChannelOpenAck = {
    portId: "",
    channelId: "",
    counterpartyChannelId: "",
    counterpartyVersion: "",
    signer: ""
};
module.exports.MsgChannelOpenAck = {
    encode (message, writer = $c99ddde25849173f$var$minimal_1.default.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (message.counterpartyChannelId !== "") writer.uint32(26).string(message.counterpartyChannelId);
        if (message.counterpartyVersion !== "") writer.uint32(34).string(message.counterpartyVersion);
        if (message.proofTry.length !== 0) writer.uint32(42).bytes(message.proofTry);
        if (message.proofHeight !== undefined) $yqmJM.Height.encode(message.proofHeight, writer.uint32(50).fork()).ldelim();
        if (message.signer !== "") writer.uint32(58).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c99ddde25849173f$var$minimal_1.default.Reader ? input : new $c99ddde25849173f$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgChannelOpenAck);
        message.proofTry = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.counterpartyChannelId = reader.string();
                    break;
                case 4:
                    message.counterpartyVersion = reader.string();
                    break;
                case 5:
                    message.proofTry = reader.bytes();
                    break;
                case 6:
                    message.proofHeight = $yqmJM.Height.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgChannelOpenAck);
        message.proofTry = new Uint8Array();
        if (object.portId !== undefined && object.portId !== null) message.portId = String(object.portId);
        else message.portId = "";
        if (object.channelId !== undefined && object.channelId !== null) message.channelId = String(object.channelId);
        else message.channelId = "";
        if (object.counterpartyChannelId !== undefined && object.counterpartyChannelId !== null) message.counterpartyChannelId = String(object.counterpartyChannelId);
        else message.counterpartyChannelId = "";
        if (object.counterpartyVersion !== undefined && object.counterpartyVersion !== null) message.counterpartyVersion = String(object.counterpartyVersion);
        else message.counterpartyVersion = "";
        if (object.proofTry !== undefined && object.proofTry !== null) message.proofTry = $c99ddde25849173f$var$bytesFromBase64(object.proofTry);
        if (object.proofHeight !== undefined && object.proofHeight !== null) message.proofHeight = $yqmJM.Height.fromJSON(object.proofHeight);
        else message.proofHeight = undefined;
        if (object.signer !== undefined && object.signer !== null) message.signer = String(object.signer);
        else message.signer = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.counterpartyChannelId !== undefined && (obj.counterpartyChannelId = message.counterpartyChannelId);
        message.counterpartyVersion !== undefined && (obj.counterpartyVersion = message.counterpartyVersion);
        message.proofTry !== undefined && (obj.proofTry = $c99ddde25849173f$var$base64FromBytes(message.proofTry !== undefined ? message.proofTry : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $yqmJM.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgChannelOpenAck);
        if (object.portId !== undefined && object.portId !== null) message.portId = object.portId;
        else message.portId = "";
        if (object.channelId !== undefined && object.channelId !== null) message.channelId = object.channelId;
        else message.channelId = "";
        if (object.counterpartyChannelId !== undefined && object.counterpartyChannelId !== null) message.counterpartyChannelId = object.counterpartyChannelId;
        else message.counterpartyChannelId = "";
        if (object.counterpartyVersion !== undefined && object.counterpartyVersion !== null) message.counterpartyVersion = object.counterpartyVersion;
        else message.counterpartyVersion = "";
        if (object.proofTry !== undefined && object.proofTry !== null) message.proofTry = object.proofTry;
        else message.proofTry = new Uint8Array();
        if (object.proofHeight !== undefined && object.proofHeight !== null) message.proofHeight = $yqmJM.Height.fromPartial(object.proofHeight);
        else message.proofHeight = undefined;
        if (object.signer !== undefined && object.signer !== null) message.signer = object.signer;
        else message.signer = "";
        return message;
    }
};
const $c99ddde25849173f$var$baseMsgChannelOpenAckResponse = {};
module.exports.MsgChannelOpenAckResponse = {
    encode (_, writer = $c99ddde25849173f$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c99ddde25849173f$var$minimal_1.default.Reader ? input : new $c99ddde25849173f$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgChannelOpenAckResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgChannelOpenAckResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgChannelOpenAckResponse);
        return message;
    }
};
const $c99ddde25849173f$var$baseMsgChannelOpenConfirm = {
    portId: "",
    channelId: "",
    signer: ""
};
module.exports.MsgChannelOpenConfirm = {
    encode (message, writer = $c99ddde25849173f$var$minimal_1.default.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (message.proofAck.length !== 0) writer.uint32(26).bytes(message.proofAck);
        if (message.proofHeight !== undefined) $yqmJM.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        if (message.signer !== "") writer.uint32(42).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c99ddde25849173f$var$minimal_1.default.Reader ? input : new $c99ddde25849173f$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgChannelOpenConfirm);
        message.proofAck = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.proofAck = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = $yqmJM.Height.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgChannelOpenConfirm);
        message.proofAck = new Uint8Array();
        if (object.portId !== undefined && object.portId !== null) message.portId = String(object.portId);
        else message.portId = "";
        if (object.channelId !== undefined && object.channelId !== null) message.channelId = String(object.channelId);
        else message.channelId = "";
        if (object.proofAck !== undefined && object.proofAck !== null) message.proofAck = $c99ddde25849173f$var$bytesFromBase64(object.proofAck);
        if (object.proofHeight !== undefined && object.proofHeight !== null) message.proofHeight = $yqmJM.Height.fromJSON(object.proofHeight);
        else message.proofHeight = undefined;
        if (object.signer !== undefined && object.signer !== null) message.signer = String(object.signer);
        else message.signer = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.proofAck !== undefined && (obj.proofAck = $c99ddde25849173f$var$base64FromBytes(message.proofAck !== undefined ? message.proofAck : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $yqmJM.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgChannelOpenConfirm);
        if (object.portId !== undefined && object.portId !== null) message.portId = object.portId;
        else message.portId = "";
        if (object.channelId !== undefined && object.channelId !== null) message.channelId = object.channelId;
        else message.channelId = "";
        if (object.proofAck !== undefined && object.proofAck !== null) message.proofAck = object.proofAck;
        else message.proofAck = new Uint8Array();
        if (object.proofHeight !== undefined && object.proofHeight !== null) message.proofHeight = $yqmJM.Height.fromPartial(object.proofHeight);
        else message.proofHeight = undefined;
        if (object.signer !== undefined && object.signer !== null) message.signer = object.signer;
        else message.signer = "";
        return message;
    }
};
const $c99ddde25849173f$var$baseMsgChannelOpenConfirmResponse = {};
module.exports.MsgChannelOpenConfirmResponse = {
    encode (_, writer = $c99ddde25849173f$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c99ddde25849173f$var$minimal_1.default.Reader ? input : new $c99ddde25849173f$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgChannelOpenConfirmResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgChannelOpenConfirmResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgChannelOpenConfirmResponse);
        return message;
    }
};
const $c99ddde25849173f$var$baseMsgChannelCloseInit = {
    portId: "",
    channelId: "",
    signer: ""
};
module.exports.MsgChannelCloseInit = {
    encode (message, writer = $c99ddde25849173f$var$minimal_1.default.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (message.signer !== "") writer.uint32(26).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c99ddde25849173f$var$minimal_1.default.Reader ? input : new $c99ddde25849173f$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgChannelCloseInit);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgChannelCloseInit);
        if (object.portId !== undefined && object.portId !== null) message.portId = String(object.portId);
        else message.portId = "";
        if (object.channelId !== undefined && object.channelId !== null) message.channelId = String(object.channelId);
        else message.channelId = "";
        if (object.signer !== undefined && object.signer !== null) message.signer = String(object.signer);
        else message.signer = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgChannelCloseInit);
        if (object.portId !== undefined && object.portId !== null) message.portId = object.portId;
        else message.portId = "";
        if (object.channelId !== undefined && object.channelId !== null) message.channelId = object.channelId;
        else message.channelId = "";
        if (object.signer !== undefined && object.signer !== null) message.signer = object.signer;
        else message.signer = "";
        return message;
    }
};
const $c99ddde25849173f$var$baseMsgChannelCloseInitResponse = {};
module.exports.MsgChannelCloseInitResponse = {
    encode (_, writer = $c99ddde25849173f$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c99ddde25849173f$var$minimal_1.default.Reader ? input : new $c99ddde25849173f$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgChannelCloseInitResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgChannelCloseInitResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgChannelCloseInitResponse);
        return message;
    }
};
const $c99ddde25849173f$var$baseMsgChannelCloseConfirm = {
    portId: "",
    channelId: "",
    signer: ""
};
module.exports.MsgChannelCloseConfirm = {
    encode (message, writer = $c99ddde25849173f$var$minimal_1.default.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (message.proofInit.length !== 0) writer.uint32(26).bytes(message.proofInit);
        if (message.proofHeight !== undefined) $yqmJM.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        if (message.signer !== "") writer.uint32(42).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c99ddde25849173f$var$minimal_1.default.Reader ? input : new $c99ddde25849173f$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgChannelCloseConfirm);
        message.proofInit = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.proofInit = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = $yqmJM.Height.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgChannelCloseConfirm);
        message.proofInit = new Uint8Array();
        if (object.portId !== undefined && object.portId !== null) message.portId = String(object.portId);
        else message.portId = "";
        if (object.channelId !== undefined && object.channelId !== null) message.channelId = String(object.channelId);
        else message.channelId = "";
        if (object.proofInit !== undefined && object.proofInit !== null) message.proofInit = $c99ddde25849173f$var$bytesFromBase64(object.proofInit);
        if (object.proofHeight !== undefined && object.proofHeight !== null) message.proofHeight = $yqmJM.Height.fromJSON(object.proofHeight);
        else message.proofHeight = undefined;
        if (object.signer !== undefined && object.signer !== null) message.signer = String(object.signer);
        else message.signer = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.proofInit !== undefined && (obj.proofInit = $c99ddde25849173f$var$base64FromBytes(message.proofInit !== undefined ? message.proofInit : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $yqmJM.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgChannelCloseConfirm);
        if (object.portId !== undefined && object.portId !== null) message.portId = object.portId;
        else message.portId = "";
        if (object.channelId !== undefined && object.channelId !== null) message.channelId = object.channelId;
        else message.channelId = "";
        if (object.proofInit !== undefined && object.proofInit !== null) message.proofInit = object.proofInit;
        else message.proofInit = new Uint8Array();
        if (object.proofHeight !== undefined && object.proofHeight !== null) message.proofHeight = $yqmJM.Height.fromPartial(object.proofHeight);
        else message.proofHeight = undefined;
        if (object.signer !== undefined && object.signer !== null) message.signer = object.signer;
        else message.signer = "";
        return message;
    }
};
const $c99ddde25849173f$var$baseMsgChannelCloseConfirmResponse = {};
module.exports.MsgChannelCloseConfirmResponse = {
    encode (_, writer = $c99ddde25849173f$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c99ddde25849173f$var$minimal_1.default.Reader ? input : new $c99ddde25849173f$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgChannelCloseConfirmResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgChannelCloseConfirmResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgChannelCloseConfirmResponse);
        return message;
    }
};
const $c99ddde25849173f$var$baseMsgRecvPacket = {
    signer: ""
};
module.exports.MsgRecvPacket = {
    encode (message, writer = $c99ddde25849173f$var$minimal_1.default.Writer.create()) {
        if (message.packet !== undefined) $cKsix.Packet.encode(message.packet, writer.uint32(10).fork()).ldelim();
        if (message.proofCommitment.length !== 0) writer.uint32(18).bytes(message.proofCommitment);
        if (message.proofHeight !== undefined) $yqmJM.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        if (message.signer !== "") writer.uint32(34).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c99ddde25849173f$var$minimal_1.default.Reader ? input : new $c99ddde25849173f$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgRecvPacket);
        message.proofCommitment = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.packet = $cKsix.Packet.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proofCommitment = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $yqmJM.Height.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgRecvPacket);
        message.proofCommitment = new Uint8Array();
        if (object.packet !== undefined && object.packet !== null) message.packet = $cKsix.Packet.fromJSON(object.packet);
        else message.packet = undefined;
        if (object.proofCommitment !== undefined && object.proofCommitment !== null) message.proofCommitment = $c99ddde25849173f$var$bytesFromBase64(object.proofCommitment);
        if (object.proofHeight !== undefined && object.proofHeight !== null) message.proofHeight = $yqmJM.Height.fromJSON(object.proofHeight);
        else message.proofHeight = undefined;
        if (object.signer !== undefined && object.signer !== null) message.signer = String(object.signer);
        else message.signer = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.packet !== undefined && (obj.packet = message.packet ? $cKsix.Packet.toJSON(message.packet) : undefined);
        message.proofCommitment !== undefined && (obj.proofCommitment = $c99ddde25849173f$var$base64FromBytes(message.proofCommitment !== undefined ? message.proofCommitment : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $yqmJM.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgRecvPacket);
        if (object.packet !== undefined && object.packet !== null) message.packet = $cKsix.Packet.fromPartial(object.packet);
        else message.packet = undefined;
        if (object.proofCommitment !== undefined && object.proofCommitment !== null) message.proofCommitment = object.proofCommitment;
        else message.proofCommitment = new Uint8Array();
        if (object.proofHeight !== undefined && object.proofHeight !== null) message.proofHeight = $yqmJM.Height.fromPartial(object.proofHeight);
        else message.proofHeight = undefined;
        if (object.signer !== undefined && object.signer !== null) message.signer = object.signer;
        else message.signer = "";
        return message;
    }
};
const $c99ddde25849173f$var$baseMsgRecvPacketResponse = {
    result: 0
};
module.exports.MsgRecvPacketResponse = {
    encode (message, writer = $c99ddde25849173f$var$minimal_1.default.Writer.create()) {
        if (message.result !== 0) writer.uint32(8).int32(message.result);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c99ddde25849173f$var$minimal_1.default.Reader ? input : new $c99ddde25849173f$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgRecvPacketResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.result = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgRecvPacketResponse);
        if (object.result !== undefined && object.result !== null) message.result = $c99ddde25849173f$var$responseResultTypeFromJSON(object.result);
        else message.result = 0;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.result !== undefined && (obj.result = $c99ddde25849173f$var$responseResultTypeToJSON(message.result));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgRecvPacketResponse);
        if (object.result !== undefined && object.result !== null) message.result = object.result;
        else message.result = 0;
        return message;
    }
};
const $c99ddde25849173f$var$baseMsgTimeout = {
    nextSequenceRecv: $c99ddde25849173f$var$long_1.default.UZERO,
    signer: ""
};
module.exports.MsgTimeout = {
    encode (message, writer = $c99ddde25849173f$var$minimal_1.default.Writer.create()) {
        if (message.packet !== undefined) $cKsix.Packet.encode(message.packet, writer.uint32(10).fork()).ldelim();
        if (message.proofUnreceived.length !== 0) writer.uint32(18).bytes(message.proofUnreceived);
        if (message.proofHeight !== undefined) $yqmJM.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        if (!message.nextSequenceRecv.isZero()) writer.uint32(32).uint64(message.nextSequenceRecv);
        if (message.signer !== "") writer.uint32(42).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c99ddde25849173f$var$minimal_1.default.Reader ? input : new $c99ddde25849173f$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgTimeout);
        message.proofUnreceived = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.packet = $cKsix.Packet.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proofUnreceived = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $yqmJM.Height.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.nextSequenceRecv = reader.uint64();
                    break;
                case 5:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgTimeout);
        message.proofUnreceived = new Uint8Array();
        if (object.packet !== undefined && object.packet !== null) message.packet = $cKsix.Packet.fromJSON(object.packet);
        else message.packet = undefined;
        if (object.proofUnreceived !== undefined && object.proofUnreceived !== null) message.proofUnreceived = $c99ddde25849173f$var$bytesFromBase64(object.proofUnreceived);
        if (object.proofHeight !== undefined && object.proofHeight !== null) message.proofHeight = $yqmJM.Height.fromJSON(object.proofHeight);
        else message.proofHeight = undefined;
        if (object.nextSequenceRecv !== undefined && object.nextSequenceRecv !== null) message.nextSequenceRecv = $c99ddde25849173f$var$long_1.default.fromString(object.nextSequenceRecv);
        else message.nextSequenceRecv = $c99ddde25849173f$var$long_1.default.UZERO;
        if (object.signer !== undefined && object.signer !== null) message.signer = String(object.signer);
        else message.signer = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.packet !== undefined && (obj.packet = message.packet ? $cKsix.Packet.toJSON(message.packet) : undefined);
        message.proofUnreceived !== undefined && (obj.proofUnreceived = $c99ddde25849173f$var$base64FromBytes(message.proofUnreceived !== undefined ? message.proofUnreceived : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $yqmJM.Height.toJSON(message.proofHeight) : undefined);
        message.nextSequenceRecv !== undefined && (obj.nextSequenceRecv = (message.nextSequenceRecv || $c99ddde25849173f$var$long_1.default.UZERO).toString());
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgTimeout);
        if (object.packet !== undefined && object.packet !== null) message.packet = $cKsix.Packet.fromPartial(object.packet);
        else message.packet = undefined;
        if (object.proofUnreceived !== undefined && object.proofUnreceived !== null) message.proofUnreceived = object.proofUnreceived;
        else message.proofUnreceived = new Uint8Array();
        if (object.proofHeight !== undefined && object.proofHeight !== null) message.proofHeight = $yqmJM.Height.fromPartial(object.proofHeight);
        else message.proofHeight = undefined;
        if (object.nextSequenceRecv !== undefined && object.nextSequenceRecv !== null) message.nextSequenceRecv = object.nextSequenceRecv;
        else message.nextSequenceRecv = $c99ddde25849173f$var$long_1.default.UZERO;
        if (object.signer !== undefined && object.signer !== null) message.signer = object.signer;
        else message.signer = "";
        return message;
    }
};
const $c99ddde25849173f$var$baseMsgTimeoutResponse = {
    result: 0
};
module.exports.MsgTimeoutResponse = {
    encode (message, writer = $c99ddde25849173f$var$minimal_1.default.Writer.create()) {
        if (message.result !== 0) writer.uint32(8).int32(message.result);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c99ddde25849173f$var$minimal_1.default.Reader ? input : new $c99ddde25849173f$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgTimeoutResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.result = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgTimeoutResponse);
        if (object.result !== undefined && object.result !== null) message.result = $c99ddde25849173f$var$responseResultTypeFromJSON(object.result);
        else message.result = 0;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.result !== undefined && (obj.result = $c99ddde25849173f$var$responseResultTypeToJSON(message.result));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgTimeoutResponse);
        if (object.result !== undefined && object.result !== null) message.result = object.result;
        else message.result = 0;
        return message;
    }
};
const $c99ddde25849173f$var$baseMsgTimeoutOnClose = {
    nextSequenceRecv: $c99ddde25849173f$var$long_1.default.UZERO,
    signer: ""
};
module.exports.MsgTimeoutOnClose = {
    encode (message, writer = $c99ddde25849173f$var$minimal_1.default.Writer.create()) {
        if (message.packet !== undefined) $cKsix.Packet.encode(message.packet, writer.uint32(10).fork()).ldelim();
        if (message.proofUnreceived.length !== 0) writer.uint32(18).bytes(message.proofUnreceived);
        if (message.proofClose.length !== 0) writer.uint32(26).bytes(message.proofClose);
        if (message.proofHeight !== undefined) $yqmJM.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        if (!message.nextSequenceRecv.isZero()) writer.uint32(40).uint64(message.nextSequenceRecv);
        if (message.signer !== "") writer.uint32(50).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c99ddde25849173f$var$minimal_1.default.Reader ? input : new $c99ddde25849173f$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgTimeoutOnClose);
        message.proofUnreceived = new Uint8Array();
        message.proofClose = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.packet = $cKsix.Packet.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proofUnreceived = reader.bytes();
                    break;
                case 3:
                    message.proofClose = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = $yqmJM.Height.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.nextSequenceRecv = reader.uint64();
                    break;
                case 6:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgTimeoutOnClose);
        message.proofUnreceived = new Uint8Array();
        message.proofClose = new Uint8Array();
        if (object.packet !== undefined && object.packet !== null) message.packet = $cKsix.Packet.fromJSON(object.packet);
        else message.packet = undefined;
        if (object.proofUnreceived !== undefined && object.proofUnreceived !== null) message.proofUnreceived = $c99ddde25849173f$var$bytesFromBase64(object.proofUnreceived);
        if (object.proofClose !== undefined && object.proofClose !== null) message.proofClose = $c99ddde25849173f$var$bytesFromBase64(object.proofClose);
        if (object.proofHeight !== undefined && object.proofHeight !== null) message.proofHeight = $yqmJM.Height.fromJSON(object.proofHeight);
        else message.proofHeight = undefined;
        if (object.nextSequenceRecv !== undefined && object.nextSequenceRecv !== null) message.nextSequenceRecv = $c99ddde25849173f$var$long_1.default.fromString(object.nextSequenceRecv);
        else message.nextSequenceRecv = $c99ddde25849173f$var$long_1.default.UZERO;
        if (object.signer !== undefined && object.signer !== null) message.signer = String(object.signer);
        else message.signer = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.packet !== undefined && (obj.packet = message.packet ? $cKsix.Packet.toJSON(message.packet) : undefined);
        message.proofUnreceived !== undefined && (obj.proofUnreceived = $c99ddde25849173f$var$base64FromBytes(message.proofUnreceived !== undefined ? message.proofUnreceived : new Uint8Array()));
        message.proofClose !== undefined && (obj.proofClose = $c99ddde25849173f$var$base64FromBytes(message.proofClose !== undefined ? message.proofClose : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $yqmJM.Height.toJSON(message.proofHeight) : undefined);
        message.nextSequenceRecv !== undefined && (obj.nextSequenceRecv = (message.nextSequenceRecv || $c99ddde25849173f$var$long_1.default.UZERO).toString());
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgTimeoutOnClose);
        if (object.packet !== undefined && object.packet !== null) message.packet = $cKsix.Packet.fromPartial(object.packet);
        else message.packet = undefined;
        if (object.proofUnreceived !== undefined && object.proofUnreceived !== null) message.proofUnreceived = object.proofUnreceived;
        else message.proofUnreceived = new Uint8Array();
        if (object.proofClose !== undefined && object.proofClose !== null) message.proofClose = object.proofClose;
        else message.proofClose = new Uint8Array();
        if (object.proofHeight !== undefined && object.proofHeight !== null) message.proofHeight = $yqmJM.Height.fromPartial(object.proofHeight);
        else message.proofHeight = undefined;
        if (object.nextSequenceRecv !== undefined && object.nextSequenceRecv !== null) message.nextSequenceRecv = object.nextSequenceRecv;
        else message.nextSequenceRecv = $c99ddde25849173f$var$long_1.default.UZERO;
        if (object.signer !== undefined && object.signer !== null) message.signer = object.signer;
        else message.signer = "";
        return message;
    }
};
const $c99ddde25849173f$var$baseMsgTimeoutOnCloseResponse = {
    result: 0
};
module.exports.MsgTimeoutOnCloseResponse = {
    encode (message, writer = $c99ddde25849173f$var$minimal_1.default.Writer.create()) {
        if (message.result !== 0) writer.uint32(8).int32(message.result);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c99ddde25849173f$var$minimal_1.default.Reader ? input : new $c99ddde25849173f$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgTimeoutOnCloseResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.result = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgTimeoutOnCloseResponse);
        if (object.result !== undefined && object.result !== null) message.result = $c99ddde25849173f$var$responseResultTypeFromJSON(object.result);
        else message.result = 0;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.result !== undefined && (obj.result = $c99ddde25849173f$var$responseResultTypeToJSON(message.result));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgTimeoutOnCloseResponse);
        if (object.result !== undefined && object.result !== null) message.result = object.result;
        else message.result = 0;
        return message;
    }
};
const $c99ddde25849173f$var$baseMsgAcknowledgement = {
    signer: ""
};
module.exports.MsgAcknowledgement = {
    encode (message, writer = $c99ddde25849173f$var$minimal_1.default.Writer.create()) {
        if (message.packet !== undefined) $cKsix.Packet.encode(message.packet, writer.uint32(10).fork()).ldelim();
        if (message.acknowledgement.length !== 0) writer.uint32(18).bytes(message.acknowledgement);
        if (message.proofAcked.length !== 0) writer.uint32(26).bytes(message.proofAcked);
        if (message.proofHeight !== undefined) $yqmJM.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        if (message.signer !== "") writer.uint32(42).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c99ddde25849173f$var$minimal_1.default.Reader ? input : new $c99ddde25849173f$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgAcknowledgement);
        message.acknowledgement = new Uint8Array();
        message.proofAcked = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.packet = $cKsix.Packet.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.acknowledgement = reader.bytes();
                    break;
                case 3:
                    message.proofAcked = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = $yqmJM.Height.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgAcknowledgement);
        message.acknowledgement = new Uint8Array();
        message.proofAcked = new Uint8Array();
        if (object.packet !== undefined && object.packet !== null) message.packet = $cKsix.Packet.fromJSON(object.packet);
        else message.packet = undefined;
        if (object.acknowledgement !== undefined && object.acknowledgement !== null) message.acknowledgement = $c99ddde25849173f$var$bytesFromBase64(object.acknowledgement);
        if (object.proofAcked !== undefined && object.proofAcked !== null) message.proofAcked = $c99ddde25849173f$var$bytesFromBase64(object.proofAcked);
        if (object.proofHeight !== undefined && object.proofHeight !== null) message.proofHeight = $yqmJM.Height.fromJSON(object.proofHeight);
        else message.proofHeight = undefined;
        if (object.signer !== undefined && object.signer !== null) message.signer = String(object.signer);
        else message.signer = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.packet !== undefined && (obj.packet = message.packet ? $cKsix.Packet.toJSON(message.packet) : undefined);
        message.acknowledgement !== undefined && (obj.acknowledgement = $c99ddde25849173f$var$base64FromBytes(message.acknowledgement !== undefined ? message.acknowledgement : new Uint8Array()));
        message.proofAcked !== undefined && (obj.proofAcked = $c99ddde25849173f$var$base64FromBytes(message.proofAcked !== undefined ? message.proofAcked : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $yqmJM.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgAcknowledgement);
        if (object.packet !== undefined && object.packet !== null) message.packet = $cKsix.Packet.fromPartial(object.packet);
        else message.packet = undefined;
        if (object.acknowledgement !== undefined && object.acknowledgement !== null) message.acknowledgement = object.acknowledgement;
        else message.acknowledgement = new Uint8Array();
        if (object.proofAcked !== undefined && object.proofAcked !== null) message.proofAcked = object.proofAcked;
        else message.proofAcked = new Uint8Array();
        if (object.proofHeight !== undefined && object.proofHeight !== null) message.proofHeight = $yqmJM.Height.fromPartial(object.proofHeight);
        else message.proofHeight = undefined;
        if (object.signer !== undefined && object.signer !== null) message.signer = object.signer;
        else message.signer = "";
        return message;
    }
};
const $c99ddde25849173f$var$baseMsgAcknowledgementResponse = {
    result: 0
};
module.exports.MsgAcknowledgementResponse = {
    encode (message, writer = $c99ddde25849173f$var$minimal_1.default.Writer.create()) {
        if (message.result !== 0) writer.uint32(8).int32(message.result);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c99ddde25849173f$var$minimal_1.default.Reader ? input : new $c99ddde25849173f$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgAcknowledgementResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.result = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgAcknowledgementResponse);
        if (object.result !== undefined && object.result !== null) message.result = $c99ddde25849173f$var$responseResultTypeFromJSON(object.result);
        else message.result = 0;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.result !== undefined && (obj.result = $c99ddde25849173f$var$responseResultTypeToJSON(message.result));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $c99ddde25849173f$var$baseMsgAcknowledgementResponse);
        if (object.result !== undefined && object.result !== null) message.result = object.result;
        else message.result = 0;
        return message;
    }
};
class $c99ddde25849173f$var$MsgClientImpl {
    ChannelOpenInit(request, metadata) {
        return this.rpc.unary(module.exports.MsgChannelOpenInitDesc, module.exports.MsgChannelOpenInit.fromPartial(request), metadata);
    }
    ChannelOpenTry(request, metadata) {
        return this.rpc.unary(module.exports.MsgChannelOpenTryDesc, module.exports.MsgChannelOpenTry.fromPartial(request), metadata);
    }
    ChannelOpenAck(request, metadata) {
        return this.rpc.unary(module.exports.MsgChannelOpenAckDesc, module.exports.MsgChannelOpenAck.fromPartial(request), metadata);
    }
    ChannelOpenConfirm(request, metadata) {
        return this.rpc.unary(module.exports.MsgChannelOpenConfirmDesc, module.exports.MsgChannelOpenConfirm.fromPartial(request), metadata);
    }
    ChannelCloseInit(request, metadata) {
        return this.rpc.unary(module.exports.MsgChannelCloseInitDesc, module.exports.MsgChannelCloseInit.fromPartial(request), metadata);
    }
    ChannelCloseConfirm(request, metadata) {
        return this.rpc.unary(module.exports.MsgChannelCloseConfirmDesc, module.exports.MsgChannelCloseConfirm.fromPartial(request), metadata);
    }
    RecvPacket(request, metadata) {
        return this.rpc.unary(module.exports.MsgRecvPacketDesc, module.exports.MsgRecvPacket.fromPartial(request), metadata);
    }
    Timeout(request, metadata) {
        return this.rpc.unary(module.exports.MsgTimeoutDesc, module.exports.MsgTimeout.fromPartial(request), metadata);
    }
    TimeoutOnClose(request, metadata) {
        return this.rpc.unary(module.exports.MsgTimeoutOnCloseDesc, module.exports.MsgTimeoutOnClose.fromPartial(request), metadata);
    }
    Acknowledgement(request, metadata) {
        return this.rpc.unary(module.exports.MsgAcknowledgementDesc, module.exports.MsgAcknowledgement.fromPartial(request), metadata);
    }
    constructor(rpc){
        this.rpc = rpc;
        this.ChannelOpenInit = this.ChannelOpenInit.bind(this);
        this.ChannelOpenTry = this.ChannelOpenTry.bind(this);
        this.ChannelOpenAck = this.ChannelOpenAck.bind(this);
        this.ChannelOpenConfirm = this.ChannelOpenConfirm.bind(this);
        this.ChannelCloseInit = this.ChannelCloseInit.bind(this);
        this.ChannelCloseConfirm = this.ChannelCloseConfirm.bind(this);
        this.RecvPacket = this.RecvPacket.bind(this);
        this.Timeout = this.Timeout.bind(this);
        this.TimeoutOnClose = this.TimeoutOnClose.bind(this);
        this.Acknowledgement = this.Acknowledgement.bind(this);
    }
}
module.exports.MsgClientImpl = $c99ddde25849173f$var$MsgClientImpl;
module.exports.MsgDesc = {
    serviceName: "ibc.core.channel.v1.Msg"
};
module.exports.MsgChannelOpenInitDesc = {
    methodName: "ChannelOpenInit",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgChannelOpenInit.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgChannelOpenInitResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.MsgChannelOpenTryDesc = {
    methodName: "ChannelOpenTry",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgChannelOpenTry.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgChannelOpenTryResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.MsgChannelOpenAckDesc = {
    methodName: "ChannelOpenAck",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgChannelOpenAck.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgChannelOpenAckResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.MsgChannelOpenConfirmDesc = {
    methodName: "ChannelOpenConfirm",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgChannelOpenConfirm.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgChannelOpenConfirmResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.MsgChannelCloseInitDesc = {
    methodName: "ChannelCloseInit",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgChannelCloseInit.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgChannelCloseInitResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.MsgChannelCloseConfirmDesc = {
    methodName: "ChannelCloseConfirm",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgChannelCloseConfirm.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgChannelCloseConfirmResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.MsgRecvPacketDesc = {
    methodName: "RecvPacket",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgRecvPacket.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgRecvPacketResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.MsgTimeoutDesc = {
    methodName: "Timeout",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgTimeout.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgTimeoutResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.MsgTimeoutOnCloseDesc = {
    methodName: "TimeoutOnClose",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgTimeoutOnClose.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgTimeoutOnCloseResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.MsgAcknowledgementDesc = {
    methodName: "Acknowledgement",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgAcknowledgement.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgAcknowledgementResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
class $c99ddde25849173f$var$GrpcWebImpl {
    unary(methodDesc, _request, metadata) {
        var _a;
        const request = Object.assign(Object.assign({}, _request), methodDesc.requestType);
        const maybeCombinedMetadata = metadata && this.options.metadata ? new $1pqjL.BrowserHeaders(Object.assign(Object.assign({}, (_a = this.options) === null || _a === void 0 ? void 0 : _a.metadata.headersMap), metadata === null || metadata === void 0 ? void 0 : metadata.headersMap)) : metadata || this.options.metadata;
        return new Promise((resolve, reject)=>{
            $jXVni.grpc.unary(methodDesc, {
                request: request,
                host: this.host,
                metadata: maybeCombinedMetadata,
                transport: this.options.transport,
                debug: this.options.debug,
                onEnd: function(response) {
                    if (response.status === $jXVni.grpc.Code.OK) resolve(response.message);
                    else {
                        const err = new Error(response.statusMessage);
                        err.code = response.status;
                        err.metadata = response.trailers;
                        reject(err);
                    }
                }
            });
        });
    }
    constructor(host, options){
        this.host = host;
        this.options = options;
    }
}
module.exports.GrpcWebImpl = $c99ddde25849173f$var$GrpcWebImpl;
var $c99ddde25849173f$var$globalThis = (()=>{
    if (typeof $c99ddde25849173f$var$globalThis !== "undefined") return $c99ddde25849173f$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $c99ddde25849173f$var$atob = $c99ddde25849173f$var$globalThis.atob || ((b64)=>$c99ddde25849173f$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $c99ddde25849173f$var$bytesFromBase64(b64) {
    const bin = $c99ddde25849173f$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $c99ddde25849173f$var$btoa = $c99ddde25849173f$var$globalThis.btoa || ((bin)=>$c99ddde25849173f$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $c99ddde25849173f$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $c99ddde25849173f$var$btoa(bin.join(""));
}
if ($c99ddde25849173f$var$minimal_1.default.util.Long !== $c99ddde25849173f$var$long_1.default) {
    $c99ddde25849173f$var$minimal_1.default.util.Long = $c99ddde25849173f$var$long_1.default;
    $c99ddde25849173f$var$minimal_1.default.configure();
}

});


parcelRegister("65TVN", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $46fe987a89b62f14$require$Buffer = $gzLuY.Buffer;
"use strict";
var $46fe987a89b62f14$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgChannelOpenTry = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $2JCWf = parcelRequire("2JCWf");

var $cz9KI = parcelRequire("cz9KI");

var $hjcrP = parcelRequire("hjcrP");
/**
 * MsgChannelOpenTry defines a msg sent by a Relayer to try to open a channel on Chain B
 */ var $46fe987a89b62f14$var$MsgChannelOpenTry = /** @class */ function(_super) {
    $46fe987a89b62f14$var$__extends(MsgChannelOpenTry, _super);
    /**
     * @param port_id identifier of the port to use
     * @param previous_channel_id
     * @param channel channel info
     * @param counterparty_version
     * @param proof_init
     * @param proof_height
     * @param signer signer address
     */ function MsgChannelOpenTry(port_id, previous_channel_id, channel, counterparty_version, proof_init, proof_height, signer) {
        var _this = _super.call(this) || this;
        _this.port_id = port_id;
        _this.previous_channel_id = previous_channel_id;
        _this.channel = channel;
        _this.counterparty_version = counterparty_version;
        _this.proof_init = proof_init;
        _this.proof_height = proof_height;
        _this.signer = signer;
        return _this;
    }
    MsgChannelOpenTry.fromAmino = function(_, isClassic) {
        _;
        isClassic;
        throw new Error("Amino not supported");
    };
    MsgChannelOpenTry.prototype.toAmino = function(_) {
        _;
        throw new Error("Amino not supported");
    };
    MsgChannelOpenTry.fromData = function(data, _) {
        _;
        var port_id = data.port_id, previous_channel_id = data.previous_channel_id, channel = data.channel, counterparty_version = data.counterparty_version, proof_init = data.proof_init, proof_height = data.proof_height, signer = data.signer;
        return new MsgChannelOpenTry(port_id, previous_channel_id, channel ? $2JCWf.Channel.fromData(channel) : undefined, counterparty_version, proof_init, proof_height ? $cz9KI.Height.fromData(proof_height) : undefined, signer);
    };
    MsgChannelOpenTry.prototype.toData = function(_) {
        _;
        var _a = this, port_id = _a.port_id, previous_channel_id = _a.previous_channel_id, channel = _a.channel, counterparty_version = _a.counterparty_version, proof_init = _a.proof_init, proof_height = _a.proof_height, signer = _a.signer;
        return {
            "@type": "/ibc.core.channel.v1.MsgChannelOpenTry",
            port_id: port_id,
            previous_channel_id: previous_channel_id,
            channel: channel ? channel.toData() : undefined,
            counterparty_version: counterparty_version,
            proof_init: proof_init,
            proof_height: proof_height ? proof_height.toData() : undefined,
            signer: signer
        };
    };
    MsgChannelOpenTry.fromProto = function(proto, _) {
        _;
        return new MsgChannelOpenTry(proto.portId, proto.previousChannelId, proto.channel ? $2JCWf.Channel.fromProto(proto.channel) : undefined, proto.counterpartyVersion, $46fe987a89b62f14$require$Buffer.from(proto.proofInit).toString("base64"), proto.proofHeight ? $cz9KI.Height.fromProto(proto.proofHeight) : undefined, proto.signer);
    };
    MsgChannelOpenTry.prototype.toProto = function(_) {
        _;
        var _a = this, port_id = _a.port_id, previous_channel_id = _a.previous_channel_id, channel = _a.channel, counterparty_version = _a.counterparty_version, proof_init = _a.proof_init, proof_height = _a.proof_height, signer = _a.signer;
        return $hjcrP.MsgChannelOpenTry.fromPartial({
            portId: port_id,
            previousChannelId: previous_channel_id,
            channel: channel ? channel.toProto() : undefined,
            counterpartyVersion: counterparty_version,
            proofInit: $46fe987a89b62f14$require$Buffer.from(proof_init, "base64"),
            proofHeight: proof_height ? proof_height.toProto() : undefined,
            signer: signer
        });
    };
    MsgChannelOpenTry.prototype.packAny = function(_) {
        _;
        return $c5FxR.Any.fromPartial({
            typeUrl: "/ibc.core.channel.v1.MsgChannelOpenTry",
            value: $hjcrP.MsgChannelOpenTry.encode(this.toProto()).finish()
        });
    };
    MsgChannelOpenTry.unpackAny = function(msgAny, _) {
        _;
        return MsgChannelOpenTry.fromProto($hjcrP.MsgChannelOpenTry.decode(msgAny.value));
    };
    return MsgChannelOpenTry;
}($26Eqx.JSONSerializable);
module.exports.MsgChannelOpenTry = $46fe987a89b62f14$var$MsgChannelOpenTry;

});

parcelRegister("3T6en", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $2d4b577673be6b15$require$Buffer = $gzLuY.Buffer;
"use strict";
var $2d4b577673be6b15$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgChannelOpenConfirm = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $cz9KI = parcelRequire("cz9KI");

var $hjcrP = parcelRequire("hjcrP");
/**
 *  MsgChannelOpenConfirm defines a msg sent by a Relayer to Chain B to acknowledge the change of channel state to OPEN on Chain A.
 */ var $2d4b577673be6b15$var$MsgChannelOpenConfirm = /** @class */ function(_super) {
    $2d4b577673be6b15$var$__extends(MsgChannelOpenConfirm, _super);
    /**
     * @param port_id identifier of the port to use
     * @param channel_id
     * @param proof_ack
     * @param proof_height
     * @param signer signer address
     */ function MsgChannelOpenConfirm(port_id, channel_id, proof_ack, proof_height, signer) {
        var _this = _super.call(this) || this;
        _this.port_id = port_id;
        _this.channel_id = channel_id;
        _this.proof_ack = proof_ack;
        _this.proof_height = proof_height;
        _this.signer = signer;
        return _this;
    }
    MsgChannelOpenConfirm.fromAmino = function(_, isClassic) {
        _;
        isClassic;
        throw new Error("Amino not supported");
    };
    MsgChannelOpenConfirm.prototype.toAmino = function(_) {
        _;
        throw new Error("Amino not supported");
    };
    MsgChannelOpenConfirm.fromData = function(data, _) {
        _;
        var port_id = data.port_id, channel_id = data.channel_id, proof_ack = data.proof_ack, proof_height = data.proof_height, signer = data.signer;
        return new MsgChannelOpenConfirm(port_id, channel_id, proof_ack, proof_height ? $cz9KI.Height.fromData(proof_height) : undefined, signer);
    };
    MsgChannelOpenConfirm.prototype.toData = function(_) {
        _;
        var _a = this, port_id = _a.port_id, channel_id = _a.channel_id, proof_ack = _a.proof_ack, proof_height = _a.proof_height, signer = _a.signer;
        return {
            "@type": "/ibc.core.channel.v1.MsgChannelOpenConfirm",
            port_id: port_id,
            channel_id: channel_id,
            proof_ack: proof_ack,
            proof_height: proof_height ? proof_height.toData() : undefined,
            signer: signer
        };
    };
    MsgChannelOpenConfirm.fromProto = function(proto, _) {
        _;
        return new MsgChannelOpenConfirm(proto.portId, proto.channelId, $2d4b577673be6b15$require$Buffer.from(proto.proofAck).toString("base64"), proto.proofHeight ? $cz9KI.Height.fromProto(proto.proofHeight) : undefined, proto.signer);
    };
    MsgChannelOpenConfirm.prototype.toProto = function(_) {
        _;
        var _a = this, port_id = _a.port_id, channel_id = _a.channel_id, proof_ack = _a.proof_ack, proof_height = _a.proof_height, signer = _a.signer;
        return $hjcrP.MsgChannelOpenConfirm.fromPartial({
            portId: port_id,
            channelId: channel_id,
            proofAck: $2d4b577673be6b15$require$Buffer.from(proof_ack, "base64"),
            proofHeight: proof_height ? proof_height.toProto() : undefined,
            signer: signer
        });
    };
    MsgChannelOpenConfirm.prototype.packAny = function(_) {
        _;
        return $c5FxR.Any.fromPartial({
            typeUrl: "/ibc.core.channel.v1.MsgChannelOpenConfirm",
            value: $hjcrP.MsgChannelOpenConfirm.encode(this.toProto()).finish()
        });
    };
    MsgChannelOpenConfirm.unpackAny = function(msgAny, _) {
        _;
        return MsgChannelOpenConfirm.fromProto($hjcrP.MsgChannelOpenConfirm.decode(msgAny.value));
    };
    return MsgChannelOpenConfirm;
}($26Eqx.JSONSerializable);
module.exports.MsgChannelOpenConfirm = $2d4b577673be6b15$var$MsgChannelOpenConfirm;

});

parcelRegister("cLeDn", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $94a539dfc1d3eccc$require$Buffer = $gzLuY.Buffer;
"use strict";
var $94a539dfc1d3eccc$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgChannelOpenAck = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $cz9KI = parcelRequire("cz9KI");

var $hjcrP = parcelRequire("hjcrP");
/**
 * MsgChannelOpenAck defines a msg sent by a Relayer to Chain A to acknowledge the change of channel state to TRYOPEN on Chain B.
 */ var $94a539dfc1d3eccc$var$MsgChannelOpenAck = /** @class */ function(_super) {
    $94a539dfc1d3eccc$var$__extends(MsgChannelOpenAck, _super);
    /**
     * @param port_id identifier of the port to use
     * @param channel_id
     * @param counterparty_channel_id
     * @param counterparty_version
     * @param proof_try
     * @param proof_height
     * @param signer signer address
     */ function MsgChannelOpenAck(port_id, channel_id, counterparty_channel_id, counterparty_version, proof_try, proof_height, signer) {
        var _this = _super.call(this) || this;
        _this.port_id = port_id;
        _this.channel_id = channel_id;
        _this.counterparty_channel_id = counterparty_channel_id;
        _this.counterparty_version = counterparty_version;
        _this.proof_try = proof_try;
        _this.proof_height = proof_height;
        _this.signer = signer;
        return _this;
    }
    MsgChannelOpenAck.fromAmino = function(_, isClassic) {
        _;
        isClassic;
        throw new Error("Amino not supported");
    };
    MsgChannelOpenAck.prototype.toAmino = function(_) {
        _;
        throw new Error("Amino not supported");
    };
    MsgChannelOpenAck.fromData = function(data, _) {
        _;
        var port_id = data.port_id, channel_id = data.channel_id, counterparty_channel_id = data.counterparty_channel_id, counterparty_version = data.counterparty_version, proof_try = data.proof_try, proof_height = data.proof_height, signer = data.signer;
        return new MsgChannelOpenAck(port_id, channel_id, counterparty_channel_id, counterparty_version, proof_try, proof_height ? $cz9KI.Height.fromData(proof_height) : undefined, signer);
    };
    MsgChannelOpenAck.prototype.toData = function(_) {
        _;
        var _a = this, port_id = _a.port_id, channel_id = _a.channel_id, counterparty_channel_id = _a.counterparty_channel_id, counterparty_version = _a.counterparty_version, proof_try = _a.proof_try, proof_height = _a.proof_height, signer = _a.signer;
        return {
            "@type": "/ibc.core.channel.v1.MsgChannelOpenAck",
            port_id: port_id,
            channel_id: channel_id,
            counterparty_channel_id: counterparty_channel_id,
            counterparty_version: counterparty_version,
            proof_try: proof_try,
            proof_height: proof_height ? proof_height.toData() : undefined,
            signer: signer
        };
    };
    MsgChannelOpenAck.fromProto = function(proto, _) {
        _;
        return new MsgChannelOpenAck(proto.portId, proto.channelId, proto.counterpartyChannelId, proto.counterpartyVersion, $94a539dfc1d3eccc$require$Buffer.from(proto.proofTry).toString("base64"), proto.proofHeight ? $cz9KI.Height.fromProto(proto.proofHeight) : undefined, proto.signer);
    };
    MsgChannelOpenAck.prototype.toProto = function(_) {
        _;
        var _a = this, port_id = _a.port_id, channel_id = _a.channel_id, counterparty_channel_id = _a.counterparty_channel_id, counterparty_version = _a.counterparty_version, proof_try = _a.proof_try, proof_height = _a.proof_height, signer = _a.signer;
        return $hjcrP.MsgChannelOpenAck.fromPartial({
            portId: port_id,
            channelId: channel_id,
            counterpartyChannelId: counterparty_channel_id,
            counterpartyVersion: counterparty_version,
            proofTry: $94a539dfc1d3eccc$require$Buffer.from(proof_try, "base64"),
            proofHeight: proof_height ? proof_height.toProto() : undefined,
            signer: signer
        });
    };
    MsgChannelOpenAck.prototype.packAny = function(_) {
        _;
        return $c5FxR.Any.fromPartial({
            typeUrl: "/ibc.core.channel.v1.MsgChannelOpenAck",
            value: $hjcrP.MsgChannelOpenAck.encode(this.toProto()).finish()
        });
    };
    MsgChannelOpenAck.unpackAny = function(msgAny, _) {
        _;
        return MsgChannelOpenAck.fromProto($hjcrP.MsgChannelOpenAck.decode(msgAny.value));
    };
    return MsgChannelOpenAck;
}($26Eqx.JSONSerializable);
module.exports.MsgChannelOpenAck = $94a539dfc1d3eccc$var$MsgChannelOpenAck;

});

parcelRegister("jSv1Y", function(module, exports) {
"use strict";
var $e78b2189d23e46df$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgChannelCloseInit = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $hjcrP = parcelRequire("hjcrP");
/**
 * MsgChannelCloseInit defines a msg sent by a Relayer to Chain A to close a channel with Chain B.
 */ var $e78b2189d23e46df$var$MsgChannelCloseInit = /** @class */ function(_super) {
    $e78b2189d23e46df$var$__extends(MsgChannelCloseInit, _super);
    /**
     * @param port_id identifier of the port to use
     * @param channel channel info
     * @param signer signer address
     */ function MsgChannelCloseInit(port_id, channel_id, signer) {
        var _this = _super.call(this) || this;
        _this.port_id = port_id;
        _this.channel_id = channel_id;
        _this.signer = signer;
        return _this;
    }
    MsgChannelCloseInit.fromAmino = function(_, isClassic) {
        _;
        isClassic;
        throw new Error("Amino not supported");
    };
    MsgChannelCloseInit.prototype.toAmino = function(_) {
        _;
        throw new Error("Amino not supported");
    };
    MsgChannelCloseInit.fromData = function(data, _) {
        _;
        var port_id = data.port_id, channel_id = data.channel_id, signer = data.signer;
        return new MsgChannelCloseInit(port_id, channel_id, signer);
    };
    MsgChannelCloseInit.prototype.toData = function(_) {
        _;
        var _a = this, port_id = _a.port_id, channel_id = _a.channel_id, signer = _a.signer;
        return {
            "@type": "/ibc.core.channel.v1.MsgChannelCloseInit",
            port_id: port_id,
            channel_id: channel_id,
            signer: signer
        };
    };
    MsgChannelCloseInit.fromProto = function(proto, _) {
        _;
        return new MsgChannelCloseInit(proto.portId, proto.channelId, proto.signer);
    };
    MsgChannelCloseInit.prototype.toProto = function(_) {
        _;
        var _a = this, port_id = _a.port_id, channel_id = _a.channel_id, signer = _a.signer;
        return $hjcrP.MsgChannelCloseInit.fromPartial({
            portId: port_id,
            channelId: channel_id,
            signer: signer
        });
    };
    MsgChannelCloseInit.prototype.packAny = function(_) {
        _;
        return $c5FxR.Any.fromPartial({
            typeUrl: "/ibc.core.channel.v1.MsgChannelCloseInit",
            value: $hjcrP.MsgChannelCloseInit.encode(this.toProto()).finish()
        });
    };
    MsgChannelCloseInit.unpackAny = function(msgAny, _) {
        _;
        return MsgChannelCloseInit.fromProto($hjcrP.MsgChannelCloseInit.decode(msgAny.value));
    };
    return MsgChannelCloseInit;
}($26Eqx.JSONSerializable);
module.exports.MsgChannelCloseInit = $e78b2189d23e46df$var$MsgChannelCloseInit;

});

parcelRegister("hcH1f", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $c864ed5c2d1161e5$require$Buffer = $gzLuY.Buffer;
"use strict";
var $c864ed5c2d1161e5$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgChannelCloseConfirm = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $cz9KI = parcelRequire("cz9KI");

var $hjcrP = parcelRequire("hjcrP");
/**
 * MsgChannelCloseConfirm defines a msg sent by a Relayer to Chain B to acknowledge the change of channel state to CLOSED on Chain A.
 */ var $c864ed5c2d1161e5$var$MsgChannelCloseConfirm = /** @class */ function(_super) {
    $c864ed5c2d1161e5$var$__extends(MsgChannelCloseConfirm, _super);
    /**
     * @param port_id identifier of the port to use
     * @param channel_id
     * @param proof_init
     * @param proof_height
     * @param signer signer address
     */ function MsgChannelCloseConfirm(port_id, channel_id, proof_init, proof_height, signer) {
        var _this = _super.call(this) || this;
        _this.port_id = port_id;
        _this.channel_id = channel_id;
        _this.proof_init = proof_init;
        _this.proof_height = proof_height;
        _this.signer = signer;
        return _this;
    }
    MsgChannelCloseConfirm.fromAmino = function(_, isClassic) {
        _;
        isClassic;
        throw new Error("Amino not supported");
    };
    MsgChannelCloseConfirm.prototype.toAmino = function(_) {
        _;
        throw new Error("Amino not supported");
    };
    MsgChannelCloseConfirm.fromData = function(data, _) {
        _;
        var port_id = data.port_id, channel_id = data.channel_id, proof_init = data.proof_init, proof_height = data.proof_height, signer = data.signer;
        return new MsgChannelCloseConfirm(port_id, channel_id, proof_init, proof_height ? $cz9KI.Height.fromData(proof_height) : undefined, signer);
    };
    MsgChannelCloseConfirm.prototype.toData = function(_) {
        _;
        var _a = this, port_id = _a.port_id, channel_id = _a.channel_id, proof_init = _a.proof_init, proof_height = _a.proof_height, signer = _a.signer;
        return {
            "@type": "/ibc.core.channel.v1.MsgChannelCloseConfirm",
            port_id: port_id,
            channel_id: channel_id,
            proof_init: proof_init,
            proof_height: proof_height ? proof_height.toData() : undefined,
            signer: signer
        };
    };
    MsgChannelCloseConfirm.fromProto = function(proto, _) {
        _;
        return new MsgChannelCloseConfirm(proto.portId, proto.channelId, $c864ed5c2d1161e5$require$Buffer.from(proto.proofInit).toString("base64"), proto.proofHeight ? $cz9KI.Height.fromProto(proto.proofHeight) : undefined, proto.signer);
    };
    MsgChannelCloseConfirm.prototype.toProto = function(_) {
        _;
        var _a = this, port_id = _a.port_id, channel_id = _a.channel_id, proof_init = _a.proof_init, proof_height = _a.proof_height, signer = _a.signer;
        return $hjcrP.MsgChannelCloseConfirm.fromPartial({
            portId: port_id,
            channelId: channel_id,
            proofInit: $c864ed5c2d1161e5$require$Buffer.from(proof_init, "base64"),
            proofHeight: proof_height ? proof_height.toProto() : undefined,
            signer: signer
        });
    };
    MsgChannelCloseConfirm.prototype.packAny = function(_) {
        _;
        return $c5FxR.Any.fromPartial({
            typeUrl: "/ibc.core.channel.v1.MsgChannelCloseConfirm",
            value: $hjcrP.MsgChannelCloseConfirm.encode(this.toProto()).finish()
        });
    };
    MsgChannelCloseConfirm.unpackAny = function(msgAny, _) {
        _;
        return MsgChannelCloseConfirm.fromProto($hjcrP.MsgChannelCloseConfirm.decode(msgAny.value));
    };
    return MsgChannelCloseConfirm;
}($26Eqx.JSONSerializable);
module.exports.MsgChannelCloseConfirm = $c864ed5c2d1161e5$var$MsgChannelCloseConfirm;

});

parcelRegister("kKAdJ", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $f1b433245e2b0362$require$Buffer = $gzLuY.Buffer;
"use strict";
var $f1b433245e2b0362$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgRecvPacket = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $cz9KI = parcelRequire("cz9KI");

var $l33HR = parcelRequire("l33HR");

var $hjcrP = parcelRequire("hjcrP");
/**
 * MsgRecvPacket receives incoming IBC packet
 */ var $f1b433245e2b0362$var$MsgRecvPacket = /** @class */ function(_super) {
    $f1b433245e2b0362$var$__extends(MsgRecvPacket, _super);
    /**
     * @param packet
     * @param proof_commitment
     * @param proof_height
     * @param signer signer address
     */ function MsgRecvPacket(packet, proof_commitment, proof_height, signer) {
        var _this = _super.call(this) || this;
        _this.packet = packet;
        _this.proof_commitment = proof_commitment;
        _this.proof_height = proof_height;
        _this.signer = signer;
        return _this;
    }
    MsgRecvPacket.fromAmino = function(_, isClassic) {
        _;
        isClassic;
        throw new Error("Amino not supported");
    };
    MsgRecvPacket.prototype.toAmino = function(_) {
        _;
        throw new Error("Amino not supported");
    };
    MsgRecvPacket.fromData = function(data, _) {
        _;
        var packet = data.packet, proof_commitment = data.proof_commitment, proof_height = data.proof_height, signer = data.signer;
        return new MsgRecvPacket(packet ? $l33HR.Packet.fromData(packet) : undefined, proof_commitment, proof_height ? $cz9KI.Height.fromData(proof_height) : undefined, signer);
    };
    MsgRecvPacket.prototype.toData = function(_) {
        _;
        var _a = this, packet = _a.packet, proof_commitment = _a.proof_commitment, proof_height = _a.proof_height, signer = _a.signer;
        return {
            "@type": "/ibc.core.channel.v1.MsgRecvPacket",
            packet: packet ? packet.toData() : undefined,
            proof_commitment: proof_commitment,
            proof_height: proof_height ? proof_height.toData() : undefined,
            signer: signer
        };
    };
    MsgRecvPacket.fromProto = function(proto, _) {
        _;
        return new MsgRecvPacket(proto.packet ? $l33HR.Packet.fromProto(proto.packet) : undefined, $f1b433245e2b0362$require$Buffer.from(proto.proofCommitment).toString("base64"), proto.proofHeight ? $cz9KI.Height.fromProto(proto.proofHeight) : undefined, proto.signer);
    };
    MsgRecvPacket.prototype.toProto = function(_) {
        _;
        var _a = this, packet = _a.packet, proof_commitment = _a.proof_commitment, proof_height = _a.proof_height, signer = _a.signer;
        return $hjcrP.MsgRecvPacket.fromPartial({
            packet: packet ? packet.toProto() : undefined,
            proofCommitment: $f1b433245e2b0362$require$Buffer.from(proof_commitment, "base64"),
            proofHeight: proof_height ? proof_height.toProto() : undefined,
            signer: signer
        });
    };
    MsgRecvPacket.prototype.packAny = function(_) {
        _;
        return $c5FxR.Any.fromPartial({
            typeUrl: "/ibc.core.channel.v1.MsgRecvPacket",
            value: $hjcrP.MsgRecvPacket.encode(this.toProto()).finish()
        });
    };
    MsgRecvPacket.unpackAny = function(msgAny, _) {
        _;
        return MsgRecvPacket.fromProto($hjcrP.MsgRecvPacket.decode(msgAny.value));
    };
    return MsgRecvPacket;
}($26Eqx.JSONSerializable);
module.exports.MsgRecvPacket = $f1b433245e2b0362$var$MsgRecvPacket;

});
parcelRegister("l33HR", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $f52cc0cb8fc56d21$require$Buffer = $gzLuY.Buffer;
"use strict";
var $f52cc0cb8fc56d21$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $f52cc0cb8fc56d21$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Packet = void 0;

var $cKsix = parcelRequire("cKsix");

var $f52cc0cb8fc56d21$var$long_1 = $f52cc0cb8fc56d21$var$__importDefault((parcelRequire("9A55m")));

var $26Eqx = parcelRequire("26Eqx");

var $cz9KI = parcelRequire("cz9KI");
/** Packet defines a type that carries data across different chains through IBC */ var $f52cc0cb8fc56d21$var$Packet = /** @class */ function(_super) {
    $f52cc0cb8fc56d21$var$__extends(Packet, _super);
    /**
     * @param port_id port on the counterparty chain which owns the other end of the channel.
     * @param channel_id channel end on the counterparty chain
     */ function Packet(sequence, source_port, source_channel, destination_port, destination_channel, data, timeout_height, timeout_timestamp) {
        var _this = _super.call(this) || this;
        _this.sequence = sequence;
        _this.source_port = source_port;
        _this.source_channel = source_channel;
        _this.destination_port = destination_port;
        _this.destination_channel = destination_channel;
        _this.data = data;
        _this.timeout_height = timeout_height;
        _this.timeout_timestamp = timeout_timestamp;
        return _this;
    }
    Packet.fromAmino = function(_data) {
        var sequence = _data.sequence, source_port = _data.source_port, source_channel = _data.source_channel, destination_port = _data.destination_port, destination_channel = _data.destination_channel, data = _data.data, timeout_height = _data.timeout_height, timeout_timestamp = _data.timeout_timestamp;
        return new Packet(sequence, source_port, source_channel, destination_port, destination_channel, data, timeout_height ? $cz9KI.Height.fromAmino(timeout_height) : undefined, timeout_timestamp);
    };
    Packet.prototype.toAmino = function() {
        var _a = this, sequence = _a.sequence, source_port = _a.source_port, source_channel = _a.source_channel, destination_port = _a.destination_port, destination_channel = _a.destination_channel, data = _a.data, timeout_height = _a.timeout_height, timeout_timestamp = _a.timeout_timestamp;
        var res = {
            sequence: sequence,
            source_port: source_port,
            source_channel: source_channel,
            destination_port: destination_port,
            destination_channel: destination_channel,
            data: data,
            timeout_height: timeout_height ? timeout_height.toAmino() : undefined,
            timeout_timestamp: timeout_timestamp
        };
        return res;
    };
    Packet.fromData = function(_data) {
        var sequence = _data.sequence, source_port = _data.source_port, source_channel = _data.source_channel, destination_port = _data.destination_port, destination_channel = _data.destination_channel, data = _data.data, timeout_height = _data.timeout_height, timeout_timestamp = _data.timeout_timestamp;
        return new Packet(sequence, source_port, source_channel, destination_port, destination_channel, data, timeout_height ? $cz9KI.Height.fromData(timeout_height) : undefined, Number.parseInt(timeout_timestamp));
    };
    Packet.prototype.toData = function() {
        var _a = this, sequence = _a.sequence, source_port = _a.source_port, source_channel = _a.source_channel, destination_port = _a.destination_port, destination_channel = _a.destination_channel, data = _a.data, timeout_height = _a.timeout_height, timeout_timestamp = _a.timeout_timestamp;
        var res = {
            sequence: sequence,
            source_port: source_port,
            source_channel: source_channel,
            destination_port: destination_port,
            destination_channel: destination_channel,
            data: data,
            timeout_height: timeout_height ? timeout_height.toData() : undefined,
            timeout_timestamp: timeout_timestamp.toFixed()
        };
        return res;
    };
    Packet.fromProto = function(proto) {
        return new Packet(proto.sequence.toNumber(), proto.sourcePort, proto.sourceChannel, proto.destinationPort, proto.destinationChannel, $f52cc0cb8fc56d21$require$Buffer.from(proto.data).toString("base64"), proto.timeoutHeight ? $cz9KI.Height.fromProto(proto.timeoutHeight) : undefined, proto.timeoutTimestamp.toNumber());
    };
    Packet.prototype.toProto = function() {
        var _a = this, sequence = _a.sequence, source_port = _a.source_port, source_channel = _a.source_channel, destination_port = _a.destination_port, destination_channel = _a.destination_channel, data = _a.data, timeout_height = _a.timeout_height, timeout_timestamp = _a.timeout_timestamp;
        return $cKsix.Packet.fromPartial({
            sequence: $f52cc0cb8fc56d21$var$long_1.default.fromNumber(sequence),
            sourcePort: source_port,
            sourceChannel: source_channel,
            destinationPort: destination_port,
            destinationChannel: destination_channel,
            data: $f52cc0cb8fc56d21$require$Buffer.from(data, "base64"),
            timeoutHeight: timeout_height ? timeout_height.toProto() : undefined,
            timeoutTimestamp: $f52cc0cb8fc56d21$var$long_1.default.fromNumber(timeout_timestamp)
        });
    };
    return Packet;
}($26Eqx.JSONSerializable);
module.exports.Packet = $f52cc0cb8fc56d21$var$Packet;

});


parcelRegister("lNVZx", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $fdfb2882dc20af27$require$Buffer = $gzLuY.Buffer;
"use strict";
var $fdfb2882dc20af27$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgAcknowledgement = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $cz9KI = parcelRequire("cz9KI");

var $l33HR = parcelRequire("l33HR");

var $hjcrP = parcelRequire("hjcrP");
/**
 * MsgAcknowledgement receives incoming IBC acknowledgement
 */ var $fdfb2882dc20af27$var$MsgAcknowledgement = /** @class */ function(_super) {
    $fdfb2882dc20af27$var$__extends(MsgAcknowledgement, _super);
    /**
     * @param packet
     * @param acknowledgement
     * @param proof_acked
     * @param proof_height
     * @param signer signer address
     */ function MsgAcknowledgement(packet, acknowledgement, proof_acked, proof_height, signer) {
        var _this = _super.call(this) || this;
        _this.packet = packet;
        _this.acknowledgement = acknowledgement;
        _this.proof_acked = proof_acked;
        _this.proof_height = proof_height;
        _this.signer = signer;
        return _this;
    }
    MsgAcknowledgement.fromAmino = function(_, isClassic) {
        _;
        isClassic;
        throw new Error("Amino not supported");
    };
    MsgAcknowledgement.prototype.toAmino = function(_) {
        _;
        throw new Error("Amino not supported");
    };
    MsgAcknowledgement.fromData = function(data, _) {
        _;
        var packet = data.packet, acknowledgement = data.acknowledgement, proof_acked = data.proof_acked, proof_height = data.proof_height, signer = data.signer;
        return new MsgAcknowledgement(packet ? $l33HR.Packet.fromData(packet) : undefined, proof_acked, acknowledgement, proof_height ? $cz9KI.Height.fromData(proof_height) : undefined, signer);
    };
    MsgAcknowledgement.prototype.toData = function(_) {
        _;
        var _a = this, packet = _a.packet, acknowledgement = _a.acknowledgement, proof_acked = _a.proof_acked, proof_height = _a.proof_height, signer = _a.signer;
        return {
            "@type": "/ibc.core.channel.v1.MsgAcknowledgement",
            packet: packet ? packet.toData() : undefined,
            acknowledgement: acknowledgement,
            proof_acked: proof_acked,
            proof_height: proof_height ? proof_height.toData() : undefined,
            signer: signer
        };
    };
    MsgAcknowledgement.fromProto = function(proto, _) {
        _;
        return new MsgAcknowledgement(proto.packet ? $l33HR.Packet.fromProto(proto.packet) : undefined, $fdfb2882dc20af27$require$Buffer.from(proto.acknowledgement).toString("base64"), $fdfb2882dc20af27$require$Buffer.from(proto.proofAcked).toString("base64"), proto.proofHeight ? $cz9KI.Height.fromProto(proto.proofHeight) : undefined, proto.signer);
    };
    MsgAcknowledgement.prototype.toProto = function(_) {
        _;
        var _a = this, packet = _a.packet, acknowledgement = _a.acknowledgement, proof_acked = _a.proof_acked, proof_height = _a.proof_height, signer = _a.signer;
        return $hjcrP.MsgAcknowledgement.fromPartial({
            packet: packet ? packet.toProto() : undefined,
            acknowledgement: $fdfb2882dc20af27$require$Buffer.from(acknowledgement, "base64"),
            proofAcked: $fdfb2882dc20af27$require$Buffer.from(proof_acked, "base64"),
            proofHeight: proof_height ? proof_height.toProto() : undefined,
            signer: signer
        });
    };
    MsgAcknowledgement.prototype.packAny = function(_) {
        _;
        return $c5FxR.Any.fromPartial({
            typeUrl: "/ibc.core.channel.v1.MsgAcknowledgement",
            value: $hjcrP.MsgAcknowledgement.encode(this.toProto()).finish()
        });
    };
    MsgAcknowledgement.unpackAny = function(msgAny, _) {
        _;
        return MsgAcknowledgement.fromProto($hjcrP.MsgAcknowledgement.decode(msgAny.value));
    };
    return MsgAcknowledgement;
}($26Eqx.JSONSerializable);
module.exports.MsgAcknowledgement = $fdfb2882dc20af27$var$MsgAcknowledgement;

});

parcelRegister("frrk3", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $b3de924fb0e8d954$require$Buffer = $gzLuY.Buffer;
"use strict";
var $b3de924fb0e8d954$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $b3de924fb0e8d954$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgTimeout = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $cz9KI = parcelRequire("cz9KI");

var $l33HR = parcelRequire("l33HR");

var $hjcrP = parcelRequire("hjcrP");

var $b3de924fb0e8d954$var$long_1 = $b3de924fb0e8d954$var$__importDefault((parcelRequire("9A55m")));
/**
 * MsgTimeout receives timed-out packet
 */ var $b3de924fb0e8d954$var$MsgTimeout = /** @class */ function(_super) {
    $b3de924fb0e8d954$var$__extends(MsgTimeout, _super);
    /**
     * @param packet
     * @param proof_unreceived
     * @param proof_height
     * @param next_seuqnce_recv
     * @param signer signer address
     */ function MsgTimeout(packet, proof_unreceived, proof_height, next_sequence_recv, signer) {
        var _this = _super.call(this) || this;
        _this.packet = packet;
        _this.proof_unreceived = proof_unreceived;
        _this.proof_height = proof_height;
        _this.next_sequence_recv = next_sequence_recv;
        _this.signer = signer;
        return _this;
    }
    MsgTimeout.fromAmino = function(_, isClassic) {
        _;
        isClassic;
        throw new Error("Amino not supported");
    };
    MsgTimeout.prototype.toAmino = function(_) {
        _;
        throw new Error("Amino not supported");
    };
    MsgTimeout.fromData = function(data, _) {
        _;
        var packet = data.packet, proof_unreceived = data.proof_unreceived, proof_height = data.proof_height, next_sequence_recv = data.next_sequence_recv, signer = data.signer;
        return new MsgTimeout(packet ? $l33HR.Packet.fromData(packet) : undefined, proof_unreceived, proof_height ? $cz9KI.Height.fromData(proof_height) : undefined, Number.parseInt(next_sequence_recv), signer);
    };
    MsgTimeout.prototype.toData = function(_) {
        _;
        var _a = this, packet = _a.packet, proof_unreceived = _a.proof_unreceived, proof_height = _a.proof_height, next_sequence_recv = _a.next_sequence_recv, signer = _a.signer;
        return {
            "@type": "/ibc.core.channel.v1.MsgTimeout",
            packet: packet ? packet.toData() : undefined,
            proof_unreceived: proof_unreceived,
            proof_height: proof_height ? proof_height.toData() : undefined,
            next_sequence_recv: next_sequence_recv.toFixed(),
            signer: signer
        };
    };
    MsgTimeout.fromProto = function(proto, _) {
        _;
        return new MsgTimeout(proto.packet ? $l33HR.Packet.fromProto(proto.packet) : undefined, $b3de924fb0e8d954$require$Buffer.from(proto.proofUnreceived).toString("base64"), proto.proofHeight ? $cz9KI.Height.fromProto(proto.proofHeight) : undefined, proto.nextSequenceRecv.toNumber(), proto.signer);
    };
    MsgTimeout.prototype.toProto = function(_) {
        _;
        var _a = this, packet = _a.packet, proof_unreceived = _a.proof_unreceived, proof_height = _a.proof_height, next_sequence_recv = _a.next_sequence_recv, signer = _a.signer;
        return $hjcrP.MsgTimeout.fromPartial({
            packet: packet ? packet.toProto() : undefined,
            proofUnreceived: $b3de924fb0e8d954$require$Buffer.from(proof_unreceived, "base64"),
            proofHeight: proof_height ? proof_height.toProto() : undefined,
            nextSequenceRecv: $b3de924fb0e8d954$var$long_1.default.fromNumber(next_sequence_recv),
            signer: signer
        });
    };
    MsgTimeout.prototype.packAny = function(_) {
        _;
        return $c5FxR.Any.fromPartial({
            typeUrl: "/ibc.core.channel.v1.MsgTimeout",
            value: $hjcrP.MsgTimeout.encode(this.toProto()).finish()
        });
    };
    MsgTimeout.unpackAny = function(msgAny, _) {
        _;
        return MsgTimeout.fromProto($hjcrP.MsgTimeout.decode(msgAny.value));
    };
    return MsgTimeout;
}($26Eqx.JSONSerializable);
module.exports.MsgTimeout = $b3de924fb0e8d954$var$MsgTimeout;

});

parcelRegister("6Hry4", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $4e0c20c55916891d$require$Buffer = $gzLuY.Buffer;
"use strict";
var $4e0c20c55916891d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $4e0c20c55916891d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgTimeoutOnClose = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $cz9KI = parcelRequire("cz9KI");

var $l33HR = parcelRequire("l33HR");

var $hjcrP = parcelRequire("hjcrP");

var $4e0c20c55916891d$var$long_1 = $4e0c20c55916891d$var$__importDefault((parcelRequire("9A55m")));
/**
 * MsgTimeoutOnClose timed-out packet upon counterparty channel closure.
 */ var $4e0c20c55916891d$var$MsgTimeoutOnClose = /** @class */ function(_super) {
    $4e0c20c55916891d$var$__extends(MsgTimeoutOnClose, _super);
    /**
     * @param packet
     * @param proof_unreceived
     * @param proof_height
     * @param proof_close
     * @param next_seuqnce_recv
     * @param signer signer address
     */ function MsgTimeoutOnClose(packet, proof_unreceived, proof_close, proof_height, next_sequence_recv, signer) {
        var _this = _super.call(this) || this;
        _this.packet = packet;
        _this.proof_unreceived = proof_unreceived;
        _this.proof_close = proof_close;
        _this.proof_height = proof_height;
        _this.next_sequence_recv = next_sequence_recv;
        _this.signer = signer;
        return _this;
    }
    MsgTimeoutOnClose.fromAmino = function(_, isClassic) {
        _;
        isClassic;
        throw new Error("Amino not supported");
    };
    MsgTimeoutOnClose.prototype.toAmino = function(_) {
        _;
        throw new Error("Amino not supported");
    };
    MsgTimeoutOnClose.fromData = function(data, _) {
        _;
        var packet = data.packet, proof_unreceived = data.proof_unreceived, proof_close = data.proof_close, proof_height = data.proof_height, next_sequence_recv = data.next_sequence_recv, signer = data.signer;
        return new MsgTimeoutOnClose(packet ? $l33HR.Packet.fromData(packet) : undefined, proof_close, proof_unreceived, proof_height ? $cz9KI.Height.fromData(proof_height) : undefined, Number.parseInt(next_sequence_recv), signer);
    };
    MsgTimeoutOnClose.prototype.toData = function(_) {
        _;
        var _a = this, packet = _a.packet, proof_unreceived = _a.proof_unreceived, proof_close = _a.proof_close, proof_height = _a.proof_height, next_sequence_recv = _a.next_sequence_recv, signer = _a.signer;
        return {
            "@type": "/ibc.core.channel.v1.MsgTimeoutOnClose",
            packet: packet ? packet.toData() : undefined,
            proof_unreceived: proof_unreceived,
            proof_close: proof_close,
            proof_height: proof_height ? proof_height.toData() : undefined,
            next_sequence_recv: next_sequence_recv.toFixed(),
            signer: signer
        };
    };
    MsgTimeoutOnClose.fromProto = function(proto, _) {
        _;
        return new MsgTimeoutOnClose(proto.packet ? $l33HR.Packet.fromProto(proto.packet) : undefined, $4e0c20c55916891d$require$Buffer.from(proto.proofUnreceived).toString("base64"), $4e0c20c55916891d$require$Buffer.from(proto.proofClose).toString("base64"), proto.proofHeight ? $cz9KI.Height.fromProto(proto.proofHeight) : undefined, proto.nextSequenceRecv.toNumber(), proto.signer);
    };
    MsgTimeoutOnClose.prototype.toProto = function(_) {
        _;
        var _a = this, packet = _a.packet, proof_unreceived = _a.proof_unreceived, proof_close = _a.proof_close, proof_height = _a.proof_height, next_sequence_recv = _a.next_sequence_recv, signer = _a.signer;
        return $hjcrP.MsgTimeoutOnClose.fromPartial({
            packet: packet ? packet.toProto() : undefined,
            proofUnreceived: $4e0c20c55916891d$require$Buffer.from(proof_unreceived, "base64"),
            proofClose: $4e0c20c55916891d$require$Buffer.from(proof_close, "base64"),
            proofHeight: proof_height ? proof_height.toProto() : undefined,
            nextSequenceRecv: $4e0c20c55916891d$var$long_1.default.fromNumber(next_sequence_recv),
            signer: signer
        });
    };
    MsgTimeoutOnClose.prototype.packAny = function(_) {
        _;
        return $c5FxR.Any.fromPartial({
            typeUrl: "/ibc.core.channel.v1.MsgTimeoutOnClose",
            value: $hjcrP.MsgTimeoutOnClose.encode(this.toProto()).finish()
        });
    };
    MsgTimeoutOnClose.unpackAny = function(msgAny, _) {
        _;
        return MsgTimeoutOnClose.fromProto($hjcrP.MsgTimeoutOnClose.decode(msgAny.value));
    };
    return MsgTimeoutOnClose;
}($26Eqx.JSONSerializable);
module.exports.MsgTimeoutOnClose = $4e0c20c55916891d$var$MsgTimeoutOnClose;

});


parcelRegister("22QhG", function(module, exports) {
"use strict";
var $17d453401c0bd664$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $17d453401c0bd664$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $17d453401c0bd664$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$17d453401c0bd664$var$__exportStar((parcelRequire("iuerq")), module.exports);

});
parcelRegister("iuerq", function(module, exports) {
"use strict";
var $d7563b1c284409dd$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgVerifyInvariant = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $c5FxR = parcelRequire("c5FxR");

var $1eh3Y = parcelRequire("1eh3Y");
/**
 * MsgVerifyInvariant represents a message to verify a particular invariance.
 */ var $d7563b1c284409dd$var$MsgVerifyInvariant = /** @class */ function(_super) {
    $d7563b1c284409dd$var$__extends(MsgVerifyInvariant, _super);
    /**
     * @param sender sender's address
     * @param invariantModuleName module name to verify invariant
     * @param invariantRoute route to verify
     */ function MsgVerifyInvariant(sender, invariantModuleName, invariantRoute) {
        var _this = _super.call(this) || this;
        _this.sender = sender;
        _this.invariantModuleName = invariantModuleName;
        _this.invariantRoute = invariantRoute;
        return _this;
    }
    MsgVerifyInvariant.fromAmino = function(data, _) {
        _;
        var _a = data.value, sender = _a.sender, invariantModuleName = _a.invariantModuleName, invariantRoute = _a.invariantRoute;
        return new MsgVerifyInvariant(sender, invariantModuleName, invariantRoute);
    };
    MsgVerifyInvariant.prototype.toAmino = function(_) {
        _;
        throw new Error("MsgVerifyInvarant is not allowed to send");
    };
    MsgVerifyInvariant.fromData = function(data, _) {
        _;
        var sender = data.sender, invariantModuleName = data.invariantModuleName, invariantRoute = data.invariantRoute;
        return new MsgVerifyInvariant(sender, invariantModuleName, invariantRoute);
    };
    MsgVerifyInvariant.prototype.toData = function(_) {
        _;
        var _a = this, sender = _a.sender, invariantModuleName = _a.invariantModuleName, invariantRoute = _a.invariantRoute;
        return {
            "@type": "/cosmos.crisis.v1beta1.MsgVerifyInvariant",
            sender: sender,
            invariantModuleName: invariantModuleName,
            invariantRoute: invariantRoute
        };
    };
    MsgVerifyInvariant.fromProto = function(proto, _) {
        _;
        return new MsgVerifyInvariant(proto.sender, proto.invariantModuleName, proto.invariantRoute);
    };
    MsgVerifyInvariant.prototype.toProto = function(_) {
        _;
        throw new Error("MsgVerifyInvarant is not allowed to send");
    };
    MsgVerifyInvariant.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmos.crisis.v1beta1.MsgVerifyInvariant",
            value: $1eh3Y.MsgVerifyInvariant.encode(this.toProto(isClassic)).finish()
        });
    };
    MsgVerifyInvariant.unpackAny = function(msgAny, isClassic) {
        return MsgVerifyInvariant.fromProto($1eh3Y.MsgVerifyInvariant.decode(msgAny.value), isClassic);
    };
    return MsgVerifyInvariant;
}($26Eqx.JSONSerializable);
module.exports.MsgVerifyInvariant = $d7563b1c284409dd$var$MsgVerifyInvariant;

});
parcelRegister("1eh3Y", function(module, exports) {
"use strict";
var $0e5455a159ba7ca9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GrpcWebImpl = module.exports.MsgVerifyInvariantDesc = module.exports.MsgDesc = module.exports.MsgClientImpl = module.exports.MsgVerifyInvariantResponse = module.exports.MsgVerifyInvariant = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $0e5455a159ba7ca9$var$long_1 = $0e5455a159ba7ca9$var$__importDefault((parcelRequire("9A55m")));

var $jXVni = parcelRequire("jXVni");

const $0e5455a159ba7ca9$var$minimal_1 = $0e5455a159ba7ca9$var$__importDefault((parcelRequire("i2pIU")));

var $1pqjL = parcelRequire("1pqjL");
module.exports.protobufPackage = "cosmos.crisis.v1beta1";
const $0e5455a159ba7ca9$var$baseMsgVerifyInvariant = {
    sender: "",
    invariantModuleName: "",
    invariantRoute: ""
};
module.exports.MsgVerifyInvariant = {
    encode (message, writer = $0e5455a159ba7ca9$var$minimal_1.default.Writer.create()) {
        if (message.sender !== "") writer.uint32(10).string(message.sender);
        if (message.invariantModuleName !== "") writer.uint32(18).string(message.invariantModuleName);
        if (message.invariantRoute !== "") writer.uint32(26).string(message.invariantRoute);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0e5455a159ba7ca9$var$minimal_1.default.Reader ? input : new $0e5455a159ba7ca9$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $0e5455a159ba7ca9$var$baseMsgVerifyInvariant);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.invariantModuleName = reader.string();
                    break;
                case 3:
                    message.invariantRoute = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $0e5455a159ba7ca9$var$baseMsgVerifyInvariant);
        if (object.sender !== undefined && object.sender !== null) message.sender = String(object.sender);
        else message.sender = "";
        if (object.invariantModuleName !== undefined && object.invariantModuleName !== null) message.invariantModuleName = String(object.invariantModuleName);
        else message.invariantModuleName = "";
        if (object.invariantRoute !== undefined && object.invariantRoute !== null) message.invariantRoute = String(object.invariantRoute);
        else message.invariantRoute = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.invariantModuleName !== undefined && (obj.invariantModuleName = message.invariantModuleName);
        message.invariantRoute !== undefined && (obj.invariantRoute = message.invariantRoute);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $0e5455a159ba7ca9$var$baseMsgVerifyInvariant);
        if (object.sender !== undefined && object.sender !== null) message.sender = object.sender;
        else message.sender = "";
        if (object.invariantModuleName !== undefined && object.invariantModuleName !== null) message.invariantModuleName = object.invariantModuleName;
        else message.invariantModuleName = "";
        if (object.invariantRoute !== undefined && object.invariantRoute !== null) message.invariantRoute = object.invariantRoute;
        else message.invariantRoute = "";
        return message;
    }
};
const $0e5455a159ba7ca9$var$baseMsgVerifyInvariantResponse = {};
module.exports.MsgVerifyInvariantResponse = {
    encode (_, writer = $0e5455a159ba7ca9$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0e5455a159ba7ca9$var$minimal_1.default.Reader ? input : new $0e5455a159ba7ca9$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $0e5455a159ba7ca9$var$baseMsgVerifyInvariantResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $0e5455a159ba7ca9$var$baseMsgVerifyInvariantResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $0e5455a159ba7ca9$var$baseMsgVerifyInvariantResponse);
        return message;
    }
};
class $0e5455a159ba7ca9$var$MsgClientImpl {
    VerifyInvariant(request, metadata) {
        return this.rpc.unary(module.exports.MsgVerifyInvariantDesc, module.exports.MsgVerifyInvariant.fromPartial(request), metadata);
    }
    constructor(rpc){
        this.rpc = rpc;
        this.VerifyInvariant = this.VerifyInvariant.bind(this);
    }
}
module.exports.MsgClientImpl = $0e5455a159ba7ca9$var$MsgClientImpl;
module.exports.MsgDesc = {
    serviceName: "cosmos.crisis.v1beta1.Msg"
};
module.exports.MsgVerifyInvariantDesc = {
    methodName: "VerifyInvariant",
    service: module.exports.MsgDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.MsgVerifyInvariant.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.MsgVerifyInvariantResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
class $0e5455a159ba7ca9$var$GrpcWebImpl {
    unary(methodDesc, _request, metadata) {
        var _a;
        const request = Object.assign(Object.assign({}, _request), methodDesc.requestType);
        const maybeCombinedMetadata = metadata && this.options.metadata ? new $1pqjL.BrowserHeaders(Object.assign(Object.assign({}, (_a = this.options) === null || _a === void 0 ? void 0 : _a.metadata.headersMap), metadata === null || metadata === void 0 ? void 0 : metadata.headersMap)) : metadata || this.options.metadata;
        return new Promise((resolve, reject)=>{
            $jXVni.grpc.unary(methodDesc, {
                request: request,
                host: this.host,
                metadata: maybeCombinedMetadata,
                transport: this.options.transport,
                debug: this.options.debug,
                onEnd: function(response) {
                    if (response.status === $jXVni.grpc.Code.OK) resolve(response.message);
                    else {
                        const err = new Error(response.statusMessage);
                        err.code = response.status;
                        err.metadata = response.trailers;
                        reject(err);
                    }
                }
            });
        });
    }
    constructor(host, options){
        this.host = host;
        this.options = options;
    }
}
module.exports.GrpcWebImpl = $0e5455a159ba7ca9$var$GrpcWebImpl;
if ($0e5455a159ba7ca9$var$minimal_1.default.util.Long !== $0e5455a159ba7ca9$var$long_1.default) {
    $0e5455a159ba7ca9$var$minimal_1.default.util.Long = $0e5455a159ba7ca9$var$long_1.default;
    $0e5455a159ba7ca9$var$minimal_1.default.configure();
}

});




parcelRegister("cqRmZ", function(module, exports) {
"use strict";
var $90d14fd9a63b07a6$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $90d14fd9a63b07a6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $90d14fd9a63b07a6$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $90d14fd9a63b07a6$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $90d14fd9a63b07a6$var$__createBinding(result, mod, k);
    }
    $90d14fd9a63b07a6$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Fee = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $kYslP = parcelRequire("kYslP");

var $5iXRZ = parcelRequire("5iXRZ");

var $fSXAC = parcelRequire("fSXAC");

var $90d14fd9a63b07a6$var$Long = $90d14fd9a63b07a6$var$__importStar((parcelRequire("9A55m")));
/**
 * A transaction must include a fee, otherwise it will be rejected.
 */ var $90d14fd9a63b07a6$var$Fee = /** @class */ function(_super) {
    $90d14fd9a63b07a6$var$__extends(Fee, _super);
    /**
     * Creates a new Fee object.
     * @param gas gas limit
     * @param amount amount to be paid to validator
     */ function Fee(gas_limit, amount, payer, granter) {
        var _this = _super.call(this) || this;
        _this.gas_limit = gas_limit;
        _this.payer = payer;
        _this.granter = granter;
        _this.amount = new $kYslP.Coins(amount);
        return _this;
    }
    Fee.fromAmino = function(data) {
        var gas = data.gas, amount = data.amount;
        return new Fee(Number.parseInt(gas), $kYslP.Coins.fromAmino(amount), "", "");
    };
    Fee.prototype.toAmino = function() {
        return {
            gas: new $5iXRZ.Int(this.gas_limit).toString(),
            amount: this.amount.toAmino()
        };
    };
    Fee.fromData = function(data) {
        return new Fee(Number.parseInt(data.gas_limit), $kYslP.Coins.fromData(data.amount), data.payer, data.granter);
    };
    Fee.prototype.toData = function() {
        var _a = this, amount = _a.amount, gas_limit = _a.gas_limit, payer = _a.payer, granter = _a.granter;
        return {
            amount: amount.toData(),
            gas_limit: gas_limit.toFixed(),
            granter: granter !== null && granter !== void 0 ? granter : "",
            payer: payer !== null && payer !== void 0 ? payer : ""
        };
    };
    Fee.fromProto = function(proto) {
        return new Fee(proto.gasLimit.toNumber(), $kYslP.Coins.fromProto(proto.amount), proto.payer, proto.granter);
    };
    Fee.prototype.toProto = function() {
        var _a = this, amount = _a.amount, gas_limit = _a.gas_limit, payer = _a.payer, granter = _a.granter;
        return $fSXAC.Fee.fromPartial({
            amount: amount.toProto(),
            gasLimit: $90d14fd9a63b07a6$var$Long.fromNumber(gas_limit),
            granter: granter,
            payer: payer
        });
    };
    /**
     * Gets the minimum gas prices implied by the fee. Minimum gas prices are `fee amount / gas`.
     */ Fee.prototype.gasPrices = function() {
        return this.amount.toDecCoins().div(this.gas_limit);
    };
    return Fee;
}($26Eqx.JSONSerializable);
module.exports.Fee = $90d14fd9a63b07a6$var$Fee;

});
parcelRegister("fSXAC", function(module, exports) {
"use strict";
var $b90a1f6e7dfe0e3e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Fee = module.exports.ModeInfo_Multi = module.exports.ModeInfo_Single = module.exports.ModeInfo = module.exports.SignerInfo = module.exports.AuthInfo = module.exports.TxBody = module.exports.SignDoc = module.exports.TxRaw = module.exports.Tx = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $b90a1f6e7dfe0e3e$var$long_1 = $b90a1f6e7dfe0e3e$var$__importDefault((parcelRequire("9A55m")));

const $b90a1f6e7dfe0e3e$var$minimal_1 = $b90a1f6e7dfe0e3e$var$__importDefault((parcelRequire("i2pIU")));

var $c5FxR = parcelRequire("c5FxR");

var $cQRUh = parcelRequire("cQRUh");

var $be8is = parcelRequire("be8is");

var $lPVUQ = parcelRequire("lPVUQ");
module.exports.protobufPackage = "cosmos.tx.v1beta1";
const $b90a1f6e7dfe0e3e$var$baseTx = {};
module.exports.Tx = {
    encode (message, writer = $b90a1f6e7dfe0e3e$var$minimal_1.default.Writer.create()) {
        if (message.body !== undefined) module.exports.TxBody.encode(message.body, writer.uint32(10).fork()).ldelim();
        if (message.authInfo !== undefined) module.exports.AuthInfo.encode(message.authInfo, writer.uint32(18).fork()).ldelim();
        for (const v of message.signatures)writer.uint32(26).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b90a1f6e7dfe0e3e$var$minimal_1.default.Reader ? input : new $b90a1f6e7dfe0e3e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b90a1f6e7dfe0e3e$var$baseTx);
        message.signatures = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.body = module.exports.TxBody.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.authInfo = module.exports.AuthInfo.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signatures.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $b90a1f6e7dfe0e3e$var$baseTx);
        message.signatures = [];
        if (object.body !== undefined && object.body !== null) message.body = module.exports.TxBody.fromJSON(object.body);
        else message.body = undefined;
        if (object.authInfo !== undefined && object.authInfo !== null) message.authInfo = module.exports.AuthInfo.fromJSON(object.authInfo);
        else message.authInfo = undefined;
        if (object.signatures !== undefined && object.signatures !== null) for (const e of object.signatures)message.signatures.push($b90a1f6e7dfe0e3e$var$bytesFromBase64(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.body !== undefined && (obj.body = message.body ? module.exports.TxBody.toJSON(message.body) : undefined);
        message.authInfo !== undefined && (obj.authInfo = message.authInfo ? module.exports.AuthInfo.toJSON(message.authInfo) : undefined);
        if (message.signatures) obj.signatures = message.signatures.map((e)=>$b90a1f6e7dfe0e3e$var$base64FromBytes(e !== undefined ? e : new Uint8Array()));
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $b90a1f6e7dfe0e3e$var$baseTx);
        message.signatures = [];
        if (object.body !== undefined && object.body !== null) message.body = module.exports.TxBody.fromPartial(object.body);
        else message.body = undefined;
        if (object.authInfo !== undefined && object.authInfo !== null) message.authInfo = module.exports.AuthInfo.fromPartial(object.authInfo);
        else message.authInfo = undefined;
        if (object.signatures !== undefined && object.signatures !== null) for (const e of object.signatures)message.signatures.push(e);
        return message;
    }
};
const $b90a1f6e7dfe0e3e$var$baseTxRaw = {};
module.exports.TxRaw = {
    encode (message, writer = $b90a1f6e7dfe0e3e$var$minimal_1.default.Writer.create()) {
        if (message.bodyBytes.length !== 0) writer.uint32(10).bytes(message.bodyBytes);
        if (message.authInfoBytes.length !== 0) writer.uint32(18).bytes(message.authInfoBytes);
        for (const v of message.signatures)writer.uint32(26).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b90a1f6e7dfe0e3e$var$minimal_1.default.Reader ? input : new $b90a1f6e7dfe0e3e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b90a1f6e7dfe0e3e$var$baseTxRaw);
        message.signatures = [];
        message.bodyBytes = new Uint8Array();
        message.authInfoBytes = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bodyBytes = reader.bytes();
                    break;
                case 2:
                    message.authInfoBytes = reader.bytes();
                    break;
                case 3:
                    message.signatures.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $b90a1f6e7dfe0e3e$var$baseTxRaw);
        message.signatures = [];
        message.bodyBytes = new Uint8Array();
        message.authInfoBytes = new Uint8Array();
        if (object.bodyBytes !== undefined && object.bodyBytes !== null) message.bodyBytes = $b90a1f6e7dfe0e3e$var$bytesFromBase64(object.bodyBytes);
        if (object.authInfoBytes !== undefined && object.authInfoBytes !== null) message.authInfoBytes = $b90a1f6e7dfe0e3e$var$bytesFromBase64(object.authInfoBytes);
        if (object.signatures !== undefined && object.signatures !== null) for (const e of object.signatures)message.signatures.push($b90a1f6e7dfe0e3e$var$bytesFromBase64(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.bodyBytes !== undefined && (obj.bodyBytes = $b90a1f6e7dfe0e3e$var$base64FromBytes(message.bodyBytes !== undefined ? message.bodyBytes : new Uint8Array()));
        message.authInfoBytes !== undefined && (obj.authInfoBytes = $b90a1f6e7dfe0e3e$var$base64FromBytes(message.authInfoBytes !== undefined ? message.authInfoBytes : new Uint8Array()));
        if (message.signatures) obj.signatures = message.signatures.map((e)=>$b90a1f6e7dfe0e3e$var$base64FromBytes(e !== undefined ? e : new Uint8Array()));
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $b90a1f6e7dfe0e3e$var$baseTxRaw);
        message.signatures = [];
        if (object.bodyBytes !== undefined && object.bodyBytes !== null) message.bodyBytes = object.bodyBytes;
        else message.bodyBytes = new Uint8Array();
        if (object.authInfoBytes !== undefined && object.authInfoBytes !== null) message.authInfoBytes = object.authInfoBytes;
        else message.authInfoBytes = new Uint8Array();
        if (object.signatures !== undefined && object.signatures !== null) for (const e of object.signatures)message.signatures.push(e);
        return message;
    }
};
const $b90a1f6e7dfe0e3e$var$baseSignDoc = {
    chainId: "",
    accountNumber: $b90a1f6e7dfe0e3e$var$long_1.default.UZERO
};
module.exports.SignDoc = {
    encode (message, writer = $b90a1f6e7dfe0e3e$var$minimal_1.default.Writer.create()) {
        if (message.bodyBytes.length !== 0) writer.uint32(10).bytes(message.bodyBytes);
        if (message.authInfoBytes.length !== 0) writer.uint32(18).bytes(message.authInfoBytes);
        if (message.chainId !== "") writer.uint32(26).string(message.chainId);
        if (!message.accountNumber.isZero()) writer.uint32(32).uint64(message.accountNumber);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b90a1f6e7dfe0e3e$var$minimal_1.default.Reader ? input : new $b90a1f6e7dfe0e3e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b90a1f6e7dfe0e3e$var$baseSignDoc);
        message.bodyBytes = new Uint8Array();
        message.authInfoBytes = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bodyBytes = reader.bytes();
                    break;
                case 2:
                    message.authInfoBytes = reader.bytes();
                    break;
                case 3:
                    message.chainId = reader.string();
                    break;
                case 4:
                    message.accountNumber = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $b90a1f6e7dfe0e3e$var$baseSignDoc);
        message.bodyBytes = new Uint8Array();
        message.authInfoBytes = new Uint8Array();
        if (object.bodyBytes !== undefined && object.bodyBytes !== null) message.bodyBytes = $b90a1f6e7dfe0e3e$var$bytesFromBase64(object.bodyBytes);
        if (object.authInfoBytes !== undefined && object.authInfoBytes !== null) message.authInfoBytes = $b90a1f6e7dfe0e3e$var$bytesFromBase64(object.authInfoBytes);
        if (object.chainId !== undefined && object.chainId !== null) message.chainId = String(object.chainId);
        else message.chainId = "";
        if (object.accountNumber !== undefined && object.accountNumber !== null) message.accountNumber = $b90a1f6e7dfe0e3e$var$long_1.default.fromString(object.accountNumber);
        else message.accountNumber = $b90a1f6e7dfe0e3e$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.bodyBytes !== undefined && (obj.bodyBytes = $b90a1f6e7dfe0e3e$var$base64FromBytes(message.bodyBytes !== undefined ? message.bodyBytes : new Uint8Array()));
        message.authInfoBytes !== undefined && (obj.authInfoBytes = $b90a1f6e7dfe0e3e$var$base64FromBytes(message.authInfoBytes !== undefined ? message.authInfoBytes : new Uint8Array()));
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.accountNumber !== undefined && (obj.accountNumber = (message.accountNumber || $b90a1f6e7dfe0e3e$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $b90a1f6e7dfe0e3e$var$baseSignDoc);
        if (object.bodyBytes !== undefined && object.bodyBytes !== null) message.bodyBytes = object.bodyBytes;
        else message.bodyBytes = new Uint8Array();
        if (object.authInfoBytes !== undefined && object.authInfoBytes !== null) message.authInfoBytes = object.authInfoBytes;
        else message.authInfoBytes = new Uint8Array();
        if (object.chainId !== undefined && object.chainId !== null) message.chainId = object.chainId;
        else message.chainId = "";
        if (object.accountNumber !== undefined && object.accountNumber !== null) message.accountNumber = object.accountNumber;
        else message.accountNumber = $b90a1f6e7dfe0e3e$var$long_1.default.UZERO;
        return message;
    }
};
const $b90a1f6e7dfe0e3e$var$baseTxBody = {
    memo: "",
    timeoutHeight: $b90a1f6e7dfe0e3e$var$long_1.default.UZERO
};
module.exports.TxBody = {
    encode (message, writer = $b90a1f6e7dfe0e3e$var$minimal_1.default.Writer.create()) {
        for (const v of message.messages)$c5FxR.Any.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.memo !== "") writer.uint32(18).string(message.memo);
        if (!message.timeoutHeight.isZero()) writer.uint32(24).uint64(message.timeoutHeight);
        for (const v of message.extensionOptions)$c5FxR.Any.encode(v, writer.uint32(8186).fork()).ldelim();
        for (const v of message.nonCriticalExtensionOptions)$c5FxR.Any.encode(v, writer.uint32(16378).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b90a1f6e7dfe0e3e$var$minimal_1.default.Reader ? input : new $b90a1f6e7dfe0e3e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b90a1f6e7dfe0e3e$var$baseTxBody);
        message.messages = [];
        message.extensionOptions = [];
        message.nonCriticalExtensionOptions = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.messages.push($c5FxR.Any.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.memo = reader.string();
                    break;
                case 3:
                    message.timeoutHeight = reader.uint64();
                    break;
                case 1023:
                    message.extensionOptions.push($c5FxR.Any.decode(reader, reader.uint32()));
                    break;
                case 2047:
                    message.nonCriticalExtensionOptions.push($c5FxR.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $b90a1f6e7dfe0e3e$var$baseTxBody);
        message.messages = [];
        message.extensionOptions = [];
        message.nonCriticalExtensionOptions = [];
        if (object.messages !== undefined && object.messages !== null) for (const e of object.messages)message.messages.push($c5FxR.Any.fromJSON(e));
        if (object.memo !== undefined && object.memo !== null) message.memo = String(object.memo);
        else message.memo = "";
        if (object.timeoutHeight !== undefined && object.timeoutHeight !== null) message.timeoutHeight = $b90a1f6e7dfe0e3e$var$long_1.default.fromString(object.timeoutHeight);
        else message.timeoutHeight = $b90a1f6e7dfe0e3e$var$long_1.default.UZERO;
        if (object.extensionOptions !== undefined && object.extensionOptions !== null) for (const e of object.extensionOptions)message.extensionOptions.push($c5FxR.Any.fromJSON(e));
        if (object.nonCriticalExtensionOptions !== undefined && object.nonCriticalExtensionOptions !== null) for (const e of object.nonCriticalExtensionOptions)message.nonCriticalExtensionOptions.push($c5FxR.Any.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.messages) obj.messages = message.messages.map((e)=>e ? $c5FxR.Any.toJSON(e) : undefined);
        else obj.messages = [];
        message.memo !== undefined && (obj.memo = message.memo);
        message.timeoutHeight !== undefined && (obj.timeoutHeight = (message.timeoutHeight || $b90a1f6e7dfe0e3e$var$long_1.default.UZERO).toString());
        if (message.extensionOptions) obj.extensionOptions = message.extensionOptions.map((e)=>e ? $c5FxR.Any.toJSON(e) : undefined);
        else obj.extensionOptions = [];
        if (message.nonCriticalExtensionOptions) obj.nonCriticalExtensionOptions = message.nonCriticalExtensionOptions.map((e)=>e ? $c5FxR.Any.toJSON(e) : undefined);
        else obj.nonCriticalExtensionOptions = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $b90a1f6e7dfe0e3e$var$baseTxBody);
        message.messages = [];
        message.extensionOptions = [];
        message.nonCriticalExtensionOptions = [];
        if (object.messages !== undefined && object.messages !== null) for (const e of object.messages)message.messages.push($c5FxR.Any.fromPartial(e));
        if (object.memo !== undefined && object.memo !== null) message.memo = object.memo;
        else message.memo = "";
        if (object.timeoutHeight !== undefined && object.timeoutHeight !== null) message.timeoutHeight = object.timeoutHeight;
        else message.timeoutHeight = $b90a1f6e7dfe0e3e$var$long_1.default.UZERO;
        if (object.extensionOptions !== undefined && object.extensionOptions !== null) for (const e of object.extensionOptions)message.extensionOptions.push($c5FxR.Any.fromPartial(e));
        if (object.nonCriticalExtensionOptions !== undefined && object.nonCriticalExtensionOptions !== null) for (const e of object.nonCriticalExtensionOptions)message.nonCriticalExtensionOptions.push($c5FxR.Any.fromPartial(e));
        return message;
    }
};
const $b90a1f6e7dfe0e3e$var$baseAuthInfo = {};
module.exports.AuthInfo = {
    encode (message, writer = $b90a1f6e7dfe0e3e$var$minimal_1.default.Writer.create()) {
        for (const v of message.signerInfos)module.exports.SignerInfo.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.fee !== undefined) module.exports.Fee.encode(message.fee, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b90a1f6e7dfe0e3e$var$minimal_1.default.Reader ? input : new $b90a1f6e7dfe0e3e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b90a1f6e7dfe0e3e$var$baseAuthInfo);
        message.signerInfos = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signerInfos.push(module.exports.SignerInfo.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.fee = module.exports.Fee.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $b90a1f6e7dfe0e3e$var$baseAuthInfo);
        message.signerInfos = [];
        if (object.signerInfos !== undefined && object.signerInfos !== null) for (const e of object.signerInfos)message.signerInfos.push(module.exports.SignerInfo.fromJSON(e));
        if (object.fee !== undefined && object.fee !== null) message.fee = module.exports.Fee.fromJSON(object.fee);
        else message.fee = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.signerInfos) obj.signerInfos = message.signerInfos.map((e)=>e ? module.exports.SignerInfo.toJSON(e) : undefined);
        else obj.signerInfos = [];
        message.fee !== undefined && (obj.fee = message.fee ? module.exports.Fee.toJSON(message.fee) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $b90a1f6e7dfe0e3e$var$baseAuthInfo);
        message.signerInfos = [];
        if (object.signerInfos !== undefined && object.signerInfos !== null) for (const e of object.signerInfos)message.signerInfos.push(module.exports.SignerInfo.fromPartial(e));
        if (object.fee !== undefined && object.fee !== null) message.fee = module.exports.Fee.fromPartial(object.fee);
        else message.fee = undefined;
        return message;
    }
};
const $b90a1f6e7dfe0e3e$var$baseSignerInfo = {
    sequence: $b90a1f6e7dfe0e3e$var$long_1.default.UZERO
};
module.exports.SignerInfo = {
    encode (message, writer = $b90a1f6e7dfe0e3e$var$minimal_1.default.Writer.create()) {
        if (message.publicKey !== undefined) $c5FxR.Any.encode(message.publicKey, writer.uint32(10).fork()).ldelim();
        if (message.modeInfo !== undefined) module.exports.ModeInfo.encode(message.modeInfo, writer.uint32(18).fork()).ldelim();
        if (!message.sequence.isZero()) writer.uint32(24).uint64(message.sequence);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b90a1f6e7dfe0e3e$var$minimal_1.default.Reader ? input : new $b90a1f6e7dfe0e3e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b90a1f6e7dfe0e3e$var$baseSignerInfo);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.publicKey = $c5FxR.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.modeInfo = module.exports.ModeInfo.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $b90a1f6e7dfe0e3e$var$baseSignerInfo);
        if (object.publicKey !== undefined && object.publicKey !== null) message.publicKey = $c5FxR.Any.fromJSON(object.publicKey);
        else message.publicKey = undefined;
        if (object.modeInfo !== undefined && object.modeInfo !== null) message.modeInfo = module.exports.ModeInfo.fromJSON(object.modeInfo);
        else message.modeInfo = undefined;
        if (object.sequence !== undefined && object.sequence !== null) message.sequence = $b90a1f6e7dfe0e3e$var$long_1.default.fromString(object.sequence);
        else message.sequence = $b90a1f6e7dfe0e3e$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.publicKey !== undefined && (obj.publicKey = message.publicKey ? $c5FxR.Any.toJSON(message.publicKey) : undefined);
        message.modeInfo !== undefined && (obj.modeInfo = message.modeInfo ? module.exports.ModeInfo.toJSON(message.modeInfo) : undefined);
        message.sequence !== undefined && (obj.sequence = (message.sequence || $b90a1f6e7dfe0e3e$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $b90a1f6e7dfe0e3e$var$baseSignerInfo);
        if (object.publicKey !== undefined && object.publicKey !== null) message.publicKey = $c5FxR.Any.fromPartial(object.publicKey);
        else message.publicKey = undefined;
        if (object.modeInfo !== undefined && object.modeInfo !== null) message.modeInfo = module.exports.ModeInfo.fromPartial(object.modeInfo);
        else message.modeInfo = undefined;
        if (object.sequence !== undefined && object.sequence !== null) message.sequence = object.sequence;
        else message.sequence = $b90a1f6e7dfe0e3e$var$long_1.default.UZERO;
        return message;
    }
};
const $b90a1f6e7dfe0e3e$var$baseModeInfo = {};
module.exports.ModeInfo = {
    encode (message, writer = $b90a1f6e7dfe0e3e$var$minimal_1.default.Writer.create()) {
        if (message.single !== undefined) module.exports.ModeInfo_Single.encode(message.single, writer.uint32(10).fork()).ldelim();
        if (message.multi !== undefined) module.exports.ModeInfo_Multi.encode(message.multi, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b90a1f6e7dfe0e3e$var$minimal_1.default.Reader ? input : new $b90a1f6e7dfe0e3e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b90a1f6e7dfe0e3e$var$baseModeInfo);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.single = module.exports.ModeInfo_Single.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.multi = module.exports.ModeInfo_Multi.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $b90a1f6e7dfe0e3e$var$baseModeInfo);
        if (object.single !== undefined && object.single !== null) message.single = module.exports.ModeInfo_Single.fromJSON(object.single);
        else message.single = undefined;
        if (object.multi !== undefined && object.multi !== null) message.multi = module.exports.ModeInfo_Multi.fromJSON(object.multi);
        else message.multi = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.single !== undefined && (obj.single = message.single ? module.exports.ModeInfo_Single.toJSON(message.single) : undefined);
        message.multi !== undefined && (obj.multi = message.multi ? module.exports.ModeInfo_Multi.toJSON(message.multi) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $b90a1f6e7dfe0e3e$var$baseModeInfo);
        if (object.single !== undefined && object.single !== null) message.single = module.exports.ModeInfo_Single.fromPartial(object.single);
        else message.single = undefined;
        if (object.multi !== undefined && object.multi !== null) message.multi = module.exports.ModeInfo_Multi.fromPartial(object.multi);
        else message.multi = undefined;
        return message;
    }
};
const $b90a1f6e7dfe0e3e$var$baseModeInfo_Single = {
    mode: 0
};
module.exports.ModeInfo_Single = {
    encode (message, writer = $b90a1f6e7dfe0e3e$var$minimal_1.default.Writer.create()) {
        if (message.mode !== 0) writer.uint32(8).int32(message.mode);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b90a1f6e7dfe0e3e$var$minimal_1.default.Reader ? input : new $b90a1f6e7dfe0e3e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b90a1f6e7dfe0e3e$var$baseModeInfo_Single);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.mode = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $b90a1f6e7dfe0e3e$var$baseModeInfo_Single);
        if (object.mode !== undefined && object.mode !== null) message.mode = $cQRUh.signModeFromJSON(object.mode);
        else message.mode = 0;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.mode !== undefined && (obj.mode = $cQRUh.signModeToJSON(message.mode));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $b90a1f6e7dfe0e3e$var$baseModeInfo_Single);
        if (object.mode !== undefined && object.mode !== null) message.mode = object.mode;
        else message.mode = 0;
        return message;
    }
};
const $b90a1f6e7dfe0e3e$var$baseModeInfo_Multi = {};
module.exports.ModeInfo_Multi = {
    encode (message, writer = $b90a1f6e7dfe0e3e$var$minimal_1.default.Writer.create()) {
        if (message.bitarray !== undefined) $be8is.CompactBitArray.encode(message.bitarray, writer.uint32(10).fork()).ldelim();
        for (const v of message.modeInfos)module.exports.ModeInfo.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b90a1f6e7dfe0e3e$var$minimal_1.default.Reader ? input : new $b90a1f6e7dfe0e3e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b90a1f6e7dfe0e3e$var$baseModeInfo_Multi);
        message.modeInfos = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bitarray = $be8is.CompactBitArray.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.modeInfos.push(module.exports.ModeInfo.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $b90a1f6e7dfe0e3e$var$baseModeInfo_Multi);
        message.modeInfos = [];
        if (object.bitarray !== undefined && object.bitarray !== null) message.bitarray = $be8is.CompactBitArray.fromJSON(object.bitarray);
        else message.bitarray = undefined;
        if (object.modeInfos !== undefined && object.modeInfos !== null) for (const e of object.modeInfos)message.modeInfos.push(module.exports.ModeInfo.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.bitarray !== undefined && (obj.bitarray = message.bitarray ? $be8is.CompactBitArray.toJSON(message.bitarray) : undefined);
        if (message.modeInfos) obj.modeInfos = message.modeInfos.map((e)=>e ? module.exports.ModeInfo.toJSON(e) : undefined);
        else obj.modeInfos = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $b90a1f6e7dfe0e3e$var$baseModeInfo_Multi);
        message.modeInfos = [];
        if (object.bitarray !== undefined && object.bitarray !== null) message.bitarray = $be8is.CompactBitArray.fromPartial(object.bitarray);
        else message.bitarray = undefined;
        if (object.modeInfos !== undefined && object.modeInfos !== null) for (const e of object.modeInfos)message.modeInfos.push(module.exports.ModeInfo.fromPartial(e));
        return message;
    }
};
const $b90a1f6e7dfe0e3e$var$baseFee = {
    gasLimit: $b90a1f6e7dfe0e3e$var$long_1.default.UZERO,
    payer: "",
    granter: ""
};
module.exports.Fee = {
    encode (message, writer = $b90a1f6e7dfe0e3e$var$minimal_1.default.Writer.create()) {
        for (const v of message.amount)$lPVUQ.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (!message.gasLimit.isZero()) writer.uint32(16).uint64(message.gasLimit);
        if (message.payer !== "") writer.uint32(26).string(message.payer);
        if (message.granter !== "") writer.uint32(34).string(message.granter);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b90a1f6e7dfe0e3e$var$minimal_1.default.Reader ? input : new $b90a1f6e7dfe0e3e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b90a1f6e7dfe0e3e$var$baseFee);
        message.amount = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.amount.push($lPVUQ.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.gasLimit = reader.uint64();
                    break;
                case 3:
                    message.payer = reader.string();
                    break;
                case 4:
                    message.granter = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $b90a1f6e7dfe0e3e$var$baseFee);
        message.amount = [];
        if (object.amount !== undefined && object.amount !== null) for (const e of object.amount)message.amount.push($lPVUQ.Coin.fromJSON(e));
        if (object.gasLimit !== undefined && object.gasLimit !== null) message.gasLimit = $b90a1f6e7dfe0e3e$var$long_1.default.fromString(object.gasLimit);
        else message.gasLimit = $b90a1f6e7dfe0e3e$var$long_1.default.UZERO;
        if (object.payer !== undefined && object.payer !== null) message.payer = String(object.payer);
        else message.payer = "";
        if (object.granter !== undefined && object.granter !== null) message.granter = String(object.granter);
        else message.granter = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $lPVUQ.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        message.gasLimit !== undefined && (obj.gasLimit = (message.gasLimit || $b90a1f6e7dfe0e3e$var$long_1.default.UZERO).toString());
        message.payer !== undefined && (obj.payer = message.payer);
        message.granter !== undefined && (obj.granter = message.granter);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $b90a1f6e7dfe0e3e$var$baseFee);
        message.amount = [];
        if (object.amount !== undefined && object.amount !== null) for (const e of object.amount)message.amount.push($lPVUQ.Coin.fromPartial(e));
        if (object.gasLimit !== undefined && object.gasLimit !== null) message.gasLimit = object.gasLimit;
        else message.gasLimit = $b90a1f6e7dfe0e3e$var$long_1.default.UZERO;
        if (object.payer !== undefined && object.payer !== null) message.payer = object.payer;
        else message.payer = "";
        if (object.granter !== undefined && object.granter !== null) message.granter = object.granter;
        else message.granter = "";
        return message;
    }
};
var $b90a1f6e7dfe0e3e$var$globalThis = (()=>{
    if (typeof $b90a1f6e7dfe0e3e$var$globalThis !== "undefined") return $b90a1f6e7dfe0e3e$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $b90a1f6e7dfe0e3e$var$atob = $b90a1f6e7dfe0e3e$var$globalThis.atob || ((b64)=>$b90a1f6e7dfe0e3e$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $b90a1f6e7dfe0e3e$var$bytesFromBase64(b64) {
    const bin = $b90a1f6e7dfe0e3e$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $b90a1f6e7dfe0e3e$var$btoa = $b90a1f6e7dfe0e3e$var$globalThis.btoa || ((bin)=>$b90a1f6e7dfe0e3e$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $b90a1f6e7dfe0e3e$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $b90a1f6e7dfe0e3e$var$btoa(bin.join(""));
}
if ($b90a1f6e7dfe0e3e$var$minimal_1.default.util.Long !== $b90a1f6e7dfe0e3e$var$long_1.default) {
    $b90a1f6e7dfe0e3e$var$minimal_1.default.util.Long = $b90a1f6e7dfe0e3e$var$long_1.default;
    $b90a1f6e7dfe0e3e$var$minimal_1.default.configure();
}

});
parcelRegister("cQRUh", function(module, exports) {
"use strict";
var $95b4281a9f8c6ef3$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SignatureDescriptor_Data_Multi = module.exports.SignatureDescriptor_Data_Single = module.exports.SignatureDescriptor_Data = module.exports.SignatureDescriptor = module.exports.SignatureDescriptors = module.exports.signModeToJSON = module.exports.signModeFromJSON = module.exports.SignMode = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $95b4281a9f8c6ef3$var$long_1 = $95b4281a9f8c6ef3$var$__importDefault((parcelRequire("9A55m")));

const $95b4281a9f8c6ef3$var$minimal_1 = $95b4281a9f8c6ef3$var$__importDefault((parcelRequire("i2pIU")));

var $c5FxR = parcelRequire("c5FxR");

var $be8is = parcelRequire("be8is");
module.exports.protobufPackage = "cosmos.tx.signing.v1beta1";
/** SignMode represents a signing mode with its own security guarantees. */ var $95b4281a9f8c6ef3$var$SignMode;
(function(SignMode) {
    /**
     * SIGN_MODE_UNSPECIFIED - SIGN_MODE_UNSPECIFIED specifies an unknown signing mode and will be
     * rejected
     */ SignMode[SignMode["SIGN_MODE_UNSPECIFIED"] = 0] = "SIGN_MODE_UNSPECIFIED";
    /**
     * SIGN_MODE_DIRECT - SIGN_MODE_DIRECT specifies a signing mode which uses SignDoc and is
     * verified with raw bytes from Tx
     */ SignMode[SignMode["SIGN_MODE_DIRECT"] = 1] = "SIGN_MODE_DIRECT";
    /**
     * SIGN_MODE_TEXTUAL - SIGN_MODE_TEXTUAL is a future signing mode that will verify some
     * human-readable textual representation on top of the binary representation
     * from SIGN_MODE_DIRECT
     */ SignMode[SignMode["SIGN_MODE_TEXTUAL"] = 2] = "SIGN_MODE_TEXTUAL";
    /**
     * SIGN_MODE_LEGACY_AMINO_JSON - SIGN_MODE_LEGACY_AMINO_JSON is a backwards compatibility mode which uses
     * Amino JSON and will be removed in the future
     */ SignMode[SignMode["SIGN_MODE_LEGACY_AMINO_JSON"] = 127] = "SIGN_MODE_LEGACY_AMINO_JSON";
    /**
     * SIGN_MODE_EIP_191 - SIGN_MODE_EIP_191 specifies the sign mode for EIP 191 signing on the Cosmos
     * SDK. Ref: https://eips.ethereum.org/EIPS/eip-191
     *
     * Currently, SIGN_MODE_EIP_191 is registered as a SignMode enum variant,
     * but is not implemented on the SDK by default. To enable EIP-191, you need
     * to pass a custom `TxConfig` that has an implementation of
     * `SignModeHandler` for EIP-191. The SDK may decide to fully support
     * EIP-191 in the future.
     *
     * Since: cosmos-sdk 0.45.2
     */ SignMode[SignMode["SIGN_MODE_EIP_191"] = 191] = "SIGN_MODE_EIP_191";
    SignMode[SignMode["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($95b4281a9f8c6ef3$var$SignMode = module.exports.SignMode || (module.exports.SignMode = {}));
function $95b4281a9f8c6ef3$var$signModeFromJSON(object) {
    switch(object){
        case 0:
        case "SIGN_MODE_UNSPECIFIED":
            return $95b4281a9f8c6ef3$var$SignMode.SIGN_MODE_UNSPECIFIED;
        case 1:
        case "SIGN_MODE_DIRECT":
            return $95b4281a9f8c6ef3$var$SignMode.SIGN_MODE_DIRECT;
        case 2:
        case "SIGN_MODE_TEXTUAL":
            return $95b4281a9f8c6ef3$var$SignMode.SIGN_MODE_TEXTUAL;
        case 127:
        case "SIGN_MODE_LEGACY_AMINO_JSON":
            return $95b4281a9f8c6ef3$var$SignMode.SIGN_MODE_LEGACY_AMINO_JSON;
        case 191:
        case "SIGN_MODE_EIP_191":
            return $95b4281a9f8c6ef3$var$SignMode.SIGN_MODE_EIP_191;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $95b4281a9f8c6ef3$var$SignMode.UNRECOGNIZED;
    }
}
module.exports.signModeFromJSON = $95b4281a9f8c6ef3$var$signModeFromJSON;
function $95b4281a9f8c6ef3$var$signModeToJSON(object) {
    switch(object){
        case $95b4281a9f8c6ef3$var$SignMode.SIGN_MODE_UNSPECIFIED:
            return "SIGN_MODE_UNSPECIFIED";
        case $95b4281a9f8c6ef3$var$SignMode.SIGN_MODE_DIRECT:
            return "SIGN_MODE_DIRECT";
        case $95b4281a9f8c6ef3$var$SignMode.SIGN_MODE_TEXTUAL:
            return "SIGN_MODE_TEXTUAL";
        case $95b4281a9f8c6ef3$var$SignMode.SIGN_MODE_LEGACY_AMINO_JSON:
            return "SIGN_MODE_LEGACY_AMINO_JSON";
        case $95b4281a9f8c6ef3$var$SignMode.SIGN_MODE_EIP_191:
            return "SIGN_MODE_EIP_191";
        default:
            return "UNKNOWN";
    }
}
module.exports.signModeToJSON = $95b4281a9f8c6ef3$var$signModeToJSON;
const $95b4281a9f8c6ef3$var$baseSignatureDescriptors = {};
module.exports.SignatureDescriptors = {
    encode (message, writer = $95b4281a9f8c6ef3$var$minimal_1.default.Writer.create()) {
        for (const v of message.signatures)module.exports.SignatureDescriptor.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $95b4281a9f8c6ef3$var$minimal_1.default.Reader ? input : new $95b4281a9f8c6ef3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $95b4281a9f8c6ef3$var$baseSignatureDescriptors);
        message.signatures = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signatures.push(module.exports.SignatureDescriptor.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $95b4281a9f8c6ef3$var$baseSignatureDescriptors);
        message.signatures = [];
        if (object.signatures !== undefined && object.signatures !== null) for (const e of object.signatures)message.signatures.push(module.exports.SignatureDescriptor.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.signatures) obj.signatures = message.signatures.map((e)=>e ? module.exports.SignatureDescriptor.toJSON(e) : undefined);
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $95b4281a9f8c6ef3$var$baseSignatureDescriptors);
        message.signatures = [];
        if (object.signatures !== undefined && object.signatures !== null) for (const e of object.signatures)message.signatures.push(module.exports.SignatureDescriptor.fromPartial(e));
        return message;
    }
};
const $95b4281a9f8c6ef3$var$baseSignatureDescriptor = {
    sequence: $95b4281a9f8c6ef3$var$long_1.default.UZERO
};
module.exports.SignatureDescriptor = {
    encode (message, writer = $95b4281a9f8c6ef3$var$minimal_1.default.Writer.create()) {
        if (message.publicKey !== undefined) $c5FxR.Any.encode(message.publicKey, writer.uint32(10).fork()).ldelim();
        if (message.data !== undefined) module.exports.SignatureDescriptor_Data.encode(message.data, writer.uint32(18).fork()).ldelim();
        if (!message.sequence.isZero()) writer.uint32(24).uint64(message.sequence);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $95b4281a9f8c6ef3$var$minimal_1.default.Reader ? input : new $95b4281a9f8c6ef3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $95b4281a9f8c6ef3$var$baseSignatureDescriptor);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.publicKey = $c5FxR.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.data = module.exports.SignatureDescriptor_Data.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $95b4281a9f8c6ef3$var$baseSignatureDescriptor);
        if (object.publicKey !== undefined && object.publicKey !== null) message.publicKey = $c5FxR.Any.fromJSON(object.publicKey);
        else message.publicKey = undefined;
        if (object.data !== undefined && object.data !== null) message.data = module.exports.SignatureDescriptor_Data.fromJSON(object.data);
        else message.data = undefined;
        if (object.sequence !== undefined && object.sequence !== null) message.sequence = $95b4281a9f8c6ef3$var$long_1.default.fromString(object.sequence);
        else message.sequence = $95b4281a9f8c6ef3$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.publicKey !== undefined && (obj.publicKey = message.publicKey ? $c5FxR.Any.toJSON(message.publicKey) : undefined);
        message.data !== undefined && (obj.data = message.data ? module.exports.SignatureDescriptor_Data.toJSON(message.data) : undefined);
        message.sequence !== undefined && (obj.sequence = (message.sequence || $95b4281a9f8c6ef3$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $95b4281a9f8c6ef3$var$baseSignatureDescriptor);
        if (object.publicKey !== undefined && object.publicKey !== null) message.publicKey = $c5FxR.Any.fromPartial(object.publicKey);
        else message.publicKey = undefined;
        if (object.data !== undefined && object.data !== null) message.data = module.exports.SignatureDescriptor_Data.fromPartial(object.data);
        else message.data = undefined;
        if (object.sequence !== undefined && object.sequence !== null) message.sequence = object.sequence;
        else message.sequence = $95b4281a9f8c6ef3$var$long_1.default.UZERO;
        return message;
    }
};
const $95b4281a9f8c6ef3$var$baseSignatureDescriptor_Data = {};
module.exports.SignatureDescriptor_Data = {
    encode (message, writer = $95b4281a9f8c6ef3$var$minimal_1.default.Writer.create()) {
        if (message.single !== undefined) module.exports.SignatureDescriptor_Data_Single.encode(message.single, writer.uint32(10).fork()).ldelim();
        if (message.multi !== undefined) module.exports.SignatureDescriptor_Data_Multi.encode(message.multi, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $95b4281a9f8c6ef3$var$minimal_1.default.Reader ? input : new $95b4281a9f8c6ef3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $95b4281a9f8c6ef3$var$baseSignatureDescriptor_Data);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.single = module.exports.SignatureDescriptor_Data_Single.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.multi = module.exports.SignatureDescriptor_Data_Multi.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $95b4281a9f8c6ef3$var$baseSignatureDescriptor_Data);
        if (object.single !== undefined && object.single !== null) message.single = module.exports.SignatureDescriptor_Data_Single.fromJSON(object.single);
        else message.single = undefined;
        if (object.multi !== undefined && object.multi !== null) message.multi = module.exports.SignatureDescriptor_Data_Multi.fromJSON(object.multi);
        else message.multi = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.single !== undefined && (obj.single = message.single ? module.exports.SignatureDescriptor_Data_Single.toJSON(message.single) : undefined);
        message.multi !== undefined && (obj.multi = message.multi ? module.exports.SignatureDescriptor_Data_Multi.toJSON(message.multi) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $95b4281a9f8c6ef3$var$baseSignatureDescriptor_Data);
        if (object.single !== undefined && object.single !== null) message.single = module.exports.SignatureDescriptor_Data_Single.fromPartial(object.single);
        else message.single = undefined;
        if (object.multi !== undefined && object.multi !== null) message.multi = module.exports.SignatureDescriptor_Data_Multi.fromPartial(object.multi);
        else message.multi = undefined;
        return message;
    }
};
const $95b4281a9f8c6ef3$var$baseSignatureDescriptor_Data_Single = {
    mode: 0
};
module.exports.SignatureDescriptor_Data_Single = {
    encode (message, writer = $95b4281a9f8c6ef3$var$minimal_1.default.Writer.create()) {
        if (message.mode !== 0) writer.uint32(8).int32(message.mode);
        if (message.signature.length !== 0) writer.uint32(18).bytes(message.signature);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $95b4281a9f8c6ef3$var$minimal_1.default.Reader ? input : new $95b4281a9f8c6ef3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $95b4281a9f8c6ef3$var$baseSignatureDescriptor_Data_Single);
        message.signature = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.mode = reader.int32();
                    break;
                case 2:
                    message.signature = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $95b4281a9f8c6ef3$var$baseSignatureDescriptor_Data_Single);
        message.signature = new Uint8Array();
        if (object.mode !== undefined && object.mode !== null) message.mode = $95b4281a9f8c6ef3$var$signModeFromJSON(object.mode);
        else message.mode = 0;
        if (object.signature !== undefined && object.signature !== null) message.signature = $95b4281a9f8c6ef3$var$bytesFromBase64(object.signature);
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.mode !== undefined && (obj.mode = $95b4281a9f8c6ef3$var$signModeToJSON(message.mode));
        message.signature !== undefined && (obj.signature = $95b4281a9f8c6ef3$var$base64FromBytes(message.signature !== undefined ? message.signature : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $95b4281a9f8c6ef3$var$baseSignatureDescriptor_Data_Single);
        if (object.mode !== undefined && object.mode !== null) message.mode = object.mode;
        else message.mode = 0;
        if (object.signature !== undefined && object.signature !== null) message.signature = object.signature;
        else message.signature = new Uint8Array();
        return message;
    }
};
const $95b4281a9f8c6ef3$var$baseSignatureDescriptor_Data_Multi = {};
module.exports.SignatureDescriptor_Data_Multi = {
    encode (message, writer = $95b4281a9f8c6ef3$var$minimal_1.default.Writer.create()) {
        if (message.bitarray !== undefined) $be8is.CompactBitArray.encode(message.bitarray, writer.uint32(10).fork()).ldelim();
        for (const v of message.signatures)module.exports.SignatureDescriptor_Data.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $95b4281a9f8c6ef3$var$minimal_1.default.Reader ? input : new $95b4281a9f8c6ef3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $95b4281a9f8c6ef3$var$baseSignatureDescriptor_Data_Multi);
        message.signatures = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bitarray = $be8is.CompactBitArray.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.signatures.push(module.exports.SignatureDescriptor_Data.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $95b4281a9f8c6ef3$var$baseSignatureDescriptor_Data_Multi);
        message.signatures = [];
        if (object.bitarray !== undefined && object.bitarray !== null) message.bitarray = $be8is.CompactBitArray.fromJSON(object.bitarray);
        else message.bitarray = undefined;
        if (object.signatures !== undefined && object.signatures !== null) for (const e of object.signatures)message.signatures.push(module.exports.SignatureDescriptor_Data.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.bitarray !== undefined && (obj.bitarray = message.bitarray ? $be8is.CompactBitArray.toJSON(message.bitarray) : undefined);
        if (message.signatures) obj.signatures = message.signatures.map((e)=>e ? module.exports.SignatureDescriptor_Data.toJSON(e) : undefined);
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $95b4281a9f8c6ef3$var$baseSignatureDescriptor_Data_Multi);
        message.signatures = [];
        if (object.bitarray !== undefined && object.bitarray !== null) message.bitarray = $be8is.CompactBitArray.fromPartial(object.bitarray);
        else message.bitarray = undefined;
        if (object.signatures !== undefined && object.signatures !== null) for (const e of object.signatures)message.signatures.push(module.exports.SignatureDescriptor_Data.fromPartial(e));
        return message;
    }
};
var $95b4281a9f8c6ef3$var$globalThis = (()=>{
    if (typeof $95b4281a9f8c6ef3$var$globalThis !== "undefined") return $95b4281a9f8c6ef3$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $95b4281a9f8c6ef3$var$atob = $95b4281a9f8c6ef3$var$globalThis.atob || ((b64)=>$95b4281a9f8c6ef3$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $95b4281a9f8c6ef3$var$bytesFromBase64(b64) {
    const bin = $95b4281a9f8c6ef3$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $95b4281a9f8c6ef3$var$btoa = $95b4281a9f8c6ef3$var$globalThis.btoa || ((bin)=>$95b4281a9f8c6ef3$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $95b4281a9f8c6ef3$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $95b4281a9f8c6ef3$var$btoa(bin.join(""));
}
if ($95b4281a9f8c6ef3$var$minimal_1.default.util.Long !== $95b4281a9f8c6ef3$var$long_1.default) {
    $95b4281a9f8c6ef3$var$minimal_1.default.util.Long = $95b4281a9f8c6ef3$var$long_1.default;
    $95b4281a9f8c6ef3$var$minimal_1.default.configure();
}

});
parcelRegister("be8is", function(module, exports) {
"use strict";
var $82c77017da94753c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CompactBitArray = module.exports.MultiSignature = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $82c77017da94753c$var$long_1 = $82c77017da94753c$var$__importDefault((parcelRequire("9A55m")));

const $82c77017da94753c$var$minimal_1 = $82c77017da94753c$var$__importDefault((parcelRequire("i2pIU")));
module.exports.protobufPackage = "cosmos.crypto.multisig.v1beta1";
const $82c77017da94753c$var$baseMultiSignature = {};
module.exports.MultiSignature = {
    encode (message, writer = $82c77017da94753c$var$minimal_1.default.Writer.create()) {
        for (const v of message.signatures)writer.uint32(10).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $82c77017da94753c$var$minimal_1.default.Reader ? input : new $82c77017da94753c$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $82c77017da94753c$var$baseMultiSignature);
        message.signatures = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signatures.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $82c77017da94753c$var$baseMultiSignature);
        message.signatures = [];
        if (object.signatures !== undefined && object.signatures !== null) for (const e of object.signatures)message.signatures.push($82c77017da94753c$var$bytesFromBase64(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.signatures) obj.signatures = message.signatures.map((e)=>$82c77017da94753c$var$base64FromBytes(e !== undefined ? e : new Uint8Array()));
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $82c77017da94753c$var$baseMultiSignature);
        message.signatures = [];
        if (object.signatures !== undefined && object.signatures !== null) for (const e of object.signatures)message.signatures.push(e);
        return message;
    }
};
const $82c77017da94753c$var$baseCompactBitArray = {
    extraBitsStored: 0
};
module.exports.CompactBitArray = {
    encode (message, writer = $82c77017da94753c$var$minimal_1.default.Writer.create()) {
        if (message.extraBitsStored !== 0) writer.uint32(8).uint32(message.extraBitsStored);
        if (message.elems.length !== 0) writer.uint32(18).bytes(message.elems);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $82c77017da94753c$var$minimal_1.default.Reader ? input : new $82c77017da94753c$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $82c77017da94753c$var$baseCompactBitArray);
        message.elems = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.extraBitsStored = reader.uint32();
                    break;
                case 2:
                    message.elems = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $82c77017da94753c$var$baseCompactBitArray);
        message.elems = new Uint8Array();
        if (object.extraBitsStored !== undefined && object.extraBitsStored !== null) message.extraBitsStored = Number(object.extraBitsStored);
        else message.extraBitsStored = 0;
        if (object.elems !== undefined && object.elems !== null) message.elems = $82c77017da94753c$var$bytesFromBase64(object.elems);
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.extraBitsStored !== undefined && (obj.extraBitsStored = message.extraBitsStored);
        message.elems !== undefined && (obj.elems = $82c77017da94753c$var$base64FromBytes(message.elems !== undefined ? message.elems : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $82c77017da94753c$var$baseCompactBitArray);
        if (object.extraBitsStored !== undefined && object.extraBitsStored !== null) message.extraBitsStored = object.extraBitsStored;
        else message.extraBitsStored = 0;
        if (object.elems !== undefined && object.elems !== null) message.elems = object.elems;
        else message.elems = new Uint8Array();
        return message;
    }
};
var $82c77017da94753c$var$globalThis = (()=>{
    if (typeof $82c77017da94753c$var$globalThis !== "undefined") return $82c77017da94753c$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $82c77017da94753c$var$atob = $82c77017da94753c$var$globalThis.atob || ((b64)=>$82c77017da94753c$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $82c77017da94753c$var$bytesFromBase64(b64) {
    const bin = $82c77017da94753c$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $82c77017da94753c$var$btoa = $82c77017da94753c$var$globalThis.btoa || ((bin)=>$82c77017da94753c$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $82c77017da94753c$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $82c77017da94753c$var$btoa(bin.join(""));
}
if ($82c77017da94753c$var$minimal_1.default.util.Long !== $82c77017da94753c$var$long_1.default) {
    $82c77017da94753c$var$minimal_1.default.util.Long = $82c77017da94753c$var$long_1.default;
    $82c77017da94753c$var$minimal_1.default.configure();
}

});




parcelRegister("mWGMO", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $044f949f38fbd5bf$require$Buffer = $gzLuY.Buffer;
"use strict";
var $044f949f38fbd5bf$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $044f949f38fbd5bf$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $044f949f38fbd5bf$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $044f949f38fbd5bf$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $044f949f38fbd5bf$var$__createBinding(result, mod, k);
    }
    $044f949f38fbd5bf$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SignDoc = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $044f949f38fbd5bf$var$Long = $044f949f38fbd5bf$var$__importStar((parcelRequire("9A55m")));

var $fSXAC = parcelRequire("fSXAC");

var $exsS4 = parcelRequire("exsS4");
/**
 * A sign message is a data structure that is used to create a [[StdSignature]] to be later
 * appended to the list of signatures in an [[StdTx]]. Essentially, it contains all the
 * information needed to sign and build a transaction, and can be described as an
 * "unsigned transaction."
 */ var $044f949f38fbd5bf$var$SignDoc = /** @class */ function(_super) {
    $044f949f38fbd5bf$var$__extends(SignDoc, _super);
    /**
     *
     * @param chain_id ID of blockchain to submit transaction to
     * @param account_number account number on blockchain
     * @param sequence Sequence number (nonce), number of signed previous transactions by
     *    account included on the blockchain at time of broadcast.
     * @param fee transaction fee
     * @param msgs list of messages to include
     * @param memo optional note
     * @param timeout_height optional transaction timeout height, does not support amino
     * @param public_key Signer's public key, only used at direct sign mode
     */ function SignDoc(chain_id, account_number, sequence, auth_info, tx_body) {
        var _this = _super.call(this) || this;
        _this.chain_id = chain_id;
        _this.account_number = account_number;
        _this.sequence = sequence;
        _this.auth_info = auth_info;
        _this.tx_body = tx_body;
        return _this;
    }
    SignDoc.prototype.toAmino = function(isClassic) {
        var _a = this, chain_id = _a.chain_id, account_number = _a.account_number, sequence = _a.sequence, _b = _a.tx_body, memo = _b.memo, messages = _b.messages, timeout_height = _b.timeout_height, fee = _a.auth_info.fee;
        return {
            chain_id: chain_id,
            account_number: account_number.toString(),
            sequence: sequence.toString(),
            timeout_height: timeout_height && timeout_height !== 0 ? timeout_height.toString() : undefined,
            fee: fee.toAmino(),
            msgs: messages.map(function(m) {
                return m.toAmino(isClassic);
            }),
            memo: memo !== null && memo !== void 0 ? memo : ""
        };
    };
    SignDoc.prototype.toData = function(isClassic) {
        var _a = this, account_number = _a.account_number, chain_id = _a.chain_id, tx_body = _a.tx_body, auth_info = _a.auth_info;
        return {
            body_bytes: $044f949f38fbd5bf$require$Buffer.from(tx_body.toBytes(isClassic)).toString("base64"),
            auth_info_bytes: $044f949f38fbd5bf$require$Buffer.from(auth_info.toBytes()).toString("base64"),
            account_number: account_number.toFixed(),
            chain_id: chain_id
        };
    };
    SignDoc.prototype.toProto = function(isClassic) {
        var _a = this, account_number = _a.account_number, chain_id = _a.chain_id, tx_body = _a.tx_body, auth_info = _a.auth_info;
        return $fSXAC.SignDoc.fromPartial({
            bodyBytes: tx_body.toBytes(isClassic),
            authInfoBytes: auth_info.toBytes(),
            accountNumber: $044f949f38fbd5bf$var$Long.fromNumber(account_number),
            chainId: chain_id
        });
    };
    SignDoc.prototype.toUnSignedTx = function() {
        return new $exsS4.Tx(this.tx_body, this.auth_info, []);
    };
    SignDoc.prototype.toBytes = function(isClassic) {
        return $fSXAC.SignDoc.encode(this.toProto(isClassic)).finish();
    };
    return SignDoc;
}($26Eqx.JSONSerializable);
module.exports.SignDoc = $044f949f38fbd5bf$var$SignDoc;

});
parcelRegister("exsS4", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $a95a8af4fd1635eb$require$Buffer = $gzLuY.Buffer;
"use strict";
var $a95a8af4fd1635eb$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a95a8af4fd1635eb$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $a95a8af4fd1635eb$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a95a8af4fd1635eb$var$__createBinding(result, mod, k);
    }
    $a95a8af4fd1635eb$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ModeInfo = module.exports.SignerInfo = module.exports.AuthInfo = module.exports.TxBody = module.exports.Tx = void 0;

var $eVVZl = parcelRequire("eVVZl");

var $cQRUh = parcelRequire("cQRUh");

var $fSXAC = parcelRequire("fSXAC");

var $9sbIx = parcelRequire("9sbIx");

var $7ag45 = parcelRequire("7ag45");

var $cqRmZ = parcelRequire("cqRmZ");

var $a95a8af4fd1635eb$var$Long = $a95a8af4fd1635eb$var$__importStar((parcelRequire("9A55m")));

var $9xHlz = parcelRequire("9xHlz");
var $a95a8af4fd1635eb$var$Tx = /** @class */ function() {
    function Tx(body, auth_info, signatures) {
        this.body = body;
        this.auth_info = auth_info;
        this.signatures = signatures;
    }
    Tx.fromAmino = function(data, isClassic) {
        var signatures = data.value.signatures.map(function(s) {
            return $9xHlz.SignatureV2.fromAmino(s);
        });
        return new Tx(new $a95a8af4fd1635eb$var$TxBody(data.value.msg.map(function(m) {
            return $7ag45.Msg.fromAmino(m, isClassic);
        }), data.value.memo, Number.parseInt(data.value.timeout_height)), new $a95a8af4fd1635eb$var$AuthInfo([], $cqRmZ.Fee.fromAmino(data.value.fee)), signatures.map(function(s) {
            var _a;
            return ((_a = s.data.single) === null || _a === void 0 ? void 0 : _a.signature) || "";
        }));
    };
    Tx.fromData = function(data, isClassic) {
        return new Tx($a95a8af4fd1635eb$var$TxBody.fromData(data.body, isClassic), $a95a8af4fd1635eb$var$AuthInfo.fromData(data.auth_info), data.signatures);
    };
    Tx.prototype.toData = function(isClassic) {
        return {
            body: this.body.toData(isClassic),
            auth_info: this.auth_info.toData(),
            signatures: this.signatures
        };
    };
    Tx.unpackAny = function(anyProto, isClassic) {
        return this.fromProto($fSXAC.Tx.decode(anyProto.value), isClassic);
    };
    Tx.fromProto = function(proto, isClassic) {
        return new Tx($a95a8af4fd1635eb$var$TxBody.fromProto(proto.body, isClassic), $a95a8af4fd1635eb$var$AuthInfo.fromProto(proto.authInfo), proto.signatures.map(function(sig) {
            return $a95a8af4fd1635eb$require$Buffer.from(sig).toString("base64");
        }));
    };
    Tx.prototype.toProto = function(isClassic) {
        return $fSXAC.Tx.fromPartial({
            body: this.body.toProto(isClassic),
            authInfo: this.auth_info.toProto(),
            signatures: this.signatures.map(function(s) {
                return $a95a8af4fd1635eb$require$Buffer.from(s, "base64");
            })
        });
    };
    Tx.prototype.toBytes = function(isClassic) {
        return $fSXAC.Tx.encode(this.toProto(isClassic)).finish();
    };
    Tx.fromBuffer = function(buf, isClassic) {
        return Tx.fromProto($fSXAC.Tx.decode(buf), isClassic);
    };
    Tx.prototype.appendEmptySignatures = function(signers) {
        var _this = this;
        signers.forEach(function(signer) {
            var signerInfo;
            if (signer.publicKey) {
                if (signer.publicKey instanceof $eVVZl.LegacyAminoMultisigPublicKey) signerInfo = new $a95a8af4fd1635eb$var$SignerInfo(signer.publicKey, signer.sequenceNumber, new $a95a8af4fd1635eb$var$ModeInfo(new $a95a8af4fd1635eb$var$ModeInfo.Multi($9sbIx.CompactBitArray.fromBits(signer.publicKey.pubkeys.length), [])));
                else signerInfo = new $a95a8af4fd1635eb$var$SignerInfo(signer.publicKey, signer.sequenceNumber, new $a95a8af4fd1635eb$var$ModeInfo(new $a95a8af4fd1635eb$var$ModeInfo.Single($a95a8af4fd1635eb$var$ModeInfo.SignMode.SIGN_MODE_DIRECT)));
            } else signerInfo = new $a95a8af4fd1635eb$var$SignerInfo(new $eVVZl.SimplePublicKey(""), signer.sequenceNumber, new $a95a8af4fd1635eb$var$ModeInfo(new $a95a8af4fd1635eb$var$ModeInfo.Single($a95a8af4fd1635eb$var$ModeInfo.SignMode.SIGN_MODE_DIRECT)));
            _this.auth_info.signer_infos.push(signerInfo);
            _this.signatures.push("");
        });
    };
    Tx.prototype.clearSignatures = function() {
        this.auth_info.signer_infos = [];
        this.signatures = [];
    };
    Tx.prototype.appendSignatures = function(signatures) {
        for(var _i = 0, signatures_1 = signatures; _i < signatures_1.length; _i++){
            var signature = signatures_1[_i];
            var _a = signature.data.toModeInfoAndSignature(), modeInfo = _a[0], sigBytes = _a[1];
            this.signatures.push($a95a8af4fd1635eb$require$Buffer.from(sigBytes).toString("base64"));
            this.auth_info.signer_infos.push(new $a95a8af4fd1635eb$var$SignerInfo(signature.public_key, signature.sequence, modeInfo));
        }
    };
    return Tx;
}();
module.exports.Tx = $a95a8af4fd1635eb$var$Tx;
var $a95a8af4fd1635eb$var$TxBody = /** @class */ function() {
    function TxBody(messages, memo, timeout_height) {
        this.messages = messages;
        this.memo = memo;
        this.timeout_height = timeout_height;
    }
    TxBody.fromData = function(data, isClassic) {
        return new TxBody(data.messages.map(function(m) {
            return $7ag45.Msg.fromData(m, isClassic);
        }), data.memo, Number.parseInt(data.timeout_height));
    };
    TxBody.prototype.toData = function(isClassic) {
        var _a, _b;
        return {
            memo: (_a = this.memo) !== null && _a !== void 0 ? _a : "",
            messages: this.messages.map(function(m) {
                return m.toData(isClassic);
            }),
            timeout_height: ((_b = this.timeout_height) !== null && _b !== void 0 ? _b : 0).toFixed()
        };
    };
    TxBody.fromProto = function(proto, isClassic) {
        return new TxBody(proto.messages.map(function(m) {
            return $7ag45.Msg.fromProto(m, isClassic);
        }), proto.memo, proto.timeoutHeight.toNumber());
    };
    TxBody.prototype.toProto = function(isClassic) {
        var _a;
        return $fSXAC.TxBody.fromPartial({
            memo: this.memo,
            messages: this.messages.map(function(m) {
                return m.packAny(isClassic);
            }),
            timeoutHeight: $a95a8af4fd1635eb$var$Long.fromNumber((_a = this.timeout_height) !== null && _a !== void 0 ? _a : 0)
        });
    };
    TxBody.prototype.toBytes = function(isClassic) {
        return $fSXAC.TxBody.encode(this.toProto(isClassic)).finish();
    };
    return TxBody;
}();
module.exports.TxBody = $a95a8af4fd1635eb$var$TxBody;
var $a95a8af4fd1635eb$var$AuthInfo = /** @class */ function() {
    function AuthInfo(signer_infos, fee) {
        this.signer_infos = signer_infos;
        this.fee = fee;
    }
    AuthInfo.fromData = function(data) {
        return new AuthInfo(data.signer_infos.map(function(s) {
            return $a95a8af4fd1635eb$var$SignerInfo.fromData(s);
        }), $cqRmZ.Fee.fromData(data.fee));
    };
    AuthInfo.prototype.toData = function() {
        return {
            fee: this.fee.toData(),
            signer_infos: this.signer_infos.map(function(info) {
                return info.toData();
            })
        };
    };
    AuthInfo.fromProto = function(proto) {
        return new AuthInfo(proto.signerInfos.map(function(s) {
            return $a95a8af4fd1635eb$var$SignerInfo.fromProto(s);
        }), $cqRmZ.Fee.fromProto(proto.fee));
    };
    AuthInfo.prototype.toProto = function() {
        return $fSXAC.AuthInfo.fromPartial({
            fee: this.fee.toProto(),
            signerInfos: this.signer_infos.map(function(info) {
                return info.toProto();
            })
        });
    };
    AuthInfo.prototype.toBytes = function() {
        return $fSXAC.AuthInfo.encode(this.toProto()).finish();
    };
    return AuthInfo;
}();
module.exports.AuthInfo = $a95a8af4fd1635eb$var$AuthInfo;
var $a95a8af4fd1635eb$var$SignerInfo = /** @class */ function() {
    function SignerInfo(public_key, sequence, mode_info) {
        this.public_key = public_key;
        this.sequence = sequence;
        this.mode_info = mode_info;
    }
    SignerInfo.fromData = function(data) {
        var _a;
        return new SignerInfo($eVVZl.PublicKey.fromData((_a = data.public_key) !== null && _a !== void 0 ? _a : new $eVVZl.SimplePublicKey("").toData()), Number.parseInt(data.sequence), $a95a8af4fd1635eb$var$ModeInfo.fromData(data.mode_info));
    };
    SignerInfo.prototype.toData = function() {
        var _a = this, public_key = _a.public_key, sequence = _a.sequence, mode_info = _a.mode_info;
        return {
            mode_info: mode_info.toData(),
            public_key: (public_key === null || public_key === void 0 ? void 0 : public_key.toData()) || null,
            sequence: sequence.toFixed()
        };
    };
    SignerInfo.fromProto = function(proto) {
        var _a;
        return new SignerInfo($eVVZl.PublicKey.fromProto((_a = proto.publicKey) !== null && _a !== void 0 ? _a : new $eVVZl.SimplePublicKey("").packAny()), proto.sequence.toNumber(), $a95a8af4fd1635eb$var$ModeInfo.fromProto(proto.modeInfo));
    };
    SignerInfo.prototype.toProto = function() {
        var _a = this, public_key = _a.public_key, sequence = _a.sequence, mode_info = _a.mode_info;
        return $fSXAC.SignerInfo.fromPartial({
            modeInfo: mode_info.toProto(),
            publicKey: public_key === null || public_key === void 0 ? void 0 : public_key.packAny(),
            sequence: $a95a8af4fd1635eb$var$Long.fromNumber(sequence)
        });
    };
    return SignerInfo;
}();
module.exports.SignerInfo = $a95a8af4fd1635eb$var$SignerInfo;
var $a95a8af4fd1635eb$var$ModeInfo = /** @class */ function() {
    function ModeInfo(mode_info) {
        if (mode_info instanceof ModeInfo.Single) this.single = mode_info;
        else this.multi = mode_info;
    }
    ModeInfo.fromData = function(data) {
        if (data.single) return new ModeInfo(ModeInfo.Single.fromData(data.single));
        if (data.multi) return new ModeInfo(ModeInfo.Multi.fromData(data.multi));
        throw new Error("must be one of single or multi");
    };
    ModeInfo.prototype.toData = function() {
        var _a, _b;
        return {
            single: (_a = this.single) === null || _a === void 0 ? void 0 : _a.toData(),
            multi: (_b = this.multi) === null || _b === void 0 ? void 0 : _b.toData()
        };
    };
    ModeInfo.fromProto = function(proto) {
        var singleMode = proto.single;
        var multiMode = proto.multi;
        return new ModeInfo(singleMode ? ModeInfo.Single.fromProto(singleMode) : ModeInfo.Multi.fromProto(multiMode));
    };
    ModeInfo.prototype.toProto = function() {
        var _a, _b;
        return $fSXAC.ModeInfo.fromPartial({
            multi: (_a = this.multi) === null || _a === void 0 ? void 0 : _a.toProto(),
            single: (_b = this.single) === null || _b === void 0 ? void 0 : _b.toProto()
        });
    };
    return ModeInfo;
}();
module.exports.ModeInfo = $a95a8af4fd1635eb$var$ModeInfo;
(function(ModeInfo) {
    ModeInfo.SignMode = $cQRUh.SignMode;
    var Single = /** @class */ function() {
        function Single(mode) {
            this.mode = mode;
        }
        Single.fromData = function(data) {
            return new Single((0, $cQRUh.signModeFromJSON)(data.mode));
        };
        Single.prototype.toData = function() {
            return {
                mode: (0, $cQRUh.signModeToJSON)(this.mode)
            };
        };
        Single.fromProto = function(proto) {
            return new Single(proto.mode);
        };
        Single.prototype.toProto = function() {
            return $fSXAC.ModeInfo_Single.fromPartial({
                mode: this.mode
            });
        };
        return Single;
    }();
    ModeInfo.Single = Single;
    var Multi = /** @class */ function() {
        function Multi(bitarray, modeInfos) {
            this.bitarray = bitarray;
            this.modeInfos = modeInfos;
        }
        Multi.fromData = function(proto) {
            return new Multi($9sbIx.CompactBitArray.fromData(proto.bitarray), proto.mode_infos.map(function(m) {
                return ModeInfo.fromData(m);
            }));
        };
        Multi.prototype.toData = function() {
            return {
                bitarray: this.bitarray.toData(),
                mode_infos: this.modeInfos.map(function(m) {
                    return m.toData();
                })
            };
        };
        Multi.fromProto = function(proto) {
            return new Multi($9sbIx.CompactBitArray.fromProto(proto.bitarray), proto.modeInfos.map(function(m) {
                return ModeInfo.fromProto(m);
            }));
        };
        Multi.prototype.toProto = function() {
            return $fSXAC.ModeInfo_Multi.fromPartial({
                bitarray: this.bitarray.toProto(),
                modeInfos: this.modeInfos.map(function(m) {
                    return m.toProto();
                })
            });
        };
        return Multi;
    }();
    ModeInfo.Multi = Multi;
})($a95a8af4fd1635eb$var$ModeInfo = module.exports.ModeInfo || (module.exports.ModeInfo = {}));
module.exports.ModeInfo = $a95a8af4fd1635eb$var$ModeInfo;

});
parcelRegister("9sbIx", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $6e1fd164b861a84f$require$Buffer = $gzLuY.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CompactBitArray = void 0;

var $be8is = parcelRequire("be8is");
var $6e1fd164b861a84f$var$CompactBitArray = /** @class */ function() {
    function CompactBitArray(extra_bits_stored, elems) {
        this.extra_bits_stored = extra_bits_stored;
        this.elems = elems;
    }
    CompactBitArray.fromBits = function(bits) {
        if (bits <= 0) throw new Error("CompactBitArray bits must be bigger than 0");
        var num_elems = (bits + 7) / 8;
        if (num_elems <= 0 || num_elems > Math.pow(2, 32) - 1) // We encountered an overflow here, and shouldn't pass negatives
        // to make, nor should we allow unreasonable limits > maxint32.
        // See https://github.com/cosmos/cosmos-sdk/issues/9162
        throw new Error("CompactBitArray overflow");
        return new CompactBitArray(bits % 8, $6e1fd164b861a84f$require$Buffer.alloc(num_elems));
    };
    // returns the number of bits in the bitarray
    CompactBitArray.prototype.count = function() {
        if (this.extra_bits_stored == 0) return this.elems.length * 8;
        return (this.elems.length - 1) * 8 + this.extra_bits_stored;
    };
    // returns true if the bit at index i is set; returns false otherwise.
    // The behavior is undefined if i >= bA.Count()
    CompactBitArray.prototype.getIndex = function(i) {
        if (i < 0 || i >= this.count()) return false;
        return (this.elems.readUInt8(i >> 3) & 1 << 7 - i % 8) > 0;
    };
    // sets the bit at index i within the bit array. Returns true if and only if the
    // operation succeeded. The behavior is undefined if i >= bA.Count()
    CompactBitArray.prototype.setIndex = function(i, v) {
        if (i < 0 || i >= this.count()) return false;
        if (v) this.elems[i >> 3] |= 1 << 7 - i % 8;
        else this.elems[i >> 3] &= ~(1 << 7 - i % 8);
        return true;
    };
    // returns the number of bits set to true before the
    // given index. e.g. if bA = _XX__XX, NumOfTrueBitsBefore(4) = 2, since
    // there are two bits set to true before index 4.
    CompactBitArray.prototype.numTrueBitsBefore = function(index) {
        var countOneBits = function(n) {
            return n.toString(2).split("0").join("").length;
        };
        var ones_count = 0;
        var max = this.count();
        if (index > max) index = max;
        // below we iterate over the bytes then over bits (in low endian) and count bits set to 1
        for(var elem = 0;; elem++){
            if (elem * 8 + 7 >= index) {
                ones_count += countOneBits(this.elems[elem] >> 7 - index % 8 + 1);
                return ones_count;
            }
            ones_count += countOneBits(this.elems[elem]);
        }
    };
    CompactBitArray.fromData = function(data) {
        return new CompactBitArray(data.extra_bits_stored, $6e1fd164b861a84f$require$Buffer.from(data.elems, "base64"));
    };
    CompactBitArray.prototype.toData = function() {
        return {
            elems: this.elems.toString("base64"),
            extra_bits_stored: this.extra_bits_stored
        };
    };
    CompactBitArray.fromProto = function(proto) {
        return new CompactBitArray(proto.extraBitsStored, $6e1fd164b861a84f$require$Buffer.from(proto.elems));
    };
    CompactBitArray.prototype.toProto = function() {
        return $be8is.CompactBitArray.fromPartial({
            elems: this.elems,
            extraBitsStored: this.extra_bits_stored
        });
    };
    return CompactBitArray;
}();
module.exports.CompactBitArray = $6e1fd164b861a84f$var$CompactBitArray;

});

parcelRegister("9xHlz", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $6f28d1ea060dc382$require$Buffer = $gzLuY.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SignatureV2 = module.exports.SignMode = void 0;

var $eVVZl = parcelRequire("eVVZl");

var $exsS4 = parcelRequire("exsS4");

var $9sbIx = parcelRequire("9sbIx");

var $cQRUh = parcelRequire("cQRUh");

var $be8is = parcelRequire("be8is");

var $cQRUh = parcelRequire("cQRUh");
Object.defineProperty(module.exports, "SignMode", {
    enumerable: true,
    get: function() {
        return $cQRUh.SignMode;
    }
});
var $6f28d1ea060dc382$var$SignatureV2 = /** @class */ function() {
    function SignatureV2(public_key, data, sequence) {
        this.public_key = public_key;
        this.data = data;
        this.sequence = sequence;
    }
    SignatureV2.fromData = function(data) {
        return new SignatureV2($eVVZl.PublicKey.fromData(data.public_key), SignatureV2.Descriptor.fromData(data.data), Number.parseInt(data.sequence));
    };
    SignatureV2.prototype.toData = function() {
        return {
            public_key: this.public_key.toData(),
            data: this.data.toData(),
            sequence: this.sequence.toFixed()
        };
    };
    SignatureV2.fromAmino = function(data) {
        return new SignatureV2($eVVZl.PublicKey.fromAmino(data.pub_key), new SignatureV2.Descriptor(new SignatureV2.Descriptor.Single(SignatureV2.SignMode.SIGN_MODE_LEGACY_AMINO_JSON, data.signature)), 0);
    };
    return SignatureV2;
}();
module.exports.SignatureV2 = $6f28d1ea060dc382$var$SignatureV2;
(function(SignatureV2) {
    SignatureV2.SignMode = $cQRUh.SignMode;
    var Descriptor = /** @class */ function() {
        function Descriptor(data) {
            data instanceof Descriptor.Single ? this.single = data : this.multi = data;
        }
        Descriptor.fromData = function(data) {
            if (data.single) return new Descriptor(Descriptor.Single.fromData(data.single));
            if (data.multi) return new Descriptor(Descriptor.Multi.fromData(data.multi));
            throw new Error("must be one of single or multi");
        };
        Descriptor.prototype.toData = function() {
            if (this.single) return {
                single: this.single.toData()
            };
            if (this.multi) return {
                multi: this.multi.toData()
            };
            throw new Error("must be one of single or multi");
        };
        Descriptor.prototype.toModeInfoAndSignature = function() {
            if (this.single) {
                var sigData = this.single;
                return [
                    new $exsS4.ModeInfo(new $exsS4.ModeInfo.Single(sigData.mode)),
                    $6f28d1ea060dc382$require$Buffer.from(sigData.signature, "base64")
                ];
            }
            if (this.multi) {
                var sigData = this.multi;
                var modeInfos = [];
                var signatures = [];
                for(var _i = 0, _a = sigData.signatures; _i < _a.length; _i++){
                    var signature = _a[_i];
                    var _b = signature.toModeInfoAndSignature(), modeInfo = _b[0], sigBytes = _b[1];
                    modeInfos.push(modeInfo);
                    signatures.push(sigBytes);
                }
                var multisigBytes = $be8is.MultiSignature.encode($be8is.MultiSignature.fromPartial({
                    signatures: signatures
                })).finish();
                return [
                    new $exsS4.ModeInfo(new $exsS4.ModeInfo.Multi(sigData.bitarray, modeInfos)),
                    multisigBytes
                ];
            }
            throw new Error("invalid signature descriptor");
        };
        return Descriptor;
    }();
    SignatureV2.Descriptor = Descriptor;
    (function(Descriptor) {
        var Single = /** @class */ function() {
            function Single(mode, signature) {
                this.mode = mode;
                this.signature = signature;
            }
            Single.fromData = function(data) {
                return new Single((0, $cQRUh.signModeFromJSON)(data.mode), data.signature);
            };
            Single.prototype.toData = function() {
                var _a = this, mode = _a.mode, signature = _a.signature;
                return {
                    mode: (0, $cQRUh.signModeToJSON)(mode),
                    signature: signature
                };
            };
            return Single;
        }();
        Descriptor.Single = Single;
        var Multi = /** @class */ function() {
            function Multi(bitarray, signatures) {
                this.bitarray = bitarray;
                this.signatures = signatures;
            }
            Multi.fromData = function(data) {
                return new Multi($9sbIx.CompactBitArray.fromData(data.bitarray), data.signatures.map(function(v) {
                    return Descriptor.fromData(v);
                }));
            };
            Multi.prototype.toData = function() {
                return {
                    bitarray: this.bitarray.toData(),
                    signatures: this.signatures.map(function(sig) {
                        return sig.toData();
                    })
                };
            };
            return Multi;
        }();
        Descriptor.Multi = Multi;
    })(Descriptor = SignatureV2.Descriptor || (SignatureV2.Descriptor = {}));
})($6f28d1ea060dc382$var$SignatureV2 = module.exports.SignatureV2 || (module.exports.SignatureV2 = {}));
module.exports.SignatureV2 = $6f28d1ea060dc382$var$SignatureV2;

});



parcelRegister("2Ie67", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TxLog = module.exports.EventsByType = module.exports.TxInfo = void 0;

var $exsS4 = parcelRequire("exsS4");

var $hXPXf = parcelRequire("hXPXf");
/**
 * A TxInfo data structure is used to capture information from a transaction lookup for
 * a transaction already included in a block
 */ var $1f9aa057a7070de2$var$TxInfo = /** @class */ function() {
    /**
     *
     * @param height height of the block in which the transaction was included.
     * @param txhash transaction's hash.
     * @param raw_log raw log information, as a string.
     * @param logs log information
     * @param gas_wanted gas limited submitted in fee
     * @param gas_used actual gas consumption
     * @param tx transaction content
     * @param timestamp time of inclusion
     * @param code error code
     */ function TxInfo(height, txhash, raw_log, logs, gas_wanted, gas_used, tx, timestamp, code, codespace) {
        this.height = height;
        this.txhash = txhash;
        this.raw_log = raw_log;
        this.logs = logs;
        this.gas_wanted = gas_wanted;
        this.gas_used = gas_used;
        this.tx = tx;
        this.timestamp = timestamp;
        this.code = code;
        this.codespace = codespace;
    }
    TxInfo.fromProto = function(proto) {
        return new TxInfo(proto.height.toNumber(), proto.txhash, proto.rawLog, proto.logs.map(function(log) {
            return $1f9aa057a7070de2$var$TxLog.fromProto(log);
        }), proto.gasWanted.toNumber(), proto.gasUsed.toNumber(), $exsS4.Tx.unpackAny(proto.tx), proto.timestamp, proto.code, proto.codespace);
    };
    TxInfo.fromData = function(data, isClassic) {
        return new TxInfo(Number.parseInt(data.height), data.txhash, data.raw_log, data.logs.map(function(log) {
            return $1f9aa057a7070de2$var$TxLog.fromData(log);
        }), Number.parseInt(data.gas_wanted), Number.parseInt(data.gas_used), $exsS4.Tx.fromData(data.tx, isClassic), data.timestamp, data.code, data.codespace);
    };
    return TxInfo;
}();
module.exports.TxInfo = $1f9aa057a7070de2$var$TxInfo;
var $1f9aa057a7070de2$var$EventsByType;
(function(EventsByType) {
    function parse(eventAmino) {
        var events = {};
        eventAmino.forEach(function(ev) {
            ev.attributes.forEach(function(attr) {
                if (!(ev.type in events)) events[ev.type] = {};
                if (!(attr.key in events[ev.type])) events[ev.type][attr.key] = [];
                events[ev.type][attr.key].push(attr.value);
            });
        });
        return events;
    }
    EventsByType.parse = parse;
})($1f9aa057a7070de2$var$EventsByType = module.exports.EventsByType || (module.exports.EventsByType = {}));
var $1f9aa057a7070de2$var$TxLog = /** @class */ function() {
    function TxLog(msg_index, log, events) {
        this.msg_index = msg_index;
        this.log = log;
        this.events = events;
        this.eventsByType = $1f9aa057a7070de2$var$EventsByType.parse(this.events);
    }
    TxLog.fromData = function(data) {
        return new TxLog(data.msg_index, data.log, data.events.map(function(e) {
            return {
                type: e.type,
                attributes: e.attributes.map(function(attr) {
                    return {
                        key: attr.key,
                        value: attr.value
                    };
                })
            };
        }));
    };
    TxLog.prototype.toData = function() {
        var _a = this, msg_index = _a.msg_index, log = _a.log, events = _a.events;
        return {
            msg_index: msg_index,
            log: log,
            events: events
        };
    };
    TxLog.fromProto = function(proto) {
        return new TxLog(proto.msgIndex, proto.log, proto.events.map(function(e) {
            return {
                type: e.type,
                attributes: e.attributes.map(function(attr) {
                    return {
                        key: attr.key,
                        value: attr.value
                    };
                })
            };
        }));
    };
    TxLog.prototype.toProto = function() {
        var _a = this, msg_index = _a.msg_index, log = _a.log, events = _a.events;
        return $hXPXf.ABCIMessageLog.fromPartial({
            msgIndex: msg_index,
            log: log,
            events: events
        });
    };
    return TxLog;
}();
module.exports.TxLog = $1f9aa057a7070de2$var$TxLog;

});
parcelRegister("hXPXf", function(module, exports) {
"use strict";
var $d1403f737abd1101$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SearchTxsResult = module.exports.TxMsgData = module.exports.MsgData = module.exports.SimulationResponse = module.exports.Result = module.exports.GasInfo = module.exports.Attribute = module.exports.StringEvent = module.exports.ABCIMessageLog = module.exports.TxResponse = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $d1403f737abd1101$var$long_1 = $d1403f737abd1101$var$__importDefault((parcelRequire("9A55m")));

const $d1403f737abd1101$var$minimal_1 = $d1403f737abd1101$var$__importDefault((parcelRequire("i2pIU")));

var $c5FxR = parcelRequire("c5FxR");

var $hzJnT = parcelRequire("hzJnT");
module.exports.protobufPackage = "cosmos.base.abci.v1beta1";
const $d1403f737abd1101$var$baseTxResponse = {
    height: $d1403f737abd1101$var$long_1.default.ZERO,
    txhash: "",
    codespace: "",
    code: 0,
    data: "",
    rawLog: "",
    info: "",
    gasWanted: $d1403f737abd1101$var$long_1.default.ZERO,
    gasUsed: $d1403f737abd1101$var$long_1.default.ZERO,
    timestamp: ""
};
module.exports.TxResponse = {
    encode (message, writer = $d1403f737abd1101$var$minimal_1.default.Writer.create()) {
        if (!message.height.isZero()) writer.uint32(8).int64(message.height);
        if (message.txhash !== "") writer.uint32(18).string(message.txhash);
        if (message.codespace !== "") writer.uint32(26).string(message.codespace);
        if (message.code !== 0) writer.uint32(32).uint32(message.code);
        if (message.data !== "") writer.uint32(42).string(message.data);
        if (message.rawLog !== "") writer.uint32(50).string(message.rawLog);
        for (const v of message.logs)module.exports.ABCIMessageLog.encode(v, writer.uint32(58).fork()).ldelim();
        if (message.info !== "") writer.uint32(66).string(message.info);
        if (!message.gasWanted.isZero()) writer.uint32(72).int64(message.gasWanted);
        if (!message.gasUsed.isZero()) writer.uint32(80).int64(message.gasUsed);
        if (message.tx !== undefined) $c5FxR.Any.encode(message.tx, writer.uint32(90).fork()).ldelim();
        if (message.timestamp !== "") writer.uint32(98).string(message.timestamp);
        for (const v of message.events)$hzJnT.Event.encode(v, writer.uint32(106).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d1403f737abd1101$var$minimal_1.default.Reader ? input : new $d1403f737abd1101$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $d1403f737abd1101$var$baseTxResponse);
        message.logs = [];
        message.events = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.int64();
                    break;
                case 2:
                    message.txhash = reader.string();
                    break;
                case 3:
                    message.codespace = reader.string();
                    break;
                case 4:
                    message.code = reader.uint32();
                    break;
                case 5:
                    message.data = reader.string();
                    break;
                case 6:
                    message.rawLog = reader.string();
                    break;
                case 7:
                    message.logs.push(module.exports.ABCIMessageLog.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.info = reader.string();
                    break;
                case 9:
                    message.gasWanted = reader.int64();
                    break;
                case 10:
                    message.gasUsed = reader.int64();
                    break;
                case 11:
                    message.tx = $c5FxR.Any.decode(reader, reader.uint32());
                    break;
                case 12:
                    message.timestamp = reader.string();
                    break;
                case 13:
                    message.events.push($hzJnT.Event.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $d1403f737abd1101$var$baseTxResponse);
        message.logs = [];
        message.events = [];
        if (object.height !== undefined && object.height !== null) message.height = $d1403f737abd1101$var$long_1.default.fromString(object.height);
        else message.height = $d1403f737abd1101$var$long_1.default.ZERO;
        if (object.txhash !== undefined && object.txhash !== null) message.txhash = String(object.txhash);
        else message.txhash = "";
        if (object.codespace !== undefined && object.codespace !== null) message.codespace = String(object.codespace);
        else message.codespace = "";
        if (object.code !== undefined && object.code !== null) message.code = Number(object.code);
        else message.code = 0;
        if (object.data !== undefined && object.data !== null) message.data = String(object.data);
        else message.data = "";
        if (object.rawLog !== undefined && object.rawLog !== null) message.rawLog = String(object.rawLog);
        else message.rawLog = "";
        if (object.logs !== undefined && object.logs !== null) for (const e of object.logs)message.logs.push(module.exports.ABCIMessageLog.fromJSON(e));
        if (object.info !== undefined && object.info !== null) message.info = String(object.info);
        else message.info = "";
        if (object.gasWanted !== undefined && object.gasWanted !== null) message.gasWanted = $d1403f737abd1101$var$long_1.default.fromString(object.gasWanted);
        else message.gasWanted = $d1403f737abd1101$var$long_1.default.ZERO;
        if (object.gasUsed !== undefined && object.gasUsed !== null) message.gasUsed = $d1403f737abd1101$var$long_1.default.fromString(object.gasUsed);
        else message.gasUsed = $d1403f737abd1101$var$long_1.default.ZERO;
        if (object.tx !== undefined && object.tx !== null) message.tx = $c5FxR.Any.fromJSON(object.tx);
        else message.tx = undefined;
        if (object.timestamp !== undefined && object.timestamp !== null) message.timestamp = String(object.timestamp);
        else message.timestamp = "";
        if (object.events !== undefined && object.events !== null) for (const e of object.events)message.events.push($hzJnT.Event.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || $d1403f737abd1101$var$long_1.default.ZERO).toString());
        message.txhash !== undefined && (obj.txhash = message.txhash);
        message.codespace !== undefined && (obj.codespace = message.codespace);
        message.code !== undefined && (obj.code = message.code);
        message.data !== undefined && (obj.data = message.data);
        message.rawLog !== undefined && (obj.rawLog = message.rawLog);
        if (message.logs) obj.logs = message.logs.map((e)=>e ? module.exports.ABCIMessageLog.toJSON(e) : undefined);
        else obj.logs = [];
        message.info !== undefined && (obj.info = message.info);
        message.gasWanted !== undefined && (obj.gasWanted = (message.gasWanted || $d1403f737abd1101$var$long_1.default.ZERO).toString());
        message.gasUsed !== undefined && (obj.gasUsed = (message.gasUsed || $d1403f737abd1101$var$long_1.default.ZERO).toString());
        message.tx !== undefined && (obj.tx = message.tx ? $c5FxR.Any.toJSON(message.tx) : undefined);
        message.timestamp !== undefined && (obj.timestamp = message.timestamp);
        if (message.events) obj.events = message.events.map((e)=>e ? $hzJnT.Event.toJSON(e) : undefined);
        else obj.events = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $d1403f737abd1101$var$baseTxResponse);
        message.logs = [];
        message.events = [];
        if (object.height !== undefined && object.height !== null) message.height = object.height;
        else message.height = $d1403f737abd1101$var$long_1.default.ZERO;
        if (object.txhash !== undefined && object.txhash !== null) message.txhash = object.txhash;
        else message.txhash = "";
        if (object.codespace !== undefined && object.codespace !== null) message.codespace = object.codespace;
        else message.codespace = "";
        if (object.code !== undefined && object.code !== null) message.code = object.code;
        else message.code = 0;
        if (object.data !== undefined && object.data !== null) message.data = object.data;
        else message.data = "";
        if (object.rawLog !== undefined && object.rawLog !== null) message.rawLog = object.rawLog;
        else message.rawLog = "";
        if (object.logs !== undefined && object.logs !== null) for (const e of object.logs)message.logs.push(module.exports.ABCIMessageLog.fromPartial(e));
        if (object.info !== undefined && object.info !== null) message.info = object.info;
        else message.info = "";
        if (object.gasWanted !== undefined && object.gasWanted !== null) message.gasWanted = object.gasWanted;
        else message.gasWanted = $d1403f737abd1101$var$long_1.default.ZERO;
        if (object.gasUsed !== undefined && object.gasUsed !== null) message.gasUsed = object.gasUsed;
        else message.gasUsed = $d1403f737abd1101$var$long_1.default.ZERO;
        if (object.tx !== undefined && object.tx !== null) message.tx = $c5FxR.Any.fromPartial(object.tx);
        else message.tx = undefined;
        if (object.timestamp !== undefined && object.timestamp !== null) message.timestamp = object.timestamp;
        else message.timestamp = "";
        if (object.events !== undefined && object.events !== null) for (const e of object.events)message.events.push($hzJnT.Event.fromPartial(e));
        return message;
    }
};
const $d1403f737abd1101$var$baseABCIMessageLog = {
    msgIndex: 0,
    log: ""
};
module.exports.ABCIMessageLog = {
    encode (message, writer = $d1403f737abd1101$var$minimal_1.default.Writer.create()) {
        if (message.msgIndex !== 0) writer.uint32(8).uint32(message.msgIndex);
        if (message.log !== "") writer.uint32(18).string(message.log);
        for (const v of message.events)module.exports.StringEvent.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d1403f737abd1101$var$minimal_1.default.Reader ? input : new $d1403f737abd1101$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $d1403f737abd1101$var$baseABCIMessageLog);
        message.events = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.msgIndex = reader.uint32();
                    break;
                case 2:
                    message.log = reader.string();
                    break;
                case 3:
                    message.events.push(module.exports.StringEvent.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $d1403f737abd1101$var$baseABCIMessageLog);
        message.events = [];
        if (object.msgIndex !== undefined && object.msgIndex !== null) message.msgIndex = Number(object.msgIndex);
        else message.msgIndex = 0;
        if (object.log !== undefined && object.log !== null) message.log = String(object.log);
        else message.log = "";
        if (object.events !== undefined && object.events !== null) for (const e of object.events)message.events.push(module.exports.StringEvent.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.msgIndex !== undefined && (obj.msgIndex = message.msgIndex);
        message.log !== undefined && (obj.log = message.log);
        if (message.events) obj.events = message.events.map((e)=>e ? module.exports.StringEvent.toJSON(e) : undefined);
        else obj.events = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $d1403f737abd1101$var$baseABCIMessageLog);
        message.events = [];
        if (object.msgIndex !== undefined && object.msgIndex !== null) message.msgIndex = object.msgIndex;
        else message.msgIndex = 0;
        if (object.log !== undefined && object.log !== null) message.log = object.log;
        else message.log = "";
        if (object.events !== undefined && object.events !== null) for (const e of object.events)message.events.push(module.exports.StringEvent.fromPartial(e));
        return message;
    }
};
const $d1403f737abd1101$var$baseStringEvent = {
    type: ""
};
module.exports.StringEvent = {
    encode (message, writer = $d1403f737abd1101$var$minimal_1.default.Writer.create()) {
        if (message.type !== "") writer.uint32(10).string(message.type);
        for (const v of message.attributes)module.exports.Attribute.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d1403f737abd1101$var$minimal_1.default.Reader ? input : new $d1403f737abd1101$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $d1403f737abd1101$var$baseStringEvent);
        message.attributes = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.string();
                    break;
                case 2:
                    message.attributes.push(module.exports.Attribute.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $d1403f737abd1101$var$baseStringEvent);
        message.attributes = [];
        if (object.type !== undefined && object.type !== null) message.type = String(object.type);
        else message.type = "";
        if (object.attributes !== undefined && object.attributes !== null) for (const e of object.attributes)message.attributes.push(module.exports.Attribute.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.type !== undefined && (obj.type = message.type);
        if (message.attributes) obj.attributes = message.attributes.map((e)=>e ? module.exports.Attribute.toJSON(e) : undefined);
        else obj.attributes = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $d1403f737abd1101$var$baseStringEvent);
        message.attributes = [];
        if (object.type !== undefined && object.type !== null) message.type = object.type;
        else message.type = "";
        if (object.attributes !== undefined && object.attributes !== null) for (const e of object.attributes)message.attributes.push(module.exports.Attribute.fromPartial(e));
        return message;
    }
};
const $d1403f737abd1101$var$baseAttribute = {
    key: "",
    value: ""
};
module.exports.Attribute = {
    encode (message, writer = $d1403f737abd1101$var$minimal_1.default.Writer.create()) {
        if (message.key !== "") writer.uint32(10).string(message.key);
        if (message.value !== "") writer.uint32(18).string(message.value);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d1403f737abd1101$var$minimal_1.default.Reader ? input : new $d1403f737abd1101$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $d1403f737abd1101$var$baseAttribute);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.value = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $d1403f737abd1101$var$baseAttribute);
        if (object.key !== undefined && object.key !== null) message.key = String(object.key);
        else message.key = "";
        if (object.value !== undefined && object.value !== null) message.value = String(object.value);
        else message.value = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = message.key);
        message.value !== undefined && (obj.value = message.value);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $d1403f737abd1101$var$baseAttribute);
        if (object.key !== undefined && object.key !== null) message.key = object.key;
        else message.key = "";
        if (object.value !== undefined && object.value !== null) message.value = object.value;
        else message.value = "";
        return message;
    }
};
const $d1403f737abd1101$var$baseGasInfo = {
    gasWanted: $d1403f737abd1101$var$long_1.default.UZERO,
    gasUsed: $d1403f737abd1101$var$long_1.default.UZERO
};
module.exports.GasInfo = {
    encode (message, writer = $d1403f737abd1101$var$minimal_1.default.Writer.create()) {
        if (!message.gasWanted.isZero()) writer.uint32(8).uint64(message.gasWanted);
        if (!message.gasUsed.isZero()) writer.uint32(16).uint64(message.gasUsed);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d1403f737abd1101$var$minimal_1.default.Reader ? input : new $d1403f737abd1101$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $d1403f737abd1101$var$baseGasInfo);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.gasWanted = reader.uint64();
                    break;
                case 2:
                    message.gasUsed = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $d1403f737abd1101$var$baseGasInfo);
        if (object.gasWanted !== undefined && object.gasWanted !== null) message.gasWanted = $d1403f737abd1101$var$long_1.default.fromString(object.gasWanted);
        else message.gasWanted = $d1403f737abd1101$var$long_1.default.UZERO;
        if (object.gasUsed !== undefined && object.gasUsed !== null) message.gasUsed = $d1403f737abd1101$var$long_1.default.fromString(object.gasUsed);
        else message.gasUsed = $d1403f737abd1101$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.gasWanted !== undefined && (obj.gasWanted = (message.gasWanted || $d1403f737abd1101$var$long_1.default.UZERO).toString());
        message.gasUsed !== undefined && (obj.gasUsed = (message.gasUsed || $d1403f737abd1101$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $d1403f737abd1101$var$baseGasInfo);
        if (object.gasWanted !== undefined && object.gasWanted !== null) message.gasWanted = object.gasWanted;
        else message.gasWanted = $d1403f737abd1101$var$long_1.default.UZERO;
        if (object.gasUsed !== undefined && object.gasUsed !== null) message.gasUsed = object.gasUsed;
        else message.gasUsed = $d1403f737abd1101$var$long_1.default.UZERO;
        return message;
    }
};
const $d1403f737abd1101$var$baseResult = {
    log: ""
};
module.exports.Result = {
    encode (message, writer = $d1403f737abd1101$var$minimal_1.default.Writer.create()) {
        if (message.data.length !== 0) writer.uint32(10).bytes(message.data);
        if (message.log !== "") writer.uint32(18).string(message.log);
        for (const v of message.events)$hzJnT.Event.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d1403f737abd1101$var$minimal_1.default.Reader ? input : new $d1403f737abd1101$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $d1403f737abd1101$var$baseResult);
        message.events = [];
        message.data = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.data = reader.bytes();
                    break;
                case 2:
                    message.log = reader.string();
                    break;
                case 3:
                    message.events.push($hzJnT.Event.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $d1403f737abd1101$var$baseResult);
        message.events = [];
        message.data = new Uint8Array();
        if (object.data !== undefined && object.data !== null) message.data = $d1403f737abd1101$var$bytesFromBase64(object.data);
        if (object.log !== undefined && object.log !== null) message.log = String(object.log);
        else message.log = "";
        if (object.events !== undefined && object.events !== null) for (const e of object.events)message.events.push($hzJnT.Event.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.data !== undefined && (obj.data = $d1403f737abd1101$var$base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        message.log !== undefined && (obj.log = message.log);
        if (message.events) obj.events = message.events.map((e)=>e ? $hzJnT.Event.toJSON(e) : undefined);
        else obj.events = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $d1403f737abd1101$var$baseResult);
        message.events = [];
        if (object.data !== undefined && object.data !== null) message.data = object.data;
        else message.data = new Uint8Array();
        if (object.log !== undefined && object.log !== null) message.log = object.log;
        else message.log = "";
        if (object.events !== undefined && object.events !== null) for (const e of object.events)message.events.push($hzJnT.Event.fromPartial(e));
        return message;
    }
};
const $d1403f737abd1101$var$baseSimulationResponse = {};
module.exports.SimulationResponse = {
    encode (message, writer = $d1403f737abd1101$var$minimal_1.default.Writer.create()) {
        if (message.gasInfo !== undefined) module.exports.GasInfo.encode(message.gasInfo, writer.uint32(10).fork()).ldelim();
        if (message.result !== undefined) module.exports.Result.encode(message.result, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d1403f737abd1101$var$minimal_1.default.Reader ? input : new $d1403f737abd1101$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $d1403f737abd1101$var$baseSimulationResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.gasInfo = module.exports.GasInfo.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.result = module.exports.Result.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $d1403f737abd1101$var$baseSimulationResponse);
        if (object.gasInfo !== undefined && object.gasInfo !== null) message.gasInfo = module.exports.GasInfo.fromJSON(object.gasInfo);
        else message.gasInfo = undefined;
        if (object.result !== undefined && object.result !== null) message.result = module.exports.Result.fromJSON(object.result);
        else message.result = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.gasInfo !== undefined && (obj.gasInfo = message.gasInfo ? module.exports.GasInfo.toJSON(message.gasInfo) : undefined);
        message.result !== undefined && (obj.result = message.result ? module.exports.Result.toJSON(message.result) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $d1403f737abd1101$var$baseSimulationResponse);
        if (object.gasInfo !== undefined && object.gasInfo !== null) message.gasInfo = module.exports.GasInfo.fromPartial(object.gasInfo);
        else message.gasInfo = undefined;
        if (object.result !== undefined && object.result !== null) message.result = module.exports.Result.fromPartial(object.result);
        else message.result = undefined;
        return message;
    }
};
const $d1403f737abd1101$var$baseMsgData = {
    msgType: ""
};
module.exports.MsgData = {
    encode (message, writer = $d1403f737abd1101$var$minimal_1.default.Writer.create()) {
        if (message.msgType !== "") writer.uint32(10).string(message.msgType);
        if (message.data.length !== 0) writer.uint32(18).bytes(message.data);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d1403f737abd1101$var$minimal_1.default.Reader ? input : new $d1403f737abd1101$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $d1403f737abd1101$var$baseMsgData);
        message.data = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.msgType = reader.string();
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $d1403f737abd1101$var$baseMsgData);
        message.data = new Uint8Array();
        if (object.msgType !== undefined && object.msgType !== null) message.msgType = String(object.msgType);
        else message.msgType = "";
        if (object.data !== undefined && object.data !== null) message.data = $d1403f737abd1101$var$bytesFromBase64(object.data);
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.msgType !== undefined && (obj.msgType = message.msgType);
        message.data !== undefined && (obj.data = $d1403f737abd1101$var$base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $d1403f737abd1101$var$baseMsgData);
        if (object.msgType !== undefined && object.msgType !== null) message.msgType = object.msgType;
        else message.msgType = "";
        if (object.data !== undefined && object.data !== null) message.data = object.data;
        else message.data = new Uint8Array();
        return message;
    }
};
const $d1403f737abd1101$var$baseTxMsgData = {};
module.exports.TxMsgData = {
    encode (message, writer = $d1403f737abd1101$var$minimal_1.default.Writer.create()) {
        for (const v of message.data)module.exports.MsgData.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d1403f737abd1101$var$minimal_1.default.Reader ? input : new $d1403f737abd1101$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $d1403f737abd1101$var$baseTxMsgData);
        message.data = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.data.push(module.exports.MsgData.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $d1403f737abd1101$var$baseTxMsgData);
        message.data = [];
        if (object.data !== undefined && object.data !== null) for (const e of object.data)message.data.push(module.exports.MsgData.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.data) obj.data = message.data.map((e)=>e ? module.exports.MsgData.toJSON(e) : undefined);
        else obj.data = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $d1403f737abd1101$var$baseTxMsgData);
        message.data = [];
        if (object.data !== undefined && object.data !== null) for (const e of object.data)message.data.push(module.exports.MsgData.fromPartial(e));
        return message;
    }
};
const $d1403f737abd1101$var$baseSearchTxsResult = {
    totalCount: $d1403f737abd1101$var$long_1.default.UZERO,
    count: $d1403f737abd1101$var$long_1.default.UZERO,
    pageNumber: $d1403f737abd1101$var$long_1.default.UZERO,
    pageTotal: $d1403f737abd1101$var$long_1.default.UZERO,
    limit: $d1403f737abd1101$var$long_1.default.UZERO
};
module.exports.SearchTxsResult = {
    encode (message, writer = $d1403f737abd1101$var$minimal_1.default.Writer.create()) {
        if (!message.totalCount.isZero()) writer.uint32(8).uint64(message.totalCount);
        if (!message.count.isZero()) writer.uint32(16).uint64(message.count);
        if (!message.pageNumber.isZero()) writer.uint32(24).uint64(message.pageNumber);
        if (!message.pageTotal.isZero()) writer.uint32(32).uint64(message.pageTotal);
        if (!message.limit.isZero()) writer.uint32(40).uint64(message.limit);
        for (const v of message.txs)module.exports.TxResponse.encode(v, writer.uint32(50).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d1403f737abd1101$var$minimal_1.default.Reader ? input : new $d1403f737abd1101$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $d1403f737abd1101$var$baseSearchTxsResult);
        message.txs = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.totalCount = reader.uint64();
                    break;
                case 2:
                    message.count = reader.uint64();
                    break;
                case 3:
                    message.pageNumber = reader.uint64();
                    break;
                case 4:
                    message.pageTotal = reader.uint64();
                    break;
                case 5:
                    message.limit = reader.uint64();
                    break;
                case 6:
                    message.txs.push(module.exports.TxResponse.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $d1403f737abd1101$var$baseSearchTxsResult);
        message.txs = [];
        if (object.totalCount !== undefined && object.totalCount !== null) message.totalCount = $d1403f737abd1101$var$long_1.default.fromString(object.totalCount);
        else message.totalCount = $d1403f737abd1101$var$long_1.default.UZERO;
        if (object.count !== undefined && object.count !== null) message.count = $d1403f737abd1101$var$long_1.default.fromString(object.count);
        else message.count = $d1403f737abd1101$var$long_1.default.UZERO;
        if (object.pageNumber !== undefined && object.pageNumber !== null) message.pageNumber = $d1403f737abd1101$var$long_1.default.fromString(object.pageNumber);
        else message.pageNumber = $d1403f737abd1101$var$long_1.default.UZERO;
        if (object.pageTotal !== undefined && object.pageTotal !== null) message.pageTotal = $d1403f737abd1101$var$long_1.default.fromString(object.pageTotal);
        else message.pageTotal = $d1403f737abd1101$var$long_1.default.UZERO;
        if (object.limit !== undefined && object.limit !== null) message.limit = $d1403f737abd1101$var$long_1.default.fromString(object.limit);
        else message.limit = $d1403f737abd1101$var$long_1.default.UZERO;
        if (object.txs !== undefined && object.txs !== null) for (const e of object.txs)message.txs.push(module.exports.TxResponse.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.totalCount !== undefined && (obj.totalCount = (message.totalCount || $d1403f737abd1101$var$long_1.default.UZERO).toString());
        message.count !== undefined && (obj.count = (message.count || $d1403f737abd1101$var$long_1.default.UZERO).toString());
        message.pageNumber !== undefined && (obj.pageNumber = (message.pageNumber || $d1403f737abd1101$var$long_1.default.UZERO).toString());
        message.pageTotal !== undefined && (obj.pageTotal = (message.pageTotal || $d1403f737abd1101$var$long_1.default.UZERO).toString());
        message.limit !== undefined && (obj.limit = (message.limit || $d1403f737abd1101$var$long_1.default.UZERO).toString());
        if (message.txs) obj.txs = message.txs.map((e)=>e ? module.exports.TxResponse.toJSON(e) : undefined);
        else obj.txs = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $d1403f737abd1101$var$baseSearchTxsResult);
        message.txs = [];
        if (object.totalCount !== undefined && object.totalCount !== null) message.totalCount = object.totalCount;
        else message.totalCount = $d1403f737abd1101$var$long_1.default.UZERO;
        if (object.count !== undefined && object.count !== null) message.count = object.count;
        else message.count = $d1403f737abd1101$var$long_1.default.UZERO;
        if (object.pageNumber !== undefined && object.pageNumber !== null) message.pageNumber = object.pageNumber;
        else message.pageNumber = $d1403f737abd1101$var$long_1.default.UZERO;
        if (object.pageTotal !== undefined && object.pageTotal !== null) message.pageTotal = object.pageTotal;
        else message.pageTotal = $d1403f737abd1101$var$long_1.default.UZERO;
        if (object.limit !== undefined && object.limit !== null) message.limit = object.limit;
        else message.limit = $d1403f737abd1101$var$long_1.default.UZERO;
        if (object.txs !== undefined && object.txs !== null) for (const e of object.txs)message.txs.push(module.exports.TxResponse.fromPartial(e));
        return message;
    }
};
var $d1403f737abd1101$var$globalThis = (()=>{
    if (typeof $d1403f737abd1101$var$globalThis !== "undefined") return $d1403f737abd1101$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $d1403f737abd1101$var$atob = $d1403f737abd1101$var$globalThis.atob || ((b64)=>$d1403f737abd1101$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $d1403f737abd1101$var$bytesFromBase64(b64) {
    const bin = $d1403f737abd1101$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $d1403f737abd1101$var$btoa = $d1403f737abd1101$var$globalThis.btoa || ((bin)=>$d1403f737abd1101$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $d1403f737abd1101$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $d1403f737abd1101$var$btoa(bin.join(""));
}
if ($d1403f737abd1101$var$minimal_1.default.util.Long !== $d1403f737abd1101$var$long_1.default) {
    $d1403f737abd1101$var$minimal_1.default.util.Long = $d1403f737abd1101$var$long_1.default;
    $d1403f737abd1101$var$minimal_1.default.configure();
}

});
parcelRegister("hzJnT", function(module, exports) {
"use strict";
var $ccb8e8f6078d2457$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GrpcWebImpl = module.exports.ABCIApplicationApplySnapshotChunkDesc = module.exports.ABCIApplicationLoadSnapshotChunkDesc = module.exports.ABCIApplicationOfferSnapshotDesc = module.exports.ABCIApplicationListSnapshotsDesc = module.exports.ABCIApplicationEndBlockDesc = module.exports.ABCIApplicationBeginBlockDesc = module.exports.ABCIApplicationInitChainDesc = module.exports.ABCIApplicationCommitDesc = module.exports.ABCIApplicationQueryDesc = module.exports.ABCIApplicationCheckTxDesc = module.exports.ABCIApplicationDeliverTxDesc = module.exports.ABCIApplicationSetOptionDesc = module.exports.ABCIApplicationInfoDesc = module.exports.ABCIApplicationFlushDesc = module.exports.ABCIApplicationEchoDesc = module.exports.ABCIApplicationDesc = module.exports.ABCIApplicationClientImpl = module.exports.Snapshot = module.exports.Evidence = module.exports.VoteInfo = module.exports.ValidatorUpdate = module.exports.Validator = module.exports.TxResult = module.exports.EventAttribute = module.exports.Event = module.exports.LastCommitInfo = module.exports.BlockParams = module.exports.ConsensusParams = module.exports.ResponseApplySnapshotChunk = module.exports.ResponseLoadSnapshotChunk = module.exports.ResponseOfferSnapshot = module.exports.ResponseListSnapshots = module.exports.ResponseCommit = module.exports.ResponseEndBlock = module.exports.ResponseDeliverTx = module.exports.ResponseCheckTx = module.exports.ResponseBeginBlock = module.exports.ResponseQuery = module.exports.ResponseInitChain = module.exports.ResponseSetOption = module.exports.ResponseInfo = module.exports.ResponseFlush = module.exports.ResponseEcho = module.exports.ResponseException = module.exports.Response = module.exports.RequestApplySnapshotChunk = module.exports.RequestLoadSnapshotChunk = module.exports.RequestOfferSnapshot = module.exports.RequestListSnapshots = module.exports.RequestCommit = module.exports.RequestEndBlock = module.exports.RequestDeliverTx = module.exports.RequestCheckTx = module.exports.RequestBeginBlock = module.exports.RequestQuery = module.exports.RequestInitChain = module.exports.RequestSetOption = module.exports.RequestInfo = module.exports.RequestFlush = module.exports.RequestEcho = module.exports.Request = module.exports.responseApplySnapshotChunk_ResultToJSON = module.exports.responseApplySnapshotChunk_ResultFromJSON = module.exports.ResponseApplySnapshotChunk_Result = module.exports.responseOfferSnapshot_ResultToJSON = module.exports.responseOfferSnapshot_ResultFromJSON = module.exports.ResponseOfferSnapshot_Result = module.exports.evidenceTypeToJSON = module.exports.evidenceTypeFromJSON = module.exports.EvidenceType = module.exports.checkTxTypeToJSON = module.exports.checkTxTypeFromJSON = module.exports.CheckTxType = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $ccb8e8f6078d2457$var$long_1 = $ccb8e8f6078d2457$var$__importDefault((parcelRequire("9A55m")));

var $jXVni = parcelRequire("jXVni");

const $ccb8e8f6078d2457$var$minimal_1 = $ccb8e8f6078d2457$var$__importDefault((parcelRequire("i2pIU")));

var $djDW6 = parcelRequire("djDW6");

var $eIxyR = parcelRequire("eIxyR");

var $4csTs = parcelRequire("4csTs");

var $a0zXC = parcelRequire("a0zXC");

var $1pqjL = parcelRequire("1pqjL");

var $5G2s6 = parcelRequire("5G2s6");
module.exports.protobufPackage = "tendermint.abci";
var $ccb8e8f6078d2457$var$CheckTxType;
(function(CheckTxType) {
    CheckTxType[CheckTxType["NEW"] = 0] = "NEW";
    CheckTxType[CheckTxType["RECHECK"] = 1] = "RECHECK";
    CheckTxType[CheckTxType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($ccb8e8f6078d2457$var$CheckTxType = module.exports.CheckTxType || (module.exports.CheckTxType = {}));
function $ccb8e8f6078d2457$var$checkTxTypeFromJSON(object) {
    switch(object){
        case 0:
        case "NEW":
            return $ccb8e8f6078d2457$var$CheckTxType.NEW;
        case 1:
        case "RECHECK":
            return $ccb8e8f6078d2457$var$CheckTxType.RECHECK;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $ccb8e8f6078d2457$var$CheckTxType.UNRECOGNIZED;
    }
}
module.exports.checkTxTypeFromJSON = $ccb8e8f6078d2457$var$checkTxTypeFromJSON;
function $ccb8e8f6078d2457$var$checkTxTypeToJSON(object) {
    switch(object){
        case $ccb8e8f6078d2457$var$CheckTxType.NEW:
            return "NEW";
        case $ccb8e8f6078d2457$var$CheckTxType.RECHECK:
            return "RECHECK";
        default:
            return "UNKNOWN";
    }
}
module.exports.checkTxTypeToJSON = $ccb8e8f6078d2457$var$checkTxTypeToJSON;
var $ccb8e8f6078d2457$var$EvidenceType;
(function(EvidenceType) {
    EvidenceType[EvidenceType["UNKNOWN"] = 0] = "UNKNOWN";
    EvidenceType[EvidenceType["DUPLICATE_VOTE"] = 1] = "DUPLICATE_VOTE";
    EvidenceType[EvidenceType["LIGHT_CLIENT_ATTACK"] = 2] = "LIGHT_CLIENT_ATTACK";
    EvidenceType[EvidenceType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($ccb8e8f6078d2457$var$EvidenceType = module.exports.EvidenceType || (module.exports.EvidenceType = {}));
function $ccb8e8f6078d2457$var$evidenceTypeFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN":
            return $ccb8e8f6078d2457$var$EvidenceType.UNKNOWN;
        case 1:
        case "DUPLICATE_VOTE":
            return $ccb8e8f6078d2457$var$EvidenceType.DUPLICATE_VOTE;
        case 2:
        case "LIGHT_CLIENT_ATTACK":
            return $ccb8e8f6078d2457$var$EvidenceType.LIGHT_CLIENT_ATTACK;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $ccb8e8f6078d2457$var$EvidenceType.UNRECOGNIZED;
    }
}
module.exports.evidenceTypeFromJSON = $ccb8e8f6078d2457$var$evidenceTypeFromJSON;
function $ccb8e8f6078d2457$var$evidenceTypeToJSON(object) {
    switch(object){
        case $ccb8e8f6078d2457$var$EvidenceType.UNKNOWN:
            return "UNKNOWN";
        case $ccb8e8f6078d2457$var$EvidenceType.DUPLICATE_VOTE:
            return "DUPLICATE_VOTE";
        case $ccb8e8f6078d2457$var$EvidenceType.LIGHT_CLIENT_ATTACK:
            return "LIGHT_CLIENT_ATTACK";
        default:
            return "UNKNOWN";
    }
}
module.exports.evidenceTypeToJSON = $ccb8e8f6078d2457$var$evidenceTypeToJSON;
var $ccb8e8f6078d2457$var$ResponseOfferSnapshot_Result;
(function(ResponseOfferSnapshot_Result) {
    /** UNKNOWN - Unknown result, abort all snapshot restoration */ ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["UNKNOWN"] = 0] = "UNKNOWN";
    /** ACCEPT - Snapshot accepted, apply chunks */ ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["ACCEPT"] = 1] = "ACCEPT";
    /** ABORT - Abort all snapshot restoration */ ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["ABORT"] = 2] = "ABORT";
    /** REJECT - Reject this specific snapshot, try others */ ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["REJECT"] = 3] = "REJECT";
    /** REJECT_FORMAT - Reject all snapshots of this format, try others */ ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["REJECT_FORMAT"] = 4] = "REJECT_FORMAT";
    /** REJECT_SENDER - Reject all snapshots from the sender(s), try others */ ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["REJECT_SENDER"] = 5] = "REJECT_SENDER";
    ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($ccb8e8f6078d2457$var$ResponseOfferSnapshot_Result = module.exports.ResponseOfferSnapshot_Result || (module.exports.ResponseOfferSnapshot_Result = {}));
function $ccb8e8f6078d2457$var$responseOfferSnapshot_ResultFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN":
            return $ccb8e8f6078d2457$var$ResponseOfferSnapshot_Result.UNKNOWN;
        case 1:
        case "ACCEPT":
            return $ccb8e8f6078d2457$var$ResponseOfferSnapshot_Result.ACCEPT;
        case 2:
        case "ABORT":
            return $ccb8e8f6078d2457$var$ResponseOfferSnapshot_Result.ABORT;
        case 3:
        case "REJECT":
            return $ccb8e8f6078d2457$var$ResponseOfferSnapshot_Result.REJECT;
        case 4:
        case "REJECT_FORMAT":
            return $ccb8e8f6078d2457$var$ResponseOfferSnapshot_Result.REJECT_FORMAT;
        case 5:
        case "REJECT_SENDER":
            return $ccb8e8f6078d2457$var$ResponseOfferSnapshot_Result.REJECT_SENDER;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $ccb8e8f6078d2457$var$ResponseOfferSnapshot_Result.UNRECOGNIZED;
    }
}
module.exports.responseOfferSnapshot_ResultFromJSON = $ccb8e8f6078d2457$var$responseOfferSnapshot_ResultFromJSON;
function $ccb8e8f6078d2457$var$responseOfferSnapshot_ResultToJSON(object) {
    switch(object){
        case $ccb8e8f6078d2457$var$ResponseOfferSnapshot_Result.UNKNOWN:
            return "UNKNOWN";
        case $ccb8e8f6078d2457$var$ResponseOfferSnapshot_Result.ACCEPT:
            return "ACCEPT";
        case $ccb8e8f6078d2457$var$ResponseOfferSnapshot_Result.ABORT:
            return "ABORT";
        case $ccb8e8f6078d2457$var$ResponseOfferSnapshot_Result.REJECT:
            return "REJECT";
        case $ccb8e8f6078d2457$var$ResponseOfferSnapshot_Result.REJECT_FORMAT:
            return "REJECT_FORMAT";
        case $ccb8e8f6078d2457$var$ResponseOfferSnapshot_Result.REJECT_SENDER:
            return "REJECT_SENDER";
        default:
            return "UNKNOWN";
    }
}
module.exports.responseOfferSnapshot_ResultToJSON = $ccb8e8f6078d2457$var$responseOfferSnapshot_ResultToJSON;
var $ccb8e8f6078d2457$var$ResponseApplySnapshotChunk_Result;
(function(ResponseApplySnapshotChunk_Result) {
    /** UNKNOWN - Unknown result, abort all snapshot restoration */ ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["UNKNOWN"] = 0] = "UNKNOWN";
    /** ACCEPT - Chunk successfully accepted */ ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["ACCEPT"] = 1] = "ACCEPT";
    /** ABORT - Abort all snapshot restoration */ ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["ABORT"] = 2] = "ABORT";
    /** RETRY - Retry chunk (combine with refetch and reject) */ ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["RETRY"] = 3] = "RETRY";
    /** RETRY_SNAPSHOT - Retry snapshot (combine with refetch and reject) */ ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["RETRY_SNAPSHOT"] = 4] = "RETRY_SNAPSHOT";
    /** REJECT_SNAPSHOT - Reject this snapshot, try others */ ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["REJECT_SNAPSHOT"] = 5] = "REJECT_SNAPSHOT";
    ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($ccb8e8f6078d2457$var$ResponseApplySnapshotChunk_Result = module.exports.ResponseApplySnapshotChunk_Result || (module.exports.ResponseApplySnapshotChunk_Result = {}));
function $ccb8e8f6078d2457$var$responseApplySnapshotChunk_ResultFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN":
            return $ccb8e8f6078d2457$var$ResponseApplySnapshotChunk_Result.UNKNOWN;
        case 1:
        case "ACCEPT":
            return $ccb8e8f6078d2457$var$ResponseApplySnapshotChunk_Result.ACCEPT;
        case 2:
        case "ABORT":
            return $ccb8e8f6078d2457$var$ResponseApplySnapshotChunk_Result.ABORT;
        case 3:
        case "RETRY":
            return $ccb8e8f6078d2457$var$ResponseApplySnapshotChunk_Result.RETRY;
        case 4:
        case "RETRY_SNAPSHOT":
            return $ccb8e8f6078d2457$var$ResponseApplySnapshotChunk_Result.RETRY_SNAPSHOT;
        case 5:
        case "REJECT_SNAPSHOT":
            return $ccb8e8f6078d2457$var$ResponseApplySnapshotChunk_Result.REJECT_SNAPSHOT;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $ccb8e8f6078d2457$var$ResponseApplySnapshotChunk_Result.UNRECOGNIZED;
    }
}
module.exports.responseApplySnapshotChunk_ResultFromJSON = $ccb8e8f6078d2457$var$responseApplySnapshotChunk_ResultFromJSON;
function $ccb8e8f6078d2457$var$responseApplySnapshotChunk_ResultToJSON(object) {
    switch(object){
        case $ccb8e8f6078d2457$var$ResponseApplySnapshotChunk_Result.UNKNOWN:
            return "UNKNOWN";
        case $ccb8e8f6078d2457$var$ResponseApplySnapshotChunk_Result.ACCEPT:
            return "ACCEPT";
        case $ccb8e8f6078d2457$var$ResponseApplySnapshotChunk_Result.ABORT:
            return "ABORT";
        case $ccb8e8f6078d2457$var$ResponseApplySnapshotChunk_Result.RETRY:
            return "RETRY";
        case $ccb8e8f6078d2457$var$ResponseApplySnapshotChunk_Result.RETRY_SNAPSHOT:
            return "RETRY_SNAPSHOT";
        case $ccb8e8f6078d2457$var$ResponseApplySnapshotChunk_Result.REJECT_SNAPSHOT:
            return "REJECT_SNAPSHOT";
        default:
            return "UNKNOWN";
    }
}
module.exports.responseApplySnapshotChunk_ResultToJSON = $ccb8e8f6078d2457$var$responseApplySnapshotChunk_ResultToJSON;
const $ccb8e8f6078d2457$var$baseRequest = {};
module.exports.Request = {
    encode (message, writer = $ccb8e8f6078d2457$var$minimal_1.default.Writer.create()) {
        if (message.echo !== undefined) module.exports.RequestEcho.encode(message.echo, writer.uint32(10).fork()).ldelim();
        if (message.flush !== undefined) module.exports.RequestFlush.encode(message.flush, writer.uint32(18).fork()).ldelim();
        if (message.info !== undefined) module.exports.RequestInfo.encode(message.info, writer.uint32(26).fork()).ldelim();
        if (message.setOption !== undefined) module.exports.RequestSetOption.encode(message.setOption, writer.uint32(34).fork()).ldelim();
        if (message.initChain !== undefined) module.exports.RequestInitChain.encode(message.initChain, writer.uint32(42).fork()).ldelim();
        if (message.query !== undefined) module.exports.RequestQuery.encode(message.query, writer.uint32(50).fork()).ldelim();
        if (message.beginBlock !== undefined) module.exports.RequestBeginBlock.encode(message.beginBlock, writer.uint32(58).fork()).ldelim();
        if (message.checkTx !== undefined) module.exports.RequestCheckTx.encode(message.checkTx, writer.uint32(66).fork()).ldelim();
        if (message.deliverTx !== undefined) module.exports.RequestDeliverTx.encode(message.deliverTx, writer.uint32(74).fork()).ldelim();
        if (message.endBlock !== undefined) module.exports.RequestEndBlock.encode(message.endBlock, writer.uint32(82).fork()).ldelim();
        if (message.commit !== undefined) module.exports.RequestCommit.encode(message.commit, writer.uint32(90).fork()).ldelim();
        if (message.listSnapshots !== undefined) module.exports.RequestListSnapshots.encode(message.listSnapshots, writer.uint32(98).fork()).ldelim();
        if (message.offerSnapshot !== undefined) module.exports.RequestOfferSnapshot.encode(message.offerSnapshot, writer.uint32(106).fork()).ldelim();
        if (message.loadSnapshotChunk !== undefined) module.exports.RequestLoadSnapshotChunk.encode(message.loadSnapshotChunk, writer.uint32(114).fork()).ldelim();
        if (message.applySnapshotChunk !== undefined) module.exports.RequestApplySnapshotChunk.encode(message.applySnapshotChunk, writer.uint32(122).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ccb8e8f6078d2457$var$minimal_1.default.Reader ? input : new $ccb8e8f6078d2457$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.echo = module.exports.RequestEcho.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.flush = module.exports.RequestFlush.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.info = module.exports.RequestInfo.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.setOption = module.exports.RequestSetOption.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.initChain = module.exports.RequestInitChain.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.query = module.exports.RequestQuery.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.beginBlock = module.exports.RequestBeginBlock.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.checkTx = module.exports.RequestCheckTx.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.deliverTx = module.exports.RequestDeliverTx.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.endBlock = module.exports.RequestEndBlock.decode(reader, reader.uint32());
                    break;
                case 11:
                    message.commit = module.exports.RequestCommit.decode(reader, reader.uint32());
                    break;
                case 12:
                    message.listSnapshots = module.exports.RequestListSnapshots.decode(reader, reader.uint32());
                    break;
                case 13:
                    message.offerSnapshot = module.exports.RequestOfferSnapshot.decode(reader, reader.uint32());
                    break;
                case 14:
                    message.loadSnapshotChunk = module.exports.RequestLoadSnapshotChunk.decode(reader, reader.uint32());
                    break;
                case 15:
                    message.applySnapshotChunk = module.exports.RequestApplySnapshotChunk.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequest);
        if (object.echo !== undefined && object.echo !== null) message.echo = module.exports.RequestEcho.fromJSON(object.echo);
        else message.echo = undefined;
        if (object.flush !== undefined && object.flush !== null) message.flush = module.exports.RequestFlush.fromJSON(object.flush);
        else message.flush = undefined;
        if (object.info !== undefined && object.info !== null) message.info = module.exports.RequestInfo.fromJSON(object.info);
        else message.info = undefined;
        if (object.setOption !== undefined && object.setOption !== null) message.setOption = module.exports.RequestSetOption.fromJSON(object.setOption);
        else message.setOption = undefined;
        if (object.initChain !== undefined && object.initChain !== null) message.initChain = module.exports.RequestInitChain.fromJSON(object.initChain);
        else message.initChain = undefined;
        if (object.query !== undefined && object.query !== null) message.query = module.exports.RequestQuery.fromJSON(object.query);
        else message.query = undefined;
        if (object.beginBlock !== undefined && object.beginBlock !== null) message.beginBlock = module.exports.RequestBeginBlock.fromJSON(object.beginBlock);
        else message.beginBlock = undefined;
        if (object.checkTx !== undefined && object.checkTx !== null) message.checkTx = module.exports.RequestCheckTx.fromJSON(object.checkTx);
        else message.checkTx = undefined;
        if (object.deliverTx !== undefined && object.deliverTx !== null) message.deliverTx = module.exports.RequestDeliverTx.fromJSON(object.deliverTx);
        else message.deliverTx = undefined;
        if (object.endBlock !== undefined && object.endBlock !== null) message.endBlock = module.exports.RequestEndBlock.fromJSON(object.endBlock);
        else message.endBlock = undefined;
        if (object.commit !== undefined && object.commit !== null) message.commit = module.exports.RequestCommit.fromJSON(object.commit);
        else message.commit = undefined;
        if (object.listSnapshots !== undefined && object.listSnapshots !== null) message.listSnapshots = module.exports.RequestListSnapshots.fromJSON(object.listSnapshots);
        else message.listSnapshots = undefined;
        if (object.offerSnapshot !== undefined && object.offerSnapshot !== null) message.offerSnapshot = module.exports.RequestOfferSnapshot.fromJSON(object.offerSnapshot);
        else message.offerSnapshot = undefined;
        if (object.loadSnapshotChunk !== undefined && object.loadSnapshotChunk !== null) message.loadSnapshotChunk = module.exports.RequestLoadSnapshotChunk.fromJSON(object.loadSnapshotChunk);
        else message.loadSnapshotChunk = undefined;
        if (object.applySnapshotChunk !== undefined && object.applySnapshotChunk !== null) message.applySnapshotChunk = module.exports.RequestApplySnapshotChunk.fromJSON(object.applySnapshotChunk);
        else message.applySnapshotChunk = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.echo !== undefined && (obj.echo = message.echo ? module.exports.RequestEcho.toJSON(message.echo) : undefined);
        message.flush !== undefined && (obj.flush = message.flush ? module.exports.RequestFlush.toJSON(message.flush) : undefined);
        message.info !== undefined && (obj.info = message.info ? module.exports.RequestInfo.toJSON(message.info) : undefined);
        message.setOption !== undefined && (obj.setOption = message.setOption ? module.exports.RequestSetOption.toJSON(message.setOption) : undefined);
        message.initChain !== undefined && (obj.initChain = message.initChain ? module.exports.RequestInitChain.toJSON(message.initChain) : undefined);
        message.query !== undefined && (obj.query = message.query ? module.exports.RequestQuery.toJSON(message.query) : undefined);
        message.beginBlock !== undefined && (obj.beginBlock = message.beginBlock ? module.exports.RequestBeginBlock.toJSON(message.beginBlock) : undefined);
        message.checkTx !== undefined && (obj.checkTx = message.checkTx ? module.exports.RequestCheckTx.toJSON(message.checkTx) : undefined);
        message.deliverTx !== undefined && (obj.deliverTx = message.deliverTx ? module.exports.RequestDeliverTx.toJSON(message.deliverTx) : undefined);
        message.endBlock !== undefined && (obj.endBlock = message.endBlock ? module.exports.RequestEndBlock.toJSON(message.endBlock) : undefined);
        message.commit !== undefined && (obj.commit = message.commit ? module.exports.RequestCommit.toJSON(message.commit) : undefined);
        message.listSnapshots !== undefined && (obj.listSnapshots = message.listSnapshots ? module.exports.RequestListSnapshots.toJSON(message.listSnapshots) : undefined);
        message.offerSnapshot !== undefined && (obj.offerSnapshot = message.offerSnapshot ? module.exports.RequestOfferSnapshot.toJSON(message.offerSnapshot) : undefined);
        message.loadSnapshotChunk !== undefined && (obj.loadSnapshotChunk = message.loadSnapshotChunk ? module.exports.RequestLoadSnapshotChunk.toJSON(message.loadSnapshotChunk) : undefined);
        message.applySnapshotChunk !== undefined && (obj.applySnapshotChunk = message.applySnapshotChunk ? module.exports.RequestApplySnapshotChunk.toJSON(message.applySnapshotChunk) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequest);
        if (object.echo !== undefined && object.echo !== null) message.echo = module.exports.RequestEcho.fromPartial(object.echo);
        else message.echo = undefined;
        if (object.flush !== undefined && object.flush !== null) message.flush = module.exports.RequestFlush.fromPartial(object.flush);
        else message.flush = undefined;
        if (object.info !== undefined && object.info !== null) message.info = module.exports.RequestInfo.fromPartial(object.info);
        else message.info = undefined;
        if (object.setOption !== undefined && object.setOption !== null) message.setOption = module.exports.RequestSetOption.fromPartial(object.setOption);
        else message.setOption = undefined;
        if (object.initChain !== undefined && object.initChain !== null) message.initChain = module.exports.RequestInitChain.fromPartial(object.initChain);
        else message.initChain = undefined;
        if (object.query !== undefined && object.query !== null) message.query = module.exports.RequestQuery.fromPartial(object.query);
        else message.query = undefined;
        if (object.beginBlock !== undefined && object.beginBlock !== null) message.beginBlock = module.exports.RequestBeginBlock.fromPartial(object.beginBlock);
        else message.beginBlock = undefined;
        if (object.checkTx !== undefined && object.checkTx !== null) message.checkTx = module.exports.RequestCheckTx.fromPartial(object.checkTx);
        else message.checkTx = undefined;
        if (object.deliverTx !== undefined && object.deliverTx !== null) message.deliverTx = module.exports.RequestDeliverTx.fromPartial(object.deliverTx);
        else message.deliverTx = undefined;
        if (object.endBlock !== undefined && object.endBlock !== null) message.endBlock = module.exports.RequestEndBlock.fromPartial(object.endBlock);
        else message.endBlock = undefined;
        if (object.commit !== undefined && object.commit !== null) message.commit = module.exports.RequestCommit.fromPartial(object.commit);
        else message.commit = undefined;
        if (object.listSnapshots !== undefined && object.listSnapshots !== null) message.listSnapshots = module.exports.RequestListSnapshots.fromPartial(object.listSnapshots);
        else message.listSnapshots = undefined;
        if (object.offerSnapshot !== undefined && object.offerSnapshot !== null) message.offerSnapshot = module.exports.RequestOfferSnapshot.fromPartial(object.offerSnapshot);
        else message.offerSnapshot = undefined;
        if (object.loadSnapshotChunk !== undefined && object.loadSnapshotChunk !== null) message.loadSnapshotChunk = module.exports.RequestLoadSnapshotChunk.fromPartial(object.loadSnapshotChunk);
        else message.loadSnapshotChunk = undefined;
        if (object.applySnapshotChunk !== undefined && object.applySnapshotChunk !== null) message.applySnapshotChunk = module.exports.RequestApplySnapshotChunk.fromPartial(object.applySnapshotChunk);
        else message.applySnapshotChunk = undefined;
        return message;
    }
};
const $ccb8e8f6078d2457$var$baseRequestEcho = {
    message: ""
};
module.exports.RequestEcho = {
    encode (message, writer = $ccb8e8f6078d2457$var$minimal_1.default.Writer.create()) {
        if (message.message !== "") writer.uint32(10).string(message.message);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ccb8e8f6078d2457$var$minimal_1.default.Reader ? input : new $ccb8e8f6078d2457$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestEcho);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.message = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestEcho);
        if (object.message !== undefined && object.message !== null) message.message = String(object.message);
        else message.message = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.message !== undefined && (obj.message = message.message);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestEcho);
        if (object.message !== undefined && object.message !== null) message.message = object.message;
        else message.message = "";
        return message;
    }
};
const $ccb8e8f6078d2457$var$baseRequestFlush = {};
module.exports.RequestFlush = {
    encode (_, writer = $ccb8e8f6078d2457$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ccb8e8f6078d2457$var$minimal_1.default.Reader ? input : new $ccb8e8f6078d2457$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestFlush);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestFlush);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestFlush);
        return message;
    }
};
const $ccb8e8f6078d2457$var$baseRequestInfo = {
    version: "",
    blockVersion: $ccb8e8f6078d2457$var$long_1.default.UZERO,
    p2pVersion: $ccb8e8f6078d2457$var$long_1.default.UZERO
};
module.exports.RequestInfo = {
    encode (message, writer = $ccb8e8f6078d2457$var$minimal_1.default.Writer.create()) {
        if (message.version !== "") writer.uint32(10).string(message.version);
        if (!message.blockVersion.isZero()) writer.uint32(16).uint64(message.blockVersion);
        if (!message.p2pVersion.isZero()) writer.uint32(24).uint64(message.p2pVersion);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ccb8e8f6078d2457$var$minimal_1.default.Reader ? input : new $ccb8e8f6078d2457$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestInfo);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.version = reader.string();
                    break;
                case 2:
                    message.blockVersion = reader.uint64();
                    break;
                case 3:
                    message.p2pVersion = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestInfo);
        if (object.version !== undefined && object.version !== null) message.version = String(object.version);
        else message.version = "";
        if (object.blockVersion !== undefined && object.blockVersion !== null) message.blockVersion = $ccb8e8f6078d2457$var$long_1.default.fromString(object.blockVersion);
        else message.blockVersion = $ccb8e8f6078d2457$var$long_1.default.UZERO;
        if (object.p2pVersion !== undefined && object.p2pVersion !== null) message.p2pVersion = $ccb8e8f6078d2457$var$long_1.default.fromString(object.p2pVersion);
        else message.p2pVersion = $ccb8e8f6078d2457$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.version !== undefined && (obj.version = message.version);
        message.blockVersion !== undefined && (obj.blockVersion = (message.blockVersion || $ccb8e8f6078d2457$var$long_1.default.UZERO).toString());
        message.p2pVersion !== undefined && (obj.p2pVersion = (message.p2pVersion || $ccb8e8f6078d2457$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestInfo);
        if (object.version !== undefined && object.version !== null) message.version = object.version;
        else message.version = "";
        if (object.blockVersion !== undefined && object.blockVersion !== null) message.blockVersion = object.blockVersion;
        else message.blockVersion = $ccb8e8f6078d2457$var$long_1.default.UZERO;
        if (object.p2pVersion !== undefined && object.p2pVersion !== null) message.p2pVersion = object.p2pVersion;
        else message.p2pVersion = $ccb8e8f6078d2457$var$long_1.default.UZERO;
        return message;
    }
};
const $ccb8e8f6078d2457$var$baseRequestSetOption = {
    key: "",
    value: ""
};
module.exports.RequestSetOption = {
    encode (message, writer = $ccb8e8f6078d2457$var$minimal_1.default.Writer.create()) {
        if (message.key !== "") writer.uint32(10).string(message.key);
        if (message.value !== "") writer.uint32(18).string(message.value);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ccb8e8f6078d2457$var$minimal_1.default.Reader ? input : new $ccb8e8f6078d2457$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestSetOption);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.value = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestSetOption);
        if (object.key !== undefined && object.key !== null) message.key = String(object.key);
        else message.key = "";
        if (object.value !== undefined && object.value !== null) message.value = String(object.value);
        else message.value = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = message.key);
        message.value !== undefined && (obj.value = message.value);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestSetOption);
        if (object.key !== undefined && object.key !== null) message.key = object.key;
        else message.key = "";
        if (object.value !== undefined && object.value !== null) message.value = object.value;
        else message.value = "";
        return message;
    }
};
const $ccb8e8f6078d2457$var$baseRequestInitChain = {
    chainId: "",
    initialHeight: $ccb8e8f6078d2457$var$long_1.default.ZERO
};
module.exports.RequestInitChain = {
    encode (message, writer = $ccb8e8f6078d2457$var$minimal_1.default.Writer.create()) {
        if (message.time !== undefined) $5G2s6.Timestamp.encode($ccb8e8f6078d2457$var$toTimestamp(message.time), writer.uint32(10).fork()).ldelim();
        if (message.chainId !== "") writer.uint32(18).string(message.chainId);
        if (message.consensusParams !== undefined) module.exports.ConsensusParams.encode(message.consensusParams, writer.uint32(26).fork()).ldelim();
        for (const v of message.validators)module.exports.ValidatorUpdate.encode(v, writer.uint32(34).fork()).ldelim();
        if (message.appStateBytes.length !== 0) writer.uint32(42).bytes(message.appStateBytes);
        if (!message.initialHeight.isZero()) writer.uint32(48).int64(message.initialHeight);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ccb8e8f6078d2457$var$minimal_1.default.Reader ? input : new $ccb8e8f6078d2457$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestInitChain);
        message.validators = [];
        message.appStateBytes = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.time = $ccb8e8f6078d2457$var$fromTimestamp($5G2s6.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.chainId = reader.string();
                    break;
                case 3:
                    message.consensusParams = module.exports.ConsensusParams.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.validators.push(module.exports.ValidatorUpdate.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.appStateBytes = reader.bytes();
                    break;
                case 6:
                    message.initialHeight = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestInitChain);
        message.validators = [];
        message.appStateBytes = new Uint8Array();
        if (object.time !== undefined && object.time !== null) message.time = $ccb8e8f6078d2457$var$fromJsonTimestamp(object.time);
        else message.time = undefined;
        if (object.chainId !== undefined && object.chainId !== null) message.chainId = String(object.chainId);
        else message.chainId = "";
        if (object.consensusParams !== undefined && object.consensusParams !== null) message.consensusParams = module.exports.ConsensusParams.fromJSON(object.consensusParams);
        else message.consensusParams = undefined;
        if (object.validators !== undefined && object.validators !== null) for (const e of object.validators)message.validators.push(module.exports.ValidatorUpdate.fromJSON(e));
        if (object.appStateBytes !== undefined && object.appStateBytes !== null) message.appStateBytes = $ccb8e8f6078d2457$var$bytesFromBase64(object.appStateBytes);
        if (object.initialHeight !== undefined && object.initialHeight !== null) message.initialHeight = $ccb8e8f6078d2457$var$long_1.default.fromString(object.initialHeight);
        else message.initialHeight = $ccb8e8f6078d2457$var$long_1.default.ZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.time !== undefined && (obj.time = message.time.toISOString());
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.consensusParams !== undefined && (obj.consensusParams = message.consensusParams ? module.exports.ConsensusParams.toJSON(message.consensusParams) : undefined);
        if (message.validators) obj.validators = message.validators.map((e)=>e ? module.exports.ValidatorUpdate.toJSON(e) : undefined);
        else obj.validators = [];
        message.appStateBytes !== undefined && (obj.appStateBytes = $ccb8e8f6078d2457$var$base64FromBytes(message.appStateBytes !== undefined ? message.appStateBytes : new Uint8Array()));
        message.initialHeight !== undefined && (obj.initialHeight = (message.initialHeight || $ccb8e8f6078d2457$var$long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestInitChain);
        message.validators = [];
        if (object.time !== undefined && object.time !== null) message.time = object.time;
        else message.time = undefined;
        if (object.chainId !== undefined && object.chainId !== null) message.chainId = object.chainId;
        else message.chainId = "";
        if (object.consensusParams !== undefined && object.consensusParams !== null) message.consensusParams = module.exports.ConsensusParams.fromPartial(object.consensusParams);
        else message.consensusParams = undefined;
        if (object.validators !== undefined && object.validators !== null) for (const e of object.validators)message.validators.push(module.exports.ValidatorUpdate.fromPartial(e));
        if (object.appStateBytes !== undefined && object.appStateBytes !== null) message.appStateBytes = object.appStateBytes;
        else message.appStateBytes = new Uint8Array();
        if (object.initialHeight !== undefined && object.initialHeight !== null) message.initialHeight = object.initialHeight;
        else message.initialHeight = $ccb8e8f6078d2457$var$long_1.default.ZERO;
        return message;
    }
};
const $ccb8e8f6078d2457$var$baseRequestQuery = {
    path: "",
    height: $ccb8e8f6078d2457$var$long_1.default.ZERO,
    prove: false
};
module.exports.RequestQuery = {
    encode (message, writer = $ccb8e8f6078d2457$var$minimal_1.default.Writer.create()) {
        if (message.data.length !== 0) writer.uint32(10).bytes(message.data);
        if (message.path !== "") writer.uint32(18).string(message.path);
        if (!message.height.isZero()) writer.uint32(24).int64(message.height);
        if (message.prove === true) writer.uint32(32).bool(message.prove);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ccb8e8f6078d2457$var$minimal_1.default.Reader ? input : new $ccb8e8f6078d2457$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestQuery);
        message.data = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.data = reader.bytes();
                    break;
                case 2:
                    message.path = reader.string();
                    break;
                case 3:
                    message.height = reader.int64();
                    break;
                case 4:
                    message.prove = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestQuery);
        message.data = new Uint8Array();
        if (object.data !== undefined && object.data !== null) message.data = $ccb8e8f6078d2457$var$bytesFromBase64(object.data);
        if (object.path !== undefined && object.path !== null) message.path = String(object.path);
        else message.path = "";
        if (object.height !== undefined && object.height !== null) message.height = $ccb8e8f6078d2457$var$long_1.default.fromString(object.height);
        else message.height = $ccb8e8f6078d2457$var$long_1.default.ZERO;
        if (object.prove !== undefined && object.prove !== null) message.prove = Boolean(object.prove);
        else message.prove = false;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.data !== undefined && (obj.data = $ccb8e8f6078d2457$var$base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        message.path !== undefined && (obj.path = message.path);
        message.height !== undefined && (obj.height = (message.height || $ccb8e8f6078d2457$var$long_1.default.ZERO).toString());
        message.prove !== undefined && (obj.prove = message.prove);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestQuery);
        if (object.data !== undefined && object.data !== null) message.data = object.data;
        else message.data = new Uint8Array();
        if (object.path !== undefined && object.path !== null) message.path = object.path;
        else message.path = "";
        if (object.height !== undefined && object.height !== null) message.height = object.height;
        else message.height = $ccb8e8f6078d2457$var$long_1.default.ZERO;
        if (object.prove !== undefined && object.prove !== null) message.prove = object.prove;
        else message.prove = false;
        return message;
    }
};
const $ccb8e8f6078d2457$var$baseRequestBeginBlock = {};
module.exports.RequestBeginBlock = {
    encode (message, writer = $ccb8e8f6078d2457$var$minimal_1.default.Writer.create()) {
        if (message.hash.length !== 0) writer.uint32(10).bytes(message.hash);
        if (message.header !== undefined) $djDW6.Header.encode(message.header, writer.uint32(18).fork()).ldelim();
        if (message.lastCommitInfo !== undefined) module.exports.LastCommitInfo.encode(message.lastCommitInfo, writer.uint32(26).fork()).ldelim();
        for (const v of message.byzantineValidators)module.exports.Evidence.encode(v, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ccb8e8f6078d2457$var$minimal_1.default.Reader ? input : new $ccb8e8f6078d2457$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestBeginBlock);
        message.byzantineValidators = [];
        message.hash = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.bytes();
                    break;
                case 2:
                    message.header = $djDW6.Header.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.lastCommitInfo = module.exports.LastCommitInfo.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.byzantineValidators.push(module.exports.Evidence.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestBeginBlock);
        message.byzantineValidators = [];
        message.hash = new Uint8Array();
        if (object.hash !== undefined && object.hash !== null) message.hash = $ccb8e8f6078d2457$var$bytesFromBase64(object.hash);
        if (object.header !== undefined && object.header !== null) message.header = $djDW6.Header.fromJSON(object.header);
        else message.header = undefined;
        if (object.lastCommitInfo !== undefined && object.lastCommitInfo !== null) message.lastCommitInfo = module.exports.LastCommitInfo.fromJSON(object.lastCommitInfo);
        else message.lastCommitInfo = undefined;
        if (object.byzantineValidators !== undefined && object.byzantineValidators !== null) for (const e of object.byzantineValidators)message.byzantineValidators.push(module.exports.Evidence.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = $ccb8e8f6078d2457$var$base64FromBytes(message.hash !== undefined ? message.hash : new Uint8Array()));
        message.header !== undefined && (obj.header = message.header ? $djDW6.Header.toJSON(message.header) : undefined);
        message.lastCommitInfo !== undefined && (obj.lastCommitInfo = message.lastCommitInfo ? module.exports.LastCommitInfo.toJSON(message.lastCommitInfo) : undefined);
        if (message.byzantineValidators) obj.byzantineValidators = message.byzantineValidators.map((e)=>e ? module.exports.Evidence.toJSON(e) : undefined);
        else obj.byzantineValidators = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestBeginBlock);
        message.byzantineValidators = [];
        if (object.hash !== undefined && object.hash !== null) message.hash = object.hash;
        else message.hash = new Uint8Array();
        if (object.header !== undefined && object.header !== null) message.header = $djDW6.Header.fromPartial(object.header);
        else message.header = undefined;
        if (object.lastCommitInfo !== undefined && object.lastCommitInfo !== null) message.lastCommitInfo = module.exports.LastCommitInfo.fromPartial(object.lastCommitInfo);
        else message.lastCommitInfo = undefined;
        if (object.byzantineValidators !== undefined && object.byzantineValidators !== null) for (const e of object.byzantineValidators)message.byzantineValidators.push(module.exports.Evidence.fromPartial(e));
        return message;
    }
};
const $ccb8e8f6078d2457$var$baseRequestCheckTx = {
    type: 0
};
module.exports.RequestCheckTx = {
    encode (message, writer = $ccb8e8f6078d2457$var$minimal_1.default.Writer.create()) {
        if (message.tx.length !== 0) writer.uint32(10).bytes(message.tx);
        if (message.type !== 0) writer.uint32(16).int32(message.type);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ccb8e8f6078d2457$var$minimal_1.default.Reader ? input : new $ccb8e8f6078d2457$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestCheckTx);
        message.tx = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.tx = reader.bytes();
                    break;
                case 2:
                    message.type = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestCheckTx);
        message.tx = new Uint8Array();
        if (object.tx !== undefined && object.tx !== null) message.tx = $ccb8e8f6078d2457$var$bytesFromBase64(object.tx);
        if (object.type !== undefined && object.type !== null) message.type = $ccb8e8f6078d2457$var$checkTxTypeFromJSON(object.type);
        else message.type = 0;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.tx !== undefined && (obj.tx = $ccb8e8f6078d2457$var$base64FromBytes(message.tx !== undefined ? message.tx : new Uint8Array()));
        message.type !== undefined && (obj.type = $ccb8e8f6078d2457$var$checkTxTypeToJSON(message.type));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestCheckTx);
        if (object.tx !== undefined && object.tx !== null) message.tx = object.tx;
        else message.tx = new Uint8Array();
        if (object.type !== undefined && object.type !== null) message.type = object.type;
        else message.type = 0;
        return message;
    }
};
const $ccb8e8f6078d2457$var$baseRequestDeliverTx = {};
module.exports.RequestDeliverTx = {
    encode (message, writer = $ccb8e8f6078d2457$var$minimal_1.default.Writer.create()) {
        if (message.tx.length !== 0) writer.uint32(10).bytes(message.tx);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ccb8e8f6078d2457$var$minimal_1.default.Reader ? input : new $ccb8e8f6078d2457$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestDeliverTx);
        message.tx = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.tx = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestDeliverTx);
        message.tx = new Uint8Array();
        if (object.tx !== undefined && object.tx !== null) message.tx = $ccb8e8f6078d2457$var$bytesFromBase64(object.tx);
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.tx !== undefined && (obj.tx = $ccb8e8f6078d2457$var$base64FromBytes(message.tx !== undefined ? message.tx : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestDeliverTx);
        if (object.tx !== undefined && object.tx !== null) message.tx = object.tx;
        else message.tx = new Uint8Array();
        return message;
    }
};
const $ccb8e8f6078d2457$var$baseRequestEndBlock = {
    height: $ccb8e8f6078d2457$var$long_1.default.ZERO
};
module.exports.RequestEndBlock = {
    encode (message, writer = $ccb8e8f6078d2457$var$minimal_1.default.Writer.create()) {
        if (!message.height.isZero()) writer.uint32(8).int64(message.height);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ccb8e8f6078d2457$var$minimal_1.default.Reader ? input : new $ccb8e8f6078d2457$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestEndBlock);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestEndBlock);
        if (object.height !== undefined && object.height !== null) message.height = $ccb8e8f6078d2457$var$long_1.default.fromString(object.height);
        else message.height = $ccb8e8f6078d2457$var$long_1.default.ZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || $ccb8e8f6078d2457$var$long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestEndBlock);
        if (object.height !== undefined && object.height !== null) message.height = object.height;
        else message.height = $ccb8e8f6078d2457$var$long_1.default.ZERO;
        return message;
    }
};
const $ccb8e8f6078d2457$var$baseRequestCommit = {};
module.exports.RequestCommit = {
    encode (_, writer = $ccb8e8f6078d2457$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ccb8e8f6078d2457$var$minimal_1.default.Reader ? input : new $ccb8e8f6078d2457$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestCommit);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestCommit);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestCommit);
        return message;
    }
};
const $ccb8e8f6078d2457$var$baseRequestListSnapshots = {};
module.exports.RequestListSnapshots = {
    encode (_, writer = $ccb8e8f6078d2457$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ccb8e8f6078d2457$var$minimal_1.default.Reader ? input : new $ccb8e8f6078d2457$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestListSnapshots);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestListSnapshots);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestListSnapshots);
        return message;
    }
};
const $ccb8e8f6078d2457$var$baseRequestOfferSnapshot = {};
module.exports.RequestOfferSnapshot = {
    encode (message, writer = $ccb8e8f6078d2457$var$minimal_1.default.Writer.create()) {
        if (message.snapshot !== undefined) module.exports.Snapshot.encode(message.snapshot, writer.uint32(10).fork()).ldelim();
        if (message.appHash.length !== 0) writer.uint32(18).bytes(message.appHash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ccb8e8f6078d2457$var$minimal_1.default.Reader ? input : new $ccb8e8f6078d2457$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestOfferSnapshot);
        message.appHash = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.snapshot = module.exports.Snapshot.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.appHash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestOfferSnapshot);
        message.appHash = new Uint8Array();
        if (object.snapshot !== undefined && object.snapshot !== null) message.snapshot = module.exports.Snapshot.fromJSON(object.snapshot);
        else message.snapshot = undefined;
        if (object.appHash !== undefined && object.appHash !== null) message.appHash = $ccb8e8f6078d2457$var$bytesFromBase64(object.appHash);
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.snapshot !== undefined && (obj.snapshot = message.snapshot ? module.exports.Snapshot.toJSON(message.snapshot) : undefined);
        message.appHash !== undefined && (obj.appHash = $ccb8e8f6078d2457$var$base64FromBytes(message.appHash !== undefined ? message.appHash : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestOfferSnapshot);
        if (object.snapshot !== undefined && object.snapshot !== null) message.snapshot = module.exports.Snapshot.fromPartial(object.snapshot);
        else message.snapshot = undefined;
        if (object.appHash !== undefined && object.appHash !== null) message.appHash = object.appHash;
        else message.appHash = new Uint8Array();
        return message;
    }
};
const $ccb8e8f6078d2457$var$baseRequestLoadSnapshotChunk = {
    height: $ccb8e8f6078d2457$var$long_1.default.UZERO,
    format: 0,
    chunk: 0
};
module.exports.RequestLoadSnapshotChunk = {
    encode (message, writer = $ccb8e8f6078d2457$var$minimal_1.default.Writer.create()) {
        if (!message.height.isZero()) writer.uint32(8).uint64(message.height);
        if (message.format !== 0) writer.uint32(16).uint32(message.format);
        if (message.chunk !== 0) writer.uint32(24).uint32(message.chunk);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ccb8e8f6078d2457$var$minimal_1.default.Reader ? input : new $ccb8e8f6078d2457$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestLoadSnapshotChunk);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.uint64();
                    break;
                case 2:
                    message.format = reader.uint32();
                    break;
                case 3:
                    message.chunk = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestLoadSnapshotChunk);
        if (object.height !== undefined && object.height !== null) message.height = $ccb8e8f6078d2457$var$long_1.default.fromString(object.height);
        else message.height = $ccb8e8f6078d2457$var$long_1.default.UZERO;
        if (object.format !== undefined && object.format !== null) message.format = Number(object.format);
        else message.format = 0;
        if (object.chunk !== undefined && object.chunk !== null) message.chunk = Number(object.chunk);
        else message.chunk = 0;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || $ccb8e8f6078d2457$var$long_1.default.UZERO).toString());
        message.format !== undefined && (obj.format = message.format);
        message.chunk !== undefined && (obj.chunk = message.chunk);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestLoadSnapshotChunk);
        if (object.height !== undefined && object.height !== null) message.height = object.height;
        else message.height = $ccb8e8f6078d2457$var$long_1.default.UZERO;
        if (object.format !== undefined && object.format !== null) message.format = object.format;
        else message.format = 0;
        if (object.chunk !== undefined && object.chunk !== null) message.chunk = object.chunk;
        else message.chunk = 0;
        return message;
    }
};
const $ccb8e8f6078d2457$var$baseRequestApplySnapshotChunk = {
    index: 0,
    sender: ""
};
module.exports.RequestApplySnapshotChunk = {
    encode (message, writer = $ccb8e8f6078d2457$var$minimal_1.default.Writer.create()) {
        if (message.index !== 0) writer.uint32(8).uint32(message.index);
        if (message.chunk.length !== 0) writer.uint32(18).bytes(message.chunk);
        if (message.sender !== "") writer.uint32(26).string(message.sender);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ccb8e8f6078d2457$var$minimal_1.default.Reader ? input : new $ccb8e8f6078d2457$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestApplySnapshotChunk);
        message.chunk = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.index = reader.uint32();
                    break;
                case 2:
                    message.chunk = reader.bytes();
                    break;
                case 3:
                    message.sender = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestApplySnapshotChunk);
        message.chunk = new Uint8Array();
        if (object.index !== undefined && object.index !== null) message.index = Number(object.index);
        else message.index = 0;
        if (object.chunk !== undefined && object.chunk !== null) message.chunk = $ccb8e8f6078d2457$var$bytesFromBase64(object.chunk);
        if (object.sender !== undefined && object.sender !== null) message.sender = String(object.sender);
        else message.sender = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.index !== undefined && (obj.index = message.index);
        message.chunk !== undefined && (obj.chunk = $ccb8e8f6078d2457$var$base64FromBytes(message.chunk !== undefined ? message.chunk : new Uint8Array()));
        message.sender !== undefined && (obj.sender = message.sender);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseRequestApplySnapshotChunk);
        if (object.index !== undefined && object.index !== null) message.index = object.index;
        else message.index = 0;
        if (object.chunk !== undefined && object.chunk !== null) message.chunk = object.chunk;
        else message.chunk = new Uint8Array();
        if (object.sender !== undefined && object.sender !== null) message.sender = object.sender;
        else message.sender = "";
        return message;
    }
};
const $ccb8e8f6078d2457$var$baseResponse = {};
module.exports.Response = {
    encode (message, writer = $ccb8e8f6078d2457$var$minimal_1.default.Writer.create()) {
        if (message.exception !== undefined) module.exports.ResponseException.encode(message.exception, writer.uint32(10).fork()).ldelim();
        if (message.echo !== undefined) module.exports.ResponseEcho.encode(message.echo, writer.uint32(18).fork()).ldelim();
        if (message.flush !== undefined) module.exports.ResponseFlush.encode(message.flush, writer.uint32(26).fork()).ldelim();
        if (message.info !== undefined) module.exports.ResponseInfo.encode(message.info, writer.uint32(34).fork()).ldelim();
        if (message.setOption !== undefined) module.exports.ResponseSetOption.encode(message.setOption, writer.uint32(42).fork()).ldelim();
        if (message.initChain !== undefined) module.exports.ResponseInitChain.encode(message.initChain, writer.uint32(50).fork()).ldelim();
        if (message.query !== undefined) module.exports.ResponseQuery.encode(message.query, writer.uint32(58).fork()).ldelim();
        if (message.beginBlock !== undefined) module.exports.ResponseBeginBlock.encode(message.beginBlock, writer.uint32(66).fork()).ldelim();
        if (message.checkTx !== undefined) module.exports.ResponseCheckTx.encode(message.checkTx, writer.uint32(74).fork()).ldelim();
        if (message.deliverTx !== undefined) module.exports.ResponseDeliverTx.encode(message.deliverTx, writer.uint32(82).fork()).ldelim();
        if (message.endBlock !== undefined) module.exports.ResponseEndBlock.encode(message.endBlock, writer.uint32(90).fork()).ldelim();
        if (message.commit !== undefined) module.exports.ResponseCommit.encode(message.commit, writer.uint32(98).fork()).ldelim();
        if (message.listSnapshots !== undefined) module.exports.ResponseListSnapshots.encode(message.listSnapshots, writer.uint32(106).fork()).ldelim();
        if (message.offerSnapshot !== undefined) module.exports.ResponseOfferSnapshot.encode(message.offerSnapshot, writer.uint32(114).fork()).ldelim();
        if (message.loadSnapshotChunk !== undefined) module.exports.ResponseLoadSnapshotChunk.encode(message.loadSnapshotChunk, writer.uint32(122).fork()).ldelim();
        if (message.applySnapshotChunk !== undefined) module.exports.ResponseApplySnapshotChunk.encode(message.applySnapshotChunk, writer.uint32(130).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ccb8e8f6078d2457$var$minimal_1.default.Reader ? input : new $ccb8e8f6078d2457$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.exception = module.exports.ResponseException.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.echo = module.exports.ResponseEcho.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.flush = module.exports.ResponseFlush.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.info = module.exports.ResponseInfo.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.setOption = module.exports.ResponseSetOption.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.initChain = module.exports.ResponseInitChain.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.query = module.exports.ResponseQuery.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.beginBlock = module.exports.ResponseBeginBlock.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.checkTx = module.exports.ResponseCheckTx.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.deliverTx = module.exports.ResponseDeliverTx.decode(reader, reader.uint32());
                    break;
                case 11:
                    message.endBlock = module.exports.ResponseEndBlock.decode(reader, reader.uint32());
                    break;
                case 12:
                    message.commit = module.exports.ResponseCommit.decode(reader, reader.uint32());
                    break;
                case 13:
                    message.listSnapshots = module.exports.ResponseListSnapshots.decode(reader, reader.uint32());
                    break;
                case 14:
                    message.offerSnapshot = module.exports.ResponseOfferSnapshot.decode(reader, reader.uint32());
                    break;
                case 15:
                    message.loadSnapshotChunk = module.exports.ResponseLoadSnapshotChunk.decode(reader, reader.uint32());
                    break;
                case 16:
                    message.applySnapshotChunk = module.exports.ResponseApplySnapshotChunk.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponse);
        if (object.exception !== undefined && object.exception !== null) message.exception = module.exports.ResponseException.fromJSON(object.exception);
        else message.exception = undefined;
        if (object.echo !== undefined && object.echo !== null) message.echo = module.exports.ResponseEcho.fromJSON(object.echo);
        else message.echo = undefined;
        if (object.flush !== undefined && object.flush !== null) message.flush = module.exports.ResponseFlush.fromJSON(object.flush);
        else message.flush = undefined;
        if (object.info !== undefined && object.info !== null) message.info = module.exports.ResponseInfo.fromJSON(object.info);
        else message.info = undefined;
        if (object.setOption !== undefined && object.setOption !== null) message.setOption = module.exports.ResponseSetOption.fromJSON(object.setOption);
        else message.setOption = undefined;
        if (object.initChain !== undefined && object.initChain !== null) message.initChain = module.exports.ResponseInitChain.fromJSON(object.initChain);
        else message.initChain = undefined;
        if (object.query !== undefined && object.query !== null) message.query = module.exports.ResponseQuery.fromJSON(object.query);
        else message.query = undefined;
        if (object.beginBlock !== undefined && object.beginBlock !== null) message.beginBlock = module.exports.ResponseBeginBlock.fromJSON(object.beginBlock);
        else message.beginBlock = undefined;
        if (object.checkTx !== undefined && object.checkTx !== null) message.checkTx = module.exports.ResponseCheckTx.fromJSON(object.checkTx);
        else message.checkTx = undefined;
        if (object.deliverTx !== undefined && object.deliverTx !== null) message.deliverTx = module.exports.ResponseDeliverTx.fromJSON(object.deliverTx);
        else message.deliverTx = undefined;
        if (object.endBlock !== undefined && object.endBlock !== null) message.endBlock = module.exports.ResponseEndBlock.fromJSON(object.endBlock);
        else message.endBlock = undefined;
        if (object.commit !== undefined && object.commit !== null) message.commit = module.exports.ResponseCommit.fromJSON(object.commit);
        else message.commit = undefined;
        if (object.listSnapshots !== undefined && object.listSnapshots !== null) message.listSnapshots = module.exports.ResponseListSnapshots.fromJSON(object.listSnapshots);
        else message.listSnapshots = undefined;
        if (object.offerSnapshot !== undefined && object.offerSnapshot !== null) message.offerSnapshot = module.exports.ResponseOfferSnapshot.fromJSON(object.offerSnapshot);
        else message.offerSnapshot = undefined;
        if (object.loadSnapshotChunk !== undefined && object.loadSnapshotChunk !== null) message.loadSnapshotChunk = module.exports.ResponseLoadSnapshotChunk.fromJSON(object.loadSnapshotChunk);
        else message.loadSnapshotChunk = undefined;
        if (object.applySnapshotChunk !== undefined && object.applySnapshotChunk !== null) message.applySnapshotChunk = module.exports.ResponseApplySnapshotChunk.fromJSON(object.applySnapshotChunk);
        else message.applySnapshotChunk = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.exception !== undefined && (obj.exception = message.exception ? module.exports.ResponseException.toJSON(message.exception) : undefined);
        message.echo !== undefined && (obj.echo = message.echo ? module.exports.ResponseEcho.toJSON(message.echo) : undefined);
        message.flush !== undefined && (obj.flush = message.flush ? module.exports.ResponseFlush.toJSON(message.flush) : undefined);
        message.info !== undefined && (obj.info = message.info ? module.exports.ResponseInfo.toJSON(message.info) : undefined);
        message.setOption !== undefined && (obj.setOption = message.setOption ? module.exports.ResponseSetOption.toJSON(message.setOption) : undefined);
        message.initChain !== undefined && (obj.initChain = message.initChain ? module.exports.ResponseInitChain.toJSON(message.initChain) : undefined);
        message.query !== undefined && (obj.query = message.query ? module.exports.ResponseQuery.toJSON(message.query) : undefined);
        message.beginBlock !== undefined && (obj.beginBlock = message.beginBlock ? module.exports.ResponseBeginBlock.toJSON(message.beginBlock) : undefined);
        message.checkTx !== undefined && (obj.checkTx = message.checkTx ? module.exports.ResponseCheckTx.toJSON(message.checkTx) : undefined);
        message.deliverTx !== undefined && (obj.deliverTx = message.deliverTx ? module.exports.ResponseDeliverTx.toJSON(message.deliverTx) : undefined);
        message.endBlock !== undefined && (obj.endBlock = message.endBlock ? module.exports.ResponseEndBlock.toJSON(message.endBlock) : undefined);
        message.commit !== undefined && (obj.commit = message.commit ? module.exports.ResponseCommit.toJSON(message.commit) : undefined);
        message.listSnapshots !== undefined && (obj.listSnapshots = message.listSnapshots ? module.exports.ResponseListSnapshots.toJSON(message.listSnapshots) : undefined);
        message.offerSnapshot !== undefined && (obj.offerSnapshot = message.offerSnapshot ? module.exports.ResponseOfferSnapshot.toJSON(message.offerSnapshot) : undefined);
        message.loadSnapshotChunk !== undefined && (obj.loadSnapshotChunk = message.loadSnapshotChunk ? module.exports.ResponseLoadSnapshotChunk.toJSON(message.loadSnapshotChunk) : undefined);
        message.applySnapshotChunk !== undefined && (obj.applySnapshotChunk = message.applySnapshotChunk ? module.exports.ResponseApplySnapshotChunk.toJSON(message.applySnapshotChunk) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponse);
        if (object.exception !== undefined && object.exception !== null) message.exception = module.exports.ResponseException.fromPartial(object.exception);
        else message.exception = undefined;
        if (object.echo !== undefined && object.echo !== null) message.echo = module.exports.ResponseEcho.fromPartial(object.echo);
        else message.echo = undefined;
        if (object.flush !== undefined && object.flush !== null) message.flush = module.exports.ResponseFlush.fromPartial(object.flush);
        else message.flush = undefined;
        if (object.info !== undefined && object.info !== null) message.info = module.exports.ResponseInfo.fromPartial(object.info);
        else message.info = undefined;
        if (object.setOption !== undefined && object.setOption !== null) message.setOption = module.exports.ResponseSetOption.fromPartial(object.setOption);
        else message.setOption = undefined;
        if (object.initChain !== undefined && object.initChain !== null) message.initChain = module.exports.ResponseInitChain.fromPartial(object.initChain);
        else message.initChain = undefined;
        if (object.query !== undefined && object.query !== null) message.query = module.exports.ResponseQuery.fromPartial(object.query);
        else message.query = undefined;
        if (object.beginBlock !== undefined && object.beginBlock !== null) message.beginBlock = module.exports.ResponseBeginBlock.fromPartial(object.beginBlock);
        else message.beginBlock = undefined;
        if (object.checkTx !== undefined && object.checkTx !== null) message.checkTx = module.exports.ResponseCheckTx.fromPartial(object.checkTx);
        else message.checkTx = undefined;
        if (object.deliverTx !== undefined && object.deliverTx !== null) message.deliverTx = module.exports.ResponseDeliverTx.fromPartial(object.deliverTx);
        else message.deliverTx = undefined;
        if (object.endBlock !== undefined && object.endBlock !== null) message.endBlock = module.exports.ResponseEndBlock.fromPartial(object.endBlock);
        else message.endBlock = undefined;
        if (object.commit !== undefined && object.commit !== null) message.commit = module.exports.ResponseCommit.fromPartial(object.commit);
        else message.commit = undefined;
        if (object.listSnapshots !== undefined && object.listSnapshots !== null) message.listSnapshots = module.exports.ResponseListSnapshots.fromPartial(object.listSnapshots);
        else message.listSnapshots = undefined;
        if (object.offerSnapshot !== undefined && object.offerSnapshot !== null) message.offerSnapshot = module.exports.ResponseOfferSnapshot.fromPartial(object.offerSnapshot);
        else message.offerSnapshot = undefined;
        if (object.loadSnapshotChunk !== undefined && object.loadSnapshotChunk !== null) message.loadSnapshotChunk = module.exports.ResponseLoadSnapshotChunk.fromPartial(object.loadSnapshotChunk);
        else message.loadSnapshotChunk = undefined;
        if (object.applySnapshotChunk !== undefined && object.applySnapshotChunk !== null) message.applySnapshotChunk = module.exports.ResponseApplySnapshotChunk.fromPartial(object.applySnapshotChunk);
        else message.applySnapshotChunk = undefined;
        return message;
    }
};
const $ccb8e8f6078d2457$var$baseResponseException = {
    error: ""
};
module.exports.ResponseException = {
    encode (message, writer = $ccb8e8f6078d2457$var$minimal_1.default.Writer.create()) {
        if (message.error !== "") writer.uint32(10).string(message.error);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ccb8e8f6078d2457$var$minimal_1.default.Reader ? input : new $ccb8e8f6078d2457$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseException);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.error = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseException);
        if (object.error !== undefined && object.error !== null) message.error = String(object.error);
        else message.error = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.error !== undefined && (obj.error = message.error);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseException);
        if (object.error !== undefined && object.error !== null) message.error = object.error;
        else message.error = "";
        return message;
    }
};
const $ccb8e8f6078d2457$var$baseResponseEcho = {
    message: ""
};
module.exports.ResponseEcho = {
    encode (message, writer = $ccb8e8f6078d2457$var$minimal_1.default.Writer.create()) {
        if (message.message !== "") writer.uint32(10).string(message.message);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ccb8e8f6078d2457$var$minimal_1.default.Reader ? input : new $ccb8e8f6078d2457$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseEcho);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.message = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseEcho);
        if (object.message !== undefined && object.message !== null) message.message = String(object.message);
        else message.message = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.message !== undefined && (obj.message = message.message);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseEcho);
        if (object.message !== undefined && object.message !== null) message.message = object.message;
        else message.message = "";
        return message;
    }
};
const $ccb8e8f6078d2457$var$baseResponseFlush = {};
module.exports.ResponseFlush = {
    encode (_, writer = $ccb8e8f6078d2457$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ccb8e8f6078d2457$var$minimal_1.default.Reader ? input : new $ccb8e8f6078d2457$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseFlush);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseFlush);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseFlush);
        return message;
    }
};
const $ccb8e8f6078d2457$var$baseResponseInfo = {
    data: "",
    version: "",
    appVersion: $ccb8e8f6078d2457$var$long_1.default.UZERO,
    lastBlockHeight: $ccb8e8f6078d2457$var$long_1.default.ZERO
};
module.exports.ResponseInfo = {
    encode (message, writer = $ccb8e8f6078d2457$var$minimal_1.default.Writer.create()) {
        if (message.data !== "") writer.uint32(10).string(message.data);
        if (message.version !== "") writer.uint32(18).string(message.version);
        if (!message.appVersion.isZero()) writer.uint32(24).uint64(message.appVersion);
        if (!message.lastBlockHeight.isZero()) writer.uint32(32).int64(message.lastBlockHeight);
        if (message.lastBlockAppHash.length !== 0) writer.uint32(42).bytes(message.lastBlockAppHash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ccb8e8f6078d2457$var$minimal_1.default.Reader ? input : new $ccb8e8f6078d2457$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseInfo);
        message.lastBlockAppHash = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.data = reader.string();
                    break;
                case 2:
                    message.version = reader.string();
                    break;
                case 3:
                    message.appVersion = reader.uint64();
                    break;
                case 4:
                    message.lastBlockHeight = reader.int64();
                    break;
                case 5:
                    message.lastBlockAppHash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseInfo);
        message.lastBlockAppHash = new Uint8Array();
        if (object.data !== undefined && object.data !== null) message.data = String(object.data);
        else message.data = "";
        if (object.version !== undefined && object.version !== null) message.version = String(object.version);
        else message.version = "";
        if (object.appVersion !== undefined && object.appVersion !== null) message.appVersion = $ccb8e8f6078d2457$var$long_1.default.fromString(object.appVersion);
        else message.appVersion = $ccb8e8f6078d2457$var$long_1.default.UZERO;
        if (object.lastBlockHeight !== undefined && object.lastBlockHeight !== null) message.lastBlockHeight = $ccb8e8f6078d2457$var$long_1.default.fromString(object.lastBlockHeight);
        else message.lastBlockHeight = $ccb8e8f6078d2457$var$long_1.default.ZERO;
        if (object.lastBlockAppHash !== undefined && object.lastBlockAppHash !== null) message.lastBlockAppHash = $ccb8e8f6078d2457$var$bytesFromBase64(object.lastBlockAppHash);
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.data !== undefined && (obj.data = message.data);
        message.version !== undefined && (obj.version = message.version);
        message.appVersion !== undefined && (obj.appVersion = (message.appVersion || $ccb8e8f6078d2457$var$long_1.default.UZERO).toString());
        message.lastBlockHeight !== undefined && (obj.lastBlockHeight = (message.lastBlockHeight || $ccb8e8f6078d2457$var$long_1.default.ZERO).toString());
        message.lastBlockAppHash !== undefined && (obj.lastBlockAppHash = $ccb8e8f6078d2457$var$base64FromBytes(message.lastBlockAppHash !== undefined ? message.lastBlockAppHash : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseInfo);
        if (object.data !== undefined && object.data !== null) message.data = object.data;
        else message.data = "";
        if (object.version !== undefined && object.version !== null) message.version = object.version;
        else message.version = "";
        if (object.appVersion !== undefined && object.appVersion !== null) message.appVersion = object.appVersion;
        else message.appVersion = $ccb8e8f6078d2457$var$long_1.default.UZERO;
        if (object.lastBlockHeight !== undefined && object.lastBlockHeight !== null) message.lastBlockHeight = object.lastBlockHeight;
        else message.lastBlockHeight = $ccb8e8f6078d2457$var$long_1.default.ZERO;
        if (object.lastBlockAppHash !== undefined && object.lastBlockAppHash !== null) message.lastBlockAppHash = object.lastBlockAppHash;
        else message.lastBlockAppHash = new Uint8Array();
        return message;
    }
};
const $ccb8e8f6078d2457$var$baseResponseSetOption = {
    code: 0,
    log: "",
    info: ""
};
module.exports.ResponseSetOption = {
    encode (message, writer = $ccb8e8f6078d2457$var$minimal_1.default.Writer.create()) {
        if (message.code !== 0) writer.uint32(8).uint32(message.code);
        if (message.log !== "") writer.uint32(26).string(message.log);
        if (message.info !== "") writer.uint32(34).string(message.info);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ccb8e8f6078d2457$var$minimal_1.default.Reader ? input : new $ccb8e8f6078d2457$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseSetOption);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.code = reader.uint32();
                    break;
                case 3:
                    message.log = reader.string();
                    break;
                case 4:
                    message.info = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseSetOption);
        if (object.code !== undefined && object.code !== null) message.code = Number(object.code);
        else message.code = 0;
        if (object.log !== undefined && object.log !== null) message.log = String(object.log);
        else message.log = "";
        if (object.info !== undefined && object.info !== null) message.info = String(object.info);
        else message.info = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.code !== undefined && (obj.code = message.code);
        message.log !== undefined && (obj.log = message.log);
        message.info !== undefined && (obj.info = message.info);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseSetOption);
        if (object.code !== undefined && object.code !== null) message.code = object.code;
        else message.code = 0;
        if (object.log !== undefined && object.log !== null) message.log = object.log;
        else message.log = "";
        if (object.info !== undefined && object.info !== null) message.info = object.info;
        else message.info = "";
        return message;
    }
};
const $ccb8e8f6078d2457$var$baseResponseInitChain = {};
module.exports.ResponseInitChain = {
    encode (message, writer = $ccb8e8f6078d2457$var$minimal_1.default.Writer.create()) {
        if (message.consensusParams !== undefined) module.exports.ConsensusParams.encode(message.consensusParams, writer.uint32(10).fork()).ldelim();
        for (const v of message.validators)module.exports.ValidatorUpdate.encode(v, writer.uint32(18).fork()).ldelim();
        if (message.appHash.length !== 0) writer.uint32(26).bytes(message.appHash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ccb8e8f6078d2457$var$minimal_1.default.Reader ? input : new $ccb8e8f6078d2457$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseInitChain);
        message.validators = [];
        message.appHash = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.consensusParams = module.exports.ConsensusParams.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.validators.push(module.exports.ValidatorUpdate.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.appHash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseInitChain);
        message.validators = [];
        message.appHash = new Uint8Array();
        if (object.consensusParams !== undefined && object.consensusParams !== null) message.consensusParams = module.exports.ConsensusParams.fromJSON(object.consensusParams);
        else message.consensusParams = undefined;
        if (object.validators !== undefined && object.validators !== null) for (const e of object.validators)message.validators.push(module.exports.ValidatorUpdate.fromJSON(e));
        if (object.appHash !== undefined && object.appHash !== null) message.appHash = $ccb8e8f6078d2457$var$bytesFromBase64(object.appHash);
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.consensusParams !== undefined && (obj.consensusParams = message.consensusParams ? module.exports.ConsensusParams.toJSON(message.consensusParams) : undefined);
        if (message.validators) obj.validators = message.validators.map((e)=>e ? module.exports.ValidatorUpdate.toJSON(e) : undefined);
        else obj.validators = [];
        message.appHash !== undefined && (obj.appHash = $ccb8e8f6078d2457$var$base64FromBytes(message.appHash !== undefined ? message.appHash : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseInitChain);
        message.validators = [];
        if (object.consensusParams !== undefined && object.consensusParams !== null) message.consensusParams = module.exports.ConsensusParams.fromPartial(object.consensusParams);
        else message.consensusParams = undefined;
        if (object.validators !== undefined && object.validators !== null) for (const e of object.validators)message.validators.push(module.exports.ValidatorUpdate.fromPartial(e));
        if (object.appHash !== undefined && object.appHash !== null) message.appHash = object.appHash;
        else message.appHash = new Uint8Array();
        return message;
    }
};
const $ccb8e8f6078d2457$var$baseResponseQuery = {
    code: 0,
    log: "",
    info: "",
    index: $ccb8e8f6078d2457$var$long_1.default.ZERO,
    height: $ccb8e8f6078d2457$var$long_1.default.ZERO,
    codespace: ""
};
module.exports.ResponseQuery = {
    encode (message, writer = $ccb8e8f6078d2457$var$minimal_1.default.Writer.create()) {
        if (message.code !== 0) writer.uint32(8).uint32(message.code);
        if (message.log !== "") writer.uint32(26).string(message.log);
        if (message.info !== "") writer.uint32(34).string(message.info);
        if (!message.index.isZero()) writer.uint32(40).int64(message.index);
        if (message.key.length !== 0) writer.uint32(50).bytes(message.key);
        if (message.value.length !== 0) writer.uint32(58).bytes(message.value);
        if (message.proofOps !== undefined) $eIxyR.ProofOps.encode(message.proofOps, writer.uint32(66).fork()).ldelim();
        if (!message.height.isZero()) writer.uint32(72).int64(message.height);
        if (message.codespace !== "") writer.uint32(82).string(message.codespace);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ccb8e8f6078d2457$var$minimal_1.default.Reader ? input : new $ccb8e8f6078d2457$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseQuery);
        message.key = new Uint8Array();
        message.value = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.code = reader.uint32();
                    break;
                case 3:
                    message.log = reader.string();
                    break;
                case 4:
                    message.info = reader.string();
                    break;
                case 5:
                    message.index = reader.int64();
                    break;
                case 6:
                    message.key = reader.bytes();
                    break;
                case 7:
                    message.value = reader.bytes();
                    break;
                case 8:
                    message.proofOps = $eIxyR.ProofOps.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.height = reader.int64();
                    break;
                case 10:
                    message.codespace = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseQuery);
        message.key = new Uint8Array();
        message.value = new Uint8Array();
        if (object.code !== undefined && object.code !== null) message.code = Number(object.code);
        else message.code = 0;
        if (object.log !== undefined && object.log !== null) message.log = String(object.log);
        else message.log = "";
        if (object.info !== undefined && object.info !== null) message.info = String(object.info);
        else message.info = "";
        if (object.index !== undefined && object.index !== null) message.index = $ccb8e8f6078d2457$var$long_1.default.fromString(object.index);
        else message.index = $ccb8e8f6078d2457$var$long_1.default.ZERO;
        if (object.key !== undefined && object.key !== null) message.key = $ccb8e8f6078d2457$var$bytesFromBase64(object.key);
        if (object.value !== undefined && object.value !== null) message.value = $ccb8e8f6078d2457$var$bytesFromBase64(object.value);
        if (object.proofOps !== undefined && object.proofOps !== null) message.proofOps = $eIxyR.ProofOps.fromJSON(object.proofOps);
        else message.proofOps = undefined;
        if (object.height !== undefined && object.height !== null) message.height = $ccb8e8f6078d2457$var$long_1.default.fromString(object.height);
        else message.height = $ccb8e8f6078d2457$var$long_1.default.ZERO;
        if (object.codespace !== undefined && object.codespace !== null) message.codespace = String(object.codespace);
        else message.codespace = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.code !== undefined && (obj.code = message.code);
        message.log !== undefined && (obj.log = message.log);
        message.info !== undefined && (obj.info = message.info);
        message.index !== undefined && (obj.index = (message.index || $ccb8e8f6078d2457$var$long_1.default.ZERO).toString());
        message.key !== undefined && (obj.key = $ccb8e8f6078d2457$var$base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        message.value !== undefined && (obj.value = $ccb8e8f6078d2457$var$base64FromBytes(message.value !== undefined ? message.value : new Uint8Array()));
        message.proofOps !== undefined && (obj.proofOps = message.proofOps ? $eIxyR.ProofOps.toJSON(message.proofOps) : undefined);
        message.height !== undefined && (obj.height = (message.height || $ccb8e8f6078d2457$var$long_1.default.ZERO).toString());
        message.codespace !== undefined && (obj.codespace = message.codespace);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseQuery);
        if (object.code !== undefined && object.code !== null) message.code = object.code;
        else message.code = 0;
        if (object.log !== undefined && object.log !== null) message.log = object.log;
        else message.log = "";
        if (object.info !== undefined && object.info !== null) message.info = object.info;
        else message.info = "";
        if (object.index !== undefined && object.index !== null) message.index = object.index;
        else message.index = $ccb8e8f6078d2457$var$long_1.default.ZERO;
        if (object.key !== undefined && object.key !== null) message.key = object.key;
        else message.key = new Uint8Array();
        if (object.value !== undefined && object.value !== null) message.value = object.value;
        else message.value = new Uint8Array();
        if (object.proofOps !== undefined && object.proofOps !== null) message.proofOps = $eIxyR.ProofOps.fromPartial(object.proofOps);
        else message.proofOps = undefined;
        if (object.height !== undefined && object.height !== null) message.height = object.height;
        else message.height = $ccb8e8f6078d2457$var$long_1.default.ZERO;
        if (object.codespace !== undefined && object.codespace !== null) message.codespace = object.codespace;
        else message.codespace = "";
        return message;
    }
};
const $ccb8e8f6078d2457$var$baseResponseBeginBlock = {};
module.exports.ResponseBeginBlock = {
    encode (message, writer = $ccb8e8f6078d2457$var$minimal_1.default.Writer.create()) {
        for (const v of message.events)module.exports.Event.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ccb8e8f6078d2457$var$minimal_1.default.Reader ? input : new $ccb8e8f6078d2457$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseBeginBlock);
        message.events = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.events.push(module.exports.Event.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseBeginBlock);
        message.events = [];
        if (object.events !== undefined && object.events !== null) for (const e of object.events)message.events.push(module.exports.Event.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.events) obj.events = message.events.map((e)=>e ? module.exports.Event.toJSON(e) : undefined);
        else obj.events = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseBeginBlock);
        message.events = [];
        if (object.events !== undefined && object.events !== null) for (const e of object.events)message.events.push(module.exports.Event.fromPartial(e));
        return message;
    }
};
const $ccb8e8f6078d2457$var$baseResponseCheckTx = {
    code: 0,
    log: "",
    info: "",
    gasWanted: $ccb8e8f6078d2457$var$long_1.default.ZERO,
    gasUsed: $ccb8e8f6078d2457$var$long_1.default.ZERO,
    codespace: ""
};
module.exports.ResponseCheckTx = {
    encode (message, writer = $ccb8e8f6078d2457$var$minimal_1.default.Writer.create()) {
        if (message.code !== 0) writer.uint32(8).uint32(message.code);
        if (message.data.length !== 0) writer.uint32(18).bytes(message.data);
        if (message.log !== "") writer.uint32(26).string(message.log);
        if (message.info !== "") writer.uint32(34).string(message.info);
        if (!message.gasWanted.isZero()) writer.uint32(40).int64(message.gasWanted);
        if (!message.gasUsed.isZero()) writer.uint32(48).int64(message.gasUsed);
        for (const v of message.events)module.exports.Event.encode(v, writer.uint32(58).fork()).ldelim();
        if (message.codespace !== "") writer.uint32(66).string(message.codespace);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ccb8e8f6078d2457$var$minimal_1.default.Reader ? input : new $ccb8e8f6078d2457$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseCheckTx);
        message.events = [];
        message.data = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.code = reader.uint32();
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                case 3:
                    message.log = reader.string();
                    break;
                case 4:
                    message.info = reader.string();
                    break;
                case 5:
                    message.gasWanted = reader.int64();
                    break;
                case 6:
                    message.gasUsed = reader.int64();
                    break;
                case 7:
                    message.events.push(module.exports.Event.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.codespace = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseCheckTx);
        message.events = [];
        message.data = new Uint8Array();
        if (object.code !== undefined && object.code !== null) message.code = Number(object.code);
        else message.code = 0;
        if (object.data !== undefined && object.data !== null) message.data = $ccb8e8f6078d2457$var$bytesFromBase64(object.data);
        if (object.log !== undefined && object.log !== null) message.log = String(object.log);
        else message.log = "";
        if (object.info !== undefined && object.info !== null) message.info = String(object.info);
        else message.info = "";
        if (object.gasWanted !== undefined && object.gasWanted !== null) message.gasWanted = $ccb8e8f6078d2457$var$long_1.default.fromString(object.gasWanted);
        else message.gasWanted = $ccb8e8f6078d2457$var$long_1.default.ZERO;
        if (object.gasUsed !== undefined && object.gasUsed !== null) message.gasUsed = $ccb8e8f6078d2457$var$long_1.default.fromString(object.gasUsed);
        else message.gasUsed = $ccb8e8f6078d2457$var$long_1.default.ZERO;
        if (object.events !== undefined && object.events !== null) for (const e of object.events)message.events.push(module.exports.Event.fromJSON(e));
        if (object.codespace !== undefined && object.codespace !== null) message.codespace = String(object.codespace);
        else message.codespace = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.code !== undefined && (obj.code = message.code);
        message.data !== undefined && (obj.data = $ccb8e8f6078d2457$var$base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        message.log !== undefined && (obj.log = message.log);
        message.info !== undefined && (obj.info = message.info);
        message.gasWanted !== undefined && (obj.gasWanted = (message.gasWanted || $ccb8e8f6078d2457$var$long_1.default.ZERO).toString());
        message.gasUsed !== undefined && (obj.gasUsed = (message.gasUsed || $ccb8e8f6078d2457$var$long_1.default.ZERO).toString());
        if (message.events) obj.events = message.events.map((e)=>e ? module.exports.Event.toJSON(e) : undefined);
        else obj.events = [];
        message.codespace !== undefined && (obj.codespace = message.codespace);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseCheckTx);
        message.events = [];
        if (object.code !== undefined && object.code !== null) message.code = object.code;
        else message.code = 0;
        if (object.data !== undefined && object.data !== null) message.data = object.data;
        else message.data = new Uint8Array();
        if (object.log !== undefined && object.log !== null) message.log = object.log;
        else message.log = "";
        if (object.info !== undefined && object.info !== null) message.info = object.info;
        else message.info = "";
        if (object.gasWanted !== undefined && object.gasWanted !== null) message.gasWanted = object.gasWanted;
        else message.gasWanted = $ccb8e8f6078d2457$var$long_1.default.ZERO;
        if (object.gasUsed !== undefined && object.gasUsed !== null) message.gasUsed = object.gasUsed;
        else message.gasUsed = $ccb8e8f6078d2457$var$long_1.default.ZERO;
        if (object.events !== undefined && object.events !== null) for (const e of object.events)message.events.push(module.exports.Event.fromPartial(e));
        if (object.codespace !== undefined && object.codespace !== null) message.codespace = object.codespace;
        else message.codespace = "";
        return message;
    }
};
const $ccb8e8f6078d2457$var$baseResponseDeliverTx = {
    code: 0,
    log: "",
    info: "",
    gasWanted: $ccb8e8f6078d2457$var$long_1.default.ZERO,
    gasUsed: $ccb8e8f6078d2457$var$long_1.default.ZERO,
    codespace: ""
};
module.exports.ResponseDeliverTx = {
    encode (message, writer = $ccb8e8f6078d2457$var$minimal_1.default.Writer.create()) {
        if (message.code !== 0) writer.uint32(8).uint32(message.code);
        if (message.data.length !== 0) writer.uint32(18).bytes(message.data);
        if (message.log !== "") writer.uint32(26).string(message.log);
        if (message.info !== "") writer.uint32(34).string(message.info);
        if (!message.gasWanted.isZero()) writer.uint32(40).int64(message.gasWanted);
        if (!message.gasUsed.isZero()) writer.uint32(48).int64(message.gasUsed);
        for (const v of message.events)module.exports.Event.encode(v, writer.uint32(58).fork()).ldelim();
        if (message.codespace !== "") writer.uint32(66).string(message.codespace);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ccb8e8f6078d2457$var$minimal_1.default.Reader ? input : new $ccb8e8f6078d2457$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseDeliverTx);
        message.events = [];
        message.data = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.code = reader.uint32();
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                case 3:
                    message.log = reader.string();
                    break;
                case 4:
                    message.info = reader.string();
                    break;
                case 5:
                    message.gasWanted = reader.int64();
                    break;
                case 6:
                    message.gasUsed = reader.int64();
                    break;
                case 7:
                    message.events.push(module.exports.Event.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.codespace = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseDeliverTx);
        message.events = [];
        message.data = new Uint8Array();
        if (object.code !== undefined && object.code !== null) message.code = Number(object.code);
        else message.code = 0;
        if (object.data !== undefined && object.data !== null) message.data = $ccb8e8f6078d2457$var$bytesFromBase64(object.data);
        if (object.log !== undefined && object.log !== null) message.log = String(object.log);
        else message.log = "";
        if (object.info !== undefined && object.info !== null) message.info = String(object.info);
        else message.info = "";
        if (object.gasWanted !== undefined && object.gasWanted !== null) message.gasWanted = $ccb8e8f6078d2457$var$long_1.default.fromString(object.gasWanted);
        else message.gasWanted = $ccb8e8f6078d2457$var$long_1.default.ZERO;
        if (object.gasUsed !== undefined && object.gasUsed !== null) message.gasUsed = $ccb8e8f6078d2457$var$long_1.default.fromString(object.gasUsed);
        else message.gasUsed = $ccb8e8f6078d2457$var$long_1.default.ZERO;
        if (object.events !== undefined && object.events !== null) for (const e of object.events)message.events.push(module.exports.Event.fromJSON(e));
        if (object.codespace !== undefined && object.codespace !== null) message.codespace = String(object.codespace);
        else message.codespace = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.code !== undefined && (obj.code = message.code);
        message.data !== undefined && (obj.data = $ccb8e8f6078d2457$var$base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        message.log !== undefined && (obj.log = message.log);
        message.info !== undefined && (obj.info = message.info);
        message.gasWanted !== undefined && (obj.gasWanted = (message.gasWanted || $ccb8e8f6078d2457$var$long_1.default.ZERO).toString());
        message.gasUsed !== undefined && (obj.gasUsed = (message.gasUsed || $ccb8e8f6078d2457$var$long_1.default.ZERO).toString());
        if (message.events) obj.events = message.events.map((e)=>e ? module.exports.Event.toJSON(e) : undefined);
        else obj.events = [];
        message.codespace !== undefined && (obj.codespace = message.codespace);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseDeliverTx);
        message.events = [];
        if (object.code !== undefined && object.code !== null) message.code = object.code;
        else message.code = 0;
        if (object.data !== undefined && object.data !== null) message.data = object.data;
        else message.data = new Uint8Array();
        if (object.log !== undefined && object.log !== null) message.log = object.log;
        else message.log = "";
        if (object.info !== undefined && object.info !== null) message.info = object.info;
        else message.info = "";
        if (object.gasWanted !== undefined && object.gasWanted !== null) message.gasWanted = object.gasWanted;
        else message.gasWanted = $ccb8e8f6078d2457$var$long_1.default.ZERO;
        if (object.gasUsed !== undefined && object.gasUsed !== null) message.gasUsed = object.gasUsed;
        else message.gasUsed = $ccb8e8f6078d2457$var$long_1.default.ZERO;
        if (object.events !== undefined && object.events !== null) for (const e of object.events)message.events.push(module.exports.Event.fromPartial(e));
        if (object.codespace !== undefined && object.codespace !== null) message.codespace = object.codespace;
        else message.codespace = "";
        return message;
    }
};
const $ccb8e8f6078d2457$var$baseResponseEndBlock = {};
module.exports.ResponseEndBlock = {
    encode (message, writer = $ccb8e8f6078d2457$var$minimal_1.default.Writer.create()) {
        for (const v of message.validatorUpdates)module.exports.ValidatorUpdate.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.consensusParamUpdates !== undefined) module.exports.ConsensusParams.encode(message.consensusParamUpdates, writer.uint32(18).fork()).ldelim();
        for (const v of message.events)module.exports.Event.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ccb8e8f6078d2457$var$minimal_1.default.Reader ? input : new $ccb8e8f6078d2457$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseEndBlock);
        message.validatorUpdates = [];
        message.events = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorUpdates.push(module.exports.ValidatorUpdate.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.consensusParamUpdates = module.exports.ConsensusParams.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.events.push(module.exports.Event.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseEndBlock);
        message.validatorUpdates = [];
        message.events = [];
        if (object.validatorUpdates !== undefined && object.validatorUpdates !== null) for (const e of object.validatorUpdates)message.validatorUpdates.push(module.exports.ValidatorUpdate.fromJSON(e));
        if (object.consensusParamUpdates !== undefined && object.consensusParamUpdates !== null) message.consensusParamUpdates = module.exports.ConsensusParams.fromJSON(object.consensusParamUpdates);
        else message.consensusParamUpdates = undefined;
        if (object.events !== undefined && object.events !== null) for (const e of object.events)message.events.push(module.exports.Event.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.validatorUpdates) obj.validatorUpdates = message.validatorUpdates.map((e)=>e ? module.exports.ValidatorUpdate.toJSON(e) : undefined);
        else obj.validatorUpdates = [];
        message.consensusParamUpdates !== undefined && (obj.consensusParamUpdates = message.consensusParamUpdates ? module.exports.ConsensusParams.toJSON(message.consensusParamUpdates) : undefined);
        if (message.events) obj.events = message.events.map((e)=>e ? module.exports.Event.toJSON(e) : undefined);
        else obj.events = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseEndBlock);
        message.validatorUpdates = [];
        message.events = [];
        if (object.validatorUpdates !== undefined && object.validatorUpdates !== null) for (const e of object.validatorUpdates)message.validatorUpdates.push(module.exports.ValidatorUpdate.fromPartial(e));
        if (object.consensusParamUpdates !== undefined && object.consensusParamUpdates !== null) message.consensusParamUpdates = module.exports.ConsensusParams.fromPartial(object.consensusParamUpdates);
        else message.consensusParamUpdates = undefined;
        if (object.events !== undefined && object.events !== null) for (const e of object.events)message.events.push(module.exports.Event.fromPartial(e));
        return message;
    }
};
const $ccb8e8f6078d2457$var$baseResponseCommit = {
    retainHeight: $ccb8e8f6078d2457$var$long_1.default.ZERO
};
module.exports.ResponseCommit = {
    encode (message, writer = $ccb8e8f6078d2457$var$minimal_1.default.Writer.create()) {
        if (message.data.length !== 0) writer.uint32(18).bytes(message.data);
        if (!message.retainHeight.isZero()) writer.uint32(24).int64(message.retainHeight);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ccb8e8f6078d2457$var$minimal_1.default.Reader ? input : new $ccb8e8f6078d2457$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseCommit);
        message.data = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 2:
                    message.data = reader.bytes();
                    break;
                case 3:
                    message.retainHeight = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseCommit);
        message.data = new Uint8Array();
        if (object.data !== undefined && object.data !== null) message.data = $ccb8e8f6078d2457$var$bytesFromBase64(object.data);
        if (object.retainHeight !== undefined && object.retainHeight !== null) message.retainHeight = $ccb8e8f6078d2457$var$long_1.default.fromString(object.retainHeight);
        else message.retainHeight = $ccb8e8f6078d2457$var$long_1.default.ZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.data !== undefined && (obj.data = $ccb8e8f6078d2457$var$base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        message.retainHeight !== undefined && (obj.retainHeight = (message.retainHeight || $ccb8e8f6078d2457$var$long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseCommit);
        if (object.data !== undefined && object.data !== null) message.data = object.data;
        else message.data = new Uint8Array();
        if (object.retainHeight !== undefined && object.retainHeight !== null) message.retainHeight = object.retainHeight;
        else message.retainHeight = $ccb8e8f6078d2457$var$long_1.default.ZERO;
        return message;
    }
};
const $ccb8e8f6078d2457$var$baseResponseListSnapshots = {};
module.exports.ResponseListSnapshots = {
    encode (message, writer = $ccb8e8f6078d2457$var$minimal_1.default.Writer.create()) {
        for (const v of message.snapshots)module.exports.Snapshot.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ccb8e8f6078d2457$var$minimal_1.default.Reader ? input : new $ccb8e8f6078d2457$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseListSnapshots);
        message.snapshots = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.snapshots.push(module.exports.Snapshot.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseListSnapshots);
        message.snapshots = [];
        if (object.snapshots !== undefined && object.snapshots !== null) for (const e of object.snapshots)message.snapshots.push(module.exports.Snapshot.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.snapshots) obj.snapshots = message.snapshots.map((e)=>e ? module.exports.Snapshot.toJSON(e) : undefined);
        else obj.snapshots = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseListSnapshots);
        message.snapshots = [];
        if (object.snapshots !== undefined && object.snapshots !== null) for (const e of object.snapshots)message.snapshots.push(module.exports.Snapshot.fromPartial(e));
        return message;
    }
};
const $ccb8e8f6078d2457$var$baseResponseOfferSnapshot = {
    result: 0
};
module.exports.ResponseOfferSnapshot = {
    encode (message, writer = $ccb8e8f6078d2457$var$minimal_1.default.Writer.create()) {
        if (message.result !== 0) writer.uint32(8).int32(message.result);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ccb8e8f6078d2457$var$minimal_1.default.Reader ? input : new $ccb8e8f6078d2457$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseOfferSnapshot);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.result = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseOfferSnapshot);
        if (object.result !== undefined && object.result !== null) message.result = $ccb8e8f6078d2457$var$responseOfferSnapshot_ResultFromJSON(object.result);
        else message.result = 0;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.result !== undefined && (obj.result = $ccb8e8f6078d2457$var$responseOfferSnapshot_ResultToJSON(message.result));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseOfferSnapshot);
        if (object.result !== undefined && object.result !== null) message.result = object.result;
        else message.result = 0;
        return message;
    }
};
const $ccb8e8f6078d2457$var$baseResponseLoadSnapshotChunk = {};
module.exports.ResponseLoadSnapshotChunk = {
    encode (message, writer = $ccb8e8f6078d2457$var$minimal_1.default.Writer.create()) {
        if (message.chunk.length !== 0) writer.uint32(10).bytes(message.chunk);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ccb8e8f6078d2457$var$minimal_1.default.Reader ? input : new $ccb8e8f6078d2457$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseLoadSnapshotChunk);
        message.chunk = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.chunk = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseLoadSnapshotChunk);
        message.chunk = new Uint8Array();
        if (object.chunk !== undefined && object.chunk !== null) message.chunk = $ccb8e8f6078d2457$var$bytesFromBase64(object.chunk);
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.chunk !== undefined && (obj.chunk = $ccb8e8f6078d2457$var$base64FromBytes(message.chunk !== undefined ? message.chunk : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseLoadSnapshotChunk);
        if (object.chunk !== undefined && object.chunk !== null) message.chunk = object.chunk;
        else message.chunk = new Uint8Array();
        return message;
    }
};
const $ccb8e8f6078d2457$var$baseResponseApplySnapshotChunk = {
    result: 0,
    refetchChunks: 0,
    rejectSenders: ""
};
module.exports.ResponseApplySnapshotChunk = {
    encode (message, writer = $ccb8e8f6078d2457$var$minimal_1.default.Writer.create()) {
        if (message.result !== 0) writer.uint32(8).int32(message.result);
        writer.uint32(18).fork();
        for (const v of message.refetchChunks)writer.uint32(v);
        writer.ldelim();
        for (const v of message.rejectSenders)writer.uint32(26).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ccb8e8f6078d2457$var$minimal_1.default.Reader ? input : new $ccb8e8f6078d2457$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseApplySnapshotChunk);
        message.refetchChunks = [];
        message.rejectSenders = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.result = reader.int32();
                    break;
                case 2:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.refetchChunks.push(reader.uint32());
                    } else message.refetchChunks.push(reader.uint32());
                    break;
                case 3:
                    message.rejectSenders.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseApplySnapshotChunk);
        message.refetchChunks = [];
        message.rejectSenders = [];
        if (object.result !== undefined && object.result !== null) message.result = $ccb8e8f6078d2457$var$responseApplySnapshotChunk_ResultFromJSON(object.result);
        else message.result = 0;
        if (object.refetchChunks !== undefined && object.refetchChunks !== null) for (const e of object.refetchChunks)message.refetchChunks.push(Number(e));
        if (object.rejectSenders !== undefined && object.rejectSenders !== null) for (const e of object.rejectSenders)message.rejectSenders.push(String(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.result !== undefined && (obj.result = $ccb8e8f6078d2457$var$responseApplySnapshotChunk_ResultToJSON(message.result));
        if (message.refetchChunks) obj.refetchChunks = message.refetchChunks.map((e)=>e);
        else obj.refetchChunks = [];
        if (message.rejectSenders) obj.rejectSenders = message.rejectSenders.map((e)=>e);
        else obj.rejectSenders = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseResponseApplySnapshotChunk);
        message.refetchChunks = [];
        message.rejectSenders = [];
        if (object.result !== undefined && object.result !== null) message.result = object.result;
        else message.result = 0;
        if (object.refetchChunks !== undefined && object.refetchChunks !== null) for (const e of object.refetchChunks)message.refetchChunks.push(e);
        if (object.rejectSenders !== undefined && object.rejectSenders !== null) for (const e of object.rejectSenders)message.rejectSenders.push(e);
        return message;
    }
};
const $ccb8e8f6078d2457$var$baseConsensusParams = {};
module.exports.ConsensusParams = {
    encode (message, writer = $ccb8e8f6078d2457$var$minimal_1.default.Writer.create()) {
        if (message.block !== undefined) module.exports.BlockParams.encode(message.block, writer.uint32(10).fork()).ldelim();
        if (message.evidence !== undefined) $4csTs.EvidenceParams.encode(message.evidence, writer.uint32(18).fork()).ldelim();
        if (message.validator !== undefined) $4csTs.ValidatorParams.encode(message.validator, writer.uint32(26).fork()).ldelim();
        if (message.version !== undefined) $4csTs.VersionParams.encode(message.version, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ccb8e8f6078d2457$var$minimal_1.default.Reader ? input : new $ccb8e8f6078d2457$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseConsensusParams);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.block = module.exports.BlockParams.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.evidence = $4csTs.EvidenceParams.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.validator = $4csTs.ValidatorParams.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.version = $4csTs.VersionParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseConsensusParams);
        if (object.block !== undefined && object.block !== null) message.block = module.exports.BlockParams.fromJSON(object.block);
        else message.block = undefined;
        if (object.evidence !== undefined && object.evidence !== null) message.evidence = $4csTs.EvidenceParams.fromJSON(object.evidence);
        else message.evidence = undefined;
        if (object.validator !== undefined && object.validator !== null) message.validator = $4csTs.ValidatorParams.fromJSON(object.validator);
        else message.validator = undefined;
        if (object.version !== undefined && object.version !== null) message.version = $4csTs.VersionParams.fromJSON(object.version);
        else message.version = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.block !== undefined && (obj.block = message.block ? module.exports.BlockParams.toJSON(message.block) : undefined);
        message.evidence !== undefined && (obj.evidence = message.evidence ? $4csTs.EvidenceParams.toJSON(message.evidence) : undefined);
        message.validator !== undefined && (obj.validator = message.validator ? $4csTs.ValidatorParams.toJSON(message.validator) : undefined);
        message.version !== undefined && (obj.version = message.version ? $4csTs.VersionParams.toJSON(message.version) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseConsensusParams);
        if (object.block !== undefined && object.block !== null) message.block = module.exports.BlockParams.fromPartial(object.block);
        else message.block = undefined;
        if (object.evidence !== undefined && object.evidence !== null) message.evidence = $4csTs.EvidenceParams.fromPartial(object.evidence);
        else message.evidence = undefined;
        if (object.validator !== undefined && object.validator !== null) message.validator = $4csTs.ValidatorParams.fromPartial(object.validator);
        else message.validator = undefined;
        if (object.version !== undefined && object.version !== null) message.version = $4csTs.VersionParams.fromPartial(object.version);
        else message.version = undefined;
        return message;
    }
};
const $ccb8e8f6078d2457$var$baseBlockParams = {
    maxBytes: $ccb8e8f6078d2457$var$long_1.default.ZERO,
    maxGas: $ccb8e8f6078d2457$var$long_1.default.ZERO
};
module.exports.BlockParams = {
    encode (message, writer = $ccb8e8f6078d2457$var$minimal_1.default.Writer.create()) {
        if (!message.maxBytes.isZero()) writer.uint32(8).int64(message.maxBytes);
        if (!message.maxGas.isZero()) writer.uint32(16).int64(message.maxGas);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ccb8e8f6078d2457$var$minimal_1.default.Reader ? input : new $ccb8e8f6078d2457$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseBlockParams);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.maxBytes = reader.int64();
                    break;
                case 2:
                    message.maxGas = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseBlockParams);
        if (object.maxBytes !== undefined && object.maxBytes !== null) message.maxBytes = $ccb8e8f6078d2457$var$long_1.default.fromString(object.maxBytes);
        else message.maxBytes = $ccb8e8f6078d2457$var$long_1.default.ZERO;
        if (object.maxGas !== undefined && object.maxGas !== null) message.maxGas = $ccb8e8f6078d2457$var$long_1.default.fromString(object.maxGas);
        else message.maxGas = $ccb8e8f6078d2457$var$long_1.default.ZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.maxBytes !== undefined && (obj.maxBytes = (message.maxBytes || $ccb8e8f6078d2457$var$long_1.default.ZERO).toString());
        message.maxGas !== undefined && (obj.maxGas = (message.maxGas || $ccb8e8f6078d2457$var$long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseBlockParams);
        if (object.maxBytes !== undefined && object.maxBytes !== null) message.maxBytes = object.maxBytes;
        else message.maxBytes = $ccb8e8f6078d2457$var$long_1.default.ZERO;
        if (object.maxGas !== undefined && object.maxGas !== null) message.maxGas = object.maxGas;
        else message.maxGas = $ccb8e8f6078d2457$var$long_1.default.ZERO;
        return message;
    }
};
const $ccb8e8f6078d2457$var$baseLastCommitInfo = {
    round: 0
};
module.exports.LastCommitInfo = {
    encode (message, writer = $ccb8e8f6078d2457$var$minimal_1.default.Writer.create()) {
        if (message.round !== 0) writer.uint32(8).int32(message.round);
        for (const v of message.votes)module.exports.VoteInfo.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ccb8e8f6078d2457$var$minimal_1.default.Reader ? input : new $ccb8e8f6078d2457$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseLastCommitInfo);
        message.votes = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.round = reader.int32();
                    break;
                case 2:
                    message.votes.push(module.exports.VoteInfo.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseLastCommitInfo);
        message.votes = [];
        if (object.round !== undefined && object.round !== null) message.round = Number(object.round);
        else message.round = 0;
        if (object.votes !== undefined && object.votes !== null) for (const e of object.votes)message.votes.push(module.exports.VoteInfo.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.round !== undefined && (obj.round = message.round);
        if (message.votes) obj.votes = message.votes.map((e)=>e ? module.exports.VoteInfo.toJSON(e) : undefined);
        else obj.votes = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseLastCommitInfo);
        message.votes = [];
        if (object.round !== undefined && object.round !== null) message.round = object.round;
        else message.round = 0;
        if (object.votes !== undefined && object.votes !== null) for (const e of object.votes)message.votes.push(module.exports.VoteInfo.fromPartial(e));
        return message;
    }
};
const $ccb8e8f6078d2457$var$baseEvent = {
    type: ""
};
module.exports.Event = {
    encode (message, writer = $ccb8e8f6078d2457$var$minimal_1.default.Writer.create()) {
        if (message.type !== "") writer.uint32(10).string(message.type);
        for (const v of message.attributes)module.exports.EventAttribute.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ccb8e8f6078d2457$var$minimal_1.default.Reader ? input : new $ccb8e8f6078d2457$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseEvent);
        message.attributes = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.string();
                    break;
                case 2:
                    message.attributes.push(module.exports.EventAttribute.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseEvent);
        message.attributes = [];
        if (object.type !== undefined && object.type !== null) message.type = String(object.type);
        else message.type = "";
        if (object.attributes !== undefined && object.attributes !== null) for (const e of object.attributes)message.attributes.push(module.exports.EventAttribute.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.type !== undefined && (obj.type = message.type);
        if (message.attributes) obj.attributes = message.attributes.map((e)=>e ? module.exports.EventAttribute.toJSON(e) : undefined);
        else obj.attributes = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseEvent);
        message.attributes = [];
        if (object.type !== undefined && object.type !== null) message.type = object.type;
        else message.type = "";
        if (object.attributes !== undefined && object.attributes !== null) for (const e of object.attributes)message.attributes.push(module.exports.EventAttribute.fromPartial(e));
        return message;
    }
};
const $ccb8e8f6078d2457$var$baseEventAttribute = {
    index: false
};
module.exports.EventAttribute = {
    encode (message, writer = $ccb8e8f6078d2457$var$minimal_1.default.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (message.value.length !== 0) writer.uint32(18).bytes(message.value);
        if (message.index === true) writer.uint32(24).bool(message.index);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ccb8e8f6078d2457$var$minimal_1.default.Reader ? input : new $ccb8e8f6078d2457$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseEventAttribute);
        message.key = new Uint8Array();
        message.value = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.value = reader.bytes();
                    break;
                case 3:
                    message.index = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseEventAttribute);
        message.key = new Uint8Array();
        message.value = new Uint8Array();
        if (object.key !== undefined && object.key !== null) message.key = $ccb8e8f6078d2457$var$bytesFromBase64(object.key);
        if (object.value !== undefined && object.value !== null) message.value = $ccb8e8f6078d2457$var$bytesFromBase64(object.value);
        if (object.index !== undefined && object.index !== null) message.index = Boolean(object.index);
        else message.index = false;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = $ccb8e8f6078d2457$var$base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        message.value !== undefined && (obj.value = $ccb8e8f6078d2457$var$base64FromBytes(message.value !== undefined ? message.value : new Uint8Array()));
        message.index !== undefined && (obj.index = message.index);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseEventAttribute);
        if (object.key !== undefined && object.key !== null) message.key = object.key;
        else message.key = new Uint8Array();
        if (object.value !== undefined && object.value !== null) message.value = object.value;
        else message.value = new Uint8Array();
        if (object.index !== undefined && object.index !== null) message.index = object.index;
        else message.index = false;
        return message;
    }
};
const $ccb8e8f6078d2457$var$baseTxResult = {
    height: $ccb8e8f6078d2457$var$long_1.default.ZERO,
    index: 0
};
module.exports.TxResult = {
    encode (message, writer = $ccb8e8f6078d2457$var$minimal_1.default.Writer.create()) {
        if (!message.height.isZero()) writer.uint32(8).int64(message.height);
        if (message.index !== 0) writer.uint32(16).uint32(message.index);
        if (message.tx.length !== 0) writer.uint32(26).bytes(message.tx);
        if (message.result !== undefined) module.exports.ResponseDeliverTx.encode(message.result, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ccb8e8f6078d2457$var$minimal_1.default.Reader ? input : new $ccb8e8f6078d2457$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseTxResult);
        message.tx = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.int64();
                    break;
                case 2:
                    message.index = reader.uint32();
                    break;
                case 3:
                    message.tx = reader.bytes();
                    break;
                case 4:
                    message.result = module.exports.ResponseDeliverTx.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseTxResult);
        message.tx = new Uint8Array();
        if (object.height !== undefined && object.height !== null) message.height = $ccb8e8f6078d2457$var$long_1.default.fromString(object.height);
        else message.height = $ccb8e8f6078d2457$var$long_1.default.ZERO;
        if (object.index !== undefined && object.index !== null) message.index = Number(object.index);
        else message.index = 0;
        if (object.tx !== undefined && object.tx !== null) message.tx = $ccb8e8f6078d2457$var$bytesFromBase64(object.tx);
        if (object.result !== undefined && object.result !== null) message.result = module.exports.ResponseDeliverTx.fromJSON(object.result);
        else message.result = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || $ccb8e8f6078d2457$var$long_1.default.ZERO).toString());
        message.index !== undefined && (obj.index = message.index);
        message.tx !== undefined && (obj.tx = $ccb8e8f6078d2457$var$base64FromBytes(message.tx !== undefined ? message.tx : new Uint8Array()));
        message.result !== undefined && (obj.result = message.result ? module.exports.ResponseDeliverTx.toJSON(message.result) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseTxResult);
        if (object.height !== undefined && object.height !== null) message.height = object.height;
        else message.height = $ccb8e8f6078d2457$var$long_1.default.ZERO;
        if (object.index !== undefined && object.index !== null) message.index = object.index;
        else message.index = 0;
        if (object.tx !== undefined && object.tx !== null) message.tx = object.tx;
        else message.tx = new Uint8Array();
        if (object.result !== undefined && object.result !== null) message.result = module.exports.ResponseDeliverTx.fromPartial(object.result);
        else message.result = undefined;
        return message;
    }
};
const $ccb8e8f6078d2457$var$baseValidator = {
    power: $ccb8e8f6078d2457$var$long_1.default.ZERO
};
module.exports.Validator = {
    encode (message, writer = $ccb8e8f6078d2457$var$minimal_1.default.Writer.create()) {
        if (message.address.length !== 0) writer.uint32(10).bytes(message.address);
        if (!message.power.isZero()) writer.uint32(24).int64(message.power);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ccb8e8f6078d2457$var$minimal_1.default.Reader ? input : new $ccb8e8f6078d2457$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseValidator);
        message.address = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.bytes();
                    break;
                case 3:
                    message.power = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseValidator);
        message.address = new Uint8Array();
        if (object.address !== undefined && object.address !== null) message.address = $ccb8e8f6078d2457$var$bytesFromBase64(object.address);
        if (object.power !== undefined && object.power !== null) message.power = $ccb8e8f6078d2457$var$long_1.default.fromString(object.power);
        else message.power = $ccb8e8f6078d2457$var$long_1.default.ZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = $ccb8e8f6078d2457$var$base64FromBytes(message.address !== undefined ? message.address : new Uint8Array()));
        message.power !== undefined && (obj.power = (message.power || $ccb8e8f6078d2457$var$long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseValidator);
        if (object.address !== undefined && object.address !== null) message.address = object.address;
        else message.address = new Uint8Array();
        if (object.power !== undefined && object.power !== null) message.power = object.power;
        else message.power = $ccb8e8f6078d2457$var$long_1.default.ZERO;
        return message;
    }
};
const $ccb8e8f6078d2457$var$baseValidatorUpdate = {
    power: $ccb8e8f6078d2457$var$long_1.default.ZERO
};
module.exports.ValidatorUpdate = {
    encode (message, writer = $ccb8e8f6078d2457$var$minimal_1.default.Writer.create()) {
        if (message.pubKey !== undefined) $a0zXC.PublicKey.encode(message.pubKey, writer.uint32(10).fork()).ldelim();
        if (!message.power.isZero()) writer.uint32(16).int64(message.power);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ccb8e8f6078d2457$var$minimal_1.default.Reader ? input : new $ccb8e8f6078d2457$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseValidatorUpdate);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pubKey = $a0zXC.PublicKey.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.power = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseValidatorUpdate);
        if (object.pubKey !== undefined && object.pubKey !== null) message.pubKey = $a0zXC.PublicKey.fromJSON(object.pubKey);
        else message.pubKey = undefined;
        if (object.power !== undefined && object.power !== null) message.power = $ccb8e8f6078d2457$var$long_1.default.fromString(object.power);
        else message.power = $ccb8e8f6078d2457$var$long_1.default.ZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.pubKey !== undefined && (obj.pubKey = message.pubKey ? $a0zXC.PublicKey.toJSON(message.pubKey) : undefined);
        message.power !== undefined && (obj.power = (message.power || $ccb8e8f6078d2457$var$long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseValidatorUpdate);
        if (object.pubKey !== undefined && object.pubKey !== null) message.pubKey = $a0zXC.PublicKey.fromPartial(object.pubKey);
        else message.pubKey = undefined;
        if (object.power !== undefined && object.power !== null) message.power = object.power;
        else message.power = $ccb8e8f6078d2457$var$long_1.default.ZERO;
        return message;
    }
};
const $ccb8e8f6078d2457$var$baseVoteInfo = {
    signedLastBlock: false
};
module.exports.VoteInfo = {
    encode (message, writer = $ccb8e8f6078d2457$var$minimal_1.default.Writer.create()) {
        if (message.validator !== undefined) module.exports.Validator.encode(message.validator, writer.uint32(10).fork()).ldelim();
        if (message.signedLastBlock === true) writer.uint32(16).bool(message.signedLastBlock);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ccb8e8f6078d2457$var$minimal_1.default.Reader ? input : new $ccb8e8f6078d2457$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseVoteInfo);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validator = module.exports.Validator.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.signedLastBlock = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseVoteInfo);
        if (object.validator !== undefined && object.validator !== null) message.validator = module.exports.Validator.fromJSON(object.validator);
        else message.validator = undefined;
        if (object.signedLastBlock !== undefined && object.signedLastBlock !== null) message.signedLastBlock = Boolean(object.signedLastBlock);
        else message.signedLastBlock = false;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.validator !== undefined && (obj.validator = message.validator ? module.exports.Validator.toJSON(message.validator) : undefined);
        message.signedLastBlock !== undefined && (obj.signedLastBlock = message.signedLastBlock);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseVoteInfo);
        if (object.validator !== undefined && object.validator !== null) message.validator = module.exports.Validator.fromPartial(object.validator);
        else message.validator = undefined;
        if (object.signedLastBlock !== undefined && object.signedLastBlock !== null) message.signedLastBlock = object.signedLastBlock;
        else message.signedLastBlock = false;
        return message;
    }
};
const $ccb8e8f6078d2457$var$baseEvidence = {
    type: 0,
    height: $ccb8e8f6078d2457$var$long_1.default.ZERO,
    totalVotingPower: $ccb8e8f6078d2457$var$long_1.default.ZERO
};
module.exports.Evidence = {
    encode (message, writer = $ccb8e8f6078d2457$var$minimal_1.default.Writer.create()) {
        if (message.type !== 0) writer.uint32(8).int32(message.type);
        if (message.validator !== undefined) module.exports.Validator.encode(message.validator, writer.uint32(18).fork()).ldelim();
        if (!message.height.isZero()) writer.uint32(24).int64(message.height);
        if (message.time !== undefined) $5G2s6.Timestamp.encode($ccb8e8f6078d2457$var$toTimestamp(message.time), writer.uint32(34).fork()).ldelim();
        if (!message.totalVotingPower.isZero()) writer.uint32(40).int64(message.totalVotingPower);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ccb8e8f6078d2457$var$minimal_1.default.Reader ? input : new $ccb8e8f6078d2457$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseEvidence);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.int32();
                    break;
                case 2:
                    message.validator = module.exports.Validator.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = reader.int64();
                    break;
                case 4:
                    message.time = $ccb8e8f6078d2457$var$fromTimestamp($5G2s6.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.totalVotingPower = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseEvidence);
        if (object.type !== undefined && object.type !== null) message.type = $ccb8e8f6078d2457$var$evidenceTypeFromJSON(object.type);
        else message.type = 0;
        if (object.validator !== undefined && object.validator !== null) message.validator = module.exports.Validator.fromJSON(object.validator);
        else message.validator = undefined;
        if (object.height !== undefined && object.height !== null) message.height = $ccb8e8f6078d2457$var$long_1.default.fromString(object.height);
        else message.height = $ccb8e8f6078d2457$var$long_1.default.ZERO;
        if (object.time !== undefined && object.time !== null) message.time = $ccb8e8f6078d2457$var$fromJsonTimestamp(object.time);
        else message.time = undefined;
        if (object.totalVotingPower !== undefined && object.totalVotingPower !== null) message.totalVotingPower = $ccb8e8f6078d2457$var$long_1.default.fromString(object.totalVotingPower);
        else message.totalVotingPower = $ccb8e8f6078d2457$var$long_1.default.ZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.type !== undefined && (obj.type = $ccb8e8f6078d2457$var$evidenceTypeToJSON(message.type));
        message.validator !== undefined && (obj.validator = message.validator ? module.exports.Validator.toJSON(message.validator) : undefined);
        message.height !== undefined && (obj.height = (message.height || $ccb8e8f6078d2457$var$long_1.default.ZERO).toString());
        message.time !== undefined && (obj.time = message.time.toISOString());
        message.totalVotingPower !== undefined && (obj.totalVotingPower = (message.totalVotingPower || $ccb8e8f6078d2457$var$long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseEvidence);
        if (object.type !== undefined && object.type !== null) message.type = object.type;
        else message.type = 0;
        if (object.validator !== undefined && object.validator !== null) message.validator = module.exports.Validator.fromPartial(object.validator);
        else message.validator = undefined;
        if (object.height !== undefined && object.height !== null) message.height = object.height;
        else message.height = $ccb8e8f6078d2457$var$long_1.default.ZERO;
        if (object.time !== undefined && object.time !== null) message.time = object.time;
        else message.time = undefined;
        if (object.totalVotingPower !== undefined && object.totalVotingPower !== null) message.totalVotingPower = object.totalVotingPower;
        else message.totalVotingPower = $ccb8e8f6078d2457$var$long_1.default.ZERO;
        return message;
    }
};
const $ccb8e8f6078d2457$var$baseSnapshot = {
    height: $ccb8e8f6078d2457$var$long_1.default.UZERO,
    format: 0,
    chunks: 0
};
module.exports.Snapshot = {
    encode (message, writer = $ccb8e8f6078d2457$var$minimal_1.default.Writer.create()) {
        if (!message.height.isZero()) writer.uint32(8).uint64(message.height);
        if (message.format !== 0) writer.uint32(16).uint32(message.format);
        if (message.chunks !== 0) writer.uint32(24).uint32(message.chunks);
        if (message.hash.length !== 0) writer.uint32(34).bytes(message.hash);
        if (message.metadata.length !== 0) writer.uint32(42).bytes(message.metadata);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ccb8e8f6078d2457$var$minimal_1.default.Reader ? input : new $ccb8e8f6078d2457$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseSnapshot);
        message.hash = new Uint8Array();
        message.metadata = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.uint64();
                    break;
                case 2:
                    message.format = reader.uint32();
                    break;
                case 3:
                    message.chunks = reader.uint32();
                    break;
                case 4:
                    message.hash = reader.bytes();
                    break;
                case 5:
                    message.metadata = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseSnapshot);
        message.hash = new Uint8Array();
        message.metadata = new Uint8Array();
        if (object.height !== undefined && object.height !== null) message.height = $ccb8e8f6078d2457$var$long_1.default.fromString(object.height);
        else message.height = $ccb8e8f6078d2457$var$long_1.default.UZERO;
        if (object.format !== undefined && object.format !== null) message.format = Number(object.format);
        else message.format = 0;
        if (object.chunks !== undefined && object.chunks !== null) message.chunks = Number(object.chunks);
        else message.chunks = 0;
        if (object.hash !== undefined && object.hash !== null) message.hash = $ccb8e8f6078d2457$var$bytesFromBase64(object.hash);
        if (object.metadata !== undefined && object.metadata !== null) message.metadata = $ccb8e8f6078d2457$var$bytesFromBase64(object.metadata);
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || $ccb8e8f6078d2457$var$long_1.default.UZERO).toString());
        message.format !== undefined && (obj.format = message.format);
        message.chunks !== undefined && (obj.chunks = message.chunks);
        message.hash !== undefined && (obj.hash = $ccb8e8f6078d2457$var$base64FromBytes(message.hash !== undefined ? message.hash : new Uint8Array()));
        message.metadata !== undefined && (obj.metadata = $ccb8e8f6078d2457$var$base64FromBytes(message.metadata !== undefined ? message.metadata : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ccb8e8f6078d2457$var$baseSnapshot);
        if (object.height !== undefined && object.height !== null) message.height = object.height;
        else message.height = $ccb8e8f6078d2457$var$long_1.default.UZERO;
        if (object.format !== undefined && object.format !== null) message.format = object.format;
        else message.format = 0;
        if (object.chunks !== undefined && object.chunks !== null) message.chunks = object.chunks;
        else message.chunks = 0;
        if (object.hash !== undefined && object.hash !== null) message.hash = object.hash;
        else message.hash = new Uint8Array();
        if (object.metadata !== undefined && object.metadata !== null) message.metadata = object.metadata;
        else message.metadata = new Uint8Array();
        return message;
    }
};
class $ccb8e8f6078d2457$var$ABCIApplicationClientImpl {
    Echo(request, metadata) {
        return this.rpc.unary(module.exports.ABCIApplicationEchoDesc, module.exports.RequestEcho.fromPartial(request), metadata);
    }
    Flush(request, metadata) {
        return this.rpc.unary(module.exports.ABCIApplicationFlushDesc, module.exports.RequestFlush.fromPartial(request), metadata);
    }
    Info(request, metadata) {
        return this.rpc.unary(module.exports.ABCIApplicationInfoDesc, module.exports.RequestInfo.fromPartial(request), metadata);
    }
    SetOption(request, metadata) {
        return this.rpc.unary(module.exports.ABCIApplicationSetOptionDesc, module.exports.RequestSetOption.fromPartial(request), metadata);
    }
    DeliverTx(request, metadata) {
        return this.rpc.unary(module.exports.ABCIApplicationDeliverTxDesc, module.exports.RequestDeliverTx.fromPartial(request), metadata);
    }
    CheckTx(request, metadata) {
        return this.rpc.unary(module.exports.ABCIApplicationCheckTxDesc, module.exports.RequestCheckTx.fromPartial(request), metadata);
    }
    Query(request, metadata) {
        return this.rpc.unary(module.exports.ABCIApplicationQueryDesc, module.exports.RequestQuery.fromPartial(request), metadata);
    }
    Commit(request, metadata) {
        return this.rpc.unary(module.exports.ABCIApplicationCommitDesc, module.exports.RequestCommit.fromPartial(request), metadata);
    }
    InitChain(request, metadata) {
        return this.rpc.unary(module.exports.ABCIApplicationInitChainDesc, module.exports.RequestInitChain.fromPartial(request), metadata);
    }
    BeginBlock(request, metadata) {
        return this.rpc.unary(module.exports.ABCIApplicationBeginBlockDesc, module.exports.RequestBeginBlock.fromPartial(request), metadata);
    }
    EndBlock(request, metadata) {
        return this.rpc.unary(module.exports.ABCIApplicationEndBlockDesc, module.exports.RequestEndBlock.fromPartial(request), metadata);
    }
    ListSnapshots(request, metadata) {
        return this.rpc.unary(module.exports.ABCIApplicationListSnapshotsDesc, module.exports.RequestListSnapshots.fromPartial(request), metadata);
    }
    OfferSnapshot(request, metadata) {
        return this.rpc.unary(module.exports.ABCIApplicationOfferSnapshotDesc, module.exports.RequestOfferSnapshot.fromPartial(request), metadata);
    }
    LoadSnapshotChunk(request, metadata) {
        return this.rpc.unary(module.exports.ABCIApplicationLoadSnapshotChunkDesc, module.exports.RequestLoadSnapshotChunk.fromPartial(request), metadata);
    }
    ApplySnapshotChunk(request, metadata) {
        return this.rpc.unary(module.exports.ABCIApplicationApplySnapshotChunkDesc, module.exports.RequestApplySnapshotChunk.fromPartial(request), metadata);
    }
    constructor(rpc){
        this.rpc = rpc;
        this.Echo = this.Echo.bind(this);
        this.Flush = this.Flush.bind(this);
        this.Info = this.Info.bind(this);
        this.SetOption = this.SetOption.bind(this);
        this.DeliverTx = this.DeliverTx.bind(this);
        this.CheckTx = this.CheckTx.bind(this);
        this.Query = this.Query.bind(this);
        this.Commit = this.Commit.bind(this);
        this.InitChain = this.InitChain.bind(this);
        this.BeginBlock = this.BeginBlock.bind(this);
        this.EndBlock = this.EndBlock.bind(this);
        this.ListSnapshots = this.ListSnapshots.bind(this);
        this.OfferSnapshot = this.OfferSnapshot.bind(this);
        this.LoadSnapshotChunk = this.LoadSnapshotChunk.bind(this);
        this.ApplySnapshotChunk = this.ApplySnapshotChunk.bind(this);
    }
}
module.exports.ABCIApplicationClientImpl = $ccb8e8f6078d2457$var$ABCIApplicationClientImpl;
module.exports.ABCIApplicationDesc = {
    serviceName: "tendermint.abci.ABCIApplication"
};
module.exports.ABCIApplicationEchoDesc = {
    methodName: "Echo",
    service: module.exports.ABCIApplicationDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.RequestEcho.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.ResponseEcho.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.ABCIApplicationFlushDesc = {
    methodName: "Flush",
    service: module.exports.ABCIApplicationDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.RequestFlush.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.ResponseFlush.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.ABCIApplicationInfoDesc = {
    methodName: "Info",
    service: module.exports.ABCIApplicationDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.RequestInfo.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.ResponseInfo.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.ABCIApplicationSetOptionDesc = {
    methodName: "SetOption",
    service: module.exports.ABCIApplicationDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.RequestSetOption.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.ResponseSetOption.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.ABCIApplicationDeliverTxDesc = {
    methodName: "DeliverTx",
    service: module.exports.ABCIApplicationDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.RequestDeliverTx.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.ResponseDeliverTx.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.ABCIApplicationCheckTxDesc = {
    methodName: "CheckTx",
    service: module.exports.ABCIApplicationDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.RequestCheckTx.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.ResponseCheckTx.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.ABCIApplicationQueryDesc = {
    methodName: "Query",
    service: module.exports.ABCIApplicationDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.RequestQuery.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.ResponseQuery.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.ABCIApplicationCommitDesc = {
    methodName: "Commit",
    service: module.exports.ABCIApplicationDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.RequestCommit.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.ResponseCommit.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.ABCIApplicationInitChainDesc = {
    methodName: "InitChain",
    service: module.exports.ABCIApplicationDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.RequestInitChain.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.ResponseInitChain.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.ABCIApplicationBeginBlockDesc = {
    methodName: "BeginBlock",
    service: module.exports.ABCIApplicationDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.RequestBeginBlock.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.ResponseBeginBlock.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.ABCIApplicationEndBlockDesc = {
    methodName: "EndBlock",
    service: module.exports.ABCIApplicationDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.RequestEndBlock.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.ResponseEndBlock.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.ABCIApplicationListSnapshotsDesc = {
    methodName: "ListSnapshots",
    service: module.exports.ABCIApplicationDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.RequestListSnapshots.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.ResponseListSnapshots.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.ABCIApplicationOfferSnapshotDesc = {
    methodName: "OfferSnapshot",
    service: module.exports.ABCIApplicationDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.RequestOfferSnapshot.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.ResponseOfferSnapshot.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.ABCIApplicationLoadSnapshotChunkDesc = {
    methodName: "LoadSnapshotChunk",
    service: module.exports.ABCIApplicationDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.RequestLoadSnapshotChunk.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.ResponseLoadSnapshotChunk.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.ABCIApplicationApplySnapshotChunkDesc = {
    methodName: "ApplySnapshotChunk",
    service: module.exports.ABCIApplicationDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.RequestApplySnapshotChunk.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.ResponseApplySnapshotChunk.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
class $ccb8e8f6078d2457$var$GrpcWebImpl {
    unary(methodDesc, _request, metadata) {
        var _a;
        const request = Object.assign(Object.assign({}, _request), methodDesc.requestType);
        const maybeCombinedMetadata = metadata && this.options.metadata ? new $1pqjL.BrowserHeaders(Object.assign(Object.assign({}, (_a = this.options) === null || _a === void 0 ? void 0 : _a.metadata.headersMap), metadata === null || metadata === void 0 ? void 0 : metadata.headersMap)) : metadata || this.options.metadata;
        return new Promise((resolve, reject)=>{
            $jXVni.grpc.unary(methodDesc, {
                request: request,
                host: this.host,
                metadata: maybeCombinedMetadata,
                transport: this.options.transport,
                debug: this.options.debug,
                onEnd: function(response) {
                    if (response.status === $jXVni.grpc.Code.OK) resolve(response.message);
                    else {
                        const err = new Error(response.statusMessage);
                        err.code = response.status;
                        err.metadata = response.trailers;
                        reject(err);
                    }
                }
            });
        });
    }
    constructor(host, options){
        this.host = host;
        this.options = options;
    }
}
module.exports.GrpcWebImpl = $ccb8e8f6078d2457$var$GrpcWebImpl;
var $ccb8e8f6078d2457$var$globalThis = (()=>{
    if (typeof $ccb8e8f6078d2457$var$globalThis !== "undefined") return $ccb8e8f6078d2457$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $ccb8e8f6078d2457$var$atob = $ccb8e8f6078d2457$var$globalThis.atob || ((b64)=>$ccb8e8f6078d2457$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $ccb8e8f6078d2457$var$bytesFromBase64(b64) {
    const bin = $ccb8e8f6078d2457$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $ccb8e8f6078d2457$var$btoa = $ccb8e8f6078d2457$var$globalThis.btoa || ((bin)=>$ccb8e8f6078d2457$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $ccb8e8f6078d2457$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $ccb8e8f6078d2457$var$btoa(bin.join(""));
}
function $ccb8e8f6078d2457$var$toTimestamp(date) {
    const seconds = $ccb8e8f6078d2457$var$numberToLong(date.getTime() / 1000);
    const nanos = date.getTime() % 1000 * 1000000;
    return {
        seconds: seconds,
        nanos: nanos
    };
}
function $ccb8e8f6078d2457$var$fromTimestamp(t) {
    let millis = t.seconds.toNumber() * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function $ccb8e8f6078d2457$var$fromJsonTimestamp(o) {
    if (o instanceof Date) return o;
    else if (typeof o === "string") return new Date(o);
    else return $ccb8e8f6078d2457$var$fromTimestamp($5G2s6.Timestamp.fromJSON(o));
}
function $ccb8e8f6078d2457$var$numberToLong(number) {
    return $ccb8e8f6078d2457$var$long_1.default.fromNumber(number);
}
if ($ccb8e8f6078d2457$var$minimal_1.default.util.Long !== $ccb8e8f6078d2457$var$long_1.default) {
    $ccb8e8f6078d2457$var$minimal_1.default.util.Long = $ccb8e8f6078d2457$var$long_1.default;
    $ccb8e8f6078d2457$var$minimal_1.default.configure();
}

});
parcelRegister("4csTs", function(module, exports) {
"use strict";
var $30eeb2108ec9a947$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HashedParams = module.exports.VersionParams = module.exports.ValidatorParams = module.exports.EvidenceParams = module.exports.BlockParams = module.exports.ConsensusParams = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $30eeb2108ec9a947$var$long_1 = $30eeb2108ec9a947$var$__importDefault((parcelRequire("9A55m")));

const $30eeb2108ec9a947$var$minimal_1 = $30eeb2108ec9a947$var$__importDefault((parcelRequire("i2pIU")));

var $dmomH = parcelRequire("dmomH");
module.exports.protobufPackage = "tendermint.types";
const $30eeb2108ec9a947$var$baseConsensusParams = {};
module.exports.ConsensusParams = {
    encode (message, writer = $30eeb2108ec9a947$var$minimal_1.default.Writer.create()) {
        if (message.block !== undefined) module.exports.BlockParams.encode(message.block, writer.uint32(10).fork()).ldelim();
        if (message.evidence !== undefined) module.exports.EvidenceParams.encode(message.evidence, writer.uint32(18).fork()).ldelim();
        if (message.validator !== undefined) module.exports.ValidatorParams.encode(message.validator, writer.uint32(26).fork()).ldelim();
        if (message.version !== undefined) module.exports.VersionParams.encode(message.version, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $30eeb2108ec9a947$var$minimal_1.default.Reader ? input : new $30eeb2108ec9a947$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $30eeb2108ec9a947$var$baseConsensusParams);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.block = module.exports.BlockParams.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.evidence = module.exports.EvidenceParams.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.validator = module.exports.ValidatorParams.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.version = module.exports.VersionParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $30eeb2108ec9a947$var$baseConsensusParams);
        if (object.block !== undefined && object.block !== null) message.block = module.exports.BlockParams.fromJSON(object.block);
        else message.block = undefined;
        if (object.evidence !== undefined && object.evidence !== null) message.evidence = module.exports.EvidenceParams.fromJSON(object.evidence);
        else message.evidence = undefined;
        if (object.validator !== undefined && object.validator !== null) message.validator = module.exports.ValidatorParams.fromJSON(object.validator);
        else message.validator = undefined;
        if (object.version !== undefined && object.version !== null) message.version = module.exports.VersionParams.fromJSON(object.version);
        else message.version = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.block !== undefined && (obj.block = message.block ? module.exports.BlockParams.toJSON(message.block) : undefined);
        message.evidence !== undefined && (obj.evidence = message.evidence ? module.exports.EvidenceParams.toJSON(message.evidence) : undefined);
        message.validator !== undefined && (obj.validator = message.validator ? module.exports.ValidatorParams.toJSON(message.validator) : undefined);
        message.version !== undefined && (obj.version = message.version ? module.exports.VersionParams.toJSON(message.version) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $30eeb2108ec9a947$var$baseConsensusParams);
        if (object.block !== undefined && object.block !== null) message.block = module.exports.BlockParams.fromPartial(object.block);
        else message.block = undefined;
        if (object.evidence !== undefined && object.evidence !== null) message.evidence = module.exports.EvidenceParams.fromPartial(object.evidence);
        else message.evidence = undefined;
        if (object.validator !== undefined && object.validator !== null) message.validator = module.exports.ValidatorParams.fromPartial(object.validator);
        else message.validator = undefined;
        if (object.version !== undefined && object.version !== null) message.version = module.exports.VersionParams.fromPartial(object.version);
        else message.version = undefined;
        return message;
    }
};
const $30eeb2108ec9a947$var$baseBlockParams = {
    maxBytes: $30eeb2108ec9a947$var$long_1.default.ZERO,
    maxGas: $30eeb2108ec9a947$var$long_1.default.ZERO,
    timeIotaMs: $30eeb2108ec9a947$var$long_1.default.ZERO
};
module.exports.BlockParams = {
    encode (message, writer = $30eeb2108ec9a947$var$minimal_1.default.Writer.create()) {
        if (!message.maxBytes.isZero()) writer.uint32(8).int64(message.maxBytes);
        if (!message.maxGas.isZero()) writer.uint32(16).int64(message.maxGas);
        if (!message.timeIotaMs.isZero()) writer.uint32(24).int64(message.timeIotaMs);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $30eeb2108ec9a947$var$minimal_1.default.Reader ? input : new $30eeb2108ec9a947$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $30eeb2108ec9a947$var$baseBlockParams);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.maxBytes = reader.int64();
                    break;
                case 2:
                    message.maxGas = reader.int64();
                    break;
                case 3:
                    message.timeIotaMs = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $30eeb2108ec9a947$var$baseBlockParams);
        if (object.maxBytes !== undefined && object.maxBytes !== null) message.maxBytes = $30eeb2108ec9a947$var$long_1.default.fromString(object.maxBytes);
        else message.maxBytes = $30eeb2108ec9a947$var$long_1.default.ZERO;
        if (object.maxGas !== undefined && object.maxGas !== null) message.maxGas = $30eeb2108ec9a947$var$long_1.default.fromString(object.maxGas);
        else message.maxGas = $30eeb2108ec9a947$var$long_1.default.ZERO;
        if (object.timeIotaMs !== undefined && object.timeIotaMs !== null) message.timeIotaMs = $30eeb2108ec9a947$var$long_1.default.fromString(object.timeIotaMs);
        else message.timeIotaMs = $30eeb2108ec9a947$var$long_1.default.ZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.maxBytes !== undefined && (obj.maxBytes = (message.maxBytes || $30eeb2108ec9a947$var$long_1.default.ZERO).toString());
        message.maxGas !== undefined && (obj.maxGas = (message.maxGas || $30eeb2108ec9a947$var$long_1.default.ZERO).toString());
        message.timeIotaMs !== undefined && (obj.timeIotaMs = (message.timeIotaMs || $30eeb2108ec9a947$var$long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $30eeb2108ec9a947$var$baseBlockParams);
        if (object.maxBytes !== undefined && object.maxBytes !== null) message.maxBytes = object.maxBytes;
        else message.maxBytes = $30eeb2108ec9a947$var$long_1.default.ZERO;
        if (object.maxGas !== undefined && object.maxGas !== null) message.maxGas = object.maxGas;
        else message.maxGas = $30eeb2108ec9a947$var$long_1.default.ZERO;
        if (object.timeIotaMs !== undefined && object.timeIotaMs !== null) message.timeIotaMs = object.timeIotaMs;
        else message.timeIotaMs = $30eeb2108ec9a947$var$long_1.default.ZERO;
        return message;
    }
};
const $30eeb2108ec9a947$var$baseEvidenceParams = {
    maxAgeNumBlocks: $30eeb2108ec9a947$var$long_1.default.ZERO,
    maxBytes: $30eeb2108ec9a947$var$long_1.default.ZERO
};
module.exports.EvidenceParams = {
    encode (message, writer = $30eeb2108ec9a947$var$minimal_1.default.Writer.create()) {
        if (!message.maxAgeNumBlocks.isZero()) writer.uint32(8).int64(message.maxAgeNumBlocks);
        if (message.maxAgeDuration !== undefined) $dmomH.Duration.encode(message.maxAgeDuration, writer.uint32(18).fork()).ldelim();
        if (!message.maxBytes.isZero()) writer.uint32(24).int64(message.maxBytes);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $30eeb2108ec9a947$var$minimal_1.default.Reader ? input : new $30eeb2108ec9a947$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $30eeb2108ec9a947$var$baseEvidenceParams);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.maxAgeNumBlocks = reader.int64();
                    break;
                case 2:
                    message.maxAgeDuration = $dmomH.Duration.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.maxBytes = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $30eeb2108ec9a947$var$baseEvidenceParams);
        if (object.maxAgeNumBlocks !== undefined && object.maxAgeNumBlocks !== null) message.maxAgeNumBlocks = $30eeb2108ec9a947$var$long_1.default.fromString(object.maxAgeNumBlocks);
        else message.maxAgeNumBlocks = $30eeb2108ec9a947$var$long_1.default.ZERO;
        if (object.maxAgeDuration !== undefined && object.maxAgeDuration !== null) message.maxAgeDuration = $dmomH.Duration.fromJSON(object.maxAgeDuration);
        else message.maxAgeDuration = undefined;
        if (object.maxBytes !== undefined && object.maxBytes !== null) message.maxBytes = $30eeb2108ec9a947$var$long_1.default.fromString(object.maxBytes);
        else message.maxBytes = $30eeb2108ec9a947$var$long_1.default.ZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.maxAgeNumBlocks !== undefined && (obj.maxAgeNumBlocks = (message.maxAgeNumBlocks || $30eeb2108ec9a947$var$long_1.default.ZERO).toString());
        message.maxAgeDuration !== undefined && (obj.maxAgeDuration = message.maxAgeDuration ? $dmomH.Duration.toJSON(message.maxAgeDuration) : undefined);
        message.maxBytes !== undefined && (obj.maxBytes = (message.maxBytes || $30eeb2108ec9a947$var$long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $30eeb2108ec9a947$var$baseEvidenceParams);
        if (object.maxAgeNumBlocks !== undefined && object.maxAgeNumBlocks !== null) message.maxAgeNumBlocks = object.maxAgeNumBlocks;
        else message.maxAgeNumBlocks = $30eeb2108ec9a947$var$long_1.default.ZERO;
        if (object.maxAgeDuration !== undefined && object.maxAgeDuration !== null) message.maxAgeDuration = $dmomH.Duration.fromPartial(object.maxAgeDuration);
        else message.maxAgeDuration = undefined;
        if (object.maxBytes !== undefined && object.maxBytes !== null) message.maxBytes = object.maxBytes;
        else message.maxBytes = $30eeb2108ec9a947$var$long_1.default.ZERO;
        return message;
    }
};
const $30eeb2108ec9a947$var$baseValidatorParams = {
    pubKeyTypes: ""
};
module.exports.ValidatorParams = {
    encode (message, writer = $30eeb2108ec9a947$var$minimal_1.default.Writer.create()) {
        for (const v of message.pubKeyTypes)writer.uint32(10).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $30eeb2108ec9a947$var$minimal_1.default.Reader ? input : new $30eeb2108ec9a947$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $30eeb2108ec9a947$var$baseValidatorParams);
        message.pubKeyTypes = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pubKeyTypes.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $30eeb2108ec9a947$var$baseValidatorParams);
        message.pubKeyTypes = [];
        if (object.pubKeyTypes !== undefined && object.pubKeyTypes !== null) for (const e of object.pubKeyTypes)message.pubKeyTypes.push(String(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.pubKeyTypes) obj.pubKeyTypes = message.pubKeyTypes.map((e)=>e);
        else obj.pubKeyTypes = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $30eeb2108ec9a947$var$baseValidatorParams);
        message.pubKeyTypes = [];
        if (object.pubKeyTypes !== undefined && object.pubKeyTypes !== null) for (const e of object.pubKeyTypes)message.pubKeyTypes.push(e);
        return message;
    }
};
const $30eeb2108ec9a947$var$baseVersionParams = {
    appVersion: $30eeb2108ec9a947$var$long_1.default.UZERO
};
module.exports.VersionParams = {
    encode (message, writer = $30eeb2108ec9a947$var$minimal_1.default.Writer.create()) {
        if (!message.appVersion.isZero()) writer.uint32(8).uint64(message.appVersion);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $30eeb2108ec9a947$var$minimal_1.default.Reader ? input : new $30eeb2108ec9a947$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $30eeb2108ec9a947$var$baseVersionParams);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.appVersion = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $30eeb2108ec9a947$var$baseVersionParams);
        if (object.appVersion !== undefined && object.appVersion !== null) message.appVersion = $30eeb2108ec9a947$var$long_1.default.fromString(object.appVersion);
        else message.appVersion = $30eeb2108ec9a947$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.appVersion !== undefined && (obj.appVersion = (message.appVersion || $30eeb2108ec9a947$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $30eeb2108ec9a947$var$baseVersionParams);
        if (object.appVersion !== undefined && object.appVersion !== null) message.appVersion = object.appVersion;
        else message.appVersion = $30eeb2108ec9a947$var$long_1.default.UZERO;
        return message;
    }
};
const $30eeb2108ec9a947$var$baseHashedParams = {
    blockMaxBytes: $30eeb2108ec9a947$var$long_1.default.ZERO,
    blockMaxGas: $30eeb2108ec9a947$var$long_1.default.ZERO
};
module.exports.HashedParams = {
    encode (message, writer = $30eeb2108ec9a947$var$minimal_1.default.Writer.create()) {
        if (!message.blockMaxBytes.isZero()) writer.uint32(8).int64(message.blockMaxBytes);
        if (!message.blockMaxGas.isZero()) writer.uint32(16).int64(message.blockMaxGas);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $30eeb2108ec9a947$var$minimal_1.default.Reader ? input : new $30eeb2108ec9a947$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $30eeb2108ec9a947$var$baseHashedParams);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.blockMaxBytes = reader.int64();
                    break;
                case 2:
                    message.blockMaxGas = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $30eeb2108ec9a947$var$baseHashedParams);
        if (object.blockMaxBytes !== undefined && object.blockMaxBytes !== null) message.blockMaxBytes = $30eeb2108ec9a947$var$long_1.default.fromString(object.blockMaxBytes);
        else message.blockMaxBytes = $30eeb2108ec9a947$var$long_1.default.ZERO;
        if (object.blockMaxGas !== undefined && object.blockMaxGas !== null) message.blockMaxGas = $30eeb2108ec9a947$var$long_1.default.fromString(object.blockMaxGas);
        else message.blockMaxGas = $30eeb2108ec9a947$var$long_1.default.ZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.blockMaxBytes !== undefined && (obj.blockMaxBytes = (message.blockMaxBytes || $30eeb2108ec9a947$var$long_1.default.ZERO).toString());
        message.blockMaxGas !== undefined && (obj.blockMaxGas = (message.blockMaxGas || $30eeb2108ec9a947$var$long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $30eeb2108ec9a947$var$baseHashedParams);
        if (object.blockMaxBytes !== undefined && object.blockMaxBytes !== null) message.blockMaxBytes = object.blockMaxBytes;
        else message.blockMaxBytes = $30eeb2108ec9a947$var$long_1.default.ZERO;
        if (object.blockMaxGas !== undefined && object.blockMaxGas !== null) message.blockMaxGas = object.blockMaxGas;
        else message.blockMaxGas = $30eeb2108ec9a947$var$long_1.default.ZERO;
        return message;
    }
};
if ($30eeb2108ec9a947$var$minimal_1.default.util.Long !== $30eeb2108ec9a947$var$long_1.default) {
    $30eeb2108ec9a947$var$minimal_1.default.util.Long = $30eeb2108ec9a947$var$long_1.default;
    $30eeb2108ec9a947$var$minimal_1.default.configure();
}

});




parcelRegister("a2Isw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("cK8Vm", function(module, exports) {
"use strict";
var $9470b40d4a7f03b6$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $9470b40d4a7f03b6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9470b40d4a7f03b6$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $9470b40d4a7f03b6$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $9470b40d4a7f03b6$var$__createBinding(result, mod, k);
    }
    $9470b40d4a7f03b6$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Deposit = void 0;

var $kYslP = parcelRequire("kYslP");

var $26Eqx = parcelRequire("26Eqx");

var $9q3yq = parcelRequire("9q3yq");

var $9470b40d4a7f03b6$var$Long = $9470b40d4a7f03b6$var$__importStar((parcelRequire("9A55m")));
/**
 * Stores deposit information for a proposal
 */ var $9470b40d4a7f03b6$var$Deposit = /** @class */ function(_super) {
    $9470b40d4a7f03b6$var$__extends(Deposit, _super);
    /**
     * @param proposal_id Id of porposal to deposit to
     * @param depositor depositor's account address
     * @param amount amount to deposit
     */ function Deposit(proposal_id, depositor, amount) {
        var _this = _super.call(this) || this;
        _this.proposal_id = proposal_id;
        _this.depositor = depositor;
        _this.amount = new $kYslP.Coins(amount);
        return _this;
    }
    Deposit.fromAmino = function(data) {
        var proposal_id = data.proposal_id, depositor = data.depositor, amount = data.amount;
        return new Deposit(Number.parseInt(proposal_id), depositor, $kYslP.Coins.fromAmino(amount));
    };
    Deposit.prototype.toAmino = function() {
        var _a = this, proposal_id = _a.proposal_id, depositor = _a.depositor, amount = _a.amount;
        return {
            proposal_id: proposal_id.toString(),
            depositor: depositor,
            amount: amount.toAmino()
        };
    };
    Deposit.fromData = function(data) {
        var proposal_id = data.proposal_id, depositor = data.depositor, amount = data.amount;
        return new Deposit(Number.parseInt(proposal_id), depositor, $kYslP.Coins.fromData(amount));
    };
    Deposit.prototype.toData = function() {
        var _a = this, proposal_id = _a.proposal_id, depositor = _a.depositor, amount = _a.amount;
        return {
            proposal_id: proposal_id.toString(),
            depositor: depositor,
            amount: amount.toData()
        };
    };
    Deposit.fromProto = function(data) {
        return new Deposit(data.proposalId.toNumber(), data.depositor, $kYslP.Coins.fromProto(data.amount));
    };
    Deposit.prototype.toProto = function() {
        var _a = this, proposal_id = _a.proposal_id, depositor = _a.depositor, amount = _a.amount;
        return $9q3yq.Deposit.fromPartial({
            proposalId: $9470b40d4a7f03b6$var$Long.fromNumber(proposal_id),
            depositor: depositor,
            amount: amount.toProto()
        });
    };
    return Deposit;
}($26Eqx.JSONSerializable);
module.exports.Deposit = $9470b40d4a7f03b6$var$Deposit;

});

parcelRegister("4jidN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MultiSignature = void 0;

var $eVVZl = parcelRequire("eVVZl");

var $9sbIx = parcelRequire("9sbIx");

var $9xHlz = parcelRequire("9xHlz");
var $3237122b01f7a875$var$MultiSignature = /** @class */ function() {
    /**
     * MultiSignature constructor
     * public_keys order must be guaranteed
     */ function MultiSignature(multisig_pubkey) {
        this.multisig_pubkey = multisig_pubkey;
        var n = multisig_pubkey.pubkeys.length;
        this.bitarray = $9sbIx.CompactBitArray.fromBits(n);
        this.signatures = [];
    }
    MultiSignature.prototype.appendSignature = function(signature_data, index) {
        var newSigIndex = this.bitarray.numTrueBitsBefore(index);
        // Signature already exists, just replace the value there
        if (this.bitarray.getIndex(index)) {
            this.signatures[newSigIndex] = signature_data;
            return;
        }
        this.bitarray.setIndex(index, true);
        // Optimization if the index is the greatest index
        if (newSigIndex == this.signatures.length) {
            this.signatures.push(signature_data);
            return;
        }
        this.signatures.splice(newSigIndex, 0, signature_data);
    };
    // adds a signature to the multisig, at the index in
    // keys corresponding to the provided pubkey.
    MultiSignature.prototype.appendSignatureFromPubKey = function(signature_data, public_key) {
        var index = this.multisig_pubkey.pubkeys.findIndex(function(v) {
            return v.key === public_key.key;
        });
        if (index == -1) throw new Error("provided key doesn't exist in public_keys");
        this.appendSignature(signature_data, index);
    };
    MultiSignature.prototype.appendSignatureV2s = function(signatures) {
        for(var _i = 0, signatures_1 = signatures; _i < signatures_1.length; _i++){
            var signature = signatures_1[_i];
            if (!(signature.public_key instanceof $eVVZl.SimplePublicKey)) throw new Error("non-SimplePublicKey cannot be used to sign multisig");
            this.appendSignatureFromPubKey(signature.data, signature.public_key);
        }
    };
    MultiSignature.prototype.toSignatureDescriptor = function() {
        return new $9xHlz.SignatureV2.Descriptor(new $9xHlz.SignatureV2.Descriptor.Multi(this.bitarray, this.signatures));
    };
    return MultiSignature;
}();
module.exports.MultiSignature = $3237122b01f7a875$var$MultiSignature;

});

parcelRegister("4Z5HV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Account = void 0;

var $7K3x8 = parcelRequire("7K3x8");

var $2Vnxc = parcelRequire("2Vnxc");

var $9UGCn = parcelRequire("9UGCn");

var $3NwSV = parcelRequire("3NwSV");

var $h7Cpe = parcelRequire("h7Cpe");

var $i1RoR = parcelRequire("i1RoR");
/**
 * Stores information about an account fetched from the blockchain.
 */ var $3a114950f680ee0d$var$Account;
(function(Account) {
    function fromAmino(amino, isClassic) {
        switch(amino.type){
            case "core/Account":
            case "cosmos-sdk/BaseAccount":
                return $7K3x8.BaseAccount.fromAmino(amino, isClassic);
            case "core/BaseVestingAccount":
            case "cosmos-sdk/BaseVestingAccount":
                return $i1RoR.BaseVestingAccount.fromAmino(amino, isClassic);
            case "core/LazyGradedVestingAccount":
                return $2Vnxc.LazyGradedVestingAccount.fromAmino(amino, isClassic);
            case "cosmos-sdk/ContinuousVestingAccount":
                return $9UGCn.ContinuousVestingAccount.fromAmino(amino, isClassic);
            case "cosmos-sdk/DelayedVestingAccount":
                return $3NwSV.DelayedVestingAccount.fromAmino(amino, isClassic);
            case "cosmos-sdk/PeriodicVestingAccount":
                return $h7Cpe.PeriodicVestingAccount.fromAmino(amino, isClassic);
        }
    }
    Account.fromAmino = fromAmino;
    function fromData(data, isClassic) {
        switch(data["@type"]){
            case "/cosmos.auth.v1beta1.BaseAccount":
                return $7K3x8.BaseAccount.fromData(data, isClassic);
            case "/cosmos.vesting.v1beta1.BaseVestingAccount":
                return $i1RoR.BaseVestingAccount.fromData(data, isClassic);
            case "/terra.vesting.v1beta1.LazyGradedVestingAccount":
                return $2Vnxc.LazyGradedVestingAccount.fromData(data, isClassic);
            case "/cosmos.vesting.v1beta1.ContinuousVestingAccount":
                return $9UGCn.ContinuousVestingAccount.fromData(data, isClassic);
            case "/cosmos.vesting.v1beta1.DelayedVestingAccount":
                return $3NwSV.DelayedVestingAccount.fromData(data, isClassic);
            case "/cosmos.vesting.v1beta1.PeriodicVestingAccount":
                return $h7Cpe.PeriodicVestingAccount.fromData(data, isClassic);
        }
    }
    Account.fromData = fromData;
    function fromProto(accountAny, isClassic) {
        var typeUrl = accountAny.typeUrl;
        if (typeUrl === "/cosmos.auth.v1beta1.BaseAccount") return $7K3x8.BaseAccount.unpackAny(accountAny, isClassic);
        else if (typeUrl === "/terra.vesting.v1beta1.LazyGradedVestingAccount") return $2Vnxc.LazyGradedVestingAccount.unpackAny(accountAny, isClassic);
        else if (typeUrl === "/cosmos.vesting.v1beta1.ContinuousVestingAccount") return $9UGCn.ContinuousVestingAccount.unpackAny(accountAny, isClassic);
        else if (typeUrl === "/cosmos.vesting.v1beta1.DelayedVestingAccount") return $3NwSV.DelayedVestingAccount.unpackAny(accountAny, isClassic);
        else if (typeUrl === "/cosmos.vesting.v1beta1.PeriodicVestingAccount") return $h7Cpe.PeriodicVestingAccount.unpackAny(accountAny, isClassic);
        throw new Error("Account type ".concat(typeUrl, " not recognized"));
    }
    Account.fromProto = fromProto;
})($3a114950f680ee0d$var$Account = module.exports.Account || (module.exports.Account = {}));

});
parcelRegister("7K3x8", function(module, exports) {
"use strict";
var $5a2f91ed597a7326$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $5a2f91ed597a7326$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5a2f91ed597a7326$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $5a2f91ed597a7326$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5a2f91ed597a7326$var$__createBinding(result, mod, k);
    }
    $5a2f91ed597a7326$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BaseAccount = void 0;

var $eVVZl = parcelRequire("eVVZl");

var $26Eqx = parcelRequire("26Eqx");

var $8Ali1 = parcelRequire("8Ali1");

var $c5FxR = parcelRequire("c5FxR");

var $5a2f91ed597a7326$var$Long = $5a2f91ed597a7326$var$__importStar((parcelRequire("9A55m")));
/**
 * Stores information about an account fetched from the blockchain.
 */ var $5a2f91ed597a7326$var$BaseAccount = /** @class */ function(_super) {
    $5a2f91ed597a7326$var$__extends(BaseAccount, _super);
    /**
     * Creates a new Account object, holding information about a basic account.
     *
     * @param address account address
     * @param public_key account's public key information
     * @param account_number account number on the blockchain
     * @param sequence sequence number, or number of transactions that have been posted
     */ function BaseAccount(address, public_key, account_number, sequence) {
        var _this = _super.call(this) || this;
        _this.address = address;
        _this.public_key = public_key;
        _this.account_number = account_number;
        _this.sequence = sequence;
        return _this;
    }
    BaseAccount.prototype.getAccountNumber = function() {
        return this.account_number;
    };
    BaseAccount.prototype.getSequenceNumber = function() {
        return this.sequence;
    };
    BaseAccount.prototype.getPublicKey = function() {
        return this.public_key;
    };
    BaseAccount.prototype.toAmino = function(isClassic) {
        var _a = this, address = _a.address, public_key = _a.public_key, account_number = _a.account_number, sequence = _a.sequence;
        return {
            type: isClassic ? "core/Account" : "cosmos-sdk/BaseAccount",
            value: {
                address: address,
                public_key: public_key ? public_key.toAmino() : null,
                account_number: account_number.toFixed(),
                sequence: sequence.toFixed()
            }
        };
    };
    BaseAccount.fromAmino = function(data, _) {
        _;
        var _a = data.value, address = _a.address, public_key = _a.public_key, account_number = _a.account_number, sequence = _a.sequence;
        return new BaseAccount(address || "", public_key ? $eVVZl.PublicKey.fromAmino(public_key) : null, Number.parseInt(account_number) || 0, Number.parseInt(sequence) || 0);
    };
    BaseAccount.fromData = function(data, _) {
        _;
        var address = data.address, pub_key = data.pub_key, account_number = data.account_number, sequence = data.sequence;
        return new BaseAccount(address || "", pub_key ? $eVVZl.PublicKey.fromData(pub_key) : null, Number.parseInt(account_number) || 0, Number.parseInt(sequence) || 0);
    };
    BaseAccount.prototype.toData = function(_) {
        _;
        var _a = this, address = _a.address, public_key = _a.public_key, account_number = _a.account_number, sequence = _a.sequence;
        return {
            "@type": "/cosmos.auth.v1beta1.BaseAccount",
            address: address,
            pub_key: public_key ? public_key.toData() : null,
            account_number: account_number.toFixed(),
            sequence: sequence.toFixed()
        };
    };
    BaseAccount.prototype.toProto = function(_) {
        _;
        var _a = this, address = _a.address, public_key = _a.public_key, account_number = _a.account_number, sequence = _a.sequence;
        return $8Ali1.BaseAccount.fromPartial({
            address: address,
            pubKey: public_key === null || public_key === void 0 ? void 0 : public_key.packAny(),
            accountNumber: $5a2f91ed597a7326$var$Long.fromNumber(account_number),
            sequence: $5a2f91ed597a7326$var$Long.fromNumber(sequence)
        });
    };
    BaseAccount.fromProto = function(baseAccountProto, _) {
        _;
        var pubkey = baseAccountProto.pubKey;
        return new BaseAccount(baseAccountProto.address, pubkey ? $eVVZl.PublicKey.fromProto(pubkey) : null, baseAccountProto.accountNumber.toNumber(), baseAccountProto.sequence.toNumber());
    };
    BaseAccount.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmos.auth.v1beta1.BaseAccount",
            value: $8Ali1.BaseAccount.encode(this.toProto(isClassic)).finish()
        });
    };
    BaseAccount.unpackAny = function(pubkeyAny, isClassic) {
        return BaseAccount.fromProto($8Ali1.BaseAccount.decode(pubkeyAny.value), isClassic);
    };
    return BaseAccount;
}($26Eqx.JSONSerializable);
module.exports.BaseAccount = $5a2f91ed597a7326$var$BaseAccount;

});

parcelRegister("2Vnxc", function(module, exports) {
"use strict";
var $22132919382078b1$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $22132919382078b1$var$__assign = module.exports && module.exports.__assign || function() {
    $22132919382078b1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $22132919382078b1$var$__assign.apply(this, arguments);
};
var $22132919382078b1$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $22132919382078b1$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $22132919382078b1$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $22132919382078b1$var$__createBinding(result, mod, k);
    }
    $22132919382078b1$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LazyGradedVestingAccount = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $i1RoR = parcelRequire("i1RoR");

var $5iXRZ = parcelRequire("5iXRZ");

var $4X1Bi = parcelRequire("4X1Bi");

var $c5FxR = parcelRequire("c5FxR");

var $22132919382078b1$var$Long = $22132919382078b1$var$__importStar((parcelRequire("9A55m")));
/**
 * Holds information about a Account which has vesting information.
 */ var $22132919382078b1$var$LazyGradedVestingAccount = /** @class */ function(_super) {
    $22132919382078b1$var$__extends(LazyGradedVestingAccount, _super);
    /**
     *
     * @param base_vesting_account account information
     * @param vesting_schedules Entries that make up vesting
     */ function LazyGradedVestingAccount(base_vesting_account, vesting_schedules) {
        var _this = _super.call(this) || this;
        _this.base_vesting_account = base_vesting_account;
        _this.vesting_schedules = vesting_schedules;
        return _this;
    }
    LazyGradedVestingAccount.prototype.getAccountNumber = function() {
        return this.base_vesting_account.getAccountNumber();
    };
    LazyGradedVestingAccount.prototype.getSequenceNumber = function() {
        return this.base_vesting_account.getSequenceNumber();
    };
    LazyGradedVestingAccount.prototype.getPublicKey = function() {
        return this.base_vesting_account.base_account.public_key;
    };
    LazyGradedVestingAccount.prototype.toAmino = function(_) {
        _;
        var _a = this, base_vesting_account = _a.base_vesting_account, vesting_schedules = _a.vesting_schedules;
        return {
            type: "core/LazyGradedVestingAccount",
            value: {
                base_vesting_account: base_vesting_account.toAmino().value,
                vesting_schedules: vesting_schedules.map(function(vs) {
                    return vs.toAmino();
                })
            }
        };
    };
    LazyGradedVestingAccount.fromAmino = function(data, _) {
        _;
        var base_vesting_account = $i1RoR.BaseVestingAccount.fromAmino({
            type: "core/BaseVestingAccount",
            value: data.value.base_vesting_account
        });
        return new LazyGradedVestingAccount(base_vesting_account, data.value.vesting_schedules.map(function(vs) {
            return LazyGradedVestingAccount.VestingSchedule.fromAmino(vs);
        }));
    };
    LazyGradedVestingAccount.prototype.toData = function(_) {
        _;
        var _a = this, base_vesting_account = _a.base_vesting_account, vesting_schedules = _a.vesting_schedules;
        return {
            "@type": "/terra.vesting.v1beta1.LazyGradedVestingAccount",
            base_vesting_account: base_vesting_account.toData(),
            vesting_schedules: vesting_schedules.map(function(vs) {
                return vs.toData();
            })
        };
    };
    LazyGradedVestingAccount.fromData = function(data, _) {
        _;
        var base_vesting_account = $i1RoR.BaseVestingAccount.fromData($22132919382078b1$var$__assign({
            "@type": "/cosmos.vesting.v1beta1.BaseVestingAccount"
        }, data.base_vesting_account));
        return new LazyGradedVestingAccount(base_vesting_account, data.vesting_schedules.map(function(vs) {
            return LazyGradedVestingAccount.VestingSchedule.fromData(vs);
        }));
    };
    LazyGradedVestingAccount.prototype.toProto = function(_) {
        _;
        var _a = this, base_vesting_account = _a.base_vesting_account, vesting_schedules = _a.vesting_schedules;
        return $4X1Bi.LazyGradedVestingAccount.fromPartial({
            baseVestingAccount: base_vesting_account.toProto(),
            vestingSchedules: vesting_schedules.map(function(s) {
                return s.toProto();
            })
        });
    };
    LazyGradedVestingAccount.fromProto = function(lazyGradedVestingAccountProto, _) {
        var _this = this;
        _;
        var baseVestingAccount = $i1RoR.BaseVestingAccount.fromProto(lazyGradedVestingAccountProto.baseVestingAccount);
        return new LazyGradedVestingAccount(baseVestingAccount, lazyGradedVestingAccountProto.vestingSchedules.map(function(s) {
            return _this.VestingSchedule.fromProto(s);
        }));
    };
    LazyGradedVestingAccount.prototype.packAny = function(isClassic) {
        return $c5FxR.Any.fromPartial({
            typeUrl: "/terra.vesting.v1beta1.LazyGradedVestingAccount",
            value: $4X1Bi.LazyGradedVestingAccount.encode(this.toProto(isClassic)).finish()
        });
    };
    LazyGradedVestingAccount.unpackAny = function(pubkeyAny, isClassic) {
        return LazyGradedVestingAccount.fromProto($4X1Bi.LazyGradedVestingAccount.decode(pubkeyAny.value), isClassic);
    };
    return LazyGradedVestingAccount;
}($26Eqx.JSONSerializable);
module.exports.LazyGradedVestingAccount = $22132919382078b1$var$LazyGradedVestingAccount;
(function(LazyGradedVestingAccount) {
    var VestingSchedule = /** @class */ function(_super) {
        $22132919382078b1$var$__extends(VestingSchedule, _super);
        function VestingSchedule(denom, schedules) {
            var _this = _super.call(this) || this;
            _this.denom = denom;
            _this.schedules = schedules;
            return _this;
        }
        VestingSchedule.prototype.toAmino = function() {
            var _a = this, denom = _a.denom, schedules = _a.schedules;
            return {
                denom: denom,
                schedules: schedules.map(function(s) {
                    return s.toAmino();
                })
            };
        };
        VestingSchedule.fromAmino = function(data) {
            var denom = data.denom, schedules = data.schedules;
            return new VestingSchedule(denom, schedules.map(function(s) {
                return VestingSchedule.Entry.fromAmino(s);
            }));
        };
        VestingSchedule.prototype.toData = function() {
            var _a = this, denom = _a.denom, schedules = _a.schedules;
            return {
                denom: denom,
                schedules: schedules.map(function(s) {
                    return s.toData();
                })
            };
        };
        VestingSchedule.fromData = function(data) {
            var denom = data.denom, schedules = data.schedules;
            return new VestingSchedule(denom, schedules.map(function(s) {
                return VestingSchedule.Entry.fromData(s);
            }));
        };
        VestingSchedule.prototype.toProto = function() {
            var _a = this, denom = _a.denom, schedules = _a.schedules;
            return $4X1Bi.VestingSchedule.fromPartial({
                denom: denom,
                schedules: schedules.map(function(s) {
                    return s.toProto();
                })
            });
        };
        VestingSchedule.fromProto = function(vestingScheduleProto) {
            return new VestingSchedule(vestingScheduleProto.denom, vestingScheduleProto.schedules.map(function(s) {
                return VestingSchedule.Entry.fromProto(s);
            }));
        };
        return VestingSchedule;
    }($26Eqx.JSONSerializable);
    LazyGradedVestingAccount.VestingSchedule = VestingSchedule;
    (function(VestingSchedule) {
        var Entry = /** @class */ function(_super) {
            $22132919382078b1$var$__extends(Entry, _super);
            /**
             *
             * @param start_time Starting time (block height)
             * @param end_time Ending time (block height)
             * @param ratio Ratio (percentage of vested funds that should be released)
             */ function Entry(start_time, end_time, ratio) {
                var _this = _super.call(this) || this;
                _this.start_time = start_time;
                _this.end_time = end_time;
                _this.ratio = ratio;
                return _this;
            }
            Entry.fromAmino = function(data) {
                var start_time = data.start_time, end_time = data.end_time, ratio = data.ratio;
                return new Entry(Number.parseInt(start_time), Number.parseInt(end_time), new $5iXRZ.Dec(ratio));
            };
            Entry.prototype.toAmino = function() {
                return {
                    start_time: this.start_time.toFixed(),
                    end_time: this.end_time.toFixed(),
                    ratio: this.ratio.toString()
                };
            };
            Entry.fromData = function(data) {
                var start_time = data.start_time, end_time = data.end_time, ratio = data.ratio;
                return new Entry(Number.parseInt(start_time), Number.parseInt(end_time), new $5iXRZ.Dec(ratio));
            };
            Entry.prototype.toData = function() {
                return {
                    start_time: this.start_time.toFixed(),
                    end_time: this.end_time.toFixed(),
                    ratio: this.ratio.toString()
                };
            };
            Entry.fromProto = function(entryProto) {
                return new Entry(entryProto.endTime.toNumber(), entryProto.startTime.toNumber(), new $5iXRZ.Dec(entryProto.ratio));
            };
            Entry.prototype.toProto = function() {
                return $4X1Bi.Schedule.fromPartial({
                    endTime: $22132919382078b1$var$Long.fromNumber(this.end_time),
                    ratio: this.ratio.toString(),
                    startTime: $22132919382078b1$var$Long.fromNumber(this.start_time)
                });
            };
            return Entry;
        }($26Eqx.JSONSerializable);
        VestingSchedule.Entry = Entry;
    })(VestingSchedule = LazyGradedVestingAccount.VestingSchedule || (LazyGradedVestingAccount.VestingSchedule = {}));
})($22132919382078b1$var$LazyGradedVestingAccount = module.exports.LazyGradedVestingAccount || (module.exports.LazyGradedVestingAccount = {}));
module.exports.LazyGradedVestingAccount = $22132919382078b1$var$LazyGradedVestingAccount;

});
parcelRegister("i1RoR", function(module, exports) {
"use strict";
var $d201be1e332b9665$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $d201be1e332b9665$var$__assign = module.exports && module.exports.__assign || function() {
    $d201be1e332b9665$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d201be1e332b9665$var$__assign.apply(this, arguments);
};
var $d201be1e332b9665$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d201be1e332b9665$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $d201be1e332b9665$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $d201be1e332b9665$var$__createBinding(result, mod, k);
    }
    $d201be1e332b9665$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BaseVestingAccount = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $kYslP = parcelRequire("kYslP");

var $7K3x8 = parcelRequire("7K3x8");

var $b4dli = parcelRequire("b4dli");

var $d201be1e332b9665$var$Long = $d201be1e332b9665$var$__importStar((parcelRequire("9A55m")));
/**
 * Holds information about a Account which has vesting information.
 */ var $d201be1e332b9665$var$BaseVestingAccount = /** @class */ function(_super) {
    $d201be1e332b9665$var$__extends(BaseVestingAccount, _super);
    /**
     *
     * @param base_account account information
     * @param original_vesting initial vesting amount
     * @param delegated_free
     * @param delegated_vesting
     * @param end_time
     */ function BaseVestingAccount(base_account, original_vesting, delegated_free, delegated_vesting, end_time) {
        var _this = _super.call(this) || this;
        _this.base_account = base_account;
        _this.original_vesting = original_vesting;
        _this.delegated_free = delegated_free;
        _this.delegated_vesting = delegated_vesting;
        _this.end_time = end_time;
        return _this;
    }
    BaseVestingAccount.prototype.getAccountNumber = function() {
        return this.base_account.account_number;
    };
    BaseVestingAccount.prototype.getSequenceNumber = function() {
        return this.base_account.sequence;
    };
    BaseVestingAccount.prototype.getPublicKey = function() {
        return this.base_account.public_key;
    };
    BaseVestingAccount.prototype.toAmino = function(isClassic) {
        var _a = this, base_account = _a.base_account, original_vesting = _a.original_vesting, delegated_free = _a.delegated_free, delegated_vesting = _a.delegated_vesting, end_time = _a.end_time;
        return {
            type: isClassic ? "core/BaseVestingAccount" : "cosmos-sdk/BaseVestingAccount",
            value: {
                base_account: base_account.toAmino().value,
                delegated_free: delegated_free.toAmino(),
                delegated_vesting: delegated_vesting.toAmino(),
                end_time: end_time.toFixed(),
                original_vesting: original_vesting.toAmino()
            }
        };
    };
    BaseVestingAccount.fromAmino = function(amino, isClassic) {
        var base_account = $7K3x8.BaseAccount.fromAmino({
            type: isClassic ? "core/Account" : "cosmos-sdk/BaseAccount",
            value: amino.value.base_account
        });
        return new BaseVestingAccount(base_account, $kYslP.Coins.fromAmino(amino.value.original_vesting), $kYslP.Coins.fromAmino(amino.value.delegated_free), $kYslP.Coins.fromAmino(amino.value.delegated_vesting), Number.parseInt(amino.value.end_time));
    };
    BaseVestingAccount.prototype.toData = function(_) {
        _;
        var _a = this, base_account = _a.base_account, original_vesting = _a.original_vesting, delegated_free = _a.delegated_free, delegated_vesting = _a.delegated_vesting, end_time = _a.end_time;
        return {
            "@type": "/cosmos.vesting.v1beta1.BaseVestingAccount",
            base_account: base_account.toData(),
            delegated_free: delegated_free.toData(),
            delegated_vesting: delegated_vesting.toData(),
            end_time: end_time.toFixed(),
            original_vesting: original_vesting.toData()
        };
    };
    BaseVestingAccount.fromData = function(data, _) {
        _;
        var base_account = $7K3x8.BaseAccount.fromData($d201be1e332b9665$var$__assign({
            "@type": "/cosmos.auth.v1beta1.BaseAccount"
        }, data.base_account));
        return new BaseVestingAccount(base_account, $kYslP.Coins.fromData(data.original_vesting), $kYslP.Coins.fromData(data.delegated_free), $kYslP.Coins.fromData(data.delegated_vesting), Number.parseInt(data.end_time));
    };
    BaseVestingAccount.prototype.toProto = function(_) {
        _;
        var _a = this, base_account = _a.base_account, original_vesting = _a.original_vesting, delegated_free = _a.delegated_free, delegated_vesting = _a.delegated_vesting, end_time = _a.end_time;
        return $b4dli.BaseVestingAccount.fromPartial({
            baseAccount: base_account.toProto(),
            delegatedFree: delegated_free.toProto(),
            delegatedVesting: delegated_vesting.toProto(),
            endTime: $d201be1e332b9665$var$Long.fromNumber(end_time),
            originalVesting: original_vesting.toProto()
        });
    };
    BaseVestingAccount.fromProto = function(proto, _) {
        _;
        var baseAccount = $7K3x8.BaseAccount.fromProto(proto.baseAccount);
        return new BaseVestingAccount(baseAccount, $kYslP.Coins.fromProto(proto.originalVesting), $kYslP.Coins.fromProto(proto.delegatedFree), $kYslP.Coins.fromProto(proto.delegatedVesting), proto.endTime.toNumber());
    };
    return BaseVestingAccount;
}($26Eqx.JSONSerializable);
module.exports.BaseVestingAccount = $d201be1e332b9665$var$BaseVestingAccount;

});

parcelRegister("4X1Bi", function(module, exports) {
"use strict";
var $39ade9f2ef64db70$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VestingSchedule = module.exports.Schedule = module.exports.LazyGradedVestingAccount = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $39ade9f2ef64db70$var$long_1 = $39ade9f2ef64db70$var$__importDefault((parcelRequire("9A55m")));

const $39ade9f2ef64db70$var$minimal_1 = $39ade9f2ef64db70$var$__importDefault((parcelRequire("i2pIU")));

var $5M6iU = parcelRequire("5M6iU");
module.exports.protobufPackage = "terra.vesting.v1beta1";
const $39ade9f2ef64db70$var$baseLazyGradedVestingAccount = {};
module.exports.LazyGradedVestingAccount = {
    encode (message, writer = $39ade9f2ef64db70$var$minimal_1.default.Writer.create()) {
        if (message.baseVestingAccount !== undefined) $5M6iU.BaseVestingAccount.encode(message.baseVestingAccount, writer.uint32(10).fork()).ldelim();
        for (const v of message.vestingSchedules)module.exports.VestingSchedule.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $39ade9f2ef64db70$var$minimal_1.default.Reader ? input : new $39ade9f2ef64db70$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $39ade9f2ef64db70$var$baseLazyGradedVestingAccount);
        message.vestingSchedules = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.baseVestingAccount = $5M6iU.BaseVestingAccount.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.vestingSchedules.push(module.exports.VestingSchedule.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $39ade9f2ef64db70$var$baseLazyGradedVestingAccount);
        message.vestingSchedules = [];
        if (object.baseVestingAccount !== undefined && object.baseVestingAccount !== null) message.baseVestingAccount = $5M6iU.BaseVestingAccount.fromJSON(object.baseVestingAccount);
        else message.baseVestingAccount = undefined;
        if (object.vestingSchedules !== undefined && object.vestingSchedules !== null) for (const e of object.vestingSchedules)message.vestingSchedules.push(module.exports.VestingSchedule.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.baseVestingAccount !== undefined && (obj.baseVestingAccount = message.baseVestingAccount ? $5M6iU.BaseVestingAccount.toJSON(message.baseVestingAccount) : undefined);
        if (message.vestingSchedules) obj.vestingSchedules = message.vestingSchedules.map((e)=>e ? module.exports.VestingSchedule.toJSON(e) : undefined);
        else obj.vestingSchedules = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $39ade9f2ef64db70$var$baseLazyGradedVestingAccount);
        message.vestingSchedules = [];
        if (object.baseVestingAccount !== undefined && object.baseVestingAccount !== null) message.baseVestingAccount = $5M6iU.BaseVestingAccount.fromPartial(object.baseVestingAccount);
        else message.baseVestingAccount = undefined;
        if (object.vestingSchedules !== undefined && object.vestingSchedules !== null) for (const e of object.vestingSchedules)message.vestingSchedules.push(module.exports.VestingSchedule.fromPartial(e));
        return message;
    }
};
const $39ade9f2ef64db70$var$baseSchedule = {
    startTime: $39ade9f2ef64db70$var$long_1.default.ZERO,
    endTime: $39ade9f2ef64db70$var$long_1.default.ZERO,
    ratio: ""
};
module.exports.Schedule = {
    encode (message, writer = $39ade9f2ef64db70$var$minimal_1.default.Writer.create()) {
        if (!message.startTime.isZero()) writer.uint32(8).int64(message.startTime);
        if (!message.endTime.isZero()) writer.uint32(16).int64(message.endTime);
        if (message.ratio !== "") writer.uint32(26).string(message.ratio);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $39ade9f2ef64db70$var$minimal_1.default.Reader ? input : new $39ade9f2ef64db70$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $39ade9f2ef64db70$var$baseSchedule);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.startTime = reader.int64();
                    break;
                case 2:
                    message.endTime = reader.int64();
                    break;
                case 3:
                    message.ratio = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $39ade9f2ef64db70$var$baseSchedule);
        if (object.startTime !== undefined && object.startTime !== null) message.startTime = $39ade9f2ef64db70$var$long_1.default.fromString(object.startTime);
        else message.startTime = $39ade9f2ef64db70$var$long_1.default.ZERO;
        if (object.endTime !== undefined && object.endTime !== null) message.endTime = $39ade9f2ef64db70$var$long_1.default.fromString(object.endTime);
        else message.endTime = $39ade9f2ef64db70$var$long_1.default.ZERO;
        if (object.ratio !== undefined && object.ratio !== null) message.ratio = String(object.ratio);
        else message.ratio = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.startTime !== undefined && (obj.startTime = (message.startTime || $39ade9f2ef64db70$var$long_1.default.ZERO).toString());
        message.endTime !== undefined && (obj.endTime = (message.endTime || $39ade9f2ef64db70$var$long_1.default.ZERO).toString());
        message.ratio !== undefined && (obj.ratio = message.ratio);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $39ade9f2ef64db70$var$baseSchedule);
        if (object.startTime !== undefined && object.startTime !== null) message.startTime = object.startTime;
        else message.startTime = $39ade9f2ef64db70$var$long_1.default.ZERO;
        if (object.endTime !== undefined && object.endTime !== null) message.endTime = object.endTime;
        else message.endTime = $39ade9f2ef64db70$var$long_1.default.ZERO;
        if (object.ratio !== undefined && object.ratio !== null) message.ratio = object.ratio;
        else message.ratio = "";
        return message;
    }
};
const $39ade9f2ef64db70$var$baseVestingSchedule = {
    denom: ""
};
module.exports.VestingSchedule = {
    encode (message, writer = $39ade9f2ef64db70$var$minimal_1.default.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        for (const v of message.schedules)module.exports.Schedule.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $39ade9f2ef64db70$var$minimal_1.default.Reader ? input : new $39ade9f2ef64db70$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $39ade9f2ef64db70$var$baseVestingSchedule);
        message.schedules = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.schedules.push(module.exports.Schedule.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $39ade9f2ef64db70$var$baseVestingSchedule);
        message.schedules = [];
        if (object.denom !== undefined && object.denom !== null) message.denom = String(object.denom);
        else message.denom = "";
        if (object.schedules !== undefined && object.schedules !== null) for (const e of object.schedules)message.schedules.push(module.exports.Schedule.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        if (message.schedules) obj.schedules = message.schedules.map((e)=>e ? module.exports.Schedule.toJSON(e) : undefined);
        else obj.schedules = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $39ade9f2ef64db70$var$baseVestingSchedule);
        message.schedules = [];
        if (object.denom !== undefined && object.denom !== null) message.denom = object.denom;
        else message.denom = "";
        if (object.schedules !== undefined && object.schedules !== null) for (const e of object.schedules)message.schedules.push(module.exports.Schedule.fromPartial(e));
        return message;
    }
};
if ($39ade9f2ef64db70$var$minimal_1.default.util.Long !== $39ade9f2ef64db70$var$long_1.default) {
    $39ade9f2ef64db70$var$minimal_1.default.util.Long = $39ade9f2ef64db70$var$long_1.default;
    $39ade9f2ef64db70$var$minimal_1.default.configure();
}

});
parcelRegister("5M6iU", function(module, exports) {
"use strict";
var $4346534718171163$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PermanentLockedAccount = module.exports.PeriodicVestingAccount = module.exports.Period = module.exports.DelayedVestingAccount = module.exports.ContinuousVestingAccount = module.exports.BaseVestingAccount = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $4346534718171163$var$long_1 = $4346534718171163$var$__importDefault((parcelRequire("9A55m")));

const $4346534718171163$var$minimal_1 = $4346534718171163$var$__importDefault((parcelRequire("i2pIU")));

var $fUicA = parcelRequire("fUicA");

var $8K62q = parcelRequire("8K62q");
module.exports.protobufPackage = "cosmos.vesting.v1beta1";
const $4346534718171163$var$baseBaseVestingAccount = {
    endTime: $4346534718171163$var$long_1.default.ZERO
};
module.exports.BaseVestingAccount = {
    encode (message, writer = $4346534718171163$var$minimal_1.default.Writer.create()) {
        if (message.baseAccount !== undefined) $fUicA.BaseAccount.encode(message.baseAccount, writer.uint32(10).fork()).ldelim();
        for (const v of message.originalVesting)$8K62q.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        for (const v of message.delegatedFree)$8K62q.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        for (const v of message.delegatedVesting)$8K62q.Coin.encode(v, writer.uint32(34).fork()).ldelim();
        if (!message.endTime.isZero()) writer.uint32(40).int64(message.endTime);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4346534718171163$var$minimal_1.default.Reader ? input : new $4346534718171163$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $4346534718171163$var$baseBaseVestingAccount);
        message.originalVesting = [];
        message.delegatedFree = [];
        message.delegatedVesting = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.baseAccount = $fUicA.BaseAccount.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.originalVesting.push($8K62q.Coin.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.delegatedFree.push($8K62q.Coin.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.delegatedVesting.push($8K62q.Coin.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.endTime = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $4346534718171163$var$baseBaseVestingAccount);
        message.originalVesting = [];
        message.delegatedFree = [];
        message.delegatedVesting = [];
        if (object.baseAccount !== undefined && object.baseAccount !== null) message.baseAccount = $fUicA.BaseAccount.fromJSON(object.baseAccount);
        else message.baseAccount = undefined;
        if (object.originalVesting !== undefined && object.originalVesting !== null) for (const e of object.originalVesting)message.originalVesting.push($8K62q.Coin.fromJSON(e));
        if (object.delegatedFree !== undefined && object.delegatedFree !== null) for (const e of object.delegatedFree)message.delegatedFree.push($8K62q.Coin.fromJSON(e));
        if (object.delegatedVesting !== undefined && object.delegatedVesting !== null) for (const e of object.delegatedVesting)message.delegatedVesting.push($8K62q.Coin.fromJSON(e));
        if (object.endTime !== undefined && object.endTime !== null) message.endTime = $4346534718171163$var$long_1.default.fromString(object.endTime);
        else message.endTime = $4346534718171163$var$long_1.default.ZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.baseAccount !== undefined && (obj.baseAccount = message.baseAccount ? $fUicA.BaseAccount.toJSON(message.baseAccount) : undefined);
        if (message.originalVesting) obj.originalVesting = message.originalVesting.map((e)=>e ? $8K62q.Coin.toJSON(e) : undefined);
        else obj.originalVesting = [];
        if (message.delegatedFree) obj.delegatedFree = message.delegatedFree.map((e)=>e ? $8K62q.Coin.toJSON(e) : undefined);
        else obj.delegatedFree = [];
        if (message.delegatedVesting) obj.delegatedVesting = message.delegatedVesting.map((e)=>e ? $8K62q.Coin.toJSON(e) : undefined);
        else obj.delegatedVesting = [];
        message.endTime !== undefined && (obj.endTime = (message.endTime || $4346534718171163$var$long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $4346534718171163$var$baseBaseVestingAccount);
        message.originalVesting = [];
        message.delegatedFree = [];
        message.delegatedVesting = [];
        if (object.baseAccount !== undefined && object.baseAccount !== null) message.baseAccount = $fUicA.BaseAccount.fromPartial(object.baseAccount);
        else message.baseAccount = undefined;
        if (object.originalVesting !== undefined && object.originalVesting !== null) for (const e of object.originalVesting)message.originalVesting.push($8K62q.Coin.fromPartial(e));
        if (object.delegatedFree !== undefined && object.delegatedFree !== null) for (const e of object.delegatedFree)message.delegatedFree.push($8K62q.Coin.fromPartial(e));
        if (object.delegatedVesting !== undefined && object.delegatedVesting !== null) for (const e of object.delegatedVesting)message.delegatedVesting.push($8K62q.Coin.fromPartial(e));
        if (object.endTime !== undefined && object.endTime !== null) message.endTime = object.endTime;
        else message.endTime = $4346534718171163$var$long_1.default.ZERO;
        return message;
    }
};
const $4346534718171163$var$baseContinuousVestingAccount = {
    startTime: $4346534718171163$var$long_1.default.ZERO
};
module.exports.ContinuousVestingAccount = {
    encode (message, writer = $4346534718171163$var$minimal_1.default.Writer.create()) {
        if (message.baseVestingAccount !== undefined) module.exports.BaseVestingAccount.encode(message.baseVestingAccount, writer.uint32(10).fork()).ldelim();
        if (!message.startTime.isZero()) writer.uint32(16).int64(message.startTime);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4346534718171163$var$minimal_1.default.Reader ? input : new $4346534718171163$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $4346534718171163$var$baseContinuousVestingAccount);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.baseVestingAccount = module.exports.BaseVestingAccount.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.startTime = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $4346534718171163$var$baseContinuousVestingAccount);
        if (object.baseVestingAccount !== undefined && object.baseVestingAccount !== null) message.baseVestingAccount = module.exports.BaseVestingAccount.fromJSON(object.baseVestingAccount);
        else message.baseVestingAccount = undefined;
        if (object.startTime !== undefined && object.startTime !== null) message.startTime = $4346534718171163$var$long_1.default.fromString(object.startTime);
        else message.startTime = $4346534718171163$var$long_1.default.ZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.baseVestingAccount !== undefined && (obj.baseVestingAccount = message.baseVestingAccount ? module.exports.BaseVestingAccount.toJSON(message.baseVestingAccount) : undefined);
        message.startTime !== undefined && (obj.startTime = (message.startTime || $4346534718171163$var$long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $4346534718171163$var$baseContinuousVestingAccount);
        if (object.baseVestingAccount !== undefined && object.baseVestingAccount !== null) message.baseVestingAccount = module.exports.BaseVestingAccount.fromPartial(object.baseVestingAccount);
        else message.baseVestingAccount = undefined;
        if (object.startTime !== undefined && object.startTime !== null) message.startTime = object.startTime;
        else message.startTime = $4346534718171163$var$long_1.default.ZERO;
        return message;
    }
};
const $4346534718171163$var$baseDelayedVestingAccount = {};
module.exports.DelayedVestingAccount = {
    encode (message, writer = $4346534718171163$var$minimal_1.default.Writer.create()) {
        if (message.baseVestingAccount !== undefined) module.exports.BaseVestingAccount.encode(message.baseVestingAccount, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4346534718171163$var$minimal_1.default.Reader ? input : new $4346534718171163$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $4346534718171163$var$baseDelayedVestingAccount);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.baseVestingAccount = module.exports.BaseVestingAccount.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $4346534718171163$var$baseDelayedVestingAccount);
        if (object.baseVestingAccount !== undefined && object.baseVestingAccount !== null) message.baseVestingAccount = module.exports.BaseVestingAccount.fromJSON(object.baseVestingAccount);
        else message.baseVestingAccount = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.baseVestingAccount !== undefined && (obj.baseVestingAccount = message.baseVestingAccount ? module.exports.BaseVestingAccount.toJSON(message.baseVestingAccount) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $4346534718171163$var$baseDelayedVestingAccount);
        if (object.baseVestingAccount !== undefined && object.baseVestingAccount !== null) message.baseVestingAccount = module.exports.BaseVestingAccount.fromPartial(object.baseVestingAccount);
        else message.baseVestingAccount = undefined;
        return message;
    }
};
const $4346534718171163$var$basePeriod = {
    length: $4346534718171163$var$long_1.default.ZERO
};
module.exports.Period = {
    encode (message, writer = $4346534718171163$var$minimal_1.default.Writer.create()) {
        if (!message.length.isZero()) writer.uint32(8).int64(message.length);
        for (const v of message.amount)$8K62q.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4346534718171163$var$minimal_1.default.Reader ? input : new $4346534718171163$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $4346534718171163$var$basePeriod);
        message.amount = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.length = reader.int64();
                    break;
                case 2:
                    message.amount.push($8K62q.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $4346534718171163$var$basePeriod);
        message.amount = [];
        if (object.length !== undefined && object.length !== null) message.length = $4346534718171163$var$long_1.default.fromString(object.length);
        else message.length = $4346534718171163$var$long_1.default.ZERO;
        if (object.amount !== undefined && object.amount !== null) for (const e of object.amount)message.amount.push($8K62q.Coin.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.length !== undefined && (obj.length = (message.length || $4346534718171163$var$long_1.default.ZERO).toString());
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $8K62q.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $4346534718171163$var$basePeriod);
        message.amount = [];
        if (object.length !== undefined && object.length !== null) message.length = object.length;
        else message.length = $4346534718171163$var$long_1.default.ZERO;
        if (object.amount !== undefined && object.amount !== null) for (const e of object.amount)message.amount.push($8K62q.Coin.fromPartial(e));
        return message;
    }
};
const $4346534718171163$var$basePeriodicVestingAccount = {
    startTime: $4346534718171163$var$long_1.default.ZERO
};
module.exports.PeriodicVestingAccount = {
    encode (message, writer = $4346534718171163$var$minimal_1.default.Writer.create()) {
        if (message.baseVestingAccount !== undefined) module.exports.BaseVestingAccount.encode(message.baseVestingAccount, writer.uint32(10).fork()).ldelim();
        if (!message.startTime.isZero()) writer.uint32(16).int64(message.startTime);
        for (const v of message.vestingPeriods)module.exports.Period.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4346534718171163$var$minimal_1.default.Reader ? input : new $4346534718171163$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $4346534718171163$var$basePeriodicVestingAccount);
        message.vestingPeriods = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.baseVestingAccount = module.exports.BaseVestingAccount.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.startTime = reader.int64();
                    break;
                case 3:
                    message.vestingPeriods.push(module.exports.Period.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $4346534718171163$var$basePeriodicVestingAccount);
        message.vestingPeriods = [];
        if (object.baseVestingAccount !== undefined && object.baseVestingAccount !== null) message.baseVestingAccount = module.exports.BaseVestingAccount.fromJSON(object.baseVestingAccount);
        else message.baseVestingAccount = undefined;
        if (object.startTime !== undefined && object.startTime !== null) message.startTime = $4346534718171163$var$long_1.default.fromString(object.startTime);
        else message.startTime = $4346534718171163$var$long_1.default.ZERO;
        if (object.vestingPeriods !== undefined && object.vestingPeriods !== null) for (const e of object.vestingPeriods)message.vestingPeriods.push(module.exports.Period.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.baseVestingAccount !== undefined && (obj.baseVestingAccount = message.baseVestingAccount ? module.exports.BaseVestingAccount.toJSON(message.baseVestingAccount) : undefined);
        message.startTime !== undefined && (obj.startTime = (message.startTime || $4346534718171163$var$long_1.default.ZERO).toString());
        if (message.vestingPeriods) obj.vestingPeriods = message.vestingPeriods.map((e)=>e ? module.exports.Period.toJSON(e) : undefined);
        else obj.vestingPeriods = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $4346534718171163$var$basePeriodicVestingAccount);
        message.vestingPeriods = [];
        if (object.baseVestingAccount !== undefined && object.baseVestingAccount !== null) message.baseVestingAccount = module.exports.BaseVestingAccount.fromPartial(object.baseVestingAccount);
        else message.baseVestingAccount = undefined;
        if (object.startTime !== undefined && object.startTime !== null) message.startTime = object.startTime;
        else message.startTime = $4346534718171163$var$long_1.default.ZERO;
        if (object.vestingPeriods !== undefined && object.vestingPeriods !== null) for (const e of object.vestingPeriods)message.vestingPeriods.push(module.exports.Period.fromPartial(e));
        return message;
    }
};
const $4346534718171163$var$basePermanentLockedAccount = {};
module.exports.PermanentLockedAccount = {
    encode (message, writer = $4346534718171163$var$minimal_1.default.Writer.create()) {
        if (message.baseVestingAccount !== undefined) module.exports.BaseVestingAccount.encode(message.baseVestingAccount, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4346534718171163$var$minimal_1.default.Reader ? input : new $4346534718171163$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $4346534718171163$var$basePermanentLockedAccount);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.baseVestingAccount = module.exports.BaseVestingAccount.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $4346534718171163$var$basePermanentLockedAccount);
        if (object.baseVestingAccount !== undefined && object.baseVestingAccount !== null) message.baseVestingAccount = module.exports.BaseVestingAccount.fromJSON(object.baseVestingAccount);
        else message.baseVestingAccount = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.baseVestingAccount !== undefined && (obj.baseVestingAccount = message.baseVestingAccount ? module.exports.BaseVestingAccount.toJSON(message.baseVestingAccount) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $4346534718171163$var$basePermanentLockedAccount);
        if (object.baseVestingAccount !== undefined && object.baseVestingAccount !== null) message.baseVestingAccount = module.exports.BaseVestingAccount.fromPartial(object.baseVestingAccount);
        else message.baseVestingAccount = undefined;
        return message;
    }
};
if ($4346534718171163$var$minimal_1.default.util.Long !== $4346534718171163$var$long_1.default) {
    $4346534718171163$var$minimal_1.default.util.Long = $4346534718171163$var$long_1.default;
    $4346534718171163$var$minimal_1.default.configure();
}

});
parcelRegister("fUicA", function(module, exports) {
"use strict";
var $b94a347faa507fee$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Params = module.exports.ModuleAccount = module.exports.BaseAccount = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $b94a347faa507fee$var$long_1 = $b94a347faa507fee$var$__importDefault((parcelRequire("9A55m")));

const $b94a347faa507fee$var$minimal_1 = $b94a347faa507fee$var$__importDefault((parcelRequire("i2pIU")));

var $jXmDZ = parcelRequire("jXmDZ");
module.exports.protobufPackage = "cosmos.auth.v1beta1";
const $b94a347faa507fee$var$baseBaseAccount = {
    address: "",
    accountNumber: $b94a347faa507fee$var$long_1.default.UZERO,
    sequence: $b94a347faa507fee$var$long_1.default.UZERO
};
module.exports.BaseAccount = {
    encode (message, writer = $b94a347faa507fee$var$minimal_1.default.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.pubKey !== undefined) $jXmDZ.Any.encode(message.pubKey, writer.uint32(18).fork()).ldelim();
        if (!message.accountNumber.isZero()) writer.uint32(24).uint64(message.accountNumber);
        if (!message.sequence.isZero()) writer.uint32(32).uint64(message.sequence);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b94a347faa507fee$var$minimal_1.default.Reader ? input : new $b94a347faa507fee$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b94a347faa507fee$var$baseBaseAccount);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.pubKey = $jXmDZ.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.accountNumber = reader.uint64();
                    break;
                case 4:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $b94a347faa507fee$var$baseBaseAccount);
        if (object.address !== undefined && object.address !== null) message.address = String(object.address);
        else message.address = "";
        if (object.pubKey !== undefined && object.pubKey !== null) message.pubKey = $jXmDZ.Any.fromJSON(object.pubKey);
        else message.pubKey = undefined;
        if (object.accountNumber !== undefined && object.accountNumber !== null) message.accountNumber = $b94a347faa507fee$var$long_1.default.fromString(object.accountNumber);
        else message.accountNumber = $b94a347faa507fee$var$long_1.default.UZERO;
        if (object.sequence !== undefined && object.sequence !== null) message.sequence = $b94a347faa507fee$var$long_1.default.fromString(object.sequence);
        else message.sequence = $b94a347faa507fee$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.pubKey !== undefined && (obj.pubKey = message.pubKey ? $jXmDZ.Any.toJSON(message.pubKey) : undefined);
        message.accountNumber !== undefined && (obj.accountNumber = (message.accountNumber || $b94a347faa507fee$var$long_1.default.UZERO).toString());
        message.sequence !== undefined && (obj.sequence = (message.sequence || $b94a347faa507fee$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $b94a347faa507fee$var$baseBaseAccount);
        if (object.address !== undefined && object.address !== null) message.address = object.address;
        else message.address = "";
        if (object.pubKey !== undefined && object.pubKey !== null) message.pubKey = $jXmDZ.Any.fromPartial(object.pubKey);
        else message.pubKey = undefined;
        if (object.accountNumber !== undefined && object.accountNumber !== null) message.accountNumber = object.accountNumber;
        else message.accountNumber = $b94a347faa507fee$var$long_1.default.UZERO;
        if (object.sequence !== undefined && object.sequence !== null) message.sequence = object.sequence;
        else message.sequence = $b94a347faa507fee$var$long_1.default.UZERO;
        return message;
    }
};
const $b94a347faa507fee$var$baseModuleAccount = {
    name: "",
    permissions: ""
};
module.exports.ModuleAccount = {
    encode (message, writer = $b94a347faa507fee$var$minimal_1.default.Writer.create()) {
        if (message.baseAccount !== undefined) module.exports.BaseAccount.encode(message.baseAccount, writer.uint32(10).fork()).ldelim();
        if (message.name !== "") writer.uint32(18).string(message.name);
        for (const v of message.permissions)writer.uint32(26).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b94a347faa507fee$var$minimal_1.default.Reader ? input : new $b94a347faa507fee$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b94a347faa507fee$var$baseModuleAccount);
        message.permissions = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.baseAccount = module.exports.BaseAccount.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.name = reader.string();
                    break;
                case 3:
                    message.permissions.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $b94a347faa507fee$var$baseModuleAccount);
        message.permissions = [];
        if (object.baseAccount !== undefined && object.baseAccount !== null) message.baseAccount = module.exports.BaseAccount.fromJSON(object.baseAccount);
        else message.baseAccount = undefined;
        if (object.name !== undefined && object.name !== null) message.name = String(object.name);
        else message.name = "";
        if (object.permissions !== undefined && object.permissions !== null) for (const e of object.permissions)message.permissions.push(String(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.baseAccount !== undefined && (obj.baseAccount = message.baseAccount ? module.exports.BaseAccount.toJSON(message.baseAccount) : undefined);
        message.name !== undefined && (obj.name = message.name);
        if (message.permissions) obj.permissions = message.permissions.map((e)=>e);
        else obj.permissions = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $b94a347faa507fee$var$baseModuleAccount);
        message.permissions = [];
        if (object.baseAccount !== undefined && object.baseAccount !== null) message.baseAccount = module.exports.BaseAccount.fromPartial(object.baseAccount);
        else message.baseAccount = undefined;
        if (object.name !== undefined && object.name !== null) message.name = object.name;
        else message.name = "";
        if (object.permissions !== undefined && object.permissions !== null) for (const e of object.permissions)message.permissions.push(e);
        return message;
    }
};
const $b94a347faa507fee$var$baseParams = {
    maxMemoCharacters: $b94a347faa507fee$var$long_1.default.UZERO,
    txSigLimit: $b94a347faa507fee$var$long_1.default.UZERO,
    txSizeCostPerByte: $b94a347faa507fee$var$long_1.default.UZERO,
    sigVerifyCostEd25519: $b94a347faa507fee$var$long_1.default.UZERO,
    sigVerifyCostSecp256k1: $b94a347faa507fee$var$long_1.default.UZERO
};
module.exports.Params = {
    encode (message, writer = $b94a347faa507fee$var$minimal_1.default.Writer.create()) {
        if (!message.maxMemoCharacters.isZero()) writer.uint32(8).uint64(message.maxMemoCharacters);
        if (!message.txSigLimit.isZero()) writer.uint32(16).uint64(message.txSigLimit);
        if (!message.txSizeCostPerByte.isZero()) writer.uint32(24).uint64(message.txSizeCostPerByte);
        if (!message.sigVerifyCostEd25519.isZero()) writer.uint32(32).uint64(message.sigVerifyCostEd25519);
        if (!message.sigVerifyCostSecp256k1.isZero()) writer.uint32(40).uint64(message.sigVerifyCostSecp256k1);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b94a347faa507fee$var$minimal_1.default.Reader ? input : new $b94a347faa507fee$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b94a347faa507fee$var$baseParams);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.maxMemoCharacters = reader.uint64();
                    break;
                case 2:
                    message.txSigLimit = reader.uint64();
                    break;
                case 3:
                    message.txSizeCostPerByte = reader.uint64();
                    break;
                case 4:
                    message.sigVerifyCostEd25519 = reader.uint64();
                    break;
                case 5:
                    message.sigVerifyCostSecp256k1 = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $b94a347faa507fee$var$baseParams);
        if (object.maxMemoCharacters !== undefined && object.maxMemoCharacters !== null) message.maxMemoCharacters = $b94a347faa507fee$var$long_1.default.fromString(object.maxMemoCharacters);
        else message.maxMemoCharacters = $b94a347faa507fee$var$long_1.default.UZERO;
        if (object.txSigLimit !== undefined && object.txSigLimit !== null) message.txSigLimit = $b94a347faa507fee$var$long_1.default.fromString(object.txSigLimit);
        else message.txSigLimit = $b94a347faa507fee$var$long_1.default.UZERO;
        if (object.txSizeCostPerByte !== undefined && object.txSizeCostPerByte !== null) message.txSizeCostPerByte = $b94a347faa507fee$var$long_1.default.fromString(object.txSizeCostPerByte);
        else message.txSizeCostPerByte = $b94a347faa507fee$var$long_1.default.UZERO;
        if (object.sigVerifyCostEd25519 !== undefined && object.sigVerifyCostEd25519 !== null) message.sigVerifyCostEd25519 = $b94a347faa507fee$var$long_1.default.fromString(object.sigVerifyCostEd25519);
        else message.sigVerifyCostEd25519 = $b94a347faa507fee$var$long_1.default.UZERO;
        if (object.sigVerifyCostSecp256k1 !== undefined && object.sigVerifyCostSecp256k1 !== null) message.sigVerifyCostSecp256k1 = $b94a347faa507fee$var$long_1.default.fromString(object.sigVerifyCostSecp256k1);
        else message.sigVerifyCostSecp256k1 = $b94a347faa507fee$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.maxMemoCharacters !== undefined && (obj.maxMemoCharacters = (message.maxMemoCharacters || $b94a347faa507fee$var$long_1.default.UZERO).toString());
        message.txSigLimit !== undefined && (obj.txSigLimit = (message.txSigLimit || $b94a347faa507fee$var$long_1.default.UZERO).toString());
        message.txSizeCostPerByte !== undefined && (obj.txSizeCostPerByte = (message.txSizeCostPerByte || $b94a347faa507fee$var$long_1.default.UZERO).toString());
        message.sigVerifyCostEd25519 !== undefined && (obj.sigVerifyCostEd25519 = (message.sigVerifyCostEd25519 || $b94a347faa507fee$var$long_1.default.UZERO).toString());
        message.sigVerifyCostSecp256k1 !== undefined && (obj.sigVerifyCostSecp256k1 = (message.sigVerifyCostSecp256k1 || $b94a347faa507fee$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $b94a347faa507fee$var$baseParams);
        if (object.maxMemoCharacters !== undefined && object.maxMemoCharacters !== null) message.maxMemoCharacters = object.maxMemoCharacters;
        else message.maxMemoCharacters = $b94a347faa507fee$var$long_1.default.UZERO;
        if (object.txSigLimit !== undefined && object.txSigLimit !== null) message.txSigLimit = object.txSigLimit;
        else message.txSigLimit = $b94a347faa507fee$var$long_1.default.UZERO;
        if (object.txSizeCostPerByte !== undefined && object.txSizeCostPerByte !== null) message.txSizeCostPerByte = object.txSizeCostPerByte;
        else message.txSizeCostPerByte = $b94a347faa507fee$var$long_1.default.UZERO;
        if (object.sigVerifyCostEd25519 !== undefined && object.sigVerifyCostEd25519 !== null) message.sigVerifyCostEd25519 = object.sigVerifyCostEd25519;
        else message.sigVerifyCostEd25519 = $b94a347faa507fee$var$long_1.default.UZERO;
        if (object.sigVerifyCostSecp256k1 !== undefined && object.sigVerifyCostSecp256k1 !== null) message.sigVerifyCostSecp256k1 = object.sigVerifyCostSecp256k1;
        else message.sigVerifyCostSecp256k1 = $b94a347faa507fee$var$long_1.default.UZERO;
        return message;
    }
};
if ($b94a347faa507fee$var$minimal_1.default.util.Long !== $b94a347faa507fee$var$long_1.default) {
    $b94a347faa507fee$var$minimal_1.default.util.Long = $b94a347faa507fee$var$long_1.default;
    $b94a347faa507fee$var$minimal_1.default.configure();
}

});
parcelRegister("jXmDZ", function(module, exports) {
"use strict";
var $e875179d273ffd1d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Any = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $e875179d273ffd1d$var$long_1 = $e875179d273ffd1d$var$__importDefault((parcelRequire("9A55m")));

const $e875179d273ffd1d$var$minimal_1 = $e875179d273ffd1d$var$__importDefault((parcelRequire("i2pIU")));
module.exports.protobufPackage = "google.protobuf";
const $e875179d273ffd1d$var$baseAny = {
    typeUrl: ""
};
module.exports.Any = {
    encode (message, writer = $e875179d273ffd1d$var$minimal_1.default.Writer.create()) {
        if (message.typeUrl !== "") writer.uint32(10).string(message.typeUrl);
        if (message.value.length !== 0) writer.uint32(18).bytes(message.value);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e875179d273ffd1d$var$minimal_1.default.Reader ? input : new $e875179d273ffd1d$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $e875179d273ffd1d$var$baseAny);
        message.value = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.typeUrl = reader.string();
                    break;
                case 2:
                    message.value = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $e875179d273ffd1d$var$baseAny);
        message.value = new Uint8Array();
        if (object.typeUrl !== undefined && object.typeUrl !== null) message.typeUrl = String(object.typeUrl);
        else message.typeUrl = "";
        if (object.value !== undefined && object.value !== null) message.value = $e875179d273ffd1d$var$bytesFromBase64(object.value);
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.typeUrl !== undefined && (obj.typeUrl = message.typeUrl);
        message.value !== undefined && (obj.value = $e875179d273ffd1d$var$base64FromBytes(message.value !== undefined ? message.value : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $e875179d273ffd1d$var$baseAny);
        if (object.typeUrl !== undefined && object.typeUrl !== null) message.typeUrl = object.typeUrl;
        else message.typeUrl = "";
        if (object.value !== undefined && object.value !== null) message.value = object.value;
        else message.value = new Uint8Array();
        return message;
    }
};
var $e875179d273ffd1d$var$globalThis = (()=>{
    if (typeof $e875179d273ffd1d$var$globalThis !== "undefined") return $e875179d273ffd1d$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $e875179d273ffd1d$var$atob = $e875179d273ffd1d$var$globalThis.atob || ((b64)=>$e875179d273ffd1d$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $e875179d273ffd1d$var$bytesFromBase64(b64) {
    const bin = $e875179d273ffd1d$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $e875179d273ffd1d$var$btoa = $e875179d273ffd1d$var$globalThis.btoa || ((bin)=>$e875179d273ffd1d$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $e875179d273ffd1d$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $e875179d273ffd1d$var$btoa(bin.join(""));
}
if ($e875179d273ffd1d$var$minimal_1.default.util.Long !== $e875179d273ffd1d$var$long_1.default) {
    $e875179d273ffd1d$var$minimal_1.default.util.Long = $e875179d273ffd1d$var$long_1.default;
    $e875179d273ffd1d$var$minimal_1.default.configure();
}

});





parcelRegister("9UGCn", function(module, exports) {
"use strict";
var $737a670ae49f815a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $737a670ae49f815a$var$__assign = module.exports && module.exports.__assign || function() {
    $737a670ae49f815a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $737a670ae49f815a$var$__assign.apply(this, arguments);
};
var $737a670ae49f815a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $737a670ae49f815a$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $737a670ae49f815a$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $737a670ae49f815a$var$__createBinding(result, mod, k);
    }
    $737a670ae49f815a$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ContinuousVestingAccount = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $i1RoR = parcelRequire("i1RoR");

var $737a670ae49f815a$var$Long = $737a670ae49f815a$var$__importStar((parcelRequire("9A55m")));

var $b4dli = parcelRequire("b4dli");

var $c5FxR = parcelRequire("c5FxR");
/**
 * ContinuousVestingAccount implements the VestingAccount interface. It
 * continuously vests by unlocking coins linearly with respect to time.
 */ var $737a670ae49f815a$var$ContinuousVestingAccount = /** @class */ function(_super) {
    $737a670ae49f815a$var$__extends(ContinuousVestingAccount, _super);
    /**
     *
     * @param base_vesting_account account information
     * @param start_time vesting start time
     */ function ContinuousVestingAccount(base_vesting_account, start_time) {
        var _this = _super.call(this) || this;
        _this.base_vesting_account = base_vesting_account;
        _this.start_time = start_time;
        return _this;
    }
    ContinuousVestingAccount.prototype.getAccountNumber = function() {
        return this.base_vesting_account.getAccountNumber();
    };
    ContinuousVestingAccount.prototype.getSequenceNumber = function() {
        return this.base_vesting_account.getSequenceNumber();
    };
    ContinuousVestingAccount.prototype.getPublicKey = function() {
        return this.base_vesting_account.base_account.public_key;
    };
    ContinuousVestingAccount.prototype.toAmino = function(isClassic) {
        if (isClassic) throw new Error("Not supported for the network");
        var _a = this, base_vesting_account = _a.base_vesting_account, start_time = _a.start_time;
        return {
            type: "cosmos-sdk/ContinuousVestingAccount",
            value: {
                base_vesting_account: base_vesting_account.toAmino().value,
                start_time: start_time.toFixed()
            }
        };
    };
    ContinuousVestingAccount.fromAmino = function(data, isClassic) {
        var base_vesting_account = $i1RoR.BaseVestingAccount.fromAmino({
            type: "cosmos-sdk/BaseVestingAccount",
            value: data.value.base_vesting_account
        });
        if (isClassic) throw new Error("Not supported for the network");
        return new ContinuousVestingAccount(base_vesting_account, Number.parseInt(data.value.start_time));
    };
    ContinuousVestingAccount.prototype.toData = function(isClassic) {
        if (isClassic) throw new Error("Not supported for the network");
        var _a = this, base_vesting_account = _a.base_vesting_account, start_time = _a.start_time;
        return {
            "@type": "/cosmos.vesting.v1beta1.ContinuousVestingAccount",
            base_vesting_account: base_vesting_account.toData(),
            start_time: start_time.toFixed()
        };
    };
    ContinuousVestingAccount.fromData = function(data, isClassic) {
        if (isClassic) throw new Error("Not supported for the network");
        var base_vesting_account = $i1RoR.BaseVestingAccount.fromData($737a670ae49f815a$var$__assign({
            "@type": "/cosmos.vesting.v1beta1.BaseVestingAccount"
        }, data.base_vesting_account));
        return new ContinuousVestingAccount(base_vesting_account, Number.parseInt(data.start_time));
    };
    ContinuousVestingAccount.prototype.toProto = function(isClassic) {
        if (isClassic) throw new Error("Not supported for the network");
        var _a = this, base_vesting_account = _a.base_vesting_account, start_time = _a.start_time;
        return $b4dli.ContinuousVestingAccount.fromPartial({
            baseVestingAccount: base_vesting_account.toProto(),
            startTime: $737a670ae49f815a$var$Long.fromNumber(start_time)
        });
    };
    ContinuousVestingAccount.fromProto = function(ContinuousVestingAccountProto, isClassic) {
        if (isClassic) throw new Error("Not supported for the network");
        var baseVestingAccount = $i1RoR.BaseVestingAccount.fromProto(ContinuousVestingAccountProto.baseVestingAccount);
        return new ContinuousVestingAccount(baseVestingAccount, ContinuousVestingAccountProto.startTime.toNumber());
    };
    ContinuousVestingAccount.prototype.packAny = function(isClassic) {
        if (isClassic) throw new Error("Not supported for the network");
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmos.vesting.v1beta1.ContinuousVestingAccount",
            value: $b4dli.ContinuousVestingAccount.encode(this.toProto(isClassic)).finish()
        });
    };
    ContinuousVestingAccount.unpackAny = function(pubkeyAny, isClassic) {
        if (isClassic) throw new Error("Not supported for the network");
        return ContinuousVestingAccount.fromProto($b4dli.ContinuousVestingAccount.decode(pubkeyAny.value), isClassic);
    };
    return ContinuousVestingAccount;
}($26Eqx.JSONSerializable);
module.exports.ContinuousVestingAccount = $737a670ae49f815a$var$ContinuousVestingAccount;

});

parcelRegister("3NwSV", function(module, exports) {
"use strict";
var $2c3f74f9c1f28d25$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $2c3f74f9c1f28d25$var$__assign = module.exports && module.exports.__assign || function() {
    $2c3f74f9c1f28d25$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2c3f74f9c1f28d25$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DelayedVestingAccount = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $i1RoR = parcelRequire("i1RoR");

var $b4dli = parcelRequire("b4dli");

var $c5FxR = parcelRequire("c5FxR");
/**
 * DelayedVestingAccount implements the VestingAccount interface. It vests all
 * coins after a specific time, but non prior. In other words, it keeps them
 * locked until a specified time.
 */ var $2c3f74f9c1f28d25$var$DelayedVestingAccount = /** @class */ function(_super) {
    $2c3f74f9c1f28d25$var$__extends(DelayedVestingAccount, _super);
    /**
     *
     * @param base_vesting_account account information
     */ function DelayedVestingAccount(base_vesting_account) {
        var _this = _super.call(this) || this;
        _this.base_vesting_account = base_vesting_account;
        return _this;
    }
    DelayedVestingAccount.prototype.getAccountNumber = function() {
        return this.base_vesting_account.getAccountNumber();
    };
    DelayedVestingAccount.prototype.getSequenceNumber = function() {
        return this.base_vesting_account.getSequenceNumber();
    };
    DelayedVestingAccount.prototype.getPublicKey = function() {
        return this.base_vesting_account.base_account.public_key;
    };
    DelayedVestingAccount.prototype.toAmino = function(isClassic) {
        if (isClassic) throw new Error("Not supported for the network");
        var base_vesting_account = this.base_vesting_account;
        return {
            type: "cosmos-sdk/DelayedVestingAccount",
            value: {
                base_vesting_account: base_vesting_account.toAmino().value
            }
        };
    };
    DelayedVestingAccount.fromAmino = function(data, isClassic) {
        var base_vesting_account = $i1RoR.BaseVestingAccount.fromAmino({
            type: "cosmos-sdk/BaseVestingAccount",
            value: data.value.base_vesting_account
        });
        if (isClassic) throw new Error("Not supported for the network");
        return new DelayedVestingAccount(base_vesting_account);
    };
    DelayedVestingAccount.prototype.toData = function(isClassic) {
        if (isClassic) throw new Error("Not supported for the network");
        var base_vesting_account = this.base_vesting_account;
        return {
            "@type": "/cosmos.vesting.v1beta1.DelayedVestingAccount",
            base_vesting_account: base_vesting_account.toData()
        };
    };
    DelayedVestingAccount.fromData = function(data, isClassic) {
        var base_vesting_account = $i1RoR.BaseVestingAccount.fromData($2c3f74f9c1f28d25$var$__assign({
            "@type": "/cosmos.vesting.v1beta1.BaseVestingAccount"
        }, data.base_vesting_account));
        if (isClassic) throw new Error("Not supported for the network");
        return new DelayedVestingAccount(base_vesting_account);
    };
    DelayedVestingAccount.prototype.toProto = function(isClassic) {
        if (isClassic) throw new Error("Not supported for the network");
        var base_vesting_account = this.base_vesting_account;
        return $b4dli.DelayedVestingAccount.fromPartial({
            baseVestingAccount: base_vesting_account.toProto()
        });
    };
    DelayedVestingAccount.fromProto = function(DelayedVestingAccountProto, isClassic) {
        var baseVestingAccount = $i1RoR.BaseVestingAccount.fromProto(DelayedVestingAccountProto.baseVestingAccount);
        if (isClassic) throw new Error("Not supported for the network");
        return new DelayedVestingAccount(baseVestingAccount);
    };
    DelayedVestingAccount.prototype.packAny = function(isClassic) {
        if (isClassic) throw new Error("Not supported for the network");
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmos.vesting.v1beta1.DelayedVestingAccount",
            value: $b4dli.DelayedVestingAccount.encode(this.toProto(isClassic)).finish()
        });
    };
    DelayedVestingAccount.unpackAny = function(pubkeyAny, isClassic) {
        if (isClassic) throw new Error("Not supported for the network");
        return DelayedVestingAccount.fromProto($b4dli.DelayedVestingAccount.decode(pubkeyAny.value), isClassic);
    };
    return DelayedVestingAccount;
}($26Eqx.JSONSerializable);
module.exports.DelayedVestingAccount = $2c3f74f9c1f28d25$var$DelayedVestingAccount;

});

parcelRegister("h7Cpe", function(module, exports) {
"use strict";
var $c770e1bfa1f4ecc8$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $c770e1bfa1f4ecc8$var$__assign = module.exports && module.exports.__assign || function() {
    $c770e1bfa1f4ecc8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c770e1bfa1f4ecc8$var$__assign.apply(this, arguments);
};
var $c770e1bfa1f4ecc8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c770e1bfa1f4ecc8$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $c770e1bfa1f4ecc8$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c770e1bfa1f4ecc8$var$__createBinding(result, mod, k);
    }
    $c770e1bfa1f4ecc8$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PeriodicVestingAccount = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $i1RoR = parcelRequire("i1RoR");

var $kYslP = parcelRequire("kYslP");

var $b4dli = parcelRequire("b4dli");

var $c5FxR = parcelRequire("c5FxR");

var $c770e1bfa1f4ecc8$var$Long = $c770e1bfa1f4ecc8$var$__importStar((parcelRequire("9A55m")));
/**
 * PeriodicVestingAccount implements the VestingAccount interface. It
 * periodically vests by unlocking coins during each specified period.
 */ var $c770e1bfa1f4ecc8$var$PeriodicVestingAccount = /** @class */ function(_super) {
    $c770e1bfa1f4ecc8$var$__extends(PeriodicVestingAccount, _super);
    /**
     *
     * @param base_vesting_account account information
     * @param start_time vesting start time
     * @param vesting_periods vesting period entries
     */ function PeriodicVestingAccount(base_vesting_account, start_time, vesting_periods) {
        var _this = _super.call(this) || this;
        _this.base_vesting_account = base_vesting_account;
        _this.start_time = start_time;
        _this.vesting_periods = vesting_periods;
        return _this;
    }
    PeriodicVestingAccount.prototype.getAccountNumber = function() {
        return this.base_vesting_account.getAccountNumber();
    };
    PeriodicVestingAccount.prototype.getSequenceNumber = function() {
        return this.base_vesting_account.getSequenceNumber();
    };
    PeriodicVestingAccount.prototype.getPublicKey = function() {
        return this.base_vesting_account.base_account.public_key;
    };
    PeriodicVestingAccount.prototype.toAmino = function(isClassic) {
        if (isClassic) throw new Error("Not supported for the network");
        var _a = this, base_vesting_account = _a.base_vesting_account, start_time = _a.start_time, vesting_periods = _a.vesting_periods;
        return {
            type: "cosmos-sdk/PeriodicVestingAccount",
            value: {
                base_vesting_account: base_vesting_account.toAmino().value,
                start_time: start_time.toFixed(),
                vesting_periods: vesting_periods.map(function(vs) {
                    return vs.toAmino();
                })
            }
        };
    };
    PeriodicVestingAccount.fromAmino = function(data, isClassic) {
        var base_vesting_account = $i1RoR.BaseVestingAccount.fromAmino({
            type: "cosmos-sdk/BaseVestingAccount",
            value: data.value.base_vesting_account
        });
        if (isClassic) throw new Error("Not supported for the network");
        return new PeriodicVestingAccount(base_vesting_account, Number.parseInt(data.value.start_time), data.value.vesting_periods.map(function(vs) {
            return PeriodicVestingAccount.Period.fromAmino(vs);
        }));
    };
    PeriodicVestingAccount.prototype.toData = function(isClassic) {
        if (isClassic) throw new Error("Not supported for the network");
        var _a = this, base_vesting_account = _a.base_vesting_account, start_time = _a.start_time, vesting_periods = _a.vesting_periods;
        return {
            "@type": "/cosmos.vesting.v1beta1.PeriodicVestingAccount",
            base_vesting_account: base_vesting_account.toData(),
            start_time: start_time.toFixed(),
            vesting_periods: vesting_periods.map(function(vs) {
                return vs.toData();
            })
        };
    };
    PeriodicVestingAccount.fromData = function(data, isClassic) {
        var base_vesting_account = $i1RoR.BaseVestingAccount.fromData($c770e1bfa1f4ecc8$var$__assign({
            "@type": "/cosmos.vesting.v1beta1.BaseVestingAccount"
        }, data.base_vesting_account));
        if (isClassic) throw new Error("Not supported for the network");
        return new PeriodicVestingAccount(base_vesting_account, Number.parseInt(data.start_time), data.vesting_periods.map(function(vs) {
            return PeriodicVestingAccount.Period.fromData(vs);
        }));
    };
    PeriodicVestingAccount.prototype.toProto = function(isClassic) {
        if (isClassic) throw new Error("Not supported for the network");
        var _a = this, base_vesting_account = _a.base_vesting_account, vesting_periods = _a.vesting_periods;
        return $b4dli.PeriodicVestingAccount.fromPartial({
            baseVestingAccount: base_vesting_account.toProto(),
            vestingPeriods: vesting_periods.map(function(s) {
                return s.toProto();
            })
        });
    };
    PeriodicVestingAccount.fromProto = function(proto, isClassic) {
        var _this = this;
        if (isClassic) throw new Error("Not supported for the network");
        var baseVestingAccount = $i1RoR.BaseVestingAccount.fromProto(proto.baseVestingAccount);
        return new PeriodicVestingAccount(baseVestingAccount, proto.startTime.toNumber(), proto.vestingPeriods.map(function(s) {
            return _this.Period.fromProto(s);
        }));
    };
    PeriodicVestingAccount.prototype.packAny = function(isClassic) {
        if (isClassic) throw new Error("Not supported for the network");
        return $c5FxR.Any.fromPartial({
            typeUrl: "/cosmos.vesting.v1beta1.PeriodicVestingAccount",
            value: $b4dli.PeriodicVestingAccount.encode(this.toProto(isClassic)).finish()
        });
    };
    PeriodicVestingAccount.unpackAny = function(pubkeyAny, isClassic) {
        if (isClassic) throw new Error("Not supported for the network");
        return PeriodicVestingAccount.fromProto($b4dli.PeriodicVestingAccount.decode(pubkeyAny.value), isClassic);
    };
    return PeriodicVestingAccount;
}($26Eqx.JSONSerializable);
module.exports.PeriodicVestingAccount = $c770e1bfa1f4ecc8$var$PeriodicVestingAccount;
(function(PeriodicVestingAccount) {
    var Period = /** @class */ function(_super) {
        $c770e1bfa1f4ecc8$var$__extends(Period, _super);
        function Period(length, amount) {
            var _this = _super.call(this) || this;
            _this.length = length;
            _this.amount = amount;
            return _this;
        }
        Period.prototype.toAmino = function() {
            var _a = this, length = _a.length, amount = _a.amount;
            return {
                length: length.toFixed(),
                amount: amount.toAmino()
            };
        };
        Period.fromAmino = function(data) {
            var length = data.length, amount = data.amount;
            return new Period(Number.parseInt(length), $kYslP.Coins.fromAmino(amount));
        };
        Period.prototype.toData = function() {
            var _a = this, length = _a.length, amount = _a.amount;
            return {
                length: length.toFixed(),
                amount: amount.toData()
            };
        };
        Period.fromData = function(data) {
            var length = data.length, amount = data.amount;
            return new Period(Number.parseInt(length), $kYslP.Coins.fromData(amount));
        };
        Period.prototype.toProto = function() {
            var _a = this, length = _a.length, amount = _a.amount;
            return $b4dli.Period.fromPartial({
                length: $c770e1bfa1f4ecc8$var$Long.fromNumber(length),
                amount: amount.toProto()
            });
        };
        Period.fromProto = function(proto) {
            return new Period(proto.length.toNumber(), $kYslP.Coins.fromProto(proto.amount));
        };
        return Period;
    }($26Eqx.JSONSerializable);
    PeriodicVestingAccount.Period = Period;
})($c770e1bfa1f4ecc8$var$PeriodicVestingAccount = module.exports.PeriodicVestingAccount || (module.exports.PeriodicVestingAccount = {}));
module.exports.PeriodicVestingAccount = $c770e1bfa1f4ecc8$var$PeriodicVestingAccount;

});


parcelRegister("9YhJA", function(module, exports) {
"use strict";
var $74277953f97307e4$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $74277953f97307e4$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $74277953f97307e4$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $74277953f97307e4$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $74277953f97307e4$var$__createBinding(result, mod, k);
    }
    $74277953f97307e4$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AggregateExchangeRatePrevote = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $4FJ9M = parcelRequire("4FJ9M");

var $74277953f97307e4$var$Long = $74277953f97307e4$var$__importStar((parcelRequire("9A55m")));
/**
 * Stores information about data about Oracle aggregate prevotes fetched from the blockchain.
 */ var $74277953f97307e4$var$AggregateExchangeRatePrevote = /** @class */ function(_super) {
    $74277953f97307e4$var$__extends(AggregateExchangeRatePrevote, _super);
    /**
     * @param hash aggregate vote hash
     * @param voter validator
     * @param submit_block block during which aggregate prevote was submitted
     */ function AggregateExchangeRatePrevote(hash, voter, submit_block) {
        var _this = _super.call(this) || this;
        _this.hash = hash;
        _this.voter = voter;
        _this.submit_block = submit_block;
        return _this;
    }
    AggregateExchangeRatePrevote.fromAmino = function(data) {
        var hash = data.hash, voter = data.voter, submit_block = data.submit_block;
        return new AggregateExchangeRatePrevote(hash, voter, Number.parseInt(submit_block));
    };
    AggregateExchangeRatePrevote.prototype.toAmino = function() {
        var _a = this, hash = _a.hash, voter = _a.voter, submit_block = _a.submit_block;
        return {
            hash: hash,
            voter: voter,
            submit_block: submit_block.toFixed()
        };
    };
    AggregateExchangeRatePrevote.fromData = function(data) {
        var hash = data.hash, voter = data.voter, submit_block = data.submit_block;
        return new AggregateExchangeRatePrevote(hash, voter, Number.parseInt(submit_block));
    };
    AggregateExchangeRatePrevote.prototype.toData = function() {
        var _a = this, hash = _a.hash, voter = _a.voter, submit_block = _a.submit_block;
        return {
            hash: hash,
            voter: voter,
            submit_block: submit_block.toFixed()
        };
    };
    AggregateExchangeRatePrevote.fromProto = function(data) {
        return new AggregateExchangeRatePrevote(data.hash, data.voter, data.submitBlock.toNumber());
    };
    AggregateExchangeRatePrevote.prototype.toProto = function() {
        var _a = this, hash = _a.hash, voter = _a.voter, submit_block = _a.submit_block;
        return $4FJ9M.AggregateExchangeRatePrevote.fromPartial({
            hash: hash,
            submitBlock: $74277953f97307e4$var$Long.fromNumber(submit_block),
            voter: voter
        });
    };
    return AggregateExchangeRatePrevote;
}($26Eqx.JSONSerializable);
module.exports.AggregateExchangeRatePrevote = $74277953f97307e4$var$AggregateExchangeRatePrevote;

});
parcelRegister("4FJ9M", function(module, exports) {
"use strict";
var $366e04f29fe8ae43$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExchangeRateTuple = module.exports.AggregateExchangeRateVote = module.exports.AggregateExchangeRatePrevote = module.exports.Denom = module.exports.Params = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $366e04f29fe8ae43$var$long_1 = $366e04f29fe8ae43$var$__importDefault((parcelRequire("9A55m")));

const $366e04f29fe8ae43$var$minimal_1 = $366e04f29fe8ae43$var$__importDefault((parcelRequire("i2pIU")));
module.exports.protobufPackage = "terra.oracle.v1beta1";
const $366e04f29fe8ae43$var$baseParams = {
    votePeriod: $366e04f29fe8ae43$var$long_1.default.UZERO,
    voteThreshold: "",
    rewardBand: "",
    rewardDistributionWindow: $366e04f29fe8ae43$var$long_1.default.UZERO,
    slashFraction: "",
    slashWindow: $366e04f29fe8ae43$var$long_1.default.UZERO,
    minValidPerWindow: ""
};
module.exports.Params = {
    encode (message, writer = $366e04f29fe8ae43$var$minimal_1.default.Writer.create()) {
        if (!message.votePeriod.isZero()) writer.uint32(8).uint64(message.votePeriod);
        if (message.voteThreshold !== "") writer.uint32(18).string(message.voteThreshold);
        if (message.rewardBand !== "") writer.uint32(26).string(message.rewardBand);
        if (!message.rewardDistributionWindow.isZero()) writer.uint32(32).uint64(message.rewardDistributionWindow);
        for (const v of message.whitelist)module.exports.Denom.encode(v, writer.uint32(42).fork()).ldelim();
        if (message.slashFraction !== "") writer.uint32(50).string(message.slashFraction);
        if (!message.slashWindow.isZero()) writer.uint32(56).uint64(message.slashWindow);
        if (message.minValidPerWindow !== "") writer.uint32(66).string(message.minValidPerWindow);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $366e04f29fe8ae43$var$minimal_1.default.Reader ? input : new $366e04f29fe8ae43$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $366e04f29fe8ae43$var$baseParams);
        message.whitelist = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.votePeriod = reader.uint64();
                    break;
                case 2:
                    message.voteThreshold = reader.string();
                    break;
                case 3:
                    message.rewardBand = reader.string();
                    break;
                case 4:
                    message.rewardDistributionWindow = reader.uint64();
                    break;
                case 5:
                    message.whitelist.push(module.exports.Denom.decode(reader, reader.uint32()));
                    break;
                case 6:
                    message.slashFraction = reader.string();
                    break;
                case 7:
                    message.slashWindow = reader.uint64();
                    break;
                case 8:
                    message.minValidPerWindow = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $366e04f29fe8ae43$var$baseParams);
        message.whitelist = [];
        if (object.votePeriod !== undefined && object.votePeriod !== null) message.votePeriod = $366e04f29fe8ae43$var$long_1.default.fromString(object.votePeriod);
        else message.votePeriod = $366e04f29fe8ae43$var$long_1.default.UZERO;
        if (object.voteThreshold !== undefined && object.voteThreshold !== null) message.voteThreshold = String(object.voteThreshold);
        else message.voteThreshold = "";
        if (object.rewardBand !== undefined && object.rewardBand !== null) message.rewardBand = String(object.rewardBand);
        else message.rewardBand = "";
        if (object.rewardDistributionWindow !== undefined && object.rewardDistributionWindow !== null) message.rewardDistributionWindow = $366e04f29fe8ae43$var$long_1.default.fromString(object.rewardDistributionWindow);
        else message.rewardDistributionWindow = $366e04f29fe8ae43$var$long_1.default.UZERO;
        if (object.whitelist !== undefined && object.whitelist !== null) for (const e of object.whitelist)message.whitelist.push(module.exports.Denom.fromJSON(e));
        if (object.slashFraction !== undefined && object.slashFraction !== null) message.slashFraction = String(object.slashFraction);
        else message.slashFraction = "";
        if (object.slashWindow !== undefined && object.slashWindow !== null) message.slashWindow = $366e04f29fe8ae43$var$long_1.default.fromString(object.slashWindow);
        else message.slashWindow = $366e04f29fe8ae43$var$long_1.default.UZERO;
        if (object.minValidPerWindow !== undefined && object.minValidPerWindow !== null) message.minValidPerWindow = String(object.minValidPerWindow);
        else message.minValidPerWindow = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.votePeriod !== undefined && (obj.votePeriod = (message.votePeriod || $366e04f29fe8ae43$var$long_1.default.UZERO).toString());
        message.voteThreshold !== undefined && (obj.voteThreshold = message.voteThreshold);
        message.rewardBand !== undefined && (obj.rewardBand = message.rewardBand);
        message.rewardDistributionWindow !== undefined && (obj.rewardDistributionWindow = (message.rewardDistributionWindow || $366e04f29fe8ae43$var$long_1.default.UZERO).toString());
        if (message.whitelist) obj.whitelist = message.whitelist.map((e)=>e ? module.exports.Denom.toJSON(e) : undefined);
        else obj.whitelist = [];
        message.slashFraction !== undefined && (obj.slashFraction = message.slashFraction);
        message.slashWindow !== undefined && (obj.slashWindow = (message.slashWindow || $366e04f29fe8ae43$var$long_1.default.UZERO).toString());
        message.minValidPerWindow !== undefined && (obj.minValidPerWindow = message.minValidPerWindow);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $366e04f29fe8ae43$var$baseParams);
        message.whitelist = [];
        if (object.votePeriod !== undefined && object.votePeriod !== null) message.votePeriod = object.votePeriod;
        else message.votePeriod = $366e04f29fe8ae43$var$long_1.default.UZERO;
        if (object.voteThreshold !== undefined && object.voteThreshold !== null) message.voteThreshold = object.voteThreshold;
        else message.voteThreshold = "";
        if (object.rewardBand !== undefined && object.rewardBand !== null) message.rewardBand = object.rewardBand;
        else message.rewardBand = "";
        if (object.rewardDistributionWindow !== undefined && object.rewardDistributionWindow !== null) message.rewardDistributionWindow = object.rewardDistributionWindow;
        else message.rewardDistributionWindow = $366e04f29fe8ae43$var$long_1.default.UZERO;
        if (object.whitelist !== undefined && object.whitelist !== null) for (const e of object.whitelist)message.whitelist.push(module.exports.Denom.fromPartial(e));
        if (object.slashFraction !== undefined && object.slashFraction !== null) message.slashFraction = object.slashFraction;
        else message.slashFraction = "";
        if (object.slashWindow !== undefined && object.slashWindow !== null) message.slashWindow = object.slashWindow;
        else message.slashWindow = $366e04f29fe8ae43$var$long_1.default.UZERO;
        if (object.minValidPerWindow !== undefined && object.minValidPerWindow !== null) message.minValidPerWindow = object.minValidPerWindow;
        else message.minValidPerWindow = "";
        return message;
    }
};
const $366e04f29fe8ae43$var$baseDenom = {
    name: "",
    tobinTax: ""
};
module.exports.Denom = {
    encode (message, writer = $366e04f29fe8ae43$var$minimal_1.default.Writer.create()) {
        if (message.name !== "") writer.uint32(10).string(message.name);
        if (message.tobinTax !== "") writer.uint32(18).string(message.tobinTax);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $366e04f29fe8ae43$var$minimal_1.default.Reader ? input : new $366e04f29fe8ae43$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $366e04f29fe8ae43$var$baseDenom);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.tobinTax = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $366e04f29fe8ae43$var$baseDenom);
        if (object.name !== undefined && object.name !== null) message.name = String(object.name);
        else message.name = "";
        if (object.tobinTax !== undefined && object.tobinTax !== null) message.tobinTax = String(object.tobinTax);
        else message.tobinTax = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.name !== undefined && (obj.name = message.name);
        message.tobinTax !== undefined && (obj.tobinTax = message.tobinTax);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $366e04f29fe8ae43$var$baseDenom);
        if (object.name !== undefined && object.name !== null) message.name = object.name;
        else message.name = "";
        if (object.tobinTax !== undefined && object.tobinTax !== null) message.tobinTax = object.tobinTax;
        else message.tobinTax = "";
        return message;
    }
};
const $366e04f29fe8ae43$var$baseAggregateExchangeRatePrevote = {
    hash: "",
    voter: "",
    submitBlock: $366e04f29fe8ae43$var$long_1.default.UZERO
};
module.exports.AggregateExchangeRatePrevote = {
    encode (message, writer = $366e04f29fe8ae43$var$minimal_1.default.Writer.create()) {
        if (message.hash !== "") writer.uint32(10).string(message.hash);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        if (!message.submitBlock.isZero()) writer.uint32(24).uint64(message.submitBlock);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $366e04f29fe8ae43$var$minimal_1.default.Reader ? input : new $366e04f29fe8ae43$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $366e04f29fe8ae43$var$baseAggregateExchangeRatePrevote);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.string();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.submitBlock = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $366e04f29fe8ae43$var$baseAggregateExchangeRatePrevote);
        if (object.hash !== undefined && object.hash !== null) message.hash = String(object.hash);
        else message.hash = "";
        if (object.voter !== undefined && object.voter !== null) message.voter = String(object.voter);
        else message.voter = "";
        if (object.submitBlock !== undefined && object.submitBlock !== null) message.submitBlock = $366e04f29fe8ae43$var$long_1.default.fromString(object.submitBlock);
        else message.submitBlock = $366e04f29fe8ae43$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = message.hash);
        message.voter !== undefined && (obj.voter = message.voter);
        message.submitBlock !== undefined && (obj.submitBlock = (message.submitBlock || $366e04f29fe8ae43$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $366e04f29fe8ae43$var$baseAggregateExchangeRatePrevote);
        if (object.hash !== undefined && object.hash !== null) message.hash = object.hash;
        else message.hash = "";
        if (object.voter !== undefined && object.voter !== null) message.voter = object.voter;
        else message.voter = "";
        if (object.submitBlock !== undefined && object.submitBlock !== null) message.submitBlock = object.submitBlock;
        else message.submitBlock = $366e04f29fe8ae43$var$long_1.default.UZERO;
        return message;
    }
};
const $366e04f29fe8ae43$var$baseAggregateExchangeRateVote = {
    voter: ""
};
module.exports.AggregateExchangeRateVote = {
    encode (message, writer = $366e04f29fe8ae43$var$minimal_1.default.Writer.create()) {
        for (const v of message.exchangeRateTuples)module.exports.ExchangeRateTuple.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $366e04f29fe8ae43$var$minimal_1.default.Reader ? input : new $366e04f29fe8ae43$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $366e04f29fe8ae43$var$baseAggregateExchangeRateVote);
        message.exchangeRateTuples = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.exchangeRateTuples.push(module.exports.ExchangeRateTuple.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $366e04f29fe8ae43$var$baseAggregateExchangeRateVote);
        message.exchangeRateTuples = [];
        if (object.exchangeRateTuples !== undefined && object.exchangeRateTuples !== null) for (const e of object.exchangeRateTuples)message.exchangeRateTuples.push(module.exports.ExchangeRateTuple.fromJSON(e));
        if (object.voter !== undefined && object.voter !== null) message.voter = String(object.voter);
        else message.voter = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.exchangeRateTuples) obj.exchangeRateTuples = message.exchangeRateTuples.map((e)=>e ? module.exports.ExchangeRateTuple.toJSON(e) : undefined);
        else obj.exchangeRateTuples = [];
        message.voter !== undefined && (obj.voter = message.voter);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $366e04f29fe8ae43$var$baseAggregateExchangeRateVote);
        message.exchangeRateTuples = [];
        if (object.exchangeRateTuples !== undefined && object.exchangeRateTuples !== null) for (const e of object.exchangeRateTuples)message.exchangeRateTuples.push(module.exports.ExchangeRateTuple.fromPartial(e));
        if (object.voter !== undefined && object.voter !== null) message.voter = object.voter;
        else message.voter = "";
        return message;
    }
};
const $366e04f29fe8ae43$var$baseExchangeRateTuple = {
    denom: "",
    exchangeRate: ""
};
module.exports.ExchangeRateTuple = {
    encode (message, writer = $366e04f29fe8ae43$var$minimal_1.default.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.exchangeRate !== "") writer.uint32(18).string(message.exchangeRate);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $366e04f29fe8ae43$var$minimal_1.default.Reader ? input : new $366e04f29fe8ae43$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $366e04f29fe8ae43$var$baseExchangeRateTuple);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.exchangeRate = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $366e04f29fe8ae43$var$baseExchangeRateTuple);
        if (object.denom !== undefined && object.denom !== null) message.denom = String(object.denom);
        else message.denom = "";
        if (object.exchangeRate !== undefined && object.exchangeRate !== null) message.exchangeRate = String(object.exchangeRate);
        else message.exchangeRate = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.exchangeRate !== undefined && (obj.exchangeRate = message.exchangeRate);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $366e04f29fe8ae43$var$baseExchangeRateTuple);
        if (object.denom !== undefined && object.denom !== null) message.denom = object.denom;
        else message.denom = "";
        if (object.exchangeRate !== undefined && object.exchangeRate !== null) message.exchangeRate = object.exchangeRate;
        else message.exchangeRate = "";
        return message;
    }
};
if ($366e04f29fe8ae43$var$minimal_1.default.util.Long !== $366e04f29fe8ae43$var$long_1.default) {
    $366e04f29fe8ae43$var$minimal_1.default.util.Long = $366e04f29fe8ae43$var$long_1.default;
    $366e04f29fe8ae43$var$minimal_1.default.configure();
}

});


parcelRegister("hpFag", function(module, exports) {
"use strict";
var $cad4b3ea09738a53$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExchangeRateTuple = module.exports.AggregateExchangeRateVote = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $4FJ9M = parcelRequire("4FJ9M");

var $5iXRZ = parcelRequire("5iXRZ");
/**
 * Stores information about data about Oracle aggregate vote fetched from the blockchain.
 */ var $cad4b3ea09738a53$var$AggregateExchangeRateVote = /** @class */ function(_super) {
    $cad4b3ea09738a53$var$__extends(AggregateExchangeRateVote, _super);
    /**
     * @param exchange_rate_tuples exchange rates for LUNA
     * @param voter validator
     */ function AggregateExchangeRateVote(exchange_rate_tuples, voter) {
        var _this = _super.call(this) || this;
        _this.exchange_rate_tuples = exchange_rate_tuples;
        _this.voter = voter;
        return _this;
    }
    AggregateExchangeRateVote.fromAmino = function(data) {
        var exchange_rate_tuples = data.exchange_rate_tuples, voter = data.voter;
        return new AggregateExchangeRateVote(exchange_rate_tuples.map(function(t) {
            return $cad4b3ea09738a53$var$ExchangeRateTuple.fromAmino(t);
        }), voter);
    };
    AggregateExchangeRateVote.prototype.toAmino = function() {
        var _a = this, exchange_rate_tuples = _a.exchange_rate_tuples, voter = _a.voter;
        return {
            exchange_rate_tuples: exchange_rate_tuples.map(function(e) {
                return e.toAmino();
            }),
            voter: voter
        };
    };
    AggregateExchangeRateVote.fromData = function(data) {
        var exchange_rate_tuples = data.exchange_rate_tuples, voter = data.voter;
        return new AggregateExchangeRateVote(exchange_rate_tuples.map(function(t) {
            return $cad4b3ea09738a53$var$ExchangeRateTuple.fromData(t);
        }), voter);
    };
    AggregateExchangeRateVote.prototype.toData = function() {
        var _a = this, exchange_rate_tuples = _a.exchange_rate_tuples, voter = _a.voter;
        return {
            exchange_rate_tuples: exchange_rate_tuples.map(function(e) {
                return e.toData();
            }),
            voter: voter
        };
    };
    AggregateExchangeRateVote.fromProto = function(data) {
        return new AggregateExchangeRateVote(data.exchangeRateTuples.map(function(t) {
            return $cad4b3ea09738a53$var$ExchangeRateTuple.fromProto(t);
        }), data.voter);
    };
    AggregateExchangeRateVote.prototype.toProto = function() {
        var _a = this, exchange_rate_tuples = _a.exchange_rate_tuples, voter = _a.voter;
        return $4FJ9M.AggregateExchangeRateVote.fromPartial({
            exchangeRateTuples: exchange_rate_tuples.map(function(t) {
                return t.toProto();
            }),
            voter: voter
        });
    };
    return AggregateExchangeRateVote;
}($26Eqx.JSONSerializable);
module.exports.AggregateExchangeRateVote = $cad4b3ea09738a53$var$AggregateExchangeRateVote;
var $cad4b3ea09738a53$var$ExchangeRateTuple = /** @class */ function(_super) {
    $cad4b3ea09738a53$var$__extends(ExchangeRateTuple, _super);
    function ExchangeRateTuple(denom, exchange_rate) {
        var _this = _super.call(this) || this;
        _this.denom = denom;
        _this.exchange_rate = new $5iXRZ.Dec(exchange_rate);
        return _this;
    }
    ExchangeRateTuple.fromAmino = function(data) {
        var denom = data.denom, exchange_rate = data.exchange_rate;
        return new ExchangeRateTuple(denom, exchange_rate);
    };
    ExchangeRateTuple.prototype.toAmino = function() {
        var _a = this, denom = _a.denom, exchange_rate = _a.exchange_rate;
        return {
            denom: denom,
            exchange_rate: exchange_rate.toString()
        };
    };
    ExchangeRateTuple.fromData = function(data) {
        var denom = data.denom, exchange_rate = data.exchange_rate;
        return new ExchangeRateTuple(denom, exchange_rate);
    };
    ExchangeRateTuple.prototype.toData = function() {
        var _a = this, denom = _a.denom, exchange_rate = _a.exchange_rate;
        return {
            denom: denom,
            exchange_rate: exchange_rate.toString()
        };
    };
    ExchangeRateTuple.fromProto = function(proto) {
        return new ExchangeRateTuple(proto.denom, proto.exchangeRate);
    };
    ExchangeRateTuple.prototype.toProto = function() {
        var _a = this, denom = _a.denom, exchange_rate = _a.exchange_rate;
        return $4FJ9M.ExchangeRateTuple.fromPartial({
            denom: denom,
            exchangeRate: exchange_rate.toString()
        });
    };
    return ExchangeRateTuple;
}($26Eqx.JSONSerializable);
module.exports.ExchangeRateTuple = $cad4b3ea09738a53$var$ExchangeRateTuple;

});

parcelRegister("k32CU", function(module, exports) {
"use strict";
var $e986200f1f070a13$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Delegation = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $5iXRZ = parcelRequire("5iXRZ");

var $7yVzo = parcelRequire("7yVzo");

var $dbzoH = parcelRequire("dbzoH");
/**
 * Stores information about the status of a delegation between a delegator and validator, fetched from the blockchain.
 */ var $e986200f1f070a13$var$Delegation = /** @class */ function(_super) {
    $e986200f1f070a13$var$__extends(Delegation, _super);
    /**
     * @param delegator_address 	delegator's account address
     * @param validator_address 	validator's operator address
     * @param shares 	delegator's shares
     * @param balance balance of the delegation
     */ function Delegation(delegator_address, validator_address, shares, balance) {
        var _this = _super.call(this) || this;
        _this.delegator_address = delegator_address;
        _this.validator_address = validator_address;
        _this.shares = shares;
        _this.balance = balance;
        return _this;
    }
    Delegation.fromAmino = function(data) {
        var _a = data.delegation, delegator_address = _a.delegator_address, validator_address = _a.validator_address, shares = _a.shares, balance = data.balance;
        return new Delegation(delegator_address, validator_address, new $5iXRZ.Dec(shares), $7yVzo.Coin.fromAmino(balance));
    };
    Delegation.prototype.toAmino = function() {
        var _a = this, delegator_address = _a.delegator_address, validator_address = _a.validator_address, shares = _a.shares, balance = _a.balance;
        return {
            delegation: {
                delegator_address: delegator_address,
                validator_address: validator_address,
                shares: shares.toString()
            },
            balance: balance.toAmino()
        };
    };
    Delegation.fromData = function(data) {
        var _a = data.delegation, delegator_address = _a.delegator_address, validator_address = _a.validator_address, shares = _a.shares, balance = data.balance;
        return new Delegation(delegator_address, validator_address, new $5iXRZ.Dec(shares), $7yVzo.Coin.fromData(balance));
    };
    Delegation.prototype.toData = function() {
        var _a = this, delegator_address = _a.delegator_address, validator_address = _a.validator_address, shares = _a.shares, balance = _a.balance;
        return {
            delegation: {
                delegator_address: delegator_address,
                validator_address: validator_address,
                shares: shares.toString()
            },
            balance: balance.toData()
        };
    };
    Delegation.fromProto = function(proto) {
        var delegationProto = proto.delegation;
        return new Delegation(delegationProto.delegatorAddress, delegationProto.validatorAddress, new $5iXRZ.Dec(delegationProto.shares), $7yVzo.Coin.fromProto(proto.balance));
    };
    Delegation.prototype.toProto = function() {
        var _a = this, delegator_address = _a.delegator_address, validator_address = _a.validator_address, shares = _a.shares, balance = _a.balance;
        return $dbzoH.DelegationResponse.fromPartial({
            delegation: $dbzoH.Delegation.fromPartial({
                delegatorAddress: delegator_address,
                shares: shares.toString(),
                validatorAddress: validator_address
            }),
            balance: balance.toProto()
        });
    };
    return Delegation;
}($26Eqx.JSONSerializable);
module.exports.Delegation = $e986200f1f070a13$var$Delegation;

});

parcelRegister("Oysv5", function(module, exports) {
"use strict";
var $097f66673fabff35$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $097f66673fabff35$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $097f66673fabff35$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $097f66673fabff35$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $097f66673fabff35$var$__createBinding(result, mod, k);
    }
    $097f66673fabff35$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Redelegation = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $5iXRZ = parcelRequire("5iXRZ");

var $dbzoH = parcelRequire("dbzoH");

var $097f66673fabff35$var$Long = $097f66673fabff35$var$__importStar((parcelRequire("9A55m")));
/**
 * A redelegation is when a delegator decides to stop staking with one validator and
 * transfer their delegation to another validator. Rather than unbonding (which takes
 * some time) and re-staking, the funds can be redelegated immediately if a
 * [[Redelegation.Entry]] can be created.
 *
 * A redelegation, like an unbonding delegation, is implemented through
 * [[Redelegation.Entry]] objects, limited by the `max_entry` parameter in the staking
 * module params. For each pair of source and target validators, you cannot redelegate
 * more times than the amount of entries. Entries are cleared when the redelegation is
 * completed, the same amount of time as unbonding.
 */ var $097f66673fabff35$var$Redelegation = /** @class */ function(_super) {
    $097f66673fabff35$var$__extends(Redelegation, _super);
    /**
     *
     * @param delegator_address delegator's account address
     * @param validator_src_address source validator's operator address (from)
     * @param validator_dst_address target validator's operator address (to)
     * @param entries entries
     */ function Redelegation(delegator_address, validator_src_address, validator_dst_address, entries) {
        var _this = _super.call(this) || this;
        _this.delegator_address = delegator_address;
        _this.validator_src_address = validator_src_address;
        _this.validator_dst_address = validator_dst_address;
        _this.entries = entries;
        return _this;
    }
    Redelegation.fromAmino = function(data) {
        var _a = data.redelegation, delegator_address = _a.delegator_address, validator_src_address = _a.validator_src_address, validator_dst_address = _a.validator_dst_address, entries = data.entries;
        return new Redelegation(delegator_address, validator_src_address, validator_dst_address, entries.map(function(e) {
            return Redelegation.Entry.fromAmino(e);
        }));
    };
    Redelegation.prototype.toAmino = function() {
        var _a = this, delegator_address = _a.delegator_address, validator_src_address = _a.validator_src_address, validator_dst_address = _a.validator_dst_address, entries = _a.entries;
        return {
            redelegation: {
                delegator_address: delegator_address,
                validator_src_address: validator_src_address,
                validator_dst_address: validator_dst_address
            },
            entries: entries.map(function(e) {
                return e.toAmino();
            })
        };
    };
    Redelegation.fromData = function(data) {
        var _a = data.redelegation, delegator_address = _a.delegator_address, validator_src_address = _a.validator_src_address, validator_dst_address = _a.validator_dst_address, entries = data.entries;
        return new Redelegation(delegator_address, validator_src_address, validator_dst_address, entries.map(function(e) {
            return Redelegation.Entry.fromData(e);
        }));
    };
    Redelegation.prototype.toData = function() {
        var _a = this, delegator_address = _a.delegator_address, validator_src_address = _a.validator_src_address, validator_dst_address = _a.validator_dst_address, entries = _a.entries;
        return {
            redelegation: {
                delegator_address: delegator_address,
                validator_src_address: validator_src_address,
                validator_dst_address: validator_dst_address
            },
            entries: entries.map(function(e) {
                return e.toData();
            })
        };
    };
    Redelegation.fromProto = function(data) {
        var redelegationProto = data.redelegation;
        return new Redelegation(redelegationProto.delegatorAddress, redelegationProto.validatorDstAddress, redelegationProto.validatorDstAddress, data.entries.map(function(e) {
            return Redelegation.Entry.fromProto(e);
        }));
    };
    Redelegation.prototype.toProto = function() {
        var _a = this, delegator_address = _a.delegator_address, validator_src_address = _a.validator_src_address, validator_dst_address = _a.validator_dst_address, entries = _a.entries;
        return $dbzoH.RedelegationResponse.fromPartial({
            entries: entries.map(function(e) {
                return e.toProto();
            }),
            redelegation: $dbzoH.Redelegation.fromPartial({
                delegatorAddress: delegator_address,
                entries: entries.map(function(e) {
                    return e.toProto().redelegationEntry;
                }),
                validatorDstAddress: validator_dst_address,
                validatorSrcAddress: validator_src_address
            })
        });
    };
    return Redelegation;
}($26Eqx.JSONSerializable);
module.exports.Redelegation = $097f66673fabff35$var$Redelegation;
(function(Redelegation) {
    var Entry = /** @class */ function(_super) {
        $097f66673fabff35$var$__extends(Entry, _super);
        /**
         *
         * @param initial_balance balance of delegation prior to initiating redelegation
         * @param shares_dst
         * @param creation_height 	height of blockchain when entry was created
         * @param completion_time time when redelegation entry will be removed
         */ function Entry(initial_balance, balance, shares_dst, creation_height, completion_time) {
            var _this = _super.call(this) || this;
            _this.initial_balance = initial_balance;
            _this.balance = balance;
            _this.shares_dst = shares_dst;
            _this.creation_height = creation_height;
            _this.completion_time = completion_time;
            return _this;
        }
        Entry.prototype.toAmino = function() {
            return {
                redelegation_entry: {
                    initial_balance: this.initial_balance.toString(),
                    shares_dst: this.shares_dst.toString(),
                    creation_height: this.creation_height,
                    completion_time: this.completion_time.toISOString()
                },
                balance: this.balance.toString()
            };
        };
        Entry.fromAmino = function(data) {
            var _a = data.redelegation_entry, initial_balance = _a.initial_balance, shares_dst = _a.shares_dst, creation_height = _a.creation_height, completion_time = _a.completion_time, balance = data.balance;
            return new Entry(new $5iXRZ.Int(initial_balance), new $5iXRZ.Int(balance), new $5iXRZ.Dec(shares_dst), creation_height, new Date(completion_time));
        };
        Entry.prototype.toData = function() {
            return {
                redelegation_entry: {
                    initial_balance: this.initial_balance.toString(),
                    shares_dst: this.shares_dst.toString(),
                    creation_height: this.creation_height,
                    completion_time: this.completion_time.toISOString()
                },
                balance: this.balance.toString()
            };
        };
        Entry.fromData = function(data) {
            var _a = data.redelegation_entry, initial_balance = _a.initial_balance, shares_dst = _a.shares_dst, creation_height = _a.creation_height, completion_time = _a.completion_time, balance = data.balance;
            return new Entry(new $5iXRZ.Int(initial_balance), new $5iXRZ.Int(balance), new $5iXRZ.Dec(shares_dst), creation_height, new Date(completion_time));
        };
        Entry.prototype.toProto = function() {
            var _a = this, initial_balance = _a.initial_balance, balance = _a.balance, shares_dst = _a.shares_dst, creation_height = _a.creation_height, completion_time = _a.completion_time;
            return $dbzoH.RedelegationEntryResponse.fromPartial({
                balance: balance.toString(),
                redelegationEntry: $dbzoH.RedelegationEntry.fromPartial({
                    completionTime: completion_time,
                    creationHeight: $097f66673fabff35$var$Long.fromNumber(creation_height),
                    initialBalance: initial_balance.toString(),
                    sharesDst: shares_dst.toString()
                })
            });
        };
        Entry.fromProto = function(proto) {
            var redelegationEntryProto = proto.redelegationEntry;
            return new Entry(new $5iXRZ.Int(redelegationEntryProto.initialBalance), new $5iXRZ.Int(proto.balance), new $5iXRZ.Dec(redelegationEntryProto.sharesDst), redelegationEntryProto.creationHeight.toNumber(), redelegationEntryProto.completionTime);
        };
        return Entry;
    }($26Eqx.JSONSerializable);
    Redelegation.Entry = Entry;
})($097f66673fabff35$var$Redelegation = module.exports.Redelegation || (module.exports.Redelegation = {}));
module.exports.Redelegation = $097f66673fabff35$var$Redelegation;

});

parcelRegister("iTcdG", function(module, exports) {
"use strict";
var $dc06d7a6aa90d516$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $dc06d7a6aa90d516$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $dc06d7a6aa90d516$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $dc06d7a6aa90d516$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $dc06d7a6aa90d516$var$__createBinding(result, mod, k);
    }
    $dc06d7a6aa90d516$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UnbondingDelegation = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $5iXRZ = parcelRequire("5iXRZ");

var $dbzoH = parcelRequire("dbzoH");

var $dc06d7a6aa90d516$var$Long = $dc06d7a6aa90d516$var$__importStar((parcelRequire("9A55m")));
/**
 * When a delegator decides to take out their funds from the staking pool, they must
 * unbond their tokens which takes an amount of time specified by `unbonding_time`
 * parameter in the staking module.
 *
 * An unbonding delegation is implemented through creating [[UnbondingDelegation.Entry]]
 * objects, limited by the max_entry parameter in the staking module params. You cannot
 * initiate unbonds more times than the amount of entries permitted. Entries are cleared
 * when their unbonding periods are completed and the funds are returned to the
 * delegator's account balance to be spent freely.
 */ var $dc06d7a6aa90d516$var$UnbondingDelegation = /** @class */ function(_super) {
    $dc06d7a6aa90d516$var$__extends(UnbondingDelegation, _super);
    function UnbondingDelegation(delegator_address, validator_address, entries) {
        var _this = _super.call(this) || this;
        _this.delegator_address = delegator_address;
        _this.validator_address = validator_address;
        _this.entries = entries;
        return _this;
    }
    UnbondingDelegation.fromAmino = function(data) {
        var delegator_address = data.delegator_address, validator_address = data.validator_address, entries = data.entries;
        return new UnbondingDelegation(delegator_address, validator_address, entries.map(function(e) {
            return UnbondingDelegation.Entry.fromAmino(e);
        }));
    };
    UnbondingDelegation.prototype.toAmino = function() {
        var _a = this, delegator_address = _a.delegator_address, validator_address = _a.validator_address, entries = _a.entries;
        return {
            delegator_address: delegator_address,
            validator_address: validator_address,
            entries: entries.map(function(e) {
                return e.toAmino();
            })
        };
    };
    UnbondingDelegation.fromData = function(data) {
        var delegator_address = data.delegator_address, validator_address = data.validator_address, entries = data.entries;
        return new UnbondingDelegation(delegator_address, validator_address, entries.map(function(e) {
            return UnbondingDelegation.Entry.fromData(e);
        }));
    };
    UnbondingDelegation.prototype.toData = function() {
        var _a = this, delegator_address = _a.delegator_address, validator_address = _a.validator_address, entries = _a.entries;
        return {
            delegator_address: delegator_address,
            validator_address: validator_address,
            entries: entries.map(function(e) {
                return e.toData();
            })
        };
    };
    UnbondingDelegation.prototype.toProto = function() {
        var _a = this, delegator_address = _a.delegator_address, validator_address = _a.validator_address, entries = _a.entries;
        return $dbzoH.UnbondingDelegation.fromPartial({
            delegatorAddress: delegator_address,
            entries: entries.map(function(e) {
                return e.toProto();
            }),
            validatorAddress: validator_address
        });
    };
    UnbondingDelegation.fromProto = function(proto) {
        return new UnbondingDelegation(proto.delegatorAddress, proto.validatorAddress, proto.entries.map(function(e) {
            return UnbondingDelegation.Entry.fromProto(e);
        }));
    };
    return UnbondingDelegation;
}($26Eqx.JSONSerializable);
module.exports.UnbondingDelegation = $dc06d7a6aa90d516$var$UnbondingDelegation;
(function(UnbondingDelegation) {
    var Entry = /** @class */ function(_super) {
        $dc06d7a6aa90d516$var$__extends(Entry, _super);
        /**
         * Note that the size of the undelegation is `initial_balance - balance`
         * @param initial_balance balance of delegation prior to initiating unbond
         * @param balance balance of delegation after initiating unbond
         * @param creation_height height of blockchain when entry was created
         * @param completion_time time when unbonding will be completed
         */ function Entry(initial_balance, balance, creation_height, completion_time) {
            var _this = _super.call(this) || this;
            _this.initial_balance = initial_balance;
            _this.balance = balance;
            _this.creation_height = creation_height;
            _this.completion_time = completion_time;
            return _this;
        }
        Entry.prototype.toAmino = function() {
            return {
                initial_balance: this.initial_balance.toString(),
                balance: this.balance.toString(),
                creation_height: this.creation_height.toFixed(),
                completion_time: this.completion_time.toISOString()
            };
        };
        Entry.fromAmino = function(data) {
            var initial_balance = data.initial_balance, balance = data.balance, creation_height = data.creation_height, completion_time = data.completion_time;
            return new Entry(new $5iXRZ.Int(initial_balance), new $5iXRZ.Int(balance), Number.parseInt(creation_height), new Date(completion_time));
        };
        Entry.prototype.toData = function() {
            return {
                initial_balance: this.initial_balance.toString(),
                balance: this.balance.toString(),
                creation_height: this.creation_height.toFixed(),
                completion_time: this.completion_time.toISOString()
            };
        };
        Entry.fromData = function(data) {
            var initial_balance = data.initial_balance, balance = data.balance, creation_height = data.creation_height, completion_time = data.completion_time;
            return new Entry(new $5iXRZ.Int(initial_balance), new $5iXRZ.Int(balance), Number.parseInt(creation_height), new Date(completion_time));
        };
        Entry.prototype.toProto = function() {
            var _a = this, initial_balance = _a.initial_balance, balance = _a.balance, creation_height = _a.creation_height, completion_time = _a.completion_time;
            return $dbzoH.UnbondingDelegationEntry.fromPartial({
                balance: balance.toString(),
                completionTime: completion_time,
                creationHeight: $dc06d7a6aa90d516$var$Long.fromNumber(creation_height),
                initialBalance: initial_balance.toString()
            });
        };
        Entry.fromProto = function(proto) {
            return new Entry(new $5iXRZ.Int(proto.initialBalance), new $5iXRZ.Int(proto.balance), proto.creationHeight.toNumber(), proto.completionTime);
        };
        return Entry;
    }($26Eqx.JSONSerializable);
    UnbondingDelegation.Entry = Entry;
})($dc06d7a6aa90d516$var$UnbondingDelegation = module.exports.UnbondingDelegation || (module.exports.UnbondingDelegation = {}));
module.exports.UnbondingDelegation = $dc06d7a6aa90d516$var$UnbondingDelegation;

});

parcelRegister("ijOp6", function(module, exports) {
"use strict";
var $d5611985cbb20921$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PolicyConstraints = void 0;

var $26Eqx = parcelRequire("26Eqx");

var $7yVzo = parcelRequire("7yVzo");

var $5iXRZ = parcelRequire("5iXRZ");

var $7hf7Q = parcelRequire("7hf7Q");
/**
 * This captures the Treasury module's `tax_policy` and `reward_policy` parameters, which
 * determine how the Tax Rate and Reward Weight values are allowed to change.
 */ var $d5611985cbb20921$var$PolicyConstraints = /** @class */ function(_super) {
    $d5611985cbb20921$var$__extends(PolicyConstraints, _super);
    /**
     *
     * @param rate_min minimum value
     * @param rate_max maximum value
     * @param cap Tax Cap (only applicable for Tax Rate)
     * @param change_rate_max max change %
     */ function PolicyConstraints(rate_min, rate_max, cap, change_rate_max) {
        var _this = _super.call(this) || this;
        _this.cap = cap;
        _this.rate_min = new $5iXRZ.Dec(rate_min);
        _this.rate_max = new $5iXRZ.Dec(rate_max);
        _this.change_rate_max = new $5iXRZ.Dec(change_rate_max);
        return _this;
    }
    PolicyConstraints.fromAmino = function(data) {
        var rate_min = data.rate_min, rate_max = data.rate_max, cap = data.cap, change_rate_max = data.change_rate_max;
        return new PolicyConstraints(rate_min, rate_max, $7yVzo.Coin.fromAmino(cap), change_rate_max);
    };
    PolicyConstraints.prototype.toAmino = function() {
        var _a = this, rate_min = _a.rate_min, rate_max = _a.rate_max, cap = _a.cap, change_rate_max = _a.change_rate_max;
        return {
            rate_min: rate_min.toString(),
            rate_max: rate_max.toString(),
            cap: cap.toAmino(),
            change_rate_max: change_rate_max.toString()
        };
    };
    PolicyConstraints.fromData = function(data) {
        var rate_min = data.rate_min, rate_max = data.rate_max, cap = data.cap, change_rate_max = data.change_rate_max;
        return new PolicyConstraints(rate_min, rate_max, $7yVzo.Coin.fromData(cap), change_rate_max);
    };
    PolicyConstraints.prototype.toData = function() {
        var _a = this, rate_min = _a.rate_min, rate_max = _a.rate_max, cap = _a.cap, change_rate_max = _a.change_rate_max;
        return {
            rate_min: rate_min.toString(),
            rate_max: rate_max.toString(),
            cap: cap.toData(),
            change_rate_max: change_rate_max.toString()
        };
    };
    PolicyConstraints.fromProto = function(proto) {
        return new PolicyConstraints(proto.rateMax, proto.rateMin, $7yVzo.Coin.fromProto(proto.cap), proto.changeRateMax);
    };
    PolicyConstraints.prototype.toProto = function() {
        var _a = this, rate_min = _a.rate_min, rate_max = _a.rate_max, cap = _a.cap, change_rate_max = _a.change_rate_max;
        return $7hf7Q.PolicyConstraints.fromPartial({
            cap: cap.toProto(),
            changeRateMax: change_rate_max.toString(),
            rateMax: rate_max.toString(),
            rateMin: rate_min.toString()
        });
    };
    /**
     * You can simulate the result of the clamping algorithm, which subjects updates in
     * rate to the rules defined by the `PolicyConstraints`.
     *
     * @param prevRate previous rate
     * @param newRate next rate
     * @returns New rate, after clamping constraints have been applied
     */ PolicyConstraints.prototype.clamp = function(prevRate, newRate) {
        var p = new $5iXRZ.Dec(prevRate); // prev
        var n = new $5iXRZ.Dec(newRate); // new
        if (n.lt(this.rate_min)) n = this.rate_min;
        else if (n.gt(this.rate_max)) n = this.rate_max;
        var delta = n.sub(p);
        if (n.gt(p)) {
            if (delta.gt(this.change_rate_max)) n = p.add(this.change_rate_max);
        } else if (delta.abs().gt(this.change_rate_max)) n = p.sub(this.change_rate_max);
        return n;
    };
    return PolicyConstraints;
}($26Eqx.JSONSerializable);
module.exports.PolicyConstraints = $d5611985cbb20921$var$PolicyConstraints;

});
parcelRegister("7hf7Q", function(module, exports) {
"use strict";
var $54c5da86569decb8$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EpochInitialIssuance = module.exports.EpochTaxProceeds = module.exports.PolicyConstraints = module.exports.Params = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $54c5da86569decb8$var$long_1 = $54c5da86569decb8$var$__importDefault((parcelRequire("9A55m")));

const $54c5da86569decb8$var$minimal_1 = $54c5da86569decb8$var$__importDefault((parcelRequire("i2pIU")));

var $8K62q = parcelRequire("8K62q");
module.exports.protobufPackage = "terra.treasury.v1beta1";
const $54c5da86569decb8$var$baseParams = {
    seigniorageBurdenTarget: "",
    miningIncrement: "",
    windowShort: $54c5da86569decb8$var$long_1.default.UZERO,
    windowLong: $54c5da86569decb8$var$long_1.default.UZERO,
    windowProbation: $54c5da86569decb8$var$long_1.default.UZERO,
    burnTaxSplit: ""
};
module.exports.Params = {
    encode (message, writer = $54c5da86569decb8$var$minimal_1.default.Writer.create()) {
        if (message.taxPolicy !== undefined) module.exports.PolicyConstraints.encode(message.taxPolicy, writer.uint32(10).fork()).ldelim();
        if (message.rewardPolicy !== undefined) module.exports.PolicyConstraints.encode(message.rewardPolicy, writer.uint32(18).fork()).ldelim();
        if (message.seigniorageBurdenTarget !== "") writer.uint32(26).string(message.seigniorageBurdenTarget);
        if (message.miningIncrement !== "") writer.uint32(34).string(message.miningIncrement);
        if (!message.windowShort.isZero()) writer.uint32(40).uint64(message.windowShort);
        if (!message.windowLong.isZero()) writer.uint32(48).uint64(message.windowLong);
        if (!message.windowProbation.isZero()) writer.uint32(56).uint64(message.windowProbation);
        if (message.burnTaxSplit !== "") writer.uint32(66).string(message.burnTaxSplit);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $54c5da86569decb8$var$minimal_1.default.Reader ? input : new $54c5da86569decb8$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $54c5da86569decb8$var$baseParams);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.taxPolicy = module.exports.PolicyConstraints.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.rewardPolicy = module.exports.PolicyConstraints.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.seigniorageBurdenTarget = reader.string();
                    break;
                case 4:
                    message.miningIncrement = reader.string();
                    break;
                case 5:
                    message.windowShort = reader.uint64();
                    break;
                case 6:
                    message.windowLong = reader.uint64();
                    break;
                case 7:
                    message.windowProbation = reader.uint64();
                    break;
                case 8:
                    message.burnTaxSplit = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $54c5da86569decb8$var$baseParams);
        if (object.taxPolicy !== undefined && object.taxPolicy !== null) message.taxPolicy = module.exports.PolicyConstraints.fromJSON(object.taxPolicy);
        else message.taxPolicy = undefined;
        if (object.rewardPolicy !== undefined && object.rewardPolicy !== null) message.rewardPolicy = module.exports.PolicyConstraints.fromJSON(object.rewardPolicy);
        else message.rewardPolicy = undefined;
        if (object.seigniorageBurdenTarget !== undefined && object.seigniorageBurdenTarget !== null) message.seigniorageBurdenTarget = String(object.seigniorageBurdenTarget);
        else message.seigniorageBurdenTarget = "";
        if (object.miningIncrement !== undefined && object.miningIncrement !== null) message.miningIncrement = String(object.miningIncrement);
        else message.miningIncrement = "";
        if (object.windowShort !== undefined && object.windowShort !== null) message.windowShort = $54c5da86569decb8$var$long_1.default.fromString(object.windowShort);
        else message.windowShort = $54c5da86569decb8$var$long_1.default.UZERO;
        if (object.windowLong !== undefined && object.windowLong !== null) message.windowLong = $54c5da86569decb8$var$long_1.default.fromString(object.windowLong);
        else message.windowLong = $54c5da86569decb8$var$long_1.default.UZERO;
        if (object.windowProbation !== undefined && object.windowProbation !== null) message.windowProbation = $54c5da86569decb8$var$long_1.default.fromString(object.windowProbation);
        else message.windowProbation = $54c5da86569decb8$var$long_1.default.UZERO;
        if (object.burnTaxSplit !== undefined && object.burnTaxSplit !== null) message.burnTaxSplit = String(object.burnTaxSplit);
        else message.burnTaxSplit = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.taxPolicy !== undefined && (obj.taxPolicy = message.taxPolicy ? module.exports.PolicyConstraints.toJSON(message.taxPolicy) : undefined);
        message.rewardPolicy !== undefined && (obj.rewardPolicy = message.rewardPolicy ? module.exports.PolicyConstraints.toJSON(message.rewardPolicy) : undefined);
        message.seigniorageBurdenTarget !== undefined && (obj.seigniorageBurdenTarget = message.seigniorageBurdenTarget);
        message.miningIncrement !== undefined && (obj.miningIncrement = message.miningIncrement);
        message.windowShort !== undefined && (obj.windowShort = (message.windowShort || $54c5da86569decb8$var$long_1.default.UZERO).toString());
        message.windowLong !== undefined && (obj.windowLong = (message.windowLong || $54c5da86569decb8$var$long_1.default.UZERO).toString());
        message.windowProbation !== undefined && (obj.windowProbation = (message.windowProbation || $54c5da86569decb8$var$long_1.default.UZERO).toString());
        message.burnTaxSplit !== undefined && (obj.burnTaxSplit = message.burnTaxSplit);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $54c5da86569decb8$var$baseParams);
        if (object.taxPolicy !== undefined && object.taxPolicy !== null) message.taxPolicy = module.exports.PolicyConstraints.fromPartial(object.taxPolicy);
        else message.taxPolicy = undefined;
        if (object.rewardPolicy !== undefined && object.rewardPolicy !== null) message.rewardPolicy = module.exports.PolicyConstraints.fromPartial(object.rewardPolicy);
        else message.rewardPolicy = undefined;
        if (object.seigniorageBurdenTarget !== undefined && object.seigniorageBurdenTarget !== null) message.seigniorageBurdenTarget = object.seigniorageBurdenTarget;
        else message.seigniorageBurdenTarget = "";
        if (object.miningIncrement !== undefined && object.miningIncrement !== null) message.miningIncrement = object.miningIncrement;
        else message.miningIncrement = "";
        if (object.windowShort !== undefined && object.windowShort !== null) message.windowShort = object.windowShort;
        else message.windowShort = $54c5da86569decb8$var$long_1.default.UZERO;
        if (object.windowLong !== undefined && object.windowLong !== null) message.windowLong = object.windowLong;
        else message.windowLong = $54c5da86569decb8$var$long_1.default.UZERO;
        if (object.windowProbation !== undefined && object.windowProbation !== null) message.windowProbation = object.windowProbation;
        else message.windowProbation = $54c5da86569decb8$var$long_1.default.UZERO;
        if (object.burnTaxSplit !== undefined && object.burnTaxSplit !== null) message.burnTaxSplit = object.burnTaxSplit;
        else message.burnTaxSplit = "";
        return message;
    }
};
const $54c5da86569decb8$var$basePolicyConstraints = {
    rateMin: "",
    rateMax: "",
    changeRateMax: ""
};
module.exports.PolicyConstraints = {
    encode (message, writer = $54c5da86569decb8$var$minimal_1.default.Writer.create()) {
        if (message.rateMin !== "") writer.uint32(10).string(message.rateMin);
        if (message.rateMax !== "") writer.uint32(18).string(message.rateMax);
        if (message.cap !== undefined) $8K62q.Coin.encode(message.cap, writer.uint32(26).fork()).ldelim();
        if (message.changeRateMax !== "") writer.uint32(34).string(message.changeRateMax);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $54c5da86569decb8$var$minimal_1.default.Reader ? input : new $54c5da86569decb8$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $54c5da86569decb8$var$basePolicyConstraints);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.rateMin = reader.string();
                    break;
                case 2:
                    message.rateMax = reader.string();
                    break;
                case 3:
                    message.cap = $8K62q.Coin.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.changeRateMax = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $54c5da86569decb8$var$basePolicyConstraints);
        if (object.rateMin !== undefined && object.rateMin !== null) message.rateMin = String(object.rateMin);
        else message.rateMin = "";
        if (object.rateMax !== undefined && object.rateMax !== null) message.rateMax = String(object.rateMax);
        else message.rateMax = "";
        if (object.cap !== undefined && object.cap !== null) message.cap = $8K62q.Coin.fromJSON(object.cap);
        else message.cap = undefined;
        if (object.changeRateMax !== undefined && object.changeRateMax !== null) message.changeRateMax = String(object.changeRateMax);
        else message.changeRateMax = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.rateMin !== undefined && (obj.rateMin = message.rateMin);
        message.rateMax !== undefined && (obj.rateMax = message.rateMax);
        message.cap !== undefined && (obj.cap = message.cap ? $8K62q.Coin.toJSON(message.cap) : undefined);
        message.changeRateMax !== undefined && (obj.changeRateMax = message.changeRateMax);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $54c5da86569decb8$var$basePolicyConstraints);
        if (object.rateMin !== undefined && object.rateMin !== null) message.rateMin = object.rateMin;
        else message.rateMin = "";
        if (object.rateMax !== undefined && object.rateMax !== null) message.rateMax = object.rateMax;
        else message.rateMax = "";
        if (object.cap !== undefined && object.cap !== null) message.cap = $8K62q.Coin.fromPartial(object.cap);
        else message.cap = undefined;
        if (object.changeRateMax !== undefined && object.changeRateMax !== null) message.changeRateMax = object.changeRateMax;
        else message.changeRateMax = "";
        return message;
    }
};
const $54c5da86569decb8$var$baseEpochTaxProceeds = {};
module.exports.EpochTaxProceeds = {
    encode (message, writer = $54c5da86569decb8$var$minimal_1.default.Writer.create()) {
        for (const v of message.taxProceeds)$8K62q.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $54c5da86569decb8$var$minimal_1.default.Reader ? input : new $54c5da86569decb8$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $54c5da86569decb8$var$baseEpochTaxProceeds);
        message.taxProceeds = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.taxProceeds.push($8K62q.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $54c5da86569decb8$var$baseEpochTaxProceeds);
        message.taxProceeds = [];
        if (object.taxProceeds !== undefined && object.taxProceeds !== null) for (const e of object.taxProceeds)message.taxProceeds.push($8K62q.Coin.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.taxProceeds) obj.taxProceeds = message.taxProceeds.map((e)=>e ? $8K62q.Coin.toJSON(e) : undefined);
        else obj.taxProceeds = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $54c5da86569decb8$var$baseEpochTaxProceeds);
        message.taxProceeds = [];
        if (object.taxProceeds !== undefined && object.taxProceeds !== null) for (const e of object.taxProceeds)message.taxProceeds.push($8K62q.Coin.fromPartial(e));
        return message;
    }
};
const $54c5da86569decb8$var$baseEpochInitialIssuance = {};
module.exports.EpochInitialIssuance = {
    encode (message, writer = $54c5da86569decb8$var$minimal_1.default.Writer.create()) {
        for (const v of message.issuance)$8K62q.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $54c5da86569decb8$var$minimal_1.default.Reader ? input : new $54c5da86569decb8$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $54c5da86569decb8$var$baseEpochInitialIssuance);
        message.issuance = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.issuance.push($8K62q.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $54c5da86569decb8$var$baseEpochInitialIssuance);
        message.issuance = [];
        if (object.issuance !== undefined && object.issuance !== null) for (const e of object.issuance)message.issuance.push($8K62q.Coin.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.issuance) obj.issuance = message.issuance.map((e)=>e ? $8K62q.Coin.toJSON(e) : undefined);
        else obj.issuance = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $54c5da86569decb8$var$baseEpochInitialIssuance);
        message.issuance = [];
        if (object.issuance !== undefined && object.issuance !== null) for (const e of object.issuance)message.issuance.push($8K62q.Coin.fromPartial(e));
        return message;
    }
};
if ($54c5da86569decb8$var$minimal_1.default.util.Long !== $54c5da86569decb8$var$long_1.default) {
    $54c5da86569decb8$var$minimal_1.default.util.Long = $54c5da86569decb8$var$long_1.default;
    $54c5da86569decb8$var$minimal_1.default.configure();
}

});


parcelRegister("4WQ5t", function(module, exports) {
"use strict";
var $39a4fba1ab7af7c1$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $39a4fba1ab7af7c1$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $39a4fba1ab7af7c1$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$39a4fba1ab7af7c1$var$__exportStar((parcelRequire("efWAQ")), module.exports);

$39a4fba1ab7af7c1$var$__exportStar((parcelRequire("kpoM2")), module.exports);

});

parcelRegister("aFUf1", function(module, exports) {
"use strict";
var $7c595c1054cf20ed$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7c595c1054cf20ed$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $7c595c1054cf20ed$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$7c595c1054cf20ed$var$__exportStar((parcelRequire("5xVNE")), module.exports);

$7c595c1054cf20ed$var$__exportStar((parcelRequire("eTRTS")), module.exports);

});

parcelRegister("47xVX", function(module, exports) {
"use strict";
//import { AccessTypeParam, AccessType } from './AccessTypeParam';
//import { AccessConfig } from './AccessConfig';
var $3002236c2445c4f8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3002236c2445c4f8$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $3002236c2445c4f8$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$3002236c2445c4f8$var$__exportStar((parcelRequire("kh0Oy")), module.exports);

$3002236c2445c4f8$var$__exportStar((parcelRequire("5SZLi")), module.exports);

});
parcelRegister("kh0Oy", function(module, exports) {
"use strict";
var $ec2606e9f9252f2b$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AccessTypeParam = module.exports.AccessType = void 0;

var $odsVG = parcelRequire("odsVG");
Object.defineProperty(module.exports, "AccessType", {
    enumerable: true,
    get: function() {
        return $odsVG.AccessType;
    }
});

var $26Eqx = parcelRequire("26Eqx");

var $8MEJi = parcelRequire("8MEJi");
/**
 *
 */ var $ec2606e9f9252f2b$var$AccessTypeParam = /** @class */ function(_super) {
    $ec2606e9f9252f2b$var$__extends(AccessTypeParam, _super);
    /**
     * @param value access type
     */ function AccessTypeParam(value) {
        var _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    AccessTypeParam.fromAmino = function(data) {
        return new AccessTypeParam((0, $8MEJi.convertAccessTypeFromJSON)(data.value));
    };
    AccessTypeParam.prototype.toAmino = function() {
        var res = {
            value: (0, $odsVG.accessTypeToJSON)(this.value)
        };
        return res;
    };
    AccessTypeParam.fromData = function(data) {
        return new AccessTypeParam((0, $8MEJi.convertAccessTypeFromJSON)(data.value));
    };
    AccessTypeParam.prototype.toData = function() {
        var res = {
            value: (0, $odsVG.accessTypeToJSON)(this.value)
        };
        return res;
    };
    AccessTypeParam.fromProto = function(proto) {
        return new AccessTypeParam(proto.value);
    };
    AccessTypeParam.prototype.toProto = function() {
        return $odsVG.AccessTypeParam.fromPartial({
            value: this.value
        });
    };
    return AccessTypeParam;
}($26Eqx.JSONSerializable);
module.exports.AccessTypeParam = $ec2606e9f9252f2b$var$AccessTypeParam;

});


parcelRegister("kMjuM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ValConsAddress = module.exports.ValPubKey = module.exports.ValAddress = module.exports.AccPubKey = module.exports.AccAddress = void 0;

var $chCai = parcelRequire("chCai");
function $f20769bfde290c4c$var$checkPrefixAndLength(prefix, data, length) {
    try {
        var vals = $chCai.bech32.decode(data);
        return vals.prefix === prefix && data.length == length;
    } catch (e) {
        return false;
    }
}
var $f20769bfde290c4c$var$AccAddress;
(function(AccAddress) {
    /**
     * Checks if a string is a valid Terra account address.
     *
     * @param data string to check
     */ function validate(data) {
        // 44 for normal account and 64 for contract account
        return $f20769bfde290c4c$var$checkPrefixAndLength("terra", data, 44) || $f20769bfde290c4c$var$checkPrefixAndLength("terra", data, 64);
    }
    AccAddress.validate = validate;
    /**
     * Converts a validator address into an account address
     *
     * @param address validator address
     */ function fromValAddress(address) {
        var vals = $chCai.bech32.decode(address);
        return $chCai.bech32.encode("terra", vals.words);
    }
    AccAddress.fromValAddress = fromValAddress;
})($f20769bfde290c4c$var$AccAddress = module.exports.AccAddress || (module.exports.AccAddress = {}));
var $f20769bfde290c4c$var$AccPubKey;
(function(AccPubKey) {
    /**
     * Checks if a string is a Terra account's public key
     * @param data string to check
     */ function validate(data) {
        return $f20769bfde290c4c$var$checkPrefixAndLength("terrapub", data, 47);
    }
    AccPubKey.validate = validate;
    /**
     * Converts a Terra validator pubkey to an account pubkey.
     * @param address validator pubkey to convert
     */ function fromAccAddress(address) {
        var vals = $chCai.bech32.decode(address);
        return $chCai.bech32.encode("terrapub", vals.words);
    }
    AccPubKey.fromAccAddress = fromAccAddress;
})($f20769bfde290c4c$var$AccPubKey = module.exports.AccPubKey || (module.exports.AccPubKey = {}));
var $f20769bfde290c4c$var$ValAddress;
(function(ValAddress) {
    /**
     * Checks if a string is a Terra validator address.
     *
     * @param data string to check
     */ function validate(data) {
        return $f20769bfde290c4c$var$checkPrefixAndLength("terravaloper", data, 51);
    }
    ValAddress.validate = validate;
    /**
     * Converts a Terra account address to a validator address.
     * @param address account address to convert
     */ function fromAccAddress(address) {
        var vals = $chCai.bech32.decode(address);
        return $chCai.bech32.encode("terravaloper", vals.words);
    }
    ValAddress.fromAccAddress = fromAccAddress;
})($f20769bfde290c4c$var$ValAddress = module.exports.ValAddress || (module.exports.ValAddress = {}));
var $f20769bfde290c4c$var$ValPubKey;
(function(ValPubKey) {
    /**
     * Checks if a string is a Terra validator pubkey
     * @param data string to check
     */ function validate(data) {
        return $f20769bfde290c4c$var$checkPrefixAndLength("terravaloperpub", data, 54);
    }
    ValPubKey.validate = validate;
    /**
     * Converts a Terra validator operator address to a validator pubkey.
     * @param valAddress account pubkey
     */ function fromValAddress(valAddress) {
        var vals = $chCai.bech32.decode(valAddress);
        return $chCai.bech32.encode("terravaloperpub", vals.words);
    }
    ValPubKey.fromValAddress = fromValAddress;
})($f20769bfde290c4c$var$ValPubKey = module.exports.ValPubKey || (module.exports.ValPubKey = {}));
var $f20769bfde290c4c$var$ValConsAddress;
(function(ValConsAddress) {
    /**
     * Checks if a string is a Terra validator consensus address
     * @param data string to check
     */ function validate(data) {
        return $f20769bfde290c4c$var$checkPrefixAndLength("terravalcons", data, 51);
    }
    ValConsAddress.validate = validate;
})($f20769bfde290c4c$var$ValConsAddress = module.exports.ValConsAddress || (module.exports.ValConsAddress = {}));

});


parcelRegister("hg3FK", function(module, exports) {
"use strict";
var $c906c789e4f3a60a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c906c789e4f3a60a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c906c789e4f3a60a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$c906c789e4f3a60a$var$__exportStar((parcelRequire("4jeDL")), module.exports);

$c906c789e4f3a60a$var$__exportStar((parcelRequire("j4gpb")), module.exports);

$c906c789e4f3a60a$var$__exportStar((parcelRequire("c37wy")), module.exports);

});
parcelRegister("4jeDL", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $32344b109f981867$require$Buffer = $gzLuY.Buffer;
"use strict";
var $32344b109f981867$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $32344b109f981867$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $32344b109f981867$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Key = void 0;

var $chCai = parcelRequire("chCai");

var $6cKfH = parcelRequire("6cKfH");

var $9xHlz = parcelRequire("9xHlz");

var $cQRUh = parcelRequire("cQRUh");
/**
 * Abstract key interface that provides transaction signing features and Bech32 address
 * and public key derivation from a public key. This allows you to create custom key
 * solutions, such as for various hardware wallets, by implementing signing and calling
 * `super` with the raw public key from within your subclass. See [[MnemonicKey]] for
 * an implementation of a basic mnemonic-based key.
 */ var $32344b109f981867$var$Key = /** @class */ function() {
    /**
     * Called to derive the relevant account and validator addresses and public keys from
     * the raw compressed public key in bytes.
     *
     * @param publicKey raw compressed bytes public key
     */ function Key(publicKey) {
        this.publicKey = publicKey;
    }
    Object.defineProperty(Key.prototype, "accAddress", {
        /**
         * Terra account address. `terra-` prefixed.
         */ get: function() {
            if (!this.publicKey) throw new Error("Could not compute accAddress: missing rawAddress");
            return this.publicKey.address();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Key.prototype, "valAddress", {
        /**
         * Terra validator address. `terravaloper-` prefixed.
         */ get: function() {
            if (!this.publicKey) throw new Error("Could not compute valAddress: missing rawAddress");
            return $chCai.bech32.encode("terravaloper", $chCai.bech32.toWords(this.publicKey.rawAddress()));
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Signs a [[StdSignMsg]] with the method supplied by the child class.
     * only used Amino sign
     *
     * @param tx sign-message of the transaction to sign
     * @param isClassic target network is isClassic or not?
     */ Key.prototype.createSignatureAmino = function(tx, isClassic) {
        return $32344b109f981867$var$__awaiter(this, void 0, void 0, function() {
            var _a, _b, _c, _d, _e, _f, _g;
            return $32344b109f981867$var$__generator(this, function(_h) {
                switch(_h.label){
                    case 0:
                        if (!this.publicKey) throw new Error("Signature could not be created: Key instance missing publicKey");
                        _a = $9xHlz.SignatureV2.bind;
                        _b = [
                            void 0,
                            this.publicKey
                        ];
                        _d = (_c = $9xHlz.SignatureV2.Descriptor).bind;
                        _f = (_e = $9xHlz.SignatureV2.Descriptor.Single).bind;
                        _g = [
                            void 0,
                            $cQRUh.SignMode.SIGN_MODE_LEGACY_AMINO_JSON
                        ];
                        return [
                            4 /*yield*/ ,
                            this.sign($32344b109f981867$require$Buffer.from(tx.toAminoJSON(isClassic)))
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            new (_a.apply($9xHlz.SignatureV2, _b.concat([
                                new (_d.apply(_c, [
                                    void 0,
                                    new (_f.apply(_e, _g.concat([
                                        _h.sent().toString("base64")
                                    ])))()
                                ]))(),
                                tx.sequence
                            ])))()
                        ];
                }
            });
        });
    };
    /**
     * Signs a [[SignDoc]] with the method supplied by the child class.
     *
     * @param tx sign-message of the transaction to sign
     * @param isClassic target network is isClassic or not?
     */ Key.prototype.createSignature = function(signDoc, isClassic) {
        return $32344b109f981867$var$__awaiter(this, void 0, void 0, function() {
            var signerInfos, sigBytes;
            return $32344b109f981867$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.publicKey) throw new Error("Signature could not be created: Key instance missing publicKey");
                        signerInfos = signDoc.auth_info.signer_infos;
                        signDoc.auth_info.signer_infos = [
                            new $6cKfH.SignerInfo(this.publicKey, signDoc.sequence, new $6cKfH.ModeInfo(new $6cKfH.ModeInfo.Single($cQRUh.SignMode.SIGN_MODE_DIRECT)))
                        ];
                        return [
                            4 /*yield*/ ,
                            this.sign($32344b109f981867$require$Buffer.from(signDoc.toBytes(isClassic)))
                        ];
                    case 1:
                        sigBytes = _a.sent().toString("base64");
                        // restore signDoc to origin
                        signDoc.auth_info.signer_infos = signerInfos;
                        return [
                            2 /*return*/ ,
                            new $9xHlz.SignatureV2(this.publicKey, new $9xHlz.SignatureV2.Descriptor(new $9xHlz.SignatureV2.Descriptor.Single($cQRUh.SignMode.SIGN_MODE_DIRECT, sigBytes)), signDoc.sequence)
                        ];
                }
            });
        });
    };
    /**
     * Signs a [[Tx]] and adds the signature to a generated StdTx that is ready to be broadcasted.
     * @param tx
     */ Key.prototype.signTx = function(tx, options, isClassic) {
        return $32344b109f981867$var$__awaiter(this, void 0, void 0, function() {
            var copyTx, sign_doc, signature, sigData;
            var _a, _b;
            return $32344b109f981867$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        copyTx = new $6cKfH.Tx(tx.body, new $6cKfH.AuthInfo([], tx.auth_info.fee), []);
                        sign_doc = new $6cKfH.SignDoc(options.chainID, options.accountNumber, options.sequence, copyTx.auth_info, copyTx.body);
                        if (!(options.signMode === $cQRUh.SignMode.SIGN_MODE_LEGACY_AMINO_JSON)) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.createSignatureAmino(sign_doc, isClassic)
                        ];
                    case 1:
                        signature = _c.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            this.createSignature(sign_doc, isClassic)
                        ];
                    case 3:
                        signature = _c.sent();
                        _c.label = 4;
                    case 4:
                        sigData = signature.data.single;
                        (_a = copyTx.signatures).push.apply(_a, $32344b109f981867$var$__spreadArray($32344b109f981867$var$__spreadArray([], tx.signatures, false), [
                            sigData.signature
                        ], false));
                        (_b = copyTx.auth_info.signer_infos).push.apply(_b, $32344b109f981867$var$__spreadArray($32344b109f981867$var$__spreadArray([], tx.auth_info.signer_infos, false), [
                            new $6cKfH.SignerInfo(signature.public_key, signature.sequence, new $6cKfH.ModeInfo(new $6cKfH.ModeInfo.Single(sigData.mode)))
                        ], false));
                        return [
                            2 /*return*/ ,
                            copyTx
                        ];
                }
            });
        });
    };
    return Key;
}();
module.exports.Key = $32344b109f981867$var$Key;

});

parcelRegister("j4gpb", function(module, exports) {
"use strict";
// Adapted from https://github.com/terra-money/terra-js/blob/master/src/utils/keyUtils.ts
var $de1b1dc525036831$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $de1b1dc525036831$var$__assign = module.exports && module.exports.__assign || function() {
    $de1b1dc525036831$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $de1b1dc525036831$var$__assign.apply(this, arguments);
};
var $de1b1dc525036831$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $de1b1dc525036831$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $de1b1dc525036831$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $de1b1dc525036831$var$__createBinding(result, mod, k);
    }
    $de1b1dc525036831$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MnemonicKey = module.exports.LUNA_COIN_TYPE = void 0;

var $de1b1dc525036831$var$bip32 = $de1b1dc525036831$var$__importStar((parcelRequire("jpU8C")));

var $de1b1dc525036831$var$bip39 = $de1b1dc525036831$var$__importStar((parcelRequire("8M4RQ")));

var $c37wy = parcelRequire("c37wy");
module.exports.LUNA_COIN_TYPE = 330;
var $de1b1dc525036831$var$DEFAULT_OPTIONS = {
    account: 0,
    index: 0,
    coinType: module.exports.LUNA_COIN_TYPE
};
/**
 * Implements a BIP39 mnemonic wallet with standard key derivation from a word list. Note
 * that this implementation exposes the private key in memory, so it is not advised to use
 * for applications requiring high security.
 */ var $de1b1dc525036831$var$MnemonicKey = /** @class */ function(_super) {
    $de1b1dc525036831$var$__extends(MnemonicKey, _super);
    /**
     * Creates a new signing key from a mnemonic phrase. If no mnemonic is provided, one
     * will be automatically generated.
     *
     * ### Providing a mnemonic
     *
     * ```ts
     * import { MnemonicKey } from 'terra.js';
     *
     * const mk = new MnemonicKey({ mnemonic: '...' });
     * console.log(mk.accAddress);
     * ```
     *
     * ### Generating a random mnemonic
     *
     * ```ts
     * const mk2 = new MnemonicKey();
     * console.log(mk2.mnemonic);
     * ```
     *
     * @param options
     */ function MnemonicKey(options) {
        if (options === void 0) options = {};
        var _this = this;
        var _a = $de1b1dc525036831$var$__assign($de1b1dc525036831$var$__assign({}, $de1b1dc525036831$var$DEFAULT_OPTIONS), options), account = _a.account, index = _a.index, coinType = _a.coinType;
        var mnemonic = options.mnemonic;
        if (mnemonic === undefined) mnemonic = $de1b1dc525036831$var$bip39.generateMnemonic(256);
        var seed = $de1b1dc525036831$var$bip39.mnemonicToSeedSync(mnemonic);
        var masterKey = $de1b1dc525036831$var$bip32.fromSeed(seed);
        var hdPathLuna = "m/44'/".concat(coinType, "'/").concat(account, "'/0/").concat(index);
        var terraHD = masterKey.derivePath(hdPathLuna);
        var privateKey = terraHD.privateKey;
        if (!privateKey) throw new Error("Failed to derive key pair");
        _this = _super.call(this, privateKey) || this;
        _this.mnemonic = mnemonic;
        return _this;
    }
    return MnemonicKey;
}($c37wy.RawKey);
module.exports.MnemonicKey = $de1b1dc525036831$var$MnemonicKey;

});
parcelRegister("jpU8C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $iYyrx = parcelRequire("iYyrx");
module.exports.fromSeed = $iYyrx.fromSeed;
module.exports.fromBase58 = $iYyrx.fromBase58;
module.exports.fromPublicKey = $iYyrx.fromPublicKey;
module.exports.fromPrivateKey = $iYyrx.fromPrivateKey;

});
parcelRegister("iYyrx", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $dd088c4fb2470d57$require$Buffer = $gzLuY.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eOSdk = parcelRequire("eOSdk");

var $5hfII = parcelRequire("5hfII");

var $O2J5L = parcelRequire("O2J5L");

var $j0bvm = parcelRequire("j0bvm");

var $6QIDt = parcelRequire("6QIDt");
const $dd088c4fb2470d57$var$UINT256_TYPE = $j0bvm.BufferN(32);
const $dd088c4fb2470d57$var$NETWORK_TYPE = $j0bvm.compile({
    wif: $j0bvm.UInt8,
    bip32: {
        public: $j0bvm.UInt32,
        private: $j0bvm.UInt32
    }
});
const $dd088c4fb2470d57$var$BITCOIN = {
    messagePrefix: "\x18Bitcoin Signed Message:\n",
    bech32: "bc",
    bip32: {
        public: 0x0488b21e,
        private: 0x0488ade4
    },
    pubKeyHash: 0x00,
    scriptHash: 0x05,
    wif: 0x80
};
const $dd088c4fb2470d57$var$HIGHEST_BIT = 0x80000000;
const $dd088c4fb2470d57$var$UINT31_MAX = Math.pow(2, 31) - 1;
function $dd088c4fb2470d57$var$BIP32Path(value) {
    return $j0bvm.String(value) && value.match(/^(m\/)?(\d+'?\/)*\d+'?$/) !== null;
}
function $dd088c4fb2470d57$var$UInt31(value) {
    return $j0bvm.UInt32(value) && value <= $dd088c4fb2470d57$var$UINT31_MAX;
}
class $dd088c4fb2470d57$var$BIP32 {
    get depth() {
        return this.__DEPTH;
    }
    get index() {
        return this.__INDEX;
    }
    get parentFingerprint() {
        return this.__PARENT_FINGERPRINT;
    }
    get publicKey() {
        if (this.__Q === undefined) this.__Q = $O2J5L.pointFromScalar(this.__D, true);
        return this.__Q;
    }
    get privateKey() {
        return this.__D;
    }
    get identifier() {
        return $eOSdk.hash160(this.publicKey);
    }
    get fingerprint() {
        return this.identifier.slice(0, 4);
    }
    get compressed() {
        return true;
    }
    // Private === not neutered
    // Public === neutered
    isNeutered() {
        return this.__D === undefined;
    }
    neutered() {
        return $dd088c4fb2470d57$var$fromPublicKeyLocal(this.publicKey, this.chainCode, this.network, this.depth, this.index, this.parentFingerprint);
    }
    toBase58() {
        const network = this.network;
        const version = !this.isNeutered() ? network.bip32.private : network.bip32.public;
        const buffer = $dd088c4fb2470d57$require$Buffer.allocUnsafe(78);
        // 4 bytes: version bytes
        buffer.writeUInt32BE(version, 0);
        // 1 byte: depth: 0x00 for master nodes, 0x01 for level-1 descendants, ....
        buffer.writeUInt8(this.depth, 4);
        // 4 bytes: the fingerprint of the parent's key (0x00000000 if master key)
        buffer.writeUInt32BE(this.parentFingerprint, 5);
        // 4 bytes: child number. This is the number i in xi = xpar/i, with xi the key being serialized.
        // This is encoded in big endian. (0x00000000 if master key)
        buffer.writeUInt32BE(this.index, 9);
        // 32 bytes: the chain code
        this.chainCode.copy(buffer, 13);
        // 33 bytes: the public key or private key data
        if (!this.isNeutered()) {
            // 0x00 + k for private keys
            buffer.writeUInt8(0, 45);
            this.privateKey.copy(buffer, 46);
        // 33 bytes: the public key
        } else // X9.62 encoding for public keys
        this.publicKey.copy(buffer, 45);
        return $5hfII.encode(buffer);
    }
    toWIF() {
        if (!this.privateKey) throw new TypeError("Missing private key");
        return $6QIDt.encode(this.network.wif, this.privateKey, true);
    }
    // https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki#child-key-derivation-ckd-functions
    derive(index) {
        $j0bvm($j0bvm.UInt32, index);
        const isHardened = index >= $dd088c4fb2470d57$var$HIGHEST_BIT;
        const data = $dd088c4fb2470d57$require$Buffer.allocUnsafe(37);
        // Hardened child
        if (isHardened) {
            if (this.isNeutered()) throw new TypeError("Missing private key for hardened child key");
            // data = 0x00 || ser256(kpar) || ser32(index)
            data[0] = 0x00;
            this.privateKey.copy(data, 1);
            data.writeUInt32BE(index, 33);
        // Normal child
        } else {
            // data = serP(point(kpar)) || ser32(index)
            //      = serP(Kpar) || ser32(index)
            this.publicKey.copy(data, 0);
            data.writeUInt32BE(index, 33);
        }
        const I = $eOSdk.hmacSHA512(this.chainCode, data);
        const IL = I.slice(0, 32);
        const IR = I.slice(32);
        // if parse256(IL) >= n, proceed with the next value for i
        if (!$O2J5L.isPrivate(IL)) return this.derive(index + 1);
        // Private parent key -> private child key
        let hd;
        if (!this.isNeutered()) {
            // ki = parse256(IL) + kpar (mod n)
            const ki = $O2J5L.privateAdd(this.privateKey, IL);
            // In case ki == 0, proceed with the next value for i
            if (ki == null) return this.derive(index + 1);
            hd = $dd088c4fb2470d57$var$fromPrivateKeyLocal(ki, IR, this.network, this.depth + 1, index, this.fingerprint.readUInt32BE(0));
        // Public parent key -> public child key
        } else {
            // Ki = point(parse256(IL)) + Kpar
            //    = G*IL + Kpar
            const Ki = $O2J5L.pointAddScalar(this.publicKey, IL, true);
            // In case Ki is the point at infinity, proceed with the next value for i
            if (Ki === null) return this.derive(index + 1);
            hd = $dd088c4fb2470d57$var$fromPublicKeyLocal(Ki, IR, this.network, this.depth + 1, index, this.fingerprint.readUInt32BE(0));
        }
        return hd;
    }
    deriveHardened(index) {
        $j0bvm($dd088c4fb2470d57$var$UInt31, index);
        // Only derives hardened private keys by default
        return this.derive(index + $dd088c4fb2470d57$var$HIGHEST_BIT);
    }
    derivePath(path) {
        $j0bvm($dd088c4fb2470d57$var$BIP32Path, path);
        let splitPath = path.split("/");
        if (splitPath[0] === "m") {
            if (this.parentFingerprint) throw new TypeError("Expected master, got child");
            splitPath = splitPath.slice(1);
        }
        return splitPath.reduce((prevHd, indexStr)=>{
            let index;
            if (indexStr.slice(-1) === `'`) {
                index = parseInt(indexStr.slice(0, -1), 10);
                return prevHd.deriveHardened(index);
            } else {
                index = parseInt(indexStr, 10);
                return prevHd.derive(index);
            }
        }, this);
    }
    sign(hash, lowR) {
        if (!this.privateKey) throw new Error("Missing private key");
        if (lowR === undefined) lowR = this.lowR;
        if (lowR === false) return $O2J5L.sign(hash, this.privateKey);
        else {
            let sig = $O2J5L.sign(hash, this.privateKey);
            const extraData = $dd088c4fb2470d57$require$Buffer.alloc(32, 0);
            let counter = 0;
            // if first try is lowR, skip the loop
            // for second try and on, add extra entropy counting up
            while(sig[0] > 0x7f){
                counter++;
                extraData.writeUIntLE(counter, 0, 6);
                sig = $O2J5L.signWithEntropy(hash, this.privateKey, extraData);
            }
            return sig;
        }
    }
    verify(hash, signature) {
        return $O2J5L.verify(hash, this.publicKey, signature);
    }
    constructor(__D, __Q, chainCode, network, __DEPTH = 0, __INDEX = 0, __PARENT_FINGERPRINT = 0x00000000){
        this.__D = __D;
        this.__Q = __Q;
        this.chainCode = chainCode;
        this.network = network;
        this.__DEPTH = __DEPTH;
        this.__INDEX = __INDEX;
        this.__PARENT_FINGERPRINT = __PARENT_FINGERPRINT;
        $j0bvm($dd088c4fb2470d57$var$NETWORK_TYPE, network);
        this.lowR = false;
    }
}
function $dd088c4fb2470d57$var$fromBase58(inString, network) {
    const buffer = $5hfII.decode(inString);
    if (buffer.length !== 78) throw new TypeError("Invalid buffer length");
    network = network || $dd088c4fb2470d57$var$BITCOIN;
    // 4 bytes: version bytes
    const version = buffer.readUInt32BE(0);
    if (version !== network.bip32.private && version !== network.bip32.public) throw new TypeError("Invalid network version");
    // 1 byte: depth: 0x00 for master nodes, 0x01 for level-1 descendants, ...
    const depth = buffer[4];
    // 4 bytes: the fingerprint of the parent's key (0x00000000 if master key)
    const parentFingerprint = buffer.readUInt32BE(5);
    if (depth === 0) {
        if (parentFingerprint !== 0x00000000) throw new TypeError("Invalid parent fingerprint");
    }
    // 4 bytes: child number. This is the number i in xi = xpar/i, with xi the key being serialized.
    // This is encoded in MSB order. (0x00000000 if master key)
    const index = buffer.readUInt32BE(9);
    if (depth === 0 && index !== 0) throw new TypeError("Invalid index");
    // 32 bytes: the chain code
    const chainCode = buffer.slice(13, 45);
    let hd;
    // 33 bytes: private key data (0x00 + k)
    if (version === network.bip32.private) {
        if (buffer.readUInt8(45) !== 0x00) throw new TypeError("Invalid private key");
        const k = buffer.slice(46, 78);
        hd = $dd088c4fb2470d57$var$fromPrivateKeyLocal(k, chainCode, network, depth, index, parentFingerprint);
    // 33 bytes: public key data (0x02 + X or 0x03 + X)
    } else {
        const X = buffer.slice(45, 78);
        hd = $dd088c4fb2470d57$var$fromPublicKeyLocal(X, chainCode, network, depth, index, parentFingerprint);
    }
    return hd;
}
module.exports.fromBase58 = $dd088c4fb2470d57$var$fromBase58;
function $dd088c4fb2470d57$var$fromPrivateKey(privateKey, chainCode, network) {
    return $dd088c4fb2470d57$var$fromPrivateKeyLocal(privateKey, chainCode, network);
}
module.exports.fromPrivateKey = $dd088c4fb2470d57$var$fromPrivateKey;
function $dd088c4fb2470d57$var$fromPrivateKeyLocal(privateKey, chainCode, network, depth, index, parentFingerprint) {
    $j0bvm({
        privateKey: $dd088c4fb2470d57$var$UINT256_TYPE,
        chainCode: $dd088c4fb2470d57$var$UINT256_TYPE
    }, {
        privateKey: privateKey,
        chainCode: chainCode
    });
    network = network || $dd088c4fb2470d57$var$BITCOIN;
    if (!$O2J5L.isPrivate(privateKey)) throw new TypeError("Private key not in range [1, n)");
    return new $dd088c4fb2470d57$var$BIP32(privateKey, undefined, chainCode, network, depth, index, parentFingerprint);
}
function $dd088c4fb2470d57$var$fromPublicKey(publicKey, chainCode, network) {
    return $dd088c4fb2470d57$var$fromPublicKeyLocal(publicKey, chainCode, network);
}
module.exports.fromPublicKey = $dd088c4fb2470d57$var$fromPublicKey;
function $dd088c4fb2470d57$var$fromPublicKeyLocal(publicKey, chainCode, network, depth, index, parentFingerprint) {
    $j0bvm({
        publicKey: $j0bvm.BufferN(33),
        chainCode: $dd088c4fb2470d57$var$UINT256_TYPE
    }, {
        publicKey: publicKey,
        chainCode: chainCode
    });
    network = network || $dd088c4fb2470d57$var$BITCOIN;
    // verify the X coordinate is a point on the curve
    if (!$O2J5L.isPoint(publicKey)) throw new TypeError("Point is not on the curve");
    return new $dd088c4fb2470d57$var$BIP32(undefined, publicKey, chainCode, network, depth, index, parentFingerprint);
}
function $dd088c4fb2470d57$var$fromSeed(seed, network) {
    $j0bvm($j0bvm.Buffer, seed);
    if (seed.length < 16) throw new TypeError("Seed should be at least 128 bits");
    if (seed.length > 64) throw new TypeError("Seed should be at most 512 bits");
    network = network || $dd088c4fb2470d57$var$BITCOIN;
    const I = $eOSdk.hmacSHA512($dd088c4fb2470d57$require$Buffer.from("Bitcoin seed", "utf8"), seed);
    const IL = I.slice(0, 32);
    const IR = I.slice(32);
    return $dd088c4fb2470d57$var$fromPrivateKey(IL, IR, network);
}
module.exports.fromSeed = $dd088c4fb2470d57$var$fromSeed;

});
parcelRegister("eOSdk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $j8bQA = parcelRequire("j8bQA");

var $l2ANw = parcelRequire("l2ANw");
function $ac9fc9f444cbe593$var$hash160(buffer) {
    const sha256Hash = $j8bQA("sha256").update(buffer).digest();
    try {
        return $j8bQA("rmd160").update(sha256Hash).digest();
    } catch (err) {
        return $j8bQA("ripemd160").update(sha256Hash).digest();
    }
}
module.exports.hash160 = $ac9fc9f444cbe593$var$hash160;
function $ac9fc9f444cbe593$var$hmacSHA512(key, data) {
    return $l2ANw("sha512", key).update(data).digest();
}
module.exports.hmacSHA512 = $ac9fc9f444cbe593$var$hmacSHA512;

});

parcelRegister("5hfII", function(module, exports) {
"use strict";

var $j8bQA = parcelRequire("j8bQA");

var $k7JTc = parcelRequire("k7JTc");
// SHA256(SHA256(buffer))
function $3d7abbfe2958e1df$var$sha256x2(buffer) {
    var tmp = $j8bQA("sha256").update(buffer).digest();
    return $j8bQA("sha256").update(tmp).digest();
}
module.exports = $k7JTc($3d7abbfe2958e1df$var$sha256x2);

});
parcelRegister("k7JTc", function(module, exports) {
"use strict";

var $5m7wF = parcelRequire("5m7wF");

var $eN0t8 = parcelRequire("eN0t8");
var $ea680ec55da424cc$require$Buffer = $eN0t8.Buffer;
module.exports = function(checksumFn) {
    // Encode a buffer as a base58-check encoded string
    function encode(payload) {
        var checksum = checksumFn(payload);
        return $5m7wF.encode($ea680ec55da424cc$require$Buffer.concat([
            payload,
            checksum
        ], payload.length + 4));
    }
    function decodeRaw(buffer) {
        var payload = buffer.slice(0, -4);
        var checksum = buffer.slice(-4);
        var newChecksum = checksumFn(payload);
        if (checksum[0] ^ newChecksum[0] | checksum[1] ^ newChecksum[1] | checksum[2] ^ newChecksum[2] | checksum[3] ^ newChecksum[3]) return;
        return payload;
    }
    // Decode a base58-check encoded string to a buffer, no result if checksum is wrong
    function decodeUnsafe(string) {
        var buffer = $5m7wF.decodeUnsafe(string);
        if (!buffer) return;
        return decodeRaw(buffer);
    }
    function decode(string) {
        var buffer = $5m7wF.decode(string);
        var payload = decodeRaw(buffer, checksumFn);
        if (!payload) throw new Error("Invalid checksum");
        return payload;
    }
    return {
        encode: encode,
        decode: decode,
        decodeUnsafe: decodeUnsafe
    };
};

});
parcelRegister("5m7wF", function(module, exports) {

var $jzxXn = parcelRequire("jzxXn");
var $3e64d84924d7d2b0$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
module.exports = $jzxXn($3e64d84924d7d2b0$var$ALPHABET);

});
parcelRegister("jzxXn", function(module, exports) {
"use strict";

var $eN0t8 = parcelRequire("eN0t8");
var $e3fba04c57c6fbb2$require$_Buffer = $eN0t8.Buffer;
function $e3fba04c57c6fbb2$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        if (Array.isArray(source) || source instanceof Uint8Array) source = $e3fba04c57c6fbb2$require$_Buffer.from(source);
        if (!$e3fba04c57c6fbb2$require$_Buffer.isBuffer(source)) throw new TypeError("Expected Buffer");
        if (source.length === 0) return "";
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return $e3fba04c57c6fbb2$require$_Buffer.alloc(0);
        var psz = 0;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        var b256 = new Uint8Array(size);
        // Process the characters.
        while(source[psz]){
            // Decode character
            var carry = BASE_MAP[source.charCodeAt(psz)];
            // Invalid character
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = $e3fba04c57c6fbb2$require$_Buffer.allocUnsafe(zeroes + (size - it4));
        vch.fill(0x00, 0, zeroes);
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error("Non-base" + BASE + " character");
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
module.exports = $e3fba04c57c6fbb2$var$base;

});




parcelRegister("O2J5L", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $0966c902d8d22ddb$require$Buffer = $gzLuY.Buffer;

var $8HSS3 = parcelRequire("8HSS3");

var $492wS = parcelRequire("492wS");
var $0966c902d8d22ddb$require$EC = $492wS.ec;
const $0966c902d8d22ddb$var$secp256k1 = new $0966c902d8d22ddb$require$EC("secp256k1");

var $bRsOI = parcelRequire("bRsOI");
const $0966c902d8d22ddb$var$ZERO32 = $0966c902d8d22ddb$require$Buffer.alloc(32, 0);
const $0966c902d8d22ddb$var$EC_GROUP_ORDER = $0966c902d8d22ddb$require$Buffer.from("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141", "hex");
const $0966c902d8d22ddb$var$EC_P = $0966c902d8d22ddb$require$Buffer.from("fffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f", "hex");
const $0966c902d8d22ddb$var$n = $0966c902d8d22ddb$var$secp256k1.curve.n;
const $0966c902d8d22ddb$var$nDiv2 = $0966c902d8d22ddb$var$n.shrn(1);
const $0966c902d8d22ddb$var$G = $0966c902d8d22ddb$var$secp256k1.curve.g;
const $0966c902d8d22ddb$var$THROW_BAD_PRIVATE = "Expected Private";
const $0966c902d8d22ddb$var$THROW_BAD_POINT = "Expected Point";
const $0966c902d8d22ddb$var$THROW_BAD_TWEAK = "Expected Tweak";
const $0966c902d8d22ddb$var$THROW_BAD_HASH = "Expected Hash";
const $0966c902d8d22ddb$var$THROW_BAD_SIGNATURE = "Expected Signature";
const $0966c902d8d22ddb$var$THROW_BAD_EXTRA_DATA = "Expected Extra Data (32 bytes)";
function $0966c902d8d22ddb$var$isScalar(x) {
    return $0966c902d8d22ddb$require$Buffer.isBuffer(x) && x.length === 32;
}
function $0966c902d8d22ddb$var$isOrderScalar(x) {
    if (!$0966c902d8d22ddb$var$isScalar(x)) return false;
    return x.compare($0966c902d8d22ddb$var$EC_GROUP_ORDER) < 0 // < G
    ;
}
function $0966c902d8d22ddb$var$isPoint(p) {
    if (!$0966c902d8d22ddb$require$Buffer.isBuffer(p)) return false;
    if (p.length < 33) return false;
    const t = p[0];
    const x = p.slice(1, 33);
    if (x.compare($0966c902d8d22ddb$var$ZERO32) === 0) return false;
    if (x.compare($0966c902d8d22ddb$var$EC_P) >= 0) return false;
    if ((t === 0x02 || t === 0x03) && p.length === 33) {
        try {
            $0966c902d8d22ddb$var$decodeFrom(p);
        } catch (e) {
            return false;
        } // TODO: temporary
        return true;
    }
    const y = p.slice(33);
    if (y.compare($0966c902d8d22ddb$var$ZERO32) === 0) return false;
    if (y.compare($0966c902d8d22ddb$var$EC_P) >= 0) return false;
    if (t === 0x04 && p.length === 65) return true;
    return false;
}
function $0966c902d8d22ddb$var$__isPointCompressed(p) {
    return p[0] !== 0x04;
}
function $0966c902d8d22ddb$var$isPointCompressed(p) {
    if (!$0966c902d8d22ddb$var$isPoint(p)) return false;
    return $0966c902d8d22ddb$var$__isPointCompressed(p);
}
function $0966c902d8d22ddb$var$isPrivate(x) {
    if (!$0966c902d8d22ddb$var$isScalar(x)) return false;
    return x.compare($0966c902d8d22ddb$var$ZERO32) > 0 && // > 0
    x.compare($0966c902d8d22ddb$var$EC_GROUP_ORDER) < 0 // < G
    ;
}
function $0966c902d8d22ddb$var$isSignature(value) {
    const r = value.slice(0, 32);
    const s = value.slice(32, 64);
    return $0966c902d8d22ddb$require$Buffer.isBuffer(value) && value.length === 64 && r.compare($0966c902d8d22ddb$var$EC_GROUP_ORDER) < 0 && s.compare($0966c902d8d22ddb$var$EC_GROUP_ORDER) < 0;
}
function $0966c902d8d22ddb$var$assumeCompression(value, pubkey) {
    if (value === undefined && pubkey !== undefined) return $0966c902d8d22ddb$var$__isPointCompressed(pubkey);
    if (value === undefined) return true;
    return value;
}
function $0966c902d8d22ddb$var$fromBuffer(d) {
    return new $8HSS3(d);
}
function $0966c902d8d22ddb$var$toBuffer(d) {
    return d.toArrayLike($0966c902d8d22ddb$require$Buffer, "be", 32);
}
function $0966c902d8d22ddb$var$decodeFrom(P) {
    return $0966c902d8d22ddb$var$secp256k1.curve.decodePoint(P);
}
function $0966c902d8d22ddb$var$getEncoded(P, compressed) {
    return $0966c902d8d22ddb$require$Buffer.from(P._encode(compressed));
}
function $0966c902d8d22ddb$var$pointAdd(pA, pB, __compressed) {
    if (!$0966c902d8d22ddb$var$isPoint(pA)) throw new TypeError($0966c902d8d22ddb$var$THROW_BAD_POINT);
    if (!$0966c902d8d22ddb$var$isPoint(pB)) throw new TypeError($0966c902d8d22ddb$var$THROW_BAD_POINT);
    const a = $0966c902d8d22ddb$var$decodeFrom(pA);
    const b = $0966c902d8d22ddb$var$decodeFrom(pB);
    const pp = a.add(b);
    if (pp.isInfinity()) return null;
    const compressed = $0966c902d8d22ddb$var$assumeCompression(__compressed, pA);
    return $0966c902d8d22ddb$var$getEncoded(pp, compressed);
}
function $0966c902d8d22ddb$var$pointAddScalar(p, tweak, __compressed) {
    if (!$0966c902d8d22ddb$var$isPoint(p)) throw new TypeError($0966c902d8d22ddb$var$THROW_BAD_POINT);
    if (!$0966c902d8d22ddb$var$isOrderScalar(tweak)) throw new TypeError($0966c902d8d22ddb$var$THROW_BAD_TWEAK);
    const compressed = $0966c902d8d22ddb$var$assumeCompression(__compressed, p);
    const pp = $0966c902d8d22ddb$var$decodeFrom(p);
    if (tweak.compare($0966c902d8d22ddb$var$ZERO32) === 0) return $0966c902d8d22ddb$var$getEncoded(pp, compressed);
    const tt = $0966c902d8d22ddb$var$fromBuffer(tweak);
    const qq = $0966c902d8d22ddb$var$G.mul(tt);
    const uu = pp.add(qq);
    if (uu.isInfinity()) return null;
    return $0966c902d8d22ddb$var$getEncoded(uu, compressed);
}
function $0966c902d8d22ddb$var$pointCompress(p, __compressed) {
    if (!$0966c902d8d22ddb$var$isPoint(p)) throw new TypeError($0966c902d8d22ddb$var$THROW_BAD_POINT);
    const pp = $0966c902d8d22ddb$var$decodeFrom(p);
    if (pp.isInfinity()) throw new TypeError($0966c902d8d22ddb$var$THROW_BAD_POINT);
    const compressed = $0966c902d8d22ddb$var$assumeCompression(__compressed, p);
    return $0966c902d8d22ddb$var$getEncoded(pp, compressed);
}
function $0966c902d8d22ddb$var$pointFromScalar(d, __compressed) {
    if (!$0966c902d8d22ddb$var$isPrivate(d)) throw new TypeError($0966c902d8d22ddb$var$THROW_BAD_PRIVATE);
    const dd = $0966c902d8d22ddb$var$fromBuffer(d);
    const pp = $0966c902d8d22ddb$var$G.mul(dd);
    if (pp.isInfinity()) return null;
    const compressed = $0966c902d8d22ddb$var$assumeCompression(__compressed);
    return $0966c902d8d22ddb$var$getEncoded(pp, compressed);
}
function $0966c902d8d22ddb$var$pointMultiply(p, tweak, __compressed) {
    if (!$0966c902d8d22ddb$var$isPoint(p)) throw new TypeError($0966c902d8d22ddb$var$THROW_BAD_POINT);
    if (!$0966c902d8d22ddb$var$isOrderScalar(tweak)) throw new TypeError($0966c902d8d22ddb$var$THROW_BAD_TWEAK);
    const compressed = $0966c902d8d22ddb$var$assumeCompression(__compressed, p);
    const pp = $0966c902d8d22ddb$var$decodeFrom(p);
    const tt = $0966c902d8d22ddb$var$fromBuffer(tweak);
    const qq = pp.mul(tt);
    if (qq.isInfinity()) return null;
    return $0966c902d8d22ddb$var$getEncoded(qq, compressed);
}
function $0966c902d8d22ddb$var$privateAdd(d, tweak) {
    if (!$0966c902d8d22ddb$var$isPrivate(d)) throw new TypeError($0966c902d8d22ddb$var$THROW_BAD_PRIVATE);
    if (!$0966c902d8d22ddb$var$isOrderScalar(tweak)) throw new TypeError($0966c902d8d22ddb$var$THROW_BAD_TWEAK);
    const dd = $0966c902d8d22ddb$var$fromBuffer(d);
    const tt = $0966c902d8d22ddb$var$fromBuffer(tweak);
    const dt = $0966c902d8d22ddb$var$toBuffer(dd.add(tt).umod($0966c902d8d22ddb$var$n));
    if (!$0966c902d8d22ddb$var$isPrivate(dt)) return null;
    return dt;
}
function $0966c902d8d22ddb$var$privateSub(d, tweak) {
    if (!$0966c902d8d22ddb$var$isPrivate(d)) throw new TypeError($0966c902d8d22ddb$var$THROW_BAD_PRIVATE);
    if (!$0966c902d8d22ddb$var$isOrderScalar(tweak)) throw new TypeError($0966c902d8d22ddb$var$THROW_BAD_TWEAK);
    const dd = $0966c902d8d22ddb$var$fromBuffer(d);
    const tt = $0966c902d8d22ddb$var$fromBuffer(tweak);
    const dt = $0966c902d8d22ddb$var$toBuffer(dd.sub(tt).umod($0966c902d8d22ddb$var$n));
    if (!$0966c902d8d22ddb$var$isPrivate(dt)) return null;
    return dt;
}
function $0966c902d8d22ddb$var$sign(hash, x) {
    return $0966c902d8d22ddb$var$__sign(hash, x);
}
function $0966c902d8d22ddb$var$signWithEntropy(hash, x, addData) {
    return $0966c902d8d22ddb$var$__sign(hash, x, addData);
}
function $0966c902d8d22ddb$var$__sign(hash, x, addData) {
    if (!$0966c902d8d22ddb$var$isScalar(hash)) throw new TypeError($0966c902d8d22ddb$var$THROW_BAD_HASH);
    if (!$0966c902d8d22ddb$var$isPrivate(x)) throw new TypeError($0966c902d8d22ddb$var$THROW_BAD_PRIVATE);
    if (addData !== undefined && !$0966c902d8d22ddb$var$isScalar(addData)) throw new TypeError($0966c902d8d22ddb$var$THROW_BAD_EXTRA_DATA);
    const d = $0966c902d8d22ddb$var$fromBuffer(x);
    const e = $0966c902d8d22ddb$var$fromBuffer(hash);
    let r, s;
    const checkSig = function(k) {
        const kI = $0966c902d8d22ddb$var$fromBuffer(k);
        const Q = $0966c902d8d22ddb$var$G.mul(kI);
        if (Q.isInfinity()) return false;
        r = Q.x.umod($0966c902d8d22ddb$var$n);
        if (r.isZero() === 0) return false;
        s = kI.invm($0966c902d8d22ddb$var$n).mul(e.add(d.mul(r))).umod($0966c902d8d22ddb$var$n);
        if (s.isZero() === 0) return false;
        return true;
    };
    $bRsOI(hash, x, checkSig, $0966c902d8d22ddb$var$isPrivate, addData);
    // enforce low S values, see bip62: 'low s values in signatures'
    if (s.cmp($0966c902d8d22ddb$var$nDiv2) > 0) s = $0966c902d8d22ddb$var$n.sub(s);
    const buffer = $0966c902d8d22ddb$require$Buffer.allocUnsafe(64);
    $0966c902d8d22ddb$var$toBuffer(r).copy(buffer, 0);
    $0966c902d8d22ddb$var$toBuffer(s).copy(buffer, 32);
    return buffer;
}
function $0966c902d8d22ddb$var$verify(hash, q, signature, strict) {
    if (!$0966c902d8d22ddb$var$isScalar(hash)) throw new TypeError($0966c902d8d22ddb$var$THROW_BAD_HASH);
    if (!$0966c902d8d22ddb$var$isPoint(q)) throw new TypeError($0966c902d8d22ddb$var$THROW_BAD_POINT);
    // 1.4.1 Enforce r and s are both integers in the interval [1, n − 1] (1, isSignature enforces '< n - 1')
    if (!$0966c902d8d22ddb$var$isSignature(signature)) throw new TypeError($0966c902d8d22ddb$var$THROW_BAD_SIGNATURE);
    const Q = $0966c902d8d22ddb$var$decodeFrom(q);
    const r = $0966c902d8d22ddb$var$fromBuffer(signature.slice(0, 32));
    const s = $0966c902d8d22ddb$var$fromBuffer(signature.slice(32, 64));
    if (strict && s.cmp($0966c902d8d22ddb$var$nDiv2) > 0) return false;
    // 1.4.1 Enforce r and s are both integers in the interval [1, n − 1] (2, enforces '> 0')
    if (r.gtn(0) <= 0 /* || r.compareTo(n) >= 0 */ ) return false;
    if (s.gtn(0) <= 0 /* || s.compareTo(n) >= 0 */ ) return false;
    // 1.4.2 H = Hash(M), already done by the user
    // 1.4.3 e = H
    const e = $0966c902d8d22ddb$var$fromBuffer(hash);
    // Compute s^-1
    const sInv = s.invm($0966c902d8d22ddb$var$n);
    // 1.4.4 Compute u1 = es^−1 mod n
    //               u2 = rs^−1 mod n
    const u1 = e.mul(sInv).umod($0966c902d8d22ddb$var$n);
    const u2 = r.mul(sInv).umod($0966c902d8d22ddb$var$n);
    // 1.4.5 Compute R = (xR, yR)
    //               R = u1G + u2Q
    const R = $0966c902d8d22ddb$var$G.mulAdd(u1, Q, u2);
    // 1.4.5 (cont.) Enforce R is not at infinity
    if (R.isInfinity()) return false;
    // 1.4.6 Convert the field element R.x to an integer
    const xR = R.x;
    // 1.4.7 Set v = xR mod n
    const v = xR.umod($0966c902d8d22ddb$var$n);
    // 1.4.8 If v = r, output "valid", and if v != r, output "invalid"
    return v.eq(r);
}
module.exports = {
    isPoint: $0966c902d8d22ddb$var$isPoint,
    isPointCompressed: $0966c902d8d22ddb$var$isPointCompressed,
    isPrivate: $0966c902d8d22ddb$var$isPrivate,
    pointAdd: $0966c902d8d22ddb$var$pointAdd,
    pointAddScalar: $0966c902d8d22ddb$var$pointAddScalar,
    pointCompress: $0966c902d8d22ddb$var$pointCompress,
    pointFromScalar: $0966c902d8d22ddb$var$pointFromScalar,
    pointMultiply: $0966c902d8d22ddb$var$pointMultiply,
    privateAdd: $0966c902d8d22ddb$var$privateAdd,
    privateSub: $0966c902d8d22ddb$var$privateSub,
    sign: $0966c902d8d22ddb$var$sign,
    signWithEntropy: $0966c902d8d22ddb$var$signWithEntropy,
    verify: $0966c902d8d22ddb$var$verify
};

});
parcelRegister("8HSS3", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("aqbQf")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("bRsOI", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $8a2aff6071b0ae66$require$Buffer = $gzLuY.Buffer;

var $l2ANw = parcelRequire("l2ANw");
const $8a2aff6071b0ae66$var$ONE1 = $8a2aff6071b0ae66$require$Buffer.alloc(1, 1);
const $8a2aff6071b0ae66$var$ZERO1 = $8a2aff6071b0ae66$require$Buffer.alloc(1, 0);
// https://tools.ietf.org/html/rfc6979#section-3.2
function $8a2aff6071b0ae66$var$deterministicGenerateK(hash, x, checkSig, isPrivate, extraEntropy) {
    // Step A, ignored as hash already provided
    // Step B
    // Step C
    let k = $8a2aff6071b0ae66$require$Buffer.alloc(32, 0);
    let v = $8a2aff6071b0ae66$require$Buffer.alloc(32, 1);
    // Step D
    k = $l2ANw("sha256", k).update(v).update($8a2aff6071b0ae66$var$ZERO1).update(x).update(hash).update(extraEntropy || "").digest();
    // Step E
    v = $l2ANw("sha256", k).update(v).digest();
    // Step F
    k = $l2ANw("sha256", k).update(v).update($8a2aff6071b0ae66$var$ONE1).update(x).update(hash).update(extraEntropy || "").digest();
    // Step G
    v = $l2ANw("sha256", k).update(v).digest();
    // Step H1/H2a, ignored as tlen === qlen (256 bit)
    // Step H2b
    v = $l2ANw("sha256", k).update(v).digest();
    let T = v;
    // Step H3, repeat until T is within the interval [1, n - 1] and is suitable for ECDSA
    while(!isPrivate(T) || !checkSig(T)){
        k = $l2ANw("sha256", k).update(v).update($8a2aff6071b0ae66$var$ZERO1).digest();
        v = $l2ANw("sha256", k).update(v).digest();
        // Step H1/H2a, again, ignored as tlen === qlen (256 bit)
        // Step H2b again
        v = $l2ANw("sha256", k).update(v).digest();
        T = v;
    }
    return T;
}
module.exports = $8a2aff6071b0ae66$var$deterministicGenerateK;

});


parcelRegister("j0bvm", function(module, exports) {

var $gD3E6 = parcelRequire("gD3E6");

var $7wNwK = parcelRequire("7wNwK");
// short-hand
var $dd56f1099edcc30b$var$tfJSON = $gD3E6.tfJSON;
var $dd56f1099edcc30b$var$TfTypeError = $gD3E6.TfTypeError;
var $dd56f1099edcc30b$var$TfPropertyTypeError = $gD3E6.TfPropertyTypeError;
var $dd56f1099edcc30b$var$tfSubError = $gD3E6.tfSubError;
var $dd56f1099edcc30b$var$getValueTypeName = $gD3E6.getValueTypeName;
var $dd56f1099edcc30b$var$TYPES = {
    arrayOf: function arrayOf(type, options) {
        type = $dd56f1099edcc30b$var$compile(type);
        options = options || {};
        function _arrayOf(array, strict) {
            if (!$7wNwK.Array(array)) return false;
            if ($7wNwK.Nil(array)) return false;
            if (options.minLength !== undefined && array.length < options.minLength) return false;
            if (options.maxLength !== undefined && array.length > options.maxLength) return false;
            if (options.length !== undefined && array.length !== options.length) return false;
            return array.every(function(value, i) {
                try {
                    return $dd56f1099edcc30b$var$typeforce(type, value, strict);
                } catch (e) {
                    throw $dd56f1099edcc30b$var$tfSubError(e, i);
                }
            });
        }
        _arrayOf.toJSON = function() {
            var str = "[" + $dd56f1099edcc30b$var$tfJSON(type) + "]";
            if (options.length !== undefined) str += "{" + options.length + "}";
            else if (options.minLength !== undefined || options.maxLength !== undefined) str += "{" + (options.minLength === undefined ? 0 : options.minLength) + "," + (options.maxLength === undefined ? Infinity : options.maxLength) + "}";
            return str;
        };
        return _arrayOf;
    },
    maybe: function maybe(type) {
        type = $dd56f1099edcc30b$var$compile(type);
        function _maybe(value, strict) {
            return $7wNwK.Nil(value) || type(value, strict, maybe);
        }
        _maybe.toJSON = function() {
            return "?" + $dd56f1099edcc30b$var$tfJSON(type);
        };
        return _maybe;
    },
    map: function map(propertyType, propertyKeyType) {
        propertyType = $dd56f1099edcc30b$var$compile(propertyType);
        if (propertyKeyType) propertyKeyType = $dd56f1099edcc30b$var$compile(propertyKeyType);
        function _map(value, strict) {
            if (!$7wNwK.Object(value)) return false;
            if ($7wNwK.Nil(value)) return false;
            for(var propertyName in value){
                try {
                    if (propertyKeyType) $dd56f1099edcc30b$var$typeforce(propertyKeyType, propertyName, strict);
                } catch (e) {
                    throw $dd56f1099edcc30b$var$tfSubError(e, propertyName, "key");
                }
                try {
                    var propertyValue = value[propertyName];
                    $dd56f1099edcc30b$var$typeforce(propertyType, propertyValue, strict);
                } catch (e) {
                    throw $dd56f1099edcc30b$var$tfSubError(e, propertyName);
                }
            }
            return true;
        }
        if (propertyKeyType) _map.toJSON = function() {
            return "{" + $dd56f1099edcc30b$var$tfJSON(propertyKeyType) + ": " + $dd56f1099edcc30b$var$tfJSON(propertyType) + "}";
        };
        else _map.toJSON = function() {
            return "{" + $dd56f1099edcc30b$var$tfJSON(propertyType) + "}";
        };
        return _map;
    },
    object: function object(uncompiled) {
        var type = {};
        for(var typePropertyName in uncompiled)type[typePropertyName] = $dd56f1099edcc30b$var$compile(uncompiled[typePropertyName]);
        function _object(value, strict) {
            if (!$7wNwK.Object(value)) return false;
            if ($7wNwK.Nil(value)) return false;
            var propertyName;
            try {
                for(propertyName in type){
                    var propertyType = type[propertyName];
                    var propertyValue = value[propertyName];
                    $dd56f1099edcc30b$var$typeforce(propertyType, propertyValue, strict);
                }
            } catch (e) {
                throw $dd56f1099edcc30b$var$tfSubError(e, propertyName);
            }
            if (strict) for(propertyName in value){
                if (type[propertyName]) continue;
                throw new $dd56f1099edcc30b$var$TfPropertyTypeError(undefined, propertyName);
            }
            return true;
        }
        _object.toJSON = function() {
            return $dd56f1099edcc30b$var$tfJSON(type);
        };
        return _object;
    },
    anyOf: function anyOf() {
        var types = [].slice.call(arguments).map($dd56f1099edcc30b$var$compile);
        function _anyOf(value, strict) {
            return types.some(function(type) {
                try {
                    return $dd56f1099edcc30b$var$typeforce(type, value, strict);
                } catch (e) {
                    return false;
                }
            });
        }
        _anyOf.toJSON = function() {
            return types.map($dd56f1099edcc30b$var$tfJSON).join("|");
        };
        return _anyOf;
    },
    allOf: function allOf() {
        var types = [].slice.call(arguments).map($dd56f1099edcc30b$var$compile);
        function _allOf(value, strict) {
            return types.every(function(type) {
                try {
                    return $dd56f1099edcc30b$var$typeforce(type, value, strict);
                } catch (e) {
                    return false;
                }
            });
        }
        _allOf.toJSON = function() {
            return types.map($dd56f1099edcc30b$var$tfJSON).join(" & ");
        };
        return _allOf;
    },
    quacksLike: function quacksLike(type) {
        function _quacksLike(value) {
            return type === $dd56f1099edcc30b$var$getValueTypeName(value);
        }
        _quacksLike.toJSON = function() {
            return type;
        };
        return _quacksLike;
    },
    tuple: function tuple() {
        var types = [].slice.call(arguments).map($dd56f1099edcc30b$var$compile);
        function _tuple(values, strict) {
            if ($7wNwK.Nil(values)) return false;
            if ($7wNwK.Nil(values.length)) return false;
            if (strict && values.length !== types.length) return false;
            return types.every(function(type, i) {
                try {
                    return $dd56f1099edcc30b$var$typeforce(type, values[i], strict);
                } catch (e) {
                    throw $dd56f1099edcc30b$var$tfSubError(e, i);
                }
            });
        }
        _tuple.toJSON = function() {
            return "(" + types.map($dd56f1099edcc30b$var$tfJSON).join(", ") + ")";
        };
        return _tuple;
    },
    value: function value(expected) {
        function _value(actual) {
            return actual === expected;
        }
        _value.toJSON = function() {
            return expected;
        };
        return _value;
    }
};
// TODO: deprecate
$dd56f1099edcc30b$var$TYPES.oneOf = $dd56f1099edcc30b$var$TYPES.anyOf;
function $dd56f1099edcc30b$var$compile(type) {
    if ($7wNwK.String(type)) {
        if (type[0] === "?") return $dd56f1099edcc30b$var$TYPES.maybe(type.slice(1));
        return $7wNwK[type] || $dd56f1099edcc30b$var$TYPES.quacksLike(type);
    } else if (type && $7wNwK.Object(type)) {
        if ($7wNwK.Array(type)) {
            if (type.length !== 1) throw new TypeError("Expected compile() parameter of type Array of length 1");
            return $dd56f1099edcc30b$var$TYPES.arrayOf(type[0]);
        }
        return $dd56f1099edcc30b$var$TYPES.object(type);
    } else if ($7wNwK.Function(type)) return type;
    return $dd56f1099edcc30b$var$TYPES.value(type);
}
function $dd56f1099edcc30b$var$typeforce(type, value, strict, surrogate) {
    if ($7wNwK.Function(type)) {
        if (type(value, strict)) return true;
        throw new $dd56f1099edcc30b$var$TfTypeError(surrogate || type, value);
    }
    // JIT
    return $dd56f1099edcc30b$var$typeforce($dd56f1099edcc30b$var$compile(type), value, strict);
}
// assign types to typeforce function
for(var $dd56f1099edcc30b$var$typeName in $7wNwK)$dd56f1099edcc30b$var$typeforce[$dd56f1099edcc30b$var$typeName] = $7wNwK[$dd56f1099edcc30b$var$typeName];
for($dd56f1099edcc30b$var$typeName in $dd56f1099edcc30b$var$TYPES)$dd56f1099edcc30b$var$typeforce[$dd56f1099edcc30b$var$typeName] = $dd56f1099edcc30b$var$TYPES[$dd56f1099edcc30b$var$typeName];

var $iiRwk = parcelRequire("iiRwk");
for($dd56f1099edcc30b$var$typeName in $iiRwk)$dd56f1099edcc30b$var$typeforce[$dd56f1099edcc30b$var$typeName] = $iiRwk[$dd56f1099edcc30b$var$typeName];
$dd56f1099edcc30b$var$typeforce.compile = $dd56f1099edcc30b$var$compile;
$dd56f1099edcc30b$var$typeforce.TfTypeError = $dd56f1099edcc30b$var$TfTypeError;
$dd56f1099edcc30b$var$typeforce.TfPropertyTypeError = $dd56f1099edcc30b$var$TfPropertyTypeError;
module.exports = $dd56f1099edcc30b$var$typeforce;

});
parcelRegister("gD3E6", function(module, exports) {

var $7wNwK = parcelRequire("7wNwK");
function $c1b31ddc4640aa5c$var$getTypeName(fn) {
    return fn.name || fn.toString().match(/function (.*?)\s*\(/)[1];
}
function $c1b31ddc4640aa5c$var$getValueTypeName(value) {
    return $7wNwK.Nil(value) ? "" : $c1b31ddc4640aa5c$var$getTypeName(value.constructor);
}
function $c1b31ddc4640aa5c$var$getValue(value) {
    if ($7wNwK.Function(value)) return "";
    if ($7wNwK.String(value)) return JSON.stringify(value);
    if (value && $7wNwK.Object(value)) return "";
    return value;
}
function $c1b31ddc4640aa5c$var$captureStackTrace(e, t) {
    if (Error.captureStackTrace) Error.captureStackTrace(e, t);
}
function $c1b31ddc4640aa5c$var$tfJSON(type) {
    if ($7wNwK.Function(type)) return type.toJSON ? type.toJSON() : $c1b31ddc4640aa5c$var$getTypeName(type);
    if ($7wNwK.Array(type)) return "Array";
    if (type && $7wNwK.Object(type)) return "Object";
    return type !== undefined ? type : "";
}
function $c1b31ddc4640aa5c$var$tfErrorString(type, value, valueTypeName) {
    var valueJson = $c1b31ddc4640aa5c$var$getValue(value);
    return "Expected " + $c1b31ddc4640aa5c$var$tfJSON(type) + ", got" + (valueTypeName !== "" ? " " + valueTypeName : "") + (valueJson !== "" ? " " + valueJson : "");
}
function $c1b31ddc4640aa5c$var$TfTypeError(type, value, valueTypeName) {
    valueTypeName = valueTypeName || $c1b31ddc4640aa5c$var$getValueTypeName(value);
    this.message = $c1b31ddc4640aa5c$var$tfErrorString(type, value, valueTypeName);
    $c1b31ddc4640aa5c$var$captureStackTrace(this, $c1b31ddc4640aa5c$var$TfTypeError);
    this.__type = type;
    this.__value = value;
    this.__valueTypeName = valueTypeName;
}
$c1b31ddc4640aa5c$var$TfTypeError.prototype = Object.create(Error.prototype);
$c1b31ddc4640aa5c$var$TfTypeError.prototype.constructor = $c1b31ddc4640aa5c$var$TfTypeError;
function $c1b31ddc4640aa5c$var$tfPropertyErrorString(type, label, name, value, valueTypeName) {
    var description = '" of type ';
    if (label === "key") description = '" with key type ';
    return $c1b31ddc4640aa5c$var$tfErrorString('property "' + $c1b31ddc4640aa5c$var$tfJSON(name) + description + $c1b31ddc4640aa5c$var$tfJSON(type), value, valueTypeName);
}
function $c1b31ddc4640aa5c$var$TfPropertyTypeError(type, property, label, value, valueTypeName) {
    if (type) {
        valueTypeName = valueTypeName || $c1b31ddc4640aa5c$var$getValueTypeName(value);
        this.message = $c1b31ddc4640aa5c$var$tfPropertyErrorString(type, label, property, value, valueTypeName);
    } else this.message = 'Unexpected property "' + property + '"';
    $c1b31ddc4640aa5c$var$captureStackTrace(this, $c1b31ddc4640aa5c$var$TfTypeError);
    this.__label = label;
    this.__property = property;
    this.__type = type;
    this.__value = value;
    this.__valueTypeName = valueTypeName;
}
$c1b31ddc4640aa5c$var$TfPropertyTypeError.prototype = Object.create(Error.prototype);
$c1b31ddc4640aa5c$var$TfPropertyTypeError.prototype.constructor = $c1b31ddc4640aa5c$var$TfTypeError;
function $c1b31ddc4640aa5c$var$tfCustomError(expected, actual) {
    return new $c1b31ddc4640aa5c$var$TfTypeError(expected, {}, actual);
}
function $c1b31ddc4640aa5c$var$tfSubError(e, property, label) {
    // sub child?
    if (e instanceof $c1b31ddc4640aa5c$var$TfPropertyTypeError) {
        property = property + "." + e.__property;
        e = new $c1b31ddc4640aa5c$var$TfPropertyTypeError(e.__type, property, e.__label, e.__value, e.__valueTypeName);
    // child?
    } else if (e instanceof $c1b31ddc4640aa5c$var$TfTypeError) e = new $c1b31ddc4640aa5c$var$TfPropertyTypeError(e.__type, property, label, e.__value, e.__valueTypeName);
    $c1b31ddc4640aa5c$var$captureStackTrace(e);
    return e;
}
module.exports = {
    TfTypeError: $c1b31ddc4640aa5c$var$TfTypeError,
    TfPropertyTypeError: $c1b31ddc4640aa5c$var$TfPropertyTypeError,
    tfCustomError: $c1b31ddc4640aa5c$var$tfCustomError,
    tfSubError: $c1b31ddc4640aa5c$var$tfSubError,
    tfJSON: $c1b31ddc4640aa5c$var$tfJSON,
    getValueTypeName: $c1b31ddc4640aa5c$var$getValueTypeName
};

});
parcelRegister("7wNwK", function(module, exports) {
var $57b1f0a102af0d6f$var$types = {
    Array: function(value) {
        return value !== null && value !== undefined && value.constructor === Array;
    },
    Boolean: function(value) {
        return typeof value === "boolean";
    },
    Function: function(value) {
        return typeof value === "function";
    },
    Nil: function(value) {
        return value === undefined || value === null;
    },
    Number: function(value) {
        return typeof value === "number";
    },
    Object: function(value) {
        return typeof value === "object";
    },
    String: function(value) {
        return typeof value === "string";
    },
    "": function() {
        return true;
    }
};
// TODO: deprecate
$57b1f0a102af0d6f$var$types.Null = $57b1f0a102af0d6f$var$types.Nil;
for(var $57b1f0a102af0d6f$var$typeName in $57b1f0a102af0d6f$var$types)$57b1f0a102af0d6f$var$types[$57b1f0a102af0d6f$var$typeName].toJSON = (function(t) {
    return t;
}).bind(null, $57b1f0a102af0d6f$var$typeName);
module.exports = $57b1f0a102af0d6f$var$types;

});


parcelRegister("iiRwk", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $d5336c751f9cb94a$require$Buffer = $gzLuY.Buffer;

var $7wNwK = parcelRequire("7wNwK");

var $gD3E6 = parcelRequire("gD3E6");
function $d5336c751f9cb94a$var$_Buffer(value) {
    return $d5336c751f9cb94a$require$Buffer.isBuffer(value);
}
function $d5336c751f9cb94a$var$Hex(value) {
    return typeof value === "string" && /^([0-9a-f]{2})+$/i.test(value);
}
function $d5336c751f9cb94a$var$_LengthN(type, length) {
    var name = type.toJSON();
    function Length(value) {
        if (!type(value)) return false;
        if (value.length === length) return true;
        throw $gD3E6.tfCustomError(name + "(Length: " + length + ")", name + "(Length: " + value.length + ")");
    }
    Length.toJSON = function() {
        return name;
    };
    return Length;
}
var $d5336c751f9cb94a$var$_ArrayN = $d5336c751f9cb94a$var$_LengthN.bind(null, $7wNwK.Array);
var $d5336c751f9cb94a$var$_BufferN = $d5336c751f9cb94a$var$_LengthN.bind(null, $d5336c751f9cb94a$var$_Buffer);
var $d5336c751f9cb94a$var$_HexN = $d5336c751f9cb94a$var$_LengthN.bind(null, $d5336c751f9cb94a$var$Hex);
var $d5336c751f9cb94a$var$_StringN = $d5336c751f9cb94a$var$_LengthN.bind(null, $7wNwK.String);
function $d5336c751f9cb94a$var$Range(a, b, f) {
    f = f || $7wNwK.Number;
    function _range(value, strict) {
        return f(value, strict) && value > a && value < b;
    }
    _range.toJSON = function() {
        return `${f.toJSON()} between [${a}, ${b}]`;
    };
    return _range;
}
var $d5336c751f9cb94a$var$INT53_MAX = Math.pow(2, 53) - 1;
function $d5336c751f9cb94a$var$Finite(value) {
    return typeof value === "number" && isFinite(value);
}
function $d5336c751f9cb94a$var$Int8(value) {
    return value << 24 >> 24 === value;
}
function $d5336c751f9cb94a$var$Int16(value) {
    return value << 16 >> 16 === value;
}
function $d5336c751f9cb94a$var$Int32(value) {
    return (value | 0) === value;
}
function $d5336c751f9cb94a$var$Int53(value) {
    return typeof value === "number" && value >= -$d5336c751f9cb94a$var$INT53_MAX && value <= $d5336c751f9cb94a$var$INT53_MAX && Math.floor(value) === value;
}
function $d5336c751f9cb94a$var$UInt8(value) {
    return (value & 0xff) === value;
}
function $d5336c751f9cb94a$var$UInt16(value) {
    return (value & 0xffff) === value;
}
function $d5336c751f9cb94a$var$UInt32(value) {
    return value >>> 0 === value;
}
function $d5336c751f9cb94a$var$UInt53(value) {
    return typeof value === "number" && value >= 0 && value <= $d5336c751f9cb94a$var$INT53_MAX && Math.floor(value) === value;
}
var $d5336c751f9cb94a$var$types = {
    ArrayN: $d5336c751f9cb94a$var$_ArrayN,
    Buffer: $d5336c751f9cb94a$var$_Buffer,
    BufferN: $d5336c751f9cb94a$var$_BufferN,
    Finite: $d5336c751f9cb94a$var$Finite,
    Hex: $d5336c751f9cb94a$var$Hex,
    HexN: $d5336c751f9cb94a$var$_HexN,
    Int8: $d5336c751f9cb94a$var$Int8,
    Int16: $d5336c751f9cb94a$var$Int16,
    Int32: $d5336c751f9cb94a$var$Int32,
    Int53: $d5336c751f9cb94a$var$Int53,
    Range: $d5336c751f9cb94a$var$Range,
    StringN: $d5336c751f9cb94a$var$_StringN,
    UInt8: $d5336c751f9cb94a$var$UInt8,
    UInt16: $d5336c751f9cb94a$var$UInt16,
    UInt32: $d5336c751f9cb94a$var$UInt32,
    UInt53: $d5336c751f9cb94a$var$UInt53
};
for(var $d5336c751f9cb94a$var$typeName in $d5336c751f9cb94a$var$types)$d5336c751f9cb94a$var$types[$d5336c751f9cb94a$var$typeName].toJSON = (function(t) {
    return t;
}).bind(null, $d5336c751f9cb94a$var$typeName);
module.exports = $d5336c751f9cb94a$var$types;

});


parcelRegister("6QIDt", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $4fca391a2a3c0ba9$require$Buffer = $gzLuY.Buffer;

var $5hfII = parcelRequire("5hfII");
function $4fca391a2a3c0ba9$var$decodeRaw(buffer, version) {
    // check version only if defined
    if (version !== undefined && buffer[0] !== version) throw new Error("Invalid network version");
    // uncompressed
    if (buffer.length === 33) return {
        version: buffer[0],
        privateKey: buffer.slice(1, 33),
        compressed: false
    };
    // invalid length
    if (buffer.length !== 34) throw new Error("Invalid WIF length");
    // invalid compression flag
    if (buffer[33] !== 0x01) throw new Error("Invalid compression flag");
    return {
        version: buffer[0],
        privateKey: buffer.slice(1, 33),
        compressed: true
    };
}
function $4fca391a2a3c0ba9$var$encodeRaw(version, privateKey, compressed) {
    var result = new $4fca391a2a3c0ba9$require$Buffer(compressed ? 34 : 33);
    result.writeUInt8(version, 0);
    privateKey.copy(result, 1);
    if (compressed) result[33] = 0x01;
    return result;
}
function $4fca391a2a3c0ba9$var$decode(string, version) {
    return $4fca391a2a3c0ba9$var$decodeRaw($5hfII.decode(string), version);
}
function $4fca391a2a3c0ba9$var$encode(version, privateKey, compressed) {
    if (typeof version === "number") return $5hfII.encode($4fca391a2a3c0ba9$var$encodeRaw(version, privateKey, compressed));
    return $5hfII.encode($4fca391a2a3c0ba9$var$encodeRaw(version.version, version.privateKey, version.compressed));
}
module.exports = {
    decode: $4fca391a2a3c0ba9$var$decode,
    decodeRaw: $4fca391a2a3c0ba9$var$decodeRaw,
    encode: $4fca391a2a3c0ba9$var$encode,
    encodeRaw: $4fca391a2a3c0ba9$var$encodeRaw
};

});



parcelRegister("8M4RQ", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $66369505a98f42d7$require$Buffer = $gzLuY.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $HGYq1 = parcelRequire("HGYq1");

var $8MCsS = parcelRequire("8MCsS");

var $5pPyY = parcelRequire("5pPyY");

var $bdetq = parcelRequire("bdetq");

var $aPkQ0 = parcelRequire("aPkQ0");
let $66369505a98f42d7$var$DEFAULT_WORDLIST = $aPkQ0._default;
const $66369505a98f42d7$var$INVALID_MNEMONIC = "Invalid mnemonic";
const $66369505a98f42d7$var$INVALID_ENTROPY = "Invalid entropy";
const $66369505a98f42d7$var$INVALID_CHECKSUM = "Invalid mnemonic checksum";
const $66369505a98f42d7$var$WORDLIST_REQUIRED = "A wordlist is required but a default could not be found.\nPlease pass a 2048 word array explicitly.";
function $66369505a98f42d7$var$normalize(str) {
    return (str || "").normalize("NFKD");
}
function $66369505a98f42d7$var$lpad(str, padString, length) {
    while(str.length < length)str = padString + str;
    return str;
}
function $66369505a98f42d7$var$binaryToByte(bin) {
    return parseInt(bin, 2);
}
function $66369505a98f42d7$var$bytesToBinary(bytes) {
    return bytes.map((x)=>$66369505a98f42d7$var$lpad(x.toString(2), "0", 8)).join("");
}
function $66369505a98f42d7$var$deriveChecksumBits(entropyBuffer) {
    const ENT = entropyBuffer.length * 8;
    const CS = ENT / 32;
    const hash = $HGYq1.sha256(Uint8Array.from(entropyBuffer));
    return $66369505a98f42d7$var$bytesToBinary(Array.from(hash)).slice(0, CS);
}
function $66369505a98f42d7$var$salt(password) {
    return "mnemonic" + (password || "");
}
function $66369505a98f42d7$var$mnemonicToSeedSync(mnemonic, password) {
    const mnemonicBuffer = Uint8Array.from($66369505a98f42d7$require$Buffer.from($66369505a98f42d7$var$normalize(mnemonic), "utf8"));
    const saltBuffer = Uint8Array.from($66369505a98f42d7$require$Buffer.from($66369505a98f42d7$var$salt($66369505a98f42d7$var$normalize(password)), "utf8"));
    const res = $5pPyY.pbkdf2($8MCsS.sha512, mnemonicBuffer, saltBuffer, {
        c: 2048,
        dkLen: 64
    });
    return $66369505a98f42d7$require$Buffer.from(res);
}
module.exports.mnemonicToSeedSync = $66369505a98f42d7$var$mnemonicToSeedSync;
function $66369505a98f42d7$var$mnemonicToSeed(mnemonic, password) {
    const mnemonicBuffer = Uint8Array.from($66369505a98f42d7$require$Buffer.from($66369505a98f42d7$var$normalize(mnemonic), "utf8"));
    const saltBuffer = Uint8Array.from($66369505a98f42d7$require$Buffer.from($66369505a98f42d7$var$salt($66369505a98f42d7$var$normalize(password)), "utf8"));
    return $5pPyY.pbkdf2Async($8MCsS.sha512, mnemonicBuffer, saltBuffer, {
        c: 2048,
        dkLen: 64
    }).then((res)=>$66369505a98f42d7$require$Buffer.from(res));
}
module.exports.mnemonicToSeed = $66369505a98f42d7$var$mnemonicToSeed;
function $66369505a98f42d7$var$mnemonicToEntropy(mnemonic, wordlist) {
    wordlist = wordlist || $66369505a98f42d7$var$DEFAULT_WORDLIST;
    if (!wordlist) throw new Error($66369505a98f42d7$var$WORDLIST_REQUIRED);
    const words = $66369505a98f42d7$var$normalize(mnemonic).split(" ");
    if (words.length % 3 !== 0) throw new Error($66369505a98f42d7$var$INVALID_MNEMONIC);
    // convert word indices to 11 bit binary strings
    const bits = words.map((word)=>{
        const index = wordlist.indexOf(word);
        if (index === -1) throw new Error($66369505a98f42d7$var$INVALID_MNEMONIC);
        return $66369505a98f42d7$var$lpad(index.toString(2), "0", 11);
    }).join("");
    // split the binary string into ENT/CS
    const dividerIndex = Math.floor(bits.length / 33) * 32;
    const entropyBits = bits.slice(0, dividerIndex);
    const checksumBits = bits.slice(dividerIndex);
    // calculate the checksum and compare
    const entropyBytes = entropyBits.match(/(.{1,8})/g).map($66369505a98f42d7$var$binaryToByte);
    if (entropyBytes.length < 16) throw new Error($66369505a98f42d7$var$INVALID_ENTROPY);
    if (entropyBytes.length > 32) throw new Error($66369505a98f42d7$var$INVALID_ENTROPY);
    if (entropyBytes.length % 4 !== 0) throw new Error($66369505a98f42d7$var$INVALID_ENTROPY);
    const entropy = $66369505a98f42d7$require$Buffer.from(entropyBytes);
    const newChecksum = $66369505a98f42d7$var$deriveChecksumBits(entropy);
    if (newChecksum !== checksumBits) throw new Error($66369505a98f42d7$var$INVALID_CHECKSUM);
    return entropy.toString("hex");
}
module.exports.mnemonicToEntropy = $66369505a98f42d7$var$mnemonicToEntropy;
function $66369505a98f42d7$var$entropyToMnemonic(entropy, wordlist) {
    if (!$66369505a98f42d7$require$Buffer.isBuffer(entropy)) entropy = $66369505a98f42d7$require$Buffer.from(entropy, "hex");
    wordlist = wordlist || $66369505a98f42d7$var$DEFAULT_WORDLIST;
    if (!wordlist) throw new Error($66369505a98f42d7$var$WORDLIST_REQUIRED);
    // 128 <= ENT <= 256
    if (entropy.length < 16) throw new TypeError($66369505a98f42d7$var$INVALID_ENTROPY);
    if (entropy.length > 32) throw new TypeError($66369505a98f42d7$var$INVALID_ENTROPY);
    if (entropy.length % 4 !== 0) throw new TypeError($66369505a98f42d7$var$INVALID_ENTROPY);
    const entropyBits = $66369505a98f42d7$var$bytesToBinary(Array.from(entropy));
    const checksumBits = $66369505a98f42d7$var$deriveChecksumBits(entropy);
    const bits = entropyBits + checksumBits;
    const chunks = bits.match(/(.{1,11})/g);
    const words = chunks.map((binary)=>{
        const index = $66369505a98f42d7$var$binaryToByte(binary);
        return wordlist[index];
    });
    return wordlist[0] === "\u3042\u3044\u3053\u304F\u3057\u3093" // Japanese wordlist
     ? words.join("\u3000") : words.join(" ");
}
module.exports.entropyToMnemonic = $66369505a98f42d7$var$entropyToMnemonic;
function $66369505a98f42d7$var$generateMnemonic(strength, rng, wordlist) {
    strength = strength || 128;
    if (strength % 32 !== 0) throw new TypeError($66369505a98f42d7$var$INVALID_ENTROPY);
    rng = rng || ((size)=>$66369505a98f42d7$require$Buffer.from($bdetq.randomBytes(size)));
    return $66369505a98f42d7$var$entropyToMnemonic(rng(strength / 8), wordlist);
}
module.exports.generateMnemonic = $66369505a98f42d7$var$generateMnemonic;
function $66369505a98f42d7$var$validateMnemonic(mnemonic, wordlist) {
    try {
        $66369505a98f42d7$var$mnemonicToEntropy(mnemonic, wordlist);
    } catch (e) {
        return false;
    }
    return true;
}
module.exports.validateMnemonic = $66369505a98f42d7$var$validateMnemonic;
function $66369505a98f42d7$var$setDefaultWordlist(language) {
    const result = $aPkQ0.wordlists[language];
    if (result) $66369505a98f42d7$var$DEFAULT_WORDLIST = result;
    else throw new Error('Could not find wordlist for language "' + language + '"');
}
module.exports.setDefaultWordlist = $66369505a98f42d7$var$setDefaultWordlist;
function $66369505a98f42d7$var$getDefaultWordlist() {
    if (!$66369505a98f42d7$var$DEFAULT_WORDLIST) throw new Error("No Default Wordlist set");
    return Object.keys($aPkQ0.wordlists).filter((lang)=>{
        if (lang === "JA" || lang === "EN") return false;
        return $aPkQ0.wordlists[lang].every((word, index)=>word === $66369505a98f42d7$var$DEFAULT_WORDLIST[index]);
    })[0];
}
module.exports.getDefaultWordlist = $66369505a98f42d7$var$getDefaultWordlist;

var $aPkQ0 = parcelRequire("aPkQ0");
module.exports.wordlists = $aPkQ0.wordlists;

});
parcelRegister("aPkQ0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
// browserify by default only pulls in files that are hard coded in requires
// In order of last to first in this file, the default wordlist will be chosen
// based on what is present. (Bundles may remove wordlists they don't need)
const $7e1ed4bce31bf083$var$wordlists = {};
module.exports.wordlists = $7e1ed4bce31bf083$var$wordlists;
let $7e1ed4bce31bf083$var$_default;
module.exports._default = $7e1ed4bce31bf083$var$_default;

try {
    module.exports._default = $7e1ed4bce31bf083$var$_default = (parcelRequire("ioW7A"));
    $7e1ed4bce31bf083$var$wordlists.czech = $7e1ed4bce31bf083$var$_default;
} catch (err) {}

try {
    module.exports._default = $7e1ed4bce31bf083$var$_default = (parcelRequire("3Ww2I"));
    $7e1ed4bce31bf083$var$wordlists.chinese_simplified = $7e1ed4bce31bf083$var$_default;
} catch (err) {}

try {
    module.exports._default = $7e1ed4bce31bf083$var$_default = (parcelRequire("eHU63"));
    $7e1ed4bce31bf083$var$wordlists.chinese_traditional = $7e1ed4bce31bf083$var$_default;
} catch (err) {}

try {
    module.exports._default = $7e1ed4bce31bf083$var$_default = (parcelRequire("ctxcO"));
    $7e1ed4bce31bf083$var$wordlists.korean = $7e1ed4bce31bf083$var$_default;
} catch (err) {}

try {
    module.exports._default = $7e1ed4bce31bf083$var$_default = (parcelRequire("bjYTx"));
    $7e1ed4bce31bf083$var$wordlists.french = $7e1ed4bce31bf083$var$_default;
} catch (err) {}

try {
    module.exports._default = $7e1ed4bce31bf083$var$_default = (parcelRequire("4IXW5"));
    $7e1ed4bce31bf083$var$wordlists.italian = $7e1ed4bce31bf083$var$_default;
} catch (err) {}

try {
    module.exports._default = $7e1ed4bce31bf083$var$_default = (parcelRequire("6n1gF"));
    $7e1ed4bce31bf083$var$wordlists.spanish = $7e1ed4bce31bf083$var$_default;
} catch (err) {}

try {
    module.exports._default = $7e1ed4bce31bf083$var$_default = (parcelRequire("2WDwo"));
    $7e1ed4bce31bf083$var$wordlists.japanese = $7e1ed4bce31bf083$var$_default;
    $7e1ed4bce31bf083$var$wordlists.JA = $7e1ed4bce31bf083$var$_default;
} catch (err) {}

try {
    module.exports._default = $7e1ed4bce31bf083$var$_default = (parcelRequire("97tng"));
    $7e1ed4bce31bf083$var$wordlists.portuguese = $7e1ed4bce31bf083$var$_default;
} catch (err) {}

try {
    module.exports._default = $7e1ed4bce31bf083$var$_default = (parcelRequire("iFGk9"));
    $7e1ed4bce31bf083$var$wordlists.english = $7e1ed4bce31bf083$var$_default;
    $7e1ed4bce31bf083$var$wordlists.EN = $7e1ed4bce31bf083$var$_default;
} catch (err) {}

});
parcelRegister("ioW7A", function(module, exports) {
module.exports = JSON.parse('["abdikace","abeceda","adresa","agrese","akce","aktovka","alej","alkohol","amputace","ananas","andulka","anekdota","anketa","antika","anulovat","archa","arogance","asfalt","asistent","aspirace","astma","astronom","atlas","atletika","atol","autobus","azyl","babka","bachor","bacil","baculka","badatel","bageta","bagr","bahno","bakterie","balada","baletka","balkon","balonek","balvan","balza","bambus","bankomat","barbar","baret","barman","baroko","barva","baterka","batoh","bavlna","bazalka","bazilika","bazuka","bedna","beran","beseda","bestie","beton","bezinka","bezmoc","beztak","bicykl","bidlo","biftek","bikiny","bilance","biograf","biolog","bitva","bizon","blahobyt","blatouch","blecha","bledule","blesk","blikat","blizna","blokovat","bloudit","blud","bobek","bobr","bodlina","bodnout","bohatost","bojkot","bojovat","bokorys","bolest","borec","borovice","bota","boubel","bouchat","bouda","boule","bourat","boxer","bradavka","brambora","branka","bratr","brepta","briketa","brko","brloh","bronz","broskev","brunetka","brusinka","brzda","brzy","bublina","bubnovat","buchta","buditel","budka","budova","bufet","bujarost","bukvice","buldok","bulva","bunda","bunkr","burza","butik","buvol","buzola","bydlet","bylina","bytovka","bzukot","capart","carevna","cedr","cedule","cejch","cejn","cela","celer","celkem","celnice","cenina","cennost","cenovka","centrum","cenzor","cestopis","cetka","chalupa","chapadlo","charita","chata","chechtat","chemie","chichot","chirurg","chlad","chleba","chlubit","chmel","chmura","chobot","chochol","chodba","cholera","chomout","chopit","choroba","chov","chrapot","chrlit","chrt","chrup","chtivost","chudina","chutnat","chvat","chvilka","chvost","chyba","chystat","chytit","cibule","cigareta","cihelna","cihla","cinkot","cirkus","cisterna","citace","citrus","cizinec","cizost","clona","cokoliv","couvat","ctitel","ctnost","cudnost","cuketa","cukr","cupot","cvaknout","cval","cvik","cvrkot","cyklista","daleko","dareba","datel","datum","dcera","debata","dechovka","decibel","deficit","deflace","dekl","dekret","demokrat","deprese","derby","deska","detektiv","dikobraz","diktovat","dioda","diplom","disk","displej","divadlo","divoch","dlaha","dlouho","dluhopis","dnes","dobro","dobytek","docent","dochutit","dodnes","dohled","dohoda","dohra","dojem","dojnice","doklad","dokola","doktor","dokument","dolar","doleva","dolina","doma","dominant","domluvit","domov","donutit","dopad","dopis","doplnit","doposud","doprovod","dopustit","dorazit","dorost","dort","dosah","doslov","dostatek","dosud","dosyta","dotaz","dotek","dotknout","doufat","doutnat","dovozce","dozadu","doznat","dozorce","drahota","drak","dramatik","dravec","draze","drdol","drobnost","drogerie","drozd","drsnost","drtit","drzost","duben","duchovno","dudek","duha","duhovka","dusit","dusno","dutost","dvojice","dvorec","dynamit","ekolog","ekonomie","elektron","elipsa","email","emise","emoce","empatie","epizoda","epocha","epopej","epos","esej","esence","eskorta","eskymo","etiketa","euforie","evoluce","exekuce","exkurze","expedice","exploze","export","extrakt","facka","fajfka","fakulta","fanatik","fantazie","farmacie","favorit","fazole","federace","fejeton","fenka","fialka","figurant","filozof","filtr","finance","finta","fixace","fjord","flanel","flirt","flotila","fond","fosfor","fotbal","fotka","foton","frakce","freska","fronta","fukar","funkce","fyzika","galeje","garant","genetika","geolog","gilotina","glazura","glejt","golem","golfista","gotika","graf","gramofon","granule","grep","gril","grog","groteska","guma","hadice","hadr","hala","halenka","hanba","hanopis","harfa","harpuna","havran","hebkost","hejkal","hejno","hejtman","hektar","helma","hematom","herec","herna","heslo","hezky","historik","hladovka","hlasivky","hlava","hledat","hlen","hlodavec","hloh","hloupost","hltat","hlubina","hluchota","hmat","hmota","hmyz","hnis","hnojivo","hnout","hoblina","hoboj","hoch","hodiny","hodlat","hodnota","hodovat","hojnost","hokej","holinka","holka","holub","homole","honitba","honorace","horal","horda","horizont","horko","horlivec","hormon","hornina","horoskop","horstvo","hospoda","hostina","hotovost","houba","houf","houpat","houska","hovor","hradba","hranice","hravost","hrazda","hrbolek","hrdina","hrdlo","hrdost","hrnek","hrobka","hromada","hrot","hrouda","hrozen","hrstka","hrubost","hryzat","hubenost","hubnout","hudba","hukot","humr","husita","hustota","hvozd","hybnost","hydrant","hygiena","hymna","hysterik","idylka","ihned","ikona","iluze","imunita","infekce","inflace","inkaso","inovace","inspekce","internet","invalida","investor","inzerce","ironie","jablko","jachta","jahoda","jakmile","jakost","jalovec","jantar","jarmark","jaro","jasan","jasno","jatka","javor","jazyk","jedinec","jedle","jednatel","jehlan","jekot","jelen","jelito","jemnost","jenom","jepice","jeseter","jevit","jezdec","jezero","jinak","jindy","jinoch","jiskra","jistota","jitrnice","jizva","jmenovat","jogurt","jurta","kabaret","kabel","kabinet","kachna","kadet","kadidlo","kahan","kajak","kajuta","kakao","kaktus","kalamita","kalhoty","kalibr","kalnost","kamera","kamkoliv","kamna","kanibal","kanoe","kantor","kapalina","kapela","kapitola","kapka","kaple","kapota","kapr","kapusta","kapybara","karamel","karotka","karton","kasa","katalog","katedra","kauce","kauza","kavalec","kazajka","kazeta","kazivost","kdekoliv","kdesi","kedluben","kemp","keramika","kino","klacek","kladivo","klam","klapot","klasika","klaun","klec","klenba","klepat","klesnout","klid","klima","klisna","klobouk","klokan","klopa","kloub","klubovna","klusat","kluzkost","kmen","kmitat","kmotr","kniha","knot","koalice","koberec","kobka","kobliha","kobyla","kocour","kohout","kojenec","kokos","koktejl","kolaps","koleda","kolize","kolo","komando","kometa","komik","komnata","komora","kompas","komunita","konat","koncept","kondice","konec","konfese","kongres","konina","konkurs","kontakt","konzerva","kopanec","kopie","kopnout","koprovka","korbel","korektor","kormidlo","koroptev","korpus","koruna","koryto","korzet","kosatec","kostka","kotel","kotleta","kotoul","koukat","koupelna","kousek","kouzlo","kovboj","koza","kozoroh","krabice","krach","krajina","kralovat","krasopis","kravata","kredit","krejcar","kresba","kreveta","kriket","kritik","krize","krkavec","krmelec","krmivo","krocan","krok","kronika","kropit","kroupa","krovka","krtek","kruhadlo","krupice","krutost","krvinka","krychle","krypta","krystal","kryt","kudlanka","kufr","kujnost","kukla","kulajda","kulich","kulka","kulomet","kultura","kuna","kupodivu","kurt","kurzor","kutil","kvalita","kvasinka","kvestor","kynolog","kyselina","kytara","kytice","kytka","kytovec","kyvadlo","labrador","lachtan","ladnost","laik","lakomec","lamela","lampa","lanovka","lasice","laso","lastura","latinka","lavina","lebka","leckdy","leden","lednice","ledovka","ledvina","legenda","legie","legrace","lehce","lehkost","lehnout","lektvar","lenochod","lentilka","lepenka","lepidlo","letadlo","letec","letmo","letokruh","levhart","levitace","levobok","libra","lichotka","lidojed","lidskost","lihovina","lijavec","lilek","limetka","linie","linka","linoleum","listopad","litina","litovat","lobista","lodivod","logika","logoped","lokalita","loket","lomcovat","lopata","lopuch","lord","losos","lotr","loudal","louh","louka","louskat","lovec","lstivost","lucerna","lucifer","lump","lusk","lustrace","lvice","lyra","lyrika","lysina","madam","madlo","magistr","mahagon","majetek","majitel","majorita","makak","makovice","makrela","malba","malina","malovat","malvice","maminka","mandle","manko","marnost","masakr","maskot","masopust","matice","matrika","maturita","mazanec","mazivo","mazlit","mazurka","mdloba","mechanik","meditace","medovina","melasa","meloun","mentolka","metla","metoda","metr","mezera","migrace","mihnout","mihule","mikina","mikrofon","milenec","milimetr","milost","mimika","mincovna","minibar","minomet","minulost","miska","mistr","mixovat","mladost","mlha","mlhovina","mlok","mlsat","mluvit","mnich","mnohem","mobil","mocnost","modelka","modlitba","mohyla","mokro","molekula","momentka","monarcha","monokl","monstrum","montovat","monzun","mosaz","moskyt","most","motivace","motorka","motyka","moucha","moudrost","mozaika","mozek","mozol","mramor","mravenec","mrkev","mrtvola","mrzet","mrzutost","mstitel","mudrc","muflon","mulat","mumie","munice","muset","mutace","muzeum","muzikant","myslivec","mzda","nabourat","nachytat","nadace","nadbytek","nadhoz","nadobro","nadpis","nahlas","nahnat","nahodile","nahradit","naivita","najednou","najisto","najmout","naklonit","nakonec","nakrmit","nalevo","namazat","namluvit","nanometr","naoko","naopak","naostro","napadat","napevno","naplnit","napnout","naposled","naprosto","narodit","naruby","narychlo","nasadit","nasekat","naslepo","nastat","natolik","navenek","navrch","navzdory","nazvat","nebe","nechat","necky","nedaleko","nedbat","neduh","negace","nehet","nehoda","nejen","nejprve","neklid","nelibost","nemilost","nemoc","neochota","neonka","nepokoj","nerost","nerv","nesmysl","nesoulad","netvor","neuron","nevina","nezvykle","nicota","nijak","nikam","nikdy","nikl","nikterak","nitro","nocleh","nohavice","nominace","nora","norek","nositel","nosnost","nouze","noviny","novota","nozdra","nuda","nudle","nuget","nutit","nutnost","nutrie","nymfa","obal","obarvit","obava","obdiv","obec","obehnat","obejmout","obezita","obhajoba","obilnice","objasnit","objekt","obklopit","oblast","oblek","obliba","obloha","obluda","obnos","obohatit","obojek","obout","obrazec","obrna","obruba","obrys","obsah","obsluha","obstarat","obuv","obvaz","obvinit","obvod","obvykle","obyvatel","obzor","ocas","ocel","ocenit","ochladit","ochota","ochrana","ocitnout","odboj","odbyt","odchod","odcizit","odebrat","odeslat","odevzdat","odezva","odhadce","odhodit","odjet","odjinud","odkaz","odkoupit","odliv","odluka","odmlka","odolnost","odpad","odpis","odplout","odpor","odpustit","odpykat","odrazka","odsoudit","odstup","odsun","odtok","odtud","odvaha","odveta","odvolat","odvracet","odznak","ofina","ofsajd","ohlas","ohnisko","ohrada","ohrozit","ohryzek","okap","okenice","oklika","okno","okouzlit","okovy","okrasa","okres","okrsek","okruh","okupant","okurka","okusit","olejnina","olizovat","omak","omeleta","omezit","omladina","omlouvat","omluva","omyl","onehdy","opakovat","opasek","operace","opice","opilost","opisovat","opora","opozice","opravdu","oproti","orbital","orchestr","orgie","orlice","orloj","ortel","osada","oschnout","osika","osivo","oslava","oslepit","oslnit","oslovit","osnova","osoba","osolit","ospalec","osten","ostraha","ostuda","ostych","osvojit","oteplit","otisk","otop","otrhat","otrlost","otrok","otruby","otvor","ovanout","ovar","oves","ovlivnit","ovoce","oxid","ozdoba","pachatel","pacient","padouch","pahorek","pakt","palanda","palec","palivo","paluba","pamflet","pamlsek","panenka","panika","panna","panovat","panstvo","pantofle","paprika","parketa","parodie","parta","paruka","paryba","paseka","pasivita","pastelka","patent","patrona","pavouk","pazneht","pazourek","pecka","pedagog","pejsek","peklo","peloton","penalta","pendrek","penze","periskop","pero","pestrost","petarda","petice","petrolej","pevnina","pexeso","pianista","piha","pijavice","pikle","piknik","pilina","pilnost","pilulka","pinzeta","pipeta","pisatel","pistole","pitevna","pivnice","pivovar","placenta","plakat","plamen","planeta","plastika","platit","plavidlo","plaz","plech","plemeno","plenta","ples","pletivo","plevel","plivat","plnit","plno","plocha","plodina","plomba","plout","pluk","plyn","pobavit","pobyt","pochod","pocit","poctivec","podat","podcenit","podepsat","podhled","podivit","podklad","podmanit","podnik","podoba","podpora","podraz","podstata","podvod","podzim","poezie","pohanka","pohnutka","pohovor","pohroma","pohyb","pointa","pojistka","pojmout","pokazit","pokles","pokoj","pokrok","pokuta","pokyn","poledne","polibek","polknout","poloha","polynom","pomalu","pominout","pomlka","pomoc","pomsta","pomyslet","ponechat","ponorka","ponurost","popadat","popel","popisek","poplach","poprosit","popsat","popud","poradce","porce","porod","porucha","poryv","posadit","posed","posila","poskok","poslanec","posoudit","pospolu","postava","posudek","posyp","potah","potkan","potlesk","potomek","potrava","potupa","potvora","poukaz","pouto","pouzdro","povaha","povidla","povlak","povoz","povrch","povstat","povyk","povzdech","pozdrav","pozemek","poznatek","pozor","pozvat","pracovat","prahory","praktika","prales","praotec","praporek","prase","pravda","princip","prkno","probudit","procento","prodej","profese","prohra","projekt","prolomit","promile","pronikat","propad","prorok","prosba","proton","proutek","provaz","prskavka","prsten","prudkost","prut","prvek","prvohory","psanec","psovod","pstruh","ptactvo","puberta","puch","pudl","pukavec","puklina","pukrle","pult","pumpa","punc","pupen","pusa","pusinka","pustina","putovat","putyka","pyramida","pysk","pytel","racek","rachot","radiace","radnice","radon","raft","ragby","raketa","rakovina","rameno","rampouch","rande","rarach","rarita","rasovna","rastr","ratolest","razance","razidlo","reagovat","reakce","recept","redaktor","referent","reflex","rejnok","reklama","rekord","rekrut","rektor","reputace","revize","revma","revolver","rezerva","riskovat","riziko","robotika","rodokmen","rohovka","rokle","rokoko","romaneto","ropovod","ropucha","rorejs","rosol","rostlina","rotmistr","rotoped","rotunda","roubenka","roucho","roup","roura","rovina","rovnice","rozbor","rozchod","rozdat","rozeznat","rozhodce","rozinka","rozjezd","rozkaz","rozloha","rozmar","rozpad","rozruch","rozsah","roztok","rozum","rozvod","rubrika","ruchadlo","rukavice","rukopis","ryba","rybolov","rychlost","rydlo","rypadlo","rytina","ryzost","sadista","sahat","sako","samec","samizdat","samota","sanitka","sardinka","sasanka","satelit","sazba","sazenice","sbor","schovat","sebranka","secese","sedadlo","sediment","sedlo","sehnat","sejmout","sekera","sekta","sekunda","sekvoje","semeno","seno","servis","sesadit","seshora","seskok","seslat","sestra","sesuv","sesypat","setba","setina","setkat","setnout","setrvat","sever","seznam","shoda","shrnout","sifon","silnice","sirka","sirotek","sirup","situace","skafandr","skalisko","skanzen","skaut","skeptik","skica","skladba","sklenice","sklo","skluz","skoba","skokan","skoro","skripta","skrz","skupina","skvost","skvrna","slabika","sladidlo","slanina","slast","slavnost","sledovat","slepec","sleva","slezina","slib","slina","sliznice","slon","sloupek","slovo","sluch","sluha","slunce","slupka","slza","smaragd","smetana","smilstvo","smlouva","smog","smrad","smrk","smrtka","smutek","smysl","snad","snaha","snob","sobota","socha","sodovka","sokol","sopka","sotva","souboj","soucit","soudce","souhlas","soulad","soumrak","souprava","soused","soutok","souviset","spalovna","spasitel","spis","splav","spodek","spojenec","spolu","sponzor","spornost","spousta","sprcha","spustit","sranda","sraz","srdce","srna","srnec","srovnat","srpen","srst","srub","stanice","starosta","statika","stavba","stehno","stezka","stodola","stolek","stopa","storno","stoupat","strach","stres","strhnout","strom","struna","studna","stupnice","stvol","styk","subjekt","subtropy","suchar","sudost","sukno","sundat","sunout","surikata","surovina","svah","svalstvo","svetr","svatba","svazek","svisle","svitek","svoboda","svodidlo","svorka","svrab","sykavka","sykot","synek","synovec","sypat","sypkost","syrovost","sysel","sytost","tabletka","tabule","tahoun","tajemno","tajfun","tajga","tajit","tajnost","taktika","tamhle","tampon","tancovat","tanec","tanker","tapeta","tavenina","tazatel","technika","tehdy","tekutina","telefon","temnota","tendence","tenista","tenor","teplota","tepna","teprve","terapie","termoska","textil","ticho","tiskopis","titulek","tkadlec","tkanina","tlapka","tleskat","tlukot","tlupa","tmel","toaleta","topinka","topol","torzo","touha","toulec","tradice","traktor","tramp","trasa","traverza","trefit","trest","trezor","trhavina","trhlina","trochu","trojice","troska","trouba","trpce","trpitel","trpkost","trubec","truchlit","truhlice","trus","trvat","tudy","tuhnout","tuhost","tundra","turista","turnaj","tuzemsko","tvaroh","tvorba","tvrdost","tvrz","tygr","tykev","ubohost","uboze","ubrat","ubrousek","ubrus","ubytovna","ucho","uctivost","udivit","uhradit","ujednat","ujistit","ujmout","ukazatel","uklidnit","uklonit","ukotvit","ukrojit","ulice","ulita","ulovit","umyvadlo","unavit","uniforma","uniknout","upadnout","uplatnit","uplynout","upoutat","upravit","uran","urazit","usednout","usilovat","usmrtit","usnadnit","usnout","usoudit","ustlat","ustrnout","utahovat","utkat","utlumit","utonout","utopenec","utrousit","uvalit","uvolnit","uvozovka","uzdravit","uzel","uzenina","uzlina","uznat","vagon","valcha","valoun","vana","vandal","vanilka","varan","varhany","varovat","vcelku","vchod","vdova","vedro","vegetace","vejce","velbloud","veletrh","velitel","velmoc","velryba","venkov","veranda","verze","veselka","veskrze","vesnice","vespodu","vesta","veterina","veverka","vibrace","vichr","videohra","vidina","vidle","vila","vinice","viset","vitalita","vize","vizitka","vjezd","vklad","vkus","vlajka","vlak","vlasec","vlevo","vlhkost","vliv","vlnovka","vloupat","vnucovat","vnuk","voda","vodivost","vodoznak","vodstvo","vojensky","vojna","vojsko","volant","volba","volit","volno","voskovka","vozidlo","vozovna","vpravo","vrabec","vracet","vrah","vrata","vrba","vrcholek","vrhat","vrstva","vrtule","vsadit","vstoupit","vstup","vtip","vybavit","vybrat","vychovat","vydat","vydra","vyfotit","vyhledat","vyhnout","vyhodit","vyhradit","vyhubit","vyjasnit","vyjet","vyjmout","vyklopit","vykonat","vylekat","vymazat","vymezit","vymizet","vymyslet","vynechat","vynikat","vynutit","vypadat","vyplatit","vypravit","vypustit","vyrazit","vyrovnat","vyrvat","vyslovit","vysoko","vystavit","vysunout","vysypat","vytasit","vytesat","vytratit","vyvinout","vyvolat","vyvrhel","vyzdobit","vyznat","vzadu","vzbudit","vzchopit","vzdor","vzduch","vzdychat","vzestup","vzhledem","vzkaz","vzlykat","vznik","vzorek","vzpoura","vztah","vztek","xylofon","zabrat","zabydlet","zachovat","zadarmo","zadusit","zafoukat","zahltit","zahodit","zahrada","zahynout","zajatec","zajet","zajistit","zaklepat","zakoupit","zalepit","zamezit","zamotat","zamyslet","zanechat","zanikat","zaplatit","zapojit","zapsat","zarazit","zastavit","zasunout","zatajit","zatemnit","zatknout","zaujmout","zavalit","zavelet","zavinit","zavolat","zavrtat","zazvonit","zbavit","zbrusu","zbudovat","zbytek","zdaleka","zdarma","zdatnost","zdivo","zdobit","zdroj","zdvih","zdymadlo","zelenina","zeman","zemina","zeptat","zezadu","zezdola","zhatit","zhltnout","zhluboka","zhotovit","zhruba","zima","zimnice","zjemnit","zklamat","zkoumat","zkratka","zkumavka","zlato","zlehka","zloba","zlom","zlost","zlozvyk","zmapovat","zmar","zmatek","zmije","zmizet","zmocnit","zmodrat","zmrzlina","zmutovat","znak","znalost","znamenat","znovu","zobrazit","zotavit","zoubek","zoufale","zplodit","zpomalit","zprava","zprostit","zprudka","zprvu","zrada","zranit","zrcadlo","zrnitost","zrno","zrovna","zrychlit","zrzavost","zticha","ztratit","zubovina","zubr","zvednout","zvenku","zvesela","zvon","zvrat","zvukovod","zvyk"]');

});

parcelRegister("3Ww2I", function(module, exports) {
module.exports = JSON.parse('["\u7684","\u4E00","\u662F","\u5728","\u4E0D","\u4E86","\u6709","\u548C","\u4EBA","\u8FD9","\u4E2D","\u5927","\u4E3A","\u4E0A","\u4E2A","\u56FD","\u6211","\u4EE5","\u8981","\u4ED6","\u65F6","\u6765","\u7528","\u4EEC","\u751F","\u5230","\u4F5C","\u5730","\u4E8E","\u51FA","\u5C31","\u5206","\u5BF9","\u6210","\u4F1A","\u53EF","\u4E3B","\u53D1","\u5E74","\u52A8","\u540C","\u5DE5","\u4E5F","\u80FD","\u4E0B","\u8FC7","\u5B50","\u8BF4","\u4EA7","\u79CD","\u9762","\u800C","\u65B9","\u540E","\u591A","\u5B9A","\u884C","\u5B66","\u6CD5","\u6240","\u6C11","\u5F97","\u7ECF","\u5341","\u4E09","\u4E4B","\u8FDB","\u7740","\u7B49","\u90E8","\u5EA6","\u5BB6","\u7535","\u529B","\u91CC","\u5982","\u6C34","\u5316","\u9AD8","\u81EA","\u4E8C","\u7406","\u8D77","\u5C0F","\u7269","\u73B0","\u5B9E","\u52A0","\u91CF","\u90FD","\u4E24","\u4F53","\u5236","\u673A","\u5F53","\u4F7F","\u70B9","\u4ECE","\u4E1A","\u672C","\u53BB","\u628A","\u6027","\u597D","\u5E94","\u5F00","\u5B83","\u5408","\u8FD8","\u56E0","\u7531","\u5176","\u4E9B","\u7136","\u524D","\u5916","\u5929","\u653F","\u56DB","\u65E5","\u90A3","\u793E","\u4E49","\u4E8B","\u5E73","\u5F62","\u76F8","\u5168","\u8868","\u95F4","\u6837","\u4E0E","\u5173","\u5404","\u91CD","\u65B0","\u7EBF","\u5185","\u6570","\u6B63","\u5FC3","\u53CD","\u4F60","\u660E","\u770B","\u539F","\u53C8","\u4E48","\u5229","\u6BD4","\u6216","\u4F46","\u8D28","\u6C14","\u7B2C","\u5411","\u9053","\u547D","\u6B64","\u53D8","\u6761","\u53EA","\u6CA1","\u7ED3","\u89E3","\u95EE","\u610F","\u5EFA","\u6708","\u516C","\u65E0","\u7CFB","\u519B","\u5F88","\u60C5","\u8005","\u6700","\u7ACB","\u4EE3","\u60F3","\u5DF2","\u901A","\u5E76","\u63D0","\u76F4","\u9898","\u515A","\u7A0B","\u5C55","\u4E94","\u679C","\u6599","\u8C61","\u5458","\u9769","\u4F4D","\u5165","\u5E38","\u6587","\u603B","\u6B21","\u54C1","\u5F0F","\u6D3B","\u8BBE","\u53CA","\u7BA1","\u7279","\u4EF6","\u957F","\u6C42","\u8001","\u5934","\u57FA","\u8D44","\u8FB9","\u6D41","\u8DEF","\u7EA7","\u5C11","\u56FE","\u5C71","\u7EDF","\u63A5","\u77E5","\u8F83","\u5C06","\u7EC4","\u89C1","\u8BA1","\u522B","\u5979","\u624B","\u89D2","\u671F","\u6839","\u8BBA","\u8FD0","\u519C","\u6307","\u51E0","\u4E5D","\u533A","\u5F3A","\u653E","\u51B3","\u897F","\u88AB","\u5E72","\u505A","\u5FC5","\u6218","\u5148","\u56DE","\u5219","\u4EFB","\u53D6","\u636E","\u5904","\u961F","\u5357","\u7ED9","\u8272","\u5149","\u95E8","\u5373","\u4FDD","\u6CBB","\u5317","\u9020","\u767E","\u89C4","\u70ED","\u9886","\u4E03","\u6D77","\u53E3","\u4E1C","\u5BFC","\u5668","\u538B","\u5FD7","\u4E16","\u91D1","\u589E","\u4E89","\u6D4E","\u9636","\u6CB9","\u601D","\u672F","\u6781","\u4EA4","\u53D7","\u8054","\u4EC0","\u8BA4","\u516D","\u5171","\u6743","\u6536","\u8BC1","\u6539","\u6E05","\u7F8E","\u518D","\u91C7","\u8F6C","\u66F4","\u5355","\u98CE","\u5207","\u6253","\u767D","\u6559","\u901F","\u82B1","\u5E26","\u5B89","\u573A","\u8EAB","\u8F66","\u4F8B","\u771F","\u52A1","\u5177","\u4E07","\u6BCF","\u76EE","\u81F3","\u8FBE","\u8D70","\u79EF","\u793A","\u8BAE","\u58F0","\u62A5","\u6597","\u5B8C","\u7C7B","\u516B","\u79BB","\u534E","\u540D","\u786E","\u624D","\u79D1","\u5F20","\u4FE1","\u9A6C","\u8282","\u8BDD","\u7C73","\u6574","\u7A7A","\u5143","\u51B5","\u4ECA","\u96C6","\u6E29","\u4F20","\u571F","\u8BB8","\u6B65","\u7FA4","\u5E7F","\u77F3","\u8BB0","\u9700","\u6BB5","\u7814","\u754C","\u62C9","\u6797","\u5F8B","\u53EB","\u4E14","\u7A76","\u89C2","\u8D8A","\u7EC7","\u88C5","\u5F71","\u7B97","\u4F4E","\u6301","\u97F3","\u4F17","\u4E66","\u5E03","\u590D","\u5BB9","\u513F","\u987B","\u9645","\u5546","\u975E","\u9A8C","\u8FDE","\u65AD","\u6DF1","\u96BE","\u8FD1","\u77FF","\u5343","\u5468","\u59D4","\u7D20","\u6280","\u5907","\u534A","\u529E","\u9752","\u7701","\u5217","\u4E60","\u54CD","\u7EA6","\u652F","\u822C","\u53F2","\u611F","\u52B3","\u4FBF","\u56E2","\u5F80","\u9178","\u5386","\u5E02","\u514B","\u4F55","\u9664","\u6D88","\u6784","\u5E9C","\u79F0","\u592A","\u51C6","\u7CBE","\u503C","\u53F7","\u7387","\u65CF","\u7EF4","\u5212","\u9009","\u6807","\u5199","\u5B58","\u5019","\u6BDB","\u4EB2","\u5FEB","\u6548","\u65AF","\u9662","\u67E5","\u6C5F","\u578B","\u773C","\u738B","\u6309","\u683C","\u517B","\u6613","\u7F6E","\u6D3E","\u5C42","\u7247","\u59CB","\u5374","\u4E13","\u72B6","\u80B2","\u5382","\u4EAC","\u8BC6","\u9002","\u5C5E","\u5706","\u5305","\u706B","\u4F4F","\u8C03","\u6EE1","\u53BF","\u5C40","\u7167","\u53C2","\u7EA2","\u7EC6","\u5F15","\u542C","\u8BE5","\u94C1","\u4EF7","\u4E25","\u9996","\u5E95","\u6DB2","\u5B98","\u5FB7","\u968F","\u75C5","\u82CF","\u5931","\u5C14","\u6B7B","\u8BB2","\u914D","\u5973","\u9EC4","\u63A8","\u663E","\u8C08","\u7F6A","\u795E","\u827A","\u5462","\u5E2D","\u542B","\u4F01","\u671B","\u5BC6","\u6279","\u8425","\u9879","\u9632","\u4E3E","\u7403","\u82F1","\u6C27","\u52BF","\u544A","\u674E","\u53F0","\u843D","\u6728","\u5E2E","\u8F6E","\u7834","\u4E9A","\u5E08","\u56F4","\u6CE8","\u8FDC","\u5B57","\u6750","\u6392","\u4F9B","\u6CB3","\u6001","\u5C01","\u53E6","\u65BD","\u51CF","\u6811","\u6EB6","\u600E","\u6B62","\u6848","\u8A00","\u58EB","\u5747","\u6B66","\u56FA","\u53F6","\u9C7C","\u6CE2","\u89C6","\u4EC5","\u8D39","\u7D27","\u7231","\u5DE6","\u7AE0","\u65E9","\u671D","\u5BB3","\u7EED","\u8F7B","\u670D","\u8BD5","\u98DF","\u5145","\u5175","\u6E90","\u5224","\u62A4","\u53F8","\u8DB3","\u67D0","\u7EC3","\u5DEE","\u81F4","\u677F","\u7530","\u964D","\u9ED1","\u72AF","\u8D1F","\u51FB","\u8303","\u7EE7","\u5174","\u4F3C","\u4F59","\u575A","\u66F2","\u8F93","\u4FEE","\u6545","\u57CE","\u592B","\u591F","\u9001","\u7B14","\u8239","\u5360","\u53F3","\u8D22","\u5403","\u5BCC","\u6625","\u804C","\u89C9","\u6C49","\u753B","\u529F","\u5DF4","\u8DDF","\u867D","\u6742","\u98DE","\u68C0","\u5438","\u52A9","\u5347","\u9633","\u4E92","\u521D","\u521B","\u6297","\u8003","\u6295","\u574F","\u7B56","\u53E4","\u5F84","\u6362","\u672A","\u8DD1","\u7559","\u94A2","\u66FE","\u7AEF","\u8D23","\u7AD9","\u7B80","\u8FF0","\u94B1","\u526F","\u5C3D","\u5E1D","\u5C04","\u8349","\u51B2","\u627F","\u72EC","\u4EE4","\u9650","\u963F","\u5BA3","\u73AF","\u53CC","\u8BF7","\u8D85","\u5FAE","\u8BA9","\u63A7","\u5DDE","\u826F","\u8F74","\u627E","\u5426","\u7EAA","\u76CA","\u4F9D","\u4F18","\u9876","\u7840","\u8F7D","\u5012","\u623F","\u7A81","\u5750","\u7C89","\u654C","\u7565","\u5BA2","\u8881","\u51B7","\u80DC","\u7EDD","\u6790","\u5757","\u5242","\u6D4B","\u4E1D","\u534F","\u8BC9","\u5FF5","\u9648","\u4ECD","\u7F57","\u76D0","\u53CB","\u6D0B","\u9519","\u82E6","\u591C","\u5211","\u79FB","\u9891","\u9010","\u9760","\u6DF7","\u6BCD","\u77ED","\u76AE","\u7EC8","\u805A","\u6C7D","\u6751","\u4E91","\u54EA","\u65E2","\u8DDD","\u536B","\u505C","\u70C8","\u592E","\u5BDF","\u70E7","\u8FC5","\u5883","\u82E5","\u5370","\u6D32","\u523B","\u62EC","\u6FC0","\u5B54","\u641E","\u751A","\u5BA4","\u5F85","\u6838","\u6821","\u6563","\u4FB5","\u5427","\u7532","\u6E38","\u4E45","\u83DC","\u5473","\u65E7","\u6A21","\u6E56","\u8D27","\u635F","\u9884","\u963B","\u6BEB","\u666E","\u7A33","\u4E59","\u5988","\u690D","\u606F","\u6269","\u94F6","\u8BED","\u6325","\u9152","\u5B88","\u62FF","\u5E8F","\u7EB8","\u533B","\u7F3A","\u96E8","\u5417","\u9488","\u5218","\u554A","\u6025","\u5531","\u8BEF","\u8BAD","\u613F","\u5BA1","\u9644","\u83B7","\u8336","\u9C9C","\u7CAE","\u65A4","\u5B69","\u8131","\u786B","\u80A5","\u5584","\u9F99","\u6F14","\u7236","\u6E10","\u8840","\u6B22","\u68B0","\u638C","\u6B4C","\u6C99","\u521A","\u653B","\u8C13","\u76FE","\u8BA8","\u665A","\u7C92","\u4E71","\u71C3","\u77DB","\u4E4E","\u6740","\u836F","\u5B81","\u9C81","\u8D35","\u949F","\u7164","\u8BFB","\u73ED","\u4F2F","\u9999","\u4ECB","\u8FEB","\u53E5","\u4E30","\u57F9","\u63E1","\u5170","\u62C5","\u5F26","\u86CB","\u6C89","\u5047","\u7A7F","\u6267","\u7B54","\u4E50","\u8C01","\u987A","\u70DF","\u7F29","\u5F81","\u8138","\u559C","\u677E","\u811A","\u56F0","\u5F02","\u514D","\u80CC","\u661F","\u798F","\u4E70","\u67D3","\u4E95","\u6982","\u6162","\u6015","\u78C1","\u500D","\u7956","\u7687","\u4FC3","\u9759","\u8865","\u8BC4","\u7FFB","\u8089","\u8DF5","\u5C3C","\u8863","\u5BBD","\u626C","\u68C9","\u5E0C","\u4F24","\u64CD","\u5782","\u79CB","\u5B9C","\u6C22","\u5957","\u7763","\u632F","\u67B6","\u4EAE","\u672B","\u5BAA","\u5E86","\u7F16","\u725B","\u89E6","\u6620","\u96F7","\u9500","\u8BD7","\u5EA7","\u5C45","\u6293","\u88C2","\u80DE","\u547C","\u5A18","\u666F","\u5A01","\u7EFF","\u6676","\u539A","\u76DF","\u8861","\u9E21","\u5B59","\u5EF6","\u5371","\u80F6","\u5C4B","\u4E61","\u4E34","\u9646","\u987E","\u6389","\u5440","\u706F","\u5C81","\u63AA","\u675F","\u8010","\u5267","\u7389","\u8D75","\u8DF3","\u54E5","\u5B63","\u8BFE","\u51EF","\u80E1","\u989D","\u6B3E","\u7ECD","\u5377","\u9F50","\u4F1F","\u84B8","\u6B96","\u6C38","\u5B97","\u82D7","\u5DDD","\u7089","\u5CA9","\u5F31","\u96F6","\u6768","\u594F","\u6CBF","\u9732","\u6746","\u63A2","\u6ED1","\u9547","\u996D","\u6D53","\u822A","\u6000","\u8D76","\u5E93","\u593A","\u4F0A","\u7075","\u7A0E","\u9014","\u706D","\u8D5B","\u5F52","\u53EC","\u9F13","\u64AD","\u76D8","\u88C1","\u9669","\u5EB7","\u552F","\u5F55","\u83CC","\u7EAF","\u501F","\u7CD6","\u76D6","\u6A2A","\u7B26","\u79C1","\u52AA","\u5802","\u57DF","\u67AA","\u6DA6","\u5E45","\u54C8","\u7ADF","\u719F","\u866B","\u6CFD","\u8111","\u58E4","\u78B3","\u6B27","\u904D","\u4FA7","\u5BE8","\u6562","\u5F7B","\u8651","\u659C","\u8584","\u5EAD","\u7EB3","\u5F39","\u9972","\u4F38","\u6298","\u9EA6","\u6E7F","\u6697","\u8377","\u74E6","\u585E","\u5E8A","\u7B51","\u6076","\u6237","\u8BBF","\u5854","\u5947","\u900F","\u6881","\u5200","\u65CB","\u8FF9","\u5361","\u6C2F","\u9047","\u4EFD","\u6BD2","\u6CE5","\u9000","\u6D17","\u6446","\u7070","\u5F69","\u5356","\u8017","\u590F","\u62E9","\u5FD9","\u94DC","\u732E","\u786C","\u4E88","\u7E41","\u5708","\u96EA","\u51FD","\u4EA6","\u62BD","\u7BC7","\u9635","\u9634","\u4E01","\u5C3A","\u8FFD","\u5806","\u96C4","\u8FCE","\u6CDB","\u7238","\u697C","\u907F","\u8C0B","\u5428","\u91CE","\u732A","\u65D7","\u7D2F","\u504F","\u5178","\u9986","\u7D22","\u79E6","\u8102","\u6F6E","\u7237","\u8C46","\u5FFD","\u6258","\u60CA","\u5851","\u9057","\u6108","\u6731","\u66FF","\u7EA4","\u7C97","\u503E","\u5C1A","\u75DB","\u695A","\u8C22","\u594B","\u8D2D","\u78E8","\u541B","\u6C60","\u65C1","\u788E","\u9AA8","\u76D1","\u6355","\u5F1F","\u66B4","\u5272","\u8D2F","\u6B8A","\u91CA","\u8BCD","\u4EA1","\u58C1","\u987F","\u5B9D","\u5348","\u5C18","\u95FB","\u63ED","\u70AE","\u6B8B","\u51AC","\u6865","\u5987","\u8B66","\u7EFC","\u62DB","\u5434","\u4ED8","\u6D6E","\u906D","\u5F90","\u60A8","\u6447","\u8C37","\u8D5E","\u7BB1","\u9694","\u8BA2","\u7537","\u5439","\u56ED","\u7EB7","\u5510","\u8D25","\u5B8B","\u73BB","\u5DE8","\u8015","\u5766","\u8363","\u95ED","\u6E7E","\u952E","\u51E1","\u9A7B","\u9505","\u6551","\u6069","\u5265","\u51DD","\u78B1","\u9F7F","\u622A","\u70BC","\u9EBB","\u7EBA","\u7981","\u5E9F","\u76DB","\u7248","\u7F13","\u51C0","\u775B","\u660C","\u5A5A","\u6D89","\u7B52","\u5634","\u63D2","\u5CB8","\u6717","\u5E84","\u8857","\u85CF","\u59D1","\u8D38","\u8150","\u5974","\u5566","\u60EF","\u4E58","\u4F19","\u6062","\u5300","\u7EB1","\u624E","\u8FA9","\u8033","\u5F6A","\u81E3","\u4EBF","\u7483","\u62B5","\u8109","\u79C0","\u8428","\u4FC4","\u7F51","\u821E","\u5E97","\u55B7","\u7EB5","\u5BF8","\u6C57","\u6302","\u6D2A","\u8D3A","\u95EA","\u67EC","\u7206","\u70EF","\u6D25","\u7A3B","\u5899","\u8F6F","\u52C7","\u50CF","\u6EDA","\u5398","\u8499","\u82B3","\u80AF","\u5761","\u67F1","\u8361","\u817F","\u4EEA","\u65C5","\u5C3E","\u8F67","\u51B0","\u8D21","\u767B","\u9ECE","\u524A","\u94BB","\u52D2","\u9003","\u969C","\u6C28","\u90ED","\u5CF0","\u5E01","\u6E2F","\u4F0F","\u8F68","\u4EA9","\u6BD5","\u64E6","\u83AB","\u523A","\u6D6A","\u79D8","\u63F4","\u682A","\u5065","\u552E","\u80A1","\u5C9B","\u7518","\u6CE1","\u7761","\u7AE5","\u94F8","\u6C64","\u9600","\u4F11","\u6C47","\u820D","\u7267","\u7ED5","\u70B8","\u54F2","\u78F7","\u7EE9","\u670B","\u6DE1","\u5C16","\u542F","\u9677","\u67F4","\u5448","\u5F92","\u989C","\u6CEA","\u7A0D","\u5FD8","\u6CF5","\u84DD","\u62D6","\u6D1E","\u6388","\u955C","\u8F9B","\u58EE","\u950B","\u8D2B","\u865A","\u5F2F","\u6469","\u6CF0","\u5E7C","\u5EF7","\u5C0A","\u7A97","\u7EB2","\u5F04","\u96B6","\u7591","\u6C0F","\u5BAB","\u59D0","\u9707","\u745E","\u602A","\u5C24","\u7434","\u5FAA","\u63CF","\u819C","\u8FDD","\u5939","\u8170","\u7F18","\u73E0","\u7A77","\u68EE","\u679D","\u7AF9","\u6C9F","\u50AC","\u7EF3","\u5FC6","\u90A6","\u5269","\u5E78","\u6D46","\u680F","\u62E5","\u7259","\u8D2E","\u793C","\u6EE4","\u94A0","\u7EB9","\u7F62","\u62CD","\u54B1","\u558A","\u8896","\u57C3","\u52E4","\u7F5A","\u7126","\u6F5C","\u4F0D","\u58A8","\u6B32","\u7F1D","\u59D3","\u520A","\u9971","\u4EFF","\u5956","\u94DD","\u9B3C","\u4E3D","\u8DE8","\u9ED8","\u6316","\u94FE","\u626B","\u559D","\u888B","\u70AD","\u6C61","\u5E55","\u8BF8","\u5F27","\u52B1","\u6885","\u5976","\u6D01","\u707E","\u821F","\u9274","\u82EF","\u8BBC","\u62B1","\u6BC1","\u61C2","\u5BD2","\u667A","\u57D4","\u5BC4","\u5C4A","\u8DC3","\u6E21","\u6311","\u4E39","\u8270","\u8D1D","\u78B0","\u62D4","\u7239","\u6234","\u7801","\u68A6","\u82BD","\u7194","\u8D64","\u6E14","\u54ED","\u656C","\u9897","\u5954","\u94C5","\u4EF2","\u864E","\u7A00","\u59B9","\u4E4F","\u73CD","\u7533","\u684C","\u9075","\u5141","\u9686","\u87BA","\u4ED3","\u9B4F","\u9510","\u6653","\u6C2E","\u517C","\u9690","\u788D","\u8D6B","\u62E8","\u5FE0","\u8083","\u7F38","\u7275","\u62A2","\u535A","\u5DE7","\u58F3","\u5144","\u675C","\u8BAF","\u8BDA","\u78A7","\u7965","\u67EF","\u9875","\u5DE1","\u77E9","\u60B2","\u704C","\u9F84","\u4F26","\u7968","\u5BFB","\u6842","\u94FA","\u5723","\u6050","\u6070","\u90D1","\u8DA3","\u62AC","\u8352","\u817E","\u8D34","\u67D4","\u6EF4","\u731B","\u9614","\u8F86","\u59BB","\u586B","\u64A4","\u50A8","\u7B7E","\u95F9","\u6270","\u7D2B","\u7802","\u9012","\u620F","\u540A","\u9676","\u4F10","\u5582","\u7597","\u74F6","\u5A46","\u629A","\u81C2","\u6478","\u5FCD","\u867E","\u8721","\u90BB","\u80F8","\u5DE9","\u6324","\u5076","\u5F03","\u69FD","\u52B2","\u4E73","\u9093","\u5409","\u4EC1","\u70C2","\u7816","\u79DF","\u4E4C","\u8230","\u4F34","\u74DC","\u6D45","\u4E19","\u6682","\u71E5","\u6A61","\u67F3","\u8FF7","\u6696","\u724C","\u79E7","\u80C6","\u8BE6","\u7C27","\u8E0F","\u74F7","\u8C31","\u5446","\u5BBE","\u7CCA","\u6D1B","\u8F89","\u6124","\u7ADE","\u9699","\u6012","\u7C98","\u4E43","\u7EEA","\u80A9","\u7C4D","\u654F","\u6D82","\u7199","\u7686","\u4FA6","\u60AC","\u6398","\u4EAB","\u7EA0","\u9192","\u72C2","\u9501","\u6DC0","\u6068","\u7272","\u9738","\u722C","\u8D4F","\u9006","\u73A9","\u9675","\u795D","\u79D2","\u6D59","\u8C8C","\u5F79","\u5F7C","\u6089","\u9E2D","\u8D8B","\u51E4","\u6668","\u755C","\u8F88","\u79E9","\u5375","\u7F72","\u68AF","\u708E","\u6EE9","\u68CB","\u9A71","\u7B5B","\u5CE1","\u5192","\u5565","\u5BFF","\u8BD1","\u6D78","\u6CC9","\u5E3D","\u8FDF","\u7845","\u7586","\u8D37","\u6F0F","\u7A3F","\u51A0","\u5AE9","\u80C1","\u82AF","\u7262","\u53DB","\u8680","\u5965","\u9E23","\u5CAD","\u7F8A","\u51ED","\u4E32","\u5858","\u7ED8","\u9175","\u878D","\u76C6","\u9521","\u5E99","\u7B79","\u51BB","\u8F85","\u6444","\u88AD","\u7B4B","\u62D2","\u50DA","\u65F1","\u94BE","\u9E1F","\u6F06","\u6C88","\u7709","\u758F","\u6DFB","\u68D2","\u7A57","\u785D","\u97E9","\u903C","\u626D","\u4FA8","\u51C9","\u633A","\u7897","\u683D","\u7092","\u676F","\u60A3","\u998F","\u529D","\u8C6A","\u8FBD","\u52C3","\u9E3F","\u65E6","\u540F","\u62DC","\u72D7","\u57CB","\u8F8A","\u63A9","\u996E","\u642C","\u9A82","\u8F9E","\u52FE","\u6263","\u4F30","\u848B","\u7ED2","\u96FE","\u4E08","\u6735","\u59C6","\u62DF","\u5B87","\u8F91","\u9655","\u96D5","\u507F","\u84C4","\u5D07","\u526A","\u5021","\u5385","\u54AC","\u9A76","\u85AF","\u5237","\u65A5","\u756A","\u8D4B","\u5949","\u4F5B","\u6D47","\u6F2B","\u66FC","\u6247","\u9499","\u6843","\u6276","\u4ED4","\u8FD4","\u4FD7","\u4E8F","\u8154","\u978B","\u68F1","\u8986","\u6846","\u6084","\u53D4","\u649E","\u9A97","\u52D8","\u65FA","\u6CB8","\u5B64","\u5410","\u5B5F","\u6E20","\u5C48","\u75BE","\u5999","\u60DC","\u4EF0","\u72E0","\u80C0","\u8C10","\u629B","\u9709","\u6851","\u5C97","\u561B","\u8870","\u76D7","\u6E17","\u810F","\u8D56","\u6D8C","\u751C","\u66F9","\u9605","\u808C","\u54E9","\u5389","\u70C3","\u7EAC","\u6BC5","\u6628","\u4F2A","\u75C7","\u716E","\u53F9","\u9489","\u642D","\u830E","\u7B3C","\u9177","\u5077","\u5F13","\u9525","\u6052","\u6770","\u5751","\u9F3B","\u7FFC","\u7EB6","\u53D9","\u72F1","\u902E","\u7F50","\u7EDC","\u68DA","\u6291","\u81A8","\u852C","\u5BFA","\u9AA4","\u7A46","\u51B6","\u67AF","\u518C","\u5C38","\u51F8","\u7EC5","\u576F","\u727A","\u7130","\u8F70","\u6B23","\u664B","\u7626","\u5FA1","\u952D","\u9526","\u4E27","\u65EC","\u953B","\u5784","\u641C","\u6251","\u9080","\u4EAD","\u916F","\u8FC8","\u8212","\u8106","\u9176","\u95F2","\u5FE7","\u915A","\u987D","\u7FBD","\u6DA8","\u5378","\u4ED7","\u966A","\u8F9F","\u60E9","\u676D","\u59DA","\u809A","\u6349","\u98D8","\u6F02","\u6606","\u6B3A","\u543E","\u90CE","\u70F7","\u6C41","\u5475","\u9970","\u8427","\u96C5","\u90AE","\u8FC1","\u71D5","\u6492","\u59FB","\u8D74","\u5BB4","\u70E6","\u503A","\u5E10","\u6591","\u94C3","\u65E8","\u9187","\u8463","\u997C","\u96CF","\u59FF","\u62CC","\u5085","\u8179","\u59A5","\u63C9","\u8D24","\u62C6","\u6B6A","\u8461","\u80FA","\u4E22","\u6D69","\u5FBD","\u6602","\u57AB","\u6321","\u89C8","\u8D2A","\u6170","\u7F34","\u6C6A","\u614C","\u51AF","\u8BFA","\u59DC","\u8C0A","\u51F6","\u52A3","\u8BEC","\u8000","\u660F","\u8EBA","\u76C8","\u9A91","\u4E54","\u6EAA","\u4E1B","\u5362","\u62B9","\u95F7","\u54A8","\u522E","\u9A7E","\u7F06","\u609F","\u6458","\u94D2","\u63B7","\u9887","\u5E7B","\u67C4","\u60E0","\u60E8","\u4F73","\u4EC7","\u814A","\u7A9D","\u6DA4","\u5251","\u77A7","\u5821","\u6CFC","\u8471","\u7F69","\u970D","\u635E","\u80CE","\u82CD","\u6EE8","\u4FE9","\u6345","\u6E58","\u780D","\u971E","\u90B5","\u8404","\u75AF","\u6DEE","\u9042","\u718A","\u7CAA","\u70D8","\u5BBF","\u6863","\u6208","\u9A73","\u5AC2","\u88D5","\u5F99","\u7BAD","\u6350","\u80A0","\u6491","\u6652","\u8FA8","\u6BBF","\u83B2","\u644A","\u6405","\u9171","\u5C4F","\u75AB","\u54C0","\u8521","\u5835","\u6CAB","\u76B1","\u7545","\u53E0","\u9601","\u83B1","\u6572","\u8F96","\u94A9","\u75D5","\u575D","\u5DF7","\u997F","\u7978","\u4E18","\u7384","\u6E9C","\u66F0","\u903B","\u5F6D","\u5C1D","\u537F","\u59A8","\u8247","\u541E","\u97E6","\u6028","\u77EE","\u6B47"]');

});

parcelRegister("eHU63", function(module, exports) {
module.exports = JSON.parse('["\u7684","\u4E00","\u662F","\u5728","\u4E0D","\u4E86","\u6709","\u548C","\u4EBA","\u9019","\u4E2D","\u5927","\u70BA","\u4E0A","\u500B","\u570B","\u6211","\u4EE5","\u8981","\u4ED6","\u6642","\u4F86","\u7528","\u5011","\u751F","\u5230","\u4F5C","\u5730","\u65BC","\u51FA","\u5C31","\u5206","\u5C0D","\u6210","\u6703","\u53EF","\u4E3B","\u767C","\u5E74","\u52D5","\u540C","\u5DE5","\u4E5F","\u80FD","\u4E0B","\u904E","\u5B50","\u8AAA","\u7522","\u7A2E","\u9762","\u800C","\u65B9","\u5F8C","\u591A","\u5B9A","\u884C","\u5B78","\u6CD5","\u6240","\u6C11","\u5F97","\u7D93","\u5341","\u4E09","\u4E4B","\u9032","\u8457","\u7B49","\u90E8","\u5EA6","\u5BB6","\u96FB","\u529B","\u88E1","\u5982","\u6C34","\u5316","\u9AD8","\u81EA","\u4E8C","\u7406","\u8D77","\u5C0F","\u7269","\u73FE","\u5BE6","\u52A0","\u91CF","\u90FD","\u5169","\u9AD4","\u5236","\u6A5F","\u7576","\u4F7F","\u9EDE","\u5F9E","\u696D","\u672C","\u53BB","\u628A","\u6027","\u597D","\u61C9","\u958B","\u5B83","\u5408","\u9084","\u56E0","\u7531","\u5176","\u4E9B","\u7136","\u524D","\u5916","\u5929","\u653F","\u56DB","\u65E5","\u90A3","\u793E","\u7FA9","\u4E8B","\u5E73","\u5F62","\u76F8","\u5168","\u8868","\u9593","\u6A23","\u8207","\u95DC","\u5404","\u91CD","\u65B0","\u7DDA","\u5167","\u6578","\u6B63","\u5FC3","\u53CD","\u4F60","\u660E","\u770B","\u539F","\u53C8","\u9EBC","\u5229","\u6BD4","\u6216","\u4F46","\u8CEA","\u6C23","\u7B2C","\u5411","\u9053","\u547D","\u6B64","\u8B8A","\u689D","\u53EA","\u6C92","\u7D50","\u89E3","\u554F","\u610F","\u5EFA","\u6708","\u516C","\u7121","\u7CFB","\u8ECD","\u5F88","\u60C5","\u8005","\u6700","\u7ACB","\u4EE3","\u60F3","\u5DF2","\u901A","\u4E26","\u63D0","\u76F4","\u984C","\u9EE8","\u7A0B","\u5C55","\u4E94","\u679C","\u6599","\u8C61","\u54E1","\u9769","\u4F4D","\u5165","\u5E38","\u6587","\u7E3D","\u6B21","\u54C1","\u5F0F","\u6D3B","\u8A2D","\u53CA","\u7BA1","\u7279","\u4EF6","\u9577","\u6C42","\u8001","\u982D","\u57FA","\u8CC7","\u908A","\u6D41","\u8DEF","\u7D1A","\u5C11","\u5716","\u5C71","\u7D71","\u63A5","\u77E5","\u8F03","\u5C07","\u7D44","\u898B","\u8A08","\u5225","\u5979","\u624B","\u89D2","\u671F","\u6839","\u8AD6","\u904B","\u8FB2","\u6307","\u5E7E","\u4E5D","\u5340","\u5F37","\u653E","\u6C7A","\u897F","\u88AB","\u5E79","\u505A","\u5FC5","\u6230","\u5148","\u56DE","\u5247","\u4EFB","\u53D6","\u64DA","\u8655","\u968A","\u5357","\u7D66","\u8272","\u5149","\u9580","\u5373","\u4FDD","\u6CBB","\u5317","\u9020","\u767E","\u898F","\u71B1","\u9818","\u4E03","\u6D77","\u53E3","\u6771","\u5C0E","\u5668","\u58D3","\u5FD7","\u4E16","\u91D1","\u589E","\u722D","\u6FDF","\u968E","\u6CB9","\u601D","\u8853","\u6975","\u4EA4","\u53D7","\u806F","\u4EC0","\u8A8D","\u516D","\u5171","\u6B0A","\u6536","\u8B49","\u6539","\u6E05","\u7F8E","\u518D","\u63A1","\u8F49","\u66F4","\u55AE","\u98A8","\u5207","\u6253","\u767D","\u6559","\u901F","\u82B1","\u5E36","\u5B89","\u5834","\u8EAB","\u8ECA","\u4F8B","\u771F","\u52D9","\u5177","\u842C","\u6BCF","\u76EE","\u81F3","\u9054","\u8D70","\u7A4D","\u793A","\u8B70","\u8072","\u5831","\u9B25","\u5B8C","\u985E","\u516B","\u96E2","\u83EF","\u540D","\u78BA","\u624D","\u79D1","\u5F35","\u4FE1","\u99AC","\u7BC0","\u8A71","\u7C73","\u6574","\u7A7A","\u5143","\u6CC1","\u4ECA","\u96C6","\u6EAB","\u50B3","\u571F","\u8A31","\u6B65","\u7FA4","\u5EE3","\u77F3","\u8A18","\u9700","\u6BB5","\u7814","\u754C","\u62C9","\u6797","\u5F8B","\u53EB","\u4E14","\u7A76","\u89C0","\u8D8A","\u7E54","\u88DD","\u5F71","\u7B97","\u4F4E","\u6301","\u97F3","\u773E","\u66F8","\u5E03","\u590D","\u5BB9","\u5152","\u9808","\u969B","\u5546","\u975E","\u9A57","\u9023","\u65B7","\u6DF1","\u96E3","\u8FD1","\u7926","\u5343","\u9031","\u59D4","\u7D20","\u6280","\u5099","\u534A","\u8FA6","\u9752","\u7701","\u5217","\u7FD2","\u97FF","\u7D04","\u652F","\u822C","\u53F2","\u611F","\u52DE","\u4FBF","\u5718","\u5F80","\u9178","\u6B77","\u5E02","\u514B","\u4F55","\u9664","\u6D88","\u69CB","\u5E9C","\u7A31","\u592A","\u6E96","\u7CBE","\u503C","\u865F","\u7387","\u65CF","\u7DAD","\u5283","\u9078","\u6A19","\u5BEB","\u5B58","\u5019","\u6BDB","\u89AA","\u5FEB","\u6548","\u65AF","\u9662","\u67E5","\u6C5F","\u578B","\u773C","\u738B","\u6309","\u683C","\u990A","\u6613","\u7F6E","\u6D3E","\u5C64","\u7247","\u59CB","\u537B","\u5C08","\u72C0","\u80B2","\u5EE0","\u4EAC","\u8B58","\u9069","\u5C6C","\u5713","\u5305","\u706B","\u4F4F","\u8ABF","\u6EFF","\u7E23","\u5C40","\u7167","\u53C3","\u7D05","\u7D30","\u5F15","\u807D","\u8A72","\u9435","\u50F9","\u56B4","\u9996","\u5E95","\u6DB2","\u5B98","\u5FB7","\u96A8","\u75C5","\u8607","\u5931","\u723E","\u6B7B","\u8B1B","\u914D","\u5973","\u9EC3","\u63A8","\u986F","\u8AC7","\u7F6A","\u795E","\u85DD","\u5462","\u5E2D","\u542B","\u4F01","\u671B","\u5BC6","\u6279","\u71DF","\u9805","\u9632","\u8209","\u7403","\u82F1","\u6C27","\u52E2","\u544A","\u674E","\u53F0","\u843D","\u6728","\u5E6B","\u8F2A","\u7834","\u4E9E","\u5E2B","\u570D","\u6CE8","\u9060","\u5B57","\u6750","\u6392","\u4F9B","\u6CB3","\u614B","\u5C01","\u53E6","\u65BD","\u6E1B","\u6A39","\u6EB6","\u600E","\u6B62","\u6848","\u8A00","\u58EB","\u5747","\u6B66","\u56FA","\u8449","\u9B5A","\u6CE2","\u8996","\u50C5","\u8CBB","\u7DCA","\u611B","\u5DE6","\u7AE0","\u65E9","\u671D","\u5BB3","\u7E8C","\u8F15","\u670D","\u8A66","\u98DF","\u5145","\u5175","\u6E90","\u5224","\u8B77","\u53F8","\u8DB3","\u67D0","\u7DF4","\u5DEE","\u81F4","\u677F","\u7530","\u964D","\u9ED1","\u72AF","\u8CA0","\u64CA","\u8303","\u7E7C","\u8208","\u4F3C","\u9918","\u5805","\u66F2","\u8F38","\u4FEE","\u6545","\u57CE","\u592B","\u5920","\u9001","\u7B46","\u8239","\u4F54","\u53F3","\u8CA1","\u5403","\u5BCC","\u6625","\u8077","\u89BA","\u6F22","\u756B","\u529F","\u5DF4","\u8DDF","\u96D6","\u96DC","\u98DB","\u6AA2","\u5438","\u52A9","\u6607","\u967D","\u4E92","\u521D","\u5275","\u6297","\u8003","\u6295","\u58DE","\u7B56","\u53E4","\u5F91","\u63DB","\u672A","\u8DD1","\u7559","\u92FC","\u66FE","\u7AEF","\u8CAC","\u7AD9","\u7C21","\u8FF0","\u9322","\u526F","\u76E1","\u5E1D","\u5C04","\u8349","\u885D","\u627F","\u7368","\u4EE4","\u9650","\u963F","\u5BA3","\u74B0","\u96D9","\u8ACB","\u8D85","\u5FAE","\u8B93","\u63A7","\u5DDE","\u826F","\u8EF8","\u627E","\u5426","\u7D00","\u76CA","\u4F9D","\u512A","\u9802","\u790E","\u8F09","\u5012","\u623F","\u7A81","\u5750","\u7C89","\u6575","\u7565","\u5BA2","\u8881","\u51B7","\u52DD","\u7D55","\u6790","\u584A","\u5291","\u6E2C","\u7D72","\u5354","\u8A34","\u5FF5","\u9673","\u4ECD","\u7F85","\u9E7D","\u53CB","\u6D0B","\u932F","\u82E6","\u591C","\u5211","\u79FB","\u983B","\u9010","\u9760","\u6DF7","\u6BCD","\u77ED","\u76AE","\u7D42","\u805A","\u6C7D","\u6751","\u96F2","\u54EA","\u65E2","\u8DDD","\u885B","\u505C","\u70C8","\u592E","\u5BDF","\u71D2","\u8FC5","\u5883","\u82E5","\u5370","\u6D32","\u523B","\u62EC","\u6FC0","\u5B54","\u641E","\u751A","\u5BA4","\u5F85","\u6838","\u6821","\u6563","\u4FB5","\u5427","\u7532","\u904A","\u4E45","\u83DC","\u5473","\u820A","\u6A21","\u6E56","\u8CA8","\u640D","\u9810","\u963B","\u6BEB","\u666E","\u7A69","\u4E59","\u5ABD","\u690D","\u606F","\u64F4","\u9280","\u8A9E","\u63EE","\u9152","\u5B88","\u62FF","\u5E8F","\u7D19","\u91AB","\u7F3A","\u96E8","\u55CE","\u91DD","\u5289","\u554A","\u6025","\u5531","\u8AA4","\u8A13","\u9858","\u5BE9","\u9644","\u7372","\u8336","\u9BAE","\u7CE7","\u65A4","\u5B69","\u812B","\u786B","\u80A5","\u5584","\u9F8D","\u6F14","\u7236","\u6F38","\u8840","\u6B61","\u68B0","\u638C","\u6B4C","\u6C99","\u525B","\u653B","\u8B02","\u76FE","\u8A0E","\u665A","\u7C92","\u4E82","\u71C3","\u77DB","\u4E4E","\u6BBA","\u85E5","\u5BE7","\u9B6F","\u8CB4","\u9418","\u7164","\u8B80","\u73ED","\u4F2F","\u9999","\u4ECB","\u8FEB","\u53E5","\u8C50","\u57F9","\u63E1","\u862D","\u64D4","\u5F26","\u86CB","\u6C89","\u5047","\u7A7F","\u57F7","\u7B54","\u6A02","\u8AB0","\u9806","\u7159","\u7E2E","\u5FB5","\u81C9","\u559C","\u677E","\u8173","\u56F0","\u7570","\u514D","\u80CC","\u661F","\u798F","\u8CB7","\u67D3","\u4E95","\u6982","\u6162","\u6015","\u78C1","\u500D","\u7956","\u7687","\u4FC3","\u975C","\u88DC","\u8A55","\u7FFB","\u8089","\u8E10","\u5C3C","\u8863","\u5BEC","\u63DA","\u68C9","\u5E0C","\u50B7","\u64CD","\u5782","\u79CB","\u5B9C","\u6C2B","\u5957","\u7763","\u632F","\u67B6","\u4EAE","\u672B","\u61B2","\u6176","\u7DE8","\u725B","\u89F8","\u6620","\u96F7","\u92B7","\u8A69","\u5EA7","\u5C45","\u6293","\u88C2","\u80DE","\u547C","\u5A18","\u666F","\u5A01","\u7DA0","\u6676","\u539A","\u76DF","\u8861","\u96DE","\u5B6B","\u5EF6","\u5371","\u81A0","\u5C4B","\u9109","\u81E8","\u9678","\u9867","\u6389","\u5440","\u71C8","\u6B72","\u63AA","\u675F","\u8010","\u5287","\u7389","\u8D99","\u8DF3","\u54E5","\u5B63","\u8AB2","\u51F1","\u80E1","\u984D","\u6B3E","\u7D39","\u5377","\u9F4A","\u5049","\u84B8","\u6B96","\u6C38","\u5B97","\u82D7","\u5DDD","\u7210","\u5CA9","\u5F31","\u96F6","\u694A","\u594F","\u6CBF","\u9732","\u687F","\u63A2","\u6ED1","\u93AE","\u98EF","\u6FC3","\u822A","\u61F7","\u8D95","\u5EAB","\u596A","\u4F0A","\u9748","\u7A05","\u9014","\u6EC5","\u8CFD","\u6B78","\u53EC","\u9F13","\u64AD","\u76E4","\u88C1","\u96AA","\u5EB7","\u552F","\u9304","\u83CC","\u7D14","\u501F","\u7CD6","\u84CB","\u6A6B","\u7B26","\u79C1","\u52AA","\u5802","\u57DF","\u69CD","\u6F64","\u5E45","\u54C8","\u7ADF","\u719F","\u87F2","\u6FA4","\u8166","\u58E4","\u78B3","\u6B50","\u904D","\u5074","\u5BE8","\u6562","\u5FB9","\u616E","\u659C","\u8584","\u5EAD","\u7D0D","\u5F48","\u98FC","\u4F38","\u6298","\u9EA5","\u6FD5","\u6697","\u8377","\u74E6","\u585E","\u5E8A","\u7BC9","\u60E1","\u6236","\u8A2A","\u5854","\u5947","\u900F","\u6881","\u5200","\u65CB","\u8DE1","\u5361","\u6C2F","\u9047","\u4EFD","\u6BD2","\u6CE5","\u9000","\u6D17","\u64FA","\u7070","\u5F69","\u8CE3","\u8017","\u590F","\u64C7","\u5FD9","\u9285","\u737B","\u786C","\u4E88","\u7E41","\u5708","\u96EA","\u51FD","\u4EA6","\u62BD","\u7BC7","\u9663","\u9670","\u4E01","\u5C3A","\u8FFD","\u5806","\u96C4","\u8FCE","\u6CDB","\u7238","\u6A13","\u907F","\u8B00","\u5678","\u91CE","\u8C6C","\u65D7","\u7D2F","\u504F","\u5178","\u9928","\u7D22","\u79E6","\u8102","\u6F6E","\u723A","\u8C46","\u5FFD","\u6258","\u9A5A","\u5851","\u907A","\u6108","\u6731","\u66FF","\u7E96","\u7C97","\u50BE","\u5C1A","\u75DB","\u695A","\u8B1D","\u596E","\u8CFC","\u78E8","\u541B","\u6C60","\u65C1","\u788E","\u9AA8","\u76E3","\u6355","\u5F1F","\u66B4","\u5272","\u8CAB","\u6B8A","\u91CB","\u8A5E","\u4EA1","\u58C1","\u9813","\u5BF6","\u5348","\u5875","\u805E","\u63ED","\u70AE","\u6B98","\u51AC","\u6A4B","\u5A66","\u8B66","\u7D9C","\u62DB","\u5433","\u4ED8","\u6D6E","\u906D","\u5F90","\u60A8","\u6416","\u8C37","\u8D0A","\u7BB1","\u9694","\u8A02","\u7537","\u5439","\u5712","\u7D1B","\u5510","\u6557","\u5B8B","\u73BB","\u5DE8","\u8015","\u5766","\u69AE","\u9589","\u7063","\u9375","\u51E1","\u99D0","\u934B","\u6551","\u6069","\u525D","\u51DD","\u9E7C","\u9F52","\u622A","\u7149","\u9EBB","\u7D21","\u7981","\u5EE2","\u76DB","\u7248","\u7DE9","\u6DE8","\u775B","\u660C","\u5A5A","\u6D89","\u7B52","\u5634","\u63D2","\u5CB8","\u6717","\u838A","\u8857","\u85CF","\u59D1","\u8CBF","\u8150","\u5974","\u5566","\u6163","\u4E58","\u5925","\u6062","\u52FB","\u7D17","\u624E","\u8FAF","\u8033","\u5F6A","\u81E3","\u5104","\u7483","\u62B5","\u8108","\u79C0","\u85A9","\u4FC4","\u7DB2","\u821E","\u5E97","\u5674","\u7E31","\u5BF8","\u6C57","\u639B","\u6D2A","\u8CC0","\u9583","\u67EC","\u7206","\u70EF","\u6D25","\u7A3B","\u7246","\u8EDF","\u52C7","\u50CF","\u6EFE","\u5398","\u8499","\u82B3","\u80AF","\u5761","\u67F1","\u76EA","\u817F","\u5100","\u65C5","\u5C3E","\u8ECB","\u51B0","\u8CA2","\u767B","\u9ECE","\u524A","\u947D","\u52D2","\u9003","\u969C","\u6C28","\u90ED","\u5CF0","\u5E63","\u6E2F","\u4F0F","\u8ECC","\u755D","\u7562","\u64E6","\u83AB","\u523A","\u6D6A","\u79D8","\u63F4","\u682A","\u5065","\u552E","\u80A1","\u5CF6","\u7518","\u6CE1","\u7761","\u7AE5","\u9444","\u6E6F","\u95A5","\u4F11","\u532F","\u820D","\u7267","\u7E5E","\u70B8","\u54F2","\u78F7","\u7E3E","\u670B","\u6DE1","\u5C16","\u555F","\u9677","\u67F4","\u5448","\u5F92","\u984F","\u6DDA","\u7A0D","\u5FD8","\u6CF5","\u85CD","\u62D6","\u6D1E","\u6388","\u93E1","\u8F9B","\u58EF","\u92D2","\u8CA7","\u865B","\u5F4E","\u6469","\u6CF0","\u5E7C","\u5EF7","\u5C0A","\u7A97","\u7DB1","\u5F04","\u96B8","\u7591","\u6C0F","\u5BAE","\u59D0","\u9707","\u745E","\u602A","\u5C24","\u7434","\u5FAA","\u63CF","\u819C","\u9055","\u593E","\u8170","\u7DE3","\u73E0","\u7AAE","\u68EE","\u679D","\u7AF9","\u6E9D","\u50AC","\u7E69","\u61B6","\u90A6","\u5269","\u5E78","\u6F3F","\u6B04","\u64C1","\u7259","\u8CAF","\u79AE","\u6FFE","\u9209","\u7D0B","\u7F77","\u62CD","\u54B1","\u558A","\u8896","\u57C3","\u52E4","\u7F70","\u7126","\u6F5B","\u4F0D","\u58A8","\u6B32","\u7E2B","\u59D3","\u520A","\u98FD","\u4EFF","\u734E","\u92C1","\u9B3C","\u9E97","\u8DE8","\u9ED8","\u6316","\u93C8","\u6383","\u559D","\u888B","\u70AD","\u6C61","\u5E55","\u8AF8","\u5F27","\u52F5","\u6885","\u5976","\u6F54","\u707D","\u821F","\u9451","\u82EF","\u8A1F","\u62B1","\u6BC0","\u61C2","\u5BD2","\u667A","\u57D4","\u5BC4","\u5C46","\u8E8D","\u6E21","\u6311","\u4E39","\u8271","\u8C9D","\u78B0","\u62D4","\u7239","\u6234","\u78BC","\u5922","\u82BD","\u7194","\u8D64","\u6F01","\u54ED","\u656C","\u9846","\u5954","\u925B","\u4EF2","\u864E","\u7A00","\u59B9","\u4E4F","\u73CD","\u7533","\u684C","\u9075","\u5141","\u9686","\u87BA","\u5009","\u9B4F","\u92B3","\u66C9","\u6C2E","\u517C","\u96B1","\u7919","\u8D6B","\u64A5","\u5FE0","\u8085","\u7F38","\u727D","\u6436","\u535A","\u5DE7","\u6BBC","\u5144","\u675C","\u8A0A","\u8AA0","\u78A7","\u7965","\u67EF","\u9801","\u5DE1","\u77E9","\u60B2","\u704C","\u9F61","\u502B","\u7968","\u5C0B","\u6842","\u92EA","\u8056","\u6050","\u6070","\u912D","\u8DA3","\u62AC","\u8352","\u9A30","\u8CBC","\u67D4","\u6EF4","\u731B","\u95CA","\u8F1B","\u59BB","\u586B","\u64A4","\u5132","\u7C3D","\u9B27","\u64FE","\u7D2B","\u7802","\u905E","\u6232","\u540A","\u9676","\u4F10","\u9935","\u7642","\u74F6","\u5A46","\u64AB","\u81C2","\u6478","\u5FCD","\u8766","\u881F","\u9130","\u80F8","\u978F","\u64E0","\u5076","\u68C4","\u69FD","\u52C1","\u4E73","\u9127","\u5409","\u4EC1","\u721B","\u78DA","\u79DF","\u70CF","\u8266","\u4F34","\u74DC","\u6DFA","\u4E19","\u66AB","\u71E5","\u6A61","\u67F3","\u8FF7","\u6696","\u724C","\u79E7","\u81BD","\u8A73","\u7C27","\u8E0F","\u74F7","\u8B5C","\u5446","\u8CD3","\u7CCA","\u6D1B","\u8F1D","\u61A4","\u7AF6","\u9699","\u6012","\u7C98","\u4E43","\u7DD2","\u80A9","\u7C4D","\u654F","\u5857","\u7199","\u7686","\u5075","\u61F8","\u6398","\u4EAB","\u7CFE","\u9192","\u72C2","\u9396","\u6DC0","\u6068","\u7272","\u9738","\u722C","\u8CDE","\u9006","\u73A9","\u9675","\u795D","\u79D2","\u6D59","\u8C8C","\u5F79","\u5F7C","\u6089","\u9D28","\u8DA8","\u9CF3","\u6668","\u755C","\u8F29","\u79E9","\u5375","\u7F72","\u68AF","\u708E","\u7058","\u68CB","\u9A45","\u7BE9","\u5CFD","\u5192","\u5565","\u58FD","\u8B6F","\u6D78","\u6CC9","\u5E3D","\u9072","\u77FD","\u7586","\u8CB8","\u6F0F","\u7A3F","\u51A0","\u5AE9","\u8105","\u82AF","\u7262","\u53DB","\u8755","\u5967","\u9CF4","\u5DBA","\u7F8A","\u6191","\u4E32","\u5858","\u7E6A","\u9175","\u878D","\u76C6","\u932B","\u5EDF","\u7C4C","\u51CD","\u8F14","\u651D","\u8972","\u7B4B","\u62D2","\u50DA","\u65F1","\u9240","\u9CE5","\u6F06","\u6C88","\u7709","\u758F","\u6DFB","\u68D2","\u7A57","\u785D","\u97D3","\u903C","\u626D","\u50D1","\u6DBC","\u633A","\u7897","\u683D","\u7092","\u676F","\u60A3","\u993E","\u52F8","\u8C6A","\u907C","\u52C3","\u9D3B","\u65E6","\u540F","\u62DC","\u72D7","\u57CB","\u8F25","\u63A9","\u98F2","\u642C","\u7F75","\u8FAD","\u52FE","\u6263","\u4F30","\u8523","\u7D68","\u9727","\u4E08","\u6735","\u59C6","\u64EC","\u5B87","\u8F2F","\u965D","\u96D5","\u511F","\u84C4","\u5D07","\u526A","\u5021","\u5EF3","\u54AC","\u99DB","\u85AF","\u5237","\u65A5","\u756A","\u8CE6","\u5949","\u4F5B","\u6F86","\u6F2B","\u66FC","\u6247","\u9223","\u6843","\u6276","\u4ED4","\u8FD4","\u4FD7","\u8667","\u8154","\u978B","\u68F1","\u8986","\u6846","\u6084","\u53D4","\u649E","\u9A19","\u52D8","\u65FA","\u6CB8","\u5B64","\u5410","\u5B5F","\u6E20","\u5C48","\u75BE","\u5999","\u60DC","\u4EF0","\u72E0","\u8139","\u8AE7","\u62CB","\u9EF4","\u6851","\u5D17","\u561B","\u8870","\u76DC","\u6EF2","\u81DF","\u8CF4","\u6E67","\u751C","\u66F9","\u95B1","\u808C","\u54E9","\u53B2","\u70F4","\u7DEF","\u6BC5","\u6628","\u507D","\u75C7","\u716E","\u5606","\u91D8","\u642D","\u8396","\u7C60","\u9177","\u5077","\u5F13","\u9310","\u6046","\u5091","\u5751","\u9F3B","\u7FFC","\u7DB8","\u6558","\u7344","\u902E","\u7F50","\u7D61","\u68DA","\u6291","\u81A8","\u852C","\u5BFA","\u9A5F","\u7A46","\u51B6","\u67AF","\u518A","\u5C4D","\u51F8","\u7D33","\u576F","\u72A7","\u7130","\u8F5F","\u6B23","\u6649","\u7626","\u79A6","\u9320","\u9326","\u55AA","\u65EC","\u935B","\u58DF","\u641C","\u64B2","\u9080","\u4EAD","\u916F","\u9081","\u8212","\u8106","\u9176","\u9592","\u6182","\u915A","\u9811","\u7FBD","\u6F32","\u5378","\u4ED7","\u966A","\u95E2","\u61F2","\u676D","\u59DA","\u809A","\u6349","\u98C4","\u6F02","\u6606","\u6B3A","\u543E","\u90CE","\u70F7","\u6C41","\u5475","\u98FE","\u856D","\u96C5","\u90F5","\u9077","\u71D5","\u6492","\u59FB","\u8D74","\u5BB4","\u7169","\u50B5","\u5E33","\u6591","\u9234","\u65E8","\u9187","\u8463","\u9905","\u96DB","\u59FF","\u62CC","\u5085","\u8179","\u59A5","\u63C9","\u8CE2","\u62C6","\u6B6A","\u8461","\u80FA","\u4E1F","\u6D69","\u5FBD","\u6602","\u588A","\u64CB","\u89BD","\u8CAA","\u6170","\u7E73","\u6C6A","\u614C","\u99AE","\u8AFE","\u59DC","\u8ABC","\u5147","\u52A3","\u8AA3","\u8000","\u660F","\u8EBA","\u76C8","\u9A0E","\u55AC","\u6EAA","\u53E2","\u76E7","\u62B9","\u60B6","\u8AEE","\u522E","\u99D5","\u7E9C","\u609F","\u6458","\u927A","\u64F2","\u9817","\u5E7B","\u67C4","\u60E0","\u6158","\u4F73","\u4EC7","\u81D8","\u7AA9","\u6ECC","\u528D","\u77A7","\u5821","\u6F51","\u8525","\u7F69","\u970D","\u6488","\u80CE","\u84BC","\u6FF1","\u5006","\u6345","\u6E58","\u780D","\u971E","\u90B5","\u8404","\u760B","\u6DEE","\u9042","\u718A","\u7CDE","\u70D8","\u5BBF","\u6A94","\u6208","\u99C1","\u5AC2","\u88D5","\u5F99","\u7BAD","\u6350","\u8178","\u6490","\u66EC","\u8FA8","\u6BBF","\u84EE","\u6524","\u652A","\u91AC","\u5C4F","\u75AB","\u54C0","\u8521","\u5835","\u6CAB","\u76BA","\u66A2","\u758A","\u95A3","\u840A","\u6572","\u8F44","\u9264","\u75D5","\u58E9","\u5DF7","\u9913","\u798D","\u4E18","\u7384","\u6E9C","\u66F0","\u908F","\u5F6D","\u5617","\u537F","\u59A8","\u8247","\u541E","\u97CB","\u6028","\u77EE","\u6B47"]');

});

parcelRegister("ctxcO", function(module, exports) {
module.exports = JSON.parse('["\u1100\u1161\u1100\u1167\u11A8","\u1100\u1161\u1101\u1173\u11B7","\u1100\u1161\u1102\u1161\u11AB","\u1100\u1161\u1102\u1173\u11BC","\u1100\u1161\u1103\u1173\u11A8","\u1100\u1161\u1105\u1173\u110E\u1175\u11B7","\u1100\u1161\u1106\u116E\u11B7","\u1100\u1161\u1107\u1161\u11BC","\u1100\u1161\u1109\u1161\u11BC","\u1100\u1161\u1109\u1173\u11B7","\u1100\u1161\u110B\u116E\u11AB\u1103\u1166","\u1100\u1161\u110B\u1173\u11AF","\u1100\u1161\u110B\u1175\u1103\u1173","\u1100\u1161\u110B\u1175\u11B8","\u1100\u1161\u110C\u1161\u11BC","\u1100\u1161\u110C\u1165\u11BC","\u1100\u1161\u110C\u1169\u11A8","\u1100\u1161\u110C\u116E\u11A8","\u1100\u1161\u11A8\u110B\u1169","\u1100\u1161\u11A8\u110C\u1161","\u1100\u1161\u11AB\u1100\u1167\u11A8","\u1100\u1161\u11AB\u1107\u116E","\u1100\u1161\u11AB\u1109\u1165\u11B8","\u1100\u1161\u11AB\u110C\u1161\u11BC","\u1100\u1161\u11AB\u110C\u1165\u11B8","\u1100\u1161\u11AB\u1111\u1161\u11AB","\u1100\u1161\u11AF\u1103\u1173\u11BC","\u1100\u1161\u11AF\u1107\u1175","\u1100\u1161\u11AF\u1109\u1162\u11A8","\u1100\u1161\u11AF\u110C\u1173\u11BC","\u1100\u1161\u11B7\u1100\u1161\u11A8","\u1100\u1161\u11B7\u1100\u1175","\u1100\u1161\u11B7\u1109\u1169","\u1100\u1161\u11B7\u1109\u116E\u1109\u1165\u11BC","\u1100\u1161\u11B7\u110C\u1161","\u1100\u1161\u11B7\u110C\u1165\u11BC","\u1100\u1161\u11B8\u110C\u1161\u1100\u1175","\u1100\u1161\u11BC\u1102\u1161\u11B7","\u1100\u1161\u11BC\u1103\u1161\u11BC","\u1100\u1161\u11BC\u1103\u1169","\u1100\u1161\u11BC\u1105\u1167\u11A8\u1112\u1175","\u1100\u1161\u11BC\u1107\u1167\u11AB","\u1100\u1161\u11BC\u1107\u116E\u11A8","\u1100\u1161\u11BC\u1109\u1161","\u1100\u1161\u11BC\u1109\u116E\u1105\u1163\u11BC","\u1100\u1161\u11BC\u110B\u1161\u110C\u1175","\u1100\u1161\u11BC\u110B\u116F\u11AB\u1103\u1169","\u1100\u1161\u11BC\u110B\u1174","\u1100\u1161\u11BC\u110C\u1166","\u1100\u1161\u11BC\u110C\u1169","\u1100\u1161\u11C0\u110B\u1175","\u1100\u1162\u1100\u116E\u1105\u1175","\u1100\u1162\u1102\u1161\u1105\u1175","\u1100\u1162\u1107\u1161\u11BC","\u1100\u1162\u1107\u1167\u11AF","\u1100\u1162\u1109\u1165\u11AB","\u1100\u1162\u1109\u1165\u11BC","\u1100\u1162\u110B\u1175\u11AB","\u1100\u1162\u11A8\u1100\u116A\u11AB\u110C\u1165\u11A8","\u1100\u1165\u1109\u1175\u11AF","\u1100\u1165\u110B\u1162\u11A8","\u1100\u1165\u110B\u116E\u11AF","\u1100\u1165\u110C\u1175\u11BA","\u1100\u1165\u1111\u116E\u11B7","\u1100\u1165\u11A8\u110C\u1165\u11BC","\u1100\u1165\u11AB\u1100\u1161\u11BC","\u1100\u1165\u11AB\u1106\u116E\u11AF","\u1100\u1165\u11AB\u1109\u1165\u11AF","\u1100\u1165\u11AB\u110C\u1169","\u1100\u1165\u11AB\u110E\u116E\u11A8","\u1100\u1165\u11AF\u110B\u1173\u11B7","\u1100\u1165\u11B7\u1109\u1161","\u1100\u1165\u11B7\u1110\u1169","\u1100\u1166\u1109\u1175\u1111\u1161\u11AB","\u1100\u1166\u110B\u1175\u11B7","\u1100\u1167\u110B\u116E\u11AF","\u1100\u1167\u11AB\u1112\u1162","\u1100\u1167\u11AF\u1100\u116A","\u1100\u1167\u11AF\u1100\u116E\u11A8","\u1100\u1167\u11AF\u1105\u1169\u11AB","\u1100\u1167\u11AF\u1109\u1165\u11A8","\u1100\u1167\u11AF\u1109\u1173\u11BC","\u1100\u1167\u11AF\u1109\u1175\u11B7","\u1100\u1167\u11AF\u110C\u1165\u11BC","\u1100\u1167\u11AF\u1112\u1169\u11AB","\u1100\u1167\u11BC\u1100\u1168","\u1100\u1167\u11BC\u1100\u1169","\u1100\u1167\u11BC\u1100\u1175","\u1100\u1167\u11BC\u1105\u1167\u11A8","\u1100\u1167\u11BC\u1107\u1169\u11A8\u1100\u116E\u11BC","\u1100\u1167\u11BC\u1107\u1175","\u1100\u1167\u11BC\u1109\u1161\u11BC\u1103\u1169","\u1100\u1167\u11BC\u110B\u1167\u11BC","\u1100\u1167\u11BC\u110B\u116E","\u1100\u1167\u11BC\u110C\u1162\u11BC","\u1100\u1167\u11BC\u110C\u1166","\u1100\u1167\u11BC\u110C\u116E","\u1100\u1167\u11BC\u110E\u1161\u11AF","\u1100\u1167\u11BC\u110E\u1175","\u1100\u1167\u11BC\u1112\u1163\u11BC","\u1100\u1167\u11BC\u1112\u1165\u11B7","\u1100\u1168\u1100\u1169\u11A8","\u1100\u1168\u1103\u1161\u11AB","\u1100\u1168\u1105\u1161\u11AB","\u1100\u1168\u1109\u1161\u11AB","\u1100\u1168\u1109\u1169\u11A8","\u1100\u1168\u110B\u1163\u11A8","\u1100\u1168\u110C\u1165\u11AF","\u1100\u1168\u110E\u1173\u11BC","\u1100\u1168\u1112\u116C\u11A8","\u1100\u1169\u1100\u1162\u11A8","\u1100\u1169\u1100\u116E\u1105\u1167","\u1100\u1169\u1100\u116E\u11BC","\u1100\u1169\u1100\u1173\u11B8","\u1100\u1169\u1103\u1173\u11BC\u1112\u1161\u11A8\u1109\u1162\u11BC","\u1100\u1169\u1106\u116E\u1109\u1175\u11AB","\u1100\u1169\u1106\u1175\u11AB","\u1100\u1169\u110B\u1163\u11BC\u110B\u1175","\u1100\u1169\u110C\u1161\u11BC","\u1100\u1169\u110C\u1165\u11AB","\u1100\u1169\u110C\u1175\u11B8","\u1100\u1169\u110E\u116E\u11BA\u1100\u1161\u1105\u116E","\u1100\u1169\u1110\u1169\u11BC","\u1100\u1169\u1112\u1163\u11BC","\u1100\u1169\u11A8\u1109\u1175\u11A8","\u1100\u1169\u11AF\u1106\u1169\u11A8","\u1100\u1169\u11AF\u110D\u1161\u1100\u1175","\u1100\u1169\u11AF\u1111\u1173","\u1100\u1169\u11BC\u1100\u1161\u11AB","\u1100\u1169\u11BC\u1100\u1162","\u1100\u1169\u11BC\u1100\u1167\u11A8","\u1100\u1169\u11BC\u1100\u116E\u11AB","\u1100\u1169\u11BC\u1100\u1173\u11B8","\u1100\u1169\u11BC\u1100\u1175","\u1100\u1169\u11BC\u1103\u1169\u11BC","\u1100\u1169\u11BC\u1106\u116E\u110B\u116F\u11AB","\u1100\u1169\u11BC\u1107\u116E","\u1100\u1169\u11BC\u1109\u1161","\u1100\u1169\u11BC\u1109\u1175\u11A8","\u1100\u1169\u11BC\u110B\u1165\u11B8","\u1100\u1169\u11BC\u110B\u1167\u11AB","\u1100\u1169\u11BC\u110B\u116F\u11AB","\u1100\u1169\u11BC\u110C\u1161\u11BC","\u1100\u1169\u11BC\u110D\u1161","\u1100\u1169\u11BC\u110E\u1162\u11A8","\u1100\u1169\u11BC\u1110\u1169\u11BC","\u1100\u1169\u11BC\u1111\u1169","\u1100\u1169\u11BC\u1112\u1161\u11BC","\u1100\u1169\u11BC\u1112\u1172\u110B\u1175\u11AF","\u1100\u116A\u1106\u1169\u11A8","\u1100\u116A\u110B\u1175\u11AF","\u1100\u116A\u110C\u1161\u11BC","\u1100\u116A\u110C\u1165\u11BC","\u1100\u116A\u1112\u1161\u11A8","\u1100\u116A\u11AB\u1100\u1162\u11A8","\u1100\u116A\u11AB\u1100\u1168","\u1100\u116A\u11AB\u1100\u116A\u11BC","\u1100\u116A\u11AB\u1102\u1167\u11B7","\u1100\u116A\u11AB\u1105\u1161\u11B7","\u1100\u116A\u11AB\u1105\u1167\u11AB","\u1100\u116A\u11AB\u1105\u1175","\u1100\u116A\u11AB\u1109\u1173\u11B8","\u1100\u116A\u11AB\u1109\u1175\u11B7","\u1100\u116A\u11AB\u110C\u1165\u11B7","\u1100\u116A\u11AB\u110E\u1161\u11AF","\u1100\u116A\u11BC\u1100\u1167\u11BC","\u1100\u116A\u11BC\u1100\u1169","\u1100\u116A\u11BC\u110C\u1161\u11BC","\u1100\u116A\u11BC\u110C\u116E","\u1100\u116C\u1105\u1169\u110B\u116E\u11B7","\u1100\u116C\u11BC\u110C\u1161\u11BC\u1112\u1175","\u1100\u116D\u1100\u116A\u1109\u1165","\u1100\u116D\u1106\u116E\u11AB","\u1100\u116D\u1107\u1169\u11A8","\u1100\u116D\u1109\u1175\u11AF","\u1100\u116D\u110B\u1163\u11BC","\u1100\u116D\u110B\u1172\u11A8","\u1100\u116D\u110C\u1161\u11BC","\u1100\u116D\u110C\u1175\u11A8","\u1100\u116D\u1110\u1169\u11BC","\u1100\u116D\u1112\u116A\u11AB","\u1100\u116D\u1112\u116E\u11AB","\u1100\u116E\u1100\u1167\u11BC","\u1100\u116E\u1105\u1173\u11B7","\u1100\u116E\u1106\u1165\u11BC","\u1100\u116E\u1107\u1167\u11AF","\u1100\u116E\u1107\u116E\u11AB","\u1100\u116E\u1109\u1165\u11A8","\u1100\u116E\u1109\u1165\u11BC","\u1100\u116E\u1109\u1169\u11A8","\u1100\u116E\u110B\u1167\u11A8","\u1100\u116E\u110B\u1175\u11B8","\u1100\u116E\u110E\u1165\u11BC","\u1100\u116E\u110E\u1166\u110C\u1165\u11A8","\u1100\u116E\u11A8\u1100\u1161","\u1100\u116E\u11A8\u1100\u1175","\u1100\u116E\u11A8\u1102\u1162","\u1100\u116E\u11A8\u1105\u1175\u11B8","\u1100\u116E\u11A8\u1106\u116E\u11AF","\u1100\u116E\u11A8\u1106\u1175\u11AB","\u1100\u116E\u11A8\u1109\u116E","\u1100\u116E\u11A8\u110B\u1165","\u1100\u116E\u11A8\u110B\u116A\u11BC","\u1100\u116E\u11A8\u110C\u1165\u11A8","\u1100\u116E\u11A8\u110C\u1166","\u1100\u116E\u11A8\u1112\u116C","\u1100\u116E\u11AB\u1103\u1162","\u1100\u116E\u11AB\u1109\u1161","\u1100\u116E\u11AB\u110B\u1175\u11AB","\u1100\u116E\u11BC\u1100\u1173\u11A8\u110C\u1165\u11A8","\u1100\u116F\u11AB\u1105\u1175","\u1100\u116F\u11AB\u110B\u1171","\u1100\u116F\u11AB\u1110\u116E","\u1100\u1171\u1100\u116E\u11A8","\u1100\u1171\u1109\u1175\u11AB","\u1100\u1172\u110C\u1165\u11BC","\u1100\u1172\u110E\u1175\u11A8","\u1100\u1172\u11AB\u1112\u1167\u11BC","\u1100\u1173\u1102\u1161\u11AF","\u1100\u1173\u1102\u1163\u11BC","\u1100\u1173\u1102\u1173\u11AF","\u1100\u1173\u1105\u1165\u1102\u1161","\u1100\u1173\u1105\u116E\u11B8","\u1100\u1173\u1105\u1173\u11BA","\u1100\u1173\u1105\u1175\u11B7","\u1100\u1173\u110C\u1166\u1109\u1165\u110B\u1163","\u1100\u1173\u1110\u1169\u1105\u1169\u11A8","\u1100\u1173\u11A8\u1107\u1169\u11A8","\u1100\u1173\u11A8\u1112\u1175","\u1100\u1173\u11AB\u1100\u1165","\u1100\u1173\u11AB\u1100\u116D","\u1100\u1173\u11AB\u1105\u1162","\u1100\u1173\u11AB\u1105\u1169","\u1100\u1173\u11AB\u1106\u116E","\u1100\u1173\u11AB\u1107\u1169\u11AB","\u1100\u1173\u11AB\u110B\u116F\u11AB","\u1100\u1173\u11AB\u110B\u1172\u11A8","\u1100\u1173\u11AB\u110E\u1165","\u1100\u1173\u11AF\u110A\u1175","\u1100\u1173\u11AF\u110C\u1161","\u1100\u1173\u11B7\u1100\u1161\u11BC\u1109\u1161\u11AB","\u1100\u1173\u11B7\u1100\u1169","\u1100\u1173\u11B7\u1102\u1167\u11AB","\u1100\u1173\u11B7\u1106\u1166\u1103\u1161\u11AF","\u1100\u1173\u11B7\u110B\u1162\u11A8","\u1100\u1173\u11B7\u110B\u1167\u11AB","\u1100\u1173\u11B7\u110B\u116D\u110B\u1175\u11AF","\u1100\u1173\u11B7\u110C\u1175","\u1100\u1173\u11BC\u110C\u1165\u11BC\u110C\u1165\u11A8","\u1100\u1175\u1100\u1161\u11AB","\u1100\u1175\u1100\u116A\u11AB","\u1100\u1175\u1102\u1167\u11B7","\u1100\u1175\u1102\u1173\u11BC","\u1100\u1175\u1103\u1169\u11A8\u1100\u116D","\u1100\u1175\u1103\u116E\u11BC","\u1100\u1175\u1105\u1169\u11A8","\u1100\u1175\u1105\u1173\u11B7","\u1100\u1175\u1107\u1165\u11B8","\u1100\u1175\u1107\u1169\u11AB","\u1100\u1175\u1107\u116E\u11AB","\u1100\u1175\u1108\u1173\u11B7","\u1100\u1175\u1109\u116E\u11A8\u1109\u1161","\u1100\u1175\u1109\u116E\u11AF","\u1100\u1175\u110B\u1165\u11A8","\u1100\u1175\u110B\u1165\u11B8","\u1100\u1175\u110B\u1169\u11AB","\u1100\u1175\u110B\u116E\u11AB","\u1100\u1175\u110B\u116F\u11AB","\u1100\u1175\u110C\u1165\u11A8","\u1100\u1175\u110C\u116E\u11AB","\u1100\u1175\u110E\u1175\u11B7","\u1100\u1175\u1112\u1169\u11AB","\u1100\u1175\u1112\u116C\u11A8","\u1100\u1175\u11AB\u1100\u1173\u11B8","\u1100\u1175\u11AB\u110C\u1161\u11BC","\u1100\u1175\u11AF\u110B\u1175","\u1100\u1175\u11B7\u1107\u1161\u11B8","\u1100\u1175\u11B7\u110E\u1175","\u1100\u1175\u11B7\u1111\u1169\u1100\u1169\u11BC\u1112\u1161\u11BC","\u1101\u1161\u11A8\u1103\u116E\u1100\u1175","\u1101\u1161\u11B7\u1108\u1161\u11A8","\u1101\u1162\u1103\u1161\u11AF\u110B\u1173\u11B7","\u1101\u1162\u1109\u1169\u1100\u1173\u11B7","\u1101\u1165\u11B8\u110C\u1175\u11AF","\u1101\u1169\u11A8\u1103\u1162\u1100\u1175","\u1101\u1169\u11BE\u110B\u1175\u11C1","\u1102\u1161\u1103\u1173\u11AF\u110B\u1175","\u1102\u1161\u1105\u1161\u11AB\u1112\u1175","\u1102\u1161\u1106\u1165\u110C\u1175","\u1102\u1161\u1106\u116E\u11AF","\u1102\u1161\u110E\u1175\u11B7\u1107\u1161\u11AB","\u1102\u1161\u1112\u1173\u11AF","\u1102\u1161\u11A8\u110B\u1167\u11B8","\u1102\u1161\u11AB\u1107\u1161\u11BC","\u1102\u1161\u11AF\u1100\u1162","\u1102\u1161\u11AF\u110A\u1175","\u1102\u1161\u11AF\u110D\u1161","\u1102\u1161\u11B7\u1102\u1167","\u1102\u1161\u11B7\u1103\u1162\u1106\u116E\u11AB","\u1102\u1161\u11B7\u1106\u1162","\u1102\u1161\u11B7\u1109\u1161\u11AB","\u1102\u1161\u11B7\u110C\u1161","\u1102\u1161\u11B7\u1111\u1167\u11AB","\u1102\u1161\u11B7\u1112\u1161\u11A8\u1109\u1162\u11BC","\u1102\u1161\u11BC\u1107\u1175","\u1102\u1161\u11C0\u1106\u1161\u11AF","\u1102\u1162\u1102\u1167\u11AB","\u1102\u1162\u110B\u116D\u11BC","\u1102\u1162\u110B\u1175\u11AF","\u1102\u1162\u11B7\u1107\u1175","\u1102\u1162\u11B7\u1109\u1162","\u1102\u1162\u11BA\u1106\u116E\u11AF","\u1102\u1162\u11BC\u1103\u1169\u11BC","\u1102\u1162\u11BC\u1106\u1167\u11AB","\u1102\u1162\u11BC\u1107\u1161\u11BC","\u1102\u1162\u11BC\u110C\u1161\u11BC\u1100\u1169","\u1102\u1166\u11A8\u1110\u1161\u110B\u1175","\u1102\u1166\u11BA\u110D\u1162","\u1102\u1169\u1103\u1169\u11BC","\u1102\u1169\u1105\u1161\u11AB\u1109\u1162\u11A8","\u1102\u1169\u1105\u1167\u11A8","\u1102\u1169\u110B\u1175\u11AB","\u1102\u1169\u11A8\u110B\u1173\u11B7","\u1102\u1169\u11A8\u110E\u1161","\u1102\u1169\u11A8\u1112\u116A","\u1102\u1169\u11AB\u1105\u1175","\u1102\u1169\u11AB\u1106\u116E\u11AB","\u1102\u1169\u11AB\u110C\u1162\u11BC","\u1102\u1169\u11AF\u110B\u1175","\u1102\u1169\u11BC\u1100\u116E","\u1102\u1169\u11BC\u1103\u1161\u11B7","\u1102\u1169\u11BC\u1106\u1175\u11AB","\u1102\u1169\u11BC\u1107\u116E","\u1102\u1169\u11BC\u110B\u1165\u11B8","\u1102\u1169\u11BC\u110C\u1161\u11BC","\u1102\u1169\u11BC\u110E\u1169\u11AB","\u1102\u1169\u11C1\u110B\u1175","\u1102\u116E\u11AB\u1103\u1169\u11BC\u110C\u1161","\u1102\u116E\u11AB\u1106\u116E\u11AF","\u1102\u116E\u11AB\u110A\u1165\u11B8","\u1102\u1172\u110B\u116D\u11A8","\u1102\u1173\u1101\u1175\u11B7","\u1102\u1173\u11A8\u1103\u1162","\u1102\u1173\u11BC\u1103\u1169\u11BC\u110C\u1165\u11A8","\u1102\u1173\u11BC\u1105\u1167\u11A8","\u1103\u1161\u1107\u1161\u11BC","\u1103\u1161\u110B\u1163\u11BC\u1109\u1165\u11BC","\u1103\u1161\u110B\u1173\u11B7","\u1103\u1161\u110B\u1175\u110B\u1165\u1110\u1173","\u1103\u1161\u1112\u1162\u11BC","\u1103\u1161\u11AB\u1100\u1168","\u1103\u1161\u11AB\u1100\u1169\u11AF","\u1103\u1161\u11AB\u1103\u1169\u11A8","\u1103\u1161\u11AB\u1106\u1161\u11BA","\u1103\u1161\u11AB\u1109\u116E\u11AB","\u1103\u1161\u11AB\u110B\u1165","\u1103\u1161\u11AB\u110B\u1171","\u1103\u1161\u11AB\u110C\u1165\u11B7","\u1103\u1161\u11AB\u110E\u1166","\u1103\u1161\u11AB\u110E\u116E","\u1103\u1161\u11AB\u1111\u1167\u11AB","\u1103\u1161\u11AB\u1111\u116E\u11BC","\u1103\u1161\u11AF\u1100\u1163\u11AF","\u1103\u1161\u11AF\u1105\u1165","\u1103\u1161\u11AF\u1105\u1167\u11A8","\u1103\u1161\u11AF\u1105\u1175","\u1103\u1161\u11B0\u1100\u1169\u1100\u1175","\u1103\u1161\u11B7\u1103\u1161\u11BC","\u1103\u1161\u11B7\u1107\u1162","\u1103\u1161\u11B7\u110B\u116D","\u1103\u1161\u11B7\u110B\u1175\u11B7","\u1103\u1161\u11B8\u1107\u1167\u11AB","\u1103\u1161\u11B8\u110C\u1161\u11BC","\u1103\u1161\u11BC\u1100\u1173\u11AB","\u1103\u1161\u11BC\u1107\u116E\u11AB\u1100\u1161\u11AB","\u1103\u1161\u11BC\u110B\u1167\u11AB\u1112\u1175","\u1103\u1161\u11BC\u110C\u1161\u11BC","\u1103\u1162\u1100\u1172\u1106\u1169","\u1103\u1162\u1102\u1161\u11BD","\u1103\u1162\u1103\u1161\u11AB\u1112\u1175","\u1103\u1162\u1103\u1161\u11B8","\u1103\u1162\u1103\u1169\u1109\u1175","\u1103\u1162\u1105\u1163\u11A8","\u1103\u1162\u1105\u1163\u11BC","\u1103\u1162\u1105\u1172\u11A8","\u1103\u1162\u1106\u116E\u11AB","\u1103\u1162\u1107\u116E\u1107\u116E\u11AB","\u1103\u1162\u1109\u1175\u11AB","\u1103\u1162\u110B\u1173\u11BC","\u1103\u1162\u110C\u1161\u11BC","\u1103\u1162\u110C\u1165\u11AB","\u1103\u1162\u110C\u1165\u11B8","\u1103\u1162\u110C\u116E\u11BC","\u1103\u1162\u110E\u1162\u11A8","\u1103\u1162\u110E\u116E\u11AF","\u1103\u1162\u110E\u116E\u11BC","\u1103\u1162\u1110\u1169\u11BC\u1105\u1167\u11BC","\u1103\u1162\u1112\u1161\u11A8","\u1103\u1162\u1112\u1161\u11AB\u1106\u1175\u11AB\u1100\u116E\u11A8","\u1103\u1162\u1112\u1161\u11B8\u1109\u1175\u11AF","\u1103\u1162\u1112\u1167\u11BC","\u1103\u1165\u11BC\u110B\u1165\u1105\u1175","\u1103\u1166\u110B\u1175\u1110\u1173","\u1103\u1169\u1103\u1162\u110E\u1166","\u1103\u1169\u1103\u1165\u11A8","\u1103\u1169\u1103\u116E\u11A8","\u1103\u1169\u1106\u1161\u11BC","\u1103\u1169\u1109\u1165\u1100\u116A\u11AB","\u1103\u1169\u1109\u1175\u11B7","\u1103\u1169\u110B\u116E\u11B7","\u1103\u1169\u110B\u1175\u11B8","\u1103\u1169\u110C\u1161\u1100\u1175","\u1103\u1169\u110C\u1165\u1112\u1175","\u1103\u1169\u110C\u1165\u11AB","\u1103\u1169\u110C\u116E\u11BC","\u1103\u1169\u110E\u1161\u11A8","\u1103\u1169\u11A8\u1100\u1161\u11B7","\u1103\u1169\u11A8\u1105\u1175\u11B8","\u1103\u1169\u11A8\u1109\u1165","\u1103\u1169\u11A8\u110B\u1175\u11AF","\u1103\u1169\u11A8\u110E\u1161\u11BC\u110C\u1165\u11A8","\u1103\u1169\u11BC\u1112\u116A\u110E\u1162\u11A8","\u1103\u1171\u11BA\u1106\u1169\u1109\u1173\u11B8","\u1103\u1171\u11BA\u1109\u1161\u11AB","\u1104\u1161\u11AF\u110B\u1161\u110B\u1175","\u1106\u1161\u1102\u116E\u1105\u1161","\u1106\u1161\u1102\u1173\u11AF","\u1106\u1161\u1103\u1161\u11BC","\u1106\u1161\u1105\u1161\u1110\u1169\u11AB","\u1106\u1161\u1105\u1167\u11AB","\u1106\u1161\u1106\u116E\u1105\u1175","\u1106\u1161\u1109\u1161\u110C\u1175","\u1106\u1161\u110B\u1163\u11A8","\u1106\u1161\u110B\u116D\u1102\u1166\u110C\u1173","\u1106\u1161\u110B\u1173\u11AF","\u1106\u1161\u110B\u1173\u11B7","\u1106\u1161\u110B\u1175\u110F\u1173","\u1106\u1161\u110C\u116E\u11BC","\u1106\u1161\u110C\u1175\u1106\u1161\u11A8","\u1106\u1161\u110E\u1161\u11AB\u1100\u1161\u110C\u1175","\u1106\u1161\u110E\u1161\u11AF","\u1106\u1161\u1112\u1173\u11AB","\u1106\u1161\u11A8\u1100\u1165\u11AF\u1105\u1175","\u1106\u1161\u11A8\u1102\u1162","\u1106\u1161\u11A8\u1109\u1161\u11BC","\u1106\u1161\u11AB\u1102\u1161\u11B7","\u1106\u1161\u11AB\u1103\u116E","\u1106\u1161\u11AB\u1109\u1166","\u1106\u1161\u11AB\u110B\u1163\u11A8","\u1106\u1161\u11AB\u110B\u1175\u11AF","\u1106\u1161\u11AB\u110C\u1165\u11B7","\u1106\u1161\u11AB\u110C\u1169\u11A8","\u1106\u1161\u11AB\u1112\u116A","\u1106\u1161\u11AD\u110B\u1175","\u1106\u1161\u11AF\u1100\u1175","\u1106\u1161\u11AF\u110A\u1173\u11B7","\u1106\u1161\u11AF\u1110\u116E","\u1106\u1161\u11B7\u1103\u1162\u1105\u1169","\u1106\u1161\u11BC\u110B\u116F\u11AB\u1100\u1167\u11BC","\u1106\u1162\u1102\u1167\u11AB","\u1106\u1162\u1103\u1161\u11AF","\u1106\u1162\u1105\u1167\u11A8","\u1106\u1162\u1107\u1165\u11AB","\u1106\u1162\u1109\u1173\u110F\u1165\u11B7","\u1106\u1162\u110B\u1175\u11AF","\u1106\u1162\u110C\u1161\u11BC","\u1106\u1162\u11A8\u110C\u116E","\u1106\u1165\u11A8\u110B\u1175","\u1106\u1165\u11AB\u110C\u1165","\u1106\u1165\u11AB\u110C\u1175","\u1106\u1165\u11AF\u1105\u1175","\u1106\u1166\u110B\u1175\u11AF","\u1106\u1167\u1102\u1173\u1105\u1175","\u1106\u1167\u110E\u1175\u11AF","\u1106\u1167\u11AB\u1103\u1161\u11B7","\u1106\u1167\u11AF\u110E\u1175","\u1106\u1167\u11BC\u1103\u1161\u11AB","\u1106\u1167\u11BC\u1105\u1167\u11BC","\u1106\u1167\u11BC\u110B\u1168","\u1106\u1167\u11BC\u110B\u1174","\u1106\u1167\u11BC\u110C\u1165\u11AF","\u1106\u1167\u11BC\u110E\u1175\u11BC","\u1106\u1167\u11BC\u1112\u1161\u11B7","\u1106\u1169\u1100\u1173\u11B7","\u1106\u1169\u1102\u1175\u1110\u1165","\u1106\u1169\u1103\u1166\u11AF","\u1106\u1169\u1103\u1173\u11AB","\u1106\u1169\u1107\u1165\u11B7","\u1106\u1169\u1109\u1173\u11B8","\u1106\u1169\u110B\u1163\u11BC","\u1106\u1169\u110B\u1175\u11B7","\u1106\u1169\u110C\u1169\u1105\u1175","\u1106\u1169\u110C\u1175\u11B8","\u1106\u1169\u1110\u116E\u11BC\u110B\u1175","\u1106\u1169\u11A8\u1100\u1165\u11AF\u110B\u1175","\u1106\u1169\u11A8\u1105\u1169\u11A8","\u1106\u1169\u11A8\u1109\u1161","\u1106\u1169\u11A8\u1109\u1169\u1105\u1175","\u1106\u1169\u11A8\u1109\u116E\u11B7","\u1106\u1169\u11A8\u110C\u1165\u11A8","\u1106\u1169\u11A8\u1111\u116D","\u1106\u1169\u11AF\u1105\u1162","\u1106\u1169\u11B7\u1106\u1162","\u1106\u1169\u11B7\u1106\u116E\u1100\u1166","\u1106\u1169\u11B7\u1109\u1161\u11AF","\u1106\u1169\u11B7\u1109\u1169\u11A8","\u1106\u1169\u11B7\u110C\u1175\u11BA","\u1106\u1169\u11B7\u1110\u1169\u11BC","\u1106\u1169\u11B8\u1109\u1175","\u1106\u116E\u1100\u116A\u11AB\u1109\u1175\u11B7","\u1106\u116E\u1100\u116E\u11BC\u1112\u116A","\u1106\u116E\u1103\u1165\u110B\u1171","\u1106\u116E\u1103\u1165\u11B7","\u1106\u116E\u1105\u1173\u11C1","\u1106\u116E\u1109\u1173\u11AB","\u1106\u116E\u110B\u1165\u11BA","\u1106\u116E\u110B\u1167\u11A8","\u1106\u116E\u110B\u116D\u11BC","\u1106\u116E\u110C\u1169\u1100\u1165\u11AB","\u1106\u116E\u110C\u1175\u1100\u1162","\u1106\u116E\u110E\u1165\u11A8","\u1106\u116E\u11AB\u1100\u116E","\u1106\u116E\u11AB\u1103\u1173\u11A8","\u1106\u116E\u11AB\u1107\u1165\u11B8","\u1106\u116E\u11AB\u1109\u1165","\u1106\u116E\u11AB\u110C\u1166","\u1106\u116E\u11AB\u1112\u1161\u11A8","\u1106\u116E\u11AB\u1112\u116A","\u1106\u116E\u11AF\u1100\u1161","\u1106\u116E\u11AF\u1100\u1165\u11AB","\u1106\u116E\u11AF\u1100\u1167\u11AF","\u1106\u116E\u11AF\u1100\u1169\u1100\u1175","\u1106\u116E\u11AF\u1105\u1169\u11AB","\u1106\u116E\u11AF\u1105\u1175\u1112\u1161\u11A8","\u1106\u116E\u11AF\u110B\u1173\u11B7","\u1106\u116E\u11AF\u110C\u1175\u11AF","\u1106\u116E\u11AF\u110E\u1166","\u1106\u1175\u1100\u116E\u11A8","\u1106\u1175\u1103\u1175\u110B\u1165","\u1106\u1175\u1109\u1161\u110B\u1175\u11AF","\u1106\u1175\u1109\u116E\u11AF","\u1106\u1175\u110B\u1167\u11A8","\u1106\u1175\u110B\u116D\u11BC\u1109\u1175\u11AF","\u1106\u1175\u110B\u116E\u11B7","\u1106\u1175\u110B\u1175\u11AB","\u1106\u1175\u1110\u1175\u11BC","\u1106\u1175\u1112\u1169\u11AB","\u1106\u1175\u11AB\u1100\u1161\u11AB","\u1106\u1175\u11AB\u110C\u1169\u11A8","\u1106\u1175\u11AB\u110C\u116E","\u1106\u1175\u11AE\u110B\u1173\u11B7","\u1106\u1175\u11AF\u1100\u1161\u1105\u116E","\u1106\u1175\u11AF\u1105\u1175\u1106\u1175\u1110\u1165","\u1106\u1175\u11C0\u1107\u1161\u1103\u1161\u11A8","\u1107\u1161\u1100\u1161\u110C\u1175","\u1107\u1161\u1100\u116E\u1102\u1175","\u1107\u1161\u1102\u1161\u1102\u1161","\u1107\u1161\u1102\u1173\u11AF","\u1107\u1161\u1103\u1161\u11A8","\u1107\u1161\u1103\u1161\u11BA\u1100\u1161","\u1107\u1161\u1105\u1161\u11B7","\u1107\u1161\u110B\u1175\u1105\u1165\u1109\u1173","\u1107\u1161\u1110\u1161\u11BC","\u1107\u1161\u11A8\u1106\u116E\u11AF\u1100\u116A\u11AB","\u1107\u1161\u11A8\u1109\u1161","\u1107\u1161\u11A8\u1109\u116E","\u1107\u1161\u11AB\u1103\u1162","\u1107\u1161\u11AB\u1103\u1173\u1109\u1175","\u1107\u1161\u11AB\u1106\u1161\u11AF","\u1107\u1161\u11AB\u1107\u1161\u11AF","\u1107\u1161\u11AB\u1109\u1165\u11BC","\u1107\u1161\u11AB\u110B\u1173\u11BC","\u1107\u1161\u11AB\u110C\u1161\u11BC","\u1107\u1161\u11AB\u110C\u116E\u11A8","\u1107\u1161\u11AB\u110C\u1175","\u1107\u1161\u11AB\u110E\u1161\u11AB","\u1107\u1161\u11AE\u110E\u1175\u11B7","\u1107\u1161\u11AF\u1100\u1161\u1105\u1161\u11A8","\u1107\u1161\u11AF\u1100\u1165\u11AF\u110B\u1173\u11B7","\u1107\u1161\u11AF\u1100\u1167\u11AB","\u1107\u1161\u11AF\u1103\u1161\u11AF","\u1107\u1161\u11AF\u1105\u1166","\u1107\u1161\u11AF\u1106\u1169\u11A8","\u1107\u1161\u11AF\u1107\u1161\u1103\u1161\u11A8","\u1107\u1161\u11AF\u1109\u1162\u11BC","\u1107\u1161\u11AF\u110B\u1173\u11B7","\u1107\u1161\u11AF\u110C\u1161\u1100\u116E\u11A8","\u1107\u1161\u11AF\u110C\u1165\u11AB","\u1107\u1161\u11AF\u1110\u1169\u11B8","\u1107\u1161\u11AF\u1111\u116D","\u1107\u1161\u11B7\u1112\u1161\u1102\u1173\u11AF","\u1107\u1161\u11B8\u1100\u1173\u1105\u1173\u11BA","\u1107\u1161\u11B8\u1106\u1161\u11BA","\u1107\u1161\u11B8\u1109\u1161\u11BC","\u1107\u1161\u11B8\u1109\u1169\u11C0","\u1107\u1161\u11BC\u1100\u1173\u11B7","\u1107\u1161\u11BC\u1106\u1167\u11AB","\u1107\u1161\u11BC\u1106\u116E\u11AB","\u1107\u1161\u11BC\u1107\u1161\u1103\u1161\u11A8","\u1107\u1161\u11BC\u1107\u1165\u11B8","\u1107\u1161\u11BC\u1109\u1169\u11BC","\u1107\u1161\u11BC\u1109\u1175\u11A8","\u1107\u1161\u11BC\u110B\u1161\u11AB","\u1107\u1161\u11BC\u110B\u116E\u11AF","\u1107\u1161\u11BC\u110C\u1175","\u1107\u1161\u11BC\u1112\u1161\u11A8","\u1107\u1161\u11BC\u1112\u1162","\u1107\u1161\u11BC\u1112\u1163\u11BC","\u1107\u1162\u1100\u1167\u11BC","\u1107\u1162\u1101\u1169\u11B8","\u1107\u1162\u1103\u1161\u11AF","\u1107\u1162\u1103\u1173\u1106\u1175\u11AB\u1110\u1165\u11AB","\u1107\u1162\u11A8\u1103\u116E\u1109\u1161\u11AB","\u1107\u1162\u11A8\u1109\u1162\u11A8","\u1107\u1162\u11A8\u1109\u1165\u11BC","\u1107\u1162\u11A8\u110B\u1175\u11AB","\u1107\u1162\u11A8\u110C\u1166","\u1107\u1162\u11A8\u1112\u116A\u110C\u1165\u11B7","\u1107\u1165\u1105\u1173\u11BA","\u1107\u1165\u1109\u1165\u11BA","\u1107\u1165\u1110\u1173\u11AB","\u1107\u1165\u11AB\u1100\u1162","\u1107\u1165\u11AB\u110B\u1167\u11A8","\u1107\u1165\u11AB\u110C\u1175","\u1107\u1165\u11AB\u1112\u1169","\u1107\u1165\u11AF\u1100\u1173\u11B7","\u1107\u1165\u11AF\u1105\u1166","\u1107\u1165\u11AF\u110A\u1165","\u1107\u1165\u11B7\u110B\u1171","\u1107\u1165\u11B7\u110B\u1175\u11AB","\u1107\u1165\u11B7\u110C\u116C","\u1107\u1165\u11B8\u1105\u1172\u11AF","\u1107\u1165\u11B8\u110B\u116F\u11AB","\u1107\u1165\u11B8\u110C\u1165\u11A8","\u1107\u1165\u11B8\u110E\u1175\u11A8","\u1107\u1166\u110B\u1175\u110C\u1175\u11BC","\u1107\u1166\u11AF\u1110\u1173","\u1107\u1167\u11AB\u1100\u1167\u11BC","\u1107\u1167\u11AB\u1103\u1169\u11BC","\u1107\u1167\u11AB\u1106\u1167\u11BC","\u1107\u1167\u11AB\u1109\u1175\u11AB","\u1107\u1167\u11AB\u1112\u1169\u1109\u1161","\u1107\u1167\u11AB\u1112\u116A","\u1107\u1167\u11AF\u1103\u1169","\u1107\u1167\u11AF\u1106\u1167\u11BC","\u1107\u1167\u11AF\u110B\u1175\u11AF","\u1107\u1167\u11BC\u1109\u1175\u11AF","\u1107\u1167\u11BC\u110B\u1161\u1105\u1175","\u1107\u1167\u11BC\u110B\u116F\u11AB","\u1107\u1169\u1100\u116A\u11AB","\u1107\u1169\u1102\u1165\u1109\u1173","\u1107\u1169\u1105\u1161\u1109\u1162\u11A8","\u1107\u1169\u1105\u1161\u11B7","\u1107\u1169\u1105\u1173\u11B7","\u1107\u1169\u1109\u1161\u11BC","\u1107\u1169\u110B\u1161\u11AB","\u1107\u1169\u110C\u1161\u1100\u1175","\u1107\u1169\u110C\u1161\u11BC","\u1107\u1169\u110C\u1165\u11AB","\u1107\u1169\u110C\u1169\u11AB","\u1107\u1169\u1110\u1169\u11BC","\u1107\u1169\u1111\u1167\u11AB\u110C\u1165\u11A8","\u1107\u1169\u1112\u1165\u11B7","\u1107\u1169\u11A8\u1103\u1169","\u1107\u1169\u11A8\u1109\u1161","\u1107\u1169\u11A8\u1109\u116E\u11BC\u110B\u1161","\u1107\u1169\u11A8\u1109\u1173\u11B8","\u1107\u1169\u11A9\u110B\u1173\u11B7","\u1107\u1169\u11AB\u1100\u1167\u11A8\u110C\u1165\u11A8","\u1107\u1169\u11AB\u1105\u1162","\u1107\u1169\u11AB\u1107\u116E","\u1107\u1169\u11AB\u1109\u1161","\u1107\u1169\u11AB\u1109\u1165\u11BC","\u1107\u1169\u11AB\u110B\u1175\u11AB","\u1107\u1169\u11AB\u110C\u1175\u11AF","\u1107\u1169\u11AF\u1111\u1166\u11AB","\u1107\u1169\u11BC\u1109\u1161","\u1107\u1169\u11BC\u110C\u1175","\u1107\u1169\u11BC\u1110\u116E","\u1107\u116E\u1100\u1173\u11AB","\u1107\u116E\u1101\u1173\u1105\u1165\u110B\u116E\u11B7","\u1107\u116E\u1103\u1161\u11B7","\u1107\u116E\u1103\u1169\u11BC\u1109\u1161\u11AB","\u1107\u116E\u1106\u116E\u11AB","\u1107\u116E\u1107\u116E\u11AB","\u1107\u116E\u1109\u1161\u11AB","\u1107\u116E\u1109\u1161\u11BC","\u1107\u116E\u110B\u1165\u11BF","\u1107\u116E\u110B\u1175\u11AB","\u1107\u116E\u110C\u1161\u11A8\u110B\u116D\u11BC","\u1107\u116E\u110C\u1161\u11BC","\u1107\u116E\u110C\u1165\u11BC","\u1107\u116E\u110C\u1169\u11A8","\u1107\u116E\u110C\u1175\u1105\u1165\u11AB\u1112\u1175","\u1107\u116E\u110E\u1175\u11AB","\u1107\u116E\u1110\u1161\u11A8","\u1107\u116E\u1111\u116E\u11B7","\u1107\u116E\u1112\u116C\u110C\u1161\u11BC","\u1107\u116E\u11A8\u1107\u116E","\u1107\u116E\u11A8\u1112\u1161\u11AB","\u1107\u116E\u11AB\u1102\u1169","\u1107\u116E\u11AB\u1105\u1163\u11BC","\u1107\u116E\u11AB\u1105\u1175","\u1107\u116E\u11AB\u1106\u1167\u11BC","\u1107\u116E\u11AB\u1109\u1165\u11A8","\u1107\u116E\u11AB\u110B\u1163","\u1107\u116E\u11AB\u110B\u1171\u1100\u1175","\u1107\u116E\u11AB\u1111\u1175\u11AF","\u1107\u116E\u11AB\u1112\u1169\u11BC\u1109\u1162\u11A8","\u1107\u116E\u11AF\u1100\u1169\u1100\u1175","\u1107\u116E\u11AF\u1100\u116A","\u1107\u116E\u11AF\u1100\u116D","\u1107\u116E\u11AF\u1101\u1169\u11BE","\u1107\u116E\u11AF\u1106\u1161\u11AB","\u1107\u116E\u11AF\u1107\u1165\u11B8","\u1107\u116E\u11AF\u1107\u1175\u11BE","\u1107\u116E\u11AF\u110B\u1161\u11AB","\u1107\u116E\u11AF\u110B\u1175\u110B\u1175\u11A8","\u1107\u116E\u11AF\u1112\u1162\u11BC","\u1107\u1173\u1105\u1162\u11AB\u1103\u1173","\u1107\u1175\u1100\u1173\u11A8","\u1107\u1175\u1102\u1161\u11AB","\u1107\u1175\u1102\u1175\u11AF","\u1107\u1175\u1103\u116E\u11AF\u1100\u1175","\u1107\u1175\u1103\u1175\u110B\u1169","\u1107\u1175\u1105\u1169\u1109\u1169","\u1107\u1175\u1106\u1161\u11AB","\u1107\u1175\u1106\u1167\u11BC","\u1107\u1175\u1106\u1175\u11AF","\u1107\u1175\u1107\u1161\u1105\u1161\u11B7","\u1107\u1175\u1107\u1175\u11B7\u1107\u1161\u11B8","\u1107\u1175\u1109\u1161\u11BC","\u1107\u1175\u110B\u116D\u11BC","\u1107\u1175\u110B\u1172\u11AF","\u1107\u1175\u110C\u116E\u11BC","\u1107\u1175\u1110\u1161\u1106\u1175\u11AB","\u1107\u1175\u1111\u1161\u11AB","\u1107\u1175\u11AF\u1103\u1175\u11BC","\u1107\u1175\u11BA\u1106\u116E\u11AF","\u1107\u1175\u11BA\u1107\u1161\u11BC\u110B\u116E\u11AF","\u1107\u1175\u11BA\u110C\u116E\u11AF\u1100\u1175","\u1107\u1175\u11BE\u1101\u1161\u11AF","\u1108\u1161\u11AF\u1100\u1161\u11AB\u1109\u1162\u11A8","\u1108\u1161\u11AF\u1105\u1162","\u1108\u1161\u11AF\u1105\u1175","\u1109\u1161\u1100\u1165\u11AB","\u1109\u1161\u1100\u1168\u110C\u1165\u11AF","\u1109\u1161\u1102\u1161\u110B\u1175","\u1109\u1161\u1102\u1163\u11BC","\u1109\u1161\u1105\u1161\u11B7","\u1109\u1161\u1105\u1161\u11BC","\u1109\u1161\u1105\u1175\u11B8","\u1109\u1161\u1106\u1169\u1102\u1175\u11B7","\u1109\u1161\u1106\u116E\u11AF","\u1109\u1161\u1107\u1161\u11BC","\u1109\u1161\u1109\u1161\u11BC","\u1109\u1161\u1109\u1162\u11BC\u1112\u116A\u11AF","\u1109\u1161\u1109\u1165\u11AF","\u1109\u1161\u1109\u1173\u11B7","\u1109\u1161\u1109\u1175\u11AF","\u1109\u1161\u110B\u1165\u11B8","\u1109\u1161\u110B\u116D\u11BC","\u1109\u1161\u110B\u116F\u11AF","\u1109\u1161\u110C\u1161\u11BC","\u1109\u1161\u110C\u1165\u11AB","\u1109\u1161\u110C\u1175\u11AB","\u1109\u1161\u110E\u1169\u11AB","\u1109\u1161\u110E\u116E\u11AB\u1100\u1175","\u1109\u1161\u1110\u1161\u11BC","\u1109\u1161\u1110\u116E\u1105\u1175","\u1109\u1161\u1112\u1173\u11AF","\u1109\u1161\u11AB\u1100\u1175\u11AF","\u1109\u1161\u11AB\u1107\u116E\u110B\u1175\u11AB\u1100\u116A","\u1109\u1161\u11AB\u110B\u1165\u11B8","\u1109\u1161\u11AB\u110E\u1162\u11A8","\u1109\u1161\u11AF\u1105\u1175\u11B7","\u1109\u1161\u11AF\u110B\u1175\u11AB","\u1109\u1161\u11AF\u110D\u1161\u11A8","\u1109\u1161\u11B7\u1100\u1168\u1110\u1161\u11BC","\u1109\u1161\u11B7\u1100\u116E\u11A8","\u1109\u1161\u11B7\u1109\u1175\u11B8","\u1109\u1161\u11B7\u110B\u116F\u11AF","\u1109\u1161\u11B7\u110E\u1169\u11AB","\u1109\u1161\u11BC\u1100\u116A\u11AB","\u1109\u1161\u11BC\u1100\u1173\u11B7","\u1109\u1161\u11BC\u1103\u1162","\u1109\u1161\u11BC\u1105\u1172","\u1109\u1161\u11BC\u1107\u1161\u11AB\u1100\u1175","\u1109\u1161\u11BC\u1109\u1161\u11BC","\u1109\u1161\u11BC\u1109\u1175\u11A8","\u1109\u1161\u11BC\u110B\u1165\u11B8","\u1109\u1161\u11BC\u110B\u1175\u11AB","\u1109\u1161\u11BC\u110C\u1161","\u1109\u1161\u11BC\u110C\u1165\u11B7","\u1109\u1161\u11BC\u110E\u1165","\u1109\u1161\u11BC\u110E\u116E","\u1109\u1161\u11BC\u1110\u1162","\u1109\u1161\u11BC\u1111\u116D","\u1109\u1161\u11BC\u1111\u116E\u11B7","\u1109\u1161\u11BC\u1112\u116A\u11BC","\u1109\u1162\u1107\u1167\u11A8","\u1109\u1162\u11A8\u1101\u1161\u11AF","\u1109\u1162\u11A8\u110B\u1167\u11AB\u1111\u1175\u11AF","\u1109\u1162\u11BC\u1100\u1161\u11A8","\u1109\u1162\u11BC\u1106\u1167\u11BC","\u1109\u1162\u11BC\u1106\u116E\u11AF","\u1109\u1162\u11BC\u1107\u1161\u11BC\u1109\u1169\u11BC","\u1109\u1162\u11BC\u1109\u1161\u11AB","\u1109\u1162\u11BC\u1109\u1165\u11AB","\u1109\u1162\u11BC\u1109\u1175\u11AB","\u1109\u1162\u11BC\u110B\u1175\u11AF","\u1109\u1162\u11BC\u1112\u116A\u11AF","\u1109\u1165\u1105\u1161\u11B8","\u1109\u1165\u1105\u1173\u11AB","\u1109\u1165\u1106\u1167\u11BC","\u1109\u1165\u1106\u1175\u11AB","\u1109\u1165\u1107\u1175\u1109\u1173","\u1109\u1165\u110B\u1163\u11BC","\u1109\u1165\u110B\u116E\u11AF","\u1109\u1165\u110C\u1165\u11A8","\u1109\u1165\u110C\u1165\u11B7","\u1109\u1165\u110D\u1169\u11A8","\u1109\u1165\u110F\u1173\u11AF","\u1109\u1165\u11A8\u1109\u1161","\u1109\u1165\u11A8\u110B\u1172","\u1109\u1165\u11AB\u1100\u1165","\u1109\u1165\u11AB\u1106\u116E\u11AF","\u1109\u1165\u11AB\u1107\u1162","\u1109\u1165\u11AB\u1109\u1162\u11BC","\u1109\u1165\u11AB\u1109\u116E","\u1109\u1165\u11AB\u110B\u116F\u11AB","\u1109\u1165\u11AB\u110C\u1161\u11BC","\u1109\u1165\u11AB\u110C\u1165\u11AB","\u1109\u1165\u11AB\u1110\u1162\u11A8","\u1109\u1165\u11AB\u1111\u116E\u11BC\u1100\u1175","\u1109\u1165\u11AF\u1100\u1165\u110C\u1175","\u1109\u1165\u11AF\u1102\u1161\u11AF","\u1109\u1165\u11AF\u1105\u1165\u11BC\u1110\u1161\u11BC","\u1109\u1165\u11AF\u1106\u1167\u11BC","\u1109\u1165\u11AF\u1106\u116E\u11AB","\u1109\u1165\u11AF\u1109\u1161","\u1109\u1165\u11AF\u110B\u1161\u11A8\u1109\u1161\u11AB","\u1109\u1165\u11AF\u110E\u1175","\u1109\u1165\u11AF\u1110\u1161\u11BC","\u1109\u1165\u11B8\u110A\u1175","\u1109\u1165\u11BC\u1100\u1169\u11BC","\u1109\u1165\u11BC\u1103\u1161\u11BC","\u1109\u1165\u11BC\u1106\u1167\u11BC","\u1109\u1165\u11BC\u1107\u1167\u11AF","\u1109\u1165\u11BC\u110B\u1175\u11AB","\u1109\u1165\u11BC\u110C\u1161\u11BC","\u1109\u1165\u11BC\u110C\u1165\u11A8","\u1109\u1165\u11BC\u110C\u1175\u11AF","\u1109\u1165\u11BC\u1112\u1161\u11B7","\u1109\u1166\u1100\u1173\u11B7","\u1109\u1166\u1106\u1175\u1102\u1161","\u1109\u1166\u1109\u1161\u11BC","\u1109\u1166\u110B\u116F\u11AF","\u1109\u1166\u110C\u1169\u11BC\u1103\u1162\u110B\u116A\u11BC","\u1109\u1166\u1110\u1161\u11A8","\u1109\u1166\u11AB\u1110\u1165","\u1109\u1166\u11AB\u1110\u1175\u1106\u1175\u1110\u1165","\u1109\u1166\u11BA\u110D\u1162","\u1109\u1169\u1100\u1172\u1106\u1169","\u1109\u1169\u1100\u1173\u11A8\u110C\u1165\u11A8","\u1109\u1169\u1100\u1173\u11B7","\u1109\u1169\u1102\u1161\u1100\u1175","\u1109\u1169\u1102\u1167\u11AB","\u1109\u1169\u1103\u1173\u11A8","\u1109\u1169\u1106\u1161\u11BC","\u1109\u1169\u1106\u116E\u11AB","\u1109\u1169\u1109\u1165\u11AF","\u1109\u1169\u1109\u1169\u11A8","\u1109\u1169\u110B\u1161\u1100\u116A","\u1109\u1169\u110B\u116D\u11BC","\u1109\u1169\u110B\u116F\u11AB","\u1109\u1169\u110B\u1173\u11B7","\u1109\u1169\u110C\u116E\u11BC\u1112\u1175","\u1109\u1169\u110C\u1175\u1111\u116E\u11B7","\u1109\u1169\u110C\u1175\u11AF","\u1109\u1169\u1111\u116E\u11BC","\u1109\u1169\u1112\u1167\u11BC","\u1109\u1169\u11A8\u1103\u1161\u11B7","\u1109\u1169\u11A8\u1103\u1169","\u1109\u1169\u11A8\u110B\u1169\u11BA","\u1109\u1169\u11AB\u1100\u1161\u1105\u1161\u11A8","\u1109\u1169\u11AB\u1100\u1175\u11AF","\u1109\u1169\u11AB\u1102\u1167","\u1109\u1169\u11AB\u1102\u1175\u11B7","\u1109\u1169\u11AB\u1103\u1173\u11BC","\u1109\u1169\u11AB\u1106\u1169\u11A8","\u1109\u1169\u11AB\u1108\u1167\u11A8","\u1109\u1169\u11AB\u1109\u1175\u11AF","\u1109\u1169\u11AB\u110C\u1175\u11AF","\u1109\u1169\u11AB\u1110\u1169\u11B8","\u1109\u1169\u11AB\u1112\u1162","\u1109\u1169\u11AF\u110C\u1175\u11A8\u1112\u1175","\u1109\u1169\u11B7\u110A\u1175","\u1109\u1169\u11BC\u110B\u1161\u110C\u1175","\u1109\u1169\u11BC\u110B\u1175","\u1109\u1169\u11BC\u1111\u1167\u11AB","\u1109\u116C\u1100\u1169\u1100\u1175","\u1109\u116D\u1111\u1175\u11BC","\u1109\u116E\u1100\u1165\u11AB","\u1109\u116E\u1102\u1167\u11AB","\u1109\u116E\u1103\u1161\u11AB","\u1109\u116E\u1103\u1169\u11BA\u1106\u116E\u11AF","\u1109\u116E\u1103\u1169\u11BC\u110C\u1165\u11A8","\u1109\u116E\u1106\u1167\u11AB","\u1109\u116E\u1106\u1167\u11BC","\u1109\u116E\u1107\u1161\u11A8","\u1109\u116E\u1109\u1161\u11BC","\u1109\u116E\u1109\u1165\u11A8","\u1109\u116E\u1109\u116E\u11AF","\u1109\u116E\u1109\u1175\u1105\u1169","\u1109\u116E\u110B\u1165\u11B8","\u1109\u116E\u110B\u1167\u11B7","\u1109\u116E\u110B\u1167\u11BC","\u1109\u116E\u110B\u1175\u11B8","\u1109\u116E\u110C\u116E\u11AB","\u1109\u116E\u110C\u1175\u11B8","\u1109\u116E\u110E\u116E\u11AF","\u1109\u116E\u110F\u1165\u11BA","\u1109\u116E\u1111\u1175\u11AF","\u1109\u116E\u1112\u1161\u11A8","\u1109\u116E\u1112\u1165\u11B7\u1109\u1162\u11BC","\u1109\u116E\u1112\u116A\u1100\u1175","\u1109\u116E\u11A8\u1102\u1167","\u1109\u116E\u11A8\u1109\u1169","\u1109\u116E\u11A8\u110C\u1166","\u1109\u116E\u11AB\u1100\u1161\u11AB","\u1109\u116E\u11AB\u1109\u1165","\u1109\u116E\u11AB\u1109\u116E","\u1109\u116E\u11AB\u1109\u1175\u11A8\u1100\u1161\u11AB","\u1109\u116E\u11AB\u110B\u1171","\u1109\u116E\u11AE\u1100\u1161\u1105\u1161\u11A8","\u1109\u116E\u11AF\u1107\u1167\u11BC","\u1109\u116E\u11AF\u110C\u1175\u11B8","\u1109\u116E\u11BA\u110C\u1161","\u1109\u1173\u1102\u1175\u11B7","\u1109\u1173\u1106\u116E\u11AF","\u1109\u1173\u1109\u1173\u1105\u1169","\u1109\u1173\u1109\u1173\u11BC","\u1109\u1173\u110B\u1170\u1110\u1165","\u1109\u1173\u110B\u1171\u110E\u1175","\u1109\u1173\u110F\u1166\u110B\u1175\u1110\u1173","\u1109\u1173\u1110\u1172\u1103\u1175\u110B\u1169","\u1109\u1173\u1110\u1173\u1105\u1166\u1109\u1173","\u1109\u1173\u1111\u1169\u110E\u1173","\u1109\u1173\u11AF\u110D\u1165\u11A8","\u1109\u1173\u11AF\u1111\u1173\u11B7","\u1109\u1173\u11B8\u1100\u116A\u11AB","\u1109\u1173\u11B8\u1100\u1175","\u1109\u1173\u11BC\u1100\u1162\u11A8","\u1109\u1173\u11BC\u1105\u1175","\u1109\u1173\u11BC\u1107\u116E","\u1109\u1173\u11BC\u110B\u116D\u11BC\u110E\u1161","\u1109\u1173\u11BC\u110C\u1175\u11AB","\u1109\u1175\u1100\u1161\u11A8","\u1109\u1175\u1100\u1161\u11AB","\u1109\u1175\u1100\u1169\u11AF","\u1109\u1175\u1100\u1173\u11B7\u110E\u1175","\u1109\u1175\u1102\u1161\u1105\u1175\u110B\u1169","\u1109\u1175\u1103\u1162\u11A8","\u1109\u1175\u1105\u1175\u110C\u1173","\u1109\u1175\u1106\u1166\u11AB\u1110\u1173","\u1109\u1175\u1106\u1175\u11AB","\u1109\u1175\u1107\u116E\u1106\u1169","\u1109\u1175\u1109\u1165\u11AB","\u1109\u1175\u1109\u1165\u11AF","\u1109\u1175\u1109\u1173\u1110\u1166\u11B7","\u1109\u1175\u110B\u1161\u1107\u1165\u110C\u1175","\u1109\u1175\u110B\u1165\u1106\u1165\u1102\u1175","\u1109\u1175\u110B\u116F\u11AF","\u1109\u1175\u110B\u1175\u11AB","\u1109\u1175\u110B\u1175\u11AF","\u1109\u1175\u110C\u1161\u11A8","\u1109\u1175\u110C\u1161\u11BC","\u1109\u1175\u110C\u1165\u11AF","\u1109\u1175\u110C\u1165\u11B7","\u1109\u1175\u110C\u116E\u11BC","\u1109\u1175\u110C\u1173\u11AB","\u1109\u1175\u110C\u1175\u11B8","\u1109\u1175\u110E\u1165\u11BC","\u1109\u1175\u1112\u1161\u11B8","\u1109\u1175\u1112\u1165\u11B7","\u1109\u1175\u11A8\u1100\u116E","\u1109\u1175\u11A8\u1100\u1175","\u1109\u1175\u11A8\u1103\u1161\u11BC","\u1109\u1175\u11A8\u1105\u1163\u11BC","\u1109\u1175\u11A8\u1105\u116D\u1111\u116E\u11B7","\u1109\u1175\u11A8\u1106\u116E\u11AF","\u1109\u1175\u11A8\u1108\u1161\u11BC","\u1109\u1175\u11A8\u1109\u1161","\u1109\u1175\u11A8\u1109\u1162\u11BC\u1112\u116A\u11AF","\u1109\u1175\u11A8\u110E\u1169","\u1109\u1175\u11A8\u1110\u1161\u11A8","\u1109\u1175\u11A8\u1111\u116E\u11B7","\u1109\u1175\u11AB\u1100\u1169","\u1109\u1175\u11AB\u1100\u1172","\u1109\u1175\u11AB\u1102\u1167\u11B7","\u1109\u1175\u11AB\u1106\u116E\u11AB","\u1109\u1175\u11AB\u1107\u1161\u11AF","\u1109\u1175\u11AB\u1107\u1175","\u1109\u1175\u11AB\u1109\u1161","\u1109\u1175\u11AB\u1109\u1166","\u1109\u1175\u11AB\u110B\u116D\u11BC","\u1109\u1175\u11AB\u110C\u1166\u1111\u116E\u11B7","\u1109\u1175\u11AB\u110E\u1165\u11BC","\u1109\u1175\u11AB\u110E\u1166","\u1109\u1175\u11AB\u1112\u116A","\u1109\u1175\u11AF\u1100\u1161\u11B7","\u1109\u1175\u11AF\u1102\u1162","\u1109\u1175\u11AF\u1105\u1167\u11A8","\u1109\u1175\u11AF\u1105\u1168","\u1109\u1175\u11AF\u1106\u1161\u11BC","\u1109\u1175\u11AF\u1109\u116E","\u1109\u1175\u11AF\u1109\u1173\u11B8","\u1109\u1175\u11AF\u1109\u1175","\u1109\u1175\u11AF\u110C\u1161\u11BC","\u1109\u1175\u11AF\u110C\u1165\u11BC","\u1109\u1175\u11AF\u110C\u1175\u11AF\u110C\u1165\u11A8","\u1109\u1175\u11AF\u110E\u1165\u11AB","\u1109\u1175\u11AF\u110E\u1166","\u1109\u1175\u11AF\u110F\u1165\u11BA","\u1109\u1175\u11AF\u1110\u1162","\u1109\u1175\u11AF\u1111\u1162","\u1109\u1175\u11AF\u1112\u1165\u11B7","\u1109\u1175\u11AF\u1112\u1167\u11AB","\u1109\u1175\u11B7\u1105\u1175","\u1109\u1175\u11B7\u1107\u116E\u1105\u1173\u11B7","\u1109\u1175\u11B7\u1109\u1161","\u1109\u1175\u11B7\u110C\u1161\u11BC","\u1109\u1175\u11B7\u110C\u1165\u11BC","\u1109\u1175\u11B7\u1111\u1161\u11AB","\u110A\u1161\u11BC\u1103\u116E\u11BC\u110B\u1175","\u110A\u1175\u1105\u1173\u11B7","\u110A\u1175\u110B\u1161\u11BA","\u110B\u1161\u1100\u1161\u110A\u1175","\u110B\u1161\u1102\u1161\u110B\u116E\u11AB\u1109\u1165","\u110B\u1161\u1103\u1173\u1102\u1175\u11B7","\u110B\u1161\u1103\u1173\u11AF","\u110B\u1161\u1109\u1171\u110B\u116E\u11B7","\u110B\u1161\u1109\u1173\u1111\u1161\u11AF\u1110\u1173","\u110B\u1161\u1109\u1175\u110B\u1161","\u110B\u1161\u110B\u116E\u11AF\u1105\u1165","\u110B\u1161\u110C\u1165\u110A\u1175","\u110B\u1161\u110C\u116E\u11B7\u1106\u1161","\u110B\u1161\u110C\u1175\u11A8","\u110B\u1161\u110E\u1175\u11B7","\u110B\u1161\u1111\u1161\u1110\u1173","\u110B\u1161\u1111\u1173\u1105\u1175\u110F\u1161","\u110B\u1161\u1111\u1173\u11B7","\u110B\u1161\u1112\u1169\u11B8","\u110B\u1161\u1112\u1173\u11AB","\u110B\u1161\u11A8\u1100\u1175","\u110B\u1161\u11A8\u1106\u1169\u11BC","\u110B\u1161\u11A8\u1109\u116E","\u110B\u1161\u11AB\u1100\u1162","\u110B\u1161\u11AB\u1100\u1167\u11BC","\u110B\u1161\u11AB\u1100\u116A","\u110B\u1161\u11AB\u1102\u1162","\u110B\u1161\u11AB\u1102\u1167\u11BC","\u110B\u1161\u11AB\u1103\u1169\u11BC","\u110B\u1161\u11AB\u1107\u1161\u11BC","\u110B\u1161\u11AB\u1107\u116E","\u110B\u1161\u11AB\u110C\u116E","\u110B\u1161\u11AF\u1105\u116E\u1106\u1175\u1102\u1172\u11B7","\u110B\u1161\u11AF\u110F\u1169\u110B\u1169\u11AF","\u110B\u1161\u11B7\u1109\u1175","\u110B\u1161\u11B7\u110F\u1165\u11BA","\u110B\u1161\u11B8\u1105\u1167\u11A8","\u110B\u1161\u11C1\u1102\u1161\u11AF","\u110B\u1161\u11C1\u1106\u116E\u11AB","\u110B\u1162\u110B\u1175\u11AB","\u110B\u1162\u110C\u1165\u11BC","\u110B\u1162\u11A8\u1109\u116E","\u110B\u1162\u11AF\u1107\u1165\u11B7","\u110B\u1163\u1100\u1161\u11AB","\u110B\u1163\u1103\u1161\u11AB","\u110B\u1163\u110B\u1169\u11BC","\u110B\u1163\u11A8\u1100\u1161\u11AB","\u110B\u1163\u11A8\u1100\u116E\u11A8","\u110B\u1163\u11A8\u1109\u1169\u11A8","\u110B\u1163\u11A8\u1109\u116E","\u110B\u1163\u11A8\u110C\u1165\u11B7","\u110B\u1163\u11A8\u1111\u116E\u11B7","\u110B\u1163\u11A8\u1112\u1169\u11AB\u1102\u1167","\u110B\u1163\u11BC\u1102\u1167\u11B7","\u110B\u1163\u11BC\u1105\u1167\u11A8","\u110B\u1163\u11BC\u1106\u1161\u11AF","\u110B\u1163\u11BC\u1107\u1162\u110E\u116E","\u110B\u1163\u11BC\u110C\u116E","\u110B\u1163\u11BC\u1111\u1161","\u110B\u1165\u1103\u116E\u11B7","\u110B\u1165\u1105\u1167\u110B\u116E\u11B7","\u110B\u1165\u1105\u1173\u11AB","\u110B\u1165\u110C\u1166\u11BA\u1107\u1161\u11B7","\u110B\u1165\u110D\u1162\u11BB\u1103\u1173\u11AB","\u110B\u1165\u110D\u1165\u1103\u1161\u1100\u1161","\u110B\u1165\u110D\u1165\u11AB\u110C\u1175","\u110B\u1165\u11AB\u1102\u1175","\u110B\u1165\u11AB\u1103\u1165\u11A8","\u110B\u1165\u11AB\u1105\u1169\u11AB","\u110B\u1165\u11AB\u110B\u1165","\u110B\u1165\u11AF\u1100\u116E\u11AF","\u110B\u1165\u11AF\u1105\u1173\u11AB","\u110B\u1165\u11AF\u110B\u1173\u11B7","\u110B\u1165\u11AF\u1111\u1175\u11BA","\u110B\u1165\u11B7\u1106\u1161","\u110B\u1165\u11B8\u1106\u116E","\u110B\u1165\u11B8\u110C\u1169\u11BC","\u110B\u1165\u11B8\u110E\u1166","\u110B\u1165\u11BC\u1103\u1165\u11BC\u110B\u1175","\u110B\u1165\u11BC\u1106\u1161\u11BC","\u110B\u1165\u11BC\u1110\u1165\u1105\u1175","\u110B\u1165\u11BD\u1100\u1173\u110C\u1166","\u110B\u1166\u1102\u1165\u110C\u1175","\u110B\u1166\u110B\u1165\u110F\u1165\u11AB","\u110B\u1166\u11AB\u110C\u1175\u11AB","\u110B\u1167\u1100\u1165\u11AB","\u110B\u1167\u1100\u1169\u1109\u1162\u11BC","\u110B\u1167\u1100\u116A\u11AB","\u110B\u1167\u1100\u116E\u11AB","\u110B\u1167\u1100\u116F\u11AB","\u110B\u1167\u1103\u1162\u1109\u1162\u11BC","\u110B\u1167\u1103\u1165\u11B2","\u110B\u1167\u1103\u1169\u11BC\u1109\u1162\u11BC","\u110B\u1167\u1103\u1173\u11AB","\u110B\u1167\u1105\u1169\u11AB","\u110B\u1167\u1105\u1173\u11B7","\u110B\u1167\u1109\u1165\u11BA","\u110B\u1167\u1109\u1165\u11BC","\u110B\u1167\u110B\u116A\u11BC","\u110B\u1167\u110B\u1175\u11AB","\u110B\u1167\u110C\u1165\u11AB\u1112\u1175","\u110B\u1167\u110C\u1175\u11A8\u110B\u116F\u11AB","\u110B\u1167\u1112\u1161\u11A8\u1109\u1162\u11BC","\u110B\u1167\u1112\u1162\u11BC","\u110B\u1167\u11A8\u1109\u1161","\u110B\u1167\u11A8\u1109\u1175","\u110B\u1167\u11A8\u1112\u1161\u11AF","\u110B\u1167\u11AB\u1100\u1167\u11AF","\u110B\u1167\u11AB\u1100\u116E","\u110B\u1167\u11AB\u1100\u1173\u11A8","\u110B\u1167\u11AB\u1100\u1175","\u110B\u1167\u11AB\u1105\u1161\u11A8","\u110B\u1167\u11AB\u1109\u1165\u11AF","\u110B\u1167\u11AB\u1109\u1166","\u110B\u1167\u11AB\u1109\u1169\u11A8","\u110B\u1167\u11AB\u1109\u1173\u11B8","\u110B\u1167\u11AB\u110B\u1162","\u110B\u1167\u11AB\u110B\u1168\u110B\u1175\u11AB","\u110B\u1167\u11AB\u110B\u1175\u11AB","\u110B\u1167\u11AB\u110C\u1161\u11BC","\u110B\u1167\u11AB\u110C\u116E","\u110B\u1167\u11AB\u110E\u116E\u11AF","\u110B\u1167\u11AB\u1111\u1175\u11AF","\u110B\u1167\u11AB\u1112\u1161\u11B8","\u110B\u1167\u11AB\u1112\u1172","\u110B\u1167\u11AF\u1100\u1175","\u110B\u1167\u11AF\u1106\u1162","\u110B\u1167\u11AF\u1109\u116C","\u110B\u1167\u11AF\u1109\u1175\u11B7\u1112\u1175","\u110B\u1167\u11AF\u110C\u1165\u11BC","\u110B\u1167\u11AF\u110E\u1161","\u110B\u1167\u11AF\u1112\u1173\u11AF","\u110B\u1167\u11B7\u1105\u1167","\u110B\u1167\u11B8\u1109\u1165","\u110B\u1167\u11BC\u1100\u116E\u11A8","\u110B\u1167\u11BC\u1102\u1161\u11B7","\u110B\u1167\u11BC\u1109\u1161\u11BC","\u110B\u1167\u11BC\u110B\u1163\u11BC","\u110B\u1167\u11BC\u110B\u1167\u11A8","\u110B\u1167\u11BC\u110B\u116E\u11BC","\u110B\u1167\u11BC\u110B\u116F\u11AB\u1112\u1175","\u110B\u1167\u11BC\u1112\u1161","\u110B\u1167\u11BC\u1112\u1163\u11BC","\u110B\u1167\u11BC\u1112\u1169\u11AB","\u110B\u1167\u11BC\u1112\u116A","\u110B\u1167\u11C1\u1100\u116E\u1105\u1175","\u110B\u1167\u11C1\u1107\u1161\u11BC","\u110B\u1167\u11C1\u110C\u1175\u11B8","\u110B\u1168\u1100\u1161\u11B7","\u110B\u1168\u1100\u1173\u11B7","\u110B\u1168\u1107\u1161\u11BC","\u110B\u1168\u1109\u1161\u11AB","\u110B\u1168\u1109\u1161\u11BC","\u110B\u1168\u1109\u1165\u11AB","\u110B\u1168\u1109\u116E\u11AF","\u110B\u1168\u1109\u1173\u11B8","\u110B\u1168\u1109\u1175\u11A8\u110C\u1161\u11BC","\u110B\u1168\u110B\u1163\u11A8","\u110B\u1168\u110C\u1165\u11AB","\u110B\u1168\u110C\u1165\u11AF","\u110B\u1168\u110C\u1165\u11BC","\u110B\u1168\u110F\u1165\u11AB\u1103\u1162","\u110B\u1168\u11BA\u1102\u1161\u11AF","\u110B\u1169\u1102\u1173\u11AF","\u110B\u1169\u1105\u1161\u11A8","\u110B\u1169\u1105\u1162\u11BA\u1103\u1169\u11BC\u110B\u1161\u11AB","\u110B\u1169\u1105\u1166\u11AB\u110C\u1175","\u110B\u1169\u1105\u1169\u110C\u1175","\u110B\u1169\u1105\u1173\u11AB\u1107\u1161\u11AF","\u110B\u1169\u1107\u1173\u11AB","\u110B\u1169\u1109\u1175\u11B8","\u110B\u1169\u110B\u1167\u11B7","\u110B\u1169\u110B\u116F\u11AF","\u110B\u1169\u110C\u1165\u11AB","\u110B\u1169\u110C\u1175\u11A8","\u110B\u1169\u110C\u1175\u11BC\u110B\u1165","\u110B\u1169\u1111\u1166\u1105\u1161","\u110B\u1169\u1111\u1175\u1109\u1173\u1110\u1166\u11AF","\u110B\u1169\u1112\u1175\u1105\u1167","\u110B\u1169\u11A8\u1109\u1161\u11BC","\u110B\u1169\u11A8\u1109\u116E\u1109\u116E","\u110B\u1169\u11AB\u1100\u1161\u11BD","\u110B\u1169\u11AB\u1105\u1161\u110B\u1175\u11AB","\u110B\u1169\u11AB\u1106\u1169\u11B7","\u110B\u1169\u11AB\u110C\u1169\u11BC\u110B\u1175\u11AF","\u110B\u1169\u11AB\u1110\u1169\u11BC","\u110B\u1169\u11AF\u1100\u1161\u110B\u1173\u11AF","\u110B\u1169\u11AF\u1105\u1175\u11B7\u1111\u1175\u11A8","\u110B\u1169\u11AF\u1112\u1162","\u110B\u1169\u11BA\u110E\u1161\u1105\u1175\u11B7","\u110B\u116A\u110B\u1175\u1109\u1167\u110E\u1173","\u110B\u116A\u110B\u1175\u11AB","\u110B\u116A\u11AB\u1109\u1165\u11BC","\u110B\u116A\u11AB\u110C\u1165\u11AB","\u110B\u116A\u11BC\u1107\u1175","\u110B\u116A\u11BC\u110C\u1161","\u110B\u116B\u1102\u1163\u1112\u1161\u1106\u1167\u11AB","\u110B\u116B\u11AB\u110C\u1175","\u110B\u116C\u1100\u1161\u11BA\u110C\u1175\u11B8","\u110B\u116C\u1100\u116E\u11A8","\u110B\u116C\u1105\u1169\u110B\u116E\u11B7","\u110B\u116C\u1109\u1161\u11B7\u110E\u1169\u11AB","\u110B\u116C\u110E\u116E\u11AF","\u110B\u116C\u110E\u1175\u11B7","\u110B\u116C\u1112\u1161\u11AF\u1106\u1165\u1102\u1175","\u110B\u116C\u11AB\u1107\u1161\u11AF","\u110B\u116C\u11AB\u1109\u1169\u11AB","\u110B\u116C\u11AB\u110D\u1169\u11A8","\u110B\u116D\u1100\u1173\u11B7","\u110B\u116D\u110B\u1175\u11AF","\u110B\u116D\u110C\u1173\u11B7","\u110B\u116D\u110E\u1165\u11BC","\u110B\u116D\u11BC\u1100\u1175","\u110B\u116D\u11BC\u1109\u1165","\u110B\u116D\u11BC\u110B\u1165","\u110B\u116E\u1109\u1161\u11AB","\u110B\u116E\u1109\u1165\u11AB","\u110B\u116E\u1109\u1173\u11BC","\u110B\u116E\u110B\u1167\u11AB\u1112\u1175","\u110B\u116E\u110C\u1165\u11BC","\u110B\u116E\u110E\u1166\u1100\u116E\u11A8","\u110B\u116E\u1111\u1167\u11AB","\u110B\u116E\u11AB\u1103\u1169\u11BC","\u110B\u116E\u11AB\u1106\u1167\u11BC","\u110B\u116E\u11AB\u1107\u1161\u11AB","\u110B\u116E\u11AB\u110C\u1165\u11AB","\u110B\u116E\u11AB\u1112\u1162\u11BC","\u110B\u116E\u11AF\u1109\u1161\u11AB","\u110B\u116E\u11AF\u110B\u1173\u11B7","\u110B\u116E\u11B7\u110C\u1175\u11A8\u110B\u1175\u11B7","\u110B\u116E\u11BA\u110B\u1165\u1105\u1173\u11AB","\u110B\u116E\u11BA\u110B\u1173\u11B7","\u110B\u116F\u1102\u1161\u11A8","\u110B\u116F\u11AB\u1100\u1169","\u110B\u116F\u11AB\u1105\u1162","\u110B\u116F\u11AB\u1109\u1165","\u110B\u116F\u11AB\u1109\u116E\u11BC\u110B\u1175","\u110B\u116F\u11AB\u110B\u1175\u11AB","\u110B\u116F\u11AB\u110C\u1161\u11BC","\u110B\u116F\u11AB\u1111\u1175\u1109\u1173","\u110B\u116F\u11AF\u1100\u1173\u11B8","\u110B\u116F\u11AF\u1103\u1173\u110F\u1165\u11B8","\u110B\u116F\u11AF\u1109\u1166","\u110B\u116F\u11AF\u110B\u116D\u110B\u1175\u11AF","\u110B\u1170\u110B\u1175\u1110\u1165","\u110B\u1171\u1107\u1161\u11AB","\u110B\u1171\u1107\u1165\u11B8","\u110B\u1171\u1109\u1165\u11BC","\u110B\u1171\u110B\u116F\u11AB","\u110B\u1171\u1112\u1165\u11B7","\u110B\u1171\u1112\u1167\u11B8","\u110B\u1171\u11BA\u1109\u1161\u1105\u1161\u11B7","\u110B\u1172\u1102\u1161\u11AB\u1112\u1175","\u110B\u1172\u1105\u1165\u11B8","\u110B\u1172\u1106\u1167\u11BC","\u110B\u1172\u1106\u116E\u11AF","\u110B\u1172\u1109\u1161\u11AB","\u110B\u1172\u110C\u1165\u11A8","\u110B\u1172\u110E\u1175\u110B\u116F\u11AB","\u110B\u1172\u1112\u1161\u11A8","\u110B\u1172\u1112\u1162\u11BC","\u110B\u1172\u1112\u1167\u11BC","\u110B\u1172\u11A8\u1100\u116E\u11AB","\u110B\u1172\u11A8\u1109\u1161\u11BC","\u110B\u1172\u11A8\u1109\u1175\u11B8","\u110B\u1172\u11A8\u110E\u1166","\u110B\u1173\u11AB\u1112\u1162\u11BC","\u110B\u1173\u11B7\u1105\u1167\u11A8","\u110B\u1173\u11B7\u1105\u116D","\u110B\u1173\u11B7\u1107\u1161\u11AB","\u110B\u1173\u11B7\u1109\u1165\u11BC","\u110B\u1173\u11B7\u1109\u1175\u11A8","\u110B\u1173\u11B7\u110B\u1161\u11A8","\u110B\u1173\u11B7\u110C\u116E","\u110B\u1174\u1100\u1167\u11AB","\u110B\u1174\u1102\u1169\u11AB","\u110B\u1174\u1106\u116E\u11AB","\u110B\u1174\u1107\u1169\u11A8","\u110B\u1174\u1109\u1175\u11A8","\u110B\u1174\u1109\u1175\u11B7","\u110B\u1174\u110B\u116C\u1105\u1169","\u110B\u1174\u110B\u116D\u11A8","\u110B\u1174\u110B\u116F\u11AB","\u110B\u1174\u1112\u1161\u11A8","\u110B\u1175\u1100\u1165\u11BA","\u110B\u1175\u1100\u1169\u11BA","\u110B\u1175\u1102\u1167\u11B7","\u110B\u1175\u1102\u1169\u11B7","\u110B\u1175\u1103\u1161\u11AF","\u110B\u1175\u1103\u1162\u1105\u1169","\u110B\u1175\u1103\u1169\u11BC","\u110B\u1175\u1105\u1165\u11C2\u1100\u1166","\u110B\u1175\u1105\u1167\u11A8\u1109\u1165","\u110B\u1175\u1105\u1169\u11AB\u110C\u1165\u11A8","\u110B\u1175\u1105\u1173\u11B7","\u110B\u1175\u1106\u1175\u11AB","\u110B\u1175\u1107\u1161\u11AF\u1109\u1169","\u110B\u1175\u1107\u1167\u11AF","\u110B\u1175\u1107\u116E\u11AF","\u110B\u1175\u1108\u1161\u11AF","\u110B\u1175\u1109\u1161\u11BC","\u110B\u1175\u1109\u1165\u11BC","\u110B\u1175\u1109\u1173\u11AF","\u110B\u1175\u110B\u1163\u1100\u1175","\u110B\u1175\u110B\u116D\u11BC","\u110B\u1175\u110B\u116E\u11BA","\u110B\u1175\u110B\u116F\u11AF","\u110B\u1175\u110B\u1173\u11A8\u1100\u1169","\u110B\u1175\u110B\u1175\u11A8","\u110B\u1175\u110C\u1165\u11AB","\u110B\u1175\u110C\u116E\u11BC","\u110B\u1175\u1110\u1173\u11AE\u1102\u1161\u11AF","\u110B\u1175\u1110\u1173\u11AF","\u110B\u1175\u1112\u1169\u11AB","\u110B\u1175\u11AB\u1100\u1161\u11AB","\u110B\u1175\u11AB\u1100\u1167\u11A8","\u110B\u1175\u11AB\u1100\u1169\u11BC","\u110B\u1175\u11AB\u1100\u116E","\u110B\u1175\u11AB\u1100\u1173\u11AB","\u110B\u1175\u11AB\u1100\u1175","\u110B\u1175\u11AB\u1103\u1169","\u110B\u1175\u11AB\u1105\u1172","\u110B\u1175\u11AB\u1106\u116E\u11AF","\u110B\u1175\u11AB\u1109\u1162\u11BC","\u110B\u1175\u11AB\u1109\u116B","\u110B\u1175\u11AB\u110B\u1167\u11AB","\u110B\u1175\u11AB\u110B\u116F\u11AB","\u110B\u1175\u11AB\u110C\u1162","\u110B\u1175\u11AB\u110C\u1169\u11BC","\u110B\u1175\u11AB\u110E\u1165\u11AB","\u110B\u1175\u11AB\u110E\u1166","\u110B\u1175\u11AB\u1110\u1165\u1102\u1166\u11BA","\u110B\u1175\u11AB\u1112\u1161","\u110B\u1175\u11AB\u1112\u1167\u11BC","\u110B\u1175\u11AF\u1100\u1169\u11B8","\u110B\u1175\u11AF\u1100\u1175","\u110B\u1175\u11AF\u1103\u1161\u11AB","\u110B\u1175\u11AF\u1103\u1162","\u110B\u1175\u11AF\u1103\u1173\u11BC","\u110B\u1175\u11AF\u1107\u1161\u11AB","\u110B\u1175\u11AF\u1107\u1169\u11AB","\u110B\u1175\u11AF\u1107\u116E","\u110B\u1175\u11AF\u1109\u1161\u11BC","\u110B\u1175\u11AF\u1109\u1162\u11BC","\u110B\u1175\u11AF\u1109\u1169\u11AB","\u110B\u1175\u11AF\u110B\u116D\u110B\u1175\u11AF","\u110B\u1175\u11AF\u110B\u116F\u11AF","\u110B\u1175\u11AF\u110C\u1165\u11BC","\u110B\u1175\u11AF\u110C\u1169\u11BC","\u110B\u1175\u11AF\u110C\u116E\u110B\u1175\u11AF","\u110B\u1175\u11AF\u110D\u1175\u11A8","\u110B\u1175\u11AF\u110E\u1166","\u110B\u1175\u11AF\u110E\u1175","\u110B\u1175\u11AF\u1112\u1162\u11BC","\u110B\u1175\u11AF\u1112\u116C\u110B\u116D\u11BC","\u110B\u1175\u11B7\u1100\u1173\u11B7","\u110B\u1175\u11B7\u1106\u116E","\u110B\u1175\u11B8\u1103\u1162","\u110B\u1175\u11B8\u1105\u1167\u11A8","\u110B\u1175\u11B8\u1106\u1161\u11BA","\u110B\u1175\u11B8\u1109\u1161","\u110B\u1175\u11B8\u1109\u116E\u11AF","\u110B\u1175\u11B8\u1109\u1175","\u110B\u1175\u11B8\u110B\u116F\u11AB","\u110B\u1175\u11B8\u110C\u1161\u11BC","\u110B\u1175\u11B8\u1112\u1161\u11A8","\u110C\u1161\u1100\u1161\u110B\u116D\u11BC","\u110C\u1161\u1100\u1167\u11A8","\u110C\u1161\u1100\u1173\u11A8","\u110C\u1161\u1103\u1169\u11BC","\u110C\u1161\u1105\u1161\u11BC","\u110C\u1161\u1107\u116E\u1109\u1175\u11B7","\u110C\u1161\u1109\u1175\u11A8","\u110C\u1161\u1109\u1175\u11AB","\u110C\u1161\u110B\u1167\u11AB","\u110C\u1161\u110B\u116F\u11AB","\u110C\u1161\u110B\u1172\u11AF","\u110C\u1161\u110C\u1165\u11AB\u1100\u1165","\u110C\u1161\u110C\u1165\u11BC","\u110C\u1161\u110C\u1169\u11AB\u1109\u1175\u11B7","\u110C\u1161\u1111\u1161\u11AB","\u110C\u1161\u11A8\u1100\u1161","\u110C\u1161\u11A8\u1102\u1167\u11AB","\u110C\u1161\u11A8\u1109\u1165\u11BC","\u110C\u1161\u11A8\u110B\u1165\u11B8","\u110C\u1161\u11A8\u110B\u116D\u11BC","\u110C\u1161\u11A8\u110B\u1173\u11AB\u1104\u1161\u11AF","\u110C\u1161\u11A8\u1111\u116E\u11B7","\u110C\u1161\u11AB\u1103\u1175","\u110C\u1161\u11AB\u1104\u1173\u11A8","\u110C\u1161\u11AB\u110E\u1175","\u110C\u1161\u11AF\u1106\u1169\u11BA","\u110C\u1161\u11B7\u1101\u1161\u11AB","\u110C\u1161\u11B7\u1109\u116E\u1112\u1161\u11B7","\u110C\u1161\u11B7\u1109\u1175","\u110C\u1161\u11B7\u110B\u1169\u11BA","\u110C\u1161\u11B7\u110C\u1161\u1105\u1175","\u110C\u1161\u11B8\u110C\u1175","\u110C\u1161\u11BC\u1100\u116A\u11AB","\u110C\u1161\u11BC\u1100\u116E\u11AB","\u110C\u1161\u11BC\u1100\u1175\u1100\u1161\u11AB","\u110C\u1161\u11BC\u1105\u1162","\u110C\u1161\u11BC\u1105\u1168","\u110C\u1161\u11BC\u1105\u1173","\u110C\u1161\u11BC\u1106\u1161","\u110C\u1161\u11BC\u1106\u1167\u11AB","\u110C\u1161\u11BC\u1106\u1169","\u110C\u1161\u11BC\u1106\u1175","\u110C\u1161\u11BC\u1107\u1175","\u110C\u1161\u11BC\u1109\u1161","\u110C\u1161\u11BC\u1109\u1169","\u110C\u1161\u11BC\u1109\u1175\u11A8","\u110C\u1161\u11BC\u110B\u1162\u110B\u1175\u11AB","\u110C\u1161\u11BC\u110B\u1175\u11AB","\u110C\u1161\u11BC\u110C\u1165\u11B7","\u110C\u1161\u11BC\u110E\u1161","\u110C\u1161\u11BC\u1112\u1161\u11A8\u1100\u1173\u11B7","\u110C\u1162\u1102\u1173\u11BC","\u110C\u1162\u1108\u1161\u11AF\u1105\u1175","\u110C\u1162\u1109\u1161\u11AB","\u110C\u1162\u1109\u1162\u11BC","\u110C\u1162\u110C\u1161\u11A8\u1102\u1167\u11AB","\u110C\u1162\u110C\u1165\u11BC","\u110C\u1162\u110E\u1162\u1100\u1175","\u110C\u1162\u1111\u1161\u11AB","\u110C\u1162\u1112\u1161\u11A8","\u110C\u1162\u1112\u116A\u11AF\u110B\u116D\u11BC","\u110C\u1165\u1100\u1165\u11BA","\u110C\u1165\u1100\u1169\u1105\u1175","\u110C\u1165\u1100\u1169\u11BA","\u110C\u1165\u1102\u1167\u11A8","\u110C\u1165\u1105\u1165\u11AB","\u110C\u1165\u1105\u1165\u11C2\u1100\u1166","\u110C\u1165\u1107\u1165\u11AB","\u110C\u1165\u110B\u116E\u11AF","\u110C\u1165\u110C\u1165\u11AF\u1105\u1169","\u110C\u1165\u110E\u116E\u11A8","\u110C\u1165\u11A8\u1100\u1173\u11A8","\u110C\u1165\u11A8\u1103\u1161\u11BC\u1112\u1175","\u110C\u1165\u11A8\u1109\u1165\u11BC","\u110C\u1165\u11A8\u110B\u116D\u11BC","\u110C\u1165\u11A8\u110B\u1173\u11BC","\u110C\u1165\u11AB\u1100\u1162","\u110C\u1165\u11AB\u1100\u1169\u11BC","\u110C\u1165\u11AB\u1100\u1175","\u110C\u1165\u11AB\u1103\u1161\u11AF","\u110C\u1165\u11AB\u1105\u1161\u1103\u1169","\u110C\u1165\u11AB\u1106\u1161\u11BC","\u110C\u1165\u11AB\u1106\u116E\u11AB","\u110C\u1165\u11AB\u1107\u1161\u11AB","\u110C\u1165\u11AB\u1107\u116E","\u110C\u1165\u11AB\u1109\u1166","\u110C\u1165\u11AB\u1109\u1175","\u110C\u1165\u11AB\u110B\u116D\u11BC","\u110C\u1165\u11AB\u110C\u1161","\u110C\u1165\u11AB\u110C\u1162\u11BC","\u110C\u1165\u11AB\u110C\u116E","\u110C\u1165\u11AB\u110E\u1165\u11AF","\u110C\u1165\u11AB\u110E\u1166","\u110C\u1165\u11AB\u1110\u1169\u11BC","\u110C\u1165\u11AB\u1112\u1167","\u110C\u1165\u11AB\u1112\u116E","\u110C\u1165\u11AF\u1103\u1162","\u110C\u1165\u11AF\u1106\u1161\u11BC","\u110C\u1165\u11AF\u1107\u1161\u11AB","\u110C\u1165\u11AF\u110B\u1163\u11A8","\u110C\u1165\u11AF\u110E\u1161","\u110C\u1165\u11B7\u1100\u1165\u11B7","\u110C\u1165\u11B7\u1109\u116E","\u110C\u1165\u11B7\u1109\u1175\u11B7","\u110C\u1165\u11B7\u110B\u116F\u11AB","\u110C\u1165\u11B7\u110C\u1165\u11B7","\u110C\u1165\u11B7\u110E\u1161","\u110C\u1165\u11B8\u1100\u1173\u11AB","\u110C\u1165\u11B8\u1109\u1175","\u110C\u1165\u11B8\u110E\u1169\u11A8","\u110C\u1165\u11BA\u1100\u1161\u1105\u1161\u11A8","\u110C\u1165\u11BC\u1100\u1165\u110C\u1161\u11BC","\u110C\u1165\u11BC\u1103\u1169","\u110C\u1165\u11BC\u1105\u1172\u110C\u1161\u11BC","\u110C\u1165\u11BC\u1105\u1175","\u110C\u1165\u11BC\u1106\u1161\u11AF","\u110C\u1165\u11BC\u1106\u1167\u11AB","\u110C\u1165\u11BC\u1106\u116E\u11AB","\u110C\u1165\u11BC\u1107\u1161\u11AB\u1103\u1162","\u110C\u1165\u11BC\u1107\u1169","\u110C\u1165\u11BC\u1107\u116E","\u110C\u1165\u11BC\u1107\u1175","\u110C\u1165\u11BC\u1109\u1161\u11BC","\u110C\u1165\u11BC\u1109\u1165\u11BC","\u110C\u1165\u11BC\u110B\u1169","\u110C\u1165\u11BC\u110B\u116F\u11AB","\u110C\u1165\u11BC\u110C\u1161\u11BC","\u110C\u1165\u11BC\u110C\u1175","\u110C\u1165\u11BC\u110E\u1175","\u110C\u1165\u11BC\u1112\u116A\u11A8\u1112\u1175","\u110C\u1166\u1100\u1169\u11BC","\u110C\u1166\u1100\u116A\u110C\u1165\u11B7","\u110C\u1166\u1103\u1162\u1105\u1169","\u110C\u1166\u1106\u1169\u11A8","\u110C\u1166\u1107\u1161\u11AF","\u110C\u1166\u1107\u1165\u11B8","\u110C\u1166\u1109\u1161\u11BA\u1102\u1161\u11AF","\u110C\u1166\u110B\u1161\u11AB","\u110C\u1166\u110B\u1175\u11AF","\u110C\u1166\u110C\u1161\u11A8","\u110C\u1166\u110C\u116E\u1103\u1169","\u110C\u1166\u110E\u116E\u11AF","\u110C\u1166\u1111\u116E\u11B7","\u110C\u1166\u1112\u1161\u11AB","\u110C\u1169\u1100\u1161\u11A8","\u110C\u1169\u1100\u1165\u11AB","\u110C\u1169\u1100\u1173\u11B7","\u110C\u1169\u1100\u1175\u11BC","\u110C\u1169\u1106\u1167\u11BC","\u110C\u1169\u1106\u1175\u1105\u116D","\u110C\u1169\u1109\u1161\u11BC","\u110C\u1169\u1109\u1165\u11AB","\u110C\u1169\u110B\u116D\u11BC\u1112\u1175","\u110C\u1169\u110C\u1165\u11AF","\u110C\u1169\u110C\u1165\u11BC","\u110C\u1169\u110C\u1175\u11A8","\u110C\u1169\u11AB\u1103\u1162\u11BA\u1106\u1161\u11AF","\u110C\u1169\u11AB\u110C\u1162","\u110C\u1169\u11AF\u110B\u1165\u11B8","\u110C\u1169\u11AF\u110B\u1173\u11B7","\u110C\u1169\u11BC\u1100\u116D","\u110C\u1169\u11BC\u1105\u1169","\u110C\u1169\u11BC\u1105\u1172","\u110C\u1169\u11BC\u1109\u1169\u1105\u1175","\u110C\u1169\u11BC\u110B\u1165\u11B8\u110B\u116F\u11AB","\u110C\u1169\u11BC\u110C\u1169\u11BC","\u110C\u1169\u11BC\u1112\u1161\u11B8","\u110C\u116A\u1109\u1165\u11A8","\u110C\u116C\u110B\u1175\u11AB","\u110C\u116E\u1100\u116A\u11AB\u110C\u1165\u11A8","\u110C\u116E\u1105\u1173\u11B7","\u110C\u116E\u1106\u1161\u11AF","\u110C\u116E\u1106\u1165\u1102\u1175","\u110C\u116E\u1106\u1165\u11A8","\u110C\u116E\u1106\u116E\u11AB","\u110C\u116E\u1106\u1175\u11AB","\u110C\u116E\u1107\u1161\u11BC","\u110C\u116E\u1107\u1167\u11AB","\u110C\u116E\u1109\u1175\u11A8","\u110C\u116E\u110B\u1175\u11AB","\u110C\u116E\u110B\u1175\u11AF","\u110C\u116E\u110C\u1161\u11BC","\u110C\u116E\u110C\u1165\u11AB\u110C\u1161","\u110C\u116E\u1110\u1162\u11A8","\u110C\u116E\u11AB\u1107\u1175","\u110C\u116E\u11AF\u1100\u1165\u1105\u1175","\u110C\u116E\u11AF\u1100\u1175","\u110C\u116E\u11AF\u1106\u116E\u1102\u1174","\u110C\u116E\u11BC\u1100\u1161\u11AB","\u110C\u116E\u11BC\u1100\u1168\u1107\u1161\u11BC\u1109\u1169\u11BC","\u110C\u116E\u11BC\u1100\u116E\u11A8","\u110C\u116E\u11BC\u1102\u1167\u11AB","\u110C\u116E\u11BC\u1103\u1161\u11AB","\u110C\u116E\u11BC\u1103\u1169\u11A8","\u110C\u116E\u11BC\u1107\u1161\u11AB","\u110C\u116E\u11BC\u1107\u116E","\u110C\u116E\u11BC\u1109\u1166","\u110C\u116E\u11BC\u1109\u1169\u1100\u1175\u110B\u1165\u11B8","\u110C\u116E\u11BC\u1109\u116E\u11AB","\u110C\u116E\u11BC\u110B\u1161\u11BC","\u110C\u116E\u11BC\u110B\u116D","\u110C\u116E\u11BC\u1112\u1161\u11A8\u1100\u116D","\u110C\u1173\u11A8\u1109\u1165\u11A8","\u110C\u1173\u11A8\u1109\u1175","\u110C\u1173\u11AF\u1100\u1165\u110B\u116E\u11B7","\u110C\u1173\u11BC\u1100\u1161","\u110C\u1173\u11BC\u1100\u1165","\u110C\u1173\u11BC\u1100\u116F\u11AB","\u110C\u1173\u11BC\u1109\u1161\u11BC","\u110C\u1173\u11BC\u1109\u1166","\u110C\u1175\u1100\u1161\u11A8","\u110C\u1175\u1100\u1161\u11B8","\u110C\u1175\u1100\u1167\u11BC","\u110C\u1175\u1100\u1173\u11A8\u1112\u1175","\u110C\u1175\u1100\u1173\u11B7","\u110C\u1175\u1100\u1173\u11B8","\u110C\u1175\u1102\u1173\u11BC","\u110C\u1175\u1105\u1173\u11B7\u1100\u1175\u11AF","\u110C\u1175\u1105\u1175\u1109\u1161\u11AB","\u110C\u1175\u1107\u1161\u11BC","\u110C\u1175\u1107\u116E\u11BC","\u110C\u1175\u1109\u1175\u11A8","\u110C\u1175\u110B\u1167\u11A8","\u110C\u1175\u110B\u116E\u1100\u1162","\u110C\u1175\u110B\u116F\u11AB","\u110C\u1175\u110C\u1165\u11A8","\u110C\u1175\u110C\u1165\u11B7","\u110C\u1175\u110C\u1175\u11AB","\u110C\u1175\u110E\u116E\u11AF","\u110C\u1175\u11A8\u1109\u1165\u11AB","\u110C\u1175\u11A8\u110B\u1165\u11B8","\u110C\u1175\u11A8\u110B\u116F\u11AB","\u110C\u1175\u11A8\u110C\u1161\u11BC","\u110C\u1175\u11AB\u1100\u1173\u11B8","\u110C\u1175\u11AB\u1103\u1169\u11BC","\u110C\u1175\u11AB\u1105\u1169","\u110C\u1175\u11AB\u1105\u116D","\u110C\u1175\u11AB\u1105\u1175","\u110C\u1175\u11AB\u110D\u1161","\u110C\u1175\u11AB\u110E\u1161\u11AF","\u110C\u1175\u11AB\u110E\u116E\u11AF","\u110C\u1175\u11AB\u1110\u1169\u11BC","\u110C\u1175\u11AB\u1112\u1162\u11BC","\u110C\u1175\u11AF\u1106\u116E\u11AB","\u110C\u1175\u11AF\u1107\u1167\u11BC","\u110C\u1175\u11AF\u1109\u1165","\u110C\u1175\u11B7\u110C\u1161\u11A8","\u110C\u1175\u11B8\u1103\u1161\u11AB","\u110C\u1175\u11B8\u110B\u1161\u11AB","\u110C\u1175\u11B8\u110C\u116E\u11BC","\u110D\u1161\u110C\u1173\u11BC","\u110D\u1175\u1101\u1165\u1100\u1175","\u110E\u1161\u1102\u1161\u11B7","\u110E\u1161\u1105\u1161\u1105\u1175","\u110E\u1161\u1105\u1163\u11BC","\u110E\u1161\u1105\u1175\u11B7","\u110E\u1161\u1107\u1167\u11AF","\u110E\u1161\u1109\u1165\u11AB","\u110E\u1161\u110E\u1173\u11B7","\u110E\u1161\u11A8\u1100\u1161\u11A8","\u110E\u1161\u11AB\u1106\u116E\u11AF","\u110E\u1161\u11AB\u1109\u1165\u11BC","\u110E\u1161\u11B7\u1100\u1161","\u110E\u1161\u11B7\u1100\u1175\u1105\u1173\u11B7","\u110E\u1161\u11B7\u1109\u1162","\u110E\u1161\u11B7\u1109\u1165\u11A8","\u110E\u1161\u11B7\u110B\u1167","\u110E\u1161\u11B7\u110B\u116C","\u110E\u1161\u11B7\u110C\u1169","\u110E\u1161\u11BA\u110C\u1161\u11AB","\u110E\u1161\u11BC\u1100\u1161","\u110E\u1161\u11BC\u1100\u1169","\u110E\u1161\u11BC\u1100\u116E","\u110E\u1161\u11BC\u1106\u116E\u11AB","\u110E\u1161\u11BC\u1107\u1161\u11A9","\u110E\u1161\u11BC\u110C\u1161\u11A8","\u110E\u1161\u11BC\u110C\u1169","\u110E\u1162\u1102\u1165\u11AF","\u110E\u1162\u110C\u1165\u11B7","\u110E\u1162\u11A8\u1100\u1161\u1107\u1161\u11BC","\u110E\u1162\u11A8\u1107\u1161\u11BC","\u110E\u1162\u11A8\u1109\u1161\u11BC","\u110E\u1162\u11A8\u110B\u1175\u11B7","\u110E\u1162\u11B7\u1111\u1175\u110B\u1165\u11AB","\u110E\u1165\u1107\u1165\u11AF","\u110E\u1165\u110B\u1173\u11B7","\u110E\u1165\u11AB\u1100\u116E\u11A8","\u110E\u1165\u11AB\u1103\u116E\u11BC","\u110E\u1165\u11AB\u110C\u1161\u11BC","\u110E\u1165\u11AB\u110C\u1162","\u110E\u1165\u11AB\u110E\u1165\u11AB\u1112\u1175","\u110E\u1165\u11AF\u1103\u1169","\u110E\u1165\u11AF\u110C\u1165\u1112\u1175","\u110E\u1165\u11AF\u1112\u1161\u11A8","\u110E\u1165\u11BA\u1102\u1161\u11AF","\u110E\u1165\u11BA\u110D\u1162","\u110E\u1165\u11BC\u1102\u1167\u11AB","\u110E\u1165\u11BC\u1107\u1161\u110C\u1175","\u110E\u1165\u11BC\u1109\u1169","\u110E\u1165\u11BC\u110E\u116E\u11AB","\u110E\u1166\u1100\u1168","\u110E\u1166\u1105\u1167\u11A8","\u110E\u1166\u110B\u1169\u11AB","\u110E\u1166\u110B\u1172\u11A8","\u110E\u1166\u110C\u116E\u11BC","\u110E\u1166\u1112\u1165\u11B7","\u110E\u1169\u1103\u1173\u11BC\u1112\u1161\u11A8\u1109\u1162\u11BC","\u110E\u1169\u1107\u1161\u11AB","\u110E\u1169\u1107\u1161\u11B8","\u110E\u1169\u1109\u1161\u11BC\u1112\u116A","\u110E\u1169\u1109\u116E\u11AB","\u110E\u1169\u110B\u1167\u1105\u1173\u11B7","\u110E\u1169\u110B\u116F\u11AB","\u110E\u1169\u110C\u1165\u1102\u1167\u11A8","\u110E\u1169\u110C\u1165\u11B7","\u110E\u1169\u110E\u1165\u11BC","\u110E\u1169\u110F\u1169\u11AF\u1105\u1175\u11BA","\u110E\u1169\u11BA\u1107\u116E\u11AF","\u110E\u1169\u11BC\u1100\u1161\u11A8","\u110E\u1169\u11BC\u1105\u1175","\u110E\u1169\u11BC\u110C\u1161\u11BC","\u110E\u116A\u11AF\u110B\u1167\u11BC","\u110E\u116C\u1100\u1173\u11AB","\u110E\u116C\u1109\u1161\u11BC","\u110E\u116C\u1109\u1165\u11AB","\u110E\u116C\u1109\u1175\u11AB","\u110E\u116C\u110B\u1161\u11A8","\u110E\u116C\u110C\u1169\u11BC","\u110E\u116E\u1109\u1165\u11A8","\u110E\u116E\u110B\u1165\u11A8","\u110E\u116E\u110C\u1175\u11AB","\u110E\u116E\u110E\u1165\u11AB","\u110E\u116E\u110E\u1173\u11A8","\u110E\u116E\u11A8\u1100\u116E","\u110E\u116E\u11A8\u1109\u1169","\u110E\u116E\u11A8\u110C\u1166","\u110E\u116E\u11A8\u1112\u1161","\u110E\u116E\u11AF\u1100\u1173\u11AB","\u110E\u116E\u11AF\u1107\u1161\u11AF","\u110E\u116E\u11AF\u1109\u1161\u11AB","\u110E\u116E\u11AF\u1109\u1175\u11AB","\u110E\u116E\u11AF\u110B\u1167\u11AB","\u110E\u116E\u11AF\u110B\u1175\u11B8","\u110E\u116E\u11AF\u110C\u1161\u11BC","\u110E\u116E\u11AF\u1111\u1161\u11AB","\u110E\u116E\u11BC\u1100\u1167\u11A8","\u110E\u116E\u11BC\u1100\u1169","\u110E\u116E\u11BC\u1103\u1169\u11AF","\u110E\u116E\u11BC\u1107\u116E\u11AB\u1112\u1175","\u110E\u116E\u11BC\u110E\u1165\u11BC\u1103\u1169","\u110E\u1171\u110B\u1165\u11B8","\u110E\u1171\u110C\u1175\u11A8","\u110E\u1171\u1112\u1163\u11BC","\u110E\u1175\u110B\u1163\u11A8","\u110E\u1175\u11AB\u1100\u116E","\u110E\u1175\u11AB\u110E\u1165\u11A8","\u110E\u1175\u11AF\u1109\u1175\u11B8","\u110E\u1175\u11AF\u110B\u116F\u11AF","\u110E\u1175\u11AF\u1111\u1161\u11AB","\u110E\u1175\u11B7\u1103\u1162","\u110E\u1175\u11B7\u1106\u116E\u11A8","\u110E\u1175\u11B7\u1109\u1175\u11AF","\u110E\u1175\u11BA\u1109\u1169\u11AF","\u110E\u1175\u11BC\u110E\u1161\u11AB","\u110F\u1161\u1106\u1166\u1105\u1161","\u110F\u1161\u110B\u116E\u11AB\u1110\u1165","\u110F\u1161\u11AF\u1100\u116E\u11A8\u1109\u116E","\u110F\u1162\u1105\u1175\u11A8\u1110\u1165","\u110F\u1162\u11B7\u1111\u1165\u1109\u1173","\u110F\u1162\u11B7\u1111\u1166\u110B\u1175\u11AB","\u110F\u1165\u1110\u1173\u11AB","\u110F\u1165\u11AB\u1103\u1175\u1109\u1167\u11AB","\u110F\u1165\u11AF\u1105\u1165","\u110F\u1165\u11B7\u1111\u1172\u1110\u1165","\u110F\u1169\u1101\u1175\u1105\u1175","\u110F\u1169\u1106\u1175\u1103\u1175","\u110F\u1169\u11AB\u1109\u1165\u1110\u1173","\u110F\u1169\u11AF\u1105\u1161","\u110F\u1169\u11B7\u1111\u1173\u11AF\u1105\u1166\u11A8\u1109\u1173","\u110F\u1169\u11BC\u1102\u1161\u1106\u116E\u11AF","\u110F\u116B\u1100\u1161\u11B7","\u110F\u116E\u1103\u1166\u1110\u1161","\u110F\u1173\u1105\u1175\u11B7","\u110F\u1173\u11AB\u1100\u1175\u11AF","\u110F\u1173\u11AB\u1104\u1161\u11AF","\u110F\u1173\u11AB\u1109\u1169\u1105\u1175","\u110F\u1173\u11AB\u110B\u1161\u1103\u1173\u11AF","\u110F\u1173\u11AB\u110B\u1165\u1106\u1165\u1102\u1175","\u110F\u1173\u11AB\u110B\u1175\u11AF","\u110F\u1173\u11AB\u110C\u1165\u11AF","\u110F\u1173\u11AF\u1105\u1162\u1109\u1175\u11A8","\u110F\u1173\u11AF\u1105\u1165\u11B8","\u110F\u1175\u11AF\u1105\u1169","\u1110\u1161\u110B\u1175\u11B8","\u1110\u1161\u110C\u1161\u1100\u1175","\u1110\u1161\u11A8\u1100\u116E","\u1110\u1161\u11A8\u110C\u1161","\u1110\u1161\u11AB\u1109\u1162\u11BC","\u1110\u1162\u1100\u116F\u11AB\u1103\u1169","\u1110\u1162\u110B\u1163\u11BC","\u1110\u1162\u1111\u116E\u11BC","\u1110\u1162\u11A8\u1109\u1175","\u1110\u1162\u11AF\u1105\u1165\u11AB\u1110\u1173","\u1110\u1165\u1102\u1165\u11AF","\u1110\u1165\u1106\u1175\u1102\u1165\u11AF","\u1110\u1166\u1102\u1175\u1109\u1173","\u1110\u1166\u1109\u1173\u1110\u1173","\u1110\u1166\u110B\u1175\u1107\u1173\u11AF","\u1110\u1166\u11AF\u1105\u1166\u1107\u1175\u110C\u1165\u11AB","\u1110\u1169\u1105\u1169\u11AB","\u1110\u1169\u1106\u1161\u1110\u1169","\u1110\u1169\u110B\u116D\u110B\u1175\u11AF","\u1110\u1169\u11BC\u1100\u1168","\u1110\u1169\u11BC\u1100\u116A","\u1110\u1169\u11BC\u1105\u1169","\u1110\u1169\u11BC\u1109\u1175\u11AB","\u1110\u1169\u11BC\u110B\u1167\u11A8","\u1110\u1169\u11BC\u110B\u1175\u11AF","\u1110\u1169\u11BC\u110C\u1161\u11BC","\u1110\u1169\u11BC\u110C\u1166","\u1110\u1169\u11BC\u110C\u1173\u11BC","\u1110\u1169\u11BC\u1112\u1161\u11B8","\u1110\u1169\u11BC\u1112\u116A","\u1110\u116C\u1100\u1173\u11AB","\u1110\u116C\u110B\u116F\u11AB","\u1110\u116C\u110C\u1175\u11A8\u1100\u1173\u11B7","\u1110\u1171\u1100\u1175\u11B7","\u1110\u1173\u1105\u1165\u11A8","\u1110\u1173\u11A8\u1100\u1173\u11B8","\u1110\u1173\u11A8\u1107\u1167\u11AF","\u1110\u1173\u11A8\u1109\u1165\u11BC","\u1110\u1173\u11A8\u1109\u116E","\u1110\u1173\u11A8\u110C\u1175\u11BC","\u1110\u1173\u11A8\u1112\u1175","\u1110\u1173\u11AB\u1110\u1173\u11AB\u1112\u1175","\u1110\u1175\u1109\u1167\u110E\u1173","\u1111\u1161\u1105\u1161\u11AB\u1109\u1162\u11A8","\u1111\u1161\u110B\u1175\u11AF","\u1111\u1161\u110E\u116E\u11AF\u1109\u1169","\u1111\u1161\u11AB\u1100\u1167\u11AF","\u1111\u1161\u11AB\u1103\u1161\u11AB","\u1111\u1161\u11AB\u1106\u1162","\u1111\u1161\u11AB\u1109\u1161","\u1111\u1161\u11AF\u1109\u1175\u11B8","\u1111\u1161\u11AF\u110B\u116F\u11AF","\u1111\u1161\u11B8\u1109\u1169\u11BC","\u1111\u1162\u1109\u1167\u11AB","\u1111\u1162\u11A8\u1109\u1173","\u1111\u1162\u11A8\u1109\u1175\u1106\u1175\u11AF\u1105\u1175","\u1111\u1162\u11AB\u1110\u1175","\u1111\u1165\u1109\u1166\u11AB\u1110\u1173","\u1111\u1166\u110B\u1175\u11AB\u1110\u1173","\u1111\u1167\u11AB\u1100\u1167\u11AB","\u1111\u1167\u11AB\u110B\u1174","\u1111\u1167\u11AB\u110C\u1175","\u1111\u1167\u11AB\u1112\u1175","\u1111\u1167\u11BC\u1100\u1161","\u1111\u1167\u11BC\u1100\u1172\u11AB","\u1111\u1167\u11BC\u1109\u1162\u11BC","\u1111\u1167\u11BC\u1109\u1169","\u1111\u1167\u11BC\u110B\u1163\u11BC","\u1111\u1167\u11BC\u110B\u1175\u11AF","\u1111\u1167\u11BC\u1112\u116A","\u1111\u1169\u1109\u1173\u1110\u1165","\u1111\u1169\u110B\u1175\u11AB\u1110\u1173","\u1111\u1169\u110C\u1161\u11BC","\u1111\u1169\u1112\u1161\u11B7","\u1111\u116D\u1106\u1167\u11AB","\u1111\u116D\u110C\u1165\u11BC","\u1111\u116D\u110C\u116E\u11AB","\u1111\u116D\u1112\u1167\u11AB","\u1111\u116E\u11B7\u1106\u1169\u11A8","\u1111\u116E\u11B7\u110C\u1175\u11AF","\u1111\u116E\u11BC\u1100\u1167\u11BC","\u1111\u116E\u11BC\u1109\u1169\u11A8","\u1111\u116E\u11BC\u1109\u1173\u11B8","\u1111\u1173\u1105\u1161\u11BC\u1109\u1173","\u1111\u1173\u1105\u1175\u11AB\u1110\u1165","\u1111\u1173\u11AF\u1105\u1161\u1109\u1173\u1110\u1175\u11A8","\u1111\u1175\u1100\u1169\u11AB","\u1111\u1175\u1106\u1161\u11BC","\u1111\u1175\u110B\u1161\u1102\u1169","\u1111\u1175\u11AF\u1105\u1173\u11B7","\u1111\u1175\u11AF\u1109\u116E","\u1111\u1175\u11AF\u110B\u116D","\u1111\u1175\u11AF\u110C\u1161","\u1111\u1175\u11AF\u1110\u1169\u11BC","\u1111\u1175\u11BC\u1100\u1168","\u1112\u1161\u1102\u1173\u1102\u1175\u11B7","\u1112\u1161\u1102\u1173\u11AF","\u1112\u1161\u1103\u1173\u110B\u1170\u110B\u1165","\u1112\u1161\u1105\u116E\u11BA\u1107\u1161\u11B7","\u1112\u1161\u1107\u1161\u11AB\u1100\u1175","\u1112\u1161\u1109\u116E\u11A8\u110C\u1175\u11B8","\u1112\u1161\u1109\u116E\u11AB","\u1112\u1161\u110B\u1167\u1110\u1173\u11AB","\u1112\u1161\u110C\u1175\u1106\u1161\u11AB","\u1112\u1161\u110E\u1165\u11AB","\u1112\u1161\u1111\u116E\u11B7","\u1112\u1161\u1111\u1175\u11AF","\u1112\u1161\u11A8\u1100\u116A","\u1112\u1161\u11A8\u1100\u116D","\u1112\u1161\u11A8\u1100\u1173\u11B8","\u1112\u1161\u11A8\u1100\u1175","\u1112\u1161\u11A8\u1102\u1167\u11AB","\u1112\u1161\u11A8\u1105\u1167\u11A8","\u1112\u1161\u11A8\u1107\u1165\u11AB","\u1112\u1161\u11A8\u1107\u116E\u1106\u1169","\u1112\u1161\u11A8\u1107\u1175","\u1112\u1161\u11A8\u1109\u1162\u11BC","\u1112\u1161\u11A8\u1109\u116E\u11AF","\u1112\u1161\u11A8\u1109\u1173\u11B8","\u1112\u1161\u11A8\u110B\u116D\u11BC\u1111\u116E\u11B7","\u1112\u1161\u11A8\u110B\u116F\u11AB","\u1112\u1161\u11A8\u110B\u1171","\u1112\u1161\u11A8\u110C\u1161","\u1112\u1161\u11A8\u110C\u1165\u11B7","\u1112\u1161\u11AB\u1100\u1168","\u1112\u1161\u11AB\u1100\u1173\u11AF","\u1112\u1161\u11AB\u1101\u1165\u1107\u1165\u11AB\u110B\u1166","\u1112\u1161\u11AB\u1102\u1161\u11BD","\u1112\u1161\u11AB\u1102\u116E\u11AB","\u1112\u1161\u11AB\u1103\u1169\u11BC\u110B\u1161\u11AB","\u1112\u1161\u11AB\u1104\u1162","\u1112\u1161\u11AB\u1105\u1161\u1109\u1161\u11AB","\u1112\u1161\u11AB\u1106\u1161\u1103\u1175","\u1112\u1161\u11AB\u1106\u116E\u11AB","\u1112\u1161\u11AB\u1107\u1165\u11AB","\u1112\u1161\u11AB\u1107\u1169\u11A8","\u1112\u1161\u11AB\u1109\u1175\u11A8","\u1112\u1161\u11AB\u110B\u1167\u1105\u1173\u11B7","\u1112\u1161\u11AB\u110D\u1169\u11A8","\u1112\u1161\u11AF\u1106\u1165\u1102\u1175","\u1112\u1161\u11AF\u110B\u1161\u1107\u1165\u110C\u1175","\u1112\u1161\u11AF\u110B\u1175\u11AB","\u1112\u1161\u11B7\u1101\u1166","\u1112\u1161\u11B7\u1107\u116E\u1105\u1169","\u1112\u1161\u11B8\u1100\u1167\u11A8","\u1112\u1161\u11B8\u1105\u1175\u110C\u1165\u11A8","\u1112\u1161\u11BC\u1100\u1169\u11BC","\u1112\u1161\u11BC\u1100\u116E","\u1112\u1161\u11BC\u1109\u1161\u11BC","\u1112\u1161\u11BC\u110B\u1174","\u1112\u1162\u1100\u1167\u11AF","\u1112\u1162\u1100\u116E\u11AB","\u1112\u1162\u1103\u1161\u11B8","\u1112\u1162\u1103\u1161\u11BC","\u1112\u1162\u1106\u116E\u11AF","\u1112\u1162\u1109\u1165\u11A8","\u1112\u1162\u1109\u1165\u11AF","\u1112\u1162\u1109\u116E\u110B\u116D\u11A8\u110C\u1161\u11BC","\u1112\u1162\u110B\u1161\u11AB","\u1112\u1162\u11A8\u1109\u1175\u11B7","\u1112\u1162\u11AB\u1103\u1173\u1107\u1162\u11A8","\u1112\u1162\u11B7\u1107\u1165\u1100\u1165","\u1112\u1162\u11BA\u1107\u1167\u11C0","\u1112\u1162\u11BA\u1109\u1161\u11AF","\u1112\u1162\u11BC\u1103\u1169\u11BC","\u1112\u1162\u11BC\u1107\u1169\u11A8","\u1112\u1162\u11BC\u1109\u1161","\u1112\u1162\u11BC\u110B\u116E\u11AB","\u1112\u1162\u11BC\u110B\u1171","\u1112\u1163\u11BC\u1100\u1175","\u1112\u1163\u11BC\u1109\u1161\u11BC","\u1112\u1163\u11BC\u1109\u116E","\u1112\u1165\u1105\u1161\u11A8","\u1112\u1165\u110B\u116D\u11BC","\u1112\u1166\u11AF\u1100\u1175","\u1112\u1167\u11AB\u1100\u116A\u11AB","\u1112\u1167\u11AB\u1100\u1173\u11B7","\u1112\u1167\u11AB\u1103\u1162","\u1112\u1167\u11AB\u1109\u1161\u11BC","\u1112\u1167\u11AB\u1109\u1175\u11AF","\u1112\u1167\u11AB\u110C\u1161\u11BC","\u1112\u1167\u11AB\u110C\u1162","\u1112\u1167\u11AB\u110C\u1175","\u1112\u1167\u11AF\u110B\u1162\u11A8","\u1112\u1167\u11B8\u1105\u1167\u11A8","\u1112\u1167\u11BC\u1107\u116E","\u1112\u1167\u11BC\u1109\u1161","\u1112\u1167\u11BC\u1109\u116E","\u1112\u1167\u11BC\u1109\u1175\u11A8","\u1112\u1167\u11BC\u110C\u1166","\u1112\u1167\u11BC\u1110\u1162","\u1112\u1167\u11BC\u1111\u1167\u11AB","\u1112\u1168\u1110\u1162\u11A8","\u1112\u1169\u1100\u1175\u1109\u1175\u11B7","\u1112\u1169\u1102\u1161\u11B7","\u1112\u1169\u1105\u1161\u11BC\u110B\u1175","\u1112\u1169\u1107\u1161\u11A8","\u1112\u1169\u1110\u1166\u11AF","\u1112\u1169\u1112\u1173\u11B8","\u1112\u1169\u11A8\u1109\u1175","\u1112\u1169\u11AF\u1105\u1169","\u1112\u1169\u11B7\u1111\u1166\u110B\u1175\u110C\u1175","\u1112\u1169\u11BC\u1107\u1169","\u1112\u1169\u11BC\u1109\u116E","\u1112\u1169\u11BC\u110E\u1161","\u1112\u116A\u1106\u1167\u11AB","\u1112\u116A\u1107\u116E\u11AB","\u1112\u116A\u1109\u1161\u11AF","\u1112\u116A\u110B\u116D\u110B\u1175\u11AF","\u1112\u116A\u110C\u1161\u11BC","\u1112\u116A\u1112\u1161\u11A8","\u1112\u116A\u11A8\u1107\u1169","\u1112\u116A\u11A8\u110B\u1175\u11AB","\u1112\u116A\u11A8\u110C\u1161\u11BC","\u1112\u116A\u11A8\u110C\u1165\u11BC","\u1112\u116A\u11AB\u1100\u1161\u11B8","\u1112\u116A\u11AB\u1100\u1167\u11BC","\u1112\u116A\u11AB\u110B\u1167\u11BC","\u1112\u116A\u11AB\u110B\u1172\u11AF","\u1112\u116A\u11AB\u110C\u1161","\u1112\u116A\u11AF\u1100\u1175","\u1112\u116A\u11AF\u1103\u1169\u11BC","\u1112\u116A\u11AF\u1107\u1161\u11AF\u1112\u1175","\u1112\u116A\u11AF\u110B\u116D\u11BC","\u1112\u116A\u11AF\u110D\u1161\u11A8","\u1112\u116C\u1100\u1167\u11AB","\u1112\u116C\u1100\u116A\u11AB","\u1112\u116C\u1107\u1169\u11A8","\u1112\u116C\u1109\u1162\u11A8","\u1112\u116C\u110B\u116F\u11AB","\u1112\u116C\u110C\u1161\u11BC","\u1112\u116C\u110C\u1165\u11AB","\u1112\u116C\u11BA\u1109\u116E","\u1112\u116C\u11BC\u1103\u1161\u11AB\u1107\u1169\u1103\u1169","\u1112\u116D\u110B\u1172\u11AF\u110C\u1165\u11A8","\u1112\u116E\u1107\u1161\u11AB","\u1112\u116E\u110E\u116E\u11BA\u1100\u1161\u1105\u116E","\u1112\u116E\u11AB\u1105\u1167\u11AB","\u1112\u116F\u11AF\u110A\u1175\u11AB","\u1112\u1172\u1109\u1175\u11A8","\u1112\u1172\u110B\u1175\u11AF","\u1112\u1172\u11BC\u1102\u1162","\u1112\u1173\u1105\u1173\u11B7","\u1112\u1173\u11A8\u1107\u1162\u11A8","\u1112\u1173\u11A8\u110B\u1175\u11AB","\u1112\u1173\u11AB\u110C\u1165\u11A8","\u1112\u1173\u11AB\u1112\u1175","\u1112\u1173\u11BC\u1106\u1175","\u1112\u1173\u11BC\u1107\u116E\u11AB","\u1112\u1174\u1100\u1169\u11A8","\u1112\u1174\u1106\u1161\u11BC","\u1112\u1174\u1109\u1162\u11BC","\u1112\u1174\u11AB\u1109\u1162\u11A8","\u1112\u1175\u11B7\u1101\u1165\u11BA"]');

});

parcelRegister("bjYTx", function(module, exports) {
module.exports = JSON.parse('["abaisser","abandon","abdiquer","abeille","abolir","aborder","aboutir","aboyer","abrasif","abreuver","abriter","abroger","abrupt","absence","absolu","absurde","abusif","abyssal","acade\u0301mie","acajou","acarien","accabler","accepter","acclamer","accolade","accroche","accuser","acerbe","achat","acheter","aciduler","acier","acompte","acque\u0301rir","acronyme","acteur","actif","actuel","adepte","ade\u0301quat","adhe\u0301sif","adjectif","adjuger","admettre","admirer","adopter","adorer","adoucir","adresse","adroit","adulte","adverbe","ae\u0301rer","ae\u0301ronef","affaire","affecter","affiche","affreux","affubler","agacer","agencer","agile","agiter","agrafer","agre\u0301able","agrume","aider","aiguille","ailier","aimable","aisance","ajouter","ajuster","alarmer","alchimie","alerte","alge\u0300bre","algue","alie\u0301ner","aliment","alle\u0301ger","alliage","allouer","allumer","alourdir","alpaga","altesse","alve\u0301ole","amateur","ambigu","ambre","ame\u0301nager","amertume","amidon","amiral","amorcer","amour","amovible","amphibie","ampleur","amusant","analyse","anaphore","anarchie","anatomie","ancien","ane\u0301antir","angle","angoisse","anguleux","animal","annexer","annonce","annuel","anodin","anomalie","anonyme","anormal","antenne","antidote","anxieux","apaiser","ape\u0301ritif","aplanir","apologie","appareil","appeler","apporter","appuyer","aquarium","aqueduc","arbitre","arbuste","ardeur","ardoise","argent","arlequin","armature","armement","armoire","armure","arpenter","arracher","arriver","arroser","arsenic","arte\u0301riel","article","aspect","asphalte","aspirer","assaut","asservir","assiette","associer","assurer","asticot","astre","astuce","atelier","atome","atrium","atroce","attaque","attentif","attirer","attraper","aubaine","auberge","audace","audible","augurer","aurore","automne","autruche","avaler","avancer","avarice","avenir","averse","aveugle","aviateur","avide","avion","aviser","avoine","avouer","avril","axial","axiome","badge","bafouer","bagage","baguette","baignade","balancer","balcon","baleine","balisage","bambin","bancaire","bandage","banlieue","bannie\u0300re","banquier","barbier","baril","baron","barque","barrage","bassin","bastion","bataille","bateau","batterie","baudrier","bavarder","belette","be\u0301lier","belote","be\u0301ne\u0301fice","berceau","berger","berline","bermuda","besace","besogne","be\u0301tail","beurre","biberon","bicycle","bidule","bijou","bilan","bilingue","billard","binaire","biologie","biopsie","biotype","biscuit","bison","bistouri","bitume","bizarre","blafard","blague","blanchir","blessant","blinder","blond","bloquer","blouson","bobard","bobine","boire","boiser","bolide","bonbon","bondir","bonheur","bonifier","bonus","bordure","borne","botte","boucle","boueux","bougie","boulon","bouquin","bourse","boussole","boutique","boxeur","branche","brasier","brave","brebis","bre\u0300che","breuvage","bricoler","brigade","brillant","brioche","brique","brochure","broder","bronzer","brousse","broyeur","brume","brusque","brutal","bruyant","buffle","buisson","bulletin","bureau","burin","bustier","butiner","butoir","buvable","buvette","cabanon","cabine","cachette","cadeau","cadre","cafe\u0301ine","caillou","caisson","calculer","calepin","calibre","calmer","calomnie","calvaire","camarade","came\u0301ra","camion","campagne","canal","caneton","canon","cantine","canular","capable","caporal","caprice","capsule","capter","capuche","carabine","carbone","caresser","caribou","carnage","carotte","carreau","carton","cascade","casier","casque","cassure","causer","caution","cavalier","caverne","caviar","ce\u0301dille","ceinture","ce\u0301leste","cellule","cendrier","censurer","central","cercle","ce\u0301re\u0301bral","cerise","cerner","cerveau","cesser","chagrin","chaise","chaleur","chambre","chance","chapitre","charbon","chasseur","chaton","chausson","chavirer","chemise","chenille","che\u0301quier","chercher","cheval","chien","chiffre","chignon","chime\u0300re","chiot","chlorure","chocolat","choisir","chose","chouette","chrome","chute","cigare","cigogne","cimenter","cine\u0301ma","cintrer","circuler","cirer","cirque","citerne","citoyen","citron","civil","clairon","clameur","claquer","classe","clavier","client","cligner","climat","clivage","cloche","clonage","cloporte","cobalt","cobra","cocasse","cocotier","coder","codifier","coffre","cogner","cohe\u0301sion","coiffer","coincer","cole\u0300re","colibri","colline","colmater","colonel","combat","come\u0301die","commande","compact","concert","conduire","confier","congeler","connoter","consonne","contact","convexe","copain","copie","corail","corbeau","cordage","corniche","corpus","correct","corte\u0300ge","cosmique","costume","coton","coude","coupure","courage","couteau","couvrir","coyote","crabe","crainte","cravate","crayon","cre\u0301ature","cre\u0301diter","cre\u0301meux","creuser","crevette","cribler","crier","cristal","crite\u0300re","croire","croquer","crotale","crucial","cruel","crypter","cubique","cueillir","cuille\u0300re","cuisine","cuivre","culminer","cultiver","cumuler","cupide","curatif","curseur","cyanure","cycle","cylindre","cynique","daigner","damier","danger","danseur","dauphin","de\u0301battre","de\u0301biter","de\u0301border","de\u0301brider","de\u0301butant","de\u0301caler","de\u0301cembre","de\u0301chirer","de\u0301cider","de\u0301clarer","de\u0301corer","de\u0301crire","de\u0301cupler","de\u0301dale","de\u0301ductif","de\u0301esse","de\u0301fensif","de\u0301filer","de\u0301frayer","de\u0301gager","de\u0301givrer","de\u0301glutir","de\u0301grafer","de\u0301jeuner","de\u0301lice","de\u0301loger","demander","demeurer","de\u0301molir","de\u0301nicher","de\u0301nouer","dentelle","de\u0301nuder","de\u0301part","de\u0301penser","de\u0301phaser","de\u0301placer","de\u0301poser","de\u0301ranger","de\u0301rober","de\u0301sastre","descente","de\u0301sert","de\u0301signer","de\u0301sobe\u0301ir","dessiner","destrier","de\u0301tacher","de\u0301tester","de\u0301tourer","de\u0301tresse","devancer","devenir","deviner","devoir","diable","dialogue","diamant","dicter","diffe\u0301rer","dige\u0301rer","digital","digne","diluer","dimanche","diminuer","dioxyde","directif","diriger","discuter","disposer","dissiper","distance","divertir","diviser","docile","docteur","dogme","doigt","domaine","domicile","dompter","donateur","donjon","donner","dopamine","dortoir","dorure","dosage","doseur","dossier","dotation","douanier","double","douceur","douter","doyen","dragon","draper","dresser","dribbler","droiture","duperie","duplexe","durable","durcir","dynastie","e\u0301blouir","e\u0301carter","e\u0301charpe","e\u0301chelle","e\u0301clairer","e\u0301clipse","e\u0301clore","e\u0301cluse","e\u0301cole","e\u0301conomie","e\u0301corce","e\u0301couter","e\u0301craser","e\u0301cre\u0301mer","e\u0301crivain","e\u0301crou","e\u0301cume","e\u0301cureuil","e\u0301difier","e\u0301duquer","effacer","effectif","effigie","effort","effrayer","effusion","e\u0301galiser","e\u0301garer","e\u0301jecter","e\u0301laborer","e\u0301largir","e\u0301lectron","e\u0301le\u0301gant","e\u0301le\u0301phant","e\u0301le\u0300ve","e\u0301ligible","e\u0301litisme","e\u0301loge","e\u0301lucider","e\u0301luder","emballer","embellir","embryon","e\u0301meraude","e\u0301mission","emmener","e\u0301motion","e\u0301mouvoir","empereur","employer","emporter","emprise","e\u0301mulsion","encadrer","enche\u0300re","enclave","encoche","endiguer","endosser","endroit","enduire","e\u0301nergie","enfance","enfermer","enfouir","engager","engin","englober","e\u0301nigme","enjamber","enjeu","enlever","ennemi","ennuyeux","enrichir","enrobage","enseigne","entasser","entendre","entier","entourer","entraver","e\u0301nume\u0301rer","envahir","enviable","envoyer","enzyme","e\u0301olien","e\u0301paissir","e\u0301pargne","e\u0301patant","e\u0301paule","e\u0301picerie","e\u0301pide\u0301mie","e\u0301pier","e\u0301pilogue","e\u0301pine","e\u0301pisode","e\u0301pitaphe","e\u0301poque","e\u0301preuve","e\u0301prouver","e\u0301puisant","e\u0301querre","e\u0301quipe","e\u0301riger","e\u0301rosion","erreur","e\u0301ruption","escalier","espadon","espe\u0300ce","espie\u0300gle","espoir","esprit","esquiver","essayer","essence","essieu","essorer","estime","estomac","estrade","e\u0301tage\u0300re","e\u0301taler","e\u0301tanche","e\u0301tatique","e\u0301teindre","e\u0301tendoir","e\u0301ternel","e\u0301thanol","e\u0301thique","ethnie","e\u0301tirer","e\u0301toffer","e\u0301toile","e\u0301tonnant","e\u0301tourdir","e\u0301trange","e\u0301troit","e\u0301tude","euphorie","e\u0301valuer","e\u0301vasion","e\u0301ventail","e\u0301vidence","e\u0301viter","e\u0301volutif","e\u0301voquer","exact","exage\u0301rer","exaucer","exceller","excitant","exclusif","excuse","exe\u0301cuter","exemple","exercer","exhaler","exhorter","exigence","exiler","exister","exotique","expe\u0301dier","explorer","exposer","exprimer","exquis","extensif","extraire","exulter","fable","fabuleux","facette","facile","facture","faiblir","falaise","fameux","famille","farceur","farfelu","farine","farouche","fasciner","fatal","fatigue","faucon","fautif","faveur","favori","fe\u0301brile","fe\u0301conder","fe\u0301de\u0301rer","fe\u0301lin","femme","fe\u0301mur","fendoir","fe\u0301odal","fermer","fe\u0301roce","ferveur","festival","feuille","feutre","fe\u0301vrier","fiasco","ficeler","fictif","fide\u0300le","figure","filature","filetage","filie\u0300re","filleul","filmer","filou","filtrer","financer","finir","fiole","firme","fissure","fixer","flairer","flamme","flasque","flatteur","fle\u0301au","fle\u0300che","fleur","flexion","flocon","flore","fluctuer","fluide","fluvial","folie","fonderie","fongible","fontaine","forcer","forgeron","formuler","fortune","fossile","foudre","fouge\u0300re","fouiller","foulure","fourmi","fragile","fraise","franchir","frapper","frayeur","fre\u0301gate","freiner","frelon","fre\u0301mir","fre\u0301ne\u0301sie","fre\u0300re","friable","friction","frisson","frivole","froid","fromage","frontal","frotter","fruit","fugitif","fuite","fureur","furieux","furtif","fusion","futur","gagner","galaxie","galerie","gambader","garantir","gardien","garnir","garrigue","gazelle","gazon","ge\u0301ant","ge\u0301latine","ge\u0301lule","gendarme","ge\u0301ne\u0301ral","ge\u0301nie","genou","gentil","ge\u0301ologie","ge\u0301ome\u0300tre","ge\u0301ranium","germe","gestuel","geyser","gibier","gicler","girafe","givre","glace","glaive","glisser","globe","gloire","glorieux","golfeur","gomme","gonfler","gorge","gorille","goudron","gouffre","goulot","goupille","gourmand","goutte","graduel","graffiti","graine","grand","grappin","gratuit","gravir","grenat","griffure","griller","grimper","grogner","gronder","grotte","groupe","gruger","grutier","gruye\u0300re","gue\u0301pard","guerrier","guide","guimauve","guitare","gustatif","gymnaste","gyrostat","habitude","hachoir","halte","hameau","hangar","hanneton","haricot","harmonie","harpon","hasard","he\u0301lium","he\u0301matome","herbe","he\u0301risson","hermine","he\u0301ron","he\u0301siter","heureux","hiberner","hibou","hilarant","histoire","hiver","homard","hommage","homoge\u0300ne","honneur","honorer","honteux","horde","horizon","horloge","hormone","horrible","houleux","housse","hublot","huileux","humain","humble","humide","humour","hurler","hydromel","hygie\u0300ne","hymne","hypnose","idylle","ignorer","iguane","illicite","illusion","image","imbiber","imiter","immense","immobile","immuable","impact","impe\u0301rial","implorer","imposer","imprimer","imputer","incarner","incendie","incident","incliner","incolore","indexer","indice","inductif","ine\u0301dit","ineptie","inexact","infini","infliger","informer","infusion","inge\u0301rer","inhaler","inhiber","injecter","injure","innocent","inoculer","inonder","inscrire","insecte","insigne","insolite","inspirer","instinct","insulter","intact","intense","intime","intrigue","intuitif","inutile","invasion","inventer","inviter","invoquer","ironique","irradier","irre\u0301el","irriter","isoler","ivoire","ivresse","jaguar","jaillir","jambe","janvier","jardin","jauger","jaune","javelot","jetable","jeton","jeudi","jeunesse","joindre","joncher","jongler","joueur","jouissif","journal","jovial","joyau","joyeux","jubiler","jugement","junior","jupon","juriste","justice","juteux","juve\u0301nile","kayak","kimono","kiosque","label","labial","labourer","lace\u0301rer","lactose","lagune","laine","laisser","laitier","lambeau","lamelle","lampe","lanceur","langage","lanterne","lapin","largeur","larme","laurier","lavabo","lavoir","lecture","le\u0301gal","le\u0301ger","le\u0301gume","lessive","lettre","levier","lexique","le\u0301zard","liasse","libe\u0301rer","libre","licence","licorne","lie\u0300ge","lie\u0300vre","ligature","ligoter","ligue","limer","limite","limonade","limpide","line\u0301aire","lingot","lionceau","liquide","lisie\u0300re","lister","lithium","litige","littoral","livreur","logique","lointain","loisir","lombric","loterie","louer","lourd","loutre","louve","loyal","lubie","lucide","lucratif","lueur","lugubre","luisant","lumie\u0300re","lunaire","lundi","luron","lutter","luxueux","machine","magasin","magenta","magique","maigre","maillon","maintien","mairie","maison","majorer","malaxer","male\u0301fice","malheur","malice","mallette","mammouth","mandater","maniable","manquant","manteau","manuel","marathon","marbre","marchand","mardi","maritime","marqueur","marron","marteler","mascotte","massif","mate\u0301riel","matie\u0300re","matraque","maudire","maussade","mauve","maximal","me\u0301chant","me\u0301connu","me\u0301daille","me\u0301decin","me\u0301diter","me\u0301duse","meilleur","me\u0301lange","me\u0301lodie","membre","me\u0301moire","menacer","mener","menhir","mensonge","mentor","mercredi","me\u0301rite","merle","messager","mesure","me\u0301tal","me\u0301te\u0301ore","me\u0301thode","me\u0301tier","meuble","miauler","microbe","miette","mignon","migrer","milieu","million","mimique","mince","mine\u0301ral","minimal","minorer","minute","miracle","miroiter","missile","mixte","mobile","moderne","moelleux","mondial","moniteur","monnaie","monotone","monstre","montagne","monument","moqueur","morceau","morsure","mortier","moteur","motif","mouche","moufle","moulin","mousson","mouton","mouvant","multiple","munition","muraille","mure\u0300ne","murmure","muscle","muse\u0301um","musicien","mutation","muter","mutuel","myriade","myrtille","myste\u0300re","mythique","nageur","nappe","narquois","narrer","natation","nation","nature","naufrage","nautique","navire","ne\u0301buleux","nectar","ne\u0301faste","ne\u0301gation","ne\u0301gliger","ne\u0301gocier","neige","nerveux","nettoyer","neurone","neutron","neveu","niche","nickel","nitrate","niveau","noble","nocif","nocturne","noirceur","noisette","nomade","nombreux","nommer","normatif","notable","notifier","notoire","nourrir","nouveau","novateur","novembre","novice","nuage","nuancer","nuire","nuisible","nume\u0301ro","nuptial","nuque","nutritif","obe\u0301ir","objectif","obliger","obscur","observer","obstacle","obtenir","obturer","occasion","occuper","oce\u0301an","octobre","octroyer","octupler","oculaire","odeur","odorant","offenser","officier","offrir","ogive","oiseau","oisillon","olfactif","olivier","ombrage","omettre","onctueux","onduler","one\u0301reux","onirique","opale","opaque","ope\u0301rer","opinion","opportun","opprimer","opter","optique","orageux","orange","orbite","ordonner","oreille","organe","orgueil","orifice","ornement","orque","ortie","osciller","osmose","ossature","otarie","ouragan","ourson","outil","outrager","ouvrage","ovation","oxyde","oxyge\u0300ne","ozone","paisible","palace","palmare\u0300s","palourde","palper","panache","panda","pangolin","paniquer","panneau","panorama","pantalon","papaye","papier","papoter","papyrus","paradoxe","parcelle","paresse","parfumer","parler","parole","parrain","parsemer","partager","parure","parvenir","passion","paste\u0300que","paternel","patience","patron","pavillon","pavoiser","payer","paysage","peigne","peintre","pelage","pe\u0301lican","pelle","pelouse","peluche","pendule","pe\u0301ne\u0301trer","pe\u0301nible","pensif","pe\u0301nurie","pe\u0301pite","pe\u0301plum","perdrix","perforer","pe\u0301riode","permuter","perplexe","persil","perte","peser","pe\u0301tale","petit","pe\u0301trir","peuple","pharaon","phobie","phoque","photon","phrase","physique","piano","pictural","pie\u0300ce","pierre","pieuvre","pilote","pinceau","pipette","piquer","pirogue","piscine","piston","pivoter","pixel","pizza","placard","plafond","plaisir","planer","plaque","plastron","plateau","pleurer","plexus","pliage","plomb","plonger","pluie","plumage","pochette","poe\u0301sie","poe\u0300te","pointe","poirier","poisson","poivre","polaire","policier","pollen","polygone","pommade","pompier","ponctuel","ponde\u0301rer","poney","portique","position","posse\u0301der","posture","potager","poteau","potion","pouce","poulain","poumon","pourpre","poussin","pouvoir","prairie","pratique","pre\u0301cieux","pre\u0301dire","pre\u0301fixe","pre\u0301lude","pre\u0301nom","pre\u0301sence","pre\u0301texte","pre\u0301voir","primitif","prince","prison","priver","proble\u0300me","proce\u0301der","prodige","profond","progre\u0300s","proie","projeter","prologue","promener","propre","prospe\u0300re","prote\u0301ger","prouesse","proverbe","prudence","pruneau","psychose","public","puceron","puiser","pulpe","pulsar","punaise","punitif","pupitre","purifier","puzzle","pyramide","quasar","querelle","question","quie\u0301tude","quitter","quotient","racine","raconter","radieux","ragondin","raideur","raisin","ralentir","rallonge","ramasser","rapide","rasage","ratisser","ravager","ravin","rayonner","re\u0301actif","re\u0301agir","re\u0301aliser","re\u0301animer","recevoir","re\u0301citer","re\u0301clamer","re\u0301colter","recruter","reculer","recycler","re\u0301diger","redouter","refaire","re\u0301flexe","re\u0301former","refrain","refuge","re\u0301galien","re\u0301gion","re\u0301glage","re\u0301gulier","re\u0301ite\u0301rer","rejeter","rejouer","relatif","relever","relief","remarque","reme\u0300de","remise","remonter","remplir","remuer","renard","renfort","renifler","renoncer","rentrer","renvoi","replier","reporter","reprise","reptile","requin","re\u0301serve","re\u0301sineux","re\u0301soudre","respect","rester","re\u0301sultat","re\u0301tablir","retenir","re\u0301ticule","retomber","retracer","re\u0301union","re\u0301ussir","revanche","revivre","re\u0301volte","re\u0301vulsif","richesse","rideau","rieur","rigide","rigoler","rincer","riposter","risible","risque","rituel","rival","rivie\u0300re","rocheux","romance","rompre","ronce","rondin","roseau","rosier","rotatif","rotor","rotule","rouge","rouille","rouleau","routine","royaume","ruban","rubis","ruche","ruelle","rugueux","ruiner","ruisseau","ruser","rustique","rythme","sabler","saboter","sabre","sacoche","safari","sagesse","saisir","salade","salive","salon","saluer","samedi","sanction","sanglier","sarcasme","sardine","saturer","saugrenu","saumon","sauter","sauvage","savant","savonner","scalpel","scandale","sce\u0301le\u0301rat","sce\u0301nario","sceptre","sche\u0301ma","science","scinder","score","scrutin","sculpter","se\u0301ance","se\u0301cable","se\u0301cher","secouer","se\u0301cre\u0301ter","se\u0301datif","se\u0301duire","seigneur","se\u0301jour","se\u0301lectif","semaine","sembler","semence","se\u0301minal","se\u0301nateur","sensible","sentence","se\u0301parer","se\u0301quence","serein","sergent","se\u0301rieux","serrure","se\u0301rum","service","se\u0301same","se\u0301vir","sevrage","sextuple","side\u0301ral","sie\u0300cle","sie\u0301ger","siffler","sigle","signal","silence","silicium","simple","since\u0300re","sinistre","siphon","sirop","sismique","situer","skier","social","socle","sodium","soigneux","soldat","soleil","solitude","soluble","sombre","sommeil","somnoler","sonde","songeur","sonnette","sonore","sorcier","sortir","sosie","sottise","soucieux","soudure","souffle","soulever","soupape","source","soutirer","souvenir","spacieux","spatial","spe\u0301cial","sphe\u0300re","spiral","stable","station","sternum","stimulus","stipuler","strict","studieux","stupeur","styliste","sublime","substrat","subtil","subvenir","succe\u0300s","sucre","suffixe","sugge\u0301rer","suiveur","sulfate","superbe","supplier","surface","suricate","surmener","surprise","sursaut","survie","suspect","syllabe","symbole","syme\u0301trie","synapse","syntaxe","syste\u0300me","tabac","tablier","tactile","tailler","talent","talisman","talonner","tambour","tamiser","tangible","tapis","taquiner","tarder","tarif","tartine","tasse","tatami","tatouage","taupe","taureau","taxer","te\u0301moin","temporel","tenaille","tendre","teneur","tenir","tension","terminer","terne","terrible","te\u0301tine","texte","the\u0300me","the\u0301orie","the\u0301rapie","thorax","tibia","tie\u0300de","timide","tirelire","tiroir","tissu","titane","titre","tituber","toboggan","tole\u0301rant","tomate","tonique","tonneau","toponyme","torche","tordre","tornade","torpille","torrent","torse","tortue","totem","toucher","tournage","tousser","toxine","traction","trafic","tragique","trahir","train","trancher","travail","tre\u0300fle","tremper","tre\u0301sor","treuil","triage","tribunal","tricoter","trilogie","triomphe","tripler","triturer","trivial","trombone","tronc","tropical","troupeau","tuile","tulipe","tumulte","tunnel","turbine","tuteur","tutoyer","tuyau","tympan","typhon","typique","tyran","ubuesque","ultime","ultrason","unanime","unifier","union","unique","unitaire","univers","uranium","urbain","urticant","usage","usine","usuel","usure","utile","utopie","vacarme","vaccin","vagabond","vague","vaillant","vaincre","vaisseau","valable","valise","vallon","valve","vampire","vanille","vapeur","varier","vaseux","vassal","vaste","vecteur","vedette","ve\u0301ge\u0301tal","ve\u0301hicule","veinard","ve\u0301loce","vendredi","ve\u0301ne\u0301rer","venger","venimeux","ventouse","verdure","ve\u0301rin","vernir","verrou","verser","vertu","veston","ve\u0301te\u0301ran","ve\u0301tuste","vexant","vexer","viaduc","viande","victoire","vidange","vide\u0301o","vignette","vigueur","vilain","village","vinaigre","violon","vipe\u0300re","virement","virtuose","virus","visage","viseur","vision","visqueux","visuel","vital","vitesse","viticole","vitrine","vivace","vivipare","vocation","voguer","voile","voisin","voiture","volaille","volcan","voltiger","volume","vorace","vortex","voter","vouloir","voyage","voyelle","wagon","xe\u0301non","yacht","ze\u0300bre","ze\u0301nith","zeste","zoologie"]');

});

parcelRegister("4IXW5", function(module, exports) {
module.exports = JSON.parse('["abaco","abbaglio","abbinato","abete","abisso","abolire","abrasivo","abrogato","accadere","accenno","accusato","acetone","achille","acido","acqua","acre","acrilico","acrobata","acuto","adagio","addebito","addome","adeguato","aderire","adipe","adottare","adulare","affabile","affetto","affisso","affranto","aforisma","afoso","africano","agave","agente","agevole","aggancio","agire","agitare","agonismo","agricolo","agrumeto","aguzzo","alabarda","alato","albatro","alberato","albo","albume","alce","alcolico","alettone","alfa","algebra","aliante","alibi","alimento","allagato","allegro","allievo","allodola","allusivo","almeno","alogeno","alpaca","alpestre","altalena","alterno","alticcio","altrove","alunno","alveolo","alzare","amalgama","amanita","amarena","ambito","ambrato","ameba","america","ametista","amico","ammasso","ammenda","ammirare","ammonito","amore","ampio","ampliare","amuleto","anacardo","anagrafe","analista","anarchia","anatra","anca","ancella","ancora","andare","andrea","anello","angelo","angolare","angusto","anima","annegare","annidato","anno","annuncio","anonimo","anticipo","anzi","apatico","apertura","apode","apparire","appetito","appoggio","approdo","appunto","aprile","arabica","arachide","aragosta","araldica","arancio","aratura","arazzo","arbitro","archivio","ardito","arenile","argento","argine","arguto","aria","armonia","arnese","arredato","arringa","arrosto","arsenico","arso","artefice","arzillo","asciutto","ascolto","asepsi","asettico","asfalto","asino","asola","aspirato","aspro","assaggio","asse","assoluto","assurdo","asta","astenuto","astice","astratto","atavico","ateismo","atomico","atono","attesa","attivare","attorno","attrito","attuale","ausilio","austria","autista","autonomo","autunno","avanzato","avere","avvenire","avviso","avvolgere","azione","azoto","azzimo","azzurro","babele","baccano","bacino","baco","badessa","badilata","bagnato","baita","balcone","baldo","balena","ballata","balzano","bambino","bandire","baraonda","barbaro","barca","baritono","barlume","barocco","basilico","basso","batosta","battuto","baule","bava","bavosa","becco","beffa","belgio","belva","benda","benevole","benigno","benzina","bere","berlina","beta","bibita","bici","bidone","bifido","biga","bilancia","bimbo","binocolo","biologo","bipede","bipolare","birbante","birra","biscotto","bisesto","bisnonno","bisonte","bisturi","bizzarro","blando","blatta","bollito","bonifico","bordo","bosco","botanico","bottino","bozzolo","braccio","bradipo","brama","branca","bravura","bretella","brevetto","brezza","briglia","brillante","brindare","broccolo","brodo","bronzina","brullo","bruno","bubbone","buca","budino","buffone","buio","bulbo","buono","burlone","burrasca","bussola","busta","cadetto","caduco","calamaro","calcolo","calesse","calibro","calmo","caloria","cambusa","camerata","camicia","cammino","camola","campale","canapa","candela","cane","canino","canotto","cantina","capace","capello","capitolo","capogiro","cappero","capra","capsula","carapace","carcassa","cardo","carisma","carovana","carretto","cartolina","casaccio","cascata","caserma","caso","cassone","castello","casuale","catasta","catena","catrame","cauto","cavillo","cedibile","cedrata","cefalo","celebre","cellulare","cena","cenone","centesimo","ceramica","cercare","certo","cerume","cervello","cesoia","cespo","ceto","chela","chiaro","chicca","chiedere","chimera","china","chirurgo","chitarra","ciao","ciclismo","cifrare","cigno","cilindro","ciottolo","circa","cirrosi","citrico","cittadino","ciuffo","civetta","civile","classico","clinica","cloro","cocco","codardo","codice","coerente","cognome","collare","colmato","colore","colposo","coltivato","colza","coma","cometa","commando","comodo","computer","comune","conciso","condurre","conferma","congelare","coniuge","connesso","conoscere","consumo","continuo","convegno","coperto","copione","coppia","copricapo","corazza","cordata","coricato","cornice","corolla","corpo","corredo","corsia","cortese","cosmico","costante","cottura","covato","cratere","cravatta","creato","credere","cremoso","crescita","creta","criceto","crinale","crisi","critico","croce","cronaca","crostata","cruciale","crusca","cucire","cuculo","cugino","cullato","cupola","curatore","cursore","curvo","cuscino","custode","dado","daino","dalmata","damerino","daniela","dannoso","danzare","datato","davanti","davvero","debutto","decennio","deciso","declino","decollo","decreto","dedicato","definito","deforme","degno","delegare","delfino","delirio","delta","demenza","denotato","dentro","deposito","derapata","derivare","deroga","descritto","deserto","desiderio","desumere","detersivo","devoto","diametro","dicembre","diedro","difeso","diffuso","digerire","digitale","diluvio","dinamico","dinnanzi","dipinto","diploma","dipolo","diradare","dire","dirotto","dirupo","disagio","discreto","disfare","disgelo","disposto","distanza","disumano","dito","divano","divelto","dividere","divorato","doblone","docente","doganale","dogma","dolce","domato","domenica","dominare","dondolo","dono","dormire","dote","dottore","dovuto","dozzina","drago","druido","dubbio","dubitare","ducale","duna","duomo","duplice","duraturo","ebano","eccesso","ecco","eclissi","economia","edera","edicola","edile","editoria","educare","egemonia","egli","egoismo","egregio","elaborato","elargire","elegante","elencato","eletto","elevare","elfico","elica","elmo","elsa","eluso","emanato","emblema","emesso","emiro","emotivo","emozione","empirico","emulo","endemico","enduro","energia","enfasi","enoteca","entrare","enzima","epatite","epilogo","episodio","epocale","eppure","equatore","erario","erba","erboso","erede","eremita","erigere","ermetico","eroe","erosivo","errante","esagono","esame","esanime","esaudire","esca","esempio","esercito","esibito","esigente","esistere","esito","esofago","esortato","esoso","espanso","espresso","essenza","esso","esteso","estimare","estonia","estroso","esultare","etilico","etnico","etrusco","etto","euclideo","europa","evaso","evidenza","evitato","evoluto","evviva","fabbrica","faccenda","fachiro","falco","famiglia","fanale","fanfara","fango","fantasma","fare","farfalla","farinoso","farmaco","fascia","fastoso","fasullo","faticare","fato","favoloso","febbre","fecola","fede","fegato","felpa","feltro","femmina","fendere","fenomeno","fermento","ferro","fertile","fessura","festivo","fetta","feudo","fiaba","fiducia","fifa","figurato","filo","finanza","finestra","finire","fiore","fiscale","fisico","fiume","flacone","flamenco","flebo","flemma","florido","fluente","fluoro","fobico","focaccia","focoso","foderato","foglio","folata","folclore","folgore","fondente","fonetico","fonia","fontana","forbito","forchetta","foresta","formica","fornaio","foro","fortezza","forzare","fosfato","fosso","fracasso","frana","frassino","fratello","freccetta","frenata","fresco","frigo","frollino","fronde","frugale","frutta","fucilata","fucsia","fuggente","fulmine","fulvo","fumante","fumetto","fumoso","fune","funzione","fuoco","furbo","furgone","furore","fuso","futile","gabbiano","gaffe","galateo","gallina","galoppo","gambero","gamma","garanzia","garbo","garofano","garzone","gasdotto","gasolio","gastrico","gatto","gaudio","gazebo","gazzella","geco","gelatina","gelso","gemello","gemmato","gene","genitore","gennaio","genotipo","gergo","ghepardo","ghiaccio","ghisa","giallo","gilda","ginepro","giocare","gioiello","giorno","giove","girato","girone","gittata","giudizio","giurato","giusto","globulo","glutine","gnomo","gobba","golf","gomito","gommone","gonfio","gonna","governo","gracile","grado","grafico","grammo","grande","grattare","gravoso","grazia","greca","gregge","grifone","grigio","grinza","grotta","gruppo","guadagno","guaio","guanto","guardare","gufo","guidare","ibernato","icona","identico","idillio","idolo","idra","idrico","idrogeno","igiene","ignaro","ignorato","ilare","illeso","illogico","illudere","imballo","imbevuto","imbocco","imbuto","immane","immerso","immolato","impacco","impeto","impiego","importo","impronta","inalare","inarcare","inattivo","incanto","incendio","inchino","incisivo","incluso","incontro","incrocio","incubo","indagine","india","indole","inedito","infatti","infilare","inflitto","ingaggio","ingegno","inglese","ingordo","ingrosso","innesco","inodore","inoltrare","inondato","insano","insetto","insieme","insonnia","insulina","intasato","intero","intonaco","intuito","inumidire","invalido","invece","invito","iperbole","ipnotico","ipotesi","ippica","iride","irlanda","ironico","irrigato","irrorare","isolato","isotopo","isterico","istituto","istrice","italia","iterare","labbro","labirinto","lacca","lacerato","lacrima","lacuna","laddove","lago","lampo","lancetta","lanterna","lardoso","larga","laringe","lastra","latenza","latino","lattuga","lavagna","lavoro","legale","leggero","lembo","lentezza","lenza","leone","lepre","lesivo","lessato","lesto","letterale","leva","levigato","libero","lido","lievito","lilla","limatura","limitare","limpido","lineare","lingua","liquido","lira","lirica","lisca","lite","litigio","livrea","locanda","lode","logica","lombare","londra","longevo","loquace","lorenzo","loto","lotteria","luce","lucidato","lumaca","luminoso","lungo","lupo","luppolo","lusinga","lusso","lutto","macabro","macchina","macero","macinato","madama","magico","maglia","magnete","magro","maiolica","malafede","malgrado","malinteso","malsano","malto","malumore","mana","mancia","mandorla","mangiare","manifesto","mannaro","manovra","mansarda","mantide","manubrio","mappa","maratona","marcire","maretta","marmo","marsupio","maschera","massaia","mastino","materasso","matricola","mattone","maturo","mazurca","meandro","meccanico","mecenate","medesimo","meditare","mega","melassa","melis","melodia","meninge","meno","mensola","mercurio","merenda","merlo","meschino","mese","messere","mestolo","metallo","metodo","mettere","miagolare","mica","micelio","michele","microbo","midollo","miele","migliore","milano","milite","mimosa","minerale","mini","minore","mirino","mirtillo","miscela","missiva","misto","misurare","mitezza","mitigare","mitra","mittente","mnemonico","modello","modifica","modulo","mogano","mogio","mole","molosso","monastero","monco","mondina","monetario","monile","monotono","monsone","montato","monviso","mora","mordere","morsicato","mostro","motivato","motosega","motto","movenza","movimento","mozzo","mucca","mucosa","muffa","mughetto","mugnaio","mulatto","mulinello","multiplo","mummia","munto","muovere","murale","musa","muscolo","musica","mutevole","muto","nababbo","nafta","nanometro","narciso","narice","narrato","nascere","nastrare","naturale","nautica","naviglio","nebulosa","necrosi","negativo","negozio","nemmeno","neofita","neretto","nervo","nessuno","nettuno","neutrale","neve","nevrotico","nicchia","ninfa","nitido","nobile","nocivo","nodo","nome","nomina","nordico","normale","norvegese","nostrano","notare","notizia","notturno","novella","nucleo","nulla","numero","nuovo","nutrire","nuvola","nuziale","oasi","obbedire","obbligo","obelisco","oblio","obolo","obsoleto","occasione","occhio","occidente","occorrere","occultare","ocra","oculato","odierno","odorare","offerta","offrire","offuscato","oggetto","oggi","ognuno","olandese","olfatto","oliato","oliva","ologramma","oltre","omaggio","ombelico","ombra","omega","omissione","ondoso","onere","onice","onnivoro","onorevole","onta","operato","opinione","opposto","oracolo","orafo","ordine","orecchino","orefice","orfano","organico","origine","orizzonte","orma","ormeggio","ornativo","orologio","orrendo","orribile","ortensia","ortica","orzata","orzo","osare","oscurare","osmosi","ospedale","ospite","ossa","ossidare","ostacolo","oste","otite","otre","ottagono","ottimo","ottobre","ovale","ovest","ovino","oviparo","ovocito","ovunque","ovviare","ozio","pacchetto","pace","pacifico","padella","padrone","paese","paga","pagina","palazzina","palesare","pallido","palo","palude","pandoro","pannello","paolo","paonazzo","paprica","parabola","parcella","parere","pargolo","pari","parlato","parola","partire","parvenza","parziale","passivo","pasticca","patacca","patologia","pattume","pavone","peccato","pedalare","pedonale","peggio","peloso","penare","pendice","penisola","pennuto","penombra","pensare","pentola","pepe","pepita","perbene","percorso","perdonato","perforare","pergamena","periodo","permesso","perno","perplesso","persuaso","pertugio","pervaso","pesatore","pesista","peso","pestifero","petalo","pettine","petulante","pezzo","piacere","pianta","piattino","piccino","picozza","piega","pietra","piffero","pigiama","pigolio","pigro","pila","pilifero","pillola","pilota","pimpante","pineta","pinna","pinolo","pioggia","piombo","piramide","piretico","pirite","pirolisi","pitone","pizzico","placebo","planare","plasma","platano","plenario","pochezza","poderoso","podismo","poesia","poggiare","polenta","poligono","pollice","polmonite","polpetta","polso","poltrona","polvere","pomice","pomodoro","ponte","popoloso","porfido","poroso","porpora","porre","portata","posa","positivo","possesso","postulato","potassio","potere","pranzo","prassi","pratica","precluso","predica","prefisso","pregiato","prelievo","premere","prenotare","preparato","presenza","pretesto","prevalso","prima","principe","privato","problema","procura","produrre","profumo","progetto","prolunga","promessa","pronome","proposta","proroga","proteso","prova","prudente","prugna","prurito","psiche","pubblico","pudica","pugilato","pugno","pulce","pulito","pulsante","puntare","pupazzo","pupilla","puro","quadro","qualcosa","quasi","querela","quota","raccolto","raddoppio","radicale","radunato","raffica","ragazzo","ragione","ragno","ramarro","ramingo","ramo","randagio","rantolare","rapato","rapina","rappreso","rasatura","raschiato","rasente","rassegna","rastrello","rata","ravveduto","reale","recepire","recinto","recluta","recondito","recupero","reddito","redimere","regalato","registro","regola","regresso","relazione","remare","remoto","renna","replica","reprimere","reputare","resa","residente","responso","restauro","rete","retina","retorica","rettifica","revocato","riassunto","ribadire","ribelle","ribrezzo","ricarica","ricco","ricevere","riciclato","ricordo","ricreduto","ridicolo","ridurre","rifasare","riflesso","riforma","rifugio","rigare","rigettato","righello","rilassato","rilevato","rimanere","rimbalzo","rimedio","rimorchio","rinascita","rincaro","rinforzo","rinnovo","rinomato","rinsavito","rintocco","rinuncia","rinvenire","riparato","ripetuto","ripieno","riportare","ripresa","ripulire","risata","rischio","riserva","risibile","riso","rispetto","ristoro","risultato","risvolto","ritardo","ritegno","ritmico","ritrovo","riunione","riva","riverso","rivincita","rivolto","rizoma","roba","robotico","robusto","roccia","roco","rodaggio","rodere","roditore","rogito","rollio","romantico","rompere","ronzio","rosolare","rospo","rotante","rotondo","rotula","rovescio","rubizzo","rubrica","ruga","rullino","rumine","rumoroso","ruolo","rupe","russare","rustico","sabato","sabbiare","sabotato","sagoma","salasso","saldatura","salgemma","salivare","salmone","salone","saltare","saluto","salvo","sapere","sapido","saporito","saraceno","sarcasmo","sarto","sassoso","satellite","satira","satollo","saturno","savana","savio","saziato","sbadiglio","sbalzo","sbancato","sbarra","sbattere","sbavare","sbendare","sbirciare","sbloccato","sbocciato","sbrinare","sbruffone","sbuffare","scabroso","scadenza","scala","scambiare","scandalo","scapola","scarso","scatenare","scavato","scelto","scenico","scettro","scheda","schiena","sciarpa","scienza","scindere","scippo","sciroppo","scivolo","sclerare","scodella","scolpito","scomparto","sconforto","scoprire","scorta","scossone","scozzese","scriba","scrollare","scrutinio","scuderia","scultore","scuola","scuro","scusare","sdebitare","sdoganare","seccatura","secondo","sedano","seggiola","segnalato","segregato","seguito","selciato","selettivo","sella","selvaggio","semaforo","sembrare","seme","seminato","sempre","senso","sentire","sepolto","sequenza","serata","serbato","sereno","serio","serpente","serraglio","servire","sestina","setola","settimana","sfacelo","sfaldare","sfamato","sfarzoso","sfaticato","sfera","sfida","sfilato","sfinge","sfocato","sfoderare","sfogo","sfoltire","sforzato","sfratto","sfruttato","sfuggito","sfumare","sfuso","sgabello","sgarbato","sgonfiare","sgorbio","sgrassato","sguardo","sibilo","siccome","sierra","sigla","signore","silenzio","sillaba","simbolo","simpatico","simulato","sinfonia","singolo","sinistro","sino","sintesi","sinusoide","sipario","sisma","sistole","situato","slitta","slogatura","sloveno","smarrito","smemorato","smentito","smeraldo","smilzo","smontare","smottato","smussato","snellire","snervato","snodo","sobbalzo","sobrio","soccorso","sociale","sodale","soffitto","sogno","soldato","solenne","solido","sollazzo","solo","solubile","solvente","somatico","somma","sonda","sonetto","sonnifero","sopire","soppeso","sopra","sorgere","sorpasso","sorriso","sorso","sorteggio","sorvolato","sospiro","sosta","sottile","spada","spalla","spargere","spatola","spavento","spazzola","specie","spedire","spegnere","spelatura","speranza","spessore","spettrale","spezzato","spia","spigoloso","spillato","spinoso","spirale","splendido","sportivo","sposo","spranga","sprecare","spronato","spruzzo","spuntino","squillo","sradicare","srotolato","stabile","stacco","staffa","stagnare","stampato","stantio","starnuto","stasera","statuto","stelo","steppa","sterzo","stiletto","stima","stirpe","stivale","stizzoso","stonato","storico","strappo","stregato","stridulo","strozzare","strutto","stuccare","stufo","stupendo","subentro","succoso","sudore","suggerito","sugo","sultano","suonare","superbo","supporto","surgelato","surrogato","sussurro","sutura","svagare","svedese","sveglio","svelare","svenuto","svezia","sviluppo","svista","svizzera","svolta","svuotare","tabacco","tabulato","tacciare","taciturno","tale","talismano","tampone","tannino","tara","tardivo","targato","tariffa","tarpare","tartaruga","tasto","tattico","taverna","tavolata","tazza","teca","tecnico","telefono","temerario","tempo","temuto","tendone","tenero","tensione","tentacolo","teorema","terme","terrazzo","terzetto","tesi","tesserato","testato","tetro","tettoia","tifare","tigella","timbro","tinto","tipico","tipografo","tiraggio","tiro","titanio","titolo","titubante","tizio","tizzone","toccare","tollerare","tolto","tombola","tomo","tonfo","tonsilla","topazio","topologia","toppa","torba","tornare","torrone","tortora","toscano","tossire","tostatura","totano","trabocco","trachea","trafila","tragedia","tralcio","tramonto","transito","trapano","trarre","trasloco","trattato","trave","treccia","tremolio","trespolo","tributo","tricheco","trifoglio","trillo","trincea","trio","tristezza","triturato","trivella","tromba","trono","troppo","trottola","trovare","truccato","tubatura","tuffato","tulipano","tumulto","tunisia","turbare","turchino","tuta","tutela","ubicato","uccello","uccisore","udire","uditivo","uffa","ufficio","uguale","ulisse","ultimato","umano","umile","umorismo","uncinetto","ungere","ungherese","unicorno","unificato","unisono","unitario","unte","uovo","upupa","uragano","urgenza","urlo","usanza","usato","uscito","usignolo","usuraio","utensile","utilizzo","utopia","vacante","vaccinato","vagabondo","vagliato","valanga","valgo","valico","valletta","valoroso","valutare","valvola","vampata","vangare","vanitoso","vano","vantaggio","vanvera","vapore","varano","varcato","variante","vasca","vedetta","vedova","veduto","vegetale","veicolo","velcro","velina","velluto","veloce","venato","vendemmia","vento","verace","verbale","vergogna","verifica","vero","verruca","verticale","vescica","vessillo","vestale","veterano","vetrina","vetusto","viandante","vibrante","vicenda","vichingo","vicinanza","vidimare","vigilia","vigneto","vigore","vile","villano","vimini","vincitore","viola","vipera","virgola","virologo","virulento","viscoso","visione","vispo","vissuto","visura","vita","vitello","vittima","vivanda","vivido","viziare","voce","voga","volatile","volere","volpe","voragine","vulcano","zampogna","zanna","zappato","zattera","zavorra","zefiro","zelante","zelo","zenzero","zerbino","zibetto","zinco","zircone","zitto","zolla","zotico","zucchero","zufolo","zulu","zuppa"]');

});

parcelRegister("6n1gF", function(module, exports) {
module.exports = JSON.parse('["a\u0301baco","abdomen","abeja","abierto","abogado","abono","aborto","abrazo","abrir","abuelo","abuso","acabar","academia","acceso","accio\u0301n","aceite","acelga","acento","aceptar","a\u0301cido","aclarar","acne\u0301","acoger","acoso","activo","acto","actriz","actuar","acudir","acuerdo","acusar","adicto","admitir","adoptar","adorno","aduana","adulto","ae\u0301reo","afectar","aficio\u0301n","afinar","afirmar","a\u0301gil","agitar","agoni\u0301a","agosto","agotar","agregar","agrio","agua","agudo","a\u0301guila","aguja","ahogo","ahorro","aire","aislar","ajedrez","ajeno","ajuste","alacra\u0301n","alambre","alarma","alba","a\u0301lbum","alcalde","aldea","alegre","alejar","alerta","aleta","alfiler","alga","algodo\u0301n","aliado","aliento","alivio","alma","almeja","almi\u0301bar","altar","alteza","altivo","alto","altura","alumno","alzar","amable","amante","amapola","amargo","amasar","a\u0301mbar","a\u0301mbito","ameno","amigo","amistad","amor","amparo","amplio","ancho","anciano","ancla","andar","ande\u0301n","anemia","a\u0301ngulo","anillo","a\u0301nimo","ani\u0301s","anotar","antena","antiguo","antojo","anual","anular","anuncio","an\u0303adir","an\u0303ejo","an\u0303o","apagar","aparato","apetito","apio","aplicar","apodo","aporte","apoyo","aprender","aprobar","apuesta","apuro","arado","aran\u0303a","arar","a\u0301rbitro","a\u0301rbol","arbusto","archivo","arco","arder","ardilla","arduo","a\u0301rea","a\u0301rido","aries","armoni\u0301a","arne\u0301s","aroma","arpa","arpo\u0301n","arreglo","arroz","arruga","arte","artista","asa","asado","asalto","ascenso","asegurar","aseo","asesor","asiento","asilo","asistir","asno","asombro","a\u0301spero","astilla","astro","astuto","asumir","asunto","atajo","ataque","atar","atento","ateo","a\u0301tico","atleta","a\u0301tomo","atraer","atroz","atu\u0301n","audaz","audio","auge","aula","aumento","ausente","autor","aval","avance","avaro","ave","avellana","avena","avestruz","avio\u0301n","aviso","ayer","ayuda","ayuno","azafra\u0301n","azar","azote","azu\u0301car","azufre","azul","baba","babor","bache","bahi\u0301a","baile","bajar","balanza","balco\u0301n","balde","bambu\u0301","banco","banda","ban\u0303o","barba","barco","barniz","barro","ba\u0301scula","basto\u0301n","basura","batalla","bateri\u0301a","batir","batuta","bau\u0301l","bazar","bebe\u0301","bebida","bello","besar","beso","bestia","bicho","bien","bingo","blanco","bloque","blusa","boa","bobina","bobo","boca","bocina","boda","bodega","boina","bola","bolero","bolsa","bomba","bondad","bonito","bono","bonsa\u0301i","borde","borrar","bosque","bote","boti\u0301n","bo\u0301veda","bozal","bravo","brazo","brecha","breve","brillo","brinco","brisa","broca","broma","bronce","brote","bruja","brusco","bruto","buceo","bucle","bueno","buey","bufanda","bufo\u0301n","bu\u0301ho","buitre","bulto","burbuja","burla","burro","buscar","butaca","buzo\u0301n","caballo","cabeza","cabina","cabra","cacao","cada\u0301ver","cadena","caer","cafe\u0301","cai\u0301da","caima\u0301n","caja","cajo\u0301n","cal","calamar","calcio","caldo","calidad","calle","calma","calor","calvo","cama","cambio","camello","camino","campo","ca\u0301ncer","candil","canela","canguro","canica","canto","can\u0303a","can\u0303o\u0301n","caoba","caos","capaz","capita\u0301n","capote","captar","capucha","cara","carbo\u0301n","ca\u0301rcel","careta","carga","carin\u0303o","carne","carpeta","carro","carta","casa","casco","casero","caspa","castor","catorce","catre","caudal","causa","cazo","cebolla","ceder","cedro","celda","ce\u0301lebre","celoso","ce\u0301lula","cemento","ceniza","centro","cerca","cerdo","cereza","cero","cerrar","certeza","ce\u0301sped","cetro","chacal","chaleco","champu\u0301","chancla","chapa","charla","chico","chiste","chivo","choque","choza","chuleta","chupar","ciclo\u0301n","ciego","cielo","cien","cierto","cifra","cigarro","cima","cinco","cine","cinta","cipre\u0301s","circo","ciruela","cisne","cita","ciudad","clamor","clan","claro","clase","clave","cliente","clima","cli\u0301nica","cobre","coccio\u0301n","cochino","cocina","coco","co\u0301digo","codo","cofre","coger","cohete","coji\u0301n","cojo","cola","colcha","colegio","colgar","colina","collar","colmo","columna","combate","comer","comida","co\u0301modo","compra","conde","conejo","conga","conocer","consejo","contar","copa","copia","corazo\u0301n","corbata","corcho","cordo\u0301n","corona","correr","coser","cosmos","costa","cra\u0301neo","cra\u0301ter","crear","crecer","crei\u0301do","crema","cri\u0301a","crimen","cripta","crisis","cromo","cro\u0301nica","croqueta","crudo","cruz","cuadro","cuarto","cuatro","cubo","cubrir","cuchara","cuello","cuento","cuerda","cuesta","cueva","cuidar","culebra","culpa","culto","cumbre","cumplir","cuna","cuneta","cuota","cupo\u0301n","cu\u0301pula","curar","curioso","curso","curva","cutis","dama","danza","dar","dardo","da\u0301til","deber","de\u0301bil","de\u0301cada","decir","dedo","defensa","definir","dejar","delfi\u0301n","delgado","delito","demora","denso","dental","deporte","derecho","derrota","desayuno","deseo","desfile","desnudo","destino","desvi\u0301o","detalle","detener","deuda","di\u0301a","diablo","diadema","diamante","diana","diario","dibujo","dictar","diente","dieta","diez","difi\u0301cil","digno","dilema","diluir","dinero","directo","dirigir","disco","disen\u0303o","disfraz","diva","divino","doble","doce","dolor","domingo","don","donar","dorado","dormir","dorso","dos","dosis","drago\u0301n","droga","ducha","duda","duelo","duen\u0303o","dulce","du\u0301o","duque","durar","dureza","duro","e\u0301bano","ebrio","echar","eco","ecuador","edad","edicio\u0301n","edificio","editor","educar","efecto","eficaz","eje","ejemplo","elefante","elegir","elemento","elevar","elipse","e\u0301lite","elixir","elogio","eludir","embudo","emitir","emocio\u0301n","empate","empen\u0303o","empleo","empresa","enano","encargo","enchufe","enci\u0301a","enemigo","enero","enfado","enfermo","engan\u0303o","enigma","enlace","enorme","enredo","ensayo","ensen\u0303ar","entero","entrar","envase","envi\u0301o","e\u0301poca","equipo","erizo","escala","escena","escolar","escribir","escudo","esencia","esfera","esfuerzo","espada","espejo","espi\u0301a","esposa","espuma","esqui\u0301","estar","este","estilo","estufa","etapa","eterno","e\u0301tica","etnia","evadir","evaluar","evento","evitar","exacto","examen","exceso","excusa","exento","exigir","exilio","existir","e\u0301xito","experto","explicar","exponer","extremo","fa\u0301brica","fa\u0301bula","fachada","fa\u0301cil","factor","faena","faja","falda","fallo","falso","faltar","fama","familia","famoso","farao\u0301n","farmacia","farol","farsa","fase","fatiga","fauna","favor","fax","febrero","fecha","feliz","feo","feria","feroz","fe\u0301rtil","fervor","festi\u0301n","fiable","fianza","fiar","fibra","ficcio\u0301n","ficha","fideo","fiebre","fiel","fiera","fiesta","figura","fijar","fijo","fila","filete","filial","filtro","fin","finca","fingir","finito","firma","flaco","flauta","flecha","flor","flota","fluir","flujo","flu\u0301or","fobia","foca","fogata","fogo\u0301n","folio","folleto","fondo","forma","forro","fortuna","forzar","fosa","foto","fracaso","fra\u0301gil","franja","frase","fraude","frei\u0301r","freno","fresa","fri\u0301o","frito","fruta","fuego","fuente","fuerza","fuga","fumar","funcio\u0301n","funda","furgo\u0301n","furia","fusil","fu\u0301tbol","futuro","gacela","gafas","gaita","gajo","gala","galeri\u0301a","gallo","gamba","ganar","gancho","ganga","ganso","garaje","garza","gasolina","gastar","gato","gavila\u0301n","gemelo","gemir","gen","ge\u0301nero","genio","gente","geranio","gerente","germen","gesto","gigante","gimnasio","girar","giro","glaciar","globo","gloria","gol","golfo","goloso","golpe","goma","gordo","gorila","gorra","gota","goteo","gozar","grada","gra\u0301fico","grano","grasa","gratis","grave","grieta","grillo","gripe","gris","grito","grosor","gru\u0301a","grueso","grumo","grupo","guante","guapo","guardia","guerra","gui\u0301a","guin\u0303o","guion","guiso","guitarra","gusano","gustar","haber","ha\u0301bil","hablar","hacer","hacha","hada","hallar","hamaca","harina","haz","hazan\u0303a","hebilla","hebra","hecho","helado","helio","hembra","herir","hermano","he\u0301roe","hervir","hielo","hierro","hi\u0301gado","higiene","hijo","himno","historia","hocico","hogar","hoguera","hoja","hombre","hongo","honor","honra","hora","hormiga","horno","hostil","hoyo","hueco","huelga","huerta","hueso","huevo","huida","huir","humano","hu\u0301medo","humilde","humo","hundir","huraca\u0301n","hurto","icono","ideal","idioma","i\u0301dolo","iglesia","iglu\u0301","igual","ilegal","ilusio\u0301n","imagen","ima\u0301n","imitar","impar","imperio","imponer","impulso","incapaz","i\u0301ndice","inerte","infiel","informe","ingenio","inicio","inmenso","inmune","innato","insecto","instante","intere\u0301s","i\u0301ntimo","intuir","inu\u0301til","invierno","ira","iris","ironi\u0301a","isla","islote","jabali\u0301","jabo\u0301n","jamo\u0301n","jarabe","jardi\u0301n","jarra","jaula","jazmi\u0301n","jefe","jeringa","jinete","jornada","joroba","joven","joya","juerga","jueves","juez","jugador","jugo","juguete","juicio","junco","jungla","junio","juntar","ju\u0301piter","jurar","justo","juvenil","juzgar","kilo","koala","labio","lacio","lacra","lado","ladro\u0301n","lagarto","la\u0301grima","laguna","laico","lamer","la\u0301mina","la\u0301mpara","lana","lancha","langosta","lanza","la\u0301piz","largo","larva","la\u0301stima","lata","la\u0301tex","latir","laurel","lavar","lazo","leal","leccio\u0301n","leche","lector","leer","legio\u0301n","legumbre","lejano","lengua","lento","len\u0303a","leo\u0301n","leopardo","lesio\u0301n","letal","letra","leve","leyenda","libertad","libro","licor","li\u0301der","lidiar","lienzo","liga","ligero","lima","li\u0301mite","limo\u0301n","limpio","lince","lindo","li\u0301nea","lingote","lino","linterna","li\u0301quido","liso","lista","litera","litio","litro","llaga","llama","llanto","llave","llegar","llenar","llevar","llorar","llover","lluvia","lobo","locio\u0301n","loco","locura","lo\u0301gica","logro","lombriz","lomo","lonja","lote","lucha","lucir","lugar","lujo","luna","lunes","lupa","lustro","luto","luz","maceta","macho","madera","madre","maduro","maestro","mafia","magia","mago","mai\u0301z","maldad","maleta","malla","malo","mama\u0301","mambo","mamut","manco","mando","manejar","manga","maniqui\u0301","manjar","mano","manso","manta","man\u0303ana","mapa","ma\u0301quina","mar","marco","marea","marfil","margen","marido","ma\u0301rmol","marro\u0301n","martes","marzo","masa","ma\u0301scara","masivo","matar","materia","matiz","matriz","ma\u0301ximo","mayor","mazorca","mecha","medalla","medio","me\u0301dula","mejilla","mejor","melena","melo\u0301n","memoria","menor","mensaje","mente","menu\u0301","mercado","merengue","me\u0301rito","mes","meso\u0301n","meta","meter","me\u0301todo","metro","mezcla","miedo","miel","miembro","miga","mil","milagro","militar","millo\u0301n","mimo","mina","minero","mi\u0301nimo","minuto","miope","mirar","misa","miseria","misil","mismo","mitad","mito","mochila","mocio\u0301n","moda","modelo","moho","mojar","molde","moler","molino","momento","momia","monarca","moneda","monja","monto","mon\u0303o","morada","morder","moreno","morir","morro","morsa","mortal","mosca","mostrar","motivo","mover","mo\u0301vil","mozo","mucho","mudar","mueble","muela","muerte","muestra","mugre","mujer","mula","muleta","multa","mundo","mun\u0303eca","mural","muro","mu\u0301sculo","museo","musgo","mu\u0301sica","muslo","na\u0301car","nacio\u0301n","nadar","naipe","naranja","nariz","narrar","nasal","natal","nativo","natural","na\u0301usea","naval","nave","navidad","necio","ne\u0301ctar","negar","negocio","negro","neo\u0301n","nervio","neto","neutro","nevar","nevera","nicho","nido","niebla","nieto","nin\u0303ez","nin\u0303o","ni\u0301tido","nivel","nobleza","noche","no\u0301mina","noria","norma","norte","nota","noticia","novato","novela","novio","nube","nuca","nu\u0301cleo","nudillo","nudo","nuera","nueve","nuez","nulo","nu\u0301mero","nutria","oasis","obeso","obispo","objeto","obra","obrero","observar","obtener","obvio","oca","ocaso","oce\u0301ano","ochenta","ocho","ocio","ocre","octavo","octubre","oculto","ocupar","ocurrir","odiar","odio","odisea","oeste","ofensa","oferta","oficio","ofrecer","ogro","oi\u0301do","oi\u0301r","ojo","ola","oleada","olfato","olivo","olla","olmo","olor","olvido","ombligo","onda","onza","opaco","opcio\u0301n","o\u0301pera","opinar","oponer","optar","o\u0301ptica","opuesto","oracio\u0301n","orador","oral","o\u0301rbita","orca","orden","oreja","o\u0301rgano","orgi\u0301a","orgullo","oriente","origen","orilla","oro","orquesta","oruga","osadi\u0301a","oscuro","osezno","oso","ostra","oton\u0303o","otro","oveja","o\u0301vulo","o\u0301xido","oxi\u0301geno","oyente","ozono","pacto","padre","paella","pa\u0301gina","pago","pai\u0301s","pa\u0301jaro","palabra","palco","paleta","pa\u0301lido","palma","paloma","palpar","pan","panal","pa\u0301nico","pantera","pan\u0303uelo","papa\u0301","papel","papilla","paquete","parar","parcela","pared","parir","paro","pa\u0301rpado","parque","pa\u0301rrafo","parte","pasar","paseo","pasio\u0301n","paso","pasta","pata","patio","patria","pausa","pauta","pavo","payaso","peato\u0301n","pecado","pecera","pecho","pedal","pedir","pegar","peine","pelar","peldan\u0303o","pelea","peligro","pellejo","pelo","peluca","pena","pensar","pen\u0303o\u0301n","peo\u0301n","peor","pepino","pequen\u0303o","pera","percha","perder","pereza","perfil","perico","perla","permiso","perro","persona","pesa","pesca","pe\u0301simo","pestan\u0303a","pe\u0301talo","petro\u0301leo","pez","pezun\u0303a","picar","picho\u0301n","pie","piedra","pierna","pieza","pijama","pilar","piloto","pimienta","pino","pintor","pinza","pin\u0303a","piojo","pipa","pirata","pisar","piscina","piso","pista","pito\u0301n","pizca","placa","plan","plata","playa","plaza","pleito","pleno","plomo","pluma","plural","pobre","poco","poder","podio","poema","poesi\u0301a","poeta","polen","polici\u0301a","pollo","polvo","pomada","pomelo","pomo","pompa","poner","porcio\u0301n","portal","posada","poseer","posible","poste","potencia","potro","pozo","prado","precoz","pregunta","premio","prensa","preso","previo","primo","pri\u0301ncipe","prisio\u0301n","privar","proa","probar","proceso","producto","proeza","profesor","programa","prole","promesa","pronto","propio","pro\u0301ximo","prueba","pu\u0301blico","puchero","pudor","pueblo","puerta","puesto","pulga","pulir","pulmo\u0301n","pulpo","pulso","puma","punto","pun\u0303al","pun\u0303o","pupa","pupila","pure\u0301","quedar","queja","quemar","querer","queso","quieto","qui\u0301mica","quince","quitar","ra\u0301bano","rabia","rabo","racio\u0301n","radical","rai\u0301z","rama","rampa","rancho","rango","rapaz","ra\u0301pido","rapto","rasgo","raspa","rato","rayo","raza","razo\u0301n","reaccio\u0301n","realidad","reban\u0303o","rebote","recaer","receta","rechazo","recoger","recreo","recto","recurso","red","redondo","reducir","reflejo","reforma","refra\u0301n","refugio","regalo","regir","regla","regreso","rehe\u0301n","reino","rei\u0301r","reja","relato","relevo","relieve","relleno","reloj","remar","remedio","remo","rencor","rendir","renta","reparto","repetir","reposo","reptil","res","rescate","resina","respeto","resto","resumen","retiro","retorno","retrato","reunir","reve\u0301s","revista","rey","rezar","rico","riego","rienda","riesgo","rifa","ri\u0301gido","rigor","rinco\u0301n","rin\u0303o\u0301n","ri\u0301o","riqueza","risa","ritmo","rito","rizo","roble","roce","rociar","rodar","rodeo","rodilla","roer","rojizo","rojo","romero","romper","ron","ronco","ronda","ropa","ropero","rosa","rosca","rostro","rotar","rubi\u0301","rubor","rudo","rueda","rugir","ruido","ruina","ruleta","rulo","rumbo","rumor","ruptura","ruta","rutina","sa\u0301bado","saber","sabio","sable","sacar","sagaz","sagrado","sala","saldo","salero","salir","salmo\u0301n","salo\u0301n","salsa","salto","salud","salvar","samba","sancio\u0301n","sandi\u0301a","sanear","sangre","sanidad","sano","santo","sapo","saque","sardina","sarte\u0301n","sastre","sata\u0301n","sauna","saxofo\u0301n","seccio\u0301n","seco","secreto","secta","sed","seguir","seis","sello","selva","semana","semilla","senda","sensor","sen\u0303al","sen\u0303or","separar","sepia","sequi\u0301a","ser","serie","sermo\u0301n","servir","sesenta","sesio\u0301n","seta","setenta","severo","sexo","sexto","sidra","siesta","siete","siglo","signo","si\u0301laba","silbar","silencio","silla","si\u0301mbolo","simio","sirena","sistema","sitio","situar","sobre","socio","sodio","sol","solapa","soldado","soledad","so\u0301lido","soltar","solucio\u0301n","sombra","sondeo","sonido","sonoro","sonrisa","sopa","soplar","soporte","sordo","sorpresa","sorteo","soste\u0301n","so\u0301tano","suave","subir","suceso","sudor","suegra","suelo","suen\u0303o","suerte","sufrir","sujeto","sulta\u0301n","sumar","superar","suplir","suponer","supremo","sur","surco","suren\u0303o","surgir","susto","sutil","tabaco","tabique","tabla","tabu\u0301","taco","tacto","tajo","talar","talco","talento","talla","talo\u0301n","taman\u0303o","tambor","tango","tanque","tapa","tapete","tapia","tapo\u0301n","taquilla","tarde","tarea","tarifa","tarjeta","tarot","tarro","tarta","tatuaje","tauro","taza","tazo\u0301n","teatro","techo","tecla","te\u0301cnica","tejado","tejer","tejido","tela","tele\u0301fono","tema","temor","templo","tenaz","tender","tener","tenis","tenso","teori\u0301a","terapia","terco","te\u0301rmino","ternura","terror","tesis","tesoro","testigo","tetera","texto","tez","tibio","tiburo\u0301n","tiempo","tienda","tierra","tieso","tigre","tijera","tilde","timbre","ti\u0301mido","timo","tinta","ti\u0301o","ti\u0301pico","tipo","tira","tiro\u0301n","tita\u0301n","ti\u0301tere","ti\u0301tulo","tiza","toalla","tobillo","tocar","tocino","todo","toga","toldo","tomar","tono","tonto","topar","tope","toque","to\u0301rax","torero","tormenta","torneo","toro","torpedo","torre","torso","tortuga","tos","tosco","toser","to\u0301xico","trabajo","tractor","traer","tra\u0301fico","trago","traje","tramo","trance","trato","trauma","trazar","tre\u0301bol","tregua","treinta","tren","trepar","tres","tribu","trigo","tripa","triste","triunfo","trofeo","trompa","tronco","tropa","trote","trozo","truco","trueno","trufa","tuberi\u0301a","tubo","tuerto","tumba","tumor","tu\u0301nel","tu\u0301nica","turbina","turismo","turno","tutor","ubicar","u\u0301lcera","umbral","unidad","unir","universo","uno","untar","un\u0303a","urbano","urbe","urgente","urna","usar","usuario","u\u0301til","utopi\u0301a","uva","vaca","vaci\u0301o","vacuna","vagar","vago","vaina","vajilla","vale","va\u0301lido","valle","valor","va\u0301lvula","vampiro","vara","variar","varo\u0301n","vaso","vecino","vector","vehi\u0301culo","veinte","vejez","vela","velero","veloz","vena","vencer","venda","veneno","vengar","venir","venta","venus","ver","verano","verbo","verde","vereda","verja","verso","verter","vi\u0301a","viaje","vibrar","vicio","vi\u0301ctima","vida","vi\u0301deo","vidrio","viejo","viernes","vigor","vil","villa","vinagre","vino","vin\u0303edo","violi\u0301n","viral","virgo","virtud","visor","vi\u0301spera","vista","vitamina","viudo","vivaz","vivero","vivir","vivo","volca\u0301n","volumen","volver","voraz","votar","voto","voz","vuelo","vulgar","yacer","yate","yegua","yema","yerno","yeso","yodo","yoga","yogur","zafiro","zanja","zapato","zarza","zona","zorro","zumo","zurdo"]');

});

parcelRegister("2WDwo", function(module, exports) {
module.exports = JSON.parse('["\u3042\u3044\u3053\u304F\u3057\u3093","\u3042\u3044\u3055\u3064","\u3042\u3044\u305F\u3099","\u3042\u304A\u305D\u3099\u3089","\u3042\u304B\u3061\u3083\u3093","\u3042\u304D\u308B","\u3042\u3051\u304B\u3099\u305F","\u3042\u3051\u308B","\u3042\u3053\u304B\u3099\u308C\u308B","\u3042\u3055\u3044","\u3042\u3055\u3072","\u3042\u3057\u3042\u3068","\u3042\u3057\u3099\u308F\u3046","\u3042\u3059\u3099\u304B\u308B","\u3042\u3059\u3099\u304D","\u3042\u305D\u3075\u3099","\u3042\u305F\u3048\u308B","\u3042\u305F\u305F\u3081\u308B","\u3042\u305F\u308A\u307E\u3048","\u3042\u305F\u308B","\u3042\u3064\u3044","\u3042\u3064\u304B\u3046","\u3042\u3063\u3057\u3085\u304F","\u3042\u3064\u307E\u308A","\u3042\u3064\u3081\u308B","\u3042\u3066\u306A","\u3042\u3066\u306F\u307E\u308B","\u3042\u3072\u308B","\u3042\u3075\u3099\u3089","\u3042\u3075\u3099\u308B","\u3042\u3075\u308C\u308B","\u3042\u307E\u3044","\u3042\u307E\u3068\u3099","\u3042\u307E\u3084\u304B\u3059","\u3042\u307E\u308A","\u3042\u307F\u3082\u306E","\u3042\u3081\u308A\u304B","\u3042\u3084\u307E\u308B","\u3042\u3086\u3080","\u3042\u3089\u3044\u304F\u3099\u307E","\u3042\u3089\u3057","\u3042\u3089\u3059\u3057\u3099","\u3042\u3089\u305F\u3081\u308B","\u3042\u3089\u3086\u308B","\u3042\u3089\u308F\u3059","\u3042\u308A\u304B\u3099\u3068\u3046","\u3042\u308F\u305B\u308B","\u3042\u308F\u3066\u308B","\u3042\u3093\u3044","\u3042\u3093\u304B\u3099\u3044","\u3042\u3093\u3053","\u3042\u3093\u305B\u3099\u3093","\u3042\u3093\u3066\u3044","\u3042\u3093\u306A\u3044","\u3042\u3093\u307E\u308A","\u3044\u3044\u305F\u3099\u3059","\u3044\u304A\u3093","\u3044\u304B\u3099\u3044","\u3044\u304B\u3099\u304F","\u3044\u304D\u304A\u3044","\u3044\u304D\u306A\u308A","\u3044\u304D\u3082\u306E","\u3044\u304D\u308B","\u3044\u304F\u3057\u3099","\u3044\u304F\u3075\u3099\u3093","\u3044\u3051\u306F\u3099\u306A","\u3044\u3051\u3093","\u3044\u3053\u3046","\u3044\u3053\u304F","\u3044\u3053\u3064","\u3044\u3055\u307E\u3057\u3044","\u3044\u3055\u3093","\u3044\u3057\u304D","\u3044\u3057\u3099\u3085\u3046","\u3044\u3057\u3099\u3087\u3046","\u3044\u3057\u3099\u308F\u308B","\u3044\u3059\u3099\u307F","\u3044\u3059\u3099\u308C","\u3044\u305B\u3044","\u3044\u305B\u3048\u3072\u3099","\u3044\u305B\u304B\u3044","\u3044\u305B\u304D","\u3044\u305B\u3099\u3093","\u3044\u305D\u3046\u308D\u3046","\u3044\u305D\u304B\u3099\u3057\u3044","\u3044\u305F\u3099\u3044","\u3044\u305F\u3099\u304F","\u3044\u305F\u3059\u3099\u3089","\u3044\u305F\u307F","\u3044\u305F\u308A\u3042","\u3044\u3061\u304A\u3046","\u3044\u3061\u3057\u3099","\u3044\u3061\u3068\u3099","\u3044\u3061\u306F\u3099","\u3044\u3061\u3075\u3099","\u3044\u3061\u308A\u3085\u3046","\u3044\u3064\u304B","\u3044\u3063\u3057\u3085\u3093","\u3044\u3063\u305B\u3044","\u3044\u3063\u305D\u3046","\u3044\u3063\u305F\u3093","\u3044\u3063\u3061","\u3044\u3063\u3066\u3044","\u3044\u3063\u307B\u309A\u3046","\u3044\u3066\u3055\u3099","\u3044\u3066\u3093","\u3044\u3068\u3099\u3046","\u3044\u3068\u3053","\u3044\u306A\u3044","\u3044\u306A\u304B","\u3044\u306D\u3080\u308A","\u3044\u306E\u3061","\u3044\u306E\u308B","\u3044\u306F\u3064","\u3044\u306F\u3099\u308B","\u3044\u306F\u3093","\u3044\u3072\u3099\u304D","\u3044\u3072\u3093","\u3044\u3075\u304F","\u3044\u3078\u3093","\u3044\u307B\u3046","\u3044\u307F\u3093","\u3044\u3082\u3046\u3068","\u3044\u3082\u305F\u308C","\u3044\u3082\u308A","\u3044\u3084\u304B\u3099\u308B","\u3044\u3084\u3059","\u3044\u3088\u304B\u3093","\u3044\u3088\u304F","\u3044\u3089\u3044","\u3044\u3089\u3059\u3068","\u3044\u308A\u304F\u3099\u3061","\u3044\u308A\u3087\u3046","\u3044\u308C\u3044","\u3044\u308C\u3082\u306E","\u3044\u308C\u308B","\u3044\u308D\u3048\u3093\u3072\u309A\u3064","\u3044\u308F\u3044","\u3044\u308F\u3046","\u3044\u308F\u304B\u3093","\u3044\u308F\u306F\u3099","\u3044\u308F\u3086\u308B","\u3044\u3093\u3051\u3099\u3093\u307E\u3081","\u3044\u3093\u3055\u3064","\u3044\u3093\u3057\u3087\u3046","\u3044\u3093\u3088\u3046","\u3046\u3048\u304D","\u3046\u3048\u308B","\u3046\u304A\u3055\u3099","\u3046\u304B\u3099\u3044","\u3046\u304B\u3075\u3099","\u3046\u304B\u3078\u3099\u308B","\u3046\u304D\u308F","\u3046\u304F\u3089\u3044\u306A","\u3046\u304F\u308C\u308C","\u3046\u3051\u305F\u307E\u308F\u308B","\u3046\u3051\u3064\u3051","\u3046\u3051\u3068\u308B","\u3046\u3051\u3082\u3064","\u3046\u3051\u308B","\u3046\u3053\u3099\u304B\u3059","\u3046\u3053\u3099\u304F","\u3046\u3053\u3093","\u3046\u3055\u304D\u3099","\u3046\u3057\u306A\u3046","\u3046\u3057\u308D\u304B\u3099\u307F","\u3046\u3059\u3044","\u3046\u3059\u304D\u3099","\u3046\u3059\u304F\u3099\u3089\u3044","\u3046\u3059\u3081\u308B","\u3046\u305B\u3064","\u3046\u3061\u3042\u308F\u305B","\u3046\u3061\u304B\u3099\u308F","\u3046\u3061\u304D","\u3046\u3061\u3085\u3046","\u3046\u3063\u304B\u308A","\u3046\u3064\u304F\u3057\u3044","\u3046\u3063\u305F\u3048\u308B","\u3046\u3064\u308B","\u3046\u3068\u3099\u3093","\u3046\u306A\u304D\u3099","\u3046\u306A\u3057\u3099","\u3046\u306A\u3059\u3099\u304F","\u3046\u306A\u308B","\u3046\u306D\u308B","\u3046\u306E\u3046","\u3046\u3075\u3099\u3051\u3099","\u3046\u3075\u3099\u3053\u3099\u3048","\u3046\u307E\u308C\u308B","\u3046\u3081\u308B","\u3046\u3082\u3046","\u3046\u3084\u307E\u3046","\u3046\u3088\u304F","\u3046\u3089\u304B\u3099\u3048\u3059","\u3046\u3089\u304F\u3099\u3061","\u3046\u3089\u306A\u3044","\u3046\u308A\u3042\u3051\u3099","\u3046\u308A\u304D\u308C","\u3046\u308B\u3055\u3044","\u3046\u308C\u3057\u3044","\u3046\u308C\u3086\u304D","\u3046\u308C\u308B","\u3046\u308D\u3053","\u3046\u308F\u304D","\u3046\u308F\u3055","\u3046\u3093\u3053\u3046","\u3046\u3093\u3061\u3093","\u3046\u3093\u3066\u3093","\u3046\u3093\u3068\u3099\u3046","\u3048\u3044\u3048\u3093","\u3048\u3044\u304B\u3099","\u3048\u3044\u304D\u3087\u3046","\u3048\u3044\u3053\u3099","\u3048\u3044\u305B\u3044","\u3048\u3044\u3075\u3099\u3093","\u3048\u3044\u3088\u3046","\u3048\u3044\u308F","\u3048\u304A\u308A","\u3048\u304B\u3099\u304A","\u3048\u304B\u3099\u304F","\u3048\u304D\u305F\u3044","\u3048\u304F\u305B\u308B","\u3048\u3057\u3083\u304F","\u3048\u3059\u3066","\u3048\u3064\u3089\u3093","\u3048\u306E\u304F\u3099","\u3048\u307B\u3046\u307E\u304D","\u3048\u307B\u3093","\u3048\u307E\u304D","\u3048\u3082\u3057\u3099","\u3048\u3082\u306E","\u3048\u3089\u3044","\u3048\u3089\u3075\u3099","\u3048\u308A\u3042","\u3048\u3093\u3048\u3093","\u3048\u3093\u304B\u3044","\u3048\u3093\u304D\u3099","\u3048\u3093\u3051\u3099\u304D","\u3048\u3093\u3057\u3085\u3046","\u3048\u3093\u305B\u3099\u3064","\u3048\u3093\u305D\u304F","\u3048\u3093\u3061\u3087\u3046","\u3048\u3093\u3068\u3064","\u304A\u3044\u304B\u3051\u308B","\u304A\u3044\u3053\u3059","\u304A\u3044\u3057\u3044","\u304A\u3044\u3064\u304F","\u304A\u3046\u3048\u3093","\u304A\u3046\u3055\u307E","\u304A\u3046\u3057\u3099","\u304A\u3046\u305B\u3064","\u304A\u3046\u305F\u3044","\u304A\u3046\u3075\u304F","\u304A\u3046\u3078\u3099\u3044","\u304A\u3046\u3088\u3046","\u304A\u3048\u308B","\u304A\u304A\u3044","\u304A\u304A\u3046","\u304A\u304A\u3068\u3099\u304A\u308A","\u304A\u304A\u3084","\u304A\u304A\u3088\u305D","\u304A\u304B\u3048\u308A","\u304A\u304B\u3059\u3099","\u304A\u304B\u3099\u3080","\u304A\u304B\u308F\u308A","\u304A\u304D\u3099\u306A\u3046","\u304A\u304D\u308B","\u304A\u304F\u3055\u307E","\u304A\u304F\u3057\u3099\u3087\u3046","\u304A\u304F\u308A\u304B\u3099\u306A","\u304A\u304F\u308B","\u304A\u304F\u308C\u308B","\u304A\u3053\u3059","\u304A\u3053\u306A\u3046","\u304A\u3053\u308B","\u304A\u3055\u3048\u308B","\u304A\u3055\u306A\u3044","\u304A\u3055\u3081\u308B","\u304A\u3057\u3044\u308C","\u304A\u3057\u3048\u308B","\u304A\u3057\u3099\u304D\u3099","\u304A\u3057\u3099\u3055\u3093","\u304A\u3057\u3083\u308C","\u304A\u305D\u3089\u304F","\u304A\u305D\u308F\u308B","\u304A\u305F\u304B\u3099\u3044","\u304A\u305F\u304F","\u304A\u305F\u3099\u3084\u304B","\u304A\u3061\u3064\u304F","\u304A\u3063\u3068","\u304A\u3064\u308A","\u304A\u3066\u3099\u304B\u3051","\u304A\u3068\u3057\u3082\u306E","\u304A\u3068\u306A\u3057\u3044","\u304A\u3068\u3099\u308A","\u304A\u3068\u3099\u308D\u304B\u3059","\u304A\u306F\u3099\u3055\u3093","\u304A\u307E\u3044\u308A","\u304A\u3081\u3066\u3099\u3068\u3046","\u304A\u3082\u3044\u3066\u3099","\u304A\u3082\u3046","\u304A\u3082\u305F\u3044","\u304A\u3082\u3061\u3083","\u304A\u3084\u3064","\u304A\u3084\u3086\u3072\u3099","\u304A\u3088\u307B\u3099\u3059","\u304A\u3089\u3093\u305F\u3099","\u304A\u308D\u3059","\u304A\u3093\u304B\u3099\u304F","\u304A\u3093\u3051\u3044","\u304A\u3093\u3057\u3083","\u304A\u3093\u305B\u3093","\u304A\u3093\u305F\u3099\u3093","\u304A\u3093\u3061\u3085\u3046","\u304A\u3093\u3068\u3099\u3051\u3044","\u304B\u3042\u3064","\u304B\u3044\u304B\u3099","\u304B\u3099\u3044\u304D","\u304B\u3099\u3044\u3051\u3093","\u304B\u3099\u3044\u3053\u3046","\u304B\u3044\u3055\u3064","\u304B\u3044\u3057\u3083","\u304B\u3044\u3059\u3044\u3088\u304F","\u304B\u3044\u305B\u3099\u3093","\u304B\u3044\u305D\u3099\u3046\u3068\u3099","\u304B\u3044\u3064\u3046","\u304B\u3044\u3066\u3093","\u304B\u3044\u3068\u3046","\u304B\u3044\u3075\u304F","\u304B\u3099\u3044\u3078\u304D","\u304B\u3044\u307B\u3046","\u304B\u3044\u3088\u3046","\u304B\u3099\u3044\u3089\u3044","\u304B\u3044\u308F","\u304B\u3048\u308B","\u304B\u304A\u308A","\u304B\u304B\u3048\u308B","\u304B\u304B\u3099\u304F","\u304B\u304B\u3099\u3057","\u304B\u304B\u3099\u307F","\u304B\u304F\u3053\u3099","\u304B\u304F\u3068\u304F","\u304B\u3055\u3099\u308B","\u304B\u3099\u305D\u3099\u3046","\u304B\u305F\u3044","\u304B\u305F\u3061","\u304B\u3099\u3061\u3087\u3046","\u304B\u3099\u3063\u304D\u3085\u3046","\u304B\u3099\u3063\u3053\u3046","\u304B\u3099\u3063\u3055\u3093","\u304B\u3099\u3063\u3057\u3087\u3046","\u304B\u306A\u3055\u3099\u308F\u3057","\u304B\u306E\u3046","\u304B\u3099\u306F\u304F","\u304B\u3075\u3099\u304B","\u304B\u307B\u3046","\u304B\u307B\u3053\u3099","\u304B\u307E\u3046","\u304B\u307E\u307B\u3099\u3053","\u304B\u3081\u308C\u304A\u3093","\u304B\u3086\u3044","\u304B\u3088\u3046\u3072\u3099","\u304B\u3089\u3044","\u304B\u308B\u3044","\u304B\u308D\u3046","\u304B\u308F\u304F","\u304B\u308F\u3089","\u304B\u3099\u3093\u304B","\u304B\u3093\u3051\u3044","\u304B\u3093\u3053\u3046","\u304B\u3093\u3057\u3083","\u304B\u3093\u305D\u3046","\u304B\u3093\u305F\u3093","\u304B\u3093\u3061","\u304B\u3099\u3093\u306F\u3099\u308B","\u304D\u3042\u3044","\u304D\u3042\u3064","\u304D\u3044\u308D","\u304D\u3099\u3044\u3093","\u304D\u3046\u3044","\u304D\u3046\u3093","\u304D\u3048\u308B","\u304D\u304A\u3046","\u304D\u304A\u304F","\u304D\u304A\u3061","\u304D\u304A\u3093","\u304D\u304B\u3044","\u304D\u304B\u304F","\u304D\u304B\u3093\u3057\u3083","\u304D\u304D\u3066","\u304D\u304F\u306F\u3099\u308A","\u304D\u304F\u3089\u3051\u3099","\u304D\u3051\u3093\u305B\u3044","\u304D\u3053\u3046","\u304D\u3053\u3048\u308B","\u304D\u3053\u304F","\u304D\u3055\u3044","\u304D\u3055\u304F","\u304D\u3055\u307E","\u304D\u3055\u3089\u304D\u3099","\u304D\u3099\u3057\u3099\u304B\u304B\u3099\u304F","\u304D\u3099\u3057\u304D","\u304D\u3099\u3057\u3099\u305F\u3044\u3051\u3093","\u304D\u3099\u3057\u3099\u306B\u3063\u3066\u3044","\u304D\u3099\u3057\u3099\u3085\u3064\u3057\u3083","\u304D\u3059\u3046","\u304D\u305B\u3044","\u304D\u305B\u304D","\u304D\u305B\u3064","\u304D\u305D\u3046","\u304D\u305D\u3099\u304F","\u304D\u305D\u3099\u3093","\u304D\u305F\u3048\u308B","\u304D\u3061\u3087\u3046","\u304D\u3064\u3048\u3093","\u304D\u3099\u3063\u3061\u308A","\u304D\u3064\u3064\u304D","\u304D\u3064\u306D","\u304D\u3066\u3044","\u304D\u3068\u3099\u3046","\u304D\u3068\u3099\u304F","\u304D\u306A\u3044","\u304D\u306A\u304B\u3099","\u304D\u306A\u3053","\u304D\u306C\u3053\u3099\u3057","\u304D\u306D\u3093","\u304D\u306E\u3046","\u304D\u306E\u3057\u305F","\u304D\u306F\u304F","\u304D\u3072\u3099\u3057\u3044","\u304D\u3072\u3093","\u304D\u3075\u304F","\u304D\u3075\u3099\u3093","\u304D\u307B\u3099\u3046","\u304D\u307B\u3093","\u304D\u307E\u308B","\u304D\u307F\u3064","\u304D\u3080\u3059\u3099\u304B\u3057\u3044","\u304D\u3081\u308B","\u304D\u3082\u305F\u3099\u3081\u3057","\u304D\u3082\u3061","\u304D\u3082\u306E","\u304D\u3083\u304F","\u304D\u3084\u304F","\u304D\u3099\u3085\u3046\u306B\u304F","\u304D\u3088\u3046","\u304D\u3087\u3046\u308A\u3085\u3046","\u304D\u3089\u3044","\u304D\u3089\u304F","\u304D\u308A\u3093","\u304D\u308C\u3044","\u304D\u308C\u3064","\u304D\u308D\u304F","\u304D\u3099\u308D\u3093","\u304D\u308F\u3081\u308B","\u304D\u3099\u3093\u3044\u308D","\u304D\u3093\u304B\u304F\u3057\u3099","\u304D\u3093\u3057\u3099\u3087","\u304D\u3093\u3088\u3046\u3072\u3099","\u304F\u3099\u3042\u3044","\u304F\u3044\u3059\u3099","\u304F\u3046\u304B\u3093","\u304F\u3046\u304D","\u304F\u3046\u304F\u3099\u3093","\u304F\u3046\u3053\u3046","\u304F\u3099\u3046\u305B\u3044","\u304F\u3046\u305D\u3046","\u304F\u3099\u3046\u305F\u3089","\u304F\u3046\u3075\u304F","\u304F\u3046\u307B\u3099","\u304F\u304B\u3093","\u304F\u304D\u3087\u3046","\u304F\u3051\u3099\u3093","\u304F\u3099\u3053\u3046","\u304F\u3055\u3044","\u304F\u3055\u304D","\u304F\u3055\u306F\u3099\u306A","\u304F\u3055\u308B","\u304F\u3057\u3083\u307F","\u304F\u3057\u3087\u3046","\u304F\u3059\u306E\u304D","\u304F\u3059\u308A\u3086\u3072\u3099","\u304F\u305B\u3051\u3099","\u304F\u305B\u3093","\u304F\u3099\u305F\u3044\u3066\u304D","\u304F\u305F\u3099\u3055\u308B","\u304F\u305F\u3072\u3099\u308C\u308B","\u304F\u3061\u3053\u307F","\u304F\u3061\u3055\u304D","\u304F\u3064\u3057\u305F","\u304F\u3099\u3063\u3059\u308A","\u304F\u3064\u308D\u304F\u3099","\u304F\u3068\u3046\u3066\u3093","\u304F\u3068\u3099\u304F","\u304F\u306A\u3093","\u304F\u306D\u304F\u306D","\u304F\u306E\u3046","\u304F\u3075\u3046","\u304F\u307F\u3042\u308F\u305B","\u304F\u307F\u305F\u3066\u308B","\u304F\u3081\u308B","\u304F\u3084\u304F\u3057\u3087","\u304F\u3089\u3059","\u304F\u3089\u3078\u3099\u308B","\u304F\u308B\u307E","\u304F\u308C\u308B","\u304F\u308D\u3046","\u304F\u308F\u3057\u3044","\u304F\u3099\u3093\u304B\u3093","\u304F\u3099\u3093\u3057\u3087\u304F","\u304F\u3099\u3093\u305F\u3044","\u304F\u3099\u3093\u3066","\u3051\u3042\u306A","\u3051\u3044\u304B\u304F","\u3051\u3044\u3051\u3093","\u3051\u3044\u3053","\u3051\u3044\u3055\u3064","\u3051\u3099\u3044\u3057\u3099\u3085\u3064","\u3051\u3044\u305F\u3044","\u3051\u3099\u3044\u306E\u3046\u3057\u3099\u3093","\u3051\u3044\u308C\u304D","\u3051\u3044\u308D","\u3051\u304A\u3068\u3059","\u3051\u304A\u308A\u3082\u306E","\u3051\u3099\u304D\u304B","\u3051\u3099\u304D\u3051\u3099\u3093","\u3051\u3099\u304D\u305F\u3099\u3093","\u3051\u3099\u304D\u3061\u3093","\u3051\u3099\u304D\u3068\u3064","\u3051\u3099\u304D\u306F","\u3051\u3099\u304D\u3084\u304F","\u3051\u3099\u3053\u3046","\u3051\u3099\u3053\u304F\u3057\u3099\u3087\u3046","\u3051\u3099\u3055\u3099\u3044","\u3051\u3055\u304D","\u3051\u3099\u3055\u3099\u3093","\u3051\u3057\u304D","\u3051\u3057\u3053\u3099\u3080","\u3051\u3057\u3087\u3046","\u3051\u3099\u3059\u3068","\u3051\u305F\u306F\u3099","\u3051\u3061\u3083\u3063\u3075\u309A","\u3051\u3061\u3089\u3059","\u3051\u3064\u3042\u3064","\u3051\u3064\u3044","\u3051\u3064\u3048\u304D","\u3051\u3063\u3053\u3093","\u3051\u3064\u3057\u3099\u3087","\u3051\u3063\u305B\u304D","\u3051\u3063\u3066\u3044","\u3051\u3064\u307E\u3064","\u3051\u3099\u3064\u3088\u3046\u3072\u3099","\u3051\u3099\u3064\u308C\u3044","\u3051\u3064\u308D\u3093","\u3051\u3099\u3068\u3099\u304F","\u3051\u3068\u306F\u3099\u3059","\u3051\u3068\u308B","\u3051\u306A\u3051\u3099","\u3051\u306A\u3059","\u3051\u306A\u307F","\u3051\u306C\u304D","\u3051\u3099\u306D\u3064","\u3051\u306D\u3093","\u3051\u306F\u3044","\u3051\u3099\u3072\u3093","\u3051\u3075\u3099\u304B\u3044","\u3051\u3099\u307B\u3099\u304F","\u3051\u307E\u308A","\u3051\u307F\u304B\u308B","\u3051\u3080\u3057","\u3051\u3080\u308A","\u3051\u3082\u306E","\u3051\u3089\u3044","\u3051\u308D\u3051\u308D","\u3051\u308F\u3057\u3044","\u3051\u3093\u3044","\u3051\u3093\u3048\u3064","\u3051\u3093\u304A","\u3051\u3093\u304B","\u3051\u3099\u3093\u304D","\u3051\u3093\u3051\u3099\u3093","\u3051\u3093\u3053\u3046","\u3051\u3093\u3055\u304F","\u3051\u3093\u3057\u3085\u3046","\u3051\u3093\u3059\u3046","\u3051\u3099\u3093\u305D\u3046","\u3051\u3093\u3061\u304F","\u3051\u3093\u3066\u3044","\u3051\u3093\u3068\u3046","\u3051\u3093\u306A\u3044","\u3051\u3093\u306B\u3093","\u3051\u3099\u3093\u3075\u3099\u3064","\u3051\u3093\u307E","\u3051\u3093\u307F\u3093","\u3051\u3093\u3081\u3044","\u3051\u3093\u3089\u3093","\u3051\u3093\u308A","\u3053\u3042\u304F\u307E","\u3053\u3044\u306C","\u3053\u3044\u3072\u3099\u3068","\u3053\u3099\u3046\u3044","\u3053\u3046\u3048\u3093","\u3053\u3046\u304A\u3093","\u3053\u3046\u304B\u3093","\u3053\u3099\u3046\u304D\u3085\u3046","\u3053\u3099\u3046\u3051\u3044","\u3053\u3046\u3053\u3046","\u3053\u3046\u3055\u3044","\u3053\u3046\u3057\u3099","\u3053\u3046\u3059\u3044","\u3053\u3099\u3046\u305B\u3044","\u3053\u3046\u305D\u304F","\u3053\u3046\u305F\u3044","\u3053\u3046\u3061\u3083","\u3053\u3046\u3064\u3046","\u3053\u3046\u3066\u3044","\u3053\u3046\u3068\u3099\u3046","\u3053\u3046\u306A\u3044","\u3053\u3046\u306F\u3044","\u3053\u3099\u3046\u307B\u3046","\u3053\u3099\u3046\u307E\u3093","\u3053\u3046\u3082\u304F","\u3053\u3046\u308A\u3064","\u3053\u3048\u308B","\u3053\u304A\u308A","\u3053\u3099\u304B\u3044","\u3053\u3099\u304B\u3099\u3064","\u3053\u3099\u304B\u3093","\u3053\u304F\u3053\u3099","\u3053\u304F\u3055\u3044","\u3053\u304F\u3068\u3046","\u3053\u304F\u306A\u3044","\u3053\u304F\u306F\u304F","\u3053\u304F\u3099\u307E","\u3053\u3051\u3044","\u3053\u3051\u308B","\u3053\u3053\u306E\u304B","\u3053\u3053\u308D","\u3053\u3055\u3081","\u3053\u3057\u3064","\u3053\u3059\u3046","\u3053\u305B\u3044","\u3053\u305B\u304D","\u3053\u305B\u3099\u3093","\u3053\u305D\u305F\u3099\u3066","\u3053\u305F\u3044","\u3053\u305F\u3048\u308B","\u3053\u305F\u3064","\u3053\u3061\u3087\u3046","\u3053\u3063\u304B","\u3053\u3064\u3053\u3064","\u3053\u3064\u306F\u3099\u3093","\u3053\u3064\u3075\u3099","\u3053\u3066\u3044","\u3053\u3066\u3093","\u3053\u3068\u304B\u3099\u3089","\u3053\u3068\u3057","\u3053\u3068\u306F\u3099","\u3053\u3068\u308A","\u3053\u306A\u3053\u3099\u306A","\u3053\u306D\u3053\u306D","\u3053\u306E\u307E\u307E","\u3053\u306E\u307F","\u3053\u306E\u3088","\u3053\u3099\u306F\u3093","\u3053\u3072\u3064\u3057\u3099","\u3053\u3075\u3046","\u3053\u3075\u3093","\u3053\u307B\u3099\u308C\u308B","\u3053\u3099\u307E\u3042\u3075\u3099\u3089","\u3053\u307E\u304B\u3044","\u3053\u3099\u307E\u3059\u308A","\u3053\u307E\u3064\u306A","\u3053\u307E\u308B","\u3053\u3080\u304D\u3099\u3053","\u3053\u3082\u3057\u3099","\u3053\u3082\u3061","\u3053\u3082\u306E","\u3053\u3082\u3093","\u3053\u3084\u304F","\u3053\u3084\u307E","\u3053\u3086\u3046","\u3053\u3086\u3072\u3099","\u3053\u3088\u3044","\u3053\u3088\u3046","\u3053\u308A\u308B","\u3053\u308C\u304F\u3057\u3087\u3093","\u3053\u308D\u3063\u3051","\u3053\u308F\u3082\u3066","\u3053\u308F\u308C\u308B","\u3053\u3093\u3044\u3093","\u3053\u3093\u304B\u3044","\u3053\u3093\u304D","\u3053\u3093\u3057\u3085\u3046","\u3053\u3093\u3059\u3044","\u3053\u3093\u305F\u3099\u3066","\u3053\u3093\u3068\u3093","\u3053\u3093\u306A\u3093","\u3053\u3093\u3072\u3099\u306B","\u3053\u3093\u307B\u309A\u3093","\u3053\u3093\u307E\u3051","\u3053\u3093\u3084","\u3053\u3093\u308C\u3044","\u3053\u3093\u308F\u304F","\u3055\u3099\u3044\u3048\u304D","\u3055\u3044\u304B\u3044","\u3055\u3044\u304D\u3093","\u3055\u3099\u3044\u3051\u3099\u3093","\u3055\u3099\u3044\u3053","\u3055\u3044\u3057\u3087","\u3055\u3044\u305B\u3044","\u3055\u3099\u3044\u305F\u304F","\u3055\u3099\u3044\u3061\u3085\u3046","\u3055\u3044\u3066\u304D","\u3055\u3099\u3044\u308A\u3087\u3046","\u3055\u3046\u306A","\u3055\u304B\u3044\u3057","\u3055\u304B\u3099\u3059","\u3055\u304B\u306A","\u3055\u304B\u307F\u3061","\u3055\u304B\u3099\u308B","\u3055\u304D\u3099\u3087\u3046","\u3055\u304F\u3057","\u3055\u304F\u3072\u3093","\u3055\u304F\u3089","\u3055\u3053\u304F","\u3055\u3053\u3064","\u3055\u3059\u3099\u304B\u308B","\u3055\u3099\u305B\u304D","\u3055\u305F\u3093","\u3055\u3064\u3048\u3044","\u3055\u3099\u3064\u304A\u3093","\u3055\u3099\u3063\u304B","\u3055\u3099\u3064\u304B\u3099\u304F","\u3055\u3063\u304D\u3087\u304F","\u3055\u3099\u3063\u3057","\u3055\u3064\u3057\u3099\u3093","\u3055\u3099\u3063\u305D\u3046","\u3055\u3064\u305F\u306F\u3099","\u3055\u3064\u307E\u3044\u3082","\u3055\u3066\u3044","\u3055\u3068\u3044\u3082","\u3055\u3068\u3046","\u3055\u3068\u304A\u3084","\u3055\u3068\u3057","\u3055\u3068\u308B","\u3055\u306E\u3046","\u3055\u306F\u3099\u304F","\u3055\u3072\u3099\u3057\u3044","\u3055\u3078\u3099\u3064","\u3055\u307B\u3046","\u3055\u307B\u3068\u3099","\u3055\u307E\u3059","\u3055\u307F\u3057\u3044","\u3055\u307F\u305F\u3099\u308C","\u3055\u3080\u3051","\u3055\u3081\u308B","\u3055\u3084\u3048\u3093\u3068\u3099\u3046","\u3055\u3086\u3046","\u3055\u3088\u3046","\u3055\u3088\u304F","\u3055\u3089\u305F\u3099","\u3055\u3099\u308B\u305D\u306F\u3099","\u3055\u308F\u3084\u304B","\u3055\u308F\u308B","\u3055\u3093\u3044\u3093","\u3055\u3093\u304B","\u3055\u3093\u304D\u3083\u304F","\u3055\u3093\u3053\u3046","\u3055\u3093\u3055\u3044","\u3055\u3099\u3093\u3057\u3087","\u3055\u3093\u3059\u3046","\u3055\u3093\u305B\u3044","\u3055\u3093\u305D","\u3055\u3093\u3061","\u3055\u3093\u307E","\u3055\u3093\u307F","\u3055\u3093\u3089\u3093","\u3057\u3042\u3044","\u3057\u3042\u3051\u3099","\u3057\u3042\u3055\u3063\u3066","\u3057\u3042\u308F\u305B","\u3057\u3044\u304F","\u3057\u3044\u3093","\u3057\u3046\u3061","\u3057\u3048\u3044","\u3057\u304A\u3051","\u3057\u304B\u3044","\u3057\u304B\u304F","\u3057\u3099\u304B\u3093","\u3057\u3053\u3099\u3068","\u3057\u3059\u3046","\u3057\u3099\u305F\u3099\u3044","\u3057\u305F\u3046\u3051","\u3057\u305F\u304D\u3099","\u3057\u305F\u3066","\u3057\u305F\u307F","\u3057\u3061\u3087\u3046","\u3057\u3061\u308A\u3093","\u3057\u3063\u304B\u308A","\u3057\u3064\u3057\u3099","\u3057\u3064\u3082\u3093","\u3057\u3066\u3044","\u3057\u3066\u304D","\u3057\u3066\u3064","\u3057\u3099\u3066\u3093","\u3057\u3099\u3068\u3099\u3046","\u3057\u306A\u304D\u3099\u308C","\u3057\u306A\u3082\u306E","\u3057\u306A\u3093","\u3057\u306D\u307E","\u3057\u306D\u3093","\u3057\u306E\u304F\u3099","\u3057\u306E\u3075\u3099","\u3057\u306F\u3044","\u3057\u306F\u3099\u304B\u308A","\u3057\u306F\u3064","\u3057\u306F\u3089\u3044","\u3057\u306F\u3093","\u3057\u3072\u3087\u3046","\u3057\u3075\u304F","\u3057\u3099\u3075\u3099\u3093","\u3057\u3078\u3044","\u3057\u307B\u3046","\u3057\u307B\u3093","\u3057\u307E\u3046","\u3057\u307E\u308B","\u3057\u307F\u3093","\u3057\u3080\u3051\u308B","\u3057\u3099\u3080\u3057\u3087","\u3057\u3081\u3044","\u3057\u3081\u308B","\u3057\u3082\u3093","\u3057\u3083\u3044\u3093","\u3057\u3083\u3046\u3093","\u3057\u3083\u304A\u3093","\u3057\u3099\u3083\u304B\u3099\u3044\u3082","\u3057\u3084\u304F\u3057\u3087","\u3057\u3083\u304F\u307B\u3046","\u3057\u3083\u3051\u3093","\u3057\u3083\u3053","\u3057\u3083\u3055\u3099\u3044","\u3057\u3083\u3057\u3093","\u3057\u3083\u305B\u3093","\u3057\u3083\u305D\u3046","\u3057\u3083\u305F\u3044","\u3057\u3083\u3061\u3087\u3046","\u3057\u3083\u3063\u304D\u3093","\u3057\u3099\u3083\u307E","\u3057\u3083\u308A\u3093","\u3057\u3083\u308C\u3044","\u3057\u3099\u3086\u3046","\u3057\u3099\u3085\u3046\u3057\u3087","\u3057\u3085\u304F\u306F\u304F","\u3057\u3099\u3085\u3057\u3093","\u3057\u3085\u3063\u305B\u304D","\u3057\u3085\u307F","\u3057\u3085\u3089\u306F\u3099","\u3057\u3099\u3085\u3093\u306F\u3099\u3093","\u3057\u3087\u3046\u304B\u3044","\u3057\u3087\u304F\u305F\u304F","\u3057\u3087\u3063\u3051\u3093","\u3057\u3087\u3068\u3099\u3046","\u3057\u3087\u3082\u3064","\u3057\u3089\u305B\u308B","\u3057\u3089\u3078\u3099\u308B","\u3057\u3093\u304B","\u3057\u3093\u3053\u3046","\u3057\u3099\u3093\u3057\u3099\u3083","\u3057\u3093\u305B\u3044\u3057\u3099","\u3057\u3093\u3061\u304F","\u3057\u3093\u308A\u3093","\u3059\u3042\u3051\u3099","\u3059\u3042\u3057","\u3059\u3042\u306A","\u3059\u3099\u3042\u3093","\u3059\u3044\u3048\u3044","\u3059\u3044\u304B","\u3059\u3044\u3068\u3046","\u3059\u3099\u3044\u3075\u3099\u3093","\u3059\u3044\u3088\u3046\u3072\u3099","\u3059\u3046\u304B\u3099\u304F","\u3059\u3046\u3057\u3099\u3064","\u3059\u3046\u305B\u3093","\u3059\u304A\u3068\u3099\u308A","\u3059\u304D\u307E","\u3059\u304F\u3046","\u3059\u304F\u306A\u3044","\u3059\u3051\u308B","\u3059\u3053\u3099\u3044","\u3059\u3053\u3057","\u3059\u3099\u3055\u3093","\u3059\u3059\u3099\u3057\u3044","\u3059\u3059\u3080","\u3059\u3059\u3081\u308B","\u3059\u3063\u304B\u308A","\u3059\u3099\u3063\u3057\u308A","\u3059\u3099\u3063\u3068","\u3059\u3066\u304D","\u3059\u3066\u308B","\u3059\u306D\u308B","\u3059\u306E\u3053","\u3059\u306F\u305F\u3099","\u3059\u306F\u3099\u3089\u3057\u3044","\u3059\u3099\u3072\u3087\u3046","\u3059\u3099\u3075\u3099\u306C\u308C","\u3059\u3075\u3099\u308A","\u3059\u3075\u308C","\u3059\u3078\u3099\u3066","\u3059\u3078\u3099\u308B","\u3059\u3099\u307B\u3046","\u3059\u307B\u3099\u3093","\u3059\u307E\u3044","\u3059\u3081\u3057","\u3059\u3082\u3046","\u3059\u3084\u304D","\u3059\u3089\u3059\u3089","\u3059\u308B\u3081","\u3059\u308C\u3061\u304B\u3099\u3046","\u3059\u308D\u3063\u3068","\u3059\u308F\u308B","\u3059\u3093\u305B\u3099\u3093","\u3059\u3093\u307B\u309A\u3046","\u305B\u3042\u3075\u3099\u3089","\u305B\u3044\u304B\u3064","\u305B\u3044\u3051\u3099\u3093","\u305B\u3044\u3057\u3099","\u305B\u3044\u3088\u3046","\u305B\u304A\u3046","\u305B\u304B\u3044\u304B\u3093","\u305B\u304D\u306B\u3093","\u305B\u304D\u3080","\u305B\u304D\u3086","\u305B\u304D\u3089\u3093\u3046\u3093","\u305B\u3051\u3093","\u305B\u3053\u3046","\u305B\u3059\u3057\u3099","\u305B\u305F\u3044","\u305B\u305F\u3051","\u305B\u3063\u304B\u304F","\u305B\u3063\u304D\u3083\u304F","\u305B\u3099\u3063\u304F","\u305B\u3063\u3051\u3093","\u305B\u3063\u3053\u3064","\u305B\u3063\u3055\u305F\u304F\u307E","\u305B\u3064\u305D\u3099\u304F","\u305B\u3064\u305F\u3099\u3093","\u305B\u3064\u3066\u3099\u3093","\u305B\u3063\u306F\u309A\u3093","\u305B\u3064\u3072\u3099","\u305B\u3064\u3075\u3099\u3093","\u305B\u3064\u3081\u3044","\u305B\u3064\u308A\u3064","\u305B\u306A\u304B","\u305B\u306E\u3072\u3099","\u305B\u306F\u306F\u3099","\u305B\u3072\u3099\u308D","\u305B\u307B\u3099\u306D","\u305B\u307E\u3044","\u305B\u307E\u308B","\u305B\u3081\u308B","\u305B\u3082\u305F\u308C","\u305B\u308A\u3075","\u305B\u3099\u3093\u3042\u304F","\u305B\u3093\u3044","\u305B\u3093\u3048\u3044","\u305B\u3093\u304B","\u305B\u3093\u304D\u3087","\u305B\u3093\u304F","\u305B\u3093\u3051\u3099\u3093","\u305B\u3099\u3093\u3053\u3099","\u305B\u3093\u3055\u3044","\u305B\u3093\u3057\u3085","\u305B\u3093\u3059\u3044","\u305B\u3093\u305B\u3044","\u305B\u3093\u305D\u3099","\u305B\u3093\u305F\u304F","\u305B\u3093\u3061\u3087\u3046","\u305B\u3093\u3066\u3044","\u305B\u3093\u3068\u3046","\u305B\u3093\u306C\u304D","\u305B\u3093\u306D\u3093","\u305B\u3093\u306F\u309A\u3044","\u305B\u3099\u3093\u3075\u3099","\u305B\u3099\u3093\u307B\u309A\u3046","\u305B\u3093\u3080","\u305B\u3093\u3081\u3093\u3057\u3099\u3087","\u305B\u3093\u3082\u3093","\u305B\u3093\u3084\u304F","\u305B\u3093\u3086\u3046","\u305B\u3093\u3088\u3046","\u305B\u3099\u3093\u3089","\u305B\u3099\u3093\u308A\u3083\u304F","\u305B\u3093\u308C\u3044","\u305B\u3093\u308D","\u305D\u3042\u304F","\u305D\u3044\u3068\u3051\u3099\u308B","\u305D\u3044\u306D","\u305D\u3046\u304B\u3099\u3093\u304D\u3087\u3046","\u305D\u3046\u304D","\u305D\u3046\u3053\u3099","\u305D\u3046\u3057\u3093","\u305D\u3046\u305F\u3099\u3093","\u305D\u3046\u306A\u3093","\u305D\u3046\u3072\u3099","\u305D\u3046\u3081\u3093","\u305D\u3046\u308A","\u305D\u3048\u3082\u306E","\u305D\u3048\u3093","\u305D\u304B\u3099\u3044","\u305D\u3051\u3099\u304D","\u305D\u3053\u3046","\u305D\u3053\u305D\u3053","\u305D\u3055\u3099\u3044","\u305D\u3057\u306A","\u305D\u305B\u3044","\u305D\u305B\u3093","\u305D\u305D\u304F\u3099","\u305D\u305F\u3099\u3066\u308B","\u305D\u3064\u3046","\u305D\u3064\u3048\u3093","\u305D\u3063\u304B\u3093","\u305D\u3064\u304D\u3099\u3087\u3046","\u305D\u3063\u3051\u3064","\u305D\u3063\u3053\u3046","\u305D\u3063\u305B\u3093","\u305D\u3063\u3068","\u305D\u3068\u304B\u3099\u308F","\u305D\u3068\u3064\u3099\u3089","\u305D\u306A\u3048\u308B","\u305D\u306A\u305F","\u305D\u3075\u307B\u3099","\u305D\u307B\u3099\u304F","\u305D\u307B\u3099\u308D","\u305D\u307E\u3064","\u305D\u307E\u308B","\u305D\u3080\u304F","\u305D\u3080\u308A\u3048","\u305D\u3081\u308B","\u305D\u3082\u305D\u3082","\u305D\u3088\u304B\u305B\u3099","\u305D\u3089\u307E\u3081","\u305D\u308D\u3046","\u305D\u3093\u304B\u3044","\u305D\u3093\u3051\u3044","\u305D\u3093\u3055\u3099\u3044","\u305D\u3093\u3057\u3064","\u305D\u3093\u305D\u3099\u304F","\u305D\u3093\u3061\u3087\u3046","\u305D\u3099\u3093\u3072\u3099","\u305D\u3099\u3093\u3075\u3099\u3093","\u305D\u3093\u307F\u3093","\u305F\u3042\u3044","\u305F\u3044\u3044\u3093","\u305F\u3044\u3046\u3093","\u305F\u3044\u3048\u304D","\u305F\u3044\u304A\u3046","\u305F\u3099\u3044\u304B\u3099\u304F","\u305F\u3044\u304D","\u305F\u3044\u304F\u3099\u3046","\u305F\u3044\u3051\u3093","\u305F\u3044\u3053","\u305F\u3044\u3055\u3099\u3044","\u305F\u3099\u3044\u3057\u3099\u3087\u3046\u3075\u3099","\u305F\u3099\u3044\u3059\u304D","\u305F\u3044\u305B\u3064","\u305F\u3044\u305D\u3046","\u305F\u3099\u3044\u305F\u3044","\u305F\u3044\u3061\u3087\u3046","\u305F\u3044\u3066\u3044","\u305F\u3099\u3044\u3068\u3099\u3053\u308D","\u305F\u3044\u306A\u3044","\u305F\u3044\u306D\u3064","\u305F\u3044\u306E\u3046","\u305F\u3044\u306F\u3093","\u305F\u3099\u3044\u3072\u3087\u3046","\u305F\u3044\u3075\u3046","\u305F\u3044\u3078\u3093","\u305F\u3044\u307B","\u305F\u3044\u307E\u3064\u306F\u3099\u306A","\u305F\u3044\u307F\u3093\u304F\u3099","\u305F\u3044\u3080","\u305F\u3044\u3081\u3093","\u305F\u3044\u3084\u304D","\u305F\u3044\u3088\u3046","\u305F\u3044\u3089","\u305F\u3044\u308A\u3087\u304F","\u305F\u3044\u308B","\u305F\u3044\u308F\u3093","\u305F\u3046\u3048","\u305F\u3048\u308B","\u305F\u304A\u3059","\u305F\u304A\u308B","\u305F\u304A\u308C\u308B","\u305F\u304B\u3044","\u305F\u304B\u306D","\u305F\u304D\u3072\u3099","\u305F\u304F\u3055\u3093","\u305F\u3053\u304F","\u305F\u3053\u3084\u304D","\u305F\u3055\u3044","\u305F\u3057\u3055\u3099\u3093","\u305F\u3099\u3057\u3099\u3083\u308C","\u305F\u3059\u3051\u308B","\u305F\u3059\u3099\u3055\u308F\u308B","\u305F\u305D\u304B\u3099\u308C","\u305F\u305F\u304B\u3046","\u305F\u305F\u304F","\u305F\u305F\u3099\u3057\u3044","\u305F\u305F\u307F","\u305F\u3061\u306F\u3099\u306A","\u305F\u3099\u3063\u304B\u3044","\u305F\u3099\u3063\u304D\u3083\u304F","\u305F\u3099\u3063\u3053","\u305F\u3099\u3063\u3057\u3085\u3064","\u305F\u3099\u3063\u305F\u3044","\u305F\u3066\u308B","\u305F\u3068\u3048\u308B","\u305F\u306A\u306F\u3099\u305F","\u305F\u306B\u3093","\u305F\u306C\u304D","\u305F\u306E\u3057\u307F","\u305F\u306F\u3064","\u305F\u3075\u3099\u3093","\u305F\u3078\u3099\u308B","\u305F\u307B\u3099\u3046","\u305F\u307E\u3053\u3099","\u305F\u307E\u308B","\u305F\u3099\u3080\u308B","\u305F\u3081\u3044\u304D","\u305F\u3081\u3059","\u305F\u3081\u308B","\u305F\u3082\u3064","\u305F\u3084\u3059\u3044","\u305F\u3088\u308B","\u305F\u3089\u3059","\u305F\u308A\u304D\u307B\u3093\u304B\u3099\u3093","\u305F\u308A\u3087\u3046","\u305F\u308A\u308B","\u305F\u308B\u3068","\u305F\u308C\u308B","\u305F\u308C\u3093\u3068","\u305F\u308D\u3063\u3068","\u305F\u308F\u3080\u308C\u308B","\u305F\u3099\u3093\u3042\u3064","\u305F\u3093\u3044","\u305F\u3093\u304A\u3093","\u305F\u3093\u304B","\u305F\u3093\u304D","\u305F\u3093\u3051\u3093","\u305F\u3093\u3053\u3099","\u305F\u3093\u3055\u3093","\u305F\u3093\u3057\u3099\u3087\u3046\u3072\u3099","\u305F\u3099\u3093\u305B\u3044","\u305F\u3093\u305D\u304F","\u305F\u3093\u305F\u3044","\u305F\u3099\u3093\u3061","\u305F\u3093\u3066\u3044","\u305F\u3093\u3068\u3046","\u305F\u3099\u3093\u306A","\u305F\u3093\u306B\u3093","\u305F\u3099\u3093\u306D\u3064","\u305F\u3093\u306E\u3046","\u305F\u3093\u3072\u309A\u3093","\u305F\u3099\u3093\u307B\u3099\u3046","\u305F\u3093\u307E\u3064","\u305F\u3093\u3081\u3044","\u305F\u3099\u3093\u308C\u3064","\u305F\u3099\u3093\u308D","\u305F\u3099\u3093\u308F","\u3061\u3042\u3044","\u3061\u3042\u3093","\u3061\u3044\u304D","\u3061\u3044\u3055\u3044","\u3061\u3048\u3093","\u3061\u304B\u3044","\u3061\u304B\u3089","\u3061\u304D\u3085\u3046","\u3061\u304D\u3093","\u3061\u3051\u3044\u3059\u3099","\u3061\u3051\u3093","\u3061\u3053\u304F","\u3061\u3055\u3044","\u3061\u3057\u304D","\u3061\u3057\u308A\u3087\u3046","\u3061\u305B\u3044","\u3061\u305D\u3046","\u3061\u305F\u3044","\u3061\u305F\u3093","\u3061\u3061\u304A\u3084","\u3061\u3064\u3057\u3099\u3087","\u3061\u3066\u304D","\u3061\u3066\u3093","\u3061\u306C\u304D","\u3061\u306C\u308A","\u3061\u306E\u3046","\u3061\u3072\u3087\u3046","\u3061\u3078\u3044\u305B\u3093","\u3061\u307B\u3046","\u3061\u307E\u305F","\u3061\u307F\u3064","\u3061\u307F\u3068\u3099\u308D","\u3061\u3081\u3044\u3068\u3099","\u3061\u3083\u3093\u3053\u306A\u3078\u3099","\u3061\u3085\u3046\u3044","\u3061\u3086\u308A\u3087\u304F","\u3061\u3087\u3046\u3057","\u3061\u3087\u3055\u304F\u3051\u3093","\u3061\u3089\u3057","\u3061\u3089\u307F","\u3061\u308A\u304B\u3099\u307F","\u3061\u308A\u3087\u3046","\u3061\u308B\u3068\u3099","\u3061\u308F\u308F","\u3061\u3093\u305F\u3044","\u3061\u3093\u3082\u304F","\u3064\u3044\u304B","\u3064\u3044\u305F\u3061","\u3064\u3046\u304B","\u3064\u3046\u3057\u3099\u3087\u3046","\u3064\u3046\u306F\u3093","\u3064\u3046\u308F","\u3064\u304B\u3046","\u3064\u304B\u308C\u308B","\u3064\u304F\u306D","\u3064\u304F\u308B","\u3064\u3051\u306D","\u3064\u3051\u308B","\u3064\u3053\u3099\u3046","\u3064\u305F\u3048\u308B","\u3064\u3064\u3099\u304F","\u3064\u3064\u3057\u3099","\u3064\u3064\u3080","\u3064\u3068\u3081\u308B","\u3064\u306A\u304B\u3099\u308B","\u3064\u306A\u307F","\u3064\u306D\u3064\u3099\u306D","\u3064\u306E\u308B","\u3064\u3075\u3099\u3059","\u3064\u307E\u3089\u306A\u3044","\u3064\u307E\u308B","\u3064\u307F\u304D","\u3064\u3081\u305F\u3044","\u3064\u3082\u308A","\u3064\u3082\u308B","\u3064\u3088\u3044","\u3064\u308B\u307B\u3099","\u3064\u308B\u307F\u304F","\u3064\u308F\u3082\u306E","\u3064\u308F\u308A","\u3066\u3042\u3057","\u3066\u3042\u3066","\u3066\u3042\u307F","\u3066\u3044\u304A\u3093","\u3066\u3044\u304B","\u3066\u3044\u304D","\u3066\u3044\u3051\u3044","\u3066\u3044\u3053\u304F","\u3066\u3044\u3055\u3064","\u3066\u3044\u3057","\u3066\u3044\u305B\u3044","\u3066\u3044\u305F\u3044","\u3066\u3044\u3068\u3099","\u3066\u3044\u306D\u3044","\u3066\u3044\u3072\u3087\u3046","\u3066\u3044\u3078\u3093","\u3066\u3044\u307B\u3099\u3046","\u3066\u3046\u3061","\u3066\u304A\u304F\u308C","\u3066\u304D\u3068\u3046","\u3066\u304F\u3072\u3099","\u3066\u3099\u3053\u307B\u3099\u3053","\u3066\u3055\u304D\u3099\u3087\u3046","\u3066\u3055\u3051\u3099","\u3066\u3059\u308A","\u3066\u305D\u3046","\u3066\u3061\u304B\u3099\u3044","\u3066\u3061\u3087\u3046","\u3066\u3064\u304B\u3099\u304F","\u3066\u3064\u3064\u3099\u304D","\u3066\u3099\u3063\u306F\u309A","\u3066\u3064\u307B\u3099\u3046","\u3066\u3064\u3084","\u3066\u3099\u306C\u304B\u3048","\u3066\u306C\u304D","\u3066\u306C\u304F\u3099\u3044","\u3066\u306E\u3072\u3089","\u3066\u306F\u3044","\u3066\u3075\u3099\u304F\u308D","\u3066\u3075\u305F\u3099","\u3066\u307B\u3068\u3099\u304D","\u3066\u307B\u3093","\u3066\u307E\u3048","\u3066\u307E\u304D\u3059\u3099\u3057","\u3066\u307F\u3057\u3099\u304B","\u3066\u307F\u3084\u3051\u3099","\u3066\u3089\u3059","\u3066\u308C\u3072\u3099","\u3066\u308F\u3051","\u3066\u308F\u305F\u3057","\u3066\u3099\u3093\u3042\u3064","\u3066\u3093\u3044\u3093","\u3066\u3093\u304B\u3044","\u3066\u3093\u304D","\u3066\u3093\u304F\u3099","\u3066\u3093\u3051\u3093","\u3066\u3093\u3053\u3099\u304F","\u3066\u3093\u3055\u3044","\u3066\u3093\u3057","\u3066\u3093\u3059\u3046","\u3066\u3099\u3093\u3061","\u3066\u3093\u3066\u304D","\u3066\u3093\u3068\u3046","\u3066\u3093\u306A\u3044","\u3066\u3093\u3075\u309A\u3089","\u3066\u3093\u307B\u3099\u3046\u305F\u3099\u3044","\u3066\u3093\u3081\u3064","\u3066\u3093\u3089\u3093\u304B\u3044","\u3066\u3099\u3093\u308A\u3087\u304F","\u3066\u3099\u3093\u308F","\u3068\u3099\u3042\u3044","\u3068\u3044\u308C","\u3068\u3099\u3046\u304B\u3093","\u3068\u3046\u304D\u3085\u3046","\u3068\u3099\u3046\u304F\u3099","\u3068\u3046\u3057","\u3068\u3046\u3080\u304D\u3099","\u3068\u304A\u3044","\u3068\u304A\u304B","\u3068\u304A\u304F","\u3068\u304A\u3059","\u3068\u304A\u308B","\u3068\u304B\u3044","\u3068\u304B\u3059","\u3068\u304D\u304A\u308A","\u3068\u304D\u3068\u3099\u304D","\u3068\u304F\u3044","\u3068\u304F\u3057\u3085\u3046","\u3068\u304F\u3066\u3093","\u3068\u304F\u306B","\u3068\u304F\u3078\u3099\u3064","\u3068\u3051\u3044","\u3068\u3051\u308B","\u3068\u3053\u3084","\u3068\u3055\u304B","\u3068\u3057\u3087\u304B\u3093","\u3068\u305D\u3046","\u3068\u305F\u3093","\u3068\u3061\u3085\u3046","\u3068\u3063\u304D\u3085\u3046","\u3068\u3063\u304F\u3093","\u3068\u3064\u305B\u3099\u3093","\u3068\u3064\u306B\u3085\u3046","\u3068\u3068\u3099\u3051\u308B","\u3068\u3068\u306E\u3048\u308B","\u3068\u306A\u3044","\u3068\u306A\u3048\u308B","\u3068\u306A\u308A","\u3068\u306E\u3055\u307E","\u3068\u306F\u3099\u3059","\u3068\u3099\u3075\u3099\u304B\u3099\u308F","\u3068\u307B\u3046","\u3068\u307E\u308B","\u3068\u3081\u308B","\u3068\u3082\u305F\u3099\u3061","\u3068\u3082\u308B","\u3068\u3099\u3088\u3046\u3072\u3099","\u3068\u3089\u3048\u308B","\u3068\u3093\u304B\u3064","\u3068\u3099\u3093\u3075\u3099\u308A","\u306A\u3044\u304B\u304F","\u306A\u3044\u3053\u3046","\u306A\u3044\u3057\u3087","\u306A\u3044\u3059","\u306A\u3044\u305B\u3093","\u306A\u3044\u305D\u3046","\u306A\u304A\u3059","\u306A\u304B\u3099\u3044","\u306A\u304F\u3059","\u306A\u3051\u3099\u308B","\u306A\u3053\u3046\u3068\u3099","\u306A\u3055\u3051","\u306A\u305F\u3066\u3099\u3053\u3053","\u306A\u3063\u3068\u3046","\u306A\u3064\u3084\u3059\u307F","\u306A\u306A\u304A\u3057","\u306A\u306B\u3053\u3099\u3068","\u306A\u306B\u3082\u306E","\u306A\u306B\u308F","\u306A\u306E\u304B","\u306A\u3075\u305F\u3099","\u306A\u307E\u3044\u304D","\u306A\u307E\u3048","\u306A\u307E\u307F","\u306A\u307F\u305F\u3099","\u306A\u3081\u3089\u304B","\u306A\u3081\u308B","\u306A\u3084\u3080","\u306A\u3089\u3046","\u306A\u3089\u3072\u3099","\u306A\u3089\u3075\u3099","\u306A\u308C\u308B","\u306A\u308F\u3068\u3072\u3099","\u306A\u308F\u306F\u3099\u308A","\u306B\u3042\u3046","\u306B\u3044\u304B\u3099\u305F","\u306B\u3046\u3051","\u306B\u304A\u3044","\u306B\u304B\u3044","\u306B\u304B\u3099\u3066","\u306B\u304D\u3072\u3099","\u306B\u304F\u3057\u307F","\u306B\u304F\u307E\u3093","\u306B\u3051\u3099\u308B","\u306B\u3055\u3093\u304B\u305F\u3093\u305D","\u306B\u3057\u304D","\u306B\u305B\u3082\u306E","\u306B\u3061\u3057\u3099\u3087\u3046","\u306B\u3061\u3088\u3046\u3072\u3099","\u306B\u3063\u304B","\u306B\u3063\u304D","\u306B\u3063\u3051\u3044","\u306B\u3063\u3053\u3046","\u306B\u3063\u3055\u3093","\u306B\u3063\u3057\u3087\u304F","\u306B\u3063\u3059\u3046","\u306B\u3063\u305B\u304D","\u306B\u3063\u3066\u3044","\u306B\u306A\u3046","\u306B\u307B\u3093","\u306B\u307E\u3081","\u306B\u3082\u3064","\u306B\u3084\u308A","\u306B\u3085\u3046\u3044\u3093","\u306B\u308A\u3093\u3057\u3083","\u306B\u308F\u3068\u308A","\u306B\u3093\u3044","\u306B\u3093\u304B","\u306B\u3093\u304D","\u306B\u3093\u3051\u3099\u3093","\u306B\u3093\u3057\u304D","\u306B\u3093\u3059\u3099\u3046","\u306B\u3093\u305D\u3046","\u306B\u3093\u305F\u3044","\u306B\u3093\u3061","\u306B\u3093\u3066\u3044","\u306B\u3093\u306B\u304F","\u306B\u3093\u3075\u309A","\u306B\u3093\u307E\u308A","\u306B\u3093\u3080","\u306B\u3093\u3081\u3044","\u306B\u3093\u3088\u3046","\u306C\u3044\u304F\u304D\u3099","\u306C\u304B\u3059","\u306C\u304F\u3099\u3044\u3068\u308B","\u306C\u304F\u3099\u3046","\u306C\u304F\u3082\u308A","\u306C\u3059\u3080","\u306C\u307E\u3048\u3072\u3099","\u306C\u3081\u308A","\u306C\u3089\u3059","\u306C\u3093\u3061\u3083\u304F","\u306D\u3042\u3051\u3099","\u306D\u3044\u304D","\u306D\u3044\u308B","\u306D\u3044\u308D","\u306D\u304F\u3099\u305B","\u306D\u304F\u305F\u3044","\u306D\u304F\u3089","\u306D\u3053\u305B\u3099","\u306D\u3053\u3080","\u306D\u3055\u3051\u3099","\u306D\u3059\u3053\u3099\u3059","\u306D\u305D\u3078\u3099\u308B","\u306D\u305F\u3099\u3093","\u306D\u3064\u3044","\u306D\u3063\u3057\u3093","\u306D\u3064\u305D\u3099\u3046","\u306D\u3063\u305F\u3044\u304D\u3099\u3087","\u306D\u3075\u3099\u305D\u304F","\u306D\u3075\u305F\u3099","\u306D\u307B\u3099\u3046","\u306D\u307B\u308A\u306F\u307B\u308A","\u306D\u307E\u304D","\u306D\u307E\u308F\u3057","\u306D\u307F\u307F","\u306D\u3080\u3044","\u306D\u3080\u305F\u3044","\u306D\u3082\u3068","\u306D\u3089\u3046","\u306D\u308F\u3055\u3099","\u306D\u3093\u3044\u308A","\u306D\u3093\u304A\u3057","\u306D\u3093\u304B\u3093","\u306D\u3093\u304D\u3093","\u306D\u3093\u304F\u3099","\u306D\u3093\u3055\u3099","\u306D\u3093\u3057","\u306D\u3093\u3061\u3083\u304F","\u306D\u3093\u3068\u3099","\u306D\u3093\u3072\u309A","\u306D\u3093\u3075\u3099\u3064","\u306D\u3093\u307E\u3064","\u306D\u3093\u308A\u3087\u3046","\u306D\u3093\u308C\u3044","\u306E\u3044\u3059\u3099","\u306E\u304A\u3064\u3099\u307E","\u306E\u304B\u3099\u3059","\u306E\u304D\u306A\u307F","\u306E\u3053\u304D\u3099\u308A","\u306E\u3053\u3059","\u306E\u3053\u308B","\u306E\u305B\u308B","\u306E\u305D\u3099\u304F","\u306E\u305D\u3099\u3080","\u306E\u305F\u307E\u3046","\u306E\u3061\u307B\u3068\u3099","\u306E\u3063\u304F","\u306E\u306F\u3099\u3059","\u306E\u306F\u3089","\u306E\u3078\u3099\u308B","\u306E\u307B\u3099\u308B","\u306E\u307F\u3082\u306E","\u306E\u3084\u307E","\u306E\u3089\u3044\u306C","\u306E\u3089\u306D\u3053","\u306E\u308A\u3082\u306E","\u306E\u308A\u3086\u304D","\u306E\u308C\u3093","\u306E\u3093\u304D","\u306F\u3099\u3042\u3044","\u306F\u3042\u304F","\u306F\u3099\u3042\u3055\u3093","\u306F\u3099\u3044\u304B","\u306F\u3099\u3044\u304F","\u306F\u3044\u3051\u3093","\u306F\u3044\u3053\u3099","\u306F\u3044\u3057\u3093","\u306F\u3044\u3059\u3044","\u306F\u3044\u305B\u3093","\u306F\u3044\u305D\u3046","\u306F\u3044\u3061","\u306F\u3099\u3044\u306F\u3099\u3044","\u306F\u3044\u308C\u3064","\u306F\u3048\u308B","\u306F\u304A\u308B","\u306F\u304B\u3044","\u306F\u3099\u304B\u308A","\u306F\u304B\u308B","\u306F\u304F\u3057\u3085","\u306F\u3051\u3093","\u306F\u3053\u3075\u3099","\u306F\u3055\u307F","\u306F\u3055\u3093","\u306F\u3057\u3053\u3099","\u306F\u3099\u3057\u3087","\u306F\u3057\u308B","\u306F\u305B\u308B","\u306F\u309A\u305D\u3053\u3093","\u306F\u305D\u3093","\u306F\u305F\u3093","\u306F\u3061\u307F\u3064","\u306F\u3064\u304A\u3093","\u306F\u3063\u304B\u304F","\u306F\u3064\u3099\u304D","\u306F\u3063\u304D\u308A","\u306F\u3063\u304F\u3064","\u306F\u3063\u3051\u3093","\u306F\u3063\u3053\u3046","\u306F\u3063\u3055\u3093","\u306F\u3063\u3057\u3093","\u306F\u3063\u305F\u3064","\u306F\u3063\u3061\u3085\u3046","\u306F\u3063\u3066\u3093","\u306F\u3063\u3072\u309A\u3087\u3046","\u306F\u3063\u307B\u309A\u3046","\u306F\u306A\u3059","\u306F\u306A\u3072\u3099","\u306F\u306B\u304B\u3080","\u306F\u3075\u3099\u3089\u3057","\u306F\u307F\u304B\u3099\u304D","\u306F\u3080\u304B\u3046","\u306F\u3081\u3064","\u306F\u3084\u3044","\u306F\u3084\u3057","\u306F\u3089\u3046","\u306F\u308D\u3046\u3043\u3093","\u306F\u308F\u3044","\u306F\u3093\u3044","\u306F\u3093\u3048\u3044","\u306F\u3093\u304A\u3093","\u306F\u3093\u304B\u304F","\u306F\u3093\u304D\u3087\u3046","\u306F\u3099\u3093\u304F\u3099\u307F","\u306F\u3093\u3053","\u306F\u3093\u3057\u3083","\u306F\u3093\u3059\u3046","\u306F\u3093\u305F\u3099\u3093","\u306F\u309A\u3093\u3061","\u306F\u309A\u3093\u3064","\u306F\u3093\u3066\u3044","\u306F\u3093\u3068\u3057","\u306F\u3093\u306E\u3046","\u306F\u3093\u306F\u309A","\u306F\u3093\u3075\u3099\u3093","\u306F\u3093\u3078\u309A\u3093","\u306F\u3093\u307B\u3099\u3046\u304D","\u306F\u3093\u3081\u3044","\u306F\u3093\u3089\u3093","\u306F\u3093\u308D\u3093","\u3072\u3044\u304D","\u3072\u3046\u3093","\u3072\u3048\u308B","\u3072\u304B\u304F","\u3072\u304B\u308A","\u3072\u304B\u308B","\u3072\u304B\u3093","\u3072\u304F\u3044","\u3072\u3051\u3064","\u3072\u3053\u3046\u304D","\u3072\u3053\u304F","\u3072\u3055\u3044","\u3072\u3055\u3057\u3075\u3099\u308A","\u3072\u3055\u3093","\u3072\u3099\u3057\u3099\u3085\u3064\u304B\u3093","\u3072\u3057\u3087","\u3072\u305D\u304B","\u3072\u305D\u3080","\u3072\u305F\u3080\u304D","\u3072\u305F\u3099\u308A","\u3072\u305F\u308B","\u3072\u3064\u304D\u3099","\u3072\u3063\u3053\u3057","\u3072\u3063\u3057","\u3072\u3064\u3057\u3099\u3085\u3072\u3093","\u3072\u3063\u3059","\u3072\u3064\u305B\u3099\u3093","\u3072\u309A\u3063\u305F\u308A","\u3072\u309A\u3063\u3061\u308A","\u3072\u3064\u3088\u3046","\u3072\u3066\u3044","\u3072\u3068\u3053\u3099\u307F","\u3072\u306A\u307E\u3064\u308A","\u3072\u306A\u3093","\u3072\u306D\u308B","\u3072\u306F\u3093","\u3072\u3072\u3099\u304F","\u3072\u3072\u3087\u3046","\u3072\u307B\u3046","\u3072\u307E\u308F\u308A","\u3072\u307E\u3093","\u3072\u307F\u3064","\u3072\u3081\u3044","\u3072\u3081\u3057\u3099\u3057","\u3072\u3084\u3051","\u3072\u3084\u3059","\u3072\u3088\u3046","\u3072\u3099\u3087\u3046\u304D","\u3072\u3089\u304B\u3099\u306A","\u3072\u3089\u304F","\u3072\u308A\u3064","\u3072\u308A\u3087\u3046","\u3072\u308B\u307E","\u3072\u308B\u3084\u3059\u307F","\u3072\u308C\u3044","\u3072\u308D\u3044","\u3072\u308D\u3046","\u3072\u308D\u304D","\u3072\u308D\u3086\u304D","\u3072\u3093\u304B\u304F","\u3072\u3093\u3051\u3064","\u3072\u3093\u3053\u3093","\u3072\u3093\u3057\u3085","\u3072\u3093\u305D\u3046","\u3072\u309A\u3093\u3061","\u3072\u3093\u306F\u309A\u3093","\u3072\u3099\u3093\u307B\u3099\u3046","\u3075\u3042\u3093","\u3075\u3044\u3046\u3061","\u3075\u3046\u3051\u3044","\u3075\u3046\u305B\u3093","\u3075\u309A\u3046\u305F\u308D\u3046","\u3075\u3046\u3068\u3046","\u3075\u3046\u3075","\u3075\u3048\u308B","\u3075\u304A\u3093","\u3075\u304B\u3044","\u3075\u304D\u3093","\u3075\u304F\u3055\u3099\u3064","\u3075\u304F\u3075\u3099\u304F\u308D","\u3075\u3053\u3046","\u3075\u3055\u3044","\u3075\u3057\u304D\u3099","\u3075\u3057\u3099\u307F","\u3075\u3059\u307E","\u3075\u305B\u3044","\u3075\u305B\u304F\u3099","\u3075\u305D\u304F","\u3075\u3099\u305F\u306B\u304F","\u3075\u305F\u3093","\u3075\u3061\u3087\u3046","\u3075\u3064\u3046","\u3075\u3064\u304B","\u3075\u3063\u304B\u3064","\u3075\u3063\u304D","\u3075\u3063\u3053\u304F","\u3075\u3099\u3068\u3099\u3046","\u3075\u3068\u308B","\u3075\u3068\u3093","\u3075\u306E\u3046","\u3075\u306F\u3044","\u3075\u3072\u3087\u3046","\u3075\u3078\u3093","\u3075\u307E\u3093","\u3075\u307F\u3093","\u3075\u3081\u3064","\u3075\u3081\u3093","\u3075\u3088\u3046","\u3075\u308A\u3053","\u3075\u308A\u308B","\u3075\u308B\u3044","\u3075\u3093\u3044\u304D","\u3075\u3099\u3093\u304B\u3099\u304F","\u3075\u3099\u3093\u304F\u3099","\u3075\u3093\u3057\u3064","\u3075\u3099\u3093\u305B\u304D","\u3075\u3093\u305D\u3046","\u3075\u3099\u3093\u307B\u309A\u3046","\u3078\u3044\u3042\u3093","\u3078\u3044\u304A\u3093","\u3078\u3044\u304B\u3099\u3044","\u3078\u3044\u304D","\u3078\u3044\u3051\u3099\u3093","\u3078\u3044\u3053\u3046","\u3078\u3044\u3055","\u3078\u3044\u3057\u3083","\u3078\u3044\u305B\u3064","\u3078\u3044\u305D","\u3078\u3044\u305F\u304F","\u3078\u3044\u3066\u3093","\u3078\u3044\u306D\u3064","\u3078\u3044\u308F","\u3078\u304D\u304B\u3099","\u3078\u3053\u3080","\u3078\u3099\u306B\u3044\u308D","\u3078\u3099\u306B\u3057\u3087\u3046\u304B\u3099","\u3078\u3089\u3059","\u3078\u3093\u304B\u3093","\u3078\u3099\u3093\u304D\u3087\u3046","\u3078\u3099\u3093\u3053\u3099\u3057","\u3078\u3093\u3055\u3044","\u3078\u3093\u305F\u3044","\u3078\u3099\u3093\u308A","\u307B\u3042\u3093","\u307B\u3044\u304F","\u307B\u3099\u3046\u304D\u3099\u3087","\u307B\u3046\u3053\u304F","\u307B\u3046\u305D\u3046","\u307B\u3046\u307B\u3046","\u307B\u3046\u3082\u3093","\u307B\u3046\u308A\u3064","\u307B\u3048\u308B","\u307B\u304A\u3093","\u307B\u304B\u3093","\u307B\u304D\u3087\u3046","\u307B\u3099\u304D\u3093","\u307B\u304F\u308D","\u307B\u3051\u3064","\u307B\u3051\u3093","\u307B\u3053\u3046","\u307B\u3053\u308B","\u307B\u3057\u3044","\u307B\u3057\u3064","\u307B\u3057\u3085","\u307B\u3057\u3087\u3046","\u307B\u305B\u3044","\u307B\u305D\u3044","\u307B\u305D\u304F","\u307B\u305F\u3066","\u307B\u305F\u308B","\u307B\u309A\u3061\u3075\u3099\u304F\u308D","\u307B\u3063\u304D\u3087\u304F","\u307B\u3063\u3055","\u307B\u3063\u305F\u3093","\u307B\u3068\u3093\u3068\u3099","\u307B\u3081\u308B","\u307B\u3093\u3044","\u307B\u3093\u304D","\u307B\u3093\u3051","\u307B\u3093\u3057\u3064","\u307B\u3093\u3084\u304F","\u307E\u3044\u306B\u3061","\u307E\u304B\u3044","\u307E\u304B\u305B\u308B","\u307E\u304B\u3099\u308B","\u307E\u3051\u308B","\u307E\u3053\u3068","\u307E\u3055\u3064","\u307E\u3057\u3099\u3081","\u307E\u3059\u304F","\u307E\u305B\u3099\u308B","\u307E\u3064\u308A","\u307E\u3068\u3081","\u307E\u306A\u3075\u3099","\u307E\u306C\u3051","\u307E\u306D\u304F","\u307E\u307B\u3046","\u307E\u3082\u308B","\u307E\u3086\u3051\u3099","\u307E\u3088\u3046","\u307E\u308D\u3084\u304B","\u307E\u308F\u3059","\u307E\u308F\u308A","\u307E\u308F\u308B","\u307E\u3093\u304B\u3099","\u307E\u3093\u304D\u3064","\u307E\u3093\u305D\u3099\u304F","\u307E\u3093\u306A\u304B","\u307F\u3044\u3089","\u307F\u3046\u3061","\u307F\u3048\u308B","\u307F\u304B\u3099\u304F","\u307F\u304B\u305F","\u307F\u304B\u3093","\u307F\u3051\u3093","\u307F\u3053\u3093","\u307F\u3057\u3099\u304B\u3044","\u307F\u3059\u3044","\u307F\u3059\u3048\u308B","\u307F\u305B\u308B","\u307F\u3063\u304B","\u307F\u3064\u304B\u308B","\u307F\u3064\u3051\u308B","\u307F\u3066\u3044","\u307F\u3068\u3081\u308B","\u307F\u306A\u3068","\u307F\u306A\u307F\u304B\u3055\u3044","\u307F\u306D\u3089\u308B","\u307F\u306E\u3046","\u307F\u306E\u304B\u3099\u3059","\u307F\u307B\u3093","\u307F\u3082\u3068","\u307F\u3084\u3051\u3099","\u307F\u3089\u3044","\u307F\u308A\u3087\u304F","\u307F\u308F\u304F","\u307F\u3093\u304B","\u307F\u3093\u305D\u3099\u304F","\u3080\u3044\u304B","\u3080\u3048\u304D","\u3080\u3048\u3093","\u3080\u304B\u3044","\u3080\u304B\u3046","\u3080\u304B\u3048","\u3080\u304B\u3057","\u3080\u304D\u3099\u3061\u3083","\u3080\u3051\u308B","\u3080\u3051\u3099\u3093","\u3080\u3055\u307B\u3099\u308B","\u3080\u3057\u3042\u3064\u3044","\u3080\u3057\u306F\u3099","\u3080\u3057\u3099\u3085\u3093","\u3080\u3057\u308D","\u3080\u3059\u3046","\u3080\u3059\u3053","\u3080\u3059\u3075\u3099","\u3080\u3059\u3081","\u3080\u305B\u308B","\u3080\u305B\u3093","\u3080\u3061\u3085\u3046","\u3080\u306A\u3057\u3044","\u3080\u306E\u3046","\u3080\u3084\u307F","\u3080\u3088\u3046","\u3080\u3089\u3055\u304D","\u3080\u308A\u3087\u3046","\u3080\u308D\u3093","\u3081\u3044\u3042\u3093","\u3081\u3044\u3046\u3093","\u3081\u3044\u3048\u3093","\u3081\u3044\u304B\u304F","\u3081\u3044\u304D\u3087\u304F","\u3081\u3044\u3055\u3044","\u3081\u3044\u3057","\u3081\u3044\u305D\u3046","\u3081\u3044\u3075\u3099\u3064","\u3081\u3044\u308C\u3044","\u3081\u3044\u308F\u304F","\u3081\u304F\u3099\u307E\u308C\u308B","\u3081\u3055\u3099\u3059","\u3081\u3057\u305F","\u3081\u3059\u3099\u3089\u3057\u3044","\u3081\u305F\u3099\u3064","\u3081\u307E\u3044","\u3081\u3084\u3059","\u3081\u3093\u304D\u3087","\u3081\u3093\u305B\u304D","\u3081\u3093\u3068\u3099\u3046","\u3082\u3046\u3057\u3042\u3051\u3099\u308B","\u3082\u3046\u3068\u3099\u3046\u3051\u3093","\u3082\u3048\u308B","\u3082\u304F\u3057","\u3082\u304F\u3066\u304D","\u3082\u304F\u3088\u3046\u3072\u3099","\u3082\u3061\u308D\u3093","\u3082\u3068\u3099\u308B","\u3082\u3089\u3046","\u3082\u3093\u304F","\u3082\u3093\u305F\u3099\u3044","\u3084\u304A\u3084","\u3084\u3051\u308B","\u3084\u3055\u3044","\u3084\u3055\u3057\u3044","\u3084\u3059\u3044","\u3084\u3059\u305F\u308D\u3046","\u3084\u3059\u307F","\u3084\u305B\u308B","\u3084\u305D\u3046","\u3084\u305F\u3044","\u3084\u3061\u3093","\u3084\u3063\u3068","\u3084\u3063\u306F\u309A\u308A","\u3084\u3075\u3099\u308B","\u3084\u3081\u308B","\u3084\u3084\u3053\u3057\u3044","\u3084\u3088\u3044","\u3084\u308F\u3089\u304B\u3044","\u3086\u3046\u304D","\u3086\u3046\u3072\u3099\u3093\u304D\u3087\u304F","\u3086\u3046\u3078\u3099","\u3086\u3046\u3081\u3044","\u3086\u3051\u3064","\u3086\u3057\u3085\u3064","\u3086\u305B\u3093","\u3086\u305D\u3046","\u3086\u305F\u304B","\u3086\u3061\u3083\u304F","\u3086\u3066\u3099\u308B","\u3086\u306B\u3085\u3046","\u3086\u3072\u3099\u308F","\u3086\u3089\u3044","\u3086\u308C\u308B","\u3088\u3046\u3044","\u3088\u3046\u304B","\u3088\u3046\u304D\u3085\u3046","\u3088\u3046\u3057\u3099","\u3088\u3046\u3059","\u3088\u3046\u3061\u3048\u3093","\u3088\u304B\u305B\u3099","\u3088\u304B\u3093","\u3088\u304D\u3093","\u3088\u304F\u305B\u3044","\u3088\u304F\u307B\u3099\u3046","\u3088\u3051\u3044","\u3088\u3053\u3099\u308C\u308B","\u3088\u3055\u3093","\u3088\u3057\u3085\u3046","\u3088\u305D\u3046","\u3088\u305D\u304F","\u3088\u3063\u304B","\u3088\u3066\u3044","\u3088\u3068\u3099\u304B\u3099\u308F\u304F","\u3088\u306D\u3064","\u3088\u3084\u304F","\u3088\u3086\u3046","\u3088\u308D\u3053\u3075\u3099","\u3088\u308D\u3057\u3044","\u3089\u3044\u3046","\u3089\u304F\u304B\u3099\u304D","\u3089\u304F\u3053\u3099","\u3089\u304F\u3055\u3064","\u3089\u304F\u305F\u3099","\u3089\u3057\u3093\u306F\u3099\u3093","\u3089\u305B\u3093","\u3089\u305D\u3099\u304F","\u3089\u305F\u3044","\u3089\u3063\u304B","\u3089\u308C\u3064","\u308A\u3048\u304D","\u308A\u304B\u3044","\u308A\u304D\u3055\u304F","\u308A\u304D\u305B\u3064","\u308A\u304F\u304F\u3099\u3093","\u308A\u304F\u3064","\u308A\u3051\u3093","\u308A\u3053\u3046","\u308A\u305B\u3044","\u308A\u305D\u3046","\u308A\u305D\u304F","\u308A\u3066\u3093","\u308A\u306D\u3093","\u308A\u3086\u3046","\u308A\u3085\u3046\u304B\u3099\u304F","\u308A\u3088\u3046","\u308A\u3087\u3046\u308A","\u308A\u3087\u304B\u3093","\u308A\u3087\u304F\u3061\u3083","\u308A\u3087\u3053\u3046","\u308A\u308A\u304F","\u308A\u308C\u304D","\u308A\u308D\u3093","\u308A\u3093\u3053\u3099","\u308B\u3044\u3051\u3044","\u308B\u3044\u3055\u3044","\u308B\u3044\u3057\u3099","\u308B\u3044\u305B\u304D","\u308B\u3059\u306F\u3099\u3093","\u308B\u308A\u304B\u3099\u308F\u3089","\u308C\u3044\u304B\u3093","\u308C\u3044\u304D\u3099","\u308C\u3044\u305B\u3044","\u308C\u3044\u305D\u3099\u3046\u3053","\u308C\u3044\u3068\u3046","\u308C\u3044\u307B\u3099\u3046","\u308C\u304D\u3057","\u308C\u304D\u305F\u3099\u3044","\u308C\u3093\u3042\u3044","\u308C\u3093\u3051\u3044","\u308C\u3093\u3053\u3093","\u308C\u3093\u3055\u3044","\u308C\u3093\u3057\u3085\u3046","\u308C\u3093\u305D\u3099\u304F","\u308C\u3093\u3089\u304F","\u308D\u3046\u304B","\u308D\u3046\u3053\u3099","\u308D\u3046\u3057\u3099\u3093","\u308D\u3046\u305D\u304F","\u308D\u304F\u304B\u3099","\u308D\u3053\u3064","\u308D\u3057\u3099\u3046\u3089","\u308D\u3057\u3085\u3064","\u308D\u305B\u3093","\u308D\u3066\u3093","\u308D\u3081\u3093","\u308D\u308C\u3064","\u308D\u3093\u304D\u3099","\u308D\u3093\u306F\u309A","\u308D\u3093\u3075\u3099\u3093","\u308D\u3093\u308A","\u308F\u304B\u3059","\u308F\u304B\u3081","\u308F\u304B\u3084\u307E","\u308F\u304B\u308C\u308B","\u308F\u3057\u3064","\u308F\u3057\u3099\u307E\u3057","\u308F\u3059\u308C\u3082\u306E","\u308F\u3089\u3046","\u308F\u308C\u308B"]');

});

parcelRegister("97tng", function(module, exports) {
module.exports = JSON.parse('["abacate","abaixo","abalar","abater","abduzir","abelha","aberto","abismo","abotoar","abranger","abreviar","abrigar","abrupto","absinto","absoluto","absurdo","abutre","acabado","acalmar","acampar","acanhar","acaso","aceitar","acelerar","acenar","acervo","acessar","acetona","achatar","acidez","acima","acionado","acirrar","aclamar","aclive","acolhida","acomodar","acoplar","acordar","acumular","acusador","adaptar","adega","adentro","adepto","adequar","aderente","adesivo","adeus","adiante","aditivo","adjetivo","adjunto","admirar","adorar","adquirir","adubo","adverso","advogado","aeronave","afastar","aferir","afetivo","afinador","afivelar","aflito","afluente","afrontar","agachar","agarrar","agasalho","agenciar","agilizar","agiota","agitado","agora","agradar","agreste","agrupar","aguardar","agulha","ajoelhar","ajudar","ajustar","alameda","alarme","alastrar","alavanca","albergue","albino","alcatra","aldeia","alecrim","alegria","alertar","alface","alfinete","algum","alheio","aliar","alicate","alienar","alinhar","aliviar","almofada","alocar","alpiste","alterar","altitude","alucinar","alugar","aluno","alusivo","alvo","amaciar","amador","amarelo","amassar","ambas","ambiente","ameixa","amenizar","amido","amistoso","amizade","amolador","amontoar","amoroso","amostra","amparar","ampliar","ampola","anagrama","analisar","anarquia","anatomia","andaime","anel","anexo","angular","animar","anjo","anomalia","anotado","ansioso","anterior","anuidade","anunciar","anzol","apagador","apalpar","apanhado","apego","apelido","apertada","apesar","apetite","apito","aplauso","aplicada","apoio","apontar","aposta","aprendiz","aprovar","aquecer","arame","aranha","arara","arcada","ardente","areia","arejar","arenito","aresta","argiloso","argola","arma","arquivo","arraial","arrebate","arriscar","arroba","arrumar","arsenal","arterial","artigo","arvoredo","asfaltar","asilado","aspirar","assador","assinar","assoalho","assunto","astral","atacado","atadura","atalho","atarefar","atear","atender","aterro","ateu","atingir","atirador","ativo","atoleiro","atracar","atrevido","atriz","atual","atum","auditor","aumentar","aura","aurora","autismo","autoria","autuar","avaliar","avante","avaria","avental","avesso","aviador","avisar","avulso","axila","azarar","azedo","azeite","azulejo","babar","babosa","bacalhau","bacharel","bacia","bagagem","baiano","bailar","baioneta","bairro","baixista","bajular","baleia","baliza","balsa","banal","bandeira","banho","banir","banquete","barato","barbado","baronesa","barraca","barulho","baseado","bastante","batata","batedor","batida","batom","batucar","baunilha","beber","beijo","beirada","beisebol","beldade","beleza","belga","beliscar","bendito","bengala","benzer","berimbau","berlinda","berro","besouro","bexiga","bezerro","bico","bicudo","bienal","bifocal","bifurcar","bigorna","bilhete","bimestre","bimotor","biologia","biombo","biosfera","bipolar","birrento","biscoito","bisneto","bispo","bissexto","bitola","bizarro","blindado","bloco","bloquear","boato","bobagem","bocado","bocejo","bochecha","boicotar","bolada","boletim","bolha","bolo","bombeiro","bonde","boneco","bonita","borbulha","borda","boreal","borracha","bovino","boxeador","branco","brasa","braveza","breu","briga","brilho","brincar","broa","brochura","bronzear","broto","bruxo","bucha","budismo","bufar","bule","buraco","busca","busto","buzina","cabana","cabelo","cabide","cabo","cabrito","cacau","cacetada","cachorro","cacique","cadastro","cadeado","cafezal","caiaque","caipira","caixote","cajado","caju","calafrio","calcular","caldeira","calibrar","calmante","calota","camada","cambista","camisa","camomila","campanha","camuflar","canavial","cancelar","caneta","canguru","canhoto","canivete","canoa","cansado","cantar","canudo","capacho","capela","capinar","capotar","capricho","captador","capuz","caracol","carbono","cardeal","careca","carimbar","carneiro","carpete","carreira","cartaz","carvalho","casaco","casca","casebre","castelo","casulo","catarata","cativar","caule","causador","cautelar","cavalo","caverna","cebola","cedilha","cegonha","celebrar","celular","cenoura","censo","centeio","cercar","cerrado","certeiro","cerveja","cetim","cevada","chacota","chaleira","chamado","chapada","charme","chatice","chave","chefe","chegada","cheiro","cheque","chicote","chifre","chinelo","chocalho","chover","chumbo","chutar","chuva","cicatriz","ciclone","cidade","cidreira","ciente","cigana","cimento","cinto","cinza","ciranda","circuito","cirurgia","citar","clareza","clero","clicar","clone","clube","coado","coagir","cobaia","cobertor","cobrar","cocada","coelho","coentro","coeso","cogumelo","coibir","coifa","coiote","colar","coleira","colher","colidir","colmeia","colono","coluna","comando","combinar","comentar","comitiva","comover","complexo","comum","concha","condor","conectar","confuso","congelar","conhecer","conjugar","consumir","contrato","convite","cooperar","copeiro","copiador","copo","coquetel","coragem","cordial","corneta","coronha","corporal","correio","cortejo","coruja","corvo","cosseno","costela","cotonete","couro","couve","covil","cozinha","cratera","cravo","creche","credor","creme","crer","crespo","criada","criminal","crioulo","crise","criticar","crosta","crua","cruzeiro","cubano","cueca","cuidado","cujo","culatra","culminar","culpar","cultura","cumprir","cunhado","cupido","curativo","curral","cursar","curto","cuspir","custear","cutelo","damasco","datar","debater","debitar","deboche","debulhar","decalque","decimal","declive","decote","decretar","dedal","dedicado","deduzir","defesa","defumar","degelo","degrau","degustar","deitado","deixar","delator","delegado","delinear","delonga","demanda","demitir","demolido","dentista","depenado","depilar","depois","depressa","depurar","deriva","derramar","desafio","desbotar","descanso","desenho","desfiado","desgaste","desigual","deslize","desmamar","desova","despesa","destaque","desviar","detalhar","detentor","detonar","detrito","deusa","dever","devido","devotado","dezena","diagrama","dialeto","didata","difuso","digitar","dilatado","diluente","diminuir","dinastia","dinheiro","diocese","direto","discreta","disfarce","disparo","disquete","dissipar","distante","ditador","diurno","diverso","divisor","divulgar","dizer","dobrador","dolorido","domador","dominado","donativo","donzela","dormente","dorsal","dosagem","dourado","doutor","drenagem","drible","drogaria","duelar","duende","dueto","duplo","duquesa","durante","duvidoso","eclodir","ecoar","ecologia","edificar","edital","educado","efeito","efetivar","ejetar","elaborar","eleger","eleitor","elenco","elevador","eliminar","elogiar","embargo","embolado","embrulho","embutido","emenda","emergir","emissor","empatia","empenho","empinado","empolgar","emprego","empurrar","emulador","encaixe","encenado","enchente","encontro","endeusar","endossar","enfaixar","enfeite","enfim","engajado","engenho","englobar","engomado","engraxar","enguia","enjoar","enlatar","enquanto","enraizar","enrolado","enrugar","ensaio","enseada","ensino","ensopado","entanto","enteado","entidade","entortar","entrada","entulho","envergar","enviado","envolver","enxame","enxerto","enxofre","enxuto","epiderme","equipar","ereto","erguido","errata","erva","ervilha","esbanjar","esbelto","escama","escola","escrita","escuta","esfinge","esfolar","esfregar","esfumado","esgrima","esmalte","espanto","espelho","espiga","esponja","espreita","espumar","esquerda","estaca","esteira","esticar","estofado","estrela","estudo","esvaziar","etanol","etiqueta","euforia","europeu","evacuar","evaporar","evasivo","eventual","evidente","evoluir","exagero","exalar","examinar","exato","exausto","excesso","excitar","exclamar","executar","exemplo","exibir","exigente","exonerar","expandir","expelir","expirar","explanar","exposto","expresso","expulsar","externo","extinto","extrato","fabricar","fabuloso","faceta","facial","fada","fadiga","faixa","falar","falta","familiar","fandango","fanfarra","fantoche","fardado","farelo","farinha","farofa","farpa","fartura","fatia","fator","favorita","faxina","fazenda","fechado","feijoada","feirante","felino","feminino","fenda","feno","fera","feriado","ferrugem","ferver","festejar","fetal","feudal","fiapo","fibrose","ficar","ficheiro","figurado","fileira","filho","filme","filtrar","firmeza","fisgada","fissura","fita","fivela","fixador","fixo","flacidez","flamingo","flanela","flechada","flora","flutuar","fluxo","focal","focinho","fofocar","fogo","foguete","foice","folgado","folheto","forjar","formiga","forno","forte","fosco","fossa","fragata","fralda","frango","frasco","fraterno","freira","frente","fretar","frieza","friso","fritura","fronha","frustrar","fruteira","fugir","fulano","fuligem","fundar","fungo","funil","furador","furioso","futebol","gabarito","gabinete","gado","gaiato","gaiola","gaivota","galega","galho","galinha","galocha","ganhar","garagem","garfo","gargalo","garimpo","garoupa","garrafa","gasoduto","gasto","gata","gatilho","gaveta","gazela","gelado","geleia","gelo","gemada","gemer","gemido","generoso","gengiva","genial","genoma","genro","geologia","gerador","germinar","gesso","gestor","ginasta","gincana","gingado","girafa","girino","glacial","glicose","global","glorioso","goela","goiaba","golfe","golpear","gordura","gorjeta","gorro","gostoso","goteira","governar","gracejo","gradual","grafite","gralha","grampo","granada","gratuito","graveto","graxa","grego","grelhar","greve","grilo","grisalho","gritaria","grosso","grotesco","grudado","grunhido","gruta","guache","guarani","guaxinim","guerrear","guiar","guincho","guisado","gula","guloso","guru","habitar","harmonia","haste","haver","hectare","herdar","heresia","hesitar","hiato","hibernar","hidratar","hiena","hino","hipismo","hipnose","hipoteca","hoje","holofote","homem","honesto","honrado","hormonal","hospedar","humorado","iate","ideia","idoso","ignorado","igreja","iguana","ileso","ilha","iludido","iluminar","ilustrar","imagem","imediato","imenso","imersivo","iminente","imitador","imortal","impacto","impedir","implante","impor","imprensa","impune","imunizar","inalador","inapto","inativo","incenso","inchar","incidir","incluir","incolor","indeciso","indireto","indutor","ineficaz","inerente","infantil","infestar","infinito","inflamar","informal","infrator","ingerir","inibido","inicial","inimigo","injetar","inocente","inodoro","inovador","inox","inquieto","inscrito","inseto","insistir","inspetor","instalar","insulto","intacto","integral","intimar","intocado","intriga","invasor","inverno","invicto","invocar","iogurte","iraniano","ironizar","irreal","irritado","isca","isento","isolado","isqueiro","italiano","janeiro","jangada","janta","jararaca","jardim","jarro","jasmim","jato","javali","jazida","jejum","joaninha","joelhada","jogador","joia","jornal","jorrar","jovem","juba","judeu","judoca","juiz","julgador","julho","jurado","jurista","juro","justa","labareda","laboral","lacre","lactante","ladrilho","lagarta","lagoa","laje","lamber","lamentar","laminar","lampejo","lanche","lapidar","lapso","laranja","lareira","largura","lasanha","lastro","lateral","latido","lavanda","lavoura","lavrador","laxante","lazer","lealdade","lebre","legado","legendar","legista","leigo","leiloar","leitura","lembrete","leme","lenhador","lentilha","leoa","lesma","leste","letivo","letreiro","levar","leveza","levitar","liberal","libido","liderar","ligar","ligeiro","limitar","limoeiro","limpador","linda","linear","linhagem","liquidez","listagem","lisura","litoral","livro","lixa","lixeira","locador","locutor","lojista","lombo","lona","longe","lontra","lorde","lotado","loteria","loucura","lousa","louvar","luar","lucidez","lucro","luneta","lustre","lutador","luva","macaco","macete","machado","macio","madeira","madrinha","magnata","magreza","maior","mais","malandro","malha","malote","maluco","mamilo","mamoeiro","mamute","manada","mancha","mandato","manequim","manhoso","manivela","manobrar","mansa","manter","manusear","mapeado","maquinar","marcador","maresia","marfim","margem","marinho","marmita","maroto","marquise","marreco","martelo","marujo","mascote","masmorra","massagem","mastigar","matagal","materno","matinal","matutar","maxilar","medalha","medida","medusa","megafone","meiga","melancia","melhor","membro","memorial","menino","menos","mensagem","mental","merecer","mergulho","mesada","mesclar","mesmo","mesquita","mestre","metade","meteoro","metragem","mexer","mexicano","micro","migalha","migrar","milagre","milenar","milhar","mimado","minerar","minhoca","ministro","minoria","miolo","mirante","mirtilo","misturar","mocidade","moderno","modular","moeda","moer","moinho","moita","moldura","moleza","molho","molinete","molusco","montanha","moqueca","morango","morcego","mordomo","morena","mosaico","mosquete","mostarda","motel","motim","moto","motriz","muda","muito","mulata","mulher","multar","mundial","munido","muralha","murcho","muscular","museu","musical","nacional","nadador","naja","namoro","narina","narrado","nascer","nativa","natureza","navalha","navegar","navio","neblina","nebuloso","negativa","negociar","negrito","nervoso","neta","neural","nevasca","nevoeiro","ninar","ninho","nitidez","nivelar","nobreza","noite","noiva","nomear","nominal","nordeste","nortear","notar","noticiar","noturno","novelo","novilho","novo","nublado","nudez","numeral","nupcial","nutrir","nuvem","obcecado","obedecer","objetivo","obrigado","obscuro","obstetra","obter","obturar","ocidente","ocioso","ocorrer","oculista","ocupado","ofegante","ofensiva","oferenda","oficina","ofuscado","ogiva","olaria","oleoso","olhar","oliveira","ombro","omelete","omisso","omitir","ondulado","oneroso","ontem","opcional","operador","oponente","oportuno","oposto","orar","orbitar","ordem","ordinal","orfanato","orgasmo","orgulho","oriental","origem","oriundo","orla","ortodoxo","orvalho","oscilar","ossada","osso","ostentar","otimismo","ousadia","outono","outubro","ouvido","ovelha","ovular","oxidar","oxigenar","pacato","paciente","pacote","pactuar","padaria","padrinho","pagar","pagode","painel","pairar","paisagem","palavra","palestra","palheta","palito","palmada","palpitar","pancada","panela","panfleto","panqueca","pantanal","papagaio","papelada","papiro","parafina","parcial","pardal","parede","partida","pasmo","passado","pastel","patamar","patente","patinar","patrono","paulada","pausar","peculiar","pedalar","pedestre","pediatra","pedra","pegada","peitoral","peixe","pele","pelicano","penca","pendurar","peneira","penhasco","pensador","pente","perceber","perfeito","pergunta","perito","permitir","perna","perplexo","persiana","pertence","peruca","pescado","pesquisa","pessoa","petiscar","piada","picado","piedade","pigmento","pilastra","pilhado","pilotar","pimenta","pincel","pinguim","pinha","pinote","pintar","pioneiro","pipoca","piquete","piranha","pires","pirueta","piscar","pistola","pitanga","pivete","planta","plaqueta","platina","plebeu","plumagem","pluvial","pneu","poda","poeira","poetisa","polegada","policiar","poluente","polvilho","pomar","pomba","ponderar","pontaria","populoso","porta","possuir","postal","pote","poupar","pouso","povoar","praia","prancha","prato","praxe","prece","predador","prefeito","premiar","prensar","preparar","presilha","pretexto","prevenir","prezar","primata","princesa","prisma","privado","processo","produto","profeta","proibido","projeto","prometer","propagar","prosa","protetor","provador","publicar","pudim","pular","pulmonar","pulseira","punhal","punir","pupilo","pureza","puxador","quadra","quantia","quarto","quase","quebrar","queda","queijo","quente","querido","quimono","quina","quiosque","rabanada","rabisco","rachar","racionar","radial","raiar","rainha","raio","raiva","rajada","ralado","ramal","ranger","ranhura","rapadura","rapel","rapidez","raposa","raquete","raridade","rasante","rascunho","rasgar","raspador","rasteira","rasurar","ratazana","ratoeira","realeza","reanimar","reaver","rebaixar","rebelde","rebolar","recado","recente","recheio","recibo","recordar","recrutar","recuar","rede","redimir","redonda","reduzida","reenvio","refinar","refletir","refogar","refresco","refugiar","regalia","regime","regra","reinado","reitor","rejeitar","relativo","remador","remendo","remorso","renovado","reparo","repelir","repleto","repolho","represa","repudiar","requerer","resenha","resfriar","resgatar","residir","resolver","respeito","ressaca","restante","resumir","retalho","reter","retirar","retomada","retratar","revelar","revisor","revolta","riacho","rica","rigidez","rigoroso","rimar","ringue","risada","risco","risonho","robalo","rochedo","rodada","rodeio","rodovia","roedor","roleta","romano","roncar","rosado","roseira","rosto","rota","roteiro","rotina","rotular","rouco","roupa","roxo","rubro","rugido","rugoso","ruivo","rumo","rupestre","russo","sabor","saciar","sacola","sacudir","sadio","safira","saga","sagrada","saibro","salada","saleiro","salgado","saliva","salpicar","salsicha","saltar","salvador","sambar","samurai","sanar","sanfona","sangue","sanidade","sapato","sarda","sargento","sarjeta","saturar","saudade","saxofone","sazonal","secar","secular","seda","sedento","sediado","sedoso","sedutor","segmento","segredo","segundo","seiva","seleto","selvagem","semanal","semente","senador","senhor","sensual","sentado","separado","sereia","seringa","serra","servo","setembro","setor","sigilo","silhueta","silicone","simetria","simpatia","simular","sinal","sincero","singular","sinopse","sintonia","sirene","siri","situado","soberano","sobra","socorro","sogro","soja","solda","soletrar","solteiro","sombrio","sonata","sondar","sonegar","sonhador","sono","soprano","soquete","sorrir","sorteio","sossego","sotaque","soterrar","sovado","sozinho","suavizar","subida","submerso","subsolo","subtrair","sucata","sucesso","suco","sudeste","sufixo","sugador","sugerir","sujeito","sulfato","sumir","suor","superior","suplicar","suposto","suprimir","surdina","surfista","surpresa","surreal","surtir","suspiro","sustento","tabela","tablete","tabuada","tacho","tagarela","talher","talo","talvez","tamanho","tamborim","tampa","tangente","tanto","tapar","tapioca","tardio","tarefa","tarja","tarraxa","tatuagem","taurino","taxativo","taxista","teatral","tecer","tecido","teclado","tedioso","teia","teimar","telefone","telhado","tempero","tenente","tensor","tentar","termal","terno","terreno","tese","tesoura","testado","teto","textura","texugo","tiara","tigela","tijolo","timbrar","timidez","tingido","tinteiro","tiragem","titular","toalha","tocha","tolerar","tolice","tomada","tomilho","tonel","tontura","topete","tora","torcido","torneio","torque","torrada","torto","tostar","touca","toupeira","toxina","trabalho","tracejar","tradutor","trafegar","trajeto","trama","trancar","trapo","traseiro","tratador","travar","treino","tremer","trepidar","trevo","triagem","tribo","triciclo","tridente","trilogia","trindade","triplo","triturar","triunfal","trocar","trombeta","trova","trunfo","truque","tubular","tucano","tudo","tulipa","tupi","turbo","turma","turquesa","tutelar","tutorial","uivar","umbigo","unha","unidade","uniforme","urologia","urso","urtiga","urubu","usado","usina","usufruir","vacina","vadiar","vagaroso","vaidoso","vala","valente","validade","valores","vantagem","vaqueiro","varanda","vareta","varrer","vascular","vasilha","vassoura","vazar","vazio","veado","vedar","vegetar","veicular","veleiro","velhice","veludo","vencedor","vendaval","venerar","ventre","verbal","verdade","vereador","vergonha","vermelho","verniz","versar","vertente","vespa","vestido","vetorial","viaduto","viagem","viajar","viatura","vibrador","videira","vidraria","viela","viga","vigente","vigiar","vigorar","vilarejo","vinco","vinheta","vinil","violeta","virada","virtude","visitar","visto","vitral","viveiro","vizinho","voador","voar","vogal","volante","voleibol","voltagem","volumoso","vontade","vulto","vuvuzela","xadrez","xarope","xeque","xeretar","xerife","xingar","zangado","zarpar","zebu","zelador","zombar","zoologia","zumbido"]');

});

parcelRegister("iFGk9", function(module, exports) {
module.exports = JSON.parse('["abandon","ability","able","about","above","absent","absorb","abstract","absurd","abuse","access","accident","account","accuse","achieve","acid","acoustic","acquire","across","act","action","actor","actress","actual","adapt","add","addict","address","adjust","admit","adult","advance","advice","aerobic","affair","afford","afraid","again","age","agent","agree","ahead","aim","air","airport","aisle","alarm","album","alcohol","alert","alien","all","alley","allow","almost","alone","alpha","already","also","alter","always","amateur","amazing","among","amount","amused","analyst","anchor","ancient","anger","angle","angry","animal","ankle","announce","annual","another","answer","antenna","antique","anxiety","any","apart","apology","appear","apple","approve","april","arch","arctic","area","arena","argue","arm","armed","armor","army","around","arrange","arrest","arrive","arrow","art","artefact","artist","artwork","ask","aspect","assault","asset","assist","assume","asthma","athlete","atom","attack","attend","attitude","attract","auction","audit","august","aunt","author","auto","autumn","average","avocado","avoid","awake","aware","away","awesome","awful","awkward","axis","baby","bachelor","bacon","badge","bag","balance","balcony","ball","bamboo","banana","banner","bar","barely","bargain","barrel","base","basic","basket","battle","beach","bean","beauty","because","become","beef","before","begin","behave","behind","believe","below","belt","bench","benefit","best","betray","better","between","beyond","bicycle","bid","bike","bind","biology","bird","birth","bitter","black","blade","blame","blanket","blast","bleak","bless","blind","blood","blossom","blouse","blue","blur","blush","board","boat","body","boil","bomb","bone","bonus","book","boost","border","boring","borrow","boss","bottom","bounce","box","boy","bracket","brain","brand","brass","brave","bread","breeze","brick","bridge","brief","bright","bring","brisk","broccoli","broken","bronze","broom","brother","brown","brush","bubble","buddy","budget","buffalo","build","bulb","bulk","bullet","bundle","bunker","burden","burger","burst","bus","business","busy","butter","buyer","buzz","cabbage","cabin","cable","cactus","cage","cake","call","calm","camera","camp","can","canal","cancel","candy","cannon","canoe","canvas","canyon","capable","capital","captain","car","carbon","card","cargo","carpet","carry","cart","case","cash","casino","castle","casual","cat","catalog","catch","category","cattle","caught","cause","caution","cave","ceiling","celery","cement","census","century","cereal","certain","chair","chalk","champion","change","chaos","chapter","charge","chase","chat","cheap","check","cheese","chef","cherry","chest","chicken","chief","child","chimney","choice","choose","chronic","chuckle","chunk","churn","cigar","cinnamon","circle","citizen","city","civil","claim","clap","clarify","claw","clay","clean","clerk","clever","click","client","cliff","climb","clinic","clip","clock","clog","close","cloth","cloud","clown","club","clump","cluster","clutch","coach","coast","coconut","code","coffee","coil","coin","collect","color","column","combine","come","comfort","comic","common","company","concert","conduct","confirm","congress","connect","consider","control","convince","cook","cool","copper","copy","coral","core","corn","correct","cost","cotton","couch","country","couple","course","cousin","cover","coyote","crack","cradle","craft","cram","crane","crash","crater","crawl","crazy","cream","credit","creek","crew","cricket","crime","crisp","critic","crop","cross","crouch","crowd","crucial","cruel","cruise","crumble","crunch","crush","cry","crystal","cube","culture","cup","cupboard","curious","current","curtain","curve","cushion","custom","cute","cycle","dad","damage","damp","dance","danger","daring","dash","daughter","dawn","day","deal","debate","debris","decade","december","decide","decline","decorate","decrease","deer","defense","define","defy","degree","delay","deliver","demand","demise","denial","dentist","deny","depart","depend","deposit","depth","deputy","derive","describe","desert","design","desk","despair","destroy","detail","detect","develop","device","devote","diagram","dial","diamond","diary","dice","diesel","diet","differ","digital","dignity","dilemma","dinner","dinosaur","direct","dirt","disagree","discover","disease","dish","dismiss","disorder","display","distance","divert","divide","divorce","dizzy","doctor","document","dog","doll","dolphin","domain","donate","donkey","donor","door","dose","double","dove","draft","dragon","drama","drastic","draw","dream","dress","drift","drill","drink","drip","drive","drop","drum","dry","duck","dumb","dune","during","dust","dutch","duty","dwarf","dynamic","eager","eagle","early","earn","earth","easily","east","easy","echo","ecology","economy","edge","edit","educate","effort","egg","eight","either","elbow","elder","electric","elegant","element","elephant","elevator","elite","else","embark","embody","embrace","emerge","emotion","employ","empower","empty","enable","enact","end","endless","endorse","enemy","energy","enforce","engage","engine","enhance","enjoy","enlist","enough","enrich","enroll","ensure","enter","entire","entry","envelope","episode","equal","equip","era","erase","erode","erosion","error","erupt","escape","essay","essence","estate","eternal","ethics","evidence","evil","evoke","evolve","exact","example","excess","exchange","excite","exclude","excuse","execute","exercise","exhaust","exhibit","exile","exist","exit","exotic","expand","expect","expire","explain","expose","express","extend","extra","eye","eyebrow","fabric","face","faculty","fade","faint","faith","fall","false","fame","family","famous","fan","fancy","fantasy","farm","fashion","fat","fatal","father","fatigue","fault","favorite","feature","february","federal","fee","feed","feel","female","fence","festival","fetch","fever","few","fiber","fiction","field","figure","file","film","filter","final","find","fine","finger","finish","fire","firm","first","fiscal","fish","fit","fitness","fix","flag","flame","flash","flat","flavor","flee","flight","flip","float","flock","floor","flower","fluid","flush","fly","foam","focus","fog","foil","fold","follow","food","foot","force","forest","forget","fork","fortune","forum","forward","fossil","foster","found","fox","fragile","frame","frequent","fresh","friend","fringe","frog","front","frost","frown","frozen","fruit","fuel","fun","funny","furnace","fury","future","gadget","gain","galaxy","gallery","game","gap","garage","garbage","garden","garlic","garment","gas","gasp","gate","gather","gauge","gaze","general","genius","genre","gentle","genuine","gesture","ghost","giant","gift","giggle","ginger","giraffe","girl","give","glad","glance","glare","glass","glide","glimpse","globe","gloom","glory","glove","glow","glue","goat","goddess","gold","good","goose","gorilla","gospel","gossip","govern","gown","grab","grace","grain","grant","grape","grass","gravity","great","green","grid","grief","grit","grocery","group","grow","grunt","guard","guess","guide","guilt","guitar","gun","gym","habit","hair","half","hammer","hamster","hand","happy","harbor","hard","harsh","harvest","hat","have","hawk","hazard","head","health","heart","heavy","hedgehog","height","hello","helmet","help","hen","hero","hidden","high","hill","hint","hip","hire","history","hobby","hockey","hold","hole","holiday","hollow","home","honey","hood","hope","horn","horror","horse","hospital","host","hotel","hour","hover","hub","huge","human","humble","humor","hundred","hungry","hunt","hurdle","hurry","hurt","husband","hybrid","ice","icon","idea","identify","idle","ignore","ill","illegal","illness","image","imitate","immense","immune","impact","impose","improve","impulse","inch","include","income","increase","index","indicate","indoor","industry","infant","inflict","inform","inhale","inherit","initial","inject","injury","inmate","inner","innocent","input","inquiry","insane","insect","inside","inspire","install","intact","interest","into","invest","invite","involve","iron","island","isolate","issue","item","ivory","jacket","jaguar","jar","jazz","jealous","jeans","jelly","jewel","job","join","joke","journey","joy","judge","juice","jump","jungle","junior","junk","just","kangaroo","keen","keep","ketchup","key","kick","kid","kidney","kind","kingdom","kiss","kit","kitchen","kite","kitten","kiwi","knee","knife","knock","know","lab","label","labor","ladder","lady","lake","lamp","language","laptop","large","later","latin","laugh","laundry","lava","law","lawn","lawsuit","layer","lazy","leader","leaf","learn","leave","lecture","left","leg","legal","legend","leisure","lemon","lend","length","lens","leopard","lesson","letter","level","liar","liberty","library","license","life","lift","light","like","limb","limit","link","lion","liquid","list","little","live","lizard","load","loan","lobster","local","lock","logic","lonely","long","loop","lottery","loud","lounge","love","loyal","lucky","luggage","lumber","lunar","lunch","luxury","lyrics","machine","mad","magic","magnet","maid","mail","main","major","make","mammal","man","manage","mandate","mango","mansion","manual","maple","marble","march","margin","marine","market","marriage","mask","mass","master","match","material","math","matrix","matter","maximum","maze","meadow","mean","measure","meat","mechanic","medal","media","melody","melt","member","memory","mention","menu","mercy","merge","merit","merry","mesh","message","metal","method","middle","midnight","milk","million","mimic","mind","minimum","minor","minute","miracle","mirror","misery","miss","mistake","mix","mixed","mixture","mobile","model","modify","mom","moment","monitor","monkey","monster","month","moon","moral","more","morning","mosquito","mother","motion","motor","mountain","mouse","move","movie","much","muffin","mule","multiply","muscle","museum","mushroom","music","must","mutual","myself","mystery","myth","naive","name","napkin","narrow","nasty","nation","nature","near","neck","need","negative","neglect","neither","nephew","nerve","nest","net","network","neutral","never","news","next","nice","night","noble","noise","nominee","noodle","normal","north","nose","notable","note","nothing","notice","novel","now","nuclear","number","nurse","nut","oak","obey","object","oblige","obscure","observe","obtain","obvious","occur","ocean","october","odor","off","offer","office","often","oil","okay","old","olive","olympic","omit","once","one","onion","online","only","open","opera","opinion","oppose","option","orange","orbit","orchard","order","ordinary","organ","orient","original","orphan","ostrich","other","outdoor","outer","output","outside","oval","oven","over","own","owner","oxygen","oyster","ozone","pact","paddle","page","pair","palace","palm","panda","panel","panic","panther","paper","parade","parent","park","parrot","party","pass","patch","path","patient","patrol","pattern","pause","pave","payment","peace","peanut","pear","peasant","pelican","pen","penalty","pencil","people","pepper","perfect","permit","person","pet","phone","photo","phrase","physical","piano","picnic","picture","piece","pig","pigeon","pill","pilot","pink","pioneer","pipe","pistol","pitch","pizza","place","planet","plastic","plate","play","please","pledge","pluck","plug","plunge","poem","poet","point","polar","pole","police","pond","pony","pool","popular","portion","position","possible","post","potato","pottery","poverty","powder","power","practice","praise","predict","prefer","prepare","present","pretty","prevent","price","pride","primary","print","priority","prison","private","prize","problem","process","produce","profit","program","project","promote","proof","property","prosper","protect","proud","provide","public","pudding","pull","pulp","pulse","pumpkin","punch","pupil","puppy","purchase","purity","purpose","purse","push","put","puzzle","pyramid","quality","quantum","quarter","question","quick","quit","quiz","quote","rabbit","raccoon","race","rack","radar","radio","rail","rain","raise","rally","ramp","ranch","random","range","rapid","rare","rate","rather","raven","raw","razor","ready","real","reason","rebel","rebuild","recall","receive","recipe","record","recycle","reduce","reflect","reform","refuse","region","regret","regular","reject","relax","release","relief","rely","remain","remember","remind","remove","render","renew","rent","reopen","repair","repeat","replace","report","require","rescue","resemble","resist","resource","response","result","retire","retreat","return","reunion","reveal","review","reward","rhythm","rib","ribbon","rice","rich","ride","ridge","rifle","right","rigid","ring","riot","ripple","risk","ritual","rival","river","road","roast","robot","robust","rocket","romance","roof","rookie","room","rose","rotate","rough","round","route","royal","rubber","rude","rug","rule","run","runway","rural","sad","saddle","sadness","safe","sail","salad","salmon","salon","salt","salute","same","sample","sand","satisfy","satoshi","sauce","sausage","save","say","scale","scan","scare","scatter","scene","scheme","school","science","scissors","scorpion","scout","scrap","screen","script","scrub","sea","search","season","seat","second","secret","section","security","seed","seek","segment","select","sell","seminar","senior","sense","sentence","series","service","session","settle","setup","seven","shadow","shaft","shallow","share","shed","shell","sheriff","shield","shift","shine","ship","shiver","shock","shoe","shoot","shop","short","shoulder","shove","shrimp","shrug","shuffle","shy","sibling","sick","side","siege","sight","sign","silent","silk","silly","silver","similar","simple","since","sing","siren","sister","situate","six","size","skate","sketch","ski","skill","skin","skirt","skull","slab","slam","sleep","slender","slice","slide","slight","slim","slogan","slot","slow","slush","small","smart","smile","smoke","smooth","snack","snake","snap","sniff","snow","soap","soccer","social","sock","soda","soft","solar","soldier","solid","solution","solve","someone","song","soon","sorry","sort","soul","sound","soup","source","south","space","spare","spatial","spawn","speak","special","speed","spell","spend","sphere","spice","spider","spike","spin","spirit","split","spoil","sponsor","spoon","sport","spot","spray","spread","spring","spy","square","squeeze","squirrel","stable","stadium","staff","stage","stairs","stamp","stand","start","state","stay","steak","steel","stem","step","stereo","stick","still","sting","stock","stomach","stone","stool","story","stove","strategy","street","strike","strong","struggle","student","stuff","stumble","style","subject","submit","subway","success","such","sudden","suffer","sugar","suggest","suit","summer","sun","sunny","sunset","super","supply","supreme","sure","surface","surge","surprise","surround","survey","suspect","sustain","swallow","swamp","swap","swarm","swear","sweet","swift","swim","swing","switch","sword","symbol","symptom","syrup","system","table","tackle","tag","tail","talent","talk","tank","tape","target","task","taste","tattoo","taxi","teach","team","tell","ten","tenant","tennis","tent","term","test","text","thank","that","theme","then","theory","there","they","thing","this","thought","three","thrive","throw","thumb","thunder","ticket","tide","tiger","tilt","timber","time","tiny","tip","tired","tissue","title","toast","tobacco","today","toddler","toe","together","toilet","token","tomato","tomorrow","tone","tongue","tonight","tool","tooth","top","topic","topple","torch","tornado","tortoise","toss","total","tourist","toward","tower","town","toy","track","trade","traffic","tragic","train","transfer","trap","trash","travel","tray","treat","tree","trend","trial","tribe","trick","trigger","trim","trip","trophy","trouble","truck","true","truly","trumpet","trust","truth","try","tube","tuition","tumble","tuna","tunnel","turkey","turn","turtle","twelve","twenty","twice","twin","twist","two","type","typical","ugly","umbrella","unable","unaware","uncle","uncover","under","undo","unfair","unfold","unhappy","uniform","unique","unit","universe","unknown","unlock","until","unusual","unveil","update","upgrade","uphold","upon","upper","upset","urban","urge","usage","use","used","useful","useless","usual","utility","vacant","vacuum","vague","valid","valley","valve","van","vanish","vapor","various","vast","vault","vehicle","velvet","vendor","venture","venue","verb","verify","version","very","vessel","veteran","viable","vibrant","vicious","victory","video","view","village","vintage","violin","virtual","virus","visa","visit","visual","vital","vivid","vocal","voice","void","volcano","volume","vote","voyage","wage","wagon","wait","walk","wall","walnut","want","warfare","warm","warrior","wash","wasp","waste","water","wave","way","wealth","weapon","wear","weasel","weather","web","wedding","weekend","weird","welcome","west","wet","whale","what","wheat","wheel","when","where","whip","whisper","wide","width","wife","wild","will","win","window","wine","wing","wink","winner","winter","wire","wisdom","wise","wish","witness","wolf","woman","wonder","wood","wool","word","work","world","worry","worth","wrap","wreck","wrestle","wrist","write","wrong","yard","year","yellow","you","young","youth","zebra","zero","zone","zoo"]');

});



parcelRegister("c37wy", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $8c5b99f25b10648e$require$Buffer = $gzLuY.Buffer;
"use strict";
var $8c5b99f25b10648e$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $8c5b99f25b10648e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8c5b99f25b10648e$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $8c5b99f25b10648e$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $8c5b99f25b10648e$var$__createBinding(result, mod, k);
    }
    $8c5b99f25b10648e$var$__setModuleDefault(result, mod);
    return result;
};
var $8c5b99f25b10648e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $8c5b99f25b10648e$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RawKey = void 0;

var $lzOVk = parcelRequire("lzOVk");

var $8c5b99f25b10648e$var$secp256k1 = $8c5b99f25b10648e$var$__importStar((parcelRequire("f1lan")));

var $4jeDL = parcelRequire("4jeDL");

var $eVVZl = parcelRequire("eVVZl");
/**
 * An implementation of the Key interfaces that uses a raw private key.
 */ var $8c5b99f25b10648e$var$RawKey = /** @class */ function(_super) {
    $8c5b99f25b10648e$var$__extends(RawKey, _super);
    function RawKey(privateKey) {
        var _this = this;
        var publicKey = $8c5b99f25b10648e$var$secp256k1.publicKeyCreate(new Uint8Array(privateKey), true);
        _this = _super.call(this, new $eVVZl.SimplePublicKey($8c5b99f25b10648e$require$Buffer.from(publicKey).toString("base64"))) || this;
        _this.privateKey = privateKey;
        return _this;
    }
    RawKey.prototype.ecdsaSign = function(payload) {
        var hash = $8c5b99f25b10648e$require$Buffer.from($lzOVk.SHA256.hash(new $lzOVk.Word32Array(payload)).toString(), "hex");
        return $8c5b99f25b10648e$var$secp256k1.ecdsaSign(Uint8Array.from(hash), Uint8Array.from(this.privateKey));
    };
    RawKey.prototype.sign = function(payload) {
        return $8c5b99f25b10648e$var$__awaiter(this, void 0, void 0, function() {
            var signature;
            return $8c5b99f25b10648e$var$__generator(this, function(_a) {
                signature = this.ecdsaSign(payload).signature;
                return [
                    2 /*return*/ ,
                    $8c5b99f25b10648e$require$Buffer.from(signature)
                ];
            });
        });
    };
    return RawKey;
}($4jeDL.Key);
module.exports.RawKey = $8c5b99f25b10648e$var$RawKey;

});
parcelRegister("f1lan", function(module, exports) {


module.exports = (parcelRequire("9T8hs"))((parcelRequire("jHh3m")));

});
parcelRegister("9T8hs", function(module, exports) {
const $732fac79cae52929$var$errors = {
    IMPOSSIBLE_CASE: "Impossible case. Please create issue.",
    TWEAK_ADD: "The tweak was out of range or the resulted private key is invalid",
    TWEAK_MUL: "The tweak was out of range or equal to zero",
    CONTEXT_RANDOMIZE_UNKNOW: "Unknow error on context randomization",
    SECKEY_INVALID: "Private Key is invalid",
    PUBKEY_PARSE: "Public Key could not be parsed",
    PUBKEY_SERIALIZE: "Public Key serialization error",
    PUBKEY_COMBINE: "The sum of the public keys is not valid",
    SIG_PARSE: "Signature could not be parsed",
    SIGN: "The nonce generation function failed, or the private key was invalid",
    RECOVER: "Public key could not be recover",
    ECDH: "Scalar was invalid (zero or overflow)"
};
function $732fac79cae52929$var$assert(cond, msg) {
    if (!cond) throw new Error(msg);
}
function $732fac79cae52929$var$isUint8Array(name, value, length) {
    $732fac79cae52929$var$assert(value instanceof Uint8Array, `Expected ${name} to be an Uint8Array`);
    if (length !== undefined) {
        if (Array.isArray(length)) {
            const numbers = length.join(", ");
            const msg = `Expected ${name} to be an Uint8Array with length [${numbers}]`;
            $732fac79cae52929$var$assert(length.includes(value.length), msg);
        } else {
            const msg = `Expected ${name} to be an Uint8Array with length ${length}`;
            $732fac79cae52929$var$assert(value.length === length, msg);
        }
    }
}
function $732fac79cae52929$var$isCompressed(value) {
    $732fac79cae52929$var$assert($732fac79cae52929$var$toTypeString(value) === "Boolean", "Expected compressed to be a Boolean");
}
function $732fac79cae52929$var$getAssertedOutput(output = (len)=>new Uint8Array(len), length) {
    if (typeof output === "function") output = output(length);
    $732fac79cae52929$var$isUint8Array("output", output, length);
    return output;
}
function $732fac79cae52929$var$toTypeString(value) {
    return Object.prototype.toString.call(value).slice(8, -1);
}
module.exports = (secp256k1)=>{
    return {
        contextRandomize (seed) {
            $732fac79cae52929$var$assert(seed === null || seed instanceof Uint8Array, "Expected seed to be an Uint8Array or null");
            if (seed !== null) $732fac79cae52929$var$isUint8Array("seed", seed, 32);
            switch(secp256k1.contextRandomize(seed)){
                case 1:
                    throw new Error($732fac79cae52929$var$errors.CONTEXT_RANDOMIZE_UNKNOW);
            }
        },
        privateKeyVerify (seckey) {
            $732fac79cae52929$var$isUint8Array("private key", seckey, 32);
            return secp256k1.privateKeyVerify(seckey) === 0;
        },
        privateKeyNegate (seckey) {
            $732fac79cae52929$var$isUint8Array("private key", seckey, 32);
            switch(secp256k1.privateKeyNegate(seckey)){
                case 0:
                    return seckey;
                case 1:
                    throw new Error($732fac79cae52929$var$errors.IMPOSSIBLE_CASE);
            }
        },
        privateKeyTweakAdd (seckey, tweak) {
            $732fac79cae52929$var$isUint8Array("private key", seckey, 32);
            $732fac79cae52929$var$isUint8Array("tweak", tweak, 32);
            switch(secp256k1.privateKeyTweakAdd(seckey, tweak)){
                case 0:
                    return seckey;
                case 1:
                    throw new Error($732fac79cae52929$var$errors.TWEAK_ADD);
            }
        },
        privateKeyTweakMul (seckey, tweak) {
            $732fac79cae52929$var$isUint8Array("private key", seckey, 32);
            $732fac79cae52929$var$isUint8Array("tweak", tweak, 32);
            switch(secp256k1.privateKeyTweakMul(seckey, tweak)){
                case 0:
                    return seckey;
                case 1:
                    throw new Error($732fac79cae52929$var$errors.TWEAK_MUL);
            }
        },
        publicKeyVerify (pubkey) {
            $732fac79cae52929$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            return secp256k1.publicKeyVerify(pubkey) === 0;
        },
        publicKeyCreate (seckey, compressed = true, output) {
            $732fac79cae52929$var$isUint8Array("private key", seckey, 32);
            $732fac79cae52929$var$isCompressed(compressed);
            output = $732fac79cae52929$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyCreate(output, seckey)){
                case 0:
                    return output;
                case 1:
                    throw new Error($732fac79cae52929$var$errors.SECKEY_INVALID);
                case 2:
                    throw new Error($732fac79cae52929$var$errors.PUBKEY_SERIALIZE);
            }
        },
        publicKeyConvert (pubkey, compressed = true, output) {
            $732fac79cae52929$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            $732fac79cae52929$var$isCompressed(compressed);
            output = $732fac79cae52929$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyConvert(output, pubkey)){
                case 0:
                    return output;
                case 1:
                    throw new Error($732fac79cae52929$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($732fac79cae52929$var$errors.PUBKEY_SERIALIZE);
            }
        },
        publicKeyNegate (pubkey, compressed = true, output) {
            $732fac79cae52929$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            $732fac79cae52929$var$isCompressed(compressed);
            output = $732fac79cae52929$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyNegate(output, pubkey)){
                case 0:
                    return output;
                case 1:
                    throw new Error($732fac79cae52929$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($732fac79cae52929$var$errors.IMPOSSIBLE_CASE);
                case 3:
                    throw new Error($732fac79cae52929$var$errors.PUBKEY_SERIALIZE);
            }
        },
        publicKeyCombine (pubkeys, compressed = true, output) {
            $732fac79cae52929$var$assert(Array.isArray(pubkeys), "Expected public keys to be an Array");
            $732fac79cae52929$var$assert(pubkeys.length > 0, "Expected public keys array will have more than zero items");
            for (const pubkey of pubkeys)$732fac79cae52929$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            $732fac79cae52929$var$isCompressed(compressed);
            output = $732fac79cae52929$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyCombine(output, pubkeys)){
                case 0:
                    return output;
                case 1:
                    throw new Error($732fac79cae52929$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($732fac79cae52929$var$errors.PUBKEY_COMBINE);
                case 3:
                    throw new Error($732fac79cae52929$var$errors.PUBKEY_SERIALIZE);
            }
        },
        publicKeyTweakAdd (pubkey, tweak, compressed = true, output) {
            $732fac79cae52929$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            $732fac79cae52929$var$isUint8Array("tweak", tweak, 32);
            $732fac79cae52929$var$isCompressed(compressed);
            output = $732fac79cae52929$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyTweakAdd(output, pubkey, tweak)){
                case 0:
                    return output;
                case 1:
                    throw new Error($732fac79cae52929$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($732fac79cae52929$var$errors.TWEAK_ADD);
            }
        },
        publicKeyTweakMul (pubkey, tweak, compressed = true, output) {
            $732fac79cae52929$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            $732fac79cae52929$var$isUint8Array("tweak", tweak, 32);
            $732fac79cae52929$var$isCompressed(compressed);
            output = $732fac79cae52929$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyTweakMul(output, pubkey, tweak)){
                case 0:
                    return output;
                case 1:
                    throw new Error($732fac79cae52929$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($732fac79cae52929$var$errors.TWEAK_MUL);
            }
        },
        signatureNormalize (sig) {
            $732fac79cae52929$var$isUint8Array("signature", sig, 64);
            switch(secp256k1.signatureNormalize(sig)){
                case 0:
                    return sig;
                case 1:
                    throw new Error($732fac79cae52929$var$errors.SIG_PARSE);
            }
        },
        signatureExport (sig, output) {
            $732fac79cae52929$var$isUint8Array("signature", sig, 64);
            output = $732fac79cae52929$var$getAssertedOutput(output, 72);
            const obj = {
                output: output,
                outputlen: 72
            };
            switch(secp256k1.signatureExport(obj, sig)){
                case 0:
                    return output.slice(0, obj.outputlen);
                case 1:
                    throw new Error($732fac79cae52929$var$errors.SIG_PARSE);
                case 2:
                    throw new Error($732fac79cae52929$var$errors.IMPOSSIBLE_CASE);
            }
        },
        signatureImport (sig, output) {
            $732fac79cae52929$var$isUint8Array("signature", sig);
            output = $732fac79cae52929$var$getAssertedOutput(output, 64);
            switch(secp256k1.signatureImport(output, sig)){
                case 0:
                    return output;
                case 1:
                    throw new Error($732fac79cae52929$var$errors.SIG_PARSE);
                case 2:
                    throw new Error($732fac79cae52929$var$errors.IMPOSSIBLE_CASE);
            }
        },
        ecdsaSign (msg32, seckey, options = {}, output) {
            $732fac79cae52929$var$isUint8Array("message", msg32, 32);
            $732fac79cae52929$var$isUint8Array("private key", seckey, 32);
            $732fac79cae52929$var$assert($732fac79cae52929$var$toTypeString(options) === "Object", "Expected options to be an Object");
            if (options.data !== undefined) $732fac79cae52929$var$isUint8Array("options.data", options.data);
            if (options.noncefn !== undefined) $732fac79cae52929$var$assert($732fac79cae52929$var$toTypeString(options.noncefn) === "Function", "Expected options.noncefn to be a Function");
            output = $732fac79cae52929$var$getAssertedOutput(output, 64);
            const obj = {
                signature: output,
                recid: null
            };
            switch(secp256k1.ecdsaSign(obj, msg32, seckey, options.data, options.noncefn)){
                case 0:
                    return obj;
                case 1:
                    throw new Error($732fac79cae52929$var$errors.SIGN);
                case 2:
                    throw new Error($732fac79cae52929$var$errors.IMPOSSIBLE_CASE);
            }
        },
        ecdsaVerify (sig, msg32, pubkey) {
            $732fac79cae52929$var$isUint8Array("signature", sig, 64);
            $732fac79cae52929$var$isUint8Array("message", msg32, 32);
            $732fac79cae52929$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            switch(secp256k1.ecdsaVerify(sig, msg32, pubkey)){
                case 0:
                    return true;
                case 3:
                    return false;
                case 1:
                    throw new Error($732fac79cae52929$var$errors.SIG_PARSE);
                case 2:
                    throw new Error($732fac79cae52929$var$errors.PUBKEY_PARSE);
            }
        },
        ecdsaRecover (sig, recid, msg32, compressed = true, output) {
            $732fac79cae52929$var$isUint8Array("signature", sig, 64);
            $732fac79cae52929$var$assert($732fac79cae52929$var$toTypeString(recid) === "Number" && recid >= 0 && recid <= 3, "Expected recovery id to be a Number within interval [0, 3]");
            $732fac79cae52929$var$isUint8Array("message", msg32, 32);
            $732fac79cae52929$var$isCompressed(compressed);
            output = $732fac79cae52929$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.ecdsaRecover(output, sig, recid, msg32)){
                case 0:
                    return output;
                case 1:
                    throw new Error($732fac79cae52929$var$errors.SIG_PARSE);
                case 2:
                    throw new Error($732fac79cae52929$var$errors.RECOVER);
                case 3:
                    throw new Error($732fac79cae52929$var$errors.IMPOSSIBLE_CASE);
            }
        },
        ecdh (pubkey, seckey, options = {}, output) {
            $732fac79cae52929$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            $732fac79cae52929$var$isUint8Array("private key", seckey, 32);
            $732fac79cae52929$var$assert($732fac79cae52929$var$toTypeString(options) === "Object", "Expected options to be an Object");
            if (options.data !== undefined) $732fac79cae52929$var$isUint8Array("options.data", options.data);
            if (options.hashfn !== undefined) {
                $732fac79cae52929$var$assert($732fac79cae52929$var$toTypeString(options.hashfn) === "Function", "Expected options.hashfn to be a Function");
                if (options.xbuf !== undefined) $732fac79cae52929$var$isUint8Array("options.xbuf", options.xbuf, 32);
                if (options.ybuf !== undefined) $732fac79cae52929$var$isUint8Array("options.ybuf", options.ybuf, 32);
                $732fac79cae52929$var$isUint8Array("output", output);
            } else output = $732fac79cae52929$var$getAssertedOutput(output, 32);
            switch(secp256k1.ecdh(output, pubkey, seckey, options.data, options.hashfn, options.xbuf, options.ybuf)){
                case 0:
                    return output;
                case 1:
                    throw new Error($732fac79cae52929$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($732fac79cae52929$var$errors.ECDH);
            }
        }
    };
};

});

parcelRegister("jHh3m", function(module, exports) {

var $492wS = parcelRequire("492wS");
var $e56f42e17ab45ef6$require$EC = $492wS.ec;
const $e56f42e17ab45ef6$var$ec = new $e56f42e17ab45ef6$require$EC("secp256k1");
const $e56f42e17ab45ef6$var$ecparams = $e56f42e17ab45ef6$var$ec.curve;
// Hack, we can not use bn.js@5, while elliptic uses bn.js@4
// See https://github.com/indutny/elliptic/issues/191#issuecomment-569888758
const $e56f42e17ab45ef6$var$BN = $e56f42e17ab45ef6$var$ecparams.n.constructor;
function $e56f42e17ab45ef6$var$loadCompressedPublicKey(first, xbuf) {
    let x = new $e56f42e17ab45ef6$var$BN(xbuf);
    // overflow
    if (x.cmp($e56f42e17ab45ef6$var$ecparams.p) >= 0) return null;
    x = x.toRed($e56f42e17ab45ef6$var$ecparams.red);
    // compute corresponding Y
    let y = x.redSqr().redIMul(x).redIAdd($e56f42e17ab45ef6$var$ecparams.b).redSqrt();
    if (first === 0x03 !== y.isOdd()) y = y.redNeg();
    return $e56f42e17ab45ef6$var$ec.keyPair({
        pub: {
            x: x,
            y: y
        }
    });
}
function $e56f42e17ab45ef6$var$loadUncompressedPublicKey(first, xbuf, ybuf) {
    let x = new $e56f42e17ab45ef6$var$BN(xbuf);
    let y = new $e56f42e17ab45ef6$var$BN(ybuf);
    // overflow
    if (x.cmp($e56f42e17ab45ef6$var$ecparams.p) >= 0 || y.cmp($e56f42e17ab45ef6$var$ecparams.p) >= 0) return null;
    x = x.toRed($e56f42e17ab45ef6$var$ecparams.red);
    y = y.toRed($e56f42e17ab45ef6$var$ecparams.red);
    // is odd flag
    if ((first === 0x06 || first === 0x07) && y.isOdd() !== (first === 0x07)) return null;
    // x*x*x + b = y*y
    const x3 = x.redSqr().redIMul(x);
    if (!y.redSqr().redISub(x3.redIAdd($e56f42e17ab45ef6$var$ecparams.b)).isZero()) return null;
    return $e56f42e17ab45ef6$var$ec.keyPair({
        pub: {
            x: x,
            y: y
        }
    });
}
function $e56f42e17ab45ef6$var$loadPublicKey(pubkey) {
    // length should be validated in interface
    const first = pubkey[0];
    switch(first){
        case 0x02:
        case 0x03:
            if (pubkey.length !== 33) return null;
            return $e56f42e17ab45ef6$var$loadCompressedPublicKey(first, pubkey.subarray(1, 33));
        case 0x04:
        case 0x06:
        case 0x07:
            if (pubkey.length !== 65) return null;
            return $e56f42e17ab45ef6$var$loadUncompressedPublicKey(first, pubkey.subarray(1, 33), pubkey.subarray(33, 65));
        default:
            return null;
    }
}
function $e56f42e17ab45ef6$var$savePublicKey(output, point) {
    const pubkey = point.encode(null, output.length === 33);
    // Loop should be faster because we do not need create extra Uint8Array
    // output.set(new Uint8Array(pubkey))
    for(let i = 0; i < output.length; ++i)output[i] = pubkey[i];
}
module.exports = {
    contextRandomize () {
        return 0;
    },
    privateKeyVerify (seckey) {
        const bn = new $e56f42e17ab45ef6$var$BN(seckey);
        return bn.cmp($e56f42e17ab45ef6$var$ecparams.n) < 0 && !bn.isZero() ? 0 : 1;
    },
    privateKeyNegate (seckey) {
        const bn = new $e56f42e17ab45ef6$var$BN(seckey);
        const negate = $e56f42e17ab45ef6$var$ecparams.n.sub(bn).umod($e56f42e17ab45ef6$var$ecparams.n).toArrayLike(Uint8Array, "be", 32);
        seckey.set(negate);
        return 0;
    },
    privateKeyTweakAdd (seckey, tweak) {
        const bn = new $e56f42e17ab45ef6$var$BN(tweak);
        if (bn.cmp($e56f42e17ab45ef6$var$ecparams.n) >= 0) return 1;
        bn.iadd(new $e56f42e17ab45ef6$var$BN(seckey));
        if (bn.cmp($e56f42e17ab45ef6$var$ecparams.n) >= 0) bn.isub($e56f42e17ab45ef6$var$ecparams.n);
        if (bn.isZero()) return 1;
        const tweaked = bn.toArrayLike(Uint8Array, "be", 32);
        seckey.set(tweaked);
        return 0;
    },
    privateKeyTweakMul (seckey, tweak) {
        let bn = new $e56f42e17ab45ef6$var$BN(tweak);
        if (bn.cmp($e56f42e17ab45ef6$var$ecparams.n) >= 0 || bn.isZero()) return 1;
        bn.imul(new $e56f42e17ab45ef6$var$BN(seckey));
        if (bn.cmp($e56f42e17ab45ef6$var$ecparams.n) >= 0) bn = bn.umod($e56f42e17ab45ef6$var$ecparams.n);
        const tweaked = bn.toArrayLike(Uint8Array, "be", 32);
        seckey.set(tweaked);
        return 0;
    },
    publicKeyVerify (pubkey) {
        const pair = $e56f42e17ab45ef6$var$loadPublicKey(pubkey);
        return pair === null ? 1 : 0;
    },
    publicKeyCreate (output, seckey) {
        const bn = new $e56f42e17ab45ef6$var$BN(seckey);
        if (bn.cmp($e56f42e17ab45ef6$var$ecparams.n) >= 0 || bn.isZero()) return 1;
        const point = $e56f42e17ab45ef6$var$ec.keyFromPrivate(seckey).getPublic();
        $e56f42e17ab45ef6$var$savePublicKey(output, point);
        return 0;
    },
    publicKeyConvert (output, pubkey) {
        const pair = $e56f42e17ab45ef6$var$loadPublicKey(pubkey);
        if (pair === null) return 1;
        const point = pair.getPublic();
        $e56f42e17ab45ef6$var$savePublicKey(output, point);
        return 0;
    },
    publicKeyNegate (output, pubkey) {
        const pair = $e56f42e17ab45ef6$var$loadPublicKey(pubkey);
        if (pair === null) return 1;
        const point = pair.getPublic();
        point.y = point.y.redNeg();
        $e56f42e17ab45ef6$var$savePublicKey(output, point);
        return 0;
    },
    publicKeyCombine (output, pubkeys) {
        const pairs = new Array(pubkeys.length);
        for(let i = 0; i < pubkeys.length; ++i){
            pairs[i] = $e56f42e17ab45ef6$var$loadPublicKey(pubkeys[i]);
            if (pairs[i] === null) return 1;
        }
        let point = pairs[0].getPublic();
        for(let i = 1; i < pairs.length; ++i)point = point.add(pairs[i].pub);
        if (point.isInfinity()) return 2;
        $e56f42e17ab45ef6$var$savePublicKey(output, point);
        return 0;
    },
    publicKeyTweakAdd (output, pubkey, tweak) {
        const pair = $e56f42e17ab45ef6$var$loadPublicKey(pubkey);
        if (pair === null) return 1;
        tweak = new $e56f42e17ab45ef6$var$BN(tweak);
        if (tweak.cmp($e56f42e17ab45ef6$var$ecparams.n) >= 0) return 2;
        const point = pair.getPublic().add($e56f42e17ab45ef6$var$ecparams.g.mul(tweak));
        if (point.isInfinity()) return 2;
        $e56f42e17ab45ef6$var$savePublicKey(output, point);
        return 0;
    },
    publicKeyTweakMul (output, pubkey, tweak) {
        const pair = $e56f42e17ab45ef6$var$loadPublicKey(pubkey);
        if (pair === null) return 1;
        tweak = new $e56f42e17ab45ef6$var$BN(tweak);
        if (tweak.cmp($e56f42e17ab45ef6$var$ecparams.n) >= 0 || tweak.isZero()) return 2;
        const point = pair.getPublic().mul(tweak);
        $e56f42e17ab45ef6$var$savePublicKey(output, point);
        return 0;
    },
    signatureNormalize (sig) {
        const r = new $e56f42e17ab45ef6$var$BN(sig.subarray(0, 32));
        const s = new $e56f42e17ab45ef6$var$BN(sig.subarray(32, 64));
        if (r.cmp($e56f42e17ab45ef6$var$ecparams.n) >= 0 || s.cmp($e56f42e17ab45ef6$var$ecparams.n) >= 0) return 1;
        if (s.cmp($e56f42e17ab45ef6$var$ec.nh) === 1) sig.set($e56f42e17ab45ef6$var$ecparams.n.sub(s).toArrayLike(Uint8Array, "be", 32), 32);
        return 0;
    },
    // Copied 1-to-1 from https://github.com/bitcoinjs/bip66/blob/master/index.js
    // Adapted for Uint8Array instead Buffer
    signatureExport (obj, sig) {
        const sigR = sig.subarray(0, 32);
        const sigS = sig.subarray(32, 64);
        if (new $e56f42e17ab45ef6$var$BN(sigR).cmp($e56f42e17ab45ef6$var$ecparams.n) >= 0) return 1;
        if (new $e56f42e17ab45ef6$var$BN(sigS).cmp($e56f42e17ab45ef6$var$ecparams.n) >= 0) return 1;
        const { output: output } = obj;
        // Prepare R
        let r = output.subarray(4, 37);
        r[0] = 0x00;
        r.set(sigR, 1);
        let lenR = 33;
        let posR = 0;
        for(; lenR > 1 && r[posR] === 0x00 && !(r[posR + 1] & 0x80); --lenR, ++posR);
        r = r.subarray(posR);
        if (r[0] & 0x80) return 1;
        if (lenR > 1 && r[0] === 0x00 && !(r[1] & 0x80)) return 1;
        // Prepare S
        let s = output.subarray(39, 72);
        s[0] = 0x00;
        s.set(sigS, 1);
        let lenS = 33;
        let posS = 0;
        for(; lenS > 1 && s[posS] === 0x00 && !(s[posS + 1] & 0x80); --lenS, ++posS);
        s = s.subarray(posS);
        if (s[0] & 0x80) return 1;
        if (lenS > 1 && s[0] === 0x00 && !(s[1] & 0x80)) return 1;
        // Set output length for return
        obj.outputlen = 6 + lenR + lenS;
        // Output in specified format
        // 0x30 [total-length] 0x02 [R-length] [R] 0x02 [S-length] [S]
        output[0] = 0x30;
        output[1] = obj.outputlen - 2;
        output[2] = 0x02;
        output[3] = r.length;
        output.set(r, 4);
        output[4 + lenR] = 0x02;
        output[5 + lenR] = s.length;
        output.set(s, 6 + lenR);
        return 0;
    },
    // Copied 1-to-1 from https://github.com/bitcoinjs/bip66/blob/master/index.js
    // Adapted for Uint8Array instead Buffer
    signatureImport (output, sig) {
        if (sig.length < 8) return 1;
        if (sig.length > 72) return 1;
        if (sig[0] !== 0x30) return 1;
        if (sig[1] !== sig.length - 2) return 1;
        if (sig[2] !== 0x02) return 1;
        const lenR = sig[3];
        if (lenR === 0) return 1;
        if (5 + lenR >= sig.length) return 1;
        if (sig[4 + lenR] !== 0x02) return 1;
        const lenS = sig[5 + lenR];
        if (lenS === 0) return 1;
        if (6 + lenR + lenS !== sig.length) return 1;
        if (sig[4] & 0x80) return 1;
        if (lenR > 1 && sig[4] === 0x00 && !(sig[5] & 0x80)) return 1;
        if (sig[lenR + 6] & 0x80) return 1;
        if (lenS > 1 && sig[lenR + 6] === 0x00 && !(sig[lenR + 7] & 0x80)) return 1;
        let sigR = sig.subarray(4, 4 + lenR);
        if (sigR.length === 33 && sigR[0] === 0x00) sigR = sigR.subarray(1);
        if (sigR.length > 32) return 1;
        let sigS = sig.subarray(6 + lenR);
        if (sigS.length === 33 && sigS[0] === 0x00) sigS = sigS.slice(1);
        if (sigS.length > 32) throw new Error("S length is too long");
        let r = new $e56f42e17ab45ef6$var$BN(sigR);
        if (r.cmp($e56f42e17ab45ef6$var$ecparams.n) >= 0) r = new $e56f42e17ab45ef6$var$BN(0);
        let s = new $e56f42e17ab45ef6$var$BN(sig.subarray(6 + lenR));
        if (s.cmp($e56f42e17ab45ef6$var$ecparams.n) >= 0) s = new $e56f42e17ab45ef6$var$BN(0);
        output.set(r.toArrayLike(Uint8Array, "be", 32), 0);
        output.set(s.toArrayLike(Uint8Array, "be", 32), 32);
        return 0;
    },
    ecdsaSign (obj, message, seckey, data, noncefn) {
        if (noncefn) {
            const _noncefn = noncefn;
            noncefn = (counter)=>{
                const nonce = _noncefn(message, seckey, null, data, counter);
                const isValid = nonce instanceof Uint8Array && nonce.length === 32;
                if (!isValid) throw new Error("This is the way");
                return new $e56f42e17ab45ef6$var$BN(nonce);
            };
        }
        const d = new $e56f42e17ab45ef6$var$BN(seckey);
        if (d.cmp($e56f42e17ab45ef6$var$ecparams.n) >= 0 || d.isZero()) return 1;
        let sig;
        try {
            sig = $e56f42e17ab45ef6$var$ec.sign(message, seckey, {
                canonical: true,
                k: noncefn,
                pers: data
            });
        } catch (err) {
            return 1;
        }
        obj.signature.set(sig.r.toArrayLike(Uint8Array, "be", 32), 0);
        obj.signature.set(sig.s.toArrayLike(Uint8Array, "be", 32), 32);
        obj.recid = sig.recoveryParam;
        return 0;
    },
    ecdsaVerify (sig, msg32, pubkey) {
        const sigObj = {
            r: sig.subarray(0, 32),
            s: sig.subarray(32, 64)
        };
        const sigr = new $e56f42e17ab45ef6$var$BN(sigObj.r);
        const sigs = new $e56f42e17ab45ef6$var$BN(sigObj.s);
        if (sigr.cmp($e56f42e17ab45ef6$var$ecparams.n) >= 0 || sigs.cmp($e56f42e17ab45ef6$var$ecparams.n) >= 0) return 1;
        if (sigs.cmp($e56f42e17ab45ef6$var$ec.nh) === 1 || sigr.isZero() || sigs.isZero()) return 3;
        const pair = $e56f42e17ab45ef6$var$loadPublicKey(pubkey);
        if (pair === null) return 2;
        const point = pair.getPublic();
        const isValid = $e56f42e17ab45ef6$var$ec.verify(msg32, sigObj, point);
        return isValid ? 0 : 3;
    },
    ecdsaRecover (output, sig, recid, msg32) {
        const sigObj = {
            r: sig.slice(0, 32),
            s: sig.slice(32, 64)
        };
        const sigr = new $e56f42e17ab45ef6$var$BN(sigObj.r);
        const sigs = new $e56f42e17ab45ef6$var$BN(sigObj.s);
        if (sigr.cmp($e56f42e17ab45ef6$var$ecparams.n) >= 0 || sigs.cmp($e56f42e17ab45ef6$var$ecparams.n) >= 0) return 1;
        if (sigr.isZero() || sigs.isZero()) return 2;
        // Can throw `throw new Error('Unable to find sencond key candinate');`
        let point;
        try {
            point = $e56f42e17ab45ef6$var$ec.recoverPubKey(msg32, sigObj, recid);
        } catch (err) {
            return 2;
        }
        $e56f42e17ab45ef6$var$savePublicKey(output, point);
        return 0;
    },
    ecdh (output, pubkey, seckey, data, hashfn, xbuf, ybuf) {
        const pair = $e56f42e17ab45ef6$var$loadPublicKey(pubkey);
        if (pair === null) return 1;
        const scalar = new $e56f42e17ab45ef6$var$BN(seckey);
        if (scalar.cmp($e56f42e17ab45ef6$var$ecparams.n) >= 0 || scalar.isZero()) return 2;
        const point = pair.getPublic().mul(scalar);
        if (hashfn === undefined) {
            const data = point.encode(null, true);
            const sha256 = $e56f42e17ab45ef6$var$ec.hash().update(data).digest();
            for(let i = 0; i < 32; ++i)output[i] = sha256[i];
        } else {
            if (!xbuf) xbuf = new Uint8Array(32);
            const x = point.getX().toArray("be", 32);
            for(let i = 0; i < 32; ++i)xbuf[i] = x[i];
            if (!ybuf) ybuf = new Uint8Array(32);
            const y = point.getY().toArray("be", 32);
            for(let i = 0; i < 32; ++i)ybuf[i] = y[i];
            const hash = hashfn(xbuf, ybuf, data);
            const isValid = hash instanceof Uint8Array && hash.length === output.length;
            if (!isValid) return 2;
            output.set(hash);
        }
        return 0;
    }
};

});





parcelRegister("JBm1g", function(module, exports) {
"use strict";
var $08912dd71ebaeb07$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $08912dd71ebaeb07$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $08912dd71ebaeb07$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

// LCDClient
$08912dd71ebaeb07$var$__exportStar((parcelRequire("6o8js")), module.exports);

$08912dd71ebaeb07$var$__exportStar((parcelRequire("jeC9j")), module.exports);

$08912dd71ebaeb07$var$__exportStar((parcelRequire("iE6dd")), module.exports);

// LocalTerra (LCDClient)
$08912dd71ebaeb07$var$__exportStar((parcelRequire("39bNt")), module.exports);

// WebSocketClient
$08912dd71ebaeb07$var$__exportStar((parcelRequire("bcWXs")), module.exports);

});
parcelRegister("6o8js", function(module, exports) {
"use strict";
var $4a6b6ebcad15a045$var$__assign = module.exports && module.exports.__assign || function() {
    $4a6b6ebcad15a045$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4a6b6ebcad15a045$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LCDClient = void 0;

var $jpUsv = parcelRequire("jpUsv");

var $iE6dd = parcelRequire("iE6dd");

var $dGqih = parcelRequire("dGqih");

var $jeC9j = parcelRequire("jeC9j");
var $4a6b6ebcad15a045$var$DEFAULT_LCD_OPTIONS = {
    gasAdjustment: 1.75
};
// isClassic network: true
// forked network : false
var $4a6b6ebcad15a045$var$DEFAULT_NETWORK_TYPE_BY_CHAIN_ID = {
    default: false,
    "columbus-5": true,
    "bombay-12": true,
    "pisco-1": false
};
var $4a6b6ebcad15a045$var$DEFAULT_GAS_PRICES_BY_CHAIN_ID = {
    default: {
        uluna: 0.15
    },
    "columbus-5": {
        uusd: 0.15
    },
    "bombay-12": {
        uusd: 0.15
    },
    "pisco-1": {
        uluna: 0.15
    }
};
/**
 * An object repesenting a connection to a terrad node running the Lite Client Daemon (LCD)
 * server, a REST server providing access to a node.
 *
 * ### Example
 *
 * ```ts
 * import { LCDClient, Coin } from 'terra.js';
 *
 * const terra = new LCDClient({
 *    URL: "https://lcd.terra.dev",
 *    chainID: "columbus-3"
 * });
 *
 * terra.market.swapRate(new Coin('uluna', 10000), 'ukrw').then(c => console.log(c.toString()));
 * ```
 */ var $4a6b6ebcad15a045$var$LCDClient = /** @class */ function() {
    /**
     * Creates a new LCD client with the specified configuration.
     *
     * @param config LCD configuration
     */ function LCDClient(config) {
        this.config = $4a6b6ebcad15a045$var$__assign($4a6b6ebcad15a045$var$__assign($4a6b6ebcad15a045$var$__assign({}, $4a6b6ebcad15a045$var$DEFAULT_LCD_OPTIONS), {
            gasPrices: $4a6b6ebcad15a045$var$DEFAULT_GAS_PRICES_BY_CHAIN_ID[config.chainID] || $4a6b6ebcad15a045$var$DEFAULT_GAS_PRICES_BY_CHAIN_ID["default"],
            isClassic: $4a6b6ebcad15a045$var$DEFAULT_NETWORK_TYPE_BY_CHAIN_ID[config.chainID] || $4a6b6ebcad15a045$var$DEFAULT_NETWORK_TYPE_BY_CHAIN_ID["default"]
        }), config);
        this.apiRequester = new $jpUsv.APIRequester(this.config.URL);
        // instantiate APIs
        this.auth = new $iE6dd.AuthAPI(this);
        this.bank = new $iE6dd.BankAPI(this);
        this.distribution = new $iE6dd.DistributionAPI(this);
        this.feeGrant = new $iE6dd.FeeGrantAPI(this);
        this.gov = new $iE6dd.GovAPI(this);
        this.market = new $iE6dd.MarketAPI(this);
        this.mint = new $iE6dd.MintAPI(this);
        this.authz = new $iE6dd.AuthzAPI(this);
        this.oracle = new $iE6dd.OracleAPI(this);
        this.slashing = new $iE6dd.SlashingAPI(this);
        this.staking = new $iE6dd.StakingAPI(this);
        this.tendermint = new $iE6dd.TendermintAPI(this);
        this.treasury = new $iE6dd.TreasuryAPI(this);
        this.wasm = new $iE6dd.WasmAPI(this);
        this.ibc = new $iE6dd.IbcAPI(this);
        this.ibcTransfer = new $iE6dd.IbcTransferAPI(this);
        this.tx = new $iE6dd.TxAPI(this);
        this.utils = new $dGqih.LCDUtils(this);
    }
    /** Creates a new wallet with the Key. */ LCDClient.prototype.wallet = function(key) {
        return new $jeC9j.Wallet(this, key);
    };
    return LCDClient;
}();
module.exports.LCDClient = $4a6b6ebcad15a045$var$LCDClient;

});
parcelRegister("jpUsv", function(module, exports) {
"use strict";
var $e22c25a70c9991b1$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $e22c25a70c9991b1$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $e22c25a70c9991b1$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.APIRequester = module.exports.OrderBy = void 0;

var $e22c25a70c9991b1$var$axios_1 = $e22c25a70c9991b1$var$__importDefault((parcelRequire("6DGWy")));

var $bQI3U = parcelRequire("bQI3U");
module.exports.OrderBy = $bQI3U.OrderBy;
var $e22c25a70c9991b1$var$APIRequester = /** @class */ function() {
    function APIRequester(baseURL) {
        this.baseURL = baseURL;
        this.axios = $e22c25a70c9991b1$var$axios_1.default.create({
            headers: {
                Accept: "application/json"
            },
            timeout: 30000
        });
    }
    APIRequester.prototype.computeEndpoint = function(endpoint) {
        var url = new URL(this.baseURL);
        url.pathname === "/" ? url.pathname = endpoint : url.pathname += endpoint;
        return url.toString();
    };
    APIRequester.prototype.getRaw = function(endpoint, params) {
        if (params === void 0) params = {};
        return $e22c25a70c9991b1$var$__awaiter(this, void 0, void 0, function() {
            var url;
            return $e22c25a70c9991b1$var$__generator(this, function(_a) {
                url = this.computeEndpoint(endpoint);
                return [
                    2 /*return*/ ,
                    this.axios.get(url, {
                        params: params
                    }).then(function(d) {
                        return d.data;
                    })
                ];
            });
        });
    };
    APIRequester.prototype.get = function(endpoint, params) {
        if (params === void 0) params = {};
        return $e22c25a70c9991b1$var$__awaiter(this, void 0, void 0, function() {
            var url;
            return $e22c25a70c9991b1$var$__generator(this, function(_a) {
                url = this.computeEndpoint(endpoint);
                return [
                    2 /*return*/ ,
                    this.axios.get(url, {
                        params: params
                    }).then(function(d) {
                        return d.data;
                    })
                ];
            });
        });
    };
    APIRequester.prototype.postRaw = function(endpoint, data) {
        return $e22c25a70c9991b1$var$__awaiter(this, void 0, void 0, function() {
            var url;
            return $e22c25a70c9991b1$var$__generator(this, function(_a) {
                url = this.computeEndpoint(endpoint);
                return [
                    2 /*return*/ ,
                    this.axios.post(url, data).then(function(d) {
                        return d.data;
                    })
                ];
            });
        });
    };
    APIRequester.prototype.post = function(endpoint, data) {
        return $e22c25a70c9991b1$var$__awaiter(this, void 0, void 0, function() {
            var url;
            return $e22c25a70c9991b1$var$__generator(this, function(_a) {
                url = this.computeEndpoint(endpoint);
                return [
                    2 /*return*/ ,
                    this.axios.post(url, data).then(function(d) {
                        return d.data;
                    })
                ];
            });
        });
    };
    return APIRequester;
}();
module.exports.APIRequester = $e22c25a70c9991b1$var$APIRequester;

});
parcelRegister("6DGWy", function(module, exports) {

module.exports = (parcelRequire("bGbcv"));

});
parcelRegister("bGbcv", function(module, exports) {
"use strict";

var $jS1Yc = parcelRequire("jS1Yc");

var $9sO3x = parcelRequire("9sO3x");

var $8JR9C = parcelRequire("8JR9C");

var $bHMeL = parcelRequire("bHMeL");

var $iMdGb = parcelRequire("iMdGb");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $880c4e335741f5f0$var$createInstance(defaultConfig) {
    var context = new $8JR9C(defaultConfig);
    var instance = $9sO3x($8JR9C.prototype.request, context);
    // Copy axios.prototype to instance
    $jS1Yc.extend(instance, $8JR9C.prototype, context);
    // Copy context to instance
    $jS1Yc.extend(instance, context);
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $880c4e335741f5f0$var$createInstance($bHMeL(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $880c4e335741f5f0$var$axios = $880c4e335741f5f0$var$createInstance($iMdGb);
// Expose Axios class to allow class inheritance
$880c4e335741f5f0$var$axios.Axios = $8JR9C;

// Expose Cancel & CancelToken
$880c4e335741f5f0$var$axios.CanceledError = (parcelRequire("4ltuv"));

$880c4e335741f5f0$var$axios.CancelToken = (parcelRequire("kkqEe"));

$880c4e335741f5f0$var$axios.isCancel = (parcelRequire("DcSua"));

$880c4e335741f5f0$var$axios.VERSION = (parcelRequire("dmTUs")).version;

$880c4e335741f5f0$var$axios.toFormData = (parcelRequire("4moAL"));

// Expose AxiosError class
$880c4e335741f5f0$var$axios.AxiosError = (parcelRequire("5yBRP"));
// alias for CanceledError for backward compatibility
$880c4e335741f5f0$var$axios.Cancel = $880c4e335741f5f0$var$axios.CanceledError;
// Expose all/spread
$880c4e335741f5f0$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$880c4e335741f5f0$var$axios.spread = (parcelRequire("luFaY"));

// Expose isAxiosError
$880c4e335741f5f0$var$axios.isAxiosError = (parcelRequire("fuUwd"));
module.exports = $880c4e335741f5f0$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $880c4e335741f5f0$var$axios;

});
parcelRegister("jS1Yc", function(module, exports) {
"use strict";

var $9sO3x = parcelRequire("9sO3x");
// utils is a library of generic helper functions non-specific to axios
var $e77496ab201aff94$var$toString = Object.prototype.toString;
// eslint-disable-next-line func-names
var $e77496ab201aff94$var$kindOf = function(cache) {
    // eslint-disable-next-line func-names
    return function(thing) {
        var str = $e77496ab201aff94$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    };
}(Object.create(null));
function $e77496ab201aff94$var$kindOfTest(type) {
    type = type.toLowerCase();
    return function isKindOf(thing) {
        return $e77496ab201aff94$var$kindOf(thing) === type;
    };
}
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $e77496ab201aff94$var$isArray(val) {
    return Array.isArray(val);
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $e77496ab201aff94$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $e77496ab201aff94$var$isBuffer(val) {
    return val !== null && !$e77496ab201aff94$var$isUndefined(val) && val.constructor !== null && !$e77496ab201aff94$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ var $e77496ab201aff94$var$isArrayBuffer = $e77496ab201aff94$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $e77496ab201aff94$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $e77496ab201aff94$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $e77496ab201aff94$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $e77496ab201aff94$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $e77496ab201aff94$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $e77496ab201aff94$var$isPlainObject(val) {
    if ($e77496ab201aff94$var$kindOf(val) !== "object") return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ var $e77496ab201aff94$var$isDate = $e77496ab201aff94$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ var $e77496ab201aff94$var$isFile = $e77496ab201aff94$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ var $e77496ab201aff94$var$isBlob = $e77496ab201aff94$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ var $e77496ab201aff94$var$isFileList = $e77496ab201aff94$var$kindOfTest("FileList");
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $e77496ab201aff94$var$isFunction(val) {
    return $e77496ab201aff94$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $e77496ab201aff94$var$isStream(val) {
    return $e77496ab201aff94$var$isObject(val) && $e77496ab201aff94$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $e77496ab201aff94$var$isFormData(thing) {
    var pattern = "[object FormData]";
    return thing && (typeof FormData === "function" && thing instanceof FormData || $e77496ab201aff94$var$toString.call(thing) === pattern || $e77496ab201aff94$var$isFunction(thing.toString) && thing.toString() === pattern);
}
/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ var $e77496ab201aff94$var$isURLSearchParams = $e77496ab201aff94$var$kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $e77496ab201aff94$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $e77496ab201aff94$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $e77496ab201aff94$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($e77496ab201aff94$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $e77496ab201aff94$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($e77496ab201aff94$var$isPlainObject(result[key]) && $e77496ab201aff94$var$isPlainObject(val)) result[key] = $e77496ab201aff94$var$merge(result[key], val);
        else if ($e77496ab201aff94$var$isPlainObject(val)) result[key] = $e77496ab201aff94$var$merge({}, val);
        else if ($e77496ab201aff94$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$e77496ab201aff94$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $e77496ab201aff94$var$extend(a, b, thisArg) {
    $e77496ab201aff94$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $9sO3x(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $e77496ab201aff94$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */ function $e77496ab201aff94$var$inherits(constructor, superConstructor, props, descriptors) {
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    props && Object.assign(constructor.prototype, props);
}
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function} [filter]
 * @returns {Object}
 */ function $e77496ab201aff94$var$toFlatObject(sourceObj, destObj, filter) {
    var props;
    var i;
    var prop;
    var merged = {};
    destObj = destObj || {};
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if (!merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = Object.getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
}
/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */ function $e77496ab201aff94$var$endsWith(str, searchString, position) {
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    var lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
}
/**
 * Returns new array from array like object
 * @param {*} [thing]
 * @returns {Array}
 */ function $e77496ab201aff94$var$toArray(thing) {
    if (!thing) return null;
    var i = thing.length;
    if ($e77496ab201aff94$var$isUndefined(i)) return null;
    var arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
}
// eslint-disable-next-line func-names
var $e77496ab201aff94$var$isTypedArray = function(TypedArray) {
    // eslint-disable-next-line func-names
    return function(thing) {
        return TypedArray && thing instanceof TypedArray;
    };
}(typeof Uint8Array !== "undefined" && Object.getPrototypeOf(Uint8Array));
module.exports = {
    isArray: $e77496ab201aff94$var$isArray,
    isArrayBuffer: $e77496ab201aff94$var$isArrayBuffer,
    isBuffer: $e77496ab201aff94$var$isBuffer,
    isFormData: $e77496ab201aff94$var$isFormData,
    isArrayBufferView: $e77496ab201aff94$var$isArrayBufferView,
    isString: $e77496ab201aff94$var$isString,
    isNumber: $e77496ab201aff94$var$isNumber,
    isObject: $e77496ab201aff94$var$isObject,
    isPlainObject: $e77496ab201aff94$var$isPlainObject,
    isUndefined: $e77496ab201aff94$var$isUndefined,
    isDate: $e77496ab201aff94$var$isDate,
    isFile: $e77496ab201aff94$var$isFile,
    isBlob: $e77496ab201aff94$var$isBlob,
    isFunction: $e77496ab201aff94$var$isFunction,
    isStream: $e77496ab201aff94$var$isStream,
    isURLSearchParams: $e77496ab201aff94$var$isURLSearchParams,
    isStandardBrowserEnv: $e77496ab201aff94$var$isStandardBrowserEnv,
    forEach: $e77496ab201aff94$var$forEach,
    merge: $e77496ab201aff94$var$merge,
    extend: $e77496ab201aff94$var$extend,
    trim: $e77496ab201aff94$var$trim,
    stripBOM: $e77496ab201aff94$var$stripBOM,
    inherits: $e77496ab201aff94$var$inherits,
    toFlatObject: $e77496ab201aff94$var$toFlatObject,
    kindOf: $e77496ab201aff94$var$kindOf,
    kindOfTest: $e77496ab201aff94$var$kindOfTest,
    endsWith: $e77496ab201aff94$var$endsWith,
    toArray: $e77496ab201aff94$var$toArray,
    isTypedArray: $e77496ab201aff94$var$isTypedArray,
    isFileList: $e77496ab201aff94$var$isFileList
};

});
parcelRegister("9sO3x", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("8JR9C", function(module, exports) {
"use strict";

var $jS1Yc = parcelRequire("jS1Yc");

var $kIXV7 = parcelRequire("kIXV7");

var $bXmq8 = parcelRequire("bXmq8");

var $4TcAf = parcelRequire("4TcAf");

var $bHMeL = parcelRequire("bHMeL");

var $b9VcG = parcelRequire("b9VcG");

var $hw4Ol = parcelRequire("hw4Ol");
var $65cbc1ff751f4bd3$var$validators = $hw4Ol.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $65cbc1ff751f4bd3$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $bXmq8(),
        response: new $bXmq8()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $65cbc1ff751f4bd3$var$Axios.prototype.request = function request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === "string") {
        config = config || {};
        config.url = configOrUrl;
    } else config = configOrUrl || {};
    config = $bHMeL(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    var transitional = config.transitional;
    if (transitional !== undefined) $hw4Ol.assertOptions(transitional, {
        silentJSONParsing: $65cbc1ff751f4bd3$var$validators.transitional($65cbc1ff751f4bd3$var$validators.boolean),
        forcedJSONParsing: $65cbc1ff751f4bd3$var$validators.transitional($65cbc1ff751f4bd3$var$validators.boolean),
        clarifyTimeoutError: $65cbc1ff751f4bd3$var$validators.transitional($65cbc1ff751f4bd3$var$validators.boolean)
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $4TcAf,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $4TcAf(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$65cbc1ff751f4bd3$var$Axios.prototype.getUri = function getUri(config) {
    config = $bHMeL(this.defaults, config);
    var fullPath = $b9VcG(config.baseURL, config.url);
    return $kIXV7(fullPath, config.params, config.paramsSerializer);
};
// Provide aliases for supported request methods
$jS1Yc.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $65cbc1ff751f4bd3$var$Axios.prototype[method] = function(url, config) {
        return this.request($bHMeL(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$jS1Yc.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request($bHMeL(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $65cbc1ff751f4bd3$var$Axios.prototype[method] = generateHTTPMethod();
    $65cbc1ff751f4bd3$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
module.exports = $65cbc1ff751f4bd3$var$Axios;

});
parcelRegister("kIXV7", function(module, exports) {
"use strict";

var $jS1Yc = parcelRequire("jS1Yc");
function $f166659d975fbcfa$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($jS1Yc.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $jS1Yc.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($jS1Yc.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $jS1Yc.forEach(val, function parseValue(v) {
                if ($jS1Yc.isDate(v)) v = v.toISOString();
                else if ($jS1Yc.isObject(v)) v = JSON.stringify(v);
                parts.push($f166659d975fbcfa$var$encode(key) + "=" + $f166659d975fbcfa$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

});

parcelRegister("bXmq8", function(module, exports) {
"use strict";

var $jS1Yc = parcelRequire("jS1Yc");
function $8b4698abab4478ff$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $8b4698abab4478ff$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $8b4698abab4478ff$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $8b4698abab4478ff$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $jS1Yc.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $8b4698abab4478ff$var$InterceptorManager;

});

parcelRegister("4TcAf", function(module, exports) {
"use strict";

var $jS1Yc = parcelRequire("jS1Yc");

var $5FCpS = parcelRequire("5FCpS");

var $DcSua = parcelRequire("DcSua");

var $iMdGb = parcelRequire("iMdGb");

var $4ltuv = parcelRequire("4ltuv");
/**
 * Throws a `CanceledError` if cancellation has been requested.
 */ function $38f60f54d37ccb76$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new $4ltuv();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $38f60f54d37ccb76$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $5FCpS.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $jS1Yc.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $jS1Yc.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $iMdGb.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $38f60f54d37ccb76$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $5FCpS.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$DcSua(reason)) {
            $38f60f54d37ccb76$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $5FCpS.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("5FCpS", function(module, exports) {
"use strict";

var $jS1Yc = parcelRequire("jS1Yc");

var $iMdGb = parcelRequire("iMdGb");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $iMdGb;
    /*eslint no-param-reassign:0*/ $jS1Yc.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRegister("iMdGb", function(module, exports) {

var $a8i8g = parcelRequire("a8i8g");
"use strict";

var $jS1Yc = parcelRequire("jS1Yc");

var $gGjFY = parcelRequire("gGjFY");

var $5yBRP = parcelRequire("5yBRP");

var $k4ieG = parcelRequire("k4ieG");

var $4moAL = parcelRequire("4moAL");
var $dab7521a8ea5ac3a$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $dab7521a8ea5ac3a$var$setContentTypeIfUnset(headers, value) {
    if (!$jS1Yc.isUndefined(headers) && $jS1Yc.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $dab7521a8ea5ac3a$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("grG77"));
    else if (typeof $a8i8g !== "undefined" && Object.prototype.toString.call($a8i8g) === "[object process]") // For node use HTTP adapter
    adapter = (parcelRequire("grG77"));
    return adapter;
}
function $dab7521a8ea5ac3a$var$stringifySafely(rawValue, parser, encoder) {
    if ($jS1Yc.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $jS1Yc.trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}

var $dab7521a8ea5ac3a$var$defaults = {
    transitional: $k4ieG,
    adapter: $dab7521a8ea5ac3a$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $gGjFY(headers, "Accept");
            $gGjFY(headers, "Content-Type");
            if ($jS1Yc.isFormData(data) || $jS1Yc.isArrayBuffer(data) || $jS1Yc.isBuffer(data) || $jS1Yc.isStream(data) || $jS1Yc.isFile(data) || $jS1Yc.isBlob(data)) return data;
            if ($jS1Yc.isArrayBufferView(data)) return data.buffer;
            if ($jS1Yc.isURLSearchParams(data)) {
                $dab7521a8ea5ac3a$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            var isObjectPayload = $jS1Yc.isObject(data);
            var contentType = headers && headers["Content-Type"];
            var isFileList;
            if ((isFileList = $jS1Yc.isFileList(data)) || isObjectPayload && contentType === "multipart/form-data") {
                var _FormData = this.env && this.env.FormData;
                return $4moAL(isFileList ? {
                    "files[]": data
                } : data, _FormData && new _FormData());
            } else if (isObjectPayload || contentType === "application/json") {
                $dab7521a8ea5ac3a$var$setContentTypeIfUnset(headers, "application/json");
                return $dab7521a8ea5ac3a$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || $dab7521a8ea5ac3a$var$defaults.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
            if (strictJSONParsing || forcedJSONParsing && $jS1Yc.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === "SyntaxError") throw $5yBRP.from(e, $5yBRP.ERR_BAD_RESPONSE, this, null, this.response);
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (parcelRequire("8ywDf"))
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*"
        }
    }
};
$jS1Yc.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $dab7521a8ea5ac3a$var$defaults.headers[method] = {};
});
$jS1Yc.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $dab7521a8ea5ac3a$var$defaults.headers[method] = $jS1Yc.merge($dab7521a8ea5ac3a$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $dab7521a8ea5ac3a$var$defaults;

});
parcelRegister("gGjFY", function(module, exports) {
"use strict";

var $jS1Yc = parcelRequire("jS1Yc");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $jS1Yc.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("5yBRP", function(module, exports) {
"use strict";

var $jS1Yc = parcelRequire("jS1Yc");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ function $40bd8056a0d94d91$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
$jS1Yc.inherits($40bd8056a0d94d91$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
var $40bd8056a0d94d91$var$prototype = $40bd8056a0d94d91$var$AxiosError.prototype;
var $40bd8056a0d94d91$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED"
].forEach(function(code) {
    $40bd8056a0d94d91$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($40bd8056a0d94d91$var$AxiosError, $40bd8056a0d94d91$var$descriptors);
Object.defineProperty($40bd8056a0d94d91$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$40bd8056a0d94d91$var$AxiosError.from = function(error, code, config, request, response, customProps) {
    var axiosError = Object.create($40bd8056a0d94d91$var$prototype);
    $jS1Yc.toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    });
    $40bd8056a0d94d91$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
module.exports = $40bd8056a0d94d91$var$AxiosError;

});

parcelRegister("k4ieG", function(module, exports) {
"use strict";
module.exports = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRegister("4moAL", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $32cc4aef1b763a28$require$Buffer = $gzLuY.Buffer;
"use strict";

var $jS1Yc = parcelRequire("jS1Yc");
/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @returns {Object}
 **/ function $32cc4aef1b763a28$var$toFormData(obj, formData) {
    // eslint-disable-next-line no-param-reassign
    formData = formData || new FormData();
    var stack = [];
    function convertValue(value) {
        if (value === null) return "";
        if ($jS1Yc.isDate(value)) return value.toISOString();
        if ($jS1Yc.isArrayBuffer(value) || $jS1Yc.isTypedArray(value)) return typeof Blob === "function" ? new Blob([
            value
        ]) : $32cc4aef1b763a28$require$Buffer.from(value);
        return value;
    }
    function build(data, parentKey) {
        if ($jS1Yc.isPlainObject(data) || $jS1Yc.isArray(data)) {
            if (stack.indexOf(data) !== -1) throw Error("Circular reference detected in " + parentKey);
            stack.push(data);
            $jS1Yc.forEach(data, function each(value, key) {
                if ($jS1Yc.isUndefined(value)) return;
                var fullKey = parentKey ? parentKey + "." + key : key;
                var arr;
                if (value && !parentKey && typeof value === "object") {
                    if ($jS1Yc.endsWith(key, "{}")) // eslint-disable-next-line no-param-reassign
                    value = JSON.stringify(value);
                    else if ($jS1Yc.endsWith(key, "[]") && (arr = $jS1Yc.toArray(value))) {
                        // eslint-disable-next-line func-names
                        arr.forEach(function(el) {
                            !$jS1Yc.isUndefined(el) && formData.append(fullKey, convertValue(el));
                        });
                        return;
                    }
                }
                build(value, fullKey);
            });
            stack.pop();
        } else formData.append(parentKey, convertValue(data));
    }
    build(obj);
    return formData;
}
module.exports = $32cc4aef1b763a28$var$toFormData;

});

parcelRegister("grG77", function(module, exports) {
"use strict";

var $jS1Yc = parcelRequire("jS1Yc");

var $88YSP = parcelRequire("88YSP");

var $3lhDv = parcelRequire("3lhDv");

var $kIXV7 = parcelRequire("kIXV7");

var $b9VcG = parcelRequire("b9VcG");

var $cjm0S = parcelRequire("cjm0S");

var $6fqzZ = parcelRequire("6fqzZ");

var $k4ieG = parcelRequire("k4ieG");

var $5yBRP = parcelRequire("5yBRP");

var $4ltuv = parcelRequire("4ltuv");

var $4SxwP = parcelRequire("4SxwP");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        if ($jS1Yc.isFormData(requestData) && $jS1Yc.isStandardBrowserEnv()) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = $b9VcG(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $kIXV7(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $cjm0S(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $88YSP(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new $5yBRP("Request aborted", $5yBRP.ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new $5yBRP("Network Error", $5yBRP.ERR_NETWORK, config, request, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            var transitional = config.transitional || $k4ieG;
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new $5yBRP(timeoutErrorMessage, transitional.clarifyTimeoutError ? $5yBRP.ETIMEDOUT : $5yBRP.ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($jS1Yc.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $6fqzZ(fullPath)) && config.xsrfCookieName ? $3lhDv.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $jS1Yc.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$jS1Yc.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function(cancel) {
                if (!request) return;
                reject(!cancel || cancel && cancel.type ? new $4ltuv() : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        if (!requestData) requestData = null;
        var protocol = $4SxwP(fullPath);
        if (protocol && [
            "http",
            "https",
            "file"
        ].indexOf(protocol) === -1) {
            reject(new $5yBRP("Unsupported protocol " + protocol + ":", $5yBRP.ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("88YSP", function(module, exports) {
"use strict";

var $5yBRP = parcelRequire("5yBRP");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new $5yBRP("Request failed with status code " + response.status, [
        $5yBRP.ERR_BAD_REQUEST,
        $5yBRP.ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
};

});

parcelRegister("3lhDv", function(module, exports) {
"use strict";

var $jS1Yc = parcelRequire("jS1Yc");
module.exports = $jS1Yc.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($jS1Yc.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($jS1Yc.isString(path)) cookie.push("path=" + path);
            if ($jS1Yc.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("b9VcG", function(module, exports) {
"use strict";

var $4ypQ2 = parcelRequire("4ypQ2");

var $fD54T = parcelRequire("fD54T");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$4ypQ2(requestedURL)) return $fD54T(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("4ypQ2", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};

});

parcelRegister("fD54T", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});


parcelRegister("cjm0S", function(module, exports) {
"use strict";

var $jS1Yc = parcelRequire("jS1Yc");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $8f6855c04f8c150a$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $jS1Yc.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $jS1Yc.trim(line.substr(0, i)).toLowerCase();
        val = $jS1Yc.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $8f6855c04f8c150a$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("6fqzZ", function(module, exports) {
"use strict";

var $jS1Yc = parcelRequire("jS1Yc");
module.exports = $jS1Yc.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $jS1Yc.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("4ltuv", function(module, exports) {
"use strict";

var $5yBRP = parcelRequire("5yBRP");

var $jS1Yc = parcelRequire("jS1Yc");
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $329fffe09987fb27$var$CanceledError(message) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    $5yBRP.call(this, message == null ? "canceled" : message, $5yBRP.ERR_CANCELED);
    this.name = "CanceledError";
}
$jS1Yc.inherits($329fffe09987fb27$var$CanceledError, $5yBRP, {
    __CANCEL__: true
});
module.exports = $329fffe09987fb27$var$CanceledError;

});

parcelRegister("4SxwP", function(module, exports) {
"use strict";
module.exports = function parseProtocol(url) {
    var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
};

});


parcelRegister("8ywDf", function(module, exports) {
// eslint-disable-next-line strict
module.exports = null;

});



parcelRegister("DcSua", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRegister("bHMeL", function(module, exports) {
"use strict";

var $jS1Yc = parcelRequire("jS1Yc");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    function getMergedValue(target, source) {
        if ($jS1Yc.isPlainObject(target) && $jS1Yc.isPlainObject(source)) return $jS1Yc.merge(target, source);
        else if ($jS1Yc.isPlainObject(source)) return $jS1Yc.merge({}, source);
        else if ($jS1Yc.isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(prop) {
        if (!$jS1Yc.isUndefined(config2[prop])) return getMergedValue(config1[prop], config2[prop]);
        else if (!$jS1Yc.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(prop) {
        if (!$jS1Yc.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(prop) {
        if (!$jS1Yc.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
        else if (!$jS1Yc.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(prop) {
        if (prop in config2) return getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) return getMergedValue(undefined, config1[prop]);
    }
    var mergeMap = {
        "url": valueFromConfig2,
        "method": valueFromConfig2,
        "data": valueFromConfig2,
        "baseURL": defaultToConfig2,
        "transformRequest": defaultToConfig2,
        "transformResponse": defaultToConfig2,
        "paramsSerializer": defaultToConfig2,
        "timeout": defaultToConfig2,
        "timeoutMessage": defaultToConfig2,
        "withCredentials": defaultToConfig2,
        "adapter": defaultToConfig2,
        "responseType": defaultToConfig2,
        "xsrfCookieName": defaultToConfig2,
        "xsrfHeaderName": defaultToConfig2,
        "onUploadProgress": defaultToConfig2,
        "onDownloadProgress": defaultToConfig2,
        "decompress": defaultToConfig2,
        "maxContentLength": defaultToConfig2,
        "maxBodyLength": defaultToConfig2,
        "beforeRedirect": defaultToConfig2,
        "transport": defaultToConfig2,
        "httpAgent": defaultToConfig2,
        "httpsAgent": defaultToConfig2,
        "cancelToken": defaultToConfig2,
        "socketPath": defaultToConfig2,
        "responseEncoding": defaultToConfig2,
        "validateStatus": mergeDirectKeys
    };
    $jS1Yc.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        $jS1Yc.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
};

});

parcelRegister("hw4Ol", function(module, exports) {
"use strict";

var $dmTUs = parcelRequire("dmTUs");
var $cc0928354f786652$require$VERSION = $dmTUs.version;

var $5yBRP = parcelRequire("5yBRP");
var $cc0928354f786652$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach(function(type, i) {
    $cc0928354f786652$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
var $cc0928354f786652$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */ $cc0928354f786652$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + $cc0928354f786652$require$VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new $5yBRP(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), $5yBRP.ERR_DEPRECATED);
        if (version && !$cc0928354f786652$var$deprecatedWarnings[opt]) {
            $cc0928354f786652$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $cc0928354f786652$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new $5yBRP("options must be an object", $5yBRP.ERR_BAD_OPTION_VALUE);
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new $5yBRP("option " + opt + " must be " + result, $5yBRP.ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new $5yBRP("Unknown option " + opt, $5yBRP.ERR_BAD_OPTION);
    }
}
module.exports = {
    assertOptions: $cc0928354f786652$var$assertOptions,
    validators: $cc0928354f786652$var$validators
};

});
parcelRegister("dmTUs", function(module, exports) {
module.exports = {
    "version": "0.27.2"
};

});



parcelRegister("kkqEe", function(module, exports) {
"use strict";

var $4ltuv = parcelRequire("4ltuv");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $ecca58a56fec04b9$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    // eslint-disable-next-line func-names
    this.promise.then(function(cancel) {
        if (!token._listeners) return;
        var i;
        var l = token._listeners.length;
        for(i = 0; i < l; i++)token._listeners[i](cancel);
        token._listeners = null;
    });
    // eslint-disable-next-line func-names
    this.promise.then = function(onfulfilled) {
        var _resolve;
        // eslint-disable-next-line func-names
        var promise = new Promise(function(resolve) {
            token.subscribe(resolve);
            _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
            token.unsubscribe(_resolve);
        };
        return promise;
    };
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $4ltuv(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `CanceledError` if cancellation has been requested.
 */ $ecca58a56fec04b9$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Subscribe to the cancel signal
 */ $ecca58a56fec04b9$var$CancelToken.prototype.subscribe = function subscribe(listener) {
    if (this.reason) {
        listener(this.reason);
        return;
    }
    if (this._listeners) this._listeners.push(listener);
    else this._listeners = [
        listener
    ];
};
/**
 * Unsubscribe from the cancel signal
 */ $ecca58a56fec04b9$var$CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
    if (!this._listeners) return;
    var index = this._listeners.indexOf(listener);
    if (index !== -1) this._listeners.splice(index, 1);
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $ecca58a56fec04b9$var$CancelToken.source = function source() {
    var cancel;
    var token = new $ecca58a56fec04b9$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $ecca58a56fec04b9$var$CancelToken;

});

parcelRegister("luFaY", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("fuUwd", function(module, exports) {
"use strict";

var $jS1Yc = parcelRequire("jS1Yc");
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return $jS1Yc.isObject(payload) && payload.isAxiosError === true;
};

});



parcelRegister("bQI3U", function(module, exports) {
"use strict";
var $8a06badc9d9ae579$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GrpcWebImpl = module.exports.ServiceGetBlockWithTxsDesc = module.exports.ServiceGetTxsEventDesc = module.exports.ServiceBroadcastTxDesc = module.exports.ServiceGetTxDesc = module.exports.ServiceSimulateDesc = module.exports.ServiceDesc = module.exports.ServiceClientImpl = module.exports.GetBlockWithTxsResponse = module.exports.GetBlockWithTxsRequest = module.exports.GetTxResponse = module.exports.GetTxRequest = module.exports.SimulateResponse = module.exports.SimulateRequest = module.exports.BroadcastTxResponse = module.exports.BroadcastTxRequest = module.exports.GetTxsEventResponse = module.exports.GetTxsEventRequest = module.exports.broadcastModeToJSON = module.exports.broadcastModeFromJSON = module.exports.BroadcastMode = module.exports.orderByToJSON = module.exports.orderByFromJSON = module.exports.OrderBy = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $8a06badc9d9ae579$var$long_1 = $8a06badc9d9ae579$var$__importDefault((parcelRequire("9A55m")));

var $jXVni = parcelRequire("jXVni");

const $8a06badc9d9ae579$var$minimal_1 = $8a06badc9d9ae579$var$__importDefault((parcelRequire("i2pIU")));

var $7LVwv = parcelRequire("7LVwv");

var $hXPXf = parcelRequire("hXPXf");

var $fSXAC = parcelRequire("fSXAC");

var $djDW6 = parcelRequire("djDW6");

var $dYjix = parcelRequire("dYjix");

var $1pqjL = parcelRequire("1pqjL");
module.exports.protobufPackage = "cosmos.tx.v1beta1";
/** OrderBy defines the sorting order */ var $8a06badc9d9ae579$var$OrderBy;
(function(OrderBy) {
    /** ORDER_BY_UNSPECIFIED - ORDER_BY_UNSPECIFIED specifies an unknown sorting order. OrderBy defaults to ASC in this case. */ OrderBy[OrderBy["ORDER_BY_UNSPECIFIED"] = 0] = "ORDER_BY_UNSPECIFIED";
    /** ORDER_BY_ASC - ORDER_BY_ASC defines ascending order */ OrderBy[OrderBy["ORDER_BY_ASC"] = 1] = "ORDER_BY_ASC";
    /** ORDER_BY_DESC - ORDER_BY_DESC defines descending order */ OrderBy[OrderBy["ORDER_BY_DESC"] = 2] = "ORDER_BY_DESC";
    OrderBy[OrderBy["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($8a06badc9d9ae579$var$OrderBy = module.exports.OrderBy || (module.exports.OrderBy = {}));
function $8a06badc9d9ae579$var$orderByFromJSON(object) {
    switch(object){
        case 0:
        case "ORDER_BY_UNSPECIFIED":
            return $8a06badc9d9ae579$var$OrderBy.ORDER_BY_UNSPECIFIED;
        case 1:
        case "ORDER_BY_ASC":
            return $8a06badc9d9ae579$var$OrderBy.ORDER_BY_ASC;
        case 2:
        case "ORDER_BY_DESC":
            return $8a06badc9d9ae579$var$OrderBy.ORDER_BY_DESC;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $8a06badc9d9ae579$var$OrderBy.UNRECOGNIZED;
    }
}
module.exports.orderByFromJSON = $8a06badc9d9ae579$var$orderByFromJSON;
function $8a06badc9d9ae579$var$orderByToJSON(object) {
    switch(object){
        case $8a06badc9d9ae579$var$OrderBy.ORDER_BY_UNSPECIFIED:
            return "ORDER_BY_UNSPECIFIED";
        case $8a06badc9d9ae579$var$OrderBy.ORDER_BY_ASC:
            return "ORDER_BY_ASC";
        case $8a06badc9d9ae579$var$OrderBy.ORDER_BY_DESC:
            return "ORDER_BY_DESC";
        default:
            return "UNKNOWN";
    }
}
module.exports.orderByToJSON = $8a06badc9d9ae579$var$orderByToJSON;
/** BroadcastMode specifies the broadcast mode for the TxService.Broadcast RPC method. */ var $8a06badc9d9ae579$var$BroadcastMode;
(function(BroadcastMode) {
    /** BROADCAST_MODE_UNSPECIFIED - zero-value for mode ordering */ BroadcastMode[BroadcastMode["BROADCAST_MODE_UNSPECIFIED"] = 0] = "BROADCAST_MODE_UNSPECIFIED";
    /**
     * BROADCAST_MODE_BLOCK - BROADCAST_MODE_BLOCK defines a tx broadcasting mode where the client waits for
     * the tx to be committed in a block.
     */ BroadcastMode[BroadcastMode["BROADCAST_MODE_BLOCK"] = 1] = "BROADCAST_MODE_BLOCK";
    /**
     * BROADCAST_MODE_SYNC - BROADCAST_MODE_SYNC defines a tx broadcasting mode where the client waits for
     * a CheckTx execution response only.
     */ BroadcastMode[BroadcastMode["BROADCAST_MODE_SYNC"] = 2] = "BROADCAST_MODE_SYNC";
    /**
     * BROADCAST_MODE_ASYNC - BROADCAST_MODE_ASYNC defines a tx broadcasting mode where the client returns
     * immediately.
     */ BroadcastMode[BroadcastMode["BROADCAST_MODE_ASYNC"] = 3] = "BROADCAST_MODE_ASYNC";
    BroadcastMode[BroadcastMode["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($8a06badc9d9ae579$var$BroadcastMode = module.exports.BroadcastMode || (module.exports.BroadcastMode = {}));
function $8a06badc9d9ae579$var$broadcastModeFromJSON(object) {
    switch(object){
        case 0:
        case "BROADCAST_MODE_UNSPECIFIED":
            return $8a06badc9d9ae579$var$BroadcastMode.BROADCAST_MODE_UNSPECIFIED;
        case 1:
        case "BROADCAST_MODE_BLOCK":
            return $8a06badc9d9ae579$var$BroadcastMode.BROADCAST_MODE_BLOCK;
        case 2:
        case "BROADCAST_MODE_SYNC":
            return $8a06badc9d9ae579$var$BroadcastMode.BROADCAST_MODE_SYNC;
        case 3:
        case "BROADCAST_MODE_ASYNC":
            return $8a06badc9d9ae579$var$BroadcastMode.BROADCAST_MODE_ASYNC;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $8a06badc9d9ae579$var$BroadcastMode.UNRECOGNIZED;
    }
}
module.exports.broadcastModeFromJSON = $8a06badc9d9ae579$var$broadcastModeFromJSON;
function $8a06badc9d9ae579$var$broadcastModeToJSON(object) {
    switch(object){
        case $8a06badc9d9ae579$var$BroadcastMode.BROADCAST_MODE_UNSPECIFIED:
            return "BROADCAST_MODE_UNSPECIFIED";
        case $8a06badc9d9ae579$var$BroadcastMode.BROADCAST_MODE_BLOCK:
            return "BROADCAST_MODE_BLOCK";
        case $8a06badc9d9ae579$var$BroadcastMode.BROADCAST_MODE_SYNC:
            return "BROADCAST_MODE_SYNC";
        case $8a06badc9d9ae579$var$BroadcastMode.BROADCAST_MODE_ASYNC:
            return "BROADCAST_MODE_ASYNC";
        default:
            return "UNKNOWN";
    }
}
module.exports.broadcastModeToJSON = $8a06badc9d9ae579$var$broadcastModeToJSON;
const $8a06badc9d9ae579$var$baseGetTxsEventRequest = {
    events: "",
    orderBy: 0
};
module.exports.GetTxsEventRequest = {
    encode (message, writer = $8a06badc9d9ae579$var$minimal_1.default.Writer.create()) {
        for (const v of message.events)writer.uint32(10).string(v);
        if (message.pagination !== undefined) $7LVwv.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        if (message.orderBy !== 0) writer.uint32(24).int32(message.orderBy);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8a06badc9d9ae579$var$minimal_1.default.Reader ? input : new $8a06badc9d9ae579$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $8a06badc9d9ae579$var$baseGetTxsEventRequest);
        message.events = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.events.push(reader.string());
                    break;
                case 2:
                    message.pagination = $7LVwv.PageRequest.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.orderBy = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $8a06badc9d9ae579$var$baseGetTxsEventRequest);
        message.events = [];
        if (object.events !== undefined && object.events !== null) for (const e of object.events)message.events.push(String(e));
        if (object.pagination !== undefined && object.pagination !== null) message.pagination = $7LVwv.PageRequest.fromJSON(object.pagination);
        else message.pagination = undefined;
        if (object.orderBy !== undefined && object.orderBy !== null) message.orderBy = $8a06badc9d9ae579$var$orderByFromJSON(object.orderBy);
        else message.orderBy = 0;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.events) obj.events = message.events.map((e)=>e);
        else obj.events = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $7LVwv.PageRequest.toJSON(message.pagination) : undefined);
        message.orderBy !== undefined && (obj.orderBy = $8a06badc9d9ae579$var$orderByToJSON(message.orderBy));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $8a06badc9d9ae579$var$baseGetTxsEventRequest);
        message.events = [];
        if (object.events !== undefined && object.events !== null) for (const e of object.events)message.events.push(e);
        if (object.pagination !== undefined && object.pagination !== null) message.pagination = $7LVwv.PageRequest.fromPartial(object.pagination);
        else message.pagination = undefined;
        if (object.orderBy !== undefined && object.orderBy !== null) message.orderBy = object.orderBy;
        else message.orderBy = 0;
        return message;
    }
};
const $8a06badc9d9ae579$var$baseGetTxsEventResponse = {};
module.exports.GetTxsEventResponse = {
    encode (message, writer = $8a06badc9d9ae579$var$minimal_1.default.Writer.create()) {
        for (const v of message.txs)$fSXAC.Tx.encode(v, writer.uint32(10).fork()).ldelim();
        for (const v of message.txResponses)$hXPXf.TxResponse.encode(v, writer.uint32(18).fork()).ldelim();
        if (message.pagination !== undefined) $7LVwv.PageResponse.encode(message.pagination, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8a06badc9d9ae579$var$minimal_1.default.Reader ? input : new $8a06badc9d9ae579$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $8a06badc9d9ae579$var$baseGetTxsEventResponse);
        message.txs = [];
        message.txResponses = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txs.push($fSXAC.Tx.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.txResponses.push($hXPXf.TxResponse.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.pagination = $7LVwv.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $8a06badc9d9ae579$var$baseGetTxsEventResponse);
        message.txs = [];
        message.txResponses = [];
        if (object.txs !== undefined && object.txs !== null) for (const e of object.txs)message.txs.push($fSXAC.Tx.fromJSON(e));
        if (object.txResponses !== undefined && object.txResponses !== null) for (const e of object.txResponses)message.txResponses.push($hXPXf.TxResponse.fromJSON(e));
        if (object.pagination !== undefined && object.pagination !== null) message.pagination = $7LVwv.PageResponse.fromJSON(object.pagination);
        else message.pagination = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.txs) obj.txs = message.txs.map((e)=>e ? $fSXAC.Tx.toJSON(e) : undefined);
        else obj.txs = [];
        if (message.txResponses) obj.txResponses = message.txResponses.map((e)=>e ? $hXPXf.TxResponse.toJSON(e) : undefined);
        else obj.txResponses = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $7LVwv.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $8a06badc9d9ae579$var$baseGetTxsEventResponse);
        message.txs = [];
        message.txResponses = [];
        if (object.txs !== undefined && object.txs !== null) for (const e of object.txs)message.txs.push($fSXAC.Tx.fromPartial(e));
        if (object.txResponses !== undefined && object.txResponses !== null) for (const e of object.txResponses)message.txResponses.push($hXPXf.TxResponse.fromPartial(e));
        if (object.pagination !== undefined && object.pagination !== null) message.pagination = $7LVwv.PageResponse.fromPartial(object.pagination);
        else message.pagination = undefined;
        return message;
    }
};
const $8a06badc9d9ae579$var$baseBroadcastTxRequest = {
    mode: 0
};
module.exports.BroadcastTxRequest = {
    encode (message, writer = $8a06badc9d9ae579$var$minimal_1.default.Writer.create()) {
        if (message.txBytes.length !== 0) writer.uint32(10).bytes(message.txBytes);
        if (message.mode !== 0) writer.uint32(16).int32(message.mode);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8a06badc9d9ae579$var$minimal_1.default.Reader ? input : new $8a06badc9d9ae579$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $8a06badc9d9ae579$var$baseBroadcastTxRequest);
        message.txBytes = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txBytes = reader.bytes();
                    break;
                case 2:
                    message.mode = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $8a06badc9d9ae579$var$baseBroadcastTxRequest);
        message.txBytes = new Uint8Array();
        if (object.txBytes !== undefined && object.txBytes !== null) message.txBytes = $8a06badc9d9ae579$var$bytesFromBase64(object.txBytes);
        if (object.mode !== undefined && object.mode !== null) message.mode = $8a06badc9d9ae579$var$broadcastModeFromJSON(object.mode);
        else message.mode = 0;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.txBytes !== undefined && (obj.txBytes = $8a06badc9d9ae579$var$base64FromBytes(message.txBytes !== undefined ? message.txBytes : new Uint8Array()));
        message.mode !== undefined && (obj.mode = $8a06badc9d9ae579$var$broadcastModeToJSON(message.mode));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $8a06badc9d9ae579$var$baseBroadcastTxRequest);
        if (object.txBytes !== undefined && object.txBytes !== null) message.txBytes = object.txBytes;
        else message.txBytes = new Uint8Array();
        if (object.mode !== undefined && object.mode !== null) message.mode = object.mode;
        else message.mode = 0;
        return message;
    }
};
const $8a06badc9d9ae579$var$baseBroadcastTxResponse = {};
module.exports.BroadcastTxResponse = {
    encode (message, writer = $8a06badc9d9ae579$var$minimal_1.default.Writer.create()) {
        if (message.txResponse !== undefined) $hXPXf.TxResponse.encode(message.txResponse, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8a06badc9d9ae579$var$minimal_1.default.Reader ? input : new $8a06badc9d9ae579$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $8a06badc9d9ae579$var$baseBroadcastTxResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txResponse = $hXPXf.TxResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $8a06badc9d9ae579$var$baseBroadcastTxResponse);
        if (object.txResponse !== undefined && object.txResponse !== null) message.txResponse = $hXPXf.TxResponse.fromJSON(object.txResponse);
        else message.txResponse = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.txResponse !== undefined && (obj.txResponse = message.txResponse ? $hXPXf.TxResponse.toJSON(message.txResponse) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $8a06badc9d9ae579$var$baseBroadcastTxResponse);
        if (object.txResponse !== undefined && object.txResponse !== null) message.txResponse = $hXPXf.TxResponse.fromPartial(object.txResponse);
        else message.txResponse = undefined;
        return message;
    }
};
const $8a06badc9d9ae579$var$baseSimulateRequest = {};
module.exports.SimulateRequest = {
    encode (message, writer = $8a06badc9d9ae579$var$minimal_1.default.Writer.create()) {
        if (message.tx !== undefined) $fSXAC.Tx.encode(message.tx, writer.uint32(10).fork()).ldelim();
        if (message.txBytes.length !== 0) writer.uint32(18).bytes(message.txBytes);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8a06badc9d9ae579$var$minimal_1.default.Reader ? input : new $8a06badc9d9ae579$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $8a06badc9d9ae579$var$baseSimulateRequest);
        message.txBytes = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.tx = $fSXAC.Tx.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.txBytes = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $8a06badc9d9ae579$var$baseSimulateRequest);
        message.txBytes = new Uint8Array();
        if (object.tx !== undefined && object.tx !== null) message.tx = $fSXAC.Tx.fromJSON(object.tx);
        else message.tx = undefined;
        if (object.txBytes !== undefined && object.txBytes !== null) message.txBytes = $8a06badc9d9ae579$var$bytesFromBase64(object.txBytes);
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.tx !== undefined && (obj.tx = message.tx ? $fSXAC.Tx.toJSON(message.tx) : undefined);
        message.txBytes !== undefined && (obj.txBytes = $8a06badc9d9ae579$var$base64FromBytes(message.txBytes !== undefined ? message.txBytes : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $8a06badc9d9ae579$var$baseSimulateRequest);
        if (object.tx !== undefined && object.tx !== null) message.tx = $fSXAC.Tx.fromPartial(object.tx);
        else message.tx = undefined;
        if (object.txBytes !== undefined && object.txBytes !== null) message.txBytes = object.txBytes;
        else message.txBytes = new Uint8Array();
        return message;
    }
};
const $8a06badc9d9ae579$var$baseSimulateResponse = {};
module.exports.SimulateResponse = {
    encode (message, writer = $8a06badc9d9ae579$var$minimal_1.default.Writer.create()) {
        if (message.gasInfo !== undefined) $hXPXf.GasInfo.encode(message.gasInfo, writer.uint32(10).fork()).ldelim();
        if (message.result !== undefined) $hXPXf.Result.encode(message.result, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8a06badc9d9ae579$var$minimal_1.default.Reader ? input : new $8a06badc9d9ae579$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $8a06badc9d9ae579$var$baseSimulateResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.gasInfo = $hXPXf.GasInfo.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.result = $hXPXf.Result.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $8a06badc9d9ae579$var$baseSimulateResponse);
        if (object.gasInfo !== undefined && object.gasInfo !== null) message.gasInfo = $hXPXf.GasInfo.fromJSON(object.gasInfo);
        else message.gasInfo = undefined;
        if (object.result !== undefined && object.result !== null) message.result = $hXPXf.Result.fromJSON(object.result);
        else message.result = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.gasInfo !== undefined && (obj.gasInfo = message.gasInfo ? $hXPXf.GasInfo.toJSON(message.gasInfo) : undefined);
        message.result !== undefined && (obj.result = message.result ? $hXPXf.Result.toJSON(message.result) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $8a06badc9d9ae579$var$baseSimulateResponse);
        if (object.gasInfo !== undefined && object.gasInfo !== null) message.gasInfo = $hXPXf.GasInfo.fromPartial(object.gasInfo);
        else message.gasInfo = undefined;
        if (object.result !== undefined && object.result !== null) message.result = $hXPXf.Result.fromPartial(object.result);
        else message.result = undefined;
        return message;
    }
};
const $8a06badc9d9ae579$var$baseGetTxRequest = {
    hash: ""
};
module.exports.GetTxRequest = {
    encode (message, writer = $8a06badc9d9ae579$var$minimal_1.default.Writer.create()) {
        if (message.hash !== "") writer.uint32(10).string(message.hash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8a06badc9d9ae579$var$minimal_1.default.Reader ? input : new $8a06badc9d9ae579$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $8a06badc9d9ae579$var$baseGetTxRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $8a06badc9d9ae579$var$baseGetTxRequest);
        if (object.hash !== undefined && object.hash !== null) message.hash = String(object.hash);
        else message.hash = "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = message.hash);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $8a06badc9d9ae579$var$baseGetTxRequest);
        if (object.hash !== undefined && object.hash !== null) message.hash = object.hash;
        else message.hash = "";
        return message;
    }
};
const $8a06badc9d9ae579$var$baseGetTxResponse = {};
module.exports.GetTxResponse = {
    encode (message, writer = $8a06badc9d9ae579$var$minimal_1.default.Writer.create()) {
        if (message.tx !== undefined) $fSXAC.Tx.encode(message.tx, writer.uint32(10).fork()).ldelim();
        if (message.txResponse !== undefined) $hXPXf.TxResponse.encode(message.txResponse, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8a06badc9d9ae579$var$minimal_1.default.Reader ? input : new $8a06badc9d9ae579$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $8a06badc9d9ae579$var$baseGetTxResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.tx = $fSXAC.Tx.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.txResponse = $hXPXf.TxResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $8a06badc9d9ae579$var$baseGetTxResponse);
        if (object.tx !== undefined && object.tx !== null) message.tx = $fSXAC.Tx.fromJSON(object.tx);
        else message.tx = undefined;
        if (object.txResponse !== undefined && object.txResponse !== null) message.txResponse = $hXPXf.TxResponse.fromJSON(object.txResponse);
        else message.txResponse = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.tx !== undefined && (obj.tx = message.tx ? $fSXAC.Tx.toJSON(message.tx) : undefined);
        message.txResponse !== undefined && (obj.txResponse = message.txResponse ? $hXPXf.TxResponse.toJSON(message.txResponse) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $8a06badc9d9ae579$var$baseGetTxResponse);
        if (object.tx !== undefined && object.tx !== null) message.tx = $fSXAC.Tx.fromPartial(object.tx);
        else message.tx = undefined;
        if (object.txResponse !== undefined && object.txResponse !== null) message.txResponse = $hXPXf.TxResponse.fromPartial(object.txResponse);
        else message.txResponse = undefined;
        return message;
    }
};
const $8a06badc9d9ae579$var$baseGetBlockWithTxsRequest = {
    height: $8a06badc9d9ae579$var$long_1.default.ZERO
};
module.exports.GetBlockWithTxsRequest = {
    encode (message, writer = $8a06badc9d9ae579$var$minimal_1.default.Writer.create()) {
        if (!message.height.isZero()) writer.uint32(8).int64(message.height);
        if (message.pagination !== undefined) $7LVwv.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8a06badc9d9ae579$var$minimal_1.default.Reader ? input : new $8a06badc9d9ae579$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $8a06badc9d9ae579$var$baseGetBlockWithTxsRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.int64();
                    break;
                case 2:
                    message.pagination = $7LVwv.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $8a06badc9d9ae579$var$baseGetBlockWithTxsRequest);
        if (object.height !== undefined && object.height !== null) message.height = $8a06badc9d9ae579$var$long_1.default.fromString(object.height);
        else message.height = $8a06badc9d9ae579$var$long_1.default.ZERO;
        if (object.pagination !== undefined && object.pagination !== null) message.pagination = $7LVwv.PageRequest.fromJSON(object.pagination);
        else message.pagination = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || $8a06badc9d9ae579$var$long_1.default.ZERO).toString());
        message.pagination !== undefined && (obj.pagination = message.pagination ? $7LVwv.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $8a06badc9d9ae579$var$baseGetBlockWithTxsRequest);
        if (object.height !== undefined && object.height !== null) message.height = object.height;
        else message.height = $8a06badc9d9ae579$var$long_1.default.ZERO;
        if (object.pagination !== undefined && object.pagination !== null) message.pagination = $7LVwv.PageRequest.fromPartial(object.pagination);
        else message.pagination = undefined;
        return message;
    }
};
const $8a06badc9d9ae579$var$baseGetBlockWithTxsResponse = {};
module.exports.GetBlockWithTxsResponse = {
    encode (message, writer = $8a06badc9d9ae579$var$minimal_1.default.Writer.create()) {
        for (const v of message.txs)$fSXAC.Tx.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.blockId !== undefined) $djDW6.BlockID.encode(message.blockId, writer.uint32(18).fork()).ldelim();
        if (message.block !== undefined) $dYjix.Block.encode(message.block, writer.uint32(26).fork()).ldelim();
        if (message.pagination !== undefined) $7LVwv.PageResponse.encode(message.pagination, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8a06badc9d9ae579$var$minimal_1.default.Reader ? input : new $8a06badc9d9ae579$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $8a06badc9d9ae579$var$baseGetBlockWithTxsResponse);
        message.txs = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txs.push($fSXAC.Tx.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.blockId = $djDW6.BlockID.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.block = $dYjix.Block.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.pagination = $7LVwv.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $8a06badc9d9ae579$var$baseGetBlockWithTxsResponse);
        message.txs = [];
        if (object.txs !== undefined && object.txs !== null) for (const e of object.txs)message.txs.push($fSXAC.Tx.fromJSON(e));
        if (object.blockId !== undefined && object.blockId !== null) message.blockId = $djDW6.BlockID.fromJSON(object.blockId);
        else message.blockId = undefined;
        if (object.block !== undefined && object.block !== null) message.block = $dYjix.Block.fromJSON(object.block);
        else message.block = undefined;
        if (object.pagination !== undefined && object.pagination !== null) message.pagination = $7LVwv.PageResponse.fromJSON(object.pagination);
        else message.pagination = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.txs) obj.txs = message.txs.map((e)=>e ? $fSXAC.Tx.toJSON(e) : undefined);
        else obj.txs = [];
        message.blockId !== undefined && (obj.blockId = message.blockId ? $djDW6.BlockID.toJSON(message.blockId) : undefined);
        message.block !== undefined && (obj.block = message.block ? $dYjix.Block.toJSON(message.block) : undefined);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $7LVwv.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $8a06badc9d9ae579$var$baseGetBlockWithTxsResponse);
        message.txs = [];
        if (object.txs !== undefined && object.txs !== null) for (const e of object.txs)message.txs.push($fSXAC.Tx.fromPartial(e));
        if (object.blockId !== undefined && object.blockId !== null) message.blockId = $djDW6.BlockID.fromPartial(object.blockId);
        else message.blockId = undefined;
        if (object.block !== undefined && object.block !== null) message.block = $dYjix.Block.fromPartial(object.block);
        else message.block = undefined;
        if (object.pagination !== undefined && object.pagination !== null) message.pagination = $7LVwv.PageResponse.fromPartial(object.pagination);
        else message.pagination = undefined;
        return message;
    }
};
class $8a06badc9d9ae579$var$ServiceClientImpl {
    Simulate(request, metadata) {
        return this.rpc.unary(module.exports.ServiceSimulateDesc, module.exports.SimulateRequest.fromPartial(request), metadata);
    }
    GetTx(request, metadata) {
        return this.rpc.unary(module.exports.ServiceGetTxDesc, module.exports.GetTxRequest.fromPartial(request), metadata);
    }
    BroadcastTx(request, metadata) {
        return this.rpc.unary(module.exports.ServiceBroadcastTxDesc, module.exports.BroadcastTxRequest.fromPartial(request), metadata);
    }
    GetTxsEvent(request, metadata) {
        return this.rpc.unary(module.exports.ServiceGetTxsEventDesc, module.exports.GetTxsEventRequest.fromPartial(request), metadata);
    }
    GetBlockWithTxs(request, metadata) {
        return this.rpc.unary(module.exports.ServiceGetBlockWithTxsDesc, module.exports.GetBlockWithTxsRequest.fromPartial(request), metadata);
    }
    constructor(rpc){
        this.rpc = rpc;
        this.Simulate = this.Simulate.bind(this);
        this.GetTx = this.GetTx.bind(this);
        this.BroadcastTx = this.BroadcastTx.bind(this);
        this.GetTxsEvent = this.GetTxsEvent.bind(this);
        this.GetBlockWithTxs = this.GetBlockWithTxs.bind(this);
    }
}
module.exports.ServiceClientImpl = $8a06badc9d9ae579$var$ServiceClientImpl;
module.exports.ServiceDesc = {
    serviceName: "cosmos.tx.v1beta1.Service"
};
module.exports.ServiceSimulateDesc = {
    methodName: "Simulate",
    service: module.exports.ServiceDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.SimulateRequest.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.SimulateResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.ServiceGetTxDesc = {
    methodName: "GetTx",
    service: module.exports.ServiceDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.GetTxRequest.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.GetTxResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.ServiceBroadcastTxDesc = {
    methodName: "BroadcastTx",
    service: module.exports.ServiceDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.BroadcastTxRequest.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.BroadcastTxResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.ServiceGetTxsEventDesc = {
    methodName: "GetTxsEvent",
    service: module.exports.ServiceDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.GetTxsEventRequest.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.GetTxsEventResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
module.exports.ServiceGetBlockWithTxsDesc = {
    methodName: "GetBlockWithTxs",
    service: module.exports.ServiceDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary () {
            return module.exports.GetBlockWithTxsRequest.encode(this).finish();
        }
    },
    responseType: {
        deserializeBinary (data) {
            return Object.assign(Object.assign({}, module.exports.GetBlockWithTxsResponse.decode(data)), {
                toObject () {
                    return this;
                }
            });
        }
    }
};
class $8a06badc9d9ae579$var$GrpcWebImpl {
    unary(methodDesc, _request, metadata) {
        var _a;
        const request = Object.assign(Object.assign({}, _request), methodDesc.requestType);
        const maybeCombinedMetadata = metadata && this.options.metadata ? new $1pqjL.BrowserHeaders(Object.assign(Object.assign({}, (_a = this.options) === null || _a === void 0 ? void 0 : _a.metadata.headersMap), metadata === null || metadata === void 0 ? void 0 : metadata.headersMap)) : metadata || this.options.metadata;
        return new Promise((resolve, reject)=>{
            $jXVni.grpc.unary(methodDesc, {
                request: request,
                host: this.host,
                metadata: maybeCombinedMetadata,
                transport: this.options.transport,
                debug: this.options.debug,
                onEnd: function(response) {
                    if (response.status === $jXVni.grpc.Code.OK) resolve(response.message);
                    else {
                        const err = new Error(response.statusMessage);
                        err.code = response.status;
                        err.metadata = response.trailers;
                        reject(err);
                    }
                }
            });
        });
    }
    constructor(host, options){
        this.host = host;
        this.options = options;
    }
}
module.exports.GrpcWebImpl = $8a06badc9d9ae579$var$GrpcWebImpl;
var $8a06badc9d9ae579$var$globalThis = (()=>{
    if (typeof $8a06badc9d9ae579$var$globalThis !== "undefined") return $8a06badc9d9ae579$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $8a06badc9d9ae579$var$atob = $8a06badc9d9ae579$var$globalThis.atob || ((b64)=>$8a06badc9d9ae579$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $8a06badc9d9ae579$var$bytesFromBase64(b64) {
    const bin = $8a06badc9d9ae579$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $8a06badc9d9ae579$var$btoa = $8a06badc9d9ae579$var$globalThis.btoa || ((bin)=>$8a06badc9d9ae579$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $8a06badc9d9ae579$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $8a06badc9d9ae579$var$btoa(bin.join(""));
}
if ($8a06badc9d9ae579$var$minimal_1.default.util.Long !== $8a06badc9d9ae579$var$long_1.default) {
    $8a06badc9d9ae579$var$minimal_1.default.util.Long = $8a06badc9d9ae579$var$long_1.default;
    $8a06badc9d9ae579$var$minimal_1.default.configure();
}

});
parcelRegister("7LVwv", function(module, exports) {
"use strict";
var $5a898b1f02d0ed61$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PageResponse = module.exports.PageRequest = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $5a898b1f02d0ed61$var$long_1 = $5a898b1f02d0ed61$var$__importDefault((parcelRequire("9A55m")));

const $5a898b1f02d0ed61$var$minimal_1 = $5a898b1f02d0ed61$var$__importDefault((parcelRequire("i2pIU")));
module.exports.protobufPackage = "cosmos.base.query.v1beta1";
const $5a898b1f02d0ed61$var$basePageRequest = {
    offset: $5a898b1f02d0ed61$var$long_1.default.UZERO,
    limit: $5a898b1f02d0ed61$var$long_1.default.UZERO,
    countTotal: false,
    reverse: false
};
module.exports.PageRequest = {
    encode (message, writer = $5a898b1f02d0ed61$var$minimal_1.default.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (!message.offset.isZero()) writer.uint32(16).uint64(message.offset);
        if (!message.limit.isZero()) writer.uint32(24).uint64(message.limit);
        if (message.countTotal === true) writer.uint32(32).bool(message.countTotal);
        if (message.reverse === true) writer.uint32(40).bool(message.reverse);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5a898b1f02d0ed61$var$minimal_1.default.Reader ? input : new $5a898b1f02d0ed61$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $5a898b1f02d0ed61$var$basePageRequest);
        message.key = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.offset = reader.uint64();
                    break;
                case 3:
                    message.limit = reader.uint64();
                    break;
                case 4:
                    message.countTotal = reader.bool();
                    break;
                case 5:
                    message.reverse = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $5a898b1f02d0ed61$var$basePageRequest);
        message.key = new Uint8Array();
        if (object.key !== undefined && object.key !== null) message.key = $5a898b1f02d0ed61$var$bytesFromBase64(object.key);
        if (object.offset !== undefined && object.offset !== null) message.offset = $5a898b1f02d0ed61$var$long_1.default.fromString(object.offset);
        else message.offset = $5a898b1f02d0ed61$var$long_1.default.UZERO;
        if (object.limit !== undefined && object.limit !== null) message.limit = $5a898b1f02d0ed61$var$long_1.default.fromString(object.limit);
        else message.limit = $5a898b1f02d0ed61$var$long_1.default.UZERO;
        if (object.countTotal !== undefined && object.countTotal !== null) message.countTotal = Boolean(object.countTotal);
        else message.countTotal = false;
        if (object.reverse !== undefined && object.reverse !== null) message.reverse = Boolean(object.reverse);
        else message.reverse = false;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = $5a898b1f02d0ed61$var$base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        message.offset !== undefined && (obj.offset = (message.offset || $5a898b1f02d0ed61$var$long_1.default.UZERO).toString());
        message.limit !== undefined && (obj.limit = (message.limit || $5a898b1f02d0ed61$var$long_1.default.UZERO).toString());
        message.countTotal !== undefined && (obj.countTotal = message.countTotal);
        message.reverse !== undefined && (obj.reverse = message.reverse);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $5a898b1f02d0ed61$var$basePageRequest);
        if (object.key !== undefined && object.key !== null) message.key = object.key;
        else message.key = new Uint8Array();
        if (object.offset !== undefined && object.offset !== null) message.offset = object.offset;
        else message.offset = $5a898b1f02d0ed61$var$long_1.default.UZERO;
        if (object.limit !== undefined && object.limit !== null) message.limit = object.limit;
        else message.limit = $5a898b1f02d0ed61$var$long_1.default.UZERO;
        if (object.countTotal !== undefined && object.countTotal !== null) message.countTotal = object.countTotal;
        else message.countTotal = false;
        if (object.reverse !== undefined && object.reverse !== null) message.reverse = object.reverse;
        else message.reverse = false;
        return message;
    }
};
const $5a898b1f02d0ed61$var$basePageResponse = {
    total: $5a898b1f02d0ed61$var$long_1.default.UZERO
};
module.exports.PageResponse = {
    encode (message, writer = $5a898b1f02d0ed61$var$minimal_1.default.Writer.create()) {
        if (message.nextKey.length !== 0) writer.uint32(10).bytes(message.nextKey);
        if (!message.total.isZero()) writer.uint32(16).uint64(message.total);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5a898b1f02d0ed61$var$minimal_1.default.Reader ? input : new $5a898b1f02d0ed61$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $5a898b1f02d0ed61$var$basePageResponse);
        message.nextKey = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.nextKey = reader.bytes();
                    break;
                case 2:
                    message.total = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $5a898b1f02d0ed61$var$basePageResponse);
        message.nextKey = new Uint8Array();
        if (object.nextKey !== undefined && object.nextKey !== null) message.nextKey = $5a898b1f02d0ed61$var$bytesFromBase64(object.nextKey);
        if (object.total !== undefined && object.total !== null) message.total = $5a898b1f02d0ed61$var$long_1.default.fromString(object.total);
        else message.total = $5a898b1f02d0ed61$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.nextKey !== undefined && (obj.nextKey = $5a898b1f02d0ed61$var$base64FromBytes(message.nextKey !== undefined ? message.nextKey : new Uint8Array()));
        message.total !== undefined && (obj.total = (message.total || $5a898b1f02d0ed61$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $5a898b1f02d0ed61$var$basePageResponse);
        if (object.nextKey !== undefined && object.nextKey !== null) message.nextKey = object.nextKey;
        else message.nextKey = new Uint8Array();
        if (object.total !== undefined && object.total !== null) message.total = object.total;
        else message.total = $5a898b1f02d0ed61$var$long_1.default.UZERO;
        return message;
    }
};
var $5a898b1f02d0ed61$var$globalThis = (()=>{
    if (typeof $5a898b1f02d0ed61$var$globalThis !== "undefined") return $5a898b1f02d0ed61$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $5a898b1f02d0ed61$var$atob = $5a898b1f02d0ed61$var$globalThis.atob || ((b64)=>$5a898b1f02d0ed61$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $5a898b1f02d0ed61$var$bytesFromBase64(b64) {
    const bin = $5a898b1f02d0ed61$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $5a898b1f02d0ed61$var$btoa = $5a898b1f02d0ed61$var$globalThis.btoa || ((bin)=>$5a898b1f02d0ed61$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $5a898b1f02d0ed61$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $5a898b1f02d0ed61$var$btoa(bin.join(""));
}
if ($5a898b1f02d0ed61$var$minimal_1.default.util.Long !== $5a898b1f02d0ed61$var$long_1.default) {
    $5a898b1f02d0ed61$var$minimal_1.default.util.Long = $5a898b1f02d0ed61$var$long_1.default;
    $5a898b1f02d0ed61$var$minimal_1.default.configure();
}

});

parcelRegister("dYjix", function(module, exports) {
"use strict";
var $a2bfd920ec72ed88$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Block = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $a2bfd920ec72ed88$var$long_1 = $a2bfd920ec72ed88$var$__importDefault((parcelRequire("9A55m")));

const $a2bfd920ec72ed88$var$minimal_1 = $a2bfd920ec72ed88$var$__importDefault((parcelRequire("i2pIU")));

var $djDW6 = parcelRequire("djDW6");

var $fNGv3 = parcelRequire("fNGv3");
module.exports.protobufPackage = "tendermint.types";
const $a2bfd920ec72ed88$var$baseBlock = {};
module.exports.Block = {
    encode (message, writer = $a2bfd920ec72ed88$var$minimal_1.default.Writer.create()) {
        if (message.header !== undefined) $djDW6.Header.encode(message.header, writer.uint32(10).fork()).ldelim();
        if (message.data !== undefined) $djDW6.Data.encode(message.data, writer.uint32(18).fork()).ldelim();
        if (message.evidence !== undefined) $fNGv3.EvidenceList.encode(message.evidence, writer.uint32(26).fork()).ldelim();
        if (message.lastCommit !== undefined) $djDW6.Commit.encode(message.lastCommit, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a2bfd920ec72ed88$var$minimal_1.default.Reader ? input : new $a2bfd920ec72ed88$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $a2bfd920ec72ed88$var$baseBlock);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.header = $djDW6.Header.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.data = $djDW6.Data.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.evidence = $fNGv3.EvidenceList.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.lastCommit = $djDW6.Commit.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $a2bfd920ec72ed88$var$baseBlock);
        if (object.header !== undefined && object.header !== null) message.header = $djDW6.Header.fromJSON(object.header);
        else message.header = undefined;
        if (object.data !== undefined && object.data !== null) message.data = $djDW6.Data.fromJSON(object.data);
        else message.data = undefined;
        if (object.evidence !== undefined && object.evidence !== null) message.evidence = $fNGv3.EvidenceList.fromJSON(object.evidence);
        else message.evidence = undefined;
        if (object.lastCommit !== undefined && object.lastCommit !== null) message.lastCommit = $djDW6.Commit.fromJSON(object.lastCommit);
        else message.lastCommit = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.header !== undefined && (obj.header = message.header ? $djDW6.Header.toJSON(message.header) : undefined);
        message.data !== undefined && (obj.data = message.data ? $djDW6.Data.toJSON(message.data) : undefined);
        message.evidence !== undefined && (obj.evidence = message.evidence ? $fNGv3.EvidenceList.toJSON(message.evidence) : undefined);
        message.lastCommit !== undefined && (obj.lastCommit = message.lastCommit ? $djDW6.Commit.toJSON(message.lastCommit) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $a2bfd920ec72ed88$var$baseBlock);
        if (object.header !== undefined && object.header !== null) message.header = $djDW6.Header.fromPartial(object.header);
        else message.header = undefined;
        if (object.data !== undefined && object.data !== null) message.data = $djDW6.Data.fromPartial(object.data);
        else message.data = undefined;
        if (object.evidence !== undefined && object.evidence !== null) message.evidence = $fNGv3.EvidenceList.fromPartial(object.evidence);
        else message.evidence = undefined;
        if (object.lastCommit !== undefined && object.lastCommit !== null) message.lastCommit = $djDW6.Commit.fromPartial(object.lastCommit);
        else message.lastCommit = undefined;
        return message;
    }
};
if ($a2bfd920ec72ed88$var$minimal_1.default.util.Long !== $a2bfd920ec72ed88$var$long_1.default) {
    $a2bfd920ec72ed88$var$minimal_1.default.util.Long = $a2bfd920ec72ed88$var$long_1.default;
    $a2bfd920ec72ed88$var$minimal_1.default.configure();
}

});
parcelRegister("fNGv3", function(module, exports) {
"use strict";
var $b80c662ed5531f23$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EvidenceList = module.exports.LightClientAttackEvidence = module.exports.DuplicateVoteEvidence = module.exports.Evidence = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $b80c662ed5531f23$var$long_1 = $b80c662ed5531f23$var$__importDefault((parcelRequire("9A55m")));

const $b80c662ed5531f23$var$minimal_1 = $b80c662ed5531f23$var$__importDefault((parcelRequire("i2pIU")));

var $djDW6 = parcelRequire("djDW6");

var $5G2s6 = parcelRequire("5G2s6");

var $j77DS = parcelRequire("j77DS");
module.exports.protobufPackage = "tendermint.types";
const $b80c662ed5531f23$var$baseEvidence = {};
module.exports.Evidence = {
    encode (message, writer = $b80c662ed5531f23$var$minimal_1.default.Writer.create()) {
        if (message.duplicateVoteEvidence !== undefined) module.exports.DuplicateVoteEvidence.encode(message.duplicateVoteEvidence, writer.uint32(10).fork()).ldelim();
        if (message.lightClientAttackEvidence !== undefined) module.exports.LightClientAttackEvidence.encode(message.lightClientAttackEvidence, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b80c662ed5531f23$var$minimal_1.default.Reader ? input : new $b80c662ed5531f23$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b80c662ed5531f23$var$baseEvidence);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.duplicateVoteEvidence = module.exports.DuplicateVoteEvidence.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.lightClientAttackEvidence = module.exports.LightClientAttackEvidence.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $b80c662ed5531f23$var$baseEvidence);
        if (object.duplicateVoteEvidence !== undefined && object.duplicateVoteEvidence !== null) message.duplicateVoteEvidence = module.exports.DuplicateVoteEvidence.fromJSON(object.duplicateVoteEvidence);
        else message.duplicateVoteEvidence = undefined;
        if (object.lightClientAttackEvidence !== undefined && object.lightClientAttackEvidence !== null) message.lightClientAttackEvidence = module.exports.LightClientAttackEvidence.fromJSON(object.lightClientAttackEvidence);
        else message.lightClientAttackEvidence = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.duplicateVoteEvidence !== undefined && (obj.duplicateVoteEvidence = message.duplicateVoteEvidence ? module.exports.DuplicateVoteEvidence.toJSON(message.duplicateVoteEvidence) : undefined);
        message.lightClientAttackEvidence !== undefined && (obj.lightClientAttackEvidence = message.lightClientAttackEvidence ? module.exports.LightClientAttackEvidence.toJSON(message.lightClientAttackEvidence) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $b80c662ed5531f23$var$baseEvidence);
        if (object.duplicateVoteEvidence !== undefined && object.duplicateVoteEvidence !== null) message.duplicateVoteEvidence = module.exports.DuplicateVoteEvidence.fromPartial(object.duplicateVoteEvidence);
        else message.duplicateVoteEvidence = undefined;
        if (object.lightClientAttackEvidence !== undefined && object.lightClientAttackEvidence !== null) message.lightClientAttackEvidence = module.exports.LightClientAttackEvidence.fromPartial(object.lightClientAttackEvidence);
        else message.lightClientAttackEvidence = undefined;
        return message;
    }
};
const $b80c662ed5531f23$var$baseDuplicateVoteEvidence = {
    totalVotingPower: $b80c662ed5531f23$var$long_1.default.ZERO,
    validatorPower: $b80c662ed5531f23$var$long_1.default.ZERO
};
module.exports.DuplicateVoteEvidence = {
    encode (message, writer = $b80c662ed5531f23$var$minimal_1.default.Writer.create()) {
        if (message.voteA !== undefined) $djDW6.Vote.encode(message.voteA, writer.uint32(10).fork()).ldelim();
        if (message.voteB !== undefined) $djDW6.Vote.encode(message.voteB, writer.uint32(18).fork()).ldelim();
        if (!message.totalVotingPower.isZero()) writer.uint32(24).int64(message.totalVotingPower);
        if (!message.validatorPower.isZero()) writer.uint32(32).int64(message.validatorPower);
        if (message.timestamp !== undefined) $5G2s6.Timestamp.encode($b80c662ed5531f23$var$toTimestamp(message.timestamp), writer.uint32(42).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b80c662ed5531f23$var$minimal_1.default.Reader ? input : new $b80c662ed5531f23$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b80c662ed5531f23$var$baseDuplicateVoteEvidence);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.voteA = $djDW6.Vote.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.voteB = $djDW6.Vote.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.totalVotingPower = reader.int64();
                    break;
                case 4:
                    message.validatorPower = reader.int64();
                    break;
                case 5:
                    message.timestamp = $b80c662ed5531f23$var$fromTimestamp($5G2s6.Timestamp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $b80c662ed5531f23$var$baseDuplicateVoteEvidence);
        if (object.voteA !== undefined && object.voteA !== null) message.voteA = $djDW6.Vote.fromJSON(object.voteA);
        else message.voteA = undefined;
        if (object.voteB !== undefined && object.voteB !== null) message.voteB = $djDW6.Vote.fromJSON(object.voteB);
        else message.voteB = undefined;
        if (object.totalVotingPower !== undefined && object.totalVotingPower !== null) message.totalVotingPower = $b80c662ed5531f23$var$long_1.default.fromString(object.totalVotingPower);
        else message.totalVotingPower = $b80c662ed5531f23$var$long_1.default.ZERO;
        if (object.validatorPower !== undefined && object.validatorPower !== null) message.validatorPower = $b80c662ed5531f23$var$long_1.default.fromString(object.validatorPower);
        else message.validatorPower = $b80c662ed5531f23$var$long_1.default.ZERO;
        if (object.timestamp !== undefined && object.timestamp !== null) message.timestamp = $b80c662ed5531f23$var$fromJsonTimestamp(object.timestamp);
        else message.timestamp = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.voteA !== undefined && (obj.voteA = message.voteA ? $djDW6.Vote.toJSON(message.voteA) : undefined);
        message.voteB !== undefined && (obj.voteB = message.voteB ? $djDW6.Vote.toJSON(message.voteB) : undefined);
        message.totalVotingPower !== undefined && (obj.totalVotingPower = (message.totalVotingPower || $b80c662ed5531f23$var$long_1.default.ZERO).toString());
        message.validatorPower !== undefined && (obj.validatorPower = (message.validatorPower || $b80c662ed5531f23$var$long_1.default.ZERO).toString());
        message.timestamp !== undefined && (obj.timestamp = message.timestamp.toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $b80c662ed5531f23$var$baseDuplicateVoteEvidence);
        if (object.voteA !== undefined && object.voteA !== null) message.voteA = $djDW6.Vote.fromPartial(object.voteA);
        else message.voteA = undefined;
        if (object.voteB !== undefined && object.voteB !== null) message.voteB = $djDW6.Vote.fromPartial(object.voteB);
        else message.voteB = undefined;
        if (object.totalVotingPower !== undefined && object.totalVotingPower !== null) message.totalVotingPower = object.totalVotingPower;
        else message.totalVotingPower = $b80c662ed5531f23$var$long_1.default.ZERO;
        if (object.validatorPower !== undefined && object.validatorPower !== null) message.validatorPower = object.validatorPower;
        else message.validatorPower = $b80c662ed5531f23$var$long_1.default.ZERO;
        if (object.timestamp !== undefined && object.timestamp !== null) message.timestamp = object.timestamp;
        else message.timestamp = undefined;
        return message;
    }
};
const $b80c662ed5531f23$var$baseLightClientAttackEvidence = {
    commonHeight: $b80c662ed5531f23$var$long_1.default.ZERO,
    totalVotingPower: $b80c662ed5531f23$var$long_1.default.ZERO
};
module.exports.LightClientAttackEvidence = {
    encode (message, writer = $b80c662ed5531f23$var$minimal_1.default.Writer.create()) {
        if (message.conflictingBlock !== undefined) $djDW6.LightBlock.encode(message.conflictingBlock, writer.uint32(10).fork()).ldelim();
        if (!message.commonHeight.isZero()) writer.uint32(16).int64(message.commonHeight);
        for (const v of message.byzantineValidators)$j77DS.Validator.encode(v, writer.uint32(26).fork()).ldelim();
        if (!message.totalVotingPower.isZero()) writer.uint32(32).int64(message.totalVotingPower);
        if (message.timestamp !== undefined) $5G2s6.Timestamp.encode($b80c662ed5531f23$var$toTimestamp(message.timestamp), writer.uint32(42).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b80c662ed5531f23$var$minimal_1.default.Reader ? input : new $b80c662ed5531f23$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b80c662ed5531f23$var$baseLightClientAttackEvidence);
        message.byzantineValidators = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.conflictingBlock = $djDW6.LightBlock.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.commonHeight = reader.int64();
                    break;
                case 3:
                    message.byzantineValidators.push($j77DS.Validator.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.totalVotingPower = reader.int64();
                    break;
                case 5:
                    message.timestamp = $b80c662ed5531f23$var$fromTimestamp($5G2s6.Timestamp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $b80c662ed5531f23$var$baseLightClientAttackEvidence);
        message.byzantineValidators = [];
        if (object.conflictingBlock !== undefined && object.conflictingBlock !== null) message.conflictingBlock = $djDW6.LightBlock.fromJSON(object.conflictingBlock);
        else message.conflictingBlock = undefined;
        if (object.commonHeight !== undefined && object.commonHeight !== null) message.commonHeight = $b80c662ed5531f23$var$long_1.default.fromString(object.commonHeight);
        else message.commonHeight = $b80c662ed5531f23$var$long_1.default.ZERO;
        if (object.byzantineValidators !== undefined && object.byzantineValidators !== null) for (const e of object.byzantineValidators)message.byzantineValidators.push($j77DS.Validator.fromJSON(e));
        if (object.totalVotingPower !== undefined && object.totalVotingPower !== null) message.totalVotingPower = $b80c662ed5531f23$var$long_1.default.fromString(object.totalVotingPower);
        else message.totalVotingPower = $b80c662ed5531f23$var$long_1.default.ZERO;
        if (object.timestamp !== undefined && object.timestamp !== null) message.timestamp = $b80c662ed5531f23$var$fromJsonTimestamp(object.timestamp);
        else message.timestamp = undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.conflictingBlock !== undefined && (obj.conflictingBlock = message.conflictingBlock ? $djDW6.LightBlock.toJSON(message.conflictingBlock) : undefined);
        message.commonHeight !== undefined && (obj.commonHeight = (message.commonHeight || $b80c662ed5531f23$var$long_1.default.ZERO).toString());
        if (message.byzantineValidators) obj.byzantineValidators = message.byzantineValidators.map((e)=>e ? $j77DS.Validator.toJSON(e) : undefined);
        else obj.byzantineValidators = [];
        message.totalVotingPower !== undefined && (obj.totalVotingPower = (message.totalVotingPower || $b80c662ed5531f23$var$long_1.default.ZERO).toString());
        message.timestamp !== undefined && (obj.timestamp = message.timestamp.toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $b80c662ed5531f23$var$baseLightClientAttackEvidence);
        message.byzantineValidators = [];
        if (object.conflictingBlock !== undefined && object.conflictingBlock !== null) message.conflictingBlock = $djDW6.LightBlock.fromPartial(object.conflictingBlock);
        else message.conflictingBlock = undefined;
        if (object.commonHeight !== undefined && object.commonHeight !== null) message.commonHeight = object.commonHeight;
        else message.commonHeight = $b80c662ed5531f23$var$long_1.default.ZERO;
        if (object.byzantineValidators !== undefined && object.byzantineValidators !== null) for (const e of object.byzantineValidators)message.byzantineValidators.push($j77DS.Validator.fromPartial(e));
        if (object.totalVotingPower !== undefined && object.totalVotingPower !== null) message.totalVotingPower = object.totalVotingPower;
        else message.totalVotingPower = $b80c662ed5531f23$var$long_1.default.ZERO;
        if (object.timestamp !== undefined && object.timestamp !== null) message.timestamp = object.timestamp;
        else message.timestamp = undefined;
        return message;
    }
};
const $b80c662ed5531f23$var$baseEvidenceList = {};
module.exports.EvidenceList = {
    encode (message, writer = $b80c662ed5531f23$var$minimal_1.default.Writer.create()) {
        for (const v of message.evidence)module.exports.Evidence.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b80c662ed5531f23$var$minimal_1.default.Reader ? input : new $b80c662ed5531f23$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b80c662ed5531f23$var$baseEvidenceList);
        message.evidence = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.evidence.push(module.exports.Evidence.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $b80c662ed5531f23$var$baseEvidenceList);
        message.evidence = [];
        if (object.evidence !== undefined && object.evidence !== null) for (const e of object.evidence)message.evidence.push(module.exports.Evidence.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.evidence) obj.evidence = message.evidence.map((e)=>e ? module.exports.Evidence.toJSON(e) : undefined);
        else obj.evidence = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $b80c662ed5531f23$var$baseEvidenceList);
        message.evidence = [];
        if (object.evidence !== undefined && object.evidence !== null) for (const e of object.evidence)message.evidence.push(module.exports.Evidence.fromPartial(e));
        return message;
    }
};
function $b80c662ed5531f23$var$toTimestamp(date) {
    const seconds = $b80c662ed5531f23$var$numberToLong(date.getTime() / 1000);
    const nanos = date.getTime() % 1000 * 1000000;
    return {
        seconds: seconds,
        nanos: nanos
    };
}
function $b80c662ed5531f23$var$fromTimestamp(t) {
    let millis = t.seconds.toNumber() * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function $b80c662ed5531f23$var$fromJsonTimestamp(o) {
    if (o instanceof Date) return o;
    else if (typeof o === "string") return new Date(o);
    else return $b80c662ed5531f23$var$fromTimestamp($5G2s6.Timestamp.fromJSON(o));
}
function $b80c662ed5531f23$var$numberToLong(number) {
    return $b80c662ed5531f23$var$long_1.default.fromNumber(number);
}
if ($b80c662ed5531f23$var$minimal_1.default.util.Long !== $b80c662ed5531f23$var$long_1.default) {
    $b80c662ed5531f23$var$minimal_1.default.util.Long = $b80c662ed5531f23$var$long_1.default;
    $b80c662ed5531f23$var$minimal_1.default.configure();
}

});




parcelRegister("iE6dd", function(module, exports) {
"use strict";
var $d930c80be62ded18$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d930c80be62ded18$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d930c80be62ded18$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$d930c80be62ded18$var$__exportStar((parcelRequire("eZNfL")), module.exports);

$d930c80be62ded18$var$__exportStar((parcelRequire("eVBzH")), module.exports);

$d930c80be62ded18$var$__exportStar((parcelRequire("4WCmR")), module.exports);

$d930c80be62ded18$var$__exportStar((parcelRequire("8bfAX")), module.exports);

$d930c80be62ded18$var$__exportStar((parcelRequire("bi40U")), module.exports);

$d930c80be62ded18$var$__exportStar((parcelRequire("lsXDQ")), module.exports);

$d930c80be62ded18$var$__exportStar((parcelRequire("efPR4")), module.exports);

$d930c80be62ded18$var$__exportStar((parcelRequire("e2X6F")), module.exports);

$d930c80be62ded18$var$__exportStar((parcelRequire("hHT9q")), module.exports);

$d930c80be62ded18$var$__exportStar((parcelRequire("83alV")), module.exports);

$d930c80be62ded18$var$__exportStar((parcelRequire("aG8cj")), module.exports);

$d930c80be62ded18$var$__exportStar((parcelRequire("elZTt")), module.exports);

$d930c80be62ded18$var$__exportStar((parcelRequire("lg08O")), module.exports);

$d930c80be62ded18$var$__exportStar((parcelRequire("biFrz")), module.exports);

$d930c80be62ded18$var$__exportStar((parcelRequire("7bWhQ")), module.exports);

$d930c80be62ded18$var$__exportStar((parcelRequire("eBnrF")), module.exports);

$d930c80be62ded18$var$__exportStar((parcelRequire("e9FVi")), module.exports);

});
parcelRegister("eZNfL", function(module, exports) {
"use strict";
var $aeacf7de0c82e1ef$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $aeacf7de0c82e1ef$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $aeacf7de0c82e1ef$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AuthAPI = void 0;

var $6cKfH = parcelRequire("6cKfH");

var $9XrZl = parcelRequire("9XrZl");
var $aeacf7de0c82e1ef$var$AuthAPI = /** @class */ function(_super) {
    $aeacf7de0c82e1ef$var$__extends(AuthAPI, _super);
    function AuthAPI(lcd) {
        var _this = _super.call(this, lcd.apiRequester) || this;
        _this.lcd = lcd;
        return _this;
    }
    /**
     * Looks up the account information using its Terra account address. If the account has
     * vesting, it will be one of [LazyGradedVestingAccount, DelayedVestingAccount, PeriodicVestingAccount, ContinuousVestingAccount]
     *
     * @param address address of account to look up
     */ AuthAPI.prototype.accountInfo = function(address, params) {
        if (params === void 0) params = {};
        return $aeacf7de0c82e1ef$var$__awaiter(this, void 0, void 0, function() {
            var account;
            return $aeacf7de0c82e1ef$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.c.get("/cosmos/auth/v1beta1/accounts/".concat(address), params)
                        ];
                    case 1:
                        account = _a.sent().account;
                        return [
                            2 /*return*/ ,
                            $6cKfH.Account.fromData(account, this.lcd.config.isClassic)
                        ];
                }
            });
        });
    };
    AuthAPI.prototype.parameters = function(params) {
        if (params === void 0) params = {};
        return $aeacf7de0c82e1ef$var$__awaiter(this, void 0, void 0, function() {
            return $aeacf7de0c82e1ef$var$__generator(this, function(_a) {
                if (this.lcd.config.isClassic) throw new Error("Not supported for the network");
                return [
                    2 /*return*/ ,
                    this.c.get("/cosmos/auth/v1beta1/params", params).then(function(_a) {
                        var d = _a.params;
                        return {
                            max_memo_characters: Number.parseInt(d.max_memo_characters),
                            tx_sig_limit: Number.parseInt(d.tx_sig_limit),
                            tx_size_cost_per_byte: Number.parseInt(d.tx_size_cost_per_byte),
                            sig_verify_cost_ed25519: Number.parseInt(d.sig_verify_cost_ed25519),
                            sig_verify_cost_secp256k1: Number.parseInt(d.sig_verify_cost_secp256k1)
                        };
                    })
                ];
            });
        });
    };
    return AuthAPI;
}($9XrZl.BaseAPI);
module.exports.AuthAPI = $aeacf7de0c82e1ef$var$AuthAPI;

});
parcelRegister("9XrZl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BaseAPI = void 0;
var $73ff55a735ba872c$var$BaseAPI = /** @class */ function() {
    function BaseAPI(c) {
        this.c = c;
    }
    return BaseAPI;
}();
module.exports.BaseAPI = $73ff55a735ba872c$var$BaseAPI;

});


parcelRegister("eVBzH", function(module, exports) {
"use strict";
var $02cdfe15382248cb$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $02cdfe15382248cb$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $02cdfe15382248cb$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BankAPI = void 0;

var $9XrZl = parcelRequire("9XrZl");

var $6cKfH = parcelRequire("6cKfH");
var $02cdfe15382248cb$var$BankAPI = /** @class */ function(_super) {
    $02cdfe15382248cb$var$__extends(BankAPI, _super);
    function BankAPI(lcd) {
        var _this = _super.call(this, lcd.apiRequester) || this;
        _this.lcd = lcd;
        return _this;
    }
    /**
     * Look up the balance of an account by its address.
     * @param address address of account to look up.
     */ BankAPI.prototype.balance = function(address, params) {
        if (params === void 0) params = {};
        return $02cdfe15382248cb$var$__awaiter(this, void 0, void 0, function() {
            return $02cdfe15382248cb$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/cosmos/bank/v1beta1/balances/".concat(address), params).then(function(d) {
                        return [
                            $6cKfH.Coins.fromData(d.balances),
                            d.pagination
                        ];
                    })
                ];
            });
        });
    };
    /**
     * Get the total supply of tokens in circulation for all denominations.
     */ BankAPI.prototype.total = function(params) {
        if (params === void 0) params = {};
        return $02cdfe15382248cb$var$__awaiter(this, void 0, void 0, function() {
            return $02cdfe15382248cb$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/cosmos/bank/v1beta1/supply", params).then(function(d) {
                        return [
                            $6cKfH.Coins.fromData(d.supply),
                            d.pagination
                        ];
                    })
                ];
            });
        });
    };
    /**
     * Lqueries the spenable balance of all coins for a single account.
     * @param address address of account to look up.
     */ BankAPI.prototype.spendableBalances = function(address, params) {
        if (params === void 0) params = {};
        return $02cdfe15382248cb$var$__awaiter(this, void 0, void 0, function() {
            return $02cdfe15382248cb$var$__generator(this, function(_a) {
                if (this.lcd.config.isClassic) throw new Error("Not supported for the network");
                return [
                    2 /*return*/ ,
                    this.c.get("/cosmos/bank/v1beta1/spendable_balances/".concat(address), params).then(function(d) {
                        return [
                            $6cKfH.Coins.fromData(d.balances),
                            d.pagination
                        ];
                    })
                ];
            });
        });
    };
    BankAPI.prototype.parameters = function(params) {
        if (params === void 0) params = {};
        return $02cdfe15382248cb$var$__awaiter(this, void 0, void 0, function() {
            return $02cdfe15382248cb$var$__generator(this, function(_a) {
                if (this.lcd.config.isClassic) throw new Error("Not supported for the network");
                return [
                    2 /*return*/ ,
                    this.c.get("/cosmos/bank/v1beta1/params", params).then(function(_a) {
                        var d = _a.params;
                        return {
                            send_enabled: d.send_enabled,
                            default_send_enabled: d.default_send_enabled
                        };
                    })
                ];
            });
        });
    };
    return BankAPI;
}($9XrZl.BaseAPI);
module.exports.BankAPI = $02cdfe15382248cb$var$BankAPI;

});

parcelRegister("4WCmR", function(module, exports) {
"use strict";
var $399a57391cf48b78$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $399a57391cf48b78$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $399a57391cf48b78$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DistributionAPI = void 0;

var $9XrZl = parcelRequire("9XrZl");

var $6cKfH = parcelRequire("6cKfH");
var $399a57391cf48b78$var$DistributionAPI = /** @class */ function(_super) {
    $399a57391cf48b78$var$__extends(DistributionAPI, _super);
    function DistributionAPI(lcd) {
        var _this = _super.call(this, lcd.apiRequester) || this;
        _this.lcd = lcd;
        return _this;
    }
    /**
     * Gets a delegator's rewards.
     * @param delegator delegator's account address
     */ DistributionAPI.prototype.rewards = function(delegator, params) {
        if (params === void 0) params = {};
        return $399a57391cf48b78$var$__awaiter(this, void 0, void 0, function() {
            var rewardsData, rewards, _i, _a, reward;
            return $399a57391cf48b78$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.c.get("/cosmos/distribution/v1beta1/delegators/".concat(delegator, "/rewards"), params).then(function(d) {
                                return d;
                            })
                        ];
                    case 1:
                        rewardsData = _b.sent();
                        rewards = {};
                        for(_i = 0, _a = rewardsData.rewards; _i < _a.length; _i++){
                            reward = _a[_i];
                            rewards[reward.validator_address] = $6cKfH.Coins.fromData(reward.reward);
                        }
                        return [
                            2 /*return*/ ,
                            {
                                rewards: rewards,
                                total: $6cKfH.Coins.fromData(rewardsData.total)
                            }
                        ];
                }
            });
        });
    };
    /**
     * Gets a validator's rewards.
     * @param validator validator's operator address
     */ DistributionAPI.prototype.validatorCommission = function(validator, params) {
        if (params === void 0) params = {};
        return $399a57391cf48b78$var$__awaiter(this, void 0, void 0, function() {
            return $399a57391cf48b78$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/cosmos/distribution/v1beta1/validators/".concat(validator, "/commission"), params).then(function(d) {
                        return d.commission;
                    }).then(function(d) {
                        return $6cKfH.Coins.fromData(d.commission);
                    })
                ];
            });
        });
    };
    /**
     * Gets the withdraw address of a delegator, the address to which rewards are withdrawn.
     * @param delegator
     */ DistributionAPI.prototype.withdrawAddress = function(delegator, params) {
        if (params === void 0) params = {};
        return $399a57391cf48b78$var$__awaiter(this, void 0, void 0, function() {
            return $399a57391cf48b78$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/cosmos/distribution/v1beta1/delegators/".concat(delegator, "/withdraw_address"), params).then(function(d) {
                        return d.withdraw_address;
                    })
                ];
            });
        });
    };
    /**
     * Gets the current value of the community pool.
     */ DistributionAPI.prototype.communityPool = function(params) {
        if (params === void 0) params = {};
        return $399a57391cf48b78$var$__awaiter(this, void 0, void 0, function() {
            return $399a57391cf48b78$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/cosmos/distribution/v1beta1/community_pool", params).then(function(d) {
                        return $6cKfH.Coins.fromData(d.pool);
                    })
                ];
            });
        });
    };
    /**
     * Gets the current distribution parameters.
     */ DistributionAPI.prototype.parameters = function(params) {
        if (params === void 0) params = {};
        return $399a57391cf48b78$var$__awaiter(this, void 0, void 0, function() {
            return $399a57391cf48b78$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/cosmos/distribution/v1beta1/params", params).then(function(_a) {
                        var d = _a.params;
                        return {
                            base_proposer_reward: new $6cKfH.Dec(d.base_proposer_reward),
                            community_tax: new $6cKfH.Dec(d.community_tax),
                            bonus_proposer_reward: new $6cKfH.Dec(d.bonus_proposer_reward),
                            withdraw_addr_enabled: d.withdraw_addr_enabled
                        };
                    })
                ];
            });
        });
    };
    return DistributionAPI;
}($9XrZl.BaseAPI);
module.exports.DistributionAPI = $399a57391cf48b78$var$DistributionAPI;

});

parcelRegister("8bfAX", function(module, exports) {
"use strict";
var $5f4b72aa0fa2c3d0$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $5f4b72aa0fa2c3d0$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $5f4b72aa0fa2c3d0$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeeGrantAPI = void 0;

var $9XrZl = parcelRequire("9XrZl");

var $cZl7P = parcelRequire("cZl7P");
var $5f4b72aa0fa2c3d0$var$FeeGrantAPI = /** @class */ function(_super) {
    $5f4b72aa0fa2c3d0$var$__extends(FeeGrantAPI, _super);
    function FeeGrantAPI(lcd) {
        var _this = _super.call(this, lcd.apiRequester) || this;
        _this.lcd = lcd;
        return _this;
    }
    FeeGrantAPI.prototype.allowances = function(grantee, params) {
        if (params === void 0) params = {};
        return $5f4b72aa0fa2c3d0$var$__awaiter(this, void 0, void 0, function() {
            return $5f4b72aa0fa2c3d0$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/cosmos/feegrant/v1beta1/allowances/".concat(grantee), params).then(function(d) {
                        return {
                            allowances: d.allowances.map(function(allowance) {
                                return {
                                    granter: allowance.granter,
                                    grantee: allowance.grantee,
                                    allowance: $cZl7P.Allowance.fromData(allowance.allowance)
                                };
                            }),
                            pagination: d.pagination
                        };
                    })
                ];
            });
        });
    };
    FeeGrantAPI.prototype.allowance = function(granter, grantee) {
        return $5f4b72aa0fa2c3d0$var$__awaiter(this, void 0, void 0, function() {
            return $5f4b72aa0fa2c3d0$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/cosmos/feegrant/v1beta1/allowance/".concat(granter, "/").concat(grantee)).then(function(d) {
                        return $cZl7P.Allowance.fromData(d.allowance.allowance);
                    })
                ];
            });
        });
    };
    FeeGrantAPI.prototype.allowancesByGranter = function(granter, params) {
        if (params === void 0) params = {};
        return $5f4b72aa0fa2c3d0$var$__awaiter(this, void 0, void 0, function() {
            return $5f4b72aa0fa2c3d0$var$__generator(this, function(_a) {
                if (this.lcd.config.isClassic) throw new Error("Not supported for the network");
                return [
                    2 /*return*/ ,
                    this.c.get("/cosmos/feegrant/v1beta1/issued/".concat(granter), params).then(function(d) {
                        return {
                            allowances: d.allowances.map(function(allowance) {
                                return {
                                    granter: allowance.granter,
                                    grantee: allowance.grantee,
                                    allowance: $cZl7P.Allowance.fromData(allowance.allowance)
                                };
                            }),
                            pagination: d.pagination
                        };
                    })
                ];
            });
        });
    };
    return FeeGrantAPI;
}($9XrZl.BaseAPI);
module.exports.FeeGrantAPI = $5f4b72aa0fa2c3d0$var$FeeGrantAPI;

});

parcelRegister("bi40U", function(module, exports) {
"use strict";
var $83847d32037f858e$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $83847d32037f858e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $83847d32037f858e$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GovAPI = void 0;

var $9XrZl = parcelRequire("9XrZl");

var $6cKfH = parcelRequire("6cKfH");

var $9q3yq = parcelRequire("9q3yq");
var $83847d32037f858e$var$GovAPI = /** @class */ function(_super) {
    $83847d32037f858e$var$__extends(GovAPI, _super);
    function GovAPI(lcd) {
        var _this = _super.call(this, lcd.apiRequester) || this;
        _this.lcd = lcd;
        return _this;
    }
    /**
     * Gets all proposals.
     */ GovAPI.prototype.proposals = function(params) {
        if (params === void 0) params = {};
        return $83847d32037f858e$var$__awaiter(this, void 0, void 0, function() {
            var _this = this;
            return $83847d32037f858e$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/cosmos/gov/v1beta1/proposals", params).then(function(d) {
                        return [
                            d.proposals.map(function(prop) {
                                return $6cKfH.Proposal.fromData(prop, _this.lcd.config.isClassic);
                            }),
                            d.pagination
                        ];
                    })
                ];
            });
        });
    };
    /**
     * Get a specific proposal by its ID
     * @param proposalId proposal's ID
     */ GovAPI.prototype.proposal = function(proposalId, params) {
        if (params === void 0) params = {};
        return $83847d32037f858e$var$__awaiter(this, void 0, void 0, function() {
            var _this = this;
            return $83847d32037f858e$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/cosmos/gov/v1beta1/proposals/".concat(proposalId), params).then(function(d) {
                        return $6cKfH.Proposal.fromData(d.proposal, _this.lcd.config.isClassic);
                    })
                ];
            });
        });
    };
    /**
     * Get the proposal's proposer
     * @param proposalId proposal's ID
     */ GovAPI.prototype.proposer = function(proposalId) {
        return $83847d32037f858e$var$__awaiter(this, void 0, void 0, function() {
            var creationTx, msg;
            return $83847d32037f858e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        proposalId;
                        return [
                            4 /*yield*/ ,
                            this.searchProposalCreationTx(proposalId)
                        ];
                    case 1:
                        creationTx = _a.sent();
                        msg = creationTx.body.messages.find(function(msg) {
                            return msg["@type"] === "/cosmos.gov.v1beta1.MsgSubmitProposal";
                        });
                        if (msg && msg["@type"] === "/cosmos.gov.v1beta1.MsgSubmitProposal") return [
                            2 /*return*/ ,
                            msg.proposer
                        ];
                        throw Error("failed to fetch submit_proposer tx");
                }
            });
        });
    };
    /**
     * Get the proposal's initial deposit
     * @param proposalId proposal's ID
     */ GovAPI.prototype.initialDeposit = function(proposalId) {
        return $83847d32037f858e$var$__awaiter(this, void 0, void 0, function() {
            var creationTx, msg;
            return $83847d32037f858e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        proposalId;
                        return [
                            4 /*yield*/ ,
                            this.searchProposalCreationTx(proposalId)
                        ];
                    case 1:
                        creationTx = _a.sent();
                        msg = creationTx.body.messages.find(function(msg) {
                            return msg["@type"] === "/cosmos.gov.v1beta1.MsgSubmitProposal";
                        });
                        if (msg && msg["@type"] === "/cosmos.gov.v1beta1.MsgSubmitProposal") return [
                            2 /*return*/ ,
                            $6cKfH.Coins.fromData(msg.initial_deposit)
                        ];
                        throw Error("failed to fetch submit_proposer tx");
                }
            });
        });
    };
    /**
     * Get the deposits for a proposal
     * @param proposalId proposal's ID
     */ GovAPI.prototype.deposits = function(proposalId, _params) {
        if (_params === void 0) _params = {};
        return $83847d32037f858e$var$__awaiter(this, void 0, void 0, function() {
            var proposal, params;
            return $83847d32037f858e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        proposalId;
                        _params;
                        return [
                            4 /*yield*/ ,
                            this.proposal(proposalId)
                        ];
                    case 1:
                        proposal = _a.sent();
                        if (proposal.status === $9q3yq.ProposalStatus.PROPOSAL_STATUS_DEPOSIT_PERIOD || proposal.status === $9q3yq.ProposalStatus.PROPOSAL_STATUS_VOTING_PERIOD) return [
                            2 /*return*/ ,
                            this.c.get("/cosmos/gov/v1beta1/proposals/".concat(proposalId, "/deposits"), _params).then(function(d) {
                                return [
                                    d.deposits.map(function(deposit) {
                                        return $6cKfH.Deposit.fromData(deposit);
                                    }),
                                    d.pagination
                                ];
                            })
                        ];
                        params = new URLSearchParams();
                        params.append("events", "message.action='/cosmos.gov.v1beta1.MsgDeposit'");
                        params.append("events", "proposal_deposit.proposal_id=".concat(proposalId));
                        Object.entries(_params).forEach(function(v) {
                            params.append(v[0], v[1]);
                        });
                        return [
                            2 /*return*/ ,
                            this.c.get("/cosmos/tx/v1beta1/txs", params).then(function(d) {
                                var deposits = [];
                                d.txs.map(function(tx) {
                                    return tx.body.messages.forEach(function(msg) {
                                        if (msg["@type"] === "/cosmos.gov.v1beta1.MsgDeposit" && Number.parseInt(msg.proposal_id) == proposalId) deposits.push(new $6cKfH.Deposit(proposalId, msg.depositor, $6cKfH.Coins.fromData(msg.amount)));
                                    }, deposits);
                                });
                                return [
                                    deposits,
                                    d.pagination
                                ];
                            })
                        ];
                }
            });
        });
    };
    GovAPI.prototype.searchProposalCreationTx = function(proposalId) {
        return $83847d32037f858e$var$__awaiter(this, void 0, void 0, function() {
            var params;
            return $83847d32037f858e$var$__generator(this, function(_a) {
                params = new URLSearchParams();
                params.append("events", "message.action='/cosmos.gov.v1beta1.MsgSubmitProposal'");
                params.append("events", "submit_proposal.proposal_id=".concat(proposalId));
                return [
                    2 /*return*/ ,
                    this.c.get("/cosmos/tx/v1beta1/txs", params).then(function(d) {
                        if (d.tx_responses.length === 0) throw Error("failed to fetch submit_proposer tx");
                        return d.txs[0];
                    })
                ];
            });
        });
    };
    /**
     * Get the current votes for a proposal
     * @param proposalId proposal's ID
     */ GovAPI.prototype.votes = function(proposalId, _params) {
        if (_params === void 0) _params = {};
        return $83847d32037f858e$var$__awaiter(this, void 0, void 0, function() {
            var proposal, params;
            return $83847d32037f858e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        proposalId;
                        _params;
                        return [
                            4 /*yield*/ ,
                            this.proposal(proposalId)
                        ];
                    case 1:
                        proposal = _a.sent();
                        if (proposal.status === $9q3yq.ProposalStatus.PROPOSAL_STATUS_DEPOSIT_PERIOD) return [
                            2 /*return*/ ,
                            this.c.get("/cosmos/gov/v1beta1/proposals/".concat(proposalId, "/votes"), _params).then(function(d) {
                                return [
                                    d.votes.map(function(v) {
                                        return $6cKfH.Vote.fromData(v);
                                    }),
                                    d.pagination
                                ];
                            })
                        ];
                        params = new URLSearchParams();
                        params.append("events", "message.action='/cosmos.gov.v1beta1.MsgVote'");
                        params.append("events", "proposal_vote.proposal_id=".concat(proposalId));
                        Object.entries(_params).forEach(function(v) {
                            params.append(v[0], v[1]);
                        });
                        return [
                            2 /*return*/ ,
                            this.c.get("/cosmos/tx/v1beta1/txs", params).then(function(d) {
                                var votes = [];
                                d.txs.map(function(tx) {
                                    return tx.body.messages.forEach(function(msg) {
                                        if (msg["@type"] === "/cosmos.gov.v1beta1.MsgVote" && Number.parseInt(msg.proposal_id) == proposalId) votes.push(new $6cKfH.Vote(proposalId, msg.voter, [
                                            new $6cKfH.WeightedVoteOption(msg.option, "1")
                                        ]));
                                        else if (msg["@type"] === "/cosmos.gov.v1beta1.MsgVoteWeighted" && Number.parseInt(msg.proposal_id) == proposalId) votes.push(new $6cKfH.Vote(proposalId, msg.voter, msg.options.map(function(o) {
                                            return $6cKfH.WeightedVoteOption.fromData(o);
                                        })));
                                    }, votes);
                                });
                                return [
                                    votes,
                                    d.pagination
                                ];
                            })
                        ];
                }
            });
        });
    };
    /**
     * Gets the current tally for a proposal.
     * @param proposalId proposal's ID
     */ GovAPI.prototype.tally = function(proposalId, params) {
        if (params === void 0) params = {};
        return $83847d32037f858e$var$__awaiter(this, void 0, void 0, function() {
            return $83847d32037f858e$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/cosmos/gov/v1beta1/proposals/".concat(proposalId, "/tally"), params).then(function(_a) {
                        var d = _a.tally;
                        return {
                            yes: new $6cKfH.Int(d.yes),
                            no: new $6cKfH.Int(d.no),
                            no_with_veto: new $6cKfH.Int(d.no_with_veto),
                            abstain: new $6cKfH.Int(d.abstain)
                        };
                    })
                ];
            });
        });
    };
    /** Gets the Gov module's deposit parameters */ GovAPI.prototype.depositParameters = function(params) {
        if (params === void 0) params = {};
        return $83847d32037f858e$var$__awaiter(this, void 0, void 0, function() {
            return $83847d32037f858e$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/cosmos/gov/v1beta1/params/deposit", params).then(function(_a) {
                        var d = _a.deposit_params;
                        return {
                            max_deposit_period: Number.parseInt(d.max_deposit_period),
                            min_deposit: $6cKfH.Coins.fromData(d.min_deposit)
                        };
                    })
                ];
            });
        });
    };
    /** Gets the Gov module's voting parameters */ GovAPI.prototype.votingParameters = function(params) {
        if (params === void 0) params = {};
        return $83847d32037f858e$var$__awaiter(this, void 0, void 0, function() {
            return $83847d32037f858e$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/cosmos/gov/v1beta1/params/voting", params).then(function(_a) {
                        var d = _a.voting_params;
                        return {
                            voting_period: Number.parseInt(d.voting_period)
                        };
                    })
                ];
            });
        });
    };
    /** Gets teh Gov module's tally parameters */ GovAPI.prototype.tallyParameters = function(params) {
        if (params === void 0) params = {};
        return $83847d32037f858e$var$__awaiter(this, void 0, void 0, function() {
            return $83847d32037f858e$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/cosmos/gov/v1beta1/params/tallying", params).then(function(_a) {
                        var d = _a.tally_params;
                        return {
                            quorum: new $6cKfH.Dec(d.quorum),
                            veto_threshold: new $6cKfH.Dec(d.veto_threshold),
                            threshold: new $6cKfH.Dec(d.threshold)
                        };
                    })
                ];
            });
        });
    };
    /** Gets the Gov module's current parameters  */ GovAPI.prototype.parameters = function(params) {
        if (params === void 0) params = {};
        return $83847d32037f858e$var$__awaiter(this, void 0, void 0, function() {
            var _a, deposit_params, voting_params, tally_params;
            return $83847d32037f858e$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            Promise.all([
                                this.depositParameters(params),
                                this.votingParameters(params),
                                this.tallyParameters(params)
                            ])
                        ];
                    case 1:
                        _a = _b.sent(), deposit_params = _a[0], voting_params = _a[1], tally_params = _a[2];
                        return [
                            2 /*return*/ ,
                            {
                                deposit_params: deposit_params,
                                voting_params: voting_params,
                                tally_params: tally_params
                            }
                        ];
                }
            });
        });
    };
    return GovAPI;
}($9XrZl.BaseAPI);
module.exports.GovAPI = $83847d32037f858e$var$GovAPI;

});

parcelRegister("lsXDQ", function(module, exports) {
"use strict";
var $fa0a7a1a284c6a6a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $fa0a7a1a284c6a6a$var$__assign = module.exports && module.exports.__assign || function() {
    $fa0a7a1a284c6a6a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fa0a7a1a284c6a6a$var$__assign.apply(this, arguments);
};
var $fa0a7a1a284c6a6a$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $fa0a7a1a284c6a6a$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MarketAPI = void 0;

var $6cKfH = parcelRequire("6cKfH");

var $9XrZl = parcelRequire("9XrZl");
var $fa0a7a1a284c6a6a$var$MarketAPI = /** @class */ function(_super) {
    $fa0a7a1a284c6a6a$var$__extends(MarketAPI, _super);
    function MarketAPI(lcd) {
        var _this = _super.call(this, lcd.apiRequester) || this;
        _this.lcd = lcd;
        return _this;
    }
    /**
     * Gets the Market's swap rate for a given coin to a requested denomination.
     * @param offerCoin coin to convert
     * @param askDenom denomination to swap into
     */ MarketAPI.prototype.swapRate = function(offerCoin, askDenom, _params) {
        if (_params === void 0) _params = {};
        return $fa0a7a1a284c6a6a$var$__awaiter(this, void 0, void 0, function() {
            var params;
            return $fa0a7a1a284c6a6a$var$__generator(this, function(_a) {
                if (!this.lcd.config.isClassic) throw new Error("Not supported for the network");
                params = $fa0a7a1a284c6a6a$var$__assign($fa0a7a1a284c6a6a$var$__assign({}, _params), {
                    offer_coin: offerCoin.toString(),
                    ask_denom: askDenom
                });
                return [
                    2 /*return*/ ,
                    this.c.get("/terra/market/v1beta1/swap", params).then(function(d) {
                        return $6cKfH.Coin.fromData(d.return_coin);
                    })
                ];
            });
        });
    };
    /**
     * Gets current value of the pool delta, which is used to determine Terra<>Luna swap rates.
     */ MarketAPI.prototype.poolDelta = function(params) {
        if (params === void 0) params = {};
        return $fa0a7a1a284c6a6a$var$__awaiter(this, void 0, void 0, function() {
            return $fa0a7a1a284c6a6a$var$__generator(this, function(_a) {
                if (!this.lcd.config.isClassic) throw new Error("Not supported for the network");
                return [
                    2 /*return*/ ,
                    this.c.get("/terra/market/v1beta1/terra_pool_delta", params).then(function(d) {
                        return new $6cKfH.Dec(d.terra_pool_delta);
                    })
                ];
            });
        });
    };
    /**
     * Gets the current Market module's parameters.
     */ MarketAPI.prototype.parameters = function(params) {
        if (params === void 0) params = {};
        return $fa0a7a1a284c6a6a$var$__awaiter(this, void 0, void 0, function() {
            return $fa0a7a1a284c6a6a$var$__generator(this, function(_a) {
                if (!this.lcd.config.isClassic) throw new Error("Not supported for the network");
                return [
                    2 /*return*/ ,
                    this.c.get("/terra/market/v1beta1/params", params).then(function(_a) {
                        var d = _a.params;
                        return {
                            pool_recovery_period: Number.parseInt(d.pool_recovery_period),
                            base_pool: new $6cKfH.Dec(d.base_pool),
                            min_stability_spread: new $6cKfH.Dec(d.min_stability_spread)
                        };
                    })
                ];
            });
        });
    };
    return MarketAPI;
}($9XrZl.BaseAPI);
module.exports.MarketAPI = $fa0a7a1a284c6a6a$var$MarketAPI;

});

parcelRegister("efPR4", function(module, exports) {
"use strict";
var $a60ab0b9a5e03fae$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $a60ab0b9a5e03fae$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a60ab0b9a5e03fae$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AuthzAPI = void 0;

var $9XrZl = parcelRequire("9XrZl");

var $btOyI = parcelRequire("btOyI");
var $a60ab0b9a5e03fae$var$AuthzAPI = /** @class */ function(_super) {
    $a60ab0b9a5e03fae$var$__extends(AuthzAPI, _super);
    function AuthzAPI(lcd) {
        var _this = _super.call(this, lcd.apiRequester) || this;
        _this.lcd = lcd;
        return _this;
    }
    /**
     * Get the message authorization grants for a specific granter and grantee
     */ AuthzAPI.prototype.grants = function(granter, grantee, msgTypeUrl, params) {
        if (params === void 0) params = {};
        return $a60ab0b9a5e03fae$var$__awaiter(this, void 0, void 0, function() {
            var _this = this;
            return $a60ab0b9a5e03fae$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/cosmos/authz/v1beta1/grants", Object.assign({
                        granter: granter,
                        grantee: grantee,
                        msg_type_url: msgTypeUrl
                    }, params)).then(function(d) {
                        return [
                            d.grants.map(function(grant) {
                                return $btOyI.AuthorizationGrant.fromData(grant, _this.lcd.config.isClassic);
                            }),
                            d.pagination
                        ];
                    })
                ];
            });
        });
    };
    /**
     * get list of `GrantAuthorization`, granted by granter.
     */ AuthzAPI.prototype.granter = function(granter, params) {
        if (params === void 0) params = {};
        return $a60ab0b9a5e03fae$var$__awaiter(this, void 0, void 0, function() {
            var _this = this;
            return $a60ab0b9a5e03fae$var$__generator(this, function(_a) {
                if (this.lcd.config.isClassic) throw new Error("Not supported for the network");
                return [
                    2 /*return*/ ,
                    this.c.get("/cosmos/authz/v1beta1/grants/granter/".concat(granter), params).then(function(d) {
                        return [
                            d.grants.map(function(g) {
                                return $btOyI.AuthorizationGrant.fromData(g, _this.lcd.config.isClassic);
                            }),
                            d.pagination
                        ];
                    })
                ];
            });
        });
    };
    /**
     * get list of `GrantAuthorization`, by grantee.
     */ AuthzAPI.prototype.grantee = function(grantee, params) {
        if (params === void 0) params = {};
        return $a60ab0b9a5e03fae$var$__awaiter(this, void 0, void 0, function() {
            var _this = this;
            return $a60ab0b9a5e03fae$var$__generator(this, function(_a) {
                if (this.lcd.config.isClassic) throw new Error("Not supported for the network");
                return [
                    2 /*return*/ ,
                    this.c.get("/cosmos/authz/v1beta1/grants/grantee/".concat(grantee), params).then(function(d) {
                        return [
                            d.grants.map(function(g) {
                                return $btOyI.AuthorizationGrant.fromData(g, _this.lcd.config.isClassic);
                            }),
                            d.pagination
                        ];
                    })
                ];
            });
        });
    };
    return AuthzAPI;
}($9XrZl.BaseAPI);
module.exports.AuthzAPI = $a60ab0b9a5e03fae$var$AuthzAPI;

});

parcelRegister("e2X6F", function(module, exports) {
"use strict";
var $a39f19ee42151327$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $a39f19ee42151327$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a39f19ee42151327$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OracleAPI = void 0;

var $9XrZl = parcelRequire("9XrZl");

var $6cKfH = parcelRequire("6cKfH");
var $a39f19ee42151327$var$OracleAPI = /** @class */ function(_super) {
    $a39f19ee42151327$var$__extends(OracleAPI, _super);
    function OracleAPI(lcd) {
        var _this = _super.call(this, lcd.apiRequester) || this;
        _this.lcd = lcd;
        return _this;
    }
    /**
     * Gets the Oracle module's currently registered exchange rate for uluna in all available denominations.
     */ OracleAPI.prototype.exchangeRates = function(params) {
        if (params === void 0) params = {};
        return $a39f19ee42151327$var$__awaiter(this, void 0, void 0, function() {
            return $a39f19ee42151327$var$__generator(this, function(_a) {
                if (!this.lcd.config.isClassic) throw new Error("Not supported for the network");
                return [
                    2 /*return*/ ,
                    this.c.get("/terra/oracle/v1beta1/denoms/exchange_rates", params).then(function(d) {
                        return $6cKfH.Coins.fromData(d.exchange_rates);
                    })
                ];
            });
        });
    };
    /**
     * Gets the Oracle module's currently registered exchange rate for the specific denomination.
     * @param denom denomination in which to get the exchange rate of uluna
     */ OracleAPI.prototype.exchangeRate = function(denom, params) {
        if (params === void 0) params = {};
        return $a39f19ee42151327$var$__awaiter(this, void 0, void 0, function() {
            return $a39f19ee42151327$var$__generator(this, function(_a) {
                if (!this.lcd.config.isClassic) throw new Error("Not supported for the network");
                return [
                    2 /*return*/ ,
                    this.c.get("/terra/oracle/v1beta1/denoms/".concat(denom, "/exchange_rate"), params).then(function(d) {
                        return $6cKfH.Coin.fromData({
                            denom: denom,
                            amount: d.exchange_rate
                        });
                    })
                ];
            });
        });
    };
    /**
     * Gets the current list of active denominations.
     */ OracleAPI.prototype.activeDenoms = function(params) {
        if (params === void 0) params = {};
        return $a39f19ee42151327$var$__awaiter(this, void 0, void 0, function() {
            return $a39f19ee42151327$var$__generator(this, function(_a) {
                if (!this.lcd.config.isClassic) throw new Error("Not supported for the network");
                return [
                    2 /*return*/ ,
                    this.c.get("/terra/oracle/v1beta1/denoms/actives", params).then(function(d) {
                        return d.actives;
                    })
                ];
            });
        });
    };
    /**
     * Gets the registered feeder address associated with the validator. The feeder address is the
     * Terra account that is permitted to sign Oracle vote messages in the validator's name.
     * @param validator validator's operator address
     */ OracleAPI.prototype.feederAddress = function(validator, params) {
        if (params === void 0) params = {};
        return $a39f19ee42151327$var$__awaiter(this, void 0, void 0, function() {
            return $a39f19ee42151327$var$__generator(this, function(_a) {
                if (!this.lcd.config.isClassic) throw new Error("Not supported for the network");
                return [
                    2 /*return*/ ,
                    this.c.get("/terra/oracle/v1beta1/validators/".concat(validator, "/feeder"), params).then(function(d) {
                        return d.feeder_addr;
                    })
                ];
            });
        });
    };
    /**
     * Gets the number of missed oracle votes for the validator over the current slash window.
     * @param validator validator's operator address
     */ OracleAPI.prototype.misses = function(validator, params) {
        if (params === void 0) params = {};
        return $a39f19ee42151327$var$__awaiter(this, void 0, void 0, function() {
            return $a39f19ee42151327$var$__generator(this, function(_a) {
                if (!this.lcd.config.isClassic) throw new Error("Not supported for the network");
                return [
                    2 /*return*/ ,
                    this.c.get("/terra/oracle/v1beta1/validators/".concat(validator, "/miss"), params).then(function(d) {
                        return Number.parseInt(d.miss_counter);
                    })
                ];
            });
        });
    };
    /**
     * Gets the validator's current submitted aggregate prevote
     * @param validator validator's operator address
     */ OracleAPI.prototype.aggregatePrevote = function(validator, params) {
        if (params === void 0) params = {};
        return $a39f19ee42151327$var$__awaiter(this, void 0, void 0, function() {
            return $a39f19ee42151327$var$__generator(this, function(_a) {
                if (!this.lcd.config.isClassic) throw new Error("Not supported for the network");
                return [
                    2 /*return*/ ,
                    this.c.get("/terra/oracle/v1beta1/validators/".concat(validator, "/aggregate_prevote"), params).then(function(d) {
                        return $6cKfH.AggregateExchangeRatePrevote.fromData(d.aggregate_prevote);
                    })
                ];
            });
        });
    };
    /**
     * Gets the validator's current submitted aggregate vote
     * @param validator validator's operator address
     */ OracleAPI.prototype.aggregateVote = function(validator, params) {
        if (params === void 0) params = {};
        return $a39f19ee42151327$var$__awaiter(this, void 0, void 0, function() {
            return $a39f19ee42151327$var$__generator(this, function(_a) {
                if (!this.lcd.config.isClassic) throw new Error("Not supported for the network");
                return [
                    2 /*return*/ ,
                    this.c.get("/terra/oracle/v1beta1/validators/".concat(validator, "/aggregate_vote"), params).then(function(d) {
                        return $6cKfH.AggregateExchangeRateVote.fromData(d.aggregate_vote);
                    })
                ];
            });
        });
    };
    /**
     * Gets the current Oracle module's parameters.
     */ OracleAPI.prototype.parameters = function(params) {
        if (params === void 0) params = {};
        return $a39f19ee42151327$var$__awaiter(this, void 0, void 0, function() {
            return $a39f19ee42151327$var$__generator(this, function(_a) {
                if (!this.lcd.config.isClassic) throw new Error("Not supported for the network");
                return [
                    2 /*return*/ ,
                    this.c.get("/terra/oracle/v1beta1/params", params).then(function(_a) {
                        var d = _a.params;
                        return {
                            vote_period: Number.parseInt(d.vote_period),
                            vote_threshold: new $6cKfH.Dec(d.vote_threshold),
                            reward_band: new $6cKfH.Dec(d.reward_band),
                            reward_distribution_window: Number.parseInt(d.reward_distribution_window),
                            whitelist: d.whitelist.map(function(x) {
                                return {
                                    name: x.name,
                                    tobin_tax: new $6cKfH.Dec(x.tobin_tax)
                                };
                            }),
                            slash_fraction: new $6cKfH.Dec(d.slash_fraction),
                            slash_window: Number.parseInt(d.slash_window),
                            min_valid_per_window: new $6cKfH.Dec(d.min_valid_per_window)
                        };
                    })
                ];
            });
        });
    };
    return OracleAPI;
}($9XrZl.BaseAPI);
module.exports.OracleAPI = $a39f19ee42151327$var$OracleAPI;

});

parcelRegister("hHT9q", function(module, exports) {
"use strict";
var $ce413baa74782602$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $ce413baa74782602$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ce413baa74782602$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SlashingAPI = void 0;

var $9XrZl = parcelRequire("9XrZl");

var $6cKfH = parcelRequire("6cKfH");
var $ce413baa74782602$var$SlashingAPI = /** @class */ function(_super) {
    $ce413baa74782602$var$__extends(SlashingAPI, _super);
    function SlashingAPI(lcd) {
        var _this = _super.call(this, lcd.apiRequester) || this;
        _this.lcd = lcd;
        return _this;
    }
    /**
     * Gets all signing info, or just the signing info of a particular validator.
     *
     * @param valConsPubKey validator's consensus public key
     */ SlashingAPI.prototype.signingInfo = function(valConsAddress, params) {
        if (params === void 0) params = {};
        return $ce413baa74782602$var$__awaiter(this, void 0, void 0, function() {
            return $ce413baa74782602$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/cosmos/slashing/v1beta1/signing_infos/".concat(valConsAddress), params).then(function(_a) {
                        var d = _a.val_signing_info;
                        return {
                            address: d.address,
                            start_height: Number.parseInt(d.start_height),
                            index_offset: Number.parseInt(d.index_offset),
                            jailed_until: new Date(d.jailed_until),
                            tombstoned: d.tombstoned,
                            missed_blocks_counter: Number.parseInt(d.missed_blocks_counter)
                        };
                    })
                ];
            });
        });
    };
    SlashingAPI.prototype.signingInfos = function(params) {
        if (params === void 0) params = {};
        return $ce413baa74782602$var$__awaiter(this, void 0, void 0, function() {
            return $ce413baa74782602$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/cosmos/slashing/v1beta1/signing_infos", params).then(function(d) {
                        return d.info.map(function(x) {
                            return {
                                address: x.address,
                                start_height: Number.parseInt(x.start_height),
                                index_offset: Number.parseInt(x.index_offset),
                                jailed_until: new Date(x.jailed_until),
                                tombstoned: x.tombstoned,
                                missed_blocks_counter: Number.parseInt(x.missed_blocks_counter)
                            };
                        });
                    })
                ];
            });
        });
    };
    /**
     * Gets the current Slashing module's parameters.
     */ SlashingAPI.prototype.parameters = function(params) {
        if (params === void 0) params = {};
        return $ce413baa74782602$var$__awaiter(this, void 0, void 0, function() {
            return $ce413baa74782602$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/cosmos/slashing/v1beta1/params", params).then(function(_a) {
                        var d = _a.params;
                        return {
                            signed_blocks_window: Number.parseInt(d.signed_blocks_window),
                            min_signed_per_window: new $6cKfH.Dec(d.min_signed_per_window),
                            downtime_jail_duration: Number.parseInt(d.downtime_jail_duration),
                            slash_fraction_double_sign: new $6cKfH.Dec(d.slash_fraction_double_sign),
                            slash_fraction_downtime: new $6cKfH.Dec(d.slash_fraction_downtime)
                        };
                    })
                ];
            });
        });
    };
    return SlashingAPI;
}($9XrZl.BaseAPI);
module.exports.SlashingAPI = $ce413baa74782602$var$SlashingAPI;

});

parcelRegister("83alV", function(module, exports) {
"use strict";
var $5dc6a258c1b6dd97$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $5dc6a258c1b6dd97$var$__assign = module.exports && module.exports.__assign || function() {
    $5dc6a258c1b6dd97$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5dc6a258c1b6dd97$var$__assign.apply(this, arguments);
};
var $5dc6a258c1b6dd97$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $5dc6a258c1b6dd97$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StakingAPI = void 0;

var $6cKfH = parcelRequire("6cKfH");

var $9XrZl = parcelRequire("9XrZl");

var $k32CU = parcelRequire("k32CU");

var $56eXa = parcelRequire("56eXa");

var $Oysv5 = parcelRequire("Oysv5");
var $5dc6a258c1b6dd97$var$StakingAPI = /** @class */ function(_super) {
    $5dc6a258c1b6dd97$var$__extends(StakingAPI, _super);
    function StakingAPI(lcd) {
        var _this = _super.call(this, lcd.apiRequester) || this;
        _this.lcd = lcd;
        return _this;
    }
    /**
     * Queries all delegations, filtering by delegator, validator, or both.
     *
     * At least one of the parameters must be defined.
     * @param delegator delegator's account address
     * @param validator validator's operator address
     */ StakingAPI.prototype.delegations = function(delegator, validator, params) {
        if (params === void 0) params = {};
        return $5dc6a258c1b6dd97$var$__awaiter(this, void 0, void 0, function() {
            return $5dc6a258c1b6dd97$var$__generator(this, function(_a) {
                if (delegator !== undefined && validator !== undefined) return [
                    2 /*return*/ ,
                    this.c.get("/cosmos/staking/v1beta1/validators/".concat(validator, "/delegations/").concat(delegator), params).then(function(_a) {
                        var data = _a.delegation_response;
                        return [
                            [
                                $k32CU.Delegation.fromData(data)
                            ],
                            {
                                total: 1,
                                next_key: ""
                            }
                        ];
                    })
                ];
                else if (delegator !== undefined) return [
                    2 /*return*/ ,
                    this.c.get("/cosmos/staking/v1beta1/delegations/".concat(delegator), params).then(function(data) {
                        return [
                            data.delegation_responses.map($k32CU.Delegation.fromData),
                            data.pagination
                        ];
                    })
                ];
                else if (validator !== undefined) return [
                    2 /*return*/ ,
                    this.c.get("/cosmos/staking/v1beta1/validators/".concat(validator, "/delegations"), params).then(function(data) {
                        return [
                            data.delegation_responses.map($k32CU.Delegation.fromData),
                            data.pagination
                        ];
                    })
                ];
                else throw new TypeError("arguments delegator and validator cannot both be empty");
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /**
     * Gets the delegation between a delegator and validator, if it exists.
     * @param delegator delegator's account address
     * @param validator validator's operator address
     */ StakingAPI.prototype.delegation = function(delegator, validator) {
        return $5dc6a258c1b6dd97$var$__awaiter(this, void 0, void 0, function() {
            return $5dc6a258c1b6dd97$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.delegations(delegator, validator).then(function(delgs) {
                        return delgs[0][0];
                    })
                ];
            });
        });
    };
    /**
     * Queries all unbonding delegations, filtering by delegator, validator, or both.
     *
     * At least one of the parameters must be defined.
     * @param delegator delegator's account address
     * @param validator validator's operator address
     */ StakingAPI.prototype.unbondingDelegations = function(delegator, validator, params) {
        if (params === void 0) params = {};
        return $5dc6a258c1b6dd97$var$__awaiter(this, void 0, void 0, function() {
            return $5dc6a258c1b6dd97$var$__generator(this, function(_a) {
                if (delegator !== undefined && validator !== undefined) return [
                    2 /*return*/ ,
                    this.c.get("/cosmos/staking/v1beta1/validators/".concat(validator, "/delegations/").concat(delegator, "/unbonding_delegation"), params).then(function(_a) {
                        var data = _a.unbond;
                        return [
                            [
                                $6cKfH.UnbondingDelegation.fromData(data)
                            ],
                            {
                                next_key: "",
                                total: 1
                            }
                        ];
                    })
                ];
                else if (delegator !== undefined) return [
                    2 /*return*/ ,
                    this.c.get("/cosmos/staking/v1beta1/delegators/".concat(delegator, "/unbonding_delegations"), params).then(function(data) {
                        return [
                            data.unbonding_responses.map($6cKfH.UnbondingDelegation.fromData),
                            data.pagination
                        ];
                    })
                ];
                else if (validator !== undefined) return [
                    2 /*return*/ ,
                    this.c.get("/cosmos/staking/v1beta1/validators/".concat(validator, "/unbonding_delegations"), params).then(function(data) {
                        return [
                            data.unbonding_responses.map($6cKfH.UnbondingDelegation.fromData),
                            data.pagination
                        ];
                    })
                ];
                else throw new TypeError("arguments delegator and validator cannot both be empty");
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /**
     * Gets the unbonding delegation between a delegator and validator, if it exists.
     * @param delegator delegator's account address
     * @param validator validator's operator address
     */ StakingAPI.prototype.unbondingDelegation = function(delegator, validator) {
        return $5dc6a258c1b6dd97$var$__awaiter(this, void 0, void 0, function() {
            return $5dc6a258c1b6dd97$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.unbondingDelegations(delegator, validator).then(function(udelgs) {
                        return udelgs[0][0];
                    })
                ];
            });
        });
    };
    /**
     * Queries all redelegations, filterable by delegator, source validator, and target validator.
     * @param delegator delegator's account address
     * @param validatorSrc source validator's operator address (from).
     * @param validatorDst destination validator's operator address (to).
     */ StakingAPI.prototype.redelegations = function(delegator, validatorSrc, validatorDst, _params) {
        if (_params === void 0) _params = {};
        return $5dc6a258c1b6dd97$var$__awaiter(this, void 0, void 0, function() {
            var params;
            return $5dc6a258c1b6dd97$var$__generator(this, function(_a) {
                params = $5dc6a258c1b6dd97$var$__assign($5dc6a258c1b6dd97$var$__assign({}, _params), {
                    src_validator_addr: validatorSrc,
                    dst_validator_addr: validatorDst
                });
                return [
                    2 /*return*/ ,
                    this.c.get("/cosmos/staking/v1beta1/delegators/".concat(delegator, "/redelegations"), params).then(function(d) {
                        return [
                            d.redelegation_responses.map($Oysv5.Redelegation.fromData),
                            d.pagination
                        ];
                    })
                ];
            });
        });
    };
    /**
     * Gets all bonded validators for a delegator given its address.
     * @param delegator delegator's account address
     */ StakingAPI.prototype.bondedValidators = function(delegator, params) {
        if (params === void 0) params = {};
        return $5dc6a258c1b6dd97$var$__awaiter(this, void 0, void 0, function() {
            return $5dc6a258c1b6dd97$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/cosmos/staking/v1beta1/delegators/".concat(delegator, "/validators"), params).then(function(d) {
                        return [
                            d.validators.map($56eXa.Validator.fromData),
                            d.pagination
                        ];
                    })
                ];
            });
        });
    };
    /**
     * Get all current registered validators, including validators that are not currently in the validating set.
     */ StakingAPI.prototype.validators = function(params) {
        if (params === void 0) params = {};
        return $5dc6a258c1b6dd97$var$__awaiter(this, void 0, void 0, function() {
            return $5dc6a258c1b6dd97$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/cosmos/staking/v1beta1/validators", params).then(function(d) {
                        return [
                            d.validators.map($56eXa.Validator.fromData),
                            d.pagination
                        ];
                    })
                ];
            });
        });
    };
    /**
     * Gets the validator information for a specific validator.
     * @param validator validator's operator address
     */ StakingAPI.prototype.validator = function(validator, params) {
        if (params === void 0) params = {};
        return $5dc6a258c1b6dd97$var$__awaiter(this, void 0, void 0, function() {
            return $5dc6a258c1b6dd97$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/cosmos/staking/v1beta1/validators/".concat(validator), params).then(function(d) {
                        return $56eXa.Validator.fromData(d.validator);
                    })
                ];
            });
        });
    };
    /**
     * Gets the current staking pool.
     */ StakingAPI.prototype.pool = function(params) {
        if (params === void 0) params = {};
        return $5dc6a258c1b6dd97$var$__awaiter(this, void 0, void 0, function() {
            return $5dc6a258c1b6dd97$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/cosmos/staking/v1beta1/pool", params).then(function(_a) {
                        var d = _a.pool;
                        return {
                            bonded_tokens: new $6cKfH.Coin("uluna", d.bonded_tokens),
                            not_bonded_tokens: new $6cKfH.Coin("uluna", d.not_bonded_tokens)
                        };
                    })
                ];
            });
        });
    };
    /**
     * Gets the current Staking module's parameters.
     */ StakingAPI.prototype.parameters = function(params) {
        if (params === void 0) params = {};
        return $5dc6a258c1b6dd97$var$__awaiter(this, void 0, void 0, function() {
            return $5dc6a258c1b6dd97$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/cosmos/staking/v1beta1/params", params).then(function(_a) {
                        var d = _a.params;
                        return {
                            unbonding_time: Number.parseInt(d.unbonding_time),
                            max_validators: d.max_validators,
                            max_entries: d.max_entries,
                            historical_entries: d.historical_entries,
                            bond_denom: d.bond_denom
                        };
                    })
                ];
            });
        });
    };
    return StakingAPI;
}($9XrZl.BaseAPI);
module.exports.StakingAPI = $5dc6a258c1b6dd97$var$StakingAPI;

});

parcelRegister("aG8cj", function(module, exports) {
"use strict";
var $7c642f850b6c41d5$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $7c642f850b6c41d5$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7c642f850b6c41d5$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TendermintAPI = void 0;

var $9XrZl = parcelRequire("9XrZl");
var $7c642f850b6c41d5$var$TendermintAPI = /** @class */ function(_super) {
    $7c642f850b6c41d5$var$__extends(TendermintAPI, _super);
    function TendermintAPI(lcd) {
        var _this = _super.call(this, lcd.apiRequester) || this;
        _this.lcd = lcd;
        return _this;
    }
    /**
     * Gets the node's information.
     */ TendermintAPI.prototype.nodeInfo = function(params) {
        if (params === void 0) params = {};
        return $7c642f850b6c41d5$var$__awaiter(this, void 0, void 0, function() {
            return $7c642f850b6c41d5$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.getRaw("/cosmos/base/tendermint/v1beta1/node_info", params)
                ];
            });
        });
    };
    /**
     * Gets whether the node is currently in syncing mode to catch up with blocks.
     */ TendermintAPI.prototype.syncing = function(params) {
        if (params === void 0) params = {};
        return $7c642f850b6c41d5$var$__awaiter(this, void 0, void 0, function() {
            return $7c642f850b6c41d5$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.getRaw("/cosmos/base/tendermint/v1beta1/syncing", params).then(function(d) {
                        return d.syncing;
                    })
                ];
            });
        });
    };
    /**
     * Gets the validator (delegates) set at the specific height. If no height is given, the current set is returned.
     * @param height block height
     */ TendermintAPI.prototype.validatorSet = function(height, params) {
        if (params === void 0) params = {};
        return $7c642f850b6c41d5$var$__awaiter(this, void 0, void 0, function() {
            var url;
            return $7c642f850b6c41d5$var$__generator(this, function(_a) {
                url = height !== undefined ? "/cosmos/base/tendermint/v1beta1/validatorsets/".concat(height) : "/cosmos/base/tendermint/v1beta1/validatorsets/latest";
                return [
                    2 /*return*/ ,
                    this.c.get(url, params).then(function(d) {
                        return [
                            d.validators,
                            d.pagination
                        ];
                    })
                ];
            });
        });
    };
    /**
     * Gets the block information at the specified height. If no height is given, the latest block is returned.
     * @param height block height.
     */ TendermintAPI.prototype.blockInfo = function(height, params) {
        if (params === void 0) params = {};
        return $7c642f850b6c41d5$var$__awaiter(this, void 0, void 0, function() {
            var url;
            return $7c642f850b6c41d5$var$__generator(this, function(_a) {
                url = height !== undefined ? "/cosmos/base/tendermint/v1beta1/blocks/".concat(height) : "/cosmos/base/tendermint/v1beta1/blocks/latest";
                return [
                    2 /*return*/ ,
                    this.c.getRaw(url, params)
                ];
            });
        });
    };
    return TendermintAPI;
}($9XrZl.BaseAPI);
module.exports.TendermintAPI = $7c642f850b6c41d5$var$TendermintAPI;

});

parcelRegister("elZTt", function(module, exports) {
"use strict";
var $a73309a87b080b1c$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $a73309a87b080b1c$var$__assign = module.exports && module.exports.__assign || function() {
    $a73309a87b080b1c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a73309a87b080b1c$var$__assign.apply(this, arguments);
};
var $a73309a87b080b1c$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a73309a87b080b1c$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TreasuryAPI = void 0;

var $9XrZl = parcelRequire("9XrZl");

var $6cKfH = parcelRequire("6cKfH");
var $a73309a87b080b1c$var$TreasuryAPI = /** @class */ function(_super) {
    $a73309a87b080b1c$var$__extends(TreasuryAPI, _super);
    function TreasuryAPI(lcd) {
        var _this = _super.call(this, lcd.apiRequester) || this;
        _this.lcd = lcd;
        return _this;
    }
    /**
     * Gets the current registered Tax caps for all denomination
     * @returns Coin[]
     */ TreasuryAPI.prototype.taxCaps = function(params) {
        if (params === void 0) params = {};
        return $a73309a87b080b1c$var$__awaiter(this, void 0, void 0, function() {
            return $a73309a87b080b1c$var$__generator(this, function(_a) {
                if (!this.lcd.config.isClassic) throw new Error("Not supported for the network");
                return [
                    2 /*return*/ ,
                    this.c.get("/terra/treasury/v1beta1/tax_caps", params).then(function(d) {
                        return new $6cKfH.Coins(d.tax_caps.map(function(c) {
                            return new $6cKfH.Coin(c.denom, c.tax_cap);
                        }));
                    })
                ];
            });
        });
    };
    /**
     * Gets the current registered Tax Cap for a specified denomination.
     * @param denom denomination desired for Tax Cap query.
     */ TreasuryAPI.prototype.taxCap = function(denom, params) {
        if (params === void 0) params = {};
        return $a73309a87b080b1c$var$__awaiter(this, void 0, void 0, function() {
            return $a73309a87b080b1c$var$__generator(this, function(_a) {
                if (!this.lcd.config.isClassic) throw new Error("Not supported for the network");
                return [
                    2 /*return*/ ,
                    this.c.get("/terra/treasury/v1beta1/tax_caps/".concat(denom), params).then(function(d) {
                        return new $6cKfH.Coin(denom, d.tax_cap);
                    })
                ];
            });
        });
    };
    /**
     * Gets the current registered Tax Rate.
     */ TreasuryAPI.prototype.taxRate = function(height, _params) {
        if (_params === void 0) _params = {};
        return $a73309a87b080b1c$var$__awaiter(this, void 0, void 0, function() {
            var params;
            return $a73309a87b080b1c$var$__generator(this, function(_a) {
                if (!this.lcd.config.isClassic) throw new Error("Not supported for the network");
                params = $a73309a87b080b1c$var$__assign({}, _params);
                if (height) params.height = height;
                return [
                    2 /*return*/ ,
                    this.c.get("/terra/treasury/v1beta1/tax_rate", params).then(function(d) {
                        return new $6cKfH.Dec(d.tax_rate);
                    })
                ];
            });
        });
    };
    /**
     * Gets the current registered Reward Weight monetary policy lever.
     */ TreasuryAPI.prototype.rewardWeight = function(params) {
        if (params === void 0) params = {};
        return $a73309a87b080b1c$var$__awaiter(this, void 0, void 0, function() {
            return $a73309a87b080b1c$var$__generator(this, function(_a) {
                if (!this.lcd.config.isClassic) throw new Error("Not supported for the network");
                return [
                    2 /*return*/ ,
                    this.c.get("/terra/treasury/v1beta1/reward_weight", params).then(function(d) {
                        return new $6cKfH.Dec(d.reward_weight);
                    })
                ];
            });
        });
    };
    /**
     * Gets the tax proceeds for the epoch.
     */ TreasuryAPI.prototype.taxProceeds = function(params) {
        if (params === void 0) params = {};
        return $a73309a87b080b1c$var$__awaiter(this, void 0, void 0, function() {
            return $a73309a87b080b1c$var$__generator(this, function(_a) {
                if (!this.lcd.config.isClassic) throw new Error("Not supported for the network");
                return [
                    2 /*return*/ ,
                    this.c.get("/terra/treasury/v1beta1/tax_proceeds", params).then(function(d) {
                        return $6cKfH.Coins.fromData(d.tax_proceeds);
                    })
                ];
            });
        });
    };
    /**
     * Gets the seigniorage proceeds for the epoch.
     */ TreasuryAPI.prototype.seigniorageProceeds = function(params) {
        if (params === void 0) params = {};
        return $a73309a87b080b1c$var$__awaiter(this, void 0, void 0, function() {
            return $a73309a87b080b1c$var$__generator(this, function(_a) {
                if (!this.lcd.config.isClassic) throw new Error("Not supported for the network");
                return [
                    2 /*return*/ ,
                    this.c.get("/terra/treasury/v1beta1/seigniorage_proceeds", params).then(function(d) {
                        return new $6cKfH.Coin("uluna", d.seigniorage_proceeds);
                    })
                ];
            });
        });
    };
    /**
     * Gets the current Treasury module's parameters.
     */ TreasuryAPI.prototype.parameters = function(params) {
        if (params === void 0) params = {};
        return $a73309a87b080b1c$var$__awaiter(this, void 0, void 0, function() {
            return $a73309a87b080b1c$var$__generator(this, function(_a) {
                if (!this.lcd.config.isClassic) throw new Error("Not supported for the network");
                return [
                    2 /*return*/ ,
                    this.c.get("/terra/treasury/v1beta1/params", params).then(function(_a) {
                        var d = _a.params;
                        return {
                            tax_policy: $6cKfH.PolicyConstraints.fromData(d.tax_policy),
                            reward_policy: $6cKfH.PolicyConstraints.fromData(d.reward_policy),
                            mining_increment: new $6cKfH.Dec(d.mining_increment),
                            seigniorage_burden_target: new $6cKfH.Dec(d.seigniorage_burden_target),
                            window_long: Number.parseInt(d.window_long),
                            window_short: Number.parseInt(d.window_short),
                            window_probation: Number.parseInt(d.window_probation),
                            burn_tax_split: new $6cKfH.Dec(d.burn_tax_split)
                        };
                    })
                ];
            });
        });
    };
    return TreasuryAPI;
}($9XrZl.BaseAPI);
module.exports.TreasuryAPI = $a73309a87b080b1c$var$TreasuryAPI;

});

parcelRegister("lg08O", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $f79b339ec215825e$require$Buffer = $gzLuY.Buffer;
"use strict";
var $f79b339ec215825e$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $f79b339ec215825e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f79b339ec215825e$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TxAPI = module.exports.SimulateResponse = module.exports.isTxError = void 0;

var $9XrZl = parcelRequire("9XrZl");

var $6cKfH = parcelRequire("6cKfH");

var $4OXyF = parcelRequire("4OXyF");

var $6cKfH = parcelRequire("6cKfH");
function $f79b339ec215825e$var$isTxError(x) {
    return x.code !== undefined && x.code !== 0 && x.code !== "0";
}
module.exports.isTxError = $f79b339ec215825e$var$isTxError;
var $f79b339ec215825e$var$SimulateResponse = /** @class */ function() {
    function SimulateResponse(gas_info, result) {
        this.gas_info = gas_info;
        this.result = result;
    }
    SimulateResponse.fromData = function(data) {
        return new SimulateResponse({
            gas_wanted: Number.parseInt(data.gas_info.gas_wanted),
            gas_used: Number.parseInt(data.gas_info.gas_used)
        }, data.result);
    };
    return SimulateResponse;
}();
module.exports.SimulateResponse = $f79b339ec215825e$var$SimulateResponse;
var $f79b339ec215825e$var$TxAPI = /** @class */ function(_super) {
    $f79b339ec215825e$var$__extends(TxAPI, _super);
    function TxAPI(lcd) {
        var _this = _super.call(this, lcd.apiRequester) || this;
        _this.lcd = lcd;
        return _this;
    }
    /**
     * Looks up a transaction on the blockchain, addressed by its hash
     * @param txHash transaction's hash
     */ TxAPI.prototype.txInfo = function(txHash, params) {
        if (params === void 0) params = {};
        return $f79b339ec215825e$var$__awaiter(this, void 0, void 0, function() {
            var _this = this;
            return $f79b339ec215825e$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.getRaw("/cosmos/tx/v1beta1/txs/".concat(txHash), params).then(function(v) {
                        return $6cKfH.TxInfo.fromData(v.tx_response, _this.lcd.config.isClassic);
                    })
                ];
            });
        });
    };
    /**
     * Builds a [[StdSignMsg]] that is ready to be signed by a [[Key]]. The appropriate
     * account number and sequence will be fetched live from the blockchain and added to
     * the resultant [[StdSignMsg]]. If no fee is provided, fee will be automatically
     * estimated using the parameters, simulated using a "dummy fee" with sourceAddress's
     * nonzero denominations in its balance.
     *
     * @param sourceAddress account address of signer
     * @param options TX generation options
     */ TxAPI.prototype.create = function(signers, options) {
        return $f79b339ec215825e$var$__awaiter(this, void 0, void 0, function() {
            var fee, msgs, memo, timeoutHeight, signerDatas, _i, signers_1, signer, sequenceNumber, publicKey, account;
            return $f79b339ec215825e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        fee = options.fee;
                        msgs = options.msgs, memo = options.memo, timeoutHeight = options.timeoutHeight;
                        signerDatas = [];
                        _i = 0, signers_1 = signers;
                        _a.label = 1;
                    case 1:
                        if (!(_i < signers_1.length)) return [
                            3 /*break*/ ,
                            5
                        ];
                        signer = signers_1[_i];
                        sequenceNumber = signer.sequenceNumber;
                        publicKey = signer.publicKey;
                        if (!(sequenceNumber === undefined || !publicKey)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.lcd.auth.accountInfo(signer.address)
                        ];
                    case 2:
                        account = _a.sent();
                        if (sequenceNumber === undefined) sequenceNumber = account.getSequenceNumber();
                        if (!publicKey) publicKey = account.getPublicKey();
                        _a.label = 3;
                    case 3:
                        signerDatas.push({
                            sequenceNumber: sequenceNumber,
                            publicKey: publicKey
                        });
                        _a.label = 4;
                    case 4:
                        _i++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 5:
                        if (!(fee === undefined)) return [
                            3 /*break*/ ,
                            7
                        ];
                        return [
                            4 /*yield*/ ,
                            this.lcd.tx.estimateFee(signerDatas, options)
                        ];
                    case 6:
                        fee = _a.sent();
                        _a.label = 7;
                    case 7:
                        return [
                            2 /*return*/ ,
                            new $6cKfH.Tx(new $6cKfH.TxBody(msgs, memo || "", timeoutHeight || 0), new $6cKfH.AuthInfo([], fee), [])
                        ];
                }
            });
        });
    };
    /**
     * Looks up transactions on the blockchain for the block height. If height is undefined,
     * gets the transactions for the latest block.
     * @param height block height
     */ TxAPI.prototype.txInfosByHeight = function(height) {
        return $f79b339ec215825e$var$__awaiter(this, void 0, void 0, function() {
            var blockInfo, txs, txhashes, txInfos, _i, txhashes_1, txhash, _a, _b;
            return $f79b339ec215825e$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.lcd.tendermint.blockInfo(height)
                        ];
                    case 1:
                        blockInfo = _c.sent();
                        txs = blockInfo.block.data.txs;
                        if (!!txs) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            2 /*return*/ ,
                            []
                        ];
                    case 2:
                        txhashes = txs.map(function(txdata) {
                            return (0, $4OXyF.hashToHex)(txdata);
                        });
                        txInfos = [];
                        _i = 0, txhashes_1 = txhashes;
                        _c.label = 3;
                    case 3:
                        if (!(_i < txhashes_1.length)) return [
                            3 /*break*/ ,
                            6
                        ];
                        txhash = txhashes_1[_i];
                        _b = (_a = txInfos).push;
                        return [
                            4 /*yield*/ ,
                            this.txInfo(txhash)
                        ];
                    case 4:
                        _b.apply(_a, [
                            _c.sent()
                        ]);
                        _c.label = 5;
                    case 5:
                        _i++;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 6:
                        return [
                            2 /*return*/ ,
                            txInfos
                        ];
                }
            });
        });
    };
    /**
     * Estimates the transaction's fee by simulating it within the node
     * @param sourceAddress address that will pay the bill
     * @param msgs standard messages
     * @param options options for fee estimation
     */ TxAPI.prototype.estimateFee = function(signers, options) {
        return $f79b339ec215825e$var$__awaiter(this, void 0, void 0, function() {
            var gasPrices, gasAdjustment, feeDenoms, gas, gasPricesCoins, gasPricesCoinsFiltered, txBody, authInfo, tx, feeAmount;
            return $f79b339ec215825e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        gasPrices = options.gasPrices || this.lcd.config.gasPrices;
                        gasAdjustment = options.gasAdjustment || this.lcd.config.gasAdjustment;
                        feeDenoms = options.feeDenoms || [
                            this.lcd.config.isClassic ? "uusd" : "uluna"
                        ];
                        gas = options.gas;
                        if (gasPrices) {
                            gasPricesCoins = new $6cKfH.Coins(gasPrices);
                            if (feeDenoms) {
                                gasPricesCoinsFiltered = gasPricesCoins.filter(function(c) {
                                    return feeDenoms.includes(c.denom);
                                });
                                if (gasPricesCoinsFiltered.toArray().length > 0) gasPricesCoins = gasPricesCoinsFiltered;
                            }
                        }
                        txBody = new $6cKfH.TxBody(options.msgs, options.memo || "");
                        authInfo = new $6cKfH.AuthInfo([], new $6cKfH.Fee(0, new $6cKfH.Coins()));
                        tx = new $6cKfH.Tx(txBody, authInfo, []);
                        // fill empty signature
                        tx.appendEmptySignatures(signers);
                        if (!(!gas || gas === "auto" || gas === "0")) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.estimateGas(tx, {
                                gasAdjustment: gasAdjustment
                            })
                        ];
                    case 1:
                        gas = _a.sent().toString();
                        _a.label = 2;
                    case 2:
                        feeAmount = gasPricesCoins ? gasPricesCoins.mul(gas).toIntCeilCoins() : this.lcd.config.isClassic ? "0uusd" : "0uluna";
                        return [
                            2 /*return*/ ,
                            new $6cKfH.Fee(Number.parseInt(gas), feeAmount, "", "")
                        ];
                }
            });
        });
    };
    TxAPI.prototype.estimateGas = function(tx, options) {
        return $f79b339ec215825e$var$__awaiter(this, void 0, void 0, function() {
            var gasAdjustment, simTx, authInfo, simulateRes;
            return $f79b339ec215825e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        gasAdjustment = (options === null || options === void 0 ? void 0 : options.gasAdjustment) || this.lcd.config.gasAdjustment;
                        simTx = tx;
                        if (tx.signatures.length <= 0) {
                            if (!(options && options.signers && options.signers.length > 0)) throw Error("cannot append signature");
                            authInfo = new $6cKfH.AuthInfo([], new $6cKfH.Fee(0, new $6cKfH.Coins()));
                            simTx = new $6cKfH.Tx(tx.body, authInfo, []);
                            simTx.appendEmptySignatures(options.signers);
                        }
                        return [
                            4 /*yield*/ ,
                            this.c.post("/cosmos/tx/v1beta1/simulate", {
                                tx_bytes: this.encode(simTx)
                            }).then(function(d) {
                                return $f79b339ec215825e$var$SimulateResponse.fromData(d);
                            })
                        ];
                    case 1:
                        simulateRes = _a.sent();
                        return [
                            2 /*return*/ ,
                            new $6cKfH.Dec(gasAdjustment).mul(simulateRes.gas_info.gas_used).toNumber()
                        ];
                }
            });
        });
    };
    TxAPI.prototype.computeTax = function() {
        return $f79b339ec215825e$var$__awaiter(this, void 0, void 0, function() {
            return $f79b339ec215825e$var$__generator(this, function(_a) {
                throw new Error("Tax was removed from network");
            });
        });
    };
    /**
     * Encode a transaction to base64-encoded protobuf
     * @param tx transaction to encode
     */ TxAPI.prototype.encode = function(tx) {
        return $f79b339ec215825e$require$Buffer.from(tx.toBytes(this.lcd.config.isClassic)).toString("base64");
    };
    /**
     * Decode a transaction from base64-encoded protobuf
     * @param tx transaction string to decode
     */ TxAPI.prototype.decode = function(encodedTx) {
        return $6cKfH.Tx.fromBuffer($f79b339ec215825e$require$Buffer.from(encodedTx, "base64"), this.lcd.config.isClassic);
    };
    /**
     * Get the transaction's hash
     * @param tx transaction to hash
     */ TxAPI.prototype.hash = function(tx) {
        return $f79b339ec215825e$var$__awaiter(this, void 0, void 0, function() {
            var txBytes;
            return $f79b339ec215825e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.encode(tx)
                        ];
                    case 1:
                        txBytes = _a.sent();
                        return [
                            2 /*return*/ ,
                            (0, $4OXyF.hashToHex)(txBytes)
                        ];
                }
            });
        });
    };
    TxAPI.prototype._broadcast = function(tx, mode) {
        return $f79b339ec215825e$var$__awaiter(this, void 0, void 0, function() {
            return $f79b339ec215825e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.c.post("/cosmos/tx/v1beta1/txs", {
                                tx_bytes: this.encode(tx),
                                mode: mode
                            })
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    /**
     * Broadcast the transaction using "sync" mode, then wait for its inclusion in a block.
     *
     * This method polls txInfo using the txHash to confirm the transaction's execution.
     *
     * @param tx      transaction to broadcast
     * @param timeout time in milliseconds to wait for transaction to be included in a block. defaults to 30000
     */ TxAPI.prototype.broadcast = function(tx, timeout) {
        if (timeout === void 0) timeout = 30000;
        return $f79b339ec215825e$var$__awaiter(this, void 0, void 0, function() {
            var POLL_INTERVAL, txResponse, result, txInfo, i, error_1;
            return $f79b339ec215825e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        POLL_INTERVAL = 500;
                        return [
                            4 /*yield*/ ,
                            this._broadcast(tx, "BROADCAST_MODE_SYNC")
                        ];
                    case 1:
                        txResponse = _a.sent().tx_response;
                        if (txResponse.code != undefined && txResponse.code != 0) {
                            result = {
                                height: Number.parseInt(txResponse.height),
                                txhash: txResponse.txhash,
                                raw_log: txResponse.raw_log,
                                code: txResponse.code,
                                codespace: txResponse.codespace,
                                gas_used: 0,
                                gas_wanted: 0,
                                timestamp: "",
                                logs: []
                            };
                            return [
                                2 /*return*/ ,
                                result
                            ];
                        }
                        i = 0;
                        _a.label = 2;
                    case 2:
                        if (!(i <= timeout / POLL_INTERVAL)) return [
                            3 /*break*/ ,
                            9
                        ];
                        _a.label = 3;
                    case 3:
                        _a.trys.push([
                            3,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.txInfo(txResponse.txhash)
                        ];
                    case 4:
                        txInfo = _a.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        error_1 = _a.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 6:
                        if (txInfo) return [
                            3 /*break*/ ,
                            9
                        ];
                        return [
                            4 /*yield*/ ,
                            new Promise(function(resolve) {
                                return setTimeout(resolve, POLL_INTERVAL);
                            })
                        ];
                    case 7:
                        _a.sent();
                        _a.label = 8;
                    case 8:
                        i++;
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 9:
                        if (!txInfo) throw new Error("Transaction was not included in a block before timeout of ".concat(timeout, "ms"));
                        return [
                            2 /*return*/ ,
                            {
                                txhash: txInfo.txhash,
                                raw_log: txInfo.raw_log,
                                gas_wanted: txInfo.gas_wanted,
                                gas_used: txInfo.gas_used,
                                height: +txInfo.height,
                                logs: (txInfo.logs || []).map(function(l) {
                                    return $6cKfH.TxLog.fromData(l);
                                }),
                                code: txInfo.code,
                                codespace: txInfo.codespace,
                                timestamp: txInfo.timestamp
                            }
                        ];
                }
            });
        });
    };
    /**
     * Broadcast the transaction using the "block" mode, waiting for its inclusion in the blockchain.
     * @param tx transaction to broadcast
     */ TxAPI.prototype.broadcastBlock = function(tx) {
        return $f79b339ec215825e$var$__awaiter(this, void 0, void 0, function() {
            return $f79b339ec215825e$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this._broadcast(tx, "BROADCAST_MODE_BLOCK").then(function(_a) {
                        var d = _a.tx_response;
                        var blockResult = {
                            txhash: d.txhash,
                            raw_log: d.raw_log,
                            gas_wanted: Number.parseInt(d.gas_wanted),
                            gas_used: Number.parseInt(d.gas_used),
                            height: +d.height,
                            logs: d.logs.map(function(l) {
                                return $6cKfH.TxLog.fromData(l);
                            }),
                            code: d.code,
                            codespace: d.codespace,
                            data: d.data,
                            info: d.info,
                            timestamp: d.timestamp
                        };
                        return blockResult;
                    })
                ];
            });
        });
    };
    /**
     * NOTE: This is not a synchronous function and is unconventionally named. This function
     * can be await as it returns a `Promise`.
     *
     * Broadcast the transaction using the "sync" mode, returning after CheckTx() is performed.
     * @param tx transaction to broadcast
     */ TxAPI.prototype.broadcastSync = function(tx) {
        return $f79b339ec215825e$var$__awaiter(this, void 0, void 0, function() {
            return $f79b339ec215825e$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this._broadcast(tx, "BROADCAST_MODE_SYNC").then(function(_a) {
                        var d = _a.tx_response;
                        var blockResult = {
                            height: +d.height,
                            txhash: d.txhash,
                            raw_log: d.raw_log
                        };
                        if (d.code) blockResult.code = d.code;
                        if (d.codespace) blockResult.codespace = d.codespace;
                        return blockResult;
                    })
                ];
            });
        });
    };
    /**
     * Broadcast the transaction using the "async" mode, returns immediately (transaction might fail).
     * @param tx transaction to broadcast
     */ TxAPI.prototype.broadcastAsync = function(tx) {
        return $f79b339ec215825e$var$__awaiter(this, void 0, void 0, function() {
            return $f79b339ec215825e$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this._broadcast(tx, "BROADCAST_MODE_ASYNC").then(function(_a) {
                        var d = _a.tx_response;
                        return {
                            height: +d.height,
                            txhash: d.txhash
                        };
                    })
                ];
            });
        });
    };
    /**
     * Search for transactions based on event attributes.
     * @param options
     */ TxAPI.prototype.search = function(options) {
        var _a;
        return $f79b339ec215825e$var$__awaiter(this, void 0, void 0, function() {
            var params;
            var _this = this;
            return $f79b339ec215825e$var$__generator(this, function(_b) {
                params = new URLSearchParams();
                // build search params
                (_a = options.events) === null || _a === void 0 || _a.forEach(function(v) {
                    return params.append("events", v.key === "tx.height" ? "".concat(v.key, "=").concat(v.value) : "".concat(v.key, "='").concat(v.value, "'"));
                });
                delete options["events"];
                Object.entries(options).forEach(function(v) {
                    params.append(v[0], v[1]);
                });
                return [
                    2 /*return*/ ,
                    this.c.getRaw("/cosmos/tx/v1beta1/txs", params).then(function(d) {
                        return {
                            txs: d.tx_responses.map(function(tx_response) {
                                return $6cKfH.TxInfo.fromData(tx_response, _this.lcd.config.isClassic);
                            }),
                            pagination: d.pagination
                        };
                    })
                ];
            });
        });
    };
    return TxAPI;
}($9XrZl.BaseAPI);
module.exports.TxAPI = $f79b339ec215825e$var$TxAPI;

});

parcelRegister("biFrz", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $83a185fc17ce2243$require$Buffer = $gzLuY.Buffer;
"use strict";
var $83a185fc17ce2243$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $83a185fc17ce2243$var$__assign = module.exports && module.exports.__assign || function() {
    $83a185fc17ce2243$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $83a185fc17ce2243$var$__assign.apply(this, arguments);
};
var $83a185fc17ce2243$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $83a185fc17ce2243$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WasmAPI = void 0;

var $9XrZl = parcelRequire("9XrZl");

var $64EV7 = parcelRequire("64EV7");

var $3kVvi = parcelRequire("3kVvi");

var $47xVX = parcelRequire("47xVX");
var $83a185fc17ce2243$var$WasmAPI = /** @class */ function(_super) {
    $83a185fc17ce2243$var$__extends(WasmAPI, _super);
    function WasmAPI(lcd) {
        var _this = _super.call(this, lcd.apiRequester) || this;
        _this.lcd = lcd;
        return _this;
    }
    WasmAPI.prototype.codeInfo = function(codeID, params) {
        if (params === void 0) params = {};
        return $83a185fc17ce2243$var$__awaiter(this, void 0, void 0, function() {
            var endpoint;
            return $83a185fc17ce2243$var$__generator(this, function(_a) {
                endpoint = "/cosmwasm/wasm/v1/code/".concat(codeID);
                return [
                    2 /*return*/ ,
                    this.c.get(endpoint, params).then(function(_a) {
                        var d = _a.code_info;
                        return {
                            code_id: +d.code_id,
                            code_hash: d.data_hash,
                            creator: d.creator,
                            instantiate_permission: d.instantiate_permission ? $47xVX.AccessConfig.fromData(d.instantiate_permission) : undefined
                        };
                    })
                ];
            });
        });
    };
    WasmAPI.prototype.contractInfo = function(contractAddress, params) {
        if (params === void 0) params = {};
        return $83a185fc17ce2243$var$__awaiter(this, void 0, void 0, function() {
            var historyEntry, endpoint;
            return $83a185fc17ce2243$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.contractHistory(contractAddress)
                        ];
                    case 1:
                        historyEntry = _a.sent()[0];
                        endpoint = "/cosmwasm/wasm/v1/contract/".concat(contractAddress);
                        return [
                            2 /*return*/ ,
                            this.c.get(endpoint, params).then(function(_a) {
                                var d = _a.contract_info;
                                return {
                                    code_id: Number.parseInt(d.code_id),
                                    address: contractAddress,
                                    creator: d.creator,
                                    admin: d.admin !== "" ? d.admin : undefined,
                                    label: d.label !== "" ? d.label : undefined,
                                    init_msg: historyEntry[0].msg,
                                    created: d.created ? $3kVvi.AbsoluteTxPosition.fromData(d.created) : undefined,
                                    ibc_port_id: d.ibc_port_id !== "" ? d.ibc_port_id : undefined
                                };
                            })
                        ];
                }
            });
        });
    };
    WasmAPI.prototype.contractQuery = function(contractAddress, query, params) {
        if (params === void 0) params = {};
        return $83a185fc17ce2243$var$__awaiter(this, void 0, void 0, function() {
            var query_msg, endpoint;
            return $83a185fc17ce2243$var$__generator(this, function(_a) {
                query_msg = $83a185fc17ce2243$require$Buffer.from(JSON.stringify(query), "utf-8").toString("base64");
                endpoint = "/cosmwasm/wasm/v1/contract/".concat(contractAddress, "/smart/").concat(query_msg);
                return [
                    2 /*return*/ ,
                    this.c.get(endpoint, $83a185fc17ce2243$var$__assign({}, params)).then(function(d) {
                        return d.data;
                    })
                ];
            });
        });
    };
    WasmAPI.prototype.parameters = function(params) {
        if (params === void 0) params = {};
        return $83a185fc17ce2243$var$__awaiter(this, void 0, void 0, function() {
            return $83a185fc17ce2243$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/terra/wasm/v1beta1/params", params).then(function(_a) {
                        var d = _a.params;
                        return {
                            max_contract_size: Number.parseInt(d.max_contract_size),
                            max_contract_gas: Number.parseInt(d.max_contract_gas),
                            max_contract_msg_size: Number.parseInt(d.max_contract_msg_size)
                        };
                    })
                ];
            });
        });
    };
    WasmAPI.prototype.pinnedCodes = function(params) {
        if (params === void 0) params = {};
        return $83a185fc17ce2243$var$__awaiter(this, void 0, void 0, function() {
            return $83a185fc17ce2243$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/cosmwasm/wasm/v1/codes/pinned", params).then(function(_a) {
                        var d = _a.pinned_code;
                        return {
                            code_ids: d.code_ids.map(function(code_id) {
                                return Number.parseInt(code_id);
                            })
                        };
                    })
                ];
            });
        });
    };
    WasmAPI.prototype.rawContractState = function(contractAddress, query_data, params) {
        if (params === void 0) params = {};
        return $83a185fc17ce2243$var$__awaiter(this, void 0, void 0, function() {
            return $83a185fc17ce2243$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/cosmwasm/wasm/v1/contract/".concat(contractAddress, "/raw/").concat($83a185fc17ce2243$require$Buffer.from(query_data, "utf-8").toString("base64")), params).then(function(_a) {
                        var d = _a.result;
                        return {
                            data: $83a185fc17ce2243$require$Buffer.from(d.data, "base64").toString()
                        };
                    })
                ];
            });
        });
    };
    WasmAPI.prototype.smartContractState = function(contractAddress, query_data, params) {
        if (params === void 0) params = {};
        return $83a185fc17ce2243$var$__awaiter(this, void 0, void 0, function() {
            return $83a185fc17ce2243$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/cosmwasm/wasm/v1/contract/".concat(contractAddress, "/smart/").concat($83a185fc17ce2243$require$Buffer.from(JSON.stringify(query_data), "utf-8").toString("base64")), params).then(function(_a) {
                        var d = _a.result;
                        return {
                            data: d.data
                        };
                    })
                ];
            });
        });
    };
    WasmAPI.prototype.contractHistory = function(contractAddress, params) {
        if (params === void 0) params = {};
        return $83a185fc17ce2243$var$__awaiter(this, void 0, void 0, function() {
            return $83a185fc17ce2243$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/cosmwasm/wasm/v1/contract/".concat(contractAddress, "/history"), params).then(function(d) {
                        return [
                            d.entries.map(function(entry) {
                                return $64EV7.HistoryEntry.fromData(entry);
                            }),
                            d.pagination
                        ];
                    })
                ];
            });
        });
    };
    WasmAPI.prototype.contractStates = function(contractAddress, params) {
        if (params === void 0) params = {};
        return $83a185fc17ce2243$var$__awaiter(this, void 0, void 0, function() {
            return $83a185fc17ce2243$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/cosmwasm/wasm/v1/contract/".concat(contractAddress, "/state"), params).then(function(d) {
                        return [
                            d.models.map(function(model) {
                                return {
                                    key: model.key,
                                    value: model.value
                                };
                            }),
                            d.pagination
                        ];
                    })
                ];
            });
        });
    };
    WasmAPI.prototype.allCodes = function(params) {
        if (params === void 0) params = {};
        return $83a185fc17ce2243$var$__awaiter(this, void 0, void 0, function() {
            return $83a185fc17ce2243$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/cosmwasm/wasm/v1/code", params).then(function(d) {
                        return [
                            d.codeInfos.map(function(codeInfo) {
                                return {
                                    code_id: +codeInfo.code_id,
                                    code_hash: codeInfo.data_hash,
                                    creator: codeInfo.creator,
                                    instantiate_permission: codeInfo.instantiate_permission ? $47xVX.AccessConfig.fromData(codeInfo.instantiate_permission) : undefined
                                };
                            }),
                            d.pagination
                        ];
                    })
                ];
            });
        });
    };
    return WasmAPI;
}($9XrZl.BaseAPI);
module.exports.WasmAPI = $83a185fc17ce2243$var$WasmAPI;

});
parcelRegister("64EV7", function(module, exports) {

var $gzLuY = parcelRequire("gzLuY");
var $46c2dbb9b5ea7941$require$Buffer = $gzLuY.Buffer;
"use strict";
var $46c2dbb9b5ea7941$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $46c2dbb9b5ea7941$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $46c2dbb9b5ea7941$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $46c2dbb9b5ea7941$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $46c2dbb9b5ea7941$var$__createBinding(result, mod, k);
    }
    $46c2dbb9b5ea7941$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HistoryEntry = void 0;

var $odsVG = parcelRequire("odsVG");

var $26Eqx = parcelRequire("26Eqx");

var $46c2dbb9b5ea7941$var$Long = $46c2dbb9b5ea7941$var$__importStar((parcelRequire("9A55m")));

var $3kVvi = parcelRequire("3kVvi");
/**
 *
 */ var $46c2dbb9b5ea7941$var$HistoryEntry = /** @class */ function(_super) {
    $46c2dbb9b5ea7941$var$__extends(HistoryEntry, _super);
    /**
     * @param operation access type
     * @param code_id
     */ function HistoryEntry(operation, code_id, updated, msg) {
        var _this = _super.call(this) || this;
        _this.operation = operation;
        _this.code_id = code_id;
        _this.updated = updated;
        _this.msg = msg;
        return _this;
    }
    HistoryEntry.fromAmino = function(data) {
        return new HistoryEntry((0, $odsVG.contractCodeHistoryOperationTypeFromJSON)(data.operation), Number.parseInt(data.code_id), data.updated ? $3kVvi.AbsoluteTxPosition.fromAmino(data.updated) : undefined, data.msg);
    };
    HistoryEntry.prototype.toAmino = function() {
        var _a;
        var res = {
            operation: (0, $odsVG.contractCodeHistoryOperationTypeToJSON)(this.operation),
            code_id: this.code_id.toFixed(),
            updated: (_a = this.updated) === null || _a === void 0 ? void 0 : _a.toAmino(),
            msg: this.msg
        };
        return res;
    };
    HistoryEntry.fromData = function(data) {
        return new HistoryEntry((0, $odsVG.contractCodeHistoryOperationTypeFromJSON)(data.operation), Number.parseInt(data.code_id), data.updated ? $3kVvi.AbsoluteTxPosition.fromData(data.updated) : undefined, data.msg);
    };
    HistoryEntry.prototype.toData = function() {
        var _a;
        var res = {
            operation: (0, $odsVG.contractCodeHistoryOperationTypeToJSON)(this.operation),
            code_id: this.code_id.toFixed(),
            updated: (_a = this.updated) === null || _a === void 0 ? void 0 : _a.toData(),
            msg: this.msg
        };
        return res;
    };
    HistoryEntry.fromProto = function(proto) {
        return new HistoryEntry(proto.operation, proto.codeId.toNumber(), proto.updated ? $3kVvi.AbsoluteTxPosition.fromProto(proto.updated) : undefined, JSON.parse($46c2dbb9b5ea7941$require$Buffer.from(proto.msg).toString("utf-8")));
    };
    HistoryEntry.prototype.toProto = function() {
        var _a;
        return $odsVG.ContractCodeHistoryEntry.fromPartial({
            operation: this.operation,
            codeId: $46c2dbb9b5ea7941$var$Long.fromNumber(this.code_id),
            updated: (_a = this.updated) === null || _a === void 0 ? void 0 : _a.toProto(),
            msg: $46c2dbb9b5ea7941$require$Buffer.from(JSON.stringify((0, $26Eqx.removeNull)(this.msg)), "utf-8")
        });
    };
    return HistoryEntry;
}($26Eqx.JSONSerializable);
module.exports.HistoryEntry = $46c2dbb9b5ea7941$var$HistoryEntry;

});
parcelRegister("3kVvi", function(module, exports) {
"use strict";
var $26dfd8659259598b$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $26dfd8659259598b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $26dfd8659259598b$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $26dfd8659259598b$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $26dfd8659259598b$var$__createBinding(result, mod, k);
    }
    $26dfd8659259598b$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AbsoluteTxPosition = void 0;

var $odsVG = parcelRequire("odsVG");

var $26Eqx = parcelRequire("26Eqx");

var $26dfd8659259598b$var$Long = $26dfd8659259598b$var$__importStar((parcelRequire("9A55m")));
/**
 *
 */ var $26dfd8659259598b$var$AbsoluteTxPosition = /** @class */ function(_super) {
    $26dfd8659259598b$var$__extends(AbsoluteTxPosition, _super);
    /**
     * @param block_height
     * @param tx_index
     */ function AbsoluteTxPosition(block_height, tx_index) {
        var _this = _super.call(this) || this;
        _this.block_height = block_height;
        _this.tx_index = tx_index;
        return _this;
    }
    AbsoluteTxPosition.fromAmino = function(data) {
        return new AbsoluteTxPosition(Number.parseInt(data.block_height), Number.parseInt(data.tx_index));
    };
    AbsoluteTxPosition.prototype.toAmino = function() {
        var res = {
            block_height: this.block_height.toFixed(),
            tx_index: this.tx_index.toFixed()
        };
        return res;
    };
    AbsoluteTxPosition.fromData = function(data) {
        return new AbsoluteTxPosition(Number.parseInt(data.block_height), Number.parseInt(data.tx_index));
    };
    AbsoluteTxPosition.prototype.toData = function() {
        var res = {
            block_height: this.block_height.toFixed(),
            tx_index: this.tx_index.toFixed()
        };
        return res;
    };
    AbsoluteTxPosition.fromProto = function(proto) {
        return new AbsoluteTxPosition(proto.blockHeight.toNumber(), proto.txIndex.toNumber());
    };
    AbsoluteTxPosition.prototype.toProto = function() {
        return $odsVG.AbsoluteTxPosition.fromPartial({
            blockHeight: $26dfd8659259598b$var$Long.fromNumber(this.block_height),
            txIndex: $26dfd8659259598b$var$Long.fromNumber(this.tx_index)
        });
    };
    return AbsoluteTxPosition;
}($26Eqx.JSONSerializable);
module.exports.AbsoluteTxPosition = $26dfd8659259598b$var$AbsoluteTxPosition;

});



parcelRegister("7bWhQ", function(module, exports) {
"use strict";
var $53c6c6051ea15262$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $53c6c6051ea15262$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $53c6c6051ea15262$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MintAPI = void 0;

var $6cKfH = parcelRequire("6cKfH");

var $9XrZl = parcelRequire("9XrZl");
var $53c6c6051ea15262$var$MintAPI = /** @class */ function(_super) {
    $53c6c6051ea15262$var$__extends(MintAPI, _super);
    function MintAPI(lcd) {
        var _this = _super.call(this, lcd.apiRequester) || this;
        _this.lcd = lcd;
        return _this;
    }
    /**
     * Gets the current minting inflation value
     */ MintAPI.prototype.inflation = function(params) {
        if (params === void 0) params = {};
        return $53c6c6051ea15262$var$__awaiter(this, void 0, void 0, function() {
            return $53c6c6051ea15262$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/cosmos/mint/v1beta1/inflation", params).then(function(d) {
                        return new $6cKfH.Dec(d.inflation);
                    })
                ];
            });
        });
    };
    /**
     * Gets the current minting annual provisions value
     */ MintAPI.prototype.annualProvisions = function(params) {
        if (params === void 0) params = {};
        return $53c6c6051ea15262$var$__awaiter(this, void 0, void 0, function() {
            return $53c6c6051ea15262$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("cosmos/mint/v1beta1/annual_provisions", params).then(function(d) {
                        return new $6cKfH.Dec(d.annual_provisions);
                    })
                ];
            });
        });
    };
    /**
     * Gets the current minting module's parameters.
     */ MintAPI.prototype.parameters = function(params) {
        if (params === void 0) params = {};
        return $53c6c6051ea15262$var$__awaiter(this, void 0, void 0, function() {
            return $53c6c6051ea15262$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/cosmos/mint/v1beta1/params", params).then(function(_a) {
                        var d = _a.params;
                        return {
                            mint_denom: d.mint_denom,
                            inflation_rate_change: new $6cKfH.Dec(d.inflation_rate_change),
                            inflation_max: new $6cKfH.Dec(d.inflation_max),
                            inflation_min: new $6cKfH.Dec(d.inflation_min),
                            goal_bonded: new $6cKfH.Dec(d.goal_bonded),
                            blocks_per_year: Number.parseInt(d.blocks_per_year)
                        };
                    })
                ];
            });
        });
    };
    return MintAPI;
}($9XrZl.BaseAPI);
module.exports.MintAPI = $53c6c6051ea15262$var$MintAPI;

});

parcelRegister("eBnrF", function(module, exports) {
"use strict";
var $aa16b51b59017ee5$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $aa16b51b59017ee5$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $aa16b51b59017ee5$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IbcAPI = void 0;

var $9XrZl = parcelRequire("9XrZl");

var $2jroW = parcelRequire("2jroW");

var $3mpIx = parcelRequire("3mpIx");

var $9SpmG = parcelRequire("9SpmG");

var $5p0HX = parcelRequire("5p0HX");

var $cz9KI = parcelRequire("cz9KI");
var $aa16b51b59017ee5$var$IbcAPI = /** @class */ function(_super) {
    $aa16b51b59017ee5$var$__extends(IbcAPI, _super);
    function IbcAPI(lcd) {
        var _this = _super.call(this, lcd.apiRequester) || this;
        _this.lcd = lcd;
        return _this;
    }
    /**
     * query all the IBC channels of a chain
     */ IbcAPI.prototype.channels = function(params) {
        if (params === void 0) params = {};
        return $aa16b51b59017ee5$var$__awaiter(this, void 0, void 0, function() {
            return $aa16b51b59017ee5$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/ibc/core/channel/v1/channels", params).then(function(d) {
                        return [
                            d.channels.map($9SpmG.Channel.fromData),
                            d.pagination
                        ];
                    })
                ];
            });
        });
    };
    /**
     * query the information of the port at given channel
     * @param channel_id channel identifier
     * @param port_id port name
     */ IbcAPI.prototype.port = function(channel_id, port_id, params) {
        if (params === void 0) params = {};
        return $aa16b51b59017ee5$var$__awaiter(this, void 0, void 0, function() {
            return $aa16b51b59017ee5$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/ibc/core/channel/v1/channels/".concat(channel_id, "/ports/").concat(port_id), params).then(function(d) {
                        return {
                            channel: $9SpmG.Channel.fromData(d.channel),
                            proof: d.proof,
                            proof_height: $cz9KI.Height.fromData(d.proof_height)
                        };
                    })
                ];
            });
        });
    };
    /**
     *  query all the IBC connections of a chain
     */ IbcAPI.prototype.connections = function(params) {
        if (params === void 0) params = {};
        return $aa16b51b59017ee5$var$__awaiter(this, void 0, void 0, function() {
            return $aa16b51b59017ee5$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/ibc/core/connection/v1/connections", params).then(function(d) {
                        return [
                            d.connections.map($5p0HX.IdentifiedConnection.fromData),
                            d.pagination
                        ];
                    })
                ];
            });
        });
    };
    /**
     * query an IBC connection end
     * @param connection_id connection unique identifier
     */ IbcAPI.prototype.connection = function(connection_id, params) {
        if (params === void 0) params = {};
        return $aa16b51b59017ee5$var$__awaiter(this, void 0, void 0, function() {
            return $aa16b51b59017ee5$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/ibc/core/connection/v1/connections/".concat(connection_id), params).then(function(d) {
                        return $5p0HX.IdentifiedConnection.fromData(d.connection);
                    })
                ];
            });
        });
    };
    /**
     * query all the channels associated with a connection end
     * @param connection_id connection unique identifier
     */ IbcAPI.prototype.connectionChannels = function(connection_id, params) {
        if (params === void 0) params = {};
        return $aa16b51b59017ee5$var$__awaiter(this, void 0, void 0, function() {
            return $aa16b51b59017ee5$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/ibc/core/channel/v1/connections/".concat(connection_id, "/channels"), params).then(function(d) {
                        return [
                            d.channels.map($9SpmG.Channel.fromData),
                            $cz9KI.Height.fromData(d.height),
                            d.pagination
                        ];
                    })
                ];
            });
        });
    };
    /**
     * Gets the current transfer application parameters.
     */ IbcAPI.prototype.parameters = function(params) {
        if (params === void 0) params = {};
        return $aa16b51b59017ee5$var$__awaiter(this, void 0, void 0, function() {
            var url;
            return $aa16b51b59017ee5$var$__generator(this, function(_a) {
                url = this.lcd.config.isClassic ? "/ibc/client/v1/params" : "/ibc/core/client/v1/params";
                return [
                    2 /*return*/ ,
                    this.c.get(url, params).then(function(_a) {
                        var d = _a.params;
                        return {
                            allowed_clients: d.allowed_clients
                        };
                    })
                ];
            });
        });
    };
    /**
     * query all the IBC light clients of a chain
     */ IbcAPI.prototype.clientStates = function(params) {
        if (params === void 0) params = {};
        return $aa16b51b59017ee5$var$__awaiter(this, void 0, void 0, function() {
            return $aa16b51b59017ee5$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/ibc/core/client/v1/client_states", params).then(function(d) {
                        return [
                            d.client_states.map($2jroW.IdentifiedClientState.fromData),
                            d.pagination
                        ];
                    })
                ];
            });
        });
    };
    /**
     * query an IBC light client
     * @param client_id client state unique identifier
     * @returns
     */ IbcAPI.prototype.clientState = function(client_id, params) {
        if (params === void 0) params = {};
        return $aa16b51b59017ee5$var$__awaiter(this, void 0, void 0, function() {
            return $aa16b51b59017ee5$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/ibc/core/client/v1/client_states/".concat(client_id), params).then(function(d) {
                        return $2jroW.IdentifiedClientState.fromData(d.client_state);
                    })
                ];
            });
        });
    };
    /**
     * query the status of an IBC light client
     * @param client_id client state unique identifier
     * @returns
     */ IbcAPI.prototype.clientStatus = function(client_id, params) {
        if (params === void 0) params = {};
        return $aa16b51b59017ee5$var$__awaiter(this, void 0, void 0, function() {
            return $aa16b51b59017ee5$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/ibc/core/client/v1/client_status/".concat(client_id), params).then()
                ];
            });
        });
    };
    /**
     * query all the consensus state associated with a given client
     * @param client_id client identifier
     * @returns
     */ IbcAPI.prototype.consensusStates = function(client_id, params) {
        if (params === void 0) params = {};
        return $aa16b51b59017ee5$var$__awaiter(this, void 0, void 0, function() {
            return $aa16b51b59017ee5$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/ibc/core/client/v1/consensus_states/".concat(client_id), params).then()
                ];
            });
        });
    };
    /**
     * Gets paramaters for interchain account controller.
     * NOTE: CURRENTLY LCD DOESN'T SERVE THE ENDPOINT
    /*
    public async interchainAccountControllerParameters(
      params: APIParams = {}
    ): Promise<ControllerParams> {
      return this.c
        .get<{ params: ControllerParams.Data }>(
          `/ibc/apps/interchain_accounts/controller/v1/params`,
          params
        )
        .then(({ params: d }) => ControllerParams.fromData(d));
    }
    */ /**
     * Gets paramaters for interchain account host.
     */ IbcAPI.prototype.interchainAccountHostParameters = function(params) {
        if (params === void 0) params = {};
        return $aa16b51b59017ee5$var$__awaiter(this, void 0, void 0, function() {
            return $aa16b51b59017ee5$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/ibc/apps/interchain_accounts/host/v1/params", params).then(function(_a) {
                        var d = _a.params;
                        return $3mpIx.Params.fromData(d);
                    })
                ];
            });
        });
    };
    return IbcAPI;
}($9XrZl.BaseAPI);
module.exports.IbcAPI = $aa16b51b59017ee5$var$IbcAPI;

});
parcelRegister("2jroW", function(module, exports) {
"use strict";
var $1af29c73fdf4a1fe$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IdentifiedClientState = void 0;

var $yqmJM = parcelRequire("yqmJM");

var $26Eqx = parcelRequire("26Eqx");
/**
 * IdentifiedClientState defines a client state with an additional client identifier field
 */ var $1af29c73fdf4a1fe$var$IdentifiedClientState = /** @class */ function(_super) {
    $1af29c73fdf4a1fe$var$__extends(IdentifiedClientState, _super);
    /**
     * @param client_id client identifier
     * @param client_state client state
     */ function IdentifiedClientState(client_id, client_state) {
        var _this = _super.call(this) || this;
        _this.client_id = client_id;
        _this.client_state = client_state;
        return _this;
    }
    IdentifiedClientState.fromAmino = function(data) {
        var client_id = data.client_id, client_state = data.client_state;
        return new IdentifiedClientState(client_id, client_state);
    };
    IdentifiedClientState.prototype.toAmino = function() {
        var _a = this, client_id = _a.client_id, client_state = _a.client_state;
        var res = {
            client_id: client_id,
            client_state: client_state
        };
        return res;
    };
    IdentifiedClientState.fromData = function(data) {
        var client_id = data.client_id, client_state = data.client_state;
        return new IdentifiedClientState(client_id, client_state);
    };
    IdentifiedClientState.prototype.toData = function() {
        var _a = this, client_id = _a.client_id, client_state = _a.client_state;
        var res = {
            client_id: client_id,
            client_state: client_state
        };
        return res;
    };
    IdentifiedClientState.fromProto = function(proto) {
        return new IdentifiedClientState(proto.clientId, proto.clientState);
    };
    IdentifiedClientState.prototype.toProto = function() {
        var _a = this, client_id = _a.client_id, client_state = _a.client_state;
        return $yqmJM.IdentifiedClientState.fromPartial({
            clientId: client_id,
            clientState: client_state
        });
    };
    return IdentifiedClientState;
}($26Eqx.JSONSerializable);
module.exports.IdentifiedClientState = $1af29c73fdf4a1fe$var$IdentifiedClientState;

});

parcelRegister("3mpIx", function(module, exports) {
"use strict";
var $2727601db0b84598$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Params = void 0;

var $km6ns = parcelRequire("km6ns");

var $26Eqx = parcelRequire("26Eqx");
/**
 *  Params defines the set of on-chain interchain accounts parameters.
 *  The following parameters may be used to disable the host submodule.
 */ var $2727601db0b84598$var$Params = /** @class */ function(_super) {
    $2727601db0b84598$var$__extends(Params, _super);
    /**
     * @param host_enabled host_enabled enables or disables the host submodule.
     */ function Params(host_enabled, allowed_messages) {
        var _this = _super.call(this) || this;
        _this.host_enabled = host_enabled;
        _this.allowed_messages = allowed_messages;
        return _this;
    }
    Params.fromAmino = function(data) {
        var host_enabled = data.host_enabled, allowed_messages = data.allowed_messages;
        return new Params(host_enabled, allowed_messages);
    };
    Params.prototype.toAmino = function() {
        var _a = this, host_enabled = _a.host_enabled, allowed_messages = _a.allowed_messages;
        var res = {
            host_enabled: host_enabled,
            allowed_messages: allowed_messages
        };
        return res;
    };
    Params.fromData = function(data) {
        var host_enabled = data.host_enabled, allowed_messages = data.allowed_messages;
        return new Params(host_enabled, allowed_messages);
    };
    Params.prototype.toData = function() {
        var _a = this, host_enabled = _a.host_enabled, allowed_messages = _a.allowed_messages;
        var res = {
            host_enabled: host_enabled,
            allowed_messages: allowed_messages
        };
        return res;
    };
    Params.fromProto = function(proto) {
        return new Params(proto.hostEnabled, proto.allowMessages);
    };
    Params.prototype.toProto = function() {
        var _a = this, host_enabled = _a.host_enabled, allowed_messages = _a.allowed_messages;
        return $km6ns.Params.fromPartial({
            hostEnabled: host_enabled,
            allowMessages: allowed_messages
        });
    };
    return Params;
}($26Eqx.JSONSerializable);
module.exports.Params = $2727601db0b84598$var$Params;

});
parcelRegister("km6ns", function(module, exports) {
"use strict";
var $ed1acf1e5c2f9722$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Params = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $ed1acf1e5c2f9722$var$long_1 = $ed1acf1e5c2f9722$var$__importDefault((parcelRequire("9A55m")));

const $ed1acf1e5c2f9722$var$minimal_1 = $ed1acf1e5c2f9722$var$__importDefault((parcelRequire("i2pIU")));
module.exports.protobufPackage = "ibc.applications.interchain_accounts.host.v1";
const $ed1acf1e5c2f9722$var$baseParams = {
    hostEnabled: false,
    allowMessages: ""
};
module.exports.Params = {
    encode (message, writer = $ed1acf1e5c2f9722$var$minimal_1.default.Writer.create()) {
        if (message.hostEnabled === true) writer.uint32(8).bool(message.hostEnabled);
        for (const v of message.allowMessages)writer.uint32(18).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ed1acf1e5c2f9722$var$minimal_1.default.Reader ? input : new $ed1acf1e5c2f9722$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ed1acf1e5c2f9722$var$baseParams);
        message.allowMessages = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hostEnabled = reader.bool();
                    break;
                case 2:
                    message.allowMessages.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ed1acf1e5c2f9722$var$baseParams);
        message.allowMessages = [];
        if (object.hostEnabled !== undefined && object.hostEnabled !== null) message.hostEnabled = Boolean(object.hostEnabled);
        else message.hostEnabled = false;
        if (object.allowMessages !== undefined && object.allowMessages !== null) for (const e of object.allowMessages)message.allowMessages.push(String(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.hostEnabled !== undefined && (obj.hostEnabled = message.hostEnabled);
        if (message.allowMessages) obj.allowMessages = message.allowMessages.map((e)=>e);
        else obj.allowMessages = [];
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $ed1acf1e5c2f9722$var$baseParams);
        message.allowMessages = [];
        if (object.hostEnabled !== undefined && object.hostEnabled !== null) message.hostEnabled = object.hostEnabled;
        else message.hostEnabled = false;
        if (object.allowMessages !== undefined && object.allowMessages !== null) for (const e of object.allowMessages)message.allowMessages.push(e);
        return message;
    }
};
if ($ed1acf1e5c2f9722$var$minimal_1.default.util.Long !== $ed1acf1e5c2f9722$var$long_1.default) {
    $ed1acf1e5c2f9722$var$minimal_1.default.util.Long = $ed1acf1e5c2f9722$var$long_1.default;
    $ed1acf1e5c2f9722$var$minimal_1.default.configure();
}

});


parcelRegister("9SpmG", function(module, exports) {
"use strict";
var $730cd5211d40fb64$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $730cd5211d40fb64$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $730cd5211d40fb64$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$730cd5211d40fb64$var$__exportStar((parcelRequire("2JCWf")), module.exports);

$730cd5211d40fb64$var$__exportStar((parcelRequire("2EhW7")), module.exports);

});
parcelRegister("2EhW7", function(module, exports) {
"use strict";
var $1edd3af9039adf33$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $1edd3af9039adf33$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1edd3af9039adf33$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $1edd3af9039adf33$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $1edd3af9039adf33$var$__createBinding(result, mod, k);
    }
    $1edd3af9039adf33$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PacketId = void 0;

var $cKsix = parcelRequire("cKsix");

var $26Eqx = parcelRequire("26Eqx");

var $1edd3af9039adf33$var$Long = $1edd3af9039adf33$var$__importStar((parcelRequire("9A55m")));
/**
 * PacketId is an identifer for a unique Packet
 * Source chains refer to packets by source port/channel
 * Destination chains refer to packets by destination port/channel
 */ var $1edd3af9039adf33$var$PacketId = /** @class */ function(_super) {
    $1edd3af9039adf33$var$__extends(PacketId, _super);
    /**
     * @param port_id  channel port identifier
     * @param channel_id channel unique identifier
     * @param sequence packet sequence
     */ function PacketId(port_id, channel_id, sequence) {
        var _this = _super.call(this) || this;
        _this.port_id = port_id;
        _this.channel_id = channel_id;
        _this.sequence = sequence;
        return _this;
    }
    PacketId.fromAmino = function(data) {
        var port_id = data.port_id, channel_id = data.channel_id, sequence = data.sequence;
        return new PacketId(port_id, channel_id, Number.parseInt(sequence));
    };
    PacketId.prototype.toAmino = function() {
        var _a = this, port_id = _a.port_id, channel_id = _a.channel_id, sequence = _a.sequence;
        var res = {
            port_id: port_id,
            channel_id: channel_id,
            sequence: sequence.toFixed()
        };
        return res;
    };
    PacketId.fromData = function(data) {
        var port_id = data.port_id, channel_id = data.channel_id, sequence = data.sequence;
        return new PacketId(port_id, channel_id, Number.parseInt(sequence));
    };
    PacketId.prototype.toData = function() {
        var _a = this, port_id = _a.port_id, channel_id = _a.channel_id, sequence = _a.sequence;
        var res = {
            port_id: port_id,
            channel_id: channel_id,
            sequence: sequence.toFixed()
        };
        return res;
    };
    PacketId.fromProto = function(proto) {
        return new PacketId(proto.portId, proto.channelId, proto.sequence.toNumber());
    };
    PacketId.prototype.toProto = function() {
        var _a = this, port_id = _a.port_id, channel_id = _a.channel_id, sequence = _a.sequence;
        return $cKsix.PacketId.fromPartial({
            portId: port_id,
            channelId: channel_id,
            sequence: $1edd3af9039adf33$var$Long.fromNumber(sequence)
        });
    };
    return PacketId;
}($26Eqx.JSONSerializable);
module.exports.PacketId = $1edd3af9039adf33$var$PacketId;

});


parcelRegister("5p0HX", function(module, exports) {
"use strict";
var $3eefd6298810f70e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3eefd6298810f70e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $3eefd6298810f70e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$3eefd6298810f70e$var$__exportStar((parcelRequire("6pjkd")), module.exports);

$3eefd6298810f70e$var$__exportStar((parcelRequire("gwXuB")), module.exports);

$3eefd6298810f70e$var$__exportStar((parcelRequire("aR4Xe")), module.exports);

});
parcelRegister("aR4Xe", function(module, exports) {
"use strict";
var $7e72b2760e73d258$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $7e72b2760e73d258$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IdentifiedConnection = module.exports.stateToJSON = module.exports.stateFromJSON = module.exports.State = void 0;

var $8WoN3 = parcelRequire("8WoN3");

var $26Eqx = parcelRequire("26Eqx");

var $gwXuB = parcelRequire("gwXuB");

var $8WoN3 = parcelRequire("8WoN3");
Object.defineProperty(module.exports, "State", {
    enumerable: true,
    get: function() {
        return $8WoN3.State;
    }
});
Object.defineProperty(module.exports, "stateFromJSON", {
    enumerable: true,
    get: function() {
        return $8WoN3.stateFromJSON;
    }
});
Object.defineProperty(module.exports, "stateToJSON", {
    enumerable: true,
    get: function() {
        return $8WoN3.stateToJSON;
    }
});

var $6pjkd = parcelRequire("6pjkd");

var $7e72b2760e73d258$var$long_1 = $7e72b2760e73d258$var$__importDefault((parcelRequire("9A55m")));
/**
 * IdentifiedConnection defines a connection with additional connection identifier field
 */ var $7e72b2760e73d258$var$IdentifiedConnection = /** @class */ function(_super) {
    $7e72b2760e73d258$var$__extends(IdentifiedConnection, _super);
    /**
     * @param id connection identifier
     * @param client_id client associated with this connection.
     * @param versions IBC version which can be utilised to determine encodings or protocols for channels or packets utilising this connection
     * @param state current state of the connection end
     * @param counterparty counterparty chain associated with this connection
     * @param delay_period delay period associated with this connection
     */ function IdentifiedConnection(id, client_id, versions, state, counterparty, delay_period) {
        var _this = _super.call(this) || this;
        _this.id = id;
        _this.client_id = client_id;
        _this.versions = versions;
        _this.state = state;
        _this.counterparty = counterparty;
        _this.delay_period = delay_period;
        return _this;
    }
    IdentifiedConnection.fromAmino = function(data) {
        var id = data.id, client_id = data.client_id, versions = data.versions, state = data.state, counterparty = data.counterparty, delay_period = data.delay_period;
        return new IdentifiedConnection(id, client_id, versions.map($gwXuB.Version.fromAmino), (0, $8WoN3.stateFromJSON)(state), counterparty ? $6pjkd.Counterparty.fromAmino(counterparty) : undefined, Number.parseInt(delay_period));
    };
    IdentifiedConnection.prototype.toAmino = function() {
        var _a = this, id = _a.id, client_id = _a.client_id, versions = _a.versions, state = _a.state, counterparty = _a.counterparty, delay_period = _a.delay_period;
        var res = {
            id: id,
            client_id: client_id,
            versions: versions.map(function(version) {
                return version.toAmino();
            }),
            state: (0, $8WoN3.stateToJSON)(state),
            counterparty: counterparty === null || counterparty === void 0 ? void 0 : counterparty.toAmino(),
            delay_period: delay_period.toFixed()
        };
        return res;
    };
    IdentifiedConnection.fromData = function(data) {
        var id = data.id, client_id = data.client_id, versions = data.versions, state = data.state, counterparty = data.counterparty, delay_period = data.delay_period;
        return new IdentifiedConnection(id, client_id, versions.map($gwXuB.Version.fromData), (0, $8WoN3.stateFromJSON)(state), counterparty ? $6pjkd.Counterparty.fromData(counterparty) : undefined, Number.parseInt(delay_period));
    };
    IdentifiedConnection.prototype.toData = function() {
        var _a = this, id = _a.id, client_id = _a.client_id, versions = _a.versions, state = _a.state, counterparty = _a.counterparty, delay_period = _a.delay_period;
        var res = {
            id: id,
            client_id: client_id,
            versions: versions.map(function(version) {
                return version.toData();
            }),
            state: (0, $8WoN3.stateToJSON)(state),
            counterparty: counterparty === null || counterparty === void 0 ? void 0 : counterparty.toData(),
            delay_period: delay_period.toFixed()
        };
        return res;
    };
    IdentifiedConnection.fromProto = function(proto) {
        return new IdentifiedConnection(proto.id, proto.clientId, proto.versions.map($gwXuB.Version.fromProto), proto.state, proto.counterparty ? $6pjkd.Counterparty.fromProto(proto.counterparty) : undefined, proto.delayPeriod.toNumber());
    };
    IdentifiedConnection.prototype.toProto = function() {
        var _a = this, id = _a.id, client_id = _a.client_id, versions = _a.versions, state = _a.state, counterparty = _a.counterparty, delay_period = _a.delay_period;
        return $8WoN3.IdentifiedConnection.fromPartial({
            id: id,
            clientId: client_id,
            versions: versions.map(function(v) {
                return v.toProto();
            }),
            state: state,
            counterparty: counterparty === null || counterparty === void 0 ? void 0 : counterparty.toProto(),
            delayPeriod: $7e72b2760e73d258$var$long_1.default.fromNumber(delay_period)
        });
    };
    return IdentifiedConnection;
}($26Eqx.JSONSerializable);
module.exports.IdentifiedConnection = $7e72b2760e73d258$var$IdentifiedConnection;

});



parcelRegister("e9FVi", function(module, exports) {
"use strict";
var $a4e26d0527b19b4b$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $a4e26d0527b19b4b$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a4e26d0527b19b4b$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IbcTransferAPI = void 0;

var $9XrZl = parcelRequire("9XrZl");

var $lqRDX = parcelRequire("lqRDX");
var $a4e26d0527b19b4b$var$IbcTransferAPI = /** @class */ function(_super) {
    $a4e26d0527b19b4b$var$__extends(IbcTransferAPI, _super);
    function IbcTransferAPI(lcd) {
        var _this = _super.call(this, lcd.apiRequester) || this;
        _this.lcd = lcd;
        return _this;
    }
    /** Gets a denomTrace for the hash */ IbcTransferAPI.prototype.denomTrace = function(hash) {
        return $a4e26d0527b19b4b$var$__awaiter(this, void 0, void 0, function() {
            return $a4e26d0527b19b4b$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/ibc/apps/transfer/v1/denom_traces/".concat(hash)).then(function(d) {
                        return $lqRDX.DenomTrace.fromData(d.denom_trace);
                    })
                ];
            });
        });
    };
    /** Gets a list of denomTraces */ IbcTransferAPI.prototype.denomTraces = function(params) {
        if (params === void 0) params = {};
        return $a4e26d0527b19b4b$var$__awaiter(this, void 0, void 0, function() {
            return $a4e26d0527b19b4b$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/ibc/apps/transfer/v1/denom_traces", params).then(function(d) {
                        return [
                            d.denom_traces.map($lqRDX.DenomTrace.fromData),
                            d.pagination
                        ];
                    })
                ];
            });
        });
    };
    /** Gets a denomination hash information */ IbcTransferAPI.prototype.denomHash = function(trace, params) {
        if (params === void 0) params = {};
        return $a4e26d0527b19b4b$var$__awaiter(this, void 0, void 0, function() {
            return $a4e26d0527b19b4b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.lcd.config.isClassic) throw new Error("Not supported for the network");
                        return [
                            4 /*yield*/ ,
                            this.c.get("/ibc/apps/transfer/v1/denom_hashes/".concat(trace), params)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    /**
     * Gets the current transfer application parameters.
     */ IbcTransferAPI.prototype.parameters = function(params) {
        if (params === void 0) params = {};
        return $a4e26d0527b19b4b$var$__awaiter(this, void 0, void 0, function() {
            return $a4e26d0527b19b4b$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.c.get("/ibc/apps/transfer/v1/params", params).then(function(_a) {
                        var d = _a.params;
                        return {
                            send_enabled: d.send_enabled,
                            receive_enabled: d.receive_enabled
                        };
                    })
                ];
            });
        });
    };
    return IbcTransferAPI;
}($9XrZl.BaseAPI);
module.exports.IbcTransferAPI = $a4e26d0527b19b4b$var$IbcTransferAPI;

});


parcelRegister("dGqih", function(module, exports) {
"use strict";
var $9f639806fed70313$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $9f639806fed70313$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LCDUtils = void 0;

var $7yVzo = parcelRequire("7yVzo");

var $5iXRZ = parcelRequire("5iXRZ");
var $9f639806fed70313$var$LCDUtils = /** @class */ function() {
    function LCDUtils(lcd) {
        this.lcd = lcd;
    }
    /**
     * Calculates the tax that would be applied for the Coin if sent.
     * Tax = min(taxCap, taxRate * amount)
     * @param coin
     */ LCDUtils.prototype.calculateTax = function(coin) {
        return $9f639806fed70313$var$__awaiter(this, void 0, void 0, function() {
            var rate, cap;
            return $9f639806fed70313$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.lcd.treasury.taxRate()
                        ];
                    case 1:
                        rate = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.lcd.treasury.taxCap(coin.denom)
                        ];
                    case 2:
                        cap = _a.sent();
                        return [
                            2 /*return*/ ,
                            new $7yVzo.Coin(coin.denom, $5iXRZ.Int.ceil($5iXRZ.Dec.min(coin.amount.mul(rate), cap.amount)))
                        ];
                }
            });
        });
    };
    /**
     * Gets current validators and merges their voting power from the validator set query.
     */ LCDUtils.prototype.validatorsWithVotingPower = function() {
        return $9f639806fed70313$var$__awaiter(this, void 0, void 0, function() {
            var validatorSet, validatorSetByPubKey, validators, next_key, validatorsRes, res, _i, validators_1, v, delegateInfo;
            return $9f639806fed70313$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.lcd.tendermint.validatorSet()
                        ];
                    case 1:
                        validatorSet = _a.sent()[0];
                        validatorSetByPubKey = validatorSet.reduce(function(m, o) {
                            m[o.pub_key.key] = o;
                            return m;
                        }, {});
                        validators = [];
                        _a.label = 2;
                    case 2:
                        return [
                            4 /*yield*/ ,
                            this.lcd.staking.validators({
                                "pagination.key": next_key
                            })
                        ];
                    case 3:
                        validatorsRes = _a.sent();
                        validators.push.apply(validators, validatorsRes[0]);
                        if (!validatorsRes[1].next_key) return [
                            3 /*break*/ ,
                            5
                        ];
                        next_key = validatorsRes[1].next_key;
                        _a.label = 4;
                    case 4:
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 5:
                        res = {};
                        for(_i = 0, validators_1 = validators; _i < validators_1.length; _i++){
                            v = validators_1[_i];
                            delegateInfo = validatorSetByPubKey[v.consensus_pubkey.toData().key];
                            if (delegateInfo === undefined) continue;
                            res[v.operator_address] = {
                                validatorInfo: v,
                                votingPower: Number.parseInt(delegateInfo.voting_power),
                                proposerPriority: Number.parseInt(delegateInfo.proposer_priority)
                            };
                        }
                        return [
                            2 /*return*/ ,
                            res
                        ];
                }
            });
        });
    };
    return LCDUtils;
}();
module.exports.LCDUtils = $9f639806fed70313$var$LCDUtils;

});

parcelRegister("jeC9j", function(module, exports) {
"use strict";
var $e00ceac3b9fbc2b7$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $e00ceac3b9fbc2b7$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Wallet = void 0;

var $cQRUh = parcelRequire("cQRUh");
var $e00ceac3b9fbc2b7$var$Wallet = /** @class */ function() {
    function Wallet(lcd, key) {
        this.lcd = lcd;
        this.key = key;
    }
    Wallet.prototype.accountNumberAndSequence = function() {
        return this.lcd.auth.accountInfo(this.key.accAddress).then(function(d) {
            return {
                account_number: d.getAccountNumber(),
                sequence: d.getSequenceNumber()
            };
        });
    };
    Wallet.prototype.accountNumber = function() {
        return this.lcd.auth.accountInfo(this.key.accAddress).then(function(d) {
            return d.getAccountNumber();
        });
    };
    Wallet.prototype.sequence = function() {
        return this.lcd.auth.accountInfo(this.key.accAddress).then(function(d) {
            return d.getSequenceNumber();
        });
    };
    Wallet.prototype.createTx = function(options) {
        return $e00ceac3b9fbc2b7$var$__awaiter(this, void 0, void 0, function() {
            return $e00ceac3b9fbc2b7$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.lcd.tx.create([
                        {
                            address: this.key.accAddress,
                            sequenceNumber: options.sequence,
                            publicKey: this.key.publicKey
                        }
                    ], options)
                ];
            });
        });
    };
    Wallet.prototype.createAndSignTx = function(options) {
        return $e00ceac3b9fbc2b7$var$__awaiter(this, void 0, void 0, function() {
            var accountNumber, sequence, res, tx;
            return $e00ceac3b9fbc2b7$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        accountNumber = options.accountNumber;
                        sequence = options.sequence;
                        if (!(accountNumber === undefined || sequence === undefined)) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.accountNumberAndSequence()
                        ];
                    case 1:
                        res = _a.sent();
                        if (accountNumber === undefined) accountNumber = res.account_number;
                        if (sequence === undefined) sequence = res.sequence;
                        _a.label = 2;
                    case 2:
                        options.sequence = sequence;
                        options.accountNumber = accountNumber;
                        return [
                            4 /*yield*/ ,
                            this.createTx(options)
                        ];
                    case 3:
                        tx = _a.sent();
                        return [
                            2 /*return*/ ,
                            this.key.signTx(tx, {
                                accountNumber: accountNumber,
                                sequence: sequence,
                                chainID: this.lcd.config.chainID,
                                signMode: options.signMode || $cQRUh.SignMode.SIGN_MODE_DIRECT
                            }, this.lcd.config.isClassic)
                        ];
                }
            });
        });
    };
    return Wallet;
}();
module.exports.Wallet = $e00ceac3b9fbc2b7$var$Wallet;

});


parcelRegister("39bNt", function(module, exports) {
"use strict";
var $24ab5cfdfaf758b9$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LocalTerra = void 0;

var $6o8js = parcelRequire("6o8js");

var $j4gpb = parcelRequire("j4gpb");
var $24ab5cfdfaf758b9$var$LOCALTERRA_MNEMONICS = {
    validator: "satisfy adjust timber high purchase tuition stool faith fine install that you unaware feed domain license impose boss human eager hat rent enjoy dawn",
    test1: "notice oak worry limit wrap speak medal online prefer cluster roof addict wrist behave treat actual wasp year salad speed social layer crew genius",
    test2: "quality vacuum heart guard buzz spike sight swarm shove special gym robust assume sudden deposit grid alcohol choice devote leader tilt noodle tide penalty",
    test3: "symbol force gallery make bulk round subway violin worry mixture penalty kingdom boring survey tool fringe patrol sausage hard admit remember broken alien absorb",
    test4: "bounce success option birth apple portion aunt rural episode solution hockey pencil lend session cause hedgehog slender journey system canvas decorate razor catch empty",
    test5: "second render cat sing soup reward cluster island bench diet lumber grocery repeat balcony perfect diesel stumble piano distance caught occur example ozone loyal",
    test6: "spatial forest elevator battle also spoon fun skirt flight initial nasty transfer glory palm drama gossip remove fan joke shove label dune debate quick",
    test7: "noble width taxi input there patrol clown public spell aunt wish punch moment will misery eight excess arena pen turtle minimum grain vague inmate",
    test8: "cream sport mango believe inhale text fish rely elegant below earth april wall rug ritual blossom cherry detail length blind digital proof identify ride",
    test9: "index light average senior silent limit usual local involve delay update rack cause inmate wall render magnet common feature laundry exact casual resource hundred",
    test10: "prefer forget visit mistake mixture feel eyebrow autumn shop pair address airport diesel street pass vague innocent poem method awful require hurry unhappy shoulder"
};
var $24ab5cfdfaf758b9$var$LocalTerra = /** @class */ function(_super) {
    $24ab5cfdfaf758b9$var$__extends(LocalTerra, _super);
    function LocalTerra(isClassic) {
        var _this = _super.call(this, {
            URL: "http://localhost:1317",
            chainID: "localterra",
            isClassic: isClassic
        }) || this;
        _this.wallets = {
            validator: _this.wallet(new $j4gpb.MnemonicKey({
                mnemonic: $24ab5cfdfaf758b9$var$LOCALTERRA_MNEMONICS.validator
            })),
            test1: _this.wallet(new $j4gpb.MnemonicKey({
                mnemonic: $24ab5cfdfaf758b9$var$LOCALTERRA_MNEMONICS.test1
            })),
            test2: _this.wallet(new $j4gpb.MnemonicKey({
                mnemonic: $24ab5cfdfaf758b9$var$LOCALTERRA_MNEMONICS.test2
            })),
            test3: _this.wallet(new $j4gpb.MnemonicKey({
                mnemonic: $24ab5cfdfaf758b9$var$LOCALTERRA_MNEMONICS.test3
            })),
            test4: _this.wallet(new $j4gpb.MnemonicKey({
                mnemonic: $24ab5cfdfaf758b9$var$LOCALTERRA_MNEMONICS.test4
            })),
            test5: _this.wallet(new $j4gpb.MnemonicKey({
                mnemonic: $24ab5cfdfaf758b9$var$LOCALTERRA_MNEMONICS.test5
            })),
            test6: _this.wallet(new $j4gpb.MnemonicKey({
                mnemonic: $24ab5cfdfaf758b9$var$LOCALTERRA_MNEMONICS.test6
            })),
            test7: _this.wallet(new $j4gpb.MnemonicKey({
                mnemonic: $24ab5cfdfaf758b9$var$LOCALTERRA_MNEMONICS.test7
            })),
            test8: _this.wallet(new $j4gpb.MnemonicKey({
                mnemonic: $24ab5cfdfaf758b9$var$LOCALTERRA_MNEMONICS.test8
            })),
            test9: _this.wallet(new $j4gpb.MnemonicKey({
                mnemonic: $24ab5cfdfaf758b9$var$LOCALTERRA_MNEMONICS.test9
            })),
            test10: _this.wallet(new $j4gpb.MnemonicKey({
                mnemonic: $24ab5cfdfaf758b9$var$LOCALTERRA_MNEMONICS.test10
            }))
        };
        return _this;
    }
    return LocalTerra;
}($6o8js.LCDClient);
module.exports.LocalTerra = $24ab5cfdfaf758b9$var$LocalTerra;

});

parcelRegister("bcWXs", function(module, exports) {
"use strict";
var $828e8c86e03c71f2$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $828e8c86e03c71f2$var$__assign = module.exports && module.exports.__assign || function() {
    $828e8c86e03c71f2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $828e8c86e03c71f2$var$__assign.apply(this, arguments);
};
var $828e8c86e03c71f2$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WebSocketClient = void 0;

var $wvaTc = parcelRequire("wvaTc");

var $828e8c86e03c71f2$var$ws_1 = $828e8c86e03c71f2$var$__importDefault((parcelRequire("1rfCi")));

var $4OXyF = parcelRequire("4OXyF");
var $828e8c86e03c71f2$var$escapeSingleQuotes = function(str) {
    return str.replace(/'/g, "\\'");
};
function $828e8c86e03c71f2$var$makeQueryParams(query) {
    var queryBuilder = [];
    for(var _i = 0, _a = Object.keys(query); _i < _a.length; _i++){
        var key = _a[_i];
        var queryItem = void 0;
        var value = query[key];
        // if value is scalar
        if (!Array.isArray(value)) switch(typeof value){
            case "number":
                queryItem = "".concat(key, "=").concat(value);
                break;
            case "string":
                queryItem = "".concat(key, "='").concat($828e8c86e03c71f2$var$escapeSingleQuotes(value), "'");
                break;
            default:
                // Date
                queryItem = "".concat(key, "=").concat(value.toISOString());
        }
        else switch(value[0]){
            case ">":
            case "<":
            case "<=":
            case ">=":
                if (typeof value[1] !== "number") queryItem = "".concat(key).concat(value[0]).concat(value[1].toISOString());
                else queryItem = "".concat(key).concat(value[0]).concat(value[1]);
                break;
            case "CONTAINS":
                queryItem = "".concat(key, " CONTAINS '").concat($828e8c86e03c71f2$var$escapeSingleQuotes(value[1]), "'");
                break;
            case "EXISTS":
                queryItem = "".concat(key, " EXISTS");
                break;
        }
        queryBuilder.push(queryItem);
    }
    return queryBuilder.join(" AND ");
}
/**
 * An object repesenting a connection to a Terra node's WebSocket RPC endpoint.
 * This allows for subscribing to Tendermint events through WebSocket.
 *
 * ### Events
 * **error** emitted when error raises
 * **connect** emitted after connection establishment
 * **reconnect** emitted upon every attempt of reconnection
 * **destroyed** emitted when socket has been destroyed
 *
 * ### Example
 *
 * ```ts
 * import { WebSocketClient } from '@terra-money/terra.js';
 *
 * const wsclient = new WebSocketClient("ws://localhost:26657/websocket");
 *
 * wsclient.subscribe('NewBlock', {}, (data) => {
 *    console.log(data.value);
 *
 *    // close after receiving one block.
 *    wsclient.destroy();
 * })
 *
 * wsclient.subscribe(
 * 'Tx',
 *  {
 *    'message.action': 'send',
 *    'message.sender': ['CONTAINS', 'terra1...'],
 *  },
 *  (data) => {
 *    console.log(data.value);
 *
 *   // close after receiving one send Tx
 *   wsclient.destroy();
 * });
 *
 * wsclient.start();
 * ```
 */ var $828e8c86e03c71f2$var$WebSocketClient = /** @class */ function(_super) {
    $828e8c86e03c71f2$var$__extends(WebSocketClient, _super);
    /**
     * WebSocketClient constructor
     * @param URL The WebSocket endpoint URL on the Tendermint RPC server.
     *            Ex: ws://localhost:26657/websocket
     * @param reconnectCount 0 for not to attempt reconnect, -1 for infinite, > 0 for number of times to attempt
     * @param reconnectInterval retry interval in milliseconds
     */ function WebSocketClient(URL, reconnectCount, reconnectInterval) {
        if (reconnectCount === void 0) reconnectCount = 0;
        if (reconnectInterval === void 0) reconnectInterval = 1000;
        var _this = _super.call(this) || this;
        _this.URL = URL;
        _this.reconnectCount = reconnectCount;
        _this.reconnectInterval = reconnectInterval;
        _this._reconnectCount = _this.reconnectCount;
        _this.isConnected = false;
        _this.shouldAttemptReconnect = !!_this.reconnectInterval;
        return _this;
    }
    /**
     * Destroys class as well as socket
     */ WebSocketClient.prototype.destroy = function() {
        this.shouldAttemptReconnect = false;
        this.reconnectTimeoutId && clearTimeout(this.reconnectTimeoutId);
        this.socket && this.socket.close();
    };
    WebSocketClient.prototype.start = function() {
        this.socket = new $828e8c86e03c71f2$var$ws_1.default(this.URL);
        this.socket.onopen = this.onOpen.bind(this);
        this.socket.onmessage = this.onMessage.bind(this);
        this.socket.onclose = this.onClose.bind(this);
        this.socket.onerror = function() {
            return undefined;
        };
    };
    WebSocketClient.prototype.onOpen = function() {
        this.isConnected = true;
        this.emit("connect");
        // reset reconnectCount after connection establishment
        this._reconnectCount = this.reconnectCount;
        this.socket.send(JSON.stringify({
            jsonrpc: "2.0",
            method: "subscribe",
            params: [
                this.queryParams
            ],
            id: 1
        }));
    };
    WebSocketClient.prototype.onMessage = function(message) {
        try {
            var parsedData = JSON.parse(message.data.toString());
            if (this.callback && parsedData.result && parsedData.result.query === this.queryParams) // this.emit('message', parsedData.result.data);
            this.callback(parsedData.result.data);
        } catch (err) {
            this.emit("error", err);
        }
    };
    WebSocketClient.prototype.onClose = function() {
        var _this = this;
        this.isConnected = false;
        if (this.shouldAttemptReconnect && (this._reconnectCount > 0 || this._reconnectCount === -1)) {
            if (this._reconnectCount !== -1) this._reconnectCount--;
            this.reconnectTimeoutId && clearTimeout(this.reconnectTimeoutId);
            this.reconnectTimeoutId = setTimeout(function() {
                _this.emit("reconnect");
                _this.start();
            }, this.reconnectInterval);
        } else this.emit("destroyed");
    };
    WebSocketClient.prototype.subscribe = function(event, query, callback) {
        this.queryParams = $828e8c86e03c71f2$var$makeQueryParams($828e8c86e03c71f2$var$__assign({
            "tm.event": event
        }, query));
        this.callback = callback;
    };
    WebSocketClient.prototype.subscribeTx = function(query, callback) {
        var newCallback = function(d) {
            d.value.TxResult.txhash = (0, $4OXyF.hashToHex)(d.value.TxResult.tx);
            return callback(d);
        };
        this.subscribe("Tx", query, newCallback);
    };
    return WebSocketClient;
}($wvaTc.EventEmitter);
module.exports.WebSocketClient = $828e8c86e03c71f2$var$WebSocketClient;

});
parcelRegister("1rfCi", function(module, exports) {
"use strict";
module.exports = function() {
    throw new Error("ws does not work in the browser. Browser clients must use the native WebSocket object");
};

});



parcelRegister("cufBA", function(module, exports) {
"use strict";
var $917464424774e1a6$var$__assign = module.exports && module.exports.__assign || function() {
    $917464424774e1a6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $917464424774e1a6$var$__assign.apply(this, arguments);
};
var $917464424774e1a6$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $917464424774e1a6$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $917464424774e1a6$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Extension = void 0;

var $917464424774e1a6$var$PostMessageStream_1 = $917464424774e1a6$var$__importDefault((parcelRequire("cz5bM")));
/**
 * Extension class is for communicating between page and extension
 */ var $917464424774e1a6$var$Extension = /** @class */ function() {
    function Extension(identifier) {
        if (identifier === void 0) identifier = "station";
        this.inpageStream = new $917464424774e1a6$var$PostMessageStream_1.default({
            name: "".concat(identifier, ":inpage"),
            target: "".concat(identifier, ":content")
        });
    }
    Extension.prototype.destroy = function() {
        this.inpageStream && this.inpageStream.destroy();
    };
    Extension.prototype.generateId = function() {
        return Date.now();
    };
    Object.defineProperty(Extension.prototype, "isAvailable", {
        /**
         * Indicates the Station Extension is installed and availble (requires extension v1.1 or later)
         */ get: function() {
            return !!window.isTerraExtensionAvailable;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * low level function for sending message to extension.
     * Do not use this function unless you know what you are doing.
     */ Extension.prototype.send = function(type, data) {
        var id = this.generateId();
        this.inpageStream.write($917464424774e1a6$var$__assign($917464424774e1a6$var$__assign({}, data), {
            id: id,
            type: type
        }));
        return id;
    };
    Extension.prototype.on = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        this.inpageStream.on("data", function(data) {
            if (typeof args[0] === "string") data.name === args[0] && args[1](data.payload, data.name);
            else args[0](data.payload, data.name);
        });
    };
    Extension.prototype.once = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        this.inpageStream.once("data", function(data) {
            if (typeof args[0] === "string") data.name === args[0] && args[1](data.payload, data.name);
            else args[0](data.payload, data.name);
        });
    };
    /**
     * Send a request
     *
     * @param {SendDataType} type
     * @param {SendData} data
     */ Extension.prototype.request = function(type, data) {
        return $917464424774e1a6$var$__awaiter(this, void 0, void 0, function() {
            var _this = this;
            return $917464424774e1a6$var$__generator(this, function(_a) {
                this.send(type, data);
                return [
                    2 /*return*/ ,
                    new Promise(function(resolve) {
                        _this.inpageStream.once("data", resolve);
                    })
                ];
            });
        });
    };
    /**
     * Request to Station Extension for connecting a wallet
     *
     * @return {string}     name      'onConnect'
     * @return {AccAddress} payload   Terra account address
     */ Extension.prototype.connect = function() {
        return this.send("connect");
    };
    /**
     * Request for Station Extension information
     *
     * @return {object}  payload.network
     * @return {string}  payload.network.name    Name of the network
     * @return {string}  payload.network.chainId Chain ID
     * @return {string}  payload.network.lcd     LCD address
     * @return {string}  payload.network.fcd     FCD address
     * @return {string}  payload.network.ws      Websocket address
     */ Extension.prototype.info = function() {
        return this.send("info");
    };
    /**
     * Request for signing tx
     *
     * @return {string}  name               'onSign'
     * @return {object}  payload
     * @return {number}  payload.id         identifier
     * @return {string}  payload.origin     origin address
     * @return {Msg[]}   payload.msgs       requested msgs
     * @return {boolean} payload.success
     * @return {string}  payload.result.public_key Base64 encoded public key
     * @return {string}  payload.result.signature  Base64 encoded signature
     * @return {number}  payload.result.recid      Recovery id
     * @return {StdSignMsg.Data} payload.result.stdSignMsgData
     */ Extension.prototype.sign = function(options) {
        var _a, _b, _c;
        return this.send("sign", $917464424774e1a6$var$__assign($917464424774e1a6$var$__assign({}, options), {
            msgs: options.msgs.map(function(msg) {
                return msg.toJSON(options.isClassic);
            }),
            fee: (_a = options.fee) === null || _a === void 0 ? void 0 : _a.toJSON(),
            memo: options.memo,
            gasPrices: (_b = options.gasPrices) === null || _b === void 0 ? void 0 : _b.toString(),
            gasAdjustment: (_c = options.gasAdjustment) === null || _c === void 0 ? void 0 : _c.toString(),
            account_number: options.accountNumber,
            sequence: options.sequence,
            waitForConfirmation: options.waitForConfirmation,
            purgeQueue: options.purgeQueue
        }));
    };
    /**
     * Request for signing bytes
     *
     * @return {string}  name               'onSign'
     * @return {object}  payload
     * @return {number}  payload.id         identifier
     * @return {string}  payload.origin     origin address
     * @return {Msg[]}   payload.msgs       requested msgs
     * @return {boolean} payload.success
     * @return {string}  payload.result.public_key Base64 encoded public key
     * @return {string}  payload.result.signature  Base64 encoded signature
     * @return {number}  payload.result.recid      Recovery id
     */ Extension.prototype.signBytes = function(options) {
        return this.send("sign", {
            bytes: options.bytes.toString("base64"),
            purgeQueue: options.purgeQueue
        });
    };
    /**
     * Request for sign and post to LCD server
     *
     * @return {string}  name                   'onPost'
     * @return {object}  payload
     * @return {number}  payload.id             identifier
     * @return {string}  payload.origin         origin address
     * @return {Msg[]}   payload.msgs           requested msgs
     * @return {boolean} payload.success
     * @return {number|undefined} payload.result.code
     *                                          error code. undefined with successful tx
     * @return {string}  payload.result.raw_log raw log
     * @return {string}  payload.result.txhash  transaction hash
     */ Extension.prototype.post = function(options) {
        var _a, _b, _c;
        return this.send("post", {
            msgs: options.msgs.map(function(msg) {
                return msg.toJSON(options.isClassic);
            }),
            fee: (_a = options.fee) === null || _a === void 0 ? void 0 : _a.toJSON(),
            memo: options.memo,
            gasPrices: (_b = options.gasPrices) === null || _b === void 0 ? void 0 : _b.toString(),
            gasAdjustment: (_c = options.gasAdjustment) === null || _c === void 0 ? void 0 : _c.toString(),
            account_number: options.accountNumber,
            sequence: options.sequence,
            waitForConfirmation: options.waitForConfirmation,
            purgeQueue: options.purgeQueue
        });
    };
    return Extension;
}();
module.exports.Extension = $917464424774e1a6$var$Extension;

});
parcelRegister("cz5bM", function(module, exports) {
"use strict";
var $925cc75537933101$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $CyGSj = parcelRequire("CyGSj");
var $925cc75537933101$var$noop = function() {
    return undefined;
};
var $925cc75537933101$var$PostMessageStream = /** @class */ function(_super) {
    $925cc75537933101$var$__extends(PostMessageStream, _super);
    function PostMessageStream(_a) {
        var name = _a.name, target = _a.target, targetWindow = _a.targetWindow;
        var _this = _super.call(this, {
            objectMode: true
        }) || this;
        _this._name = name;
        _this._target = target;
        _this._targetWindow = targetWindow || window;
        _this._origin = targetWindow ? "*" : location.origin;
        // initialization flags
        _this._init = false;
        _this._haveSyn = false;
        _this._onMessage = _this._onMessage.bind(_this);
        window.addEventListener("message", _this._onMessage, false);
        // send syncorization message
        _this._write("SYN", null, $925cc75537933101$var$noop);
        _this.cork();
        return _this;
    }
    PostMessageStream.prototype._destroy = function() {
        // console.log('PostMessageStream: destroy');
        window.removeEventListener("message", this._onMessage, false);
    };
    PostMessageStream.prototype._onMessage = function(event) {
        var msg = event.data;
        // validate message
        if (this._origin !== "*" && event.origin !== this._origin) return;
        if (event.source !== this._targetWindow) return;
        if (typeof msg !== "object") return;
        if (msg.target !== this._name) return;
        if (!msg.data) return;
        if (!this._init) {
            if (msg.data === "SYN") {
                this._haveSyn = true;
                this._write("ACK", null, $925cc75537933101$var$noop);
            } else if (msg.data === "ACK") {
                this._init = true;
                if (!this._haveSyn) this._write("ACK", null, $925cc75537933101$var$noop);
                this.uncork();
            }
        } else // forward message
        try {
            this.push(msg.data);
        } catch (err) {
            this.emit("error", err);
        }
    };
    PostMessageStream.prototype._read = function() {
        return undefined;
    };
    PostMessageStream.prototype._write = function(data, _encoding, cb) {
        var message = {
            target: this._target,
            data: data
        };
        this._targetWindow.postMessage(message, this._origin);
        cb(null);
    };
    return PostMessageStream;
}($CyGSj.Duplex);
module.exports.default = $925cc75537933101$var$PostMessageStream;

});


parcelRegister("lNUVY", function(module, exports) {
"use strict";
var $fdfa567a3c9915af$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fdfa567a3c9915af$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $fdfa567a3c9915af$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$fdfa567a3c9915af$var$__exportStar((parcelRequire("4OXyF")), module.exports);

$fdfa567a3c9915af$var$__exportStar((parcelRequire("3nRat")), module.exports);

});
parcelRegister("3nRat", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getContractEvents = module.exports.getContractAddress = module.exports.getCodeId = void 0;

var $lg08O = parcelRequire("lg08O");
function $276cc323146615b7$var$getCodeId(txResult, msgIndex) {
    if (msgIndex === void 0) msgIndex = 0;
    if ((0, $lg08O.isTxError)(txResult) || txResult.logs === undefined || txResult.logs.length === 0) throw new Error("could not parse code id -- tx logs are empty.");
    var codeId = txResult.logs[msgIndex].eventsByType["store_code"]["code_id"][0];
    return codeId;
}
module.exports.getCodeId = $276cc323146615b7$var$getCodeId;
function $276cc323146615b7$var$getContractAddress(txResult, msgIndex, isClassic) {
    if (msgIndex === void 0) msgIndex = 0;
    if (isClassic === void 0) isClassic = false;
    if ((0, $lg08O.isTxError)(txResult) || txResult.logs === undefined || txResult.logs.length === 0) throw new Error("could not parse contract address -- tx logs are empty.");
    var eventName;
    var attributeKey;
    if (isClassic) {
        eventName = "instantiate_contract";
        attributeKey = "contract_address";
    } else {
        eventName = "wasm";
        attributeKey = "_contract_address";
    }
    var contractAddress = txResult.logs[msgIndex].eventsByType[eventName][attributeKey][0];
    return contractAddress;
}
module.exports.getContractAddress = $276cc323146615b7$var$getContractAddress;
function $276cc323146615b7$var$getContractEvents(txResult, msgIndex, isClassic) {
    if (msgIndex === void 0) msgIndex = 0;
    if (isClassic === void 0) isClassic = false;
    if ((0, $lg08O.isTxError)(txResult) || txResult.logs === undefined || txResult.logs.length === 0) throw new Error("could not parse contract events -- tx logs are empty.");
    var eventName;
    var attributeKey;
    if (isClassic) {
        eventName = "from_contract";
        attributeKey = "contract_address";
    } else {
        eventName = "instantiate";
        attributeKey = "_contract_address";
    }
    var contractEvents = [];
    for(var _i = 0, _a = txResult.logs[msgIndex].events; _i < _a.length; _i++){
        var event_1 = _a[_i];
        if (event_1.type === eventName) {
            var eventData = {
                contract_address: ""
            }; // will be overwritten
            var currentContractAddress = event_1.attributes[0].value;
            for(var _b = 0, _c = event_1.attributes; _b < _c.length; _b++){
                var att = _c[_b];
                if (att.key == attributeKey && currentContractAddress !== att.value) {
                    contractEvents.push(eventData);
                    eventData = {
                        contract_address: ""
                    };
                    currentContractAddress = att.value;
                }
                eventData[att.key] = att.value;
            }
            contractEvents.push(eventData);
            return contractEvents;
        }
    }
    throw new Error("could not find event type ".concat(eventName, " in logs"));
}
module.exports.getContractEvents = $276cc323146615b7$var$getContractEvents;

});


parcelRegister("icOy8", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        Buffer = (parcelRequire("aqbQf")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") start++;
        if (base === 16) this._parseHex(number, start);
        else this._parseBase(number, base, start);
        if (number[0] === "-") this.negative = 1;
        this.strip();
        if (endian !== "le") return;
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex(str, start, end) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r <<= 4;
            // 'a' - 'f'
            if (c >= 49 && c <= 54) r |= c - 49 + 0xa;
            else if (c >= 17 && c <= 22) r |= c - 17 + 0xa;
            else r |= c & 0xf;
        }
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        // Scan 24-bit chunks and add them to the number
        var off = 0;
        for(i = number.length - 6, j = 0; i >= start; i -= 6){
            w = parseHex(number, i, i + 6);
            this.words[j] |= w << off & 0x3ffffff;
            // NOTE: `0x3fffff` is intentional here, 26bits max shift + 24bit hex limb
            this.words[j + 1] |= w >>> 26 - off & 0x3fffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        if (i + 6 !== start) {
            w = parseHex(number, start, i + 6);
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] |= w >>> 26 - off & 0x3fffff;
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else r.strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("eOzb5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isBrowserCryptoAvailable = module.exports.getSubtleCrypto = module.exports.getBrowerCrypto = void 0;
function $ac9105c384140939$var$getBrowerCrypto() {
    return ($parcel$global === null || $parcel$global === void 0 ? void 0 : $parcel$global.crypto) || ($parcel$global === null || $parcel$global === void 0 ? void 0 : $parcel$global.msCrypto) || {};
}
module.exports.getBrowerCrypto = $ac9105c384140939$var$getBrowerCrypto;
function $ac9105c384140939$var$getSubtleCrypto() {
    const browserCrypto = $ac9105c384140939$var$getBrowerCrypto();
    return browserCrypto.subtle || browserCrypto.webkitSubtle;
}
module.exports.getSubtleCrypto = $ac9105c384140939$var$getSubtleCrypto;
function $ac9105c384140939$var$isBrowserCryptoAvailable() {
    return !!$ac9105c384140939$var$getBrowerCrypto() && !!$ac9105c384140939$var$getSubtleCrypto();
}
module.exports.isBrowserCryptoAvailable = $ac9105c384140939$var$isBrowserCryptoAvailable;

});

parcelRegister("ar1Qx", function(module, exports) {

var $a8i8g = parcelRequire("a8i8g");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isBrowser = module.exports.isNode = module.exports.isReactNative = void 0;
function $798ddba79018ea53$var$isReactNative() {
    return typeof document === "undefined" && typeof navigator !== "undefined" && navigator.product === "ReactNative";
}
module.exports.isReactNative = $798ddba79018ea53$var$isReactNative;
function $798ddba79018ea53$var$isNode() {
    return typeof $a8i8g !== "undefined" && typeof $a8i8g.versions !== "undefined" && typeof $a8i8g.versions.node !== "undefined";
}
module.exports.isNode = $798ddba79018ea53$var$isNode;
function $798ddba79018ea53$var$isBrowser() {
    return !$798ddba79018ea53$var$isReactNative() && !$798ddba79018ea53$var$isNode();
}
module.exports.isBrowser = $798ddba79018ea53$var$isBrowser;

});

parcelRegister("8IOxf", function(module, exports) {
"use strict";
module.exports = function() {
    throw new Error("ws does not work in the browser. Browser clients must use the native WebSocket object");
};

});

parcelRegister("aGpG0", function(module, exports) {
"use strict";
var $7c71be770d710fb6$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7c71be770d710fb6$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Keplr = void 0;

var $f7g3d = parcelRequire("f7g3d");

var $8JFBD = parcelRequire("8JFBD");

var $3RsMA = parcelRequire("3RsMA");

var $5pFPa = parcelRequire("5pFPa");

const $7c71be770d710fb6$var$deepmerge_1 = $7c71be770d710fb6$var$__importDefault((parcelRequire("8LGKR")));

const $7c71be770d710fb6$var$long_1 = $7c71be770d710fb6$var$__importDefault((parcelRequire("9A55m")));

var $gzLuY = parcelRequire("gzLuY");
class $7c71be770d710fb6$var$Keplr {
    enable(chainIds) {
        return $7c71be770d710fb6$var$__awaiter(this, void 0, void 0, function*() {
            if (typeof chainIds === "string") chainIds = [
                chainIds
            ];
            yield this.requester.sendMessage($f7g3d.BACKGROUND_PORT, new $8JFBD.EnableAccessMsg(chainIds));
        });
    }
    disable(chainIds) {
        return $7c71be770d710fb6$var$__awaiter(this, void 0, void 0, function*() {
            if (typeof chainIds === "string") chainIds = [
                chainIds
            ];
            yield this.requester.sendMessage($f7g3d.BACKGROUND_PORT, new $8JFBD.DisableAccessMsg(chainIds !== null && chainIds !== void 0 ? chainIds : []));
        });
    }
    experimentalSuggestChain(chainInfo) {
        return $7c71be770d710fb6$var$__awaiter(this, void 0, void 0, function*() {
            if (chainInfo.gasPriceStep) {
                // Gas price step in ChainInfo is legacy format.
                // Try to change the recent format for backward-compatibility.
                const gasPriceStep = Object.assign({}, chainInfo.gasPriceStep);
                for (const feeCurrency of chainInfo.feeCurrencies)if (!feeCurrency.gasPriceStep) feeCurrency.gasPriceStep = gasPriceStep;
                delete chainInfo.gasPriceStep;
                console.warn("The `gasPriceStep` field of the `ChainInfo` has been moved under `feeCurrencies`. This is automatically handled as of right now, but the upcoming update would potentially cause errors.");
            }
            const msg = new $8JFBD.SuggestChainInfoMsg(chainInfo);
            yield this.requester.sendMessage($f7g3d.BACKGROUND_PORT, msg);
        });
    }
    getKey(chainId) {
        return $7c71be770d710fb6$var$__awaiter(this, void 0, void 0, function*() {
            const msg = new $8JFBD.GetKeyMsg(chainId);
            return yield this.requester.sendMessage($f7g3d.BACKGROUND_PORT, msg);
        });
    }
    getChainInfosWithoutEndpoints() {
        return $7c71be770d710fb6$var$__awaiter(this, void 0, void 0, function*() {
            const msg = new $8JFBD.GetChainInfosWithoutEndpointsMsg();
            return (yield this.requester.sendMessage($f7g3d.BACKGROUND_PORT, msg)).chainInfos;
        });
    }
    sendTx(chainId, tx, mode) {
        return $7c71be770d710fb6$var$__awaiter(this, void 0, void 0, function*() {
            const msg = new $8JFBD.SendTxMsg(chainId, tx, mode);
            return yield this.requester.sendMessage($f7g3d.BACKGROUND_PORT, msg);
        });
    }
    signAmino(chainId, signer, signDoc, signOptions = {}) {
        var _a;
        return $7c71be770d710fb6$var$__awaiter(this, void 0, void 0, function*() {
            const msg = new $8JFBD.RequestSignAminoMsg(chainId, signer, signDoc, $7c71be770d710fb6$var$deepmerge_1.default((_a = this.defaultOptions.sign) !== null && _a !== void 0 ? _a : {}, signOptions));
            return yield this.requester.sendMessage($f7g3d.BACKGROUND_PORT, msg);
        });
    }
    signDirect(chainId, signer, signDoc, signOptions = {}) {
        var _a;
        return $7c71be770d710fb6$var$__awaiter(this, void 0, void 0, function*() {
            const msg = new $8JFBD.RequestSignDirectMsg(chainId, signer, {
                bodyBytes: signDoc.bodyBytes,
                authInfoBytes: signDoc.authInfoBytes,
                chainId: signDoc.chainId,
                accountNumber: signDoc.accountNumber ? signDoc.accountNumber.toString() : null
            }, $7c71be770d710fb6$var$deepmerge_1.default((_a = this.defaultOptions.sign) !== null && _a !== void 0 ? _a : {}, signOptions));
            const response = yield this.requester.sendMessage($f7g3d.BACKGROUND_PORT, msg);
            return {
                signed: {
                    bodyBytes: response.signed.bodyBytes,
                    authInfoBytes: response.signed.authInfoBytes,
                    chainId: response.signed.chainId,
                    accountNumber: $7c71be770d710fb6$var$long_1.default.fromString(response.signed.accountNumber)
                },
                signature: response.signature
            };
        });
    }
    signArbitrary(chainId, signer, data) {
        return $7c71be770d710fb6$var$__awaiter(this, void 0, void 0, function*() {
            let isADR36WithString;
            [data, isADR36WithString] = this.getDataForADR36(data);
            const signDoc = this.getADR36SignDoc(signer, data);
            const msg = new $8JFBD.RequestSignAminoMsg(chainId, signer, signDoc, {
                isADR36WithString: isADR36WithString
            });
            return (yield this.requester.sendMessage($f7g3d.BACKGROUND_PORT, msg)).signature;
        });
    }
    verifyArbitrary(chainId, signer, data, signature) {
        return $7c71be770d710fb6$var$__awaiter(this, void 0, void 0, function*() {
            if (typeof data === "string") data = $gzLuY.Buffer.from(data);
            return yield this.requester.sendMessage($f7g3d.BACKGROUND_PORT, new $8JFBD.RequestVerifyADR36AminoSignDoc(chainId, signer, data, signature));
        });
    }
    signEthereum(chainId, signer, data, type) {
        return $7c71be770d710fb6$var$__awaiter(this, void 0, void 0, function*() {
            let isADR36WithString;
            [data, isADR36WithString] = this.getDataForADR36(data);
            const signDoc = this.getADR36SignDoc(signer, data);
            if (data === "") throw new Error("Signing empty data is not supported.");
            const msg = new $8JFBD.RequestSignAminoMsg(chainId, signer, signDoc, {
                isADR36WithString: isADR36WithString,
                ethSignType: type
            });
            const signature = (yield this.requester.sendMessage($f7g3d.BACKGROUND_PORT, msg)).signature;
            return $gzLuY.Buffer.from(signature.signature, "base64");
        });
    }
    signICNSAdr36(chainId, contractAddress, owner, username, addressChainIds) {
        return this.requester.sendMessage($f7g3d.BACKGROUND_PORT, new $8JFBD.RequestICNSAdr36SignaturesMsg(chainId, contractAddress, owner, username, addressChainIds));
    }
    getOfflineSigner(chainId) {
        return new $5pFPa.CosmJSOfflineSigner(chainId, this);
    }
    getOfflineSignerOnlyAmino(chainId) {
        return new $5pFPa.CosmJSOfflineSignerOnlyAmino(chainId, this);
    }
    getOfflineSignerAuto(chainId) {
        return $7c71be770d710fb6$var$__awaiter(this, void 0, void 0, function*() {
            const key = yield this.getKey(chainId);
            if (key.isNanoLedger) return new $5pFPa.CosmJSOfflineSignerOnlyAmino(chainId, this);
            return new $5pFPa.CosmJSOfflineSigner(chainId, this);
        });
    }
    suggestToken(chainId, contractAddress, viewingKey) {
        return $7c71be770d710fb6$var$__awaiter(this, void 0, void 0, function*() {
            const msg = new $8JFBD.SuggestTokenMsg(chainId, contractAddress, viewingKey);
            yield this.requester.sendMessage($f7g3d.BACKGROUND_PORT, msg);
        });
    }
    getSecret20ViewingKey(chainId, contractAddress) {
        return $7c71be770d710fb6$var$__awaiter(this, void 0, void 0, function*() {
            const msg = new $8JFBD.GetSecret20ViewingKey(chainId, contractAddress);
            return yield this.requester.sendMessage($f7g3d.BACKGROUND_PORT, msg);
        });
    }
    getEnigmaPubKey(chainId) {
        return $7c71be770d710fb6$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.requester.sendMessage($f7g3d.BACKGROUND_PORT, new $8JFBD.GetPubkeyMsg(chainId));
        });
    }
    getEnigmaTxEncryptionKey(chainId, nonce) {
        return $7c71be770d710fb6$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.requester.sendMessage($f7g3d.BACKGROUND_PORT, new $8JFBD.GetTxEncryptionKeyMsg(chainId, nonce));
        });
    }
    enigmaEncrypt(chainId, contractCodeHash, // eslint-disable-next-line @typescript-eslint/ban-types
    msg) {
        return $7c71be770d710fb6$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.requester.sendMessage($f7g3d.BACKGROUND_PORT, new $8JFBD.ReqeustEncryptMsg(chainId, contractCodeHash, msg));
        });
    }
    enigmaDecrypt(chainId, ciphertext, nonce) {
        return $7c71be770d710fb6$var$__awaiter(this, void 0, void 0, function*() {
            if (!ciphertext || ciphertext.length === 0) return new Uint8Array();
            return yield this.requester.sendMessage($f7g3d.BACKGROUND_PORT, new $8JFBD.RequestDecryptMsg(chainId, ciphertext, nonce));
        });
    }
    getEnigmaUtils(chainId) {
        if (this.enigmaUtils.has(chainId)) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return this.enigmaUtils.get(chainId);
        const enigmaUtils = new $3RsMA.KeplrEnigmaUtils(chainId, this);
        this.enigmaUtils.set(chainId, enigmaUtils);
        return enigmaUtils;
    }
    experimentalSignEIP712CosmosTx_v0(chainId, signer, eip712, signDoc, signOptions = {}) {
        var _a;
        return $7c71be770d710fb6$var$__awaiter(this, void 0, void 0, function*() {
            const msg = new $8JFBD.RequestSignEIP712CosmosTxMsg_v0(chainId, signer, eip712, signDoc, $7c71be770d710fb6$var$deepmerge_1.default((_a = this.defaultOptions.sign) !== null && _a !== void 0 ? _a : {}, signOptions));
            return yield this.requester.sendMessage($f7g3d.BACKGROUND_PORT, msg);
        });
    }
    getDataForADR36(data) {
        let isADR36WithString = false;
        if (typeof data === "string") {
            data = $gzLuY.Buffer.from(data).toString("base64");
            isADR36WithString = true;
        } else data = $gzLuY.Buffer.from(data).toString("base64");
        return [
            data,
            isADR36WithString
        ];
    }
    getADR36SignDoc(signer, data) {
        return {
            chain_id: "",
            account_number: "0",
            sequence: "0",
            fee: {
                gas: "0",
                amount: []
            },
            msgs: [
                {
                    type: "sign/MsgSignData",
                    value: {
                        signer: signer,
                        data: data
                    }
                }
            ],
            memo: ""
        };
    }
    __core__getAnalyticsId() {
        const msg = new $8JFBD.GetAnalyticsIdMsg();
        return this.requester.sendMessage($f7g3d.BACKGROUND_PORT, msg);
    }
    changeKeyRingName({ defaultName: defaultName, editable: editable = true }) {
        return $7c71be770d710fb6$var$__awaiter(this, void 0, void 0, function*() {
            const msg = new $8JFBD.ChangeKeyRingNameMsg(defaultName, editable);
            return yield this.requester.sendMessage($f7g3d.BACKGROUND_PORT, msg);
        });
    }
    constructor(version, mode, requester){
        this.version = version;
        this.mode = mode;
        this.requester = requester;
        this.enigmaUtils = new Map();
        this.defaultOptions = {};
    }
}
module.exports.Keplr = $7c71be770d710fb6$var$Keplr;

});
parcelRegister("f7g3d", function(module, exports) {
"use strict";
var $b013f5cf60437983$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b013f5cf60437983$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $b013f5cf60437983$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$b013f5cf60437983$var$__exportStar((parcelRequire("1hbzL")), module.exports);

$b013f5cf60437983$var$__exportStar((parcelRequire("10QUf")), module.exports);

$b013f5cf60437983$var$__exportStar((parcelRequire("8rqmk")), module.exports);

$b013f5cf60437983$var$__exportStar((parcelRequire("4JoW9")), module.exports);

$b013f5cf60437983$var$__exportStar((parcelRequire("eHin5")), module.exports);

$b013f5cf60437983$var$__exportStar((parcelRequire("a1raU")), module.exports);

$b013f5cf60437983$var$__exportStar((parcelRequire("gmiaO")), module.exports);

$b013f5cf60437983$var$__exportStar((parcelRequire("3c4CD")), module.exports);

$b013f5cf60437983$var$__exportStar((parcelRequire("k3SPD")), module.exports);

});
parcelRegister("1hbzL", function(module, exports) {
"use strict";
var $0ee05bb578b1649a$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Router = void 0;

var $3c4CD = parcelRequire("3c4CD");

var $k3SPD = parcelRequire("k3SPD");
class $0ee05bb578b1649a$var$Router {
    registerMessage(msgCls) {
        this.msgRegistry.registerMessage(msgCls);
    }
    addHandler(route, handler) {
        if (this.registeredHandler.has(route)) throw new Error(`Already registered type ${route}`);
        this.registeredHandler.set(route, handler);
    }
    addGuard(guard) {
        this.guards.push(guard);
    }
    handleMessage(message, sender) {
        var _a;
        return $0ee05bb578b1649a$var$__awaiter(this, void 0, void 0, function*() {
            const msg = this.msgRegistry.parseMessage($k3SPD.JSONUint8Array.unwrap(message));
            const env = this.envProducer(sender, (_a = msg.routerMeta) !== null && _a !== void 0 ? _a : {});
            for (const guard of this.guards)yield guard(env, msg, sender);
            // Can happen throw
            msg.validateBasic();
            const route = msg.route();
            if (!route) throw new Error("Null router");
            const handler = this.registeredHandler.get(route);
            if (!handler) throw new Error("Can't get handler");
            return $k3SPD.JSONUint8Array.wrap((yield handler(env, msg)));
        });
    }
    constructor(envProducer){
        this.envProducer = envProducer;
        this.msgRegistry = new $3c4CD.MessageRegistry();
        this.registeredHandler = new Map();
        this.guards = [];
        this.port = "";
    }
}
module.exports.Router = $0ee05bb578b1649a$var$Router;

});
parcelRegister("3c4CD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MessageRegistry = void 0;
class $253613f6d08736d7$var$MessageRegistry {
    registerMessage(msgCls) {
        if (this.registeredMsgType.has(msgCls.type())) throw new Error(`Already registered type ${msgCls.type()}`);
        this.registeredMsgType.set(msgCls.type(), msgCls);
    }
    parseMessage(message) {
        if (!message.type) throw new Error("Null type");
        const msgCls = this.registeredMsgType.get(message.type);
        if (!msgCls) throw new Error(`Unregistered msg type ${message.type}`);
        return Object.setPrototypeOf(message.msg, msgCls.prototype);
    }
    constructor(){
        this.registeredMsgType = new Map();
    }
}
module.exports.MessageRegistry = $253613f6d08736d7$var$MessageRegistry;

});

parcelRegister("k3SPD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JSONUint8Array = void 0;

var $3CqVi = parcelRequire("3CqVi");
class $e9ae9ee64c1c13f0$var$JSONUint8Array {
    static parse(text) {
        return JSON.parse(text, (key, value)=>{
            // Prevent potential prototype poisoning.
            if (key === "__proto__") throw new Error("__proto__ is disallowed");
            if (value && typeof value === "string" && value.startsWith("__uint8array__")) return $3CqVi.fromHex(value.replace("__uint8array__", ""));
            return value;
        });
    }
    static stringify(obj) {
        return JSON.stringify(obj, (key, value)=>{
            // Prevent potential prototype poisoning.
            if (key === "__proto__") throw new Error("__proto__ is disallowed");
            if (value && (value instanceof Uint8Array || typeof value === "object" && "type" in value && "data" in value && value.type === "Buffer" && Array.isArray(value.data))) {
                const array = value instanceof Uint8Array ? value : new Uint8Array(value.data);
                return `__uint8array__${$3CqVi.toHex(array)}`;
            }
            return value;
        });
    }
    static wrap(obj) {
        if (obj === undefined) return undefined;
        return JSON.parse($e9ae9ee64c1c13f0$var$JSONUint8Array.stringify(obj));
    }
    static unwrap(obj) {
        if (obj === undefined) return undefined;
        return $e9ae9ee64c1c13f0$var$JSONUint8Array.parse(JSON.stringify(obj));
    }
}
module.exports.JSONUint8Array = $e9ae9ee64c1c13f0$var$JSONUint8Array;

});
parcelRegister("3CqVi", function(module, exports) {
"use strict";
/*
  Belows are from @cosmjs/encoding library.
  To reduce the bundle size of provider, put them directly here.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromHex = module.exports.toHex = void 0;
function $2a29ce1967ea9124$var$toHex(data) {
    let out = "";
    for (const byte of data)out += ("0" + byte.toString(16)).slice(-2);
    return out;
}
module.exports.toHex = $2a29ce1967ea9124$var$toHex;
function $2a29ce1967ea9124$var$fromHex(hexstring) {
    if (hexstring.length % 2 !== 0) throw new Error("hex string length must be a multiple of 2");
    const listOfInts = [];
    for(let i = 0; i < hexstring.length; i += 2){
        const hexByteAsString = hexstring.substr(i, 2);
        if (!hexByteAsString.match(/[0-9a-f]{2}/i)) throw new Error("hex string contains invalid characters");
        listOfInts.push(parseInt(hexByteAsString, 16));
    }
    return new Uint8Array(listOfInts);
}
module.exports.fromHex = $2a29ce1967ea9124$var$fromHex;

});



parcelRegister("10QUf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("8rqmk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("4JoW9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("eHin5", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.KeplrError = void 0;
class KeplrError extends Error {
    constructor(module, code, message){
        super(message);
        this.module = module;
        this.code = code;
        Object.setPrototypeOf(this, KeplrError.prototype);
    }
}
exports.KeplrError = KeplrError;

});

parcelRegister("a1raU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Message = void 0;
/**
 * This messaging system is influenced by cosmos-sdk.
 * The messages are processed in the following order:
 * "deserialize message -> approve external -> validate basic -> handler by routing".
 * This deserializing system has weak polymorphism feature.
 * Message would be converted to object according to their class and registered type.
 * But, nested class is not supported. Non primitivie types or array that includes non primitive types in message's fields
 * can't be decoded to their type properly. In this case, user should set thier prototype manually.
 */ class $74bf13bea68e4bff$var$Message {
    /**
     * Ask for approval if message is sent externally.
     */ approveExternal(_env, _sender) {
        return false;
    }
}
module.exports.Message = $74bf13bea68e4bff$var$Message;

});

parcelRegister("gmiaO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WEBPAGE_PORT = module.exports.APP_PORT = module.exports.BACKGROUND_PORT = void 0;
module.exports.BACKGROUND_PORT = "background";
module.exports.APP_PORT = "popup";
module.exports.WEBPAGE_PORT = "webpage";

});


parcelRegister("8JFBD", function(module, exports) {
"use strict";
var $65c2ccc2ea60a471$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $65c2ccc2ea60a471$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $65c2ccc2ea60a471$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$65c2ccc2ea60a471$var$__exportStar((parcelRequire("khWhR")), module.exports);

});
parcelRegister("khWhR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChangeKeyRingNameMsg = module.exports.GetAnalyticsIdMsg = module.exports.GetChainInfosWithoutEndpointsMsg = module.exports.GetTxEncryptionKeyMsg = module.exports.RequestDecryptMsg = module.exports.ReqeustEncryptMsg = module.exports.GetPubkeyMsg = module.exports.RequestSignDirectMsg = module.exports.RequestVerifyADR36AminoSignDoc = module.exports.RequestICNSAdr36SignaturesMsg = module.exports.RequestSignEIP712CosmosTxMsg_v0 = module.exports.RequestSignAminoMsg = module.exports.GetSecret20ViewingKey = module.exports.SendTxMsg = module.exports.SuggestTokenMsg = module.exports.SuggestChainInfoMsg = module.exports.GetKeyMsg = module.exports.DisableAccessMsg = module.exports.EnableAccessMsg = void 0;

var $f7g3d = parcelRequire("f7g3d");
class $ec529bc28888fb9f$var$EnableAccessMsg extends $f7g3d.Message {
    static type() {
        return "enable-access";
    }
    validateBasic() {
        if (!this.chainIds || this.chainIds.length === 0) throw new Error("chain id not set");
    }
    route() {
        return "permission";
    }
    type() {
        return $ec529bc28888fb9f$var$EnableAccessMsg.type();
    }
    constructor(chainIds){
        super();
        this.chainIds = chainIds;
    }
}
module.exports.EnableAccessMsg = $ec529bc28888fb9f$var$EnableAccessMsg;
class $ec529bc28888fb9f$var$DisableAccessMsg extends $f7g3d.Message {
    static type() {
        return "disable-access";
    }
    validateBasic() {
        if (!this.chainIds) throw new Error("chain id not set");
    }
    route() {
        return "permission";
    }
    type() {
        return $ec529bc28888fb9f$var$DisableAccessMsg.type();
    }
    constructor(chainIds){
        super();
        this.chainIds = chainIds;
    }
}
module.exports.DisableAccessMsg = $ec529bc28888fb9f$var$DisableAccessMsg;
class $ec529bc28888fb9f$var$GetKeyMsg extends $f7g3d.Message {
    static type() {
        return "get-key";
    }
    validateBasic() {
        if (!this.chainId) throw new Error("chain id not set");
    }
    route() {
        return "keyring";
    }
    type() {
        return $ec529bc28888fb9f$var$GetKeyMsg.type();
    }
    constructor(chainId){
        super();
        this.chainId = chainId;
    }
}
module.exports.GetKeyMsg = $ec529bc28888fb9f$var$GetKeyMsg;
class $ec529bc28888fb9f$var$SuggestChainInfoMsg extends $f7g3d.Message {
    static type() {
        return "suggest-chain-info";
    }
    validateBasic() {
        if (!this.chainInfo) throw new Error("chain info not set");
    }
    route() {
        return "chains";
    }
    type() {
        return $ec529bc28888fb9f$var$SuggestChainInfoMsg.type();
    }
    constructor(chainInfo){
        super();
        this.chainInfo = chainInfo;
    }
}
module.exports.SuggestChainInfoMsg = $ec529bc28888fb9f$var$SuggestChainInfoMsg;
class $ec529bc28888fb9f$var$SuggestTokenMsg extends $f7g3d.Message {
    static type() {
        return "suggest-token";
    }
    validateBasic() {
        if (!this.chainId) throw new Error("Chain id is empty");
        if (!this.contractAddress) throw new Error("Contract address is empty");
    }
    route() {
        return "tokens";
    }
    type() {
        return $ec529bc28888fb9f$var$SuggestTokenMsg.type();
    }
    constructor(chainId, contractAddress, viewingKey){
        super();
        this.chainId = chainId;
        this.contractAddress = contractAddress;
        this.viewingKey = viewingKey;
    }
}
module.exports.SuggestTokenMsg = $ec529bc28888fb9f$var$SuggestTokenMsg;
// Return the tx hash
class $ec529bc28888fb9f$var$SendTxMsg extends $f7g3d.Message {
    static type() {
        return "send-tx-to-background";
    }
    validateBasic() {
        if (!this.chainId) throw new Error("chain id is empty");
        if (!this.tx) throw new Error("tx is empty");
        if (!this.mode || this.mode !== "sync" && this.mode !== "async" && this.mode !== "block") throw new Error("invalid mode");
    }
    route() {
        return "background-tx";
    }
    type() {
        return $ec529bc28888fb9f$var$SendTxMsg.type();
    }
    constructor(chainId, tx, mode){
        super();
        this.chainId = chainId;
        this.tx = tx;
        this.mode = mode;
    }
}
module.exports.SendTxMsg = $ec529bc28888fb9f$var$SendTxMsg;
class $ec529bc28888fb9f$var$GetSecret20ViewingKey extends $f7g3d.Message {
    static type() {
        return "get-secret20-viewing-key";
    }
    validateBasic() {
        if (!this.chainId) throw new Error("Chain id is empty");
        if (!this.contractAddress) throw new Error("Contract address is empty");
    }
    route() {
        return "tokens";
    }
    type() {
        return $ec529bc28888fb9f$var$GetSecret20ViewingKey.type();
    }
    constructor(chainId, contractAddress){
        super();
        this.chainId = chainId;
        this.contractAddress = contractAddress;
    }
}
module.exports.GetSecret20ViewingKey = $ec529bc28888fb9f$var$GetSecret20ViewingKey;
class $ec529bc28888fb9f$var$RequestSignAminoMsg extends $f7g3d.Message {
    static type() {
        return "request-sign-amino";
    }
    validateBasic() {
        if (!this.chainId) throw new Error("chain id not set");
        if (!this.signer) throw new Error("signer not set");
        // It is not important to check this on the client side as opposed to increasing the bundle size.
        // Validate bech32 address.
        // Bech32Address.validate(this.signer);
        const signDoc = this.signDoc;
        // Check that the sign doc is for ADR-36,
        // the validation should be performed on the background.
        const hasOnlyMsgSignData = (()=>{
            if (signDoc && signDoc.msgs && Array.isArray(signDoc.msgs) && signDoc.msgs.length === 1) {
                const msg = signDoc.msgs[0];
                return msg.type === "sign/MsgSignData";
            } else return false;
        })();
        // If the sign doc is expected to be for ADR-36,
        // it doesn't have to have the chain id in the sign doc.
        if (!hasOnlyMsgSignData && signDoc.chain_id !== this.chainId) throw new Error("Chain id in the message is not matched with the requested chain id");
        if (!this.signOptions) throw new Error("Sign options are null");
    }
    route() {
        return "keyring";
    }
    type() {
        return $ec529bc28888fb9f$var$RequestSignAminoMsg.type();
    }
    constructor(chainId, signer, signDoc, signOptions = {}){
        super();
        this.chainId = chainId;
        this.signer = signer;
        this.signDoc = signDoc;
        this.signOptions = signOptions;
    }
}
module.exports.RequestSignAminoMsg = $ec529bc28888fb9f$var$RequestSignAminoMsg;
class $ec529bc28888fb9f$var$RequestSignEIP712CosmosTxMsg_v0 extends $f7g3d.Message {
    static type() {
        return "request-sign-eip-712-cosmos-tx-v0";
    }
    validateBasic() {
        if (!this.chainId) throw new Error("chain id not set");
        if (!this.signer) throw new Error("signer not set");
        if (this.signDoc.chain_id !== this.chainId) throw new Error("Chain id in the message is not matched with the requested chain id");
        if (!this.signOptions) throw new Error("Sign options are null");
    }
    approveExternal() {
        return true;
    }
    route() {
        return "keyring";
    }
    type() {
        return $ec529bc28888fb9f$var$RequestSignEIP712CosmosTxMsg_v0.type();
    }
    constructor(chainId, signer, eip712, signDoc, signOptions){
        super();
        this.chainId = chainId;
        this.signer = signer;
        this.eip712 = eip712;
        this.signDoc = signDoc;
        this.signOptions = signOptions;
    }
}
module.exports.RequestSignEIP712CosmosTxMsg_v0 = $ec529bc28888fb9f$var$RequestSignEIP712CosmosTxMsg_v0;
class $ec529bc28888fb9f$var$RequestICNSAdr36SignaturesMsg extends $f7g3d.Message {
    static type() {
        return "request-icns-adr-36-signatures";
    }
    validateBasic() {
        if (!this.chainId) throw new Error("chain id not set");
        if (!this.contractAddress) throw new Error("contract address not set");
        if (!this.owner) throw new Error("signer not set");
        // Validate bech32 address.
        // Bech32Address.validate(this.signer);
        if (!this.username) throw new Error("username not set");
        if (!this.addressChainIds || this.addressChainIds.length === 0) throw new Error("address chain ids not set");
    }
    approveExternal() {
        return true;
    }
    route() {
        return "keyring";
    }
    type() {
        return $ec529bc28888fb9f$var$RequestICNSAdr36SignaturesMsg.type();
    }
    constructor(chainId, contractAddress, owner, username, addressChainIds){
        super();
        this.chainId = chainId;
        this.contractAddress = contractAddress;
        this.owner = owner;
        this.username = username;
        this.addressChainIds = addressChainIds;
    }
}
module.exports.RequestICNSAdr36SignaturesMsg = $ec529bc28888fb9f$var$RequestICNSAdr36SignaturesMsg;
class $ec529bc28888fb9f$var$RequestVerifyADR36AminoSignDoc extends $f7g3d.Message {
    static type() {
        return "request-verify-adr-36-amino-doc";
    }
    validateBasic() {
        if (!this.chainId) throw new Error("chain id not set");
        if (!this.signer) throw new Error("signer not set");
        if (!this.signature) throw new Error("Signature not set");
    // It is not important to check this on the client side as opposed to increasing the bundle size.
    // Validate bech32 address.
    // Bech32Address.validate(this.signer);
    }
    route() {
        return "keyring";
    }
    type() {
        return $ec529bc28888fb9f$var$RequestVerifyADR36AminoSignDoc.type();
    }
    constructor(chainId, signer, data, signature){
        super();
        this.chainId = chainId;
        this.signer = signer;
        this.data = data;
        this.signature = signature;
    }
}
module.exports.RequestVerifyADR36AminoSignDoc = $ec529bc28888fb9f$var$RequestVerifyADR36AminoSignDoc;
class $ec529bc28888fb9f$var$RequestSignDirectMsg extends $f7g3d.Message {
    static type() {
        return "request-sign-direct";
    }
    validateBasic() {
        if (!this.chainId) throw new Error("chain id not set");
        if (!this.signer) throw new Error("signer not set");
        // It is not important to check this on the client side as opposed to increasing the bundle size.
        // Validate bech32 address.
        // Bech32Address.validate(this.signer);
        // const signDoc = cosmos.tx.v1beta1.SignDoc.create({
        //   bodyBytes: this.signDoc.bodyBytes,
        //   authInfoBytes: this.signDoc.authInfoBytes,
        //   chainId: this.signDoc.chainId,
        //   accountNumber: this.signDoc.accountNumber
        //     ? Long.fromString(this.signDoc.accountNumber)
        //     : undefined,
        // });
        //
        // if (signDoc.chainId !== this.chainId) {
        //   throw new Error(
        //     "Chain id in the message is not matched with the requested chain id"
        //   );
        // }
        if (!this.signOptions) throw new Error("Sign options are null");
    }
    route() {
        return "keyring";
    }
    type() {
        return $ec529bc28888fb9f$var$RequestSignDirectMsg.type();
    }
    constructor(chainId, signer, signDoc, signOptions = {}){
        super();
        this.chainId = chainId;
        this.signer = signer;
        this.signDoc = signDoc;
        this.signOptions = signOptions;
    }
}
module.exports.RequestSignDirectMsg = $ec529bc28888fb9f$var$RequestSignDirectMsg;
class $ec529bc28888fb9f$var$GetPubkeyMsg extends $f7g3d.Message {
    static type() {
        return "get-pubkey-msg";
    }
    validateBasic() {
        if (!this.chainId) throw new Error("chain id not set");
    }
    route() {
        return "secret-wasm";
    }
    type() {
        return $ec529bc28888fb9f$var$GetPubkeyMsg.type();
    }
    constructor(chainId){
        super();
        this.chainId = chainId;
    }
}
module.exports.GetPubkeyMsg = $ec529bc28888fb9f$var$GetPubkeyMsg;
class $ec529bc28888fb9f$var$ReqeustEncryptMsg extends $f7g3d.Message {
    static type() {
        return "request-encrypt-msg";
    }
    validateBasic() {
        if (!this.chainId) throw new Error("chain id not set");
        if (!this.contractCodeHash) throw new Error("contract code hash not set");
        if (!this.msg) throw new Error("msg not set");
    }
    route() {
        return "secret-wasm";
    }
    type() {
        return $ec529bc28888fb9f$var$ReqeustEncryptMsg.type();
    }
    constructor(chainId, contractCodeHash, // eslint-disable-next-line @typescript-eslint/ban-types
    msg){
        super();
        this.chainId = chainId;
        this.contractCodeHash = contractCodeHash;
        this.msg = msg;
    }
}
module.exports.ReqeustEncryptMsg = $ec529bc28888fb9f$var$ReqeustEncryptMsg;
class $ec529bc28888fb9f$var$RequestDecryptMsg extends $f7g3d.Message {
    static type() {
        return "request-decrypt-msg";
    }
    validateBasic() {
        if (!this.chainId) throw new Error("chain id not set");
        if (!this.cipherText || this.cipherText.length === 0) throw new Error("ciphertext not set");
        if (!this.nonce || this.nonce.length === 0) throw new Error("nonce not set");
    }
    route() {
        return "secret-wasm";
    }
    type() {
        return $ec529bc28888fb9f$var$RequestDecryptMsg.type();
    }
    constructor(chainId, cipherText, nonce){
        super();
        this.chainId = chainId;
        this.cipherText = cipherText;
        this.nonce = nonce;
    }
}
module.exports.RequestDecryptMsg = $ec529bc28888fb9f$var$RequestDecryptMsg;
class $ec529bc28888fb9f$var$GetTxEncryptionKeyMsg extends $f7g3d.Message {
    static type() {
        return "get-tx-encryption-key-msg";
    }
    validateBasic() {
        if (!this.chainId) throw new Error("chain id not set");
        if (!this.nonce) // Nonce of zero length is permitted.
        throw new Error("nonce is null");
    }
    route() {
        return "secret-wasm";
    }
    type() {
        return $ec529bc28888fb9f$var$GetTxEncryptionKeyMsg.type();
    }
    constructor(chainId, nonce){
        super();
        this.chainId = chainId;
        this.nonce = nonce;
    }
}
module.exports.GetTxEncryptionKeyMsg = $ec529bc28888fb9f$var$GetTxEncryptionKeyMsg;
class $ec529bc28888fb9f$var$GetChainInfosWithoutEndpointsMsg extends $f7g3d.Message {
    static type() {
        return "get-chain-infos-without-endpoints";
    }
    validateBasic() {
    // noop
    }
    route() {
        return "chains";
    }
    type() {
        return $ec529bc28888fb9f$var$GetChainInfosWithoutEndpointsMsg.type();
    }
}
module.exports.GetChainInfosWithoutEndpointsMsg = $ec529bc28888fb9f$var$GetChainInfosWithoutEndpointsMsg;
class $ec529bc28888fb9f$var$GetAnalyticsIdMsg extends $f7g3d.Message {
    static type() {
        return "get-analytics-id";
    }
    validateBasic() {
    // noop
    }
    approveExternal() {
        return true;
    }
    route() {
        return "analytics";
    }
    type() {
        return $ec529bc28888fb9f$var$GetAnalyticsIdMsg.type();
    }
    constructor(){
        super();
    }
}
module.exports.GetAnalyticsIdMsg = $ec529bc28888fb9f$var$GetAnalyticsIdMsg;
class $ec529bc28888fb9f$var$ChangeKeyRingNameMsg extends $f7g3d.Message {
    static type() {
        return "change-keyring-name-msg";
    }
    validateBasic() {
        // Not allow empty name.
        if (!this.defaultName) throw new Error("default name not set");
    }
    route() {
        return "keyring";
    }
    type() {
        return $ec529bc28888fb9f$var$ChangeKeyRingNameMsg.type();
    }
    constructor(defaultName, editable){
        super();
        this.defaultName = defaultName;
        this.editable = editable;
    }
}
module.exports.ChangeKeyRingNameMsg = $ec529bc28888fb9f$var$ChangeKeyRingNameMsg;

});


parcelRegister("3RsMA", function(module, exports) {
"use strict";
var $2cfca5fdcd0253ed$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KeplrEnigmaUtils = void 0;
/**
 * KeplrEnigmaUtils duplicates the public methods that are supported on secretjs's EnigmaUtils class.
 */ class $2cfca5fdcd0253ed$var$KeplrEnigmaUtils {
    getPubkey() {
        return $2cfca5fdcd0253ed$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.keplr.getEnigmaPubKey(this.chainId);
        });
    }
    getTxEncryptionKey(nonce) {
        return $2cfca5fdcd0253ed$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.keplr.getEnigmaTxEncryptionKey(this.chainId, nonce);
        });
    }
    encrypt(contractCodeHash, // eslint-disable-next-line @typescript-eslint/ban-types
    msg) {
        return $2cfca5fdcd0253ed$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.keplr.enigmaEncrypt(this.chainId, contractCodeHash, msg);
        });
    }
    decrypt(ciphertext, nonce) {
        return $2cfca5fdcd0253ed$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.keplr.enigmaDecrypt(this.chainId, ciphertext, nonce);
        });
    }
    constructor(chainId, keplr){
        this.chainId = chainId;
        this.keplr = keplr;
    }
}
module.exports.KeplrEnigmaUtils = $2cfca5fdcd0253ed$var$KeplrEnigmaUtils;

});

parcelRegister("5pFPa", function(module, exports) {
"use strict";
var $3f0fbafb76a6b248$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CosmJSOfflineSigner = module.exports.CosmJSOfflineSignerOnlyAmino = void 0;
class $3f0fbafb76a6b248$var$CosmJSOfflineSignerOnlyAmino {
    getAccounts() {
        return $3f0fbafb76a6b248$var$__awaiter(this, void 0, void 0, function*() {
            const key = yield this.keplr.getKey(this.chainId);
            return [
                {
                    address: key.bech32Address,
                    // Currently, only secp256k1 is supported.
                    algo: "secp256k1",
                    pubkey: key.pubKey
                }
            ];
        });
    }
    signAmino(signerAddress, signDoc) {
        return $3f0fbafb76a6b248$var$__awaiter(this, void 0, void 0, function*() {
            if (this.chainId !== signDoc.chain_id) throw new Error("Unmatched chain id with the offline signer");
            const key = yield this.keplr.getKey(signDoc.chain_id);
            if (key.bech32Address !== signerAddress) throw new Error("Unknown signer address");
            return yield this.keplr.signAmino(this.chainId, signerAddress, signDoc);
        });
    }
    // Fallback function for the legacy cosmjs implementation before the staragte.
    sign(signerAddress, signDoc) {
        return $3f0fbafb76a6b248$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.signAmino(signerAddress, signDoc);
        });
    }
    constructor(chainId, keplr){
        this.chainId = chainId;
        this.keplr = keplr;
    }
}
module.exports.CosmJSOfflineSignerOnlyAmino = $3f0fbafb76a6b248$var$CosmJSOfflineSignerOnlyAmino;
class $3f0fbafb76a6b248$var$CosmJSOfflineSigner extends $3f0fbafb76a6b248$var$CosmJSOfflineSignerOnlyAmino {
    signDirect(signerAddress, signDoc) {
        return $3f0fbafb76a6b248$var$__awaiter(this, void 0, void 0, function*() {
            if (this.chainId !== signDoc.chainId) throw new Error("Unmatched chain id with the offline signer");
            const key = yield this.keplr.getKey(signDoc.chainId);
            if (key.bech32Address !== signerAddress) throw new Error("Unknown signer address");
            return yield this.keplr.signDirect(this.chainId, signerAddress, signDoc);
        });
    }
    constructor(chainId, keplr){
        super(chainId, keplr);
        this.chainId = chainId;
        this.keplr = keplr;
    }
}
module.exports.CosmJSOfflineSigner = $3f0fbafb76a6b248$var$CosmJSOfflineSigner;

});

parcelRegister("8LGKR", function(module, exports) {
"use strict";
var $01a5bd6e49e0c3bd$var$isMergeableObject = function isMergeableObject(value) {
    return $01a5bd6e49e0c3bd$var$isNonNullObject(value) && !$01a5bd6e49e0c3bd$var$isSpecial(value);
};
function $01a5bd6e49e0c3bd$var$isNonNullObject(value) {
    return !!value && typeof value === "object";
}
function $01a5bd6e49e0c3bd$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === "[object RegExp]" || stringValue === "[object Date]" || $01a5bd6e49e0c3bd$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $01a5bd6e49e0c3bd$var$canUseSymbol = typeof Symbol === "function" && Symbol.for;
var $01a5bd6e49e0c3bd$var$REACT_ELEMENT_TYPE = $01a5bd6e49e0c3bd$var$canUseSymbol ? Symbol.for("react.element") : 0xeac7;
function $01a5bd6e49e0c3bd$var$isReactElement(value) {
    return value.$$typeof === $01a5bd6e49e0c3bd$var$REACT_ELEMENT_TYPE;
}
function $01a5bd6e49e0c3bd$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $01a5bd6e49e0c3bd$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $01a5bd6e49e0c3bd$var$deepmerge($01a5bd6e49e0c3bd$var$emptyTarget(value), value, options) : value;
}
function $01a5bd6e49e0c3bd$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $01a5bd6e49e0c3bd$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $01a5bd6e49e0c3bd$var$getMergeFunction(key, options) {
    if (!options.customMerge) return $01a5bd6e49e0c3bd$var$deepmerge;
    var customMerge = options.customMerge(key);
    return typeof customMerge === "function" ? customMerge : $01a5bd6e49e0c3bd$var$deepmerge;
}
function $01a5bd6e49e0c3bd$var$getEnumerableOwnPropertySymbols(target) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
        return Object.propertyIsEnumerable.call(target, symbol);
    }) : [];
}
function $01a5bd6e49e0c3bd$var$getKeys(target) {
    return Object.keys(target).concat($01a5bd6e49e0c3bd$var$getEnumerableOwnPropertySymbols(target));
}
function $01a5bd6e49e0c3bd$var$propertyIsOnObject(object, property) {
    try {
        return property in object;
    } catch (_) {
        return false;
    }
}
// Protects from prototype poisoning and unexpected merging up the prototype chain.
function $01a5bd6e49e0c3bd$var$propertyIsUnsafe(target, key) {
    return $01a5bd6e49e0c3bd$var$propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
     && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
     && Object.propertyIsEnumerable.call(target, key) // and also unsafe if they're nonenumerable.
    );
}
function $01a5bd6e49e0c3bd$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) $01a5bd6e49e0c3bd$var$getKeys(target).forEach(function(key) {
        destination[key] = $01a5bd6e49e0c3bd$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    $01a5bd6e49e0c3bd$var$getKeys(source).forEach(function(key) {
        if ($01a5bd6e49e0c3bd$var$propertyIsUnsafe(target, key)) return;
        if ($01a5bd6e49e0c3bd$var$propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) destination[key] = $01a5bd6e49e0c3bd$var$getMergeFunction(key, options)(target[key], source[key], options);
        else destination[key] = $01a5bd6e49e0c3bd$var$cloneUnlessOtherwiseSpecified(source[key], options);
    });
    return destination;
}
function $01a5bd6e49e0c3bd$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $01a5bd6e49e0c3bd$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $01a5bd6e49e0c3bd$var$isMergeableObject;
    // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
    // implementations can use it. The caller may not replace it.
    options.cloneUnlessOtherwiseSpecified = $01a5bd6e49e0c3bd$var$cloneUnlessOtherwiseSpecified;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $01a5bd6e49e0c3bd$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $01a5bd6e49e0c3bd$var$mergeObject(target, source, options);
}
$01a5bd6e49e0c3bd$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error("first argument should be an array");
    return array.reduce(function(prev, next) {
        return $01a5bd6e49e0c3bd$var$deepmerge(prev, next, options);
    }, {});
};
var $01a5bd6e49e0c3bd$var$deepmerge_1 = $01a5bd6e49e0c3bd$var$deepmerge;
module.exports = $01a5bd6e49e0c3bd$var$deepmerge_1;

});


parcelRegister("barq0", function(module, exports) {
"use strict";
var $8215e59d1d2251cc$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $8215e59d1d2251cc$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InjectedKeplr = module.exports.injectKeplrToWindow = void 0;

var $f7g3d = parcelRequire("f7g3d");

var $3RsMA = parcelRequire("3RsMA");

var $5pFPa = parcelRequire("5pFPa");

const $8215e59d1d2251cc$var$deepmerge_1 = $8215e59d1d2251cc$var$__importDefault((parcelRequire("8LGKR")));

const $8215e59d1d2251cc$var$long_1 = $8215e59d1d2251cc$var$__importDefault((parcelRequire("9A55m")));
function $8215e59d1d2251cc$var$defineUnwritablePropertyIfPossible(o, p, value) {
    const descriptor = Object.getOwnPropertyDescriptor(o, p);
    if (!descriptor || descriptor.writable) {
        if (!descriptor || descriptor.configurable) Object.defineProperty(o, p, {
            value: value,
            writable: false
        });
        else o[p] = value;
    } else console.warn(`Failed to inject ${p} from keplr. Probably, other wallet is trying to intercept Keplr`);
}
function $8215e59d1d2251cc$var$injectKeplrToWindow(keplr) {
    $8215e59d1d2251cc$var$defineUnwritablePropertyIfPossible(window, "keplr", keplr);
    $8215e59d1d2251cc$var$defineUnwritablePropertyIfPossible(window, "getOfflineSigner", keplr.getOfflineSigner);
    $8215e59d1d2251cc$var$defineUnwritablePropertyIfPossible(window, "getOfflineSignerOnlyAmino", keplr.getOfflineSignerOnlyAmino);
    $8215e59d1d2251cc$var$defineUnwritablePropertyIfPossible(window, "getOfflineSignerAuto", keplr.getOfflineSignerAuto);
    $8215e59d1d2251cc$var$defineUnwritablePropertyIfPossible(window, "getEnigmaUtils", keplr.getEnigmaUtils);
}
module.exports.injectKeplrToWindow = $8215e59d1d2251cc$var$injectKeplrToWindow;
/**
 * InjectedKeplr would be injected to the webpage.
 * In the webpage, it can't request any messages to the extension because it doesn't have any API related to the extension.
 * So, to request some methods of the extension, this will proxy the request to the content script that is injected to webpage on the extension level.
 * This will use `window.postMessage` to interact with the content script.
 */ class $8215e59d1d2251cc$var$InjectedKeplr {
    static startProxy(keplr, eventListener = {
        addMessageListener: (fn)=>window.addEventListener("message", fn),
        postMessage: (message)=>window.postMessage(message, window.location.origin)
    }, parseMessage) {
        eventListener.addMessageListener((e)=>$8215e59d1d2251cc$var$__awaiter(this, void 0, void 0, function*() {
                const message = parseMessage ? parseMessage(e.data) : e.data;
                if (!message || message.type !== "proxy-request") return;
                try {
                    if (!message.id) throw new Error("Empty id");
                    if (message.method === "version") throw new Error("Version is not function");
                    if (message.method === "mode") throw new Error("Mode is not function");
                    if (message.method === "defaultOptions") throw new Error("DefaultOptions is not function");
                    if (!keplr[message.method] || typeof keplr[message.method] !== "function") throw new Error(`Invalid method: ${message.method}`);
                    if (message.method === "getOfflineSigner") throw new Error("GetOfflineSigner method can't be proxy request");
                    if (message.method === "getOfflineSignerOnlyAmino") throw new Error("GetOfflineSignerOnlyAmino method can't be proxy request");
                    if (message.method === "getOfflineSignerAuto") throw new Error("GetOfflineSignerAuto method can't be proxy request");
                    if (message.method === "getEnigmaUtils") throw new Error("GetEnigmaUtils method can't be proxy request");
                    const result = message.method === "signDirect" ? yield (()=>$8215e59d1d2251cc$var$__awaiter(this, void 0, void 0, function*() {
                            const receivedSignDoc = message.args[2];
                            const result = yield keplr.signDirect(message.args[0], message.args[1], {
                                bodyBytes: receivedSignDoc.bodyBytes,
                                authInfoBytes: receivedSignDoc.authInfoBytes,
                                chainId: receivedSignDoc.chainId,
                                accountNumber: receivedSignDoc.accountNumber ? $8215e59d1d2251cc$var$long_1.default.fromString(receivedSignDoc.accountNumber) : null
                            }, message.args[3]);
                            return {
                                signed: {
                                    bodyBytes: result.signed.bodyBytes,
                                    authInfoBytes: result.signed.authInfoBytes,
                                    chainId: result.signed.chainId,
                                    accountNumber: result.signed.accountNumber.toString()
                                },
                                signature: result.signature
                            };
                        }))() : yield keplr[message.method](// eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    ...$f7g3d.JSONUint8Array.unwrap(message.args));
                    const proxyResponse = {
                        type: "proxy-request-response",
                        id: message.id,
                        result: {
                            return: $f7g3d.JSONUint8Array.wrap(result)
                        }
                    };
                    eventListener.postMessage(proxyResponse);
                } catch (e) {
                    const proxyResponse = {
                        type: "proxy-request-response",
                        id: message.id,
                        result: {
                            error: e.message || e.toString()
                        }
                    };
                    eventListener.postMessage(proxyResponse);
                }
            }));
    }
    requestMethod(method, args) {
        const bytes = new Uint8Array(8);
        const id = Array.from(crypto.getRandomValues(bytes)).map((value)=>{
            return value.toString(16);
        }).join("");
        const proxyMessage = {
            type: "proxy-request",
            id: id,
            method: method,
            args: $f7g3d.JSONUint8Array.wrap(args)
        };
        return new Promise((resolve, reject)=>{
            const receiveResponse = (e)=>{
                const proxyResponse = this.parseMessage ? this.parseMessage(e.data) : e.data;
                if (!proxyResponse || proxyResponse.type !== "proxy-request-response") return;
                if (proxyResponse.id !== id) return;
                this.eventListener.removeMessageListener(receiveResponse);
                const result = $f7g3d.JSONUint8Array.unwrap(proxyResponse.result);
                if (!result) {
                    reject(new Error("Result is null"));
                    return;
                }
                if (result.error) {
                    reject(new Error(result.error));
                    return;
                }
                resolve(result.return);
            };
            this.eventListener.addMessageListener(receiveResponse);
            this.eventListener.postMessage(proxyMessage);
        });
    }
    enable(chainIds) {
        return $8215e59d1d2251cc$var$__awaiter(this, void 0, void 0, function*() {
            yield this.requestMethod("enable", [
                chainIds
            ]);
        });
    }
    disable(chainIds) {
        return $8215e59d1d2251cc$var$__awaiter(this, void 0, void 0, function*() {
            yield this.requestMethod("disable", [
                chainIds
            ]);
        });
    }
    experimentalSuggestChain(chainInfo) {
        var _a, _b;
        return $8215e59d1d2251cc$var$__awaiter(this, void 0, void 0, function*() {
            if (((_a = chainInfo.features) === null || _a === void 0 ? void 0 : _a.includes("stargate")) || ((_b = chainInfo.features) === null || _b === void 0 ? void 0 : _b.includes("no-legacy-stdTx"))) console.warn("\u201Cstargate\u201D, \u201Cno-legacy-stdTx\u201D feature has been deprecated. The launchpad is no longer supported, thus works without the two features. We would keep the aforementioned two feature for a while, but the upcoming update would potentially cause errors. Remove the two feature.");
            yield this.requestMethod("experimentalSuggestChain", [
                chainInfo
            ]);
        });
    }
    getKey(chainId) {
        return $8215e59d1d2251cc$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.requestMethod("getKey", [
                chainId
            ]);
        });
    }
    sendTx(chainId, tx, mode) {
        return $8215e59d1d2251cc$var$__awaiter(this, void 0, void 0, function*() {
            if (!("length" in tx)) console.warn("Do not send legacy std tx via `sendTx` API. We now only support protobuf tx. The usage of legeacy std tx would throw an error in the near future.");
            return yield this.requestMethod("sendTx", [
                chainId,
                tx,
                mode
            ]);
        });
    }
    signAmino(chainId, signer, signDoc, signOptions = {}) {
        var _a;
        return $8215e59d1d2251cc$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.requestMethod("signAmino", [
                chainId,
                signer,
                signDoc,
                $8215e59d1d2251cc$var$deepmerge_1.default((_a = this.defaultOptions.sign) !== null && _a !== void 0 ? _a : {}, signOptions)
            ]);
        });
    }
    signDirect(chainId, signer, signDoc, signOptions = {}) {
        var _a;
        return $8215e59d1d2251cc$var$__awaiter(this, void 0, void 0, function*() {
            const result = yield this.requestMethod("signDirect", [
                chainId,
                signer,
                // We can't send the `Long` with remaing the type.
                // Receiver should change the `string` to `Long`.
                {
                    bodyBytes: signDoc.bodyBytes,
                    authInfoBytes: signDoc.authInfoBytes,
                    chainId: signDoc.chainId,
                    accountNumber: signDoc.accountNumber ? signDoc.accountNumber.toString() : null
                },
                $8215e59d1d2251cc$var$deepmerge_1.default((_a = this.defaultOptions.sign) !== null && _a !== void 0 ? _a : {}, signOptions)
            ]);
            const signed = result.signed;
            return {
                signed: {
                    bodyBytes: signed.bodyBytes,
                    authInfoBytes: signed.authInfoBytes,
                    chainId: signed.chainId,
                    // We can't send the `Long` with remaing the type.
                    // Sender should change the `Long` to `string`.
                    accountNumber: $8215e59d1d2251cc$var$long_1.default.fromString(signed.accountNumber)
                },
                signature: result.signature
            };
        });
    }
    signArbitrary(chainId, signer, data) {
        return $8215e59d1d2251cc$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.requestMethod("signArbitrary", [
                chainId,
                signer,
                data
            ]);
        });
    }
    signICNSAdr36(chainId, contractAddress, owner, username, addressChainIds) {
        return this.requestMethod("signICNSAdr36", [
            chainId,
            contractAddress,
            owner,
            username,
            addressChainIds
        ]);
    }
    verifyArbitrary(chainId, signer, data, signature) {
        return $8215e59d1d2251cc$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.requestMethod("verifyArbitrary", [
                chainId,
                signer,
                data,
                signature
            ]);
        });
    }
    signEthereum(chainId, signer, data, type) {
        return $8215e59d1d2251cc$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.requestMethod("signEthereum", [
                chainId,
                signer,
                data,
                type
            ]);
        });
    }
    getOfflineSigner(chainId) {
        return new $5pFPa.CosmJSOfflineSigner(chainId, this);
    }
    getOfflineSignerOnlyAmino(chainId) {
        return new $5pFPa.CosmJSOfflineSignerOnlyAmino(chainId, this);
    }
    getOfflineSignerAuto(chainId) {
        return $8215e59d1d2251cc$var$__awaiter(this, void 0, void 0, function*() {
            const key = yield this.getKey(chainId);
            if (key.isNanoLedger) return new $5pFPa.CosmJSOfflineSignerOnlyAmino(chainId, this);
            return new $5pFPa.CosmJSOfflineSigner(chainId, this);
        });
    }
    suggestToken(chainId, contractAddress, viewingKey) {
        return $8215e59d1d2251cc$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.requestMethod("suggestToken", [
                chainId,
                contractAddress,
                viewingKey
            ]);
        });
    }
    getSecret20ViewingKey(chainId, contractAddress) {
        return $8215e59d1d2251cc$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.requestMethod("getSecret20ViewingKey", [
                chainId,
                contractAddress
            ]);
        });
    }
    getEnigmaPubKey(chainId) {
        return $8215e59d1d2251cc$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.requestMethod("getEnigmaPubKey", [
                chainId
            ]);
        });
    }
    getEnigmaTxEncryptionKey(chainId, nonce) {
        return $8215e59d1d2251cc$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.requestMethod("getEnigmaTxEncryptionKey", [
                chainId,
                nonce
            ]);
        });
    }
    enigmaEncrypt(chainId, contractCodeHash, // eslint-disable-next-line @typescript-eslint/ban-types
    msg) {
        return $8215e59d1d2251cc$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.requestMethod("enigmaEncrypt", [
                chainId,
                contractCodeHash,
                msg
            ]);
        });
    }
    enigmaDecrypt(chainId, ciphertext, nonce) {
        return $8215e59d1d2251cc$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.requestMethod("enigmaDecrypt", [
                chainId,
                ciphertext,
                nonce
            ]);
        });
    }
    getEnigmaUtils(chainId) {
        if (this.enigmaUtils.has(chainId)) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return this.enigmaUtils.get(chainId);
        const enigmaUtils = new $3RsMA.KeplrEnigmaUtils(chainId, this);
        this.enigmaUtils.set(chainId, enigmaUtils);
        return enigmaUtils;
    }
    experimentalSignEIP712CosmosTx_v0(chainId, signer, eip712, signDoc, signOptions = {}) {
        var _a;
        return $8215e59d1d2251cc$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.requestMethod("experimentalSignEIP712CosmosTx_v0", [
                chainId,
                signer,
                eip712,
                signDoc,
                $8215e59d1d2251cc$var$deepmerge_1.default((_a = this.defaultOptions.sign) !== null && _a !== void 0 ? _a : {}, signOptions)
            ]);
        });
    }
    getChainInfosWithoutEndpoints() {
        return $8215e59d1d2251cc$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.requestMethod("getChainInfosWithoutEndpoints", []);
        });
    }
    __core__getAnalyticsId() {
        return this.requestMethod("__core__getAnalyticsId", []);
    }
    changeKeyRingName({ defaultName: defaultName, editable: editable = true }) {
        return $8215e59d1d2251cc$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.requestMethod("changeKeyRingName", [
                {
                    defaultName: defaultName,
                    editable: editable
                }
            ]);
        });
    }
    constructor(version, mode, eventListener = {
        addMessageListener: (fn)=>window.addEventListener("message", fn),
        removeMessageListener: (fn)=>window.removeEventListener("message", fn),
        postMessage: (message)=>window.postMessage(message, window.location.origin)
    }, parseMessage){
        this.version = version;
        this.mode = mode;
        this.eventListener = eventListener;
        this.parseMessage = parseMessage;
        this.enigmaUtils = new Map();
        this.defaultOptions = {};
        // Freeze fields/method except for "defaultOptions"
        // Intentionally, "defaultOptions" can be mutated to allow a webpage to change the options with cosmjs usage.
        // Freeze fields
        const fieldNames = Object.keys(this);
        for (const fieldName of fieldNames){
            if (fieldName !== "defaultOptions") Object.defineProperty(this, fieldName, {
                value: this[fieldName],
                writable: false
            });
            // If field is "eventListener", try to iterate one-level deep.
            if (fieldName === "eventListener") {
                const fieldNames = Object.keys(this.eventListener);
                for (const fieldName of fieldNames)Object.defineProperty(this.eventListener, fieldName, {
                    value: this.eventListener[fieldName],
                    writable: false
                });
            }
        }
        // Freeze methods
        const methodNames = Object.getOwnPropertyNames($8215e59d1d2251cc$var$InjectedKeplr.prototype);
        for (const methodName of methodNames)if (methodName !== "constructor" && typeof this[methodName] === "function") Object.defineProperty(this, methodName, {
            value: this[methodName].bind(this),
            writable: false
        });
    }
}
module.exports.InjectedKeplr = $8215e59d1d2251cc$var$InjectedKeplr;

});

parcelRegister("2UwcM", function(module, exports) {
"use strict";
var $21e9cb0381b05e7e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $21e9cb0381b05e7e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $21e9cb0381b05e7e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$21e9cb0381b05e7e$var$__exportStar((parcelRequire("gdCur")), module.exports);

$21e9cb0381b05e7e$var$__exportStar((parcelRequire("3n5ib")), module.exports);

$21e9cb0381b05e7e$var$__exportStar((parcelRequire("6SJhc")), module.exports);

$21e9cb0381b05e7e$var$__exportStar((parcelRequire("crdMs")), module.exports);

$21e9cb0381b05e7e$var$__exportStar((parcelRequire("3qLGk")), module.exports);

$21e9cb0381b05e7e$var$__exportStar((parcelRequire("jvJ6s")), module.exports);

});
parcelRegister("gdCur", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("3n5ib", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExtensionKVStore = void 0;

var $6SJhc = parcelRequire("6SJhc");
class $2747a008ee8702a2$var$ExtensionKVStore extends $6SJhc.BaseKVStore {
    constructor(prefix){
        if (!$2747a008ee8702a2$var$ExtensionKVStore.KVStoreProvider) {
            if (typeof browser === "undefined") console.log("You should use ExtensionKVStore on the extension environment.");
            else if (!browser.storage || !browser.storage.local) console.log("The 'browser' exists, but it doesn't seem to be an extension environment. This can happen in Safari browser.");
            else $2747a008ee8702a2$var$ExtensionKVStore.KVStoreProvider = {
                get: browser.storage.local.get,
                set: browser.storage.local.set
            };
        }
        if (!$2747a008ee8702a2$var$ExtensionKVStore.KVStoreProvider) throw new Error("Can't initialize kv store for browser extension");
        super($2747a008ee8702a2$var$ExtensionKVStore.KVStoreProvider, prefix);
    }
}
module.exports.ExtensionKVStore = $2747a008ee8702a2$var$ExtensionKVStore;

});
parcelRegister("6SJhc", function(module, exports) {
"use strict";
var $502ae82b6937d420$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BaseKVStore = void 0;
class $502ae82b6937d420$var$BaseKVStore {
    get(key) {
        return $502ae82b6937d420$var$__awaiter(this, void 0, void 0, function*() {
            const k = this.prefix() + "/" + key;
            const data = yield this.provider.get();
            return data[k];
        });
    }
    set(key, data) {
        const k = this.prefix() + "/" + key;
        return this.provider.set({
            [k]: data
        });
    }
    prefix() {
        return this._prefix;
    }
    constructor(provider, _prefix){
        this.provider = provider;
        this._prefix = _prefix;
    }
}
module.exports.BaseKVStore = $502ae82b6937d420$var$BaseKVStore;

});


parcelRegister("crdMs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MemoryKVStore = void 0;

var $6SJhc = parcelRequire("6SJhc");
class $90e2b2309e955c9b$var$MemoryKVStoreProvider {
    get() {
        return Promise.resolve(this.store);
    }
    set(items) {
        this.store = Object.assign(Object.assign({}, this.store), items);
        return Promise.resolve();
    }
    constructor(){
        this.store = {};
    }
}
class $90e2b2309e955c9b$var$MemoryKVStore extends $6SJhc.BaseKVStore {
    constructor(prefix){
        super(new $90e2b2309e955c9b$var$MemoryKVStoreProvider(), prefix);
    }
}
module.exports.MemoryKVStore = $90e2b2309e955c9b$var$MemoryKVStore;

});

parcelRegister("3qLGk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LocalKVStore = void 0;
class $27f8c96047eba542$var$LocalKVStore {
    get(key) {
        const k = this.prefix() + "/" + key;
        const data = localStorage.getItem(k);
        if (data === null) return Promise.resolve(undefined);
        return Promise.resolve(JSON.parse(data));
    }
    set(key, data) {
        const k = this.prefix() + "/" + key;
        if (data === null) return Promise.resolve(localStorage.removeItem(k));
        return Promise.resolve(localStorage.setItem(k, JSON.stringify(data)));
    }
    prefix() {
        return this._prefix;
    }
    constructor(_prefix){
        this._prefix = _prefix;
    }
}
module.exports.LocalKVStore = $27f8c96047eba542$var$LocalKVStore;

});

parcelRegister("jvJ6s", function(module, exports) {
"use strict";
var $e343e61919bbf7d3$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IndexedDBKVStore = void 0;
class $e343e61919bbf7d3$var$IndexedDBKVStore {
    get(key) {
        return $e343e61919bbf7d3$var$__awaiter(this, void 0, void 0, function*() {
            const tx = (yield this.getDB()).transaction([
                this.prefix()
            ], "readonly");
            const store = tx.objectStore(this.prefix());
            return new Promise((resolve, reject)=>{
                const request = store.get(key);
                request.onerror = (event)=>{
                    event.stopPropagation();
                    reject(event.target);
                };
                request.onsuccess = ()=>{
                    if (!request.result) resolve(undefined);
                    else resolve(request.result.data);
                };
            });
        });
    }
    set(key, data) {
        return $e343e61919bbf7d3$var$__awaiter(this, void 0, void 0, function*() {
            if (data === null) {
                const tx = (yield this.getDB()).transaction([
                    this.prefix()
                ], "readwrite");
                const store = tx.objectStore(this.prefix());
                return new Promise((resolve, reject)=>{
                    const request = store.delete(key);
                    request.onerror = (event)=>{
                        event.stopPropagation();
                        reject(event.target);
                    };
                    request.onsuccess = ()=>{
                        resolve();
                    };
                });
            } else {
                const tx = (yield this.getDB()).transaction([
                    this.prefix()
                ], "readwrite");
                const store = tx.objectStore(this.prefix());
                return new Promise((resolve, reject)=>{
                    const request = store.put({
                        key: key,
                        data: data
                    });
                    request.onerror = (event)=>{
                        event.stopPropagation();
                        reject(event.target);
                    };
                    request.onsuccess = ()=>{
                        resolve();
                    };
                });
            }
        });
    }
    prefix() {
        return this._prefix;
    }
    getDB() {
        return $e343e61919bbf7d3$var$__awaiter(this, void 0, void 0, function*() {
            if (this.cachedDB) return this.cachedDB;
            return new Promise((resolve, reject)=>{
                const request = window.indexedDB.open(this.prefix());
                request.onerror = (event)=>{
                    event.stopPropagation();
                    reject(event.target);
                };
                request.onupgradeneeded = (event)=>{
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    const db = event.target.result;
                    db.createObjectStore(this.prefix(), {
                        keyPath: "key"
                    });
                };
                request.onsuccess = ()=>{
                    this.cachedDB = request.result;
                    resolve(request.result);
                };
            });
        });
    }
    constructor(_prefix){
        this._prefix = _prefix;
    }
}
module.exports.IndexedDBKVStore = $e343e61919bbf7d3$var$IndexedDBKVStore;

});


parcelRegister("b3McW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DenomHelper = void 0;

var $gzLuY = parcelRequire("gzLuY");

var $diQDV = parcelRequire("diQDV");
class $80d55e9393640fea$var$DenomHelper {
    static ibcDenom(paths, coinMinimalDenom) {
        const prefixes = [];
        for (const path of paths)prefixes.push(`${path.portId}/${path.channelId}`);
        const prefix = prefixes.join("/");
        const denom = `${prefix}/${coinMinimalDenom}`;
        return "ibc/" + $gzLuY.Buffer.from($diQDV.Hash.sha256($gzLuY.Buffer.from(denom))).toString("hex").toUpperCase();
    }
    get denom() {
        return this._denom;
    }
    get type() {
        return this._type || "native";
    }
    get contractAddress() {
        return this._contractAddress;
    }
    constructor(_denom){
        this._denom = _denom;
        // Remember that the coin's actual denom should start with "type:contractAddress:denom" if it is for the token based on contract.
        const split = this.denom.split(/(\w+):(\w+):(.+)/).filter(Boolean);
        if (split.length !== 1 && split.length !== 3) throw new Error(`Invalid denom: ${this.denom}`);
        this._type = split.length === 3 ? split[0] : "";
        this._contractAddress = split.length === 3 ? split[1] : "";
    }
}
module.exports.DenomHelper = $80d55e9393640fea$var$DenomHelper;

});
parcelRegister("diQDV", function(module, exports) {
"use strict";
var $9af5ca9325d07b83$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9af5ca9325d07b83$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $9af5ca9325d07b83$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$9af5ca9325d07b83$var$__exportStar((parcelRequire("gJZio")), module.exports);

$9af5ca9325d07b83$var$__exportStar((parcelRequire("85Ek8")), module.exports);

$9af5ca9325d07b83$var$__exportStar((parcelRequire("ciGRa")), module.exports);

});
parcelRegister("gJZio", function(module, exports) {
"use strict";
var $c3006556297ca602$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Mnemonic = void 0;

var $8M4RQ = parcelRequire("8M4RQ");

var $jpU8C = parcelRequire("jpU8C");

var $5hfII = parcelRequire("5hfII");

var $gzLuY = parcelRequire("gzLuY");
class $c3006556297ca602$var$Mnemonic {
    static generateWallet(rng, path = `m/44'/118'/0'/0/0`, password = "", strength = 256) {
        return $c3006556297ca602$var$__awaiter(this, void 0, void 0, function*() {
            const mnemonic = yield $c3006556297ca602$var$Mnemonic.generateSeed(rng, strength);
            const privKey = $c3006556297ca602$var$Mnemonic.generateWalletFromMnemonic(mnemonic, path, password);
            return {
                privKey: privKey,
                mnemonic: mnemonic
            };
        });
    }
    static validateMnemonic(mnemonic) {
        return $8M4RQ.validateMnemonic(mnemonic);
    }
    static generateSeed(rng, strength = 128) {
        return $c3006556297ca602$var$__awaiter(this, void 0, void 0, function*() {
            if (strength % 32 !== 0) throw new TypeError("invalid entropy");
            let bytes = new Uint8Array(strength / 8);
            bytes = yield rng(bytes);
            return $8M4RQ.entropyToMnemonic($gzLuY.Buffer.from(bytes).toString("hex"));
        });
    }
    static generateWalletFromMnemonic(mnemonic, path = `m/44'/118'/0'/0/0`, password = "") {
        const seed = $8M4RQ.mnemonicToSeedSync(mnemonic, password);
        const masterSeed = $jpU8C.fromSeed(seed);
        const hd = masterSeed.derivePath(path);
        const privateKey = hd.privateKey;
        if (!privateKey) throw new Error("null hd key");
        return privateKey;
    }
    static generateMasterSeedFromMnemonic(mnemonic, password = "") {
        const seed = $8M4RQ.mnemonicToSeedSync(mnemonic, password);
        const masterKey = $jpU8C.fromSeed(seed);
        return $gzLuY.Buffer.from($5hfII.decode(masterKey.toBase58()));
    }
    static generatePrivateKeyFromMasterSeed(seed, path = `m/44'/118'/0'/0/0`) {
        const masterSeed = $jpU8C.fromBase58($5hfII.encode(seed));
        const hd = masterSeed.derivePath(path);
        const privateKey = hd.privateKey;
        if (!privateKey) throw new Error("null hd key");
        return privateKey;
    }
}
module.exports.Mnemonic = $c3006556297ca602$var$Mnemonic;

});

parcelRegister("85Ek8", function(module, exports) {
"use strict";
var $5e3e11d025c8354a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PubKeySecp256k1 = module.exports.PrivKeySecp256k1 = void 0;

var $492wS = parcelRequire("492wS");

const $5e3e11d025c8354a$var$crypto_js_1 = $5e3e11d025c8354a$var$__importDefault((parcelRequire("kyxLP")));

var $gzLuY = parcelRequire("gzLuY");

var $ciGRa = parcelRequire("ciGRa");
class $5e3e11d025c8354a$var$PrivKeySecp256k1 {
    static generateRandomKey() {
        const secp256k1 = new $492wS.ec("secp256k1");
        return new $5e3e11d025c8354a$var$PrivKeySecp256k1($gzLuY.Buffer.from(secp256k1.genKeyPair().getPrivate().toArray()));
    }
    toBytes() {
        return new Uint8Array(this.privKey);
    }
    getPubKey() {
        const secp256k1 = new $492wS.ec("secp256k1");
        const key = secp256k1.keyFromPrivate(this.privKey);
        return new $5e3e11d025c8354a$var$PubKeySecp256k1(new Uint8Array(key.getPublic().encodeCompressed("array")));
    }
    /**
     * @deprecated Use `signDigest32(Hash.sha256(data))` instead.
     * @param msg
     */ sign(msg) {
        return this.signDigest32($ciGRa.Hash.sha256(msg));
    }
    signDigest32(digest) {
        if (digest.length !== 32) throw new Error(`Invalid length of digest to sign: ${digest.length}`);
        const secp256k1 = new $492wS.ec("secp256k1");
        const key = secp256k1.keyFromPrivate(this.privKey);
        const signature = key.sign(digest, {
            canonical: true
        });
        return new Uint8Array(signature.r.toArray("be", 32).concat(signature.s.toArray("be", 32)));
    }
    constructor(privKey){
        this.privKey = privKey;
    }
}
module.exports.PrivKeySecp256k1 = $5e3e11d025c8354a$var$PrivKeySecp256k1;
class $5e3e11d025c8354a$var$PubKeySecp256k1 {
    toBytes(uncompressed) {
        if (uncompressed) {
            const keyPair = this.toKeyPair();
            return new Uint8Array($gzLuY.Buffer.from(keyPair.getPublic().encode("hex", false), "hex"));
        }
        return new Uint8Array(this.pubKey);
    }
    // Cosmos address
    getAddress() {
        let hash = $5e3e11d025c8354a$var$crypto_js_1.default.SHA256($5e3e11d025c8354a$var$crypto_js_1.default.lib.WordArray.create(this.pubKey)).toString();
        hash = $5e3e11d025c8354a$var$crypto_js_1.default.RIPEMD160($5e3e11d025c8354a$var$crypto_js_1.default.enc.Hex.parse(hash)).toString();
        return new Uint8Array($gzLuY.Buffer.from(hash, "hex"));
    }
    getEthAddress() {
        // Should be uncompressed.
        // And remove prefix byte.
        // And hash by keccak256.
        // Use last 20 bytes.
        return $ciGRa.Hash.keccak256(this.toBytes(true).slice(1)).slice(-20);
    }
    toKeyPair() {
        const secp256k1 = new $492wS.ec("secp256k1");
        return secp256k1.keyFromPublic($gzLuY.Buffer.from(this.pubKey).toString("hex"), "hex");
    }
    /**
     * @deprecated Use `verifyDigest32(Hash.sha256(data))` instead.
     * @param msg
     */ verify(msg, signature) {
        return this.verifyDigest32($ciGRa.Hash.sha256(msg), signature);
    }
    verifyDigest32(digest, signature) {
        if (digest.length !== 32) throw new Error(`Invalid length of digest to verify: ${digest.length}`);
        if (signature.length !== 64) throw new Error(`Invalid length of signature: ${signature.length}`);
        const secp256k1 = new $492wS.ec("secp256k1");
        const r = signature.slice(0, 32);
        const s = signature.slice(32);
        return secp256k1.verify(digest, {
            r: $gzLuY.Buffer.from(r).toString("hex"),
            s: $gzLuY.Buffer.from(s).toString("hex")
        }, this.toKeyPair());
    }
    constructor(pubKey){
        this.pubKey = pubKey;
    }
}
module.exports.PubKeySecp256k1 = $5e3e11d025c8354a$var$PubKeySecp256k1;

});
parcelRegister("kyxLP", function(module, exports) {



































(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("iCQTn")), (parcelRequire("kVcBU")), (parcelRequire("eXtXB")), (parcelRequire("8mimy")), (parcelRequire("eg7Z0")), (parcelRequire("cSpKU")), (parcelRequire("gJi2y")), (parcelRequire("7pYDf")), (parcelRequire("b4zd4")), (parcelRequire("kxbG3")), (parcelRequire("6DsZi")), (parcelRequire("gHnaK")), (parcelRequire("iKDGt")), (parcelRequire("gEJHB")), (parcelRequire("gNPXo")), (parcelRequire("gIUnh")), (parcelRequire("cL93H")), (parcelRequire("lLOi4")), (parcelRequire("6JXUS")), (parcelRequire("7cvkA")), (parcelRequire("fp0ZR")), (parcelRequire("7vorb")), (parcelRequire("l4l1x")), (parcelRequire("fuTlY")), (parcelRequire("hh5we")), (parcelRequire("1fjor")), (parcelRequire("dM2wj")), (parcelRequire("lGseF")), (parcelRequire("6oSmW")), (parcelRequire("3D3Ku")), (parcelRequire("7Z3Xv")), (parcelRequire("89sC6")), (parcelRequire("8dzkn")), (parcelRequire("kSTFn")), (parcelRequire("62CxY")));
})(this, function(CryptoJS) {
    return CryptoJS;
});

});
parcelRegister("iCQTn", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory();
})(this, function() {
    /*globals window, global, require*/ /**
	 * CryptoJS core components.
	 */ var CryptoJS = CryptoJS || function(Math1, undefined) {
        var crypto;
        // Native crypto from window (Browser)
        if (typeof window !== "undefined" && window.crypto) crypto = window.crypto;
        // Native crypto in web worker (Browser)
        if (typeof self !== "undefined" && self.crypto) crypto = self.crypto;
        // Native crypto from worker
        if (typeof globalThis !== "undefined" && globalThis.crypto) crypto = globalThis.crypto;
        // Native (experimental IE 11) crypto from window (Browser)
        if (!crypto && typeof window !== "undefined" && window.msCrypto) crypto = window.msCrypto;
        // Native crypto from global (NodeJS)
        if (!crypto && typeof $parcel$global !== "undefined" && $parcel$global.crypto) crypto = $parcel$global.crypto;
        // Native crypto import via require (NodeJS)
        if (!crypto && true) try {
            crypto = (parcelRequire("aqbQf"));
        } catch (err) {}
        /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */ var cryptoSecureRandomInt = function() {
            if (crypto) {
                // Use getRandomValues method (Browser)
                if (typeof crypto.getRandomValues === "function") try {
                    return crypto.getRandomValues(new Uint32Array(1))[0];
                } catch (err) {}
                // Use randomBytes method (NodeJS)
                if (typeof crypto.randomBytes === "function") try {
                    return crypto.randomBytes(4).readInt32LE();
                } catch (err) {}
            }
            throw new Error("Native crypto module could not be used to get secure random number.");
        };
        /*
	     * Local polyfill of Object.create

	     */ var create = Object.create || function() {
            function F() {}
            return function(obj) {
                var subtype;
                F.prototype = obj;
                subtype = new F();
                F.prototype = null;
                return subtype;
            };
        }();
        /**
	     * CryptoJS namespace.
	     */ var C = {};
        /**
	     * Library namespace.
	     */ var C_lib = C.lib = {};
        /**
	     * Base object for prototypal inheritance.
	     */ var Base = C_lib.Base = function() {
            return {
                /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */ extend: function(overrides) {
                    // Spawn
                    var subtype = create(this);
                    // Augment
                    if (overrides) subtype.mixIn(overrides);
                    // Create default initializer
                    if (!subtype.hasOwnProperty("init") || this.init === subtype.init) subtype.init = function() {
                        subtype.$super.init.apply(this, arguments);
                    };
                    // Initializer's prototype is the subtype object
                    subtype.init.prototype = subtype;
                    // Reference supertype
                    subtype.$super = this;
                    return subtype;
                },
                /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */ create: function() {
                    var instance = this.extend();
                    instance.init.apply(instance, arguments);
                    return instance;
                },
                /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */ init: function() {},
                /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */ mixIn: function(properties) {
                    for(var propertyName in properties)if (properties.hasOwnProperty(propertyName)) this[propertyName] = properties[propertyName];
                    // IE won't copy toString using the loop above
                    if (properties.hasOwnProperty("toString")) this.toString = properties.toString;
                },
                /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */ clone: function() {
                    return this.init.prototype.extend(this);
                }
            };
        }();
        /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var WordArray = C_lib.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 4;
            },
            /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */ toString: function(encoder) {
                return (encoder || Hex).stringify(this);
            },
            /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */ concat: function(wordArray) {
                // Shortcuts
                var thisWords = this.words;
                var thatWords = wordArray.words;
                var thisSigBytes = this.sigBytes;
                var thatSigBytes = wordArray.sigBytes;
                // Clamp excess bits
                this.clamp();
                // Concat
                if (thisSigBytes % 4) // Copy one byte at a time
                for(var i = 0; i < thatSigBytes; i++){
                    var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
                }
                else // Copy one word at a time
                for(var j = 0; j < thatSigBytes; j += 4)thisWords[thisSigBytes + j >>> 2] = thatWords[j >>> 2];
                this.sigBytes += thatSigBytes;
                // Chainable
                return this;
            },
            /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */ clamp: function() {
                // Shortcuts
                var words = this.words;
                var sigBytes = this.sigBytes;
                // Clamp
                words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
                words.length = Math1.ceil(sigBytes / 4);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone.words = this.words.slice(0);
                return clone;
            },
            /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */ random: function(nBytes) {
                var words = [];
                for(var i = 0; i < nBytes; i += 4)words.push(cryptoSecureRandomInt());
                return new WordArray.init(words, nBytes);
            }
        });
        /**
	     * Encoder namespace.
	     */ var C_enc = C.enc = {};
        /**
	     * Hex encoding strategy.
	     */ var Hex = C_enc.Hex = {
            /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var hexChars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    hexChars.push((bite >>> 4).toString(16));
                    hexChars.push((bite & 0x0f).toString(16));
                }
                return hexChars.join("");
            },
            /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */ parse: function(hexStr) {
                // Shortcut
                var hexStrLength = hexStr.length;
                // Convert
                var words = [];
                for(var i = 0; i < hexStrLength; i += 2)words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
                return new WordArray.init(words, hexStrLength / 2);
            }
        };
        /**
	     * Latin1 encoding strategy.
	     */ var Latin1 = C_enc.Latin1 = {
            /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var latin1Chars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    latin1Chars.push(String.fromCharCode(bite));
                }
                return latin1Chars.join("");
            },
            /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */ parse: function(latin1Str) {
                // Shortcut
                var latin1StrLength = latin1Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < latin1StrLength; i++)words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
                return new WordArray.init(words, latin1StrLength);
            }
        };
        /**
	     * UTF-8 encoding strategy.
	     */ var Utf8 = C_enc.Utf8 = {
            /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */ stringify: function(wordArray) {
                try {
                    return decodeURIComponent(escape(Latin1.stringify(wordArray)));
                } catch (e) {
                    throw new Error("Malformed UTF-8 data");
                }
            },
            /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */ parse: function(utf8Str) {
                return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
            }
        };
        /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */ var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
            /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */ reset: function() {
                // Initial values
                this._data = new WordArray.init();
                this._nDataBytes = 0;
            },
            /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */ _append: function(data) {
                // Convert string to WordArray, else assume WordArray already
                if (typeof data == "string") data = Utf8.parse(data);
                // Append
                this._data.concat(data);
                this._nDataBytes += data.sigBytes;
            },
            /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */ _process: function(doFlush) {
                var processedWords;
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var dataSigBytes = data.sigBytes;
                var blockSize = this.blockSize;
                var blockSizeBytes = blockSize * 4;
                // Count blocks ready
                var nBlocksReady = dataSigBytes / blockSizeBytes;
                if (doFlush) // Round up to include partial blocks
                nBlocksReady = Math1.ceil(nBlocksReady);
                else // Round down to include only full blocks,
                // less the number of blocks that must remain in the buffer
                nBlocksReady = Math1.max((nBlocksReady | 0) - this._minBufferSize, 0);
                // Count words ready
                var nWordsReady = nBlocksReady * blockSize;
                // Count bytes ready
                var nBytesReady = Math1.min(nWordsReady * 4, dataSigBytes);
                // Process blocks
                if (nWordsReady) {
                    for(var offset = 0; offset < nWordsReady; offset += blockSize)// Perform concrete-algorithm logic
                    this._doProcessBlock(dataWords, offset);
                    // Remove processed words
                    processedWords = dataWords.splice(0, nWordsReady);
                    data.sigBytes -= nBytesReady;
                }
                // Return processed words
                return new WordArray.init(processedWords, nBytesReady);
            },
            /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone._data = this._data.clone();
                return clone;
            },
            _minBufferSize: 0
        });
        /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */ var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         */ cfg: Base.extend(),
            /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */ init: function(cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-hasher logic
                this._doReset();
            },
            /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */ update: function(messageUpdate) {
                // Append
                this._append(messageUpdate);
                // Update the hash
                this._process();
                // Chainable
                return this;
            },
            /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Final message update
                if (messageUpdate) this._append(messageUpdate);
                // Perform concrete-hasher logic
                var hash = this._doFinalize();
                return hash;
            },
            blockSize: 16,
            /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */ _createHelper: function(hasher) {
                return function(message, cfg) {
                    return new hasher.init(cfg).finalize(message);
                };
            },
            /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */ _createHmacHelper: function(hasher) {
                return function(message, key) {
                    return new C_algo.HMAC.init(hasher, key).finalize(message);
                };
            }
        });
        /**
	     * Algorithm namespace.
	     */ var C_algo = C.algo = {};
        return C;
    }(Math);
    return CryptoJS;
});

});

parcelRegister("kVcBU", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("iCQTn")));
})(this, function(CryptoJS) {
    (function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var X32WordArray = C_lib.WordArray;
        /**
	     * x64 namespace.
	     */ var C_x64 = C.x64 = {};
        /**
	     * A 64-bit word.
	     */ var X64Word = C_x64.Word = Base.extend({
            /**
	         * Initializes a newly created 64-bit word.
	         *
	         * @param {number} high The high 32 bits.
	         * @param {number} low The low 32 bits.
	         *
	         * @example
	         *
	         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
	         */ init: function(high, low) {
                this.high = high;
                this.low = low;
            }
        });
        /**
	     * An array of 64-bit words.
	     *
	     * @property {Array} words The array of CryptoJS.x64.Word objects.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var X64WordArray = C_x64.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create();
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ]);
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ], 10);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 8;
            },
            /**
	         * Converts this 64-bit word array to a 32-bit word array.
	         *
	         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
	         *
	         * @example
	         *
	         *     var x32WordArray = x64WordArray.toX32();
	         */ toX32: function() {
                // Shortcuts
                var x64Words = this.words;
                var x64WordsLength = x64Words.length;
                // Convert
                var x32Words = [];
                for(var i = 0; i < x64WordsLength; i++){
                    var x64Word = x64Words[i];
                    x32Words.push(x64Word.high);
                    x32Words.push(x64Word.low);
                }
                return X32WordArray.create(x32Words, this.sigBytes);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {X64WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = x64WordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                // Clone "words" array
                var words = clone.words = this.words.slice(0);
                // Clone each X64Word object
                var wordsLength = words.length;
                for(var i = 0; i < wordsLength; i++)words[i] = words[i].clone();
                return clone;
            }
        });
    })();
    return CryptoJS;
});

});

parcelRegister("eXtXB", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("iCQTn")));
})(this, function(CryptoJS) {
    (function() {
        // Check if typed arrays are supported
        if (typeof ArrayBuffer != "function") return;
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        // Reference original init
        var superInit = WordArray.init;
        // Augment WordArray.init to handle typed arrays
        var subInit = WordArray.init = function(typedArray) {
            // Convert buffers to uint8
            if (typedArray instanceof ArrayBuffer) typedArray = new Uint8Array(typedArray);
            // Convert other array views to uint8
            if (typedArray instanceof Int8Array || typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray || typedArray instanceof Int16Array || typedArray instanceof Uint16Array || typedArray instanceof Int32Array || typedArray instanceof Uint32Array || typedArray instanceof Float32Array || typedArray instanceof Float64Array) typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
            // Handle Uint8Array
            if (typedArray instanceof Uint8Array) {
                // Shortcut
                var typedArrayByteLength = typedArray.byteLength;
                // Extract bytes
                var words = [];
                for(var i = 0; i < typedArrayByteLength; i++)words[i >>> 2] |= typedArray[i] << 24 - i % 4 * 8;
                // Initialize this word array
                superInit.call(this, words, typedArrayByteLength);
            } else // Else call normal init
            superInit.apply(this, arguments);
        };
        subInit.prototype = WordArray;
    })();
    return CryptoJS.lib.WordArray;
});

});

parcelRegister("8mimy", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("iCQTn")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * UTF-16 BE encoding strategy.
	     */ var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
            /**
	         * Converts a word array to a UTF-16 BE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 BE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var utf16Chars = [];
                for(var i = 0; i < sigBytes; i += 2){
                    var codePoint = words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff;
                    utf16Chars.push(String.fromCharCode(codePoint));
                }
                return utf16Chars.join("");
            },
            /**
	         * Converts a UTF-16 BE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 BE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
	         */ parse: function(utf16Str) {
                // Shortcut
                var utf16StrLength = utf16Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < utf16StrLength; i++)words[i >>> 1] |= utf16Str.charCodeAt(i) << 16 - i % 2 * 16;
                return WordArray.create(words, utf16StrLength * 2);
            }
        };
        /**
	     * UTF-16 LE encoding strategy.
	     */ C_enc.Utf16LE = {
            /**
	         * Converts a word array to a UTF-16 LE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 LE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var utf16Chars = [];
                for(var i = 0; i < sigBytes; i += 2){
                    var codePoint = swapEndian(words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff);
                    utf16Chars.push(String.fromCharCode(codePoint));
                }
                return utf16Chars.join("");
            },
            /**
	         * Converts a UTF-16 LE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 LE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
	         */ parse: function(utf16Str) {
                // Shortcut
                var utf16StrLength = utf16Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < utf16StrLength; i++)words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << 16 - i % 2 * 16);
                return WordArray.create(words, utf16StrLength * 2);
            }
        };
        function swapEndian(word) {
            return word << 8 & 0xff00ff00 | word >>> 8 & 0x00ff00ff;
        }
    })();
    return CryptoJS.enc.Utf16;
});

});

parcelRegister("eg7Z0", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("iCQTn")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * Base64 encoding strategy.
	     */ var Base64 = C_enc.Base64 = {
            /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                var map = this._map;
                // Clamp excess bits
                wordArray.clamp();
                // Convert
                var base64Chars = [];
                for(var i = 0; i < sigBytes; i += 3){
                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                }
                // Add padding
                var paddingChar = map.charAt(64);
                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                return base64Chars.join("");
            },
            /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */ parse: function(base64Str) {
                // Shortcuts
                var base64StrLength = base64Str.length;
                var map = this._map;
                var reverseMap = this._reverseMap;
                if (!reverseMap) {
                    reverseMap = this._reverseMap = [];
                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                }
                // Ignore padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                    var paddingIndex = base64Str.indexOf(paddingChar);
                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                }
                // Convert
                return parseLoop(base64Str, base64StrLength, reverseMap);
            },
            _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
            var words = [];
            var nBytes = 0;
            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                var bitsCombined = bits1 | bits2;
                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                nBytes++;
            }
            return WordArray.create(words, nBytes);
        }
    })();
    return CryptoJS.enc.Base64;
});

});

parcelRegister("cSpKU", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("iCQTn")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * Base64url encoding strategy.
	     */ var Base64url = C_enc.Base64url = {
            /**
	         * Converts a word array to a Base64url string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @param {boolean} urlSafe Whether to use url safe
	         *
	         * @return {string} The Base64url string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64url.stringify(wordArray);
	         */ stringify: function(wordArray, urlSafe) {
                if (urlSafe === undefined) urlSafe = true;
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                var map = urlSafe ? this._safe_map : this._map;
                // Clamp excess bits
                wordArray.clamp();
                // Convert
                var base64Chars = [];
                for(var i = 0; i < sigBytes; i += 3){
                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                }
                // Add padding
                var paddingChar = map.charAt(64);
                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                return base64Chars.join("");
            },
            /**
	         * Converts a Base64url string to a word array.
	         *
	         * @param {string} base64Str The Base64url string.
	         *
	         * @param {boolean} urlSafe Whether to use url safe
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64url.parse(base64String);
	         */ parse: function(base64Str, urlSafe) {
                if (urlSafe === undefined) urlSafe = true;
                // Shortcuts
                var base64StrLength = base64Str.length;
                var map = urlSafe ? this._safe_map : this._map;
                var reverseMap = this._reverseMap;
                if (!reverseMap) {
                    reverseMap = this._reverseMap = [];
                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                }
                // Ignore padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                    var paddingIndex = base64Str.indexOf(paddingChar);
                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                }
                // Convert
                return parseLoop(base64Str, base64StrLength, reverseMap);
            },
            _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
            _safe_map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
            var words = [];
            var nBytes = 0;
            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                var bitsCombined = bits1 | bits2;
                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                nBytes++;
            }
            return WordArray.create(words, nBytes);
        }
    })();
    return CryptoJS.enc.Base64url;
});

});

parcelRegister("gJi2y", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("iCQTn")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Constants table
        var T = [];
        // Compute constants
        (function() {
            for(var i = 0; i < 64; i++)T[i] = Math1.abs(Math1.sin(i + 1)) * 0x100000000 | 0;
        })();
        /**
	     * MD5 hash algorithm.
	     */ var MD5 = C_algo.MD5 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0x67452301,
                    0xefcdab89,
                    0x98badcfe,
                    0x10325476
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Swap endian
                for(var i = 0; i < 16; i++){
                    // Shortcuts
                    var offset_i = offset + i;
                    var M_offset_i = M[offset_i];
                    M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                }
                // Shortcuts
                var H = this._hash.words;
                var M_offset_0 = M[offset + 0];
                var M_offset_1 = M[offset + 1];
                var M_offset_2 = M[offset + 2];
                var M_offset_3 = M[offset + 3];
                var M_offset_4 = M[offset + 4];
                var M_offset_5 = M[offset + 5];
                var M_offset_6 = M[offset + 6];
                var M_offset_7 = M[offset + 7];
                var M_offset_8 = M[offset + 8];
                var M_offset_9 = M[offset + 9];
                var M_offset_10 = M[offset + 10];
                var M_offset_11 = M[offset + 11];
                var M_offset_12 = M[offset + 12];
                var M_offset_13 = M[offset + 13];
                var M_offset_14 = M[offset + 14];
                var M_offset_15 = M[offset + 15];
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                // Computation
                a = FF(a, b, c, d, M_offset_0, 7, T[0]);
                d = FF(d, a, b, c, M_offset_1, 12, T[1]);
                c = FF(c, d, a, b, M_offset_2, 17, T[2]);
                b = FF(b, c, d, a, M_offset_3, 22, T[3]);
                a = FF(a, b, c, d, M_offset_4, 7, T[4]);
                d = FF(d, a, b, c, M_offset_5, 12, T[5]);
                c = FF(c, d, a, b, M_offset_6, 17, T[6]);
                b = FF(b, c, d, a, M_offset_7, 22, T[7]);
                a = FF(a, b, c, d, M_offset_8, 7, T[8]);
                d = FF(d, a, b, c, M_offset_9, 12, T[9]);
                c = FF(c, d, a, b, M_offset_10, 17, T[10]);
                b = FF(b, c, d, a, M_offset_11, 22, T[11]);
                a = FF(a, b, c, d, M_offset_12, 7, T[12]);
                d = FF(d, a, b, c, M_offset_13, 12, T[13]);
                c = FF(c, d, a, b, M_offset_14, 17, T[14]);
                b = FF(b, c, d, a, M_offset_15, 22, T[15]);
                a = GG(a, b, c, d, M_offset_1, 5, T[16]);
                d = GG(d, a, b, c, M_offset_6, 9, T[17]);
                c = GG(c, d, a, b, M_offset_11, 14, T[18]);
                b = GG(b, c, d, a, M_offset_0, 20, T[19]);
                a = GG(a, b, c, d, M_offset_5, 5, T[20]);
                d = GG(d, a, b, c, M_offset_10, 9, T[21]);
                c = GG(c, d, a, b, M_offset_15, 14, T[22]);
                b = GG(b, c, d, a, M_offset_4, 20, T[23]);
                a = GG(a, b, c, d, M_offset_9, 5, T[24]);
                d = GG(d, a, b, c, M_offset_14, 9, T[25]);
                c = GG(c, d, a, b, M_offset_3, 14, T[26]);
                b = GG(b, c, d, a, M_offset_8, 20, T[27]);
                a = GG(a, b, c, d, M_offset_13, 5, T[28]);
                d = GG(d, a, b, c, M_offset_2, 9, T[29]);
                c = GG(c, d, a, b, M_offset_7, 14, T[30]);
                b = GG(b, c, d, a, M_offset_12, 20, T[31]);
                a = HH(a, b, c, d, M_offset_5, 4, T[32]);
                d = HH(d, a, b, c, M_offset_8, 11, T[33]);
                c = HH(c, d, a, b, M_offset_11, 16, T[34]);
                b = HH(b, c, d, a, M_offset_14, 23, T[35]);
                a = HH(a, b, c, d, M_offset_1, 4, T[36]);
                d = HH(d, a, b, c, M_offset_4, 11, T[37]);
                c = HH(c, d, a, b, M_offset_7, 16, T[38]);
                b = HH(b, c, d, a, M_offset_10, 23, T[39]);
                a = HH(a, b, c, d, M_offset_13, 4, T[40]);
                d = HH(d, a, b, c, M_offset_0, 11, T[41]);
                c = HH(c, d, a, b, M_offset_3, 16, T[42]);
                b = HH(b, c, d, a, M_offset_6, 23, T[43]);
                a = HH(a, b, c, d, M_offset_9, 4, T[44]);
                d = HH(d, a, b, c, M_offset_12, 11, T[45]);
                c = HH(c, d, a, b, M_offset_15, 16, T[46]);
                b = HH(b, c, d, a, M_offset_2, 23, T[47]);
                a = II(a, b, c, d, M_offset_0, 6, T[48]);
                d = II(d, a, b, c, M_offset_7, 10, T[49]);
                c = II(c, d, a, b, M_offset_14, 15, T[50]);
                b = II(b, c, d, a, M_offset_5, 21, T[51]);
                a = II(a, b, c, d, M_offset_12, 6, T[52]);
                d = II(d, a, b, c, M_offset_3, 10, T[53]);
                c = II(c, d, a, b, M_offset_10, 15, T[54]);
                b = II(b, c, d, a, M_offset_1, 21, T[55]);
                a = II(a, b, c, d, M_offset_8, 6, T[56]);
                d = II(d, a, b, c, M_offset_15, 10, T[57]);
                c = II(c, d, a, b, M_offset_6, 15, T[58]);
                b = II(b, c, d, a, M_offset_13, 21, T[59]);
                a = II(a, b, c, d, M_offset_4, 6, T[60]);
                d = II(d, a, b, c, M_offset_11, 10, T[61]);
                c = II(c, d, a, b, M_offset_2, 15, T[62]);
                b = II(b, c, d, a, M_offset_9, 21, T[63]);
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                var nBitsTotalH = Math1.floor(nBitsTotal / 0x100000000);
                var nBitsTotalL = nBitsTotal;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = (nBitsTotalH << 8 | nBitsTotalH >>> 24) & 0x00ff00ff | (nBitsTotalH << 24 | nBitsTotalH >>> 8) & 0xff00ff00;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotalL << 8 | nBitsTotalL >>> 24) & 0x00ff00ff | (nBitsTotalL << 24 | nBitsTotalL >>> 8) & 0xff00ff00;
                data.sigBytes = (dataWords.length + 1) * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var hash = this._hash;
                var H = hash.words;
                // Swap endian
                for(var i = 0; i < 4; i++){
                    // Shortcut
                    var H_i = H[i];
                    H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                }
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        function FF(a, b, c, d, x, s, t) {
            var n = a + (b & c | ~b & d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function GG(a, b, c, d, x, s, t) {
            var n = a + (b & d | c & ~d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function HH(a, b, c, d, x, s, t) {
            var n = a + (b ^ c ^ d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function II(a, b, c, d, x, s, t) {
            var n = a + (c ^ (b | ~d)) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */ C.MD5 = Hasher._createHelper(MD5);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */ C.HmacMD5 = Hasher._createHmacHelper(MD5);
    })(Math);
    return CryptoJS.MD5;
});

});

parcelRegister("7pYDf", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("iCQTn")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Reusable object
        var W = [];
        /**
	     * SHA-1 hash algorithm.
	     */ var SHA1 = C_algo.SHA1 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0x67452301,
                    0xefcdab89,
                    0x98badcfe,
                    0x10325476,
                    0xc3d2e1f0
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                // Computation
                for(var i = 0; i < 80; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
                        W[i] = n << 1 | n >>> 31;
                    }
                    var t = (a << 5 | a >>> 27) + e + W[i];
                    if (i < 20) t += (b & c | ~b & d) + 0x5a827999;
                    else if (i < 40) t += (b ^ c ^ d) + 0x6ed9eba1;
                    else if (i < 60) t += (b & c | b & d | c & d) - 0x70e44324;
                    else t += (b ^ c ^ d) - 0x359d3e2a;
                    e = d;
                    d = c;
                    c = b << 30 | b >>> 2;
                    b = a;
                    a = t;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */ C.SHA1 = Hasher._createHelper(SHA1);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */ C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
    })();
    return CryptoJS.SHA1;
});

});

parcelRegister("b4zd4", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("iCQTn")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Initialization and round constants tables
        var H = [];
        var K = [];
        // Compute constants
        (function() {
            function isPrime(n) {
                var sqrtN = Math1.sqrt(n);
                for(var factor = 2; factor <= sqrtN; factor++){
                    if (!(n % factor)) return false;
                }
                return true;
            }
            function getFractionalBits(n) {
                return (n - (n | 0)) * 0x100000000 | 0;
            }
            var n = 2;
            var nPrime = 0;
            while(nPrime < 64){
                if (isPrime(n)) {
                    if (nPrime < 8) H[nPrime] = getFractionalBits(Math1.pow(n, 0.5));
                    K[nPrime] = getFractionalBits(Math1.pow(n, 1 / 3));
                    nPrime++;
                }
                n++;
            }
        })();
        // Reusable object
        var W = [];
        /**
	     * SHA-256 hash algorithm.
	     */ var SHA256 = C_algo.SHA256 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init(H.slice(0));
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                var f = H[5];
                var g = H[6];
                var h = H[7];
                // Computation
                for(var i = 0; i < 64; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var gamma0x = W[i - 15];
                        var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
                        var gamma1x = W[i - 2];
                        var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
                        W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
                    }
                    var ch = e & f ^ ~e & g;
                    var maj = a & b ^ a & c ^ b & c;
                    var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
                    var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
                    var t1 = h + sigma1 + ch + K[i] + W[i];
                    var t2 = sigma0 + maj;
                    h = g;
                    g = f;
                    f = e;
                    e = d + t1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = t1 + t2 | 0;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
                H[5] = H[5] + f | 0;
                H[6] = H[6] + g | 0;
                H[7] = H[7] + h | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math1.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */ C.SHA256 = Hasher._createHelper(SHA256);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */ C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
    })(Math);
    return CryptoJS.SHA256;
});

});

parcelRegister("kxbG3", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("iCQTn")), (parcelRequire("b4zd4")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var SHA256 = C_algo.SHA256;
        /**
	     * SHA-224 hash algorithm.
	     */ var SHA224 = C_algo.SHA224 = SHA256.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0xc1059ed8,
                    0x367cd507,
                    0x3070dd17,
                    0xf70e5939,
                    0xffc00b31,
                    0x68581511,
                    0x64f98fa7,
                    0xbefa4fa4
                ]);
            },
            _doFinalize: function() {
                var hash = SHA256._doFinalize.call(this);
                hash.sigBytes -= 4;
                return hash;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA224('message');
	     *     var hash = CryptoJS.SHA224(wordArray);
	     */ C.SHA224 = SHA256._createHelper(SHA224);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA224(message, key);
	     */ C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
    })();
    return CryptoJS.SHA224;
});

});

parcelRegister("6DsZi", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("iCQTn")), (parcelRequire("kVcBU")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Hasher = C_lib.Hasher;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var X64WordArray = C_x64.WordArray;
        var C_algo = C.algo;
        function X64Word_create() {
            return X64Word.create.apply(X64Word, arguments);
        }
        // Constants
        var K = [
            X64Word_create(0x428a2f98, 0xd728ae22),
            X64Word_create(0x71374491, 0x23ef65cd),
            X64Word_create(0xb5c0fbcf, 0xec4d3b2f),
            X64Word_create(0xe9b5dba5, 0x8189dbbc),
            X64Word_create(0x3956c25b, 0xf348b538),
            X64Word_create(0x59f111f1, 0xb605d019),
            X64Word_create(0x923f82a4, 0xaf194f9b),
            X64Word_create(0xab1c5ed5, 0xda6d8118),
            X64Word_create(0xd807aa98, 0xa3030242),
            X64Word_create(0x12835b01, 0x45706fbe),
            X64Word_create(0x243185be, 0x4ee4b28c),
            X64Word_create(0x550c7dc3, 0xd5ffb4e2),
            X64Word_create(0x72be5d74, 0xf27b896f),
            X64Word_create(0x80deb1fe, 0x3b1696b1),
            X64Word_create(0x9bdc06a7, 0x25c71235),
            X64Word_create(0xc19bf174, 0xcf692694),
            X64Word_create(0xe49b69c1, 0x9ef14ad2),
            X64Word_create(0xefbe4786, 0x384f25e3),
            X64Word_create(0x0fc19dc6, 0x8b8cd5b5),
            X64Word_create(0x240ca1cc, 0x77ac9c65),
            X64Word_create(0x2de92c6f, 0x592b0275),
            X64Word_create(0x4a7484aa, 0x6ea6e483),
            X64Word_create(0x5cb0a9dc, 0xbd41fbd4),
            X64Word_create(0x76f988da, 0x831153b5),
            X64Word_create(0x983e5152, 0xee66dfab),
            X64Word_create(0xa831c66d, 0x2db43210),
            X64Word_create(0xb00327c8, 0x98fb213f),
            X64Word_create(0xbf597fc7, 0xbeef0ee4),
            X64Word_create(0xc6e00bf3, 0x3da88fc2),
            X64Word_create(0xd5a79147, 0x930aa725),
            X64Word_create(0x06ca6351, 0xe003826f),
            X64Word_create(0x14292967, 0x0a0e6e70),
            X64Word_create(0x27b70a85, 0x46d22ffc),
            X64Word_create(0x2e1b2138, 0x5c26c926),
            X64Word_create(0x4d2c6dfc, 0x5ac42aed),
            X64Word_create(0x53380d13, 0x9d95b3df),
            X64Word_create(0x650a7354, 0x8baf63de),
            X64Word_create(0x766a0abb, 0x3c77b2a8),
            X64Word_create(0x81c2c92e, 0x47edaee6),
            X64Word_create(0x92722c85, 0x1482353b),
            X64Word_create(0xa2bfe8a1, 0x4cf10364),
            X64Word_create(0xa81a664b, 0xbc423001),
            X64Word_create(0xc24b8b70, 0xd0f89791),
            X64Word_create(0xc76c51a3, 0x0654be30),
            X64Word_create(0xd192e819, 0xd6ef5218),
            X64Word_create(0xd6990624, 0x5565a910),
            X64Word_create(0xf40e3585, 0x5771202a),
            X64Word_create(0x106aa070, 0x32bbd1b8),
            X64Word_create(0x19a4c116, 0xb8d2d0c8),
            X64Word_create(0x1e376c08, 0x5141ab53),
            X64Word_create(0x2748774c, 0xdf8eeb99),
            X64Word_create(0x34b0bcb5, 0xe19b48a8),
            X64Word_create(0x391c0cb3, 0xc5c95a63),
            X64Word_create(0x4ed8aa4a, 0xe3418acb),
            X64Word_create(0x5b9cca4f, 0x7763e373),
            X64Word_create(0x682e6ff3, 0xd6b2b8a3),
            X64Word_create(0x748f82ee, 0x5defb2fc),
            X64Word_create(0x78a5636f, 0x43172f60),
            X64Word_create(0x84c87814, 0xa1f0ab72),
            X64Word_create(0x8cc70208, 0x1a6439ec),
            X64Word_create(0x90befffa, 0x23631e28),
            X64Word_create(0xa4506ceb, 0xde82bde9),
            X64Word_create(0xbef9a3f7, 0xb2c67915),
            X64Word_create(0xc67178f2, 0xe372532b),
            X64Word_create(0xca273ece, 0xea26619c),
            X64Word_create(0xd186b8c7, 0x21c0c207),
            X64Word_create(0xeada7dd6, 0xcde0eb1e),
            X64Word_create(0xf57d4f7f, 0xee6ed178),
            X64Word_create(0x06f067aa, 0x72176fba),
            X64Word_create(0x0a637dc5, 0xa2c898a6),
            X64Word_create(0x113f9804, 0xbef90dae),
            X64Word_create(0x1b710b35, 0x131c471b),
            X64Word_create(0x28db77f5, 0x23047d84),
            X64Word_create(0x32caab7b, 0x40c72493),
            X64Word_create(0x3c9ebe0a, 0x15c9bebc),
            X64Word_create(0x431d67c4, 0x9c100d4c),
            X64Word_create(0x4cc5d4be, 0xcb3e42b6),
            X64Word_create(0x597f299c, 0xfc657e2a),
            X64Word_create(0x5fcb6fab, 0x3ad6faec),
            X64Word_create(0x6c44198c, 0x4a475817)
        ];
        // Reusable objects
        var W = [];
        (function() {
            for(var i = 0; i < 80; i++)W[i] = X64Word_create();
        })();
        /**
	     * SHA-512 hash algorithm.
	     */ var SHA512 = C_algo.SHA512 = Hasher.extend({
            _doReset: function() {
                this._hash = new X64WordArray.init([
                    new X64Word.init(0x6a09e667, 0xf3bcc908),
                    new X64Word.init(0xbb67ae85, 0x84caa73b),
                    new X64Word.init(0x3c6ef372, 0xfe94f82b),
                    new X64Word.init(0xa54ff53a, 0x5f1d36f1),
                    new X64Word.init(0x510e527f, 0xade682d1),
                    new X64Word.init(0x9b05688c, 0x2b3e6c1f),
                    new X64Word.init(0x1f83d9ab, 0xfb41bd6b),
                    new X64Word.init(0x5be0cd19, 0x137e2179)
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Shortcuts
                var H = this._hash.words;
                var H0 = H[0];
                var H1 = H[1];
                var H2 = H[2];
                var H3 = H[3];
                var H4 = H[4];
                var H5 = H[5];
                var H6 = H[6];
                var H7 = H[7];
                var H0h = H0.high;
                var H0l = H0.low;
                var H1h = H1.high;
                var H1l = H1.low;
                var H2h = H2.high;
                var H2l = H2.low;
                var H3h = H3.high;
                var H3l = H3.low;
                var H4h = H4.high;
                var H4l = H4.low;
                var H5h = H5.high;
                var H5l = H5.low;
                var H6h = H6.high;
                var H6l = H6.low;
                var H7h = H7.high;
                var H7l = H7.low;
                // Working variables
                var ah = H0h;
                var al = H0l;
                var bh = H1h;
                var bl = H1l;
                var ch = H2h;
                var cl = H2l;
                var dh = H3h;
                var dl = H3l;
                var eh = H4h;
                var el = H4l;
                var fh = H5h;
                var fl = H5l;
                var gh = H6h;
                var gl = H6l;
                var hh = H7h;
                var hl = H7l;
                // Rounds
                for(var i = 0; i < 80; i++){
                    var Wil;
                    var Wih;
                    // Shortcut
                    var Wi = W[i];
                    // Extend message
                    if (i < 16) {
                        Wih = Wi.high = M[offset + i * 2] | 0;
                        Wil = Wi.low = M[offset + i * 2 + 1] | 0;
                    } else {
                        // Gamma0
                        var gamma0x = W[i - 15];
                        var gamma0xh = gamma0x.high;
                        var gamma0xl = gamma0x.low;
                        var gamma0h = (gamma0xh >>> 1 | gamma0xl << 31) ^ (gamma0xh >>> 8 | gamma0xl << 24) ^ gamma0xh >>> 7;
                        var gamma0l = (gamma0xl >>> 1 | gamma0xh << 31) ^ (gamma0xl >>> 8 | gamma0xh << 24) ^ (gamma0xl >>> 7 | gamma0xh << 25);
                        // Gamma1
                        var gamma1x = W[i - 2];
                        var gamma1xh = gamma1x.high;
                        var gamma1xl = gamma1x.low;
                        var gamma1h = (gamma1xh >>> 19 | gamma1xl << 13) ^ (gamma1xh << 3 | gamma1xl >>> 29) ^ gamma1xh >>> 6;
                        var gamma1l = (gamma1xl >>> 19 | gamma1xh << 13) ^ (gamma1xl << 3 | gamma1xh >>> 29) ^ (gamma1xl >>> 6 | gamma1xh << 26);
                        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
                        var Wi7 = W[i - 7];
                        var Wi7h = Wi7.high;
                        var Wi7l = Wi7.low;
                        var Wi16 = W[i - 16];
                        var Wi16h = Wi16.high;
                        var Wi16l = Wi16.low;
                        Wil = gamma0l + Wi7l;
                        Wih = gamma0h + Wi7h + (Wil >>> 0 < gamma0l >>> 0 ? 1 : 0);
                        Wil = Wil + gamma1l;
                        Wih = Wih + gamma1h + (Wil >>> 0 < gamma1l >>> 0 ? 1 : 0);
                        Wil = Wil + Wi16l;
                        Wih = Wih + Wi16h + (Wil >>> 0 < Wi16l >>> 0 ? 1 : 0);
                        Wi.high = Wih;
                        Wi.low = Wil;
                    }
                    var chh = eh & fh ^ ~eh & gh;
                    var chl = el & fl ^ ~el & gl;
                    var majh = ah & bh ^ ah & ch ^ bh & ch;
                    var majl = al & bl ^ al & cl ^ bl & cl;
                    var sigma0h = (ah >>> 28 | al << 4) ^ (ah << 30 | al >>> 2) ^ (ah << 25 | al >>> 7);
                    var sigma0l = (al >>> 28 | ah << 4) ^ (al << 30 | ah >>> 2) ^ (al << 25 | ah >>> 7);
                    var sigma1h = (eh >>> 14 | el << 18) ^ (eh >>> 18 | el << 14) ^ (eh << 23 | el >>> 9);
                    var sigma1l = (el >>> 14 | eh << 18) ^ (el >>> 18 | eh << 14) ^ (el << 23 | eh >>> 9);
                    // t1 = h + sigma1 + ch + K[i] + W[i]
                    var Ki = K[i];
                    var Kih = Ki.high;
                    var Kil = Ki.low;
                    var t1l = hl + sigma1l;
                    var t1h = hh + sigma1h + (t1l >>> 0 < hl >>> 0 ? 1 : 0);
                    var t1l = t1l + chl;
                    var t1h = t1h + chh + (t1l >>> 0 < chl >>> 0 ? 1 : 0);
                    var t1l = t1l + Kil;
                    var t1h = t1h + Kih + (t1l >>> 0 < Kil >>> 0 ? 1 : 0);
                    var t1l = t1l + Wil;
                    var t1h = t1h + Wih + (t1l >>> 0 < Wil >>> 0 ? 1 : 0);
                    // t2 = sigma0 + maj
                    var t2l = sigma0l + majl;
                    var t2h = sigma0h + majh + (t2l >>> 0 < sigma0l >>> 0 ? 1 : 0);
                    // Update working variables
                    hh = gh;
                    hl = gl;
                    gh = fh;
                    gl = fl;
                    fh = eh;
                    fl = el;
                    el = dl + t1l | 0;
                    eh = dh + t1h + (el >>> 0 < dl >>> 0 ? 1 : 0) | 0;
                    dh = ch;
                    dl = cl;
                    ch = bh;
                    cl = bl;
                    bh = ah;
                    bl = al;
                    al = t1l + t2l | 0;
                    ah = t1h + t2h + (al >>> 0 < t1l >>> 0 ? 1 : 0) | 0;
                }
                // Intermediate hash value
                H0l = H0.low = H0l + al;
                H0.high = H0h + ah + (H0l >>> 0 < al >>> 0 ? 1 : 0);
                H1l = H1.low = H1l + bl;
                H1.high = H1h + bh + (H1l >>> 0 < bl >>> 0 ? 1 : 0);
                H2l = H2.low = H2l + cl;
                H2.high = H2h + ch + (H2l >>> 0 < cl >>> 0 ? 1 : 0);
                H3l = H3.low = H3l + dl;
                H3.high = H3h + dh + (H3l >>> 0 < dl >>> 0 ? 1 : 0);
                H4l = H4.low = H4l + el;
                H4.high = H4h + eh + (H4l >>> 0 < el >>> 0 ? 1 : 0);
                H5l = H5.low = H5l + fl;
                H5.high = H5h + fh + (H5l >>> 0 < fl >>> 0 ? 1 : 0);
                H6l = H6.low = H6l + gl;
                H6.high = H6h + gh + (H6l >>> 0 < gl >>> 0 ? 1 : 0);
                H7l = H7.low = H7l + hl;
                H7.high = H7h + hh + (H7l >>> 0 < hl >>> 0 ? 1 : 0);
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 128 >>> 10 << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 128 >>> 10 << 5) + 31] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Convert hash to 32-bit word array before returning
                var hash = this._hash.toX32();
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            },
            blockSize: 32
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA512('message');
	     *     var hash = CryptoJS.SHA512(wordArray);
	     */ C.SHA512 = Hasher._createHelper(SHA512);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA512(message, key);
	     */ C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
    })();
    return CryptoJS.SHA512;
});

});

parcelRegister("gHnaK", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("iCQTn")), (parcelRequire("kVcBU")), (parcelRequire("6DsZi")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var X64WordArray = C_x64.WordArray;
        var C_algo = C.algo;
        var SHA512 = C_algo.SHA512;
        /**
	     * SHA-384 hash algorithm.
	     */ var SHA384 = C_algo.SHA384 = SHA512.extend({
            _doReset: function() {
                this._hash = new X64WordArray.init([
                    new X64Word.init(0xcbbb9d5d, 0xc1059ed8),
                    new X64Word.init(0x629a292a, 0x367cd507),
                    new X64Word.init(0x9159015a, 0x3070dd17),
                    new X64Word.init(0x152fecd8, 0xf70e5939),
                    new X64Word.init(0x67332667, 0xffc00b31),
                    new X64Word.init(0x8eb44a87, 0x68581511),
                    new X64Word.init(0xdb0c2e0d, 0x64f98fa7),
                    new X64Word.init(0x47b5481d, 0xbefa4fa4)
                ]);
            },
            _doFinalize: function() {
                var hash = SHA512._doFinalize.call(this);
                hash.sigBytes -= 16;
                return hash;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA384('message');
	     *     var hash = CryptoJS.SHA384(wordArray);
	     */ C.SHA384 = SHA512._createHelper(SHA384);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA384(message, key);
	     */ C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
    })();
    return CryptoJS.SHA384;
});

});

parcelRegister("iKDGt", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("iCQTn")), (parcelRequire("kVcBU")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var C_algo = C.algo;
        // Constants tables
        var RHO_OFFSETS = [];
        var PI_INDEXES = [];
        var ROUND_CONSTANTS = [];
        // Compute Constants
        (function() {
            // Compute rho offset constants
            var x = 1, y = 0;
            for(var t = 0; t < 24; t++){
                RHO_OFFSETS[x + 5 * y] = (t + 1) * (t + 2) / 2 % 64;
                var newX = y % 5;
                var newY = (2 * x + 3 * y) % 5;
                x = newX;
                y = newY;
            }
            // Compute pi index constants
            for(var x = 0; x < 5; x++)for(var y = 0; y < 5; y++)PI_INDEXES[x + 5 * y] = y + (2 * x + 3 * y) % 5 * 5;
            // Compute round constants
            var LFSR = 0x01;
            for(var i = 0; i < 24; i++){
                var roundConstantMsw = 0;
                var roundConstantLsw = 0;
                for(var j = 0; j < 7; j++){
                    if (LFSR & 0x01) {
                        var bitPosition = (1 << j) - 1;
                        if (bitPosition < 32) roundConstantLsw ^= 1 << bitPosition;
                        else roundConstantMsw ^= 1 << bitPosition - 32;
                    }
                    // Compute next LFSR
                    if (LFSR & 0x80) // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
                    LFSR = LFSR << 1 ^ 0x71;
                    else LFSR <<= 1;
                }
                ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
            }
        })();
        // Reusable objects for temporary values
        var T = [];
        (function() {
            for(var i = 0; i < 25; i++)T[i] = X64Word.create();
        })();
        /**
	     * SHA-3 hash algorithm.
	     */ var SHA3 = C_algo.SHA3 = Hasher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} outputLength
	         *   The desired number of bits in the output hash.
	         *   Only values permitted are: 224, 256, 384, 512.
	         *   Default: 512
	         */ cfg: Hasher.cfg.extend({
                outputLength: 512
            }),
            _doReset: function() {
                var state = this._state = [];
                for(var i = 0; i < 25; i++)state[i] = new X64Word.init();
                this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
            },
            _doProcessBlock: function(M, offset) {
                // Shortcuts
                var state = this._state;
                var nBlockSizeLanes = this.blockSize / 2;
                // Absorb
                for(var i = 0; i < nBlockSizeLanes; i++){
                    // Shortcuts
                    var M2i = M[offset + 2 * i];
                    var M2i1 = M[offset + 2 * i + 1];
                    // Swap endian
                    M2i = (M2i << 8 | M2i >>> 24) & 0x00ff00ff | (M2i << 24 | M2i >>> 8) & 0xff00ff00;
                    M2i1 = (M2i1 << 8 | M2i1 >>> 24) & 0x00ff00ff | (M2i1 << 24 | M2i1 >>> 8) & 0xff00ff00;
                    // Absorb message into state
                    var lane = state[i];
                    lane.high ^= M2i1;
                    lane.low ^= M2i;
                }
                // Rounds
                for(var round = 0; round < 24; round++){
                    // Theta
                    for(var x = 0; x < 5; x++){
                        // Mix column lanes
                        var tMsw = 0, tLsw = 0;
                        for(var y = 0; y < 5; y++){
                            var lane = state[x + 5 * y];
                            tMsw ^= lane.high;
                            tLsw ^= lane.low;
                        }
                        // Temporary values
                        var Tx = T[x];
                        Tx.high = tMsw;
                        Tx.low = tLsw;
                    }
                    for(var x = 0; x < 5; x++){
                        // Shortcuts
                        var Tx4 = T[(x + 4) % 5];
                        var Tx1 = T[(x + 1) % 5];
                        var Tx1Msw = Tx1.high;
                        var Tx1Lsw = Tx1.low;
                        // Mix surrounding columns
                        var tMsw = Tx4.high ^ (Tx1Msw << 1 | Tx1Lsw >>> 31);
                        var tLsw = Tx4.low ^ (Tx1Lsw << 1 | Tx1Msw >>> 31);
                        for(var y = 0; y < 5; y++){
                            var lane = state[x + 5 * y];
                            lane.high ^= tMsw;
                            lane.low ^= tLsw;
                        }
                    }
                    // Rho Pi
                    for(var laneIndex = 1; laneIndex < 25; laneIndex++){
                        var tMsw;
                        var tLsw;
                        // Shortcuts
                        var lane = state[laneIndex];
                        var laneMsw = lane.high;
                        var laneLsw = lane.low;
                        var rhoOffset = RHO_OFFSETS[laneIndex];
                        // Rotate lanes
                        if (rhoOffset < 32) {
                            tMsw = laneMsw << rhoOffset | laneLsw >>> 32 - rhoOffset;
                            tLsw = laneLsw << rhoOffset | laneMsw >>> 32 - rhoOffset;
                        } else /* if (rhoOffset >= 32) */ {
                            tMsw = laneLsw << rhoOffset - 32 | laneMsw >>> 64 - rhoOffset;
                            tLsw = laneMsw << rhoOffset - 32 | laneLsw >>> 64 - rhoOffset;
                        }
                        // Transpose lanes
                        var TPiLane = T[PI_INDEXES[laneIndex]];
                        TPiLane.high = tMsw;
                        TPiLane.low = tLsw;
                    }
                    // Rho pi at x = y = 0
                    var T0 = T[0];
                    var state0 = state[0];
                    T0.high = state0.high;
                    T0.low = state0.low;
                    // Chi
                    for(var x = 0; x < 5; x++)for(var y = 0; y < 5; y++){
                        // Shortcuts
                        var laneIndex = x + 5 * y;
                        var lane = state[laneIndex];
                        var TLane = T[laneIndex];
                        var Tx1Lane = T[(x + 1) % 5 + 5 * y];
                        var Tx2Lane = T[(x + 2) % 5 + 5 * y];
                        // Mix rows
                        lane.high = TLane.high ^ ~Tx1Lane.high & Tx2Lane.high;
                        lane.low = TLane.low ^ ~Tx1Lane.low & Tx2Lane.low;
                    }
                    // Iota
                    var lane = state[0];
                    var roundConstant = ROUND_CONSTANTS[round];
                    lane.high ^= roundConstant.high;
                    lane.low ^= roundConstant.low;
                }
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                var blockSizeBits = this.blockSize * 32;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x1 << 24 - nBitsLeft % 32;
                dataWords[(Math1.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits >>> 5) - 1] |= 0x80;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var state = this._state;
                var outputLengthBytes = this.cfg.outputLength / 8;
                var outputLengthLanes = outputLengthBytes / 8;
                // Squeeze
                var hashWords = [];
                for(var i = 0; i < outputLengthLanes; i++){
                    // Shortcuts
                    var lane = state[i];
                    var laneMsw = lane.high;
                    var laneLsw = lane.low;
                    // Swap endian
                    laneMsw = (laneMsw << 8 | laneMsw >>> 24) & 0x00ff00ff | (laneMsw << 24 | laneMsw >>> 8) & 0xff00ff00;
                    laneLsw = (laneLsw << 8 | laneLsw >>> 24) & 0x00ff00ff | (laneLsw << 24 | laneLsw >>> 8) & 0xff00ff00;
                    // Squeeze state to retrieve hash
                    hashWords.push(laneLsw);
                    hashWords.push(laneMsw);
                }
                // Return final computed hash
                return new WordArray.init(hashWords, outputLengthBytes);
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                var state = clone._state = this._state.slice(0);
                for(var i = 0; i < 25; i++)state[i] = state[i].clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA3('message');
	     *     var hash = CryptoJS.SHA3(wordArray);
	     */ C.SHA3 = Hasher._createHelper(SHA3);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA3(message, key);
	     */ C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
    })(Math);
    return CryptoJS.SHA3;
});

});

parcelRegister("gEJHB", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("iCQTn")));
})(this, function(CryptoJS) {
    /** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.

	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/ (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Constants table
        var _zl = WordArray.create([
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            7,
            4,
            13,
            1,
            10,
            6,
            15,
            3,
            12,
            0,
            9,
            5,
            2,
            14,
            11,
            8,
            3,
            10,
            14,
            4,
            9,
            15,
            8,
            1,
            2,
            7,
            0,
            6,
            13,
            11,
            5,
            12,
            1,
            9,
            11,
            10,
            0,
            8,
            12,
            4,
            13,
            3,
            7,
            15,
            14,
            5,
            6,
            2,
            4,
            0,
            5,
            9,
            7,
            12,
            2,
            10,
            14,
            1,
            3,
            8,
            11,
            6,
            15,
            13
        ]);
        var _zr = WordArray.create([
            5,
            14,
            7,
            0,
            9,
            2,
            11,
            4,
            13,
            6,
            15,
            8,
            1,
            10,
            3,
            12,
            6,
            11,
            3,
            7,
            0,
            13,
            5,
            10,
            14,
            15,
            8,
            12,
            4,
            9,
            1,
            2,
            15,
            5,
            1,
            3,
            7,
            14,
            6,
            9,
            11,
            8,
            12,
            2,
            10,
            0,
            4,
            13,
            8,
            6,
            4,
            1,
            3,
            11,
            15,
            0,
            5,
            12,
            2,
            13,
            9,
            7,
            10,
            14,
            12,
            15,
            10,
            4,
            1,
            5,
            8,
            7,
            6,
            2,
            13,
            14,
            0,
            3,
            9,
            11
        ]);
        var _sl = WordArray.create([
            11,
            14,
            15,
            12,
            5,
            8,
            7,
            9,
            11,
            13,
            14,
            15,
            6,
            7,
            9,
            8,
            7,
            6,
            8,
            13,
            11,
            9,
            7,
            15,
            7,
            12,
            15,
            9,
            11,
            7,
            13,
            12,
            11,
            13,
            6,
            7,
            14,
            9,
            13,
            15,
            14,
            8,
            13,
            6,
            5,
            12,
            7,
            5,
            11,
            12,
            14,
            15,
            14,
            15,
            9,
            8,
            9,
            14,
            5,
            6,
            8,
            6,
            5,
            12,
            9,
            15,
            5,
            11,
            6,
            8,
            13,
            12,
            5,
            12,
            13,
            14,
            11,
            8,
            5,
            6
        ]);
        var _sr = WordArray.create([
            8,
            9,
            9,
            11,
            13,
            15,
            15,
            5,
            7,
            7,
            8,
            11,
            14,
            14,
            12,
            6,
            9,
            13,
            15,
            7,
            12,
            8,
            9,
            11,
            7,
            7,
            12,
            7,
            6,
            15,
            13,
            11,
            9,
            7,
            15,
            11,
            8,
            6,
            6,
            14,
            12,
            13,
            5,
            14,
            13,
            13,
            7,
            5,
            15,
            5,
            8,
            11,
            14,
            14,
            6,
            14,
            6,
            9,
            12,
            9,
            12,
            5,
            15,
            8,
            8,
            5,
            12,
            9,
            12,
            5,
            14,
            6,
            8,
            13,
            6,
            5,
            15,
            13,
            11,
            11
        ]);
        var _hl = WordArray.create([
            0x00000000,
            0x5A827999,
            0x6ED9EBA1,
            0x8F1BBCDC,
            0xA953FD4E
        ]);
        var _hr = WordArray.create([
            0x50A28BE6,
            0x5C4DD124,
            0x6D703EF3,
            0x7A6D76E9,
            0x00000000
        ]);
        /**
	     * RIPEMD160 hash algorithm.
	     */ var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
            _doReset: function() {
                this._hash = WordArray.create([
                    0x67452301,
                    0xEFCDAB89,
                    0x98BADCFE,
                    0x10325476,
                    0xC3D2E1F0
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Swap endian
                for(var i = 0; i < 16; i++){
                    // Shortcuts
                    var offset_i = offset + i;
                    var M_offset_i = M[offset_i];
                    // Swap
                    M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                }
                // Shortcut
                var H = this._hash.words;
                var hl = _hl.words;
                var hr = _hr.words;
                var zl = _zl.words;
                var zr = _zr.words;
                var sl = _sl.words;
                var sr = _sr.words;
                // Working variables
                var al, bl, cl, dl, el;
                var ar, br, cr, dr, er;
                ar = al = H[0];
                br = bl = H[1];
                cr = cl = H[2];
                dr = dl = H[3];
                er = el = H[4];
                // Computation
                var t;
                for(var i = 0; i < 80; i += 1){
                    t = al + M[offset + zl[i]] | 0;
                    if (i < 16) t += f1(bl, cl, dl) + hl[0];
                    else if (i < 32) t += f2(bl, cl, dl) + hl[1];
                    else if (i < 48) t += f3(bl, cl, dl) + hl[2];
                    else if (i < 64) t += f4(bl, cl, dl) + hl[3];
                    else t += f5(bl, cl, dl) + hl[4];
                    t = t | 0;
                    t = rotl(t, sl[i]);
                    t = t + el | 0;
                    al = el;
                    el = dl;
                    dl = rotl(cl, 10);
                    cl = bl;
                    bl = t;
                    t = ar + M[offset + zr[i]] | 0;
                    if (i < 16) t += f5(br, cr, dr) + hr[0];
                    else if (i < 32) t += f4(br, cr, dr) + hr[1];
                    else if (i < 48) t += f3(br, cr, dr) + hr[2];
                    else if (i < 64) t += f2(br, cr, dr) + hr[3];
                    else t += f1(br, cr, dr) + hr[4];
                    t = t | 0;
                    t = rotl(t, sr[i]);
                    t = t + er | 0;
                    ar = er;
                    er = dr;
                    dr = rotl(cr, 10);
                    cr = br;
                    br = t;
                }
                // Intermediate hash value
                t = H[1] + cl + dr | 0;
                H[1] = H[2] + dl + er | 0;
                H[2] = H[3] + el + ar | 0;
                H[3] = H[4] + al + br | 0;
                H[4] = H[0] + bl + cr | 0;
                H[0] = t;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotal << 8 | nBitsTotal >>> 24) & 0x00ff00ff | (nBitsTotal << 24 | nBitsTotal >>> 8) & 0xff00ff00;
                data.sigBytes = (dataWords.length + 1) * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var hash = this._hash;
                var H = hash.words;
                // Swap endian
                for(var i = 0; i < 5; i++){
                    // Shortcut
                    var H_i = H[i];
                    // Swap
                    H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                }
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        function f1(x, y, z) {
            return x ^ y ^ z;
        }
        function f2(x, y, z) {
            return x & y | ~x & z;
        }
        function f3(x, y, z) {
            return (x | ~y) ^ z;
        }
        function f4(x, y, z) {
            return x & z | y & ~z;
        }
        function f5(x, y, z) {
            return x ^ (y | ~z);
        }
        function rotl(x, n) {
            return x << n | x >>> 32 - n;
        }
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.RIPEMD160('message');
	     *     var hash = CryptoJS.RIPEMD160(wordArray);
	     */ C.RIPEMD160 = Hasher._createHelper(RIPEMD160);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
	     */ C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
    })(Math);
    return CryptoJS.RIPEMD160;
});

});

parcelRegister("gNPXo", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("iCQTn")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var C_algo = C.algo;
        /**
	     * HMAC algorithm.
	     */ var HMAC = C_algo.HMAC = Base.extend({
            /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */ init: function(hasher, key) {
                // Init hasher
                hasher = this._hasher = new hasher.init();
                // Convert string to WordArray, else assume WordArray already
                if (typeof key == "string") key = Utf8.parse(key);
                // Shortcuts
                var hasherBlockSize = hasher.blockSize;
                var hasherBlockSizeBytes = hasherBlockSize * 4;
                // Allow arbitrary length keys
                if (key.sigBytes > hasherBlockSizeBytes) key = hasher.finalize(key);
                // Clamp excess bits
                key.clamp();
                // Clone key for inner and outer pads
                var oKey = this._oKey = key.clone();
                var iKey = this._iKey = key.clone();
                // Shortcuts
                var oKeyWords = oKey.words;
                var iKeyWords = iKey.words;
                // XOR keys with pad constants
                for(var i = 0; i < hasherBlockSize; i++){
                    oKeyWords[i] ^= 0x5c5c5c5c;
                    iKeyWords[i] ^= 0x36363636;
                }
                oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */ reset: function() {
                // Shortcut
                var hasher = this._hasher;
                // Reset
                hasher.reset();
                hasher.update(this._iKey);
            },
            /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */ update: function(messageUpdate) {
                this._hasher.update(messageUpdate);
                // Chainable
                return this;
            },
            /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Shortcut
                var hasher = this._hasher;
                // Compute HMAC
                var innerHash = hasher.finalize(messageUpdate);
                hasher.reset();
                var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
                return hmac;
            }
        });
    })();
});

});

parcelRegister("gIUnh", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("iCQTn")), (parcelRequire("b4zd4")), (parcelRequire("gNPXo")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var SHA256 = C_algo.SHA256;
        var HMAC = C_algo.HMAC;
        /**
	     * Password-Based Key Derivation Function 2 algorithm.
	     */ var PBKDF2 = C_algo.PBKDF2 = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hasher to use. Default: SHA256
	         * @property {number} iterations The number of iterations to perform. Default: 250000
	         */ cfg: Base.extend({
                keySize: 4,
                hasher: SHA256,
                iterations: 250000
            }),
            /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.PBKDF2.create();
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
	         */ init: function(cfg) {
                this.cfg = this.cfg.extend(cfg);
            },
            /**
	         * Computes the Password-Based Key Derivation Function 2.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */ compute: function(password, salt) {
                // Shortcut
                var cfg = this.cfg;
                // Init HMAC
                var hmac = HMAC.create(cfg.hasher, password);
                // Initial values
                var derivedKey = WordArray.create();
                var blockIndex = WordArray.create([
                    0x00000001
                ]);
                // Shortcuts
                var derivedKeyWords = derivedKey.words;
                var blockIndexWords = blockIndex.words;
                var keySize = cfg.keySize;
                var iterations = cfg.iterations;
                // Generate key
                while(derivedKeyWords.length < keySize){
                    var block = hmac.update(salt).finalize(blockIndex);
                    hmac.reset();
                    // Shortcuts
                    var blockWords = block.words;
                    var blockWordsLength = blockWords.length;
                    // Iterations
                    var intermediate = block;
                    for(var i = 1; i < iterations; i++){
                        intermediate = hmac.finalize(intermediate);
                        hmac.reset();
                        // Shortcut
                        var intermediateWords = intermediate.words;
                        // XOR intermediate with block
                        for(var j = 0; j < blockWordsLength; j++)blockWords[j] ^= intermediateWords[j];
                    }
                    derivedKey.concat(block);
                    blockIndexWords[0]++;
                }
                derivedKey.sigBytes = keySize * 4;
                return derivedKey;
            }
        });
        /**
	     * Computes the Password-Based Key Derivation Function 2.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.PBKDF2(password, salt);
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
	     */ C.PBKDF2 = function(password, salt, cfg) {
            return PBKDF2.create(cfg).compute(password, salt);
        };
    })();
    return CryptoJS.PBKDF2;
});

});

parcelRegister("cL93H", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("iCQTn")), (parcelRequire("7pYDf")), (parcelRequire("gNPXo")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var MD5 = C_algo.MD5;
        /**
	     * This key derivation function is meant to conform with EVP_BytesToKey.
	     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
	     */ var EvpKDF = C_algo.EvpKDF = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */ cfg: Base.extend({
                keySize: 4,
                hasher: MD5,
                iterations: 1
            }),
            /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.EvpKDF.create();
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
	         */ init: function(cfg) {
                this.cfg = this.cfg.extend(cfg);
            },
            /**
	         * Derives a key from a password.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */ compute: function(password, salt) {
                var block;
                // Shortcut
                var cfg = this.cfg;
                // Init hasher
                var hasher = cfg.hasher.create();
                // Initial values
                var derivedKey = WordArray.create();
                // Shortcuts
                var derivedKeyWords = derivedKey.words;
                var keySize = cfg.keySize;
                var iterations = cfg.iterations;
                // Generate key
                while(derivedKeyWords.length < keySize){
                    if (block) hasher.update(block);
                    block = hasher.update(password).finalize(salt);
                    hasher.reset();
                    // Iterations
                    for(var i = 1; i < iterations; i++){
                        block = hasher.finalize(block);
                        hasher.reset();
                    }
                    derivedKey.concat(block);
                }
                derivedKey.sigBytes = keySize * 4;
                return derivedKey;
            }
        });
        /**
	     * Derives a key from a password.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.EvpKDF(password, salt);
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
	     */ C.EvpKDF = function(password, salt, cfg) {
            return EvpKDF.create(cfg).compute(password, salt);
        };
    })();
    return CryptoJS.EvpKDF;
});

});

parcelRegister("lLOi4", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("iCQTn")), (parcelRequire("cL93H")));
})(this, function(CryptoJS) {
    /**
	 * Cipher core components.
	 */ CryptoJS.lib.Cipher || function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var Base64 = C_enc.Base64;
        var C_algo = C.algo;
        var EvpKDF = C_algo.EvpKDF;
        /**
	     * Abstract base cipher template.
	     *
	     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
	     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
	     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
	     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
	     */ var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         *
	         * @property {WordArray} iv The IV to use for this operation.
	         */ cfg: Base.extend(),
            /**
	         * Creates this cipher in encryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
	         */ createEncryptor: function(key, cfg) {
                return this.create(this._ENC_XFORM_MODE, key, cfg);
            },
            /**
	         * Creates this cipher in decryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
	         */ createDecryptor: function(key, cfg) {
                return this.create(this._DEC_XFORM_MODE, key, cfg);
            },
            /**
	         * Initializes a newly created cipher.
	         *
	         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
	         */ init: function(xformMode, key, cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Store transform mode and key
                this._xformMode = xformMode;
                this._key = key;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this cipher to its initial state.
	         *
	         * @example
	         *
	         *     cipher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-cipher logic
                this._doReset();
            },
            /**
	         * Adds data to be encrypted or decrypted.
	         *
	         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.process('data');
	         *     var encrypted = cipher.process(wordArray);
	         */ process: function(dataUpdate) {
                // Append
                this._append(dataUpdate);
                // Process available blocks
                return this._process();
            },
            /**
	         * Finalizes the encryption or decryption process.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after final processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.finalize();
	         *     var encrypted = cipher.finalize('data');
	         *     var encrypted = cipher.finalize(wordArray);
	         */ finalize: function(dataUpdate) {
                // Final data update
                if (dataUpdate) this._append(dataUpdate);
                // Perform concrete-cipher logic
                var finalProcessedData = this._doFinalize();
                return finalProcessedData;
            },
            keySize: 4,
            ivSize: 4,
            _ENC_XFORM_MODE: 1,
            _DEC_XFORM_MODE: 2,
            /**
	         * Creates shortcut functions to a cipher's object interface.
	         *
	         * @param {Cipher} cipher The cipher to create a helper for.
	         *
	         * @return {Object} An object with encrypt and decrypt shortcut functions.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
	         */ _createHelper: function() {
                function selectCipherStrategy(key) {
                    if (typeof key == "string") return PasswordBasedCipher;
                    else return SerializableCipher;
                }
                return function(cipher) {
                    return {
                        encrypt: function(message, key, cfg) {
                            return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
                        },
                        decrypt: function(ciphertext, key, cfg) {
                            return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
                        }
                    };
                };
            }()
        });
        /**
	     * Abstract base stream cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
	     */ var StreamCipher = C_lib.StreamCipher = Cipher.extend({
            _doFinalize: function() {
                // Process partial blocks
                var finalProcessedBlocks = this._process(true);
                return finalProcessedBlocks;
            },
            blockSize: 1
        });
        /**
	     * Mode namespace.
	     */ var C_mode = C.mode = {};
        /**
	     * Abstract base block cipher mode template.
	     */ var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
            /**
	         * Creates this mode for encryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
	         */ createEncryptor: function(cipher, iv) {
                return this.Encryptor.create(cipher, iv);
            },
            /**
	         * Creates this mode for decryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
	         */ createDecryptor: function(cipher, iv) {
                return this.Decryptor.create(cipher, iv);
            },
            /**
	         * Initializes a newly created mode.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
	         */ init: function(cipher, iv) {
                this._cipher = cipher;
                this._iv = iv;
            }
        });
        /**
	     * Cipher Block Chaining mode.
	     */ var CBC = C_mode.CBC = function() {
            /**
	         * Abstract base CBC mode.
	         */ var CBC = BlockCipherMode.extend();
            /**
	         * CBC encryptor.
	         */ CBC.Encryptor = CBC.extend({
                /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */ processBlock: function(words, offset) {
                    // Shortcuts
                    var cipher = this._cipher;
                    var blockSize = cipher.blockSize;
                    // XOR and encrypt
                    xorBlock.call(this, words, offset, blockSize);
                    cipher.encryptBlock(words, offset);
                    // Remember this block to use with next block
                    this._prevBlock = words.slice(offset, offset + blockSize);
                }
            });
            /**
	         * CBC decryptor.
	         */ CBC.Decryptor = CBC.extend({
                /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */ processBlock: function(words, offset) {
                    // Shortcuts
                    var cipher = this._cipher;
                    var blockSize = cipher.blockSize;
                    // Remember this block to use with next block
                    var thisBlock = words.slice(offset, offset + blockSize);
                    // Decrypt and XOR
                    cipher.decryptBlock(words, offset);
                    xorBlock.call(this, words, offset, blockSize);
                    // This block becomes the previous block
                    this._prevBlock = thisBlock;
                }
            });
            function xorBlock(words, offset, blockSize) {
                var block;
                // Shortcut
                var iv = this._iv;
                // Choose mixing block
                if (iv) {
                    block = iv;
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                } else block = this._prevBlock;
                // XOR blocks
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= block[i];
            }
            return CBC;
        }();
        /**
	     * Padding namespace.
	     */ var C_pad = C.pad = {};
        /**
	     * PKCS #5/7 padding strategy.
	     */ var Pkcs7 = C_pad.Pkcs7 = {
            /**
	         * Pads data using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to pad.
	         * @param {number} blockSize The multiple that the data should be padded to.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
	         */ pad: function(data, blockSize) {
                // Shortcut
                var blockSizeBytes = blockSize * 4;
                // Count padding bytes
                var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
                // Create padding word
                var paddingWord = nPaddingBytes << 24 | nPaddingBytes << 16 | nPaddingBytes << 8 | nPaddingBytes;
                // Create padding
                var paddingWords = [];
                for(var i = 0; i < nPaddingBytes; i += 4)paddingWords.push(paddingWord);
                var padding = WordArray.create(paddingWords, nPaddingBytes);
                // Add padding
                data.concat(padding);
            },
            /**
	         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to unpad.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
	         */ unpad: function(data) {
                // Get number of padding bytes from last byte
                var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
                // Remove padding
                data.sigBytes -= nPaddingBytes;
            }
        };
        /**
	     * Abstract base block cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
	     */ var BlockCipher = C_lib.BlockCipher = Cipher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {Mode} mode The block mode to use. Default: CBC
	         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
	         */ cfg: Cipher.cfg.extend({
                mode: CBC,
                padding: Pkcs7
            }),
            reset: function() {
                var modeCreator;
                // Reset cipher
                Cipher.reset.call(this);
                // Shortcuts
                var cfg = this.cfg;
                var iv = cfg.iv;
                var mode = cfg.mode;
                // Reset block mode
                if (this._xformMode == this._ENC_XFORM_MODE) modeCreator = mode.createEncryptor;
                else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                    modeCreator = mode.createDecryptor;
                    // Keep at least one block in the buffer for unpadding
                    this._minBufferSize = 1;
                }
                if (this._mode && this._mode.__creator == modeCreator) this._mode.init(this, iv && iv.words);
                else {
                    this._mode = modeCreator.call(mode, this, iv && iv.words);
                    this._mode.__creator = modeCreator;
                }
            },
            _doProcessBlock: function(words, offset) {
                this._mode.processBlock(words, offset);
            },
            _doFinalize: function() {
                var finalProcessedBlocks;
                // Shortcut
                var padding = this.cfg.padding;
                // Finalize
                if (this._xformMode == this._ENC_XFORM_MODE) {
                    // Pad data
                    padding.pad(this._data, this.blockSize);
                    // Process final blocks
                    finalProcessedBlocks = this._process(true);
                } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                    // Process final blocks
                    finalProcessedBlocks = this._process(true);
                    // Unpad data
                    padding.unpad(finalProcessedBlocks);
                }
                return finalProcessedBlocks;
            },
            blockSize: 4
        });
        /**
	     * A collection of cipher parameters.
	     *
	     * @property {WordArray} ciphertext The raw ciphertext.
	     * @property {WordArray} key The key to this ciphertext.
	     * @property {WordArray} iv The IV used in the ciphering operation.
	     * @property {WordArray} salt The salt used with a key derivation function.
	     * @property {Cipher} algorithm The cipher algorithm.
	     * @property {Mode} mode The block mode used in the ciphering operation.
	     * @property {Padding} padding The padding scheme used in the ciphering operation.
	     * @property {number} blockSize The block size of the cipher.
	     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
	     */ var CipherParams = C_lib.CipherParams = Base.extend({
            /**
	         * Initializes a newly created cipher params object.
	         *
	         * @param {Object} cipherParams An object with any of the possible cipher parameters.
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.lib.CipherParams.create({
	         *         ciphertext: ciphertextWordArray,
	         *         key: keyWordArray,
	         *         iv: ivWordArray,
	         *         salt: saltWordArray,
	         *         algorithm: CryptoJS.algo.AES,
	         *         mode: CryptoJS.mode.CBC,
	         *         padding: CryptoJS.pad.PKCS7,
	         *         blockSize: 4,
	         *         formatter: CryptoJS.format.OpenSSL
	         *     });
	         */ init: function(cipherParams) {
                this.mixIn(cipherParams);
            },
            /**
	         * Converts this cipher params object to a string.
	         *
	         * @param {Format} formatter (Optional) The formatting strategy to use.
	         *
	         * @return {string} The stringified cipher params.
	         *
	         * @throws Error If neither the formatter nor the default formatter is set.
	         *
	         * @example
	         *
	         *     var string = cipherParams + '';
	         *     var string = cipherParams.toString();
	         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
	         */ toString: function(formatter) {
                return (formatter || this.formatter).stringify(this);
            }
        });
        /**
	     * Format namespace.
	     */ var C_format = C.format = {};
        /**
	     * OpenSSL formatting strategy.
	     */ var OpenSSLFormatter = C_format.OpenSSL = {
            /**
	         * Converts a cipher params object to an OpenSSL-compatible string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The OpenSSL-compatible string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
	         */ stringify: function(cipherParams) {
                var wordArray;
                // Shortcuts
                var ciphertext = cipherParams.ciphertext;
                var salt = cipherParams.salt;
                // Format
                if (salt) wordArray = WordArray.create([
                    0x53616c74,
                    0x65645f5f
                ]).concat(salt).concat(ciphertext);
                else wordArray = ciphertext;
                return wordArray.toString(Base64);
            },
            /**
	         * Converts an OpenSSL-compatible string to a cipher params object.
	         *
	         * @param {string} openSSLStr The OpenSSL-compatible string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
	         */ parse: function(openSSLStr) {
                var salt;
                // Parse base64
                var ciphertext = Base64.parse(openSSLStr);
                // Shortcut
                var ciphertextWords = ciphertext.words;
                // Test for salt
                if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
                    // Extract salt
                    salt = WordArray.create(ciphertextWords.slice(2, 4));
                    // Remove salt from ciphertext
                    ciphertextWords.splice(0, 4);
                    ciphertext.sigBytes -= 16;
                }
                return CipherParams.create({
                    ciphertext: ciphertext,
                    salt: salt
                });
            }
        };
        /**
	     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
	     */ var SerializableCipher = C_lib.SerializableCipher = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
	         */ cfg: Base.extend({
                format: OpenSSLFormatter
            }),
            /**
	         * Encrypts a message.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */ encrypt: function(cipher, message, key, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Encrypt
                var encryptor = cipher.createEncryptor(key, cfg);
                var ciphertext = encryptor.finalize(message);
                // Shortcut
                var cipherCfg = encryptor.cfg;
                // Create and return serializable cipher params
                return CipherParams.create({
                    ciphertext: ciphertext,
                    key: key,
                    iv: cipherCfg.iv,
                    algorithm: cipher,
                    mode: cipherCfg.mode,
                    padding: cipherCfg.padding,
                    blockSize: cipher.blockSize,
                    formatter: cfg.format
                });
            },
            /**
	         * Decrypts serialized ciphertext.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */ decrypt: function(cipher, ciphertext, key, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Convert string to CipherParams
                ciphertext = this._parse(ciphertext, cfg.format);
                // Decrypt
                var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);
                return plaintext;
            },
            /**
	         * Converts serialized ciphertext to CipherParams,
	         * else assumed CipherParams already and returns ciphertext unchanged.
	         *
	         * @param {CipherParams|string} ciphertext The ciphertext.
	         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
	         *
	         * @return {CipherParams} The unserialized ciphertext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
	         */ _parse: function(ciphertext, format) {
                if (typeof ciphertext == "string") return format.parse(ciphertext, this);
                else return ciphertext;
            }
        });
        /**
	     * Key derivation function namespace.
	     */ var C_kdf = C.kdf = {};
        /**
	     * OpenSSL key derivation function.
	     */ var OpenSSLKdf = C_kdf.OpenSSL = {
            /**
	         * Derives a key and IV from a password.
	         *
	         * @param {string} password The password to derive from.
	         * @param {number} keySize The size in words of the key to generate.
	         * @param {number} ivSize The size in words of the IV to generate.
	         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
	         *
	         * @return {CipherParams} A cipher params object with the key, IV, and salt.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
	         */ execute: function(password, keySize, ivSize, salt, hasher) {
                // Generate random salt
                if (!salt) salt = WordArray.random(8);
                // Derive key and IV
                if (!hasher) var key = EvpKDF.create({
                    keySize: keySize + ivSize
                }).compute(password, salt);
                else var key = EvpKDF.create({
                    keySize: keySize + ivSize,
                    hasher: hasher
                }).compute(password, salt);
                // Separate key and IV
                var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
                key.sigBytes = keySize * 4;
                // Return params
                return CipherParams.create({
                    key: key,
                    iv: iv,
                    salt: salt
                });
            }
        };
        /**
	     * A serializable cipher wrapper that derives the key from a password,
	     * and returns ciphertext as a serializable cipher params object.
	     */ var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
	         */ cfg: SerializableCipher.cfg.extend({
                kdf: OpenSSLKdf
            }),
            /**
	         * Encrypts a message using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
	         */ encrypt: function(cipher, message, password, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Derive key and other params
                var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, cfg.salt, cfg.hasher);
                // Add IV to config
                cfg.iv = derivedParams.iv;
                // Encrypt
                var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);
                // Mix in derived params
                ciphertext.mixIn(derivedParams);
                return ciphertext;
            },
            /**
	         * Decrypts serialized ciphertext using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
	         */ decrypt: function(cipher, ciphertext, password, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Convert string to CipherParams
                ciphertext = this._parse(ciphertext, cfg.format);
                // Derive key and other params
                var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt, cfg.hasher);
                // Add IV to config
                cfg.iv = derivedParams.iv;
                // Decrypt
                var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);
                return plaintext;
            }
        });
    }();
});

});

parcelRegister("6JXUS", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("iCQTn")), (parcelRequire("lLOi4")));
})(this, function(CryptoJS) {
    /**
	 * Cipher Feedback block mode.
	 */ CryptoJS.mode.CFB = function() {
        var CFB = CryptoJS.lib.BlockCipherMode.extend();
        CFB.Encryptor = CFB.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
                // Remember this block to use with next block
                this._prevBlock = words.slice(offset, offset + blockSize);
            }
        });
        CFB.Decryptor = CFB.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                // Remember this block to use with next block
                var thisBlock = words.slice(offset, offset + blockSize);
                generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
                // This block becomes the previous block
                this._prevBlock = thisBlock;
            }
        });
        function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
            var keystream;
            // Shortcut
            var iv = this._iv;
            // Generate keystream
            if (iv) {
                keystream = iv.slice(0);
                // Remove IV for subsequent blocks
                this._iv = undefined;
            } else keystream = this._prevBlock;
            cipher.encryptBlock(keystream, 0);
            // Encrypt
            for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
        }
        return CFB;
    }();
    return CryptoJS.mode.CFB;
});

});

parcelRegister("7cvkA", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("iCQTn")), (parcelRequire("lLOi4")));
})(this, function(CryptoJS) {
    /**
	 * Counter block mode.
	 */ CryptoJS.mode.CTR = function() {
        var CTR = CryptoJS.lib.BlockCipherMode.extend();
        var Encryptor = CTR.Encryptor = CTR.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var counter = this._counter;
                // Generate keystream
                if (iv) {
                    counter = this._counter = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                var keystream = counter.slice(0);
                cipher.encryptBlock(keystream, 0);
                // Increment counter
                counter[blockSize - 1] = counter[blockSize - 1] + 1 | 0;
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        CTR.Decryptor = Encryptor;
        return CTR;
    }();
    return CryptoJS.mode.CTR;
});

});

parcelRegister("fp0ZR", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("iCQTn")), (parcelRequire("lLOi4")));
})(this, function(CryptoJS) {
    /** @preserve
	 * Counter block mode compatible with  Dr Brian Gladman fileenc.c
	 * derived from CryptoJS.mode.CTR
	 * Jan Hruby jhruby.web@gmail.com
	 */ CryptoJS.mode.CTRGladman = function() {
        var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();
        function incWord(word) {
            if ((word >> 24 & 0xff) === 0xff) {
                var b1 = word >> 16 & 0xff;
                var b2 = word >> 8 & 0xff;
                var b3 = word & 0xff;
                if (b1 === 0xff) {
                    b1 = 0;
                    if (b2 === 0xff) {
                        b2 = 0;
                        if (b3 === 0xff) b3 = 0;
                        else ++b3;
                    } else ++b2;
                } else ++b1;
                word = 0;
                word += b1 << 16;
                word += b2 << 8;
                word += b3;
            } else word += 16777216;
            return word;
        }
        function incCounter(counter) {
            if ((counter[0] = incWord(counter[0])) === 0) // encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
            counter[1] = incWord(counter[1]);
            return counter;
        }
        var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var counter = this._counter;
                // Generate keystream
                if (iv) {
                    counter = this._counter = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                incCounter(counter);
                var keystream = counter.slice(0);
                cipher.encryptBlock(keystream, 0);
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        CTRGladman.Decryptor = Encryptor;
        return CTRGladman;
    }();
    return CryptoJS.mode.CTRGladman;
});

});

parcelRegister("7vorb", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("iCQTn")), (parcelRequire("lLOi4")));
})(this, function(CryptoJS) {
    /**
	 * Output Feedback block mode.
	 */ CryptoJS.mode.OFB = function() {
        var OFB = CryptoJS.lib.BlockCipherMode.extend();
        var Encryptor = OFB.Encryptor = OFB.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var keystream = this._keystream;
                // Generate keystream
                if (iv) {
                    keystream = this._keystream = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                cipher.encryptBlock(keystream, 0);
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        OFB.Decryptor = Encryptor;
        return OFB;
    }();
    return CryptoJS.mode.OFB;
});

});

parcelRegister("l4l1x", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("iCQTn")), (parcelRequire("lLOi4")));
})(this, function(CryptoJS) {
    /**
	 * Electronic Codebook block mode.
	 */ CryptoJS.mode.ECB = function() {
        var ECB = CryptoJS.lib.BlockCipherMode.extend();
        ECB.Encryptor = ECB.extend({
            processBlock: function(words, offset) {
                this._cipher.encryptBlock(words, offset);
            }
        });
        ECB.Decryptor = ECB.extend({
            processBlock: function(words, offset) {
                this._cipher.decryptBlock(words, offset);
            }
        });
        return ECB;
    }();
    return CryptoJS.mode.ECB;
});

});

parcelRegister("fuTlY", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("iCQTn")), (parcelRequire("lLOi4")));
})(this, function(CryptoJS) {
    /**
	 * ANSI X.923 padding strategy.
	 */ CryptoJS.pad.AnsiX923 = {
        pad: function(data, blockSize) {
            // Shortcuts
            var dataSigBytes = data.sigBytes;
            var blockSizeBytes = blockSize * 4;
            // Count padding bytes
            var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;
            // Compute last byte position
            var lastBytePos = dataSigBytes + nPaddingBytes - 1;
            // Pad
            data.clamp();
            data.words[lastBytePos >>> 2] |= nPaddingBytes << 24 - lastBytePos % 4 * 8;
            data.sigBytes += nPaddingBytes;
        },
        unpad: function(data) {
            // Get number of padding bytes from last byte
            var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
            // Remove padding
            data.sigBytes -= nPaddingBytes;
        }
    };
    return CryptoJS.pad.Ansix923;
});

});

parcelRegister("hh5we", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("iCQTn")), (parcelRequire("lLOi4")));
})(this, function(CryptoJS) {
    /**
	 * ISO 10126 padding strategy.
	 */ CryptoJS.pad.Iso10126 = {
        pad: function(data, blockSize) {
            // Shortcut
            var blockSizeBytes = blockSize * 4;
            // Count padding bytes
            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
            // Pad
            data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).concat(CryptoJS.lib.WordArray.create([
                nPaddingBytes << 24
            ], 1));
        },
        unpad: function(data) {
            // Get number of padding bytes from last byte
            var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
            // Remove padding
            data.sigBytes -= nPaddingBytes;
        }
    };
    return CryptoJS.pad.Iso10126;
});

});

parcelRegister("1fjor", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("iCQTn")), (parcelRequire("lLOi4")));
})(this, function(CryptoJS) {
    /**
	 * ISO/IEC 9797-1 Padding Method 2.
	 */ CryptoJS.pad.Iso97971 = {
        pad: function(data, blockSize) {
            // Add 0x80 byte
            data.concat(CryptoJS.lib.WordArray.create([
                0x80000000
            ], 1));
            // Zero pad the rest
            CryptoJS.pad.ZeroPadding.pad(data, blockSize);
        },
        unpad: function(data) {
            // Remove zero padding
            CryptoJS.pad.ZeroPadding.unpad(data);
            // Remove one more byte -- the 0x80 byte
            data.sigBytes--;
        }
    };
    return CryptoJS.pad.Iso97971;
});

});

parcelRegister("dM2wj", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("iCQTn")), (parcelRequire("lLOi4")));
})(this, function(CryptoJS) {
    /**
	 * Zero padding strategy.
	 */ CryptoJS.pad.ZeroPadding = {
        pad: function(data, blockSize) {
            // Shortcut
            var blockSizeBytes = blockSize * 4;
            // Pad
            data.clamp();
            data.sigBytes += blockSizeBytes - (data.sigBytes % blockSizeBytes || blockSizeBytes);
        },
        unpad: function(data) {
            // Shortcut
            var dataWords = data.words;
            // Unpad
            var i = data.sigBytes - 1;
            for(var i = data.sigBytes - 1; i >= 0; i--)if (dataWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff) {
                data.sigBytes = i + 1;
                break;
            }
        }
    };
    return CryptoJS.pad.ZeroPadding;
});

});

parcelRegister("lGseF", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("iCQTn")), (parcelRequire("lLOi4")));
})(this, function(CryptoJS) {
    /**
	 * A noop padding strategy.
	 */ CryptoJS.pad.NoPadding = {
        pad: function() {},
        unpad: function() {}
    };
    return CryptoJS.pad.NoPadding;
});

});

parcelRegister("6oSmW", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("iCQTn")), (parcelRequire("lLOi4")));
})(this, function(CryptoJS) {
    (function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var CipherParams = C_lib.CipherParams;
        var C_enc = C.enc;
        var Hex = C_enc.Hex;
        var C_format = C.format;
        var HexFormatter = C_format.Hex = {
            /**
	         * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The hexadecimally encoded string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
	         */ stringify: function(cipherParams) {
                return cipherParams.ciphertext.toString(Hex);
            },
            /**
	         * Converts a hexadecimally encoded ciphertext string to a cipher params object.
	         *
	         * @param {string} input The hexadecimally encoded string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
	         */ parse: function(input) {
                var ciphertext = Hex.parse(input);
                return CipherParams.create({
                    ciphertext: ciphertext
                });
            }
        };
    })();
    return CryptoJS.format.Hex;
});

});

parcelRegister("3D3Ku", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("iCQTn")), (parcelRequire("eg7Z0")), (parcelRequire("gJi2y")), (parcelRequire("cL93H")), (parcelRequire("lLOi4")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        // Lookup tables
        var SBOX = [];
        var INV_SBOX = [];
        var SUB_MIX_0 = [];
        var SUB_MIX_1 = [];
        var SUB_MIX_2 = [];
        var SUB_MIX_3 = [];
        var INV_SUB_MIX_0 = [];
        var INV_SUB_MIX_1 = [];
        var INV_SUB_MIX_2 = [];
        var INV_SUB_MIX_3 = [];
        // Compute lookup tables
        (function() {
            // Compute double table
            var d = [];
            for(var i = 0; i < 256; i++)if (i < 128) d[i] = i << 1;
            else d[i] = i << 1 ^ 0x11b;
            // Walk GF(2^8)
            var x = 0;
            var xi = 0;
            for(var i = 0; i < 256; i++){
                // Compute sbox
                var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
                sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
                SBOX[x] = sx;
                INV_SBOX[sx] = x;
                // Compute multiplication
                var x2 = d[x];
                var x4 = d[x2];
                var x8 = d[x4];
                // Compute sub bytes, mix columns tables
                var t = d[sx] * 0x101 ^ sx * 0x1010100;
                SUB_MIX_0[x] = t << 24 | t >>> 8;
                SUB_MIX_1[x] = t << 16 | t >>> 16;
                SUB_MIX_2[x] = t << 8 | t >>> 24;
                SUB_MIX_3[x] = t;
                // Compute inv sub bytes, inv mix columns tables
                var t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
                INV_SUB_MIX_0[sx] = t << 24 | t >>> 8;
                INV_SUB_MIX_1[sx] = t << 16 | t >>> 16;
                INV_SUB_MIX_2[sx] = t << 8 | t >>> 24;
                INV_SUB_MIX_3[sx] = t;
                // Compute next counter
                if (!x) x = xi = 1;
                else {
                    x = x2 ^ d[d[d[x8 ^ x2]]];
                    xi ^= d[d[xi]];
                }
            }
        })();
        // Precomputed Rcon lookup
        var RCON = [
            0x00,
            0x01,
            0x02,
            0x04,
            0x08,
            0x10,
            0x20,
            0x40,
            0x80,
            0x1b,
            0x36
        ];
        /**
	     * AES block cipher algorithm.
	     */ var AES = C_algo.AES = BlockCipher.extend({
            _doReset: function() {
                var t;
                // Skip reset of nRounds has been set before and key did not change
                if (this._nRounds && this._keyPriorReset === this._key) return;
                // Shortcuts
                var key = this._keyPriorReset = this._key;
                var keyWords = key.words;
                var keySize = key.sigBytes / 4;
                // Compute number of rounds
                var nRounds = this._nRounds = keySize + 6;
                // Compute number of key schedule rows
                var ksRows = (nRounds + 1) * 4;
                // Compute key schedule
                var keySchedule = this._keySchedule = [];
                for(var ksRow = 0; ksRow < ksRows; ksRow++)if (ksRow < keySize) keySchedule[ksRow] = keyWords[ksRow];
                else {
                    t = keySchedule[ksRow - 1];
                    if (!(ksRow % keySize)) {
                        // Rot word
                        t = t << 8 | t >>> 24;
                        // Sub word
                        t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                        // Mix Rcon
                        t ^= RCON[ksRow / keySize | 0] << 24;
                    } else if (keySize > 6 && ksRow % keySize == 4) // Sub word
                    t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
                }
                // Compute inv key schedule
                var invKeySchedule = this._invKeySchedule = [];
                for(var invKsRow = 0; invKsRow < ksRows; invKsRow++){
                    var ksRow = ksRows - invKsRow;
                    if (invKsRow % 4) var t = keySchedule[ksRow];
                    else var t = keySchedule[ksRow - 4];
                    if (invKsRow < 4 || ksRow <= 4) invKeySchedule[invKsRow] = t;
                    else invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[t >>> 16 & 0xff]] ^ INV_SUB_MIX_2[SBOX[t >>> 8 & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
                }
            },
            encryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
            },
            decryptBlock: function(M, offset) {
                // Swap 2nd and 4th rows
                var t = M[offset + 1];
                M[offset + 1] = M[offset + 3];
                M[offset + 3] = t;
                this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);
                // Inv swap 2nd and 4th rows
                var t = M[offset + 1];
                M[offset + 1] = M[offset + 3];
                M[offset + 3] = t;
            },
            _doCryptBlock: function(M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
                // Shortcut
                var nRounds = this._nRounds;
                // Get input, add round key
                var s0 = M[offset] ^ keySchedule[0];
                var s1 = M[offset + 1] ^ keySchedule[1];
                var s2 = M[offset + 2] ^ keySchedule[2];
                var s3 = M[offset + 3] ^ keySchedule[3];
                // Key schedule row counter
                var ksRow = 4;
                // Rounds
                for(var round = 1; round < nRounds; round++){
                    // Shift rows, sub bytes, mix columns, add round key
                    var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[s1 >>> 16 & 0xff] ^ SUB_MIX_2[s2 >>> 8 & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
                    var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[s2 >>> 16 & 0xff] ^ SUB_MIX_2[s3 >>> 8 & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
                    var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[s3 >>> 16 & 0xff] ^ SUB_MIX_2[s0 >>> 8 & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
                    var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[s0 >>> 16 & 0xff] ^ SUB_MIX_2[s1 >>> 8 & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];
                    // Update state
                    s0 = t0;
                    s1 = t1;
                    s2 = t2;
                    s3 = t3;
                }
                // Shift rows, sub bytes, add round key
                var t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
                var t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
                var t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
                var t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
                // Set output
                M[offset] = t0;
                M[offset + 1] = t1;
                M[offset + 2] = t2;
                M[offset + 3] = t3;
            },
            keySize: 8
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
	     */ C.AES = BlockCipher._createHelper(AES);
    })();
    return CryptoJS.AES;
});

});

parcelRegister("7Z3Xv", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("iCQTn")), (parcelRequire("eg7Z0")), (parcelRequire("gJi2y")), (parcelRequire("cL93H")), (parcelRequire("lLOi4")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        // Permuted Choice 1 constants
        var PC1 = [
            57,
            49,
            41,
            33,
            25,
            17,
            9,
            1,
            58,
            50,
            42,
            34,
            26,
            18,
            10,
            2,
            59,
            51,
            43,
            35,
            27,
            19,
            11,
            3,
            60,
            52,
            44,
            36,
            63,
            55,
            47,
            39,
            31,
            23,
            15,
            7,
            62,
            54,
            46,
            38,
            30,
            22,
            14,
            6,
            61,
            53,
            45,
            37,
            29,
            21,
            13,
            5,
            28,
            20,
            12,
            4
        ];
        // Permuted Choice 2 constants
        var PC2 = [
            14,
            17,
            11,
            24,
            1,
            5,
            3,
            28,
            15,
            6,
            21,
            10,
            23,
            19,
            12,
            4,
            26,
            8,
            16,
            7,
            27,
            20,
            13,
            2,
            41,
            52,
            31,
            37,
            47,
            55,
            30,
            40,
            51,
            45,
            33,
            48,
            44,
            49,
            39,
            56,
            34,
            53,
            46,
            42,
            50,
            36,
            29,
            32
        ];
        // Cumulative bit shift constants
        var BIT_SHIFTS = [
            1,
            2,
            4,
            6,
            8,
            10,
            12,
            14,
            15,
            17,
            19,
            21,
            23,
            25,
            27,
            28
        ];
        // SBOXes and round permutation constants
        var SBOX_P = [
            {
                0x0: 0x808200,
                0x10000000: 0x8000,
                0x20000000: 0x808002,
                0x30000000: 0x2,
                0x40000000: 0x200,
                0x50000000: 0x808202,
                0x60000000: 0x800202,
                0x70000000: 0x800000,
                0x80000000: 0x202,
                0x90000000: 0x800200,
                0xa0000000: 0x8200,
                0xb0000000: 0x808000,
                0xc0000000: 0x8002,
                0xd0000000: 0x800002,
                0xe0000000: 0x0,
                0xf0000000: 0x8202,
                0x8000000: 0x0,
                0x18000000: 0x808202,
                0x28000000: 0x8202,
                0x38000000: 0x8000,
                0x48000000: 0x808200,
                0x58000000: 0x200,
                0x68000000: 0x808002,
                0x78000000: 0x2,
                0x88000000: 0x800200,
                0x98000000: 0x8200,
                0xa8000000: 0x808000,
                0xb8000000: 0x800202,
                0xc8000000: 0x800002,
                0xd8000000: 0x8002,
                0xe8000000: 0x202,
                0xf8000000: 0x800000,
                0x1: 0x8000,
                0x10000001: 0x2,
                0x20000001: 0x808200,
                0x30000001: 0x800000,
                0x40000001: 0x808002,
                0x50000001: 0x8200,
                0x60000001: 0x200,
                0x70000001: 0x800202,
                0x80000001: 0x808202,
                0x90000001: 0x808000,
                0xa0000001: 0x800002,
                0xb0000001: 0x8202,
                0xc0000001: 0x202,
                0xd0000001: 0x800200,
                0xe0000001: 0x8002,
                0xf0000001: 0x0,
                0x8000001: 0x808202,
                0x18000001: 0x808000,
                0x28000001: 0x800000,
                0x38000001: 0x200,
                0x48000001: 0x8000,
                0x58000001: 0x800002,
                0x68000001: 0x2,
                0x78000001: 0x8202,
                0x88000001: 0x8002,
                0x98000001: 0x800202,
                0xa8000001: 0x202,
                0xb8000001: 0x808200,
                0xc8000001: 0x800200,
                0xd8000001: 0x0,
                0xe8000001: 0x8200,
                0xf8000001: 0x808002
            },
            {
                0x0: 0x40084010,
                0x1000000: 0x4000,
                0x2000000: 0x80000,
                0x3000000: 0x40080010,
                0x4000000: 0x40000010,
                0x5000000: 0x40084000,
                0x6000000: 0x40004000,
                0x7000000: 0x10,
                0x8000000: 0x84000,
                0x9000000: 0x40004010,
                0xa000000: 0x40000000,
                0xb000000: 0x84010,
                0xc000000: 0x80010,
                0xd000000: 0x0,
                0xe000000: 0x4010,
                0xf000000: 0x40080000,
                0x800000: 0x40004000,
                0x1800000: 0x84010,
                0x2800000: 0x10,
                0x3800000: 0x40004010,
                0x4800000: 0x40084010,
                0x5800000: 0x40000000,
                0x6800000: 0x80000,
                0x7800000: 0x40080010,
                0x8800000: 0x80010,
                0x9800000: 0x0,
                0xa800000: 0x4000,
                0xb800000: 0x40080000,
                0xc800000: 0x40000010,
                0xd800000: 0x84000,
                0xe800000: 0x40084000,
                0xf800000: 0x4010,
                0x10000000: 0x0,
                0x11000000: 0x40080010,
                0x12000000: 0x40004010,
                0x13000000: 0x40084000,
                0x14000000: 0x40080000,
                0x15000000: 0x10,
                0x16000000: 0x84010,
                0x17000000: 0x4000,
                0x18000000: 0x4010,
                0x19000000: 0x80000,
                0x1a000000: 0x80010,
                0x1b000000: 0x40000010,
                0x1c000000: 0x84000,
                0x1d000000: 0x40004000,
                0x1e000000: 0x40000000,
                0x1f000000: 0x40084010,
                0x10800000: 0x84010,
                0x11800000: 0x80000,
                0x12800000: 0x40080000,
                0x13800000: 0x4000,
                0x14800000: 0x40004000,
                0x15800000: 0x40084010,
                0x16800000: 0x10,
                0x17800000: 0x40000000,
                0x18800000: 0x40084000,
                0x19800000: 0x40000010,
                0x1a800000: 0x40004010,
                0x1b800000: 0x80010,
                0x1c800000: 0x0,
                0x1d800000: 0x4010,
                0x1e800000: 0x40080010,
                0x1f800000: 0x84000
            },
            {
                0x0: 0x104,
                0x100000: 0x0,
                0x200000: 0x4000100,
                0x300000: 0x10104,
                0x400000: 0x10004,
                0x500000: 0x4000004,
                0x600000: 0x4010104,
                0x700000: 0x4010000,
                0x800000: 0x4000000,
                0x900000: 0x4010100,
                0xa00000: 0x10100,
                0xb00000: 0x4010004,
                0xc00000: 0x4000104,
                0xd00000: 0x10000,
                0xe00000: 0x4,
                0xf00000: 0x100,
                0x80000: 0x4010100,
                0x180000: 0x4010004,
                0x280000: 0x0,
                0x380000: 0x4000100,
                0x480000: 0x4000004,
                0x580000: 0x10000,
                0x680000: 0x10004,
                0x780000: 0x104,
                0x880000: 0x4,
                0x980000: 0x100,
                0xa80000: 0x4010000,
                0xb80000: 0x10104,
                0xc80000: 0x10100,
                0xd80000: 0x4000104,
                0xe80000: 0x4010104,
                0xf80000: 0x4000000,
                0x1000000: 0x4010100,
                0x1100000: 0x10004,
                0x1200000: 0x10000,
                0x1300000: 0x4000100,
                0x1400000: 0x100,
                0x1500000: 0x4010104,
                0x1600000: 0x4000004,
                0x1700000: 0x0,
                0x1800000: 0x4000104,
                0x1900000: 0x4000000,
                0x1a00000: 0x4,
                0x1b00000: 0x10100,
                0x1c00000: 0x4010000,
                0x1d00000: 0x104,
                0x1e00000: 0x10104,
                0x1f00000: 0x4010004,
                0x1080000: 0x4000000,
                0x1180000: 0x104,
                0x1280000: 0x4010100,
                0x1380000: 0x0,
                0x1480000: 0x10004,
                0x1580000: 0x4000100,
                0x1680000: 0x100,
                0x1780000: 0x4010004,
                0x1880000: 0x10000,
                0x1980000: 0x4010104,
                0x1a80000: 0x10104,
                0x1b80000: 0x4000004,
                0x1c80000: 0x4000104,
                0x1d80000: 0x4010000,
                0x1e80000: 0x4,
                0x1f80000: 0x10100
            },
            {
                0x0: 0x80401000,
                0x10000: 0x80001040,
                0x20000: 0x401040,
                0x30000: 0x80400000,
                0x40000: 0x0,
                0x50000: 0x401000,
                0x60000: 0x80000040,
                0x70000: 0x400040,
                0x80000: 0x80000000,
                0x90000: 0x400000,
                0xa0000: 0x40,
                0xb0000: 0x80001000,
                0xc0000: 0x80400040,
                0xd0000: 0x1040,
                0xe0000: 0x1000,
                0xf0000: 0x80401040,
                0x8000: 0x80001040,
                0x18000: 0x40,
                0x28000: 0x80400040,
                0x38000: 0x80001000,
                0x48000: 0x401000,
                0x58000: 0x80401040,
                0x68000: 0x0,
                0x78000: 0x80400000,
                0x88000: 0x1000,
                0x98000: 0x80401000,
                0xa8000: 0x400000,
                0xb8000: 0x1040,
                0xc8000: 0x80000000,
                0xd8000: 0x400040,
                0xe8000: 0x401040,
                0xf8000: 0x80000040,
                0x100000: 0x400040,
                0x110000: 0x401000,
                0x120000: 0x80000040,
                0x130000: 0x0,
                0x140000: 0x1040,
                0x150000: 0x80400040,
                0x160000: 0x80401000,
                0x170000: 0x80001040,
                0x180000: 0x80401040,
                0x190000: 0x80000000,
                0x1a0000: 0x80400000,
                0x1b0000: 0x401040,
                0x1c0000: 0x80001000,
                0x1d0000: 0x400000,
                0x1e0000: 0x40,
                0x1f0000: 0x1000,
                0x108000: 0x80400000,
                0x118000: 0x80401040,
                0x128000: 0x0,
                0x138000: 0x401000,
                0x148000: 0x400040,
                0x158000: 0x80000000,
                0x168000: 0x80001040,
                0x178000: 0x40,
                0x188000: 0x80000040,
                0x198000: 0x1000,
                0x1a8000: 0x80001000,
                0x1b8000: 0x80400040,
                0x1c8000: 0x1040,
                0x1d8000: 0x80401000,
                0x1e8000: 0x400000,
                0x1f8000: 0x401040
            },
            {
                0x0: 0x80,
                0x1000: 0x1040000,
                0x2000: 0x40000,
                0x3000: 0x20000000,
                0x4000: 0x20040080,
                0x5000: 0x1000080,
                0x6000: 0x21000080,
                0x7000: 0x40080,
                0x8000: 0x1000000,
                0x9000: 0x20040000,
                0xa000: 0x20000080,
                0xb000: 0x21040080,
                0xc000: 0x21040000,
                0xd000: 0x0,
                0xe000: 0x1040080,
                0xf000: 0x21000000,
                0x800: 0x1040080,
                0x1800: 0x21000080,
                0x2800: 0x80,
                0x3800: 0x1040000,
                0x4800: 0x40000,
                0x5800: 0x20040080,
                0x6800: 0x21040000,
                0x7800: 0x20000000,
                0x8800: 0x20040000,
                0x9800: 0x0,
                0xa800: 0x21040080,
                0xb800: 0x1000080,
                0xc800: 0x20000080,
                0xd800: 0x21000000,
                0xe800: 0x1000000,
                0xf800: 0x40080,
                0x10000: 0x40000,
                0x11000: 0x80,
                0x12000: 0x20000000,
                0x13000: 0x21000080,
                0x14000: 0x1000080,
                0x15000: 0x21040000,
                0x16000: 0x20040080,
                0x17000: 0x1000000,
                0x18000: 0x21040080,
                0x19000: 0x21000000,
                0x1a000: 0x1040000,
                0x1b000: 0x20040000,
                0x1c000: 0x40080,
                0x1d000: 0x20000080,
                0x1e000: 0x0,
                0x1f000: 0x1040080,
                0x10800: 0x21000080,
                0x11800: 0x1000000,
                0x12800: 0x1040000,
                0x13800: 0x20040080,
                0x14800: 0x20000000,
                0x15800: 0x1040080,
                0x16800: 0x80,
                0x17800: 0x21040000,
                0x18800: 0x40080,
                0x19800: 0x21040080,
                0x1a800: 0x0,
                0x1b800: 0x21000000,
                0x1c800: 0x1000080,
                0x1d800: 0x40000,
                0x1e800: 0x20040000,
                0x1f800: 0x20000080
            },
            {
                0x0: 0x10000008,
                0x100: 0x2000,
                0x200: 0x10200000,
                0x300: 0x10202008,
                0x400: 0x10002000,
                0x500: 0x200000,
                0x600: 0x200008,
                0x700: 0x10000000,
                0x800: 0x0,
                0x900: 0x10002008,
                0xa00: 0x202000,
                0xb00: 0x8,
                0xc00: 0x10200008,
                0xd00: 0x202008,
                0xe00: 0x2008,
                0xf00: 0x10202000,
                0x80: 0x10200000,
                0x180: 0x10202008,
                0x280: 0x8,
                0x380: 0x200000,
                0x480: 0x202008,
                0x580: 0x10000008,
                0x680: 0x10002000,
                0x780: 0x2008,
                0x880: 0x200008,
                0x980: 0x2000,
                0xa80: 0x10002008,
                0xb80: 0x10200008,
                0xc80: 0x0,
                0xd80: 0x10202000,
                0xe80: 0x202000,
                0xf80: 0x10000000,
                0x1000: 0x10002000,
                0x1100: 0x10200008,
                0x1200: 0x10202008,
                0x1300: 0x2008,
                0x1400: 0x200000,
                0x1500: 0x10000000,
                0x1600: 0x10000008,
                0x1700: 0x202000,
                0x1800: 0x202008,
                0x1900: 0x0,
                0x1a00: 0x8,
                0x1b00: 0x10200000,
                0x1c00: 0x2000,
                0x1d00: 0x10002008,
                0x1e00: 0x10202000,
                0x1f00: 0x200008,
                0x1080: 0x8,
                0x1180: 0x202000,
                0x1280: 0x200000,
                0x1380: 0x10000008,
                0x1480: 0x10002000,
                0x1580: 0x2008,
                0x1680: 0x10202008,
                0x1780: 0x10200000,
                0x1880: 0x10202000,
                0x1980: 0x10200008,
                0x1a80: 0x2000,
                0x1b80: 0x202008,
                0x1c80: 0x200008,
                0x1d80: 0x0,
                0x1e80: 0x10000000,
                0x1f80: 0x10002008
            },
            {
                0x0: 0x100000,
                0x10: 0x2000401,
                0x20: 0x400,
                0x30: 0x100401,
                0x40: 0x2100401,
                0x50: 0x0,
                0x60: 0x1,
                0x70: 0x2100001,
                0x80: 0x2000400,
                0x90: 0x100001,
                0xa0: 0x2000001,
                0xb0: 0x2100400,
                0xc0: 0x2100000,
                0xd0: 0x401,
                0xe0: 0x100400,
                0xf0: 0x2000000,
                0x8: 0x2100001,
                0x18: 0x0,
                0x28: 0x2000401,
                0x38: 0x2100400,
                0x48: 0x100000,
                0x58: 0x2000001,
                0x68: 0x2000000,
                0x78: 0x401,
                0x88: 0x100401,
                0x98: 0x2000400,
                0xa8: 0x2100000,
                0xb8: 0x100001,
                0xc8: 0x400,
                0xd8: 0x2100401,
                0xe8: 0x1,
                0xf8: 0x100400,
                0x100: 0x2000000,
                0x110: 0x100000,
                0x120: 0x2000401,
                0x130: 0x2100001,
                0x140: 0x100001,
                0x150: 0x2000400,
                0x160: 0x2100400,
                0x170: 0x100401,
                0x180: 0x401,
                0x190: 0x2100401,
                0x1a0: 0x100400,
                0x1b0: 0x1,
                0x1c0: 0x0,
                0x1d0: 0x2100000,
                0x1e0: 0x2000001,
                0x1f0: 0x400,
                0x108: 0x100400,
                0x118: 0x2000401,
                0x128: 0x2100001,
                0x138: 0x1,
                0x148: 0x2000000,
                0x158: 0x100000,
                0x168: 0x401,
                0x178: 0x2100400,
                0x188: 0x2000001,
                0x198: 0x2100000,
                0x1a8: 0x0,
                0x1b8: 0x2100401,
                0x1c8: 0x100401,
                0x1d8: 0x400,
                0x1e8: 0x2000400,
                0x1f8: 0x100001
            },
            {
                0x0: 0x8000820,
                0x1: 0x20000,
                0x2: 0x8000000,
                0x3: 0x20,
                0x4: 0x20020,
                0x5: 0x8020820,
                0x6: 0x8020800,
                0x7: 0x800,
                0x8: 0x8020000,
                0x9: 0x8000800,
                0xa: 0x20800,
                0xb: 0x8020020,
                0xc: 0x820,
                0xd: 0x0,
                0xe: 0x8000020,
                0xf: 0x20820,
                0x80000000: 0x800,
                0x80000001: 0x8020820,
                0x80000002: 0x8000820,
                0x80000003: 0x8000000,
                0x80000004: 0x8020000,
                0x80000005: 0x20800,
                0x80000006: 0x20820,
                0x80000007: 0x20,
                0x80000008: 0x8000020,
                0x80000009: 0x820,
                0x8000000a: 0x20020,
                0x8000000b: 0x8020800,
                0x8000000c: 0x0,
                0x8000000d: 0x8020020,
                0x8000000e: 0x8000800,
                0x8000000f: 0x20000,
                0x10: 0x20820,
                0x11: 0x8020800,
                0x12: 0x20,
                0x13: 0x800,
                0x14: 0x8000800,
                0x15: 0x8000020,
                0x16: 0x8020020,
                0x17: 0x20000,
                0x18: 0x0,
                0x19: 0x20020,
                0x1a: 0x8020000,
                0x1b: 0x8000820,
                0x1c: 0x8020820,
                0x1d: 0x20800,
                0x1e: 0x820,
                0x1f: 0x8000000,
                0x80000010: 0x20000,
                0x80000011: 0x800,
                0x80000012: 0x8020020,
                0x80000013: 0x20820,
                0x80000014: 0x20,
                0x80000015: 0x8020000,
                0x80000016: 0x8000000,
                0x80000017: 0x8000820,
                0x80000018: 0x8020820,
                0x80000019: 0x8000020,
                0x8000001a: 0x8000800,
                0x8000001b: 0x0,
                0x8000001c: 0x20800,
                0x8000001d: 0x820,
                0x8000001e: 0x20020,
                0x8000001f: 0x8020800
            }
        ];
        // Masks that select the SBOX input
        var SBOX_MASK = [
            0xf8000001,
            0x1f800000,
            0x01f80000,
            0x001f8000,
            0x0001f800,
            0x00001f80,
            0x000001f8,
            0x8000001f
        ];
        /**
	     * DES block cipher algorithm.
	     */ var DES = C_algo.DES = BlockCipher.extend({
            _doReset: function() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                // Select 56 bits according to PC1
                var keyBits = [];
                for(var i = 0; i < 56; i++){
                    var keyBitPos = PC1[i] - 1;
                    keyBits[i] = keyWords[keyBitPos >>> 5] >>> 31 - keyBitPos % 32 & 1;
                }
                // Assemble 16 subkeys
                var subKeys = this._subKeys = [];
                for(var nSubKey = 0; nSubKey < 16; nSubKey++){
                    // Create subkey
                    var subKey = subKeys[nSubKey] = [];
                    // Shortcut
                    var bitShift = BIT_SHIFTS[nSubKey];
                    // Select 48 bits according to PC2
                    for(var i = 0; i < 24; i++){
                        // Select from the left 28 key bits
                        subKey[i / 6 | 0] |= keyBits[(PC2[i] - 1 + bitShift) % 28] << 31 - i % 6;
                        // Select from the right 28 key bits
                        subKey[4 + (i / 6 | 0)] |= keyBits[28 + (PC2[i + 24] - 1 + bitShift) % 28] << 31 - i % 6;
                    }
                    // Since each subkey is applied to an expanded 32-bit input,
                    // the subkey can be broken into 8 values scaled to 32-bits,
                    // which allows the key to be used without expansion
                    subKey[0] = subKey[0] << 1 | subKey[0] >>> 31;
                    for(var i = 1; i < 7; i++)subKey[i] = subKey[i] >>> (i - 1) * 4 + 3;
                    subKey[7] = subKey[7] << 5 | subKey[7] >>> 27;
                }
                // Compute inverse subkeys
                var invSubKeys = this._invSubKeys = [];
                for(var i = 0; i < 16; i++)invSubKeys[i] = subKeys[15 - i];
            },
            encryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._subKeys);
            },
            decryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._invSubKeys);
            },
            _doCryptBlock: function(M, offset, subKeys) {
                // Get input
                this._lBlock = M[offset];
                this._rBlock = M[offset + 1];
                // Initial permutation
                exchangeLR.call(this, 4, 0x0f0f0f0f);
                exchangeLR.call(this, 16, 0x0000ffff);
                exchangeRL.call(this, 2, 0x33333333);
                exchangeRL.call(this, 8, 0x00ff00ff);
                exchangeLR.call(this, 1, 0x55555555);
                // Rounds
                for(var round = 0; round < 16; round++){
                    // Shortcuts
                    var subKey = subKeys[round];
                    var lBlock = this._lBlock;
                    var rBlock = this._rBlock;
                    // Feistel function
                    var f = 0;
                    for(var i = 0; i < 8; i++)f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
                    this._lBlock = rBlock;
                    this._rBlock = lBlock ^ f;
                }
                // Undo swap from last round
                var t = this._lBlock;
                this._lBlock = this._rBlock;
                this._rBlock = t;
                // Final permutation
                exchangeLR.call(this, 1, 0x55555555);
                exchangeRL.call(this, 8, 0x00ff00ff);
                exchangeRL.call(this, 2, 0x33333333);
                exchangeLR.call(this, 16, 0x0000ffff);
                exchangeLR.call(this, 4, 0x0f0f0f0f);
                // Set output
                M[offset] = this._lBlock;
                M[offset + 1] = this._rBlock;
            },
            keySize: 2,
            ivSize: 2,
            blockSize: 2
        });
        // Swap bits across the left and right words
        function exchangeLR(offset, mask) {
            var t = (this._lBlock >>> offset ^ this._rBlock) & mask;
            this._rBlock ^= t;
            this._lBlock ^= t << offset;
        }
        function exchangeRL(offset, mask) {
            var t = (this._rBlock >>> offset ^ this._lBlock) & mask;
            this._lBlock ^= t;
            this._rBlock ^= t << offset;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
	     */ C.DES = BlockCipher._createHelper(DES);
        /**
	     * Triple-DES block cipher algorithm.
	     */ var TripleDES = C_algo.TripleDES = BlockCipher.extend({
            _doReset: function() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                // Make sure the key length is valid (64, 128 or >= 192 bit)
                if (keyWords.length !== 2 && keyWords.length !== 4 && keyWords.length < 6) throw new Error("Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.");
                // Extend the key according to the keying options defined in 3DES standard
                var key1 = keyWords.slice(0, 2);
                var key2 = keyWords.length < 4 ? keyWords.slice(0, 2) : keyWords.slice(2, 4);
                var key3 = keyWords.length < 6 ? keyWords.slice(0, 2) : keyWords.slice(4, 6);
                // Create DES instances
                this._des1 = DES.createEncryptor(WordArray.create(key1));
                this._des2 = DES.createEncryptor(WordArray.create(key2));
                this._des3 = DES.createEncryptor(WordArray.create(key3));
            },
            encryptBlock: function(M, offset) {
                this._des1.encryptBlock(M, offset);
                this._des2.decryptBlock(M, offset);
                this._des3.encryptBlock(M, offset);
            },
            decryptBlock: function(M, offset) {
                this._des3.decryptBlock(M, offset);
                this._des2.encryptBlock(M, offset);
                this._des1.decryptBlock(M, offset);
            },
            keySize: 6,
            ivSize: 2,
            blockSize: 2
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
	     */ C.TripleDES = BlockCipher._createHelper(TripleDES);
    })();
    return CryptoJS.TripleDES;
});

});

parcelRegister("89sC6", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("iCQTn")), (parcelRequire("eg7Z0")), (parcelRequire("gJi2y")), (parcelRequire("cL93H")), (parcelRequire("lLOi4")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        /**
	     * RC4 stream cipher algorithm.
	     */ var RC4 = C_algo.RC4 = StreamCipher.extend({
            _doReset: function() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                var keySigBytes = key.sigBytes;
                // Init sbox
                var S = this._S = [];
                for(var i = 0; i < 256; i++)S[i] = i;
                // Key setup
                for(var i = 0, j = 0; i < 256; i++){
                    var keyByteIndex = i % keySigBytes;
                    var keyByte = keyWords[keyByteIndex >>> 2] >>> 24 - keyByteIndex % 4 * 8 & 0xff;
                    j = (j + S[i] + keyByte) % 256;
                    // Swap
                    var t = S[i];
                    S[i] = S[j];
                    S[j] = t;
                }
                // Counters
                this._i = this._j = 0;
            },
            _doProcessBlock: function(M, offset) {
                M[offset] ^= generateKeystreamWord.call(this);
            },
            keySize: 8,
            ivSize: 0
        });
        function generateKeystreamWord() {
            // Shortcuts
            var S = this._S;
            var i = this._i;
            var j = this._j;
            // Generate keystream word
            var keystreamWord = 0;
            for(var n = 0; n < 4; n++){
                i = (i + 1) % 256;
                j = (j + S[i]) % 256;
                // Swap
                var t = S[i];
                S[i] = S[j];
                S[j] = t;
                keystreamWord |= S[(S[i] + S[j]) % 256] << 24 - n * 8;
            }
            // Update counters
            this._i = i;
            this._j = j;
            return keystreamWord;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
	     */ C.RC4 = StreamCipher._createHelper(RC4);
        /**
	     * Modified RC4 stream cipher algorithm.
	     */ var RC4Drop = C_algo.RC4Drop = RC4.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} drop The number of keystream words to drop. Default 192
	         */ cfg: RC4.cfg.extend({
                drop: 192
            }),
            _doReset: function() {
                RC4._doReset.call(this);
                // Drop
                for(var i = this.cfg.drop; i > 0; i--)generateKeystreamWord.call(this);
            }
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
	     */ C.RC4Drop = StreamCipher._createHelper(RC4Drop);
    })();
    return CryptoJS.RC4;
});

});

parcelRegister("8dzkn", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("iCQTn")), (parcelRequire("eg7Z0")), (parcelRequire("gJi2y")), (parcelRequire("cL93H")), (parcelRequire("lLOi4")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        // Reusable objects
        var S = [];
        var C_ = [];
        var G = [];
        /**
	     * Rabbit stream cipher algorithm
	     */ var Rabbit = C_algo.Rabbit = StreamCipher.extend({
            _doReset: function() {
                // Shortcuts
                var K = this._key.words;
                var iv = this.cfg.iv;
                // Swap endian
                for(var i = 0; i < 4; i++)K[i] = (K[i] << 8 | K[i] >>> 24) & 0x00ff00ff | (K[i] << 24 | K[i] >>> 8) & 0xff00ff00;
                // Generate initial state values
                var X = this._X = [
                    K[0],
                    K[3] << 16 | K[2] >>> 16,
                    K[1],
                    K[0] << 16 | K[3] >>> 16,
                    K[2],
                    K[1] << 16 | K[0] >>> 16,
                    K[3],
                    K[2] << 16 | K[1] >>> 16
                ];
                // Generate initial counter values
                var C = this._C = [
                    K[2] << 16 | K[2] >>> 16,
                    K[0] & 0xffff0000 | K[1] & 0x0000ffff,
                    K[3] << 16 | K[3] >>> 16,
                    K[1] & 0xffff0000 | K[2] & 0x0000ffff,
                    K[0] << 16 | K[0] >>> 16,
                    K[2] & 0xffff0000 | K[3] & 0x0000ffff,
                    K[1] << 16 | K[1] >>> 16,
                    K[3] & 0xffff0000 | K[0] & 0x0000ffff
                ];
                // Carry bit
                this._b = 0;
                // Iterate the system four times
                for(var i = 0; i < 4; i++)nextState.call(this);
                // Modify the counters
                for(var i = 0; i < 8; i++)C[i] ^= X[i + 4 & 7];
                // IV setup
                if (iv) {
                    // Shortcuts
                    var IV = iv.words;
                    var IV_0 = IV[0];
                    var IV_1 = IV[1];
                    // Generate four subvectors
                    var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
                    var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
                    var i1 = i0 >>> 16 | i2 & 0xffff0000;
                    var i3 = i2 << 16 | i0 & 0x0000ffff;
                    // Modify counter values
                    C[0] ^= i0;
                    C[1] ^= i1;
                    C[2] ^= i2;
                    C[3] ^= i3;
                    C[4] ^= i0;
                    C[5] ^= i1;
                    C[6] ^= i2;
                    C[7] ^= i3;
                    // Iterate the system four times
                    for(var i = 0; i < 4; i++)nextState.call(this);
                }
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var X = this._X;
                // Iterate the system
                nextState.call(this);
                // Generate four keystream words
                S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
                S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
                S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
                S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;
                for(var i = 0; i < 4; i++){
                    // Swap endian
                    S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00;
                    // Encrypt
                    M[offset + i] ^= S[i];
                }
            },
            blockSize: 4,
            ivSize: 2
        });
        function nextState() {
            // Shortcuts
            var X = this._X;
            var C = this._C;
            // Save old counter values
            for(var i = 0; i < 8; i++)C_[i] = C[i];
            // Calculate new counter values
            C[0] = C[0] + 0x4d34d34d + this._b | 0;
            C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
            C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
            C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
            C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
            C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
            C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
            C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
            this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
            // Calculate the g-values
            for(var i = 0; i < 8; i++){
                var gx = X[i] + C[i];
                // Construct high and low argument for squaring
                var ga = gx & 0xffff;
                var gb = gx >>> 16;
                // Calculate high and low result of squaring
                var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
                var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0);
                // High XOR low
                G[i] = gh ^ gl;
            }
            // Calculate new state values
            X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
            X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
            X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
            X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
            X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
            X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
            X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
            X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
	     */ C.Rabbit = StreamCipher._createHelper(Rabbit);
    })();
    return CryptoJS.Rabbit;
});

});

parcelRegister("kSTFn", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("iCQTn")), (parcelRequire("eg7Z0")), (parcelRequire("gJi2y")), (parcelRequire("cL93H")), (parcelRequire("lLOi4")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        // Reusable objects
        var S = [];
        var C_ = [];
        var G = [];
        /**
	     * Rabbit stream cipher algorithm.
	     *
	     * This is a legacy version that neglected to convert the key to little-endian.
	     * This error doesn't affect the cipher's security,
	     * but it does affect its compatibility with other implementations.
	     */ var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
            _doReset: function() {
                // Shortcuts
                var K = this._key.words;
                var iv = this.cfg.iv;
                // Generate initial state values
                var X = this._X = [
                    K[0],
                    K[3] << 16 | K[2] >>> 16,
                    K[1],
                    K[0] << 16 | K[3] >>> 16,
                    K[2],
                    K[1] << 16 | K[0] >>> 16,
                    K[3],
                    K[2] << 16 | K[1] >>> 16
                ];
                // Generate initial counter values
                var C = this._C = [
                    K[2] << 16 | K[2] >>> 16,
                    K[0] & 0xffff0000 | K[1] & 0x0000ffff,
                    K[3] << 16 | K[3] >>> 16,
                    K[1] & 0xffff0000 | K[2] & 0x0000ffff,
                    K[0] << 16 | K[0] >>> 16,
                    K[2] & 0xffff0000 | K[3] & 0x0000ffff,
                    K[1] << 16 | K[1] >>> 16,
                    K[3] & 0xffff0000 | K[0] & 0x0000ffff
                ];
                // Carry bit
                this._b = 0;
                // Iterate the system four times
                for(var i = 0; i < 4; i++)nextState.call(this);
                // Modify the counters
                for(var i = 0; i < 8; i++)C[i] ^= X[i + 4 & 7];
                // IV setup
                if (iv) {
                    // Shortcuts
                    var IV = iv.words;
                    var IV_0 = IV[0];
                    var IV_1 = IV[1];
                    // Generate four subvectors
                    var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
                    var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
                    var i1 = i0 >>> 16 | i2 & 0xffff0000;
                    var i3 = i2 << 16 | i0 & 0x0000ffff;
                    // Modify counter values
                    C[0] ^= i0;
                    C[1] ^= i1;
                    C[2] ^= i2;
                    C[3] ^= i3;
                    C[4] ^= i0;
                    C[5] ^= i1;
                    C[6] ^= i2;
                    C[7] ^= i3;
                    // Iterate the system four times
                    for(var i = 0; i < 4; i++)nextState.call(this);
                }
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var X = this._X;
                // Iterate the system
                nextState.call(this);
                // Generate four keystream words
                S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
                S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
                S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
                S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;
                for(var i = 0; i < 4; i++){
                    // Swap endian
                    S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00;
                    // Encrypt
                    M[offset + i] ^= S[i];
                }
            },
            blockSize: 4,
            ivSize: 2
        });
        function nextState() {
            // Shortcuts
            var X = this._X;
            var C = this._C;
            // Save old counter values
            for(var i = 0; i < 8; i++)C_[i] = C[i];
            // Calculate new counter values
            C[0] = C[0] + 0x4d34d34d + this._b | 0;
            C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
            C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
            C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
            C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
            C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
            C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
            C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
            this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
            // Calculate the g-values
            for(var i = 0; i < 8; i++){
                var gx = X[i] + C[i];
                // Construct high and low argument for squaring
                var ga = gx & 0xffff;
                var gb = gx >>> 16;
                // Calculate high and low result of squaring
                var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
                var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0);
                // High XOR low
                G[i] = gh ^ gl;
            }
            // Calculate new state values
            X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
            X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
            X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
            X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
            X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
            X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
            X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
            X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
	     */ C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
    })();
    return CryptoJS.RabbitLegacy;
});

});

parcelRegister("62CxY", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("iCQTn")), (parcelRequire("eg7Z0")), (parcelRequire("gJi2y")), (parcelRequire("cL93H")), (parcelRequire("lLOi4")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        const N = 16;
        //Origin pbox and sbox, derived from PI
        const ORIG_P = [
            0x243F6A88,
            0x85A308D3,
            0x13198A2E,
            0x03707344,
            0xA4093822,
            0x299F31D0,
            0x082EFA98,
            0xEC4E6C89,
            0x452821E6,
            0x38D01377,
            0xBE5466CF,
            0x34E90C6C,
            0xC0AC29B7,
            0xC97C50DD,
            0x3F84D5B5,
            0xB5470917,
            0x9216D5D9,
            0x8979FB1B
        ];
        const ORIG_S = [
            [
                0xD1310BA6,
                0x98DFB5AC,
                0x2FFD72DB,
                0xD01ADFB7,
                0xB8E1AFED,
                0x6A267E96,
                0xBA7C9045,
                0xF12C7F99,
                0x24A19947,
                0xB3916CF7,
                0x0801F2E2,
                0x858EFC16,
                0x636920D8,
                0x71574E69,
                0xA458FEA3,
                0xF4933D7E,
                0x0D95748F,
                0x728EB658,
                0x718BCD58,
                0x82154AEE,
                0x7B54A41D,
                0xC25A59B5,
                0x9C30D539,
                0x2AF26013,
                0xC5D1B023,
                0x286085F0,
                0xCA417918,
                0xB8DB38EF,
                0x8E79DCB0,
                0x603A180E,
                0x6C9E0E8B,
                0xB01E8A3E,
                0xD71577C1,
                0xBD314B27,
                0x78AF2FDA,
                0x55605C60,
                0xE65525F3,
                0xAA55AB94,
                0x57489862,
                0x63E81440,
                0x55CA396A,
                0x2AAB10B6,
                0xB4CC5C34,
                0x1141E8CE,
                0xA15486AF,
                0x7C72E993,
                0xB3EE1411,
                0x636FBC2A,
                0x2BA9C55D,
                0x741831F6,
                0xCE5C3E16,
                0x9B87931E,
                0xAFD6BA33,
                0x6C24CF5C,
                0x7A325381,
                0x28958677,
                0x3B8F4898,
                0x6B4BB9AF,
                0xC4BFE81B,
                0x66282193,
                0x61D809CC,
                0xFB21A991,
                0x487CAC60,
                0x5DEC8032,
                0xEF845D5D,
                0xE98575B1,
                0xDC262302,
                0xEB651B88,
                0x23893E81,
                0xD396ACC5,
                0x0F6D6FF3,
                0x83F44239,
                0x2E0B4482,
                0xA4842004,
                0x69C8F04A,
                0x9E1F9B5E,
                0x21C66842,
                0xF6E96C9A,
                0x670C9C61,
                0xABD388F0,
                0x6A51A0D2,
                0xD8542F68,
                0x960FA728,
                0xAB5133A3,
                0x6EEF0B6C,
                0x137A3BE4,
                0xBA3BF050,
                0x7EFB2A98,
                0xA1F1651D,
                0x39AF0176,
                0x66CA593E,
                0x82430E88,
                0x8CEE8619,
                0x456F9FB4,
                0x7D84A5C3,
                0x3B8B5EBE,
                0xE06F75D8,
                0x85C12073,
                0x401A449F,
                0x56C16AA6,
                0x4ED3AA62,
                0x363F7706,
                0x1BFEDF72,
                0x429B023D,
                0x37D0D724,
                0xD00A1248,
                0xDB0FEAD3,
                0x49F1C09B,
                0x075372C9,
                0x80991B7B,
                0x25D479D8,
                0xF6E8DEF7,
                0xE3FE501A,
                0xB6794C3B,
                0x976CE0BD,
                0x04C006BA,
                0xC1A94FB6,
                0x409F60C4,
                0x5E5C9EC2,
                0x196A2463,
                0x68FB6FAF,
                0x3E6C53B5,
                0x1339B2EB,
                0x3B52EC6F,
                0x6DFC511F,
                0x9B30952C,
                0xCC814544,
                0xAF5EBD09,
                0xBEE3D004,
                0xDE334AFD,
                0x660F2807,
                0x192E4BB3,
                0xC0CBA857,
                0x45C8740F,
                0xD20B5F39,
                0xB9D3FBDB,
                0x5579C0BD,
                0x1A60320A,
                0xD6A100C6,
                0x402C7279,
                0x679F25FE,
                0xFB1FA3CC,
                0x8EA5E9F8,
                0xDB3222F8,
                0x3C7516DF,
                0xFD616B15,
                0x2F501EC8,
                0xAD0552AB,
                0x323DB5FA,
                0xFD238760,
                0x53317B48,
                0x3E00DF82,
                0x9E5C57BB,
                0xCA6F8CA0,
                0x1A87562E,
                0xDF1769DB,
                0xD542A8F6,
                0x287EFFC3,
                0xAC6732C6,
                0x8C4F5573,
                0x695B27B0,
                0xBBCA58C8,
                0xE1FFA35D,
                0xB8F011A0,
                0x10FA3D98,
                0xFD2183B8,
                0x4AFCB56C,
                0x2DD1D35B,
                0x9A53E479,
                0xB6F84565,
                0xD28E49BC,
                0x4BFB9790,
                0xE1DDF2DA,
                0xA4CB7E33,
                0x62FB1341,
                0xCEE4C6E8,
                0xEF20CADA,
                0x36774C01,
                0xD07E9EFE,
                0x2BF11FB4,
                0x95DBDA4D,
                0xAE909198,
                0xEAAD8E71,
                0x6B93D5A0,
                0xD08ED1D0,
                0xAFC725E0,
                0x8E3C5B2F,
                0x8E7594B7,
                0x8FF6E2FB,
                0xF2122B64,
                0x8888B812,
                0x900DF01C,
                0x4FAD5EA0,
                0x688FC31C,
                0xD1CFF191,
                0xB3A8C1AD,
                0x2F2F2218,
                0xBE0E1777,
                0xEA752DFE,
                0x8B021FA1,
                0xE5A0CC0F,
                0xB56F74E8,
                0x18ACF3D6,
                0xCE89E299,
                0xB4A84FE0,
                0xFD13E0B7,
                0x7CC43B81,
                0xD2ADA8D9,
                0x165FA266,
                0x80957705,
                0x93CC7314,
                0x211A1477,
                0xE6AD2065,
                0x77B5FA86,
                0xC75442F5,
                0xFB9D35CF,
                0xEBCDAF0C,
                0x7B3E89A0,
                0xD6411BD3,
                0xAE1E7E49,
                0x00250E2D,
                0x2071B35E,
                0x226800BB,
                0x57B8E0AF,
                0x2464369B,
                0xF009B91E,
                0x5563911D,
                0x59DFA6AA,
                0x78C14389,
                0xD95A537F,
                0x207D5BA2,
                0x02E5B9C5,
                0x83260376,
                0x6295CFA9,
                0x11C81968,
                0x4E734A41,
                0xB3472DCA,
                0x7B14A94A,
                0x1B510052,
                0x9A532915,
                0xD60F573F,
                0xBC9BC6E4,
                0x2B60A476,
                0x81E67400,
                0x08BA6FB5,
                0x571BE91F,
                0xF296EC6B,
                0x2A0DD915,
                0xB6636521,
                0xE7B9F9B6,
                0xFF34052E,
                0xC5855664,
                0x53B02D5D,
                0xA99F8FA1,
                0x08BA4799,
                0x6E85076A
            ],
            [
                0x4B7A70E9,
                0xB5B32944,
                0xDB75092E,
                0xC4192623,
                0xAD6EA6B0,
                0x49A7DF7D,
                0x9CEE60B8,
                0x8FEDB266,
                0xECAA8C71,
                0x699A17FF,
                0x5664526C,
                0xC2B19EE1,
                0x193602A5,
                0x75094C29,
                0xA0591340,
                0xE4183A3E,
                0x3F54989A,
                0x5B429D65,
                0x6B8FE4D6,
                0x99F73FD6,
                0xA1D29C07,
                0xEFE830F5,
                0x4D2D38E6,
                0xF0255DC1,
                0x4CDD2086,
                0x8470EB26,
                0x6382E9C6,
                0x021ECC5E,
                0x09686B3F,
                0x3EBAEFC9,
                0x3C971814,
                0x6B6A70A1,
                0x687F3584,
                0x52A0E286,
                0xB79C5305,
                0xAA500737,
                0x3E07841C,
                0x7FDEAE5C,
                0x8E7D44EC,
                0x5716F2B8,
                0xB03ADA37,
                0xF0500C0D,
                0xF01C1F04,
                0x0200B3FF,
                0xAE0CF51A,
                0x3CB574B2,
                0x25837A58,
                0xDC0921BD,
                0xD19113F9,
                0x7CA92FF6,
                0x94324773,
                0x22F54701,
                0x3AE5E581,
                0x37C2DADC,
                0xC8B57634,
                0x9AF3DDA7,
                0xA9446146,
                0x0FD0030E,
                0xECC8C73E,
                0xA4751E41,
                0xE238CD99,
                0x3BEA0E2F,
                0x3280BBA1,
                0x183EB331,
                0x4E548B38,
                0x4F6DB908,
                0x6F420D03,
                0xF60A04BF,
                0x2CB81290,
                0x24977C79,
                0x5679B072,
                0xBCAF89AF,
                0xDE9A771F,
                0xD9930810,
                0xB38BAE12,
                0xDCCF3F2E,
                0x5512721F,
                0x2E6B7124,
                0x501ADDE6,
                0x9F84CD87,
                0x7A584718,
                0x7408DA17,
                0xBC9F9ABC,
                0xE94B7D8C,
                0xEC7AEC3A,
                0xDB851DFA,
                0x63094366,
                0xC464C3D2,
                0xEF1C1847,
                0x3215D908,
                0xDD433B37,
                0x24C2BA16,
                0x12A14D43,
                0x2A65C451,
                0x50940002,
                0x133AE4DD,
                0x71DFF89E,
                0x10314E55,
                0x81AC77D6,
                0x5F11199B,
                0x043556F1,
                0xD7A3C76B,
                0x3C11183B,
                0x5924A509,
                0xF28FE6ED,
                0x97F1FBFA,
                0x9EBABF2C,
                0x1E153C6E,
                0x86E34570,
                0xEAE96FB1,
                0x860E5E0A,
                0x5A3E2AB3,
                0x771FE71C,
                0x4E3D06FA,
                0x2965DCB9,
                0x99E71D0F,
                0x803E89D6,
                0x5266C825,
                0x2E4CC978,
                0x9C10B36A,
                0xC6150EBA,
                0x94E2EA78,
                0xA5FC3C53,
                0x1E0A2DF4,
                0xF2F74EA7,
                0x361D2B3D,
                0x1939260F,
                0x19C27960,
                0x5223A708,
                0xF71312B6,
                0xEBADFE6E,
                0xEAC31F66,
                0xE3BC4595,
                0xA67BC883,
                0xB17F37D1,
                0x018CFF28,
                0xC332DDEF,
                0xBE6C5AA5,
                0x65582185,
                0x68AB9802,
                0xEECEA50F,
                0xDB2F953B,
                0x2AEF7DAD,
                0x5B6E2F84,
                0x1521B628,
                0x29076170,
                0xECDD4775,
                0x619F1510,
                0x13CCA830,
                0xEB61BD96,
                0x0334FE1E,
                0xAA0363CF,
                0xB5735C90,
                0x4C70A239,
                0xD59E9E0B,
                0xCBAADE14,
                0xEECC86BC,
                0x60622CA7,
                0x9CAB5CAB,
                0xB2F3846E,
                0x648B1EAF,
                0x19BDF0CA,
                0xA02369B9,
                0x655ABB50,
                0x40685A32,
                0x3C2AB4B3,
                0x319EE9D5,
                0xC021B8F7,
                0x9B540B19,
                0x875FA099,
                0x95F7997E,
                0x623D7DA8,
                0xF837889A,
                0x97E32D77,
                0x11ED935F,
                0x16681281,
                0x0E358829,
                0xC7E61FD6,
                0x96DEDFA1,
                0x7858BA99,
                0x57F584A5,
                0x1B227263,
                0x9B83C3FF,
                0x1AC24696,
                0xCDB30AEB,
                0x532E3054,
                0x8FD948E4,
                0x6DBC3128,
                0x58EBF2EF,
                0x34C6FFEA,
                0xFE28ED61,
                0xEE7C3C73,
                0x5D4A14D9,
                0xE864B7E3,
                0x42105D14,
                0x203E13E0,
                0x45EEE2B6,
                0xA3AAABEA,
                0xDB6C4F15,
                0xFACB4FD0,
                0xC742F442,
                0xEF6ABBB5,
                0x654F3B1D,
                0x41CD2105,
                0xD81E799E,
                0x86854DC7,
                0xE44B476A,
                0x3D816250,
                0xCF62A1F2,
                0x5B8D2646,
                0xFC8883A0,
                0xC1C7B6A3,
                0x7F1524C3,
                0x69CB7492,
                0x47848A0B,
                0x5692B285,
                0x095BBF00,
                0xAD19489D,
                0x1462B174,
                0x23820E00,
                0x58428D2A,
                0x0C55F5EA,
                0x1DADF43E,
                0x233F7061,
                0x3372F092,
                0x8D937E41,
                0xD65FECF1,
                0x6C223BDB,
                0x7CDE3759,
                0xCBEE7460,
                0x4085F2A7,
                0xCE77326E,
                0xA6078084,
                0x19F8509E,
                0xE8EFD855,
                0x61D99735,
                0xA969A7AA,
                0xC50C06C2,
                0x5A04ABFC,
                0x800BCADC,
                0x9E447A2E,
                0xC3453484,
                0xFDD56705,
                0x0E1E9EC9,
                0xDB73DBD3,
                0x105588CD,
                0x675FDA79,
                0xE3674340,
                0xC5C43465,
                0x713E38D8,
                0x3D28F89E,
                0xF16DFF20,
                0x153E21E7,
                0x8FB03D4A,
                0xE6E39F2B,
                0xDB83ADF7
            ],
            [
                0xE93D5A68,
                0x948140F7,
                0xF64C261C,
                0x94692934,
                0x411520F7,
                0x7602D4F7,
                0xBCF46B2E,
                0xD4A20068,
                0xD4082471,
                0x3320F46A,
                0x43B7D4B7,
                0x500061AF,
                0x1E39F62E,
                0x97244546,
                0x14214F74,
                0xBF8B8840,
                0x4D95FC1D,
                0x96B591AF,
                0x70F4DDD3,
                0x66A02F45,
                0xBFBC09EC,
                0x03BD9785,
                0x7FAC6DD0,
                0x31CB8504,
                0x96EB27B3,
                0x55FD3941,
                0xDA2547E6,
                0xABCA0A9A,
                0x28507825,
                0x530429F4,
                0x0A2C86DA,
                0xE9B66DFB,
                0x68DC1462,
                0xD7486900,
                0x680EC0A4,
                0x27A18DEE,
                0x4F3FFEA2,
                0xE887AD8C,
                0xB58CE006,
                0x7AF4D6B6,
                0xAACE1E7C,
                0xD3375FEC,
                0xCE78A399,
                0x406B2A42,
                0x20FE9E35,
                0xD9F385B9,
                0xEE39D7AB,
                0x3B124E8B,
                0x1DC9FAF7,
                0x4B6D1856,
                0x26A36631,
                0xEAE397B2,
                0x3A6EFA74,
                0xDD5B4332,
                0x6841E7F7,
                0xCA7820FB,
                0xFB0AF54E,
                0xD8FEB397,
                0x454056AC,
                0xBA489527,
                0x55533A3A,
                0x20838D87,
                0xFE6BA9B7,
                0xD096954B,
                0x55A867BC,
                0xA1159A58,
                0xCCA92963,
                0x99E1DB33,
                0xA62A4A56,
                0x3F3125F9,
                0x5EF47E1C,
                0x9029317C,
                0xFDF8E802,
                0x04272F70,
                0x80BB155C,
                0x05282CE3,
                0x95C11548,
                0xE4C66D22,
                0x48C1133F,
                0xC70F86DC,
                0x07F9C9EE,
                0x41041F0F,
                0x404779A4,
                0x5D886E17,
                0x325F51EB,
                0xD59BC0D1,
                0xF2BCC18F,
                0x41113564,
                0x257B7834,
                0x602A9C60,
                0xDFF8E8A3,
                0x1F636C1B,
                0x0E12B4C2,
                0x02E1329E,
                0xAF664FD1,
                0xCAD18115,
                0x6B2395E0,
                0x333E92E1,
                0x3B240B62,
                0xEEBEB922,
                0x85B2A20E,
                0xE6BA0D99,
                0xDE720C8C,
                0x2DA2F728,
                0xD0127845,
                0x95B794FD,
                0x647D0862,
                0xE7CCF5F0,
                0x5449A36F,
                0x877D48FA,
                0xC39DFD27,
                0xF33E8D1E,
                0x0A476341,
                0x992EFF74,
                0x3A6F6EAB,
                0xF4F8FD37,
                0xA812DC60,
                0xA1EBDDF8,
                0x991BE14C,
                0xDB6E6B0D,
                0xC67B5510,
                0x6D672C37,
                0x2765D43B,
                0xDCD0E804,
                0xF1290DC7,
                0xCC00FFA3,
                0xB5390F92,
                0x690FED0B,
                0x667B9FFB,
                0xCEDB7D9C,
                0xA091CF0B,
                0xD9155EA3,
                0xBB132F88,
                0x515BAD24,
                0x7B9479BF,
                0x763BD6EB,
                0x37392EB3,
                0xCC115979,
                0x8026E297,
                0xF42E312D,
                0x6842ADA7,
                0xC66A2B3B,
                0x12754CCC,
                0x782EF11C,
                0x6A124237,
                0xB79251E7,
                0x06A1BBE6,
                0x4BFB6350,
                0x1A6B1018,
                0x11CAEDFA,
                0x3D25BDD8,
                0xE2E1C3C9,
                0x44421659,
                0x0A121386,
                0xD90CEC6E,
                0xD5ABEA2A,
                0x64AF674E,
                0xDA86A85F,
                0xBEBFE988,
                0x64E4C3FE,
                0x9DBC8057,
                0xF0F7C086,
                0x60787BF8,
                0x6003604D,
                0xD1FD8346,
                0xF6381FB0,
                0x7745AE04,
                0xD736FCCC,
                0x83426B33,
                0xF01EAB71,
                0xB0804187,
                0x3C005E5F,
                0x77A057BE,
                0xBDE8AE24,
                0x55464299,
                0xBF582E61,
                0x4E58F48F,
                0xF2DDFDA2,
                0xF474EF38,
                0x8789BDC2,
                0x5366F9C3,
                0xC8B38E74,
                0xB475F255,
                0x46FCD9B9,
                0x7AEB2661,
                0x8B1DDF84,
                0x846A0E79,
                0x915F95E2,
                0x466E598E,
                0x20B45770,
                0x8CD55591,
                0xC902DE4C,
                0xB90BACE1,
                0xBB8205D0,
                0x11A86248,
                0x7574A99E,
                0xB77F19B6,
                0xE0A9DC09,
                0x662D09A1,
                0xC4324633,
                0xE85A1F02,
                0x09F0BE8C,
                0x4A99A025,
                0x1D6EFE10,
                0x1AB93D1D,
                0x0BA5A4DF,
                0xA186F20F,
                0x2868F169,
                0xDCB7DA83,
                0x573906FE,
                0xA1E2CE9B,
                0x4FCD7F52,
                0x50115E01,
                0xA70683FA,
                0xA002B5C4,
                0x0DE6D027,
                0x9AF88C27,
                0x773F8641,
                0xC3604C06,
                0x61A806B5,
                0xF0177A28,
                0xC0F586E0,
                0x006058AA,
                0x30DC7D62,
                0x11E69ED7,
                0x2338EA63,
                0x53C2DD94,
                0xC2C21634,
                0xBBCBEE56,
                0x90BCB6DE,
                0xEBFC7DA1,
                0xCE591D76,
                0x6F05E409,
                0x4B7C0188,
                0x39720A3D,
                0x7C927C24,
                0x86E3725F,
                0x724D9DB9,
                0x1AC15BB4,
                0xD39EB8FC,
                0xED545578,
                0x08FCA5B5,
                0xD83D7CD3,
                0x4DAD0FC4,
                0x1E50EF5E,
                0xB161E6F8,
                0xA28514D9,
                0x6C51133C,
                0x6FD5C7E7,
                0x56E14EC4,
                0x362ABFCE,
                0xDDC6C837,
                0xD79A3234,
                0x92638212,
                0x670EFA8E,
                0x406000E0
            ],
            [
                0x3A39CE37,
                0xD3FAF5CF,
                0xABC27737,
                0x5AC52D1B,
                0x5CB0679E,
                0x4FA33742,
                0xD3822740,
                0x99BC9BBE,
                0xD5118E9D,
                0xBF0F7315,
                0xD62D1C7E,
                0xC700C47B,
                0xB78C1B6B,
                0x21A19045,
                0xB26EB1BE,
                0x6A366EB4,
                0x5748AB2F,
                0xBC946E79,
                0xC6A376D2,
                0x6549C2C8,
                0x530FF8EE,
                0x468DDE7D,
                0xD5730A1D,
                0x4CD04DC6,
                0x2939BBDB,
                0xA9BA4650,
                0xAC9526E8,
                0xBE5EE304,
                0xA1FAD5F0,
                0x6A2D519A,
                0x63EF8CE2,
                0x9A86EE22,
                0xC089C2B8,
                0x43242EF6,
                0xA51E03AA,
                0x9CF2D0A4,
                0x83C061BA,
                0x9BE96A4D,
                0x8FE51550,
                0xBA645BD6,
                0x2826A2F9,
                0xA73A3AE1,
                0x4BA99586,
                0xEF5562E9,
                0xC72FEFD3,
                0xF752F7DA,
                0x3F046F69,
                0x77FA0A59,
                0x80E4A915,
                0x87B08601,
                0x9B09E6AD,
                0x3B3EE593,
                0xE990FD5A,
                0x9E34D797,
                0x2CF0B7D9,
                0x022B8B51,
                0x96D5AC3A,
                0x017DA67D,
                0xD1CF3ED6,
                0x7C7D2D28,
                0x1F9F25CF,
                0xADF2B89B,
                0x5AD6B472,
                0x5A88F54C,
                0xE029AC71,
                0xE019A5E6,
                0x47B0ACFD,
                0xED93FA9B,
                0xE8D3C48D,
                0x283B57CC,
                0xF8D56629,
                0x79132E28,
                0x785F0191,
                0xED756055,
                0xF7960E44,
                0xE3D35E8C,
                0x15056DD4,
                0x88F46DBA,
                0x03A16125,
                0x0564F0BD,
                0xC3EB9E15,
                0x3C9057A2,
                0x97271AEC,
                0xA93A072A,
                0x1B3F6D9B,
                0x1E6321F5,
                0xF59C66FB,
                0x26DCF319,
                0x7533D928,
                0xB155FDF5,
                0x03563482,
                0x8ABA3CBB,
                0x28517711,
                0xC20AD9F8,
                0xABCC5167,
                0xCCAD925F,
                0x4DE81751,
                0x3830DC8E,
                0x379D5862,
                0x9320F991,
                0xEA7A90C2,
                0xFB3E7BCE,
                0x5121CE64,
                0x774FBE32,
                0xA8B6E37E,
                0xC3293D46,
                0x48DE5369,
                0x6413E680,
                0xA2AE0810,
                0xDD6DB224,
                0x69852DFD,
                0x09072166,
                0xB39A460A,
                0x6445C0DD,
                0x586CDECF,
                0x1C20C8AE,
                0x5BBEF7DD,
                0x1B588D40,
                0xCCD2017F,
                0x6BB4E3BB,
                0xDDA26A7E,
                0x3A59FF45,
                0x3E350A44,
                0xBCB4CDD5,
                0x72EACEA8,
                0xFA6484BB,
                0x8D6612AE,
                0xBF3C6F47,
                0xD29BE463,
                0x542F5D9E,
                0xAEC2771B,
                0xF64E6370,
                0x740E0D8D,
                0xE75B1357,
                0xF8721671,
                0xAF537D5D,
                0x4040CB08,
                0x4EB4E2CC,
                0x34D2466A,
                0x0115AF84,
                0xE1B00428,
                0x95983A1D,
                0x06B89FB4,
                0xCE6EA048,
                0x6F3F3B82,
                0x3520AB82,
                0x011A1D4B,
                0x277227F8,
                0x611560B1,
                0xE7933FDC,
                0xBB3A792B,
                0x344525BD,
                0xA08839E1,
                0x51CE794B,
                0x2F32C9B7,
                0xA01FBAC9,
                0xE01CC87E,
                0xBCC7D1F6,
                0xCF0111C3,
                0xA1E8AAC7,
                0x1A908749,
                0xD44FBD9A,
                0xD0DADECB,
                0xD50ADA38,
                0x0339C32A,
                0xC6913667,
                0x8DF9317C,
                0xE0B12B4F,
                0xF79E59B7,
                0x43F5BB3A,
                0xF2D519FF,
                0x27D9459C,
                0xBF97222C,
                0x15E6FC2A,
                0x0F91FC71,
                0x9B941525,
                0xFAE59361,
                0xCEB69CEB,
                0xC2A86459,
                0x12BAA8D1,
                0xB6C1075E,
                0xE3056A0C,
                0x10D25065,
                0xCB03A442,
                0xE0EC6E0E,
                0x1698DB3B,
                0x4C98A0BE,
                0x3278E964,
                0x9F1F9532,
                0xE0D392DF,
                0xD3A0342B,
                0x8971F21E,
                0x1B0A7441,
                0x4BA3348C,
                0xC5BE7120,
                0xC37632D8,
                0xDF359F8D,
                0x9B992F2E,
                0xE60B6F47,
                0x0FE3F11D,
                0xE54CDA54,
                0x1EDAD891,
                0xCE6279CF,
                0xCD3E7E6F,
                0x1618B166,
                0xFD2C1D05,
                0x848FD2C5,
                0xF6FB2299,
                0xF523F357,
                0xA6327623,
                0x93A83531,
                0x56CCCD02,
                0xACF08162,
                0x5A75EBB5,
                0x6E163697,
                0x88D273CC,
                0xDE966292,
                0x81B949D0,
                0x4C50901B,
                0x71C65614,
                0xE6C6C7BD,
                0x327A140A,
                0x45E1D006,
                0xC3F27B9A,
                0xC9AA53FD,
                0x62A80F00,
                0xBB25BFE2,
                0x35BDD2F6,
                0x71126905,
                0xB2040222,
                0xB6CBCF7C,
                0xCD769C2B,
                0x53113EC0,
                0x1640E3D3,
                0x38ABBD60,
                0x2547ADF0,
                0xBA38209C,
                0xF746CE76,
                0x77AFA1C5,
                0x20756060,
                0x85CBFE4E,
                0x8AE88DD8,
                0x7AAAF9B0,
                0x4CF9AA7E,
                0x1948C25C,
                0x02FB8A8C,
                0x01C36AE4,
                0xD6EBE1F9,
                0x90D4F869,
                0xA65CDEA0,
                0x3F09252D,
                0xC208E69F,
                0xB74E6132,
                0xCE77E25B,
                0x578FDFE3,
                0x3AC372E6
            ]
        ];
        var BLOWFISH_CTX = {
            pbox: [],
            sbox: []
        };
        function F(ctx, x) {
            let a = x >> 24 & 0xFF;
            let b = x >> 16 & 0xFF;
            let c = x >> 8 & 0xFF;
            let d = x & 0xFF;
            let y = ctx.sbox[0][a] + ctx.sbox[1][b];
            y = y ^ ctx.sbox[2][c];
            y = y + ctx.sbox[3][d];
            return y;
        }
        function BlowFish_Encrypt(ctx, left, right) {
            let Xl = left;
            let Xr = right;
            let temp;
            for(let i = 0; i < N; ++i){
                Xl = Xl ^ ctx.pbox[i];
                Xr = F(ctx, Xl) ^ Xr;
                temp = Xl;
                Xl = Xr;
                Xr = temp;
            }
            temp = Xl;
            Xl = Xr;
            Xr = temp;
            Xr = Xr ^ ctx.pbox[N];
            Xl = Xl ^ ctx.pbox[N + 1];
            return {
                left: Xl,
                right: Xr
            };
        }
        function BlowFish_Decrypt(ctx, left, right) {
            let Xl = left;
            let Xr = right;
            let temp;
            for(let i = N + 1; i > 1; --i){
                Xl = Xl ^ ctx.pbox[i];
                Xr = F(ctx, Xl) ^ Xr;
                temp = Xl;
                Xl = Xr;
                Xr = temp;
            }
            temp = Xl;
            Xl = Xr;
            Xr = temp;
            Xr = Xr ^ ctx.pbox[1];
            Xl = Xl ^ ctx.pbox[0];
            return {
                left: Xl,
                right: Xr
            };
        }
        /**
	     * Initialization ctx's pbox and sbox.
	     *
	     * @param {Object} ctx The object has pbox and sbox.
	     * @param {Array} key An array of 32-bit words.
	     * @param {int} keysize The length of the key.
	     *
	     * @example
	     *
	     *     BlowFishInit(BLOWFISH_CTX, key, 128/32);
	     */ function BlowFishInit(ctx, key, keysize) {
            for(let Row = 0; Row < 4; Row++){
                ctx.sbox[Row] = [];
                for(let Col = 0; Col < 256; Col++)ctx.sbox[Row][Col] = ORIG_S[Row][Col];
            }
            let keyIndex = 0;
            for(let index = 0; index < N + 2; index++){
                ctx.pbox[index] = ORIG_P[index] ^ key[keyIndex];
                keyIndex++;
                if (keyIndex >= keysize) keyIndex = 0;
            }
            let Data1 = 0;
            let Data2 = 0;
            let res = 0;
            for(let i = 0; i < N + 2; i += 2){
                res = BlowFish_Encrypt(ctx, Data1, Data2);
                Data1 = res.left;
                Data2 = res.right;
                ctx.pbox[i] = Data1;
                ctx.pbox[i + 1] = Data2;
            }
            for(let i = 0; i < 4; i++)for(let j = 0; j < 256; j += 2){
                res = BlowFish_Encrypt(ctx, Data1, Data2);
                Data1 = res.left;
                Data2 = res.right;
                ctx.sbox[i][j] = Data1;
                ctx.sbox[i][j + 1] = Data2;
            }
            return true;
        }
        /**
	     * Blowfish block cipher algorithm.
	     */ var Blowfish = C_algo.Blowfish = BlockCipher.extend({
            _doReset: function() {
                // Skip reset of nRounds has been set before and key did not change
                if (this._keyPriorReset === this._key) return;
                // Shortcuts
                var key = this._keyPriorReset = this._key;
                var keyWords = key.words;
                var keySize = key.sigBytes / 4;
                //Initialization pbox and sbox
                BlowFishInit(BLOWFISH_CTX, keyWords, keySize);
            },
            encryptBlock: function(M, offset) {
                var res = BlowFish_Encrypt(BLOWFISH_CTX, M[offset], M[offset + 1]);
                M[offset] = res.left;
                M[offset + 1] = res.right;
            },
            decryptBlock: function(M, offset) {
                var res = BlowFish_Decrypt(BLOWFISH_CTX, M[offset], M[offset + 1]);
                M[offset] = res.left;
                M[offset + 1] = res.right;
            },
            blockSize: 2,
            keySize: 4,
            ivSize: 2
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Blowfish.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Blowfish.decrypt(ciphertext, key, cfg);
	     */ C.Blowfish = BlockCipher._createHelper(Blowfish);
    })();
    return CryptoJS.Blowfish;
});

});


parcelRegister("ciGRa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hash = void 0;

var $cWKoG = parcelRequire("cWKoG");

var $4ujqV = parcelRequire("4ujqV");

var $gzLuY = parcelRequire("gzLuY");
class $8f4868de9fcf9a7b$var$Hash {
    static sha256(data) {
        return new Uint8Array(new $cWKoG.sha256().update(data).digest());
    }
    static keccak256(data) {
        return $gzLuY.Buffer.from($4ujqV.keccak256(data).replace("0x", ""), "hex");
    }
    static truncHashPortion(str, firstCharCount = str.length, endCharCount = 0) {
        return str.substring(0, firstCharCount) + "\u2026" + str.substring(str.length - endCharCount, str.length);
    }
}
module.exports.Hash = $8f4868de9fcf9a7b$var$Hash;

});
parcelRegister("4ujqV", function(module, exports) {

$parcel$export(module.exports, "keccak256", function () { return $344909d1f36347b2$export$f8151fce47ad1c35; });

var $cCjFr = parcelRequire("cCjFr");

var $j2rU8 = parcelRequire("j2rU8");
"use strict";
function $344909d1f36347b2$export$f8151fce47ad1c35(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($cCjFr))).keccak_256((0, $j2rU8.arrayify)(data));
}

});
parcelRegister("cCjFr", function(module, exports) {

var $a8i8g = parcelRequire("a8i8g");
/**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2018
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    "use strict";
    var INPUT_ERROR = "input is invalid type";
    var FINALIZE_ERROR = "finalize already called";
    var WINDOW = typeof window === "object";
    var root = WINDOW ? window : {};
    if (root.JS_SHA3_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === "object";
    var NODE_JS = !root.JS_SHA3_NO_NODE_JS && typeof $a8i8g === "object" && $a8i8g.versions && $a8i8g.versions.node;
    if (NODE_JS) root = $parcel$global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_SHA3_NO_COMMON_JS && true && module.exports;
    var AMD = typeof define === "function" && define.amd;
    var ARRAY_BUFFER = !root.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer !== "undefined";
    var HEX_CHARS = "0123456789abcdef".split("");
    var SHAKE_PADDING = [
        31,
        7936,
        2031616,
        520093696
    ];
    var CSHAKE_PADDING = [
        4,
        1024,
        262144,
        67108864
    ];
    var KECCAK_PADDING = [
        1,
        256,
        65536,
        16777216
    ];
    var PADDING = [
        6,
        1536,
        393216,
        100663296
    ];
    var SHIFT = [
        0,
        8,
        16,
        24
    ];
    var RC = [
        1,
        0,
        32898,
        0,
        32906,
        2147483648,
        2147516416,
        2147483648,
        32907,
        0,
        2147483649,
        0,
        2147516545,
        2147483648,
        32777,
        2147483648,
        138,
        0,
        136,
        0,
        2147516425,
        0,
        2147483658,
        0,
        2147516555,
        0,
        139,
        2147483648,
        32905,
        2147483648,
        32771,
        2147483648,
        32770,
        2147483648,
        128,
        2147483648,
        32778,
        0,
        2147483658,
        2147483648,
        2147516545,
        2147483648,
        32896,
        2147483648,
        2147483649,
        0,
        2147516424,
        2147483648
    ];
    var BITS = [
        224,
        256,
        384,
        512
    ];
    var SHAKE_BITS = [
        128,
        256
    ];
    var OUTPUT_TYPES = [
        "hex",
        "buffer",
        "arrayBuffer",
        "array",
        "digest"
    ];
    var CSHAKE_BYTEPAD = {
        "128": 168,
        "256": 136
    };
    if (root.JS_SHA3_NO_NODE_JS || !Array.isArray) Array.isArray = function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    if (ARRAY_BUFFER && (root.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) ArrayBuffer.isView = function(obj) {
        return typeof obj === "object" && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
    var createOutputMethod = function(bits, padding, outputType) {
        return function(message) {
            return new Keccak(bits, padding, bits).update(message)[outputType]();
        };
    };
    var createShakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits) {
            return new Keccak(bits, padding, outputBits).update(message)[outputType]();
        };
    };
    var createCshakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits, n, s) {
            return methods["cshake" + bits].update(message, outputBits, n, s)[outputType]();
        };
    };
    var createKmacOutputMethod = function(bits, padding, outputType) {
        return function(key, message, outputBits, s) {
            return methods["kmac" + bits].update(key, message, outputBits, s)[outputType]();
        };
    };
    var createOutputMethods = function(method, createMethod, bits, padding) {
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createMethod(bits, padding, type);
        }
        return method;
    };
    var createMethod = function(bits, padding) {
        var method = createOutputMethod(bits, padding, "hex");
        method.create = function() {
            return new Keccak(bits, padding, bits);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        return createOutputMethods(method, createOutputMethod, bits, padding);
    };
    var createShakeMethod = function(bits, padding) {
        var method = createShakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits) {
            return new Keccak(bits, padding, outputBits);
        };
        method.update = function(message, outputBits) {
            return method.create(outputBits).update(message);
        };
        return createOutputMethods(method, createShakeOutputMethod, bits, padding);
    };
    var createCshakeMethod = function(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createCshakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits, n, s) {
            if (!n && !s) return methods["shake" + bits].create(outputBits);
            else return new Keccak(bits, padding, outputBits).bytepad([
                n,
                s
            ], w);
        };
        method.update = function(message, outputBits, n, s) {
            return method.create(outputBits, n, s).update(message);
        };
        return createOutputMethods(method, createCshakeOutputMethod, bits, padding);
    };
    var createKmacMethod = function(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createKmacOutputMethod(bits, padding, "hex");
        method.create = function(key, outputBits, s) {
            return new Kmac(bits, padding, outputBits).bytepad([
                "KMAC",
                s
            ], w).bytepad([
                key
            ], w);
        };
        method.update = function(key, message, outputBits, s) {
            return method.create(key, outputBits, s).update(message);
        };
        return createOutputMethods(method, createKmacOutputMethod, bits, padding);
    };
    var algorithms = [
        {
            name: "keccak",
            padding: KECCAK_PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "sha3",
            padding: PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "shake",
            padding: SHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createShakeMethod
        },
        {
            name: "cshake",
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createCshakeMethod
        },
        {
            name: "kmac",
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createKmacMethod
        }
    ];
    var methods = {}, methodNames = [];
    for(var i = 0; i < algorithms.length; ++i){
        var algorithm = algorithms[i];
        var bits = algorithm.bits;
        for(var j = 0; j < bits.length; ++j){
            var methodName = algorithm.name + "_" + bits[j];
            methodNames.push(methodName);
            methods[methodName] = algorithm.createMethod(bits[j], algorithm.padding);
            if (algorithm.name !== "sha3") {
                var newMethodName = algorithm.name + bits[j];
                methodNames.push(newMethodName);
                methods[newMethodName] = methods[methodName];
            }
        }
    }
    function Keccak(bits, padding, outputBits) {
        this.blocks = [];
        this.s = [];
        this.padding = padding;
        this.outputBits = outputBits;
        this.reset = true;
        this.finalized = false;
        this.block = 0;
        this.start = 0;
        this.blockCount = 1600 - (bits << 1) >> 5;
        this.byteCount = this.blockCount << 2;
        this.outputBlocks = outputBits >> 5;
        this.extraBytes = (outputBits & 31) >> 3;
        for(var i = 0; i < 50; ++i)this.s[i] = 0;
    }
    Keccak.prototype.update = function(message) {
        if (this.finalized) throw new Error(FINALIZE_ERROR);
        var notString, type = typeof message;
        if (type !== "string") {
            if (type === "object") {
                if (message === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) message = new Uint8Array(message);
                else if (!Array.isArray(message)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var blocks = this.blocks, byteCount = this.byteCount, length = message.length, blockCount = this.blockCount, index = 0, s = this.s, i, code;
        while(index < length){
            if (this.reset) {
                this.reset = false;
                blocks[0] = this.block;
                for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
            }
            if (notString) for(i = this.start; index < length && i < byteCount; ++index)blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < byteCount; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            if (i >= byteCount) {
                this.start = i - byteCount;
                this.block = blocks[blockCount];
                for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
                f(s);
                this.reset = true;
            } else this.start = i;
        }
        return this;
    };
    Keccak.prototype.encode = function(x, right) {
        var o = x & 255, n = 1;
        var bytes = [
            o
        ];
        x = x >> 8;
        o = x & 255;
        while(o > 0){
            bytes.unshift(o);
            x = x >> 8;
            o = x & 255;
            ++n;
        }
        if (right) bytes.push(n);
        else bytes.unshift(n);
        this.update(bytes);
        return bytes.length;
    };
    Keccak.prototype.encodeString = function(str) {
        var notString, type = typeof str;
        if (type !== "string") {
            if (type === "object") {
                if (str === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && str.constructor === ArrayBuffer) str = new Uint8Array(str);
                else if (!Array.isArray(str)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(str)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var bytes = 0, length = str.length;
        if (notString) bytes = length;
        else for(var i = 0; i < str.length; ++i){
            var code = str.charCodeAt(i);
            if (code < 0x80) bytes += 1;
            else if (code < 0x800) bytes += 2;
            else if (code < 0xd800 || code >= 0xe000) bytes += 3;
            else {
                code = 0x10000 + ((code & 0x3ff) << 10 | str.charCodeAt(++i) & 0x3ff);
                bytes += 4;
            }
        }
        bytes += this.encode(bytes * 8);
        this.update(str);
        return bytes;
    };
    Keccak.prototype.bytepad = function(strs, w) {
        var bytes = this.encode(w);
        for(var i = 0; i < strs.length; ++i)bytes += this.encodeString(strs[i]);
        var paddingBytes = w - bytes % w;
        var zeros = [];
        zeros.length = paddingBytes;
        this.update(zeros);
        return this;
    };
    Keccak.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks = this.blocks, i = this.lastByteIndex, blockCount = this.blockCount, s = this.s;
        blocks[i >> 2] |= this.padding[i & 3];
        if (this.lastByteIndex === this.byteCount) {
            blocks[0] = blocks[blockCount];
            for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
        }
        blocks[blockCount - 1] |= 0x80000000;
        for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
        f(s);
    };
    Keccak.prototype.toString = Keccak.prototype.hex = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var hex = "", block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                block = s[i];
                hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F] + HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F] + HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F] + HEX_CHARS[block >> 28 & 0x0F] + HEX_CHARS[block >> 24 & 0x0F];
            }
            if (j % blockCount === 0) {
                f(s);
                i = 0;
            }
        }
        if (extraBytes) {
            block = s[i];
            hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F];
            if (extraBytes > 1) hex += HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F];
            if (extraBytes > 2) hex += HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F];
        }
        return hex;
    };
    Keccak.prototype.arrayBuffer = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var bytes = this.outputBits >> 3;
        var buffer;
        if (extraBytes) buffer = new ArrayBuffer(outputBlocks + 1 << 2);
        else buffer = new ArrayBuffer(bytes);
        var array = new Uint32Array(buffer);
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j)array[j] = s[i];
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            array[i] = s[i];
            buffer = buffer.slice(0, bytes);
        }
        return buffer;
    };
    Keccak.prototype.buffer = Keccak.prototype.arrayBuffer;
    Keccak.prototype.digest = Keccak.prototype.array = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var array = [], offset, block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                offset = j << 2;
                block = s[i];
                array[offset] = block & 0xFF;
                array[offset + 1] = block >> 8 & 0xFF;
                array[offset + 2] = block >> 16 & 0xFF;
                array[offset + 3] = block >> 24 & 0xFF;
            }
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            offset = j << 2;
            block = s[i];
            array[offset] = block & 0xFF;
            if (extraBytes > 1) array[offset + 1] = block >> 8 & 0xFF;
            if (extraBytes > 2) array[offset + 2] = block >> 16 & 0xFF;
        }
        return array;
    };
    function Kmac(bits, padding, outputBits) {
        Keccak.call(this, bits, padding, outputBits);
    }
    Kmac.prototype = new Keccak();
    Kmac.prototype.finalize = function() {
        this.encode(this.outputBits, true);
        return Keccak.prototype.finalize.call(this);
    };
    var f = function(s) {
        var h, l, n, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9, b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17, b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33, b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
        for(n = 0; n < 48; n += 2){
            c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
            c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
            c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
            c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
            c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
            c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
            c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
            c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
            c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
            c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
            h = c8 ^ (c2 << 1 | c3 >>> 31);
            l = c9 ^ (c3 << 1 | c2 >>> 31);
            s[0] ^= h;
            s[1] ^= l;
            s[10] ^= h;
            s[11] ^= l;
            s[20] ^= h;
            s[21] ^= l;
            s[30] ^= h;
            s[31] ^= l;
            s[40] ^= h;
            s[41] ^= l;
            h = c0 ^ (c4 << 1 | c5 >>> 31);
            l = c1 ^ (c5 << 1 | c4 >>> 31);
            s[2] ^= h;
            s[3] ^= l;
            s[12] ^= h;
            s[13] ^= l;
            s[22] ^= h;
            s[23] ^= l;
            s[32] ^= h;
            s[33] ^= l;
            s[42] ^= h;
            s[43] ^= l;
            h = c2 ^ (c6 << 1 | c7 >>> 31);
            l = c3 ^ (c7 << 1 | c6 >>> 31);
            s[4] ^= h;
            s[5] ^= l;
            s[14] ^= h;
            s[15] ^= l;
            s[24] ^= h;
            s[25] ^= l;
            s[34] ^= h;
            s[35] ^= l;
            s[44] ^= h;
            s[45] ^= l;
            h = c4 ^ (c8 << 1 | c9 >>> 31);
            l = c5 ^ (c9 << 1 | c8 >>> 31);
            s[6] ^= h;
            s[7] ^= l;
            s[16] ^= h;
            s[17] ^= l;
            s[26] ^= h;
            s[27] ^= l;
            s[36] ^= h;
            s[37] ^= l;
            s[46] ^= h;
            s[47] ^= l;
            h = c6 ^ (c0 << 1 | c1 >>> 31);
            l = c7 ^ (c1 << 1 | c0 >>> 31);
            s[8] ^= h;
            s[9] ^= l;
            s[18] ^= h;
            s[19] ^= l;
            s[28] ^= h;
            s[29] ^= l;
            s[38] ^= h;
            s[39] ^= l;
            s[48] ^= h;
            s[49] ^= l;
            b0 = s[0];
            b1 = s[1];
            b32 = s[11] << 4 | s[10] >>> 28;
            b33 = s[10] << 4 | s[11] >>> 28;
            b14 = s[20] << 3 | s[21] >>> 29;
            b15 = s[21] << 3 | s[20] >>> 29;
            b46 = s[31] << 9 | s[30] >>> 23;
            b47 = s[30] << 9 | s[31] >>> 23;
            b28 = s[40] << 18 | s[41] >>> 14;
            b29 = s[41] << 18 | s[40] >>> 14;
            b20 = s[2] << 1 | s[3] >>> 31;
            b21 = s[3] << 1 | s[2] >>> 31;
            b2 = s[13] << 12 | s[12] >>> 20;
            b3 = s[12] << 12 | s[13] >>> 20;
            b34 = s[22] << 10 | s[23] >>> 22;
            b35 = s[23] << 10 | s[22] >>> 22;
            b16 = s[33] << 13 | s[32] >>> 19;
            b17 = s[32] << 13 | s[33] >>> 19;
            b48 = s[42] << 2 | s[43] >>> 30;
            b49 = s[43] << 2 | s[42] >>> 30;
            b40 = s[5] << 30 | s[4] >>> 2;
            b41 = s[4] << 30 | s[5] >>> 2;
            b22 = s[14] << 6 | s[15] >>> 26;
            b23 = s[15] << 6 | s[14] >>> 26;
            b4 = s[25] << 11 | s[24] >>> 21;
            b5 = s[24] << 11 | s[25] >>> 21;
            b36 = s[34] << 15 | s[35] >>> 17;
            b37 = s[35] << 15 | s[34] >>> 17;
            b18 = s[45] << 29 | s[44] >>> 3;
            b19 = s[44] << 29 | s[45] >>> 3;
            b10 = s[6] << 28 | s[7] >>> 4;
            b11 = s[7] << 28 | s[6] >>> 4;
            b42 = s[17] << 23 | s[16] >>> 9;
            b43 = s[16] << 23 | s[17] >>> 9;
            b24 = s[26] << 25 | s[27] >>> 7;
            b25 = s[27] << 25 | s[26] >>> 7;
            b6 = s[36] << 21 | s[37] >>> 11;
            b7 = s[37] << 21 | s[36] >>> 11;
            b38 = s[47] << 24 | s[46] >>> 8;
            b39 = s[46] << 24 | s[47] >>> 8;
            b30 = s[8] << 27 | s[9] >>> 5;
            b31 = s[9] << 27 | s[8] >>> 5;
            b12 = s[18] << 20 | s[19] >>> 12;
            b13 = s[19] << 20 | s[18] >>> 12;
            b44 = s[29] << 7 | s[28] >>> 25;
            b45 = s[28] << 7 | s[29] >>> 25;
            b26 = s[38] << 8 | s[39] >>> 24;
            b27 = s[39] << 8 | s[38] >>> 24;
            b8 = s[48] << 14 | s[49] >>> 18;
            b9 = s[49] << 14 | s[48] >>> 18;
            s[0] = b0 ^ ~b2 & b4;
            s[1] = b1 ^ ~b3 & b5;
            s[10] = b10 ^ ~b12 & b14;
            s[11] = b11 ^ ~b13 & b15;
            s[20] = b20 ^ ~b22 & b24;
            s[21] = b21 ^ ~b23 & b25;
            s[30] = b30 ^ ~b32 & b34;
            s[31] = b31 ^ ~b33 & b35;
            s[40] = b40 ^ ~b42 & b44;
            s[41] = b41 ^ ~b43 & b45;
            s[2] = b2 ^ ~b4 & b6;
            s[3] = b3 ^ ~b5 & b7;
            s[12] = b12 ^ ~b14 & b16;
            s[13] = b13 ^ ~b15 & b17;
            s[22] = b22 ^ ~b24 & b26;
            s[23] = b23 ^ ~b25 & b27;
            s[32] = b32 ^ ~b34 & b36;
            s[33] = b33 ^ ~b35 & b37;
            s[42] = b42 ^ ~b44 & b46;
            s[43] = b43 ^ ~b45 & b47;
            s[4] = b4 ^ ~b6 & b8;
            s[5] = b5 ^ ~b7 & b9;
            s[14] = b14 ^ ~b16 & b18;
            s[15] = b15 ^ ~b17 & b19;
            s[24] = b24 ^ ~b26 & b28;
            s[25] = b25 ^ ~b27 & b29;
            s[34] = b34 ^ ~b36 & b38;
            s[35] = b35 ^ ~b37 & b39;
            s[44] = b44 ^ ~b46 & b48;
            s[45] = b45 ^ ~b47 & b49;
            s[6] = b6 ^ ~b8 & b0;
            s[7] = b7 ^ ~b9 & b1;
            s[16] = b16 ^ ~b18 & b10;
            s[17] = b17 ^ ~b19 & b11;
            s[26] = b26 ^ ~b28 & b20;
            s[27] = b27 ^ ~b29 & b21;
            s[36] = b36 ^ ~b38 & b30;
            s[37] = b37 ^ ~b39 & b31;
            s[46] = b46 ^ ~b48 & b40;
            s[47] = b47 ^ ~b49 & b41;
            s[8] = b8 ^ ~b0 & b2;
            s[9] = b9 ^ ~b1 & b3;
            s[18] = b18 ^ ~b10 & b12;
            s[19] = b19 ^ ~b11 & b13;
            s[28] = b28 ^ ~b20 & b22;
            s[29] = b29 ^ ~b21 & b23;
            s[38] = b38 ^ ~b30 & b32;
            s[39] = b39 ^ ~b31 & b33;
            s[48] = b48 ^ ~b40 & b42;
            s[49] = b49 ^ ~b41 & b43;
            s[0] ^= RC[n];
            s[1] ^= RC[n + 1];
        }
    };
    if (COMMON_JS) module.exports = methods;
    else {
        for(i = 0; i < methodNames.length; ++i)root[methodNames[i]] = methods[methodNames[i]];
        if (AMD) define(function() {
            return methods;
        });
    }
})();

});

parcelRegister("j2rU8", function(module, exports) {

$parcel$export(module.exports, "arrayify", function () { return $ddc3d9704a40b613$export$3131421a7d01b4fb; });

var $6M65e = parcelRequire("6M65e");

var $eraBF = parcelRequire("eraBF");
"use strict";
const $ddc3d9704a40b613$var$logger = new (0, $6M65e.Logger)((0, $eraBF.version));
///////////////////////////////
function $ddc3d9704a40b613$var$isHexable(value) {
    return !!value.toHexString;
}
function $ddc3d9704a40b613$var$addSlice(array) {
    if (array.slice) return array;
    array.slice = function() {
        const args = Array.prototype.slice.call(arguments);
        return $ddc3d9704a40b613$var$addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
    };
    return array;
}
function $ddc3d9704a40b613$export$9a14abb1a440cd5e(value) {
    return $ddc3d9704a40b613$export$b02a40aff8e4ad18(value) && !(value.length % 2) || $ddc3d9704a40b613$export$c6fabfbfd097fc30(value);
}
function $ddc3d9704a40b613$var$isInteger(value) {
    return typeof value === "number" && value == value && value % 1 === 0;
}
function $ddc3d9704a40b613$export$c6fabfbfd097fc30(value) {
    if (value == null) return false;
    if (value.constructor === Uint8Array) return true;
    if (typeof value === "string") return false;
    if (!$ddc3d9704a40b613$var$isInteger(value.length) || value.length < 0) return false;
    for(let i = 0; i < value.length; i++){
        const v = value[i];
        if (!$ddc3d9704a40b613$var$isInteger(v) || v < 0 || v >= 256) return false;
    }
    return true;
}
function $ddc3d9704a40b613$export$3131421a7d01b4fb(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $ddc3d9704a40b613$var$logger.checkSafeUint53(value, "invalid arrayify value");
        const result = [];
        while(value){
            result.unshift(value & 0xff);
            value = parseInt(String(value / 256));
        }
        if (result.length === 0) result.push(0);
        return $ddc3d9704a40b613$var$addSlice(new Uint8Array(result));
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($ddc3d9704a40b613$var$isHexable(value)) value = value.toHexString();
    if ($ddc3d9704a40b613$export$b02a40aff8e4ad18(value)) {
        let hex = value.substring(2);
        if (hex.length % 2) {
            if (options.hexPad === "left") hex = "0" + hex;
            else if (options.hexPad === "right") hex += "0";
            else $ddc3d9704a40b613$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        const result = [];
        for(let i = 0; i < hex.length; i += 2)result.push(parseInt(hex.substring(i, i + 2), 16));
        return $ddc3d9704a40b613$var$addSlice(new Uint8Array(result));
    }
    if ($ddc3d9704a40b613$export$c6fabfbfd097fc30(value)) return $ddc3d9704a40b613$var$addSlice(new Uint8Array(value));
    return $ddc3d9704a40b613$var$logger.throwArgumentError("invalid arrayify value", "value", value);
}
function $ddc3d9704a40b613$export$ee1b3e54f0441b22(items) {
    const objects = items.map((item)=>$ddc3d9704a40b613$export$3131421a7d01b4fb(item));
    const length = objects.reduce((accum, item)=>accum + item.length, 0);
    const result = new Uint8Array(length);
    objects.reduce((offset, object)=>{
        result.set(object, offset);
        return offset + object.length;
    }, 0);
    return $ddc3d9704a40b613$var$addSlice(result);
}
function $ddc3d9704a40b613$export$a8f4574d0e56446c(value) {
    let result = $ddc3d9704a40b613$export$3131421a7d01b4fb(value);
    if (result.length === 0) return result;
    // Find the first non-zero entry
    let start = 0;
    while(start < result.length && result[start] === 0)start++;
    // If we started with zeros, strip them
    if (start) result = result.slice(start);
    return result;
}
function $ddc3d9704a40b613$export$3cdc770bf8b2ed3d(value, length) {
    value = $ddc3d9704a40b613$export$3131421a7d01b4fb(value);
    if (value.length > length) $ddc3d9704a40b613$var$logger.throwArgumentError("value out of range", "value", arguments[0]);
    const result = new Uint8Array(length);
    result.set(value, length - value.length);
    return $ddc3d9704a40b613$var$addSlice(result);
}
function $ddc3d9704a40b613$export$b02a40aff8e4ad18(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (length && value.length !== 2 + 2 * length) return false;
    return true;
}
const $ddc3d9704a40b613$var$HexCharacters = "0123456789abcdef";
function $ddc3d9704a40b613$export$2b0d6b5fbe698c70(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $ddc3d9704a40b613$var$logger.checkSafeUint53(value, "invalid hexlify value");
        let hex = "";
        while(value){
            hex = $ddc3d9704a40b613$var$HexCharacters[value & 0xf] + hex;
            value = Math.floor(value / 16);
        }
        if (hex.length) {
            if (hex.length % 2) hex = "0" + hex;
            return "0x" + hex;
        }
        return "0x00";
    }
    if (typeof value === "bigint") {
        value = value.toString(16);
        if (value.length % 2) return "0x0" + value;
        return "0x" + value;
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($ddc3d9704a40b613$var$isHexable(value)) return value.toHexString();
    if ($ddc3d9704a40b613$export$b02a40aff8e4ad18(value)) {
        if (value.length % 2) {
            if (options.hexPad === "left") value = "0x0" + value.substring(2);
            else if (options.hexPad === "right") value += "0";
            else $ddc3d9704a40b613$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        return value.toLowerCase();
    }
    if ($ddc3d9704a40b613$export$c6fabfbfd097fc30(value)) {
        let result = "0x";
        for(let i = 0; i < value.length; i++){
            let v = value[i];
            result += $ddc3d9704a40b613$var$HexCharacters[(v & 0xf0) >> 4] + $ddc3d9704a40b613$var$HexCharacters[v & 0x0f];
        }
        return result;
    }
    return $ddc3d9704a40b613$var$logger.throwArgumentError("invalid hexlify value", "value", value);
}
function $ddc3d9704a40b613$export$13882f896d3c0683(data) {
    if (typeof data !== "string") data = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(data);
    else if (!$ddc3d9704a40b613$export$b02a40aff8e4ad18(data) || data.length % 2) return null;
    return (data.length - 2) / 2;
}
function $ddc3d9704a40b613$export$15da666eba198c18(data, offset, endOffset) {
    if (typeof data !== "string") data = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(data);
    else if (!$ddc3d9704a40b613$export$b02a40aff8e4ad18(data) || data.length % 2) $ddc3d9704a40b613$var$logger.throwArgumentError("invalid hexData", "value", data);
    offset = 2 + 2 * offset;
    if (endOffset != null) return "0x" + data.substring(offset, 2 + 2 * endOffset);
    return "0x" + data.substring(offset);
}
function $ddc3d9704a40b613$export$6d4b99629b38754a(items) {
    let result = "0x";
    items.forEach((item)=>{
        result += $ddc3d9704a40b613$export$2b0d6b5fbe698c70(item).substring(2);
    });
    return result;
}
function $ddc3d9704a40b613$export$6916af760a341dd3(value) {
    const trimmed = $ddc3d9704a40b613$export$967bc0082a978949($ddc3d9704a40b613$export$2b0d6b5fbe698c70(value, {
        hexPad: "left"
    }));
    if (trimmed === "0x") return "0x0";
    return trimmed;
}
function $ddc3d9704a40b613$export$967bc0082a978949(value) {
    if (typeof value !== "string") value = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(value);
    if (!$ddc3d9704a40b613$export$b02a40aff8e4ad18(value)) $ddc3d9704a40b613$var$logger.throwArgumentError("invalid hex string", "value", value);
    value = value.substring(2);
    let offset = 0;
    while(offset < value.length && value[offset] === "0")offset++;
    return "0x" + value.substring(offset);
}
function $ddc3d9704a40b613$export$e9c46a54370b47e8(value, length) {
    if (typeof value !== "string") value = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(value);
    else if (!$ddc3d9704a40b613$export$b02a40aff8e4ad18(value)) $ddc3d9704a40b613$var$logger.throwArgumentError("invalid hex string", "value", value);
    if (value.length > 2 * length + 2) $ddc3d9704a40b613$var$logger.throwArgumentError("value out of range", "value", arguments[1]);
    while(value.length < 2 * length + 2)value = "0x0" + value.substring(2);
    return value;
}
function $ddc3d9704a40b613$export$7fb170f1e457988f(signature) {
    const result = {
        r: "0x",
        s: "0x",
        _vs: "0x",
        recoveryParam: 0,
        v: 0,
        yParityAndS: "0x",
        compact: "0x"
    };
    if ($ddc3d9704a40b613$export$9a14abb1a440cd5e(signature)) {
        let bytes = $ddc3d9704a40b613$export$3131421a7d01b4fb(signature);
        // Get the r, s and v
        if (bytes.length === 64) {
            // EIP-2098; pull the v from the top bit of s and clear it
            result.v = 27 + (bytes[32] >> 7);
            bytes[32] &= 0x7f;
            result.r = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
        } else if (bytes.length === 65) {
            result.r = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
            result.v = bytes[64];
        } else $ddc3d9704a40b613$var$logger.throwArgumentError("invalid signature string", "signature", signature);
        // Allow a recid to be used as the v
        if (result.v < 27) {
            if (result.v === 0 || result.v === 1) result.v += 27;
            else $ddc3d9704a40b613$var$logger.throwArgumentError("signature invalid v byte", "signature", signature);
        }
        // Compute recoveryParam from v
        result.recoveryParam = 1 - result.v % 2;
        // Compute _vs from recoveryParam and s
        if (result.recoveryParam) bytes[32] |= 0x80;
        result._vs = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
    } else {
        result.r = signature.r;
        result.s = signature.s;
        result.v = signature.v;
        result.recoveryParam = signature.recoveryParam;
        result._vs = signature._vs;
        // If the _vs is available, use it to populate missing s, v and recoveryParam
        // and verify non-missing s, v and recoveryParam
        if (result._vs != null) {
            const vs = $ddc3d9704a40b613$export$3cdc770bf8b2ed3d($ddc3d9704a40b613$export$3131421a7d01b4fb(result._vs), 32);
            result._vs = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(vs);
            // Set or check the recid
            const recoveryParam = vs[0] >= 128 ? 1 : 0;
            if (result.recoveryParam == null) result.recoveryParam = recoveryParam;
            else if (result.recoveryParam !== recoveryParam) $ddc3d9704a40b613$var$logger.throwArgumentError("signature recoveryParam mismatch _vs", "signature", signature);
            // Set or check the s
            vs[0] &= 0x7f;
            const s = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(vs);
            if (result.s == null) result.s = s;
            else if (result.s !== s) $ddc3d9704a40b613$var$logger.throwArgumentError("signature v mismatch _vs", "signature", signature);
        }
        // Use recid and v to populate each other
        if (result.recoveryParam == null) {
            if (result.v == null) $ddc3d9704a40b613$var$logger.throwArgumentError("signature missing v and recoveryParam", "signature", signature);
            else if (result.v === 0 || result.v === 1) result.recoveryParam = result.v;
            else result.recoveryParam = 1 - result.v % 2;
        } else if (result.v == null) result.v = 27 + result.recoveryParam;
        else {
            const recId = result.v === 0 || result.v === 1 ? result.v : 1 - result.v % 2;
            if (result.recoveryParam !== recId) $ddc3d9704a40b613$var$logger.throwArgumentError("signature recoveryParam mismatch v", "signature", signature);
        }
        if (result.r == null || !$ddc3d9704a40b613$export$b02a40aff8e4ad18(result.r)) $ddc3d9704a40b613$var$logger.throwArgumentError("signature missing or invalid r", "signature", signature);
        else result.r = $ddc3d9704a40b613$export$e9c46a54370b47e8(result.r, 32);
        if (result.s == null || !$ddc3d9704a40b613$export$b02a40aff8e4ad18(result.s)) $ddc3d9704a40b613$var$logger.throwArgumentError("signature missing or invalid s", "signature", signature);
        else result.s = $ddc3d9704a40b613$export$e9c46a54370b47e8(result.s, 32);
        const vs = $ddc3d9704a40b613$export$3131421a7d01b4fb(result.s);
        if (vs[0] >= 128) $ddc3d9704a40b613$var$logger.throwArgumentError("signature s out of range", "signature", signature);
        if (result.recoveryParam) vs[0] |= 0x80;
        const _vs = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(vs);
        if (result._vs) {
            if (!$ddc3d9704a40b613$export$b02a40aff8e4ad18(result._vs)) $ddc3d9704a40b613$var$logger.throwArgumentError("signature invalid _vs", "signature", signature);
            result._vs = $ddc3d9704a40b613$export$e9c46a54370b47e8(result._vs, 32);
        }
        // Set or check the _vs
        if (result._vs == null) result._vs = _vs;
        else if (result._vs !== _vs) $ddc3d9704a40b613$var$logger.throwArgumentError("signature _vs mismatch v and s", "signature", signature);
    }
    result.yParityAndS = result._vs;
    result.compact = result.r + result.yParityAndS.substring(2);
    return result;
}
function $ddc3d9704a40b613$export$71bb9d78a59bbe25(signature) {
    signature = $ddc3d9704a40b613$export$7fb170f1e457988f(signature);
    return $ddc3d9704a40b613$export$2b0d6b5fbe698c70($ddc3d9704a40b613$export$ee1b3e54f0441b22([
        signature.r,
        signature.s,
        signature.recoveryParam ? "0x1c" : "0x1b"
    ]));
}

});
parcelRegister("6M65e", function(module, exports) {

$parcel$export(module.exports, "Logger", function () { return $4eebf1ca9f327f54$export$efa9a398d6368992; });

var $3uyfT = parcelRequire("3uyfT");
"use strict";
let $4eebf1ca9f327f54$var$_permanentCensorErrors = false;
let $4eebf1ca9f327f54$var$_censorErrors = false;
const $4eebf1ca9f327f54$var$LogLevels = {
    debug: 1,
    "default": 2,
    info: 2,
    warning: 3,
    error: 4,
    off: 5
};
let $4eebf1ca9f327f54$var$_logLevel = $4eebf1ca9f327f54$var$LogLevels["default"];
let $4eebf1ca9f327f54$var$_globalLogger = null;
function $4eebf1ca9f327f54$var$_checkNormalize() {
    try {
        const missing = [];
        // Make sure all forms of normalization are supported
        [
            "NFD",
            "NFC",
            "NFKD",
            "NFKC"
        ].forEach((form)=>{
            try {
                if ("test".normalize(form) !== "test") throw new Error("bad normalize");
            } catch (error) {
                missing.push(form);
            }
        });
        if (missing.length) throw new Error("missing " + missing.join(", "));
        if (String.fromCharCode(0xe9).normalize("NFD") !== String.fromCharCode(0x65, 0x0301)) throw new Error("broken implementation");
    } catch (error) {
        return error.message;
    }
    return null;
}
const $4eebf1ca9f327f54$var$_normalizeError = $4eebf1ca9f327f54$var$_checkNormalize();
var $4eebf1ca9f327f54$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARNING"] = "WARNING";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["OFF"] = "OFF";
})($4eebf1ca9f327f54$export$243e62d78d3b544d || ($4eebf1ca9f327f54$export$243e62d78d3b544d = {}));
var $4eebf1ca9f327f54$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    ///////////////////
    // Generic Errors
    // Unknown Error
    ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    // Not Implemented
    ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    // Unsupported Operation
    //   - operation
    ErrorCode["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
    // Network Error (i.e. Ethereum Network, such as an invalid chain ID)
    //   - event ("noNetwork" is not re-thrown in provider.ready; otherwise thrown)
    ErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    // Some sort of bad response from the server
    ErrorCode["SERVER_ERROR"] = "SERVER_ERROR";
    // Timeout
    ErrorCode["TIMEOUT"] = "TIMEOUT";
    ///////////////////
    // Operational  Errors
    // Buffer Overrun
    ErrorCode["BUFFER_OVERRUN"] = "BUFFER_OVERRUN";
    // Numeric Fault
    //   - operation: the operation being executed
    //   - fault: the reason this faulted
    ErrorCode["NUMERIC_FAULT"] = "NUMERIC_FAULT";
    ///////////////////
    // Argument Errors
    // Missing new operator to an object
    //  - name: The name of the class
    ErrorCode["MISSING_NEW"] = "MISSING_NEW";
    // Invalid argument (e.g. value is incompatible with type) to a function:
    //   - argument: The argument name that was invalid
    //   - value: The value of the argument
    ErrorCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    // Missing argument to a function:
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["MISSING_ARGUMENT"] = "MISSING_ARGUMENT";
    // Too many arguments
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["UNEXPECTED_ARGUMENT"] = "UNEXPECTED_ARGUMENT";
    ///////////////////
    // Blockchain Errors
    // Call exception
    //  - transaction: the transaction
    //  - address?: the contract address
    //  - args?: The arguments passed into the function
    //  - method?: The Solidity method signature
    //  - errorSignature?: The EIP848 error signature
    //  - errorArgs?: The EIP848 error parameters
    //  - reason: The reason (only for EIP848 "Error(string)")
    ErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    // Insufficient funds (< value + gasLimit * gasPrice)
    //   - transaction: the transaction attempted
    ErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    // Nonce has already been used
    //   - transaction: the transaction attempted
    ErrorCode["NONCE_EXPIRED"] = "NONCE_EXPIRED";
    // The replacement fee for the transaction is too low
    //   - transaction: the transaction attempted
    ErrorCode["REPLACEMENT_UNDERPRICED"] = "REPLACEMENT_UNDERPRICED";
    // The gas limit could not be estimated
    //   - transaction: the transaction passed to estimateGas
    ErrorCode["UNPREDICTABLE_GAS_LIMIT"] = "UNPREDICTABLE_GAS_LIMIT";
    // The transaction was replaced by one with a higher gas price
    //   - reason: "cancelled", "replaced" or "repriced"
    //   - cancelled: true if reason == "cancelled" or reason == "replaced")
    //   - hash: original transaction hash
    //   - replacement: the full TransactionsResponse for the replacement
    //   - receipt: the receipt of the replacement
    ErrorCode["TRANSACTION_REPLACED"] = "TRANSACTION_REPLACED";
    ///////////////////
    // Interaction Errors
    // The user rejected the action, such as signing a message or sending
    // a transaction
    ErrorCode["ACTION_REJECTED"] = "ACTION_REJECTED";
})($4eebf1ca9f327f54$export$d4e71bc0b80dc0fb || ($4eebf1ca9f327f54$export$d4e71bc0b80dc0fb = {}));
const $4eebf1ca9f327f54$var$HEX = "0123456789abcdef";
class $4eebf1ca9f327f54$export$efa9a398d6368992 {
    _log(logLevel, args) {
        const level = logLevel.toLowerCase();
        if ($4eebf1ca9f327f54$var$LogLevels[level] == null) this.throwArgumentError("invalid log level name", "logLevel", logLevel);
        if ($4eebf1ca9f327f54$var$_logLevel > $4eebf1ca9f327f54$var$LogLevels[level]) return;
        console.log.apply(console, args);
    }
    debug(...args) {
        this._log($4eebf1ca9f327f54$export$efa9a398d6368992.levels.DEBUG, args);
    }
    info(...args) {
        this._log($4eebf1ca9f327f54$export$efa9a398d6368992.levels.INFO, args);
    }
    warn(...args) {
        this._log($4eebf1ca9f327f54$export$efa9a398d6368992.levels.WARNING, args);
    }
    makeError(message, code, params) {
        // Errors are being censored
        if ($4eebf1ca9f327f54$var$_censorErrors) return this.makeError("censored error", code, {});
        if (!code) code = $4eebf1ca9f327f54$export$efa9a398d6368992.errors.UNKNOWN_ERROR;
        if (!params) params = {};
        const messageDetails = [];
        Object.keys(params).forEach((key)=>{
            const value = params[key];
            try {
                if (value instanceof Uint8Array) {
                    let hex = "";
                    for(let i = 0; i < value.length; i++){
                        hex += $4eebf1ca9f327f54$var$HEX[value[i] >> 4];
                        hex += $4eebf1ca9f327f54$var$HEX[value[i] & 0x0f];
                    }
                    messageDetails.push(key + "=Uint8Array(0x" + hex + ")");
                } else messageDetails.push(key + "=" + JSON.stringify(value));
            } catch (error) {
                messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
            }
        });
        messageDetails.push(`code=${code}`);
        messageDetails.push(`version=${this.version}`);
        const reason = message;
        let url = "";
        switch(code){
            case $4eebf1ca9f327f54$export$d4e71bc0b80dc0fb.NUMERIC_FAULT:
                {
                    url = "NUMERIC_FAULT";
                    const fault = message;
                    switch(fault){
                        case "overflow":
                        case "underflow":
                        case "division-by-zero":
                            url += "-" + fault;
                            break;
                        case "negative-power":
                        case "negative-width":
                            url += "-unsupported";
                            break;
                        case "unbound-bitwise-result":
                            url += "-unbound-result";
                            break;
                    }
                    break;
                }
            case $4eebf1ca9f327f54$export$d4e71bc0b80dc0fb.CALL_EXCEPTION:
            case $4eebf1ca9f327f54$export$d4e71bc0b80dc0fb.INSUFFICIENT_FUNDS:
            case $4eebf1ca9f327f54$export$d4e71bc0b80dc0fb.MISSING_NEW:
            case $4eebf1ca9f327f54$export$d4e71bc0b80dc0fb.NONCE_EXPIRED:
            case $4eebf1ca9f327f54$export$d4e71bc0b80dc0fb.REPLACEMENT_UNDERPRICED:
            case $4eebf1ca9f327f54$export$d4e71bc0b80dc0fb.TRANSACTION_REPLACED:
            case $4eebf1ca9f327f54$export$d4e71bc0b80dc0fb.UNPREDICTABLE_GAS_LIMIT:
                url = code;
                break;
        }
        if (url) message += " [ See: https://links.ethers.org/v5-errors-" + url + " ]";
        if (messageDetails.length) message += " (" + messageDetails.join(", ") + ")";
        // @TODO: Any??
        const error = new Error(message);
        error.reason = reason;
        error.code = code;
        Object.keys(params).forEach(function(key) {
            error[key] = params[key];
        });
        return error;
    }
    throwError(message, code, params) {
        throw this.makeError(message, code, params);
    }
    throwArgumentError(message, name, value) {
        return this.throwError(message, $4eebf1ca9f327f54$export$efa9a398d6368992.errors.INVALID_ARGUMENT, {
            argument: name,
            value: value
        });
    }
    assert(condition, message, code, params) {
        if (!!condition) return;
        this.throwError(message, code, params);
    }
    assertArgument(condition, message, name, value) {
        if (!!condition) return;
        this.throwArgumentError(message, name, value);
    }
    checkNormalize(message) {
        if (message == null) message = "platform missing String.prototype.normalize";
        if ($4eebf1ca9f327f54$var$_normalizeError) this.throwError("platform missing String.prototype.normalize", $4eebf1ca9f327f54$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "String.prototype.normalize",
            form: $4eebf1ca9f327f54$var$_normalizeError
        });
    }
    checkSafeUint53(value, message) {
        if (typeof value !== "number") return;
        if (message == null) message = "value not safe";
        if (value < 0 || value >= 0x1fffffffffffff) this.throwError(message, $4eebf1ca9f327f54$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "out-of-safe-range",
            value: value
        });
        if (value % 1) this.throwError(message, $4eebf1ca9f327f54$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "non-integer",
            value: value
        });
    }
    checkArgumentCount(count, expectedCount, message) {
        if (message) message = ": " + message;
        else message = "";
        if (count < expectedCount) this.throwError("missing argument" + message, $4eebf1ca9f327f54$export$efa9a398d6368992.errors.MISSING_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
        if (count > expectedCount) this.throwError("too many arguments" + message, $4eebf1ca9f327f54$export$efa9a398d6368992.errors.UNEXPECTED_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
    }
    checkNew(target, kind) {
        if (target === Object || target == null) this.throwError("missing new", $4eebf1ca9f327f54$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    checkAbstract(target, kind) {
        if (target === kind) this.throwError("cannot instantiate abstract class " + JSON.stringify(kind.name) + " directly; use a sub-class", $4eebf1ca9f327f54$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            name: target.name,
            operation: "new"
        });
        else if (target === Object || target == null) this.throwError("missing new", $4eebf1ca9f327f54$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    static globalLogger() {
        if (!$4eebf1ca9f327f54$var$_globalLogger) $4eebf1ca9f327f54$var$_globalLogger = new $4eebf1ca9f327f54$export$efa9a398d6368992((0, $3uyfT.version));
        return $4eebf1ca9f327f54$var$_globalLogger;
    }
    static setCensorship(censorship, permanent) {
        if (!censorship && permanent) this.globalLogger().throwError("cannot permanently disable censorship", $4eebf1ca9f327f54$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "setCensorship"
        });
        if ($4eebf1ca9f327f54$var$_permanentCensorErrors) {
            if (!censorship) return;
            this.globalLogger().throwError("error censorship permanent", $4eebf1ca9f327f54$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
                operation: "setCensorship"
            });
        }
        $4eebf1ca9f327f54$var$_censorErrors = !!censorship;
        $4eebf1ca9f327f54$var$_permanentCensorErrors = !!permanent;
    }
    static setLogLevel(logLevel) {
        const level = $4eebf1ca9f327f54$var$LogLevels[logLevel.toLowerCase()];
        if (level == null) {
            $4eebf1ca9f327f54$export$efa9a398d6368992.globalLogger().warn("invalid log level - " + logLevel);
            return;
        }
        $4eebf1ca9f327f54$var$_logLevel = level;
    }
    static from(version) {
        return new $4eebf1ca9f327f54$export$efa9a398d6368992(version);
    }
    constructor(version){
        Object.defineProperty(this, "version", {
            enumerable: true,
            value: version,
            writable: false
        });
    }
}
$4eebf1ca9f327f54$export$efa9a398d6368992.errors = $4eebf1ca9f327f54$export$d4e71bc0b80dc0fb;
$4eebf1ca9f327f54$export$efa9a398d6368992.levels = $4eebf1ca9f327f54$export$243e62d78d3b544d;

});
parcelRegister("3uyfT", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $28aebedb0958c5ea$export$83d89fbfd8236492; });
const $28aebedb0958c5ea$export$83d89fbfd8236492 = "logger/5.7.0";

});


parcelRegister("eraBF", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $a82bd087aad0b6d2$export$83d89fbfd8236492; });
const $a82bd087aad0b6d2$export$83d89fbfd8236492 = "bytes/5.7.0";

});







parcelRegister("b1wkq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toGenerator = void 0;
// Copied from the mobx-state-tree repository.
/**
 * @experimental
 * experimental api - might change on minor/patch releases
 *
 * Convert a promise to a generator yielding that promise
 * This is intended to allow for usage of `yield*` in async actions to
 * retain the promise return type.
 *
 * Example:
 * ```ts
 * function getDataAsync(input: string): Promise<number> { ... }
 *
 * const someModel.actions(self => ({
 *   someAction: flow(function*() {
 *     // value is typed as number
 *     const value = yield* toGenerator(getDataAsync("input value"));
 *     ...
 *   })
 * }))
 * ```
 */ function* $8068dd7474a8a328$var$toGenerator(p) {
    return yield p;
}
module.exports.toGenerator = $8068dd7474a8a328$var$toGenerator;

});

parcelRegister("lcQNw", function(module, exports) {
"use strict";
var $f703ac7beb7ff2f5$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f703ac7beb7ff2f5$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f703ac7beb7ff2f5$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f703ac7beb7ff2f5$var$__exportStar((parcelRequire("lqyD9")), module.exports);

});
parcelRegister("lqyD9", function(module, exports) {
"use strict";
var $f996e3929b46e983$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Debouncer = void 0;
class $f996e3929b46e983$var$Debouncer {
    static promise(fn) {
        let currentPromise;
        return (...arguments_)=>$f996e3929b46e983$var$__awaiter(this, void 0, void 0, function*() {
                if (currentPromise) return currentPromise;
                try {
                    currentPromise = fn.apply(this, arguments_);
                    return yield currentPromise;
                } finally{
                    currentPromise = undefined;
                }
            });
    }
}
module.exports.Debouncer = $f996e3929b46e983$var$Debouncer;

});


parcelRegister("1JhRD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.unescapeHTML = module.exports.escapeHTML = void 0;
/**
 * Escapes <,>,& in string.
 * Golang's json marshaller escapes <,>,& by default.
 * However, because JS doesn't do that by default, to match the sign doc with cosmos-sdk,
 * we should escape <,>,& in string manually.
 * @param str
 */ function $1427d9df3936798c$var$escapeHTML(str) {
    return str.replace(/</g, "\\u003c").replace(/>/g, "\\u003e").replace(/&/g, "\\u0026");
}
module.exports.escapeHTML = $1427d9df3936798c$var$escapeHTML;
/**
 * Unescapes \u003c/(<),\u003e(>),\u0026(&) in string.
 * Golang's json marshaller escapes <,>,& by default, whilst for most of the users, such escape characters are unfamiliar.
 * This function can be used to show the escaped characters with more familiar characters.
 * @param str
 */ function $1427d9df3936798c$var$unescapeHTML(str) {
    return str.replace(/\\u003c/g, "<").replace(/\\u003e/g, ">").replace(/\\u0026/g, "&");
}
module.exports.unescapeHTML = $1427d9df3936798c$var$unescapeHTML;

});

parcelRegister("aGL8U", function(module, exports) {
"use strict";
var $7c826531488f6934$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7c826531488f6934$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $7c826531488f6934$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$7c826531488f6934$var$__exportStar((parcelRequire("j6uwh")), module.exports);

});
parcelRegister("j6uwh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sortedJsonByKeyStringify = module.exports.sortObjectByKey = void 0;
function $de864072c0a38b30$var$sortObjectByKey(obj) {
    if (typeof obj !== "object" || obj === null) return obj;
    if (Array.isArray(obj)) return obj.map($de864072c0a38b30$var$sortObjectByKey);
    const sortedKeys = Object.keys(obj).sort();
    const result = {};
    sortedKeys.forEach((key)=>{
        result[key] = $de864072c0a38b30$var$sortObjectByKey(obj[key]);
    });
    return result;
}
module.exports.sortObjectByKey = $de864072c0a38b30$var$sortObjectByKey;
function $de864072c0a38b30$var$sortedJsonByKeyStringify(obj) {
    return JSON.stringify($de864072c0a38b30$var$sortObjectByKey(obj));
}
module.exports.sortedJsonByKeyStringify = $de864072c0a38b30$var$sortedJsonByKeyStringify;

});


parcelRegister("jr1yD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateICNSName = module.exports.parseICNSName = void 0;
function $e261bf3a791d605b$var$parseICNSName(name) {
    const split = name.split(".");
    if (split.length === 2) {
        if (split[0].length > 0 && split[1].length > 0) return [
            split[0],
            split[1]
        ];
    }
    return undefined;
}
module.exports.parseICNSName = $e261bf3a791d605b$var$parseICNSName;
function $e261bf3a791d605b$var$validateICNSName(name, bech32Prefix) {
    const parsed = $e261bf3a791d605b$var$parseICNSName(name);
    if (!parsed) return false;
    return parsed[1] === bech32Prefix;
}
module.exports.validateICNSName = $e261bf3a791d605b$var$validateICNSName;

});

parcelRegister("86xDK", function(module, exports) {


module.exports = (parcelRequire("9FZDf"))((parcelRequire("lGKbD")).resolve("jD60Z")).then(()=>parcelRequire("cNIke"));

});

var $fba0f23e9e6a11bb$exports = {};
"use strict";

$fba0f23e9e6a11bb$exports = (parcelRequire("a58XM"));


var $af103a78974d72e1$exports = {};

$af103a78974d72e1$exports = (parcelRequire("3tMCR"));


var $375213fb35a15afb$exports = {};
(function(f) {
    var g;
    $375213fb35a15afb$exports = f();
})(function() {
    var define, module1, exports;
    var _$src_1 = {};
    function _extends() {
        _extends = Object.assign || function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        return _extends.apply(this, arguments);
    }
    function _assertThisInitialized(self) {
        if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return self;
    }
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        _setPrototypeOf(subClass, superClass);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    _$src_1 = /*#__PURE__*/ function() {
        function BugsnagPluginReact() {
            // Fetch React from the window object, if it exists
            var globalReact = typeof window !== "undefined" && window.React;
            this.name = "react";
            this.lazy = arguments.length === 0 && !globalReact;
            if (!this.lazy) {
                this.React = (arguments.length <= 0 ? undefined : arguments[0]) || globalReact;
                if (!this.React) throw new Error("@bugsnag/plugin-react reference to `React` was undefined");
            }
        }
        var _proto = BugsnagPluginReact.prototype;
        _proto.load = function load(client) {
            if (!this.lazy) {
                var ErrorBoundary = createClass(this.React, client);
                ErrorBoundary.createErrorBoundary = function() {
                    return ErrorBoundary;
                };
                return ErrorBoundary;
            }
            var BugsnagPluginReactLazyInitializer = function() {
                throw new Error("@bugsnag/plugin-react was used incorrectly. Valid usage is as follows:\nPass React to the plugin constructor\n\n  `Bugsnag.start({ plugins: [new BugsnagPluginReact(React)] })`\nand then call `const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary()`\n\nOr if React is not available until after Bugsnag has started,\nconstruct the plugin with no arguments\n  `Bugsnag.start({ plugins: [new BugsnagPluginReact()] })`,\nthen pass in React when available to construct your error boundary\n  `const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React)`");
            };
            BugsnagPluginReactLazyInitializer.createErrorBoundary = function(React) {
                if (!React) throw new Error("@bugsnag/plugin-react reference to `React` was undefined");
                return createClass(React, client);
            };
            return BugsnagPluginReactLazyInitializer;
        };
        return BugsnagPluginReact;
    }();
    var formatComponentStack = function(str) {
        var lines = str.split(/\s*\n\s*/g);
        var ret = "";
        for(var line = 0, len = lines.length; line < len; line++)if (lines[line].length) ret += "" + (ret.length ? "\n" : "") + lines[line];
        return ret;
    };
    var createClass = function(React, client) {
        return /*#__PURE__*/ function(_React$Component) {
            _inheritsLoose(ErrorBoundary, _React$Component);
            function ErrorBoundary(props) {
                var _this;
                _this = _React$Component.call(this, props) || this;
                _this.state = {
                    error: null,
                    info: null
                };
                _this.handleClearError = _this.handleClearError.bind(_assertThisInitialized(_this));
                return _this;
            }
            var _proto2 = ErrorBoundary.prototype;
            _proto2.handleClearError = function handleClearError() {
                this.setState({
                    error: null,
                    info: null
                });
            };
            _proto2.componentDidCatch = function componentDidCatch(error, info) {
                var onError = this.props.onError;
                var handledState = {
                    severity: "error",
                    unhandled: true,
                    severityReason: {
                        type: "unhandledException"
                    }
                };
                var event = client.Event.create(error, true, handledState, 1);
                if (info && info.componentStack) info.componentStack = formatComponentStack(info.componentStack);
                event.addMetadata("react", info);
                client._notify(event, onError);
                this.setState({
                    error: error,
                    info: info
                });
            };
            _proto2.render = function render() {
                var error = this.state.error;
                if (error) {
                    var FallbackComponent = this.props.FallbackComponent;
                    if (FallbackComponent) return React.createElement(FallbackComponent, _extends({}, this.state, {
                        clearError: this.handleClearError
                    }));
                    return null;
                }
                return this.props.children;
            };
            return ErrorBoundary;
        }(React.Component);
    };
    _$src_1.formatComponentStack = formatComponentStack;
    _$src_1["default"] = _$src_1;
    return _$src_1;
});



var $6cds3 = parcelRequire("6cds3");
var $6d4849ee44552f5f$exports = {};
"use strict";
function $6d4849ee44552f5f$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($6d4849ee44552f5f$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$6d4849ee44552f5f$var$checkDCE();

$6d4849ee44552f5f$exports = (parcelRequire("jZA9I"));


/**
 * React Router DOM v6.22.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $6cds3 = parcelRequire("6cds3");

/**
 * React Router v6.22.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $6cds3 = parcelRequire("6cds3");
/**
 * @remix-run/router v1.15.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $96b280a33643b696$var$_extends() {
    $96b280a33643b696$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $96b280a33643b696$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $96b280a33643b696$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($96b280a33643b696$export$e19cd5f9376f8cee || ($96b280a33643b696$export$e19cd5f9376f8cee = {}));
const $96b280a33643b696$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $96b280a33643b696$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $96b280a33643b696$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $96b280a33643b696$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $96b280a33643b696$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $96b280a33643b696$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $96b280a33643b696$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $96b280a33643b696$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $96b280a33643b696$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $96b280a33643b696$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $96b280a33643b696$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $96b280a33643b696$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $96b280a33643b696$export$fe53371bee54353d(to);
    }
    return $96b280a33643b696$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $96b280a33643b696$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $96b280a33643b696$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $96b280a33643b696$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $96b280a33643b696$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $96b280a33643b696$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $96b280a33643b696$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $96b280a33643b696$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $96b280a33643b696$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $96b280a33643b696$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $96b280a33643b696$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $96b280a33643b696$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $96b280a33643b696$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $96b280a33643b696$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $96b280a33643b696$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $96b280a33643b696$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $96b280a33643b696$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $96b280a33643b696$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $96b280a33643b696$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($96b280a33643b696$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $96b280a33643b696$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $96b280a33643b696$export$e19cd5f9376f8cee.Push;
        let location = $96b280a33643b696$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $96b280a33643b696$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $96b280a33643b696$export$e19cd5f9376f8cee.Replace;
        let location = $96b280a33643b696$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $96b280a33643b696$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $96b280a33643b696$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $96b280a33643b696$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($96b280a33643b696$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($96b280a33643b696$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $96b280a33643b696$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($96b280a33643b696$var$ResultType || ($96b280a33643b696$var$ResultType = {}));
const $96b280a33643b696$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $96b280a33643b696$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $96b280a33643b696$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $96b280a33643b696$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $96b280a33643b696$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($96b280a33643b696$var$isIndexRoute(route)) {
            let indexRoute = $96b280a33643b696$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $96b280a33643b696$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $96b280a33643b696$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $96b280a33643b696$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $96b280a33643b696$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $96b280a33643b696$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $96b280a33643b696$var$flattenRoutes(routes);
    $96b280a33643b696$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $96b280a33643b696$var$decodePath(pathname);
        matches = $96b280a33643b696$var$matchRouteBranch(branches[i], decoded);
    }
    return matches;
}
function $96b280a33643b696$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $96b280a33643b696$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $96b280a33643b696$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $96b280a33643b696$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $96b280a33643b696$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $96b280a33643b696$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $96b280a33643b696$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $96b280a33643b696$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $96b280a33643b696$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $96b280a33643b696$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $96b280a33643b696$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $96b280a33643b696$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $96b280a33643b696$var$paramRe = /^:[\w-]+$/;
const $96b280a33643b696$var$dynamicSegmentValue = 3;
const $96b280a33643b696$var$indexRouteValue = 2;
const $96b280a33643b696$var$emptySegmentValue = 1;
const $96b280a33643b696$var$staticSegmentValue = 10;
const $96b280a33643b696$var$splatPenalty = -2;
const $96b280a33643b696$var$isSplat = (s)=>s === "*";
function $96b280a33643b696$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($96b280a33643b696$var$isSplat)) initialScore += $96b280a33643b696$var$splatPenalty;
    if (index) initialScore += $96b280a33643b696$var$indexRouteValue;
    return segments.filter((s)=>!$96b280a33643b696$var$isSplat(s)).reduce((score, segment)=>score + ($96b280a33643b696$var$paramRe.test(segment) ? $96b280a33643b696$var$dynamicSegmentValue : segment === "" ? $96b280a33643b696$var$emptySegmentValue : $96b280a33643b696$var$staticSegmentValue), initialScore);
}
function $96b280a33643b696$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $96b280a33643b696$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $96b280a33643b696$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $96b280a33643b696$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $96b280a33643b696$export$a5c6d149b50c1d86($96b280a33643b696$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $96b280a33643b696$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $96b280a33643b696$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $96b280a33643b696$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $96b280a33643b696$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $96b280a33643b696$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $96b280a33643b696$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $96b280a33643b696$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $96b280a33643b696$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $96b280a33643b696$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $96b280a33643b696$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $96b280a33643b696$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $96b280a33643b696$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $96b280a33643b696$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $96b280a33643b696$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $96b280a33643b696$var$normalizeSearch(search),
        hash: $96b280a33643b696$var$normalizeHash(hash)
    };
}
function $96b280a33643b696$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $96b280a33643b696$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $96b280a33643b696$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $96b280a33643b696$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $96b280a33643b696$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $96b280a33643b696$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $96b280a33643b696$export$8ccf933b0513f8d0(toArg);
    else {
        to = $96b280a33643b696$var$_extends({}, toArg);
        $96b280a33643b696$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $96b280a33643b696$var$getInvalidPathError("?", "pathname", "search", to));
        $96b280a33643b696$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $96b280a33643b696$var$getInvalidPathError("#", "pathname", "hash", to));
        $96b280a33643b696$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $96b280a33643b696$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $96b280a33643b696$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $96b280a33643b696$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $96b280a33643b696$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $96b280a33643b696$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $96b280a33643b696$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $96b280a33643b696$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $96b280a33643b696$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $96b280a33643b696$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $96b280a33643b696$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $96b280a33643b696$export$42a99a7a4bc0e76a extends Error {
}
class $96b280a33643b696$export$61d759255b4eec65 {
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $96b280a33643b696$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $96b280a33643b696$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $96b280a33643b696$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $96b280a33643b696$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $96b280a33643b696$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
}
function $96b280a33643b696$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $96b280a33643b696$var$unwrapTrackedPromise(value) {
    if (!$96b280a33643b696$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $96b280a33643b696$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $96b280a33643b696$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $96b280a33643b696$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $96b280a33643b696$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $96b280a33643b696$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $96b280a33643b696$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $96b280a33643b696$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $96b280a33643b696$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $96b280a33643b696$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $96b280a33643b696$var$validMutationMethods = new Set($96b280a33643b696$var$validMutationMethodsArr);
const $96b280a33643b696$var$validRequestMethodsArr = [
    "get",
    ...$96b280a33643b696$var$validMutationMethodsArr
];
const $96b280a33643b696$var$validRequestMethods = new Set($96b280a33643b696$var$validRequestMethodsArr);
const $96b280a33643b696$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $96b280a33643b696$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $96b280a33643b696$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $96b280a33643b696$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $96b280a33643b696$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $96b280a33643b696$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $96b280a33643b696$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $96b280a33643b696$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $96b280a33643b696$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $96b280a33643b696$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $96b280a33643b696$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $96b280a33643b696$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $96b280a33643b696$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $96b280a33643b696$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $96b280a33643b696$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $96b280a33643b696$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        initialized = initialMatches.every((m)=>m.route.loader && m.route.loader.hydrate !== true && (loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $96b280a33643b696$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $96b280a33643b696$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $96b280a33643b696$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $96b280a33643b696$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $96b280a33643b696$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$96b280a33643b696$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($96b280a33643b696$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $96b280a33643b696$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $96b280a33643b696$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $96b280a33643b696$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $96b280a33643b696$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $96b280a33643b696$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $96b280a33643b696$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $96b280a33643b696$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $96b280a33643b696$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $96b280a33643b696$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($96b280a33643b696$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $96b280a33643b696$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $96b280a33643b696$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $96b280a33643b696$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $96b280a33643b696$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $96b280a33643b696$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $96b280a33643b696$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $96b280a33643b696$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $96b280a33643b696$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $96b280a33643b696$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $96b280a33643b696$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $96b280a33643b696$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $96b280a33643b696$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $96b280a33643b696$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $96b280a33643b696$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $96b280a33643b696$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $96b280a33643b696$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $96b280a33643b696$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$96b280a33643b696$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $96b280a33643b696$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $96b280a33643b696$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $96b280a33643b696$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $96b280a33643b696$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $96b280a33643b696$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $96b280a33643b696$var$ResultType.error,
            error: $96b280a33643b696$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $96b280a33643b696$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($96b280a33643b696$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($96b280a33643b696$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $96b280a33643b696$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $96b280a33643b696$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($96b280a33643b696$var$isDeferredResult(result)) throw $96b280a33643b696$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $96b280a33643b696$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $96b280a33643b696$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $96b280a33643b696$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $96b280a33643b696$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since iot's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $96b280a33643b696$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($96b280a33643b696$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $96b280a33643b696$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $96b280a33643b696$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $96b280a33643b696$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $96b280a33643b696$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $96b280a33643b696$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $96b280a33643b696$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $96b280a33643b696$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $96b280a33643b696$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $96b280a33643b696$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $96b280a33643b696$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $96b280a33643b696$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $96b280a33643b696$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $96b280a33643b696$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($96b280a33643b696$var$isRedirectResult(actionResult) || $96b280a33643b696$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $96b280a33643b696$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($96b280a33643b696$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $96b280a33643b696$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $96b280a33643b696$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(state, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($96b280a33643b696$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($96b280a33643b696$var$isDeferredResult(actionResult)) throw $96b280a33643b696$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $96b280a33643b696$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $96b280a33643b696$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $96b280a33643b696$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $96b280a33643b696$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $96b280a33643b696$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $96b280a33643b696$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $96b280a33643b696$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $96b280a33643b696$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $96b280a33643b696$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $96b280a33643b696$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $96b280a33643b696$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $96b280a33643b696$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $96b280a33643b696$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $96b280a33643b696$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($96b280a33643b696$var$isDeferredResult(result)) result = await $96b280a33643b696$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $96b280a33643b696$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($96b280a33643b696$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $96b280a33643b696$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($96b280a33643b696$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $96b280a33643b696$export$3e9cee6b33872309(!$96b280a33643b696$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $96b280a33643b696$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $96b280a33643b696$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $96b280a33643b696$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($96b280a33643b696$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $96b280a33643b696$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $96b280a33643b696$export$e19cd5f9376f8cee.Replace : $96b280a33643b696$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $96b280a33643b696$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($96b280a33643b696$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $96b280a33643b696$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $96b280a33643b696$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $96b280a33643b696$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$96b280a33643b696$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $96b280a33643b696$var$callLoaderOrAction("loader", $96b280a33643b696$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
                else {
                    let error = {
                        type: $96b280a33643b696$var$ResultType.error,
                        error: $96b280a33643b696$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $96b280a33643b696$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $96b280a33643b696$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $96b280a33643b696$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $96b280a33643b696$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $96b280a33643b696$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $96b280a33643b696$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $96b280a33643b696$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $96b280a33643b696$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $96b280a33643b696$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $96b280a33643b696$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $96b280a33643b696$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $96b280a33643b696$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $96b280a33643b696$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$96b280a33643b696$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $96b280a33643b696$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $96b280a33643b696$export$4d0306f8f6a4585b = Symbol("deferred");
function $96b280a33643b696$export$3336b097a6fbc59a(routes, opts) {
    $96b280a33643b696$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $96b280a33643b696$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $96b280a33643b696$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $96b280a33643b696$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp3) {
        let { requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $96b280a33643b696$var$createLocation("", $96b280a33643b696$export$fe53371bee54353d(url), null, "default");
        let matches = $96b280a33643b696$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$96b280a33643b696$var$isValidMethod(method) && method !== "HEAD") {
            let error = $96b280a33643b696$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $96b280a33643b696$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $96b280a33643b696$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $96b280a33643b696$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($96b280a33643b696$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $96b280a33643b696$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $96b280a33643b696$var$createLocation("", $96b280a33643b696$export$fe53371bee54353d(url), null, "default");
        let matches = $96b280a33643b696$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$96b280a33643b696$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $96b280a33643b696$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $96b280a33643b696$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $96b280a33643b696$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $96b280a33643b696$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $96b280a33643b696$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($96b280a33643b696$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$96b280a33643b696$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $96b280a33643b696$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($96b280a33643b696$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $96b280a33643b696$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $96b280a33643b696$var$isResponse(result) ? result : $96b280a33643b696$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($96b280a33643b696$var$isQueryRouteResponse(e)) {
                if (e.type === $96b280a33643b696$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($96b280a33643b696$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $96b280a33643b696$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $96b280a33643b696$var$ResultType.error,
                error: error
            };
        } else {
            result = await $96b280a33643b696$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) $96b280a33643b696$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($96b280a33643b696$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($96b280a33643b696$var$isDeferredResult(result)) {
            let error = $96b280a33643b696$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $96b280a33643b696$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($96b280a33643b696$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($96b280a33643b696$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $96b280a33643b696$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $96b280a33643b696$var$_extends({}, context, {
                statusCode: $96b280a33643b696$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $96b280a33643b696$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $96b280a33643b696$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $96b280a33643b696$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $96b280a33643b696$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $96b280a33643b696$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$96b280a33643b696$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) $96b280a33643b696$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $96b280a33643b696$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $96b280a33643b696$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $96b280a33643b696$export$fec11da027c70692(routes, context, error) {
    let newContext = $96b280a33643b696$var$_extends({}, context, {
        statusCode: $96b280a33643b696$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $96b280a33643b696$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $96b280a33643b696$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $96b280a33643b696$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $96b280a33643b696$export$cae722b0cc860f13(to ? to : ".", $96b280a33643b696$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $96b280a33643b696$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$96b280a33643b696$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $96b280a33643b696$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $96b280a33643b696$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $96b280a33643b696$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$96b280a33643b696$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$96b280a33643b696$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $96b280a33643b696$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $96b280a33643b696$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $96b280a33643b696$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$96b280a33643b696$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$96b280a33643b696$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $96b280a33643b696$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $96b280a33643b696$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $96b280a33643b696$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $96b280a33643b696$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $96b280a33643b696$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($96b280a33643b696$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $96b280a33643b696$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $96b280a33643b696$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $96b280a33643b696$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $96b280a33643b696$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $96b280a33643b696$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $96b280a33643b696$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($96b280a33643b696$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $96b280a33643b696$var$shouldRevalidateLoader(match, $96b280a33643b696$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $96b280a33643b696$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $96b280a33643b696$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $96b280a33643b696$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $96b280a33643b696$var$shouldRevalidateLoader(fetcherMatch, $96b280a33643b696$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $96b280a33643b696$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $96b280a33643b696$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $96b280a33643b696$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $96b280a33643b696$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $96b280a33643b696$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $96b280a33643b696$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$96b280a33643b696$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $96b280a33643b696$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $96b280a33643b696$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, v7_relativeSplatPath, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $96b280a33643b696$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $96b280a33643b696$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $96b280a33643b696$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $96b280a33643b696$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $96b280a33643b696$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $96b280a33643b696$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $96b280a33643b696$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($96b280a33643b696$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($96b280a33643b696$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $96b280a33643b696$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$96b280a33643b696$var$ABSOLUTE_URL_REGEX.test(location)) location = $96b280a33643b696$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location, v7_relativeSplatPath);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $96b280a33643b696$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $96b280a33643b696$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $96b280a33643b696$var$ResultType.error ? $96b280a33643b696$var$ResultType.error : $96b280a33643b696$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $96b280a33643b696$var$ResultType.error,
                error: e
            };
        }
        if (resultType === $96b280a33643b696$var$ResultType.error) return {
            type: resultType,
            error: new $96b280a33643b696$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $96b280a33643b696$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $96b280a33643b696$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($96b280a33643b696$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $96b280a33643b696$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $96b280a33643b696$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $96b280a33643b696$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($96b280a33643b696$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $96b280a33643b696$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $96b280a33643b696$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $96b280a33643b696$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $96b280a33643b696$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $96b280a33643b696$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $96b280a33643b696$export$3e9cee6b33872309(!$96b280a33643b696$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($96b280a33643b696$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $96b280a33643b696$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $96b280a33643b696$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($96b280a33643b696$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $96b280a33643b696$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $96b280a33643b696$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $96b280a33643b696$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($96b280a33643b696$var$isErrorResult(result)) {
            let boundaryMatch = $96b280a33643b696$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $96b280a33643b696$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($96b280a33643b696$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $96b280a33643b696$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($96b280a33643b696$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $96b280a33643b696$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $96b280a33643b696$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $96b280a33643b696$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $96b280a33643b696$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $96b280a33643b696$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $96b280a33643b696$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $96b280a33643b696$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $96b280a33643b696$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $96b280a33643b696$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($96b280a33643b696$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $96b280a33643b696$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $96b280a33643b696$export$8ccf933b0513f8d0(path) : path;
    return $96b280a33643b696$export$fe53371bee54353d($96b280a33643b696$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $96b280a33643b696$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $96b280a33643b696$var$isDeferredResult(result) {
    return result.type === $96b280a33643b696$var$ResultType.deferred;
}
function $96b280a33643b696$var$isErrorResult(result) {
    return result.type === $96b280a33643b696$var$ResultType.error;
}
function $96b280a33643b696$var$isRedirectResult(result) {
    return (result && result.type) === $96b280a33643b696$var$ResultType.redirect;
}
function $96b280a33643b696$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $96b280a33643b696$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $96b280a33643b696$var$isRedirectResponse(result) {
    if (!$96b280a33643b696$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $96b280a33643b696$var$isQueryRouteResponse(obj) {
    return obj && $96b280a33643b696$var$isResponse(obj.response) && (obj.type === $96b280a33643b696$var$ResultType.data || obj.type === $96b280a33643b696$var$ResultType.error);
}
function $96b280a33643b696$var$isValidMethod(method) {
    return $96b280a33643b696$var$validRequestMethods.has(method.toLowerCase());
}
function $96b280a33643b696$var$isMutationMethod(method) {
    return $96b280a33643b696$var$validMutationMethods.has(method.toLowerCase());
}
async function $96b280a33643b696$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$96b280a33643b696$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($96b280a33643b696$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $96b280a33643b696$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $96b280a33643b696$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $96b280a33643b696$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $96b280a33643b696$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $96b280a33643b696$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $96b280a33643b696$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $96b280a33643b696$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $96b280a33643b696$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $96b280a33643b696$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $96b280a33643b696$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $96b280a33643b696$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $96b280a33643b696$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $96b280a33643b696$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $96b280a33643b696$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $96b280a33643b696$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $96b280a33643b696$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $96b280a33643b696$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $96b280a33643b696$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($96b280a33643b696$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $96b280a33643b696$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($96b280a33643b696$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $96b280a33643b696$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}


function $4a3e215446c0ed92$var$_extends() {
    $4a3e215446c0ed92$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4a3e215446c0ed92$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $4a3e215446c0ed92$export$3add0d5dce533e2e = /*#__PURE__*/ $6cds3.createContext(null);
const $4a3e215446c0ed92$export$145dfa71566a64dc = /*#__PURE__*/ $6cds3.createContext(null);
const $4a3e215446c0ed92$var$AwaitContext = /*#__PURE__*/ $6cds3.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $4a3e215446c0ed92$export$26749e8557646306 = /*#__PURE__*/ $6cds3.createContext(null);
const $4a3e215446c0ed92$export$c7914228fb69b0f5 = /*#__PURE__*/ $6cds3.createContext(null);
const $4a3e215446c0ed92$export$9072aa6dd1f93057 = /*#__PURE__*/ $6cds3.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $4a3e215446c0ed92$var$RouteErrorContext = /*#__PURE__*/ $6cds3.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $4a3e215446c0ed92$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$4a3e215446c0ed92$export$9c954a9d03d32f4a() && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $6cds3.useContext($4a3e215446c0ed92$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $4a3e215446c0ed92$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $96b280a33643b696$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $4a3e215446c0ed92$export$9c954a9d03d32f4a() {
    return $6cds3.useContext($4a3e215446c0ed92$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $4a3e215446c0ed92$export$45d76561a5302f2b() {
    !$4a3e215446c0ed92$export$9c954a9d03d32f4a() && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    return $6cds3.useContext($4a3e215446c0ed92$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $4a3e215446c0ed92$export$1b3f31771c5d07c() {
    return $6cds3.useContext($4a3e215446c0ed92$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $4a3e215446c0ed92$export$6c330e8992e8a295(pattern) {
    !$4a3e215446c0ed92$export$9c954a9d03d32f4a() && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $4a3e215446c0ed92$export$45d76561a5302f2b();
    return $6cds3.useMemo(()=>(0, $96b280a33643b696$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $4a3e215446c0ed92$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $4a3e215446c0ed92$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $6cds3.useContext($4a3e215446c0ed92$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $6cds3.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $4a3e215446c0ed92$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $4a3e215446c0ed92$var$useNavigateStable() : $4a3e215446c0ed92$var$useNavigateUnstable();
}
function $4a3e215446c0ed92$var$useNavigateUnstable() {
    !$4a3e215446c0ed92$export$9c954a9d03d32f4a() && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    let dataRouterContext = $6cds3.useContext($4a3e215446c0ed92$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $6cds3.useContext($4a3e215446c0ed92$export$26749e8557646306);
    let { matches: matches } = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $4a3e215446c0ed92$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $96b280a33643b696$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $6cds3.useRef(false);
    $4a3e215446c0ed92$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $6cds3.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $96b280a33643b696$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $96b280a33643b696$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $4a3e215446c0ed92$var$OutletContext = /*#__PURE__*/ $6cds3.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $4a3e215446c0ed92$export$4138103a3ae699cc() {
    return $6cds3.useContext($4a3e215446c0ed92$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $4a3e215446c0ed92$export$a3be3530d8e40d0b(context) {
    let outlet = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $4a3e215446c0ed92$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $4a3e215446c0ed92$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $6cds3.useContext($4a3e215446c0ed92$export$26749e8557646306);
    let { matches: matches } = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $4a3e215446c0ed92$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $96b280a33643b696$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $6cds3.useMemo(()=>(0, $96b280a33643b696$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $4a3e215446c0ed92$export$5d3fca4a98652595(routes, locationArg) {
    return $4a3e215446c0ed92$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $4a3e215446c0ed92$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$4a3e215446c0ed92$export$9c954a9d03d32f4a() && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $6cds3.useContext($4a3e215446c0ed92$export$26749e8557646306);
    let { matches: parentMatches } = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $4a3e215446c0ed92$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $96b280a33643b696$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $96b280a33643b696$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $4a3e215446c0ed92$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $96b280a33643b696$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $96b280a33643b696$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $4a3e215446c0ed92$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $96b280a33643b696$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $4a3e215446c0ed92$var$DefaultErrorComponent() {
    let error = $4a3e215446c0ed92$export$ed527bf60f6e05f2();
    let message = (0, $96b280a33643b696$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $6cds3.createElement($6cds3.Fragment, null, /*#__PURE__*/ $6cds3.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $6cds3.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $6cds3.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $4a3e215446c0ed92$var$defaultErrorElement = /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$DefaultErrorComponent, null);
class $4a3e215446c0ed92$var$RenderErrorBoundary extends $6cds3.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
}
function $4a3e215446c0ed92$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $6cds3.useContext($4a3e215446c0ed92$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $4a3e215446c0ed92$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $4a3e215446c0ed92$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $4a3e215446c0ed92$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $6cds3.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $4a3e215446c0ed92$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($4a3e215446c0ed92$var$DataRouterHook || {});
var $4a3e215446c0ed92$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($4a3e215446c0ed92$var$DataRouterStateHook || {});
function $4a3e215446c0ed92$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $4a3e215446c0ed92$var$useDataRouterContext(hookName) {
    let ctx = $6cds3.useContext($4a3e215446c0ed92$export$3add0d5dce533e2e);
    !ctx && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    return ctx;
}
function $4a3e215446c0ed92$var$useDataRouterState(hookName) {
    let state = $6cds3.useContext($4a3e215446c0ed92$export$145dfa71566a64dc);
    !state && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    return state;
}
function $4a3e215446c0ed92$var$useRouteContext(hookName) {
    let route = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057);
    !route && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $4a3e215446c0ed92$var$useCurrentRouteId(hookName) {
    let route = $4a3e215446c0ed92$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $4a3e215446c0ed92$export$5fc8298006ad9e58() {
    return $4a3e215446c0ed92$var$useCurrentRouteId($4a3e215446c0ed92$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $4a3e215446c0ed92$export$d0fd4b7106de2769() {
    let state = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $4a3e215446c0ed92$export$600dc272ed516c15() {
    let dataRouterContext = $4a3e215446c0ed92$var$useDataRouterContext($4a3e215446c0ed92$var$DataRouterHook.UseRevalidator);
    let state = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseRevalidator);
    return $6cds3.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $4a3e215446c0ed92$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseMatches);
    return $6cds3.useMemo(()=>matches.map((m)=>(0, $96b280a33643b696$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $4a3e215446c0ed92$export$1448a5050d252c4d() {
    let state = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseLoaderData);
    let routeId = $4a3e215446c0ed92$var$useCurrentRouteId($4a3e215446c0ed92$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $4a3e215446c0ed92$export$fd5d37484eab868d(routeId) {
    let state = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $4a3e215446c0ed92$export$fdc00f3f26066d5e() {
    let state = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseActionData);
    let routeId = $4a3e215446c0ed92$var$useCurrentRouteId($4a3e215446c0ed92$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $4a3e215446c0ed92$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $6cds3.useContext($4a3e215446c0ed92$var$RouteErrorContext);
    let state = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseRouteError);
    let routeId = $4a3e215446c0ed92$var$useCurrentRouteId($4a3e215446c0ed92$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $4a3e215446c0ed92$export$78a72ddb39bdd145() {
    let value = $6cds3.useContext($4a3e215446c0ed92$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $4a3e215446c0ed92$export$17f53340677d5831() {
    let value = $6cds3.useContext($4a3e215446c0ed92$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $4a3e215446c0ed92$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $4a3e215446c0ed92$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $4a3e215446c0ed92$var$useDataRouterContext($4a3e215446c0ed92$var$DataRouterHook.UseBlocker);
    let state = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $6cds3.useState("");
    let blockerFunction = $6cds3.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $4a3e215446c0ed92$var$_extends({}, currentLocation, {
                pathname: (0, $96b280a33643b696$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $4a3e215446c0ed92$var$_extends({}, nextLocation, {
                pathname: (0, $96b280a33643b696$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $6cds3.useEffect(()=>{
        let key = String(++$4a3e215446c0ed92$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $6cds3.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $96b280a33643b696$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $4a3e215446c0ed92$var$useNavigateStable() {
    let { router: router } = $4a3e215446c0ed92$var$useDataRouterContext($4a3e215446c0ed92$var$DataRouterHook.UseNavigateStable);
    let id = $4a3e215446c0ed92$var$useCurrentRouteId($4a3e215446c0ed92$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $6cds3.useRef(false);
    $4a3e215446c0ed92$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $6cds3.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $4a3e215446c0ed92$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $4a3e215446c0ed92$var$alreadyWarned = {};
function $4a3e215446c0ed92$var$warningOnce(key, cond, message) {
    if (!cond && !$4a3e215446c0ed92$var$alreadyWarned[key]) $4a3e215446c0ed92$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $4a3e215446c0ed92$var$START_TRANSITION = "startTransition";
const $4a3e215446c0ed92$var$startTransitionImpl = $6cds3[$4a3e215446c0ed92$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $4a3e215446c0ed92$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $6cds3.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $6cds3.useCallback((newState)=>{
        if (v7_startTransition && $4a3e215446c0ed92$var$startTransitionImpl) $4a3e215446c0ed92$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $6cds3.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $6cds3.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $6cds3.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $6cds3.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $6cds3.createElement($6cds3.Fragment, null, /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $4a3e215446c0ed92$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $4a3e215446c0ed92$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $4a3e215446c0ed92$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $6cds3.useRef();
    if (historyRef.current == null) historyRef.current = (0, $96b280a33643b696$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $6cds3.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $6cds3.useCallback((newState)=>{
        v7_startTransition && $4a3e215446c0ed92$var$startTransitionImpl ? $4a3e215446c0ed92$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $6cds3.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $4a3e215446c0ed92$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$4a3e215446c0ed92$export$9c954a9d03d32f4a() && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $6cds3.useContext($4a3e215446c0ed92$export$26749e8557646306);
    let { matches: matches } = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $4a3e215446c0ed92$export$45d76561a5302f2b();
    let navigate = $4a3e215446c0ed92$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $96b280a33643b696$export$cae722b0cc860f13)(to, (0, $96b280a33643b696$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $6cds3.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $4a3e215446c0ed92$export$910ae8079b2c2852(props) {
    return $4a3e215446c0ed92$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $4a3e215446c0ed92$export$e7b0ac011bb776c6(_props) {
    (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $4a3e215446c0ed92$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $96b280a33643b696$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$4a3e215446c0ed92$export$9c954a9d03d32f4a() && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $6cds3.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $4a3e215446c0ed92$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $96b280a33643b696$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $6cds3.useMemo(()=>{
        let trailingPathname = (0, $96b280a33643b696$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $4a3e215446c0ed92$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $4a3e215446c0ed92$export$5d3fca4a98652595($4a3e215446c0ed92$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $4a3e215446c0ed92$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$ResolveAwait, null, children));
}
var $4a3e215446c0ed92$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($4a3e215446c0ed92$var$AwaitRenderStatus || {});
const $4a3e215446c0ed92$var$neverSettledPromise = new Promise(()=>{});
class $4a3e215446c0ed92$var$AwaitErrorBoundary extends $6cds3.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $4a3e215446c0ed92$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $4a3e215446c0ed92$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $4a3e215446c0ed92$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $4a3e215446c0ed92$var$AwaitRenderStatus.error : promise._data !== undefined ? $4a3e215446c0ed92$var$AwaitRenderStatus.success : $4a3e215446c0ed92$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $4a3e215446c0ed92$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $4a3e215446c0ed92$var$AwaitRenderStatus.error && promise._error instanceof (0, $96b280a33643b696$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $4a3e215446c0ed92$var$neverSettledPromise;
        if (status === $4a3e215446c0ed92$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $4a3e215446c0ed92$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $4a3e215446c0ed92$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $4a3e215446c0ed92$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $4a3e215446c0ed92$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $6cds3.createElement($6cds3.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $4a3e215446c0ed92$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $6cds3.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $6cds3.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $6cds3.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $4a3e215446c0ed92$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $4a3e215446c0ed92$export$e7b0ac011bb776c6) && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $4a3e215446c0ed92$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $4a3e215446c0ed92$export$daf73786167a7f72(matches) {
    return $4a3e215446c0ed92$var$_renderMatches(matches);
}
function $4a3e215446c0ed92$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $6cds3.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $6cds3.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $6cds3.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $4a3e215446c0ed92$export$f30f7e456d254e83(routes, opts) {
    return (0, $96b280a33643b696$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $4a3e215446c0ed92$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $96b280a33643b696$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $4a3e215446c0ed92$export$52b333d321859367
    }).initialize();
}



function $0e36e707c39d0f3a$var$_extends() {
    $0e36e707c39d0f3a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0e36e707c39d0f3a$var$_extends.apply(this, arguments);
}
function $0e36e707c39d0f3a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $0e36e707c39d0f3a$var$defaultMethod = "get";
const $0e36e707c39d0f3a$var$defaultEncType = "application/x-www-form-urlencoded";
function $0e36e707c39d0f3a$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $0e36e707c39d0f3a$var$isButtonElement(object) {
    return $0e36e707c39d0f3a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $0e36e707c39d0f3a$var$isFormElement(object) {
    return $0e36e707c39d0f3a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $0e36e707c39d0f3a$var$isInputElement(object) {
    return $0e36e707c39d0f3a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $0e36e707c39d0f3a$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $0e36e707c39d0f3a$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$0e36e707c39d0f3a$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $0e36e707c39d0f3a$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $0e36e707c39d0f3a$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $0e36e707c39d0f3a$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $0e36e707c39d0f3a$var$_formDataSupportsSubmitter = null;
function $0e36e707c39d0f3a$var$isFormDataSubmitterSupported() {
    if ($0e36e707c39d0f3a$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $0e36e707c39d0f3a$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $0e36e707c39d0f3a$var$_formDataSupportsSubmitter = true;
    }
    return $0e36e707c39d0f3a$var$_formDataSupportsSubmitter;
}
const $0e36e707c39d0f3a$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $0e36e707c39d0f3a$var$getFormEncType(encType) {
    if (encType != null && !$0e36e707c39d0f3a$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $0e36e707c39d0f3a$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($0e36e707c39d0f3a$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $96b280a33643b696$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $0e36e707c39d0f3a$var$defaultMethod;
        encType = $0e36e707c39d0f3a$var$getFormEncType(target.getAttribute("enctype")) || $0e36e707c39d0f3a$var$defaultEncType;
        formData = new FormData(target);
    } else if ($0e36e707c39d0f3a$var$isButtonElement(target) || $0e36e707c39d0f3a$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $96b280a33643b696$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $0e36e707c39d0f3a$var$defaultMethod;
        encType = $0e36e707c39d0f3a$var$getFormEncType(target.getAttribute("formenctype")) || $0e36e707c39d0f3a$var$getFormEncType(form.getAttribute("enctype")) || $0e36e707c39d0f3a$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$0e36e707c39d0f3a$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($0e36e707c39d0f3a$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $0e36e707c39d0f3a$var$defaultMethod;
        action = null;
        encType = $0e36e707c39d0f3a$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $0e36e707c39d0f3a$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $0e36e707c39d0f3a$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $0e36e707c39d0f3a$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $0e36e707c39d0f3a$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $0e36e707c39d0f3a$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $0e36e707c39d0f3a$export$1f3f55432a00e06d(routes, opts) {
    return (0, $96b280a33643b696$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $0e36e707c39d0f3a$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $96b280a33643b696$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $0e36e707c39d0f3a$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $4a3e215446c0ed92$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $0e36e707c39d0f3a$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $96b280a33643b696$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $0e36e707c39d0f3a$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $96b280a33643b696$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $0e36e707c39d0f3a$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $4a3e215446c0ed92$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $0e36e707c39d0f3a$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $0e36e707c39d0f3a$var$_extends({}, state, {
        errors: $0e36e707c39d0f3a$var$deserializeErrors(state.errors)
    });
    return state;
}
function $0e36e707c39d0f3a$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $96b280a33643b696$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $0e36e707c39d0f3a$export$7ad602f0e94e62d1 = /*#__PURE__*/ $6cds3.createContext({
    isTransitioning: false
});
const $0e36e707c39d0f3a$export$148fd98d095596d4 = /*#__PURE__*/ $6cds3.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $0e36e707c39d0f3a$var$START_TRANSITION = "startTransition";
const $0e36e707c39d0f3a$var$startTransitionImpl = $6cds3[$0e36e707c39d0f3a$var$START_TRANSITION];
const $0e36e707c39d0f3a$var$FLUSH_SYNC = "flushSync";
const $0e36e707c39d0f3a$var$flushSyncImpl = $6d4849ee44552f5f$exports[$0e36e707c39d0f3a$var$FLUSH_SYNC];
const $0e36e707c39d0f3a$var$USE_ID = "useId";
const $0e36e707c39d0f3a$var$useIdImpl = $6cds3[$0e36e707c39d0f3a$var$USE_ID];
function $0e36e707c39d0f3a$var$startTransitionSafe(cb) {
    if ($0e36e707c39d0f3a$var$startTransitionImpl) $0e36e707c39d0f3a$var$startTransitionImpl(cb);
    else cb();
}
function $0e36e707c39d0f3a$var$flushSyncSafe(cb) {
    if ($0e36e707c39d0f3a$var$flushSyncImpl) $0e36e707c39d0f3a$var$flushSyncImpl(cb);
    else cb();
}
class $0e36e707c39d0f3a$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $0e36e707c39d0f3a$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $6cds3.useState(router.state);
    let [pendingState, setPendingState] = $6cds3.useState();
    let [vtContext, setVtContext] = $6cds3.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $6cds3.useState();
    let [transition, setTransition] = $6cds3.useState();
    let [interruption, setInterruption] = $6cds3.useState();
    let fetcherData = $6cds3.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $6cds3.useCallback((cb)=>{
        if (v7_startTransition) $0e36e707c39d0f3a$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $6cds3.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $0e36e707c39d0f3a$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $0e36e707c39d0f3a$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $0e36e707c39d0f3a$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $0e36e707c39d0f3a$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $0e36e707c39d0f3a$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $6cds3.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $6cds3.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $0e36e707c39d0f3a$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $6cds3.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $6cds3.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $6cds3.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $6cds3.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $6cds3.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $6cds3.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $6cds3.createElement($6cds3.Fragment, null, /*#__PURE__*/ $6cds3.createElement((0, $4a3e215446c0ed92$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $6cds3.createElement((0, $4a3e215446c0ed92$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $6cds3.createElement($0e36e707c39d0f3a$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $6cds3.createElement($0e36e707c39d0f3a$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $6cds3.createElement((0, $4a3e215446c0ed92$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $6cds3.createElement($0e36e707c39d0f3a$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $0e36e707c39d0f3a$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $4a3e215446c0ed92$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $0e36e707c39d0f3a$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $6cds3.useRef();
    if (historyRef.current == null) historyRef.current = (0, $96b280a33643b696$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $6cds3.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $6cds3.useCallback((newState)=>{
        v7_startTransition && $0e36e707c39d0f3a$var$startTransitionImpl ? $0e36e707c39d0f3a$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $6cds3.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $6cds3.createElement((0, $4a3e215446c0ed92$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $0e36e707c39d0f3a$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $6cds3.useRef();
    if (historyRef.current == null) historyRef.current = (0, $96b280a33643b696$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $6cds3.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $6cds3.useCallback((newState)=>{
        v7_startTransition && $0e36e707c39d0f3a$var$startTransitionImpl ? $0e36e707c39d0f3a$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $6cds3.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $6cds3.createElement((0, $4a3e215446c0ed92$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $0e36e707c39d0f3a$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $6cds3.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $6cds3.useCallback((newState)=>{
        v7_startTransition && $0e36e707c39d0f3a$var$startTransitionImpl ? $0e36e707c39d0f3a$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $6cds3.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $6cds3.createElement((0, $4a3e215446c0ed92$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $0e36e707c39d0f3a$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $0e36e707c39d0f3a$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $0e36e707c39d0f3a$export$a6c7ac8248d6e38a = /*#__PURE__*/ $6cds3.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $0e36e707c39d0f3a$var$_objectWithoutPropertiesLoose(_ref7, $0e36e707c39d0f3a$var$_excluded);
    let { basename: basename } = $6cds3.useContext((0, $4a3e215446c0ed92$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $0e36e707c39d0f3a$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($0e36e707c39d0f3a$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $96b280a33643b696$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $4a3e215446c0ed92$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $0e36e707c39d0f3a$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $6cds3.createElement("a", $0e36e707c39d0f3a$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $0e36e707c39d0f3a$export$b0d92dbee9b5b60d = /*#__PURE__*/ $6cds3.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $0e36e707c39d0f3a$var$_objectWithoutPropertiesLoose(_ref8, $0e36e707c39d0f3a$var$_excluded2);
    let path = (0, $4a3e215446c0ed92$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $4a3e215446c0ed92$export$45d76561a5302f2b)();
    let routerState = $6cds3.useContext((0, $4a3e215446c0ed92$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $6cds3.useContext((0, $4a3e215446c0ed92$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $0e36e707c39d0f3a$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $96b280a33643b696$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $6cds3.createElement($0e36e707c39d0f3a$export$a6c7ac8248d6e38a, $0e36e707c39d0f3a$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $0e36e707c39d0f3a$export$a7fed597f4b8afd8 = /*#__PURE__*/ $6cds3.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $0e36e707c39d0f3a$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $0e36e707c39d0f3a$var$_objectWithoutPropertiesLoose(_ref9, $0e36e707c39d0f3a$var$_excluded3);
    let submit = $0e36e707c39d0f3a$export$47c85c6e3a081d3();
    let formAction = $0e36e707c39d0f3a$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $6cds3.createElement("form", $0e36e707c39d0f3a$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $0e36e707c39d0f3a$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $0e36e707c39d0f3a$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $0e36e707c39d0f3a$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($0e36e707c39d0f3a$var$DataRouterHook || ($0e36e707c39d0f3a$var$DataRouterHook = {}));
var $0e36e707c39d0f3a$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($0e36e707c39d0f3a$var$DataRouterStateHook || ($0e36e707c39d0f3a$var$DataRouterStateHook = {}));
// Internal hooks
function $0e36e707c39d0f3a$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $0e36e707c39d0f3a$var$useDataRouterContext(hookName) {
    let ctx = $6cds3.useContext((0, $4a3e215446c0ed92$export$3add0d5dce533e2e));
    !ctx && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    return ctx;
}
function $0e36e707c39d0f3a$var$useDataRouterState(hookName) {
    let state = $6cds3.useContext((0, $4a3e215446c0ed92$export$145dfa71566a64dc));
    !state && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $0e36e707c39d0f3a$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $4a3e215446c0ed92$export$9770f232ac06a008)();
    let location = (0, $4a3e215446c0ed92$export$45d76561a5302f2b)();
    let path = (0, $4a3e215446c0ed92$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $6cds3.useCallback((event)=>{
        if ($0e36e707c39d0f3a$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $96b280a33643b696$export$fe53371bee54353d)(location) === (0, $96b280a33643b696$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $0e36e707c39d0f3a$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $6cds3.useRef($0e36e707c39d0f3a$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $6cds3.useRef(false);
    let location = (0, $4a3e215446c0ed92$export$45d76561a5302f2b)();
    let searchParams = $6cds3.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $0e36e707c39d0f3a$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $4a3e215446c0ed92$export$9770f232ac06a008)();
    let setSearchParams = $6cds3.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $0e36e707c39d0f3a$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $0e36e707c39d0f3a$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $0e36e707c39d0f3a$var$fetcherId = 0;
let $0e36e707c39d0f3a$var$getUniqueFetcherId = ()=>"__" + String(++$0e36e707c39d0f3a$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $0e36e707c39d0f3a$export$47c85c6e3a081d3() {
    let { router: router } = $0e36e707c39d0f3a$var$useDataRouterContext($0e36e707c39d0f3a$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $6cds3.useContext((0, $4a3e215446c0ed92$export$26749e8557646306));
    let currentRouteId = (0, $4a3e215446c0ed92$export$5fc8298006ad9e58)();
    return $6cds3.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $0e36e707c39d0f3a$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $0e36e707c39d0f3a$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $0e36e707c39d0f3a$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $0e36e707c39d0f3a$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $6cds3.useContext((0, $4a3e215446c0ed92$export$26749e8557646306));
    let routeContext = $6cds3.useContext((0, $4a3e215446c0ed92$export$9072aa6dd1f93057));
    !routeContext && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $0e36e707c39d0f3a$var$_extends({}, (0, $4a3e215446c0ed92$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $4a3e215446c0ed92$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $96b280a33643b696$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $96b280a33643b696$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $0e36e707c39d0f3a$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $0e36e707c39d0f3a$var$useDataRouterContext($0e36e707c39d0f3a$var$DataRouterHook.UseFetcher);
    let state = $0e36e707c39d0f3a$var$useDataRouterState($0e36e707c39d0f3a$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $6cds3.useContext($0e36e707c39d0f3a$export$148fd98d095596d4);
    let route = $6cds3.useContext((0, $4a3e215446c0ed92$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    !route && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $0e36e707c39d0f3a$var$useIdImpl ? $0e36e707c39d0f3a$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $6cds3.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($0e36e707c39d0f3a$var$getUniqueFetcherId());
    // Registration/cleanup
    $6cds3.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $6cds3.useCallback((href, opts)=>{
        !routeId && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $0e36e707c39d0f3a$export$47c85c6e3a081d3();
    let submit = $6cds3.useCallback((target, opts)=>{
        submitImpl(target, $0e36e707c39d0f3a$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $6cds3.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $6cds3.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $6cds3.createElement($0e36e707c39d0f3a$export$a7fed597f4b8afd8, $0e36e707c39d0f3a$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $96b280a33643b696$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $6cds3.useMemo(()=>$0e36e707c39d0f3a$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $0e36e707c39d0f3a$export$fa996778a3a31087() {
    let state = $0e36e707c39d0f3a$var$useDataRouterState($0e36e707c39d0f3a$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $0e36e707c39d0f3a$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $0e36e707c39d0f3a$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $0e36e707c39d0f3a$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $0e36e707c39d0f3a$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $0e36e707c39d0f3a$var$useDataRouterContext($0e36e707c39d0f3a$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $0e36e707c39d0f3a$var$useDataRouterState($0e36e707c39d0f3a$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $6cds3.useContext((0, $4a3e215446c0ed92$export$26749e8557646306));
    let location = (0, $4a3e215446c0ed92$export$45d76561a5302f2b)();
    let matches = (0, $4a3e215446c0ed92$export$2378eb7f5ff86053)();
    let navigation = (0, $4a3e215446c0ed92$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $6cds3.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $0e36e707c39d0f3a$var$usePageHide($6cds3.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $0e36e707c39d0f3a$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $0e36e707c39d0f3a$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($0e36e707c39d0f3a$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $6cds3.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $0e36e707c39d0f3a$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $0e36e707c39d0f3a$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $6cds3.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($0e36e707c39d0f3a$var$_extends({}, location, {
                    pathname: (0, $96b280a33643b696$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($0e36e707c39d0f3a$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $6cds3.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $0e36e707c39d0f3a$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $6cds3.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $0e36e707c39d0f3a$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $6cds3.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $0e36e707c39d0f3a$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $4a3e215446c0ed92$export$b273b3273281a049)(when);
    $6cds3.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $6cds3.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $0e36e707c39d0f3a$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $6cds3.useContext($0e36e707c39d0f3a$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    let { basename: basename } = $0e36e707c39d0f3a$var$useDataRouterContext($0e36e707c39d0f3a$var$DataRouterHook.useViewTransitionState);
    let path = (0, $4a3e215446c0ed92$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $96b280a33643b696$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $96b280a33643b696$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $96b280a33643b696$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $96b280a33643b696$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}




var $c9wMV = parcelRequire("c9wMV");

var $6cds3 = parcelRequire("6cds3");


var $c9wMV = parcelRequire("c9wMV");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */ var $2f82469e03d52db2$exports = {};
function $2f82469e03d52db2$var$_extends() {
    $2f82469e03d52db2$exports = $2f82469e03d52db2$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, $2f82469e03d52db2$exports.__esModule = true, $2f82469e03d52db2$exports["default"] = $2f82469e03d52db2$exports;
    return $2f82469e03d52db2$var$_extends.apply(this, arguments);
}
$2f82469e03d52db2$exports = $2f82469e03d52db2$var$_extends, $2f82469e03d52db2$exports.__esModule = true, $2f82469e03d52db2$exports["default"] = $2f82469e03d52db2$exports;


var $95656f4756a1b6d2$export$c2f8e0cc249a8d8f = {
    // minimum relative difference between two compared values,
    // used by all comparison functions
    epsilon: 1e-12,
    // type of default matrix output. Choose 'matrix' (default) or 'array'
    matrix: "Matrix",
    // type of default number output. Choose 'number' (default) 'BigNumber', or 'Fraction
    number: "number",
    // number of significant digits in BigNumbers
    precision: 64,
    // predictable output type of functions. When true, output type depends only
    // on the input types. When false (default), output type can vary depending
    // on input values. For example `math.sqrt(-4)` returns `complex('2i')` when
    // predictable is false, and returns `NaN` when true.
    predictable: false,
    // random seed for seeded pseudo random number generation
    // null = randomly seed
    randomSeed: null
};


// type checks for all known types
//
// note that:
//
// - check by duck-typing on a property like `isUnit`, instead of checking instanceof.
//   instanceof cannot be used because that would not allow to pass data from
//   one instance of math.js to another since each has it's own instance of Unit.
// - check the `isUnit` property via the constructor, so there will be no
//   matches for "fake" instances like plain objects with a property `isUnit`.
//   That is important for security reasons.
// - It must not be possible to override the type checks used internally,
//   for security reasons, so these functions are not exposed in the expression
//   parser.
function $d8097b7a6d6e36d8$export$7e4aa119212bc614(x) {
    return typeof x === "number";
}
function $d8097b7a6d6e36d8$export$e51d0e7e5c4a03ab(x) {
    if (!x || typeof x !== "object" || typeof x.constructor !== "function") return false;
    if (x.isBigNumber === true && typeof x.constructor.prototype === "object" && x.constructor.prototype.isBigNumber === true) return true;
    if (typeof x.constructor.isDecimal === "function" && x.constructor.isDecimal(x) === true) return true;
    return false;
}
function $d8097b7a6d6e36d8$export$8849a896711efe0c(x) {
    return x && typeof x === "object" && Object.getPrototypeOf(x).isComplex === true || false;
}
function $d8097b7a6d6e36d8$export$e312cb8a8e5e7c34(x) {
    return x && typeof x === "object" && Object.getPrototypeOf(x).isFraction === true || false;
}
function $d8097b7a6d6e36d8$export$8960dc335987b8da(x) {
    return x && x.constructor.prototype.isUnit === true || false;
}
function $d8097b7a6d6e36d8$export$844ec244b1367d54(x) {
    return typeof x === "string";
}
var $d8097b7a6d6e36d8$export$43bee75e5e14138e = Array.isArray;
function $d8097b7a6d6e36d8$export$b22160e0a14f87b7(x) {
    return x && x.constructor.prototype.isMatrix === true || false;
}
function $d8097b7a6d6e36d8$export$cea7aa84e978eba5(x) {
    return Array.isArray(x) || $d8097b7a6d6e36d8$export$b22160e0a14f87b7(x);
}
function $d8097b7a6d6e36d8$export$eb44495df7ba11d(x) {
    return x && x.isDenseMatrix && x.constructor.prototype.isMatrix === true || false;
}
function $d8097b7a6d6e36d8$export$d508368d4da3c38a(x) {
    return x && x.isSparseMatrix && x.constructor.prototype.isMatrix === true || false;
}
function $d8097b7a6d6e36d8$export$e331ccfa6f694c99(x) {
    return x && x.constructor.prototype.isRange === true || false;
}
function $d8097b7a6d6e36d8$export$ba3dc792055c2f45(x) {
    return x && x.constructor.prototype.isIndex === true || false;
}
function $d8097b7a6d6e36d8$export$f9ce7b637dfbe238(x) {
    return typeof x === "boolean";
}
function $d8097b7a6d6e36d8$export$381a1a20e6a63376(x) {
    return x && x.constructor.prototype.isResultSet === true || false;
}
function $d8097b7a6d6e36d8$export$e5dec9a75b602d6c(x) {
    return x && x.constructor.prototype.isHelp === true || false;
}
function $d8097b7a6d6e36d8$export$f6e2535fb5126e54(x) {
    return typeof x === "function";
}
function $d8097b7a6d6e36d8$export$871608497c498473(x) {
    return x instanceof Date;
}
function $d8097b7a6d6e36d8$export$49841c62b9eff15(x) {
    return x instanceof RegExp;
}
function $d8097b7a6d6e36d8$export$a6cdc56e425d0d0a(x) {
    return !!(x && typeof x === "object" && x.constructor === Object && !$d8097b7a6d6e36d8$export$8849a896711efe0c(x) && !$d8097b7a6d6e36d8$export$e312cb8a8e5e7c34(x));
}
function $d8097b7a6d6e36d8$export$630801d484da15df(x) {
    return x === null;
}
function $d8097b7a6d6e36d8$export$fce6876652108ab(x) {
    return x === undefined;
}
function $d8097b7a6d6e36d8$export$f88fb19d6b9ee5cb(x) {
    return x && x.isAccessorNode === true && x.constructor.prototype.isNode === true || false;
}
function $d8097b7a6d6e36d8$export$440fa93dcf2757a3(x) {
    return x && x.isArrayNode === true && x.constructor.prototype.isNode === true || false;
}
function $d8097b7a6d6e36d8$export$64d7d515ec030d5e(x) {
    return x && x.isAssignmentNode === true && x.constructor.prototype.isNode === true || false;
}
function $d8097b7a6d6e36d8$export$1665e2275a3d717a(x) {
    return x && x.isBlockNode === true && x.constructor.prototype.isNode === true || false;
}
function $d8097b7a6d6e36d8$export$e1babefe78c70737(x) {
    return x && x.isConditionalNode === true && x.constructor.prototype.isNode === true || false;
}
function $d8097b7a6d6e36d8$export$fa9d80731fd8c54b(x) {
    return x && x.isConstantNode === true && x.constructor.prototype.isNode === true || false;
}
function $d8097b7a6d6e36d8$export$27c05cfffd263d30(x) {
    return x && x.isFunctionAssignmentNode === true && x.constructor.prototype.isNode === true || false;
}
function $d8097b7a6d6e36d8$export$6ae03b16e064e6c4(x) {
    return x && x.isFunctionNode === true && x.constructor.prototype.isNode === true || false;
}
function $d8097b7a6d6e36d8$export$ff90979121a6cabc(x) {
    return x && x.isIndexNode === true && x.constructor.prototype.isNode === true || false;
}
function $d8097b7a6d6e36d8$export$8ee0fc9ee280b4ee(x) {
    return x && x.isNode === true && x.constructor.prototype.isNode === true || false;
}
function $d8097b7a6d6e36d8$export$3f18867a334658e9(x) {
    return x && x.isObjectNode === true && x.constructor.prototype.isNode === true || false;
}
function $d8097b7a6d6e36d8$export$7e624cbaab6cce94(x) {
    return x && x.isOperatorNode === true && x.constructor.prototype.isNode === true || false;
}
function $d8097b7a6d6e36d8$export$c55e3736c5721220(x) {
    return x && x.isParenthesisNode === true && x.constructor.prototype.isNode === true || false;
}
function $d8097b7a6d6e36d8$export$92729c5c4ff6fc83(x) {
    return x && x.isRangeNode === true && x.constructor.prototype.isNode === true || false;
}
function $d8097b7a6d6e36d8$export$87815d550facaed9(x) {
    return x && x.isSymbolNode === true && x.constructor.prototype.isNode === true || false;
}
function $d8097b7a6d6e36d8$export$dc36953d0b3a4f05(x) {
    return x && x.constructor.prototype.isChain === true || false;
}
function $d8097b7a6d6e36d8$export$f5bbd400c2f4426f(x) {
    var t = typeof x;
    if (t === "object") {
        // JavaScript types
        if (x === null) return "null";
        if (Array.isArray(x)) return "Array";
        if (x instanceof Date) return "Date";
        if (x instanceof RegExp) return "RegExp"; // math.js types
        if ($d8097b7a6d6e36d8$export$e51d0e7e5c4a03ab(x)) return "BigNumber";
        if ($d8097b7a6d6e36d8$export$8849a896711efe0c(x)) return "Complex";
        if ($d8097b7a6d6e36d8$export$e312cb8a8e5e7c34(x)) return "Fraction";
        if ($d8097b7a6d6e36d8$export$b22160e0a14f87b7(x)) return "Matrix";
        if ($d8097b7a6d6e36d8$export$8960dc335987b8da(x)) return "Unit";
        if ($d8097b7a6d6e36d8$export$ba3dc792055c2f45(x)) return "Index";
        if ($d8097b7a6d6e36d8$export$e331ccfa6f694c99(x)) return "Range";
        if ($d8097b7a6d6e36d8$export$381a1a20e6a63376(x)) return "ResultSet";
        if ($d8097b7a6d6e36d8$export$8ee0fc9ee280b4ee(x)) return x.type;
        if ($d8097b7a6d6e36d8$export$dc36953d0b3a4f05(x)) return "Chain";
        if ($d8097b7a6d6e36d8$export$e5dec9a75b602d6c(x)) return "Help";
        return "Object";
    }
    if (t === "function") return "Function";
    return t; // can be 'string', 'number', 'boolean', ...
}


function $6819694788cbfa38$export$9cd59f9826255e47(x) {
    var type = typeof x; // immutable primitive types
    if (type === "number" || type === "string" || type === "boolean" || x === null || x === undefined) return x;
     // use clone function of the object when available
    if (typeof x.clone === "function") return x.clone();
     // array
    if (Array.isArray(x)) return x.map(function(value) {
        return $6819694788cbfa38$export$9cd59f9826255e47(value);
    });
    if (x instanceof Date) return new Date(x.valueOf());
    if ((0, $d8097b7a6d6e36d8$export$e51d0e7e5c4a03ab)(x)) return x; // bignumbers are immutable
    if (x instanceof RegExp) throw new TypeError("Cannot clone " + x); // TODO: clone a RegExp
    // object
    return $6819694788cbfa38$export$d6051a0f7a227332(x, $6819694788cbfa38$export$9cd59f9826255e47);
}
function $6819694788cbfa38$export$d6051a0f7a227332(object, callback) {
    var clone = {};
    for(var key in object)if ($6819694788cbfa38$export$5a15a386532a5ea4(object, key)) clone[key] = callback(object[key]);
    return clone;
}
function $6819694788cbfa38$export$8b58be045bf06082(a, b) {
    for(var prop in b)if ($6819694788cbfa38$export$5a15a386532a5ea4(b, prop)) a[prop] = b[prop];
    return a;
}
function $6819694788cbfa38$export$54e9fb29908872fa(a, b) {
    // TODO: add support for Arrays to deepExtend
    if (Array.isArray(b)) throw new TypeError("Arrays are not supported by deepExtend");
    for(var prop in b)// We check against prop not being in Object.prototype or Function.prototype
    // to prevent polluting for example Object.__proto__.
    if ($6819694788cbfa38$export$5a15a386532a5ea4(b, prop) && !(prop in Object.prototype) && !(prop in Function.prototype)) {
        if (b[prop] && b[prop].constructor === Object) {
            if (a[prop] === undefined) a[prop] = {};
            if (a[prop] && a[prop].constructor === Object) $6819694788cbfa38$export$54e9fb29908872fa(a[prop], b[prop]);
            else a[prop] = b[prop];
        } else if (Array.isArray(b[prop])) throw new TypeError("Arrays are not supported by deepExtend");
        else a[prop] = b[prop];
    }
    return a;
}
function $6819694788cbfa38$export$6cc798251952180(a, b) {
    var prop, i, len;
    if (Array.isArray(a)) {
        if (!Array.isArray(b)) return false;
        if (a.length !== b.length) return false;
        for(i = 0, len = a.length; i < len; i++){
            if (!$6819694788cbfa38$export$6cc798251952180(a[i], b[i])) return false;
        }
        return true;
    } else if (typeof a === "function") return a === b;
    else if (a instanceof Object) {
        if (Array.isArray(b) || !(b instanceof Object)) return false;
        for(prop in a){
            // noinspection JSUnfilteredForInLoop
            if (!(prop in b) || !$6819694788cbfa38$export$6cc798251952180(a[prop], b[prop])) return false;
        }
        for(prop in b){
            // noinspection JSUnfilteredForInLoop
            if (!(prop in a)) return false;
        }
        return true;
    } else return a === b;
}
function $6819694788cbfa38$export$519b2d75cc54d03b(nestedObject) {
    var flattenedObject = {};
    $6819694788cbfa38$var$_deepFlatten(nestedObject, flattenedObject);
    return flattenedObject;
} // helper function used by deepFlatten
function $6819694788cbfa38$var$_deepFlatten(nestedObject, flattenedObject) {
    for(var prop in nestedObject)if ($6819694788cbfa38$export$5a15a386532a5ea4(nestedObject, prop)) {
        var value = nestedObject[prop];
        if (typeof value === "object" && value !== null) $6819694788cbfa38$var$_deepFlatten(value, flattenedObject);
        else flattenedObject[prop] = value;
    }
}
function $6819694788cbfa38$export$a73e197d57374bd3() {
    // test needed for broken IE8 implementation
    try {
        if (Object.defineProperty) {
            Object.defineProperty({}, "x", {
                get: function get() {
                    return null;
                }
            });
            return true;
        }
    } catch (e) {}
    return false;
}
function $6819694788cbfa38$export$488013bae63b21da(object, prop, valueResolver) {
    var _uninitialized = true;
    var _value;
    Object.defineProperty(object, prop, {
        get: function get() {
            if (_uninitialized) {
                _value = valueResolver();
                _uninitialized = false;
            }
            return _value;
        },
        set: function set(value) {
            _value = value;
            _uninitialized = false;
        },
        configurable: true,
        enumerable: true
    });
}
function $6819694788cbfa38$export$df3f009e3d155b20(object, path) {
    if (path && typeof path === "string") return $6819694788cbfa38$export$df3f009e3d155b20(object, path.split("."));
    var obj = object;
    if (path) for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (!(key in obj)) obj[key] = {};
        obj = obj[key];
    }
    return obj;
}
function $6819694788cbfa38$export$5a15a386532a5ea4(object, property) {
    return object && Object.hasOwnProperty.call(object, property);
}
function $6819694788cbfa38$export$1bc2c269dfa97885(object) {
    return object && typeof object.factory === "function";
}
function $6819694788cbfa38$export$3988ae62b71be9a3(object, path) {
    if (typeof path === "string") {
        if ($6819694788cbfa38$var$isPath(path)) return $6819694788cbfa38$export$3988ae62b71be9a3(object, path.split("."));
        else return object[path];
    }
    var child = object;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        child = child ? child[key] : undefined;
    }
    return child;
}
function $6819694788cbfa38$export$adaa4cf7ef1b65be(object, path, value) {
    if (typeof path === "string") {
        if ($6819694788cbfa38$var$isPath(path)) return $6819694788cbfa38$export$adaa4cf7ef1b65be(object, path.split("."), value);
        else {
            object[path] = value;
            return object;
        }
    }
    var child = object;
    for(var i = 0; i < path.length - 1; i++){
        var key = path[i];
        if (child[key] === undefined) child[key] = {};
        child = child[key];
    }
    if (path.length > 0) {
        var lastKey = path[path.length - 1];
        child[lastKey] = value;
    }
    return object;
}
function $6819694788cbfa38$export$357523c63a2253b9(object, properties, transform) {
    var copy = {};
    for(var i = 0; i < properties.length; i++){
        var key = properties[i];
        var value = $6819694788cbfa38$export$3988ae62b71be9a3(object, key);
        if (value !== undefined) $6819694788cbfa38$export$adaa4cf7ef1b65be(copy, key, transform ? transform(value, key) : value);
    }
    return copy;
}
function $6819694788cbfa38$export$8cea971c64639ea7(object, properties) {
    var copy = {};
    for(var i = 0; i < properties.length; i++){
        var key = properties[i];
        var value = object[key];
        if (value !== undefined) copy[key] = value;
    }
    return copy;
}
function $6819694788cbfa38$export$68c286be0e7e55b7(object) {
    return Object.keys(object).map((key)=>object[key]);
} // helper function to test whether a string contains a path like 'user.name'
function $6819694788cbfa38$var$isPath(str) {
    return str.indexOf(".") !== -1;
}



var $163ac21b7b40b65d$export$517ab898194ae9af = [
    "Matrix",
    "Array"
]; // valid values for option matrix
var $163ac21b7b40b65d$export$f4b0a2084fdf2177 = [
    "number",
    "BigNumber",
    "Fraction"
]; // valid values for option number
function $163ac21b7b40b65d$export$3984aa6f7f77f1ae(config, emit) {
    /**
   * Set configuration options for math.js, and get current options.
   * Will emit a 'config' event, with arguments (curr, prev, changes).
   *
   * This function is only available on a mathjs instance created using `create`.
   *
   * Syntax:
   *
   *     math.config(config: Object): Object
   *
   * Examples:
   *
   *
   *     import { create, all } from 'mathjs'
   *
   *     // create a mathjs instance
   *     const math = create(all)
   *
   *     math.config().number                // outputs 'number'
   *     math.evaluate('0.4')                // outputs number 0.4
   *     math.config({number: 'Fraction'})
   *     math.evaluate('0.4')                // outputs Fraction 2/5
   *
   * @param {Object} [options] Available options:
   *                            {number} epsilon
   *                              Minimum relative difference between two
   *                              compared values, used by all comparison functions.
   *                            {string} matrix
   *                              A string 'Matrix' (default) or 'Array'.
   *                            {string} number
   *                              A string 'number' (default), 'BigNumber', or 'Fraction'
   *                            {number} precision
   *                              The number of significant digits for BigNumbers.
   *                              Not applicable for Numbers.
   *                            {string} parenthesis
   *                              How to display parentheses in LaTeX and string
   *                              output.
   *                            {string} randomSeed
   *                              Random seed for seeded pseudo random number generator.
   *                              Set to null to randomly seed.
   * @return {Object} Returns the current configuration
   */ function _config(options) {
        if (options) {
            var prev = (0, $6819694788cbfa38$export$d6051a0f7a227332)(config, (0, $6819694788cbfa38$export$9cd59f9826255e47)); // validate some of the options
            $163ac21b7b40b65d$var$validateOption(options, "matrix", $163ac21b7b40b65d$export$517ab898194ae9af);
            $163ac21b7b40b65d$var$validateOption(options, "number", $163ac21b7b40b65d$export$f4b0a2084fdf2177); // merge options
            (0, $6819694788cbfa38$export$54e9fb29908872fa)(config, options);
            var curr = (0, $6819694788cbfa38$export$d6051a0f7a227332)(config, (0, $6819694788cbfa38$export$9cd59f9826255e47));
            var changes = (0, $6819694788cbfa38$export$d6051a0f7a227332)(options, (0, $6819694788cbfa38$export$9cd59f9826255e47)); // emit 'config' event
            emit("config", curr, prev, changes);
            return curr;
        } else return (0, $6819694788cbfa38$export$d6051a0f7a227332)(config, (0, $6819694788cbfa38$export$9cd59f9826255e47));
    } // attach the valid options to the function so they can be extended
    _config.MATRIX_OPTIONS = $163ac21b7b40b65d$export$517ab898194ae9af;
    _config.NUMBER_OPTIONS = $163ac21b7b40b65d$export$f4b0a2084fdf2177; // attach the config properties as readonly properties to the config function
    Object.keys((0, $95656f4756a1b6d2$export$c2f8e0cc249a8d8f)).forEach((key)=>{
        Object.defineProperty(_config, key, {
            get: ()=>config[key],
            enumerable: true,
            configurable: true
        });
    });
    return _config;
}
/**
 * Test whether an Array contains a specific item.
 * @param {Array.<string>} array
 * @param {string} item
 * @return {boolean}
 */ function $163ac21b7b40b65d$var$contains(array, item) {
    return array.indexOf(item) !== -1;
}
/**
 * Validate an option
 * @param {Object} options         Object with options
 * @param {string} name            Name of the option to validate
 * @param {Array.<string>} values  Array with valid values for this option
 */ function $163ac21b7b40b65d$var$validateOption(options, name, values) {
    if (options[name] !== undefined && !$163ac21b7b40b65d$var$contains(values, options[name])) // unknown value
    console.warn('Warning: Unknown value "' + options[name] + '" for configuration option "' + name + '". ' + "Available options: " + values.map((value)=>JSON.stringify(value)).join(", ") + ".");
}


var $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20 = /* #__PURE__ */ function config(options) {
    if (options) throw new Error("The global config is readonly. \nPlease create a mathjs instance if you want to change the default configuration. \nExample:\n\n  import { create, all } from 'mathjs';\n  const mathjs = create(all);\n  mathjs.config({ number: 'BigNumber' });\n");
    return Object.freeze((0, $95656f4756a1b6d2$export$c2f8e0cc249a8d8f));
};
(0, (/*@__PURE__*/$parcel$interopDefault($2f82469e03d52db2$exports)))($3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20, (0, $95656f4756a1b6d2$export$c2f8e0cc249a8d8f), {
    MATRIX_OPTIONS: $163ac21b7b40b65d$export$517ab898194ae9af,
    NUMBER_OPTIONS: $163ac21b7b40b65d$export$f4b0a2084fdf2177
});



var $4qPUL = parcelRequire("4qPUL");

function $668e051498bf5fa0$export$a287f47fed4544b8(value) {
    if (typeof value === "boolean") return true;
    return isFinite(value) ? value === Math.round(value) : false;
}
var $668e051498bf5fa0$export$c5552dfdbc7cec71 = /* #__PURE__ */ Math.sign || function(x) {
    if (x > 0) return 1;
    else if (x < 0) return -1;
    else return 0;
};
var $668e051498bf5fa0$export$b9fae0bba9d9094d = /* #__PURE__ */ Math.log2 || function log2(x) {
    return Math.log(x) / Math.LN2;
};
var $668e051498bf5fa0$export$75e08744a3ff8516 = /* #__PURE__ */ Math.log10 || function log10(x) {
    return Math.log(x) / Math.LN10;
};
var $668e051498bf5fa0$export$144dcf16adfb9698 = /* #__PURE__ */ Math.log1p || function(x) {
    return Math.log(x + 1);
};
var $668e051498bf5fa0$export$841fc4d5a1480b85 = /* #__PURE__ */ Math.cbrt || function cbrt(x) {
    if (x === 0) return x;
    var negate = x < 0;
    var result;
    if (negate) x = -x;
    if (isFinite(x)) {
        result = Math.exp(Math.log(x) / 3); // from https://en.wikipedia.org/wiki/Cube_root#Numerical_methods
        result = (x / (result * result) + 2 * result) / 3;
    } else result = x;
    return negate ? -result : result;
};
var $668e051498bf5fa0$export$b6c0a80d46d3391d = /* #__PURE__ */ Math.expm1 || function expm1(x) {
    return x >= 2e-4 || x <= -0.0002 ? Math.exp(x) - 1 : x + x * x / 2 + x * x * x / 6;
};
/**
 * Formats a number in a given base
 * @param {number} n
 * @param {number} base
 * @param {number} size
 * @returns {string}
 */ function $668e051498bf5fa0$var$formatNumberToBase(n, base, size) {
    var prefixes = {
        2: "0b",
        8: "0o",
        16: "0x"
    };
    var prefix = prefixes[base];
    var suffix = "";
    if (size) {
        if (size < 1) throw new Error("size must be in greater than 0");
        if (!$668e051498bf5fa0$export$a287f47fed4544b8(size)) throw new Error("size must be an integer");
        if (n > 2 ** (size - 1) - 1 || n < -(2 ** (size - 1))) throw new Error("Value must be in range [-2^".concat(size - 1, ", 2^").concat(size - 1, "-1]"));
        if (!$668e051498bf5fa0$export$a287f47fed4544b8(n)) throw new Error("Value must be an integer");
        if (n < 0) n = n + 2 ** size;
        suffix = "i".concat(size);
    }
    var sign = "";
    if (n < 0) {
        n = -n;
        sign = "-";
    }
    return "".concat(sign).concat(prefix).concat(n.toString(base)).concat(suffix);
}
function $668e051498bf5fa0$export$d9468344d3651243(value, options) {
    if (typeof options === "function") // handle format(value, fn)
    return options(value);
     // handle special cases
    if (value === Infinity) return "Infinity";
    else if (value === -Infinity) return "-Infinity";
    else if (isNaN(value)) return "NaN";
     // default values for options
    var notation = "auto";
    var precision;
    var wordSize;
    if (options) {
        // determine notation from options
        if (options.notation) notation = options.notation;
         // determine precision from options
        if ((0, $d8097b7a6d6e36d8$export$7e4aa119212bc614)(options)) precision = options;
        else if ((0, $d8097b7a6d6e36d8$export$7e4aa119212bc614)(options.precision)) precision = options.precision;
        if (options.wordSize) {
            wordSize = options.wordSize;
            if (typeof wordSize !== "number") throw new Error('Option "wordSize" must be a number');
        }
    } // handle the various notations
    switch(notation){
        case "fixed":
            return $668e051498bf5fa0$export$a81f732198733497(value, precision);
        case "exponential":
            return $668e051498bf5fa0$export$888cb08ddc4765be(value, precision);
        case "engineering":
            return $668e051498bf5fa0$export$9299fe684ed0ee48(value, precision);
        case "bin":
            return $668e051498bf5fa0$var$formatNumberToBase(value, 2, wordSize);
        case "oct":
            return $668e051498bf5fa0$var$formatNumberToBase(value, 8, wordSize);
        case "hex":
            return $668e051498bf5fa0$var$formatNumberToBase(value, 16, wordSize);
        case "auto":
            // remove trailing zeros after the decimal point
            return $668e051498bf5fa0$export$3e91a10e66078270(value, precision, options && options).replace(/((\.\d*?)(0+))($|e)/, function() {
                var digits = arguments[2];
                var e = arguments[4];
                return digits !== "." ? digits + e : e;
            });
        default:
            throw new Error('Unknown notation "' + notation + '". ' + 'Choose "auto", "exponential", "fixed", "bin", "oct", or "hex.');
    }
}
function $668e051498bf5fa0$export$feb80e120a50087f(value) {
    // parse the input value
    var match = String(value).toLowerCase().match(/^(-?)(\d+\.?\d*)(e([+-]?\d+))?$/);
    if (!match) throw new SyntaxError("Invalid number " + value);
    var sign = match[1];
    var digits = match[2];
    var exponent = parseFloat(match[4] || "0");
    var dot = digits.indexOf(".");
    exponent += dot !== -1 ? dot - 1 : digits.length - 1;
    var coefficients = digits.replace(".", "") // remove the dot (must be removed before removing leading zeros)
    .replace(/^0*/, function(zeros) {
        // remove leading zeros, add their count to the exponent
        exponent -= zeros.length;
        return "";
    }).replace(/0*$/, "") // remove trailing zeros
    .split("").map(function(d) {
        return parseInt(d);
    });
    if (coefficients.length === 0) {
        coefficients.push(0);
        exponent++;
    }
    return {
        sign: sign,
        coefficients: coefficients,
        exponent: exponent
    };
}
function $668e051498bf5fa0$export$9299fe684ed0ee48(value, precision) {
    if (isNaN(value) || !isFinite(value)) return String(value);
    var split = $668e051498bf5fa0$export$feb80e120a50087f(value);
    var rounded = $668e051498bf5fa0$export$e5b32ced877afc7e(split, precision);
    var e = rounded.exponent;
    var c = rounded.coefficients; // find nearest lower multiple of 3 for exponent
    var newExp = e % 3 === 0 ? e : e < 0 ? e - 3 - e % 3 : e - e % 3;
    if ((0, $d8097b7a6d6e36d8$export$7e4aa119212bc614)(precision)) // add zeroes to give correct sig figs
    while(precision > c.length || e - newExp + 1 > c.length)c.push(0);
    else {
        // concatenate coefficients with necessary zeros
        // add zeros if necessary (for example: 1e+8 -> 100e+6)
        var missingZeros = Math.abs(e - newExp) - (c.length - 1);
        for(var i = 0; i < missingZeros; i++)c.push(0);
    } // find difference in exponents
    var expDiff = Math.abs(e - newExp);
    var decimalIdx = 1; // push decimal index over by expDiff times
    while(expDiff > 0){
        decimalIdx++;
        expDiff--;
    } // if all coefficient values are zero after the decimal point and precision is unset, don't add a decimal value.
    // otherwise concat with the rest of the coefficients
    var decimals = c.slice(decimalIdx).join("");
    var decimalVal = (0, $d8097b7a6d6e36d8$export$7e4aa119212bc614)(precision) && decimals.length || decimals.match(/[1-9]/) ? "." + decimals : "";
    var str = c.slice(0, decimalIdx).join("") + decimalVal + "e" + (e >= 0 ? "+" : "") + newExp.toString();
    return rounded.sign + str;
}
function $668e051498bf5fa0$export$a81f732198733497(value, precision) {
    if (isNaN(value) || !isFinite(value)) return String(value);
    var splitValue = $668e051498bf5fa0$export$feb80e120a50087f(value);
    var rounded = typeof precision === "number" ? $668e051498bf5fa0$export$e5b32ced877afc7e(splitValue, splitValue.exponent + 1 + precision) : splitValue;
    var c = rounded.coefficients;
    var p = rounded.exponent + 1; // exponent may have changed
    // append zeros if needed
    var pp = p + (precision || 0);
    if (c.length < pp) c = c.concat($668e051498bf5fa0$var$zeros(pp - c.length));
     // prepend zeros if needed
    if (p < 0) {
        c = $668e051498bf5fa0$var$zeros(-p + 1).concat(c);
        p = 1;
    } // insert a dot if needed
    if (p < c.length) c.splice(p, 0, p === 0 ? "0." : ".");
    return rounded.sign + c.join("");
}
function $668e051498bf5fa0$export$888cb08ddc4765be(value, precision) {
    if (isNaN(value) || !isFinite(value)) return String(value);
     // round if needed, else create a clone
    var split = $668e051498bf5fa0$export$feb80e120a50087f(value);
    var rounded = precision ? $668e051498bf5fa0$export$e5b32ced877afc7e(split, precision) : split;
    var c = rounded.coefficients;
    var e = rounded.exponent; // append zeros if needed
    if (c.length < precision) c = c.concat($668e051498bf5fa0$var$zeros(precision - c.length));
     // format as `C.CCCe+EEE` or `C.CCCe-EEE`
    var first = c.shift();
    return rounded.sign + first + (c.length > 0 ? "." + c.join("") : "") + "e" + (e >= 0 ? "+" : "") + e;
}
function $668e051498bf5fa0$export$3e91a10e66078270(value, precision, options) {
    if (isNaN(value) || !isFinite(value)) return String(value);
     // determine lower and upper bound for exponential notation.
    var lowerExp = options && options.lowerExp !== undefined ? options.lowerExp : -3;
    var upperExp = options && options.upperExp !== undefined ? options.upperExp : 5;
    var split = $668e051498bf5fa0$export$feb80e120a50087f(value);
    var rounded = precision ? $668e051498bf5fa0$export$e5b32ced877afc7e(split, precision) : split;
    if (rounded.exponent < lowerExp || rounded.exponent >= upperExp) // exponential notation
    return $668e051498bf5fa0$export$888cb08ddc4765be(value, precision);
    else {
        var c = rounded.coefficients;
        var e = rounded.exponent; // append trailing zeros
        if (c.length < precision) c = c.concat($668e051498bf5fa0$var$zeros(precision - c.length));
         // append trailing zeros
        // TODO: simplify the next statement
        c = c.concat($668e051498bf5fa0$var$zeros(e - c.length + 1 + (c.length < precision ? precision - c.length : 0))); // prepend zeros
        c = $668e051498bf5fa0$var$zeros(-e).concat(c);
        var dot = e > 0 ? e : 0;
        if (dot < c.length - 1) c.splice(dot + 1, 0, ".");
        return rounded.sign + c.join("");
    }
}
function $668e051498bf5fa0$export$e5b32ced877afc7e(split, precision) {
    // create a clone
    var rounded = {
        sign: split.sign,
        coefficients: split.coefficients,
        exponent: split.exponent
    };
    var c = rounded.coefficients; // prepend zeros if needed
    while(precision <= 0){
        c.unshift(0);
        rounded.exponent++;
        precision++;
    }
    if (c.length > precision) {
        var removed = c.splice(precision, c.length - precision);
        if (removed[0] >= 5) {
            var i = precision - 1;
            c[i]++;
            while(c[i] === 10){
                c.pop();
                if (i === 0) {
                    c.unshift(0);
                    rounded.exponent++;
                    i++;
                }
                i--;
                c[i]++;
            }
        }
    }
    return rounded;
}
/**
 * Create an array filled with zeros.
 * @param {number} length
 * @return {Array}
 */ function $668e051498bf5fa0$var$zeros(length) {
    var arr = [];
    for(var i = 0; i < length; i++)arr.push(0);
    return arr;
}
function $668e051498bf5fa0$export$9c0987062f8f5d89(value) {
    return value.toExponential().replace(/e.*$/, "") // remove exponential notation
    .replace(/^0\.?0*|\./, "") // remove decimal point and leading zeros
    .length;
}
var $668e051498bf5fa0$export$41b54fa1db30dbb5 = Number.EPSILON || 2.2204460492503130808472633361816E-16;
function $668e051498bf5fa0$export$6f3989c6ecc04081(x, y, epsilon) {
    // if epsilon is null or undefined, test whether x and y are exactly equal
    if (epsilon === null || epsilon === undefined) return x === y;
    if (x === y) return true;
     // NaN
    if (isNaN(x) || isNaN(y)) return false;
     // at this point x and y should be finite
    if (isFinite(x) && isFinite(y)) {
        // check numbers are very close, needed when comparing numbers near zero
        var diff = Math.abs(x - y);
        if (diff < $668e051498bf5fa0$export$41b54fa1db30dbb5) return true;
        else // use relative error
        return diff <= Math.max(Math.abs(x), Math.abs(y)) * epsilon;
    } // Infinite and Number or negative Infinite and positive Infinite cases
    return false;
}
var $668e051498bf5fa0$export$b26caf0f29211d08 = Math.acosh || function(x) {
    return Math.log(Math.sqrt(x * x - 1) + x);
};
var $668e051498bf5fa0$export$839d8a01b6af4fc0 = Math.asinh || function(x) {
    return Math.log(Math.sqrt(x * x + 1) + x);
};
var $668e051498bf5fa0$export$21ea955025ceb08b = Math.atanh || function(x) {
    return Math.log((1 + x) / (1 - x)) / 2;
};
var $668e051498bf5fa0$export$2e2fd1ad24e4d350 = Math.cosh || function(x) {
    return (Math.exp(x) + Math.exp(-x)) / 2;
};
var $668e051498bf5fa0$export$545004b505d7c555 = Math.sinh || function(x) {
    return (Math.exp(x) - Math.exp(-x)) / 2;
};
var $668e051498bf5fa0$export$7128670e45beef9a = Math.tanh || function(x) {
    var e = Math.exp(2 * x);
    return (e - 1) / (e + 1);
};
function $668e051498bf5fa0$export$fe7b50dc6162f97e(x, y) {
    var signx = x > 0 ? true : x < 0 ? false : 1 / x === Infinity;
    var signy = y > 0 ? true : y < 0 ? false : 1 / y === Infinity;
    return signx ^ signy ? -x : x;
}






/**
 * Formats a BigNumber in a given base
 * @param {BigNumber} n
 * @param {number} base
 * @param {number} size
 * @returns {string}
 */ function $1e37934caf7cc870$var$formatBigNumberToBase(n, base, size) {
    var BigNumberCtor = n.constructor;
    var big2 = new BigNumberCtor(2);
    var suffix = "";
    if (size) {
        if (size < 1) throw new Error("size must be in greater than 0");
        if (!(0, $668e051498bf5fa0$export$a287f47fed4544b8)(size)) throw new Error("size must be an integer");
        if (n.greaterThan(big2.pow(size - 1).sub(1)) || n.lessThan(big2.pow(size - 1).mul(-1))) throw new Error("Value must be in range [-2^".concat(size - 1, ", 2^").concat(size - 1, "-1]"));
        if (!n.isInteger()) throw new Error("Value must be an integer");
        if (n.lessThan(0)) n = n.add(big2.pow(size));
        suffix = "i".concat(size);
    }
    switch(base){
        case 2:
            return "".concat(n.toBinary()).concat(suffix);
        case 8:
            return "".concat(n.toOctal()).concat(suffix);
        case 16:
            return "".concat(n.toHexadecimal()).concat(suffix);
        default:
            throw new Error("Base ".concat(base, " not supported "));
    }
}
function $1e37934caf7cc870$export$d9468344d3651243(value, options) {
    if (typeof options === "function") // handle format(value, fn)
    return options(value);
     // handle special cases
    if (!value.isFinite()) return value.isNaN() ? "NaN" : value.gt(0) ? "Infinity" : "-Infinity";
     // default values for options
    var notation = "auto";
    var precision;
    var wordSize;
    if (options !== undefined) {
        // determine notation from options
        if (options.notation) notation = options.notation;
         // determine precision from options
        if (typeof options === "number") precision = options;
        else if (options.precision) precision = options.precision;
        if (options.wordSize) {
            wordSize = options.wordSize;
            if (typeof wordSize !== "number") throw new Error('Option "wordSize" must be a number');
        }
    } // handle the various notations
    switch(notation){
        case "fixed":
            return $1e37934caf7cc870$export$a81f732198733497(value, precision);
        case "exponential":
            return $1e37934caf7cc870$export$888cb08ddc4765be(value, precision);
        case "engineering":
            return $1e37934caf7cc870$export$9299fe684ed0ee48(value, precision);
        case "bin":
            return $1e37934caf7cc870$var$formatBigNumberToBase(value, 2, wordSize);
        case "oct":
            return $1e37934caf7cc870$var$formatBigNumberToBase(value, 8, wordSize);
        case "hex":
            return $1e37934caf7cc870$var$formatBigNumberToBase(value, 16, wordSize);
        case "auto":
            // determine lower and upper bound for exponential notation.
            // TODO: implement support for upper and lower to be BigNumbers themselves
            var lowerExp = options && options.lowerExp !== undefined ? options.lowerExp : -3;
            var upperExp = options && options.upperExp !== undefined ? options.upperExp : 5; // handle special case zero
            if (value.isZero()) return "0"; // determine whether or not to output exponential notation
            var str;
            var rounded = value.toSignificantDigits(precision);
            var exp = rounded.e;
            if (exp >= lowerExp && exp < upperExp) // normal number notation
            str = rounded.toFixed();
            else // exponential notation
            str = $1e37934caf7cc870$export$888cb08ddc4765be(value, precision);
             // remove trailing zeros after the decimal point
            return str.replace(/((\.\d*?)(0+))($|e)/, function() {
                var digits = arguments[2];
                var e = arguments[4];
                return digits !== "." ? digits + e : e;
            });
        default:
            throw new Error('Unknown notation "' + notation + '". ' + 'Choose "auto", "exponential", "fixed", "bin", "oct", or "hex.');
    }
}
function $1e37934caf7cc870$export$9299fe684ed0ee48(value, precision) {
    // find nearest lower multiple of 3 for exponent
    var e = value.e;
    var newExp = e % 3 === 0 ? e : e < 0 ? e - 3 - e % 3 : e - e % 3; // find difference in exponents, and calculate the value without exponent
    var valueWithoutExp = value.mul(Math.pow(10, -newExp));
    var valueStr = valueWithoutExp.toPrecision(precision);
    if (valueStr.indexOf("e") !== -1) valueStr = valueWithoutExp.toString();
    return valueStr + "e" + (e >= 0 ? "+" : "") + newExp.toString();
}
function $1e37934caf7cc870$export$888cb08ddc4765be(value, precision) {
    if (precision !== undefined) return value.toExponential(precision - 1); // Note the offset of one
    else return value.toExponential();
}
function $1e37934caf7cc870$export$a81f732198733497(value, precision) {
    return value.toFixed(precision);
}


function $b94963e97c376b6d$export$10fdab3683b55b22(text, search) {
    var start = text.length - search.length;
    var end = text.length;
    return text.substring(start, end) === search;
}
function $b94963e97c376b6d$export$d9468344d3651243(value, options) {
    var result = $b94963e97c376b6d$var$_format(value, options);
    if (options && typeof options === "object" && "truncate" in options && result.length > options.truncate) return result.substring(0, options.truncate - 3) + "...";
    return result;
}
function $b94963e97c376b6d$var$_format(value, options) {
    if (typeof value === "number") return (0, $668e051498bf5fa0$export$d9468344d3651243)(value, options);
    if ((0, $d8097b7a6d6e36d8$export$e51d0e7e5c4a03ab)(value)) return (0, $1e37934caf7cc870$export$d9468344d3651243)(value, options);
     // note: we use unsafe duck-typing here to check for Fractions, this is
    // ok here since we're only invoking toString or concatenating its values
    if ($b94963e97c376b6d$var$looksLikeFraction(value)) {
        if (!options || options.fraction !== "decimal") // output as ratio, like '1/3'
        return value.s * value.n + "/" + value.d;
        else // output as decimal, like '0.(3)'
        return value.toString();
    }
    if (Array.isArray(value)) return $b94963e97c376b6d$var$formatArray(value, options);
    if ((0, $d8097b7a6d6e36d8$export$844ec244b1367d54)(value)) return '"' + value + '"';
    if (typeof value === "function") return value.syntax ? String(value.syntax) : "function";
    if (value && typeof value === "object") {
        if (typeof value.format === "function") return value.format(options);
        else if (value && value.toString(options) !== ({}).toString()) // this object has a non-native toString method, use that one
        return value.toString(options);
        else {
            var entries = Object.keys(value).map((key)=>{
                return '"' + key + '": ' + $b94963e97c376b6d$export$d9468344d3651243(value[key], options);
            });
            return "{" + entries.join(", ") + "}";
        }
    }
    return String(value);
}
function $b94963e97c376b6d$export$fac44ee5b035f737(value) {
    var text = String(value);
    var escaped = "";
    var i = 0;
    while(i < text.length){
        var c = text.charAt(i);
        if (c === "\\") {
            escaped += c;
            i++;
            c = text.charAt(i);
            if (c === "" || '"\\/bfnrtu'.indexOf(c) === -1) escaped += "\\"; // no valid escape character -> escape it
            escaped += c;
        } else if (c === '"') escaped += '\\"';
        else escaped += c;
        i++;
    }
    return '"' + escaped + '"';
}
function $b94963e97c376b6d$export$4e7f196112fea3c5(value) {
    var text = String(value);
    text = text.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    return text;
}
/**
 * Recursively format an n-dimensional matrix
 * Example output: "[[1, 2], [3, 4]]"
 * @param {Array} array
 * @param {Object | number | Function} [options]  Formatting options. See
 *                                                lib/utils/number:format for a
 *                                                description of the available
 *                                                options.
 * @returns {string} str
 */ function $b94963e97c376b6d$var$formatArray(array, options) {
    if (Array.isArray(array)) {
        var str = "[";
        var len = array.length;
        for(var i = 0; i < len; i++){
            if (i !== 0) str += ", ";
            str += $b94963e97c376b6d$var$formatArray(array[i], options);
        }
        str += "]";
        return str;
    } else return $b94963e97c376b6d$export$d9468344d3651243(array, options);
}
/**
 * Check whether a value looks like a Fraction (unsafe duck-type check)
 * @param {*} value
 * @return {boolean}
 */ function $b94963e97c376b6d$var$looksLikeFraction(value) {
    return value && typeof value === "object" && typeof value.s === "number" && typeof value.n === "number" && typeof value.d === "number" || false;
}
function $b94963e97c376b6d$export$2da9287da10b19e2(x, y) {
    // we don't want to convert numbers to string, only accept string input
    if (!(0, $d8097b7a6d6e36d8$export$844ec244b1367d54)(x)) throw new TypeError("Unexpected type of argument in function compareText (expected: string or Array or Matrix, actual: " + (0, $d8097b7a6d6e36d8$export$f5bbd400c2f4426f)(x) + ", index: 0)");
    if (!(0, $d8097b7a6d6e36d8$export$844ec244b1367d54)(y)) throw new TypeError("Unexpected type of argument in function compareText (expected: string or Array or Matrix, actual: " + (0, $d8097b7a6d6e36d8$export$f5bbd400c2f4426f)(y) + ", index: 1)");
    return x === y ? 0 : x > y ? 1 : -1;
}


/**
 * Create a range error with the message:
 *     'Dimension mismatch (<actual size> != <expected size>)'
 * @param {number | number[]} actual        The actual size
 * @param {number | number[]} expected      The expected size
 * @param {string} [relation='!=']          Optional relation between actual
 *                                          and expected size: '!=', '<', etc.
 * @extends RangeError
 */ function $89c7b7a60bca4b11$export$ad1391ca020fdd96(actual, expected, relation) {
    if (!(this instanceof $89c7b7a60bca4b11$export$ad1391ca020fdd96)) throw new SyntaxError("Constructor must be called with the new operator");
    this.actual = actual;
    this.expected = expected;
    this.relation = relation;
    this.message = "Dimension mismatch (" + (Array.isArray(actual) ? "[" + actual.join(", ") + "]" : actual) + " " + (this.relation || "!=") + " " + (Array.isArray(expected) ? "[" + expected.join(", ") + "]" : expected) + ")";
    this.stack = new Error().stack;
}
$89c7b7a60bca4b11$export$ad1391ca020fdd96.prototype = new RangeError();
$89c7b7a60bca4b11$export$ad1391ca020fdd96.prototype.constructor = RangeError;
$89c7b7a60bca4b11$export$ad1391ca020fdd96.prototype.name = "DimensionError";
$89c7b7a60bca4b11$export$ad1391ca020fdd96.prototype.isDimensionError = true;


/**
 * Create a range error with the message:
 *     'Index out of range (index < min)'
 *     'Index out of range (index < max)'
 *
 * @param {number} index     The actual index
 * @param {number} [min=0]   Minimum index (included)
 * @param {number} [max]     Maximum index (excluded)
 * @extends RangeError
 */ function $5f2abd91081f798a$export$efa5eacb1304c464(index, min, max) {
    if (!(this instanceof $5f2abd91081f798a$export$efa5eacb1304c464)) throw new SyntaxError("Constructor must be called with the new operator");
    this.index = index;
    if (arguments.length < 3) {
        this.min = 0;
        this.max = min;
    } else {
        this.min = min;
        this.max = max;
    }
    if (this.min !== undefined && this.index < this.min) this.message = "Index out of range (" + this.index + " < " + this.min + ")";
    else if (this.max !== undefined && this.index >= this.max) this.message = "Index out of range (" + this.index + " > " + (this.max - 1) + ")";
    else this.message = "Index out of range (" + this.index + ")";
    this.stack = new Error().stack;
}
$5f2abd91081f798a$export$efa5eacb1304c464.prototype = new RangeError();
$5f2abd91081f798a$export$efa5eacb1304c464.prototype.constructor = RangeError;
$5f2abd91081f798a$export$efa5eacb1304c464.prototype.name = "IndexError";
$5f2abd91081f798a$export$efa5eacb1304c464.prototype.isIndexError = true;


function $a14a10567870d913$export$51ffaee4afb683a5(x) {
    var s = [];
    while(Array.isArray(x)){
        s.push(x.length);
        x = x[0];
    }
    return s;
}
/**
 * Recursively validate whether each element in a multi dimensional array
 * has a size corresponding to the provided size array.
 * @param {Array} array    Array to be validated
 * @param {number[]} size  Array with the size of each dimension
 * @param {number} dim   Current dimension
 * @throws DimensionError
 * @private
 */ function $a14a10567870d913$var$_validate(array, size, dim) {
    var i;
    var len = array.length;
    if (len !== size[dim]) throw new (0, $89c7b7a60bca4b11$export$ad1391ca020fdd96)(len, size[dim]);
    if (dim < size.length - 1) {
        // recursively validate each child array
        var dimNext = dim + 1;
        for(i = 0; i < len; i++){
            var child = array[i];
            if (!Array.isArray(child)) throw new (0, $89c7b7a60bca4b11$export$ad1391ca020fdd96)(size.length - 1, size.length, "<");
            $a14a10567870d913$var$_validate(array[i], size, dimNext);
        }
    } else // last dimension. none of the childs may be an array
    for(i = 0; i < len; i++){
        if (Array.isArray(array[i])) throw new (0, $89c7b7a60bca4b11$export$ad1391ca020fdd96)(size.length + 1, size.length, ">");
    }
}
function $a14a10567870d913$export$a22775fa5e2eebd9(array, size) {
    var isScalar = size.length === 0;
    if (isScalar) {
        // scalar
        if (Array.isArray(array)) throw new (0, $89c7b7a60bca4b11$export$ad1391ca020fdd96)(array.length, 0);
    } else // array
    $a14a10567870d913$var$_validate(array, size, 0);
}
function $a14a10567870d913$export$3cfe3fbfec03f260(index, length) {
    if (!(0, $d8097b7a6d6e36d8$export$7e4aa119212bc614)(index) || !(0, $668e051498bf5fa0$export$a287f47fed4544b8)(index)) throw new TypeError("Index must be an integer (value: " + index + ")");
    if (index < 0 || typeof length === "number" && index >= length) throw new (0, $5f2abd91081f798a$export$efa5eacb1304c464)(index, length);
}
function $a14a10567870d913$export$4380c87abf28fdf(array, size, defaultValue) {
    // TODO: add support for scalars, having size=[] ?
    // check the type of the arguments
    if (!Array.isArray(array) || !Array.isArray(size)) throw new TypeError("Array expected");
    if (size.length === 0) throw new Error("Resizing to scalar is not supported");
     // check whether size contains positive integers
    size.forEach(function(value) {
        if (!(0, $d8097b7a6d6e36d8$export$7e4aa119212bc614)(value) || !(0, $668e051498bf5fa0$export$a287f47fed4544b8)(value) || value < 0) throw new TypeError("Invalid size, must contain positive integers (size: " + (0, $b94963e97c376b6d$export$d9468344d3651243)(size) + ")");
    }); // recursively resize the array
    var _defaultValue = defaultValue !== undefined ? defaultValue : 0;
    $a14a10567870d913$var$_resize(array, size, 0, _defaultValue);
    return array;
}
/**
 * Recursively resize a multi dimensional array
 * @param {Array} array         Array to be resized
 * @param {number[]} size       Array with the size of each dimension
 * @param {number} dim          Current dimension
 * @param {*} [defaultValue]    Value to be filled in in new entries,
 *                              undefined by default.
 * @private
 */ function $a14a10567870d913$var$_resize(array, size, dim, defaultValue) {
    var i;
    var elem;
    var oldLen = array.length;
    var newLen = size[dim];
    var minLen = Math.min(oldLen, newLen); // apply new length
    array.length = newLen;
    if (dim < size.length - 1) {
        // non-last dimension
        var dimNext = dim + 1; // resize existing child arrays
        for(i = 0; i < minLen; i++){
            // resize child array
            elem = array[i];
            if (!Array.isArray(elem)) {
                elem = [
                    elem
                ]; // add a dimension
                array[i] = elem;
            }
            $a14a10567870d913$var$_resize(elem, size, dimNext, defaultValue);
        } // create new child arrays
        for(i = minLen; i < newLen; i++){
            // get child array
            elem = [];
            array[i] = elem; // resize new child array
            $a14a10567870d913$var$_resize(elem, size, dimNext, defaultValue);
        }
    } else {
        // last dimension
        // remove dimensions of existing values
        for(i = 0; i < minLen; i++)while(Array.isArray(array[i]))array[i] = array[i][0];
         // fill new elements with the default value
        for(i = minLen; i < newLen; i++)array[i] = defaultValue;
    }
}
function $a14a10567870d913$export$9eaad88cf88cee2b(array, sizes) {
    var flatArray = $a14a10567870d913$export$bffa455ba8c619a6(array);
    var currentLength = flatArray.length;
    if (!Array.isArray(array) || !Array.isArray(sizes)) throw new TypeError("Array expected");
    if (sizes.length === 0) throw new (0, $89c7b7a60bca4b11$export$ad1391ca020fdd96)(0, currentLength, "!=");
    sizes = $a14a10567870d913$export$d0efc868ac2c6822(sizes, currentLength);
    var newLength = $a14a10567870d913$var$product(sizes);
    if (currentLength !== newLength) throw new (0, $89c7b7a60bca4b11$export$ad1391ca020fdd96)(newLength, currentLength, "!=");
    try {
        return $a14a10567870d913$var$_reshape(flatArray, sizes);
    } catch (e) {
        if (e instanceof (0, $89c7b7a60bca4b11$export$ad1391ca020fdd96)) throw new (0, $89c7b7a60bca4b11$export$ad1391ca020fdd96)(newLength, currentLength, "!=");
        throw e;
    }
}
function $a14a10567870d913$export$d0efc868ac2c6822(sizes, currentLength) {
    var newLength = $a14a10567870d913$var$product(sizes);
    var processedSizes = sizes.slice();
    var WILDCARD = -1;
    var wildCardIndex = sizes.indexOf(WILDCARD);
    var isMoreThanOneWildcard = sizes.indexOf(WILDCARD, wildCardIndex + 1) >= 0;
    if (isMoreThanOneWildcard) throw new Error("More than one wildcard in sizes");
    var hasWildcard = wildCardIndex >= 0;
    var canReplaceWildcard = currentLength % newLength === 0;
    if (hasWildcard) {
        if (canReplaceWildcard) processedSizes[wildCardIndex] = -currentLength / newLength;
        else throw new Error("Could not replace wildcard, since " + currentLength + " is no multiple of " + -newLength);
    }
    return processedSizes;
}
/**
 * Computes the product of all array elements.
 * @param {Array<number>} array Array of factors
 * @returns {number}            Product of all elements
 */ function $a14a10567870d913$var$product(array) {
    return array.reduce((prev, curr)=>prev * curr, 1);
}
/**
 * Iteratively re-shape a multi dimensional array to fit the specified dimensions
 * @param {Array} array           Array to be reshaped
 * @param {Array.<number>} sizes  List of sizes for each dimension
 * @returns {Array}               Array whose data has been formatted to fit the
 *                                specified dimensions
 */ function $a14a10567870d913$var$_reshape(array, sizes) {
    // testing if there are enough elements for the requested shape
    var tmpArray = array;
    var tmpArray2; // for each dimensions starting by the last one and ignoring the first one
    for(var sizeIndex = sizes.length - 1; sizeIndex > 0; sizeIndex--){
        var size = sizes[sizeIndex];
        tmpArray2 = []; // aggregate the elements of the current tmpArray in elements of the requested size
        var length = tmpArray.length / size;
        for(var i = 0; i < length; i++)tmpArray2.push(tmpArray.slice(i * size, (i + 1) * size));
         // set it as the new tmpArray for the next loop turn or for return
        tmpArray = tmpArray2;
    }
    return tmpArray;
}
function $a14a10567870d913$export$889c931173b77c2f(array, size) {
    var s = size || $a14a10567870d913$export$51ffaee4afb683a5(array); // squeeze outer dimensions
    while(Array.isArray(array) && array.length === 1){
        array = array[0];
        s.shift();
    } // find the first dimension to be squeezed
    var dims = s.length;
    while(s[dims - 1] === 1)dims--;
     // squeeze inner dimensions
    if (dims < s.length) {
        array = $a14a10567870d913$var$_squeeze(array, dims, 0);
        s.length = dims;
    }
    return array;
}
/**
 * Recursively squeeze a multi dimensional array
 * @param {Array} array
 * @param {number} dims Required number of dimensions
 * @param {number} dim  Current dimension
 * @returns {Array | *} Returns the squeezed array
 * @private
 */ function $a14a10567870d913$var$_squeeze(array, dims, dim) {
    var i, ii;
    if (dim < dims) {
        var next = dim + 1;
        for(i = 0, ii = array.length; i < ii; i++)array[i] = $a14a10567870d913$var$_squeeze(array[i], dims, next);
    } else while(Array.isArray(array))array = array[0];
    return array;
}
function $a14a10567870d913$export$5a07c5202d40a604(array, dims, outer, size) {
    var s = size || $a14a10567870d913$export$51ffaee4afb683a5(array); // unsqueeze outer dimensions
    if (outer) for(var i = 0; i < outer; i++){
        array = [
            array
        ];
        s.unshift(1);
    }
     // unsqueeze inner dimensions
    array = $a14a10567870d913$var$_unsqueeze(array, dims, 0);
    while(s.length < dims)s.push(1);
    return array;
}
/**
 * Recursively unsqueeze a multi dimensional array
 * @param {Array} array
 * @param {number} dims Required number of dimensions
 * @param {number} dim  Current dimension
 * @returns {Array | *} Returns the squeezed array
 * @private
 */ function $a14a10567870d913$var$_unsqueeze(array, dims, dim) {
    var i, ii;
    if (Array.isArray(array)) {
        var next = dim + 1;
        for(i = 0, ii = array.length; i < ii; i++)array[i] = $a14a10567870d913$var$_unsqueeze(array[i], dims, next);
    } else for(var d = dim; d < dims; d++)array = [
        array
    ];
    return array;
}
function $a14a10567870d913$export$bffa455ba8c619a6(array) {
    if (!Array.isArray(array)) // if not an array, return as is
    return array;
    var flat = [];
    array.forEach(function callback(value) {
        if (Array.isArray(value)) value.forEach(callback); // traverse through sub-arrays recursively
        else flat.push(value);
    });
    return flat;
}
function $a14a10567870d913$export$871de8747c9eaa88(array, callback) {
    return Array.prototype.map.call(array, callback);
}
function $a14a10567870d913$export$4b80e395e36b5a56(array, callback) {
    Array.prototype.forEach.call(array, callback);
}
function $a14a10567870d913$export$3dea766d36a8935f(array, callback) {
    if ($a14a10567870d913$export$51ffaee4afb683a5(array).length !== 1) throw new Error("Only one dimensional matrices supported");
    return Array.prototype.filter.call(array, callback);
}
function $a14a10567870d913$export$322859471e81229d(array, regexp) {
    if ($a14a10567870d913$export$51ffaee4afb683a5(array).length !== 1) throw new Error("Only one dimensional matrices supported");
    return Array.prototype.filter.call(array, (entry)=>regexp.test(entry));
}
function $a14a10567870d913$export$f7e2c8231c57a8bd(array, separator) {
    return Array.prototype.join.call(array, separator);
}
function $a14a10567870d913$export$65e5b62a4c490288(a) {
    if (!Array.isArray(a)) throw new TypeError("Array input expected");
    if (a.length === 0) return a;
    var b = [];
    var count = 0;
    b[0] = {
        value: a[0],
        identifier: 0
    };
    for(var i = 1; i < a.length; i++){
        if (a[i] === a[i - 1]) count++;
        else count = 0;
        b.push({
            value: a[i],
            identifier: count
        });
    }
    return b;
}
function $a14a10567870d913$export$d57ad8b840ad6a01(a) {
    if (!Array.isArray(a)) throw new TypeError("Array input expected");
    if (a.length === 0) return a;
    var b = [];
    for(var i = 0; i < a.length; i++)b.push(a[i].value);
    return b;
}
function $a14a10567870d913$export$d31e00bf4359ea8b(array, typeOf) {
    var type; // to hold type info
    var length = 0; // to hold length value to ensure it has consistent sizes
    for(var i = 0; i < array.length; i++){
        var item = array[i];
        var isArray = Array.isArray(item); // Saving the target matrix row size
        if (i === 0 && isArray) length = item.length;
         // If the current item is an array but the length does not equal the targetVectorSize
        if (isArray && item.length !== length) return undefined;
        var itemType = isArray ? $a14a10567870d913$export$d31e00bf4359ea8b(item, typeOf) // recurse into a nested array
         : typeOf(item);
        if (type === undefined) type = itemType; // first item
        else if (type !== itemType) return "mixed";
    }
    return type;
}
function $a14a10567870d913$export$4c7897fafd92b108(array) {
    return array[array.length - 1];
}
function $a14a10567870d913$export$59ff82fc918bd7e3(array) {
    return array.slice(0, array.length - 1);
}
function $a14a10567870d913$export$2344b14b097df817(array, item) {
    return array.indexOf(item) !== -1;
}



function $e745cf56e5b0be75$export$e9008f2713103c6c(name, dependencies, create, meta) {
    function assertAndCreate(scope) {
        // we only pass the requested dependencies to the factory function
        // to prevent functions to rely on dependencies that are not explicitly
        // requested.
        var deps = (0, $6819694788cbfa38$export$8cea971c64639ea7)(scope, dependencies.map($e745cf56e5b0be75$export$2f4d32a1468e229c));
        $e745cf56e5b0be75$export$19a2c26dad95d6e7(name, dependencies, scope);
        return create(deps);
    }
    assertAndCreate.isFactory = true;
    assertAndCreate.fn = name;
    assertAndCreate.dependencies = dependencies.slice().sort();
    if (meta) assertAndCreate.meta = meta;
    return assertAndCreate;
}
function $e745cf56e5b0be75$export$883f1d394ed355c(factories) {
    var factoriesByName = {};
    factories.forEach((factory)=>{
        factoriesByName[factory.fn] = factory;
    });
    function containsDependency(factory, dependency) {
        // TODO: detect circular references
        if ($e745cf56e5b0be75$export$34763cfbed1075c2(factory)) {
            if ((0, $a14a10567870d913$export$2344b14b097df817)(factory.dependencies, dependency.fn || dependency.name)) return true;
            if (factory.dependencies.some((d)=>containsDependency(factoriesByName[d], dependency))) return true;
        }
        return false;
    }
    var sorted = [];
    function addFactory(factory) {
        var index = 0;
        while(index < sorted.length && !containsDependency(sorted[index], factory))index++;
        sorted.splice(index, 0, factory);
    } // sort regular factory functions
    factories.filter($e745cf56e5b0be75$export$34763cfbed1075c2).forEach(addFactory); // sort legacy factory functions AFTER the regular factory functions
    factories.filter((factory)=>!$e745cf56e5b0be75$export$34763cfbed1075c2(factory)).forEach(addFactory);
    return sorted;
} // TODO: comment or cleanup if unused in the end
function $e745cf56e5b0be75$export$185802fd694ee1f5(factories) {
    var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    $e745cf56e5b0be75$export$883f1d394ed355c(factories).forEach((factory)=>factory(scope));
    return scope;
}
function $e745cf56e5b0be75$export$34763cfbed1075c2(obj) {
    return typeof obj === "function" && typeof obj.fn === "string" && Array.isArray(obj.dependencies);
}
function $e745cf56e5b0be75$export$19a2c26dad95d6e7(name, dependencies, scope) {
    var allDefined = dependencies.filter((dependency)=>!$e745cf56e5b0be75$export$1399ac7f45b04b5(dependency)) // filter optionals
    .every((dependency)=>scope[dependency] !== undefined);
    if (!allDefined) {
        var missingDependencies = dependencies.filter((dependency)=>scope[dependency] === undefined); // TODO: create a custom error class for this, a MathjsError or something like that
        throw new Error('Cannot create function "'.concat(name, '", ') + "some dependencies are missing: ".concat(missingDependencies.map((d)=>'"'.concat(d, '"')).join(", "), "."));
    }
}
function $e745cf56e5b0be75$export$1399ac7f45b04b5(dependency) {
    return dependency && dependency[0] === "?";
}
function $e745cf56e5b0be75$export$2f4d32a1468e229c(dependency) {
    return dependency && dependency[0] === "?" ? dependency.slice(1) : dependency;
}


var $e4540763674cd14e$var$name = "BigNumber";
var $e4540763674cd14e$var$dependencies = [
    "?on",
    "config"
];
var $e4540763674cd14e$export$234de8d4231bfea3 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($e4540763674cd14e$var$name, $e4540763674cd14e$var$dependencies, (_ref)=>{
    var { on: on, config: config } = _ref;
    var BigNumber = (0, (/*@__PURE__*/$parcel$interopDefault($4qPUL))).clone({
        precision: config.precision,
        modulo: (0, (/*@__PURE__*/$parcel$interopDefault($4qPUL))).EUCLID
    });
    BigNumber.prototype = Object.create(BigNumber.prototype);
    /**
   * Attach type information
   */ BigNumber.prototype.type = "BigNumber";
    BigNumber.prototype.isBigNumber = true;
    /**
   * Get a JSON representation of a BigNumber containing
   * type information
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "BigNumber", "value": "0.2"}`
   */ BigNumber.prototype.toJSON = function() {
        return {
            mathjs: "BigNumber",
            value: this.toString()
        };
    };
    /**
   * Instantiate a BigNumber from a JSON object
   * @param {Object} json  a JSON object structured as:
   *                       `{"mathjs": "BigNumber", "value": "0.2"}`
   * @return {BigNumber}
   */ BigNumber.fromJSON = function(json) {
        return new BigNumber(json.value);
    };
    if (on) // listen for changed in the configuration, automatically apply changed precision
    on("config", function(curr, prev) {
        if (curr.precision !== prev.precision) BigNumber.config({
            precision: curr.precision
        });
    });
    return BigNumber;
}, {
    isClass: true
});

var $300e2d6880da0e38$exports = {};
/**
 * @license Complex.js v2.1.1 12/05/2020
 *
 * Copyright (c) 2020, Robert Eisele (robert@xarg.org)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 **/ /**
 *
 * This class allows the manipulation of complex numbers.
 * You can pass a complex number in different formats. Either as object, double, string or two integer parameters.
 *
 * Object form
 * { re: <real>, im: <imaginary> }
 * { arg: <angle>, abs: <radius> }
 * { phi: <angle>, r: <radius> }
 *
 * Array / Vector form
 * [ real, imaginary ]
 *
 * Double form
 * 99.3 - Single double value
 *
 * String form
 * '23.1337' - Simple real number
 * '15+3i' - a simple complex number
 * '3-i' - a simple complex number
 *
 * Example:
 *
 * var c = new Complex('99.3+8i');
 * c.mul({r: 3, i: 9}).div(4.9).sub(3, 2);
 *
 */ (function(root) {
    "use strict";
    var cosh = Math.cosh || function(x) {
        return Math.abs(x) < 1e-9 ? 1 - x : (Math.exp(x) + Math.exp(-x)) * 0.5;
    };
    var sinh = Math.sinh || function(x) {
        return Math.abs(x) < 1e-9 ? x : (Math.exp(x) - Math.exp(-x)) * 0.5;
    };
    /**
   * Calculates cos(x) - 1 using Taylor series if x is small (-¼π ≤ x ≤ ¼π).
   *
   * @param {number} x
   * @returns {number} cos(x) - 1
   */ var cosm1 = function(x) {
        var b = Math.PI / 4;
        if (-b > x || x > b) return Math.cos(x) - 1.0;
        /* Calculate horner form of polynomial of taylor series in Q
    var fac = 1, alt = 1, pol = {};
    for (var i = 0; i <= 16; i++) {
      fac*= i || 1;
      if (i % 2 == 0) {
        pol[i] = new Fraction(1, alt * fac);
        alt = -alt;
      }
    }
    console.log(new Polynomial(pol).toHorner()); // (((((((1/20922789888000x^2-1/87178291200)x^2+1/479001600)x^2-1/3628800)x^2+1/40320)x^2-1/720)x^2+1/24)x^2-1/2)x^2+1
    */ var xx = x * x;
        return xx * (xx * (xx * (xx * (xx * (xx * (xx * (xx / 20922789888000 - 1 / 87178291200) + 1 / 479001600) - 1 / 3628800) + 1 / 40320) - 1 / 720) + 1 / 24) - 0.5);
    };
    var hypot = function(x, y) {
        var a = Math.abs(x);
        var b = Math.abs(y);
        if (a < 3000 && b < 3000) return Math.sqrt(a * a + b * b);
        if (a < b) {
            a = b;
            b = x / y;
        } else b = y / x;
        return a * Math.sqrt(1 + b * b);
    };
    var parser_exit = function() {
        throw SyntaxError("Invalid Param");
    };
    /**
   * Calculates log(sqrt(a^2+b^2)) in a way to avoid overflows
   *
   * @param {number} a
   * @param {number} b
   * @returns {number}
   */ function logHypot(a, b) {
        var _a = Math.abs(a);
        var _b = Math.abs(b);
        if (a === 0) return Math.log(_b);
        if (b === 0) return Math.log(_a);
        if (_a < 3000 && _b < 3000) return Math.log(a * a + b * b) * 0.5;
        /* I got 4 ideas to compute this property without overflow:
     *
     * Testing 1000000 times with random samples for a,b ∈ [1, 1000000000] against a big decimal library to get an error estimate
     *
     * 1. Only eliminate the square root: (OVERALL ERROR: 3.9122483030951116e-11)

     Math.log(a * a + b * b) / 2

     *
     *
     * 2. Try to use the non-overflowing pythagoras: (OVERALL ERROR: 8.889760039210159e-10)

     var fn = function(a, b) {
     a = Math.abs(a);
     b = Math.abs(b);
     var t = Math.min(a, b);
     a = Math.max(a, b);
     t = t / a;

     return Math.log(a) + Math.log(1 + t * t) / 2;
     };

     * 3. Abuse the identity cos(atan(y/x) = x / sqrt(x^2+y^2): (OVERALL ERROR: 3.4780178737037204e-10)

     Math.log(a / Math.cos(Math.atan2(b, a)))

     * 4. Use 3. and apply log rules: (OVERALL ERROR: 1.2014087502620896e-9)

     Math.log(a) - Math.log(Math.cos(Math.atan2(b, a)))

     */ a = a / 2;
        b = b / 2;
        return 0.5 * Math.log(a * a + b * b) + Math.LN2;
    }
    var parse = function(a, b) {
        var z = {
            "re": 0,
            "im": 0
        };
        if (a === undefined || a === null) z["re"] = z["im"] = 0;
        else if (b !== undefined) {
            z["re"] = a;
            z["im"] = b;
        } else switch(typeof a){
            case "object":
                if ("im" in a && "re" in a) {
                    z["re"] = a["re"];
                    z["im"] = a["im"];
                } else if ("abs" in a && "arg" in a) {
                    if (!Number.isFinite(a["abs"]) && Number.isFinite(a["arg"])) return Complex["INFINITY"];
                    z["re"] = a["abs"] * Math.cos(a["arg"]);
                    z["im"] = a["abs"] * Math.sin(a["arg"]);
                } else if ("r" in a && "phi" in a) {
                    if (!Number.isFinite(a["r"]) && Number.isFinite(a["phi"])) return Complex["INFINITY"];
                    z["re"] = a["r"] * Math.cos(a["phi"]);
                    z["im"] = a["r"] * Math.sin(a["phi"]);
                } else if (a.length === 2) {
                    z["re"] = a[0];
                    z["im"] = a[1];
                } else parser_exit();
                break;
            case "string":
                z["im"] = /* void */ z["re"] = 0;
                var tokens = a.match(/\d+\.?\d*e[+-]?\d+|\d+\.?\d*|\.\d+|./g);
                var plus = 1;
                var minus = 0;
                if (tokens === null) parser_exit();
                for(var i = 0; i < tokens.length; i++){
                    var c = tokens[i];
                    if (c === " " || c === "	" || c === "\n") ;
                    else if (c === "+") plus++;
                    else if (c === "-") minus++;
                    else if (c === "i" || c === "I") {
                        if (plus + minus === 0) parser_exit();
                        if (tokens[i + 1] !== " " && !isNaN(tokens[i + 1])) {
                            z["im"] += parseFloat((minus % 2 ? "-" : "") + tokens[i + 1]);
                            i++;
                        } else z["im"] += parseFloat((minus % 2 ? "-" : "") + "1");
                        plus = minus = 0;
                    } else {
                        if (plus + minus === 0 || isNaN(c)) parser_exit();
                        if (tokens[i + 1] === "i" || tokens[i + 1] === "I") {
                            z["im"] += parseFloat((minus % 2 ? "-" : "") + c);
                            i++;
                        } else z["re"] += parseFloat((minus % 2 ? "-" : "") + c);
                        plus = minus = 0;
                    }
                }
                // Still something on the stack
                if (plus + minus > 0) parser_exit();
                break;
            case "number":
                z["im"] = 0;
                z["re"] = a;
                break;
            default:
                parser_exit();
        }
        isNaN(z["re"]) || isNaN(z["im"]);
        return z;
    };
    /**
   * @constructor
   * @returns {Complex}
   */ function Complex(a, b) {
        if (!(this instanceof Complex)) return new Complex(a, b);
        var z = parse(a, b);
        this["re"] = z["re"];
        this["im"] = z["im"];
    }
    Complex.prototype = {
        "re": 0,
        "im": 0,
        /**
     * Calculates the sign of a complex number, which is a normalized complex
     *
     * @returns {Complex}
     */ "sign": function() {
            var abs = this["abs"]();
            return new Complex(this["re"] / abs, this["im"] / abs);
        },
        /**
     * Adds two complex numbers
     *
     * @returns {Complex}
     */ "add": function(a, b) {
            var z = new Complex(a, b);
            // Infinity + Infinity = NaN
            if (this["isInfinite"]() && z["isInfinite"]()) return Complex["NAN"];
            // Infinity + z = Infinity { where z != Infinity }
            if (this["isInfinite"]() || z["isInfinite"]()) return Complex["INFINITY"];
            return new Complex(this["re"] + z["re"], this["im"] + z["im"]);
        },
        /**
     * Subtracts two complex numbers
     *
     * @returns {Complex}
     */ "sub": function(a, b) {
            var z = new Complex(a, b);
            // Infinity - Infinity = NaN
            if (this["isInfinite"]() && z["isInfinite"]()) return Complex["NAN"];
            // Infinity - z = Infinity { where z != Infinity }
            if (this["isInfinite"]() || z["isInfinite"]()) return Complex["INFINITY"];
            return new Complex(this["re"] - z["re"], this["im"] - z["im"]);
        },
        /**
     * Multiplies two complex numbers
     *
     * @returns {Complex}
     */ "mul": function(a, b) {
            var z = new Complex(a, b);
            // Infinity * 0 = NaN
            if (this["isInfinite"]() && z["isZero"]() || this["isZero"]() && z["isInfinite"]()) return Complex["NAN"];
            // Infinity * z = Infinity { where z != 0 }
            if (this["isInfinite"]() || z["isInfinite"]()) return Complex["INFINITY"];
            // Short circuit for real values
            if (z["im"] === 0 && this["im"] === 0) return new Complex(this["re"] * z["re"], 0);
            return new Complex(this["re"] * z["re"] - this["im"] * z["im"], this["re"] * z["im"] + this["im"] * z["re"]);
        },
        /**
     * Divides two complex numbers
     *
     * @returns {Complex}
     */ "div": function(a, b) {
            var z = new Complex(a, b);
            // 0 / 0 = NaN and Infinity / Infinity = NaN
            if (this["isZero"]() && z["isZero"]() || this["isInfinite"]() && z["isInfinite"]()) return Complex["NAN"];
            // Infinity / 0 = Infinity
            if (this["isInfinite"]() || z["isZero"]()) return Complex["INFINITY"];
            // 0 / Infinity = 0
            if (this["isZero"]() || z["isInfinite"]()) return Complex["ZERO"];
            a = this["re"];
            b = this["im"];
            var c = z["re"];
            var d = z["im"];
            var t, x;
            if (0 === d) // Divisor is real
            return new Complex(a / c, b / c);
            if (Math.abs(c) < Math.abs(d)) {
                x = c / d;
                t = c * x + d;
                return new Complex((a * x + b) / t, (b * x - a) / t);
            } else {
                x = d / c;
                t = d * x + c;
                return new Complex((a + b * x) / t, (b - a * x) / t);
            }
        },
        /**
     * Calculate the power of two complex numbers
     *
     * @returns {Complex}
     */ "pow": function(a, b) {
            var z = new Complex(a, b);
            a = this["re"];
            b = this["im"];
            if (z["isZero"]()) return Complex["ONE"];
            // If the exponent is real
            if (z["im"] === 0) {
                if (b === 0 && a > 0) return new Complex(Math.pow(a, z["re"]), 0);
                else if (a === 0) switch((z["re"] % 4 + 4) % 4){
                    case 0:
                        return new Complex(Math.pow(b, z["re"]), 0);
                    case 1:
                        return new Complex(0, Math.pow(b, z["re"]));
                    case 2:
                        return new Complex(-Math.pow(b, z["re"]), 0);
                    case 3:
                        return new Complex(0, -Math.pow(b, z["re"]));
                }
            }
            /* I couldn't find a good formula, so here is a derivation and optimization
       *
       * z_1^z_2 = (a + bi)^(c + di)
       *         = exp((c + di) * log(a + bi)
       *         = pow(a^2 + b^2, (c + di) / 2) * exp(i(c + di)atan2(b, a))
       * =>...
       * Re = (pow(a^2 + b^2, c / 2) * exp(-d * atan2(b, a))) * cos(d * log(a^2 + b^2) / 2 + c * atan2(b, a))
       * Im = (pow(a^2 + b^2, c / 2) * exp(-d * atan2(b, a))) * sin(d * log(a^2 + b^2) / 2 + c * atan2(b, a))
       *
       * =>...
       * Re = exp(c * log(sqrt(a^2 + b^2)) - d * atan2(b, a)) * cos(d * log(sqrt(a^2 + b^2)) + c * atan2(b, a))
       * Im = exp(c * log(sqrt(a^2 + b^2)) - d * atan2(b, a)) * sin(d * log(sqrt(a^2 + b^2)) + c * atan2(b, a))
       *
       * =>
       * Re = exp(c * logsq2 - d * arg(z_1)) * cos(d * logsq2 + c * arg(z_1))
       * Im = exp(c * logsq2 - d * arg(z_1)) * sin(d * logsq2 + c * arg(z_1))
       *
       */ if (a === 0 && b === 0 && z["re"] > 0 && z["im"] >= 0) return Complex["ZERO"];
            var arg = Math.atan2(b, a);
            var loh = logHypot(a, b);
            a = Math.exp(z["re"] * loh - z["im"] * arg);
            b = z["im"] * loh + z["re"] * arg;
            return new Complex(a * Math.cos(b), a * Math.sin(b));
        },
        /**
     * Calculate the complex square root
     *
     * @returns {Complex}
     */ "sqrt": function() {
            var a = this["re"];
            var b = this["im"];
            var r = this["abs"]();
            var re, im;
            if (a >= 0) {
                if (b === 0) return new Complex(Math.sqrt(a), 0);
                re = 0.5 * Math.sqrt(2.0 * (r + a));
            } else re = Math.abs(b) / Math.sqrt(2 * (r - a));
            if (a <= 0) im = 0.5 * Math.sqrt(2.0 * (r - a));
            else im = Math.abs(b) / Math.sqrt(2 * (r + a));
            return new Complex(re, b < 0 ? -im : im);
        },
        /**
     * Calculate the complex exponent
     *
     * @returns {Complex}
     */ "exp": function() {
            var tmp = Math.exp(this["re"]);
            this["im"];
            return new Complex(tmp * Math.cos(this["im"]), tmp * Math.sin(this["im"]));
        },
        /**
     * Calculate the complex exponent and subtracts one.
     *
     * This may be more accurate than `Complex(x).exp().sub(1)` if
     * `x` is small.
     *
     * @returns {Complex}
     */ "expm1": function() {
            /**
       * exp(a + i*b) - 1
       = exp(a) * (cos(b) + j*sin(b)) - 1
       = expm1(a)*cos(b) + cosm1(b) + j*exp(a)*sin(b)
       */ var a = this["re"];
            var b = this["im"];
            return new Complex(Math.expm1(a) * Math.cos(b) + cosm1(b), Math.exp(a) * Math.sin(b));
        },
        /**
     * Calculate the natural log
     *
     * @returns {Complex}
     */ "log": function() {
            var a = this["re"];
            var b = this["im"];
            b === 0 && a;
            return new Complex(logHypot(a, b), Math.atan2(b, a));
        },
        /**
     * Calculate the magnitude of the complex number
     *
     * @returns {number}
     */ "abs": function() {
            return hypot(this["re"], this["im"]);
        },
        /**
     * Calculate the angle of the complex number
     *
     * @returns {number}
     */ "arg": function() {
            return Math.atan2(this["im"], this["re"]);
        },
        /**
     * Calculate the sine of the complex number
     *
     * @returns {Complex}
     */ "sin": function() {
            // sin(z) = ( e^iz - e^-iz ) / 2i 
            //        = sin(a)cosh(b) + i cos(a)sinh(b)
            var a = this["re"];
            var b = this["im"];
            return new Complex(Math.sin(a) * cosh(b), Math.cos(a) * sinh(b));
        },
        /**
     * Calculate the cosine
     *
     * @returns {Complex}
     */ "cos": function() {
            // cos(z) = ( e^iz + e^-iz ) / 2 
            //        = cos(a)cosh(b) - i sin(a)sinh(b)
            var a = this["re"];
            var b = this["im"];
            return new Complex(Math.cos(a) * cosh(b), -Math.sin(a) * sinh(b));
        },
        /**
     * Calculate the tangent
     *
     * @returns {Complex}
     */ "tan": function() {
            // tan(z) = sin(z) / cos(z) 
            //        = ( e^iz - e^-iz ) / ( i( e^iz + e^-iz ) )
            //        = ( e^2iz - 1 ) / i( e^2iz + 1 )
            //        = ( sin(2a) + i sinh(2b) ) / ( cos(2a) + cosh(2b) )
            var a = 2 * this["re"];
            var b = 2 * this["im"];
            var d = Math.cos(a) + cosh(b);
            return new Complex(Math.sin(a) / d, sinh(b) / d);
        },
        /**
     * Calculate the cotangent
     *
     * @returns {Complex}
     */ "cot": function() {
            // cot(c) = i(e^(ci) + e^(-ci)) / (e^(ci) - e^(-ci))
            var a = 2 * this["re"];
            var b = 2 * this["im"];
            var d = Math.cos(a) - cosh(b);
            return new Complex(-Math.sin(a) / d, sinh(b) / d);
        },
        /**
     * Calculate the secant
     *
     * @returns {Complex}
     */ "sec": function() {
            // sec(c) = 2 / (e^(ci) + e^(-ci))
            var a = this["re"];
            var b = this["im"];
            var d = 0.5 * cosh(2 * b) + 0.5 * Math.cos(2 * a);
            return new Complex(Math.cos(a) * cosh(b) / d, Math.sin(a) * sinh(b) / d);
        },
        /**
     * Calculate the cosecans
     *
     * @returns {Complex}
     */ "csc": function() {
            // csc(c) = 2i / (e^(ci) - e^(-ci))
            var a = this["re"];
            var b = this["im"];
            var d = 0.5 * cosh(2 * b) - 0.5 * Math.cos(2 * a);
            return new Complex(Math.sin(a) * cosh(b) / d, -Math.cos(a) * sinh(b) / d);
        },
        /**
     * Calculate the complex arcus sinus
     *
     * @returns {Complex}
     */ "asin": function() {
            // asin(c) = -i * log(ci + sqrt(1 - c^2))
            var a = this["re"];
            var b = this["im"];
            var t1 = new Complex(b * b - a * a + 1, -2 * a * b)["sqrt"]();
            var t2 = new Complex(t1["re"] - b, t1["im"] + a)["log"]();
            return new Complex(t2["im"], -t2["re"]);
        },
        /**
     * Calculate the complex arcus cosinus
     *
     * @returns {Complex}
     */ "acos": function() {
            // acos(c) = i * log(c - i * sqrt(1 - c^2))
            var a = this["re"];
            var b = this["im"];
            var t1 = new Complex(b * b - a * a + 1, -2 * a * b)["sqrt"]();
            var t2 = new Complex(t1["re"] - b, t1["im"] + a)["log"]();
            return new Complex(Math.PI / 2 - t2["im"], t2["re"]);
        },
        /**
     * Calculate the complex arcus tangent
     *
     * @returns {Complex}
     */ "atan": function() {
            // atan(c) = i / 2 log((i + x) / (i - x))
            var a = this["re"];
            var b = this["im"];
            if (a === 0) {
                if (b === 1) return new Complex(0, Infinity);
                if (b === -1) return new Complex(0, -Infinity);
            }
            var d = a * a + (1.0 - b) * (1.0 - b);
            var t1 = new Complex((1 - b * b - a * a) / d, -2 * a / d).log();
            return new Complex(-0.5 * t1["im"], 0.5 * t1["re"]);
        },
        /**
     * Calculate the complex arcus cotangent
     *
     * @returns {Complex}
     */ "acot": function() {
            // acot(c) = i / 2 log((c - i) / (c + i))
            var a = this["re"];
            var b = this["im"];
            if (b === 0) return new Complex(Math.atan2(1, a), 0);
            var d = a * a + b * b;
            return d !== 0 ? new Complex(a / d, -b / d).atan() : new Complex(a !== 0 ? a / 0 : 0, b !== 0 ? -b / 0 : 0).atan();
        },
        /**
     * Calculate the complex arcus secant
     *
     * @returns {Complex}
     */ "asec": function() {
            // asec(c) = -i * log(1 / c + sqrt(1 - i / c^2))
            var a = this["re"];
            var b = this["im"];
            if (a === 0 && b === 0) return new Complex(0, Infinity);
            var d = a * a + b * b;
            return d !== 0 ? new Complex(a / d, -b / d).acos() : new Complex(a !== 0 ? a / 0 : 0, b !== 0 ? -b / 0 : 0).acos();
        },
        /**
     * Calculate the complex arcus cosecans
     *
     * @returns {Complex}
     */ "acsc": function() {
            // acsc(c) = -i * log(i / c + sqrt(1 - 1 / c^2))
            var a = this["re"];
            var b = this["im"];
            if (a === 0 && b === 0) return new Complex(Math.PI / 2, Infinity);
            var d = a * a + b * b;
            return d !== 0 ? new Complex(a / d, -b / d).asin() : new Complex(a !== 0 ? a / 0 : 0, b !== 0 ? -b / 0 : 0).asin();
        },
        /**
     * Calculate the complex sinh
     *
     * @returns {Complex}
     */ "sinh": function() {
            // sinh(c) = (e^c - e^-c) / 2
            var a = this["re"];
            var b = this["im"];
            return new Complex(sinh(a) * Math.cos(b), cosh(a) * Math.sin(b));
        },
        /**
     * Calculate the complex cosh
     *
     * @returns {Complex}
     */ "cosh": function() {
            // cosh(c) = (e^c + e^-c) / 2
            var a = this["re"];
            var b = this["im"];
            return new Complex(cosh(a) * Math.cos(b), sinh(a) * Math.sin(b));
        },
        /**
     * Calculate the complex tanh
     *
     * @returns {Complex}
     */ "tanh": function() {
            // tanh(c) = (e^c - e^-c) / (e^c + e^-c)
            var a = 2 * this["re"];
            var b = 2 * this["im"];
            var d = cosh(a) + Math.cos(b);
            return new Complex(sinh(a) / d, Math.sin(b) / d);
        },
        /**
     * Calculate the complex coth
     *
     * @returns {Complex}
     */ "coth": function() {
            // coth(c) = (e^c + e^-c) / (e^c - e^-c)
            var a = 2 * this["re"];
            var b = 2 * this["im"];
            var d = cosh(a) - Math.cos(b);
            return new Complex(sinh(a) / d, -Math.sin(b) / d);
        },
        /**
     * Calculate the complex coth
     *
     * @returns {Complex}
     */ "csch": function() {
            // csch(c) = 2 / (e^c - e^-c)
            var a = this["re"];
            var b = this["im"];
            var d = Math.cos(2 * b) - cosh(2 * a);
            return new Complex(-2 * sinh(a) * Math.cos(b) / d, 2 * cosh(a) * Math.sin(b) / d);
        },
        /**
     * Calculate the complex sech
     *
     * @returns {Complex}
     */ "sech": function() {
            // sech(c) = 2 / (e^c + e^-c)
            var a = this["re"];
            var b = this["im"];
            var d = Math.cos(2 * b) + cosh(2 * a);
            return new Complex(2 * cosh(a) * Math.cos(b) / d, -2 * sinh(a) * Math.sin(b) / d);
        },
        /**
     * Calculate the complex asinh
     *
     * @returns {Complex}
     */ "asinh": function() {
            // asinh(c) = log(c + sqrt(c^2 + 1))
            var tmp = this["im"];
            this["im"] = -this["re"];
            this["re"] = tmp;
            var res = this["asin"]();
            this["re"] = -this["im"];
            this["im"] = tmp;
            tmp = res["re"];
            res["re"] = -res["im"];
            res["im"] = tmp;
            return res;
        },
        /**
     * Calculate the complex acosh
     *
     * @returns {Complex}
     */ "acosh": function() {
            // acosh(c) = log(c + sqrt(c^2 - 1))
            var res = this["acos"]();
            if (res["im"] <= 0) {
                var tmp = res["re"];
                res["re"] = -res["im"];
                res["im"] = tmp;
            } else {
                var tmp = res["im"];
                res["im"] = -res["re"];
                res["re"] = tmp;
            }
            return res;
        },
        /**
     * Calculate the complex atanh
     *
     * @returns {Complex}
     */ "atanh": function() {
            // atanh(c) = log((1+c) / (1-c)) / 2
            var a = this["re"];
            var b = this["im"];
            var noIM = a > 1 && b === 0;
            var oneMinus = 1 - a;
            var onePlus = 1 + a;
            var d = oneMinus * oneMinus + b * b;
            var x = d !== 0 ? new Complex((onePlus * oneMinus - b * b) / d, (b * oneMinus + onePlus * b) / d) : new Complex(a !== -1 ? a / 0 : 0, b !== 0 ? b / 0 : 0);
            var temp = x["re"];
            x["re"] = logHypot(x["re"], x["im"]) / 2;
            x["im"] = Math.atan2(x["im"], temp) / 2;
            if (noIM) x["im"] = -x["im"];
            return x;
        },
        /**
     * Calculate the complex acoth
     *
     * @returns {Complex}
     */ "acoth": function() {
            // acoth(c) = log((c+1) / (c-1)) / 2
            var a = this["re"];
            var b = this["im"];
            if (a === 0 && b === 0) return new Complex(0, Math.PI / 2);
            var d = a * a + b * b;
            return d !== 0 ? new Complex(a / d, -b / d).atanh() : new Complex(a !== 0 ? a / 0 : 0, b !== 0 ? -b / 0 : 0).atanh();
        },
        /**
     * Calculate the complex acsch
     *
     * @returns {Complex}
     */ "acsch": function() {
            // acsch(c) = log((1+sqrt(1+c^2))/c)
            var a = this["re"];
            var b = this["im"];
            if (b === 0) return new Complex(a !== 0 ? Math.log(a + Math.sqrt(a * a + 1)) : Infinity, 0);
            var d = a * a + b * b;
            return d !== 0 ? new Complex(a / d, -b / d).asinh() : new Complex(a !== 0 ? a / 0 : 0, b !== 0 ? -b / 0 : 0).asinh();
        },
        /**
     * Calculate the complex asech
     *
     * @returns {Complex}
     */ "asech": function() {
            // asech(c) = log((1+sqrt(1-c^2))/c)
            var a = this["re"];
            var b = this["im"];
            if (this["isZero"]()) return Complex["INFINITY"];
            var d = a * a + b * b;
            return d !== 0 ? new Complex(a / d, -b / d).acosh() : new Complex(a !== 0 ? a / 0 : 0, b !== 0 ? -b / 0 : 0).acosh();
        },
        /**
     * Calculate the complex inverse 1/z
     *
     * @returns {Complex}
     */ "inverse": function() {
            // 1 / 0 = Infinity and 1 / Infinity = 0
            if (this["isZero"]()) return Complex["INFINITY"];
            if (this["isInfinite"]()) return Complex["ZERO"];
            var a = this["re"];
            var b = this["im"];
            var d = a * a + b * b;
            return new Complex(a / d, -b / d);
        },
        /**
     * Returns the complex conjugate
     *
     * @returns {Complex}
     */ "conjugate": function() {
            return new Complex(this["re"], -this["im"]);
        },
        /**
     * Gets the negated complex number
     *
     * @returns {Complex}
     */ "neg": function() {
            return new Complex(-this["re"], -this["im"]);
        },
        /**
     * Ceils the actual complex number
     *
     * @returns {Complex}
     */ "ceil": function(places) {
            places = Math.pow(10, places || 0);
            return new Complex(Math.ceil(this["re"] * places) / places, Math.ceil(this["im"] * places) / places);
        },
        /**
     * Floors the actual complex number
     *
     * @returns {Complex}
     */ "floor": function(places) {
            places = Math.pow(10, places || 0);
            return new Complex(Math.floor(this["re"] * places) / places, Math.floor(this["im"] * places) / places);
        },
        /**
     * Ceils the actual complex number
     *
     * @returns {Complex}
     */ "round": function(places) {
            places = Math.pow(10, places || 0);
            return new Complex(Math.round(this["re"] * places) / places, Math.round(this["im"] * places) / places);
        },
        /**
     * Compares two complex numbers
     *
     * **Note:** new Complex(Infinity).equals(Infinity) === false
     *
     * @returns {boolean}
     */ "equals": function(a, b) {
            var z = new Complex(a, b);
            return Math.abs(z["re"] - this["re"]) <= Complex["EPSILON"] && Math.abs(z["im"] - this["im"]) <= Complex["EPSILON"];
        },
        /**
     * Clones the actual object
     *
     * @returns {Complex}
     */ "clone": function() {
            return new Complex(this["re"], this["im"]);
        },
        /**
     * Gets a string of the actual complex number
     *
     * @returns {string}
     */ "toString": function() {
            var a = this["re"];
            var b = this["im"];
            var ret = "";
            if (this["isNaN"]()) return "NaN";
            if (this["isInfinite"]()) return "Infinity";
            if (Math.abs(a) < Complex["EPSILON"]) a = 0;
            if (Math.abs(b) < Complex["EPSILON"]) b = 0;
            // If is real number
            if (b === 0) return ret + a;
            if (a !== 0) {
                ret += a;
                ret += " ";
                if (b < 0) {
                    b = -b;
                    ret += "-";
                } else ret += "+";
                ret += " ";
            } else if (b < 0) {
                b = -b;
                ret += "-";
            }
            if (1 !== b) ret += b;
            return ret + "i";
        },
        /**
     * Returns the actual number as a vector
     *
     * @returns {Array}
     */ "toVector": function() {
            return [
                this["re"],
                this["im"]
            ];
        },
        /**
     * Returns the actual real value of the current object
     *
     * @returns {number|null}
     */ "valueOf": function() {
            if (this["im"] === 0) return this["re"];
            return null;
        },
        /**
     * Determines whether a complex number is not on the Riemann sphere.
     *
     * @returns {boolean}
     */ "isNaN": function() {
            return isNaN(this["re"]) || isNaN(this["im"]);
        },
        /**
     * Determines whether or not a complex number is at the zero pole of the
     * Riemann sphere.
     *
     * @returns {boolean}
     */ "isZero": function() {
            return this["im"] === 0 && this["re"] === 0;
        },
        /**
     * Determines whether a complex number is not at the infinity pole of the
     * Riemann sphere.
     *
     * @returns {boolean}
     */ "isFinite": function() {
            return isFinite(this["re"]) && isFinite(this["im"]);
        },
        /**
     * Determines whether or not a complex number is at the infinity pole of the
     * Riemann sphere.
     *
     * @returns {boolean}
     */ "isInfinite": function() {
            return !(this["isNaN"]() || this["isFinite"]());
        }
    };
    Complex["ZERO"] = new Complex(0, 0);
    Complex["ONE"] = new Complex(1, 0);
    Complex["I"] = new Complex(0, 1);
    Complex["PI"] = new Complex(Math.PI, 0);
    Complex["E"] = new Complex(Math.E, 0);
    Complex["INFINITY"] = new Complex(Infinity, Infinity);
    Complex["NAN"] = new Complex(NaN, NaN);
    Complex["EPSILON"] = 1e-15;
    if (typeof define === "function" && define["amd"]) define([], function() {
        return Complex;
    });
    else {
        Object.defineProperty(Complex, "__esModule", {
            "value": true
        });
        Complex["default"] = Complex;
        Complex["Complex"] = Complex;
        $300e2d6880da0e38$exports = Complex;
    }
})($300e2d6880da0e38$exports);





var $9d81e778db0198b3$var$name = "Complex";
var $9d81e778db0198b3$var$dependencies = [];
var $9d81e778db0198b3$export$24a4be44fc8b6392 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($9d81e778db0198b3$var$name, $9d81e778db0198b3$var$dependencies, ()=>{
    /**
   * Attach type information
   */ (0, (/*@__PURE__*/$parcel$interopDefault($300e2d6880da0e38$exports))).prototype.type = "Complex";
    (0, (/*@__PURE__*/$parcel$interopDefault($300e2d6880da0e38$exports))).prototype.isComplex = true;
    /**
   * Get a JSON representation of the complex number
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "Complex", "re": 2, "im": 3}`
   */ (0, (/*@__PURE__*/$parcel$interopDefault($300e2d6880da0e38$exports))).prototype.toJSON = function() {
        return {
            mathjs: "Complex",
            re: this.re,
            im: this.im
        };
    };
    /*
   * Return the value of the complex number in polar notation
   * The angle phi will be set in the interval of [-pi, pi].
   * @return {{r: number, phi: number}} Returns and object with properties r and phi.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($300e2d6880da0e38$exports))).prototype.toPolar = function() {
        return {
            r: this.abs(),
            phi: this.arg()
        };
    };
    /**
   * Get a string representation of the complex number,
   * with optional formatting options.
   * @param {Object | number | Function} [options]  Formatting options. See
   *                                                lib/utils/number:format for a
   *                                                description of the available
   *                                                options.
   * @return {string} str
   */ (0, (/*@__PURE__*/$parcel$interopDefault($300e2d6880da0e38$exports))).prototype.format = function(options) {
        var str = "";
        var im = this.im;
        var re = this.re;
        var strRe = (0, $668e051498bf5fa0$export$d9468344d3651243)(this.re, options);
        var strIm = (0, $668e051498bf5fa0$export$d9468344d3651243)(this.im, options); // round either re or im when smaller than the configured precision
        var precision = (0, $d8097b7a6d6e36d8$export$7e4aa119212bc614)(options) ? options : options ? options.precision : null;
        if (precision !== null) {
            var epsilon = Math.pow(10, -precision);
            if (Math.abs(re / im) < epsilon) re = 0;
            if (Math.abs(im / re) < epsilon) im = 0;
        }
        if (im === 0) // real value
        str = strRe;
        else if (re === 0) {
            // purely complex value
            if (im === 1) str = "i";
            else if (im === -1) str = "-i";
            else str = strIm + "i";
        } else {
            // complex value
            if (im < 0) {
                if (im === -1) str = strRe + " - i";
                else str = strRe + " - " + strIm.substring(1) + "i";
            } else if (im === 1) str = strRe + " + i";
            else str = strRe + " + " + strIm + "i";
        }
        return str;
    };
    /**
   * Create a complex number from polar coordinates
   *
   * Usage:
   *
   *     Complex.fromPolar(r: number, phi: number) : Complex
   *     Complex.fromPolar({r: number, phi: number}) : Complex
   *
   * @param {*} args...
   * @return {Complex}
   */ (0, (/*@__PURE__*/$parcel$interopDefault($300e2d6880da0e38$exports))).fromPolar = function(args) {
        switch(arguments.length){
            case 1:
                var arg = arguments[0];
                if (typeof arg === "object") return (0, (/*@__PURE__*/$parcel$interopDefault($300e2d6880da0e38$exports)))(arg);
                else throw new TypeError("Input has to be an object with r and phi keys.");
            case 2:
                var r = arguments[0];
                var phi = arguments[1];
                if ((0, $d8097b7a6d6e36d8$export$7e4aa119212bc614)(r)) {
                    if ((0, $d8097b7a6d6e36d8$export$8960dc335987b8da)(phi) && phi.hasBase("ANGLE")) // convert unit to a number in radians
                    phi = phi.toNumber("rad");
                    if ((0, $d8097b7a6d6e36d8$export$7e4aa119212bc614)(phi)) return new (0, (/*@__PURE__*/$parcel$interopDefault($300e2d6880da0e38$exports)))({
                        r: r,
                        phi: phi
                    });
                    throw new TypeError("Phi is not a number nor an angle unit.");
                } else throw new TypeError("Radius r is not a number.");
            default:
                throw new SyntaxError("Wrong number of arguments in function fromPolar");
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($300e2d6880da0e38$exports))).prototype.valueOf = (0, (/*@__PURE__*/$parcel$interopDefault($300e2d6880da0e38$exports))).prototype.toString;
    /**
   * Create a Complex number from a JSON object
   * @param {Object} json  A JSON Object structured as
   *                       {"mathjs": "Complex", "re": 2, "im": 3}
   *                       All properties are optional, default values
   *                       for `re` and `im` are 0.
   * @return {Complex} Returns a new Complex number
   */ (0, (/*@__PURE__*/$parcel$interopDefault($300e2d6880da0e38$exports))).fromJSON = function(json) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($300e2d6880da0e38$exports)))(json);
    };
    /**
   * Compare two complex numbers, `a` and `b`:
   *
   * - Returns 1 when the real part of `a` is larger than the real part of `b`
   * - Returns -1 when the real part of `a` is smaller than the real part of `b`
   * - Returns 1 when the real parts are equal
   *   and the imaginary part of `a` is larger than the imaginary part of `b`
   * - Returns -1 when the real parts are equal
   *   and the imaginary part of `a` is smaller than the imaginary part of `b`
   * - Returns 0 when both real and imaginary parts are equal.
   *
   * @params {Complex} a
   * @params {Complex} b
   * @returns {number} Returns the comparison result: -1, 0, or 1
   */ (0, (/*@__PURE__*/$parcel$interopDefault($300e2d6880da0e38$exports))).compare = function(a, b) {
        if (a.re > b.re) return 1;
        if (a.re < b.re) return -1;
        if (a.im > b.im) return 1;
        if (a.im < b.im) return -1;
        return 0;
    };
    return 0, (/*@__PURE__*/$parcel$interopDefault($300e2d6880da0e38$exports));
}, {
    isClass: true
});


var $a4353b44782dc3fe$export$83d89fbfd8236492 = "10.6.4"; // Note: This file is automatically generated when building math.js.
 // Changes made in this file will be overwritten.


// function utils
// (c) 2018, Mariusz Nowak
// SPDX-License-Identifier: ISC
// Derived from https://github.com/medikoo/lru-queue
function $89320e7d06a237da$export$6080faceac22b73a(limit) {
    var size = 0;
    var base = 1;
    var queue = Object.create(null);
    var map = Object.create(null);
    var index = 0;
    var del = function del(id) {
        var oldIndex = map[id];
        if (!oldIndex) return;
        delete queue[oldIndex];
        delete map[id];
        --size;
        if (base !== oldIndex) return;
        if (!size) {
            index = 0;
            base = 1;
            return;
        }
        while(!hasOwnProperty.call(queue, ++base))continue;
    };
    limit = Math.abs(limit);
    return {
        hit: function hit(id) {
            var oldIndex = map[id];
            var nuIndex = ++index;
            queue[nuIndex] = id;
            map[id] = nuIndex;
            if (!oldIndex) {
                ++size;
                if (size <= limit) return undefined;
                id = queue[base];
                del(id);
                return id;
            }
            delete queue[oldIndex];
            if (base !== oldIndex) return undefined;
            while(!hasOwnProperty.call(queue, ++base))continue;
            return undefined;
        },
        delete: del,
        clear: function clear() {
            size = index = 0;
            base = 1;
            queue = Object.create(null);
            map = Object.create(null);
        }
    };
}


function $458cc793bcf3a223$export$fc10aeed3a532e2a(fn) {
    var { hasher: hasher, limit: limit } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    limit = limit == null ? Number.POSITIVE_INFINITY : limit;
    hasher = hasher == null ? JSON.stringify : hasher;
    return function memoize() {
        if (typeof memoize.cache !== "object") memoize.cache = {
            values: new Map(),
            lru: (0, $89320e7d06a237da$export$6080faceac22b73a)(limit || Number.POSITIVE_INFINITY)
        };
        var args = [];
        for(var i = 0; i < arguments.length; i++)args[i] = arguments[i];
        var hash = hasher(args);
        if (memoize.cache.values.has(hash)) {
            memoize.cache.lru.hit(hash);
            return memoize.cache.values.get(hash);
        }
        var newVal = fn.apply(fn, args);
        memoize.cache.values.set(hash, newVal);
        memoize.cache.values.delete(memoize.cache.lru.hit(hash));
        return newVal;
    };
}
function $458cc793bcf3a223$export$22992fec26710d5a(fn, isEqual) {
    var memoize = function memoize() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args[i] = arguments[i];
        for(var c = 0; c < memoize.cache.length; c++){
            var cached = memoize.cache[c];
            if (isEqual(args, cached.args)) // TODO: move this cache entry to the top so recently used entries move up?
            return cached.res;
        }
        var res = fn.apply(fn, args);
        memoize.cache.unshift({
            args: args,
            res: res
        });
        return res;
    };
    memoize.cache = [];
    return memoize;
}
function $458cc793bcf3a223$export$6c00fba23f8c91a7(fn) {
    return Object.keys(fn.signatures || {}).reduce(function(args, signature) {
        var count = (signature.match(/,/g) || []).length + 1;
        return Math.max(args, count);
    }, -1);
}


var $40ac173b3ca35861$export$737cba75de6dfb68 = (0, $458cc793bcf3a223$export$fc10aeed3a532e2a)(function(BigNumber) {
    return new BigNumber(1).exp();
}, {
    hasher: $40ac173b3ca35861$var$hasher
});
var $40ac173b3ca35861$export$c7e121b24930c156 = (0, $458cc793bcf3a223$export$fc10aeed3a532e2a)(function(BigNumber) {
    return new BigNumber(1).plus(new BigNumber(5).sqrt()).div(2);
}, {
    hasher: $40ac173b3ca35861$var$hasher
});
var $40ac173b3ca35861$export$d0a8190d955e3c5b = (0, $458cc793bcf3a223$export$fc10aeed3a532e2a)(function(BigNumber) {
    return BigNumber.acos(-1);
}, {
    hasher: $40ac173b3ca35861$var$hasher
});
var $40ac173b3ca35861$export$83b6ee92a84f32c6 = (0, $458cc793bcf3a223$export$fc10aeed3a532e2a)(function(BigNumber) {
    return $40ac173b3ca35861$export$d0a8190d955e3c5b(BigNumber).times(2);
}, {
    hasher: $40ac173b3ca35861$var$hasher
});
/**
 * Create a hash for a BigNumber constructor function. The created has is
 * the configured precision
 * @param {Array} args         Supposed to contain a single entry with
 *                             a BigNumber constructor
 * @return {number} precision
 * @private
 */ function $40ac173b3ca35861$var$hasher(args) {
    return args[0].precision;
}


var $e48fe504ea4436b4$export$18c7bea995a110f = Math.PI;
var $e48fe504ea4436b4$export$a4b4b4d4d776fe92 = 2 * Math.PI;
var $e48fe504ea4436b4$export$f1e1789686576879 = Math.E;
var $e48fe504ea4436b4$export$324943737027944a = 1.6180339887498948; // eslint-disable-line no-loss-of-precision


var $04364ed81e47ae96$export$e13d32722e2756df = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)("true", [], ()=>true);
var $04364ed81e47ae96$export$cb94e3a54c9e99b = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)("false", [], ()=>false);
var $04364ed81e47ae96$export$d07c6114481fc17b = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)("null", [], ()=>null);
var $04364ed81e47ae96$export$df1313fb6eb44f05 = /* #__PURE__ */ $04364ed81e47ae96$var$recreateFactory("Infinity", [
    "config",
    "?BigNumber"
], (_ref)=>{
    var { config: config, BigNumber: BigNumber } = _ref;
    return config.number === "BigNumber" ? new BigNumber(Infinity) : Infinity;
});
var $04364ed81e47ae96$export$fbdaee11df58c3cc = /* #__PURE__ */ $04364ed81e47ae96$var$recreateFactory("NaN", [
    "config",
    "?BigNumber"
], (_ref2)=>{
    var { config: config, BigNumber: BigNumber } = _ref2;
    return config.number === "BigNumber" ? new BigNumber(NaN) : NaN;
});
var $04364ed81e47ae96$export$2dbe69c48ac7f49c = /* #__PURE__ */ $04364ed81e47ae96$var$recreateFactory("pi", [
    "config",
    "?BigNumber"
], (_ref3)=>{
    var { config: config, BigNumber: BigNumber } = _ref3;
    return config.number === "BigNumber" ? (0, $40ac173b3ca35861$export$d0a8190d955e3c5b)(BigNumber) : (0, $e48fe504ea4436b4$export$18c7bea995a110f);
});
var $04364ed81e47ae96$export$d5973a6d5d95d479 = /* #__PURE__ */ $04364ed81e47ae96$var$recreateFactory("tau", [
    "config",
    "?BigNumber"
], (_ref4)=>{
    var { config: config, BigNumber: BigNumber } = _ref4;
    return config.number === "BigNumber" ? (0, $40ac173b3ca35861$export$83b6ee92a84f32c6)(BigNumber) : (0, $e48fe504ea4436b4$export$a4b4b4d4d776fe92);
});
var $04364ed81e47ae96$export$6dca51ff4d4b257f = /* #__PURE__ */ $04364ed81e47ae96$var$recreateFactory("e", [
    "config",
    "?BigNumber"
], (_ref5)=>{
    var { config: config, BigNumber: BigNumber } = _ref5;
    return config.number === "BigNumber" ? (0, $40ac173b3ca35861$export$737cba75de6dfb68)(BigNumber) : (0, $e48fe504ea4436b4$export$f1e1789686576879);
}); // golden ratio, (1+sqrt(5))/2
var $04364ed81e47ae96$export$f131830080647892 = /* #__PURE__ */ $04364ed81e47ae96$var$recreateFactory("phi", [
    "config",
    "?BigNumber"
], (_ref6)=>{
    var { config: config, BigNumber: BigNumber } = _ref6;
    return config.number === "BigNumber" ? (0, $40ac173b3ca35861$export$c7e121b24930c156)(BigNumber) : (0, $e48fe504ea4436b4$export$324943737027944a);
});
var $04364ed81e47ae96$export$ab67ddb9e8290a2c = /* #__PURE__ */ $04364ed81e47ae96$var$recreateFactory("LN2", [
    "config",
    "?BigNumber"
], (_ref7)=>{
    var { config: config, BigNumber: BigNumber } = _ref7;
    return config.number === "BigNumber" ? new BigNumber(2).ln() : Math.LN2;
});
var $04364ed81e47ae96$export$5365e90aad1235b4 = /* #__PURE__ */ $04364ed81e47ae96$var$recreateFactory("LN10", [
    "config",
    "?BigNumber"
], (_ref8)=>{
    var { config: config, BigNumber: BigNumber } = _ref8;
    return config.number === "BigNumber" ? new BigNumber(10).ln() : Math.LN10;
});
var $04364ed81e47ae96$export$b57f4b4cfc057c2d = /* #__PURE__ */ $04364ed81e47ae96$var$recreateFactory("LOG2E", [
    "config",
    "?BigNumber"
], (_ref9)=>{
    var { config: config, BigNumber: BigNumber } = _ref9;
    return config.number === "BigNumber" ? new BigNumber(1).div(new BigNumber(2).ln()) : Math.LOG2E;
});
var $04364ed81e47ae96$export$57f654bce66ec8ce = /* #__PURE__ */ $04364ed81e47ae96$var$recreateFactory("LOG10E", [
    "config",
    "?BigNumber"
], (_ref10)=>{
    var { config: config, BigNumber: BigNumber } = _ref10;
    return config.number === "BigNumber" ? new BigNumber(1).div(new BigNumber(10).ln()) : Math.LOG10E;
});
var $04364ed81e47ae96$export$e6df2cb14f3e8316 = /* #__PURE__ */ $04364ed81e47ae96$var$recreateFactory("SQRT1_2", [
    "config",
    "?BigNumber"
], (_ref11)=>{
    var { config: config, BigNumber: BigNumber } = _ref11;
    return config.number === "BigNumber" ? new BigNumber("0.5").sqrt() : Math.SQRT1_2;
});
var $04364ed81e47ae96$export$f7a593fe98eba575 = /* #__PURE__ */ $04364ed81e47ae96$var$recreateFactory("SQRT2", [
    "config",
    "?BigNumber"
], (_ref12)=>{
    var { config: config, BigNumber: BigNumber } = _ref12;
    return config.number === "BigNumber" ? new BigNumber(2).sqrt() : Math.SQRT2;
});
var $04364ed81e47ae96$export$7122d2461a6f9b76 = /* #__PURE__ */ $04364ed81e47ae96$var$recreateFactory("i", [
    "Complex"
], (_ref13)=>{
    var { Complex: Complex } = _ref13;
    return Complex.I;
}); // for backward compatibility with v5
var $04364ed81e47ae96$export$5aab935c59859292 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)("PI", [
    "pi"
], (_ref14)=>{
    var { pi: pi } = _ref14;
    return pi;
});
var $04364ed81e47ae96$export$56c791a240a1c942 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)("E", [
    "e"
], (_ref15)=>{
    var { e: e } = _ref15;
    return e;
});
var $04364ed81e47ae96$export$72a91d9326d5a672 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)("version", [], ()=>(0, $a4353b44782dc3fe$export$83d89fbfd8236492)); // helper function to create a factory with a flag recreateOnConfigChange
// idea: allow passing optional properties to be attached to the factory function as 4th argument?
function $04364ed81e47ae96$var$recreateFactory(name, dependencies, create) {
    return (0, $e745cf56e5b0be75$export$e9008f2713103c6c)(name, dependencies, create, {
        recreateOnConfigChange: true
    });
}


var $f30778583b16570c$export$ace78258608300fc = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("speedOfLight", "299792458", "m s^-1");
var $f30778583b16570c$export$157e78cb05354391 = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("gravitationConstant", "6.67430e-11", "m^3 kg^-1 s^-2");
var $f30778583b16570c$export$e58ff8150d83ea6a = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("planckConstant", "6.62607015e-34", "J s");
var $f30778583b16570c$export$50bee65ab76b402 = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("reducedPlanckConstant", "1.0545718176461565e-34", "J s"); // Electromagnetic constants
var $f30778583b16570c$export$e7fcb8898ecb0703 = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("magneticConstant", "1.25663706212e-6", "N A^-2");
var $f30778583b16570c$export$d69030cf93f04407 = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("electricConstant", "8.8541878128e-12", "F m^-1");
var $f30778583b16570c$export$c9ff08d282f03cf0 = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("vacuumImpedance", "376.730313667", "ohm");
var $f30778583b16570c$export$815f2029cd62d0d6 = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("coulomb", "8.987551792261171e9", "N m^2 C^-2");
var $f30778583b16570c$export$542715ad7e3a9798 = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("elementaryCharge", "1.602176634e-19", "C");
var $f30778583b16570c$export$f5851397fd1173db = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("bohrMagneton", "9.2740100783e-24", "J T^-1");
var $f30778583b16570c$export$e26bbd27fc291ddf = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("conductanceQuantum", "7.748091729863649e-5", "S");
var $f30778583b16570c$export$f2f136373157165b = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("inverseConductanceQuantum", "12906.403729652257", "ohm");
var $f30778583b16570c$export$fd46b6c8680e4d01 = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("magneticFluxQuantum", "2.0678338484619295e-15", "Wb");
var $f30778583b16570c$export$9670d94122b9a81b = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("nuclearMagneton", "5.0507837461e-27", "J T^-1");
var $f30778583b16570c$export$e3f21ac13bee6a0f = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("klitzing", "25812.807459304513", "ohm");
var $f30778583b16570c$export$c090909964c68de4 = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("josephson", "4.835978484169836e14 Hz V", "Hz V^-1"); // TODO: support for Hz needed
var $f30778583b16570c$export$19b72356ad84e4ee = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("bohrRadius", "5.29177210903e-11", "m");
var $f30778583b16570c$export$68a9771dccce9a23 = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("classicalElectronRadius", "2.8179403262e-15", "m");
var $f30778583b16570c$export$85362d2a7862e209 = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("electronMass", "9.1093837015e-31", "kg");
var $f30778583b16570c$export$b6687a2f3911256b = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("fermiCoupling", "1.1663787e-5", "GeV^-2");
var $f30778583b16570c$export$aaddb59a993d3ac4 = $f30778583b16570c$var$numberFactory("fineStructure", 7.2973525693e-3);
var $f30778583b16570c$export$8bb818baeaa40bd6 = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("hartreeEnergy", "4.3597447222071e-18", "J");
var $f30778583b16570c$export$f357c1a8d4fccef6 = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("protonMass", "1.67262192369e-27", "kg");
var $f30778583b16570c$export$a403f6c5bed71f22 = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("deuteronMass", "3.3435830926e-27", "kg");
var $f30778583b16570c$export$676d5ebe8fbeb250 = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("neutronMass", "1.6749271613e-27", "kg");
var $f30778583b16570c$export$6840f334b8a5b6b1 = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("quantumOfCirculation", "3.6369475516e-4", "m^2 s^-1");
var $f30778583b16570c$export$fd1b48ecb0d5c0ef = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("rydberg", "10973731.568160", "m^-1");
var $f30778583b16570c$export$229739a879741f68 = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("thomsonCrossSection", "6.6524587321e-29", "m^2");
var $f30778583b16570c$export$fa2d42c5c25c1883 = $f30778583b16570c$var$numberFactory("weakMixingAngle", 0.22290);
var $f30778583b16570c$export$55fc8769b037d266 = $f30778583b16570c$var$numberFactory("efimovFactor", 22.7); // Physico-chemical constants
var $f30778583b16570c$export$2f8d2da219209d0a = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("atomicMass", "1.66053906660e-27", "kg");
var $f30778583b16570c$export$4924e3d8de6ad850 = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("avogadro", "6.02214076e23", "mol^-1");
var $f30778583b16570c$export$221b7a8c9510b6cc = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("boltzmann", "1.380649e-23", "J K^-1");
var $f30778583b16570c$export$17ef8d738c9b0091 = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("faraday", "96485.33212331001", "C mol^-1");
var $f30778583b16570c$export$266a9bae8a62fb6e = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("firstRadiation", "3.7417718521927573e-16", "W m^2"); // export const createSpectralRadiance = /* #__PURE__ */ unitFactory('spectralRadiance', '1.1910429723971881e-16', 'W m^2 sr^-1') // TODO spectralRadiance
var $f30778583b16570c$export$c38bce537e0ffddb = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("loschmidt", "2.686780111798444e25", "m^-3");
var $f30778583b16570c$export$85a77a0842c24f74 = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("gasConstant", "8.31446261815324", "J K^-1 mol^-1");
var $f30778583b16570c$export$12e2358797b853c9 = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("molarPlanckConstant", "3.990312712893431e-10", "J s mol^-1");
var $f30778583b16570c$export$f5e8f56ebfacbaca = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("molarVolume", "0.022413969545014137", "m^3 mol^-1");
var $f30778583b16570c$export$467c65d9dfc3d3a2 = $f30778583b16570c$var$numberFactory("sackurTetrode", -1.16487052358);
var $f30778583b16570c$export$ea93a35a6f35e1b6 = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("secondRadiation", "0.014387768775039337", "m K");
var $f30778583b16570c$export$a943525a62f69cd2 = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("stefanBoltzmann", "5.67037441918443e-8", "W m^-2 K^-4");
var $f30778583b16570c$export$3c74568e9574d168 = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("wienDisplacement", "2.897771955e-3", "m K"); // Adopted values
var $f30778583b16570c$export$85414d775c93e6de = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("molarMass", "0.99999999965e-3", "kg mol^-1");
var $f30778583b16570c$export$d5045cf71611a462 = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("molarMassC12", "11.9999999958e-3", "kg mol^-1");
var $f30778583b16570c$export$42b5845f95e0feee = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("gravity", "9.80665", "m s^-2"); // atm is defined in Unit.js
var $f30778583b16570c$export$675ebbcd6bdcebd7 = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("planckLength", "1.616255e-35", "m");
var $f30778583b16570c$export$d44b96c94520b20e = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("planckMass", "2.176435e-8", "kg");
var $f30778583b16570c$export$3bf63d7b96fd8541 = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("planckTime", "5.391245e-44", "s");
var $f30778583b16570c$export$43e139a6eec1ab59 = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("planckCharge", "1.87554603778e-18", "C");
var $f30778583b16570c$export$d21f20fc89fac8c0 = /* #__PURE__ */ $f30778583b16570c$var$unitFactory("planckTemperature", "1.416785e+32", "K"); // helper function to create a factory function which creates a physical constant,
// a Unit with either a number value or a BigNumber value depending on the configuration
function $f30778583b16570c$var$unitFactory(name, valueStr, unitStr) {
    var dependencies = [
        "config",
        "Unit",
        "BigNumber"
    ];
    return (0, $e745cf56e5b0be75$export$e9008f2713103c6c)(name, dependencies, (_ref)=>{
        var { config: config, Unit: Unit, BigNumber: BigNumber } = _ref;
        // Note that we can parse into number or BigNumber.
        // We do not parse into Fractions as that doesn't make sense: we would lose precision of the values
        // Therefore we dont use Unit.parse()
        var value = config.number === "BigNumber" ? new BigNumber(valueStr) : parseFloat(valueStr);
        var unit = new Unit(value, unitStr);
        unit.fixPrefix = true;
        return unit;
    });
} // helper function to create a factory function which creates a numeric constant,
// either a number or BigNumber depending on the configuration
function $f30778583b16570c$var$numberFactory(name, value) {
    var dependencies = [
        "config",
        "BigNumber"
    ];
    return (0, $e745cf56e5b0be75$export$e9008f2713103c6c)(name, dependencies, (_ref2)=>{
        var { config: config, BigNumber: BigNumber } = _ref2;
        return config.number === "BigNumber" ? new BigNumber(value) : value;
    });
}

var $837d94196a0cfb1e$exports = {};
/**
 * @license Fraction.js v4.3.7 31/08/2023
 * https://www.xarg.org/2014/03/rational-numbers-in-javascript/
 *
 * Copyright (c) 2023, Robert Eisele (robert@raw.org)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 **/ /**
 *
 * This class offers the possibility to calculate fractions.
 * You can pass a fraction in different formats. Either as array, as double, as string or as an integer.
 *
 * Array/Object form
 * [ 0 => <numerator>, 1 => <denominator> ]
 * [ n => <numerator>, d => <denominator> ]
 *
 * Integer form
 * - Single integer value
 *
 * Double form
 * - Single double value
 *
 * String form
 * 123.456 - a simple double
 * 123/456 - a string fraction
 * 123.'456' - a double with repeating decimal places
 * 123.(456) - synonym
 * 123.45'6' - a double with repeating last place
 * 123.45(6) - synonym
 *
 * Example:
 *
 * var f = new Fraction("9.4'31'");
 * f.mul([-4, 3]).div(4.9);
 *
 */ (function(root) {
    "use strict";
    // Maximum search depth for cyclic rational numbers. 2000 should be more than enough.
    // Example: 1/7 = 0.(142857) has 6 repeating decimal places.
    // If MAX_CYCLE_LEN gets reduced, long cycles will not be detected and toString() only gets the first 10 digits
    var MAX_CYCLE_LEN = 2000;
    // Parsed data to avoid calling "new" all the time
    var P = {
        "s": 1,
        "n": 0,
        "d": 1
    };
    function assign(n, s) {
        if (isNaN(n = parseInt(n, 10))) throw InvalidParameter();
        return n * s;
    }
    // Creates a new Fraction internally without the need of the bulky constructor
    function newFraction(n, d) {
        if (d === 0) throw DivisionByZero();
        var f = Object.create(Fraction.prototype);
        f["s"] = n < 0 ? -1 : 1;
        n = n < 0 ? -n : n;
        var a = gcd(n, d);
        f["n"] = n / a;
        f["d"] = d / a;
        return f;
    }
    function factorize(num) {
        var factors = {};
        var n = num;
        var i = 2;
        var s = 4;
        while(s <= n){
            while(n % i === 0){
                n /= i;
                factors[i] = (factors[i] || 0) + 1;
            }
            s += 1 + 2 * i++;
        }
        if (n !== num) {
            if (n > 1) factors[n] = (factors[n] || 0) + 1;
        } else factors[num] = (factors[num] || 0) + 1;
        return factors;
    }
    var parse = function(p1, p2) {
        var n = 0, d = 1, s = 1;
        var v = 0, w = 0, x = 0, y = 1, z = 1;
        var A = 0, B = 1;
        var C = 1, D = 1;
        var N = 10000000;
        var M;
        if (p1 === undefined || p1 === null) ;
        else if (p2 !== undefined) {
            n = p1;
            d = p2;
            s = n * d;
            if (n % 1 !== 0 || d % 1 !== 0) throw NonIntegerParameter();
        } else switch(typeof p1){
            case "object":
                if ("d" in p1 && "n" in p1) {
                    n = p1["n"];
                    d = p1["d"];
                    if ("s" in p1) n *= p1["s"];
                } else if (0 in p1) {
                    n = p1[0];
                    if (1 in p1) d = p1[1];
                } else throw InvalidParameter();
                s = n * d;
                break;
            case "number":
                if (p1 < 0) {
                    s = p1;
                    p1 = -p1;
                }
                if (p1 % 1 === 0) n = p1;
                else if (p1 > 0) {
                    if (p1 >= 1) {
                        z = Math.pow(10, Math.floor(1 + Math.log(p1) / Math.LN10));
                        p1 /= z;
                    }
                    // Using Farey Sequences
                    // http://www.johndcook.com/blog/2010/10/20/best-rational-approximation/
                    while(B <= N && D <= N){
                        M = (A + C) / (B + D);
                        if (p1 === M) {
                            if (B + D <= N) {
                                n = A + C;
                                d = B + D;
                            } else if (D > B) {
                                n = C;
                                d = D;
                            } else {
                                n = A;
                                d = B;
                            }
                            break;
                        } else {
                            if (p1 > M) {
                                A += C;
                                B += D;
                            } else {
                                C += A;
                                D += B;
                            }
                            if (B > N) {
                                n = C;
                                d = D;
                            } else {
                                n = A;
                                d = B;
                            }
                        }
                    }
                    n *= z;
                } else if (isNaN(p1) || isNaN(p2)) d = n = NaN;
                break;
            case "string":
                B = p1.match(/\d+|./g);
                if (B === null) throw InvalidParameter();
                if (B[A] === "-") {
                    s = -1;
                    A++;
                } else if (B[A] === "+") A++;
                if (B.length === A + 1) w = assign(B[A++], s);
                else if (B[A + 1] === "." || B[A] === ".") {
                    if (B[A] !== ".") v = assign(B[A++], s);
                    A++;
                    // Check for decimal places
                    if (A + 1 === B.length || B[A + 1] === "(" && B[A + 3] === ")" || B[A + 1] === "'" && B[A + 3] === "'") {
                        w = assign(B[A], s);
                        y = Math.pow(10, B[A].length);
                        A++;
                    }
                    // Check for repeating places
                    if (B[A] === "(" && B[A + 2] === ")" || B[A] === "'" && B[A + 2] === "'") {
                        x = assign(B[A + 1], s);
                        z = Math.pow(10, B[A + 1].length) - 1;
                        A += 3;
                    }
                } else if (B[A + 1] === "/" || B[A + 1] === ":") {
                    w = assign(B[A], s);
                    y = assign(B[A + 2], 1);
                    A += 3;
                } else if (B[A + 3] === "/" && B[A + 1] === " ") {
                    v = assign(B[A], s);
                    w = assign(B[A + 2], s);
                    y = assign(B[A + 4], 1);
                    A += 5;
                }
                if (B.length <= A) {
                    d = y * z;
                    s = /* void */ n = x + d * v + z * w;
                    break;
                }
            default:
                throw InvalidParameter();
        }
        if (d === 0) throw DivisionByZero();
        P["s"] = s < 0 ? -1 : 1;
        P["n"] = Math.abs(n);
        P["d"] = Math.abs(d);
    };
    function modpow(b, e, m) {
        var r = 1;
        for(; e > 0; b = b * b % m, e >>= 1)if (e & 1) r = r * b % m;
        return r;
    }
    function cycleLen(n, d) {
        for(; d % 2 === 0; d /= 2);
        for(; d % 5 === 0; d /= 5);
        if (d === 1) return 0;
        // If we would like to compute really large numbers quicker, we could make use of Fermat's little theorem:
        // 10^(d-1) % d == 1
        // However, we don't need such large numbers and MAX_CYCLE_LEN should be the capstone,
        // as we want to translate the numbers to strings.
        var rem = 10 % d;
        var t = 1;
        for(; rem !== 1; t++){
            rem = rem * 10 % d;
            if (t > MAX_CYCLE_LEN) return 0; // Returning 0 here means that we don't print it as a cyclic number. It's likely that the answer is `d-1`
        }
        return t;
    }
    function cycleStart(n, d, len) {
        var rem1 = 1;
        var rem2 = modpow(10, len, d);
        for(var t = 0; t < 300; t++){
            // Solve 10^s == 10^(s+t) (mod d)
            if (rem1 === rem2) return t;
            rem1 = rem1 * 10 % d;
            rem2 = rem2 * 10 % d;
        }
        return 0;
    }
    function gcd(a, b) {
        if (!a) return b;
        if (!b) return a;
        while(true){
            a %= b;
            if (!a) return b;
            b %= a;
            if (!b) return a;
        }
    }
    /**
   * Module constructor
   *
   * @constructor
   * @param {number|Fraction=} a
   * @param {number=} b
   */ function Fraction(a, b) {
        parse(a, b);
        if (this instanceof Fraction) {
            a = gcd(P["d"], P["n"]); // Abuse variable a
            this["s"] = P["s"];
            this["n"] = P["n"] / a;
            this["d"] = P["d"] / a;
        } else return newFraction(P["s"] * P["n"], P["d"]);
    }
    var DivisionByZero = function() {
        return new Error("Division by Zero");
    };
    var InvalidParameter = function() {
        return new Error("Invalid argument");
    };
    var NonIntegerParameter = function() {
        return new Error("Parameters must be integer");
    };
    Fraction.prototype = {
        "s": 1,
        "n": 0,
        "d": 1,
        /**
     * Calculates the absolute value
     *
     * Ex: new Fraction(-4).abs() => 4
     **/ "abs": function() {
            return newFraction(this["n"], this["d"]);
        },
        /**
     * Inverts the sign of the current fraction
     *
     * Ex: new Fraction(-4).neg() => 4
     **/ "neg": function() {
            return newFraction(-this["s"] * this["n"], this["d"]);
        },
        /**
     * Adds two rational numbers
     *
     * Ex: new Fraction({n: 2, d: 3}).add("14.9") => 467 / 30
     **/ "add": function(a, b) {
            parse(a, b);
            return newFraction(this["s"] * this["n"] * P["d"] + P["s"] * this["d"] * P["n"], this["d"] * P["d"]);
        },
        /**
     * Subtracts two rational numbers
     *
     * Ex: new Fraction({n: 2, d: 3}).add("14.9") => -427 / 30
     **/ "sub": function(a, b) {
            parse(a, b);
            return newFraction(this["s"] * this["n"] * P["d"] - P["s"] * this["d"] * P["n"], this["d"] * P["d"]);
        },
        /**
     * Multiplies two rational numbers
     *
     * Ex: new Fraction("-17.(345)").mul(3) => 5776 / 111
     **/ "mul": function(a, b) {
            parse(a, b);
            return newFraction(this["s"] * P["s"] * this["n"] * P["n"], this["d"] * P["d"]);
        },
        /**
     * Divides two rational numbers
     *
     * Ex: new Fraction("-17.(345)").inverse().div(3)
     **/ "div": function(a, b) {
            parse(a, b);
            return newFraction(this["s"] * P["s"] * this["n"] * P["d"], this["d"] * P["n"]);
        },
        /**
     * Clones the actual object
     *
     * Ex: new Fraction("-17.(345)").clone()
     **/ "clone": function() {
            return newFraction(this["s"] * this["n"], this["d"]);
        },
        /**
     * Calculates the modulo of two rational numbers - a more precise fmod
     *
     * Ex: new Fraction('4.(3)').mod([7, 8]) => (13/3) % (7/8) = (5/6)
     **/ "mod": function(a, b) {
            if (isNaN(this["n"]) || isNaN(this["d"])) return new Fraction(NaN);
            if (a === undefined) return newFraction(this["s"] * this["n"] % this["d"], 1);
            parse(a, b);
            if (0 === P["n"] && 0 === this["d"]) throw DivisionByZero();
            /*
       * First silly attempt, kinda slow
       *
       return that["sub"]({
       "n": num["n"] * Math.floor((this.n / this.d) / (num.n / num.d)),
       "d": num["d"],
       "s": this["s"]
       });*/ /*
       * New attempt: a1 / b1 = a2 / b2 * q + r
       * => b2 * a1 = a2 * b1 * q + b1 * b2 * r
       * => (b2 * a1 % a2 * b1) / (b1 * b2)
       */ return newFraction(this["s"] * (P["d"] * this["n"]) % (P["n"] * this["d"]), P["d"] * this["d"]);
        },
        /**
     * Calculates the fractional gcd of two rational numbers
     *
     * Ex: new Fraction(5,8).gcd(3,7) => 1/56
     */ "gcd": function(a, b) {
            parse(a, b);
            // gcd(a / b, c / d) = gcd(a, c) / lcm(b, d)
            return newFraction(gcd(P["n"], this["n"]) * gcd(P["d"], this["d"]), P["d"] * this["d"]);
        },
        /**
     * Calculates the fractional lcm of two rational numbers
     *
     * Ex: new Fraction(5,8).lcm(3,7) => 15
     */ "lcm": function(a, b) {
            parse(a, b);
            // lcm(a / b, c / d) = lcm(a, c) / gcd(b, d)
            if (P["n"] === 0 && this["n"] === 0) return newFraction(0, 1);
            return newFraction(P["n"] * this["n"], gcd(P["n"], this["n"]) * gcd(P["d"], this["d"]));
        },
        /**
     * Calculates the ceil of a rational number
     *
     * Ex: new Fraction('4.(3)').ceil() => (5 / 1)
     **/ "ceil": function(places) {
            places = Math.pow(10, places || 0);
            if (isNaN(this["n"]) || isNaN(this["d"])) return new Fraction(NaN);
            return newFraction(Math.ceil(places * this["s"] * this["n"] / this["d"]), places);
        },
        /**
     * Calculates the floor of a rational number
     *
     * Ex: new Fraction('4.(3)').floor() => (4 / 1)
     **/ "floor": function(places) {
            places = Math.pow(10, places || 0);
            if (isNaN(this["n"]) || isNaN(this["d"])) return new Fraction(NaN);
            return newFraction(Math.floor(places * this["s"] * this["n"] / this["d"]), places);
        },
        /**
     * Rounds a rational numbers
     *
     * Ex: new Fraction('4.(3)').round() => (4 / 1)
     **/ "round": function(places) {
            places = Math.pow(10, places || 0);
            if (isNaN(this["n"]) || isNaN(this["d"])) return new Fraction(NaN);
            return newFraction(Math.round(places * this["s"] * this["n"] / this["d"]), places);
        },
        /**
     * Rounds a rational number to a multiple of another rational number
     *
     * Ex: new Fraction('0.9').roundTo("1/8") => 7 / 8
     **/ "roundTo": function(a, b) {
            /*
      k * x/y ≤ a/b < (k+1) * x/y
      ⇔ k ≤ a/b / (x/y) < (k+1)
      ⇔ k = floor(a/b * y/x)
      */ parse(a, b);
            return newFraction(this["s"] * Math.round(this["n"] * P["d"] / (this["d"] * P["n"])) * P["n"], P["d"]);
        },
        /**
     * Gets the inverse of the fraction, means numerator and denominator are exchanged
     *
     * Ex: new Fraction([-3, 4]).inverse() => -4 / 3
     **/ "inverse": function() {
            return newFraction(this["s"] * this["d"], this["n"]);
        },
        /**
     * Calculates the fraction to some rational exponent, if possible
     *
     * Ex: new Fraction(-1,2).pow(-3) => -8
     */ "pow": function(a, b) {
            parse(a, b);
            // Trivial case when exp is an integer
            if (P["d"] === 1) {
                if (P["s"] < 0) return newFraction(Math.pow(this["s"] * this["d"], P["n"]), Math.pow(this["n"], P["n"]));
                else return newFraction(Math.pow(this["s"] * this["n"], P["n"]), Math.pow(this["d"], P["n"]));
            }
            // Negative roots become complex
            //     (-a/b)^(c/d) = x
            // <=> (-1)^(c/d) * (a/b)^(c/d) = x
            // <=> (cos(pi) + i*sin(pi))^(c/d) * (a/b)^(c/d) = x         # rotate 1 by 180°
            // <=> (cos(c*pi/d) + i*sin(c*pi/d)) * (a/b)^(c/d) = x       # DeMoivre's formula in Q ( https://proofwiki.org/wiki/De_Moivre%27s_Formula/Rational_Index )
            // From which follows that only for c=0 the root is non-complex. c/d is a reduced fraction, so that sin(c/dpi)=0 occurs for d=1, which is handled by our trivial case.
            if (this["s"] < 0) return null;
            // Now prime factor n and d
            var N = factorize(this["n"]);
            var D = factorize(this["d"]);
            // Exponentiate and take root for n and d individually
            var n = 1;
            var d = 1;
            for(var k in N){
                if (k === "1") continue;
                if (k === "0") {
                    n = 0;
                    break;
                }
                N[k] *= P["n"];
                if (N[k] % P["d"] === 0) N[k] /= P["d"];
                else return null;
                n *= Math.pow(k, N[k]);
            }
            for(var k in D){
                if (k === "1") continue;
                D[k] *= P["n"];
                if (D[k] % P["d"] === 0) D[k] /= P["d"];
                else return null;
                d *= Math.pow(k, D[k]);
            }
            if (P["s"] < 0) return newFraction(d, n);
            return newFraction(n, d);
        },
        /**
     * Check if two rational numbers are the same
     *
     * Ex: new Fraction(19.6).equals([98, 5]);
     **/ "equals": function(a, b) {
            parse(a, b);
            return this["s"] * this["n"] * P["d"] === P["s"] * P["n"] * this["d"]; // Same as compare() === 0
        },
        /**
     * Check if two rational numbers are the same
     *
     * Ex: new Fraction(19.6).equals([98, 5]);
     **/ "compare": function(a, b) {
            parse(a, b);
            var t = this["s"] * this["n"] * P["d"] - P["s"] * P["n"] * this["d"];
            return (0 < t) - (t < 0);
        },
        "simplify": function(eps) {
            if (isNaN(this["n"]) || isNaN(this["d"])) return this;
            eps = eps || 0.001;
            var thisABS = this["abs"]();
            var cont = thisABS["toContinued"]();
            for(var i = 1; i < cont.length; i++){
                var s = newFraction(cont[i - 1], 1);
                for(var k = i - 2; k >= 0; k--)s = s["inverse"]()["add"](cont[k]);
                if (Math.abs(s["sub"](thisABS).valueOf()) < eps) return s["mul"](this["s"]);
            }
            return this;
        },
        /**
     * Check if two rational numbers are divisible
     *
     * Ex: new Fraction(19.6).divisible(1.5);
     */ "divisible": function(a, b) {
            parse(a, b);
            return !(!(P["n"] * this["d"]) || this["n"] * P["d"] % (P["n"] * this["d"]));
        },
        /**
     * Returns a decimal representation of the fraction
     *
     * Ex: new Fraction("100.'91823'").valueOf() => 100.91823918239183
     **/ "valueOf": function() {
            return this["s"] * this["n"] / this["d"];
        },
        /**
     * Returns a string-fraction representation of a Fraction object
     *
     * Ex: new Fraction("1.'3'").toFraction(true) => "4 1/3"
     **/ "toFraction": function(excludeWhole) {
            var whole, str = "";
            var n = this["n"];
            var d = this["d"];
            if (this["s"] < 0) str += "-";
            if (d === 1) str += n;
            else {
                if (excludeWhole && (whole = Math.floor(n / d)) > 0) {
                    str += whole;
                    str += " ";
                    n %= d;
                }
                str += n;
                str += "/";
                str += d;
            }
            return str;
        },
        /**
     * Returns a latex representation of a Fraction object
     *
     * Ex: new Fraction("1.'3'").toLatex() => "\frac{4}{3}"
     **/ "toLatex": function(excludeWhole) {
            var whole, str = "";
            var n = this["n"];
            var d = this["d"];
            if (this["s"] < 0) str += "-";
            if (d === 1) str += n;
            else {
                if (excludeWhole && (whole = Math.floor(n / d)) > 0) {
                    str += whole;
                    n %= d;
                }
                str += "\\frac{";
                str += n;
                str += "}{";
                str += d;
                str += "}";
            }
            return str;
        },
        /**
     * Returns an array of continued fraction elements
     *
     * Ex: new Fraction("7/8").toContinued() => [0,1,7]
     */ "toContinued": function() {
            var t;
            var a = this["n"];
            var b = this["d"];
            var res = [];
            if (isNaN(a) || isNaN(b)) return res;
            do {
                res.push(Math.floor(a / b));
                t = a % b;
                a = b;
                b = t;
            }while (a !== 1);
            return res;
        },
        /**
     * Creates a string representation of a fraction with all digits
     *
     * Ex: new Fraction("100.'91823'").toString() => "100.(91823)"
     **/ "toString": function(dec) {
            var N = this["n"];
            var D = this["d"];
            if (isNaN(N) || isNaN(D)) return "NaN";
            dec = dec || 15; // 15 = decimal places when no repetation
            var cycLen = cycleLen(N, D); // Cycle length
            var cycOff = cycleStart(N, D, cycLen); // Cycle start
            var str = this["s"] < 0 ? "-" : "";
            str += N / D | 0;
            N %= D;
            N *= 10;
            if (N) str += ".";
            if (cycLen) {
                for(var i = cycOff; i--;){
                    str += N / D | 0;
                    N %= D;
                    N *= 10;
                }
                str += "(";
                for(var i = cycLen; i--;){
                    str += N / D | 0;
                    N %= D;
                    N *= 10;
                }
                str += ")";
            } else for(var i = dec; N && i--;){
                str += N / D | 0;
                N %= D;
                N *= 10;
            }
            return str;
        }
    };
    Object.defineProperty($837d94196a0cfb1e$exports, "__esModule", {
        "value": true
    });
    $837d94196a0cfb1e$exports["default"] = Fraction;
    $837d94196a0cfb1e$exports = Fraction;
})($837d94196a0cfb1e$exports);



var $273c5e5221ed04ec$var$name = "Fraction";
var $273c5e5221ed04ec$var$dependencies = [];
var $273c5e5221ed04ec$export$c317f082100fca89 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($273c5e5221ed04ec$var$name, $273c5e5221ed04ec$var$dependencies, ()=>{
    /**
   * Attach type information
   */ (0, (/*@__PURE__*/$parcel$interopDefault($837d94196a0cfb1e$exports))).prototype.type = "Fraction";
    (0, (/*@__PURE__*/$parcel$interopDefault($837d94196a0cfb1e$exports))).prototype.isFraction = true;
    /**
   * Get a JSON representation of a Fraction containing type information
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "Fraction", "n": 3, "d": 8}`
   */ (0, (/*@__PURE__*/$parcel$interopDefault($837d94196a0cfb1e$exports))).prototype.toJSON = function() {
        return {
            mathjs: "Fraction",
            n: this.s * this.n,
            d: this.d
        };
    };
    /**
   * Instantiate a Fraction from a JSON object
   * @param {Object} json  a JSON object structured as:
   *                       `{"mathjs": "Fraction", "n": 3, "d": 8}`
   * @return {BigNumber}
   */ (0, (/*@__PURE__*/$parcel$interopDefault($837d94196a0cfb1e$exports))).fromJSON = function(json) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($837d94196a0cfb1e$exports)))(json);
    };
    return 0, (/*@__PURE__*/$parcel$interopDefault($837d94196a0cfb1e$exports));
}, {
    isClass: true
});


var $0938237193b54607$var$name = "Matrix";
var $0938237193b54607$var$dependencies = [];
var $0938237193b54607$export$72d485cc3ed6a97a = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($0938237193b54607$var$name, $0938237193b54607$var$dependencies, ()=>{
    /**
   * @constructor Matrix
   *
   * A Matrix is a wrapper around an Array. A matrix can hold a multi dimensional
   * array. A matrix can be constructed as:
   *
   *     let matrix = math.matrix(data)
   *
   * Matrix contains the functions to resize, get and set values, get the size,
   * clone the matrix and to convert the matrix to a vector, array, or scalar.
   * Furthermore, one can iterate over the matrix using map and forEach.
   * The internal Array of the Matrix can be accessed using the function valueOf.
   *
   * Example usage:
   *
   *     let matrix = math.matrix([[1, 2], [3, 4]])
   *     matix.size()              // [2, 2]
   *     matrix.resize([3, 2], 5)
   *     matrix.valueOf()          // [[1, 2], [3, 4], [5, 5]]
   *     matrix.subset([1,2])       // 3 (indexes are zero-based)
   *
   */ function Matrix() {
        if (!(this instanceof Matrix)) throw new SyntaxError("Constructor must be called with the new operator");
    }
    /**
   * Attach type information
   */ Matrix.prototype.type = "Matrix";
    Matrix.prototype.isMatrix = true;
    /**
   * Get the storage format used by the matrix.
   *
   * Usage:
   *     const format = matrix.storage()   // retrieve storage format
   *
   * @return {string}           The storage format.
   */ Matrix.prototype.storage = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke storage on a Matrix interface");
    };
    /**
   * Get the datatype of the data stored in the matrix.
   *
   * Usage:
   *     const format = matrix.datatype()    // retrieve matrix datatype
   *
   * @return {string}           The datatype.
   */ Matrix.prototype.datatype = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke datatype on a Matrix interface");
    };
    /**
   * Create a new Matrix With the type of the current matrix instance
   * @param {Array | Object} data
   * @param {string} [datatype]
   */ Matrix.prototype.create = function(data, datatype) {
        throw new Error("Cannot invoke create on a Matrix interface");
    };
    /**
   * Get a subset of the matrix, or replace a subset of the matrix.
   *
   * Usage:
   *     const subset = matrix.subset(index)               // retrieve subset
   *     const value = matrix.subset(index, replacement)   // replace subset
   *
   * @param {Index} index
   * @param {Array | Matrix | *} [replacement]
   * @param {*} [defaultValue=0]      Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be filled with zeros.
   */ Matrix.prototype.subset = function(index, replacement, defaultValue) {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke subset on a Matrix interface");
    };
    /**
   * Get a single element from the matrix.
   * @param {number[]} index   Zero-based index
   * @return {*} value
   */ Matrix.prototype.get = function(index) {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke get on a Matrix interface");
    };
    /**
   * Replace a single element in the matrix.
   * @param {number[]} index   Zero-based index
   * @param {*} value
   * @param {*} [defaultValue]        Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be left undefined.
   * @return {Matrix} self
   */ Matrix.prototype.set = function(index, value, defaultValue) {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke set on a Matrix interface");
    };
    /**
   * Resize the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (resize in place).
   *
   * @param {number[]} size           The new size the matrix should have.
   * @param {*} [defaultValue=0]      Default value, filled in on new entries.
   *                                  If not provided, the matrix elements will
   *                                  be filled with zeros.
   * @param {boolean} [copy]          Return a resized copy of the matrix
   *
   * @return {Matrix}                 The resized matrix
   */ Matrix.prototype.resize = function(size, defaultValue) {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke resize on a Matrix interface");
    };
    /**
   * Reshape the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (reshape in place).
   *
   * @param {number[]} size           The new size the matrix should have.
   * @param {boolean} [copy]          Return a reshaped copy of the matrix
   *
   * @return {Matrix}                 The reshaped matrix
   */ Matrix.prototype.reshape = function(size, defaultValue) {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke reshape on a Matrix interface");
    };
    /**
   * Create a clone of the matrix
   * @return {Matrix} clone
   */ Matrix.prototype.clone = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke clone on a Matrix interface");
    };
    /**
   * Retrieve the size of the matrix.
   * @returns {number[]} size
   */ Matrix.prototype.size = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke size on a Matrix interface");
    };
    /**
   * Create a new matrix with the results of the callback function executed on
   * each entry of the matrix.
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   * @param {boolean} [skipZeros] Invoke callback function for non-zero values only.
   *
   * @return {Matrix} matrix
   */ Matrix.prototype.map = function(callback, skipZeros) {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke map on a Matrix interface");
    };
    /**
   * Execute a callback function on each entry of the matrix.
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   */ Matrix.prototype.forEach = function(callback) {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke forEach on a Matrix interface");
    };
    /**
   * Iterate over the matrix elements
   * @return {Iterable<{ value, index: number[] }>}
   */ Matrix.prototype[Symbol.iterator] = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot iterate a Matrix interface");
    };
    /**
   * Create an Array with a copy of the data of the Matrix
   * @returns {Array} array
   */ Matrix.prototype.toArray = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke toArray on a Matrix interface");
    };
    /**
   * Get the primitive value of the Matrix: a multidimensional array
   * @returns {Array} array
   */ Matrix.prototype.valueOf = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke valueOf on a Matrix interface");
    };
    /**
   * Get a string representation of the matrix, with optional formatting options.
   * @param {Object | number | Function} [options]  Formatting options. See
   *                                                lib/utils/number:format for a
   *                                                description of the available
   *                                                options.
   * @returns {string} str
   */ Matrix.prototype.format = function(options) {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke format on a Matrix interface");
    };
    /**
   * Get a string representation of the matrix
   * @returns {string} str
   */ Matrix.prototype.toString = function() {
        // must be implemented by each of the Matrix implementations
        throw new Error("Cannot invoke toString on a Matrix interface");
    };
    return Matrix;
}, {
    isClass: true
});




var $df7de91489582452$var$name = "Range";
var $df7de91489582452$var$dependencies = [];
var $df7de91489582452$export$e87cc8d3f29c5e1b = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($df7de91489582452$var$name, $df7de91489582452$var$dependencies, ()=>{
    /**
   * Create a range. A range has a start, step, and end, and contains functions
   * to iterate over the range.
   *
   * A range can be constructed as:
   *
   *     const range = new Range(start, end)
   *     const range = new Range(start, end, step)
   *
   * To get the result of the range:
   *     range.forEach(function (x) {
   *         console.log(x)
   *     })
   *     range.map(function (x) {
   *         return math.sin(x)
   *     })
   *     range.toArray()
   *
   * Example usage:
   *
   *     const c = new Range(2, 6)       // 2:1:5
   *     c.toArray()                     // [2, 3, 4, 5]
   *     const d = new Range(2, -3, -1)  // 2:-1:-2
   *     d.toArray()                     // [2, 1, 0, -1, -2]
   *
   * @class Range
   * @constructor Range
   * @param {number} start  included lower bound
   * @param {number} end    excluded upper bound
   * @param {number} [step] step size, default value is 1
   */ function Range(start, end, step) {
        if (!(this instanceof Range)) throw new SyntaxError("Constructor must be called with the new operator");
        var hasStart = start !== null && start !== undefined;
        var hasEnd = end !== null && end !== undefined;
        var hasStep = step !== null && step !== undefined;
        if (hasStart) {
            if ((0, $d8097b7a6d6e36d8$export$e51d0e7e5c4a03ab)(start)) start = start.toNumber();
            else if (typeof start !== "number") throw new TypeError("Parameter start must be a number");
        }
        if (hasEnd) {
            if ((0, $d8097b7a6d6e36d8$export$e51d0e7e5c4a03ab)(end)) end = end.toNumber();
            else if (typeof end !== "number") throw new TypeError("Parameter end must be a number");
        }
        if (hasStep) {
            if ((0, $d8097b7a6d6e36d8$export$e51d0e7e5c4a03ab)(step)) step = step.toNumber();
            else if (typeof step !== "number") throw new TypeError("Parameter step must be a number");
        }
        this.start = hasStart ? parseFloat(start) : 0;
        this.end = hasEnd ? parseFloat(end) : 0;
        this.step = hasStep ? parseFloat(step) : 1;
    }
    /**
   * Attach type information
   */ Range.prototype.type = "Range";
    Range.prototype.isRange = true;
    /**
   * Parse a string into a range,
   * The string contains the start, optional step, and end, separated by a colon.
   * If the string does not contain a valid range, null is returned.
   * For example str='0:2:11'.
   * @memberof Range
   * @param {string} str
   * @return {Range | null} range
   */ Range.parse = function(str) {
        if (typeof str !== "string") return null;
        var args = str.split(":");
        var nums = args.map(function(arg) {
            return parseFloat(arg);
        });
        var invalid = nums.some(function(num) {
            return isNaN(num);
        });
        if (invalid) return null;
        switch(nums.length){
            case 2:
                return new Range(nums[0], nums[1]);
            case 3:
                return new Range(nums[0], nums[2], nums[1]);
            default:
                return null;
        }
    };
    /**
   * Create a clone of the range
   * @return {Range} clone
   */ Range.prototype.clone = function() {
        return new Range(this.start, this.end, this.step);
    };
    /**
   * Retrieve the size of the range.
   * Returns an array containing one number, the number of elements in the range.
   * @memberof Range
   * @returns {number[]} size
   */ Range.prototype.size = function() {
        var len = 0;
        var start = this.start;
        var step = this.step;
        var end = this.end;
        var diff = end - start;
        if ((0, $668e051498bf5fa0$export$c5552dfdbc7cec71)(step) === (0, $668e051498bf5fa0$export$c5552dfdbc7cec71)(diff)) len = Math.ceil(diff / step);
        else if (diff === 0) len = 0;
        if (isNaN(len)) len = 0;
        return [
            len
        ];
    };
    /**
   * Calculate the minimum value in the range
   * @memberof Range
   * @return {number | undefined} min
   */ Range.prototype.min = function() {
        var size = this.size()[0];
        if (size > 0) {
            if (this.step > 0) // positive step
            return this.start;
            else // negative step
            return this.start + (size - 1) * this.step;
        } else return undefined;
    };
    /**
   * Calculate the maximum value in the range
   * @memberof Range
   * @return {number | undefined} max
   */ Range.prototype.max = function() {
        var size = this.size()[0];
        if (size > 0) {
            if (this.step > 0) // positive step
            return this.start + (size - 1) * this.step;
            else // negative step
            return this.start;
        } else return undefined;
    };
    /**
   * Execute a callback function for each value in the range.
   * @memberof Range
   * @param {function} callback   The callback method is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Range being traversed.
   */ Range.prototype.forEach = function(callback) {
        var x = this.start;
        var step = this.step;
        var end = this.end;
        var i = 0;
        if (step > 0) while(x < end){
            callback(x, [
                i
            ], this);
            x += step;
            i++;
        }
        else if (step < 0) while(x > end){
            callback(x, [
                i
            ], this);
            x += step;
            i++;
        }
    };
    /**
   * Execute a callback function for each value in the Range, and return the
   * results as an array
   * @memberof Range
   * @param {function} callback   The callback method is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   * @returns {Array} array
   */ Range.prototype.map = function(callback) {
        var array = [];
        this.forEach(function(value, index, obj) {
            array[index[0]] = callback(value, index, obj);
        });
        return array;
    };
    /**
   * Create an Array with a copy of the Ranges data
   * @memberof Range
   * @returns {Array} array
   */ Range.prototype.toArray = function() {
        var array = [];
        this.forEach(function(value, index) {
            array[index[0]] = value;
        });
        return array;
    };
    /**
   * Get the primitive value of the Range, a one dimensional array
   * @memberof Range
   * @returns {Array} array
   */ Range.prototype.valueOf = function() {
        // TODO: implement a caching mechanism for range.valueOf()
        return this.toArray();
    };
    /**
   * Get a string representation of the range, with optional formatting options.
   * Output is formatted as 'start:step:end', for example '2:6' or '0:0.2:11'
   * @memberof Range
   * @param {Object | number | function} [options]  Formatting options. See
   *                                                lib/utils/number:format for a
   *                                                description of the available
   *                                                options.
   * @returns {string} str
   */ Range.prototype.format = function(options) {
        var str = (0, $668e051498bf5fa0$export$d9468344d3651243)(this.start, options);
        if (this.step !== 1) str += ":" + (0, $668e051498bf5fa0$export$d9468344d3651243)(this.step, options);
        str += ":" + (0, $668e051498bf5fa0$export$d9468344d3651243)(this.end, options);
        return str;
    };
    /**
   * Get a string representation of the range.
   * @memberof Range
   * @returns {string}
   */ Range.prototype.toString = function() {
        return this.format();
    };
    /**
   * Get a JSON representation of the range
   * @memberof Range
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "Range", "start": 2, "end": 4, "step": 1}`
   */ Range.prototype.toJSON = function() {
        return {
            mathjs: "Range",
            start: this.start,
            end: this.end,
            step: this.step
        };
    };
    /**
   * Instantiate a Range from a JSON object
   * @memberof Range
   * @param {Object} json A JSON object structured as:
   *                      `{"mathjs": "Range", "start": 2, "end": 4, "step": 1}`
   * @return {Range}
   */ Range.fromJSON = function(json) {
        return new Range(json.start, json.end, json.step);
    };
    return Range;
}, {
    isClass: true
});


var $a661d702bc0c915e$var$name = "ResultSet";
var $a661d702bc0c915e$var$dependencies = [];
var $a661d702bc0c915e$export$dfb3187f1c4e3bbe = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($a661d702bc0c915e$var$name, $a661d702bc0c915e$var$dependencies, ()=>{
    /**
   * A ResultSet contains a list or results
   * @class ResultSet
   * @param {Array} entries
   * @constructor ResultSet
   */ function ResultSet(entries) {
        if (!(this instanceof ResultSet)) throw new SyntaxError("Constructor must be called with the new operator");
        this.entries = entries || [];
    }
    /**
   * Attach type information
   */ ResultSet.prototype.type = "ResultSet";
    ResultSet.prototype.isResultSet = true;
    /**
   * Returns the array with results hold by this ResultSet
   * @memberof ResultSet
   * @returns {Array} entries
   */ ResultSet.prototype.valueOf = function() {
        return this.entries;
    };
    /**
   * Returns the stringified results of the ResultSet
   * @memberof ResultSet
   * @returns {string} string
   */ ResultSet.prototype.toString = function() {
        return "[" + this.entries.join(", ") + "]";
    };
    /**
   * Get a JSON representation of the ResultSet
   * @memberof ResultSet
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "ResultSet", "entries": [...]}`
   */ ResultSet.prototype.toJSON = function() {
        return {
            mathjs: "ResultSet",
            entries: this.entries
        };
    };
    /**
   * Instantiate a ResultSet from a JSON object
   * @memberof ResultSet
   * @param {Object} json  A JSON object structured as:
   *                       `{"mathjs": "ResultSet", "entries": [...]}`
   * @return {ResultSet}
   */ ResultSet.fromJSON = function(json) {
        return new ResultSet(json.entries);
    };
    return ResultSet;
}, {
    isClass: true
});








var $3f02b11f7bdb3e86$var$name = "DenseMatrix";
var $3f02b11f7bdb3e86$var$dependencies = [
    "Matrix"
];
var $3f02b11f7bdb3e86$export$1a088ca8dd364cd1 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($3f02b11f7bdb3e86$var$name, $3f02b11f7bdb3e86$var$dependencies, (_ref)=>{
    var { Matrix: Matrix } = _ref;
    /**
   * Dense Matrix implementation. A regular, dense matrix, supporting multi-dimensional matrices. This is the default matrix type.
   * @class DenseMatrix
   * @enum {{ value, index: number[] }}
   */ function DenseMatrix(data, datatype) {
        if (!(this instanceof DenseMatrix)) throw new SyntaxError("Constructor must be called with the new operator");
        if (datatype && !(0, $d8097b7a6d6e36d8$export$844ec244b1367d54)(datatype)) throw new Error("Invalid datatype: " + datatype);
        if ((0, $d8097b7a6d6e36d8$export$b22160e0a14f87b7)(data)) {
            // check data is a DenseMatrix
            if (data.type === "DenseMatrix") {
                // clone data & size
                this._data = (0, $6819694788cbfa38$export$9cd59f9826255e47)(data._data);
                this._size = (0, $6819694788cbfa38$export$9cd59f9826255e47)(data._size);
                this._datatype = datatype || data._datatype;
            } else {
                // build data from existing matrix
                this._data = data.toArray();
                this._size = data.size();
                this._datatype = datatype || data._datatype;
            }
        } else if (data && (0, $d8097b7a6d6e36d8$export$43bee75e5e14138e)(data.data) && (0, $d8097b7a6d6e36d8$export$43bee75e5e14138e)(data.size)) {
            // initialize fields from JSON representation
            this._data = data.data;
            this._size = data.size; // verify the dimensions of the array
            (0, $a14a10567870d913$export$a22775fa5e2eebd9)(this._data, this._size);
            this._datatype = datatype || data.datatype;
        } else if ((0, $d8097b7a6d6e36d8$export$43bee75e5e14138e)(data)) {
            // replace nested Matrices with Arrays
            this._data = preprocess(data); // get the dimensions of the array
            this._size = (0, $a14a10567870d913$export$51ffaee4afb683a5)(this._data); // verify the dimensions of the array, TODO: compute size while processing array
            (0, $a14a10567870d913$export$a22775fa5e2eebd9)(this._data, this._size); // data type unknown
            this._datatype = datatype;
        } else if (data) // unsupported type
        throw new TypeError("Unsupported type of data (" + (0, $d8097b7a6d6e36d8$export$f5bbd400c2f4426f)(data) + ")");
        else {
            // nothing provided
            this._data = [];
            this._size = [
                0
            ];
            this._datatype = datatype;
        }
    }
    DenseMatrix.prototype = new Matrix();
    /**
   * Create a new DenseMatrix
   */ DenseMatrix.prototype.createDenseMatrix = function(data, datatype) {
        return new DenseMatrix(data, datatype);
    };
    /**
   * Attach type information
   */ DenseMatrix.prototype.type = "DenseMatrix";
    DenseMatrix.prototype.isDenseMatrix = true;
    /**
   * Get the matrix type
   *
   * Usage:
   *    const matrixType = matrix.getDataType()  // retrieves the matrix type
   *
   * @memberOf DenseMatrix
   * @return {string}   type information; if multiple types are found from the Matrix, it will return "mixed"
   */ DenseMatrix.prototype.getDataType = function() {
        return (0, $a14a10567870d913$export$d31e00bf4359ea8b)(this._data, (0, $d8097b7a6d6e36d8$export$f5bbd400c2f4426f));
    };
    /**
   * Get the storage format used by the matrix.
   *
   * Usage:
   *     const format = matrix.storage()  // retrieve storage format
   *
   * @memberof DenseMatrix
   * @return {string}           The storage format.
   */ DenseMatrix.prototype.storage = function() {
        return "dense";
    };
    /**
   * Get the datatype of the data stored in the matrix.
   *
   * Usage:
   *     const format = matrix.datatype()   // retrieve matrix datatype
   *
   * @memberof DenseMatrix
   * @return {string}           The datatype.
   */ DenseMatrix.prototype.datatype = function() {
        return this._datatype;
    };
    /**
   * Create a new DenseMatrix
   * @memberof DenseMatrix
   * @param {Array} data
   * @param {string} [datatype]
   */ DenseMatrix.prototype.create = function(data, datatype) {
        return new DenseMatrix(data, datatype);
    };
    /**
   * Get a subset of the matrix, or replace a subset of the matrix.
   *
   * Usage:
   *     const subset = matrix.subset(index)               // retrieve subset
   *     const value = matrix.subset(index, replacement)   // replace subset
   *
   * @memberof DenseMatrix
   * @param {Index} index
   * @param {Array | Matrix | *} [replacement]
   * @param {*} [defaultValue=0]      Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be filled with zeros.
   */ DenseMatrix.prototype.subset = function(index, replacement, defaultValue) {
        switch(arguments.length){
            case 1:
                return _get(this, index);
            // intentional fall through
            case 2:
            case 3:
                return _set(this, index, replacement, defaultValue);
            default:
                throw new SyntaxError("Wrong number of arguments");
        }
    };
    /**
   * Get a single element from the matrix.
   * @memberof DenseMatrix
   * @param {number[]} index   Zero-based index
   * @return {*} value
   */ DenseMatrix.prototype.get = function(index) {
        if (!(0, $d8097b7a6d6e36d8$export$43bee75e5e14138e)(index)) throw new TypeError("Array expected");
        if (index.length !== this._size.length) throw new (0, $89c7b7a60bca4b11$export$ad1391ca020fdd96)(index.length, this._size.length);
         // check index
        for(var x = 0; x < index.length; x++)(0, $a14a10567870d913$export$3cfe3fbfec03f260)(index[x], this._size[x]);
        var data = this._data;
        for(var i = 0, ii = index.length; i < ii; i++){
            var indexI = index[i];
            (0, $a14a10567870d913$export$3cfe3fbfec03f260)(indexI, data.length);
            data = data[indexI];
        }
        return data;
    };
    /**
   * Replace a single element in the matrix.
   * @memberof DenseMatrix
   * @param {number[]} index   Zero-based index
   * @param {*} value
   * @param {*} [defaultValue]        Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be left undefined.
   * @return {DenseMatrix} self
   */ DenseMatrix.prototype.set = function(index, value, defaultValue) {
        if (!(0, $d8097b7a6d6e36d8$export$43bee75e5e14138e)(index)) throw new TypeError("Array expected");
        if (index.length < this._size.length) throw new (0, $89c7b7a60bca4b11$export$ad1391ca020fdd96)(index.length, this._size.length, "<");
        var i, ii, indexI; // enlarge matrix when needed
        var size = index.map(function(i) {
            return i + 1;
        });
        _fit(this, size, defaultValue); // traverse over the dimensions
        var data = this._data;
        for(i = 0, ii = index.length - 1; i < ii; i++){
            indexI = index[i];
            (0, $a14a10567870d913$export$3cfe3fbfec03f260)(indexI, data.length);
            data = data[indexI];
        } // set new value
        indexI = index[index.length - 1];
        (0, $a14a10567870d913$export$3cfe3fbfec03f260)(indexI, data.length);
        data[indexI] = value;
        return this;
    };
    /**
   * Get a submatrix of this matrix
   * @memberof DenseMatrix
   * @param {DenseMatrix} matrix
   * @param {Index} index   Zero-based index
   * @private
   */ function _get(matrix, index) {
        if (!(0, $d8097b7a6d6e36d8$export$ba3dc792055c2f45)(index)) throw new TypeError("Invalid index");
        var isScalar = index.isScalar();
        if (isScalar) // return a scalar
        return matrix.get(index.min());
        else {
            // validate dimensions
            var size = index.size();
            if (size.length !== matrix._size.length) throw new (0, $89c7b7a60bca4b11$export$ad1391ca020fdd96)(size.length, matrix._size.length);
             // validate if any of the ranges in the index is out of range
            var min = index.min();
            var max = index.max();
            for(var i = 0, ii = matrix._size.length; i < ii; i++){
                (0, $a14a10567870d913$export$3cfe3fbfec03f260)(min[i], matrix._size[i]);
                (0, $a14a10567870d913$export$3cfe3fbfec03f260)(max[i], matrix._size[i]);
            } // retrieve submatrix
            // TODO: more efficient when creating an empty matrix and setting _data and _size manually
            return new DenseMatrix(_getSubmatrix(matrix._data, index, size.length, 0), matrix._datatype);
        }
    }
    /**
   * Recursively get a submatrix of a multi dimensional matrix.
   * Index is not checked for correct number or length of dimensions.
   * @memberof DenseMatrix
   * @param {Array} data
   * @param {Index} index
   * @param {number} dims   Total number of dimensions
   * @param {number} dim    Current dimension
   * @return {Array} submatrix
   * @private
   */ function _getSubmatrix(data, index, dims, dim) {
        var last = dim === dims - 1;
        var range = index.dimension(dim);
        if (last) return range.map(function(i) {
            (0, $a14a10567870d913$export$3cfe3fbfec03f260)(i, data.length);
            return data[i];
        }).valueOf();
        else return range.map(function(i) {
            (0, $a14a10567870d913$export$3cfe3fbfec03f260)(i, data.length);
            var child = data[i];
            return _getSubmatrix(child, index, dims, dim + 1);
        }).valueOf();
    }
    /**
   * Replace a submatrix in this matrix
   * Indexes are zero-based.
   * @memberof DenseMatrix
   * @param {DenseMatrix} matrix
   * @param {Index} index
   * @param {DenseMatrix | Array | *} submatrix
   * @param {*} defaultValue          Default value, filled in on new entries when
   *                                  the matrix is resized.
   * @return {DenseMatrix} matrix
   * @private
   */ function _set(matrix, index, submatrix, defaultValue) {
        if (!index || index.isIndex !== true) throw new TypeError("Invalid index");
         // get index size and check whether the index contains a single value
        var iSize = index.size();
        var isScalar = index.isScalar(); // calculate the size of the submatrix, and convert it into an Array if needed
        var sSize;
        if ((0, $d8097b7a6d6e36d8$export$b22160e0a14f87b7)(submatrix)) {
            sSize = submatrix.size();
            submatrix = submatrix.valueOf();
        } else sSize = (0, $a14a10567870d913$export$51ffaee4afb683a5)(submatrix);
        if (isScalar) {
            // set a scalar
            // check whether submatrix is a scalar
            if (sSize.length !== 0) throw new TypeError("Scalar expected");
            matrix.set(index.min(), submatrix, defaultValue);
        } else {
            // set a submatrix
            // validate dimensions
            if (iSize.length < matrix._size.length) throw new (0, $89c7b7a60bca4b11$export$ad1391ca020fdd96)(iSize.length, matrix._size.length, "<");
            if (sSize.length < iSize.length) {
                // calculate number of missing outer dimensions
                var i = 0;
                var outer = 0;
                while(iSize[i] === 1 && sSize[i] === 1)i++;
                while(iSize[i] === 1){
                    outer++;
                    i++;
                } // unsqueeze both outer and inner dimensions
                submatrix = (0, $a14a10567870d913$export$5a07c5202d40a604)(submatrix, iSize.length, outer, sSize);
            } // check whether the size of the submatrix matches the index size
            if (!(0, $6819694788cbfa38$export$6cc798251952180)(iSize, sSize)) throw new (0, $89c7b7a60bca4b11$export$ad1391ca020fdd96)(iSize, sSize, ">");
             // enlarge matrix when needed
            var size = index.max().map(function(i) {
                return i + 1;
            });
            _fit(matrix, size, defaultValue); // insert the sub matrix
            var dims = iSize.length;
            var dim = 0;
            _setSubmatrix(matrix._data, index, submatrix, dims, dim);
        }
        return matrix;
    }
    /**
   * Replace a submatrix of a multi dimensional matrix.
   * @memberof DenseMatrix
   * @param {Array} data
   * @param {Index} index
   * @param {Array} submatrix
   * @param {number} dims   Total number of dimensions
   * @param {number} dim
   * @private
   */ function _setSubmatrix(data, index, submatrix, dims, dim) {
        var last = dim === dims - 1;
        var range = index.dimension(dim);
        if (last) range.forEach(function(dataIndex, subIndex) {
            (0, $a14a10567870d913$export$3cfe3fbfec03f260)(dataIndex);
            data[dataIndex] = submatrix[subIndex[0]];
        });
        else range.forEach(function(dataIndex, subIndex) {
            (0, $a14a10567870d913$export$3cfe3fbfec03f260)(dataIndex);
            _setSubmatrix(data[dataIndex], index, submatrix[subIndex[0]], dims, dim + 1);
        });
    }
    /**
   * Resize the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (resize in place).
   *
   * @memberof DenseMatrix
   * @param {number[] || Matrix} size The new size the matrix should have.
   * @param {*} [defaultValue=0]      Default value, filled in on new entries.
   *                                  If not provided, the matrix elements will
   *                                  be filled with zeros.
   * @param {boolean} [copy]          Return a resized copy of the matrix
   *
   * @return {Matrix}                 The resized matrix
   */ DenseMatrix.prototype.resize = function(size, defaultValue, copy) {
        // validate arguments
        if (!(0, $d8097b7a6d6e36d8$export$cea7aa84e978eba5)(size)) throw new TypeError("Array or Matrix expected");
         // SparseMatrix input is always 2d, flatten this into 1d if it's indeed a vector
        var sizeArray = size.valueOf().map((value)=>{
            return Array.isArray(value) && value.length === 1 ? value[0] : value;
        }); // matrix to resize
        var m = copy ? this.clone() : this; // resize matrix
        return _resize(m, sizeArray, defaultValue);
    };
    function _resize(matrix, size, defaultValue) {
        // check size
        if (size.length === 0) {
            // first value in matrix
            var v = matrix._data; // go deep
            while((0, $d8097b7a6d6e36d8$export$43bee75e5e14138e)(v))v = v[0];
            return v;
        } // resize matrix
        matrix._size = size.slice(0); // copy the array
        matrix._data = (0, $a14a10567870d913$export$4380c87abf28fdf)(matrix._data, matrix._size, defaultValue); // return matrix
        return matrix;
    }
    /**
   * Reshape the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (reshape in place).
   *
   * NOTE: This might be better suited to copy by default, instead of modifying
   *       in place. For now, it operates in place to remain consistent with
   *       resize().
   *
   * @memberof DenseMatrix
   * @param {number[]} size           The new size the matrix should have.
   * @param {boolean} [copy]          Return a reshaped copy of the matrix
   *
   * @return {Matrix}                 The reshaped matrix
   */ DenseMatrix.prototype.reshape = function(size, copy) {
        var m = copy ? this.clone() : this;
        m._data = (0, $a14a10567870d913$export$9eaad88cf88cee2b)(m._data, size);
        var currentLength = m._size.reduce((length, size)=>length * size);
        m._size = (0, $a14a10567870d913$export$d0efc868ac2c6822)(size, currentLength);
        return m;
    };
    /**
   * Enlarge the matrix when it is smaller than given size.
   * If the matrix is larger or equal sized, nothing is done.
   * @memberof DenseMatrix
   * @param {DenseMatrix} matrix           The matrix to be resized
   * @param {number[]} size
   * @param {*} defaultValue          Default value, filled in on new entries.
   * @private
   */ function _fit(matrix, size, defaultValue) {
        var newSize = matrix._size.slice(0);
        var changed = false; // add dimensions when needed
        while(newSize.length < size.length){
            newSize.push(0);
            changed = true;
        } // enlarge size when needed
        for(var i = 0, ii = size.length; i < ii; i++)if (size[i] > newSize[i]) {
            newSize[i] = size[i];
            changed = true;
        }
        if (changed) // resize only when size is changed
        _resize(matrix, newSize, defaultValue);
    }
    /**
   * Create a clone of the matrix
   * @memberof DenseMatrix
   * @return {DenseMatrix} clone
   */ DenseMatrix.prototype.clone = function() {
        var m = new DenseMatrix({
            data: (0, $6819694788cbfa38$export$9cd59f9826255e47)(this._data),
            size: (0, $6819694788cbfa38$export$9cd59f9826255e47)(this._size),
            datatype: this._datatype
        });
        return m;
    };
    /**
   * Retrieve the size of the matrix.
   * @memberof DenseMatrix
   * @returns {number[]} size
   */ DenseMatrix.prototype.size = function() {
        return this._size.slice(0); // return a clone of _size
    };
    /**
   * Create a new matrix with the results of the callback function executed on
   * each entry of the matrix.
   * @memberof DenseMatrix
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   *
   * @return {DenseMatrix} matrix
   */ DenseMatrix.prototype.map = function(callback) {
        // matrix instance
        var me = this;
        var recurse = function recurse(value, index) {
            if ((0, $d8097b7a6d6e36d8$export$43bee75e5e14138e)(value)) return value.map(function(child, i) {
                return recurse(child, index.concat(i));
            });
            else return callback(value, index, me);
        }; // determine the new datatype when the original matrix has datatype defined
        // TODO: should be done in matrix constructor instead
        var data = recurse(this._data, []);
        var datatype = this._datatype !== undefined ? (0, $a14a10567870d913$export$d31e00bf4359ea8b)(data, (0, $d8097b7a6d6e36d8$export$f5bbd400c2f4426f)) : undefined;
        return new DenseMatrix(data, datatype);
    };
    /**
   * Execute a callback function on each entry of the matrix.
   * @memberof DenseMatrix
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   */ DenseMatrix.prototype.forEach = function(callback) {
        // matrix instance
        var me = this;
        var recurse = function recurse(value, index) {
            if ((0, $d8097b7a6d6e36d8$export$43bee75e5e14138e)(value)) value.forEach(function(child, i) {
                recurse(child, index.concat(i));
            });
            else callback(value, index, me);
        };
        recurse(this._data, []);
    };
    /**
   * Iterate over the matrix elements
   * @return {Iterable<{ value, index: number[] }>}
   */ DenseMatrix.prototype[Symbol.iterator] = function*() {
        var recurse = function* recurse(value, index) {
            if ((0, $d8097b7a6d6e36d8$export$43bee75e5e14138e)(value)) for(var i = 0; i < value.length; i++)yield* recurse(value[i], index.concat(i));
            else yield {
                value: value,
                index: index
            };
        };
        yield* recurse(this._data, []);
    };
    /**
   * Returns an array containing the rows of a 2D matrix
   * @returns {Array<Matrix>}
   */ DenseMatrix.prototype.rows = function() {
        var result = [];
        var s = this.size();
        if (s.length !== 2) throw new TypeError("Rows can only be returned for a 2D matrix.");
        var data = this._data;
        for (var row of data)result.push(new DenseMatrix([
            row
        ], this._datatype));
        return result;
    };
    /**
   * Returns an array containing the columns of a 2D matrix
   * @returns {Array<Matrix>}
   */ DenseMatrix.prototype.columns = function() {
        var _this = this;
        var result = [];
        var s = this.size();
        if (s.length !== 2) throw new TypeError("Rows can only be returned for a 2D matrix.");
        var data = this._data;
        var _loop = function _loop(i) {
            var col = data.map((row)=>[
                    row[i]
                ]);
            result.push(new DenseMatrix(col, _this._datatype));
        };
        for(var i = 0; i < s[1]; i++)_loop(i);
        return result;
    };
    /**
   * Create an Array with a copy of the data of the DenseMatrix
   * @memberof DenseMatrix
   * @returns {Array} array
   */ DenseMatrix.prototype.toArray = function() {
        return (0, $6819694788cbfa38$export$9cd59f9826255e47)(this._data);
    };
    /**
   * Get the primitive value of the DenseMatrix: a multidimensional array
   * @memberof DenseMatrix
   * @returns {Array} array
   */ DenseMatrix.prototype.valueOf = function() {
        return this._data;
    };
    /**
   * Get a string representation of the matrix, with optional formatting options.
   * @memberof DenseMatrix
   * @param {Object | number | Function} [options]  Formatting options. See
   *                                                lib/utils/number:format for a
   *                                                description of the available
   *                                                options.
   * @returns {string} str
   */ DenseMatrix.prototype.format = function(options) {
        return (0, $b94963e97c376b6d$export$d9468344d3651243)(this._data, options);
    };
    /**
   * Get a string representation of the matrix
   * @memberof DenseMatrix
   * @returns {string} str
   */ DenseMatrix.prototype.toString = function() {
        return (0, $b94963e97c376b6d$export$d9468344d3651243)(this._data);
    };
    /**
   * Get a JSON representation of the matrix
   * @memberof DenseMatrix
   * @returns {Object}
   */ DenseMatrix.prototype.toJSON = function() {
        return {
            mathjs: "DenseMatrix",
            data: this._data,
            size: this._size,
            datatype: this._datatype
        };
    };
    /**
   * Get the kth Matrix diagonal.
   *
   * @memberof DenseMatrix
   * @param {number | BigNumber} [k=0]     The kth diagonal where the vector will retrieved.
   *
   * @returns {Matrix}                     The matrix with the diagonal values.
   */ DenseMatrix.prototype.diagonal = function(k) {
        // validate k if any
        if (k) {
            // convert BigNumber to a number
            if ((0, $d8097b7a6d6e36d8$export$e51d0e7e5c4a03ab)(k)) k = k.toNumber();
             // is must be an integer
            if (!(0, $d8097b7a6d6e36d8$export$7e4aa119212bc614)(k) || !(0, $668e051498bf5fa0$export$a287f47fed4544b8)(k)) throw new TypeError("The parameter k must be an integer number");
        } else // default value
        k = 0;
        var kSuper = k > 0 ? k : 0;
        var kSub = k < 0 ? -k : 0; // rows & columns
        var rows = this._size[0];
        var columns = this._size[1]; // number diagonal values
        var n = Math.min(rows - kSub, columns - kSuper); // x is a matrix get diagonal from matrix
        var data = []; // loop rows
        for(var i = 0; i < n; i++)data[i] = this._data[i + kSub][i + kSuper];
         // create DenseMatrix
        return new DenseMatrix({
            data: data,
            size: [
                n
            ],
            datatype: this._datatype
        });
    };
    /**
   * Create a diagonal matrix.
   *
   * @memberof DenseMatrix
   * @param {Array} size                     The matrix size.
   * @param {number | Matrix | Array } value The values for the diagonal.
   * @param {number | BigNumber} [k=0]       The kth diagonal where the vector will be filled in.
   * @param {number} [defaultValue]          The default value for non-diagonal
   * @param {string} [datatype]              The datatype for the diagonal
   *
   * @returns {DenseMatrix}
   */ DenseMatrix.diagonal = function(size, value, k, defaultValue) {
        if (!(0, $d8097b7a6d6e36d8$export$43bee75e5e14138e)(size)) throw new TypeError("Array expected, size parameter");
        if (size.length !== 2) throw new Error("Only two dimensions matrix are supported");
         // map size & validate
        size = size.map(function(s) {
            // check it is a big number
            if ((0, $d8097b7a6d6e36d8$export$e51d0e7e5c4a03ab)(s)) // convert it
            s = s.toNumber();
             // validate arguments
            if (!(0, $d8097b7a6d6e36d8$export$7e4aa119212bc614)(s) || !(0, $668e051498bf5fa0$export$a287f47fed4544b8)(s) || s < 1) throw new Error("Size values must be positive integers");
            return s;
        }); // validate k if any
        if (k) {
            // convert BigNumber to a number
            if ((0, $d8097b7a6d6e36d8$export$e51d0e7e5c4a03ab)(k)) k = k.toNumber();
             // is must be an integer
            if (!(0, $d8097b7a6d6e36d8$export$7e4aa119212bc614)(k) || !(0, $668e051498bf5fa0$export$a287f47fed4544b8)(k)) throw new TypeError("The parameter k must be an integer number");
        } else // default value
        k = 0;
        var kSuper = k > 0 ? k : 0;
        var kSub = k < 0 ? -k : 0; // rows and columns
        var rows = size[0];
        var columns = size[1]; // number of non-zero items
        var n = Math.min(rows - kSub, columns - kSuper); // value extraction function
        var _value; // check value
        if ((0, $d8097b7a6d6e36d8$export$43bee75e5e14138e)(value)) {
            // validate array
            if (value.length !== n) // number of values in array must be n
            throw new Error("Invalid value array length");
             // define function
            _value = function _value(i) {
                // return value @ i
                return value[i];
            };
        } else if ((0, $d8097b7a6d6e36d8$export$b22160e0a14f87b7)(value)) {
            // matrix size
            var ms = value.size(); // validate matrix
            if (ms.length !== 1 || ms[0] !== n) // number of values in array must be n
            throw new Error("Invalid matrix length");
             // define function
            _value = function _value(i) {
                // return value @ i
                return value.get([
                    i
                ]);
            };
        } else // define function
        _value = function _value() {
            // return value
            return value;
        };
         // discover default value if needed
        if (!defaultValue) // check first value in array
        defaultValue = (0, $d8097b7a6d6e36d8$export$e51d0e7e5c4a03ab)(_value(0)) ? _value(0).mul(0) // trick to create a BigNumber with value zero
         : 0;
         // empty array
        var data = []; // check we need to resize array
        if (size.length > 0) {
            // resize array
            data = (0, $a14a10567870d913$export$4380c87abf28fdf)(data, size, defaultValue); // fill diagonal
            for(var d = 0; d < n; d++)data[d + kSub][d + kSuper] = _value(d);
        } // create DenseMatrix
        return new DenseMatrix({
            data: data,
            size: [
                rows,
                columns
            ]
        });
    };
    /**
   * Generate a matrix from a JSON object
   * @memberof DenseMatrix
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "DenseMatrix", data: [], size: []}`,
   *                       where mathjs is optional
   * @returns {DenseMatrix}
   */ DenseMatrix.fromJSON = function(json) {
        return new DenseMatrix(json);
    };
    /**
   * Swap rows i and j in Matrix.
   *
   * @memberof DenseMatrix
   * @param {number} i       Matrix row index 1
   * @param {number} j       Matrix row index 2
   *
   * @return {Matrix}        The matrix reference
   */ DenseMatrix.prototype.swapRows = function(i, j) {
        // check index
        if (!(0, $d8097b7a6d6e36d8$export$7e4aa119212bc614)(i) || !(0, $668e051498bf5fa0$export$a287f47fed4544b8)(i) || !(0, $d8097b7a6d6e36d8$export$7e4aa119212bc614)(j) || !(0, $668e051498bf5fa0$export$a287f47fed4544b8)(j)) throw new Error("Row index must be positive integers");
         // check dimensions
        if (this._size.length !== 2) throw new Error("Only two dimensional matrix is supported");
         // validate index
        (0, $a14a10567870d913$export$3cfe3fbfec03f260)(i, this._size[0]);
        (0, $a14a10567870d913$export$3cfe3fbfec03f260)(j, this._size[0]); // swap rows
        DenseMatrix._swapRows(i, j, this._data); // return current instance
        return this;
    };
    /**
   * Swap rows i and j in Dense Matrix data structure.
   *
   * @param {number} i       Matrix row index 1
   * @param {number} j       Matrix row index 2
   * @param {Array} data     Matrix data
   */ DenseMatrix._swapRows = function(i, j, data) {
        // swap values i <-> j
        var vi = data[i];
        data[i] = data[j];
        data[j] = vi;
    };
    /**
   * Preprocess data, which can be an Array or DenseMatrix with nested Arrays and
   * Matrices. Replaces all nested Matrices with Arrays
   * @memberof DenseMatrix
   * @param {Array} data
   * @return {Array} data
   */ function preprocess(data) {
        for(var i = 0, ii = data.length; i < ii; i++){
            var elem = data[i];
            if ((0, $d8097b7a6d6e36d8$export$43bee75e5e14138e)(elem)) data[i] = preprocess(elem);
            else if (elem && elem.isMatrix === true) data[i] = preprocess(elem.valueOf());
        }
        return data;
    }
    return DenseMatrix;
}, {
    isClass: true
});


var $c5e99c589ef7988d$var$name = "replacer";
var $c5e99c589ef7988d$var$dependencies = [];
var $c5e99c589ef7988d$export$481a522c866104eb = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($c5e99c589ef7988d$var$name, $c5e99c589ef7988d$var$dependencies, ()=>{
    /**
   * Stringify data types into their JSON representation.
   * Most data types can be serialized using their `.toJSON` method,
   * but not all, for example the number `Infinity`. For these cases you have
   * to use the replacer. Example usage:
   *
   *     JSON.stringify([2, Infinity], math.replacer)
   *
   * @param {string} key
   * @param {*} value
   * @returns {*} Returns the replaced object
   */ return function replacer(key, value) {
        // the numeric values Infinitiy, -Infinity, and NaN cannot be serialized to JSON
        if (typeof value === "number" && (!isFinite(value) || isNaN(value))) return {
            mathjs: "number",
            value: String(value)
        };
        return value;
    };
});

/**
 * Create a typed-function which checks the types of the arguments and
 * can match them against multiple provided signatures. The typed-function
 * automatically converts inputs in order to find a matching signature.
 * Typed functions throw informative errors in case of wrong input arguments.
 *
 * See the library [typed-function](https://github.com/josdejong/typed-function)
 * for detailed documentation.
 *
 * Syntax:
 *
 *     math.typed(name, signatures) : function
 *     math.typed(signatures) : function
 *
 * Examples:
 *
 *     // create a typed function with multiple types per argument (type union)
 *     const fn2 = typed({
 *       'number | boolean': function (b) {
 *         return 'b is a number or boolean'
 *       },
 *       'string, number | boolean': function (a, b) {
 *         return 'a is a string, b is a number or boolean'
 *       }
 *     })
 *
 *     // create a typed function with an any type argument
 *     const log = typed({
 *       'string, any': function (event, data) {
 *         console.log('event: ' + event + ', data: ' + JSON.stringify(data))
 *       }
 *     })
 *
 * @param {string} [name]                          Optional name for the typed-function
 * @param {Object<string, function>} signatures   Object with one or multiple function signatures
 * @returns {function} The created typed-function.
 */ 
var $2a2be6c42d18dd82$exports = {};
/**
 * typed-function
 *
 * Type checking for JavaScript functions
 *
 * https://github.com/josdejong/typed-function
 */ "use strict";
(function(root, factory) {
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([], factory);
    else // OldNode. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like OldNode.
    $2a2be6c42d18dd82$exports = factory();
})($2a2be6c42d18dd82$exports, function() {
    function ok() {
        return true;
    }
    function notOk() {
        return false;
    }
    function undef() {
        return undefined;
    }
    /**
   * @typedef {{
   *   params: Param[],
   *   fn: function
   * }} Signature
   *
   * @typedef {{
   *   types: Type[],
   *   restParam: boolean
   * }} Param
   *
   * @typedef {{
   *   name: string,
   *   typeIndex: number,
   *   test: function,
   *   conversion?: ConversionDef,
   *   conversionIndex: number,
   * }} Type
   *
   * @typedef {{
   *   from: string,
   *   to: string,
   *   convert: function (*) : *
   * }} ConversionDef
   *
   * @typedef {{
   *   name: string,
   *   test: function(*) : boolean
   * }} TypeDef
   */ // create a new instance of typed-function
    function create() {
        // data type tests
        var _types = [
            {
                name: "number",
                test: function(x) {
                    return typeof x === "number";
                }
            },
            {
                name: "string",
                test: function(x) {
                    return typeof x === "string";
                }
            },
            {
                name: "boolean",
                test: function(x) {
                    return typeof x === "boolean";
                }
            },
            {
                name: "Function",
                test: function(x) {
                    return typeof x === "function";
                }
            },
            {
                name: "Array",
                test: Array.isArray
            },
            {
                name: "Date",
                test: function(x) {
                    return x instanceof Date;
                }
            },
            {
                name: "RegExp",
                test: function(x) {
                    return x instanceof RegExp;
                }
            },
            {
                name: "Object",
                test: function(x) {
                    return typeof x === "object" && x !== null && x.constructor === Object;
                }
            },
            {
                name: "null",
                test: function(x) {
                    return x === null;
                }
            },
            {
                name: "undefined",
                test: function(x) {
                    return x === undefined;
                }
            }
        ];
        var anyType = {
            name: "any",
            test: ok
        };
        // types which need to be ignored
        var _ignore = [];
        // type conversions
        var _conversions = [];
        // This is a temporary object, will be replaced with a typed function at the end
        var typed = {
            types: _types,
            conversions: _conversions,
            ignore: _ignore
        };
        /**
     * Find the test function for a type
     * @param {String} typeName
     * @return {TypeDef} Returns the type definition when found,
     *                    Throws a TypeError otherwise
     */ function findTypeByName(typeName) {
            var entry = findInArray(typed.types, function(entry) {
                return entry.name === typeName;
            });
            if (entry) return entry;
            if (typeName === "any") return anyType;
            var hint = findInArray(typed.types, function(entry) {
                return entry.name.toLowerCase() === typeName.toLowerCase();
            });
            throw new TypeError('Unknown type "' + typeName + '"' + (hint ? '. Did you mean "' + hint.name + '"?' : ""));
        }
        /**
     * Find the index of a type definition. Handles special case 'any'
     * @param {TypeDef} type
     * @return {number}
     */ function findTypeIndex(type) {
            if (type === anyType) return 999;
            return typed.types.indexOf(type);
        }
        /**
     * Find a type that matches a value.
     * @param {*} value
     * @return {string} Returns the name of the first type for which
     *                  the type test matches the value.
     */ function findTypeName(value) {
            var entry = findInArray(typed.types, function(entry) {
                return entry.test(value);
            });
            if (entry) return entry.name;
            throw new TypeError("Value has unknown type. Value: " + value);
        }
        /**
     * Find a specific signature from a (composed) typed function, for example:
     *
     *   typed.find(fn, ['number', 'string'])
     *   typed.find(fn, 'number, string')
     *
     * Function find only only works for exact matches.
     *
     * @param {Function} fn                   A typed-function
     * @param {string | string[]} signature   Signature to be found, can be
     *                                        an array or a comma separated string.
     * @return {Function}                     Returns the matching signature, or
     *                                        throws an error when no signature
     *                                        is found.
     */ function find(fn, signature) {
            if (!fn.signatures) throw new TypeError("Function is no typed-function");
            // normalize input
            var arr;
            if (typeof signature === "string") {
                arr = signature.split(",");
                for(var i = 0; i < arr.length; i++)arr[i] = arr[i].trim();
            } else if (Array.isArray(signature)) arr = signature;
            else throw new TypeError("String array or a comma separated string expected");
            var str = arr.join(",");
            // find an exact match
            var match = fn.signatures[str];
            if (match) return match;
            // TODO: extend find to match non-exact signatures
            throw new TypeError("Signature not found (signature: " + (fn.name || "unnamed") + "(" + arr.join(", ") + "))");
        }
        /**
     * Convert a given value to another data type.
     * @param {*} value
     * @param {string} type
     */ function convert(value, type) {
            var from = findTypeName(value);
            // check conversion is needed
            if (type === from) return value;
            for(var i = 0; i < typed.conversions.length; i++){
                var conversion = typed.conversions[i];
                if (conversion.from === from && conversion.to === type) return conversion.convert(value);
            }
            throw new Error("Cannot convert from " + from + " to " + type);
        }
        /**
     * Stringify parameters in a normalized way
     * @param {Param[]} params
     * @return {string}
     */ function stringifyParams(params) {
            return params.map(function(param) {
                var typeNames = param.types.map(getTypeName);
                return (param.restParam ? "..." : "") + typeNames.join("|");
            }).join(",");
        }
        /**
     * Parse a parameter, like "...number | boolean"
     * @param {string} param
     * @param {ConversionDef[]} conversions
     * @return {Param} param
     */ function parseParam(param, conversions) {
            var restParam = param.indexOf("...") === 0;
            var types = !restParam ? param : param.length > 3 ? param.slice(3) : "any";
            var typeNames = types.split("|").map(trim).filter(notEmpty).filter(notIgnore);
            var matchingConversions = filterConversions(conversions, typeNames);
            var exactTypes = typeNames.map(function(typeName) {
                var type = findTypeByName(typeName);
                return {
                    name: typeName,
                    typeIndex: findTypeIndex(type),
                    test: type.test,
                    conversion: null,
                    conversionIndex: -1
                };
            });
            var convertibleTypes = matchingConversions.map(function(conversion) {
                var type = findTypeByName(conversion.from);
                return {
                    name: conversion.from,
                    typeIndex: findTypeIndex(type),
                    test: type.test,
                    conversion: conversion,
                    conversionIndex: conversions.indexOf(conversion)
                };
            });
            return {
                types: exactTypes.concat(convertibleTypes),
                restParam: restParam
            };
        }
        /**
     * Parse a signature with comma separated parameters,
     * like "number | boolean, ...string"
     * @param {string} signature
     * @param {function} fn
     * @param {ConversionDef[]} conversions
     * @return {Signature | null} signature
     */ function parseSignature(signature, fn, conversions) {
            var params = [];
            if (signature.trim() !== "") params = signature.split(",").map(trim).map(function(param, index, array) {
                var parsedParam = parseParam(param, conversions);
                if (parsedParam.restParam && index !== array.length - 1) throw new SyntaxError('Unexpected rest parameter "' + param + '": ' + "only allowed for the last parameter");
                return parsedParam;
            });
            if (params.some(isInvalidParam)) // invalid signature: at least one parameter has no types
            // (they may have been filtered)
            return null;
            return {
                params: params,
                fn: fn
            };
        }
        /**
     * Test whether a set of params contains a restParam
     * @param {Param[]} params
     * @return {boolean} Returns true when the last parameter is a restParam
     */ function hasRestParam(params) {
            var param = last(params);
            return param ? param.restParam : false;
        }
        /**
     * Test whether a parameter contains conversions
     * @param {Param} param
     * @return {boolean} Returns true when at least one of the parameters
     *                   contains a conversion.
     */ function hasConversions(param) {
            return param.types.some(function(type) {
                return type.conversion != null;
            });
        }
        /**
     * Create a type test for a single parameter, which can have one or multiple
     * types.
     * @param {Param} param
     * @return {function(x: *) : boolean} Returns a test function
     */ function compileTest(param) {
            if (!param || param.types.length === 0) // nothing to do
            return ok;
            else if (param.types.length === 1) return findTypeByName(param.types[0].name).test;
            else if (param.types.length === 2) {
                var test0 = findTypeByName(param.types[0].name).test;
                var test1 = findTypeByName(param.types[1].name).test;
                return function or(x) {
                    return test0(x) || test1(x);
                };
            } else {
                var tests = param.types.map(function(type) {
                    return findTypeByName(type.name).test;
                });
                return function or(x) {
                    for(var i = 0; i < tests.length; i++){
                        if (tests[i](x)) return true;
                    }
                    return false;
                };
            }
        }
        /**
     * Create a test for all parameters of a signature
     * @param {Param[]} params
     * @return {function(args: Array<*>) : boolean}
     */ function compileTests(params) {
            var tests, test0, test1;
            if (hasRestParam(params)) {
                // variable arguments like '...number'
                tests = initial(params).map(compileTest);
                var varIndex = tests.length;
                var lastTest = compileTest(last(params));
                var testRestParam = function(args) {
                    for(var i = varIndex; i < args.length; i++){
                        if (!lastTest(args[i])) return false;
                    }
                    return true;
                };
                return function testArgs(args) {
                    for(var i = 0; i < tests.length; i++){
                        if (!tests[i](args[i])) return false;
                    }
                    return testRestParam(args) && args.length >= varIndex + 1;
                };
            } else {
                // no variable arguments
                if (params.length === 0) return function testArgs(args) {
                    return args.length === 0;
                };
                else if (params.length === 1) {
                    test0 = compileTest(params[0]);
                    return function testArgs(args) {
                        return test0(args[0]) && args.length === 1;
                    };
                } else if (params.length === 2) {
                    test0 = compileTest(params[0]);
                    test1 = compileTest(params[1]);
                    return function testArgs(args) {
                        return test0(args[0]) && test1(args[1]) && args.length === 2;
                    };
                } else {
                    tests = params.map(compileTest);
                    return function testArgs(args) {
                        for(var i = 0; i < tests.length; i++){
                            if (!tests[i](args[i])) return false;
                        }
                        return args.length === tests.length;
                    };
                }
            }
        }
        /**
     * Find the parameter at a specific index of a signature.
     * Handles rest parameters.
     * @param {Signature} signature
     * @param {number} index
     * @return {Param | null} Returns the matching parameter when found,
     *                        null otherwise.
     */ function getParamAtIndex(signature, index) {
            return index < signature.params.length ? signature.params[index] : hasRestParam(signature.params) ? last(signature.params) : null;
        }
        /**
     * Get all type names of a parameter
     * @param {Signature} signature
     * @param {number} index
     * @param {boolean} excludeConversions
     * @return {string[]} Returns an array with type names
     */ function getExpectedTypeNames(signature, index, excludeConversions) {
            var param = getParamAtIndex(signature, index);
            var types = param ? excludeConversions ? param.types.filter(isExactType) : param.types : [];
            return types.map(getTypeName);
        }
        /**
     * Returns the name of a type
     * @param {Type} type
     * @return {string} Returns the type name
     */ function getTypeName(type) {
            return type.name;
        }
        /**
     * Test whether a type is an exact type or conversion
     * @param {Type} type
     * @return {boolean} Returns true when
     */ function isExactType(type) {
            return type.conversion === null || type.conversion === undefined;
        }
        /**
     * Helper function for creating error messages: create an array with
     * all available types on a specific argument index.
     * @param {Signature[]} signatures
     * @param {number} index
     * @return {string[]} Returns an array with available types
     */ function mergeExpectedParams(signatures, index) {
            var typeNames = uniq(flatMap(signatures, function(signature) {
                return getExpectedTypeNames(signature, index, false);
            }));
            return typeNames.indexOf("any") !== -1 ? [
                "any"
            ] : typeNames;
        }
        /**
     * Create
     * @param {string} name             The name of the function
     * @param {array.<*>} args          The actual arguments passed to the function
     * @param {Signature[]} signatures  A list with available signatures
     * @return {TypeError} Returns a type error with additional data
     *                     attached to it in the property `data`
     */ function createError(name, args, signatures) {
            var err, expected;
            var _name = name || "unnamed";
            // test for wrong type at some index
            var matchingSignatures = signatures;
            var index;
            for(index = 0; index < args.length; index++){
                var nextMatchingDefs = matchingSignatures.filter(function(signature) {
                    var test = compileTest(getParamAtIndex(signature, index));
                    return (index < signature.params.length || hasRestParam(signature.params)) && test(args[index]);
                });
                if (nextMatchingDefs.length === 0) {
                    // no matching signatures anymore, throw error "wrong type"
                    expected = mergeExpectedParams(matchingSignatures, index);
                    if (expected.length > 0) {
                        var actualType = findTypeName(args[index]);
                        err = new TypeError("Unexpected type of argument in function " + _name + " (expected: " + expected.join(" or ") + ", actual: " + actualType + ", index: " + index + ")");
                        err.data = {
                            category: "wrongType",
                            fn: _name,
                            index: index,
                            actual: actualType,
                            expected: expected
                        };
                        return err;
                    }
                } else matchingSignatures = nextMatchingDefs;
            }
            // test for too few arguments
            var lengths = matchingSignatures.map(function(signature) {
                return hasRestParam(signature.params) ? Infinity : signature.params.length;
            });
            if (args.length < Math.min.apply(null, lengths)) {
                expected = mergeExpectedParams(matchingSignatures, index);
                err = new TypeError("Too few arguments in function " + _name + " (expected: " + expected.join(" or ") + ", index: " + args.length + ")");
                err.data = {
                    category: "tooFewArgs",
                    fn: _name,
                    index: args.length,
                    expected: expected
                };
                return err;
            }
            // test for too many arguments
            var maxLength = Math.max.apply(null, lengths);
            if (args.length > maxLength) {
                err = new TypeError("Too many arguments in function " + _name + " (expected: " + maxLength + ", actual: " + args.length + ")");
                err.data = {
                    category: "tooManyArgs",
                    fn: _name,
                    index: args.length,
                    expectedLength: maxLength
                };
                return err;
            }
            err = new TypeError('Arguments of type "' + args.join(", ") + '" do not match any of the defined signatures of function ' + _name + ".");
            err.data = {
                category: "mismatch",
                actual: args.map(findTypeName)
            };
            return err;
        }
        /**
     * Find the lowest index of all exact types of a parameter (no conversions)
     * @param {Param} param
     * @return {number} Returns the index of the lowest type in typed.types
     */ function getLowestTypeIndex(param) {
            var min = 999;
            for(var i = 0; i < param.types.length; i++)if (isExactType(param.types[i])) min = Math.min(min, param.types[i].typeIndex);
            return min;
        }
        /**
     * Find the lowest index of the conversion of all types of the parameter
     * having a conversion
     * @param {Param} param
     * @return {number} Returns the lowest index of the conversions of this type
     */ function getLowestConversionIndex(param) {
            var min = 999;
            for(var i = 0; i < param.types.length; i++)if (!isExactType(param.types[i])) min = Math.min(min, param.types[i].conversionIndex);
            return min;
        }
        /**
     * Compare two params
     * @param {Param} param1
     * @param {Param} param2
     * @return {number} returns a negative number when param1 must get a lower
     *                  index than param2, a positive number when the opposite,
     *                  or zero when both are equal
     */ function compareParams(param1, param2) {
            var c;
            // compare having a rest parameter or not
            c = param1.restParam - param2.restParam;
            if (c !== 0) return c;
            // compare having conversions or not
            c = hasConversions(param1) - hasConversions(param2);
            if (c !== 0) return c;
            // compare the index of the types
            c = getLowestTypeIndex(param1) - getLowestTypeIndex(param2);
            if (c !== 0) return c;
            // compare the index of any conversion
            return getLowestConversionIndex(param1) - getLowestConversionIndex(param2);
        }
        /**
     * Compare two signatures
     * @param {Signature} signature1
     * @param {Signature} signature2
     * @return {number} returns a negative number when param1 must get a lower
     *                  index than param2, a positive number when the opposite,
     *                  or zero when both are equal
     */ function compareSignatures(signature1, signature2) {
            var len = Math.min(signature1.params.length, signature2.params.length);
            var i;
            var c;
            // compare whether the params have conversions at all or not
            c = signature1.params.some(hasConversions) - signature2.params.some(hasConversions);
            if (c !== 0) return c;
            // next compare whether the params have conversions one by one
            for(i = 0; i < len; i++){
                c = hasConversions(signature1.params[i]) - hasConversions(signature2.params[i]);
                if (c !== 0) return c;
            }
            // compare the types of the params one by one
            for(i = 0; i < len; i++){
                c = compareParams(signature1.params[i], signature2.params[i]);
                if (c !== 0) return c;
            }
            // compare the number of params
            return signature1.params.length - signature2.params.length;
        }
        /**
     * Get params containing all types that can be converted to the defined types.
     *
     * @param {ConversionDef[]} conversions
     * @param {string[]} typeNames
     * @return {ConversionDef[]} Returns the conversions that are available
     *                        for every type (if any)
     */ function filterConversions(conversions, typeNames) {
            var matches = {};
            conversions.forEach(function(conversion) {
                if (typeNames.indexOf(conversion.from) === -1 && typeNames.indexOf(conversion.to) !== -1 && !matches[conversion.from]) matches[conversion.from] = conversion;
            });
            return Object.keys(matches).map(function(from) {
                return matches[from];
            });
        }
        /**
     * Preprocess arguments before calling the original function:
     * - if needed convert the parameters
     * - in case of rest parameters, move the rest parameters into an Array
     * @param {Param[]} params
     * @param {function} fn
     * @return {function} Returns a wrapped function
     */ function compileArgsPreprocessing(params, fn) {
            var fnConvert = fn;
            // TODO: can we make this wrapper function smarter/simpler?
            if (params.some(hasConversions)) {
                var restParam = hasRestParam(params);
                var compiledConversions = params.map(compileArgConversion);
                fnConvert = function convertArgs() {
                    var args = [];
                    var last = restParam ? arguments.length - 1 : arguments.length;
                    for(var i = 0; i < last; i++)args[i] = compiledConversions[i](arguments[i]);
                    if (restParam) args[last] = arguments[last].map(compiledConversions[last]);
                    return fn.apply(this, args);
                };
            }
            var fnPreprocess = fnConvert;
            if (hasRestParam(params)) {
                var offset = params.length - 1;
                fnPreprocess = function preprocessRestParams() {
                    return fnConvert.apply(this, slice(arguments, 0, offset).concat([
                        slice(arguments, offset)
                    ]));
                };
            }
            return fnPreprocess;
        }
        /**
     * Compile conversion for a parameter to the right type
     * @param {Param} param
     * @return {function} Returns the wrapped function that will convert arguments
     *
     */ function compileArgConversion(param) {
            var test0, test1, conversion0, conversion1;
            var tests = [];
            var conversions = [];
            param.types.forEach(function(type) {
                if (type.conversion) {
                    tests.push(findTypeByName(type.conversion.from).test);
                    conversions.push(type.conversion.convert);
                }
            });
            // create optimized conversion functions depending on the number of conversions
            switch(conversions.length){
                case 0:
                    return function convertArg(arg) {
                        return arg;
                    };
                case 1:
                    test0 = tests[0];
                    conversion0 = conversions[0];
                    return function convertArg(arg) {
                        if (test0(arg)) return conversion0(arg);
                        return arg;
                    };
                case 2:
                    test0 = tests[0];
                    test1 = tests[1];
                    conversion0 = conversions[0];
                    conversion1 = conversions[1];
                    return function convertArg(arg) {
                        if (test0(arg)) return conversion0(arg);
                        if (test1(arg)) return conversion1(arg);
                        return arg;
                    };
                default:
                    return function convertArg(arg) {
                        for(var i = 0; i < conversions.length; i++){
                            if (tests[i](arg)) return conversions[i](arg);
                        }
                        return arg;
                    };
            }
        }
        /**
     * Convert an array with signatures into a map with signatures,
     * where signatures with union types are split into separate signatures
     *
     * Throws an error when there are conflicting types
     *
     * @param {Signature[]} signatures
     * @return {Object.<string, function>}  Returns a map with signatures
     *                                      as key and the original function
     *                                      of this signature as value.
     */ function createSignaturesMap(signatures) {
            var signaturesMap = {};
            signatures.forEach(function(signature) {
                if (!signature.params.some(hasConversions)) splitParams(signature.params, true).forEach(function(params) {
                    signaturesMap[stringifyParams(params)] = signature.fn;
                });
            });
            return signaturesMap;
        }
        /**
     * Split params with union types in to separate params.
     *
     * For example:
     *
     *     splitParams([['Array', 'Object'], ['string', 'RegExp'])
     *     // returns:
     *     // [
     *     //   ['Array', 'string'],
     *     //   ['Array', 'RegExp'],
     *     //   ['Object', 'string'],
     *     //   ['Object', 'RegExp']
     *     // ]
     *
     * @param {Param[]} params
     * @param {boolean} ignoreConversionTypes
     * @return {Param[]}
     */ function splitParams(params, ignoreConversionTypes) {
            function _splitParams(params, index, types) {
                if (index < params.length) {
                    var param = params[index];
                    var filteredTypes = ignoreConversionTypes ? param.types.filter(isExactType) : param.types;
                    var typeGroups;
                    if (param.restParam) {
                        // split the types of a rest parameter in two:
                        // one with only exact types, and one with exact types and conversions
                        var exactTypes = filteredTypes.filter(isExactType);
                        typeGroups = exactTypes.length < filteredTypes.length ? [
                            exactTypes,
                            filteredTypes
                        ] : [
                            filteredTypes
                        ];
                    } else // split all the types of a regular parameter into one type per group
                    typeGroups = filteredTypes.map(function(type) {
                        return [
                            type
                        ];
                    });
                    // recurse over the groups with types
                    return flatMap(typeGroups, function(typeGroup) {
                        return _splitParams(params, index + 1, types.concat([
                            typeGroup
                        ]));
                    });
                } else {
                    // we've reached the end of the parameters. Now build a new Param
                    var splittedParams = types.map(function(type, typeIndex) {
                        return {
                            types: type,
                            restParam: typeIndex === params.length - 1 && hasRestParam(params)
                        };
                    });
                    return [
                        splittedParams
                    ];
                }
            }
            return _splitParams(params, 0, []);
        }
        /**
     * Test whether two signatures have a conflicting signature
     * @param {Signature} signature1
     * @param {Signature} signature2
     * @return {boolean} Returns true when the signatures conflict, false otherwise.
     */ function hasConflictingParams(signature1, signature2) {
            var ii = Math.max(signature1.params.length, signature2.params.length);
            for(var i = 0; i < ii; i++){
                var typesNames1 = getExpectedTypeNames(signature1, i, true);
                var typesNames2 = getExpectedTypeNames(signature2, i, true);
                if (!hasOverlap(typesNames1, typesNames2)) return false;
            }
            var len1 = signature1.params.length;
            var len2 = signature2.params.length;
            var restParam1 = hasRestParam(signature1.params);
            var restParam2 = hasRestParam(signature2.params);
            return restParam1 ? restParam2 ? len1 === len2 : len2 >= len1 : restParam2 ? len1 >= len2 : len1 === len2;
        }
        /**
     * Create a typed function
     * @param {String} name               The name for the typed function
     * @param {Object.<string, function>} signaturesMap
     *                                    An object with one or
     *                                    multiple signatures as key, and the
     *                                    function corresponding to the
     *                                    signature as value.
     * @return {function}  Returns the created typed function.
     */ function createTypedFunction(name, signaturesMap) {
            if (Object.keys(signaturesMap).length === 0) throw new SyntaxError("No signatures provided");
            // parse the signatures, and check for conflicts
            var parsedSignatures = [];
            Object.keys(signaturesMap).map(function(signature) {
                return parseSignature(signature, signaturesMap[signature], typed.conversions);
            }).filter(notNull).forEach(function(parsedSignature) {
                // check whether this parameter conflicts with already parsed signatures
                var conflictingSignature = findInArray(parsedSignatures, function(s) {
                    return hasConflictingParams(s, parsedSignature);
                });
                if (conflictingSignature) throw new TypeError('Conflicting signatures "' + stringifyParams(conflictingSignature.params) + '" and "' + stringifyParams(parsedSignature.params) + '".');
                parsedSignatures.push(parsedSignature);
            });
            // split and filter the types of the signatures, and then order them
            var signatures = flatMap(parsedSignatures, function(parsedSignature) {
                var params = parsedSignature ? splitParams(parsedSignature.params, false) : [];
                return params.map(function(params) {
                    return {
                        params: params,
                        fn: parsedSignature.fn
                    };
                });
            }).filter(notNull);
            signatures.sort(compareSignatures);
            // we create a highly optimized checks for the first couple of signatures with max 2 arguments
            var ok0 = signatures[0] && signatures[0].params.length <= 2 && !hasRestParam(signatures[0].params);
            var ok1 = signatures[1] && signatures[1].params.length <= 2 && !hasRestParam(signatures[1].params);
            var ok2 = signatures[2] && signatures[2].params.length <= 2 && !hasRestParam(signatures[2].params);
            var ok3 = signatures[3] && signatures[3].params.length <= 2 && !hasRestParam(signatures[3].params);
            var ok4 = signatures[4] && signatures[4].params.length <= 2 && !hasRestParam(signatures[4].params);
            var ok5 = signatures[5] && signatures[5].params.length <= 2 && !hasRestParam(signatures[5].params);
            var allOk = ok0 && ok1 && ok2 && ok3 && ok4 && ok5;
            // compile the tests
            var tests = signatures.map(function(signature) {
                return compileTests(signature.params);
            });
            var test00 = ok0 ? compileTest(signatures[0].params[0]) : notOk;
            var test10 = ok1 ? compileTest(signatures[1].params[0]) : notOk;
            var test20 = ok2 ? compileTest(signatures[2].params[0]) : notOk;
            var test30 = ok3 ? compileTest(signatures[3].params[0]) : notOk;
            var test40 = ok4 ? compileTest(signatures[4].params[0]) : notOk;
            var test50 = ok5 ? compileTest(signatures[5].params[0]) : notOk;
            var test01 = ok0 ? compileTest(signatures[0].params[1]) : notOk;
            var test11 = ok1 ? compileTest(signatures[1].params[1]) : notOk;
            var test21 = ok2 ? compileTest(signatures[2].params[1]) : notOk;
            var test31 = ok3 ? compileTest(signatures[3].params[1]) : notOk;
            var test41 = ok4 ? compileTest(signatures[4].params[1]) : notOk;
            var test51 = ok5 ? compileTest(signatures[5].params[1]) : notOk;
            // compile the functions
            var fns = signatures.map(function(signature) {
                return compileArgsPreprocessing(signature.params, signature.fn);
            });
            var fn0 = ok0 ? fns[0] : undef;
            var fn1 = ok1 ? fns[1] : undef;
            var fn2 = ok2 ? fns[2] : undef;
            var fn3 = ok3 ? fns[3] : undef;
            var fn4 = ok4 ? fns[4] : undef;
            var fn5 = ok5 ? fns[5] : undef;
            var len0 = ok0 ? signatures[0].params.length : -1;
            var len1 = ok1 ? signatures[1].params.length : -1;
            var len2 = ok2 ? signatures[2].params.length : -1;
            var len3 = ok3 ? signatures[3].params.length : -1;
            var len4 = ok4 ? signatures[4].params.length : -1;
            var len5 = ok5 ? signatures[5].params.length : -1;
            // simple and generic, but also slow
            var iStart = allOk ? 6 : 0;
            var iEnd = signatures.length;
            var generic = function generic() {
                "use strict";
                for(var i = iStart; i < iEnd; i++){
                    if (tests[i](arguments)) return fns[i].apply(this, arguments);
                }
                return typed.onMismatch(name, arguments, signatures);
            };
            // create the typed function
            // fast, specialized version. Falls back to the slower, generic one if needed
            var fn = function fn(arg0, arg1) {
                "use strict";
                if (arguments.length === len0 && test00(arg0) && test01(arg1)) return fn0.apply(fn, arguments);
                if (arguments.length === len1 && test10(arg0) && test11(arg1)) return fn1.apply(fn, arguments);
                if (arguments.length === len2 && test20(arg0) && test21(arg1)) return fn2.apply(fn, arguments);
                if (arguments.length === len3 && test30(arg0) && test31(arg1)) return fn3.apply(fn, arguments);
                if (arguments.length === len4 && test40(arg0) && test41(arg1)) return fn4.apply(fn, arguments);
                if (arguments.length === len5 && test50(arg0) && test51(arg1)) return fn5.apply(fn, arguments);
                return generic.apply(fn, arguments);
            };
            // attach name the typed function
            try {
                Object.defineProperty(fn, "name", {
                    value: name
                });
            } catch (err) {
            // old browsers do not support Object.defineProperty and some don't support setting the name property
            // the function name is not essential for the functioning, it's mostly useful for debugging,
            // so it's fine to have unnamed functions.
            }
            // attach signatures to the function
            fn.signatures = createSignaturesMap(signatures);
            return fn;
        }
        /**
     * Action to take on mismatch
     * @param {string} name      Name of function that was attempted to be called
     * @param {Array} args       Actual arguments to the call
     * @param {Array} signatures Known signatures of the named typed-function
     */ function _onMismatch(name, args, signatures) {
            throw createError(name, args, signatures);
        }
        /**
     * Test whether a type should be NOT be ignored
     * @param {string} typeName
     * @return {boolean}
     */ function notIgnore(typeName) {
            return typed.ignore.indexOf(typeName) === -1;
        }
        /**
     * trim a string
     * @param {string} str
     * @return {string}
     */ function trim(str) {
            return str.trim();
        }
        /**
     * Test whether a string is not empty
     * @param {string} str
     * @return {boolean}
     */ function notEmpty(str) {
            return !!str;
        }
        /**
     * test whether a value is not strict equal to null
     * @param {*} value
     * @return {boolean}
     */ function notNull(value) {
            return value !== null;
        }
        /**
     * Test whether a parameter has no types defined
     * @param {Param} param
     * @return {boolean}
     */ function isInvalidParam(param) {
            return param.types.length === 0;
        }
        /**
     * Return all but the last items of an array
     * @param {Array} arr
     * @return {Array}
     */ function initial(arr) {
            return arr.slice(0, arr.length - 1);
        }
        /**
     * return the last item of an array
     * @param {Array} arr
     * @return {*}
     */ function last(arr) {
            return arr[arr.length - 1];
        }
        /**
     * Slice an array or function Arguments
     * @param {Array | Arguments | IArguments} arr
     * @param {number} start
     * @param {number} [end]
     * @return {Array}
     */ function slice(arr, start, end) {
            return Array.prototype.slice.call(arr, start, end);
        }
        /**
     * Test whether an array contains some item
     * @param {Array} array
     * @param {*} item
     * @return {boolean} Returns true if array contains item, false if not.
     */ function contains(array, item) {
            return array.indexOf(item) !== -1;
        }
        /**
     * Test whether two arrays have overlapping items
     * @param {Array} array1
     * @param {Array} array2
     * @return {boolean} Returns true when at least one item exists in both arrays
     */ function hasOverlap(array1, array2) {
            for(var i = 0; i < array1.length; i++){
                if (contains(array2, array1[i])) return true;
            }
            return false;
        }
        /**
     * Return the first item from an array for which test(arr[i]) returns true
     * @param {Array} arr
     * @param {function} test
     * @return {* | undefined} Returns the first matching item
     *                         or undefined when there is no match
     */ function findInArray(arr, test) {
            for(var i = 0; i < arr.length; i++){
                if (test(arr[i])) return arr[i];
            }
            return undefined;
        }
        /**
     * Filter unique items of an array with strings
     * @param {string[]} arr
     * @return {string[]}
     */ function uniq(arr) {
            var entries = {};
            for(var i = 0; i < arr.length; i++)entries[arr[i]] = true;
            return Object.keys(entries);
        }
        /**
     * Flat map the result invoking a callback for every item in an array.
     * https://gist.github.com/samgiles/762ee337dff48623e729
     * @param {Array} arr
     * @param {function} callback
     * @return {Array}
     */ function flatMap(arr, callback) {
            return Array.prototype.concat.apply([], arr.map(callback));
        }
        /**
     * Retrieve the function name from a set of typed functions,
     * and check whether the name of all functions match (if given)
     * @param {function[]} fns
     */ function getName(fns) {
            var name = "";
            for(var i = 0; i < fns.length; i++){
                var fn = fns[i];
                // check whether the names are the same when defined
                if ((typeof fn.signatures === "object" || typeof fn.signature === "string") && fn.name !== "") {
                    if (name === "") name = fn.name;
                    else if (name !== fn.name) {
                        var err = new Error("Function names do not match (expected: " + name + ", actual: " + fn.name + ")");
                        err.data = {
                            actual: fn.name,
                            expected: name
                        };
                        throw err;
                    }
                }
            }
            return name;
        }
        // extract and merge all signatures of a list with typed functions
        function extractSignatures(fns) {
            var err;
            var signaturesMap = {};
            function validateUnique(_signature, _fn) {
                if (signaturesMap.hasOwnProperty(_signature) && _fn !== signaturesMap[_signature]) {
                    err = new Error('Signature "' + _signature + '" is defined twice');
                    err.data = {
                        signature: _signature
                    };
                    throw err;
                // else: both signatures point to the same function, that's fine
                }
            }
            for(var i = 0; i < fns.length; i++){
                var fn = fns[i];
                // test whether this is a typed-function
                if (typeof fn.signatures === "object") {
                    // merge the signatures
                    for(var signature in fn.signatures)if (fn.signatures.hasOwnProperty(signature)) {
                        validateUnique(signature, fn.signatures[signature]);
                        signaturesMap[signature] = fn.signatures[signature];
                    }
                } else if (typeof fn.signature === "string") {
                    validateUnique(fn.signature, fn);
                    signaturesMap[fn.signature] = fn;
                } else {
                    err = new TypeError("Function is no typed-function (index: " + i + ")");
                    err.data = {
                        index: i
                    };
                    throw err;
                }
            }
            return signaturesMap;
        }
        typed = createTypedFunction("typed", {
            "string, Object": createTypedFunction,
            "Object": function(signaturesMap) {
                // find existing name
                var fns = [];
                for(var signature in signaturesMap)if (signaturesMap.hasOwnProperty(signature)) fns.push(signaturesMap[signature]);
                var name = getName(fns);
                return createTypedFunction(name, signaturesMap);
            },
            "...Function": function(fns) {
                return createTypedFunction(getName(fns), extractSignatures(fns));
            },
            "string, ...Function": function(name, fns) {
                return createTypedFunction(name, extractSignatures(fns));
            }
        });
        typed.create = create;
        typed.types = _types;
        typed.conversions = _conversions;
        typed.ignore = _ignore;
        typed.onMismatch = _onMismatch;
        typed.throwMismatchError = _onMismatch;
        typed.createError = createError;
        typed.convert = convert;
        typed.find = find;
        /**
     * add a type
     * @param {{name: string, test: function}} type
     * @param {boolean} [beforeObjectTest=true]
     *                          If true, the new test will be inserted before
     *                          the test with name 'Object' (if any), since
     *                          tests for Object match Array and classes too.
     */ typed.addType = function(type, beforeObjectTest) {
            if (!type || typeof type.name !== "string" || typeof type.test !== "function") throw new TypeError("Object with properties {name: string, test: function} expected");
            if (beforeObjectTest !== false) {
                for(var i = 0; i < typed.types.length; i++)if (typed.types[i].name === "Object") {
                    typed.types.splice(i, 0, type);
                    return;
                }
            }
            typed.types.push(type);
        };
        // add a conversion
        typed.addConversion = function(conversion) {
            if (!conversion || typeof conversion.from !== "string" || typeof conversion.to !== "string" || typeof conversion.convert !== "function") throw new TypeError("Object with properties {from: string, to: string, convert: function} expected");
            typed.conversions.push(conversion);
        };
        return typed;
    }
    return create();
});





/**
 * Get a property of a plain object
 * Throws an error in case the object is not a plain object or the
 * property is not defined on the object itself
 * @param {Object} object
 * @param {string} prop
 * @return {*} Returns the property value when safe
 */ function $452194a24e9d7818$export$87a87648a1961976(object, prop) {
    // only allow getting safe properties of a plain object
    if ($452194a24e9d7818$export$53b83ca8eaab0383(object) && $452194a24e9d7818$export$3039c640f3cfc12a(object, prop)) return object[prop];
    if (typeof object[prop] === "function" && $452194a24e9d7818$export$2220a91638ab1d9e(object, prop)) throw new Error('Cannot access method "' + prop + '" as a property');
    throw new Error('No access to property "' + prop + '"');
}
/**
 * Set a property on a plain object.
 * Throws an error in case the object is not a plain object or the
 * property would override an inherited property like .constructor or .toString
 * @param {Object} object
 * @param {string} prop
 * @param {*} value
 * @return {*} Returns the value
 */ // TODO: merge this function into access.js?
function $452194a24e9d7818$export$e99fe8700ee9f9cd(object, prop, value) {
    // only allow setting safe properties of a plain object
    if ($452194a24e9d7818$export$53b83ca8eaab0383(object) && $452194a24e9d7818$export$3039c640f3cfc12a(object, prop)) {
        object[prop] = value;
        return value;
    }
    throw new Error('No access to property "' + prop + '"');
}
function $452194a24e9d7818$export$97accea1a2314d22(object) {
    return Object.keys(object).filter((prop)=>(0, $6819694788cbfa38$export$5a15a386532a5ea4)(object, prop));
}
function $452194a24e9d7818$export$626bde2ef1d9655a(object, prop) {
    return prop in object;
}
/**
 * Test whether a property is safe to use for an object.
 * For example .toString and .constructor are not safe
 * @param {string} prop
 * @return {boolean} Returns true when safe
 */ function $452194a24e9d7818$export$3039c640f3cfc12a(object, prop) {
    if (!object || typeof object !== "object") return false;
     // SAFE: whitelisted
    // e.g length
    if ((0, $6819694788cbfa38$export$5a15a386532a5ea4)($452194a24e9d7818$var$safeNativeProperties, prop)) return true;
     // UNSAFE: inherited from Object prototype
    // e.g constructor
    if (prop in Object.prototype) // 'in' is used instead of hasOwnProperty for nodejs v0.10
    // which is inconsistent on root prototypes. It is safe
    // here because Object.prototype is a root object
    return false;
     // UNSAFE: inherited from Function prototype
    // e.g call, apply
    if (prop in Function.prototype) // 'in' is used instead of hasOwnProperty for nodejs v0.10
    // which is inconsistent on root prototypes. It is safe
    // here because Function.prototype is a root object
    return false;
    return true;
}
/**
 * Validate whether a method is safe.
 * Throws an error when that's not the case.
 * @param {Object} object
 * @param {string} method
 */ // TODO: merge this function into assign.js?
function $452194a24e9d7818$export$7cfb146d96805fec(object, method) {
    if (!$452194a24e9d7818$export$2220a91638ab1d9e(object, method)) throw new Error('No access to method "' + method + '"');
}
/**
 * Check whether a method is safe.
 * Throws an error when that's not the case (for example for `constructor`).
 * @param {Object} object
 * @param {string} method
 * @return {boolean} Returns true when safe, false otherwise
 */ function $452194a24e9d7818$export$2220a91638ab1d9e(object, method) {
    if (object === null || object === undefined || typeof object[method] !== "function") return false;
     // UNSAFE: ghosted
    // e.g overridden toString
    // Note that IE10 doesn't support __proto__ and we can't do this check there.
    if ((0, $6819694788cbfa38$export$5a15a386532a5ea4)(object, method) && Object.getPrototypeOf && method in Object.getPrototypeOf(object)) return false;
     // SAFE: whitelisted
    // e.g toString
    if ((0, $6819694788cbfa38$export$5a15a386532a5ea4)($452194a24e9d7818$var$safeNativeMethods, method)) return true;
     // UNSAFE: inherited from Object prototype
    // e.g constructor
    if (method in Object.prototype) // 'in' is used instead of hasOwnProperty for nodejs v0.10
    // which is inconsistent on root prototypes. It is safe
    // here because Object.prototype is a root object
    return false;
     // UNSAFE: inherited from Function prototype
    // e.g call, apply
    if (method in Function.prototype) // 'in' is used instead of hasOwnProperty for nodejs v0.10
    // which is inconsistent on root prototypes. It is safe
    // here because Function.prototype is a root object
    return false;
    return true;
}
function $452194a24e9d7818$export$53b83ca8eaab0383(object) {
    return typeof object === "object" && object && object.constructor === Object;
}
var $452194a24e9d7818$var$safeNativeProperties = {
    length: true,
    name: true
};
var $452194a24e9d7818$var$safeNativeMethods = {
    toString: true,
    valueOf: true,
    toLocaleString: true
};



class $7f9f5a32770f9fe4$export$6f491f8f4fd27271 {
    keys() {
        return Object.keys(this.wrappedObject);
    }
    get(key) {
        return (0, $452194a24e9d7818$export$87a87648a1961976)(this.wrappedObject, key);
    }
    set(key, value) {
        (0, $452194a24e9d7818$export$e99fe8700ee9f9cd)(this.wrappedObject, key, value);
        return this;
    }
    has(key) {
        return (0, $452194a24e9d7818$export$626bde2ef1d9655a)(this.wrappedObject, key);
    }
    constructor(object){
        this.wrappedObject = object;
    }
}
function $7f9f5a32770f9fe4$export$89a4bcaf5b4d37d2() {
    return new Map();
}
function $7f9f5a32770f9fe4$export$d49c9aa30b771d59(mapOrObject) {
    if (!mapOrObject) return $7f9f5a32770f9fe4$export$89a4bcaf5b4d37d2();
    if ($7f9f5a32770f9fe4$export$5c90113a285f2241(mapOrObject)) return mapOrObject;
    if ((0, $d8097b7a6d6e36d8$export$a6cdc56e425d0d0a)(mapOrObject)) return new $7f9f5a32770f9fe4$export$6f491f8f4fd27271(mapOrObject);
    throw new Error("createMap can create maps from objects or Maps");
}
function $7f9f5a32770f9fe4$export$697e4a1b90752ce2(map) {
    if (map instanceof $7f9f5a32770f9fe4$export$6f491f8f4fd27271) return map.wrappedObject;
    var object = {};
    for (var key of map.keys()){
        var value = map.get(key);
        (0, $452194a24e9d7818$export$e99fe8700ee9f9cd)(object, key, value);
    }
    return object;
}
function $7f9f5a32770f9fe4$export$5c90113a285f2241(object) {
    // We can use the fast instanceof, or a slower duck typing check.
    // The duck typing method needs to cover enough methods to not be confused with DenseMatrix.
    if (!object) return false;
    return object instanceof Map || object instanceof $7f9f5a32770f9fe4$export$6f491f8f4fd27271 || typeof object.set === "function" && typeof object.get === "function" && typeof object.keys === "function" && typeof object.has === "function";
}
function $7f9f5a32770f9fe4$export$e6e34fd1f2686227(map) {
    for(var _len = arguments.length, objects = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)objects[_key - 1] = arguments[_key];
    for (var args of objects){
        if (!args) continue;
        if ($7f9f5a32770f9fe4$export$5c90113a285f2241(args)) for (var key of args.keys())map.set(key, args.get(key));
        else if ((0, $d8097b7a6d6e36d8$export$a6cdc56e425d0d0a)(args)) for (var _key2 of Object.keys(args))map.set(_key2, args[_key2]);
    }
    return map;
}


var $f456e29c03959ae3$var$_createTyped2 = function _createTyped() {
    // initially, return the original instance of typed-function
    // consecutively, return a new instance from typed.create.
    $f456e29c03959ae3$var$_createTyped2 = (0, (/*@__PURE__*/$parcel$interopDefault($2a2be6c42d18dd82$exports))).create;
    return 0, (/*@__PURE__*/$parcel$interopDefault($2a2be6c42d18dd82$exports));
};
var $f456e29c03959ae3$var$dependencies = [
    "?BigNumber",
    "?Complex",
    "?DenseMatrix",
    "?Fraction"
];
var $f456e29c03959ae3$export$8597b5d47504f989 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)("typed", $f456e29c03959ae3$var$dependencies, function createTyped(_ref) {
    var { BigNumber: BigNumber, Complex: Complex, DenseMatrix: DenseMatrix, Fraction: Fraction } = _ref;
    // TODO: typed-function must be able to silently ignore signatures with unknown data types
    // get a new instance of typed-function
    var typed = $f456e29c03959ae3$var$_createTyped2(); // define all types. The order of the types determines in which order function
    // arguments are type-checked (so for performance it's important to put the
    // most used types first).
    typed.types = [
        {
            name: "number",
            test: (0, $d8097b7a6d6e36d8$export$7e4aa119212bc614)
        },
        {
            name: "Complex",
            test: (0, $d8097b7a6d6e36d8$export$8849a896711efe0c)
        },
        {
            name: "BigNumber",
            test: (0, $d8097b7a6d6e36d8$export$e51d0e7e5c4a03ab)
        },
        {
            name: "Fraction",
            test: (0, $d8097b7a6d6e36d8$export$e312cb8a8e5e7c34)
        },
        {
            name: "Unit",
            test: (0, $d8097b7a6d6e36d8$export$8960dc335987b8da)
        },
        {
            name: "string",
            test: (0, $d8097b7a6d6e36d8$export$844ec244b1367d54)
        },
        {
            name: "Chain",
            test: (0, $d8097b7a6d6e36d8$export$dc36953d0b3a4f05)
        },
        {
            name: "Array",
            test: (0, $d8097b7a6d6e36d8$export$43bee75e5e14138e)
        },
        {
            name: "Matrix",
            test: (0, $d8097b7a6d6e36d8$export$b22160e0a14f87b7)
        },
        {
            name: "DenseMatrix",
            test: (0, $d8097b7a6d6e36d8$export$eb44495df7ba11d)
        },
        {
            name: "SparseMatrix",
            test: (0, $d8097b7a6d6e36d8$export$d508368d4da3c38a)
        },
        {
            name: "Range",
            test: (0, $d8097b7a6d6e36d8$export$e331ccfa6f694c99)
        },
        {
            name: "Index",
            test: (0, $d8097b7a6d6e36d8$export$ba3dc792055c2f45)
        },
        {
            name: "boolean",
            test: (0, $d8097b7a6d6e36d8$export$f9ce7b637dfbe238)
        },
        {
            name: "ResultSet",
            test: (0, $d8097b7a6d6e36d8$export$381a1a20e6a63376)
        },
        {
            name: "Help",
            test: (0, $d8097b7a6d6e36d8$export$e5dec9a75b602d6c)
        },
        {
            name: "function",
            test: (0, $d8097b7a6d6e36d8$export$f6e2535fb5126e54)
        },
        {
            name: "Date",
            test: (0, $d8097b7a6d6e36d8$export$871608497c498473)
        },
        {
            name: "RegExp",
            test: (0, $d8097b7a6d6e36d8$export$49841c62b9eff15)
        },
        {
            name: "null",
            test: (0, $d8097b7a6d6e36d8$export$630801d484da15df)
        },
        {
            name: "undefined",
            test: (0, $d8097b7a6d6e36d8$export$fce6876652108ab)
        },
        {
            name: "AccessorNode",
            test: (0, $d8097b7a6d6e36d8$export$f88fb19d6b9ee5cb)
        },
        {
            name: "ArrayNode",
            test: (0, $d8097b7a6d6e36d8$export$440fa93dcf2757a3)
        },
        {
            name: "AssignmentNode",
            test: (0, $d8097b7a6d6e36d8$export$64d7d515ec030d5e)
        },
        {
            name: "BlockNode",
            test: (0, $d8097b7a6d6e36d8$export$1665e2275a3d717a)
        },
        {
            name: "ConditionalNode",
            test: (0, $d8097b7a6d6e36d8$export$e1babefe78c70737)
        },
        {
            name: "ConstantNode",
            test: (0, $d8097b7a6d6e36d8$export$fa9d80731fd8c54b)
        },
        {
            name: "FunctionNode",
            test: (0, $d8097b7a6d6e36d8$export$6ae03b16e064e6c4)
        },
        {
            name: "FunctionAssignmentNode",
            test: (0, $d8097b7a6d6e36d8$export$27c05cfffd263d30)
        },
        {
            name: "IndexNode",
            test: (0, $d8097b7a6d6e36d8$export$ff90979121a6cabc)
        },
        {
            name: "Node",
            test: (0, $d8097b7a6d6e36d8$export$8ee0fc9ee280b4ee)
        },
        {
            name: "ObjectNode",
            test: (0, $d8097b7a6d6e36d8$export$3f18867a334658e9)
        },
        {
            name: "OperatorNode",
            test: (0, $d8097b7a6d6e36d8$export$7e624cbaab6cce94)
        },
        {
            name: "ParenthesisNode",
            test: (0, $d8097b7a6d6e36d8$export$c55e3736c5721220)
        },
        {
            name: "RangeNode",
            test: (0, $d8097b7a6d6e36d8$export$92729c5c4ff6fc83)
        },
        {
            name: "SymbolNode",
            test: (0, $d8097b7a6d6e36d8$export$87815d550facaed9)
        },
        {
            name: "Map",
            test: (0, $7f9f5a32770f9fe4$export$5c90113a285f2241)
        },
        {
            name: "Object",
            test: (0, $d8097b7a6d6e36d8$export$a6cdc56e425d0d0a)
        } // order 'Object' last, it matches on other classes too
    ];
    typed.conversions = [
        {
            from: "number",
            to: "BigNumber",
            convert: function convert(x) {
                if (!BigNumber) $f456e29c03959ae3$var$throwNoBignumber(x);
                 // note: conversion from number to BigNumber can fail if x has >15 digits
                if ((0, $668e051498bf5fa0$export$9c0987062f8f5d89)(x) > 15) throw new TypeError("Cannot implicitly convert a number with >15 significant digits to BigNumber (value: " + x + "). " + "Use function bignumber(x) to convert to BigNumber.");
                return new BigNumber(x);
            }
        },
        {
            from: "number",
            to: "Complex",
            convert: function convert(x) {
                if (!Complex) $f456e29c03959ae3$var$throwNoComplex(x);
                return new Complex(x, 0);
            }
        },
        {
            from: "number",
            to: "string",
            convert: function convert(x) {
                return x + "";
            }
        },
        {
            from: "BigNumber",
            to: "Complex",
            convert: function convert(x) {
                if (!Complex) $f456e29c03959ae3$var$throwNoComplex(x);
                return new Complex(x.toNumber(), 0);
            }
        },
        {
            from: "Fraction",
            to: "BigNumber",
            convert: function convert(x) {
                throw new TypeError("Cannot implicitly convert a Fraction to BigNumber or vice versa. Use function bignumber(x) to convert to BigNumber or fraction(x) to convert to Fraction.");
            }
        },
        {
            from: "Fraction",
            to: "Complex",
            convert: function convert(x) {
                if (!Complex) $f456e29c03959ae3$var$throwNoComplex(x);
                return new Complex(x.valueOf(), 0);
            }
        },
        {
            from: "number",
            to: "Fraction",
            convert: function convert(x) {
                if (!Fraction) $f456e29c03959ae3$var$throwNoFraction(x);
                var f = new Fraction(x);
                if (f.valueOf() !== x) throw new TypeError("Cannot implicitly convert a number to a Fraction when there will be a loss of precision (value: " + x + "). " + "Use function fraction(x) to convert to Fraction.");
                return f;
            }
        },
        {
            // FIXME: add conversion from Fraction to number, for example for `sqrt(fraction(1,3))`
            //  from: 'Fraction',
            //  to: 'number',
            //  convert: function (x) {
            //    return x.valueOf()
            //  }
            // }, {
            from: "string",
            to: "number",
            convert: function convert(x) {
                var n = Number(x);
                if (isNaN(n)) throw new Error('Cannot convert "' + x + '" to a number');
                return n;
            }
        },
        {
            from: "string",
            to: "BigNumber",
            convert: function convert(x) {
                if (!BigNumber) $f456e29c03959ae3$var$throwNoBignumber(x);
                try {
                    return new BigNumber(x);
                } catch (err) {
                    throw new Error('Cannot convert "' + x + '" to BigNumber');
                }
            }
        },
        {
            from: "string",
            to: "Fraction",
            convert: function convert(x) {
                if (!Fraction) $f456e29c03959ae3$var$throwNoFraction(x);
                try {
                    return new Fraction(x);
                } catch (err) {
                    throw new Error('Cannot convert "' + x + '" to Fraction');
                }
            }
        },
        {
            from: "string",
            to: "Complex",
            convert: function convert(x) {
                if (!Complex) $f456e29c03959ae3$var$throwNoComplex(x);
                try {
                    return new Complex(x);
                } catch (err) {
                    throw new Error('Cannot convert "' + x + '" to Complex');
                }
            }
        },
        {
            from: "boolean",
            to: "number",
            convert: function convert(x) {
                return +x;
            }
        },
        {
            from: "boolean",
            to: "BigNumber",
            convert: function convert(x) {
                if (!BigNumber) $f456e29c03959ae3$var$throwNoBignumber(x);
                return new BigNumber(+x);
            }
        },
        {
            from: "boolean",
            to: "Fraction",
            convert: function convert(x) {
                if (!Fraction) $f456e29c03959ae3$var$throwNoFraction(x);
                return new Fraction(+x);
            }
        },
        {
            from: "boolean",
            to: "string",
            convert: function convert(x) {
                return String(x);
            }
        },
        {
            from: "Array",
            to: "Matrix",
            convert: function convert(array) {
                if (!DenseMatrix) $f456e29c03959ae3$var$throwNoMatrix();
                return new DenseMatrix(array);
            }
        },
        {
            from: "Matrix",
            to: "Array",
            convert: function convert(matrix) {
                return matrix.valueOf();
            }
        }
    ];
    return typed;
});
function $f456e29c03959ae3$var$throwNoBignumber(x) {
    throw new Error("Cannot convert value ".concat(x, " into a BigNumber: no class 'BigNumber' provided"));
}
function $f456e29c03959ae3$var$throwNoComplex(x) {
    throw new Error("Cannot convert value ".concat(x, " into a Complex number: no class 'Complex' provided"));
}
function $f456e29c03959ae3$var$throwNoMatrix() {
    throw new Error("Cannot convert array into a Matrix: no class 'DenseMatrix' provided");
}
function $f456e29c03959ae3$var$throwNoFraction(x) {
    throw new Error("Cannot convert value ".concat(x, " into a Fraction, no class 'Fraction' provided."));
}





/**
 * Transpose a matrix
 * @param {Array} mat
 * @returns {Array} ret
 * @private
 */ function $52b148bf6ec821bd$export$424b8b2ab9af2944(mat) {
    var I = mat.length;
    var J = mat[0].length;
    var i, j;
    var ret = [];
    for(j = 0; j < J; j++){
        var tmp = [];
        for(i = 0; i < I; i++)tmp.push(mat[i][j]);
        ret.push(tmp);
    }
    return ret;
}


function $dd57e6221b0e50b6$export$4d8f6a27e2f5bcb2(array) {
    for(var i = 0; i < array.length; i++){
        if ((0, $d8097b7a6d6e36d8$export$cea7aa84e978eba5)(array[i])) return true;
    }
    return false;
}
function $dd57e6221b0e50b6$export$519ada94592b97fc(array, callback) {
    if ((0, $d8097b7a6d6e36d8$export$b22160e0a14f87b7)(array)) array = array.valueOf();
    for(var i = 0, ii = array.length; i < ii; i++){
        var value = array[i];
        if (Array.isArray(value)) $dd57e6221b0e50b6$export$519ada94592b97fc(value, callback);
        else callback(value);
    }
}
function $dd57e6221b0e50b6$export$ce7eaaed37329a1b(array, callback, skipZeros) {
    if (array && typeof array.map === "function") // TODO: replace array.map with a for loop to improve performance
    return array.map(function(x) {
        return $dd57e6221b0e50b6$export$ce7eaaed37329a1b(x, callback, skipZeros);
    });
    else return callback(array);
}
function $dd57e6221b0e50b6$export$533b26079ad0b4b(mat, dim, callback) {
    var size = Array.isArray(mat) ? (0, $a14a10567870d913$export$51ffaee4afb683a5)(mat) : mat.size();
    if (dim < 0 || dim >= size.length) // TODO: would be more clear when throwing a DimensionError here
    throw new (0, $5f2abd91081f798a$export$efa5eacb1304c464)(dim, size.length);
    if ((0, $d8097b7a6d6e36d8$export$b22160e0a14f87b7)(mat)) return mat.create($dd57e6221b0e50b6$var$_reduce(mat.valueOf(), dim, callback));
    else return $dd57e6221b0e50b6$var$_reduce(mat, dim, callback);
}
/**
 * Recursively reduce a matrix
 * @param {Array} mat
 * @param {number} dim
 * @param {Function} callback
 * @returns {Array} ret
 * @private
 */ function $dd57e6221b0e50b6$var$_reduce(mat, dim, callback) {
    var i, ret, val, tran;
    if (dim <= 0) {
        if (!Array.isArray(mat[0])) {
            val = mat[0];
            for(i = 1; i < mat.length; i++)val = callback(val, mat[i]);
            return val;
        } else {
            tran = (0, $52b148bf6ec821bd$export$424b8b2ab9af2944)(mat);
            ret = [];
            for(i = 0; i < tran.length; i++)ret[i] = $dd57e6221b0e50b6$var$_reduce(tran[i], dim - 1, callback);
            return ret;
        }
    } else {
        ret = [];
        for(i = 0; i < mat.length; i++)ret[i] = $dd57e6221b0e50b6$var$_reduce(mat[i], dim - 1, callback);
        return ret;
    }
} // TODO: document function scatter
function $dd57e6221b0e50b6$export$c97954fff4307550(a, j, w, x, u, mark, cindex, f, inverse, update, value) {
    // a arrays
    var avalues = a._values;
    var aindex = a._index;
    var aptr = a._ptr; // vars
    var k, k0, k1, i; // check we need to process values (pattern matrix)
    if (x) // values in j
    for(k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
        // row
        i = aindex[k]; // check value exists in current j
        if (w[i] !== mark) {
            // i is new entry in j
            w[i] = mark; // add i to pattern of C
            cindex.push(i); // x(i) = A, check we need to call function this time
            if (update) {
                // copy value to workspace calling callback function
                x[i] = inverse ? f(avalues[k], value) : f(value, avalues[k]); // function was called on current row
                u[i] = mark;
            } else // copy value to workspace
            x[i] = avalues[k];
        } else {
            // i exists in C already
            x[i] = inverse ? f(avalues[k], x[i]) : f(x[i], avalues[k]); // function was called on current row
            u[i] = mark;
        }
    }
    else // values in j
    for(k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
        // row
        i = aindex[k]; // check value exists in current j
        if (w[i] !== mark) {
            // i is new entry in j
            w[i] = mark; // add i to pattern of C
            cindex.push(i);
        } else // indicate function was called on current row
        u[i] = mark;
    }
}



var $4b37ed316f05dd33$var$n1 = "number";
var $4b37ed316f05dd33$var$n2 = "number, number";
function $4b37ed316f05dd33$export$59270f717756a93a(a) {
    return Math.abs(a);
}
$4b37ed316f05dd33$export$59270f717756a93a.signature = $4b37ed316f05dd33$var$n1;
function $4b37ed316f05dd33$export$d6751d2a3b6da12a(a, b) {
    return a + b;
}
$4b37ed316f05dd33$export$d6751d2a3b6da12a.signature = $4b37ed316f05dd33$var$n2;
function $4b37ed316f05dd33$export$fd8ce9cfca47ace5(a, b) {
    return a - b;
}
$4b37ed316f05dd33$export$fd8ce9cfca47ace5.signature = $4b37ed316f05dd33$var$n2;
function $4b37ed316f05dd33$export$4ad41ac849e391ec(a, b) {
    return a * b;
}
$4b37ed316f05dd33$export$4ad41ac849e391ec.signature = $4b37ed316f05dd33$var$n2;
function $4b37ed316f05dd33$export$58c48a269ab4a155(a, b) {
    return a / b;
}
$4b37ed316f05dd33$export$58c48a269ab4a155.signature = $4b37ed316f05dd33$var$n2;
function $4b37ed316f05dd33$export$339666dc881be46b(x) {
    return -x;
}
$4b37ed316f05dd33$export$339666dc881be46b.signature = $4b37ed316f05dd33$var$n1;
function $4b37ed316f05dd33$export$da5b80d388a295fb(x) {
    return x;
}
$4b37ed316f05dd33$export$da5b80d388a295fb.signature = $4b37ed316f05dd33$var$n1;
function $4b37ed316f05dd33$export$95c2aecb85f70726(x) {
    return (0, $668e051498bf5fa0$export$841fc4d5a1480b85)(x);
}
$4b37ed316f05dd33$export$95c2aecb85f70726.signature = $4b37ed316f05dd33$var$n1;
function $4b37ed316f05dd33$export$9505f0b39acd04c(x) {
    return x * x * x;
}
$4b37ed316f05dd33$export$9505f0b39acd04c.signature = $4b37ed316f05dd33$var$n1;
function $4b37ed316f05dd33$export$a33b288b35672fe5(x) {
    return Math.exp(x);
}
$4b37ed316f05dd33$export$a33b288b35672fe5.signature = $4b37ed316f05dd33$var$n1;
function $4b37ed316f05dd33$export$756d0c010cecc6c3(x) {
    return (0, $668e051498bf5fa0$export$b6c0a80d46d3391d)(x);
}
$4b37ed316f05dd33$export$756d0c010cecc6c3.signature = $4b37ed316f05dd33$var$n1;
function $4b37ed316f05dd33$export$3a8d786b08b3a70c(a, b) {
    if (!(0, $668e051498bf5fa0$export$a287f47fed4544b8)(a) || !(0, $668e051498bf5fa0$export$a287f47fed4544b8)(b)) throw new Error("Parameters in function gcd must be integer numbers");
     // https://en.wikipedia.org/wiki/Euclidean_algorithm
    var r;
    while(b !== 0){
        r = a % b;
        a = b;
        b = r;
    }
    return a < 0 ? -a : a;
}
$4b37ed316f05dd33$export$3a8d786b08b3a70c.signature = $4b37ed316f05dd33$var$n2;
function $4b37ed316f05dd33$export$b55f99ec1f4c5649(a, b) {
    if (!(0, $668e051498bf5fa0$export$a287f47fed4544b8)(a) || !(0, $668e051498bf5fa0$export$a287f47fed4544b8)(b)) throw new Error("Parameters in function lcm must be integer numbers");
    if (a === 0 || b === 0) return 0;
     // https://en.wikipedia.org/wiki/Euclidean_algorithm
    // evaluate lcm here inline to reduce overhead
    var t;
    var prod = a * b;
    while(b !== 0){
        t = b;
        b = a % t;
        a = t;
    }
    return Math.abs(prod / a);
}
$4b37ed316f05dd33$export$b55f99ec1f4c5649.signature = $4b37ed316f05dd33$var$n2;
function $4b37ed316f05dd33$export$4df0e8fcdd5c0927(x, y) {
    if (y) return Math.log(x) / Math.log(y);
    return Math.log(x);
}
function $4b37ed316f05dd33$export$e3f8d49574d29dff(x) {
    return (0, $668e051498bf5fa0$export$75e08744a3ff8516)(x);
}
$4b37ed316f05dd33$export$e3f8d49574d29dff.signature = $4b37ed316f05dd33$var$n1;
function $4b37ed316f05dd33$export$f9bc93220cfa3c59(x) {
    return (0, $668e051498bf5fa0$export$b9fae0bba9d9094d)(x);
}
$4b37ed316f05dd33$export$f9bc93220cfa3c59.signature = $4b37ed316f05dd33$var$n1;
function $4b37ed316f05dd33$export$ae1f56e105ebe4a1(x) {
    return (0, $668e051498bf5fa0$export$144dcf16adfb9698)(x);
}
$4b37ed316f05dd33$export$ae1f56e105ebe4a1.signature = $4b37ed316f05dd33$var$n1;
function $4b37ed316f05dd33$export$64b58c5b0372ae95(x, y) {
    if (y > 0) // We don't use JavaScript's % operator here as this doesn't work
    // correctly for x < 0 and x === 0
    // see https://en.wikipedia.org/wiki/Modulo_operation
    return x - y * Math.floor(x / y);
    else if (y === 0) return x;
    else // y < 0
    // TODO: implement mod for a negative divisor
    throw new Error("Cannot calculate mod for a negative divisor");
}
$4b37ed316f05dd33$export$64b58c5b0372ae95.signature = $4b37ed316f05dd33$var$n2;
function $4b37ed316f05dd33$export$9f26f16bd796a7b3(a) {
    var root = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    var inv = root < 0;
    if (inv) root = -root;
    if (root === 0) throw new Error("Root must be non-zero");
    if (a < 0 && Math.abs(root) % 2 !== 1) throw new Error("Root must be odd when a is negative.");
     // edge cases zero and infinity
    if (a === 0) return inv ? Infinity : 0;
    if (!isFinite(a)) return inv ? 0 : a;
    var x = Math.pow(Math.abs(a), 1 / root); // If a < 0, we require that root is an odd integer,
    // so (-1) ^ (1/root) = -1
    x = a < 0 ? -x : x;
    return inv ? 1 / x : x; // Very nice algorithm, but fails with nthRoot(-2, 3).
// Newton's method has some well-known problems at times:
// https://en.wikipedia.org/wiki/Newton%27s_method#Failure_analysis
/*
  let x = 1 // Initial guess
  let xPrev = 1
  let i = 0
  const iMax = 10000
  do {
    const delta = (a / Math.pow(x, root - 1) - x) / root
    xPrev = x
    x = x + delta
    i++
  }
  while (xPrev !== x && i < iMax)
   if (xPrev !== x) {
    throw new Error('Function nthRoot failed to converge')
  }
   return inv ? 1 / x : x
  */ }
function $4b37ed316f05dd33$export$af3d9fe43be78285(x) {
    return (0, $668e051498bf5fa0$export$c5552dfdbc7cec71)(x);
}
$4b37ed316f05dd33$export$af3d9fe43be78285.signature = $4b37ed316f05dd33$var$n1;
function $4b37ed316f05dd33$export$aacd0ed14e49886d(x) {
    return Math.sqrt(x);
}
$4b37ed316f05dd33$export$aacd0ed14e49886d.signature = $4b37ed316f05dd33$var$n1;
function $4b37ed316f05dd33$export$c4094a156ed9ab35(x) {
    return x * x;
}
$4b37ed316f05dd33$export$c4094a156ed9ab35.signature = $4b37ed316f05dd33$var$n1;
function $4b37ed316f05dd33$export$8cb756a23a623229(a, b) {
    // source: https://en.wikipedia.org/wiki/Extended_Euclidean_algorithm
    var t; // used to swap two variables
    var q; // quotient
    var r; // remainder
    var x = 0;
    var lastx = 1;
    var y = 1;
    var lasty = 0;
    if (!(0, $668e051498bf5fa0$export$a287f47fed4544b8)(a) || !(0, $668e051498bf5fa0$export$a287f47fed4544b8)(b)) throw new Error("Parameters in function xgcd must be integer numbers");
    while(b){
        q = Math.floor(a / b);
        r = a - q * b;
        t = x;
        x = lastx - q * x;
        lastx = t;
        t = y;
        y = lasty - q * y;
        lasty = t;
        a = b;
        b = r;
    }
    var res;
    if (a < 0) res = [
        -a,
        -lastx,
        -lasty
    ];
    else res = [
        a,
        a ? lastx : 0,
        lasty
    ];
    return res;
}
$4b37ed316f05dd33$export$8cb756a23a623229.signature = $4b37ed316f05dd33$var$n2;
function $4b37ed316f05dd33$export$3f512e7fd4999e01(x, y) {
    // x^Infinity === 0 if -1 < x < 1
    // A real number 0 is returned instead of complex(0)
    if (x * x < 1 && y === Infinity || x * x > 1 && y === -Infinity) return 0;
    return Math.pow(x, y);
}
$4b37ed316f05dd33$export$3f512e7fd4999e01.signature = $4b37ed316f05dd33$var$n2;
function $4b37ed316f05dd33$export$a3992db8dd0fd9e6(value) {
    var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    if (!(0, $668e051498bf5fa0$export$a287f47fed4544b8)(decimals) || decimals < 0 || decimals > 15) throw new Error("Number of decimals in function round must be an integer from 0 to 15 inclusive");
    return parseFloat((0, $668e051498bf5fa0$export$a81f732198733497)(value, decimals));
}
function $4b37ed316f05dd33$export$d78ecacee56245ec(x) {
    return Math.abs(x);
}
$4b37ed316f05dd33$export$d78ecacee56245ec.signature = $4b37ed316f05dd33$var$n1;


var $5162cbd1eca10369$var$name = "unaryPlus";
var $5162cbd1eca10369$var$dependencies = [
    "typed",
    "config",
    "BigNumber"
];
var $5162cbd1eca10369$export$cb425222dc08ff4e = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($5162cbd1eca10369$var$name, $5162cbd1eca10369$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, BigNumber: BigNumber } = _ref;
    /**
   * Unary plus operation.
   * Boolean values and strings will be converted to a number, numeric values will be returned as is.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.unaryPlus(x)
   *
   * Examples:
   *
   *    math.unaryPlus(3.5)      // returns 3.5
   *    math.unaryPlus(1)     // returns 1
   *
   * See also:
   *
   *    unaryMinus, add, subtract
   *
   * @param  {number | BigNumber | Fraction | string | Complex | Unit | Array | Matrix} x
   *            Input value
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}
   *            Returns the input value when numeric, converts to a number when input is non-numeric.
   */ return typed($5162cbd1eca10369$var$name, {
        number: (0, $4b37ed316f05dd33$export$da5b80d388a295fb),
        Complex: function Complex(x) {
            return x; // complex numbers are immutable
        },
        BigNumber: function BigNumber(x) {
            return x; // bignumbers are immutable
        },
        Fraction: function Fraction(x) {
            return x; // fractions are immutable
        },
        Unit: function Unit(x) {
            return x.clone();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since unaryPlus(0) = 0
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this, true);
        },
        "boolean | string": function booleanString(x) {
            // convert to a number or bignumber
            return config.number === "BigNumber" ? new BigNumber(+x) : +x;
        }
    });
});




var $3b15ea4368bd064b$var$name = "abs";
var $3b15ea4368bd064b$var$dependencies = [
    "typed"
];
var $3b15ea4368bd064b$export$dd8a9b3843a4df95 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($3b15ea4368bd064b$var$name, $3b15ea4368bd064b$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Calculate the absolute value of a number. For matrices, the function is
   * evaluated element wise.
   *
   * Syntax:
   *
   *    math.abs(x)
   *
   * Examples:
   *
   *    math.abs(3.5)                // returns number 3.5
   *    math.abs(-4.2)               // returns number 4.2
   *
   *    math.abs([3, -5, -1, 0, 2])  // returns Array [3, 5, 1, 0, 2]
   *
   * See also:
   *
   *    sign
   *
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix | Unit} x
   *            A number or matrix for which to get the absolute value
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix | Unit}
   *            Absolute value of `x`
   */ return typed($3b15ea4368bd064b$var$name, {
        number: (0, $4b37ed316f05dd33$export$59270f717756a93a),
        Complex: function Complex(x) {
            return x.abs();
        },
        BigNumber: function BigNumber(x) {
            return x.abs();
        },
        Fraction: function Fraction(x) {
            return x.abs();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since abs(0) = 0
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this, true);
        },
        Unit: function Unit(x) {
            return x.abs();
        }
    });
});



var $6b4e029c5e006c1b$var$name = "acos";
var $6b4e029c5e006c1b$var$dependencies = [
    "typed",
    "config",
    "Complex"
];
var $6b4e029c5e006c1b$export$33da46c5ece67581 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($6b4e029c5e006c1b$var$name, $6b4e029c5e006c1b$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex } = _ref;
    /**
   * Calculate the inverse cosine of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.acos(x)
   *
   * Examples:
   *
   *    math.acos(0.5)           // returns number 1.0471975511965979
   *    math.acos(math.cos(1.5)) // returns number 1.5
   *
   *    math.acos(2)             // returns Complex 0 + 1.3169578969248166 i
   *
   * See also:
   *
   *    cos, atan, asin
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x  Function input
   * @return {number | BigNumber | Complex | Array | Matrix} The arc cosine of x
   */ return typed($6b4e029c5e006c1b$var$name, {
        number: function number(x) {
            if (x >= -1 && x <= 1 || config.predictable) return Math.acos(x);
            else return new Complex(x, 0).acos();
        },
        Complex: function Complex(x) {
            return x.acos();
        },
        BigNumber: function BigNumber(x) {
            return x.acos();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this);
        }
    });
});




var $d10e9b2ec26dc177$var$n1 = "number";
var $d10e9b2ec26dc177$var$n2 = "number, number";
function $d10e9b2ec26dc177$export$99a14685a3a2b607(x) {
    return Math.acos(x);
}
$d10e9b2ec26dc177$export$99a14685a3a2b607.signature = $d10e9b2ec26dc177$var$n1;
function $d10e9b2ec26dc177$export$84088556f7d2d0be(x) {
    return (0, $668e051498bf5fa0$export$b26caf0f29211d08)(x);
}
$d10e9b2ec26dc177$export$84088556f7d2d0be.signature = $d10e9b2ec26dc177$var$n1;
function $d10e9b2ec26dc177$export$ba80ccbf024897ef(x) {
    return Math.atan(1 / x);
}
$d10e9b2ec26dc177$export$ba80ccbf024897ef.signature = $d10e9b2ec26dc177$var$n1;
function $d10e9b2ec26dc177$export$e2be1aa5d5a3f81(x) {
    return isFinite(x) ? (Math.log((x + 1) / x) + Math.log(x / (x - 1))) / 2 : 0;
}
$d10e9b2ec26dc177$export$e2be1aa5d5a3f81.signature = $d10e9b2ec26dc177$var$n1;
function $d10e9b2ec26dc177$export$e3b67a6e3df3fd81(x) {
    return Math.asin(1 / x);
}
$d10e9b2ec26dc177$export$e3b67a6e3df3fd81.signature = $d10e9b2ec26dc177$var$n1;
function $d10e9b2ec26dc177$export$51cd224337b2c783(x) {
    var xInv = 1 / x;
    return Math.log(xInv + Math.sqrt(xInv * xInv + 1));
}
$d10e9b2ec26dc177$export$51cd224337b2c783.signature = $d10e9b2ec26dc177$var$n1;
function $d10e9b2ec26dc177$export$5ec3930177455ade(x) {
    return Math.acos(1 / x);
}
$d10e9b2ec26dc177$export$5ec3930177455ade.signature = $d10e9b2ec26dc177$var$n1;
function $d10e9b2ec26dc177$export$cf144300ea173362(x) {
    var xInv = 1 / x;
    var ret = Math.sqrt(xInv * xInv - 1);
    return Math.log(ret + xInv);
}
$d10e9b2ec26dc177$export$cf144300ea173362.signature = $d10e9b2ec26dc177$var$n1;
function $d10e9b2ec26dc177$export$444ef2855488a2d5(x) {
    return Math.asin(x);
}
$d10e9b2ec26dc177$export$444ef2855488a2d5.signature = $d10e9b2ec26dc177$var$n1;
function $d10e9b2ec26dc177$export$3a027485d3336d8d(x) {
    return (0, $668e051498bf5fa0$export$839d8a01b6af4fc0)(x);
}
$d10e9b2ec26dc177$export$3a027485d3336d8d.signature = $d10e9b2ec26dc177$var$n1;
function $d10e9b2ec26dc177$export$c38dcb11df4699c0(x) {
    return Math.atan(x);
}
$d10e9b2ec26dc177$export$c38dcb11df4699c0.signature = $d10e9b2ec26dc177$var$n1;
function $d10e9b2ec26dc177$export$a97666a135b540f9(y, x) {
    return Math.atan2(y, x);
}
$d10e9b2ec26dc177$export$a97666a135b540f9.signature = $d10e9b2ec26dc177$var$n2;
function $d10e9b2ec26dc177$export$44a1f653c6513db8(x) {
    return (0, $668e051498bf5fa0$export$21ea955025ceb08b)(x);
}
$d10e9b2ec26dc177$export$44a1f653c6513db8.signature = $d10e9b2ec26dc177$var$n1;
function $d10e9b2ec26dc177$export$8d04496be3e647d4(x) {
    return Math.cos(x);
}
$d10e9b2ec26dc177$export$8d04496be3e647d4.signature = $d10e9b2ec26dc177$var$n1;
function $d10e9b2ec26dc177$export$7cf8db0cff734545(x) {
    return (0, $668e051498bf5fa0$export$2e2fd1ad24e4d350)(x);
}
$d10e9b2ec26dc177$export$7cf8db0cff734545.signature = $d10e9b2ec26dc177$var$n1;
function $d10e9b2ec26dc177$export$515b39f7fd07e09f(x) {
    return 1 / Math.tan(x);
}
$d10e9b2ec26dc177$export$515b39f7fd07e09f.signature = $d10e9b2ec26dc177$var$n1;
function $d10e9b2ec26dc177$export$925affe88b2512fc(x) {
    var e = Math.exp(2 * x);
    return (e + 1) / (e - 1);
}
$d10e9b2ec26dc177$export$925affe88b2512fc.signature = $d10e9b2ec26dc177$var$n1;
function $d10e9b2ec26dc177$export$5a8409ad16e318b2(x) {
    return 1 / Math.sin(x);
}
$d10e9b2ec26dc177$export$5a8409ad16e318b2.signature = $d10e9b2ec26dc177$var$n1;
function $d10e9b2ec26dc177$export$143835b5c1db9790(x) {
    // consider values close to zero (+/-)
    if (x === 0) return Number.POSITIVE_INFINITY;
    else return Math.abs(2 / (Math.exp(x) - Math.exp(-x))) * (0, $668e051498bf5fa0$export$c5552dfdbc7cec71)(x);
}
$d10e9b2ec26dc177$export$143835b5c1db9790.signature = $d10e9b2ec26dc177$var$n1;
function $d10e9b2ec26dc177$export$ee1efc70bd8a6d93(x) {
    return 1 / Math.cos(x);
}
$d10e9b2ec26dc177$export$ee1efc70bd8a6d93.signature = $d10e9b2ec26dc177$var$n1;
function $d10e9b2ec26dc177$export$b83345d70fe4a871(x) {
    return 2 / (Math.exp(x) + Math.exp(-x));
}
$d10e9b2ec26dc177$export$b83345d70fe4a871.signature = $d10e9b2ec26dc177$var$n1;
function $d10e9b2ec26dc177$export$b6e96f13f41c8816(x) {
    return Math.sin(x);
}
$d10e9b2ec26dc177$export$b6e96f13f41c8816.signature = $d10e9b2ec26dc177$var$n1;
function $d10e9b2ec26dc177$export$89648c4ce0d79e70(x) {
    return (0, $668e051498bf5fa0$export$545004b505d7c555)(x);
}
$d10e9b2ec26dc177$export$89648c4ce0d79e70.signature = $d10e9b2ec26dc177$var$n1;
function $d10e9b2ec26dc177$export$ecbd7b3271ebce16(x) {
    return Math.tan(x);
}
$d10e9b2ec26dc177$export$ecbd7b3271ebce16.signature = $d10e9b2ec26dc177$var$n1;
function $d10e9b2ec26dc177$export$70e2e2cc9c2555e4(x) {
    return (0, $668e051498bf5fa0$export$7128670e45beef9a)(x);
}
$d10e9b2ec26dc177$export$70e2e2cc9c2555e4.signature = $d10e9b2ec26dc177$var$n1;


var $9f162a2f00142af4$var$name = "acot";
var $9f162a2f00142af4$var$dependencies = [
    "typed",
    "BigNumber"
];
var $9f162a2f00142af4$export$8a6845771325148e = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($9f162a2f00142af4$var$name, $9f162a2f00142af4$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the inverse cotangent of a value, defined as `acot(x) = atan(1/x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.acot(x)
   *
   * Examples:
   *
   *    math.acot(0.5)           // returns number 0.4636476090008061
   *    math.acot(math.cot(1.5)) // returns number 1.5
   *
   *    math.acot(2)             // returns Complex 1.5707963267948966 -1.3169578969248166 i
   *
   * See also:
   *
   *    cot, atan
   *
   * @param {number | Complex | Array | Matrix} x   Function input
   * @return {number | Complex | Array | Matrix} The arc cotangent of x
   */ return typed($9f162a2f00142af4$var$name, {
        number: (0, $d10e9b2ec26dc177$export$ba80ccbf024897ef),
        Complex: function Complex(x) {
            return x.acot();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x).atan();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this);
        }
    });
});




var $cc732836f684e4e9$var$name = "acsc";
var $cc732836f684e4e9$var$dependencies = [
    "typed",
    "config",
    "Complex",
    "BigNumber"
];
var $cc732836f684e4e9$export$95580581b134a5bd = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($cc732836f684e4e9$var$name, $cc732836f684e4e9$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the inverse cosecant of a value, defined as `acsc(x) = asin(1/x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.acsc(x)
   *
   * Examples:
   *
   *    math.acsc(0.5)           // returns number 0.5235987755982989
   *    math.acsc(math.csc(1.5)) // returns number ~1.5
   *
   *    math.acsc(2)             // returns Complex 1.5707963267948966 -1.3169578969248166 i
   *
   * See also:
   *
   *    csc, asin, asec
   *
   * @param {number | Complex | Array | Matrix} x   Function input
   * @return {number | Complex | Array | Matrix} The arc cosecant of x
   */ return typed($cc732836f684e4e9$var$name, {
        number: function number(x) {
            if (x <= -1 || x >= 1 || config.predictable) return (0, $d10e9b2ec26dc177$export$e3b67a6e3df3fd81)(x);
            return new Complex(x, 0).acsc();
        },
        Complex: function Complex(x) {
            return x.acsc();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x).asin();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this);
        }
    });
});



var $943ad76e8ef3c24c$var$name = "addScalar";
var $943ad76e8ef3c24c$var$dependencies = [
    "typed"
];
var $943ad76e8ef3c24c$export$bbebd809b9ccc50b = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($943ad76e8ef3c24c$var$name, $943ad76e8ef3c24c$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Add two scalar values, `x + y`.
   * This function is meant for internal use: it is used by the public function
   * `add`
   *
   * This function does not support collections (Array or Matrix).
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit} x   First value to add
   * @param  {number | BigNumber | Fraction | Complex} y          Second value to add
   * @return {number | BigNumber | Fraction | Complex | Unit}     Sum of `x` and `y`
   * @private
   */ return typed($943ad76e8ef3c24c$var$name, {
        "number, number": (0, $4b37ed316f05dd33$export$d6751d2a3b6da12a),
        "Complex, Complex": function ComplexComplex(x, y) {
            return x.add(y);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.plus(y);
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.add(y);
        },
        "Unit, Unit": function UnitUnit(x, y) {
            if (x.value === null || x.value === undefined) throw new Error("Parameter x contains a unit with undefined value");
            if (y.value === null || y.value === undefined) throw new Error("Parameter y contains a unit with undefined value");
            if (!x.equalBase(y)) throw new Error("Units do not match");
            var res = x.clone();
            res.value = this(res.value, y.value);
            res.fixPrefix = false;
            return res;
        }
    });
});



var $a30a14fd5f11a878$var$name = "arg";
var $a30a14fd5f11a878$var$dependencies = [
    "typed"
];
var $a30a14fd5f11a878$export$bde3dabbd4699a93 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($a30a14fd5f11a878$var$name, $a30a14fd5f11a878$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Compute the argument of a complex value.
   * For a complex number `a + bi`, the argument is computed as `atan2(b, a)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.arg(x)
   *
   * Examples:
   *
   *    const a = math.complex(2, 2)
   *    math.arg(a) / math.pi          // returns number 0.25
   *
   *    const b = math.complex('2 + 3i')
   *    math.arg(b)                    // returns number 0.982793723247329
   *    math.atan2(3, 2)               // returns number 0.982793723247329
   *
   * See also:
   *
   *    re, im, conj, abs
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            A complex number or array with complex numbers
   * @return {number | BigNumber | Array | Matrix} The argument of x
   */ return typed($a30a14fd5f11a878$var$name, {
        number: function number(x) {
            return Math.atan2(0, x);
        },
        BigNumber: function BigNumber(x) {
            return x.constructor.atan2(0, x);
        },
        Complex: function Complex(x) {
            return x.arg();
        },
        // TODO: implement BigNumber support for function arg
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this);
        }
    });
});




var $76dc85681c6c84ca$var$name = "asech";
var $76dc85681c6c84ca$var$dependencies = [
    "typed",
    "config",
    "Complex",
    "BigNumber"
];
var $76dc85681c6c84ca$export$8eeff5f09afe95bc = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($76dc85681c6c84ca$var$name, $76dc85681c6c84ca$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the hyperbolic arcsecant of a value,
   * defined as `asech(x) = acosh(1/x) = ln(sqrt(1/x^2 - 1) + 1/x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.asech(x)
   *
   * Examples:
   *
   *    math.asech(0.5)       // returns 1.3169578969248166
   *
   * See also:
   *
   *    acsch, acoth
   *
   * @param {number | Complex | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic arcsecant of x
   */ return typed($76dc85681c6c84ca$var$name, {
        number: function number(x) {
            if (x <= 1 && x >= -1 || config.predictable) {
                var xInv = 1 / x;
                if (xInv > 0 || config.predictable) return (0, $d10e9b2ec26dc177$export$cf144300ea173362)(x);
                var ret = Math.sqrt(xInv * xInv - 1);
                return new Complex(Math.log(ret - xInv), Math.PI);
            }
            return new Complex(x, 0).asech();
        },
        Complex: function Complex(x) {
            return x.asech();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x).acosh();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this);
        }
    });
});




var $abae3bfc37d54e73$var$name = "asinh";
var $abae3bfc37d54e73$var$dependencies = [
    "typed"
];
var $abae3bfc37d54e73$export$7278bb4e3c84d46a = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($abae3bfc37d54e73$var$name, $abae3bfc37d54e73$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Calculate the hyperbolic arcsine of a value,
   * defined as `asinh(x) = ln(x + sqrt(x^2 + 1))`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.asinh(x)
   *
   * Examples:
   *
   *    math.asinh(0.5)       // returns 0.48121182505960347
   *
   * See also:
   *
   *    acosh, atanh
   *
   * @param {number | Complex | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic arcsine of x
   */ return typed("asinh", {
        number: (0, $d10e9b2ec26dc177$export$3a027485d3336d8d),
        Complex: function Complex(x) {
            return x.asinh();
        },
        BigNumber: function BigNumber(x) {
            return x.asinh();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since asinh(0) = 0
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this, true);
        }
    });
});



var $b338faf592a8c405$var$name = "atan";
var $b338faf592a8c405$var$dependencies = [
    "typed"
];
var $b338faf592a8c405$export$b87f3a3301a24256 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($b338faf592a8c405$var$name, $b338faf592a8c405$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Calculate the inverse tangent of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.atan(x)
   *
   * Examples:
   *
   *    math.atan(0.5)           // returns number 0.4636476090008061
   *    math.atan(math.tan(1.5)) // returns number 1.5
   *
   *    math.atan(2)             // returns Complex 1.5707963267948966 -1.3169578969248166 i
   *
   * See also:
   *
   *    tan, asin, acos
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x   Function input
   * @return {number | BigNumber | Complex | Array | Matrix} The arc tangent of x
   */ return typed("atan", {
        number: function number(x) {
            return Math.atan(x);
        },
        Complex: function Complex(x) {
            return x.atan();
        },
        BigNumber: function BigNumber(x) {
            return x.atan();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since atan(0) = 0
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this, true);
        }
    });
});




var $86dbb32021258726$var$name = "atanh";
var $86dbb32021258726$var$dependencies = [
    "typed",
    "config",
    "Complex"
];
var $86dbb32021258726$export$c2dbbeab1e5e6195 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($86dbb32021258726$var$name, $86dbb32021258726$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex } = _ref;
    /**
   * Calculate the hyperbolic arctangent of a value,
   * defined as `atanh(x) = ln((1 + x)/(1 - x)) / 2`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.atanh(x)
   *
   * Examples:
   *
   *    math.atanh(0.5)       // returns 0.5493061443340549
   *
   * See also:
   *
   *    acosh, asinh
   *
   * @param {number | Complex | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic arctangent of x
   */ return typed($86dbb32021258726$var$name, {
        number: function number(x) {
            if (x <= 1 && x >= -1 || config.predictable) return (0, $d10e9b2ec26dc177$export$44a1f653c6513db8)(x);
            return new Complex(x, 0).atanh();
        },
        Complex: function Complex(x) {
            return x.atanh();
        },
        BigNumber: function BigNumber(x) {
            return x.atanh();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since atanh(0) = 0
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this, true);
        }
    });
});



var $271b4a230f93869e$var$name = "bignumber";
var $271b4a230f93869e$var$dependencies = [
    "typed",
    "BigNumber"
];
var $271b4a230f93869e$export$1c955ee1b8a97877 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($271b4a230f93869e$var$name, $271b4a230f93869e$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: BigNumber } = _ref;
    /**
   * Create a BigNumber, which can store numbers with arbitrary precision.
   * When a matrix is provided, all elements will be converted to BigNumber.
   *
   * Syntax:
   *
   *    math.bignumber(x)
   *
   * Examples:
   *
   *    0.1 + 0.2                                  // returns number 0.30000000000000004
   *    math.bignumber(0.1) + math.bignumber(0.2)  // returns BigNumber 0.3
   *
   *
   *    7.2e500                                    // returns number Infinity
   *    math.bignumber('7.2e500')                  // returns BigNumber 7.2e500
   *
   * See also:
   *
   *    boolean, complex, index, matrix, string, unit
   *
   * @param {number | string | Fraction | BigNumber | Array | Matrix | boolean | null} [value]  Value for the big number,
   *                                                    0 by default.
   * @returns {BigNumber} The created bignumber
   */ return typed("bignumber", {
        "": function _() {
            return new BigNumber(0);
        },
        number: function number(x) {
            // convert to string to prevent errors in case of >15 digits
            return new BigNumber(x + "");
        },
        string: function string(x) {
            var wordSizeSuffixMatch = x.match(/(0[box][0-9a-fA-F]*)i([0-9]*)/);
            if (wordSizeSuffixMatch) {
                // x has a word size suffix
                var size = wordSizeSuffixMatch[2];
                var n = BigNumber(wordSizeSuffixMatch[1]);
                var twoPowSize = new BigNumber(2).pow(Number(size));
                if (n.gt(twoPowSize.sub(1))) throw new SyntaxError('String "'.concat(x, '" is out of range'));
                var twoPowSizeSubOne = new BigNumber(2).pow(Number(size) - 1);
                if (n.gte(twoPowSizeSubOne)) return n.sub(twoPowSize);
                else return n;
            }
            return new BigNumber(x);
        },
        BigNumber: function BigNumber(x) {
            // we assume a BigNumber is immutable
            return x;
        },
        Fraction: function Fraction(x) {
            return new BigNumber(x.n).div(x.d).times(x.s);
        },
        null: function _null(x) {
            return new BigNumber(0);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this);
        }
    });
});

/**
 * Bitwise and for Bignumbers
 *
 * Special Cases:
 *   N &  n =  N
 *   n &  0 =  0
 *   n & -1 =  n
 *   n &  n =  n
 *   I &  I =  I
 *  -I & -I = -I
 *   I & -I =  0
 *   I &  n =  n
 *   I & -n =  I
 *  -I &  n =  0
 *  -I & -n = -I
 *
 * @param {BigNumber} x
 * @param {BigNumber} y
 * @return {BigNumber} Result of `x` & `y`, is fully precise
 * @private
 */ function $3b8565a47dc4d809$export$94757ce5cf54fec9(x, y) {
    if (x.isFinite() && !x.isInteger() || y.isFinite() && !y.isInteger()) throw new Error("Integers expected in function bitAnd");
    var BigNumber = x.constructor;
    if (x.isNaN() || y.isNaN()) return new BigNumber(NaN);
    if (x.isZero() || y.eq(-1) || x.eq(y)) return x;
    if (y.isZero() || x.eq(-1)) return y;
    if (!x.isFinite() || !y.isFinite()) {
        if (!x.isFinite() && !y.isFinite()) {
            if (x.isNegative() === y.isNegative()) return x;
            return new BigNumber(0);
        }
        if (!x.isFinite()) {
            if (y.isNegative()) return x;
            if (x.isNegative()) return new BigNumber(0);
            return y;
        }
        if (!y.isFinite()) {
            if (x.isNegative()) return y;
            if (y.isNegative()) return new BigNumber(0);
            return x;
        }
    }
    return $3b8565a47dc4d809$export$884842863a0853c4(x, y, function(a, b) {
        return a & b;
    });
}
function $3b8565a47dc4d809$export$2ada53b3c51e9645(x) {
    if (x.isFinite() && !x.isInteger()) throw new Error("Integer expected in function bitNot");
    var BigNumber = x.constructor;
    var prevPrec = BigNumber.precision;
    BigNumber.config({
        precision: 1E9
    });
    var result = x.plus(new BigNumber(1));
    result.s = -result.s || null;
    BigNumber.config({
        precision: prevPrec
    });
    return result;
}
function $3b8565a47dc4d809$export$e43ec6c4cff46d2c(x, y) {
    if (x.isFinite() && !x.isInteger() || y.isFinite() && !y.isInteger()) throw new Error("Integers expected in function bitOr");
    var BigNumber = x.constructor;
    if (x.isNaN() || y.isNaN()) return new BigNumber(NaN);
    var negOne = new BigNumber(-1);
    if (x.isZero() || y.eq(negOne) || x.eq(y)) return y;
    if (y.isZero() || x.eq(negOne)) return x;
    if (!x.isFinite() || !y.isFinite()) {
        if (!x.isFinite() && !x.isNegative() && y.isNegative() || x.isNegative() && !y.isNegative() && !y.isFinite()) return negOne;
        if (x.isNegative() && y.isNegative()) return x.isFinite() ? x : y;
        return x.isFinite() ? y : x;
    }
    return $3b8565a47dc4d809$export$884842863a0853c4(x, y, function(a, b) {
        return a | b;
    });
}
function $3b8565a47dc4d809$export$884842863a0853c4(x, y, func) {
    var BigNumber = x.constructor;
    var xBits, yBits;
    var xSign = +(x.s < 0);
    var ySign = +(y.s < 0);
    if (xSign) {
        xBits = $3b8565a47dc4d809$var$decCoefficientToBinaryString($3b8565a47dc4d809$export$2ada53b3c51e9645(x));
        for(var i = 0; i < xBits.length; ++i)xBits[i] ^= 1;
    } else xBits = $3b8565a47dc4d809$var$decCoefficientToBinaryString(x);
    if (ySign) {
        yBits = $3b8565a47dc4d809$var$decCoefficientToBinaryString($3b8565a47dc4d809$export$2ada53b3c51e9645(y));
        for(var _i = 0; _i < yBits.length; ++_i)yBits[_i] ^= 1;
    } else yBits = $3b8565a47dc4d809$var$decCoefficientToBinaryString(y);
    var minBits, maxBits, minSign;
    if (xBits.length <= yBits.length) {
        minBits = xBits;
        maxBits = yBits;
        minSign = xSign;
    } else {
        minBits = yBits;
        maxBits = xBits;
        minSign = ySign;
    }
    var shortLen = minBits.length;
    var longLen = maxBits.length;
    var expFuncVal = func(xSign, ySign) ^ 1;
    var outVal = new BigNumber(expFuncVal ^ 1);
    var twoPower = new BigNumber(1);
    var two = new BigNumber(2);
    var prevPrec = BigNumber.precision;
    BigNumber.config({
        precision: 1E9
    });
    while(shortLen > 0){
        if (func(minBits[--shortLen], maxBits[--longLen]) === expFuncVal) outVal = outVal.plus(twoPower);
        twoPower = twoPower.times(two);
    }
    while(longLen > 0){
        if (func(minSign, maxBits[--longLen]) === expFuncVal) outVal = outVal.plus(twoPower);
        twoPower = twoPower.times(two);
    }
    BigNumber.config({
        precision: prevPrec
    });
    if (expFuncVal === 0) outVal.s = -outVal.s;
    return outVal;
}
/* Extracted from decimal.js, and edited to specialize. */ function $3b8565a47dc4d809$var$decCoefficientToBinaryString(x) {
    // Convert to string
    var a = x.d; // array with digits
    var r = a[0] + "";
    for(var i = 1; i < a.length; ++i){
        var s = a[i] + "";
        for(var z = 7 - s.length; z--;)s = "0" + s;
        r += s;
    }
    var j = r.length;
    while(r.charAt(j) === "0")j--;
    var xe = x.e;
    var str = r.slice(0, j + 1 || 1);
    var strL = str.length;
    if (xe > 0) {
        if (++xe > strL) {
            // Append zeros.
            xe -= strL;
            while(xe--)str += "0";
        } else if (xe < strL) str = str.slice(0, xe) + "." + str.slice(xe);
    } // Convert from base 10 (decimal) to base 2
    var arr = [
        0
    ];
    for(var _i2 = 0; _i2 < str.length;){
        var arrL = arr.length;
        while(arrL--)arr[arrL] *= 10;
        arr[0] += parseInt(str.charAt(_i2++)); // convert to int
        for(var _j = 0; _j < arr.length; ++_j)if (arr[_j] > 1) {
            if (arr[_j + 1] === null || arr[_j + 1] === undefined) arr[_j + 1] = 0;
            arr[_j + 1] += arr[_j] >> 1;
            arr[_j] &= 1;
        }
    }
    return arr.reverse();
}
function $3b8565a47dc4d809$export$bfcff4501301c191(x, y) {
    if (x.isFinite() && !x.isInteger() || y.isFinite() && !y.isInteger()) throw new Error("Integers expected in function bitXor");
    var BigNumber = x.constructor;
    if (x.isNaN() || y.isNaN()) return new BigNumber(NaN);
    if (x.isZero()) return y;
    if (y.isZero()) return x;
    if (x.eq(y)) return new BigNumber(0);
    var negOne = new BigNumber(-1);
    if (x.eq(negOne)) return $3b8565a47dc4d809$export$2ada53b3c51e9645(y);
    if (y.eq(negOne)) return $3b8565a47dc4d809$export$2ada53b3c51e9645(x);
    if (!x.isFinite() || !y.isFinite()) {
        if (!x.isFinite() && !y.isFinite()) return negOne;
        return new BigNumber(x.isNegative() === y.isNegative() ? Infinity : -Infinity);
    }
    return $3b8565a47dc4d809$export$884842863a0853c4(x, y, function(a, b) {
        return a ^ b;
    });
}
function $3b8565a47dc4d809$export$626dff8098a67b4c(x, y) {
    if (x.isFinite() && !x.isInteger() || y.isFinite() && !y.isInteger()) throw new Error("Integers expected in function leftShift");
    var BigNumber = x.constructor;
    if (x.isNaN() || y.isNaN() || y.isNegative() && !y.isZero()) return new BigNumber(NaN);
    if (x.isZero() || y.isZero()) return x;
    if (!x.isFinite() && !y.isFinite()) return new BigNumber(NaN);
     // Math.pow(2, y) is fully precise for y < 55, and fast
    if (y.lt(55)) return x.times(Math.pow(2, y.toNumber()) + "");
    return x.times(new BigNumber(2).pow(y));
}
function $3b8565a47dc4d809$export$d489c03691bd4cd(x, y) {
    if (x.isFinite() && !x.isInteger() || y.isFinite() && !y.isInteger()) throw new Error("Integers expected in function rightArithShift");
    var BigNumber = x.constructor;
    if (x.isNaN() || y.isNaN() || y.isNegative() && !y.isZero()) return new BigNumber(NaN);
    if (x.isZero() || y.isZero()) return x;
    if (!y.isFinite()) {
        if (x.isNegative()) return new BigNumber(-1);
        if (!x.isFinite()) return new BigNumber(NaN);
        return new BigNumber(0);
    } // Math.pow(2, y) is fully precise for y < 55, and fast
    if (y.lt(55)) return x.div(Math.pow(2, y.toNumber()) + "").floor();
    return x.div(new BigNumber(2).pow(y)).floor();
}





var $ac33a15c81597bf3$var$n1 = "number";
var $ac33a15c81597bf3$var$n2 = "number, number";
function $ac33a15c81597bf3$export$e7607930867bd49a(x, y) {
    if (!(0, $668e051498bf5fa0$export$a287f47fed4544b8)(x) || !(0, $668e051498bf5fa0$export$a287f47fed4544b8)(y)) throw new Error("Integers expected in function bitAnd");
    return x & y;
}
$ac33a15c81597bf3$export$e7607930867bd49a.signature = $ac33a15c81597bf3$var$n2;
function $ac33a15c81597bf3$export$22a2b2a0351218e7(x) {
    if (!(0, $668e051498bf5fa0$export$a287f47fed4544b8)(x)) throw new Error("Integer expected in function bitNot");
    return ~x;
}
$ac33a15c81597bf3$export$22a2b2a0351218e7.signature = $ac33a15c81597bf3$var$n1;
function $ac33a15c81597bf3$export$9aecb772cb5ad1c7(x, y) {
    if (!(0, $668e051498bf5fa0$export$a287f47fed4544b8)(x) || !(0, $668e051498bf5fa0$export$a287f47fed4544b8)(y)) throw new Error("Integers expected in function bitOr");
    return x | y;
}
$ac33a15c81597bf3$export$9aecb772cb5ad1c7.signature = $ac33a15c81597bf3$var$n2;
function $ac33a15c81597bf3$export$2260a44ec1c987dc(x, y) {
    if (!(0, $668e051498bf5fa0$export$a287f47fed4544b8)(x) || !(0, $668e051498bf5fa0$export$a287f47fed4544b8)(y)) throw new Error("Integers expected in function bitXor");
    return x ^ y;
}
$ac33a15c81597bf3$export$2260a44ec1c987dc.signature = $ac33a15c81597bf3$var$n2;
function $ac33a15c81597bf3$export$65c07a47901525ba(x, y) {
    if (!(0, $668e051498bf5fa0$export$a287f47fed4544b8)(x) || !(0, $668e051498bf5fa0$export$a287f47fed4544b8)(y)) throw new Error("Integers expected in function leftShift");
    return x << y;
}
$ac33a15c81597bf3$export$65c07a47901525ba.signature = $ac33a15c81597bf3$var$n2;
function $ac33a15c81597bf3$export$b6d96f775be90000(x, y) {
    if (!(0, $668e051498bf5fa0$export$a287f47fed4544b8)(x) || !(0, $668e051498bf5fa0$export$a287f47fed4544b8)(y)) throw new Error("Integers expected in function rightArithShift");
    return x >> y;
}
$ac33a15c81597bf3$export$b6d96f775be90000.signature = $ac33a15c81597bf3$var$n2;
function $ac33a15c81597bf3$export$2a8d1e3dcede6e47(x, y) {
    if (!(0, $668e051498bf5fa0$export$a287f47fed4544b8)(x) || !(0, $668e051498bf5fa0$export$a287f47fed4544b8)(y)) throw new Error("Integers expected in function rightLogShift");
    return x >>> y;
}
$ac33a15c81597bf3$export$2a8d1e3dcede6e47.signature = $ac33a15c81597bf3$var$n2;


var $0a398a90254a8e91$var$name = "bitNot";
var $0a398a90254a8e91$var$dependencies = [
    "typed"
];
var $0a398a90254a8e91$export$9e7f3c72ca8b5aa = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($0a398a90254a8e91$var$name, $0a398a90254a8e91$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Bitwise NOT value, `~x`.
   * For matrices, the function is evaluated element wise.
   * For units, the function is evaluated on the best prefix base.
   *
   * Syntax:
   *
   *    math.bitNot(x)
   *
   * Examples:
   *
   *    math.bitNot(1)               // returns number -2
   *
   *    math.bitNot([2, -3, 4])      // returns Array [-3, 2, 5]
   *
   * See also:
   *
   *    bitAnd, bitOr, bitXor, leftShift, rightArithShift, rightLogShift
   *
   * @param  {number | BigNumber | Array | Matrix} x Value to not
   * @return {number | BigNumber | Array | Matrix} NOT of `x`
   */ return typed($0a398a90254a8e91$var$name, {
        number: (0, $ac33a15c81597bf3$export$22a2b2a0351218e7),
        BigNumber: (0, $3b8565a47dc4d809$export$2ada53b3c51e9645),
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this);
        }
    });
});



var $c0cb2ed95ed35729$var$name = "boolean";
var $c0cb2ed95ed35729$var$dependencies = [
    "typed"
];
var $c0cb2ed95ed35729$export$3c82aec2d86a5525 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($c0cb2ed95ed35729$var$name, $c0cb2ed95ed35729$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Create a boolean or convert a string or number to a boolean.
   * In case of a number, `true` is returned for non-zero numbers, and `false` in
   * case of zero.
   * Strings can be `'true'` or `'false'`, or can contain a number.
   * When value is a matrix, all elements will be converted to boolean.
   *
   * Syntax:
   *
   *    math.boolean(x)
   *
   * Examples:
   *
   *    math.boolean(0)     // returns false
   *    math.boolean(1)     // returns true
   *    math.boolean(-3)     // returns true
   *    math.boolean('true')     // returns true
   *    math.boolean('false')     // returns false
   *    math.boolean([1, 0, 1, 1])     // returns [true, false, true, true]
   *
   * See also:
   *
   *    bignumber, complex, index, matrix, string, unit
   *
   * @param {string | number | boolean | Array | Matrix | null} value  A value of any type
   * @return {boolean | Array | Matrix} The boolean value
   */ return typed($c0cb2ed95ed35729$var$name, {
        "": function _() {
            return false;
        },
        boolean: function boolean(x) {
            return x;
        },
        number: function number(x) {
            return !!x;
        },
        null: function _null(x) {
            return false;
        },
        BigNumber: function BigNumber(x) {
            return !x.isZero();
        },
        string: function string(x) {
            // try case insensitive
            var lcase = x.toLowerCase();
            if (lcase === "true") return true;
            else if (lcase === "false") return false;
             // test whether value is a valid number
            var num = Number(x);
            if (x !== "" && !isNaN(num)) return !!num;
            throw new Error('Cannot convert "' + x + '" to a boolean');
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this);
        }
    });
});



var $48d9bfb32272e8b1$var$name = "clone";
var $48d9bfb32272e8b1$var$dependencies = [
    "typed"
];
var $48d9bfb32272e8b1$export$39ad70de4044028a = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($48d9bfb32272e8b1$var$name, $48d9bfb32272e8b1$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Clone an object. Will make a deep copy of the data.
   *
   * Syntax:
   *
   *     math.clone(x)
   *
   * Examples:
   *
   *    math.clone(3.5)                   // returns number 3.5
   *    math.clone(math.complex('2-4i') // returns Complex 2 - 4i
   *    math.clone(math.unit(45, 'deg'))  // returns Unit 45 deg
   *    math.clone([[1, 2], [3, 4]])      // returns Array [[1, 2], [3, 4]]
   *    math.clone("hello world")         // returns string "hello world"
   *
   * @param {*} x   Object to be cloned
   * @return {*} A clone of object x
   */ return typed($48d9bfb32272e8b1$var$name, {
        any: (0, $6819694788cbfa38$export$9cd59f9826255e47)
    });
});



/** @param {number} i
 *  @param {number} n
 *  @returns {number} product of i to n
 */ function $dc1c171d547e28ef$export$dbd0f18357df1ddd(i, n) {
    if (n < i) return 1;
    if (n === i) return n;
    var half = n + i >> 1; // divide (n + i) by 2 and truncate to integer
    return $dc1c171d547e28ef$export$dbd0f18357df1ddd(i, half) * $dc1c171d547e28ef$export$dbd0f18357df1ddd(half + 1, n);
}


function $3ea0cee821b393d1$export$2a122d28e37477a2(n, k) {
    if (!(0, $668e051498bf5fa0$export$a287f47fed4544b8)(n) || n < 0) throw new TypeError("Positive integer value expected in function combinations");
    if (!(0, $668e051498bf5fa0$export$a287f47fed4544b8)(k) || k < 0) throw new TypeError("Positive integer value expected in function combinations");
    if (k > n) throw new TypeError("k must be less than or equal to n");
    var nMinusk = n - k;
    var answer = 1;
    var firstnumerator = k < nMinusk ? nMinusk + 1 : k + 1;
    var nextdivisor = 2;
    var lastdivisor = k < nMinusk ? k : nMinusk; // balance multiplications and divisions to try to keep intermediate values
    // in exact-integer range as long as possible
    for(var nextnumerator = firstnumerator; nextnumerator <= n; ++nextnumerator){
        answer *= nextnumerator;
        while(nextdivisor <= lastdivisor && answer % nextdivisor === 0){
            answer /= nextdivisor;
            ++nextdivisor;
        }
    } // for big n, k, floating point may have caused weirdness in remainder
    if (nextdivisor <= lastdivisor) answer /= (0, $dc1c171d547e28ef$export$dbd0f18357df1ddd)(nextdivisor, lastdivisor);
    return answer;
}
$3ea0cee821b393d1$export$2a122d28e37477a2.signature = "number, number";


var $cfe9f2c4c826b621$var$name = "combinations";
var $cfe9f2c4c826b621$var$dependencies = [
    "typed"
];
var $cfe9f2c4c826b621$export$63e3129a196da23d = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($cfe9f2c4c826b621$var$name, $cfe9f2c4c826b621$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Compute the number of ways of picking `k` unordered outcomes from `n`
   * possibilities.
   *
   * Combinations only takes integer arguments.
   * The following condition must be enforced: k <= n.
   *
   * Syntax:
   *
   *     math.combinations(n, k)
   *
   * Examples:
   *
   *    math.combinations(7, 5) // returns 21
   *
   * See also:
   *
   *    combinationsWithRep, permutations, factorial
   *
   * @param {number | BigNumber} n    Total number of objects in the set
   * @param {number | BigNumber} k    Number of objects in the subset
   * @return {number | BigNumber}     Number of possible combinations.
   */ return typed($cfe9f2c4c826b621$var$name, {
        "number, number": (0, $3ea0cee821b393d1$export$2a122d28e37477a2),
        "BigNumber, BigNumber": function BigNumberBigNumber(n, k) {
            var BigNumber = n.constructor;
            var result, i;
            var nMinusk = n.minus(k);
            var one = new BigNumber(1);
            if (!$cfe9f2c4c826b621$var$isPositiveInteger(n) || !$cfe9f2c4c826b621$var$isPositiveInteger(k)) throw new TypeError("Positive integer value expected in function combinations");
            if (k.gt(n)) throw new TypeError("k must be less than n in function combinations");
            result = one;
            if (k.lt(nMinusk)) for(i = one; i.lte(nMinusk); i = i.plus(one))result = result.times(k.plus(i)).dividedBy(i);
            else for(i = one; i.lte(k); i = i.plus(one))result = result.times(nMinusk.plus(i)).dividedBy(i);
            return result;
        } // TODO: implement support for collection in combinations
    });
});
/**
 * Test whether BigNumber n is a positive integer
 * @param {BigNumber} n
 * @returns {boolean} isPositiveInteger
 */ function $cfe9f2c4c826b621$var$isPositiveInteger(n) {
    return n.isInteger() && n.gte(0);
}



var $5c9a405c8b050b24$var$name = "complex";
var $5c9a405c8b050b24$var$dependencies = [
    "typed",
    "Complex"
];
var $5c9a405c8b050b24$export$82a905fb6826da0d = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($5c9a405c8b050b24$var$name, $5c9a405c8b050b24$var$dependencies, (_ref)=>{
    var { typed: typed, Complex: Complex } = _ref;
    /**
   * Create a complex value or convert a value to a complex value.
   *
   * Syntax:
   *
   *     math.complex()                           // creates a complex value with zero
   *                                              // as real and imaginary part.
   *     math.complex(re : number, im : string)   // creates a complex value with provided
   *                                              // values for real and imaginary part.
   *     math.complex(re : number)                // creates a complex value with provided
   *                                              // real value and zero imaginary part.
   *     math.complex(complex : Complex)          // clones the provided complex value.
   *     math.complex(arg : string)               // parses a string into a complex value.
   *     math.complex(array : Array)              // converts the elements of the array
   *                                              // or matrix element wise into a
   *                                              // complex value.
   *     math.complex({re: number, im: number})   // creates a complex value with provided
   *                                              // values for real an imaginary part.
   *     math.complex({r: number, phi: number})   // creates a complex value with provided
   *                                              // polar coordinates
   *
   * Examples:
   *
   *    const a = math.complex(3, -4)     // a = Complex 3 - 4i
   *    a.re = 5                          // a = Complex 5 - 4i
   *    const i = a.im                    // Number -4
   *    const b = math.complex('2 + 6i')  // Complex 2 + 6i
   *    const c = math.complex()          // Complex 0 + 0i
   *    const d = math.add(a, b)          // Complex 5 + 2i
   *
   * See also:
   *
   *    bignumber, boolean, index, matrix, number, string, unit
   *
   * @param {* | Array | Matrix} [args]
   *            Arguments specifying the real and imaginary part of the complex number
   * @return {Complex | Array | Matrix} Returns a complex value
   */ return typed("complex", {
        "": function _() {
            return Complex.ZERO;
        },
        number: function number(x) {
            return new Complex(x, 0);
        },
        "number, number": function numberNumber(re, im) {
            return new Complex(re, im);
        },
        // TODO: this signature should be redundant
        "BigNumber, BigNumber": function BigNumberBigNumber(re, im) {
            return new Complex(re.toNumber(), im.toNumber());
        },
        Fraction: function Fraction(x) {
            return new Complex(x.valueOf(), 0);
        },
        Complex: function Complex(x) {
            return x.clone();
        },
        string: function string(x) {
            return Complex(x); // for example '2 + 3i'
        },
        null: function _null(x) {
            return Complex(0);
        },
        Object: function Object(x) {
            if ("re" in x && "im" in x) return new Complex(x.re, x.im);
            if ("r" in x && "phi" in x || "abs" in x && "arg" in x) return new Complex(x);
            throw new Error("Expected object with properties (re and im) or (r and phi) or (abs and arg)");
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this);
        }
    });
});



var $a0461c2ebb3582a9$var$name = "conj";
var $a0461c2ebb3582a9$var$dependencies = [
    "typed"
];
var $a0461c2ebb3582a9$export$af5efe8ad97f01a2 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($a0461c2ebb3582a9$var$name, $a0461c2ebb3582a9$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Compute the complex conjugate of a complex value.
   * If `x = a+bi`, the complex conjugate of `x` is `a - bi`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.conj(x)
   *
   * Examples:
   *
   *    math.conj(math.complex('2 + 3i'))  // returns Complex 2 - 3i
   *    math.conj(math.complex('2 - 3i'))  // returns Complex 2 + 3i
   *    math.conj(math.complex('-5.2i'))  // returns Complex 5.2i
   *
   * See also:
   *
   *    re, im, arg, abs
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            A complex number or array with complex numbers
   * @return {number | BigNumber | Complex | Array | Matrix}
   *            The complex conjugate of x
   */ return typed($a0461c2ebb3582a9$var$name, {
        number: function number(x) {
            return x;
        },
        BigNumber: function BigNumber(x) {
            return x;
        },
        Complex: function Complex(x) {
            return x.conjugate();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this);
        }
    });
});




var $d9aee101e2c18cef$var$name = "cosh";
var $d9aee101e2c18cef$var$dependencies = [
    "typed"
];
var $d9aee101e2c18cef$export$63d35097da636c02 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($d9aee101e2c18cef$var$name, $d9aee101e2c18cef$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Calculate the hyperbolic cosine of a value,
   * defined as `cosh(x) = 1/2 * (exp(x) + exp(-x))`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.cosh(x)
   *
   * Examples:
   *
   *    math.cosh(0.5)       // returns number 1.1276259652063807
   *
   * See also:
   *
   *    sinh, tanh
   *
   * @param {number | BigNumber | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | BigNumber | Complex | Array | Matrix} Hyperbolic cosine of x
   */ return typed($d9aee101e2c18cef$var$name, {
        number: (0, $668e051498bf5fa0$export$2e2fd1ad24e4d350),
        Complex: function Complex(x) {
            return x.cosh();
        },
        BigNumber: function BigNumber(x) {
            return x.cosh();
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function cosh is no angle");
            return this(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this);
        }
    });
});




var $0bf854e4b4ccb587$var$name = "coth";
var $0bf854e4b4ccb587$var$dependencies = [
    "typed",
    "BigNumber"
];
var $0bf854e4b4ccb587$export$3f7f9b5400315e6a = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($0bf854e4b4ccb587$var$name, $0bf854e4b4ccb587$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the hyperbolic cotangent of a value,
   * defined as `coth(x) = 1 / tanh(x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.coth(x)
   *
   * Examples:
   *
   *    // coth(x) = 1 / tanh(x)
   *    math.coth(2)         // returns 1.0373147207275482
   *    1 / math.tanh(2)     // returns 1.0373147207275482
   *
   * See also:
   *
   *    sinh, tanh, cosh
   *
   * @param {number | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic cotangent of x
   */ return typed($0bf854e4b4ccb587$var$name, {
        number: (0, $d10e9b2ec26dc177$export$925affe88b2512fc),
        Complex: function Complex(x) {
            return x.coth();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x.tanh());
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function coth is no angle");
            return this(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this);
        }
    });
});




var $5fd48631a1cf5cff$var$name = "csc";
var $5fd48631a1cf5cff$var$dependencies = [
    "typed",
    "BigNumber"
];
var $5fd48631a1cf5cff$export$a0beb298aa7a2962 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($5fd48631a1cf5cff$var$name, $5fd48631a1cf5cff$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the cosecant of a value, defined as `csc(x) = 1/sin(x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.csc(x)
   *
   * Examples:
   *
   *    math.csc(2)      // returns number 1.099750170294617
   *    1 / math.sin(2)  // returns number 1.099750170294617
   *
   * See also:
   *
   *    sin, sec, cot
   *
   * @param {number | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Cosecant of x
   */ return typed($5fd48631a1cf5cff$var$name, {
        number: (0, $d10e9b2ec26dc177$export$5a8409ad16e318b2),
        Complex: function Complex(x) {
            return x.csc();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x.sin());
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function csc is no angle");
            return this(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this);
        }
    });
});




var $11475161a75d7c01$var$name = "cube";
var $11475161a75d7c01$var$dependencies = [
    "typed"
];
var $11475161a75d7c01$export$ce223d612b94804b = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($11475161a75d7c01$var$name, $11475161a75d7c01$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Compute the cube of a value, `x * x * x`.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.cube(x)
   *
   * Examples:
   *
   *    math.cube(2)            // returns number 8
   *    math.pow(2, 3)          // returns number 8
   *    math.cube(4)            // returns number 64
   *    4 * 4 * 4               // returns number 64
   *
   *    math.cube([1, 2, 3, 4]) // returns Array [1, 8, 27, 64]
   *
   * See also:
   *
   *    multiply, square, pow, cbrt
   *
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix | Unit} x  Number for which to calculate the cube
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix | Unit} Cube of x
   */ return typed($11475161a75d7c01$var$name, {
        number: (0, $4b37ed316f05dd33$export$9505f0b39acd04c),
        Complex: function Complex(x) {
            return x.mul(x).mul(x); // Is faster than pow(x, 3)
        },
        BigNumber: function BigNumber(x) {
            return x.times(x).times(x);
        },
        Fraction: function Fraction(x) {
            return x.pow(3); // Is faster than mul()mul()mul()
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since cube(0) = 0
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this, true);
        },
        Unit: function Unit(x) {
            return x.pow(3);
        }
    });
});

/**
 * Compares two BigNumbers.
 * @param {BigNumber} x       First value to compare
 * @param {BigNumber} y       Second value to compare
 * @param {number} [epsilon]  The maximum relative difference between x and y
 *                            If epsilon is undefined or null, the function will
 *                            test whether x and y are exactly equal.
 * @return {boolean} whether the two numbers are nearly equal
 */ function $53e0635127e7c5a0$export$6f3989c6ecc04081(x, y, epsilon) {
    // if epsilon is null or undefined, test whether x and y are exactly equal
    if (epsilon === null || epsilon === undefined) return x.eq(y);
     // use "==" operator, handles infinities
    if (x.eq(y)) return true;
     // NaN
    if (x.isNaN() || y.isNaN()) return false;
     // at this point x and y should be finite
    if (x.isFinite() && y.isFinite()) {
        // check numbers are very close, needed when comparing numbers near zero
        var diff = x.minus(y).abs();
        if (diff.isZero()) return true;
        else {
            // use relative error
            var max = x.constructor.max(x.abs(), y.abs());
            return diff.lte(max.times(epsilon));
        }
    } // Infinite and Number or negative Infinite and positive Infinite cases
    return false;
}





function $7f39e80f40f7cc00$export$852c8261c9f393e0(x, y, epsilon) {
    return (0, $668e051498bf5fa0$export$6f3989c6ecc04081)(x.re, y.re, epsilon) && (0, $668e051498bf5fa0$export$6f3989c6ecc04081)(x.im, y.im, epsilon);
}


var $a8e3599cee836598$var$name = "equalScalar";
var $a8e3599cee836598$var$dependencies = [
    "typed",
    "config"
];
var $a8e3599cee836598$export$c370bab664a0c9a2 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($a8e3599cee836598$var$name, $a8e3599cee836598$var$dependencies, (_ref)=>{
    var { typed: typed, config: config } = _ref;
    /**
   * Test whether two scalar values are nearly equal.
   *
   * @param  {number | BigNumber | Fraction | boolean | Complex | Unit} x   First value to compare
   * @param  {number | BigNumber | Fraction | boolean | Complex} y          Second value to compare
   * @return {boolean}                                                  Returns true when the compared values are equal, else returns false
   * @private
   */ return typed($a8e3599cee836598$var$name, {
        "boolean, boolean": function booleanBoolean(x, y) {
            return x === y;
        },
        "number, number": function numberNumber(x, y) {
            return (0, $668e051498bf5fa0$export$6f3989c6ecc04081)(x, y, config.epsilon);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.eq(y) || (0, $53e0635127e7c5a0$export$6f3989c6ecc04081)(x, y, config.epsilon);
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.equals(y);
        },
        "Complex, Complex": function ComplexComplex(x, y) {
            return (0, $7f39e80f40f7cc00$export$852c8261c9f393e0)(x, y, config.epsilon);
        },
        "Unit, Unit": function UnitUnit(x, y) {
            if (!x.equalBase(y)) throw new Error("Cannot compare units with different base");
            return this(x.value, y.value);
        }
    });
});
var $a8e3599cee836598$export$55f78fcc2979d648 = (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($a8e3599cee836598$var$name, [
    "typed",
    "config"
], (_ref2)=>{
    var { typed: typed, config: config } = _ref2;
    return typed($a8e3599cee836598$var$name, {
        "number, number": function numberNumber(x, y) {
            return (0, $668e051498bf5fa0$export$6f3989c6ecc04081)(x, y, config.epsilon);
        }
    });
});

/* eslint-disable no-loss-of-precision */ 


var $cb08105b913df155$var$name = "erf";
var $cb08105b913df155$var$dependencies = [
    "typed"
];
var $cb08105b913df155$export$470dfa326d6cbdf5 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($cb08105b913df155$var$name, $cb08105b913df155$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Compute the erf function of a value using a rational Chebyshev
   * approximations for different intervals of x.
   *
   * This is a translation of W. J. Cody's Fortran implementation from 1987
   * ( https://www.netlib.org/specfun/erf ). See the AMS publication
   * "Rational Chebyshev Approximations for the Error Function" by W. J. Cody
   * for an explanation of this process.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.erf(x)
   *
   * Examples:
   *
   *    math.erf(0.2)    // returns 0.22270258921047847
   *    math.erf(-0.5)   // returns -0.5204998778130465
   *    math.erf(4)      // returns 0.9999999845827421
   *
   * @param {number | Array | Matrix} x   A real number
   * @return {number | Array | Matrix}    The erf of `x`
   */ return typed("name", {
        number: function number(x) {
            var y = Math.abs(x);
            if (y >= $cb08105b913df155$var$MAX_NUM) return (0, $668e051498bf5fa0$export$c5552dfdbc7cec71)(x);
            if (y <= $cb08105b913df155$var$THRESH) return (0, $668e051498bf5fa0$export$c5552dfdbc7cec71)(x) * erf1(y);
            if (y <= 4.0) return (0, $668e051498bf5fa0$export$c5552dfdbc7cec71)(x) * (1 - erfc2(y));
            return (0, $668e051498bf5fa0$export$c5552dfdbc7cec71)(x) * (1 - erfc3(y));
        },
        "Array | Matrix": function ArrayMatrix(n) {
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(n, this);
        } // TODO: For complex numbers, use the approximation for the Faddeeva function
    });
    /**
   * Approximates the error function erf() for x <= 0.46875 using this function:
   *               n
   * erf(x) = x * sum (p_j * x^(2j)) / (q_j * x^(2j))
   *              j=0
   */ function erf1(y) {
        var ysq = y * y;
        var xnum = $cb08105b913df155$var$P[0][4] * ysq;
        var xden = ysq;
        var i;
        for(i = 0; i < 3; i += 1){
            xnum = (xnum + $cb08105b913df155$var$P[0][i]) * ysq;
            xden = (xden + $cb08105b913df155$var$Q[0][i]) * ysq;
        }
        return y * (xnum + $cb08105b913df155$var$P[0][3]) / (xden + $cb08105b913df155$var$Q[0][3]);
    }
    /**
   * Approximates the complement of the error function erfc() for
   * 0.46875 <= x <= 4.0 using this function:
   *                       n
   * erfc(x) = e^(-x^2) * sum (p_j * x^j) / (q_j * x^j)
   *                      j=0
   */ function erfc2(y) {
        var xnum = $cb08105b913df155$var$P[1][8] * y;
        var xden = y;
        var i;
        for(i = 0; i < 7; i += 1){
            xnum = (xnum + $cb08105b913df155$var$P[1][i]) * y;
            xden = (xden + $cb08105b913df155$var$Q[1][i]) * y;
        }
        var result = (xnum + $cb08105b913df155$var$P[1][7]) / (xden + $cb08105b913df155$var$Q[1][7]);
        var ysq = parseInt(y * 16) / 16;
        var del = (y - ysq) * (y + ysq);
        return Math.exp(-ysq * ysq) * Math.exp(-del) * result;
    }
    /**
   * Approximates the complement of the error function erfc() for x > 4.0 using
   * this function:
   *
   * erfc(x) = (e^(-x^2) / x) * [ 1/sqrt(pi) +
   *               n
   *    1/(x^2) * sum (p_j * x^(-2j)) / (q_j * x^(-2j)) ]
   *              j=0
   */ function erfc3(y) {
        var ysq = 1 / (y * y);
        var xnum = $cb08105b913df155$var$P[2][5] * ysq;
        var xden = ysq;
        var i;
        for(i = 0; i < 4; i += 1){
            xnum = (xnum + $cb08105b913df155$var$P[2][i]) * ysq;
            xden = (xden + $cb08105b913df155$var$Q[2][i]) * ysq;
        }
        var result = ysq * (xnum + $cb08105b913df155$var$P[2][4]) / (xden + $cb08105b913df155$var$Q[2][4]);
        result = ($cb08105b913df155$var$SQRPI - result) / y;
        ysq = parseInt(y * 16) / 16;
        var del = (y - ysq) * (y + ysq);
        return Math.exp(-ysq * ysq) * Math.exp(-del) * result;
    }
});
/**
 * Upper bound for the first approximation interval, 0 <= x <= THRESH
 * @constant
 */ var $cb08105b913df155$var$THRESH = 0.46875;
/**
 * Constant used by W. J. Cody's Fortran77 implementation to denote sqrt(pi)
 * @constant
 */ var $cb08105b913df155$var$SQRPI = 5.6418958354775628695e-1;
/**
 * Coefficients for each term of the numerator sum (p_j) for each approximation
 * interval (see W. J. Cody's paper for more details)
 * @constant
 */ var $cb08105b913df155$var$P = [
    [
        3.16112374387056560e00,
        1.13864154151050156e02,
        3.77485237685302021e02,
        3.20937758913846947e03,
        1.85777706184603153e-1
    ],
    [
        5.64188496988670089e-1,
        8.88314979438837594e00,
        6.61191906371416295e01,
        2.98635138197400131e02,
        8.81952221241769090e02,
        1.71204761263407058e03,
        2.05107837782607147e03,
        1.23033935479799725e03,
        2.15311535474403846e-8
    ],
    [
        3.05326634961232344e-1,
        3.60344899949804439e-1,
        1.25781726111229246e-1,
        1.60837851487422766e-2,
        6.58749161529837803e-4,
        1.63153871373020978e-2
    ]
];
/**
 * Coefficients for each term of the denominator sum (q_j) for each approximation
 * interval (see W. J. Cody's paper for more details)
 * @constant
 */ var $cb08105b913df155$var$Q = [
    [
        2.36012909523441209e01,
        2.44024637934444173e02,
        1.28261652607737228e03,
        2.84423683343917062e03
    ],
    [
        1.57449261107098347e01,
        1.17693950891312499e02,
        5.37181101862009858e02,
        1.62138957456669019e03,
        3.29079923573345963e03,
        4.36261909014324716e03,
        3.43936767414372164e03,
        1.23033935480374942e03
    ],
    [
        2.56852019228982242e00,
        1.87295284992346047e00,
        5.27905102951428412e-1,
        6.05183413124413191e-2,
        2.33520497626869185e-3
    ]
];
/**
 * Maximum/minimum safe numbers to input to erf() (in ES6+, this number is
 * Number.[MAX|MIN]_SAFE_INTEGER). erf() for all numbers beyond this limit will
 * return 1
 */ var $cb08105b913df155$var$MAX_NUM = Math.pow(2, 53);




var $b9e212bd9bf743a0$var$name = "exp";
var $b9e212bd9bf743a0$var$dependencies = [
    "typed"
];
var $b9e212bd9bf743a0$export$95a576617fd015b1 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($b9e212bd9bf743a0$var$name, $b9e212bd9bf743a0$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Calculate the exponent of a value.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.exp(x)
   *
   * Examples:
   *
   *    math.exp(2)                  // returns number 7.3890560989306495
   *    math.pow(math.e, 2)          // returns number 7.3890560989306495
   *    math.log(math.exp(2))        // returns number 2
   *
   *    math.exp([1, 2, 3])
   *    // returns Array [
   *    //   2.718281828459045,
   *    //   7.3890560989306495,
   *    //   20.085536923187668
   *    // ]
   *
   * See also:
   *
   *    expm1, log, pow
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x  A number or matrix to exponentiate
   * @return {number | BigNumber | Complex | Array | Matrix} Exponent of `x`
   */ return typed($b9e212bd9bf743a0$var$name, {
        number: (0, $4b37ed316f05dd33$export$a33b288b35672fe5),
        Complex: function Complex(x) {
            return x.exp();
        },
        BigNumber: function BigNumber(x) {
            return x.exp();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // TODO: exp(sparse) should return a dense matrix since exp(0)==1
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this);
        }
    });
});




var $b1af9d874f4fec41$var$name = "expm1";
var $b1af9d874f4fec41$var$dependencies = [
    "typed",
    "Complex"
];
var $b1af9d874f4fec41$export$2b203b63f664bab3 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($b1af9d874f4fec41$var$name, $b1af9d874f4fec41$var$dependencies, (_ref)=>{
    var { typed: typed, Complex: _Complex } = _ref;
    /**
   * Calculate the value of subtracting 1 from the exponential value.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.expm1(x)
   *
   * Examples:
   *
   *    math.expm1(2)                      // returns number 6.38905609893065
   *    math.pow(math.e, 2) - 1            // returns number 6.3890560989306495
   *    math.log(math.expm1(2) + 1)        // returns number 2
   *
   *    math.expm1([1, 2, 3])
   *    // returns Array [
   *    //   1.718281828459045,
   *    //   6.3890560989306495,
   *    //   19.085536923187668
   *    // ]
   *
   * See also:
   *
   *    exp, log, pow
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x  A number or matrix to apply expm1
   * @return {number | BigNumber | Complex | Array | Matrix} Exponent of `x`
   */ return typed($b1af9d874f4fec41$var$name, {
        number: (0, $4b37ed316f05dd33$export$756d0c010cecc6c3),
        Complex: function Complex(x) {
            var r = Math.exp(x.re);
            return new _Complex(r * Math.cos(x.im) - 1, r * Math.sin(x.im));
        },
        BigNumber: function BigNumber(x) {
            return x.exp().minus(1);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this);
        }
    });
});




var $d1603a9aa2eb6ada$var$name = "filter";
var $d1603a9aa2eb6ada$var$dependencies = [
    "typed"
];
var $d1603a9aa2eb6ada$export$5d81789ff4aeccdf = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($d1603a9aa2eb6ada$var$name, $d1603a9aa2eb6ada$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Filter the items in an array or one dimensional matrix.
   *
   * Syntax:
   *
   *    math.filter(x, test)
   *
   * Examples:
   *
   *    function isPositive (x) {
   *      return x > 0
   *    }
   *    math.filter([6, -2, -1, 4, 3], isPositive) // returns [6, 4, 3]
   *
   *    math.filter(["23", "foo", "100", "55", "bar"], /[0-9]+/) // returns ["23", "100", "55"]
   *
   * See also:
   *
   *    forEach, map, sort
   *
   * @param {Matrix | Array} x    A one dimensional matrix or array to filter
   * @param {Function | RegExp} test
   *        A function or regular expression to test items.
   *        All entries for which `test` returns true are returned.
   *        When `test` is a function, it is invoked with three parameters:
   *        the value of the element, the index of the element, and the
   *        matrix/array being traversed. The function must return a boolean.
   * @return {Matrix | Array} Returns the filtered matrix.
   */ return typed("filter", {
        "Array, function": $d1603a9aa2eb6ada$var$_filterCallback,
        "Matrix, function": function MatrixFunction(x, test) {
            return x.create($d1603a9aa2eb6ada$var$_filterCallback(x.toArray(), test));
        },
        "Array, RegExp": (0, $a14a10567870d913$export$322859471e81229d),
        "Matrix, RegExp": function MatrixRegExp(x, test) {
            return x.create((0, $a14a10567870d913$export$322859471e81229d)(x.toArray(), test));
        }
    });
});
/**
 * Filter values in a callback given a callback function
 * @param {Array} x
 * @param {Function} callback
 * @return {Array} Returns the filtered array
 * @private
 */ function $d1603a9aa2eb6ada$var$_filterCallback(x, callback) {
    // figure out what number of arguments the callback function expects
    var args = (0, $458cc793bcf3a223$export$6c00fba23f8c91a7)(callback);
    return (0, $a14a10567870d913$export$3dea766d36a8935f)(x, function(value, index, array) {
        // invoke the callback function with the right number of arguments
        if (args === 1) return callback(value);
        else if (args === 2) return callback(value, [
            index
        ]);
        else // 3 or -1
        return callback(value, [
            index
        ], array);
    });
}




var $f9ad3cb7a0d84c1d$var$name = "forEach";
var $f9ad3cb7a0d84c1d$var$dependencies = [
    "typed"
];
var $f9ad3cb7a0d84c1d$export$a5218987e0811e05 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($f9ad3cb7a0d84c1d$var$name, $f9ad3cb7a0d84c1d$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Iterate over all elements of a matrix/array, and executes the given callback function.
   *
   * Syntax:
   *
   *    math.forEach(x, callback)
   *
   * Examples:
   *
   *    math.forEach([1, 2, 3], function(value) {
   *      console.log(value)
   *    })
   *    // outputs 1, 2, 3
   *
   * See also:
   *
   *    filter, map, sort
   *
   * @param {Matrix | Array} x    The matrix to iterate on.
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix/array being traversed.
   */ return typed($f9ad3cb7a0d84c1d$var$name, {
        "Array, function": $f9ad3cb7a0d84c1d$var$_forEach,
        "Matrix, function": function MatrixFunction(x, callback) {
            return x.forEach(callback);
        }
    });
});
/**
 * forEach for a multi dimensional array
 * @param {Array} array
 * @param {Function} callback
 * @private
 */ function $f9ad3cb7a0d84c1d$var$_forEach(array, callback) {
    // figure out what number of arguments the callback function expects
    var args = (0, $458cc793bcf3a223$export$6c00fba23f8c91a7)(callback);
    var recurse = function recurse(value, index) {
        if (Array.isArray(value)) (0, $a14a10567870d913$export$4b80e395e36b5a56)(value, function(child, i) {
            // we create a copy of the index array and append the new index value
            recurse(child, index.concat(i));
        });
        else {
            // invoke the callback function with the right number of arguments
            if (args === 1) callback(value);
            else if (args === 2) callback(value, index);
            else // 3 or -1
            callback(value, index, array);
        }
    };
    recurse(array, []);
}



var $ed78932878972773$var$name = "format";
var $ed78932878972773$var$dependencies = [
    "typed"
];
var $ed78932878972773$export$abf0d9399b60f9bb = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($ed78932878972773$var$name, $ed78932878972773$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Format a value of any type into a string.
   *
   * Syntax:
   *
   *    math.format(value)
   *    math.format(value, options)
   *    math.format(value, precision)
   *    math.format(value, callback)
   *
   * Where:
   *
   *  - `value: *`
   *    The value to be formatted
   *  - `options: Object`
   *    An object with formatting options. Available options:
   *    - `notation: string`
   *      Number notation. Choose from:
   *      - 'fixed'
   *        Always use regular number notation.
   *        For example '123.40' and '14000000'
   *      - 'exponential'
   *        Always use exponential notation.
   *        For example '1.234e+2' and '1.4e+7'
   *      - 'engineering'
   *        Always use engineering notation: always have exponential notation,
   *        and select the exponent to be a multiple of 3.
   *        For example '123.4e+0' and '14.0e+6'
   *      - 'auto' (default)
   *        Regular number notation for numbers having an absolute value between
   *        `lower` and `upper` bounds, and uses exponential notation elsewhere.
   *        Lower bound is included, upper bound is excluded.
   *        For example '123.4' and '1.4e7'.
   *      - 'bin', 'oct, or 'hex'
   *        Format the number using binary, octal, or hexadecimal notation.
   *        For example '0b1101' and '0x10fe'.
   *    - `wordSize: number`
   *      The word size in bits to use for formatting in binary, octal, or
   *      hexadecimal notation. To be used only with 'bin', 'oct', or 'hex'
   *      values for 'notation' option. When this option is defined the value
   *      is formatted as a signed twos complement integer of the given word
   *      size and the size suffix is appended to the output.
   *      For example format(-1, {notation: 'hex', wordSize: 8}) === '0xffi8'.
   *      Default value is undefined.
   *    - `precision: number`
   *      Limit the number of digits of the formatted value.
   *      For regular numbers, must be a number between 0 and 16.
   *      For bignumbers, the maximum depends on the configured precision,
   *      see function `config()`.
   *      In case of notations 'exponential', 'engineering', and 'auto', `precision`
   *      defines the total number of significant digits returned.
   *      In case of notation 'fixed', `precision` defines the number of
   *      significant digits after the decimal point.
   *      `precision` is undefined by default.
   *    - `lowerExp: number`
   *      Exponent determining the lower boundary for formatting a value with
   *      an exponent when `notation='auto`. Default value is `-3`.
   *    - `upperExp: number`
   *      Exponent determining the upper boundary for formatting a value with
   *      an exponent when `notation='auto`. Default value is `5`.
   *    - `fraction: string`. Available values: 'ratio' (default) or 'decimal'.
   *      For example `format(fraction(1, 3))` will output '1/3' when 'ratio' is
   *      configured, and will output `0.(3)` when 'decimal' is configured.
   *    - `truncate: number`. Specifies the maximum allowed length of the
   *      returned string. If it would have been longer, the excess characters
   *      are deleted and replaced with `'...'`.
   * - `callback: function`
   *   A custom formatting function, invoked for all numeric elements in `value`,
   *   for example all elements of a matrix, or the real and imaginary
   *   parts of a complex number. This callback can be used to override the
   *   built-in numeric notation with any type of formatting. Function `callback`
   *   is called with `value` as parameter and must return a string.
   *
   * When `value` is an Object:
   *
   * - When the object contains a property `format` being a function, this function
   *   is invoked as `value.format(options)` and the result is returned.
   * - When the object has its own `toString` method, this method is invoked
   *   and the result is returned.
   * - In other cases the function will loop over all object properties and
   *   return JSON object notation like '{"a": 2, "b": 3}'.
   *
   * When value is a function:
   *
   * - When the function has a property `syntax`, it returns this
   *   syntax description.
   * - In other cases, a string `'function'` is returned.
   *
   * Examples:
   *
   *    math.format(6.4)                                        // returns '6.4'
   *    math.format(1240000)                                    // returns '1.24e6'
   *    math.format(1/3)                                        // returns '0.3333333333333333'
   *    math.format(1/3, 3)                                     // returns '0.333'
   *    math.format(21385, 2)                                   // returns '21000'
   *    math.format(12e8, {notation: 'fixed'})                  // returns '1200000000'
   *    math.format(2.3,  {notation: 'fixed', precision: 4})    // returns '2.3000'
   *    math.format(52.8, {notation: 'exponential'})            // returns '5.28e+1'
   *    math.format(12400,{notation: 'engineering'})            // returns '12.400e+3'
   *    math.format(2000, {lowerExp: -2, upperExp: 2})          // returns '2e+3'
   *
   *    function formatCurrency(value) {
   *      // return currency notation with two digits:
   *      return '$' + value.toFixed(2)
   *
   *      // you could also use math.format inside the callback:
   *      // return '$' + math.format(value, {notation: 'fixed', precision: 2})
   *    }
   *    math.format([2.1, 3, 0.016], formatCurrency)            // returns '[$2.10, $3.00, $0.02]'
   *
   * See also:
   *
   *    print
   *
   * @param {*} value                               Value to be stringified
   * @param {Object | Function | number} [options]  Formatting options
   * @return {string} The formatted value
   */ return typed($ed78932878972773$var$name, {
        any: (0, $b94963e97c376b6d$export$d9468344d3651243),
        "any, Object | function | number": (0, $b94963e97c376b6d$export$d9468344d3651243)
    });
});




var $cf628c4622ecc418$var$name = "getMatrixDataType";
var $cf628c4622ecc418$var$dependencies = [
    "typed"
];
var $cf628c4622ecc418$export$b83055c9a38abe3c = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($cf628c4622ecc418$var$name, $cf628c4622ecc418$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Find the data type of all elements in a matrix or array,
   * for example 'number' if all items are a number and 'Complex' if all values
   * are complex numbers.
   * If a matrix contains more than one data type, it will return 'mixed'.
   *
   * Syntax:
   *
   *    math.getMatrixDataType(x)
   *
   * Examples:
   *
   *    const x = [ [1, 2, 3], [4, 5, 6] ]
   *    const mixedX = [ [1, true], [2, 3] ]
   *    const fractionX = [ [math.fraction(1, 3)], [math.fraction(1, 3] ]
   *    const unitX = [ [math.unit('5cm')], [math.unit('5cm')] ]
   *    const bigNumberX = [ [math.bignumber(1)], [math.bignumber(0)] ]
   *    const sparse = math.sparse(x)
   *    const dense = math.matrix(x)
   *    math.getMatrixDataType(x)   // returns 'number'
   *    math.getMatrixDataType(sparse)   // returns 'number'
   *    math.getMatrixDataType(dense)   // returns 'number'
   *    math.getMatrixDataType(mixedX) // returns 'mixed'
   *    math.getMatrixDataType(fractionX) // returns 'Fraction'
   *    math.getMatrixDataType(unitX) // returns 'Unit'
   *    math.getMatrixDataType(bigNumberX) // return 'BigNumber'
   *
   * See also:
   *  SparseMatrix, DenseMatrix
   *
   * @param {...Matrix | Array} x   The Matrix with values.
   *
   * @return {string} A string representation of the matrix type
   */ return typed($cf628c4622ecc418$var$name, {
        Array: function Array(x) {
            return (0, $a14a10567870d913$export$d31e00bf4359ea8b)(x, (0, $d8097b7a6d6e36d8$export$f5bbd400c2f4426f));
        },
        Matrix: function Matrix(x) {
            return x.getDataType();
        }
    });
});


var $a0f150b4129ba9f6$var$name = "hex";
var $a0f150b4129ba9f6$var$dependencies = [
    "typed",
    "format"
];
var $a0f150b4129ba9f6$export$9cafd9970d25a17c = (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($a0f150b4129ba9f6$var$name, $a0f150b4129ba9f6$var$dependencies, (_ref)=>{
    var { typed: typed, format: format } = _ref;
    return typed($a0f150b4129ba9f6$var$name, {
        "number | BigNumber": function numberBigNumber(n) {
            return format(n, {
                notation: "hex"
            });
        },
        "number | BigNumber, number": function numberBigNumberNumber(n, wordSize) {
            return format(n, {
                notation: "hex",
                wordSize: wordSize
            });
        }
    });
});



var $76573e9eb3dcaa88$var$name = "im";
var $76573e9eb3dcaa88$var$dependencies = [
    "typed"
];
var $76573e9eb3dcaa88$export$47dfdf308b91581 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($76573e9eb3dcaa88$var$name, $76573e9eb3dcaa88$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Get the imaginary part of a complex number.
   * For a complex number `a + bi`, the function returns `b`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.im(x)
   *
   * Examples:
   *
   *    const a = math.complex(2, 3)
   *    math.re(a)                     // returns number 2
   *    math.im(a)                     // returns number 3
   *
   *    math.re(math.complex('-5.2i')) // returns number -5.2
   *    math.re(math.complex(2.4))     // returns number 0
   *
   * See also:
   *
   *    re, conj, abs, arg
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            A complex number or array with complex numbers
   * @return {number | BigNumber | Array | Matrix} The imaginary part of x
   */ return typed($76573e9eb3dcaa88$var$name, {
        number: function number(x) {
            return 0;
        },
        BigNumber: function BigNumber(x) {
            return x.mul(0);
        },
        Fraction: function Fraction(x) {
            return x.mul(0);
        },
        Complex: function Complex(x) {
            return x.im;
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this);
        }
    });
});




var $36246b3ad4dab182$var$name = "isInteger";
var $36246b3ad4dab182$var$dependencies = [
    "typed"
];
var $36246b3ad4dab182$export$766996d075d5608a = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($36246b3ad4dab182$var$name, $36246b3ad4dab182$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Test whether a value is an integer number.
   * The function supports `number`, `BigNumber`, and `Fraction`.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isInteger(x)
   *
   * Examples:
   *
   *    math.isInteger(2)                     // returns true
   *    math.isInteger(0)                     // returns true
   *    math.isInteger(0.5)                   // returns false
   *    math.isInteger(math.bignumber(500))   // returns true
   *    math.isInteger(math.fraction(4))      // returns true
   *    math.isInteger('3')                   // returns true
   *    math.isInteger([3, 0.5, -2])          // returns [true, false, true]
   *    math.isInteger(math.complex('2-4i')   // throws an error
   *
   * See also:
   *
   *    isNumeric, isPositive, isNegative, isZero
   *
   * @param {number | BigNumber | Fraction | Array | Matrix} x   Value to be tested
   * @return {boolean}  Returns true when `x` contains a numeric, integer value.
   *                    Throws an error in case of an unknown data type.
   */ return typed($36246b3ad4dab182$var$name, {
        number: (0, $668e051498bf5fa0$export$a287f47fed4544b8),
        // TODO: what to do with isInteger(add(0.1, 0.2))  ?
        BigNumber: function BigNumber(x) {
            return x.isInt();
        },
        Fraction: function Fraction(x) {
            return x.d === 1 && isFinite(x.n);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this);
        }
    });
});




var $613b7405ae95cf49$var$n1 = "number";
function $613b7405ae95cf49$export$312381923ba56895(x) {
    return (0, $668e051498bf5fa0$export$a287f47fed4544b8)(x);
}
$613b7405ae95cf49$export$312381923ba56895.signature = $613b7405ae95cf49$var$n1;
function $613b7405ae95cf49$export$6dbd64961904ec9a(x) {
    return x < 0;
}
$613b7405ae95cf49$export$6dbd64961904ec9a.signature = $613b7405ae95cf49$var$n1;
function $613b7405ae95cf49$export$5374bb854d0e41c8(x) {
    return x > 0;
}
$613b7405ae95cf49$export$5374bb854d0e41c8.signature = $613b7405ae95cf49$var$n1;
function $613b7405ae95cf49$export$83fb4ed1cc9804a(x) {
    return x === 0;
}
$613b7405ae95cf49$export$83fb4ed1cc9804a.signature = $613b7405ae95cf49$var$n1;
function $613b7405ae95cf49$export$9fd08d8371c55110(x) {
    return Number.isNaN(x);
}
$613b7405ae95cf49$export$9fd08d8371c55110.signature = $613b7405ae95cf49$var$n1;


var $cc3c03c0b0064eac$var$name = "isNegative";
var $cc3c03c0b0064eac$var$dependencies = [
    "typed"
];
var $cc3c03c0b0064eac$export$159ccd8c63e17c58 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($cc3c03c0b0064eac$var$name, $cc3c03c0b0064eac$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Test whether a value is negative: smaller than zero.
   * The function supports types `number`, `BigNumber`, `Fraction`, and `Unit`.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isNegative(x)
   *
   * Examples:
   *
   *    math.isNegative(3)                     // returns false
   *    math.isNegative(-2)                    // returns true
   *    math.isNegative(0)                     // returns false
   *    math.isNegative(-0)                    // returns false
   *    math.isNegative(math.bignumber(2))     // returns false
   *    math.isNegative(math.fraction(-2, 5))  // returns true
   *    math.isNegative('-2')                  // returns true
   *    math.isNegative([2, 0, -3]')           // returns [false, false, true]
   *
   * See also:
   *
   *    isNumeric, isPositive, isZero, isInteger
   *
   * @param {number | BigNumber | Fraction | Unit | Array | Matrix} x  Value to be tested
   * @return {boolean}  Returns true when `x` is larger than zero.
   *                    Throws an error in case of an unknown data type.
   */ return typed($cc3c03c0b0064eac$var$name, {
        number: (0, $613b7405ae95cf49$export$6dbd64961904ec9a),
        BigNumber: function BigNumber(x) {
            return x.isNeg() && !x.isZero() && !x.isNaN();
        },
        Fraction: function Fraction(x) {
            return x.s < 0; // It's enough to decide on the sign
        },
        Unit: function Unit(x) {
            return this(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this);
        }
    });
});




var $c3fafd52c47ea619$var$name = "isPositive";
var $c3fafd52c47ea619$var$dependencies = [
    "typed"
];
var $c3fafd52c47ea619$export$2d862c12fb537dd9 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($c3fafd52c47ea619$var$name, $c3fafd52c47ea619$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Test whether a value is positive: larger than zero.
   * The function supports types `number`, `BigNumber`, `Fraction`, and `Unit`.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isPositive(x)
   *
   * Examples:
   *
   *    math.isPositive(3)                     // returns true
   *    math.isPositive(-2)                    // returns false
   *    math.isPositive(0)                     // returns false
   *    math.isPositive(-0)                    // returns false
   *    math.isPositive(0.5)                   // returns true
   *    math.isPositive(math.bignumber(2))     // returns true
   *    math.isPositive(math.fraction(-2, 5))  // returns false
   *    math.isPositive(math.fraction(1,3))    // returns false
   *    math.isPositive('2')                   // returns true
   *    math.isPositive([2, 0, -3])            // returns [true, false, false]
   *
   * See also:
   *
   *    isNumeric, isZero, isNegative, isInteger
   *
   * @param {number | BigNumber | Fraction | Unit | Array | Matrix} x  Value to be tested
   * @return {boolean}  Returns true when `x` is larger than zero.
   *                    Throws an error in case of an unknown data type.
   */ return typed($c3fafd52c47ea619$var$name, {
        number: (0, $613b7405ae95cf49$export$5374bb854d0e41c8),
        BigNumber: function BigNumber(x) {
            return !x.isNeg() && !x.isZero() && !x.isNaN();
        },
        Fraction: function Fraction(x) {
            return x.s > 0 && x.n > 0;
        },
        Unit: function Unit(x) {
            return this(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this);
        }
    });
});




var $4eaac03f309f97e9$var$name = "isZero";
var $4eaac03f309f97e9$var$dependencies = [
    "typed"
];
var $4eaac03f309f97e9$export$ea90652d00dab06e = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($4eaac03f309f97e9$var$name, $4eaac03f309f97e9$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Test whether a value is zero.
   * The function can check for zero for types `number`, `BigNumber`, `Fraction`,
   * `Complex`, and `Unit`.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isZero(x)
   *
   * Examples:
   *
   *    math.isZero(0)                     // returns true
   *    math.isZero(2)                     // returns false
   *    math.isZero(0.5)                   // returns false
   *    math.isZero(math.bignumber(0))     // returns true
   *    math.isZero(math.fraction(0))      // returns true
   *    math.isZero(math.fraction(1,3))    // returns false
   *    math.isZero(math.complex('2 - 4i') // returns false
   *    math.isZero(math.complex('0i')     // returns true
   *    math.isZero('0')                   // returns true
   *    math.isZero('2')                   // returns false
   *    math.isZero([2, 0, -3]')           // returns [false, true, false]
   *
   * See also:
   *
   *    isNumeric, isPositive, isNegative, isInteger
   *
   * @param {number | BigNumber | Complex | Fraction | Unit | Array | Matrix} x       Value to be tested
   * @return {boolean}  Returns true when `x` is zero.
   *                    Throws an error in case of an unknown data type.
   */ return typed($4eaac03f309f97e9$var$name, {
        number: (0, $613b7405ae95cf49$export$83fb4ed1cc9804a),
        BigNumber: function BigNumber(x) {
            return x.isZero();
        },
        Complex: function Complex(x) {
            return x.re === 0 && x.im === 0;
        },
        Fraction: function Fraction(x) {
            return x.d === 1 && x.n === 0;
        },
        Unit: function Unit(x) {
            return this(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this);
        }
    });
});

/* eslint-disable no-loss-of-precision */ // References
// ----------
// [1] Hare, "Computing the Principal Branch of log-Gamma", Journal of Algorithms, 1997.
// [2] https://math.stackexchange.com/questions/1338753/how-do-i-calculate-values-for-gamma-function-with-complex-arguments
/* eslint-disable no-loss-of-precision */ 

function $2dcefc023d1c7c4b$export$da03a9f23c941fae(n) {
    var x;
    if ((0, $668e051498bf5fa0$export$a287f47fed4544b8)(n)) {
        if (n <= 0) return isFinite(n) ? Infinity : NaN;
        if (n > 171) return Infinity; // Will overflow
        return (0, $dc1c171d547e28ef$export$dbd0f18357df1ddd)(1, n - 1);
    }
    if (n < 0.5) return Math.PI / (Math.sin(Math.PI * n) * $2dcefc023d1c7c4b$export$da03a9f23c941fae(1 - n));
    if (n >= 171.35) return Infinity; // will overflow
    if (n > 85.0) {
        // Extended Stirling Approx
        var twoN = n * n;
        var threeN = twoN * n;
        var fourN = threeN * n;
        var fiveN = fourN * n;
        return Math.sqrt(2 * Math.PI / n) * Math.pow(n / Math.E, n) * (1 + 1 / (12 * n) + 1 / (288 * twoN) - 139 / (51840 * threeN) - 571 / (2488320 * fourN) + 163879 / (209018880 * fiveN) + 5246819 / (75246796800 * fiveN * n));
    }
    --n;
    x = $2dcefc023d1c7c4b$export$4ef5d09c80bf8d89[0];
    for(var i = 1; i < $2dcefc023d1c7c4b$export$4ef5d09c80bf8d89.length; ++i)x += $2dcefc023d1c7c4b$export$4ef5d09c80bf8d89[i] / (n + i);
    var t = n + $2dcefc023d1c7c4b$export$c1392abb9fefd3b6 + 0.5;
    return Math.sqrt(2 * Math.PI) * Math.pow(t, n + 0.5) * Math.exp(-t) * x;
}
$2dcefc023d1c7c4b$export$da03a9f23c941fae.signature = "number"; // TODO: comment on the variables g and p
var $2dcefc023d1c7c4b$export$c1392abb9fefd3b6 = 4.7421875;
var $2dcefc023d1c7c4b$export$4ef5d09c80bf8d89 = [
    0.99999999999999709182,
    57.156235665862923517,
    -59.59796035547549,
    14.136097974741747174,
    -0.4919138160976202,
    0.33994649984811888699e-4,
    0.46523628927048575665e-4,
    -0.00009837447530487956,
    0.15808870322491248884e-3,
    -0.00021026444172410488,
    0.21743961811521264320e-3,
    -0.0001643181065367639,
    0.84418223983852743293e-4,
    -0.000026190838401581408,
    0.36899182659531622704e-5
]; // lgamma implementation ref: https://mrob.com/pub/ries/lanczos-gamma.html#code
var $2dcefc023d1c7c4b$export$6854df5fcb691251 = 0.91893853320467274178;
var $2dcefc023d1c7c4b$export$ec32a260632ccc98 = 5; // Lanczos parameter "g"
var $2dcefc023d1c7c4b$export$e1cadc5b48a02cef = 7; // Range of coefficients "n"
var $2dcefc023d1c7c4b$export$591d8f773e88a995 = [
    1.000000000190015,
    76.18009172947146,
    -86.50532032941678,
    24.01409824083091,
    -1.231739572450155,
    0.1208650973866179e-2,
    -0.000005395239384953
];
function $2dcefc023d1c7c4b$export$a9c1cdc6d03f0efc(n) {
    if (n < 0) return NaN;
    if (n === 0) return Infinity;
    if (!isFinite(n)) return n;
    if (n < 0.5) // Use Euler's reflection formula:
    // gamma(z) = PI / (sin(PI * z) * gamma(1 - z))
    return Math.log(Math.PI / Math.sin(Math.PI * n)) - $2dcefc023d1c7c4b$export$a9c1cdc6d03f0efc(1 - n);
     // Compute the logarithm of the Gamma function using the Lanczos method
    n = n - 1;
    var base = n + $2dcefc023d1c7c4b$export$ec32a260632ccc98 + 0.5; // Base of the Lanczos exponential
    var sum = $2dcefc023d1c7c4b$export$591d8f773e88a995[0]; // We start with the terms that have the smallest coefficients and largest denominator
    for(var i = $2dcefc023d1c7c4b$export$e1cadc5b48a02cef - 1; i >= 1; i--)sum += $2dcefc023d1c7c4b$export$591d8f773e88a995[i] / (n + i);
    return $2dcefc023d1c7c4b$export$6854df5fcb691251 + (n + 0.5) * Math.log(base) - base + Math.log(sum);
}
$2dcefc023d1c7c4b$export$a9c1cdc6d03f0efc.signature = "number";




var $2140b094078343cf$var$name = "lgamma";
var $2140b094078343cf$var$dependencies = [
    "Complex",
    "typed"
];
var $2140b094078343cf$export$bc3a6f6286e9085a = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($2140b094078343cf$var$name, $2140b094078343cf$var$dependencies, (_ref)=>{
    var { Complex: _Complex, typed: typed } = _ref;
    // Stirling series is non-convergent, we need to use the recurrence `lgamma(z) = lgamma(z+1) - log z` to get
    // sufficient accuracy.
    //
    // These two values are copied from Scipy implementation:
    // https://github.com/scipy/scipy/blob/v1.8.0/scipy/special/_loggamma.pxd#L37
    var SMALL_RE = 7;
    var SMALL_IM = 7;
    /**
   * The coefficients are B[2*n]/(2*n*(2*n - 1)) where B[2*n] is the (2*n)th Bernoulli number. See (1.1) in [1].
   *
   * If you cannot access the paper, can also get these values from the formula in [2].
   *
   *    1 /     12 = 0.00833333333333333333333333333333
   *    1 /    360 = 0.00277777777777777777777777777778
   * ...
   * 3617 / 133400 = 0.02955065359477124183006535947712
   */ var coeffs = [
        -0.029550653594771242,
        6.4102564102564102564e-3,
        -0.0019175269175269176,
        8.4175084175084175084e-4,
        -0.0005952380952380953,
        7.9365079365079365079e-4,
        -0.002777777777777778,
        8.3333333333333333333e-2
    ];
    /**
   * Logarithm of the gamma function for real, positive numbers and complex numbers,
   * using Lanczos approximation for numbers and Stirling series for complex numbers.
   *
   * Syntax:
   *
   *    math.lgamma(n)
   *
   * Examples:
   *
   *    math.lgamma(5)       // returns 3.178053830347945
   *    math.lgamma(0)       // returns Infinity
   *    math.lgamma(-0.5)    // returns NaN
   *    math.lgamma(math.i)  // returns -0.6509231993018536 - 1.8724366472624294i
   *
   * See also:
   *
   *    gamma
   *
   * @param {number | Complex} n   A real or complex number
   * @return {number | Complex}    The log gamma of `n`
   */ return typed($2140b094078343cf$var$name, {
        number: (0, $2dcefc023d1c7c4b$export$a9c1cdc6d03f0efc),
        Complex: function Complex(n) {
            var TWOPI = 6.2831853071795864769252842; // 2*pi
            var LOGPI = 1.1447298858494001741434262; // log(pi)
            var REFLECTION = 0.1;
            if (n.isNaN()) return new _Complex(NaN, NaN);
            else if (n.im === 0) return new _Complex((0, $2dcefc023d1c7c4b$export$a9c1cdc6d03f0efc)(n.re), 0);
            else if (n.re >= SMALL_RE || Math.abs(n.im) >= SMALL_IM) return lgammaStirling(n);
            else if (n.re <= REFLECTION) {
                // Reflection formula. see Proposition 3.1 in [1]
                var tmp = (0, $668e051498bf5fa0$export$fe7b50dc6162f97e)(TWOPI, n.im) * Math.floor(0.5 * n.re + 0.25); // TODO: `complex.js sin` doesn't have extremely high precision, so this value `a` may lose a little precision,
                // causing the computation results to be less accurate than the lgamma of real numbers
                var a = n.mul(Math.PI).sin().log();
                var b = this(new _Complex(1 - n.re, -n.im));
                return new _Complex(LOGPI, tmp).sub(a).sub(b);
            } else if (n.im >= 0) return lgammaRecurrence(n);
            else return lgammaRecurrence(n.conjugate()).conjugate();
        },
        BigNumber: function BigNumber() {
            throw new Error("mathjs doesn't yet provide an implementation of the algorithm lgamma for BigNumber");
        }
    });
    function lgammaStirling(z) {
        // formula ref in [2]
        // computation ref:
        // https://github.com/scipy/scipy/blob/v1.8.0/scipy/special/_loggamma.pxd#L101
        // left part
        // x (log(x) - 1) + 1/2 (log(2PI) - log(x))
        // => (x - 0.5) * log(x) - x + log(2PI) / 2
        var leftPart = z.sub(0.5).mul(z.log()).sub(z).add((0, $2dcefc023d1c7c4b$export$6854df5fcb691251)); // right part
        var rz = new _Complex(1, 0).div(z);
        var rzz = rz.div(z);
        var a = coeffs[0];
        var b = coeffs[1];
        var r = 2 * rzz.re;
        var s = rzz.re * rzz.re + rzz.im * rzz.im;
        for(var i = 2; i < 8; i++){
            var tmp = b;
            b = -s * a + coeffs[i];
            a = r * a + tmp;
        }
        var rightPart = rz.mul(rzz.mul(a).add(b)); // plus left and right
        return leftPart.add(rightPart);
    }
    function lgammaRecurrence(z) {
        // computation ref:
        // https://github.com/scipy/scipy/blob/v1.8.0/scipy/special/_loggamma.pxd#L78
        var signflips = 0;
        var sb = 0;
        var shiftprod = z;
        z = z.add(1);
        while(z.re <= SMALL_RE){
            shiftprod = shiftprod.mul(z);
            var nsb = shiftprod.im < 0 ? 1 : 0;
            if (nsb !== 0 && sb === 0) signflips++;
            sb = nsb;
            z = z.add(1);
        }
        return lgammaStirling(z).sub(shiftprod.log()).sub(new _Complex(0, signflips * 2 * Math.PI * 1));
    }
});




var $dfe5aefd5ba6b4f0$var$name = "log10";
var $dfe5aefd5ba6b4f0$var$dependencies = [
    "typed",
    "config",
    "Complex"
];
var $dfe5aefd5ba6b4f0$export$dea4efeb24d4590d = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($dfe5aefd5ba6b4f0$var$name, $dfe5aefd5ba6b4f0$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: _Complex } = _ref;
    /**
   * Calculate the 10-base logarithm of a value. This is the same as calculating `log(x, 10)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.log10(x)
   *
   * Examples:
   *
   *    math.log10(0.00001)            // returns -5
   *    math.log10(10000)              // returns 4
   *    math.log(10000) / math.log(10) // returns 4
   *    math.pow(10, 4)                // returns 10000
   *
   * See also:
   *
   *    exp, log, log1p, log2
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            Value for which to calculate the logarithm.
   * @return {number | BigNumber | Complex | Array | Matrix}
   *            Returns the 10-base logarithm of `x`
   */ return typed($dfe5aefd5ba6b4f0$var$name, {
        number: function number(x) {
            if (x >= 0 || config.predictable) return (0, $4b37ed316f05dd33$export$e3f8d49574d29dff)(x);
            else // negative value -> complex value computation
            return new _Complex(x, 0).log().div(Math.LN10);
        },
        Complex: function Complex(x) {
            return new _Complex(x).log().div(Math.LN10);
        },
        BigNumber: function BigNumber(x) {
            if (!x.isNegative() || config.predictable) return x.log();
            else // downgrade to number, return Complex valued result
            return new _Complex(x.toNumber(), 0).log().div(Math.LN10);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this);
        }
    });
});




var $df3976634f9977b9$var$name = "log2";
var $df3976634f9977b9$var$dependencies = [
    "typed",
    "config",
    "Complex"
];
var $df3976634f9977b9$export$a993dae3988e0f19 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($df3976634f9977b9$var$name, $df3976634f9977b9$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex } = _ref;
    /**
   * Calculate the 2-base of a value. This is the same as calculating `log(x, 2)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.log2(x)
   *
   * Examples:
   *
   *    math.log2(0.03125)           // returns -5
   *    math.log2(16)                // returns 4
   *    math.log2(16) / math.log2(2) // returns 4
   *    math.pow(2, 4)               // returns 16
   *
   * See also:
   *
   *    exp, log, log1p, log10
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            Value for which to calculate the logarithm.
   * @return {number | BigNumber | Complex | Array | Matrix}
   *            Returns the 2-base logarithm of `x`
   */ return typed($df3976634f9977b9$var$name, {
        number: function number(x) {
            if (x >= 0 || config.predictable) return (0, $4b37ed316f05dd33$export$f9bc93220cfa3c59)(x);
            else // negative value -> complex value computation
            return _log2Complex(new Complex(x, 0));
        },
        Complex: _log2Complex,
        BigNumber: function BigNumber(x) {
            if (!x.isNegative() || config.predictable) return x.log(2);
            else // downgrade to number, return Complex valued result
            return _log2Complex(new Complex(x.toNumber(), 0));
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this);
        }
    });
    /**
   * Calculate log2 for a complex value
   * @param {Complex} x
   * @returns {Complex}
   * @private
   */ function _log2Complex(x) {
        var newX = Math.sqrt(x.re * x.re + x.im * x.im);
        return new Complex(Math.log2 ? Math.log2(newX) : Math.log(newX) / Math.LN2, Math.atan2(x.im, x.re) / Math.LN2);
    }
});



var $f874e0e0b1135d36$var$name = "map";
var $f874e0e0b1135d36$var$dependencies = [
    "typed"
];
var $f874e0e0b1135d36$export$d49c9aa30b771d59 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($f874e0e0b1135d36$var$name, $f874e0e0b1135d36$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Create a new matrix or array with the results of a callback function executed on
   * each entry of a given matrix/array.
   *
   * For each entry of the input, the callback is invoked with three arguments:
   * the value of the entry, the index at which that entry occurs, and the full
   * matrix/array being traversed. Note that because the matrix/array might be
   * multidimensional, the "index" argument is always an array of numbers giving
   * the index in each dimension. This is true even for vectors: the "index"
   * argument is an array of length 1, rather than simply a number.
   *
   * Syntax:
   *
   *    math.map(x, callback)
   *
   * Examples:
   *
   *    math.map([1, 2, 3], function(value) {
   *      return value * value
   *    })  // returns [1, 4, 9]
   *
   *    // The calling convention for the callback can cause subtleties:
   *    math.map([1, 2, 3], math.format)
   *    // throws TypeError: map attempted to call 'format(1,[0])' but argument 2 of type Array does not match expected type number or function or Object or string or boolean
   *    // [This happens because `format` _can_ take a second argument,
   *    // but its semantics don't match that of the 2nd argument `map` provides]
   *
   *    // To avoid this error, use a function that takes exactly the
   *    // desired arguments:
   *    math.map([1, 2, 3], x => math.format(x)) // returns ['1', '2', '3']
   *
   * See also:
   *
   *    filter, forEach, sort
   *
   * @param {Matrix | Array} x    The input to iterate on.
   * @param {Function} callback
   *     The function to call (as described above) on each entry of the input
   * @return {Matrix | array}
   *     Transformed map of x; always has the same type and shape as x
   */ return typed($f874e0e0b1135d36$var$name, {
        "Array, function": $f874e0e0b1135d36$var$_map,
        "Matrix, function": function MatrixFunction(x, callback) {
            return x.map(callback);
        }
    });
});
/**
 * Map for a multi dimensional array
 * @param {Array} array
 * @param {Function} callback
 * @return {Array}
 * @private
 */ function $f874e0e0b1135d36$var$_map(array, callback) {
    // figure out what number of arguments the callback function expects
    var args = (0, $458cc793bcf3a223$export$6c00fba23f8c91a7)(callback);
    var recurse = function recurse(value, index) {
        if (Array.isArray(value)) return value.map(function(child, i) {
            // we create a copy of the index array and append the new index value
            return recurse(child, index.concat(i));
        });
        else try {
            // invoke the callback function with the right number of arguments
            if (args === 1) return callback(value);
            else if (args === 2) return callback(value, index);
            else // 3 or -1
            return callback(value, index, array);
        } catch (err) {
            // But maybe the arguments still weren't right
            if (err instanceof TypeError && "data" in err && err.data.category === "wrongType") {
                var newmsg = "map attempted to call '".concat(err.data.fn, "(").concat(value);
                var indexString = JSON.stringify(index);
                if (args === 2) newmsg += "," + indexString;
                else if (args !== 1) newmsg += ",".concat(indexString, ",").concat(array);
                newmsg += ")' but argument ".concat(err.data.index + 1, " of type ");
                newmsg += "".concat(err.data.actual, " does not match expected type ");
                newmsg += err.data.expected.join(" or ");
                throw new TypeError(newmsg);
            }
            throw err;
        }
    };
    return recurse(array, []);
}



var $5053d0f9a9085c9f$var$name = "multiplyScalar";
var $5053d0f9a9085c9f$var$dependencies = [
    "typed"
];
var $5053d0f9a9085c9f$export$37dc64d7e8361b32 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($5053d0f9a9085c9f$var$name, $5053d0f9a9085c9f$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Multiply two scalar values, `x * y`.
   * This function is meant for internal use: it is used by the public function
   * `multiply`
   *
   * This function does not support collections (Array or Matrix).
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit} x   First value to multiply
   * @param  {number | BigNumber | Fraction | Complex} y          Second value to multiply
   * @return {number | BigNumber | Fraction | Complex | Unit}     Multiplication of `x` and `y`
   * @private
   */ return typed("multiplyScalar", {
        "number, number": (0, $4b37ed316f05dd33$export$4ad41ac849e391ec),
        "Complex, Complex": function ComplexComplex(x, y) {
            return x.mul(y);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.times(y);
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.mul(y);
        },
        "number | Fraction | BigNumber | Complex, Unit": function numberFractionBigNumberComplexUnit(x, y) {
            var res = y.clone();
            res.value = res.value === null ? res._normalize(x) : this(res.value, x);
            return res;
        },
        "Unit, number | Fraction | BigNumber | Complex": function UnitNumberFractionBigNumberComplex(x, y) {
            var res = x.clone();
            res.value = res.value === null ? res._normalize(y) : this(res.value, y);
            return res;
        },
        "Unit, Unit": function UnitUnit(x, y) {
            return x.multiply(y);
        }
    });
});



var $e69afcd9e58cec61$var$n1 = "number";
var $e69afcd9e58cec61$var$n2 = "number, number";
function $e69afcd9e58cec61$export$5c3e9fce4e8f3d3a(x) {
    return !x;
}
$e69afcd9e58cec61$export$5c3e9fce4e8f3d3a.signature = $e69afcd9e58cec61$var$n1;
function $e69afcd9e58cec61$export$cb9e31d07eec8012(x, y) {
    return !!(x || y);
}
$e69afcd9e58cec61$export$cb9e31d07eec8012.signature = $e69afcd9e58cec61$var$n2;
function $e69afcd9e58cec61$export$17cc7dc3a74df3af(x, y) {
    return !!x !== !!y;
}
$e69afcd9e58cec61$export$17cc7dc3a74df3af.signature = $e69afcd9e58cec61$var$n2;
function $e69afcd9e58cec61$export$11dffb061e00e795(x, y) {
    return !!(x && y);
}
$e69afcd9e58cec61$export$11dffb061e00e795.signature = $e69afcd9e58cec61$var$n2;


var $5baf9282ba9fae19$var$name = "not";
var $5baf9282ba9fae19$var$dependencies = [
    "typed"
];
var $5baf9282ba9fae19$export$8dbfb388cd6a8853 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($5baf9282ba9fae19$var$name, $5baf9282ba9fae19$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Logical `not`. Flips boolean value of a given parameter.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.not(x)
   *
   * Examples:
   *
   *    math.not(2)      // returns false
   *    math.not(0)      // returns true
   *    math.not(true)   // returns false
   *
   *    a = [2, -7, 0]
   *    math.not(a)      // returns [false, false, true]
   *
   * See also:
   *
   *    and, or, xor
   *
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} x First value to check
   * @return {boolean | Array | Matrix}
   *            Returns true when input is a zero or empty value.
   */ return typed($5baf9282ba9fae19$var$name, {
        number: (0, $e69afcd9e58cec61$export$5c3e9fce4e8f3d3a),
        Complex: function Complex(x) {
            return x.re === 0 && x.im === 0;
        },
        BigNumber: function BigNumber(x) {
            return x.isZero() || x.isNaN();
        },
        Unit: function Unit(x) {
            return x.value !== null ? this(x.value) : true;
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this);
        }
    });
});



var $930896808ac47b5e$var$name = "number";
var $930896808ac47b5e$var$dependencies = [
    "typed"
];
/**
 * Separates the radix, integer part, and fractional part of a non decimal number string
 * @param {string} input string to parse
 * @returns {object} the parts of the string or null if not a valid input
 */ function $930896808ac47b5e$var$getNonDecimalNumberParts(input) {
    var nonDecimalWithRadixMatch = input.match(/(0[box])([0-9a-fA-F]*)\.([0-9a-fA-F]*)/);
    if (nonDecimalWithRadixMatch) {
        var radix = {
            "0b": 2,
            "0o": 8,
            "0x": 16
        }[nonDecimalWithRadixMatch[1]];
        var integerPart = nonDecimalWithRadixMatch[2];
        var fractionalPart = nonDecimalWithRadixMatch[3];
        return {
            input: input,
            radix: radix,
            integerPart: integerPart,
            fractionalPart: fractionalPart
        };
    } else return null;
}
/**
 * Makes a number from a radix, and integer part, and a fractional part
 * @param {parts} [x] parts of the number string (from getNonDecimalNumberParts)
 * @returns {number} the number
 */ function $930896808ac47b5e$var$makeNumberFromNonDecimalParts(parts) {
    var n = parseInt(parts.integerPart, parts.radix);
    var f = 0;
    for(var i = 0; i < parts.fractionalPart.length; i++){
        var digitValue = parseInt(parts.fractionalPart[i], parts.radix);
        f += digitValue / Math.pow(parts.radix, i + 1);
    }
    var result = n + f;
    if (isNaN(result)) throw new SyntaxError('String "' + parts.input + '" is no valid number');
    return result;
}
var $930896808ac47b5e$export$763ee9f6477981ab = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($930896808ac47b5e$var$name, $930896808ac47b5e$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Create a number or convert a string, boolean, or unit to a number.
   * When value is a matrix, all elements will be converted to number.
   *
   * Syntax:
   *
   *    math.number(value)
   *    math.number(unit, valuelessUnit)
   *
   * Examples:
   *
   *    math.number(2)                         // returns number 2
   *    math.number('7.2')                     // returns number 7.2
   *    math.number(true)                      // returns number 1
   *    math.number([true, false, true, true]) // returns [1, 0, 1, 1]
   *    math.number(math.unit('52cm'), 'm')    // returns 0.52
   *
   * See also:
   *
   *    bignumber, boolean, complex, index, matrix, string, unit
   *
   * @param {string | number | BigNumber | Fraction | boolean | Array | Matrix | Unit | null} [value]  Value to be converted
   * @param {Unit | string} [valuelessUnit] A valueless unit, used to convert a unit to a number
   * @return {number | Array | Matrix} The created number
   */ var number = typed("number", {
        "": function _() {
            return 0;
        },
        number: function number(x) {
            return x;
        },
        string: function string(x) {
            if (x === "NaN") return NaN;
            var nonDecimalNumberParts = $930896808ac47b5e$var$getNonDecimalNumberParts(x);
            if (nonDecimalNumberParts) return $930896808ac47b5e$var$makeNumberFromNonDecimalParts(nonDecimalNumberParts);
            var size = 0;
            var wordSizeSuffixMatch = x.match(/(0[box][0-9a-fA-F]*)i([0-9]*)/);
            if (wordSizeSuffixMatch) {
                // x includes a size suffix like 0xffffi32, so we extract
                // the suffix and remove it from x
                size = Number(wordSizeSuffixMatch[2]);
                x = wordSizeSuffixMatch[1];
            }
            var num = Number(x);
            if (isNaN(num)) throw new SyntaxError('String "' + x + '" is no valid number');
            if (wordSizeSuffixMatch) {
                // x is a signed bin, oct, or hex literal
                // num is the value of string x if x is interpreted as unsigned
                if (num > 2 ** size - 1) // literal is too large for size suffix
                throw new SyntaxError('String "'.concat(x, '" is out of range'));
                 // check if the bit at index size - 1 is set and if so do the twos complement
                if (num >= 2 ** (size - 1)) num = num - 2 ** size;
            }
            return num;
        },
        BigNumber: function BigNumber(x) {
            return x.toNumber();
        },
        Fraction: function Fraction(x) {
            return x.valueOf();
        },
        Unit: function Unit(x) {
            throw new Error("Second argument with valueless unit expected");
        },
        null: function _null(x) {
            return 0;
        },
        "Unit, string | Unit": function UnitStringUnit(unit, valuelessUnit) {
            return unit.toNumber(valuelessUnit);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this);
        }
    }); // reviver function to parse a JSON object like:
    //
    //     {"mathjs":"number","value":"2.3"}
    //
    // into a number 2.3
    number.fromJSON = function(json) {
        return parseFloat(json.value);
    };
    return number;
});


var $cdc5bba4f0159798$var$name = "oct";
var $cdc5bba4f0159798$var$dependencies = [
    "typed",
    "format"
];
var $cdc5bba4f0159798$export$6692788ef49c21c9 = (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($cdc5bba4f0159798$var$name, $cdc5bba4f0159798$var$dependencies, (_ref)=>{
    var { typed: typed, format: format } = _ref;
    return typed($cdc5bba4f0159798$var$name, {
        "number | BigNumber": function numberBigNumber(n) {
            return format(n, {
                notation: "oct"
            });
        },
        "number | BigNumber, number": function numberBigNumberNumber(n, wordSize) {
            return format(n, {
                notation: "oct",
                wordSize: wordSize
            });
        }
    });
});




var $98414aaf1bea2287$exports = {};
// A library of seedable RNGs implemented in Javascript.
//
// Usage:
//
// var seedrandom = require('seedrandom');
// var random = seedrandom(1); // or any seed.
// var x = random();       // 0 <= x < 1.  Every bit is random.
// var x = random.quick(); // 0 <= x < 1.  32 bits of randomness.
// alea, a 53-bit multiply-with-carry generator by Johannes Baagøe.
// Period: ~2^116
// Reported to pass all BigCrush tests.

var $1FN1V = parcelRequire("1FN1V");

var $ckzGC = parcelRequire("ckzGC");

var $hjML1 = parcelRequire("hjML1");

var $1CTAg = parcelRequire("1CTAg");

var $iBClV = parcelRequire("iBClV");

var $cuVEv = parcelRequire("cuVEv");
var $af83b6437a2d7711$exports = {};

/*
Copyright 2019 David Bau.

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/ (function(global, pool, math) {
    //
    // The following constants are related to IEEE 754 limits.
    //
    var width = 256, chunks = 6, digits = 52, rngname = "random", startdenom = math.pow(width, chunks), significance = math.pow(2, digits), overflow = significance * 2, mask = width - 1, nodecrypto; // node.js crypto module, initialized at the bottom.
    //
    // seedrandom()
    // This is the seedrandom function described above.
    //
    function seedrandom(seed, options, callback) {
        var key = [];
        options = options == true ? {
            entropy: true
        } : options || {};
        // Flatten the seed string or build one from local entropy if needed.
        var shortseed = mixkey(flatten(options.entropy ? [
            seed,
            tostring(pool)
        ] : seed == null ? autoseed() : seed, 3), key);
        // Use the seed to initialize an ARC4 generator.
        var arc4 = new ARC4(key);
        // This function returns a random double in [0, 1) that contains
        // randomness in every bit of the mantissa of the IEEE 754 value.
        var prng = function() {
            var n = arc4.g(chunks), d = startdenom, x = 0; //   and no 'extra last byte'.
            while(n < significance){
                n = (n + x) * width; //   shifting numerator and
                d *= width; //   denominator and generating a
                x = arc4.g(1); //   new least-significant-byte.
            }
            while(n >= overflow){
                n /= 2; //   last byte, shift everything
                d /= 2; //   right using integer math until
                x >>>= 1; //   we have exactly the desired bits.
            }
            return (n + x) / d; // Form the number within [0, 1).
        };
        prng.int32 = function() {
            return arc4.g(4) | 0;
        };
        prng.quick = function() {
            return arc4.g(4) / 0x100000000;
        };
        prng.double = prng;
        // Mix the randomness into accumulated entropy.
        mixkey(tostring(arc4.S), pool);
        // Calling convention: what to return as a function of prng, seed, is_math.
        return (options.pass || callback || function(prng, seed, is_math_call, state) {
            if (state) {
                // Load the arc4 state from the given state if it has an S array.
                if (state.S) copy(state, arc4);
                // Only provide the .state method if requested via options.state.
                prng.state = function() {
                    return copy(arc4, {});
                };
            }
            // If called as a method of Math (Math.seedrandom()), mutate
            // Math.random because that is how seedrandom.js has worked since v1.0.
            if (is_math_call) {
                math[rngname] = prng;
                return seed;
            } else return prng;
        })(prng, shortseed, "global" in options ? options.global : this == math, options.state);
    }
    //
    // ARC4
    //
    // An ARC4 implementation.  The constructor takes a key in the form of
    // an array of at most (width) integers that should be 0 <= x < (width).
    //
    // The g(count) method returns a pseudorandom integer that concatenates
    // the next (count) outputs from ARC4.  Its return value is a number x
    // that is in the range 0 <= x < (width ^ count).
    //
    function ARC4(key) {
        var t, keylen = key.length, me = this, i = 0, j = me.i = me.j = 0, s = me.S = [];
        // The empty key [] is treated as [0].
        if (!keylen) key = [
            keylen++
        ];
        // Set up S using the standard key scheduling algorithm.
        while(i < width)s[i] = i++;
        for(i = 0; i < width; i++){
            s[i] = s[j = mask & j + key[i % keylen] + (t = s[i])];
            s[j] = t;
        }
        // The "g" method returns the next (count) outputs as one number.
        (me.g = function(count) {
            // Using instance members instead of closure state nearly doubles speed.
            var t, r = 0, i = me.i, j = me.j, s = me.S;
            while(count--){
                t = s[i = mask & i + 1];
                r = r * width + s[mask & (s[i] = s[j = mask & j + t]) + (s[j] = t)];
            }
            me.i = i;
            me.j = j;
            return r;
        // For robust unpredictability, the function call below automatically
        // discards an initial batch of values.  This is called RC4-drop[256].
        // See http://google.com/search?q=rsa+fluhrer+response&btnI
        })(width);
    }
    //
    // copy()
    // Copies internal state of ARC4 to or from a plain object.
    //
    function copy(f, t) {
        t.i = f.i;
        t.j = f.j;
        t.S = f.S.slice();
        return t;
    }
    //
    // flatten()
    // Converts an object tree to nested arrays of strings.
    //
    function flatten(obj, depth) {
        var result = [], typ = typeof obj, prop;
        if (depth && typ == "object") {
            for(prop in obj)try {
                result.push(flatten(obj[prop], depth - 1));
            } catch (e) {}
        }
        return result.length ? result : typ == "string" ? obj : obj + "\x00";
    }
    //
    // mixkey()
    // Mixes a string seed into a key that is an array of integers, and
    // returns a shortened string seed that is equivalent to the result key.
    //
    function mixkey(seed, key) {
        var stringseed = seed + "", smear, j = 0;
        while(j < stringseed.length)key[mask & j] = mask & (smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++);
        return tostring(key);
    }
    //
    // autoseed()
    // Returns an object for autoseeding, using window.crypto and Node crypto
    // module if available.
    //
    function autoseed() {
        try {
            var out;
            if (nodecrypto && (out = nodecrypto.randomBytes)) // The use of 'out' to remember randomBytes makes tight minified code.
            out = out(width);
            else {
                out = new Uint8Array(width);
                (global.crypto || global.msCrypto).getRandomValues(out);
            }
            return tostring(out);
        } catch (e) {
            var browser = global.navigator, plugins = browser && browser.plugins;
            return [
                +new Date,
                global,
                plugins,
                global.screen,
                tostring(pool)
            ];
        }
    }
    //
    // tostring()
    // Converts an array of charcodes to a string
    //
    function tostring(a) {
        return String.fromCharCode.apply(0, a);
    }
    //
    // When seedrandom.js is loaded, we immediately mix a few bits
    // from the built-in RNG into the entropy pool.  Because we do
    // not want to interfere with deterministic PRNG state later,
    // seedrandom will not call math.random on its own again after
    // initialization.
    //
    mixkey(math.random(), pool);
    //
    // Nodejs and AMD support: export the implementation as a module using
    // either convention.
    //
    if (0, $af83b6437a2d7711$exports) {
        $af83b6437a2d7711$exports = seedrandom;
        // When in node.js, try using crypto package for autoseeding.
        try {
            nodecrypto = (parcelRequire("aqbQf"));
        } catch (ex) {}
    } else if (typeof define == "function" && define.amd) define(function() {
        return seedrandom;
    });
    else // When included as a plain script, set up Math.seedrandom global.
    math["seed" + rngname] = seedrandom;
// End anonymous scope, and pass initial values.
})(// global: `self` in browsers (including strict mode and web workers),
// otherwise `this` in Node and other environments
typeof self !== "undefined" ? self : $af83b6437a2d7711$exports, [], Math // math: package containing random, pow, and seedrandom
);


$af83b6437a2d7711$exports.alea = $1FN1V;
$af83b6437a2d7711$exports.xor128 = $ckzGC;
$af83b6437a2d7711$exports.xorwow = $hjML1;
$af83b6437a2d7711$exports.xorshift7 = $1CTAg;
$af83b6437a2d7711$exports.xor4096 = $iBClV;
$af83b6437a2d7711$exports.tychei = $cuVEv;
$98414aaf1bea2287$exports = $af83b6437a2d7711$exports;


var $1059d98e3912f47f$var$singletonRandom = /* #__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($98414aaf1bea2287$exports)))(Date.now());
function $1059d98e3912f47f$export$eaf9227667332084(randomSeed) {
    var random; // create a new random generator with given seed
    function setSeed(seed) {
        random = seed === null ? $1059d98e3912f47f$var$singletonRandom : (0, (/*@__PURE__*/$parcel$interopDefault($98414aaf1bea2287$exports)))(String(seed));
    } // initialize a seeded pseudo random number generator with config's random seed
    setSeed(randomSeed); // wrapper function so the rng can be updated via generator
    function rng() {
        return random();
    }
    return rng;
}


var $ee18b24310ad0068$var$name = "pickRandom";
var $ee18b24310ad0068$var$dependencies = [
    "typed",
    "config",
    "?on"
];
var $ee18b24310ad0068$export$fbe25b9f25feec34 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($ee18b24310ad0068$var$name, $ee18b24310ad0068$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, on: on } = _ref;
    // seeded pseudo random number generator
    var rng = (0, $1059d98e3912f47f$export$eaf9227667332084)(config.randomSeed);
    if (on) on("config", function(curr, prev) {
        if (curr.randomSeed !== prev.randomSeed) rng = (0, $1059d98e3912f47f$export$eaf9227667332084)(curr.randomSeed);
    });
    /**
   * Random pick one or more values from a one dimensional array.
   * Array elements are picked using a random function with uniform or weighted distribution.
   *
   * Syntax:
   *
   *     math.pickRandom(array)
   *     math.pickRandom(array, number)
   *     math.pickRandom(array, weights)
   *     math.pickRandom(array, number, weights)
   *     math.pickRandom(array, weights, number)
   *     math.pickRandom(array, { weights, number, elementWise })
   *
   * Examples:
   *
   *     math.pickRandom([3, 6, 12, 2])                  // returns one of the values in the array
   *     math.pickRandom([3, 6, 12, 2], 2)               // returns an array of two of the values in the array
   *     math.pickRandom([3, 6, 12, 2], { number: 2 })   // returns an array of two of the values in the array
   *     math.pickRandom([3, 6, 12, 2], [1, 3, 2, 1])    // returns one of the values in the array with weighted distribution
   *     math.pickRandom([3, 6, 12, 2], 2, [1, 3, 2, 1]) // returns an array of two of the values in the array with weighted distribution
   *     math.pickRandom([3, 6, 12, 2], [1, 3, 2, 1], 2) // returns an array of two of the values in the array with weighted distribution
   *
   *     math.pickRandom([{x: 1.0, y: 2.0}, {x: 1.1, y: 2.0}], { elementWise: false })
   *         // returns one of the items in the array
   *
   * See also:
   *
   *     random, randomInt
   *
   * @param {Array | Matrix} array     A one dimensional array
   * @param {Int} number               An int or float
   * @param {Array | Matrix} weights   An array of ints or floats
   * @return {number | Array}          Returns a single random value from array when number is 1 or undefined.
   *                                   Returns an array with the configured number of elements when number is > 1.
   */ return typed($ee18b24310ad0068$var$name, {
        "Array | Matrix": function ArrayMatrix(possibles) {
            return _pickRandom(possibles, {});
        },
        "Array | Matrix, Object": function ArrayMatrixObject(possibles, options) {
            return _pickRandom(possibles, options);
        },
        "Array | Matrix, number": function ArrayMatrixNumber(possibles, number) {
            return _pickRandom(possibles, {
                number: number
            });
        },
        "Array | Matrix, Array | Matrix": function ArrayMatrixArrayMatrix(possibles, weights) {
            return _pickRandom(possibles, {
                weights: weights
            });
        },
        "Array | Matrix, Array | Matrix, number": function ArrayMatrixArrayMatrixNumber(possibles, weights, number) {
            return _pickRandom(possibles, {
                number: number,
                weights: weights
            });
        },
        "Array | Matrix, number, Array | Matrix": function ArrayMatrixNumberArrayMatrix(possibles, number, weights) {
            return _pickRandom(possibles, {
                number: number,
                weights: weights
            });
        }
    });
    /**
   * @param {Array | Matrix} possibles
   * @param {{
   *   number?: number,
   *   weights?: Array | Matrix,
   *   elementWise: boolean
   * }} options
   * @returns {number | Array}
   * @private
   */ function _pickRandom(possibles, _ref2) {
        var { number: number, weights: weights, elementWise: elementWise = true } = _ref2;
        var single = typeof number === "undefined";
        if (single) number = 1;
        var createMatrix = (0, $d8097b7a6d6e36d8$export$b22160e0a14f87b7)(possibles) ? possibles.create : (0, $d8097b7a6d6e36d8$export$b22160e0a14f87b7)(weights) ? weights.create : null;
        possibles = possibles.valueOf(); // get Array
        if (weights) weights = weights.valueOf(); // get Array
        if (elementWise === true) {
            possibles = (0, $a14a10567870d913$export$bffa455ba8c619a6)(possibles);
            weights = (0, $a14a10567870d913$export$bffa455ba8c619a6)(weights);
        }
        var totalWeights = 0;
        if (typeof weights !== "undefined") {
            if (weights.length !== possibles.length) throw new Error("Weights must have the same length as possibles");
            for(var i = 0, len = weights.length; i < len; i++){
                if (!(0, $d8097b7a6d6e36d8$export$7e4aa119212bc614)(weights[i]) || weights[i] < 0) throw new Error("Weights must be an array of positive numbers");
                totalWeights += weights[i];
            }
        }
        var length = possibles.length;
        var result = [];
        var pick;
        while(result.length < number){
            if (typeof weights === "undefined") pick = possibles[Math.floor(rng() * length)];
            else {
                var randKey = rng() * totalWeights;
                for(var _i = 0, _len = possibles.length; _i < _len; _i++){
                    randKey -= weights[_i];
                    if (randKey < 0) {
                        pick = possibles[_i];
                        break;
                    }
                }
            }
            result.push(pick);
        }
        return single ? result[0] : createMatrix ? createMatrix(result) : result;
    }
});




var $42c4d4840ed26722$var$name = "print";
var $42c4d4840ed26722$var$dependencies = [
    "typed"
];
var $42c4d4840ed26722$export$ea4b9d9569ff81cc = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($42c4d4840ed26722$var$name, $42c4d4840ed26722$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Interpolate values into a string template.
   *
   * Syntax:
   *
   *     math.print(template, values)
   *     math.print(template, values, precision)
   *     math.print(template, values, options)
   *
   * Example usage:
   *
   *     // the following outputs: 'Lucy is 5 years old'
   *     math.print('Lucy is $age years old', {age: 5})
   *
   *     // the following outputs: 'The value of pi is 3.141592654'
   *     math.print('The value of pi is $pi', {pi: math.pi}, 10)
   *
   *     // the following outputs: 'hello Mary! The date is 2013-03-23'
   *     math.print('Hello $user.name! The date is $date', {
   *       user: {
   *         name: 'Mary',
   *       },
   *       date: new Date(2013, 2, 23).toISOString().substring(0, 10)
   *     })
   *
   *     // the following outputs: 'My favorite fruits are apples and bananas !'
   *     math.print('My favorite fruits are $0 and $1 !', [
   *       'apples',
   *       'bananas'
   *     ])
   *
   * See also:
   *
   *     format
   *
   * @param {string} template           A string containing variable placeholders.
   * @param {Object | Array | Matrix}   values An object or array containing variables
   *                                    which will be filled in in the template.
   * @param {number | Object} [options] Formatting options,
   *                                    or the number of digits to format numbers.
   *                                    See function math.format for a description
   *                                    of all options.
   * @return {string} Interpolated string
   */ return typed($42c4d4840ed26722$var$name, {
        // note: Matrix will be converted automatically to an Array
        "string, Object | Array": $42c4d4840ed26722$var$_print,
        "string, Object | Array, number | Object": $42c4d4840ed26722$var$_print
    });
});
/**
 * Interpolate values into a string template.
 * @param {string} template
 * @param {Object} values
 * @param {number | Object} [options]
 * @returns {string} Interpolated string
 * @private
 */ function $42c4d4840ed26722$var$_print(template, values, options) {
    return template.replace(/\$([\w.]+)/g, function(original, key) {
        var keys = key.split(".");
        var value = values[keys.shift()];
        while(keys.length && value !== undefined){
            var k = keys.shift();
            value = k ? value[k] : value + ".";
        }
        if (value !== undefined) {
            if (!(0, $d8097b7a6d6e36d8$export$844ec244b1367d54)(value)) return (0, $b94963e97c376b6d$export$d9468344d3651243)(value, options);
            else return value;
        }
        return original;
    });
}




/**
 * This is a util function for generating a random matrix recursively.
 * @param {number[]} size
 * @param {function} random
 * @returns {Array}
 */ function $020121c2fe1a81e4$export$6549281d357a44ec(size, random) {
    var data = [];
    size = size.slice(0);
    if (size.length > 1) for(var i = 0, length = size.shift(); i < length; i++)data.push($020121c2fe1a81e4$export$6549281d357a44ec(size, random));
    else for(var _i = 0, _length = size.shift(); _i < _length; _i++)data.push(random());
    return data;
}


var $0410891c7115dc60$var$name = "random";
var $0410891c7115dc60$var$dependencies = [
    "typed",
    "config",
    "?on"
];
var $0410891c7115dc60$export$5c03d20f483e909a = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($0410891c7115dc60$var$name, $0410891c7115dc60$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, on: on } = _ref;
    // seeded pseudo random number generator
    var rng = (0, $1059d98e3912f47f$export$eaf9227667332084)(config.randomSeed);
    if (on) on("config", function(curr, prev) {
        if (curr.randomSeed !== prev.randomSeed) rng = (0, $1059d98e3912f47f$export$eaf9227667332084)(curr.randomSeed);
    });
    /**
   * Return a random number larger or equal to `min` and smaller than `max`
   * using a uniform distribution.
   *
   * Syntax:
   *
   *     math.random()                // generate a random number between 0 and 1
   *     math.random(max)             // generate a random number between 0 and max
   *     math.random(min, max)        // generate a random number between min and max
   *     math.random(size)            // generate a matrix with random numbers between 0 and 1
   *     math.random(size, max)       // generate a matrix with random numbers between 0 and max
   *     math.random(size, min, max)  // generate a matrix with random numbers between min and max
   *
   * Examples:
   *
   *     math.random()       // returns a random number between 0 and 1
   *     math.random(100)    // returns a random number between 0 and 100
   *     math.random(30, 40) // returns a random number between 30 and 40
   *     math.random([2, 3]) // returns a 2x3 matrix with random numbers between 0 and 1
   *
   * See also:
   *
   *     randomInt, pickRandom
   *
   * @param {Array | Matrix} [size] If provided, an array or matrix with given
   *                                size and filled with random values is returned
   * @param {number} [min]  Minimum boundary for the random value, included
   * @param {number} [max]  Maximum boundary for the random value, excluded
   * @return {number | Array | Matrix} A random number
   */ return typed($0410891c7115dc60$var$name, {
        "": ()=>_random(0, 1),
        number: (max)=>_random(0, max),
        "number, number": (min, max)=>_random(min, max),
        "Array | Matrix": (size)=>_randomMatrix(size, 0, 1),
        "Array | Matrix, number": (size, max)=>_randomMatrix(size, 0, max),
        "Array | Matrix, number, number": (size, min, max)=>_randomMatrix(size, min, max)
    });
    function _randomMatrix(size, min, max) {
        var res = (0, $020121c2fe1a81e4$export$6549281d357a44ec)(size.valueOf(), ()=>_random(min, max));
        return (0, $d8097b7a6d6e36d8$export$b22160e0a14f87b7)(size) ? size.create(res) : res;
    }
    function _random(min, max) {
        return min + rng() * (max - min);
    }
}); // number only implementation of random, no matrix support
var $0410891c7115dc60$export$267a132af241f602 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($0410891c7115dc60$var$name, [
    "typed",
    "config",
    "?on"
], (_ref2)=>{
    var { typed: typed, config: config, on: on, matrix: matrix } = _ref2;
    // seeded pseudo random number generator1
    var rng = (0, $1059d98e3912f47f$export$eaf9227667332084)(config.randomSeed);
    if (on) on("config", function(curr, prev) {
        if (curr.randomSeed !== prev.randomSeed) rng = (0, $1059d98e3912f47f$export$eaf9227667332084)(curr.randomSeed);
    });
    return typed($0410891c7115dc60$var$name, {
        "": ()=>_random(0, 1),
        number: (max)=>_random(0, max),
        "number, number": (min, max)=>_random(min, max)
    });
    function _random(min, max) {
        return min + rng() * (max - min);
    }
});



var $b18ec0992e5f4f5d$var$name = "re";
var $b18ec0992e5f4f5d$var$dependencies = [
    "typed"
];
var $b18ec0992e5f4f5d$export$803e46d0de790dbf = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($b18ec0992e5f4f5d$var$name, $b18ec0992e5f4f5d$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Get the real part of a complex number.
   * For a complex number `a + bi`, the function returns `a`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.re(x)
   *
   * Examples:
   *
   *    const a = math.complex(2, 3)
   *    math.re(a)                     // returns number 2
   *    math.im(a)                     // returns number 3
   *
   *    math.re(math.complex('-5.2i')) // returns number 0
   *    math.re(math.complex(2.4))     // returns number 2.4
   *
   * See also:
   *
   *    im, conj, abs, arg
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            A complex number or array with complex numbers
   * @return {number | BigNumber | Array | Matrix} The real part of x
   */ return typed($b18ec0992e5f4f5d$var$name, {
        number: function number(x) {
            return x;
        },
        BigNumber: function BigNumber(x) {
            return x;
        },
        Fraction: function Fraction(x) {
            return x;
        },
        Complex: function Complex(x) {
            return x.re;
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this);
        }
    });
});




var $bf2edef83a84ee5d$var$name = "sec";
var $bf2edef83a84ee5d$var$dependencies = [
    "typed",
    "BigNumber"
];
var $bf2edef83a84ee5d$export$5c169ecd5c25a09e = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($bf2edef83a84ee5d$var$name, $bf2edef83a84ee5d$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the secant of a value, defined as `sec(x) = 1/cos(x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.sec(x)
   *
   * Examples:
   *
   *    math.sec(2)      // returns number -2.4029979617223822
   *    1 / math.cos(2)  // returns number -2.4029979617223822
   *
   * See also:
   *
   *    cos, csc, cot
   *
   * @param {number | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Secant of x
   */ return typed($bf2edef83a84ee5d$var$name, {
        number: (0, $d10e9b2ec26dc177$export$ee1efc70bd8a6d93),
        Complex: function Complex(x) {
            return x.sec();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x.cos());
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function sec is no angle");
            return this(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this);
        }
    });
});




var $056afbcfb57540c1$var$name = "sign";
var $056afbcfb57540c1$var$dependencies = [
    "typed",
    "BigNumber",
    "Fraction",
    "complex"
];
var $056afbcfb57540c1$export$45df7cae684751af = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($056afbcfb57540c1$var$name, $056afbcfb57540c1$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber, complex: complex, Fraction: _Fraction } = _ref;
    /**
   * Compute the sign of a value. The sign of a value x is:
   *
   * -  1 when x > 0
   * - -1 when x < 0
   * -  0 when x == 0
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.sign(x)
   *
   * Examples:
   *
   *    math.sign(3.5)               // returns 1
   *    math.sign(-4.2)              // returns -1
   *    math.sign(0)                 // returns 0
   *
   *    math.sign([3, 5, -2, 0, 2])  // returns [1, 1, -1, 0, 1]
   *
   * See also:
   *
   *    abs
   *
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix | Unit} x
   *            The number for which to determine the sign
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix | Unit}e
   *            The sign of `x`
   */ return typed($056afbcfb57540c1$var$name, {
        number: (0, $4b37ed316f05dd33$export$af3d9fe43be78285),
        Complex: function Complex(x) {
            return x.im === 0 ? complex((0, $4b37ed316f05dd33$export$af3d9fe43be78285)(x.re)) : x.sign();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(x.cmp(0));
        },
        Fraction: function Fraction(x) {
            return new _Fraction(x.s, 1);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since sign(0) = 0
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this, true);
        },
        Unit: function Unit(x) {
            if (!x._isDerived() && x.units[0].unit.offset !== 0) throw new TypeError("sign is ambiguous for units with offset");
            return this(x.value);
        }
    });
});



var $be3842f86d00047d$var$name = "sin";
var $be3842f86d00047d$var$dependencies = [
    "typed"
];
var $be3842f86d00047d$export$4b4fac44ef379cae = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($be3842f86d00047d$var$name, $be3842f86d00047d$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Calculate the sine of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.sin(x)
   *
   * Examples:
   *
   *    math.sin(2)                      // returns number 0.9092974268256813
   *    math.sin(math.pi / 4)            // returns number 0.7071067811865475
   *    math.sin(math.unit(90, 'deg'))   // returns number 1
   *    math.sin(math.unit(30, 'deg'))   // returns number 0.5
   *
   *    const angle = 0.2
   *    math.pow(math.sin(angle), 2) + math.pow(math.cos(angle), 2) // returns number ~1
   *
   * See also:
   *
   *    cos, tan
   *
   * @param {number | BigNumber | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | BigNumber | Complex | Array | Matrix} Sine of x
   */ return typed($be3842f86d00047d$var$name, {
        number: Math.sin,
        Complex: function Complex(x) {
            return x.sin();
        },
        BigNumber: function BigNumber(x) {
            return x.sin();
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function sin is no angle");
            return this(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since sin(0) = 0
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this, true);
        }
    });
});








var $78eb395e24cc718a$var$name = "SparseMatrix";
var $78eb395e24cc718a$var$dependencies = [
    "typed",
    "equalScalar",
    "Matrix"
];
var $78eb395e24cc718a$export$a783ce8f6a98b2e5 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($78eb395e24cc718a$var$name, $78eb395e24cc718a$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar, Matrix: Matrix } = _ref;
    /**
   * Sparse Matrix implementation. This type implements
   * a [Compressed Column Storage](https://en.wikipedia.org/wiki/Sparse_matrix#Compressed_sparse_column_(CSC_or_CCS))
   * format for two-dimensional sparse matrices.
   * @class SparseMatrix
   */ function SparseMatrix(data, datatype) {
        if (!(this instanceof SparseMatrix)) throw new SyntaxError("Constructor must be called with the new operator");
        if (datatype && !(0, $d8097b7a6d6e36d8$export$844ec244b1367d54)(datatype)) throw new Error("Invalid datatype: " + datatype);
        if ((0, $d8097b7a6d6e36d8$export$b22160e0a14f87b7)(data)) // create from matrix
        _createFromMatrix(this, data, datatype);
        else if (data && (0, $d8097b7a6d6e36d8$export$43bee75e5e14138e)(data.index) && (0, $d8097b7a6d6e36d8$export$43bee75e5e14138e)(data.ptr) && (0, $d8097b7a6d6e36d8$export$43bee75e5e14138e)(data.size)) {
            // initialize fields
            this._values = data.values;
            this._index = data.index;
            this._ptr = data.ptr;
            this._size = data.size;
            this._datatype = datatype || data.datatype;
        } else if ((0, $d8097b7a6d6e36d8$export$43bee75e5e14138e)(data)) // create from array
        _createFromArray(this, data, datatype);
        else if (data) // unsupported type
        throw new TypeError("Unsupported type of data (" + (0, $d8097b7a6d6e36d8$export$f5bbd400c2f4426f)(data) + ")");
        else {
            // nothing provided
            this._values = [];
            this._index = [];
            this._ptr = [
                0
            ];
            this._size = [
                0,
                0
            ];
            this._datatype = datatype;
        }
    }
    function _createFromMatrix(matrix, source, datatype) {
        // check matrix type
        if (source.type === "SparseMatrix") {
            // clone arrays
            matrix._values = source._values ? (0, $6819694788cbfa38$export$9cd59f9826255e47)(source._values) : undefined;
            matrix._index = (0, $6819694788cbfa38$export$9cd59f9826255e47)(source._index);
            matrix._ptr = (0, $6819694788cbfa38$export$9cd59f9826255e47)(source._ptr);
            matrix._size = (0, $6819694788cbfa38$export$9cd59f9826255e47)(source._size);
            matrix._datatype = datatype || source._datatype;
        } else // build from matrix data
        _createFromArray(matrix, source.valueOf(), datatype || source._datatype);
    }
    function _createFromArray(matrix, data, datatype) {
        // initialize fields
        matrix._values = [];
        matrix._index = [];
        matrix._ptr = [];
        matrix._datatype = datatype; // discover rows & columns, do not use math.size() to avoid looping array twice
        var rows = data.length;
        var columns = 0; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0;
        if ((0, $d8097b7a6d6e36d8$export$844ec244b1367d54)(datatype)) {
            // find signature that matches (datatype, datatype)
            eq = typed.find(equalScalar, [
                datatype,
                datatype
            ]) || equalScalar; // convert 0 to the same datatype
            zero = typed.convert(0, datatype);
        } // check we have rows (empty array)
        if (rows > 0) {
            // column index
            var j = 0;
            do {
                // store pointer to values index
                matrix._ptr.push(matrix._index.length); // loop rows
                for(var i = 0; i < rows; i++){
                    // current row
                    var row = data[i]; // check row is an array
                    if ((0, $d8097b7a6d6e36d8$export$43bee75e5e14138e)(row)) {
                        // update columns if needed (only on first column)
                        if (j === 0 && columns < row.length) columns = row.length;
                         // check row has column
                        if (j < row.length) {
                            // value
                            var v = row[j]; // check value != 0
                            if (!eq(v, zero)) {
                                // store value
                                matrix._values.push(v); // index
                                matrix._index.push(i);
                            }
                        }
                    } else {
                        // update columns if needed (only on first column)
                        if (j === 0 && columns < 1) columns = 1;
                         // check value != 0 (row is a scalar)
                        if (!eq(row, zero)) {
                            // store value
                            matrix._values.push(row); // index
                            matrix._index.push(i);
                        }
                    }
                } // increment index
                j++;
            }while (j < columns);
        } // store number of values in ptr
        matrix._ptr.push(matrix._index.length); // size
        matrix._size = [
            rows,
            columns
        ];
    }
    SparseMatrix.prototype = new Matrix();
    /**
   * Create a new SparseMatrix
   */ SparseMatrix.prototype.createSparseMatrix = function(data, datatype) {
        return new SparseMatrix(data, datatype);
    };
    /**
   * Attach type information
   */ SparseMatrix.prototype.type = "SparseMatrix";
    SparseMatrix.prototype.isSparseMatrix = true;
    /**
   * Get the matrix type
   *
   * Usage:
   *    const matrixType = matrix.getDataType()  // retrieves the matrix type
   *
   * @memberOf SparseMatrix
   * @return {string}   type information; if multiple types are found from the Matrix, it will return "mixed"
   */ SparseMatrix.prototype.getDataType = function() {
        return (0, $a14a10567870d913$export$d31e00bf4359ea8b)(this._values, (0, $d8097b7a6d6e36d8$export$f5bbd400c2f4426f));
    };
    /**
   * Get the storage format used by the matrix.
   *
   * Usage:
   *     const format = matrix.storage()   // retrieve storage format
   *
   * @memberof SparseMatrix
   * @return {string}           The storage format.
   */ SparseMatrix.prototype.storage = function() {
        return "sparse";
    };
    /**
   * Get the datatype of the data stored in the matrix.
   *
   * Usage:
   *     const format = matrix.datatype()    // retrieve matrix datatype
   *
   * @memberof SparseMatrix
   * @return {string}           The datatype.
   */ SparseMatrix.prototype.datatype = function() {
        return this._datatype;
    };
    /**
   * Create a new SparseMatrix
   * @memberof SparseMatrix
   * @param {Array} data
   * @param {string} [datatype]
   */ SparseMatrix.prototype.create = function(data, datatype) {
        return new SparseMatrix(data, datatype);
    };
    /**
   * Get the matrix density.
   *
   * Usage:
   *     const density = matrix.density()                   // retrieve matrix density
   *
   * @memberof SparseMatrix
   * @return {number}           The matrix density.
   */ SparseMatrix.prototype.density = function() {
        // rows & columns
        var rows = this._size[0];
        var columns = this._size[1]; // calculate density
        return rows !== 0 && columns !== 0 ? this._index.length / (rows * columns) : 0;
    };
    /**
   * Get a subset of the matrix, or replace a subset of the matrix.
   *
   * Usage:
   *     const subset = matrix.subset(index)               // retrieve subset
   *     const value = matrix.subset(index, replacement)   // replace subset
   *
   * @memberof SparseMatrix
   * @param {Index} index
   * @param {Array | Matrix | *} [replacement]
   * @param {*} [defaultValue=0]      Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be filled with zeros.
   */ SparseMatrix.prototype.subset = function(index, replacement, defaultValue) {
        // check it is a pattern matrix
        if (!this._values) throw new Error("Cannot invoke subset on a Pattern only matrix");
         // check arguments
        switch(arguments.length){
            case 1:
                return _getsubset(this, index);
            // intentional fall through
            case 2:
            case 3:
                return _setsubset(this, index, replacement, defaultValue);
            default:
                throw new SyntaxError("Wrong number of arguments");
        }
    };
    function _getsubset(matrix, idx) {
        // check idx
        if (!(0, $d8097b7a6d6e36d8$export$ba3dc792055c2f45)(idx)) throw new TypeError("Invalid index");
        var isScalar = idx.isScalar();
        if (isScalar) // return a scalar
        return matrix.get(idx.min());
         // validate dimensions
        var size = idx.size();
        if (size.length !== matrix._size.length) throw new (0, $89c7b7a60bca4b11$export$ad1391ca020fdd96)(size.length, matrix._size.length);
         // vars
        var i, ii, k, kk; // validate if any of the ranges in the index is out of range
        var min = idx.min();
        var max = idx.max();
        for(i = 0, ii = matrix._size.length; i < ii; i++){
            (0, $a14a10567870d913$export$3cfe3fbfec03f260)(min[i], matrix._size[i]);
            (0, $a14a10567870d913$export$3cfe3fbfec03f260)(max[i], matrix._size[i]);
        } // matrix arrays
        var mvalues = matrix._values;
        var mindex = matrix._index;
        var mptr = matrix._ptr; // rows & columns dimensions for result matrix
        var rows = idx.dimension(0);
        var columns = idx.dimension(1); // workspace & permutation vector
        var w = [];
        var pv = []; // loop rows in resulting matrix
        rows.forEach(function(i, r) {
            // update permutation vector
            pv[i] = r[0]; // mark i in workspace
            w[i] = true;
        }); // result matrix arrays
        var values = mvalues ? [] : undefined;
        var index = [];
        var ptr = []; // loop columns in result matrix
        columns.forEach(function(j) {
            // update ptr
            ptr.push(index.length); // loop values in column j
            for(k = mptr[j], kk = mptr[j + 1]; k < kk; k++){
                // row
                i = mindex[k]; // check row is in result matrix
                if (w[i] === true) {
                    // push index
                    index.push(pv[i]); // check we need to process values
                    if (values) values.push(mvalues[k]);
                }
            }
        }); // update ptr
        ptr.push(index.length); // return matrix
        return new SparseMatrix({
            values: values,
            index: index,
            ptr: ptr,
            size: size,
            datatype: matrix._datatype
        });
    }
    function _setsubset(matrix, index, submatrix, defaultValue) {
        // check index
        if (!index || index.isIndex !== true) throw new TypeError("Invalid index");
         // get index size and check whether the index contains a single value
        var iSize = index.size();
        var isScalar = index.isScalar(); // calculate the size of the submatrix, and convert it into an Array if needed
        var sSize;
        if ((0, $d8097b7a6d6e36d8$export$b22160e0a14f87b7)(submatrix)) {
            // submatrix size
            sSize = submatrix.size(); // use array representation
            submatrix = submatrix.toArray();
        } else // get submatrix size (array, scalar)
        sSize = (0, $a14a10567870d913$export$51ffaee4afb683a5)(submatrix);
         // check index is a scalar
        if (isScalar) {
            // verify submatrix is a scalar
            if (sSize.length !== 0) throw new TypeError("Scalar expected");
             // set value
            matrix.set(index.min(), submatrix, defaultValue);
        } else {
            // validate dimensions, index size must be one or two dimensions
            if (iSize.length !== 1 && iSize.length !== 2) throw new (0, $89c7b7a60bca4b11$export$ad1391ca020fdd96)(iSize.length, matrix._size.length, "<");
             // check submatrix and index have the same dimensions
            if (sSize.length < iSize.length) {
                // calculate number of missing outer dimensions
                var i = 0;
                var outer = 0;
                while(iSize[i] === 1 && sSize[i] === 1)i++;
                while(iSize[i] === 1){
                    outer++;
                    i++;
                } // unsqueeze both outer and inner dimensions
                submatrix = (0, $a14a10567870d913$export$5a07c5202d40a604)(submatrix, iSize.length, outer, sSize);
            } // check whether the size of the submatrix matches the index size
            if (!(0, $6819694788cbfa38$export$6cc798251952180)(iSize, sSize)) throw new (0, $89c7b7a60bca4b11$export$ad1391ca020fdd96)(iSize, sSize, ">");
             // insert the sub matrix
            if (iSize.length === 1) {
                // if the replacement index only has 1 dimension, go trough each one and set its value
                var range = index.dimension(0);
                range.forEach(function(dataIndex, subIndex) {
                    (0, $a14a10567870d913$export$3cfe3fbfec03f260)(dataIndex);
                    matrix.set([
                        dataIndex,
                        0
                    ], submatrix[subIndex[0]], defaultValue);
                });
            } else {
                // if the replacement index has 2 dimensions, go through each one and set the value in the correct index
                var firstDimensionRange = index.dimension(0);
                var secondDimensionRange = index.dimension(1);
                firstDimensionRange.forEach(function(firstDataIndex, firstSubIndex) {
                    (0, $a14a10567870d913$export$3cfe3fbfec03f260)(firstDataIndex);
                    secondDimensionRange.forEach(function(secondDataIndex, secondSubIndex) {
                        (0, $a14a10567870d913$export$3cfe3fbfec03f260)(secondDataIndex);
                        matrix.set([
                            firstDataIndex,
                            secondDataIndex
                        ], submatrix[firstSubIndex[0]][secondSubIndex[0]], defaultValue);
                    });
                });
            }
        }
        return matrix;
    }
    /**
   * Get a single element from the matrix.
   * @memberof SparseMatrix
   * @param {number[]} index   Zero-based index
   * @return {*} value
   */ SparseMatrix.prototype.get = function(index) {
        if (!(0, $d8097b7a6d6e36d8$export$43bee75e5e14138e)(index)) throw new TypeError("Array expected");
        if (index.length !== this._size.length) throw new (0, $89c7b7a60bca4b11$export$ad1391ca020fdd96)(index.length, this._size.length);
         // check it is a pattern matrix
        if (!this._values) throw new Error("Cannot invoke get on a Pattern only matrix");
         // row and column
        var i = index[0];
        var j = index[1]; // check i, j are valid
        (0, $a14a10567870d913$export$3cfe3fbfec03f260)(i, this._size[0]);
        (0, $a14a10567870d913$export$3cfe3fbfec03f260)(j, this._size[1]); // find value index
        var k = _getValueIndex(i, this._ptr[j], this._ptr[j + 1], this._index); // check k is prior to next column k and it is in the correct row
        if (k < this._ptr[j + 1] && this._index[k] === i) return this._values[k];
        return 0;
    };
    /**
   * Replace a single element in the matrix.
   * @memberof SparseMatrix
   * @param {number[]} index   Zero-based index
   * @param {*} v
   * @param {*} [defaultValue]        Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be set to zero.
   * @return {SparseMatrix} self
   */ SparseMatrix.prototype.set = function(index, v, defaultValue) {
        if (!(0, $d8097b7a6d6e36d8$export$43bee75e5e14138e)(index)) throw new TypeError("Array expected");
        if (index.length !== this._size.length) throw new (0, $89c7b7a60bca4b11$export$ad1391ca020fdd96)(index.length, this._size.length);
         // check it is a pattern matrix
        if (!this._values) throw new Error("Cannot invoke set on a Pattern only matrix");
         // row and column
        var i = index[0];
        var j = index[1]; // rows & columns
        var rows = this._size[0];
        var columns = this._size[1]; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0;
        if ((0, $d8097b7a6d6e36d8$export$844ec244b1367d54)(this._datatype)) {
            // find signature that matches (datatype, datatype)
            eq = typed.find(equalScalar, [
                this._datatype,
                this._datatype
            ]) || equalScalar; // convert 0 to the same datatype
            zero = typed.convert(0, this._datatype);
        } // check we need to resize matrix
        if (i > rows - 1 || j > columns - 1) {
            // resize matrix
            _resize(this, Math.max(i + 1, rows), Math.max(j + 1, columns), defaultValue); // update rows & columns
            rows = this._size[0];
            columns = this._size[1];
        } // check i, j are valid
        (0, $a14a10567870d913$export$3cfe3fbfec03f260)(i, rows);
        (0, $a14a10567870d913$export$3cfe3fbfec03f260)(j, columns); // find value index
        var k = _getValueIndex(i, this._ptr[j], this._ptr[j + 1], this._index); // check k is prior to next column k and it is in the correct row
        if (k < this._ptr[j + 1] && this._index[k] === i) {
            // check value != 0
            if (!eq(v, zero)) // update value
            this._values[k] = v;
            else // remove value from matrix
            _remove(k, j, this._values, this._index, this._ptr);
        } else // insert value @ (i, j)
        _insert(k, i, j, v, this._values, this._index, this._ptr);
        return this;
    };
    function _getValueIndex(i, top, bottom, index) {
        // check row is on the bottom side
        if (bottom - top === 0) return bottom;
         // loop rows [top, bottom[
        for(var r = top; r < bottom; r++){
            // check we found value index
            if (index[r] === i) return r;
        } // we did not find row
        return top;
    }
    function _remove(k, j, values, index, ptr) {
        // remove value @ k
        values.splice(k, 1);
        index.splice(k, 1); // update pointers
        for(var x = j + 1; x < ptr.length; x++)ptr[x]--;
    }
    function _insert(k, i, j, v, values, index, ptr) {
        // insert value
        values.splice(k, 0, v); // update row for k
        index.splice(k, 0, i); // update column pointers
        for(var x = j + 1; x < ptr.length; x++)ptr[x]++;
    }
    /**
   * Resize the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (resize in place).
   *
   * @memberof SparseMatrix
   * @param {number[] | Matrix} size  The new size the matrix should have.
   *                                  Since sparse matrices are always two-dimensional,
   *                                  size must be two numbers in either an array or a matrix
   * @param {*} [defaultValue=0]      Default value, filled in on new entries.
   *                                  If not provided, the matrix elements will
   *                                  be filled with zeros.
   * @param {boolean} [copy]          Return a resized copy of the matrix
   *
   * @return {Matrix}                 The resized matrix
   */ SparseMatrix.prototype.resize = function(size, defaultValue, copy) {
        // validate arguments
        if (!(0, $d8097b7a6d6e36d8$export$cea7aa84e978eba5)(size)) throw new TypeError("Array or Matrix expected");
         // SparseMatrix input is always 2d, flatten this into 1d if it's indeed a vector
        var sizeArray = size.valueOf().map((value)=>{
            return Array.isArray(value) && value.length === 1 ? value[0] : value;
        });
        if (sizeArray.length !== 2) throw new Error("Only two dimensions matrix are supported");
         // check sizes
        sizeArray.forEach(function(value) {
            if (!(0, $d8097b7a6d6e36d8$export$7e4aa119212bc614)(value) || !(0, $668e051498bf5fa0$export$a287f47fed4544b8)(value) || value < 0) throw new TypeError("Invalid size, must contain positive integers (size: " + (0, $b94963e97c376b6d$export$d9468344d3651243)(sizeArray) + ")");
        }); // matrix to resize
        var m = copy ? this.clone() : this; // resize matrix
        return _resize(m, sizeArray[0], sizeArray[1], defaultValue);
    };
    function _resize(matrix, rows, columns, defaultValue) {
        // value to insert at the time of growing matrix
        var value = defaultValue || 0; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0;
        if ((0, $d8097b7a6d6e36d8$export$844ec244b1367d54)(matrix._datatype)) {
            // find signature that matches (datatype, datatype)
            eq = typed.find(equalScalar, [
                matrix._datatype,
                matrix._datatype
            ]) || equalScalar; // convert 0 to the same datatype
            zero = typed.convert(0, matrix._datatype); // convert value to the same datatype
            value = typed.convert(value, matrix._datatype);
        } // should we insert the value?
        var ins = !eq(value, zero); // old columns and rows
        var r = matrix._size[0];
        var c = matrix._size[1];
        var i, j, k; // check we need to increase columns
        if (columns > c) {
            // loop new columns
            for(j = c; j < columns; j++){
                // update matrix._ptr for current column
                matrix._ptr[j] = matrix._values.length; // check we need to insert matrix._values
                if (ins) // loop rows
                for(i = 0; i < r; i++){
                    // add new matrix._values
                    matrix._values.push(value); // update matrix._index
                    matrix._index.push(i);
                }
            } // store number of matrix._values in matrix._ptr
            matrix._ptr[columns] = matrix._values.length;
        } else if (columns < c) {
            // truncate matrix._ptr
            matrix._ptr.splice(columns + 1, c - columns); // truncate matrix._values and matrix._index
            matrix._values.splice(matrix._ptr[columns], matrix._values.length);
            matrix._index.splice(matrix._ptr[columns], matrix._index.length);
        } // update columns
        c = columns; // check we need to increase rows
        if (rows > r) // check we have to insert values
        {
            if (ins) {
                // inserts
                var n = 0; // loop columns
                for(j = 0; j < c; j++){
                    // update matrix._ptr for current column
                    matrix._ptr[j] = matrix._ptr[j] + n; // where to insert matrix._values
                    k = matrix._ptr[j + 1] + n; // pointer
                    var p = 0; // loop new rows, initialize pointer
                    for(i = r; i < rows; i++, p++){
                        // add value
                        matrix._values.splice(k + p, 0, value); // update matrix._index
                        matrix._index.splice(k + p, 0, i); // increment inserts
                        n++;
                    }
                } // store number of matrix._values in matrix._ptr
                matrix._ptr[c] = matrix._values.length;
            }
        } else if (rows < r) {
            // deletes
            var d = 0; // loop columns
            for(j = 0; j < c; j++){
                // update matrix._ptr for current column
                matrix._ptr[j] = matrix._ptr[j] - d; // where matrix._values start for next column
                var k0 = matrix._ptr[j];
                var k1 = matrix._ptr[j + 1] - d; // loop matrix._index
                for(k = k0; k < k1; k++){
                    // row
                    i = matrix._index[k]; // check we need to delete value and matrix._index
                    if (i > rows - 1) {
                        // remove value
                        matrix._values.splice(k, 1); // remove item from matrix._index
                        matrix._index.splice(k, 1); // increase deletes
                        d++;
                    }
                }
            } // update matrix._ptr for current column
            matrix._ptr[j] = matrix._values.length;
        } // update matrix._size
        matrix._size[0] = rows;
        matrix._size[1] = columns; // return matrix
        return matrix;
    }
    /**
   * Reshape the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (reshape in place).
   *
   * NOTE: This might be better suited to copy by default, instead of modifying
   *       in place. For now, it operates in place to remain consistent with
   *       resize().
   *
   * @memberof SparseMatrix
   * @param {number[]} sizes          The new size the matrix should have.
   *                                  Since sparse matrices are always two-dimensional,
   *                                  size must be two numbers in either an array or a matrix
   * @param {boolean} [copy]          Return a reshaped copy of the matrix
   *
   * @return {Matrix}                 The reshaped matrix
   */ SparseMatrix.prototype.reshape = function(sizes, copy) {
        // validate arguments
        if (!(0, $d8097b7a6d6e36d8$export$43bee75e5e14138e)(sizes)) throw new TypeError("Array expected");
        if (sizes.length !== 2) throw new Error("Sparse matrices can only be reshaped in two dimensions");
         // check sizes
        sizes.forEach(function(value) {
            if (!(0, $d8097b7a6d6e36d8$export$7e4aa119212bc614)(value) || !(0, $668e051498bf5fa0$export$a287f47fed4544b8)(value) || value <= -2 || value === 0) throw new TypeError("Invalid size, must contain positive integers or -1 (size: " + (0, $b94963e97c376b6d$export$d9468344d3651243)(sizes) + ")");
        });
        var currentLength = this._size[0] * this._size[1];
        sizes = (0, $a14a10567870d913$export$d0efc868ac2c6822)(sizes, currentLength);
        var newLength = sizes[0] * sizes[1]; // m * n must not change
        if (currentLength !== newLength) throw new Error("Reshaping sparse matrix will result in the wrong number of elements");
         // matrix to reshape
        var m = copy ? this.clone() : this; // return unchanged if the same shape
        if (this._size[0] === sizes[0] && this._size[1] === sizes[1]) return m;
         // Convert to COO format (generate a column index)
        var colIndex = [];
        for(var i = 0; i < m._ptr.length; i++)for(var j = 0; j < m._ptr[i + 1] - m._ptr[i]; j++)colIndex.push(i);
         // Clone the values array
        var values = m._values.slice(); // Clone the row index array
        var rowIndex = m._index.slice(); // Transform the (row, column) indices
        for(var _i = 0; _i < m._index.length; _i++){
            var r1 = rowIndex[_i];
            var c1 = colIndex[_i];
            var flat = r1 * m._size[1] + c1;
            colIndex[_i] = flat % sizes[1];
            rowIndex[_i] = Math.floor(flat / sizes[1]);
        } // Now reshaping is supposed to preserve the row-major order, BUT these sparse matrices are stored
        // in column-major order, so we have to reorder the value array now. One option is to use a multisort,
        // sorting several arrays based on some other array.
        // OR, we could easily just:
        // 1. Remove all values from the matrix
        m._values.length = 0;
        m._index.length = 0;
        m._ptr.length = sizes[1] + 1;
        m._size = sizes.slice();
        for(var _i2 = 0; _i2 < m._ptr.length; _i2++)m._ptr[_i2] = 0;
         // 2. Re-insert all elements in the proper order (simplified code from SparseMatrix.prototype.set)
        // This step is probably the most time-consuming
        for(var h = 0; h < values.length; h++){
            var _i3 = rowIndex[h];
            var _j = colIndex[h];
            var v = values[h];
            var k = _getValueIndex(_i3, m._ptr[_j], m._ptr[_j + 1], m._index);
            _insert(k, _i3, _j, v, m._values, m._index, m._ptr);
        } // The value indices are inserted out of order, but apparently that's... still OK?
        return m;
    };
    /**
   * Create a clone of the matrix
   * @memberof SparseMatrix
   * @return {SparseMatrix} clone
   */ SparseMatrix.prototype.clone = function() {
        var m = new SparseMatrix({
            values: this._values ? (0, $6819694788cbfa38$export$9cd59f9826255e47)(this._values) : undefined,
            index: (0, $6819694788cbfa38$export$9cd59f9826255e47)(this._index),
            ptr: (0, $6819694788cbfa38$export$9cd59f9826255e47)(this._ptr),
            size: (0, $6819694788cbfa38$export$9cd59f9826255e47)(this._size),
            datatype: this._datatype
        });
        return m;
    };
    /**
   * Retrieve the size of the matrix.
   * @memberof SparseMatrix
   * @returns {number[]} size
   */ SparseMatrix.prototype.size = function() {
        return this._size.slice(0); // copy the Array
    };
    /**
   * Create a new matrix with the results of the callback function executed on
   * each entry of the matrix.
   * @memberof SparseMatrix
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   * @param {boolean} [skipZeros] Invoke callback function for non-zero values only.
   *
   * @return {SparseMatrix} matrix
   */ SparseMatrix.prototype.map = function(callback, skipZeros) {
        // check it is a pattern matrix
        if (!this._values) throw new Error("Cannot invoke map on a Pattern only matrix");
         // matrix instance
        var me = this; // rows and columns
        var rows = this._size[0];
        var columns = this._size[1]; // invoke callback
        var invoke = function invoke(v, i, j) {
            // invoke callback
            return callback(v, [
                i,
                j
            ], me);
        }; // invoke _map
        return _map(this, 0, rows - 1, 0, columns - 1, invoke, skipZeros);
    };
    /**
   * Create a new matrix with the results of the callback function executed on the interval
   * [minRow..maxRow, minColumn..maxColumn].
   */ function _map(matrix, minRow, maxRow, minColumn, maxColumn, callback, skipZeros) {
        // result arrays
        var values = [];
        var index = [];
        var ptr = []; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0;
        if ((0, $d8097b7a6d6e36d8$export$844ec244b1367d54)(matrix._datatype)) {
            // find signature that matches (datatype, datatype)
            eq = typed.find(equalScalar, [
                matrix._datatype,
                matrix._datatype
            ]) || equalScalar; // convert 0 to the same datatype
            zero = typed.convert(0, matrix._datatype);
        } // invoke callback
        var invoke = function invoke(v, x, y) {
            // invoke callback
            v = callback(v, x, y); // check value != 0
            if (!eq(v, zero)) {
                // store value
                values.push(v); // index
                index.push(x);
            }
        }; // loop columns
        for(var j = minColumn; j <= maxColumn; j++){
            // store pointer to values index
            ptr.push(values.length); // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = matrix._ptr[j];
            var k1 = matrix._ptr[j + 1];
            if (skipZeros) // loop k within [k0, k1[
            for(var k = k0; k < k1; k++){
                // row index
                var i = matrix._index[k]; // check i is in range
                if (i >= minRow && i <= maxRow) // value @ k
                invoke(matrix._values[k], i - minRow, j - minColumn);
            }
            else {
                // create a cache holding all defined values
                var _values = {};
                for(var _k = k0; _k < k1; _k++){
                    var _i4 = matrix._index[_k];
                    _values[_i4] = matrix._values[_k];
                } // loop over all rows (indexes can be unordered so we can't use that),
                // and either read the value or zero
                for(var _i5 = minRow; _i5 <= maxRow; _i5++){
                    var value = _i5 in _values ? _values[_i5] : 0;
                    invoke(value, _i5 - minRow, j - minColumn);
                }
            }
        } // store number of values in ptr
        ptr.push(values.length); // return sparse matrix
        return new SparseMatrix({
            values: values,
            index: index,
            ptr: ptr,
            size: [
                maxRow - minRow + 1,
                maxColumn - minColumn + 1
            ]
        });
    }
    /**
   * Execute a callback function on each entry of the matrix.
   * @memberof SparseMatrix
   * @param {Function} callback   The callback function is invoked with three
   *                              parameters: the value of the element, the index
   *                              of the element, and the Matrix being traversed.
   * @param {boolean} [skipZeros] Invoke callback function for non-zero values only.
   *                              If false, the indices are guaranteed to be in order,
   *                              if true, the indices can be unordered.
   */ SparseMatrix.prototype.forEach = function(callback, skipZeros) {
        // check it is a pattern matrix
        if (!this._values) throw new Error("Cannot invoke forEach on a Pattern only matrix");
         // matrix instance
        var me = this; // rows and columns
        var rows = this._size[0];
        var columns = this._size[1]; // loop columns
        for(var j = 0; j < columns; j++){
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = this._ptr[j];
            var k1 = this._ptr[j + 1];
            if (skipZeros) // loop k within [k0, k1[
            for(var k = k0; k < k1; k++){
                // row index
                var i = this._index[k]; // value @ k
                callback(this._values[k], [
                    i,
                    j
                ], me);
            }
            else {
                // create a cache holding all defined values
                var values = {};
                for(var _k2 = k0; _k2 < k1; _k2++){
                    var _i6 = this._index[_k2];
                    values[_i6] = this._values[_k2];
                } // loop over all rows (indexes can be unordered so we can't use that),
                // and either read the value or zero
                for(var _i7 = 0; _i7 < rows; _i7++){
                    var value = _i7 in values ? values[_i7] : 0;
                    callback(value, [
                        _i7,
                        j
                    ], me);
                }
            }
        }
    };
    /**
   * Iterate over the matrix elements, skipping zeros
   * @return {Iterable<{ value, index: number[] }>}
   */ SparseMatrix.prototype[Symbol.iterator] = function*() {
        if (!this._values) throw new Error("Cannot iterate a Pattern only matrix");
        var columns = this._size[1];
        for(var j = 0; j < columns; j++){
            var k0 = this._ptr[j];
            var k1 = this._ptr[j + 1];
            for(var k = k0; k < k1; k++){
                // row index
                var i = this._index[k];
                yield {
                    value: this._values[k],
                    index: [
                        i,
                        j
                    ]
                };
            }
        }
    };
    /**
   * Create an Array with a copy of the data of the SparseMatrix
   * @memberof SparseMatrix
   * @returns {Array} array
   */ SparseMatrix.prototype.toArray = function() {
        return _toArray(this._values, this._index, this._ptr, this._size, true);
    };
    /**
   * Get the primitive value of the SparseMatrix: a two dimensions array
   * @memberof SparseMatrix
   * @returns {Array} array
   */ SparseMatrix.prototype.valueOf = function() {
        return _toArray(this._values, this._index, this._ptr, this._size, false);
    };
    function _toArray(values, index, ptr, size, copy) {
        // rows and columns
        var rows = size[0];
        var columns = size[1]; // result
        var a = []; // vars
        var i, j; // initialize array
        for(i = 0; i < rows; i++){
            a[i] = [];
            for(j = 0; j < columns; j++)a[i][j] = 0;
        } // loop columns
        for(j = 0; j < columns; j++){
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = ptr[j];
            var k1 = ptr[j + 1]; // loop k within [k0, k1[
            for(var k = k0; k < k1; k++){
                // row index
                i = index[k]; // set value (use one for pattern matrix)
                a[i][j] = values ? copy ? (0, $6819694788cbfa38$export$9cd59f9826255e47)(values[k]) : values[k] : 1;
            }
        }
        return a;
    }
    /**
   * Get a string representation of the matrix, with optional formatting options.
   * @memberof SparseMatrix
   * @param {Object | number | Function} [options]  Formatting options. See
   *                                                lib/utils/number:format for a
   *                                                description of the available
   *                                                options.
   * @returns {string} str
   */ SparseMatrix.prototype.format = function(options) {
        // rows and columns
        var rows = this._size[0];
        var columns = this._size[1]; // density
        var density = this.density(); // rows & columns
        var str = "Sparse Matrix [" + (0, $b94963e97c376b6d$export$d9468344d3651243)(rows, options) + " x " + (0, $b94963e97c376b6d$export$d9468344d3651243)(columns, options) + "] density: " + (0, $b94963e97c376b6d$export$d9468344d3651243)(density, options) + "\n"; // loop columns
        for(var j = 0; j < columns; j++){
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = this._ptr[j];
            var k1 = this._ptr[j + 1]; // loop k within [k0, k1[
            for(var k = k0; k < k1; k++){
                // row index
                var i = this._index[k]; // append value
                str += "\n    (" + (0, $b94963e97c376b6d$export$d9468344d3651243)(i, options) + ", " + (0, $b94963e97c376b6d$export$d9468344d3651243)(j, options) + ") ==> " + (this._values ? (0, $b94963e97c376b6d$export$d9468344d3651243)(this._values[k], options) : "X");
            }
        }
        return str;
    };
    /**
   * Get a string representation of the matrix
   * @memberof SparseMatrix
   * @returns {string} str
   */ SparseMatrix.prototype.toString = function() {
        return (0, $b94963e97c376b6d$export$d9468344d3651243)(this.toArray());
    };
    /**
   * Get a JSON representation of the matrix
   * @memberof SparseMatrix
   * @returns {Object}
   */ SparseMatrix.prototype.toJSON = function() {
        return {
            mathjs: "SparseMatrix",
            values: this._values,
            index: this._index,
            ptr: this._ptr,
            size: this._size,
            datatype: this._datatype
        };
    };
    /**
   * Get the kth Matrix diagonal.
   *
   * @memberof SparseMatrix
   * @param {number | BigNumber} [k=0]     The kth diagonal where the vector will retrieved.
   *
   * @returns {Matrix}                     The matrix vector with the diagonal values.
   */ SparseMatrix.prototype.diagonal = function(k) {
        // validate k if any
        if (k) {
            // convert BigNumber to a number
            if ((0, $d8097b7a6d6e36d8$export$e51d0e7e5c4a03ab)(k)) k = k.toNumber();
             // is must be an integer
            if (!(0, $d8097b7a6d6e36d8$export$7e4aa119212bc614)(k) || !(0, $668e051498bf5fa0$export$a287f47fed4544b8)(k)) throw new TypeError("The parameter k must be an integer number");
        } else // default value
        k = 0;
        var kSuper = k > 0 ? k : 0;
        var kSub = k < 0 ? -k : 0; // rows & columns
        var rows = this._size[0];
        var columns = this._size[1]; // number diagonal values
        var n = Math.min(rows - kSub, columns - kSuper); // diagonal arrays
        var values = [];
        var index = [];
        var ptr = []; // initial ptr value
        ptr[0] = 0; // loop columns
        for(var j = kSuper; j < columns && values.length < n; j++){
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = this._ptr[j];
            var k1 = this._ptr[j + 1]; // loop x within [k0, k1[
            for(var x = k0; x < k1; x++){
                // row index
                var i = this._index[x]; // check row
                if (i === j - kSuper + kSub) {
                    // value on this column
                    values.push(this._values[x]); // store row
                    index[values.length - 1] = i - kSub; // exit loop
                    break;
                }
            }
        } // close ptr
        ptr.push(values.length); // return matrix
        return new SparseMatrix({
            values: values,
            index: index,
            ptr: ptr,
            size: [
                n,
                1
            ]
        });
    };
    /**
   * Generate a matrix from a JSON object
   * @memberof SparseMatrix
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "SparseMatrix", "values": [], "index": [], "ptr": [], "size": []}`,
   *                       where mathjs is optional
   * @returns {SparseMatrix}
   */ SparseMatrix.fromJSON = function(json) {
        return new SparseMatrix(json);
    };
    /**
   * Create a diagonal matrix.
   *
   * @memberof SparseMatrix
   * @param {Array} size                       The matrix size.
   * @param {number | Array | Matrix } value   The values for the diagonal.
   * @param {number | BigNumber} [k=0]         The kth diagonal where the vector will be filled in.
   * @param {number} [defaultValue]            The default value for non-diagonal
   * @param {string} [datatype]                The Matrix datatype, values must be of this datatype.
   *
   * @returns {SparseMatrix}
   */ SparseMatrix.diagonal = function(size, value, k, defaultValue, datatype) {
        if (!(0, $d8097b7a6d6e36d8$export$43bee75e5e14138e)(size)) throw new TypeError("Array expected, size parameter");
        if (size.length !== 2) throw new Error("Only two dimensions matrix are supported");
         // map size & validate
        size = size.map(function(s) {
            // check it is a big number
            if ((0, $d8097b7a6d6e36d8$export$e51d0e7e5c4a03ab)(s)) // convert it
            s = s.toNumber();
             // validate arguments
            if (!(0, $d8097b7a6d6e36d8$export$7e4aa119212bc614)(s) || !(0, $668e051498bf5fa0$export$a287f47fed4544b8)(s) || s < 1) throw new Error("Size values must be positive integers");
            return s;
        }); // validate k if any
        if (k) {
            // convert BigNumber to a number
            if ((0, $d8097b7a6d6e36d8$export$e51d0e7e5c4a03ab)(k)) k = k.toNumber();
             // is must be an integer
            if (!(0, $d8097b7a6d6e36d8$export$7e4aa119212bc614)(k) || !(0, $668e051498bf5fa0$export$a287f47fed4544b8)(k)) throw new TypeError("The parameter k must be an integer number");
        } else // default value
        k = 0;
         // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0;
        if ((0, $d8097b7a6d6e36d8$export$844ec244b1367d54)(datatype)) {
            // find signature that matches (datatype, datatype)
            eq = typed.find(equalScalar, [
                datatype,
                datatype
            ]) || equalScalar; // convert 0 to the same datatype
            zero = typed.convert(0, datatype);
        }
        var kSuper = k > 0 ? k : 0;
        var kSub = k < 0 ? -k : 0; // rows and columns
        var rows = size[0];
        var columns = size[1]; // number of non-zero items
        var n = Math.min(rows - kSub, columns - kSuper); // value extraction function
        var _value; // check value
        if ((0, $d8097b7a6d6e36d8$export$43bee75e5e14138e)(value)) {
            // validate array
            if (value.length !== n) // number of values in array must be n
            throw new Error("Invalid value array length");
             // define function
            _value = function _value(i) {
                // return value @ i
                return value[i];
            };
        } else if ((0, $d8097b7a6d6e36d8$export$b22160e0a14f87b7)(value)) {
            // matrix size
            var ms = value.size(); // validate matrix
            if (ms.length !== 1 || ms[0] !== n) // number of values in array must be n
            throw new Error("Invalid matrix length");
             // define function
            _value = function _value(i) {
                // return value @ i
                return value.get([
                    i
                ]);
            };
        } else // define function
        _value = function _value() {
            // return value
            return value;
        };
         // create arrays
        var values = [];
        var index = [];
        var ptr = []; // loop items
        for(var j = 0; j < columns; j++){
            // number of rows with value
            ptr.push(values.length); // diagonal index
            var i = j - kSuper; // check we need to set diagonal value
            if (i >= 0 && i < n) {
                // get value @ i
                var v = _value(i); // check for zero
                if (!eq(v, zero)) {
                    // column
                    index.push(i + kSub); // add value
                    values.push(v);
                }
            }
        } // last value should be number of values
        ptr.push(values.length); // create SparseMatrix
        return new SparseMatrix({
            values: values,
            index: index,
            ptr: ptr,
            size: [
                rows,
                columns
            ]
        });
    };
    /**
   * Swap rows i and j in Matrix.
   *
   * @memberof SparseMatrix
   * @param {number} i       Matrix row index 1
   * @param {number} j       Matrix row index 2
   *
   * @return {Matrix}        The matrix reference
   */ SparseMatrix.prototype.swapRows = function(i, j) {
        // check index
        if (!(0, $d8097b7a6d6e36d8$export$7e4aa119212bc614)(i) || !(0, $668e051498bf5fa0$export$a287f47fed4544b8)(i) || !(0, $d8097b7a6d6e36d8$export$7e4aa119212bc614)(j) || !(0, $668e051498bf5fa0$export$a287f47fed4544b8)(j)) throw new Error("Row index must be positive integers");
         // check dimensions
        if (this._size.length !== 2) throw new Error("Only two dimensional matrix is supported");
         // validate index
        (0, $a14a10567870d913$export$3cfe3fbfec03f260)(i, this._size[0]);
        (0, $a14a10567870d913$export$3cfe3fbfec03f260)(j, this._size[0]); // swap rows
        SparseMatrix._swapRows(i, j, this._size[1], this._values, this._index, this._ptr); // return current instance
        return this;
    };
    /**
   * Loop rows with data in column j.
   *
   * @param {number} j            Column
   * @param {Array} values        Matrix values
   * @param {Array} index         Matrix row indeces
   * @param {Array} ptr           Matrix column pointers
   * @param {Function} callback   Callback function invoked for every row in column j
   */ SparseMatrix._forEachRow = function(j, values, index, ptr, callback) {
        // indeces for column j
        var k0 = ptr[j];
        var k1 = ptr[j + 1]; // loop
        for(var k = k0; k < k1; k++)// invoke callback
        callback(index[k], values[k]);
    };
    /**
   * Swap rows x and y in Sparse Matrix data structures.
   *
   * @param {number} x         Matrix row index 1
   * @param {number} y         Matrix row index 2
   * @param {number} columns   Number of columns in matrix
   * @param {Array} values     Matrix values
   * @param {Array} index      Matrix row indeces
   * @param {Array} ptr        Matrix column pointers
   */ SparseMatrix._swapRows = function(x, y, columns, values, index, ptr) {
        // loop columns
        for(var j = 0; j < columns; j++){
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = ptr[j];
            var k1 = ptr[j + 1]; // find value index @ x
            var kx = _getValueIndex(x, k0, k1, index); // find value index @ x
            var ky = _getValueIndex(y, k0, k1, index); // check both rows exist in matrix
            if (kx < k1 && ky < k1 && index[kx] === x && index[ky] === y) {
                // swap values (check for pattern matrix)
                if (values) {
                    var v = values[kx];
                    values[kx] = values[ky];
                    values[ky] = v;
                } // next column
                continue;
            } // check x row exist & no y row
            if (kx < k1 && index[kx] === x && (ky >= k1 || index[ky] !== y)) {
                // value @ x (check for pattern matrix)
                var vx = values ? values[kx] : undefined; // insert value @ y
                index.splice(ky, 0, y);
                if (values) values.splice(ky, 0, vx);
                 // remove value @ x (adjust array index if needed)
                index.splice(ky <= kx ? kx + 1 : kx, 1);
                if (values) values.splice(ky <= kx ? kx + 1 : kx, 1);
                 // next column
                continue;
            } // check y row exist & no x row
            if (ky < k1 && index[ky] === y && (kx >= k1 || index[kx] !== x)) {
                // value @ y (check for pattern matrix)
                var vy = values ? values[ky] : undefined; // insert value @ x
                index.splice(kx, 0, x);
                if (values) values.splice(kx, 0, vy);
                 // remove value @ y (adjust array index if needed)
                index.splice(kx <= ky ? ky + 1 : ky, 1);
                if (values) values.splice(kx <= ky ? ky + 1 : ky, 1);
            }
        }
    };
    return SparseMatrix;
}, {
    isClass: true
});


var $dbbf0806472e2299$var$name = "splitUnit";
var $dbbf0806472e2299$var$dependencies = [
    "typed"
];
var $dbbf0806472e2299$export$a9f61753ee14ea96 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($dbbf0806472e2299$var$name, $dbbf0806472e2299$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Split a unit in an array of units whose sum is equal to the original unit.
   *
   * Syntax:
   *
   *     splitUnit(unit: Unit, parts: Array.<Unit>)
   *
   * Example:
   *
   *     math.splitUnit(new Unit(1, 'm'), ['feet', 'inch'])
   *     // [ 3 feet, 3.3700787401575 inch ]
   *
   * See also:
   *
   *     unit
   *
   * @param {Array} [parts] An array of strings or valueless units.
   * @return {Array} An array of units.
   */ return typed($dbbf0806472e2299$var$name, {
        "Unit, Array": function UnitArray(unit, parts) {
            return unit.splitUnit(parts);
        }
    });
});




var $b2fbb66eda80dbcf$var$name = "square";
var $b2fbb66eda80dbcf$var$dependencies = [
    "typed"
];
var $b2fbb66eda80dbcf$export$4ba960a63f731b0b = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($b2fbb66eda80dbcf$var$name, $b2fbb66eda80dbcf$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Compute the square of a value, `x * x`.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.square(x)
   *
   * Examples:
   *
   *    math.square(2)           // returns number 4
   *    math.square(3)           // returns number 9
   *    math.pow(3, 2)           // returns number 9
   *    math.multiply(3, 3)      // returns number 9
   *
   *    math.square([1, 2, 3, 4])  // returns Array [1, 4, 9, 16]
   *
   * See also:
   *
   *    multiply, cube, sqrt, pow
   *
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix | Unit} x
   *            Number for which to calculate the square
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix | Unit}
   *            Squared value
   */ return typed($b2fbb66eda80dbcf$var$name, {
        number: (0, $4b37ed316f05dd33$export$c4094a156ed9ab35),
        Complex: function Complex(x) {
            return x.mul(x);
        },
        BigNumber: function BigNumber(x) {
            return x.times(x);
        },
        Fraction: function Fraction(x) {
            return x.mul(x);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since square(0) = 0
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this, true);
        },
        Unit: function Unit(x) {
            return x.pow(2);
        }
    });
});




var $f9e9a1efd9d04759$var$name = "string";
var $f9e9a1efd9d04759$var$dependencies = [
    "typed"
];
var $f9e9a1efd9d04759$export$b2cf5914f5f18823 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($f9e9a1efd9d04759$var$name, $f9e9a1efd9d04759$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Create a string or convert any object into a string.
   * Elements of Arrays and Matrices are processed element wise.
   *
   * Syntax:
   *
   *    math.string(value)
   *
   * Examples:
   *
   *    math.string(4.2)               // returns string '4.2'
   *    math.string(math.complex(3, 2) // returns string '3 + 2i'
   *
   *    const u = math.unit(5, 'km')
   *    math.string(u.to('m'))         // returns string '5000 m'
   *
   *    math.string([true, false])     // returns ['true', 'false']
   *
   * See also:
   *
   *    bignumber, boolean, complex, index, matrix, number, unit
   *
   * @param {* | Array | Matrix | null} [value]  A value to convert to a string
   * @return {string | Array | Matrix} The created string
   */ return typed($f9e9a1efd9d04759$var$name, {
        "": function _() {
            return "";
        },
        number: (0, $668e051498bf5fa0$export$d9468344d3651243),
        null: function _null(x) {
            return "null";
        },
        boolean: function boolean(x) {
            return x + "";
        },
        string: function string(x) {
            return x;
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this);
        },
        any: function any(x) {
            return String(x);
        }
    });
});



var $5df0f80da18cbed1$var$name = "tan";
var $5df0f80da18cbed1$var$dependencies = [
    "typed"
];
var $5df0f80da18cbed1$export$b61ad4f38fd9301d = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($5df0f80da18cbed1$var$name, $5df0f80da18cbed1$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Calculate the tangent of a value. `tan(x)` is equal to `sin(x) / cos(x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.tan(x)
   *
   * Examples:
   *
   *    math.tan(0.5)                    // returns number 0.5463024898437905
   *    math.sin(0.5) / math.cos(0.5)    // returns number 0.5463024898437905
   *    math.tan(math.pi / 4)            // returns number 1
   *    math.tan(math.unit(45, 'deg'))   // returns number 1
   *
   * See also:
   *
   *    atan, sin, cos
   *
   * @param {number | BigNumber | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | BigNumber | Complex | Array | Matrix} Tangent of x
   */ return typed($5df0f80da18cbed1$var$name, {
        number: Math.tan,
        Complex: function Complex(x) {
            return x.tan();
        },
        BigNumber: function BigNumber(x) {
            return x.tan();
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function tan is no angle");
            return this(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since tan(0) = 0
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this, true);
        }
    });
});



var $caaa070b381cb64f$var$name = "typeOf";
var $caaa070b381cb64f$var$dependencies = [
    "typed"
];
var $caaa070b381cb64f$export$d7acf116afef7b4d = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($caaa070b381cb64f$var$name, $caaa070b381cb64f$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Determine the type of a variable.
   *
   * Function `typeOf` recognizes the following types of objects:
   *
   * Object                 | Returns       | Example
   * ---------------------- | ------------- | ------------------------------------------
   * null                   | `'null'`      | `math.typeOf(null)`
   * number                 | `'number'`    | `math.typeOf(3.5)`
   * boolean                | `'boolean'`   | `math.typeOf(true)`
   * string                 | `'string'`    | `math.typeOf('hello world')`
   * Array                  | `'Array'`     | `math.typeOf([1, 2, 3])`
   * Date                   | `'Date'`      | `math.typeOf(new Date())`
   * Function               | `'Function'`  | `math.typeOf(function () {})`
   * Object                 | `'Object'`    | `math.typeOf({a: 2, b: 3})`
   * RegExp                 | `'RegExp'`    | `math.typeOf(/a regexp/)`
   * undefined              | `'undefined'` | `math.typeOf(undefined)`
   * math.BigNumber         | `'BigNumber'` | `math.typeOf(math.bignumber('2.3e500'))`
   * math.Chain             | `'Chain'`     | `math.typeOf(math.chain(2))`
   * math.Complex           | `'Complex'`   | `math.typeOf(math.complex(2, 3))`
   * math.Fraction          | `'Fraction'`  | `math.typeOf(math.fraction(1, 3))`
   * math.Help              | `'Help'`      | `math.typeOf(math.help('sqrt'))`
   * math.Help              | `'Help'`      | `math.typeOf(math.help('sqrt'))`
   * math.Index             | `'Index'`     | `math.typeOf(math.index(1, 3))`
   * math.Matrix            | `'Matrix'`    | `math.typeOf(math.matrix([[1,2], [3, 4]]))`
   * math.Range             | `'Range'`     | `math.typeOf(math.range(0, 10))`
   * math.ResultSet         | `'ResultSet'` | `math.typeOf(math.evaluate('a=2\nb=3'))`
   * math.Unit              | `'Unit'`      | `math.typeOf(math.unit('45 deg'))`
   * math.AccessorNode            | `'AccessorNode'`            | `math.typeOf(math.parse('A[2]'))`
   * math.ArrayNode               | `'ArrayNode'`               | `math.typeOf(math.parse('[1,2,3]'))`
   * math.AssignmentNode          | `'AssignmentNode'`          | `math.typeOf(math.parse('x=2'))`
   * math.BlockNode               | `'BlockNode'`               | `math.typeOf(math.parse('a=2; b=3'))`
   * math.ConditionalNode         | `'ConditionalNode'`         | `math.typeOf(math.parse('x<0 ? -x : x'))`
   * math.ConstantNode            | `'ConstantNode'`            | `math.typeOf(math.parse('2.3'))`
   * math.FunctionAssignmentNode  | `'FunctionAssignmentNode'`  | `math.typeOf(math.parse('f(x)=x^2'))`
   * math.FunctionNode            | `'FunctionNode'`            | `math.typeOf(math.parse('sqrt(4)'))`
   * math.IndexNode               | `'IndexNode'`               | `math.typeOf(math.parse('A[2]').index)`
   * math.ObjectNode              | `'ObjectNode'`              | `math.typeOf(math.parse('{a:2}'))`
   * math.ParenthesisNode         | `'ParenthesisNode'`         | `math.typeOf(math.parse('(2+3)'))`
   * math.RangeNode               | `'RangeNode'`               | `math.typeOf(math.parse('1:10'))`
   * math.SymbolNode              | `'SymbolNode'`              | `math.typeOf(math.parse('x'))`
   *
   * Syntax:
   *
   *    math.typeOf(x)
   *
   * Examples:
   *
   *    math.typeOf(3.5)                     // returns 'number'
   *    math.typeOf(math.complex('2-4i'))    // returns 'Complex'
   *    math.typeOf(math.unit('45 deg'))     // returns 'Unit'
   *    math.typeOf('hello world')           // returns 'string'
   *
   * @param {*} x     The variable for which to test the type.
   * @return {string} Returns the name of the type. Primitive types are lower case,
   *                  non-primitive types are upper-camel-case.
   *                  For example 'number', 'string', 'Array', 'Date'.
   */ return typed($caaa070b381cb64f$var$name, {
        any: (0, $d8097b7a6d6e36d8$export$f5bbd400c2f4426f)
    });
});




var $b53a719755e98b12$var$name = "acosh";
var $b53a719755e98b12$var$dependencies = [
    "typed",
    "config",
    "Complex"
];
var $b53a719755e98b12$export$c634796792055579 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($b53a719755e98b12$var$name, $b53a719755e98b12$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex } = _ref;
    /**
   * Calculate the hyperbolic arccos of a value,
   * defined as `acosh(x) = ln(sqrt(x^2 - 1) + x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.acosh(x)
   *
   * Examples:
   *
   *    math.acosh(1.5)       // returns 0.9624236501192069
   *
   * See also:
   *
   *    cosh, asinh, atanh
   *
   * @param {number | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic arccosine of x
   */ return typed($b53a719755e98b12$var$name, {
        number: function number(x) {
            if (x >= 1 || config.predictable) return (0, $d10e9b2ec26dc177$export$84088556f7d2d0be)(x);
            if (x <= -1) return new Complex(Math.log(Math.sqrt(x * x - 1) - x), Math.PI);
            return new Complex(x, 0).acosh();
        },
        Complex: function Complex(x) {
            return x.acosh();
        },
        BigNumber: function BigNumber(x) {
            return x.acosh();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this);
        }
    });
});




var $299146234ce71769$var$name = "acsch";
var $299146234ce71769$var$dependencies = [
    "typed",
    "BigNumber"
];
var $299146234ce71769$export$d6534043a40dc59 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($299146234ce71769$var$name, $299146234ce71769$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the hyperbolic arccosecant of a value,
   * defined as `acsch(x) = asinh(1/x) = ln(1/x + sqrt(1/x^2 + 1))`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.acsch(x)
   *
   * Examples:
   *
   *    math.acsch(0.5)       // returns 1.4436354751788103
   *
   * See also:
   *
   *    asech, acoth
   *
   * @param {number | Complex | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic arccosecant of x
   */ return typed($299146234ce71769$var$name, {
        number: (0, $d10e9b2ec26dc177$export$51cd224337b2c783),
        Complex: function Complex(x) {
            return x.acsch();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x).asinh();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this);
        }
    });
});





var $f7bddcfe920bce4c$var$name = "apply";
var $f7bddcfe920bce4c$var$dependencies = [
    "typed",
    "isInteger"
];
var $f7bddcfe920bce4c$export$5ccffa1686df7f00 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($f7bddcfe920bce4c$var$name, $f7bddcfe920bce4c$var$dependencies, (_ref)=>{
    var { typed: typed, isInteger: isInteger } = _ref;
    /**
   * Apply a function that maps an array to a scalar
   * along a given axis of a matrix or array.
   * Returns a new matrix or array with one less dimension than the input.
   *
   * Syntax:
   *
   *     math.apply(A, dim, callback)
   *
   * Where:
   *
   * - `dim: number` is a zero-based dimension over which to concatenate the matrices.
   *
   * Examples:
   *
   *    const A = [[1, 2], [3, 4]]
   *    const sum = math.sum
   *
   *    math.apply(A, 0, sum)             // returns [4, 6]
   *    math.apply(A, 1, sum)             // returns [3, 7]
   *
   * See also:
   *
   *    map, filter, forEach
   *
   * @param {Array | Matrix} array   The input Matrix
   * @param {number} dim             The dimension along which the callback is applied
   * @param {Function} callback      The callback function that is applied. This Function
   *                                 should take an array or 1-d matrix as an input and
   *                                 return a number.
   * @return {Array | Matrix} res    The residual matrix with the function applied over some dimension.
   */ return typed($f7bddcfe920bce4c$var$name, {
        "Array | Matrix, number | BigNumber, function": function ArrayMatrixNumberBigNumberFunction(mat, dim, callback) {
            if (!isInteger(dim)) throw new TypeError("Integer number expected for dimension");
            var size = Array.isArray(mat) ? (0, $a14a10567870d913$export$51ffaee4afb683a5)(mat) : mat.size();
            if (dim < 0 || dim >= size.length) throw new (0, $5f2abd91081f798a$export$efa5eacb1304c464)(dim, size.length);
            if ((0, $d8097b7a6d6e36d8$export$b22160e0a14f87b7)(mat)) return mat.create($f7bddcfe920bce4c$var$_apply(mat.valueOf(), dim, callback));
            else return $f7bddcfe920bce4c$var$_apply(mat, dim, callback);
        }
    });
});
/**
 * Recursively reduce a matrix
 * @param {Array} mat
 * @param {number} dim
 * @param {Function} callback
 * @returns {Array} ret
 * @private
 */ function $f7bddcfe920bce4c$var$_apply(mat, dim, callback) {
    var i, ret, tran;
    if (dim <= 0) {
        if (!Array.isArray(mat[0])) return callback(mat);
        else {
            tran = $f7bddcfe920bce4c$var$_switch(mat);
            ret = [];
            for(i = 0; i < tran.length; i++)ret[i] = $f7bddcfe920bce4c$var$_apply(tran[i], dim - 1, callback);
            return ret;
        }
    } else {
        ret = [];
        for(i = 0; i < mat.length; i++)ret[i] = $f7bddcfe920bce4c$var$_apply(mat[i], dim - 1, callback);
        return ret;
    }
}
/**
 * Transpose a matrix
 * @param {Array} mat
 * @returns {Array} ret
 * @private
 */ function $f7bddcfe920bce4c$var$_switch(mat) {
    var I = mat.length;
    var J = mat[0].length;
    var i, j;
    var ret = [];
    for(j = 0; j < J; j++){
        var tmp = [];
        for(i = 0; i < I; i++)tmp.push(mat[i][j]);
        ret.push(tmp);
    }
    return ret;
}




var $d8eb00c42b04816a$var$name = "asec";
var $d8eb00c42b04816a$var$dependencies = [
    "typed",
    "config",
    "Complex",
    "BigNumber"
];
var $d8eb00c42b04816a$export$e1f28fc7c94f90b0 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($d8eb00c42b04816a$var$name, $d8eb00c42b04816a$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the inverse secant of a value. Defined as `asec(x) = acos(1/x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.asec(x)
   *
   * Examples:
   *
   *    math.asec(0.5)           // returns 1.0471975511965979
   *    math.asec(math.sec(1.5)) // returns 1.5
   *
   *    math.asec(2)             // returns 0 + 1.3169578969248166 i
   *
   * See also:
   *
   *    acos, acot, acsc
   *
   * @param {number | Complex | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} The arc secant of x
   */ return typed($d8eb00c42b04816a$var$name, {
        number: function number(x) {
            if (x <= -1 || x >= 1 || config.predictable) return (0, $d10e9b2ec26dc177$export$5ec3930177455ade)(x);
            return new Complex(x, 0).asec();
        },
        Complex: function Complex(x) {
            return x.asec();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x).acos();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this);
        }
    });
});


var $b70eaa1394094666$var$name = "bin";
var $b70eaa1394094666$var$dependencies = [
    "typed",
    "format"
];
var $b70eaa1394094666$export$a770ddfd7e536064 = (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($b70eaa1394094666$var$name, $b70eaa1394094666$var$dependencies, (_ref)=>{
    var { typed: typed, format: format } = _ref;
    return typed($b70eaa1394094666$var$name, {
        "number | BigNumber": function numberBigNumber(n) {
            return format(n, {
                notation: "bin"
            });
        },
        "number | BigNumber, number": function numberBigNumberNumber(n, wordSize) {
            return format(n, {
                notation: "bin",
                wordSize: wordSize
            });
        }
    });
});




var $89db069cce3272ee$var$name = "combinationsWithRep";
var $89db069cce3272ee$var$dependencies = [
    "typed"
];
var $89db069cce3272ee$export$4bdc90311ec7c1dd = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($89db069cce3272ee$var$name, $89db069cce3272ee$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Compute the number of ways of picking `k` unordered outcomes from `n`
   * possibilities, allowing individual outcomes to be repeated more than once.
   *
   * CombinationsWithRep only takes integer arguments.
   * The following condition must be enforced: k <= n + k -1.
   *
   * Syntax:
   *
   *     math.combinationsWithRep(n, k)
   *
   * Examples:
   *
   *    math.combinationsWithRep(7, 5) // returns 462
   *
   * See also:
   *
   *    combinations, permutations, factorial
   *
   * @param {number | BigNumber} n    Total number of objects in the set
   * @param {number | BigNumber} k    Number of objects in the subset
   * @return {number | BigNumber}     Number of possible combinations with replacement.
   */ return typed($89db069cce3272ee$var$name, {
        "number, number": function numberNumber(n, k) {
            if (!(0, $668e051498bf5fa0$export$a287f47fed4544b8)(n) || n < 0) throw new TypeError("Positive integer value expected in function combinationsWithRep");
            if (!(0, $668e051498bf5fa0$export$a287f47fed4544b8)(k) || k < 0) throw new TypeError("Positive integer value expected in function combinationsWithRep");
            if (n < 1) throw new TypeError("k must be less than or equal to n + k - 1");
            if (k < n - 1) {
                var _prodrange = (0, $dc1c171d547e28ef$export$dbd0f18357df1ddd)(n, n + k - 1);
                return _prodrange / (0, $dc1c171d547e28ef$export$dbd0f18357df1ddd)(1, k);
            }
            var prodrange = (0, $dc1c171d547e28ef$export$dbd0f18357df1ddd)(k + 1, n + k - 1);
            return prodrange / (0, $dc1c171d547e28ef$export$dbd0f18357df1ddd)(1, n - 1);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(n, k) {
            var BigNumber = n.constructor;
            var result, i;
            var one = new BigNumber(1);
            var nMinusOne = n.minus(one);
            if (!$89db069cce3272ee$var$isPositiveInteger(n) || !$89db069cce3272ee$var$isPositiveInteger(k)) throw new TypeError("Positive integer value expected in function combinationsWithRep");
            if (n.lt(one)) throw new TypeError("k must be less than or equal to n + k - 1 in function combinationsWithRep");
            result = one;
            if (k.lt(nMinusOne)) for(i = one; i.lte(nMinusOne); i = i.plus(one))result = result.times(k.plus(i)).dividedBy(i);
            else for(i = one; i.lte(k); i = i.plus(one))result = result.times(nMinusOne.plus(i)).dividedBy(i);
            return result;
        }
    });
});
/**
 * Test whether BigNumber n is a positive integer
 * @param {BigNumber} n
 * @returns {boolean} isPositiveInteger
 */ function $89db069cce3272ee$var$isPositiveInteger(n) {
    return n.isInteger() && n.gte(0);
}



var $d7248087b592523f$var$name = "cos";
var $d7248087b592523f$var$dependencies = [
    "typed"
];
var $d7248087b592523f$export$923b60dfa791c630 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($d7248087b592523f$var$name, $d7248087b592523f$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Calculate the cosine of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.cos(x)
   *
   * Examples:
   *
   *    math.cos(2)                      // returns number -0.4161468365471422
   *    math.cos(math.pi / 4)            // returns number  0.7071067811865475
   *    math.cos(math.unit(180, 'deg'))  // returns number -1
   *    math.cos(math.unit(60, 'deg'))   // returns number  0.5
   *
   *    const angle = 0.2
   *    math.pow(math.sin(angle), 2) + math.pow(math.cos(angle), 2) // returns number ~1
   *
   * See also:
   *
   *    cos, tan
   *
   * @param {number | BigNumber | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | BigNumber | Complex | Array | Matrix} Cosine of x
   */ return typed($d7248087b592523f$var$name, {
        number: Math.cos,
        Complex: function Complex(x) {
            return x.cos();
        },
        BigNumber: function BigNumber(x) {
            return x.cos();
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function cos is no angle");
            return this(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this);
        }
    });
});




var $e584730979e3a498$var$name = "csch";
var $e584730979e3a498$var$dependencies = [
    "typed",
    "BigNumber"
];
var $e584730979e3a498$export$9160aa3a39425fc9 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($e584730979e3a498$var$name, $e584730979e3a498$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the hyperbolic cosecant of a value,
   * defined as `csch(x) = 1 / sinh(x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.csch(x)
   *
   * Examples:
   *
   *    // csch(x) = 1/ sinh(x)
   *    math.csch(0.5)       // returns 1.9190347513349437
   *    1 / math.sinh(0.5)   // returns 1.9190347513349437
   *
   * See also:
   *
   *    sinh, sech, coth
   *
   * @param {number | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic cosecant of x
   */ return typed($e584730979e3a498$var$name, {
        number: (0, $d10e9b2ec26dc177$export$143835b5c1db9790),
        Complex: function Complex(x) {
            return x.csch();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x.sinh());
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function csch is no angle");
            return this(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this);
        }
    });
});




var $f4281c57d38e6673$var$name = "isNaN";
var $f4281c57d38e6673$var$dependencies = [
    "typed"
];
var $f4281c57d38e6673$export$f85085363cf09711 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($f4281c57d38e6673$var$name, $f4281c57d38e6673$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Test whether a value is NaN (not a number).
   * The function supports types `number`, `BigNumber`, `Fraction`, `Unit` and `Complex`.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isNaN(x)
   *
   * Examples:
   *
   *    math.isNaN(3)                     // returns false
   *    math.isNaN(NaN)                   // returns true
   *    math.isNaN(0)                     // returns false
   *    math.isNaN(math.bignumber(NaN))   // returns true
   *    math.isNaN(math.bignumber(0))     // returns false
   *    math.isNaN(math.fraction(-2, 5))  // returns false
   *    math.isNaN('-2')                  // returns false
   *    math.isNaN([2, 0, -3, NaN]')      // returns [false, false, false, true]
   *
   * See also:
   *
   *    isNumeric, isNegative, isPositive, isZero, isInteger
   *
   * @param {number | BigNumber | Fraction | Unit | Array | Matrix} x  Value to be tested
   * @return {boolean}  Returns true when `x` is NaN.
   *                    Throws an error in case of an unknown data type.
   */ return typed($f4281c57d38e6673$var$name, {
        number: (0, $613b7405ae95cf49$export$9fd08d8371c55110),
        BigNumber: function BigNumber(x) {
            return x.isNaN();
        },
        Fraction: function Fraction(x) {
            return false;
        },
        Complex: function Complex(x) {
            return x.isNaN();
        },
        Unit: function Unit(x) {
            return Number.isNaN(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, Number.isNaN);
        }
    });
});



var $f348f7a9fdb82323$var$name = "isPrime";
var $f348f7a9fdb82323$var$dependencies = [
    "typed"
];
var $f348f7a9fdb82323$export$4e02350f5fb7a050 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($f348f7a9fdb82323$var$name, $f348f7a9fdb82323$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Test whether a value is prime: has no divisors other than itself and one.
   * The function supports type `number`, `bignumber`.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isPrime(x)
   *
   * Examples:
   *
   *    math.isPrime(3)                     // returns true
   *    math.isPrime(-2)                    // returns false
   *    math.isPrime(0)                     // returns false
   *    math.isPrime(-0)                    // returns false
   *    math.isPrime(0.5)                   // returns false
   *    math.isPrime('2')                   // returns true
   *    math.isPrime([2, 17, 100])           // returns [true, true, false]
   *
   * See also:
   *
   *    isNumeric, isZero, isNegative, isInteger
   *
   * @param {number | BigNumber | Array | Matrix} x  Value to be tested
   * @return {boolean}  Returns true when `x` is larger than zero.
   *                    Throws an error in case of an unknown data type.
   */ return typed($f348f7a9fdb82323$var$name, {
        number: function number(x) {
            if (x * 0 !== 0) return false;
            if (x <= 3) return x > 1;
            if (x % 2 === 0 || x % 3 === 0) return false;
            for(var i = 5; i * i <= x; i += 6){
                if (x % i === 0 || x % (i + 2) === 0) return false;
            }
            return true;
        },
        BigNumber: function BigNumber(n) {
            if (n.toNumber() * 0 !== 0) return false;
            if (n.lte(3)) return n.gt(1);
            if (n.mod(2).eq(0) || n.mod(3).eq(0)) return false;
            if (n.lt(Math.pow(2, 32))) {
                var x = n.toNumber();
                for(var i = 5; i * i <= x; i += 6){
                    if (x % i === 0 || x % (i + 2) === 0) return false;
                }
                return true;
            }
            function modPow(base, exponent, modulus) {
                // exponent can be huge, use non-recursive variant
                var accumulator = 1;
                while(!exponent.eq(0))if (exponent.mod(2).eq(0)) {
                    exponent = exponent.div(2);
                    base = base.mul(base).mod(modulus);
                } else {
                    exponent = exponent.sub(1);
                    accumulator = base.mul(accumulator).mod(modulus);
                }
                return accumulator;
            } // https://en.wikipedia.org/wiki/Miller%E2%80%93Rabin_primality_test#Deterministic_variants
            var Decimal = n.constructor.clone({
                precision: n.toFixed(0).length * 2
            });
            n = new Decimal(n);
            var r = 0;
            var d = n.sub(1);
            while(d.mod(2).eq(0)){
                d = d.div(2);
                r += 1;
            }
            var bases = null; // https://en.wikipedia.org/wiki/Miller–Rabin_primality_test#Testing_against_small_sets_of_bases
            if (n.lt("3317044064679887385961981")) bases = [
                2,
                3,
                5,
                7,
                11,
                13,
                17,
                19,
                23,
                29,
                31,
                37,
                41
            ].filter((x)=>x < n);
            else {
                var max = Math.min(n.toNumber() - 2, Math.floor(2 * Math.pow(n.toFixed(0).length * Math.log(10), 2)));
                bases = [];
                for(var _i = 2; _i <= max; _i += 1)bases.push(max);
            }
            for(var _i2 = 0; _i2 < bases.length; _i2 += 1){
                var a = bases[_i2];
                var adn = modPow(n.sub(n).add(a), d, n);
                if (!adn.eq(1)) for(var _i3 = 0, _x = adn; !_x.eq(n.sub(1)); _i3 += 1, _x = _x.mul(_x).mod(n)){
                    if (_i3 === r - 1) return false;
                }
            }
            return true;
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this);
        }
    });
});





var $221176819d2016eb$var$name = "randomInt";
var $221176819d2016eb$var$dependencies = [
    "typed",
    "config",
    "?on"
];
var $221176819d2016eb$export$e158da47ae479dd4 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($221176819d2016eb$var$name, $221176819d2016eb$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, on: on } = _ref;
    // seeded pseudo random number generator
    var rng = (0, $1059d98e3912f47f$export$eaf9227667332084)(config.randomSeed);
    if (on) on("config", function(curr, prev) {
        if (curr.randomSeed !== prev.randomSeed) rng = (0, $1059d98e3912f47f$export$eaf9227667332084)(curr.randomSeed);
    });
    /**
   * Return a random integer number larger or equal to `min` and smaller than `max`
   * using a uniform distribution.
   *
   * Syntax:
   *
   *     math.randomInt()                // generate a random integer between 0 and 1
   *     math.randomInt(max)             // generate a random integer between 0 and max
   *     math.randomInt(min, max)        // generate a random integer between min and max
   *     math.randomInt(size)            // generate a matrix with random integer between 0 and 1
   *     math.randomInt(size, max)       // generate a matrix with random integer between 0 and max
   *     math.randomInt(size, min, max)  // generate a matrix with random integer between min and max
   *
   * Examples:
   *
   *     math.randomInt(100)    // returns a random integer between 0 and 100
   *     math.randomInt(30, 40) // returns a random integer between 30 and 40
   *     math.randomInt([2, 3]) // returns a 2x3 matrix with random integers between 0 and 1
   *
   * See also:
   *
   *     random, pickRandom
   *
   * @param {Array | Matrix} [size] If provided, an array or matrix with given
   *                                size and filled with random values is returned
   * @param {number} [min]  Minimum boundary for the random value, included
   * @param {number} [max]  Maximum boundary for the random value, excluded
   * @return {number | Array | Matrix} A random integer value
   */ return typed($221176819d2016eb$var$name, {
        "": ()=>_randomInt(0, 1),
        number: (max)=>_randomInt(0, max),
        "number, number": (min, max)=>_randomInt(min, max),
        "Array | Matrix": (size)=>_randomIntMatrix(size, 0, 1),
        "Array | Matrix, number": (size, max)=>_randomIntMatrix(size, 0, max),
        "Array | Matrix, number, number": (size, min, max)=>_randomIntMatrix(size, min, max)
    });
    function _randomIntMatrix(size, min, max) {
        var res = (0, $020121c2fe1a81e4$export$6549281d357a44ec)(size.valueOf(), ()=>_randomInt(min, max));
        return (0, $d8097b7a6d6e36d8$export$b22160e0a14f87b7)(size) ? size.create(res) : res;
    }
    function _randomInt(min, max) {
        return Math.floor(min + rng() * (max - min));
    }
});




var $c4e19a00f42432bf$var$name = "sech";
var $c4e19a00f42432bf$var$dependencies = [
    "typed",
    "BigNumber"
];
var $c4e19a00f42432bf$export$97a0cf2b7d31f38b = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($c4e19a00f42432bf$var$name, $c4e19a00f42432bf$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the hyperbolic secant of a value,
   * defined as `sech(x) = 1 / cosh(x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.sech(x)
   *
   * Examples:
   *
   *    // sech(x) = 1/ cosh(x)
   *    math.sech(0.5)       // returns 0.886818883970074
   *    1 / math.cosh(0.5)   // returns 0.886818883970074
   *
   * See also:
   *
   *    cosh, csch, coth
   *
   * @param {number | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic secant of x
   */ return typed($c4e19a00f42432bf$var$name, {
        number: (0, $d10e9b2ec26dc177$export$b83345d70fe4a871),
        Complex: function Complex(x) {
            return x.sech();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x.cosh());
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function sech is no angle");
            return this(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this);
        }
    });
});




var $716b6b44b18da9ba$var$name = "sinh";
var $716b6b44b18da9ba$var$dependencies = [
    "typed"
];
var $716b6b44b18da9ba$export$c3a62182c56878d5 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($716b6b44b18da9ba$var$name, $716b6b44b18da9ba$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Calculate the hyperbolic sine of a value,
   * defined as `sinh(x) = 1/2 * (exp(x) - exp(-x))`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.sinh(x)
   *
   * Examples:
   *
   *    math.sinh(0.5)       // returns number 0.5210953054937474
   *
   * See also:
   *
   *    cosh, tanh
   *
   * @param {number | BigNumber | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | BigNumber | Complex | Array | Matrix} Hyperbolic sine of x
   */ return typed($716b6b44b18da9ba$var$name, {
        number: (0, $d10e9b2ec26dc177$export$89648c4ce0d79e70),
        Complex: function Complex(x) {
            return x.sinh();
        },
        BigNumber: function BigNumber(x) {
            return x.sinh();
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function sinh is no angle");
            return this(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since sinh(0) = 0
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this, true);
        }
    });
});


var $a91be007ed40c7b8$var$name = "sparse";
var $a91be007ed40c7b8$var$dependencies = [
    "typed",
    "SparseMatrix"
];
var $a91be007ed40c7b8$export$89ff03fdb3964a99 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($a91be007ed40c7b8$var$name, $a91be007ed40c7b8$var$dependencies, (_ref)=>{
    var { typed: typed, SparseMatrix: SparseMatrix } = _ref;
    /**
   * Create a Sparse Matrix. The function creates a new `math.Matrix` object from
   * an `Array`. A Matrix has utility functions to manipulate the data in the
   * matrix, like getting the size and getting or setting values in the matrix.
   * Note that a Sparse Matrix is always 2-dimensional, so for example if
   * you create one from a plain array of _n_ numbers, you get an _n_ by 1
   * Sparse "column vector".
   *
   * Syntax:
   *
   *    math.sparse()               // creates an empty sparse matrix.
   *    math.sparse(data)           // creates a sparse matrix with initial data.
   *    math.sparse(data, 'number') // creates a sparse matrix with initial data, number datatype.
   *
   * Examples:
   *
   *    let m = math.sparse([[1, 2], [3, 4]])
   *    m.size()                        // Array [2, 2]
   *    m.resize([3, 2], 5)
   *    m.valueOf()                     // Array [[1, 2], [3, 4], [5, 5]]
   *    m.get([1, 0])                    // number 3
   *    let v = math.sparse([0, 0, 1])
   *    v.size()                        // Array [3, 1]
   *    v.get([2, 0])                   // number 1
   *
   * See also:
   *
   *    bignumber, boolean, complex, index, number, string, unit, matrix
   *
   * @param {Array | Matrix} [data]    A two dimensional array
   *
   * @return {Matrix} The created matrix
   */ return typed($a91be007ed40c7b8$var$name, {
        "": function _() {
            return new SparseMatrix([]);
        },
        string: function string(datatype) {
            return new SparseMatrix([], datatype);
        },
        "Array | Matrix": function ArrayMatrix(data) {
            return new SparseMatrix(data);
        },
        "Array | Matrix, string": function ArrayMatrixString(data, datatype) {
            return new SparseMatrix(data, datatype);
        }
    });
});



var $82a490fa2f36f261$var$name = "sqrt";
var $82a490fa2f36f261$var$dependencies = [
    "config",
    "typed",
    "Complex"
];
var $82a490fa2f36f261$export$eb18ce1988c5f19c = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($82a490fa2f36f261$var$name, $82a490fa2f36f261$var$dependencies, (_ref)=>{
    var { config: config, typed: typed, Complex: Complex } = _ref;
    /**
   * Calculate the square root of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.sqrt(x)
   *
   * Examples:
   *
   *    math.sqrt(25)                // returns 5
   *    math.square(5)               // returns 25
   *    math.sqrt(-4)                // returns Complex 2i
   *
   * See also:
   *
   *    square, multiply, cube, cbrt, sqrtm
   *
   * @param {number | BigNumber | Complex | Array | Matrix | Unit} x
   *            Value for which to calculate the square root.
   * @return {number | BigNumber | Complex | Array | Matrix | Unit}
   *            Returns the square root of `x`
   */ return typed("sqrt", {
        number: _sqrtNumber,
        Complex: function Complex(x) {
            return x.sqrt();
        },
        BigNumber: function BigNumber(x) {
            if (!x.isNegative() || config.predictable) return x.sqrt();
            else // negative value -> downgrade to number to do complex value computation
            return _sqrtNumber(x.toNumber());
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since sqrt(0) = 0
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this, true);
        },
        Unit: function Unit(x) {
            // Someday will work for complex units when they are implemented
            return x.pow(0.5);
        }
    });
    /**
   * Calculate sqrt for a number
   * @param {number} x
   * @returns {number | Complex} Returns the square root of x
   * @private
   */ function _sqrtNumber(x) {
        if (isNaN(x)) return NaN;
        else if (x >= 0 || config.predictable) return Math.sqrt(x);
        else return new Complex(x, 0).sqrt();
    }
});




var $ce23360eba9bac64$var$name = "tanh";
var $ce23360eba9bac64$var$dependencies = [
    "typed"
];
var $ce23360eba9bac64$export$e1f66a5bda779194 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($ce23360eba9bac64$var$name, $ce23360eba9bac64$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Calculate the hyperbolic tangent of a value,
   * defined as `tanh(x) = (exp(2 * x) - 1) / (exp(2 * x) + 1)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.tanh(x)
   *
   * Examples:
   *
   *    // tanh(x) = sinh(x) / cosh(x) = 1 / coth(x)
   *    math.tanh(0.5)                   // returns 0.46211715726000974
   *    math.sinh(0.5) / math.cosh(0.5)  // returns 0.46211715726000974
   *    1 / math.coth(0.5)               // returns 0.46211715726000974
   *
   * See also:
   *
   *    sinh, cosh, coth
   *
   * @param {number | BigNumber | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | BigNumber | Complex | Array | Matrix} Hyperbolic tangent of x
   */ return typed("tanh", {
        number: (0, $668e051498bf5fa0$export$7128670e45beef9a),
        Complex: function Complex(x) {
            return x.tanh();
        },
        BigNumber: function BigNumber(x) {
            return x.tanh();
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function tanh is no angle");
            return this(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since tanh(0) = 0
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this, true);
        }
    });
});




var $7e409df0d8f124ad$var$name = "unaryMinus";
var $7e409df0d8f124ad$var$dependencies = [
    "typed"
];
var $7e409df0d8f124ad$export$939e1be6e134f392 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($7e409df0d8f124ad$var$name, $7e409df0d8f124ad$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Inverse the sign of a value, apply a unary minus operation.
   *
   * For matrices, the function is evaluated element wise. Boolean values and
   * strings will be converted to a number. For complex numbers, both real and
   * complex value are inverted.
   *
   * Syntax:
   *
   *    math.unaryMinus(x)
   *
   * Examples:
   *
   *    math.unaryMinus(3.5)      // returns -3.5
   *    math.unaryMinus(-4.2)     // returns 4.2
   *
   * See also:
   *
   *    add, subtract, unaryPlus
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x Number to be inverted.
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} Returns the value with inverted sign.
   */ return typed($7e409df0d8f124ad$var$name, {
        number: (0, $4b37ed316f05dd33$export$339666dc881be46b),
        Complex: function Complex(x) {
            return x.neg();
        },
        BigNumber: function BigNumber(x) {
            return x.neg();
        },
        Fraction: function Fraction(x) {
            return x.neg();
        },
        Unit: function Unit(x) {
            var res = x.clone();
            res.value = this(x.value);
            return res;
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since unaryMinus(0) = 0
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this, true);
        } // TODO: add support for string
    });
});




var $5e71b2c9ace047e4$var$name = "acoth";
var $5e71b2c9ace047e4$var$dependencies = [
    "typed",
    "config",
    "Complex",
    "BigNumber"
];
var $5e71b2c9ace047e4$export$67e40c7fd8f5703a = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($5e71b2c9ace047e4$var$name, $5e71b2c9ace047e4$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the hyperbolic arccotangent of a value,
   * defined as `acoth(x) = atanh(1/x) = (ln((x+1)/x) + ln(x/(x-1))) / 2`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.acoth(x)
   *
   * Examples:
   *
   *    math.acoth(0.5)       // returns 0.8047189562170503
   *
   * See also:
   *
   *    acsch, asech
   *
   * @param {number | Complex | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Hyperbolic arccotangent of x
   */ return typed($5e71b2c9ace047e4$var$name, {
        number: function number(x) {
            if (x >= 1 || x <= -1 || config.predictable) return (0, $d10e9b2ec26dc177$export$e2be1aa5d5a3f81)(x);
            return new Complex(x, 0).acoth();
        },
        Complex: function Complex(x) {
            return x.acoth();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x).atanh();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this);
        }
    });
});




var $1602024f41300d63$var$name = "cot";
var $1602024f41300d63$var$dependencies = [
    "typed",
    "BigNumber"
];
var $1602024f41300d63$export$c5598f542ea1565c = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($1602024f41300d63$var$name, $1602024f41300d63$var$dependencies, (_ref)=>{
    var { typed: typed, BigNumber: _BigNumber } = _ref;
    /**
   * Calculate the cotangent of a value. Defined as `cot(x) = 1 / tan(x)`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.cot(x)
   *
   * Examples:
   *
   *    math.cot(2)      // returns number -0.45765755436028577
   *    1 / math.tan(2)  // returns number -0.45765755436028577
   *
   * See also:
   *
   *    tan, sec, csc
   *
   * @param {number | Complex | Unit | Array | Matrix} x  Function input
   * @return {number | Complex | Array | Matrix} Cotangent of x
   */ return typed($1602024f41300d63$var$name, {
        number: (0, $d10e9b2ec26dc177$export$515b39f7fd07e09f),
        Complex: function Complex(x) {
            return x.cot();
        },
        BigNumber: function BigNumber(x) {
            return new _BigNumber(1).div(x.tan());
        },
        Unit: function Unit(x) {
            if (!x.hasBase(x.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function cot is no angle");
            return this(x.value);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this);
        }
    });
});



var $3d59d6306cd28f58$var$name = "fraction";
var $3d59d6306cd28f58$var$dependencies = [
    "typed",
    "Fraction"
];
var $3d59d6306cd28f58$export$de147ca8498e0312 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($3d59d6306cd28f58$var$name, $3d59d6306cd28f58$var$dependencies, (_ref)=>{
    var { typed: typed, Fraction: Fraction } = _ref;
    /**
   * Create a fraction or convert a value to a fraction.
   *
   * With one numeric argument, produces the closest rational approximation to the
   * input.
   * With two arguments, the first is the numerator and the second is the denominator,
   * and creates the corresponding fraction. Both numerator and denominator must be
   * integers.
   * With one object argument, looks for the integer numerator as the value of property
   * 'n' and the integer denominator as the value of property 'd'.
   * With a matrix argument, creates a matrix of the same shape with entries
   * converted into fractions.
   *
   * Syntax:
   *     math.fraction(value)
   *     math.fraction(numerator, denominator)
   *     math.fraction({n: numerator, d: denominator})
   *     math.fraction(matrix: Array | Matrix)
   *
   * Examples:
   *
   *     math.fraction(6.283)             // returns Fraction 6283/1000
   *     math.fraction(1, 3)              // returns Fraction 1/3
   *     math.fraction('2/3')             // returns Fraction 2/3
   *     math.fraction({n: 2, d: 3})      // returns Fraction 2/3
   *     math.fraction([0.2, 0.25, 1.25]) // returns Array [1/5, 1/4, 5/4]
   *     math.fraction(4, 5.1)            // throws Error: Parameters must be integer
   *
   * See also:
   *
   *    bignumber, number, string, unit
   *
   * @param {number | string | Fraction | BigNumber | Array | Matrix} [args]
   *            Arguments specifying the value, or numerator and denominator of
   *            the fraction
   * @return {Fraction | Array | Matrix} Returns a fraction
   */ return typed("fraction", {
        number: function number(x) {
            if (!isFinite(x) || isNaN(x)) throw new Error(x + " cannot be represented as a fraction");
            return new Fraction(x);
        },
        string: function string(x) {
            return new Fraction(x);
        },
        "number, number": function numberNumber(numerator, denominator) {
            return new Fraction(numerator, denominator);
        },
        null: function _null(x) {
            return new Fraction(0);
        },
        BigNumber: function BigNumber(x) {
            return new Fraction(x.toString());
        },
        Fraction: function Fraction(x) {
            return x; // fractions are immutable
        },
        Object: function Object(x) {
            return new Fraction(x);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this);
        }
    });
});



var $f1404df2748180e3$var$name = "isNumeric";
var $f1404df2748180e3$var$dependencies = [
    "typed"
];
var $f1404df2748180e3$export$85b0631fa122b7f1 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($f1404df2748180e3$var$name, $f1404df2748180e3$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Test whether a value is an numeric value.
   *
   * The function is evaluated element-wise in case of Array or Matrix input.
   *
   * Syntax:
   *
   *     math.isNumeric(x)
   *
   * Examples:
   *
   *    math.isNumeric(2)                     // returns true
   *    math.isNumeric('2')                   // returns false
   *    math.hasNumericValue('2')             // returns true
   *    math.isNumeric(0)                     // returns true
   *    math.isNumeric(math.bignumber(500))   // returns true
   *    math.isNumeric(math.fraction(4))      // returns true
   *    math.isNumeric(math.complex('2-4i')   // returns false
   *    math.isNumeric([2.3, 'foo', false])   // returns [true, false, true]
   *
   * See also:
   *
   *    isZero, isPositive, isNegative, isInteger, hasNumericValue
   *
   * @param {*} x       Value to be tested
   * @return {boolean}  Returns true when `x` is a `number`, `BigNumber`,
   *                    `Fraction`, or `boolean`. Returns false for other types.
   *                    Throws an error in case of unknown types.
   */ return typed($f1404df2748180e3$var$name, {
        "number | BigNumber | Fraction | boolean": function numberBigNumberFractionBoolean() {
            return true;
        },
        "Complex | Unit | string | null | undefined | Node": function ComplexUnitStringNullUndefinedNode() {
            return false;
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this);
        }
    });
});


var $2731ffdb281d587e$var$name = "matrix";
var $2731ffdb281d587e$var$dependencies = [
    "typed",
    "Matrix",
    "DenseMatrix",
    "SparseMatrix"
];
var $2731ffdb281d587e$export$f3cf8b510f9cb8ab = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($2731ffdb281d587e$var$name, $2731ffdb281d587e$var$dependencies, (_ref)=>{
    var { typed: typed, Matrix: Matrix, DenseMatrix: DenseMatrix, SparseMatrix: SparseMatrix } = _ref;
    /**
   * Create a Matrix. The function creates a new `math.Matrix` object from
   * an `Array`. A Matrix has utility functions to manipulate the data in the
   * matrix, like getting the size and getting or setting values in the matrix.
   * Supported storage formats are 'dense' and 'sparse'.
   *
   * Syntax:
   *
   *    math.matrix()                         // creates an empty matrix using default storage format (dense).
   *    math.matrix(data)                     // creates a matrix with initial data using default storage format (dense).
   *    math.matrix('dense')                  // creates an empty matrix using the given storage format.
   *    math.matrix(data, 'dense')            // creates a matrix with initial data using the given storage format.
   *    math.matrix(data, 'sparse')           // creates a sparse matrix with initial data.
   *    math.matrix(data, 'sparse', 'number') // creates a sparse matrix with initial data, number data type.
   *
   * Examples:
   *
   *    let m = math.matrix([[1, 2], [3, 4]])
   *    m.size()                        // Array [2, 2]
   *    m.resize([3, 2], 5)
   *    m.valueOf()                     // Array [[1, 2], [3, 4], [5, 5]]
   *    m.get([1, 0])                    // number 3
   *
   * See also:
   *
   *    bignumber, boolean, complex, index, number, string, unit, sparse
   *
   * @param {Array | Matrix} [data]    A multi dimensional array
   * @param {string} [format]          The Matrix storage format, either `'dense'` or `'sparse'`
   * @param {string} [datatype]        Type of the values
   *
   * @return {Matrix} The created matrix
   */ return typed($2731ffdb281d587e$var$name, {
        "": function _() {
            return _create([]);
        },
        string: function string(format) {
            return _create([], format);
        },
        "string, string": function stringString(format, datatype) {
            return _create([], format, datatype);
        },
        Array: function Array(data) {
            return _create(data);
        },
        Matrix: function Matrix(data) {
            return _create(data, data.storage());
        },
        "Array | Matrix, string": _create,
        "Array | Matrix, string, string": _create
    });
    /**
   * Create a new Matrix with given storage format
   * @param {Array} data
   * @param {string} [format]
   * @param {string} [datatype]
   * @returns {Matrix} Returns a new Matrix
   * @private
   */ function _create(data, format, datatype) {
        // get storage format constructor
        if (format === "dense" || format === "default" || format === undefined) return new DenseMatrix(data, datatype);
        if (format === "sparse") return new SparseMatrix(data, datatype);
        throw new TypeError("Unknown matrix type " + JSON.stringify(format) + ".");
    }
});


var $5ae2c66d00503c0d$var$name = "matrixFromFunction";
var $5ae2c66d00503c0d$var$dependencies = [
    "typed",
    "matrix",
    "isZero"
];
var $5ae2c66d00503c0d$export$983d2c97138363e0 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($5ae2c66d00503c0d$var$name, $5ae2c66d00503c0d$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, isZero: isZero } = _ref;
    /**
   * Create a matrix by evaluating a generating function at each index.
   * The simplest overload returns a multi-dimensional array as long as `size` is an array.
   * Passing `size` as a Matrix or specifying a `format` will result in returning a Matrix.
   *
   * Syntax:
   *
   *    math.matrixFromFunction(size, fn)
   *    math.matrixFromFunction(size, fn, format)
   *    math.matrixFromFunction(size, fn, format, datatype)
   *    math.matrixFromFunction(size, format, fn)
   *    math.matrixFromFunction(size, format, datatype, fn)
   *
   * Examples:
   *
   *    math.matrixFromFunction([3,3], i => i[0] - i[1]) // an antisymmetric matrix
   *    math.matrixFromFunction([100, 100], 'sparse', i => i[0] - i[1] === 1 ? 4 : 0) // a sparse subdiagonal matrix
   *    math.matrixFromFunction([5], i => math.random()) // a random vector
   *
   * See also:
   *
   *    matrix, zeros
   *
   * @param {Array | Matrix} size   The size of the matrix to be created
   * @param {function} fn           Callback function invoked for every entry in the matrix
   * @param {string} [format]       The Matrix storage format, either `'dense'` or `'sparse'`
   * @param {string} [datatype]     Type of the values
   * @return {Array | Matrix} Returns the created matrix
   */ return typed($5ae2c66d00503c0d$var$name, {
        "Array | Matrix, function, string, string": function ArrayMatrixFunctionStringString(size, fn, format, datatype) {
            return _create(size, fn, format, datatype);
        },
        "Array | Matrix, function, string": function ArrayMatrixFunctionString(size, fn, format) {
            return _create(size, fn, format);
        },
        "Matrix, function": function MatrixFunction(size, fn) {
            return _create(size, fn, "dense");
        },
        "Array, function": function ArrayFunction(size, fn) {
            return _create(size, fn, "dense").toArray();
        },
        "Array | Matrix, string, function": function ArrayMatrixStringFunction(size, format, fn) {
            return _create(size, fn, format);
        },
        "Array | Matrix, string, string, function": function ArrayMatrixStringStringFunction(size, format, datatype, fn) {
            return _create(size, fn, format, datatype);
        }
    });
    function _create(size, fn, format, datatype) {
        var m;
        if (datatype !== undefined) m = matrix(format, datatype);
        else m = matrix(format);
        m.resize(size);
        m.forEach(function(_, index) {
            var val = fn(index);
            if (isZero(val)) return;
            m.set(index, val);
        });
        return m;
    }
});




var $caf358e9c2d20263$var$name = "algorithm02";
var $caf358e9c2d20263$var$dependencies = [
    "typed",
    "equalScalar"
];
var $caf358e9c2d20263$export$92edb534a8f19a37 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($caf358e9c2d20263$var$name, $caf358e9c2d20263$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref;
    /**
   * Iterates over SparseMatrix nonzero items and invokes the callback function f(Dij, Sij).
   * Callback function invoked NNZ times (number of nonzero items in SparseMatrix).
   *
   *
   *          ┌  f(Dij, Sij)  ; S(i,j) !== 0
   * C(i,j) = ┤
   *          └  0            ; otherwise
   *
   *
   * @param {Matrix}   denseMatrix       The DenseMatrix instance (D)
   * @param {Matrix}   sparseMatrix      The SparseMatrix instance (S)
   * @param {Function} callback          The f(Dij,Sij) operation to invoke, where Dij = DenseMatrix(i,j) and Sij = SparseMatrix(i,j)
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(Sij,Dij)
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97477571
   */ return function algorithm02(denseMatrix, sparseMatrix, callback, inverse) {
        // dense matrix arrays
        var adata = denseMatrix._data;
        var asize = denseMatrix._size;
        var adt = denseMatrix._datatype; // sparse matrix arrays
        var bvalues = sparseMatrix._values;
        var bindex = sparseMatrix._index;
        var bptr = sparseMatrix._ptr;
        var bsize = sparseMatrix._size;
        var bdt = sparseMatrix._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $89c7b7a60bca4b11$export$ad1391ca020fdd96)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
         // sparse matrix cannot be a Pattern matrix
        if (!bvalues) throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string" && adt === bdt) {
            // datatype
            dt = adt; // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result (SparseMatrix)
        var cvalues = [];
        var cindex = [];
        var cptr = []; // loop columns in b
        for(var j = 0; j < columns; j++){
            // update cptr
            cptr[j] = cindex.length; // values in column j
            for(var k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++){
                // row
                var i = bindex[k]; // update C(i,j)
                var cij = inverse ? cf(bvalues[k], adata[i][j]) : cf(adata[i][j], bvalues[k]); // check for nonzero
                if (!eq(cij, zero)) {
                    // push i & v
                    cindex.push(i);
                    cvalues.push(cij);
                }
            }
        } // update cptr
        cptr[columns] = cindex.length; // return sparse matrix
        return sparseMatrix.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});




var $523b807a911c3d38$var$name = "algorithm03";
var $523b807a911c3d38$var$dependencies = [
    "typed"
];
var $523b807a911c3d38$export$486bb900f1a3c833 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($523b807a911c3d38$var$name, $523b807a911c3d38$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Iterates over SparseMatrix items and invokes the callback function f(Dij, Sij).
   * Callback function invoked M*N times.
   *
   *
   *          ┌  f(Dij, Sij)  ; S(i,j) !== 0
   * C(i,j) = ┤
   *          └  f(Dij, 0)    ; otherwise
   *
   *
   * @param {Matrix}   denseMatrix       The DenseMatrix instance (D)
   * @param {Matrix}   sparseMatrix      The SparseMatrix instance (C)
   * @param {Function} callback          The f(Dij,Sij) operation to invoke, where Dij = DenseMatrix(i,j) and Sij = SparseMatrix(i,j)
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(Sij,Dij)
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97477571
   */ return function algorithm03(denseMatrix, sparseMatrix, callback, inverse) {
        // dense matrix arrays
        var adata = denseMatrix._data;
        var asize = denseMatrix._size;
        var adt = denseMatrix._datatype; // sparse matrix arrays
        var bvalues = sparseMatrix._values;
        var bindex = sparseMatrix._index;
        var bptr = sparseMatrix._ptr;
        var bsize = sparseMatrix._size;
        var bdt = sparseMatrix._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $89c7b7a60bca4b11$export$ad1391ca020fdd96)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
         // sparse matrix cannot be a Pattern matrix
        if (!bvalues) throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string" && adt === bdt) {
            // datatype
            dt = adt; // convert 0 to the same datatype
            zero = typed.convert(0, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result (DenseMatrix)
        var cdata = []; // initialize dense matrix
        for(var z = 0; z < rows; z++)// initialize row
        cdata[z] = [];
         // workspace
        var x = []; // marks indicating we have a value in x for a given column
        var w = []; // loop columns in b
        for(var j = 0; j < columns; j++){
            // column mark
            var mark = j + 1; // values in column j
            for(var k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++){
                // row
                var i = bindex[k]; // update workspace
                x[i] = inverse ? cf(bvalues[k], adata[i][j]) : cf(adata[i][j], bvalues[k]);
                w[i] = mark;
            } // process workspace
            for(var y = 0; y < rows; y++)// check we have a calculated value for current row
            if (w[y] === mark) // use calculated value
            cdata[y][j] = x[y];
            else // calculate value
            cdata[y][j] = inverse ? cf(zero, adata[y][j]) : cf(adata[y][j], zero);
        } // return dense matrix
        return denseMatrix.createDenseMatrix({
            data: cdata,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});




var $c751eae6ac416bf7$var$name = "algorithm05";
var $c751eae6ac416bf7$var$dependencies = [
    "typed",
    "equalScalar"
];
var $c751eae6ac416bf7$export$f80c3080566d43b4 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($c751eae6ac416bf7$var$name, $c751eae6ac416bf7$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref;
    /**
   * Iterates over SparseMatrix A and SparseMatrix B nonzero items and invokes the callback function f(Aij, Bij).
   * Callback function invoked MAX(NNZA, NNZB) times
   *
   *
   *          ┌  f(Aij, Bij)  ; A(i,j) !== 0 || B(i,j) !== 0
   * C(i,j) = ┤
   *          └  0            ; otherwise
   *
   *
   * @param {Matrix}   a                 The SparseMatrix instance (A)
   * @param {Matrix}   b                 The SparseMatrix instance (B)
   * @param {Function} callback          The f(Aij,Bij) operation to invoke
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
   */ return function algorithm05(a, b, callback) {
        // sparse matrix arrays
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var asize = a._size;
        var adt = a._datatype; // sparse matrix arrays
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr;
        var bsize = b._size;
        var bdt = b._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $89c7b7a60bca4b11$export$ad1391ca020fdd96)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string" && adt === bdt) {
            // datatype
            dt = adt; // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result arrays
        var cvalues = avalues && bvalues ? [] : undefined;
        var cindex = [];
        var cptr = []; // workspaces
        var xa = cvalues ? [] : undefined;
        var xb = cvalues ? [] : undefined; // marks indicating we have a value in x for a given column
        var wa = [];
        var wb = []; // vars
        var i, j, k, k1; // loop columns
        for(j = 0; j < columns; j++){
            // update cptr
            cptr[j] = cindex.length; // columns mark
            var mark = j + 1; // loop values A(:,j)
            for(k = aptr[j], k1 = aptr[j + 1]; k < k1; k++){
                // row
                i = aindex[k]; // push index
                cindex.push(i); // update workspace
                wa[i] = mark; // check we need to process values
                if (xa) xa[i] = avalues[k];
            } // loop values B(:,j)
            for(k = bptr[j], k1 = bptr[j + 1]; k < k1; k++){
                // row
                i = bindex[k]; // check row existed in A
                if (wa[i] !== mark) // push index
                cindex.push(i);
                 // update workspace
                wb[i] = mark; // check we need to process values
                if (xb) xb[i] = bvalues[k];
            } // check we need to process values (non pattern matrix)
            if (cvalues) {
                // initialize first index in j
                k = cptr[j]; // loop index in j
                while(k < cindex.length){
                    // row
                    i = cindex[k]; // marks
                    var wai = wa[i];
                    var wbi = wb[i]; // check Aij or Bij are nonzero
                    if (wai === mark || wbi === mark) {
                        // matrix values @ i,j
                        var va = wai === mark ? xa[i] : zero;
                        var vb = wbi === mark ? xb[i] : zero; // Cij
                        var vc = cf(va, vb); // check for zero
                        if (!eq(vc, zero)) {
                            // push value
                            cvalues.push(vc); // increment pointer
                            k++;
                        } else // remove value @ i, do not increment pointer
                        cindex.splice(k, 1);
                    }
                }
            }
        } // update cptr
        cptr[columns] = cindex.length; // return sparse matrix
        return a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});



var $83b92f81e511657d$var$name = "algorithm11";
var $83b92f81e511657d$var$dependencies = [
    "typed",
    "equalScalar"
];
var $83b92f81e511657d$export$a38279a12199d831 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($83b92f81e511657d$var$name, $83b92f81e511657d$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref;
    /**
   * Iterates over SparseMatrix S nonzero items and invokes the callback function f(Sij, b).
   * Callback function invoked NZ times (number of nonzero items in S).
   *
   *
   *          ┌  f(Sij, b)  ; S(i,j) !== 0
   * C(i,j) = ┤
   *          └  0          ; otherwise
   *
   *
   * @param {Matrix}   s                 The SparseMatrix instance (S)
   * @param {Scalar}   b                 The Scalar value
   * @param {Function} callback          The f(Aij,b) operation to invoke
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(b,Sij)
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97626813
   */ return function algorithm11(s, b, callback, inverse) {
        // sparse matrix arrays
        var avalues = s._values;
        var aindex = s._index;
        var aptr = s._ptr;
        var asize = s._size;
        var adt = s._datatype; // sparse matrix cannot be a Pattern matrix
        if (!avalues) throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string") {
            // datatype
            dt = adt; // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt); // convert b to the same datatype
            b = typed.convert(b, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result arrays
        var cvalues = [];
        var cindex = [];
        var cptr = []; // loop columns
        for(var j = 0; j < columns; j++){
            // initialize ptr
            cptr[j] = cindex.length; // values in j
            for(var k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
                // row
                var i = aindex[k]; // invoke callback
                var v = inverse ? cf(b, avalues[k]) : cf(avalues[k], b); // check value is zero
                if (!eq(v, zero)) {
                    // push index & value
                    cindex.push(i);
                    cvalues.push(v);
                }
            }
        } // update ptr
        cptr[columns] = cindex.length; // return sparse matrix
        return s.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});



var $500ff63908aabda9$var$name = "algorithm12";
var $500ff63908aabda9$var$dependencies = [
    "typed",
    "DenseMatrix"
];
var $500ff63908aabda9$export$806772cd23b603dc = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($500ff63908aabda9$var$name, $500ff63908aabda9$var$dependencies, (_ref)=>{
    var { typed: typed, DenseMatrix: DenseMatrix } = _ref;
    /**
   * Iterates over SparseMatrix S nonzero items and invokes the callback function f(Sij, b).
   * Callback function invoked MxN times.
   *
   *
   *          ┌  f(Sij, b)  ; S(i,j) !== 0
   * C(i,j) = ┤
   *          └  f(0, b)    ; otherwise
   *
   *
   * @param {Matrix}   s                 The SparseMatrix instance (S)
   * @param {Scalar}   b                 The Scalar value
   * @param {Function} callback          The f(Aij,b) operation to invoke
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(b,Sij)
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97626813
   */ return function algorithm12(s, b, callback, inverse) {
        // sparse matrix arrays
        var avalues = s._values;
        var aindex = s._index;
        var aptr = s._ptr;
        var asize = s._size;
        var adt = s._datatype; // sparse matrix cannot be a Pattern matrix
        if (!avalues) throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string") {
            // datatype
            dt = adt; // convert b to the same datatype
            b = typed.convert(b, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result arrays
        var cdata = []; // workspaces
        var x = []; // marks indicating we have a value in x for a given column
        var w = []; // loop columns
        for(var j = 0; j < columns; j++){
            // columns mark
            var mark = j + 1; // values in j
            for(var k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
                // row
                var r = aindex[k]; // update workspace
                x[r] = avalues[k];
                w[r] = mark;
            } // loop rows
            for(var i = 0; i < rows; i++){
                // initialize C on first column
                if (j === 0) // create row array
                cdata[i] = [];
                 // check sparse matrix has a value @ i,j
                if (w[i] === mark) // invoke callback, update C
                cdata[i][j] = inverse ? cf(b, x[i]) : cf(x[i], b);
                else // dense matrix value @ i, j
                cdata[i][j] = inverse ? cf(b, 0) : cf(0, b);
            }
        } // return dense matrix
        return new DenseMatrix({
            data: cdata,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});




var $c68b38998aadcc11$var$name = "algorithm13";
var $c68b38998aadcc11$var$dependencies = [
    "typed"
];
var $c68b38998aadcc11$export$fa05124e71a8ffb3 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($c68b38998aadcc11$var$name, $c68b38998aadcc11$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Iterates over DenseMatrix items and invokes the callback function f(Aij..z, Bij..z).
   * Callback function invoked MxN times.
   *
   * C(i,j,...z) = f(Aij..z, Bij..z)
   *
   * @param {Matrix}   a                 The DenseMatrix instance (A)
   * @param {Matrix}   b                 The DenseMatrix instance (B)
   * @param {Function} callback          The f(Aij..z,Bij..z) operation to invoke
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97658658
   */ return function algorithm13(a, b, callback) {
        // a arrays
        var adata = a._data;
        var asize = a._size;
        var adt = a._datatype; // b arrays
        var bdata = b._data;
        var bsize = b._size;
        var bdt = b._datatype; // c arrays
        var csize = []; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $89c7b7a60bca4b11$export$ad1391ca020fdd96)(asize.length, bsize.length);
         // validate each one of the dimension sizes
        for(var s = 0; s < asize.length; s++){
            // must match
            if (asize[s] !== bsize[s]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
             // update dimension in c
            csize[s] = asize[s];
        } // datatype
        var dt; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string" && adt === bdt) {
            // datatype
            dt = adt; // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // populate cdata, iterate through dimensions
        var cdata = csize.length > 0 ? _iterate(cf, 0, csize, csize[0], adata, bdata) : []; // c matrix
        return a.createDenseMatrix({
            data: cdata,
            size: csize,
            datatype: dt
        });
    }; // recursive function
    function _iterate(f, level, s, n, av, bv) {
        // initialize array for this level
        var cv = []; // check we reach the last level
        if (level === s.length - 1) // loop arrays in last level
        for(var i = 0; i < n; i++)// invoke callback and store value
        cv[i] = f(av[i], bv[i]);
        else // iterate current level
        for(var j = 0; j < n; j++)// iterate next level
        cv[j] = _iterate(f, level + 1, s, s[level + 1], av[j], bv[j]);
        return cv;
    }
});




var $533d58927c47005f$var$name = "algorithm14";
var $533d58927c47005f$var$dependencies = [
    "typed"
];
var $533d58927c47005f$export$e5afe3bc814ef550 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($533d58927c47005f$var$name, $533d58927c47005f$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Iterates over DenseMatrix items and invokes the callback function f(Aij..z, b).
   * Callback function invoked MxN times.
   *
   * C(i,j,...z) = f(Aij..z, b)
   *
   * @param {Matrix}   a                 The DenseMatrix instance (A)
   * @param {Scalar}   b                 The Scalar value
   * @param {Function} callback          The f(Aij..z,b) operation to invoke
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(b,Aij..z)
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97659042
   */ return function algorithm14(a, b, callback, inverse) {
        // a arrays
        var adata = a._data;
        var asize = a._size;
        var adt = a._datatype; // datatype
        var dt; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string") {
            // datatype
            dt = adt; // convert b to the same datatype
            b = typed.convert(b, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // populate cdata, iterate through dimensions
        var cdata = asize.length > 0 ? _iterate(cf, 0, asize, asize[0], adata, b, inverse) : []; // c matrix
        return a.createDenseMatrix({
            data: cdata,
            size: (0, $6819694788cbfa38$export$9cd59f9826255e47)(asize),
            datatype: dt
        });
    }; // recursive function
    function _iterate(f, level, s, n, av, bv, inverse) {
        // initialize array for this level
        var cv = []; // check we reach the last level
        if (level === s.length - 1) // loop arrays in last level
        for(var i = 0; i < n; i++)// invoke callback and store value
        cv[i] = inverse ? f(bv, av[i]) : f(av[i], bv);
        else // iterate current level
        for(var j = 0; j < n; j++)// iterate next level
        cv[j] = _iterate(f, level + 1, s, s[level + 1], av[j], bv, inverse);
        return cv;
    }
});



var $5de7f52c1e6972c9$var$name = "mod";
var $5de7f52c1e6972c9$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "DenseMatrix"
];
var $5de7f52c1e6972c9$export$735bb6c30160c058 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($5de7f52c1e6972c9$var$name, $5de7f52c1e6972c9$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, DenseMatrix: DenseMatrix } = _ref;
    var algorithm02 = (0, $caf358e9c2d20263$export$92edb534a8f19a37)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm03 = (0, $523b807a911c3d38$export$486bb900f1a3c833)({
        typed: typed
    });
    var algorithm05 = (0, $c751eae6ac416bf7$export$f80c3080566d43b4)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm11 = (0, $83b92f81e511657d$export$a38279a12199d831)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm12 = (0, $500ff63908aabda9$export$806772cd23b603dc)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $c68b38998aadcc11$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $533d58927c47005f$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Calculates the modulus, the remainder of an integer division.
   *
   * For matrices, the function is evaluated element wise.
   *
   * The modulus is defined as:
   *
   *     x - y * floor(x / y)
   *
   * See https://en.wikipedia.org/wiki/Modulo_operation.
   *
   * Syntax:
   *
   *    math.mod(x, y)
   *
   * Examples:
   *
   *    math.mod(8, 3)                // returns 2
   *    math.mod(11, 2)               // returns 1
   *
   *    function isOdd(x) {
   *      return math.mod(x, 2) != 0
   *    }
   *
   *    isOdd(2)                      // returns false
   *    isOdd(3)                      // returns true
   *
   * See also:
   *
   *    divide
   *
   * @param  {number | BigNumber | Fraction | Array | Matrix} x Dividend
   * @param  {number | BigNumber | Fraction | Array | Matrix} y Divisor
   * @return {number | BigNumber | Fraction | Array | Matrix} Returns the remainder of `x` divided by `y`.
   */ return typed($5de7f52c1e6972c9$var$name, {
        "number, number": (0, $4b37ed316f05dd33$export$64b58c5b0372ae95),
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            if (y.isNeg()) throw new Error("Cannot calculate mod for a negative divisor");
            return y.isZero() ? x : x.mod(y);
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            if (y.compare(0) < 0) throw new Error("Cannot calculate mod for a negative divisor");
             // Workaround suggested in Fraction.js library to calculate correct modulo for negative dividend
            return x.compare(0) >= 0 ? x.mod(y) : x.mod(y).add(y).mod(y);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm05(x, y, this, false);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, this, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, this, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm11(x, y, this, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, this, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, this, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});




var $87b5a4e357abde7d$var$name = "algorithm01";
var $87b5a4e357abde7d$var$dependencies = [
    "typed"
];
var $87b5a4e357abde7d$export$5e6d55d37a917802 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($87b5a4e357abde7d$var$name, $87b5a4e357abde7d$var$dependencies, (_ref)=>{
    var { typed: typed } = _ref;
    /**
   * Iterates over SparseMatrix nonzero items and invokes the callback function f(Dij, Sij).
   * Callback function invoked NNZ times (number of nonzero items in SparseMatrix).
   *
   *
   *          ┌  f(Dij, Sij)  ; S(i,j) !== 0
   * C(i,j) = ┤
   *          └  Dij          ; otherwise
   *
   *
   * @param {Matrix}   denseMatrix       The DenseMatrix instance (D)
   * @param {Matrix}   sparseMatrix      The SparseMatrix instance (S)
   * @param {Function} callback          The f(Dij,Sij) operation to invoke, where Dij = DenseMatrix(i,j) and Sij = SparseMatrix(i,j)
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(Sij,Dij)
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97477571
   */ return function algorithm1(denseMatrix, sparseMatrix, callback, inverse) {
        // dense matrix arrays
        var adata = denseMatrix._data;
        var asize = denseMatrix._size;
        var adt = denseMatrix._datatype; // sparse matrix arrays
        var bvalues = sparseMatrix._values;
        var bindex = sparseMatrix._index;
        var bptr = sparseMatrix._ptr;
        var bsize = sparseMatrix._size;
        var bdt = sparseMatrix._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $89c7b7a60bca4b11$export$ad1391ca020fdd96)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
         // sparse matrix cannot be a Pattern matrix
        if (!bvalues) throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // process data types
        var dt = typeof adt === "string" && adt === bdt ? adt : undefined; // callback function
        var cf = dt ? typed.find(callback, [
            dt,
            dt
        ]) : callback; // vars
        var i, j; // result (DenseMatrix)
        var cdata = []; // initialize c
        for(i = 0; i < rows; i++)cdata[i] = [];
         // workspace
        var x = []; // marks indicating we have a value in x for a given column
        var w = []; // loop columns in b
        for(j = 0; j < columns; j++){
            // column mark
            var mark = j + 1; // values in column j
            for(var k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++){
                // row
                i = bindex[k]; // update workspace
                x[i] = inverse ? cf(bvalues[k], adata[i][j]) : cf(adata[i][j], bvalues[k]); // mark i as updated
                w[i] = mark;
            } // loop rows
            for(i = 0; i < rows; i++)// check row is in workspace
            if (w[i] === mark) // c[i][j] was already calculated
            cdata[i][j] = x[i];
            else // item does not exist in S
            cdata[i][j] = adata[i][j];
        } // return dense matrix
        return denseMatrix.createDenseMatrix({
            data: cdata,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});






var $648c171bfbb07130$var$name = "algorithm06";
var $648c171bfbb07130$var$dependencies = [
    "typed",
    "equalScalar"
];
var $648c171bfbb07130$export$d6f401e6f2a7e54b = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($648c171bfbb07130$var$name, $648c171bfbb07130$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref;
    /**
   * Iterates over SparseMatrix A and SparseMatrix B nonzero items and invokes the callback function f(Aij, Bij).
   * Callback function invoked (Anz U Bnz) times, where Anz and Bnz are the nonzero elements in both matrices.
   *
   *
   *          ┌  f(Aij, Bij)  ; A(i,j) !== 0 && B(i,j) !== 0
   * C(i,j) = ┤
   *          └  0            ; otherwise
   *
   *
   * @param {Matrix}   a                 The SparseMatrix instance (A)
   * @param {Matrix}   b                 The SparseMatrix instance (B)
   * @param {Function} callback          The f(Aij,Bij) operation to invoke
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
   */ return function algorithm06(a, b, callback) {
        // sparse matrix arrays
        var avalues = a._values;
        var asize = a._size;
        var adt = a._datatype; // sparse matrix arrays
        var bvalues = b._values;
        var bsize = b._size;
        var bdt = b._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $89c7b7a60bca4b11$export$ad1391ca020fdd96)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string" && adt === bdt) {
            // datatype
            dt = adt; // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result arrays
        var cvalues = avalues && bvalues ? [] : undefined;
        var cindex = [];
        var cptr = []; // workspaces
        var x = cvalues ? [] : undefined; // marks indicating we have a value in x for a given column
        var w = []; // marks indicating value in a given row has been updated
        var u = []; // loop columns
        for(var j = 0; j < columns; j++){
            // update cptr
            cptr[j] = cindex.length; // columns mark
            var mark = j + 1; // scatter the values of A(:,j) into workspace
            (0, $dd57e6221b0e50b6$export$c97954fff4307550)(a, j, w, x, u, mark, cindex, cf); // scatter the values of B(:,j) into workspace
            (0, $dd57e6221b0e50b6$export$c97954fff4307550)(b, j, w, x, u, mark, cindex, cf); // check we need to process values (non pattern matrix)
            if (x) {
                // initialize first index in j
                var k = cptr[j]; // loop index in j
                while(k < cindex.length){
                    // row
                    var i = cindex[k]; // check function was invoked on current row (Aij !=0 && Bij != 0)
                    if (u[i] === mark) {
                        // value @ i
                        var v = x[i]; // check for zero value
                        if (!eq(v, zero)) {
                            // push value
                            cvalues.push(v); // increment pointer
                            k++;
                        } else // remove value @ i, do not increment pointer
                        cindex.splice(k, 1);
                    } else // remove value @ i, do not increment pointer
                    cindex.splice(k, 1);
                }
            } else {
                // initialize first index in j
                var p = cptr[j]; // loop index in j
                while(p < cindex.length){
                    // row
                    var r = cindex[p]; // check function was invoked on current row (Aij !=0 && Bij != 0)
                    if (u[r] !== mark) // remove value @ i, do not increment pointer
                    cindex.splice(p, 1);
                    else // increment pointer
                    p++;
                }
            }
        } // update cptr
        cptr[columns] = cindex.length; // return sparse matrix
        return a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});






var $0593ec8dcbba0d4c$var$name = "nthRoot";
var $0593ec8dcbba0d4c$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "BigNumber"
];
var $0593ec8dcbba0d4c$export$964e38ef60b1ac68 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($0593ec8dcbba0d4c$var$name, $0593ec8dcbba0d4c$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, BigNumber: _BigNumber } = _ref;
    var algorithm01 = (0, $87b5a4e357abde7d$export$5e6d55d37a917802)({
        typed: typed
    });
    var algorithm02 = (0, $caf358e9c2d20263$export$92edb534a8f19a37)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm06 = (0, $648c171bfbb07130$export$d6f401e6f2a7e54b)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm11 = (0, $83b92f81e511657d$export$a38279a12199d831)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm13 = (0, $c68b38998aadcc11$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $533d58927c47005f$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Calculate the nth root of a value.
   * The principal nth root of a positive real number A, is the positive real
   * solution of the equation
   *
   *     x^root = A
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *     math.nthRoot(a)
   *     math.nthRoot(a, root)
   *
   * Examples:
   *
   *     math.nthRoot(9, 2)    // returns 3, as 3^2 == 9
   *     math.sqrt(9)          // returns 3, as 3^2 == 9
   *     math.nthRoot(64, 3)   // returns 4, as 4^3 == 64
   *
   * See also:
   *
   *     sqrt, pow
   *
   * @param {number | BigNumber | Array | Matrix | Complex} a
   *              Value for which to calculate the nth root
   * @param {number | BigNumber} [root=2]    The root.
   * @return {number | Complex | Array | Matrix} Returns the nth root of `a`
   */ var complexErr = "Complex number not supported in function nthRoot. Use nthRoots instead.";
    return typed($0593ec8dcbba0d4c$var$name, {
        number: (0, $4b37ed316f05dd33$export$9f26f16bd796a7b3),
        "number, number": (0, $4b37ed316f05dd33$export$9f26f16bd796a7b3),
        BigNumber: function BigNumber(x) {
            return _bigNthRoot(x, new _BigNumber(2));
        },
        Complex: function Complex(x) {
            throw new Error(complexErr);
        },
        "Complex, number": function ComplexNumber(x, y) {
            throw new Error(complexErr);
        },
        "BigNumber, BigNumber": _bigNthRoot,
        "Array | Matrix": function ArrayMatrix(x) {
            return this(x, 2);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            // density must be one (no zeros in matrix)
            if (y.density() === 1) // sparse + sparse
            return algorithm06(x, y, this);
            else // throw exception
            throw new Error("Root must be non-zero");
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, this, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            // density must be one (no zeros in matrix)
            if (y.density() === 1) // dense + sparse
            return algorithm01(x, y, this, false);
            else // throw exception
            throw new Error("Root must be non-zero");
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, number | BigNumber": function SparseMatrixNumberBigNumber(x, y) {
            return algorithm11(x, y, this, false);
        },
        "DenseMatrix, number | BigNumber": function DenseMatrixNumberBigNumber(x, y) {
            return algorithm14(x, y, this, false);
        },
        "number | BigNumber, SparseMatrix": function numberBigNumberSparseMatrix(x, y) {
            // density must be one (no zeros in matrix)
            if (y.density() === 1) // sparse - scalar
            return algorithm11(y, x, this, true);
            else // throw exception
            throw new Error("Root must be non-zero");
        },
        "number | BigNumber, DenseMatrix": function numberBigNumberDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        "Array, number | BigNumber": function ArrayNumberBigNumber(x, y) {
            // use matrix implementation
            return this(matrix(x), y).valueOf();
        },
        "number | BigNumber, Array": function numberBigNumberArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y)).valueOf();
        }
    });
    /**
   * Calculate the nth root of a for BigNumbers, solve x^root == a
   * https://rosettacode.org/wiki/Nth_root#JavaScript
   * @param {BigNumber} a
   * @param {BigNumber} root
   * @private
   */ function _bigNthRoot(a, root) {
        var precision = _BigNumber.precision;
        var Big = _BigNumber.clone({
            precision: precision + 2
        });
        var zero = new _BigNumber(0);
        var one = new Big(1);
        var inv = root.isNegative();
        if (inv) root = root.neg();
        if (root.isZero()) throw new Error("Root must be non-zero");
        if (a.isNegative() && !root.abs().mod(2).equals(1)) throw new Error("Root must be odd when a is negative.");
         // edge cases zero and infinity
        if (a.isZero()) return inv ? new Big(Infinity) : 0;
        if (!a.isFinite()) return inv ? zero : a;
        var x = a.abs().pow(one.div(root)); // If a < 0, we require that root is an odd integer,
        // so (-1) ^ (1/root) = -1
        x = a.isNeg() ? x.neg() : x;
        return new _BigNumber((inv ? one.div(x) : x).toPrecision(precision));
    }
});
var $0593ec8dcbba0d4c$export$f098cf3c4ef0f7ef = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($0593ec8dcbba0d4c$var$name, [
    "typed"
], (_ref2)=>{
    var { typed: typed } = _ref2;
    return typed($0593ec8dcbba0d4c$var$name, {
        number: (0, $4b37ed316f05dd33$export$9f26f16bd796a7b3),
        "number, number": (0, $4b37ed316f05dd33$export$9f26f16bd796a7b3)
    });
});



function $ca365da641461865$export$f0829713dc162a8() {
    throw new Error('No "bignumber" implementation available');
}
function $ca365da641461865$export$9978fd42ef220ba0() {
    throw new Error('No "fraction" implementation available');
}
function $ca365da641461865$export$b81416cb7ecca475() {
    throw new Error('No "matrix" implementation available');
}
function $ca365da641461865$export$a38f8cf2e48f2bd() {
    throw new Error('No "index" implementation available');
}
function $ca365da641461865$export$32411ef9704d5eea() {
    throw new Error('No "matrix" implementation available');
}


var $853d7e1d4a10ae79$var$name = "numeric";
var $853d7e1d4a10ae79$var$dependencies = [
    "number",
    "?bignumber",
    "?fraction"
];
var $853d7e1d4a10ae79$export$e3cf2d123164e554 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($853d7e1d4a10ae79$var$name, $853d7e1d4a10ae79$var$dependencies, (_ref)=>{
    var { number: _number, bignumber: bignumber, fraction: fraction } = _ref;
    var validInputTypes = {
        string: true,
        number: true,
        BigNumber: true,
        Fraction: true
    }; // Load the conversion functions for each output type
    var validOutputTypes = {
        number: (x)=>_number(x),
        BigNumber: bignumber ? (x)=>bignumber(x) : (0, $ca365da641461865$export$f0829713dc162a8),
        Fraction: fraction ? (x)=>fraction(x) : (0, $ca365da641461865$export$9978fd42ef220ba0)
    };
    /**
   * Convert a numeric input to a specific numeric type: number, BigNumber, or Fraction.
   *
   * Syntax:
   *
   *    math.numeric(x)
   *
   * Examples:
   *
   *    math.numeric('4')                           // returns number 4
   *    math.numeric('4', 'number')                 // returns number 4
   *    math.numeric('4', 'BigNumber')              // returns BigNumber 4
   *    math.numeric('4', 'Fraction')               // returns Fraction 4
   *    math.numeric(4, 'Fraction')                 // returns Fraction 4
   *    math.numeric(math.fraction(2, 5), 'number') // returns number 0.4
   *
   * See also:
   *
   *    number, fraction, bignumber, string, format
   *
   * @param {string | number | BigNumber | Fraction } value
   *              A numeric value or a string containing a numeric value
   * @param {string} outputType
   *              Desired numeric output type.
   *              Available values: 'number', 'BigNumber', or 'Fraction'
   * @return {number | BigNumber | Fraction}
   *              Returns an instance of the numeric in the requested type
   */ return function numeric(value, outputType) {
        var inputType = (0, $d8097b7a6d6e36d8$export$f5bbd400c2f4426f)(value);
        if (!(inputType in validInputTypes)) throw new TypeError("Cannot convert " + value + ' of type "' + inputType + '"; valid input types are ' + Object.keys(validInputTypes).join(", "));
        if (!(outputType in validOutputTypes)) throw new TypeError("Cannot convert " + value + ' to type "' + outputType + '"; valid output types are ' + Object.keys(validOutputTypes).join(", "));
        if (outputType === inputType) return value;
        else return validOutputTypes[outputType](value);
    };
});








var $7f11fcfd924108fa$var$name = "or";
var $7f11fcfd924108fa$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "DenseMatrix"
];
var $7f11fcfd924108fa$export$3d19b09907d6fd4a = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($7f11fcfd924108fa$var$name, $7f11fcfd924108fa$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, DenseMatrix: DenseMatrix } = _ref;
    var algorithm03 = (0, $523b807a911c3d38$export$486bb900f1a3c833)({
        typed: typed
    });
    var algorithm05 = (0, $c751eae6ac416bf7$export$f80c3080566d43b4)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm12 = (0, $500ff63908aabda9$export$806772cd23b603dc)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $c68b38998aadcc11$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $533d58927c47005f$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Logical `or`. Test if at least one value is defined with a nonzero/nonempty value.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.or(x, y)
   *
   * Examples:
   *
   *    math.or(2, 4)   // returns true
   *
   *    a = [2, 5, 0]
   *    b = [0, 22, 0]
   *    c = 0
   *
   *    math.or(a, b)   // returns [true, true, false]
   *    math.or(b, c)   // returns [false, true, false]
   *
   * See also:
   *
   *    and, not, xor
   *
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} x First value to check
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} y Second value to check
   * @return {boolean | Array | Matrix}
   *            Returns true when one of the inputs is defined with a nonzero/nonempty value.
   */ return typed($7f11fcfd924108fa$var$name, {
        "number, number": (0, $e69afcd9e58cec61$export$cb9e31d07eec8012),
        "Complex, Complex": function ComplexComplex(x, y) {
            return x.re !== 0 || x.im !== 0 || y.re !== 0 || y.im !== 0;
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return !x.isZero() && !x.isNaN() || !y.isZero() && !y.isNaN();
        },
        "Unit, Unit": function UnitUnit(x, y) {
            return this(x.value || 0, y.value || 0);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm05(x, y, this);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, this, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, this, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm12(x, y, this, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, this, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, this, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});




function $b113219b83527e4b$export$c8994973cec629ae(err, fnName, value) {
    // TODO: add information with the index (also needs transform in expression parser)
    var details;
    if (String(err).indexOf("Unexpected type") !== -1) {
        details = arguments.length > 2 ? " (type: " + (0, $d8097b7a6d6e36d8$export$f5bbd400c2f4426f)(value) + ", value: " + JSON.stringify(value) + ")" : " (type: " + err.data.actual + ")";
        return new TypeError("Cannot calculate " + fnName + ", unexpected type of argument" + details);
    }
    if (String(err).indexOf("complex numbers") !== -1) {
        details = arguments.length > 2 ? " (type: " + (0, $d8097b7a6d6e36d8$export$f5bbd400c2f4426f)(value) + ", value: " + JSON.stringify(value) + ")" : "";
        return new TypeError("Cannot calculate " + fnName + ", no ordering relation is defined for complex numbers" + details);
    }
    return err;
}


var $5fdc7816ae0643b9$var$name = "prod";
var $5fdc7816ae0643b9$var$dependencies = [
    "typed",
    "config",
    "multiplyScalar",
    "numeric"
];
var $5fdc7816ae0643b9$export$60310f756e9cfd41 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($5fdc7816ae0643b9$var$name, $5fdc7816ae0643b9$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, multiplyScalar: multiplyScalar, numeric: numeric } = _ref;
    /**
   * Compute the product of a matrix or a list with values.
   * In case of a (multi dimensional) array or matrix, the sum of all
   * elements will be calculated.
   *
   * Syntax:
   *
   *     math.prod(a, b, c, ...)
   *     math.prod(A)
   *
   * Examples:
   *
   *     math.multiply(2, 3)           // returns 6
   *     math.prod(2, 3)               // returns 6
   *     math.prod(2, 3, 4)            // returns 24
   *     math.prod([2, 3, 4])          // returns 24
   *     math.prod([[2, 5], [4, 3]])   // returns 120
   *
   * See also:
   *
   *    mean, median, min, max, sum, std, variance
   *
   * @param {... *} args  A single matrix or or multiple scalar values
   * @return {*} The product of all values
   */ return typed($5fdc7816ae0643b9$var$name, {
        // prod([a, b, c, d, ...])
        "Array | Matrix": _prod,
        // prod([a, b, c, d, ...], dim)
        "Array | Matrix, number | BigNumber": function ArrayMatrixNumberBigNumber(array, dim) {
            // TODO: implement prod(A, dim)
            throw new Error("prod(A, dim) is not yet supported"); // return reduce(arguments[0], arguments[1], math.prod)
        },
        // prod(a, b, c, d, ...)
        "...": function _(args) {
            return _prod(args);
        }
    });
    /**
   * Recursively calculate the product of an n-dimensional array
   * @param {Array} array
   * @return {number} prod
   * @private
   */ function _prod(array) {
        var prod;
        (0, $dd57e6221b0e50b6$export$519ada94592b97fc)(array, function(value) {
            try {
                prod = prod === undefined ? value : multiplyScalar(prod, value);
            } catch (err) {
                throw (0, $b113219b83527e4b$export$c8994973cec629ae)(err, "prod", value);
            }
        }); // make sure returning numeric value: parse a string into a numeric value
        if (typeof prod === "string") prod = numeric(prod, config.number);
        if (prod === undefined) throw new Error("Cannot calculate prod of an empty array");
        return prod;
    }
});



var $46de69f0f41f52a9$var$name = "reshape";
var $46de69f0f41f52a9$var$dependencies = [
    "typed",
    "isInteger",
    "matrix"
];
var $46de69f0f41f52a9$export$76c9752f34fb3440 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($46de69f0f41f52a9$var$name, $46de69f0f41f52a9$var$dependencies, (_ref)=>{
    var { typed: typed, isInteger: isInteger } = _ref;
    /**
   * Reshape a multi dimensional array to fit the specified dimensions
   *
   * Syntax:
   *
   *     math.reshape(x, sizes)
   *
   * Examples:
   *
   *     math.reshape([1, 2, 3, 4, 5, 6], [2, 3])
   *     // returns Array  [[1, 2, 3], [4, 5, 6]]
   *
   *     math.reshape([[1, 2], [3, 4]], [1, 4])
   *     // returns Array  [[1, 2, 3, 4]]
   *
   *     math.reshape([[1, 2], [3, 4]], [4])
   *     // returns Array [1, 2, 3, 4]
   *
   *     const x = math.matrix([1, 2, 3, 4, 5, 6, 7, 8])
   *     math.reshape(x, [2, 2, 2])
   *     // returns Matrix [[[1, 2], [3, 4]], [[5, 6], [7, 8]]]
   *
   *    math.reshape([1, 2, 3, 4], [-1, 2])
   *    // returns Matrix [[1, 2], [3, 4]]
   *
   * See also:
   *
   *     size, squeeze, resize
   *
   * @param {Array | Matrix | *} x  Matrix to be reshaped
   * @param {number[]} sizes        One dimensional array with integral sizes for
   *                                each dimension. One -1 is allowed as wildcard,
   *                                which calculates this dimension automatically.
   *
   * @return {* | Array | Matrix}   A reshaped clone of matrix `x`
   *
   * @throws {TypeError}            If `sizes` does not contain solely integers
   * @throws {DimensionError}       If the product of the new dimension sizes does
   *                                not equal that of the old ones
   */ return typed($46de69f0f41f52a9$var$name, {
        "Matrix, Array": function MatrixArray(x, sizes) {
            return x.reshape(sizes);
        },
        "Array, Array": function ArrayArray(x, sizes) {
            sizes.forEach(function(size) {
                if (!isInteger(size)) throw new TypeError("Invalid size for dimension: " + size);
            });
            return (0, $a14a10567870d913$export$9eaad88cf88cee2b)(x, sizes);
        }
    });
});




var $82d61f6ea0246e24$var$name = "size";
var $82d61f6ea0246e24$var$dependencies = [
    "typed",
    "config",
    "?matrix"
];
var $82d61f6ea0246e24$export$9151c23a59ce3fb6 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($82d61f6ea0246e24$var$name, $82d61f6ea0246e24$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix } = _ref;
    /**
   * Calculate the size of a matrix or scalar.
   *
   * Syntax:
   *
   *     math.size(x)
   *
   * Examples:
   *
   *     math.size(2.3)                  // returns []
   *     math.size('hello world')        // returns [11]
   *
   *     const A = [[1, 2, 3], [4, 5, 6]]
   *     math.size(A)                    // returns [2, 3]
   *     math.size(math.range(1,6))      // returns [5]
   *
   * See also:
   *
   *     count, resize, squeeze, subset
   *
   * @param {boolean | number | Complex | Unit | string | Array | Matrix} x  A matrix
   * @return {Array | Matrix} A vector with size of `x`.
   */ return typed($82d61f6ea0246e24$var$name, {
        Matrix: function Matrix(x) {
            return x.create(x.size());
        },
        Array: (0, $a14a10567870d913$export$51ffaee4afb683a5),
        string: function string(x) {
            return config.matrix === "Array" ? [
                x.length
            ] : matrix([
                x.length
            ]);
        },
        "number | Complex | BigNumber | Unit | boolean | null": function numberComplexBigNumberUnitBooleanNull(x) {
            // scalar
            return config.matrix === "Array" ? [] : matrix ? matrix([]) : (0, $ca365da641461865$export$b81416cb7ecca475)();
        }
    });
});







var $5200888766c056e5$var$name = "algorithm07";
var $5200888766c056e5$var$dependencies = [
    "typed",
    "DenseMatrix"
];
var $5200888766c056e5$export$b908fb77c4366999 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($5200888766c056e5$var$name, $5200888766c056e5$var$dependencies, (_ref)=>{
    var { typed: typed, DenseMatrix: DenseMatrix } = _ref;
    /**
   * Iterates over SparseMatrix A and SparseMatrix B items (zero and nonzero) and invokes the callback function f(Aij, Bij).
   * Callback function invoked MxN times.
   *
   * C(i,j) = f(Aij, Bij)
   *
   * @param {Matrix}   a                 The SparseMatrix instance (A)
   * @param {Matrix}   b                 The SparseMatrix instance (B)
   * @param {Function} callback          The f(Aij,Bij) operation to invoke
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
   */ return function algorithm07(a, b, callback) {
        // sparse matrix arrays
        var asize = a._size;
        var adt = a._datatype; // sparse matrix arrays
        var bsize = b._size;
        var bdt = b._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $89c7b7a60bca4b11$export$ad1391ca020fdd96)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string" && adt === bdt) {
            // datatype
            dt = adt; // convert 0 to the same datatype
            zero = typed.convert(0, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // vars
        var i, j; // result arrays
        var cdata = []; // initialize c
        for(i = 0; i < rows; i++)cdata[i] = [];
         // workspaces
        var xa = [];
        var xb = []; // marks indicating we have a value in x for a given column
        var wa = [];
        var wb = []; // loop columns
        for(j = 0; j < columns; j++){
            // columns mark
            var mark = j + 1; // scatter the values of A(:,j) into workspace
            _scatter(a, j, wa, xa, mark); // scatter the values of B(:,j) into workspace
            _scatter(b, j, wb, xb, mark); // loop rows
            for(i = 0; i < rows; i++){
                // matrix values @ i,j
                var va = wa[i] === mark ? xa[i] : zero;
                var vb = wb[i] === mark ? xb[i] : zero; // invoke callback
                cdata[i][j] = cf(va, vb);
            }
        } // return dense matrix
        return new DenseMatrix({
            data: cdata,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
    function _scatter(m, j, w, x, mark) {
        // a arrays
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr; // loop values in column j
        for(var k = ptr[j], k1 = ptr[j + 1]; k < k1; k++){
            // row
            var i = index[k]; // update workspace
            w[i] = mark;
            x[i] = values[k];
        }
    }
});





var $bbdd46adbb465239$var$name = "smaller";
var $bbdd46adbb465239$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "DenseMatrix"
];
var $bbdd46adbb465239$export$6b477d90b957f03e = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($bbdd46adbb465239$var$name, $bbdd46adbb465239$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, DenseMatrix: DenseMatrix } = _ref;
    var algorithm03 = (0, $523b807a911c3d38$export$486bb900f1a3c833)({
        typed: typed
    });
    var algorithm07 = (0, $5200888766c056e5$export$b908fb77c4366999)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm12 = (0, $500ff63908aabda9$export$806772cd23b603dc)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $c68b38998aadcc11$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $533d58927c47005f$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Test whether value x is smaller than y.
   *
   * The function returns true when x is smaller than y and the relative
   * difference between x and y is smaller than the configured epsilon. The
   * function cannot be used to compare values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.smaller(x, y)
   *
   * Examples:
   *
   *    math.smaller(2, 3)            // returns true
   *    math.smaller(5, 2 * 2)        // returns false
   *
   *    const a = math.unit('5 cm')
   *    const b = math.unit('2 inch')
   *    math.smaller(a, b)            // returns true
   *
   * See also:
   *
   *    equal, unequal, smallerEq, smaller, smallerEq, compare
   *
   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} x First value to compare
   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} y Second value to compare
   * @return {boolean | Array | Matrix} Returns true when the x is smaller than y, else returns false
   */ return typed($bbdd46adbb465239$var$name, {
        "boolean, boolean": function booleanBoolean(x, y) {
            return x < y;
        },
        "number, number": function numberNumber(x, y) {
            return x < y && !(0, $668e051498bf5fa0$export$6f3989c6ecc04081)(x, y, config.epsilon);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.lt(y) && !(0, $53e0635127e7c5a0$export$6f3989c6ecc04081)(x, y, config.epsilon);
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.compare(y) === -1;
        },
        "Complex, Complex": function ComplexComplex(x, y) {
            throw new TypeError("No ordering relation is defined for complex numbers");
        },
        "Unit, Unit": function UnitUnit(x, y) {
            if (!x.equalBase(y)) throw new Error("Cannot compare units with different base");
            return this(x.value, y.value);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, this);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, this, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, this, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm12(x, y, this, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, this, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, this, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});
var $bbdd46adbb465239$export$4f82e7db4d803209 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($bbdd46adbb465239$var$name, [
    "typed",
    "config"
], (_ref2)=>{
    var { typed: typed, config: config } = _ref2;
    return typed($bbdd46adbb465239$var$name, {
        "number, number": function numberNumber(x, y) {
            return x < y && !(0, $668e051498bf5fa0$export$6f3989c6ecc04081)(x, y, config.epsilon);
        }
    });
});




var $dabccf1fd7e2b78c$var$name = "squeeze";
var $dabccf1fd7e2b78c$var$dependencies = [
    "typed",
    "matrix"
];
var $dabccf1fd7e2b78c$export$1a885844ffd505a4 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($dabccf1fd7e2b78c$var$name, $dabccf1fd7e2b78c$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix } = _ref;
    /**
   * Squeeze a matrix, remove inner and outer singleton dimensions from a matrix.
   *
   * Syntax:
   *
   *     math.squeeze(x)
   *
   * Examples:
   *
   *     math.squeeze([3])           // returns 3
   *     math.squeeze([[3]])         // returns 3
   *
   *     const A = math.zeros(3, 1)    // returns [[0], [0], [0]] (size 3x1)
   *     math.squeeze(A)             // returns [0, 0, 0] (size 3)
   *
   *     const B = math.zeros(1, 3)    // returns [[0, 0, 0]] (size 1x3)
   *     math.squeeze(B)             // returns [0, 0, 0] (size 3)
   *
   *     // only inner and outer dimensions are removed
   *     const C = math.zeros(2, 1, 3) // returns [[[0, 0, 0]], [[0, 0, 0]]] (size 2x1x3)
   *     math.squeeze(C)             // returns [[[0, 0, 0]], [[0, 0, 0]]] (size 2x1x3)
   *
   * See also:
   *
   *     subset
   *
   * @param {Matrix | Array} x      Matrix to be squeezed
   * @return {Matrix | Array} Squeezed matrix
   */ return typed($dabccf1fd7e2b78c$var$name, {
        Array: function Array1(x) {
            return (0, $a14a10567870d913$export$889c931173b77c2f)((0, $6819694788cbfa38$export$9cd59f9826255e47)(x));
        },
        Matrix: function Matrix(x) {
            var res = (0, $a14a10567870d913$export$889c931173b77c2f)(x.toArray()); // FIXME: return the same type of matrix as the input
            return Array.isArray(res) ? matrix(res) : res;
        },
        any: function any(x) {
            // scalar
            return (0, $6819694788cbfa38$export$9cd59f9826255e47)(x);
        }
    });
});







var $5d38c660a6bdbeba$var$name = "subset";
var $5d38c660a6bdbeba$var$dependencies = [
    "typed",
    "matrix"
];
var $5d38c660a6bdbeba$export$d8c56e74d683bb33 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($5d38c660a6bdbeba$var$name, $5d38c660a6bdbeba$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix } = _ref;
    /**
   * Get or set a subset of a matrix or string.
   *
   * Syntax:
   *     math.subset(value, index)                                // retrieve a subset
   *     math.subset(value, index, replacement [, defaultValue])  // replace a subset
   *
   * Examples:
   *
   *     // get a subset
   *     const d = [[1, 2], [3, 4]]
   *     math.subset(d, math.index(1, 0))        // returns 3
   *     math.subset(d, math.index([0, 1], 1))   // returns [[2], [4]]
   *
   *     // replace a subset
   *     const e = []
   *     const f = math.subset(e, math.index(0, [0, 2]), [5, 6])  // f = [[5, 6]] and e = [[5, 0, 6]]
   *     const g = math.subset(f, math.index(1, 1), 7, 0)         // g = [[5, 6], [0, 7]]
   *
   *     // get submatrix using ranges
   *     const M = [
   *       [1,2,3],
   *       [4,5,6],
   *       [7,8,9]
   *     ]
   *     math.subset(M, math.index(math.range(0,2), math.range(0,3))) // [[1,2,3],[4,5,6]]
   *
   * See also:
   *
   *     size, resize, squeeze, index
   *
   * @param {Array | Matrix | string} matrix  An array, matrix, or string
   * @param {Index} index
   *    For each dimension of the target, specifies an index or a list of
   *    indices to fetch or set. `subset` uses the cartesian product of
   *    the indices specified in each dimension.
   * @param {*} [replacement]                 An array, matrix, or scalar.
   *                                          If provided, the subset is replaced with replacement.
   *                                          If not provided, the subset is returned
   * @param {*} [defaultValue=undefined]      Default value, filled in on new entries when
   *                                          the matrix is resized. If not provided,
   *                                          math.matrix elements will be left undefined.
   * @return {Array | Matrix | string} Either the retrieved subset or the updated matrix.
   */ return typed($5d38c660a6bdbeba$var$name, {
        // get subset
        "Array, Index": function ArrayIndex(value, index) {
            var m = matrix(value);
            var subset = m.subset(index); // returns a Matrix
            return index.isScalar() ? subset : subset.valueOf(); // return an Array (like the input)
        },
        "Matrix, Index": function MatrixIndex(value, index) {
            return value.subset(index);
        },
        "Object, Index": $5d38c660a6bdbeba$var$_getObjectProperty,
        "string, Index": $5d38c660a6bdbeba$var$_getSubstring,
        // set subset
        "Array, Index, any": function ArrayIndexAny(value, index, replacement) {
            return matrix((0, $6819694788cbfa38$export$9cd59f9826255e47)(value)).subset(index, replacement, undefined).valueOf();
        },
        "Array, Index, any, any": function ArrayIndexAnyAny(value, index, replacement, defaultValue) {
            return matrix((0, $6819694788cbfa38$export$9cd59f9826255e47)(value)).subset(index, replacement, defaultValue).valueOf();
        },
        "Matrix, Index, any": function MatrixIndexAny(value, index, replacement) {
            return value.clone().subset(index, replacement);
        },
        "Matrix, Index, any, any": function MatrixIndexAnyAny(value, index, replacement, defaultValue) {
            return value.clone().subset(index, replacement, defaultValue);
        },
        "string, Index, string": $5d38c660a6bdbeba$var$_setSubstring,
        "string, Index, string, string": $5d38c660a6bdbeba$var$_setSubstring,
        "Object, Index, any": $5d38c660a6bdbeba$var$_setObjectProperty
    });
});
/**
 * Retrieve a subset of a string
 * @param {string} str            string from which to get a substring
 * @param {Index} index           An index or list of indices (character positions)
 * @returns {string} substring
 * @private
 */ function $5d38c660a6bdbeba$var$_getSubstring(str, index) {
    if (!(0, $d8097b7a6d6e36d8$export$ba3dc792055c2f45)(index)) // TODO: better error message
    throw new TypeError("Index expected");
    if (index.size().length !== 1) throw new (0, $89c7b7a60bca4b11$export$ad1391ca020fdd96)(index.size().length, 1);
     // validate whether the range is out of range
    var strLen = str.length;
    (0, $a14a10567870d913$export$3cfe3fbfec03f260)(index.min()[0], strLen);
    (0, $a14a10567870d913$export$3cfe3fbfec03f260)(index.max()[0], strLen);
    var range = index.dimension(0);
    var substr = "";
    range.forEach(function(v) {
        substr += str.charAt(v);
    });
    return substr;
}
/**
 * Replace a substring in a string
 * @param {string} str            string to be replaced
 * @param {Index} index           An index or list of indices (character positions)
 * @param {string} replacement    Replacement string
 * @param {string} [defaultValue] Default value to be uses when resizing
 *                                the string. is ' ' by default
 * @returns {string} result
 * @private
 */ function $5d38c660a6bdbeba$var$_setSubstring(str, index, replacement, defaultValue) {
    if (!index || index.isIndex !== true) // TODO: better error message
    throw new TypeError("Index expected");
    if (index.size().length !== 1) throw new (0, $89c7b7a60bca4b11$export$ad1391ca020fdd96)(index.size().length, 1);
    if (defaultValue !== undefined) {
        if (typeof defaultValue !== "string" || defaultValue.length !== 1) throw new TypeError("Single character expected as defaultValue");
    } else defaultValue = " ";
    var range = index.dimension(0);
    var len = range.size()[0];
    if (len !== replacement.length) throw new (0, $89c7b7a60bca4b11$export$ad1391ca020fdd96)(range.size()[0], replacement.length);
     // validate whether the range is out of range
    var strLen = str.length;
    (0, $a14a10567870d913$export$3cfe3fbfec03f260)(index.min()[0]);
    (0, $a14a10567870d913$export$3cfe3fbfec03f260)(index.max()[0]); // copy the string into an array with characters
    var chars = [];
    for(var i = 0; i < strLen; i++)chars[i] = str.charAt(i);
    range.forEach(function(v, i) {
        chars[v] = replacement.charAt(i[0]);
    }); // initialize undefined characters with a space
    if (chars.length > strLen) {
        for(var _i = strLen - 1, _len = chars.length; _i < _len; _i++)if (!chars[_i]) chars[_i] = defaultValue;
    }
    return chars.join("");
}
/**
 * Retrieve a property from an object
 * @param {Object} object
 * @param {Index} index
 * @return {*} Returns the value of the property
 * @private
 */ function $5d38c660a6bdbeba$var$_getObjectProperty(object, index) {
    if (index.size().length !== 1) throw new (0, $89c7b7a60bca4b11$export$ad1391ca020fdd96)(index.size(), 1);
    var key = index.dimension(0);
    if (typeof key !== "string") throw new TypeError("String expected as index to retrieve an object property");
    return (0, $452194a24e9d7818$export$87a87648a1961976)(object, key);
}
/**
 * Set a property on an object
 * @param {Object} object
 * @param {Index} index
 * @param {*} replacement
 * @return {*} Returns the updated object
 * @private
 */ function $5d38c660a6bdbeba$var$_setObjectProperty(object, index, replacement) {
    if (index.size().length !== 1) throw new (0, $89c7b7a60bca4b11$export$ad1391ca020fdd96)(index.size(), 1);
    var key = index.dimension(0);
    if (typeof key !== "string") throw new TypeError("String expected as index to retrieve an object property");
     // clone the object, and apply the property to the clone
    var updated = (0, $6819694788cbfa38$export$9cd59f9826255e47)(object);
    (0, $452194a24e9d7818$export$e99fe8700ee9f9cd)(updated, key, replacement);
    return updated;
}







var $5e80d3fce4071128$var$name = "algorithm10";
var $5e80d3fce4071128$var$dependencies = [
    "typed",
    "DenseMatrix"
];
var $5e80d3fce4071128$export$72a88f2eee9ec1ed = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($5e80d3fce4071128$var$name, $5e80d3fce4071128$var$dependencies, (_ref)=>{
    var { typed: typed, DenseMatrix: DenseMatrix } = _ref;
    /**
   * Iterates over SparseMatrix S nonzero items and invokes the callback function f(Sij, b).
   * Callback function invoked NZ times (number of nonzero items in S).
   *
   *
   *          ┌  f(Sij, b)  ; S(i,j) !== 0
   * C(i,j) = ┤
   *          └  b          ; otherwise
   *
   *
   * @param {Matrix}   s                 The SparseMatrix instance (S)
   * @param {Scalar}   b                 The Scalar value
   * @param {Function} callback          The f(Aij,b) operation to invoke
   * @param {boolean}  inverse           A true value indicates callback should be invoked f(b,Sij)
   *
   * @return {Matrix}                    DenseMatrix (C)
   *
   * https://github.com/josdejong/mathjs/pull/346#issuecomment-97626813
   */ return function algorithm10(s, b, callback, inverse) {
        // sparse matrix arrays
        var avalues = s._values;
        var aindex = s._index;
        var aptr = s._ptr;
        var asize = s._size;
        var adt = s._datatype; // sparse matrix cannot be a Pattern matrix
        if (!avalues) throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string") {
            // datatype
            dt = adt; // convert b to the same datatype
            b = typed.convert(b, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result arrays
        var cdata = []; // workspaces
        var x = []; // marks indicating we have a value in x for a given column
        var w = []; // loop columns
        for(var j = 0; j < columns; j++){
            // columns mark
            var mark = j + 1; // values in j
            for(var k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
                // row
                var r = aindex[k]; // update workspace
                x[r] = avalues[k];
                w[r] = mark;
            } // loop rows
            for(var i = 0; i < rows; i++){
                // initialize C on first column
                if (j === 0) // create row array
                cdata[i] = [];
                 // check sparse matrix has a value @ i,j
                if (w[i] === mark) // invoke callback, update C
                cdata[i][j] = inverse ? cf(b, x[i]) : cf(x[i], b);
                else // dense matrix value @ i, j
                cdata[i][j] = b;
            }
        } // return dense matrix
        return new DenseMatrix({
            data: cdata,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});




var $486347f104d1caa3$var$name = "subtract";
var $486347f104d1caa3$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "addScalar",
    "unaryMinus",
    "DenseMatrix"
];
var $486347f104d1caa3$export$cd7a6c131b18ab16 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($486347f104d1caa3$var$name, $486347f104d1caa3$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, addScalar: addScalar, unaryMinus: unaryMinus, DenseMatrix: DenseMatrix } = _ref;
    // TODO: split function subtract in two: subtract and subtractScalar
    var algorithm01 = (0, $87b5a4e357abde7d$export$5e6d55d37a917802)({
        typed: typed
    });
    var algorithm03 = (0, $523b807a911c3d38$export$486bb900f1a3c833)({
        typed: typed
    });
    var algorithm05 = (0, $c751eae6ac416bf7$export$f80c3080566d43b4)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm10 = (0, $5e80d3fce4071128$export$72a88f2eee9ec1ed)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $c68b38998aadcc11$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $533d58927c47005f$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Subtract two values, `x - y`.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.subtract(x, y)
   *
   * Examples:
   *
   *    math.subtract(5.3, 2)        // returns number 3.3
   *
   *    const a = math.complex(2, 3)
   *    const b = math.complex(4, 1)
   *    math.subtract(a, b)          // returns Complex -2 + 2i
   *
   *    math.subtract([5, 7, 4], 4)  // returns Array [1, 3, 0]
   *
   *    const c = math.unit('2.1 km')
   *    const d = math.unit('500m')
   *    math.subtract(c, d)          // returns Unit 1.6 km
   *
   * See also:
   *
   *    add
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x
   *            Initial value
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y
   *            Value to subtract from `x`
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}
   *            Subtraction of `x` and `y`
   */ return typed($486347f104d1caa3$var$name, {
        "number, number": function numberNumber(x, y) {
            return x - y;
        },
        "Complex, Complex": function ComplexComplex(x, y) {
            return x.sub(y);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.minus(y);
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.sub(y);
        },
        "Unit, Unit": function UnitUnit(x, y) {
            if (x.value === null) throw new Error("Parameter x contains a unit with undefined value");
            if (y.value === null) throw new Error("Parameter y contains a unit with undefined value");
            if (!x.equalBase(y)) throw new Error("Units do not match");
            var res = x.clone();
            res.value = this(res.value, y.value);
            res.fixPrefix = false;
            return res;
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            $486347f104d1caa3$var$checkEqualDimensions(x, y);
            return algorithm05(x, y, this);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            $486347f104d1caa3$var$checkEqualDimensions(x, y);
            return algorithm03(y, x, this, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            $486347f104d1caa3$var$checkEqualDimensions(x, y);
            return algorithm01(x, y, this, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            $486347f104d1caa3$var$checkEqualDimensions(x, y);
            return algorithm13(x, y, this);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm10(x, unaryMinus(y), addScalar);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, this);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm10(y, x, this, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});
/**
 * Check whether matrix x and y have the same number of dimensions.
 * Throws a DimensionError when dimensions are not equal
 * @param {Matrix} x
 * @param {Matrix} y
 */ function $486347f104d1caa3$var$checkEqualDimensions(x, y) {
    var xsize = x.size();
    var ysize = y.size();
    if (xsize.length !== ysize.length) throw new (0, $89c7b7a60bca4b11$export$ad1391ca020fdd96)(xsize.length, ysize.length);
}




var $70235fdf3b767b54$var$name = "to";
var $70235fdf3b767b54$var$dependencies = [
    "typed",
    "matrix"
];
var $70235fdf3b767b54$export$6e6c19ceb4cd6856 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($70235fdf3b767b54$var$name, $70235fdf3b767b54$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix } = _ref;
    var algorithm13 = (0, $c68b38998aadcc11$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $533d58927c47005f$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Change the unit of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.to(x, unit)
   *
   * Examples:
   *
   *    math.to(math.unit('2 inch'), 'cm')                   // returns Unit 5.08 cm
   *    math.to(math.unit('2 inch'), math.unit(null, 'cm'))  // returns Unit 5.08 cm
   *    math.to(math.unit(16, 'bytes'), 'bits')              // returns Unit 128 bits
   *
   * See also:
   *
   *    unit
   *
   * @param {Unit | Array | Matrix} x     The unit to be converted.
   * @param {Unit | Array | Matrix} unit  New unit. Can be a string like "cm"
   *                                      or a unit without value.
   * @return {Unit | Array | Matrix} value with changed, fixed unit.
   */ return typed($70235fdf3b767b54$var$name, {
        "Unit, Unit | string": function UnitUnitString(x, unit) {
            return x.to(unit);
        },
        "Matrix, Matrix": function MatrixMatrix(x, y) {
            // SparseMatrix does not support Units
            return algorithm13(x, y, this);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "Matrix, any": function MatrixAny(x, y) {
            // SparseMatrix does not support Units
            return algorithm14(x, y, this, false);
        },
        "any, Matrix": function anyMatrix(x, y) {
            // SparseMatrix does not support Units
            return algorithm14(y, x, this, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});




var $df363a406353858c$var$name = "transpose";
var $df363a406353858c$var$dependencies = [
    "typed",
    "matrix"
];
var $df363a406353858c$export$9a8c88485f8f638b = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($df363a406353858c$var$name, $df363a406353858c$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix } = _ref;
    /**
   * Transpose a matrix. All values of the matrix are reflected over its
   * main diagonal. Only applicable to two dimensional matrices containing
   * a vector (i.e. having size `[1,n]` or `[n,1]`). One dimensional
   * vectors and scalars return the input unchanged.
   *
   * Syntax:
   *
   *     math.transpose(x)
   *
   * Examples:
   *
   *     const A = [[1, 2, 3], [4, 5, 6]]
   *     math.transpose(A)               // returns [[1, 4], [2, 5], [3, 6]]
   *
   * See also:
   *
   *     diag, inv, subset, squeeze
   *
   * @param {Array | Matrix} x  Matrix to be transposed
   * @return {Array | Matrix}   The transposed matrix
   */ return typed("transpose", {
        Array: function Array(x) {
            // use dense matrix implementation
            return this(matrix(x)).valueOf();
        },
        Matrix: function Matrix(x) {
            // matrix size
            var size = x.size(); // result
            var c; // process dimensions
            switch(size.length){
                case 1:
                    // vector
                    c = x.clone();
                    break;
                case 2:
                    // rows and columns
                    var rows = size[0];
                    var columns = size[1]; // check columns
                    if (columns === 0) // throw exception
                    throw new RangeError("Cannot transpose a 2D matrix with no columns (size: " + (0, $b94963e97c376b6d$export$d9468344d3651243)(size) + ")");
                     // process storage format
                    switch(x.storage()){
                        case "dense":
                            c = _denseTranspose(x, rows, columns);
                            break;
                        case "sparse":
                            c = _sparseTranspose(x, rows, columns);
                            break;
                    }
                    break;
                default:
                    // multi dimensional
                    throw new RangeError("Matrix must be a vector or two dimensional (size: " + (0, $b94963e97c376b6d$export$d9468344d3651243)(this._size) + ")");
            }
            return c;
        },
        // scalars
        any: function any(x) {
            return (0, $6819694788cbfa38$export$9cd59f9826255e47)(x);
        }
    });
    function _denseTranspose(m, rows, columns) {
        // matrix array
        var data = m._data; // transposed matrix data
        var transposed = [];
        var transposedRow; // loop columns
        for(var j = 0; j < columns; j++){
            // initialize row
            transposedRow = transposed[j] = []; // loop rows
            for(var i = 0; i < rows; i++)// set data
            transposedRow[i] = (0, $6819694788cbfa38$export$9cd59f9826255e47)(data[i][j]);
        } // return matrix
        return m.createDenseMatrix({
            data: transposed,
            size: [
                columns,
                rows
            ],
            datatype: m._datatype
        });
    }
    function _sparseTranspose(m, rows, columns) {
        // matrix arrays
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr; // result matrices
        var cvalues = values ? [] : undefined;
        var cindex = [];
        var cptr = []; // row counts
        var w = [];
        for(var x = 0; x < rows; x++)w[x] = 0;
         // vars
        var p, l, j; // loop values in matrix
        for(p = 0, l = index.length; p < l; p++)// number of values in row
        w[index[p]]++;
         // cumulative sum
        var sum = 0; // initialize cptr with the cummulative sum of row counts
        for(var i = 0; i < rows; i++){
            // update cptr
            cptr.push(sum); // update sum
            sum += w[i]; // update w
            w[i] = cptr[i];
        } // update cptr
        cptr.push(sum); // loop columns
        for(j = 0; j < columns; j++)// values & index in column
        for(var k0 = ptr[j], k1 = ptr[j + 1], k = k0; k < k1; k++){
            // C values & index
            var q = w[index[k]]++; // C[j, i] = A[i, j]
            cindex[q] = j; // check we need to process values (pattern matrix)
            if (values) cvalues[q] = (0, $6819694788cbfa38$export$9cd59f9826255e47)(values[k]);
        }
         // return matrix
        return m.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                columns,
                rows
            ],
            datatype: m._datatype
        });
    }
});



var $42c9c0db27eb5c70$var$name = "xgcd";
var $42c9c0db27eb5c70$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "BigNumber"
];
var $42c9c0db27eb5c70$export$de8cbd18c98bf9d5 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($42c9c0db27eb5c70$var$name, $42c9c0db27eb5c70$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, BigNumber: BigNumber } = _ref;
    /**
   * Calculate the extended greatest common divisor for two values.
   * See https://en.wikipedia.org/wiki/Extended_Euclidean_algorithm.
   *
   * Syntax:
   *
   *    math.xgcd(a, b)
   *
   * Examples:
   *
   *    math.xgcd(8, 12)             // returns [4, -1, 1]
   *    math.gcd(8, 12)              // returns 4
   *    math.xgcd(36163, 21199)      // returns [1247, -7, 12]
   *
   * See also:
   *
   *    gcd, lcm
   *
   * @param {number | BigNumber} a  An integer number
   * @param {number | BigNumber} b  An integer number
   * @return {Array}              Returns an array containing 3 integers `[div, m, n]`
   *                              where `div = gcd(a, b)` and `a*m + b*n = div`
   */ return typed($42c9c0db27eb5c70$var$name, {
        "number, number": function numberNumber(a, b) {
            var res = (0, $4b37ed316f05dd33$export$8cb756a23a623229)(a, b);
            return config.matrix === "Array" ? res : matrix(res);
        },
        "BigNumber, BigNumber": _xgcdBigNumber // TODO: implement support for Fraction
    });
    /**
   * Calculate xgcd for two BigNumbers
   * @param {BigNumber} a
   * @param {BigNumber} b
   * @return {BigNumber[]} result
   * @private
   */ function _xgcdBigNumber(a, b) {
        // source: https://en.wikipedia.org/wiki/Extended_Euclidean_algorithm
        var t;
        var q;
        var r;
        var zero = new BigNumber(0);
        var one = new BigNumber(1);
        var x = zero;
        var lastx = one;
        var y = one;
        var lasty = zero;
        if (!a.isInt() || !b.isInt()) throw new Error("Parameters in function xgcd must be integer numbers");
        while(!b.isZero()){
            q = a.div(b).floor();
            r = a.mod(b);
            t = x;
            x = lastx.minus(q.times(x));
            lastx = t;
            t = y;
            y = lasty.minus(q.times(y));
            lasty = t;
            a = b;
            b = r;
        }
        var res;
        if (a.lt(zero)) res = [
            a.neg(),
            lastx.neg(),
            lasty.neg()
        ];
        else res = [
            a,
            !a.isZero() ? lastx : 0,
            lasty
        ];
        return config.matrix === "Array" ? res : matrix(res);
    }
});





var $2d2cbce1fa072220$var$name = "zeros";
var $2d2cbce1fa072220$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "BigNumber"
];
var $2d2cbce1fa072220$export$13096c1635fe6e3d = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($2d2cbce1fa072220$var$name, $2d2cbce1fa072220$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, BigNumber: BigNumber } = _ref;
    /**
   * Create a matrix filled with zeros. The created matrix can have one or
   * multiple dimensions.
   *
   * Syntax:
   *
   *    math.zeros(m)
   *    math.zeros(m, format)
   *    math.zeros(m, n)
   *    math.zeros(m, n, format)
   *    math.zeros([m, n])
   *    math.zeros([m, n], format)
   *
   * Examples:
   *
   *    math.zeros(3)                  // returns [0, 0, 0]
   *    math.zeros(3, 2)               // returns [[0, 0], [0, 0], [0, 0]]
   *    math.zeros(3, 'dense')         // returns [0, 0, 0]
   *
   *    const A = [[1, 2, 3], [4, 5, 6]]
   *    math.zeros(math.size(A))       // returns [[0, 0, 0], [0, 0, 0]]
   *
   * See also:
   *
   *    ones, identity, size, range
   *
   * @param {...number | Array} size    The size of each dimension of the matrix
   * @param {string} [format]           The Matrix storage format
   *
   * @return {Array | Matrix}           A matrix filled with zeros
   */ return typed($2d2cbce1fa072220$var$name, {
        "": function _() {
            return config.matrix === "Array" ? _zeros([]) : _zeros([], "default");
        },
        // math.zeros(m, n, p, ..., format)
        // TODO: more accurate signature '...number | BigNumber, string' as soon as typed-function supports this
        "...number | BigNumber | string": function numberBigNumberString(size) {
            var last = size[size.length - 1];
            if (typeof last === "string") {
                var format = size.pop();
                return _zeros(size, format);
            } else if (config.matrix === "Array") return _zeros(size);
            else return _zeros(size, "default");
        },
        Array: _zeros,
        Matrix: function Matrix(size) {
            var format = size.storage();
            return _zeros(size.valueOf(), format);
        },
        "Array | Matrix, string": function ArrayMatrixString(size, format) {
            return _zeros(size.valueOf(), format);
        }
    });
    /**
   * Create an Array or Matrix with zeros
   * @param {Array} size
   * @param {string} [format='default']
   * @return {Array | Matrix}
   * @private
   */ function _zeros(size, format) {
        var hasBigNumbers = _normalize(size);
        var defaultValue = hasBigNumbers ? new BigNumber(0) : 0;
        _validate(size);
        if (format) {
            // return a matrix
            var m = matrix(format);
            if (size.length > 0) return m.resize(size, defaultValue);
            return m;
        } else {
            // return an Array
            var arr = [];
            if (size.length > 0) return (0, $a14a10567870d913$export$4380c87abf28fdf)(arr, size, defaultValue);
            return arr;
        }
    } // replace BigNumbers with numbers, returns true if size contained BigNumbers
    function _normalize(size) {
        var hasBigNumbers = false;
        size.forEach(function(value, index, arr) {
            if ((0, $d8097b7a6d6e36d8$export$e51d0e7e5c4a03ab)(value)) {
                hasBigNumbers = true;
                arr[index] = value.toNumber();
            }
        });
        return hasBigNumbers;
    } // validate arguments
    function _validate(size) {
        size.forEach(function(value) {
            if (typeof value !== "number" || !(0, $668e051498bf5fa0$export$a287f47fed4544b8)(value) || value < 0) throw new Error("Parameters in function zeros must be positive integers");
        });
    }
}); // TODO: zeros contains almost the same code as ones. Reuse this?








var $b3492dc85e9ec3ef$var$name = "and";
var $b3492dc85e9ec3ef$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "zeros",
    "not"
];
var $b3492dc85e9ec3ef$export$15a698d88cae0eff = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($b3492dc85e9ec3ef$var$name, $b3492dc85e9ec3ef$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, zeros: zeros, not: not } = _ref;
    var algorithm02 = (0, $caf358e9c2d20263$export$92edb534a8f19a37)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm06 = (0, $648c171bfbb07130$export$d6f401e6f2a7e54b)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm11 = (0, $83b92f81e511657d$export$a38279a12199d831)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm13 = (0, $c68b38998aadcc11$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $533d58927c47005f$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Logical `and`. Test whether two values are both defined with a nonzero/nonempty value.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.and(x, y)
   *
   * Examples:
   *
   *    math.and(2, 4)   // returns true
   *
   *    a = [2, 0, 0]
   *    b = [3, 7, 0]
   *    c = 0
   *
   *    math.and(a, b)   // returns [true, false, false]
   *    math.and(a, c)   // returns [false, false, false]
   *
   * See also:
   *
   *    not, or, xor
   *
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} x First value to check
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} y Second value to check
   * @return {boolean | Array | Matrix}
   *            Returns true when both inputs are defined with a nonzero/nonempty value.
   */ return typed($b3492dc85e9ec3ef$var$name, {
        "number, number": (0, $e69afcd9e58cec61$export$11dffb061e00e795),
        "Complex, Complex": function ComplexComplex(x, y) {
            return (x.re !== 0 || x.im !== 0) && (y.re !== 0 || y.im !== 0);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return !x.isZero() && !y.isZero() && !x.isNaN() && !y.isNaN();
        },
        "Unit, Unit": function UnitUnit(x, y) {
            return this(x.value || 0, y.value || 0);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm06(x, y, this, false);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, this, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm02(x, y, this, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            // check scalar
            if (not(y)) // return zero matrix
            return zeros(x.size(), x.storage());
            return algorithm11(x, y, this, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            // check scalar
            if (not(y)) // return zero matrix
            return zeros(x.size(), x.storage());
            return algorithm14(x, y, this, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            // check scalar
            if (not(x)) // return zero matrix
            return zeros(x.size(), x.storage());
            return algorithm11(y, x, this, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            // check scalar
            if (not(x)) // return zero matrix
            return zeros(x.size(), x.storage());
            return algorithm14(y, x, this, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return this(matrix(x), y).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y)).valueOf();
        }
    });
});









var $8444b8cd9809d5bc$var$name = "bitAnd";
var $8444b8cd9809d5bc$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar"
];
var $8444b8cd9809d5bc$export$bea4e06c5befec3b = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($8444b8cd9809d5bc$var$name, $8444b8cd9809d5bc$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar } = _ref;
    var algorithm02 = (0, $caf358e9c2d20263$export$92edb534a8f19a37)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm06 = (0, $648c171bfbb07130$export$d6f401e6f2a7e54b)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm11 = (0, $83b92f81e511657d$export$a38279a12199d831)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm13 = (0, $c68b38998aadcc11$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $533d58927c47005f$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Bitwise AND two values, `x & y`.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.bitAnd(x, y)
   *
   * Examples:
   *
   *    math.bitAnd(53, 131)               // returns number 1
   *
   *    math.bitAnd([1, 12, 31], 42)       // returns Array [0, 8, 10]
   *
   * See also:
   *
   *    bitNot, bitOr, bitXor, leftShift, rightArithShift, rightLogShift
   *
   * @param  {number | BigNumber | Array | Matrix} x First value to and
   * @param  {number | BigNumber | Array | Matrix} y Second value to and
   * @return {number | BigNumber | Array | Matrix} AND of `x` and `y`
   */ return typed($8444b8cd9809d5bc$var$name, {
        "number, number": (0, $ac33a15c81597bf3$export$e7607930867bd49a),
        "BigNumber, BigNumber": (0, $3b8565a47dc4d809$export$94757ce5cf54fec9),
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm06(x, y, this, false);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, this, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm02(x, y, this, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm11(x, y, this, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, this, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm11(y, x, this, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});









var $dab42c98161ee357$var$name = "bitXor";
var $dab42c98161ee357$var$dependencies = [
    "typed",
    "matrix",
    "DenseMatrix"
];
var $dab42c98161ee357$export$1cae728fa8e01928 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($dab42c98161ee357$var$name, $dab42c98161ee357$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, DenseMatrix: DenseMatrix } = _ref;
    var algorithm03 = (0, $523b807a911c3d38$export$486bb900f1a3c833)({
        typed: typed
    });
    var algorithm07 = (0, $5200888766c056e5$export$b908fb77c4366999)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm12 = (0, $500ff63908aabda9$export$806772cd23b603dc)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $c68b38998aadcc11$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $533d58927c47005f$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Bitwise XOR two values, `x ^ y`.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.bitXor(x, y)
   *
   * Examples:
   *
   *    math.bitXor(1, 2)               // returns number 3
   *
   *    math.bitXor([2, 3, 4], 4)       // returns Array [6, 7, 0]
   *
   * See also:
   *
   *    bitAnd, bitNot, bitOr, leftShift, rightArithShift, rightLogShift
   *
   * @param  {number | BigNumber | Array | Matrix} x First value to xor
   * @param  {number | BigNumber | Array | Matrix} y Second value to xor
   * @return {number | BigNumber | Array | Matrix} XOR of `x` and `y`
   */ return typed($dab42c98161ee357$var$name, {
        "number, number": (0, $ac33a15c81597bf3$export$2260a44ec1c987dc),
        "BigNumber, BigNumber": (0, $3b8565a47dc4d809$export$bfcff4501301c191),
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, this);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, this, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, this, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm12(x, y, this, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, this, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, this, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});





var $8d46e2432e39dee8$var$name = "cbrt";
var $8d46e2432e39dee8$var$dependencies = [
    "config",
    "typed",
    "isNegative",
    "unaryMinus",
    "matrix",
    "Complex",
    "BigNumber",
    "Fraction"
];
var $8d46e2432e39dee8$export$2103fed9c34b0004 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($8d46e2432e39dee8$var$name, $8d46e2432e39dee8$var$dependencies, (_ref)=>{
    var { config: config, typed: typed, isNegative: isNegative, unaryMinus: unaryMinus, matrix: matrix, Complex: Complex, BigNumber: BigNumber, Fraction: Fraction } = _ref;
    /**
   * Calculate the cubic root of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.cbrt(x)
   *    math.cbrt(x, allRoots)
   *
   * Examples:
   *
   *    math.cbrt(27)                  // returns 3
   *    math.cube(3)                   // returns 27
   *    math.cbrt(-64)                 // returns -4
   *    math.cbrt(math.unit('27 m^3')) // returns Unit 3 m
   *    math.cbrt([27, 64, 125])       // returns [3, 4, 5]
   *
   *    const x = math.complex('8i')
   *    math.cbrt(x)                   // returns Complex 1.7320508075689 + i
   *    math.cbrt(x, true)             // returns Matrix [
   *                                    //    1.7320508075689 + i
   *                                    //   -1.7320508075689 + i
   *                                    //   -2i
   *                                    // ]
   *
   * See also:
   *
   *    square, sqrt, cube
   *
   * @param {number | BigNumber | Complex | Unit | Array | Matrix} x
   *            Value for which to calculate the cubic root.
   * @param {boolean} [allRoots]  Optional, false by default. Only applicable
   *            when `x` is a number or complex number. If true, all complex
   *            roots are returned, if false (default) the principal root is
   *            returned.
   * @return {number | BigNumber | Complex | Unit | Array | Matrix}
   *            Returns the cubic root of `x`
   */ return typed($8d46e2432e39dee8$var$name, {
        number: (0, $4b37ed316f05dd33$export$95c2aecb85f70726),
        // note: signature 'number, boolean' is also supported,
        //       created by typed as it knows how to convert number to Complex
        Complex: _cbrtComplex,
        "Complex, boolean": _cbrtComplex,
        BigNumber: function BigNumber(x) {
            return x.cbrt();
        },
        Unit: _cbrtUnit,
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since cbrt(0) = 0
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this, true);
        }
    });
    /**
   * Calculate the cubic root for a complex number
   * @param {Complex} x
   * @param {boolean} [allRoots]   If true, the function will return an array
   *                               with all three roots. If false or undefined,
   *                               the principal root is returned.
   * @returns {Complex | Array.<Complex> | Matrix.<Complex>} Returns the cubic root(s) of x
   * @private
   */ function _cbrtComplex(x, allRoots) {
        // https://www.wikiwand.com/en/Cube_root#/Complex_numbers
        var arg3 = x.arg() / 3;
        var abs = x.abs(); // principal root:
        var principal = new Complex((0, $4b37ed316f05dd33$export$95c2aecb85f70726)(abs), 0).mul(new Complex(0, arg3).exp());
        if (allRoots) {
            var all = [
                principal,
                new Complex((0, $4b37ed316f05dd33$export$95c2aecb85f70726)(abs), 0).mul(new Complex(0, arg3 + Math.PI * 2 / 3).exp()),
                new Complex((0, $4b37ed316f05dd33$export$95c2aecb85f70726)(abs), 0).mul(new Complex(0, arg3 - Math.PI * 2 / 3).exp())
            ];
            return config.matrix === "Array" ? all : matrix(all);
        } else return principal;
    }
    /**
   * Calculate the cubic root for a Unit
   * @param {Unit} x
   * @return {Unit} Returns the cubic root of x
   * @private
   */ function _cbrtUnit(x) {
        if (x.value && (0, $d8097b7a6d6e36d8$export$8849a896711efe0c)(x.value)) {
            var result = x.clone();
            result.value = 1.0;
            result = result.pow(1.0 / 3); // Compute the units
            result.value = _cbrtComplex(x.value); // Compute the value
            return result;
        } else {
            var negate = isNegative(x.value);
            if (negate) x.value = unaryMinus(x.value);
             // TODO: create a helper function for this
            var third;
            if ((0, $d8097b7a6d6e36d8$export$e51d0e7e5c4a03ab)(x.value)) third = new BigNumber(1).div(3);
            else if ((0, $d8097b7a6d6e36d8$export$e312cb8a8e5e7c34)(x.value)) third = new Fraction(1, 3);
            else third = 1 / 3;
            var _result = x.pow(third);
            if (negate) _result.value = unaryMinus(_result.value);
            return _result;
        }
    }
});









var $12b0750539b49baf$var$name = "compare";
var $12b0750539b49baf$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "equalScalar",
    "BigNumber",
    "Fraction",
    "DenseMatrix"
];
var $12b0750539b49baf$export$a6e723c0e3b918d4 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($12b0750539b49baf$var$name, $12b0750539b49baf$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, equalScalar: equalScalar, matrix: matrix, BigNumber: BigNumber, Fraction: Fraction, DenseMatrix: DenseMatrix } = _ref;
    var algorithm03 = (0, $523b807a911c3d38$export$486bb900f1a3c833)({
        typed: typed
    });
    var algorithm05 = (0, $c751eae6ac416bf7$export$f80c3080566d43b4)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm12 = (0, $500ff63908aabda9$export$806772cd23b603dc)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $c68b38998aadcc11$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $533d58927c47005f$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Compare two values. Returns 1 when x > y, -1 when x < y, and 0 when x == y.
   *
   * x and y are considered equal when the relative difference between x and y
   * is smaller than the configured epsilon. The function cannot be used to
   * compare values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.compare(x, y)
   *
   * Examples:
   *
   *    math.compare(6, 1)           // returns 1
   *    math.compare(2, 3)           // returns -1
   *    math.compare(7, 7)           // returns 0
   *    math.compare('10', '2')      // returns 1
   *    math.compare('1000', '1e3')  // returns 0
   *
   *    const a = math.unit('5 cm')
   *    const b = math.unit('40 mm')
   *    math.compare(a, b)           // returns 1
   *
   *    math.compare(2, [1, 2, 3])   // returns [1, 0, -1]
   *
   * See also:
   *
   *    equal, unequal, smaller, smallerEq, larger, largerEq, compareNatural, compareText
   *
   * @param  {number | BigNumber | Fraction | Unit | string | Array | Matrix} x First value to compare
   * @param  {number | BigNumber | Fraction | Unit | string | Array | Matrix} y Second value to compare
   * @return {number | BigNumber | Fraction | Array | Matrix} Returns the result of the comparison:
   *                                                          1 when x > y, -1 when x < y, and 0 when x == y.
   */ return typed($12b0750539b49baf$var$name, {
        "boolean, boolean": function booleanBoolean(x, y) {
            return x === y ? 0 : x > y ? 1 : -1;
        },
        "number, number": function numberNumber(x, y) {
            return (0, $668e051498bf5fa0$export$6f3989c6ecc04081)(x, y, config.epsilon) ? 0 : x > y ? 1 : -1;
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return (0, $53e0635127e7c5a0$export$6f3989c6ecc04081)(x, y, config.epsilon) ? new BigNumber(0) : new BigNumber(x.cmp(y));
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return new Fraction(x.compare(y));
        },
        "Complex, Complex": function ComplexComplex() {
            throw new TypeError("No ordering relation is defined for complex numbers");
        },
        "Unit, Unit": function UnitUnit(x, y) {
            if (!x.equalBase(y)) throw new Error("Cannot compare units with different base");
            return this(x.value, y.value);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm05(x, y, this);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, this, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, this, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm12(x, y, this, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, this, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, this, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});
var $12b0750539b49baf$export$e744cf3e2e3d6926 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($12b0750539b49baf$var$name, [
    "typed",
    "config"
], (_ref2)=>{
    var { typed: typed, config: config } = _ref2;
    return typed($12b0750539b49baf$var$name, {
        "number, number": function numberNumber(x, y) {
            return (0, $668e051498bf5fa0$export$6f3989c6ecc04081)(x, y, config.epsilon) ? 0 : x > y ? 1 : -1;
        }
    });
});





var $3f8e2116e8497f63$var$name = "compareText";
var $3f8e2116e8497f63$var$dependencies = [
    "typed",
    "matrix"
];
var $3f8e2116e8497f63$export$3e578d0534ab5935 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($3f8e2116e8497f63$var$name, $3f8e2116e8497f63$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix } = _ref;
    var algorithm13 = (0, $c68b38998aadcc11$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $533d58927c47005f$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Compare two strings lexically. Comparison is case sensitive.
   * Returns 1 when x > y, -1 when x < y, and 0 when x == y.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.compareText(x, y)
   *
   * Examples:
   *
   *    math.compareText('B', 'A')     // returns 1
   *    math.compareText('2', '10')    // returns 1
   *    math.compare('2', '10')        // returns -1
   *    math.compareNatural('2', '10') // returns -1
   *
   *    math.compareText('B', ['A', 'B', 'C']) // returns [1, 0, -1]
   *
   * See also:
   *
   *    equal, equalText, compare, compareNatural
   *
   * @param  {string | Array | DenseMatrix} x First string to compare
   * @param  {string | Array | DenseMatrix} y Second string to compare
   * @return {number | Array | DenseMatrix} Returns the result of the comparison:
   *                                        1 when x > y, -1 when x < y, and 0 when x == y.
   */ return typed($3f8e2116e8497f63$var$name, {
        "any, any": (0, $b94963e97c376b6d$export$2da9287da10b19e2),
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, (0, $b94963e97c376b6d$export$2da9287da10b19e2));
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, (0, $b94963e97c376b6d$export$2da9287da10b19e2), false);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, (0, $b94963e97c376b6d$export$2da9287da10b19e2), true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, (0, $b94963e97c376b6d$export$2da9287da10b19e2), false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, (0, $b94963e97c376b6d$export$2da9287da10b19e2), true).valueOf();
        }
    });
});
var $3f8e2116e8497f63$export$1d0ea0d151dafd85 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($3f8e2116e8497f63$var$name, [
    "typed"
], (_ref2)=>{
    var { typed: typed } = _ref2;
    return typed($3f8e2116e8497f63$var$name, {
        "any, any": (0, $b94963e97c376b6d$export$2da9287da10b19e2)
    });
});







var $1e5b402e8818d906$var$name = "concat";
var $1e5b402e8818d906$var$dependencies = [
    "typed",
    "matrix",
    "isInteger"
];
var $1e5b402e8818d906$export$c36b5511b12560e8 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($1e5b402e8818d906$var$name, $1e5b402e8818d906$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, isInteger: isInteger } = _ref;
    /**
   * Concatenate two or more matrices.
   *
   * Syntax:
   *
   *     math.concat(A, B, C, ...)
   *     math.concat(A, B, C, ..., dim)
   *
   * Where:
   *
   * - `dim: number` is a zero-based dimension over which to concatenate the matrices.
   *   By default the last dimension of the matrices.
   *
   * Examples:
   *
   *    const A = [[1, 2], [5, 6]]
   *    const B = [[3, 4], [7, 8]]
   *
   *    math.concat(A, B)                  // returns [[1, 2, 3, 4], [5, 6, 7, 8]]
   *    math.concat(A, B, 0)               // returns [[1, 2], [5, 6], [3, 4], [7, 8]]
   *    math.concat('hello', ' ', 'world') // returns 'hello world'
   *
   * See also:
   *
   *    size, squeeze, subset, transpose
   *
   * @param {... Array | Matrix} args     Two or more matrices
   * @return {Array | Matrix} Concatenated matrix
   */ return typed($1e5b402e8818d906$var$name, {
        // TODO: change signature to '...Array | Matrix, dim?' when supported
        "...Array | Matrix | number | BigNumber": function ArrayMatrixNumberBigNumber(args) {
            var i;
            var len = args.length;
            var dim = -1; // zero-based dimension
            var prevDim;
            var asMatrix = false;
            var matrices = []; // contains multi dimensional arrays
            for(i = 0; i < len; i++){
                var arg = args[i]; // test whether we need to return a Matrix (if not we return an Array)
                if ((0, $d8097b7a6d6e36d8$export$b22160e0a14f87b7)(arg)) asMatrix = true;
                if ((0, $d8097b7a6d6e36d8$export$7e4aa119212bc614)(arg) || (0, $d8097b7a6d6e36d8$export$e51d0e7e5c4a03ab)(arg)) {
                    if (i !== len - 1) throw new Error("Dimension must be specified as last argument");
                     // last argument contains the dimension on which to concatenate
                    prevDim = dim;
                    dim = arg.valueOf(); // change BigNumber to number
                    if (!isInteger(dim)) throw new TypeError("Integer number expected for dimension");
                    if (dim < 0 || i > 0 && dim > prevDim) // TODO: would be more clear when throwing a DimensionError here
                    throw new (0, $5f2abd91081f798a$export$efa5eacb1304c464)(dim, prevDim + 1);
                } else {
                    // this is a matrix or array
                    var m = (0, $6819694788cbfa38$export$9cd59f9826255e47)(arg).valueOf();
                    var size = (0, $a14a10567870d913$export$51ffaee4afb683a5)(m);
                    matrices[i] = m;
                    prevDim = dim;
                    dim = size.length - 1; // verify whether each of the matrices has the same number of dimensions
                    if (i > 0 && dim !== prevDim) throw new (0, $89c7b7a60bca4b11$export$ad1391ca020fdd96)(prevDim + 1, dim + 1);
                }
            }
            if (matrices.length === 0) throw new SyntaxError("At least one matrix expected");
            var res = matrices.shift();
            while(matrices.length)res = $1e5b402e8818d906$var$_concat(res, matrices.shift(), dim, 0);
            return asMatrix ? matrix(res) : res;
        },
        "...string": function string(args) {
            return args.join("");
        }
    });
});
/**
 * Recursively concatenate two matrices.
 * The contents of the matrices is not cloned.
 * @param {Array} a             Multi dimensional array
 * @param {Array} b             Multi dimensional array
 * @param {number} concatDim    The dimension on which to concatenate (zero-based)
 * @param {number} dim          The current dim (zero-based)
 * @return {Array} c            The concatenated matrix
 * @private
 */ function $1e5b402e8818d906$var$_concat(a, b, concatDim, dim) {
    if (dim < concatDim) {
        // recurse into next dimension
        if (a.length !== b.length) throw new (0, $89c7b7a60bca4b11$export$ad1391ca020fdd96)(a.length, b.length);
        var c = [];
        for(var i = 0; i < a.length; i++)c[i] = $1e5b402e8818d906$var$_concat(a[i], b[i], concatDim, dim + 1);
        return c;
    } else // concatenate this dimension
    return a.concat(b);
}


var $b97aae50b408899d$var$name = "count";
var $b97aae50b408899d$var$dependencies = [
    "typed",
    "size",
    "prod"
];
var $b97aae50b408899d$export$decd32c762b504bc = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($b97aae50b408899d$var$name, $b97aae50b408899d$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, prod: prod } = _ref;
    /**
   * Count the number of elements of a matrix, array or string.
   *
   * Syntax:
   *
   *     math.count(x)
   *
   * Examples:
   *
   *     math.count('hello world')        // returns 11
   *     const A = [[1, 2, 3], [4, 5, 6]]
   *     math.count(A)                    // returns 6
   *     math.count(math.range(1,6))      // returns 5
   *
   * See also:
   *
   *     size
   *
   * @param {string | Array | Matrix} x  A matrix or string
   * @return {number} An integer with the elements in `x`.
   */ return typed($b97aae50b408899d$var$name, {
        string: function string(x) {
            return x.length;
        },
        "Matrix | Array": function MatrixArray(x) {
            return prod(size(x));
        }
    });
});


var $9b47d831cc2608c4$var$name = "ctranspose";
var $9b47d831cc2608c4$var$dependencies = [
    "typed",
    "transpose",
    "conj"
];
var $9b47d831cc2608c4$export$5d07146b3894f212 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($9b47d831cc2608c4$var$name, $9b47d831cc2608c4$var$dependencies, (_ref)=>{
    var { typed: typed, transpose: transpose, conj: conj } = _ref;
    /**
   * Transpose and complex conjugate a matrix. All values of the matrix are
   * reflected over its main diagonal and then the complex conjugate is
   * taken. This is equivalent to complex conjugation for scalars and
   * vectors.
   *
   * Syntax:
   *
   *     math.ctranspose(x)
   *
   * Examples:
   *
   *     const A = [[1, 2, 3], [4, 5, math.complex(6,7)]]
   *     math.ctranspose(A)               // returns [[1, 4], [2, 5], [3, {re:6,im:7}]]
   *
   * See also:
   *
   *     transpose, diag, inv, subset, squeeze
   *
   * @param {Array | Matrix} x  Matrix to be ctransposed
   * @return {Array | Matrix}   The ctransposed matrix
   */ return typed($9b47d831cc2608c4$var$name, {
        any: function any(x) {
            return conj(transpose(x));
        }
    });
});





var $c8f494d197b3a6db$var$name = "diag";
var $c8f494d197b3a6db$var$dependencies = [
    "typed",
    "matrix",
    "DenseMatrix",
    "SparseMatrix"
];
var $c8f494d197b3a6db$export$743a950f2cd4bacc = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($c8f494d197b3a6db$var$name, $c8f494d197b3a6db$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, DenseMatrix: DenseMatrix, SparseMatrix: SparseMatrix } = _ref;
    /**
   * Create a diagonal matrix or retrieve the diagonal of a matrix
   *
   * When `x` is a vector, a matrix with vector `x` on the diagonal will be returned.
   * When `x` is a two dimensional matrix, the matrixes `k`th diagonal will be returned as vector.
   * When k is positive, the values are placed on the super diagonal.
   * When k is negative, the values are placed on the sub diagonal.
   *
   * Syntax:
   *
   *     math.diag(X)
   *     math.diag(X, format)
   *     math.diag(X, k)
   *     math.diag(X, k, format)
   *
   * Examples:
   *
   *     // create a diagonal matrix
   *     math.diag([1, 2, 3])      // returns [[1, 0, 0], [0, 2, 0], [0, 0, 3]]
   *     math.diag([1, 2, 3], 1)   // returns [[0, 1, 0, 0], [0, 0, 2, 0], [0, 0, 0, 3]]
   *     math.diag([1, 2, 3], -1)  // returns [[0, 0, 0], [1, 0, 0], [0, 2, 0], [0, 0, 3]]
   *
   *    // retrieve the diagonal from a matrix
   *    const a = [[1, 2, 3], [4, 5, 6], [7, 8, 9]]
   *    math.diag(a)   // returns [1, 5, 9]
   *
   * See also:
   *
   *     ones, zeros, identity
   *
   * @param {Matrix | Array} x          A two dimensional matrix or a vector
   * @param {number | BigNumber} [k=0]  The diagonal where the vector will be filled
   *                                    in or retrieved.
   * @param {string} [format='dense']   The matrix storage format.
   *
   * @returns {Matrix | Array} Diagonal matrix from input vector, or diagonal from input matrix.
   */ return typed($c8f494d197b3a6db$var$name, {
        // FIXME: simplify this huge amount of signatures as soon as typed-function supports optional arguments
        Array: function Array(x) {
            return _diag(x, 0, (0, $a14a10567870d913$export$51ffaee4afb683a5)(x), null);
        },
        "Array, number": function ArrayNumber(x, k) {
            return _diag(x, k, (0, $a14a10567870d913$export$51ffaee4afb683a5)(x), null);
        },
        "Array, BigNumber": function ArrayBigNumber(x, k) {
            return _diag(x, k.toNumber(), (0, $a14a10567870d913$export$51ffaee4afb683a5)(x), null);
        },
        "Array, string": function ArrayString(x, format) {
            return _diag(x, 0, (0, $a14a10567870d913$export$51ffaee4afb683a5)(x), format);
        },
        "Array, number, string": function ArrayNumberString(x, k, format) {
            return _diag(x, k, (0, $a14a10567870d913$export$51ffaee4afb683a5)(x), format);
        },
        "Array, BigNumber, string": function ArrayBigNumberString(x, k, format) {
            return _diag(x, k.toNumber(), (0, $a14a10567870d913$export$51ffaee4afb683a5)(x), format);
        },
        Matrix: function Matrix(x) {
            return _diag(x, 0, x.size(), x.storage());
        },
        "Matrix, number": function MatrixNumber(x, k) {
            return _diag(x, k, x.size(), x.storage());
        },
        "Matrix, BigNumber": function MatrixBigNumber(x, k) {
            return _diag(x, k.toNumber(), x.size(), x.storage());
        },
        "Matrix, string": function MatrixString(x, format) {
            return _diag(x, 0, x.size(), format);
        },
        "Matrix, number, string": function MatrixNumberString(x, k, format) {
            return _diag(x, k, x.size(), format);
        },
        "Matrix, BigNumber, string": function MatrixBigNumberString(x, k, format) {
            return _diag(x, k.toNumber(), x.size(), format);
        }
    });
    /**
   * Creeate diagonal matrix from a vector or vice versa
   * @param {Array | Matrix} x
   * @param {number} k
   * @param {string} format Storage format for matrix. If null,
   *                          an Array is returned
   * @returns {Array | Matrix}
   * @private
   */ function _diag(x, k, size, format) {
        if (!(0, $668e051498bf5fa0$export$a287f47fed4544b8)(k)) throw new TypeError("Second parameter in function diag must be an integer");
        var kSuper = k > 0 ? k : 0;
        var kSub = k < 0 ? -k : 0; // check dimensions
        switch(size.length){
            case 1:
                return _createDiagonalMatrix(x, k, format, size[0], kSub, kSuper);
            case 2:
                return _getDiagonal(x, k, format, size, kSub, kSuper);
        }
        throw new RangeError("Matrix for function diag must be 2 dimensional");
    }
    function _createDiagonalMatrix(x, k, format, l, kSub, kSuper) {
        // matrix size
        var ms = [
            l + kSub,
            l + kSuper
        ];
        if (format && format !== "sparse" && format !== "dense") throw new TypeError("Unknown matrix type ".concat(format, '"'));
         // create diagonal matrix
        var m = format === "sparse" ? SparseMatrix.diagonal(ms, x, k) : DenseMatrix.diagonal(ms, x, k); // check we need to return a matrix
        return format !== null ? m : m.valueOf();
    }
    function _getDiagonal(x, k, format, s, kSub, kSuper) {
        // check x is a Matrix
        if ((0, $d8097b7a6d6e36d8$export$b22160e0a14f87b7)(x)) {
            // get diagonal matrix
            var dm = x.diagonal(k); // check we need to return a matrix
            if (format !== null) {
                // check we need to change matrix format
                if (format !== dm.storage()) return matrix(dm, format);
                return dm;
            }
            return dm.valueOf();
        } // vector size
        var n = Math.min(s[0] - kSub, s[1] - kSuper); // diagonal values
        var vector = []; // loop diagonal
        for(var i = 0; i < n; i++)vector[i] = x[i + kSub][i + kSuper];
         // check we need to return a matrix
        return format !== null ? matrix(vector) : vector;
    }
});



var $88446208f5362d74$var$name = "divideScalar";
var $88446208f5362d74$var$dependencies = [
    "typed",
    "numeric"
];
var $88446208f5362d74$export$399593177816ff82 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($88446208f5362d74$var$name, $88446208f5362d74$var$dependencies, (_ref)=>{
    var { typed: typed, numeric: numeric } = _ref;
    /**
   * Divide two scalar values, `x / y`.
   * This function is meant for internal use: it is used by the public functions
   * `divide` and `inv`.
   *
   * This function does not support collections (Array or Matrix).
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit} x   Numerator
   * @param  {number | BigNumber | Fraction | Complex} y          Denominator
   * @return {number | BigNumber | Fraction | Complex | Unit}     Quotient, `x / y`
   * @private
   */ return typed($88446208f5362d74$var$name, {
        "number, number": function numberNumber(x, y) {
            return x / y;
        },
        "Complex, Complex": function ComplexComplex(x, y) {
            return x.div(y);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.div(y);
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.div(y);
        },
        "Unit, number | Fraction | BigNumber": function UnitNumberFractionBigNumber(x, y) {
            var res = x.clone(); // TODO: move the divide function to Unit.js, it uses internals of Unit
            var one = numeric(1, (0, $d8097b7a6d6e36d8$export$f5bbd400c2f4426f)(y));
            res.value = this(res.value === null ? res._normalize(one) : res.value, y);
            return res;
        },
        "number | Fraction | BigNumber, Unit": function numberFractionBigNumberUnit(x, y) {
            var res = y.clone();
            res = res.pow(-1); // TODO: move the divide function to Unit.js, it uses internals of Unit
            var one = numeric(1, (0, $d8097b7a6d6e36d8$export$f5bbd400c2f4426f)(x));
            res.value = this(x, y.value === null ? y._normalize(one) : y.value);
            return res;
        },
        "Unit, Unit": function UnitUnit(x, y) {
            return x.divide(y);
        }
    });
});









var $2343dfd1c51b4e20$var$name = "dotDivide";
var $2343dfd1c51b4e20$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "divideScalar",
    "DenseMatrix"
];
var $2343dfd1c51b4e20$export$e4930a420a373a24 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($2343dfd1c51b4e20$var$name, $2343dfd1c51b4e20$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, divideScalar: divideScalar, DenseMatrix: DenseMatrix } = _ref;
    var algorithm02 = (0, $caf358e9c2d20263$export$92edb534a8f19a37)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm03 = (0, $523b807a911c3d38$export$486bb900f1a3c833)({
        typed: typed
    });
    var algorithm07 = (0, $5200888766c056e5$export$b908fb77c4366999)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm11 = (0, $83b92f81e511657d$export$a38279a12199d831)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm12 = (0, $500ff63908aabda9$export$806772cd23b603dc)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $c68b38998aadcc11$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $533d58927c47005f$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Divide two matrices element wise. The function accepts both matrices and
   * scalar values.
   *
   * Syntax:
   *
   *    math.dotDivide(x, y)
   *
   * Examples:
   *
   *    math.dotDivide(2, 4)   // returns 0.5
   *
   *    a = [[9, 5], [6, 1]]
   *    b = [[3, 2], [5, 2]]
   *
   *    math.dotDivide(a, b)   // returns [[3, 2.5], [1.2, 0.5]]
   *    math.divide(a, b)      // returns [[1.75, 0.75], [-1.75, 2.25]]
   *
   * See also:
   *
   *    divide, multiply, dotMultiply
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x Numerator
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Denominator
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}                    Quotient, `x ./ y`
   */ return typed($2343dfd1c51b4e20$var$name, {
        "any, any": divideScalar,
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, divideScalar, false);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, divideScalar, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, divideScalar, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, divideScalar);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm11(x, y, divideScalar, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, divideScalar, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, divideScalar, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, divideScalar, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, divideScalar, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, divideScalar, true).valueOf();
        }
    });
});







var $0515173c22f58791$var$name = "equal";
var $0515173c22f58791$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "DenseMatrix"
];
var $0515173c22f58791$export$988f37bc1f709b0d = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($0515173c22f58791$var$name, $0515173c22f58791$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, DenseMatrix: DenseMatrix } = _ref;
    var algorithm03 = (0, $523b807a911c3d38$export$486bb900f1a3c833)({
        typed: typed
    });
    var algorithm07 = (0, $5200888766c056e5$export$b908fb77c4366999)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm12 = (0, $500ff63908aabda9$export$806772cd23b603dc)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $c68b38998aadcc11$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $533d58927c47005f$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Test whether two values are equal.
   *
   * The function tests whether the relative difference between x and y is
   * smaller than the configured epsilon. The function cannot be used to
   * compare values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * In case of complex numbers, x.re must equal y.re, and x.im must equal y.im.
   *
   * Values `null` and `undefined` are compared strictly, thus `null` is only
   * equal to `null` and nothing else, and `undefined` is only equal to
   * `undefined` and nothing else. Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.equal(x, y)
   *
   * Examples:
   *
   *    math.equal(2 + 2, 3)         // returns false
   *    math.equal(2 + 2, 4)         // returns true
   *
   *    const a = math.unit('50 cm')
   *    const b = math.unit('5 m')
   *    math.equal(a, b)             // returns true
   *
   *    const c = [2, 5, 1]
   *    const d = [2, 7, 1]
   *
   *    math.equal(c, d)             // returns [true, false, true]
   *    math.deepEqual(c, d)         // returns false
   *
   *    math.equal("1000", "1e3")    // returns true
   *    math.equal(0, null)          // returns false
   *
   * See also:
   *
   *    unequal, smaller, smallerEq, larger, largerEq, compare, deepEqual, equalText
   *
   * @param  {number | BigNumber | boolean | Complex | Unit | string | Array | Matrix} x First value to compare
   * @param  {number | BigNumber | boolean | Complex | Unit | string | Array | Matrix} y Second value to compare
   * @return {boolean | Array | Matrix} Returns true when the compared values are equal, else returns false
   */ return typed($0515173c22f58791$var$name, {
        "any, any": function anyAny(x, y) {
            // strict equality for null and undefined?
            if (x === null) return y === null;
            if (y === null) return x === null;
            if (x === undefined) return y === undefined;
            if (y === undefined) return x === undefined;
            return equalScalar(x, y);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, equalScalar);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, equalScalar, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, equalScalar, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, equalScalar);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm12(x, y, equalScalar, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, equalScalar, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, equalScalar, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, equalScalar, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, equalScalar, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, equalScalar, true).valueOf();
        }
    });
});
var $0515173c22f58791$export$87c1b92540f5e2ae = (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($0515173c22f58791$var$name, [
    "typed",
    "equalScalar"
], (_ref2)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref2;
    return typed($0515173c22f58791$var$name, {
        "any, any": function anyAny(x, y) {
            // strict equality for null and undefined?
            if (x === null) return y === null;
            if (y === null) return x === null;
            if (x === undefined) return y === undefined;
            if (y === undefined) return x === undefined;
            return equalScalar(x, y);
        }
    });
});



var $45e310f8771da7d3$var$name = "fft";
var $45e310f8771da7d3$var$dependencies = [
    "typed",
    "matrix",
    "addScalar",
    "multiplyScalar",
    "divideScalar",
    "exp",
    "tau",
    "i"
];
var $45e310f8771da7d3$export$41ce8d9733cb73c1 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($45e310f8771da7d3$var$name, $45e310f8771da7d3$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, addScalar: addScalar, multiplyScalar: multiplyScalar, divideScalar: divideScalar, exp: exp, tau: tau, i: I } = _ref;
    /**
   * Calculate N-dimensional fourier transform
   *
   * Syntax:
   *
   *     math.fft(arr)
   *
   * Examples:
   *
   *    math.fft([[1, 0], [1, 0]]) // returns [[{re:2, im:0}, {re:2, im:0}], [{re:0, im:0}, {re:0, im:0}]]
   *
   *
   * See Also:
   *
   *      ifft
   *
   * @param {Array | Matrix} arr    An array or matrix
   * @return {Array | Matrix}       N-dimensional fourier transformation of the array
   */ return typed($45e310f8771da7d3$var$name, {
        Array: _ndFft,
        Matrix: function Matrix(matrix) {
            return matrix.create(_ndFft(matrix.toArray()));
        }
    });
    /**
   * Perform an N-dimensional Fourier transform
   *
   * @param {Array} arr      The array
   * @return {Array}         resulting array
   */ function _ndFft(arr) {
        var size = (0, $a14a10567870d913$export$51ffaee4afb683a5)(arr);
        if (size.length === 1) return _fft(arr, size[0]); // ndFft along dimension 1,...,N-1 then 1dFft along dimension 0
        return _1dFft(arr.map((slice)=>_ndFft(slice, size.slice(1))), 0);
    }
    /**
   * Perform an 1-dimensional Fourier transform
   *
   * @param {Array} arr      The array
   * @param {number} dim     dimension of the array to perform on
   * @return {Array}         resulting array
   */ function _1dFft(arr, dim) {
        var size = (0, $a14a10567870d913$export$51ffaee4afb683a5)(arr);
        if (dim !== 0) return new Array(size[0]).fill(0).map((_, i)=>_1dFft(arr[i], dim - 1));
        if (size.length === 1) return _fft(arr);
        function _transpose(arr) {
            // Swap first 2 dimensions
            var size = (0, $a14a10567870d913$export$51ffaee4afb683a5)(arr);
            return new Array(size[1]).fill(0).map((_, j)=>new Array(size[0]).fill(0).map((_, i)=>arr[i][j]));
        }
        return _transpose(_1dFft(_transpose(arr), 1));
    }
    /**
   * Perform an 1-dimensional Fourier transform
   *
   * @param {Array} arr      The array
   * @return {Array}         resulting array
   */ function _fft(arr) {
        var len = arr.length;
        if (len === 1) return [
            arr[0]
        ];
        if (len % 2 === 0) {
            var ret = [
                ..._fft(arr.filter((_, i)=>i % 2 === 0), len / 2),
                ..._fft(arr.filter((_, i)=>i % 2 === 1), len / 2)
            ];
            for(var k = 0; k < len / 2; k++){
                var p = ret[k];
                var q = multiplyScalar(ret[k + len / 2], exp(multiplyScalar(multiplyScalar(tau, I), divideScalar(-k, len))));
                ret[k] = addScalar(p, q);
                ret[k + len / 2] = addScalar(p, multiplyScalar(-1, q));
            }
            return ret;
        }
        throw new Error("Can only calculate FFT of power-of-two size");
    }
});




var $b5ad8281b188fc17$var$name = "flatten";
var $b5ad8281b188fc17$var$dependencies = [
    "typed",
    "matrix"
];
var $b5ad8281b188fc17$export$107988e3ee9f3d12 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($b5ad8281b188fc17$var$name, $b5ad8281b188fc17$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix } = _ref;
    /**
   * Flatten a multi dimensional matrix into a single dimensional matrix.
   * It is guaranteed to always return a clone of the argument.
   *
   * Syntax:
   *
   *    math.flatten(x)
   *
   * Examples:
   *
   *    math.flatten([[1,2], [3,4]])   // returns [1, 2, 3, 4]
   *
   * See also:
   *
   *    concat, resize, size, squeeze
   *
   * @param {Matrix | Array} x   Matrix to be flattened
   * @return {Matrix | Array} Returns the flattened matrix
   */ return typed($b5ad8281b188fc17$var$name, {
        Array: function Array(x) {
            return (0, $a14a10567870d913$export$bffa455ba8c619a6)((0, $6819694788cbfa38$export$9cd59f9826255e47)(x));
        },
        Matrix: function Matrix(x) {
            var flat = (0, $a14a10567870d913$export$bffa455ba8c619a6)((0, $6819694788cbfa38$export$9cd59f9826255e47)(x.toArray())); // TODO: return the same matrix type as x
            return matrix(flat);
        }
    });
});





var $a82cb0c9b14aa1c6$var$name = "algorithm04";
var $a82cb0c9b14aa1c6$var$dependencies = [
    "typed",
    "equalScalar"
];
var $a82cb0c9b14aa1c6$export$898ea3bef50d41b7 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($a82cb0c9b14aa1c6$var$name, $a82cb0c9b14aa1c6$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref;
    /**
   * Iterates over SparseMatrix A and SparseMatrix B nonzero items and invokes the callback function f(Aij, Bij).
   * Callback function invoked MAX(NNZA, NNZB) times
   *
   *
   *          ┌  f(Aij, Bij)  ; A(i,j) !== 0 && B(i,j) !== 0
   * C(i,j) = ┤  A(i,j)       ; A(i,j) !== 0
   *          └  B(i,j)       ; B(i,j) !== 0
   *
   *
   * @param {Matrix}   a                 The SparseMatrix instance (A)
   * @param {Matrix}   b                 The SparseMatrix instance (B)
   * @param {Function} callback          The f(Aij,Bij) operation to invoke
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
   */ return function algorithm04(a, b, callback) {
        // sparse matrix arrays
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var asize = a._size;
        var adt = a._datatype; // sparse matrix arrays
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr;
        var bsize = b._size;
        var bdt = b._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $89c7b7a60bca4b11$export$ad1391ca020fdd96)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string" && adt === bdt) {
            // datatype
            dt = adt; // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result arrays
        var cvalues = avalues && bvalues ? [] : undefined;
        var cindex = [];
        var cptr = []; // workspace
        var xa = avalues && bvalues ? [] : undefined;
        var xb = avalues && bvalues ? [] : undefined; // marks indicating we have a value in x for a given column
        var wa = [];
        var wb = []; // vars
        var i, j, k, k0, k1; // loop columns
        for(j = 0; j < columns; j++){
            // update cptr
            cptr[j] = cindex.length; // columns mark
            var mark = j + 1; // loop A(:,j)
            for(k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
                // row
                i = aindex[k]; // update c
                cindex.push(i); // update workspace
                wa[i] = mark; // check we need to process values
                if (xa) xa[i] = avalues[k];
            } // loop B(:,j)
            for(k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++){
                // row
                i = bindex[k]; // check row exists in A
                if (wa[i] === mark) // update record in xa @ i
                {
                    if (xa) {
                        // invoke callback
                        var v = cf(xa[i], bvalues[k]); // check for zero
                        if (!eq(v, zero)) // update workspace
                        xa[i] = v;
                        else // remove mark (index will be removed later)
                        wa[i] = null;
                    }
                } else {
                    // update c
                    cindex.push(i); // update workspace
                    wb[i] = mark; // check we need to process values
                    if (xb) xb[i] = bvalues[k];
                }
            } // check we need to process values (non pattern matrix)
            if (xa && xb) {
                // initialize first index in j
                k = cptr[j]; // loop index in j
                while(k < cindex.length){
                    // row
                    i = cindex[k]; // check workspace has value @ i
                    if (wa[i] === mark) {
                        // push value (Aij != 0 || (Aij != 0 && Bij != 0))
                        cvalues[k] = xa[i]; // increment pointer
                        k++;
                    } else if (wb[i] === mark) {
                        // push value (bij != 0)
                        cvalues[k] = xb[i]; // increment pointer
                        k++;
                    } else // remove index @ k
                    cindex.splice(k, 1);
                }
            }
        } // update cptr
        cptr[columns] = cindex.length; // return sparse matrix
        return a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});






var $90ee737470100bb9$var$name = "gcd";
var $90ee737470100bb9$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "BigNumber",
    "DenseMatrix"
];
var $90ee737470100bb9$export$2eb8acc96c598512 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($90ee737470100bb9$var$name, $90ee737470100bb9$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, BigNumber: BigNumber, DenseMatrix: DenseMatrix } = _ref;
    var algorithm01 = (0, $87b5a4e357abde7d$export$5e6d55d37a917802)({
        typed: typed
    });
    var algorithm04 = (0, $a82cb0c9b14aa1c6$export$898ea3bef50d41b7)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm10 = (0, $5e80d3fce4071128$export$72a88f2eee9ec1ed)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $c68b38998aadcc11$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $533d58927c47005f$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Calculate the greatest common divisor for two or more values or arrays.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.gcd(a, b)
   *    math.gcd(a, b, c, ...)
   *
   * Examples:
   *
   *    math.gcd(8, 12)              // returns 4
   *    math.gcd(-4, 6)              // returns 2
   *    math.gcd(25, 15, -10)        // returns 5
   *
   *    math.gcd([8, -4], [12, 6])   // returns [4, 2]
   *
   * See also:
   *
   *    lcm, xgcd
   *
   * @param {... number | BigNumber | Fraction | Array | Matrix} args  Two or more integer numbers
   * @return {number | BigNumber | Fraction | Array | Matrix}                           The greatest common divisor
   */ return typed($90ee737470100bb9$var$name, {
        "number, number": (0, $4b37ed316f05dd33$export$3a8d786b08b3a70c),
        "BigNumber, BigNumber": _gcdBigNumber,
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.gcd(y);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm04(x, y, this);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm01(y, x, this, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm01(x, y, this, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, number | BigNumber": function SparseMatrixNumberBigNumber(x, y) {
            return algorithm10(x, y, this, false);
        },
        "DenseMatrix, number | BigNumber": function DenseMatrixNumberBigNumber(x, y) {
            return algorithm14(x, y, this, false);
        },
        "number | BigNumber, SparseMatrix": function numberBigNumberSparseMatrix(x, y) {
            return algorithm10(y, x, this, true);
        },
        "number | BigNumber, DenseMatrix": function numberBigNumberDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        "Array, number | BigNumber": function ArrayNumberBigNumber(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        "number | BigNumber, Array": function numberBigNumberArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        },
        // TODO: need a smarter notation here
        "Array | Matrix | number | BigNumber, Array | Matrix | number | BigNumber, ...Array | Matrix | number | BigNumber": function ArrayMatrixNumberBigNumberArrayMatrixNumberBigNumberArrayMatrixNumberBigNumber(a, b, args) {
            var res = this(a, b);
            for(var i = 0; i < args.length; i++)res = this(res, args[i]);
            return res;
        }
    });
    /**
   * Calculate gcd for BigNumbers
   * @param {BigNumber} a
   * @param {BigNumber} b
   * @returns {BigNumber} Returns greatest common denominator of a and b
   * @private
   */ function _gcdBigNumber(a, b) {
        if (!a.isInt() || !b.isInt()) throw new Error("Parameters in function gcd must be integer numbers");
         // https://en.wikipedia.org/wiki/Euclidean_algorithm
        var zero = new BigNumber(0);
        while(!b.isZero()){
            var r = a.mod(b);
            a = b;
            b = r;
        }
        return a.lt(zero) ? a.neg() : a;
    }
});


var $1394b7c758158021$var$name = "hasNumericValue";
var $1394b7c758158021$var$dependencies = [
    "typed",
    "isNumeric"
];
var $1394b7c758158021$export$acff9f91b891ace6 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($1394b7c758158021$var$name, $1394b7c758158021$var$dependencies, (_ref)=>{
    var { typed: typed, isNumeric: isNumeric } = _ref;
    /**
   * Test whether a value is an numeric value.
   *
   * In case of a string, true is returned if the string contains a numeric value.
   *
   * Syntax:
   *
   *     math.hasNumericValue(x)
   *
   * Examples:
   *
   *    math.hasNumericValue(2)                     // returns true
   *    math.hasNumericValue('2')                   // returns true
   *    math.isNumeric('2')                         // returns false
   *    math.hasNumericValue(0)                     // returns true
   *    math.hasNumericValue(math.bignumber(500))   // returns true
   *    math.hasNumericValue(math.fraction(4))      // returns true
   *    math.hasNumericValue(math.complex('2-4i')   // returns false
   *    math.hasNumericValue([2.3, 'foo', false])   // returns [true, false, true]
   *
   * See also:
   *
   *    isZero, isPositive, isNegative, isInteger, isNumeric
   *
   * @param {*} x       Value to be tested
   * @return {boolean}  Returns true when `x` is a `number`, `BigNumber`,
   *                    `Fraction`, `Boolean`, or a `String` containing number. Returns false for other types.
   *                    Throws an error in case of unknown types.
   */ return typed($1394b7c758158021$var$name, {
        string: function string(x) {
            return x.trim().length > 0 && !isNaN(Number(x));
        },
        any: function any(x) {
            return isNumeric(x);
        }
    });
});



var $37ba9516e51550e6$var$name = "hypot";
var $37ba9516e51550e6$var$dependencies = [
    "typed",
    "abs",
    "addScalar",
    "divideScalar",
    "multiplyScalar",
    "sqrt",
    "smaller",
    "isPositive"
];
var $37ba9516e51550e6$export$87e3687740a09cb = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($37ba9516e51550e6$var$name, $37ba9516e51550e6$var$dependencies, (_ref)=>{
    var { typed: typed, abs: abs, addScalar: addScalar, divideScalar: divideScalar, multiplyScalar: multiplyScalar, sqrt: sqrt, smaller: smaller, isPositive: isPositive } = _ref;
    /**
   * Calculate the hypotenusa of a list with values. The hypotenusa is defined as:
   *
   *     hypot(a, b, c, ...) = sqrt(a^2 + b^2 + c^2 + ...)
   *
   * For matrix input, the hypotenusa is calculated for all values in the matrix.
   *
   * Syntax:
   *
   *     math.hypot(a, b, ...)
   *     math.hypot([a, b, c, ...])
   *
   * Examples:
   *
   *     math.hypot(3, 4)      // 5
   *     math.hypot(3, 4, 5)   // 7.0710678118654755
   *     math.hypot([3, 4, 5]) // 7.0710678118654755
   *     math.hypot(-2)        // 2
   *
   * See also:
   *
   *     abs, norm
   *
   * @param {... number | BigNumber | Array | Matrix} args    A list with numeric values or an Array or Matrix.
   *                                                          Matrix and Array input is flattened and returns a
   *                                                          single number for the whole matrix.
   * @return {number | BigNumber} Returns the hypothenusa of the input values.
   */ return typed($37ba9516e51550e6$var$name, {
        "... number | BigNumber": _hypot,
        Array: function Array(x) {
            return this.apply(this, (0, $a14a10567870d913$export$bffa455ba8c619a6)(x));
        },
        Matrix: function Matrix(x) {
            return this.apply(this, (0, $a14a10567870d913$export$bffa455ba8c619a6)(x.toArray()));
        }
    });
    /**
   * Calculate the hypotenusa for an Array with values
   * @param {Array.<number | BigNumber>} args
   * @return {number | BigNumber} Returns the result
   * @private
   */ function _hypot(args) {
        // code based on `hypot` from es6-shim:
        // https://github.com/paulmillr/es6-shim/blob/master/es6-shim.js#L1619-L1633
        var result = 0;
        var largest = 0;
        for(var i = 0; i < args.length; i++){
            var value = abs(args[i]);
            if (smaller(largest, value)) {
                result = multiplyScalar(result, multiplyScalar(divideScalar(largest, value), divideScalar(largest, value)));
                result = addScalar(result, 1);
                largest = value;
            } else result = addScalar(result, isPositive(value) ? multiplyScalar(divideScalar(value, largest), divideScalar(value, largest)) : value);
        }
        return multiplyScalar(largest, sqrt(result));
    }
});




var $f939700b33cdde6d$var$name = "ifft";
var $f939700b33cdde6d$var$dependencies = [
    "typed",
    "fft",
    "dotDivide",
    "conj"
];
var $f939700b33cdde6d$export$fb893320704d694a = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($f939700b33cdde6d$var$name, $f939700b33cdde6d$var$dependencies, (_ref)=>{
    var { typed: typed, fft: fft, dotDivide: dotDivide, conj: conj } = _ref;
    /**
   * Calculate N-dimensional inverse fourier transform
   *
   * Syntax:
   *
   *     math.ifft(arr)
   *
   * Examples:
   *
   *    math.ifft([[2, 2], [0, 0]]) // returns [[{re:1, im:0}, {re:0, im:0}], [{re:1, im:0}, {re:0, im:0}]]
   *
   * See Also:
   *
   *      fft
   *
   * @param {Array | Matrix} arr    An array or matrix
   * @return {Array | Matrix}       N-dimensional fourier transformation of the array
   */ return typed($f939700b33cdde6d$var$name, {
        "Array | Matrix": function ArrayMatrix(arr) {
            var size = (0, $d8097b7a6d6e36d8$export$b22160e0a14f87b7)(arr) ? arr.size() : (0, $a14a10567870d913$export$51ffaee4afb683a5)(arr);
            return dotDivide(conj(fft(conj(arr))), size.reduce((acc, curr)=>acc * curr, 1));
        }
    });
});



var $81a28db092625990$var$name = "kron";
var $81a28db092625990$var$dependencies = [
    "typed",
    "matrix",
    "multiplyScalar"
];
var $81a28db092625990$export$cee275bf38ddc295 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($81a28db092625990$var$name, $81a28db092625990$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, multiplyScalar: multiplyScalar } = _ref;
    /**
     * Calculates the kronecker product of 2 matrices or vectors.
     *
     * NOTE: If a one dimensional vector / matrix is given, it will be
     * wrapped so its two dimensions.
     * See the examples.
     *
     * Syntax:
     *
     *    math.kron(x, y)
     *
     * Examples:
     *
     *    math.kron([[1, 0], [0, 1]], [[1, 2], [3, 4]])
     *    // returns [ [ 1, 2, 0, 0 ], [ 3, 4, 0, 0 ], [ 0, 0, 1, 2 ], [ 0, 0, 3, 4 ] ]
     *
     *    math.kron([1,1], [2,3,4])
     *    // returns [ [ 2, 3, 4, 2, 3, 4 ] ]
     *
     * See also:
     *
     *    multiply, dot, cross
     *
     * @param  {Array | Matrix} x     First vector
     * @param  {Array | Matrix} y     Second vector
     * @return {Array | Matrix}       Returns the kronecker product of `x` and `y`
     */ return typed($81a28db092625990$var$name, {
        "Matrix, Matrix": function MatrixMatrix(x, y) {
            return matrix(_kron(x.toArray(), y.toArray()));
        },
        "Matrix, Array": function MatrixArray(x, y) {
            return matrix(_kron(x.toArray(), y));
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            return matrix(_kron(x, y.toArray()));
        },
        "Array, Array": _kron
    });
    /**
     * Calculate the kronecker product of two matrices / vectors
     * @param {Array} a  First vector
     * @param {Array} b  Second vector
     * @returns {Array} Returns the kronecker product of x and y
     * @private
     */ function _kron(a, b) {
        // Deal with the dimensions of the matricies.
        if ((0, $a14a10567870d913$export$51ffaee4afb683a5)(a).length === 1) // Wrap it in a 2D Matrix
        a = [
            a
        ];
        if ((0, $a14a10567870d913$export$51ffaee4afb683a5)(b).length === 1) // Wrap it in a 2D Matrix
        b = [
            b
        ];
        if ((0, $a14a10567870d913$export$51ffaee4afb683a5)(a).length > 2 || (0, $a14a10567870d913$export$51ffaee4afb683a5)(b).length > 2) throw new RangeError("Vectors with dimensions greater then 2 are not supported expected (Size x = " + JSON.stringify(a.length) + ", y = " + JSON.stringify(b.length) + ")");
        var t = [];
        var r = [];
        return a.map(function(a) {
            return b.map(function(b) {
                r = [];
                t.push(r);
                return a.map(function(y) {
                    return b.map(function(x) {
                        return r.push(multiplyScalar(y, x));
                    });
                });
            });
        }) && t;
    }
});









var $653c14e56f7be1ca$var$name = "largerEq";
var $653c14e56f7be1ca$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "DenseMatrix"
];
var $653c14e56f7be1ca$export$26aa7f5b5fee1150 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($653c14e56f7be1ca$var$name, $653c14e56f7be1ca$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, DenseMatrix: DenseMatrix } = _ref;
    var algorithm03 = (0, $523b807a911c3d38$export$486bb900f1a3c833)({
        typed: typed
    });
    var algorithm07 = (0, $5200888766c056e5$export$b908fb77c4366999)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm12 = (0, $500ff63908aabda9$export$806772cd23b603dc)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $c68b38998aadcc11$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $533d58927c47005f$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Test whether value x is larger or equal to y.
   *
   * The function returns true when x is larger than y or the relative
   * difference between x and y is smaller than the configured epsilon. The
   * function cannot be used to compare values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.largerEq(x, y)
   *
   * Examples:
   *
   *    math.larger(2, 1 + 1)         // returns false
   *    math.largerEq(2, 1 + 1)       // returns true
   *
   * See also:
   *
   *    equal, unequal, smaller, smallerEq, larger, compare
   *
   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} x First value to compare
   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} y Second value to compare
   * @return {boolean | Array | Matrix} Returns true when the x is larger or equal to y, else returns false
   */ return typed($653c14e56f7be1ca$var$name, {
        "boolean, boolean": function booleanBoolean(x, y) {
            return x >= y;
        },
        "number, number": function numberNumber(x, y) {
            return x >= y || (0, $668e051498bf5fa0$export$6f3989c6ecc04081)(x, y, config.epsilon);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.gte(y) || (0, $53e0635127e7c5a0$export$6f3989c6ecc04081)(x, y, config.epsilon);
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.compare(y) !== -1;
        },
        "Complex, Complex": function ComplexComplex() {
            throw new TypeError("No ordering relation is defined for complex numbers");
        },
        "Unit, Unit": function UnitUnit(x, y) {
            if (!x.equalBase(y)) throw new Error("Cannot compare units with different base");
            return this(x.value, y.value);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, this);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, this, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, this, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm12(x, y, this, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, this, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, this, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});
var $653c14e56f7be1ca$export$494ed93834104475 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($653c14e56f7be1ca$var$name, [
    "typed",
    "config"
], (_ref2)=>{
    var { typed: typed, config: config } = _ref2;
    return typed($653c14e56f7be1ca$var$name, {
        "number, number": function numberNumber(x, y) {
            return x >= y || (0, $668e051498bf5fa0$export$6f3989c6ecc04081)(x, y, config.epsilon);
        }
    });
});









var $77f7cfbe3a0de141$var$name = "algorithm08";
var $77f7cfbe3a0de141$var$dependencies = [
    "typed",
    "equalScalar"
];
var $77f7cfbe3a0de141$export$59a068f853cfbf8 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($77f7cfbe3a0de141$var$name, $77f7cfbe3a0de141$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref;
    /**
   * Iterates over SparseMatrix A and SparseMatrix B nonzero items and invokes the callback function f(Aij, Bij).
   * Callback function invoked MAX(NNZA, NNZB) times
   *
   *
   *          ┌  f(Aij, Bij)  ; A(i,j) !== 0 && B(i,j) !== 0
   * C(i,j) = ┤  A(i,j)       ; A(i,j) !== 0
   *          └  0            ; otherwise
   *
   *
   * @param {Matrix}   a                 The SparseMatrix instance (A)
   * @param {Matrix}   b                 The SparseMatrix instance (B)
   * @param {Function} callback          The f(Aij,Bij) operation to invoke
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
   */ return function algorithm08(a, b, callback) {
        // sparse matrix arrays
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var asize = a._size;
        var adt = a._datatype; // sparse matrix arrays
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr;
        var bsize = b._size;
        var bdt = b._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $89c7b7a60bca4b11$export$ad1391ca020fdd96)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
         // sparse matrix cannot be a Pattern matrix
        if (!avalues || !bvalues) throw new Error("Cannot perform operation on Pattern Sparse Matrices");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string" && adt === bdt) {
            // datatype
            dt = adt; // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result arrays
        var cvalues = [];
        var cindex = [];
        var cptr = []; // workspace
        var x = []; // marks indicating we have a value in x for a given column
        var w = []; // vars
        var k, k0, k1, i; // loop columns
        for(var j = 0; j < columns; j++){
            // update cptr
            cptr[j] = cindex.length; // columns mark
            var mark = j + 1; // loop values in a
            for(k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
                // row
                i = aindex[k]; // mark workspace
                w[i] = mark; // set value
                x[i] = avalues[k]; // add index
                cindex.push(i);
            } // loop values in b
            for(k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++){
                // row
                i = bindex[k]; // check value exists in workspace
                if (w[i] === mark) // evaluate callback
                x[i] = cf(x[i], bvalues[k]);
            } // initialize first index in j
            k = cptr[j]; // loop index in j
            while(k < cindex.length){
                // row
                i = cindex[k]; // value @ i
                var v = x[i]; // check for zero value
                if (!eq(v, zero)) {
                    // push value
                    cvalues.push(v); // increment pointer
                    k++;
                } else // remove value @ i, do not increment pointer
                cindex.splice(k, 1);
            }
        } // update cptr
        cptr[columns] = cindex.length; // return sparse matrix
        return a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});





var $33f5848669d23bbf$var$name = "leftShift";
var $33f5848669d23bbf$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "zeros",
    "DenseMatrix"
];
var $33f5848669d23bbf$export$ce15600b23f5e78 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($33f5848669d23bbf$var$name, $33f5848669d23bbf$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, zeros: zeros, DenseMatrix: DenseMatrix } = _ref;
    var algorithm01 = (0, $87b5a4e357abde7d$export$5e6d55d37a917802)({
        typed: typed
    });
    var algorithm02 = (0, $caf358e9c2d20263$export$92edb534a8f19a37)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm08 = (0, $77f7cfbe3a0de141$export$59a068f853cfbf8)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm10 = (0, $5e80d3fce4071128$export$72a88f2eee9ec1ed)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm11 = (0, $83b92f81e511657d$export$a38279a12199d831)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm13 = (0, $c68b38998aadcc11$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $533d58927c47005f$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Bitwise left logical shift of a value x by y number of bits, `x << y`.
   * For matrices, the function is evaluated element wise.
   * For units, the function is evaluated on the best prefix base.
   *
   * Syntax:
   *
   *    math.leftShift(x, y)
   *
   * Examples:
   *
   *    math.leftShift(1, 2)               // returns number 4
   *
   *    math.leftShift([1, 2, 3], 4)       // returns Array [16, 32, 64]
   *
   * See also:
   *
   *    leftShift, bitNot, bitOr, bitXor, rightArithShift, rightLogShift
   *
   * @param  {number | BigNumber | Array | Matrix} x Value to be shifted
   * @param  {number | BigNumber} y Amount of shifts
   * @return {number | BigNumber | Array | Matrix} `x` shifted left `y` times
   */ return typed($33f5848669d23bbf$var$name, {
        "number, number": (0, $ac33a15c81597bf3$export$65c07a47901525ba),
        "BigNumber, BigNumber": (0, $3b8565a47dc4d809$export$626dff8098a67b4c),
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm08(x, y, this, false);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, this, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm01(x, y, this, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, number | BigNumber": function SparseMatrixNumberBigNumber(x, y) {
            // check scalar
            if (equalScalar(y, 0)) return x.clone();
            return algorithm11(x, y, this, false);
        },
        "DenseMatrix, number | BigNumber": function DenseMatrixNumberBigNumber(x, y) {
            // check scalar
            if (equalScalar(y, 0)) return x.clone();
            return algorithm14(x, y, this, false);
        },
        "number | BigNumber, SparseMatrix": function numberBigNumberSparseMatrix(x, y) {
            // check scalar
            if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
            return algorithm10(y, x, this, true);
        },
        "number | BigNumber, DenseMatrix": function numberBigNumberDenseMatrix(x, y) {
            // check scalar
            if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
            return algorithm14(y, x, this, true);
        },
        "Array, number | BigNumber": function ArrayNumberBigNumber(x, y) {
            // use matrix implementation
            return this(matrix(x), y).valueOf();
        },
        "number | BigNumber, Array": function numberBigNumberArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y)).valueOf();
        }
    });
});





function $5b483e7b4659dfae$export$6accbcba5dda801d(_ref) {
    var { DenseMatrix: DenseMatrix } = _ref;
    /**
   * Validates matrix and column vector b for backward/forward substitution algorithms.
   *
   * @param {Matrix} m            An N x N matrix
   * @param {Array | Matrix} b    A column vector
   * @param {Boolean} copy        Return a copy of vector b
   *
   * @return {DenseMatrix}        Dense column vector b
   */ return function solveValidation(m, b, copy) {
        var mSize = m.size();
        if (mSize.length !== 2) throw new RangeError("Matrix must be two dimensional (size: " + (0, $b94963e97c376b6d$export$d9468344d3651243)(mSize) + ")");
        var rows = mSize[0];
        var columns = mSize[1];
        if (rows !== columns) throw new RangeError("Matrix must be square (size: " + (0, $b94963e97c376b6d$export$d9468344d3651243)(mSize) + ")");
        var data = [];
        if ((0, $d8097b7a6d6e36d8$export$b22160e0a14f87b7)(b)) {
            var bSize = b.size();
            var bdata = b._data; // 1-dim vector
            if (bSize.length === 1) {
                if (bSize[0] !== rows) throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
                for(var i = 0; i < rows; i++)data[i] = [
                    bdata[i]
                ];
                return new DenseMatrix({
                    data: data,
                    size: [
                        rows,
                        1
                    ],
                    datatype: b._datatype
                });
            } // 2-dim column
            if (bSize.length === 2) {
                if (bSize[0] !== rows || bSize[1] !== 1) throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
                if ((0, $d8097b7a6d6e36d8$export$eb44495df7ba11d)(b)) {
                    if (copy) {
                        data = [];
                        for(var _i = 0; _i < rows; _i++)data[_i] = [
                            bdata[_i][0]
                        ];
                        return new DenseMatrix({
                            data: data,
                            size: [
                                rows,
                                1
                            ],
                            datatype: b._datatype
                        });
                    }
                    return b;
                }
                if ((0, $d8097b7a6d6e36d8$export$d508368d4da3c38a)(b)) {
                    for(var _i2 = 0; _i2 < rows; _i2++)data[_i2] = [
                        0
                    ];
                    var values = b._values;
                    var index = b._index;
                    var ptr = b._ptr;
                    for(var k1 = ptr[1], k = ptr[0]; k < k1; k++){
                        var _i3 = index[k];
                        data[_i3][0] = values[k];
                    }
                    return new DenseMatrix({
                        data: data,
                        size: [
                            rows,
                            1
                        ],
                        datatype: b._datatype
                    });
                }
            }
            throw new RangeError("Dimension mismatch. The right side has to be either 1- or 2-dimensional vector.");
        }
        if ((0, $d8097b7a6d6e36d8$export$43bee75e5e14138e)(b)) {
            var bsize = (0, $a14a10567870d913$export$51ffaee4afb683a5)(b);
            if (bsize.length === 1) {
                if (bsize[0] !== rows) throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
                for(var _i4 = 0; _i4 < rows; _i4++)data[_i4] = [
                    b[_i4]
                ];
                return new DenseMatrix({
                    data: data,
                    size: [
                        rows,
                        1
                    ]
                });
            }
            if (bsize.length === 2) {
                if (bsize[0] !== rows || bsize[1] !== 1) throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
                for(var _i5 = 0; _i5 < rows; _i5++)data[_i5] = [
                    b[_i5][0]
                ];
                return new DenseMatrix({
                    data: data,
                    size: [
                        rows,
                        1
                    ]
                });
            }
            throw new RangeError("Dimension mismatch. The right side has to be either 1- or 2-dimensional vector.");
        }
    };
}


var $8ccd4616592e81e1$var$name = "lsolve";
var $8ccd4616592e81e1$var$dependencies = [
    "typed",
    "matrix",
    "divideScalar",
    "multiplyScalar",
    "subtract",
    "equalScalar",
    "DenseMatrix"
];
var $8ccd4616592e81e1$export$1b88d04961967a10 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($8ccd4616592e81e1$var$name, $8ccd4616592e81e1$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, divideScalar: divideScalar, multiplyScalar: multiplyScalar, subtract: subtract, equalScalar: equalScalar, DenseMatrix: DenseMatrix } = _ref;
    var solveValidation = (0, $5b483e7b4659dfae$export$6accbcba5dda801d)({
        DenseMatrix: DenseMatrix
    });
    /**
   * Finds one solution of a linear equation system by forwards substitution. Matrix must be a lower triangular matrix. Throws an error if there's no solution.
   *
   * `L * x = b`
   *
   * Syntax:
   *
   *    math.lsolve(L, b)
   *
   * Examples:
   *
   *    const a = [[-2, 3], [2, 1]]
   *    const b = [11, 9]
   *    const x = lsolve(a, b)  // [[-5.5], [20]]
   *
   * See also:
   *
   *    lsolveAll, lup, slu, usolve, lusolve
   *
   * @param {Matrix, Array} L       A N x N matrix or array (L)
   * @param {Matrix, Array} b       A column vector with the b values
   *
   * @return {DenseMatrix | Array}  A column vector with the linear system solution (x)
   */ return typed($8ccd4616592e81e1$var$name, {
        "SparseMatrix, Array | Matrix": function SparseMatrixArrayMatrix(m, b) {
            return _sparseForwardSubstitution(m, b);
        },
        "DenseMatrix, Array | Matrix": function DenseMatrixArrayMatrix(m, b) {
            return _denseForwardSubstitution(m, b);
        },
        "Array, Array | Matrix": function ArrayArrayMatrix(a, b) {
            var m = matrix(a);
            var r = _denseForwardSubstitution(m, b);
            return r.valueOf();
        }
    });
    function _denseForwardSubstitution(m, b) {
        // validate matrix and vector, return copy of column vector b
        b = solveValidation(m, b, true);
        var bdata = b._data;
        var rows = m._size[0];
        var columns = m._size[1]; // result
        var x = [];
        var mdata = m._data; // loop columns
        for(var j = 0; j < columns; j++){
            var bj = bdata[j][0] || 0;
            var xj = void 0;
            if (!equalScalar(bj, 0)) {
                // non-degenerate row, find solution
                var vjj = mdata[j][j];
                if (equalScalar(vjj, 0)) throw new Error("Linear system cannot be solved since matrix is singular");
                xj = divideScalar(bj, vjj); // loop rows
                for(var i = j + 1; i < rows; i++)bdata[i] = [
                    subtract(bdata[i][0] || 0, multiplyScalar(xj, mdata[i][j]))
                ];
            } else // degenerate row, we can choose any value
            xj = 0;
            x[j] = [
                xj
            ];
        }
        return new DenseMatrix({
            data: x,
            size: [
                rows,
                1
            ]
        });
    }
    function _sparseForwardSubstitution(m, b) {
        // validate matrix and vector, return copy of column vector b
        b = solveValidation(m, b, true);
        var bdata = b._data;
        var rows = m._size[0];
        var columns = m._size[1];
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr; // result
        var x = []; // loop columns
        for(var j = 0; j < columns; j++){
            var bj = bdata[j][0] || 0;
            if (!equalScalar(bj, 0)) {
                // non-degenerate row, find solution
                var vjj = 0; // matrix values & indices (column j)
                var jValues = [];
                var jIndices = []; // first and last index in the column
                var firstIndex = ptr[j];
                var lastIndex = ptr[j + 1]; // values in column, find value at [j, j]
                for(var k = firstIndex; k < lastIndex; k++){
                    var i = index[k]; // check row (rows are not sorted!)
                    if (i === j) vjj = values[k];
                    else if (i > j) {
                        // store lower triangular
                        jValues.push(values[k]);
                        jIndices.push(i);
                    }
                } // at this point we must have a value in vjj
                if (equalScalar(vjj, 0)) throw new Error("Linear system cannot be solved since matrix is singular");
                var xj = divideScalar(bj, vjj);
                for(var _k = 0, l = jIndices.length; _k < l; _k++){
                    var _i = jIndices[_k];
                    bdata[_i] = [
                        subtract(bdata[_i][0] || 0, multiplyScalar(xj, jValues[_k]))
                    ];
                }
                x[j] = [
                    xj
                ];
            } else // degenerate row, we can choose any value
            x[j] = [
                0
            ];
        }
        return new DenseMatrix({
            data: x,
            size: [
                rows,
                1
            ]
        });
    }
});


var $504fd1964fd88314$var$name = "matrixFromColumns";
var $504fd1964fd88314$var$dependencies = [
    "typed",
    "matrix",
    "flatten",
    "size"
];
var $504fd1964fd88314$export$65fefc9f63da4d13 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($504fd1964fd88314$var$name, $504fd1964fd88314$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, flatten: flatten, size: size } = _ref;
    /**
   * Create a dense matrix from vectors as individual columns.
   * If you pass row vectors, they will be transposed (but not conjugated!)
   *
   * Syntax:
   *
   *    math.matrixFromColumns(...arr)
   *    math.matrixFromColumns(col1, col2)
   *    math.matrixFromColumns(col1, col2, col3)
   *
   * Examples:
   *
   *    math.matrixFromColumns([1, 2, 3], [[4],[5],[6]])
   *    math.matrixFromColumns(...vectors)
   *
   * See also:
   *
   *    matrix, matrixFromRows, matrixFromFunction, zeros
   *
   * @param {... Array | Matrix} cols Multiple columns
   * @return { number[][] | Matrix } if at least one of the arguments is an array, an array will be returned
   */ return typed($504fd1964fd88314$var$name, {
        "...Array": function Array(arr) {
            return _createArray(arr);
        },
        "...Matrix": function Matrix(arr) {
            return matrix(_createArray(arr.map((m)=>m.toArray())));
        } // TODO implement this properly for SparseMatrix
    });
    function _createArray(arr) {
        if (arr.length === 0) throw new TypeError("At least one column is needed to construct a matrix.");
        var N = checkVectorTypeAndReturnLength(arr[0]); // create an array with empty rows
        var result = [];
        for(var i = 0; i < N; i++)result[i] = [];
         // loop columns
        for (var col of arr){
            var colLength = checkVectorTypeAndReturnLength(col);
            if (colLength !== N) throw new TypeError("The vectors had different length: " + (N | 0) + " \u2260 " + (colLength | 0));
            var f = flatten(col); // push a value to each row
            for(var _i = 0; _i < N; _i++)result[_i].push(f[_i]);
        }
        return result;
    }
    function checkVectorTypeAndReturnLength(vec) {
        var s = size(vec);
        if (s.length === 1) // 1D vector
        return s[0];
        else if (s.length === 2) {
            // 2D vector
            if (s[0] === 1) // row vector
            return s[1];
            else if (s[1] === 1) // col vector
            return s[0];
            else throw new TypeError("At least one of the arguments is not a vector.");
        } else throw new TypeError("Only one- or two-dimensional vectors are supported.");
    }
});




var $02bb6f64048cae79$var$name = "min";
var $02bb6f64048cae79$var$dependencies = [
    "typed",
    "config",
    "numeric",
    "smaller"
];
var $02bb6f64048cae79$export$b795f47e2b99170 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($02bb6f64048cae79$var$name, $02bb6f64048cae79$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, numeric: numeric, smaller: smaller } = _ref;
    /**
   * Compute the minimum value of a matrix or a  list of values.
   * In case of a multi dimensional array, the minimum of the flattened array
   * will be calculated. When `dim` is provided, the minimum over the selected
   * dimension will be calculated. Parameter `dim` is zero-based.
   *
   * Syntax:
   *
   *     math.min(a, b, c, ...)
   *     math.min(A)
   *     math.min(A, dim)
   *
   * Examples:
   *
   *     math.min(2, 1, 4, 3)                  // returns 1
   *     math.min([2, 1, 4, 3])                // returns 1
   *
   *     // minimum over a specified dimension (zero-based)
   *     math.min([[2, 5], [4, 3], [1, 7]], 0) // returns [1, 3]
   *     math.min([[2, 5], [4, 3], [1, 7]], 1) // returns [2, 3, 1]
   *
   *     math.max(2.7, 7.1, -4.5, 2.0, 4.1)    // returns 7.1
   *     math.min(2.7, 7.1, -4.5, 2.0, 4.1)    // returns -4.5
   *
   * See also:
   *
   *    mean, median, max, prod, std, sum, variance
   *
   * @param {... *} args  A single matrix or or multiple scalar values
   * @return {*} The minimum value
   */ return typed($02bb6f64048cae79$var$name, {
        // min([a, b, c, d, ...])
        "Array | Matrix": _min,
        // min([a, b, c, d, ...], dim)
        "Array | Matrix, number | BigNumber": function ArrayMatrixNumberBigNumber(array, dim) {
            return (0, $dd57e6221b0e50b6$export$533b26079ad0b4b)(array, dim.valueOf(), _smallest);
        },
        // min(a, b, c, d, ...)
        "...": function _(args) {
            if ((0, $dd57e6221b0e50b6$export$4d8f6a27e2f5bcb2)(args)) throw new TypeError("Scalar values expected in function min");
            return _min(args);
        }
    });
    /**
   * Return the smallest of two values
   * @param {*} x
   * @param {*} y
   * @returns {*} Returns x when x is smallest, or y when y is smallest
   * @private
   */ function _smallest(x, y) {
        try {
            return smaller(x, y) ? x : y;
        } catch (err) {
            throw (0, $b113219b83527e4b$export$c8994973cec629ae)(err, "min", y);
        }
    }
    /**
   * Recursively calculate the minimum value in an n-dimensional array
   * @param {Array} array
   * @return {number} min
   * @private
   */ function _min(array) {
        var min;
        (0, $dd57e6221b0e50b6$export$519ada94592b97fc)(array, function(value) {
            try {
                if (isNaN(value) && typeof value === "number") min = NaN;
                else if (min === undefined || smaller(value, min)) min = value;
            } catch (err) {
                throw (0, $b113219b83527e4b$export$c8994973cec629ae)(err, "min", value);
            }
        });
        if (min === undefined) throw new Error("Cannot calculate min of an empty array");
         // make sure returning numeric value: parse a string into a numeric value
        if (typeof min === "string") min = numeric(min, config.number);
        return min;
    }
});



var $f807d4e52615def4$var$name = "mode";
var $f807d4e52615def4$var$dependencies = [
    "typed",
    "isNaN",
    "isNumeric"
];
var $f807d4e52615def4$export$822530980ba269d9 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($f807d4e52615def4$var$name, $f807d4e52615def4$var$dependencies, (_ref)=>{
    var { typed: typed, isNaN: isNaN, isNumeric: isNumeric } = _ref;
    /**
  * Computes the mode of a set of numbers or a list with values(numbers or characters).
  * If there are more than one modes, it returns a list of those values.
  *
  * Syntax:
  *
  *     math.mode(a, b, c, ...)
  *     math.mode(A)
  *
  * Examples:
  *
  *     math.mode(2, 1, 4, 3, 1)                            // returns [1]
  *     math.mode([1, 2.7, 3.2, 4, 2.7])                    // returns [2.7]
  *     math.mode(1, 4, 6, 1, 6)                             // returns [1, 6]
  *     math.mode('a','a','b','c')                           // returns ["a"]
  *     math.mode(1, 1.5, 'abc')                             // returns [1, 1.5, "abc"]
  *
  * See also:
  *
  *     median,
  *     mean
  *
  * @param {... *} args  A single matrix
  * @return {*} The mode of all values
  */ return typed($f807d4e52615def4$var$name, {
        "Array | Matrix": _mode,
        "...": function _(args) {
            return _mode(args);
        }
    });
    /**
   * Calculates the mode in an 1-dimensional array
   * @param {Array} values
   * @return {Array} mode
   * @private
   */ function _mode(values) {
        values = (0, $a14a10567870d913$export$bffa455ba8c619a6)(values.valueOf());
        var num = values.length;
        if (num === 0) throw new Error("Cannot calculate mode of an empty array");
        var count = {};
        var mode = [];
        var max = 0;
        for(var i = 0; i < values.length; i++){
            var value = values[i];
            if (isNumeric(value) && isNaN(value)) throw new Error("Cannot calculate mode of an array containing NaN values");
            if (!(value in count)) count[value] = 0;
            count[value]++;
            if (count[value] === max) mode.push(value);
            else if (count[value] > max) {
                max = count[value];
                mode = [
                    value
                ];
            }
        }
        return mode;
    }
});


var $45d02e7130a66684$var$name = "nthRoots";
var $45d02e7130a66684$var$dependencies = [
    "config",
    "typed",
    "divideScalar",
    "Complex"
];
var $45d02e7130a66684$export$36e27b45d2aa738c = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($45d02e7130a66684$var$name, $45d02e7130a66684$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, divideScalar: divideScalar, Complex: Complex } = _ref;
    /**
   * Each function here returns a real multiple of i as a Complex value.
   * @param  {number} val
   * @return {Complex} val, i*val, -val or -i*val for index 0, 1, 2, 3
   */ // This is used to fix float artifacts for zero-valued components.
    var _calculateExactResult = [
        function realPos(val) {
            return new Complex(val, 0);
        },
        function imagPos(val) {
            return new Complex(0, val);
        },
        function realNeg(val) {
            return new Complex(-val, 0);
        },
        function imagNeg(val) {
            return new Complex(0, -val);
        }
    ];
    /**
   * Calculate the nth root of a Complex Number a using De Movire's Theorem.
   * @param  {Complex} a
   * @param  {number} root
   * @return {Array} array of n Complex Roots
   */ function _nthComplexRoots(a, root) {
        if (root < 0) throw new Error("Root must be greater than zero");
        if (root === 0) throw new Error("Root must be non-zero");
        if (root % 1 !== 0) throw new Error("Root must be an integer");
        if (a === 0 || a.abs() === 0) return [
            new Complex(0, 0)
        ];
        var aIsNumeric = typeof a === "number";
        var offset; // determine the offset (argument of a)/(pi/2)
        if (aIsNumeric || a.re === 0 || a.im === 0) {
            if (aIsNumeric) offset = 2 * +(a < 0); // numeric value on the real axis
            else if (a.im === 0) offset = 2 * +(a.re < 0); // complex value on the real axis
            else offset = 2 * +(a.im < 0) + 1; // complex value on the imaginary axis
        }
        var arg = a.arg();
        var abs = a.abs();
        var roots = [];
        var r = Math.pow(abs, 1 / root);
        for(var k = 0; k < root; k++){
            var halfPiFactor = (offset + 4 * k) / root;
            /**
       * If (offset + 4*k)/root is an integral multiple of pi/2
       * then we can produce a more exact result.
       */ if (halfPiFactor === Math.round(halfPiFactor)) {
                roots.push(_calculateExactResult[halfPiFactor % 4](r));
                continue;
            }
            roots.push(new Complex({
                r: r,
                phi: (arg + 2 * Math.PI * k) / root
            }));
        }
        return roots;
    }
    /**
   * Calculate the nth roots of a value.
   * An nth root of a positive real number A,
   * is a positive real solution of the equation "x^root = A".
   * This function returns an array of complex values.
   *
   * Syntax:
   *
   *    math.nthRoots(x)
   *    math.nthRoots(x, root)
   *
   * Examples:
   *
   *    math.nthRoots(1)
   *    // returns [
   *    //   {re: 1, im: 0},
   *    //   {re: -1, im: 0}
   *    // ]
   *    nthRoots(1, 3)
   *    // returns [
   *    //   { re: 1, im: 0 },
   *    //   { re: -0.4999999999999998, im: 0.8660254037844387 },
   *    //   { re: -0.5000000000000004, im: -0.8660254037844385 }
   *    ]
   *
   * See also:
   *
   *    nthRoot, pow, sqrt
   *
   * @param {number | BigNumber | Fraction | Complex} x Number to be rounded
   * @return {number | BigNumber | Fraction | Complex}            Rounded value
   */ return typed($45d02e7130a66684$var$name, {
        Complex: function Complex(x) {
            return _nthComplexRoots(x, 2);
        },
        "Complex, number": _nthComplexRoots
    });
});





var $b94aa3a321c12711$var$name = "ones";
var $b94aa3a321c12711$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "BigNumber"
];
var $b94aa3a321c12711$export$f524a435b9c16a90 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($b94aa3a321c12711$var$name, $b94aa3a321c12711$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, BigNumber: BigNumber } = _ref;
    /**
   * Create a matrix filled with ones. The created matrix can have one or
   * multiple dimensions.
   *
   * Syntax:
   *
   *    math.ones(m)
   *    math.ones(m, format)
   *    math.ones(m, n)
   *    math.ones(m, n, format)
   *    math.ones([m, n])
   *    math.ones([m, n], format)
   *    math.ones([m, n, p, ...])
   *    math.ones([m, n, p, ...], format)
   *
   * Examples:
   *
   *    math.ones(3)                   // returns [1, 1, 1]
   *    math.ones(3, 2)                // returns [[1, 1], [1, 1], [1, 1]]
   *    math.ones(3, 2, 'dense')       // returns Dense Matrix [[1, 1], [1, 1], [1, 1]]
   *
   *    const A = [[1, 2, 3], [4, 5, 6]]
   *    math.ones(math.size(A))       // returns [[1, 1, 1], [1, 1, 1]]
   *
   * See also:
   *
   *    zeros, identity, size, range
   *
   * @param {...number | Array} size    The size of each dimension of the matrix
   * @param {string} [format]           The Matrix storage format
   *
   * @return {Array | Matrix | number}  A matrix filled with ones
   */ return typed("ones", {
        "": function _() {
            return config.matrix === "Array" ? _ones([]) : _ones([], "default");
        },
        // math.ones(m, n, p, ..., format)
        // TODO: more accurate signature '...number | BigNumber, string' as soon as typed-function supports this
        "...number | BigNumber | string": function numberBigNumberString(size) {
            var last = size[size.length - 1];
            if (typeof last === "string") {
                var format = size.pop();
                return _ones(size, format);
            } else if (config.matrix === "Array") return _ones(size);
            else return _ones(size, "default");
        },
        Array: _ones,
        Matrix: function Matrix(size) {
            var format = size.storage();
            return _ones(size.valueOf(), format);
        },
        "Array | Matrix, string": function ArrayMatrixString(size, format) {
            return _ones(size.valueOf(), format);
        }
    });
    /**
   * Create an Array or Matrix with ones
   * @param {Array} size
   * @param {string} [format='default']
   * @return {Array | Matrix}
   * @private
   */ function _ones(size, format) {
        var hasBigNumbers = _normalize(size);
        var defaultValue = hasBigNumbers ? new BigNumber(1) : 1;
        _validate(size);
        if (format) {
            // return a matrix
            var m = matrix(format);
            if (size.length > 0) return m.resize(size, defaultValue);
            return m;
        } else {
            // return an Array
            var arr = [];
            if (size.length > 0) return (0, $a14a10567870d913$export$4380c87abf28fdf)(arr, size, defaultValue);
            return arr;
        }
    } // replace BigNumbers with numbers, returns true if size contained BigNumbers
    function _normalize(size) {
        var hasBigNumbers = false;
        size.forEach(function(value, index, arr) {
            if ((0, $d8097b7a6d6e36d8$export$e51d0e7e5c4a03ab)(value)) {
                hasBigNumbers = true;
                arr[index] = value.toNumber();
            }
        });
        return hasBigNumbers;
    } // validate arguments
    function _validate(size) {
        size.forEach(function(value) {
            if (typeof value !== "number" || !(0, $668e051498bf5fa0$export$a287f47fed4544b8)(value) || value < 0) throw new Error("Parameters in function ones must be positive integers");
        });
    }
});




var $30252cc422b2a269$var$name = "partitionSelect";
var $30252cc422b2a269$var$dependencies = [
    "typed",
    "isNumeric",
    "isNaN",
    "compare"
];
var $30252cc422b2a269$export$47c1a746705f5c42 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($30252cc422b2a269$var$name, $30252cc422b2a269$var$dependencies, (_ref)=>{
    var { typed: typed, isNumeric: isNumeric, isNaN: isNaN, compare: compare } = _ref;
    var asc = compare;
    var desc = (a, b)=>-compare(a, b);
    /**
   * Partition-based selection of an array or 1D matrix.
   * Will find the kth smallest value, and mutates the input array.
   * Uses Quickselect.
   *
   * Syntax:
   *
   *    math.partitionSelect(x, k)
   *    math.partitionSelect(x, k, compare)
   *
   * Examples:
   *
   *    math.partitionSelect([5, 10, 1], 2)           // returns 10
   *    math.partitionSelect(['C', 'B', 'A', 'D'], 1) // returns 'B'
   *
   *    function sortByLength (a, b) {
   *      return a.length - b.length
   *    }
   *    math.partitionSelect(['Langdon', 'Tom', 'Sara'], 2, sortByLength) // returns 'Langdon'
   *
   * See also:
   *
   *    sort
   *
   * @param {Matrix | Array} x    A one dimensional matrix or array to sort
   * @param {Number} k            The kth smallest value to be retrieved zero-based index
   * @param {Function | 'asc' | 'desc'} [compare='asc']
   *        An optional comparator function. The function is called as
   *        `compare(a, b)`, and must return 1 when a > b, -1 when a < b,
   *        and 0 when a == b.
   * @return {*} Returns the kth lowest value.
   */ return typed($30252cc422b2a269$var$name, {
        "Array | Matrix, number": function ArrayMatrixNumber(x, k) {
            return _partitionSelect(x, k, asc);
        },
        "Array | Matrix, number, string": function ArrayMatrixNumberString(x, k, compare) {
            if (compare === "asc") return _partitionSelect(x, k, asc);
            else if (compare === "desc") return _partitionSelect(x, k, desc);
            else throw new Error('Compare string must be "asc" or "desc"');
        },
        "Array | Matrix, number, function": _partitionSelect
    });
    function _partitionSelect(x, k, compare) {
        if (!(0, $668e051498bf5fa0$export$a287f47fed4544b8)(k) || k < 0) throw new Error("k must be a non-negative integer");
        if ((0, $d8097b7a6d6e36d8$export$b22160e0a14f87b7)(x)) {
            var size = x.size();
            if (size.length > 1) throw new Error("Only one dimensional matrices supported");
            return quickSelect(x.valueOf(), k, compare);
        }
        if (Array.isArray(x)) return quickSelect(x, k, compare);
    }
    /**
   * Quickselect algorithm.
   * Code adapted from:
   * https://blog.teamleadnet.com/2012/07/quick-select-algorithm-find-kth-element.html
   *
   * @param {Array} arr
   * @param {Number} k
   * @param {Function} compare
   * @private
   */ function quickSelect(arr, k, compare) {
        if (k >= arr.length) throw new Error("k out of bounds");
         // check for NaN values since these can cause an infinite while loop
        for(var i = 0; i < arr.length; i++){
            if (isNumeric(arr[i]) && isNaN(arr[i])) return arr[i]; // return NaN
        }
        var from = 0;
        var to = arr.length - 1; // if from == to we reached the kth element
        while(from < to){
            var r = from;
            var w = to;
            var pivot = arr[Math.floor(Math.random() * (to - from + 1)) + from]; // stop if the reader and writer meets
            while(r < w)// arr[r] >= pivot
            if (compare(arr[r], pivot) >= 0) {
                // put the large values at the end
                var tmp = arr[w];
                arr[w] = arr[r];
                arr[r] = tmp;
                --w;
            } else // the value is smaller than the pivot, skip
            ++r;
             // if we stepped up (r++) we need to step one down (arr[r] > pivot)
            if (compare(arr[r], pivot) > 0) --r;
             // the r pointer is on the end of the first k elements
            if (k <= r) to = r;
            else from = r + 1;
        }
        return arr[k];
    }
});



/**
 * Create a syntax error with the message:
 *     'Wrong number of arguments in function <fn> (<count> provided, <min>-<max> expected)'
 * @param {string} fn     Function name
 * @param {number} count  Actual argument count
 * @param {number} min    Minimum required argument count
 * @param {number} [max]  Maximum required argument count
 * @extends Error
 */ function $b228fd75fce9c1e8$export$f27c2c74ddc37d80(fn, count, min, max) {
    if (!(this instanceof $b228fd75fce9c1e8$export$f27c2c74ddc37d80)) throw new SyntaxError("Constructor must be called with the new operator");
    this.fn = fn;
    this.count = count;
    this.min = min;
    this.max = max;
    this.message = "Wrong number of arguments in function " + fn + " (" + count + " provided, " + min + (max !== undefined && max !== null ? "-" + max : "") + " expected)";
    this.stack = new Error().stack;
}
$b228fd75fce9c1e8$export$f27c2c74ddc37d80.prototype = new Error();
$b228fd75fce9c1e8$export$f27c2c74ddc37d80.prototype.constructor = Error;
$b228fd75fce9c1e8$export$f27c2c74ddc37d80.prototype.name = "ArgumentsError";
$b228fd75fce9c1e8$export$f27c2c74ddc37d80.prototype.isArgumentsError = true;







var $394f7d6546df11c8$var$name = "resize";
var $394f7d6546df11c8$var$dependencies = [
    "config",
    "matrix"
];
var $394f7d6546df11c8$export$58909557046ca413 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($394f7d6546df11c8$var$name, $394f7d6546df11c8$var$dependencies, (_ref)=>{
    var { config: config, matrix: matrix } = _ref;
    /**
   * Resize a matrix
   *
   * Syntax:
   *
   *     math.resize(x, size)
   *     math.resize(x, size, defaultValue)
   *
   * Examples:
   *
   *     math.resize([1, 2, 3, 4, 5], [3]) // returns Array  [1, 2, 3]
   *     math.resize([1, 2, 3], [5], 0)    // returns Array  [1, 2, 3, 0, 0]
   *     math.resize(2, [2, 3], 0)         // returns Matrix [[2, 0, 0], [0, 0, 0]]
   *     math.resize("hello", [8], "!")    // returns string 'hello!!!'
   *
   * See also:
   *
   *     size, squeeze, subset, reshape
   *
   * @param {Array | Matrix | *} x             Matrix to be resized
   * @param {Array | Matrix} size              One dimensional array with numbers
   * @param {number | string} [defaultValue=0] Zero by default, except in
   *                                           case of a string, in that case
   *                                           defaultValue = ' '
   * @return {* | Array | Matrix} A resized clone of matrix `x`
   */ // TODO: rework resize to a typed-function
    return function resize(x, size, defaultValue) {
        if (arguments.length !== 2 && arguments.length !== 3) throw new (0, $b228fd75fce9c1e8$export$f27c2c74ddc37d80)("resize", arguments.length, 2, 3);
        if ((0, $d8097b7a6d6e36d8$export$b22160e0a14f87b7)(size)) size = size.valueOf(); // get Array
        if ((0, $d8097b7a6d6e36d8$export$e51d0e7e5c4a03ab)(size[0])) // convert bignumbers to numbers
        size = size.map(function(value) {
            return !(0, $d8097b7a6d6e36d8$export$e51d0e7e5c4a03ab)(value) ? value : value.toNumber();
        });
         // check x is a Matrix
        if ((0, $d8097b7a6d6e36d8$export$b22160e0a14f87b7)(x)) // use optimized matrix implementation, return copy
        return x.resize(size, defaultValue, true);
        if (typeof x === "string") // resize string
        return _resizeString(x, size, defaultValue);
         // check result should be a matrix
        var asMatrix = Array.isArray(x) ? false : config.matrix !== "Array";
        if (size.length === 0) {
            // output a scalar
            while(Array.isArray(x))x = x[0];
            return (0, $6819694788cbfa38$export$9cd59f9826255e47)(x);
        } else {
            // output an array/matrix
            if (!Array.isArray(x)) x = [
                x
            ];
            x = (0, $6819694788cbfa38$export$9cd59f9826255e47)(x);
            var res = (0, $a14a10567870d913$export$4380c87abf28fdf)(x, size, defaultValue);
            return asMatrix ? matrix(res) : res;
        }
    };
    /**
   * Resize a string
   * @param {string} str
   * @param {number[]} size
   * @param {string} [defaultChar=' ']
   * @private
   */ function _resizeString(str, size, defaultChar) {
        if (defaultChar !== undefined) {
            if (typeof defaultChar !== "string" || defaultChar.length !== 1) throw new TypeError("Single character expected as defaultValue");
        } else defaultChar = " ";
        if (size.length !== 1) throw new (0, $89c7b7a60bca4b11$export$ad1391ca020fdd96)(size.length, 1);
        var len = size[0];
        if (typeof len !== "number" || !(0, $668e051498bf5fa0$export$a287f47fed4544b8)(len)) throw new TypeError("Invalid size, must contain positive integers (size: " + (0, $b94963e97c376b6d$export$d9468344d3651243)(size) + ")");
        if (str.length > len) return str.substring(0, len);
        else if (str.length < len) {
            var res = str;
            for(var i = 0, ii = len - str.length; i < ii; i++)res += defaultChar;
            return res;
        } else return str;
    }
});











var $e9614007ff5a7b5f$var$name = "rightArithShift";
var $e9614007ff5a7b5f$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "zeros",
    "DenseMatrix"
];
var $e9614007ff5a7b5f$export$ef742376390cbf7 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($e9614007ff5a7b5f$var$name, $e9614007ff5a7b5f$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, zeros: zeros, DenseMatrix: DenseMatrix } = _ref;
    var algorithm01 = (0, $87b5a4e357abde7d$export$5e6d55d37a917802)({
        typed: typed
    });
    var algorithm02 = (0, $caf358e9c2d20263$export$92edb534a8f19a37)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm08 = (0, $77f7cfbe3a0de141$export$59a068f853cfbf8)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm10 = (0, $5e80d3fce4071128$export$72a88f2eee9ec1ed)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm11 = (0, $83b92f81e511657d$export$a38279a12199d831)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm13 = (0, $c68b38998aadcc11$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $533d58927c47005f$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Bitwise right arithmetic shift of a value x by y number of bits, `x >> y`.
   * For matrices, the function is evaluated element wise.
   * For units, the function is evaluated on the best prefix base.
   *
   * Syntax:
   *
   *    math.rightArithShift(x, y)
   *
   * Examples:
   *
   *    math.rightArithShift(4, 2)               // returns number 1
   *
   *    math.rightArithShift([16, -32, 64], 4)   // returns Array [1, -2, 3]
   *
   * See also:
   *
   *    bitAnd, bitNot, bitOr, bitXor, rightArithShift, rightLogShift
   *
   * @param  {number | BigNumber | Array | Matrix} x Value to be shifted
   * @param  {number | BigNumber} y Amount of shifts
   * @return {number | BigNumber | Array | Matrix} `x` sign-filled shifted right `y` times
   */ return typed($e9614007ff5a7b5f$var$name, {
        "number, number": (0, $ac33a15c81597bf3$export$b6d96f775be90000),
        "BigNumber, BigNumber": (0, $3b8565a47dc4d809$export$d489c03691bd4cd),
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm08(x, y, this, false);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, this, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm01(x, y, this, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, number | BigNumber": function SparseMatrixNumberBigNumber(x, y) {
            // check scalar
            if (equalScalar(y, 0)) return x.clone();
            return algorithm11(x, y, this, false);
        },
        "DenseMatrix, number | BigNumber": function DenseMatrixNumberBigNumber(x, y) {
            // check scalar
            if (equalScalar(y, 0)) return x.clone();
            return algorithm14(x, y, this, false);
        },
        "number | BigNumber, SparseMatrix": function numberBigNumberSparseMatrix(x, y) {
            // check scalar
            if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
            return algorithm10(y, x, this, true);
        },
        "number | BigNumber, DenseMatrix": function numberBigNumberDenseMatrix(x, y) {
            // check scalar
            if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
            return algorithm14(y, x, this, true);
        },
        "Array, number | BigNumber": function ArrayNumberBigNumber(x, y) {
            // use matrix implementation
            return this(matrix(x), y).valueOf();
        },
        "number | BigNumber, Array": function numberBigNumberArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y)).valueOf();
        }
    });
});







var $e6aaa6da0a785dc8$var$NO_INT = "Number of decimals in function round must be an integer";
var $e6aaa6da0a785dc8$var$name = "round";
var $e6aaa6da0a785dc8$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "zeros",
    "BigNumber",
    "DenseMatrix"
];
var $e6aaa6da0a785dc8$export$c41ddfead54b1fbc = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($e6aaa6da0a785dc8$var$name, $e6aaa6da0a785dc8$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, zeros: zeros, BigNumber: BigNumber, DenseMatrix: DenseMatrix } = _ref;
    var algorithm11 = (0, $83b92f81e511657d$export$a38279a12199d831)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm12 = (0, $500ff63908aabda9$export$806772cd23b603dc)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm14 = (0, $533d58927c47005f$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Round a value towards the nearest integer.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.round(x)
   *    math.round(x, n)
   *
   * Examples:
   *
   *    math.round(3.22)             // returns number 3
   *    math.round(3.82)             // returns number 4
   *    math.round(-4.2)             // returns number -4
   *    math.round(-4.7)             // returns number -5
   *    math.round(3.22, 1)          // returns number 3.2
   *    math.round(3.88, 1)          // returns number 3.9
   *    math.round(-4.21, 1)         // returns number -4.2
   *    math.round(-4.71, 1)         // returns number -4.7
   *    math.round(math.pi, 3)       // returns number 3.142
   *    math.round(123.45678, 2)     // returns number 123.46
   *
   *    const c = math.complex(3.2, -2.7)
   *    math.round(c)                // returns Complex 3 - 3i
   *
   *    math.round([3.2, 3.8, -4.7]) // returns Array [3, 4, -5]
   *
   * See also:
   *
   *    ceil, fix, floor
   *
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix} x  Number to be rounded
   * @param  {number | BigNumber | Array} [n=0]                            Number of decimals
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix} Rounded value
   */ return typed($e6aaa6da0a785dc8$var$name, {
        number: (0, $4b37ed316f05dd33$export$a3992db8dd0fd9e6),
        "number, number": (0, $4b37ed316f05dd33$export$a3992db8dd0fd9e6),
        "number, BigNumber": function numberBigNumber(x, n) {
            if (!n.isInteger()) throw new TypeError($e6aaa6da0a785dc8$var$NO_INT);
            return new BigNumber(x).toDecimalPlaces(n.toNumber());
        },
        Complex: function Complex(x) {
            return x.round();
        },
        "Complex, number": function ComplexNumber(x, n) {
            if (n % 1) throw new TypeError($e6aaa6da0a785dc8$var$NO_INT);
            return x.round(n);
        },
        "Complex, BigNumber": function ComplexBigNumber(x, n) {
            if (!n.isInteger()) throw new TypeError($e6aaa6da0a785dc8$var$NO_INT);
            var _n = n.toNumber();
            return x.round(_n);
        },
        BigNumber: function BigNumber(x) {
            return x.toDecimalPlaces(0);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, n) {
            if (!n.isInteger()) throw new TypeError($e6aaa6da0a785dc8$var$NO_INT);
            return x.toDecimalPlaces(n.toNumber());
        },
        Fraction: function Fraction(x) {
            return x.round();
        },
        "Fraction, number": function FractionNumber(x, n) {
            if (n % 1) throw new TypeError($e6aaa6da0a785dc8$var$NO_INT);
            return x.round(n);
        },
        "Fraction, BigNumber": function FractionBigNumber(x, n) {
            if (!n.isInteger()) throw new TypeError($e6aaa6da0a785dc8$var$NO_INT);
            return x.round(n.toNumber());
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since round(0) = 0
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this, true);
        },
        "SparseMatrix, number | BigNumber": function SparseMatrixNumberBigNumber(x, y) {
            return algorithm11(x, y, this, false);
        },
        "DenseMatrix, number | BigNumber": function DenseMatrixNumberBigNumber(x, y) {
            return algorithm14(x, y, this, false);
        },
        "Array, number | BigNumber": function ArrayNumberBigNumber(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        "number | Complex | BigNumber | Fraction, SparseMatrix": function numberComplexBigNumberFractionSparseMatrix(x, y) {
            // check scalar is zero
            if (equalScalar(x, 0)) // do not execute algorithm, result will be a zero matrix
            return zeros(y.size(), y.storage());
            return algorithm12(y, x, this, true);
        },
        "number | Complex | BigNumber | Fraction, DenseMatrix": function numberComplexBigNumberFractionDenseMatrix(x, y) {
            // check scalar is zero
            if (equalScalar(x, 0)) // do not execute algorithm, result will be a zero matrix
            return zeros(y.size(), y.storage());
            return algorithm14(y, x, this, true);
        },
        "number | Complex | BigNumber | Fraction, Array": function numberComplexBigNumberFractionArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});









var $82571df89f4cff70$var$name = "smallerEq";
var $82571df89f4cff70$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "DenseMatrix"
];
var $82571df89f4cff70$export$e1b2fff975be9083 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($82571df89f4cff70$var$name, $82571df89f4cff70$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, DenseMatrix: DenseMatrix } = _ref;
    var algorithm03 = (0, $523b807a911c3d38$export$486bb900f1a3c833)({
        typed: typed
    });
    var algorithm07 = (0, $5200888766c056e5$export$b908fb77c4366999)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm12 = (0, $500ff63908aabda9$export$806772cd23b603dc)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $c68b38998aadcc11$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $533d58927c47005f$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Test whether value x is smaller or equal to y.
   *
   * The function returns true when x is smaller than y or the relative
   * difference between x and y is smaller than the configured epsilon. The
   * function cannot be used to compare values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.smallerEq(x, y)
   *
   * Examples:
   *
   *    math.smaller(1 + 2, 3)        // returns false
   *    math.smallerEq(1 + 2, 3)      // returns true
   *
   * See also:
   *
   *    equal, unequal, smaller, larger, largerEq, compare
   *
   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} x First value to compare
   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} y Second value to compare
   * @return {boolean | Array | Matrix} Returns true when the x is smaller than y, else returns false
   */ return typed($82571df89f4cff70$var$name, {
        "boolean, boolean": function booleanBoolean(x, y) {
            return x <= y;
        },
        "number, number": function numberNumber(x, y) {
            return x <= y || (0, $668e051498bf5fa0$export$6f3989c6ecc04081)(x, y, config.epsilon);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.lte(y) || (0, $53e0635127e7c5a0$export$6f3989c6ecc04081)(x, y, config.epsilon);
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.compare(y) !== 1;
        },
        "Complex, Complex": function ComplexComplex() {
            throw new TypeError("No ordering relation is defined for complex numbers");
        },
        "Unit, Unit": function UnitUnit(x, y) {
            if (!x.equalBase(y)) throw new Error("Cannot compare units with different base");
            return this(x.value, y.value);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, this);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, this, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, this, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm12(x, y, this, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, this, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, this, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});
var $82571df89f4cff70$export$78c24428429985da = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($82571df89f4cff70$var$name, [
    "typed",
    "config"
], (_ref2)=>{
    var { typed: typed, config: config } = _ref2;
    return typed($82571df89f4cff70$var$name, {
        "number, number": function numberNumber(x, y) {
            return x <= y || (0, $668e051498bf5fa0$export$6f3989c6ecc04081)(x, y, config.epsilon);
        }
    });
});







var $f8fcd935dc196172$var$name = "unequal";
var $f8fcd935dc196172$var$dependencies = [
    "typed",
    "config",
    "equalScalar",
    "matrix",
    "DenseMatrix"
];
var $f8fcd935dc196172$export$833e6c382e279d04 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($f8fcd935dc196172$var$name, $f8fcd935dc196172$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, equalScalar: equalScalar, matrix: matrix, DenseMatrix: DenseMatrix } = _ref;
    var algorithm03 = (0, $523b807a911c3d38$export$486bb900f1a3c833)({
        typed: typed
    });
    var algorithm07 = (0, $5200888766c056e5$export$b908fb77c4366999)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm12 = (0, $500ff63908aabda9$export$806772cd23b603dc)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $c68b38998aadcc11$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $533d58927c47005f$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Test whether two values are unequal.
   *
   * The function tests whether the relative difference between x and y is
   * larger than the configured epsilon. The function cannot be used to compare
   * values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * In case of complex numbers, x.re must unequal y.re, or x.im must unequal y.im.
   * Strings are compared by their numerical value.
   *
   * Values `null` and `undefined` are compared strictly, thus `null` is unequal
   * with everything except `null`, and `undefined` is unequal with everything
   * except `undefined`.
   *
   * Syntax:
   *
   *    math.unequal(x, y)
   *
   * Examples:
   *
   *    math.unequal(2 + 2, 3)       // returns true
   *    math.unequal(2 + 2, 4)       // returns false
   *
   *    const a = math.unit('50 cm')
   *    const b = math.unit('5 m')
   *    math.unequal(a, b)           // returns false
   *
   *    const c = [2, 5, 1]
   *    const d = [2, 7, 1]
   *
   *    math.unequal(c, d)           // returns [false, true, false]
   *    math.deepEqual(c, d)         // returns false
   *
   *    math.unequal(0, null)        // returns true
   * See also:
   *
   *    equal, deepEqual, smaller, smallerEq, larger, largerEq, compare
   *
   * @param  {number | BigNumber | Fraction | boolean | Complex | Unit | string | Array | Matrix | undefined} x First value to compare
   * @param  {number | BigNumber | Fraction | boolean | Complex | Unit | string | Array | Matrix | undefined} y Second value to compare
   * @return {boolean | Array | Matrix} Returns true when the compared values are unequal, else returns false
   */ return typed("unequal", {
        "any, any": function anyAny(x, y) {
            // strict equality for null and undefined?
            if (x === null) return y !== null;
            if (y === null) return x !== null;
            if (x === undefined) return y !== undefined;
            if (y === undefined) return x !== undefined;
            return _unequal(x, y);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, _unequal);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, _unequal, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, _unequal, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, _unequal);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm12(x, y, _unequal, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, _unequal, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, _unequal, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, _unequal, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, _unequal, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, _unequal, true).valueOf();
        }
    });
    function _unequal(x, y) {
        return !equalScalar(x, y);
    }
});
var $f8fcd935dc196172$export$b0b3dad01e54080b = (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($f8fcd935dc196172$var$name, [
    "typed",
    "equalScalar"
], (_ref2)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref2;
    return typed($f8fcd935dc196172$var$name, {
        "any, any": function anyAny(x, y) {
            // strict equality for null and undefined?
            if (x === null) return y !== null;
            if (y === null) return x !== null;
            if (x === undefined) return y !== undefined;
            if (y === undefined) return x !== undefined;
            return !equalScalar(x, y);
        }
    });
});



var $707c0b6af4f4a7e5$var$name = "usolve";
var $707c0b6af4f4a7e5$var$dependencies = [
    "typed",
    "matrix",
    "divideScalar",
    "multiplyScalar",
    "subtract",
    "equalScalar",
    "DenseMatrix"
];
var $707c0b6af4f4a7e5$export$f652f5e8e3e838da = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($707c0b6af4f4a7e5$var$name, $707c0b6af4f4a7e5$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, divideScalar: divideScalar, multiplyScalar: multiplyScalar, subtract: subtract, equalScalar: equalScalar, DenseMatrix: DenseMatrix } = _ref;
    var solveValidation = (0, $5b483e7b4659dfae$export$6accbcba5dda801d)({
        DenseMatrix: DenseMatrix
    });
    /**
   * Finds one solution of a linear equation system by backward substitution. Matrix must be an upper triangular matrix. Throws an error if there's no solution.
   *
   * `U * x = b`
   *
   * Syntax:
   *
   *    math.usolve(U, b)
   *
   * Examples:
   *
   *    const a = [[-2, 3], [2, 1]]
   *    const b = [11, 9]
   *    const x = usolve(a, b)  // [[8], [9]]
   *
   * See also:
   *
   *    usolveAll, lup, slu, usolve, lusolve
   *
   * @param {Matrix, Array} U       A N x N matrix or array (U)
   * @param {Matrix, Array} b       A column vector with the b values
   *
   * @return {DenseMatrix | Array}  A column vector with the linear system solution (x)
   */ return typed($707c0b6af4f4a7e5$var$name, {
        "SparseMatrix, Array | Matrix": function SparseMatrixArrayMatrix(m, b) {
            return _sparseBackwardSubstitution(m, b);
        },
        "DenseMatrix, Array | Matrix": function DenseMatrixArrayMatrix(m, b) {
            return _denseBackwardSubstitution(m, b);
        },
        "Array, Array | Matrix": function ArrayArrayMatrix(a, b) {
            var m = matrix(a);
            var r = _denseBackwardSubstitution(m, b);
            return r.valueOf();
        }
    });
    function _denseBackwardSubstitution(m, b) {
        // make b into a column vector
        b = solveValidation(m, b, true);
        var bdata = b._data;
        var rows = m._size[0];
        var columns = m._size[1]; // result
        var x = [];
        var mdata = m._data; // loop columns backwards
        for(var j = columns - 1; j >= 0; j--){
            // b[j]
            var bj = bdata[j][0] || 0; // x[j]
            var xj = void 0;
            if (!equalScalar(bj, 0)) {
                // value at [j, j]
                var vjj = mdata[j][j];
                if (equalScalar(vjj, 0)) // system cannot be solved
                throw new Error("Linear system cannot be solved since matrix is singular");
                xj = divideScalar(bj, vjj); // loop rows
                for(var i = j - 1; i >= 0; i--)// update copy of b
                bdata[i] = [
                    subtract(bdata[i][0] || 0, multiplyScalar(xj, mdata[i][j]))
                ];
            } else // zero value at j
            xj = 0;
             // update x
            x[j] = [
                xj
            ];
        }
        return new DenseMatrix({
            data: x,
            size: [
                rows,
                1
            ]
        });
    }
    function _sparseBackwardSubstitution(m, b) {
        // make b into a column vector
        b = solveValidation(m, b, true);
        var bdata = b._data;
        var rows = m._size[0];
        var columns = m._size[1];
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr; // result
        var x = []; // loop columns backwards
        for(var j = columns - 1; j >= 0; j--){
            var bj = bdata[j][0] || 0;
            if (!equalScalar(bj, 0)) {
                // non-degenerate row, find solution
                var vjj = 0; // upper triangular matrix values & index (column j)
                var jValues = [];
                var jIndices = []; // first & last indeces in column
                var firstIndex = ptr[j];
                var lastIndex = ptr[j + 1]; // values in column, find value at [j, j], loop backwards
                for(var k = lastIndex - 1; k >= firstIndex; k--){
                    var i = index[k]; // check row (rows are not sorted!)
                    if (i === j) vjj = values[k];
                    else if (i < j) {
                        // store upper triangular
                        jValues.push(values[k]);
                        jIndices.push(i);
                    }
                } // at this point we must have a value in vjj
                if (equalScalar(vjj, 0)) throw new Error("Linear system cannot be solved since matrix is singular");
                var xj = divideScalar(bj, vjj);
                for(var _k = 0, _lastIndex = jIndices.length; _k < _lastIndex; _k++){
                    var _i = jIndices[_k];
                    bdata[_i] = [
                        subtract(bdata[_i][0], multiplyScalar(xj, jValues[_k]))
                    ];
                }
                x[j] = [
                    xj
                ];
            } else // degenerate row, we can choose any value
            x[j] = [
                0
            ];
        }
        return new DenseMatrix({
            data: x,
            size: [
                rows,
                1
            ]
        });
    }
});








var $655c8c9f11045b0d$var$name = "xor";
var $655c8c9f11045b0d$var$dependencies = [
    "typed",
    "matrix",
    "DenseMatrix"
];
var $655c8c9f11045b0d$export$a2b8cab2c7385f0e = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($655c8c9f11045b0d$var$name, $655c8c9f11045b0d$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, DenseMatrix: DenseMatrix } = _ref;
    var algorithm03 = (0, $523b807a911c3d38$export$486bb900f1a3c833)({
        typed: typed
    });
    var algorithm07 = (0, $5200888766c056e5$export$b908fb77c4366999)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm12 = (0, $500ff63908aabda9$export$806772cd23b603dc)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $c68b38998aadcc11$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $533d58927c47005f$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Logical `xor`. Test whether one and only one value is defined with a nonzero/nonempty value.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.xor(x, y)
   *
   * Examples:
   *
   *    math.xor(2, 4)   // returns false
   *
   *    a = [2, 0, 0]
   *    b = [2, 7, 0]
   *    c = 0
   *
   *    math.xor(a, b)   // returns [false, true, false]
   *    math.xor(a, c)   // returns [true, false, false]
   *
   * See also:
   *
   *    and, not, or
   *
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} x First value to check
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} y Second value to check
   * @return {boolean | Array | Matrix}
   *            Returns true when one and only one input is defined with a nonzero/nonempty value.
   */ return typed($655c8c9f11045b0d$var$name, {
        "number, number": (0, $e69afcd9e58cec61$export$17cc7dc3a74df3af),
        "Complex, Complex": function ComplexComplex(x, y) {
            return (x.re !== 0 || x.im !== 0) !== (y.re !== 0 || y.im !== 0);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return (!x.isZero() && !x.isNaN()) !== (!y.isZero() && !y.isNaN());
        },
        "Unit, Unit": function UnitUnit(x, y) {
            return this(x.value || 0, y.value || 0);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, this);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, this, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, this, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm12(x, y, this, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, this, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, this, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});








var $3130c6bb84cb9430$var$name = "add";
var $3130c6bb84cb9430$var$dependencies = [
    "typed",
    "matrix",
    "addScalar",
    "equalScalar",
    "DenseMatrix",
    "SparseMatrix"
];
var $3130c6bb84cb9430$export$c6b51545da64d82f = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($3130c6bb84cb9430$var$name, $3130c6bb84cb9430$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, addScalar: addScalar, equalScalar: equalScalar, DenseMatrix: DenseMatrix, SparseMatrix: SparseMatrix } = _ref;
    var algorithm01 = (0, $87b5a4e357abde7d$export$5e6d55d37a917802)({
        typed: typed
    });
    var algorithm04 = (0, $a82cb0c9b14aa1c6$export$898ea3bef50d41b7)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm10 = (0, $5e80d3fce4071128$export$72a88f2eee9ec1ed)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $c68b38998aadcc11$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $533d58927c47005f$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Add two or more values, `x + y`.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.add(x, y)
   *    math.add(x, y, z, ...)
   *
   * Examples:
   *
   *    math.add(2, 3)               // returns number 5
   *    math.add(2, 3, 4)            // returns number 9
   *
   *    const a = math.complex(2, 3)
   *    const b = math.complex(-4, 1)
   *    math.add(a, b)               // returns Complex -2 + 4i
   *
   *    math.add([1, 2, 3], 4)       // returns Array [5, 6, 7]
   *
   *    const c = math.unit('5 cm')
   *    const d = math.unit('2.1 mm')
   *    math.add(c, d)               // returns Unit 52.1 mm
   *
   *    math.add("2.3", "4")         // returns number 6.3
   *
   * See also:
   *
   *    subtract, sum
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x First value to add
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Second value to add
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} Sum of `x` and `y`
   */ return typed($3130c6bb84cb9430$var$name, (0, $6819694788cbfa38$export$8b58be045bf06082)({
        // we extend the signatures of addScalar with signatures dealing with matrices
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, addScalar);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm01(x, y, addScalar, false);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm01(y, x, addScalar, true);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm04(x, y, addScalar);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, addScalar, false);
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm10(x, y, addScalar, false);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, addScalar, true);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm10(y, x, addScalar, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, addScalar, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, addScalar, true).valueOf();
        },
        "any, any": addScalar,
        "any, any, ...any": function anyAnyAny(x, y, rest) {
            var result = this(x, y);
            for(var i = 0; i < rest.length; i++)result = this(result, rest[i]);
            return result;
        }
    }, addScalar.signatures));
});






var $fb5028d7a5e916f4$var$name = "algorithm09";
var $fb5028d7a5e916f4$var$dependencies = [
    "typed",
    "equalScalar"
];
var $fb5028d7a5e916f4$export$c769437575b0fcdd = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($fb5028d7a5e916f4$var$name, $fb5028d7a5e916f4$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar } = _ref;
    /**
   * Iterates over SparseMatrix A and invokes the callback function f(Aij, Bij).
   * Callback function invoked NZA times, number of nonzero elements in A.
   *
   *
   *          ┌  f(Aij, Bij)  ; A(i,j) !== 0
   * C(i,j) = ┤
   *          └  0            ; otherwise
   *
   *
   * @param {Matrix}   a                 The SparseMatrix instance (A)
   * @param {Matrix}   b                 The SparseMatrix instance (B)
   * @param {Function} callback          The f(Aij,Bij) operation to invoke
   *
   * @return {Matrix}                    SparseMatrix (C)
   *
   * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
   */ return function algorithm09(a, b, callback) {
        // sparse matrix arrays
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var asize = a._size;
        var adt = a._datatype; // sparse matrix arrays
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr;
        var bsize = b._size;
        var bdt = b._datatype; // validate dimensions
        if (asize.length !== bsize.length) throw new (0, $89c7b7a60bca4b11$export$ad1391ca020fdd96)(asize.length, bsize.length);
         // check rows & columns
        if (asize[0] !== bsize[0] || asize[1] !== bsize[1]) throw new RangeError("Dimension mismatch. Matrix A (" + asize + ") must match Matrix B (" + bsize + ")");
         // rows & columns
        var rows = asize[0];
        var columns = asize[1]; // datatype
        var dt; // equal signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // callback signature to use
        var cf = callback; // process data types
        if (typeof adt === "string" && adt === bdt) {
            // datatype
            dt = adt; // find signature that matches (dt, dt)
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt); // callback
            cf = typed.find(callback, [
                dt,
                dt
            ]);
        } // result arrays
        var cvalues = avalues && bvalues ? [] : undefined;
        var cindex = [];
        var cptr = []; // workspaces
        var x = cvalues ? [] : undefined; // marks indicating we have a value in x for a given column
        var w = []; // vars
        var i, j, k, k0, k1; // loop columns
        for(j = 0; j < columns; j++){
            // update cptr
            cptr[j] = cindex.length; // column mark
            var mark = j + 1; // check we need to process values
            if (x) // loop B(:,j)
            for(k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++){
                // row
                i = bindex[k]; // update workspace
                w[i] = mark;
                x[i] = bvalues[k];
            }
             // loop A(:,j)
            for(k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++){
                // row
                i = aindex[k]; // check we need to process values
                if (x) {
                    // b value @ i,j
                    var vb = w[i] === mark ? x[i] : zero; // invoke f
                    var vc = cf(avalues[k], vb); // check zero value
                    if (!eq(vc, zero)) {
                        // push index
                        cindex.push(i); // push value
                        cvalues.push(vc);
                    }
                } else // push index
                cindex.push(i);
            }
        } // update cptr
        cptr[columns] = cindex.length; // return sparse matrix
        return a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                rows,
                columns
            ],
            datatype: dt
        });
    };
});






var $5875922bf5468e3f$var$name = "atan2";
var $5875922bf5468e3f$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "BigNumber",
    "DenseMatrix"
];
var $5875922bf5468e3f$export$c56716e11a38354e = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($5875922bf5468e3f$var$name, $5875922bf5468e3f$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, BigNumber: BigNumber, DenseMatrix: DenseMatrix } = _ref;
    var algorithm02 = (0, $caf358e9c2d20263$export$92edb534a8f19a37)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm03 = (0, $523b807a911c3d38$export$486bb900f1a3c833)({
        typed: typed
    });
    var algorithm09 = (0, $fb5028d7a5e916f4$export$c769437575b0fcdd)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm11 = (0, $83b92f81e511657d$export$a38279a12199d831)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm12 = (0, $500ff63908aabda9$export$806772cd23b603dc)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $c68b38998aadcc11$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $533d58927c47005f$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Calculate the inverse tangent function with two arguments, y/x.
   * By providing two arguments, the right quadrant of the computed angle can be
   * determined.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.atan2(y, x)
   *
   * Examples:
   *
   *    math.atan2(2, 2) / math.pi       // returns number 0.25
   *
   *    const angle = math.unit(60, 'deg') // returns Unit 60 deg
   *    const x = math.cos(angle)
   *    const y = math.sin(angle)
   *
   *    math.atan(2)             // returns Complex 1.5707963267948966 -1.3169578969248166 i
   *
   * See also:
   *
   *    tan, atan, sin, cos
   *
   * @param {number | Array | Matrix} y  Second dimension
   * @param {number | Array | Matrix} x  First dimension
   * @return {number | Array | Matrix} Four-quadrant inverse tangent
   */ return typed($5875922bf5468e3f$var$name, {
        "number, number": Math.atan2,
        // Complex numbers doesn't seem to have a reasonable implementation of
        // atan2(). Even Matlab removed the support, after they only calculated
        // the atan only on base of the real part of the numbers and ignored the imaginary.
        "BigNumber, BigNumber": function BigNumberBigNumber(y, x) {
            return BigNumber.atan2(y, x);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm09(x, y, this, false);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            // mind the order of y and x!
            return algorithm02(y, x, this, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, this, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        "Array, Array": function ArrayArray(x, y) {
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            return this(x, matrix(y));
        },
        "SparseMatrix, number | BigNumber": function SparseMatrixNumberBigNumber(x, y) {
            return algorithm11(x, y, this, false);
        },
        "DenseMatrix, number | BigNumber": function DenseMatrixNumberBigNumber(x, y) {
            return algorithm14(x, y, this, false);
        },
        "number | BigNumber, SparseMatrix": function numberBigNumberSparseMatrix(x, y) {
            // mind the order of y and x
            return algorithm12(y, x, this, true);
        },
        "number | BigNumber, DenseMatrix": function numberBigNumberDenseMatrix(x, y) {
            // mind the order of y and x
            return algorithm14(y, x, this, true);
        },
        "Array, number | BigNumber": function ArrayNumberBigNumber(x, y) {
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        "number | BigNumber, Array": function numberBigNumberArray(x, y) {
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});









var $1c7a232991ab04d4$var$name = "bitOr";
var $1c7a232991ab04d4$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "DenseMatrix"
];
var $1c7a232991ab04d4$export$f45a7846535e9b07 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($1c7a232991ab04d4$var$name, $1c7a232991ab04d4$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, DenseMatrix: DenseMatrix } = _ref;
    var algorithm01 = (0, $87b5a4e357abde7d$export$5e6d55d37a917802)({
        typed: typed
    });
    var algorithm04 = (0, $a82cb0c9b14aa1c6$export$898ea3bef50d41b7)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm10 = (0, $5e80d3fce4071128$export$72a88f2eee9ec1ed)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $c68b38998aadcc11$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $533d58927c47005f$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Bitwise OR two values, `x | y`.
   * For matrices, the function is evaluated element wise.
   * For units, the function is evaluated on the lowest print base.
   *
   * Syntax:
   *
   *    math.bitOr(x, y)
   *
   * Examples:
   *
   *    math.bitOr(1, 2)               // returns number 3
   *
   *    math.bitOr([1, 2, 3], 4)       // returns Array [5, 6, 7]
   *
   * See also:
   *
   *    bitAnd, bitNot, bitXor, leftShift, rightArithShift, rightLogShift
   *
   * @param  {number | BigNumber | Array | Matrix} x First value to or
   * @param  {number | BigNumber | Array | Matrix} y Second value to or
   * @return {number | BigNumber | Array | Matrix} OR of `x` and `y`
   */ return typed($1c7a232991ab04d4$var$name, {
        "number, number": (0, $ac33a15c81597bf3$export$9aecb772cb5ad1c7),
        "BigNumber, BigNumber": (0, $3b8565a47dc4d809$export$e43ec6c4cff46d2c),
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm04(x, y, this);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm01(y, x, this, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm01(x, y, this, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm10(x, y, this, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, this, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm10(y, x, this, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});


var $3c361448103bf479$var$name = "catalan";
var $3c361448103bf479$var$dependencies = [
    "typed",
    "addScalar",
    "divideScalar",
    "multiplyScalar",
    "combinations",
    "isNegative",
    "isInteger"
];
var $3c361448103bf479$export$5a3f7692f3d4dd50 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($3c361448103bf479$var$name, $3c361448103bf479$var$dependencies, (_ref)=>{
    var { typed: typed, addScalar: addScalar, divideScalar: divideScalar, multiplyScalar: multiplyScalar, combinations: combinations, isNegative: isNegative, isInteger: isInteger } = _ref;
    /**
   * The Catalan Numbers enumerate combinatorial structures of many different types.
   * catalan only takes integer arguments.
   * The following condition must be enforced: n >= 0
   *
   * Syntax:
   *
   *   math.catalan(n)
   *
   * Examples:
   *
   *    math.catalan(3) // returns 5
   *    math.catalan(8) // returns 1430
   *
   * See also:
   *
   *    bellNumbers
   *
   * @param {Number | BigNumber} n    nth Catalan number
   * @return {Number | BigNumber}     Cn(n)
   */ return typed($3c361448103bf479$var$name, {
        "number | BigNumber": function numberBigNumber(n) {
            if (!isInteger(n) || isNegative(n)) throw new TypeError("Non-negative integer value expected in function catalan");
            return divideScalar(combinations(multiplyScalar(n, 2), n), addScalar(n, 1));
        }
    });
});

var $96046186d0a5bc18$exports = {};
/*
 * Natural Sort algorithm for Javascript - Version 0.7 - Released under MIT license
 * Author: Jim Palmer (based on chunking idea from Dave Koelle)
 */ /*jshint unused:false */ $96046186d0a5bc18$exports = function naturalSort(a, b) {
    "use strict";
    var re = /(^([+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?)?$|^0x[0-9a-f]+$|\d+)/gi, sre = /(^[ ]*|[ ]*$)/g, dre = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/, hre = /^0x[0-9a-f]+$/i, ore = /^0/, i = function(s) {
        return naturalSort.insensitive && ("" + s).toLowerCase() || "" + s;
    }, // convert all to strings strip whitespace
    x = i(a).replace(sre, "") || "", y = i(b).replace(sre, "") || "", // chunk/tokenize
    xN = x.replace(re, "\x00$1\x00").replace(/\0$/, "").replace(/^\0/, "").split("\x00"), yN = y.replace(re, "\x00$1\x00").replace(/\0$/, "").replace(/^\0/, "").split("\x00"), // numeric, hex or date detection
    xD = parseInt(x.match(hre), 16) || xN.length !== 1 && x.match(dre) && Date.parse(x), yD = parseInt(y.match(hre), 16) || xD && y.match(dre) && Date.parse(y) || null, oFxNcL, oFyNcL;
    // first try and sort Hex codes or Dates
    if (yD) {
        if (xD < yD) return -1;
        else if (xD > yD) return 1;
    }
    // natural sorting through split numeric strings and default strings
    for(var cLoc = 0, numS = Math.max(xN.length, yN.length); cLoc < numS; cLoc++){
        // find floats not starting with '0', string or 0 if not defined (Clint Priest)
        oFxNcL = !(xN[cLoc] || "").match(ore) && parseFloat(xN[cLoc]) || xN[cLoc] || 0;
        oFyNcL = !(yN[cLoc] || "").match(ore) && parseFloat(yN[cLoc]) || yN[cLoc] || 0;
        // handle numeric vs string comparison - number < string - (Kyle Adams)
        if (isNaN(oFxNcL) !== isNaN(oFyNcL)) return isNaN(oFxNcL) ? 1 : -1;
        else if (typeof oFxNcL !== typeof oFyNcL) {
            oFxNcL += "";
            oFyNcL += "";
        }
        if (oFxNcL < oFyNcL) return -1;
        if (oFxNcL > oFyNcL) return 1;
    }
    return 0;
};




var $a2acd1552e59b5cf$var$name = "compareNatural";
var $a2acd1552e59b5cf$var$dependencies = [
    "typed",
    "compare"
];
var $a2acd1552e59b5cf$export$ac9dd39e43534605 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($a2acd1552e59b5cf$var$name, $a2acd1552e59b5cf$var$dependencies, (_ref)=>{
    var { typed: typed, compare: compare } = _ref;
    var compareBooleans = compare.signatures["boolean,boolean"];
    /**
   * Compare two values of any type in a deterministic, natural way.
   *
   * For numeric values, the function works the same as `math.compare`.
   * For types of values that can't be compared mathematically,
   * the function compares in a natural way.
   *
   * For numeric values, x and y are considered equal when the relative
   * difference between x and y is smaller than the configured epsilon.
   * The function cannot be used to compare values smaller than
   * approximately 2.22e-16.
   *
   * For Complex numbers, first the real parts are compared. If equal,
   * the imaginary parts are compared.
   *
   * Strings are compared with a natural sorting algorithm, which
   * orders strings in a "logic" way following some heuristics.
   * This differs from the function `compare`, which converts the string
   * into a numeric value and compares that. The function `compareText`
   * on the other hand compares text lexically.
   *
   * Arrays and Matrices are compared value by value until there is an
   * unequal pair of values encountered. Objects are compared by sorted
   * keys until the keys or their values are unequal.
   *
   * Syntax:
   *
   *    math.compareNatural(x, y)
   *
   * Examples:
   *
   *    math.compareNatural(6, 1)              // returns 1
   *    math.compareNatural(2, 3)              // returns -1
   *    math.compareNatural(7, 7)              // returns 0
   *
   *    math.compareNatural('10', '2')         // returns 1
   *    math.compareText('10', '2')            // returns -1
   *    math.compare('10', '2')                // returns 1
   *
   *    math.compareNatural('Answer: 10', 'Answer: 2') // returns 1
   *    math.compareText('Answer: 10', 'Answer: 2')    // returns -1
   *    math.compare('Answer: 10', 'Answer: 2')
   *        // Error: Cannot convert "Answer: 10" to a number
   *
   *    const a = math.unit('5 cm')
   *    const b = math.unit('40 mm')
   *    math.compareNatural(a, b)              // returns 1
   *
   *    const c = math.complex('2 + 3i')
   *    const d = math.complex('2 + 4i')
   *    math.compareNatural(c, d)              // returns -1
   *
   *    math.compareNatural([1, 2, 4], [1, 2, 3]) // returns 1
   *    math.compareNatural([1, 2, 3], [1, 2])    // returns 1
   *    math.compareNatural([1, 5], [1, 2, 3])    // returns 1
   *    math.compareNatural([1, 2], [1, 2])       // returns 0
   *
   *    math.compareNatural({a: 2}, {a: 4})       // returns -1
   *
   * See also:
   *
   *    compare, compareText
   *
   * @param  {*} x First value to compare
   * @param  {*} y Second value to compare
   * @return {number} Returns the result of the comparison:
   *                  1 when x > y, -1 when x < y, and 0 when x == y.
   */ return typed($a2acd1552e59b5cf$var$name, {
        "any, any": function anyAny(x, y) {
            var typeX = (0, $d8097b7a6d6e36d8$export$f5bbd400c2f4426f)(x);
            var typeY = (0, $d8097b7a6d6e36d8$export$f5bbd400c2f4426f)(y);
            var c; // numeric types
            if ((typeX === "number" || typeX === "BigNumber" || typeX === "Fraction") && (typeY === "number" || typeY === "BigNumber" || typeY === "Fraction")) {
                c = compare(x, y);
                if (c.toString() !== "0") // c can be number, BigNumber, or Fraction
                return c > 0 ? 1 : -1; // return a number
                else return (0, (/*@__PURE__*/$parcel$interopDefault($96046186d0a5bc18$exports)))(typeX, typeY);
            } // matrix types
            if (typeX === "Array" || typeX === "Matrix" || typeY === "Array" || typeY === "Matrix") {
                c = compareMatricesAndArrays(this, x, y);
                if (c !== 0) return c;
                else return (0, (/*@__PURE__*/$parcel$interopDefault($96046186d0a5bc18$exports)))(typeX, typeY);
            } // in case of different types, order by name of type, i.e. 'BigNumber' < 'Complex'
            if (typeX !== typeY) return (0, (/*@__PURE__*/$parcel$interopDefault($96046186d0a5bc18$exports)))(typeX, typeY);
            if (typeX === "Complex") return $a2acd1552e59b5cf$var$compareComplexNumbers(x, y);
            if (typeX === "Unit") {
                if (x.equalBase(y)) return this(x.value, y.value);
                 // compare by units
                return compareArrays(this, x.formatUnits(), y.formatUnits());
            }
            if (typeX === "boolean") return compareBooleans(x, y);
            if (typeX === "string") return (0, (/*@__PURE__*/$parcel$interopDefault($96046186d0a5bc18$exports)))(x, y);
            if (typeX === "Object") return compareObjects(this, x, y);
            if (typeX === "null") return 0;
            if (typeX === "undefined") return 0;
             // this should not occur...
            throw new TypeError('Unsupported type of value "' + typeX + '"');
        }
    });
    /**
   * Compare mixed matrix/array types, by converting to same-shaped array.
   * This comparator is non-deterministic regarding input types.
   * @param {Array | SparseMatrix | DenseMatrix | *} x
   * @param {Array | SparseMatrix | DenseMatrix | *} y
   * @returns {number} Returns the comparison result: -1, 0, or 1
   */ function compareMatricesAndArrays(compareNatural, x, y) {
        if ((0, $d8097b7a6d6e36d8$export$d508368d4da3c38a)(x) && (0, $d8097b7a6d6e36d8$export$d508368d4da3c38a)(y)) return compareArrays(compareNatural, x.toJSON().values, y.toJSON().values);
        if ((0, $d8097b7a6d6e36d8$export$d508368d4da3c38a)(x)) // note: convert to array is expensive
        return compareMatricesAndArrays(compareNatural, x.toArray(), y);
        if ((0, $d8097b7a6d6e36d8$export$d508368d4da3c38a)(y)) // note: convert to array is expensive
        return compareMatricesAndArrays(compareNatural, x, y.toArray());
         // convert DenseArray into Array
        if ((0, $d8097b7a6d6e36d8$export$eb44495df7ba11d)(x)) return compareMatricesAndArrays(compareNatural, x.toJSON().data, y);
        if ((0, $d8097b7a6d6e36d8$export$eb44495df7ba11d)(y)) return compareMatricesAndArrays(compareNatural, x, y.toJSON().data);
         // convert scalars to array
        if (!Array.isArray(x)) return compareMatricesAndArrays(compareNatural, [
            x
        ], y);
        if (!Array.isArray(y)) return compareMatricesAndArrays(compareNatural, x, [
            y
        ]);
        return compareArrays(compareNatural, x, y);
    }
    /**
   * Compare two Arrays
   *
   * - First, compares value by value
   * - Next, if all corresponding values are equal,
   *   look at the length: longest array will be considered largest
   *
   * @param {Array} x
   * @param {Array} y
   * @returns {number} Returns the comparison result: -1, 0, or 1
   */ function compareArrays(compareNatural, x, y) {
        // compare each value
        for(var i = 0, ii = Math.min(x.length, y.length); i < ii; i++){
            var v = compareNatural(x[i], y[i]);
            if (v !== 0) return v;
        } // compare the size of the arrays
        if (x.length > y.length) return 1;
        if (x.length < y.length) return -1;
         // both Arrays have equal size and content
        return 0;
    }
    /**
   * Compare two objects
   *
   * - First, compare sorted property names
   * - Next, compare the property values
   *
   * @param {Object} x
   * @param {Object} y
   * @returns {number} Returns the comparison result: -1, 0, or 1
   */ function compareObjects(compareNatural, x, y) {
        var keysX = Object.keys(x);
        var keysY = Object.keys(y); // compare keys
        keysX.sort((0, (/*@__PURE__*/$parcel$interopDefault($96046186d0a5bc18$exports))));
        keysY.sort((0, (/*@__PURE__*/$parcel$interopDefault($96046186d0a5bc18$exports))));
        var c = compareArrays(compareNatural, keysX, keysY);
        if (c !== 0) return c;
         // compare values
        for(var i = 0; i < keysX.length; i++){
            var v = compareNatural(x[keysX[i]], y[keysY[i]]);
            if (v !== 0) return v;
        }
        return 0;
    }
});
/**
 * Compare two complex numbers, `x` and `y`:
 *
 * - First, compare the real values of `x` and `y`
 * - If equal, compare the imaginary values of `x` and `y`
 *
 * @params {Complex} x
 * @params {Complex} y
 * @returns {number} Returns the comparison result: -1, 0, or 1
 */ function $a2acd1552e59b5cf$var$compareComplexNumbers(x, y) {
    if (x.re > y.re) return 1;
    if (x.re < y.re) return -1;
    if (x.im > y.im) return 1;
    if (x.im < y.im) return -1;
    return 0;
}







var $95fb3695e64d410c$var$name = "cumsum";
var $95fb3695e64d410c$var$dependencies = [
    "typed",
    "add",
    "unaryPlus"
];
var $95fb3695e64d410c$export$e11ffe2ce577c262 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($95fb3695e64d410c$var$name, $95fb3695e64d410c$var$dependencies, (_ref)=>{
    var { typed: typed, add: add, unaryPlus: unaryPlus } = _ref;
    /**
   * Compute the cumulative sum of a matrix or a list with values.
   * In case of a (multi dimensional) array or matrix, the cumulative sums
   * along a specified dimension (defaulting to the first) will be calculated.
   *
   * Syntax:
   *
   *     math.cumsum(a, b, c, ...)
   *     math.cumsum(A)
   *
   * Examples:
   *
   *     math.cumsum(2, 1, 4, 3)               // returns [2, 3, 7, 10]
   *     math.cumsum([2, 1, 4, 3])             // returns [2, 3, 7, 10]
   *     math.cumsum([[1, 2], [3, 4]])         // returns [[1, 2], [4, 6]]
   *     math.cumsum([[1, 2], [3, 4]], 0)      // returns [[1, 2], [4, 6]]
   *     math.cumsum([[1, 2], [3, 4]], 1)      // returns [[1, 3], [3, 7]]
   *     math.cumsum([[2, 5], [4, 3], [1, 7]]) // returns [[2, 5], [6, 8], [7, 15]]
   *
   * See also:
   *
   *    mean, median, min, max, prod, std, variance, sum
   *
   * @param {... *} args  A single matrix or or multiple scalar values
   * @return {*} The cumulative sum of all values
   */ return typed($95fb3695e64d410c$var$name, {
        // sum([a, b, c, d, ...])
        Array: _cumsum,
        Matrix: function Matrix(matrix) {
            return matrix.create(_cumsum(matrix.valueOf()));
        },
        // sum([a, b, c, d, ...], dim)
        "Array, number | BigNumber": _ncumSumDim,
        "Matrix, number | BigNumber": function MatrixNumberBigNumber(matrix, dim) {
            return matrix.create(_ncumSumDim(matrix.valueOf(), dim));
        },
        // cumsum(a, b, c, d, ...)
        "...": function _(args) {
            if ((0, $dd57e6221b0e50b6$export$4d8f6a27e2f5bcb2)(args)) throw new TypeError("All values expected to be scalar in function cumsum");
            return _cumsum(args);
        }
    });
    /**
     * Recursively calculate the cumulative sum of an n-dimensional array
     * @param {Array} array
     * @return {number} cumsum
     * @private
     */ function _cumsum(array) {
        try {
            return _cumsummap(array);
        } catch (err) {
            throw (0, $b113219b83527e4b$export$c8994973cec629ae)(err, $95fb3695e64d410c$var$name);
        }
    }
    function _cumsummap(array) {
        if (array.length === 0) return [];
        var sums = [
            unaryPlus(array[0])
        ]; // unaryPlus converts to number if need be
        for(var i = 1; i < array.length; ++i)// Must use add below and not addScalar for the case of summing a
        // 2+-dimensional array along the 0th dimension (the row vectors,
        // or higher-d analogues, are literally added to each other).
        sums.push(add(sums[i - 1], array[i]));
        return sums;
    }
    function _ncumSumDim(array, dim) {
        var size = (0, $a14a10567870d913$export$51ffaee4afb683a5)(array);
        if (dim < 0 || dim >= size.length) // TODO: would be more clear when throwing a DimensionError here
        throw new (0, $5f2abd91081f798a$export$efa5eacb1304c464)(dim, size.length);
        try {
            return _cumsumDimensional(array, dim);
        } catch (err) {
            throw (0, $b113219b83527e4b$export$c8994973cec629ae)(err, $95fb3695e64d410c$var$name);
        }
    }
    /* Possible TODO: Refactor _reduce in collection.js to be able to work here as well */ function _cumsumDimensional(mat, dim) {
        var i, ret, tran;
        if (dim <= 0) {
            var initialValue = mat[0][0];
            if (!Array.isArray(initialValue)) return _cumsummap(mat);
            else {
                tran = (0, $52b148bf6ec821bd$export$424b8b2ab9af2944)(mat);
                ret = [];
                for(i = 0; i < tran.length; i++)ret[i] = _cumsumDimensional(tran[i], dim - 1);
                return ret;
            }
        } else {
            ret = [];
            for(i = 0; i < mat.length; i++)ret[i] = _cumsumDimensional(mat[i], dim - 1);
            return ret;
        }
    }
});


var $1ca015603b832422$var$name = "deepEqual";
var $1ca015603b832422$var$dependencies = [
    "typed",
    "equal"
];
var $1ca015603b832422$export$b1b11fc839367b58 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($1ca015603b832422$var$name, $1ca015603b832422$var$dependencies, (_ref)=>{
    var { typed: typed, equal: equal } = _ref;
    /**
   * Test element wise whether two matrices are equal.
   * The function accepts both matrices and scalar values.
   *
   * Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.deepEqual(x, y)
   *
   * Examples:
   *
   *    math.deepEqual(2, 4)   // returns false
   *
   *    a = [2, 5, 1]
   *    b = [2, 7, 1]
   *
   *    math.deepEqual(a, b)   // returns false
   *    math.equal(a, b)       // returns [true, false, true]
   *
   * See also:
   *
   *    equal, unequal
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x First matrix to compare
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Second matrix to compare
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}
   *            Returns true when the input matrices have the same size and each of their elements is equal.
   */ return typed($1ca015603b832422$var$name, {
        "any, any": function anyAny(x, y) {
            return _deepEqual(x.valueOf(), y.valueOf());
        }
    });
    /**
   * Test whether two arrays have the same size and all elements are equal
   * @param {Array | *} x
   * @param {Array | *} y
   * @return {boolean} Returns true if both arrays are deep equal
   */ function _deepEqual(x, y) {
        if (Array.isArray(x)) {
            if (Array.isArray(y)) {
                var len = x.length;
                if (len !== y.length) return false;
                for(var i = 0; i < len; i++){
                    if (!_deepEqual(x[i], y[i])) return false;
                }
                return true;
            } else return false;
        } else {
            if (Array.isArray(y)) return false;
            else return equal(x, y);
        }
    }
});




var $220ba1ccce520f09$var$name = "diff";
var $220ba1ccce520f09$var$dependencies = [
    "typed",
    "matrix",
    "subtract",
    "number"
];
var $220ba1ccce520f09$export$49df08fd121951b4 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($220ba1ccce520f09$var$name, $220ba1ccce520f09$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, subtract: subtract, number: number } = _ref;
    /**
   * Create a new matrix or array of the difference between elements of the given array
   * The optional dim parameter lets you specify the dimension to evaluate the difference of
   * If no dimension parameter is passed it is assumed as dimension 0
   *
   * Dimension is zero-based in javascript and one-based in the parser and can be a number or bignumber
   * Arrays must be 'rectangular' meaning arrays like [1, 2]
   * If something is passed as a matrix it will be returned as a matrix but other than that all matrices are converted to arrays
   *
   * Syntax:
   *
   *     math.diff(arr)
   *     math.diff(arr, dim)
   *
   * Examples:
   *
   *     const arr = [1, 2, 4, 7, 0]
   *     math.diff(arr) // returns [1, 2, 3, -7] (no dimension passed so 0 is assumed)
   *     math.diff(math.matrix(arr)) // returns math.matrix([1, 2, 3, -7])
   *
   *     const arr = [[1, 2, 3, 4, 5], [1, 2, 3, 4, 5], [9, 8, 7, 6, 4]]
   *     math.diff(arr) // returns [[0, 0, 0, 0, 0], [8, 6, 4, 2, -1]]
   *     math.diff(arr, 0) // returns [[0, 0, 0, 0, 0], [8, 6, 4, 2, -1]]
   *     math.diff(arr, 1) // returns [[1, 1, 1, 1], [1, 1, 1, 1], [-1, -1, -1, -2]]
   *     math.diff(arr, math.bignumber(1)) // returns [[1, 1, 1, 1], [1, 1, 1, 1], [-1, -1, -1, -2]]
   *
   *     math.diff(arr, 2) // throws RangeError as arr is 2 dimensional not 3
   *     math.diff(arr, -1) // throws RangeError as negative dimensions are not allowed
   *
   *     // These will all produce the same result
   *     math.diff([[1, 2], [3, 4]])
   *     math.diff([math.matrix([1, 2]), math.matrix([3, 4])])
   *     math.diff([[1, 2], math.matrix([3, 4])])
   *     math.diff([math.matrix([1, 2]), [3, 4]])
   *     // They do not produce the same result as  math.diff(math.matrix([[1, 2], [3, 4]])) as this returns a matrix
   *
   * See Also:
   *
   *      sum
   *      subtract
   *      partitionSelect
   *
   * @param {Array | Matrix} arr    An array or matrix
   * @param {number} dim            Dimension
   * @return {Array | Matrix}       Difference between array elements in given dimension
   */ return typed($220ba1ccce520f09$var$name, {
        "Array | Matrix": function ArrayMatrix(arr) {
            // No dimension specified => assume dimension 0
            if ((0, $d8097b7a6d6e36d8$export$b22160e0a14f87b7)(arr)) return matrix(_diff(arr.toArray()));
            else return _diff(arr);
        },
        "Array | Matrix, number": function ArrayMatrixNumber(arr, dim) {
            if (!(0, $668e051498bf5fa0$export$a287f47fed4544b8)(dim)) throw new RangeError("Dimension must be a whole number");
            if ((0, $d8097b7a6d6e36d8$export$b22160e0a14f87b7)(arr)) return matrix(_recursive(arr.toArray(), dim));
            else return _recursive(arr, dim);
        },
        "Array | Matrix, BigNumber": function ArrayMatrixBigNumber(arr, dim) {
            return this(arr, number(dim));
        }
    });
    /**
   * Recursively find the correct dimension in the array/matrix
   * Then Apply _diff to that dimension
   *
   * @param {Array} arr      The array
   * @param {number} dim     Dimension
   * @return {Array}         resulting array
   */ function _recursive(arr, dim) {
        if ((0, $d8097b7a6d6e36d8$export$b22160e0a14f87b7)(arr)) arr = arr.toArray(); // Makes sure arrays like [ matrix([0, 1]), matrix([1, 0]) ] are processed properly
        if (!Array.isArray(arr)) throw RangeError("Array/Matrix does not have that many dimensions");
        if (dim > 0) {
            var result = [];
            arr.forEach((element)=>{
                result.push(_recursive(element, dim - 1));
            });
            return result;
        } else if (dim === 0) return _diff(arr);
        else throw RangeError("Cannot have negative dimension");
    }
    /**
   * Difference between elements in the array
   *
   * @param {Array} arr      An array
   * @return {Array}         resulting array
   */ function _diff(arr) {
        var result = [];
        var size = arr.length;
        if (size < 2) return arr;
        for(var i = 1; i < size; i++)result.push(_ElementDiff(arr[i - 1], arr[i]));
        return result;
    }
    /**
   * Difference between 2 objects
   *
   * @param {Object} obj1    First object
   * @param {Object} obj2    Second object
   * @return {Array}         resulting array
   */ function _ElementDiff(obj1, obj2) {
        // Convert matrices to arrays
        if ((0, $d8097b7a6d6e36d8$export$b22160e0a14f87b7)(obj1)) obj1 = obj1.toArray();
        if ((0, $d8097b7a6d6e36d8$export$b22160e0a14f87b7)(obj2)) obj2 = obj2.toArray();
        var obj1IsArray = Array.isArray(obj1);
        var obj2IsArray = Array.isArray(obj2);
        if (obj1IsArray && obj2IsArray) return _ArrayDiff(obj1, obj2);
        if (!obj1IsArray && !obj2IsArray) return subtract(obj2, obj1); // Difference is (second - first) NOT (first - second)
        throw TypeError("Cannot calculate difference between 1 array and 1 non-array");
    }
    /**
   * Difference of elements in 2 arrays
   *
   * @param {Array} arr1     Array 1
   * @param {Array} arr2     Array 2
   * @return {Array}         resulting array
   */ function _ArrayDiff(arr1, arr2) {
        if (arr1.length !== arr2.length) throw RangeError("Not all sub-arrays have the same length");
        var result = [];
        var size = arr1.length;
        for(var i = 0; i < size; i++)result.push(_ElementDiff(arr1[i], arr2[i]));
        return result;
    }
});



var $9976cd53c699da0f$var$name = "dot";
var $9976cd53c699da0f$var$dependencies = [
    "typed",
    "addScalar",
    "multiplyScalar",
    "conj",
    "size"
];
var $9976cd53c699da0f$export$3dc59ff00984d687 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($9976cd53c699da0f$var$name, $9976cd53c699da0f$var$dependencies, (_ref)=>{
    var { typed: typed, addScalar: addScalar, multiplyScalar: multiplyScalar, conj: conj, size: size } = _ref;
    /**
   * Calculate the dot product of two vectors. The dot product of
   * `A = [a1, a2, ..., an]` and `B = [b1, b2, ..., bn]` is defined as:
   *
   *    dot(A, B) = conj(a1) * b1 + conj(a2) * b2 + ... + conj(an) * bn
   *
   * Syntax:
   *
   *    math.dot(x, y)
   *
   * Examples:
   *
   *    math.dot([2, 4, 1], [2, 2, 3])       // returns number 15
   *    math.multiply([2, 4, 1], [2, 2, 3])  // returns number 15
   *
   * See also:
   *
   *    multiply, cross
   *
   * @param  {Array | Matrix} x     First vector
   * @param  {Array | Matrix} y     Second vector
   * @return {number}               Returns the dot product of `x` and `y`
   */ return typed($9976cd53c699da0f$var$name, {
        "Array | DenseMatrix, Array | DenseMatrix": _denseDot,
        "SparseMatrix, SparseMatrix": _sparseDot
    });
    function _validateDim(x, y) {
        var xSize = _size(x);
        var ySize = _size(y);
        var xLen, yLen;
        if (xSize.length === 1) xLen = xSize[0];
        else if (xSize.length === 2 && xSize[1] === 1) xLen = xSize[0];
        else throw new RangeError("Expected a column vector, instead got a matrix of size (" + xSize.join(", ") + ")");
        if (ySize.length === 1) yLen = ySize[0];
        else if (ySize.length === 2 && ySize[1] === 1) yLen = ySize[0];
        else throw new RangeError("Expected a column vector, instead got a matrix of size (" + ySize.join(", ") + ")");
        if (xLen !== yLen) throw new RangeError("Vectors must have equal length (" + xLen + " != " + yLen + ")");
        if (xLen === 0) throw new RangeError("Cannot calculate the dot product of empty vectors");
        return xLen;
    }
    function _denseDot(a, b) {
        var N = _validateDim(a, b);
        var adata = (0, $d8097b7a6d6e36d8$export$b22160e0a14f87b7)(a) ? a._data : a;
        var adt = (0, $d8097b7a6d6e36d8$export$b22160e0a14f87b7)(a) ? a._datatype : undefined;
        var bdata = (0, $d8097b7a6d6e36d8$export$b22160e0a14f87b7)(b) ? b._data : b;
        var bdt = (0, $d8097b7a6d6e36d8$export$b22160e0a14f87b7)(b) ? b._datatype : undefined; // are these 2-dimensional column vectors? (as opposed to 1-dimensional vectors)
        var aIsColumn = _size(a).length === 2;
        var bIsColumn = _size(b).length === 2;
        var add = addScalar;
        var mul = multiplyScalar; // process data types
        if (adt && bdt && adt === bdt && typeof adt === "string") {
            var dt = adt; // find signatures that matches (dt, dt)
            add = typed.find(addScalar, [
                dt,
                dt
            ]);
            mul = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
        } // both vectors 1-dimensional
        if (!aIsColumn && !bIsColumn) {
            var c = mul(conj(adata[0]), bdata[0]);
            for(var i = 1; i < N; i++)c = add(c, mul(conj(adata[i]), bdata[i]));
            return c;
        } // a is 1-dim, b is column
        if (!aIsColumn && bIsColumn) {
            var _c = mul(conj(adata[0]), bdata[0][0]);
            for(var _i = 1; _i < N; _i++)_c = add(_c, mul(conj(adata[_i]), bdata[_i][0]));
            return _c;
        } // a is column, b is 1-dim
        if (aIsColumn && !bIsColumn) {
            var _c2 = mul(conj(adata[0][0]), bdata[0]);
            for(var _i2 = 1; _i2 < N; _i2++)_c2 = add(_c2, mul(conj(adata[_i2][0]), bdata[_i2]));
            return _c2;
        } // both vectors are column
        if (aIsColumn && bIsColumn) {
            var _c3 = mul(conj(adata[0][0]), bdata[0][0]);
            for(var _i3 = 1; _i3 < N; _i3++)_c3 = add(_c3, mul(conj(adata[_i3][0]), bdata[_i3][0]));
            return _c3;
        }
    }
    function _sparseDot(x, y) {
        _validateDim(x, y);
        var xindex = x._index;
        var xvalues = x._values;
        var yindex = y._index;
        var yvalues = y._values; // TODO optimize add & mul using datatype
        var c = 0;
        var add = addScalar;
        var mul = multiplyScalar;
        var i = 0;
        var j = 0;
        while(i < xindex.length && j < yindex.length){
            var I = xindex[i];
            var J = yindex[j];
            if (I < J) {
                i++;
                continue;
            }
            if (I > J) {
                j++;
                continue;
            }
            if (I === J) {
                c = add(c, mul(xvalues[i], yvalues[j]));
                i++;
                j++;
            }
        }
        return c;
    } // TODO remove this once #1771 is fixed
    function _size(x) {
        return (0, $d8097b7a6d6e36d8$export$b22160e0a14f87b7)(x) ? x.size() : size(x);
    }
});


var $f17e7954f6ee7c0a$var$name = "equalText";
var $f17e7954f6ee7c0a$var$dependencies = [
    "typed",
    "compareText",
    "isZero"
];
var $f17e7954f6ee7c0a$export$1589aaa29568b87 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($f17e7954f6ee7c0a$var$name, $f17e7954f6ee7c0a$var$dependencies, (_ref)=>{
    var { typed: typed, compareText: compareText, isZero: isZero } = _ref;
    /**
   * Check equality of two strings. Comparison is case sensitive.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.equalText(x, y)
   *
   * Examples:
   *
   *    math.equalText('Hello', 'Hello')     // returns true
   *    math.equalText('a', 'A')             // returns false
   *    math.equal('2e3', '2000')            // returns true
   *    math.equalText('2e3', '2000')        // returns false
   *
   *    math.equalText('B', ['A', 'B', 'C']) // returns [false, true, false]
   *
   * See also:
   *
   *    equal, compareText, compare, compareNatural
   *
   * @param  {string | Array | DenseMatrix} x First string to compare
   * @param  {string | Array | DenseMatrix} y Second string to compare
   * @return {number | Array | DenseMatrix} Returns true if the values are equal, and false if not.
   */ return typed($f17e7954f6ee7c0a$var$name, {
        "any, any": function anyAny(x, y) {
            return isZero(compareText(x, y));
        }
    });
});


var $4qPUL = parcelRequire("4qPUL");







var $f6280cce342fad8e$var$name = "floor";
var $f6280cce342fad8e$var$dependencies = [
    "typed",
    "config",
    "round",
    "matrix",
    "equalScalar",
    "zeros",
    "DenseMatrix"
];
var $f6280cce342fad8e$export$a13f3226a75ff445 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($f6280cce342fad8e$var$name, [
    "typed",
    "config",
    "round"
], (_ref)=>{
    var { typed: typed, config: config, round: round } = _ref;
    return typed($f6280cce342fad8e$var$name, {
        number: function number(x) {
            if ((0, $668e051498bf5fa0$export$6f3989c6ecc04081)(x, round(x), config.epsilon)) return round(x);
            else return Math.floor(x);
        },
        "number, number": function numberNumber(x, n) {
            if ((0, $668e051498bf5fa0$export$6f3989c6ecc04081)(x, round(x, n), config.epsilon)) return round(x, n);
            else {
                var [number, exponent] = "".concat(x, "e").split("e");
                var result = Math.floor(Number("".concat(number, "e").concat(Number(exponent) + n)));
                [number, exponent] = "".concat(result, "e").split("e");
                return Number("".concat(number, "e").concat(Number(exponent) - n));
            }
        }
    });
});
var $f6280cce342fad8e$export$e04e4803a9128c9b = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($f6280cce342fad8e$var$name, $f6280cce342fad8e$var$dependencies, (_ref2)=>{
    var { typed: typed, config: config, round: round, matrix: matrix, equalScalar: equalScalar, zeros: zeros, DenseMatrix: DenseMatrix } = _ref2;
    var algorithm11 = (0, $83b92f81e511657d$export$a38279a12199d831)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm12 = (0, $500ff63908aabda9$export$806772cd23b603dc)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm14 = (0, $533d58927c47005f$export$e5afe3bc814ef550)({
        typed: typed
    });
    var floorNumber = $f6280cce342fad8e$export$a13f3226a75ff445({
        typed: typed,
        config: config,
        round: round
    });
    /**
   * Round a value towards minus infinity.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.floor(x)
   *    math.floor(x, n)
   *
   * Examples:
   *
   *    math.floor(3.2)              // returns number 3
   *    math.floor(3.8)              // returns number 3
   *    math.floor(-4.2)             // returns number -5
   *    math.floor(-4.7)             // returns number -5
   *
   *    math.floor(3.212, 2)          // returns number 3.21
   *    math.floor(3.288, 2)          // returns number 3.28
   *    math.floor(-4.212, 2)         // returns number -4.22
   *    math.floor(-4.782, 2)         // returns number -4.79
   *
   *    const c = math.complex(3.24, -2.71)
   *    math.floor(c)                 // returns Complex 3 - 3i
   *    math.floor(c, 1)              // returns Complex 3.2 - 2.8i
   *
   *    math.floor([3.2, 3.8, -4.7])       // returns Array [3, 3, -5]
   *    math.floor([3.21, 3.82, -4.71], 1)  // returns Array [3.2, 3.8, -4.8]
   *
   *    math.floor(math.tau, [2, 3])  // returns Array [6.28, 6.283]
   *
   *    // Note that floor(array, array) currently not implemented.
   *
   * See also:
   *
   *    ceil, fix, round
   *
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix} x  Number to be rounded
   * @param  {number | BigNumber | Array} [n=0]                            Number of decimals
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix} Rounded value
   */ return typed("floor", {
        number: floorNumber.signatures.number,
        "number,number": floorNumber.signatures["number,number"],
        Complex: function Complex(x) {
            return x.floor();
        },
        "Complex, number": function ComplexNumber(x, n) {
            return x.floor(n);
        },
        "Complex, BigNumber": function ComplexBigNumber(x, n) {
            return x.floor(n.toNumber());
        },
        BigNumber: function BigNumber(x) {
            if ((0, $53e0635127e7c5a0$export$6f3989c6ecc04081)(x, round(x), config.epsilon)) return round(x);
            else return x.floor();
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, n) {
            if ((0, $53e0635127e7c5a0$export$6f3989c6ecc04081)(x, round(x, n), config.epsilon)) return round(x, n);
            else return x.toDecimalPlaces(n.toNumber(), (0, (/*@__PURE__*/$parcel$interopDefault($4qPUL))).ROUND_FLOOR);
        },
        Fraction: function Fraction(x) {
            return x.floor();
        },
        "Fraction, number": function FractionNumber(x, n) {
            return x.floor(n);
        },
        "Fraction, BigNumber": function FractionBigNumber(x, n) {
            return x.floor(n.toNumber());
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since floor(0) = 0
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this, true);
        },
        "Array, number | BigNumber": function ArrayNumberBigNumber(x, n) {
            // deep map collection, skip zeros since ceil(0) = 0
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, (i)=>this(i, n), true);
        },
        "SparseMatrix, number | BigNumber": function SparseMatrixNumberBigNumber(x, y) {
            return algorithm11(x, y, this, false);
        },
        "DenseMatrix, number | BigNumber": function DenseMatrixNumberBigNumber(x, y) {
            return algorithm14(x, y, this, false);
        },
        "number | Complex | Fraction | BigNumber, Array": function numberComplexFractionBigNumberArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        },
        "number | Complex | Fraction | BigNumber, Matrix": function numberComplexFractionBigNumberMatrix(x, y) {
            if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
            if (y.storage() === "dense") return algorithm14(y, x, this, true);
            return algorithm12(y, x, this, true);
        }
    });
});





var $fb30af8a6979a0f9$var$name = "identity";
var $fb30af8a6979a0f9$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "BigNumber",
    "DenseMatrix",
    "SparseMatrix"
];
var $fb30af8a6979a0f9$export$2eca89e9ac669625 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($fb30af8a6979a0f9$var$name, $fb30af8a6979a0f9$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, BigNumber: BigNumber, DenseMatrix: DenseMatrix, SparseMatrix: SparseMatrix } = _ref;
    /**
   * Create a 2-dimensional identity matrix with size m x n or n x n.
   * The matrix has ones on the diagonal and zeros elsewhere.
   *
   * Syntax:
   *
   *    math.identity(n)
   *    math.identity(n, format)
   *    math.identity(m, n)
   *    math.identity(m, n, format)
   *    math.identity([m, n])
   *    math.identity([m, n], format)
   *
   * Examples:
   *
   *    math.identity(3)                    // returns [[1, 0, 0], [0, 1, 0], [0, 0, 1]]
   *    math.identity(3, 2)                 // returns [[1, 0], [0, 1], [0, 0]]
   *
   *    const A = [[1, 2, 3], [4, 5, 6]]
   *    math.identity(math.size(A))         // returns [[1, 0, 0], [0, 1, 0]]
   *
   * See also:
   *
   *    diag, ones, zeros, size, range
   *
   * @param {...number | Matrix | Array} size   The size for the matrix
   * @param {string} [format]                   The Matrix storage format
   *
   * @return {Matrix | Array | number} A matrix with ones on the diagonal.
   */ return typed($fb30af8a6979a0f9$var$name, {
        "": function _() {
            return config.matrix === "Matrix" ? matrix([]) : [];
        },
        string: function string(format) {
            return matrix(format);
        },
        "number | BigNumber": function numberBigNumber(rows) {
            return _identity(rows, rows, config.matrix === "Matrix" ? "dense" : undefined);
        },
        "number | BigNumber, string": function numberBigNumberString(rows, format) {
            return _identity(rows, rows, format);
        },
        "number | BigNumber, number | BigNumber": function numberBigNumberNumberBigNumber(rows, cols) {
            return _identity(rows, cols, config.matrix === "Matrix" ? "dense" : undefined);
        },
        "number | BigNumber, number | BigNumber, string": function numberBigNumberNumberBigNumberString(rows, cols, format) {
            return _identity(rows, cols, format);
        },
        Array: function Array(size) {
            return _identityVector(size);
        },
        "Array, string": function ArrayString(size, format) {
            return _identityVector(size, format);
        },
        Matrix: function Matrix(size) {
            return _identityVector(size.valueOf(), size.storage());
        },
        "Matrix, string": function MatrixString(size, format) {
            return _identityVector(size.valueOf(), format);
        }
    });
    function _identityVector(size, format) {
        switch(size.length){
            case 0:
                return format ? matrix(format) : [];
            case 1:
                return _identity(size[0], size[0], format);
            case 2:
                return _identity(size[0], size[1], format);
            default:
                throw new Error("Vector containing two values expected");
        }
    }
    /**
   * Create an identity matrix
   * @param {number | BigNumber} rows
   * @param {number | BigNumber} cols
   * @param {string} [format]
   * @returns {Matrix}
   * @private
   */ function _identity(rows, cols, format) {
        // BigNumber constructor with the right precision
        var Big = (0, $d8097b7a6d6e36d8$export$e51d0e7e5c4a03ab)(rows) || (0, $d8097b7a6d6e36d8$export$e51d0e7e5c4a03ab)(cols) ? BigNumber : null;
        if ((0, $d8097b7a6d6e36d8$export$e51d0e7e5c4a03ab)(rows)) rows = rows.toNumber();
        if ((0, $d8097b7a6d6e36d8$export$e51d0e7e5c4a03ab)(cols)) cols = cols.toNumber();
        if (!(0, $668e051498bf5fa0$export$a287f47fed4544b8)(rows) || rows < 1) throw new Error("Parameters in function identity must be positive integers");
        if (!(0, $668e051498bf5fa0$export$a287f47fed4544b8)(cols) || cols < 1) throw new Error("Parameters in function identity must be positive integers");
        var one = Big ? new BigNumber(1) : 1;
        var defaultValue = Big ? new Big(0) : 0;
        var size = [
            rows,
            cols
        ]; // check we need to return a matrix
        if (format) {
            // create diagonal matrix (use optimized implementation for storage format)
            if (format === "sparse") return SparseMatrix.diagonal(size, one, 0, defaultValue);
            if (format === "dense") return DenseMatrix.diagonal(size, one, 0, defaultValue);
            throw new TypeError('Unknown matrix type "'.concat(format, '"'));
        } // create and resize array
        var res = (0, $a14a10567870d913$export$4380c87abf28fdf)([], size, defaultValue); // fill in ones on the diagonal
        var minimum = rows < cols ? rows : cols; // fill diagonal
        for(var d = 0; d < minimum; d++)res[d][d] = one;
        return res;
    }
});


var $e0121f565452861a$var$name = "invmod";
var $e0121f565452861a$var$dependencies = [
    "typed",
    "config",
    "BigNumber",
    "xgcd",
    "equal",
    "smaller",
    "mod",
    "add",
    "isInteger"
];
var $e0121f565452861a$export$1e04c9355dadf1c8 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($e0121f565452861a$var$name, $e0121f565452861a$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, BigNumber: BigNumber, xgcd: xgcd, equal: equal, smaller: smaller, mod: mod, add: add, isInteger: isInteger } = _ref;
    /**
   * Calculate the (modular) multiplicative inverse of a modulo b. Solution to the equation `ax ≣ 1 (mod b)`
   * See https://en.wikipedia.org/wiki/Modular_multiplicative_inverse.
   *
   * Syntax:
   *
   *    math.invmod(a, b)
   *
   * Examples:
   *
   *    math.invmod(8, 12)             // returns NaN
   *    math.invmod(7, 13)             // return 2
   *    math.invmod(15151, 15122)      // returns 10429
   *
   * See also:
   *
   *    gcd, xgcd
   *
   * @param {number | BigNumber} a  An integer number
   * @param {number | BigNumber} b  An integer number
   * @return {number | BigNumber }  Returns an integer number
   *                              where `invmod(a,b)*a ≣ 1 (mod b)`
   */ return typed($e0121f565452861a$var$name, {
        "number, number": invmod,
        "BigNumber, BigNumber": invmod
    });
    function invmod(a, b) {
        if (!isInteger(a) || !isInteger(b)) throw new Error("Parameters in function invmod must be integer numbers");
        a = mod(a, b);
        if (equal(b, 0)) throw new Error("Divisor must be non zero");
        var res = xgcd(a, b);
        res = res.valueOf();
        var [gcd, inv] = res;
        if (!equal(gcd, BigNumber(1))) return NaN;
        inv = mod(inv, b);
        if (smaller(inv, BigNumber(0))) inv = add(inv, b);
        return inv;
    }
});









var $684dbb1cf747e6c3$var$name = "larger";
var $684dbb1cf747e6c3$var$dependencies = [
    "typed",
    "config",
    "matrix",
    "DenseMatrix"
];
var $684dbb1cf747e6c3$export$af9bc16ae70e9aa8 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($684dbb1cf747e6c3$var$name, $684dbb1cf747e6c3$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, DenseMatrix: DenseMatrix } = _ref;
    var algorithm03 = (0, $523b807a911c3d38$export$486bb900f1a3c833)({
        typed: typed
    });
    var algorithm07 = (0, $5200888766c056e5$export$b908fb77c4366999)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm12 = (0, $500ff63908aabda9$export$806772cd23b603dc)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $c68b38998aadcc11$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $533d58927c47005f$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Test whether value x is larger than y.
   *
   * The function returns true when x is larger than y and the relative
   * difference between x and y is larger than the configured epsilon. The
   * function cannot be used to compare values smaller than approximately 2.22e-16.
   *
   * For matrices, the function is evaluated element wise.
   * Strings are compared by their numerical value.
   *
   * Syntax:
   *
   *    math.larger(x, y)
   *
   * Examples:
   *
   *    math.larger(2, 3)             // returns false
   *    math.larger(5, 2 + 2)         // returns true
   *
   *    const a = math.unit('5 cm')
   *    const b = math.unit('2 inch')
   *    math.larger(a, b)             // returns false
   *
   * See also:
   *
   *    equal, unequal, smaller, smallerEq, largerEq, compare
   *
   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} x First value to compare
   * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} y Second value to compare
   * @return {boolean | Array | Matrix} Returns true when the x is larger than y, else returns false
   */ return typed($684dbb1cf747e6c3$var$name, {
        "boolean, boolean": function booleanBoolean(x, y) {
            return x > y;
        },
        "number, number": function numberNumber(x, y) {
            return x > y && !(0, $668e051498bf5fa0$export$6f3989c6ecc04081)(x, y, config.epsilon);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            return x.gt(y) && !(0, $53e0635127e7c5a0$export$6f3989c6ecc04081)(x, y, config.epsilon);
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.compare(y) === 1;
        },
        "Complex, Complex": function ComplexComplex() {
            throw new TypeError("No ordering relation is defined for complex numbers");
        },
        "Unit, Unit": function UnitUnit(x, y) {
            if (!x.equalBase(y)) throw new Error("Cannot compare units with different base");
            return this(x.value, y.value);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, this);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, this, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, this, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm12(x, y, this, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, this, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, this, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});
var $684dbb1cf747e6c3$export$36e0507f86788708 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($684dbb1cf747e6c3$var$name, [
    "typed",
    "config"
], (_ref2)=>{
    var { typed: typed, config: config } = _ref2;
    return typed($684dbb1cf747e6c3$var$name, {
        "number, number": function numberNumber(x, y) {
            return x > y && !(0, $668e051498bf5fa0$export$6f3989c6ecc04081)(x, y, config.epsilon);
        }
    });
});




var $8405c8baeee2ba0a$var$name = "log";
var $8405c8baeee2ba0a$var$dependencies = [
    "config",
    "typed",
    "divideScalar",
    "Complex"
];
var $8405c8baeee2ba0a$export$aea8a16d5c9d1b93 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($8405c8baeee2ba0a$var$name, $8405c8baeee2ba0a$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, divideScalar: divideScalar, Complex: Complex } = _ref;
    /**
   * Calculate the logarithm of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.log(x)
   *    math.log(x, base)
   *
   * Examples:
   *
   *    math.log(3.5)                  // returns 1.252762968495368
   *    math.exp(math.log(2.4))        // returns 2.4
   *
   *    math.pow(10, 4)                // returns 10000
   *    math.log(10000, 10)            // returns 4
   *    math.log(10000) / math.log(10) // returns 4
   *
   *    math.log(1024, 2)              // returns 10
   *    math.pow(2, 10)                // returns 1024
   *
   * See also:
   *
   *    exp, log2, log10, log1p
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            Value for which to calculate the logarithm.
   * @param {number | BigNumber | Complex} [base=e]
   *            Optional base for the logarithm. If not provided, the natural
   *            logarithm of `x` is calculated.
   * @return {number | BigNumber | Complex | Array | Matrix}
   *            Returns the logarithm of `x`
   */ return typed($8405c8baeee2ba0a$var$name, {
        number: function number(x) {
            if (x >= 0 || config.predictable) return (0, $4b37ed316f05dd33$export$4df0e8fcdd5c0927)(x);
            else // negative value -> complex value computation
            return new Complex(x, 0).log();
        },
        Complex: function Complex(x) {
            return x.log();
        },
        BigNumber: function BigNumber(x) {
            if (!x.isNegative() || config.predictable) return x.ln();
            else // downgrade to number, return Complex valued result
            return new Complex(x.toNumber(), 0).log();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this);
        },
        "any, any": function anyAny(x, base) {
            // calculate logarithm for a specified base, log(x, base)
            return divideScalar(this(x), this(base));
        }
    });
});



var $d9f225d7957974b1$var$name = "lsolveAll";
var $d9f225d7957974b1$var$dependencies = [
    "typed",
    "matrix",
    "divideScalar",
    "multiplyScalar",
    "subtract",
    "equalScalar",
    "DenseMatrix"
];
var $d9f225d7957974b1$export$70743fd0ad1f42d7 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($d9f225d7957974b1$var$name, $d9f225d7957974b1$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, divideScalar: divideScalar, multiplyScalar: multiplyScalar, subtract: subtract, equalScalar: equalScalar, DenseMatrix: DenseMatrix } = _ref;
    var solveValidation = (0, $5b483e7b4659dfae$export$6accbcba5dda801d)({
        DenseMatrix: DenseMatrix
    });
    /**
   * Finds all solutions of a linear equation system by forwards substitution. Matrix must be a lower triangular matrix.
   *
   * `L * x = b`
   *
   * Syntax:
   *
   *    math.lsolveAll(L, b)
   *
   * Examples:
   *
   *    const a = [[-2, 3], [2, 1]]
   *    const b = [11, 9]
   *    const x = lsolveAll(a, b)  // [ [[-5.5], [20]] ]
   *
   * See also:
   *
   *    lsolve, lup, slu, usolve, lusolve
   *
   * @param {Matrix, Array} L       A N x N matrix or array (L)
   * @param {Matrix, Array} b       A column vector with the b values
   *
   * @return {DenseMatrix[] | Array[]}  An array of affine-independent column vectors (x) that solve the linear system
   */ return typed($d9f225d7957974b1$var$name, {
        "SparseMatrix, Array | Matrix": function SparseMatrixArrayMatrix(m, b) {
            return _sparseForwardSubstitution(m, b);
        },
        "DenseMatrix, Array | Matrix": function DenseMatrixArrayMatrix(m, b) {
            return _denseForwardSubstitution(m, b);
        },
        "Array, Array | Matrix": function ArrayArrayMatrix(a, b) {
            var m = matrix(a);
            var R = _denseForwardSubstitution(m, b);
            return R.map((r)=>r.valueOf());
        }
    });
    function _denseForwardSubstitution(m, b_) {
        // the algorithm is derived from
        // https://www.overleaf.com/read/csvgqdxggyjv
        // array of right-hand sides
        var B = [
            solveValidation(m, b_, true)._data.map((e)=>e[0])
        ];
        var M = m._data;
        var rows = m._size[0];
        var columns = m._size[1]; // loop columns
        for(var i = 0; i < columns; i++){
            var L = B.length; // loop right-hand sides
            for(var k = 0; k < L; k++){
                var b = B[k];
                if (!equalScalar(M[i][i], 0)) {
                    // non-singular row
                    b[i] = divideScalar(b[i], M[i][i]);
                    for(var j = i + 1; j < columns; j++)// b[j] -= b[i] * M[j,i]
                    b[j] = subtract(b[j], multiplyScalar(b[i], M[j][i]));
                } else if (!equalScalar(b[i], 0)) {
                    // singular row, nonzero RHS
                    if (k === 0) // There is no valid solution
                    return [];
                    else {
                        // This RHS is invalid but other solutions may still exist
                        B.splice(k, 1);
                        k -= 1;
                        L -= 1;
                    }
                } else if (k === 0) {
                    // singular row, RHS is zero
                    var bNew = [
                        ...b
                    ];
                    bNew[i] = 1;
                    for(var _j = i + 1; _j < columns; _j++)bNew[_j] = subtract(bNew[_j], M[_j][i]);
                    B.push(bNew);
                }
            }
        }
        return B.map((x)=>new DenseMatrix({
                data: x.map((e)=>[
                        e
                    ]),
                size: [
                    rows,
                    1
                ]
            }));
    }
    function _sparseForwardSubstitution(m, b_) {
        // array of right-hand sides
        var B = [
            solveValidation(m, b_, true)._data.map((e)=>e[0])
        ];
        var rows = m._size[0];
        var columns = m._size[1];
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr; // loop columns
        for(var i = 0; i < columns; i++){
            var L = B.length; // loop right-hand sides
            for(var k = 0; k < L; k++){
                var b = B[k]; // values & indices (column i)
                var iValues = [];
                var iIndices = []; // first & last indeces in column
                var firstIndex = ptr[i];
                var lastIndex = ptr[i + 1]; // find the value at [i, i]
                var Mii = 0;
                for(var j = firstIndex; j < lastIndex; j++){
                    var J = index[j]; // check row
                    if (J === i) Mii = values[j];
                    else if (J > i) {
                        // store lower triangular
                        iValues.push(values[j]);
                        iIndices.push(J);
                    }
                }
                if (!equalScalar(Mii, 0)) {
                    // non-singular row
                    b[i] = divideScalar(b[i], Mii);
                    for(var _j2 = 0, _lastIndex = iIndices.length; _j2 < _lastIndex; _j2++){
                        var _J = iIndices[_j2];
                        b[_J] = subtract(b[_J], multiplyScalar(b[i], iValues[_j2]));
                    }
                } else if (!equalScalar(b[i], 0)) {
                    // singular row, nonzero RHS
                    if (k === 0) // There is no valid solution
                    return [];
                    else {
                        // This RHS is invalid but other solutions may still exist
                        B.splice(k, 1);
                        k -= 1;
                        L -= 1;
                    }
                } else if (k === 0) {
                    // singular row, RHS is zero
                    var bNew = [
                        ...b
                    ];
                    bNew[i] = 1;
                    for(var _j3 = 0, _lastIndex2 = iIndices.length; _j3 < _lastIndex2; _j3++){
                        var _J2 = iIndices[_j3];
                        bNew[_J2] = subtract(bNew[_J2], iValues[_j3]);
                    }
                    B.push(bNew);
                }
            }
        }
        return B.map((x)=>new DenseMatrix({
                data: x.map((e)=>[
                        e
                    ]),
                size: [
                    rows,
                    1
                ]
            }));
    }
});


var $30d219cc04ecd4dc$var$name = "matrixFromRows";
var $30d219cc04ecd4dc$var$dependencies = [
    "typed",
    "matrix",
    "flatten",
    "size"
];
var $30d219cc04ecd4dc$export$b72d61f960d7c36b = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($30d219cc04ecd4dc$var$name, $30d219cc04ecd4dc$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, flatten: flatten, size: size } = _ref;
    /**
   * Create a dense matrix from vectors as individual rows.
   * If you pass column vectors, they will be transposed (but not conjugated!)
   *
   * Syntax:
   *
   *    math.matrixFromRows(...arr)
   *    math.matrixFromRows(row1, row2)
   *    math.matrixFromRows(row1, row2, row3)
   *
   * Examples:
   *
   *    math.matrixFromRows([1, 2, 3], [[4],[5],[6]])
   *    math.matrixFromRows(...vectors)
   *
   * See also:
   *
   *    matrix, matrixFromColumns, matrixFromFunction, zeros
   *
   * @param {... Array | Matrix} rows  Multiple rows
   * @return { number[][] | Matrix } if at least one of the arguments is an array, an array will be returned
   */ return typed($30d219cc04ecd4dc$var$name, {
        "...Array": function Array(arr) {
            return _createArray(arr);
        },
        "...Matrix": function Matrix(arr) {
            return matrix(_createArray(arr.map((m)=>m.toArray())));
        } // TODO implement this properly for SparseMatrix
    });
    function _createArray(arr) {
        if (arr.length === 0) throw new TypeError("At least one row is needed to construct a matrix.");
        var N = checkVectorTypeAndReturnLength(arr[0]);
        var result = [];
        for (var row of arr){
            var rowLength = checkVectorTypeAndReturnLength(row);
            if (rowLength !== N) throw new TypeError("The vectors had different length: " + (N | 0) + " \u2260 " + (rowLength | 0));
            result.push(flatten(row));
        }
        return result;
    }
    function checkVectorTypeAndReturnLength(vec) {
        var s = size(vec);
        if (s.length === 1) // 1D vector
        return s[0];
        else if (s.length === 2) {
            // 2D vector
            if (s[0] === 1) // row vector
            return s[1];
            else if (s[1] === 1) // col vector
            return s[0];
            else throw new TypeError("At least one of the arguments is not a vector.");
        } else throw new TypeError("Only one- or two-dimensional vectors are supported.");
    }
});







var $c2f426575adc27ba$var$name = "multiply";
var $c2f426575adc27ba$var$dependencies = [
    "typed",
    "matrix",
    "addScalar",
    "multiplyScalar",
    "equalScalar",
    "dot"
];
var $c2f426575adc27ba$export$86d08fd318fa07c8 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($c2f426575adc27ba$var$name, $c2f426575adc27ba$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, addScalar: addScalar, multiplyScalar: multiplyScalar, equalScalar: equalScalar, dot: dot } = _ref;
    var algorithm11 = (0, $83b92f81e511657d$export$a38279a12199d831)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm14 = (0, $533d58927c47005f$export$e5afe3bc814ef550)({
        typed: typed
    });
    function _validateMatrixDimensions(size1, size2) {
        // check left operand dimensions
        switch(size1.length){
            case 1:
                // check size2
                switch(size2.length){
                    case 1:
                        // Vector x Vector
                        if (size1[0] !== size2[0]) // throw error
                        throw new RangeError("Dimension mismatch in multiplication. Vectors must have the same length");
                        break;
                    case 2:
                        // Vector x Matrix
                        if (size1[0] !== size2[0]) // throw error
                        throw new RangeError("Dimension mismatch in multiplication. Vector length (" + size1[0] + ") must match Matrix rows (" + size2[0] + ")");
                        break;
                    default:
                        throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix B has " + size2.length + " dimensions)");
                }
                break;
            case 2:
                // check size2
                switch(size2.length){
                    case 1:
                        // Matrix x Vector
                        if (size1[1] !== size2[0]) // throw error
                        throw new RangeError("Dimension mismatch in multiplication. Matrix columns (" + size1[1] + ") must match Vector length (" + size2[0] + ")");
                        break;
                    case 2:
                        // Matrix x Matrix
                        if (size1[1] !== size2[0]) // throw error
                        throw new RangeError("Dimension mismatch in multiplication. Matrix A columns (" + size1[1] + ") must match Matrix B rows (" + size2[0] + ")");
                        break;
                    default:
                        throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix B has " + size2.length + " dimensions)");
                }
                break;
            default:
                throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix A has " + size1.length + " dimensions)");
        }
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            Dense Vector   (N)
   * @param {Matrix} b            Dense Vector   (N)
   *
   * @return {number}             Scalar value
   */ function _multiplyVectorVector(a, b, n) {
        // check empty vector
        if (n === 0) throw new Error("Cannot multiply two empty vectors");
        return dot(a, b);
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            Dense Vector   (M)
   * @param {Matrix} b            Matrix         (MxN)
   *
   * @return {Matrix}             Dense Vector   (N)
   */ function _multiplyVectorMatrix(a, b) {
        // process storage
        if (b.storage() !== "dense") throw new Error("Support for SparseMatrix not implemented");
        return _multiplyVectorDenseMatrix(a, b);
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            Dense Vector   (M)
   * @param {Matrix} b            Dense Matrix   (MxN)
   *
   * @return {Matrix}             Dense Vector   (N)
   */ function _multiplyVectorDenseMatrix(a, b) {
        // a dense
        var adata = a._data;
        var asize = a._size;
        var adt = a._datatype; // b dense
        var bdata = b._data;
        var bsize = b._size;
        var bdt = b._datatype; // rows & columns
        var alength = asize[0];
        var bcolumns = bsize[1]; // datatype
        var dt; // addScalar signature to use
        var af = addScalar; // multiplyScalar signature to use
        var mf = multiplyScalar; // process data types
        if (adt && bdt && adt === bdt && typeof adt === "string") {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
        } // result
        var c = []; // loop matrix columns
        for(var j = 0; j < bcolumns; j++){
            // sum (do not initialize it with zero)
            var sum = mf(adata[0], bdata[0][j]); // loop vector
            for(var i = 1; i < alength; i++)// multiply & accumulate
            sum = af(sum, mf(adata[i], bdata[i][j]));
            c[j] = sum;
        } // return matrix
        return a.createDenseMatrix({
            data: c,
            size: [
                bcolumns
            ],
            datatype: dt
        });
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            Matrix         (MxN)
   * @param {Matrix} b            Dense Vector   (N)
   *
   * @return {Matrix}             Dense Vector   (M)
   */ var _multiplyMatrixVector = typed("_multiplyMatrixVector", {
        "DenseMatrix, any": _multiplyDenseMatrixVector,
        "SparseMatrix, any": _multiplySparseMatrixVector
    });
    /**
   * C = A * B
   *
   * @param {Matrix} a            Matrix         (MxN)
   * @param {Matrix} b            Matrix         (NxC)
   *
   * @return {Matrix}             Matrix         (MxC)
   */ var _multiplyMatrixMatrix = typed("_multiplyMatrixMatrix", {
        "DenseMatrix, DenseMatrix": _multiplyDenseMatrixDenseMatrix,
        "DenseMatrix, SparseMatrix": _multiplyDenseMatrixSparseMatrix,
        "SparseMatrix, DenseMatrix": _multiplySparseMatrixDenseMatrix,
        "SparseMatrix, SparseMatrix": _multiplySparseMatrixSparseMatrix
    });
    /**
   * C = A * B
   *
   * @param {Matrix} a            DenseMatrix  (MxN)
   * @param {Matrix} b            Dense Vector (N)
   *
   * @return {Matrix}             Dense Vector (M)
   */ function _multiplyDenseMatrixVector(a, b) {
        // a dense
        var adata = a._data;
        var asize = a._size;
        var adt = a._datatype; // b dense
        var bdata = b._data;
        var bdt = b._datatype; // rows & columns
        var arows = asize[0];
        var acolumns = asize[1]; // datatype
        var dt; // addScalar signature to use
        var af = addScalar; // multiplyScalar signature to use
        var mf = multiplyScalar; // process data types
        if (adt && bdt && adt === bdt && typeof adt === "string") {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
        } // result
        var c = []; // loop matrix a rows
        for(var i = 0; i < arows; i++){
            // current row
            var row = adata[i]; // sum (do not initialize it with zero)
            var sum = mf(row[0], bdata[0]); // loop matrix a columns
            for(var j = 1; j < acolumns; j++)// multiply & accumulate
            sum = af(sum, mf(row[j], bdata[j]));
            c[i] = sum;
        } // return matrix
        return a.createDenseMatrix({
            data: c,
            size: [
                arows
            ],
            datatype: dt
        });
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            DenseMatrix    (MxN)
   * @param {Matrix} b            DenseMatrix    (NxC)
   *
   * @return {Matrix}             DenseMatrix    (MxC)
   */ function _multiplyDenseMatrixDenseMatrix(a, b) {
        // a dense
        var adata = a._data;
        var asize = a._size;
        var adt = a._datatype; // b dense
        var bdata = b._data;
        var bsize = b._size;
        var bdt = b._datatype; // rows & columns
        var arows = asize[0];
        var acolumns = asize[1];
        var bcolumns = bsize[1]; // datatype
        var dt; // addScalar signature to use
        var af = addScalar; // multiplyScalar signature to use
        var mf = multiplyScalar; // process data types
        if (adt && bdt && adt === bdt && typeof adt === "string") {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
        } // result
        var c = []; // loop matrix a rows
        for(var i = 0; i < arows; i++){
            // current row
            var row = adata[i]; // initialize row array
            c[i] = []; // loop matrix b columns
            for(var j = 0; j < bcolumns; j++){
                // sum (avoid initializing sum to zero)
                var sum = mf(row[0], bdata[0][j]); // loop matrix a columns
                for(var x = 1; x < acolumns; x++)// multiply & accumulate
                sum = af(sum, mf(row[x], bdata[x][j]));
                c[i][j] = sum;
            }
        } // return matrix
        return a.createDenseMatrix({
            data: c,
            size: [
                arows,
                bcolumns
            ],
            datatype: dt
        });
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            DenseMatrix    (MxN)
   * @param {Matrix} b            SparseMatrix   (NxC)
   *
   * @return {Matrix}             SparseMatrix   (MxC)
   */ function _multiplyDenseMatrixSparseMatrix(a, b) {
        // a dense
        var adata = a._data;
        var asize = a._size;
        var adt = a._datatype; // b sparse
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr;
        var bsize = b._size;
        var bdt = b._datatype; // validate b matrix
        if (!bvalues) throw new Error("Cannot multiply Dense Matrix times Pattern only Matrix");
         // rows & columns
        var arows = asize[0];
        var bcolumns = bsize[1]; // datatype
        var dt; // addScalar signature to use
        var af = addScalar; // multiplyScalar signature to use
        var mf = multiplyScalar; // equalScalar signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // process data types
        if (adt && bdt && adt === bdt && typeof adt === "string") {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt);
        } // result
        var cvalues = [];
        var cindex = [];
        var cptr = []; // c matrix
        var c = b.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                arows,
                bcolumns
            ],
            datatype: dt
        }); // loop b columns
        for(var jb = 0; jb < bcolumns; jb++){
            // update ptr
            cptr[jb] = cindex.length; // indeces in column jb
            var kb0 = bptr[jb];
            var kb1 = bptr[jb + 1]; // do not process column jb if no data exists
            if (kb1 > kb0) {
                // last row mark processed
                var last = 0; // loop a rows
                for(var i = 0; i < arows; i++){
                    // column mark
                    var mark = i + 1; // C[i, jb]
                    var cij = void 0; // values in b column j
                    for(var kb = kb0; kb < kb1; kb++){
                        // row
                        var ib = bindex[kb]; // check value has been initialized
                        if (last !== mark) {
                            // first value in column jb
                            cij = mf(adata[i][ib], bvalues[kb]); // update mark
                            last = mark;
                        } else // accumulate value
                        cij = af(cij, mf(adata[i][ib], bvalues[kb]));
                    } // check column has been processed and value != 0
                    if (last === mark && !eq(cij, zero)) {
                        // push row & value
                        cindex.push(i);
                        cvalues.push(cij);
                    }
                }
            }
        } // update ptr
        cptr[bcolumns] = cindex.length; // return sparse matrix
        return c;
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            SparseMatrix    (MxN)
   * @param {Matrix} b            Dense Vector (N)
   *
   * @return {Matrix}             SparseMatrix    (M, 1)
   */ function _multiplySparseMatrixVector(a, b) {
        // a sparse
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var adt = a._datatype; // validate a matrix
        if (!avalues) throw new Error("Cannot multiply Pattern only Matrix times Dense Matrix");
         // b dense
        var bdata = b._data;
        var bdt = b._datatype; // rows & columns
        var arows = a._size[0];
        var brows = b._size[0]; // result
        var cvalues = [];
        var cindex = [];
        var cptr = []; // datatype
        var dt; // addScalar signature to use
        var af = addScalar; // multiplyScalar signature to use
        var mf = multiplyScalar; // equalScalar signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // process data types
        if (adt && bdt && adt === bdt && typeof adt === "string") {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt);
        } // workspace
        var x = []; // vector with marks indicating a value x[i] exists in a given column
        var w = []; // update ptr
        cptr[0] = 0; // rows in b
        for(var ib = 0; ib < brows; ib++){
            // b[ib]
            var vbi = bdata[ib]; // check b[ib] != 0, avoid loops
            if (!eq(vbi, zero)) // A values & index in ib column
            for(var ka0 = aptr[ib], ka1 = aptr[ib + 1], ka = ka0; ka < ka1; ka++){
                // a row
                var ia = aindex[ka]; // check value exists in current j
                if (!w[ia]) {
                    // ia is new entry in j
                    w[ia] = true; // add i to pattern of C
                    cindex.push(ia); // x(ia) = A
                    x[ia] = mf(vbi, avalues[ka]);
                } else // i exists in C already
                x[ia] = af(x[ia], mf(vbi, avalues[ka]));
            }
        } // copy values from x to column jb of c
        for(var p1 = cindex.length, p = 0; p < p1; p++){
            // row
            var ic = cindex[p]; // copy value
            cvalues[p] = x[ic];
        } // update ptr
        cptr[1] = cindex.length; // return sparse matrix
        return a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                arows,
                1
            ],
            datatype: dt
        });
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            SparseMatrix      (MxN)
   * @param {Matrix} b            DenseMatrix       (NxC)
   *
   * @return {Matrix}             SparseMatrix      (MxC)
   */ function _multiplySparseMatrixDenseMatrix(a, b) {
        // a sparse
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var adt = a._datatype; // validate a matrix
        if (!avalues) throw new Error("Cannot multiply Pattern only Matrix times Dense Matrix");
         // b dense
        var bdata = b._data;
        var bdt = b._datatype; // rows & columns
        var arows = a._size[0];
        var brows = b._size[0];
        var bcolumns = b._size[1]; // datatype
        var dt; // addScalar signature to use
        var af = addScalar; // multiplyScalar signature to use
        var mf = multiplyScalar; // equalScalar signature to use
        var eq = equalScalar; // zero value
        var zero = 0; // process data types
        if (adt && bdt && adt === bdt && typeof adt === "string") {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
            eq = typed.find(equalScalar, [
                dt,
                dt
            ]); // convert 0 to the same datatype
            zero = typed.convert(0, dt);
        } // result
        var cvalues = [];
        var cindex = [];
        var cptr = []; // c matrix
        var c = a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                arows,
                bcolumns
            ],
            datatype: dt
        }); // workspace
        var x = []; // vector with marks indicating a value x[i] exists in a given column
        var w = []; // loop b columns
        for(var jb = 0; jb < bcolumns; jb++){
            // update ptr
            cptr[jb] = cindex.length; // mark in workspace for current column
            var mark = jb + 1; // rows in jb
            for(var ib = 0; ib < brows; ib++){
                // b[ib, jb]
                var vbij = bdata[ib][jb]; // check b[ib, jb] != 0, avoid loops
                if (!eq(vbij, zero)) // A values & index in ib column
                for(var ka0 = aptr[ib], ka1 = aptr[ib + 1], ka = ka0; ka < ka1; ka++){
                    // a row
                    var ia = aindex[ka]; // check value exists in current j
                    if (w[ia] !== mark) {
                        // ia is new entry in j
                        w[ia] = mark; // add i to pattern of C
                        cindex.push(ia); // x(ia) = A
                        x[ia] = mf(vbij, avalues[ka]);
                    } else // i exists in C already
                    x[ia] = af(x[ia], mf(vbij, avalues[ka]));
                }
            } // copy values from x to column jb of c
            for(var p0 = cptr[jb], p1 = cindex.length, p = p0; p < p1; p++){
                // row
                var ic = cindex[p]; // copy value
                cvalues[p] = x[ic];
            }
        } // update ptr
        cptr[bcolumns] = cindex.length; // return sparse matrix
        return c;
    }
    /**
   * C = A * B
   *
   * @param {Matrix} a            SparseMatrix      (MxN)
   * @param {Matrix} b            SparseMatrix      (NxC)
   *
   * @return {Matrix}             SparseMatrix      (MxC)
   */ function _multiplySparseMatrixSparseMatrix(a, b) {
        // a sparse
        var avalues = a._values;
        var aindex = a._index;
        var aptr = a._ptr;
        var adt = a._datatype; // b sparse
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr;
        var bdt = b._datatype; // rows & columns
        var arows = a._size[0];
        var bcolumns = b._size[1]; // flag indicating both matrices (a & b) contain data
        var values = avalues && bvalues; // datatype
        var dt; // addScalar signature to use
        var af = addScalar; // multiplyScalar signature to use
        var mf = multiplyScalar; // process data types
        if (adt && bdt && adt === bdt && typeof adt === "string") {
            // datatype
            dt = adt; // find signatures that matches (dt, dt)
            af = typed.find(addScalar, [
                dt,
                dt
            ]);
            mf = typed.find(multiplyScalar, [
                dt,
                dt
            ]);
        } // result
        var cvalues = values ? [] : undefined;
        var cindex = [];
        var cptr = []; // c matrix
        var c = a.createSparseMatrix({
            values: cvalues,
            index: cindex,
            ptr: cptr,
            size: [
                arows,
                bcolumns
            ],
            datatype: dt
        }); // workspace
        var x = values ? [] : undefined; // vector with marks indicating a value x[i] exists in a given column
        var w = []; // variables
        var ka, ka0, ka1, kb, kb0, kb1, ia, ib; // loop b columns
        for(var jb = 0; jb < bcolumns; jb++){
            // update ptr
            cptr[jb] = cindex.length; // mark in workspace for current column
            var mark = jb + 1; // B values & index in j
            for(kb0 = bptr[jb], kb1 = bptr[jb + 1], kb = kb0; kb < kb1; kb++){
                // b row
                ib = bindex[kb]; // check we need to process values
                if (values) // loop values in a[:,ib]
                for(ka0 = aptr[ib], ka1 = aptr[ib + 1], ka = ka0; ka < ka1; ka++){
                    // row
                    ia = aindex[ka]; // check value exists in current j
                    if (w[ia] !== mark) {
                        // ia is new entry in j
                        w[ia] = mark; // add i to pattern of C
                        cindex.push(ia); // x(ia) = A
                        x[ia] = mf(bvalues[kb], avalues[ka]);
                    } else // i exists in C already
                    x[ia] = af(x[ia], mf(bvalues[kb], avalues[ka]));
                }
                else // loop values in a[:,ib]
                for(ka0 = aptr[ib], ka1 = aptr[ib + 1], ka = ka0; ka < ka1; ka++){
                    // row
                    ia = aindex[ka]; // check value exists in current j
                    if (w[ia] !== mark) {
                        // ia is new entry in j
                        w[ia] = mark; // add i to pattern of C
                        cindex.push(ia);
                    }
                }
            } // check we need to process matrix values (pattern matrix)
            if (values) // copy values from x to column jb of c
            for(var p0 = cptr[jb], p1 = cindex.length, p = p0; p < p1; p++){
                // row
                var ic = cindex[p]; // copy value
                cvalues[p] = x[ic];
            }
        } // update ptr
        cptr[bcolumns] = cindex.length; // return sparse matrix
        return c;
    }
    /**
   * Multiply two or more values, `x * y`.
   * For matrices, the matrix product is calculated.
   *
   * Syntax:
   *
   *    math.multiply(x, y)
   *    math.multiply(x, y, z, ...)
   *
   * Examples:
   *
   *    math.multiply(4, 5.2)        // returns number 20.8
   *    math.multiply(2, 3, 4)       // returns number 24
   *
   *    const a = math.complex(2, 3)
   *    const b = math.complex(4, 1)
   *    math.multiply(a, b)          // returns Complex 5 + 14i
   *
   *    const c = [[1, 2], [4, 3]]
   *    const d = [[1, 2, 3], [3, -4, 7]]
   *    math.multiply(c, d)          // returns Array [[7, -6, 17], [13, -4, 33]]
   *
   *    const e = math.unit('2.1 km')
   *    math.multiply(3, e)          // returns Unit 6.3 km
   *
   * See also:
   *
   *    divide, prod, cross, dot
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x First value to multiply
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Second value to multiply
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} Multiplication of `x` and `y`
   */ return typed($c2f426575adc27ba$var$name, (0, $6819694788cbfa38$export$8b58be045bf06082)({
        // we extend the signatures of multiplyScalar with signatures dealing with matrices
        "Array, Array": function ArrayArray(x, y) {
            // check dimensions
            _validateMatrixDimensions((0, $a14a10567870d913$export$51ffaee4afb683a5)(x), (0, $a14a10567870d913$export$51ffaee4afb683a5)(y)); // use dense matrix implementation
            var m = this(matrix(x), matrix(y)); // return array or scalar
            return (0, $d8097b7a6d6e36d8$export$b22160e0a14f87b7)(m) ? m.valueOf() : m;
        },
        "Matrix, Matrix": function MatrixMatrix(x, y) {
            // dimensions
            var xsize = x.size();
            var ysize = y.size(); // check dimensions
            _validateMatrixDimensions(xsize, ysize); // process dimensions
            if (xsize.length === 1) {
                // process y dimensions
                if (ysize.length === 1) // Vector * Vector
                return _multiplyVectorVector(x, y, xsize[0]);
                 // Vector * Matrix
                return _multiplyVectorMatrix(x, y);
            } // process y dimensions
            if (ysize.length === 1) // Matrix * Vector
            return _multiplyMatrixVector(x, y);
             // Matrix * Matrix
            return _multiplyMatrixMatrix(x, y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use Matrix * Matrix implementation
            return this(x, matrix(y));
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use Matrix * Matrix implementation
            return this(matrix(x, y.storage()), y);
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm11(x, y, multiplyScalar, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, multiplyScalar, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm11(y, x, multiplyScalar, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, multiplyScalar, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, multiplyScalar, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, multiplyScalar, true).valueOf();
        },
        "any, any": multiplyScalar,
        "any, any, ...any": function anyAnyAny(x, y, rest) {
            var result = this(x, y);
            for(var i = 0; i < rest.length; i++)result = this(result, rest[i]);
            return result;
        }
    }, multiplyScalar.signatures));
});



var $f015874d25b628a8$var$name = "qr";
var $f015874d25b628a8$var$dependencies = [
    "typed",
    "matrix",
    "zeros",
    "identity",
    "isZero",
    "equal",
    "sign",
    "sqrt",
    "conj",
    "unaryMinus",
    "addScalar",
    "divideScalar",
    "multiplyScalar",
    "subtract",
    "complex"
];
var $f015874d25b628a8$export$39b52312ba2c4d03 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($f015874d25b628a8$var$name, $f015874d25b628a8$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, zeros: zeros, identity: identity, isZero: isZero, equal: equal, sign: sign, sqrt: sqrt, conj: conj, unaryMinus: unaryMinus, addScalar: addScalar, divideScalar: divideScalar, multiplyScalar: multiplyScalar, subtract: subtract, complex: complex } = _ref;
    /**
   * Calculate the Matrix QR decomposition. Matrix `A` is decomposed in
   * two matrices (`Q`, `R`) where `Q` is an
   * orthogonal matrix and `R` is an upper triangular matrix.
   *
   * Syntax:
   *
   *    math.qr(A)
   *
   * Example:
   *
   *    const m = [
   *      [1, -1,  4],
   *      [1,  4, -2],
   *      [1,  4,  2],
   *      [1,  -1, 0]
   *    ]
   *    const result = math.qr(m)
   *    // r = {
   *    //   Q: [
   *    //     [0.5, -0.5,   0.5],
   *    //     [0.5,  0.5,  -0.5],
   *    //     [0.5,  0.5,   0.5],
   *    //     [0.5, -0.5,  -0.5],
   *    //   ],
   *    //   R: [
   *    //     [2, 3,  2],
   *    //     [0, 5, -2],
   *    //     [0, 0,  4],
   *    //     [0, 0,  0]
   *    //   ]
   *    // }
   *
   * See also:
   *
   *    lup, lusolve
   *
   * @param {Matrix | Array} A    A two dimensional matrix or array
   * for which to get the QR decomposition.
   *
   * @return {{Q: Array | Matrix, R: Array | Matrix}} Q: the orthogonal
   * matrix and R: the upper triangular matrix
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($2f82469e03d52db2$exports)))(typed($f015874d25b628a8$var$name, {
        DenseMatrix: function DenseMatrix(m) {
            return _denseQR(m);
        },
        SparseMatrix: function SparseMatrix(m) {
            return _sparseQR(m);
        },
        Array: function Array(a) {
            // create dense matrix from array
            var m = matrix(a); // lup, use matrix implementation
            var r = _denseQR(m); // result
            return {
                Q: r.Q.valueOf(),
                R: r.R.valueOf()
            };
        }
    }), {
        _denseQRimpl: _denseQRimpl
    });
    function _denseQRimpl(m) {
        // rows & columns (m x n)
        var rows = m._size[0]; // m
        var cols = m._size[1]; // n
        var Q = identity([
            rows
        ], "dense");
        var Qdata = Q._data;
        var R = m.clone();
        var Rdata = R._data; // vars
        var i, j, k;
        var w = zeros([
            rows
        ], "");
        for(k = 0; k < Math.min(cols, rows); ++k){
            /*
       * **k-th Household matrix**
       *
       * The matrix I - 2*v*transpose(v)
       * x     = first column of A
       * x1    = first element of x
       * alpha = x1 / |x1| * |x|
       * e1    = tranpose([1, 0, 0, ...])
       * u     = x - alpha * e1
       * v     = u / |u|
       *
       * Household matrix = I - 2 * v * tranpose(v)
       *
       *  * Initially Q = I and R = A.
       *  * Household matrix is a reflection in a plane normal to v which
       *    will zero out all but the top right element in R.
       *  * Appplying reflection to both Q and R will not change product.
       *  * Repeat this process on the (1,1) minor to get R as an upper
       *    triangular matrix.
       *  * Reflections leave the magnitude of the columns of Q unchanged
       *    so Q remains othoganal.
       *
       */ var pivot = Rdata[k][k];
            var sgn = unaryMinus(equal(pivot, 0) ? 1 : sign(pivot));
            var conjSgn = conj(sgn);
            var alphaSquared = 0;
            for(i = k; i < rows; i++)alphaSquared = addScalar(alphaSquared, multiplyScalar(Rdata[i][k], conj(Rdata[i][k])));
            var alpha = multiplyScalar(sgn, sqrt(alphaSquared));
            if (!isZero(alpha)) {
                // first element in vector u
                var u1 = subtract(pivot, alpha); // w = v * u1 / |u|    (only elements k to (rows-1) are used)
                w[k] = 1;
                for(i = k + 1; i < rows; i++)w[i] = divideScalar(Rdata[i][k], u1);
                 // tau = - conj(u1 / alpha)
                var tau = unaryMinus(conj(divideScalar(u1, alpha)));
                var s = void 0;
                /*
         * tau and w have been choosen so that
         *
         * 2 * v * tranpose(v) = tau * w * tranpose(w)
         */ /*
         * -- calculate R = R - tau * w * tranpose(w) * R --
         * Only do calculation with rows k to (rows-1)
         * Additionally columns 0 to (k-1) will not be changed by this
         *   multiplication so do not bother recalculating them
         */ for(j = k; j < cols; j++){
                    s = 0.0; // calculate jth element of [tranpose(w) * R]
                    for(i = k; i < rows; i++)s = addScalar(s, multiplyScalar(conj(w[i]), Rdata[i][j]));
                     // calculate the jth element of [tau * transpose(w) * R]
                    s = multiplyScalar(s, tau);
                    for(i = k; i < rows; i++)Rdata[i][j] = multiplyScalar(subtract(Rdata[i][j], multiplyScalar(w[i], s)), conjSgn);
                }
                /*
         * -- calculate Q = Q - tau * Q * w * transpose(w) --
         * Q is a square matrix (rows x rows)
         * Only do calculation with columns k to (rows-1)
         * Additionally rows 0 to (k-1) will not be changed by this
         *   multiplication so do not bother recalculating them
         */ for(i = 0; i < rows; i++){
                    s = 0.0; // calculate ith element of [Q * w]
                    for(j = k; j < rows; j++)s = addScalar(s, multiplyScalar(Qdata[i][j], w[j]));
                     // calculate the ith element of [tau * Q * w]
                    s = multiplyScalar(s, tau);
                    for(j = k; j < rows; ++j)Qdata[i][j] = divideScalar(subtract(Qdata[i][j], multiplyScalar(s, conj(w[j]))), conjSgn);
                }
            }
        } // return matrices
        return {
            Q: Q,
            R: R,
            toString: function toString() {
                return "Q: " + this.Q.toString() + "\nR: " + this.R.toString();
            }
        };
    }
    function _denseQR(m) {
        var ret = _denseQRimpl(m);
        var Rdata = ret.R._data;
        if (m._data.length > 0) {
            var zero = Rdata[0][0].type === "Complex" ? complex(0) : 0;
            for(var i = 0; i < Rdata.length; ++i)for(var j = 0; j < i && j < (Rdata[0] || []).length; ++j)Rdata[i][j] = zero;
        }
        return ret;
    }
    function _sparseQR(m) {
        throw new Error("qr not implemented for sparse matrices yet");
    }
});



var $800a158788abd9d6$var$name = "range";
var $800a158788abd9d6$var$dependencies = [
    "typed",
    "config",
    "?matrix",
    "?bignumber",
    "smaller",
    "smallerEq",
    "larger",
    "largerEq"
];
var $800a158788abd9d6$export$d372f2f3c4d1b8e5 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($800a158788abd9d6$var$name, $800a158788abd9d6$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, matrix: matrix, bignumber: bignumber, smaller: smaller, smallerEq: smallerEq, larger: larger, largerEq: largerEq } = _ref;
    /**
   * Create an array from a range.
   * By default, the range end is excluded. This can be customized by providing
   * an extra parameter `includeEnd`.
   *
   * Syntax:
   *
   *     math.range(str [, includeEnd])               // Create a range from a string,
   *                                                  // where the string contains the
   *                                                  // start, optional step, and end,
   *                                                  // separated by a colon.
   *     math.range(start, end [, includeEnd])        // Create a range with start and
   *                                                  // end and a step size of 1.
   *     math.range(start, end, step [, includeEnd])  // Create a range with start, step,
   *                                                  // and end.
   *
   * Where:
   *
   * - `str: string`
   *   A string 'start:end' or 'start:step:end'
   * - `start: {number | BigNumber}`
   *   Start of the range
   * - `end: number | BigNumber`
   *   End of the range, excluded by default, included when parameter includeEnd=true
   * - `step: number | BigNumber`
   *   Step size. Default value is 1.
   * - `includeEnd: boolean`
   *   Option to specify whether to include the end or not. False by default.
   *
   * Examples:
   *
   *     math.range(2, 6)        // [2, 3, 4, 5]
   *     math.range(2, -3, -1)   // [2, 1, 0, -1, -2]
   *     math.range('2:1:6')     // [2, 3, 4, 5]
   *     math.range(2, 6, true)  // [2, 3, 4, 5, 6]
   *
   * See also:
   *
   *     ones, zeros, size, subset
   *
   * @param {*} args   Parameters describing the ranges `start`, `end`, and optional `step`.
   * @return {Array | Matrix} range
   */ return typed($800a158788abd9d6$var$name, {
        // TODO: simplify signatures when typed-function supports default values and optional arguments
        // TODO: a number or boolean should not be converted to string here
        string: _strRange,
        "string, boolean": _strRange,
        "number, number": function numberNumber(start, end) {
            return _out(_rangeEx(start, end, 1));
        },
        "number, number, number": function numberNumberNumber(start, end, step) {
            return _out(_rangeEx(start, end, step));
        },
        "number, number, boolean": function numberNumberBoolean(start, end, includeEnd) {
            return includeEnd ? _out(_rangeInc(start, end, 1)) : _out(_rangeEx(start, end, 1));
        },
        "number, number, number, boolean": function numberNumberNumberBoolean(start, end, step, includeEnd) {
            return includeEnd ? _out(_rangeInc(start, end, step)) : _out(_rangeEx(start, end, step));
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(start, end) {
            var BigNumber = start.constructor;
            return _out(_bigRangeEx(start, end, new BigNumber(1)));
        },
        "BigNumber, BigNumber, BigNumber": function BigNumberBigNumberBigNumber(start, end, step) {
            return _out(_bigRangeEx(start, end, step));
        },
        "BigNumber, BigNumber, boolean": function BigNumberBigNumberBoolean(start, end, includeEnd) {
            var BigNumber = start.constructor;
            return includeEnd ? _out(_bigRangeInc(start, end, new BigNumber(1))) : _out(_bigRangeEx(start, end, new BigNumber(1)));
        },
        "BigNumber, BigNumber, BigNumber, boolean": function BigNumberBigNumberBigNumberBoolean(start, end, step, includeEnd) {
            return includeEnd ? _out(_bigRangeInc(start, end, step)) : _out(_bigRangeEx(start, end, step));
        }
    });
    function _out(arr) {
        if (config.matrix === "Matrix") return matrix ? matrix(arr) : (0, $ca365da641461865$export$b81416cb7ecca475)();
        return arr;
    }
    function _strRange(str, includeEnd) {
        var r = _parse(str);
        if (!r) throw new SyntaxError('String "' + str + '" is no valid range');
        var fn;
        if (config.number === "BigNumber") {
            if (bignumber === undefined) (0, $ca365da641461865$export$f0829713dc162a8)();
            fn = includeEnd ? _bigRangeInc : _bigRangeEx;
            return _out(fn(bignumber(r.start), bignumber(r.end), bignumber(r.step)));
        } else {
            fn = includeEnd ? _rangeInc : _rangeEx;
            return _out(fn(r.start, r.end, r.step));
        }
    }
    /**
   * Create a range with numbers. End is excluded
   * @param {number} start
   * @param {number} end
   * @param {number} step
   * @returns {Array} range
   * @private
   */ function _rangeEx(start, end, step) {
        var array = [];
        var x = start;
        if (step > 0) while(smaller(x, end)){
            array.push(x);
            x += step;
        }
        else if (step < 0) while(larger(x, end)){
            array.push(x);
            x += step;
        }
        return array;
    }
    /**
   * Create a range with numbers. End is included
   * @param {number} start
   * @param {number} end
   * @param {number} step
   * @returns {Array} range
   * @private
   */ function _rangeInc(start, end, step) {
        var array = [];
        var x = start;
        if (step > 0) while(smallerEq(x, end)){
            array.push(x);
            x += step;
        }
        else if (step < 0) while(largerEq(x, end)){
            array.push(x);
            x += step;
        }
        return array;
    }
    /**
   * Create a range with big numbers. End is excluded
   * @param {BigNumber} start
   * @param {BigNumber} end
   * @param {BigNumber} step
   * @returns {Array} range
   * @private
   */ function _bigRangeEx(start, end, step) {
        var zero = bignumber(0);
        var array = [];
        var x = start;
        if (step.gt(zero)) while(smaller(x, end)){
            array.push(x);
            x = x.plus(step);
        }
        else if (step.lt(zero)) while(larger(x, end)){
            array.push(x);
            x = x.plus(step);
        }
        return array;
    }
    /**
   * Create a range with big numbers. End is included
   * @param {BigNumber} start
   * @param {BigNumber} end
   * @param {BigNumber} step
   * @returns {Array} range
   * @private
   */ function _bigRangeInc(start, end, step) {
        var zero = bignumber(0);
        var array = [];
        var x = start;
        if (step.gt(zero)) while(smallerEq(x, end)){
            array.push(x);
            x = x.plus(step);
        }
        else if (step.lt(zero)) while(largerEq(x, end)){
            array.push(x);
            x = x.plus(step);
        }
        return array;
    }
    /**
   * Parse a string into a range,
   * The string contains the start, optional step, and end, separated by a colon.
   * If the string does not contain a valid range, null is returned.
   * For example str='0:2:11'.
   * @param {string} str
   * @return {{start: number, end: number, step: number} | null} range Object containing properties start, end, step
   * @private
   */ function _parse(str) {
        var args = str.split(":"); // number
        var nums = args.map(function(arg) {
            // use Number and not parseFloat as Number returns NaN on invalid garbage in the string
            return Number(arg);
        });
        var invalid = nums.some(function(num) {
            return isNaN(num);
        });
        if (invalid) return null;
        switch(nums.length){
            case 2:
                return {
                    start: nums[0],
                    end: nums[1],
                    step: 1
                };
            case 3:
                return {
                    start: nums[0],
                    end: nums[2],
                    step: nums[1]
                };
            default:
                return null;
        }
    }
});










var $37a4e2e4508818f4$var$name = "rightLogShift";
var $37a4e2e4508818f4$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "zeros",
    "DenseMatrix"
];
var $37a4e2e4508818f4$export$2dd001e9fd66adcd = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($37a4e2e4508818f4$var$name, $37a4e2e4508818f4$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, zeros: zeros, DenseMatrix: DenseMatrix } = _ref;
    var algorithm01 = (0, $87b5a4e357abde7d$export$5e6d55d37a917802)({
        typed: typed
    });
    var algorithm02 = (0, $caf358e9c2d20263$export$92edb534a8f19a37)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm08 = (0, $77f7cfbe3a0de141$export$59a068f853cfbf8)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm10 = (0, $5e80d3fce4071128$export$72a88f2eee9ec1ed)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm11 = (0, $83b92f81e511657d$export$a38279a12199d831)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm13 = (0, $c68b38998aadcc11$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $533d58927c47005f$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Bitwise right logical shift of value x by y number of bits, `x >>> y`.
   * For matrices, the function is evaluated element wise.
   * For units, the function is evaluated on the best prefix base.
   *
   * Syntax:
   *
   *    math.rightLogShift(x, y)
   *
   * Examples:
   *
   *    math.rightLogShift(4, 2)               // returns number 1
   *
   *    math.rightLogShift([16, -32, 64], 4)   // returns Array [1, 2, 3]
   *
   * See also:
   *
   *    bitAnd, bitNot, bitOr, bitXor, leftShift, rightLogShift
   *
   * @param  {number | Array | Matrix} x Value to be shifted
   * @param  {number} y Amount of shifts
   * @return {number | Array | Matrix} `x` zero-filled shifted right `y` times
   */ return typed($37a4e2e4508818f4$var$name, {
        "number, number": (0, $ac33a15c81597bf3$export$2a8d1e3dcede6e47),
        // 'BigNumber, BigNumber': ..., // TODO: implement BigNumber support for rightLogShift
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm08(x, y, this, false);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, this, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm01(x, y, this, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, number | BigNumber": function SparseMatrixNumberBigNumber(x, y) {
            // check scalar
            if (equalScalar(y, 0)) return x.clone();
            return algorithm11(x, y, this, false);
        },
        "DenseMatrix, number | BigNumber": function DenseMatrixNumberBigNumber(x, y) {
            // check scalar
            if (equalScalar(y, 0)) return x.clone();
            return algorithm14(x, y, this, false);
        },
        "number | BigNumber, SparseMatrix": function numberBigNumberSparseMatrix(x, y) {
            // check scalar
            if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
            return algorithm10(y, x, this, true);
        },
        "number | BigNumber, DenseMatrix": function numberBigNumberDenseMatrix(x, y) {
            // check scalar
            if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
            return algorithm14(y, x, this, true);
        },
        "Array, number | BigNumber": function ArrayNumberBigNumber(x, y) {
            // use matrix implementation
            return this(matrix(x), y).valueOf();
        },
        "number | BigNumber, Array": function numberBigNumberArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y)).valueOf();
        }
    });
});



var $dedeed91a301fa74$var$name = "setSize";
var $dedeed91a301fa74$var$dependencies = [
    "typed",
    "compareNatural"
];
var $dedeed91a301fa74$export$55134310fc79366a = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($dedeed91a301fa74$var$name, $dedeed91a301fa74$var$dependencies, (_ref)=>{
    var { typed: typed, compareNatural: compareNatural } = _ref;
    /**
   * Count the number of elements of a (multi)set. When a second parameter is 'true', count only the unique values.
   * A multi-dimension array will be converted to a single-dimension array before the operation.
   *
   * Syntax:
   *
   *    math.setSize(set)
   *    math.setSize(set, unique)
   *
   * Examples:
   *
   *    math.setSize([1, 2, 2, 4])          // returns 4
   *    math.setSize([1, 2, 2, 4], true)    // returns 3
   *
   * See also:
   *
   *    setUnion, setIntersect, setDifference
   *
   * @param {Array | Matrix}    a  A multiset
   * @return {number}            The number of elements of the (multi)set
   */ return typed($dedeed91a301fa74$var$name, {
        "Array | Matrix": function ArrayMatrix(a) {
            return Array.isArray(a) ? (0, $a14a10567870d913$export$bffa455ba8c619a6)(a).length : (0, $a14a10567870d913$export$bffa455ba8c619a6)(a.toArray()).length;
        },
        "Array | Matrix, boolean": function ArrayMatrixBoolean(a, unique) {
            if (unique === false || a.length === 0) return Array.isArray(a) ? (0, $a14a10567870d913$export$bffa455ba8c619a6)(a).length : (0, $a14a10567870d913$export$bffa455ba8c619a6)(a.toArray()).length;
            else {
                var b = (0, $a14a10567870d913$export$bffa455ba8c619a6)(Array.isArray(a) ? a : a.toArray()).sort(compareNatural);
                var count = 1;
                for(var i = 1; i < b.length; i++)if (compareNatural(b[i], b[i - 1]) !== 0) count++;
                return count;
            }
        }
    });
});



/**
 * Permutes a sparse matrix C = P * A * Q
 *
 * @param {SparseMatrix}  a         The Matrix A
 * @param {Array}   pinv            The row permutation vector
 * @param {Array}   q               The column permutation vector
 * @param {boolean} values          Create a pattern matrix (false), values and pattern otherwise
 *
 * @return {Matrix}                 C = P * A * Q, null on error
 *
 * Reference: http://faculty.cse.tamu.edu/davis/publications.html
 */ function $5f7060a72de69718$export$76070a0ecffd0bb2(a, pinv, q, values) {
    // a arrays
    var avalues = a._values;
    var aindex = a._index;
    var aptr = a._ptr;
    var asize = a._size;
    var adt = a._datatype; // rows & columns
    var m = asize[0];
    var n = asize[1]; // c arrays
    var cvalues = values && a._values ? [] : null;
    var cindex = []; // (aptr[n])
    var cptr = []; // (n + 1)
    // initialize vars
    var nz = 0; // loop columns
    for(var k = 0; k < n; k++){
        // column k of C is column q[k] of A
        cptr[k] = nz; // apply column permutation
        var j = q ? q[k] : k; // loop values in column j of A
        for(var t0 = aptr[j], t1 = aptr[j + 1], t = t0; t < t1; t++){
            // row i of A is row pinv[i] of C
            var r = pinv ? pinv[aindex[t]] : aindex[t]; // index
            cindex[nz] = r; // check we need to populate values
            if (cvalues) cvalues[nz] = avalues[t];
             // increment number of nonzero elements
            nz++;
        }
    } // finalize the last column of C
    cptr[n] = nz; // return C matrix
    return a.createSparseMatrix({
        values: cvalues,
        index: cindex,
        ptr: cptr,
        size: [
            m,
            n
        ],
        datatype: adt
    });
}


/**
 * Depth-first search and postorder of a tree rooted at node j
 *
 * @param {Number}  j               The tree node
 * @param {Number}  k
 * @param {Array}   w               The workspace array
 * @param {Number}  head            The index offset within the workspace for the head array
 * @param {Number}  next            The index offset within the workspace for the next array
 * @param {Array}   post            The post ordering array
 * @param {Number}  stack           The index offset within the workspace for the stack array
 *
 * Reference: http://faculty.cse.tamu.edu/davis/publications.html
 */ function $f4b1497f97a7023b$export$18e42241aee7902a(j, k, w, head, next, post, stack) {
    // variables
    var top = 0; // place j on the stack
    w[stack] = j; // while (stack is not empty)
    while(top >= 0){
        // p = top of stack
        var p = w[stack + top]; // i = youngest child of p
        var i = w[head + p];
        if (i === -1) {
            // p has no unordered children left
            top--; // node p is the kth postordered node
            post[k++] = p;
        } else {
            // remove i from children of p
            w[head + p] = w[next + i]; // increment top
            ++top; // start dfs on child node i
            w[stack + top] = i;
        }
    }
    return k;
}


function $d34ca55802c8bef9$export$90626b0a5705891a(parent, n) {
    // check inputs
    if (!parent) return null;
     // vars
    var k = 0;
    var j; // allocate result
    var post = []; // (n)
    // workspace, head: first n entries, next: next n entries, stack: last n entries
    var w = []; // (3 * n)
    var head = 0;
    var next = n;
    var stack = 2 * n; // initialize workspace
    for(j = 0; j < n; j++)// empty linked lists
    w[head + j] = -1;
     // traverse nodes in reverse order
    for(j = n - 1; j >= 0; j--){
        // check j is a root
        if (parent[j] === -1) continue;
         // add j to list of its parent
        w[next + j] = w[head + parent[j]];
        w[head + parent[j]] = j;
    } // loop nodes
    for(j = 0; j < n; j++){
        // skip j if it is not a root
        if (parent[j] !== -1) continue;
         // depth-first search
        k = (0, $f4b1497f97a7023b$export$18e42241aee7902a)(j, k, w, head, next, post, stack);
    }
    return post;
}


/**
 * Computes the elimination tree of Matrix A (using triu(A)) or the
 * elimination tree of A'A without forming A'A.
 *
 * @param {Matrix}  a               The A Matrix
 * @param {boolean} ata             A value of true the function computes the etree of A'A
 *
 * Reference: http://faculty.cse.tamu.edu/davis/publications.html
 */ function $79401809a66095bf$export$720e2a9a0fdebf8c(a, ata) {
    // check inputs
    if (!a) return null;
     // a arrays
    var aindex = a._index;
    var aptr = a._ptr;
    var asize = a._size; // rows & columns
    var m = asize[0];
    var n = asize[1]; // allocate result
    var parent = []; // (n)
    // allocate workspace
    var w = []; // (n + (ata ? m : 0))
    var ancestor = 0; // first n entries in w
    var prev = n; // last m entries (ata = true)
    var i, inext; // check we are calculating A'A
    if (ata) // initialize workspace
    for(i = 0; i < m; i++)w[prev + i] = -1;
     // loop columns
    for(var k = 0; k < n; k++){
        // node k has no parent yet
        parent[k] = -1; // nor does k have an ancestor
        w[ancestor + k] = -1; // values in column k
        for(var p0 = aptr[k], p1 = aptr[k + 1], p = p0; p < p1; p++){
            // row
            var r = aindex[p]; // node
            i = ata ? w[prev + r] : r; // traverse from i to k
            for(; i !== -1 && i < k; i = inext){
                // inext = ancestor of i
                inext = w[ancestor + i]; // path compression
                w[ancestor + i] = k; // check no anc., parent is k
                if (inext === -1) parent[i] = k;
            }
            if (ata) w[prev + r] = k;
        }
    }
    return parent;
}



/**
 * Keeps entries in the matrix when the callback function returns true, removes the entry otherwise
 *
 * @param {Matrix}   a              The sparse matrix
 * @param {function} callback       The callback function, function will be invoked with the following args:
 *                                    - The entry row
 *                                    - The entry column
 *                                    - The entry value
 *                                    - The state parameter
 * @param {any}      other          The state
 *
 * @return                          The number of nonzero elements in the matrix
 *
 * Reference: http://faculty.cse.tamu.edu/davis/publications.html
 */ function $5f699a5a307852f6$export$9453433d9395b8cb(a, callback, other) {
    // a arrays
    var avalues = a._values;
    var aindex = a._index;
    var aptr = a._ptr;
    var asize = a._size; // columns
    var n = asize[1]; // nonzero items
    var nz = 0; // loop columns
    for(var j = 0; j < n; j++){
        // get current location of col j
        var p = aptr[j]; // record new location of col j
        aptr[j] = nz;
        for(; p < aptr[j + 1]; p++)// check we need to keep this item
        if (callback(aindex[p], j, avalues ? avalues[p] : 1, other)) {
            // keep A(i,j)
            aindex[nz] = aindex[p]; // check we need to process values (pattern only)
            if (avalues) avalues[nz] = avalues[p];
             // increment nonzero items
            nz++;
        }
    } // finalize A
    aptr[n] = nz; // trim arrays
    aindex.splice(nz, aindex.length - nz); // check we need to process values (pattern only)
    if (avalues) avalues.splice(nz, avalues.length - nz);
     // return number of nonzero items
    return nz;
}


/**
 * This function "flips" its input about the integer -1.
 *
 * @param {Number}  i               The value to flip
 *
 * Reference: http://faculty.cse.tamu.edu/davis/publications.html
 */ function $d5529e3dc3ec2a9e$export$d405b3d9168b83fa(i) {
    // flip the value
    return -i - 2;
}



var $9cc6e1a5a4364ef7$var$name = "csAmd";
var $9cc6e1a5a4364ef7$var$dependencies = [
    "add",
    "multiply",
    "transpose"
];
var $9cc6e1a5a4364ef7$export$485230eb48878637 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($9cc6e1a5a4364ef7$var$name, $9cc6e1a5a4364ef7$var$dependencies, (_ref)=>{
    var { add: add, multiply: multiply, transpose: transpose } = _ref;
    /**
   * Approximate minimum degree ordering. The minimum degree algorithm is a widely used
   * heuristic for finding a permutation P so that P*A*P' has fewer nonzeros in its factorization
   * than A. It is a gready method that selects the sparsest pivot row and column during the course
   * of a right looking sparse Cholesky factorization.
   *
   * Reference: http://faculty.cse.tamu.edu/davis/publications.html
   *
   * @param {Number} order    0: Natural, 1: Cholesky, 2: LU, 3: QR
   * @param {Matrix} m        Sparse Matrix
   */ return function csAmd(order, a) {
        // check input parameters
        if (!a || order <= 0 || order > 3) return null;
         // a matrix arrays
        var asize = a._size; // rows and columns
        var m = asize[0];
        var n = asize[1]; // initialize vars
        var lemax = 0; // dense threshold
        var dense = Math.max(16, 10 * Math.sqrt(n));
        dense = Math.min(n - 2, dense); // create target matrix C
        var cm = _createTargetMatrix(order, a, m, n, dense); // drop diagonal entries
        (0, $5f699a5a307852f6$export$9453433d9395b8cb)(cm, _diag, null); // C matrix arrays
        var cindex = cm._index;
        var cptr = cm._ptr; // number of nonzero elements in C
        var cnz = cptr[n]; // allocate result (n+1)
        var P = []; // create workspace (8 * (n + 1))
        var W = [];
        var len = 0; // first n + 1 entries
        var nv = n + 1; // next n + 1 entries
        var next = 2 * (n + 1); // next n + 1 entries
        var head = 3 * (n + 1); // next n + 1 entries
        var elen = 4 * (n + 1); // next n + 1 entries
        var degree = 5 * (n + 1); // next n + 1 entries
        var w = 6 * (n + 1); // next n + 1 entries
        var hhead = 7 * (n + 1); // last n + 1 entries
        // use P as workspace for last
        var last = P; // initialize quotient graph
        var mark = _initializeQuotientGraph(n, cptr, W, len, head, last, next, hhead, nv, w, elen, degree); // initialize degree lists
        var nel = _initializeDegreeLists(n, cptr, W, degree, elen, w, dense, nv, head, last, next); // minimum degree node
        var mindeg = 0; // vars
        var i, j, k, k1, k2, e, pj, ln, nvi, pk, eln, p1, p2, pn, h, d; // while (selecting pivots) do
        while(nel < n){
            // select node of minimum approximate degree. amd() is now ready to start eliminating the graph. It first
            // finds a node k of minimum degree and removes it from its degree list. The variable nel keeps track of thow
            // many nodes have been eliminated.
            for(k = -1; mindeg < n && (k = W[head + mindeg]) === -1; mindeg++);
            if (W[next + k] !== -1) last[W[next + k]] = -1;
             // remove k from degree list
            W[head + mindeg] = W[next + k]; // elenk = |Ek|
            var elenk = W[elen + k]; // # of nodes k represents
            var nvk = W[nv + k]; // W[nv + k] nodes of A eliminated
            nel += nvk; // Construct a new element. The new element Lk is constructed in place if |Ek| = 0. nv[i] is
            // negated for all nodes i in Lk to flag them as members of this set. Each node i is removed from the
            // degree lists. All elements e in Ek are absorved into element k.
            var dk = 0; // flag k as in Lk
            W[nv + k] = -nvk;
            var p = cptr[k]; // do in place if W[elen + k] === 0
            var pk1 = elenk === 0 ? p : cnz;
            var pk2 = pk1;
            for(k1 = 1; k1 <= elenk + 1; k1++){
                if (k1 > elenk) {
                    // search the nodes in k
                    e = k; // list of nodes starts at cindex[pj]
                    pj = p; // length of list of nodes in k
                    ln = W[len + k] - elenk;
                } else {
                    // search the nodes in e
                    e = cindex[p++];
                    pj = cptr[e]; // length of list of nodes in e
                    ln = W[len + e];
                }
                for(k2 = 1; k2 <= ln; k2++){
                    i = cindex[pj++]; // check  node i dead, or seen
                    if ((nvi = W[nv + i]) <= 0) continue;
                     // W[degree + Lk] += size of node i
                    dk += nvi; // negate W[nv + i] to denote i in Lk
                    W[nv + i] = -nvi; // place i in Lk
                    cindex[pk2++] = i;
                    if (W[next + i] !== -1) last[W[next + i]] = last[i];
                     // check we need to remove i from degree list
                    if (last[i] !== -1) W[next + last[i]] = W[next + i];
                    else W[head + W[degree + i]] = W[next + i];
                }
                if (e !== k) {
                    // absorb e into k
                    cptr[e] = (0, $d5529e3dc3ec2a9e$export$d405b3d9168b83fa)(k); // e is now a dead element
                    W[w + e] = 0;
                }
            } // cindex[cnz...nzmax] is free
            if (elenk !== 0) cnz = pk2;
             // external degree of k - |Lk\i|
            W[degree + k] = dk; // element k is in cindex[pk1..pk2-1]
            cptr[k] = pk1;
            W[len + k] = pk2 - pk1; // k is now an element
            W[elen + k] = -2; // Find set differences. The scan1 function now computes the set differences |Le \ Lk| for all elements e. At the start of the
            // scan, no entry in the w array is greater than or equal to mark.
            // clear w if necessary
            mark = _wclear(mark, lemax, W, w, n); // scan 1: find |Le\Lk|
            for(pk = pk1; pk < pk2; pk++){
                i = cindex[pk]; // check if W[elen + i] empty, skip it
                if ((eln = W[elen + i]) <= 0) continue;
                 // W[nv + i] was negated
                nvi = -W[nv + i];
                var wnvi = mark - nvi; // scan Ei
                for(p = cptr[i], p1 = cptr[i] + eln - 1; p <= p1; p++){
                    e = cindex[p];
                    if (W[w + e] >= mark) // decrement |Le\Lk|
                    W[w + e] -= nvi;
                    else if (W[w + e] !== 0) // ensure e is a live element, 1st time e seen in scan 1
                    W[w + e] = W[degree + e] + wnvi;
                }
            } // degree update
            // The second pass computes the approximate degree di, prunes the sets Ei and Ai, and computes a hash
            // function h(i) for all nodes in Lk.
            // scan2: degree update
            for(pk = pk1; pk < pk2; pk++){
                // consider node i in Lk
                i = cindex[pk];
                p1 = cptr[i];
                p2 = p1 + W[elen + i] - 1;
                pn = p1; // scan Ei
                for(h = 0, d = 0, p = p1; p <= p2; p++){
                    e = cindex[p]; // check e is an unabsorbed element
                    if (W[w + e] !== 0) {
                        // dext = |Le\Lk|
                        var dext = W[w + e] - mark;
                        if (dext > 0) {
                            // sum up the set differences
                            d += dext; // keep e in Ei
                            cindex[pn++] = e; // compute the hash of node i
                            h += e;
                        } else {
                            // aggressive absorb. e->k
                            cptr[e] = (0, $d5529e3dc3ec2a9e$export$d405b3d9168b83fa)(k); // e is a dead element
                            W[w + e] = 0;
                        }
                    }
                } // W[elen + i] = |Ei|
                W[elen + i] = pn - p1 + 1;
                var p3 = pn;
                var p4 = p1 + W[len + i]; // prune edges in Ai
                for(p = p2 + 1; p < p4; p++){
                    j = cindex[p]; // check node j dead or in Lk
                    var nvj = W[nv + j];
                    if (nvj <= 0) continue;
                     // degree(i) += |j|
                    d += nvj; // place j in node list of i
                    cindex[pn++] = j; // compute hash for node i
                    h += j;
                } // check for mass elimination
                if (d === 0) {
                    // absorb i into k
                    cptr[i] = (0, $d5529e3dc3ec2a9e$export$d405b3d9168b83fa)(k);
                    nvi = -W[nv + i]; // |Lk| -= |i|
                    dk -= nvi; // |k| += W[nv + i]
                    nvk += nvi;
                    nel += nvi;
                    W[nv + i] = 0; // node i is dead
                    W[elen + i] = -1;
                } else {
                    // update degree(i)
                    W[degree + i] = Math.min(W[degree + i], d); // move first node to end
                    cindex[pn] = cindex[p3]; // move 1st el. to end of Ei
                    cindex[p3] = cindex[p1]; // add k as 1st element in of Ei
                    cindex[p1] = k; // new len of adj. list of node i
                    W[len + i] = pn - p1 + 1; // finalize hash of i
                    h = (h < 0 ? -h : h) % n; // place i in hash bucket
                    W[next + i] = W[hhead + h];
                    W[hhead + h] = i; // save hash of i in last[i]
                    last[i] = h;
                }
            } // finalize |Lk|
            W[degree + k] = dk;
            lemax = Math.max(lemax, dk); // clear w
            mark = _wclear(mark + lemax, lemax, W, w, n); // Supernode detection. Supernode detection relies on the hash function h(i) computed for each node i.
            // If two nodes have identical adjacency lists, their hash functions wil be identical.
            for(pk = pk1; pk < pk2; pk++){
                i = cindex[pk]; // check i is dead, skip it
                if (W[nv + i] >= 0) continue;
                 // scan hash bucket of node i
                h = last[i];
                i = W[hhead + h]; // hash bucket will be empty
                W[hhead + h] = -1;
                for(; i !== -1 && W[next + i] !== -1; i = W[next + i], mark++){
                    ln = W[len + i];
                    eln = W[elen + i];
                    for(p = cptr[i] + 1; p <= cptr[i] + ln - 1; p++)W[w + cindex[p]] = mark;
                    var jlast = i; // compare i with all j
                    for(j = W[next + i]; j !== -1;){
                        var ok = W[len + j] === ln && W[elen + j] === eln;
                        for(p = cptr[j] + 1; ok && p <= cptr[j] + ln - 1; p++)// compare i and j
                        if (W[w + cindex[p]] !== mark) ok = 0;
                         // check i and j are identical
                        if (ok) {
                            // absorb j into i
                            cptr[j] = (0, $d5529e3dc3ec2a9e$export$d405b3d9168b83fa)(i);
                            W[nv + i] += W[nv + j];
                            W[nv + j] = 0; // node j is dead
                            W[elen + j] = -1; // delete j from hash bucket
                            j = W[next + j];
                            W[next + jlast] = j;
                        } else {
                            // j and i are different
                            jlast = j;
                            j = W[next + j];
                        }
                    }
                }
            } // Finalize new element. The elimination of node k is nearly complete. All nodes i in Lk are scanned one last time.
            // Node i is removed from Lk if it is dead. The flagged status of nv[i] is cleared.
            for(p = pk1, pk = pk1; pk < pk2; pk++){
                i = cindex[pk]; // check  i is dead, skip it
                if ((nvi = -W[nv + i]) <= 0) continue;
                 // restore W[nv + i]
                W[nv + i] = nvi; // compute external degree(i)
                d = W[degree + i] + dk - nvi;
                d = Math.min(d, n - nel - nvi);
                if (W[head + d] !== -1) last[W[head + d]] = i;
                 // put i back in degree list
                W[next + i] = W[head + d];
                last[i] = -1;
                W[head + d] = i; // find new minimum degree
                mindeg = Math.min(mindeg, d);
                W[degree + i] = d; // place i in Lk
                cindex[p++] = i;
            } // # nodes absorbed into k
            W[nv + k] = nvk; // length of adj list of element k
            if ((W[len + k] = p - pk1) === 0) {
                // k is a root of the tree
                cptr[k] = -1; // k is now a dead element
                W[w + k] = 0;
            }
            if (elenk !== 0) // free unused space in Lk
            cnz = p;
        } // Postordering. The elimination is complete, but no permutation has been computed. All that is left
        // of the graph is the assembly tree (ptr) and a set of dead nodes and elements (i is a dead node if
        // nv[i] is zero and a dead element if nv[i] > 0). It is from this information only that the final permutation
        // is computed. The tree is restored by unflipping all of ptr.
        // fix assembly tree
        for(i = 0; i < n; i++)cptr[i] = (0, $d5529e3dc3ec2a9e$export$d405b3d9168b83fa)(cptr[i]);
        for(j = 0; j <= n; j++)W[head + j] = -1;
         // place unordered nodes in lists
        for(j = n; j >= 0; j--){
            // skip if j is an element
            if (W[nv + j] > 0) continue;
             // place j in list of its parent
            W[next + j] = W[head + cptr[j]];
            W[head + cptr[j]] = j;
        } // place elements in lists
        for(e = n; e >= 0; e--){
            // skip unless e is an element
            if (W[nv + e] <= 0) continue;
            if (cptr[e] !== -1) {
                // place e in list of its parent
                W[next + e] = W[head + cptr[e]];
                W[head + cptr[e]] = e;
            }
        } // postorder the assembly tree
        for(k = 0, i = 0; i <= n; i++)if (cptr[i] === -1) k = (0, $f4b1497f97a7023b$export$18e42241aee7902a)(i, k, W, head, next, P, w);
         // remove last item in array
        P.splice(P.length - 1, 1); // return P
        return P;
    };
    /**
   * Creates the matrix that will be used by the approximate minimum degree ordering algorithm. The function accepts the matrix M as input and returns a permutation
   * vector P. The amd algorithm operates on a symmetrix matrix, so one of three symmetric matrices is formed.
   *
   * Order: 0
   *   A natural ordering P=null matrix is returned.
   *
   * Order: 1
   *   Matrix must be square. This is appropriate for a Cholesky or LU factorization.
   *   P = M + M'
   *
   * Order: 2
   *   Dense columns from M' are dropped, M recreated from M'. This is appropriatefor LU factorization of unsymmetric matrices.
   *   P = M' * M
   *
   * Order: 3
   *   This is best used for QR factorization or LU factorization is matrix M has no dense rows. A dense row is a row with more than 10*sqr(columns) entries.
   *   P = M' * M
   */ function _createTargetMatrix(order, a, m, n, dense) {
        // compute A'
        var at = transpose(a); // check order = 1, matrix must be square
        if (order === 1 && n === m) // C = A + A'
        return add(a, at);
         // check order = 2, drop dense columns from M'
        if (order === 2) {
            // transpose arrays
            var tindex = at._index;
            var tptr = at._ptr; // new column index
            var p2 = 0; // loop A' columns (rows)
            for(var j = 0; j < m; j++){
                // column j of AT starts here
                var p = tptr[j]; // new column j starts here
                tptr[j] = p2; // skip dense col j
                if (tptr[j + 1] - p > dense) continue;
                 // map rows in column j of A
                for(var p1 = tptr[j + 1]; p < p1; p++)tindex[p2++] = tindex[p];
            } // finalize AT
            tptr[m] = p2; // recreate A from new transpose matrix
            a = transpose(at); // use A' * A
            return multiply(at, a);
        } // use A' * A, square or rectangular matrix
        return multiply(at, a);
    }
    /**
   * Initialize quotient graph. There are four kind of nodes and elements that must be represented:
   *
   *  - A live node is a node i (or a supernode) that has not been selected as a pivot nad has not been merged into another supernode.
   *  - A dead node i is one that has been removed from the graph, having been absorved into r = flip(ptr[i]).
   *  - A live element e is one that is in the graph, having been formed when node e was selected as the pivot.
   *  - A dead element e is one that has benn absorved into a subsequent element s = flip(ptr[e]).
   */ function _initializeQuotientGraph(n, cptr, W, len, head, last, next, hhead, nv, w, elen, degree) {
        // Initialize quotient graph
        for(var k = 0; k < n; k++)W[len + k] = cptr[k + 1] - cptr[k];
        W[len + n] = 0; // initialize workspace
        for(var i = 0; i <= n; i++){
            // degree list i is empty
            W[head + i] = -1;
            last[i] = -1;
            W[next + i] = -1; // hash list i is empty
            W[hhead + i] = -1; // node i is just one node
            W[nv + i] = 1; // node i is alive
            W[w + i] = 1; // Ek of node i is empty
            W[elen + i] = 0; // degree of node i
            W[degree + i] = W[len + i];
        } // clear w
        var mark = _wclear(0, 0, W, w, n); // n is a dead element
        W[elen + n] = -2; // n is a root of assembly tree
        cptr[n] = -1; // n is a dead element
        W[w + n] = 0; // return mark
        return mark;
    }
    /**
   * Initialize degree lists. Each node is placed in its degree lists. Nodes of zero degree are eliminated immediately. Nodes with
   * degree >= dense are alsol eliminated and merged into a placeholder node n, a dead element. Thes nodes will appera last in the
   * output permutation p.
   */ function _initializeDegreeLists(n, cptr, W, degree, elen, w, dense, nv, head, last, next) {
        // result
        var nel = 0; // loop columns
        for(var i = 0; i < n; i++){
            // degree @ i
            var d = W[degree + i]; // check node i is empty
            if (d === 0) {
                // element i is dead
                W[elen + i] = -2;
                nel++; // i is a root of assembly tree
                cptr[i] = -1;
                W[w + i] = 0;
            } else if (d > dense) {
                // absorb i into element n
                W[nv + i] = 0; // node i is dead
                W[elen + i] = -1;
                nel++;
                cptr[i] = (0, $d5529e3dc3ec2a9e$export$d405b3d9168b83fa)(n);
                W[nv + n]++;
            } else {
                var h = W[head + d];
                if (h !== -1) last[h] = i;
                 // put node i in degree list d
                W[next + i] = W[head + d];
                W[head + d] = i;
            }
        }
        return nel;
    }
    function _wclear(mark, lemax, W, w, n) {
        if (mark < 2 || mark + lemax < 0) {
            for(var k = 0; k < n; k++)if (W[w + k] !== 0) W[w + k] = 1;
            mark = 2;
        } // at this point, W [0..n-1] < mark holds
        return mark;
    }
    function _diag(i, j) {
        return i !== j;
    }
});



/**
 * This function determines if j is a leaf of the ith row subtree.
 * Consider A(i,j), node j in ith row subtree and return lca(jprev,j)
 *
 * @param {Number}  i               The ith row subtree
 * @param {Number}  j               The node to test
 * @param {Array}   w               The workspace array
 * @param {Number}  first           The index offset within the workspace for the first array
 * @param {Number}  maxfirst        The index offset within the workspace for the maxfirst array
 * @param {Number}  prevleaf        The index offset within the workspace for the prevleaf array
 * @param {Number}  ancestor        The index offset within the workspace for the ancestor array
 *
 * @return {Object}
 *
 * Reference: http://faculty.cse.tamu.edu/davis/publications.html
 */ function $a94648c5340751ed$export$e5adc9884f74ac27(i, j, w, first, maxfirst, prevleaf, ancestor) {
    var s, sparent; // our result
    var jleaf = 0;
    var q; // check j is a leaf
    if (i <= j || w[first + j] <= w[maxfirst + i]) return -1;
     // update max first[j] seen so far
    w[maxfirst + i] = w[first + j]; // jprev = previous leaf of ith subtree
    var jprev = w[prevleaf + i];
    w[prevleaf + i] = j; // check j is first or subsequent leaf
    if (jprev === -1) {
        // 1st leaf, q = root of ith subtree
        jleaf = 1;
        q = i;
    } else {
        // update jleaf
        jleaf = 2; // q = least common ancester (jprev,j)
        for(q = jprev; q !== w[ancestor + q]; q = w[ancestor + q]);
        for(s = jprev; s !== q; s = sparent){
            // path compression
            sparent = w[ancestor + s];
            w[ancestor + s] = q;
        }
    }
    return {
        jleaf: jleaf,
        q: q
    };
}


var $eac5d8c5c3b060c2$var$name = "csCounts";
var $eac5d8c5c3b060c2$var$dependencies = [
    "transpose"
];
var $eac5d8c5c3b060c2$export$1feb4fbda2abf3b3 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($eac5d8c5c3b060c2$var$name, $eac5d8c5c3b060c2$var$dependencies, (_ref)=>{
    var { transpose: transpose } = _ref;
    /**
   * Computes the column counts using the upper triangular part of A.
   * It transposes A internally, none of the input parameters are modified.
   *
   * @param {Matrix} a           The sparse matrix A
   *
   * @param {Matrix} ata         Count the columns of A'A instead
   *
   * @return                     An array of size n of the column counts or null on error
   *
   * Reference: http://faculty.cse.tamu.edu/davis/publications.html
   */ return function(a, parent, post, ata) {
        // check inputs
        if (!a || !parent || !post) return null;
         // a matrix arrays
        var asize = a._size; // rows and columns
        var m = asize[0];
        var n = asize[1]; // variables
        var i, j, k, J, p, p0, p1; // workspace size
        var s = 4 * n + (ata ? n + m + 1 : 0); // allocate workspace
        var w = []; // (s)
        var ancestor = 0; // first n entries
        var maxfirst = n; // next n entries
        var prevleaf = 2 * n; // next n entries
        var first = 3 * n; // next n entries
        var head = 4 * n; // next n + 1 entries (used when ata is true)
        var next = 5 * n + 1; // last entries in workspace
        // clear workspace w[0..s-1]
        for(k = 0; k < s; k++)w[k] = -1;
         // allocate result
        var colcount = []; // (n)
        // AT = A'
        var at = transpose(a); // at arrays
        var tindex = at._index;
        var tptr = at._ptr; // find w[first + j]
        for(k = 0; k < n; k++){
            j = post[k]; // colcount[j]=1 if j is a leaf
            colcount[j] = w[first + j] === -1 ? 1 : 0;
            for(; j !== -1 && w[first + j] === -1; j = parent[j])w[first + j] = k;
        } // initialize ata if needed
        if (ata) {
            // invert post
            for(k = 0; k < n; k++)w[post[k]] = k;
             // loop rows (columns in AT)
            for(i = 0; i < m; i++){
                // values in column i of AT
                for(k = n, p0 = tptr[i], p1 = tptr[i + 1], p = p0; p < p1; p++)k = Math.min(k, w[tindex[p]]);
                 // place row i in linked list k
                w[next + i] = w[head + k];
                w[head + k] = i;
            }
        } // each node in its own set
        for(i = 0; i < n; i++)w[ancestor + i] = i;
        for(k = 0; k < n; k++){
            // j is the kth node in postordered etree
            j = post[k]; // check j is not a root
            if (parent[j] !== -1) colcount[parent[j]]--;
             // J=j for LL'=A case
            for(J = ata ? w[head + k] : j; J !== -1; J = ata ? w[next + J] : -1)for(p = tptr[J]; p < tptr[J + 1]; p++){
                i = tindex[p];
                var r = (0, $a94648c5340751ed$export$e5adc9884f74ac27)(i, j, w, first, maxfirst, prevleaf, ancestor); // check A(i,j) is in skeleton
                if (r.jleaf >= 1) colcount[j]++;
                 // check account for overlap in q
                if (r.jleaf === 2) colcount[r.q]--;
            }
            if (parent[j] !== -1) w[ancestor + j] = parent[j];
        } // sum up colcount's of each child
        for(j = 0; j < n; j++)if (parent[j] !== -1) colcount[parent[j]] += colcount[j];
        return colcount;
    };
});



var $b4ecbec722deadf4$var$name = "csSqr";
var $b4ecbec722deadf4$var$dependencies = [
    "add",
    "multiply",
    "transpose"
];
var $b4ecbec722deadf4$export$4d3f338d9cfe48c1 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($b4ecbec722deadf4$var$name, $b4ecbec722deadf4$var$dependencies, (_ref)=>{
    var { add: add, multiply: multiply, transpose: transpose } = _ref;
    var csAmd = (0, $9cc6e1a5a4364ef7$export$485230eb48878637)({
        add: add,
        multiply: multiply,
        transpose: transpose
    });
    var csCounts = (0, $eac5d8c5c3b060c2$export$1feb4fbda2abf3b3)({
        transpose: transpose
    });
    /**
   * Symbolic ordering and analysis for QR and LU decompositions.
   *
   * @param {Number}  order           The ordering strategy (see csAmd for more details)
   * @param {Matrix}  a               The A matrix
   * @param {boolean} qr              Symbolic ordering and analysis for QR decomposition (true) or
   *                                  symbolic ordering and analysis for LU decomposition (false)
   *
   * @return {Object}                 The Symbolic ordering and analysis for matrix A
   *
   * Reference: http://faculty.cse.tamu.edu/davis/publications.html
   */ return function csSqr(order, a, qr) {
        // a arrays
        var aptr = a._ptr;
        var asize = a._size; // columns
        var n = asize[1]; // vars
        var k; // symbolic analysis result
        var s = {}; // fill-reducing ordering
        s.q = csAmd(order, a); // validate results
        if (order && !s.q) return null;
         // QR symbolic analysis
        if (qr) {
            // apply permutations if needed
            var c = order ? (0, $5f7060a72de69718$export$76070a0ecffd0bb2)(a, null, s.q, 0) : a; // etree of C'*C, where C=A(:,q)
            s.parent = (0, $79401809a66095bf$export$720e2a9a0fdebf8c)(c, 1); // post order elimination tree
            var post = (0, $d34ca55802c8bef9$export$90626b0a5705891a)(s.parent, n); // col counts chol(C'*C)
            s.cp = csCounts(c, s.parent, post, 1); // check we have everything needed to calculate number of nonzero elements
            if (c && s.parent && s.cp && _vcount(c, s)) // calculate number of nonzero elements
            for(s.unz = 0, k = 0; k < n; k++)s.unz += s.cp[k];
        } else {
            // for LU factorization only, guess nnz(L) and nnz(U)
            s.unz = 4 * aptr[n] + n;
            s.lnz = s.unz;
        } // return result S
        return s;
    };
    /**
   * Compute nnz(V) = s.lnz, s.pinv, s.leftmost, s.m2 from A and s.parent
   */ function _vcount(a, s) {
        // a arrays
        var aptr = a._ptr;
        var aindex = a._index;
        var asize = a._size; // rows & columns
        var m = asize[0];
        var n = asize[1]; // initialize s arrays
        s.pinv = []; // (m + n)
        s.leftmost = []; // (m)
        // vars
        var parent = s.parent;
        var pinv = s.pinv;
        var leftmost = s.leftmost; // workspace, next: first m entries, head: next n entries, tail: next n entries, nque: next n entries
        var w = []; // (m + 3 * n)
        var next = 0;
        var head = m;
        var tail = m + n;
        var nque = m + 2 * n; // vars
        var i, k, p, p0, p1; // initialize w
        for(k = 0; k < n; k++){
            // queue k is empty
            w[head + k] = -1;
            w[tail + k] = -1;
            w[nque + k] = 0;
        } // initialize row arrays
        for(i = 0; i < m; i++)leftmost[i] = -1;
         // loop columns backwards
        for(k = n - 1; k >= 0; k--)// values & index for column k
        for(p0 = aptr[k], p1 = aptr[k + 1], p = p0; p < p1; p++)// leftmost[i] = min(find(A(i,:)))
        leftmost[aindex[p]] = k;
         // scan rows in reverse order
        for(i = m - 1; i >= 0; i--){
            // row i is not yet ordered
            pinv[i] = -1;
            k = leftmost[i]; // check row i is empty
            if (k === -1) continue;
             // first row in queue k
            if (w[nque + k]++ === 0) w[tail + k] = i;
             // put i at head of queue k
            w[next + i] = w[head + k];
            w[head + k] = i;
        }
        s.lnz = 0;
        s.m2 = m; // find row permutation and nnz(V)
        for(k = 0; k < n; k++){
            // remove row i from queue k
            i = w[head + k]; // count V(k,k) as nonzero
            s.lnz++; // add a fictitious row
            if (i < 0) i = s.m2++;
             // associate row i with V(:,k)
            pinv[i] = k; // skip if V(k+1:m,k) is empty
            if (--nque[k] <= 0) continue;
             // nque[k] is nnz (V(k+1:m,k))
            s.lnz += w[nque + k]; // move all rows to parent of k
            var pa = parent[k];
            if (pa !== -1) {
                if (w[nque + pa] === 0) w[tail + pa] = w[tail + k];
                w[next + w[tail + k]] = w[head + pa];
                w[head + pa] = w[next + i];
                w[nque + pa] += w[nque + k];
            }
        }
        for(i = 0; i < m; i++)if (pinv[i] < 0) pinv[i] = k++;
        return true;
    }
});



/**
 * Checks if the node at w[j] is marked
 *
 * @param {Array}   w               The array
 * @param {Number}  j               The array index
 *
 * Reference: http://faculty.cse.tamu.edu/davis/publications.html
 */ function $0b34c88646cdf563$export$f0d640c1b5bfa3e(w, j) {
    // check node is marked
    return w[j] < 0;
}



function $e6b2e1f4b754a406$export$53b20e7656f0b914(w, j) {
    // mark w[j]
    w[j] = (0, $d5529e3dc3ec2a9e$export$d405b3d9168b83fa)(w[j]);
}





function $f29790a28d565600$export$8b1bf205e2e76d92(i) {
    // flip the value if it is negative
    return i < 0 ? (0, $d5529e3dc3ec2a9e$export$d405b3d9168b83fa)(i) : i;
}


function $7e44a5dd0cc3ee43$export$c913fe476af3832b(j, g, top, xi, pinv) {
    // g arrays
    var index = g._index;
    var ptr = g._ptr;
    var size = g._size; // columns
    var n = size[1]; // vars
    var i, p, p2; // initialize head
    var head = 0; // initialize the recursion stack
    xi[0] = j; // loop
    while(head >= 0){
        // get j from the top of the recursion stack
        j = xi[head]; // apply permutation vector
        var jnew = pinv ? pinv[j] : j; // check node j is marked
        if (!(0, $0b34c88646cdf563$export$f0d640c1b5bfa3e)(ptr, j)) {
            // mark node j as visited
            (0, $e6b2e1f4b754a406$export$53b20e7656f0b914)(ptr, j); // update stack (last n entries in xi)
            xi[n + head] = jnew < 0 ? 0 : (0, $f29790a28d565600$export$8b1bf205e2e76d92)(ptr[jnew]);
        } // node j done if no unvisited neighbors
        var done = 1; // examine all neighbors of j, stack (last n entries in xi)
        for(p = xi[n + head], p2 = jnew < 0 ? 0 : (0, $f29790a28d565600$export$8b1bf205e2e76d92)(ptr[jnew + 1]); p < p2; p++){
            // consider neighbor node i
            i = index[p]; // check we have visited node i, skip it
            if ((0, $0b34c88646cdf563$export$f0d640c1b5bfa3e)(ptr, i)) continue;
             // pause depth-first search of node j, update stack (last n entries in xi)
            xi[n + head] = p; // start dfs at node i
            xi[++head] = i; // node j is not done
            done = 0; // break, to start dfs(i)
            break;
        } // check depth-first search at node j is done
        if (done) {
            // remove j from the recursion stack
            head--; // and place in the output stack
            xi[--top] = j;
        }
    }
    return top;
}


function $289a01f2f9ae619b$export$125cefbcd149ec98(g, b, k, xi, pinv) {
    // g arrays
    var gptr = g._ptr;
    var gsize = g._size; // b arrays
    var bindex = b._index;
    var bptr = b._ptr; // columns
    var n = gsize[1]; // vars
    var p, p0, p1; // initialize top
    var top = n; // loop column indeces in B
    for(p0 = bptr[k], p1 = bptr[k + 1], p = p0; p < p1; p++){
        // node i
        var i = bindex[p]; // check node i is marked
        if (!(0, $0b34c88646cdf563$export$f0d640c1b5bfa3e)(gptr, i)) // start a dfs at unmarked node i
        top = (0, $7e44a5dd0cc3ee43$export$c913fe476af3832b)(i, g, top, xi, pinv);
    } // loop columns from top -> n - 1
    for(p = top; p < n; p++)// restore G
    (0, $e6b2e1f4b754a406$export$53b20e7656f0b914)(gptr, xi[p]);
    return top;
}



var $05e2929485677e5a$var$name = "csSpsolve";
var $05e2929485677e5a$var$dependencies = [
    "divideScalar",
    "multiply",
    "subtract"
];
var $05e2929485677e5a$export$517933164557054f = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($05e2929485677e5a$var$name, $05e2929485677e5a$var$dependencies, (_ref)=>{
    var { divideScalar: divideScalar, multiply: multiply, subtract: subtract } = _ref;
    /**
   * The function csSpsolve() computes the solution to G * x = bk, where bk is the
   * kth column of B. When lo is true, the function assumes G = L is lower triangular with the
   * diagonal entry as the first entry in each column. When lo is true, the function assumes G = U
   * is upper triangular with the diagonal entry as the last entry in each column.
   *
   * @param {Matrix}  g               The G matrix
   * @param {Matrix}  b               The B matrix
   * @param {Number}  k               The kth column in B
   * @param {Array}   xi              The nonzero pattern xi[top] .. xi[n - 1], an array of size = 2 * n
   *                                  The first n entries is the nonzero pattern, the last n entries is the stack
   * @param {Array}   x               The soluton to the linear system G * x = b
   * @param {Array}   pinv            The inverse row permutation vector, must be null for L * x = b
   * @param {boolean} lo              The lower (true) upper triangular (false) flag
   *
   * @return {Number}                 The index for the nonzero pattern
   *
   * Reference: http://faculty.cse.tamu.edu/davis/publications.html
   */ return function csSpsolve(g, b, k, xi, x, pinv, lo) {
        // g arrays
        var gvalues = g._values;
        var gindex = g._index;
        var gptr = g._ptr;
        var gsize = g._size; // columns
        var n = gsize[1]; // b arrays
        var bvalues = b._values;
        var bindex = b._index;
        var bptr = b._ptr; // vars
        var p, p0, p1, q; // xi[top..n-1] = csReach(B(:,k))
        var top = (0, $289a01f2f9ae619b$export$125cefbcd149ec98)(g, b, k, xi, pinv); // clear x
        for(p = top; p < n; p++)x[xi[p]] = 0;
         // scatter b
        for(p0 = bptr[k], p1 = bptr[k + 1], p = p0; p < p1; p++)x[bindex[p]] = bvalues[p];
         // loop columns
        for(var px = top; px < n; px++){
            // x array index for px
            var j = xi[px]; // apply permutation vector (U x = b), j maps to column J of G
            var J = pinv ? pinv[j] : j; // check column J is empty
            if (J < 0) continue;
             // column value indeces in G, p0 <= p < p1
            p0 = gptr[J];
            p1 = gptr[J + 1]; // x(j) /= G(j,j)
            x[j] = divideScalar(x[j], gvalues[lo ? p0 : p1 - 1]); // first entry L(j,j)
            p = lo ? p0 + 1 : p0;
            q = lo ? p1 : p1 - 1; // loop
            for(; p < q; p++){
                // row
                var i = gindex[p]; // x(i) -= G(i,j) * x(j)
                x[i] = subtract(x[i], multiply(gvalues[p], x[j]));
            }
        } // return top of stack
        return top;
    };
});


var $09eff536a97f3dec$var$name = "csLu";
var $09eff536a97f3dec$var$dependencies = [
    "abs",
    "divideScalar",
    "multiply",
    "subtract",
    "larger",
    "largerEq",
    "SparseMatrix"
];
var $09eff536a97f3dec$export$5487b5fadeacd2f6 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($09eff536a97f3dec$var$name, $09eff536a97f3dec$var$dependencies, (_ref)=>{
    var { abs: abs, divideScalar: divideScalar, multiply: multiply, subtract: subtract, larger: larger, largerEq: largerEq, SparseMatrix: SparseMatrix } = _ref;
    var csSpsolve = (0, $05e2929485677e5a$export$517933164557054f)({
        divideScalar: divideScalar,
        multiply: multiply,
        subtract: subtract
    });
    /**
   * Computes the numeric LU factorization of the sparse matrix A. Implements a Left-looking LU factorization
   * algorithm that computes L and U one column at a tume. At the kth step, it access columns 1 to k-1 of L
   * and column k of A. Given the fill-reducing column ordering q (see parameter s) computes L, U and pinv so
   * L * U = A(p, q), where p is the inverse of pinv.
   *
   * @param {Matrix}  m               The A Matrix to factorize
   * @param {Object}  s               The symbolic analysis from csSqr(). Provides the fill-reducing
   *                                  column ordering q
   * @param {Number}  tol             Partial pivoting threshold (1 for partial pivoting)
   *
   * @return {Number}                 The numeric LU factorization of A or null
   *
   * Reference: http://faculty.cse.tamu.edu/davis/publications.html
   */ return function csLu(m, s, tol) {
        // validate input
        if (!m) return null;
         // m arrays
        var size = m._size; // columns
        var n = size[1]; // symbolic analysis result
        var q;
        var lnz = 100;
        var unz = 100; // update symbolic analysis parameters
        if (s) {
            q = s.q;
            lnz = s.lnz || lnz;
            unz = s.unz || unz;
        } // L arrays
        var lvalues = []; // (lnz)
        var lindex = []; // (lnz)
        var lptr = []; // (n + 1)
        // L
        var L = new SparseMatrix({
            values: lvalues,
            index: lindex,
            ptr: lptr,
            size: [
                n,
                n
            ]
        }); // U arrays
        var uvalues = []; // (unz)
        var uindex = []; // (unz)
        var uptr = []; // (n + 1)
        // U
        var U = new SparseMatrix({
            values: uvalues,
            index: uindex,
            ptr: uptr,
            size: [
                n,
                n
            ]
        }); // inverse of permutation vector
        var pinv = []; // (n)
        // vars
        var i, p; // allocate arrays
        var x = []; // (n)
        var xi = []; // (2 * n)
        // initialize variables
        for(i = 0; i < n; i++){
            // clear workspace
            x[i] = 0; // no rows pivotal yet
            pinv[i] = -1; // no cols of L yet
            lptr[i + 1] = 0;
        } // reset number of nonzero elements in L and U
        lnz = 0;
        unz = 0; // compute L(:,k) and U(:,k)
        for(var k = 0; k < n; k++){
            // update ptr
            lptr[k] = lnz;
            uptr[k] = unz; // apply column permutations if needed
            var col = q ? q[k] : k; // solve triangular system, x = L\A(:,col)
            var top = csSpsolve(L, m, col, xi, x, pinv, 1); // find pivot
            var ipiv = -1;
            var a = -1; // loop xi[] from top -> n
            for(p = top; p < n; p++){
                // x[i] is nonzero
                i = xi[p]; // check row i is not yet pivotal
                if (pinv[i] < 0) {
                    // absolute value of x[i]
                    var xabs = abs(x[i]); // check absoulte value is greater than pivot value
                    if (larger(xabs, a)) {
                        // largest pivot candidate so far
                        a = xabs;
                        ipiv = i;
                    }
                } else {
                    // x(i) is the entry U(pinv[i],k)
                    uindex[unz] = pinv[i];
                    uvalues[unz++] = x[i];
                }
            } // validate we found a valid pivot
            if (ipiv === -1 || a <= 0) return null;
             // update actual pivot column, give preference to diagonal value
            if (pinv[col] < 0 && largerEq(abs(x[col]), multiply(a, tol))) ipiv = col;
             // the chosen pivot
            var pivot = x[ipiv]; // last entry in U(:,k) is U(k,k)
            uindex[unz] = k;
            uvalues[unz++] = pivot; // ipiv is the kth pivot row
            pinv[ipiv] = k; // first entry in L(:,k) is L(k,k) = 1
            lindex[lnz] = ipiv;
            lvalues[lnz++] = 1; // L(k+1:n,k) = x / pivot
            for(p = top; p < n; p++){
                // row
                i = xi[p]; // check x(i) is an entry in L(:,k)
                if (pinv[i] < 0) {
                    // save unpermuted row in L
                    lindex[lnz] = i; // scale pivot column
                    lvalues[lnz++] = divideScalar(x[i], pivot);
                } // x[0..n-1] = 0 for next k
                x[i] = 0;
            }
        } // update ptr
        lptr[n] = lnz;
        uptr[n] = unz; // fix row indices of L for final pinv
        for(p = 0; p < lnz; p++)lindex[p] = pinv[lindex[p]];
         // trim arrays
        lvalues.splice(lnz, lvalues.length - lnz);
        lindex.splice(lnz, lindex.length - lnz);
        uvalues.splice(unz, uvalues.length - unz);
        uindex.splice(unz, uindex.length - unz); // return LU factor
        return {
            L: L,
            U: U,
            pinv: pinv
        };
    };
});


var $4e9454c6117f0ccc$var$name = "slu";
var $4e9454c6117f0ccc$var$dependencies = [
    "typed",
    "abs",
    "add",
    "multiply",
    "transpose",
    "divideScalar",
    "subtract",
    "larger",
    "largerEq",
    "SparseMatrix"
];
var $4e9454c6117f0ccc$export$e44ac9822ce417ae = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($4e9454c6117f0ccc$var$name, $4e9454c6117f0ccc$var$dependencies, (_ref)=>{
    var { typed: typed, abs: abs, add: add, multiply: multiply, transpose: transpose, divideScalar: divideScalar, subtract: subtract, larger: larger, largerEq: largerEq, SparseMatrix: SparseMatrix } = _ref;
    var csSqr = (0, $b4ecbec722deadf4$export$4d3f338d9cfe48c1)({
        add: add,
        multiply: multiply,
        transpose: transpose
    });
    var csLu = (0, $09eff536a97f3dec$export$5487b5fadeacd2f6)({
        abs: abs,
        divideScalar: divideScalar,
        multiply: multiply,
        subtract: subtract,
        larger: larger,
        largerEq: largerEq,
        SparseMatrix: SparseMatrix
    });
    /**
   * Calculate the Sparse Matrix LU decomposition with full pivoting. Sparse Matrix `A` is decomposed in two matrices (`L`, `U`) and two permutation vectors (`pinv`, `q`) where
   *
   * `P * A * Q = L * U`
   *
   * Syntax:
   *
   *    math.slu(A, order, threshold)
   *
   * Examples:
   *
   *    const A = math.sparse([[4,3], [6, 3]])
   *    math.slu(A, 1, 0.001)
   *    // returns:
   *    // {
   *    //   L: [[1, 0], [1.5, 1]]
   *    //   U: [[4, 3], [0, -1.5]]
   *    //   p: [0, 1]
   *    //   q: [0, 1]
   *    // }
   *
   * See also:
   *
   *    lup, lsolve, usolve, lusolve
   *
   * @param {SparseMatrix} A              A two dimensional sparse matrix for which to get the LU decomposition.
   * @param {Number}       order          The Symbolic Ordering and Analysis order:
   *                                       0 - Natural ordering, no permutation vector q is returned
   *                                       1 - Matrix must be square, symbolic ordering and analisis is performed on M = A + A'
   *                                       2 - Symbolic ordering and analisis is performed on M = A' * A. Dense columns from A' are dropped, A recreated from A'.
   *                                           This is appropriatefor LU factorization of unsymmetric matrices.
   *                                       3 - Symbolic ordering and analisis is performed on M = A' * A. This is best used for LU factorization is matrix M has no dense rows.
   *                                           A dense row is a row with more than 10*sqr(columns) entries.
   * @param {Number}       threshold       Partial pivoting threshold (1 for partial pivoting)
   *
   * @return {Object} The lower triangular matrix, the upper triangular matrix and the permutation vectors.
   */ return typed($4e9454c6117f0ccc$var$name, {
        "SparseMatrix, number, number": function SparseMatrixNumberNumber(a, order, threshold) {
            // verify order
            if (!(0, $668e051498bf5fa0$export$a287f47fed4544b8)(order) || order < 0 || order > 3) throw new Error("Symbolic Ordering and Analysis order must be an integer number in the interval [0, 3]");
             // verify threshold
            if (threshold < 0 || threshold > 1) throw new Error("Partial pivoting threshold must be a number from 0 to 1");
             // perform symbolic ordering and analysis
            var s = csSqr(order, a, false); // perform lu decomposition
            var f = csLu(a, s, threshold); // return decomposition
            return {
                L: f.L,
                U: f.U,
                p: f.pinv,
                q: s.q,
                toString: function toString() {
                    return "L: " + this.L.toString() + "\nU: " + this.U.toString() + "\np: " + this.p.toString() + (this.q ? "\nq: " + this.q.toString() : "") + "\n";
                }
            };
        }
    });
});




var $6e1553ed8eaa8d62$var$name = "sum";
var $6e1553ed8eaa8d62$var$dependencies = [
    "typed",
    "config",
    "add",
    "numeric"
];
var $6e1553ed8eaa8d62$export$14d444d810bc35b5 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($6e1553ed8eaa8d62$var$name, $6e1553ed8eaa8d62$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, add: add, numeric: numeric } = _ref;
    /**
   * Compute the sum of a matrix or a list with values.
   * In case of a (multi dimensional) array or matrix, the sum of all
   * elements will be calculated.
   *
   * Syntax:
   *
   *     math.sum(a, b, c, ...)
   *     math.sum(A)
   *
   * Examples:
   *
   *     math.sum(2, 1, 4, 3)               // returns 10
   *     math.sum([2, 1, 4, 3])             // returns 10
   *     math.sum([[2, 5], [4, 3], [1, 7]]) // returns 22
   *
   * See also:
   *
   *    mean, median, min, max, prod, std, variance, cumsum
   *
   * @param {... *} args  A single matrix or or multiple scalar values
   * @return {*} The sum of all values
   */ return typed($6e1553ed8eaa8d62$var$name, {
        // sum([a, b, c, d, ...])
        "Array | Matrix": _sum,
        // sum([a, b, c, d, ...], dim)
        "Array | Matrix, number | BigNumber": _nsumDim,
        // sum(a, b, c, d, ...)
        "...": function _(args) {
            if ((0, $dd57e6221b0e50b6$export$4d8f6a27e2f5bcb2)(args)) throw new TypeError("Scalar values expected in function sum");
            return _sum(args);
        }
    });
    /**
   * Recursively calculate the sum of an n-dimensional array
   * @param {Array | Matrix} array
   * @return {number} sum
   * @private
   */ function _sum(array) {
        var sum;
        (0, $dd57e6221b0e50b6$export$519ada94592b97fc)(array, function(value) {
            try {
                sum = sum === undefined ? value : add(sum, value);
            } catch (err) {
                throw (0, $b113219b83527e4b$export$c8994973cec629ae)(err, "sum", value);
            }
        }); // make sure returning numeric value: parse a string into a numeric value
        if (sum === undefined) sum = numeric(0, config.number);
        if (typeof sum === "string") sum = numeric(sum, config.number);
        return sum;
    }
    function _nsumDim(array, dim) {
        try {
            var sum = (0, $dd57e6221b0e50b6$export$533b26079ad0b4b)(array, dim, add);
            return sum;
        } catch (err) {
            throw (0, $b113219b83527e4b$export$c8994973cec629ae)(err, "sum");
        }
    }
});




var $240130b95903c32f$var$name = "trace";
var $240130b95903c32f$var$dependencies = [
    "typed",
    "matrix",
    "add"
];
var $240130b95903c32f$export$acff8254414be03b = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($240130b95903c32f$var$name, $240130b95903c32f$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, add: add } = _ref;
    /**
   * Calculate the trace of a matrix: the sum of the elements on the main
   * diagonal of a square matrix.
   *
   * Syntax:
   *
   *    math.trace(x)
   *
   * Examples:
   *
   *    math.trace([[1, 2], [3, 4]]) // returns 5
   *
   *    const A = [
   *      [1, 2, 3],
   *      [-1, 2, 3],
   *      [2, 0, 3]
   *    ]
   *    math.trace(A) // returns 6
   *
   * See also:
   *
   *    diag
   *
   * @param {Array | Matrix} x  A matrix
   *
   * @return {number} The trace of `x`
   */ return typed("trace", {
        Array: function _arrayTrace(x) {
            // use dense matrix implementation
            return _denseTrace(matrix(x));
        },
        SparseMatrix: _sparseTrace,
        DenseMatrix: _denseTrace,
        any: (0, $6819694788cbfa38$export$9cd59f9826255e47)
    });
    function _denseTrace(m) {
        // matrix size & data
        var size = m._size;
        var data = m._data; // process dimensions
        switch(size.length){
            case 1:
                // vector
                if (size[0] === 1) // return data[0]
                return (0, $6819694788cbfa38$export$9cd59f9826255e47)(data[0]);
                throw new RangeError("Matrix must be square (size: " + (0, $b94963e97c376b6d$export$d9468344d3651243)(size) + ")");
            case 2:
                // two dimensional
                var rows = size[0];
                var cols = size[1];
                if (rows === cols) {
                    // calulate sum
                    var sum = 0; // loop diagonal
                    for(var i = 0; i < rows; i++)sum = add(sum, data[i][i]);
                     // return trace
                    return sum;
                } else throw new RangeError("Matrix must be square (size: " + (0, $b94963e97c376b6d$export$d9468344d3651243)(size) + ")");
            default:
                // multi dimensional
                throw new RangeError("Matrix must be two dimensional (size: " + (0, $b94963e97c376b6d$export$d9468344d3651243)(size) + ")");
        }
    }
    function _sparseTrace(m) {
        // matrix arrays
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr;
        var size = m._size; // check dimensions
        var rows = size[0];
        var columns = size[1]; // matrix must be square
        if (rows === columns) {
            // calulate sum
            var sum = 0; // check we have data (avoid looping columns)
            if (values.length > 0) // loop columns
            for(var j = 0; j < columns; j++){
                // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
                var k0 = ptr[j];
                var k1 = ptr[j + 1]; // loop k within [k0, k1[
                for(var k = k0; k < k1; k++){
                    // row index
                    var i = index[k]; // check row
                    if (i === j) {
                        // accumulate value
                        sum = add(sum, values[k]); // exit loop
                        break;
                    }
                    if (i > j) break;
                }
            }
             // return trace
            return sum;
        }
        throw new RangeError("Matrix must be square (size: " + (0, $b94963e97c376b6d$export$d9468344d3651243)(size) + ")");
    }
});



var $07876562cef2037d$var$name = "usolveAll";
var $07876562cef2037d$var$dependencies = [
    "typed",
    "matrix",
    "divideScalar",
    "multiplyScalar",
    "subtract",
    "equalScalar",
    "DenseMatrix"
];
var $07876562cef2037d$export$c8bbc8bec60c7fc3 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($07876562cef2037d$var$name, $07876562cef2037d$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, divideScalar: divideScalar, multiplyScalar: multiplyScalar, subtract: subtract, equalScalar: equalScalar, DenseMatrix: DenseMatrix } = _ref;
    var solveValidation = (0, $5b483e7b4659dfae$export$6accbcba5dda801d)({
        DenseMatrix: DenseMatrix
    });
    /**
   * Finds all solutions of a linear equation system by backward substitution. Matrix must be an upper triangular matrix.
   *
   * `U * x = b`
   *
   * Syntax:
   *
   *    math.usolveAll(U, b)
   *
   * Examples:
   *
   *    const a = [[-2, 3], [2, 1]]
   *    const b = [11, 9]
   *    const x = usolveAll(a, b)  // [ [[8], [9]] ]
   *
   * See also:
   *
   *    usolve, lup, slu, usolve, lusolve
   *
   * @param {Matrix, Array} U       A N x N matrix or array (U)
   * @param {Matrix, Array} b       A column vector with the b values
   *
   * @return {DenseMatrix[] | Array[]}  An array of affine-independent column vectors (x) that solve the linear system
   */ return typed($07876562cef2037d$var$name, {
        "SparseMatrix, Array | Matrix": function SparseMatrixArrayMatrix(m, b) {
            return _sparseBackwardSubstitution(m, b);
        },
        "DenseMatrix, Array | Matrix": function DenseMatrixArrayMatrix(m, b) {
            return _denseBackwardSubstitution(m, b);
        },
        "Array, Array | Matrix": function ArrayArrayMatrix(a, b) {
            var m = matrix(a);
            var R = _denseBackwardSubstitution(m, b);
            return R.map((r)=>r.valueOf());
        }
    });
    function _denseBackwardSubstitution(m, b_) {
        // the algorithm is derived from
        // https://www.overleaf.com/read/csvgqdxggyjv
        // array of right-hand sides
        var B = [
            solveValidation(m, b_, true)._data.map((e)=>e[0])
        ];
        var M = m._data;
        var rows = m._size[0];
        var columns = m._size[1]; // loop columns backwards
        for(var i = columns - 1; i >= 0; i--){
            var L = B.length; // loop right-hand sides
            for(var k = 0; k < L; k++){
                var b = B[k];
                if (!equalScalar(M[i][i], 0)) {
                    // non-singular row
                    b[i] = divideScalar(b[i], M[i][i]);
                    for(var j = i - 1; j >= 0; j--)// b[j] -= b[i] * M[j,i]
                    b[j] = subtract(b[j], multiplyScalar(b[i], M[j][i]));
                } else if (!equalScalar(b[i], 0)) {
                    // singular row, nonzero RHS
                    if (k === 0) // There is no valid solution
                    return [];
                    else {
                        // This RHS is invalid but other solutions may still exist
                        B.splice(k, 1);
                        k -= 1;
                        L -= 1;
                    }
                } else if (k === 0) {
                    // singular row, RHS is zero
                    var bNew = [
                        ...b
                    ];
                    bNew[i] = 1;
                    for(var _j = i - 1; _j >= 0; _j--)bNew[_j] = subtract(bNew[_j], M[_j][i]);
                    B.push(bNew);
                }
            }
        }
        return B.map((x)=>new DenseMatrix({
                data: x.map((e)=>[
                        e
                    ]),
                size: [
                    rows,
                    1
                ]
            }));
    }
    function _sparseBackwardSubstitution(m, b_) {
        // array of right-hand sides
        var B = [
            solveValidation(m, b_, true)._data.map((e)=>e[0])
        ];
        var rows = m._size[0];
        var columns = m._size[1];
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr; // loop columns backwards
        for(var i = columns - 1; i >= 0; i--){
            var L = B.length; // loop right-hand sides
            for(var k = 0; k < L; k++){
                var b = B[k]; // values & indices (column i)
                var iValues = [];
                var iIndices = []; // first & last indeces in column
                var firstIndex = ptr[i];
                var lastIndex = ptr[i + 1]; // find the value at [i, i]
                var Mii = 0;
                for(var j = lastIndex - 1; j >= firstIndex; j--){
                    var J = index[j]; // check row
                    if (J === i) Mii = values[j];
                    else if (J < i) {
                        // store upper triangular
                        iValues.push(values[j]);
                        iIndices.push(J);
                    }
                }
                if (!equalScalar(Mii, 0)) {
                    // non-singular row
                    b[i] = divideScalar(b[i], Mii); // loop upper triangular
                    for(var _j2 = 0, _lastIndex = iIndices.length; _j2 < _lastIndex; _j2++){
                        var _J = iIndices[_j2];
                        b[_J] = subtract(b[_J], multiplyScalar(b[i], iValues[_j2]));
                    }
                } else if (!equalScalar(b[i], 0)) {
                    // singular row, nonzero RHS
                    if (k === 0) // There is no valid solution
                    return [];
                    else {
                        // This RHS is invalid but other solutions may still exist
                        B.splice(k, 1);
                        k -= 1;
                        L -= 1;
                    }
                } else if (k === 0) {
                    // singular row, RHS is zero
                    var bNew = [
                        ...b
                    ];
                    bNew[i] = 1; // loop upper triangular
                    for(var _j3 = 0, _lastIndex2 = iIndices.length; _j3 < _lastIndex2; _j3++){
                        var _J2 = iIndices[_j3];
                        bNew[_J2] = subtract(bNew[_J2], iValues[_j3]);
                    }
                    B.push(bNew);
                }
            }
        }
        return B.map((x)=>new DenseMatrix({
                data: x.map((e)=>[
                        e
                    ]),
                size: [
                    rows,
                    1
                ]
            }));
    }
});



var $25a1e2e6a1388cbc$var$name = "asin";
var $25a1e2e6a1388cbc$var$dependencies = [
    "typed",
    "config",
    "Complex"
];
var $25a1e2e6a1388cbc$export$5f05d91ddc56bc14 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($25a1e2e6a1388cbc$var$name, $25a1e2e6a1388cbc$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, Complex: Complex } = _ref;
    /**
   * Calculate the inverse sine of a value.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.asin(x)
   *
   * Examples:
   *
   *    math.asin(0.5)           // returns number 0.5235987755982989
   *    math.asin(math.sin(1.5)) // returns number ~1.5
   *
   *    math.asin(2)             // returns Complex 1.5707963267948966 -1.3169578969248166 i
   *
   * See also:
   *
   *    sin, atan, acos
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x   Function input
   * @return {number | BigNumber | Complex | Array | Matrix} The arc sine of x
   */ return typed($25a1e2e6a1388cbc$var$name, {
        number: function number(x) {
            if (x >= -1 && x <= 1 || config.predictable) return Math.asin(x);
            else return new Complex(x, 0).asin();
        },
        Complex: function Complex(x) {
            return x.asin();
        },
        BigNumber: function BigNumber(x) {
            return x.asin();
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since asin(0) = 0
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this, true);
        }
    });
});


var $4qPUL = parcelRequire("4qPUL");







var $6b60b8aa1ec7db00$var$name = "ceil";
var $6b60b8aa1ec7db00$var$dependencies = [
    "typed",
    "config",
    "round",
    "matrix",
    "equalScalar",
    "zeros",
    "DenseMatrix"
];
var $6b60b8aa1ec7db00$export$7f32b339ed8a324b = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($6b60b8aa1ec7db00$var$name, [
    "typed",
    "config",
    "round"
], (_ref)=>{
    var { typed: typed, config: config, round: round } = _ref;
    return typed($6b60b8aa1ec7db00$var$name, {
        number: function number(x) {
            if ((0, $668e051498bf5fa0$export$6f3989c6ecc04081)(x, round(x), config.epsilon)) return round(x);
            else return Math.ceil(x);
        },
        "number, number": function numberNumber(x, n) {
            if ((0, $668e051498bf5fa0$export$6f3989c6ecc04081)(x, round(x, n), config.epsilon)) return round(x, n);
            else {
                var [number, exponent] = "".concat(x, "e").split("e");
                var result = Math.ceil(Number("".concat(number, "e").concat(Number(exponent) + n)));
                [number, exponent] = "".concat(result, "e").split("e");
                return Number("".concat(number, "e").concat(Number(exponent) - n));
            }
        }
    });
});
var $6b60b8aa1ec7db00$export$bab247d909829ddf = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($6b60b8aa1ec7db00$var$name, $6b60b8aa1ec7db00$var$dependencies, (_ref2)=>{
    var { typed: typed, config: config, round: round, matrix: matrix, equalScalar: equalScalar, zeros: zeros, DenseMatrix: DenseMatrix } = _ref2;
    var algorithm11 = (0, $83b92f81e511657d$export$a38279a12199d831)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm12 = (0, $500ff63908aabda9$export$806772cd23b603dc)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm14 = (0, $533d58927c47005f$export$e5afe3bc814ef550)({
        typed: typed
    });
    var ceilNumber = $6b60b8aa1ec7db00$export$7f32b339ed8a324b({
        typed: typed,
        config: config,
        round: round
    });
    /**
   * Round a value towards plus infinity
   * If `x` is complex, both real and imaginary part are rounded towards plus infinity.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.ceil(x)
   *    math.ceil(x, n)
   *
   * Examples:
   *
   *    math.ceil(3.2)               // returns number 4
   *    math.ceil(3.8)               // returns number 4
   *    math.ceil(-4.2)              // returns number -4
   *    math.ceil(-4.7)              // returns number -4
   *
   *    math.ceil(3.212, 2)          // returns number 3.22
   *    math.ceil(3.288, 2)          // returns number 3.29
   *    math.ceil(-4.212, 2)         // returns number -4.21
   *    math.ceil(-4.782, 2)         // returns number -4.78
   *
   *    const c = math.complex(3.24, -2.71)
   *    math.ceil(c)                 // returns Complex 4 - 2i
   *    math.ceil(c, 1)              // returns Complex 3.3 - 2.7i
   *
   *    math.ceil([3.2, 3.8, -4.7])  // returns Array [4, 4, -4]
   *    math.ceil([3.21, 3.82, -4.71], 1)  // returns Array [3.3, 3.9, -4.7]
   *
   * See also:
   *
   *    floor, fix, round
   *
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix} x  Number to be rounded
   * @param  {number | BigNumber | Array} [n=0]                            Number of decimals
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix} Rounded value
   */ return typed("ceil", {
        number: ceilNumber.signatures.number,
        "number,number": ceilNumber.signatures["number,number"],
        Complex: function Complex(x) {
            return x.ceil();
        },
        "Complex, number": function ComplexNumber(x, n) {
            return x.ceil(n);
        },
        "Complex, BigNumber": function ComplexBigNumber(x, n) {
            return x.ceil(n.toNumber());
        },
        BigNumber: function BigNumber(x) {
            if ((0, $53e0635127e7c5a0$export$6f3989c6ecc04081)(x, round(x), config.epsilon)) return round(x);
            else return x.ceil();
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, n) {
            if ((0, $53e0635127e7c5a0$export$6f3989c6ecc04081)(x, round(x, n), config.epsilon)) return round(x, n);
            else return x.toDecimalPlaces(n.toNumber(), (0, (/*@__PURE__*/$parcel$interopDefault($4qPUL))).ROUND_CEIL);
        },
        Fraction: function Fraction(x) {
            return x.ceil();
        },
        "Fraction, number": function FractionNumber(x, n) {
            return x.ceil(n);
        },
        "Fraction, BigNumber": function FractionBigNumber(x, n) {
            return x.ceil(n.toNumber());
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since ceil(0) = 0
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this, true);
        },
        "Array, number | BigNumber": function ArrayNumberBigNumber(x, n) {
            // deep map collection, skip zeros since ceil(0) = 0
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, (i)=>this(i, n), true);
        },
        "SparseMatrix, number | BigNumber": function SparseMatrixNumberBigNumber(x, y) {
            return algorithm11(x, y, this, false);
        },
        "DenseMatrix, number | BigNumber": function DenseMatrixNumberBigNumber(x, y) {
            return algorithm14(x, y, this, false);
        },
        "number | Complex | Fraction | BigNumber, Array": function numberComplexFractionBigNumberArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        },
        "number | Complex | Fraction | BigNumber, Matrix": function numberComplexFractionBigNumberMatrix(x, y) {
            if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
            if (y.storage() === "dense") return algorithm14(y, x, this, true);
            return algorithm12(y, x, this, true);
        }
    });
});


var $c2caee1d2208fc45$var$name = "composition";
var $c2caee1d2208fc45$var$dependencies = [
    "typed",
    "addScalar",
    "combinations",
    "isNegative",
    "isPositive",
    "isInteger",
    "larger"
];
var $c2caee1d2208fc45$export$1ddf9cbadd17315f = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($c2caee1d2208fc45$var$name, $c2caee1d2208fc45$var$dependencies, (_ref)=>{
    var { typed: typed, addScalar: addScalar, combinations: combinations, isPositive: isPositive, isNegative: isNegative, isInteger: isInteger, larger: larger } = _ref;
    /**
   * The composition counts of n into k parts.
   *
   * composition only takes integer arguments.
   * The following condition must be enforced: k <= n.
   *
   * Syntax:
   *
   *   math.composition(n, k)
   *
   * Examples:
   *
   *    math.composition(5, 3) // returns 6
   *
   * See also:
   *
   *    combinations
   *
   * @param {Number | BigNumber} n    Total number of objects in the set
   * @param {Number | BigNumber} k    Number of objects in the subset
   * @return {Number | BigNumber}     Returns the composition counts of n into k parts.
   */ return typed($c2caee1d2208fc45$var$name, {
        "number | BigNumber, number | BigNumber": function numberBigNumberNumberBigNumber(n, k) {
            if (!isInteger(n) || !isPositive(n) || !isInteger(k) || !isPositive(k)) throw new TypeError("Positive integer value expected in function composition");
            else if (larger(k, n)) throw new TypeError("k must be less than or equal to n in function composition");
            return combinations(addScalar(n, -1), addScalar(k, -1));
        }
    });
});



var $ea17902fc0c95a99$var$name = "cross";
var $ea17902fc0c95a99$var$dependencies = [
    "typed",
    "matrix",
    "subtract",
    "multiply"
];
var $ea17902fc0c95a99$export$bc2585c0ed744c0e = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($ea17902fc0c95a99$var$name, $ea17902fc0c95a99$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, subtract: subtract, multiply: multiply } = _ref;
    /**
   * Calculate the cross product for two vectors in three dimensional space.
   * The cross product of `A = [a1, a2, a3]` and `B = [b1, b2, b3]` is defined
   * as:
   *
   *    cross(A, B) = [
   *      a2 * b3 - a3 * b2,
   *      a3 * b1 - a1 * b3,
   *      a1 * b2 - a2 * b1
   *    ]
   *
   * If one of the input vectors has a dimension greater than 1, the output
   * vector will be a 1x3 (2-dimensional) matrix.
   *
   * Syntax:
   *
   *    math.cross(x, y)
   *
   * Examples:
   *
   *    math.cross([1, 1, 0],   [0, 1, 1])       // Returns [1, -1, 1]
   *    math.cross([3, -3, 1],  [4, 9, 2])       // Returns [-15, -2, 39]
   *    math.cross([2, 3, 4],   [5, 6, 7])       // Returns [-3, 6, -3]
   *    math.cross([[1, 2, 3]], [[4], [5], [6]]) // Returns [[-3, 6, -3]]
   *
   * See also:
   *
   *    dot, multiply
   *
   * @param  {Array | Matrix} x   First vector
   * @param  {Array | Matrix} y   Second vector
   * @return {Array | Matrix}     Returns the cross product of `x` and `y`
   */ return typed($ea17902fc0c95a99$var$name, {
        "Matrix, Matrix": function MatrixMatrix(x, y) {
            return matrix(_cross(x.toArray(), y.toArray()));
        },
        "Matrix, Array": function MatrixArray(x, y) {
            return matrix(_cross(x.toArray(), y));
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            return matrix(_cross(x, y.toArray()));
        },
        "Array, Array": _cross
    });
    /**
   * Calculate the cross product for two arrays
   * @param {Array} x  First vector
   * @param {Array} y  Second vector
   * @returns {Array} Returns the cross product of x and y
   * @private
   */ function _cross(x, y) {
        var highestDimension = Math.max((0, $a14a10567870d913$export$51ffaee4afb683a5)(x).length, (0, $a14a10567870d913$export$51ffaee4afb683a5)(y).length);
        x = (0, $a14a10567870d913$export$889c931173b77c2f)(x);
        y = (0, $a14a10567870d913$export$889c931173b77c2f)(y);
        var xSize = (0, $a14a10567870d913$export$51ffaee4afb683a5)(x);
        var ySize = (0, $a14a10567870d913$export$51ffaee4afb683a5)(y);
        if (xSize.length !== 1 || ySize.length !== 1 || xSize[0] !== 3 || ySize[0] !== 3) throw new RangeError("Vectors with length 3 expected (Size A = [" + xSize.join(", ") + "], B = [" + ySize.join(", ") + "])");
        var product = [
            subtract(multiply(x[1], y[2]), multiply(x[2], y[1])),
            subtract(multiply(x[2], y[0]), multiply(x[0], y[2])),
            subtract(multiply(x[0], y[1]), multiply(x[1], y[0]))
        ];
        if (highestDimension > 1) return [
            product
        ];
        else return product;
    }
});





var $03d1dc9783c3f11a$var$name = "det";
var $03d1dc9783c3f11a$var$dependencies = [
    "typed",
    "matrix",
    "subtract",
    "multiply",
    "divideScalar",
    "isZero",
    "unaryMinus"
];
var $03d1dc9783c3f11a$export$93f810683c54b005 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($03d1dc9783c3f11a$var$name, $03d1dc9783c3f11a$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, subtract: subtract, multiply: multiply, divideScalar: divideScalar, isZero: isZero, unaryMinus: unaryMinus } = _ref;
    /**
   * Calculate the determinant of a matrix.
   *
   * Syntax:
   *
   *    math.det(x)
   *
   * Examples:
   *
   *    math.det([[1, 2], [3, 4]]) // returns -2
   *
   *    const A = [
   *      [-2, 2, 3],
   *      [-1, 1, 3],
   *      [2, 0, -1]
   *    ]
   *    math.det(A) // returns 6
   *
   * See also:
   *
   *    inv
   *
   * @param {Array | Matrix} x  A matrix
   * @return {number} The determinant of `x`
   */ return typed($03d1dc9783c3f11a$var$name, {
        any: function any(x) {
            return (0, $6819694788cbfa38$export$9cd59f9826255e47)(x);
        },
        "Array | Matrix": function det(x) {
            var size;
            if ((0, $d8097b7a6d6e36d8$export$b22160e0a14f87b7)(x)) size = x.size();
            else if (Array.isArray(x)) {
                x = matrix(x);
                size = x.size();
            } else // a scalar
            size = [];
            switch(size.length){
                case 0:
                    // scalar
                    return (0, $6819694788cbfa38$export$9cd59f9826255e47)(x);
                case 1:
                    // vector
                    if (size[0] === 1) return (0, $6819694788cbfa38$export$9cd59f9826255e47)(x.valueOf()[0]);
                    else throw new RangeError("Matrix must be square (size: " + (0, $b94963e97c376b6d$export$d9468344d3651243)(size) + ")");
                case 2:
                    // two dimensional array
                    var rows = size[0];
                    var cols = size[1];
                    if (rows === cols) return _det(x.clone().valueOf(), rows, cols);
                    else throw new RangeError("Matrix must be square (size: " + (0, $b94963e97c376b6d$export$d9468344d3651243)(size) + ")");
                default:
                    // multi dimensional array
                    throw new RangeError("Matrix must be two dimensional (size: " + (0, $b94963e97c376b6d$export$d9468344d3651243)(size) + ")");
            }
        }
    });
    /**
   * Calculate the determinant of a matrix
   * @param {Array[]} matrix  A square, two dimensional matrix
   * @param {number} rows     Number of rows of the matrix (zero-based)
   * @param {number} cols     Number of columns of the matrix (zero-based)
   * @returns {number} det
   * @private
   */ function _det(matrix, rows, cols) {
        if (rows === 1) // this is a 1 x 1 matrix
        return (0, $6819694788cbfa38$export$9cd59f9826255e47)(matrix[0][0]);
        else if (rows === 2) // this is a 2 x 2 matrix
        // the determinant of [a11,a12;a21,a22] is det = a11*a22-a21*a12
        return subtract(multiply(matrix[0][0], matrix[1][1]), multiply(matrix[1][0], matrix[0][1]));
        else {
            // Bareiss algorithm
            // this algorithm have same complexity as LUP decomposition (O(n^3))
            // but it preserve precision of floating point more relative to the LUP decomposition
            var negated = false;
            var rowIndices = new Array(rows).fill(0).map((_, i)=>i); // matrix index of row i
            for(var k = 0; k < rows; k++){
                var k_ = rowIndices[k];
                if (isZero(matrix[k_][k])) {
                    var _k = void 0;
                    for(_k = k + 1; _k < rows; _k++)if (!isZero(matrix[rowIndices[_k]][k])) {
                        k_ = rowIndices[_k];
                        rowIndices[_k] = rowIndices[k];
                        rowIndices[k] = k_;
                        negated = !negated;
                        break;
                    }
                    if (_k === rows) return matrix[k_][k]; // some zero of the type
                }
                var piv = matrix[k_][k];
                var piv_ = k === 0 ? 1 : matrix[rowIndices[k - 1]][k - 1];
                for(var i = k + 1; i < rows; i++){
                    var i_ = rowIndices[i];
                    for(var j = k + 1; j < rows; j++)matrix[i_][j] = divideScalar(subtract(multiply(matrix[i_][j], piv), multiply(matrix[i_][k], matrix[k_][j])), piv_);
                }
            }
            var det = matrix[rowIndices[rows - 1]][rows - 1];
            return negated ? unaryMinus(det) : det;
        }
    }
});



var $77add40d9e3f9b43$var$name = "distance";
var $77add40d9e3f9b43$var$dependencies = [
    "typed",
    "addScalar",
    "subtract",
    "divideScalar",
    "multiplyScalar",
    "unaryMinus",
    "sqrt",
    "abs"
];
var $77add40d9e3f9b43$export$23f482ad1a94fa7e = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($77add40d9e3f9b43$var$name, $77add40d9e3f9b43$var$dependencies, (_ref)=>{
    var { typed: typed, addScalar: addScalar, subtract: subtract, multiplyScalar: multiplyScalar, divideScalar: divideScalar, unaryMinus: unaryMinus, sqrt: sqrt, abs: abs } = _ref;
    /**
    * Calculates:
    *    The eucledian distance between two points in N-dimensional spaces.
    *    Distance between point and a line in 2 and 3 dimensional spaces.
    *    Pairwise distance between a set of 2D or 3D points
    * NOTE:
    *    When substituting coefficients of a line(a, b and c), use ax + by + c = 0 instead of ax + by = c
    *    For parametric equation of a 3D line, x0, y0, z0, a, b, c are from: (x−x0, y−y0, z−z0) = t(a, b, c)
    *
    * Syntax:
    *    math.distance([x1, y1], [x2, y2])
    *-   math.distance({pointOneX: 4, pointOneY: 5}, {pointTwoX: 2, pointTwoY: 7})
    *    math.distance([x1, y1, z1], [x2, y2, z2])
    *    math.distance({pointOneX: 4, pointOneY: 5, pointOneZ: 8}, {pointTwoX: 2, pointTwoY: 7, pointTwoZ: 9})
    *    math.distance([x1, y1, ... , N1], [x2, y2, ... , N2])
    *    math.distance([[A], [B], [C]...])
    *    math.distance([x1, y1], [LinePtX1, LinePtY1], [LinePtX2, LinePtY2])
    *    math.distance({pointX: 1, pointY: 4}, {lineOnePtX: 6, lineOnePtY: 3}, {lineTwoPtX: 2, lineTwoPtY: 8})
    *    math.distance([x1, y1, z1], [LinePtX1, LinePtY1, LinePtZ1], [LinePtX2, LinePtY2, LinePtZ2])
    *    math.distance({pointX: 1, pointY: 4, pointZ: 7}, {lineOnePtX: 6, lineOnePtY: 3, lineOnePtZ: 4}, {lineTwoPtX: 2, lineTwoPtY: 8, lineTwoPtZ: 5})
    *    math.distance([x1, y1], [xCoeffLine, yCoeffLine, constant])
    *    math.distance({pointX: 10, pointY: 10}, {xCoeffLine: 8, yCoeffLine: 1, constant: 3})
    *    math.distance([x1, y1, z1], [x0, y0, z0, a-tCoeff, b-tCoeff, c-tCoeff]) point and parametric equation of 3D line
    *    math.distance([x, y, z], [x0, y0, z0, a, b, c])
    *    math.distance({pointX: 2, pointY: 5, pointZ: 9}, {x0: 4, y0: 6, z0: 3, a: 4, b: 2, c: 0})
    *
    * Examples:
    *    math.distance([0,0], [4,4])                     // Returns 5.6569
    *    math.distance(
    *     {pointOneX: 0, pointOneY: 0},
    *     {pointTwoX: 10, pointTwoY: 10})                // Returns 14.142135623730951
    *    math.distance([1, 0, 1], [4, -2, 2])            // Returns 3.74166
    *    math.distance(
    *     {pointOneX: 4, pointOneY: 5, pointOneZ: 8},
    *     {pointTwoX: 2, pointTwoY: 7, pointTwoZ: 9})    // Returns 3
    *    math.distance([1, 0, 1, 0], [0, -1, 0, -1])     // Returns 2
    *    math.distance([[1, 2], [1, 2], [1, 3]])         // Returns [0, 1, 1]
    *    math.distance([[1,2,4], [1,2,6], [8,1,3]])      // Returns [2, 7.14142842854285, 7.681145747868608]
    *    math.distance([10, 10], [8, 1, 3])              // Returns 11.535230316796387
    *    math.distance([10, 10], [2, 3], [-8, 0])        // Returns 8.759953130362847
    *    math.distance(
    *     {pointX: 1, pointY: 4},
    *     {lineOnePtX: 6, lineOnePtY: 3},
    *     {lineTwoPtX: 2, lineTwoPtY: 8})                // Returns 2.720549372624744
    *    math.distance([2, 3, 1], [1, 1, 2, 5, 0, 1])    // Returns 2.3204774044612857
    *    math.distance(
    *     {pointX: 2, pointY: 3, pointZ: 1},
    *     {x0: 1, y0: 1, z0: 2, a: 5, b: 0, c: 1}        // Returns 2.3204774044612857
    *
    * @param {Array | Matrix | Object} x    Co-ordinates of first point
    * @param {Array | Matrix | Object} y    Co-ordinates of second point
    * @return {Number | BigNumber} Returns the distance from two/three points
  */ return typed($77add40d9e3f9b43$var$name, {
        "Array, Array, Array": function ArrayArrayArray(x, y, z) {
            // Point to Line 2D (x=Point, y=LinePoint1, z=LinePoint2)
            if (x.length === 2 && y.length === 2 && z.length === 2) {
                if (!_2d(x)) throw new TypeError("Array with 2 numbers or BigNumbers expected for first argument");
                if (!_2d(y)) throw new TypeError("Array with 2 numbers or BigNumbers expected for second argument");
                if (!_2d(z)) throw new TypeError("Array with 2 numbers or BigNumbers expected for third argument");
                var m = divideScalar(subtract(z[1], z[0]), subtract(y[1], y[0]));
                var xCoeff = multiplyScalar(multiplyScalar(m, m), y[0]);
                var yCoeff = unaryMinus(multiplyScalar(m, y[0]));
                var constant = x[1];
                return _distancePointLine2D(x[0], x[1], xCoeff, yCoeff, constant);
            } else throw new TypeError("Invalid Arguments: Try again");
        },
        "Object, Object, Object": function ObjectObjectObject(x, y, z) {
            if (Object.keys(x).length === 2 && Object.keys(y).length === 2 && Object.keys(z).length === 2) {
                if (!_2d(x)) throw new TypeError("Values of pointX and pointY should be numbers or BigNumbers");
                if (!_2d(y)) throw new TypeError("Values of lineOnePtX and lineOnePtY should be numbers or BigNumbers");
                if (!_2d(z)) throw new TypeError("Values of lineTwoPtX and lineTwoPtY should be numbers or BigNumbers");
                if ("pointX" in x && "pointY" in x && "lineOnePtX" in y && "lineOnePtY" in y && "lineTwoPtX" in z && "lineTwoPtY" in z) {
                    var m = divideScalar(subtract(z.lineTwoPtY, z.lineTwoPtX), subtract(y.lineOnePtY, y.lineOnePtX));
                    var xCoeff = multiplyScalar(multiplyScalar(m, m), y.lineOnePtX);
                    var yCoeff = unaryMinus(multiplyScalar(m, y.lineOnePtX));
                    var constant = x.pointX;
                    return _distancePointLine2D(x.pointX, x.pointY, xCoeff, yCoeff, constant);
                } else throw new TypeError("Key names do not match");
            } else throw new TypeError("Invalid Arguments: Try again");
        },
        "Array, Array": function ArrayArray(x, y) {
            // Point to Line 2D (x=[pointX, pointY], y=[x-coeff, y-coeff, const])
            if (x.length === 2 && y.length === 3) {
                if (!_2d(x)) throw new TypeError("Array with 2 numbers or BigNumbers expected for first argument");
                if (!_3d(y)) throw new TypeError("Array with 3 numbers or BigNumbers expected for second argument");
                return _distancePointLine2D(x[0], x[1], y[0], y[1], y[2]);
            } else if (x.length === 3 && y.length === 6) {
                // Point to Line 3D
                if (!_3d(x)) throw new TypeError("Array with 3 numbers or BigNumbers expected for first argument");
                if (!_parametricLine(y)) throw new TypeError("Array with 6 numbers or BigNumbers expected for second argument");
                return _distancePointLine3D(x[0], x[1], x[2], y[0], y[1], y[2], y[3], y[4], y[5]);
            } else if (x.length === y.length && x.length > 0) {
                // Point to Point N-dimensions
                if (!_containsOnlyNumbers(x)) throw new TypeError("All values of an array should be numbers or BigNumbers");
                if (!_containsOnlyNumbers(y)) throw new TypeError("All values of an array should be numbers or BigNumbers");
                return _euclideanDistance(x, y);
            } else throw new TypeError("Invalid Arguments: Try again");
        },
        "Object, Object": function ObjectObject(x, y) {
            if (Object.keys(x).length === 2 && Object.keys(y).length === 3) {
                if (!_2d(x)) throw new TypeError("Values of pointX and pointY should be numbers or BigNumbers");
                if (!_3d(y)) throw new TypeError("Values of xCoeffLine, yCoeffLine and constant should be numbers or BigNumbers");
                if ("pointX" in x && "pointY" in x && "xCoeffLine" in y && "yCoeffLine" in y && "constant" in y) return _distancePointLine2D(x.pointX, x.pointY, y.xCoeffLine, y.yCoeffLine, y.constant);
                else throw new TypeError("Key names do not match");
            } else if (Object.keys(x).length === 3 && Object.keys(y).length === 6) {
                // Point to Line 3D
                if (!_3d(x)) throw new TypeError("Values of pointX, pointY and pointZ should be numbers or BigNumbers");
                if (!_parametricLine(y)) throw new TypeError("Values of x0, y0, z0, a, b and c should be numbers or BigNumbers");
                if ("pointX" in x && "pointY" in x && "x0" in y && "y0" in y && "z0" in y && "a" in y && "b" in y && "c" in y) return _distancePointLine3D(x.pointX, x.pointY, x.pointZ, y.x0, y.y0, y.z0, y.a, y.b, y.c);
                else throw new TypeError("Key names do not match");
            } else if (Object.keys(x).length === 2 && Object.keys(y).length === 2) {
                // Point to Point 2D
                if (!_2d(x)) throw new TypeError("Values of pointOneX and pointOneY should be numbers or BigNumbers");
                if (!_2d(y)) throw new TypeError("Values of pointTwoX and pointTwoY should be numbers or BigNumbers");
                if ("pointOneX" in x && "pointOneY" in x && "pointTwoX" in y && "pointTwoY" in y) return _euclideanDistance([
                    x.pointOneX,
                    x.pointOneY
                ], [
                    y.pointTwoX,
                    y.pointTwoY
                ]);
                else throw new TypeError("Key names do not match");
            } else if (Object.keys(x).length === 3 && Object.keys(y).length === 3) {
                // Point to Point 3D
                if (!_3d(x)) throw new TypeError("Values of pointOneX, pointOneY and pointOneZ should be numbers or BigNumbers");
                if (!_3d(y)) throw new TypeError("Values of pointTwoX, pointTwoY and pointTwoZ should be numbers or BigNumbers");
                if ("pointOneX" in x && "pointOneY" in x && "pointOneZ" in x && "pointTwoX" in y && "pointTwoY" in y && "pointTwoZ" in y) return _euclideanDistance([
                    x.pointOneX,
                    x.pointOneY,
                    x.pointOneZ
                ], [
                    y.pointTwoX,
                    y.pointTwoY,
                    y.pointTwoZ
                ]);
                else throw new TypeError("Key names do not match");
            } else throw new TypeError("Invalid Arguments: Try again");
        },
        Array: function Array1(arr) {
            if (!_pairwise(arr)) throw new TypeError("Incorrect array format entered for pairwise distance calculation");
            return _distancePairwise(arr);
        }
    });
    function _isNumber(a) {
        // distance supports numbers and bignumbers
        return typeof a === "number" || (0, $d8097b7a6d6e36d8$export$e51d0e7e5c4a03ab)(a);
    }
    function _2d(a) {
        // checks if the number of arguments are correct in count and are valid (should be numbers)
        if (a.constructor !== Array) a = _objectToArray(a);
        return _isNumber(a[0]) && _isNumber(a[1]);
    }
    function _3d(a) {
        // checks if the number of arguments are correct in count and are valid (should be numbers)
        if (a.constructor !== Array) a = _objectToArray(a);
        return _isNumber(a[0]) && _isNumber(a[1]) && _isNumber(a[2]);
    }
    function _containsOnlyNumbers(a) {
        // checks if the number of arguments are correct in count and are valid (should be numbers)
        if (!Array.isArray(a)) a = _objectToArray(a);
        return a.every(_isNumber);
    }
    function _parametricLine(a) {
        if (a.constructor !== Array) a = _objectToArray(a);
        return _isNumber(a[0]) && _isNumber(a[1]) && _isNumber(a[2]) && _isNumber(a[3]) && _isNumber(a[4]) && _isNumber(a[5]);
    }
    function _objectToArray(o) {
        var keys = Object.keys(o);
        var a = [];
        for(var i = 0; i < keys.length; i++)a.push(o[keys[i]]);
        return a;
    }
    function _pairwise(a) {
        // checks for valid arguments passed to _distancePairwise(Array)
        if (a[0].length === 2 && _isNumber(a[0][0]) && _isNumber(a[0][1])) {
            if (a.some((aI)=>aI.length !== 2 || !_isNumber(aI[0]) || !_isNumber(aI[1]))) return false;
        } else if (a[0].length === 3 && _isNumber(a[0][0]) && _isNumber(a[0][1]) && _isNumber(a[0][2])) {
            if (a.some((aI)=>aI.length !== 3 || !_isNumber(aI[0]) || !_isNumber(aI[1]) || !_isNumber(aI[2]))) return false;
        } else return false;
        return true;
    }
    function _distancePointLine2D(x, y, a, b, c) {
        var num = abs(addScalar(addScalar(multiplyScalar(a, x), multiplyScalar(b, y)), c));
        var den = sqrt(addScalar(multiplyScalar(a, a), multiplyScalar(b, b)));
        return divideScalar(num, den);
    }
    function _distancePointLine3D(x, y, z, x0, y0, z0, a, b, c) {
        var num = [
            subtract(multiplyScalar(subtract(y0, y), c), multiplyScalar(subtract(z0, z), b)),
            subtract(multiplyScalar(subtract(z0, z), a), multiplyScalar(subtract(x0, x), c)),
            subtract(multiplyScalar(subtract(x0, x), b), multiplyScalar(subtract(y0, y), a))
        ];
        num = sqrt(addScalar(addScalar(multiplyScalar(num[0], num[0]), multiplyScalar(num[1], num[1])), multiplyScalar(num[2], num[2])));
        var den = sqrt(addScalar(addScalar(multiplyScalar(a, a), multiplyScalar(b, b)), multiplyScalar(c, c)));
        return divideScalar(num, den);
    }
    function _euclideanDistance(x, y) {
        var vectorSize = x.length;
        var result = 0;
        var diff = 0;
        for(var i = 0; i < vectorSize; i++){
            diff = subtract(x[i], y[i]);
            result = addScalar(multiplyScalar(diff, diff), result);
        }
        return sqrt(result);
    }
    function _distancePairwise(a) {
        var result = [];
        var pointA = [];
        var pointB = [];
        for(var i = 0; i < a.length - 1; i++)for(var j = i + 1; j < a.length; j++){
            if (a[0].length === 2) {
                pointA = [
                    a[i][0],
                    a[i][1]
                ];
                pointB = [
                    a[j][0],
                    a[j][1]
                ];
            } else if (a[0].length === 3) {
                pointA = [
                    a[i][0],
                    a[i][1],
                    a[i][2]
                ];
                pointB = [
                    a[j][0],
                    a[j][1],
                    a[j][2]
                ];
            }
            result.push(_euclideanDistance(pointA, pointB));
        }
        return result;
    }
});







var $0e4903b2befa5dae$var$name = "dotMultiply";
var $0e4903b2befa5dae$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar",
    "multiplyScalar"
];
var $0e4903b2befa5dae$export$a4620e84460f321e = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($0e4903b2befa5dae$var$name, $0e4903b2befa5dae$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar, multiplyScalar: multiplyScalar } = _ref;
    var algorithm02 = (0, $caf358e9c2d20263$export$92edb534a8f19a37)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm09 = (0, $fb5028d7a5e916f4$export$c769437575b0fcdd)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm11 = (0, $83b92f81e511657d$export$a38279a12199d831)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm13 = (0, $c68b38998aadcc11$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $533d58927c47005f$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Multiply two matrices element wise. The function accepts both matrices and
   * scalar values.
   *
   * Syntax:
   *
   *    math.dotMultiply(x, y)
   *
   * Examples:
   *
   *    math.dotMultiply(2, 4) // returns 8
   *
   *    a = [[9, 5], [6, 1]]
   *    b = [[3, 2], [5, 2]]
   *
   *    math.dotMultiply(a, b) // returns [[27, 10], [30, 2]]
   *    math.multiply(a, b)    // returns [[52, 28], [23, 14]]
   *
   * See also:
   *
   *    multiply, divide, dotDivide
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x Left hand value
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Right hand value
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}                    Multiplication of `x` and `y`
   */ return typed($0e4903b2befa5dae$var$name, {
        "any, any": multiplyScalar,
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm09(x, y, multiplyScalar, false);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, multiplyScalar, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm02(x, y, multiplyScalar, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, multiplyScalar);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm11(x, y, multiplyScalar, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, multiplyScalar, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm11(y, x, multiplyScalar, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, multiplyScalar, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, multiplyScalar, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, multiplyScalar, true).valueOf();
        }
    });
});


var $ec58370dc92fd308$var$name = "FibonacciHeap";
var $ec58370dc92fd308$var$dependencies = [
    "smaller",
    "larger"
];
var $ec58370dc92fd308$export$3143a09e27a84c41 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($ec58370dc92fd308$var$name, $ec58370dc92fd308$var$dependencies, (_ref)=>{
    var { smaller: smaller, larger: larger } = _ref;
    var oneOverLogPhi = 1.0 / Math.log((1.0 + Math.sqrt(5.0)) / 2.0);
    /**
   * Fibonacci Heap implementation, used interally for Matrix math.
   * @class FibonacciHeap
   * @constructor FibonacciHeap
   */ function FibonacciHeap() {
        if (!(this instanceof FibonacciHeap)) throw new SyntaxError("Constructor must be called with the new operator");
         // initialize fields
        this._minimum = null;
        this._size = 0;
    }
    /**
   * Attach type information
   */ FibonacciHeap.prototype.type = "FibonacciHeap";
    FibonacciHeap.prototype.isFibonacciHeap = true;
    /**
   * Inserts a new data element into the heap. No heap consolidation is
   * performed at this time, the new node is simply inserted into the root
   * list of this heap. Running time: O(1) actual.
   * @memberof FibonacciHeap
   */ FibonacciHeap.prototype.insert = function(key, value) {
        // create node
        var node = {
            key: key,
            value: value,
            degree: 0
        }; // check we have a node in the minimum
        if (this._minimum) {
            // minimum node
            var minimum = this._minimum; // update left & right of node
            node.left = minimum;
            node.right = minimum.right;
            minimum.right = node;
            node.right.left = node; // update minimum node in heap if needed
            if (smaller(key, minimum.key)) // node has a smaller key, use it as minimum
            this._minimum = node;
        } else {
            // set left & right
            node.left = node;
            node.right = node; // this is the first node
            this._minimum = node;
        } // increment number of nodes in heap
        this._size++; // return node
        return node;
    };
    /**
   * Returns the number of nodes in heap. Running time: O(1) actual.
   * @memberof FibonacciHeap
   */ FibonacciHeap.prototype.size = function() {
        return this._size;
    };
    /**
   * Removes all elements from this heap.
   * @memberof FibonacciHeap
   */ FibonacciHeap.prototype.clear = function() {
        this._minimum = null;
        this._size = 0;
    };
    /**
   * Returns true if the heap is empty, otherwise false.
   * @memberof FibonacciHeap
   */ FibonacciHeap.prototype.isEmpty = function() {
        return this._size === 0;
    };
    /**
   * Extracts the node with minimum key from heap. Amortized running
   * time: O(log n).
   * @memberof FibonacciHeap
   */ FibonacciHeap.prototype.extractMinimum = function() {
        // node to remove
        var node = this._minimum; // check we have a minimum
        if (node === null) return node;
         // current minimum
        var minimum = this._minimum; // get number of children
        var numberOfChildren = node.degree; // pointer to the first child
        var x = node.child; // for each child of node do...
        while(numberOfChildren > 0){
            // store node in right side
            var tempRight = x.right; // remove x from child list
            x.left.right = x.right;
            x.right.left = x.left; // add x to root list of heap
            x.left = minimum;
            x.right = minimum.right;
            minimum.right = x;
            x.right.left = x; // set Parent[x] to null
            x.parent = null;
            x = tempRight;
            numberOfChildren--;
        } // remove node from root list of heap
        node.left.right = node.right;
        node.right.left = node.left; // update minimum
        if (node === node.right) // empty
        minimum = null;
        else {
            // update minimum
            minimum = node.right; // we need to update the pointer to the root with minimum key
            minimum = _findMinimumNode(minimum, this._size);
        } // decrement size of heap
        this._size--; // update minimum
        this._minimum = minimum; // return node
        return node;
    };
    /**
   * Removes a node from the heap given the reference to the node. The trees
   * in the heap will be consolidated, if necessary. This operation may fail
   * to remove the correct element if there are nodes with key value -Infinity.
   * Running time: O(log n) amortized.
   * @memberof FibonacciHeap
   */ FibonacciHeap.prototype.remove = function(node) {
        // decrease key value
        this._minimum = _decreaseKey(this._minimum, node, -1); // remove the smallest
        this.extractMinimum();
    };
    /**
   * Decreases the key value for a heap node, given the new value to take on.
   * The structure of the heap may be changed and will not be consolidated.
   * Running time: O(1) amortized.
   * @memberof FibonacciHeap
   */ function _decreaseKey(minimum, node, key) {
        // set node key
        node.key = key; // get parent node
        var parent = node.parent;
        if (parent && smaller(node.key, parent.key)) {
            // remove node from parent
            _cut(minimum, node, parent); // remove all nodes from parent to the root parent
            _cascadingCut(minimum, parent);
        } // update minimum node if needed
        if (smaller(node.key, minimum.key)) minimum = node;
         // return minimum
        return minimum;
    }
    /**
   * The reverse of the link operation: removes node from the child list of parent.
   * This method assumes that min is non-null. Running time: O(1).
   * @memberof FibonacciHeap
   */ function _cut(minimum, node, parent) {
        // remove node from parent children and decrement Degree[parent]
        node.left.right = node.right;
        node.right.left = node.left;
        parent.degree--; // reset y.child if necessary
        if (parent.child === node) parent.child = node.right;
         // remove child if degree is 0
        if (parent.degree === 0) parent.child = null;
         // add node to root list of heap
        node.left = minimum;
        node.right = minimum.right;
        minimum.right = node;
        node.right.left = node; // set parent[node] to null
        node.parent = null; // set mark[node] to false
        node.mark = false;
    }
    /**
   * Performs a cascading cut operation. This cuts node from its parent and then
   * does the same for its parent, and so on up the tree.
   * Running time: O(log n); O(1) excluding the recursion.
   * @memberof FibonacciHeap
   */ function _cascadingCut(minimum, node) {
        // store parent node
        var parent = node.parent; // if there's a parent...
        if (!parent) return;
         // if node is unmarked, set it marked
        if (!node.mark) node.mark = true;
        else {
            // it's marked, cut it from parent
            _cut(minimum, node, parent); // cut its parent as well
            _cascadingCut(parent);
        }
    }
    /**
   * Make the first node a child of the second one. Running time: O(1) actual.
   * @memberof FibonacciHeap
   */ var _linkNodes = function _linkNodes(node, parent) {
        // remove node from root list of heap
        node.left.right = node.right;
        node.right.left = node.left; // make node a Child of parent
        node.parent = parent;
        if (!parent.child) {
            parent.child = node;
            node.right = node;
            node.left = node;
        } else {
            node.left = parent.child;
            node.right = parent.child.right;
            parent.child.right = node;
            node.right.left = node;
        } // increase degree[parent]
        parent.degree++; // set mark[node] false
        node.mark = false;
    };
    function _findMinimumNode(minimum, size) {
        // to find trees of the same degree efficiently we use an array of length O(log n) in which we keep a pointer to one root of each degree
        var arraySize = Math.floor(Math.log(size) * oneOverLogPhi) + 1; // create list with initial capacity
        var array = new Array(arraySize); // find the number of root nodes.
        var numRoots = 0;
        var x = minimum;
        if (x) {
            numRoots++;
            x = x.right;
            while(x !== minimum){
                numRoots++;
                x = x.right;
            }
        } // vars
        var y; // For each node in root list do...
        while(numRoots > 0){
            // access this node's degree..
            var d = x.degree; // get next node
            var next = x.right; // check if there is a node already in array with the same degree
            while(true){
                // get node with the same degree is any
                y = array[d];
                if (!y) break;
                 // make one node with the same degree a child of the other, do this based on the key value.
                if (larger(x.key, y.key)) {
                    var temp = y;
                    y = x;
                    x = temp;
                } // make y a child of x
                _linkNodes(y, x); // we have handled this degree, go to next one.
                array[d] = null;
                d++;
            } // save this node for later when we might encounter another of the same degree.
            array[d] = x; // move forward through list.
            x = next;
            numRoots--;
        } // Set min to null (effectively losing the root list) and reconstruct the root list from the array entries in array[].
        minimum = null; // loop nodes in array
        for(var i = 0; i < arraySize; i++){
            // get current node
            y = array[i];
            if (!y) continue;
             // check if we have a linked list
            if (minimum) {
                // First remove node from root list.
                y.left.right = y.right;
                y.right.left = y.left; // now add to root list, again.
                y.left = minimum;
                y.right = minimum.right;
                minimum.right = y;
                y.right.left = y; // check if this is a new min.
                if (smaller(y.key, minimum.key)) minimum = y;
            } else minimum = y;
        }
        return minimum;
    }
    return FibonacciHeap;
}, {
    isClass: true
});





var $20a0cc318f977309$var$name = "fix";
var $20a0cc318f977309$var$dependencies = [
    "typed",
    "Complex",
    "matrix",
    "ceil",
    "floor",
    "equalScalar",
    "zeros",
    "DenseMatrix"
];
var $20a0cc318f977309$export$595d114466bb5460 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($20a0cc318f977309$var$name, [
    "typed",
    "ceil",
    "floor"
], (_ref)=>{
    var { typed: typed, ceil: ceil, floor: floor } = _ref;
    return typed($20a0cc318f977309$var$name, {
        number: function number(x) {
            return x > 0 ? floor(x) : ceil(x);
        },
        "number, number": function numberNumber(x, n) {
            return x > 0 ? floor(x, n) : ceil(x, n);
        }
    });
});
var $20a0cc318f977309$export$3ed06081b8a4ee6 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($20a0cc318f977309$var$name, $20a0cc318f977309$var$dependencies, (_ref2)=>{
    var { typed: typed, Complex: _Complex, matrix: matrix, ceil: ceil, floor: floor, equalScalar: equalScalar, zeros: zeros, DenseMatrix: DenseMatrix } = _ref2;
    var algorithm12 = (0, $500ff63908aabda9$export$806772cd23b603dc)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm14 = (0, $533d58927c47005f$export$e5afe3bc814ef550)({
        typed: typed
    });
    var fixNumber = $20a0cc318f977309$export$595d114466bb5460({
        typed: typed,
        ceil: ceil,
        floor: floor
    });
    /**
   * Round a value towards zero.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.fix(x)
   *    math.fix(x,n)
   *
   * Examples:
   *
   *    math.fix(3.2)                // returns number 3
   *    math.fix(3.8)                // returns number 3
   *    math.fix(-4.2)               // returns number -4
   *    math.fix(-4.7)               // returns number -4
   *
   *    math.fix(3.12, 1)                // returns number 3.1
   *    math.fix(3.18, 1)                // returns number 3.1
   *    math.fix(-4.12, 1)               // returns number -4.1
   *    math.fix(-4.17, 1)               // returns number -4.1
   *
   *    const c = math.complex(3.22, -2.78)
   *    math.fix(c)                  // returns Complex 3 - 2i
   *    math.fix(c, 1)               // returns Complex 3.2 - 2.7i
   *
   *    math.fix([3.2, 3.8, -4.7])      // returns Array [3, 3, -4]
   *    math.fix([3.2, 3.8, -4.7], 1)   // returns Array [3.2, 3.8, -4.7]
   *
   * See also:
   *
   *    ceil, floor, round
   *
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix} x    Number to be rounded
   * @param  {number | BigNumber | Array} [n=0]                             Number of decimals
   * @return {number | BigNumber | Fraction | Complex | Array | Matrix}     Rounded value
   */ return typed("fix", {
        number: fixNumber.signatures.number,
        "number, number | BigNumber": fixNumber.signatures["number,number"],
        Complex: function Complex(x) {
            return new _Complex(x.re > 0 ? Math.floor(x.re) : Math.ceil(x.re), x.im > 0 ? Math.floor(x.im) : Math.ceil(x.im));
        },
        "Complex, number": function ComplexNumber(x, n) {
            return new _Complex(x.re > 0 ? floor(x.re, n) : ceil(x.re, n), x.im > 0 ? floor(x.im, n) : ceil(x.im, n));
        },
        "Complex, BigNumber": function ComplexBigNumber(x, bn) {
            var n = bn.toNumber();
            return new _Complex(x.re > 0 ? floor(x.re, n) : ceil(x.re, n), x.im > 0 ? floor(x.im, n) : ceil(x.im, n));
        },
        BigNumber: function BigNumber(x) {
            return x.isNegative() ? ceil(x) : floor(x);
        },
        "BigNumber, number | BigNumber": function BigNumberNumberBigNumber(x, n) {
            return x.isNegative() ? ceil(x, n) : floor(x, n);
        },
        Fraction: function Fraction(x) {
            return x.s < 0 ? x.ceil() : x.floor();
        },
        "Fraction, number | BigNumber": function FractionNumberBigNumber(x, n) {
            return x.s < 0 ? ceil(x, n) : floor(x, n);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            // deep map collection, skip zeros since fix(0) = 0
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this, true);
        },
        "Array | Matrix, number | BigNumber": function ArrayMatrixNumberBigNumber(x, n) {
            // deep map collection, skip zeros since fix(0) = 0
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, (i)=>this(i, n), true);
        },
        "number | Complex | Fraction | BigNumber, Array": function numberComplexFractionBigNumberArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        },
        "number | Complex | Fraction | BigNumber, Matrix": function numberComplexFractionBigNumberMatrix(x, y) {
            if (equalScalar(x, 0)) return zeros(y.size(), y.storage());
            if (y.storage() === "dense") return algorithm14(y, x, this, true);
            return algorithm12(y, x, this, true);
        }
    });
});




var $9c1144a03dbe6f48$var$name = "ImmutableDenseMatrix";
var $9c1144a03dbe6f48$var$dependencies = [
    "smaller",
    "DenseMatrix"
];
var $9c1144a03dbe6f48$export$49a565643b9ab608 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($9c1144a03dbe6f48$var$name, $9c1144a03dbe6f48$var$dependencies, (_ref)=>{
    var { smaller: smaller, DenseMatrix: DenseMatrix } = _ref;
    function ImmutableDenseMatrix(data, datatype) {
        if (!(this instanceof ImmutableDenseMatrix)) throw new SyntaxError("Constructor must be called with the new operator");
        if (datatype && !(0, $d8097b7a6d6e36d8$export$844ec244b1367d54)(datatype)) throw new Error("Invalid datatype: " + datatype);
        if ((0, $d8097b7a6d6e36d8$export$b22160e0a14f87b7)(data) || (0, $d8097b7a6d6e36d8$export$43bee75e5e14138e)(data)) {
            // use DenseMatrix implementation
            var matrix = new DenseMatrix(data, datatype); // internal structures
            this._data = matrix._data;
            this._size = matrix._size;
            this._datatype = matrix._datatype;
            this._min = null;
            this._max = null;
        } else if (data && (0, $d8097b7a6d6e36d8$export$43bee75e5e14138e)(data.data) && (0, $d8097b7a6d6e36d8$export$43bee75e5e14138e)(data.size)) {
            // initialize fields from JSON representation
            this._data = data.data;
            this._size = data.size;
            this._datatype = data.datatype;
            this._min = typeof data.min !== "undefined" ? data.min : null;
            this._max = typeof data.max !== "undefined" ? data.max : null;
        } else if (data) // unsupported type
        throw new TypeError("Unsupported type of data (" + (0, $d8097b7a6d6e36d8$export$f5bbd400c2f4426f)(data) + ")");
        else {
            // nothing provided
            this._data = [];
            this._size = [
                0
            ];
            this._datatype = datatype;
            this._min = null;
            this._max = null;
        }
    }
    ImmutableDenseMatrix.prototype = new DenseMatrix();
    /**
   * Attach type information
   */ ImmutableDenseMatrix.prototype.type = "ImmutableDenseMatrix";
    ImmutableDenseMatrix.prototype.isImmutableDenseMatrix = true;
    /**
   * Get a subset of the matrix, or replace a subset of the matrix.
   *
   * Usage:
   *     const subset = matrix.subset(index)               // retrieve subset
   *     const value = matrix.subset(index, replacement)   // replace subset
   *
   * @param {Index} index
   * @param {Array | ImmutableDenseMatrix | *} [replacement]
   * @param {*} [defaultValue=0]      Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be filled with zeros.
   */ ImmutableDenseMatrix.prototype.subset = function(index) {
        switch(arguments.length){
            case 1:
                // use base implementation
                var m = DenseMatrix.prototype.subset.call(this, index); // check result is a matrix
                if ((0, $d8097b7a6d6e36d8$export$b22160e0a14f87b7)(m)) // return immutable matrix
                return new ImmutableDenseMatrix({
                    data: m._data,
                    size: m._size,
                    datatype: m._datatype
                });
                return m;
            // intentional fall through
            case 2:
            case 3:
                throw new Error("Cannot invoke set subset on an Immutable Matrix instance");
            default:
                throw new SyntaxError("Wrong number of arguments");
        }
    };
    /**
   * Replace a single element in the matrix.
   * @param {Number[]} index   Zero-based index
   * @param {*} value
   * @param {*} [defaultValue]        Default value, filled in on new entries when
   *                                  the matrix is resized. If not provided,
   *                                  new matrix elements will be left undefined.
   * @return {ImmutableDenseMatrix} self
   */ ImmutableDenseMatrix.prototype.set = function() {
        throw new Error("Cannot invoke set on an Immutable Matrix instance");
    };
    /**
   * Resize the matrix to the given size. Returns a copy of the matrix when
   * `copy=true`, otherwise return the matrix itself (resize in place).
   *
   * @param {Number[]} size           The new size the matrix should have.
   * @param {*} [defaultValue=0]      Default value, filled in on new entries.
   *                                  If not provided, the matrix elements will
   *                                  be filled with zeros.
   * @param {boolean} [copy]          Return a resized copy of the matrix
   *
   * @return {Matrix}                 The resized matrix
   */ ImmutableDenseMatrix.prototype.resize = function() {
        throw new Error("Cannot invoke resize on an Immutable Matrix instance");
    };
    /**
   * Disallows reshaping in favor of immutability.
   *
   * @throws {Error} Operation not allowed
   */ ImmutableDenseMatrix.prototype.reshape = function() {
        throw new Error("Cannot invoke reshape on an Immutable Matrix instance");
    };
    /**
   * Create a clone of the matrix
   * @return {ImmutableDenseMatrix} clone
   */ ImmutableDenseMatrix.prototype.clone = function() {
        return new ImmutableDenseMatrix({
            data: (0, $6819694788cbfa38$export$9cd59f9826255e47)(this._data),
            size: (0, $6819694788cbfa38$export$9cd59f9826255e47)(this._size),
            datatype: this._datatype
        });
    };
    /**
   * Get a JSON representation of the matrix
   * @returns {Object}
   */ ImmutableDenseMatrix.prototype.toJSON = function() {
        return {
            mathjs: "ImmutableDenseMatrix",
            data: this._data,
            size: this._size,
            datatype: this._datatype
        };
    };
    /**
   * Generate a matrix from a JSON object
   * @param {Object} json  An object structured like
   *                       `{"mathjs": "ImmutableDenseMatrix", data: [], size: []}`,
   *                       where mathjs is optional
   * @returns {ImmutableDenseMatrix}
   */ ImmutableDenseMatrix.fromJSON = function(json) {
        return new ImmutableDenseMatrix(json);
    };
    /**
   * Swap rows i and j in Matrix.
   *
   * @param {Number} i       Matrix row index 1
   * @param {Number} j       Matrix row index 2
   *
   * @return {Matrix}        The matrix reference
   */ ImmutableDenseMatrix.prototype.swapRows = function() {
        throw new Error("Cannot invoke swapRows on an Immutable Matrix instance");
    };
    /**
   * Calculate the minimum value in the set
   * @return {Number | undefined} min
   */ ImmutableDenseMatrix.prototype.min = function() {
        // check min has been calculated before
        if (this._min === null) {
            // minimum
            var m = null; // compute min
            this.forEach(function(v) {
                if (m === null || smaller(v, m)) m = v;
            });
            this._min = m !== null ? m : undefined;
        }
        return this._min;
    };
    /**
   * Calculate the maximum value in the set
   * @return {Number | undefined} max
   */ ImmutableDenseMatrix.prototype.max = function() {
        // check max has been calculated before
        if (this._max === null) {
            // maximum
            var m = null; // compute max
            this.forEach(function(v) {
                if (m === null || smaller(m, v)) m = v;
            });
            this._max = m !== null ? m : undefined;
        }
        return this._max;
    };
    return ImmutableDenseMatrix;
}, {
    isClass: true
});





var $b90195680626113a$var$name = "Index";
var $b90195680626113a$var$dependencies = [
    "ImmutableDenseMatrix"
];
var $b90195680626113a$export$300720b4fe34e62e = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($b90195680626113a$var$name, $b90195680626113a$var$dependencies, (_ref)=>{
    var { ImmutableDenseMatrix: ImmutableDenseMatrix } = _ref;
    /**
   * Create an index. An Index can store ranges and sets for multiple dimensions.
   * Matrix.get, Matrix.set, and math.subset accept an Index as input.
   *
   * Usage:
   *     const index = new Index(range1, range2, matrix1, array1, ...)
   *
   * Where each parameter can be any of:
   *     A number
   *     A string (containing a name of an object property)
   *     An instance of Range
   *     An Array with the Set values
   *     A Matrix with the Set values
   *
   * The parameters start, end, and step must be integer numbers.
   *
   * @class Index
   * @Constructor Index
   * @param {...*} ranges
   */ function Index(ranges) {
        if (!(this instanceof Index)) throw new SyntaxError("Constructor must be called with the new operator");
        this._dimensions = [];
        this._isScalar = true;
        for(var i = 0, ii = arguments.length; i < ii; i++){
            var arg = arguments[i];
            if ((0, $d8097b7a6d6e36d8$export$e331ccfa6f694c99)(arg)) {
                this._dimensions.push(arg);
                this._isScalar = false;
            } else if (Array.isArray(arg) || (0, $d8097b7a6d6e36d8$export$b22160e0a14f87b7)(arg)) {
                // create matrix
                var m = _createImmutableMatrix(arg.valueOf());
                this._dimensions.push(m); // size
                var size = m.size(); // scalar
                if (size.length !== 1 || size[0] !== 1) this._isScalar = false;
            } else if (typeof arg === "number") this._dimensions.push(_createImmutableMatrix([
                arg
            ]));
            else if (typeof arg === "string") // object property (arguments.count should be 1)
            this._dimensions.push(arg);
            else throw new TypeError("Dimension must be an Array, Matrix, number, string, or Range");
             // TODO: implement support for wildcard '*'
        }
    }
    /**
   * Attach type information
   */ Index.prototype.type = "Index";
    Index.prototype.isIndex = true;
    function _createImmutableMatrix(arg) {
        // loop array elements
        for(var i = 0, l = arg.length; i < l; i++){
            if (typeof arg[i] !== "number" || !(0, $668e051498bf5fa0$export$a287f47fed4544b8)(arg[i])) throw new TypeError("Index parameters must be positive integer numbers");
        } // create matrix
        return new ImmutableDenseMatrix(arg);
    }
    /**
   * Create a clone of the index
   * @memberof Index
   * @return {Index} clone
   */ Index.prototype.clone = function() {
        var index = new Index();
        index._dimensions = (0, $6819694788cbfa38$export$9cd59f9826255e47)(this._dimensions);
        index._isScalar = this._isScalar;
        return index;
    };
    /**
   * Create an index from an array with ranges/numbers
   * @memberof Index
   * @param {Array.<Array | number>} ranges
   * @return {Index} index
   * @private
   */ Index.create = function(ranges) {
        var index = new Index();
        Index.apply(index, ranges);
        return index;
    };
    /**
   * Retrieve the size of the index, the number of elements for each dimension.
   * @memberof Index
   * @returns {number[]} size
   */ Index.prototype.size = function() {
        var size = [];
        for(var i = 0, ii = this._dimensions.length; i < ii; i++){
            var d = this._dimensions[i];
            size[i] = typeof d === "string" ? 1 : d.size()[0];
        }
        return size;
    };
    /**
   * Get the maximum value for each of the indexes ranges.
   * @memberof Index
   * @returns {number[]} max
   */ Index.prototype.max = function() {
        var values = [];
        for(var i = 0, ii = this._dimensions.length; i < ii; i++){
            var range = this._dimensions[i];
            values[i] = typeof range === "string" ? range : range.max();
        }
        return values;
    };
    /**
   * Get the minimum value for each of the indexes ranges.
   * @memberof Index
   * @returns {number[]} min
   */ Index.prototype.min = function() {
        var values = [];
        for(var i = 0, ii = this._dimensions.length; i < ii; i++){
            var range = this._dimensions[i];
            values[i] = typeof range === "string" ? range : range.min();
        }
        return values;
    };
    /**
   * Loop over each of the ranges of the index
   * @memberof Index
   * @param {Function} callback   Called for each range with a Range as first
   *                              argument, the dimension as second, and the
   *                              index object as third.
   */ Index.prototype.forEach = function(callback) {
        for(var i = 0, ii = this._dimensions.length; i < ii; i++)callback(this._dimensions[i], i, this);
    };
    /**
   * Retrieve the dimension for the given index
   * @memberof Index
   * @param {Number} dim                  Number of the dimension
   * @returns {Range | null} range
   */ Index.prototype.dimension = function(dim) {
        return this._dimensions[dim] || null;
    };
    /**
   * Test whether this index contains an object property
   * @returns {boolean} Returns true if the index is an object property
   */ Index.prototype.isObjectProperty = function() {
        return this._dimensions.length === 1 && typeof this._dimensions[0] === "string";
    };
    /**
   * Returns the object property name when the Index holds a single object property,
   * else returns null
   * @returns {string | null}
   */ Index.prototype.getObjectProperty = function() {
        return this.isObjectProperty() ? this._dimensions[0] : null;
    };
    /**
   * Test whether this index contains only a single value.
   *
   * This is the case when the index is created with only scalar values as ranges,
   * not for ranges resolving into a single value.
   * @memberof Index
   * @return {boolean} isScalar
   */ Index.prototype.isScalar = function() {
        return this._isScalar;
    };
    /**
   * Expand the Index into an array.
   * For example new Index([0,3], [2,7]) returns [[0,1,2], [2,3,4,5,6]]
   * @memberof Index
   * @returns {Array} array
   */ Index.prototype.toArray = function() {
        var array = [];
        for(var i = 0, ii = this._dimensions.length; i < ii; i++){
            var dimension = this._dimensions[i];
            array.push(typeof dimension === "string" ? dimension : dimension.toArray());
        }
        return array;
    };
    /**
   * Get the primitive value of the Index, a two dimensional array.
   * Equivalent to Index.toArray().
   * @memberof Index
   * @returns {Array} array
   */ Index.prototype.valueOf = Index.prototype.toArray;
    /**
   * Get the string representation of the index, for example '[2:6]' or '[0:2:10, 4:7, [1,2,3]]'
   * @memberof Index
   * @returns {String} str
   */ Index.prototype.toString = function() {
        var strings = [];
        for(var i = 0, ii = this._dimensions.length; i < ii; i++){
            var dimension = this._dimensions[i];
            if (typeof dimension === "string") strings.push(JSON.stringify(dimension));
            else strings.push(dimension.toString());
        }
        return "[" + strings.join(", ") + "]";
    };
    /**
   * Get a JSON representation of the Index
   * @memberof Index
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "Index", "ranges": [{"mathjs": "Range", start: 0, end: 10, step:1}, ...]}`
   */ Index.prototype.toJSON = function() {
        return {
            mathjs: "Index",
            dimensions: this._dimensions
        };
    };
    /**
   * Instantiate an Index from a JSON object
   * @memberof Index
   * @param {Object} json A JSON object structured as:
   *                     `{"mathjs": "Index", "dimensions": [{"mathjs": "Range", start: 0, end: 10, step:1}, ...]}`
   * @return {Index}
   */ Index.fromJSON = function(json) {
        return Index.create(json.dimensions);
    };
    return Index;
}, {
    isClass: true
});


var $28723d1534b136da$var$name = "intersect";
var $28723d1534b136da$var$dependencies = [
    "typed",
    "config",
    "abs",
    "add",
    "addScalar",
    "matrix",
    "multiply",
    "multiplyScalar",
    "divideScalar",
    "subtract",
    "smaller",
    "equalScalar",
    "flatten",
    "isZero",
    "isNumeric"
];
var $28723d1534b136da$export$e2d92d8f89fdd92d = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($28723d1534b136da$var$name, $28723d1534b136da$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, abs: abs, add: add, addScalar: addScalar, matrix: matrix, multiply: multiply, multiplyScalar: multiplyScalar, divideScalar: divideScalar, subtract: subtract, smaller: smaller, equalScalar: equalScalar, flatten: flatten, isZero: isZero, isNumeric: isNumeric } = _ref;
    /**
   * Calculates the point of intersection of two lines in two or three dimensions
   * and of a line and a plane in three dimensions. The inputs are in the form of
   * arrays or 1 dimensional matrices. The line intersection functions return null
   * if the lines do not meet.
   *
   * Note: Fill the plane coefficients as `x + y + z = c` and not as `x + y + z + c = 0`.
   *
   * Syntax:
   *
   *    math.intersect(endPoint1Line1, endPoint2Line1, endPoint1Line2, endPoint2Line2)
   *    math.intersect(endPoint1, endPoint2, planeCoefficients)
   *
   * Examples:
   *
   *    math.intersect([0, 0], [10, 10], [10, 0], [0, 10])              // Returns [5, 5]
   *    math.intersect([0, 0, 0], [10, 10, 0], [10, 0, 0], [0, 10, 0])  // Returns [5, 5, 0]
   *    math.intersect([1, 0, 1],  [4, -2, 2], [1, 1, 1, 6])            // Returns [7, -4, 3]
   *
   * @param  {Array | Matrix} w   Co-ordinates of first end-point of first line
   * @param  {Array | Matrix} x   Co-ordinates of second end-point of first line
   * @param  {Array | Matrix} y   Co-ordinates of first end-point of second line
   *                              OR Co-efficients of the plane's equation
   * @param  {Array | Matrix} z   Co-ordinates of second end-point of second line
   *                              OR undefined if the calculation is for line and plane
   * @return {Array}              Returns the point of intersection of lines/lines-planes
   */ return typed("intersect", {
        "Array, Array, Array": _AAA,
        "Array, Array, Array, Array": _AAAA,
        "Matrix, Matrix, Matrix": function MatrixMatrixMatrix(x, y, plane) {
            var arr = _AAA(x.valueOf(), y.valueOf(), plane.valueOf());
            return arr === null ? null : matrix(arr);
        },
        "Matrix, Matrix, Matrix, Matrix": function MatrixMatrixMatrixMatrix(w, x, y, z) {
            // TODO: output matrix type should match input matrix type
            var arr = _AAAA(w.valueOf(), x.valueOf(), y.valueOf(), z.valueOf());
            return arr === null ? null : matrix(arr);
        }
    });
    function _AAA(x, y, plane) {
        x = _coerceArr(x);
        y = _coerceArr(y);
        plane = _coerceArr(plane);
        if (!_3d(x)) throw new TypeError("Array with 3 numbers or BigNumbers expected for first argument");
        if (!_3d(y)) throw new TypeError("Array with 3 numbers or BigNumbers expected for second argument");
        if (!_4d(plane)) throw new TypeError("Array with 4 numbers expected as third argument");
        return _intersectLinePlane(x[0], x[1], x[2], y[0], y[1], y[2], plane[0], plane[1], plane[2], plane[3]);
    }
    function _AAAA(w, x, y, z) {
        w = _coerceArr(w);
        x = _coerceArr(x);
        y = _coerceArr(y);
        z = _coerceArr(z);
        if (w.length === 2) {
            if (!_2d(w)) throw new TypeError("Array with 2 numbers or BigNumbers expected for first argument");
            if (!_2d(x)) throw new TypeError("Array with 2 numbers or BigNumbers expected for second argument");
            if (!_2d(y)) throw new TypeError("Array with 2 numbers or BigNumbers expected for third argument");
            if (!_2d(z)) throw new TypeError("Array with 2 numbers or BigNumbers expected for fourth argument");
            return _intersect2d(w, x, y, z);
        } else if (w.length === 3) {
            if (!_3d(w)) throw new TypeError("Array with 3 numbers or BigNumbers expected for first argument");
            if (!_3d(x)) throw new TypeError("Array with 3 numbers or BigNumbers expected for second argument");
            if (!_3d(y)) throw new TypeError("Array with 3 numbers or BigNumbers expected for third argument");
            if (!_3d(z)) throw new TypeError("Array with 3 numbers or BigNumbers expected for fourth argument");
            return _intersect3d(w[0], w[1], w[2], x[0], x[1], x[2], y[0], y[1], y[2], z[0], z[1], z[2]);
        } else throw new TypeError("Arrays with two or thee dimensional points expected");
    }
    /** Coerce row and column 2-dim arrays to 1-dim array */ function _coerceArr(arr) {
        // row matrix
        if (arr.length === 1) return arr[0]; // column matrix
        if (arr.length > 1 && Array.isArray(arr[0])) {
            if (arr.every((el)=>Array.isArray(el) && el.length === 1)) return flatten(arr);
        }
        return arr;
    }
    function _2d(x) {
        return x.length === 2 && isNumeric(x[0]) && isNumeric(x[1]);
    }
    function _3d(x) {
        return x.length === 3 && isNumeric(x[0]) && isNumeric(x[1]) && isNumeric(x[2]);
    }
    function _4d(x) {
        return x.length === 4 && isNumeric(x[0]) && isNumeric(x[1]) && isNumeric(x[2]) && isNumeric(x[3]);
    }
    function _intersect2d(p1a, p1b, p2a, p2b) {
        var o1 = p1a;
        var o2 = p2a;
        var d1 = subtract(o1, p1b);
        var d2 = subtract(o2, p2b);
        var det = subtract(multiplyScalar(d1[0], d2[1]), multiplyScalar(d2[0], d1[1]));
        if (isZero(det)) return null;
        if (smaller(abs(det), config.epsilon)) return null;
        var d20o11 = multiplyScalar(d2[0], o1[1]);
        var d21o10 = multiplyScalar(d2[1], o1[0]);
        var d20o21 = multiplyScalar(d2[0], o2[1]);
        var d21o20 = multiplyScalar(d2[1], o2[0]);
        var t = divideScalar(addScalar(subtract(subtract(d20o11, d21o10), d20o21), d21o20), det);
        return add(multiply(d1, t), o1);
    }
    function _intersect3dHelper(a, b, c, d, e, f, g, h, i, j, k, l) {
        // (a - b)*(c - d) + (e - f)*(g - h) + (i - j)*(k - l)
        var add1 = multiplyScalar(subtract(a, b), subtract(c, d));
        var add2 = multiplyScalar(subtract(e, f), subtract(g, h));
        var add3 = multiplyScalar(subtract(i, j), subtract(k, l));
        return addScalar(addScalar(add1, add2), add3);
    }
    function _intersect3d(x1, y1, z1, x2, y2, z2, x3, y3, z3, x4, y4, z4) {
        var d1343 = _intersect3dHelper(x1, x3, x4, x3, y1, y3, y4, y3, z1, z3, z4, z3);
        var d4321 = _intersect3dHelper(x4, x3, x2, x1, y4, y3, y2, y1, z4, z3, z2, z1);
        var d1321 = _intersect3dHelper(x1, x3, x2, x1, y1, y3, y2, y1, z1, z3, z2, z1);
        var d4343 = _intersect3dHelper(x4, x3, x4, x3, y4, y3, y4, y3, z4, z3, z4, z3);
        var d2121 = _intersect3dHelper(x2, x1, x2, x1, y2, y1, y2, y1, z2, z1, z2, z1);
        var numerator = subtract(multiplyScalar(d1343, d4321), multiplyScalar(d1321, d4343));
        var denominator = subtract(multiplyScalar(d2121, d4343), multiplyScalar(d4321, d4321));
        if (isZero(denominator)) return null;
        var ta = divideScalar(numerator, denominator);
        var tb = divideScalar(addScalar(d1343, multiplyScalar(ta, d4321)), d4343);
        var pax = addScalar(x1, multiplyScalar(ta, subtract(x2, x1)));
        var pay = addScalar(y1, multiplyScalar(ta, subtract(y2, y1)));
        var paz = addScalar(z1, multiplyScalar(ta, subtract(z2, z1)));
        var pbx = addScalar(x3, multiplyScalar(tb, subtract(x4, x3)));
        var pby = addScalar(y3, multiplyScalar(tb, subtract(y4, y3)));
        var pbz = addScalar(z3, multiplyScalar(tb, subtract(z4, z3)));
        if (equalScalar(pax, pbx) && equalScalar(pay, pby) && equalScalar(paz, pbz)) return [
            pax,
            pay,
            paz
        ];
        else return null;
    }
    function _intersectLinePlane(x1, y1, z1, x2, y2, z2, x, y, z, c) {
        var x1x = multiplyScalar(x1, x);
        var x2x = multiplyScalar(x2, x);
        var y1y = multiplyScalar(y1, y);
        var y2y = multiplyScalar(y2, y);
        var z1z = multiplyScalar(z1, z);
        var z2z = multiplyScalar(z2, z);
        var numerator = subtract(subtract(subtract(c, x1x), y1y), z1z);
        var denominator = subtract(subtract(subtract(addScalar(addScalar(x2x, y2y), z2z), x1x), y1y), z1z);
        var t = divideScalar(numerator, denominator);
        var px = addScalar(x1, multiplyScalar(t, subtract(x2, x1)));
        var py = addScalar(y1, multiplyScalar(t, subtract(y2, y1)));
        var pz = addScalar(z1, multiplyScalar(t, subtract(z2, z1)));
        return [
            px,
            py,
            pz
        ]; // TODO: Add cases when line is parallel to the plane:
    //       (a) no intersection,
    //       (b) line contained in plane
    }
});








var $05fb4effad623485$var$name = "lcm";
var $05fb4effad623485$var$dependencies = [
    "typed",
    "matrix",
    "equalScalar"
];
var $05fb4effad623485$export$5d3af1956d9bb33b = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($05fb4effad623485$var$name, $05fb4effad623485$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, equalScalar: equalScalar } = _ref;
    var algorithm02 = (0, $caf358e9c2d20263$export$92edb534a8f19a37)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm06 = (0, $648c171bfbb07130$export$d6f401e6f2a7e54b)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm11 = (0, $83b92f81e511657d$export$a38279a12199d831)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm13 = (0, $c68b38998aadcc11$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $533d58927c47005f$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Calculate the least common multiple for two or more values or arrays.
   *
   * lcm is defined as:
   *
   *     lcm(a, b) = abs(a * b) / gcd(a, b)
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.lcm(a, b)
   *    math.lcm(a, b, c, ...)
   *
   * Examples:
   *
   *    math.lcm(4, 6)               // returns 12
   *    math.lcm(6, 21)              // returns 42
   *    math.lcm(6, 21, 5)           // returns 210
   *
   *    math.lcm([4, 6], [6, 21])    // returns [12, 42]
   *
   * See also:
   *
   *    gcd, xgcd
   *
   * @param {... number | BigNumber | Array | Matrix} args  Two or more integer numbers
   * @return {number | BigNumber | Array | Matrix}                           The least common multiple
   */ return typed($05fb4effad623485$var$name, {
        "number, number": (0, $4b37ed316f05dd33$export$b55f99ec1f4c5649),
        "BigNumber, BigNumber": _lcmBigNumber,
        "Fraction, Fraction": function FractionFraction(x, y) {
            return x.lcm(y);
        },
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm06(x, y, this);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm02(y, x, this, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm02(x, y, this, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, this);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, number | BigNumber": function SparseMatrixNumberBigNumber(x, y) {
            return algorithm11(x, y, this, false);
        },
        "DenseMatrix, number | BigNumber": function DenseMatrixNumberBigNumber(x, y) {
            return algorithm14(x, y, this, false);
        },
        "number | BigNumber, SparseMatrix": function numberBigNumberSparseMatrix(x, y) {
            return algorithm11(y, x, this, true);
        },
        "number | BigNumber, DenseMatrix": function numberBigNumberDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        "Array, number | BigNumber": function ArrayNumberBigNumber(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        "number | BigNumber, Array": function numberBigNumberArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        },
        // TODO: need a smarter notation here
        "Array | Matrix | number | BigNumber, Array | Matrix | number | BigNumber, ...Array | Matrix | number | BigNumber": function ArrayMatrixNumberBigNumberArrayMatrixNumberBigNumberArrayMatrixNumberBigNumber(a, b, args) {
            var res = this(a, b);
            for(var i = 0; i < args.length; i++)res = this(res, args[i]);
            return res;
        }
    });
    /**
   * Calculate lcm for two BigNumbers
   * @param {BigNumber} a
   * @param {BigNumber} b
   * @returns {BigNumber} Returns the least common multiple of a and b
   * @private
   */ function _lcmBigNumber(a, b) {
        if (!a.isInt() || !b.isInt()) throw new Error("Parameters in function lcm must be integer numbers");
        if (a.isZero()) return a;
        if (b.isZero()) return b;
         // https://en.wikipedia.org/wiki/Euclidean_algorithm
        // evaluate lcm here inline to reduce overhead
        var prod = a.times(b);
        while(!b.isZero()){
            var t = b;
            b = a.mod(t);
            a = t;
        }
        return prod.div(a).abs();
    }
});




var $95662a94e91cd3f8$var$name = "log1p";
var $95662a94e91cd3f8$var$dependencies = [
    "typed",
    "config",
    "divideScalar",
    "log",
    "Complex"
];
var $95662a94e91cd3f8$export$93da279859a704f0 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($95662a94e91cd3f8$var$name, $95662a94e91cd3f8$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, divideScalar: divideScalar, log: log, Complex: Complex } = _ref;
    /**
   * Calculate the logarithm of a `value+1`.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.log1p(x)
   *    math.log1p(x, base)
   *
   * Examples:
   *
   *    math.log1p(2.5)                 // returns 1.252762968495368
   *    math.exp(math.log1p(1.4))       // returns 2.4
   *
   *    math.pow(10, 4)                 // returns 10000
   *    math.log1p(9999, 10)            // returns 4
   *    math.log1p(9999) / math.log(10) // returns 4
   *
   * See also:
   *
   *    exp, log, log2, log10
   *
   * @param {number | BigNumber | Complex | Array | Matrix} x
   *            Value for which to calculate the logarithm of `x+1`.
   * @param {number | BigNumber | Complex} [base=e]
   *            Optional base for the logarithm. If not provided, the natural
   *            logarithm of `x+1` is calculated.
   * @return {number | BigNumber | Complex | Array | Matrix}
   *            Returns the logarithm of `x+1`
   */ return typed($95662a94e91cd3f8$var$name, {
        number: function number(x) {
            if (x >= -1 || config.predictable) return (0, $668e051498bf5fa0$export$144dcf16adfb9698)(x);
            else // negative value -> complex value computation
            return _log1pComplex(new Complex(x, 0));
        },
        Complex: _log1pComplex,
        BigNumber: function BigNumber(x) {
            var y = x.plus(1);
            if (!y.isNegative() || config.predictable) return y.ln();
            else // downgrade to number, return Complex valued result
            return _log1pComplex(new Complex(x.toNumber(), 0));
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this);
        },
        "any, any": function anyAny(x, base) {
            // calculate logarithm for a specified base, log1p(x, base)
            return divideScalar(this(x), log(base));
        }
    });
    /**
   * Calculate the natural logarithm of a complex number + 1
   * @param {Complex} x
   * @returns {Complex}
   * @private
   */ function _log1pComplex(x) {
        var xRe1p = x.re + 1;
        return new Complex(Math.log(Math.sqrt(xRe1p * xRe1p + x.im * x.im)), Math.atan2(x.im, xRe1p));
    }
});




var $3b645b58d3c5484c$var$name = "max";
var $3b645b58d3c5484c$var$dependencies = [
    "typed",
    "config",
    "numeric",
    "larger"
];
var $3b645b58d3c5484c$export$b18a1b0c26c000ee = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($3b645b58d3c5484c$var$name, $3b645b58d3c5484c$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, numeric: numeric, larger: larger } = _ref;
    /**
   * Compute the maximum value of a matrix or a  list with values.
   * In case of a multi dimensional array, the maximum of the flattened array
   * will be calculated. When `dim` is provided, the maximum over the selected
   * dimension will be calculated. Parameter `dim` is zero-based.
   *
   * Syntax:
   *
   *     math.max(a, b, c, ...)
   *     math.max(A)
   *     math.max(A, dim)
   *
   * Examples:
   *
   *     math.max(2, 1, 4, 3)                  // returns 4
   *     math.max([2, 1, 4, 3])                // returns 4
   *
   *     // maximum over a specified dimension (zero-based)
   *     math.max([[2, 5], [4, 3], [1, 7]], 0) // returns [4, 7]
   *     math.max([[2, 5], [4, 3]], [1, 7], 1) // returns [5, 4, 7]
   *
   *     math.max(2.7, 7.1, -4.5, 2.0, 4.1)    // returns 7.1
   *     math.min(2.7, 7.1, -4.5, 2.0, 4.1)    // returns -4.5
   *
   * See also:
   *
   *    mean, median, min, prod, std, sum, variance
   *
   * @param {... *} args  A single matrix or or multiple scalar values
   * @return {*} The maximum value
   */ return typed($3b645b58d3c5484c$var$name, {
        // max([a, b, c, d, ...])
        "Array | Matrix": _max,
        // max([a, b, c, d, ...], dim)
        "Array | Matrix, number | BigNumber": function ArrayMatrixNumberBigNumber(array, dim) {
            return (0, $dd57e6221b0e50b6$export$533b26079ad0b4b)(array, dim.valueOf(), _largest);
        },
        // max(a, b, c, d, ...)
        "...": function _(args) {
            if ((0, $dd57e6221b0e50b6$export$4d8f6a27e2f5bcb2)(args)) throw new TypeError("Scalar values expected in function max");
            return _max(args);
        }
    });
    /**
   * Return the largest of two values
   * @param {*} x
   * @param {*} y
   * @returns {*} Returns x when x is largest, or y when y is largest
   * @private
   */ function _largest(x, y) {
        try {
            return larger(x, y) ? x : y;
        } catch (err) {
            throw (0, $b113219b83527e4b$export$c8994973cec629ae)(err, "max", y);
        }
    }
    /**
   * Recursively calculate the maximum value in an n-dimensional array
   * @param {Array} array
   * @return {number} max
   * @private
   */ function _max(array) {
        var res;
        (0, $dd57e6221b0e50b6$export$519ada94592b97fc)(array, function(value) {
            try {
                if (isNaN(value) && typeof value === "number") res = NaN;
                else if (res === undefined || larger(value, res)) res = value;
            } catch (err) {
                throw (0, $b113219b83527e4b$export$c8994973cec629ae)(err, "max", value);
            }
        });
        if (res === undefined) throw new Error("Cannot calculate max of an empty array");
         // make sure returning numeric value: parse a string into a numeric value
        if (typeof res === "string") res = numeric(res, config.number);
        return res;
    }
});





var $9b05ba7d0392c532$var$name = "quantileSeq";
var $9b05ba7d0392c532$var$dependencies = [
    "typed",
    "add",
    "multiply",
    "partitionSelect",
    "compare"
];
var $9b05ba7d0392c532$export$524607d17ea053e9 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($9b05ba7d0392c532$var$name, $9b05ba7d0392c532$var$dependencies, (_ref)=>{
    var { typed: typed, add: add, multiply: multiply, partitionSelect: partitionSelect, compare: compare } = _ref;
    /**
   * Compute the prob order quantile of a matrix or a list with values.
   * The sequence is sorted and the middle value is returned.
   * Supported types of sequence values are: Number, BigNumber, Unit
   * Supported types of probability are: Number, BigNumber
   *
   * In case of a (multi dimensional) array or matrix, the prob order quantile
   * of all elements will be calculated.
   *
   * Syntax:
   *
   *     math.quantileSeq(A, prob[, sorted])
   *     math.quantileSeq(A, [prob1, prob2, ...][, sorted])
   *     math.quantileSeq(A, N[, sorted])
   *
   * Examples:
   *
   *     math.quantileSeq([3, -1, 5, 7], 0.5)         // returns 4
   *     math.quantileSeq([3, -1, 5, 7], [1/3, 2/3])  // returns [3, 5]
   *     math.quantileSeq([3, -1, 5, 7], 2)           // returns [3, 5]
   *     math.quantileSeq([-1, 3, 5, 7], 0.5, true)   // returns 4
   *
   * See also:
   *
   *     median, mean, min, max, sum, prod, std, variance
   *
   * @param {Array, Matrix} data                A single matrix or Array
   * @param {Number, BigNumber, Array} probOrN  prob is the order of the quantile, while N is
   *                                            the amount of evenly distributed steps of
   *                                            probabilities; only one of these options can
   *                                            be provided
   * @param {Boolean} sorted=false              is data sorted in ascending order
   * @return {Number, BigNumber, Unit, Array}   Quantile(s)
   */ function quantileSeq(data, probOrN, sorted) {
        var probArr, dataArr, one;
        if (arguments.length < 2 || arguments.length > 3) throw new SyntaxError("Function quantileSeq requires two or three parameters");
        if ((0, $d8097b7a6d6e36d8$export$cea7aa84e978eba5)(data)) {
            sorted = sorted || false;
            if (typeof sorted === "boolean") {
                dataArr = data.valueOf();
                if ((0, $d8097b7a6d6e36d8$export$7e4aa119212bc614)(probOrN)) {
                    if (probOrN < 0) throw new Error("N/prob must be non-negative");
                    if (probOrN <= 1) // quantileSeq([a, b, c, d, ...], prob[,sorted])
                    return _quantileSeq(dataArr, probOrN, sorted);
                    if (probOrN > 1) {
                        // quantileSeq([a, b, c, d, ...], N[,sorted])
                        if (!(0, $668e051498bf5fa0$export$a287f47fed4544b8)(probOrN)) throw new Error("N must be a positive integer");
                        var nPlusOne = probOrN + 1;
                        probArr = new Array(probOrN);
                        for(var i = 0; i < probOrN;)probArr[i] = _quantileSeq(dataArr, ++i / nPlusOne, sorted);
                        return probArr;
                    }
                }
                if ((0, $d8097b7a6d6e36d8$export$e51d0e7e5c4a03ab)(probOrN)) {
                    var BigNumber = probOrN.constructor;
                    if (probOrN.isNegative()) throw new Error("N/prob must be non-negative");
                    one = new BigNumber(1);
                    if (probOrN.lte(one)) // quantileSeq([a, b, c, d, ...], prob[,sorted])
                    return new BigNumber(_quantileSeq(dataArr, probOrN, sorted));
                    if (probOrN.gt(one)) {
                        // quantileSeq([a, b, c, d, ...], N[,sorted])
                        if (!probOrN.isInteger()) throw new Error("N must be a positive integer");
                         // largest possible Array length is 2^32-1
                        // 2^32 < 10^15, thus safe conversion guaranteed
                        var intN = probOrN.toNumber();
                        if (intN > 4294967295) throw new Error("N must be less than or equal to 2^32-1, as that is the maximum length of an Array");
                        var _nPlusOne = new BigNumber(intN + 1);
                        probArr = new Array(intN);
                        for(var _i = 0; _i < intN;)probArr[_i] = new BigNumber(_quantileSeq(dataArr, new BigNumber(++_i).div(_nPlusOne), sorted));
                        return probArr;
                    }
                }
                if (Array.isArray(probOrN)) {
                    // quantileSeq([a, b, c, d, ...], [prob1, prob2, ...][,sorted])
                    probArr = new Array(probOrN.length);
                    for(var _i2 = 0; _i2 < probArr.length; ++_i2){
                        var currProb = probOrN[_i2];
                        if ((0, $d8097b7a6d6e36d8$export$7e4aa119212bc614)(currProb)) {
                            if (currProb < 0 || currProb > 1) throw new Error("Probability must be between 0 and 1, inclusive");
                        } else if ((0, $d8097b7a6d6e36d8$export$e51d0e7e5c4a03ab)(currProb)) {
                            one = new currProb.constructor(1);
                            if (currProb.isNegative() || currProb.gt(one)) throw new Error("Probability must be between 0 and 1, inclusive");
                        } else throw new TypeError("Unexpected type of argument in function quantileSeq"); // FIXME: becomes redundant when converted to typed-function
                        probArr[_i2] = _quantileSeq(dataArr, currProb, sorted);
                    }
                    return probArr;
                }
                throw new TypeError("Unexpected type of argument in function quantileSeq"); // FIXME: becomes redundant when converted to typed-function
            }
            throw new TypeError("Unexpected type of argument in function quantileSeq"); // FIXME: becomes redundant when converted to typed-function
        }
        throw new TypeError("Unexpected type of argument in function quantileSeq"); // FIXME: becomes redundant when converted to typed-function
    }
    /**
   * Calculate the prob order quantile of an n-dimensional array.
   *
   * @param {Array} array
   * @param {Number, BigNumber} prob
   * @param {Boolean} sorted
   * @return {Number, BigNumber, Unit} prob order quantile
   * @private
   */ function _quantileSeq(array, prob, sorted) {
        var flat = (0, $a14a10567870d913$export$bffa455ba8c619a6)(array);
        var len = flat.length;
        if (len === 0) throw new Error("Cannot calculate quantile of an empty sequence");
        if ((0, $d8097b7a6d6e36d8$export$7e4aa119212bc614)(prob)) {
            var _index = prob * (len - 1);
            var _fracPart = _index % 1;
            if (_fracPart === 0) {
                var value = sorted ? flat[_index] : partitionSelect(flat, _index);
                validate(value);
                return value;
            }
            var _integerPart = Math.floor(_index);
            var _left;
            var _right;
            if (sorted) {
                _left = flat[_integerPart];
                _right = flat[_integerPart + 1];
            } else {
                _right = partitionSelect(flat, _integerPart + 1); // max of partition is kth largest
                _left = flat[_integerPart];
                for(var i = 0; i < _integerPart; ++i)if (compare(flat[i], _left) > 0) _left = flat[i];
            }
            validate(_left);
            validate(_right); // Q(prob) = (1-f)*A[floor(index)] + f*A[floor(index)+1]
            return add(multiply(_left, 1 - _fracPart), multiply(_right, _fracPart));
        } // If prob is a BigNumber
        var index = prob.times(len - 1);
        if (index.isInteger()) {
            index = index.toNumber();
            var _value = sorted ? flat[index] : partitionSelect(flat, index);
            validate(_value);
            return _value;
        }
        var integerPart = index.floor();
        var fracPart = index.minus(integerPart);
        var integerPartNumber = integerPart.toNumber();
        var left;
        var right;
        if (sorted) {
            left = flat[integerPartNumber];
            right = flat[integerPartNumber + 1];
        } else {
            right = partitionSelect(flat, integerPartNumber + 1); // max of partition is kth largest
            left = flat[integerPartNumber];
            for(var _i3 = 0; _i3 < integerPartNumber; ++_i3)if (compare(flat[_i3], left) > 0) left = flat[_i3];
        }
        validate(left);
        validate(right); // Q(prob) = (1-f)*A[floor(index)] + f*A[floor(index)+1]
        var one = new fracPart.constructor(1);
        return add(multiply(left, one.minus(fracPart)), multiply(right, fracPart));
    }
    /**
   * Check if array value types are valid, throw error otherwise.
   * @param {number | BigNumber | Unit} x
   * @param {number | BigNumber | Unit} x
   * @private
   */ var validate = typed({
        "number | BigNumber | Unit": function numberBigNumberUnit(x) {
            return x;
        }
    });
    return quantileSeq;
});




var $9f5952ec29ad9446$var$name = "row";
var $9f5952ec29ad9446$var$dependencies = [
    "typed",
    "Index",
    "matrix",
    "range"
];
var $9f5952ec29ad9446$export$3442c5d213434705 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($9f5952ec29ad9446$var$name, $9f5952ec29ad9446$var$dependencies, (_ref)=>{
    var { typed: typed, Index: Index, matrix: matrix, range: range } = _ref;
    /**
   * Return a row from a Matrix.
   *
   * Syntax:
   *
   *     math.row(value, index)
   *
   * Example:
   *
   *     // get a row
   *     const d = [[1, 2], [3, 4]]
   *     math.row(d, 1) // returns [[3, 4]]
   *
   * See also:
   *
   *     column
   *
   * @param {Array | Matrix } value   An array or matrix
   * @param {number} row              The index of the row
   * @return {Array | Matrix}         The retrieved row
   */ return typed($9f5952ec29ad9446$var$name, {
        "Matrix, number": _row,
        "Array, number": function ArrayNumber(value, row) {
            return _row(matrix((0, $6819694788cbfa38$export$9cd59f9826255e47)(value)), row).valueOf();
        }
    });
    /**
   * Retrieve a row of a matrix
   * @param {Matrix } value  A matrix
   * @param {number} row     The index of the row
   * @return {Matrix}        The retrieved row
   */ function _row(value, row) {
        // check dimensions
        if (value.size().length !== 2) throw new Error("Only two dimensional matrix is supported");
        (0, $a14a10567870d913$export$3cfe3fbfec03f260)(row, value.size()[0]);
        var columnRange = range(0, value.size()[1]);
        var index = new Index(row, columnRange);
        return value.subset(index);
    }
});



var $fbaa05cffb8cba99$var$name = "setCartesian";
var $fbaa05cffb8cba99$var$dependencies = [
    "typed",
    "size",
    "subset",
    "compareNatural",
    "Index",
    "DenseMatrix"
];
var $fbaa05cffb8cba99$export$9fa12a9d198718c8 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($fbaa05cffb8cba99$var$name, $fbaa05cffb8cba99$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, subset: subset, compareNatural: compareNatural, Index: Index, DenseMatrix: DenseMatrix } = _ref;
    /**
   * Create the cartesian product of two (multi)sets.
   * Multi-dimension arrays will be converted to single-dimension arrays
   * and the values will be sorted in ascending order before the operation.
   *
   * Syntax:
   *
   *    math.setCartesian(set1, set2)
   *
   * Examples:
   *
   *    math.setCartesian([1, 2], [3, 4])        // returns [[1, 3], [1, 4], [2, 3], [2, 4]]
   *    math.setCartesian([4, 3], [2, 1])        // returns [[3, 1], [3, 2], [4, 1], [4, 2]]
   *
   * See also:
   *
   *    setUnion, setIntersect, setDifference, setPowerset
   *
   * @param {Array | Matrix}    a1  A (multi)set
   * @param {Array | Matrix}    a2  A (multi)set
   * @return {Array | Matrix}    The cartesian product of two (multi)sets
   */ return typed($fbaa05cffb8cba99$var$name, {
        "Array | Matrix, Array | Matrix": function ArrayMatrixArrayMatrix(a1, a2) {
            var result = [];
            if (subset(size(a1), new Index(0)) !== 0 && subset(size(a2), new Index(0)) !== 0) {
                // if any of them is empty, return empty
                var b1 = (0, $a14a10567870d913$export$bffa455ba8c619a6)(Array.isArray(a1) ? a1 : a1.toArray()).sort(compareNatural);
                var b2 = (0, $a14a10567870d913$export$bffa455ba8c619a6)(Array.isArray(a2) ? a2 : a2.toArray()).sort(compareNatural);
                result = [];
                for(var i = 0; i < b1.length; i++)for(var j = 0; j < b2.length; j++)result.push([
                    b1[i],
                    b2[j]
                ]);
            } // return an array, if both inputs were arrays
            if (Array.isArray(a1) && Array.isArray(a2)) return result;
             // return a matrix otherwise
            return new DenseMatrix(result);
        }
    });
});



var $0dc24e9a07b9f5ba$var$name = "setDistinct";
var $0dc24e9a07b9f5ba$var$dependencies = [
    "typed",
    "size",
    "subset",
    "compareNatural",
    "Index",
    "DenseMatrix"
];
var $0dc24e9a07b9f5ba$export$c149680b9d8f2963 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($0dc24e9a07b9f5ba$var$name, $0dc24e9a07b9f5ba$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, subset: subset, compareNatural: compareNatural, Index: Index, DenseMatrix: DenseMatrix } = _ref;
    /**
   * Collect the distinct elements of a multiset.
   * A multi-dimension array will be converted to a single-dimension array before the operation.
   *
   * Syntax:
   *
   *    math.setDistinct(set)
   *
   * Examples:
   *
   *    math.setDistinct([1, 1, 1, 2, 2, 3])        // returns [1, 2, 3]
   *
   * See also:
   *
   *    setMultiplicity
   *
   * @param {Array | Matrix}    a  A multiset
   * @return {Array | Matrix}    A set containing the distinc elements of the multiset
   */ return typed($0dc24e9a07b9f5ba$var$name, {
        "Array | Matrix": function ArrayMatrix(a) {
            var result;
            if (subset(size(a), new Index(0)) === 0) // if empty, return empty
            result = [];
            else {
                var b = (0, $a14a10567870d913$export$bffa455ba8c619a6)(Array.isArray(a) ? a : a.toArray()).sort(compareNatural);
                result = [];
                result.push(b[0]);
                for(var i = 1; i < b.length; i++)if (compareNatural(b[i], b[i - 1]) !== 0) result.push(b[i]);
            } // return an array, if the input was an array
            if (Array.isArray(a)) return result;
             // return a matrix otherwise
            return new DenseMatrix(result);
        }
    });
});



var $fada4357731287d7$var$name = "setIsSubset";
var $fada4357731287d7$var$dependencies = [
    "typed",
    "size",
    "subset",
    "compareNatural",
    "Index"
];
var $fada4357731287d7$export$40ad73493b9f8712 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($fada4357731287d7$var$name, $fada4357731287d7$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, subset: subset, compareNatural: compareNatural, Index: Index } = _ref;
    /**
   * Check whether a (multi)set is a subset of another (multi)set. (Every element of set1 is the element of set2.)
   * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
   *
   * Syntax:
   *
   *    math.setIsSubset(set1, set2)
   *
   * Examples:
   *
   *    math.setIsSubset([1, 2], [3, 4, 5, 6])        // returns false
   *    math.setIsSubset([3, 4], [3, 4, 5, 6])        // returns true
   *
   * See also:
   *
   *    setUnion, setIntersect, setDifference
   *
   * @param {Array | Matrix}    a1  A (multi)set
   * @param {Array | Matrix}    a2  A (multi)set
   * @return {boolean}            true | false
   */ return typed($fada4357731287d7$var$name, {
        "Array | Matrix, Array | Matrix": function ArrayMatrixArrayMatrix(a1, a2) {
            if (subset(size(a1), new Index(0)) === 0) // empty is a subset of anything
            return true;
            else if (subset(size(a2), new Index(0)) === 0) // anything is not a subset of empty
            return false;
            var b1 = (0, $a14a10567870d913$export$65e5b62a4c490288)((0, $a14a10567870d913$export$bffa455ba8c619a6)(Array.isArray(a1) ? a1 : a1.toArray()).sort(compareNatural));
            var b2 = (0, $a14a10567870d913$export$65e5b62a4c490288)((0, $a14a10567870d913$export$bffa455ba8c619a6)(Array.isArray(a2) ? a2 : a2.toArray()).sort(compareNatural));
            var inb2;
            for(var i = 0; i < b1.length; i++){
                inb2 = false;
                for(var j = 0; j < b2.length; j++)if (compareNatural(b1[i].value, b2[j].value) === 0 && b1[i].identifier === b2[j].identifier) {
                    // the identifier is always a decimal int
                    inb2 = true;
                    break;
                }
                if (inb2 === false) return false;
            }
            return true;
        }
    });
});



var $ad311d25c88378e9$var$name = "setPowerset";
var $ad311d25c88378e9$var$dependencies = [
    "typed",
    "size",
    "subset",
    "compareNatural",
    "Index"
];
var $ad311d25c88378e9$export$55c6b5cb0b0637db = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($ad311d25c88378e9$var$name, $ad311d25c88378e9$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, subset: subset, compareNatural: compareNatural, Index: Index } = _ref;
    /**
   * Create the powerset of a (multi)set. (The powerset contains very possible subsets of a (multi)set.)
   * A multi-dimension array will be converted to a single-dimension array before the operation.
   *
   * Syntax:
   *
   *    math.setPowerset(set)
   *
   * Examples:
   *
   *    math.setPowerset([1, 2, 3])        // returns [[], [1], [2], [3], [1, 2], [1, 3], [2, 3], [1, 2, 3]]
   *
   * See also:
   *
   *    setCartesian
   *
   * @param {Array | Matrix}    a  A (multi)set
   * @return {Array}    The powerset of the (multi)set
   */ return typed($ad311d25c88378e9$var$name, {
        "Array | Matrix": function ArrayMatrix(a) {
            if (subset(size(a), new Index(0)) === 0) // if empty, return empty
            return [];
            var b = (0, $a14a10567870d913$export$bffa455ba8c619a6)(Array.isArray(a) ? a : a.toArray()).sort(compareNatural);
            var result = [];
            var number = 0;
            while(number.toString(2).length <= b.length){
                result.push(_subset(b, number.toString(2).split("").reverse()));
                number++;
            } // can not return a matrix, because of the different size of the subarrays
            return _sort(result);
        }
    }); // create subset
    function _subset(array, bitarray) {
        var result = [];
        for(var i = 0; i < bitarray.length; i++)if (bitarray[i] === "1") result.push(array[i]);
        return result;
    } // sort subsests by length
    function _sort(array) {
        var temp = [];
        for(var i = array.length - 1; i > 0; i--){
            for(var j = 0; j < i; j++)if (array[j].length > array[j + 1].length) {
                temp = array[j];
                array[j] = array[j + 1];
                array[j + 1] = temp;
            }
        }
        return array;
    }
});



var $c188ce4a68cd8883$var$name = "sort";
var $c188ce4a68cd8883$var$dependencies = [
    "typed",
    "matrix",
    "compare",
    "compareNatural"
];
var $c188ce4a68cd8883$export$10463693a2093403 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($c188ce4a68cd8883$var$name, $c188ce4a68cd8883$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, compare: compare, compareNatural: compareNatural } = _ref;
    var compareAsc = compare;
    var compareDesc = (a, b)=>-compare(a, b);
    /**
   * Sort the items in a matrix.
   *
   * Syntax:
   *
   *    math.sort(x)
   *    math.sort(x, compare)
   *
   * Examples:
   *
   *    math.sort([5, 10, 1]) // returns [1, 5, 10]
   *    math.sort(['C', 'B', 'A', 'D'], math.compareNatural)
   *    // returns ['A', 'B', 'C', 'D']
   *
   *    function sortByLength (a, b) {
   *      return a.length - b.length
   *    }
   *    math.sort(['Langdon', 'Tom', 'Sara'], sortByLength)
   *    // returns ['Tom', 'Sara', 'Langdon']
   *
   * See also:
   *
   *    filter, forEach, map, compare, compareNatural
   *
   * @param {Matrix | Array} x    A one dimensional matrix or array to sort
   * @param {Function | 'asc' | 'desc' | 'natural'} [compare='asc']
   *        An optional _comparator function or name. The function is called as
   *        `compare(a, b)`, and must return 1 when a > b, -1 when a < b,
   *        and 0 when a == b.
   * @return {Matrix | Array} Returns the sorted matrix.
   */ return typed($c188ce4a68cd8883$var$name, {
        Array: function Array(x) {
            _arrayIsVector(x);
            return x.sort(compareAsc);
        },
        Matrix: function Matrix(x) {
            _matrixIsVector(x);
            return matrix(x.toArray().sort(compareAsc), x.storage());
        },
        "Array, function": function ArrayFunction(x, _comparator) {
            _arrayIsVector(x);
            return x.sort(_comparator);
        },
        "Matrix, function": function MatrixFunction(x, _comparator) {
            _matrixIsVector(x);
            return matrix(x.toArray().sort(_comparator), x.storage());
        },
        "Array, string": function ArrayString(x, order) {
            _arrayIsVector(x);
            return x.sort(_comparator(order));
        },
        "Matrix, string": function MatrixString(x, order) {
            _matrixIsVector(x);
            return matrix(x.toArray().sort(_comparator(order)), x.storage());
        }
    });
    /**
   * Get the comparator for given order ('asc', 'desc', 'natural')
   * @param {'asc' | 'desc' | 'natural'} order
   * @return {Function} Returns a _comparator function
   */ function _comparator(order) {
        if (order === "asc") return compareAsc;
        else if (order === "desc") return compareDesc;
        else if (order === "natural") return compareNatural;
        else throw new Error('String "asc", "desc", or "natural" expected');
    }
    /**
   * Validate whether an array is one dimensional
   * Throws an error when this is not the case
   * @param {Array} array
   * @private
   */ function _arrayIsVector(array) {
        if ((0, $a14a10567870d913$export$51ffaee4afb683a5)(array).length !== 1) throw new Error("One dimensional array expected");
    }
    /**
   * Validate whether a matrix is one dimensional
   * Throws an error when this is not the case
   * @param {Matrix} matrix
   * @private
   */ function _matrixIsVector(matrix) {
        if (matrix.size().length !== 1) throw new Error("One dimensional matrix expected");
    }
});




var $cfa633333096bba9$var$name = "column";
var $cfa633333096bba9$var$dependencies = [
    "typed",
    "Index",
    "matrix",
    "range"
];
var $cfa633333096bba9$export$1bfa986e9c92c0b5 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($cfa633333096bba9$var$name, $cfa633333096bba9$var$dependencies, (_ref)=>{
    var { typed: typed, Index: Index, matrix: matrix, range: range } = _ref;
    /**
   * Return a column from a Matrix.
   *
   * Syntax:
   *
   *     math.column(value, index)
   *
   * Example:
   *
   *     // get a column
   *     const d = [[1, 2], [3, 4]]
   *     math.column(d, 1) // returns [[2], [4]]
   *
   * See also:
   *
   *     row
   *
   * @param {Array | Matrix } value   An array or matrix
   * @param {number} column           The index of the column
   * @return {Array | Matrix}         The retrieved column
   */ return typed($cfa633333096bba9$var$name, {
        "Matrix, number": _column,
        "Array, number": function ArrayNumber(value, column) {
            return _column(matrix((0, $6819694788cbfa38$export$9cd59f9826255e47)(value)), column).valueOf();
        }
    });
    /**
   * Retrieve a column of a matrix
   * @param {Matrix } value  A matrix
   * @param {number} column  The index of the column
   * @return {Matrix}        The retrieved column
   */ function _column(value, column) {
        // check dimensions
        if (value.size().length !== 2) throw new Error("Only two dimensional matrix is supported");
        (0, $a14a10567870d913$export$3cfe3fbfec03f260)(column, value.size()[1]);
        var rowRange = range(0, value.size()[0]);
        var index = new Index(rowRange, column);
        return value.subset(index);
    }
});



var $d311d25c4bf6dff2$var$name = "index";
var $d311d25c4bf6dff2$var$dependencies = [
    "typed",
    "Index"
];
var $d311d25c4bf6dff2$export$c6d108d7c8095f19 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($d311d25c4bf6dff2$var$name, $d311d25c4bf6dff2$var$dependencies, (_ref)=>{
    var { typed: typed, Index: Index } = _ref;
    /**
   * Create an index. An Index can store ranges having start, step, and end
   * for multiple dimensions.
   * Matrix.get, Matrix.set, and math.subset accept an Index as input.
   *
   * Syntax:
   *
   *     math.index(range1, range2, ...)
   *
   * Where each range can be any of:
   *
   * - A number
   * - A string for getting/setting an object property
   * - An instance of `Range`
   * - A one-dimensional Array or a Matrix with numbers
   *
   * Indexes must be zero-based, integer numbers.
   *
   * Examples:
   *
   *    const b = [1, 2, 3, 4, 5]
   *    math.subset(b, math.index([1, 2, 3]))     // returns [2, 3, 4]
   *
   *    const a = math.matrix([[1, 2], [3, 4]])
   *    a.subset(math.index(0, 1))             // returns 2
   *
   * See also:
   *
   *    bignumber, boolean, complex, matrix, number, string, unit
   *
   * @param {...*} ranges   Zero or more ranges or numbers.
   * @return {Index}        Returns the created index
   */ return typed($d311d25c4bf6dff2$var$name, {
        "...number | string | BigNumber | Range | Array | Matrix": function numberStringBigNumberRangeArrayMatrix(args) {
            var ranges = args.map(function(arg) {
                if ((0, $d8097b7a6d6e36d8$export$e51d0e7e5c4a03ab)(arg)) return arg.toNumber(); // convert BigNumber to Number
                else if (Array.isArray(arg) || (0, $d8097b7a6d6e36d8$export$b22160e0a14f87b7)(arg)) return arg.map(function(elem) {
                    // convert BigNumber to Number
                    return (0, $d8097b7a6d6e36d8$export$e51d0e7e5c4a03ab)(elem) ? elem.toNumber() : elem;
                });
                else return arg;
            });
            var res = new Index();
            Index.apply(res, ranges);
            return res;
        }
    });
});





var $dd56c50501f95659$var$name = "inv";
var $dd56c50501f95659$var$dependencies = [
    "typed",
    "matrix",
    "divideScalar",
    "addScalar",
    "multiply",
    "unaryMinus",
    "det",
    "identity",
    "abs"
];
var $dd56c50501f95659$export$ad9771ef9eafe06a = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($dd56c50501f95659$var$name, $dd56c50501f95659$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, divideScalar: divideScalar, addScalar: addScalar, multiply: multiply, unaryMinus: unaryMinus, det: det, identity: identity, abs: abs } = _ref;
    /**
   * Calculate the inverse of a square matrix.
   *
   * Syntax:
   *
   *     math.inv(x)
   *
   * Examples:
   *
   *     math.inv([[1, 2], [3, 4]])  // returns [[-2, 1], [1.5, -0.5]]
   *     math.inv(4)                 // returns 0.25
   *     1 / 4                       // returns 0.25
   *
   * See also:
   *
   *     det, transpose
   *
   * @param {number | Complex | Array | Matrix} x     Matrix to be inversed
   * @return {number | Complex | Array | Matrix} The inverse of `x`.
   */ return typed($dd56c50501f95659$var$name, {
        "Array | Matrix": function ArrayMatrix(x) {
            var size = (0, $d8097b7a6d6e36d8$export$b22160e0a14f87b7)(x) ? x.size() : (0, $a14a10567870d913$export$51ffaee4afb683a5)(x);
            switch(size.length){
                case 1:
                    // vector
                    if (size[0] === 1) {
                        if ((0, $d8097b7a6d6e36d8$export$b22160e0a14f87b7)(x)) return matrix([
                            divideScalar(1, x.valueOf()[0])
                        ]);
                        else return [
                            divideScalar(1, x[0])
                        ];
                    } else throw new RangeError("Matrix must be square (size: " + (0, $b94963e97c376b6d$export$d9468344d3651243)(size) + ")");
                case 2:
                    var rows = size[0];
                    var cols = size[1];
                    if (rows === cols) {
                        if ((0, $d8097b7a6d6e36d8$export$b22160e0a14f87b7)(x)) return matrix(_inv(x.valueOf(), rows, cols), x.storage());
                        else // return an Array
                        return _inv(x, rows, cols);
                    } else throw new RangeError("Matrix must be square (size: " + (0, $b94963e97c376b6d$export$d9468344d3651243)(size) + ")");
                default:
                    // multi dimensional array
                    throw new RangeError("Matrix must be two dimensional (size: " + (0, $b94963e97c376b6d$export$d9468344d3651243)(size) + ")");
            }
        },
        any: function any(x) {
            // scalar
            return divideScalar(1, x); // FIXME: create a BigNumber one when configured for bignumbers
        }
    });
    /**
   * Calculate the inverse of a square matrix
   * @param {Array[]} mat     A square matrix
   * @param {number} rows     Number of rows
   * @param {number} cols     Number of columns, must equal rows
   * @return {Array[]} inv    Inverse matrix
   * @private
   */ function _inv(mat, rows, cols) {
        var r, s, f, value, temp;
        if (rows === 1) {
            // this is a 1 x 1 matrix
            value = mat[0][0];
            if (value === 0) throw Error("Cannot calculate inverse, determinant is zero");
            return [
                [
                    divideScalar(1, value)
                ]
            ];
        } else if (rows === 2) {
            // this is a 2 x 2 matrix
            var d = det(mat);
            if (d === 0) throw Error("Cannot calculate inverse, determinant is zero");
            return [
                [
                    divideScalar(mat[1][1], d),
                    divideScalar(unaryMinus(mat[0][1]), d)
                ],
                [
                    divideScalar(unaryMinus(mat[1][0]), d),
                    divideScalar(mat[0][0], d)
                ]
            ];
        } else {
            // this is a matrix of 3 x 3 or larger
            // calculate inverse using gauss-jordan elimination
            //      https://en.wikipedia.org/wiki/Gaussian_elimination
            //      http://mathworld.wolfram.com/MatrixInverse.html
            //      http://math.uww.edu/~mcfarlat/inverse.htm
            // make a copy of the matrix (only the arrays, not of the elements)
            var A = mat.concat();
            for(r = 0; r < rows; r++)A[r] = A[r].concat();
             // create an identity matrix which in the end will contain the
            // matrix inverse
            var B = identity(rows).valueOf(); // loop over all columns, and perform row reductions
            for(var c = 0; c < cols; c++){
                // Pivoting: Swap row c with row r, where row r contains the largest element A[r][c]
                var ABig = abs(A[c][c]);
                var rBig = c;
                r = c + 1;
                while(r < rows){
                    if (abs(A[r][c]) > ABig) {
                        ABig = abs(A[r][c]);
                        rBig = r;
                    }
                    r++;
                }
                if (ABig === 0) throw Error("Cannot calculate inverse, determinant is zero");
                r = rBig;
                if (r !== c) {
                    temp = A[c];
                    A[c] = A[r];
                    A[r] = temp;
                    temp = B[c];
                    B[c] = B[r];
                    B[r] = temp;
                } // eliminate non-zero values on the other rows at column c
                var Ac = A[c];
                var Bc = B[c];
                for(r = 0; r < rows; r++){
                    var Ar = A[r];
                    var Br = B[r];
                    if (r !== c) // eliminate value at column c and row r
                    {
                        if (Ar[c] !== 0) {
                            f = divideScalar(unaryMinus(Ar[c]), Ac[c]); // add (f * row c) to row r to eliminate the value
                            // at column c
                            for(s = c; s < cols; s++)Ar[s] = addScalar(Ar[s], multiply(f, Ac[s]));
                            for(s = 0; s < cols; s++)Br[s] = addScalar(Br[s], multiply(f, Bc[s]));
                        }
                    } else {
                        // normalize value at Acc to 1,
                        // divide each value on row r with the value at Acc
                        f = Ac[c];
                        for(s = c; s < cols; s++)Ar[s] = divideScalar(Ar[s], f);
                        for(s = 0; s < cols; s++)Br[s] = divideScalar(Br[s], f);
                    }
                }
            }
            return B;
        }
    }
});






var $0562ba836acfa9d6$var$name = "pinv";
var $0562ba836acfa9d6$var$dependencies = [
    "typed",
    "matrix",
    "inv",
    "deepEqual",
    "equal",
    "dotDivide",
    "dot",
    "ctranspose",
    "divideScalar",
    "multiply",
    "add",
    "Complex"
];
var $0562ba836acfa9d6$export$1456c5eaeee6aa07 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($0562ba836acfa9d6$var$name, $0562ba836acfa9d6$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, inv: inv, deepEqual: deepEqual, equal: equal, dotDivide: dotDivide, dot: dot, ctranspose: ctranspose, divideScalar: divideScalar, multiply: multiply, add: add, Complex: Complex } = _ref;
    /**
   * Calculate the Moore–Penrose inverse of a matrix.
   *
   * Syntax:
   *
   *     math.pinv(x)
   *
   * Examples:
   *
   *     math.pinv([[1, 2], [3, 4]])          // returns [[-2, 1], [1.5, -0.5]]
   *     math.pinv([[1, 0], [0, 1], [0, 1]])  // returns [[1, 0, 0], [0, 0.5, 0.5]]
   *     math.pinv(4)                         // returns 0.25
   *
   * See also:
   *
   *     inv
   *
   * @param {number | Complex | Array | Matrix} x     Matrix to be inversed
   * @return {number | Complex | Array | Matrix} The inverse of `x`.
   */ return typed($0562ba836acfa9d6$var$name, {
        "Array | Matrix": function ArrayMatrix(x) {
            var size = (0, $d8097b7a6d6e36d8$export$b22160e0a14f87b7)(x) ? x.size() : (0, $a14a10567870d913$export$51ffaee4afb683a5)(x);
            switch(size.length){
                case 1:
                    // vector
                    if (_isZeros(x)) return ctranspose(x); // null vector
                    if (size[0] === 1) return inv(x); // invertible matrix
                    else return dotDivide(ctranspose(x), dot(x, x));
                case 2:
                    if (_isZeros(x)) return ctranspose(x); // zero matrixx
                    var rows = size[0];
                    var cols = size[1];
                    if (rows === cols) try {
                        return inv(x); // invertible matrix
                    } catch (err) {
                        if (err instanceof Error && err.message.match(/Cannot calculate inverse, determinant is zero/)) ;
                        else throw err;
                    }
                    if ((0, $d8097b7a6d6e36d8$export$b22160e0a14f87b7)(x)) return matrix(_pinv(x.valueOf(), rows, cols), x.storage());
                    else // return an Array
                    return _pinv(x, rows, cols);
                default:
                    // multi dimensional array
                    throw new RangeError("Matrix must be two dimensional (size: " + (0, $b94963e97c376b6d$export$d9468344d3651243)(size) + ")");
            }
        },
        any: function any(x) {
            // scalar
            if (equal(x, 0)) return (0, $6819694788cbfa38$export$9cd59f9826255e47)(x); // zero
            return divideScalar(1, x);
        }
    });
    /**
   * Calculate the Moore–Penrose inverse of a matrix
   * @param {Array[]} mat     A matrix
   * @param {number} rows     Number of rows
   * @param {number} cols     Number of columns
   * @return {Array[]} pinv    Pseudoinverse matrix
   * @private
   */ function _pinv(mat, rows, cols) {
        var { C: C, F: F } = _rankFact(mat, rows, cols); // TODO: Use SVD instead (may improve precision)
        var Cpinv = multiply(inv(multiply(ctranspose(C), C)), ctranspose(C));
        var Fpinv = multiply(ctranspose(F), inv(multiply(F, ctranspose(F))));
        return multiply(Fpinv, Cpinv);
    }
    /**
   * Calculate the reduced row echelon form of a matrix
   *
   * Modified from https://rosettacode.org/wiki/Reduced_row_echelon_form
   *
   * @param {Array[]} mat     A matrix
   * @param {number} rows     Number of rows
   * @param {number} cols     Number of columns
   * @return {Array[]}        Reduced row echelon form
   * @private
   */ function _rref(mat, rows, cols) {
        var M = (0, $6819694788cbfa38$export$9cd59f9826255e47)(mat);
        var lead = 0;
        for(var r = 0; r < rows; r++){
            if (cols <= lead) return M;
            var i = r;
            while(_isZero(M[i][lead])){
                i++;
                if (rows === i) {
                    i = r;
                    lead++;
                    if (cols === lead) return M;
                }
            }
            [M[i], M[r]] = [
                M[r],
                M[i]
            ];
            var val = M[r][lead];
            for(var j = 0; j < cols; j++)M[r][j] = dotDivide(M[r][j], val);
            for(var _i = 0; _i < rows; _i++){
                if (_i === r) continue;
                val = M[_i][lead];
                for(var _j = 0; _j < cols; _j++)M[_i][_j] = add(M[_i][_j], multiply(-1, multiply(val, M[r][_j])));
            }
            lead++;
        }
        return M;
    }
    /**
   * Calculate the rank factorization of a matrix
   *
   * @param {Array[]} mat                  A matrix (M)
   * @param {number} rows                  Number of rows
   * @param {number} cols                  Number of columns
   * @return {{C: Array, F: Array}}        rank factorization where M = C F
   * @private
   */ function _rankFact(mat, rows, cols) {
        var rref = _rref(mat, rows, cols);
        var C = mat.map((_, i)=>_.filter((_, j)=>j < rows && !_isZero(dot(rref[j], rref[j]))));
        var F = rref.filter((_, i)=>!_isZero(dot(rref[i], rref[i])));
        return {
            C: C,
            F: F
        };
    }
    function _isZero(x) {
        return equal(add(x, Complex(1, 1)), add(0, Complex(1, 1)));
    }
    function _isZeros(arr) {
        return deepEqual(add(arr, Complex(1, 1)), add(multiply(arr, 0), Complex(1, 1)));
    }
});





var $db869f8892627191$var$name = "pow";
var $db869f8892627191$var$dependencies = [
    "typed",
    "config",
    "identity",
    "multiply",
    "matrix",
    "inv",
    "fraction",
    "number",
    "Complex"
];
var $db869f8892627191$export$9c94d2d08a8d8146 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($db869f8892627191$var$name, $db869f8892627191$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, identity: identity, multiply: multiply, matrix: matrix, inv: inv, number: number, fraction: fraction, Complex: Complex } = _ref;
    /**
   * Calculates the power of x to y, `x ^ y`.
   *
   * Matrix exponentiation is supported for square matrices `x` and integers `y`:
   * when `y` is nonnegative, `x` may be any square matrix; and when `y` is
   * negative, `x` must be invertible, and then this function returns
   * inv(x)^(-y).
   *
   * For cubic roots of negative numbers, the function returns the principal
   * root by default. In order to let the function return the real root,
   * math.js can be configured with `math.config({predictable: true})`.
   * To retrieve all cubic roots of a value, use `math.cbrt(x, true)`.
   *
   * Syntax:
   *
   *    math.pow(x, y)
   *
   * Examples:
   *
   *    math.pow(2, 3)               // returns number 8
   *
   *    const a = math.complex(2, 3)
   *    math.pow(a, 2)                // returns Complex -5 + 12i
   *
   *    const b = [[1, 2], [4, 3]]
   *    math.pow(b, 2)               // returns Array [[9, 8], [16, 17]]
   *
   *    const c = [[1, 2], [4, 3]]
   *    math.pow(c, -1)               // returns Array [[-0.6, 0.4], [0.8, -0.2]]
   *
   * See also:
   *
   *    multiply, sqrt, cbrt, nthRoot
   *
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} x  The base
   * @param  {number | BigNumber | Complex} y                          The exponent
   * @return {number | BigNumber | Complex | Array | Matrix} The value of `x` to the power `y`
   */ return typed($db869f8892627191$var$name, {
        "number, number": _pow,
        "Complex, Complex": function ComplexComplex(x, y) {
            return x.pow(y);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(x, y) {
            if (y.isInteger() || x >= 0 || config.predictable) return x.pow(y);
            else return new Complex(x.toNumber(), 0).pow(y.toNumber(), 0);
        },
        "Fraction, Fraction": function FractionFraction(x, y) {
            var result = x.pow(y);
            if (result != null) return result;
            if (config.predictable) throw new Error("Result of pow is non-rational and cannot be expressed as a fraction");
            else return _pow(x.valueOf(), y.valueOf());
        },
        "Array, number": _powArray,
        "Array, BigNumber": function ArrayBigNumber(x, y) {
            return _powArray(x, y.toNumber());
        },
        "Matrix, number": _powMatrix,
        "Matrix, BigNumber": function MatrixBigNumber(x, y) {
            return _powMatrix(x, y.toNumber());
        },
        "Unit, number | BigNumber": function UnitNumberBigNumber(x, y) {
            return x.pow(y);
        }
    });
    /**
   * Calculates the power of x to y, x^y, for two numbers.
   * @param {number} x
   * @param {number} y
   * @return {number | Complex} res
   * @private
   */ function _pow(x, y) {
        // Alternatively could define a 'realmode' config option or something, but
        // 'predictable' will work for now
        if (config.predictable && !(0, $668e051498bf5fa0$export$a287f47fed4544b8)(y) && x < 0) // Check to see if y can be represented as a fraction
        try {
            var yFrac = fraction(y);
            var yNum = number(yFrac);
            if (y === yNum || Math.abs((y - yNum) / y) < 1e-14) {
                if (yFrac.d % 2 === 1) return (yFrac.n % 2 === 0 ? 1 : -1) * Math.pow(-x, y);
            }
        } catch (ex) {} // Unable to express y as a fraction, so continue on
         // **for predictable mode** x^Infinity === NaN if x < -1
        // N.B. this behavour is different from `Math.pow` which gives
        // (-2)^Infinity === Infinity
        if (config.predictable && (x < -1 && y === Infinity || x > -1 && x < 0 && y === -Infinity)) return NaN;
        if ((0, $668e051498bf5fa0$export$a287f47fed4544b8)(y) || x >= 0 || config.predictable) return (0, $4b37ed316f05dd33$export$3f512e7fd4999e01)(x, y);
        else {
            // TODO: the following infinity checks are duplicated from powNumber. Deduplicate this somehow
            // x^Infinity === 0 if -1 < x < 1
            // A real number 0 is returned instead of complex(0)
            if (x * x < 1 && y === Infinity || x * x > 1 && y === -Infinity) return 0;
            return new Complex(x, 0).pow(y, 0);
        }
    }
    /**
   * Calculate the power of a 2d array
   * @param {Array} x     must be a 2 dimensional, square matrix
   * @param {number} y    a integer value (positive if `x` is not invertible)
   * @returns {Array}
   * @private
   */ function _powArray(x, y) {
        if (!(0, $668e051498bf5fa0$export$a287f47fed4544b8)(y)) throw new TypeError("For A^b, b must be an integer (value is " + y + ")");
         // verify that A is a 2 dimensional square matrix
        var s = (0, $a14a10567870d913$export$51ffaee4afb683a5)(x);
        if (s.length !== 2) throw new Error("For A^b, A must be 2 dimensional (A has " + s.length + " dimensions)");
        if (s[0] !== s[1]) throw new Error("For A^b, A must be square (size is " + s[0] + "x" + s[1] + ")");
        if (y < 0) try {
            return _powArray(inv(x), -y);
        } catch (error) {
            if (error.message === "Cannot calculate inverse, determinant is zero") throw new TypeError("For A^b, when A is not invertible, b must be a positive integer (value is " + y + ")");
            throw error;
        }
        var res = identity(s[0]).valueOf();
        var px = x;
        while(y >= 1){
            if ((y & 1) === 1) res = multiply(px, res);
            y >>= 1;
            px = multiply(px, px);
        }
        return res;
    }
    /**
   * Calculate the power of a 2d matrix
   * @param {Matrix} x     must be a 2 dimensional, square matrix
   * @param {number} y    a positive, integer value
   * @returns {Matrix}
   * @private
   */ function _powMatrix(x, y) {
        return matrix(_powArray(x.valueOf(), y));
    }
});



var $b917d1decdc25499$var$name = "setDifference";
var $b917d1decdc25499$var$dependencies = [
    "typed",
    "size",
    "subset",
    "compareNatural",
    "Index",
    "DenseMatrix"
];
var $b917d1decdc25499$export$d81c0f9dab86d854 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($b917d1decdc25499$var$name, $b917d1decdc25499$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, subset: subset, compareNatural: compareNatural, Index: Index, DenseMatrix: DenseMatrix } = _ref;
    /**
   * Create the difference of two (multi)sets: every element of set1, that is not the element of set2.
   * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
   *
   * Syntax:
   *
   *    math.setDifference(set1, set2)
   *
   * Examples:
   *
   *    math.setDifference([1, 2, 3, 4], [3, 4, 5, 6])            // returns [1, 2]
   *    math.setDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])    // returns [1, 2]
   *
   * See also:
   *
   *    setUnion, setIntersect, setSymDifference
   *
   * @param {Array | Matrix}    a1  A (multi)set
   * @param {Array | Matrix}    a2  A (multi)set
   * @return {Array | Matrix}    The difference of two (multi)sets
   */ return typed($b917d1decdc25499$var$name, {
        "Array | Matrix, Array | Matrix": function ArrayMatrixArrayMatrix(a1, a2) {
            var result;
            if (subset(size(a1), new Index(0)) === 0) // empty-anything=empty
            result = [];
            else if (subset(size(a2), new Index(0)) === 0) // anything-empty=anything
            return (0, $a14a10567870d913$export$bffa455ba8c619a6)(a1.toArray());
            else {
                var b1 = (0, $a14a10567870d913$export$65e5b62a4c490288)((0, $a14a10567870d913$export$bffa455ba8c619a6)(Array.isArray(a1) ? a1 : a1.toArray()).sort(compareNatural));
                var b2 = (0, $a14a10567870d913$export$65e5b62a4c490288)((0, $a14a10567870d913$export$bffa455ba8c619a6)(Array.isArray(a2) ? a2 : a2.toArray()).sort(compareNatural));
                result = [];
                var inb2;
                for(var i = 0; i < b1.length; i++){
                    inb2 = false;
                    for(var j = 0; j < b2.length; j++)if (compareNatural(b1[i].value, b2[j].value) === 0 && b1[i].identifier === b2[j].identifier) {
                        // the identifier is always a decimal int
                        inb2 = true;
                        break;
                    }
                    if (!inb2) result.push(b1[i]);
                }
            } // return an array, if both inputs were arrays
            if (Array.isArray(a1) && Array.isArray(a2)) return (0, $a14a10567870d913$export$d57ad8b840ad6a01)(result);
             // return a matrix otherwise
            return new DenseMatrix((0, $a14a10567870d913$export$d57ad8b840ad6a01)(result));
        }
    });
});



var $633716d7a5d3b648$var$name = "setMultiplicity";
var $633716d7a5d3b648$var$dependencies = [
    "typed",
    "size",
    "subset",
    "compareNatural",
    "Index"
];
var $633716d7a5d3b648$export$d1f961d649e525df = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($633716d7a5d3b648$var$name, $633716d7a5d3b648$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, subset: subset, compareNatural: compareNatural, Index: Index } = _ref;
    /**
   * Count the multiplicity of an element in a multiset.
   * A multi-dimension array will be converted to a single-dimension array before the operation.
   *
   * Syntax:
   *
   *    math.setMultiplicity(element, set)
   *
   * Examples:
   *
   *    math.setMultiplicity(1, [1, 2, 2, 4])    // returns 1
   *    math.setMultiplicity(2, [1, 2, 2, 4])    // returns 2
   *
   * See also:
   *
   *    setDistinct, setSize
   *
   * @param {number | BigNumber | Fraction | Complex} e  An element in the multiset
   * @param {Array | Matrix}     a  A multiset
   * @return {number}            The number of how many times the multiset contains the element
   */ return typed($633716d7a5d3b648$var$name, {
        "number | BigNumber | Fraction | Complex, Array | Matrix": function numberBigNumberFractionComplexArrayMatrix(e, a) {
            if (subset(size(a), new Index(0)) === 0) // if empty, return 0
            return 0;
            var b = (0, $a14a10567870d913$export$bffa455ba8c619a6)(Array.isArray(a) ? a : a.toArray());
            var count = 0;
            for(var i = 0; i < b.length; i++)if (compareNatural(b[i], e) === 0) count++;
            return count;
        }
    });
});


var $408ad15099e65a98$var$name = "Spa";
var $408ad15099e65a98$var$dependencies = [
    "addScalar",
    "equalScalar",
    "FibonacciHeap"
];
var $408ad15099e65a98$export$5e37e847685a0540 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($408ad15099e65a98$var$name, $408ad15099e65a98$var$dependencies, (_ref)=>{
    var { addScalar: addScalar, equalScalar: equalScalar, FibonacciHeap: FibonacciHeap } = _ref;
    /**
   * An ordered Sparse Accumulator is a representation for a sparse vector that includes a dense array
   * of the vector elements and an ordered list of non-zero elements.
   */ function Spa() {
        if (!(this instanceof Spa)) throw new SyntaxError("Constructor must be called with the new operator");
         // allocate vector, TODO use typed arrays
        this._values = [];
        this._heap = new FibonacciHeap();
    }
    /**
   * Attach type information
   */ Spa.prototype.type = "Spa";
    Spa.prototype.isSpa = true;
    /**
   * Set the value for index i.
   *
   * @param {number} i                       The index
   * @param {number | BigNumber | Complex}   The value at index i
   */ Spa.prototype.set = function(i, v) {
        // check we have a value @ i
        if (!this._values[i]) {
            // insert in heap
            var node = this._heap.insert(i, v); // set the value @ i
            this._values[i] = node;
        } else // update the value @ i
        this._values[i].value = v;
    };
    Spa.prototype.get = function(i) {
        var node = this._values[i];
        if (node) return node.value;
        return 0;
    };
    Spa.prototype.accumulate = function(i, v) {
        // node @ i
        var node = this._values[i];
        if (!node) {
            // insert in heap
            node = this._heap.insert(i, v); // initialize value
            this._values[i] = node;
        } else // accumulate value
        node.value = addScalar(node.value, v);
    };
    Spa.prototype.forEach = function(from, to, callback) {
        // references
        var heap = this._heap;
        var values = this._values; // nodes
        var nodes = []; // node with minimum key, save it
        var node = heap.extractMinimum();
        if (node) nodes.push(node);
         // extract nodes from heap (ordered)
        while(node && node.key <= to){
            // check it is in range
            if (node.key >= from) // check value is not zero
            {
                if (!equalScalar(node.value, 0)) // invoke callback
                callback(node.key, node.value, this);
            } // extract next node, save it
            node = heap.extractMinimum();
            if (node) nodes.push(node);
        } // reinsert all nodes in heap
        for(var i = 0; i < nodes.length; i++){
            // current node
            var n = nodes[i]; // insert node in heap
            node = heap.insert(n.key, n.value); // update values
            values[node.key] = node;
        }
    };
    Spa.prototype.swap = function(i, j) {
        // node @ i and j
        var nodei = this._values[i];
        var nodej = this._values[j]; // check we need to insert indeces
        if (!nodei && nodej) {
            // insert in heap
            nodei = this._heap.insert(i, nodej.value); // remove from heap
            this._heap.remove(nodej); // set values
            this._values[i] = nodei;
            this._values[j] = undefined;
        } else if (nodei && !nodej) {
            // insert in heap
            nodej = this._heap.insert(j, nodei.value); // remove from heap
            this._heap.remove(nodei); // set values
            this._values[j] = nodej;
            this._values[i] = undefined;
        } else if (nodei && nodej) {
            // swap values
            var v = nodei.value;
            nodei.value = nodej.value;
            nodej.value = v;
        }
    };
    return Spa;
}, {
    isClass: true
});





var $e69bd42b49013a9f$var$name = "sqrtm";
var $e69bd42b49013a9f$var$dependencies = [
    "typed",
    "abs",
    "add",
    "multiply",
    "sqrt",
    "subtract",
    "inv",
    "size",
    "max",
    "identity"
];
var $e69bd42b49013a9f$export$71d0f952576e7511 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($e69bd42b49013a9f$var$name, $e69bd42b49013a9f$var$dependencies, (_ref)=>{
    var { typed: typed, abs: abs, add: add, multiply: multiply, sqrt: sqrt, subtract: subtract, inv: inv, size: size, max: max, identity: identity } = _ref;
    var _maxIterations = 1e3;
    var _tolerance = 1e-6;
    /**
   * Calculate the principal square root matrix using the Denman–Beavers iterative method
   *
   * https://en.wikipedia.org/wiki/Square_root_of_a_matrix#By_Denman–Beavers_iteration
   *
   * @param  {Array | Matrix} A   The square matrix `A`
   * @return {Array | Matrix}     The principal square root of matrix `A`
   * @private
   */ function _denmanBeavers(A) {
        var error;
        var iterations = 0;
        var Y = A;
        var Z = identity(size(A));
        do {
            var Yk = Y;
            Y = multiply(0.5, add(Yk, inv(Z)));
            Z = multiply(0.5, add(Z, inv(Yk)));
            error = max(abs(subtract(Y, Yk)));
            if (error > _tolerance && ++iterations > _maxIterations) throw new Error("computing square root of matrix: iterative method could not converge");
        }while (error > _tolerance);
        return Y;
    }
    /**
   * Calculate the principal square root of a square matrix.
   * The principal square root matrix `X` of another matrix `A` is such that `X * X = A`.
   *
   * https://en.wikipedia.org/wiki/Square_root_of_a_matrix
   *
   * Syntax:
   *
   *     X = math.sqrtm(A)
   *
   * Examples:
   *
   *     math.sqrtm([[1, 2], [3, 4]]) // returns [[-2, 1], [1.5, -0.5]]
   *
   * See also:
   *
   *     sqrt, pow
   *
   * @param  {Array | Matrix} A   The square matrix `A`
   * @return {Array | Matrix}     The principal square root of matrix `A`
   */ return typed($e69bd42b49013a9f$var$name, {
        "Array | Matrix": function ArrayMatrix(A) {
            var size = (0, $d8097b7a6d6e36d8$export$b22160e0a14f87b7)(A) ? A.size() : (0, $a14a10567870d913$export$51ffaee4afb683a5)(A);
            switch(size.length){
                case 1:
                    // Single element Array | Matrix
                    if (size[0] === 1) return sqrt(A);
                    else throw new RangeError("Matrix must be square (size: " + (0, $b94963e97c376b6d$export$d9468344d3651243)(size) + ")");
                case 2:
                    // Two-dimensional Array | Matrix
                    var rows = size[0];
                    var cols = size[1];
                    if (rows === cols) return _denmanBeavers(A);
                    else throw new RangeError("Matrix must be square (size: " + (0, $b94963e97c376b6d$export$d9468344d3651243)(size) + ")");
                default:
                    // Multi dimensional array
                    throw new RangeError("Matrix must be at most two dimensional (size: " + (0, $b94963e97c376b6d$export$d9468344d3651243)(size) + ")");
            }
        }
    });
});


var $4a3adae6c43f9f2f$exports = {};
var $3bc9bf0cfc9870da$exports = {};
var $cb41ce2cd8de63fa$exports = {};
function $cb41ce2cd8de63fa$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $cb41ce2cd8de63fa$exports = $cb41ce2cd8de63fa$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $cb41ce2cd8de63fa$exports.__esModule = true, $cb41ce2cd8de63fa$exports["default"] = $cb41ce2cd8de63fa$exports, $cb41ce2cd8de63fa$var$_typeof(o);
}
$cb41ce2cd8de63fa$exports = $cb41ce2cd8de63fa$var$_typeof, $cb41ce2cd8de63fa$exports.__esModule = true, $cb41ce2cd8de63fa$exports["default"] = $cb41ce2cd8de63fa$exports;


var $3bc9bf0cfc9870da$var$_typeof = $cb41ce2cd8de63fa$exports.default;
var $d5da5c0b532e6f32$exports = {};

var $d5da5c0b532e6f32$var$_typeof = $cb41ce2cd8de63fa$exports.default;
function $d5da5c0b532e6f32$var$toPrimitive(t, r) {
    if ("object" != $d5da5c0b532e6f32$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $d5da5c0b532e6f32$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
$d5da5c0b532e6f32$exports = $d5da5c0b532e6f32$var$toPrimitive, $d5da5c0b532e6f32$exports.__esModule = true, $d5da5c0b532e6f32$exports["default"] = $d5da5c0b532e6f32$exports;


function $3bc9bf0cfc9870da$var$toPropertyKey(t) {
    var i = $d5da5c0b532e6f32$exports(t, "string");
    return "symbol" == $3bc9bf0cfc9870da$var$_typeof(i) ? i : String(i);
}
$3bc9bf0cfc9870da$exports = $3bc9bf0cfc9870da$var$toPropertyKey, $3bc9bf0cfc9870da$exports.__esModule = true, $3bc9bf0cfc9870da$exports["default"] = $3bc9bf0cfc9870da$exports;


function $4a3adae6c43f9f2f$var$_defineProperty(obj, key, value) {
    key = $3bc9bf0cfc9870da$exports(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
$4a3adae6c43f9f2f$exports = $4a3adae6c43f9f2f$var$_defineProperty, $4a3adae6c43f9f2f$exports.__esModule = true, $4a3adae6c43f9f2f$exports["default"] = $4a3adae6c43f9f2f$exports;








function $898e4cfe14895b45$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $898e4cfe14895b45$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $898e4cfe14895b45$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($4a3adae6c43f9f2f$exports)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $898e4cfe14895b45$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $898e4cfe14895b45$var$name = "Unit";
var $898e4cfe14895b45$var$dependencies = [
    "?on",
    "config",
    "addScalar",
    "subtract",
    "multiplyScalar",
    "divideScalar",
    "pow",
    "abs",
    "fix",
    "round",
    "equal",
    "isNumeric",
    "format",
    "number",
    "Complex",
    "BigNumber",
    "Fraction"
];
var $898e4cfe14895b45$export$3ad06557a3ac7a63 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($898e4cfe14895b45$var$name, $898e4cfe14895b45$var$dependencies, (_ref)=>{
    var { on: on, config: config, addScalar: addScalar, subtract: subtract, multiplyScalar: multiplyScalar, divideScalar: divideScalar, pow: pow, abs: abs, fix: fix, round: round, equal: equal, isNumeric: isNumeric, format: format, number: number, Complex: Complex, BigNumber: _BigNumber, Fraction: _Fraction } = _ref;
    var toNumber = number;
    /**
   * A unit can be constructed in the following ways:
   *
   *     const a = new Unit(value, name)
   *     const b = new Unit(null, name)
   *     const c = Unit.parse(str)
   *
   * Example usage:
   *
   *     const a = new Unit(5, 'cm')               // 50 mm
   *     const b = Unit.parse('23 kg')             // 23 kg
   *     const c = math.in(a, new Unit(null, 'm')  // 0.05 m
   *     const d = new Unit(9.81, "m/s^2")         // 9.81 m/s^2
   *
   * @class Unit
   * @constructor Unit
   * @param {number | BigNumber | Fraction | Complex | boolean} [value]  A value like 5.2
   * @param {string} [name]   A unit name like "cm" or "inch", or a derived unit of the form: "u1[^ex1] [u2[^ex2] ...] [/ u3[^ex3] [u4[^ex4]]]", such as "kg m^2/s^2", where each unit appearing after the forward slash is taken to be in the denominator. "kg m^2 s^-2" is a synonym and is also acceptable. Any of the units can include a prefix.
   */ function Unit(value, name) {
        if (!(this instanceof Unit)) throw new Error("Constructor must be called with the new operator");
        if (!(value === null || value === undefined || isNumeric(value) || (0, $d8097b7a6d6e36d8$export$8849a896711efe0c)(value))) throw new TypeError("First parameter in Unit constructor must be number, BigNumber, Fraction, Complex, or undefined");
        if (name !== undefined && (typeof name !== "string" || name === "")) throw new TypeError("Second parameter in Unit constructor must be a string");
        if (name !== undefined) {
            var u = Unit.parse(name);
            this.units = u.units;
            this.dimensions = u.dimensions;
        } else {
            this.units = [
                {
                    unit: UNIT_NONE,
                    prefix: PREFIXES.NONE,
                    // link to a list with supported prefixes
                    power: 0
                }
            ];
            this.dimensions = [];
            for(var i = 0; i < BASE_DIMENSIONS.length; i++)this.dimensions[i] = 0;
        }
        this.value = value !== undefined && value !== null ? this._normalize(value) : null;
        this.fixPrefix = false; // if true, function format will not search for the
        // best prefix but leave it as initially provided.
        // fixPrefix is set true by the method Unit.to
        // The justification behind this is that if the constructor is explicitly called,
        // the caller wishes the units to be returned exactly as he supplied.
        this.skipAutomaticSimplification = true;
    }
    /**
   * Attach type information
   */ Unit.prototype.type = "Unit";
    Unit.prototype.isUnit = true; // private variables and functions for the Unit parser
    var text, index, c;
    function skipWhitespace() {
        while(c === " " || c === "	")next();
    }
    function isDigitDot(c) {
        return c >= "0" && c <= "9" || c === ".";
    }
    function isDigit(c) {
        return c >= "0" && c <= "9";
    }
    function next() {
        index++;
        c = text.charAt(index);
    }
    function revert(oldIndex) {
        index = oldIndex;
        c = text.charAt(index);
    }
    function parseNumber() {
        var number = "";
        var oldIndex = index;
        if (c === "+") next();
        else if (c === "-") {
            number += c;
            next();
        }
        if (!isDigitDot(c)) {
            // a + or - must be followed by a digit
            revert(oldIndex);
            return null;
        } // get number, can have a single dot
        if (c === ".") {
            number += c;
            next();
            if (!isDigit(c)) {
                // this is no legal number, it is just a dot
                revert(oldIndex);
                return null;
            }
        } else {
            while(isDigit(c)){
                number += c;
                next();
            }
            if (c === ".") {
                number += c;
                next();
            }
        }
        while(isDigit(c)){
            number += c;
            next();
        } // check for exponential notation like "2.3e-4" or "1.23e50"
        if (c === "E" || c === "e") {
            // The grammar branches here. This could either be part of an exponent or the start of a unit that begins with the letter e, such as "4exabytes"
            var tentativeNumber = "";
            var tentativeIndex = index;
            tentativeNumber += c;
            next();
            if (c === "+" || c === "-") {
                tentativeNumber += c;
                next();
            } // Scientific notation MUST be followed by an exponent (otherwise we assume it is not scientific notation)
            if (!isDigit(c)) {
                // The e or E must belong to something else, so return the number without the e or E.
                revert(tentativeIndex);
                return number;
            } // We can now safely say that this is scientific notation.
            number = number + tentativeNumber;
            while(isDigit(c)){
                number += c;
                next();
            }
        }
        return number;
    }
    function parseUnit() {
        var unitName = ""; // Alphanumeric characters only; matches [a-zA-Z0-9]
        while(isDigit(c) || Unit.isValidAlpha(c)){
            unitName += c;
            next();
        } // Must begin with [a-zA-Z]
        var firstC = unitName.charAt(0);
        if (Unit.isValidAlpha(firstC)) return unitName;
        else return null;
    }
    function parseCharacter(toFind) {
        if (c === toFind) {
            next();
            return toFind;
        } else return null;
    }
    /**
   * Parse a string into a unit. The value of the unit is parsed as number,
   * BigNumber, or Fraction depending on the math.js config setting `number`.
   *
   * Throws an exception if the provided string does not contain a valid unit or
   * cannot be parsed.
   * @memberof Unit
   * @param {string} str        A string like "5.2 inch", "4e2 cm/s^2"
   * @return {Unit} unit
   */ Unit.parse = function(str, options) {
        options = options || {};
        text = str;
        index = -1;
        c = "";
        if (typeof text !== "string") throw new TypeError("Invalid argument in Unit.parse, string expected");
        var unit = new Unit();
        unit.units = [];
        var powerMultiplierCurrent = 1;
        var expectingUnit = false; // A unit should follow this pattern:
        // [number] ...[ [*/] unit[^number] ]
        // unit[^number] ... [ [*/] unit[^number] ]
        // Rules:
        // number is any floating point number.
        // unit is any alphanumeric string beginning with an alpha. Units with names like e3 should be avoided because they look like the exponent of a floating point number!
        // The string may optionally begin with a number.
        // Each unit may optionally be followed by ^number.
        // Whitespace or a forward slash is recommended between consecutive units, although the following technically is parseable:
        //   2m^2kg/s^2
        // it is not good form. If a unit starts with e, then it could be confused as a floating point number:
        //   4erg
        next();
        skipWhitespace(); // Optional number at the start of the string
        var valueStr = parseNumber();
        var value = null;
        if (valueStr) {
            if (config.number === "BigNumber") value = new _BigNumber(valueStr);
            else if (config.number === "Fraction") try {
                // not all numbers can be turned in Fractions, for example very small numbers not
                value = new _Fraction(valueStr);
            } catch (err) {
                value = parseFloat(valueStr);
            }
            else // number
            value = parseFloat(valueStr);
            skipWhitespace(); // Whitespace is not required here
            // handle multiplication or division right after the value, like '1/s'
            if (parseCharacter("*")) {
                powerMultiplierCurrent = 1;
                expectingUnit = true;
            } else if (parseCharacter("/")) {
                powerMultiplierCurrent = -1;
                expectingUnit = true;
            }
        } // Stack to keep track of powerMultipliers applied to each parentheses group
        var powerMultiplierStack = []; // Running product of all elements in powerMultiplierStack
        var powerMultiplierStackProduct = 1;
        while(true){
            skipWhitespace(); // Check for and consume opening parentheses, pushing powerMultiplierCurrent to the stack
            // A '(' will always appear directly before a unit.
            while(c === "("){
                powerMultiplierStack.push(powerMultiplierCurrent);
                powerMultiplierStackProduct *= powerMultiplierCurrent;
                powerMultiplierCurrent = 1;
                next();
                skipWhitespace();
            } // Is there something here?
            var uStr = void 0;
            if (c) {
                var oldC = c;
                uStr = parseUnit();
                if (uStr === null) throw new SyntaxError('Unexpected "' + oldC + '" in "' + text + '" at index ' + index.toString());
            } else break;
             // Verify the unit exists and get the prefix (if any)
            var res = _findUnit(uStr);
            if (res === null) // Unit not found.
            throw new SyntaxError('Unit "' + uStr + '" not found.');
            var power = powerMultiplierCurrent * powerMultiplierStackProduct; // Is there a "^ number"?
            skipWhitespace();
            if (parseCharacter("^")) {
                skipWhitespace();
                var p = parseNumber();
                if (p === null) // No valid number found for the power!
                throw new SyntaxError('In "' + str + '", "^" must be followed by a floating-point number');
                power *= p;
            } // Add the unit to the list
            unit.units.push({
                unit: res.unit,
                prefix: res.prefix,
                power: power
            });
            for(var i = 0; i < BASE_DIMENSIONS.length; i++)unit.dimensions[i] += (res.unit.dimensions[i] || 0) * power;
             // Check for and consume closing parentheses, popping from the stack.
            // A ')' will always follow a unit.
            skipWhitespace();
            while(c === ")"){
                if (powerMultiplierStack.length === 0) throw new SyntaxError('Unmatched ")" in "' + text + '" at index ' + index.toString());
                powerMultiplierStackProduct /= powerMultiplierStack.pop();
                next();
                skipWhitespace();
            } // "*" and "/" should mean we are expecting something to come next.
            // Is there a forward slash? If so, negate powerMultiplierCurrent. The next unit or paren group is in the denominator.
            expectingUnit = false;
            if (parseCharacter("*")) {
                // explicit multiplication
                powerMultiplierCurrent = 1;
                expectingUnit = true;
            } else if (parseCharacter("/")) {
                // division
                powerMultiplierCurrent = -1;
                expectingUnit = true;
            } else // implicit multiplication
            powerMultiplierCurrent = 1;
             // Replace the unit into the auto unit system
            if (res.unit.base) {
                var baseDim = res.unit.base.key;
                UNIT_SYSTEMS.auto[baseDim] = {
                    unit: res.unit,
                    prefix: res.prefix
                };
            }
        } // Has the string been entirely consumed?
        skipWhitespace();
        if (c) throw new SyntaxError('Could not parse: "' + str + '"');
         // Is there a trailing slash?
        if (expectingUnit) throw new SyntaxError('Trailing characters: "' + str + '"');
         // Is the parentheses stack empty?
        if (powerMultiplierStack.length !== 0) throw new SyntaxError('Unmatched "(" in "' + text + '"');
         // Are there any units at all?
        if (unit.units.length === 0 && !options.allowNoUnits) throw new SyntaxError('"' + str + '" contains no units');
        unit.value = value !== undefined ? unit._normalize(value) : null;
        return unit;
    };
    /**
   * create a copy of this unit
   * @memberof Unit
   * @return {Unit} Returns a cloned version of the unit
   */ Unit.prototype.clone = function() {
        var unit = new Unit();
        unit.fixPrefix = this.fixPrefix;
        unit.skipAutomaticSimplification = this.skipAutomaticSimplification;
        unit.value = (0, $6819694788cbfa38$export$9cd59f9826255e47)(this.value);
        unit.dimensions = this.dimensions.slice(0);
        unit.units = [];
        for(var i = 0; i < this.units.length; i++){
            unit.units[i] = {};
            for(var p in this.units[i])if ((0, $6819694788cbfa38$export$5a15a386532a5ea4)(this.units[i], p)) unit.units[i][p] = this.units[i][p];
        }
        return unit;
    };
    /**
   * Return whether the unit is derived (such as m/s, or cm^2, but not N)
   * @memberof Unit
   * @return {boolean} True if the unit is derived
   */ Unit.prototype._isDerived = function() {
        if (this.units.length === 0) return false;
        return this.units.length > 1 || Math.abs(this.units[0].power - 1.0) > 1e-15;
    };
    /**
   * Normalize a value, based on its currently set unit(s)
   * @memberof Unit
   * @param {number | BigNumber | Fraction | boolean} value
   * @return {number | BigNumber | Fraction | boolean} normalized value
   * @private
   */ Unit.prototype._normalize = function(value) {
        if (value === null || value === undefined || this.units.length === 0) return value;
        var res = value;
        var convert = Unit._getNumberConverter((0, $d8097b7a6d6e36d8$export$f5bbd400c2f4426f)(value)); // convert to Fraction or BigNumber if needed
        for(var i = 0; i < this.units.length; i++){
            var unitValue = convert(this.units[i].unit.value);
            var unitPrefixValue = convert(this.units[i].prefix.value);
            var unitPower = convert(this.units[i].power);
            res = multiplyScalar(res, pow(multiplyScalar(unitValue, unitPrefixValue), unitPower));
        }
        return res;
    };
    /**
   * Denormalize a value, based on its currently set unit(s)
   * @memberof Unit
   * @param {number} value
   * @param {number} [prefixValue]    Optional prefix value to be used (ignored if this is a derived unit)
   * @return {number} denormalized value
   * @private
   */ Unit.prototype._denormalize = function(value, prefixValue) {
        if (value === null || value === undefined || this.units.length === 0) return value;
        var res = value;
        var convert = Unit._getNumberConverter((0, $d8097b7a6d6e36d8$export$f5bbd400c2f4426f)(value)); // convert to Fraction or BigNumber if needed
        for(var i = 0; i < this.units.length; i++){
            var unitValue = convert(this.units[i].unit.value);
            var unitPrefixValue = convert(this.units[i].prefix.value);
            var unitPower = convert(this.units[i].power);
            res = divideScalar(res, pow(multiplyScalar(unitValue, unitPrefixValue), unitPower));
        }
        return res;
    };
    /**
   * Find a unit from a string
   * @memberof Unit
   * @param {string} str              A string like 'cm' or 'inch'
   * @returns {Object | null} result  When found, an object with fields unit and
   *                                  prefix is returned. Else, null is returned.
   * @private
   */ var _findUnit = (0, $458cc793bcf3a223$export$fc10aeed3a532e2a)((str)=>{
        // First, match units names exactly. For example, a user could define 'mm' as 10^-4 m, which is silly, but then we would want 'mm' to match the user-defined unit.
        if ((0, $6819694788cbfa38$export$5a15a386532a5ea4)(UNITS, str)) {
            var unit = UNITS[str];
            var prefix = unit.prefixes[""];
            return {
                unit: unit,
                prefix: prefix
            };
        }
        for(var _name in UNITS){
            if ((0, $6819694788cbfa38$export$5a15a386532a5ea4)(UNITS, _name)) {
                if ((0, $b94963e97c376b6d$export$10fdab3683b55b22)(str, _name)) {
                    var _unit = UNITS[_name];
                    var prefixLen = str.length - _name.length;
                    var prefixName = str.substring(0, prefixLen);
                    var _prefix = (0, $6819694788cbfa38$export$5a15a386532a5ea4)(_unit.prefixes, prefixName) ? _unit.prefixes[prefixName] : undefined;
                    if (_prefix !== undefined) // store unit, prefix, and value
                    return {
                        unit: _unit,
                        prefix: _prefix
                    };
                }
            }
        }
        return null;
    }, {
        hasher: (args)=>args[0],
        limit: 100
    });
    /**
   * Test if the given expression is a unit.
   * The unit can have a prefix but cannot have a value.
   * @memberof Unit
   * @param {string} name   A string to be tested whether it is a value less unit.
   *                        The unit can have prefix, like "cm"
   * @return {boolean}      true if the given string is a unit
   */ Unit.isValuelessUnit = function(name) {
        return _findUnit(name) !== null;
    };
    /**
   * check if this unit has given base unit
   * If this unit is a derived unit, this will ALWAYS return false, since by definition base units are not derived.
   * @memberof Unit
   * @param {BASE_UNITS | string | undefined} base
   */ Unit.prototype.hasBase = function(base) {
        if (typeof base === "string") base = BASE_UNITS[base];
        if (!base) return false;
         // All dimensions must be the same
        for(var i = 0; i < BASE_DIMENSIONS.length; i++){
            if (Math.abs((this.dimensions[i] || 0) - (base.dimensions[i] || 0)) > 1e-12) return false;
        }
        return true;
    };
    /**
   * Check if this unit has a base or bases equal to another base or bases
   * For derived units, the exponent on each base also must match
   * @memberof Unit
   * @param {Unit} other
   * @return {boolean} true if equal base
   */ Unit.prototype.equalBase = function(other) {
        // All dimensions must be the same
        for(var i = 0; i < BASE_DIMENSIONS.length; i++){
            if (Math.abs((this.dimensions[i] || 0) - (other.dimensions[i] || 0)) > 1e-12) return false;
        }
        return true;
    };
    /**
   * Check if this unit equals another unit
   * @memberof Unit
   * @param {Unit} other
   * @return {boolean} true if both units are equal
   */ Unit.prototype.equals = function(other) {
        return this.equalBase(other) && equal(this.value, other.value);
    };
    /**
   * Multiply this unit with another one
   * @memberof Unit
   * @param {Unit} other
   * @return {Unit} product of this unit and the other unit
   */ Unit.prototype.multiply = function(other) {
        var res = this.clone();
        for(var i = 0; i < BASE_DIMENSIONS.length; i++)// Dimensions arrays may be of different lengths. Default to 0.
        res.dimensions[i] = (this.dimensions[i] || 0) + (other.dimensions[i] || 0);
         // Append other's units list onto res
        for(var _i = 0; _i < other.units.length; _i++){
            // Make a shallow copy of every unit
            var inverted = $898e4cfe14895b45$var$_objectSpread({}, other.units[_i]);
            res.units.push(inverted);
        } // If at least one operand has a value, then the result should also have a value
        if (this.value !== null || other.value !== null) {
            var valThis = this.value === null ? this._normalize(1) : this.value;
            var valOther = other.value === null ? other._normalize(1) : other.value;
            res.value = multiplyScalar(valThis, valOther);
        } else res.value = null;
        res.skipAutomaticSimplification = false;
        return getNumericIfUnitless(res);
    };
    /**
   * Divide this unit by another one
   * @memberof Unit
   * @param {Unit} other
   * @return {Unit} result of dividing this unit by the other unit
   */ Unit.prototype.divide = function(other) {
        var res = this.clone();
        for(var i = 0; i < BASE_DIMENSIONS.length; i++)// Dimensions arrays may be of different lengths. Default to 0.
        res.dimensions[i] = (this.dimensions[i] || 0) - (other.dimensions[i] || 0);
         // Invert and append other's units list onto res
        for(var _i2 = 0; _i2 < other.units.length; _i2++){
            // Make a shallow copy of every unit
            var inverted = $898e4cfe14895b45$var$_objectSpread($898e4cfe14895b45$var$_objectSpread({}, other.units[_i2]), {}, {
                power: -other.units[_i2].power
            });
            res.units.push(inverted);
        } // If at least one operand has a value, the result should have a value
        if (this.value !== null || other.value !== null) {
            var valThis = this.value === null ? this._normalize(1) : this.value;
            var valOther = other.value === null ? other._normalize(1) : other.value;
            res.value = divideScalar(valThis, valOther);
        } else res.value = null;
        res.skipAutomaticSimplification = false;
        return getNumericIfUnitless(res);
    };
    /**
   * Calculate the power of a unit
   * @memberof Unit
   * @param {number | Fraction | BigNumber} p
   * @returns {Unit}      The result: this^p
   */ Unit.prototype.pow = function(p) {
        var res = this.clone();
        for(var i = 0; i < BASE_DIMENSIONS.length; i++)// Dimensions arrays may be of different lengths. Default to 0.
        res.dimensions[i] = (this.dimensions[i] || 0) * p;
         // Adjust the power of each unit in the list
        for(var _i3 = 0; _i3 < res.units.length; _i3++)res.units[_i3].power *= p;
        if (res.value !== null) res.value = pow(res.value, p); // only allow numeric output, we don't want to return a Complex number
        else res.value = null;
        res.skipAutomaticSimplification = false;
        return getNumericIfUnitless(res);
    };
    /**
   * Return the numeric value of this unit if it is dimensionless, has a value, and config.predictable == false; or the original unit otherwise
   * @param {Unit} unit
   * @returns {number | Fraction | BigNumber | Unit}  The numeric value of the unit if conditions are met, or the original unit otherwise
   */ function getNumericIfUnitless(unit) {
        if (unit.equalBase(BASE_UNITS.NONE) && unit.value !== null && !config.predictable) return unit.value;
        else return unit;
    }
    /**
   * Calculate the absolute value of a unit
   * @memberof Unit
   * @param {number | Fraction | BigNumber} x
   * @returns {Unit}      The result: |x|, absolute value of x
   */ Unit.prototype.abs = function() {
        var ret = this.clone();
        if (ret.value !== null) {
            if (ret._isDerived() || ret.units[0].unit.offset === 0) ret.value = abs(ret.value);
            else {
                // To give the correct, but unexpected, results for units with an offset.
                // For example, abs(-283.15 degC) = -263.15 degC !!!
                // We must take the offset into consideration here
                var convert = Unit._getNumberConverter((0, $d8097b7a6d6e36d8$export$f5bbd400c2f4426f)(ret.value)); // convert to Fraction or BigNumber if needed
                var unitValue = convert(ret.units[0].unit.value);
                var nominalOffset = convert(ret.units[0].unit.offset);
                var unitOffset = multiplyScalar(unitValue, nominalOffset);
                ret.value = subtract(abs(addScalar(ret.value, unitOffset)), unitOffset);
            }
        }
        for(var i in ret.units)if (ret.units[i].unit.name === "VA" || ret.units[i].unit.name === "VAR") ret.units[i].unit = UNITS.W;
        return ret;
    };
    /**
   * Convert the unit to a specific unit name.
   * @memberof Unit
   * @param {string | Unit} valuelessUnit   A unit without value. Can have prefix, like "cm"
   * @returns {Unit} Returns a clone of the unit with a fixed prefix and unit.
   */ Unit.prototype.to = function(valuelessUnit) {
        var value = this.value === null ? this._normalize(1) : this.value;
        var other;
        if (typeof valuelessUnit === "string") other = Unit.parse(valuelessUnit);
        else if ((0, $d8097b7a6d6e36d8$export$8960dc335987b8da)(valuelessUnit)) other = valuelessUnit.clone();
        else throw new Error("String or Unit expected as parameter");
        if (!this.equalBase(other)) throw new Error("Units do not match ('".concat(other.toString(), "' != '").concat(this.toString(), "')"));
        if (other.value !== null) throw new Error("Cannot convert to a unit with a value");
        if (this.value === null || this._isDerived() || this.units[0].unit.offset === other.units[0].unit.offset) other.value = (0, $6819694788cbfa38$export$9cd59f9826255e47)(value);
        else {
            /* Need to adjust value by difference in offset to convert */ var convert = Unit._getNumberConverter((0, $d8097b7a6d6e36d8$export$f5bbd400c2f4426f)(value)); // convert to Fraction or BigNumber if needed
            var thisUnitValue = convert(this.units[0].unit.value);
            var thisNominalOffset = convert(this.units[0].unit.offset);
            var thisUnitOffset = multiplyScalar(thisUnitValue, thisNominalOffset);
            var otherUnitValue = convert(other.units[0].unit.value);
            var otherNominalOffset = convert(other.units[0].unit.offset);
            var otherUnitOffset = multiplyScalar(otherUnitValue, otherNominalOffset);
            other.value = subtract(addScalar(value, thisUnitOffset), otherUnitOffset);
        }
        other.fixPrefix = true;
        other.skipAutomaticSimplification = true;
        return other;
    };
    /**
   * Return the value of the unit when represented with given valueless unit
   * @memberof Unit
   * @param {string | Unit} valuelessUnit    For example 'cm' or 'inch'
   * @return {number} Returns the unit value as number.
   */ // TODO: deprecate Unit.toNumber? It's always better to use toNumeric
    Unit.prototype.toNumber = function(valuelessUnit) {
        return toNumber(this.toNumeric(valuelessUnit));
    };
    /**
   * Return the value of the unit in the original numeric type
   * @memberof Unit
   * @param {string | Unit} valuelessUnit    For example 'cm' or 'inch'
   * @return {number | BigNumber | Fraction} Returns the unit value
   */ Unit.prototype.toNumeric = function(valuelessUnit) {
        var other;
        if (valuelessUnit) // Allow getting the numeric value without converting to a different unit
        other = this.to(valuelessUnit);
        else other = this.clone();
        if (other._isDerived() || other.units.length === 0) return other._denormalize(other.value);
        else return other._denormalize(other.value, other.units[0].prefix.value);
    };
    /**
   * Get a string representation of the unit.
   * @memberof Unit
   * @return {string}
   */ Unit.prototype.toString = function() {
        return this.format();
    };
    /**
   * Get a JSON representation of the unit
   * @memberof Unit
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "Unit", "value": 2, "unit": "cm", "fixPrefix": false}`
   */ Unit.prototype.toJSON = function() {
        return {
            mathjs: "Unit",
            value: this._denormalize(this.value),
            unit: this.formatUnits(),
            fixPrefix: this.fixPrefix
        };
    };
    /**
   * Instantiate a Unit from a JSON object
   * @memberof Unit
   * @param {Object} json  A JSON object structured as:
   *                       `{"mathjs": "Unit", "value": 2, "unit": "cm", "fixPrefix": false}`
   * @return {Unit}
   */ Unit.fromJSON = function(json) {
        var unit = new Unit(json.value, json.unit);
        unit.fixPrefix = json.fixPrefix || false;
        return unit;
    };
    /**
   * Returns the string representation of the unit.
   * @memberof Unit
   * @return {string}
   */ Unit.prototype.valueOf = Unit.prototype.toString;
    /**
   * Simplify this Unit's unit list and return a new Unit with the simplified list.
   * The returned Unit will contain a list of the "best" units for formatting.
   */ Unit.prototype.simplify = function() {
        var ret = this.clone();
        var proposedUnitList = []; // Search for a matching base
        var matchingBase;
        for(var key in currentUnitSystem){
            if ((0, $6819694788cbfa38$export$5a15a386532a5ea4)(currentUnitSystem, key)) {
                if (ret.hasBase(BASE_UNITS[key])) {
                    matchingBase = key;
                    break;
                }
            }
        }
        if (matchingBase === "NONE") ret.units = [];
        else {
            var matchingUnit;
            if (matchingBase) // Does the unit system have a matching unit?
            {
                if ((0, $6819694788cbfa38$export$5a15a386532a5ea4)(currentUnitSystem, matchingBase)) matchingUnit = currentUnitSystem[matchingBase];
            }
            if (matchingUnit) ret.units = [
                {
                    unit: matchingUnit.unit,
                    prefix: matchingUnit.prefix,
                    power: 1.0
                }
            ];
            else {
                // Multiple units or units with powers are formatted like this:
                // 5 (kg m^2) / (s^3 mol)
                // Build an representation from the base units of the current unit system
                var missingBaseDim = false;
                for(var i = 0; i < BASE_DIMENSIONS.length; i++){
                    var baseDim = BASE_DIMENSIONS[i];
                    if (Math.abs(ret.dimensions[i] || 0) > 1e-12) {
                        if ((0, $6819694788cbfa38$export$5a15a386532a5ea4)(currentUnitSystem, baseDim)) proposedUnitList.push({
                            unit: currentUnitSystem[baseDim].unit,
                            prefix: currentUnitSystem[baseDim].prefix,
                            power: ret.dimensions[i] || 0
                        });
                        else missingBaseDim = true;
                    }
                } // Is the proposed unit list "simpler" than the existing one?
                if (proposedUnitList.length < ret.units.length && !missingBaseDim) // Replace this unit list with the proposed list
                ret.units = proposedUnitList;
            }
        }
        return ret;
    };
    /**
   * Returns a new Unit in the SI system with the same value as this one
   */ Unit.prototype.toSI = function() {
        var ret = this.clone();
        var proposedUnitList = []; // Multiple units or units with powers are formatted like this:
        // 5 (kg m^2) / (s^3 mol)
        // Build an representation from the base units of the SI unit system
        for(var i = 0; i < BASE_DIMENSIONS.length; i++){
            var baseDim = BASE_DIMENSIONS[i];
            if (Math.abs(ret.dimensions[i] || 0) > 1e-12) {
                if ((0, $6819694788cbfa38$export$5a15a386532a5ea4)(UNIT_SYSTEMS.si, baseDim)) proposedUnitList.push({
                    unit: UNIT_SYSTEMS.si[baseDim].unit,
                    prefix: UNIT_SYSTEMS.si[baseDim].prefix,
                    power: ret.dimensions[i] || 0
                });
                else throw new Error("Cannot express custom unit " + baseDim + " in SI units");
            }
        } // Replace this unit list with the proposed list
        ret.units = proposedUnitList;
        ret.fixPrefix = true;
        ret.skipAutomaticSimplification = true;
        return ret;
    };
    /**
   * Get a string representation of the units of this Unit, without the value. The unit list is formatted as-is without first being simplified.
   * @memberof Unit
   * @return {string}
   */ Unit.prototype.formatUnits = function() {
        var strNum = "";
        var strDen = "";
        var nNum = 0;
        var nDen = 0;
        for(var i = 0; i < this.units.length; i++){
            if (this.units[i].power > 0) {
                nNum++;
                strNum += " " + this.units[i].prefix.name + this.units[i].unit.name;
                if (Math.abs(this.units[i].power - 1.0) > 1e-15) strNum += "^" + this.units[i].power;
            } else if (this.units[i].power < 0) nDen++;
        }
        if (nDen > 0) {
            for(var _i4 = 0; _i4 < this.units.length; _i4++)if (this.units[_i4].power < 0) {
                if (nNum > 0) {
                    strDen += " " + this.units[_i4].prefix.name + this.units[_i4].unit.name;
                    if (Math.abs(this.units[_i4].power + 1.0) > 1e-15) strDen += "^" + -this.units[_i4].power;
                } else {
                    strDen += " " + this.units[_i4].prefix.name + this.units[_i4].unit.name;
                    strDen += "^" + this.units[_i4].power;
                }
            }
        } // Remove leading " "
        strNum = strNum.substr(1);
        strDen = strDen.substr(1); // Add parans for better copy/paste back into evaluate, for example, or for better pretty print formatting
        if (nNum > 1 && nDen > 0) strNum = "(" + strNum + ")";
        if (nDen > 1 && nNum > 0) strDen = "(" + strDen + ")";
        var str = strNum;
        if (nNum > 0 && nDen > 0) str += " / ";
        str += strDen;
        return str;
    };
    /**
   * Get a string representation of the Unit, with optional formatting options.
   * @memberof Unit
   * @param {Object | number | Function} [options]  Formatting options. See
   *                                                lib/utils/number:format for a
   *                                                description of the available
   *                                                options.
   * @return {string}
   */ Unit.prototype.format = function(options) {
        // Simplfy the unit list, unless it is valueless or was created directly in the
        // constructor or as the result of to or toSI
        var simp = this.skipAutomaticSimplification || this.value === null ? this.clone() : this.simplify(); // Apply some custom logic for handling VA and VAR. The goal is to express the value of the unit as a real value, if possible. Otherwise, use a real-valued unit instead of a complex-valued one.
        var isImaginary = false;
        if (typeof simp.value !== "undefined" && simp.value !== null && (0, $d8097b7a6d6e36d8$export$8849a896711efe0c)(simp.value)) // TODO: Make this better, for example, use relative magnitude of re and im rather than absolute
        isImaginary = Math.abs(simp.value.re) < 1e-14;
        for(var i in simp.units){
            if ((0, $6819694788cbfa38$export$5a15a386532a5ea4)(simp.units, i)) {
                if (simp.units[i].unit) {
                    if (simp.units[i].unit.name === "VA" && isImaginary) simp.units[i].unit = UNITS.VAR;
                    else if (simp.units[i].unit.name === "VAR" && !isImaginary) simp.units[i].unit = UNITS.VA;
                }
            }
        } // Now apply the best prefix
        // Units must have only one unit and not have the fixPrefix flag set
        if (simp.units.length === 1 && !simp.fixPrefix) // Units must have integer powers, otherwise the prefix will change the
        // outputted value by not-an-integer-power-of-ten
        {
            if (Math.abs(simp.units[0].power - Math.round(simp.units[0].power)) < 1e-14) // Apply the best prefix
            simp.units[0].prefix = simp._bestPrefix();
        }
        var value = simp._denormalize(simp.value);
        var str = simp.value !== null ? format(value, options || {}) : "";
        var unitStr = simp.formatUnits();
        if (simp.value && (0, $d8097b7a6d6e36d8$export$8849a896711efe0c)(simp.value)) str = "(" + str + ")"; // Surround complex values with ( ) to enable better parsing
        if (unitStr.length > 0 && str.length > 0) str += " ";
        str += unitStr;
        return str;
    };
    /**
   * Calculate the best prefix using current value.
   * @memberof Unit
   * @returns {Object} prefix
   * @private
   */ Unit.prototype._bestPrefix = function() {
        if (this.units.length !== 1) throw new Error("Can only compute the best prefix for single units with integer powers, like kg, s^2, N^-1, and so forth!");
        if (Math.abs(this.units[0].power - Math.round(this.units[0].power)) >= 1e-14) throw new Error("Can only compute the best prefix for single units with integer powers, like kg, s^2, N^-1, and so forth!");
         // find the best prefix value (resulting in the value of which
        // the absolute value of the log10 is closest to zero,
        // though with a little offset of 1.2 for nicer values: you get a
        // sequence 1mm 100mm 500mm 0.6m 1m 10m 100m 500m 0.6km 1km ...
        // Note: the units value can be any numeric type, but to find the best
        // prefix it's enough to work with limited precision of a regular number
        // Update: using mathjs abs since we also allow complex numbers
        var absValue = this.value !== null ? abs(this.value) : 0;
        var absUnitValue = abs(this.units[0].unit.value);
        var bestPrefix = this.units[0].prefix;
        if (absValue === 0) return bestPrefix;
        var power = this.units[0].power;
        var bestDiff = Math.log(absValue / Math.pow(bestPrefix.value * absUnitValue, power)) / Math.LN10 - 1.2;
        if (bestDiff > -2.200001 && bestDiff < 1.800001) return bestPrefix; // Allow the original prefix
        bestDiff = Math.abs(bestDiff);
        var prefixes = this.units[0].unit.prefixes;
        for(var p in prefixes)if ((0, $6819694788cbfa38$export$5a15a386532a5ea4)(prefixes, p)) {
            var prefix = prefixes[p];
            if (prefix.scientific) {
                var diff = Math.abs(Math.log(absValue / Math.pow(prefix.value * absUnitValue, power)) / Math.LN10 - 1.2);
                if (diff < bestDiff || diff === bestDiff && prefix.name.length < bestPrefix.name.length) {
                    // choose the prefix with the smallest diff, or if equal, choose the one
                    // with the shortest name (can happen with SHORTLONG for example)
                    bestPrefix = prefix;
                    bestDiff = diff;
                }
            }
        }
        return bestPrefix;
    };
    /**
   * Returns an array of units whose sum is equal to this unit
   * @memberof Unit
   * @param {Array} [parts] An array of strings or valueless units.
   *
   *   Example:
   *
   *   const u = new Unit(1, 'm')
   *   u.splitUnit(['feet', 'inch'])
   *     [ 3 feet, 3.3700787401575 inch ]
   *
   * @return {Array} An array of units.
   */ Unit.prototype.splitUnit = function(parts) {
        var x = this.clone();
        var ret = [];
        for(var i = 0; i < parts.length; i++){
            // Convert x to the requested unit
            x = x.to(parts[i]);
            if (i === parts.length - 1) break; // Get the numeric value of this unit
            var xNumeric = x.toNumeric(); // Check to see if xNumeric is nearly equal to an integer,
            // since fix can incorrectly round down if there is round-off error
            var xRounded = round(xNumeric);
            var xFixed = void 0;
            var isNearlyEqual = equal(xRounded, xNumeric);
            if (isNearlyEqual) xFixed = xRounded;
            else xFixed = fix(x.toNumeric());
            var y = new Unit(xFixed, parts[i].toString());
            ret.push(y);
            x = subtract(x, y);
        } // This little bit fixes a bug where the remainder should be 0 but is a little bit off.
        // But instead of comparing x, the remainder, with zero--we will compare the sum of
        // all the parts so far with the original value. If they are nearly equal,
        // we set the remainder to 0.
        var testSum = 0;
        for(var _i5 = 0; _i5 < ret.length; _i5++)testSum = addScalar(testSum, ret[_i5].value);
        if (equal(testSum, this.value)) x.value = 0;
        ret.push(x);
        return ret;
    };
    var PREFIXES = {
        NONE: {
            "": {
                name: "",
                value: 1,
                scientific: true
            }
        },
        SHORT: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            da: {
                name: "da",
                value: 1e1,
                scientific: false
            },
            h: {
                name: "h",
                value: 1e2,
                scientific: false
            },
            k: {
                name: "k",
                value: 1e3,
                scientific: true
            },
            M: {
                name: "M",
                value: 1e6,
                scientific: true
            },
            G: {
                name: "G",
                value: 1e9,
                scientific: true
            },
            T: {
                name: "T",
                value: 1e12,
                scientific: true
            },
            P: {
                name: "P",
                value: 1e15,
                scientific: true
            },
            E: {
                name: "E",
                value: 1e18,
                scientific: true
            },
            Z: {
                name: "Z",
                value: 1e21,
                scientific: true
            },
            Y: {
                name: "Y",
                value: 1e24,
                scientific: true
            },
            d: {
                name: "d",
                value: 1e-1,
                scientific: false
            },
            c: {
                name: "c",
                value: 1e-2,
                scientific: false
            },
            m: {
                name: "m",
                value: 1e-3,
                scientific: true
            },
            u: {
                name: "u",
                value: 1e-6,
                scientific: true
            },
            n: {
                name: "n",
                value: 1e-9,
                scientific: true
            },
            p: {
                name: "p",
                value: 1e-12,
                scientific: true
            },
            f: {
                name: "f",
                value: 1e-15,
                scientific: true
            },
            a: {
                name: "a",
                value: 1e-18,
                scientific: true
            },
            z: {
                name: "z",
                value: 1e-21,
                scientific: true
            },
            y: {
                name: "y",
                value: 1e-24,
                scientific: true
            }
        },
        LONG: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            deca: {
                name: "deca",
                value: 1e1,
                scientific: false
            },
            hecto: {
                name: "hecto",
                value: 1e2,
                scientific: false
            },
            kilo: {
                name: "kilo",
                value: 1e3,
                scientific: true
            },
            mega: {
                name: "mega",
                value: 1e6,
                scientific: true
            },
            giga: {
                name: "giga",
                value: 1e9,
                scientific: true
            },
            tera: {
                name: "tera",
                value: 1e12,
                scientific: true
            },
            peta: {
                name: "peta",
                value: 1e15,
                scientific: true
            },
            exa: {
                name: "exa",
                value: 1e18,
                scientific: true
            },
            zetta: {
                name: "zetta",
                value: 1e21,
                scientific: true
            },
            yotta: {
                name: "yotta",
                value: 1e24,
                scientific: true
            },
            deci: {
                name: "deci",
                value: 1e-1,
                scientific: false
            },
            centi: {
                name: "centi",
                value: 1e-2,
                scientific: false
            },
            milli: {
                name: "milli",
                value: 1e-3,
                scientific: true
            },
            micro: {
                name: "micro",
                value: 1e-6,
                scientific: true
            },
            nano: {
                name: "nano",
                value: 1e-9,
                scientific: true
            },
            pico: {
                name: "pico",
                value: 1e-12,
                scientific: true
            },
            femto: {
                name: "femto",
                value: 1e-15,
                scientific: true
            },
            atto: {
                name: "atto",
                value: 1e-18,
                scientific: true
            },
            zepto: {
                name: "zepto",
                value: 1e-21,
                scientific: true
            },
            yocto: {
                name: "yocto",
                value: 1e-24,
                scientific: true
            }
        },
        SQUARED: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            da: {
                name: "da",
                value: 1e2,
                scientific: false
            },
            h: {
                name: "h",
                value: 1e4,
                scientific: false
            },
            k: {
                name: "k",
                value: 1e6,
                scientific: true
            },
            M: {
                name: "M",
                value: 1e12,
                scientific: true
            },
            G: {
                name: "G",
                value: 1e18,
                scientific: true
            },
            T: {
                name: "T",
                value: 1e24,
                scientific: true
            },
            P: {
                name: "P",
                value: 1e30,
                scientific: true
            },
            E: {
                name: "E",
                value: 1e36,
                scientific: true
            },
            Z: {
                name: "Z",
                value: 1e42,
                scientific: true
            },
            Y: {
                name: "Y",
                value: 1e48,
                scientific: true
            },
            d: {
                name: "d",
                value: 1e-2,
                scientific: false
            },
            c: {
                name: "c",
                value: 1e-4,
                scientific: false
            },
            m: {
                name: "m",
                value: 1e-6,
                scientific: true
            },
            u: {
                name: "u",
                value: 1e-12,
                scientific: true
            },
            n: {
                name: "n",
                value: 1e-18,
                scientific: true
            },
            p: {
                name: "p",
                value: 1e-24,
                scientific: true
            },
            f: {
                name: "f",
                value: 1e-30,
                scientific: true
            },
            a: {
                name: "a",
                value: 1e-36,
                scientific: true
            },
            z: {
                name: "z",
                value: 1e-42,
                scientific: true
            },
            y: {
                name: "y",
                value: 1e-48,
                scientific: true
            }
        },
        CUBIC: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            da: {
                name: "da",
                value: 1e3,
                scientific: false
            },
            h: {
                name: "h",
                value: 1e6,
                scientific: false
            },
            k: {
                name: "k",
                value: 1e9,
                scientific: true
            },
            M: {
                name: "M",
                value: 1e18,
                scientific: true
            },
            G: {
                name: "G",
                value: 1e27,
                scientific: true
            },
            T: {
                name: "T",
                value: 1e36,
                scientific: true
            },
            P: {
                name: "P",
                value: 1e45,
                scientific: true
            },
            E: {
                name: "E",
                value: 1e54,
                scientific: true
            },
            Z: {
                name: "Z",
                value: 1e63,
                scientific: true
            },
            Y: {
                name: "Y",
                value: 1e72,
                scientific: true
            },
            d: {
                name: "d",
                value: 1e-3,
                scientific: false
            },
            c: {
                name: "c",
                value: 1e-6,
                scientific: false
            },
            m: {
                name: "m",
                value: 1e-9,
                scientific: true
            },
            u: {
                name: "u",
                value: 1e-18,
                scientific: true
            },
            n: {
                name: "n",
                value: 1e-27,
                scientific: true
            },
            p: {
                name: "p",
                value: 1e-36,
                scientific: true
            },
            f: {
                name: "f",
                value: 1e-45,
                scientific: true
            },
            a: {
                name: "a",
                value: 1e-54,
                scientific: true
            },
            z: {
                name: "z",
                value: 1e-63,
                scientific: true
            },
            y: {
                name: "y",
                value: 1e-72,
                scientific: true
            }
        },
        BINARY_SHORT_SI: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            k: {
                name: "k",
                value: 1e3,
                scientific: true
            },
            M: {
                name: "M",
                value: 1e6,
                scientific: true
            },
            G: {
                name: "G",
                value: 1e9,
                scientific: true
            },
            T: {
                name: "T",
                value: 1e12,
                scientific: true
            },
            P: {
                name: "P",
                value: 1e15,
                scientific: true
            },
            E: {
                name: "E",
                value: 1e18,
                scientific: true
            },
            Z: {
                name: "Z",
                value: 1e21,
                scientific: true
            },
            Y: {
                name: "Y",
                value: 1e24,
                scientific: true
            }
        },
        BINARY_SHORT_IEC: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            Ki: {
                name: "Ki",
                value: 1024,
                scientific: true
            },
            Mi: {
                name: "Mi",
                value: Math.pow(1024, 2),
                scientific: true
            },
            Gi: {
                name: "Gi",
                value: Math.pow(1024, 3),
                scientific: true
            },
            Ti: {
                name: "Ti",
                value: Math.pow(1024, 4),
                scientific: true
            },
            Pi: {
                name: "Pi",
                value: Math.pow(1024, 5),
                scientific: true
            },
            Ei: {
                name: "Ei",
                value: Math.pow(1024, 6),
                scientific: true
            },
            Zi: {
                name: "Zi",
                value: Math.pow(1024, 7),
                scientific: true
            },
            Yi: {
                name: "Yi",
                value: Math.pow(1024, 8),
                scientific: true
            }
        },
        BINARY_LONG_SI: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            kilo: {
                name: "kilo",
                value: 1e3,
                scientific: true
            },
            mega: {
                name: "mega",
                value: 1e6,
                scientific: true
            },
            giga: {
                name: "giga",
                value: 1e9,
                scientific: true
            },
            tera: {
                name: "tera",
                value: 1e12,
                scientific: true
            },
            peta: {
                name: "peta",
                value: 1e15,
                scientific: true
            },
            exa: {
                name: "exa",
                value: 1e18,
                scientific: true
            },
            zetta: {
                name: "zetta",
                value: 1e21,
                scientific: true
            },
            yotta: {
                name: "yotta",
                value: 1e24,
                scientific: true
            }
        },
        BINARY_LONG_IEC: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            kibi: {
                name: "kibi",
                value: 1024,
                scientific: true
            },
            mebi: {
                name: "mebi",
                value: Math.pow(1024, 2),
                scientific: true
            },
            gibi: {
                name: "gibi",
                value: Math.pow(1024, 3),
                scientific: true
            },
            tebi: {
                name: "tebi",
                value: Math.pow(1024, 4),
                scientific: true
            },
            pebi: {
                name: "pebi",
                value: Math.pow(1024, 5),
                scientific: true
            },
            exi: {
                name: "exi",
                value: Math.pow(1024, 6),
                scientific: true
            },
            zebi: {
                name: "zebi",
                value: Math.pow(1024, 7),
                scientific: true
            },
            yobi: {
                name: "yobi",
                value: Math.pow(1024, 8),
                scientific: true
            }
        },
        BTU: {
            "": {
                name: "",
                value: 1,
                scientific: true
            },
            MM: {
                name: "MM",
                value: 1e6,
                scientific: true
            }
        }
    };
    PREFIXES.SHORTLONG = (0, (/*@__PURE__*/$parcel$interopDefault($2f82469e03d52db2$exports)))({}, PREFIXES.SHORT, PREFIXES.LONG);
    PREFIXES.BINARY_SHORT = (0, (/*@__PURE__*/$parcel$interopDefault($2f82469e03d52db2$exports)))({}, PREFIXES.BINARY_SHORT_SI, PREFIXES.BINARY_SHORT_IEC);
    PREFIXES.BINARY_LONG = (0, (/*@__PURE__*/$parcel$interopDefault($2f82469e03d52db2$exports)))({}, PREFIXES.BINARY_LONG_SI, PREFIXES.BINARY_LONG_IEC);
    /* Internally, each unit is represented by a value and a dimension array. The elements of the dimensions array have the following meaning:
   * Index  Dimension
   * -----  ---------
   *   0    Length
   *   1    Mass
   *   2    Time
   *   3    Current
   *   4    Temperature
   *   5    Luminous intensity
   *   6    Amount of substance
   *   7    Angle
   *   8    Bit (digital)
   * For example, the unit "298.15 K" is a pure temperature and would have a value of 298.15 and a dimension array of [0, 0, 0, 0, 1, 0, 0, 0, 0]. The unit "1 cal / (gm °C)" can be written in terms of the 9 fundamental dimensions as [length^2] / ([time^2] * [temperature]), and would a value of (after conversion to SI) 4184.0 and a dimensions array of [2, 0, -2, 0, -1, 0, 0, 0, 0].
   *
   */ var BASE_DIMENSIONS = [
        "MASS",
        "LENGTH",
        "TIME",
        "CURRENT",
        "TEMPERATURE",
        "LUMINOUS_INTENSITY",
        "AMOUNT_OF_SUBSTANCE",
        "ANGLE",
        "BIT"
    ];
    var BASE_UNITS = {
        NONE: {
            dimensions: [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        MASS: {
            dimensions: [
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        LENGTH: {
            dimensions: [
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        TIME: {
            dimensions: [
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        CURRENT: {
            dimensions: [
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0
            ]
        },
        TEMPERATURE: {
            dimensions: [
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0
            ]
        },
        LUMINOUS_INTENSITY: {
            dimensions: [
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0
            ]
        },
        AMOUNT_OF_SUBSTANCE: {
            dimensions: [
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0
            ]
        },
        FORCE: {
            dimensions: [
                1,
                1,
                -2,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        SURFACE: {
            dimensions: [
                0,
                2,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        VOLUME: {
            dimensions: [
                0,
                3,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ENERGY: {
            dimensions: [
                1,
                2,
                -2,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        POWER: {
            dimensions: [
                1,
                2,
                -3,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        PRESSURE: {
            dimensions: [
                1,
                -1,
                -2,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ELECTRIC_CHARGE: {
            dimensions: [
                0,
                0,
                1,
                1,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ELECTRIC_CAPACITANCE: {
            dimensions: [
                -1,
                -2,
                4,
                2,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ELECTRIC_POTENTIAL: {
            dimensions: [
                1,
                2,
                -3,
                -1,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ELECTRIC_RESISTANCE: {
            dimensions: [
                1,
                2,
                -3,
                -2,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ELECTRIC_INDUCTANCE: {
            dimensions: [
                1,
                2,
                -2,
                -2,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ELECTRIC_CONDUCTANCE: {
            dimensions: [
                -1,
                -2,
                3,
                2,
                0,
                0,
                0,
                0,
                0
            ]
        },
        MAGNETIC_FLUX: {
            dimensions: [
                1,
                2,
                -2,
                -1,
                0,
                0,
                0,
                0,
                0
            ]
        },
        MAGNETIC_FLUX_DENSITY: {
            dimensions: [
                1,
                0,
                -2,
                -1,
                0,
                0,
                0,
                0,
                0
            ]
        },
        FREQUENCY: {
            dimensions: [
                0,
                0,
                -1,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        },
        ANGLE: {
            dimensions: [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0
            ]
        },
        BIT: {
            dimensions: [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1
            ]
        }
    };
    for(var key in BASE_UNITS)if ((0, $6819694788cbfa38$export$5a15a386532a5ea4)(BASE_UNITS, key)) BASE_UNITS[key].key = key;
    var BASE_UNIT_NONE = {};
    var UNIT_NONE = {
        name: "",
        base: BASE_UNIT_NONE,
        value: 1,
        offset: 0,
        dimensions: BASE_DIMENSIONS.map((x)=>0)
    };
    var UNITS = {
        // length
        meter: {
            name: "meter",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        inch: {
            name: "inch",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.0254,
            offset: 0
        },
        foot: {
            name: "foot",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.3048,
            offset: 0
        },
        yard: {
            name: "yard",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.9144,
            offset: 0
        },
        mile: {
            name: "mile",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 1609.344,
            offset: 0
        },
        link: {
            name: "link",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.201168,
            offset: 0
        },
        rod: {
            name: "rod",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 5.0292,
            offset: 0
        },
        chain: {
            name: "chain",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 20.1168,
            offset: 0
        },
        angstrom: {
            name: "angstrom",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 1e-10,
            offset: 0
        },
        m: {
            name: "m",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        in: {
            name: "in",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.0254,
            offset: 0
        },
        ft: {
            name: "ft",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.3048,
            offset: 0
        },
        yd: {
            name: "yd",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.9144,
            offset: 0
        },
        mi: {
            name: "mi",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 1609.344,
            offset: 0
        },
        li: {
            name: "li",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.201168,
            offset: 0
        },
        rd: {
            name: "rd",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 5.029210,
            offset: 0
        },
        ch: {
            name: "ch",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 20.1168,
            offset: 0
        },
        mil: {
            name: "mil",
            base: BASE_UNITS.LENGTH,
            prefixes: PREFIXES.NONE,
            value: 0.0000254,
            offset: 0
        },
        // 1/1000 inch
        // Surface
        m2: {
            name: "m2",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.SQUARED,
            value: 1,
            offset: 0
        },
        sqin: {
            name: "sqin",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 0.00064516,
            offset: 0
        },
        // 645.16 mm2
        sqft: {
            name: "sqft",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 0.09290304,
            offset: 0
        },
        // 0.09290304 m2
        sqyd: {
            name: "sqyd",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 0.83612736,
            offset: 0
        },
        // 0.83612736 m2
        sqmi: {
            name: "sqmi",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 2589988.110336,
            offset: 0
        },
        // 2.589988110336 km2
        sqrd: {
            name: "sqrd",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 25.29295,
            offset: 0
        },
        // 25.29295 m2
        sqch: {
            name: "sqch",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 404.6873,
            offset: 0
        },
        // 404.6873 m2
        sqmil: {
            name: "sqmil",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 6.4516e-10,
            offset: 0
        },
        // 6.4516 * 10^-10 m2
        acre: {
            name: "acre",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 4046.86,
            offset: 0
        },
        // 4046.86 m2
        hectare: {
            name: "hectare",
            base: BASE_UNITS.SURFACE,
            prefixes: PREFIXES.NONE,
            value: 10000,
            offset: 0
        },
        // 10000 m2
        // Volume
        m3: {
            name: "m3",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.CUBIC,
            value: 1,
            offset: 0
        },
        L: {
            name: "L",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.SHORT,
            value: 0.001,
            offset: 0
        },
        // litre
        l: {
            name: "l",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.SHORT,
            value: 0.001,
            offset: 0
        },
        // litre
        litre: {
            name: "litre",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.LONG,
            value: 0.001,
            offset: 0
        },
        cuin: {
            name: "cuin",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 1.6387064e-5,
            offset: 0
        },
        // 1.6387064e-5 m3
        cuft: {
            name: "cuft",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.028316846592,
            offset: 0
        },
        // 28.316 846 592 L
        cuyd: {
            name: "cuyd",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.764554857984,
            offset: 0
        },
        // 764.554 857 984 L
        teaspoon: {
            name: "teaspoon",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.000005,
            offset: 0
        },
        // 5 mL
        tablespoon: {
            name: "tablespoon",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.000015,
            offset: 0
        },
        // 15 mL
        // {name: 'cup', base: BASE_UNITS.VOLUME, prefixes: PREFIXES.NONE, value: 0.000240, offset: 0}, // 240 mL  // not possible, we have already another cup
        drop: {
            name: "drop",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 5e-8,
            offset: 0
        },
        // 0.05 mL = 5e-8 m3
        gtt: {
            name: "gtt",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 5e-8,
            offset: 0
        },
        // 0.05 mL = 5e-8 m3
        // Liquid volume
        minim: {
            name: "minim",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.00000006161152,
            offset: 0
        },
        // 0.06161152 mL
        fluiddram: {
            name: "fluiddram",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0000036966911,
            offset: 0
        },
        // 3.696691 mL
        fluidounce: {
            name: "fluidounce",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.00002957353,
            offset: 0
        },
        // 29.57353 mL
        gill: {
            name: "gill",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0001182941,
            offset: 0
        },
        // 118.2941 mL
        cc: {
            name: "cc",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 1e-6,
            offset: 0
        },
        // 1e-6 L
        cup: {
            name: "cup",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0002365882,
            offset: 0
        },
        // 236.5882 mL
        pint: {
            name: "pint",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0004731765,
            offset: 0
        },
        // 473.1765 mL
        quart: {
            name: "quart",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0009463529,
            offset: 0
        },
        // 946.3529 mL
        gallon: {
            name: "gallon",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.003785412,
            offset: 0
        },
        // 3.785412 L
        beerbarrel: {
            name: "beerbarrel",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.1173478,
            offset: 0
        },
        // 117.3478 L
        oilbarrel: {
            name: "oilbarrel",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.1589873,
            offset: 0
        },
        // 158.9873 L
        hogshead: {
            name: "hogshead",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.2384810,
            offset: 0
        },
        // 238.4810 L
        // {name: 'min', base: BASE_UNITS.VOLUME, prefixes: PREFIXES.NONE, value: 0.00000006161152, offset: 0}, // 0.06161152 mL // min is already in use as minute
        fldr: {
            name: "fldr",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0000036966911,
            offset: 0
        },
        // 3.696691 mL
        floz: {
            name: "floz",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.00002957353,
            offset: 0
        },
        // 29.57353 mL
        gi: {
            name: "gi",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0001182941,
            offset: 0
        },
        // 118.2941 mL
        cp: {
            name: "cp",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0002365882,
            offset: 0
        },
        // 236.5882 mL
        pt: {
            name: "pt",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0004731765,
            offset: 0
        },
        // 473.1765 mL
        qt: {
            name: "qt",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.0009463529,
            offset: 0
        },
        // 946.3529 mL
        gal: {
            name: "gal",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.003785412,
            offset: 0
        },
        // 3.785412 L
        bbl: {
            name: "bbl",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.1173478,
            offset: 0
        },
        // 117.3478 L
        obl: {
            name: "obl",
            base: BASE_UNITS.VOLUME,
            prefixes: PREFIXES.NONE,
            value: 0.1589873,
            offset: 0
        },
        // 158.9873 L
        // {name: 'hogshead', base: BASE_UNITS.VOLUME, prefixes: PREFIXES.NONE, value: 0.2384810, offset: 0}, // 238.4810 L // TODO: hh?
        // Mass
        g: {
            name: "g",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.SHORT,
            value: 0.001,
            offset: 0
        },
        gram: {
            name: "gram",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.LONG,
            value: 0.001,
            offset: 0
        },
        ton: {
            name: "ton",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.SHORT,
            value: 907.18474,
            offset: 0
        },
        t: {
            name: "t",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.SHORT,
            value: 1000,
            offset: 0
        },
        tonne: {
            name: "tonne",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.LONG,
            value: 1000,
            offset: 0
        },
        grain: {
            name: "grain",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 64.79891e-6,
            offset: 0
        },
        dram: {
            name: "dram",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 1.7718451953125e-3,
            offset: 0
        },
        ounce: {
            name: "ounce",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 28.349523125e-3,
            offset: 0
        },
        poundmass: {
            name: "poundmass",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 453.59237e-3,
            offset: 0
        },
        hundredweight: {
            name: "hundredweight",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 45.359237,
            offset: 0
        },
        stick: {
            name: "stick",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 115e-3,
            offset: 0
        },
        stone: {
            name: "stone",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 6.35029318,
            offset: 0
        },
        gr: {
            name: "gr",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 64.79891e-6,
            offset: 0
        },
        dr: {
            name: "dr",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 1.7718451953125e-3,
            offset: 0
        },
        oz: {
            name: "oz",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 28.349523125e-3,
            offset: 0
        },
        lbm: {
            name: "lbm",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 453.59237e-3,
            offset: 0
        },
        cwt: {
            name: "cwt",
            base: BASE_UNITS.MASS,
            prefixes: PREFIXES.NONE,
            value: 45.359237,
            offset: 0
        },
        // Time
        s: {
            name: "s",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        min: {
            name: "min",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 60,
            offset: 0
        },
        h: {
            name: "h",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 3600,
            offset: 0
        },
        second: {
            name: "second",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        sec: {
            name: "sec",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        minute: {
            name: "minute",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 60,
            offset: 0
        },
        hour: {
            name: "hour",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 3600,
            offset: 0
        },
        day: {
            name: "day",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 86400,
            offset: 0
        },
        week: {
            name: "week",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 604800,
            offset: 0
        },
        month: {
            name: "month",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 2629800,
            // 1/12th of Julian year
            offset: 0
        },
        year: {
            name: "year",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 31557600,
            // Julian year
            offset: 0
        },
        decade: {
            name: "decade",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 315576000,
            // Julian decade
            offset: 0
        },
        century: {
            name: "century",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 3155760000,
            // Julian century
            offset: 0
        },
        millennium: {
            name: "millennium",
            base: BASE_UNITS.TIME,
            prefixes: PREFIXES.NONE,
            value: 31557600000,
            // Julian millennium
            offset: 0
        },
        // Frequency
        hertz: {
            name: "Hertz",
            base: BASE_UNITS.FREQUENCY,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0,
            reciprocal: true
        },
        Hz: {
            name: "Hz",
            base: BASE_UNITS.FREQUENCY,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0,
            reciprocal: true
        },
        // Angle
        rad: {
            name: "rad",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        radian: {
            name: "radian",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        // deg = rad / (2*pi) * 360 = rad / 0.017453292519943295769236907684888
        deg: {
            name: "deg",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.SHORT,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        degree: {
            name: "degree",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.LONG,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        // grad = rad / (2*pi) * 400  = rad / 0.015707963267948966192313216916399
        grad: {
            name: "grad",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.SHORT,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        gradian: {
            name: "gradian",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.LONG,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        // cycle = rad / (2*pi) = rad / 6.2831853071795864769252867665793
        cycle: {
            name: "cycle",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.NONE,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        // arcsec = rad / (3600 * (360 / 2 * pi)) = rad / 0.0000048481368110953599358991410235795
        arcsec: {
            name: "arcsec",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.NONE,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        // arcmin = rad / (60 * (360 / 2 * pi)) = rad / 0.00029088820866572159615394846141477
        arcmin: {
            name: "arcmin",
            base: BASE_UNITS.ANGLE,
            prefixes: PREFIXES.NONE,
            value: null,
            // will be filled in by calculateAngleValues()
            offset: 0
        },
        // Electric current
        A: {
            name: "A",
            base: BASE_UNITS.CURRENT,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        ampere: {
            name: "ampere",
            base: BASE_UNITS.CURRENT,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        // Temperature
        // K(C) = °C + 273.15
        // K(F) = (°F + 459.67) / 1.8
        // K(R) = °R / 1.8
        K: {
            name: "K",
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.NONE,
            value: 1,
            offset: 0
        },
        degC: {
            name: "degC",
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.NONE,
            value: 1,
            offset: 273.15
        },
        degF: {
            name: "degF",
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.NONE,
            value: 1 / 1.8,
            offset: 459.67
        },
        degR: {
            name: "degR",
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.NONE,
            value: 1 / 1.8,
            offset: 0
        },
        kelvin: {
            name: "kelvin",
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.NONE,
            value: 1,
            offset: 0
        },
        celsius: {
            name: "celsius",
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.NONE,
            value: 1,
            offset: 273.15
        },
        fahrenheit: {
            name: "fahrenheit",
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.NONE,
            value: 1 / 1.8,
            offset: 459.67
        },
        rankine: {
            name: "rankine",
            base: BASE_UNITS.TEMPERATURE,
            prefixes: PREFIXES.NONE,
            value: 1 / 1.8,
            offset: 0
        },
        // amount of substance
        mol: {
            name: "mol",
            base: BASE_UNITS.AMOUNT_OF_SUBSTANCE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        mole: {
            name: "mole",
            base: BASE_UNITS.AMOUNT_OF_SUBSTANCE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        // luminous intensity
        cd: {
            name: "cd",
            base: BASE_UNITS.LUMINOUS_INTENSITY,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        candela: {
            name: "candela",
            base: BASE_UNITS.LUMINOUS_INTENSITY,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        // TODO: units STERADIAN
        // {name: 'sr', base: BASE_UNITS.STERADIAN, prefixes: PREFIXES.NONE, value: 1, offset: 0},
        // {name: 'steradian', base: BASE_UNITS.STERADIAN, prefixes: PREFIXES.NONE, value: 1, offset: 0},
        // Force
        N: {
            name: "N",
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        newton: {
            name: "newton",
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        dyn: {
            name: "dyn",
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.SHORT,
            value: 0.00001,
            offset: 0
        },
        dyne: {
            name: "dyne",
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.LONG,
            value: 0.00001,
            offset: 0
        },
        lbf: {
            name: "lbf",
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.NONE,
            value: 4.4482216152605,
            offset: 0
        },
        poundforce: {
            name: "poundforce",
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.NONE,
            value: 4.4482216152605,
            offset: 0
        },
        kip: {
            name: "kip",
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.LONG,
            value: 4448.2216,
            offset: 0
        },
        kilogramforce: {
            name: "kilogramforce",
            base: BASE_UNITS.FORCE,
            prefixes: PREFIXES.NONE,
            value: 9.80665,
            offset: 0
        },
        // Energy
        J: {
            name: "J",
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        joule: {
            name: "joule",
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        erg: {
            name: "erg",
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.NONE,
            value: 1e-7,
            offset: 0
        },
        Wh: {
            name: "Wh",
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.SHORT,
            value: 3600,
            offset: 0
        },
        BTU: {
            name: "BTU",
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.BTU,
            value: 1055.05585262,
            offset: 0
        },
        eV: {
            name: "eV",
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.SHORT,
            value: 1.602176565e-19,
            offset: 0
        },
        electronvolt: {
            name: "electronvolt",
            base: BASE_UNITS.ENERGY,
            prefixes: PREFIXES.LONG,
            value: 1.602176565e-19,
            offset: 0
        },
        // Power
        W: {
            name: "W",
            base: BASE_UNITS.POWER,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        watt: {
            name: "watt",
            base: BASE_UNITS.POWER,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        hp: {
            name: "hp",
            base: BASE_UNITS.POWER,
            prefixes: PREFIXES.NONE,
            value: 745.6998715386,
            offset: 0
        },
        // Electrical power units
        VAR: {
            name: "VAR",
            base: BASE_UNITS.POWER,
            prefixes: PREFIXES.SHORT,
            value: Complex.I,
            offset: 0
        },
        VA: {
            name: "VA",
            base: BASE_UNITS.POWER,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Pressure
        Pa: {
            name: "Pa",
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        psi: {
            name: "psi",
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.NONE,
            value: 6894.75729276459,
            offset: 0
        },
        atm: {
            name: "atm",
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.NONE,
            value: 101325,
            offset: 0
        },
        bar: {
            name: "bar",
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.SHORTLONG,
            value: 100000,
            offset: 0
        },
        torr: {
            name: "torr",
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.NONE,
            value: 133.322,
            offset: 0
        },
        mmHg: {
            name: "mmHg",
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.NONE,
            value: 133.322,
            offset: 0
        },
        mmH2O: {
            name: "mmH2O",
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.NONE,
            value: 9.80665,
            offset: 0
        },
        cmH2O: {
            name: "cmH2O",
            base: BASE_UNITS.PRESSURE,
            prefixes: PREFIXES.NONE,
            value: 98.0665,
            offset: 0
        },
        // Electric charge
        coulomb: {
            name: "coulomb",
            base: BASE_UNITS.ELECTRIC_CHARGE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        C: {
            name: "C",
            base: BASE_UNITS.ELECTRIC_CHARGE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Electric capacitance
        farad: {
            name: "farad",
            base: BASE_UNITS.ELECTRIC_CAPACITANCE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        F: {
            name: "F",
            base: BASE_UNITS.ELECTRIC_CAPACITANCE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Electric potential
        volt: {
            name: "volt",
            base: BASE_UNITS.ELECTRIC_POTENTIAL,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        V: {
            name: "V",
            base: BASE_UNITS.ELECTRIC_POTENTIAL,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Electric resistance
        ohm: {
            name: "ohm",
            base: BASE_UNITS.ELECTRIC_RESISTANCE,
            prefixes: PREFIXES.SHORTLONG,
            // Both Mohm and megaohm are acceptable
            value: 1,
            offset: 0
        },
        /*
     * Unicode breaks in browsers if charset is not specified
    Ω: {
      name: 'Ω',
      base: BASE_UNITS.ELECTRIC_RESISTANCE,
      prefixes: PREFIXES.SHORT,
      value: 1,
      offset: 0
    },
    */ // Electric inductance
        henry: {
            name: "henry",
            base: BASE_UNITS.ELECTRIC_INDUCTANCE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        H: {
            name: "H",
            base: BASE_UNITS.ELECTRIC_INDUCTANCE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Electric conductance
        siemens: {
            name: "siemens",
            base: BASE_UNITS.ELECTRIC_CONDUCTANCE,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        S: {
            name: "S",
            base: BASE_UNITS.ELECTRIC_CONDUCTANCE,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Magnetic flux
        weber: {
            name: "weber",
            base: BASE_UNITS.MAGNETIC_FLUX,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        Wb: {
            name: "Wb",
            base: BASE_UNITS.MAGNETIC_FLUX,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Magnetic flux density
        tesla: {
            name: "tesla",
            base: BASE_UNITS.MAGNETIC_FLUX_DENSITY,
            prefixes: PREFIXES.LONG,
            value: 1,
            offset: 0
        },
        T: {
            name: "T",
            base: BASE_UNITS.MAGNETIC_FLUX_DENSITY,
            prefixes: PREFIXES.SHORT,
            value: 1,
            offset: 0
        },
        // Binary
        b: {
            name: "b",
            base: BASE_UNITS.BIT,
            prefixes: PREFIXES.BINARY_SHORT,
            value: 1,
            offset: 0
        },
        bits: {
            name: "bits",
            base: BASE_UNITS.BIT,
            prefixes: PREFIXES.BINARY_LONG,
            value: 1,
            offset: 0
        },
        B: {
            name: "B",
            base: BASE_UNITS.BIT,
            prefixes: PREFIXES.BINARY_SHORT,
            value: 8,
            offset: 0
        },
        bytes: {
            name: "bytes",
            base: BASE_UNITS.BIT,
            prefixes: PREFIXES.BINARY_LONG,
            value: 8,
            offset: 0
        }
    }; // aliases (formerly plurals)
    var ALIASES = {
        meters: "meter",
        inches: "inch",
        feet: "foot",
        yards: "yard",
        miles: "mile",
        links: "link",
        rods: "rod",
        chains: "chain",
        angstroms: "angstrom",
        lt: "l",
        litres: "litre",
        liter: "litre",
        liters: "litre",
        teaspoons: "teaspoon",
        tablespoons: "tablespoon",
        minims: "minim",
        fluiddrams: "fluiddram",
        fluidounces: "fluidounce",
        gills: "gill",
        cups: "cup",
        pints: "pint",
        quarts: "quart",
        gallons: "gallon",
        beerbarrels: "beerbarrel",
        oilbarrels: "oilbarrel",
        hogsheads: "hogshead",
        gtts: "gtt",
        grams: "gram",
        tons: "ton",
        tonnes: "tonne",
        grains: "grain",
        drams: "dram",
        ounces: "ounce",
        poundmasses: "poundmass",
        hundredweights: "hundredweight",
        sticks: "stick",
        lb: "lbm",
        lbs: "lbm",
        kips: "kip",
        kgf: "kilogramforce",
        acres: "acre",
        hectares: "hectare",
        sqfeet: "sqft",
        sqyard: "sqyd",
        sqmile: "sqmi",
        sqmiles: "sqmi",
        mmhg: "mmHg",
        mmh2o: "mmH2O",
        cmh2o: "cmH2O",
        seconds: "second",
        secs: "second",
        minutes: "minute",
        mins: "minute",
        hours: "hour",
        hr: "hour",
        hrs: "hour",
        days: "day",
        weeks: "week",
        months: "month",
        years: "year",
        decades: "decade",
        centuries: "century",
        millennia: "millennium",
        hertz: "hertz",
        radians: "radian",
        degrees: "degree",
        gradians: "gradian",
        cycles: "cycle",
        arcsecond: "arcsec",
        arcseconds: "arcsec",
        arcminute: "arcmin",
        arcminutes: "arcmin",
        BTUs: "BTU",
        watts: "watt",
        joules: "joule",
        amperes: "ampere",
        coulombs: "coulomb",
        volts: "volt",
        ohms: "ohm",
        farads: "farad",
        webers: "weber",
        teslas: "tesla",
        electronvolts: "electronvolt",
        moles: "mole",
        bit: "bits",
        byte: "bytes"
    };
    /**
   * Calculate the values for the angle units.
   * Value is calculated as number or BigNumber depending on the configuration
   * @param {{number: 'number' | 'BigNumber'}} config
   */ function calculateAngleValues(config) {
        if (config.number === "BigNumber") {
            var pi = (0, $40ac173b3ca35861$export$d0a8190d955e3c5b)(_BigNumber);
            UNITS.rad.value = new _BigNumber(1);
            UNITS.deg.value = pi.div(180); // 2 * pi / 360
            UNITS.grad.value = pi.div(200); // 2 * pi / 400
            UNITS.cycle.value = pi.times(2); // 2 * pi
            UNITS.arcsec.value = pi.div(648000); // 2 * pi / 360 / 3600
            UNITS.arcmin.value = pi.div(10800); // 2 * pi / 360 / 60
        } else {
            // number
            UNITS.rad.value = 1;
            UNITS.deg.value = Math.PI / 180; // 2 * pi / 360
            UNITS.grad.value = Math.PI / 200; // 2 * pi / 400
            UNITS.cycle.value = Math.PI * 2; // 2 * pi
            UNITS.arcsec.value = Math.PI / 648000; // 2 * pi / 360 / 3600
            UNITS.arcmin.value = Math.PI / 10800; // 2 * pi / 360 / 60
        } // copy to the full names of the angles
        UNITS.radian.value = UNITS.rad.value;
        UNITS.degree.value = UNITS.deg.value;
        UNITS.gradian.value = UNITS.grad.value;
    } // apply the angle values now
    calculateAngleValues(config);
    if (on) // recalculate the values on change of configuration
    on("config", function(curr, prev) {
        if (curr.number !== prev.number) calculateAngleValues(curr);
    });
    /**
   * A unit system is a set of dimensionally independent base units plus a set of derived units, formed by multiplication and division of the base units, that are by convention used with the unit system.
   * A user perhaps could issue a command to select a preferred unit system, or use the default (see below).
   * Auto unit system: The default unit system is updated on the fly anytime a unit is parsed. The corresponding unit in the default unit system is updated, so that answers are given in the same units the user supplies.
   */ var UNIT_SYSTEMS = {
        si: {
            // Base units
            NONE: {
                unit: UNIT_NONE,
                prefix: PREFIXES.NONE[""]
            },
            LENGTH: {
                unit: UNITS.m,
                prefix: PREFIXES.SHORT[""]
            },
            MASS: {
                unit: UNITS.g,
                prefix: PREFIXES.SHORT.k
            },
            TIME: {
                unit: UNITS.s,
                prefix: PREFIXES.SHORT[""]
            },
            CURRENT: {
                unit: UNITS.A,
                prefix: PREFIXES.SHORT[""]
            },
            TEMPERATURE: {
                unit: UNITS.K,
                prefix: PREFIXES.SHORT[""]
            },
            LUMINOUS_INTENSITY: {
                unit: UNITS.cd,
                prefix: PREFIXES.SHORT[""]
            },
            AMOUNT_OF_SUBSTANCE: {
                unit: UNITS.mol,
                prefix: PREFIXES.SHORT[""]
            },
            ANGLE: {
                unit: UNITS.rad,
                prefix: PREFIXES.SHORT[""]
            },
            BIT: {
                unit: UNITS.bits,
                prefix: PREFIXES.SHORT[""]
            },
            // Derived units
            FORCE: {
                unit: UNITS.N,
                prefix: PREFIXES.SHORT[""]
            },
            ENERGY: {
                unit: UNITS.J,
                prefix: PREFIXES.SHORT[""]
            },
            POWER: {
                unit: UNITS.W,
                prefix: PREFIXES.SHORT[""]
            },
            PRESSURE: {
                unit: UNITS.Pa,
                prefix: PREFIXES.SHORT[""]
            },
            ELECTRIC_CHARGE: {
                unit: UNITS.C,
                prefix: PREFIXES.SHORT[""]
            },
            ELECTRIC_CAPACITANCE: {
                unit: UNITS.F,
                prefix: PREFIXES.SHORT[""]
            },
            ELECTRIC_POTENTIAL: {
                unit: UNITS.V,
                prefix: PREFIXES.SHORT[""]
            },
            ELECTRIC_RESISTANCE: {
                unit: UNITS.ohm,
                prefix: PREFIXES.SHORT[""]
            },
            ELECTRIC_INDUCTANCE: {
                unit: UNITS.H,
                prefix: PREFIXES.SHORT[""]
            },
            ELECTRIC_CONDUCTANCE: {
                unit: UNITS.S,
                prefix: PREFIXES.SHORT[""]
            },
            MAGNETIC_FLUX: {
                unit: UNITS.Wb,
                prefix: PREFIXES.SHORT[""]
            },
            MAGNETIC_FLUX_DENSITY: {
                unit: UNITS.T,
                prefix: PREFIXES.SHORT[""]
            },
            FREQUENCY: {
                unit: UNITS.Hz,
                prefix: PREFIXES.SHORT[""]
            }
        }
    }; // Clone to create the other unit systems
    UNIT_SYSTEMS.cgs = JSON.parse(JSON.stringify(UNIT_SYSTEMS.si));
    UNIT_SYSTEMS.cgs.LENGTH = {
        unit: UNITS.m,
        prefix: PREFIXES.SHORT.c
    };
    UNIT_SYSTEMS.cgs.MASS = {
        unit: UNITS.g,
        prefix: PREFIXES.SHORT[""]
    };
    UNIT_SYSTEMS.cgs.FORCE = {
        unit: UNITS.dyn,
        prefix: PREFIXES.SHORT[""]
    };
    UNIT_SYSTEMS.cgs.ENERGY = {
        unit: UNITS.erg,
        prefix: PREFIXES.NONE[""]
    }; // there are wholly 4 unique cgs systems for electricity and magnetism,
    // so let's not worry about it unless somebody complains
    UNIT_SYSTEMS.us = JSON.parse(JSON.stringify(UNIT_SYSTEMS.si));
    UNIT_SYSTEMS.us.LENGTH = {
        unit: UNITS.ft,
        prefix: PREFIXES.NONE[""]
    };
    UNIT_SYSTEMS.us.MASS = {
        unit: UNITS.lbm,
        prefix: PREFIXES.NONE[""]
    };
    UNIT_SYSTEMS.us.TEMPERATURE = {
        unit: UNITS.degF,
        prefix: PREFIXES.NONE[""]
    };
    UNIT_SYSTEMS.us.FORCE = {
        unit: UNITS.lbf,
        prefix: PREFIXES.NONE[""]
    };
    UNIT_SYSTEMS.us.ENERGY = {
        unit: UNITS.BTU,
        prefix: PREFIXES.BTU[""]
    };
    UNIT_SYSTEMS.us.POWER = {
        unit: UNITS.hp,
        prefix: PREFIXES.NONE[""]
    };
    UNIT_SYSTEMS.us.PRESSURE = {
        unit: UNITS.psi,
        prefix: PREFIXES.NONE[""]
    }; // Add additional unit systems here.
    // Choose a unit system to seed the auto unit system.
    UNIT_SYSTEMS.auto = JSON.parse(JSON.stringify(UNIT_SYSTEMS.si)); // Set the current unit system
    var currentUnitSystem = UNIT_SYSTEMS.auto;
    /**
   * Set a unit system for formatting derived units.
   * @param {string} [name] The name of the unit system.
   */ Unit.setUnitSystem = function(name) {
        if ((0, $6819694788cbfa38$export$5a15a386532a5ea4)(UNIT_SYSTEMS, name)) currentUnitSystem = UNIT_SYSTEMS[name];
        else throw new Error("Unit system " + name + " does not exist. Choices are: " + Object.keys(UNIT_SYSTEMS).join(", "));
    };
    /**
   * Return the current unit system.
   * @return {string} The current unit system.
   */ Unit.getUnitSystem = function() {
        for(var _key in UNIT_SYSTEMS)if ((0, $6819694788cbfa38$export$5a15a386532a5ea4)(UNIT_SYSTEMS, _key)) {
            if (UNIT_SYSTEMS[_key] === currentUnitSystem) return _key;
        }
    };
    /**
   * Converters to convert from number to an other numeric type like BigNumber
   * or Fraction
   */ Unit.typeConverters = {
        BigNumber: function BigNumber(x) {
            return new _BigNumber(x + ""); // stringify to prevent constructor error
        },
        Fraction: function Fraction(x) {
            return new _Fraction(x);
        },
        Complex: function Complex(x) {
            return x;
        },
        number: function number(x) {
            return x;
        }
    };
    /**
   * Retrieve the right convertor function corresponding with the type
   * of provided exampleValue.
   *
   * @param {string} type   A string 'number', 'BigNumber', or 'Fraction'
   *                        In case of an unknown type,
   * @return {Function}
   */ Unit._getNumberConverter = function(type) {
        if (!Unit.typeConverters[type]) throw new TypeError('Unsupported type "' + type + '"');
        return Unit.typeConverters[type];
    }; // Add dimensions to each built-in unit
    for(var _key2 in UNITS)if ((0, $6819694788cbfa38$export$5a15a386532a5ea4)(UNITS, _key2)) {
        var unit = UNITS[_key2];
        unit.dimensions = unit.base.dimensions;
    }
     // Create aliases
    for(var _name2 in ALIASES)if ((0, $6819694788cbfa38$export$5a15a386532a5ea4)(ALIASES, _name2)) {
        var _unit2 = UNITS[ALIASES[_name2]];
        var alias = {};
        for(var _key3 in _unit2)if ((0, $6819694788cbfa38$export$5a15a386532a5ea4)(_unit2, _key3)) alias[_key3] = _unit2[_key3];
        alias.name = _name2;
        UNITS[_name2] = alias;
    }
    /**
   * Checks if a character is a valid latin letter (upper or lower case).
   * Note that this function can be overridden, for example to allow support of other alphabets.
   * @param {string} c Tested character
   */ Unit.isValidAlpha = function isValidAlpha(c) {
        return /^[a-zA-Z]$/.test(c);
    };
    function assertUnitNameIsValid(name) {
        for(var i = 0; i < name.length; i++){
            c = name.charAt(i);
            if (i === 0 && !Unit.isValidAlpha(c)) throw new Error('Invalid unit name (must begin with alpha character): "' + name + '"');
            if (i > 0 && !(Unit.isValidAlpha(c) || isDigit(c))) throw new Error('Invalid unit name (only alphanumeric characters are allowed): "' + name + '"');
        }
    }
    /**
   * Wrapper around createUnitSingle.
   * Example:
   *  createUnit({
   *    foo: { },
   *    bar: {
   *      definition: 'kg/foo',
   *      aliases: ['ba', 'barr', 'bars'],
   *      offset: 200
   *    },
   *    baz: '4 bar'
   *  },
   *  {
   *    override: true
   *  })
   * @param {object} obj      Object map. Each key becomes a unit which is defined by its value.
   * @param {object} options
   */ Unit.createUnit = function(obj, options) {
        if (typeof obj !== "object") throw new TypeError("createUnit expects first parameter to be of type 'Object'");
         // Remove all units and aliases we are overriding
        if (options && options.override) for(var _key4 in obj){
            if ((0, $6819694788cbfa38$export$5a15a386532a5ea4)(obj, _key4)) Unit.deleteUnit(_key4);
            if (obj[_key4].aliases) for(var i = 0; i < obj[_key4].aliases.length; i++)Unit.deleteUnit(obj[_key4].aliases[i]);
        }
         // TODO: traverse multiple times until all units have been added
        var lastUnit;
        for(var _key5 in obj)if ((0, $6819694788cbfa38$export$5a15a386532a5ea4)(obj, _key5)) lastUnit = Unit.createUnitSingle(_key5, obj[_key5]);
        return lastUnit;
    };
    /**
   * Create a user-defined unit and register it with the Unit type.
   * Example:
   *  createUnitSingle('knot', '0.514444444 m/s')
   *  createUnitSingle('acre', new Unit(43560, 'ft^2'))
   *
   * @param {string} name      The name of the new unit. Must be unique. Example: 'knot'
   * @param {string, Unit, Object} definition      Definition of the unit in terms
   * of existing units. For example, '0.514444444 m / s'. Can be a Unit, a string,
   * or an Object. If an Object, may have the following properties:
   *   - definition {string|Unit} The definition of this unit.
   *   - prefixes {string} "none", "short", "long", "binary_short", or "binary_long".
   *     The default is "none".
   *   - aliases {Array} Array of strings. Example: ['knots', 'kt', 'kts']
   *   - offset {Numeric} An offset to apply when converting from the unit. For
   *     example, the offset for celsius is 273.15 and the offset for farhenheit
   *     is 459.67. Default is 0.
   *   - baseName {string} If the unit's dimension does not match that of any other
   *     base unit, the name of the newly create base unit. Otherwise, this property
   *     has no effect.
   *
   * @param {Object} options   (optional) An object containing any of the following
   * properties:
   *   - override {boolean} Whether this unit should be allowed to override existing
   *     units.
   *
   * @return {Unit}
   */ Unit.createUnitSingle = function(name, obj, options) {
        if (typeof obj === "undefined" || obj === null) obj = {};
        if (typeof name !== "string") throw new TypeError("createUnitSingle expects first parameter to be of type 'string'");
         // Check collisions with existing units
        if ((0, $6819694788cbfa38$export$5a15a386532a5ea4)(UNITS, name)) throw new Error('Cannot create unit "' + name + '": a unit with that name already exists');
         // TODO: Validate name for collisions with other built-in functions (like abs or cos, for example), and for acceptable variable names. For example, '42' is probably not a valid unit. Nor is '%', since it is also an operator.
        assertUnitNameIsValid(name);
        var defUnit = null; // The Unit from which the new unit will be created.
        var aliases = [];
        var offset = 0;
        var definition;
        var prefixes;
        var baseName;
        if (obj && obj.type === "Unit") defUnit = obj.clone();
        else if (typeof obj === "string") {
            if (obj !== "") definition = obj;
        } else if (typeof obj === "object") {
            definition = obj.definition;
            prefixes = obj.prefixes;
            offset = obj.offset;
            baseName = obj.baseName;
            if (obj.aliases) aliases = obj.aliases.valueOf(); // aliases could be a Matrix, so convert to Array
        } else throw new TypeError('Cannot create unit "' + name + '" from "' + obj.toString() + '": expecting "string" or "Unit" or "Object"');
        if (aliases) for(var i = 0; i < aliases.length; i++){
            if ((0, $6819694788cbfa38$export$5a15a386532a5ea4)(UNITS, aliases[i])) throw new Error('Cannot create alias "' + aliases[i] + '": a unit with that name already exists');
        }
        if (definition && typeof definition === "string" && !defUnit) try {
            defUnit = Unit.parse(definition, {
                allowNoUnits: true
            });
        } catch (ex) {
            ex.message = 'Could not create unit "' + name + '" from "' + definition + '": ' + ex.message;
            throw ex;
        }
        else if (definition && definition.type === "Unit") defUnit = definition.clone();
        aliases = aliases || [];
        offset = offset || 0;
        if (prefixes && prefixes.toUpperCase) prefixes = PREFIXES[prefixes.toUpperCase()] || PREFIXES.NONE;
        else prefixes = PREFIXES.NONE;
         // If defUnit is null, it is because the user did not
        // specify a defintion. So create a new base dimension.
        var newUnit = {};
        if (!defUnit) {
            // Add a new base dimension
            baseName = baseName || name + "_STUFF"; // foo --> foo_STUFF, or the essence of foo
            if (BASE_DIMENSIONS.indexOf(baseName) >= 0) throw new Error('Cannot create new base unit "' + name + '": a base unit with that name already exists (and cannot be overridden)');
            BASE_DIMENSIONS.push(baseName); // Push 0 onto existing base units
            for(var b in BASE_UNITS)if ((0, $6819694788cbfa38$export$5a15a386532a5ea4)(BASE_UNITS, b)) BASE_UNITS[b].dimensions[BASE_DIMENSIONS.length - 1] = 0;
             // Add the new base unit
            var newBaseUnit = {
                dimensions: []
            };
            for(var _i6 = 0; _i6 < BASE_DIMENSIONS.length; _i6++)newBaseUnit.dimensions[_i6] = 0;
            newBaseUnit.dimensions[BASE_DIMENSIONS.length - 1] = 1;
            newBaseUnit.key = baseName;
            BASE_UNITS[baseName] = newBaseUnit;
            newUnit = {
                name: name,
                value: 1,
                dimensions: BASE_UNITS[baseName].dimensions.slice(0),
                prefixes: prefixes,
                offset: offset,
                base: BASE_UNITS[baseName]
            };
            currentUnitSystem[baseName] = {
                unit: newUnit,
                prefix: PREFIXES.NONE[""]
            };
        } else {
            newUnit = {
                name: name,
                value: defUnit.value,
                dimensions: defUnit.dimensions.slice(0),
                prefixes: prefixes,
                offset: offset
            }; // Create a new base if no matching base exists
            var anyMatch = false;
            for(var _i7 in BASE_UNITS)if ((0, $6819694788cbfa38$export$5a15a386532a5ea4)(BASE_UNITS, _i7)) {
                var match = true;
                for(var j = 0; j < BASE_DIMENSIONS.length; j++)if (Math.abs((newUnit.dimensions[j] || 0) - (BASE_UNITS[_i7].dimensions[j] || 0)) > 1e-12) {
                    match = false;
                    break;
                }
                if (match) {
                    anyMatch = true;
                    newUnit.base = BASE_UNITS[_i7];
                    break;
                }
            }
            if (!anyMatch) {
                baseName = baseName || name + "_STUFF"; // foo --> foo_STUFF, or the essence of foo
                // Add the new base unit
                var _newBaseUnit = {
                    dimensions: defUnit.dimensions.slice(0)
                };
                _newBaseUnit.key = baseName;
                BASE_UNITS[baseName] = _newBaseUnit;
                currentUnitSystem[baseName] = {
                    unit: newUnit,
                    prefix: PREFIXES.NONE[""]
                };
                newUnit.base = BASE_UNITS[baseName];
            }
        }
        Unit.UNITS[name] = newUnit;
        for(var _i8 = 0; _i8 < aliases.length; _i8++){
            var aliasName = aliases[_i8];
            var _alias = {};
            for(var _key6 in newUnit)if ((0, $6819694788cbfa38$export$5a15a386532a5ea4)(newUnit, _key6)) _alias[_key6] = newUnit[_key6];
            _alias.name = aliasName;
            Unit.UNITS[aliasName] = _alias;
        } // delete the memoization cache, since adding a new unit to the array
        // invalidates all old results
        delete _findUnit.cache;
        return new Unit(null, name);
    };
    Unit.deleteUnit = function(name) {
        delete Unit.UNITS[name];
    }; // expose arrays with prefixes, dimensions, units, systems
    Unit.PREFIXES = PREFIXES;
    Unit.BASE_DIMENSIONS = BASE_DIMENSIONS;
    Unit.BASE_UNITS = BASE_UNITS;
    Unit.UNIT_SYSTEMS = UNIT_SYSTEMS;
    Unit.UNITS = UNITS;
    return Unit;
}, {
    isClass: true
});


var $1ce9cae43880ed35$var$name = "createUnit";
var $1ce9cae43880ed35$var$dependencies = [
    "typed",
    "Unit"
];
var $1ce9cae43880ed35$export$27641941eb5cadbb = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($1ce9cae43880ed35$var$name, $1ce9cae43880ed35$var$dependencies, (_ref)=>{
    var { typed: typed, Unit: Unit } = _ref;
    /**
   * Create a user-defined unit and register it with the Unit type.
   *
   * Syntax:
   *
   *     math.createUnit({
   *       baseUnit1: {
   *         aliases: [string, ...]
   *         prefixes: object
   *       },
   *       unit2: {
   *         definition: string,
   *         aliases: [string, ...]
   *         prefixes: object,
   *         offset: number
   *       },
   *       unit3: string    // Shortcut
   *     })
   *
   *     // Another shortcut:
   *     math.createUnit(string, unit : string, [object])
   *
   * Examples:
   *
   *     math.createUnit('foo')
   *     math.createUnit('knot', {definition: '0.514444444 m/s', aliases: ['knots', 'kt', 'kts']})
   *     math.createUnit('mph', '1 mile/hour')
   *
   * @param {string} name      The name of the new unit. Must be unique. Example: 'knot'
   * @param {string, Unit} definition      Definition of the unit in terms of existing units. For example, '0.514444444 m / s'.
   * @param {Object} options   (optional) An object containing any of the following properties:
   *     - `prefixes {string}` "none", "short", "long", "binary_short", or "binary_long". The default is "none".
   *     - `aliases {Array}` Array of strings. Example: ['knots', 'kt', 'kts']
   *     - `offset {Numeric}` An offset to apply when converting from the unit. For example, the offset for celsius is 273.15. Default is 0.
   *
   * See also:
   *
   *     unit
   *
   * @return {Unit} The new unit
   */ return typed($1ce9cae43880ed35$var$name, {
        // General function signature. First parameter is an object where each property is the definition of a new unit. The object keys are the unit names and the values are the definitions. The values can be objects, strings, or Units. If a property is an empty object or an empty string, a new base unit is created. The second parameter is the options.
        "Object, Object": function ObjectObject(obj, options) {
            return Unit.createUnit(obj, options);
        },
        // Same as above but without the options.
        Object: function Object(obj) {
            return Unit.createUnit(obj, {});
        },
        // Shortcut method for creating one unit.
        "string, Unit | string | Object, Object": function stringUnitStringObjectObject(name, def, options) {
            var obj = {};
            obj[name] = def;
            return Unit.createUnit(obj, options);
        },
        // Same as above but without the options.
        "string, Unit | string | Object": function stringUnitStringObject(name, def) {
            var obj = {};
            obj[name] = def;
            return Unit.createUnit(obj, {});
        },
        // Without a definition, creates a base unit.
        string: function string(name) {
            var obj = {};
            obj[name] = {};
            return Unit.createUnit(obj, {});
        }
    });
});








var $344ee122e154a1a5$var$name = "dotPow";
var $344ee122e154a1a5$var$dependencies = [
    "typed",
    "equalScalar",
    "matrix",
    "pow",
    "DenseMatrix"
];
var $344ee122e154a1a5$export$734b49568d8effd6 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($344ee122e154a1a5$var$name, $344ee122e154a1a5$var$dependencies, (_ref)=>{
    var { typed: typed, equalScalar: equalScalar, matrix: matrix, pow: pow, DenseMatrix: DenseMatrix } = _ref;
    var algorithm03 = (0, $523b807a911c3d38$export$486bb900f1a3c833)({
        typed: typed
    });
    var algorithm07 = (0, $5200888766c056e5$export$b908fb77c4366999)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm11 = (0, $83b92f81e511657d$export$a38279a12199d831)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm12 = (0, $500ff63908aabda9$export$806772cd23b603dc)({
        typed: typed,
        DenseMatrix: DenseMatrix
    });
    var algorithm13 = (0, $c68b38998aadcc11$export$fa05124e71a8ffb3)({
        typed: typed
    });
    var algorithm14 = (0, $533d58927c47005f$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Calculates the power of x to y element wise.
   *
   * Syntax:
   *
   *    math.dotPow(x, y)
   *
   * Examples:
   *
   *    math.dotPow(2, 3)            // returns number 8
   *
   *    const a = [[1, 2], [4, 3]]
   *    math.dotPow(a, 2)            // returns Array [[1, 4], [16, 9]]
   *    math.pow(a, 2)               // returns Array [[9, 8], [16, 17]]
   *
   * See also:
   *
   *    pow, sqrt, multiply
   *
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} x  The base
   * @param  {number | BigNumber | Complex | Unit | Array | Matrix} y  The exponent
   * @return {number | BigNumber | Complex | Unit | Array | Matrix}                     The value of `x` to the power `y`
   */ return typed($344ee122e154a1a5$var$name, {
        "any, any": pow,
        "SparseMatrix, SparseMatrix": function SparseMatrixSparseMatrix(x, y) {
            return algorithm07(x, y, pow, false);
        },
        "SparseMatrix, DenseMatrix": function SparseMatrixDenseMatrix(x, y) {
            return algorithm03(y, x, pow, true);
        },
        "DenseMatrix, SparseMatrix": function DenseMatrixSparseMatrix(x, y) {
            return algorithm03(x, y, pow, false);
        },
        "DenseMatrix, DenseMatrix": function DenseMatrixDenseMatrix(x, y) {
            return algorithm13(x, y, pow);
        },
        "Array, Array": function ArrayArray(x, y) {
            // use matrix implementation
            return this(matrix(x), matrix(y)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(x, y) {
            // use matrix implementation
            return this(matrix(x), y);
        },
        "Matrix, Array": function MatrixArray(x, y) {
            // use matrix implementation
            return this(x, matrix(y));
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm11(x, y, this, false);
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, this, false);
        },
        "any, SparseMatrix": function anySparseMatrix(x, y) {
            return algorithm12(y, x, this, true);
        },
        "any, DenseMatrix": function anyDenseMatrix(x, y) {
            return algorithm14(y, x, this, true);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, this, false).valueOf();
        },
        "any, Array": function anyArray(x, y) {
            // use matrix implementation
            return algorithm14(matrix(y), x, this, true).valueOf();
        }
    });
});




var $17cfa07a4997488f$var$name = "expm";
var $17cfa07a4997488f$var$dependencies = [
    "typed",
    "abs",
    "add",
    "identity",
    "inv",
    "multiply"
];
var $17cfa07a4997488f$export$f2c0a6357ff6cb4c = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($17cfa07a4997488f$var$name, $17cfa07a4997488f$var$dependencies, (_ref)=>{
    var { typed: typed, abs: abs, add: add, identity: identity, inv: inv, multiply: multiply } = _ref;
    /**
   * Compute the matrix exponential, expm(A) = e^A. The matrix must be square.
   * Not to be confused with exp(a), which performs element-wise
   * exponentiation.
   *
   * The exponential is calculated using the Padé approximant with scaling and
   * squaring; see "Nineteen Dubious Ways to Compute the Exponential of a
   * Matrix," by Moler and Van Loan.
   *
   * Syntax:
   *
   *     math.expm(x)
   *
   * Examples:
   *
   *     const A = [[0,2],[0,0]]
   *     math.expm(A)        // returns [[1,2],[0,1]]
   *
   * See also:
   *
   *     exp
   *
   * @param {Matrix} x  A square Matrix
   * @return {Matrix}   The exponential of x
   */ return typed($17cfa07a4997488f$var$name, {
        Matrix: function Matrix(A) {
            // Check matrix size
            var size = A.size();
            if (size.length !== 2 || size[0] !== size[1]) throw new RangeError("Matrix must be square (size: " + (0, $b94963e97c376b6d$export$d9468344d3651243)(size) + ")");
            var n = size[0]; // Desired accuracy of the approximant (The actual accuracy
            // will be affected by round-off error)
            var eps = 1e-15; // The Padé approximant is not so accurate when the values of A
            // are "large", so scale A by powers of two. Then compute the
            // exponential, and square the result repeatedly according to
            // the identity e^A = (e^(A/m))^m
            // Compute infinity-norm of A, ||A||, to see how "big" it is
            var infNorm = infinityNorm(A); // Find the optimal scaling factor and number of terms in the
            // Padé approximant to reach the desired accuracy
            var params = findParams(infNorm, eps);
            var q = params.q;
            var j = params.j; // The Pade approximation to e^A is:
            // Rqq(A) = Dqq(A) ^ -1 * Nqq(A)
            // where
            // Nqq(A) = sum(i=0, q, (2q-i)!p! / [ (2q)!i!(q-i)! ] A^i
            // Dqq(A) = sum(i=0, q, (2q-i)!q! / [ (2q)!i!(q-i)! ] (-A)^i
            // Scale A by 1 / 2^j
            var Apos = multiply(A, Math.pow(2, -j)); // The i=0 term is just the identity matrix
            var N = identity(n);
            var D = identity(n); // Initialization (i=0)
            var factor = 1; // Initialization (i=1)
            var AposToI = Apos; // Cloning not necessary
            var alternate = -1;
            for(var i = 1; i <= q; i++){
                if (i > 1) {
                    AposToI = multiply(AposToI, Apos);
                    alternate = -alternate;
                }
                factor = factor * (q - i + 1) / ((2 * q - i + 1) * i);
                N = add(N, multiply(factor, AposToI));
                D = add(D, multiply(factor * alternate, AposToI));
            }
            var R = multiply(inv(D), N); // Square j times
            for(var _i = 0; _i < j; _i++)R = multiply(R, R);
            return (0, $d8097b7a6d6e36d8$export$d508368d4da3c38a)(A) ? A.createSparseMatrix(R) : R;
        }
    });
    function infinityNorm(A) {
        var n = A.size()[0];
        var infNorm = 0;
        for(var i = 0; i < n; i++){
            var rowSum = 0;
            for(var j = 0; j < n; j++)rowSum += abs(A.get([
                i,
                j
            ]));
            infNorm = Math.max(rowSum, infNorm);
        }
        return infNorm;
    }
    /**
   * Find the best parameters for the Pade approximant given
   * the matrix norm and desired accuracy. Returns the first acceptable
   * combination in order of increasing computational load.
   */ function findParams(infNorm, eps) {
        var maxSearchSize = 30;
        for(var k = 0; k < maxSearchSize; k++)for(var q = 0; q <= k; q++){
            var j = k - q;
            if (errorEstimate(infNorm, q, j) < eps) return {
                q: q,
                j: j
            };
        }
        throw new Error("Could not find acceptable parameters to compute the matrix exponential (try increasing maxSearchSize in expm.js)");
    }
    /**
   * Returns the estimated error of the Pade approximant for the given
   * parameters.
   */ function errorEstimate(infNorm, q, j) {
        var qfac = 1;
        for(var i = 2; i <= q; i++)qfac *= i;
        var twoqfac = qfac;
        for(var _i2 = q + 1; _i2 <= 2 * q; _i2++)twoqfac *= _i2;
        var twoqp1fac = twoqfac * (2 * q + 1);
        return 8.0 * Math.pow(infNorm / Math.pow(2, j), 2 * q) * qfac * qfac / (twoqfac * twoqp1fac);
    }
});




var $a972424be30d4005$var$name = "gamma";
var $a972424be30d4005$var$dependencies = [
    "typed",
    "config",
    "multiplyScalar",
    "pow",
    "BigNumber",
    "Complex"
];
var $a972424be30d4005$export$115da31fc3cf3d15 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($a972424be30d4005$var$name, $a972424be30d4005$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, multiplyScalar: multiplyScalar, pow: pow, BigNumber: _BigNumber, Complex: _Complex } = _ref;
    /**
   * Compute the gamma function of a value using Lanczos approximation for
   * small values, and an extended Stirling approximation for large values.
   *
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.gamma(n)
   *
   * Examples:
   *
   *    math.gamma(5)       // returns 24
   *    math.gamma(-0.5)    // returns -3.5449077018110335
   *    math.gamma(math.i)  // returns -0.15494982830180973 - 0.49801566811835596i
   *
   * See also:
   *
   *    combinations, factorial, permutations
   *
   * @param {number | Array | Matrix} n   A real or complex number
   * @return {number | Array | Matrix}    The gamma of `n`
   */ return typed($a972424be30d4005$var$name, {
        number: (0, $2dcefc023d1c7c4b$export$da03a9f23c941fae),
        Complex: function Complex(n) {
            if (n.im === 0) return this(n.re);
             // Lanczos approximation doesn't work well with real part lower than 0.5
            // So reflection formula is required
            if (n.re < 0.5) {
                // Euler's reflection formula
                // gamma(1-z) * gamma(z) = PI / sin(PI * z)
                // real part of Z should not be integer [sin(PI) == 0 -> 1/0 - undefined]
                // thanks to imperfect sin implementation sin(PI * n) != 0
                // we can safely use it anyway
                var _t = new _Complex(1 - n.re, -n.im);
                var r = new _Complex(Math.PI * n.re, Math.PI * n.im);
                return new _Complex(Math.PI).div(r.sin()).div(this(_t));
            } // Lanczos approximation
            // z -= 1
            n = new _Complex(n.re - 1, n.im); // x = gammaPval[0]
            var x = new _Complex((0, $2dcefc023d1c7c4b$export$4ef5d09c80bf8d89)[0], 0); // for (i, gammaPval) in enumerate(gammaP):
            for(var i = 1; i < (0, $2dcefc023d1c7c4b$export$4ef5d09c80bf8d89).length; ++i){
                // x += gammaPval / (z + i)
                var gammaPval = new _Complex((0, $2dcefc023d1c7c4b$export$4ef5d09c80bf8d89)[i], 0);
                x = x.add(gammaPval.div(n.add(i)));
            } // t = z + gammaG + 0.5
            var t = new _Complex(n.re + (0, $2dcefc023d1c7c4b$export$c1392abb9fefd3b6) + 0.5, n.im); // y = sqrt(2 * pi) * t ** (z + 0.5) * exp(-t) * x
            var twoPiSqrt = Math.sqrt(2 * Math.PI);
            var tpow = t.pow(n.add(0.5));
            var expt = t.neg().exp(); // y = [x] * [sqrt(2 * pi)] * [t ** (z + 0.5)] * [exp(-t)]
            return x.mul(twoPiSqrt).mul(tpow).mul(expt);
        },
        BigNumber: function BigNumber(n) {
            if (n.isInteger()) return n.isNegative() || n.isZero() ? new _BigNumber(Infinity) : bigFactorial(n.minus(1));
            if (!n.isFinite()) return new _BigNumber(n.isNegative() ? NaN : Infinity);
            throw new Error("Integer BigNumber expected");
        },
        "Array | Matrix": function ArrayMatrix(n) {
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(n, this);
        }
    });
    /**
   * Calculate factorial for a BigNumber
   * @param {BigNumber} n
   * @returns {BigNumber} Returns the factorial of n
   */ function bigFactorial(n) {
        if (n < 8) return new _BigNumber([
            1,
            1,
            2,
            6,
            24,
            120,
            720,
            5040
        ][n]);
        var precision = config.precision + (Math.log(n.toNumber()) | 0);
        var Big = _BigNumber.clone({
            precision: precision
        });
        if (n % 2 === 1) return n.times(bigFactorial(new _BigNumber(n - 1)));
        var p = n;
        var prod = new Big(n);
        var sum = n.toNumber();
        while(p > 2){
            p -= 2;
            sum += p;
            prod = prod.times(sum);
        }
        return new _BigNumber(prod.toPrecision(_BigNumber.precision));
    }
});



var $6afc4254d8dd8701$var$name = "setIntersect";
var $6afc4254d8dd8701$var$dependencies = [
    "typed",
    "size",
    "subset",
    "compareNatural",
    "Index",
    "DenseMatrix"
];
var $6afc4254d8dd8701$export$b20ee2bdfbf6defd = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($6afc4254d8dd8701$var$name, $6afc4254d8dd8701$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, subset: subset, compareNatural: compareNatural, Index: Index, DenseMatrix: DenseMatrix } = _ref;
    /**
   * Create the intersection of two (multi)sets.
   * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
   *
   * Syntax:
   *
   *    math.setIntersect(set1, set2)
   *
   * Examples:
   *
   *    math.setIntersect([1, 2, 3, 4], [3, 4, 5, 6])            // returns [3, 4]
   *    math.setIntersect([[1, 2], [3, 4]], [[3, 4], [5, 6]])    // returns [3, 4]
   *
   * See also:
   *
   *    setUnion, setDifference
   *
   * @param {Array | Matrix}    a1  A (multi)set
   * @param {Array | Matrix}    a2  A (multi)set
   * @return {Array | Matrix}    The intersection of two (multi)sets
   */ return typed($6afc4254d8dd8701$var$name, {
        "Array | Matrix, Array | Matrix": function ArrayMatrixArrayMatrix(a1, a2) {
            var result;
            if (subset(size(a1), new Index(0)) === 0 || subset(size(a2), new Index(0)) === 0) // of any of them is empty, return empty
            result = [];
            else {
                var b1 = (0, $a14a10567870d913$export$65e5b62a4c490288)((0, $a14a10567870d913$export$bffa455ba8c619a6)(Array.isArray(a1) ? a1 : a1.toArray()).sort(compareNatural));
                var b2 = (0, $a14a10567870d913$export$65e5b62a4c490288)((0, $a14a10567870d913$export$bffa455ba8c619a6)(Array.isArray(a2) ? a2 : a2.toArray()).sort(compareNatural));
                result = [];
                for(var i = 0; i < b1.length; i++){
                    for(var j = 0; j < b2.length; j++)if (compareNatural(b1[i].value, b2[j].value) === 0 && b1[i].identifier === b2[j].identifier) {
                        // the identifier is always a decimal int
                        result.push(b1[i]);
                        break;
                    }
                }
            } // return an array, if both inputs were arrays
            if (Array.isArray(a1) && Array.isArray(a2)) return (0, $a14a10567870d913$export$d57ad8b840ad6a01)(result);
             // return a matrix otherwise
            return new DenseMatrix((0, $a14a10567870d913$export$d57ad8b840ad6a01)(result));
        }
    });
});





var $91be779ec18fe4c7$var$name = "divide";
var $91be779ec18fe4c7$var$dependencies = [
    "typed",
    "matrix",
    "multiply",
    "equalScalar",
    "divideScalar",
    "inv"
];
var $91be779ec18fe4c7$export$4df5e56bb6d14758 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($91be779ec18fe4c7$var$name, $91be779ec18fe4c7$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, multiply: multiply, equalScalar: equalScalar, divideScalar: divideScalar, inv: inv } = _ref;
    var algorithm11 = (0, $83b92f81e511657d$export$a38279a12199d831)({
        typed: typed,
        equalScalar: equalScalar
    });
    var algorithm14 = (0, $533d58927c47005f$export$e5afe3bc814ef550)({
        typed: typed
    });
    /**
   * Divide two values, `x / y`.
   * To divide matrices, `x` is multiplied with the inverse of `y`: `x * inv(y)`.
   *
   * Syntax:
   *
   *    math.divide(x, y)
   *
   * Examples:
   *
   *    math.divide(2, 3)            // returns number 0.6666666666666666
   *
   *    const a = math.complex(5, 14)
   *    const b = math.complex(4, 1)
   *    math.divide(a, b)            // returns Complex 2 + 3i
   *
   *    const c = [[7, -6], [13, -4]]
   *    const d = [[1, 2], [4, 3]]
   *    math.divide(c, d)            // returns Array [[-9, 4], [-11, 6]]
   *
   *    const e = math.unit('18 km')
   *    math.divide(e, 4.5)          // returns Unit 4 km
   *
   * See also:
   *
   *    multiply
   *
   * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x   Numerator
   * @param  {number | BigNumber | Fraction | Complex | Array | Matrix} y          Denominator
   * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}                      Quotient, `x / y`
   */ return typed("divide", (0, $6819694788cbfa38$export$8b58be045bf06082)({
        // we extend the signatures of divideScalar with signatures dealing with matrices
        "Array | Matrix, Array | Matrix": function ArrayMatrixArrayMatrix(x, y) {
            // TODO: implement matrix right division using pseudo inverse
            // https://www.mathworks.nl/help/matlab/ref/mrdivide.html
            // https://www.gnu.org/software/octave/doc/interpreter/Arithmetic-Ops.html
            // https://stackoverflow.com/questions/12263932/how-does-gnu-octave-matrix-division-work-getting-unexpected-behaviour
            return multiply(x, inv(y));
        },
        "DenseMatrix, any": function DenseMatrixAny(x, y) {
            return algorithm14(x, y, divideScalar, false);
        },
        "SparseMatrix, any": function SparseMatrixAny(x, y) {
            return algorithm11(x, y, divideScalar, false);
        },
        "Array, any": function ArrayAny(x, y) {
            // use matrix implementation
            return algorithm14(matrix(x), y, divideScalar, false).valueOf();
        },
        "any, Array | Matrix": function anyArrayMatrix(x, y) {
            return multiply(x, inv(y));
        }
    }, divideScalar.signatures));
});



var $7af5940f10e9442f$var$name = "factorial";
var $7af5940f10e9442f$var$dependencies = [
    "typed",
    "gamma"
];
var $7af5940f10e9442f$export$92c37ad44e3d0481 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($7af5940f10e9442f$var$name, $7af5940f10e9442f$var$dependencies, (_ref)=>{
    var { typed: typed, gamma: gamma } = _ref;
    /**
   * Compute the factorial of a value
   *
   * Factorial only supports an integer value as argument.
   * For matrices, the function is evaluated element wise.
   *
   * Syntax:
   *
   *    math.factorial(n)
   *
   * Examples:
   *
   *    math.factorial(5)    // returns 120
   *    math.factorial(3)    // returns 6
   *
   * See also:
   *
   *    combinations, combinationsWithRep, gamma, permutations
   *
   * @param {number | BigNumber | Array | Matrix} n   An integer number
   * @return {number | BigNumber | Array | Matrix}    The factorial of `n`
   */ return typed($7af5940f10e9442f$var$name, {
        number: function number(n) {
            if (n < 0) throw new Error("Value must be non-negative");
            return gamma(n + 1);
        },
        BigNumber: function BigNumber(n) {
            if (n.isNegative()) throw new Error("Value must be non-negative");
            return gamma(n.plus(1));
        },
        "Array | Matrix": function ArrayMatrix(n) {
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(n, this);
        }
    });
});



var $91601432d3f984b9$var$name = "lup";
var $91601432d3f984b9$var$dependencies = [
    "typed",
    "matrix",
    "abs",
    "addScalar",
    "divideScalar",
    "multiplyScalar",
    "subtract",
    "larger",
    "equalScalar",
    "unaryMinus",
    "DenseMatrix",
    "SparseMatrix",
    "Spa"
];
var $91601432d3f984b9$export$86ddf344397699d5 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($91601432d3f984b9$var$name, $91601432d3f984b9$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, abs: abs, addScalar: addScalar, divideScalar: divideScalar, multiplyScalar: multiplyScalar, subtract: subtract, larger: larger, equalScalar: equalScalar, unaryMinus: unaryMinus, DenseMatrix: DenseMatrix, SparseMatrix: SparseMatrix, Spa: Spa } = _ref;
    /**
   * Calculate the Matrix LU decomposition with partial pivoting. Matrix `A` is decomposed in two matrices (`L`, `U`) and a
   * row permutation vector `p` where `A[p,:] = L * U`
   *
   * Syntax:
   *
   *    math.lup(A)
   *
   * Example:
   *
   *    const m = [[2, 1], [1, 4]]
   *    const r = math.lup(m)
   *    // r = {
   *    //   L: [[1, 0], [0.5, 1]],
   *    //   U: [[2, 1], [0, 3.5]],
   *    //   P: [0, 1]
   *    // }
   *
   * See also:
   *
   *    slu, lsolve, lusolve, usolve
   *
   * @param {Matrix | Array} A    A two dimensional matrix or array for which to get the LUP decomposition.
   *
   * @return {{L: Array | Matrix, U: Array | Matrix, P: Array.<number>}} The lower triangular matrix, the upper triangular matrix and the permutation matrix.
   */ return typed($91601432d3f984b9$var$name, {
        DenseMatrix: function DenseMatrix(m) {
            return _denseLUP(m);
        },
        SparseMatrix: function SparseMatrix(m) {
            return _sparseLUP(m);
        },
        Array: function Array(a) {
            // create dense matrix from array
            var m = matrix(a); // lup, use matrix implementation
            var r = _denseLUP(m); // result
            return {
                L: r.L.valueOf(),
                U: r.U.valueOf(),
                p: r.p
            };
        }
    });
    function _denseLUP(m) {
        // rows & columns
        var rows = m._size[0];
        var columns = m._size[1]; // minimum rows and columns
        var n = Math.min(rows, columns); // matrix array, clone original data
        var data = (0, $6819694788cbfa38$export$9cd59f9826255e47)(m._data); // l matrix arrays
        var ldata = [];
        var lsize = [
            rows,
            n
        ]; // u matrix arrays
        var udata = [];
        var usize = [
            n,
            columns
        ]; // vars
        var i, j, k; // permutation vector
        var p = [];
        for(i = 0; i < rows; i++)p[i] = i;
         // loop columns
        for(j = 0; j < columns; j++){
            // skip first column in upper triangular matrix
            if (j > 0) // loop rows
            for(i = 0; i < rows; i++){
                // min i,j
                var min = Math.min(i, j); // v[i, j]
                var s = 0; // loop up to min
                for(k = 0; k < min; k++)// s = l[i, k] - data[k, j]
                s = addScalar(s, multiplyScalar(data[i][k], data[k][j]));
                data[i][j] = subtract(data[i][j], s);
            }
             // row with larger value in cvector, row >= j
            var pi = j;
            var pabsv = 0;
            var vjj = 0; // loop rows
            for(i = j; i < rows; i++){
                // data @ i, j
                var v = data[i][j]; // absolute value
                var absv = abs(v); // value is greater than pivote value
                if (larger(absv, pabsv)) {
                    // store row
                    pi = i; // update max value
                    pabsv = absv; // value @ [j, j]
                    vjj = v;
                }
            } // swap rows (j <-> pi)
            if (j !== pi) {
                // swap values j <-> pi in p
                p[j] = [
                    p[pi],
                    p[pi] = p[j]
                ][0]; // swap j <-> pi in data
                DenseMatrix._swapRows(j, pi, data);
            } // check column is in lower triangular matrix
            if (j < rows) // loop rows (lower triangular matrix)
            for(i = j + 1; i < rows; i++){
                // value @ i, j
                var vij = data[i][j];
                if (!equalScalar(vij, 0)) // update data
                data[i][j] = divideScalar(data[i][j], vjj);
            }
        } // loop columns
        for(j = 0; j < columns; j++)// loop rows
        for(i = 0; i < rows; i++){
            // initialize row in arrays
            if (j === 0) {
                // check row exists in upper triangular matrix
                if (i < columns) // U
                udata[i] = [];
                 // L
                ldata[i] = [];
            } // check we are in the upper triangular matrix
            if (i < j) {
                // check row exists in upper triangular matrix
                if (i < columns) // U
                udata[i][j] = data[i][j];
                 // check column exists in lower triangular matrix
                if (j < rows) // L
                ldata[i][j] = 0;
                continue;
            } // diagonal value
            if (i === j) {
                // check row exists in upper triangular matrix
                if (i < columns) // U
                udata[i][j] = data[i][j];
                 // check column exists in lower triangular matrix
                if (j < rows) // L
                ldata[i][j] = 1;
                continue;
            } // check row exists in upper triangular matrix
            if (i < columns) // U
            udata[i][j] = 0;
             // check column exists in lower triangular matrix
            if (j < rows) // L
            ldata[i][j] = data[i][j];
        }
         // l matrix
        var l = new DenseMatrix({
            data: ldata,
            size: lsize
        }); // u matrix
        var u = new DenseMatrix({
            data: udata,
            size: usize
        }); // p vector
        var pv = [];
        for(i = 0, n = p.length; i < n; i++)pv[p[i]] = i;
         // return matrices
        return {
            L: l,
            U: u,
            p: pv,
            toString: function toString() {
                return "L: " + this.L.toString() + "\nU: " + this.U.toString() + "\nP: " + this.p;
            }
        };
    }
    function _sparseLUP(m) {
        // rows & columns
        var rows = m._size[0];
        var columns = m._size[1]; // minimum rows and columns
        var n = Math.min(rows, columns); // matrix arrays (will not be modified, thanks to permutation vector)
        var values = m._values;
        var index = m._index;
        var ptr = m._ptr; // l matrix arrays
        var lvalues = [];
        var lindex = [];
        var lptr = [];
        var lsize = [
            rows,
            n
        ]; // u matrix arrays
        var uvalues = [];
        var uindex = [];
        var uptr = [];
        var usize = [
            n,
            columns
        ]; // vars
        var i, j, k; // permutation vectors, (current index -> original index) and (original index -> current index)
        var pvCo = [];
        var pvOc = [];
        for(i = 0; i < rows; i++){
            pvCo[i] = i;
            pvOc[i] = i;
        } // swap indices in permutation vectors (condition x < y)!
        var swapIndeces = function swapIndeces(x, y) {
            // find pv indeces getting data from x and y
            var kx = pvOc[x];
            var ky = pvOc[y]; // update permutation vector current -> original
            pvCo[kx] = y;
            pvCo[ky] = x; // update permutation vector original -> current
            pvOc[x] = ky;
            pvOc[y] = kx;
        }; // loop columns
        var _loop = function _loop() {
            // sparse accumulator
            var spa = new Spa(); // check lower triangular matrix has a value @ column j
            if (j < rows) {
                // update ptr
                lptr.push(lvalues.length); // first value in j column for lower triangular matrix
                lvalues.push(1);
                lindex.push(j);
            } // update ptr
            uptr.push(uvalues.length); // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = ptr[j];
            var k1 = ptr[j + 1]; // copy column j into sparse accumulator
            for(k = k0; k < k1; k++){
                // row
                i = index[k]; // copy column values into sparse accumulator (use permutation vector)
                spa.set(pvCo[i], values[k]);
            } // skip first column in upper triangular matrix
            if (j > 0) // loop rows in column j (above diagonal)
            spa.forEach(0, j - 1, function(k, vkj) {
                // loop rows in column k (L)
                SparseMatrix._forEachRow(k, lvalues, lindex, lptr, function(i, vik) {
                    // check row is below k
                    if (i > k) // update spa value
                    spa.accumulate(i, unaryMinus(multiplyScalar(vik, vkj)));
                });
            });
             // row with larger value in spa, row >= j
            var pi = j;
            var vjj = spa.get(j);
            var pabsv = abs(vjj); // loop values in spa (order by row, below diagonal)
            spa.forEach(j + 1, rows - 1, function(x, v) {
                // absolute value
                var absv = abs(v); // value is greater than pivote value
                if (larger(absv, pabsv)) {
                    // store row
                    pi = x; // update max value
                    pabsv = absv; // value @ [j, j]
                    vjj = v;
                }
            }); // swap rows (j <-> pi)
            if (j !== pi) {
                // swap values j <-> pi in L
                SparseMatrix._swapRows(j, pi, lsize[1], lvalues, lindex, lptr); // swap values j <-> pi in U
                SparseMatrix._swapRows(j, pi, usize[1], uvalues, uindex, uptr); // swap values in spa
                spa.swap(j, pi); // update permutation vector (swap values @ j, pi)
                swapIndeces(j, pi);
            } // loop values in spa (order by row)
            spa.forEach(0, rows - 1, function(x, v) {
                // check we are above diagonal
                if (x <= j) {
                    // update upper triangular matrix
                    uvalues.push(v);
                    uindex.push(x);
                } else {
                    // update value
                    v = divideScalar(v, vjj); // check value is non zero
                    if (!equalScalar(v, 0)) {
                        // update lower triangular matrix
                        lvalues.push(v);
                        lindex.push(x);
                    }
                }
            });
        };
        for(j = 0; j < columns; j++)_loop();
         // update ptrs
        uptr.push(uvalues.length);
        lptr.push(lvalues.length); // return matrices
        return {
            L: new SparseMatrix({
                values: lvalues,
                index: lindex,
                ptr: lptr,
                size: lsize
            }),
            U: new SparseMatrix({
                values: uvalues,
                index: uindex,
                ptr: uptr,
                size: usize
            }),
            p: pvCo,
            toString: function toString() {
                return "L: " + this.L.toString() + "\nU: " + this.U.toString() + "\nP: " + this.p;
            }
        };
    }
});



var $a0ab79d22b3ae8a3$var$name = "multinomial";
var $a0ab79d22b3ae8a3$var$dependencies = [
    "typed",
    "add",
    "divide",
    "multiply",
    "factorial",
    "isInteger",
    "isPositive"
];
var $a0ab79d22b3ae8a3$export$b15aee1001d110 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($a0ab79d22b3ae8a3$var$name, $a0ab79d22b3ae8a3$var$dependencies, (_ref)=>{
    var { typed: typed, add: add, divide: divide, multiply: multiply, factorial: factorial, isInteger: isInteger, isPositive: isPositive } = _ref;
    /**
   * Multinomial Coefficients compute the number of ways of picking a1, a2, ..., ai unordered outcomes from `n` possibilities.
   *
   * multinomial takes one array of integers as an argument.
   * The following condition must be enforced: every ai <= 0
   *
   * Syntax:
   *
   *     math.multinomial(a) // a is an array type
   *
   * Examples:
   *
   *    math.multinomial([1,2,1]) // returns 12
   *
   * See also:
   *
   *    combinations, factorial
   *
   * @param {number[] | BigNumber[]} a    Integer numbers of objects in the subset
   * @return {Number | BigNumber}         Multinomial coefficient.
   */ return typed($a0ab79d22b3ae8a3$var$name, {
        "Array | Matrix": function ArrayMatrix(a) {
            var sum = 0;
            var denom = 1;
            (0, $dd57e6221b0e50b6$export$519ada94592b97fc)(a, function(ai) {
                if (!isInteger(ai) || !isPositive(ai)) throw new TypeError("Positive integer value expected in function multinomial");
                sum = add(sum, ai);
                denom = multiply(denom, factorial(ai));
            });
            return divide(factorial(sum), denom);
        }
    });
});




var $be9ccd6b3be7f5c1$var$name = "permutations";
var $be9ccd6b3be7f5c1$var$dependencies = [
    "typed",
    "factorial"
];
var $be9ccd6b3be7f5c1$export$1d58d7915914cc9c = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($be9ccd6b3be7f5c1$var$name, $be9ccd6b3be7f5c1$var$dependencies, (_ref)=>{
    var { typed: typed, factorial: factorial } = _ref;
    /**
   * Compute the number of ways of obtaining an ordered subset of `k` elements
   * from a set of `n` elements.
   *
   * Permutations only takes integer arguments.
   * The following condition must be enforced: k <= n.
   *
   * Syntax:
   *
   *     math.permutations(n)
   *     math.permutations(n, k)
   *
   * Examples:
   *
   *    math.permutations(5)     // 120
   *    math.permutations(5, 3)  // 60
   *
   * See also:
   *
   *    combinations, combinationsWithRep, factorial
   *
   * @param {number | BigNumber} n   The number of objects in total
   * @param {number | BigNumber} [k] The number of objects in the subset
   * @return {number | BigNumber}    The number of permutations
   */ return typed($be9ccd6b3be7f5c1$var$name, {
        "number | BigNumber": factorial,
        "number, number": function numberNumber(n, k) {
            if (!(0, $668e051498bf5fa0$export$a287f47fed4544b8)(n) || n < 0) throw new TypeError("Positive integer value expected in function permutations");
            if (!(0, $668e051498bf5fa0$export$a287f47fed4544b8)(k) || k < 0) throw new TypeError("Positive integer value expected in function permutations");
            if (k > n) throw new TypeError("second argument k must be less than or equal to first argument n");
             // Permute n objects, k at a time
            return (0, $dc1c171d547e28ef$export$dbd0f18357df1ddd)(n - k + 1, n);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(n, k) {
            var result, i;
            if (!$be9ccd6b3be7f5c1$var$isPositiveInteger(n) || !$be9ccd6b3be7f5c1$var$isPositiveInteger(k)) throw new TypeError("Positive integer value expected in function permutations");
            if (k.gt(n)) throw new TypeError("second argument k must be less than or equal to first argument n");
            var one = n.mul(0).add(1);
            result = one;
            for(i = n.minus(k).plus(1); i.lte(n); i = i.plus(1))result = result.times(i);
            return result;
        } // TODO: implement support for collection in permutations
    });
});
/**
 * Test whether BigNumber n is a positive integer
 * @param {BigNumber} n
 * @returns {boolean} isPositiveInteger
 */ function $be9ccd6b3be7f5c1$var$isPositiveInteger(n) {
    return n.isInteger() && n.gte(0);
}



var $f0b7289c0552c7b2$var$name = "stirlingS2";
var $f0b7289c0552c7b2$var$dependencies = [
    "typed",
    "addScalar",
    "subtract",
    "multiplyScalar",
    "divideScalar",
    "pow",
    "factorial",
    "combinations",
    "isNegative",
    "isInteger",
    "number",
    "?bignumber",
    "larger"
];
var $f0b7289c0552c7b2$export$18813d136a9b83d0 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($f0b7289c0552c7b2$var$name, $f0b7289c0552c7b2$var$dependencies, (_ref)=>{
    var { typed: typed, addScalar: addScalar, subtract: subtract, multiplyScalar: multiplyScalar, divideScalar: divideScalar, pow: pow, factorial: factorial, combinations: combinations, isNegative: isNegative, isInteger: isInteger, number: number, bignumber: bignumber, larger: larger } = _ref;
    var smallCache = [];
    var bigCache = [];
    /**
   * The Stirling numbers of the second kind, counts the number of ways to partition
   * a set of n labelled objects into k nonempty unlabelled subsets.
   * stirlingS2 only takes integer arguments.
   * The following condition must be enforced: k <= n.
   *
   *  If n = k or k = 1 <= n, then s(n,k) = 1
   *  If k = 0 < n, then s(n,k) = 0
   *
   * Note that if either n or k is supplied as a BigNumber, the result will be
   * as well.
   *
   * Syntax:
   *
   *   math.stirlingS2(n, k)
   *
   * Examples:
   *
   *    math.stirlingS2(5, 3) //returns 25
   *
   * See also:
   *
   *    bellNumbers
   *
   * @param {Number | BigNumber} n    Total number of objects in the set
   * @param {Number | BigNumber} k    Number of objects in the subset
   * @return {Number | BigNumber}     S(n,k)
   */ return typed($f0b7289c0552c7b2$var$name, {
        "number | BigNumber, number | BigNumber": function numberBigNumberNumberBigNumber(n, k) {
            if (!isInteger(n) || isNegative(n) || !isInteger(k) || isNegative(k)) throw new TypeError("Non-negative integer value expected in function stirlingS2");
            else if (larger(k, n)) throw new TypeError("k must be less than or equal to n in function stirlingS2");
            var big = !((0, $d8097b7a6d6e36d8$export$7e4aa119212bc614)(n) && (0, $d8097b7a6d6e36d8$export$7e4aa119212bc614)(k));
            var cache = big ? bigCache : smallCache;
            var make = big ? bignumber : number;
            var nn = number(n);
            var nk = number(k);
            /* See if we already have the value: */ if (cache[nn] && cache[nn].length > nk) return cache[nn][nk];
            /* Fill the cache */ for(var m = 0; m <= nn; ++m){
                if (!cache[m]) cache[m] = [
                    m === 0 ? make(1) : make(0)
                ];
                if (m === 0) continue;
                var row = cache[m];
                var prev = cache[m - 1];
                for(var i = row.length; i <= m && i <= nk; ++i)if (i === m) row[i] = 1;
                else row[i] = addScalar(multiplyScalar(make(i), prev[i]), prev[i - 1]);
            }
            return cache[nn][nk];
        }
    });
});



var $14dd6c4acdb9f4f4$var$name = "unit";
var $14dd6c4acdb9f4f4$var$dependencies = [
    "typed",
    "Unit"
]; // This function is named createUnitFunction to prevent a naming conflict with createUnit
var $14dd6c4acdb9f4f4$export$17074f98b69d2545 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($14dd6c4acdb9f4f4$var$name, $14dd6c4acdb9f4f4$var$dependencies, (_ref)=>{
    var { typed: typed, Unit: Unit } = _ref;
    /**
   * Create a unit. Depending on the passed arguments, the function
   * will create and return a new math.Unit object.
   * When a matrix is provided, all elements will be converted to units.
   *
   * Syntax:
   *
   *     math.unit(unit : string)
   *     math.unit(value : number, unit : string)
   *
   * Examples:
   *
   *    const a = math.unit(5, 'cm')    // returns Unit 50 mm
   *    const b = math.unit('23 kg')    // returns Unit 23 kg
   *    a.to('m')                       // returns Unit 0.05 m
   *
   * See also:
   *
   *    bignumber, boolean, complex, index, matrix, number, string, createUnit
   *
   * @param {* | Array | Matrix} args   A number and unit.
   * @return {Unit | Array | Matrix}    The created unit
   */ return typed($14dd6c4acdb9f4f4$var$name, {
        Unit: function Unit(x) {
            return x.clone();
        },
        string: function string(x) {
            if (Unit.isValuelessUnit(x)) return new Unit(null, x); // a pure unit
            return Unit.parse(x, {
                allowNoUnits: true
            }); // a unit with value, like '5cm'
        },
        "number | BigNumber | Fraction | Complex, string": function numberBigNumberFractionComplexString(value, unit) {
            return new Unit(value, unit);
        },
        "Array | Matrix": function ArrayMatrix(x) {
            return (0, $dd57e6221b0e50b6$export$ce7eaaed37329a1b)(x, this);
        }
    });
});


var $6e51035b9e1a81dc$var$name = "bellNumbers";
var $6e51035b9e1a81dc$var$dependencies = [
    "typed",
    "addScalar",
    "isNegative",
    "isInteger",
    "stirlingS2"
];
var $6e51035b9e1a81dc$export$7b7dc3bd00d38afb = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($6e51035b9e1a81dc$var$name, $6e51035b9e1a81dc$var$dependencies, (_ref)=>{
    var { typed: typed, addScalar: addScalar, isNegative: isNegative, isInteger: isInteger, stirlingS2: stirlingS2 } = _ref;
    /**
   * The Bell Numbers count the number of partitions of a set. A partition is a pairwise disjoint subset of S whose union is S.
   * bellNumbers only takes integer arguments.
   * The following condition must be enforced: n >= 0
   *
   * Syntax:
   *
   *   math.bellNumbers(n)
   *
   * Examples:
   *
   *    math.bellNumbers(3) // returns 5
   *    math.bellNumbers(8) // returns 4140
   *
   * See also:
   *
   *    stirlingS2
   *
   * @param {Number | BigNumber} n    Total number of objects in the set
   * @return {Number | BigNumber}     B(n)
   */ return typed($6e51035b9e1a81dc$var$name, {
        "number | BigNumber": function numberBigNumber(n) {
            if (!isInteger(n) || isNegative(n)) throw new TypeError("Non-negative integer value expected in function bellNumbers");
             // Sum (k=0, n) S(n,k).
            var result = 0;
            for(var i = 0; i <= n; i++)result = addScalar(result, stirlingS2(n, i));
            return result;
        }
    });
});




function $6297ea39689cbd93$export$190353ff415180b5(_ref) {
    var { addScalar: addScalar, subtract: subtract, flatten: flatten, multiply: multiply, multiplyScalar: multiplyScalar, divideScalar: divideScalar, sqrt: sqrt, abs: abs, bignumber: bignumber, diag: diag, inv: inv, qr: qr, usolve: usolve, usolveAll: usolveAll, equal: equal, complex: complex, larger: larger, smaller: smaller, matrixFromColumns: matrixFromColumns, dot: dot } = _ref;
    /**
   * @param {number[][]} arr the matrix to find eigenvalues of
   * @param {number} N size of the matrix
   * @param {number|BigNumber} prec precision, anything lower will be considered zero
   * @param {'number'|'BigNumber'|'Complex'} type
   * @param {boolean} findVectors should we find eigenvectors?
   *
   * @returns {{ values: number[], vectors: number[][] }}
   */ function complexEigs(arr, N, prec, type, findVectors) {
        if (findVectors === undefined) findVectors = true;
         // TODO check if any row/col are zero except the diagonal
        // make sure corresponding rows and columns have similar magnitude
        // important because of numerical stability
        // MODIFIES arr by side effect!
        var R = balance(arr, N, prec, type, findVectors); // R is the row transformation matrix
        // arr = A' = R A R⁻¹, A is the original matrix
        // (if findVectors is false, R is undefined)
        // (And so to return to original matrix: A = R⁻¹ arr R)
        // TODO if magnitudes of elements vary over many orders,
        // move greatest elements to the top left corner
        // using similarity transformations, reduce the matrix
        // to Hessenberg form (upper triangular plus one subdiagonal row)
        // updates the transformation matrix R with new row operationsq
        // MODIFIES arr by side effect!
        reduceToHessenberg(arr, N, prec, type, findVectors, R); // still true that original A = R⁻¹ arr R)
        // find eigenvalues
        var { values: values, C: C } = iterateUntilTriangular(arr, N, prec, type, findVectors); // values is the list of eigenvalues, C is the column
        // transformation matrix that transforms arr, the hessenberg
        // matrix, to upper triangular
        // (So U = C⁻¹ arr C and the relationship between current arr
        // and original A is unchanged.)
        var vectors;
        if (findVectors) {
            vectors = findEigenvectors(arr, N, C, R, values, prec, type);
            vectors = matrixFromColumns(...vectors);
        }
        return {
            values: values,
            vectors: vectors
        };
    }
    /**
   * @param {number[][]} arr
   * @param {number} N
   * @param {number} prec
   * @param {'number'|'BigNumber'|'Complex'} type
   * @returns {number[][]}
   */ function balance(arr, N, prec, type, findVectors) {
        var big = type === "BigNumber";
        var cplx = type === "Complex";
        var realzero = big ? bignumber(0) : 0;
        var one = big ? bignumber(1) : cplx ? complex(1) : 1;
        var realone = big ? bignumber(1) : 1; // base of the floating-point arithmetic
        var radix = big ? bignumber(10) : 2;
        var radixSq = multiplyScalar(radix, radix); // the diagonal transformation matrix R
        var Rdiag;
        if (findVectors) Rdiag = Array(N).fill(one);
         // this isn't the only time we loop thru the matrix...
        var last = false;
        while(!last){
            // ...haha I'm joking! unless...
            last = true;
            for(var i = 0; i < N; i++){
                // compute the taxicab norm of i-th column and row
                // TODO optimize for complex numbers
                var colNorm = realzero;
                var rowNorm = realzero;
                for(var j = 0; j < N; j++){
                    if (i === j) continue;
                    var c = abs(arr[i][j]); // should be real
                    colNorm = addScalar(colNorm, c);
                    rowNorm = addScalar(rowNorm, c);
                }
                if (!equal(colNorm, 0) && !equal(rowNorm, 0)) {
                    // find integer power closest to balancing the matrix
                    // (we want to scale only by integer powers of radix,
                    // so that we don't lose any precision due to round-off)
                    var f = realone;
                    var _c = colNorm;
                    var rowDivRadix = divideScalar(rowNorm, radix);
                    var rowMulRadix = multiplyScalar(rowNorm, radix);
                    while(smaller(_c, rowDivRadix)){
                        _c = multiplyScalar(_c, radixSq);
                        f = multiplyScalar(f, radix);
                    }
                    while(larger(_c, rowMulRadix)){
                        _c = divideScalar(_c, radixSq);
                        f = divideScalar(f, radix);
                    } // check whether balancing is needed
                    // condition = (c + rowNorm) / f < 0.95 * (colNorm + rowNorm)
                    var condition = smaller(divideScalar(addScalar(_c, rowNorm), f), multiplyScalar(addScalar(colNorm, rowNorm), 0.95)); // apply balancing similarity transformation
                    if (condition) {
                        // we should loop once again to check whether
                        // another rebalancing is needed
                        last = false;
                        var g = divideScalar(1, f);
                        for(var _j = 0; _j < N; _j++){
                            if (i === _j) continue;
                            arr[i][_j] = multiplyScalar(arr[i][_j], f);
                            arr[_j][i] = multiplyScalar(arr[_j][i], g);
                        } // keep track of transformations
                        if (findVectors) Rdiag[i] = multiplyScalar(Rdiag[i], f);
                    }
                }
            }
        } // return the diagonal row transformation matrix
        return diag(Rdiag);
    }
    /**
   * @param {number[][]} arr
   * @param {number} N
   * @param {number} prec
   * @param {'number'|'BigNumber'|'Complex'} type
   * @param {boolean} findVectors
   * @param {number[][]} R the row transformation matrix that will be modified
   */ function reduceToHessenberg(arr, N, prec, type, findVectors, R) {
        var big = type === "BigNumber";
        var cplx = type === "Complex";
        var zero = big ? bignumber(0) : cplx ? complex(0) : 0;
        if (big) prec = bignumber(prec);
        for(var i = 0; i < N - 2; i++){
            // Find the largest subdiag element in the i-th col
            var maxIndex = 0;
            var max = zero;
            for(var j = i + 1; j < N; j++){
                var el = arr[j][i];
                if (smaller(abs(max), abs(el))) {
                    max = el;
                    maxIndex = j;
                }
            } // This col is pivoted, no need to do anything
            if (smaller(abs(max), prec)) continue;
            if (maxIndex !== i + 1) {
                // Interchange maxIndex-th and (i+1)-th row
                var tmp1 = arr[maxIndex];
                arr[maxIndex] = arr[i + 1];
                arr[i + 1] = tmp1; // Interchange maxIndex-th and (i+1)-th column
                for(var _j2 = 0; _j2 < N; _j2++){
                    var tmp2 = arr[_j2][maxIndex];
                    arr[_j2][maxIndex] = arr[_j2][i + 1];
                    arr[_j2][i + 1] = tmp2;
                } // keep track of transformations
                if (findVectors) {
                    var tmp3 = R[maxIndex];
                    R[maxIndex] = R[i + 1];
                    R[i + 1] = tmp3;
                }
            } // Reduce following rows and columns
            for(var _j3 = i + 2; _j3 < N; _j3++){
                var n = divideScalar(arr[_j3][i], max);
                if (n === 0) continue;
                 // from j-th row subtract n-times (i+1)th row
                for(var k = 0; k < N; k++)arr[_j3][k] = subtract(arr[_j3][k], multiplyScalar(n, arr[i + 1][k]));
                 // to (i+1)th column add n-times j-th column
                for(var _k = 0; _k < N; _k++)arr[_k][i + 1] = addScalar(arr[_k][i + 1], multiplyScalar(n, arr[_k][_j3]));
                 // keep track of transformations
                if (findVectors) for(var _k2 = 0; _k2 < N; _k2++)R[_j3][_k2] = subtract(R[_j3][_k2], multiplyScalar(n, R[i + 1][_k2]));
            }
        }
        return R;
    }
    /**
   * @returns {{values: values, C: Matrix}}
   * @see Press, Wiliams: Numerical recipes in Fortran 77
   * @see https://en.wikipedia.org/wiki/QR_algorithm
   */ function iterateUntilTriangular(A, N, prec, type, findVectors) {
        var big = type === "BigNumber";
        var cplx = type === "Complex";
        var one = big ? bignumber(1) : cplx ? complex(1) : 1;
        if (big) prec = bignumber(prec);
         // The Francis Algorithm
        // The core idea of this algorithm is that doing successive
        // A' = Q⁺AQ transformations will eventually converge to block-
        // upper-triangular with diagonal blocks either 1x1 or 2x2.
        // The Q here is the one from the QR decomposition, A = QR.
        // Since the eigenvalues of a block-upper-triangular matrix are
        // the eigenvalues of its diagonal blocks and we know how to find
        // eigenvalues of a 2x2 matrix, we know the eigenvalues of A.
        var arr = (0, $6819694788cbfa38$export$9cd59f9826255e47)(A); // the list of converged eigenvalues
        var lambdas = []; // size of arr, which will get smaller as eigenvalues converge
        var n = N; // the diagonal of the block-diagonal matrix that turns
        // converged 2x2 matrices into upper triangular matrices
        var Sdiag = []; // N×N matrix describing the overall transformation done during the QR algorithm
        var Qtotal = findVectors ? diag(Array(N).fill(one)) : undefined; // n×n matrix describing the QR transformations done since last convergence
        var Qpartial = findVectors ? diag(Array(n).fill(one)) : undefined; // last eigenvalue converged before this many steps
        var lastConvergenceBefore = 0;
        while(lastConvergenceBefore <= 100){
            lastConvergenceBefore += 1; // TODO if the convergence is slow, do something clever
            // Perform the factorization
            var k = 0; // TODO set close to an eigenvalue
            for(var i = 0; i < n; i++)arr[i][i] = subtract(arr[i][i], k);
             // TODO do an implicit QR transformation
            var { Q: Q, R: R } = qr(arr);
            arr = multiply(R, Q);
            for(var _i = 0; _i < n; _i++)arr[_i][_i] = addScalar(arr[_i][_i], k);
             // keep track of transformations
            if (findVectors) Qpartial = multiply(Qpartial, Q);
             // The rightmost diagonal element converged to an eigenvalue
            if (n === 1 || smaller(abs(arr[n - 1][n - 2]), prec)) {
                lastConvergenceBefore = 0;
                lambdas.push(arr[n - 1][n - 1]); // keep track of transformations
                if (findVectors) {
                    Sdiag.unshift([
                        [
                            1
                        ]
                    ]);
                    inflateMatrix(Qpartial, N);
                    Qtotal = multiply(Qtotal, Qpartial);
                    if (n > 1) Qpartial = diag(Array(n - 1).fill(one));
                } // reduce the matrix size
                n -= 1;
                arr.pop();
                for(var _i2 = 0; _i2 < n; _i2++)arr[_i2].pop();
                 // The rightmost diagonal 2x2 block converged
            } else if (n === 2 || smaller(abs(arr[n - 2][n - 3]), prec)) {
                lastConvergenceBefore = 0;
                var ll = eigenvalues2x2(arr[n - 2][n - 2], arr[n - 2][n - 1], arr[n - 1][n - 2], arr[n - 1][n - 1]);
                lambdas.push(...ll); // keep track of transformations
                if (findVectors) {
                    Sdiag.unshift(jordanBase2x2(arr[n - 2][n - 2], arr[n - 2][n - 1], arr[n - 1][n - 2], arr[n - 1][n - 1], ll[0], ll[1], prec, type));
                    inflateMatrix(Qpartial, N);
                    Qtotal = multiply(Qtotal, Qpartial);
                    if (n > 2) Qpartial = diag(Array(n - 2).fill(one));
                } // reduce the matrix size
                n -= 2;
                arr.pop();
                arr.pop();
                for(var _i3 = 0; _i3 < n; _i3++){
                    arr[_i3].pop();
                    arr[_i3].pop();
                }
            }
            if (n === 0) break;
        } // standard sorting
        lambdas.sort((a, b)=>+subtract(abs(a), abs(b))); // the algorithm didn't converge
        if (lastConvergenceBefore > 100) {
            var err = Error("The eigenvalues failed to converge. Only found these eigenvalues: " + lambdas.join(", "));
            err.values = lambdas;
            err.vectors = [];
            throw err;
        } // combine the overall QR transformation Qtotal with the subsequent
        // transformation S that turns the diagonal 2x2 blocks to upper triangular
        var C = findVectors ? multiply(Qtotal, blockDiag(Sdiag, N)) : undefined;
        return {
            values: lambdas,
            C: C
        };
    }
    /**
   * @param {Matrix} A hessenberg-form matrix
   * @param {number} N size of A
   * @param {Matrix} C column transformation matrix that turns A into upper triangular
   * @param {Matrix} R similarity that turns original matrix into A
   * @param {number[]} values array of eigenvalues of A
   * @param {'number'|'BigNumber'|'Complex'} type
   * @returns {number[][]} eigenvalues
   */ function findEigenvectors(A, N, C, R, values, prec, type) {
        var Cinv = inv(C);
        var U = multiply(Cinv, A, C);
        var big = type === "BigNumber";
        var cplx = type === "Complex";
        var zero = big ? bignumber(0) : cplx ? complex(0) : 0;
        var one = big ? bignumber(1) : cplx ? complex(1) : 1; // turn values into a kind of "multiset"
        // this way it is easier to find eigenvectors
        var uniqueValues = [];
        var multiplicities = [];
        for (var \u03BB of values){
            var i = indexOf(uniqueValues, \u03BB, equal);
            if (i === -1) {
                uniqueValues.push(\u03BB);
                multiplicities.push(1);
            } else multiplicities[i] += 1;
        } // find eigenvectors by solving U − λE = 0
        // TODO replace with an iterative eigenvector algorithm
        // (this one might fail for imprecise eigenvalues)
        var vectors = [];
        var len = uniqueValues.length;
        var b = Array(N).fill(zero);
        var E = diag(Array(N).fill(one)); // eigenvalues for which usolve failed (due to numerical error)
        var failedLambdas = [];
        var _loop = function _loop(_i4) {
            var \u03BB = uniqueValues[_i4];
            var S = subtract(U, multiply(\u03BB, E)); // the characteristic matrix
            var solutions = usolveAll(S, b);
            solutions.shift(); // ignore the null vector
            // looks like we missed something, try inverse iteration
            while(solutions.length < multiplicities[_i4]){
                var approxVec = inverseIterate(S, N, solutions, prec, type);
                if (approxVec == null) {
                    // no more vectors were found
                    failedLambdas.push(\u03BB);
                    break;
                }
                solutions.push(approxVec);
            } // Transform back into original array coordinates
            var correction = multiply(inv(R), C);
            solutions = solutions.map((v)=>multiply(correction, v));
            vectors.push(...solutions.map((v)=>flatten(v)));
        };
        for(var _i4 = 0; _i4 < len; _i4++)_loop(_i4);
        if (failedLambdas.length !== 0) {
            var err = new Error("Failed to find eigenvectors for the following eigenvalues: " + failedLambdas.join(", "));
            err.values = values;
            err.vectors = vectors;
            throw err;
        }
        return vectors;
    }
    /**
   * Compute the eigenvalues of an 2x2 matrix
   * @return {[number,number]}
   */ function eigenvalues2x2(a, b, c, d) {
        // λ± = ½ trA ± ½ √( tr²A - 4 detA )
        var trA = addScalar(a, d);
        var detA = subtract(multiplyScalar(a, d), multiplyScalar(b, c));
        var x = multiplyScalar(trA, 0.5);
        var y = multiplyScalar(sqrt(subtract(multiplyScalar(trA, trA), multiplyScalar(4, detA))), 0.5);
        return [
            addScalar(x, y),
            subtract(x, y)
        ];
    }
    /**
   * For an 2x2 matrix compute the transformation matrix S,
   * so that SAS⁻¹ is an upper triangular matrix
   * @return {[[number,number],[number,number]]}
   * @see https://math.berkeley.edu/~ogus/old/Math_54-05/webfoils/jordan.pdf
   * @see http://people.math.harvard.edu/~knill/teaching/math21b2004/exhibits/2dmatrices/index.html
   */ function jordanBase2x2(a, b, c, d, l1, l2, prec, type) {
        var big = type === "BigNumber";
        var cplx = type === "Complex";
        var zero = big ? bignumber(0) : cplx ? complex(0) : 0;
        var one = big ? bignumber(1) : cplx ? complex(1) : 1; // matrix is already upper triangular
        // return an identity matrix
        if (smaller(abs(c), prec)) return [
            [
                one,
                zero
            ],
            [
                zero,
                one
            ]
        ];
         // matrix is diagonalizable
        // return its eigenvectors as columns
        if (larger(abs(subtract(l1, l2)), prec)) return [
            [
                subtract(l1, d),
                subtract(l2, d)
            ],
            [
                c,
                c
            ]
        ];
         // matrix is not diagonalizable
        // compute off-diagonal elements of N = A - λI
        // N₁₂ = 0 ⇒ S = ( N⃗₁, I⃗₁ )
        // N₁₂ ≠ 0 ⇒ S = ( N⃗₂, I⃗₂ )
        var na = subtract(a, l1);
        var nb = subtract(b, l1);
        var nc = subtract(c, l1);
        var nd = subtract(d, l1);
        if (smaller(abs(nb), prec)) return [
            [
                na,
                one
            ],
            [
                nc,
                zero
            ]
        ];
        else return [
            [
                nb,
                zero
            ],
            [
                nd,
                one
            ]
        ];
    }
    /**
   * Enlarge the matrix from n×n to N×N, setting the new
   * elements to 1 on diagonal and 0 elsewhere
   */ function inflateMatrix(arr, N) {
        // add columns
        for(var i = 0; i < arr.length; i++)arr[i].push(...Array(N - arr[i].length).fill(0));
         // add rows
        for(var _i5 = arr.length; _i5 < N; _i5++){
            arr.push(Array(N).fill(0));
            arr[_i5][_i5] = 1;
        }
        return arr;
    }
    /**
   * Create a block-diagonal matrix with the given square matrices on the diagonal
   * @param {Matrix[] | number[][][]} arr array of matrices to be placed on the diagonal
   * @param {number} N the size of the resulting matrix
   */ function blockDiag(arr, N) {
        var M = [];
        for(var i = 0; i < N; i++)M[i] = Array(N).fill(0);
        var I = 0;
        for (var sub of arr){
            var n = sub.length;
            for(var _i6 = 0; _i6 < n; _i6++)for(var j = 0; j < n; j++)M[I + _i6][I + j] = sub[_i6][j];
            I += n;
        }
        return M;
    }
    /**
   * Finds the index of an element in an array using a custom equality function
   * @template T
   * @param {Array<T>} arr array in which to search
   * @param {T} el the element to find
   * @param {function(T, T): boolean} fn the equality function, first argument is an element of `arr`, the second is always `el`
   * @returns {number} the index of `el`, or -1 when it's not in `arr`
   */ function indexOf(arr, el, fn) {
        for(var i = 0; i < arr.length; i++){
            if (fn(arr[i], el)) return i;
        }
        return -1;
    }
    /**
   * Provided a near-singular upper-triangular matrix A and a list of vectors,
   * finds an eigenvector of A with the smallest eigenvalue, which is orthogonal
   * to each vector in the list
   * @template T
   * @param {T[][]} A near-singular square matrix
   * @param {number} N dimension
   * @param {T[][]} orthog list of vectors
   * @param {number} prec epsilon
   * @param {'number'|'BigNumber'|'Complex'} type
   * @return {T[] | null} eigenvector
   *
   * @see Numerical Recipes for Fortran 77 – 11.7 Eigenvalues or Eigenvectors by Inverse Iteration
   */ function inverseIterate(A, N, orthog, prec, type) {
        var largeNum = type === "BigNumber" ? bignumber(1000) : 1000;
        var b; // the vector
        // you better choose a random vector before I count to five
        var i = 0;
        while(true){
            b = randomOrthogonalVector(N, orthog, type);
            b = usolve(A, b);
            if (larger(norm(b), largeNum)) break;
            if (++i >= 5) return null;
        } // you better converge before I count to ten
        i = 0;
        while(true){
            var c = usolve(A, b);
            if (smaller(norm(orthogonalComplement(b, [
                c
            ])), prec)) break;
            if (++i >= 10) return null;
            b = normalize(c);
        }
        return b;
    }
    /**
   * Generates a random unit vector of dimension N, orthogonal to each vector in the list
   * @template T
   * @param {number} N dimension
   * @param {T[][]} orthog list of vectors
   * @param {'number'|'BigNumber'|'Complex'} type
   * @returns {T[]} random vector
   */ function randomOrthogonalVector(N, orthog, type) {
        var big = type === "BigNumber";
        var cplx = type === "Complex"; // generate random vector with the correct type
        var v = Array(N).fill(0).map((_)=>2 * Math.random() - 1);
        if (big) v = v.map((n)=>bignumber(n));
        if (cplx) v = v.map((n)=>complex(n));
         // project to orthogonal complement
        v = orthogonalComplement(v, orthog); // normalize
        return normalize(v, type);
    }
    /**
   * Project vector v to the orthogonal complement of an array of vectors
   */ function orthogonalComplement(v, orthog) {
        for (var w of orthog)// v := v − (w, v)/∥w∥² w
        v = subtract(v, multiply(divideScalar(dot(w, v), dot(w, w)), w));
        return v;
    }
    /**
   * Calculate the norm of a vector.
   * We can't use math.norm because factory can't handle circular dependency.
   * Seriously, I'm really fed up with factory.
   */ function norm(v) {
        return abs(sqrt(dot(v, v)));
    }
    /**
   * Normalize a vector
   * @template T
   * @param {T[]} v
   * @param {'number'|'BigNumber'|'Complex'} type
   * @returns {T[]} normalized vec
   */ function normalize(v, type) {
        var big = type === "BigNumber";
        var cplx = type === "Complex";
        var one = big ? bignumber(1) : cplx ? complex(1) : 1;
        return multiply(divideScalar(one, norm(v)), v);
    }
    return complexEigs;
}



function $fe6e22733ee75ddd$export$a8f76d83a88e1b99(_ref) {
    var { config: config, addScalar: addScalar, subtract: subtract, abs: abs, atan: atan, cos: cos, sin: sin, multiplyScalar: multiplyScalar, inv: inv, bignumber: bignumber, multiply: multiply, add: add } = _ref;
    /**
   * @param {number[] | BigNumber[]} arr
   * @param {number} N
   * @param {number} prec
   * @param {'number' | 'BigNumber'} type
   */ function main(arr, N) {
        var prec = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : config.epsilon;
        var type = arguments.length > 3 ? arguments[3] : undefined;
        if (type === "number") return diag(arr, prec);
        if (type === "BigNumber") return diagBig(arr, prec);
        throw TypeError("Unsupported data type: " + type);
    } // diagonalization implementation for number (efficient)
    function diag(x, precision) {
        var N = x.length;
        var e0 = Math.abs(precision / N);
        var psi;
        var Sij = new Array(N); // Sij is Identity Matrix
        for(var i = 0; i < N; i++){
            Sij[i] = createArray(N, 0);
            Sij[i][i] = 1.0;
        } // initial error
        var Vab = getAij(x);
        while(Math.abs(Vab[1]) >= Math.abs(e0)){
            var _i = Vab[0][0];
            var j = Vab[0][1];
            psi = getTheta(x[_i][_i], x[j][j], x[_i][j]);
            x = x1(x, psi, _i, j);
            Sij = Sij1(Sij, psi, _i, j);
            Vab = getAij(x);
        }
        var Ei = createArray(N, 0); // eigenvalues
        for(var _i2 = 0; _i2 < N; _i2++)Ei[_i2] = x[_i2][_i2];
        return sorting((0, $6819694788cbfa38$export$9cd59f9826255e47)(Ei), (0, $6819694788cbfa38$export$9cd59f9826255e47)(Sij));
    } // diagonalization implementation for bigNumber
    function diagBig(x, precision) {
        var N = x.length;
        var e0 = abs(precision / N);
        var psi;
        var Sij = new Array(N); // Sij is Identity Matrix
        for(var i = 0; i < N; i++){
            Sij[i] = createArray(N, 0);
            Sij[i][i] = 1.0;
        } // initial error
        var Vab = getAijBig(x);
        while(abs(Vab[1]) >= abs(e0)){
            var _i3 = Vab[0][0];
            var j = Vab[0][1];
            psi = getThetaBig(x[_i3][_i3], x[j][j], x[_i3][j]);
            x = x1Big(x, psi, _i3, j);
            Sij = Sij1Big(Sij, psi, _i3, j);
            Vab = getAijBig(x);
        }
        var Ei = createArray(N, 0); // eigenvalues
        for(var _i4 = 0; _i4 < N; _i4++)Ei[_i4] = x[_i4][_i4];
         // return [clone(Ei), clone(Sij)]
        return sorting((0, $6819694788cbfa38$export$9cd59f9826255e47)(Ei), (0, $6819694788cbfa38$export$9cd59f9826255e47)(Sij));
    } // get angle
    function getTheta(aii, ajj, aij) {
        var denom = ajj - aii;
        if (Math.abs(denom) <= config.epsilon) return Math.PI / 4.0;
        else return 0.5 * Math.atan(2.0 * aij / (ajj - aii));
    } // get angle
    function getThetaBig(aii, ajj, aij) {
        var denom = subtract(ajj, aii);
        if (abs(denom) <= config.epsilon) return bignumber(-1).acos().div(4);
        else return multiplyScalar(0.5, atan(multiply(2.0, aij, inv(denom))));
    } // update eigvec
    function Sij1(Sij, theta, i, j) {
        var N = Sij.length;
        var c = Math.cos(theta);
        var s = Math.sin(theta);
        var Ski = createArray(N, 0);
        var Skj = createArray(N, 0);
        for(var k = 0; k < N; k++){
            Ski[k] = c * Sij[k][i] - s * Sij[k][j];
            Skj[k] = s * Sij[k][i] + c * Sij[k][j];
        }
        for(var _k = 0; _k < N; _k++){
            Sij[_k][i] = Ski[_k];
            Sij[_k][j] = Skj[_k];
        }
        return Sij;
    } // update eigvec for overlap
    function Sij1Big(Sij, theta, i, j) {
        var N = Sij.length;
        var c = cos(theta);
        var s = sin(theta);
        var Ski = createArray(N, bignumber(0));
        var Skj = createArray(N, bignumber(0));
        for(var k = 0; k < N; k++){
            Ski[k] = subtract(multiplyScalar(c, Sij[k][i]), multiplyScalar(s, Sij[k][j]));
            Skj[k] = addScalar(multiplyScalar(s, Sij[k][i]), multiplyScalar(c, Sij[k][j]));
        }
        for(var _k2 = 0; _k2 < N; _k2++){
            Sij[_k2][i] = Ski[_k2];
            Sij[_k2][j] = Skj[_k2];
        }
        return Sij;
    } // update matrix
    function x1Big(Hij, theta, i, j) {
        var N = Hij.length;
        var c = bignumber(cos(theta));
        var s = bignumber(sin(theta));
        var c2 = multiplyScalar(c, c);
        var s2 = multiplyScalar(s, s);
        var Aki = createArray(N, bignumber(0));
        var Akj = createArray(N, bignumber(0)); // 2cs Hij
        var csHij = multiply(bignumber(2), c, s, Hij[i][j]); //  Aii
        var Aii = addScalar(subtract(multiplyScalar(c2, Hij[i][i]), csHij), multiplyScalar(s2, Hij[j][j]));
        var Ajj = add(multiplyScalar(s2, Hij[i][i]), csHij, multiplyScalar(c2, Hij[j][j])); // 0  to i
        for(var k = 0; k < N; k++){
            Aki[k] = subtract(multiplyScalar(c, Hij[i][k]), multiplyScalar(s, Hij[j][k]));
            Akj[k] = addScalar(multiplyScalar(s, Hij[i][k]), multiplyScalar(c, Hij[j][k]));
        } // Modify Hij
        Hij[i][i] = Aii;
        Hij[j][j] = Ajj;
        Hij[i][j] = bignumber(0);
        Hij[j][i] = bignumber(0); // 0  to i
        for(var _k3 = 0; _k3 < N; _k3++)if (_k3 !== i && _k3 !== j) {
            Hij[i][_k3] = Aki[_k3];
            Hij[_k3][i] = Aki[_k3];
            Hij[j][_k3] = Akj[_k3];
            Hij[_k3][j] = Akj[_k3];
        }
        return Hij;
    } // update matrix
    function x1(Hij, theta, i, j) {
        var N = Hij.length;
        var c = Math.cos(theta);
        var s = Math.sin(theta);
        var c2 = c * c;
        var s2 = s * s;
        var Aki = createArray(N, 0);
        var Akj = createArray(N, 0); //  Aii
        var Aii = c2 * Hij[i][i] - 2 * c * s * Hij[i][j] + s2 * Hij[j][j];
        var Ajj = s2 * Hij[i][i] + 2 * c * s * Hij[i][j] + c2 * Hij[j][j]; // 0  to i
        for(var k = 0; k < N; k++){
            Aki[k] = c * Hij[i][k] - s * Hij[j][k];
            Akj[k] = s * Hij[i][k] + c * Hij[j][k];
        } // Modify Hij
        Hij[i][i] = Aii;
        Hij[j][j] = Ajj;
        Hij[i][j] = 0;
        Hij[j][i] = 0; // 0  to i
        for(var _k4 = 0; _k4 < N; _k4++)if (_k4 !== i && _k4 !== j) {
            Hij[i][_k4] = Aki[_k4];
            Hij[_k4][i] = Aki[_k4];
            Hij[j][_k4] = Akj[_k4];
            Hij[_k4][j] = Akj[_k4];
        }
        return Hij;
    } // get max off-diagonal value from Upper Diagonal
    function getAij(Mij) {
        var N = Mij.length;
        var maxMij = 0;
        var maxIJ = [
            0,
            1
        ];
        for(var i = 0; i < N; i++){
            for(var j = i + 1; j < N; j++)if (Math.abs(maxMij) < Math.abs(Mij[i][j])) {
                maxMij = Math.abs(Mij[i][j]);
                maxIJ = [
                    i,
                    j
                ];
            }
        }
        return [
            maxIJ,
            maxMij
        ];
    } // get max off-diagonal value from Upper Diagonal
    function getAijBig(Mij) {
        var N = Mij.length;
        var maxMij = 0;
        var maxIJ = [
            0,
            1
        ];
        for(var i = 0; i < N; i++){
            for(var j = i + 1; j < N; j++)if (abs(maxMij) < abs(Mij[i][j])) {
                maxMij = abs(Mij[i][j]);
                maxIJ = [
                    i,
                    j
                ];
            }
        }
        return [
            maxIJ,
            maxMij
        ];
    } // sort results
    function sorting(E, S) {
        var N = E.length;
        var values = Array(N);
        var vectors = Array(N);
        for(var k = 0; k < N; k++)vectors[k] = Array(N);
        for(var i = 0; i < N; i++){
            var minID = 0;
            var minE = E[0];
            for(var j = 0; j < E.length; j++)if (abs(E[j]) < abs(minE)) {
                minID = j;
                minE = E[minID];
            }
            values[i] = E.splice(minID, 1)[0];
            for(var _k5 = 0; _k5 < N; _k5++){
                vectors[_k5][i] = S[_k5][minID];
                S[_k5].splice(minID, 1);
            }
        }
        return {
            values: values,
            vectors: vectors
        };
    }
    /**
   * Create an array of a certain size and fill all items with an initial value
   * @param {number} size
   * @param {number} value
   * @return {number[]}
   */ function createArray(size, value) {
        // TODO: as soon as all browsers support Array.fill, use that instead (IE doesn't support it)
        var array = new Array(size);
        for(var i = 0; i < size; i++)array[i] = value;
        return array;
    }
    return main;
}



var $6fc6236b87bf06e9$var$name = "eigs"; // The absolute state of math.js's dependency system:
var $6fc6236b87bf06e9$var$dependencies = [
    "config",
    "typed",
    "matrix",
    "addScalar",
    "equal",
    "subtract",
    "abs",
    "atan",
    "cos",
    "sin",
    "multiplyScalar",
    "divideScalar",
    "inv",
    "bignumber",
    "multiply",
    "add",
    "larger",
    "column",
    "flatten",
    "number",
    "complex",
    "sqrt",
    "diag",
    "qr",
    "usolve",
    "usolveAll",
    "im",
    "re",
    "smaller",
    "matrixFromColumns",
    "dot"
];
var $6fc6236b87bf06e9$export$ba9e077a2df092d7 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($6fc6236b87bf06e9$var$name, $6fc6236b87bf06e9$var$dependencies, (_ref)=>{
    var { config: config, typed: typed, matrix: matrix, addScalar: addScalar, subtract: subtract, equal: equal, abs: abs, atan: atan, cos: cos, sin: sin, multiplyScalar: multiplyScalar, divideScalar: divideScalar, inv: inv, bignumber: bignumber, multiply: multiply, add: add, larger: larger, column: column, flatten: flatten, number: number, complex: complex, sqrt: sqrt, diag: diag, qr: qr, usolve: usolve, usolveAll: usolveAll, im: im, re: re, smaller: smaller, matrixFromColumns: matrixFromColumns, dot: dot } = _ref;
    var doRealSymetric = (0, $fe6e22733ee75ddd$export$a8f76d83a88e1b99)({
        config: config,
        addScalar: addScalar,
        subtract: subtract,
        column: column,
        flatten: flatten,
        equal: equal,
        abs: abs,
        atan: atan,
        cos: cos,
        sin: sin,
        multiplyScalar: multiplyScalar,
        inv: inv,
        bignumber: bignumber,
        complex: complex,
        multiply: multiply,
        add: add
    });
    var doComplexEigs = (0, $6297ea39689cbd93$export$190353ff415180b5)({
        config: config,
        addScalar: addScalar,
        subtract: subtract,
        multiply: multiply,
        multiplyScalar: multiplyScalar,
        flatten: flatten,
        divideScalar: divideScalar,
        sqrt: sqrt,
        abs: abs,
        bignumber: bignumber,
        diag: diag,
        qr: qr,
        inv: inv,
        usolve: usolve,
        usolveAll: usolveAll,
        equal: equal,
        complex: complex,
        larger: larger,
        smaller: smaller,
        matrixFromColumns: matrixFromColumns,
        dot: dot
    });
    /**
   * Compute eigenvalues and eigenvectors of a matrix. The eigenvalues are sorted by their absolute value, ascending.
   * An eigenvalue with multiplicity k will be listed k times. The eigenvectors are returned as columns of a matrix –
   * the eigenvector that belongs to the j-th eigenvalue in the list (eg. `values[j]`) is the j-th column (eg. `column(vectors, j)`).
   * If the algorithm fails to converge, it will throw an error – in that case, however, you may still find useful information
   * in `err.values` and `err.vectors`.
   *
   * Syntax:
   *
   *     math.eigs(x, [prec])
   *
   * Examples:
   *
   *     const { eigs, multiply, column, transpose } = math
   *     const H = [[5, 2.3], [2.3, 1]]
   *     const ans = eigs(H) // returns {values: [E1,E2...sorted], vectors: [v1,v2.... corresponding vectors as columns]}
   *     const E = ans.values
   *     const U = ans.vectors
   *     multiply(H, column(U, 0)) // returns multiply(E[0], column(U, 0))
   *     const UTxHxU = multiply(transpose(U), H, U) // diagonalizes H
   *     E[0] == UTxHxU[0][0]  // returns true
   *
   * See also:
   *
   *     inv
   *
   * @param {Array | Matrix} x  Matrix to be diagonalized
   *
   * @param {number | BigNumber} [prec] Precision, default value: 1e-15
   * @return {{values: Array|Matrix, vectors: Array|Matrix}} Object containing an array of eigenvalues and a matrix with eigenvectors as columns.
   *
   */ return typed("eigs", {
        Array: function Array(x) {
            var mat = matrix(x);
            return computeValuesAndVectors(mat);
        },
        "Array, number|BigNumber": function ArrayNumberBigNumber(x, prec) {
            var mat = matrix(x);
            return computeValuesAndVectors(mat, prec);
        },
        Matrix: function Matrix(mat) {
            var { values: values, vectors: vectors } = computeValuesAndVectors(mat);
            return {
                values: matrix(values),
                vectors: matrix(vectors)
            };
        },
        "Matrix, number|BigNumber": function MatrixNumberBigNumber(mat, prec) {
            var { values: values, vectors: vectors } = computeValuesAndVectors(mat, prec);
            return {
                values: matrix(values),
                vectors: matrix(vectors)
            };
        }
    });
    function computeValuesAndVectors(mat, prec) {
        if (prec === undefined) prec = config.epsilon;
        var size = mat.size();
        if (size.length !== 2 || size[0] !== size[1]) throw new RangeError("Matrix must be square (size: " + (0, $b94963e97c376b6d$export$d9468344d3651243)(size) + ")");
        var arr = mat.toArray();
        var N = size[0];
        if (isReal(arr, N, prec)) {
            coerceReal(arr, N);
            if (isSymmetric(arr, N, prec)) {
                var _type = coerceTypes(mat, arr, N);
                return doRealSymetric(arr, N, prec, _type);
            }
        }
        var type = coerceTypes(mat, arr, N);
        return doComplexEigs(arr, N, prec, type);
    }
    /** @return {boolean} */ function isSymmetric(arr, N, prec) {
        for(var i = 0; i < N; i++)for(var j = i; j < N; j++){
            // TODO proper comparison of bignum and frac
            if (larger(bignumber(abs(subtract(arr[i][j], arr[j][i]))), prec)) return false;
        }
        return true;
    }
    /** @return {boolean} */ function isReal(arr, N, prec) {
        for(var i = 0; i < N; i++)for(var j = 0; j < N; j++){
            // TODO proper comparison of bignum and frac
            if (larger(bignumber(abs(im(arr[i][j]))), prec)) return false;
        }
        return true;
    }
    function coerceReal(arr, N) {
        for(var i = 0; i < N; i++)for(var j = 0; j < N; j++)arr[i][j] = re(arr[i][j]);
    }
    /** @return {'number' | 'BigNumber' | 'Complex'} */ function coerceTypes(mat, arr, N) {
        /** @type {string} */ var type = mat.datatype();
        if (type === "number" || type === "BigNumber" || type === "Complex") return type;
        var hasNumber = false;
        var hasBig = false;
        var hasComplex = false;
        for(var i = 0; i < N; i++)for(var j = 0; j < N; j++){
            var el = arr[i][j];
            if ((0, $d8097b7a6d6e36d8$export$7e4aa119212bc614)(el) || (0, $d8097b7a6d6e36d8$export$e312cb8a8e5e7c34)(el)) hasNumber = true;
            else if ((0, $d8097b7a6d6e36d8$export$e51d0e7e5c4a03ab)(el)) hasBig = true;
            else if ((0, $d8097b7a6d6e36d8$export$8849a896711efe0c)(el)) hasComplex = true;
            else throw TypeError("Unsupported type in Matrix: " + (0, $d8097b7a6d6e36d8$export$f5bbd400c2f4426f)(el));
        }
        if (hasBig && hasComplex) console.warn("Complex BigNumbers not supported, this operation will lose precission.");
        if (hasComplex) {
            for(var _i = 0; _i < N; _i++)for(var _j = 0; _j < N; _j++)arr[_i][_j] = complex(arr[_i][_j]);
            return "Complex";
        }
        if (hasBig) {
            for(var _i2 = 0; _i2 < N; _i2++)for(var _j2 = 0; _j2 < N; _j2++)arr[_i2][_j2] = bignumber(arr[_i2][_j2]);
            return "BigNumber";
        }
        if (hasNumber) {
            for(var _i3 = 0; _i3 < N; _i3++)for(var _j3 = 0; _j3 < N; _j3++)arr[_i3][_j3] = number(arr[_i3][_j3]);
            return "number";
        } else throw TypeError("Matrix contains unsupported types only.");
    }
});





var $ca8f568d87cc3b8f$var$name = "mean";
var $ca8f568d87cc3b8f$var$dependencies = [
    "typed",
    "add",
    "divide"
];
var $ca8f568d87cc3b8f$export$301ef7ca1de6782c = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($ca8f568d87cc3b8f$var$name, $ca8f568d87cc3b8f$var$dependencies, (_ref)=>{
    var { typed: typed, add: add, divide: divide } = _ref;
    /**
   * Compute the mean value of matrix or a list with values.
   * In case of a multi dimensional array, the mean of the flattened array
   * will be calculated. When `dim` is provided, the maximum over the selected
   * dimension will be calculated. Parameter `dim` is zero-based.
   *
   * Syntax:
   *
   *     math.mean(a, b, c, ...)
   *     math.mean(A)
   *     math.mean(A, dim)
   *
   * Examples:
   *
   *     math.mean(2, 1, 4, 3)                     // returns 2.5
   *     math.mean([1, 2.7, 3.2, 4])               // returns 2.725
   *
   *     math.mean([[2, 5], [6, 3], [1, 7]], 0)    // returns [3, 5]
   *     math.mean([[2, 5], [6, 3], [1, 7]], 1)    // returns [3.5, 4.5, 4]
   *
   * See also:
   *
   *     median, min, max, sum, prod, std, variance
   *
   * @param {... *} args  A single matrix or or multiple scalar values
   * @return {*} The mean of all values
   */ return typed($ca8f568d87cc3b8f$var$name, {
        // mean([a, b, c, d, ...])
        "Array | Matrix": _mean,
        // mean([a, b, c, d, ...], dim)
        "Array | Matrix, number | BigNumber": _nmeanDim,
        // mean(a, b, c, d, ...)
        "...": function _(args) {
            if ((0, $dd57e6221b0e50b6$export$4d8f6a27e2f5bcb2)(args)) throw new TypeError("Scalar values expected in function mean");
            return _mean(args);
        }
    });
    /**
   * Calculate the mean value in an n-dimensional array, returning a
   * n-1 dimensional array
   * @param {Array} array
   * @param {number} dim
   * @return {number} mean
   * @private
   */ function _nmeanDim(array, dim) {
        try {
            var sum = (0, $dd57e6221b0e50b6$export$533b26079ad0b4b)(array, dim, add);
            var s = Array.isArray(array) ? (0, $a14a10567870d913$export$51ffaee4afb683a5)(array) : array.size();
            return divide(sum, s[dim]);
        } catch (err) {
            throw (0, $b113219b83527e4b$export$c8994973cec629ae)(err, "mean");
        }
    }
    /**
   * Recursively calculate the mean value in an n-dimensional array
   * @param {Array} array
   * @return {number} mean
   * @private
   */ function _mean(array) {
        var sum;
        var num = 0;
        (0, $dd57e6221b0e50b6$export$519ada94592b97fc)(array, function(value) {
            try {
                sum = sum === undefined ? value : add(sum, value);
                num++;
            } catch (err) {
                throw (0, $b113219b83527e4b$export$c8994973cec629ae)(err, "mean", value);
            }
        });
        if (num === 0) throw new Error("Cannot calculate the mean of an empty array");
        return divide(sum, num);
    }
});



var $0494ffff2b4a0baf$var$name = "setSymDifference";
var $0494ffff2b4a0baf$var$dependencies = [
    "typed",
    "size",
    "concat",
    "subset",
    "setDifference",
    "Index"
];
var $0494ffff2b4a0baf$export$4a9a0ead2012bfc4 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($0494ffff2b4a0baf$var$name, $0494ffff2b4a0baf$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, concat: concat, subset: subset, setDifference: setDifference, Index: Index } = _ref;
    /**
   * Create the symmetric difference of two (multi)sets.
   * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
   *
   * Syntax:
   *
   *    math.setSymDifference(set1, set2)
   *
   * Examples:
   *
   *    math.setSymDifference([1, 2, 3, 4], [3, 4, 5, 6])            // returns [1, 2, 5, 6]
   *    math.setSymDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])    // returns [1, 2, 5, 6]
   *
   * See also:
   *
   *    setUnion, setIntersect, setDifference
   *
   * @param {Array | Matrix}    a1  A (multi)set
   * @param {Array | Matrix}    a2  A (multi)set
   * @return {Array | Matrix}    The symmetric difference of two (multi)sets
   */ return typed($0494ffff2b4a0baf$var$name, {
        "Array | Matrix, Array | Matrix": function ArrayMatrixArrayMatrix(a1, a2) {
            if (subset(size(a1), new Index(0)) === 0) // if any of them is empty, return the other one
            return (0, $a14a10567870d913$export$bffa455ba8c619a6)(a2);
            else if (subset(size(a2), new Index(0)) === 0) return (0, $a14a10567870d913$export$bffa455ba8c619a6)(a1);
            var b1 = (0, $a14a10567870d913$export$bffa455ba8c619a6)(a1);
            var b2 = (0, $a14a10567870d913$export$bffa455ba8c619a6)(a2);
            return concat(setDifference(b1, b2), setDifference(b2, b1));
        }
    });
});




/**
 * Permutes a vector; x = P'b. In MATLAB notation, x(p)=b.
 *
 * @param {Array} p           The permutation vector of length n. null value denotes identity
 * @param {Array} b           The input vector
 *
 * @return {Array}            The output vector x = P'b
 */ function $1a8a2407e61d38c6$export$29cc81cfd083fd62(p, b) {
    // vars
    var k;
    var n = b.length;
    var x = []; // check permutation vector was provided, p = null denotes identity
    if (p) // loop vector
    for(k = 0; k < n; k++)// apply permutation
    x[p[k]] = b[k];
    else // loop vector
    for(k = 0; k < n; k++)// x[i] = b[i]
    x[k] = b[k];
    return x;
}


var $355a604d27dae86b$var$name = "lusolve";
var $355a604d27dae86b$var$dependencies = [
    "typed",
    "matrix",
    "lup",
    "slu",
    "usolve",
    "lsolve",
    "DenseMatrix"
];
var $355a604d27dae86b$export$a3f0777edf21dcd5 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($355a604d27dae86b$var$name, $355a604d27dae86b$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, lup: lup, slu: slu, usolve: usolve, lsolve: lsolve, DenseMatrix: DenseMatrix } = _ref;
    var solveValidation = (0, $5b483e7b4659dfae$export$6accbcba5dda801d)({
        DenseMatrix: DenseMatrix
    });
    /**
   * Solves the linear system `A * x = b` where `A` is an [n x n] matrix and `b` is a [n] column vector.
   *
   * Syntax:
   *
   *    math.lusolve(A, b)     // returns column vector with the solution to the linear system A * x = b
   *    math.lusolve(lup, b)   // returns column vector with the solution to the linear system A * x = b, lup = math.lup(A)
   *
   * Examples:
   *
   *    const m = [[1, 0, 0, 0], [0, 2, 0, 0], [0, 0, 3, 0], [0, 0, 0, 4]]
   *
   *    const x = math.lusolve(m, [-1, -1, -1, -1])        // x = [[-1], [-0.5], [-1/3], [-0.25]]
   *
   *    const f = math.lup(m)
   *    const x1 = math.lusolve(f, [-1, -1, -1, -1])       // x1 = [[-1], [-0.5], [-1/3], [-0.25]]
   *    const x2 = math.lusolve(f, [1, 2, 1, -1])          // x2 = [[1], [1], [1/3], [-0.25]]
   *
   *    const a = [[-2, 3], [2, 1]]
   *    const b = [11, 9]
   *    const x = math.lusolve(a, b)  // [[2], [5]]
   *
   * See also:
   *
   *    lup, slu, lsolve, usolve
   *
   * @param {Matrix | Array | Object} A      Invertible Matrix or the Matrix LU decomposition
   * @param {Matrix | Array} b               Column Vector
   * @param {number} [order]                 The Symbolic Ordering and Analysis order, see slu for details. Matrix must be a SparseMatrix
   * @param {Number} [threshold]             Partial pivoting threshold (1 for partial pivoting), see slu for details. Matrix must be a SparseMatrix.
   *
   * @return {DenseMatrix | Array}           Column vector with the solution to the linear system A * x = b
   */ return typed($355a604d27dae86b$var$name, {
        "Array, Array | Matrix": function ArrayArrayMatrix(a, b) {
            a = matrix(a);
            var d = lup(a);
            var x = _lusolve(d.L, d.U, d.p, null, b);
            return x.valueOf();
        },
        "DenseMatrix, Array | Matrix": function DenseMatrixArrayMatrix(a, b) {
            var d = lup(a);
            return _lusolve(d.L, d.U, d.p, null, b);
        },
        "SparseMatrix, Array | Matrix": function SparseMatrixArrayMatrix(a, b) {
            var d = lup(a);
            return _lusolve(d.L, d.U, d.p, null, b);
        },
        "SparseMatrix, Array | Matrix, number, number": function SparseMatrixArrayMatrixNumberNumber(a, b, order, threshold) {
            var d = slu(a, order, threshold);
            return _lusolve(d.L, d.U, d.p, d.q, b);
        },
        "Object, Array | Matrix": function ObjectArrayMatrix(d, b) {
            return _lusolve(d.L, d.U, d.p, d.q, b);
        }
    });
    function _toMatrix(a) {
        if ((0, $d8097b7a6d6e36d8$export$b22160e0a14f87b7)(a)) return a;
        if ((0, $d8097b7a6d6e36d8$export$43bee75e5e14138e)(a)) return matrix(a);
        throw new TypeError("Invalid Matrix LU decomposition");
    }
    function _lusolve(l, u, p, q, b) {
        // verify decomposition
        l = _toMatrix(l);
        u = _toMatrix(u); // apply row permutations if needed (b is a DenseMatrix)
        if (p) {
            b = solveValidation(l, b, true);
            b._data = (0, $1a8a2407e61d38c6$export$29cc81cfd083fd62)(p, b._data);
        } // use forward substitution to resolve L * y = b
        var y = lsolve(l, b); // use backward substitution to resolve U * x = y
        var x = usolve(u, y); // apply column permutations if needed (x is a DenseMatrix)
        if (q) x._data = (0, $1a8a2407e61d38c6$export$29cc81cfd083fd62)(q, x._data);
        return x;
    }
});





var $7146c3b54b34babd$var$name = "median";
var $7146c3b54b34babd$var$dependencies = [
    "typed",
    "add",
    "divide",
    "compare",
    "partitionSelect"
];
var $7146c3b54b34babd$export$cdebf3fc89add777 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($7146c3b54b34babd$var$name, $7146c3b54b34babd$var$dependencies, (_ref)=>{
    var { typed: typed, add: add, divide: divide, compare: compare, partitionSelect: partitionSelect } = _ref;
    /**
   * Recursively calculate the median of an n-dimensional array
   * @param {Array} array
   * @return {Number} median
   * @private
   */ function _median(array) {
        try {
            array = (0, $a14a10567870d913$export$bffa455ba8c619a6)(array.valueOf());
            var num = array.length;
            if (num === 0) throw new Error("Cannot calculate median of an empty array");
            if (num % 2 === 0) {
                // even: return the average of the two middle values
                var mid = num / 2 - 1;
                var right = partitionSelect(array, mid + 1); // array now partitioned at mid + 1, take max of left part
                var left = array[mid];
                for(var i = 0; i < mid; ++i)if (compare(array[i], left) > 0) left = array[i];
                return middle2(left, right);
            } else {
                // odd: return the middle value
                var m = partitionSelect(array, (num - 1) / 2);
                return middle(m);
            }
        } catch (err) {
            throw (0, $b113219b83527e4b$export$c8994973cec629ae)(err, "median");
        }
    } // helper function to type check the middle value of the array
    var middle = typed({
        "number | BigNumber | Complex | Unit": function numberBigNumberComplexUnit(value) {
            return value;
        }
    }); // helper function to type check the two middle value of the array
    var middle2 = typed({
        "number | BigNumber | Complex | Unit, number | BigNumber | Complex | Unit": function numberBigNumberComplexUnitNumberBigNumberComplexUnit(left, right) {
            return divide(add(left, right), 2);
        }
    });
    /**
   * Compute the median of a matrix or a list with values. The values are
   * sorted and the middle value is returned. In case of an even number of
   * values, the average of the two middle values is returned.
   * Supported types of values are: Number, BigNumber, Unit
   *
   * In case of a (multi dimensional) array or matrix, the median of all
   * elements will be calculated.
   *
   * Syntax:
   *
   *     math.median(a, b, c, ...)
   *     math.median(A)
   *
   * Examples:
   *
   *     math.median(5, 2, 7)        // returns 5
   *     math.median([3, -1, 5, 7])  // returns 4
   *
   * See also:
   *
   *     mean, min, max, sum, prod, std, variance, quantileSeq
   *
   * @param {... *} args  A single matrix or or multiple scalar values
   * @return {*} The median
   */ return typed($7146c3b54b34babd$var$name, {
        // median([a, b, c, d, ...])
        "Array | Matrix": _median,
        // median([a, b, c, d, ...], dim)
        "Array | Matrix, number | BigNumber": function ArrayMatrixNumberBigNumber(array, dim) {
            // TODO: implement median(A, dim)
            throw new Error("median(A, dim) is not yet supported"); // return reduce(arguments[0], arguments[1], ...)
        },
        // median(a, b, c, d, ...)
        "...": function _(args) {
            if ((0, $dd57e6221b0e50b6$export$4d8f6a27e2f5bcb2)(args)) throw new TypeError("Scalar values expected in function median");
            return _median(args);
        }
    });
});



var $3e01998067e0dde5$var$name = "setUnion";
var $3e01998067e0dde5$var$dependencies = [
    "typed",
    "size",
    "concat",
    "subset",
    "setIntersect",
    "setSymDifference",
    "Index"
];
var $3e01998067e0dde5$export$fbdfd2054d37f888 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($3e01998067e0dde5$var$name, $3e01998067e0dde5$var$dependencies, (_ref)=>{
    var { typed: typed, size: size, concat: concat, subset: subset, setIntersect: setIntersect, setSymDifference: setSymDifference, Index: Index } = _ref;
    /**
   * Create the union of two (multi)sets.
   * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
   *
   * Syntax:
   *
   *    math.setUnion(set1, set2)
   *
   * Examples:
   *
   *    math.setUnion([1, 2, 3, 4], [3, 4, 5, 6])            // returns [1, 2, 3, 4, 5, 6]
   *    math.setUnion([[1, 2], [3, 4]], [[3, 4], [5, 6]])    // returns [1, 2, 3, 4, 5, 6]
   *
   * See also:
   *
   *    setIntersect, setDifference
   *
   * @param {Array | Matrix}    a1  A (multi)set
   * @param {Array | Matrix}    a2  A (multi)set
   * @return {Array | Matrix}    The union of two (multi)sets
   */ return typed($3e01998067e0dde5$var$name, {
        "Array | Matrix, Array | Matrix": function ArrayMatrixArrayMatrix(a1, a2) {
            if (subset(size(a1), new Index(0)) === 0) // if any of them is empty, return the other one
            return (0, $a14a10567870d913$export$bffa455ba8c619a6)(a2);
            else if (subset(size(a2), new Index(0)) === 0) return (0, $a14a10567870d913$export$bffa455ba8c619a6)(a1);
            var b1 = (0, $a14a10567870d913$export$bffa455ba8c619a6)(a1);
            var b2 = (0, $a14a10567870d913$export$bffa455ba8c619a6)(a2);
            return concat(setSymDifference(b1, b2), setIntersect(b1, b2));
        }
    });
});





var $cd7877b745b67b56$var$DEFAULT_NORMALIZATION = "unbiased";
var $cd7877b745b67b56$var$name = "variance";
var $cd7877b745b67b56$var$dependencies = [
    "typed",
    "add",
    "subtract",
    "multiply",
    "divide",
    "apply",
    "isNaN"
];
var $cd7877b745b67b56$export$b989221824390fb = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($cd7877b745b67b56$var$name, $cd7877b745b67b56$var$dependencies, (_ref)=>{
    var { typed: typed, add: add, subtract: subtract, multiply: multiply, divide: divide, apply: apply, isNaN: isNaN } = _ref;
    /**
   * Compute the variance of a matrix or a  list with values.
   * In case of a (multi dimensional) array or matrix, the variance over all
   * elements will be calculated.
   *
   * Additionally, it is possible to compute the variance along the rows
   * or columns of a matrix by specifying the dimension as the second argument.
   *
   * Optionally, the type of normalization can be specified as the final
   * parameter. The parameter `normalization` can be one of the following values:
   *
   * - 'unbiased' (default) The sum of squared errors is divided by (n - 1)
   * - 'uncorrected'        The sum of squared errors is divided by n
   * - 'biased'             The sum of squared errors is divided by (n + 1)
   *
   *
   * Note that older browser may not like the variable name `var`. In that
   * case, the function can be called as `math['var'](...)` instead of
   * `math.var(...)`.
   *
   * Syntax:
   *
   *     math.variance(a, b, c, ...)
   *     math.variance(A)
   *     math.variance(A, normalization)
   *     math.variance(A, dimension)
   *     math.variance(A, dimension, normalization)
   *
   * Examples:
   *
   *     math.variance(2, 4, 6)                     // returns 4
   *     math.variance([2, 4, 6, 8])                // returns 6.666666666666667
   *     math.variance([2, 4, 6, 8], 'uncorrected') // returns 5
   *     math.variance([2, 4, 6, 8], 'biased')      // returns 4
   *
   *     math.variance([[1, 2, 3], [4, 5, 6]])      // returns 3.5
   *     math.variance([[1, 2, 3], [4, 6, 8]], 0)   // returns [4.5, 8, 12.5]
   *     math.variance([[1, 2, 3], [4, 6, 8]], 1)   // returns [1, 4]
   *     math.variance([[1, 2, 3], [4, 6, 8]], 1, 'biased') // returns [0.5, 2]
   *
   * See also:
   *
   *    mean, median, max, min, prod, std, sum
   *
   * @param {Array | Matrix} array
   *                        A single matrix or or multiple scalar values
   * @param {string} [normalization='unbiased']
   *                        Determines how to normalize the variance.
   *                        Choose 'unbiased' (default), 'uncorrected', or 'biased'.
   * @param dimension {number | BigNumber}
   *                        Determines the axis to compute the variance for a matrix
   * @return {*} The variance
   */ return typed($cd7877b745b67b56$var$name, {
        // variance([a, b, c, d, ...])
        "Array | Matrix": function ArrayMatrix(array) {
            return _var(array, $cd7877b745b67b56$var$DEFAULT_NORMALIZATION);
        },
        // variance([a, b, c, d, ...], normalization)
        "Array | Matrix, string": _var,
        // variance([a, b, c, c, ...], dim)
        "Array | Matrix, number | BigNumber": function ArrayMatrixNumberBigNumber(array, dim) {
            return _varDim(array, dim, $cd7877b745b67b56$var$DEFAULT_NORMALIZATION);
        },
        // variance([a, b, c, c, ...], dim, normalization)
        "Array | Matrix, number | BigNumber, string": _varDim,
        // variance(a, b, c, d, ...)
        "...": function _(args) {
            return _var(args, $cd7877b745b67b56$var$DEFAULT_NORMALIZATION);
        }
    });
    /**
   * Recursively calculate the variance of an n-dimensional array
   * @param {Array} array
   * @param {string} normalization
   *                        Determines how to normalize the variance:
   *                        - 'unbiased'    The sum of squared errors is divided by (n - 1)
   *                        - 'uncorrected' The sum of squared errors is divided by n
   *                        - 'biased'      The sum of squared errors is divided by (n + 1)
   * @return {number | BigNumber} variance
   * @private
   */ function _var(array, normalization) {
        var sum;
        var num = 0;
        if (array.length === 0) throw new SyntaxError("Function variance requires one or more parameters (0 provided)");
         // calculate the mean and number of elements
        (0, $dd57e6221b0e50b6$export$519ada94592b97fc)(array, function(value) {
            try {
                sum = sum === undefined ? value : add(sum, value);
                num++;
            } catch (err) {
                throw (0, $b113219b83527e4b$export$c8994973cec629ae)(err, "variance", value);
            }
        });
        if (num === 0) throw new Error("Cannot calculate variance of an empty array");
        var mean = divide(sum, num); // calculate the variance
        sum = undefined;
        (0, $dd57e6221b0e50b6$export$519ada94592b97fc)(array, function(value) {
            var diff = subtract(value, mean);
            sum = sum === undefined ? multiply(diff, diff) : add(sum, multiply(diff, diff));
        });
        if (isNaN(sum)) return sum;
        switch(normalization){
            case "uncorrected":
                return divide(sum, num);
            case "biased":
                return divide(sum, num + 1);
            case "unbiased":
                var zero = (0, $d8097b7a6d6e36d8$export$e51d0e7e5c4a03ab)(sum) ? sum.mul(0) : 0;
                return num === 1 ? zero : divide(sum, num - 1);
            default:
                throw new Error('Unknown normalization "' + normalization + '". ' + 'Choose "unbiased" (default), "uncorrected", or "biased".');
        }
    }
    function _varDim(array, dim, normalization) {
        try {
            if (array.length === 0) throw new SyntaxError("Function variance requires one or more parameters (0 provided)");
            return apply(array, dim, (x)=>_var(x, normalization));
        } catch (err) {
            throw (0, $b113219b83527e4b$export$c8994973cec629ae)(err, "variance");
        }
    }
});


var $19bea5148572fcc2$var$name = "kldivergence";
var $19bea5148572fcc2$var$dependencies = [
    "typed",
    "matrix",
    "divide",
    "sum",
    "multiply",
    "dotDivide",
    "log",
    "isNumeric"
];
var $19bea5148572fcc2$export$eaa5cb8fd86b8d43 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($19bea5148572fcc2$var$name, $19bea5148572fcc2$var$dependencies, (_ref)=>{
    var { typed: typed, matrix: matrix, divide: divide, sum: sum, multiply: multiply, dotDivide: dotDivide, log: log, isNumeric: isNumeric } = _ref;
    /**
     * Calculate the Kullback-Leibler (KL) divergence  between two distributions
     *
     * Syntax:
     *
     *     math.kldivergence(x, y)
     *
     * Examples:
     *
     *     math.kldivergence([0.7,0.5,0.4], [0.2,0.9,0.5])   //returns 0.24376698773121153
     *
     *
     * @param  {Array | Matrix} q    First vector
     * @param  {Array | Matrix} p    Second vector
     * @return {number}              Returns distance between q and p
     */ return typed($19bea5148572fcc2$var$name, {
        "Array, Array": function ArrayArray(q, p) {
            return _kldiv(matrix(q), matrix(p));
        },
        "Matrix, Array": function MatrixArray(q, p) {
            return _kldiv(q, matrix(p));
        },
        "Array, Matrix": function ArrayMatrix(q, p) {
            return _kldiv(matrix(q), p);
        },
        "Matrix, Matrix": function MatrixMatrix(q, p) {
            return _kldiv(q, p);
        }
    });
    function _kldiv(q, p) {
        var plength = p.size().length;
        var qlength = q.size().length;
        if (plength > 1) throw new Error("first object must be one dimensional");
        if (qlength > 1) throw new Error("second object must be one dimensional");
        if (plength !== qlength) throw new Error("Length of two vectors must be equal");
         // Before calculation, apply normalization
        var sumq = sum(q);
        if (sumq === 0) throw new Error("Sum of elements in first object must be non zero");
        var sump = sum(p);
        if (sump === 0) throw new Error("Sum of elements in second object must be non zero");
        var qnorm = divide(q, sum(q));
        var pnorm = divide(p, sum(p));
        var result = sum(multiply(qnorm, log(dotDivide(qnorm, pnorm))));
        if (isNumeric(result)) return result;
        else return Number.NaN;
    }
});


var $2b94a62b68f7788c$var$name = "norm";
var $2b94a62b68f7788c$var$dependencies = [
    "typed",
    "abs",
    "add",
    "pow",
    "conj",
    "sqrt",
    "multiply",
    "equalScalar",
    "larger",
    "smaller",
    "matrix",
    "ctranspose",
    "eigs"
];
var $2b94a62b68f7788c$export$ce85a9d2952c2966 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($2b94a62b68f7788c$var$name, $2b94a62b68f7788c$var$dependencies, (_ref)=>{
    var { typed: typed, abs: abs, add: add, pow: pow, conj: conj, sqrt: sqrt, multiply: multiply, equalScalar: equalScalar, larger: larger, smaller: smaller, matrix: matrix, ctranspose: ctranspose, eigs: eigs } = _ref;
    /**
   * Calculate the norm of a number, vector or matrix.
   *
   * The second parameter p is optional. If not provided, it defaults to 2.
   *
   * Syntax:
   *
   *    math.norm(x)
   *    math.norm(x, p)
   *
   * Examples:
   *
   *    math.abs(-3.5)                         // returns 3.5
   *    math.norm(-3.5)                        // returns 3.5
   *
   *    math.norm(math.complex(3, -4))         // returns 5
   *
   *    math.norm([1, 2, -3], Infinity)        // returns 3
   *    math.norm([1, 2, -3], -Infinity)       // returns 1
   *
   *    math.norm([3, 4], 2)                   // returns 5
   *
   *    math.norm([[1, 2], [3, 4]], 1)          // returns 6
   *    math.norm([[1, 2], [3, 4]], 'inf')     // returns 7
   *    math.norm([[1, 2], [3, 4]], 'fro')     // returns 5.477225575051661
   *
   * See also:
   *
   *    abs, hypot
   *
   * @param  {number | BigNumber | Complex | Array | Matrix} x
   *            Value for which to calculate the norm
   * @param  {number | BigNumber | string} [p=2]
   *            Vector space.
   *            Supported numbers include Infinity and -Infinity.
   *            Supported strings are: 'inf', '-inf', and 'fro' (The Frobenius norm)
   * @return {number | BigNumber} the p-norm
   */ return typed($2b94a62b68f7788c$var$name, {
        number: Math.abs,
        Complex: function Complex(x) {
            return x.abs();
        },
        BigNumber: function BigNumber(x) {
            // norm(x) = abs(x)
            return x.abs();
        },
        boolean: function boolean(x) {
            // norm(x) = abs(x)
            return Math.abs(x);
        },
        Array: function Array(x) {
            return _norm(matrix(x), 2);
        },
        Matrix: function Matrix(x) {
            return _norm(x, 2);
        },
        "number | Complex | BigNumber | boolean, number | BigNumber | string": function numberComplexBigNumberBooleanNumberBigNumberString(x) {
            // ignore second parameter, TODO: remove the option of second parameter for these types
            return this(x);
        },
        "Array, number | BigNumber | string": function ArrayNumberBigNumberString(x, p) {
            return _norm(matrix(x), p);
        },
        "Matrix, number | BigNumber | string": function MatrixNumberBigNumberString(x, p) {
            return _norm(x, p);
        }
    });
    /**
   * Calculate the plus infinity norm for a vector
   * @param {Matrix} x
   * @returns {number} Returns the norm
   * @private
   */ function _vectorNormPlusInfinity(x) {
        // norm(x, Infinity) = max(abs(x))
        var pinf = 0; // skip zeros since abs(0) === 0
        x.forEach(function(value) {
            var v = abs(value);
            if (larger(v, pinf)) pinf = v;
        }, true);
        return pinf;
    }
    /**
   * Calculate the minus infinity norm for a vector
   * @param {Matrix} x
   * @returns {number} Returns the norm
   * @private
   */ function _vectorNormMinusInfinity(x) {
        // norm(x, -Infinity) = min(abs(x))
        var ninf; // skip zeros since abs(0) === 0
        x.forEach(function(value) {
            var v = abs(value);
            if (!ninf || smaller(v, ninf)) ninf = v;
        }, true);
        return ninf || 0;
    }
    /**
   * Calculate the norm for a vector
   * @param {Matrix} x
   * @param {number | string} p
   * @returns {number} Returns the norm
   * @private
   */ function _vectorNorm(x, p) {
        // check p
        if (p === Number.POSITIVE_INFINITY || p === "inf") return _vectorNormPlusInfinity(x);
        if (p === Number.NEGATIVE_INFINITY || p === "-inf") return _vectorNormMinusInfinity(x);
        if (p === "fro") return _norm(x, 2);
        if (typeof p === "number" && !isNaN(p)) {
            // check p != 0
            if (!equalScalar(p, 0)) {
                // norm(x, p) = sum(abs(xi) ^ p) ^ 1/p
                var n = 0; // skip zeros since abs(0) === 0
                x.forEach(function(value) {
                    n = add(pow(abs(value), p), n);
                }, true);
                return pow(n, 1 / p);
            }
            return Number.POSITIVE_INFINITY;
        } // invalid parameter value
        throw new Error("Unsupported parameter value");
    }
    /**
   * Calculate the Frobenius norm for a matrix
   * @param {Matrix} x
   * @returns {number} Returns the norm
   * @private
   */ function _matrixNormFrobenius(x) {
        // norm(x) = sqrt(sum(diag(x'x)))
        var fro = 0;
        x.forEach(function(value, index) {
            fro = add(fro, multiply(value, conj(value)));
        });
        return abs(sqrt(fro));
    }
    /**
   * Calculate the norm L1 for a matrix
   * @param {Matrix} x
   * @returns {number} Returns the norm
   * @private
   */ function _matrixNormOne(x) {
        // norm(x) = the largest column sum
        var c = []; // result
        var maxc = 0; // skip zeros since abs(0) == 0
        x.forEach(function(value, index) {
            var j = index[1];
            var cj = add(c[j] || 0, abs(value));
            if (larger(cj, maxc)) maxc = cj;
            c[j] = cj;
        }, true);
        return maxc;
    }
    /**
   * Calculate the norm L2 for a matrix
   * @param {Matrix} x
   * @returns {number} Returns the norm
   * @private
   */ function _matrixNormTwo(x) {
        // norm(x) = sqrt( max eigenvalue of A*.A)
        var sizeX = x.size();
        if (sizeX[0] !== sizeX[1]) throw new RangeError("Invalid matrix dimensions");
        var tx = ctranspose(x);
        var squaredX = multiply(tx, x);
        var eigenVals = eigs(squaredX).values.toArray();
        var rho = eigenVals[eigenVals.length - 1];
        return abs(sqrt(rho));
    }
    /**
   * Calculate the infinity norm for a matrix
   * @param {Matrix} x
   * @returns {number} Returns the norm
   * @private
   */ function _matrixNormInfinity(x) {
        // norm(x) = the largest row sum
        var r = []; // result
        var maxr = 0; // skip zeros since abs(0) == 0
        x.forEach(function(value, index) {
            var i = index[0];
            var ri = add(r[i] || 0, abs(value));
            if (larger(ri, maxr)) maxr = ri;
            r[i] = ri;
        }, true);
        return maxr;
    }
    /**
   * Calculate the norm for a 2D Matrix (M*N)
   * @param {Matrix} x
   * @param {number | string} p
   * @returns {number} Returns the norm
   * @private
   */ function _matrixNorm(x, p) {
        // check p
        if (p === 1) return _matrixNormOne(x);
        if (p === Number.POSITIVE_INFINITY || p === "inf") return _matrixNormInfinity(x);
        if (p === "fro") return _matrixNormFrobenius(x);
        if (p === 2) return _matrixNormTwo(x);
         // invalid parameter value
        throw new Error("Unsupported parameter value " + p);
    }
    /**
   * Calculate the norm for an array
   * @param {Matrix} x
   * @param {number | string} p
   * @returns {number} Returns the norm
   * @private
   */ function _norm(x, p) {
        // size
        var sizeX = x.size(); // check if it is a vector
        if (sizeX.length === 1) return _vectorNorm(x, p);
         // MxN matrix
        if (sizeX.length === 2) {
            if (sizeX[0] && sizeX[1]) return _matrixNorm(x, p);
            else throw new RangeError("Invalid matrix dimensions");
        }
    }
});



var $e146459ae6618893$var$name = "rotationMatrix";
var $e146459ae6618893$var$dependencies = [
    "typed",
    "config",
    "multiplyScalar",
    "addScalar",
    "unaryMinus",
    "norm",
    "matrix",
    "BigNumber",
    "DenseMatrix",
    "SparseMatrix",
    "cos",
    "sin"
];
var $e146459ae6618893$export$7c79514a80dc15a2 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($e146459ae6618893$var$name, $e146459ae6618893$var$dependencies, (_ref)=>{
    var { typed: typed, config: config, multiplyScalar: multiplyScalar, addScalar: addScalar, unaryMinus: unaryMinus, norm: norm, BigNumber: BigNumber, matrix: matrix, DenseMatrix: DenseMatrix, SparseMatrix: SparseMatrix, cos: cos, sin: sin } = _ref;
    /**
   * Create a 2-dimensional counter-clockwise rotation matrix (2x2) for a given angle (expressed in radians).
   * Create a 2-dimensional counter-clockwise rotation matrix (3x3) by a given angle (expressed in radians) around a given axis (1x3).
   *
   * Syntax:
   *
   *    math.rotationMatrix(theta)
   *    math.rotationMatrix(theta, format)
   *    math.rotationMatrix(theta, [v])
   *    math.rotationMatrix(theta, [v], format)
   *
   * Examples:
   *
   *    math.rotationMatrix(math.pi / 2)                      // returns [[0, -1], [1, 0]]
   *    math.rotationMatrix(math.bignumber(1))                // returns [[bignumber(cos(1)), bignumber(-sin(1))], [bignumber(sin(1)), bignumber(cos(1))]]
   *    math.rotationMatrix(math.complex(1 + i))              // returns [[cos(1 + i), -sin(1 + i)], [sin(1 + i), cos(1 + i)]]
   *    math.rotationMatrix(math.unit('1rad'))                // returns [[cos(1), -sin(1)], [sin(1), cos(1)]]
   *
   *    math.rotationMatrix(math.pi / 2, [0, 1, 0])           // returns [[0, 0, 1], [0, 1, 0], [-1, 0, 0]]
   *    math.rotationMatrix(math.pi / 2, matrix([0, 1, 0]))   // returns matrix([[0, 0, 1], [0, 1, 0], [-1, 0, 0]])
   *
   *
   * See also:
   *
   *    matrix, cos, sin
   *
   *
   * @param {number | BigNumber | Complex | Unit} theta    Rotation angle
   * @param {Array | Matrix} [v]                           Rotation axis
   * @param {string} [format]                              Result Matrix storage format
   * @return {Array | Matrix}                              Rotation matrix
   */ return typed($e146459ae6618893$var$name, {
        "": function _() {
            return config.matrix === "Matrix" ? matrix([]) : [];
        },
        string: function string(format) {
            return matrix(format);
        },
        "number | BigNumber | Complex | Unit": function numberBigNumberComplexUnit(theta) {
            return _rotationMatrix2x2(theta, config.matrix === "Matrix" ? "dense" : undefined);
        },
        "number | BigNumber | Complex | Unit, string": function numberBigNumberComplexUnitString(theta, format) {
            return _rotationMatrix2x2(theta, format);
        },
        "number | BigNumber | Complex | Unit, Array": function numberBigNumberComplexUnitArray(theta, v) {
            var matrixV = matrix(v);
            _validateVector(matrixV);
            return _rotationMatrix3x3(theta, matrixV, undefined);
        },
        "number | BigNumber | Complex | Unit, Matrix": function numberBigNumberComplexUnitMatrix(theta, v) {
            _validateVector(v);
            var storageType = v.storage() || (config.matrix === "Matrix" ? "dense" : undefined);
            return _rotationMatrix3x3(theta, v, storageType);
        },
        "number | BigNumber | Complex | Unit, Array, string": function numberBigNumberComplexUnitArrayString(theta, v, format) {
            var matrixV = matrix(v);
            _validateVector(matrixV);
            return _rotationMatrix3x3(theta, matrixV, format);
        },
        "number | BigNumber | Complex | Unit, Matrix, string": function numberBigNumberComplexUnitMatrixString(theta, v, format) {
            _validateVector(v);
            return _rotationMatrix3x3(theta, v, format);
        }
    });
    /**
   * Returns 2x2 matrix of 2D rotation of angle theta
   *
   * @param {number | BigNumber | Complex | Unit} theta  The rotation angle
   * @param {string} format                              The result Matrix storage format
   * @returns {Matrix}
   * @private
   */ function _rotationMatrix2x2(theta, format) {
        var Big = (0, $d8097b7a6d6e36d8$export$e51d0e7e5c4a03ab)(theta);
        var minusOne = Big ? new BigNumber(-1) : -1;
        var cosTheta = cos(theta);
        var sinTheta = sin(theta);
        var data = [
            [
                cosTheta,
                multiplyScalar(minusOne, sinTheta)
            ],
            [
                sinTheta,
                cosTheta
            ]
        ];
        return _convertToFormat(data, format);
    }
    function _validateVector(v) {
        var size = v.size();
        if (size.length < 1 || size[0] !== 3) throw new RangeError("Vector must be of dimensions 1x3");
    }
    function _mul(array) {
        return array.reduce((p, curr)=>multiplyScalar(p, curr));
    }
    function _convertToFormat(data, format) {
        if (format) {
            if (format === "sparse") return new SparseMatrix(data);
            if (format === "dense") return new DenseMatrix(data);
            throw new TypeError('Unknown matrix type "'.concat(format, '"'));
        }
        return data;
    }
    /**
   * Returns a 3x3 matrix of rotation of angle theta around vector v
   *
   * @param {number | BigNumber | Complex | Unit} theta The rotation angle
   * @param {Matrix} v                                  The rotation axis vector
   * @param {string} format                             The storage format of the resulting matrix
   * @returns {Matrix}
   * @private
   */ function _rotationMatrix3x3(theta, v, format) {
        var normV = norm(v);
        if (normV === 0) throw new RangeError("Rotation around zero vector");
        var Big = (0, $d8097b7a6d6e36d8$export$e51d0e7e5c4a03ab)(theta) ? BigNumber : null;
        var one = Big ? new Big(1) : 1;
        var minusOne = Big ? new Big(-1) : -1;
        var vx = Big ? new Big(v.get([
            0
        ]) / normV) : v.get([
            0
        ]) / normV;
        var vy = Big ? new Big(v.get([
            1
        ]) / normV) : v.get([
            1
        ]) / normV;
        var vz = Big ? new Big(v.get([
            2
        ]) / normV) : v.get([
            2
        ]) / normV;
        var c = cos(theta);
        var oneMinusC = addScalar(one, unaryMinus(c));
        var s = sin(theta);
        var r11 = addScalar(c, _mul([
            vx,
            vx,
            oneMinusC
        ]));
        var r12 = addScalar(_mul([
            vx,
            vy,
            oneMinusC
        ]), _mul([
            minusOne,
            vz,
            s
        ]));
        var r13 = addScalar(_mul([
            vx,
            vz,
            oneMinusC
        ]), _mul([
            vy,
            s
        ]));
        var r21 = addScalar(_mul([
            vx,
            vy,
            oneMinusC
        ]), _mul([
            vz,
            s
        ]));
        var r22 = addScalar(c, _mul([
            vy,
            vy,
            oneMinusC
        ]));
        var r23 = addScalar(_mul([
            vy,
            vz,
            oneMinusC
        ]), _mul([
            minusOne,
            vx,
            s
        ]));
        var r31 = addScalar(_mul([
            vx,
            vz,
            oneMinusC
        ]), _mul([
            minusOne,
            vy,
            s
        ]));
        var r32 = addScalar(_mul([
            vy,
            vz,
            oneMinusC
        ]), _mul([
            vx,
            s
        ]));
        var r33 = addScalar(c, _mul([
            vz,
            vz,
            oneMinusC
        ]));
        var data = [
            [
                r11,
                r12,
                r13
            ],
            [
                r21,
                r22,
                r23
            ],
            [
                r31,
                r32,
                r33
            ]
        ];
        return _convertToFormat(data, format);
    }
});


var $17250ba77f6a2235$var$name = "std";
var $17250ba77f6a2235$var$dependencies = [
    "typed",
    "sqrt",
    "variance"
];
var $17250ba77f6a2235$export$d3f0a8dda5df7afd = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($17250ba77f6a2235$var$name, $17250ba77f6a2235$var$dependencies, (_ref)=>{
    var { typed: typed, sqrt: sqrt, variance: variance } = _ref;
    /**
   * Compute the standard deviation of a matrix or a  list with values.
   * The standard deviations is defined as the square root of the variance:
   * `std(A) = sqrt(variance(A))`.
   * In case of a (multi dimensional) array or matrix, the standard deviation
   * over all elements will be calculated by default, unless an axis is specified
   * in which case the standard deviation will be computed along that axis.
   *
   * Additionally, it is possible to compute the standard deviation along the rows
   * or columns of a matrix by specifying the dimension as the second argument.
   *
   * Optionally, the type of normalization can be specified as the final
   * parameter. The parameter `normalization` can be one of the following values:
   *
   * - 'unbiased' (default) The sum of squared errors is divided by (n - 1)
   * - 'uncorrected'        The sum of squared errors is divided by n
   * - 'biased'             The sum of squared errors is divided by (n + 1)
   *
   *
   * Syntax:
   *
   *     math.std(a, b, c, ...)
   *     math.std(A)
   *     math.std(A, normalization)
   *     math.std(A, dimension)
   *     math.std(A, dimension, normalization)
   *
   * Examples:
   *
   *     math.std(2, 4, 6)                     // returns 2
   *     math.std([2, 4, 6, 8])                // returns 2.581988897471611
   *     math.std([2, 4, 6, 8], 'uncorrected') // returns 2.23606797749979
   *     math.std([2, 4, 6, 8], 'biased')      // returns 2
   *
   *     math.std([[1, 2, 3], [4, 5, 6]])      // returns 1.8708286933869707
   *     math.std([[1, 2, 3], [4, 6, 8]], 0)    // returns [2.1213203435596424, 2.8284271247461903, 3.5355339059327378]
   *     math.std([[1, 2, 3], [4, 6, 8]], 1)    // returns [1, 2]
   *     math.std([[1, 2, 3], [4, 6, 8]], 1, 'biased') // returns [0.7071067811865476, 1.4142135623730951]
   *
   * See also:
   *
   *    mean, median, max, min, prod, sum, variance
   *
   * @param {Array | Matrix} array
   *                        A single matrix or or multiple scalar values
   * @param {string} [normalization='unbiased']
   *                        Determines how to normalize the variance.
   *                        Choose 'unbiased' (default), 'uncorrected', or 'biased'.
   * @param dimension {number | BigNumber}
   *                        Determines the axis to compute the standard deviation for a matrix
   * @return {*} The standard deviation
   */ return typed($17250ba77f6a2235$var$name, {
        // std([a, b, c, d, ...])
        "Array | Matrix": _std,
        // std([a, b, c, d, ...], normalization)
        "Array | Matrix, string": _std,
        // std([a, b, c, c, ...], dim)
        "Array | Matrix, number | BigNumber": _std,
        // std([a, b, c, c, ...], dim, normalization)
        "Array | Matrix, number | BigNumber, string": _std,
        // std(a, b, c, d, ...)
        "...": function _(args) {
            return _std(args);
        }
    });
    function _std(array, normalization) {
        if (array.length === 0) throw new SyntaxError("Function std requires one or more parameters (0 provided)");
        try {
            return sqrt(variance.apply(null, arguments));
        } catch (err) {
            if (err instanceof TypeError && err.message.indexOf(" variance") !== -1) throw new TypeError(err.message.replace(" variance", " std"));
            else throw err;
        }
    }
});




var $36eb9bbb60cc9744$var$name = "mad";
var $36eb9bbb60cc9744$var$dependencies = [
    "typed",
    "abs",
    "map",
    "median",
    "subtract"
];
var $36eb9bbb60cc9744$export$7b17fbe41c88575a = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($36eb9bbb60cc9744$var$name, $36eb9bbb60cc9744$var$dependencies, (_ref)=>{
    var { typed: typed, abs: abs, map: map, median: median, subtract: subtract } = _ref;
    /**
   * Compute the median absolute deviation of a matrix or a list with values.
   * The median absolute deviation is defined as the median of the absolute
   * deviations from the median.
   *
   * Syntax:
   *
   *     math.mad(a, b, c, ...)
   *     math.mad(A)
   *
   * Examples:
   *
   *     math.mad(10, 20, 30)             // returns 10
   *     math.mad([1, 2, 3])              // returns 1
   *     math.mad([[1, 2, 3], [4, 5, 6]]) // returns 1.5
   *
   * See also:
   *
   *     median, mean, std, abs
   *
   * @param {Array | Matrix} array
   *                        A single matrix or multiple scalar values.
   * @return {*} The median absolute deviation.
   */ return typed($36eb9bbb60cc9744$var$name, {
        // mad([a, b, c, d, ...])
        "Array | Matrix": _mad,
        // mad(a, b, c, d, ...)
        "...": function _(args) {
            return _mad(args);
        }
    });
    function _mad(array) {
        array = (0, $a14a10567870d913$export$bffa455ba8c619a6)(array.valueOf());
        if (array.length === 0) throw new Error("Cannot calculate median absolute deviation (mad) of an empty array");
        try {
            var med = median(array);
            return median(map(array, function(value) {
                return abs(subtract(value, med));
            }));
        } catch (err) {
            if (err instanceof TypeError && err.message.indexOf("median") !== -1) throw new TypeError(err.message.replace("median", "mad"));
            else throw (0, $b113219b83527e4b$export$c8994973cec629ae)(err, "mad");
        }
    }
});



var $59cd08414f0a6cb6$var$name = "rotate";
var $59cd08414f0a6cb6$var$dependencies = [
    "typed",
    "multiply",
    "rotationMatrix"
];
var $59cd08414f0a6cb6$export$484058214789ee04 = /* #__PURE__ */ (0, $e745cf56e5b0be75$export$e9008f2713103c6c)($59cd08414f0a6cb6$var$name, $59cd08414f0a6cb6$var$dependencies, (_ref)=>{
    var { typed: typed, multiply: multiply, rotationMatrix: rotationMatrix } = _ref;
    /**
     * Rotate a vector of size 1x2 counter-clockwise by a given angle
     * Rotate a vector of size 1x3 counter-clockwise by a given angle around the given axis
     *
     * Syntax:
     *
     *    math.rotate(w, theta)
     *    math.rotate(w, theta, v)
     *
     * Examples:
     *
     *    math.rotate([11, 12], math.pi / 2)                           // returns matrix([-12, 11])
     *    math.rotate(matrix([11, 12]), math.pi / 2)                   // returns matrix([-12, 11])
     *
     *    math.rotate([1, 0, 0], unit('90deg'), [0, 0, 1])             // returns matrix([0, 1, 0])
     *    math.rotate(matrix([1, 0, 0]), unit('90deg'), [0, 0, 1])     // returns matrix([0, 1, 0])
     *
     *    math.rotate([1, 0], math.complex(1 + i))                     // returns matrix([cos(1 + i) - sin(1 + i), sin(1 + i) + cos(1 + i)])
     *
     * See also:
     *
     *    matrix, rotationMatrix
     *
     * @param {Array | Matrix} w                             Vector to rotate
     * @param {number | BigNumber | Complex | Unit} theta    Rotation angle
     * @param {Array | Matrix} [v]                           Rotation axis
     * @return {Array | Matrix}                              Multiplication of the rotation matrix and w
     */ return typed($59cd08414f0a6cb6$var$name, {
        "Array , number | BigNumber | Complex | Unit": function ArrayNumberBigNumberComplexUnit(w, theta) {
            _validateSize(w, 2);
            var matrixRes = multiply(rotationMatrix(theta), w);
            return matrixRes.toArray();
        },
        "Matrix , number | BigNumber | Complex | Unit": function MatrixNumberBigNumberComplexUnit(w, theta) {
            _validateSize(w, 2);
            return multiply(rotationMatrix(theta), w);
        },
        "Array, number | BigNumber | Complex | Unit, Array | Matrix": function ArrayNumberBigNumberComplexUnitArrayMatrix(w, theta, v) {
            _validateSize(w, 3);
            var matrixRes = multiply(rotationMatrix(theta, v), w);
            return matrixRes;
        },
        "Matrix, number | BigNumber | Complex | Unit, Array | Matrix": function MatrixNumberBigNumberComplexUnitArrayMatrix(w, theta, v) {
            _validateSize(w, 3);
            return multiply(rotationMatrix(theta, v), w);
        }
    });
    function _validateSize(v, expectedSize) {
        var actualSize = Array.isArray(v) ? (0, $a14a10567870d913$export$51ffaee4afb683a5)(v) : v.size();
        if (actualSize.length > 2) throw new RangeError("Vector must be of dimensions 1x".concat(expectedSize));
        if (actualSize.length === 2 && actualSize[1] !== 1) throw new RangeError("Vector must be of dimensions 1x".concat(expectedSize));
        if (actualSize[0] !== expectedSize) throw new RangeError("Vector must be of dimensions 1x".concat(expectedSize));
    }
});


var $ed89d4c20b089b73$export$d97aa349ed20696 = /* #__PURE__ */ (0, $e4540763674cd14e$export$234de8d4231bfea3)({
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$50ceb3fb9926e63e = /* #__PURE__ */ (0, $9d81e778db0198b3$export$24a4be44fc8b6392)({});
var $ed89d4c20b089b73$export$f1e1789686576879 = /* #__PURE__ */ (0, $04364ed81e47ae96$export$6dca51ff4d4b257f)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$f650004d56f90c2a = /* #__PURE__ */ (0, $04364ed81e47ae96$export$cb94e3a54c9e99b)({});
var $ed89d4c20b089b73$export$5c15dd8d2782cbd0 = /* #__PURE__ */ (0, $f30778583b16570c$export$aaddb59a993d3ac4)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$b336c2702c498be5 = /* #__PURE__ */ (0, $273c5e5221ed04ec$export$c317f082100fca89)({});
var $ed89d4c20b089b73$export$23f2a1d2818174ef = /* #__PURE__ */ (0, $04364ed81e47ae96$export$7122d2461a6f9b76)({
    Complex: $ed89d4c20b089b73$export$50ceb3fb9926e63e
});
var $ed89d4c20b089b73$export$20607595d292e7d3 = /* #__PURE__ */ (0, $04364ed81e47ae96$export$df1313fb6eb44f05)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$c44341d65988fdd6 = /* #__PURE__ */ (0, $04364ed81e47ae96$export$5365e90aad1235b4)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$5ed2c057bd191c66 = /* #__PURE__ */ (0, $04364ed81e47ae96$export$57f654bce66ec8ce)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$5b12bf1653c0dd85 = /* #__PURE__ */ (0, $0938237193b54607$export$72d485cc3ed6a97a)({});
var $ed89d4c20b089b73$export$14edd9ca775dcd61 = /* #__PURE__ */ (0, $04364ed81e47ae96$export$fbdaee11df58c3cc)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$a2cbb38cda512d16 = /* #__PURE__ */ (0, $04364ed81e47ae96$export$d07c6114481fc17b)({});
var $ed89d4c20b089b73$export$324943737027944a = /* #__PURE__ */ (0, $04364ed81e47ae96$export$f131830080647892)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$9a58ef0d7ad3278c = /* #__PURE__ */ (0, $df7de91489582452$export$e87cc8d3f29c5e1b)({});
var $ed89d4c20b089b73$export$aebd5179ff543a90 = /* #__PURE__ */ (0, $a661d702bc0c915e$export$dfb3187f1c4e3bbe)({});
var $ed89d4c20b089b73$export$83247d8be11c091e = /* #__PURE__ */ (0, $04364ed81e47ae96$export$e6df2cb14f3e8316)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$a7100dcd4c5af6d4 = /* #__PURE__ */ (0, $f30778583b16570c$export$467c65d9dfc3d3a2)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$a4b4b4d4d776fe92 = /* #__PURE__ */ (0, $04364ed81e47ae96$export$d5973a6d5d95d479)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$93f71dfe5e50cd3e = /* #__PURE__ */ (0, $04364ed81e47ae96$export$e13d32722e2756df)({});
var $ed89d4c20b089b73$export$83d89fbfd8236492 = /* #__PURE__ */ (0, $04364ed81e47ae96$export$72a91d9326d5a672)({});
var $ed89d4c20b089b73$export$97f0d27b48f120e8 = /* #__PURE__ */ (0, $3f02b11f7bdb3e86$export$1a088ca8dd364cd1)({
    Matrix: $ed89d4c20b089b73$export$5b12bf1653c0dd85
});
var $ed89d4c20b089b73$export$9ea6550edaaee998 = /* #__PURE__ */ (0, $f30778583b16570c$export$55fc8769b037d266)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$578b45ddcdefa518 = /* #__PURE__ */ (0, $04364ed81e47ae96$export$ab67ddb9e8290a2c)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$18c7bea995a110f = /* #__PURE__ */ (0, $04364ed81e47ae96$export$2dbe69c48ac7f49c)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$b644b65666fe0c18 = /* #__PURE__ */ (0, $c5e99c589ef7988d$export$481a522c866104eb)({});
var $ed89d4c20b089b73$export$3681641e15b6e2c3 = /* #__PURE__ */ (0, $04364ed81e47ae96$export$f7a593fe98eba575)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$519f616c41a1c711 = /* #__PURE__ */ (0, $f456e29c03959ae3$export$8597b5d47504f989)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Complex: $ed89d4c20b089b73$export$50ceb3fb9926e63e,
    DenseMatrix: $ed89d4c20b089b73$export$97f0d27b48f120e8,
    Fraction: $ed89d4c20b089b73$export$b336c2702c498be5
});
var $ed89d4c20b089b73$export$df8c837ae5df4ce4 = /* #__PURE__ */ (0, $5162cbd1eca10369$export$cb425222dc08ff4e)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$857d2e3e2bc524d0 = /* #__PURE__ */ (0, $f30778583b16570c$export$fa2d42c5c25c1883)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$2335f513bbd82c6d = /* #__PURE__ */ (0, $3b15ea4368bd064b$export$dd8a9b3843a4df95)({
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$fd6306be3fde5b04 = /* #__PURE__ */ (0, $6b4e029c5e006c1b$export$33da46c5ece67581)({
    Complex: $ed89d4c20b089b73$export$50ceb3fb9926e63e,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$4919a578c4aafd3 = /* #__PURE__ */ (0, $9f162a2f00142af4$export$8a6845771325148e)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$43298db932064b4a = /* #__PURE__ */ (0, $cc732836f684e4e9$export$95580581b134a5bd)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Complex: $ed89d4c20b089b73$export$50ceb3fb9926e63e,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$2b7b095c4f443355 = /* #__PURE__ */ (0, $943ad76e8ef3c24c$export$bbebd809b9ccc50b)({
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$d8da458ed75e15b = /* #__PURE__ */ (0, $a30a14fd5f11a878$export$bde3dabbd4699a93)({
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$3aaf4e522be48075 = /* #__PURE__ */ (0, $76dc85681c6c84ca$export$8eeff5f09afe95bc)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Complex: $ed89d4c20b089b73$export$50ceb3fb9926e63e,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$839d8a01b6af4fc0 = /* #__PURE__ */ (0, $abae3bfc37d54e73$export$7278bb4e3c84d46a)({
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$628dc4eed22b0fbd = /* #__PURE__ */ (0, $b338faf592a8c405$export$b87f3a3301a24256)({
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$21ea955025ceb08b = /* #__PURE__ */ (0, $86dbb32021258726$export$c2dbbeab1e5e6195)({
    Complex: $ed89d4c20b089b73$export$50ceb3fb9926e63e,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$8576f72eb7f14a7e = /* #__PURE__ */ (0, $271b4a230f93869e$export$1c955ee1b8a97877)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$aabc449fa5b5f4c0 = /* #__PURE__ */ (0, $0a398a90254a8e91$export$9e7f3c72ca8b5aa)({
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$4a21f16c33752377 = /* #__PURE__ */ (0, $c0cb2ed95ed35729$export$3c82aec2d86a5525)({
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$9cd59f9826255e47 = /* #__PURE__ */ (0, $48d9bfb32272e8b1$export$39ad70de4044028a)({
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$bdfcf4c6b5766439 = /* #__PURE__ */ (0, $cfe9f2c4c826b621$export$63e3129a196da23d)({
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$83a0e34f1302825b = /* #__PURE__ */ (0, $5c9a405c8b050b24$export$82a905fb6826da0d)({
    Complex: $ed89d4c20b089b73$export$50ceb3fb9926e63e,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$fb254c661fe9c0db = /* #__PURE__ */ (0, $a0461c2ebb3582a9$export$af5efe8ad97f01a2)({
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$2e2fd1ad24e4d350 = /* #__PURE__ */ (0, $d9aee101e2c18cef$export$63d35097da636c02)({
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$fe7b8a3b046ac25b = /* #__PURE__ */ (0, $0bf854e4b4ccb587$export$3f7f9b5400315e6a)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$a830b5ed334924be = /* #__PURE__ */ (0, $5fd48631a1cf5cff$export$a0beb298aa7a2962)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$2b0340f6c7dec49a = /* #__PURE__ */ (0, $11475161a75d7c01$export$ce223d612b94804b)({
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$943761f5c9c3f156 = /* #__PURE__ */ (0, $a8e3599cee836598$export$c370bab664a0c9a2)({
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$d3896f355fc09423 = /* #__PURE__ */ (0, $cb08105b913df155$export$470dfa326d6cbdf5)({
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$b310ec824aaee37f = /* #__PURE__ */ (0, $b9e212bd9bf743a0$export$95a576617fd015b1)({
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$b6c0a80d46d3391d = /* #__PURE__ */ (0, $b1af9d874f4fec41$export$2b203b63f664bab3)({
    Complex: $ed89d4c20b089b73$export$50ceb3fb9926e63e,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$3dea766d36a8935f = /* #__PURE__ */ (0, $d1603a9aa2eb6ada$export$5d81789ff4aeccdf)({
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$4b80e395e36b5a56 = /* #__PURE__ */ (0, $f9ad3cb7a0d84c1d$export$a5218987e0811e05)({
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$d9468344d3651243 = /* #__PURE__ */ (0, $ed78932878972773$export$abf0d9399b60f9bb)({
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$42c7d1d712906e32 = /* #__PURE__ */ (0, $cf628c4622ecc418$export$b83055c9a38abe3c)({
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$834dfc94dde4b3d8 = /* #__PURE__ */ (0, $a0f150b4129ba9f6$export$9cafd9970d25a17c)({
    format: $ed89d4c20b089b73$export$d9468344d3651243,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$5fc500b917996661 = /* #__PURE__ */ (0, $76573e9eb3dcaa88$export$47dfdf308b91581)({
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$a287f47fed4544b8 = /* #__PURE__ */ (0, $36246b3ad4dab182$export$766996d075d5608a)({
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$d0909a4f38b5c4d0 = /* #__PURE__ */ (0, $cc3c03c0b0064eac$export$159ccd8c63e17c58)({
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$7e69d4236fcc3b19 = /* #__PURE__ */ (0, $c3fafd52c47ea619$export$2d862c12fb537dd9)({
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$c46ec7d82fb1f602 = /* #__PURE__ */ (0, $4eaac03f309f97e9$export$ea90652d00dab06e)({
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$8c2c65adacba8d14 = /* #__PURE__ */ (0, $04364ed81e47ae96$export$b57f4b4cfc057c2d)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$3daae2744d8ce460 = /* #__PURE__ */ (0, $2140b094078343cf$export$bc3a6f6286e9085a)({
    Complex: $ed89d4c20b089b73$export$50ceb3fb9926e63e,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$75e08744a3ff8516 = /* #__PURE__ */ (0, $dfe5aefd5ba6b4f0$export$dea4efeb24d4590d)({
    Complex: $ed89d4c20b089b73$export$50ceb3fb9926e63e,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$b9fae0bba9d9094d = /* #__PURE__ */ (0, $df3976634f9977b9$export$a993dae3988e0f19)({
    Complex: $ed89d4c20b089b73$export$50ceb3fb9926e63e,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$871de8747c9eaa88 = /* #__PURE__ */ (0, $f874e0e0b1135d36$export$d49c9aa30b771d59)({
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$c697bed75648cdb7 = /* #__PURE__ */ (0, $5053d0f9a9085c9f$export$37dc64d7e8361b32)({
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$6003a5f097c73977 = /* #__PURE__ */ (0, $5baf9282ba9fae19$export$8dbfb388cd6a8853)({
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$98e628dec113755e = /* #__PURE__ */ (0, $930896808ac47b5e$export$763ee9f6477981ab)({
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$8d9f5ae1af806929 = /* #__PURE__ */ (0, $cdc5bba4f0159798$export$6692788ef49c21c9)({
    format: $ed89d4c20b089b73$export$d9468344d3651243,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$2e015b6955893291 = /* #__PURE__ */ (0, $ee18b24310ad0068$export$fbe25b9f25feec34)({
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$c2d084dc44961371 = /* #__PURE__ */ (0, $42c4d4840ed26722$export$ea4b9d9569ff81cc)({
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$4385e60b38654f68 = /* #__PURE__ */ (0, $0410891c7115dc60$export$5c03d20f483e909a)({
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$b1f1627d659a651 = /* #__PURE__ */ (0, $b18ec0992e5f4f5d$export$803e46d0de790dbf)({
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$e17a63917e2ebf0f = /* #__PURE__ */ (0, $bf2edef83a84ee5d$export$5c169ecd5c25a09e)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$c5552dfdbc7cec71 = /* #__PURE__ */ (0, $056afbcfb57540c1$export$45df7cae684751af)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Fraction: $ed89d4c20b089b73$export$b336c2702c498be5,
    complex: $ed89d4c20b089b73$export$83a0e34f1302825b,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$5de3937cb4b592ed = /* #__PURE__ */ (0, $be3842f86d00047d$export$4b4fac44ef379cae)({
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$de9b2b7556879848 = /* #__PURE__ */ (0, $78eb395e24cc718a$export$a783ce8f6a98b2e5)({
    Matrix: $ed89d4c20b089b73$export$5b12bf1653c0dd85,
    equalScalar: $ed89d4c20b089b73$export$943761f5c9c3f156,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$dd67294014106b35 = /* #__PURE__ */ (0, $dbbf0806472e2299$export$a9f61753ee14ea96)({
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$dd4f28cef696bc7d = /* #__PURE__ */ (0, $b2fbb66eda80dbcf$export$4ba960a63f731b0b)({
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$22b082955e083ec3 = /* #__PURE__ */ (0, $f9e9a1efd9d04759$export$b2cf5914f5f18823)({
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$fcdd3b0b3246a325 = /* #__PURE__ */ (0, $5df0f80da18cbed1$export$b61ad4f38fd9301d)({
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$f5bbd400c2f4426f = /* #__PURE__ */ (0, $caaa070b381cb64f$export$d7acf116afef7b4d)({
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$b26caf0f29211d08 = /* #__PURE__ */ (0, $b53a719755e98b12$export$c634796792055579)({
    Complex: $ed89d4c20b089b73$export$50ceb3fb9926e63e,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$eafdb403a25900df = /* #__PURE__ */ (0, $299146234ce71769$export$d6534043a40dc59)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$5635d7ef4b8fee1c = /* #__PURE__ */ (0, $f7bddcfe920bce4c$export$5ccffa1686df7f00)({
    isInteger: $ed89d4c20b089b73$export$a287f47fed4544b8,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$ec42f46098b24bb4 = /* #__PURE__ */ (0, $d8eb00c42b04816a$export$e1f28fc7c94f90b0)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Complex: $ed89d4c20b089b73$export$50ceb3fb9926e63e,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$f03e751d9cddb7a = /* #__PURE__ */ (0, $b70eaa1394094666$export$a770ddfd7e536064)({
    format: $ed89d4c20b089b73$export$d9468344d3651243,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$f297162cf5d656b2 = /* #__PURE__ */ (0, $89db069cce3272ee$export$4bdc90311ec7c1dd)({
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$50d414a77b60d802 = /* #__PURE__ */ (0, $d7248087b592523f$export$923b60dfa791c630)({
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$ca7427e8bf42a21b = /* #__PURE__ */ (0, $e584730979e3a498$export$9160aa3a39425fc9)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$c9f5652083b8129d = /* #__PURE__ */ (0, $f4281c57d38e6673$export$f85085363cf09711)({
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$8676dd5fabd5ee34 = /* #__PURE__ */ (0, $f348f7a9fdb82323$export$4e02350f5fb7a050)({
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$3c5f89dae98e900b = /* #__PURE__ */ (0, $221176819d2016eb$export$e158da47ae479dd4)({
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$becbc39f348ea65e = /* #__PURE__ */ (0, $c4e19a00f42432bf$export$97a0cf2b7d31f38b)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$545004b505d7c555 = /* #__PURE__ */ (0, $716b6b44b18da9ba$export$c3a62182c56878d5)({
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$b6b7e189aa5d134c = /* #__PURE__ */ (0, $a91be007ed40c7b8$export$89ff03fdb3964a99)({
    SparseMatrix: $ed89d4c20b089b73$export$de9b2b7556879848,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$eba8049fb5020b81 = /* #__PURE__ */ (0, $82a490fa2f36f261$export$eb18ce1988c5f19c)({
    Complex: $ed89d4c20b089b73$export$50ceb3fb9926e63e,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$7128670e45beef9a = /* #__PURE__ */ (0, $ce23360eba9bac64$export$e1f66a5bda779194)({
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$6cd304851a69e08 = /* #__PURE__ */ (0, $7e409df0d8f124ad$export$939e1be6e134f392)({
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$6faaac9ab79fd3a4 = /* #__PURE__ */ (0, $5e71b2c9ace047e4$export$67e40c7fd8f5703a)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Complex: $ed89d4c20b089b73$export$50ceb3fb9926e63e,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$ef569ec50496610c = /* #__PURE__ */ (0, $1602024f41300d63$export$c5598f542ea1565c)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$7f34ce79760854f7 = /* #__PURE__ */ (0, $3d59d6306cd28f58$export$de147ca8498e0312)({
    Fraction: $ed89d4c20b089b73$export$b336c2702c498be5,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$e90fb89750dba83f = /* #__PURE__ */ (0, $f1404df2748180e3$export$85b0631fa122b7f1)({
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$9bdad1ae37d738e0 = /* #__PURE__ */ (0, $2731ffdb281d587e$export$f3cf8b510f9cb8ab)({
    DenseMatrix: $ed89d4c20b089b73$export$97f0d27b48f120e8,
    Matrix: $ed89d4c20b089b73$export$5b12bf1653c0dd85,
    SparseMatrix: $ed89d4c20b089b73$export$de9b2b7556879848,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$7860df605315d572 = /* #__PURE__ */ (0, $5ae2c66d00503c0d$export$983d2c97138363e0)({
    isZero: $ed89d4c20b089b73$export$c46ec7d82fb1f602,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$842a2cf37af977e1 = /* #__PURE__ */ (0, $5de7f52c1e6972c9$export$735bb6c30160c058)({
    DenseMatrix: $ed89d4c20b089b73$export$97f0d27b48f120e8,
    equalScalar: $ed89d4c20b089b73$export$943761f5c9c3f156,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$cc5da69d359d7991 = /* #__PURE__ */ (0, $0593ec8dcbba0d4c$export$964e38ef60b1ac68)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    equalScalar: $ed89d4c20b089b73$export$943761f5c9c3f156,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$b7a508fa8dae59fc = /* #__PURE__ */ (0, $853d7e1d4a10ae79$export$e3cf2d123164e554)({
    bignumber: $ed89d4c20b089b73$export$8576f72eb7f14a7e,
    fraction: $ed89d4c20b089b73$export$7f34ce79760854f7,
    number: $ed89d4c20b089b73$export$98e628dec113755e
});
var $ed89d4c20b089b73$export$252bb8b3bbdf6749 = /* #__PURE__ */ (0, $7f11fcfd924108fa$export$3d19b09907d6fd4a)({
    DenseMatrix: $ed89d4c20b089b73$export$97f0d27b48f120e8,
    equalScalar: $ed89d4c20b089b73$export$943761f5c9c3f156,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$5e143010dea16c85 = /* #__PURE__ */ (0, $5fdc7816ae0643b9$export$60310f756e9cfd41)({
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    multiplyScalar: $ed89d4c20b089b73$export$c697bed75648cdb7,
    numeric: $ed89d4c20b089b73$export$b7a508fa8dae59fc,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$9eaad88cf88cee2b = /* #__PURE__ */ (0, $46de69f0f41f52a9$export$76c9752f34fb3440)({
    isInteger: $ed89d4c20b089b73$export$a287f47fed4544b8,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$346677f925de839c = /* #__PURE__ */ (0, $82d61f6ea0246e24$export$9151c23a59ce3fb6)({
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$3f732695c1493aec = /* #__PURE__ */ (0, $bbdd46adbb465239$export$6b477d90b957f03e)({
    DenseMatrix: $ed89d4c20b089b73$export$97f0d27b48f120e8,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$889c931173b77c2f = /* #__PURE__ */ (0, $dabccf1fd7e2b78c$export$1a885844ffd505a4)({
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$e06bd7b1ab877a71 = /* #__PURE__ */ (0, $5d38c660a6bdbeba$export$d8c56e74d683bb33)({
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$4e2d2ead65e5f7e3 = /* #__PURE__ */ (0, $486347f104d1caa3$export$cd7a6c131b18ab16)({
    DenseMatrix: $ed89d4c20b089b73$export$97f0d27b48f120e8,
    addScalar: $ed89d4c20b089b73$export$2b7b095c4f443355,
    equalScalar: $ed89d4c20b089b73$export$943761f5c9c3f156,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711,
    unaryMinus: $ed89d4c20b089b73$export$6cd304851a69e08
});
var $ed89d4c20b089b73$export$2c618a4308a30424 = /* #__PURE__ */ (0, $70235fdf3b767b54$export$6e6c19ceb4cd6856)({
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$9cb09a71b7d66923 = /* #__PURE__ */ (0, $df363a406353858c$export$9a8c88485f8f638b)({
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$6ba103b0465fe6cc = /* #__PURE__ */ (0, $42c9c0db27eb5c70$export$de8cbd18c98bf9d5)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$4445a00dafa2633b = /* #__PURE__ */ (0, $2d2cbce1fa072220$export$13096c1635fe6e3d)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$21c0ac7fe1cef1b8 = /* #__PURE__ */ (0, $b3492dc85e9ec3ef$export$15a698d88cae0eff)({
    equalScalar: $ed89d4c20b089b73$export$943761f5c9c3f156,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    not: $ed89d4c20b089b73$export$6003a5f097c73977,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711,
    zeros: $ed89d4c20b089b73$export$4445a00dafa2633b
});
var $ed89d4c20b089b73$export$a74ff8d3fdef72fc = /* #__PURE__ */ (0, $8444b8cd9809d5bc$export$bea4e06c5befec3b)({
    equalScalar: $ed89d4c20b089b73$export$943761f5c9c3f156,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$bfcff4501301c191 = /* #__PURE__ */ (0, $dab42c98161ee357$export$1cae728fa8e01928)({
    DenseMatrix: $ed89d4c20b089b73$export$97f0d27b48f120e8,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$841fc4d5a1480b85 = /* #__PURE__ */ (0, $8d46e2432e39dee8$export$2103fed9c34b0004)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Complex: $ed89d4c20b089b73$export$50ceb3fb9926e63e,
    Fraction: $ed89d4c20b089b73$export$b336c2702c498be5,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    isNegative: $ed89d4c20b089b73$export$d0909a4f38b5c4d0,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711,
    unaryMinus: $ed89d4c20b089b73$export$6cd304851a69e08
});
var $ed89d4c20b089b73$export$398604a469f7de9a = /* #__PURE__ */ (0, $12b0750539b49baf$export$a6e723c0e3b918d4)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    DenseMatrix: $ed89d4c20b089b73$export$97f0d27b48f120e8,
    Fraction: $ed89d4c20b089b73$export$b336c2702c498be5,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    equalScalar: $ed89d4c20b089b73$export$943761f5c9c3f156,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$2da9287da10b19e2 = /* #__PURE__ */ (0, $3f8e2116e8497f63$export$3e578d0534ab5935)({
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$ee1b3e54f0441b22 = /* #__PURE__ */ (0, $1e5b402e8818d906$export$c36b5511b12560e8)({
    isInteger: $ed89d4c20b089b73$export$a287f47fed4544b8,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$85b9a36db797e02b = /* #__PURE__ */ (0, $b97aae50b408899d$export$decd32c762b504bc)({
    prod: $ed89d4c20b089b73$export$5e143010dea16c85,
    size: $ed89d4c20b089b73$export$346677f925de839c,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$eb6ad7870b1d0b0b = /* #__PURE__ */ (0, $9b47d831cc2608c4$export$5d07146b3894f212)({
    conj: $ed89d4c20b089b73$export$fb254c661fe9c0db,
    transpose: $ed89d4c20b089b73$export$9cb09a71b7d66923,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$c042e7c2f59bc046 = /* #__PURE__ */ (0, $c8f494d197b3a6db$export$743a950f2cd4bacc)({
    DenseMatrix: $ed89d4c20b089b73$export$97f0d27b48f120e8,
    SparseMatrix: $ed89d4c20b089b73$export$de9b2b7556879848,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$67275f837d70084d = /* #__PURE__ */ (0, $88446208f5362d74$export$399593177816ff82)({
    numeric: $ed89d4c20b089b73$export$b7a508fa8dae59fc,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$c74f132961c51406 = /* #__PURE__ */ (0, $2343dfd1c51b4e20$export$e4930a420a373a24)({
    DenseMatrix: $ed89d4c20b089b73$export$97f0d27b48f120e8,
    divideScalar: $ed89d4c20b089b73$export$67275f837d70084d,
    equalScalar: $ed89d4c20b089b73$export$943761f5c9c3f156,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$411ce8e5a71e3069 = /* #__PURE__ */ (0, $0515173c22f58791$export$988f37bc1f709b0d)({
    DenseMatrix: $ed89d4c20b089b73$export$97f0d27b48f120e8,
    equalScalar: $ed89d4c20b089b73$export$943761f5c9c3f156,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$a535ef183b6128fa = /* #__PURE__ */ (0, $45e310f8771da7d3$export$41ce8d9733cb73c1)({
    addScalar: $ed89d4c20b089b73$export$2b7b095c4f443355,
    divideScalar: $ed89d4c20b089b73$export$67275f837d70084d,
    exp: $ed89d4c20b089b73$export$b310ec824aaee37f,
    i: $ed89d4c20b089b73$export$23f2a1d2818174ef,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    multiplyScalar: $ed89d4c20b089b73$export$c697bed75648cdb7,
    tau: $ed89d4c20b089b73$export$a4b4b4d4d776fe92,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$bffa455ba8c619a6 = /* #__PURE__ */ (0, $b5ad8281b188fc17$export$107988e3ee9f3d12)({
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$f81847884871263e = /* #__PURE__ */ (0, $90ee737470100bb9$export$2eb8acc96c598512)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    DenseMatrix: $ed89d4c20b089b73$export$97f0d27b48f120e8,
    equalScalar: $ed89d4c20b089b73$export$943761f5c9c3f156,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$f6fc628e09f3ff5d = /* #__PURE__ */ (0, $1394b7c758158021$export$acff9f91b891ace6)({
    isNumeric: $ed89d4c20b089b73$export$e90fb89750dba83f,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$f95c7888b62f8e9a = /* #__PURE__ */ (0, $37ba9516e51550e6$export$87e3687740a09cb)({
    abs: $ed89d4c20b089b73$export$2335f513bbd82c6d,
    addScalar: $ed89d4c20b089b73$export$2b7b095c4f443355,
    divideScalar: $ed89d4c20b089b73$export$67275f837d70084d,
    isPositive: $ed89d4c20b089b73$export$7e69d4236fcc3b19,
    multiplyScalar: $ed89d4c20b089b73$export$c697bed75648cdb7,
    smaller: $ed89d4c20b089b73$export$3f732695c1493aec,
    sqrt: $ed89d4c20b089b73$export$eba8049fb5020b81,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$776649b0bf8ce1fd = /* #__PURE__ */ (0, $f939700b33cdde6d$export$fb893320704d694a)({
    conj: $ed89d4c20b089b73$export$fb254c661fe9c0db,
    dotDivide: $ed89d4c20b089b73$export$c74f132961c51406,
    fft: $ed89d4c20b089b73$export$a535ef183b6128fa,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$44f32dfde3d58545 = /* #__PURE__ */ (0, $81a28db092625990$export$cee275bf38ddc295)({
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    multiplyScalar: $ed89d4c20b089b73$export$c697bed75648cdb7,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$72693dfc692346df = /* #__PURE__ */ (0, $653c14e56f7be1ca$export$26aa7f5b5fee1150)({
    DenseMatrix: $ed89d4c20b089b73$export$97f0d27b48f120e8,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$48901d58d322262f = /* #__PURE__ */ (0, $33f5848669d23bbf$export$ce15600b23f5e78)({
    DenseMatrix: $ed89d4c20b089b73$export$97f0d27b48f120e8,
    equalScalar: $ed89d4c20b089b73$export$943761f5c9c3f156,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711,
    zeros: $ed89d4c20b089b73$export$4445a00dafa2633b
});
var $ed89d4c20b089b73$export$be3b83cc1aa539e4 = /* #__PURE__ */ (0, $8ccd4616592e81e1$export$1b88d04961967a10)({
    DenseMatrix: $ed89d4c20b089b73$export$97f0d27b48f120e8,
    divideScalar: $ed89d4c20b089b73$export$67275f837d70084d,
    equalScalar: $ed89d4c20b089b73$export$943761f5c9c3f156,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    multiplyScalar: $ed89d4c20b089b73$export$c697bed75648cdb7,
    subtract: $ed89d4c20b089b73$export$4e2d2ead65e5f7e3,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$e8999e227859a482 = /* #__PURE__ */ (0, $504fd1964fd88314$export$65fefc9f63da4d13)({
    flatten: $ed89d4c20b089b73$export$bffa455ba8c619a6,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    size: $ed89d4c20b089b73$export$346677f925de839c,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$96ec731ed4dcb222 = /* #__PURE__ */ (0, $02bb6f64048cae79$export$b795f47e2b99170)({
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    numeric: $ed89d4c20b089b73$export$b7a508fa8dae59fc,
    smaller: $ed89d4c20b089b73$export$3f732695c1493aec,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$549ff81930776885 = /* #__PURE__ */ (0, $f807d4e52615def4$export$822530980ba269d9)({
    isNaN: $ed89d4c20b089b73$export$c9f5652083b8129d,
    isNumeric: $ed89d4c20b089b73$export$e90fb89750dba83f,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$adb173527af10aca = /* #__PURE__ */ (0, $45d02e7130a66684$export$36e27b45d2aa738c)({
    Complex: $ed89d4c20b089b73$export$50ceb3fb9926e63e,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    divideScalar: $ed89d4c20b089b73$export$67275f837d70084d,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$21041dee6b8001b0 = /* #__PURE__ */ (0, $b94aa3a321c12711$export$f524a435b9c16a90)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$54d1e322cf7aa273 = /* #__PURE__ */ (0, $30252cc422b2a269$export$47c1a746705f5c42)({
    compare: $ed89d4c20b089b73$export$398604a469f7de9a,
    isNaN: $ed89d4c20b089b73$export$c9f5652083b8129d,
    isNumeric: $ed89d4c20b089b73$export$e90fb89750dba83f,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$4380c87abf28fdf = /* #__PURE__ */ (0, $394f7d6546df11c8$export$58909557046ca413)({
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0
});
var $ed89d4c20b089b73$export$a1da16976d3a5f68 = /* #__PURE__ */ (0, $e9614007ff5a7b5f$export$ef742376390cbf7)({
    DenseMatrix: $ed89d4c20b089b73$export$97f0d27b48f120e8,
    equalScalar: $ed89d4c20b089b73$export$943761f5c9c3f156,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711,
    zeros: $ed89d4c20b089b73$export$4445a00dafa2633b
});
var $ed89d4c20b089b73$export$2077e0241d6afd3c = /* #__PURE__ */ (0, $e6aaa6da0a785dc8$export$c41ddfead54b1fbc)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    DenseMatrix: $ed89d4c20b089b73$export$97f0d27b48f120e8,
    equalScalar: $ed89d4c20b089b73$export$943761f5c9c3f156,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711,
    zeros: $ed89d4c20b089b73$export$4445a00dafa2633b
});
var $ed89d4c20b089b73$export$8d38c87f33a93d98 = /* #__PURE__ */ (0, $82571df89f4cff70$export$e1b2fff975be9083)({
    DenseMatrix: $ed89d4c20b089b73$export$97f0d27b48f120e8,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$b20c1c5fa0c7dd75 = /* #__PURE__ */ (0, $f8fcd935dc196172$export$833e6c382e279d04)({
    DenseMatrix: $ed89d4c20b089b73$export$97f0d27b48f120e8,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    equalScalar: $ed89d4c20b089b73$export$943761f5c9c3f156,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$41828460570e21eb = /* #__PURE__ */ (0, $707c0b6af4f4a7e5$export$f652f5e8e3e838da)({
    DenseMatrix: $ed89d4c20b089b73$export$97f0d27b48f120e8,
    divideScalar: $ed89d4c20b089b73$export$67275f837d70084d,
    equalScalar: $ed89d4c20b089b73$export$943761f5c9c3f156,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    multiplyScalar: $ed89d4c20b089b73$export$c697bed75648cdb7,
    subtract: $ed89d4c20b089b73$export$4e2d2ead65e5f7e3,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$6444ef5cd411280c = /* #__PURE__ */ (0, $655c8c9f11045b0d$export$a2b8cab2c7385f0e)({
    DenseMatrix: $ed89d4c20b089b73$export$97f0d27b48f120e8,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$e16d8520af44a096 = /* #__PURE__ */ (0, $3130c6bb84cb9430$export$c6b51545da64d82f)({
    DenseMatrix: $ed89d4c20b089b73$export$97f0d27b48f120e8,
    SparseMatrix: $ed89d4c20b089b73$export$de9b2b7556879848,
    addScalar: $ed89d4c20b089b73$export$2b7b095c4f443355,
    equalScalar: $ed89d4c20b089b73$export$943761f5c9c3f156,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$b8b770ee6a0d9760 = /* #__PURE__ */ (0, $5875922bf5468e3f$export$c56716e11a38354e)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    DenseMatrix: $ed89d4c20b089b73$export$97f0d27b48f120e8,
    equalScalar: $ed89d4c20b089b73$export$943761f5c9c3f156,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$361eb278cc70bacf = /* #__PURE__ */ (0, $1c7a232991ab04d4$export$f45a7846535e9b07)({
    DenseMatrix: $ed89d4c20b089b73$export$97f0d27b48f120e8,
    equalScalar: $ed89d4c20b089b73$export$943761f5c9c3f156,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$d8807a6c0487483a = /* #__PURE__ */ (0, $3c361448103bf479$export$5a3f7692f3d4dd50)({
    addScalar: $ed89d4c20b089b73$export$2b7b095c4f443355,
    combinations: $ed89d4c20b089b73$export$bdfcf4c6b5766439,
    divideScalar: $ed89d4c20b089b73$export$67275f837d70084d,
    isInteger: $ed89d4c20b089b73$export$a287f47fed4544b8,
    isNegative: $ed89d4c20b089b73$export$d0909a4f38b5c4d0,
    multiplyScalar: $ed89d4c20b089b73$export$c697bed75648cdb7,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$762e84baec56595d = /* #__PURE__ */ (0, $a2acd1552e59b5cf$export$ac9dd39e43534605)({
    compare: $ed89d4c20b089b73$export$398604a469f7de9a,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$71990b1e1c4912fe = /* #__PURE__ */ (0, $95fb3695e64d410c$export$e11ffe2ce577c262)({
    add: $ed89d4c20b089b73$export$e16d8520af44a096,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711,
    unaryPlus: $ed89d4c20b089b73$export$df8c837ae5df4ce4
});
var $ed89d4c20b089b73$export$9cb4719e2e525b7a = /* #__PURE__ */ (0, $1ca015603b832422$export$b1b11fc839367b58)({
    equal: $ed89d4c20b089b73$export$411ce8e5a71e3069,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$a37e3c603d7117e5 = /* #__PURE__ */ (0, $220ba1ccce520f09$export$49df08fd121951b4)({
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    number: $ed89d4c20b089b73$export$98e628dec113755e,
    subtract: $ed89d4c20b089b73$export$4e2d2ead65e5f7e3,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$94132a0e348806d4 = /* #__PURE__ */ (0, $9976cd53c699da0f$export$3dc59ff00984d687)({
    addScalar: $ed89d4c20b089b73$export$2b7b095c4f443355,
    conj: $ed89d4c20b089b73$export$fb254c661fe9c0db,
    multiplyScalar: $ed89d4c20b089b73$export$c697bed75648cdb7,
    size: $ed89d4c20b089b73$export$346677f925de839c,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$5bc21f656fb5d284 = /* #__PURE__ */ (0, $f17e7954f6ee7c0a$export$1589aaa29568b87)({
    compareText: $ed89d4c20b089b73$export$2da9287da10b19e2,
    isZero: $ed89d4c20b089b73$export$c46ec7d82fb1f602,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$a3fe094919f356fd = /* #__PURE__ */ (0, $f6280cce342fad8e$export$e04e4803a9128c9b)({
    DenseMatrix: $ed89d4c20b089b73$export$97f0d27b48f120e8,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    equalScalar: $ed89d4c20b089b73$export$943761f5c9c3f156,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    round: $ed89d4c20b089b73$export$2077e0241d6afd3c,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711,
    zeros: $ed89d4c20b089b73$export$4445a00dafa2633b
});
var $ed89d4c20b089b73$export$f0954fd7d5368655 = /* #__PURE__ */ (0, $fb30af8a6979a0f9$export$2eca89e9ac669625)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    DenseMatrix: $ed89d4c20b089b73$export$97f0d27b48f120e8,
    SparseMatrix: $ed89d4c20b089b73$export$de9b2b7556879848,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$5c1ba7f73c917315 = /* #__PURE__ */ (0, $e0121f565452861a$export$1e04c9355dadf1c8)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    add: $ed89d4c20b089b73$export$e16d8520af44a096,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    equal: $ed89d4c20b089b73$export$411ce8e5a71e3069,
    isInteger: $ed89d4c20b089b73$export$a287f47fed4544b8,
    mod: $ed89d4c20b089b73$export$842a2cf37af977e1,
    smaller: $ed89d4c20b089b73$export$3f732695c1493aec,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711,
    xgcd: $ed89d4c20b089b73$export$6ba103b0465fe6cc
});
var $ed89d4c20b089b73$export$a94a7414fa942aea = /* #__PURE__ */ (0, $684dbb1cf747e6c3$export$af9bc16ae70e9aa8)({
    DenseMatrix: $ed89d4c20b089b73$export$97f0d27b48f120e8,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$bef1f36f5486a6a3 = /* #__PURE__ */ (0, $8405c8baeee2ba0a$export$aea8a16d5c9d1b93)({
    Complex: $ed89d4c20b089b73$export$50ceb3fb9926e63e,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    divideScalar: $ed89d4c20b089b73$export$67275f837d70084d,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$de5c6af4003ef448 = /* #__PURE__ */ (0, $d9f225d7957974b1$export$70743fd0ad1f42d7)({
    DenseMatrix: $ed89d4c20b089b73$export$97f0d27b48f120e8,
    divideScalar: $ed89d4c20b089b73$export$67275f837d70084d,
    equalScalar: $ed89d4c20b089b73$export$943761f5c9c3f156,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    multiplyScalar: $ed89d4c20b089b73$export$c697bed75648cdb7,
    subtract: $ed89d4c20b089b73$export$4e2d2ead65e5f7e3,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$f4f4b934de52d430 = /* #__PURE__ */ (0, $30d219cc04ecd4dc$export$b72d61f960d7c36b)({
    flatten: $ed89d4c20b089b73$export$bffa455ba8c619a6,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    size: $ed89d4c20b089b73$export$346677f925de839c,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$2060d2db72cce88f = /* #__PURE__ */ (0, $c2f426575adc27ba$export$86d08fd318fa07c8)({
    addScalar: $ed89d4c20b089b73$export$2b7b095c4f443355,
    dot: $ed89d4c20b089b73$export$94132a0e348806d4,
    equalScalar: $ed89d4c20b089b73$export$943761f5c9c3f156,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    multiplyScalar: $ed89d4c20b089b73$export$c697bed75648cdb7,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$7c27fb47516129d9 = /* #__PURE__ */ (0, $f015874d25b628a8$export$39b52312ba2c4d03)({
    addScalar: $ed89d4c20b089b73$export$2b7b095c4f443355,
    complex: $ed89d4c20b089b73$export$83a0e34f1302825b,
    conj: $ed89d4c20b089b73$export$fb254c661fe9c0db,
    divideScalar: $ed89d4c20b089b73$export$67275f837d70084d,
    equal: $ed89d4c20b089b73$export$411ce8e5a71e3069,
    identity: $ed89d4c20b089b73$export$f0954fd7d5368655,
    isZero: $ed89d4c20b089b73$export$c46ec7d82fb1f602,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    multiplyScalar: $ed89d4c20b089b73$export$c697bed75648cdb7,
    sign: $ed89d4c20b089b73$export$c5552dfdbc7cec71,
    sqrt: $ed89d4c20b089b73$export$eba8049fb5020b81,
    subtract: $ed89d4c20b089b73$export$4e2d2ead65e5f7e3,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711,
    unaryMinus: $ed89d4c20b089b73$export$6cd304851a69e08,
    zeros: $ed89d4c20b089b73$export$4445a00dafa2633b
});
var $ed89d4c20b089b73$export$d02631cccf789723 = /* #__PURE__ */ (0, $800a158788abd9d6$export$d372f2f3c4d1b8e5)({
    bignumber: $ed89d4c20b089b73$export$8576f72eb7f14a7e,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    larger: $ed89d4c20b089b73$export$a94a7414fa942aea,
    largerEq: $ed89d4c20b089b73$export$72693dfc692346df,
    smaller: $ed89d4c20b089b73$export$3f732695c1493aec,
    smallerEq: $ed89d4c20b089b73$export$8d38c87f33a93d98,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$502f8a5a1147da = /* #__PURE__ */ (0, $37a4e2e4508818f4$export$2dd001e9fd66adcd)({
    DenseMatrix: $ed89d4c20b089b73$export$97f0d27b48f120e8,
    equalScalar: $ed89d4c20b089b73$export$943761f5c9c3f156,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711,
    zeros: $ed89d4c20b089b73$export$4445a00dafa2633b
});
var $ed89d4c20b089b73$export$1c70a6cc12bc0366 = /* #__PURE__ */ (0, $dedeed91a301fa74$export$55134310fc79366a)({
    compareNatural: $ed89d4c20b089b73$export$762e84baec56595d,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$95c7459688ef4e3a = /* #__PURE__ */ (0, $4e9454c6117f0ccc$export$e44ac9822ce417ae)({
    SparseMatrix: $ed89d4c20b089b73$export$de9b2b7556879848,
    abs: $ed89d4c20b089b73$export$2335f513bbd82c6d,
    add: $ed89d4c20b089b73$export$e16d8520af44a096,
    divideScalar: $ed89d4c20b089b73$export$67275f837d70084d,
    larger: $ed89d4c20b089b73$export$a94a7414fa942aea,
    largerEq: $ed89d4c20b089b73$export$72693dfc692346df,
    multiply: $ed89d4c20b089b73$export$2060d2db72cce88f,
    subtract: $ed89d4c20b089b73$export$4e2d2ead65e5f7e3,
    transpose: $ed89d4c20b089b73$export$9cb09a71b7d66923,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$8a63f25cc62965f1 = /* #__PURE__ */ (0, $6e1553ed8eaa8d62$export$14d444d810bc35b5)({
    add: $ed89d4c20b089b73$export$e16d8520af44a096,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    numeric: $ed89d4c20b089b73$export$b7a508fa8dae59fc,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$357889f174732d38 = /* #__PURE__ */ (0, $240130b95903c32f$export$acff8254414be03b)({
    add: $ed89d4c20b089b73$export$e16d8520af44a096,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$c8a1cf0e83678d9 = /* #__PURE__ */ (0, $07876562cef2037d$export$c8bbc8bec60c7fc3)({
    DenseMatrix: $ed89d4c20b089b73$export$97f0d27b48f120e8,
    divideScalar: $ed89d4c20b089b73$export$67275f837d70084d,
    equalScalar: $ed89d4c20b089b73$export$943761f5c9c3f156,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    multiplyScalar: $ed89d4c20b089b73$export$c697bed75648cdb7,
    subtract: $ed89d4c20b089b73$export$4e2d2ead65e5f7e3,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$41726bdb1fc63f = /* #__PURE__ */ (0, $25a1e2e6a1388cbc$export$5f05d91ddc56bc14)({
    Complex: $ed89d4c20b089b73$export$50ceb3fb9926e63e,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$803ce6b71a0a94b2 = /* #__PURE__ */ (0, $6b60b8aa1ec7db00$export$bab247d909829ddf)({
    DenseMatrix: $ed89d4c20b089b73$export$97f0d27b48f120e8,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    equalScalar: $ed89d4c20b089b73$export$943761f5c9c3f156,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    round: $ed89d4c20b089b73$export$2077e0241d6afd3c,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711,
    zeros: $ed89d4c20b089b73$export$4445a00dafa2633b
});
var $ed89d4c20b089b73$export$fd2cf6bce05a0b18 = /* #__PURE__ */ (0, $c2caee1d2208fc45$export$1ddf9cbadd17315f)({
    addScalar: $ed89d4c20b089b73$export$2b7b095c4f443355,
    combinations: $ed89d4c20b089b73$export$bdfcf4c6b5766439,
    isInteger: $ed89d4c20b089b73$export$a287f47fed4544b8,
    isNegative: $ed89d4c20b089b73$export$d0909a4f38b5c4d0,
    isPositive: $ed89d4c20b089b73$export$7e69d4236fcc3b19,
    larger: $ed89d4c20b089b73$export$a94a7414fa942aea,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$bb646b20bb93d339 = /* #__PURE__ */ (0, $ea17902fc0c95a99$export$bc2585c0ed744c0e)({
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    multiply: $ed89d4c20b089b73$export$2060d2db72cce88f,
    subtract: $ed89d4c20b089b73$export$4e2d2ead65e5f7e3,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$d063d65fed97e7fa = /* #__PURE__ */ (0, $03d1dc9783c3f11a$export$93f810683c54b005)({
    divideScalar: $ed89d4c20b089b73$export$67275f837d70084d,
    isZero: $ed89d4c20b089b73$export$c46ec7d82fb1f602,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    multiply: $ed89d4c20b089b73$export$2060d2db72cce88f,
    subtract: $ed89d4c20b089b73$export$4e2d2ead65e5f7e3,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711,
    unaryMinus: $ed89d4c20b089b73$export$6cd304851a69e08
});
var $ed89d4c20b089b73$export$9f17032d917177de = /* #__PURE__ */ (0, $77add40d9e3f9b43$export$23f482ad1a94fa7e)({
    abs: $ed89d4c20b089b73$export$2335f513bbd82c6d,
    addScalar: $ed89d4c20b089b73$export$2b7b095c4f443355,
    divideScalar: $ed89d4c20b089b73$export$67275f837d70084d,
    multiplyScalar: $ed89d4c20b089b73$export$c697bed75648cdb7,
    sqrt: $ed89d4c20b089b73$export$eba8049fb5020b81,
    subtract: $ed89d4c20b089b73$export$4e2d2ead65e5f7e3,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711,
    unaryMinus: $ed89d4c20b089b73$export$6cd304851a69e08
});
var $ed89d4c20b089b73$export$c6d93afbf4ee8afc = /* #__PURE__ */ (0, $0e4903b2befa5dae$export$a4620e84460f321e)({
    equalScalar: $ed89d4c20b089b73$export$943761f5c9c3f156,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    multiplyScalar: $ed89d4c20b089b73$export$c697bed75648cdb7,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$dd5bb73729f20aa3 = /* #__PURE__ */ (0, $ec58370dc92fd308$export$3143a09e27a84c41)({
    larger: $ed89d4c20b089b73$export$a94a7414fa942aea,
    smaller: $ed89d4c20b089b73$export$3f732695c1493aec
});
var $ed89d4c20b089b73$export$d838837eb5b184e3 = /* #__PURE__ */ (0, $20a0cc318f977309$export$3ed06081b8a4ee6)({
    Complex: $ed89d4c20b089b73$export$50ceb3fb9926e63e,
    DenseMatrix: $ed89d4c20b089b73$export$97f0d27b48f120e8,
    ceil: $ed89d4c20b089b73$export$803ce6b71a0a94b2,
    equalScalar: $ed89d4c20b089b73$export$943761f5c9c3f156,
    floor: $ed89d4c20b089b73$export$a3fe094919f356fd,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711,
    zeros: $ed89d4c20b089b73$export$4445a00dafa2633b
});
var $ed89d4c20b089b73$export$66fe727d7ec8c7b9 = /* #__PURE__ */ (0, $9c1144a03dbe6f48$export$49a565643b9ab608)({
    DenseMatrix: $ed89d4c20b089b73$export$97f0d27b48f120e8,
    smaller: $ed89d4c20b089b73$export$3f732695c1493aec
});
var $ed89d4c20b089b73$export$cf17b003b6192af3 = /* #__PURE__ */ (0, $b90195680626113a$export$300720b4fe34e62e)({
    ImmutableDenseMatrix: $ed89d4c20b089b73$export$66fe727d7ec8c7b9
});
var $ed89d4c20b089b73$export$1f4807a235930d45 = /* #__PURE__ */ (0, $28723d1534b136da$export$e2d92d8f89fdd92d)({
    abs: $ed89d4c20b089b73$export$2335f513bbd82c6d,
    add: $ed89d4c20b089b73$export$e16d8520af44a096,
    addScalar: $ed89d4c20b089b73$export$2b7b095c4f443355,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    divideScalar: $ed89d4c20b089b73$export$67275f837d70084d,
    equalScalar: $ed89d4c20b089b73$export$943761f5c9c3f156,
    flatten: $ed89d4c20b089b73$export$bffa455ba8c619a6,
    isNumeric: $ed89d4c20b089b73$export$e90fb89750dba83f,
    isZero: $ed89d4c20b089b73$export$c46ec7d82fb1f602,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    multiply: $ed89d4c20b089b73$export$2060d2db72cce88f,
    multiplyScalar: $ed89d4c20b089b73$export$c697bed75648cdb7,
    smaller: $ed89d4c20b089b73$export$3f732695c1493aec,
    subtract: $ed89d4c20b089b73$export$4e2d2ead65e5f7e3,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$f686d97e407ec4ef = /* #__PURE__ */ (0, $05fb4effad623485$export$5d3af1956d9bb33b)({
    equalScalar: $ed89d4c20b089b73$export$943761f5c9c3f156,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$144dcf16adfb9698 = /* #__PURE__ */ (0, $95662a94e91cd3f8$export$93da279859a704f0)({
    Complex: $ed89d4c20b089b73$export$50ceb3fb9926e63e,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    divideScalar: $ed89d4c20b089b73$export$67275f837d70084d,
    log: $ed89d4c20b089b73$export$bef1f36f5486a6a3,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$8960430cfd85939f = /* #__PURE__ */ (0, $3b645b58d3c5484c$export$b18a1b0c26c000ee)({
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    larger: $ed89d4c20b089b73$export$a94a7414fa942aea,
    numeric: $ed89d4c20b089b73$export$b7a508fa8dae59fc,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$ff63ee916cadcfe = /* #__PURE__ */ (0, $9b05ba7d0392c532$export$524607d17ea053e9)({
    add: $ed89d4c20b089b73$export$e16d8520af44a096,
    compare: $ed89d4c20b089b73$export$398604a469f7de9a,
    multiply: $ed89d4c20b089b73$export$2060d2db72cce88f,
    partitionSelect: $ed89d4c20b089b73$export$54d1e322cf7aa273,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$120ff0929b202a6d = /* #__PURE__ */ (0, $9f5952ec29ad9446$export$3442c5d213434705)({
    Index: $ed89d4c20b089b73$export$cf17b003b6192af3,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    range: $ed89d4c20b089b73$export$d02631cccf789723,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$dcac7a71ff10ad82 = /* #__PURE__ */ (0, $fbaa05cffb8cba99$export$9fa12a9d198718c8)({
    DenseMatrix: $ed89d4c20b089b73$export$97f0d27b48f120e8,
    Index: $ed89d4c20b089b73$export$cf17b003b6192af3,
    compareNatural: $ed89d4c20b089b73$export$762e84baec56595d,
    size: $ed89d4c20b089b73$export$346677f925de839c,
    subset: $ed89d4c20b089b73$export$e06bd7b1ab877a71,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$ec60221e756bab15 = /* #__PURE__ */ (0, $0dc24e9a07b9f5ba$export$c149680b9d8f2963)({
    DenseMatrix: $ed89d4c20b089b73$export$97f0d27b48f120e8,
    Index: $ed89d4c20b089b73$export$cf17b003b6192af3,
    compareNatural: $ed89d4c20b089b73$export$762e84baec56595d,
    size: $ed89d4c20b089b73$export$346677f925de839c,
    subset: $ed89d4c20b089b73$export$e06bd7b1ab877a71,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$ca5251f59a067f9a = /* #__PURE__ */ (0, $fada4357731287d7$export$40ad73493b9f8712)({
    Index: $ed89d4c20b089b73$export$cf17b003b6192af3,
    compareNatural: $ed89d4c20b089b73$export$762e84baec56595d,
    size: $ed89d4c20b089b73$export$346677f925de839c,
    subset: $ed89d4c20b089b73$export$e06bd7b1ab877a71,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$f6ce4c11993e56f2 = /* #__PURE__ */ (0, $ad311d25c88378e9$export$55c6b5cb0b0637db)({
    Index: $ed89d4c20b089b73$export$cf17b003b6192af3,
    compareNatural: $ed89d4c20b089b73$export$762e84baec56595d,
    size: $ed89d4c20b089b73$export$346677f925de839c,
    subset: $ed89d4c20b089b73$export$e06bd7b1ab877a71,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$97db5808d8f88186 = /* #__PURE__ */ (0, $c188ce4a68cd8883$export$10463693a2093403)({
    compare: $ed89d4c20b089b73$export$398604a469f7de9a,
    compareNatural: $ed89d4c20b089b73$export$762e84baec56595d,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$4e0c71f277ca26b3 = /* #__PURE__ */ (0, $cfa633333096bba9$export$1bfa986e9c92c0b5)({
    Index: $ed89d4c20b089b73$export$cf17b003b6192af3,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    range: $ed89d4c20b089b73$export$d02631cccf789723,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$b610b8812bbcded9 = /* #__PURE__ */ (0, $d311d25c4bf6dff2$export$c6d108d7c8095f19)({
    Index: $ed89d4c20b089b73$export$cf17b003b6192af3,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$c02accee9f2b6a8f = /* #__PURE__ */ (0, $dd56c50501f95659$export$ad9771ef9eafe06a)({
    abs: $ed89d4c20b089b73$export$2335f513bbd82c6d,
    addScalar: $ed89d4c20b089b73$export$2b7b095c4f443355,
    det: $ed89d4c20b089b73$export$d063d65fed97e7fa,
    divideScalar: $ed89d4c20b089b73$export$67275f837d70084d,
    identity: $ed89d4c20b089b73$export$f0954fd7d5368655,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    multiply: $ed89d4c20b089b73$export$2060d2db72cce88f,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711,
    unaryMinus: $ed89d4c20b089b73$export$6cd304851a69e08
});
var $ed89d4c20b089b73$export$5cde0f23b96c7c61 = /* #__PURE__ */ (0, $0562ba836acfa9d6$export$1456c5eaeee6aa07)({
    Complex: $ed89d4c20b089b73$export$50ceb3fb9926e63e,
    add: $ed89d4c20b089b73$export$e16d8520af44a096,
    ctranspose: $ed89d4c20b089b73$export$eb6ad7870b1d0b0b,
    deepEqual: $ed89d4c20b089b73$export$9cb4719e2e525b7a,
    divideScalar: $ed89d4c20b089b73$export$67275f837d70084d,
    dot: $ed89d4c20b089b73$export$94132a0e348806d4,
    dotDivide: $ed89d4c20b089b73$export$c74f132961c51406,
    equal: $ed89d4c20b089b73$export$411ce8e5a71e3069,
    inv: $ed89d4c20b089b73$export$c02accee9f2b6a8f,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    multiply: $ed89d4c20b089b73$export$2060d2db72cce88f,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$9c297f60e22e3389 = /* #__PURE__ */ (0, $db869f8892627191$export$9c94d2d08a8d8146)({
    Complex: $ed89d4c20b089b73$export$50ceb3fb9926e63e,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    fraction: $ed89d4c20b089b73$export$7f34ce79760854f7,
    identity: $ed89d4c20b089b73$export$f0954fd7d5368655,
    inv: $ed89d4c20b089b73$export$c02accee9f2b6a8f,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    multiply: $ed89d4c20b089b73$export$2060d2db72cce88f,
    number: $ed89d4c20b089b73$export$98e628dec113755e,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$8bd517cc5b3722f7 = /* #__PURE__ */ (0, $b917d1decdc25499$export$d81c0f9dab86d854)({
    DenseMatrix: $ed89d4c20b089b73$export$97f0d27b48f120e8,
    Index: $ed89d4c20b089b73$export$cf17b003b6192af3,
    compareNatural: $ed89d4c20b089b73$export$762e84baec56595d,
    size: $ed89d4c20b089b73$export$346677f925de839c,
    subset: $ed89d4c20b089b73$export$e06bd7b1ab877a71,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$8bb4a52260216736 = /* #__PURE__ */ (0, $633716d7a5d3b648$export$d1f961d649e525df)({
    Index: $ed89d4c20b089b73$export$cf17b003b6192af3,
    compareNatural: $ed89d4c20b089b73$export$762e84baec56595d,
    size: $ed89d4c20b089b73$export$346677f925de839c,
    subset: $ed89d4c20b089b73$export$e06bd7b1ab877a71,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$6d4069f4b64f7492 = /* #__PURE__ */ (0, $408ad15099e65a98$export$5e37e847685a0540)({
    FibonacciHeap: $ed89d4c20b089b73$export$dd5bb73729f20aa3,
    addScalar: $ed89d4c20b089b73$export$2b7b095c4f443355,
    equalScalar: $ed89d4c20b089b73$export$943761f5c9c3f156
});
var $ed89d4c20b089b73$export$17c7cd2216e18593 = /* #__PURE__ */ (0, $e69bd42b49013a9f$export$71d0f952576e7511)({
    abs: $ed89d4c20b089b73$export$2335f513bbd82c6d,
    add: $ed89d4c20b089b73$export$e16d8520af44a096,
    identity: $ed89d4c20b089b73$export$f0954fd7d5368655,
    inv: $ed89d4c20b089b73$export$c02accee9f2b6a8f,
    max: $ed89d4c20b089b73$export$8960430cfd85939f,
    multiply: $ed89d4c20b089b73$export$2060d2db72cce88f,
    size: $ed89d4c20b089b73$export$346677f925de839c,
    sqrt: $ed89d4c20b089b73$export$eba8049fb5020b81,
    subtract: $ed89d4c20b089b73$export$4e2d2ead65e5f7e3,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$1d8b9ae22d404866 = /* #__PURE__ */ (0, $898e4cfe14895b45$export$3ad06557a3ac7a63)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Complex: $ed89d4c20b089b73$export$50ceb3fb9926e63e,
    Fraction: $ed89d4c20b089b73$export$b336c2702c498be5,
    abs: $ed89d4c20b089b73$export$2335f513bbd82c6d,
    addScalar: $ed89d4c20b089b73$export$2b7b095c4f443355,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    divideScalar: $ed89d4c20b089b73$export$67275f837d70084d,
    equal: $ed89d4c20b089b73$export$411ce8e5a71e3069,
    fix: $ed89d4c20b089b73$export$d838837eb5b184e3,
    format: $ed89d4c20b089b73$export$d9468344d3651243,
    isNumeric: $ed89d4c20b089b73$export$e90fb89750dba83f,
    multiplyScalar: $ed89d4c20b089b73$export$c697bed75648cdb7,
    number: $ed89d4c20b089b73$export$98e628dec113755e,
    pow: $ed89d4c20b089b73$export$9c297f60e22e3389,
    round: $ed89d4c20b089b73$export$2077e0241d6afd3c,
    subtract: $ed89d4c20b089b73$export$4e2d2ead65e5f7e3
});
var $ed89d4c20b089b73$export$4b15dbe639ad9539 = /* #__PURE__ */ (0, $f30778583b16570c$export$c9ff08d282f03cf0)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$2bcc1e96766dec50 = /* #__PURE__ */ (0, $f30778583b16570c$export$3c74568e9574d168)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$11b531e5540c3ca4 = /* #__PURE__ */ (0, $f30778583b16570c$export$2f8d2da219209d0a)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$c779781d69f736e8 = /* #__PURE__ */ (0, $f30778583b16570c$export$f5851397fd1173db)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$f727e86dcab4e2c6 = /* #__PURE__ */ (0, $f30778583b16570c$export$221b7a8c9510b6cc)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$6eafe330bdda8c71 = /* #__PURE__ */ (0, $f30778583b16570c$export$e26bbd27fc291ddf)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$aab44654646f3ccc = /* #__PURE__ */ (0, $1ce9cae43880ed35$export$27641941eb5cadbb)({
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$80bf07f129ad1319 = /* #__PURE__ */ (0, $f30778583b16570c$export$a403f6c5bed71f22)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$ef3b15136279c2ab = /* #__PURE__ */ (0, $344ee122e154a1a5$export$734b49568d8effd6)({
    DenseMatrix: $ed89d4c20b089b73$export$97f0d27b48f120e8,
    equalScalar: $ed89d4c20b089b73$export$943761f5c9c3f156,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    pow: $ed89d4c20b089b73$export$9c297f60e22e3389,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$11ff82822f958f25 = /* #__PURE__ */ (0, $f30778583b16570c$export$d69030cf93f04407)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$199cdfec7f52c877 = /* #__PURE__ */ (0, $f30778583b16570c$export$542715ad7e3a9798)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$d9bacaa51f70e8e = /* #__PURE__ */ (0, $17cfa07a4997488f$export$f2c0a6357ff6cb4c)({
    abs: $ed89d4c20b089b73$export$2335f513bbd82c6d,
    add: $ed89d4c20b089b73$export$e16d8520af44a096,
    identity: $ed89d4c20b089b73$export$f0954fd7d5368655,
    inv: $ed89d4c20b089b73$export$c02accee9f2b6a8f,
    multiply: $ed89d4c20b089b73$export$2060d2db72cce88f,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$7130fbae042d5c0f = /* #__PURE__ */ (0, $f30778583b16570c$export$17ef8d738c9b0091)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$f83f3c3b84952e0b = /* #__PURE__ */ (0, $f30778583b16570c$export$266a9bae8a62fb6e)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$a7ebe8cc6aaf8d37 = /* #__PURE__ */ (0, $a972424be30d4005$export$115da31fc3cf3d15)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Complex: $ed89d4c20b089b73$export$50ceb3fb9926e63e,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    multiplyScalar: $ed89d4c20b089b73$export$c697bed75648cdb7,
    pow: $ed89d4c20b089b73$export$9c297f60e22e3389,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$d9cccfa50756330b = /* #__PURE__ */ (0, $f30778583b16570c$export$157e78cb05354391)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$37b0dd3693d47685 = /* #__PURE__ */ (0, $f30778583b16570c$export$8bb818baeaa40bd6)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$10054c6b64de12f5 = /* #__PURE__ */ (0, $f30778583b16570c$export$e3f21ac13bee6a0f)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$9eedba962d6a1c01 = /* #__PURE__ */ (0, $f30778583b16570c$export$c38bce537e0ffddb)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$ba3f3691dd1c5a7 = /* #__PURE__ */ (0, $f30778583b16570c$export$e7fcb8898ecb0703)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$6d4ff429f3f89356 = /* #__PURE__ */ (0, $f30778583b16570c$export$85414d775c93e6de)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$dacf4a2cf8881dff = /* #__PURE__ */ (0, $f30778583b16570c$export$12e2358797b853c9)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$ba7a41eda790cc15 = /* #__PURE__ */ (0, $f30778583b16570c$export$676d5ebe8fbeb250)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$7274fb1d27d1cd19 = /* #__PURE__ */ (0, $f30778583b16570c$export$9670d94122b9a81b)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$9b1b4e5bc980cec6 = /* #__PURE__ */ (0, $f30778583b16570c$export$43e139a6eec1ab59)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$c20ab336465d7d5e = /* #__PURE__ */ (0, $f30778583b16570c$export$675ebbcd6bdcebd7)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$5a85cd1a26c2cced = /* #__PURE__ */ (0, $f30778583b16570c$export$d21f20fc89fac8c0)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$1c88a737209eb089 = /* #__PURE__ */ (0, $f30778583b16570c$export$f357c1a8d4fccef6)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$963167ae5579ea00 = /* #__PURE__ */ (0, $f30778583b16570c$export$50bee65ab76b402)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$683732ab8f5759dc = /* #__PURE__ */ (0, $f30778583b16570c$export$fd1b48ecb0d5c0ef)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$9404cfefeb010e68 = /* #__PURE__ */ (0, $6afc4254d8dd8701$export$b20ee2bdfbf6defd)({
    DenseMatrix: $ed89d4c20b089b73$export$97f0d27b48f120e8,
    Index: $ed89d4c20b089b73$export$cf17b003b6192af3,
    compareNatural: $ed89d4c20b089b73$export$762e84baec56595d,
    size: $ed89d4c20b089b73$export$346677f925de839c,
    subset: $ed89d4c20b089b73$export$e06bd7b1ab877a71,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$5d66ae3b3e8fce48 = /* #__PURE__ */ (0, $f30778583b16570c$export$ace78258608300fc)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$f63e81544c3d56ef = /* #__PURE__ */ (0, $f30778583b16570c$export$a943525a62f69cd2)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$93039724ea765a8e = /* #__PURE__ */ (0, $f30778583b16570c$export$229739a879741f68)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$1236f2451dbdfd63 = /* #__PURE__ */ (0, $f30778583b16570c$export$4924e3d8de6ad850)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$5a57f82afcc3edeb = /* #__PURE__ */ (0, $f30778583b16570c$export$19b72356ad84e4ee)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$2f2e110dac549211 = /* #__PURE__ */ (0, $f30778583b16570c$export$815f2029cd62d0d6)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$cd007d971a5a2143 = /* #__PURE__ */ (0, $91be779ec18fe4c7$export$4df5e56bb6d14758)({
    divideScalar: $ed89d4c20b089b73$export$67275f837d70084d,
    equalScalar: $ed89d4c20b089b73$export$943761f5c9c3f156,
    inv: $ed89d4c20b089b73$export$c02accee9f2b6a8f,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    multiply: $ed89d4c20b089b73$export$2060d2db72cce88f,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$c00fb43e712bef2c = /* #__PURE__ */ (0, $f30778583b16570c$export$85362d2a7862e209)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$329ce89a99f0e343 = /* #__PURE__ */ (0, $7af5940f10e9442f$export$92c37ad44e3d0481)({
    gamma: $ed89d4c20b089b73$export$a7ebe8cc6aaf8d37,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$bfb00cec0048377d = /* #__PURE__ */ (0, $f30778583b16570c$export$42b5845f95e0feee)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$f060c4f0aa5bef89 = /* #__PURE__ */ (0, $f30778583b16570c$export$f2f136373157165b)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$91d2d01a33a1e6f8 = /* #__PURE__ */ (0, $91601432d3f984b9$export$86ddf344397699d5)({
    DenseMatrix: $ed89d4c20b089b73$export$97f0d27b48f120e8,
    Spa: $ed89d4c20b089b73$export$6d4069f4b64f7492,
    SparseMatrix: $ed89d4c20b089b73$export$de9b2b7556879848,
    abs: $ed89d4c20b089b73$export$2335f513bbd82c6d,
    addScalar: $ed89d4c20b089b73$export$2b7b095c4f443355,
    divideScalar: $ed89d4c20b089b73$export$67275f837d70084d,
    equalScalar: $ed89d4c20b089b73$export$943761f5c9c3f156,
    larger: $ed89d4c20b089b73$export$a94a7414fa942aea,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    multiplyScalar: $ed89d4c20b089b73$export$c697bed75648cdb7,
    subtract: $ed89d4c20b089b73$export$4e2d2ead65e5f7e3,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711,
    unaryMinus: $ed89d4c20b089b73$export$6cd304851a69e08
});
var $ed89d4c20b089b73$export$699e2a89b148c5ee = /* #__PURE__ */ (0, $f30778583b16570c$export$fd46b6c8680e4d01)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$9589ebe123df8f2e = /* #__PURE__ */ (0, $f30778583b16570c$export$d5045cf71611a462)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$f4d580f3101a1c7e = /* #__PURE__ */ (0, $a0ab79d22b3ae8a3$export$b15aee1001d110)({
    add: $ed89d4c20b089b73$export$e16d8520af44a096,
    divide: $ed89d4c20b089b73$export$cd007d971a5a2143,
    factorial: $ed89d4c20b089b73$export$329ce89a99f0e343,
    isInteger: $ed89d4c20b089b73$export$a287f47fed4544b8,
    isPositive: $ed89d4c20b089b73$export$7e69d4236fcc3b19,
    multiply: $ed89d4c20b089b73$export$2060d2db72cce88f,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$4567adbe5dd91621 = /* #__PURE__ */ (0, $be9ccd6b3be7f5c1$export$1d58d7915914cc9c)({
    factorial: $ed89d4c20b089b73$export$329ce89a99f0e343,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$5ce790af25e5ac75 = /* #__PURE__ */ (0, $f30778583b16570c$export$d44b96c94520b20e)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$5d88bfa2004001d3 = /* #__PURE__ */ (0, $f30778583b16570c$export$6840f334b8a5b6b1)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$1f7c42a78c01e4f9 = /* #__PURE__ */ (0, $f30778583b16570c$export$ea93a35a6f35e1b6)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$a5abae3de3985f2f = /* #__PURE__ */ (0, $f0b7289c0552c7b2$export$18813d136a9b83d0)({
    bignumber: $ed89d4c20b089b73$export$8576f72eb7f14a7e,
    addScalar: $ed89d4c20b089b73$export$2b7b095c4f443355,
    combinations: $ed89d4c20b089b73$export$bdfcf4c6b5766439,
    divideScalar: $ed89d4c20b089b73$export$67275f837d70084d,
    factorial: $ed89d4c20b089b73$export$329ce89a99f0e343,
    isInteger: $ed89d4c20b089b73$export$a287f47fed4544b8,
    isNegative: $ed89d4c20b089b73$export$d0909a4f38b5c4d0,
    larger: $ed89d4c20b089b73$export$a94a7414fa942aea,
    multiplyScalar: $ed89d4c20b089b73$export$c697bed75648cdb7,
    number: $ed89d4c20b089b73$export$98e628dec113755e,
    pow: $ed89d4c20b089b73$export$9c297f60e22e3389,
    subtract: $ed89d4c20b089b73$export$4e2d2ead65e5f7e3,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$523c0b569236b342 = /* #__PURE__ */ (0, $14dd6c4acdb9f4f4$export$17074f98b69d2545)({
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$bb522a71cda46a13 = /* #__PURE__ */ (0, $6e51035b9e1a81dc$export$7b7dc3bd00d38afb)({
    addScalar: $ed89d4c20b089b73$export$2b7b095c4f443355,
    isInteger: $ed89d4c20b089b73$export$a287f47fed4544b8,
    isNegative: $ed89d4c20b089b73$export$d0909a4f38b5c4d0,
    stirlingS2: $ed89d4c20b089b73$export$a5abae3de3985f2f,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$e822b38c59ee8a2a = /* #__PURE__ */ (0, $6fc6236b87bf06e9$export$ba9e077a2df092d7)({
    abs: $ed89d4c20b089b73$export$2335f513bbd82c6d,
    add: $ed89d4c20b089b73$export$e16d8520af44a096,
    addScalar: $ed89d4c20b089b73$export$2b7b095c4f443355,
    atan: $ed89d4c20b089b73$export$628dc4eed22b0fbd,
    bignumber: $ed89d4c20b089b73$export$8576f72eb7f14a7e,
    column: $ed89d4c20b089b73$export$4e0c71f277ca26b3,
    complex: $ed89d4c20b089b73$export$83a0e34f1302825b,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    cos: $ed89d4c20b089b73$export$50d414a77b60d802,
    diag: $ed89d4c20b089b73$export$c042e7c2f59bc046,
    divideScalar: $ed89d4c20b089b73$export$67275f837d70084d,
    dot: $ed89d4c20b089b73$export$94132a0e348806d4,
    equal: $ed89d4c20b089b73$export$411ce8e5a71e3069,
    flatten: $ed89d4c20b089b73$export$bffa455ba8c619a6,
    im: $ed89d4c20b089b73$export$5fc500b917996661,
    inv: $ed89d4c20b089b73$export$c02accee9f2b6a8f,
    larger: $ed89d4c20b089b73$export$a94a7414fa942aea,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    matrixFromColumns: $ed89d4c20b089b73$export$e8999e227859a482,
    multiply: $ed89d4c20b089b73$export$2060d2db72cce88f,
    multiplyScalar: $ed89d4c20b089b73$export$c697bed75648cdb7,
    number: $ed89d4c20b089b73$export$98e628dec113755e,
    qr: $ed89d4c20b089b73$export$7c27fb47516129d9,
    re: $ed89d4c20b089b73$export$b1f1627d659a651,
    sin: $ed89d4c20b089b73$export$5de3937cb4b592ed,
    smaller: $ed89d4c20b089b73$export$3f732695c1493aec,
    sqrt: $ed89d4c20b089b73$export$eba8049fb5020b81,
    subtract: $ed89d4c20b089b73$export$4e2d2ead65e5f7e3,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711,
    usolve: $ed89d4c20b089b73$export$41828460570e21eb,
    usolveAll: $ed89d4c20b089b73$export$c8a1cf0e83678d9
});
var $ed89d4c20b089b73$export$84a9a66802fec40 = /* #__PURE__ */ (0, $f30778583b16570c$export$b6687a2f3911256b)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$1ce691f85baaa52 = /* #__PURE__ */ (0, $ca8f568d87cc3b8f$export$301ef7ca1de6782c)({
    add: $ed89d4c20b089b73$export$e16d8520af44a096,
    divide: $ed89d4c20b089b73$export$cd007d971a5a2143,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$863459416408c428 = /* #__PURE__ */ (0, $f30778583b16570c$export$f5e8f56ebfacbaca)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$cbd33810258dab2e = /* #__PURE__ */ (0, $f30778583b16570c$export$e58ff8150d83ea6a)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$a7eac91d5496c35b = /* #__PURE__ */ (0, $0494ffff2b4a0baf$export$4a9a0ead2012bfc4)({
    Index: $ed89d4c20b089b73$export$cf17b003b6192af3,
    concat: $ed89d4c20b089b73$export$ee1b3e54f0441b22,
    setDifference: $ed89d4c20b089b73$export$8bd517cc5b3722f7,
    size: $ed89d4c20b089b73$export$346677f925de839c,
    subset: $ed89d4c20b089b73$export$e06bd7b1ab877a71,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$f48a0c6b8cc21601 = /* #__PURE__ */ (0, $f30778583b16570c$export$68a9771dccce9a23)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$fccc724a69f253a = /* #__PURE__ */ (0, $355a604d27dae86b$export$a3f0777edf21dcd5)({
    DenseMatrix: $ed89d4c20b089b73$export$97f0d27b48f120e8,
    lsolve: $ed89d4c20b089b73$export$be3b83cc1aa539e4,
    lup: $ed89d4c20b089b73$export$91d2d01a33a1e6f8,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    slu: $ed89d4c20b089b73$export$95c7459688ef4e3a,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711,
    usolve: $ed89d4c20b089b73$export$41828460570e21eb
});
var $ed89d4c20b089b73$export$9c490b34b2f16a34 = /* #__PURE__ */ (0, $7146c3b54b34babd$export$cdebf3fc89add777)({
    add: $ed89d4c20b089b73$export$e16d8520af44a096,
    compare: $ed89d4c20b089b73$export$398604a469f7de9a,
    divide: $ed89d4c20b089b73$export$cd007d971a5a2143,
    partitionSelect: $ed89d4c20b089b73$export$54d1e322cf7aa273,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$667066422fa0af46 = /* #__PURE__ */ (0, $3e01998067e0dde5$export$fbdfd2054d37f888)({
    Index: $ed89d4c20b089b73$export$cf17b003b6192af3,
    concat: $ed89d4c20b089b73$export$ee1b3e54f0441b22,
    setIntersect: $ed89d4c20b089b73$export$9404cfefeb010e68,
    setSymDifference: $ed89d4c20b089b73$export$a7eac91d5496c35b,
    size: $ed89d4c20b089b73$export$346677f925de839c,
    subset: $ed89d4c20b089b73$export$e06bd7b1ab877a71,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$9b77da0927470c3d = /* #__PURE__ */ (0, $cd7877b745b67b56$export$b989221824390fb)({
    add: $ed89d4c20b089b73$export$e16d8520af44a096,
    apply: $ed89d4c20b089b73$export$5635d7ef4b8fee1c,
    divide: $ed89d4c20b089b73$export$cd007d971a5a2143,
    isNaN: $ed89d4c20b089b73$export$c9f5652083b8129d,
    multiply: $ed89d4c20b089b73$export$2060d2db72cce88f,
    subtract: $ed89d4c20b089b73$export$4e2d2ead65e5f7e3,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$a9fffb6ae6e33dcc = /* #__PURE__ */ (0, $19bea5148572fcc2$export$eaa5cb8fd86b8d43)({
    divide: $ed89d4c20b089b73$export$cd007d971a5a2143,
    dotDivide: $ed89d4c20b089b73$export$c74f132961c51406,
    isNumeric: $ed89d4c20b089b73$export$e90fb89750dba83f,
    log: $ed89d4c20b089b73$export$bef1f36f5486a6a3,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    multiply: $ed89d4c20b089b73$export$2060d2db72cce88f,
    sum: $ed89d4c20b089b73$export$8a63f25cc62965f1,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$1991ecd29cc92c6b = /* #__PURE__ */ (0, $2b94a62b68f7788c$export$ce85a9d2952c2966)({
    abs: $ed89d4c20b089b73$export$2335f513bbd82c6d,
    add: $ed89d4c20b089b73$export$e16d8520af44a096,
    conj: $ed89d4c20b089b73$export$fb254c661fe9c0db,
    ctranspose: $ed89d4c20b089b73$export$eb6ad7870b1d0b0b,
    eigs: $ed89d4c20b089b73$export$e822b38c59ee8a2a,
    equalScalar: $ed89d4c20b089b73$export$943761f5c9c3f156,
    larger: $ed89d4c20b089b73$export$a94a7414fa942aea,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    multiply: $ed89d4c20b089b73$export$2060d2db72cce88f,
    pow: $ed89d4c20b089b73$export$9c297f60e22e3389,
    smaller: $ed89d4c20b089b73$export$3f732695c1493aec,
    sqrt: $ed89d4c20b089b73$export$eba8049fb5020b81,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$85aaf319784a5b0 = /* #__PURE__ */ (0, $f30778583b16570c$export$3bf63d7b96fd8541)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$52ded331ee8b28e8 = /* #__PURE__ */ (0, $e146459ae6618893$export$7c79514a80dc15a2)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    DenseMatrix: $ed89d4c20b089b73$export$97f0d27b48f120e8,
    SparseMatrix: $ed89d4c20b089b73$export$de9b2b7556879848,
    addScalar: $ed89d4c20b089b73$export$2b7b095c4f443355,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20,
    cos: $ed89d4c20b089b73$export$50d414a77b60d802,
    matrix: $ed89d4c20b089b73$export$9bdad1ae37d738e0,
    multiplyScalar: $ed89d4c20b089b73$export$c697bed75648cdb7,
    norm: $ed89d4c20b089b73$export$1991ecd29cc92c6b,
    sin: $ed89d4c20b089b73$export$5de3937cb4b592ed,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711,
    unaryMinus: $ed89d4c20b089b73$export$6cd304851a69e08
});
var $ed89d4c20b089b73$export$a614e1ad972260a9 = /* #__PURE__ */ (0, $f30778583b16570c$export$85a77a0842c24f74)({
    BigNumber: $ed89d4c20b089b73$export$d97aa349ed20696,
    Unit: $ed89d4c20b089b73$export$1d8b9ae22d404866,
    config: $3ff8f6b2f8f10b6c$export$e506a1d27d1eaa20
});
var $ed89d4c20b089b73$export$b14c5e819cb6c927 = /* #__PURE__ */ (0, $17250ba77f6a2235$export$d3f0a8dda5df7afd)({
    sqrt: $ed89d4c20b089b73$export$eba8049fb5020b81,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711,
    variance: $ed89d4c20b089b73$export$9b77da0927470c3d
});
var $ed89d4c20b089b73$export$b14ea41a64d6efa6 = /* #__PURE__ */ (0, $36eb9bbb60cc9744$export$7b17fbe41c88575a)({
    abs: $ed89d4c20b089b73$export$2335f513bbd82c6d,
    map: $ed89d4c20b089b73$export$871de8747c9eaa88,
    median: $ed89d4c20b089b73$export$9c490b34b2f16a34,
    subtract: $ed89d4c20b089b73$export$4e2d2ead65e5f7e3,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});
var $ed89d4c20b089b73$export$bb628a54ab399bc9 = /* #__PURE__ */ (0, $59cd08414f0a6cb6$export$484058214789ee04)({
    multiply: $ed89d4c20b089b73$export$2060d2db72cce88f,
    rotationMatrix: $ed89d4c20b089b73$export$52ded331ee8b28e8,
    typed: $ed89d4c20b089b73$export$519f616c41a1c711
});


var $842e3ecb6082807a$exports = {};
"use strict";
var $842e3ecb6082807a$var$__createBinding = $842e3ecb6082807a$exports && $842e3ecb6082807a$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $842e3ecb6082807a$var$__setModuleDefault = $842e3ecb6082807a$exports && $842e3ecb6082807a$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $842e3ecb6082807a$var$__importStar = $842e3ecb6082807a$exports && $842e3ecb6082807a$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $842e3ecb6082807a$var$__createBinding(result, mod, k);
    }
    $842e3ecb6082807a$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($842e3ecb6082807a$exports, "__esModule", {
    value: true
});
$842e3ecb6082807a$exports.QueryClient = $842e3ecb6082807a$exports.decodeCosmosSdkDecFromProto = $842e3ecb6082807a$exports.createProtobufRpcClient = $842e3ecb6082807a$exports.createPagination = $842e3ecb6082807a$exports.makeMultisignedTx = $842e3ecb6082807a$exports.createStakingAminoConverters = $842e3ecb6082807a$exports.createIbcAminoConverters = $842e3ecb6082807a$exports.createGovAminoConverters = $842e3ecb6082807a$exports.createFreegrantAminoConverters = $842e3ecb6082807a$exports.createDistributionAminoConverters = $842e3ecb6082807a$exports.createBankAminoConverters = $842e3ecb6082807a$exports.createAuthzAminoConverters = $842e3ecb6082807a$exports.setupTxExtension = $842e3ecb6082807a$exports.setupStakingExtension = $842e3ecb6082807a$exports.setupMintExtension = $842e3ecb6082807a$exports.setupIbcExtension = $842e3ecb6082807a$exports.setupGovExtension = $842e3ecb6082807a$exports.setupDistributionExtension = $842e3ecb6082807a$exports.setupBankExtension = $842e3ecb6082807a$exports.setupAuthExtension = $842e3ecb6082807a$exports.isMsgWithdrawDelegatorRewardEncodeObject = $842e3ecb6082807a$exports.isMsgVoteEncodeObject = $842e3ecb6082807a$exports.isMsgUndelegateEncodeObject = $842e3ecb6082807a$exports.isMsgTransferEncodeObject = $842e3ecb6082807a$exports.isMsgSubmitProposalEncodeObject = $842e3ecb6082807a$exports.isMsgSendEncodeObject = $842e3ecb6082807a$exports.isMsgDepositEncodeObject = $842e3ecb6082807a$exports.isMsgDelegateEncodeObject = $842e3ecb6082807a$exports.isAminoMsgWithdrawValidatorCommission = $842e3ecb6082807a$exports.isAminoMsgWithdrawDelegatorReward = $842e3ecb6082807a$exports.isAminoMsgVote = $842e3ecb6082807a$exports.isAminoMsgVerifyInvariant = $842e3ecb6082807a$exports.isAminoMsgUnjail = $842e3ecb6082807a$exports.isAminoMsgUndelegate = $842e3ecb6082807a$exports.isAminoMsgSubmitProposal = $842e3ecb6082807a$exports.isAminoMsgSubmitEvidence = $842e3ecb6082807a$exports.isAminoMsgSetWithdrawAddress = $842e3ecb6082807a$exports.isAminoMsgSend = $842e3ecb6082807a$exports.isAminoMsgMultiSend = $842e3ecb6082807a$exports.isAminoMsgFundCommunityPool = $842e3ecb6082807a$exports.isAminoMsgEditValidator = $842e3ecb6082807a$exports.isAminoMsgDeposit = $842e3ecb6082807a$exports.isAminoMsgDelegate = $842e3ecb6082807a$exports.isAminoMsgCreateValidator = $842e3ecb6082807a$exports.isAminoMsgBeginRedelegate = $842e3ecb6082807a$exports.logs = $842e3ecb6082807a$exports.GasPrice = $842e3ecb6082807a$exports.calculateFee = $842e3ecb6082807a$exports.AminoTypes = $842e3ecb6082807a$exports.accountFromAny = void 0;
$842e3ecb6082807a$exports.parseCoins = $842e3ecb6082807a$exports.makeCosmoshubPath = $842e3ecb6082807a$exports.coins = $842e3ecb6082807a$exports.coin = $842e3ecb6082807a$exports.TimeoutError = $842e3ecb6082807a$exports.StargateClient = $842e3ecb6082807a$exports.isDeliverTxSuccess = $842e3ecb6082807a$exports.isDeliverTxFailure = $842e3ecb6082807a$exports.assertIsDeliverTxSuccess = $842e3ecb6082807a$exports.assertIsDeliverTxFailure = $842e3ecb6082807a$exports.SigningStargateClient = $842e3ecb6082807a$exports.defaultRegistryTypes = $842e3ecb6082807a$exports.isSearchByTagsQuery = $842e3ecb6082807a$exports.isSearchBySentFromOrToQuery = $842e3ecb6082807a$exports.isSearchByHeightQuery = void 0;
var $f152202261c35b7c$exports = {};
"use strict";
Object.defineProperty($f152202261c35b7c$exports, "__esModule", {
    value: true
});
$f152202261c35b7c$exports.accountFromAny = void 0;

var $9YIif = parcelRequire("9YIif");
var $eb9a28d0d0241b06$exports = {};
"use strict";
Object.defineProperty($eb9a28d0d0241b06$exports, "__esModule", {
    value: true
});
$eb9a28d0d0241b06$exports.coins = $eb9a28d0d0241b06$exports.coin = $eb9a28d0d0241b06$exports.executeKdf = $eb9a28d0d0241b06$exports.makeSignDoc = $eb9a28d0d0241b06$exports.makeSignBytes = $eb9a28d0d0241b06$exports.makeAuthInfoBytes = $eb9a28d0d0241b06$exports.isOfflineDirectSigner = $eb9a28d0d0241b06$exports.Registry = $eb9a28d0d0241b06$exports.isTxBodyEncodeObject = $eb9a28d0d0241b06$exports.isTsProtoGeneratedType = $eb9a28d0d0241b06$exports.isPbjsGeneratedType = $eb9a28d0d0241b06$exports.encodePubkey = $eb9a28d0d0241b06$exports.decodePubkey = $eb9a28d0d0241b06$exports.makeCosmoshubPath = $eb9a28d0d0241b06$exports.DirectSecp256k1Wallet = $eb9a28d0d0241b06$exports.extractKdfConfiguration = $eb9a28d0d0241b06$exports.DirectSecp256k1HdWallet = $eb9a28d0d0241b06$exports.decodeTxRaw = $eb9a28d0d0241b06$exports.parseCoins = void 0;
var $98283ddfdc09e8b5$exports = {};
"use strict";
Object.defineProperty($98283ddfdc09e8b5$exports, "__esModule", {
    value: true
});
$98283ddfdc09e8b5$exports.parseCoins = void 0;

var $9YIif = parcelRequire("9YIif");
/**
 * Takes a coins list like "819966000ucosm,700000000ustake" and parses it.
 *
 * This is a Stargate ready version of parseCoins from @cosmjs/amino.
 * It supports more denoms.
 */ function $98283ddfdc09e8b5$var$parseCoins(input) {
    return input.replace(/\s/g, "").split(",").filter(Boolean).map((part)=>{
        // Denom regex from Stargate (https://github.com/cosmos/cosmos-sdk/blob/v0.42.7/types/coin.go#L599-L601)
        const match = part.match(/^([0-9]+)([a-zA-Z][a-zA-Z0-9/]{2,127})$/);
        if (!match) throw new Error("Got an invalid coin string");
        return {
            amount: $9YIif.Uint64.fromString(match[1]).toString(),
            denom: match[2]
        };
    });
}
$98283ddfdc09e8b5$exports.parseCoins = $98283ddfdc09e8b5$var$parseCoins;


Object.defineProperty($eb9a28d0d0241b06$exports, "parseCoins", {
    enumerable: true,
    get: function() {
        return $98283ddfdc09e8b5$exports.parseCoins;
    }
});
var $8c62935165171ab9$exports = {};
"use strict";
Object.defineProperty($8c62935165171ab9$exports, "__esModule", {
    value: true
});
$8c62935165171ab9$exports.decodeTxRaw = void 0;
var $07786b3434b3c544$exports = {};
"use strict";
var $07786b3434b3c544$var$__importDefault = $07786b3434b3c544$exports && $07786b3434b3c544$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($07786b3434b3c544$exports, "__esModule", {
    value: true
});
$07786b3434b3c544$exports.Fee = $07786b3434b3c544$exports.ModeInfo_Multi = $07786b3434b3c544$exports.ModeInfo_Single = $07786b3434b3c544$exports.ModeInfo = $07786b3434b3c544$exports.SignerInfo = $07786b3434b3c544$exports.AuthInfo = $07786b3434b3c544$exports.TxBody = $07786b3434b3c544$exports.SignDoc = $07786b3434b3c544$exports.TxRaw = $07786b3434b3c544$exports.Tx = $07786b3434b3c544$exports.protobufPackage = void 0;

/* eslint-disable */ const $07786b3434b3c544$var$long_1 = $07786b3434b3c544$var$__importDefault((parcelRequire("9A55m")));

const $07786b3434b3c544$var$minimal_1 = $07786b3434b3c544$var$__importDefault((parcelRequire("i2pIU")));
var $4232fce010c3a46b$exports = {};
"use strict";
var $4232fce010c3a46b$var$__importDefault = $4232fce010c3a46b$exports && $4232fce010c3a46b$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($4232fce010c3a46b$exports, "__esModule", {
    value: true
});
$4232fce010c3a46b$exports.Any = $4232fce010c3a46b$exports.protobufPackage = void 0;

/* eslint-disable */ const $4232fce010c3a46b$var$long_1 = $4232fce010c3a46b$var$__importDefault((parcelRequire("9A55m")));

const $4232fce010c3a46b$var$minimal_1 = $4232fce010c3a46b$var$__importDefault((parcelRequire("i2pIU")));
$4232fce010c3a46b$exports.protobufPackage = "google.protobuf";
const $4232fce010c3a46b$var$baseAny = {
    typeUrl: ""
};
$4232fce010c3a46b$exports.Any = {
    encode (message, writer = $4232fce010c3a46b$var$minimal_1.default.Writer.create()) {
        if (message.typeUrl !== "") writer.uint32(10).string(message.typeUrl);
        if (message.value.length !== 0) writer.uint32(18).bytes(message.value);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4232fce010c3a46b$var$minimal_1.default.Reader ? input : new $4232fce010c3a46b$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $4232fce010c3a46b$var$baseAny);
        message.value = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.typeUrl = reader.string();
                    break;
                case 2:
                    message.value = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $4232fce010c3a46b$var$baseAny);
        message.typeUrl = object.typeUrl !== undefined && object.typeUrl !== null ? String(object.typeUrl) : "";
        message.value = object.value !== undefined && object.value !== null ? $4232fce010c3a46b$var$bytesFromBase64(object.value) : new Uint8Array();
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.typeUrl !== undefined && (obj.typeUrl = message.typeUrl);
        message.value !== undefined && (obj.value = $4232fce010c3a46b$var$base64FromBytes(message.value !== undefined ? message.value : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $4232fce010c3a46b$var$baseAny);
        message.typeUrl = (_a = object.typeUrl) !== null && _a !== void 0 ? _a : "";
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : new Uint8Array();
        return message;
    }
};
var $4232fce010c3a46b$var$globalThis = (()=>{
    if (typeof $4232fce010c3a46b$var$globalThis !== "undefined") return $4232fce010c3a46b$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $4232fce010c3a46b$var$atob = $4232fce010c3a46b$var$globalThis.atob || ((b64)=>$4232fce010c3a46b$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $4232fce010c3a46b$var$bytesFromBase64(b64) {
    const bin = $4232fce010c3a46b$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $4232fce010c3a46b$var$btoa = $4232fce010c3a46b$var$globalThis.btoa || ((bin)=>$4232fce010c3a46b$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $4232fce010c3a46b$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $4232fce010c3a46b$var$btoa(bin.join(""));
}
if ($4232fce010c3a46b$var$minimal_1.default.util.Long !== $4232fce010c3a46b$var$long_1.default) {
    $4232fce010c3a46b$var$minimal_1.default.util.Long = $4232fce010c3a46b$var$long_1.default;
    $4232fce010c3a46b$var$minimal_1.default.configure();
}


var $d422a57cb1210f8b$exports = {};
"use strict";
var $d422a57cb1210f8b$var$__importDefault = $d422a57cb1210f8b$exports && $d422a57cb1210f8b$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($d422a57cb1210f8b$exports, "__esModule", {
    value: true
});
$d422a57cb1210f8b$exports.SignatureDescriptor_Data_Multi = $d422a57cb1210f8b$exports.SignatureDescriptor_Data_Single = $d422a57cb1210f8b$exports.SignatureDescriptor_Data = $d422a57cb1210f8b$exports.SignatureDescriptor = $d422a57cb1210f8b$exports.SignatureDescriptors = $d422a57cb1210f8b$exports.signModeToJSON = $d422a57cb1210f8b$exports.signModeFromJSON = $d422a57cb1210f8b$exports.SignMode = $d422a57cb1210f8b$exports.protobufPackage = void 0;

/* eslint-disable */ const $d422a57cb1210f8b$var$long_1 = $d422a57cb1210f8b$var$__importDefault((parcelRequire("9A55m")));

const $d422a57cb1210f8b$var$minimal_1 = $d422a57cb1210f8b$var$__importDefault((parcelRequire("i2pIU")));

var $a28ec594ef179a17$exports = {};
"use strict";
var $a28ec594ef179a17$var$__importDefault = $a28ec594ef179a17$exports && $a28ec594ef179a17$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($a28ec594ef179a17$exports, "__esModule", {
    value: true
});
$a28ec594ef179a17$exports.CompactBitArray = $a28ec594ef179a17$exports.MultiSignature = $a28ec594ef179a17$exports.protobufPackage = void 0;

/* eslint-disable */ const $a28ec594ef179a17$var$long_1 = $a28ec594ef179a17$var$__importDefault((parcelRequire("9A55m")));

const $a28ec594ef179a17$var$minimal_1 = $a28ec594ef179a17$var$__importDefault((parcelRequire("i2pIU")));
$a28ec594ef179a17$exports.protobufPackage = "cosmos.crypto.multisig.v1beta1";
const $a28ec594ef179a17$var$baseMultiSignature = {};
$a28ec594ef179a17$exports.MultiSignature = {
    encode (message, writer = $a28ec594ef179a17$var$minimal_1.default.Writer.create()) {
        for (const v of message.signatures)writer.uint32(10).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a28ec594ef179a17$var$minimal_1.default.Reader ? input : new $a28ec594ef179a17$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $a28ec594ef179a17$var$baseMultiSignature);
        message.signatures = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signatures.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $a28ec594ef179a17$var$baseMultiSignature);
        message.signatures = ((_a = object.signatures) !== null && _a !== void 0 ? _a : []).map((e)=>$a28ec594ef179a17$var$bytesFromBase64(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.signatures) obj.signatures = message.signatures.map((e)=>$a28ec594ef179a17$var$base64FromBytes(e !== undefined ? e : new Uint8Array()));
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $a28ec594ef179a17$var$baseMultiSignature);
        message.signatures = ((_a = object.signatures) === null || _a === void 0 ? void 0 : _a.map((e)=>e)) || [];
        return message;
    }
};
const $a28ec594ef179a17$var$baseCompactBitArray = {
    extraBitsStored: 0
};
$a28ec594ef179a17$exports.CompactBitArray = {
    encode (message, writer = $a28ec594ef179a17$var$minimal_1.default.Writer.create()) {
        if (message.extraBitsStored !== 0) writer.uint32(8).uint32(message.extraBitsStored);
        if (message.elems.length !== 0) writer.uint32(18).bytes(message.elems);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a28ec594ef179a17$var$minimal_1.default.Reader ? input : new $a28ec594ef179a17$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $a28ec594ef179a17$var$baseCompactBitArray);
        message.elems = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.extraBitsStored = reader.uint32();
                    break;
                case 2:
                    message.elems = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $a28ec594ef179a17$var$baseCompactBitArray);
        message.extraBitsStored = object.extraBitsStored !== undefined && object.extraBitsStored !== null ? Number(object.extraBitsStored) : 0;
        message.elems = object.elems !== undefined && object.elems !== null ? $a28ec594ef179a17$var$bytesFromBase64(object.elems) : new Uint8Array();
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.extraBitsStored !== undefined && (obj.extraBitsStored = message.extraBitsStored);
        message.elems !== undefined && (obj.elems = $a28ec594ef179a17$var$base64FromBytes(message.elems !== undefined ? message.elems : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $a28ec594ef179a17$var$baseCompactBitArray);
        message.extraBitsStored = (_a = object.extraBitsStored) !== null && _a !== void 0 ? _a : 0;
        message.elems = (_b = object.elems) !== null && _b !== void 0 ? _b : new Uint8Array();
        return message;
    }
};
var $a28ec594ef179a17$var$globalThis = (()=>{
    if (typeof $a28ec594ef179a17$var$globalThis !== "undefined") return $a28ec594ef179a17$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $a28ec594ef179a17$var$atob = $a28ec594ef179a17$var$globalThis.atob || ((b64)=>$a28ec594ef179a17$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $a28ec594ef179a17$var$bytesFromBase64(b64) {
    const bin = $a28ec594ef179a17$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $a28ec594ef179a17$var$btoa = $a28ec594ef179a17$var$globalThis.btoa || ((bin)=>$a28ec594ef179a17$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $a28ec594ef179a17$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $a28ec594ef179a17$var$btoa(bin.join(""));
}
if ($a28ec594ef179a17$var$minimal_1.default.util.Long !== $a28ec594ef179a17$var$long_1.default) {
    $a28ec594ef179a17$var$minimal_1.default.util.Long = $a28ec594ef179a17$var$long_1.default;
    $a28ec594ef179a17$var$minimal_1.default.configure();
}


$d422a57cb1210f8b$exports.protobufPackage = "cosmos.tx.signing.v1beta1";
/** SignMode represents a signing mode with its own security guarantees. */ var $d422a57cb1210f8b$var$SignMode;
(function(SignMode) {
    /**
     * SIGN_MODE_UNSPECIFIED - SIGN_MODE_UNSPECIFIED specifies an unknown signing mode and will be
     * rejected
     */ SignMode[SignMode["SIGN_MODE_UNSPECIFIED"] = 0] = "SIGN_MODE_UNSPECIFIED";
    /**
     * SIGN_MODE_DIRECT - SIGN_MODE_DIRECT specifies a signing mode which uses SignDoc and is
     * verified with raw bytes from Tx
     */ SignMode[SignMode["SIGN_MODE_DIRECT"] = 1] = "SIGN_MODE_DIRECT";
    /**
     * SIGN_MODE_TEXTUAL - SIGN_MODE_TEXTUAL is a future signing mode that will verify some
     * human-readable textual representation on top of the binary representation
     * from SIGN_MODE_DIRECT
     */ SignMode[SignMode["SIGN_MODE_TEXTUAL"] = 2] = "SIGN_MODE_TEXTUAL";
    /**
     * SIGN_MODE_LEGACY_AMINO_JSON - SIGN_MODE_LEGACY_AMINO_JSON is a backwards compatibility mode which uses
     * Amino JSON and will be removed in the future
     */ SignMode[SignMode["SIGN_MODE_LEGACY_AMINO_JSON"] = 127] = "SIGN_MODE_LEGACY_AMINO_JSON";
    SignMode[SignMode["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($d422a57cb1210f8b$var$SignMode = $d422a57cb1210f8b$exports.SignMode || ($d422a57cb1210f8b$exports.SignMode = {}));
function $d422a57cb1210f8b$var$signModeFromJSON(object) {
    switch(object){
        case 0:
        case "SIGN_MODE_UNSPECIFIED":
            return $d422a57cb1210f8b$var$SignMode.SIGN_MODE_UNSPECIFIED;
        case 1:
        case "SIGN_MODE_DIRECT":
            return $d422a57cb1210f8b$var$SignMode.SIGN_MODE_DIRECT;
        case 2:
        case "SIGN_MODE_TEXTUAL":
            return $d422a57cb1210f8b$var$SignMode.SIGN_MODE_TEXTUAL;
        case 127:
        case "SIGN_MODE_LEGACY_AMINO_JSON":
            return $d422a57cb1210f8b$var$SignMode.SIGN_MODE_LEGACY_AMINO_JSON;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $d422a57cb1210f8b$var$SignMode.UNRECOGNIZED;
    }
}
$d422a57cb1210f8b$exports.signModeFromJSON = $d422a57cb1210f8b$var$signModeFromJSON;
function $d422a57cb1210f8b$var$signModeToJSON(object) {
    switch(object){
        case $d422a57cb1210f8b$var$SignMode.SIGN_MODE_UNSPECIFIED:
            return "SIGN_MODE_UNSPECIFIED";
        case $d422a57cb1210f8b$var$SignMode.SIGN_MODE_DIRECT:
            return "SIGN_MODE_DIRECT";
        case $d422a57cb1210f8b$var$SignMode.SIGN_MODE_TEXTUAL:
            return "SIGN_MODE_TEXTUAL";
        case $d422a57cb1210f8b$var$SignMode.SIGN_MODE_LEGACY_AMINO_JSON:
            return "SIGN_MODE_LEGACY_AMINO_JSON";
        default:
            return "UNKNOWN";
    }
}
$d422a57cb1210f8b$exports.signModeToJSON = $d422a57cb1210f8b$var$signModeToJSON;
const $d422a57cb1210f8b$var$baseSignatureDescriptors = {};
$d422a57cb1210f8b$exports.SignatureDescriptors = {
    encode (message, writer = $d422a57cb1210f8b$var$minimal_1.default.Writer.create()) {
        for (const v of message.signatures)$d422a57cb1210f8b$exports.SignatureDescriptor.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d422a57cb1210f8b$var$minimal_1.default.Reader ? input : new $d422a57cb1210f8b$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $d422a57cb1210f8b$var$baseSignatureDescriptors);
        message.signatures = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signatures.push($d422a57cb1210f8b$exports.SignatureDescriptor.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $d422a57cb1210f8b$var$baseSignatureDescriptors);
        message.signatures = ((_a = object.signatures) !== null && _a !== void 0 ? _a : []).map((e)=>$d422a57cb1210f8b$exports.SignatureDescriptor.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.signatures) obj.signatures = message.signatures.map((e)=>e ? $d422a57cb1210f8b$exports.SignatureDescriptor.toJSON(e) : undefined);
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $d422a57cb1210f8b$var$baseSignatureDescriptors);
        message.signatures = ((_a = object.signatures) === null || _a === void 0 ? void 0 : _a.map((e)=>$d422a57cb1210f8b$exports.SignatureDescriptor.fromPartial(e))) || [];
        return message;
    }
};
const $d422a57cb1210f8b$var$baseSignatureDescriptor = {
    sequence: $d422a57cb1210f8b$var$long_1.default.UZERO
};
$d422a57cb1210f8b$exports.SignatureDescriptor = {
    encode (message, writer = $d422a57cb1210f8b$var$minimal_1.default.Writer.create()) {
        if (message.publicKey !== undefined) $4232fce010c3a46b$exports.Any.encode(message.publicKey, writer.uint32(10).fork()).ldelim();
        if (message.data !== undefined) $d422a57cb1210f8b$exports.SignatureDescriptor_Data.encode(message.data, writer.uint32(18).fork()).ldelim();
        if (!message.sequence.isZero()) writer.uint32(24).uint64(message.sequence);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d422a57cb1210f8b$var$minimal_1.default.Reader ? input : new $d422a57cb1210f8b$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $d422a57cb1210f8b$var$baseSignatureDescriptor);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.publicKey = $4232fce010c3a46b$exports.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.data = $d422a57cb1210f8b$exports.SignatureDescriptor_Data.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $d422a57cb1210f8b$var$baseSignatureDescriptor);
        message.publicKey = object.publicKey !== undefined && object.publicKey !== null ? $4232fce010c3a46b$exports.Any.fromJSON(object.publicKey) : undefined;
        message.data = object.data !== undefined && object.data !== null ? $d422a57cb1210f8b$exports.SignatureDescriptor_Data.fromJSON(object.data) : undefined;
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $d422a57cb1210f8b$var$long_1.default.fromString(object.sequence) : $d422a57cb1210f8b$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.publicKey !== undefined && (obj.publicKey = message.publicKey ? $4232fce010c3a46b$exports.Any.toJSON(message.publicKey) : undefined);
        message.data !== undefined && (obj.data = message.data ? $d422a57cb1210f8b$exports.SignatureDescriptor_Data.toJSON(message.data) : undefined);
        message.sequence !== undefined && (obj.sequence = (message.sequence || $d422a57cb1210f8b$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $d422a57cb1210f8b$var$baseSignatureDescriptor);
        message.publicKey = object.publicKey !== undefined && object.publicKey !== null ? $4232fce010c3a46b$exports.Any.fromPartial(object.publicKey) : undefined;
        message.data = object.data !== undefined && object.data !== null ? $d422a57cb1210f8b$exports.SignatureDescriptor_Data.fromPartial(object.data) : undefined;
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $d422a57cb1210f8b$var$long_1.default.fromValue(object.sequence) : $d422a57cb1210f8b$var$long_1.default.UZERO;
        return message;
    }
};
const $d422a57cb1210f8b$var$baseSignatureDescriptor_Data = {};
$d422a57cb1210f8b$exports.SignatureDescriptor_Data = {
    encode (message, writer = $d422a57cb1210f8b$var$minimal_1.default.Writer.create()) {
        if (message.single !== undefined) $d422a57cb1210f8b$exports.SignatureDescriptor_Data_Single.encode(message.single, writer.uint32(10).fork()).ldelim();
        if (message.multi !== undefined) $d422a57cb1210f8b$exports.SignatureDescriptor_Data_Multi.encode(message.multi, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d422a57cb1210f8b$var$minimal_1.default.Reader ? input : new $d422a57cb1210f8b$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $d422a57cb1210f8b$var$baseSignatureDescriptor_Data);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.single = $d422a57cb1210f8b$exports.SignatureDescriptor_Data_Single.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.multi = $d422a57cb1210f8b$exports.SignatureDescriptor_Data_Multi.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $d422a57cb1210f8b$var$baseSignatureDescriptor_Data);
        message.single = object.single !== undefined && object.single !== null ? $d422a57cb1210f8b$exports.SignatureDescriptor_Data_Single.fromJSON(object.single) : undefined;
        message.multi = object.multi !== undefined && object.multi !== null ? $d422a57cb1210f8b$exports.SignatureDescriptor_Data_Multi.fromJSON(object.multi) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.single !== undefined && (obj.single = message.single ? $d422a57cb1210f8b$exports.SignatureDescriptor_Data_Single.toJSON(message.single) : undefined);
        message.multi !== undefined && (obj.multi = message.multi ? $d422a57cb1210f8b$exports.SignatureDescriptor_Data_Multi.toJSON(message.multi) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $d422a57cb1210f8b$var$baseSignatureDescriptor_Data);
        message.single = object.single !== undefined && object.single !== null ? $d422a57cb1210f8b$exports.SignatureDescriptor_Data_Single.fromPartial(object.single) : undefined;
        message.multi = object.multi !== undefined && object.multi !== null ? $d422a57cb1210f8b$exports.SignatureDescriptor_Data_Multi.fromPartial(object.multi) : undefined;
        return message;
    }
};
const $d422a57cb1210f8b$var$baseSignatureDescriptor_Data_Single = {
    mode: 0
};
$d422a57cb1210f8b$exports.SignatureDescriptor_Data_Single = {
    encode (message, writer = $d422a57cb1210f8b$var$minimal_1.default.Writer.create()) {
        if (message.mode !== 0) writer.uint32(8).int32(message.mode);
        if (message.signature.length !== 0) writer.uint32(18).bytes(message.signature);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d422a57cb1210f8b$var$minimal_1.default.Reader ? input : new $d422a57cb1210f8b$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $d422a57cb1210f8b$var$baseSignatureDescriptor_Data_Single);
        message.signature = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.mode = reader.int32();
                    break;
                case 2:
                    message.signature = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $d422a57cb1210f8b$var$baseSignatureDescriptor_Data_Single);
        message.mode = object.mode !== undefined && object.mode !== null ? $d422a57cb1210f8b$var$signModeFromJSON(object.mode) : 0;
        message.signature = object.signature !== undefined && object.signature !== null ? $d422a57cb1210f8b$var$bytesFromBase64(object.signature) : new Uint8Array();
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.mode !== undefined && (obj.mode = $d422a57cb1210f8b$var$signModeToJSON(message.mode));
        message.signature !== undefined && (obj.signature = $d422a57cb1210f8b$var$base64FromBytes(message.signature !== undefined ? message.signature : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $d422a57cb1210f8b$var$baseSignatureDescriptor_Data_Single);
        message.mode = (_a = object.mode) !== null && _a !== void 0 ? _a : 0;
        message.signature = (_b = object.signature) !== null && _b !== void 0 ? _b : new Uint8Array();
        return message;
    }
};
const $d422a57cb1210f8b$var$baseSignatureDescriptor_Data_Multi = {};
$d422a57cb1210f8b$exports.SignatureDescriptor_Data_Multi = {
    encode (message, writer = $d422a57cb1210f8b$var$minimal_1.default.Writer.create()) {
        if (message.bitarray !== undefined) $a28ec594ef179a17$exports.CompactBitArray.encode(message.bitarray, writer.uint32(10).fork()).ldelim();
        for (const v of message.signatures)$d422a57cb1210f8b$exports.SignatureDescriptor_Data.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d422a57cb1210f8b$var$minimal_1.default.Reader ? input : new $d422a57cb1210f8b$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $d422a57cb1210f8b$var$baseSignatureDescriptor_Data_Multi);
        message.signatures = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bitarray = $a28ec594ef179a17$exports.CompactBitArray.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.signatures.push($d422a57cb1210f8b$exports.SignatureDescriptor_Data.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $d422a57cb1210f8b$var$baseSignatureDescriptor_Data_Multi);
        message.bitarray = object.bitarray !== undefined && object.bitarray !== null ? $a28ec594ef179a17$exports.CompactBitArray.fromJSON(object.bitarray) : undefined;
        message.signatures = ((_a = object.signatures) !== null && _a !== void 0 ? _a : []).map((e)=>$d422a57cb1210f8b$exports.SignatureDescriptor_Data.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.bitarray !== undefined && (obj.bitarray = message.bitarray ? $a28ec594ef179a17$exports.CompactBitArray.toJSON(message.bitarray) : undefined);
        if (message.signatures) obj.signatures = message.signatures.map((e)=>e ? $d422a57cb1210f8b$exports.SignatureDescriptor_Data.toJSON(e) : undefined);
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $d422a57cb1210f8b$var$baseSignatureDescriptor_Data_Multi);
        message.bitarray = object.bitarray !== undefined && object.bitarray !== null ? $a28ec594ef179a17$exports.CompactBitArray.fromPartial(object.bitarray) : undefined;
        message.signatures = ((_a = object.signatures) === null || _a === void 0 ? void 0 : _a.map((e)=>$d422a57cb1210f8b$exports.SignatureDescriptor_Data.fromPartial(e))) || [];
        return message;
    }
};
var $d422a57cb1210f8b$var$globalThis = (()=>{
    if (typeof $d422a57cb1210f8b$var$globalThis !== "undefined") return $d422a57cb1210f8b$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $d422a57cb1210f8b$var$atob = $d422a57cb1210f8b$var$globalThis.atob || ((b64)=>$d422a57cb1210f8b$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $d422a57cb1210f8b$var$bytesFromBase64(b64) {
    const bin = $d422a57cb1210f8b$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $d422a57cb1210f8b$var$btoa = $d422a57cb1210f8b$var$globalThis.btoa || ((bin)=>$d422a57cb1210f8b$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $d422a57cb1210f8b$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $d422a57cb1210f8b$var$btoa(bin.join(""));
}
if ($d422a57cb1210f8b$var$minimal_1.default.util.Long !== $d422a57cb1210f8b$var$long_1.default) {
    $d422a57cb1210f8b$var$minimal_1.default.util.Long = $d422a57cb1210f8b$var$long_1.default;
    $d422a57cb1210f8b$var$minimal_1.default.configure();
}



var $82ef09d1a8e2224d$exports = {};
"use strict";
var $82ef09d1a8e2224d$var$__importDefault = $82ef09d1a8e2224d$exports && $82ef09d1a8e2224d$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($82ef09d1a8e2224d$exports, "__esModule", {
    value: true
});
$82ef09d1a8e2224d$exports.DecProto = $82ef09d1a8e2224d$exports.IntProto = $82ef09d1a8e2224d$exports.DecCoin = $82ef09d1a8e2224d$exports.Coin = $82ef09d1a8e2224d$exports.protobufPackage = void 0;

/* eslint-disable */ const $82ef09d1a8e2224d$var$long_1 = $82ef09d1a8e2224d$var$__importDefault((parcelRequire("9A55m")));

const $82ef09d1a8e2224d$var$minimal_1 = $82ef09d1a8e2224d$var$__importDefault((parcelRequire("i2pIU")));
$82ef09d1a8e2224d$exports.protobufPackage = "cosmos.base.v1beta1";
const $82ef09d1a8e2224d$var$baseCoin = {
    denom: "",
    amount: ""
};
$82ef09d1a8e2224d$exports.Coin = {
    encode (message, writer = $82ef09d1a8e2224d$var$minimal_1.default.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.amount !== "") writer.uint32(18).string(message.amount);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $82ef09d1a8e2224d$var$minimal_1.default.Reader ? input : new $82ef09d1a8e2224d$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $82ef09d1a8e2224d$var$baseCoin);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $82ef09d1a8e2224d$var$baseCoin);
        message.denom = object.denom !== undefined && object.denom !== null ? String(object.denom) : "";
        message.amount = object.amount !== undefined && object.amount !== null ? String(object.amount) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $82ef09d1a8e2224d$var$baseCoin);
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        message.amount = (_b = object.amount) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
const $82ef09d1a8e2224d$var$baseDecCoin = {
    denom: "",
    amount: ""
};
$82ef09d1a8e2224d$exports.DecCoin = {
    encode (message, writer = $82ef09d1a8e2224d$var$minimal_1.default.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.amount !== "") writer.uint32(18).string(message.amount);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $82ef09d1a8e2224d$var$minimal_1.default.Reader ? input : new $82ef09d1a8e2224d$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $82ef09d1a8e2224d$var$baseDecCoin);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $82ef09d1a8e2224d$var$baseDecCoin);
        message.denom = object.denom !== undefined && object.denom !== null ? String(object.denom) : "";
        message.amount = object.amount !== undefined && object.amount !== null ? String(object.amount) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $82ef09d1a8e2224d$var$baseDecCoin);
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        message.amount = (_b = object.amount) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
const $82ef09d1a8e2224d$var$baseIntProto = {
    int: ""
};
$82ef09d1a8e2224d$exports.IntProto = {
    encode (message, writer = $82ef09d1a8e2224d$var$minimal_1.default.Writer.create()) {
        if (message.int !== "") writer.uint32(10).string(message.int);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $82ef09d1a8e2224d$var$minimal_1.default.Reader ? input : new $82ef09d1a8e2224d$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $82ef09d1a8e2224d$var$baseIntProto);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.int = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $82ef09d1a8e2224d$var$baseIntProto);
        message.int = object.int !== undefined && object.int !== null ? String(object.int) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.int !== undefined && (obj.int = message.int);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $82ef09d1a8e2224d$var$baseIntProto);
        message.int = (_a = object.int) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
const $82ef09d1a8e2224d$var$baseDecProto = {
    dec: ""
};
$82ef09d1a8e2224d$exports.DecProto = {
    encode (message, writer = $82ef09d1a8e2224d$var$minimal_1.default.Writer.create()) {
        if (message.dec !== "") writer.uint32(10).string(message.dec);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $82ef09d1a8e2224d$var$minimal_1.default.Reader ? input : new $82ef09d1a8e2224d$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $82ef09d1a8e2224d$var$baseDecProto);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.dec = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $82ef09d1a8e2224d$var$baseDecProto);
        message.dec = object.dec !== undefined && object.dec !== null ? String(object.dec) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.dec !== undefined && (obj.dec = message.dec);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $82ef09d1a8e2224d$var$baseDecProto);
        message.dec = (_a = object.dec) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
if ($82ef09d1a8e2224d$var$minimal_1.default.util.Long !== $82ef09d1a8e2224d$var$long_1.default) {
    $82ef09d1a8e2224d$var$minimal_1.default.util.Long = $82ef09d1a8e2224d$var$long_1.default;
    $82ef09d1a8e2224d$var$minimal_1.default.configure();
}


$07786b3434b3c544$exports.protobufPackage = "cosmos.tx.v1beta1";
const $07786b3434b3c544$var$baseTx = {};
$07786b3434b3c544$exports.Tx = {
    encode (message, writer = $07786b3434b3c544$var$minimal_1.default.Writer.create()) {
        if (message.body !== undefined) $07786b3434b3c544$exports.TxBody.encode(message.body, writer.uint32(10).fork()).ldelim();
        if (message.authInfo !== undefined) $07786b3434b3c544$exports.AuthInfo.encode(message.authInfo, writer.uint32(18).fork()).ldelim();
        for (const v of message.signatures)writer.uint32(26).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $07786b3434b3c544$var$minimal_1.default.Reader ? input : new $07786b3434b3c544$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $07786b3434b3c544$var$baseTx);
        message.signatures = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.body = $07786b3434b3c544$exports.TxBody.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.authInfo = $07786b3434b3c544$exports.AuthInfo.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signatures.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $07786b3434b3c544$var$baseTx);
        message.body = object.body !== undefined && object.body !== null ? $07786b3434b3c544$exports.TxBody.fromJSON(object.body) : undefined;
        message.authInfo = object.authInfo !== undefined && object.authInfo !== null ? $07786b3434b3c544$exports.AuthInfo.fromJSON(object.authInfo) : undefined;
        message.signatures = ((_a = object.signatures) !== null && _a !== void 0 ? _a : []).map((e)=>$07786b3434b3c544$var$bytesFromBase64(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.body !== undefined && (obj.body = message.body ? $07786b3434b3c544$exports.TxBody.toJSON(message.body) : undefined);
        message.authInfo !== undefined && (obj.authInfo = message.authInfo ? $07786b3434b3c544$exports.AuthInfo.toJSON(message.authInfo) : undefined);
        if (message.signatures) obj.signatures = message.signatures.map((e)=>$07786b3434b3c544$var$base64FromBytes(e !== undefined ? e : new Uint8Array()));
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $07786b3434b3c544$var$baseTx);
        message.body = object.body !== undefined && object.body !== null ? $07786b3434b3c544$exports.TxBody.fromPartial(object.body) : undefined;
        message.authInfo = object.authInfo !== undefined && object.authInfo !== null ? $07786b3434b3c544$exports.AuthInfo.fromPartial(object.authInfo) : undefined;
        message.signatures = ((_a = object.signatures) === null || _a === void 0 ? void 0 : _a.map((e)=>e)) || [];
        return message;
    }
};
const $07786b3434b3c544$var$baseTxRaw = {};
$07786b3434b3c544$exports.TxRaw = {
    encode (message, writer = $07786b3434b3c544$var$minimal_1.default.Writer.create()) {
        if (message.bodyBytes.length !== 0) writer.uint32(10).bytes(message.bodyBytes);
        if (message.authInfoBytes.length !== 0) writer.uint32(18).bytes(message.authInfoBytes);
        for (const v of message.signatures)writer.uint32(26).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $07786b3434b3c544$var$minimal_1.default.Reader ? input : new $07786b3434b3c544$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $07786b3434b3c544$var$baseTxRaw);
        message.signatures = [];
        message.bodyBytes = new Uint8Array();
        message.authInfoBytes = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bodyBytes = reader.bytes();
                    break;
                case 2:
                    message.authInfoBytes = reader.bytes();
                    break;
                case 3:
                    message.signatures.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $07786b3434b3c544$var$baseTxRaw);
        message.bodyBytes = object.bodyBytes !== undefined && object.bodyBytes !== null ? $07786b3434b3c544$var$bytesFromBase64(object.bodyBytes) : new Uint8Array();
        message.authInfoBytes = object.authInfoBytes !== undefined && object.authInfoBytes !== null ? $07786b3434b3c544$var$bytesFromBase64(object.authInfoBytes) : new Uint8Array();
        message.signatures = ((_a = object.signatures) !== null && _a !== void 0 ? _a : []).map((e)=>$07786b3434b3c544$var$bytesFromBase64(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.bodyBytes !== undefined && (obj.bodyBytes = $07786b3434b3c544$var$base64FromBytes(message.bodyBytes !== undefined ? message.bodyBytes : new Uint8Array()));
        message.authInfoBytes !== undefined && (obj.authInfoBytes = $07786b3434b3c544$var$base64FromBytes(message.authInfoBytes !== undefined ? message.authInfoBytes : new Uint8Array()));
        if (message.signatures) obj.signatures = message.signatures.map((e)=>$07786b3434b3c544$var$base64FromBytes(e !== undefined ? e : new Uint8Array()));
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $07786b3434b3c544$var$baseTxRaw);
        message.bodyBytes = (_a = object.bodyBytes) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.authInfoBytes = (_b = object.authInfoBytes) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.signatures = ((_c = object.signatures) === null || _c === void 0 ? void 0 : _c.map((e)=>e)) || [];
        return message;
    }
};
const $07786b3434b3c544$var$baseSignDoc = {
    chainId: "",
    accountNumber: $07786b3434b3c544$var$long_1.default.UZERO
};
$07786b3434b3c544$exports.SignDoc = {
    encode (message, writer = $07786b3434b3c544$var$minimal_1.default.Writer.create()) {
        if (message.bodyBytes.length !== 0) writer.uint32(10).bytes(message.bodyBytes);
        if (message.authInfoBytes.length !== 0) writer.uint32(18).bytes(message.authInfoBytes);
        if (message.chainId !== "") writer.uint32(26).string(message.chainId);
        if (!message.accountNumber.isZero()) writer.uint32(32).uint64(message.accountNumber);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $07786b3434b3c544$var$minimal_1.default.Reader ? input : new $07786b3434b3c544$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $07786b3434b3c544$var$baseSignDoc);
        message.bodyBytes = new Uint8Array();
        message.authInfoBytes = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bodyBytes = reader.bytes();
                    break;
                case 2:
                    message.authInfoBytes = reader.bytes();
                    break;
                case 3:
                    message.chainId = reader.string();
                    break;
                case 4:
                    message.accountNumber = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $07786b3434b3c544$var$baseSignDoc);
        message.bodyBytes = object.bodyBytes !== undefined && object.bodyBytes !== null ? $07786b3434b3c544$var$bytesFromBase64(object.bodyBytes) : new Uint8Array();
        message.authInfoBytes = object.authInfoBytes !== undefined && object.authInfoBytes !== null ? $07786b3434b3c544$var$bytesFromBase64(object.authInfoBytes) : new Uint8Array();
        message.chainId = object.chainId !== undefined && object.chainId !== null ? String(object.chainId) : "";
        message.accountNumber = object.accountNumber !== undefined && object.accountNumber !== null ? $07786b3434b3c544$var$long_1.default.fromString(object.accountNumber) : $07786b3434b3c544$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.bodyBytes !== undefined && (obj.bodyBytes = $07786b3434b3c544$var$base64FromBytes(message.bodyBytes !== undefined ? message.bodyBytes : new Uint8Array()));
        message.authInfoBytes !== undefined && (obj.authInfoBytes = $07786b3434b3c544$var$base64FromBytes(message.authInfoBytes !== undefined ? message.authInfoBytes : new Uint8Array()));
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.accountNumber !== undefined && (obj.accountNumber = (message.accountNumber || $07786b3434b3c544$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $07786b3434b3c544$var$baseSignDoc);
        message.bodyBytes = (_a = object.bodyBytes) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.authInfoBytes = (_b = object.authInfoBytes) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.chainId = (_c = object.chainId) !== null && _c !== void 0 ? _c : "";
        message.accountNumber = object.accountNumber !== undefined && object.accountNumber !== null ? $07786b3434b3c544$var$long_1.default.fromValue(object.accountNumber) : $07786b3434b3c544$var$long_1.default.UZERO;
        return message;
    }
};
const $07786b3434b3c544$var$baseTxBody = {
    memo: "",
    timeoutHeight: $07786b3434b3c544$var$long_1.default.UZERO
};
$07786b3434b3c544$exports.TxBody = {
    encode (message, writer = $07786b3434b3c544$var$minimal_1.default.Writer.create()) {
        for (const v of message.messages)$4232fce010c3a46b$exports.Any.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.memo !== "") writer.uint32(18).string(message.memo);
        if (!message.timeoutHeight.isZero()) writer.uint32(24).uint64(message.timeoutHeight);
        for (const v of message.extensionOptions)$4232fce010c3a46b$exports.Any.encode(v, writer.uint32(8186).fork()).ldelim();
        for (const v of message.nonCriticalExtensionOptions)$4232fce010c3a46b$exports.Any.encode(v, writer.uint32(16378).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $07786b3434b3c544$var$minimal_1.default.Reader ? input : new $07786b3434b3c544$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $07786b3434b3c544$var$baseTxBody);
        message.messages = [];
        message.extensionOptions = [];
        message.nonCriticalExtensionOptions = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.messages.push($4232fce010c3a46b$exports.Any.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.memo = reader.string();
                    break;
                case 3:
                    message.timeoutHeight = reader.uint64();
                    break;
                case 1023:
                    message.extensionOptions.push($4232fce010c3a46b$exports.Any.decode(reader, reader.uint32()));
                    break;
                case 2047:
                    message.nonCriticalExtensionOptions.push($4232fce010c3a46b$exports.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $07786b3434b3c544$var$baseTxBody);
        message.messages = ((_a = object.messages) !== null && _a !== void 0 ? _a : []).map((e)=>$4232fce010c3a46b$exports.Any.fromJSON(e));
        message.memo = object.memo !== undefined && object.memo !== null ? String(object.memo) : "";
        message.timeoutHeight = object.timeoutHeight !== undefined && object.timeoutHeight !== null ? $07786b3434b3c544$var$long_1.default.fromString(object.timeoutHeight) : $07786b3434b3c544$var$long_1.default.UZERO;
        message.extensionOptions = ((_b = object.extensionOptions) !== null && _b !== void 0 ? _b : []).map((e)=>$4232fce010c3a46b$exports.Any.fromJSON(e));
        message.nonCriticalExtensionOptions = ((_c = object.nonCriticalExtensionOptions) !== null && _c !== void 0 ? _c : []).map((e)=>$4232fce010c3a46b$exports.Any.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.messages) obj.messages = message.messages.map((e)=>e ? $4232fce010c3a46b$exports.Any.toJSON(e) : undefined);
        else obj.messages = [];
        message.memo !== undefined && (obj.memo = message.memo);
        message.timeoutHeight !== undefined && (obj.timeoutHeight = (message.timeoutHeight || $07786b3434b3c544$var$long_1.default.UZERO).toString());
        if (message.extensionOptions) obj.extensionOptions = message.extensionOptions.map((e)=>e ? $4232fce010c3a46b$exports.Any.toJSON(e) : undefined);
        else obj.extensionOptions = [];
        if (message.nonCriticalExtensionOptions) obj.nonCriticalExtensionOptions = message.nonCriticalExtensionOptions.map((e)=>e ? $4232fce010c3a46b$exports.Any.toJSON(e) : undefined);
        else obj.nonCriticalExtensionOptions = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = Object.assign({}, $07786b3434b3c544$var$baseTxBody);
        message.messages = ((_a = object.messages) === null || _a === void 0 ? void 0 : _a.map((e)=>$4232fce010c3a46b$exports.Any.fromPartial(e))) || [];
        message.memo = (_b = object.memo) !== null && _b !== void 0 ? _b : "";
        message.timeoutHeight = object.timeoutHeight !== undefined && object.timeoutHeight !== null ? $07786b3434b3c544$var$long_1.default.fromValue(object.timeoutHeight) : $07786b3434b3c544$var$long_1.default.UZERO;
        message.extensionOptions = ((_c = object.extensionOptions) === null || _c === void 0 ? void 0 : _c.map((e)=>$4232fce010c3a46b$exports.Any.fromPartial(e))) || [];
        message.nonCriticalExtensionOptions = ((_d = object.nonCriticalExtensionOptions) === null || _d === void 0 ? void 0 : _d.map((e)=>$4232fce010c3a46b$exports.Any.fromPartial(e))) || [];
        return message;
    }
};
const $07786b3434b3c544$var$baseAuthInfo = {};
$07786b3434b3c544$exports.AuthInfo = {
    encode (message, writer = $07786b3434b3c544$var$minimal_1.default.Writer.create()) {
        for (const v of message.signerInfos)$07786b3434b3c544$exports.SignerInfo.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.fee !== undefined) $07786b3434b3c544$exports.Fee.encode(message.fee, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $07786b3434b3c544$var$minimal_1.default.Reader ? input : new $07786b3434b3c544$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $07786b3434b3c544$var$baseAuthInfo);
        message.signerInfos = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signerInfos.push($07786b3434b3c544$exports.SignerInfo.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.fee = $07786b3434b3c544$exports.Fee.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $07786b3434b3c544$var$baseAuthInfo);
        message.signerInfos = ((_a = object.signerInfos) !== null && _a !== void 0 ? _a : []).map((e)=>$07786b3434b3c544$exports.SignerInfo.fromJSON(e));
        message.fee = object.fee !== undefined && object.fee !== null ? $07786b3434b3c544$exports.Fee.fromJSON(object.fee) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.signerInfos) obj.signerInfos = message.signerInfos.map((e)=>e ? $07786b3434b3c544$exports.SignerInfo.toJSON(e) : undefined);
        else obj.signerInfos = [];
        message.fee !== undefined && (obj.fee = message.fee ? $07786b3434b3c544$exports.Fee.toJSON(message.fee) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $07786b3434b3c544$var$baseAuthInfo);
        message.signerInfos = ((_a = object.signerInfos) === null || _a === void 0 ? void 0 : _a.map((e)=>$07786b3434b3c544$exports.SignerInfo.fromPartial(e))) || [];
        message.fee = object.fee !== undefined && object.fee !== null ? $07786b3434b3c544$exports.Fee.fromPartial(object.fee) : undefined;
        return message;
    }
};
const $07786b3434b3c544$var$baseSignerInfo = {
    sequence: $07786b3434b3c544$var$long_1.default.UZERO
};
$07786b3434b3c544$exports.SignerInfo = {
    encode (message, writer = $07786b3434b3c544$var$minimal_1.default.Writer.create()) {
        if (message.publicKey !== undefined) $4232fce010c3a46b$exports.Any.encode(message.publicKey, writer.uint32(10).fork()).ldelim();
        if (message.modeInfo !== undefined) $07786b3434b3c544$exports.ModeInfo.encode(message.modeInfo, writer.uint32(18).fork()).ldelim();
        if (!message.sequence.isZero()) writer.uint32(24).uint64(message.sequence);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $07786b3434b3c544$var$minimal_1.default.Reader ? input : new $07786b3434b3c544$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $07786b3434b3c544$var$baseSignerInfo);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.publicKey = $4232fce010c3a46b$exports.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.modeInfo = $07786b3434b3c544$exports.ModeInfo.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $07786b3434b3c544$var$baseSignerInfo);
        message.publicKey = object.publicKey !== undefined && object.publicKey !== null ? $4232fce010c3a46b$exports.Any.fromJSON(object.publicKey) : undefined;
        message.modeInfo = object.modeInfo !== undefined && object.modeInfo !== null ? $07786b3434b3c544$exports.ModeInfo.fromJSON(object.modeInfo) : undefined;
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $07786b3434b3c544$var$long_1.default.fromString(object.sequence) : $07786b3434b3c544$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.publicKey !== undefined && (obj.publicKey = message.publicKey ? $4232fce010c3a46b$exports.Any.toJSON(message.publicKey) : undefined);
        message.modeInfo !== undefined && (obj.modeInfo = message.modeInfo ? $07786b3434b3c544$exports.ModeInfo.toJSON(message.modeInfo) : undefined);
        message.sequence !== undefined && (obj.sequence = (message.sequence || $07786b3434b3c544$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $07786b3434b3c544$var$baseSignerInfo);
        message.publicKey = object.publicKey !== undefined && object.publicKey !== null ? $4232fce010c3a46b$exports.Any.fromPartial(object.publicKey) : undefined;
        message.modeInfo = object.modeInfo !== undefined && object.modeInfo !== null ? $07786b3434b3c544$exports.ModeInfo.fromPartial(object.modeInfo) : undefined;
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $07786b3434b3c544$var$long_1.default.fromValue(object.sequence) : $07786b3434b3c544$var$long_1.default.UZERO;
        return message;
    }
};
const $07786b3434b3c544$var$baseModeInfo = {};
$07786b3434b3c544$exports.ModeInfo = {
    encode (message, writer = $07786b3434b3c544$var$minimal_1.default.Writer.create()) {
        if (message.single !== undefined) $07786b3434b3c544$exports.ModeInfo_Single.encode(message.single, writer.uint32(10).fork()).ldelim();
        if (message.multi !== undefined) $07786b3434b3c544$exports.ModeInfo_Multi.encode(message.multi, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $07786b3434b3c544$var$minimal_1.default.Reader ? input : new $07786b3434b3c544$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $07786b3434b3c544$var$baseModeInfo);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.single = $07786b3434b3c544$exports.ModeInfo_Single.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.multi = $07786b3434b3c544$exports.ModeInfo_Multi.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $07786b3434b3c544$var$baseModeInfo);
        message.single = object.single !== undefined && object.single !== null ? $07786b3434b3c544$exports.ModeInfo_Single.fromJSON(object.single) : undefined;
        message.multi = object.multi !== undefined && object.multi !== null ? $07786b3434b3c544$exports.ModeInfo_Multi.fromJSON(object.multi) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.single !== undefined && (obj.single = message.single ? $07786b3434b3c544$exports.ModeInfo_Single.toJSON(message.single) : undefined);
        message.multi !== undefined && (obj.multi = message.multi ? $07786b3434b3c544$exports.ModeInfo_Multi.toJSON(message.multi) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $07786b3434b3c544$var$baseModeInfo);
        message.single = object.single !== undefined && object.single !== null ? $07786b3434b3c544$exports.ModeInfo_Single.fromPartial(object.single) : undefined;
        message.multi = object.multi !== undefined && object.multi !== null ? $07786b3434b3c544$exports.ModeInfo_Multi.fromPartial(object.multi) : undefined;
        return message;
    }
};
const $07786b3434b3c544$var$baseModeInfo_Single = {
    mode: 0
};
$07786b3434b3c544$exports.ModeInfo_Single = {
    encode (message, writer = $07786b3434b3c544$var$minimal_1.default.Writer.create()) {
        if (message.mode !== 0) writer.uint32(8).int32(message.mode);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $07786b3434b3c544$var$minimal_1.default.Reader ? input : new $07786b3434b3c544$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $07786b3434b3c544$var$baseModeInfo_Single);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.mode = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $07786b3434b3c544$var$baseModeInfo_Single);
        message.mode = object.mode !== undefined && object.mode !== null ? $d422a57cb1210f8b$exports.signModeFromJSON(object.mode) : 0;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.mode !== undefined && (obj.mode = $d422a57cb1210f8b$exports.signModeToJSON(message.mode));
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $07786b3434b3c544$var$baseModeInfo_Single);
        message.mode = (_a = object.mode) !== null && _a !== void 0 ? _a : 0;
        return message;
    }
};
const $07786b3434b3c544$var$baseModeInfo_Multi = {};
$07786b3434b3c544$exports.ModeInfo_Multi = {
    encode (message, writer = $07786b3434b3c544$var$minimal_1.default.Writer.create()) {
        if (message.bitarray !== undefined) $a28ec594ef179a17$exports.CompactBitArray.encode(message.bitarray, writer.uint32(10).fork()).ldelim();
        for (const v of message.modeInfos)$07786b3434b3c544$exports.ModeInfo.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $07786b3434b3c544$var$minimal_1.default.Reader ? input : new $07786b3434b3c544$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $07786b3434b3c544$var$baseModeInfo_Multi);
        message.modeInfos = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bitarray = $a28ec594ef179a17$exports.CompactBitArray.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.modeInfos.push($07786b3434b3c544$exports.ModeInfo.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $07786b3434b3c544$var$baseModeInfo_Multi);
        message.bitarray = object.bitarray !== undefined && object.bitarray !== null ? $a28ec594ef179a17$exports.CompactBitArray.fromJSON(object.bitarray) : undefined;
        message.modeInfos = ((_a = object.modeInfos) !== null && _a !== void 0 ? _a : []).map((e)=>$07786b3434b3c544$exports.ModeInfo.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.bitarray !== undefined && (obj.bitarray = message.bitarray ? $a28ec594ef179a17$exports.CompactBitArray.toJSON(message.bitarray) : undefined);
        if (message.modeInfos) obj.modeInfos = message.modeInfos.map((e)=>e ? $07786b3434b3c544$exports.ModeInfo.toJSON(e) : undefined);
        else obj.modeInfos = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $07786b3434b3c544$var$baseModeInfo_Multi);
        message.bitarray = object.bitarray !== undefined && object.bitarray !== null ? $a28ec594ef179a17$exports.CompactBitArray.fromPartial(object.bitarray) : undefined;
        message.modeInfos = ((_a = object.modeInfos) === null || _a === void 0 ? void 0 : _a.map((e)=>$07786b3434b3c544$exports.ModeInfo.fromPartial(e))) || [];
        return message;
    }
};
const $07786b3434b3c544$var$baseFee = {
    gasLimit: $07786b3434b3c544$var$long_1.default.UZERO,
    payer: "",
    granter: ""
};
$07786b3434b3c544$exports.Fee = {
    encode (message, writer = $07786b3434b3c544$var$minimal_1.default.Writer.create()) {
        for (const v of message.amount)$82ef09d1a8e2224d$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (!message.gasLimit.isZero()) writer.uint32(16).uint64(message.gasLimit);
        if (message.payer !== "") writer.uint32(26).string(message.payer);
        if (message.granter !== "") writer.uint32(34).string(message.granter);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $07786b3434b3c544$var$minimal_1.default.Reader ? input : new $07786b3434b3c544$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $07786b3434b3c544$var$baseFee);
        message.amount = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.amount.push($82ef09d1a8e2224d$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.gasLimit = reader.uint64();
                    break;
                case 3:
                    message.payer = reader.string();
                    break;
                case 4:
                    message.granter = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $07786b3434b3c544$var$baseFee);
        message.amount = ((_a = object.amount) !== null && _a !== void 0 ? _a : []).map((e)=>$82ef09d1a8e2224d$exports.Coin.fromJSON(e));
        message.gasLimit = object.gasLimit !== undefined && object.gasLimit !== null ? $07786b3434b3c544$var$long_1.default.fromString(object.gasLimit) : $07786b3434b3c544$var$long_1.default.UZERO;
        message.payer = object.payer !== undefined && object.payer !== null ? String(object.payer) : "";
        message.granter = object.granter !== undefined && object.granter !== null ? String(object.granter) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $82ef09d1a8e2224d$exports.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        message.gasLimit !== undefined && (obj.gasLimit = (message.gasLimit || $07786b3434b3c544$var$long_1.default.UZERO).toString());
        message.payer !== undefined && (obj.payer = message.payer);
        message.granter !== undefined && (obj.granter = message.granter);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $07786b3434b3c544$var$baseFee);
        message.amount = ((_a = object.amount) === null || _a === void 0 ? void 0 : _a.map((e)=>$82ef09d1a8e2224d$exports.Coin.fromPartial(e))) || [];
        message.gasLimit = object.gasLimit !== undefined && object.gasLimit !== null ? $07786b3434b3c544$var$long_1.default.fromValue(object.gasLimit) : $07786b3434b3c544$var$long_1.default.UZERO;
        message.payer = (_b = object.payer) !== null && _b !== void 0 ? _b : "";
        message.granter = (_c = object.granter) !== null && _c !== void 0 ? _c : "";
        return message;
    }
};
var $07786b3434b3c544$var$globalThis = (()=>{
    if (typeof $07786b3434b3c544$var$globalThis !== "undefined") return $07786b3434b3c544$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $07786b3434b3c544$var$atob = $07786b3434b3c544$var$globalThis.atob || ((b64)=>$07786b3434b3c544$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $07786b3434b3c544$var$bytesFromBase64(b64) {
    const bin = $07786b3434b3c544$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $07786b3434b3c544$var$btoa = $07786b3434b3c544$var$globalThis.btoa || ((bin)=>$07786b3434b3c544$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $07786b3434b3c544$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $07786b3434b3c544$var$btoa(bin.join(""));
}
if ($07786b3434b3c544$var$minimal_1.default.util.Long !== $07786b3434b3c544$var$long_1.default) {
    $07786b3434b3c544$var$minimal_1.default.util.Long = $07786b3434b3c544$var$long_1.default;
    $07786b3434b3c544$var$minimal_1.default.configure();
}


/**
 * Takes a serialized TxRaw (the bytes stored in Tendermint) and decodes it into something usable.
 */ function $8c62935165171ab9$var$decodeTxRaw(tx) {
    const txRaw = $07786b3434b3c544$exports.TxRaw.decode(tx);
    return {
        authInfo: $07786b3434b3c544$exports.AuthInfo.decode(txRaw.authInfoBytes),
        body: $07786b3434b3c544$exports.TxBody.decode(txRaw.bodyBytes),
        signatures: txRaw.signatures
    };
}
$8c62935165171ab9$exports.decodeTxRaw = $8c62935165171ab9$var$decodeTxRaw;


Object.defineProperty($eb9a28d0d0241b06$exports, "decodeTxRaw", {
    enumerable: true,
    get: function() {
        return $8c62935165171ab9$exports.decodeTxRaw;
    }
});
var $25f61b8ec8445a32$exports = {};
"use strict";
Object.defineProperty($25f61b8ec8445a32$exports, "__esModule", {
    value: true
});
$25f61b8ec8445a32$exports.DirectSecp256k1HdWallet = $25f61b8ec8445a32$exports.extractKdfConfiguration = void 0;
var $111142153d5adf1c$exports = {};
"use strict";
Object.defineProperty($111142153d5adf1c$exports, "__esModule", {
    value: true
});
$111142153d5adf1c$exports.executeKdf = $111142153d5adf1c$exports.makeStdTx = $111142153d5adf1c$exports.isStdTx = $111142153d5adf1c$exports.serializeSignDoc = $111142153d5adf1c$exports.makeSignDoc = $111142153d5adf1c$exports.encodeSecp256k1Signature = $111142153d5adf1c$exports.decodeSignature = $111142153d5adf1c$exports.Secp256k1Wallet = $111142153d5adf1c$exports.Secp256k1HdWallet = $111142153d5adf1c$exports.extractKdfConfiguration = $111142153d5adf1c$exports.pubkeyType = $111142153d5adf1c$exports.isSinglePubkey = $111142153d5adf1c$exports.isSecp256k1Pubkey = $111142153d5adf1c$exports.isMultisigThresholdPubkey = $111142153d5adf1c$exports.isEd25519Pubkey = $111142153d5adf1c$exports.makeCosmoshubPath = $111142153d5adf1c$exports.createMultisigThresholdPubkey = $111142153d5adf1c$exports.encodeSecp256k1Pubkey = $111142153d5adf1c$exports.encodeBech32Pubkey = $111142153d5adf1c$exports.encodeAminoPubkey = $111142153d5adf1c$exports.decodeBech32Pubkey = $111142153d5adf1c$exports.decodeAminoPubkey = $111142153d5adf1c$exports.parseCoins = $111142153d5adf1c$exports.coins = $111142153d5adf1c$exports.coin = $111142153d5adf1c$exports.addCoins = $111142153d5adf1c$exports.rawSecp256k1PubkeyToRawAddress = $111142153d5adf1c$exports.rawEd25519PubkeyToRawAddress = $111142153d5adf1c$exports.pubkeyToRawAddress = $111142153d5adf1c$exports.pubkeyToAddress = void 0;
var $e2ad3f9190979ff4$exports = {};
"use strict";
// See https://github.com/tendermint/tendermint/blob/f2ada0a604b4c0763bda2f64fac53d506d3beca7/docs/spec/blockchain/encoding.md#public-key-cryptography
Object.defineProperty($e2ad3f9190979ff4$exports, "__esModule", {
    value: true
});
$e2ad3f9190979ff4$exports.pubkeyToAddress = $e2ad3f9190979ff4$exports.pubkeyToRawAddress = $e2ad3f9190979ff4$exports.rawSecp256k1PubkeyToRawAddress = $e2ad3f9190979ff4$exports.rawEd25519PubkeyToRawAddress = void 0;

var $9Nqq4 = parcelRequire("9Nqq4");

var $5zb9p = parcelRequire("5zb9p");
var $7574bd6de3b98f77$exports = {};
"use strict";
Object.defineProperty($7574bd6de3b98f77$exports, "__esModule", {
    value: true
});
$7574bd6de3b98f77$exports.encodeBech32Pubkey = $7574bd6de3b98f77$exports.encodeAminoPubkey = $7574bd6de3b98f77$exports.decodeBech32Pubkey = $7574bd6de3b98f77$exports.decodeAminoPubkey = $7574bd6de3b98f77$exports.encodeSecp256k1Pubkey = void 0;

var $5zb9p = parcelRequire("5zb9p");

var $9YIif = parcelRequire("9YIif");

var $F6P8J = parcelRequire("F6P8J");
var $696d72d499d0b557$exports = {};
"use strict";
Object.defineProperty($696d72d499d0b557$exports, "__esModule", {
    value: true
});
$696d72d499d0b557$exports.isMultisigThresholdPubkey = $696d72d499d0b557$exports.isSinglePubkey = $696d72d499d0b557$exports.pubkeyType = $696d72d499d0b557$exports.isSecp256k1Pubkey = $696d72d499d0b557$exports.isEd25519Pubkey = void 0;
function $696d72d499d0b557$var$isEd25519Pubkey(pubkey) {
    return pubkey.type === "tendermint/PubKeyEd25519";
}
$696d72d499d0b557$exports.isEd25519Pubkey = $696d72d499d0b557$var$isEd25519Pubkey;
function $696d72d499d0b557$var$isSecp256k1Pubkey(pubkey) {
    return pubkey.type === "tendermint/PubKeySecp256k1";
}
$696d72d499d0b557$exports.isSecp256k1Pubkey = $696d72d499d0b557$var$isSecp256k1Pubkey;
$696d72d499d0b557$exports.pubkeyType = {
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/ed25519/ed25519.go#L22 */ secp256k1: "tendermint/PubKeySecp256k1",
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/secp256k1/secp256k1.go#L23 */ ed25519: "tendermint/PubKeyEd25519",
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/sr25519/codec.go#L12 */ sr25519: "tendermint/PubKeySr25519",
    multisigThreshold: "tendermint/PubKeyMultisigThreshold"
};
function $696d72d499d0b557$var$isSinglePubkey(pubkey) {
    const singPubkeyTypes = [
        $696d72d499d0b557$exports.pubkeyType.ed25519,
        $696d72d499d0b557$exports.pubkeyType.secp256k1,
        $696d72d499d0b557$exports.pubkeyType.sr25519
    ];
    return singPubkeyTypes.includes(pubkey.type);
}
$696d72d499d0b557$exports.isSinglePubkey = $696d72d499d0b557$var$isSinglePubkey;
function $696d72d499d0b557$var$isMultisigThresholdPubkey(pubkey) {
    return pubkey.type === "tendermint/PubKeyMultisigThreshold";
}
$696d72d499d0b557$exports.isMultisigThresholdPubkey = $696d72d499d0b557$var$isMultisigThresholdPubkey;


function $7574bd6de3b98f77$var$encodeSecp256k1Pubkey(pubkey) {
    if (pubkey.length !== 33 || pubkey[0] !== 0x02 && pubkey[0] !== 0x03) throw new Error("Public key must be compressed secp256k1, i.e. 33 bytes starting with 0x02 or 0x03");
    return {
        type: $696d72d499d0b557$exports.pubkeyType.secp256k1,
        value: (0, $5zb9p.toBase64)(pubkey)
    };
}
$7574bd6de3b98f77$exports.encodeSecp256k1Pubkey = $7574bd6de3b98f77$var$encodeSecp256k1Pubkey;
// As discussed in https://github.com/binance-chain/javascript-sdk/issues/163
// Prefixes listed here: https://github.com/tendermint/tendermint/blob/d419fffe18531317c28c29a292ad7d253f6cafdf/docs/spec/blockchain/encoding.md#public-key-cryptography
// Last bytes is varint-encoded length prefix
const $7574bd6de3b98f77$var$pubkeyAminoPrefixSecp256k1 = (0, $5zb9p.fromHex)("eb5ae98721" /* fixed length */ );
const $7574bd6de3b98f77$var$pubkeyAminoPrefixEd25519 = (0, $5zb9p.fromHex)("1624de6420" /* fixed length */ );
const $7574bd6de3b98f77$var$pubkeyAminoPrefixSr25519 = (0, $5zb9p.fromHex)("0dfb100520" /* fixed length */ );
/** See https://github.com/tendermint/tendermint/commit/38b401657e4ad7a7eeb3c30a3cbf512037df3740 */ const $7574bd6de3b98f77$var$pubkeyAminoPrefixMultisigThreshold = (0, $5zb9p.fromHex)("22c1f7e2" /* variable length not included */ );
/**
 * Decodes a pubkey in the Amino binary format to a type/value object.
 */ function $7574bd6de3b98f77$var$decodeAminoPubkey(data) {
    if ((0, $F6P8J.arrayContentStartsWith)(data, $7574bd6de3b98f77$var$pubkeyAminoPrefixSecp256k1)) {
        const rest = data.slice($7574bd6de3b98f77$var$pubkeyAminoPrefixSecp256k1.length);
        if (rest.length !== 33) throw new Error("Invalid rest data length. Expected 33 bytes (compressed secp256k1 pubkey).");
        return {
            type: $696d72d499d0b557$exports.pubkeyType.secp256k1,
            value: (0, $5zb9p.toBase64)(rest)
        };
    } else if ((0, $F6P8J.arrayContentStartsWith)(data, $7574bd6de3b98f77$var$pubkeyAminoPrefixEd25519)) {
        const rest = data.slice($7574bd6de3b98f77$var$pubkeyAminoPrefixEd25519.length);
        if (rest.length !== 32) throw new Error("Invalid rest data length. Expected 32 bytes (Ed25519 pubkey).");
        return {
            type: $696d72d499d0b557$exports.pubkeyType.ed25519,
            value: (0, $5zb9p.toBase64)(rest)
        };
    } else if ((0, $F6P8J.arrayContentStartsWith)(data, $7574bd6de3b98f77$var$pubkeyAminoPrefixSr25519)) {
        const rest = data.slice($7574bd6de3b98f77$var$pubkeyAminoPrefixSr25519.length);
        if (rest.length !== 32) throw new Error("Invalid rest data length. Expected 32 bytes (Sr25519 pubkey).");
        return {
            type: $696d72d499d0b557$exports.pubkeyType.sr25519,
            value: (0, $5zb9p.toBase64)(rest)
        };
    } else if ((0, $F6P8J.arrayContentStartsWith)(data, $7574bd6de3b98f77$var$pubkeyAminoPrefixMultisigThreshold)) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $7574bd6de3b98f77$var$decodeMultisigPubkey(data);
    else throw new Error("Unsupported public key type. Amino data starts with: " + (0, $5zb9p.toHex)(data.slice(0, 5)));
}
$7574bd6de3b98f77$exports.decodeAminoPubkey = $7574bd6de3b98f77$var$decodeAminoPubkey;
/**
 * Decodes a bech32 pubkey to Amino binary, which is then decoded to a type/value object.
 * The bech32 prefix is ignored and discareded.
 *
 * @param bechEncoded the bech32 encoded pubkey
 */ function $7574bd6de3b98f77$var$decodeBech32Pubkey(bechEncoded) {
    const { data: data } = (0, $5zb9p.fromBech32)(bechEncoded);
    return $7574bd6de3b98f77$var$decodeAminoPubkey(data);
}
$7574bd6de3b98f77$exports.decodeBech32Pubkey = $7574bd6de3b98f77$var$decodeBech32Pubkey;
/**
 * Uvarint decoder for Amino.
 * @see https://github.com/tendermint/go-amino/blob/8e779b71f40d175/decoder.go#L64-76
 * @returns varint as number, and bytes count occupied by varaint
 */ function $7574bd6de3b98f77$var$decodeUvarint(reader) {
    if (reader.length < 1) throw new Error("Can't decode varint. EOF");
    if (reader[0] > 127) throw new Error("Decoding numbers > 127 is not supported here. Please tell those lazy CosmJS maintainers to port the binary.Varint implementation from the Go standard library and write some tests.");
    return [
        reader[0],
        1
    ];
}
/**
 * Decodes a multisig pubkey to type object.
 * Pubkey structure [ prefix + const + threshold + loop:(const + pubkeyLength + pubkey            ) ]
 *                  [   4b   + 1b    +  varint   + loop:(1b    +    varint    + pubkeyLength bytes) ]
 * @param data encoded pubkey
 */ function $7574bd6de3b98f77$var$decodeMultisigPubkey(data) {
    const reader = Array.from(data);
    // remove multisig amino prefix;
    const prefixFromReader = reader.splice(0, $7574bd6de3b98f77$var$pubkeyAminoPrefixMultisigThreshold.length);
    if (!(0, $F6P8J.arrayContentStartsWith)(prefixFromReader, $7574bd6de3b98f77$var$pubkeyAminoPrefixMultisigThreshold)) throw new Error("Invalid multisig prefix.");
    // remove 0x08 threshold prefix;
    if (reader.shift() != 0x08) throw new Error("Invalid multisig data. Expecting 0x08 prefix before threshold.");
    // read threshold
    const [threshold, thresholdBytesLength] = $7574bd6de3b98f77$var$decodeUvarint(reader);
    reader.splice(0, thresholdBytesLength);
    // read participants pubkeys
    const pubkeys = [];
    while(reader.length > 0){
        // remove 0x12 threshold prefix;
        if (reader.shift() != 0x12) throw new Error("Invalid multisig data. Expecting 0x12 prefix before participant pubkey length.");
        // read pubkey length
        const [pubkeyLength, pubkeyLengthBytesSize] = $7574bd6de3b98f77$var$decodeUvarint(reader);
        reader.splice(0, pubkeyLengthBytesSize);
        // verify that we can read pubkey
        if (reader.length < pubkeyLength) throw new Error("Invalid multisig data length.");
        // read and decode participant pubkey
        const encodedPubkey = reader.splice(0, pubkeyLength);
        const pubkey = $7574bd6de3b98f77$var$decodeAminoPubkey(Uint8Array.from(encodedPubkey));
        pubkeys.push(pubkey);
    }
    return {
        type: $696d72d499d0b557$exports.pubkeyType.multisigThreshold,
        value: {
            threshold: threshold.toString(),
            pubkeys: pubkeys
        }
    };
}
/**
 * Uvarint encoder for Amino. This is the same encoding as `binary.PutUvarint` from the Go
 * standard library.
 *
 * @see https://github.com/tendermint/go-amino/blob/8e779b71f40d175/encoder.go#L77-L85
 */ function $7574bd6de3b98f77$var$encodeUvarint(value) {
    const checked = $9YIif.Uint53.fromString(value.toString()).toNumber();
    if (checked > 127) throw new Error("Encoding numbers > 127 is not supported here. Please tell those lazy CosmJS maintainers to port the binary.PutUvarint implementation from the Go standard library and write some tests.");
    return [
        checked
    ];
}
/**
 * Encodes a public key to binary Amino.
 */ function $7574bd6de3b98f77$var$encodeAminoPubkey(pubkey) {
    if ((0, $696d72d499d0b557$exports.isMultisigThresholdPubkey)(pubkey)) {
        const out = Array.from($7574bd6de3b98f77$var$pubkeyAminoPrefixMultisigThreshold);
        out.push(0x08); // TODO: What is this?
        out.push(...$7574bd6de3b98f77$var$encodeUvarint(pubkey.value.threshold));
        for (const pubkeyData of pubkey.value.pubkeys.map((p)=>$7574bd6de3b98f77$var$encodeAminoPubkey(p))){
            out.push(0x12); // TODO: What is this?
            out.push(...$7574bd6de3b98f77$var$encodeUvarint(pubkeyData.length));
            out.push(...pubkeyData);
        }
        return new Uint8Array(out);
    } else if ((0, $696d72d499d0b557$exports.isEd25519Pubkey)(pubkey)) return new Uint8Array([
        ...$7574bd6de3b98f77$var$pubkeyAminoPrefixEd25519,
        ...(0, $5zb9p.fromBase64)(pubkey.value)
    ]);
    else if ((0, $696d72d499d0b557$exports.isSecp256k1Pubkey)(pubkey)) return new Uint8Array([
        ...$7574bd6de3b98f77$var$pubkeyAminoPrefixSecp256k1,
        ...(0, $5zb9p.fromBase64)(pubkey.value)
    ]);
    else throw new Error("Unsupported pubkey type");
}
$7574bd6de3b98f77$exports.encodeAminoPubkey = $7574bd6de3b98f77$var$encodeAminoPubkey;
/**
 * Encodes a public key to binary Amino and then to bech32.
 *
 * @param pubkey the public key to encode
 * @param prefix the bech32 prefix (human readable part)
 */ function $7574bd6de3b98f77$var$encodeBech32Pubkey(pubkey, prefix) {
    return (0, $5zb9p.toBech32)(prefix, $7574bd6de3b98f77$var$encodeAminoPubkey(pubkey));
}
$7574bd6de3b98f77$exports.encodeBech32Pubkey = $7574bd6de3b98f77$var$encodeBech32Pubkey;



function $e2ad3f9190979ff4$var$rawEd25519PubkeyToRawAddress(pubkeyData) {
    if (pubkeyData.length !== 32) throw new Error(`Invalid Ed25519 pubkey length: ${pubkeyData.length}`);
    return (0, $9Nqq4.sha256)(pubkeyData).slice(0, 20);
}
$e2ad3f9190979ff4$exports.rawEd25519PubkeyToRawAddress = $e2ad3f9190979ff4$var$rawEd25519PubkeyToRawAddress;
function $e2ad3f9190979ff4$var$rawSecp256k1PubkeyToRawAddress(pubkeyData) {
    if (pubkeyData.length !== 33) throw new Error(`Invalid Secp256k1 pubkey length (compressed): ${pubkeyData.length}`);
    return (0, $9Nqq4.ripemd160)((0, $9Nqq4.sha256)(pubkeyData));
}
$e2ad3f9190979ff4$exports.rawSecp256k1PubkeyToRawAddress = $e2ad3f9190979ff4$var$rawSecp256k1PubkeyToRawAddress;
// For secp256k1 this assumes we already have a compressed pubkey.
function $e2ad3f9190979ff4$var$pubkeyToRawAddress(pubkey) {
    if ((0, $696d72d499d0b557$exports.isSecp256k1Pubkey)(pubkey)) {
        const pubkeyData = (0, $5zb9p.fromBase64)(pubkey.value);
        return $e2ad3f9190979ff4$var$rawSecp256k1PubkeyToRawAddress(pubkeyData);
    } else if ((0, $696d72d499d0b557$exports.isEd25519Pubkey)(pubkey)) {
        const pubkeyData = (0, $5zb9p.fromBase64)(pubkey.value);
        return $e2ad3f9190979ff4$var$rawEd25519PubkeyToRawAddress(pubkeyData);
    } else if ((0, $696d72d499d0b557$exports.isMultisigThresholdPubkey)(pubkey)) {
        // https://github.com/tendermint/tendermint/blob/38b401657e4ad7a7eeb3c30a3cbf512037df3740/crypto/multisig/threshold_pubkey.go#L71-L74
        const pubkeyData = (0, $7574bd6de3b98f77$exports.encodeAminoPubkey)(pubkey);
        return (0, $9Nqq4.sha256)(pubkeyData).slice(0, 20);
    } else throw new Error("Unsupported public key type");
}
$e2ad3f9190979ff4$exports.pubkeyToRawAddress = $e2ad3f9190979ff4$var$pubkeyToRawAddress;
function $e2ad3f9190979ff4$var$pubkeyToAddress(pubkey, prefix) {
    return (0, $5zb9p.toBech32)(prefix, $e2ad3f9190979ff4$var$pubkeyToRawAddress(pubkey));
}
$e2ad3f9190979ff4$exports.pubkeyToAddress = $e2ad3f9190979ff4$var$pubkeyToAddress;


Object.defineProperty($111142153d5adf1c$exports, "pubkeyToAddress", {
    enumerable: true,
    get: function() {
        return $e2ad3f9190979ff4$exports.pubkeyToAddress;
    }
});
Object.defineProperty($111142153d5adf1c$exports, "pubkeyToRawAddress", {
    enumerable: true,
    get: function() {
        return $e2ad3f9190979ff4$exports.pubkeyToRawAddress;
    }
});
Object.defineProperty($111142153d5adf1c$exports, "rawEd25519PubkeyToRawAddress", {
    enumerable: true,
    get: function() {
        return $e2ad3f9190979ff4$exports.rawEd25519PubkeyToRawAddress;
    }
});
Object.defineProperty($111142153d5adf1c$exports, "rawSecp256k1PubkeyToRawAddress", {
    enumerable: true,
    get: function() {
        return $e2ad3f9190979ff4$exports.rawSecp256k1PubkeyToRawAddress;
    }
});
var $83a8973b97e2e32d$exports = {};
"use strict";
Object.defineProperty($83a8973b97e2e32d$exports, "__esModule", {
    value: true
});
$83a8973b97e2e32d$exports.addCoins = $83a8973b97e2e32d$exports.parseCoins = $83a8973b97e2e32d$exports.coins = $83a8973b97e2e32d$exports.coin = void 0;

var $9YIif = parcelRequire("9YIif");
/**
 * Creates a coin.
 *
 * If your values do not exceed the safe integer range of JS numbers (53 bit),
 * you can use the number type here. This is the case for all typical Cosmos SDK
 * chains that use the default 6 decimals.
 *
 * In case you need to supportr larger values, use unsigned integer strings instead.
 */ function $83a8973b97e2e32d$var$coin(amount, denom) {
    let outAmount;
    if (typeof amount === "number") try {
        outAmount = new $9YIif.Uint53(amount).toString();
    } catch (_err) {
        throw new Error("Given amount is not a safe integer. Consider using a string instead to overcome the limitations of JS numbers.");
    }
    else {
        if (!amount.match(/^[0-9]+$/)) throw new Error("Invalid unsigned integer string format");
        outAmount = amount.replace(/^0*/, "") || "0";
    }
    return {
        amount: outAmount,
        denom: denom
    };
}
$83a8973b97e2e32d$exports.coin = $83a8973b97e2e32d$var$coin;
/**
 * Creates a list of coins with one element.
 */ function $83a8973b97e2e32d$var$coins(amount, denom) {
    return [
        $83a8973b97e2e32d$var$coin(amount, denom)
    ];
}
$83a8973b97e2e32d$exports.coins = $83a8973b97e2e32d$var$coins;
/**
 * Takes a coins list like "819966000ucosm,700000000ustake" and parses it.
 *
 * A Stargate-ready variant of this function is available via:
 *
 * ```
 * import { parseCoins } from "@cosmjs/proto-signing";
 * // or
 * import { parseCoins } from "@cosmjs/stargate";
 * ```
 */ function $83a8973b97e2e32d$var$parseCoins(input) {
    return input.replace(/\s/g, "").split(",").filter(Boolean).map((part)=>{
        const match = part.match(/^([0-9]+)([a-zA-Z]+)/);
        if (!match) throw new Error("Got an invalid coin string");
        return {
            amount: $9YIif.Uint64.fromString(match[1]).toString(),
            denom: match[2]
        };
    });
}
$83a8973b97e2e32d$exports.parseCoins = $83a8973b97e2e32d$var$parseCoins;
/**
 * Function to sum up coins with type Coin
 */ function $83a8973b97e2e32d$var$addCoins(lhs, rhs) {
    if (lhs.denom !== rhs.denom) throw new Error("Trying to add two coins with different denoms");
    return {
        amount: $9YIif.Decimal.fromAtomics(lhs.amount, 0).plus($9YIif.Decimal.fromAtomics(rhs.amount, 0)).atomics,
        denom: lhs.denom
    };
}
$83a8973b97e2e32d$exports.addCoins = $83a8973b97e2e32d$var$addCoins;


Object.defineProperty($111142153d5adf1c$exports, "addCoins", {
    enumerable: true,
    get: function() {
        return $83a8973b97e2e32d$exports.addCoins;
    }
});
Object.defineProperty($111142153d5adf1c$exports, "coin", {
    enumerable: true,
    get: function() {
        return $83a8973b97e2e32d$exports.coin;
    }
});
Object.defineProperty($111142153d5adf1c$exports, "coins", {
    enumerable: true,
    get: function() {
        return $83a8973b97e2e32d$exports.coins;
    }
});
Object.defineProperty($111142153d5adf1c$exports, "parseCoins", {
    enumerable: true,
    get: function() {
        return $83a8973b97e2e32d$exports.parseCoins;
    }
});

Object.defineProperty($111142153d5adf1c$exports, "decodeAminoPubkey", {
    enumerable: true,
    get: function() {
        return $7574bd6de3b98f77$exports.decodeAminoPubkey;
    }
});
Object.defineProperty($111142153d5adf1c$exports, "decodeBech32Pubkey", {
    enumerable: true,
    get: function() {
        return $7574bd6de3b98f77$exports.decodeBech32Pubkey;
    }
});
Object.defineProperty($111142153d5adf1c$exports, "encodeAminoPubkey", {
    enumerable: true,
    get: function() {
        return $7574bd6de3b98f77$exports.encodeAminoPubkey;
    }
});
Object.defineProperty($111142153d5adf1c$exports, "encodeBech32Pubkey", {
    enumerable: true,
    get: function() {
        return $7574bd6de3b98f77$exports.encodeBech32Pubkey;
    }
});
Object.defineProperty($111142153d5adf1c$exports, "encodeSecp256k1Pubkey", {
    enumerable: true,
    get: function() {
        return $7574bd6de3b98f77$exports.encodeSecp256k1Pubkey;
    }
});
var $a16c877a757bb04b$exports = {};
"use strict";
Object.defineProperty($a16c877a757bb04b$exports, "__esModule", {
    value: true
});
$a16c877a757bb04b$exports.createMultisigThresholdPubkey = $a16c877a757bb04b$exports.compareArrays = void 0;

var $5zb9p = parcelRequire("5zb9p");

var $9YIif = parcelRequire("9YIif");

/**
 * Compare arrays lexicographically.
 *
 * Returns value < 0 if `a < b`.
 * Returns value > 0 if `a > b`.
 * Returns 0 if `a === b`.
 */ function $a16c877a757bb04b$var$compareArrays(a, b) {
    const aHex = (0, $5zb9p.toHex)(a);
    const bHex = (0, $5zb9p.toHex)(b);
    return aHex === bHex ? 0 : aHex < bHex ? -1 : 1;
}
$a16c877a757bb04b$exports.compareArrays = $a16c877a757bb04b$var$compareArrays;
function $a16c877a757bb04b$var$createMultisigThresholdPubkey(pubkeys, threshold, nosort = false) {
    const uintThreshold = new $9YIif.Uint53(threshold);
    if (uintThreshold.toNumber() > pubkeys.length) throw new Error(`Threshold k = ${uintThreshold.toNumber()} exceeds number of keys n = ${pubkeys.length}`);
    const outPubkeys = nosort ? pubkeys : Array.from(pubkeys).sort((lhs, rhs)=>{
        // https://github.com/cosmos/cosmos-sdk/blob/v0.42.2/client/keys/add.go#L172-L174
        const addressLhs = (0, $e2ad3f9190979ff4$exports.pubkeyToRawAddress)(lhs);
        const addressRhs = (0, $e2ad3f9190979ff4$exports.pubkeyToRawAddress)(rhs);
        return $a16c877a757bb04b$var$compareArrays(addressLhs, addressRhs);
    });
    return {
        type: "tendermint/PubKeyMultisigThreshold",
        value: {
            threshold: uintThreshold.toString(),
            pubkeys: outPubkeys
        }
    };
}
$a16c877a757bb04b$exports.createMultisigThresholdPubkey = $a16c877a757bb04b$var$createMultisigThresholdPubkey;


Object.defineProperty($111142153d5adf1c$exports, "createMultisigThresholdPubkey", {
    enumerable: true,
    get: function() {
        return $a16c877a757bb04b$exports.createMultisigThresholdPubkey;
    }
});
var $2d9fb7ccb0086425$exports = {};
"use strict";
Object.defineProperty($2d9fb7ccb0086425$exports, "__esModule", {
    value: true
});
$2d9fb7ccb0086425$exports.makeCosmoshubPath = void 0;

var $9Nqq4 = parcelRequire("9Nqq4");
/**
 * The Cosmos Hub derivation path in the form `m/44'/118'/0'/0/a`
 * with 0-based account index `a`.
 */ function $2d9fb7ccb0086425$var$makeCosmoshubPath(a) {
    return [
        $9Nqq4.Slip10RawIndex.hardened(44),
        $9Nqq4.Slip10RawIndex.hardened(118),
        $9Nqq4.Slip10RawIndex.hardened(0),
        $9Nqq4.Slip10RawIndex.normal(0),
        $9Nqq4.Slip10RawIndex.normal(a)
    ];
}
$2d9fb7ccb0086425$exports.makeCosmoshubPath = $2d9fb7ccb0086425$var$makeCosmoshubPath;


Object.defineProperty($111142153d5adf1c$exports, "makeCosmoshubPath", {
    enumerable: true,
    get: function() {
        return $2d9fb7ccb0086425$exports.makeCosmoshubPath;
    }
});

Object.defineProperty($111142153d5adf1c$exports, "isEd25519Pubkey", {
    enumerable: true,
    get: function() {
        return $696d72d499d0b557$exports.isEd25519Pubkey;
    }
});
Object.defineProperty($111142153d5adf1c$exports, "isMultisigThresholdPubkey", {
    enumerable: true,
    get: function() {
        return $696d72d499d0b557$exports.isMultisigThresholdPubkey;
    }
});
Object.defineProperty($111142153d5adf1c$exports, "isSecp256k1Pubkey", {
    enumerable: true,
    get: function() {
        return $696d72d499d0b557$exports.isSecp256k1Pubkey;
    }
});
Object.defineProperty($111142153d5adf1c$exports, "isSinglePubkey", {
    enumerable: true,
    get: function() {
        return $696d72d499d0b557$exports.isSinglePubkey;
    }
});
Object.defineProperty($111142153d5adf1c$exports, "pubkeyType", {
    enumerable: true,
    get: function() {
        return $696d72d499d0b557$exports.pubkeyType;
    }
});
var $3258dfa7557d6ced$exports = {};
"use strict";
Object.defineProperty($3258dfa7557d6ced$exports, "__esModule", {
    value: true
});
$3258dfa7557d6ced$exports.Secp256k1HdWallet = $3258dfa7557d6ced$exports.extractKdfConfiguration = void 0;

var $9Nqq4 = parcelRequire("9Nqq4");

var $5zb9p = parcelRequire("5zb9p");

var $F6P8J = parcelRequire("F6P8J");


var $4aec026b07ed3c91$exports = {};
"use strict";
Object.defineProperty($4aec026b07ed3c91$exports, "__esModule", {
    value: true
});
$4aec026b07ed3c91$exports.decodeSignature = $4aec026b07ed3c91$exports.encodeSecp256k1Signature = void 0;

var $5zb9p = parcelRequire("5zb9p");


/**
 * Takes a binary pubkey and signature to create a signature object
 *
 * @param pubkey a compressed secp256k1 public key
 * @param signature a 64 byte fixed length representation of secp256k1 signature components r and s
 */ function $4aec026b07ed3c91$var$encodeSecp256k1Signature(pubkey, signature) {
    if (signature.length !== 64) throw new Error("Signature must be 64 bytes long. Cosmos SDK uses a 2x32 byte fixed length encoding for the secp256k1 signature integers r and s.");
    return {
        pub_key: (0, $7574bd6de3b98f77$exports.encodeSecp256k1Pubkey)(pubkey),
        signature: (0, $5zb9p.toBase64)(signature)
    };
}
$4aec026b07ed3c91$exports.encodeSecp256k1Signature = $4aec026b07ed3c91$var$encodeSecp256k1Signature;
function $4aec026b07ed3c91$var$decodeSignature(signature) {
    switch(signature.pub_key.type){
        // Note: please don't add cases here without writing additional unit tests
        case $696d72d499d0b557$exports.pubkeyType.secp256k1:
            return {
                pubkey: (0, $5zb9p.fromBase64)(signature.pub_key.value),
                signature: (0, $5zb9p.fromBase64)(signature.signature)
            };
        default:
            throw new Error("Unsupported pubkey type");
    }
}
$4aec026b07ed3c91$exports.decodeSignature = $4aec026b07ed3c91$var$decodeSignature;


var $bef1ddbb532f4139$exports = {};
"use strict";
Object.defineProperty($bef1ddbb532f4139$exports, "__esModule", {
    value: true
});
$bef1ddbb532f4139$exports.serializeSignDoc = $bef1ddbb532f4139$exports.makeSignDoc = $bef1ddbb532f4139$exports.sortedJsonStringify = void 0;

var $5zb9p = parcelRequire("5zb9p");

var $9YIif = parcelRequire("9YIif");
function $bef1ddbb532f4139$var$sortedObject(obj) {
    if (typeof obj !== "object" || obj === null) return obj;
    if (Array.isArray(obj)) return obj.map($bef1ddbb532f4139$var$sortedObject);
    const sortedKeys = Object.keys(obj).sort();
    const result = {};
    // NOTE: Use forEach instead of reduce for performance with large objects eg Wasm code
    sortedKeys.forEach((key)=>{
        result[key] = $bef1ddbb532f4139$var$sortedObject(obj[key]);
    });
    return result;
}
/** Returns a JSON string with objects sorted by key */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $bef1ddbb532f4139$var$sortedJsonStringify(obj) {
    return JSON.stringify($bef1ddbb532f4139$var$sortedObject(obj));
}
$bef1ddbb532f4139$exports.sortedJsonStringify = $bef1ddbb532f4139$var$sortedJsonStringify;
function $bef1ddbb532f4139$var$makeSignDoc(msgs, fee, chainId, memo, accountNumber, sequence) {
    return {
        chain_id: chainId,
        account_number: $9YIif.Uint53.fromString(accountNumber.toString()).toString(),
        sequence: $9YIif.Uint53.fromString(sequence.toString()).toString(),
        fee: fee,
        msgs: msgs,
        memo: memo || ""
    };
}
$bef1ddbb532f4139$exports.makeSignDoc = $bef1ddbb532f4139$var$makeSignDoc;
function $bef1ddbb532f4139$var$serializeSignDoc(signDoc) {
    return (0, $5zb9p.toUtf8)($bef1ddbb532f4139$var$sortedJsonStringify(signDoc));
}
$bef1ddbb532f4139$exports.serializeSignDoc = $bef1ddbb532f4139$var$serializeSignDoc;


var $bbc0bf0230241eb0$exports = {};
"use strict";
Object.defineProperty($bbc0bf0230241eb0$exports, "__esModule", {
    value: true
});
$bbc0bf0230241eb0$exports.decrypt = $bbc0bf0230241eb0$exports.encrypt = $bbc0bf0230241eb0$exports.supportedAlgorithms = $bbc0bf0230241eb0$exports.executeKdf = $bbc0bf0230241eb0$exports.cosmjsSalt = void 0;

var $9Nqq4 = parcelRequire("9Nqq4");

var $5zb9p = parcelRequire("5zb9p");
/**
 * A fixed salt is chosen to archive a deterministic password to key derivation.
 * This reduces the scope of a potential rainbow attack to all CosmJS users.
 * Must be 16 bytes due to implementation limitations.
 */ $bbc0bf0230241eb0$exports.cosmjsSalt = (0, $5zb9p.toAscii)("The CosmJS salt.");
async function $bbc0bf0230241eb0$var$executeKdf(password, configuration) {
    switch(configuration.algorithm){
        case "argon2id":
            {
                const options = configuration.params;
                if (!(0, $9Nqq4.isArgon2idOptions)(options)) throw new Error("Invalid format of argon2id params");
                return $9Nqq4.Argon2id.execute(password, $bbc0bf0230241eb0$exports.cosmjsSalt, options);
            }
        default:
            throw new Error("Unsupported KDF algorithm");
    }
}
$bbc0bf0230241eb0$exports.executeKdf = $bbc0bf0230241eb0$var$executeKdf;
$bbc0bf0230241eb0$exports.supportedAlgorithms = {
    xchacha20poly1305Ietf: "xchacha20poly1305-ietf"
};
async function $bbc0bf0230241eb0$var$encrypt(plaintext, encryptionKey, config) {
    switch(config.algorithm){
        case $bbc0bf0230241eb0$exports.supportedAlgorithms.xchacha20poly1305Ietf:
            {
                const nonce = $9Nqq4.Random.getBytes($9Nqq4.xchacha20NonceLength);
                // Prepend fixed-length nonce to ciphertext as suggested in the example from https://github.com/jedisct1/libsodium.js#api
                return new Uint8Array([
                    ...nonce,
                    ...await $9Nqq4.Xchacha20poly1305Ietf.encrypt(plaintext, encryptionKey, nonce)
                ]);
            }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
$bbc0bf0230241eb0$exports.encrypt = $bbc0bf0230241eb0$var$encrypt;
async function $bbc0bf0230241eb0$var$decrypt(ciphertext, encryptionKey, config) {
    switch(config.algorithm){
        case $bbc0bf0230241eb0$exports.supportedAlgorithms.xchacha20poly1305Ietf:
            {
                const nonce = ciphertext.slice(0, $9Nqq4.xchacha20NonceLength);
                return $9Nqq4.Xchacha20poly1305Ietf.decrypt(ciphertext.slice($9Nqq4.xchacha20NonceLength), encryptionKey, nonce);
            }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
$bbc0bf0230241eb0$exports.decrypt = $bbc0bf0230241eb0$var$decrypt;


const $3258dfa7557d6ced$var$serializationTypeV1 = "secp256k1wallet-v1";
/**
 * A KDF configuration that is not very strong but can be used on the main thread.
 * It takes about 1 second in Node.js 16.0.0 and should have similar runtimes in other modern Wasm hosts.
 */ const $3258dfa7557d6ced$var$basicPasswordHashingOptions = {
    algorithm: "argon2id",
    params: {
        outputLength: 32,
        opsLimit: 24,
        memLimitKib: 12288
    }
};
function $3258dfa7557d6ced$var$isDerivationJson(thing) {
    if (!(0, $F6P8J.isNonNullObject)(thing)) return false;
    if (typeof thing.hdPath !== "string") return false;
    if (typeof thing.prefix !== "string") return false;
    return true;
}
function $3258dfa7557d6ced$var$extractKdfConfigurationV1(doc) {
    return doc.kdf;
}
function $3258dfa7557d6ced$var$extractKdfConfiguration(serialization) {
    const root = JSON.parse(serialization);
    if (!(0, $F6P8J.isNonNullObject)(root)) throw new Error("Root document is not an object.");
    switch(root.type){
        case $3258dfa7557d6ced$var$serializationTypeV1:
            return $3258dfa7557d6ced$var$extractKdfConfigurationV1(root);
        default:
            throw new Error("Unsupported serialization type");
    }
}
$3258dfa7557d6ced$exports.extractKdfConfiguration = $3258dfa7557d6ced$var$extractKdfConfiguration;
const $3258dfa7557d6ced$var$defaultOptions = {
    bip39Password: "",
    hdPaths: [
        (0, $2d9fb7ccb0086425$exports.makeCosmoshubPath)(0)
    ],
    prefix: "cosmos"
};
class $3258dfa7557d6ced$var$Secp256k1HdWallet {
    /**
     * Restores a wallet from the given BIP39 mnemonic.
     *
     * @param mnemonic Any valid English mnemonic.
     * @param options An optional `Secp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */ static async fromMnemonic(mnemonic, options = {}) {
        const mnemonicChecked = new $9Nqq4.EnglishMnemonic(mnemonic);
        const seed = await $9Nqq4.Bip39.mnemonicToSeed(mnemonicChecked, options.bip39Password);
        return new $3258dfa7557d6ced$var$Secp256k1HdWallet(mnemonicChecked, {
            ...options,
            seed: seed
        });
    }
    /**
     * Generates a new wallet with a BIP39 mnemonic of the given length.
     *
     * @param length The number of words in the mnemonic (12, 15, 18, 21 or 24).
     * @param options An optional `Secp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */ static async generate(length = 12, options = {}) {
        const entropyLength = 4 * Math.floor(11 * length / 33);
        const entropy = $9Nqq4.Random.getBytes(entropyLength);
        const mnemonic = $9Nqq4.Bip39.encode(entropy);
        return $3258dfa7557d6ced$var$Secp256k1HdWallet.fromMnemonic(mnemonic.toString(), options);
    }
    /**
     * Restores a wallet from an encrypted serialization.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */ static async deserialize(serialization, password) {
        const root = JSON.parse(serialization);
        if (!(0, $F6P8J.isNonNullObject)(root)) throw new Error("Root document is not an object.");
        switch(root.type){
            case $3258dfa7557d6ced$var$serializationTypeV1:
                return $3258dfa7557d6ced$var$Secp256k1HdWallet.deserializeTypeV1(serialization, password);
            default:
                throw new Error("Unsupported serialization type");
        }
    }
    /**
     * Restores a wallet from an encrypted serialization.
     *
     * This is an advanced alternative to calling `deserialize(serialization, password)` directly, which allows
     * you to offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF configuration. This can be
     * done using `extractKdfConfiguration(serialization)` and `executeKdf(password, kdfConfiguration)` from this package.
     */ static async deserializeWithEncryptionKey(serialization, encryptionKey) {
        const root = JSON.parse(serialization);
        if (!(0, $F6P8J.isNonNullObject)(root)) throw new Error("Root document is not an object.");
        const untypedRoot = root;
        switch(untypedRoot.type){
            case $3258dfa7557d6ced$var$serializationTypeV1:
                {
                    const decryptedBytes = await (0, $bbc0bf0230241eb0$exports.decrypt)((0, $5zb9p.fromBase64)(untypedRoot.data), encryptionKey, untypedRoot.encryption);
                    const decryptedDocument = JSON.parse((0, $5zb9p.fromUtf8)(decryptedBytes));
                    const { mnemonic: mnemonic, accounts: accounts } = decryptedDocument;
                    (0, $F6P8J.assert)(typeof mnemonic === "string");
                    if (!Array.isArray(accounts)) throw new Error("Property 'accounts' is not an array");
                    if (!accounts.every((account)=>$3258dfa7557d6ced$var$isDerivationJson(account))) throw new Error("Account is not in the correct format.");
                    const firstPrefix = accounts[0].prefix;
                    if (!accounts.every(({ prefix: prefix })=>prefix === firstPrefix)) throw new Error("Accounts do not all have the same prefix");
                    const hdPaths = accounts.map(({ hdPath: hdPath })=>(0, $9Nqq4.stringToPath)(hdPath));
                    return $3258dfa7557d6ced$var$Secp256k1HdWallet.fromMnemonic(mnemonic, {
                        hdPaths: hdPaths,
                        prefix: firstPrefix
                    });
                }
            default:
                throw new Error("Unsupported serialization type");
        }
    }
    static async deserializeTypeV1(serialization, password) {
        const root = JSON.parse(serialization);
        if (!(0, $F6P8J.isNonNullObject)(root)) throw new Error("Root document is not an object.");
        const encryptionKey = await (0, $bbc0bf0230241eb0$exports.executeKdf)(password, root.kdf);
        return $3258dfa7557d6ced$var$Secp256k1HdWallet.deserializeWithEncryptionKey(serialization, encryptionKey);
    }
    get mnemonic() {
        return this.secret.toString();
    }
    async getAccounts() {
        const accountsWithPrivkeys = await this.getAccountsWithPrivkeys();
        return accountsWithPrivkeys.map(({ algo: algo, pubkey: pubkey, address: address })=>({
                algo: algo,
                pubkey: pubkey,
                address: address
            }));
    }
    async signAmino(signerAddress, signDoc) {
        const accounts = await this.getAccountsWithPrivkeys();
        const account = accounts.find(({ address: address })=>address === signerAddress);
        if (account === undefined) throw new Error(`Address ${signerAddress} not found in wallet`);
        const { privkey: privkey, pubkey: pubkey } = account;
        const message = (0, $9Nqq4.sha256)((0, $bef1ddbb532f4139$exports.serializeSignDoc)(signDoc));
        const signature = await $9Nqq4.Secp256k1.createSignature(message, privkey);
        const signatureBytes = new Uint8Array([
            ...signature.r(32),
            ...signature.s(32)
        ]);
        return {
            signed: signDoc,
            signature: (0, $4aec026b07ed3c91$exports.encodeSecp256k1Signature)(pubkey, signatureBytes)
        };
    }
    /**
     * Generates an encrypted serialization of this wallet.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */ async serialize(password) {
        const kdfConfiguration = $3258dfa7557d6ced$var$basicPasswordHashingOptions;
        const encryptionKey = await (0, $bbc0bf0230241eb0$exports.executeKdf)(password, kdfConfiguration);
        return this.serializeWithEncryptionKey(encryptionKey, kdfConfiguration);
    }
    /**
     * Generates an encrypted serialization of this wallet.
     *
     * This is an advanced alternative to calling `serialize(password)` directly, which allows you to
     * offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF options. If this
     * is not the case, the wallet cannot be restored with the original password.
     */ async serializeWithEncryptionKey(encryptionKey, kdfConfiguration) {
        const dataToEncrypt = {
            mnemonic: this.mnemonic,
            accounts: this.accounts.map(({ hdPath: hdPath, prefix: prefix })=>({
                    hdPath: (0, $9Nqq4.pathToString)(hdPath),
                    prefix: prefix
                }))
        };
        const dataToEncryptRaw = (0, $5zb9p.toUtf8)(JSON.stringify(dataToEncrypt));
        const encryptionConfiguration = {
            algorithm: $bbc0bf0230241eb0$exports.supportedAlgorithms.xchacha20poly1305Ietf
        };
        const encryptedData = await (0, $bbc0bf0230241eb0$exports.encrypt)(dataToEncryptRaw, encryptionKey, encryptionConfiguration);
        const out = {
            type: $3258dfa7557d6ced$var$serializationTypeV1,
            kdf: kdfConfiguration,
            encryption: encryptionConfiguration,
            data: (0, $5zb9p.toBase64)(encryptedData)
        };
        return JSON.stringify(out);
    }
    async getKeyPair(hdPath) {
        const { privkey: privkey } = $9Nqq4.Slip10.derivePath($9Nqq4.Slip10Curve.Secp256k1, this.seed, hdPath);
        const { pubkey: pubkey } = await $9Nqq4.Secp256k1.makeKeypair(privkey);
        return {
            privkey: privkey,
            pubkey: $9Nqq4.Secp256k1.compressPubkey(pubkey)
        };
    }
    async getAccountsWithPrivkeys() {
        return Promise.all(this.accounts.map(async ({ hdPath: hdPath, prefix: prefix })=>{
            const { privkey: privkey, pubkey: pubkey } = await this.getKeyPair(hdPath);
            const address = (0, $5zb9p.toBech32)(prefix, (0, $e2ad3f9190979ff4$exports.rawSecp256k1PubkeyToRawAddress)(pubkey));
            return {
                algo: "secp256k1",
                privkey: privkey,
                pubkey: pubkey,
                address: address
            };
        }));
    }
    constructor(mnemonic, options){
        var _a, _b;
        const hdPaths = (_a = options.hdPaths) !== null && _a !== void 0 ? _a : $3258dfa7557d6ced$var$defaultOptions.hdPaths;
        const prefix = (_b = options.prefix) !== null && _b !== void 0 ? _b : $3258dfa7557d6ced$var$defaultOptions.prefix;
        this.secret = mnemonic;
        this.seed = options.seed;
        this.accounts = hdPaths.map((hdPath)=>({
                hdPath: hdPath,
                prefix: prefix
            }));
    }
}
$3258dfa7557d6ced$exports.Secp256k1HdWallet = $3258dfa7557d6ced$var$Secp256k1HdWallet;


Object.defineProperty($111142153d5adf1c$exports, "extractKdfConfiguration", {
    enumerable: true,
    get: function() {
        return $3258dfa7557d6ced$exports.extractKdfConfiguration;
    }
});
Object.defineProperty($111142153d5adf1c$exports, "Secp256k1HdWallet", {
    enumerable: true,
    get: function() {
        return $3258dfa7557d6ced$exports.Secp256k1HdWallet;
    }
});
var $4efaac9d53cef7a7$exports = {};
"use strict";
Object.defineProperty($4efaac9d53cef7a7$exports, "__esModule", {
    value: true
});
$4efaac9d53cef7a7$exports.Secp256k1Wallet = void 0;

var $9Nqq4 = parcelRequire("9Nqq4");

var $5zb9p = parcelRequire("5zb9p");



/**
 * A wallet that holds a single secp256k1 keypair.
 *
 * If you want to work with BIP39 mnemonics and multiple accounts, use Secp256k1HdWallet.
 */ class $4efaac9d53cef7a7$var$Secp256k1Wallet {
    /**
     * Creates a Secp256k1Wallet from the given private key
     *
     * @param privkey The private key.
     * @param prefix The bech32 address prefix (human readable part). Defaults to "cosmos".
     */ static async fromKey(privkey, prefix = "cosmos") {
        const uncompressed = (await $9Nqq4.Secp256k1.makeKeypair(privkey)).pubkey;
        return new $4efaac9d53cef7a7$var$Secp256k1Wallet(privkey, $9Nqq4.Secp256k1.compressPubkey(uncompressed), prefix);
    }
    get address() {
        return (0, $5zb9p.toBech32)(this.prefix, (0, $e2ad3f9190979ff4$exports.rawSecp256k1PubkeyToRawAddress)(this.pubkey));
    }
    async getAccounts() {
        return [
            {
                algo: "secp256k1",
                address: this.address,
                pubkey: this.pubkey
            }
        ];
    }
    async signAmino(signerAddress, signDoc) {
        if (signerAddress !== this.address) throw new Error(`Address ${signerAddress} not found in wallet`);
        const message = new $9Nqq4.Sha256((0, $bef1ddbb532f4139$exports.serializeSignDoc)(signDoc)).digest();
        const signature = await $9Nqq4.Secp256k1.createSignature(message, this.privkey);
        const signatureBytes = new Uint8Array([
            ...signature.r(32),
            ...signature.s(32)
        ]);
        return {
            signed: signDoc,
            signature: (0, $4aec026b07ed3c91$exports.encodeSecp256k1Signature)(this.pubkey, signatureBytes)
        };
    }
    constructor(privkey, pubkey, prefix){
        this.privkey = privkey;
        this.pubkey = pubkey;
        this.prefix = prefix;
    }
}
$4efaac9d53cef7a7$exports.Secp256k1Wallet = $4efaac9d53cef7a7$var$Secp256k1Wallet;


Object.defineProperty($111142153d5adf1c$exports, "Secp256k1Wallet", {
    enumerable: true,
    get: function() {
        return $4efaac9d53cef7a7$exports.Secp256k1Wallet;
    }
});

Object.defineProperty($111142153d5adf1c$exports, "decodeSignature", {
    enumerable: true,
    get: function() {
        return $4aec026b07ed3c91$exports.decodeSignature;
    }
});
Object.defineProperty($111142153d5adf1c$exports, "encodeSecp256k1Signature", {
    enumerable: true,
    get: function() {
        return $4aec026b07ed3c91$exports.encodeSecp256k1Signature;
    }
});

Object.defineProperty($111142153d5adf1c$exports, "makeSignDoc", {
    enumerable: true,
    get: function() {
        return $bef1ddbb532f4139$exports.makeSignDoc;
    }
});
Object.defineProperty($111142153d5adf1c$exports, "serializeSignDoc", {
    enumerable: true,
    get: function() {
        return $bef1ddbb532f4139$exports.serializeSignDoc;
    }
});
var $cc1c19e15faaa0ee$exports = {};
"use strict";
Object.defineProperty($cc1c19e15faaa0ee$exports, "__esModule", {
    value: true
});
$cc1c19e15faaa0ee$exports.makeStdTx = $cc1c19e15faaa0ee$exports.isStdTx = void 0;
function $cc1c19e15faaa0ee$var$isStdTx(txValue) {
    const { memo: memo, msg: msg, fee: fee, signatures: signatures } = txValue;
    return typeof memo === "string" && Array.isArray(msg) && typeof fee === "object" && Array.isArray(signatures);
}
$cc1c19e15faaa0ee$exports.isStdTx = $cc1c19e15faaa0ee$var$isStdTx;
function $cc1c19e15faaa0ee$var$makeStdTx(content, signatures) {
    return {
        msg: content.msgs,
        fee: content.fee,
        memo: content.memo,
        signatures: Array.isArray(signatures) ? signatures : [
            signatures
        ]
    };
}
$cc1c19e15faaa0ee$exports.makeStdTx = $cc1c19e15faaa0ee$var$makeStdTx;


Object.defineProperty($111142153d5adf1c$exports, "isStdTx", {
    enumerable: true,
    get: function() {
        return $cc1c19e15faaa0ee$exports.isStdTx;
    }
});
Object.defineProperty($111142153d5adf1c$exports, "makeStdTx", {
    enumerable: true,
    get: function() {
        return $cc1c19e15faaa0ee$exports.makeStdTx;
    }
});

Object.defineProperty($111142153d5adf1c$exports, "executeKdf", {
    enumerable: true,
    get: function() {
        return $bbc0bf0230241eb0$exports.executeKdf;
    }
});



var $9Nqq4 = parcelRequire("9Nqq4");

var $5zb9p = parcelRequire("5zb9p");

var $F6P8J = parcelRequire("F6P8J");
var $5b82a40661cae0d6$exports = {};
"use strict";
var $5b82a40661cae0d6$var$__importDefault = $5b82a40661cae0d6$exports && $5b82a40661cae0d6$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($5b82a40661cae0d6$exports, "__esModule", {
    value: true
});
$5b82a40661cae0d6$exports.makeSignBytes = $5b82a40661cae0d6$exports.makeSignDoc = $5b82a40661cae0d6$exports.makeAuthInfoBytes = void 0;



const $5b82a40661cae0d6$var$long_1 = $5b82a40661cae0d6$var$__importDefault((parcelRequire("9A55m")));
/**
 * Create signer infos from the provided signers.
 *
 * This implementation does not support different signing modes for the different signers.
 */ function $5b82a40661cae0d6$var$makeSignerInfos(signers, signMode) {
    return signers.map(({ pubkey: pubkey, sequence: sequence })=>({
            publicKey: pubkey,
            modeInfo: {
                single: {
                    mode: signMode
                }
            },
            sequence: $5b82a40661cae0d6$var$long_1.default.fromNumber(sequence)
        }));
}
/**
 * Creates and serializes an AuthInfo document.
 *
 * This implementation does not support different signing modes for the different signers.
 */ function $5b82a40661cae0d6$var$makeAuthInfoBytes(signers, feeAmount, gasLimit, signMode = $d422a57cb1210f8b$exports.SignMode.SIGN_MODE_DIRECT) {
    const authInfo = {
        signerInfos: $5b82a40661cae0d6$var$makeSignerInfos(signers, signMode),
        fee: {
            amount: [
                ...feeAmount
            ],
            gasLimit: $5b82a40661cae0d6$var$long_1.default.fromNumber(gasLimit)
        }
    };
    return $07786b3434b3c544$exports.AuthInfo.encode($07786b3434b3c544$exports.AuthInfo.fromPartial(authInfo)).finish();
}
$5b82a40661cae0d6$exports.makeAuthInfoBytes = $5b82a40661cae0d6$var$makeAuthInfoBytes;
function $5b82a40661cae0d6$var$makeSignDoc(bodyBytes, authInfoBytes, chainId, accountNumber) {
    return {
        bodyBytes: bodyBytes,
        authInfoBytes: authInfoBytes,
        chainId: chainId,
        accountNumber: $5b82a40661cae0d6$var$long_1.default.fromNumber(accountNumber)
    };
}
$5b82a40661cae0d6$exports.makeSignDoc = $5b82a40661cae0d6$var$makeSignDoc;
function $5b82a40661cae0d6$var$makeSignBytes({ accountNumber: accountNumber, authInfoBytes: authInfoBytes, bodyBytes: bodyBytes, chainId: chainId }) {
    const signDoc = $07786b3434b3c544$exports.SignDoc.fromPartial({
        accountNumber: accountNumber,
        authInfoBytes: authInfoBytes,
        bodyBytes: bodyBytes,
        chainId: chainId
    });
    return $07786b3434b3c544$exports.SignDoc.encode(signDoc).finish();
}
$5b82a40661cae0d6$exports.makeSignBytes = $5b82a40661cae0d6$var$makeSignBytes;


var $338aaf6a7a996fc6$exports = {};
"use strict";
Object.defineProperty($338aaf6a7a996fc6$exports, "__esModule", {
    value: true
});
$338aaf6a7a996fc6$exports.decrypt = $338aaf6a7a996fc6$exports.encrypt = $338aaf6a7a996fc6$exports.supportedAlgorithms = $338aaf6a7a996fc6$exports.executeKdf = $338aaf6a7a996fc6$exports.cosmjsSalt = void 0;

var $9Nqq4 = parcelRequire("9Nqq4");

var $5zb9p = parcelRequire("5zb9p");
/**
 * A fixed salt is chosen to archive a deterministic password to key derivation.
 * This reduces the scope of a potential rainbow attack to all CosmJS users.
 * Must be 16 bytes due to implementation limitations.
 */ $338aaf6a7a996fc6$exports.cosmjsSalt = (0, $5zb9p.toAscii)("The CosmJS salt.");
async function $338aaf6a7a996fc6$var$executeKdf(password, configuration) {
    switch(configuration.algorithm){
        case "argon2id":
            {
                const options = configuration.params;
                if (!(0, $9Nqq4.isArgon2idOptions)(options)) throw new Error("Invalid format of argon2id params");
                return $9Nqq4.Argon2id.execute(password, $338aaf6a7a996fc6$exports.cosmjsSalt, options);
            }
        default:
            throw new Error("Unsupported KDF algorithm");
    }
}
$338aaf6a7a996fc6$exports.executeKdf = $338aaf6a7a996fc6$var$executeKdf;
$338aaf6a7a996fc6$exports.supportedAlgorithms = {
    xchacha20poly1305Ietf: "xchacha20poly1305-ietf"
};
async function $338aaf6a7a996fc6$var$encrypt(plaintext, encryptionKey, config) {
    switch(config.algorithm){
        case $338aaf6a7a996fc6$exports.supportedAlgorithms.xchacha20poly1305Ietf:
            {
                const nonce = $9Nqq4.Random.getBytes($9Nqq4.xchacha20NonceLength);
                // Prepend fixed-length nonce to ciphertext as suggested in the example from https://github.com/jedisct1/libsodium.js#api
                return new Uint8Array([
                    ...nonce,
                    ...await $9Nqq4.Xchacha20poly1305Ietf.encrypt(plaintext, encryptionKey, nonce)
                ]);
            }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
$338aaf6a7a996fc6$exports.encrypt = $338aaf6a7a996fc6$var$encrypt;
async function $338aaf6a7a996fc6$var$decrypt(ciphertext, encryptionKey, config) {
    switch(config.algorithm){
        case $338aaf6a7a996fc6$exports.supportedAlgorithms.xchacha20poly1305Ietf:
            {
                const nonce = ciphertext.slice(0, $9Nqq4.xchacha20NonceLength);
                return $9Nqq4.Xchacha20poly1305Ietf.decrypt(ciphertext.slice($9Nqq4.xchacha20NonceLength), encryptionKey, nonce);
            }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
$338aaf6a7a996fc6$exports.decrypt = $338aaf6a7a996fc6$var$decrypt;


const $25f61b8ec8445a32$var$serializationTypeV1 = "directsecp256k1hdwallet-v1";
/**
 * A KDF configuration that is not very strong but can be used on the main thread.
 * It takes about 1 second in Node.js 16.0.0 and should have similar runtimes in other modern Wasm hosts.
 */ const $25f61b8ec8445a32$var$basicPasswordHashingOptions = {
    algorithm: "argon2id",
    params: {
        outputLength: 32,
        opsLimit: 24,
        memLimitKib: 12288
    }
};
function $25f61b8ec8445a32$var$isDerivationJson(thing) {
    if (!(0, $F6P8J.isNonNullObject)(thing)) return false;
    if (typeof thing.hdPath !== "string") return false;
    if (typeof thing.prefix !== "string") return false;
    return true;
}
function $25f61b8ec8445a32$var$extractKdfConfigurationV1(doc) {
    return doc.kdf;
}
function $25f61b8ec8445a32$var$extractKdfConfiguration(serialization) {
    const root = JSON.parse(serialization);
    if (!(0, $F6P8J.isNonNullObject)(root)) throw new Error("Root document is not an object.");
    switch(root.type){
        case $25f61b8ec8445a32$var$serializationTypeV1:
            return $25f61b8ec8445a32$var$extractKdfConfigurationV1(root);
        default:
            throw new Error("Unsupported serialization type");
    }
}
$25f61b8ec8445a32$exports.extractKdfConfiguration = $25f61b8ec8445a32$var$extractKdfConfiguration;
const $25f61b8ec8445a32$var$defaultOptions = {
    bip39Password: "",
    hdPaths: [
        (0, $111142153d5adf1c$exports.makeCosmoshubPath)(0)
    ],
    prefix: "cosmos"
};
/** A wallet for protobuf based signing using SIGN_MODE_DIRECT */ class $25f61b8ec8445a32$var$DirectSecp256k1HdWallet {
    /**
     * Restores a wallet from the given BIP39 mnemonic.
     *
     * @param mnemonic Any valid English mnemonic.
     * @param options An optional `DirectSecp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */ static async fromMnemonic(mnemonic, options = {}) {
        const mnemonicChecked = new $9Nqq4.EnglishMnemonic(mnemonic);
        const seed = await $9Nqq4.Bip39.mnemonicToSeed(mnemonicChecked, options.bip39Password);
        return new $25f61b8ec8445a32$var$DirectSecp256k1HdWallet(mnemonicChecked, {
            ...options,
            seed: seed
        });
    }
    /**
     * Generates a new wallet with a BIP39 mnemonic of the given length.
     *
     * @param length The number of words in the mnemonic (12, 15, 18, 21 or 24).
     * @param options An optional `DirectSecp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */ static async generate(length = 12, options = {}) {
        const entropyLength = 4 * Math.floor(11 * length / 33);
        const entropy = $9Nqq4.Random.getBytes(entropyLength);
        const mnemonic = $9Nqq4.Bip39.encode(entropy);
        return $25f61b8ec8445a32$var$DirectSecp256k1HdWallet.fromMnemonic(mnemonic.toString(), options);
    }
    /**
     * Restores a wallet from an encrypted serialization.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */ static async deserialize(serialization, password) {
        const root = JSON.parse(serialization);
        if (!(0, $F6P8J.isNonNullObject)(root)) throw new Error("Root document is not an object.");
        switch(root.type){
            case $25f61b8ec8445a32$var$serializationTypeV1:
                return $25f61b8ec8445a32$var$DirectSecp256k1HdWallet.deserializeTypeV1(serialization, password);
            default:
                throw new Error("Unsupported serialization type");
        }
    }
    /**
     * Restores a wallet from an encrypted serialization.
     *
     * This is an advanced alternative to calling `deserialize(serialization, password)` directly, which allows
     * you to offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF configuration. This can be
     * done using `extractKdfConfiguration(serialization)` and `executeKdf(password, kdfConfiguration)` from this package.
     */ static async deserializeWithEncryptionKey(serialization, encryptionKey) {
        const root = JSON.parse(serialization);
        if (!(0, $F6P8J.isNonNullObject)(root)) throw new Error("Root document is not an object.");
        const untypedRoot = root;
        switch(untypedRoot.type){
            case $25f61b8ec8445a32$var$serializationTypeV1:
                {
                    const decryptedBytes = await (0, $338aaf6a7a996fc6$exports.decrypt)((0, $5zb9p.fromBase64)(untypedRoot.data), encryptionKey, untypedRoot.encryption);
                    const decryptedDocument = JSON.parse((0, $5zb9p.fromUtf8)(decryptedBytes));
                    const { mnemonic: mnemonic, accounts: accounts } = decryptedDocument;
                    (0, $F6P8J.assert)(typeof mnemonic === "string");
                    if (!Array.isArray(accounts)) throw new Error("Property 'accounts' is not an array");
                    if (!accounts.every((account)=>$25f61b8ec8445a32$var$isDerivationJson(account))) throw new Error("Account is not in the correct format.");
                    const firstPrefix = accounts[0].prefix;
                    if (!accounts.every(({ prefix: prefix })=>prefix === firstPrefix)) throw new Error("Accounts do not all have the same prefix");
                    const hdPaths = accounts.map(({ hdPath: hdPath })=>(0, $9Nqq4.stringToPath)(hdPath));
                    return $25f61b8ec8445a32$var$DirectSecp256k1HdWallet.fromMnemonic(mnemonic, {
                        hdPaths: hdPaths,
                        prefix: firstPrefix
                    });
                }
            default:
                throw new Error("Unsupported serialization type");
        }
    }
    static async deserializeTypeV1(serialization, password) {
        const root = JSON.parse(serialization);
        if (!(0, $F6P8J.isNonNullObject)(root)) throw new Error("Root document is not an object.");
        const encryptionKey = await (0, $338aaf6a7a996fc6$exports.executeKdf)(password, root.kdf);
        return $25f61b8ec8445a32$var$DirectSecp256k1HdWallet.deserializeWithEncryptionKey(serialization, encryptionKey);
    }
    get mnemonic() {
        return this.secret.toString();
    }
    async getAccounts() {
        const accountsWithPrivkeys = await this.getAccountsWithPrivkeys();
        return accountsWithPrivkeys.map(({ algo: algo, pubkey: pubkey, address: address })=>({
                algo: algo,
                pubkey: pubkey,
                address: address
            }));
    }
    async signDirect(signerAddress, signDoc) {
        const accounts = await this.getAccountsWithPrivkeys();
        const account = accounts.find(({ address: address })=>address === signerAddress);
        if (account === undefined) throw new Error(`Address ${signerAddress} not found in wallet`);
        const { privkey: privkey, pubkey: pubkey } = account;
        const signBytes = (0, $5b82a40661cae0d6$exports.makeSignBytes)(signDoc);
        const hashedMessage = (0, $9Nqq4.sha256)(signBytes);
        const signature = await $9Nqq4.Secp256k1.createSignature(hashedMessage, privkey);
        const signatureBytes = new Uint8Array([
            ...signature.r(32),
            ...signature.s(32)
        ]);
        const stdSignature = (0, $111142153d5adf1c$exports.encodeSecp256k1Signature)(pubkey, signatureBytes);
        return {
            signed: signDoc,
            signature: stdSignature
        };
    }
    /**
     * Generates an encrypted serialization of this wallet.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */ async serialize(password) {
        const kdfConfiguration = $25f61b8ec8445a32$var$basicPasswordHashingOptions;
        const encryptionKey = await (0, $338aaf6a7a996fc6$exports.executeKdf)(password, kdfConfiguration);
        return this.serializeWithEncryptionKey(encryptionKey, kdfConfiguration);
    }
    /**
     * Generates an encrypted serialization of this wallet.
     *
     * This is an advanced alternative to calling `serialize(password)` directly, which allows you to
     * offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF options. If this
     * is not the case, the wallet cannot be restored with the original password.
     */ async serializeWithEncryptionKey(encryptionKey, kdfConfiguration) {
        const dataToEncrypt = {
            mnemonic: this.mnemonic,
            accounts: this.accounts.map(({ hdPath: hdPath, prefix: prefix })=>({
                    hdPath: (0, $9Nqq4.pathToString)(hdPath),
                    prefix: prefix
                }))
        };
        const dataToEncryptRaw = (0, $5zb9p.toUtf8)(JSON.stringify(dataToEncrypt));
        const encryptionConfiguration = {
            algorithm: $338aaf6a7a996fc6$exports.supportedAlgorithms.xchacha20poly1305Ietf
        };
        const encryptedData = await (0, $338aaf6a7a996fc6$exports.encrypt)(dataToEncryptRaw, encryptionKey, encryptionConfiguration);
        const out = {
            type: $25f61b8ec8445a32$var$serializationTypeV1,
            kdf: kdfConfiguration,
            encryption: encryptionConfiguration,
            data: (0, $5zb9p.toBase64)(encryptedData)
        };
        return JSON.stringify(out);
    }
    async getKeyPair(hdPath) {
        const { privkey: privkey } = $9Nqq4.Slip10.derivePath($9Nqq4.Slip10Curve.Secp256k1, this.seed, hdPath);
        const { pubkey: pubkey } = await $9Nqq4.Secp256k1.makeKeypair(privkey);
        return {
            privkey: privkey,
            pubkey: $9Nqq4.Secp256k1.compressPubkey(pubkey)
        };
    }
    async getAccountsWithPrivkeys() {
        return Promise.all(this.accounts.map(async ({ hdPath: hdPath, prefix: prefix })=>{
            const { privkey: privkey, pubkey: pubkey } = await this.getKeyPair(hdPath);
            const address = (0, $5zb9p.toBech32)(prefix, (0, $111142153d5adf1c$exports.rawSecp256k1PubkeyToRawAddress)(pubkey));
            return {
                algo: "secp256k1",
                privkey: privkey,
                pubkey: pubkey,
                address: address
            };
        }));
    }
    constructor(mnemonic, options){
        var _a, _b;
        const prefix = (_a = options.prefix) !== null && _a !== void 0 ? _a : $25f61b8ec8445a32$var$defaultOptions.prefix;
        const hdPaths = (_b = options.hdPaths) !== null && _b !== void 0 ? _b : $25f61b8ec8445a32$var$defaultOptions.hdPaths;
        this.secret = mnemonic;
        this.seed = options.seed;
        this.accounts = hdPaths.map((hdPath)=>({
                hdPath: hdPath,
                prefix: prefix
            }));
    }
}
$25f61b8ec8445a32$exports.DirectSecp256k1HdWallet = $25f61b8ec8445a32$var$DirectSecp256k1HdWallet;


Object.defineProperty($eb9a28d0d0241b06$exports, "DirectSecp256k1HdWallet", {
    enumerable: true,
    get: function() {
        return $25f61b8ec8445a32$exports.DirectSecp256k1HdWallet;
    }
});
Object.defineProperty($eb9a28d0d0241b06$exports, "extractKdfConfiguration", {
    enumerable: true,
    get: function() {
        return $25f61b8ec8445a32$exports.extractKdfConfiguration;
    }
});
var $0b925385fe10b436$exports = {};
"use strict";
Object.defineProperty($0b925385fe10b436$exports, "__esModule", {
    value: true
});
$0b925385fe10b436$exports.DirectSecp256k1Wallet = void 0;


var $9Nqq4 = parcelRequire("9Nqq4");

var $5zb9p = parcelRequire("5zb9p");

/**
 * A wallet that holds a single secp256k1 keypair.
 *
 * If you want to work with BIP39 mnemonics and multiple accounts, use DirectSecp256k1HdWallet.
 */ class $0b925385fe10b436$var$DirectSecp256k1Wallet {
    /**
     * Creates a DirectSecp256k1Wallet from the given private key
     *
     * @param privkey The private key.
     * @param prefix The bech32 address prefix (human readable part). Defaults to "cosmos".
     */ static async fromKey(privkey, prefix = "cosmos") {
        const uncompressed = (await $9Nqq4.Secp256k1.makeKeypair(privkey)).pubkey;
        return new $0b925385fe10b436$var$DirectSecp256k1Wallet(privkey, $9Nqq4.Secp256k1.compressPubkey(uncompressed), prefix);
    }
    get address() {
        return (0, $5zb9p.toBech32)(this.prefix, (0, $111142153d5adf1c$exports.rawSecp256k1PubkeyToRawAddress)(this.pubkey));
    }
    async getAccounts() {
        return [
            {
                algo: "secp256k1",
                address: this.address,
                pubkey: this.pubkey
            }
        ];
    }
    async signDirect(address, signDoc) {
        const signBytes = (0, $5b82a40661cae0d6$exports.makeSignBytes)(signDoc);
        if (address !== this.address) throw new Error(`Address ${address} not found in wallet`);
        const hashedMessage = (0, $9Nqq4.sha256)(signBytes);
        const signature = await $9Nqq4.Secp256k1.createSignature(hashedMessage, this.privkey);
        const signatureBytes = new Uint8Array([
            ...signature.r(32),
            ...signature.s(32)
        ]);
        const stdSignature = (0, $111142153d5adf1c$exports.encodeSecp256k1Signature)(this.pubkey, signatureBytes);
        return {
            signed: signDoc,
            signature: stdSignature
        };
    }
    constructor(privkey, pubkey, prefix){
        this.privkey = privkey;
        this.pubkey = pubkey;
        this.prefix = prefix;
    }
}
$0b925385fe10b436$exports.DirectSecp256k1Wallet = $0b925385fe10b436$var$DirectSecp256k1Wallet;


Object.defineProperty($eb9a28d0d0241b06$exports, "DirectSecp256k1Wallet", {
    enumerable: true,
    get: function() {
        return $0b925385fe10b436$exports.DirectSecp256k1Wallet;
    }
});
var $c3dc491c46438c66$exports = {};
"use strict";
Object.defineProperty($c3dc491c46438c66$exports, "__esModule", {
    value: true
});
$c3dc491c46438c66$exports.makeCosmoshubPath = void 0;

var $9Nqq4 = parcelRequire("9Nqq4");
/**
 * The Cosmos Hub derivation path in the form `m/44'/118'/0'/0/a`
 * with 0-based account index `a`.
 */ function $c3dc491c46438c66$var$makeCosmoshubPath(a) {
    return [
        $9Nqq4.Slip10RawIndex.hardened(44),
        $9Nqq4.Slip10RawIndex.hardened(118),
        $9Nqq4.Slip10RawIndex.hardened(0),
        $9Nqq4.Slip10RawIndex.normal(0),
        $9Nqq4.Slip10RawIndex.normal(a)
    ];
}
$c3dc491c46438c66$exports.makeCosmoshubPath = $c3dc491c46438c66$var$makeCosmoshubPath;


Object.defineProperty($eb9a28d0d0241b06$exports, "makeCosmoshubPath", {
    enumerable: true,
    get: function() {
        return $c3dc491c46438c66$exports.makeCosmoshubPath;
    }
});
var $8d86c467dea0b004$exports = {};
"use strict";
Object.defineProperty($8d86c467dea0b004$exports, "__esModule", {
    value: true
});
$8d86c467dea0b004$exports.decodePubkey = $8d86c467dea0b004$exports.encodePubkey = void 0;


var $5zb9p = parcelRequire("5zb9p");

var $9YIif = parcelRequire("9YIif");
var $7d0e0411c103f9ac$exports = {};
"use strict";
var $7d0e0411c103f9ac$var$__importDefault = $7d0e0411c103f9ac$exports && $7d0e0411c103f9ac$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($7d0e0411c103f9ac$exports, "__esModule", {
    value: true
});
$7d0e0411c103f9ac$exports.LegacyAminoPubKey = $7d0e0411c103f9ac$exports.protobufPackage = void 0;

/* eslint-disable */ const $7d0e0411c103f9ac$var$long_1 = $7d0e0411c103f9ac$var$__importDefault((parcelRequire("9A55m")));

const $7d0e0411c103f9ac$var$minimal_1 = $7d0e0411c103f9ac$var$__importDefault((parcelRequire("i2pIU")));

$7d0e0411c103f9ac$exports.protobufPackage = "cosmos.crypto.multisig";
const $7d0e0411c103f9ac$var$baseLegacyAminoPubKey = {
    threshold: 0
};
$7d0e0411c103f9ac$exports.LegacyAminoPubKey = {
    encode (message, writer = $7d0e0411c103f9ac$var$minimal_1.default.Writer.create()) {
        if (message.threshold !== 0) writer.uint32(8).uint32(message.threshold);
        for (const v of message.publicKeys)$4232fce010c3a46b$exports.Any.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7d0e0411c103f9ac$var$minimal_1.default.Reader ? input : new $7d0e0411c103f9ac$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $7d0e0411c103f9ac$var$baseLegacyAminoPubKey);
        message.publicKeys = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.threshold = reader.uint32();
                    break;
                case 2:
                    message.publicKeys.push($4232fce010c3a46b$exports.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $7d0e0411c103f9ac$var$baseLegacyAminoPubKey);
        message.threshold = object.threshold !== undefined && object.threshold !== null ? Number(object.threshold) : 0;
        message.publicKeys = ((_a = object.publicKeys) !== null && _a !== void 0 ? _a : []).map((e)=>$4232fce010c3a46b$exports.Any.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.threshold !== undefined && (obj.threshold = message.threshold);
        if (message.publicKeys) obj.publicKeys = message.publicKeys.map((e)=>e ? $4232fce010c3a46b$exports.Any.toJSON(e) : undefined);
        else obj.publicKeys = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $7d0e0411c103f9ac$var$baseLegacyAminoPubKey);
        message.threshold = (_a = object.threshold) !== null && _a !== void 0 ? _a : 0;
        message.publicKeys = ((_b = object.publicKeys) === null || _b === void 0 ? void 0 : _b.map((e)=>$4232fce010c3a46b$exports.Any.fromPartial(e))) || [];
        return message;
    }
};
if ($7d0e0411c103f9ac$var$minimal_1.default.util.Long !== $7d0e0411c103f9ac$var$long_1.default) {
    $7d0e0411c103f9ac$var$minimal_1.default.util.Long = $7d0e0411c103f9ac$var$long_1.default;
    $7d0e0411c103f9ac$var$minimal_1.default.configure();
}


var $25ad8429c4974c2b$exports = {};
"use strict";
var $25ad8429c4974c2b$var$__importDefault = $25ad8429c4974c2b$exports && $25ad8429c4974c2b$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($25ad8429c4974c2b$exports, "__esModule", {
    value: true
});
$25ad8429c4974c2b$exports.PrivKey = $25ad8429c4974c2b$exports.PubKey = $25ad8429c4974c2b$exports.protobufPackage = void 0;

/* eslint-disable */ const $25ad8429c4974c2b$var$long_1 = $25ad8429c4974c2b$var$__importDefault((parcelRequire("9A55m")));

const $25ad8429c4974c2b$var$minimal_1 = $25ad8429c4974c2b$var$__importDefault((parcelRequire("i2pIU")));
$25ad8429c4974c2b$exports.protobufPackage = "cosmos.crypto.secp256k1";
const $25ad8429c4974c2b$var$basePubKey = {};
$25ad8429c4974c2b$exports.PubKey = {
    encode (message, writer = $25ad8429c4974c2b$var$minimal_1.default.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $25ad8429c4974c2b$var$minimal_1.default.Reader ? input : new $25ad8429c4974c2b$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $25ad8429c4974c2b$var$basePubKey);
        message.key = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $25ad8429c4974c2b$var$basePubKey);
        message.key = object.key !== undefined && object.key !== null ? $25ad8429c4974c2b$var$bytesFromBase64(object.key) : new Uint8Array();
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = $25ad8429c4974c2b$var$base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $25ad8429c4974c2b$var$basePubKey);
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : new Uint8Array();
        return message;
    }
};
const $25ad8429c4974c2b$var$basePrivKey = {};
$25ad8429c4974c2b$exports.PrivKey = {
    encode (message, writer = $25ad8429c4974c2b$var$minimal_1.default.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $25ad8429c4974c2b$var$minimal_1.default.Reader ? input : new $25ad8429c4974c2b$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $25ad8429c4974c2b$var$basePrivKey);
        message.key = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $25ad8429c4974c2b$var$basePrivKey);
        message.key = object.key !== undefined && object.key !== null ? $25ad8429c4974c2b$var$bytesFromBase64(object.key) : new Uint8Array();
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = $25ad8429c4974c2b$var$base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $25ad8429c4974c2b$var$basePrivKey);
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : new Uint8Array();
        return message;
    }
};
var $25ad8429c4974c2b$var$globalThis = (()=>{
    if (typeof $25ad8429c4974c2b$var$globalThis !== "undefined") return $25ad8429c4974c2b$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $25ad8429c4974c2b$var$atob = $25ad8429c4974c2b$var$globalThis.atob || ((b64)=>$25ad8429c4974c2b$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $25ad8429c4974c2b$var$bytesFromBase64(b64) {
    const bin = $25ad8429c4974c2b$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $25ad8429c4974c2b$var$btoa = $25ad8429c4974c2b$var$globalThis.btoa || ((bin)=>$25ad8429c4974c2b$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $25ad8429c4974c2b$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $25ad8429c4974c2b$var$btoa(bin.join(""));
}
if ($25ad8429c4974c2b$var$minimal_1.default.util.Long !== $25ad8429c4974c2b$var$long_1.default) {
    $25ad8429c4974c2b$var$minimal_1.default.util.Long = $25ad8429c4974c2b$var$long_1.default;
    $25ad8429c4974c2b$var$minimal_1.default.configure();
}



function $8d86c467dea0b004$var$encodePubkey(pubkey) {
    if ((0, $111142153d5adf1c$exports.isSecp256k1Pubkey)(pubkey)) {
        const pubkeyProto = $25ad8429c4974c2b$exports.PubKey.fromPartial({
            key: (0, $5zb9p.fromBase64)(pubkey.value)
        });
        return $4232fce010c3a46b$exports.Any.fromPartial({
            typeUrl: "/cosmos.crypto.secp256k1.PubKey",
            value: Uint8Array.from($25ad8429c4974c2b$exports.PubKey.encode(pubkeyProto).finish())
        });
    } else if ((0, $111142153d5adf1c$exports.isMultisigThresholdPubkey)(pubkey)) {
        const pubkeyProto = $7d0e0411c103f9ac$exports.LegacyAminoPubKey.fromPartial({
            threshold: $9YIif.Uint53.fromString(pubkey.value.threshold).toNumber(),
            publicKeys: pubkey.value.pubkeys.map($8d86c467dea0b004$var$encodePubkey)
        });
        return $4232fce010c3a46b$exports.Any.fromPartial({
            typeUrl: "/cosmos.crypto.multisig.LegacyAminoPubKey",
            value: Uint8Array.from($7d0e0411c103f9ac$exports.LegacyAminoPubKey.encode(pubkeyProto).finish())
        });
    } else throw new Error(`Pubkey type ${pubkey.type} not recognized`);
}
$8d86c467dea0b004$exports.encodePubkey = $8d86c467dea0b004$var$encodePubkey;
function $8d86c467dea0b004$var$decodeSinglePubkey(pubkey) {
    switch(pubkey.typeUrl){
        case "/cosmos.crypto.secp256k1.PubKey":
            {
                const { key: key } = $25ad8429c4974c2b$exports.PubKey.decode(pubkey.value);
                return (0, $111142153d5adf1c$exports.encodeSecp256k1Pubkey)(key);
            }
        default:
            throw new Error(`Pubkey type_url ${pubkey.typeUrl} not recognized as single public key type`);
    }
}
function $8d86c467dea0b004$var$decodePubkey(pubkey) {
    if (!pubkey || !pubkey.value) return null;
    switch(pubkey.typeUrl){
        case "/cosmos.crypto.secp256k1.PubKey":
            return $8d86c467dea0b004$var$decodeSinglePubkey(pubkey);
        case "/cosmos.crypto.multisig.LegacyAminoPubKey":
            {
                const { threshold: threshold, publicKeys: publicKeys } = $7d0e0411c103f9ac$exports.LegacyAminoPubKey.decode(pubkey.value);
                const out = {
                    type: "tendermint/PubKeyMultisigThreshold",
                    value: {
                        threshold: threshold.toString(),
                        pubkeys: publicKeys.map($8d86c467dea0b004$var$decodeSinglePubkey)
                    }
                };
                return out;
            }
        default:
            throw new Error(`Pubkey type_url ${pubkey.typeUrl} not recognized`);
    }
}
$8d86c467dea0b004$exports.decodePubkey = $8d86c467dea0b004$var$decodePubkey;


Object.defineProperty($eb9a28d0d0241b06$exports, "decodePubkey", {
    enumerable: true,
    get: function() {
        return $8d86c467dea0b004$exports.decodePubkey;
    }
});
Object.defineProperty($eb9a28d0d0241b06$exports, "encodePubkey", {
    enumerable: true,
    get: function() {
        return $8d86c467dea0b004$exports.encodePubkey;
    }
});
var $3986dd6abfedb6cf$exports = {};

var $gzLuY = parcelRequire("gzLuY");
var $3986dd6abfedb6cf$require$Buffer = $gzLuY.Buffer;
"use strict";
Object.defineProperty($3986dd6abfedb6cf$exports, "__esModule", {
    value: true
});
$3986dd6abfedb6cf$exports.Registry = $3986dd6abfedb6cf$exports.isTxBodyEncodeObject = $3986dd6abfedb6cf$exports.isPbjsGeneratedType = $3986dd6abfedb6cf$exports.isTsProtoGeneratedType = void 0;
var $d1741032746595ab$exports = {};
"use strict";
var $d1741032746595ab$var$__importDefault = $d1741032746595ab$exports && $d1741032746595ab$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($d1741032746595ab$exports, "__esModule", {
    value: true
});
$d1741032746595ab$exports.MsgClientImpl = $d1741032746595ab$exports.MsgMultiSendResponse = $d1741032746595ab$exports.MsgMultiSend = $d1741032746595ab$exports.MsgSendResponse = $d1741032746595ab$exports.MsgSend = $d1741032746595ab$exports.protobufPackage = void 0;

/* eslint-disable */ const $d1741032746595ab$var$long_1 = $d1741032746595ab$var$__importDefault((parcelRequire("9A55m")));

const $d1741032746595ab$var$minimal_1 = $d1741032746595ab$var$__importDefault((parcelRequire("i2pIU")));

var $f72b6892583c91bd$exports = {};
"use strict";
var $f72b6892583c91bd$var$__importDefault = $f72b6892583c91bd$exports && $f72b6892583c91bd$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($f72b6892583c91bd$exports, "__esModule", {
    value: true
});
$f72b6892583c91bd$exports.Metadata = $f72b6892583c91bd$exports.DenomUnit = $f72b6892583c91bd$exports.Supply = $f72b6892583c91bd$exports.Output = $f72b6892583c91bd$exports.Input = $f72b6892583c91bd$exports.SendEnabled = $f72b6892583c91bd$exports.Params = $f72b6892583c91bd$exports.protobufPackage = void 0;

/* eslint-disable */ const $f72b6892583c91bd$var$long_1 = $f72b6892583c91bd$var$__importDefault((parcelRequire("9A55m")));

const $f72b6892583c91bd$var$minimal_1 = $f72b6892583c91bd$var$__importDefault((parcelRequire("i2pIU")));

$f72b6892583c91bd$exports.protobufPackage = "cosmos.bank.v1beta1";
const $f72b6892583c91bd$var$baseParams = {
    defaultSendEnabled: false
};
$f72b6892583c91bd$exports.Params = {
    encode (message, writer = $f72b6892583c91bd$var$minimal_1.default.Writer.create()) {
        for (const v of message.sendEnabled)$f72b6892583c91bd$exports.SendEnabled.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.defaultSendEnabled === true) writer.uint32(16).bool(message.defaultSendEnabled);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f72b6892583c91bd$var$minimal_1.default.Reader ? input : new $f72b6892583c91bd$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $f72b6892583c91bd$var$baseParams);
        message.sendEnabled = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sendEnabled.push($f72b6892583c91bd$exports.SendEnabled.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.defaultSendEnabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $f72b6892583c91bd$var$baseParams);
        message.sendEnabled = ((_a = object.sendEnabled) !== null && _a !== void 0 ? _a : []).map((e)=>$f72b6892583c91bd$exports.SendEnabled.fromJSON(e));
        message.defaultSendEnabled = object.defaultSendEnabled !== undefined && object.defaultSendEnabled !== null ? Boolean(object.defaultSendEnabled) : false;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.sendEnabled) obj.sendEnabled = message.sendEnabled.map((e)=>e ? $f72b6892583c91bd$exports.SendEnabled.toJSON(e) : undefined);
        else obj.sendEnabled = [];
        message.defaultSendEnabled !== undefined && (obj.defaultSendEnabled = message.defaultSendEnabled);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $f72b6892583c91bd$var$baseParams);
        message.sendEnabled = ((_a = object.sendEnabled) === null || _a === void 0 ? void 0 : _a.map((e)=>$f72b6892583c91bd$exports.SendEnabled.fromPartial(e))) || [];
        message.defaultSendEnabled = (_b = object.defaultSendEnabled) !== null && _b !== void 0 ? _b : false;
        return message;
    }
};
const $f72b6892583c91bd$var$baseSendEnabled = {
    denom: "",
    enabled: false
};
$f72b6892583c91bd$exports.SendEnabled = {
    encode (message, writer = $f72b6892583c91bd$var$minimal_1.default.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.enabled === true) writer.uint32(16).bool(message.enabled);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f72b6892583c91bd$var$minimal_1.default.Reader ? input : new $f72b6892583c91bd$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $f72b6892583c91bd$var$baseSendEnabled);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.enabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $f72b6892583c91bd$var$baseSendEnabled);
        message.denom = object.denom !== undefined && object.denom !== null ? String(object.denom) : "";
        message.enabled = object.enabled !== undefined && object.enabled !== null ? Boolean(object.enabled) : false;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.enabled !== undefined && (obj.enabled = message.enabled);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $f72b6892583c91bd$var$baseSendEnabled);
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        message.enabled = (_b = object.enabled) !== null && _b !== void 0 ? _b : false;
        return message;
    }
};
const $f72b6892583c91bd$var$baseInput = {
    address: ""
};
$f72b6892583c91bd$exports.Input = {
    encode (message, writer = $f72b6892583c91bd$var$minimal_1.default.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        for (const v of message.coins)$82ef09d1a8e2224d$exports.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f72b6892583c91bd$var$minimal_1.default.Reader ? input : new $f72b6892583c91bd$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $f72b6892583c91bd$var$baseInput);
        message.coins = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.coins.push($82ef09d1a8e2224d$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $f72b6892583c91bd$var$baseInput);
        message.address = object.address !== undefined && object.address !== null ? String(object.address) : "";
        message.coins = ((_a = object.coins) !== null && _a !== void 0 ? _a : []).map((e)=>$82ef09d1a8e2224d$exports.Coin.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        if (message.coins) obj.coins = message.coins.map((e)=>e ? $82ef09d1a8e2224d$exports.Coin.toJSON(e) : undefined);
        else obj.coins = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $f72b6892583c91bd$var$baseInput);
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        message.coins = ((_b = object.coins) === null || _b === void 0 ? void 0 : _b.map((e)=>$82ef09d1a8e2224d$exports.Coin.fromPartial(e))) || [];
        return message;
    }
};
const $f72b6892583c91bd$var$baseOutput = {
    address: ""
};
$f72b6892583c91bd$exports.Output = {
    encode (message, writer = $f72b6892583c91bd$var$minimal_1.default.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        for (const v of message.coins)$82ef09d1a8e2224d$exports.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f72b6892583c91bd$var$minimal_1.default.Reader ? input : new $f72b6892583c91bd$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $f72b6892583c91bd$var$baseOutput);
        message.coins = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.coins.push($82ef09d1a8e2224d$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $f72b6892583c91bd$var$baseOutput);
        message.address = object.address !== undefined && object.address !== null ? String(object.address) : "";
        message.coins = ((_a = object.coins) !== null && _a !== void 0 ? _a : []).map((e)=>$82ef09d1a8e2224d$exports.Coin.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        if (message.coins) obj.coins = message.coins.map((e)=>e ? $82ef09d1a8e2224d$exports.Coin.toJSON(e) : undefined);
        else obj.coins = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $f72b6892583c91bd$var$baseOutput);
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        message.coins = ((_b = object.coins) === null || _b === void 0 ? void 0 : _b.map((e)=>$82ef09d1a8e2224d$exports.Coin.fromPartial(e))) || [];
        return message;
    }
};
const $f72b6892583c91bd$var$baseSupply = {};
$f72b6892583c91bd$exports.Supply = {
    encode (message, writer = $f72b6892583c91bd$var$minimal_1.default.Writer.create()) {
        for (const v of message.total)$82ef09d1a8e2224d$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f72b6892583c91bd$var$minimal_1.default.Reader ? input : new $f72b6892583c91bd$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $f72b6892583c91bd$var$baseSupply);
        message.total = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.total.push($82ef09d1a8e2224d$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $f72b6892583c91bd$var$baseSupply);
        message.total = ((_a = object.total) !== null && _a !== void 0 ? _a : []).map((e)=>$82ef09d1a8e2224d$exports.Coin.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.total) obj.total = message.total.map((e)=>e ? $82ef09d1a8e2224d$exports.Coin.toJSON(e) : undefined);
        else obj.total = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $f72b6892583c91bd$var$baseSupply);
        message.total = ((_a = object.total) === null || _a === void 0 ? void 0 : _a.map((e)=>$82ef09d1a8e2224d$exports.Coin.fromPartial(e))) || [];
        return message;
    }
};
const $f72b6892583c91bd$var$baseDenomUnit = {
    denom: "",
    exponent: 0,
    aliases: ""
};
$f72b6892583c91bd$exports.DenomUnit = {
    encode (message, writer = $f72b6892583c91bd$var$minimal_1.default.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.exponent !== 0) writer.uint32(16).uint32(message.exponent);
        for (const v of message.aliases)writer.uint32(26).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f72b6892583c91bd$var$minimal_1.default.Reader ? input : new $f72b6892583c91bd$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $f72b6892583c91bd$var$baseDenomUnit);
        message.aliases = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.exponent = reader.uint32();
                    break;
                case 3:
                    message.aliases.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $f72b6892583c91bd$var$baseDenomUnit);
        message.denom = object.denom !== undefined && object.denom !== null ? String(object.denom) : "";
        message.exponent = object.exponent !== undefined && object.exponent !== null ? Number(object.exponent) : 0;
        message.aliases = ((_a = object.aliases) !== null && _a !== void 0 ? _a : []).map((e)=>String(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.exponent !== undefined && (obj.exponent = message.exponent);
        if (message.aliases) obj.aliases = message.aliases.map((e)=>e);
        else obj.aliases = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $f72b6892583c91bd$var$baseDenomUnit);
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        message.exponent = (_b = object.exponent) !== null && _b !== void 0 ? _b : 0;
        message.aliases = ((_c = object.aliases) === null || _c === void 0 ? void 0 : _c.map((e)=>e)) || [];
        return message;
    }
};
const $f72b6892583c91bd$var$baseMetadata = {
    description: "",
    base: "",
    display: "",
    name: "",
    symbol: ""
};
$f72b6892583c91bd$exports.Metadata = {
    encode (message, writer = $f72b6892583c91bd$var$minimal_1.default.Writer.create()) {
        if (message.description !== "") writer.uint32(10).string(message.description);
        for (const v of message.denomUnits)$f72b6892583c91bd$exports.DenomUnit.encode(v, writer.uint32(18).fork()).ldelim();
        if (message.base !== "") writer.uint32(26).string(message.base);
        if (message.display !== "") writer.uint32(34).string(message.display);
        if (message.name !== "") writer.uint32(42).string(message.name);
        if (message.symbol !== "") writer.uint32(50).string(message.symbol);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f72b6892583c91bd$var$minimal_1.default.Reader ? input : new $f72b6892583c91bd$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $f72b6892583c91bd$var$baseMetadata);
        message.denomUnits = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.description = reader.string();
                    break;
                case 2:
                    message.denomUnits.push($f72b6892583c91bd$exports.DenomUnit.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.base = reader.string();
                    break;
                case 4:
                    message.display = reader.string();
                    break;
                case 5:
                    message.name = reader.string();
                    break;
                case 6:
                    message.symbol = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $f72b6892583c91bd$var$baseMetadata);
        message.description = object.description !== undefined && object.description !== null ? String(object.description) : "";
        message.denomUnits = ((_a = object.denomUnits) !== null && _a !== void 0 ? _a : []).map((e)=>$f72b6892583c91bd$exports.DenomUnit.fromJSON(e));
        message.base = object.base !== undefined && object.base !== null ? String(object.base) : "";
        message.display = object.display !== undefined && object.display !== null ? String(object.display) : "";
        message.name = object.name !== undefined && object.name !== null ? String(object.name) : "";
        message.symbol = object.symbol !== undefined && object.symbol !== null ? String(object.symbol) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.description !== undefined && (obj.description = message.description);
        if (message.denomUnits) obj.denomUnits = message.denomUnits.map((e)=>e ? $f72b6892583c91bd$exports.DenomUnit.toJSON(e) : undefined);
        else obj.denomUnits = [];
        message.base !== undefined && (obj.base = message.base);
        message.display !== undefined && (obj.display = message.display);
        message.name !== undefined && (obj.name = message.name);
        message.symbol !== undefined && (obj.symbol = message.symbol);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e, _f;
        const message = Object.assign({}, $f72b6892583c91bd$var$baseMetadata);
        message.description = (_a = object.description) !== null && _a !== void 0 ? _a : "";
        message.denomUnits = ((_b = object.denomUnits) === null || _b === void 0 ? void 0 : _b.map((e)=>$f72b6892583c91bd$exports.DenomUnit.fromPartial(e))) || [];
        message.base = (_c = object.base) !== null && _c !== void 0 ? _c : "";
        message.display = (_d = object.display) !== null && _d !== void 0 ? _d : "";
        message.name = (_e = object.name) !== null && _e !== void 0 ? _e : "";
        message.symbol = (_f = object.symbol) !== null && _f !== void 0 ? _f : "";
        return message;
    }
};
if ($f72b6892583c91bd$var$minimal_1.default.util.Long !== $f72b6892583c91bd$var$long_1.default) {
    $f72b6892583c91bd$var$minimal_1.default.util.Long = $f72b6892583c91bd$var$long_1.default;
    $f72b6892583c91bd$var$minimal_1.default.configure();
}


$d1741032746595ab$exports.protobufPackage = "cosmos.bank.v1beta1";
const $d1741032746595ab$var$baseMsgSend = {
    fromAddress: "",
    toAddress: ""
};
$d1741032746595ab$exports.MsgSend = {
    encode (message, writer = $d1741032746595ab$var$minimal_1.default.Writer.create()) {
        if (message.fromAddress !== "") writer.uint32(10).string(message.fromAddress);
        if (message.toAddress !== "") writer.uint32(18).string(message.toAddress);
        for (const v of message.amount)$82ef09d1a8e2224d$exports.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d1741032746595ab$var$minimal_1.default.Reader ? input : new $d1741032746595ab$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $d1741032746595ab$var$baseMsgSend);
        message.amount = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.fromAddress = reader.string();
                    break;
                case 2:
                    message.toAddress = reader.string();
                    break;
                case 3:
                    message.amount.push($82ef09d1a8e2224d$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $d1741032746595ab$var$baseMsgSend);
        message.fromAddress = object.fromAddress !== undefined && object.fromAddress !== null ? String(object.fromAddress) : "";
        message.toAddress = object.toAddress !== undefined && object.toAddress !== null ? String(object.toAddress) : "";
        message.amount = ((_a = object.amount) !== null && _a !== void 0 ? _a : []).map((e)=>$82ef09d1a8e2224d$exports.Coin.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.fromAddress !== undefined && (obj.fromAddress = message.fromAddress);
        message.toAddress !== undefined && (obj.toAddress = message.toAddress);
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $82ef09d1a8e2224d$exports.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $d1741032746595ab$var$baseMsgSend);
        message.fromAddress = (_a = object.fromAddress) !== null && _a !== void 0 ? _a : "";
        message.toAddress = (_b = object.toAddress) !== null && _b !== void 0 ? _b : "";
        message.amount = ((_c = object.amount) === null || _c === void 0 ? void 0 : _c.map((e)=>$82ef09d1a8e2224d$exports.Coin.fromPartial(e))) || [];
        return message;
    }
};
const $d1741032746595ab$var$baseMsgSendResponse = {};
$d1741032746595ab$exports.MsgSendResponse = {
    encode (_, writer = $d1741032746595ab$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d1741032746595ab$var$minimal_1.default.Reader ? input : new $d1741032746595ab$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $d1741032746595ab$var$baseMsgSendResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $d1741032746595ab$var$baseMsgSendResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $d1741032746595ab$var$baseMsgSendResponse);
        return message;
    }
};
const $d1741032746595ab$var$baseMsgMultiSend = {};
$d1741032746595ab$exports.MsgMultiSend = {
    encode (message, writer = $d1741032746595ab$var$minimal_1.default.Writer.create()) {
        for (const v of message.inputs)$f72b6892583c91bd$exports.Input.encode(v, writer.uint32(10).fork()).ldelim();
        for (const v of message.outputs)$f72b6892583c91bd$exports.Output.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d1741032746595ab$var$minimal_1.default.Reader ? input : new $d1741032746595ab$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $d1741032746595ab$var$baseMsgMultiSend);
        message.inputs = [];
        message.outputs = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.inputs.push($f72b6892583c91bd$exports.Input.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.outputs.push($f72b6892583c91bd$exports.Output.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a, _b;
        const message = Object.assign({}, $d1741032746595ab$var$baseMsgMultiSend);
        message.inputs = ((_a = object.inputs) !== null && _a !== void 0 ? _a : []).map((e)=>$f72b6892583c91bd$exports.Input.fromJSON(e));
        message.outputs = ((_b = object.outputs) !== null && _b !== void 0 ? _b : []).map((e)=>$f72b6892583c91bd$exports.Output.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.inputs) obj.inputs = message.inputs.map((e)=>e ? $f72b6892583c91bd$exports.Input.toJSON(e) : undefined);
        else obj.inputs = [];
        if (message.outputs) obj.outputs = message.outputs.map((e)=>e ? $f72b6892583c91bd$exports.Output.toJSON(e) : undefined);
        else obj.outputs = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $d1741032746595ab$var$baseMsgMultiSend);
        message.inputs = ((_a = object.inputs) === null || _a === void 0 ? void 0 : _a.map((e)=>$f72b6892583c91bd$exports.Input.fromPartial(e))) || [];
        message.outputs = ((_b = object.outputs) === null || _b === void 0 ? void 0 : _b.map((e)=>$f72b6892583c91bd$exports.Output.fromPartial(e))) || [];
        return message;
    }
};
const $d1741032746595ab$var$baseMsgMultiSendResponse = {};
$d1741032746595ab$exports.MsgMultiSendResponse = {
    encode (_, writer = $d1741032746595ab$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d1741032746595ab$var$minimal_1.default.Reader ? input : new $d1741032746595ab$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $d1741032746595ab$var$baseMsgMultiSendResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $d1741032746595ab$var$baseMsgMultiSendResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $d1741032746595ab$var$baseMsgMultiSendResponse);
        return message;
    }
};
class $d1741032746595ab$var$MsgClientImpl {
    Send(request) {
        const data = $d1741032746595ab$exports.MsgSend.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Msg", "Send", data);
        return promise.then((data)=>$d1741032746595ab$exports.MsgSendResponse.decode(new $d1741032746595ab$var$minimal_1.default.Reader(data)));
    }
    MultiSend(request) {
        const data = $d1741032746595ab$exports.MsgMultiSend.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Msg", "MultiSend", data);
        return promise.then((data)=>$d1741032746595ab$exports.MsgMultiSendResponse.decode(new $d1741032746595ab$var$minimal_1.default.Reader(data)));
    }
    constructor(rpc){
        this.rpc = rpc;
        this.Send = this.Send.bind(this);
        this.MultiSend = this.MultiSend.bind(this);
    }
}
$d1741032746595ab$exports.MsgClientImpl = $d1741032746595ab$var$MsgClientImpl;
if ($d1741032746595ab$var$minimal_1.default.util.Long !== $d1741032746595ab$var$long_1.default) {
    $d1741032746595ab$var$minimal_1.default.util.Long = $d1741032746595ab$var$long_1.default;
    $d1741032746595ab$var$minimal_1.default.configure();
}





function $3986dd6abfedb6cf$var$isTsProtoGeneratedType(type) {
    return typeof type.fromPartial === "function";
}
$3986dd6abfedb6cf$exports.isTsProtoGeneratedType = $3986dd6abfedb6cf$var$isTsProtoGeneratedType;
function $3986dd6abfedb6cf$var$isPbjsGeneratedType(type) {
    return !$3986dd6abfedb6cf$var$isTsProtoGeneratedType(type);
}
$3986dd6abfedb6cf$exports.isPbjsGeneratedType = $3986dd6abfedb6cf$var$isPbjsGeneratedType;
const $3986dd6abfedb6cf$var$defaultTypeUrls = {
    cosmosCoin: "/cosmos.base.v1beta1.Coin",
    cosmosMsgSend: "/cosmos.bank.v1beta1.MsgSend",
    cosmosTxBody: "/cosmos.tx.v1beta1.TxBody",
    googleAny: "/google.protobuf.Any"
};
function $3986dd6abfedb6cf$var$isTxBodyEncodeObject(encodeObject) {
    return encodeObject.typeUrl === "/cosmos.tx.v1beta1.TxBody";
}
$3986dd6abfedb6cf$exports.isTxBodyEncodeObject = $3986dd6abfedb6cf$var$isTxBodyEncodeObject;
class $3986dd6abfedb6cf$var$Registry {
    register(typeUrl, type) {
        this.types.set(typeUrl, type);
    }
    /**
     * Looks up a type that was previously added to the registry.
     *
     * The generator information (ts-proto or pbjs) gets lost along the way.
     * If you need to work with the result type in TypeScript, you can use:
     *
     * ```
     * import { assert } from "@cosmjs/utils";
     *
     * const Coin = registry.lookupType("/cosmos.base.v1beta1.Coin");
     * assert(Coin); // Ensures not unset
     * assert(isTsProtoGeneratedType(Coin)); // Ensures this is the type we expect
     *
     * // Coin is typed TsProtoGeneratedType now.
     * ```
     */ lookupType(typeUrl) {
        return this.types.get(typeUrl);
    }
    lookupTypeWithError(typeUrl) {
        const type = this.lookupType(typeUrl);
        if (!type) throw new Error(`Unregistered type url: ${typeUrl}`);
        return type;
    }
    /**
     * Takes a typeUrl/value pair and encodes the value to protobuf if
     * the given type was previously registered.
     *
     * If the value has to be wrapped in an Any, this needs to be done
     * manually after this call. Or use `encodeAsAny` instead.
     */ encode(encodeObject) {
        const { value: value, typeUrl: typeUrl } = encodeObject;
        if ($3986dd6abfedb6cf$var$isTxBodyEncodeObject(encodeObject)) return this.encodeTxBody(value);
        const type = this.lookupTypeWithError(typeUrl);
        const instance = $3986dd6abfedb6cf$var$isTsProtoGeneratedType(type) ? type.fromPartial(value) : type.create(value);
        return type.encode(instance).finish();
    }
    /**
     * Takes a typeUrl/value pair and encodes the value to an Any if
     * the given type was previously registered.
     */ encodeAsAny(encodeObject) {
        const binaryValue = this.encode(encodeObject);
        return $4232fce010c3a46b$exports.Any.fromPartial({
            typeUrl: encodeObject.typeUrl,
            value: binaryValue
        });
    }
    encodeTxBody(txBodyFields) {
        const wrappedMessages = txBodyFields.messages.map((message)=>this.encodeAsAny(message));
        const txBody = $07786b3434b3c544$exports.TxBody.fromPartial({
            ...txBodyFields,
            messages: wrappedMessages
        });
        return $07786b3434b3c544$exports.TxBody.encode(txBody).finish();
    }
    decode({ typeUrl: typeUrl, value: value }) {
        if (typeUrl === $3986dd6abfedb6cf$var$defaultTypeUrls.cosmosTxBody) return this.decodeTxBody(value);
        const type = this.lookupTypeWithError(typeUrl);
        const decoded = type.decode(value);
        Object.entries(decoded).forEach(([key, val])=>{
            if (typeof $3986dd6abfedb6cf$require$Buffer !== "undefined" && typeof $3986dd6abfedb6cf$require$Buffer.isBuffer !== "undefined" && $3986dd6abfedb6cf$require$Buffer.isBuffer(val)) decoded[key] = Uint8Array.from(val);
        });
        return decoded;
    }
    decodeTxBody(txBody) {
        const decodedTxBody = $07786b3434b3c544$exports.TxBody.decode(txBody);
        return {
            ...decodedTxBody,
            messages: decodedTxBody.messages.map(({ typeUrl: typeUrl, value: value })=>{
                if (!typeUrl) throw new Error("Missing type_url in Any");
                if (!value) throw new Error("Missing value in Any");
                return this.decode({
                    typeUrl: typeUrl,
                    value: value
                });
            })
        };
    }
    /**
     * Creates a new Registry for mapping protobuf type identifiers/type URLs to
     * actual implementations. Those implementations are typically generated with ts-proto
     * but we also support protobuf.js as a type generator.
     *
     * If there is no parameter given, a `new Registry()` adds the types `Coin` and `MsgSend`
     * for historic reasons. Those can be overriden by customTypes.
     *
     * There are currently two methods for adding new types:
     * 1. Passing types to the constructor.
     * 2. Using the `register()` method
     */ constructor(customTypes){
        const { cosmosCoin: cosmosCoin, cosmosMsgSend: cosmosMsgSend } = $3986dd6abfedb6cf$var$defaultTypeUrls;
        this.types = customTypes ? new Map([
            ...customTypes
        ]) : new Map([
            [
                cosmosCoin,
                $82ef09d1a8e2224d$exports.Coin
            ],
            [
                cosmosMsgSend,
                $d1741032746595ab$exports.MsgSend
            ]
        ]);
    }
}
$3986dd6abfedb6cf$exports.Registry = $3986dd6abfedb6cf$var$Registry;


Object.defineProperty($eb9a28d0d0241b06$exports, "isPbjsGeneratedType", {
    enumerable: true,
    get: function() {
        return $3986dd6abfedb6cf$exports.isPbjsGeneratedType;
    }
});
Object.defineProperty($eb9a28d0d0241b06$exports, "isTsProtoGeneratedType", {
    enumerable: true,
    get: function() {
        return $3986dd6abfedb6cf$exports.isTsProtoGeneratedType;
    }
});
Object.defineProperty($eb9a28d0d0241b06$exports, "isTxBodyEncodeObject", {
    enumerable: true,
    get: function() {
        return $3986dd6abfedb6cf$exports.isTxBodyEncodeObject;
    }
});
Object.defineProperty($eb9a28d0d0241b06$exports, "Registry", {
    enumerable: true,
    get: function() {
        return $3986dd6abfedb6cf$exports.Registry;
    }
});
var $63b39be7b5b8ebb4$exports = {};
"use strict";
Object.defineProperty($63b39be7b5b8ebb4$exports, "__esModule", {
    value: true
});
$63b39be7b5b8ebb4$exports.isOfflineDirectSigner = void 0;
function $63b39be7b5b8ebb4$var$isOfflineDirectSigner(signer) {
    return signer.signDirect !== undefined;
}
$63b39be7b5b8ebb4$exports.isOfflineDirectSigner = $63b39be7b5b8ebb4$var$isOfflineDirectSigner;


Object.defineProperty($eb9a28d0d0241b06$exports, "isOfflineDirectSigner", {
    enumerable: true,
    get: function() {
        return $63b39be7b5b8ebb4$exports.isOfflineDirectSigner;
    }
});

Object.defineProperty($eb9a28d0d0241b06$exports, "makeAuthInfoBytes", {
    enumerable: true,
    get: function() {
        return $5b82a40661cae0d6$exports.makeAuthInfoBytes;
    }
});
Object.defineProperty($eb9a28d0d0241b06$exports, "makeSignBytes", {
    enumerable: true,
    get: function() {
        return $5b82a40661cae0d6$exports.makeSignBytes;
    }
});
Object.defineProperty($eb9a28d0d0241b06$exports, "makeSignDoc", {
    enumerable: true,
    get: function() {
        return $5b82a40661cae0d6$exports.makeSignDoc;
    }
});

Object.defineProperty($eb9a28d0d0241b06$exports, "executeKdf", {
    enumerable: true,
    get: function() {
        return $338aaf6a7a996fc6$exports.executeKdf;
    }
});

Object.defineProperty($eb9a28d0d0241b06$exports, "coin", {
    enumerable: true,
    get: function() {
        return $111142153d5adf1c$exports.coin;
    }
});
Object.defineProperty($eb9a28d0d0241b06$exports, "coins", {
    enumerable: true,
    get: function() {
        return $111142153d5adf1c$exports.coins;
    }
});



var $F6P8J = parcelRequire("F6P8J");
var $fc581078c2d0cd59$exports = {};
"use strict";
var $fc581078c2d0cd59$var$__importDefault = $fc581078c2d0cd59$exports && $fc581078c2d0cd59$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($fc581078c2d0cd59$exports, "__esModule", {
    value: true
});
$fc581078c2d0cd59$exports.Params = $fc581078c2d0cd59$exports.ModuleAccount = $fc581078c2d0cd59$exports.BaseAccount = $fc581078c2d0cd59$exports.protobufPackage = void 0;

/* eslint-disable */ const $fc581078c2d0cd59$var$long_1 = $fc581078c2d0cd59$var$__importDefault((parcelRequire("9A55m")));

const $fc581078c2d0cd59$var$minimal_1 = $fc581078c2d0cd59$var$__importDefault((parcelRequire("i2pIU")));

$fc581078c2d0cd59$exports.protobufPackage = "cosmos.auth.v1beta1";
const $fc581078c2d0cd59$var$baseBaseAccount = {
    address: "",
    accountNumber: $fc581078c2d0cd59$var$long_1.default.UZERO,
    sequence: $fc581078c2d0cd59$var$long_1.default.UZERO
};
$fc581078c2d0cd59$exports.BaseAccount = {
    encode (message, writer = $fc581078c2d0cd59$var$minimal_1.default.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.pubKey !== undefined) $4232fce010c3a46b$exports.Any.encode(message.pubKey, writer.uint32(18).fork()).ldelim();
        if (!message.accountNumber.isZero()) writer.uint32(24).uint64(message.accountNumber);
        if (!message.sequence.isZero()) writer.uint32(32).uint64(message.sequence);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fc581078c2d0cd59$var$minimal_1.default.Reader ? input : new $fc581078c2d0cd59$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $fc581078c2d0cd59$var$baseBaseAccount);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.pubKey = $4232fce010c3a46b$exports.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.accountNumber = reader.uint64();
                    break;
                case 4:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $fc581078c2d0cd59$var$baseBaseAccount);
        message.address = object.address !== undefined && object.address !== null ? String(object.address) : "";
        message.pubKey = object.pubKey !== undefined && object.pubKey !== null ? $4232fce010c3a46b$exports.Any.fromJSON(object.pubKey) : undefined;
        message.accountNumber = object.accountNumber !== undefined && object.accountNumber !== null ? $fc581078c2d0cd59$var$long_1.default.fromString(object.accountNumber) : $fc581078c2d0cd59$var$long_1.default.UZERO;
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $fc581078c2d0cd59$var$long_1.default.fromString(object.sequence) : $fc581078c2d0cd59$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.pubKey !== undefined && (obj.pubKey = message.pubKey ? $4232fce010c3a46b$exports.Any.toJSON(message.pubKey) : undefined);
        message.accountNumber !== undefined && (obj.accountNumber = (message.accountNumber || $fc581078c2d0cd59$var$long_1.default.UZERO).toString());
        message.sequence !== undefined && (obj.sequence = (message.sequence || $fc581078c2d0cd59$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $fc581078c2d0cd59$var$baseBaseAccount);
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        message.pubKey = object.pubKey !== undefined && object.pubKey !== null ? $4232fce010c3a46b$exports.Any.fromPartial(object.pubKey) : undefined;
        message.accountNumber = object.accountNumber !== undefined && object.accountNumber !== null ? $fc581078c2d0cd59$var$long_1.default.fromValue(object.accountNumber) : $fc581078c2d0cd59$var$long_1.default.UZERO;
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $fc581078c2d0cd59$var$long_1.default.fromValue(object.sequence) : $fc581078c2d0cd59$var$long_1.default.UZERO;
        return message;
    }
};
const $fc581078c2d0cd59$var$baseModuleAccount = {
    name: "",
    permissions: ""
};
$fc581078c2d0cd59$exports.ModuleAccount = {
    encode (message, writer = $fc581078c2d0cd59$var$minimal_1.default.Writer.create()) {
        if (message.baseAccount !== undefined) $fc581078c2d0cd59$exports.BaseAccount.encode(message.baseAccount, writer.uint32(10).fork()).ldelim();
        if (message.name !== "") writer.uint32(18).string(message.name);
        for (const v of message.permissions)writer.uint32(26).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fc581078c2d0cd59$var$minimal_1.default.Reader ? input : new $fc581078c2d0cd59$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $fc581078c2d0cd59$var$baseModuleAccount);
        message.permissions = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.baseAccount = $fc581078c2d0cd59$exports.BaseAccount.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.name = reader.string();
                    break;
                case 3:
                    message.permissions.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $fc581078c2d0cd59$var$baseModuleAccount);
        message.baseAccount = object.baseAccount !== undefined && object.baseAccount !== null ? $fc581078c2d0cd59$exports.BaseAccount.fromJSON(object.baseAccount) : undefined;
        message.name = object.name !== undefined && object.name !== null ? String(object.name) : "";
        message.permissions = ((_a = object.permissions) !== null && _a !== void 0 ? _a : []).map((e)=>String(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.baseAccount !== undefined && (obj.baseAccount = message.baseAccount ? $fc581078c2d0cd59$exports.BaseAccount.toJSON(message.baseAccount) : undefined);
        message.name !== undefined && (obj.name = message.name);
        if (message.permissions) obj.permissions = message.permissions.map((e)=>e);
        else obj.permissions = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $fc581078c2d0cd59$var$baseModuleAccount);
        message.baseAccount = object.baseAccount !== undefined && object.baseAccount !== null ? $fc581078c2d0cd59$exports.BaseAccount.fromPartial(object.baseAccount) : undefined;
        message.name = (_a = object.name) !== null && _a !== void 0 ? _a : "";
        message.permissions = ((_b = object.permissions) === null || _b === void 0 ? void 0 : _b.map((e)=>e)) || [];
        return message;
    }
};
const $fc581078c2d0cd59$var$baseParams = {
    maxMemoCharacters: $fc581078c2d0cd59$var$long_1.default.UZERO,
    txSigLimit: $fc581078c2d0cd59$var$long_1.default.UZERO,
    txSizeCostPerByte: $fc581078c2d0cd59$var$long_1.default.UZERO,
    sigVerifyCostEd25519: $fc581078c2d0cd59$var$long_1.default.UZERO,
    sigVerifyCostSecp256k1: $fc581078c2d0cd59$var$long_1.default.UZERO
};
$fc581078c2d0cd59$exports.Params = {
    encode (message, writer = $fc581078c2d0cd59$var$minimal_1.default.Writer.create()) {
        if (!message.maxMemoCharacters.isZero()) writer.uint32(8).uint64(message.maxMemoCharacters);
        if (!message.txSigLimit.isZero()) writer.uint32(16).uint64(message.txSigLimit);
        if (!message.txSizeCostPerByte.isZero()) writer.uint32(24).uint64(message.txSizeCostPerByte);
        if (!message.sigVerifyCostEd25519.isZero()) writer.uint32(32).uint64(message.sigVerifyCostEd25519);
        if (!message.sigVerifyCostSecp256k1.isZero()) writer.uint32(40).uint64(message.sigVerifyCostSecp256k1);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fc581078c2d0cd59$var$minimal_1.default.Reader ? input : new $fc581078c2d0cd59$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $fc581078c2d0cd59$var$baseParams);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.maxMemoCharacters = reader.uint64();
                    break;
                case 2:
                    message.txSigLimit = reader.uint64();
                    break;
                case 3:
                    message.txSizeCostPerByte = reader.uint64();
                    break;
                case 4:
                    message.sigVerifyCostEd25519 = reader.uint64();
                    break;
                case 5:
                    message.sigVerifyCostSecp256k1 = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $fc581078c2d0cd59$var$baseParams);
        message.maxMemoCharacters = object.maxMemoCharacters !== undefined && object.maxMemoCharacters !== null ? $fc581078c2d0cd59$var$long_1.default.fromString(object.maxMemoCharacters) : $fc581078c2d0cd59$var$long_1.default.UZERO;
        message.txSigLimit = object.txSigLimit !== undefined && object.txSigLimit !== null ? $fc581078c2d0cd59$var$long_1.default.fromString(object.txSigLimit) : $fc581078c2d0cd59$var$long_1.default.UZERO;
        message.txSizeCostPerByte = object.txSizeCostPerByte !== undefined && object.txSizeCostPerByte !== null ? $fc581078c2d0cd59$var$long_1.default.fromString(object.txSizeCostPerByte) : $fc581078c2d0cd59$var$long_1.default.UZERO;
        message.sigVerifyCostEd25519 = object.sigVerifyCostEd25519 !== undefined && object.sigVerifyCostEd25519 !== null ? $fc581078c2d0cd59$var$long_1.default.fromString(object.sigVerifyCostEd25519) : $fc581078c2d0cd59$var$long_1.default.UZERO;
        message.sigVerifyCostSecp256k1 = object.sigVerifyCostSecp256k1 !== undefined && object.sigVerifyCostSecp256k1 !== null ? $fc581078c2d0cd59$var$long_1.default.fromString(object.sigVerifyCostSecp256k1) : $fc581078c2d0cd59$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.maxMemoCharacters !== undefined && (obj.maxMemoCharacters = (message.maxMemoCharacters || $fc581078c2d0cd59$var$long_1.default.UZERO).toString());
        message.txSigLimit !== undefined && (obj.txSigLimit = (message.txSigLimit || $fc581078c2d0cd59$var$long_1.default.UZERO).toString());
        message.txSizeCostPerByte !== undefined && (obj.txSizeCostPerByte = (message.txSizeCostPerByte || $fc581078c2d0cd59$var$long_1.default.UZERO).toString());
        message.sigVerifyCostEd25519 !== undefined && (obj.sigVerifyCostEd25519 = (message.sigVerifyCostEd25519 || $fc581078c2d0cd59$var$long_1.default.UZERO).toString());
        message.sigVerifyCostSecp256k1 !== undefined && (obj.sigVerifyCostSecp256k1 = (message.sigVerifyCostSecp256k1 || $fc581078c2d0cd59$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $fc581078c2d0cd59$var$baseParams);
        message.maxMemoCharacters = object.maxMemoCharacters !== undefined && object.maxMemoCharacters !== null ? $fc581078c2d0cd59$var$long_1.default.fromValue(object.maxMemoCharacters) : $fc581078c2d0cd59$var$long_1.default.UZERO;
        message.txSigLimit = object.txSigLimit !== undefined && object.txSigLimit !== null ? $fc581078c2d0cd59$var$long_1.default.fromValue(object.txSigLimit) : $fc581078c2d0cd59$var$long_1.default.UZERO;
        message.txSizeCostPerByte = object.txSizeCostPerByte !== undefined && object.txSizeCostPerByte !== null ? $fc581078c2d0cd59$var$long_1.default.fromValue(object.txSizeCostPerByte) : $fc581078c2d0cd59$var$long_1.default.UZERO;
        message.sigVerifyCostEd25519 = object.sigVerifyCostEd25519 !== undefined && object.sigVerifyCostEd25519 !== null ? $fc581078c2d0cd59$var$long_1.default.fromValue(object.sigVerifyCostEd25519) : $fc581078c2d0cd59$var$long_1.default.UZERO;
        message.sigVerifyCostSecp256k1 = object.sigVerifyCostSecp256k1 !== undefined && object.sigVerifyCostSecp256k1 !== null ? $fc581078c2d0cd59$var$long_1.default.fromValue(object.sigVerifyCostSecp256k1) : $fc581078c2d0cd59$var$long_1.default.UZERO;
        return message;
    }
};
if ($fc581078c2d0cd59$var$minimal_1.default.util.Long !== $fc581078c2d0cd59$var$long_1.default) {
    $fc581078c2d0cd59$var$minimal_1.default.util.Long = $fc581078c2d0cd59$var$long_1.default;
    $fc581078c2d0cd59$var$minimal_1.default.configure();
}


var $da9a33239166115f$exports = {};
"use strict";
var $da9a33239166115f$var$__importDefault = $da9a33239166115f$exports && $da9a33239166115f$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($da9a33239166115f$exports, "__esModule", {
    value: true
});
$da9a33239166115f$exports.PermanentLockedAccount = $da9a33239166115f$exports.PeriodicVestingAccount = $da9a33239166115f$exports.Period = $da9a33239166115f$exports.DelayedVestingAccount = $da9a33239166115f$exports.ContinuousVestingAccount = $da9a33239166115f$exports.BaseVestingAccount = $da9a33239166115f$exports.protobufPackage = void 0;

/* eslint-disable */ const $da9a33239166115f$var$long_1 = $da9a33239166115f$var$__importDefault((parcelRequire("9A55m")));

const $da9a33239166115f$var$minimal_1 = $da9a33239166115f$var$__importDefault((parcelRequire("i2pIU")));


$da9a33239166115f$exports.protobufPackage = "cosmos.vesting.v1beta1";
const $da9a33239166115f$var$baseBaseVestingAccount = {
    endTime: $da9a33239166115f$var$long_1.default.ZERO
};
$da9a33239166115f$exports.BaseVestingAccount = {
    encode (message, writer = $da9a33239166115f$var$minimal_1.default.Writer.create()) {
        if (message.baseAccount !== undefined) $fc581078c2d0cd59$exports.BaseAccount.encode(message.baseAccount, writer.uint32(10).fork()).ldelim();
        for (const v of message.originalVesting)$82ef09d1a8e2224d$exports.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        for (const v of message.delegatedFree)$82ef09d1a8e2224d$exports.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        for (const v of message.delegatedVesting)$82ef09d1a8e2224d$exports.Coin.encode(v, writer.uint32(34).fork()).ldelim();
        if (!message.endTime.isZero()) writer.uint32(40).int64(message.endTime);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $da9a33239166115f$var$minimal_1.default.Reader ? input : new $da9a33239166115f$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $da9a33239166115f$var$baseBaseVestingAccount);
        message.originalVesting = [];
        message.delegatedFree = [];
        message.delegatedVesting = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.baseAccount = $fc581078c2d0cd59$exports.BaseAccount.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.originalVesting.push($82ef09d1a8e2224d$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.delegatedFree.push($82ef09d1a8e2224d$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.delegatedVesting.push($82ef09d1a8e2224d$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.endTime = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $da9a33239166115f$var$baseBaseVestingAccount);
        message.baseAccount = object.baseAccount !== undefined && object.baseAccount !== null ? $fc581078c2d0cd59$exports.BaseAccount.fromJSON(object.baseAccount) : undefined;
        message.originalVesting = ((_a = object.originalVesting) !== null && _a !== void 0 ? _a : []).map((e)=>$82ef09d1a8e2224d$exports.Coin.fromJSON(e));
        message.delegatedFree = ((_b = object.delegatedFree) !== null && _b !== void 0 ? _b : []).map((e)=>$82ef09d1a8e2224d$exports.Coin.fromJSON(e));
        message.delegatedVesting = ((_c = object.delegatedVesting) !== null && _c !== void 0 ? _c : []).map((e)=>$82ef09d1a8e2224d$exports.Coin.fromJSON(e));
        message.endTime = object.endTime !== undefined && object.endTime !== null ? $da9a33239166115f$var$long_1.default.fromString(object.endTime) : $da9a33239166115f$var$long_1.default.ZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.baseAccount !== undefined && (obj.baseAccount = message.baseAccount ? $fc581078c2d0cd59$exports.BaseAccount.toJSON(message.baseAccount) : undefined);
        if (message.originalVesting) obj.originalVesting = message.originalVesting.map((e)=>e ? $82ef09d1a8e2224d$exports.Coin.toJSON(e) : undefined);
        else obj.originalVesting = [];
        if (message.delegatedFree) obj.delegatedFree = message.delegatedFree.map((e)=>e ? $82ef09d1a8e2224d$exports.Coin.toJSON(e) : undefined);
        else obj.delegatedFree = [];
        if (message.delegatedVesting) obj.delegatedVesting = message.delegatedVesting.map((e)=>e ? $82ef09d1a8e2224d$exports.Coin.toJSON(e) : undefined);
        else obj.delegatedVesting = [];
        message.endTime !== undefined && (obj.endTime = (message.endTime || $da9a33239166115f$var$long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $da9a33239166115f$var$baseBaseVestingAccount);
        message.baseAccount = object.baseAccount !== undefined && object.baseAccount !== null ? $fc581078c2d0cd59$exports.BaseAccount.fromPartial(object.baseAccount) : undefined;
        message.originalVesting = ((_a = object.originalVesting) === null || _a === void 0 ? void 0 : _a.map((e)=>$82ef09d1a8e2224d$exports.Coin.fromPartial(e))) || [];
        message.delegatedFree = ((_b = object.delegatedFree) === null || _b === void 0 ? void 0 : _b.map((e)=>$82ef09d1a8e2224d$exports.Coin.fromPartial(e))) || [];
        message.delegatedVesting = ((_c = object.delegatedVesting) === null || _c === void 0 ? void 0 : _c.map((e)=>$82ef09d1a8e2224d$exports.Coin.fromPartial(e))) || [];
        message.endTime = object.endTime !== undefined && object.endTime !== null ? $da9a33239166115f$var$long_1.default.fromValue(object.endTime) : $da9a33239166115f$var$long_1.default.ZERO;
        return message;
    }
};
const $da9a33239166115f$var$baseContinuousVestingAccount = {
    startTime: $da9a33239166115f$var$long_1.default.ZERO
};
$da9a33239166115f$exports.ContinuousVestingAccount = {
    encode (message, writer = $da9a33239166115f$var$minimal_1.default.Writer.create()) {
        if (message.baseVestingAccount !== undefined) $da9a33239166115f$exports.BaseVestingAccount.encode(message.baseVestingAccount, writer.uint32(10).fork()).ldelim();
        if (!message.startTime.isZero()) writer.uint32(16).int64(message.startTime);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $da9a33239166115f$var$minimal_1.default.Reader ? input : new $da9a33239166115f$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $da9a33239166115f$var$baseContinuousVestingAccount);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.baseVestingAccount = $da9a33239166115f$exports.BaseVestingAccount.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.startTime = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $da9a33239166115f$var$baseContinuousVestingAccount);
        message.baseVestingAccount = object.baseVestingAccount !== undefined && object.baseVestingAccount !== null ? $da9a33239166115f$exports.BaseVestingAccount.fromJSON(object.baseVestingAccount) : undefined;
        message.startTime = object.startTime !== undefined && object.startTime !== null ? $da9a33239166115f$var$long_1.default.fromString(object.startTime) : $da9a33239166115f$var$long_1.default.ZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.baseVestingAccount !== undefined && (obj.baseVestingAccount = message.baseVestingAccount ? $da9a33239166115f$exports.BaseVestingAccount.toJSON(message.baseVestingAccount) : undefined);
        message.startTime !== undefined && (obj.startTime = (message.startTime || $da9a33239166115f$var$long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $da9a33239166115f$var$baseContinuousVestingAccount);
        message.baseVestingAccount = object.baseVestingAccount !== undefined && object.baseVestingAccount !== null ? $da9a33239166115f$exports.BaseVestingAccount.fromPartial(object.baseVestingAccount) : undefined;
        message.startTime = object.startTime !== undefined && object.startTime !== null ? $da9a33239166115f$var$long_1.default.fromValue(object.startTime) : $da9a33239166115f$var$long_1.default.ZERO;
        return message;
    }
};
const $da9a33239166115f$var$baseDelayedVestingAccount = {};
$da9a33239166115f$exports.DelayedVestingAccount = {
    encode (message, writer = $da9a33239166115f$var$minimal_1.default.Writer.create()) {
        if (message.baseVestingAccount !== undefined) $da9a33239166115f$exports.BaseVestingAccount.encode(message.baseVestingAccount, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $da9a33239166115f$var$minimal_1.default.Reader ? input : new $da9a33239166115f$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $da9a33239166115f$var$baseDelayedVestingAccount);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.baseVestingAccount = $da9a33239166115f$exports.BaseVestingAccount.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $da9a33239166115f$var$baseDelayedVestingAccount);
        message.baseVestingAccount = object.baseVestingAccount !== undefined && object.baseVestingAccount !== null ? $da9a33239166115f$exports.BaseVestingAccount.fromJSON(object.baseVestingAccount) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.baseVestingAccount !== undefined && (obj.baseVestingAccount = message.baseVestingAccount ? $da9a33239166115f$exports.BaseVestingAccount.toJSON(message.baseVestingAccount) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $da9a33239166115f$var$baseDelayedVestingAccount);
        message.baseVestingAccount = object.baseVestingAccount !== undefined && object.baseVestingAccount !== null ? $da9a33239166115f$exports.BaseVestingAccount.fromPartial(object.baseVestingAccount) : undefined;
        return message;
    }
};
const $da9a33239166115f$var$basePeriod = {
    length: $da9a33239166115f$var$long_1.default.ZERO
};
$da9a33239166115f$exports.Period = {
    encode (message, writer = $da9a33239166115f$var$minimal_1.default.Writer.create()) {
        if (!message.length.isZero()) writer.uint32(8).int64(message.length);
        for (const v of message.amount)$82ef09d1a8e2224d$exports.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $da9a33239166115f$var$minimal_1.default.Reader ? input : new $da9a33239166115f$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $da9a33239166115f$var$basePeriod);
        message.amount = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.length = reader.int64();
                    break;
                case 2:
                    message.amount.push($82ef09d1a8e2224d$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $da9a33239166115f$var$basePeriod);
        message.length = object.length !== undefined && object.length !== null ? $da9a33239166115f$var$long_1.default.fromString(object.length) : $da9a33239166115f$var$long_1.default.ZERO;
        message.amount = ((_a = object.amount) !== null && _a !== void 0 ? _a : []).map((e)=>$82ef09d1a8e2224d$exports.Coin.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.length !== undefined && (obj.length = (message.length || $da9a33239166115f$var$long_1.default.ZERO).toString());
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $82ef09d1a8e2224d$exports.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $da9a33239166115f$var$basePeriod);
        message.length = object.length !== undefined && object.length !== null ? $da9a33239166115f$var$long_1.default.fromValue(object.length) : $da9a33239166115f$var$long_1.default.ZERO;
        message.amount = ((_a = object.amount) === null || _a === void 0 ? void 0 : _a.map((e)=>$82ef09d1a8e2224d$exports.Coin.fromPartial(e))) || [];
        return message;
    }
};
const $da9a33239166115f$var$basePeriodicVestingAccount = {
    startTime: $da9a33239166115f$var$long_1.default.ZERO
};
$da9a33239166115f$exports.PeriodicVestingAccount = {
    encode (message, writer = $da9a33239166115f$var$minimal_1.default.Writer.create()) {
        if (message.baseVestingAccount !== undefined) $da9a33239166115f$exports.BaseVestingAccount.encode(message.baseVestingAccount, writer.uint32(10).fork()).ldelim();
        if (!message.startTime.isZero()) writer.uint32(16).int64(message.startTime);
        for (const v of message.vestingPeriods)$da9a33239166115f$exports.Period.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $da9a33239166115f$var$minimal_1.default.Reader ? input : new $da9a33239166115f$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $da9a33239166115f$var$basePeriodicVestingAccount);
        message.vestingPeriods = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.baseVestingAccount = $da9a33239166115f$exports.BaseVestingAccount.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.startTime = reader.int64();
                    break;
                case 3:
                    message.vestingPeriods.push($da9a33239166115f$exports.Period.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $da9a33239166115f$var$basePeriodicVestingAccount);
        message.baseVestingAccount = object.baseVestingAccount !== undefined && object.baseVestingAccount !== null ? $da9a33239166115f$exports.BaseVestingAccount.fromJSON(object.baseVestingAccount) : undefined;
        message.startTime = object.startTime !== undefined && object.startTime !== null ? $da9a33239166115f$var$long_1.default.fromString(object.startTime) : $da9a33239166115f$var$long_1.default.ZERO;
        message.vestingPeriods = ((_a = object.vestingPeriods) !== null && _a !== void 0 ? _a : []).map((e)=>$da9a33239166115f$exports.Period.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.baseVestingAccount !== undefined && (obj.baseVestingAccount = message.baseVestingAccount ? $da9a33239166115f$exports.BaseVestingAccount.toJSON(message.baseVestingAccount) : undefined);
        message.startTime !== undefined && (obj.startTime = (message.startTime || $da9a33239166115f$var$long_1.default.ZERO).toString());
        if (message.vestingPeriods) obj.vestingPeriods = message.vestingPeriods.map((e)=>e ? $da9a33239166115f$exports.Period.toJSON(e) : undefined);
        else obj.vestingPeriods = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $da9a33239166115f$var$basePeriodicVestingAccount);
        message.baseVestingAccount = object.baseVestingAccount !== undefined && object.baseVestingAccount !== null ? $da9a33239166115f$exports.BaseVestingAccount.fromPartial(object.baseVestingAccount) : undefined;
        message.startTime = object.startTime !== undefined && object.startTime !== null ? $da9a33239166115f$var$long_1.default.fromValue(object.startTime) : $da9a33239166115f$var$long_1.default.ZERO;
        message.vestingPeriods = ((_a = object.vestingPeriods) === null || _a === void 0 ? void 0 : _a.map((e)=>$da9a33239166115f$exports.Period.fromPartial(e))) || [];
        return message;
    }
};
const $da9a33239166115f$var$basePermanentLockedAccount = {};
$da9a33239166115f$exports.PermanentLockedAccount = {
    encode (message, writer = $da9a33239166115f$var$minimal_1.default.Writer.create()) {
        if (message.baseVestingAccount !== undefined) $da9a33239166115f$exports.BaseVestingAccount.encode(message.baseVestingAccount, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $da9a33239166115f$var$minimal_1.default.Reader ? input : new $da9a33239166115f$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $da9a33239166115f$var$basePermanentLockedAccount);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.baseVestingAccount = $da9a33239166115f$exports.BaseVestingAccount.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $da9a33239166115f$var$basePermanentLockedAccount);
        message.baseVestingAccount = object.baseVestingAccount !== undefined && object.baseVestingAccount !== null ? $da9a33239166115f$exports.BaseVestingAccount.fromJSON(object.baseVestingAccount) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.baseVestingAccount !== undefined && (obj.baseVestingAccount = message.baseVestingAccount ? $da9a33239166115f$exports.BaseVestingAccount.toJSON(message.baseVestingAccount) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $da9a33239166115f$var$basePermanentLockedAccount);
        message.baseVestingAccount = object.baseVestingAccount !== undefined && object.baseVestingAccount !== null ? $da9a33239166115f$exports.BaseVestingAccount.fromPartial(object.baseVestingAccount) : undefined;
        return message;
    }
};
if ($da9a33239166115f$var$minimal_1.default.util.Long !== $da9a33239166115f$var$long_1.default) {
    $da9a33239166115f$var$minimal_1.default.util.Long = $da9a33239166115f$var$long_1.default;
    $da9a33239166115f$var$minimal_1.default.configure();
}


function $f152202261c35b7c$var$uint64FromProto(input) {
    return $9YIif.Uint64.fromString(input.toString());
}
function $f152202261c35b7c$var$accountFromBaseAccount(input) {
    const { address: address, pubKey: pubKey, accountNumber: accountNumber, sequence: sequence } = input;
    const pubkey = (0, $eb9a28d0d0241b06$exports.decodePubkey)(pubKey);
    return {
        address: address,
        pubkey: pubkey,
        accountNumber: $f152202261c35b7c$var$uint64FromProto(accountNumber).toNumber(),
        sequence: $f152202261c35b7c$var$uint64FromProto(sequence).toNumber()
    };
}
/**
 * Basic implementation of AccountParser. This is supposed to support the most relevant
 * common Cosmos SDK account types. If you need support for exotic account types,
 * you'll need to write your own account decoder.
 */ function $f152202261c35b7c$var$accountFromAny(input) {
    var _a, _b, _c, _d, _e, _f, _g;
    const { typeUrl: typeUrl, value: value } = input;
    switch(typeUrl){
        // auth
        case "/cosmos.auth.v1beta1.BaseAccount":
            return $f152202261c35b7c$var$accountFromBaseAccount($fc581078c2d0cd59$exports.BaseAccount.decode(value));
        case "/cosmos.auth.v1beta1.ModuleAccount":
            {
                const baseAccount = $fc581078c2d0cd59$exports.ModuleAccount.decode(value).baseAccount;
                (0, $F6P8J.assert)(baseAccount);
                return $f152202261c35b7c$var$accountFromBaseAccount(baseAccount);
            }
        // vesting
        case "/cosmos.vesting.v1beta1.BaseVestingAccount":
            {
                const baseAccount = (_a = $da9a33239166115f$exports.BaseVestingAccount.decode(value)) === null || _a === void 0 ? void 0 : _a.baseAccount;
                (0, $F6P8J.assert)(baseAccount);
                return $f152202261c35b7c$var$accountFromBaseAccount(baseAccount);
            }
        case "/cosmos.vesting.v1beta1.ContinuousVestingAccount":
            {
                const baseAccount = (_c = (_b = $da9a33239166115f$exports.ContinuousVestingAccount.decode(value)) === null || _b === void 0 ? void 0 : _b.baseVestingAccount) === null || _c === void 0 ? void 0 : _c.baseAccount;
                (0, $F6P8J.assert)(baseAccount);
                return $f152202261c35b7c$var$accountFromBaseAccount(baseAccount);
            }
        case "/cosmos.vesting.v1beta1.DelayedVestingAccount":
            {
                const baseAccount = (_e = (_d = $da9a33239166115f$exports.DelayedVestingAccount.decode(value)) === null || _d === void 0 ? void 0 : _d.baseVestingAccount) === null || _e === void 0 ? void 0 : _e.baseAccount;
                (0, $F6P8J.assert)(baseAccount);
                return $f152202261c35b7c$var$accountFromBaseAccount(baseAccount);
            }
        case "/cosmos.vesting.v1beta1.PeriodicVestingAccount":
            {
                const baseAccount = (_g = (_f = $da9a33239166115f$exports.PeriodicVestingAccount.decode(value)) === null || _f === void 0 ? void 0 : _f.baseVestingAccount) === null || _g === void 0 ? void 0 : _g.baseAccount;
                (0, $F6P8J.assert)(baseAccount);
                return $f152202261c35b7c$var$accountFromBaseAccount(baseAccount);
            }
        default:
            throw new Error(`Unsupported type: '${typeUrl}'`);
    }
}
$f152202261c35b7c$exports.accountFromAny = $f152202261c35b7c$var$accountFromAny;


Object.defineProperty($842e3ecb6082807a$exports, "accountFromAny", {
    enumerable: true,
    get: function() {
        return $f152202261c35b7c$exports.accountFromAny;
    }
});
var $e47c3667af262a39$exports = {};
"use strict";
Object.defineProperty($e47c3667af262a39$exports, "__esModule", {
    value: true
});
$e47c3667af262a39$exports.AminoTypes = void 0;
function $e47c3667af262a39$var$isAminoConverter(converter) {
    return typeof converter[1] !== "string";
}
/**
 * A map from Stargate message types as used in the messages's `Any` type
 * to Amino types.
 */ class $e47c3667af262a39$var$AminoTypes {
    toAmino({ typeUrl: typeUrl, value: value }) {
        const converter = this.register[typeUrl];
        if (converter === "not_supported_by_chain") throw new Error(`The message type '${typeUrl}' cannot be signed using the Amino JSON sign mode because this is not supported by chain.`);
        if (!converter) throw new Error(`Type URL '${typeUrl}' does not exist in the Amino message type register. ` + "If you need support for this message type, you can pass in additional entries to the AminoTypes constructor. " + "If you think this message type should be included by default, please open an issue at https://github.com/cosmos/cosmjs/issues.");
        return {
            type: converter.aminoType,
            value: converter.toAmino(value)
        };
    }
    fromAmino({ type: type, value: value }) {
        const matches = Object.entries(this.register).filter($e47c3667af262a39$var$isAminoConverter).filter(([_typeUrl, { aminoType: aminoType }])=>aminoType === type);
        switch(matches.length){
            case 0:
                throw new Error(`Amino type identifier '${type}' does not exist in the Amino message type register. ` + "If you need support for this message type, you can pass in additional entries to the AminoTypes constructor. " + "If you think this message type should be included by default, please open an issue at https://github.com/cosmos/cosmjs/issues.");
            case 1:
                {
                    const [typeUrl, converter] = matches[0];
                    return {
                        typeUrl: typeUrl,
                        value: converter.fromAmino(value)
                    };
                }
            default:
                throw new Error(`Multiple types are registered with Amino type identifier '${type}': '` + matches.map(([key, _value])=>key).sort().join("', '") + "'. Thus fromAmino cannot be performed.");
        }
    }
    constructor(types){
        this.register = types;
    }
}
$e47c3667af262a39$exports.AminoTypes = $e47c3667af262a39$var$AminoTypes;


Object.defineProperty($842e3ecb6082807a$exports, "AminoTypes", {
    enumerable: true,
    get: function() {
        return $e47c3667af262a39$exports.AminoTypes;
    }
});
var $7e86b235f7779e86$exports = {};
"use strict";
Object.defineProperty($7e86b235f7779e86$exports, "__esModule", {
    value: true
});
$7e86b235f7779e86$exports.calculateFee = $7e86b235f7779e86$exports.GasPrice = void 0;

var $9YIif = parcelRequire("9YIif");

/**
 * Denom checker for the Cosmos SDK 0.42 denom pattern
 * (https://github.com/cosmos/cosmos-sdk/blob/v0.42.4/types/coin.go#L599-L601).
 *
 * This is like a regexp but with helpful error messages.
 */ function $7e86b235f7779e86$var$checkDenom(denom) {
    if (denom.length < 3 || denom.length > 128) throw new Error("Denom must be between 3 and 128 characters");
}
/**
 * A gas price, i.e. the price of a single unit of gas. This is typically a fraction of
 * the smallest fee token unit, such as 0.012utoken.
 */ class $7e86b235f7779e86$var$GasPrice {
    /**
     * Parses a gas price formatted as `<amount><denom>`, e.g. `GasPrice.fromString("0.012utoken")`.
     *
     * The denom must match the Cosmos SDK 0.42 pattern (https://github.com/cosmos/cosmos-sdk/blob/v0.42.4/types/coin.go#L599-L601).
     * See `GasPrice` in @cosmjs/stargate for a more generic matcher.
     *
     * Separators are not yet supported.
     */ static fromString(gasPrice) {
        // Use Decimal.fromUserInput and checkDenom for detailed checks and helpful error messages
        const matchResult = gasPrice.match(/^([0-9.]+)([a-z][a-z0-9]*)$/i);
        if (!matchResult) throw new Error("Invalid gas price string");
        const [_, amount, denom] = matchResult;
        $7e86b235f7779e86$var$checkDenom(denom);
        const fractionalDigits = 18;
        const decimalAmount = $9YIif.Decimal.fromUserInput(amount, fractionalDigits);
        return new $7e86b235f7779e86$var$GasPrice(decimalAmount, denom);
    }
    /**
     * Returns a string representation of this gas price, e.g. "0.025uatom".
     * This can be used as an input to `GasPrice.fromString`.
     */ toString() {
        return this.amount.toString() + this.denom;
    }
    constructor(amount, denom){
        this.amount = amount;
        this.denom = denom;
    }
}
$7e86b235f7779e86$exports.GasPrice = $7e86b235f7779e86$var$GasPrice;
function $7e86b235f7779e86$var$calculateFee(gasLimit, gasPrice) {
    const processedGasPrice = typeof gasPrice === "string" ? $7e86b235f7779e86$var$GasPrice.fromString(gasPrice) : gasPrice;
    const { denom: denom, amount: gasPriceAmount } = processedGasPrice;
    // Note: Amount can exceed the safe integer range (https://github.com/cosmos/cosmjs/issues/1134),
    // which we handle by converting from Decimal to string without going through number.
    const amount = gasPriceAmount.multiply(new $9YIif.Uint53(gasLimit)).ceil().toString();
    return {
        amount: (0, $eb9a28d0d0241b06$exports.coins)(amount, denom),
        gas: gasLimit.toString()
    };
}
$7e86b235f7779e86$exports.calculateFee = $7e86b235f7779e86$var$calculateFee;


Object.defineProperty($842e3ecb6082807a$exports, "calculateFee", {
    enumerable: true,
    get: function() {
        return $7e86b235f7779e86$exports.calculateFee;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "GasPrice", {
    enumerable: true,
    get: function() {
        return $7e86b235f7779e86$exports.GasPrice;
    }
});

$842e3ecb6082807a$exports.logs = $842e3ecb6082807a$var$__importStar((parcelRequire("lubYL")));
var $7725f2e3ca016b52$exports = {};
"use strict";
Object.defineProperty($7725f2e3ca016b52$exports, "__esModule", {
    value: true
});
$7725f2e3ca016b52$exports.stakingTypes = $7725f2e3ca016b52$exports.isMsgUndelegateEncodeObject = $7725f2e3ca016b52$exports.isMsgDelegateEncodeObject = $7725f2e3ca016b52$exports.isAminoMsgUndelegate = $7725f2e3ca016b52$exports.isAminoMsgEditValidator = $7725f2e3ca016b52$exports.isAminoMsgDelegate = $7725f2e3ca016b52$exports.isAminoMsgCreateValidator = $7725f2e3ca016b52$exports.isAminoMsgBeginRedelegate = $7725f2e3ca016b52$exports.createStakingAminoConverters = $7725f2e3ca016b52$exports.setupSlashingExtension = $7725f2e3ca016b52$exports.isAminoMsgUnjail = $7725f2e3ca016b52$exports.createSlashingAminoConverters = $7725f2e3ca016b52$exports.setupMintExtension = $7725f2e3ca016b52$exports.setupIbcExtension = $7725f2e3ca016b52$exports.isMsgTransferEncodeObject = $7725f2e3ca016b52$exports.ibcTypes = $7725f2e3ca016b52$exports.isAminoMsgTransfer = $7725f2e3ca016b52$exports.createIbcAminoConverters = $7725f2e3ca016b52$exports.setupGovExtension = $7725f2e3ca016b52$exports.isMsgVoteEncodeObject = $7725f2e3ca016b52$exports.isMsgSubmitProposalEncodeObject = $7725f2e3ca016b52$exports.isMsgDepositEncodeObject = $7725f2e3ca016b52$exports.govTypes = $7725f2e3ca016b52$exports.isAminoMsgVote = $7725f2e3ca016b52$exports.isAminoMsgSubmitProposal = $7725f2e3ca016b52$exports.isAminoMsgDeposit = $7725f2e3ca016b52$exports.createGovAminoConverters = $7725f2e3ca016b52$exports.feegrantTypes = $7725f2e3ca016b52$exports.createFreegrantAminoConverters = $7725f2e3ca016b52$exports.isAminoMsgSubmitEvidence = $7725f2e3ca016b52$exports.createEvidenceAminoConverters = $7725f2e3ca016b52$exports.setupDistributionExtension = $7725f2e3ca016b52$exports.isMsgWithdrawDelegatorRewardEncodeObject = $7725f2e3ca016b52$exports.distributionTypes = $7725f2e3ca016b52$exports.isAminoMsgWithdrawValidatorCommission = $7725f2e3ca016b52$exports.isAminoMsgWithdrawDelegatorReward = $7725f2e3ca016b52$exports.isAminoMsgSetWithdrawAddress = $7725f2e3ca016b52$exports.isAminoMsgFundCommunityPool = $7725f2e3ca016b52$exports.createDistributionAminoConverters = $7725f2e3ca016b52$exports.isAminoMsgVerifyInvariant = $7725f2e3ca016b52$exports.createCrysisAminoConverters = $7725f2e3ca016b52$exports.setupBankExtension = $7725f2e3ca016b52$exports.isMsgSendEncodeObject = $7725f2e3ca016b52$exports.bankTypes = $7725f2e3ca016b52$exports.isAminoMsgSend = $7725f2e3ca016b52$exports.isAminoMsgMultiSend = $7725f2e3ca016b52$exports.createBankAminoConverters = $7725f2e3ca016b52$exports.authzTypes = $7725f2e3ca016b52$exports.createAuthzAminoConverters = $7725f2e3ca016b52$exports.setupAuthExtension = void 0;
$7725f2e3ca016b52$exports.vestingTypes = $7725f2e3ca016b52$exports.createVestingAminoConverters = $7725f2e3ca016b52$exports.setupTxExtension = $7725f2e3ca016b52$exports.setupStakingExtension = void 0;
var $6f017155cc32f781$exports = {};
"use strict";
Object.defineProperty($6f017155cc32f781$exports, "__esModule", {
    value: true
});
$6f017155cc32f781$exports.setupAuthExtension = void 0;
var $4e1d12610f69ad10$exports = {};
"use strict";
var $4e1d12610f69ad10$var$__importDefault = $4e1d12610f69ad10$exports && $4e1d12610f69ad10$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($4e1d12610f69ad10$exports, "__esModule", {
    value: true
});
$4e1d12610f69ad10$exports.QueryClientImpl = $4e1d12610f69ad10$exports.QueryParamsResponse = $4e1d12610f69ad10$exports.QueryParamsRequest = $4e1d12610f69ad10$exports.QueryAccountResponse = $4e1d12610f69ad10$exports.QueryAccountRequest = $4e1d12610f69ad10$exports.QueryAccountsResponse = $4e1d12610f69ad10$exports.QueryAccountsRequest = $4e1d12610f69ad10$exports.protobufPackage = void 0;

/* eslint-disable */ const $4e1d12610f69ad10$var$long_1 = $4e1d12610f69ad10$var$__importDefault((parcelRequire("9A55m")));

const $4e1d12610f69ad10$var$minimal_1 = $4e1d12610f69ad10$var$__importDefault((parcelRequire("i2pIU")));
var $f01b40e20607eb8e$exports = {};
"use strict";
var $f01b40e20607eb8e$var$__importDefault = $f01b40e20607eb8e$exports && $f01b40e20607eb8e$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($f01b40e20607eb8e$exports, "__esModule", {
    value: true
});
$f01b40e20607eb8e$exports.PageResponse = $f01b40e20607eb8e$exports.PageRequest = $f01b40e20607eb8e$exports.protobufPackage = void 0;

/* eslint-disable */ const $f01b40e20607eb8e$var$long_1 = $f01b40e20607eb8e$var$__importDefault((parcelRequire("9A55m")));

const $f01b40e20607eb8e$var$minimal_1 = $f01b40e20607eb8e$var$__importDefault((parcelRequire("i2pIU")));
$f01b40e20607eb8e$exports.protobufPackage = "cosmos.base.query.v1beta1";
const $f01b40e20607eb8e$var$basePageRequest = {
    offset: $f01b40e20607eb8e$var$long_1.default.UZERO,
    limit: $f01b40e20607eb8e$var$long_1.default.UZERO,
    countTotal: false,
    reverse: false
};
$f01b40e20607eb8e$exports.PageRequest = {
    encode (message, writer = $f01b40e20607eb8e$var$minimal_1.default.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (!message.offset.isZero()) writer.uint32(16).uint64(message.offset);
        if (!message.limit.isZero()) writer.uint32(24).uint64(message.limit);
        if (message.countTotal === true) writer.uint32(32).bool(message.countTotal);
        if (message.reverse === true) writer.uint32(40).bool(message.reverse);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f01b40e20607eb8e$var$minimal_1.default.Reader ? input : new $f01b40e20607eb8e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $f01b40e20607eb8e$var$basePageRequest);
        message.key = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.offset = reader.uint64();
                    break;
                case 3:
                    message.limit = reader.uint64();
                    break;
                case 4:
                    message.countTotal = reader.bool();
                    break;
                case 5:
                    message.reverse = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $f01b40e20607eb8e$var$basePageRequest);
        message.key = object.key !== undefined && object.key !== null ? $f01b40e20607eb8e$var$bytesFromBase64(object.key) : new Uint8Array();
        message.offset = object.offset !== undefined && object.offset !== null ? $f01b40e20607eb8e$var$long_1.default.fromString(object.offset) : $f01b40e20607eb8e$var$long_1.default.UZERO;
        message.limit = object.limit !== undefined && object.limit !== null ? $f01b40e20607eb8e$var$long_1.default.fromString(object.limit) : $f01b40e20607eb8e$var$long_1.default.UZERO;
        message.countTotal = object.countTotal !== undefined && object.countTotal !== null ? Boolean(object.countTotal) : false;
        message.reverse = object.reverse !== undefined && object.reverse !== null ? Boolean(object.reverse) : false;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = $f01b40e20607eb8e$var$base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        message.offset !== undefined && (obj.offset = (message.offset || $f01b40e20607eb8e$var$long_1.default.UZERO).toString());
        message.limit !== undefined && (obj.limit = (message.limit || $f01b40e20607eb8e$var$long_1.default.UZERO).toString());
        message.countTotal !== undefined && (obj.countTotal = message.countTotal);
        message.reverse !== undefined && (obj.reverse = message.reverse);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $f01b40e20607eb8e$var$basePageRequest);
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.offset = object.offset !== undefined && object.offset !== null ? $f01b40e20607eb8e$var$long_1.default.fromValue(object.offset) : $f01b40e20607eb8e$var$long_1.default.UZERO;
        message.limit = object.limit !== undefined && object.limit !== null ? $f01b40e20607eb8e$var$long_1.default.fromValue(object.limit) : $f01b40e20607eb8e$var$long_1.default.UZERO;
        message.countTotal = (_b = object.countTotal) !== null && _b !== void 0 ? _b : false;
        message.reverse = (_c = object.reverse) !== null && _c !== void 0 ? _c : false;
        return message;
    }
};
const $f01b40e20607eb8e$var$basePageResponse = {
    total: $f01b40e20607eb8e$var$long_1.default.UZERO
};
$f01b40e20607eb8e$exports.PageResponse = {
    encode (message, writer = $f01b40e20607eb8e$var$minimal_1.default.Writer.create()) {
        if (message.nextKey.length !== 0) writer.uint32(10).bytes(message.nextKey);
        if (!message.total.isZero()) writer.uint32(16).uint64(message.total);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f01b40e20607eb8e$var$minimal_1.default.Reader ? input : new $f01b40e20607eb8e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $f01b40e20607eb8e$var$basePageResponse);
        message.nextKey = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.nextKey = reader.bytes();
                    break;
                case 2:
                    message.total = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $f01b40e20607eb8e$var$basePageResponse);
        message.nextKey = object.nextKey !== undefined && object.nextKey !== null ? $f01b40e20607eb8e$var$bytesFromBase64(object.nextKey) : new Uint8Array();
        message.total = object.total !== undefined && object.total !== null ? $f01b40e20607eb8e$var$long_1.default.fromString(object.total) : $f01b40e20607eb8e$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.nextKey !== undefined && (obj.nextKey = $f01b40e20607eb8e$var$base64FromBytes(message.nextKey !== undefined ? message.nextKey : new Uint8Array()));
        message.total !== undefined && (obj.total = (message.total || $f01b40e20607eb8e$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $f01b40e20607eb8e$var$basePageResponse);
        message.nextKey = (_a = object.nextKey) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.total = object.total !== undefined && object.total !== null ? $f01b40e20607eb8e$var$long_1.default.fromValue(object.total) : $f01b40e20607eb8e$var$long_1.default.UZERO;
        return message;
    }
};
var $f01b40e20607eb8e$var$globalThis = (()=>{
    if (typeof $f01b40e20607eb8e$var$globalThis !== "undefined") return $f01b40e20607eb8e$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $f01b40e20607eb8e$var$atob = $f01b40e20607eb8e$var$globalThis.atob || ((b64)=>$f01b40e20607eb8e$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $f01b40e20607eb8e$var$bytesFromBase64(b64) {
    const bin = $f01b40e20607eb8e$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $f01b40e20607eb8e$var$btoa = $f01b40e20607eb8e$var$globalThis.btoa || ((bin)=>$f01b40e20607eb8e$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $f01b40e20607eb8e$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $f01b40e20607eb8e$var$btoa(bin.join(""));
}
if ($f01b40e20607eb8e$var$minimal_1.default.util.Long !== $f01b40e20607eb8e$var$long_1.default) {
    $f01b40e20607eb8e$var$minimal_1.default.util.Long = $f01b40e20607eb8e$var$long_1.default;
    $f01b40e20607eb8e$var$minimal_1.default.configure();
}




$4e1d12610f69ad10$exports.protobufPackage = "cosmos.auth.v1beta1";
const $4e1d12610f69ad10$var$baseQueryAccountsRequest = {};
$4e1d12610f69ad10$exports.QueryAccountsRequest = {
    encode (message, writer = $4e1d12610f69ad10$var$minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4e1d12610f69ad10$var$minimal_1.default.Reader ? input : new $4e1d12610f69ad10$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $4e1d12610f69ad10$var$baseQueryAccountsRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pagination = $f01b40e20607eb8e$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $4e1d12610f69ad10$var$baseQueryAccountsRequest);
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromJSON(object.pagination) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $4e1d12610f69ad10$var$baseQueryAccountsRequest);
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
const $4e1d12610f69ad10$var$baseQueryAccountsResponse = {};
$4e1d12610f69ad10$exports.QueryAccountsResponse = {
    encode (message, writer = $4e1d12610f69ad10$var$minimal_1.default.Writer.create()) {
        for (const v of message.accounts)$4232fce010c3a46b$exports.Any.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4e1d12610f69ad10$var$minimal_1.default.Reader ? input : new $4e1d12610f69ad10$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $4e1d12610f69ad10$var$baseQueryAccountsResponse);
        message.accounts = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.accounts.push($4232fce010c3a46b$exports.Any.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $f01b40e20607eb8e$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $4e1d12610f69ad10$var$baseQueryAccountsResponse);
        message.accounts = ((_a = object.accounts) !== null && _a !== void 0 ? _a : []).map((e)=>$4232fce010c3a46b$exports.Any.fromJSON(e));
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromJSON(object.pagination) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.accounts) obj.accounts = message.accounts.map((e)=>e ? $4232fce010c3a46b$exports.Any.toJSON(e) : undefined);
        else obj.accounts = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $4e1d12610f69ad10$var$baseQueryAccountsResponse);
        message.accounts = ((_a = object.accounts) === null || _a === void 0 ? void 0 : _a.map((e)=>$4232fce010c3a46b$exports.Any.fromPartial(e))) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
const $4e1d12610f69ad10$var$baseQueryAccountRequest = {
    address: ""
};
$4e1d12610f69ad10$exports.QueryAccountRequest = {
    encode (message, writer = $4e1d12610f69ad10$var$minimal_1.default.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4e1d12610f69ad10$var$minimal_1.default.Reader ? input : new $4e1d12610f69ad10$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $4e1d12610f69ad10$var$baseQueryAccountRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $4e1d12610f69ad10$var$baseQueryAccountRequest);
        message.address = object.address !== undefined && object.address !== null ? String(object.address) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $4e1d12610f69ad10$var$baseQueryAccountRequest);
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
const $4e1d12610f69ad10$var$baseQueryAccountResponse = {};
$4e1d12610f69ad10$exports.QueryAccountResponse = {
    encode (message, writer = $4e1d12610f69ad10$var$minimal_1.default.Writer.create()) {
        if (message.account !== undefined) $4232fce010c3a46b$exports.Any.encode(message.account, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4e1d12610f69ad10$var$minimal_1.default.Reader ? input : new $4e1d12610f69ad10$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $4e1d12610f69ad10$var$baseQueryAccountResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.account = $4232fce010c3a46b$exports.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $4e1d12610f69ad10$var$baseQueryAccountResponse);
        message.account = object.account !== undefined && object.account !== null ? $4232fce010c3a46b$exports.Any.fromJSON(object.account) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.account !== undefined && (obj.account = message.account ? $4232fce010c3a46b$exports.Any.toJSON(message.account) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $4e1d12610f69ad10$var$baseQueryAccountResponse);
        message.account = object.account !== undefined && object.account !== null ? $4232fce010c3a46b$exports.Any.fromPartial(object.account) : undefined;
        return message;
    }
};
const $4e1d12610f69ad10$var$baseQueryParamsRequest = {};
$4e1d12610f69ad10$exports.QueryParamsRequest = {
    encode (_, writer = $4e1d12610f69ad10$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4e1d12610f69ad10$var$minimal_1.default.Reader ? input : new $4e1d12610f69ad10$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $4e1d12610f69ad10$var$baseQueryParamsRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $4e1d12610f69ad10$var$baseQueryParamsRequest);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $4e1d12610f69ad10$var$baseQueryParamsRequest);
        return message;
    }
};
const $4e1d12610f69ad10$var$baseQueryParamsResponse = {};
$4e1d12610f69ad10$exports.QueryParamsResponse = {
    encode (message, writer = $4e1d12610f69ad10$var$minimal_1.default.Writer.create()) {
        if (message.params !== undefined) $fc581078c2d0cd59$exports.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4e1d12610f69ad10$var$minimal_1.default.Reader ? input : new $4e1d12610f69ad10$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $4e1d12610f69ad10$var$baseQueryParamsResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $fc581078c2d0cd59$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $4e1d12610f69ad10$var$baseQueryParamsResponse);
        message.params = object.params !== undefined && object.params !== null ? $fc581078c2d0cd59$exports.Params.fromJSON(object.params) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? $fc581078c2d0cd59$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $4e1d12610f69ad10$var$baseQueryParamsResponse);
        message.params = object.params !== undefined && object.params !== null ? $fc581078c2d0cd59$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
class $4e1d12610f69ad10$var$QueryClientImpl {
    Accounts(request) {
        const data = $4e1d12610f69ad10$exports.QueryAccountsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "Accounts", data);
        return promise.then((data)=>$4e1d12610f69ad10$exports.QueryAccountsResponse.decode(new $4e1d12610f69ad10$var$minimal_1.default.Reader(data)));
    }
    Account(request) {
        const data = $4e1d12610f69ad10$exports.QueryAccountRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "Account", data);
        return promise.then((data)=>$4e1d12610f69ad10$exports.QueryAccountResponse.decode(new $4e1d12610f69ad10$var$minimal_1.default.Reader(data)));
    }
    Params(request) {
        const data = $4e1d12610f69ad10$exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "Params", data);
        return promise.then((data)=>$4e1d12610f69ad10$exports.QueryParamsResponse.decode(new $4e1d12610f69ad10$var$minimal_1.default.Reader(data)));
    }
    constructor(rpc){
        this.rpc = rpc;
        this.Accounts = this.Accounts.bind(this);
        this.Account = this.Account.bind(this);
        this.Params = this.Params.bind(this);
    }
}
$4e1d12610f69ad10$exports.QueryClientImpl = $4e1d12610f69ad10$var$QueryClientImpl;
if ($4e1d12610f69ad10$var$minimal_1.default.util.Long !== $4e1d12610f69ad10$var$long_1.default) {
    $4e1d12610f69ad10$var$minimal_1.default.util.Long = $4e1d12610f69ad10$var$long_1.default;
    $4e1d12610f69ad10$var$minimal_1.default.configure();
}


var $ffdede50deec576f$exports = {};
"use strict";
Object.defineProperty($ffdede50deec576f$exports, "__esModule", {
    value: true
});
$ffdede50deec576f$exports.longify = $ffdede50deec576f$exports.decodeCosmosSdkDecFromProto = $ffdede50deec576f$exports.createProtobufRpcClient = $ffdede50deec576f$exports.createPagination = $ffdede50deec576f$exports.QueryClient = void 0;
var $089d9f1f704bbb73$exports = {};
"use strict";
Object.defineProperty($089d9f1f704bbb73$exports, "__esModule", {
    value: true
});
$089d9f1f704bbb73$exports.QueryClient = void 0;
var $fc6baa8f2374ecb4$exports = {};
"use strict";
Object.defineProperty($fc6baa8f2374ecb4$exports, "__esModule", {
    value: true
});
$fc6baa8f2374ecb4$exports.verifyNonExistence = $fc6baa8f2374ecb4$exports.verifyExistence = $fc6baa8f2374ecb4$exports.tendermintSpec = $fc6baa8f2374ecb4$exports.iavlSpec = $fc6baa8f2374ecb4$exports.calculateExistenceRoot = $fc6baa8f2374ecb4$exports.verifyNonMembership = $fc6baa8f2374ecb4$exports.verifyMembership = $fc6baa8f2374ecb4$exports.ics23 = void 0;
var $06fa977204174ead$exports = {};
/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/ "use strict";

var $i2pIU = parcelRequire("i2pIU");
// Common aliases
var $06fa977204174ead$var$$Reader = $i2pIU.Reader, $06fa977204174ead$var$$Writer = $i2pIU.Writer, $06fa977204174ead$var$$util = $i2pIU.util;
// Exported root namespace
var $06fa977204174ead$var$$root = $i2pIU.roots["default"] || ($i2pIU.roots["default"] = {});
$06fa977204174ead$var$$root.ics23 = function() {
    /**
     * Namespace ics23.
     * @exports ics23
     * @namespace
     */ var ics23 = {};
    /**
     * HashOp enum.
     * @name ics23.HashOp
     * @enum {string}
     * @property {number} NO_HASH=0 NO_HASH value
     * @property {number} SHA256=1 SHA256 value
     * @property {number} SHA512=2 SHA512 value
     * @property {number} KECCAK=3 KECCAK value
     * @property {number} RIPEMD160=4 RIPEMD160 value
     * @property {number} BITCOIN=5 BITCOIN value
     * @property {number} SHA512_256=6 SHA512_256 value
     */ ics23.HashOp = function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "NO_HASH"] = 0;
        values[valuesById[1] = "SHA256"] = 1;
        values[valuesById[2] = "SHA512"] = 2;
        values[valuesById[3] = "KECCAK"] = 3;
        values[valuesById[4] = "RIPEMD160"] = 4;
        values[valuesById[5] = "BITCOIN"] = 5;
        values[valuesById[6] = "SHA512_256"] = 6;
        return values;
    }();
    /**
     * LengthOp defines how to process the key and value of the LeafOp
     * to include length information. After encoding the length with the given
     * algorithm, the length will be prepended to the key and value bytes.
     * (Each one with it's own encoded length)
     * @name ics23.LengthOp
     * @enum {string}
     * @property {number} NO_PREFIX=0 NO_PREFIX value
     * @property {number} VAR_PROTO=1 VAR_PROTO value
     * @property {number} VAR_RLP=2 VAR_RLP value
     * @property {number} FIXED32_BIG=3 FIXED32_BIG value
     * @property {number} FIXED32_LITTLE=4 FIXED32_LITTLE value
     * @property {number} FIXED64_BIG=5 FIXED64_BIG value
     * @property {number} FIXED64_LITTLE=6 FIXED64_LITTLE value
     * @property {number} REQUIRE_32_BYTES=7 REQUIRE_32_BYTES value
     * @property {number} REQUIRE_64_BYTES=8 REQUIRE_64_BYTES value
     */ ics23.LengthOp = function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "NO_PREFIX"] = 0;
        values[valuesById[1] = "VAR_PROTO"] = 1;
        values[valuesById[2] = "VAR_RLP"] = 2;
        values[valuesById[3] = "FIXED32_BIG"] = 3;
        values[valuesById[4] = "FIXED32_LITTLE"] = 4;
        values[valuesById[5] = "FIXED64_BIG"] = 5;
        values[valuesById[6] = "FIXED64_LITTLE"] = 6;
        values[valuesById[7] = "REQUIRE_32_BYTES"] = 7;
        values[valuesById[8] = "REQUIRE_64_BYTES"] = 8;
        return values;
    }();
    ics23.ExistenceProof = function() {
        /**
         * Properties of an ExistenceProof.
         * @memberof ics23
         * @interface IExistenceProof
         * @property {Uint8Array|null} [key] ExistenceProof key
         * @property {Uint8Array|null} [value] ExistenceProof value
         * @property {ics23.ILeafOp|null} [leaf] ExistenceProof leaf
         * @property {Array.<ics23.IInnerOp>|null} [path] ExistenceProof path
         */ /**
         * Constructs a new ExistenceProof.
         * @memberof ics23
         * @classdesc ExistenceProof takes a key and a value and a set of steps to perform on it.
         * The result of peforming all these steps will provide a "root hash", which can
         * be compared to the value in a header.
         * 
         * Since it is computationally infeasible to produce a hash collission for any of the used
         * cryptographic hash functions, if someone can provide a series of operations to transform
         * a given key and value into a root hash that matches some trusted root, these key and values
         * must be in the referenced merkle tree.
         * 
         * The only possible issue is maliablity in LeafOp, such as providing extra prefix data,
         * which should be controlled by a spec. Eg. with lengthOp as NONE,
         * prefix = FOO, key = BAR, value = CHOICE
         * and
         * prefix = F, key = OOBAR, value = CHOICE
         * would produce the same value.
         * 
         * With LengthOp this is tricker but not impossible. Which is why the "leafPrefixEqual" field
         * in the ProofSpec is valuable to prevent this mutability. And why all trees should
         * length-prefix the data before hashing it.
         * @implements IExistenceProof
         * @constructor
         * @param {ics23.IExistenceProof=} [properties] Properties to set
         */ function ExistenceProof(properties) {
            this.path = [];
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * ExistenceProof key.
         * @member {Uint8Array} key
         * @memberof ics23.ExistenceProof
         * @instance
         */ ExistenceProof.prototype.key = $06fa977204174ead$var$$util.newBuffer([]);
        /**
         * ExistenceProof value.
         * @member {Uint8Array} value
         * @memberof ics23.ExistenceProof
         * @instance
         */ ExistenceProof.prototype.value = $06fa977204174ead$var$$util.newBuffer([]);
        /**
         * ExistenceProof leaf.
         * @member {ics23.ILeafOp|null|undefined} leaf
         * @memberof ics23.ExistenceProof
         * @instance
         */ ExistenceProof.prototype.leaf = null;
        /**
         * ExistenceProof path.
         * @member {Array.<ics23.IInnerOp>} path
         * @memberof ics23.ExistenceProof
         * @instance
         */ ExistenceProof.prototype.path = $06fa977204174ead$var$$util.emptyArray;
        /**
         * Creates a new ExistenceProof instance using the specified properties.
         * @function create
         * @memberof ics23.ExistenceProof
         * @static
         * @param {ics23.IExistenceProof=} [properties] Properties to set
         * @returns {ics23.ExistenceProof} ExistenceProof instance
         */ ExistenceProof.create = function create(properties) {
            return new ExistenceProof(properties);
        };
        /**
         * Encodes the specified ExistenceProof message. Does not implicitly {@link ics23.ExistenceProof.verify|verify} messages.
         * @function encode
         * @memberof ics23.ExistenceProof
         * @static
         * @param {ics23.IExistenceProof} message ExistenceProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ ExistenceProof.encode = function encode(message, writer) {
            if (!writer) writer = $06fa977204174ead$var$$Writer.create();
            if (message.key != null && message.hasOwnProperty("key")) writer.uint32(/* id 1, wireType 2 =*/ 10).bytes(message.key);
            if (message.value != null && message.hasOwnProperty("value")) writer.uint32(/* id 2, wireType 2 =*/ 18).bytes(message.value);
            if (message.leaf != null && message.hasOwnProperty("leaf")) $06fa977204174ead$var$$root.ics23.LeafOp.encode(message.leaf, writer.uint32(/* id 3, wireType 2 =*/ 26).fork()).ldelim();
            if (message.path != null && message.path.length) for(var i = 0; i < message.path.length; ++i)$06fa977204174ead$var$$root.ics23.InnerOp.encode(message.path[i], writer.uint32(/* id 4, wireType 2 =*/ 34).fork()).ldelim();
            return writer;
        };
        /**
         * Encodes the specified ExistenceProof message, length delimited. Does not implicitly {@link ics23.ExistenceProof.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.ExistenceProof
         * @static
         * @param {ics23.IExistenceProof} message ExistenceProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ ExistenceProof.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes an ExistenceProof message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.ExistenceProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.ExistenceProof} ExistenceProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ ExistenceProof.decode = function decode(reader, length) {
            if (!(reader instanceof $06fa977204174ead$var$$Reader)) reader = $06fa977204174ead$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $06fa977204174ead$var$$root.ics23.ExistenceProof();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.key = reader.bytes();
                        break;
                    case 2:
                        message.value = reader.bytes();
                        break;
                    case 3:
                        message.leaf = $06fa977204174ead$var$$root.ics23.LeafOp.decode(reader, reader.uint32());
                        break;
                    case 4:
                        if (!(message.path && message.path.length)) message.path = [];
                        message.path.push($06fa977204174ead$var$$root.ics23.InnerOp.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes an ExistenceProof message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.ExistenceProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.ExistenceProof} ExistenceProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ ExistenceProof.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $06fa977204174ead$var$$Reader)) reader = new $06fa977204174ead$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies an ExistenceProof message.
         * @function verify
         * @memberof ics23.ExistenceProof
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ ExistenceProof.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.key != null && message.hasOwnProperty("key")) {
                if (!(message.key && typeof message.key.length === "number" || $06fa977204174ead$var$$util.isString(message.key))) return "key: buffer expected";
            }
            if (message.value != null && message.hasOwnProperty("value")) {
                if (!(message.value && typeof message.value.length === "number" || $06fa977204174ead$var$$util.isString(message.value))) return "value: buffer expected";
            }
            if (message.leaf != null && message.hasOwnProperty("leaf")) {
                var error = $06fa977204174ead$var$$root.ics23.LeafOp.verify(message.leaf);
                if (error) return "leaf." + error;
            }
            if (message.path != null && message.hasOwnProperty("path")) {
                if (!Array.isArray(message.path)) return "path: array expected";
                for(var i = 0; i < message.path.length; ++i){
                    var error = $06fa977204174ead$var$$root.ics23.InnerOp.verify(message.path[i]);
                    if (error) return "path." + error;
                }
            }
            return null;
        };
        /**
         * Creates an ExistenceProof message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.ExistenceProof
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.ExistenceProof} ExistenceProof
         */ ExistenceProof.fromObject = function fromObject(object) {
            if (object instanceof $06fa977204174ead$var$$root.ics23.ExistenceProof) return object;
            var message = new $06fa977204174ead$var$$root.ics23.ExistenceProof();
            if (object.key != null) {
                if (typeof object.key === "string") $06fa977204174ead$var$$util.base64.decode(object.key, message.key = $06fa977204174ead$var$$util.newBuffer($06fa977204174ead$var$$util.base64.length(object.key)), 0);
                else if (object.key.length) message.key = object.key;
            }
            if (object.value != null) {
                if (typeof object.value === "string") $06fa977204174ead$var$$util.base64.decode(object.value, message.value = $06fa977204174ead$var$$util.newBuffer($06fa977204174ead$var$$util.base64.length(object.value)), 0);
                else if (object.value.length) message.value = object.value;
            }
            if (object.leaf != null) {
                if (typeof object.leaf !== "object") throw TypeError(".ics23.ExistenceProof.leaf: object expected");
                message.leaf = $06fa977204174ead$var$$root.ics23.LeafOp.fromObject(object.leaf);
            }
            if (object.path) {
                if (!Array.isArray(object.path)) throw TypeError(".ics23.ExistenceProof.path: array expected");
                message.path = [];
                for(var i = 0; i < object.path.length; ++i){
                    if (typeof object.path[i] !== "object") throw TypeError(".ics23.ExistenceProof.path: object expected");
                    message.path[i] = $06fa977204174ead$var$$root.ics23.InnerOp.fromObject(object.path[i]);
                }
            }
            return message;
        };
        /**
         * Creates a plain object from an ExistenceProof message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.ExistenceProof
         * @static
         * @param {ics23.ExistenceProof} message ExistenceProof
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ ExistenceProof.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.path = [];
            if (options.defaults) {
                if (options.bytes === String) object.key = "";
                else {
                    object.key = [];
                    if (options.bytes !== Array) object.key = $06fa977204174ead$var$$util.newBuffer(object.key);
                }
                if (options.bytes === String) object.value = "";
                else {
                    object.value = [];
                    if (options.bytes !== Array) object.value = $06fa977204174ead$var$$util.newBuffer(object.value);
                }
                object.leaf = null;
            }
            if (message.key != null && message.hasOwnProperty("key")) object.key = options.bytes === String ? $06fa977204174ead$var$$util.base64.encode(message.key, 0, message.key.length) : options.bytes === Array ? Array.prototype.slice.call(message.key) : message.key;
            if (message.value != null && message.hasOwnProperty("value")) object.value = options.bytes === String ? $06fa977204174ead$var$$util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
            if (message.leaf != null && message.hasOwnProperty("leaf")) object.leaf = $06fa977204174ead$var$$root.ics23.LeafOp.toObject(message.leaf, options);
            if (message.path && message.path.length) {
                object.path = [];
                for(var j = 0; j < message.path.length; ++j)object.path[j] = $06fa977204174ead$var$$root.ics23.InnerOp.toObject(message.path[j], options);
            }
            return object;
        };
        /**
         * Converts this ExistenceProof to JSON.
         * @function toJSON
         * @memberof ics23.ExistenceProof
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ ExistenceProof.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $i2pIU.util.toJSONOptions);
        };
        return ExistenceProof;
    }();
    ics23.NonExistenceProof = function() {
        /**
         * Properties of a NonExistenceProof.
         * @memberof ics23
         * @interface INonExistenceProof
         * @property {Uint8Array|null} [key] NonExistenceProof key
         * @property {ics23.IExistenceProof|null} [left] NonExistenceProof left
         * @property {ics23.IExistenceProof|null} [right] NonExistenceProof right
         */ /**
         * Constructs a new NonExistenceProof.
         * @memberof ics23
         * @classdesc Represents a NonExistenceProof.
         * @implements INonExistenceProof
         * @constructor
         * @param {ics23.INonExistenceProof=} [properties] Properties to set
         */ function NonExistenceProof(properties) {
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * NonExistenceProof key.
         * @member {Uint8Array} key
         * @memberof ics23.NonExistenceProof
         * @instance
         */ NonExistenceProof.prototype.key = $06fa977204174ead$var$$util.newBuffer([]);
        /**
         * NonExistenceProof left.
         * @member {ics23.IExistenceProof|null|undefined} left
         * @memberof ics23.NonExistenceProof
         * @instance
         */ NonExistenceProof.prototype.left = null;
        /**
         * NonExistenceProof right.
         * @member {ics23.IExistenceProof|null|undefined} right
         * @memberof ics23.NonExistenceProof
         * @instance
         */ NonExistenceProof.prototype.right = null;
        /**
         * Creates a new NonExistenceProof instance using the specified properties.
         * @function create
         * @memberof ics23.NonExistenceProof
         * @static
         * @param {ics23.INonExistenceProof=} [properties] Properties to set
         * @returns {ics23.NonExistenceProof} NonExistenceProof instance
         */ NonExistenceProof.create = function create(properties) {
            return new NonExistenceProof(properties);
        };
        /**
         * Encodes the specified NonExistenceProof message. Does not implicitly {@link ics23.NonExistenceProof.verify|verify} messages.
         * @function encode
         * @memberof ics23.NonExistenceProof
         * @static
         * @param {ics23.INonExistenceProof} message NonExistenceProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ NonExistenceProof.encode = function encode(message, writer) {
            if (!writer) writer = $06fa977204174ead$var$$Writer.create();
            if (message.key != null && message.hasOwnProperty("key")) writer.uint32(/* id 1, wireType 2 =*/ 10).bytes(message.key);
            if (message.left != null && message.hasOwnProperty("left")) $06fa977204174ead$var$$root.ics23.ExistenceProof.encode(message.left, writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
            if (message.right != null && message.hasOwnProperty("right")) $06fa977204174ead$var$$root.ics23.ExistenceProof.encode(message.right, writer.uint32(/* id 3, wireType 2 =*/ 26).fork()).ldelim();
            return writer;
        };
        /**
         * Encodes the specified NonExistenceProof message, length delimited. Does not implicitly {@link ics23.NonExistenceProof.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.NonExistenceProof
         * @static
         * @param {ics23.INonExistenceProof} message NonExistenceProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ NonExistenceProof.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a NonExistenceProof message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.NonExistenceProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.NonExistenceProof} NonExistenceProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ NonExistenceProof.decode = function decode(reader, length) {
            if (!(reader instanceof $06fa977204174ead$var$$Reader)) reader = $06fa977204174ead$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $06fa977204174ead$var$$root.ics23.NonExistenceProof();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.key = reader.bytes();
                        break;
                    case 2:
                        message.left = $06fa977204174ead$var$$root.ics23.ExistenceProof.decode(reader, reader.uint32());
                        break;
                    case 3:
                        message.right = $06fa977204174ead$var$$root.ics23.ExistenceProof.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a NonExistenceProof message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.NonExistenceProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.NonExistenceProof} NonExistenceProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ NonExistenceProof.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $06fa977204174ead$var$$Reader)) reader = new $06fa977204174ead$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a NonExistenceProof message.
         * @function verify
         * @memberof ics23.NonExistenceProof
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ NonExistenceProof.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.key != null && message.hasOwnProperty("key")) {
                if (!(message.key && typeof message.key.length === "number" || $06fa977204174ead$var$$util.isString(message.key))) return "key: buffer expected";
            }
            if (message.left != null && message.hasOwnProperty("left")) {
                var error = $06fa977204174ead$var$$root.ics23.ExistenceProof.verify(message.left);
                if (error) return "left." + error;
            }
            if (message.right != null && message.hasOwnProperty("right")) {
                var error = $06fa977204174ead$var$$root.ics23.ExistenceProof.verify(message.right);
                if (error) return "right." + error;
            }
            return null;
        };
        /**
         * Creates a NonExistenceProof message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.NonExistenceProof
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.NonExistenceProof} NonExistenceProof
         */ NonExistenceProof.fromObject = function fromObject(object) {
            if (object instanceof $06fa977204174ead$var$$root.ics23.NonExistenceProof) return object;
            var message = new $06fa977204174ead$var$$root.ics23.NonExistenceProof();
            if (object.key != null) {
                if (typeof object.key === "string") $06fa977204174ead$var$$util.base64.decode(object.key, message.key = $06fa977204174ead$var$$util.newBuffer($06fa977204174ead$var$$util.base64.length(object.key)), 0);
                else if (object.key.length) message.key = object.key;
            }
            if (object.left != null) {
                if (typeof object.left !== "object") throw TypeError(".ics23.NonExistenceProof.left: object expected");
                message.left = $06fa977204174ead$var$$root.ics23.ExistenceProof.fromObject(object.left);
            }
            if (object.right != null) {
                if (typeof object.right !== "object") throw TypeError(".ics23.NonExistenceProof.right: object expected");
                message.right = $06fa977204174ead$var$$root.ics23.ExistenceProof.fromObject(object.right);
            }
            return message;
        };
        /**
         * Creates a plain object from a NonExistenceProof message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.NonExistenceProof
         * @static
         * @param {ics23.NonExistenceProof} message NonExistenceProof
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ NonExistenceProof.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String) object.key = "";
                else {
                    object.key = [];
                    if (options.bytes !== Array) object.key = $06fa977204174ead$var$$util.newBuffer(object.key);
                }
                object.left = null;
                object.right = null;
            }
            if (message.key != null && message.hasOwnProperty("key")) object.key = options.bytes === String ? $06fa977204174ead$var$$util.base64.encode(message.key, 0, message.key.length) : options.bytes === Array ? Array.prototype.slice.call(message.key) : message.key;
            if (message.left != null && message.hasOwnProperty("left")) object.left = $06fa977204174ead$var$$root.ics23.ExistenceProof.toObject(message.left, options);
            if (message.right != null && message.hasOwnProperty("right")) object.right = $06fa977204174ead$var$$root.ics23.ExistenceProof.toObject(message.right, options);
            return object;
        };
        /**
         * Converts this NonExistenceProof to JSON.
         * @function toJSON
         * @memberof ics23.NonExistenceProof
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ NonExistenceProof.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $i2pIU.util.toJSONOptions);
        };
        return NonExistenceProof;
    }();
    ics23.CommitmentProof = function() {
        /**
         * Properties of a CommitmentProof.
         * @memberof ics23
         * @interface ICommitmentProof
         * @property {ics23.IExistenceProof|null} [exist] CommitmentProof exist
         * @property {ics23.INonExistenceProof|null} [nonexist] CommitmentProof nonexist
         * @property {ics23.IBatchProof|null} [batch] CommitmentProof batch
         * @property {ics23.ICompressedBatchProof|null} [compressed] CommitmentProof compressed
         */ /**
         * Constructs a new CommitmentProof.
         * @memberof ics23
         * @classdesc Represents a CommitmentProof.
         * @implements ICommitmentProof
         * @constructor
         * @param {ics23.ICommitmentProof=} [properties] Properties to set
         */ function CommitmentProof(properties) {
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * CommitmentProof exist.
         * @member {ics23.IExistenceProof|null|undefined} exist
         * @memberof ics23.CommitmentProof
         * @instance
         */ CommitmentProof.prototype.exist = null;
        /**
         * CommitmentProof nonexist.
         * @member {ics23.INonExistenceProof|null|undefined} nonexist
         * @memberof ics23.CommitmentProof
         * @instance
         */ CommitmentProof.prototype.nonexist = null;
        /**
         * CommitmentProof batch.
         * @member {ics23.IBatchProof|null|undefined} batch
         * @memberof ics23.CommitmentProof
         * @instance
         */ CommitmentProof.prototype.batch = null;
        /**
         * CommitmentProof compressed.
         * @member {ics23.ICompressedBatchProof|null|undefined} compressed
         * @memberof ics23.CommitmentProof
         * @instance
         */ CommitmentProof.prototype.compressed = null;
        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;
        /**
         * CommitmentProof proof.
         * @member {"exist"|"nonexist"|"batch"|"compressed"|undefined} proof
         * @memberof ics23.CommitmentProof
         * @instance
         */ Object.defineProperty(CommitmentProof.prototype, "proof", {
            get: $06fa977204174ead$var$$util.oneOfGetter($oneOfFields = [
                "exist",
                "nonexist",
                "batch",
                "compressed"
            ]),
            set: $06fa977204174ead$var$$util.oneOfSetter($oneOfFields)
        });
        /**
         * Creates a new CommitmentProof instance using the specified properties.
         * @function create
         * @memberof ics23.CommitmentProof
         * @static
         * @param {ics23.ICommitmentProof=} [properties] Properties to set
         * @returns {ics23.CommitmentProof} CommitmentProof instance
         */ CommitmentProof.create = function create(properties) {
            return new CommitmentProof(properties);
        };
        /**
         * Encodes the specified CommitmentProof message. Does not implicitly {@link ics23.CommitmentProof.verify|verify} messages.
         * @function encode
         * @memberof ics23.CommitmentProof
         * @static
         * @param {ics23.ICommitmentProof} message CommitmentProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CommitmentProof.encode = function encode(message, writer) {
            if (!writer) writer = $06fa977204174ead$var$$Writer.create();
            if (message.exist != null && message.hasOwnProperty("exist")) $06fa977204174ead$var$$root.ics23.ExistenceProof.encode(message.exist, writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) $06fa977204174ead$var$$root.ics23.NonExistenceProof.encode(message.nonexist, writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
            if (message.batch != null && message.hasOwnProperty("batch")) $06fa977204174ead$var$$root.ics23.BatchProof.encode(message.batch, writer.uint32(/* id 3, wireType 2 =*/ 26).fork()).ldelim();
            if (message.compressed != null && message.hasOwnProperty("compressed")) $06fa977204174ead$var$$root.ics23.CompressedBatchProof.encode(message.compressed, writer.uint32(/* id 4, wireType 2 =*/ 34).fork()).ldelim();
            return writer;
        };
        /**
         * Encodes the specified CommitmentProof message, length delimited. Does not implicitly {@link ics23.CommitmentProof.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.CommitmentProof
         * @static
         * @param {ics23.ICommitmentProof} message CommitmentProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CommitmentProof.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a CommitmentProof message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.CommitmentProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.CommitmentProof} CommitmentProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CommitmentProof.decode = function decode(reader, length) {
            if (!(reader instanceof $06fa977204174ead$var$$Reader)) reader = $06fa977204174ead$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $06fa977204174ead$var$$root.ics23.CommitmentProof();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.exist = $06fa977204174ead$var$$root.ics23.ExistenceProof.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.nonexist = $06fa977204174ead$var$$root.ics23.NonExistenceProof.decode(reader, reader.uint32());
                        break;
                    case 3:
                        message.batch = $06fa977204174ead$var$$root.ics23.BatchProof.decode(reader, reader.uint32());
                        break;
                    case 4:
                        message.compressed = $06fa977204174ead$var$$root.ics23.CompressedBatchProof.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a CommitmentProof message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.CommitmentProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.CommitmentProof} CommitmentProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CommitmentProof.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $06fa977204174ead$var$$Reader)) reader = new $06fa977204174ead$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a CommitmentProof message.
         * @function verify
         * @memberof ics23.CommitmentProof
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ CommitmentProof.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            var properties = {};
            if (message.exist != null && message.hasOwnProperty("exist")) {
                properties.proof = 1;
                var error = $06fa977204174ead$var$$root.ics23.ExistenceProof.verify(message.exist);
                if (error) return "exist." + error;
            }
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) {
                if (properties.proof === 1) return "proof: multiple values";
                properties.proof = 1;
                var error = $06fa977204174ead$var$$root.ics23.NonExistenceProof.verify(message.nonexist);
                if (error) return "nonexist." + error;
            }
            if (message.batch != null && message.hasOwnProperty("batch")) {
                if (properties.proof === 1) return "proof: multiple values";
                properties.proof = 1;
                var error = $06fa977204174ead$var$$root.ics23.BatchProof.verify(message.batch);
                if (error) return "batch." + error;
            }
            if (message.compressed != null && message.hasOwnProperty("compressed")) {
                if (properties.proof === 1) return "proof: multiple values";
                properties.proof = 1;
                var error = $06fa977204174ead$var$$root.ics23.CompressedBatchProof.verify(message.compressed);
                if (error) return "compressed." + error;
            }
            return null;
        };
        /**
         * Creates a CommitmentProof message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.CommitmentProof
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.CommitmentProof} CommitmentProof
         */ CommitmentProof.fromObject = function fromObject(object) {
            if (object instanceof $06fa977204174ead$var$$root.ics23.CommitmentProof) return object;
            var message = new $06fa977204174ead$var$$root.ics23.CommitmentProof();
            if (object.exist != null) {
                if (typeof object.exist !== "object") throw TypeError(".ics23.CommitmentProof.exist: object expected");
                message.exist = $06fa977204174ead$var$$root.ics23.ExistenceProof.fromObject(object.exist);
            }
            if (object.nonexist != null) {
                if (typeof object.nonexist !== "object") throw TypeError(".ics23.CommitmentProof.nonexist: object expected");
                message.nonexist = $06fa977204174ead$var$$root.ics23.NonExistenceProof.fromObject(object.nonexist);
            }
            if (object.batch != null) {
                if (typeof object.batch !== "object") throw TypeError(".ics23.CommitmentProof.batch: object expected");
                message.batch = $06fa977204174ead$var$$root.ics23.BatchProof.fromObject(object.batch);
            }
            if (object.compressed != null) {
                if (typeof object.compressed !== "object") throw TypeError(".ics23.CommitmentProof.compressed: object expected");
                message.compressed = $06fa977204174ead$var$$root.ics23.CompressedBatchProof.fromObject(object.compressed);
            }
            return message;
        };
        /**
         * Creates a plain object from a CommitmentProof message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.CommitmentProof
         * @static
         * @param {ics23.CommitmentProof} message CommitmentProof
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ CommitmentProof.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (message.exist != null && message.hasOwnProperty("exist")) {
                object.exist = $06fa977204174ead$var$$root.ics23.ExistenceProof.toObject(message.exist, options);
                if (options.oneofs) object.proof = "exist";
            }
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) {
                object.nonexist = $06fa977204174ead$var$$root.ics23.NonExistenceProof.toObject(message.nonexist, options);
                if (options.oneofs) object.proof = "nonexist";
            }
            if (message.batch != null && message.hasOwnProperty("batch")) {
                object.batch = $06fa977204174ead$var$$root.ics23.BatchProof.toObject(message.batch, options);
                if (options.oneofs) object.proof = "batch";
            }
            if (message.compressed != null && message.hasOwnProperty("compressed")) {
                object.compressed = $06fa977204174ead$var$$root.ics23.CompressedBatchProof.toObject(message.compressed, options);
                if (options.oneofs) object.proof = "compressed";
            }
            return object;
        };
        /**
         * Converts this CommitmentProof to JSON.
         * @function toJSON
         * @memberof ics23.CommitmentProof
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ CommitmentProof.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $i2pIU.util.toJSONOptions);
        };
        return CommitmentProof;
    }();
    ics23.LeafOp = function() {
        /**
         * Properties of a LeafOp.
         * @memberof ics23
         * @interface ILeafOp
         * @property {ics23.HashOp|null} [hash] LeafOp hash
         * @property {ics23.HashOp|null} [prehashKey] LeafOp prehashKey
         * @property {ics23.HashOp|null} [prehashValue] LeafOp prehashValue
         * @property {ics23.LengthOp|null} [length] LeafOp length
         * @property {Uint8Array|null} [prefix] LeafOp prefix
         */ /**
         * Constructs a new LeafOp.
         * @memberof ics23
         * @classdesc LeafOp represents the raw key-value data we wish to prove, and
         * must be flexible to represent the internal transformation from
         * the original key-value pairs into the basis hash, for many existing
         * merkle trees.
         * 
         * key and value are passed in. So that the signature of this operation is:
         * leafOp(key, value) -> output
         * 
         * To process this, first prehash the keys and values if needed (ANY means no hash in this case):
         * hkey = prehashKey(key)
         * hvalue = prehashValue(value)
         * 
         * Then combine the bytes, and hash it
         * output = hash(prefix || length(hkey) || hkey || length(hvalue) || hvalue)
         * @implements ILeafOp
         * @constructor
         * @param {ics23.ILeafOp=} [properties] Properties to set
         */ function LeafOp(properties) {
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * LeafOp hash.
         * @member {ics23.HashOp} hash
         * @memberof ics23.LeafOp
         * @instance
         */ LeafOp.prototype.hash = 0;
        /**
         * LeafOp prehashKey.
         * @member {ics23.HashOp} prehashKey
         * @memberof ics23.LeafOp
         * @instance
         */ LeafOp.prototype.prehashKey = 0;
        /**
         * LeafOp prehashValue.
         * @member {ics23.HashOp} prehashValue
         * @memberof ics23.LeafOp
         * @instance
         */ LeafOp.prototype.prehashValue = 0;
        /**
         * LeafOp length.
         * @member {ics23.LengthOp} length
         * @memberof ics23.LeafOp
         * @instance
         */ LeafOp.prototype.length = 0;
        /**
         * LeafOp prefix.
         * @member {Uint8Array} prefix
         * @memberof ics23.LeafOp
         * @instance
         */ LeafOp.prototype.prefix = $06fa977204174ead$var$$util.newBuffer([]);
        /**
         * Creates a new LeafOp instance using the specified properties.
         * @function create
         * @memberof ics23.LeafOp
         * @static
         * @param {ics23.ILeafOp=} [properties] Properties to set
         * @returns {ics23.LeafOp} LeafOp instance
         */ LeafOp.create = function create(properties) {
            return new LeafOp(properties);
        };
        /**
         * Encodes the specified LeafOp message. Does not implicitly {@link ics23.LeafOp.verify|verify} messages.
         * @function encode
         * @memberof ics23.LeafOp
         * @static
         * @param {ics23.ILeafOp} message LeafOp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ LeafOp.encode = function encode(message, writer) {
            if (!writer) writer = $06fa977204174ead$var$$Writer.create();
            if (message.hash != null && message.hasOwnProperty("hash")) writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.hash);
            if (message.prehashKey != null && message.hasOwnProperty("prehashKey")) writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.prehashKey);
            if (message.prehashValue != null && message.hasOwnProperty("prehashValue")) writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.prehashValue);
            if (message.length != null && message.hasOwnProperty("length")) writer.uint32(/* id 4, wireType 0 =*/ 32).int32(message.length);
            if (message.prefix != null && message.hasOwnProperty("prefix")) writer.uint32(/* id 5, wireType 2 =*/ 42).bytes(message.prefix);
            return writer;
        };
        /**
         * Encodes the specified LeafOp message, length delimited. Does not implicitly {@link ics23.LeafOp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.LeafOp
         * @static
         * @param {ics23.ILeafOp} message LeafOp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ LeafOp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a LeafOp message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.LeafOp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.LeafOp} LeafOp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ LeafOp.decode = function decode(reader, length) {
            if (!(reader instanceof $06fa977204174ead$var$$Reader)) reader = $06fa977204174ead$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $06fa977204174ead$var$$root.ics23.LeafOp();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.hash = reader.int32();
                        break;
                    case 2:
                        message.prehashKey = reader.int32();
                        break;
                    case 3:
                        message.prehashValue = reader.int32();
                        break;
                    case 4:
                        message.length = reader.int32();
                        break;
                    case 5:
                        message.prefix = reader.bytes();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a LeafOp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.LeafOp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.LeafOp} LeafOp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ LeafOp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $06fa977204174ead$var$$Reader)) reader = new $06fa977204174ead$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a LeafOp message.
         * @function verify
         * @memberof ics23.LeafOp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ LeafOp.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.hash != null && message.hasOwnProperty("hash")) switch(message.hash){
                default:
                    return "hash: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                    break;
            }
            if (message.prehashKey != null && message.hasOwnProperty("prehashKey")) switch(message.prehashKey){
                default:
                    return "prehashKey: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                    break;
            }
            if (message.prehashValue != null && message.hasOwnProperty("prehashValue")) switch(message.prehashValue){
                default:
                    return "prehashValue: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                    break;
            }
            if (message.length != null && message.hasOwnProperty("length")) switch(message.length){
                default:
                    return "length: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                    break;
            }
            if (message.prefix != null && message.hasOwnProperty("prefix")) {
                if (!(message.prefix && typeof message.prefix.length === "number" || $06fa977204174ead$var$$util.isString(message.prefix))) return "prefix: buffer expected";
            }
            return null;
        };
        /**
         * Creates a LeafOp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.LeafOp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.LeafOp} LeafOp
         */ LeafOp.fromObject = function fromObject(object) {
            if (object instanceof $06fa977204174ead$var$$root.ics23.LeafOp) return object;
            var message = new $06fa977204174ead$var$$root.ics23.LeafOp();
            switch(object.hash){
                case "NO_HASH":
                case 0:
                    message.hash = 0;
                    break;
                case "SHA256":
                case 1:
                    message.hash = 1;
                    break;
                case "SHA512":
                case 2:
                    message.hash = 2;
                    break;
                case "KECCAK":
                case 3:
                    message.hash = 3;
                    break;
                case "RIPEMD160":
                case 4:
                    message.hash = 4;
                    break;
                case "BITCOIN":
                case 5:
                    message.hash = 5;
                    break;
                case "SHA512_256":
                case 6:
                    message.hash = 6;
                    break;
            }
            switch(object.prehashKey){
                case "NO_HASH":
                case 0:
                    message.prehashKey = 0;
                    break;
                case "SHA256":
                case 1:
                    message.prehashKey = 1;
                    break;
                case "SHA512":
                case 2:
                    message.prehashKey = 2;
                    break;
                case "KECCAK":
                case 3:
                    message.prehashKey = 3;
                    break;
                case "RIPEMD160":
                case 4:
                    message.prehashKey = 4;
                    break;
                case "BITCOIN":
                case 5:
                    message.prehashKey = 5;
                    break;
                case "SHA512_256":
                case 6:
                    message.prehashKey = 6;
                    break;
            }
            switch(object.prehashValue){
                case "NO_HASH":
                case 0:
                    message.prehashValue = 0;
                    break;
                case "SHA256":
                case 1:
                    message.prehashValue = 1;
                    break;
                case "SHA512":
                case 2:
                    message.prehashValue = 2;
                    break;
                case "KECCAK":
                case 3:
                    message.prehashValue = 3;
                    break;
                case "RIPEMD160":
                case 4:
                    message.prehashValue = 4;
                    break;
                case "BITCOIN":
                case 5:
                    message.prehashValue = 5;
                    break;
                case "SHA512_256":
                case 6:
                    message.prehashValue = 6;
                    break;
            }
            switch(object.length){
                case "NO_PREFIX":
                case 0:
                    message.length = 0;
                    break;
                case "VAR_PROTO":
                case 1:
                    message.length = 1;
                    break;
                case "VAR_RLP":
                case 2:
                    message.length = 2;
                    break;
                case "FIXED32_BIG":
                case 3:
                    message.length = 3;
                    break;
                case "FIXED32_LITTLE":
                case 4:
                    message.length = 4;
                    break;
                case "FIXED64_BIG":
                case 5:
                    message.length = 5;
                    break;
                case "FIXED64_LITTLE":
                case 6:
                    message.length = 6;
                    break;
                case "REQUIRE_32_BYTES":
                case 7:
                    message.length = 7;
                    break;
                case "REQUIRE_64_BYTES":
                case 8:
                    message.length = 8;
                    break;
            }
            if (object.prefix != null) {
                if (typeof object.prefix === "string") $06fa977204174ead$var$$util.base64.decode(object.prefix, message.prefix = $06fa977204174ead$var$$util.newBuffer($06fa977204174ead$var$$util.base64.length(object.prefix)), 0);
                else if (object.prefix.length) message.prefix = object.prefix;
            }
            return message;
        };
        /**
         * Creates a plain object from a LeafOp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.LeafOp
         * @static
         * @param {ics23.LeafOp} message LeafOp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ LeafOp.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
                object.hash = options.enums === String ? "NO_HASH" : 0;
                object.prehashKey = options.enums === String ? "NO_HASH" : 0;
                object.prehashValue = options.enums === String ? "NO_HASH" : 0;
                object.length = options.enums === String ? "NO_PREFIX" : 0;
                if (options.bytes === String) object.prefix = "";
                else {
                    object.prefix = [];
                    if (options.bytes !== Array) object.prefix = $06fa977204174ead$var$$util.newBuffer(object.prefix);
                }
            }
            if (message.hash != null && message.hasOwnProperty("hash")) object.hash = options.enums === String ? $06fa977204174ead$var$$root.ics23.HashOp[message.hash] : message.hash;
            if (message.prehashKey != null && message.hasOwnProperty("prehashKey")) object.prehashKey = options.enums === String ? $06fa977204174ead$var$$root.ics23.HashOp[message.prehashKey] : message.prehashKey;
            if (message.prehashValue != null && message.hasOwnProperty("prehashValue")) object.prehashValue = options.enums === String ? $06fa977204174ead$var$$root.ics23.HashOp[message.prehashValue] : message.prehashValue;
            if (message.length != null && message.hasOwnProperty("length")) object.length = options.enums === String ? $06fa977204174ead$var$$root.ics23.LengthOp[message.length] : message.length;
            if (message.prefix != null && message.hasOwnProperty("prefix")) object.prefix = options.bytes === String ? $06fa977204174ead$var$$util.base64.encode(message.prefix, 0, message.prefix.length) : options.bytes === Array ? Array.prototype.slice.call(message.prefix) : message.prefix;
            return object;
        };
        /**
         * Converts this LeafOp to JSON.
         * @function toJSON
         * @memberof ics23.LeafOp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ LeafOp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $i2pIU.util.toJSONOptions);
        };
        return LeafOp;
    }();
    ics23.InnerOp = function() {
        /**
         * Properties of an InnerOp.
         * @memberof ics23
         * @interface IInnerOp
         * @property {ics23.HashOp|null} [hash] InnerOp hash
         * @property {Uint8Array|null} [prefix] InnerOp prefix
         * @property {Uint8Array|null} [suffix] InnerOp suffix
         */ /**
         * Constructs a new InnerOp.
         * @memberof ics23
         * @classdesc InnerOp represents a merkle-proof step that is not a leaf.
         * It represents concatenating two children and hashing them to provide the next result.
         * 
         * The result of the previous step is passed in, so the signature of this op is:
         * innerOp(child) -> output
         * 
         * The result of applying InnerOp should be:
         * output = op.hash(op.prefix || child || op.suffix)
         * 
         * where the || operator is concatenation of binary data,
         * and child is the result of hashing all the tree below this step.
         * 
         * Any special data, like prepending child with the length, or prepending the entire operation with
         * some value to differentiate from leaf nodes, should be included in prefix and suffix.
         * If either of prefix or suffix is empty, we just treat it as an empty string
         * @implements IInnerOp
         * @constructor
         * @param {ics23.IInnerOp=} [properties] Properties to set
         */ function InnerOp(properties) {
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * InnerOp hash.
         * @member {ics23.HashOp} hash
         * @memberof ics23.InnerOp
         * @instance
         */ InnerOp.prototype.hash = 0;
        /**
         * InnerOp prefix.
         * @member {Uint8Array} prefix
         * @memberof ics23.InnerOp
         * @instance
         */ InnerOp.prototype.prefix = $06fa977204174ead$var$$util.newBuffer([]);
        /**
         * InnerOp suffix.
         * @member {Uint8Array} suffix
         * @memberof ics23.InnerOp
         * @instance
         */ InnerOp.prototype.suffix = $06fa977204174ead$var$$util.newBuffer([]);
        /**
         * Creates a new InnerOp instance using the specified properties.
         * @function create
         * @memberof ics23.InnerOp
         * @static
         * @param {ics23.IInnerOp=} [properties] Properties to set
         * @returns {ics23.InnerOp} InnerOp instance
         */ InnerOp.create = function create(properties) {
            return new InnerOp(properties);
        };
        /**
         * Encodes the specified InnerOp message. Does not implicitly {@link ics23.InnerOp.verify|verify} messages.
         * @function encode
         * @memberof ics23.InnerOp
         * @static
         * @param {ics23.IInnerOp} message InnerOp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ InnerOp.encode = function encode(message, writer) {
            if (!writer) writer = $06fa977204174ead$var$$Writer.create();
            if (message.hash != null && message.hasOwnProperty("hash")) writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.hash);
            if (message.prefix != null && message.hasOwnProperty("prefix")) writer.uint32(/* id 2, wireType 2 =*/ 18).bytes(message.prefix);
            if (message.suffix != null && message.hasOwnProperty("suffix")) writer.uint32(/* id 3, wireType 2 =*/ 26).bytes(message.suffix);
            return writer;
        };
        /**
         * Encodes the specified InnerOp message, length delimited. Does not implicitly {@link ics23.InnerOp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.InnerOp
         * @static
         * @param {ics23.IInnerOp} message InnerOp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ InnerOp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes an InnerOp message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.InnerOp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.InnerOp} InnerOp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ InnerOp.decode = function decode(reader, length) {
            if (!(reader instanceof $06fa977204174ead$var$$Reader)) reader = $06fa977204174ead$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $06fa977204174ead$var$$root.ics23.InnerOp();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.hash = reader.int32();
                        break;
                    case 2:
                        message.prefix = reader.bytes();
                        break;
                    case 3:
                        message.suffix = reader.bytes();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes an InnerOp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.InnerOp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.InnerOp} InnerOp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ InnerOp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $06fa977204174ead$var$$Reader)) reader = new $06fa977204174ead$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies an InnerOp message.
         * @function verify
         * @memberof ics23.InnerOp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ InnerOp.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.hash != null && message.hasOwnProperty("hash")) switch(message.hash){
                default:
                    return "hash: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                    break;
            }
            if (message.prefix != null && message.hasOwnProperty("prefix")) {
                if (!(message.prefix && typeof message.prefix.length === "number" || $06fa977204174ead$var$$util.isString(message.prefix))) return "prefix: buffer expected";
            }
            if (message.suffix != null && message.hasOwnProperty("suffix")) {
                if (!(message.suffix && typeof message.suffix.length === "number" || $06fa977204174ead$var$$util.isString(message.suffix))) return "suffix: buffer expected";
            }
            return null;
        };
        /**
         * Creates an InnerOp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.InnerOp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.InnerOp} InnerOp
         */ InnerOp.fromObject = function fromObject(object) {
            if (object instanceof $06fa977204174ead$var$$root.ics23.InnerOp) return object;
            var message = new $06fa977204174ead$var$$root.ics23.InnerOp();
            switch(object.hash){
                case "NO_HASH":
                case 0:
                    message.hash = 0;
                    break;
                case "SHA256":
                case 1:
                    message.hash = 1;
                    break;
                case "SHA512":
                case 2:
                    message.hash = 2;
                    break;
                case "KECCAK":
                case 3:
                    message.hash = 3;
                    break;
                case "RIPEMD160":
                case 4:
                    message.hash = 4;
                    break;
                case "BITCOIN":
                case 5:
                    message.hash = 5;
                    break;
                case "SHA512_256":
                case 6:
                    message.hash = 6;
                    break;
            }
            if (object.prefix != null) {
                if (typeof object.prefix === "string") $06fa977204174ead$var$$util.base64.decode(object.prefix, message.prefix = $06fa977204174ead$var$$util.newBuffer($06fa977204174ead$var$$util.base64.length(object.prefix)), 0);
                else if (object.prefix.length) message.prefix = object.prefix;
            }
            if (object.suffix != null) {
                if (typeof object.suffix === "string") $06fa977204174ead$var$$util.base64.decode(object.suffix, message.suffix = $06fa977204174ead$var$$util.newBuffer($06fa977204174ead$var$$util.base64.length(object.suffix)), 0);
                else if (object.suffix.length) message.suffix = object.suffix;
            }
            return message;
        };
        /**
         * Creates a plain object from an InnerOp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.InnerOp
         * @static
         * @param {ics23.InnerOp} message InnerOp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ InnerOp.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
                object.hash = options.enums === String ? "NO_HASH" : 0;
                if (options.bytes === String) object.prefix = "";
                else {
                    object.prefix = [];
                    if (options.bytes !== Array) object.prefix = $06fa977204174ead$var$$util.newBuffer(object.prefix);
                }
                if (options.bytes === String) object.suffix = "";
                else {
                    object.suffix = [];
                    if (options.bytes !== Array) object.suffix = $06fa977204174ead$var$$util.newBuffer(object.suffix);
                }
            }
            if (message.hash != null && message.hasOwnProperty("hash")) object.hash = options.enums === String ? $06fa977204174ead$var$$root.ics23.HashOp[message.hash] : message.hash;
            if (message.prefix != null && message.hasOwnProperty("prefix")) object.prefix = options.bytes === String ? $06fa977204174ead$var$$util.base64.encode(message.prefix, 0, message.prefix.length) : options.bytes === Array ? Array.prototype.slice.call(message.prefix) : message.prefix;
            if (message.suffix != null && message.hasOwnProperty("suffix")) object.suffix = options.bytes === String ? $06fa977204174ead$var$$util.base64.encode(message.suffix, 0, message.suffix.length) : options.bytes === Array ? Array.prototype.slice.call(message.suffix) : message.suffix;
            return object;
        };
        /**
         * Converts this InnerOp to JSON.
         * @function toJSON
         * @memberof ics23.InnerOp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ InnerOp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $i2pIU.util.toJSONOptions);
        };
        return InnerOp;
    }();
    ics23.ProofSpec = function() {
        /**
         * Properties of a ProofSpec.
         * @memberof ics23
         * @interface IProofSpec
         * @property {ics23.ILeafOp|null} [leafSpec] ProofSpec leafSpec
         * @property {ics23.IInnerSpec|null} [innerSpec] ProofSpec innerSpec
         * @property {number|null} [maxDepth] ProofSpec maxDepth
         * @property {number|null} [minDepth] ProofSpec minDepth
         */ /**
         * Constructs a new ProofSpec.
         * @memberof ics23
         * @classdesc ProofSpec defines what the expected parameters are for a given proof type.
         * This can be stored in the client and used to validate any incoming proofs.
         * 
         * verify(ProofSpec, Proof) -> Proof | Error
         * 
         * As demonstrated in tests, if we don't fix the algorithm used to calculate the
         * LeafHash for a given tree, there are many possible key-value pairs that can
         * generate a given hash (by interpretting the preimage differently).
         * We need this for proper security, requires client knows a priori what
         * tree format server uses. But not in code, rather a configuration object.
         * @implements IProofSpec
         * @constructor
         * @param {ics23.IProofSpec=} [properties] Properties to set
         */ function ProofSpec(properties) {
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * ProofSpec leafSpec.
         * @member {ics23.ILeafOp|null|undefined} leafSpec
         * @memberof ics23.ProofSpec
         * @instance
         */ ProofSpec.prototype.leafSpec = null;
        /**
         * ProofSpec innerSpec.
         * @member {ics23.IInnerSpec|null|undefined} innerSpec
         * @memberof ics23.ProofSpec
         * @instance
         */ ProofSpec.prototype.innerSpec = null;
        /**
         * ProofSpec maxDepth.
         * @member {number} maxDepth
         * @memberof ics23.ProofSpec
         * @instance
         */ ProofSpec.prototype.maxDepth = 0;
        /**
         * ProofSpec minDepth.
         * @member {number} minDepth
         * @memberof ics23.ProofSpec
         * @instance
         */ ProofSpec.prototype.minDepth = 0;
        /**
         * Creates a new ProofSpec instance using the specified properties.
         * @function create
         * @memberof ics23.ProofSpec
         * @static
         * @param {ics23.IProofSpec=} [properties] Properties to set
         * @returns {ics23.ProofSpec} ProofSpec instance
         */ ProofSpec.create = function create(properties) {
            return new ProofSpec(properties);
        };
        /**
         * Encodes the specified ProofSpec message. Does not implicitly {@link ics23.ProofSpec.verify|verify} messages.
         * @function encode
         * @memberof ics23.ProofSpec
         * @static
         * @param {ics23.IProofSpec} message ProofSpec message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ ProofSpec.encode = function encode(message, writer) {
            if (!writer) writer = $06fa977204174ead$var$$Writer.create();
            if (message.leafSpec != null && message.hasOwnProperty("leafSpec")) $06fa977204174ead$var$$root.ics23.LeafOp.encode(message.leafSpec, writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
            if (message.innerSpec != null && message.hasOwnProperty("innerSpec")) $06fa977204174ead$var$$root.ics23.InnerSpec.encode(message.innerSpec, writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
            if (message.maxDepth != null && message.hasOwnProperty("maxDepth")) writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.maxDepth);
            if (message.minDepth != null && message.hasOwnProperty("minDepth")) writer.uint32(/* id 4, wireType 0 =*/ 32).int32(message.minDepth);
            return writer;
        };
        /**
         * Encodes the specified ProofSpec message, length delimited. Does not implicitly {@link ics23.ProofSpec.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.ProofSpec
         * @static
         * @param {ics23.IProofSpec} message ProofSpec message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ ProofSpec.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a ProofSpec message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.ProofSpec
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.ProofSpec} ProofSpec
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ ProofSpec.decode = function decode(reader, length) {
            if (!(reader instanceof $06fa977204174ead$var$$Reader)) reader = $06fa977204174ead$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $06fa977204174ead$var$$root.ics23.ProofSpec();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.leafSpec = $06fa977204174ead$var$$root.ics23.LeafOp.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.innerSpec = $06fa977204174ead$var$$root.ics23.InnerSpec.decode(reader, reader.uint32());
                        break;
                    case 3:
                        message.maxDepth = reader.int32();
                        break;
                    case 4:
                        message.minDepth = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a ProofSpec message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.ProofSpec
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.ProofSpec} ProofSpec
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ ProofSpec.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $06fa977204174ead$var$$Reader)) reader = new $06fa977204174ead$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a ProofSpec message.
         * @function verify
         * @memberof ics23.ProofSpec
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ ProofSpec.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.leafSpec != null && message.hasOwnProperty("leafSpec")) {
                var error = $06fa977204174ead$var$$root.ics23.LeafOp.verify(message.leafSpec);
                if (error) return "leafSpec." + error;
            }
            if (message.innerSpec != null && message.hasOwnProperty("innerSpec")) {
                var error = $06fa977204174ead$var$$root.ics23.InnerSpec.verify(message.innerSpec);
                if (error) return "innerSpec." + error;
            }
            if (message.maxDepth != null && message.hasOwnProperty("maxDepth")) {
                if (!$06fa977204174ead$var$$util.isInteger(message.maxDepth)) return "maxDepth: integer expected";
            }
            if (message.minDepth != null && message.hasOwnProperty("minDepth")) {
                if (!$06fa977204174ead$var$$util.isInteger(message.minDepth)) return "minDepth: integer expected";
            }
            return null;
        };
        /**
         * Creates a ProofSpec message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.ProofSpec
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.ProofSpec} ProofSpec
         */ ProofSpec.fromObject = function fromObject(object) {
            if (object instanceof $06fa977204174ead$var$$root.ics23.ProofSpec) return object;
            var message = new $06fa977204174ead$var$$root.ics23.ProofSpec();
            if (object.leafSpec != null) {
                if (typeof object.leafSpec !== "object") throw TypeError(".ics23.ProofSpec.leafSpec: object expected");
                message.leafSpec = $06fa977204174ead$var$$root.ics23.LeafOp.fromObject(object.leafSpec);
            }
            if (object.innerSpec != null) {
                if (typeof object.innerSpec !== "object") throw TypeError(".ics23.ProofSpec.innerSpec: object expected");
                message.innerSpec = $06fa977204174ead$var$$root.ics23.InnerSpec.fromObject(object.innerSpec);
            }
            if (object.maxDepth != null) message.maxDepth = object.maxDepth | 0;
            if (object.minDepth != null) message.minDepth = object.minDepth | 0;
            return message;
        };
        /**
         * Creates a plain object from a ProofSpec message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.ProofSpec
         * @static
         * @param {ics23.ProofSpec} message ProofSpec
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ ProofSpec.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
                object.leafSpec = null;
                object.innerSpec = null;
                object.maxDepth = 0;
                object.minDepth = 0;
            }
            if (message.leafSpec != null && message.hasOwnProperty("leafSpec")) object.leafSpec = $06fa977204174ead$var$$root.ics23.LeafOp.toObject(message.leafSpec, options);
            if (message.innerSpec != null && message.hasOwnProperty("innerSpec")) object.innerSpec = $06fa977204174ead$var$$root.ics23.InnerSpec.toObject(message.innerSpec, options);
            if (message.maxDepth != null && message.hasOwnProperty("maxDepth")) object.maxDepth = message.maxDepth;
            if (message.minDepth != null && message.hasOwnProperty("minDepth")) object.minDepth = message.minDepth;
            return object;
        };
        /**
         * Converts this ProofSpec to JSON.
         * @function toJSON
         * @memberof ics23.ProofSpec
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ ProofSpec.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $i2pIU.util.toJSONOptions);
        };
        return ProofSpec;
    }();
    ics23.InnerSpec = function() {
        /**
         * Properties of an InnerSpec.
         * @memberof ics23
         * @interface IInnerSpec
         * @property {Array.<number>|null} [childOrder] InnerSpec childOrder
         * @property {number|null} [childSize] InnerSpec childSize
         * @property {number|null} [minPrefixLength] InnerSpec minPrefixLength
         * @property {number|null} [maxPrefixLength] InnerSpec maxPrefixLength
         * @property {Uint8Array|null} [emptyChild] InnerSpec emptyChild
         * @property {ics23.HashOp|null} [hash] InnerSpec hash
         */ /**
         * Constructs a new InnerSpec.
         * @memberof ics23
         * @classdesc Represents an InnerSpec.
         * @implements IInnerSpec
         * @constructor
         * @param {ics23.IInnerSpec=} [properties] Properties to set
         */ function InnerSpec(properties) {
            this.childOrder = [];
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * InnerSpec childOrder.
         * @member {Array.<number>} childOrder
         * @memberof ics23.InnerSpec
         * @instance
         */ InnerSpec.prototype.childOrder = $06fa977204174ead$var$$util.emptyArray;
        /**
         * InnerSpec childSize.
         * @member {number} childSize
         * @memberof ics23.InnerSpec
         * @instance
         */ InnerSpec.prototype.childSize = 0;
        /**
         * InnerSpec minPrefixLength.
         * @member {number} minPrefixLength
         * @memberof ics23.InnerSpec
         * @instance
         */ InnerSpec.prototype.minPrefixLength = 0;
        /**
         * InnerSpec maxPrefixLength.
         * @member {number} maxPrefixLength
         * @memberof ics23.InnerSpec
         * @instance
         */ InnerSpec.prototype.maxPrefixLength = 0;
        /**
         * InnerSpec emptyChild.
         * @member {Uint8Array} emptyChild
         * @memberof ics23.InnerSpec
         * @instance
         */ InnerSpec.prototype.emptyChild = $06fa977204174ead$var$$util.newBuffer([]);
        /**
         * InnerSpec hash.
         * @member {ics23.HashOp} hash
         * @memberof ics23.InnerSpec
         * @instance
         */ InnerSpec.prototype.hash = 0;
        /**
         * Creates a new InnerSpec instance using the specified properties.
         * @function create
         * @memberof ics23.InnerSpec
         * @static
         * @param {ics23.IInnerSpec=} [properties] Properties to set
         * @returns {ics23.InnerSpec} InnerSpec instance
         */ InnerSpec.create = function create(properties) {
            return new InnerSpec(properties);
        };
        /**
         * Encodes the specified InnerSpec message. Does not implicitly {@link ics23.InnerSpec.verify|verify} messages.
         * @function encode
         * @memberof ics23.InnerSpec
         * @static
         * @param {ics23.IInnerSpec} message InnerSpec message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ InnerSpec.encode = function encode(message, writer) {
            if (!writer) writer = $06fa977204174ead$var$$Writer.create();
            if (message.childOrder != null && message.childOrder.length) {
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork();
                for(var i = 0; i < message.childOrder.length; ++i)writer.int32(message.childOrder[i]);
                writer.ldelim();
            }
            if (message.childSize != null && message.hasOwnProperty("childSize")) writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.childSize);
            if (message.minPrefixLength != null && message.hasOwnProperty("minPrefixLength")) writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.minPrefixLength);
            if (message.maxPrefixLength != null && message.hasOwnProperty("maxPrefixLength")) writer.uint32(/* id 4, wireType 0 =*/ 32).int32(message.maxPrefixLength);
            if (message.emptyChild != null && message.hasOwnProperty("emptyChild")) writer.uint32(/* id 5, wireType 2 =*/ 42).bytes(message.emptyChild);
            if (message.hash != null && message.hasOwnProperty("hash")) writer.uint32(/* id 6, wireType 0 =*/ 48).int32(message.hash);
            return writer;
        };
        /**
         * Encodes the specified InnerSpec message, length delimited. Does not implicitly {@link ics23.InnerSpec.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.InnerSpec
         * @static
         * @param {ics23.IInnerSpec} message InnerSpec message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ InnerSpec.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes an InnerSpec message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.InnerSpec
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.InnerSpec} InnerSpec
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ InnerSpec.decode = function decode(reader, length) {
            if (!(reader instanceof $06fa977204174ead$var$$Reader)) reader = $06fa977204174ead$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $06fa977204174ead$var$$root.ics23.InnerSpec();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        if (!(message.childOrder && message.childOrder.length)) message.childOrder = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while(reader.pos < end2)message.childOrder.push(reader.int32());
                        } else message.childOrder.push(reader.int32());
                        break;
                    case 2:
                        message.childSize = reader.int32();
                        break;
                    case 3:
                        message.minPrefixLength = reader.int32();
                        break;
                    case 4:
                        message.maxPrefixLength = reader.int32();
                        break;
                    case 5:
                        message.emptyChild = reader.bytes();
                        break;
                    case 6:
                        message.hash = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes an InnerSpec message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.InnerSpec
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.InnerSpec} InnerSpec
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ InnerSpec.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $06fa977204174ead$var$$Reader)) reader = new $06fa977204174ead$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies an InnerSpec message.
         * @function verify
         * @memberof ics23.InnerSpec
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ InnerSpec.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.childOrder != null && message.hasOwnProperty("childOrder")) {
                if (!Array.isArray(message.childOrder)) return "childOrder: array expected";
                for(var i = 0; i < message.childOrder.length; ++i)if (!$06fa977204174ead$var$$util.isInteger(message.childOrder[i])) return "childOrder: integer[] expected";
            }
            if (message.childSize != null && message.hasOwnProperty("childSize")) {
                if (!$06fa977204174ead$var$$util.isInteger(message.childSize)) return "childSize: integer expected";
            }
            if (message.minPrefixLength != null && message.hasOwnProperty("minPrefixLength")) {
                if (!$06fa977204174ead$var$$util.isInteger(message.minPrefixLength)) return "minPrefixLength: integer expected";
            }
            if (message.maxPrefixLength != null && message.hasOwnProperty("maxPrefixLength")) {
                if (!$06fa977204174ead$var$$util.isInteger(message.maxPrefixLength)) return "maxPrefixLength: integer expected";
            }
            if (message.emptyChild != null && message.hasOwnProperty("emptyChild")) {
                if (!(message.emptyChild && typeof message.emptyChild.length === "number" || $06fa977204174ead$var$$util.isString(message.emptyChild))) return "emptyChild: buffer expected";
            }
            if (message.hash != null && message.hasOwnProperty("hash")) switch(message.hash){
                default:
                    return "hash: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                    break;
            }
            return null;
        };
        /**
         * Creates an InnerSpec message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.InnerSpec
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.InnerSpec} InnerSpec
         */ InnerSpec.fromObject = function fromObject(object) {
            if (object instanceof $06fa977204174ead$var$$root.ics23.InnerSpec) return object;
            var message = new $06fa977204174ead$var$$root.ics23.InnerSpec();
            if (object.childOrder) {
                if (!Array.isArray(object.childOrder)) throw TypeError(".ics23.InnerSpec.childOrder: array expected");
                message.childOrder = [];
                for(var i = 0; i < object.childOrder.length; ++i)message.childOrder[i] = object.childOrder[i] | 0;
            }
            if (object.childSize != null) message.childSize = object.childSize | 0;
            if (object.minPrefixLength != null) message.minPrefixLength = object.minPrefixLength | 0;
            if (object.maxPrefixLength != null) message.maxPrefixLength = object.maxPrefixLength | 0;
            if (object.emptyChild != null) {
                if (typeof object.emptyChild === "string") $06fa977204174ead$var$$util.base64.decode(object.emptyChild, message.emptyChild = $06fa977204174ead$var$$util.newBuffer($06fa977204174ead$var$$util.base64.length(object.emptyChild)), 0);
                else if (object.emptyChild.length) message.emptyChild = object.emptyChild;
            }
            switch(object.hash){
                case "NO_HASH":
                case 0:
                    message.hash = 0;
                    break;
                case "SHA256":
                case 1:
                    message.hash = 1;
                    break;
                case "SHA512":
                case 2:
                    message.hash = 2;
                    break;
                case "KECCAK":
                case 3:
                    message.hash = 3;
                    break;
                case "RIPEMD160":
                case 4:
                    message.hash = 4;
                    break;
                case "BITCOIN":
                case 5:
                    message.hash = 5;
                    break;
                case "SHA512_256":
                case 6:
                    message.hash = 6;
                    break;
            }
            return message;
        };
        /**
         * Creates a plain object from an InnerSpec message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.InnerSpec
         * @static
         * @param {ics23.InnerSpec} message InnerSpec
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ InnerSpec.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.childOrder = [];
            if (options.defaults) {
                object.childSize = 0;
                object.minPrefixLength = 0;
                object.maxPrefixLength = 0;
                if (options.bytes === String) object.emptyChild = "";
                else {
                    object.emptyChild = [];
                    if (options.bytes !== Array) object.emptyChild = $06fa977204174ead$var$$util.newBuffer(object.emptyChild);
                }
                object.hash = options.enums === String ? "NO_HASH" : 0;
            }
            if (message.childOrder && message.childOrder.length) {
                object.childOrder = [];
                for(var j = 0; j < message.childOrder.length; ++j)object.childOrder[j] = message.childOrder[j];
            }
            if (message.childSize != null && message.hasOwnProperty("childSize")) object.childSize = message.childSize;
            if (message.minPrefixLength != null && message.hasOwnProperty("minPrefixLength")) object.minPrefixLength = message.minPrefixLength;
            if (message.maxPrefixLength != null && message.hasOwnProperty("maxPrefixLength")) object.maxPrefixLength = message.maxPrefixLength;
            if (message.emptyChild != null && message.hasOwnProperty("emptyChild")) object.emptyChild = options.bytes === String ? $06fa977204174ead$var$$util.base64.encode(message.emptyChild, 0, message.emptyChild.length) : options.bytes === Array ? Array.prototype.slice.call(message.emptyChild) : message.emptyChild;
            if (message.hash != null && message.hasOwnProperty("hash")) object.hash = options.enums === String ? $06fa977204174ead$var$$root.ics23.HashOp[message.hash] : message.hash;
            return object;
        };
        /**
         * Converts this InnerSpec to JSON.
         * @function toJSON
         * @memberof ics23.InnerSpec
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ InnerSpec.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $i2pIU.util.toJSONOptions);
        };
        return InnerSpec;
    }();
    ics23.BatchProof = function() {
        /**
         * Properties of a BatchProof.
         * @memberof ics23
         * @interface IBatchProof
         * @property {Array.<ics23.IBatchEntry>|null} [entries] BatchProof entries
         */ /**
         * Constructs a new BatchProof.
         * @memberof ics23
         * @classdesc Represents a BatchProof.
         * @implements IBatchProof
         * @constructor
         * @param {ics23.IBatchProof=} [properties] Properties to set
         */ function BatchProof(properties) {
            this.entries = [];
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * BatchProof entries.
         * @member {Array.<ics23.IBatchEntry>} entries
         * @memberof ics23.BatchProof
         * @instance
         */ BatchProof.prototype.entries = $06fa977204174ead$var$$util.emptyArray;
        /**
         * Creates a new BatchProof instance using the specified properties.
         * @function create
         * @memberof ics23.BatchProof
         * @static
         * @param {ics23.IBatchProof=} [properties] Properties to set
         * @returns {ics23.BatchProof} BatchProof instance
         */ BatchProof.create = function create(properties) {
            return new BatchProof(properties);
        };
        /**
         * Encodes the specified BatchProof message. Does not implicitly {@link ics23.BatchProof.verify|verify} messages.
         * @function encode
         * @memberof ics23.BatchProof
         * @static
         * @param {ics23.IBatchProof} message BatchProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ BatchProof.encode = function encode(message, writer) {
            if (!writer) writer = $06fa977204174ead$var$$Writer.create();
            if (message.entries != null && message.entries.length) for(var i = 0; i < message.entries.length; ++i)$06fa977204174ead$var$$root.ics23.BatchEntry.encode(message.entries[i], writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
            return writer;
        };
        /**
         * Encodes the specified BatchProof message, length delimited. Does not implicitly {@link ics23.BatchProof.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.BatchProof
         * @static
         * @param {ics23.IBatchProof} message BatchProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ BatchProof.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a BatchProof message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.BatchProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.BatchProof} BatchProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ BatchProof.decode = function decode(reader, length) {
            if (!(reader instanceof $06fa977204174ead$var$$Reader)) reader = $06fa977204174ead$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $06fa977204174ead$var$$root.ics23.BatchProof();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        if (!(message.entries && message.entries.length)) message.entries = [];
                        message.entries.push($06fa977204174ead$var$$root.ics23.BatchEntry.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a BatchProof message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.BatchProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.BatchProof} BatchProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ BatchProof.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $06fa977204174ead$var$$Reader)) reader = new $06fa977204174ead$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a BatchProof message.
         * @function verify
         * @memberof ics23.BatchProof
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ BatchProof.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.entries != null && message.hasOwnProperty("entries")) {
                if (!Array.isArray(message.entries)) return "entries: array expected";
                for(var i = 0; i < message.entries.length; ++i){
                    var error = $06fa977204174ead$var$$root.ics23.BatchEntry.verify(message.entries[i]);
                    if (error) return "entries." + error;
                }
            }
            return null;
        };
        /**
         * Creates a BatchProof message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.BatchProof
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.BatchProof} BatchProof
         */ BatchProof.fromObject = function fromObject(object) {
            if (object instanceof $06fa977204174ead$var$$root.ics23.BatchProof) return object;
            var message = new $06fa977204174ead$var$$root.ics23.BatchProof();
            if (object.entries) {
                if (!Array.isArray(object.entries)) throw TypeError(".ics23.BatchProof.entries: array expected");
                message.entries = [];
                for(var i = 0; i < object.entries.length; ++i){
                    if (typeof object.entries[i] !== "object") throw TypeError(".ics23.BatchProof.entries: object expected");
                    message.entries[i] = $06fa977204174ead$var$$root.ics23.BatchEntry.fromObject(object.entries[i]);
                }
            }
            return message;
        };
        /**
         * Creates a plain object from a BatchProof message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.BatchProof
         * @static
         * @param {ics23.BatchProof} message BatchProof
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ BatchProof.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.entries = [];
            if (message.entries && message.entries.length) {
                object.entries = [];
                for(var j = 0; j < message.entries.length; ++j)object.entries[j] = $06fa977204174ead$var$$root.ics23.BatchEntry.toObject(message.entries[j], options);
            }
            return object;
        };
        /**
         * Converts this BatchProof to JSON.
         * @function toJSON
         * @memberof ics23.BatchProof
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ BatchProof.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $i2pIU.util.toJSONOptions);
        };
        return BatchProof;
    }();
    ics23.BatchEntry = function() {
        /**
         * Properties of a BatchEntry.
         * @memberof ics23
         * @interface IBatchEntry
         * @property {ics23.IExistenceProof|null} [exist] BatchEntry exist
         * @property {ics23.INonExistenceProof|null} [nonexist] BatchEntry nonexist
         */ /**
         * Constructs a new BatchEntry.
         * @memberof ics23
         * @classdesc Represents a BatchEntry.
         * @implements IBatchEntry
         * @constructor
         * @param {ics23.IBatchEntry=} [properties] Properties to set
         */ function BatchEntry(properties) {
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * BatchEntry exist.
         * @member {ics23.IExistenceProof|null|undefined} exist
         * @memberof ics23.BatchEntry
         * @instance
         */ BatchEntry.prototype.exist = null;
        /**
         * BatchEntry nonexist.
         * @member {ics23.INonExistenceProof|null|undefined} nonexist
         * @memberof ics23.BatchEntry
         * @instance
         */ BatchEntry.prototype.nonexist = null;
        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;
        /**
         * BatchEntry proof.
         * @member {"exist"|"nonexist"|undefined} proof
         * @memberof ics23.BatchEntry
         * @instance
         */ Object.defineProperty(BatchEntry.prototype, "proof", {
            get: $06fa977204174ead$var$$util.oneOfGetter($oneOfFields = [
                "exist",
                "nonexist"
            ]),
            set: $06fa977204174ead$var$$util.oneOfSetter($oneOfFields)
        });
        /**
         * Creates a new BatchEntry instance using the specified properties.
         * @function create
         * @memberof ics23.BatchEntry
         * @static
         * @param {ics23.IBatchEntry=} [properties] Properties to set
         * @returns {ics23.BatchEntry} BatchEntry instance
         */ BatchEntry.create = function create(properties) {
            return new BatchEntry(properties);
        };
        /**
         * Encodes the specified BatchEntry message. Does not implicitly {@link ics23.BatchEntry.verify|verify} messages.
         * @function encode
         * @memberof ics23.BatchEntry
         * @static
         * @param {ics23.IBatchEntry} message BatchEntry message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ BatchEntry.encode = function encode(message, writer) {
            if (!writer) writer = $06fa977204174ead$var$$Writer.create();
            if (message.exist != null && message.hasOwnProperty("exist")) $06fa977204174ead$var$$root.ics23.ExistenceProof.encode(message.exist, writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) $06fa977204174ead$var$$root.ics23.NonExistenceProof.encode(message.nonexist, writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
            return writer;
        };
        /**
         * Encodes the specified BatchEntry message, length delimited. Does not implicitly {@link ics23.BatchEntry.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.BatchEntry
         * @static
         * @param {ics23.IBatchEntry} message BatchEntry message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ BatchEntry.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a BatchEntry message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.BatchEntry
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.BatchEntry} BatchEntry
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ BatchEntry.decode = function decode(reader, length) {
            if (!(reader instanceof $06fa977204174ead$var$$Reader)) reader = $06fa977204174ead$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $06fa977204174ead$var$$root.ics23.BatchEntry();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.exist = $06fa977204174ead$var$$root.ics23.ExistenceProof.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.nonexist = $06fa977204174ead$var$$root.ics23.NonExistenceProof.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a BatchEntry message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.BatchEntry
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.BatchEntry} BatchEntry
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ BatchEntry.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $06fa977204174ead$var$$Reader)) reader = new $06fa977204174ead$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a BatchEntry message.
         * @function verify
         * @memberof ics23.BatchEntry
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ BatchEntry.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            var properties = {};
            if (message.exist != null && message.hasOwnProperty("exist")) {
                properties.proof = 1;
                var error = $06fa977204174ead$var$$root.ics23.ExistenceProof.verify(message.exist);
                if (error) return "exist." + error;
            }
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) {
                if (properties.proof === 1) return "proof: multiple values";
                properties.proof = 1;
                var error = $06fa977204174ead$var$$root.ics23.NonExistenceProof.verify(message.nonexist);
                if (error) return "nonexist." + error;
            }
            return null;
        };
        /**
         * Creates a BatchEntry message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.BatchEntry
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.BatchEntry} BatchEntry
         */ BatchEntry.fromObject = function fromObject(object) {
            if (object instanceof $06fa977204174ead$var$$root.ics23.BatchEntry) return object;
            var message = new $06fa977204174ead$var$$root.ics23.BatchEntry();
            if (object.exist != null) {
                if (typeof object.exist !== "object") throw TypeError(".ics23.BatchEntry.exist: object expected");
                message.exist = $06fa977204174ead$var$$root.ics23.ExistenceProof.fromObject(object.exist);
            }
            if (object.nonexist != null) {
                if (typeof object.nonexist !== "object") throw TypeError(".ics23.BatchEntry.nonexist: object expected");
                message.nonexist = $06fa977204174ead$var$$root.ics23.NonExistenceProof.fromObject(object.nonexist);
            }
            return message;
        };
        /**
         * Creates a plain object from a BatchEntry message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.BatchEntry
         * @static
         * @param {ics23.BatchEntry} message BatchEntry
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ BatchEntry.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (message.exist != null && message.hasOwnProperty("exist")) {
                object.exist = $06fa977204174ead$var$$root.ics23.ExistenceProof.toObject(message.exist, options);
                if (options.oneofs) object.proof = "exist";
            }
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) {
                object.nonexist = $06fa977204174ead$var$$root.ics23.NonExistenceProof.toObject(message.nonexist, options);
                if (options.oneofs) object.proof = "nonexist";
            }
            return object;
        };
        /**
         * Converts this BatchEntry to JSON.
         * @function toJSON
         * @memberof ics23.BatchEntry
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ BatchEntry.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $i2pIU.util.toJSONOptions);
        };
        return BatchEntry;
    }();
    ics23.CompressedBatchProof = function() {
        /**
         * Properties of a CompressedBatchProof.
         * @memberof ics23
         * @interface ICompressedBatchProof
         * @property {Array.<ics23.ICompressedBatchEntry>|null} [entries] CompressedBatchProof entries
         * @property {Array.<ics23.IInnerOp>|null} [lookupInners] CompressedBatchProof lookupInners
         */ /**
         * Constructs a new CompressedBatchProof.
         * @memberof ics23
         * @classdesc Represents a CompressedBatchProof.
         * @implements ICompressedBatchProof
         * @constructor
         * @param {ics23.ICompressedBatchProof=} [properties] Properties to set
         */ function CompressedBatchProof(properties) {
            this.entries = [];
            this.lookupInners = [];
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * CompressedBatchProof entries.
         * @member {Array.<ics23.ICompressedBatchEntry>} entries
         * @memberof ics23.CompressedBatchProof
         * @instance
         */ CompressedBatchProof.prototype.entries = $06fa977204174ead$var$$util.emptyArray;
        /**
         * CompressedBatchProof lookupInners.
         * @member {Array.<ics23.IInnerOp>} lookupInners
         * @memberof ics23.CompressedBatchProof
         * @instance
         */ CompressedBatchProof.prototype.lookupInners = $06fa977204174ead$var$$util.emptyArray;
        /**
         * Creates a new CompressedBatchProof instance using the specified properties.
         * @function create
         * @memberof ics23.CompressedBatchProof
         * @static
         * @param {ics23.ICompressedBatchProof=} [properties] Properties to set
         * @returns {ics23.CompressedBatchProof} CompressedBatchProof instance
         */ CompressedBatchProof.create = function create(properties) {
            return new CompressedBatchProof(properties);
        };
        /**
         * Encodes the specified CompressedBatchProof message. Does not implicitly {@link ics23.CompressedBatchProof.verify|verify} messages.
         * @function encode
         * @memberof ics23.CompressedBatchProof
         * @static
         * @param {ics23.ICompressedBatchProof} message CompressedBatchProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CompressedBatchProof.encode = function encode(message, writer) {
            if (!writer) writer = $06fa977204174ead$var$$Writer.create();
            if (message.entries != null && message.entries.length) for(var i = 0; i < message.entries.length; ++i)$06fa977204174ead$var$$root.ics23.CompressedBatchEntry.encode(message.entries[i], writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
            if (message.lookupInners != null && message.lookupInners.length) for(var i = 0; i < message.lookupInners.length; ++i)$06fa977204174ead$var$$root.ics23.InnerOp.encode(message.lookupInners[i], writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
            return writer;
        };
        /**
         * Encodes the specified CompressedBatchProof message, length delimited. Does not implicitly {@link ics23.CompressedBatchProof.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.CompressedBatchProof
         * @static
         * @param {ics23.ICompressedBatchProof} message CompressedBatchProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CompressedBatchProof.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a CompressedBatchProof message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.CompressedBatchProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.CompressedBatchProof} CompressedBatchProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CompressedBatchProof.decode = function decode(reader, length) {
            if (!(reader instanceof $06fa977204174ead$var$$Reader)) reader = $06fa977204174ead$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $06fa977204174ead$var$$root.ics23.CompressedBatchProof();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        if (!(message.entries && message.entries.length)) message.entries = [];
                        message.entries.push($06fa977204174ead$var$$root.ics23.CompressedBatchEntry.decode(reader, reader.uint32()));
                        break;
                    case 2:
                        if (!(message.lookupInners && message.lookupInners.length)) message.lookupInners = [];
                        message.lookupInners.push($06fa977204174ead$var$$root.ics23.InnerOp.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a CompressedBatchProof message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.CompressedBatchProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.CompressedBatchProof} CompressedBatchProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CompressedBatchProof.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $06fa977204174ead$var$$Reader)) reader = new $06fa977204174ead$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a CompressedBatchProof message.
         * @function verify
         * @memberof ics23.CompressedBatchProof
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ CompressedBatchProof.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.entries != null && message.hasOwnProperty("entries")) {
                if (!Array.isArray(message.entries)) return "entries: array expected";
                for(var i = 0; i < message.entries.length; ++i){
                    var error = $06fa977204174ead$var$$root.ics23.CompressedBatchEntry.verify(message.entries[i]);
                    if (error) return "entries." + error;
                }
            }
            if (message.lookupInners != null && message.hasOwnProperty("lookupInners")) {
                if (!Array.isArray(message.lookupInners)) return "lookupInners: array expected";
                for(var i = 0; i < message.lookupInners.length; ++i){
                    var error = $06fa977204174ead$var$$root.ics23.InnerOp.verify(message.lookupInners[i]);
                    if (error) return "lookupInners." + error;
                }
            }
            return null;
        };
        /**
         * Creates a CompressedBatchProof message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.CompressedBatchProof
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.CompressedBatchProof} CompressedBatchProof
         */ CompressedBatchProof.fromObject = function fromObject(object) {
            if (object instanceof $06fa977204174ead$var$$root.ics23.CompressedBatchProof) return object;
            var message = new $06fa977204174ead$var$$root.ics23.CompressedBatchProof();
            if (object.entries) {
                if (!Array.isArray(object.entries)) throw TypeError(".ics23.CompressedBatchProof.entries: array expected");
                message.entries = [];
                for(var i = 0; i < object.entries.length; ++i){
                    if (typeof object.entries[i] !== "object") throw TypeError(".ics23.CompressedBatchProof.entries: object expected");
                    message.entries[i] = $06fa977204174ead$var$$root.ics23.CompressedBatchEntry.fromObject(object.entries[i]);
                }
            }
            if (object.lookupInners) {
                if (!Array.isArray(object.lookupInners)) throw TypeError(".ics23.CompressedBatchProof.lookupInners: array expected");
                message.lookupInners = [];
                for(var i = 0; i < object.lookupInners.length; ++i){
                    if (typeof object.lookupInners[i] !== "object") throw TypeError(".ics23.CompressedBatchProof.lookupInners: object expected");
                    message.lookupInners[i] = $06fa977204174ead$var$$root.ics23.InnerOp.fromObject(object.lookupInners[i]);
                }
            }
            return message;
        };
        /**
         * Creates a plain object from a CompressedBatchProof message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.CompressedBatchProof
         * @static
         * @param {ics23.CompressedBatchProof} message CompressedBatchProof
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ CompressedBatchProof.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.entries = [];
                object.lookupInners = [];
            }
            if (message.entries && message.entries.length) {
                object.entries = [];
                for(var j = 0; j < message.entries.length; ++j)object.entries[j] = $06fa977204174ead$var$$root.ics23.CompressedBatchEntry.toObject(message.entries[j], options);
            }
            if (message.lookupInners && message.lookupInners.length) {
                object.lookupInners = [];
                for(var j = 0; j < message.lookupInners.length; ++j)object.lookupInners[j] = $06fa977204174ead$var$$root.ics23.InnerOp.toObject(message.lookupInners[j], options);
            }
            return object;
        };
        /**
         * Converts this CompressedBatchProof to JSON.
         * @function toJSON
         * @memberof ics23.CompressedBatchProof
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ CompressedBatchProof.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $i2pIU.util.toJSONOptions);
        };
        return CompressedBatchProof;
    }();
    ics23.CompressedBatchEntry = function() {
        /**
         * Properties of a CompressedBatchEntry.
         * @memberof ics23
         * @interface ICompressedBatchEntry
         * @property {ics23.ICompressedExistenceProof|null} [exist] CompressedBatchEntry exist
         * @property {ics23.ICompressedNonExistenceProof|null} [nonexist] CompressedBatchEntry nonexist
         */ /**
         * Constructs a new CompressedBatchEntry.
         * @memberof ics23
         * @classdesc Represents a CompressedBatchEntry.
         * @implements ICompressedBatchEntry
         * @constructor
         * @param {ics23.ICompressedBatchEntry=} [properties] Properties to set
         */ function CompressedBatchEntry(properties) {
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * CompressedBatchEntry exist.
         * @member {ics23.ICompressedExistenceProof|null|undefined} exist
         * @memberof ics23.CompressedBatchEntry
         * @instance
         */ CompressedBatchEntry.prototype.exist = null;
        /**
         * CompressedBatchEntry nonexist.
         * @member {ics23.ICompressedNonExistenceProof|null|undefined} nonexist
         * @memberof ics23.CompressedBatchEntry
         * @instance
         */ CompressedBatchEntry.prototype.nonexist = null;
        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;
        /**
         * CompressedBatchEntry proof.
         * @member {"exist"|"nonexist"|undefined} proof
         * @memberof ics23.CompressedBatchEntry
         * @instance
         */ Object.defineProperty(CompressedBatchEntry.prototype, "proof", {
            get: $06fa977204174ead$var$$util.oneOfGetter($oneOfFields = [
                "exist",
                "nonexist"
            ]),
            set: $06fa977204174ead$var$$util.oneOfSetter($oneOfFields)
        });
        /**
         * Creates a new CompressedBatchEntry instance using the specified properties.
         * @function create
         * @memberof ics23.CompressedBatchEntry
         * @static
         * @param {ics23.ICompressedBatchEntry=} [properties] Properties to set
         * @returns {ics23.CompressedBatchEntry} CompressedBatchEntry instance
         */ CompressedBatchEntry.create = function create(properties) {
            return new CompressedBatchEntry(properties);
        };
        /**
         * Encodes the specified CompressedBatchEntry message. Does not implicitly {@link ics23.CompressedBatchEntry.verify|verify} messages.
         * @function encode
         * @memberof ics23.CompressedBatchEntry
         * @static
         * @param {ics23.ICompressedBatchEntry} message CompressedBatchEntry message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CompressedBatchEntry.encode = function encode(message, writer) {
            if (!writer) writer = $06fa977204174ead$var$$Writer.create();
            if (message.exist != null && message.hasOwnProperty("exist")) $06fa977204174ead$var$$root.ics23.CompressedExistenceProof.encode(message.exist, writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) $06fa977204174ead$var$$root.ics23.CompressedNonExistenceProof.encode(message.nonexist, writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
            return writer;
        };
        /**
         * Encodes the specified CompressedBatchEntry message, length delimited. Does not implicitly {@link ics23.CompressedBatchEntry.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.CompressedBatchEntry
         * @static
         * @param {ics23.ICompressedBatchEntry} message CompressedBatchEntry message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CompressedBatchEntry.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a CompressedBatchEntry message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.CompressedBatchEntry
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.CompressedBatchEntry} CompressedBatchEntry
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CompressedBatchEntry.decode = function decode(reader, length) {
            if (!(reader instanceof $06fa977204174ead$var$$Reader)) reader = $06fa977204174ead$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $06fa977204174ead$var$$root.ics23.CompressedBatchEntry();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.exist = $06fa977204174ead$var$$root.ics23.CompressedExistenceProof.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.nonexist = $06fa977204174ead$var$$root.ics23.CompressedNonExistenceProof.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a CompressedBatchEntry message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.CompressedBatchEntry
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.CompressedBatchEntry} CompressedBatchEntry
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CompressedBatchEntry.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $06fa977204174ead$var$$Reader)) reader = new $06fa977204174ead$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a CompressedBatchEntry message.
         * @function verify
         * @memberof ics23.CompressedBatchEntry
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ CompressedBatchEntry.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            var properties = {};
            if (message.exist != null && message.hasOwnProperty("exist")) {
                properties.proof = 1;
                var error = $06fa977204174ead$var$$root.ics23.CompressedExistenceProof.verify(message.exist);
                if (error) return "exist." + error;
            }
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) {
                if (properties.proof === 1) return "proof: multiple values";
                properties.proof = 1;
                var error = $06fa977204174ead$var$$root.ics23.CompressedNonExistenceProof.verify(message.nonexist);
                if (error) return "nonexist." + error;
            }
            return null;
        };
        /**
         * Creates a CompressedBatchEntry message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.CompressedBatchEntry
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.CompressedBatchEntry} CompressedBatchEntry
         */ CompressedBatchEntry.fromObject = function fromObject(object) {
            if (object instanceof $06fa977204174ead$var$$root.ics23.CompressedBatchEntry) return object;
            var message = new $06fa977204174ead$var$$root.ics23.CompressedBatchEntry();
            if (object.exist != null) {
                if (typeof object.exist !== "object") throw TypeError(".ics23.CompressedBatchEntry.exist: object expected");
                message.exist = $06fa977204174ead$var$$root.ics23.CompressedExistenceProof.fromObject(object.exist);
            }
            if (object.nonexist != null) {
                if (typeof object.nonexist !== "object") throw TypeError(".ics23.CompressedBatchEntry.nonexist: object expected");
                message.nonexist = $06fa977204174ead$var$$root.ics23.CompressedNonExistenceProof.fromObject(object.nonexist);
            }
            return message;
        };
        /**
         * Creates a plain object from a CompressedBatchEntry message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.CompressedBatchEntry
         * @static
         * @param {ics23.CompressedBatchEntry} message CompressedBatchEntry
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ CompressedBatchEntry.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (message.exist != null && message.hasOwnProperty("exist")) {
                object.exist = $06fa977204174ead$var$$root.ics23.CompressedExistenceProof.toObject(message.exist, options);
                if (options.oneofs) object.proof = "exist";
            }
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) {
                object.nonexist = $06fa977204174ead$var$$root.ics23.CompressedNonExistenceProof.toObject(message.nonexist, options);
                if (options.oneofs) object.proof = "nonexist";
            }
            return object;
        };
        /**
         * Converts this CompressedBatchEntry to JSON.
         * @function toJSON
         * @memberof ics23.CompressedBatchEntry
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ CompressedBatchEntry.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $i2pIU.util.toJSONOptions);
        };
        return CompressedBatchEntry;
    }();
    ics23.CompressedExistenceProof = function() {
        /**
         * Properties of a CompressedExistenceProof.
         * @memberof ics23
         * @interface ICompressedExistenceProof
         * @property {Uint8Array|null} [key] CompressedExistenceProof key
         * @property {Uint8Array|null} [value] CompressedExistenceProof value
         * @property {ics23.ILeafOp|null} [leaf] CompressedExistenceProof leaf
         * @property {Array.<number>|null} [path] CompressedExistenceProof path
         */ /**
         * Constructs a new CompressedExistenceProof.
         * @memberof ics23
         * @classdesc Represents a CompressedExistenceProof.
         * @implements ICompressedExistenceProof
         * @constructor
         * @param {ics23.ICompressedExistenceProof=} [properties] Properties to set
         */ function CompressedExistenceProof(properties) {
            this.path = [];
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * CompressedExistenceProof key.
         * @member {Uint8Array} key
         * @memberof ics23.CompressedExistenceProof
         * @instance
         */ CompressedExistenceProof.prototype.key = $06fa977204174ead$var$$util.newBuffer([]);
        /**
         * CompressedExistenceProof value.
         * @member {Uint8Array} value
         * @memberof ics23.CompressedExistenceProof
         * @instance
         */ CompressedExistenceProof.prototype.value = $06fa977204174ead$var$$util.newBuffer([]);
        /**
         * CompressedExistenceProof leaf.
         * @member {ics23.ILeafOp|null|undefined} leaf
         * @memberof ics23.CompressedExistenceProof
         * @instance
         */ CompressedExistenceProof.prototype.leaf = null;
        /**
         * CompressedExistenceProof path.
         * @member {Array.<number>} path
         * @memberof ics23.CompressedExistenceProof
         * @instance
         */ CompressedExistenceProof.prototype.path = $06fa977204174ead$var$$util.emptyArray;
        /**
         * Creates a new CompressedExistenceProof instance using the specified properties.
         * @function create
         * @memberof ics23.CompressedExistenceProof
         * @static
         * @param {ics23.ICompressedExistenceProof=} [properties] Properties to set
         * @returns {ics23.CompressedExistenceProof} CompressedExistenceProof instance
         */ CompressedExistenceProof.create = function create(properties) {
            return new CompressedExistenceProof(properties);
        };
        /**
         * Encodes the specified CompressedExistenceProof message. Does not implicitly {@link ics23.CompressedExistenceProof.verify|verify} messages.
         * @function encode
         * @memberof ics23.CompressedExistenceProof
         * @static
         * @param {ics23.ICompressedExistenceProof} message CompressedExistenceProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CompressedExistenceProof.encode = function encode(message, writer) {
            if (!writer) writer = $06fa977204174ead$var$$Writer.create();
            if (message.key != null && message.hasOwnProperty("key")) writer.uint32(/* id 1, wireType 2 =*/ 10).bytes(message.key);
            if (message.value != null && message.hasOwnProperty("value")) writer.uint32(/* id 2, wireType 2 =*/ 18).bytes(message.value);
            if (message.leaf != null && message.hasOwnProperty("leaf")) $06fa977204174ead$var$$root.ics23.LeafOp.encode(message.leaf, writer.uint32(/* id 3, wireType 2 =*/ 26).fork()).ldelim();
            if (message.path != null && message.path.length) {
                writer.uint32(/* id 4, wireType 2 =*/ 34).fork();
                for(var i = 0; i < message.path.length; ++i)writer.int32(message.path[i]);
                writer.ldelim();
            }
            return writer;
        };
        /**
         * Encodes the specified CompressedExistenceProof message, length delimited. Does not implicitly {@link ics23.CompressedExistenceProof.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.CompressedExistenceProof
         * @static
         * @param {ics23.ICompressedExistenceProof} message CompressedExistenceProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CompressedExistenceProof.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a CompressedExistenceProof message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.CompressedExistenceProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.CompressedExistenceProof} CompressedExistenceProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CompressedExistenceProof.decode = function decode(reader, length) {
            if (!(reader instanceof $06fa977204174ead$var$$Reader)) reader = $06fa977204174ead$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $06fa977204174ead$var$$root.ics23.CompressedExistenceProof();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.key = reader.bytes();
                        break;
                    case 2:
                        message.value = reader.bytes();
                        break;
                    case 3:
                        message.leaf = $06fa977204174ead$var$$root.ics23.LeafOp.decode(reader, reader.uint32());
                        break;
                    case 4:
                        if (!(message.path && message.path.length)) message.path = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while(reader.pos < end2)message.path.push(reader.int32());
                        } else message.path.push(reader.int32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a CompressedExistenceProof message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.CompressedExistenceProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.CompressedExistenceProof} CompressedExistenceProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CompressedExistenceProof.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $06fa977204174ead$var$$Reader)) reader = new $06fa977204174ead$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a CompressedExistenceProof message.
         * @function verify
         * @memberof ics23.CompressedExistenceProof
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ CompressedExistenceProof.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.key != null && message.hasOwnProperty("key")) {
                if (!(message.key && typeof message.key.length === "number" || $06fa977204174ead$var$$util.isString(message.key))) return "key: buffer expected";
            }
            if (message.value != null && message.hasOwnProperty("value")) {
                if (!(message.value && typeof message.value.length === "number" || $06fa977204174ead$var$$util.isString(message.value))) return "value: buffer expected";
            }
            if (message.leaf != null && message.hasOwnProperty("leaf")) {
                var error = $06fa977204174ead$var$$root.ics23.LeafOp.verify(message.leaf);
                if (error) return "leaf." + error;
            }
            if (message.path != null && message.hasOwnProperty("path")) {
                if (!Array.isArray(message.path)) return "path: array expected";
                for(var i = 0; i < message.path.length; ++i)if (!$06fa977204174ead$var$$util.isInteger(message.path[i])) return "path: integer[] expected";
            }
            return null;
        };
        /**
         * Creates a CompressedExistenceProof message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.CompressedExistenceProof
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.CompressedExistenceProof} CompressedExistenceProof
         */ CompressedExistenceProof.fromObject = function fromObject(object) {
            if (object instanceof $06fa977204174ead$var$$root.ics23.CompressedExistenceProof) return object;
            var message = new $06fa977204174ead$var$$root.ics23.CompressedExistenceProof();
            if (object.key != null) {
                if (typeof object.key === "string") $06fa977204174ead$var$$util.base64.decode(object.key, message.key = $06fa977204174ead$var$$util.newBuffer($06fa977204174ead$var$$util.base64.length(object.key)), 0);
                else if (object.key.length) message.key = object.key;
            }
            if (object.value != null) {
                if (typeof object.value === "string") $06fa977204174ead$var$$util.base64.decode(object.value, message.value = $06fa977204174ead$var$$util.newBuffer($06fa977204174ead$var$$util.base64.length(object.value)), 0);
                else if (object.value.length) message.value = object.value;
            }
            if (object.leaf != null) {
                if (typeof object.leaf !== "object") throw TypeError(".ics23.CompressedExistenceProof.leaf: object expected");
                message.leaf = $06fa977204174ead$var$$root.ics23.LeafOp.fromObject(object.leaf);
            }
            if (object.path) {
                if (!Array.isArray(object.path)) throw TypeError(".ics23.CompressedExistenceProof.path: array expected");
                message.path = [];
                for(var i = 0; i < object.path.length; ++i)message.path[i] = object.path[i] | 0;
            }
            return message;
        };
        /**
         * Creates a plain object from a CompressedExistenceProof message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.CompressedExistenceProof
         * @static
         * @param {ics23.CompressedExistenceProof} message CompressedExistenceProof
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ CompressedExistenceProof.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.path = [];
            if (options.defaults) {
                if (options.bytes === String) object.key = "";
                else {
                    object.key = [];
                    if (options.bytes !== Array) object.key = $06fa977204174ead$var$$util.newBuffer(object.key);
                }
                if (options.bytes === String) object.value = "";
                else {
                    object.value = [];
                    if (options.bytes !== Array) object.value = $06fa977204174ead$var$$util.newBuffer(object.value);
                }
                object.leaf = null;
            }
            if (message.key != null && message.hasOwnProperty("key")) object.key = options.bytes === String ? $06fa977204174ead$var$$util.base64.encode(message.key, 0, message.key.length) : options.bytes === Array ? Array.prototype.slice.call(message.key) : message.key;
            if (message.value != null && message.hasOwnProperty("value")) object.value = options.bytes === String ? $06fa977204174ead$var$$util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
            if (message.leaf != null && message.hasOwnProperty("leaf")) object.leaf = $06fa977204174ead$var$$root.ics23.LeafOp.toObject(message.leaf, options);
            if (message.path && message.path.length) {
                object.path = [];
                for(var j = 0; j < message.path.length; ++j)object.path[j] = message.path[j];
            }
            return object;
        };
        /**
         * Converts this CompressedExistenceProof to JSON.
         * @function toJSON
         * @memberof ics23.CompressedExistenceProof
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ CompressedExistenceProof.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $i2pIU.util.toJSONOptions);
        };
        return CompressedExistenceProof;
    }();
    ics23.CompressedNonExistenceProof = function() {
        /**
         * Properties of a CompressedNonExistenceProof.
         * @memberof ics23
         * @interface ICompressedNonExistenceProof
         * @property {Uint8Array|null} [key] CompressedNonExistenceProof key
         * @property {ics23.ICompressedExistenceProof|null} [left] CompressedNonExistenceProof left
         * @property {ics23.ICompressedExistenceProof|null} [right] CompressedNonExistenceProof right
         */ /**
         * Constructs a new CompressedNonExistenceProof.
         * @memberof ics23
         * @classdesc Represents a CompressedNonExistenceProof.
         * @implements ICompressedNonExistenceProof
         * @constructor
         * @param {ics23.ICompressedNonExistenceProof=} [properties] Properties to set
         */ function CompressedNonExistenceProof(properties) {
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * CompressedNonExistenceProof key.
         * @member {Uint8Array} key
         * @memberof ics23.CompressedNonExistenceProof
         * @instance
         */ CompressedNonExistenceProof.prototype.key = $06fa977204174ead$var$$util.newBuffer([]);
        /**
         * CompressedNonExistenceProof left.
         * @member {ics23.ICompressedExistenceProof|null|undefined} left
         * @memberof ics23.CompressedNonExistenceProof
         * @instance
         */ CompressedNonExistenceProof.prototype.left = null;
        /**
         * CompressedNonExistenceProof right.
         * @member {ics23.ICompressedExistenceProof|null|undefined} right
         * @memberof ics23.CompressedNonExistenceProof
         * @instance
         */ CompressedNonExistenceProof.prototype.right = null;
        /**
         * Creates a new CompressedNonExistenceProof instance using the specified properties.
         * @function create
         * @memberof ics23.CompressedNonExistenceProof
         * @static
         * @param {ics23.ICompressedNonExistenceProof=} [properties] Properties to set
         * @returns {ics23.CompressedNonExistenceProof} CompressedNonExistenceProof instance
         */ CompressedNonExistenceProof.create = function create(properties) {
            return new CompressedNonExistenceProof(properties);
        };
        /**
         * Encodes the specified CompressedNonExistenceProof message. Does not implicitly {@link ics23.CompressedNonExistenceProof.verify|verify} messages.
         * @function encode
         * @memberof ics23.CompressedNonExistenceProof
         * @static
         * @param {ics23.ICompressedNonExistenceProof} message CompressedNonExistenceProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CompressedNonExistenceProof.encode = function encode(message, writer) {
            if (!writer) writer = $06fa977204174ead$var$$Writer.create();
            if (message.key != null && message.hasOwnProperty("key")) writer.uint32(/* id 1, wireType 2 =*/ 10).bytes(message.key);
            if (message.left != null && message.hasOwnProperty("left")) $06fa977204174ead$var$$root.ics23.CompressedExistenceProof.encode(message.left, writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
            if (message.right != null && message.hasOwnProperty("right")) $06fa977204174ead$var$$root.ics23.CompressedExistenceProof.encode(message.right, writer.uint32(/* id 3, wireType 2 =*/ 26).fork()).ldelim();
            return writer;
        };
        /**
         * Encodes the specified CompressedNonExistenceProof message, length delimited. Does not implicitly {@link ics23.CompressedNonExistenceProof.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.CompressedNonExistenceProof
         * @static
         * @param {ics23.ICompressedNonExistenceProof} message CompressedNonExistenceProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CompressedNonExistenceProof.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a CompressedNonExistenceProof message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.CompressedNonExistenceProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.CompressedNonExistenceProof} CompressedNonExistenceProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CompressedNonExistenceProof.decode = function decode(reader, length) {
            if (!(reader instanceof $06fa977204174ead$var$$Reader)) reader = $06fa977204174ead$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $06fa977204174ead$var$$root.ics23.CompressedNonExistenceProof();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.key = reader.bytes();
                        break;
                    case 2:
                        message.left = $06fa977204174ead$var$$root.ics23.CompressedExistenceProof.decode(reader, reader.uint32());
                        break;
                    case 3:
                        message.right = $06fa977204174ead$var$$root.ics23.CompressedExistenceProof.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a CompressedNonExistenceProof message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.CompressedNonExistenceProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.CompressedNonExistenceProof} CompressedNonExistenceProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CompressedNonExistenceProof.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $06fa977204174ead$var$$Reader)) reader = new $06fa977204174ead$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a CompressedNonExistenceProof message.
         * @function verify
         * @memberof ics23.CompressedNonExistenceProof
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ CompressedNonExistenceProof.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.key != null && message.hasOwnProperty("key")) {
                if (!(message.key && typeof message.key.length === "number" || $06fa977204174ead$var$$util.isString(message.key))) return "key: buffer expected";
            }
            if (message.left != null && message.hasOwnProperty("left")) {
                var error = $06fa977204174ead$var$$root.ics23.CompressedExistenceProof.verify(message.left);
                if (error) return "left." + error;
            }
            if (message.right != null && message.hasOwnProperty("right")) {
                var error = $06fa977204174ead$var$$root.ics23.CompressedExistenceProof.verify(message.right);
                if (error) return "right." + error;
            }
            return null;
        };
        /**
         * Creates a CompressedNonExistenceProof message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.CompressedNonExistenceProof
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.CompressedNonExistenceProof} CompressedNonExistenceProof
         */ CompressedNonExistenceProof.fromObject = function fromObject(object) {
            if (object instanceof $06fa977204174ead$var$$root.ics23.CompressedNonExistenceProof) return object;
            var message = new $06fa977204174ead$var$$root.ics23.CompressedNonExistenceProof();
            if (object.key != null) {
                if (typeof object.key === "string") $06fa977204174ead$var$$util.base64.decode(object.key, message.key = $06fa977204174ead$var$$util.newBuffer($06fa977204174ead$var$$util.base64.length(object.key)), 0);
                else if (object.key.length) message.key = object.key;
            }
            if (object.left != null) {
                if (typeof object.left !== "object") throw TypeError(".ics23.CompressedNonExistenceProof.left: object expected");
                message.left = $06fa977204174ead$var$$root.ics23.CompressedExistenceProof.fromObject(object.left);
            }
            if (object.right != null) {
                if (typeof object.right !== "object") throw TypeError(".ics23.CompressedNonExistenceProof.right: object expected");
                message.right = $06fa977204174ead$var$$root.ics23.CompressedExistenceProof.fromObject(object.right);
            }
            return message;
        };
        /**
         * Creates a plain object from a CompressedNonExistenceProof message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.CompressedNonExistenceProof
         * @static
         * @param {ics23.CompressedNonExistenceProof} message CompressedNonExistenceProof
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ CompressedNonExistenceProof.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String) object.key = "";
                else {
                    object.key = [];
                    if (options.bytes !== Array) object.key = $06fa977204174ead$var$$util.newBuffer(object.key);
                }
                object.left = null;
                object.right = null;
            }
            if (message.key != null && message.hasOwnProperty("key")) object.key = options.bytes === String ? $06fa977204174ead$var$$util.base64.encode(message.key, 0, message.key.length) : options.bytes === Array ? Array.prototype.slice.call(message.key) : message.key;
            if (message.left != null && message.hasOwnProperty("left")) object.left = $06fa977204174ead$var$$root.ics23.CompressedExistenceProof.toObject(message.left, options);
            if (message.right != null && message.hasOwnProperty("right")) object.right = $06fa977204174ead$var$$root.ics23.CompressedExistenceProof.toObject(message.right, options);
            return object;
        };
        /**
         * Converts this CompressedNonExistenceProof to JSON.
         * @function toJSON
         * @memberof ics23.CompressedNonExistenceProof
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ CompressedNonExistenceProof.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $i2pIU.util.toJSONOptions);
        };
        return CompressedNonExistenceProof;
    }();
    return ics23;
}();
$06fa977204174ead$exports = $06fa977204174ead$var$$root;


Object.defineProperty($fc6baa8f2374ecb4$exports, "ics23", {
    enumerable: true,
    get: function() {
        return $06fa977204174ead$exports.ics23;
    }
});
var $480f3411cb2df690$exports = {};
"use strict";
Object.defineProperty($480f3411cb2df690$exports, "__esModule", {
    value: true
});
$480f3411cb2df690$exports.batchVerifyNonMembership = $480f3411cb2df690$exports.batchVerifyMembership = $480f3411cb2df690$exports.verifyNonMembership = $480f3411cb2df690$exports.verifyMembership = void 0;
var $04f4cd4f1ea54c52$exports = {};
"use strict";
Object.defineProperty($04f4cd4f1ea54c52$exports, "__esModule", {
    value: true
});
$04f4cd4f1ea54c52$exports.decompress = $04f4cd4f1ea54c52$exports.compress = void 0;

function $04f4cd4f1ea54c52$var$compress(proof) {
    if (!proof.batch) return proof;
    return {
        compressed: $04f4cd4f1ea54c52$var$compressBatch(proof.batch)
    };
}
$04f4cd4f1ea54c52$exports.compress = $04f4cd4f1ea54c52$var$compress;
function $04f4cd4f1ea54c52$var$decompress(proof) {
    if (!proof.compressed) return proof;
    return {
        batch: $04f4cd4f1ea54c52$var$decompressBatch(proof.compressed)
    };
}
$04f4cd4f1ea54c52$exports.decompress = $04f4cd4f1ea54c52$var$decompress;
function $04f4cd4f1ea54c52$var$compressBatch(proof) {
    const centries = [];
    const lookup = [];
    const registry = new Map();
    for (const entry of proof.entries){
        if (entry.exist) {
            const centry = {
                exist: $04f4cd4f1ea54c52$var$compressExist(entry.exist, lookup, registry)
            };
            centries.push(centry);
        } else if (entry.nonexist) {
            const non = entry.nonexist;
            const centry = {
                nonexist: {
                    key: non.key,
                    left: $04f4cd4f1ea54c52$var$compressExist(non.left, lookup, registry),
                    right: $04f4cd4f1ea54c52$var$compressExist(non.right, lookup, registry)
                }
            };
            centries.push(centry);
        } else throw new Error("Unexpected batch entry during compress");
    }
    return {
        entries: centries,
        lookupInners: lookup
    };
}
function $04f4cd4f1ea54c52$var$compressExist(exist, lookup, registry) {
    if (!exist) return undefined;
    const path = exist.path.map((inner)=>{
        const sig = $06fa977204174ead$exports.ics23.InnerOp.encode(inner).finish();
        let idx = registry.get(sig);
        if (idx === undefined) {
            idx = lookup.length;
            lookup.push(inner);
            registry.set(sig, idx);
        }
        return idx;
    });
    return {
        key: exist.key,
        value: exist.value,
        leaf: exist.leaf,
        path: path
    };
}
function $04f4cd4f1ea54c52$var$decompressBatch(proof) {
    const lookup = proof.lookupInners;
    const entries = proof.entries.map((comp)=>{
        if (comp.exist) return {
            exist: $04f4cd4f1ea54c52$var$decompressExist(comp.exist, lookup)
        };
        else if (comp.nonexist) {
            const non = comp.nonexist;
            return {
                nonexist: {
                    key: non.key,
                    left: $04f4cd4f1ea54c52$var$decompressExist(non.left, lookup),
                    right: $04f4cd4f1ea54c52$var$decompressExist(non.right, lookup)
                }
            };
        } else throw new Error("Unexpected batch entry during compress");
    });
    return {
        entries: entries
    };
}
function $04f4cd4f1ea54c52$var$decompressExist(exist, lookup) {
    if (!exist) return undefined;
    const { key: key, value: value, leaf: leaf, path: path } = exist;
    const newPath = (path || []).map((idx)=>lookup[idx]);
    return {
        key: key,
        value: value,
        leaf: leaf,
        path: newPath
    };
}


var $41d1695d4c511a06$exports = {};
"use strict";
Object.defineProperty($41d1695d4c511a06$exports, "__esModule", {
    value: true
});
$41d1695d4c511a06$exports.ensureLeftNeighbor = $41d1695d4c511a06$exports.ensureSpec = $41d1695d4c511a06$exports.calculateExistenceRoot = $41d1695d4c511a06$exports.verifyNonExistence = $41d1695d4c511a06$exports.verifyExistence = $41d1695d4c511a06$exports.smtSpec = $41d1695d4c511a06$exports.tendermintSpec = $41d1695d4c511a06$exports.iavlSpec = void 0;

var $a395a04f0fbb7379$exports = {};
"use strict";
Object.defineProperty($a395a04f0fbb7379$exports, "__esModule", {
    value: true
});
$a395a04f0fbb7379$exports.doHash = $a395a04f0fbb7379$exports.applyInner = $a395a04f0fbb7379$exports.applyLeaf = void 0;

var $dQbF2 = parcelRequire("dQbF2");

var $HGYq1 = parcelRequire("HGYq1");

var $8MCsS = parcelRequire("8MCsS");

function $a395a04f0fbb7379$var$applyLeaf(leaf, key, value) {
    if (key.length === 0) throw new Error("Missing key");
    if (value.length === 0) throw new Error("Missing value");
    const pkey = $a395a04f0fbb7379$var$prepareLeafData($a395a04f0fbb7379$var$ensureHash(leaf.prehashKey), $a395a04f0fbb7379$var$ensureLength(leaf.length), key);
    const pvalue = $a395a04f0fbb7379$var$prepareLeafData($a395a04f0fbb7379$var$ensureHash(leaf.prehashValue), $a395a04f0fbb7379$var$ensureLength(leaf.length), value);
    const data = new Uint8Array([
        ...$a395a04f0fbb7379$var$ensureBytes(leaf.prefix),
        ...pkey,
        ...pvalue
    ]);
    return $a395a04f0fbb7379$var$doHash($a395a04f0fbb7379$var$ensureHash(leaf.hash), data);
}
$a395a04f0fbb7379$exports.applyLeaf = $a395a04f0fbb7379$var$applyLeaf;
function $a395a04f0fbb7379$var$applyInner(inner, child) {
    if (child.length === 0) throw new Error("Inner op needs child value");
    const preimage = new Uint8Array([
        ...$a395a04f0fbb7379$var$ensureBytes(inner.prefix),
        ...child,
        ...$a395a04f0fbb7379$var$ensureBytes(inner.suffix)
    ]);
    return $a395a04f0fbb7379$var$doHash($a395a04f0fbb7379$var$ensureHash(inner.hash), preimage);
}
$a395a04f0fbb7379$exports.applyInner = $a395a04f0fbb7379$var$applyInner;
function $a395a04f0fbb7379$var$ensure(maybe, value) {
    return maybe === undefined || maybe === null ? value : maybe;
}
const $a395a04f0fbb7379$var$ensureHash = (h)=>$a395a04f0fbb7379$var$ensure(h, $06fa977204174ead$exports.ics23.HashOp.NO_HASH);
const $a395a04f0fbb7379$var$ensureLength = (l)=>$a395a04f0fbb7379$var$ensure(l, $06fa977204174ead$exports.ics23.LengthOp.NO_PREFIX);
const $a395a04f0fbb7379$var$ensureBytes = (b)=>$a395a04f0fbb7379$var$ensure(b, new Uint8Array([]));
function $a395a04f0fbb7379$var$prepareLeafData(hashOp, lengthOp, data) {
    const h = $a395a04f0fbb7379$var$doHashOrNoop(hashOp, data);
    return $a395a04f0fbb7379$var$doLengthOp(lengthOp, h);
}
// doHashOrNoop will return the preimage untouched if hashOp == NONE,
// otherwise, perform doHash
function $a395a04f0fbb7379$var$doHashOrNoop(hashOp, preimage) {
    if (hashOp === $06fa977204174ead$exports.ics23.HashOp.NO_HASH) return preimage;
    return $a395a04f0fbb7379$var$doHash(hashOp, preimage);
}
// doHash will preform the specified hash on the preimage.
// if hashOp == NONE, it will return an error (use doHashOrNoop if you want different behavior)
function $a395a04f0fbb7379$var$doHash(hashOp, preimage) {
    switch(hashOp){
        case $06fa977204174ead$exports.ics23.HashOp.SHA256:
            return (0, $HGYq1.sha256)(preimage);
        case $06fa977204174ead$exports.ics23.HashOp.SHA512:
            return (0, $8MCsS.sha512)(preimage);
        case $06fa977204174ead$exports.ics23.HashOp.RIPEMD160:
            return (0, $dQbF2.ripemd160)(preimage);
        case $06fa977204174ead$exports.ics23.HashOp.BITCOIN:
            return (0, $dQbF2.ripemd160)((0, $HGYq1.sha256)(preimage));
        case $06fa977204174ead$exports.ics23.HashOp.SHA512_256:
            return (0, $8MCsS.sha512_256)(preimage);
    }
    throw new Error(`Unsupported hashop: ${hashOp}`);
}
$a395a04f0fbb7379$exports.doHash = $a395a04f0fbb7379$var$doHash;
// doLengthOp will calculate the proper prefix and return it prepended
//   doLengthOp(op, data) -> length(data) || data
function $a395a04f0fbb7379$var$doLengthOp(lengthOp, data) {
    switch(lengthOp){
        case $06fa977204174ead$exports.ics23.LengthOp.NO_PREFIX:
            return data;
        case $06fa977204174ead$exports.ics23.LengthOp.VAR_PROTO:
            return new Uint8Array([
                ...$a395a04f0fbb7379$var$encodeVarintProto(data.length),
                ...data
            ]);
        case $06fa977204174ead$exports.ics23.LengthOp.REQUIRE_32_BYTES:
            if (data.length !== 32) throw new Error(`Length is ${data.length}, not 32 bytes`);
            return data;
        case $06fa977204174ead$exports.ics23.LengthOp.REQUIRE_64_BYTES:
            if (data.length !== 64) throw new Error(`Length is ${data.length}, not 64 bytes`);
            return data;
        case $06fa977204174ead$exports.ics23.LengthOp.FIXED32_LITTLE:
            return new Uint8Array([
                ...$a395a04f0fbb7379$var$encodeFixed32Le(data.length),
                ...data
            ]);
    }
    throw new Error(`Unsupported lengthop: ${lengthOp}`);
}
function $a395a04f0fbb7379$var$encodeVarintProto(n) {
    let enc = [];
    let l = n;
    while(l >= 128){
        const b = l % 128 + 128;
        enc = [
            ...enc,
            b
        ];
        l = l / 128;
    }
    enc = [
        ...enc,
        l
    ];
    return new Uint8Array(enc);
}
function $a395a04f0fbb7379$var$encodeFixed32Le(n) {
    const enc = new Uint8Array(4);
    let l = n;
    for(let i = enc.length; i > 0; i--){
        enc[Math.abs(i - enc.length)] = l % 256;
        l = Math.floor(l / 256);
    }
    return enc;
}


var $ab5acedccd7201bd$exports = {};
"use strict";
Object.defineProperty($ab5acedccd7201bd$exports, "__esModule", {
    value: true
});
$ab5acedccd7201bd$exports.bytesBefore = $ab5acedccd7201bd$exports.ensureBytesBefore = $ab5acedccd7201bd$exports.bytesEqual = $ab5acedccd7201bd$exports.ensureBytesEqual = $ab5acedccd7201bd$exports.ensureInner = $ab5acedccd7201bd$exports.ensureLeaf = void 0;
function $ab5acedccd7201bd$var$ensureLeaf(leaf, spec) {
    if (leaf.hash !== spec.hash) throw new Error(`Unexpected hashOp: ${leaf.hash}`);
    if (leaf.prehashKey !== spec.prehashKey) throw new Error(`Unexpected prehashKey: ${leaf.prehashKey}`);
    if (leaf.prehashValue !== spec.prehashValue) throw new Error(`Unexpected prehashValue: ${leaf.prehashValue}`);
    if (leaf.length !== spec.length) throw new Error(`Unexpected length op: ${leaf.length}`);
    $ab5acedccd7201bd$var$ensurePrefix(leaf.prefix, spec.prefix);
}
$ab5acedccd7201bd$exports.ensureLeaf = $ab5acedccd7201bd$var$ensureLeaf;
function $ab5acedccd7201bd$var$ensureInner(inner, prefix, spec) {
    if (inner.hash !== spec.hash) throw new Error(`Unexpected hashOp: ${inner.hash}`);
    if (!inner.prefix) throw new Error("No prefix set for inner node");
    if ($ab5acedccd7201bd$var$hasPrefix(inner.prefix, prefix)) throw new Error(`Inner node has leaf prefix`);
    if (inner.prefix.length < (spec.minPrefixLength || 0)) throw new Error(`Prefix too short: ${inner.prefix.length} bytes`);
    const maxLeftChildBytes = (spec.childOrder.length - 1) * spec.childSize;
    if (inner.prefix.length > (spec.maxPrefixLength || 0) + maxLeftChildBytes) throw new Error(`Prefix too long: ${inner.prefix.length} bytes`);
}
$ab5acedccd7201bd$exports.ensureInner = $ab5acedccd7201bd$var$ensureInner;
function $ab5acedccd7201bd$var$ensurePrefix(check, prefix) {
    // no prefix supplied, means everything passes
    if (!prefix || prefix.length === 0) return;
    if (!check) throw new Error(`Target bytes missing`);
    $ab5acedccd7201bd$var$ensureBytesEqual(prefix, check.slice(0, prefix.length));
}
// ensureBytesEqual throws an error if the arrays are different
function $ab5acedccd7201bd$var$ensureBytesEqual(a, b) {
    if (a.length !== b.length) throw new Error(`Different lengths ${a.length} vs ${b.length}`);
    for(let i = 0; i < a.length; i++){
        if (a[i] !== b[i]) throw new Error(`Arrays differ at index ${i}: ${a[i]} vs ${b[i]}`);
    }
}
$ab5acedccd7201bd$exports.ensureBytesEqual = $ab5acedccd7201bd$var$ensureBytesEqual;
function $ab5acedccd7201bd$var$bytesEqual(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
$ab5acedccd7201bd$exports.bytesEqual = $ab5acedccd7201bd$var$bytesEqual;
function $ab5acedccd7201bd$var$hasPrefix(check, prefix) {
    // no prefix supplied, means everything passes
    if (!prefix || prefix.length === 0) return false;
    if (!check) return false;
    if (check.length <= prefix.length) return false;
    for(let i = 0; i < prefix.length; i++){
        if (check[i] !== prefix[i]) return false;
    }
    throw true;
}
// ensureBytesBefore throws an error if first >= last
// we compare byte by byte
function $ab5acedccd7201bd$var$ensureBytesBefore(first, last) {
    if (!$ab5acedccd7201bd$var$bytesBefore(first, last)) throw new Error("first is after last");
}
$ab5acedccd7201bd$exports.ensureBytesBefore = $ab5acedccd7201bd$var$ensureBytesBefore;
function $ab5acedccd7201bd$var$bytesBefore(first, last) {
    const min = first.length < last.length ? first.length : last.length;
    for(let i = 0; i < min; i++){
        if (first[i] < last[i]) return true;
        if (first[i] > last[i]) return false;
    // if they are equal, continue to next step
    }
    // if they match, ensure that last is longer than first..
    return first.length < last.length;
}
$ab5acedccd7201bd$exports.bytesBefore = $ab5acedccd7201bd$var$bytesBefore;


$41d1695d4c511a06$exports.iavlSpec = {
    leafSpec: {
        prefix: Uint8Array.from([
            0
        ]),
        hash: $06fa977204174ead$exports.ics23.HashOp.SHA256,
        prehashValue: $06fa977204174ead$exports.ics23.HashOp.SHA256,
        prehashKey: $06fa977204174ead$exports.ics23.HashOp.NO_HASH,
        length: $06fa977204174ead$exports.ics23.LengthOp.VAR_PROTO
    },
    innerSpec: {
        childOrder: [
            0,
            1
        ],
        minPrefixLength: 4,
        maxPrefixLength: 12,
        childSize: 33,
        hash: $06fa977204174ead$exports.ics23.HashOp.SHA256
    }
};
$41d1695d4c511a06$exports.tendermintSpec = {
    leafSpec: {
        prefix: Uint8Array.from([
            0
        ]),
        hash: $06fa977204174ead$exports.ics23.HashOp.SHA256,
        prehashValue: $06fa977204174ead$exports.ics23.HashOp.SHA256,
        prehashKey: $06fa977204174ead$exports.ics23.HashOp.NO_HASH,
        length: $06fa977204174ead$exports.ics23.LengthOp.VAR_PROTO
    },
    innerSpec: {
        childOrder: [
            0,
            1
        ],
        minPrefixLength: 1,
        maxPrefixLength: 1,
        childSize: 32,
        hash: $06fa977204174ead$exports.ics23.HashOp.SHA256
    }
};
$41d1695d4c511a06$exports.smtSpec = {
    leafSpec: {
        hash: $06fa977204174ead$exports.ics23.HashOp.SHA256,
        prehashKey: $06fa977204174ead$exports.ics23.HashOp.NO_HASH,
        prehashValue: $06fa977204174ead$exports.ics23.HashOp.SHA256,
        length: $06fa977204174ead$exports.ics23.LengthOp.NO_PREFIX,
        prefix: Uint8Array.from([
            0
        ])
    },
    innerSpec: {
        childOrder: [
            0,
            1
        ],
        childSize: 32,
        minPrefixLength: 1,
        maxPrefixLength: 1,
        emptyChild: new Uint8Array(32),
        hash: $06fa977204174ead$exports.ics23.HashOp.SHA256
    },
    maxDepth: 256
};
// verifyExistence will throw an error if the proof doesn't link key, value -> root
// or if it doesn't fulfill the spec
function $41d1695d4c511a06$var$verifyExistence(proof, spec, root, key, value) {
    $41d1695d4c511a06$var$ensureSpec(proof, spec);
    const calc = $41d1695d4c511a06$var$calculateExistenceRoot(proof);
    (0, $ab5acedccd7201bd$exports.ensureBytesEqual)(calc, root);
    (0, $ab5acedccd7201bd$exports.ensureBytesEqual)(key, proof.key);
    (0, $ab5acedccd7201bd$exports.ensureBytesEqual)(value, proof.value);
}
$41d1695d4c511a06$exports.verifyExistence = $41d1695d4c511a06$var$verifyExistence;
// Verify does all checks to ensure the proof has valid non-existence proofs,
// and they ensure the given key is not in the CommitmentState,
// throwing an error if there is an issue
function $41d1695d4c511a06$var$verifyNonExistence(proof, spec, root, key) {
    let leftKey;
    let rightKey;
    if (proof.left) {
        $41d1695d4c511a06$var$verifyExistence(proof.left, spec, root, proof.left.key, proof.left.value);
        leftKey = proof.left.key;
    }
    if (proof.right) {
        $41d1695d4c511a06$var$verifyExistence(proof.right, spec, root, proof.right.key, proof.right.value);
        rightKey = proof.right.key;
    }
    if (!leftKey && !rightKey) throw new Error("neither left nor right proof defined");
    if (leftKey) (0, $ab5acedccd7201bd$exports.ensureBytesBefore)(leftKey, key);
    if (rightKey) (0, $ab5acedccd7201bd$exports.ensureBytesBefore)(key, rightKey);
    if (!spec.innerSpec) throw new Error("no inner spec");
    if (!leftKey) $41d1695d4c511a06$var$ensureLeftMost(spec.innerSpec, proof.right.path);
    else if (!rightKey) $41d1695d4c511a06$var$ensureRightMost(spec.innerSpec, proof.left.path);
    else $41d1695d4c511a06$var$ensureLeftNeighbor(spec.innerSpec, proof.left.path, proof.right.path);
    return;
}
$41d1695d4c511a06$exports.verifyNonExistence = $41d1695d4c511a06$var$verifyNonExistence;
// Calculate determines the root hash that matches the given proof.
// You must validate the result is what you have in a header.
// Returns error if the calculations cannot be performed.
function $41d1695d4c511a06$var$calculateExistenceRoot(proof) {
    if (!proof.key || !proof.value) throw new Error("Existence proof needs key and value set");
    if (!proof.leaf) throw new Error("Existence proof must start with a leaf operation");
    const path = proof.path || [];
    let res = (0, $a395a04f0fbb7379$exports.applyLeaf)(proof.leaf, proof.key, proof.value);
    for (const inner of path)res = (0, $a395a04f0fbb7379$exports.applyInner)(inner, res);
    return res;
}
$41d1695d4c511a06$exports.calculateExistenceRoot = $41d1695d4c511a06$var$calculateExistenceRoot;
// ensureSpec throws an Error if proof doesn't fulfill spec
function $41d1695d4c511a06$var$ensureSpec(proof, spec) {
    if (!proof.leaf) throw new Error("Existence proof must start with a leaf operation");
    if (!spec.leafSpec) throw new Error("Spec must include leafSpec");
    if (!spec.innerSpec) throw new Error("Spec must include innerSpec");
    (0, $ab5acedccd7201bd$exports.ensureLeaf)(proof.leaf, spec.leafSpec);
    const path = proof.path || [];
    if (spec.minDepth && path.length < spec.minDepth) throw new Error(`Too few inner nodes ${path.length}`);
    if (spec.maxDepth && path.length > spec.maxDepth) throw new Error(`Too many inner nodes ${path.length}`);
    for (const inner of path)(0, $ab5acedccd7201bd$exports.ensureInner)(inner, spec.leafSpec.prefix, spec.innerSpec);
}
$41d1695d4c511a06$exports.ensureSpec = $41d1695d4c511a06$var$ensureSpec;
function $41d1695d4c511a06$var$ensureLeftMost(spec, path) {
    const { minPrefix: minPrefix, maxPrefix: maxPrefix, suffix: suffix } = $41d1695d4c511a06$var$getPadding(spec, 0);
    // ensure every step has a prefix and suffix defined to be leftmost
    for (const step of path){
        if (!$41d1695d4c511a06$var$hasPadding(step, minPrefix, maxPrefix, suffix)) throw new Error("Step not leftmost");
    }
}
function $41d1695d4c511a06$var$ensureRightMost(spec, path) {
    const len = spec.childOrder.length - 1;
    const { minPrefix: minPrefix, maxPrefix: maxPrefix, suffix: suffix } = $41d1695d4c511a06$var$getPadding(spec, len);
    // ensure every step has a prefix and suffix defined to be leftmost
    for (const step of path){
        if (!$41d1695d4c511a06$var$hasPadding(step, minPrefix, maxPrefix, suffix)) throw new Error("Step not leftmost");
    }
}
function $41d1695d4c511a06$var$ensureLeftNeighbor(spec, left, right) {
    const mutleft = [
        ...left
    ];
    const mutright = [
        ...right
    ];
    let topleft = mutleft.pop();
    let topright = mutright.pop();
    while((0, $ab5acedccd7201bd$exports.bytesEqual)(topleft.prefix, topright.prefix) && (0, $ab5acedccd7201bd$exports.bytesEqual)(topleft.suffix, topright.suffix)){
        topleft = mutleft.pop();
        topright = mutright.pop();
    }
    // now topleft and topright are the first divergent nodes
    // make sure they are left and right of each other
    if (!$41d1695d4c511a06$var$isLeftStep(spec, topleft, topright)) throw new Error(`Not left neightbor at first divergent step`);
    // make sure the paths are left and right most possibilities respectively
    $41d1695d4c511a06$var$ensureRightMost(spec, mutleft);
    $41d1695d4c511a06$var$ensureLeftMost(spec, mutright);
}
$41d1695d4c511a06$exports.ensureLeftNeighbor = $41d1695d4c511a06$var$ensureLeftNeighbor;
// isLeftStep assumes left and right have common parents
// checks if left is exactly one slot to the left of right
function $41d1695d4c511a06$var$isLeftStep(spec, left, right) {
    const leftidx = $41d1695d4c511a06$var$orderFromPadding(spec, left);
    const rightidx = $41d1695d4c511a06$var$orderFromPadding(spec, right);
    return rightidx === leftidx + 1;
}
function $41d1695d4c511a06$var$orderFromPadding(spec, inner) {
    for(let branch = 0; branch < spec.childOrder.length; branch++){
        const { minPrefix: minPrefix, maxPrefix: maxPrefix, suffix: suffix } = $41d1695d4c511a06$var$getPadding(spec, branch);
        if ($41d1695d4c511a06$var$hasPadding(inner, minPrefix, maxPrefix, suffix)) return branch;
    }
    throw new Error(`Cannot find any valid spacing for this node`);
}
function $41d1695d4c511a06$var$hasPadding(op, minPrefix, maxPrefix, suffix) {
    if ((op.prefix || []).length < minPrefix) return false;
    if ((op.prefix || []).length > maxPrefix) return false;
    return (op.suffix || []).length === suffix;
}
function $41d1695d4c511a06$var$getPadding(spec, branch) {
    const idx = $41d1695d4c511a06$var$getPosition(spec.childOrder, branch);
    // count how many children are in the prefix
    const prefix = idx * spec.childSize;
    const minPrefix = prefix + spec.minPrefixLength;
    const maxPrefix = prefix + spec.maxPrefixLength;
    // count how many children are in the suffix
    const suffix = (spec.childOrder.length - 1 - idx) * spec.childSize;
    return {
        minPrefix: minPrefix,
        maxPrefix: maxPrefix,
        suffix: suffix
    };
}
function $41d1695d4c511a06$var$getPosition(order, branch) {
    if (branch < 0 || branch >= order.length) throw new Error(`Invalid branch: ${branch}`);
    return order.findIndex((val)=>val === branch);
}



/*
This implements the client side functions as specified in
https://github.com/cosmos/ics/tree/master/spec/ics-023-vector-commitments

In particular:

  // Assumes ExistenceProof
  type verifyMembership = (root: CommitmentRoot, proof: CommitmentProof, key: Key, value: Value) => boolean

  // Assumes NonExistenceProof
  type verifyNonMembership = (root: CommitmentRoot, proof: CommitmentProof, key: Key) => boolean

  // Assumes BatchProof - required ExistenceProofs may be a subset of all items proven
  type batchVerifyMembership = (root: CommitmentRoot, proof: CommitmentProof, items: Map<Key, Value>) => boolean

  // Assumes BatchProof - required NonExistenceProofs may be a subset of all items proven
  type batchVerifyNonMembership = (root: CommitmentRoot, proof: CommitmentProof, keys: Set<Key>) => boolean

We make an adjustment to accept a Spec to ensure the provided proof is in the format of the expected merkle store.
This can avoid an range of attacks on fake preimages, as we need to be careful on how to map key, value -> leaf
and determine neighbors
*/ /**
 * verifyMembership ensures proof is (contains) a valid existence proof for the given
 */ function $480f3411cb2df690$var$verifyMembership(proof, spec, root, key, value) {
    const norm = (0, $04f4cd4f1ea54c52$exports.decompress)(proof);
    const exist = $480f3411cb2df690$var$getExistForKey(norm, key);
    if (!exist) return false;
    try {
        (0, $41d1695d4c511a06$exports.verifyExistence)(exist, spec, root, key, value);
        return true;
    } catch (_a) {
        return false;
    }
}
$480f3411cb2df690$exports.verifyMembership = $480f3411cb2df690$var$verifyMembership;
/**
 * verifyNonMembership ensures proof is (contains) a valid non-existence proof for the given key
 */ function $480f3411cb2df690$var$verifyNonMembership(proof, spec, root, key) {
    const norm = (0, $04f4cd4f1ea54c52$exports.decompress)(proof);
    const nonexist = $480f3411cb2df690$var$getNonExistForKey(norm, key);
    if (!nonexist) return false;
    try {
        (0, $41d1695d4c511a06$exports.verifyNonExistence)(nonexist, spec, root, key);
        return true;
    } catch (_a) {
        return false;
    }
}
$480f3411cb2df690$exports.verifyNonMembership = $480f3411cb2df690$var$verifyNonMembership;
/**
 * batchVerifyMembership ensures proof is (contains) a valid existence proof for the given
 */ function $480f3411cb2df690$var$batchVerifyMembership(proof, spec, root, items) {
    const norm = (0, $04f4cd4f1ea54c52$exports.decompress)(proof);
    for (const [key, value] of items.entries()){
        if (!$480f3411cb2df690$var$verifyMembership(norm, spec, root, key, value)) return false;
    }
    return true;
}
$480f3411cb2df690$exports.batchVerifyMembership = $480f3411cb2df690$var$batchVerifyMembership;
/**
 * batchVerifyNonMembership ensures proof is (contains) a valid existence proof for the given
 */ function $480f3411cb2df690$var$batchVerifyNonMembership(proof, spec, root, keys) {
    const norm = (0, $04f4cd4f1ea54c52$exports.decompress)(proof);
    for (const key of keys){
        if (!$480f3411cb2df690$var$verifyNonMembership(norm, spec, root, key)) return false;
    }
    return true;
}
$480f3411cb2df690$exports.batchVerifyNonMembership = $480f3411cb2df690$var$batchVerifyNonMembership;
function $480f3411cb2df690$var$getExistForKey(proof, key) {
    const match = (p)=>!!p && (0, $ab5acedccd7201bd$exports.bytesEqual)(key, p.key);
    if (match(proof.exist)) return proof.exist;
    else if (proof.batch) return proof.batch.entries.map((x)=>x.exist || null).find(match);
    return undefined;
}
function $480f3411cb2df690$var$getNonExistForKey(proof, key) {
    const match = (p)=>{
        return !!p && (!p.left || (0, $ab5acedccd7201bd$exports.bytesBefore)(p.left.key, key)) && (!p.right || (0, $ab5acedccd7201bd$exports.bytesBefore)(key, p.right.key));
    };
    if (match(proof.nonexist)) return proof.nonexist;
    else if (proof.batch) return proof.batch.entries.map((x)=>x.nonexist || null).find(match);
    return undefined;
}


Object.defineProperty($fc6baa8f2374ecb4$exports, "verifyMembership", {
    enumerable: true,
    get: function() {
        return $480f3411cb2df690$exports.verifyMembership;
    }
});
Object.defineProperty($fc6baa8f2374ecb4$exports, "verifyNonMembership", {
    enumerable: true,
    get: function() {
        return $480f3411cb2df690$exports.verifyNonMembership;
    }
});

Object.defineProperty($fc6baa8f2374ecb4$exports, "calculateExistenceRoot", {
    enumerable: true,
    get: function() {
        return $41d1695d4c511a06$exports.calculateExistenceRoot;
    }
});
Object.defineProperty($fc6baa8f2374ecb4$exports, "iavlSpec", {
    enumerable: true,
    get: function() {
        return $41d1695d4c511a06$exports.iavlSpec;
    }
});
Object.defineProperty($fc6baa8f2374ecb4$exports, "tendermintSpec", {
    enumerable: true,
    get: function() {
        return $41d1695d4c511a06$exports.tendermintSpec;
    }
});
Object.defineProperty($fc6baa8f2374ecb4$exports, "verifyExistence", {
    enumerable: true,
    get: function() {
        return $41d1695d4c511a06$exports.verifyExistence;
    }
});
Object.defineProperty($fc6baa8f2374ecb4$exports, "verifyNonExistence", {
    enumerable: true,
    get: function() {
        return $41d1695d4c511a06$exports.verifyNonExistence;
    }
});



var $5zb9p = parcelRequire("5zb9p");

var $9XZPj = parcelRequire("9XZPj");

var $F6P8J = parcelRequire("F6P8J");
function $089d9f1f704bbb73$var$checkAndParseOp(op, kind, key) {
    if (op.type !== kind) throw new Error(`Op expected to be ${kind}, got "${op.type}`);
    if (!(0, $F6P8J.arrayContentEquals)(key, op.key)) throw new Error(`Proven key different than queried key.\nQuery: ${(0, $5zb9p.toHex)(key)}\nProven: ${(0, $5zb9p.toHex)(op.key)}`);
    return $fc6baa8f2374ecb4$exports.ics23.CommitmentProof.decode(op.data);
}
class $089d9f1f704bbb73$var$QueryClient {
    static withExtensions(tmClient, ...extensionSetups) {
        const client = new $089d9f1f704bbb73$var$QueryClient(tmClient);
        const extensions = extensionSetups.map((setupExtension)=>setupExtension(client));
        for (const extension of extensions){
            (0, $F6P8J.assert)((0, $F6P8J.isNonNullObject)(extension), `Extension must be a non-null object`);
            for (const [moduleKey, moduleValue] of Object.entries(extension)){
                (0, $F6P8J.assert)((0, $F6P8J.isNonNullObject)(moduleValue), `Module must be a non-null object. Found type ${typeof moduleValue} for module "${moduleKey}".`);
                const current = client[moduleKey] || {};
                client[moduleKey] = {
                    ...current,
                    ...moduleValue
                };
            }
        }
        return client;
    }
    async queryVerified(store, key, desiredHeight) {
        const { height: height, proof: proof, value: value } = await this.queryRawProof(store, key, desiredHeight);
        const subProof = $089d9f1f704bbb73$var$checkAndParseOp(proof.ops[0], "ics23:iavl", key);
        const storeProof = $089d9f1f704bbb73$var$checkAndParseOp(proof.ops[1], "ics23:simple", (0, $5zb9p.toAscii)(store));
        // this must always be existence, if the store is not a typo
        (0, $F6P8J.assert)(storeProof.exist);
        (0, $F6P8J.assert)(storeProof.exist.value);
        // this may be exist or non-exist, depends on response
        if (!value || value.length === 0) {
            // non-existence check
            (0, $F6P8J.assert)(subProof.nonexist);
            // the subproof must map the desired key to the "value" of the storeProof
            (0, $fc6baa8f2374ecb4$exports.verifyNonExistence)(subProof.nonexist, $fc6baa8f2374ecb4$exports.iavlSpec, storeProof.exist.value, key);
        } else {
            // existence check
            (0, $F6P8J.assert)(subProof.exist);
            (0, $F6P8J.assert)(subProof.exist.value);
            // the subproof must map the desired key to the "value" of the storeProof
            (0, $fc6baa8f2374ecb4$exports.verifyExistence)(subProof.exist, $fc6baa8f2374ecb4$exports.iavlSpec, storeProof.exist.value, key, value);
        }
        // the store proof must map its declared value (root of subProof) to the appHash of the next block
        const header = await this.getNextHeader(height);
        (0, $fc6baa8f2374ecb4$exports.verifyExistence)(storeProof.exist, $fc6baa8f2374ecb4$exports.tendermintSpec, header.appHash, (0, $5zb9p.toAscii)(store), storeProof.exist.value);
        return value;
    }
    async queryRawProof(store, queryKey, desiredHeight) {
        var _a;
        const { key: key, value: value, height: height, proof: proof, code: code, log: log } = await this.tmClient.abciQuery({
            // we need the StoreKey for the module, not the module name
            // https://github.com/cosmos/cosmos-sdk/blob/8cab43c8120fec5200c3459cbf4a92017bb6f287/x/auth/types/keys.go#L12
            path: `/store/${store}/key`,
            data: queryKey,
            prove: true,
            height: desiredHeight
        });
        if (code) throw new Error(`Query failed with (${code}): ${log}`);
        if (!(0, $F6P8J.arrayContentEquals)(queryKey, key)) throw new Error(`Response key ${(0, $5zb9p.toHex)(key)} doesn't match query key ${(0, $5zb9p.toHex)(queryKey)}`);
        if (!height) throw new Error("No query height returned");
        if (!proof || proof.ops.length !== 2) throw new Error(`Expected 2 proof ops, got ${(_a = proof === null || proof === void 0 ? void 0 : proof.ops.length) !== null && _a !== void 0 ? _a : 0}. Are you using stargate?`);
        // we don't need the results, but we can ensure the data is the proper format
        $089d9f1f704bbb73$var$checkAndParseOp(proof.ops[0], "ics23:iavl", key);
        $089d9f1f704bbb73$var$checkAndParseOp(proof.ops[1], "ics23:simple", (0, $5zb9p.toAscii)(store));
        return {
            key: key,
            value: value,
            height: height,
            // need to clone this: readonly input / writeable output
            proof: {
                ops: [
                    ...proof.ops
                ]
            }
        };
    }
    async queryUnverified(path, request) {
        const response = await this.tmClient.abciQuery({
            path: path,
            data: request,
            prove: false
        });
        if (response.code) throw new Error(`Query failed with (${response.code}): ${response.log}`);
        return response.value;
    }
    // this must return the header for height+1
    // throws an error if height is 0 or undefined
    async getNextHeader(height) {
        (0, $F6P8J.assertDefined)(height);
        if (height === 0) throw new Error("Query returned height 0, cannot prove it");
        const searchHeight = height + 1;
        let nextHeader;
        let headersSubscription;
        try {
            headersSubscription = this.tmClient.subscribeNewBlockHeader();
        } catch (_a) {
        // Ignore exception caused by non-WebSocket Tendermint clients
        }
        if (headersSubscription) {
            const firstHeader = await (0, $9XZPj.firstEvent)(headersSubscription);
            // The first header we get might not be n+1 but n+2 or even higher. In such cases we fall back on a query.
            if (firstHeader.height === searchHeight) nextHeader = firstHeader;
        }
        while(!nextHeader){
            // start from current height to avoid backend error for minHeight in the future
            const correctHeader = (await this.tmClient.blockchain(height, searchHeight)).blockMetas.map((meta)=>meta.header).find((h)=>h.height === searchHeight);
            if (correctHeader) nextHeader = correctHeader;
            else await (0, $F6P8J.sleep)(1000);
        }
        (0, $F6P8J.assert)(nextHeader.height === searchHeight, "Got wrong header. This is a bug in the logic above.");
        return nextHeader;
    }
    constructor(tmClient){
        this.tmClient = tmClient;
    }
}
$089d9f1f704bbb73$exports.QueryClient = $089d9f1f704bbb73$var$QueryClient;


Object.defineProperty($ffdede50deec576f$exports, "QueryClient", {
    enumerable: true,
    get: function() {
        return $089d9f1f704bbb73$exports.QueryClient;
    }
});
var $0727a3095818d365$exports = {};
"use strict";
var $0727a3095818d365$var$__importDefault = $0727a3095818d365$exports && $0727a3095818d365$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($0727a3095818d365$exports, "__esModule", {
    value: true
});
$0727a3095818d365$exports.decodeCosmosSdkDecFromProto = $0727a3095818d365$exports.longify = $0727a3095818d365$exports.createProtobufRpcClient = $0727a3095818d365$exports.createPagination = $0727a3095818d365$exports.toAccAddress = void 0;

var $5zb9p = parcelRequire("5zb9p");

var $9YIif = parcelRequire("9YIif");


const $0727a3095818d365$var$long_1 = $0727a3095818d365$var$__importDefault((parcelRequire("9A55m")));
/**
 * Takes a bech32 encoded address and returns the data part. The prefix is ignored and discarded.
 * This is called AccAddress in Cosmos SDK, which is basically an alias for raw binary data.
 * The result is typically 20 bytes long but not restricted to that.
 */ function $0727a3095818d365$var$toAccAddress(address) {
    return (0, $5zb9p.fromBech32)(address).data;
}
$0727a3095818d365$exports.toAccAddress = $0727a3095818d365$var$toAccAddress;
/**
 * If paginationKey is set, return a `PageRequest` with the given key.
 * If paginationKey is unset, return `undefined`.
 *
 * Use this with a query response's pagination next key to
 * request the next page.
 */ function $0727a3095818d365$var$createPagination(paginationKey) {
    return paginationKey ? $f01b40e20607eb8e$exports.PageRequest.fromPartial({
        key: paginationKey,
        offset: $0727a3095818d365$var$long_1.default.fromNumber(0, true),
        limit: $0727a3095818d365$var$long_1.default.fromNumber(0, true),
        countTotal: false
    }) : undefined;
}
$0727a3095818d365$exports.createPagination = $0727a3095818d365$var$createPagination;
function $0727a3095818d365$var$createProtobufRpcClient(base) {
    return {
        request: (service, method, data)=>{
            const path = `/${service}/${method}`;
            return base.queryUnverified(path, data);
        }
    };
}
$0727a3095818d365$exports.createProtobufRpcClient = $0727a3095818d365$var$createProtobufRpcClient;
/**
 * Takes a uint64 value as string, number, Long or Uint64 and returns an unsigned Long instance
 * of it.
 */ function $0727a3095818d365$var$longify(value) {
    const checkedValue = $9YIif.Uint64.fromString(value.toString());
    return $0727a3095818d365$var$long_1.default.fromBytesBE([
        ...checkedValue.toBytesBigEndian()
    ], true);
}
$0727a3095818d365$exports.longify = $0727a3095818d365$var$longify;
/**
 * Takes a string or binary encoded `github.com/cosmos/cosmos-sdk/types.Dec` from the
 * protobuf API and converts it into a `Decimal` with 18 fractional digits.
 *
 * See https://github.com/cosmos/cosmos-sdk/issues/10863 for more context why this is needed.
 */ function $0727a3095818d365$var$decodeCosmosSdkDecFromProto(input) {
    const asString = typeof input === "string" ? input : (0, $5zb9p.fromAscii)(input);
    return $9YIif.Decimal.fromAtomics(asString, 18);
}
$0727a3095818d365$exports.decodeCosmosSdkDecFromProto = $0727a3095818d365$var$decodeCosmosSdkDecFromProto;


Object.defineProperty($ffdede50deec576f$exports, "createPagination", {
    enumerable: true,
    get: function() {
        return $0727a3095818d365$exports.createPagination;
    }
});
Object.defineProperty($ffdede50deec576f$exports, "createProtobufRpcClient", {
    enumerable: true,
    get: function() {
        return $0727a3095818d365$exports.createProtobufRpcClient;
    }
});
Object.defineProperty($ffdede50deec576f$exports, "decodeCosmosSdkDecFromProto", {
    enumerable: true,
    get: function() {
        return $0727a3095818d365$exports.decodeCosmosSdkDecFromProto;
    }
});
Object.defineProperty($ffdede50deec576f$exports, "longify", {
    enumerable: true,
    get: function() {
        return $0727a3095818d365$exports.longify;
    }
});


function $6f017155cc32f781$var$setupAuthExtension(base) {
    const rpc = (0, $ffdede50deec576f$exports.createProtobufRpcClient)(base);
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const queryService = new $4e1d12610f69ad10$exports.QueryClientImpl(rpc);
    return {
        auth: {
            account: async (address)=>{
                const { account: account } = await queryService.Account({
                    address: address
                });
                return account !== null && account !== void 0 ? account : null;
            }
        }
    };
}
$6f017155cc32f781$exports.setupAuthExtension = $6f017155cc32f781$var$setupAuthExtension;


Object.defineProperty($7725f2e3ca016b52$exports, "setupAuthExtension", {
    enumerable: true,
    get: function() {
        return $6f017155cc32f781$exports.setupAuthExtension;
    }
});
var $77b736fe9ba21263$exports = {};
"use strict";
Object.defineProperty($77b736fe9ba21263$exports, "__esModule", {
    value: true
});
$77b736fe9ba21263$exports.createAuthzAminoConverters = void 0;
function $77b736fe9ba21263$var$createAuthzAminoConverters() {
    return {
        "/cosmos.authz.v1beta1.MsgGrant": "not_supported_by_chain",
        "/cosmos.authz.v1beta1.MsgExec": "not_supported_by_chain",
        "/cosmos.authz.v1beta1.MsgRevoke": "not_supported_by_chain"
    };
}
$77b736fe9ba21263$exports.createAuthzAminoConverters = $77b736fe9ba21263$var$createAuthzAminoConverters;


Object.defineProperty($7725f2e3ca016b52$exports, "createAuthzAminoConverters", {
    enumerable: true,
    get: function() {
        return $77b736fe9ba21263$exports.createAuthzAminoConverters;
    }
});
var $8037f395b020f355$exports = {};
"use strict";
Object.defineProperty($8037f395b020f355$exports, "__esModule", {
    value: true
});
$8037f395b020f355$exports.authzTypes = void 0;
var $d189b8fd7c99c4ec$exports = {};
"use strict";
var $d189b8fd7c99c4ec$var$__importDefault = $d189b8fd7c99c4ec$exports && $d189b8fd7c99c4ec$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($d189b8fd7c99c4ec$exports, "__esModule", {
    value: true
});
$d189b8fd7c99c4ec$exports.MsgClientImpl = $d189b8fd7c99c4ec$exports.MsgRevokeResponse = $d189b8fd7c99c4ec$exports.MsgRevoke = $d189b8fd7c99c4ec$exports.MsgGrantResponse = $d189b8fd7c99c4ec$exports.MsgExec = $d189b8fd7c99c4ec$exports.MsgExecResponse = $d189b8fd7c99c4ec$exports.MsgGrant = $d189b8fd7c99c4ec$exports.protobufPackage = void 0;

/* eslint-disable */ const $d189b8fd7c99c4ec$var$long_1 = $d189b8fd7c99c4ec$var$__importDefault((parcelRequire("9A55m")));

const $d189b8fd7c99c4ec$var$minimal_1 = $d189b8fd7c99c4ec$var$__importDefault((parcelRequire("i2pIU")));
var $e556dc7c9dd62702$exports = {};
"use strict";
var $e556dc7c9dd62702$var$__importDefault = $e556dc7c9dd62702$exports && $e556dc7c9dd62702$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($e556dc7c9dd62702$exports, "__esModule", {
    value: true
});
$e556dc7c9dd62702$exports.Grant = $e556dc7c9dd62702$exports.GenericAuthorization = $e556dc7c9dd62702$exports.protobufPackage = void 0;

/* eslint-disable */ const $e556dc7c9dd62702$var$long_1 = $e556dc7c9dd62702$var$__importDefault((parcelRequire("9A55m")));

const $e556dc7c9dd62702$var$minimal_1 = $e556dc7c9dd62702$var$__importDefault((parcelRequire("i2pIU")));

var $d6c3291d6aa8eb5b$exports = {};
"use strict";
var $d6c3291d6aa8eb5b$var$__importDefault = $d6c3291d6aa8eb5b$exports && $d6c3291d6aa8eb5b$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($d6c3291d6aa8eb5b$exports, "__esModule", {
    value: true
});
$d6c3291d6aa8eb5b$exports.Timestamp = $d6c3291d6aa8eb5b$exports.protobufPackage = void 0;

/* eslint-disable */ const $d6c3291d6aa8eb5b$var$long_1 = $d6c3291d6aa8eb5b$var$__importDefault((parcelRequire("9A55m")));

const $d6c3291d6aa8eb5b$var$minimal_1 = $d6c3291d6aa8eb5b$var$__importDefault((parcelRequire("i2pIU")));
$d6c3291d6aa8eb5b$exports.protobufPackage = "google.protobuf";
const $d6c3291d6aa8eb5b$var$baseTimestamp = {
    seconds: $d6c3291d6aa8eb5b$var$long_1.default.ZERO,
    nanos: 0
};
$d6c3291d6aa8eb5b$exports.Timestamp = {
    encode (message, writer = $d6c3291d6aa8eb5b$var$minimal_1.default.Writer.create()) {
        if (!message.seconds.isZero()) writer.uint32(8).int64(message.seconds);
        if (message.nanos !== 0) writer.uint32(16).int32(message.nanos);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d6c3291d6aa8eb5b$var$minimal_1.default.Reader ? input : new $d6c3291d6aa8eb5b$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $d6c3291d6aa8eb5b$var$baseTimestamp);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.seconds = reader.int64();
                    break;
                case 2:
                    message.nanos = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $d6c3291d6aa8eb5b$var$baseTimestamp);
        message.seconds = object.seconds !== undefined && object.seconds !== null ? $d6c3291d6aa8eb5b$var$long_1.default.fromString(object.seconds) : $d6c3291d6aa8eb5b$var$long_1.default.ZERO;
        message.nanos = object.nanos !== undefined && object.nanos !== null ? Number(object.nanos) : 0;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.seconds !== undefined && (obj.seconds = (message.seconds || $d6c3291d6aa8eb5b$var$long_1.default.ZERO).toString());
        message.nanos !== undefined && (obj.nanos = message.nanos);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $d6c3291d6aa8eb5b$var$baseTimestamp);
        message.seconds = object.seconds !== undefined && object.seconds !== null ? $d6c3291d6aa8eb5b$var$long_1.default.fromValue(object.seconds) : $d6c3291d6aa8eb5b$var$long_1.default.ZERO;
        message.nanos = (_a = object.nanos) !== null && _a !== void 0 ? _a : 0;
        return message;
    }
};
if ($d6c3291d6aa8eb5b$var$minimal_1.default.util.Long !== $d6c3291d6aa8eb5b$var$long_1.default) {
    $d6c3291d6aa8eb5b$var$minimal_1.default.util.Long = $d6c3291d6aa8eb5b$var$long_1.default;
    $d6c3291d6aa8eb5b$var$minimal_1.default.configure();
}


$e556dc7c9dd62702$exports.protobufPackage = "cosmos.authz.v1beta1";
const $e556dc7c9dd62702$var$baseGenericAuthorization = {
    msg: ""
};
$e556dc7c9dd62702$exports.GenericAuthorization = {
    encode (message, writer = $e556dc7c9dd62702$var$minimal_1.default.Writer.create()) {
        if (message.msg !== "") writer.uint32(10).string(message.msg);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e556dc7c9dd62702$var$minimal_1.default.Reader ? input : new $e556dc7c9dd62702$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $e556dc7c9dd62702$var$baseGenericAuthorization);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.msg = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $e556dc7c9dd62702$var$baseGenericAuthorization);
        message.msg = object.msg !== undefined && object.msg !== null ? String(object.msg) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.msg !== undefined && (obj.msg = message.msg);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $e556dc7c9dd62702$var$baseGenericAuthorization);
        message.msg = (_a = object.msg) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
const $e556dc7c9dd62702$var$baseGrant = {};
$e556dc7c9dd62702$exports.Grant = {
    encode (message, writer = $e556dc7c9dd62702$var$minimal_1.default.Writer.create()) {
        if (message.authorization !== undefined) $4232fce010c3a46b$exports.Any.encode(message.authorization, writer.uint32(10).fork()).ldelim();
        if (message.expiration !== undefined) $d6c3291d6aa8eb5b$exports.Timestamp.encode(message.expiration, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e556dc7c9dd62702$var$minimal_1.default.Reader ? input : new $e556dc7c9dd62702$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $e556dc7c9dd62702$var$baseGrant);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.authorization = $4232fce010c3a46b$exports.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.expiration = $d6c3291d6aa8eb5b$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $e556dc7c9dd62702$var$baseGrant);
        message.authorization = object.authorization !== undefined && object.authorization !== null ? $4232fce010c3a46b$exports.Any.fromJSON(object.authorization) : undefined;
        message.expiration = object.expiration !== undefined && object.expiration !== null ? $e556dc7c9dd62702$var$fromJsonTimestamp(object.expiration) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.authorization !== undefined && (obj.authorization = message.authorization ? $4232fce010c3a46b$exports.Any.toJSON(message.authorization) : undefined);
        message.expiration !== undefined && (obj.expiration = $e556dc7c9dd62702$var$fromTimestamp(message.expiration).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $e556dc7c9dd62702$var$baseGrant);
        message.authorization = object.authorization !== undefined && object.authorization !== null ? $4232fce010c3a46b$exports.Any.fromPartial(object.authorization) : undefined;
        message.expiration = object.expiration !== undefined && object.expiration !== null ? $d6c3291d6aa8eb5b$exports.Timestamp.fromPartial(object.expiration) : undefined;
        return message;
    }
};
function $e556dc7c9dd62702$var$toTimestamp(date) {
    const seconds = $e556dc7c9dd62702$var$numberToLong(date.getTime() / 1000);
    const nanos = date.getTime() % 1000 * 1000000;
    return {
        seconds: seconds,
        nanos: nanos
    };
}
function $e556dc7c9dd62702$var$fromTimestamp(t) {
    let millis = t.seconds.toNumber() * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function $e556dc7c9dd62702$var$fromJsonTimestamp(o) {
    if (o instanceof Date) return $e556dc7c9dd62702$var$toTimestamp(o);
    else if (typeof o === "string") return $e556dc7c9dd62702$var$toTimestamp(new Date(o));
    else return $d6c3291d6aa8eb5b$exports.Timestamp.fromJSON(o);
}
function $e556dc7c9dd62702$var$numberToLong(number) {
    return $e556dc7c9dd62702$var$long_1.default.fromNumber(number);
}
if ($e556dc7c9dd62702$var$minimal_1.default.util.Long !== $e556dc7c9dd62702$var$long_1.default) {
    $e556dc7c9dd62702$var$minimal_1.default.util.Long = $e556dc7c9dd62702$var$long_1.default;
    $e556dc7c9dd62702$var$minimal_1.default.configure();
}



$d189b8fd7c99c4ec$exports.protobufPackage = "cosmos.authz.v1beta1";
const $d189b8fd7c99c4ec$var$baseMsgGrant = {
    granter: "",
    grantee: ""
};
$d189b8fd7c99c4ec$exports.MsgGrant = {
    encode (message, writer = $d189b8fd7c99c4ec$var$minimal_1.default.Writer.create()) {
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        if (message.grant !== undefined) $e556dc7c9dd62702$exports.Grant.encode(message.grant, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d189b8fd7c99c4ec$var$minimal_1.default.Reader ? input : new $d189b8fd7c99c4ec$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $d189b8fd7c99c4ec$var$baseMsgGrant);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.grant = $e556dc7c9dd62702$exports.Grant.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $d189b8fd7c99c4ec$var$baseMsgGrant);
        message.granter = object.granter !== undefined && object.granter !== null ? String(object.granter) : "";
        message.grantee = object.grantee !== undefined && object.grantee !== null ? String(object.grantee) : "";
        message.grant = object.grant !== undefined && object.grant !== null ? $e556dc7c9dd62702$exports.Grant.fromJSON(object.grant) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.grant !== undefined && (obj.grant = message.grant ? $e556dc7c9dd62702$exports.Grant.toJSON(message.grant) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $d189b8fd7c99c4ec$var$baseMsgGrant);
        message.granter = (_a = object.granter) !== null && _a !== void 0 ? _a : "";
        message.grantee = (_b = object.grantee) !== null && _b !== void 0 ? _b : "";
        message.grant = object.grant !== undefined && object.grant !== null ? $e556dc7c9dd62702$exports.Grant.fromPartial(object.grant) : undefined;
        return message;
    }
};
const $d189b8fd7c99c4ec$var$baseMsgExecResponse = {};
$d189b8fd7c99c4ec$exports.MsgExecResponse = {
    encode (message, writer = $d189b8fd7c99c4ec$var$minimal_1.default.Writer.create()) {
        for (const v of message.results)writer.uint32(10).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d189b8fd7c99c4ec$var$minimal_1.default.Reader ? input : new $d189b8fd7c99c4ec$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $d189b8fd7c99c4ec$var$baseMsgExecResponse);
        message.results = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.results.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $d189b8fd7c99c4ec$var$baseMsgExecResponse);
        message.results = ((_a = object.results) !== null && _a !== void 0 ? _a : []).map((e)=>$d189b8fd7c99c4ec$var$bytesFromBase64(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.results) obj.results = message.results.map((e)=>$d189b8fd7c99c4ec$var$base64FromBytes(e !== undefined ? e : new Uint8Array()));
        else obj.results = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $d189b8fd7c99c4ec$var$baseMsgExecResponse);
        message.results = ((_a = object.results) === null || _a === void 0 ? void 0 : _a.map((e)=>e)) || [];
        return message;
    }
};
const $d189b8fd7c99c4ec$var$baseMsgExec = {
    grantee: ""
};
$d189b8fd7c99c4ec$exports.MsgExec = {
    encode (message, writer = $d189b8fd7c99c4ec$var$minimal_1.default.Writer.create()) {
        if (message.grantee !== "") writer.uint32(10).string(message.grantee);
        for (const v of message.msgs)$4232fce010c3a46b$exports.Any.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d189b8fd7c99c4ec$var$minimal_1.default.Reader ? input : new $d189b8fd7c99c4ec$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $d189b8fd7c99c4ec$var$baseMsgExec);
        message.msgs = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.grantee = reader.string();
                    break;
                case 2:
                    message.msgs.push($4232fce010c3a46b$exports.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $d189b8fd7c99c4ec$var$baseMsgExec);
        message.grantee = object.grantee !== undefined && object.grantee !== null ? String(object.grantee) : "";
        message.msgs = ((_a = object.msgs) !== null && _a !== void 0 ? _a : []).map((e)=>$4232fce010c3a46b$exports.Any.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.grantee !== undefined && (obj.grantee = message.grantee);
        if (message.msgs) obj.msgs = message.msgs.map((e)=>e ? $4232fce010c3a46b$exports.Any.toJSON(e) : undefined);
        else obj.msgs = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $d189b8fd7c99c4ec$var$baseMsgExec);
        message.grantee = (_a = object.grantee) !== null && _a !== void 0 ? _a : "";
        message.msgs = ((_b = object.msgs) === null || _b === void 0 ? void 0 : _b.map((e)=>$4232fce010c3a46b$exports.Any.fromPartial(e))) || [];
        return message;
    }
};
const $d189b8fd7c99c4ec$var$baseMsgGrantResponse = {};
$d189b8fd7c99c4ec$exports.MsgGrantResponse = {
    encode (_, writer = $d189b8fd7c99c4ec$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d189b8fd7c99c4ec$var$minimal_1.default.Reader ? input : new $d189b8fd7c99c4ec$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $d189b8fd7c99c4ec$var$baseMsgGrantResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $d189b8fd7c99c4ec$var$baseMsgGrantResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $d189b8fd7c99c4ec$var$baseMsgGrantResponse);
        return message;
    }
};
const $d189b8fd7c99c4ec$var$baseMsgRevoke = {
    granter: "",
    grantee: "",
    msgTypeUrl: ""
};
$d189b8fd7c99c4ec$exports.MsgRevoke = {
    encode (message, writer = $d189b8fd7c99c4ec$var$minimal_1.default.Writer.create()) {
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        if (message.msgTypeUrl !== "") writer.uint32(26).string(message.msgTypeUrl);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d189b8fd7c99c4ec$var$minimal_1.default.Reader ? input : new $d189b8fd7c99c4ec$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $d189b8fd7c99c4ec$var$baseMsgRevoke);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.msgTypeUrl = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $d189b8fd7c99c4ec$var$baseMsgRevoke);
        message.granter = object.granter !== undefined && object.granter !== null ? String(object.granter) : "";
        message.grantee = object.grantee !== undefined && object.grantee !== null ? String(object.grantee) : "";
        message.msgTypeUrl = object.msgTypeUrl !== undefined && object.msgTypeUrl !== null ? String(object.msgTypeUrl) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.msgTypeUrl !== undefined && (obj.msgTypeUrl = message.msgTypeUrl);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $d189b8fd7c99c4ec$var$baseMsgRevoke);
        message.granter = (_a = object.granter) !== null && _a !== void 0 ? _a : "";
        message.grantee = (_b = object.grantee) !== null && _b !== void 0 ? _b : "";
        message.msgTypeUrl = (_c = object.msgTypeUrl) !== null && _c !== void 0 ? _c : "";
        return message;
    }
};
const $d189b8fd7c99c4ec$var$baseMsgRevokeResponse = {};
$d189b8fd7c99c4ec$exports.MsgRevokeResponse = {
    encode (_, writer = $d189b8fd7c99c4ec$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d189b8fd7c99c4ec$var$minimal_1.default.Reader ? input : new $d189b8fd7c99c4ec$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $d189b8fd7c99c4ec$var$baseMsgRevokeResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $d189b8fd7c99c4ec$var$baseMsgRevokeResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $d189b8fd7c99c4ec$var$baseMsgRevokeResponse);
        return message;
    }
};
class $d189b8fd7c99c4ec$var$MsgClientImpl {
    Grant(request) {
        const data = $d189b8fd7c99c4ec$exports.MsgGrant.encode(request).finish();
        const promise = this.rpc.request("cosmos.authz.v1beta1.Msg", "Grant", data);
        return promise.then((data)=>$d189b8fd7c99c4ec$exports.MsgGrantResponse.decode(new $d189b8fd7c99c4ec$var$minimal_1.default.Reader(data)));
    }
    Exec(request) {
        const data = $d189b8fd7c99c4ec$exports.MsgExec.encode(request).finish();
        const promise = this.rpc.request("cosmos.authz.v1beta1.Msg", "Exec", data);
        return promise.then((data)=>$d189b8fd7c99c4ec$exports.MsgExecResponse.decode(new $d189b8fd7c99c4ec$var$minimal_1.default.Reader(data)));
    }
    Revoke(request) {
        const data = $d189b8fd7c99c4ec$exports.MsgRevoke.encode(request).finish();
        const promise = this.rpc.request("cosmos.authz.v1beta1.Msg", "Revoke", data);
        return promise.then((data)=>$d189b8fd7c99c4ec$exports.MsgRevokeResponse.decode(new $d189b8fd7c99c4ec$var$minimal_1.default.Reader(data)));
    }
    constructor(rpc){
        this.rpc = rpc;
        this.Grant = this.Grant.bind(this);
        this.Exec = this.Exec.bind(this);
        this.Revoke = this.Revoke.bind(this);
    }
}
$d189b8fd7c99c4ec$exports.MsgClientImpl = $d189b8fd7c99c4ec$var$MsgClientImpl;
var $d189b8fd7c99c4ec$var$globalThis = (()=>{
    if (typeof $d189b8fd7c99c4ec$var$globalThis !== "undefined") return $d189b8fd7c99c4ec$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $d189b8fd7c99c4ec$var$atob = $d189b8fd7c99c4ec$var$globalThis.atob || ((b64)=>$d189b8fd7c99c4ec$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $d189b8fd7c99c4ec$var$bytesFromBase64(b64) {
    const bin = $d189b8fd7c99c4ec$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $d189b8fd7c99c4ec$var$btoa = $d189b8fd7c99c4ec$var$globalThis.btoa || ((bin)=>$d189b8fd7c99c4ec$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $d189b8fd7c99c4ec$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $d189b8fd7c99c4ec$var$btoa(bin.join(""));
}
if ($d189b8fd7c99c4ec$var$minimal_1.default.util.Long !== $d189b8fd7c99c4ec$var$long_1.default) {
    $d189b8fd7c99c4ec$var$minimal_1.default.util.Long = $d189b8fd7c99c4ec$var$long_1.default;
    $d189b8fd7c99c4ec$var$minimal_1.default.configure();
}


$8037f395b020f355$exports.authzTypes = [
    [
        "/cosmos.authz.v1beta1.MsgExec",
        $d189b8fd7c99c4ec$exports.MsgExec
    ],
    [
        "/cosmos.authz.v1beta1.MsgGrant",
        $d189b8fd7c99c4ec$exports.MsgGrant
    ],
    [
        "/cosmos.authz.v1beta1.MsgRevoke",
        $d189b8fd7c99c4ec$exports.MsgRevoke
    ]
];


Object.defineProperty($7725f2e3ca016b52$exports, "authzTypes", {
    enumerable: true,
    get: function() {
        return $8037f395b020f355$exports.authzTypes;
    }
});
var $a17778e2fe834c44$exports = {};
"use strict";
Object.defineProperty($a17778e2fe834c44$exports, "__esModule", {
    value: true
});
$a17778e2fe834c44$exports.createBankAminoConverters = $a17778e2fe834c44$exports.isAminoMsgMultiSend = $a17778e2fe834c44$exports.isAminoMsgSend = void 0;
function $a17778e2fe834c44$var$isAminoMsgSend(msg) {
    return msg.type === "cosmos-sdk/MsgSend";
}
$a17778e2fe834c44$exports.isAminoMsgSend = $a17778e2fe834c44$var$isAminoMsgSend;
function $a17778e2fe834c44$var$isAminoMsgMultiSend(msg) {
    return msg.type === "cosmos-sdk/MsgMultiSend";
}
$a17778e2fe834c44$exports.isAminoMsgMultiSend = $a17778e2fe834c44$var$isAminoMsgMultiSend;
function $a17778e2fe834c44$var$createBankAminoConverters() {
    return {
        "/cosmos.bank.v1beta1.MsgSend": {
            aminoType: "cosmos-sdk/MsgSend",
            toAmino: ({ fromAddress: fromAddress, toAddress: toAddress, amount: amount })=>({
                    from_address: fromAddress,
                    to_address: toAddress,
                    amount: [
                        ...amount
                    ]
                }),
            fromAmino: ({ from_address: from_address, to_address: to_address, amount: amount })=>({
                    fromAddress: from_address,
                    toAddress: to_address,
                    amount: [
                        ...amount
                    ]
                })
        },
        "/cosmos.bank.v1beta1.MsgMultiSend": {
            aminoType: "cosmos-sdk/MsgMultiSend",
            toAmino: ({ inputs: inputs, outputs: outputs })=>({
                    inputs: inputs.map((input)=>({
                            address: input.address,
                            coins: [
                                ...input.coins
                            ]
                        })),
                    outputs: outputs.map((output)=>({
                            address: output.address,
                            coins: [
                                ...output.coins
                            ]
                        }))
                }),
            fromAmino: ({ inputs: inputs, outputs: outputs })=>({
                    inputs: inputs.map((input)=>({
                            address: input.address,
                            coins: [
                                ...input.coins
                            ]
                        })),
                    outputs: outputs.map((output)=>({
                            address: output.address,
                            coins: [
                                ...output.coins
                            ]
                        }))
                })
        }
    };
}
$a17778e2fe834c44$exports.createBankAminoConverters = $a17778e2fe834c44$var$createBankAminoConverters;


Object.defineProperty($7725f2e3ca016b52$exports, "createBankAminoConverters", {
    enumerable: true,
    get: function() {
        return $a17778e2fe834c44$exports.createBankAminoConverters;
    }
});
Object.defineProperty($7725f2e3ca016b52$exports, "isAminoMsgMultiSend", {
    enumerable: true,
    get: function() {
        return $a17778e2fe834c44$exports.isAminoMsgMultiSend;
    }
});
Object.defineProperty($7725f2e3ca016b52$exports, "isAminoMsgSend", {
    enumerable: true,
    get: function() {
        return $a17778e2fe834c44$exports.isAminoMsgSend;
    }
});
var $97e6cfc987029c93$exports = {};
"use strict";
Object.defineProperty($97e6cfc987029c93$exports, "__esModule", {
    value: true
});
$97e6cfc987029c93$exports.isMsgSendEncodeObject = $97e6cfc987029c93$exports.bankTypes = void 0;

$97e6cfc987029c93$exports.bankTypes = [
    [
        "/cosmos.bank.v1beta1.MsgMultiSend",
        $d1741032746595ab$exports.MsgMultiSend
    ],
    [
        "/cosmos.bank.v1beta1.MsgSend",
        $d1741032746595ab$exports.MsgSend
    ]
];
function $97e6cfc987029c93$var$isMsgSendEncodeObject(encodeObject) {
    return encodeObject.typeUrl === "/cosmos.bank.v1beta1.MsgSend";
}
$97e6cfc987029c93$exports.isMsgSendEncodeObject = $97e6cfc987029c93$var$isMsgSendEncodeObject;


Object.defineProperty($7725f2e3ca016b52$exports, "bankTypes", {
    enumerable: true,
    get: function() {
        return $97e6cfc987029c93$exports.bankTypes;
    }
});
Object.defineProperty($7725f2e3ca016b52$exports, "isMsgSendEncodeObject", {
    enumerable: true,
    get: function() {
        return $97e6cfc987029c93$exports.isMsgSendEncodeObject;
    }
});
var $0a9f39c98f92d6ec$exports = {};
"use strict";
Object.defineProperty($0a9f39c98f92d6ec$exports, "__esModule", {
    value: true
});
$0a9f39c98f92d6ec$exports.setupBankExtension = void 0;

var $F6P8J = parcelRequire("F6P8J");
var $b62953798c6dd5c7$exports = {};
"use strict";
var $b62953798c6dd5c7$var$__importDefault = $b62953798c6dd5c7$exports && $b62953798c6dd5c7$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($b62953798c6dd5c7$exports, "__esModule", {
    value: true
});
$b62953798c6dd5c7$exports.QueryClientImpl = $b62953798c6dd5c7$exports.QueryDenomMetadataResponse = $b62953798c6dd5c7$exports.QueryDenomMetadataRequest = $b62953798c6dd5c7$exports.QueryDenomsMetadataResponse = $b62953798c6dd5c7$exports.QueryDenomsMetadataRequest = $b62953798c6dd5c7$exports.QueryParamsResponse = $b62953798c6dd5c7$exports.QueryParamsRequest = $b62953798c6dd5c7$exports.QuerySupplyOfResponse = $b62953798c6dd5c7$exports.QuerySupplyOfRequest = $b62953798c6dd5c7$exports.QueryTotalSupplyResponse = $b62953798c6dd5c7$exports.QueryTotalSupplyRequest = $b62953798c6dd5c7$exports.QueryAllBalancesResponse = $b62953798c6dd5c7$exports.QueryAllBalancesRequest = $b62953798c6dd5c7$exports.QueryBalanceResponse = $b62953798c6dd5c7$exports.QueryBalanceRequest = $b62953798c6dd5c7$exports.protobufPackage = void 0;

/* eslint-disable */ const $b62953798c6dd5c7$var$long_1 = $b62953798c6dd5c7$var$__importDefault((parcelRequire("9A55m")));

const $b62953798c6dd5c7$var$minimal_1 = $b62953798c6dd5c7$var$__importDefault((parcelRequire("i2pIU")));



$b62953798c6dd5c7$exports.protobufPackage = "cosmos.bank.v1beta1";
const $b62953798c6dd5c7$var$baseQueryBalanceRequest = {
    address: "",
    denom: ""
};
$b62953798c6dd5c7$exports.QueryBalanceRequest = {
    encode (message, writer = $b62953798c6dd5c7$var$minimal_1.default.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.denom !== "") writer.uint32(18).string(message.denom);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b62953798c6dd5c7$var$minimal_1.default.Reader ? input : new $b62953798c6dd5c7$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b62953798c6dd5c7$var$baseQueryBalanceRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $b62953798c6dd5c7$var$baseQueryBalanceRequest);
        message.address = object.address !== undefined && object.address !== null ? String(object.address) : "";
        message.denom = object.denom !== undefined && object.denom !== null ? String(object.denom) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $b62953798c6dd5c7$var$baseQueryBalanceRequest);
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        message.denom = (_b = object.denom) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
const $b62953798c6dd5c7$var$baseQueryBalanceResponse = {};
$b62953798c6dd5c7$exports.QueryBalanceResponse = {
    encode (message, writer = $b62953798c6dd5c7$var$minimal_1.default.Writer.create()) {
        if (message.balance !== undefined) $82ef09d1a8e2224d$exports.Coin.encode(message.balance, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b62953798c6dd5c7$var$minimal_1.default.Reader ? input : new $b62953798c6dd5c7$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b62953798c6dd5c7$var$baseQueryBalanceResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.balance = $82ef09d1a8e2224d$exports.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $b62953798c6dd5c7$var$baseQueryBalanceResponse);
        message.balance = object.balance !== undefined && object.balance !== null ? $82ef09d1a8e2224d$exports.Coin.fromJSON(object.balance) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.balance !== undefined && (obj.balance = message.balance ? $82ef09d1a8e2224d$exports.Coin.toJSON(message.balance) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $b62953798c6dd5c7$var$baseQueryBalanceResponse);
        message.balance = object.balance !== undefined && object.balance !== null ? $82ef09d1a8e2224d$exports.Coin.fromPartial(object.balance) : undefined;
        return message;
    }
};
const $b62953798c6dd5c7$var$baseQueryAllBalancesRequest = {
    address: ""
};
$b62953798c6dd5c7$exports.QueryAllBalancesRequest = {
    encode (message, writer = $b62953798c6dd5c7$var$minimal_1.default.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b62953798c6dd5c7$var$minimal_1.default.Reader ? input : new $b62953798c6dd5c7$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b62953798c6dd5c7$var$baseQueryAllBalancesRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.pagination = $f01b40e20607eb8e$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $b62953798c6dd5c7$var$baseQueryAllBalancesRequest);
        message.address = object.address !== undefined && object.address !== null ? String(object.address) : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromJSON(object.pagination) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $b62953798c6dd5c7$var$baseQueryAllBalancesRequest);
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
const $b62953798c6dd5c7$var$baseQueryAllBalancesResponse = {};
$b62953798c6dd5c7$exports.QueryAllBalancesResponse = {
    encode (message, writer = $b62953798c6dd5c7$var$minimal_1.default.Writer.create()) {
        for (const v of message.balances)$82ef09d1a8e2224d$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b62953798c6dd5c7$var$minimal_1.default.Reader ? input : new $b62953798c6dd5c7$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b62953798c6dd5c7$var$baseQueryAllBalancesResponse);
        message.balances = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.balances.push($82ef09d1a8e2224d$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $f01b40e20607eb8e$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $b62953798c6dd5c7$var$baseQueryAllBalancesResponse);
        message.balances = ((_a = object.balances) !== null && _a !== void 0 ? _a : []).map((e)=>$82ef09d1a8e2224d$exports.Coin.fromJSON(e));
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromJSON(object.pagination) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.balances) obj.balances = message.balances.map((e)=>e ? $82ef09d1a8e2224d$exports.Coin.toJSON(e) : undefined);
        else obj.balances = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $b62953798c6dd5c7$var$baseQueryAllBalancesResponse);
        message.balances = ((_a = object.balances) === null || _a === void 0 ? void 0 : _a.map((e)=>$82ef09d1a8e2224d$exports.Coin.fromPartial(e))) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
const $b62953798c6dd5c7$var$baseQueryTotalSupplyRequest = {};
$b62953798c6dd5c7$exports.QueryTotalSupplyRequest = {
    encode (message, writer = $b62953798c6dd5c7$var$minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b62953798c6dd5c7$var$minimal_1.default.Reader ? input : new $b62953798c6dd5c7$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b62953798c6dd5c7$var$baseQueryTotalSupplyRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pagination = $f01b40e20607eb8e$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $b62953798c6dd5c7$var$baseQueryTotalSupplyRequest);
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromJSON(object.pagination) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $b62953798c6dd5c7$var$baseQueryTotalSupplyRequest);
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
const $b62953798c6dd5c7$var$baseQueryTotalSupplyResponse = {};
$b62953798c6dd5c7$exports.QueryTotalSupplyResponse = {
    encode (message, writer = $b62953798c6dd5c7$var$minimal_1.default.Writer.create()) {
        for (const v of message.supply)$82ef09d1a8e2224d$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b62953798c6dd5c7$var$minimal_1.default.Reader ? input : new $b62953798c6dd5c7$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b62953798c6dd5c7$var$baseQueryTotalSupplyResponse);
        message.supply = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.supply.push($82ef09d1a8e2224d$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $f01b40e20607eb8e$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $b62953798c6dd5c7$var$baseQueryTotalSupplyResponse);
        message.supply = ((_a = object.supply) !== null && _a !== void 0 ? _a : []).map((e)=>$82ef09d1a8e2224d$exports.Coin.fromJSON(e));
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromJSON(object.pagination) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.supply) obj.supply = message.supply.map((e)=>e ? $82ef09d1a8e2224d$exports.Coin.toJSON(e) : undefined);
        else obj.supply = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $b62953798c6dd5c7$var$baseQueryTotalSupplyResponse);
        message.supply = ((_a = object.supply) === null || _a === void 0 ? void 0 : _a.map((e)=>$82ef09d1a8e2224d$exports.Coin.fromPartial(e))) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
const $b62953798c6dd5c7$var$baseQuerySupplyOfRequest = {
    denom: ""
};
$b62953798c6dd5c7$exports.QuerySupplyOfRequest = {
    encode (message, writer = $b62953798c6dd5c7$var$minimal_1.default.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b62953798c6dd5c7$var$minimal_1.default.Reader ? input : new $b62953798c6dd5c7$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b62953798c6dd5c7$var$baseQuerySupplyOfRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $b62953798c6dd5c7$var$baseQuerySupplyOfRequest);
        message.denom = object.denom !== undefined && object.denom !== null ? String(object.denom) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $b62953798c6dd5c7$var$baseQuerySupplyOfRequest);
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
const $b62953798c6dd5c7$var$baseQuerySupplyOfResponse = {};
$b62953798c6dd5c7$exports.QuerySupplyOfResponse = {
    encode (message, writer = $b62953798c6dd5c7$var$minimal_1.default.Writer.create()) {
        if (message.amount !== undefined) $82ef09d1a8e2224d$exports.Coin.encode(message.amount, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b62953798c6dd5c7$var$minimal_1.default.Reader ? input : new $b62953798c6dd5c7$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b62953798c6dd5c7$var$baseQuerySupplyOfResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.amount = $82ef09d1a8e2224d$exports.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $b62953798c6dd5c7$var$baseQuerySupplyOfResponse);
        message.amount = object.amount !== undefined && object.amount !== null ? $82ef09d1a8e2224d$exports.Coin.fromJSON(object.amount) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.amount !== undefined && (obj.amount = message.amount ? $82ef09d1a8e2224d$exports.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $b62953798c6dd5c7$var$baseQuerySupplyOfResponse);
        message.amount = object.amount !== undefined && object.amount !== null ? $82ef09d1a8e2224d$exports.Coin.fromPartial(object.amount) : undefined;
        return message;
    }
};
const $b62953798c6dd5c7$var$baseQueryParamsRequest = {};
$b62953798c6dd5c7$exports.QueryParamsRequest = {
    encode (_, writer = $b62953798c6dd5c7$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b62953798c6dd5c7$var$minimal_1.default.Reader ? input : new $b62953798c6dd5c7$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b62953798c6dd5c7$var$baseQueryParamsRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $b62953798c6dd5c7$var$baseQueryParamsRequest);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $b62953798c6dd5c7$var$baseQueryParamsRequest);
        return message;
    }
};
const $b62953798c6dd5c7$var$baseQueryParamsResponse = {};
$b62953798c6dd5c7$exports.QueryParamsResponse = {
    encode (message, writer = $b62953798c6dd5c7$var$minimal_1.default.Writer.create()) {
        if (message.params !== undefined) $f72b6892583c91bd$exports.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b62953798c6dd5c7$var$minimal_1.default.Reader ? input : new $b62953798c6dd5c7$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b62953798c6dd5c7$var$baseQueryParamsResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $f72b6892583c91bd$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $b62953798c6dd5c7$var$baseQueryParamsResponse);
        message.params = object.params !== undefined && object.params !== null ? $f72b6892583c91bd$exports.Params.fromJSON(object.params) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? $f72b6892583c91bd$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $b62953798c6dd5c7$var$baseQueryParamsResponse);
        message.params = object.params !== undefined && object.params !== null ? $f72b6892583c91bd$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
const $b62953798c6dd5c7$var$baseQueryDenomsMetadataRequest = {};
$b62953798c6dd5c7$exports.QueryDenomsMetadataRequest = {
    encode (message, writer = $b62953798c6dd5c7$var$minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b62953798c6dd5c7$var$minimal_1.default.Reader ? input : new $b62953798c6dd5c7$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b62953798c6dd5c7$var$baseQueryDenomsMetadataRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pagination = $f01b40e20607eb8e$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $b62953798c6dd5c7$var$baseQueryDenomsMetadataRequest);
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromJSON(object.pagination) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $b62953798c6dd5c7$var$baseQueryDenomsMetadataRequest);
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
const $b62953798c6dd5c7$var$baseQueryDenomsMetadataResponse = {};
$b62953798c6dd5c7$exports.QueryDenomsMetadataResponse = {
    encode (message, writer = $b62953798c6dd5c7$var$minimal_1.default.Writer.create()) {
        for (const v of message.metadatas)$f72b6892583c91bd$exports.Metadata.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b62953798c6dd5c7$var$minimal_1.default.Reader ? input : new $b62953798c6dd5c7$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b62953798c6dd5c7$var$baseQueryDenomsMetadataResponse);
        message.metadatas = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.metadatas.push($f72b6892583c91bd$exports.Metadata.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $f01b40e20607eb8e$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $b62953798c6dd5c7$var$baseQueryDenomsMetadataResponse);
        message.metadatas = ((_a = object.metadatas) !== null && _a !== void 0 ? _a : []).map((e)=>$f72b6892583c91bd$exports.Metadata.fromJSON(e));
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromJSON(object.pagination) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.metadatas) obj.metadatas = message.metadatas.map((e)=>e ? $f72b6892583c91bd$exports.Metadata.toJSON(e) : undefined);
        else obj.metadatas = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $b62953798c6dd5c7$var$baseQueryDenomsMetadataResponse);
        message.metadatas = ((_a = object.metadatas) === null || _a === void 0 ? void 0 : _a.map((e)=>$f72b6892583c91bd$exports.Metadata.fromPartial(e))) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
const $b62953798c6dd5c7$var$baseQueryDenomMetadataRequest = {
    denom: ""
};
$b62953798c6dd5c7$exports.QueryDenomMetadataRequest = {
    encode (message, writer = $b62953798c6dd5c7$var$minimal_1.default.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b62953798c6dd5c7$var$minimal_1.default.Reader ? input : new $b62953798c6dd5c7$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b62953798c6dd5c7$var$baseQueryDenomMetadataRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $b62953798c6dd5c7$var$baseQueryDenomMetadataRequest);
        message.denom = object.denom !== undefined && object.denom !== null ? String(object.denom) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $b62953798c6dd5c7$var$baseQueryDenomMetadataRequest);
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
const $b62953798c6dd5c7$var$baseQueryDenomMetadataResponse = {};
$b62953798c6dd5c7$exports.QueryDenomMetadataResponse = {
    encode (message, writer = $b62953798c6dd5c7$var$minimal_1.default.Writer.create()) {
        if (message.metadata !== undefined) $f72b6892583c91bd$exports.Metadata.encode(message.metadata, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b62953798c6dd5c7$var$minimal_1.default.Reader ? input : new $b62953798c6dd5c7$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b62953798c6dd5c7$var$baseQueryDenomMetadataResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.metadata = $f72b6892583c91bd$exports.Metadata.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $b62953798c6dd5c7$var$baseQueryDenomMetadataResponse);
        message.metadata = object.metadata !== undefined && object.metadata !== null ? $f72b6892583c91bd$exports.Metadata.fromJSON(object.metadata) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.metadata !== undefined && (obj.metadata = message.metadata ? $f72b6892583c91bd$exports.Metadata.toJSON(message.metadata) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $b62953798c6dd5c7$var$baseQueryDenomMetadataResponse);
        message.metadata = object.metadata !== undefined && object.metadata !== null ? $f72b6892583c91bd$exports.Metadata.fromPartial(object.metadata) : undefined;
        return message;
    }
};
class $b62953798c6dd5c7$var$QueryClientImpl {
    Balance(request) {
        const data = $b62953798c6dd5c7$exports.QueryBalanceRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "Balance", data);
        return promise.then((data)=>$b62953798c6dd5c7$exports.QueryBalanceResponse.decode(new $b62953798c6dd5c7$var$minimal_1.default.Reader(data)));
    }
    AllBalances(request) {
        const data = $b62953798c6dd5c7$exports.QueryAllBalancesRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "AllBalances", data);
        return promise.then((data)=>$b62953798c6dd5c7$exports.QueryAllBalancesResponse.decode(new $b62953798c6dd5c7$var$minimal_1.default.Reader(data)));
    }
    TotalSupply(request) {
        const data = $b62953798c6dd5c7$exports.QueryTotalSupplyRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "TotalSupply", data);
        return promise.then((data)=>$b62953798c6dd5c7$exports.QueryTotalSupplyResponse.decode(new $b62953798c6dd5c7$var$minimal_1.default.Reader(data)));
    }
    SupplyOf(request) {
        const data = $b62953798c6dd5c7$exports.QuerySupplyOfRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "SupplyOf", data);
        return promise.then((data)=>$b62953798c6dd5c7$exports.QuerySupplyOfResponse.decode(new $b62953798c6dd5c7$var$minimal_1.default.Reader(data)));
    }
    Params(request) {
        const data = $b62953798c6dd5c7$exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "Params", data);
        return promise.then((data)=>$b62953798c6dd5c7$exports.QueryParamsResponse.decode(new $b62953798c6dd5c7$var$minimal_1.default.Reader(data)));
    }
    DenomMetadata(request) {
        const data = $b62953798c6dd5c7$exports.QueryDenomMetadataRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "DenomMetadata", data);
        return promise.then((data)=>$b62953798c6dd5c7$exports.QueryDenomMetadataResponse.decode(new $b62953798c6dd5c7$var$minimal_1.default.Reader(data)));
    }
    DenomsMetadata(request) {
        const data = $b62953798c6dd5c7$exports.QueryDenomsMetadataRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "DenomsMetadata", data);
        return promise.then((data)=>$b62953798c6dd5c7$exports.QueryDenomsMetadataResponse.decode(new $b62953798c6dd5c7$var$minimal_1.default.Reader(data)));
    }
    constructor(rpc){
        this.rpc = rpc;
        this.Balance = this.Balance.bind(this);
        this.AllBalances = this.AllBalances.bind(this);
        this.TotalSupply = this.TotalSupply.bind(this);
        this.SupplyOf = this.SupplyOf.bind(this);
        this.Params = this.Params.bind(this);
        this.DenomMetadata = this.DenomMetadata.bind(this);
        this.DenomsMetadata = this.DenomsMetadata.bind(this);
    }
}
$b62953798c6dd5c7$exports.QueryClientImpl = $b62953798c6dd5c7$var$QueryClientImpl;
if ($b62953798c6dd5c7$var$minimal_1.default.util.Long !== $b62953798c6dd5c7$var$long_1.default) {
    $b62953798c6dd5c7$var$minimal_1.default.util.Long = $b62953798c6dd5c7$var$long_1.default;
    $b62953798c6dd5c7$var$minimal_1.default.configure();
}



function $0a9f39c98f92d6ec$var$setupBankExtension(base) {
    const rpc = (0, $ffdede50deec576f$exports.createProtobufRpcClient)(base);
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const queryService = new $b62953798c6dd5c7$exports.QueryClientImpl(rpc);
    return {
        bank: {
            balance: async (address, denom)=>{
                const { balance: balance } = await queryService.Balance({
                    address: address,
                    denom: denom
                });
                (0, $F6P8J.assert)(balance);
                return balance;
            },
            allBalances: async (address)=>{
                const { balances: balances } = await queryService.AllBalances({
                    address: address
                });
                return balances;
            },
            totalSupply: async ()=>{
                const { supply: supply } = await queryService.TotalSupply({});
                return supply;
            },
            supplyOf: async (denom)=>{
                const { amount: amount } = await queryService.SupplyOf({
                    denom: denom
                });
                (0, $F6P8J.assert)(amount);
                return amount;
            },
            denomMetadata: async (denom)=>{
                const { metadata: metadata } = await queryService.DenomMetadata({
                    denom: denom
                });
                (0, $F6P8J.assert)(metadata);
                return metadata;
            },
            denomsMetadata: async ()=>{
                const { metadatas: metadatas } = await queryService.DenomsMetadata({
                    pagination: undefined
                });
                return metadatas;
            }
        }
    };
}
$0a9f39c98f92d6ec$exports.setupBankExtension = $0a9f39c98f92d6ec$var$setupBankExtension;


Object.defineProperty($7725f2e3ca016b52$exports, "setupBankExtension", {
    enumerable: true,
    get: function() {
        return $0a9f39c98f92d6ec$exports.setupBankExtension;
    }
});
var $0294da7e221e779c$exports = {};
"use strict";
Object.defineProperty($0294da7e221e779c$exports, "__esModule", {
    value: true
});
$0294da7e221e779c$exports.createCrysisAminoConverters = $0294da7e221e779c$exports.isAminoMsgVerifyInvariant = void 0;
function $0294da7e221e779c$var$isAminoMsgVerifyInvariant(msg) {
    return msg.type === "cosmos-sdk/MsgVerifyInvariant";
}
$0294da7e221e779c$exports.isAminoMsgVerifyInvariant = $0294da7e221e779c$var$isAminoMsgVerifyInvariant;
function $0294da7e221e779c$var$createCrysisAminoConverters() {
    throw new Error("Not implemented");
}
$0294da7e221e779c$exports.createCrysisAminoConverters = $0294da7e221e779c$var$createCrysisAminoConverters;


Object.defineProperty($7725f2e3ca016b52$exports, "createCrysisAminoConverters", {
    enumerable: true,
    get: function() {
        return $0294da7e221e779c$exports.createCrysisAminoConverters;
    }
});
Object.defineProperty($7725f2e3ca016b52$exports, "isAminoMsgVerifyInvariant", {
    enumerable: true,
    get: function() {
        return $0294da7e221e779c$exports.isAminoMsgVerifyInvariant;
    }
});
var $3e131491157bfa48$exports = {};
"use strict";
Object.defineProperty($3e131491157bfa48$exports, "__esModule", {
    value: true
});
$3e131491157bfa48$exports.createDistributionAminoConverters = $3e131491157bfa48$exports.isAminoMsgFundCommunityPool = $3e131491157bfa48$exports.isAminoMsgWithdrawValidatorCommission = $3e131491157bfa48$exports.isAminoMsgWithdrawDelegatorReward = $3e131491157bfa48$exports.isAminoMsgSetWithdrawAddress = void 0;
function $3e131491157bfa48$var$isAminoMsgSetWithdrawAddress(msg) {
    // NOTE: Type string and names diverge here!
    return msg.type === "cosmos-sdk/MsgModifyWithdrawAddress";
}
$3e131491157bfa48$exports.isAminoMsgSetWithdrawAddress = $3e131491157bfa48$var$isAminoMsgSetWithdrawAddress;
function $3e131491157bfa48$var$isAminoMsgWithdrawDelegatorReward(msg) {
    // NOTE: Type string and names diverge here!
    return msg.type === "cosmos-sdk/MsgWithdrawDelegationReward";
}
$3e131491157bfa48$exports.isAminoMsgWithdrawDelegatorReward = $3e131491157bfa48$var$isAminoMsgWithdrawDelegatorReward;
function $3e131491157bfa48$var$isAminoMsgWithdrawValidatorCommission(msg) {
    return msg.type === "cosmos-sdk/MsgWithdrawValidatorCommission";
}
$3e131491157bfa48$exports.isAminoMsgWithdrawValidatorCommission = $3e131491157bfa48$var$isAminoMsgWithdrawValidatorCommission;
function $3e131491157bfa48$var$isAminoMsgFundCommunityPool(msg) {
    return msg.type === "cosmos-sdk/MsgFundCommunityPool";
}
$3e131491157bfa48$exports.isAminoMsgFundCommunityPool = $3e131491157bfa48$var$isAminoMsgFundCommunityPool;
function $3e131491157bfa48$var$createDistributionAminoConverters() {
    return {
        "/cosmos.distribution.v1beta1.MsgFundCommunityPool": {
            aminoType: "cosmos-sdk/MsgFundCommunityPool",
            toAmino: ({ amount: amount, depositor: depositor })=>({
                    amount: [
                        ...amount
                    ],
                    depositor: depositor
                }),
            fromAmino: ({ amount: amount, depositor: depositor })=>({
                    amount: [
                        ...amount
                    ],
                    depositor: depositor
                })
        },
        "/cosmos.distribution.v1beta1.MsgSetWithdrawAddress": {
            aminoType: "cosmos-sdk/MsgModifyWithdrawAddress",
            toAmino: ({ delegatorAddress: delegatorAddress, withdrawAddress: withdrawAddress })=>({
                    delegator_address: delegatorAddress,
                    withdraw_address: withdrawAddress
                }),
            fromAmino: ({ delegator_address: delegator_address, withdraw_address: withdraw_address })=>({
                    delegatorAddress: delegator_address,
                    withdrawAddress: withdraw_address
                })
        },
        "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward": {
            aminoType: "cosmos-sdk/MsgWithdrawDelegationReward",
            toAmino: ({ delegatorAddress: delegatorAddress, validatorAddress: validatorAddress })=>({
                    delegator_address: delegatorAddress,
                    validator_address: validatorAddress
                }),
            fromAmino: ({ delegator_address: delegator_address, validator_address: validator_address })=>({
                    delegatorAddress: delegator_address,
                    validatorAddress: validator_address
                })
        },
        "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission": {
            aminoType: "cosmos-sdk/MsgWithdrawValidatorCommission",
            toAmino: ({ validatorAddress: validatorAddress })=>({
                    validator_address: validatorAddress
                }),
            fromAmino: ({ validator_address: validator_address })=>({
                    validatorAddress: validator_address
                })
        }
    };
}
$3e131491157bfa48$exports.createDistributionAminoConverters = $3e131491157bfa48$var$createDistributionAminoConverters;


Object.defineProperty($7725f2e3ca016b52$exports, "createDistributionAminoConverters", {
    enumerable: true,
    get: function() {
        return $3e131491157bfa48$exports.createDistributionAminoConverters;
    }
});
Object.defineProperty($7725f2e3ca016b52$exports, "isAminoMsgFundCommunityPool", {
    enumerable: true,
    get: function() {
        return $3e131491157bfa48$exports.isAminoMsgFundCommunityPool;
    }
});
Object.defineProperty($7725f2e3ca016b52$exports, "isAminoMsgSetWithdrawAddress", {
    enumerable: true,
    get: function() {
        return $3e131491157bfa48$exports.isAminoMsgSetWithdrawAddress;
    }
});
Object.defineProperty($7725f2e3ca016b52$exports, "isAminoMsgWithdrawDelegatorReward", {
    enumerable: true,
    get: function() {
        return $3e131491157bfa48$exports.isAminoMsgWithdrawDelegatorReward;
    }
});
Object.defineProperty($7725f2e3ca016b52$exports, "isAminoMsgWithdrawValidatorCommission", {
    enumerable: true,
    get: function() {
        return $3e131491157bfa48$exports.isAminoMsgWithdrawValidatorCommission;
    }
});
var $369b2fb008403733$exports = {};
"use strict";
Object.defineProperty($369b2fb008403733$exports, "__esModule", {
    value: true
});
$369b2fb008403733$exports.isMsgWithdrawDelegatorRewardEncodeObject = $369b2fb008403733$exports.distributionTypes = void 0;
var $770beae6d633ee1a$exports = {};
"use strict";
var $770beae6d633ee1a$var$__importDefault = $770beae6d633ee1a$exports && $770beae6d633ee1a$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($770beae6d633ee1a$exports, "__esModule", {
    value: true
});
$770beae6d633ee1a$exports.MsgClientImpl = $770beae6d633ee1a$exports.MsgFundCommunityPoolResponse = $770beae6d633ee1a$exports.MsgFundCommunityPool = $770beae6d633ee1a$exports.MsgWithdrawValidatorCommissionResponse = $770beae6d633ee1a$exports.MsgWithdrawValidatorCommission = $770beae6d633ee1a$exports.MsgWithdrawDelegatorRewardResponse = $770beae6d633ee1a$exports.MsgWithdrawDelegatorReward = $770beae6d633ee1a$exports.MsgSetWithdrawAddressResponse = $770beae6d633ee1a$exports.MsgSetWithdrawAddress = $770beae6d633ee1a$exports.protobufPackage = void 0;

/* eslint-disable */ const $770beae6d633ee1a$var$long_1 = $770beae6d633ee1a$var$__importDefault((parcelRequire("9A55m")));

const $770beae6d633ee1a$var$minimal_1 = $770beae6d633ee1a$var$__importDefault((parcelRequire("i2pIU")));

$770beae6d633ee1a$exports.protobufPackage = "cosmos.distribution.v1beta1";
const $770beae6d633ee1a$var$baseMsgSetWithdrawAddress = {
    delegatorAddress: "",
    withdrawAddress: ""
};
$770beae6d633ee1a$exports.MsgSetWithdrawAddress = {
    encode (message, writer = $770beae6d633ee1a$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.withdrawAddress !== "") writer.uint32(18).string(message.withdrawAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $770beae6d633ee1a$var$minimal_1.default.Reader ? input : new $770beae6d633ee1a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $770beae6d633ee1a$var$baseMsgSetWithdrawAddress);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.withdrawAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $770beae6d633ee1a$var$baseMsgSetWithdrawAddress);
        message.delegatorAddress = object.delegatorAddress !== undefined && object.delegatorAddress !== null ? String(object.delegatorAddress) : "";
        message.withdrawAddress = object.withdrawAddress !== undefined && object.withdrawAddress !== null ? String(object.withdrawAddress) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.withdrawAddress !== undefined && (obj.withdrawAddress = message.withdrawAddress);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $770beae6d633ee1a$var$baseMsgSetWithdrawAddress);
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.withdrawAddress = (_b = object.withdrawAddress) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
const $770beae6d633ee1a$var$baseMsgSetWithdrawAddressResponse = {};
$770beae6d633ee1a$exports.MsgSetWithdrawAddressResponse = {
    encode (_, writer = $770beae6d633ee1a$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $770beae6d633ee1a$var$minimal_1.default.Reader ? input : new $770beae6d633ee1a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $770beae6d633ee1a$var$baseMsgSetWithdrawAddressResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $770beae6d633ee1a$var$baseMsgSetWithdrawAddressResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $770beae6d633ee1a$var$baseMsgSetWithdrawAddressResponse);
        return message;
    }
};
const $770beae6d633ee1a$var$baseMsgWithdrawDelegatorReward = {
    delegatorAddress: "",
    validatorAddress: ""
};
$770beae6d633ee1a$exports.MsgWithdrawDelegatorReward = {
    encode (message, writer = $770beae6d633ee1a$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $770beae6d633ee1a$var$minimal_1.default.Reader ? input : new $770beae6d633ee1a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $770beae6d633ee1a$var$baseMsgWithdrawDelegatorReward);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $770beae6d633ee1a$var$baseMsgWithdrawDelegatorReward);
        message.delegatorAddress = object.delegatorAddress !== undefined && object.delegatorAddress !== null ? String(object.delegatorAddress) : "";
        message.validatorAddress = object.validatorAddress !== undefined && object.validatorAddress !== null ? String(object.validatorAddress) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $770beae6d633ee1a$var$baseMsgWithdrawDelegatorReward);
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorAddress = (_b = object.validatorAddress) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
const $770beae6d633ee1a$var$baseMsgWithdrawDelegatorRewardResponse = {};
$770beae6d633ee1a$exports.MsgWithdrawDelegatorRewardResponse = {
    encode (_, writer = $770beae6d633ee1a$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $770beae6d633ee1a$var$minimal_1.default.Reader ? input : new $770beae6d633ee1a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $770beae6d633ee1a$var$baseMsgWithdrawDelegatorRewardResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $770beae6d633ee1a$var$baseMsgWithdrawDelegatorRewardResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $770beae6d633ee1a$var$baseMsgWithdrawDelegatorRewardResponse);
        return message;
    }
};
const $770beae6d633ee1a$var$baseMsgWithdrawValidatorCommission = {
    validatorAddress: ""
};
$770beae6d633ee1a$exports.MsgWithdrawValidatorCommission = {
    encode (message, writer = $770beae6d633ee1a$var$minimal_1.default.Writer.create()) {
        if (message.validatorAddress !== "") writer.uint32(10).string(message.validatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $770beae6d633ee1a$var$minimal_1.default.Reader ? input : new $770beae6d633ee1a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $770beae6d633ee1a$var$baseMsgWithdrawValidatorCommission);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $770beae6d633ee1a$var$baseMsgWithdrawValidatorCommission);
        message.validatorAddress = object.validatorAddress !== undefined && object.validatorAddress !== null ? String(object.validatorAddress) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $770beae6d633ee1a$var$baseMsgWithdrawValidatorCommission);
        message.validatorAddress = (_a = object.validatorAddress) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
const $770beae6d633ee1a$var$baseMsgWithdrawValidatorCommissionResponse = {};
$770beae6d633ee1a$exports.MsgWithdrawValidatorCommissionResponse = {
    encode (_, writer = $770beae6d633ee1a$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $770beae6d633ee1a$var$minimal_1.default.Reader ? input : new $770beae6d633ee1a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $770beae6d633ee1a$var$baseMsgWithdrawValidatorCommissionResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $770beae6d633ee1a$var$baseMsgWithdrawValidatorCommissionResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $770beae6d633ee1a$var$baseMsgWithdrawValidatorCommissionResponse);
        return message;
    }
};
const $770beae6d633ee1a$var$baseMsgFundCommunityPool = {
    depositor: ""
};
$770beae6d633ee1a$exports.MsgFundCommunityPool = {
    encode (message, writer = $770beae6d633ee1a$var$minimal_1.default.Writer.create()) {
        for (const v of message.amount)$82ef09d1a8e2224d$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.depositor !== "") writer.uint32(18).string(message.depositor);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $770beae6d633ee1a$var$minimal_1.default.Reader ? input : new $770beae6d633ee1a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $770beae6d633ee1a$var$baseMsgFundCommunityPool);
        message.amount = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.amount.push($82ef09d1a8e2224d$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $770beae6d633ee1a$var$baseMsgFundCommunityPool);
        message.amount = ((_a = object.amount) !== null && _a !== void 0 ? _a : []).map((e)=>$82ef09d1a8e2224d$exports.Coin.fromJSON(e));
        message.depositor = object.depositor !== undefined && object.depositor !== null ? String(object.depositor) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $82ef09d1a8e2224d$exports.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        message.depositor !== undefined && (obj.depositor = message.depositor);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $770beae6d633ee1a$var$baseMsgFundCommunityPool);
        message.amount = ((_a = object.amount) === null || _a === void 0 ? void 0 : _a.map((e)=>$82ef09d1a8e2224d$exports.Coin.fromPartial(e))) || [];
        message.depositor = (_b = object.depositor) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
const $770beae6d633ee1a$var$baseMsgFundCommunityPoolResponse = {};
$770beae6d633ee1a$exports.MsgFundCommunityPoolResponse = {
    encode (_, writer = $770beae6d633ee1a$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $770beae6d633ee1a$var$minimal_1.default.Reader ? input : new $770beae6d633ee1a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $770beae6d633ee1a$var$baseMsgFundCommunityPoolResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $770beae6d633ee1a$var$baseMsgFundCommunityPoolResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $770beae6d633ee1a$var$baseMsgFundCommunityPoolResponse);
        return message;
    }
};
class $770beae6d633ee1a$var$MsgClientImpl {
    SetWithdrawAddress(request) {
        const data = $770beae6d633ee1a$exports.MsgSetWithdrawAddress.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Msg", "SetWithdrawAddress", data);
        return promise.then((data)=>$770beae6d633ee1a$exports.MsgSetWithdrawAddressResponse.decode(new $770beae6d633ee1a$var$minimal_1.default.Reader(data)));
    }
    WithdrawDelegatorReward(request) {
        const data = $770beae6d633ee1a$exports.MsgWithdrawDelegatorReward.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Msg", "WithdrawDelegatorReward", data);
        return promise.then((data)=>$770beae6d633ee1a$exports.MsgWithdrawDelegatorRewardResponse.decode(new $770beae6d633ee1a$var$minimal_1.default.Reader(data)));
    }
    WithdrawValidatorCommission(request) {
        const data = $770beae6d633ee1a$exports.MsgWithdrawValidatorCommission.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Msg", "WithdrawValidatorCommission", data);
        return promise.then((data)=>$770beae6d633ee1a$exports.MsgWithdrawValidatorCommissionResponse.decode(new $770beae6d633ee1a$var$minimal_1.default.Reader(data)));
    }
    FundCommunityPool(request) {
        const data = $770beae6d633ee1a$exports.MsgFundCommunityPool.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Msg", "FundCommunityPool", data);
        return promise.then((data)=>$770beae6d633ee1a$exports.MsgFundCommunityPoolResponse.decode(new $770beae6d633ee1a$var$minimal_1.default.Reader(data)));
    }
    constructor(rpc){
        this.rpc = rpc;
        this.SetWithdrawAddress = this.SetWithdrawAddress.bind(this);
        this.WithdrawDelegatorReward = this.WithdrawDelegatorReward.bind(this);
        this.WithdrawValidatorCommission = this.WithdrawValidatorCommission.bind(this);
        this.FundCommunityPool = this.FundCommunityPool.bind(this);
    }
}
$770beae6d633ee1a$exports.MsgClientImpl = $770beae6d633ee1a$var$MsgClientImpl;
if ($770beae6d633ee1a$var$minimal_1.default.util.Long !== $770beae6d633ee1a$var$long_1.default) {
    $770beae6d633ee1a$var$minimal_1.default.util.Long = $770beae6d633ee1a$var$long_1.default;
    $770beae6d633ee1a$var$minimal_1.default.configure();
}


$369b2fb008403733$exports.distributionTypes = [
    [
        "/cosmos.distribution.v1beta1.MsgFundCommunityPool",
        $770beae6d633ee1a$exports.MsgFundCommunityPool
    ],
    [
        "/cosmos.distribution.v1beta1.MsgSetWithdrawAddress",
        $770beae6d633ee1a$exports.MsgSetWithdrawAddress
    ],
    [
        "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
        $770beae6d633ee1a$exports.MsgWithdrawDelegatorReward
    ],
    [
        "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission",
        $770beae6d633ee1a$exports.MsgWithdrawValidatorCommission
    ]
];
function $369b2fb008403733$var$isMsgWithdrawDelegatorRewardEncodeObject(object) {
    return object.typeUrl === "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward";
}
$369b2fb008403733$exports.isMsgWithdrawDelegatorRewardEncodeObject = $369b2fb008403733$var$isMsgWithdrawDelegatorRewardEncodeObject;


Object.defineProperty($7725f2e3ca016b52$exports, "distributionTypes", {
    enumerable: true,
    get: function() {
        return $369b2fb008403733$exports.distributionTypes;
    }
});
Object.defineProperty($7725f2e3ca016b52$exports, "isMsgWithdrawDelegatorRewardEncodeObject", {
    enumerable: true,
    get: function() {
        return $369b2fb008403733$exports.isMsgWithdrawDelegatorRewardEncodeObject;
    }
});
var $aa3d1de913220979$exports = {};
"use strict";
var $aa3d1de913220979$var$__importDefault = $aa3d1de913220979$exports && $aa3d1de913220979$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($aa3d1de913220979$exports, "__esModule", {
    value: true
});
$aa3d1de913220979$exports.setupDistributionExtension = void 0;
var $928198056f96ecb1$exports = {};
"use strict";
var $928198056f96ecb1$var$__importDefault = $928198056f96ecb1$exports && $928198056f96ecb1$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($928198056f96ecb1$exports, "__esModule", {
    value: true
});
$928198056f96ecb1$exports.QueryClientImpl = $928198056f96ecb1$exports.QueryCommunityPoolResponse = $928198056f96ecb1$exports.QueryCommunityPoolRequest = $928198056f96ecb1$exports.QueryDelegatorWithdrawAddressResponse = $928198056f96ecb1$exports.QueryDelegatorWithdrawAddressRequest = $928198056f96ecb1$exports.QueryDelegatorValidatorsResponse = $928198056f96ecb1$exports.QueryDelegatorValidatorsRequest = $928198056f96ecb1$exports.QueryDelegationTotalRewardsResponse = $928198056f96ecb1$exports.QueryDelegationTotalRewardsRequest = $928198056f96ecb1$exports.QueryDelegationRewardsResponse = $928198056f96ecb1$exports.QueryDelegationRewardsRequest = $928198056f96ecb1$exports.QueryValidatorSlashesResponse = $928198056f96ecb1$exports.QueryValidatorSlashesRequest = $928198056f96ecb1$exports.QueryValidatorCommissionResponse = $928198056f96ecb1$exports.QueryValidatorCommissionRequest = $928198056f96ecb1$exports.QueryValidatorOutstandingRewardsResponse = $928198056f96ecb1$exports.QueryValidatorOutstandingRewardsRequest = $928198056f96ecb1$exports.QueryParamsResponse = $928198056f96ecb1$exports.QueryParamsRequest = $928198056f96ecb1$exports.protobufPackage = void 0;

/* eslint-disable */ const $928198056f96ecb1$var$long_1 = $928198056f96ecb1$var$__importDefault((parcelRequire("9A55m")));

const $928198056f96ecb1$var$minimal_1 = $928198056f96ecb1$var$__importDefault((parcelRequire("i2pIU")));
var $f6bb1544e36de7dd$exports = {};
"use strict";
var $f6bb1544e36de7dd$var$__importDefault = $f6bb1544e36de7dd$exports && $f6bb1544e36de7dd$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($f6bb1544e36de7dd$exports, "__esModule", {
    value: true
});
$f6bb1544e36de7dd$exports.CommunityPoolSpendProposalWithDeposit = $f6bb1544e36de7dd$exports.DelegationDelegatorReward = $f6bb1544e36de7dd$exports.DelegatorStartingInfo = $f6bb1544e36de7dd$exports.CommunityPoolSpendProposal = $f6bb1544e36de7dd$exports.FeePool = $f6bb1544e36de7dd$exports.ValidatorSlashEvents = $f6bb1544e36de7dd$exports.ValidatorSlashEvent = $f6bb1544e36de7dd$exports.ValidatorOutstandingRewards = $f6bb1544e36de7dd$exports.ValidatorAccumulatedCommission = $f6bb1544e36de7dd$exports.ValidatorCurrentRewards = $f6bb1544e36de7dd$exports.ValidatorHistoricalRewards = $f6bb1544e36de7dd$exports.Params = $f6bb1544e36de7dd$exports.protobufPackage = void 0;

/* eslint-disable */ const $f6bb1544e36de7dd$var$long_1 = $f6bb1544e36de7dd$var$__importDefault((parcelRequire("9A55m")));

const $f6bb1544e36de7dd$var$minimal_1 = $f6bb1544e36de7dd$var$__importDefault((parcelRequire("i2pIU")));

$f6bb1544e36de7dd$exports.protobufPackage = "cosmos.distribution.v1beta1";
const $f6bb1544e36de7dd$var$baseParams = {
    communityTax: "",
    baseProposerReward: "",
    bonusProposerReward: "",
    withdrawAddrEnabled: false
};
$f6bb1544e36de7dd$exports.Params = {
    encode (message, writer = $f6bb1544e36de7dd$var$minimal_1.default.Writer.create()) {
        if (message.communityTax !== "") writer.uint32(10).string(message.communityTax);
        if (message.baseProposerReward !== "") writer.uint32(18).string(message.baseProposerReward);
        if (message.bonusProposerReward !== "") writer.uint32(26).string(message.bonusProposerReward);
        if (message.withdrawAddrEnabled === true) writer.uint32(32).bool(message.withdrawAddrEnabled);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f6bb1544e36de7dd$var$minimal_1.default.Reader ? input : new $f6bb1544e36de7dd$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $f6bb1544e36de7dd$var$baseParams);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.communityTax = reader.string();
                    break;
                case 2:
                    message.baseProposerReward = reader.string();
                    break;
                case 3:
                    message.bonusProposerReward = reader.string();
                    break;
                case 4:
                    message.withdrawAddrEnabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $f6bb1544e36de7dd$var$baseParams);
        message.communityTax = object.communityTax !== undefined && object.communityTax !== null ? String(object.communityTax) : "";
        message.baseProposerReward = object.baseProposerReward !== undefined && object.baseProposerReward !== null ? String(object.baseProposerReward) : "";
        message.bonusProposerReward = object.bonusProposerReward !== undefined && object.bonusProposerReward !== null ? String(object.bonusProposerReward) : "";
        message.withdrawAddrEnabled = object.withdrawAddrEnabled !== undefined && object.withdrawAddrEnabled !== null ? Boolean(object.withdrawAddrEnabled) : false;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.communityTax !== undefined && (obj.communityTax = message.communityTax);
        message.baseProposerReward !== undefined && (obj.baseProposerReward = message.baseProposerReward);
        message.bonusProposerReward !== undefined && (obj.bonusProposerReward = message.bonusProposerReward);
        message.withdrawAddrEnabled !== undefined && (obj.withdrawAddrEnabled = message.withdrawAddrEnabled);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = Object.assign({}, $f6bb1544e36de7dd$var$baseParams);
        message.communityTax = (_a = object.communityTax) !== null && _a !== void 0 ? _a : "";
        message.baseProposerReward = (_b = object.baseProposerReward) !== null && _b !== void 0 ? _b : "";
        message.bonusProposerReward = (_c = object.bonusProposerReward) !== null && _c !== void 0 ? _c : "";
        message.withdrawAddrEnabled = (_d = object.withdrawAddrEnabled) !== null && _d !== void 0 ? _d : false;
        return message;
    }
};
const $f6bb1544e36de7dd$var$baseValidatorHistoricalRewards = {
    referenceCount: 0
};
$f6bb1544e36de7dd$exports.ValidatorHistoricalRewards = {
    encode (message, writer = $f6bb1544e36de7dd$var$minimal_1.default.Writer.create()) {
        for (const v of message.cumulativeRewardRatio)$82ef09d1a8e2224d$exports.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.referenceCount !== 0) writer.uint32(16).uint32(message.referenceCount);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f6bb1544e36de7dd$var$minimal_1.default.Reader ? input : new $f6bb1544e36de7dd$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $f6bb1544e36de7dd$var$baseValidatorHistoricalRewards);
        message.cumulativeRewardRatio = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.cumulativeRewardRatio.push($82ef09d1a8e2224d$exports.DecCoin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.referenceCount = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $f6bb1544e36de7dd$var$baseValidatorHistoricalRewards);
        message.cumulativeRewardRatio = ((_a = object.cumulativeRewardRatio) !== null && _a !== void 0 ? _a : []).map((e)=>$82ef09d1a8e2224d$exports.DecCoin.fromJSON(e));
        message.referenceCount = object.referenceCount !== undefined && object.referenceCount !== null ? Number(object.referenceCount) : 0;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.cumulativeRewardRatio) obj.cumulativeRewardRatio = message.cumulativeRewardRatio.map((e)=>e ? $82ef09d1a8e2224d$exports.DecCoin.toJSON(e) : undefined);
        else obj.cumulativeRewardRatio = [];
        message.referenceCount !== undefined && (obj.referenceCount = message.referenceCount);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $f6bb1544e36de7dd$var$baseValidatorHistoricalRewards);
        message.cumulativeRewardRatio = ((_a = object.cumulativeRewardRatio) === null || _a === void 0 ? void 0 : _a.map((e)=>$82ef09d1a8e2224d$exports.DecCoin.fromPartial(e))) || [];
        message.referenceCount = (_b = object.referenceCount) !== null && _b !== void 0 ? _b : 0;
        return message;
    }
};
const $f6bb1544e36de7dd$var$baseValidatorCurrentRewards = {
    period: $f6bb1544e36de7dd$var$long_1.default.UZERO
};
$f6bb1544e36de7dd$exports.ValidatorCurrentRewards = {
    encode (message, writer = $f6bb1544e36de7dd$var$minimal_1.default.Writer.create()) {
        for (const v of message.rewards)$82ef09d1a8e2224d$exports.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        if (!message.period.isZero()) writer.uint32(16).uint64(message.period);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f6bb1544e36de7dd$var$minimal_1.default.Reader ? input : new $f6bb1544e36de7dd$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $f6bb1544e36de7dd$var$baseValidatorCurrentRewards);
        message.rewards = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.rewards.push($82ef09d1a8e2224d$exports.DecCoin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.period = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $f6bb1544e36de7dd$var$baseValidatorCurrentRewards);
        message.rewards = ((_a = object.rewards) !== null && _a !== void 0 ? _a : []).map((e)=>$82ef09d1a8e2224d$exports.DecCoin.fromJSON(e));
        message.period = object.period !== undefined && object.period !== null ? $f6bb1544e36de7dd$var$long_1.default.fromString(object.period) : $f6bb1544e36de7dd$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.rewards) obj.rewards = message.rewards.map((e)=>e ? $82ef09d1a8e2224d$exports.DecCoin.toJSON(e) : undefined);
        else obj.rewards = [];
        message.period !== undefined && (obj.period = (message.period || $f6bb1544e36de7dd$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $f6bb1544e36de7dd$var$baseValidatorCurrentRewards);
        message.rewards = ((_a = object.rewards) === null || _a === void 0 ? void 0 : _a.map((e)=>$82ef09d1a8e2224d$exports.DecCoin.fromPartial(e))) || [];
        message.period = object.period !== undefined && object.period !== null ? $f6bb1544e36de7dd$var$long_1.default.fromValue(object.period) : $f6bb1544e36de7dd$var$long_1.default.UZERO;
        return message;
    }
};
const $f6bb1544e36de7dd$var$baseValidatorAccumulatedCommission = {};
$f6bb1544e36de7dd$exports.ValidatorAccumulatedCommission = {
    encode (message, writer = $f6bb1544e36de7dd$var$minimal_1.default.Writer.create()) {
        for (const v of message.commission)$82ef09d1a8e2224d$exports.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f6bb1544e36de7dd$var$minimal_1.default.Reader ? input : new $f6bb1544e36de7dd$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $f6bb1544e36de7dd$var$baseValidatorAccumulatedCommission);
        message.commission = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.commission.push($82ef09d1a8e2224d$exports.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $f6bb1544e36de7dd$var$baseValidatorAccumulatedCommission);
        message.commission = ((_a = object.commission) !== null && _a !== void 0 ? _a : []).map((e)=>$82ef09d1a8e2224d$exports.DecCoin.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.commission) obj.commission = message.commission.map((e)=>e ? $82ef09d1a8e2224d$exports.DecCoin.toJSON(e) : undefined);
        else obj.commission = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $f6bb1544e36de7dd$var$baseValidatorAccumulatedCommission);
        message.commission = ((_a = object.commission) === null || _a === void 0 ? void 0 : _a.map((e)=>$82ef09d1a8e2224d$exports.DecCoin.fromPartial(e))) || [];
        return message;
    }
};
const $f6bb1544e36de7dd$var$baseValidatorOutstandingRewards = {};
$f6bb1544e36de7dd$exports.ValidatorOutstandingRewards = {
    encode (message, writer = $f6bb1544e36de7dd$var$minimal_1.default.Writer.create()) {
        for (const v of message.rewards)$82ef09d1a8e2224d$exports.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f6bb1544e36de7dd$var$minimal_1.default.Reader ? input : new $f6bb1544e36de7dd$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $f6bb1544e36de7dd$var$baseValidatorOutstandingRewards);
        message.rewards = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.rewards.push($82ef09d1a8e2224d$exports.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $f6bb1544e36de7dd$var$baseValidatorOutstandingRewards);
        message.rewards = ((_a = object.rewards) !== null && _a !== void 0 ? _a : []).map((e)=>$82ef09d1a8e2224d$exports.DecCoin.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.rewards) obj.rewards = message.rewards.map((e)=>e ? $82ef09d1a8e2224d$exports.DecCoin.toJSON(e) : undefined);
        else obj.rewards = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $f6bb1544e36de7dd$var$baseValidatorOutstandingRewards);
        message.rewards = ((_a = object.rewards) === null || _a === void 0 ? void 0 : _a.map((e)=>$82ef09d1a8e2224d$exports.DecCoin.fromPartial(e))) || [];
        return message;
    }
};
const $f6bb1544e36de7dd$var$baseValidatorSlashEvent = {
    validatorPeriod: $f6bb1544e36de7dd$var$long_1.default.UZERO,
    fraction: ""
};
$f6bb1544e36de7dd$exports.ValidatorSlashEvent = {
    encode (message, writer = $f6bb1544e36de7dd$var$minimal_1.default.Writer.create()) {
        if (!message.validatorPeriod.isZero()) writer.uint32(8).uint64(message.validatorPeriod);
        if (message.fraction !== "") writer.uint32(18).string(message.fraction);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f6bb1544e36de7dd$var$minimal_1.default.Reader ? input : new $f6bb1544e36de7dd$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $f6bb1544e36de7dd$var$baseValidatorSlashEvent);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorPeriod = reader.uint64();
                    break;
                case 2:
                    message.fraction = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $f6bb1544e36de7dd$var$baseValidatorSlashEvent);
        message.validatorPeriod = object.validatorPeriod !== undefined && object.validatorPeriod !== null ? $f6bb1544e36de7dd$var$long_1.default.fromString(object.validatorPeriod) : $f6bb1544e36de7dd$var$long_1.default.UZERO;
        message.fraction = object.fraction !== undefined && object.fraction !== null ? String(object.fraction) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.validatorPeriod !== undefined && (obj.validatorPeriod = (message.validatorPeriod || $f6bb1544e36de7dd$var$long_1.default.UZERO).toString());
        message.fraction !== undefined && (obj.fraction = message.fraction);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $f6bb1544e36de7dd$var$baseValidatorSlashEvent);
        message.validatorPeriod = object.validatorPeriod !== undefined && object.validatorPeriod !== null ? $f6bb1544e36de7dd$var$long_1.default.fromValue(object.validatorPeriod) : $f6bb1544e36de7dd$var$long_1.default.UZERO;
        message.fraction = (_a = object.fraction) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
const $f6bb1544e36de7dd$var$baseValidatorSlashEvents = {};
$f6bb1544e36de7dd$exports.ValidatorSlashEvents = {
    encode (message, writer = $f6bb1544e36de7dd$var$minimal_1.default.Writer.create()) {
        for (const v of message.validatorSlashEvents)$f6bb1544e36de7dd$exports.ValidatorSlashEvent.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f6bb1544e36de7dd$var$minimal_1.default.Reader ? input : new $f6bb1544e36de7dd$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $f6bb1544e36de7dd$var$baseValidatorSlashEvents);
        message.validatorSlashEvents = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorSlashEvents.push($f6bb1544e36de7dd$exports.ValidatorSlashEvent.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $f6bb1544e36de7dd$var$baseValidatorSlashEvents);
        message.validatorSlashEvents = ((_a = object.validatorSlashEvents) !== null && _a !== void 0 ? _a : []).map((e)=>$f6bb1544e36de7dd$exports.ValidatorSlashEvent.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.validatorSlashEvents) obj.validatorSlashEvents = message.validatorSlashEvents.map((e)=>e ? $f6bb1544e36de7dd$exports.ValidatorSlashEvent.toJSON(e) : undefined);
        else obj.validatorSlashEvents = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $f6bb1544e36de7dd$var$baseValidatorSlashEvents);
        message.validatorSlashEvents = ((_a = object.validatorSlashEvents) === null || _a === void 0 ? void 0 : _a.map((e)=>$f6bb1544e36de7dd$exports.ValidatorSlashEvent.fromPartial(e))) || [];
        return message;
    }
};
const $f6bb1544e36de7dd$var$baseFeePool = {};
$f6bb1544e36de7dd$exports.FeePool = {
    encode (message, writer = $f6bb1544e36de7dd$var$minimal_1.default.Writer.create()) {
        for (const v of message.communityPool)$82ef09d1a8e2224d$exports.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f6bb1544e36de7dd$var$minimal_1.default.Reader ? input : new $f6bb1544e36de7dd$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $f6bb1544e36de7dd$var$baseFeePool);
        message.communityPool = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.communityPool.push($82ef09d1a8e2224d$exports.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $f6bb1544e36de7dd$var$baseFeePool);
        message.communityPool = ((_a = object.communityPool) !== null && _a !== void 0 ? _a : []).map((e)=>$82ef09d1a8e2224d$exports.DecCoin.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.communityPool) obj.communityPool = message.communityPool.map((e)=>e ? $82ef09d1a8e2224d$exports.DecCoin.toJSON(e) : undefined);
        else obj.communityPool = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $f6bb1544e36de7dd$var$baseFeePool);
        message.communityPool = ((_a = object.communityPool) === null || _a === void 0 ? void 0 : _a.map((e)=>$82ef09d1a8e2224d$exports.DecCoin.fromPartial(e))) || [];
        return message;
    }
};
const $f6bb1544e36de7dd$var$baseCommunityPoolSpendProposal = {
    title: "",
    description: "",
    recipient: ""
};
$f6bb1544e36de7dd$exports.CommunityPoolSpendProposal = {
    encode (message, writer = $f6bb1544e36de7dd$var$minimal_1.default.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        if (message.recipient !== "") writer.uint32(26).string(message.recipient);
        for (const v of message.amount)$82ef09d1a8e2224d$exports.Coin.encode(v, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f6bb1544e36de7dd$var$minimal_1.default.Reader ? input : new $f6bb1544e36de7dd$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $f6bb1544e36de7dd$var$baseCommunityPoolSpendProposal);
        message.amount = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.recipient = reader.string();
                    break;
                case 4:
                    message.amount.push($82ef09d1a8e2224d$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $f6bb1544e36de7dd$var$baseCommunityPoolSpendProposal);
        message.title = object.title !== undefined && object.title !== null ? String(object.title) : "";
        message.description = object.description !== undefined && object.description !== null ? String(object.description) : "";
        message.recipient = object.recipient !== undefined && object.recipient !== null ? String(object.recipient) : "";
        message.amount = ((_a = object.amount) !== null && _a !== void 0 ? _a : []).map((e)=>$82ef09d1a8e2224d$exports.Coin.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.recipient !== undefined && (obj.recipient = message.recipient);
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $82ef09d1a8e2224d$exports.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = Object.assign({}, $f6bb1544e36de7dd$var$baseCommunityPoolSpendProposal);
        message.title = (_a = object.title) !== null && _a !== void 0 ? _a : "";
        message.description = (_b = object.description) !== null && _b !== void 0 ? _b : "";
        message.recipient = (_c = object.recipient) !== null && _c !== void 0 ? _c : "";
        message.amount = ((_d = object.amount) === null || _d === void 0 ? void 0 : _d.map((e)=>$82ef09d1a8e2224d$exports.Coin.fromPartial(e))) || [];
        return message;
    }
};
const $f6bb1544e36de7dd$var$baseDelegatorStartingInfo = {
    previousPeriod: $f6bb1544e36de7dd$var$long_1.default.UZERO,
    stake: "",
    height: $f6bb1544e36de7dd$var$long_1.default.UZERO
};
$f6bb1544e36de7dd$exports.DelegatorStartingInfo = {
    encode (message, writer = $f6bb1544e36de7dd$var$minimal_1.default.Writer.create()) {
        if (!message.previousPeriod.isZero()) writer.uint32(8).uint64(message.previousPeriod);
        if (message.stake !== "") writer.uint32(18).string(message.stake);
        if (!message.height.isZero()) writer.uint32(24).uint64(message.height);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f6bb1544e36de7dd$var$minimal_1.default.Reader ? input : new $f6bb1544e36de7dd$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $f6bb1544e36de7dd$var$baseDelegatorStartingInfo);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.previousPeriod = reader.uint64();
                    break;
                case 2:
                    message.stake = reader.string();
                    break;
                case 3:
                    message.height = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $f6bb1544e36de7dd$var$baseDelegatorStartingInfo);
        message.previousPeriod = object.previousPeriod !== undefined && object.previousPeriod !== null ? $f6bb1544e36de7dd$var$long_1.default.fromString(object.previousPeriod) : $f6bb1544e36de7dd$var$long_1.default.UZERO;
        message.stake = object.stake !== undefined && object.stake !== null ? String(object.stake) : "";
        message.height = object.height !== undefined && object.height !== null ? $f6bb1544e36de7dd$var$long_1.default.fromString(object.height) : $f6bb1544e36de7dd$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.previousPeriod !== undefined && (obj.previousPeriod = (message.previousPeriod || $f6bb1544e36de7dd$var$long_1.default.UZERO).toString());
        message.stake !== undefined && (obj.stake = message.stake);
        message.height !== undefined && (obj.height = (message.height || $f6bb1544e36de7dd$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $f6bb1544e36de7dd$var$baseDelegatorStartingInfo);
        message.previousPeriod = object.previousPeriod !== undefined && object.previousPeriod !== null ? $f6bb1544e36de7dd$var$long_1.default.fromValue(object.previousPeriod) : $f6bb1544e36de7dd$var$long_1.default.UZERO;
        message.stake = (_a = object.stake) !== null && _a !== void 0 ? _a : "";
        message.height = object.height !== undefined && object.height !== null ? $f6bb1544e36de7dd$var$long_1.default.fromValue(object.height) : $f6bb1544e36de7dd$var$long_1.default.UZERO;
        return message;
    }
};
const $f6bb1544e36de7dd$var$baseDelegationDelegatorReward = {
    validatorAddress: ""
};
$f6bb1544e36de7dd$exports.DelegationDelegatorReward = {
    encode (message, writer = $f6bb1544e36de7dd$var$minimal_1.default.Writer.create()) {
        if (message.validatorAddress !== "") writer.uint32(10).string(message.validatorAddress);
        for (const v of message.reward)$82ef09d1a8e2224d$exports.DecCoin.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f6bb1544e36de7dd$var$minimal_1.default.Reader ? input : new $f6bb1544e36de7dd$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $f6bb1544e36de7dd$var$baseDelegationDelegatorReward);
        message.reward = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                case 2:
                    message.reward.push($82ef09d1a8e2224d$exports.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $f6bb1544e36de7dd$var$baseDelegationDelegatorReward);
        message.validatorAddress = object.validatorAddress !== undefined && object.validatorAddress !== null ? String(object.validatorAddress) : "";
        message.reward = ((_a = object.reward) !== null && _a !== void 0 ? _a : []).map((e)=>$82ef09d1a8e2224d$exports.DecCoin.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        if (message.reward) obj.reward = message.reward.map((e)=>e ? $82ef09d1a8e2224d$exports.DecCoin.toJSON(e) : undefined);
        else obj.reward = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $f6bb1544e36de7dd$var$baseDelegationDelegatorReward);
        message.validatorAddress = (_a = object.validatorAddress) !== null && _a !== void 0 ? _a : "";
        message.reward = ((_b = object.reward) === null || _b === void 0 ? void 0 : _b.map((e)=>$82ef09d1a8e2224d$exports.DecCoin.fromPartial(e))) || [];
        return message;
    }
};
const $f6bb1544e36de7dd$var$baseCommunityPoolSpendProposalWithDeposit = {
    title: "",
    description: "",
    recipient: "",
    amount: "",
    deposit: ""
};
$f6bb1544e36de7dd$exports.CommunityPoolSpendProposalWithDeposit = {
    encode (message, writer = $f6bb1544e36de7dd$var$minimal_1.default.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        if (message.recipient !== "") writer.uint32(26).string(message.recipient);
        if (message.amount !== "") writer.uint32(34).string(message.amount);
        if (message.deposit !== "") writer.uint32(42).string(message.deposit);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f6bb1544e36de7dd$var$minimal_1.default.Reader ? input : new $f6bb1544e36de7dd$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $f6bb1544e36de7dd$var$baseCommunityPoolSpendProposalWithDeposit);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.recipient = reader.string();
                    break;
                case 4:
                    message.amount = reader.string();
                    break;
                case 5:
                    message.deposit = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $f6bb1544e36de7dd$var$baseCommunityPoolSpendProposalWithDeposit);
        message.title = object.title !== undefined && object.title !== null ? String(object.title) : "";
        message.description = object.description !== undefined && object.description !== null ? String(object.description) : "";
        message.recipient = object.recipient !== undefined && object.recipient !== null ? String(object.recipient) : "";
        message.amount = object.amount !== undefined && object.amount !== null ? String(object.amount) : "";
        message.deposit = object.deposit !== undefined && object.deposit !== null ? String(object.deposit) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.recipient !== undefined && (obj.recipient = message.recipient);
        message.amount !== undefined && (obj.amount = message.amount);
        message.deposit !== undefined && (obj.deposit = message.deposit);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e;
        const message = Object.assign({}, $f6bb1544e36de7dd$var$baseCommunityPoolSpendProposalWithDeposit);
        message.title = (_a = object.title) !== null && _a !== void 0 ? _a : "";
        message.description = (_b = object.description) !== null && _b !== void 0 ? _b : "";
        message.recipient = (_c = object.recipient) !== null && _c !== void 0 ? _c : "";
        message.amount = (_d = object.amount) !== null && _d !== void 0 ? _d : "";
        message.deposit = (_e = object.deposit) !== null && _e !== void 0 ? _e : "";
        return message;
    }
};
if ($f6bb1544e36de7dd$var$minimal_1.default.util.Long !== $f6bb1544e36de7dd$var$long_1.default) {
    $f6bb1544e36de7dd$var$minimal_1.default.util.Long = $f6bb1544e36de7dd$var$long_1.default;
    $f6bb1544e36de7dd$var$minimal_1.default.configure();
}




$928198056f96ecb1$exports.protobufPackage = "cosmos.distribution.v1beta1";
const $928198056f96ecb1$var$baseQueryParamsRequest = {};
$928198056f96ecb1$exports.QueryParamsRequest = {
    encode (_, writer = $928198056f96ecb1$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $928198056f96ecb1$var$minimal_1.default.Reader ? input : new $928198056f96ecb1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryParamsRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryParamsRequest);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryParamsRequest);
        return message;
    }
};
const $928198056f96ecb1$var$baseQueryParamsResponse = {};
$928198056f96ecb1$exports.QueryParamsResponse = {
    encode (message, writer = $928198056f96ecb1$var$minimal_1.default.Writer.create()) {
        if (message.params !== undefined) $f6bb1544e36de7dd$exports.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $928198056f96ecb1$var$minimal_1.default.Reader ? input : new $928198056f96ecb1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryParamsResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $f6bb1544e36de7dd$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryParamsResponse);
        message.params = object.params !== undefined && object.params !== null ? $f6bb1544e36de7dd$exports.Params.fromJSON(object.params) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? $f6bb1544e36de7dd$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryParamsResponse);
        message.params = object.params !== undefined && object.params !== null ? $f6bb1544e36de7dd$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
const $928198056f96ecb1$var$baseQueryValidatorOutstandingRewardsRequest = {
    validatorAddress: ""
};
$928198056f96ecb1$exports.QueryValidatorOutstandingRewardsRequest = {
    encode (message, writer = $928198056f96ecb1$var$minimal_1.default.Writer.create()) {
        if (message.validatorAddress !== "") writer.uint32(10).string(message.validatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $928198056f96ecb1$var$minimal_1.default.Reader ? input : new $928198056f96ecb1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryValidatorOutstandingRewardsRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryValidatorOutstandingRewardsRequest);
        message.validatorAddress = object.validatorAddress !== undefined && object.validatorAddress !== null ? String(object.validatorAddress) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryValidatorOutstandingRewardsRequest);
        message.validatorAddress = (_a = object.validatorAddress) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
const $928198056f96ecb1$var$baseQueryValidatorOutstandingRewardsResponse = {};
$928198056f96ecb1$exports.QueryValidatorOutstandingRewardsResponse = {
    encode (message, writer = $928198056f96ecb1$var$minimal_1.default.Writer.create()) {
        if (message.rewards !== undefined) $f6bb1544e36de7dd$exports.ValidatorOutstandingRewards.encode(message.rewards, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $928198056f96ecb1$var$minimal_1.default.Reader ? input : new $928198056f96ecb1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryValidatorOutstandingRewardsResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.rewards = $f6bb1544e36de7dd$exports.ValidatorOutstandingRewards.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryValidatorOutstandingRewardsResponse);
        message.rewards = object.rewards !== undefined && object.rewards !== null ? $f6bb1544e36de7dd$exports.ValidatorOutstandingRewards.fromJSON(object.rewards) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.rewards !== undefined && (obj.rewards = message.rewards ? $f6bb1544e36de7dd$exports.ValidatorOutstandingRewards.toJSON(message.rewards) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryValidatorOutstandingRewardsResponse);
        message.rewards = object.rewards !== undefined && object.rewards !== null ? $f6bb1544e36de7dd$exports.ValidatorOutstandingRewards.fromPartial(object.rewards) : undefined;
        return message;
    }
};
const $928198056f96ecb1$var$baseQueryValidatorCommissionRequest = {
    validatorAddress: ""
};
$928198056f96ecb1$exports.QueryValidatorCommissionRequest = {
    encode (message, writer = $928198056f96ecb1$var$minimal_1.default.Writer.create()) {
        if (message.validatorAddress !== "") writer.uint32(10).string(message.validatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $928198056f96ecb1$var$minimal_1.default.Reader ? input : new $928198056f96ecb1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryValidatorCommissionRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryValidatorCommissionRequest);
        message.validatorAddress = object.validatorAddress !== undefined && object.validatorAddress !== null ? String(object.validatorAddress) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryValidatorCommissionRequest);
        message.validatorAddress = (_a = object.validatorAddress) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
const $928198056f96ecb1$var$baseQueryValidatorCommissionResponse = {};
$928198056f96ecb1$exports.QueryValidatorCommissionResponse = {
    encode (message, writer = $928198056f96ecb1$var$minimal_1.default.Writer.create()) {
        if (message.commission !== undefined) $f6bb1544e36de7dd$exports.ValidatorAccumulatedCommission.encode(message.commission, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $928198056f96ecb1$var$minimal_1.default.Reader ? input : new $928198056f96ecb1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryValidatorCommissionResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.commission = $f6bb1544e36de7dd$exports.ValidatorAccumulatedCommission.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryValidatorCommissionResponse);
        message.commission = object.commission !== undefined && object.commission !== null ? $f6bb1544e36de7dd$exports.ValidatorAccumulatedCommission.fromJSON(object.commission) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.commission !== undefined && (obj.commission = message.commission ? $f6bb1544e36de7dd$exports.ValidatorAccumulatedCommission.toJSON(message.commission) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryValidatorCommissionResponse);
        message.commission = object.commission !== undefined && object.commission !== null ? $f6bb1544e36de7dd$exports.ValidatorAccumulatedCommission.fromPartial(object.commission) : undefined;
        return message;
    }
};
const $928198056f96ecb1$var$baseQueryValidatorSlashesRequest = {
    validatorAddress: "",
    startingHeight: $928198056f96ecb1$var$long_1.default.UZERO,
    endingHeight: $928198056f96ecb1$var$long_1.default.UZERO
};
$928198056f96ecb1$exports.QueryValidatorSlashesRequest = {
    encode (message, writer = $928198056f96ecb1$var$minimal_1.default.Writer.create()) {
        if (message.validatorAddress !== "") writer.uint32(10).string(message.validatorAddress);
        if (!message.startingHeight.isZero()) writer.uint32(16).uint64(message.startingHeight);
        if (!message.endingHeight.isZero()) writer.uint32(24).uint64(message.endingHeight);
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageRequest.encode(message.pagination, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $928198056f96ecb1$var$minimal_1.default.Reader ? input : new $928198056f96ecb1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryValidatorSlashesRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                case 2:
                    message.startingHeight = reader.uint64();
                    break;
                case 3:
                    message.endingHeight = reader.uint64();
                    break;
                case 4:
                    message.pagination = $f01b40e20607eb8e$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryValidatorSlashesRequest);
        message.validatorAddress = object.validatorAddress !== undefined && object.validatorAddress !== null ? String(object.validatorAddress) : "";
        message.startingHeight = object.startingHeight !== undefined && object.startingHeight !== null ? $928198056f96ecb1$var$long_1.default.fromString(object.startingHeight) : $928198056f96ecb1$var$long_1.default.UZERO;
        message.endingHeight = object.endingHeight !== undefined && object.endingHeight !== null ? $928198056f96ecb1$var$long_1.default.fromString(object.endingHeight) : $928198056f96ecb1$var$long_1.default.UZERO;
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromJSON(object.pagination) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.startingHeight !== undefined && (obj.startingHeight = (message.startingHeight || $928198056f96ecb1$var$long_1.default.UZERO).toString());
        message.endingHeight !== undefined && (obj.endingHeight = (message.endingHeight || $928198056f96ecb1$var$long_1.default.UZERO).toString());
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryValidatorSlashesRequest);
        message.validatorAddress = (_a = object.validatorAddress) !== null && _a !== void 0 ? _a : "";
        message.startingHeight = object.startingHeight !== undefined && object.startingHeight !== null ? $928198056f96ecb1$var$long_1.default.fromValue(object.startingHeight) : $928198056f96ecb1$var$long_1.default.UZERO;
        message.endingHeight = object.endingHeight !== undefined && object.endingHeight !== null ? $928198056f96ecb1$var$long_1.default.fromValue(object.endingHeight) : $928198056f96ecb1$var$long_1.default.UZERO;
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
const $928198056f96ecb1$var$baseQueryValidatorSlashesResponse = {};
$928198056f96ecb1$exports.QueryValidatorSlashesResponse = {
    encode (message, writer = $928198056f96ecb1$var$minimal_1.default.Writer.create()) {
        for (const v of message.slashes)$f6bb1544e36de7dd$exports.ValidatorSlashEvent.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $928198056f96ecb1$var$minimal_1.default.Reader ? input : new $928198056f96ecb1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryValidatorSlashesResponse);
        message.slashes = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.slashes.push($f6bb1544e36de7dd$exports.ValidatorSlashEvent.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $f01b40e20607eb8e$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryValidatorSlashesResponse);
        message.slashes = ((_a = object.slashes) !== null && _a !== void 0 ? _a : []).map((e)=>$f6bb1544e36de7dd$exports.ValidatorSlashEvent.fromJSON(e));
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromJSON(object.pagination) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.slashes) obj.slashes = message.slashes.map((e)=>e ? $f6bb1544e36de7dd$exports.ValidatorSlashEvent.toJSON(e) : undefined);
        else obj.slashes = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryValidatorSlashesResponse);
        message.slashes = ((_a = object.slashes) === null || _a === void 0 ? void 0 : _a.map((e)=>$f6bb1544e36de7dd$exports.ValidatorSlashEvent.fromPartial(e))) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
const $928198056f96ecb1$var$baseQueryDelegationRewardsRequest = {
    delegatorAddress: "",
    validatorAddress: ""
};
$928198056f96ecb1$exports.QueryDelegationRewardsRequest = {
    encode (message, writer = $928198056f96ecb1$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $928198056f96ecb1$var$minimal_1.default.Reader ? input : new $928198056f96ecb1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryDelegationRewardsRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryDelegationRewardsRequest);
        message.delegatorAddress = object.delegatorAddress !== undefined && object.delegatorAddress !== null ? String(object.delegatorAddress) : "";
        message.validatorAddress = object.validatorAddress !== undefined && object.validatorAddress !== null ? String(object.validatorAddress) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryDelegationRewardsRequest);
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorAddress = (_b = object.validatorAddress) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
const $928198056f96ecb1$var$baseQueryDelegationRewardsResponse = {};
$928198056f96ecb1$exports.QueryDelegationRewardsResponse = {
    encode (message, writer = $928198056f96ecb1$var$minimal_1.default.Writer.create()) {
        for (const v of message.rewards)$82ef09d1a8e2224d$exports.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $928198056f96ecb1$var$minimal_1.default.Reader ? input : new $928198056f96ecb1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryDelegationRewardsResponse);
        message.rewards = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.rewards.push($82ef09d1a8e2224d$exports.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryDelegationRewardsResponse);
        message.rewards = ((_a = object.rewards) !== null && _a !== void 0 ? _a : []).map((e)=>$82ef09d1a8e2224d$exports.DecCoin.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.rewards) obj.rewards = message.rewards.map((e)=>e ? $82ef09d1a8e2224d$exports.DecCoin.toJSON(e) : undefined);
        else obj.rewards = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryDelegationRewardsResponse);
        message.rewards = ((_a = object.rewards) === null || _a === void 0 ? void 0 : _a.map((e)=>$82ef09d1a8e2224d$exports.DecCoin.fromPartial(e))) || [];
        return message;
    }
};
const $928198056f96ecb1$var$baseQueryDelegationTotalRewardsRequest = {
    delegatorAddress: ""
};
$928198056f96ecb1$exports.QueryDelegationTotalRewardsRequest = {
    encode (message, writer = $928198056f96ecb1$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $928198056f96ecb1$var$minimal_1.default.Reader ? input : new $928198056f96ecb1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryDelegationTotalRewardsRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryDelegationTotalRewardsRequest);
        message.delegatorAddress = object.delegatorAddress !== undefined && object.delegatorAddress !== null ? String(object.delegatorAddress) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryDelegationTotalRewardsRequest);
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
const $928198056f96ecb1$var$baseQueryDelegationTotalRewardsResponse = {};
$928198056f96ecb1$exports.QueryDelegationTotalRewardsResponse = {
    encode (message, writer = $928198056f96ecb1$var$minimal_1.default.Writer.create()) {
        for (const v of message.rewards)$f6bb1544e36de7dd$exports.DelegationDelegatorReward.encode(v, writer.uint32(10).fork()).ldelim();
        for (const v of message.total)$82ef09d1a8e2224d$exports.DecCoin.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $928198056f96ecb1$var$minimal_1.default.Reader ? input : new $928198056f96ecb1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryDelegationTotalRewardsResponse);
        message.rewards = [];
        message.total = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.rewards.push($f6bb1544e36de7dd$exports.DelegationDelegatorReward.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.total.push($82ef09d1a8e2224d$exports.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a, _b;
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryDelegationTotalRewardsResponse);
        message.rewards = ((_a = object.rewards) !== null && _a !== void 0 ? _a : []).map((e)=>$f6bb1544e36de7dd$exports.DelegationDelegatorReward.fromJSON(e));
        message.total = ((_b = object.total) !== null && _b !== void 0 ? _b : []).map((e)=>$82ef09d1a8e2224d$exports.DecCoin.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.rewards) obj.rewards = message.rewards.map((e)=>e ? $f6bb1544e36de7dd$exports.DelegationDelegatorReward.toJSON(e) : undefined);
        else obj.rewards = [];
        if (message.total) obj.total = message.total.map((e)=>e ? $82ef09d1a8e2224d$exports.DecCoin.toJSON(e) : undefined);
        else obj.total = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryDelegationTotalRewardsResponse);
        message.rewards = ((_a = object.rewards) === null || _a === void 0 ? void 0 : _a.map((e)=>$f6bb1544e36de7dd$exports.DelegationDelegatorReward.fromPartial(e))) || [];
        message.total = ((_b = object.total) === null || _b === void 0 ? void 0 : _b.map((e)=>$82ef09d1a8e2224d$exports.DecCoin.fromPartial(e))) || [];
        return message;
    }
};
const $928198056f96ecb1$var$baseQueryDelegatorValidatorsRequest = {
    delegatorAddress: ""
};
$928198056f96ecb1$exports.QueryDelegatorValidatorsRequest = {
    encode (message, writer = $928198056f96ecb1$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $928198056f96ecb1$var$minimal_1.default.Reader ? input : new $928198056f96ecb1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryDelegatorValidatorsRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryDelegatorValidatorsRequest);
        message.delegatorAddress = object.delegatorAddress !== undefined && object.delegatorAddress !== null ? String(object.delegatorAddress) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryDelegatorValidatorsRequest);
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
const $928198056f96ecb1$var$baseQueryDelegatorValidatorsResponse = {
    validators: ""
};
$928198056f96ecb1$exports.QueryDelegatorValidatorsResponse = {
    encode (message, writer = $928198056f96ecb1$var$minimal_1.default.Writer.create()) {
        for (const v of message.validators)writer.uint32(10).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $928198056f96ecb1$var$minimal_1.default.Reader ? input : new $928198056f96ecb1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryDelegatorValidatorsResponse);
        message.validators = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validators.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryDelegatorValidatorsResponse);
        message.validators = ((_a = object.validators) !== null && _a !== void 0 ? _a : []).map((e)=>String(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.validators) obj.validators = message.validators.map((e)=>e);
        else obj.validators = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryDelegatorValidatorsResponse);
        message.validators = ((_a = object.validators) === null || _a === void 0 ? void 0 : _a.map((e)=>e)) || [];
        return message;
    }
};
const $928198056f96ecb1$var$baseQueryDelegatorWithdrawAddressRequest = {
    delegatorAddress: ""
};
$928198056f96ecb1$exports.QueryDelegatorWithdrawAddressRequest = {
    encode (message, writer = $928198056f96ecb1$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $928198056f96ecb1$var$minimal_1.default.Reader ? input : new $928198056f96ecb1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryDelegatorWithdrawAddressRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryDelegatorWithdrawAddressRequest);
        message.delegatorAddress = object.delegatorAddress !== undefined && object.delegatorAddress !== null ? String(object.delegatorAddress) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryDelegatorWithdrawAddressRequest);
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
const $928198056f96ecb1$var$baseQueryDelegatorWithdrawAddressResponse = {
    withdrawAddress: ""
};
$928198056f96ecb1$exports.QueryDelegatorWithdrawAddressResponse = {
    encode (message, writer = $928198056f96ecb1$var$minimal_1.default.Writer.create()) {
        if (message.withdrawAddress !== "") writer.uint32(10).string(message.withdrawAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $928198056f96ecb1$var$minimal_1.default.Reader ? input : new $928198056f96ecb1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryDelegatorWithdrawAddressResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.withdrawAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryDelegatorWithdrawAddressResponse);
        message.withdrawAddress = object.withdrawAddress !== undefined && object.withdrawAddress !== null ? String(object.withdrawAddress) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.withdrawAddress !== undefined && (obj.withdrawAddress = message.withdrawAddress);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryDelegatorWithdrawAddressResponse);
        message.withdrawAddress = (_a = object.withdrawAddress) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
const $928198056f96ecb1$var$baseQueryCommunityPoolRequest = {};
$928198056f96ecb1$exports.QueryCommunityPoolRequest = {
    encode (_, writer = $928198056f96ecb1$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $928198056f96ecb1$var$minimal_1.default.Reader ? input : new $928198056f96ecb1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryCommunityPoolRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryCommunityPoolRequest);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryCommunityPoolRequest);
        return message;
    }
};
const $928198056f96ecb1$var$baseQueryCommunityPoolResponse = {};
$928198056f96ecb1$exports.QueryCommunityPoolResponse = {
    encode (message, writer = $928198056f96ecb1$var$minimal_1.default.Writer.create()) {
        for (const v of message.pool)$82ef09d1a8e2224d$exports.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $928198056f96ecb1$var$minimal_1.default.Reader ? input : new $928198056f96ecb1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryCommunityPoolResponse);
        message.pool = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pool.push($82ef09d1a8e2224d$exports.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryCommunityPoolResponse);
        message.pool = ((_a = object.pool) !== null && _a !== void 0 ? _a : []).map((e)=>$82ef09d1a8e2224d$exports.DecCoin.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.pool) obj.pool = message.pool.map((e)=>e ? $82ef09d1a8e2224d$exports.DecCoin.toJSON(e) : undefined);
        else obj.pool = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $928198056f96ecb1$var$baseQueryCommunityPoolResponse);
        message.pool = ((_a = object.pool) === null || _a === void 0 ? void 0 : _a.map((e)=>$82ef09d1a8e2224d$exports.DecCoin.fromPartial(e))) || [];
        return message;
    }
};
class $928198056f96ecb1$var$QueryClientImpl {
    Params(request) {
        const data = $928198056f96ecb1$exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "Params", data);
        return promise.then((data)=>$928198056f96ecb1$exports.QueryParamsResponse.decode(new $928198056f96ecb1$var$minimal_1.default.Reader(data)));
    }
    ValidatorOutstandingRewards(request) {
        const data = $928198056f96ecb1$exports.QueryValidatorOutstandingRewardsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "ValidatorOutstandingRewards", data);
        return promise.then((data)=>$928198056f96ecb1$exports.QueryValidatorOutstandingRewardsResponse.decode(new $928198056f96ecb1$var$minimal_1.default.Reader(data)));
    }
    ValidatorCommission(request) {
        const data = $928198056f96ecb1$exports.QueryValidatorCommissionRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "ValidatorCommission", data);
        return promise.then((data)=>$928198056f96ecb1$exports.QueryValidatorCommissionResponse.decode(new $928198056f96ecb1$var$minimal_1.default.Reader(data)));
    }
    ValidatorSlashes(request) {
        const data = $928198056f96ecb1$exports.QueryValidatorSlashesRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "ValidatorSlashes", data);
        return promise.then((data)=>$928198056f96ecb1$exports.QueryValidatorSlashesResponse.decode(new $928198056f96ecb1$var$minimal_1.default.Reader(data)));
    }
    DelegationRewards(request) {
        const data = $928198056f96ecb1$exports.QueryDelegationRewardsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "DelegationRewards", data);
        return promise.then((data)=>$928198056f96ecb1$exports.QueryDelegationRewardsResponse.decode(new $928198056f96ecb1$var$minimal_1.default.Reader(data)));
    }
    DelegationTotalRewards(request) {
        const data = $928198056f96ecb1$exports.QueryDelegationTotalRewardsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "DelegationTotalRewards", data);
        return promise.then((data)=>$928198056f96ecb1$exports.QueryDelegationTotalRewardsResponse.decode(new $928198056f96ecb1$var$minimal_1.default.Reader(data)));
    }
    DelegatorValidators(request) {
        const data = $928198056f96ecb1$exports.QueryDelegatorValidatorsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "DelegatorValidators", data);
        return promise.then((data)=>$928198056f96ecb1$exports.QueryDelegatorValidatorsResponse.decode(new $928198056f96ecb1$var$minimal_1.default.Reader(data)));
    }
    DelegatorWithdrawAddress(request) {
        const data = $928198056f96ecb1$exports.QueryDelegatorWithdrawAddressRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "DelegatorWithdrawAddress", data);
        return promise.then((data)=>$928198056f96ecb1$exports.QueryDelegatorWithdrawAddressResponse.decode(new $928198056f96ecb1$var$minimal_1.default.Reader(data)));
    }
    CommunityPool(request) {
        const data = $928198056f96ecb1$exports.QueryCommunityPoolRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "CommunityPool", data);
        return promise.then((data)=>$928198056f96ecb1$exports.QueryCommunityPoolResponse.decode(new $928198056f96ecb1$var$minimal_1.default.Reader(data)));
    }
    constructor(rpc){
        this.rpc = rpc;
        this.Params = this.Params.bind(this);
        this.ValidatorOutstandingRewards = this.ValidatorOutstandingRewards.bind(this);
        this.ValidatorCommission = this.ValidatorCommission.bind(this);
        this.ValidatorSlashes = this.ValidatorSlashes.bind(this);
        this.DelegationRewards = this.DelegationRewards.bind(this);
        this.DelegationTotalRewards = this.DelegationTotalRewards.bind(this);
        this.DelegatorValidators = this.DelegatorValidators.bind(this);
        this.DelegatorWithdrawAddress = this.DelegatorWithdrawAddress.bind(this);
        this.CommunityPool = this.CommunityPool.bind(this);
    }
}
$928198056f96ecb1$exports.QueryClientImpl = $928198056f96ecb1$var$QueryClientImpl;
if ($928198056f96ecb1$var$minimal_1.default.util.Long !== $928198056f96ecb1$var$long_1.default) {
    $928198056f96ecb1$var$minimal_1.default.util.Long = $928198056f96ecb1$var$long_1.default;
    $928198056f96ecb1$var$minimal_1.default.configure();
}



const $aa3d1de913220979$var$long_1 = $aa3d1de913220979$var$__importDefault((parcelRequire("9A55m")));

function $aa3d1de913220979$var$setupDistributionExtension(base) {
    const rpc = (0, $ffdede50deec576f$exports.createProtobufRpcClient)(base);
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const queryService = new $928198056f96ecb1$exports.QueryClientImpl(rpc);
    return {
        distribution: {
            communityPool: async ()=>{
                const response = await queryService.CommunityPool({});
                return response;
            },
            delegationRewards: async (delegatorAddress, validatorAddress)=>{
                const response = await queryService.DelegationRewards({
                    delegatorAddress: delegatorAddress,
                    validatorAddress: validatorAddress
                });
                return response;
            },
            delegationTotalRewards: async (delegatorAddress)=>{
                const response = await queryService.DelegationTotalRewards({
                    delegatorAddress: delegatorAddress
                });
                return response;
            },
            delegatorValidators: async (delegatorAddress)=>{
                const response = await queryService.DelegatorValidators({
                    delegatorAddress: delegatorAddress
                });
                return response;
            },
            delegatorWithdrawAddress: async (delegatorAddress)=>{
                const response = await queryService.DelegatorWithdrawAddress({
                    delegatorAddress: delegatorAddress
                });
                return response;
            },
            params: async ()=>{
                const response = await queryService.Params({});
                return response;
            },
            validatorCommission: async (validatorAddress)=>{
                const response = await queryService.ValidatorCommission({
                    validatorAddress: validatorAddress
                });
                return response;
            },
            validatorOutstandingRewards: async (validatorAddress)=>{
                const response = await queryService.ValidatorOutstandingRewards({
                    validatorAddress: validatorAddress
                });
                return response;
            },
            validatorSlashes: async (validatorAddress, startingHeight, endingHeight, paginationKey)=>{
                const response = await queryService.ValidatorSlashes({
                    validatorAddress: validatorAddress,
                    startingHeight: $aa3d1de913220979$var$long_1.default.fromNumber(startingHeight, true),
                    endingHeight: $aa3d1de913220979$var$long_1.default.fromNumber(endingHeight, true),
                    pagination: (0, $ffdede50deec576f$exports.createPagination)(paginationKey)
                });
                return response;
            }
        }
    };
}
$aa3d1de913220979$exports.setupDistributionExtension = $aa3d1de913220979$var$setupDistributionExtension;


Object.defineProperty($7725f2e3ca016b52$exports, "setupDistributionExtension", {
    enumerable: true,
    get: function() {
        return $aa3d1de913220979$exports.setupDistributionExtension;
    }
});
var $6d1722201a0017df$exports = {};
"use strict";
Object.defineProperty($6d1722201a0017df$exports, "__esModule", {
    value: true
});
$6d1722201a0017df$exports.createEvidenceAminoConverters = $6d1722201a0017df$exports.isAminoMsgSubmitEvidence = void 0;
function $6d1722201a0017df$var$isAminoMsgSubmitEvidence(msg) {
    return msg.type === "cosmos-sdk/MsgSubmitEvidence";
}
$6d1722201a0017df$exports.isAminoMsgSubmitEvidence = $6d1722201a0017df$var$isAminoMsgSubmitEvidence;
function $6d1722201a0017df$var$createEvidenceAminoConverters() {
    throw new Error("Not implemented");
}
$6d1722201a0017df$exports.createEvidenceAminoConverters = $6d1722201a0017df$var$createEvidenceAminoConverters;


Object.defineProperty($7725f2e3ca016b52$exports, "createEvidenceAminoConverters", {
    enumerable: true,
    get: function() {
        return $6d1722201a0017df$exports.createEvidenceAminoConverters;
    }
});
Object.defineProperty($7725f2e3ca016b52$exports, "isAminoMsgSubmitEvidence", {
    enumerable: true,
    get: function() {
        return $6d1722201a0017df$exports.isAminoMsgSubmitEvidence;
    }
});
var $84ccad88b9829d36$exports = {};
"use strict";
Object.defineProperty($84ccad88b9829d36$exports, "__esModule", {
    value: true
});
$84ccad88b9829d36$exports.createFreegrantAminoConverters = void 0;
function $84ccad88b9829d36$var$createFreegrantAminoConverters() {
    return {
        "/cosmos.feegrant.v1beta1.MsgGrantAllowance": "not_supported_by_chain",
        "/cosmos.feegrant.v1beta1.MsgRevokeAllowance": "not_supported_by_chain"
    };
}
$84ccad88b9829d36$exports.createFreegrantAminoConverters = $84ccad88b9829d36$var$createFreegrantAminoConverters;


Object.defineProperty($7725f2e3ca016b52$exports, "createFreegrantAminoConverters", {
    enumerable: true,
    get: function() {
        return $84ccad88b9829d36$exports.createFreegrantAminoConverters;
    }
});
var $000b3d4fdd0a28a2$exports = {};
"use strict";
Object.defineProperty($000b3d4fdd0a28a2$exports, "__esModule", {
    value: true
});
$000b3d4fdd0a28a2$exports.feegrantTypes = void 0;
var $a812e8d41f716113$exports = {};
"use strict";
var $a812e8d41f716113$var$__importDefault = $a812e8d41f716113$exports && $a812e8d41f716113$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($a812e8d41f716113$exports, "__esModule", {
    value: true
});
$a812e8d41f716113$exports.MsgClientImpl = $a812e8d41f716113$exports.MsgRevokeAllowanceResponse = $a812e8d41f716113$exports.MsgRevokeAllowance = $a812e8d41f716113$exports.MsgGrantAllowanceResponse = $a812e8d41f716113$exports.MsgGrantAllowance = $a812e8d41f716113$exports.protobufPackage = void 0;

/* eslint-disable */ const $a812e8d41f716113$var$long_1 = $a812e8d41f716113$var$__importDefault((parcelRequire("9A55m")));

const $a812e8d41f716113$var$minimal_1 = $a812e8d41f716113$var$__importDefault((parcelRequire("i2pIU")));

$a812e8d41f716113$exports.protobufPackage = "cosmos.feegrant.v1beta1";
const $a812e8d41f716113$var$baseMsgGrantAllowance = {
    granter: "",
    grantee: ""
};
$a812e8d41f716113$exports.MsgGrantAllowance = {
    encode (message, writer = $a812e8d41f716113$var$minimal_1.default.Writer.create()) {
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        if (message.allowance !== undefined) $4232fce010c3a46b$exports.Any.encode(message.allowance, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a812e8d41f716113$var$minimal_1.default.Reader ? input : new $a812e8d41f716113$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $a812e8d41f716113$var$baseMsgGrantAllowance);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.allowance = $4232fce010c3a46b$exports.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $a812e8d41f716113$var$baseMsgGrantAllowance);
        message.granter = object.granter !== undefined && object.granter !== null ? String(object.granter) : "";
        message.grantee = object.grantee !== undefined && object.grantee !== null ? String(object.grantee) : "";
        message.allowance = object.allowance !== undefined && object.allowance !== null ? $4232fce010c3a46b$exports.Any.fromJSON(object.allowance) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.allowance !== undefined && (obj.allowance = message.allowance ? $4232fce010c3a46b$exports.Any.toJSON(message.allowance) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $a812e8d41f716113$var$baseMsgGrantAllowance);
        message.granter = (_a = object.granter) !== null && _a !== void 0 ? _a : "";
        message.grantee = (_b = object.grantee) !== null && _b !== void 0 ? _b : "";
        message.allowance = object.allowance !== undefined && object.allowance !== null ? $4232fce010c3a46b$exports.Any.fromPartial(object.allowance) : undefined;
        return message;
    }
};
const $a812e8d41f716113$var$baseMsgGrantAllowanceResponse = {};
$a812e8d41f716113$exports.MsgGrantAllowanceResponse = {
    encode (_, writer = $a812e8d41f716113$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a812e8d41f716113$var$minimal_1.default.Reader ? input : new $a812e8d41f716113$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $a812e8d41f716113$var$baseMsgGrantAllowanceResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $a812e8d41f716113$var$baseMsgGrantAllowanceResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $a812e8d41f716113$var$baseMsgGrantAllowanceResponse);
        return message;
    }
};
const $a812e8d41f716113$var$baseMsgRevokeAllowance = {
    granter: "",
    grantee: ""
};
$a812e8d41f716113$exports.MsgRevokeAllowance = {
    encode (message, writer = $a812e8d41f716113$var$minimal_1.default.Writer.create()) {
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a812e8d41f716113$var$minimal_1.default.Reader ? input : new $a812e8d41f716113$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $a812e8d41f716113$var$baseMsgRevokeAllowance);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $a812e8d41f716113$var$baseMsgRevokeAllowance);
        message.granter = object.granter !== undefined && object.granter !== null ? String(object.granter) : "";
        message.grantee = object.grantee !== undefined && object.grantee !== null ? String(object.grantee) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $a812e8d41f716113$var$baseMsgRevokeAllowance);
        message.granter = (_a = object.granter) !== null && _a !== void 0 ? _a : "";
        message.grantee = (_b = object.grantee) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
const $a812e8d41f716113$var$baseMsgRevokeAllowanceResponse = {};
$a812e8d41f716113$exports.MsgRevokeAllowanceResponse = {
    encode (_, writer = $a812e8d41f716113$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a812e8d41f716113$var$minimal_1.default.Reader ? input : new $a812e8d41f716113$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $a812e8d41f716113$var$baseMsgRevokeAllowanceResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $a812e8d41f716113$var$baseMsgRevokeAllowanceResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $a812e8d41f716113$var$baseMsgRevokeAllowanceResponse);
        return message;
    }
};
class $a812e8d41f716113$var$MsgClientImpl {
    GrantAllowance(request) {
        const data = $a812e8d41f716113$exports.MsgGrantAllowance.encode(request).finish();
        const promise = this.rpc.request("cosmos.feegrant.v1beta1.Msg", "GrantAllowance", data);
        return promise.then((data)=>$a812e8d41f716113$exports.MsgGrantAllowanceResponse.decode(new $a812e8d41f716113$var$minimal_1.default.Reader(data)));
    }
    RevokeAllowance(request) {
        const data = $a812e8d41f716113$exports.MsgRevokeAllowance.encode(request).finish();
        const promise = this.rpc.request("cosmos.feegrant.v1beta1.Msg", "RevokeAllowance", data);
        return promise.then((data)=>$a812e8d41f716113$exports.MsgRevokeAllowanceResponse.decode(new $a812e8d41f716113$var$minimal_1.default.Reader(data)));
    }
    constructor(rpc){
        this.rpc = rpc;
        this.GrantAllowance = this.GrantAllowance.bind(this);
        this.RevokeAllowance = this.RevokeAllowance.bind(this);
    }
}
$a812e8d41f716113$exports.MsgClientImpl = $a812e8d41f716113$var$MsgClientImpl;
if ($a812e8d41f716113$var$minimal_1.default.util.Long !== $a812e8d41f716113$var$long_1.default) {
    $a812e8d41f716113$var$minimal_1.default.util.Long = $a812e8d41f716113$var$long_1.default;
    $a812e8d41f716113$var$minimal_1.default.configure();
}


$000b3d4fdd0a28a2$exports.feegrantTypes = [
    [
        "/cosmos.feegrant.v1beta1.MsgGrantAllowance",
        $a812e8d41f716113$exports.MsgGrantAllowance
    ],
    [
        "/cosmos.feegrant.v1beta1.MsgRevokeAllowance",
        $a812e8d41f716113$exports.MsgRevokeAllowance
    ]
];


Object.defineProperty($7725f2e3ca016b52$exports, "feegrantTypes", {
    enumerable: true,
    get: function() {
        return $000b3d4fdd0a28a2$exports.feegrantTypes;
    }
});
var $ac4fd039c3ed988e$exports = {};
"use strict";
var $ac4fd039c3ed988e$var$__importDefault = $ac4fd039c3ed988e$exports && $ac4fd039c3ed988e$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($ac4fd039c3ed988e$exports, "__esModule", {
    value: true
});
$ac4fd039c3ed988e$exports.createGovAminoConverters = $ac4fd039c3ed988e$exports.isAminoMsgDeposit = $ac4fd039c3ed988e$exports.isAminoMsgVote = $ac4fd039c3ed988e$exports.isAminoMsgSubmitProposal = void 0;

var $F6P8J = parcelRequire("F6P8J");
var $7595a8a64e79a70f$exports = {};
"use strict";
var $7595a8a64e79a70f$var$__importDefault = $7595a8a64e79a70f$exports && $7595a8a64e79a70f$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($7595a8a64e79a70f$exports, "__esModule", {
    value: true
});
$7595a8a64e79a70f$exports.TallyParams = $7595a8a64e79a70f$exports.VotingParams = $7595a8a64e79a70f$exports.DepositParams = $7595a8a64e79a70f$exports.Vote = $7595a8a64e79a70f$exports.TallyResult = $7595a8a64e79a70f$exports.Proposal = $7595a8a64e79a70f$exports.Deposit = $7595a8a64e79a70f$exports.TextProposal = $7595a8a64e79a70f$exports.WeightedVoteOption = $7595a8a64e79a70f$exports.proposalStatusToJSON = $7595a8a64e79a70f$exports.proposalStatusFromJSON = $7595a8a64e79a70f$exports.ProposalStatus = $7595a8a64e79a70f$exports.voteOptionToJSON = $7595a8a64e79a70f$exports.voteOptionFromJSON = $7595a8a64e79a70f$exports.VoteOption = $7595a8a64e79a70f$exports.protobufPackage = void 0;

/* eslint-disable */ const $7595a8a64e79a70f$var$long_1 = $7595a8a64e79a70f$var$__importDefault((parcelRequire("9A55m")));

const $7595a8a64e79a70f$var$minimal_1 = $7595a8a64e79a70f$var$__importDefault((parcelRequire("i2pIU")));


var $ad1f748ecd469446$exports = {};
"use strict";
var $ad1f748ecd469446$var$__importDefault = $ad1f748ecd469446$exports && $ad1f748ecd469446$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($ad1f748ecd469446$exports, "__esModule", {
    value: true
});
$ad1f748ecd469446$exports.Duration = $ad1f748ecd469446$exports.protobufPackage = void 0;

/* eslint-disable */ const $ad1f748ecd469446$var$long_1 = $ad1f748ecd469446$var$__importDefault((parcelRequire("9A55m")));

const $ad1f748ecd469446$var$minimal_1 = $ad1f748ecd469446$var$__importDefault((parcelRequire("i2pIU")));
$ad1f748ecd469446$exports.protobufPackage = "google.protobuf";
const $ad1f748ecd469446$var$baseDuration = {
    seconds: $ad1f748ecd469446$var$long_1.default.ZERO,
    nanos: 0
};
$ad1f748ecd469446$exports.Duration = {
    encode (message, writer = $ad1f748ecd469446$var$minimal_1.default.Writer.create()) {
        if (!message.seconds.isZero()) writer.uint32(8).int64(message.seconds);
        if (message.nanos !== 0) writer.uint32(16).int32(message.nanos);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ad1f748ecd469446$var$minimal_1.default.Reader ? input : new $ad1f748ecd469446$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ad1f748ecd469446$var$baseDuration);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.seconds = reader.int64();
                    break;
                case 2:
                    message.nanos = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ad1f748ecd469446$var$baseDuration);
        message.seconds = object.seconds !== undefined && object.seconds !== null ? $ad1f748ecd469446$var$long_1.default.fromString(object.seconds) : $ad1f748ecd469446$var$long_1.default.ZERO;
        message.nanos = object.nanos !== undefined && object.nanos !== null ? Number(object.nanos) : 0;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.seconds !== undefined && (obj.seconds = (message.seconds || $ad1f748ecd469446$var$long_1.default.ZERO).toString());
        message.nanos !== undefined && (obj.nanos = message.nanos);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $ad1f748ecd469446$var$baseDuration);
        message.seconds = object.seconds !== undefined && object.seconds !== null ? $ad1f748ecd469446$var$long_1.default.fromValue(object.seconds) : $ad1f748ecd469446$var$long_1.default.ZERO;
        message.nanos = (_a = object.nanos) !== null && _a !== void 0 ? _a : 0;
        return message;
    }
};
if ($ad1f748ecd469446$var$minimal_1.default.util.Long !== $ad1f748ecd469446$var$long_1.default) {
    $ad1f748ecd469446$var$minimal_1.default.util.Long = $ad1f748ecd469446$var$long_1.default;
    $ad1f748ecd469446$var$minimal_1.default.configure();
}



$7595a8a64e79a70f$exports.protobufPackage = "cosmos.gov.v1beta1";
/** VoteOption enumerates the valid vote options for a given governance proposal. */ var $7595a8a64e79a70f$var$VoteOption;
(function(VoteOption) {
    /** VOTE_OPTION_UNSPECIFIED - VOTE_OPTION_UNSPECIFIED defines a no-op vote option. */ VoteOption[VoteOption["VOTE_OPTION_UNSPECIFIED"] = 0] = "VOTE_OPTION_UNSPECIFIED";
    /** VOTE_OPTION_YES - VOTE_OPTION_YES defines a yes vote option. */ VoteOption[VoteOption["VOTE_OPTION_YES"] = 1] = "VOTE_OPTION_YES";
    /** VOTE_OPTION_ABSTAIN - VOTE_OPTION_ABSTAIN defines an abstain vote option. */ VoteOption[VoteOption["VOTE_OPTION_ABSTAIN"] = 2] = "VOTE_OPTION_ABSTAIN";
    /** VOTE_OPTION_NO - VOTE_OPTION_NO defines a no vote option. */ VoteOption[VoteOption["VOTE_OPTION_NO"] = 3] = "VOTE_OPTION_NO";
    /** VOTE_OPTION_NO_WITH_VETO - VOTE_OPTION_NO_WITH_VETO defines a no with veto vote option. */ VoteOption[VoteOption["VOTE_OPTION_NO_WITH_VETO"] = 4] = "VOTE_OPTION_NO_WITH_VETO";
    VoteOption[VoteOption["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($7595a8a64e79a70f$var$VoteOption = $7595a8a64e79a70f$exports.VoteOption || ($7595a8a64e79a70f$exports.VoteOption = {}));
function $7595a8a64e79a70f$var$voteOptionFromJSON(object) {
    switch(object){
        case 0:
        case "VOTE_OPTION_UNSPECIFIED":
            return $7595a8a64e79a70f$var$VoteOption.VOTE_OPTION_UNSPECIFIED;
        case 1:
        case "VOTE_OPTION_YES":
            return $7595a8a64e79a70f$var$VoteOption.VOTE_OPTION_YES;
        case 2:
        case "VOTE_OPTION_ABSTAIN":
            return $7595a8a64e79a70f$var$VoteOption.VOTE_OPTION_ABSTAIN;
        case 3:
        case "VOTE_OPTION_NO":
            return $7595a8a64e79a70f$var$VoteOption.VOTE_OPTION_NO;
        case 4:
        case "VOTE_OPTION_NO_WITH_VETO":
            return $7595a8a64e79a70f$var$VoteOption.VOTE_OPTION_NO_WITH_VETO;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $7595a8a64e79a70f$var$VoteOption.UNRECOGNIZED;
    }
}
$7595a8a64e79a70f$exports.voteOptionFromJSON = $7595a8a64e79a70f$var$voteOptionFromJSON;
function $7595a8a64e79a70f$var$voteOptionToJSON(object) {
    switch(object){
        case $7595a8a64e79a70f$var$VoteOption.VOTE_OPTION_UNSPECIFIED:
            return "VOTE_OPTION_UNSPECIFIED";
        case $7595a8a64e79a70f$var$VoteOption.VOTE_OPTION_YES:
            return "VOTE_OPTION_YES";
        case $7595a8a64e79a70f$var$VoteOption.VOTE_OPTION_ABSTAIN:
            return "VOTE_OPTION_ABSTAIN";
        case $7595a8a64e79a70f$var$VoteOption.VOTE_OPTION_NO:
            return "VOTE_OPTION_NO";
        case $7595a8a64e79a70f$var$VoteOption.VOTE_OPTION_NO_WITH_VETO:
            return "VOTE_OPTION_NO_WITH_VETO";
        default:
            return "UNKNOWN";
    }
}
$7595a8a64e79a70f$exports.voteOptionToJSON = $7595a8a64e79a70f$var$voteOptionToJSON;
/** ProposalStatus enumerates the valid statuses of a proposal. */ var $7595a8a64e79a70f$var$ProposalStatus;
(function(ProposalStatus) {
    /** PROPOSAL_STATUS_UNSPECIFIED - PROPOSAL_STATUS_UNSPECIFIED defines the default propopsal status. */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_UNSPECIFIED"] = 0] = "PROPOSAL_STATUS_UNSPECIFIED";
    /**
     * PROPOSAL_STATUS_DEPOSIT_PERIOD - PROPOSAL_STATUS_DEPOSIT_PERIOD defines a proposal status during the deposit
     * period.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_DEPOSIT_PERIOD"] = 1] = "PROPOSAL_STATUS_DEPOSIT_PERIOD";
    /**
     * PROPOSAL_STATUS_VOTING_PERIOD - PROPOSAL_STATUS_VOTING_PERIOD defines a proposal status during the voting
     * period.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_VOTING_PERIOD"] = 2] = "PROPOSAL_STATUS_VOTING_PERIOD";
    /**
     * PROPOSAL_STATUS_PASSED - PROPOSAL_STATUS_PASSED defines a proposal status of a proposal that has
     * passed.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_PASSED"] = 3] = "PROPOSAL_STATUS_PASSED";
    /**
     * PROPOSAL_STATUS_REJECTED - PROPOSAL_STATUS_REJECTED defines a proposal status of a proposal that has
     * been rejected.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_REJECTED"] = 4] = "PROPOSAL_STATUS_REJECTED";
    /**
     * PROPOSAL_STATUS_FAILED - PROPOSAL_STATUS_FAILED defines a proposal status of a proposal that has
     * failed.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_FAILED"] = 5] = "PROPOSAL_STATUS_FAILED";
    ProposalStatus[ProposalStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($7595a8a64e79a70f$var$ProposalStatus = $7595a8a64e79a70f$exports.ProposalStatus || ($7595a8a64e79a70f$exports.ProposalStatus = {}));
function $7595a8a64e79a70f$var$proposalStatusFromJSON(object) {
    switch(object){
        case 0:
        case "PROPOSAL_STATUS_UNSPECIFIED":
            return $7595a8a64e79a70f$var$ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED;
        case 1:
        case "PROPOSAL_STATUS_DEPOSIT_PERIOD":
            return $7595a8a64e79a70f$var$ProposalStatus.PROPOSAL_STATUS_DEPOSIT_PERIOD;
        case 2:
        case "PROPOSAL_STATUS_VOTING_PERIOD":
            return $7595a8a64e79a70f$var$ProposalStatus.PROPOSAL_STATUS_VOTING_PERIOD;
        case 3:
        case "PROPOSAL_STATUS_PASSED":
            return $7595a8a64e79a70f$var$ProposalStatus.PROPOSAL_STATUS_PASSED;
        case 4:
        case "PROPOSAL_STATUS_REJECTED":
            return $7595a8a64e79a70f$var$ProposalStatus.PROPOSAL_STATUS_REJECTED;
        case 5:
        case "PROPOSAL_STATUS_FAILED":
            return $7595a8a64e79a70f$var$ProposalStatus.PROPOSAL_STATUS_FAILED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $7595a8a64e79a70f$var$ProposalStatus.UNRECOGNIZED;
    }
}
$7595a8a64e79a70f$exports.proposalStatusFromJSON = $7595a8a64e79a70f$var$proposalStatusFromJSON;
function $7595a8a64e79a70f$var$proposalStatusToJSON(object) {
    switch(object){
        case $7595a8a64e79a70f$var$ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED:
            return "PROPOSAL_STATUS_UNSPECIFIED";
        case $7595a8a64e79a70f$var$ProposalStatus.PROPOSAL_STATUS_DEPOSIT_PERIOD:
            return "PROPOSAL_STATUS_DEPOSIT_PERIOD";
        case $7595a8a64e79a70f$var$ProposalStatus.PROPOSAL_STATUS_VOTING_PERIOD:
            return "PROPOSAL_STATUS_VOTING_PERIOD";
        case $7595a8a64e79a70f$var$ProposalStatus.PROPOSAL_STATUS_PASSED:
            return "PROPOSAL_STATUS_PASSED";
        case $7595a8a64e79a70f$var$ProposalStatus.PROPOSAL_STATUS_REJECTED:
            return "PROPOSAL_STATUS_REJECTED";
        case $7595a8a64e79a70f$var$ProposalStatus.PROPOSAL_STATUS_FAILED:
            return "PROPOSAL_STATUS_FAILED";
        default:
            return "UNKNOWN";
    }
}
$7595a8a64e79a70f$exports.proposalStatusToJSON = $7595a8a64e79a70f$var$proposalStatusToJSON;
const $7595a8a64e79a70f$var$baseWeightedVoteOption = {
    option: 0,
    weight: ""
};
$7595a8a64e79a70f$exports.WeightedVoteOption = {
    encode (message, writer = $7595a8a64e79a70f$var$minimal_1.default.Writer.create()) {
        if (message.option !== 0) writer.uint32(8).int32(message.option);
        if (message.weight !== "") writer.uint32(18).string(message.weight);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7595a8a64e79a70f$var$minimal_1.default.Reader ? input : new $7595a8a64e79a70f$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $7595a8a64e79a70f$var$baseWeightedVoteOption);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.option = reader.int32();
                    break;
                case 2:
                    message.weight = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $7595a8a64e79a70f$var$baseWeightedVoteOption);
        message.option = object.option !== undefined && object.option !== null ? $7595a8a64e79a70f$var$voteOptionFromJSON(object.option) : 0;
        message.weight = object.weight !== undefined && object.weight !== null ? String(object.weight) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.option !== undefined && (obj.option = $7595a8a64e79a70f$var$voteOptionToJSON(message.option));
        message.weight !== undefined && (obj.weight = message.weight);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $7595a8a64e79a70f$var$baseWeightedVoteOption);
        message.option = (_a = object.option) !== null && _a !== void 0 ? _a : 0;
        message.weight = (_b = object.weight) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
const $7595a8a64e79a70f$var$baseTextProposal = {
    title: "",
    description: ""
};
$7595a8a64e79a70f$exports.TextProposal = {
    encode (message, writer = $7595a8a64e79a70f$var$minimal_1.default.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7595a8a64e79a70f$var$minimal_1.default.Reader ? input : new $7595a8a64e79a70f$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $7595a8a64e79a70f$var$baseTextProposal);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $7595a8a64e79a70f$var$baseTextProposal);
        message.title = object.title !== undefined && object.title !== null ? String(object.title) : "";
        message.description = object.description !== undefined && object.description !== null ? String(object.description) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $7595a8a64e79a70f$var$baseTextProposal);
        message.title = (_a = object.title) !== null && _a !== void 0 ? _a : "";
        message.description = (_b = object.description) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
const $7595a8a64e79a70f$var$baseDeposit = {
    proposalId: $7595a8a64e79a70f$var$long_1.default.UZERO,
    depositor: ""
};
$7595a8a64e79a70f$exports.Deposit = {
    encode (message, writer = $7595a8a64e79a70f$var$minimal_1.default.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.depositor !== "") writer.uint32(18).string(message.depositor);
        for (const v of message.amount)$82ef09d1a8e2224d$exports.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7595a8a64e79a70f$var$minimal_1.default.Reader ? input : new $7595a8a64e79a70f$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $7595a8a64e79a70f$var$baseDeposit);
        message.amount = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                case 3:
                    message.amount.push($82ef09d1a8e2224d$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $7595a8a64e79a70f$var$baseDeposit);
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $7595a8a64e79a70f$var$long_1.default.fromString(object.proposalId) : $7595a8a64e79a70f$var$long_1.default.UZERO;
        message.depositor = object.depositor !== undefined && object.depositor !== null ? String(object.depositor) : "";
        message.amount = ((_a = object.amount) !== null && _a !== void 0 ? _a : []).map((e)=>$82ef09d1a8e2224d$exports.Coin.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $7595a8a64e79a70f$var$long_1.default.UZERO).toString());
        message.depositor !== undefined && (obj.depositor = message.depositor);
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $82ef09d1a8e2224d$exports.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $7595a8a64e79a70f$var$baseDeposit);
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $7595a8a64e79a70f$var$long_1.default.fromValue(object.proposalId) : $7595a8a64e79a70f$var$long_1.default.UZERO;
        message.depositor = (_a = object.depositor) !== null && _a !== void 0 ? _a : "";
        message.amount = ((_b = object.amount) === null || _b === void 0 ? void 0 : _b.map((e)=>$82ef09d1a8e2224d$exports.Coin.fromPartial(e))) || [];
        return message;
    }
};
const $7595a8a64e79a70f$var$baseProposal = {
    proposalId: $7595a8a64e79a70f$var$long_1.default.UZERO,
    status: 0
};
$7595a8a64e79a70f$exports.Proposal = {
    encode (message, writer = $7595a8a64e79a70f$var$minimal_1.default.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.content !== undefined) $4232fce010c3a46b$exports.Any.encode(message.content, writer.uint32(18).fork()).ldelim();
        if (message.status !== 0) writer.uint32(24).int32(message.status);
        if (message.finalTallyResult !== undefined) $7595a8a64e79a70f$exports.TallyResult.encode(message.finalTallyResult, writer.uint32(34).fork()).ldelim();
        if (message.submitTime !== undefined) $d6c3291d6aa8eb5b$exports.Timestamp.encode(message.submitTime, writer.uint32(42).fork()).ldelim();
        if (message.depositEndTime !== undefined) $d6c3291d6aa8eb5b$exports.Timestamp.encode(message.depositEndTime, writer.uint32(50).fork()).ldelim();
        for (const v of message.totalDeposit)$82ef09d1a8e2224d$exports.Coin.encode(v, writer.uint32(58).fork()).ldelim();
        if (message.votingStartTime !== undefined) $d6c3291d6aa8eb5b$exports.Timestamp.encode(message.votingStartTime, writer.uint32(66).fork()).ldelim();
        if (message.votingEndTime !== undefined) $d6c3291d6aa8eb5b$exports.Timestamp.encode(message.votingEndTime, writer.uint32(74).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7595a8a64e79a70f$var$minimal_1.default.Reader ? input : new $7595a8a64e79a70f$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $7595a8a64e79a70f$var$baseProposal);
        message.totalDeposit = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.content = $4232fce010c3a46b$exports.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.status = reader.int32();
                    break;
                case 4:
                    message.finalTallyResult = $7595a8a64e79a70f$exports.TallyResult.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.submitTime = $d6c3291d6aa8eb5b$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.depositEndTime = $d6c3291d6aa8eb5b$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.totalDeposit.push($82ef09d1a8e2224d$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.votingStartTime = $d6c3291d6aa8eb5b$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.votingEndTime = $d6c3291d6aa8eb5b$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $7595a8a64e79a70f$var$baseProposal);
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $7595a8a64e79a70f$var$long_1.default.fromString(object.proposalId) : $7595a8a64e79a70f$var$long_1.default.UZERO;
        message.content = object.content !== undefined && object.content !== null ? $4232fce010c3a46b$exports.Any.fromJSON(object.content) : undefined;
        message.status = object.status !== undefined && object.status !== null ? $7595a8a64e79a70f$var$proposalStatusFromJSON(object.status) : 0;
        message.finalTallyResult = object.finalTallyResult !== undefined && object.finalTallyResult !== null ? $7595a8a64e79a70f$exports.TallyResult.fromJSON(object.finalTallyResult) : undefined;
        message.submitTime = object.submitTime !== undefined && object.submitTime !== null ? $7595a8a64e79a70f$var$fromJsonTimestamp(object.submitTime) : undefined;
        message.depositEndTime = object.depositEndTime !== undefined && object.depositEndTime !== null ? $7595a8a64e79a70f$var$fromJsonTimestamp(object.depositEndTime) : undefined;
        message.totalDeposit = ((_a = object.totalDeposit) !== null && _a !== void 0 ? _a : []).map((e)=>$82ef09d1a8e2224d$exports.Coin.fromJSON(e));
        message.votingStartTime = object.votingStartTime !== undefined && object.votingStartTime !== null ? $7595a8a64e79a70f$var$fromJsonTimestamp(object.votingStartTime) : undefined;
        message.votingEndTime = object.votingEndTime !== undefined && object.votingEndTime !== null ? $7595a8a64e79a70f$var$fromJsonTimestamp(object.votingEndTime) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $7595a8a64e79a70f$var$long_1.default.UZERO).toString());
        message.content !== undefined && (obj.content = message.content ? $4232fce010c3a46b$exports.Any.toJSON(message.content) : undefined);
        message.status !== undefined && (obj.status = $7595a8a64e79a70f$var$proposalStatusToJSON(message.status));
        message.finalTallyResult !== undefined && (obj.finalTallyResult = message.finalTallyResult ? $7595a8a64e79a70f$exports.TallyResult.toJSON(message.finalTallyResult) : undefined);
        message.submitTime !== undefined && (obj.submitTime = $7595a8a64e79a70f$var$fromTimestamp(message.submitTime).toISOString());
        message.depositEndTime !== undefined && (obj.depositEndTime = $7595a8a64e79a70f$var$fromTimestamp(message.depositEndTime).toISOString());
        if (message.totalDeposit) obj.totalDeposit = message.totalDeposit.map((e)=>e ? $82ef09d1a8e2224d$exports.Coin.toJSON(e) : undefined);
        else obj.totalDeposit = [];
        message.votingStartTime !== undefined && (obj.votingStartTime = $7595a8a64e79a70f$var$fromTimestamp(message.votingStartTime).toISOString());
        message.votingEndTime !== undefined && (obj.votingEndTime = $7595a8a64e79a70f$var$fromTimestamp(message.votingEndTime).toISOString());
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $7595a8a64e79a70f$var$baseProposal);
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $7595a8a64e79a70f$var$long_1.default.fromValue(object.proposalId) : $7595a8a64e79a70f$var$long_1.default.UZERO;
        message.content = object.content !== undefined && object.content !== null ? $4232fce010c3a46b$exports.Any.fromPartial(object.content) : undefined;
        message.status = (_a = object.status) !== null && _a !== void 0 ? _a : 0;
        message.finalTallyResult = object.finalTallyResult !== undefined && object.finalTallyResult !== null ? $7595a8a64e79a70f$exports.TallyResult.fromPartial(object.finalTallyResult) : undefined;
        message.submitTime = object.submitTime !== undefined && object.submitTime !== null ? $d6c3291d6aa8eb5b$exports.Timestamp.fromPartial(object.submitTime) : undefined;
        message.depositEndTime = object.depositEndTime !== undefined && object.depositEndTime !== null ? $d6c3291d6aa8eb5b$exports.Timestamp.fromPartial(object.depositEndTime) : undefined;
        message.totalDeposit = ((_b = object.totalDeposit) === null || _b === void 0 ? void 0 : _b.map((e)=>$82ef09d1a8e2224d$exports.Coin.fromPartial(e))) || [];
        message.votingStartTime = object.votingStartTime !== undefined && object.votingStartTime !== null ? $d6c3291d6aa8eb5b$exports.Timestamp.fromPartial(object.votingStartTime) : undefined;
        message.votingEndTime = object.votingEndTime !== undefined && object.votingEndTime !== null ? $d6c3291d6aa8eb5b$exports.Timestamp.fromPartial(object.votingEndTime) : undefined;
        return message;
    }
};
const $7595a8a64e79a70f$var$baseTallyResult = {
    yes: "",
    abstain: "",
    no: "",
    noWithVeto: ""
};
$7595a8a64e79a70f$exports.TallyResult = {
    encode (message, writer = $7595a8a64e79a70f$var$minimal_1.default.Writer.create()) {
        if (message.yes !== "") writer.uint32(10).string(message.yes);
        if (message.abstain !== "") writer.uint32(18).string(message.abstain);
        if (message.no !== "") writer.uint32(26).string(message.no);
        if (message.noWithVeto !== "") writer.uint32(34).string(message.noWithVeto);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7595a8a64e79a70f$var$minimal_1.default.Reader ? input : new $7595a8a64e79a70f$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $7595a8a64e79a70f$var$baseTallyResult);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.yes = reader.string();
                    break;
                case 2:
                    message.abstain = reader.string();
                    break;
                case 3:
                    message.no = reader.string();
                    break;
                case 4:
                    message.noWithVeto = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $7595a8a64e79a70f$var$baseTallyResult);
        message.yes = object.yes !== undefined && object.yes !== null ? String(object.yes) : "";
        message.abstain = object.abstain !== undefined && object.abstain !== null ? String(object.abstain) : "";
        message.no = object.no !== undefined && object.no !== null ? String(object.no) : "";
        message.noWithVeto = object.noWithVeto !== undefined && object.noWithVeto !== null ? String(object.noWithVeto) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.yes !== undefined && (obj.yes = message.yes);
        message.abstain !== undefined && (obj.abstain = message.abstain);
        message.no !== undefined && (obj.no = message.no);
        message.noWithVeto !== undefined && (obj.noWithVeto = message.noWithVeto);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = Object.assign({}, $7595a8a64e79a70f$var$baseTallyResult);
        message.yes = (_a = object.yes) !== null && _a !== void 0 ? _a : "";
        message.abstain = (_b = object.abstain) !== null && _b !== void 0 ? _b : "";
        message.no = (_c = object.no) !== null && _c !== void 0 ? _c : "";
        message.noWithVeto = (_d = object.noWithVeto) !== null && _d !== void 0 ? _d : "";
        return message;
    }
};
const $7595a8a64e79a70f$var$baseVote = {
    proposalId: $7595a8a64e79a70f$var$long_1.default.UZERO,
    voter: "",
    option: 0
};
$7595a8a64e79a70f$exports.Vote = {
    encode (message, writer = $7595a8a64e79a70f$var$minimal_1.default.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        if (message.option !== 0) writer.uint32(24).int32(message.option);
        for (const v of message.options)$7595a8a64e79a70f$exports.WeightedVoteOption.encode(v, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7595a8a64e79a70f$var$minimal_1.default.Reader ? input : new $7595a8a64e79a70f$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $7595a8a64e79a70f$var$baseVote);
        message.options = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.option = reader.int32();
                    break;
                case 4:
                    message.options.push($7595a8a64e79a70f$exports.WeightedVoteOption.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $7595a8a64e79a70f$var$baseVote);
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $7595a8a64e79a70f$var$long_1.default.fromString(object.proposalId) : $7595a8a64e79a70f$var$long_1.default.UZERO;
        message.voter = object.voter !== undefined && object.voter !== null ? String(object.voter) : "";
        message.option = object.option !== undefined && object.option !== null ? $7595a8a64e79a70f$var$voteOptionFromJSON(object.option) : 0;
        message.options = ((_a = object.options) !== null && _a !== void 0 ? _a : []).map((e)=>$7595a8a64e79a70f$exports.WeightedVoteOption.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $7595a8a64e79a70f$var$long_1.default.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        message.option !== undefined && (obj.option = $7595a8a64e79a70f$var$voteOptionToJSON(message.option));
        if (message.options) obj.options = message.options.map((e)=>e ? $7595a8a64e79a70f$exports.WeightedVoteOption.toJSON(e) : undefined);
        else obj.options = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $7595a8a64e79a70f$var$baseVote);
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $7595a8a64e79a70f$var$long_1.default.fromValue(object.proposalId) : $7595a8a64e79a70f$var$long_1.default.UZERO;
        message.voter = (_a = object.voter) !== null && _a !== void 0 ? _a : "";
        message.option = (_b = object.option) !== null && _b !== void 0 ? _b : 0;
        message.options = ((_c = object.options) === null || _c === void 0 ? void 0 : _c.map((e)=>$7595a8a64e79a70f$exports.WeightedVoteOption.fromPartial(e))) || [];
        return message;
    }
};
const $7595a8a64e79a70f$var$baseDepositParams = {};
$7595a8a64e79a70f$exports.DepositParams = {
    encode (message, writer = $7595a8a64e79a70f$var$minimal_1.default.Writer.create()) {
        for (const v of message.minDeposit)$82ef09d1a8e2224d$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.maxDepositPeriod !== undefined) $ad1f748ecd469446$exports.Duration.encode(message.maxDepositPeriod, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7595a8a64e79a70f$var$minimal_1.default.Reader ? input : new $7595a8a64e79a70f$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $7595a8a64e79a70f$var$baseDepositParams);
        message.minDeposit = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.minDeposit.push($82ef09d1a8e2224d$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.maxDepositPeriod = $ad1f748ecd469446$exports.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $7595a8a64e79a70f$var$baseDepositParams);
        message.minDeposit = ((_a = object.minDeposit) !== null && _a !== void 0 ? _a : []).map((e)=>$82ef09d1a8e2224d$exports.Coin.fromJSON(e));
        message.maxDepositPeriod = object.maxDepositPeriod !== undefined && object.maxDepositPeriod !== null ? $ad1f748ecd469446$exports.Duration.fromJSON(object.maxDepositPeriod) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.minDeposit) obj.minDeposit = message.minDeposit.map((e)=>e ? $82ef09d1a8e2224d$exports.Coin.toJSON(e) : undefined);
        else obj.minDeposit = [];
        message.maxDepositPeriod !== undefined && (obj.maxDepositPeriod = message.maxDepositPeriod ? $ad1f748ecd469446$exports.Duration.toJSON(message.maxDepositPeriod) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $7595a8a64e79a70f$var$baseDepositParams);
        message.minDeposit = ((_a = object.minDeposit) === null || _a === void 0 ? void 0 : _a.map((e)=>$82ef09d1a8e2224d$exports.Coin.fromPartial(e))) || [];
        message.maxDepositPeriod = object.maxDepositPeriod !== undefined && object.maxDepositPeriod !== null ? $ad1f748ecd469446$exports.Duration.fromPartial(object.maxDepositPeriod) : undefined;
        return message;
    }
};
const $7595a8a64e79a70f$var$baseVotingParams = {};
$7595a8a64e79a70f$exports.VotingParams = {
    encode (message, writer = $7595a8a64e79a70f$var$minimal_1.default.Writer.create()) {
        if (message.votingPeriod !== undefined) $ad1f748ecd469446$exports.Duration.encode(message.votingPeriod, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7595a8a64e79a70f$var$minimal_1.default.Reader ? input : new $7595a8a64e79a70f$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $7595a8a64e79a70f$var$baseVotingParams);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.votingPeriod = $ad1f748ecd469446$exports.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $7595a8a64e79a70f$var$baseVotingParams);
        message.votingPeriod = object.votingPeriod !== undefined && object.votingPeriod !== null ? $ad1f748ecd469446$exports.Duration.fromJSON(object.votingPeriod) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.votingPeriod !== undefined && (obj.votingPeriod = message.votingPeriod ? $ad1f748ecd469446$exports.Duration.toJSON(message.votingPeriod) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $7595a8a64e79a70f$var$baseVotingParams);
        message.votingPeriod = object.votingPeriod !== undefined && object.votingPeriod !== null ? $ad1f748ecd469446$exports.Duration.fromPartial(object.votingPeriod) : undefined;
        return message;
    }
};
const $7595a8a64e79a70f$var$baseTallyParams = {};
$7595a8a64e79a70f$exports.TallyParams = {
    encode (message, writer = $7595a8a64e79a70f$var$minimal_1.default.Writer.create()) {
        if (message.quorum.length !== 0) writer.uint32(10).bytes(message.quorum);
        if (message.threshold.length !== 0) writer.uint32(18).bytes(message.threshold);
        if (message.vetoThreshold.length !== 0) writer.uint32(26).bytes(message.vetoThreshold);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7595a8a64e79a70f$var$minimal_1.default.Reader ? input : new $7595a8a64e79a70f$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $7595a8a64e79a70f$var$baseTallyParams);
        message.quorum = new Uint8Array();
        message.threshold = new Uint8Array();
        message.vetoThreshold = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.quorum = reader.bytes();
                    break;
                case 2:
                    message.threshold = reader.bytes();
                    break;
                case 3:
                    message.vetoThreshold = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $7595a8a64e79a70f$var$baseTallyParams);
        message.quorum = object.quorum !== undefined && object.quorum !== null ? $7595a8a64e79a70f$var$bytesFromBase64(object.quorum) : new Uint8Array();
        message.threshold = object.threshold !== undefined && object.threshold !== null ? $7595a8a64e79a70f$var$bytesFromBase64(object.threshold) : new Uint8Array();
        message.vetoThreshold = object.vetoThreshold !== undefined && object.vetoThreshold !== null ? $7595a8a64e79a70f$var$bytesFromBase64(object.vetoThreshold) : new Uint8Array();
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.quorum !== undefined && (obj.quorum = $7595a8a64e79a70f$var$base64FromBytes(message.quorum !== undefined ? message.quorum : new Uint8Array()));
        message.threshold !== undefined && (obj.threshold = $7595a8a64e79a70f$var$base64FromBytes(message.threshold !== undefined ? message.threshold : new Uint8Array()));
        message.vetoThreshold !== undefined && (obj.vetoThreshold = $7595a8a64e79a70f$var$base64FromBytes(message.vetoThreshold !== undefined ? message.vetoThreshold : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $7595a8a64e79a70f$var$baseTallyParams);
        message.quorum = (_a = object.quorum) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.threshold = (_b = object.threshold) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.vetoThreshold = (_c = object.vetoThreshold) !== null && _c !== void 0 ? _c : new Uint8Array();
        return message;
    }
};
var $7595a8a64e79a70f$var$globalThis = (()=>{
    if (typeof $7595a8a64e79a70f$var$globalThis !== "undefined") return $7595a8a64e79a70f$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $7595a8a64e79a70f$var$atob = $7595a8a64e79a70f$var$globalThis.atob || ((b64)=>$7595a8a64e79a70f$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $7595a8a64e79a70f$var$bytesFromBase64(b64) {
    const bin = $7595a8a64e79a70f$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $7595a8a64e79a70f$var$btoa = $7595a8a64e79a70f$var$globalThis.btoa || ((bin)=>$7595a8a64e79a70f$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $7595a8a64e79a70f$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $7595a8a64e79a70f$var$btoa(bin.join(""));
}
function $7595a8a64e79a70f$var$toTimestamp(date) {
    const seconds = $7595a8a64e79a70f$var$numberToLong(date.getTime() / 1000);
    const nanos = date.getTime() % 1000 * 1000000;
    return {
        seconds: seconds,
        nanos: nanos
    };
}
function $7595a8a64e79a70f$var$fromTimestamp(t) {
    let millis = t.seconds.toNumber() * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function $7595a8a64e79a70f$var$fromJsonTimestamp(o) {
    if (o instanceof Date) return $7595a8a64e79a70f$var$toTimestamp(o);
    else if (typeof o === "string") return $7595a8a64e79a70f$var$toTimestamp(new Date(o));
    else return $d6c3291d6aa8eb5b$exports.Timestamp.fromJSON(o);
}
function $7595a8a64e79a70f$var$numberToLong(number) {
    return $7595a8a64e79a70f$var$long_1.default.fromNumber(number);
}
if ($7595a8a64e79a70f$var$minimal_1.default.util.Long !== $7595a8a64e79a70f$var$long_1.default) {
    $7595a8a64e79a70f$var$minimal_1.default.util.Long = $7595a8a64e79a70f$var$long_1.default;
    $7595a8a64e79a70f$var$minimal_1.default.configure();
}




const $ac4fd039c3ed988e$var$long_1 = $ac4fd039c3ed988e$var$__importDefault((parcelRequire("9A55m")));
function $ac4fd039c3ed988e$var$isAminoMsgSubmitProposal(msg) {
    return msg.type === "cosmos-sdk/MsgSubmitProposal";
}
$ac4fd039c3ed988e$exports.isAminoMsgSubmitProposal = $ac4fd039c3ed988e$var$isAminoMsgSubmitProposal;
function $ac4fd039c3ed988e$var$isAminoMsgVote(msg) {
    return msg.type === "cosmos-sdk/MsgVote";
}
$ac4fd039c3ed988e$exports.isAminoMsgVote = $ac4fd039c3ed988e$var$isAminoMsgVote;
function $ac4fd039c3ed988e$var$isAminoMsgDeposit(msg) {
    return msg.type === "cosmos-sdk/MsgDeposit";
}
$ac4fd039c3ed988e$exports.isAminoMsgDeposit = $ac4fd039c3ed988e$var$isAminoMsgDeposit;
function $ac4fd039c3ed988e$var$createGovAminoConverters() {
    return {
        "/cosmos.gov.v1beta1.MsgDeposit": {
            aminoType: "cosmos-sdk/MsgDeposit",
            toAmino: ({ amount: amount, depositor: depositor, proposalId: proposalId })=>{
                return {
                    amount: amount,
                    depositor: depositor,
                    proposal_id: proposalId.toString()
                };
            },
            fromAmino: ({ amount: amount, depositor: depositor, proposal_id: proposal_id })=>{
                return {
                    amount: Array.from(amount),
                    depositor: depositor,
                    proposalId: $ac4fd039c3ed988e$var$long_1.default.fromString(proposal_id)
                };
            }
        },
        "/cosmos.gov.v1beta1.MsgVote": {
            aminoType: "cosmos-sdk/MsgVote",
            toAmino: ({ option: option, proposalId: proposalId, voter: voter })=>{
                return {
                    option: option,
                    proposal_id: proposalId.toString(),
                    voter: voter
                };
            },
            fromAmino: ({ option: option, proposal_id: proposal_id, voter: voter })=>{
                return {
                    option: (0, $7595a8a64e79a70f$exports.voteOptionFromJSON)(option),
                    proposalId: $ac4fd039c3ed988e$var$long_1.default.fromString(proposal_id),
                    voter: voter
                };
            }
        },
        "/cosmos.gov.v1beta1.MsgSubmitProposal": {
            aminoType: "cosmos-sdk/MsgSubmitProposal",
            toAmino: ({ initialDeposit: initialDeposit, proposer: proposer, content: content })=>{
                (0, $F6P8J.assertDefinedAndNotNull)(content);
                let proposal;
                switch(content.typeUrl){
                    case "/cosmos.gov.v1beta1.TextProposal":
                        {
                            const textProposal = $7595a8a64e79a70f$exports.TextProposal.decode(content.value);
                            proposal = {
                                type: "cosmos-sdk/TextProposal",
                                value: {
                                    description: textProposal.description,
                                    title: textProposal.title
                                }
                            };
                            break;
                        }
                    default:
                        throw new Error(`Unsupported proposal type: '${content.typeUrl}'`);
                }
                return {
                    initial_deposit: initialDeposit,
                    proposer: proposer,
                    content: proposal
                };
            },
            fromAmino: ({ initial_deposit: initial_deposit, proposer: proposer, content: content })=>{
                let any_content;
                switch(content.type){
                    case "cosmos-sdk/TextProposal":
                        {
                            const { value: value } = content;
                            (0, $F6P8J.assert)((0, $F6P8J.isNonNullObject)(value));
                            const { title: title, description: description } = value;
                            (0, $F6P8J.assert)(typeof title === "string");
                            (0, $F6P8J.assert)(typeof description === "string");
                            any_content = $4232fce010c3a46b$exports.Any.fromPartial({
                                typeUrl: "/cosmos.gov.v1beta1.TextProposal",
                                value: $7595a8a64e79a70f$exports.TextProposal.encode($7595a8a64e79a70f$exports.TextProposal.fromPartial({
                                    title: title,
                                    description: description
                                })).finish()
                            });
                            break;
                        }
                    default:
                        throw new Error(`Unsupported proposal type: '${content.type}'`);
                }
                return {
                    initialDeposit: Array.from(initial_deposit),
                    proposer: proposer,
                    content: any_content
                };
            }
        }
    };
}
$ac4fd039c3ed988e$exports.createGovAminoConverters = $ac4fd039c3ed988e$var$createGovAminoConverters;


Object.defineProperty($7725f2e3ca016b52$exports, "createGovAminoConverters", {
    enumerable: true,
    get: function() {
        return $ac4fd039c3ed988e$exports.createGovAminoConverters;
    }
});
Object.defineProperty($7725f2e3ca016b52$exports, "isAminoMsgDeposit", {
    enumerable: true,
    get: function() {
        return $ac4fd039c3ed988e$exports.isAminoMsgDeposit;
    }
});
Object.defineProperty($7725f2e3ca016b52$exports, "isAminoMsgSubmitProposal", {
    enumerable: true,
    get: function() {
        return $ac4fd039c3ed988e$exports.isAminoMsgSubmitProposal;
    }
});
Object.defineProperty($7725f2e3ca016b52$exports, "isAminoMsgVote", {
    enumerable: true,
    get: function() {
        return $ac4fd039c3ed988e$exports.isAminoMsgVote;
    }
});
var $ce52bf47aa9f62c2$exports = {};
"use strict";
Object.defineProperty($ce52bf47aa9f62c2$exports, "__esModule", {
    value: true
});
$ce52bf47aa9f62c2$exports.isMsgVoteEncodeObject = $ce52bf47aa9f62c2$exports.isMsgSubmitProposalEncodeObject = $ce52bf47aa9f62c2$exports.isMsgDepositEncodeObject = $ce52bf47aa9f62c2$exports.govTypes = void 0;
var $45c64d9a52e17eab$exports = {};
"use strict";
var $45c64d9a52e17eab$var$__importDefault = $45c64d9a52e17eab$exports && $45c64d9a52e17eab$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($45c64d9a52e17eab$exports, "__esModule", {
    value: true
});
$45c64d9a52e17eab$exports.MsgClientImpl = $45c64d9a52e17eab$exports.MsgDepositResponse = $45c64d9a52e17eab$exports.MsgDeposit = $45c64d9a52e17eab$exports.MsgVoteWeightedResponse = $45c64d9a52e17eab$exports.MsgVoteWeighted = $45c64d9a52e17eab$exports.MsgVoteResponse = $45c64d9a52e17eab$exports.MsgVote = $45c64d9a52e17eab$exports.MsgSubmitProposalResponse = $45c64d9a52e17eab$exports.MsgSubmitProposal = $45c64d9a52e17eab$exports.protobufPackage = void 0;

/* eslint-disable */ const $45c64d9a52e17eab$var$long_1 = $45c64d9a52e17eab$var$__importDefault((parcelRequire("9A55m")));

const $45c64d9a52e17eab$var$minimal_1 = $45c64d9a52e17eab$var$__importDefault((parcelRequire("i2pIU")));



$45c64d9a52e17eab$exports.protobufPackage = "cosmos.gov.v1beta1";
const $45c64d9a52e17eab$var$baseMsgSubmitProposal = {
    proposer: ""
};
$45c64d9a52e17eab$exports.MsgSubmitProposal = {
    encode (message, writer = $45c64d9a52e17eab$var$minimal_1.default.Writer.create()) {
        if (message.content !== undefined) $4232fce010c3a46b$exports.Any.encode(message.content, writer.uint32(10).fork()).ldelim();
        for (const v of message.initialDeposit)$82ef09d1a8e2224d$exports.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        if (message.proposer !== "") writer.uint32(26).string(message.proposer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $45c64d9a52e17eab$var$minimal_1.default.Reader ? input : new $45c64d9a52e17eab$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $45c64d9a52e17eab$var$baseMsgSubmitProposal);
        message.initialDeposit = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.content = $4232fce010c3a46b$exports.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.initialDeposit.push($82ef09d1a8e2224d$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.proposer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $45c64d9a52e17eab$var$baseMsgSubmitProposal);
        message.content = object.content !== undefined && object.content !== null ? $4232fce010c3a46b$exports.Any.fromJSON(object.content) : undefined;
        message.initialDeposit = ((_a = object.initialDeposit) !== null && _a !== void 0 ? _a : []).map((e)=>$82ef09d1a8e2224d$exports.Coin.fromJSON(e));
        message.proposer = object.proposer !== undefined && object.proposer !== null ? String(object.proposer) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.content !== undefined && (obj.content = message.content ? $4232fce010c3a46b$exports.Any.toJSON(message.content) : undefined);
        if (message.initialDeposit) obj.initialDeposit = message.initialDeposit.map((e)=>e ? $82ef09d1a8e2224d$exports.Coin.toJSON(e) : undefined);
        else obj.initialDeposit = [];
        message.proposer !== undefined && (obj.proposer = message.proposer);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $45c64d9a52e17eab$var$baseMsgSubmitProposal);
        message.content = object.content !== undefined && object.content !== null ? $4232fce010c3a46b$exports.Any.fromPartial(object.content) : undefined;
        message.initialDeposit = ((_a = object.initialDeposit) === null || _a === void 0 ? void 0 : _a.map((e)=>$82ef09d1a8e2224d$exports.Coin.fromPartial(e))) || [];
        message.proposer = (_b = object.proposer) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
const $45c64d9a52e17eab$var$baseMsgSubmitProposalResponse = {
    proposalId: $45c64d9a52e17eab$var$long_1.default.UZERO
};
$45c64d9a52e17eab$exports.MsgSubmitProposalResponse = {
    encode (message, writer = $45c64d9a52e17eab$var$minimal_1.default.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $45c64d9a52e17eab$var$minimal_1.default.Reader ? input : new $45c64d9a52e17eab$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $45c64d9a52e17eab$var$baseMsgSubmitProposalResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $45c64d9a52e17eab$var$baseMsgSubmitProposalResponse);
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $45c64d9a52e17eab$var$long_1.default.fromString(object.proposalId) : $45c64d9a52e17eab$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $45c64d9a52e17eab$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $45c64d9a52e17eab$var$baseMsgSubmitProposalResponse);
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $45c64d9a52e17eab$var$long_1.default.fromValue(object.proposalId) : $45c64d9a52e17eab$var$long_1.default.UZERO;
        return message;
    }
};
const $45c64d9a52e17eab$var$baseMsgVote = {
    proposalId: $45c64d9a52e17eab$var$long_1.default.UZERO,
    voter: "",
    option: 0
};
$45c64d9a52e17eab$exports.MsgVote = {
    encode (message, writer = $45c64d9a52e17eab$var$minimal_1.default.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        if (message.option !== 0) writer.uint32(24).int32(message.option);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $45c64d9a52e17eab$var$minimal_1.default.Reader ? input : new $45c64d9a52e17eab$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $45c64d9a52e17eab$var$baseMsgVote);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.option = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $45c64d9a52e17eab$var$baseMsgVote);
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $45c64d9a52e17eab$var$long_1.default.fromString(object.proposalId) : $45c64d9a52e17eab$var$long_1.default.UZERO;
        message.voter = object.voter !== undefined && object.voter !== null ? String(object.voter) : "";
        message.option = object.option !== undefined && object.option !== null ? $7595a8a64e79a70f$exports.voteOptionFromJSON(object.option) : 0;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $45c64d9a52e17eab$var$long_1.default.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        message.option !== undefined && (obj.option = $7595a8a64e79a70f$exports.voteOptionToJSON(message.option));
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $45c64d9a52e17eab$var$baseMsgVote);
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $45c64d9a52e17eab$var$long_1.default.fromValue(object.proposalId) : $45c64d9a52e17eab$var$long_1.default.UZERO;
        message.voter = (_a = object.voter) !== null && _a !== void 0 ? _a : "";
        message.option = (_b = object.option) !== null && _b !== void 0 ? _b : 0;
        return message;
    }
};
const $45c64d9a52e17eab$var$baseMsgVoteResponse = {};
$45c64d9a52e17eab$exports.MsgVoteResponse = {
    encode (_, writer = $45c64d9a52e17eab$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $45c64d9a52e17eab$var$minimal_1.default.Reader ? input : new $45c64d9a52e17eab$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $45c64d9a52e17eab$var$baseMsgVoteResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $45c64d9a52e17eab$var$baseMsgVoteResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $45c64d9a52e17eab$var$baseMsgVoteResponse);
        return message;
    }
};
const $45c64d9a52e17eab$var$baseMsgVoteWeighted = {
    proposalId: $45c64d9a52e17eab$var$long_1.default.UZERO,
    voter: ""
};
$45c64d9a52e17eab$exports.MsgVoteWeighted = {
    encode (message, writer = $45c64d9a52e17eab$var$minimal_1.default.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        for (const v of message.options)$7595a8a64e79a70f$exports.WeightedVoteOption.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $45c64d9a52e17eab$var$minimal_1.default.Reader ? input : new $45c64d9a52e17eab$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $45c64d9a52e17eab$var$baseMsgVoteWeighted);
        message.options = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.options.push($7595a8a64e79a70f$exports.WeightedVoteOption.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $45c64d9a52e17eab$var$baseMsgVoteWeighted);
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $45c64d9a52e17eab$var$long_1.default.fromString(object.proposalId) : $45c64d9a52e17eab$var$long_1.default.UZERO;
        message.voter = object.voter !== undefined && object.voter !== null ? String(object.voter) : "";
        message.options = ((_a = object.options) !== null && _a !== void 0 ? _a : []).map((e)=>$7595a8a64e79a70f$exports.WeightedVoteOption.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $45c64d9a52e17eab$var$long_1.default.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        if (message.options) obj.options = message.options.map((e)=>e ? $7595a8a64e79a70f$exports.WeightedVoteOption.toJSON(e) : undefined);
        else obj.options = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $45c64d9a52e17eab$var$baseMsgVoteWeighted);
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $45c64d9a52e17eab$var$long_1.default.fromValue(object.proposalId) : $45c64d9a52e17eab$var$long_1.default.UZERO;
        message.voter = (_a = object.voter) !== null && _a !== void 0 ? _a : "";
        message.options = ((_b = object.options) === null || _b === void 0 ? void 0 : _b.map((e)=>$7595a8a64e79a70f$exports.WeightedVoteOption.fromPartial(e))) || [];
        return message;
    }
};
const $45c64d9a52e17eab$var$baseMsgVoteWeightedResponse = {};
$45c64d9a52e17eab$exports.MsgVoteWeightedResponse = {
    encode (_, writer = $45c64d9a52e17eab$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $45c64d9a52e17eab$var$minimal_1.default.Reader ? input : new $45c64d9a52e17eab$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $45c64d9a52e17eab$var$baseMsgVoteWeightedResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $45c64d9a52e17eab$var$baseMsgVoteWeightedResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $45c64d9a52e17eab$var$baseMsgVoteWeightedResponse);
        return message;
    }
};
const $45c64d9a52e17eab$var$baseMsgDeposit = {
    proposalId: $45c64d9a52e17eab$var$long_1.default.UZERO,
    depositor: ""
};
$45c64d9a52e17eab$exports.MsgDeposit = {
    encode (message, writer = $45c64d9a52e17eab$var$minimal_1.default.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.depositor !== "") writer.uint32(18).string(message.depositor);
        for (const v of message.amount)$82ef09d1a8e2224d$exports.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $45c64d9a52e17eab$var$minimal_1.default.Reader ? input : new $45c64d9a52e17eab$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $45c64d9a52e17eab$var$baseMsgDeposit);
        message.amount = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                case 3:
                    message.amount.push($82ef09d1a8e2224d$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $45c64d9a52e17eab$var$baseMsgDeposit);
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $45c64d9a52e17eab$var$long_1.default.fromString(object.proposalId) : $45c64d9a52e17eab$var$long_1.default.UZERO;
        message.depositor = object.depositor !== undefined && object.depositor !== null ? String(object.depositor) : "";
        message.amount = ((_a = object.amount) !== null && _a !== void 0 ? _a : []).map((e)=>$82ef09d1a8e2224d$exports.Coin.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $45c64d9a52e17eab$var$long_1.default.UZERO).toString());
        message.depositor !== undefined && (obj.depositor = message.depositor);
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $82ef09d1a8e2224d$exports.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $45c64d9a52e17eab$var$baseMsgDeposit);
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $45c64d9a52e17eab$var$long_1.default.fromValue(object.proposalId) : $45c64d9a52e17eab$var$long_1.default.UZERO;
        message.depositor = (_a = object.depositor) !== null && _a !== void 0 ? _a : "";
        message.amount = ((_b = object.amount) === null || _b === void 0 ? void 0 : _b.map((e)=>$82ef09d1a8e2224d$exports.Coin.fromPartial(e))) || [];
        return message;
    }
};
const $45c64d9a52e17eab$var$baseMsgDepositResponse = {};
$45c64d9a52e17eab$exports.MsgDepositResponse = {
    encode (_, writer = $45c64d9a52e17eab$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $45c64d9a52e17eab$var$minimal_1.default.Reader ? input : new $45c64d9a52e17eab$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $45c64d9a52e17eab$var$baseMsgDepositResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $45c64d9a52e17eab$var$baseMsgDepositResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $45c64d9a52e17eab$var$baseMsgDepositResponse);
        return message;
    }
};
class $45c64d9a52e17eab$var$MsgClientImpl {
    SubmitProposal(request) {
        const data = $45c64d9a52e17eab$exports.MsgSubmitProposal.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Msg", "SubmitProposal", data);
        return promise.then((data)=>$45c64d9a52e17eab$exports.MsgSubmitProposalResponse.decode(new $45c64d9a52e17eab$var$minimal_1.default.Reader(data)));
    }
    Vote(request) {
        const data = $45c64d9a52e17eab$exports.MsgVote.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Msg", "Vote", data);
        return promise.then((data)=>$45c64d9a52e17eab$exports.MsgVoteResponse.decode(new $45c64d9a52e17eab$var$minimal_1.default.Reader(data)));
    }
    VoteWeighted(request) {
        const data = $45c64d9a52e17eab$exports.MsgVoteWeighted.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Msg", "VoteWeighted", data);
        return promise.then((data)=>$45c64d9a52e17eab$exports.MsgVoteWeightedResponse.decode(new $45c64d9a52e17eab$var$minimal_1.default.Reader(data)));
    }
    Deposit(request) {
        const data = $45c64d9a52e17eab$exports.MsgDeposit.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Msg", "Deposit", data);
        return promise.then((data)=>$45c64d9a52e17eab$exports.MsgDepositResponse.decode(new $45c64d9a52e17eab$var$minimal_1.default.Reader(data)));
    }
    constructor(rpc){
        this.rpc = rpc;
        this.SubmitProposal = this.SubmitProposal.bind(this);
        this.Vote = this.Vote.bind(this);
        this.VoteWeighted = this.VoteWeighted.bind(this);
        this.Deposit = this.Deposit.bind(this);
    }
}
$45c64d9a52e17eab$exports.MsgClientImpl = $45c64d9a52e17eab$var$MsgClientImpl;
if ($45c64d9a52e17eab$var$minimal_1.default.util.Long !== $45c64d9a52e17eab$var$long_1.default) {
    $45c64d9a52e17eab$var$minimal_1.default.util.Long = $45c64d9a52e17eab$var$long_1.default;
    $45c64d9a52e17eab$var$minimal_1.default.configure();
}


$ce52bf47aa9f62c2$exports.govTypes = [
    [
        "/cosmos.gov.v1beta1.MsgDeposit",
        $45c64d9a52e17eab$exports.MsgDeposit
    ],
    [
        "/cosmos.gov.v1beta1.MsgSubmitProposal",
        $45c64d9a52e17eab$exports.MsgSubmitProposal
    ],
    [
        "/cosmos.gov.v1beta1.MsgVote",
        $45c64d9a52e17eab$exports.MsgVote
    ]
];
function $ce52bf47aa9f62c2$var$isMsgDepositEncodeObject(object) {
    return object.typeUrl === "/cosmos.gov.v1beta1.MsgDeposit";
}
$ce52bf47aa9f62c2$exports.isMsgDepositEncodeObject = $ce52bf47aa9f62c2$var$isMsgDepositEncodeObject;
function $ce52bf47aa9f62c2$var$isMsgSubmitProposalEncodeObject(object) {
    return object.typeUrl === "/cosmos.gov.v1beta1.MsgSubmitProposal";
}
$ce52bf47aa9f62c2$exports.isMsgSubmitProposalEncodeObject = $ce52bf47aa9f62c2$var$isMsgSubmitProposalEncodeObject;
function $ce52bf47aa9f62c2$var$isMsgVoteEncodeObject(object) {
    return object.typeUrl === "/cosmos.gov.v1beta1.MsgVote";
}
$ce52bf47aa9f62c2$exports.isMsgVoteEncodeObject = $ce52bf47aa9f62c2$var$isMsgVoteEncodeObject;


Object.defineProperty($7725f2e3ca016b52$exports, "govTypes", {
    enumerable: true,
    get: function() {
        return $ce52bf47aa9f62c2$exports.govTypes;
    }
});
Object.defineProperty($7725f2e3ca016b52$exports, "isMsgDepositEncodeObject", {
    enumerable: true,
    get: function() {
        return $ce52bf47aa9f62c2$exports.isMsgDepositEncodeObject;
    }
});
Object.defineProperty($7725f2e3ca016b52$exports, "isMsgSubmitProposalEncodeObject", {
    enumerable: true,
    get: function() {
        return $ce52bf47aa9f62c2$exports.isMsgSubmitProposalEncodeObject;
    }
});
Object.defineProperty($7725f2e3ca016b52$exports, "isMsgVoteEncodeObject", {
    enumerable: true,
    get: function() {
        return $ce52bf47aa9f62c2$exports.isMsgVoteEncodeObject;
    }
});
var $058d229376aa4532$exports = {};
"use strict";
Object.defineProperty($058d229376aa4532$exports, "__esModule", {
    value: true
});
$058d229376aa4532$exports.setupGovExtension = void 0;
var $c8a06e6afeae6f2a$exports = {};
"use strict";
var $c8a06e6afeae6f2a$var$__importDefault = $c8a06e6afeae6f2a$exports && $c8a06e6afeae6f2a$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($c8a06e6afeae6f2a$exports, "__esModule", {
    value: true
});
$c8a06e6afeae6f2a$exports.QueryClientImpl = $c8a06e6afeae6f2a$exports.QueryTallyResultResponse = $c8a06e6afeae6f2a$exports.QueryTallyResultRequest = $c8a06e6afeae6f2a$exports.QueryDepositsResponse = $c8a06e6afeae6f2a$exports.QueryDepositsRequest = $c8a06e6afeae6f2a$exports.QueryDepositResponse = $c8a06e6afeae6f2a$exports.QueryDepositRequest = $c8a06e6afeae6f2a$exports.QueryParamsResponse = $c8a06e6afeae6f2a$exports.QueryParamsRequest = $c8a06e6afeae6f2a$exports.QueryVotesResponse = $c8a06e6afeae6f2a$exports.QueryVotesRequest = $c8a06e6afeae6f2a$exports.QueryVoteResponse = $c8a06e6afeae6f2a$exports.QueryVoteRequest = $c8a06e6afeae6f2a$exports.QueryProposalsResponse = $c8a06e6afeae6f2a$exports.QueryProposalsRequest = $c8a06e6afeae6f2a$exports.QueryProposalResponse = $c8a06e6afeae6f2a$exports.QueryProposalRequest = $c8a06e6afeae6f2a$exports.protobufPackage = void 0;

/* eslint-disable */ const $c8a06e6afeae6f2a$var$long_1 = $c8a06e6afeae6f2a$var$__importDefault((parcelRequire("9A55m")));

const $c8a06e6afeae6f2a$var$minimal_1 = $c8a06e6afeae6f2a$var$__importDefault((parcelRequire("i2pIU")));


$c8a06e6afeae6f2a$exports.protobufPackage = "cosmos.gov.v1beta1";
const $c8a06e6afeae6f2a$var$baseQueryProposalRequest = {
    proposalId: $c8a06e6afeae6f2a$var$long_1.default.UZERO
};
$c8a06e6afeae6f2a$exports.QueryProposalRequest = {
    encode (message, writer = $c8a06e6afeae6f2a$var$minimal_1.default.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c8a06e6afeae6f2a$var$minimal_1.default.Reader ? input : new $c8a06e6afeae6f2a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryProposalRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryProposalRequest);
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $c8a06e6afeae6f2a$var$long_1.default.fromString(object.proposalId) : $c8a06e6afeae6f2a$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $c8a06e6afeae6f2a$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryProposalRequest);
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $c8a06e6afeae6f2a$var$long_1.default.fromValue(object.proposalId) : $c8a06e6afeae6f2a$var$long_1.default.UZERO;
        return message;
    }
};
const $c8a06e6afeae6f2a$var$baseQueryProposalResponse = {};
$c8a06e6afeae6f2a$exports.QueryProposalResponse = {
    encode (message, writer = $c8a06e6afeae6f2a$var$minimal_1.default.Writer.create()) {
        if (message.proposal !== undefined) $7595a8a64e79a70f$exports.Proposal.encode(message.proposal, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c8a06e6afeae6f2a$var$minimal_1.default.Reader ? input : new $c8a06e6afeae6f2a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryProposalResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposal = $7595a8a64e79a70f$exports.Proposal.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryProposalResponse);
        message.proposal = object.proposal !== undefined && object.proposal !== null ? $7595a8a64e79a70f$exports.Proposal.fromJSON(object.proposal) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.proposal !== undefined && (obj.proposal = message.proposal ? $7595a8a64e79a70f$exports.Proposal.toJSON(message.proposal) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryProposalResponse);
        message.proposal = object.proposal !== undefined && object.proposal !== null ? $7595a8a64e79a70f$exports.Proposal.fromPartial(object.proposal) : undefined;
        return message;
    }
};
const $c8a06e6afeae6f2a$var$baseQueryProposalsRequest = {
    proposalStatus: 0,
    voter: "",
    depositor: ""
};
$c8a06e6afeae6f2a$exports.QueryProposalsRequest = {
    encode (message, writer = $c8a06e6afeae6f2a$var$minimal_1.default.Writer.create()) {
        if (message.proposalStatus !== 0) writer.uint32(8).int32(message.proposalStatus);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        if (message.depositor !== "") writer.uint32(26).string(message.depositor);
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageRequest.encode(message.pagination, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c8a06e6afeae6f2a$var$minimal_1.default.Reader ? input : new $c8a06e6afeae6f2a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryProposalsRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalStatus = reader.int32();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.depositor = reader.string();
                    break;
                case 4:
                    message.pagination = $f01b40e20607eb8e$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryProposalsRequest);
        message.proposalStatus = object.proposalStatus !== undefined && object.proposalStatus !== null ? $7595a8a64e79a70f$exports.proposalStatusFromJSON(object.proposalStatus) : 0;
        message.voter = object.voter !== undefined && object.voter !== null ? String(object.voter) : "";
        message.depositor = object.depositor !== undefined && object.depositor !== null ? String(object.depositor) : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromJSON(object.pagination) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.proposalStatus !== undefined && (obj.proposalStatus = $7595a8a64e79a70f$exports.proposalStatusToJSON(message.proposalStatus));
        message.voter !== undefined && (obj.voter = message.voter);
        message.depositor !== undefined && (obj.depositor = message.depositor);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryProposalsRequest);
        message.proposalStatus = (_a = object.proposalStatus) !== null && _a !== void 0 ? _a : 0;
        message.voter = (_b = object.voter) !== null && _b !== void 0 ? _b : "";
        message.depositor = (_c = object.depositor) !== null && _c !== void 0 ? _c : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
const $c8a06e6afeae6f2a$var$baseQueryProposalsResponse = {};
$c8a06e6afeae6f2a$exports.QueryProposalsResponse = {
    encode (message, writer = $c8a06e6afeae6f2a$var$minimal_1.default.Writer.create()) {
        for (const v of message.proposals)$7595a8a64e79a70f$exports.Proposal.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c8a06e6afeae6f2a$var$minimal_1.default.Reader ? input : new $c8a06e6afeae6f2a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryProposalsResponse);
        message.proposals = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposals.push($7595a8a64e79a70f$exports.Proposal.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $f01b40e20607eb8e$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryProposalsResponse);
        message.proposals = ((_a = object.proposals) !== null && _a !== void 0 ? _a : []).map((e)=>$7595a8a64e79a70f$exports.Proposal.fromJSON(e));
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromJSON(object.pagination) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.proposals) obj.proposals = message.proposals.map((e)=>e ? $7595a8a64e79a70f$exports.Proposal.toJSON(e) : undefined);
        else obj.proposals = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryProposalsResponse);
        message.proposals = ((_a = object.proposals) === null || _a === void 0 ? void 0 : _a.map((e)=>$7595a8a64e79a70f$exports.Proposal.fromPartial(e))) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
const $c8a06e6afeae6f2a$var$baseQueryVoteRequest = {
    proposalId: $c8a06e6afeae6f2a$var$long_1.default.UZERO,
    voter: ""
};
$c8a06e6afeae6f2a$exports.QueryVoteRequest = {
    encode (message, writer = $c8a06e6afeae6f2a$var$minimal_1.default.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c8a06e6afeae6f2a$var$minimal_1.default.Reader ? input : new $c8a06e6afeae6f2a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryVoteRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryVoteRequest);
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $c8a06e6afeae6f2a$var$long_1.default.fromString(object.proposalId) : $c8a06e6afeae6f2a$var$long_1.default.UZERO;
        message.voter = object.voter !== undefined && object.voter !== null ? String(object.voter) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $c8a06e6afeae6f2a$var$long_1.default.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryVoteRequest);
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $c8a06e6afeae6f2a$var$long_1.default.fromValue(object.proposalId) : $c8a06e6afeae6f2a$var$long_1.default.UZERO;
        message.voter = (_a = object.voter) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
const $c8a06e6afeae6f2a$var$baseQueryVoteResponse = {};
$c8a06e6afeae6f2a$exports.QueryVoteResponse = {
    encode (message, writer = $c8a06e6afeae6f2a$var$minimal_1.default.Writer.create()) {
        if (message.vote !== undefined) $7595a8a64e79a70f$exports.Vote.encode(message.vote, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c8a06e6afeae6f2a$var$minimal_1.default.Reader ? input : new $c8a06e6afeae6f2a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryVoteResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.vote = $7595a8a64e79a70f$exports.Vote.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryVoteResponse);
        message.vote = object.vote !== undefined && object.vote !== null ? $7595a8a64e79a70f$exports.Vote.fromJSON(object.vote) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.vote !== undefined && (obj.vote = message.vote ? $7595a8a64e79a70f$exports.Vote.toJSON(message.vote) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryVoteResponse);
        message.vote = object.vote !== undefined && object.vote !== null ? $7595a8a64e79a70f$exports.Vote.fromPartial(object.vote) : undefined;
        return message;
    }
};
const $c8a06e6afeae6f2a$var$baseQueryVotesRequest = {
    proposalId: $c8a06e6afeae6f2a$var$long_1.default.UZERO
};
$c8a06e6afeae6f2a$exports.QueryVotesRequest = {
    encode (message, writer = $c8a06e6afeae6f2a$var$minimal_1.default.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c8a06e6afeae6f2a$var$minimal_1.default.Reader ? input : new $c8a06e6afeae6f2a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryVotesRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.pagination = $f01b40e20607eb8e$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryVotesRequest);
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $c8a06e6afeae6f2a$var$long_1.default.fromString(object.proposalId) : $c8a06e6afeae6f2a$var$long_1.default.UZERO;
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromJSON(object.pagination) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $c8a06e6afeae6f2a$var$long_1.default.UZERO).toString());
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryVotesRequest);
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $c8a06e6afeae6f2a$var$long_1.default.fromValue(object.proposalId) : $c8a06e6afeae6f2a$var$long_1.default.UZERO;
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
const $c8a06e6afeae6f2a$var$baseQueryVotesResponse = {};
$c8a06e6afeae6f2a$exports.QueryVotesResponse = {
    encode (message, writer = $c8a06e6afeae6f2a$var$minimal_1.default.Writer.create()) {
        for (const v of message.votes)$7595a8a64e79a70f$exports.Vote.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c8a06e6afeae6f2a$var$minimal_1.default.Reader ? input : new $c8a06e6afeae6f2a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryVotesResponse);
        message.votes = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.votes.push($7595a8a64e79a70f$exports.Vote.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $f01b40e20607eb8e$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryVotesResponse);
        message.votes = ((_a = object.votes) !== null && _a !== void 0 ? _a : []).map((e)=>$7595a8a64e79a70f$exports.Vote.fromJSON(e));
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromJSON(object.pagination) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.votes) obj.votes = message.votes.map((e)=>e ? $7595a8a64e79a70f$exports.Vote.toJSON(e) : undefined);
        else obj.votes = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryVotesResponse);
        message.votes = ((_a = object.votes) === null || _a === void 0 ? void 0 : _a.map((e)=>$7595a8a64e79a70f$exports.Vote.fromPartial(e))) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
const $c8a06e6afeae6f2a$var$baseQueryParamsRequest = {
    paramsType: ""
};
$c8a06e6afeae6f2a$exports.QueryParamsRequest = {
    encode (message, writer = $c8a06e6afeae6f2a$var$minimal_1.default.Writer.create()) {
        if (message.paramsType !== "") writer.uint32(10).string(message.paramsType);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c8a06e6afeae6f2a$var$minimal_1.default.Reader ? input : new $c8a06e6afeae6f2a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryParamsRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.paramsType = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryParamsRequest);
        message.paramsType = object.paramsType !== undefined && object.paramsType !== null ? String(object.paramsType) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.paramsType !== undefined && (obj.paramsType = message.paramsType);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryParamsRequest);
        message.paramsType = (_a = object.paramsType) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
const $c8a06e6afeae6f2a$var$baseQueryParamsResponse = {};
$c8a06e6afeae6f2a$exports.QueryParamsResponse = {
    encode (message, writer = $c8a06e6afeae6f2a$var$minimal_1.default.Writer.create()) {
        if (message.votingParams !== undefined) $7595a8a64e79a70f$exports.VotingParams.encode(message.votingParams, writer.uint32(10).fork()).ldelim();
        if (message.depositParams !== undefined) $7595a8a64e79a70f$exports.DepositParams.encode(message.depositParams, writer.uint32(18).fork()).ldelim();
        if (message.tallyParams !== undefined) $7595a8a64e79a70f$exports.TallyParams.encode(message.tallyParams, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c8a06e6afeae6f2a$var$minimal_1.default.Reader ? input : new $c8a06e6afeae6f2a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryParamsResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.votingParams = $7595a8a64e79a70f$exports.VotingParams.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.depositParams = $7595a8a64e79a70f$exports.DepositParams.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.tallyParams = $7595a8a64e79a70f$exports.TallyParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryParamsResponse);
        message.votingParams = object.votingParams !== undefined && object.votingParams !== null ? $7595a8a64e79a70f$exports.VotingParams.fromJSON(object.votingParams) : undefined;
        message.depositParams = object.depositParams !== undefined && object.depositParams !== null ? $7595a8a64e79a70f$exports.DepositParams.fromJSON(object.depositParams) : undefined;
        message.tallyParams = object.tallyParams !== undefined && object.tallyParams !== null ? $7595a8a64e79a70f$exports.TallyParams.fromJSON(object.tallyParams) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.votingParams !== undefined && (obj.votingParams = message.votingParams ? $7595a8a64e79a70f$exports.VotingParams.toJSON(message.votingParams) : undefined);
        message.depositParams !== undefined && (obj.depositParams = message.depositParams ? $7595a8a64e79a70f$exports.DepositParams.toJSON(message.depositParams) : undefined);
        message.tallyParams !== undefined && (obj.tallyParams = message.tallyParams ? $7595a8a64e79a70f$exports.TallyParams.toJSON(message.tallyParams) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryParamsResponse);
        message.votingParams = object.votingParams !== undefined && object.votingParams !== null ? $7595a8a64e79a70f$exports.VotingParams.fromPartial(object.votingParams) : undefined;
        message.depositParams = object.depositParams !== undefined && object.depositParams !== null ? $7595a8a64e79a70f$exports.DepositParams.fromPartial(object.depositParams) : undefined;
        message.tallyParams = object.tallyParams !== undefined && object.tallyParams !== null ? $7595a8a64e79a70f$exports.TallyParams.fromPartial(object.tallyParams) : undefined;
        return message;
    }
};
const $c8a06e6afeae6f2a$var$baseQueryDepositRequest = {
    proposalId: $c8a06e6afeae6f2a$var$long_1.default.UZERO,
    depositor: ""
};
$c8a06e6afeae6f2a$exports.QueryDepositRequest = {
    encode (message, writer = $c8a06e6afeae6f2a$var$minimal_1.default.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.depositor !== "") writer.uint32(18).string(message.depositor);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c8a06e6afeae6f2a$var$minimal_1.default.Reader ? input : new $c8a06e6afeae6f2a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryDepositRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryDepositRequest);
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $c8a06e6afeae6f2a$var$long_1.default.fromString(object.proposalId) : $c8a06e6afeae6f2a$var$long_1.default.UZERO;
        message.depositor = object.depositor !== undefined && object.depositor !== null ? String(object.depositor) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $c8a06e6afeae6f2a$var$long_1.default.UZERO).toString());
        message.depositor !== undefined && (obj.depositor = message.depositor);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryDepositRequest);
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $c8a06e6afeae6f2a$var$long_1.default.fromValue(object.proposalId) : $c8a06e6afeae6f2a$var$long_1.default.UZERO;
        message.depositor = (_a = object.depositor) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
const $c8a06e6afeae6f2a$var$baseQueryDepositResponse = {};
$c8a06e6afeae6f2a$exports.QueryDepositResponse = {
    encode (message, writer = $c8a06e6afeae6f2a$var$minimal_1.default.Writer.create()) {
        if (message.deposit !== undefined) $7595a8a64e79a70f$exports.Deposit.encode(message.deposit, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c8a06e6afeae6f2a$var$minimal_1.default.Reader ? input : new $c8a06e6afeae6f2a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryDepositResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.deposit = $7595a8a64e79a70f$exports.Deposit.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryDepositResponse);
        message.deposit = object.deposit !== undefined && object.deposit !== null ? $7595a8a64e79a70f$exports.Deposit.fromJSON(object.deposit) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.deposit !== undefined && (obj.deposit = message.deposit ? $7595a8a64e79a70f$exports.Deposit.toJSON(message.deposit) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryDepositResponse);
        message.deposit = object.deposit !== undefined && object.deposit !== null ? $7595a8a64e79a70f$exports.Deposit.fromPartial(object.deposit) : undefined;
        return message;
    }
};
const $c8a06e6afeae6f2a$var$baseQueryDepositsRequest = {
    proposalId: $c8a06e6afeae6f2a$var$long_1.default.UZERO
};
$c8a06e6afeae6f2a$exports.QueryDepositsRequest = {
    encode (message, writer = $c8a06e6afeae6f2a$var$minimal_1.default.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c8a06e6afeae6f2a$var$minimal_1.default.Reader ? input : new $c8a06e6afeae6f2a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryDepositsRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.pagination = $f01b40e20607eb8e$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryDepositsRequest);
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $c8a06e6afeae6f2a$var$long_1.default.fromString(object.proposalId) : $c8a06e6afeae6f2a$var$long_1.default.UZERO;
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromJSON(object.pagination) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $c8a06e6afeae6f2a$var$long_1.default.UZERO).toString());
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryDepositsRequest);
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $c8a06e6afeae6f2a$var$long_1.default.fromValue(object.proposalId) : $c8a06e6afeae6f2a$var$long_1.default.UZERO;
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
const $c8a06e6afeae6f2a$var$baseQueryDepositsResponse = {};
$c8a06e6afeae6f2a$exports.QueryDepositsResponse = {
    encode (message, writer = $c8a06e6afeae6f2a$var$minimal_1.default.Writer.create()) {
        for (const v of message.deposits)$7595a8a64e79a70f$exports.Deposit.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c8a06e6afeae6f2a$var$minimal_1.default.Reader ? input : new $c8a06e6afeae6f2a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryDepositsResponse);
        message.deposits = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.deposits.push($7595a8a64e79a70f$exports.Deposit.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $f01b40e20607eb8e$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryDepositsResponse);
        message.deposits = ((_a = object.deposits) !== null && _a !== void 0 ? _a : []).map((e)=>$7595a8a64e79a70f$exports.Deposit.fromJSON(e));
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromJSON(object.pagination) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.deposits) obj.deposits = message.deposits.map((e)=>e ? $7595a8a64e79a70f$exports.Deposit.toJSON(e) : undefined);
        else obj.deposits = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryDepositsResponse);
        message.deposits = ((_a = object.deposits) === null || _a === void 0 ? void 0 : _a.map((e)=>$7595a8a64e79a70f$exports.Deposit.fromPartial(e))) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
const $c8a06e6afeae6f2a$var$baseQueryTallyResultRequest = {
    proposalId: $c8a06e6afeae6f2a$var$long_1.default.UZERO
};
$c8a06e6afeae6f2a$exports.QueryTallyResultRequest = {
    encode (message, writer = $c8a06e6afeae6f2a$var$minimal_1.default.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c8a06e6afeae6f2a$var$minimal_1.default.Reader ? input : new $c8a06e6afeae6f2a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryTallyResultRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryTallyResultRequest);
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $c8a06e6afeae6f2a$var$long_1.default.fromString(object.proposalId) : $c8a06e6afeae6f2a$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $c8a06e6afeae6f2a$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryTallyResultRequest);
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $c8a06e6afeae6f2a$var$long_1.default.fromValue(object.proposalId) : $c8a06e6afeae6f2a$var$long_1.default.UZERO;
        return message;
    }
};
const $c8a06e6afeae6f2a$var$baseQueryTallyResultResponse = {};
$c8a06e6afeae6f2a$exports.QueryTallyResultResponse = {
    encode (message, writer = $c8a06e6afeae6f2a$var$minimal_1.default.Writer.create()) {
        if (message.tally !== undefined) $7595a8a64e79a70f$exports.TallyResult.encode(message.tally, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c8a06e6afeae6f2a$var$minimal_1.default.Reader ? input : new $c8a06e6afeae6f2a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryTallyResultResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.tally = $7595a8a64e79a70f$exports.TallyResult.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryTallyResultResponse);
        message.tally = object.tally !== undefined && object.tally !== null ? $7595a8a64e79a70f$exports.TallyResult.fromJSON(object.tally) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.tally !== undefined && (obj.tally = message.tally ? $7595a8a64e79a70f$exports.TallyResult.toJSON(message.tally) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $c8a06e6afeae6f2a$var$baseQueryTallyResultResponse);
        message.tally = object.tally !== undefined && object.tally !== null ? $7595a8a64e79a70f$exports.TallyResult.fromPartial(object.tally) : undefined;
        return message;
    }
};
class $c8a06e6afeae6f2a$var$QueryClientImpl {
    Proposal(request) {
        const data = $c8a06e6afeae6f2a$exports.QueryProposalRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Proposal", data);
        return promise.then((data)=>$c8a06e6afeae6f2a$exports.QueryProposalResponse.decode(new $c8a06e6afeae6f2a$var$minimal_1.default.Reader(data)));
    }
    Proposals(request) {
        const data = $c8a06e6afeae6f2a$exports.QueryProposalsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Proposals", data);
        return promise.then((data)=>$c8a06e6afeae6f2a$exports.QueryProposalsResponse.decode(new $c8a06e6afeae6f2a$var$minimal_1.default.Reader(data)));
    }
    Vote(request) {
        const data = $c8a06e6afeae6f2a$exports.QueryVoteRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Vote", data);
        return promise.then((data)=>$c8a06e6afeae6f2a$exports.QueryVoteResponse.decode(new $c8a06e6afeae6f2a$var$minimal_1.default.Reader(data)));
    }
    Votes(request) {
        const data = $c8a06e6afeae6f2a$exports.QueryVotesRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Votes", data);
        return promise.then((data)=>$c8a06e6afeae6f2a$exports.QueryVotesResponse.decode(new $c8a06e6afeae6f2a$var$minimal_1.default.Reader(data)));
    }
    Params(request) {
        const data = $c8a06e6afeae6f2a$exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Params", data);
        return promise.then((data)=>$c8a06e6afeae6f2a$exports.QueryParamsResponse.decode(new $c8a06e6afeae6f2a$var$minimal_1.default.Reader(data)));
    }
    Deposit(request) {
        const data = $c8a06e6afeae6f2a$exports.QueryDepositRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Deposit", data);
        return promise.then((data)=>$c8a06e6afeae6f2a$exports.QueryDepositResponse.decode(new $c8a06e6afeae6f2a$var$minimal_1.default.Reader(data)));
    }
    Deposits(request) {
        const data = $c8a06e6afeae6f2a$exports.QueryDepositsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Deposits", data);
        return promise.then((data)=>$c8a06e6afeae6f2a$exports.QueryDepositsResponse.decode(new $c8a06e6afeae6f2a$var$minimal_1.default.Reader(data)));
    }
    TallyResult(request) {
        const data = $c8a06e6afeae6f2a$exports.QueryTallyResultRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "TallyResult", data);
        return promise.then((data)=>$c8a06e6afeae6f2a$exports.QueryTallyResultResponse.decode(new $c8a06e6afeae6f2a$var$minimal_1.default.Reader(data)));
    }
    constructor(rpc){
        this.rpc = rpc;
        this.Proposal = this.Proposal.bind(this);
        this.Proposals = this.Proposals.bind(this);
        this.Vote = this.Vote.bind(this);
        this.Votes = this.Votes.bind(this);
        this.Params = this.Params.bind(this);
        this.Deposit = this.Deposit.bind(this);
        this.Deposits = this.Deposits.bind(this);
        this.TallyResult = this.TallyResult.bind(this);
    }
}
$c8a06e6afeae6f2a$exports.QueryClientImpl = $c8a06e6afeae6f2a$var$QueryClientImpl;
if ($c8a06e6afeae6f2a$var$minimal_1.default.util.Long !== $c8a06e6afeae6f2a$var$long_1.default) {
    $c8a06e6afeae6f2a$var$minimal_1.default.util.Long = $c8a06e6afeae6f2a$var$long_1.default;
    $c8a06e6afeae6f2a$var$minimal_1.default.configure();
}



function $058d229376aa4532$var$setupGovExtension(base) {
    const rpc = (0, $ffdede50deec576f$exports.createProtobufRpcClient)(base);
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const queryService = new $c8a06e6afeae6f2a$exports.QueryClientImpl(rpc);
    return {
        gov: {
            params: async (parametersType)=>{
                const response = await queryService.Params({
                    paramsType: parametersType
                });
                return response;
            },
            proposals: async (proposalStatus, depositorAddress, voterAddress, paginationKey)=>{
                const response = await queryService.Proposals({
                    proposalStatus: proposalStatus,
                    depositor: depositorAddress,
                    voter: voterAddress,
                    pagination: (0, $ffdede50deec576f$exports.createPagination)(paginationKey)
                });
                return response;
            },
            proposal: async (proposalId)=>{
                const response = await queryService.Proposal({
                    proposalId: (0, $ffdede50deec576f$exports.longify)(proposalId)
                });
                return response;
            },
            deposits: async (proposalId, paginationKey)=>{
                const response = await queryService.Deposits({
                    proposalId: (0, $ffdede50deec576f$exports.longify)(proposalId),
                    pagination: (0, $ffdede50deec576f$exports.createPagination)(paginationKey)
                });
                return response;
            },
            deposit: async (proposalId, depositorAddress)=>{
                const response = await queryService.Deposit({
                    proposalId: (0, $ffdede50deec576f$exports.longify)(proposalId),
                    depositor: depositorAddress
                });
                return response;
            },
            tally: async (proposalId)=>{
                const response = await queryService.TallyResult({
                    proposalId: (0, $ffdede50deec576f$exports.longify)(proposalId)
                });
                return response;
            },
            votes: async (proposalId, paginationKey)=>{
                const response = await queryService.Votes({
                    proposalId: (0, $ffdede50deec576f$exports.longify)(proposalId),
                    pagination: (0, $ffdede50deec576f$exports.createPagination)(paginationKey)
                });
                return response;
            },
            vote: async (proposalId, voterAddress)=>{
                const response = await queryService.Vote({
                    proposalId: (0, $ffdede50deec576f$exports.longify)(proposalId),
                    voter: voterAddress
                });
                return response;
            }
        }
    };
}
$058d229376aa4532$exports.setupGovExtension = $058d229376aa4532$var$setupGovExtension;


Object.defineProperty($7725f2e3ca016b52$exports, "setupGovExtension", {
    enumerable: true,
    get: function() {
        return $058d229376aa4532$exports.setupGovExtension;
    }
});
var $bbb7f66f7657521b$exports = {};
"use strict";
var $bbb7f66f7657521b$var$__importDefault = $bbb7f66f7657521b$exports && $bbb7f66f7657521b$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($bbb7f66f7657521b$exports, "__esModule", {
    value: true
});
$bbb7f66f7657521b$exports.createIbcAminoConverters = $bbb7f66f7657521b$exports.isAminoMsgTransfer = void 0;

const $bbb7f66f7657521b$var$long_1 = $bbb7f66f7657521b$var$__importDefault((parcelRequire("9A55m")));
function $bbb7f66f7657521b$var$isAminoMsgTransfer(msg) {
    return msg.type === "cosmos-sdk/MsgTransfer";
}
$bbb7f66f7657521b$exports.isAminoMsgTransfer = $bbb7f66f7657521b$var$isAminoMsgTransfer;
function $bbb7f66f7657521b$var$omitDefault(input) {
    if (typeof input === "string") return input === "" ? undefined : input;
    if (typeof input === "number") return input === 0 ? undefined : input;
    if ($bbb7f66f7657521b$var$long_1.default.isLong(input)) return input.isZero() ? undefined : input;
    throw new Error(`Got unsupported type '${typeof input}'`);
}
function $bbb7f66f7657521b$var$createIbcAminoConverters() {
    return {
        "/ibc.applications.transfer.v1.MsgTransfer": {
            aminoType: "cosmos-sdk/MsgTransfer",
            toAmino: ({ sourcePort: sourcePort, sourceChannel: sourceChannel, token: token, sender: sender, receiver: receiver, timeoutHeight: timeoutHeight, timeoutTimestamp: timeoutTimestamp })=>{
                var _a, _b, _c;
                return {
                    source_port: sourcePort,
                    source_channel: sourceChannel,
                    token: token,
                    sender: sender,
                    receiver: receiver,
                    timeout_height: timeoutHeight ? {
                        revision_height: (_a = $bbb7f66f7657521b$var$omitDefault(timeoutHeight.revisionHeight)) === null || _a === void 0 ? void 0 : _a.toString(),
                        revision_number: (_b = $bbb7f66f7657521b$var$omitDefault(timeoutHeight.revisionNumber)) === null || _b === void 0 ? void 0 : _b.toString()
                    } : {},
                    timeout_timestamp: (_c = $bbb7f66f7657521b$var$omitDefault(timeoutTimestamp)) === null || _c === void 0 ? void 0 : _c.toString()
                };
            },
            fromAmino: ({ source_port: source_port, source_channel: source_channel, token: token, sender: sender, receiver: receiver, timeout_height: timeout_height, timeout_timestamp: timeout_timestamp })=>({
                    sourcePort: source_port,
                    sourceChannel: source_channel,
                    token: token,
                    sender: sender,
                    receiver: receiver,
                    timeoutHeight: timeout_height ? {
                        revisionHeight: $bbb7f66f7657521b$var$long_1.default.fromString(timeout_height.revision_height || "0", true),
                        revisionNumber: $bbb7f66f7657521b$var$long_1.default.fromString(timeout_height.revision_number || "0", true)
                    } : undefined,
                    timeoutTimestamp: $bbb7f66f7657521b$var$long_1.default.fromString(timeout_timestamp || "0", true)
                })
        }
    };
}
$bbb7f66f7657521b$exports.createIbcAminoConverters = $bbb7f66f7657521b$var$createIbcAminoConverters;


Object.defineProperty($7725f2e3ca016b52$exports, "createIbcAminoConverters", {
    enumerable: true,
    get: function() {
        return $bbb7f66f7657521b$exports.createIbcAminoConverters;
    }
});
Object.defineProperty($7725f2e3ca016b52$exports, "isAminoMsgTransfer", {
    enumerable: true,
    get: function() {
        return $bbb7f66f7657521b$exports.isAminoMsgTransfer;
    }
});
var $cc1ee4a35ebc4a44$exports = {};
"use strict";
Object.defineProperty($cc1ee4a35ebc4a44$exports, "__esModule", {
    value: true
});
$cc1ee4a35ebc4a44$exports.isMsgTransferEncodeObject = $cc1ee4a35ebc4a44$exports.ibcTypes = void 0;
var $1f4036e8aebd4a0e$exports = {};
"use strict";
var $1f4036e8aebd4a0e$var$__importDefault = $1f4036e8aebd4a0e$exports && $1f4036e8aebd4a0e$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($1f4036e8aebd4a0e$exports, "__esModule", {
    value: true
});
$1f4036e8aebd4a0e$exports.MsgClientImpl = $1f4036e8aebd4a0e$exports.MsgTransferResponse = $1f4036e8aebd4a0e$exports.MsgTransfer = $1f4036e8aebd4a0e$exports.protobufPackage = void 0;

/* eslint-disable */ const $1f4036e8aebd4a0e$var$long_1 = $1f4036e8aebd4a0e$var$__importDefault((parcelRequire("9A55m")));

const $1f4036e8aebd4a0e$var$minimal_1 = $1f4036e8aebd4a0e$var$__importDefault((parcelRequire("i2pIU")));

var $0935332a1587f29e$exports = {};
"use strict";
var $0935332a1587f29e$var$__importDefault = $0935332a1587f29e$exports && $0935332a1587f29e$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($0935332a1587f29e$exports, "__esModule", {
    value: true
});
$0935332a1587f29e$exports.Params = $0935332a1587f29e$exports.Height = $0935332a1587f29e$exports.ClientUpdateProposal = $0935332a1587f29e$exports.ClientConsensusStates = $0935332a1587f29e$exports.ConsensusStateWithHeight = $0935332a1587f29e$exports.IdentifiedClientState = $0935332a1587f29e$exports.protobufPackage = void 0;

/* eslint-disable */ const $0935332a1587f29e$var$long_1 = $0935332a1587f29e$var$__importDefault((parcelRequire("9A55m")));

const $0935332a1587f29e$var$minimal_1 = $0935332a1587f29e$var$__importDefault((parcelRequire("i2pIU")));

$0935332a1587f29e$exports.protobufPackage = "ibc.core.client.v1";
const $0935332a1587f29e$var$baseIdentifiedClientState = {
    clientId: ""
};
$0935332a1587f29e$exports.IdentifiedClientState = {
    encode (message, writer = $0935332a1587f29e$var$minimal_1.default.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.clientState !== undefined) $4232fce010c3a46b$exports.Any.encode(message.clientState, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0935332a1587f29e$var$minimal_1.default.Reader ? input : new $0935332a1587f29e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $0935332a1587f29e$var$baseIdentifiedClientState);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.clientState = $4232fce010c3a46b$exports.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $0935332a1587f29e$var$baseIdentifiedClientState);
        message.clientId = object.clientId !== undefined && object.clientId !== null ? String(object.clientId) : "";
        message.clientState = object.clientState !== undefined && object.clientState !== null ? $4232fce010c3a46b$exports.Any.fromJSON(object.clientState) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.clientState !== undefined && (obj.clientState = message.clientState ? $4232fce010c3a46b$exports.Any.toJSON(message.clientState) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $0935332a1587f29e$var$baseIdentifiedClientState);
        message.clientId = (_a = object.clientId) !== null && _a !== void 0 ? _a : "";
        message.clientState = object.clientState !== undefined && object.clientState !== null ? $4232fce010c3a46b$exports.Any.fromPartial(object.clientState) : undefined;
        return message;
    }
};
const $0935332a1587f29e$var$baseConsensusStateWithHeight = {};
$0935332a1587f29e$exports.ConsensusStateWithHeight = {
    encode (message, writer = $0935332a1587f29e$var$minimal_1.default.Writer.create()) {
        if (message.height !== undefined) $0935332a1587f29e$exports.Height.encode(message.height, writer.uint32(10).fork()).ldelim();
        if (message.consensusState !== undefined) $4232fce010c3a46b$exports.Any.encode(message.consensusState, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0935332a1587f29e$var$minimal_1.default.Reader ? input : new $0935332a1587f29e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $0935332a1587f29e$var$baseConsensusStateWithHeight);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = $0935332a1587f29e$exports.Height.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.consensusState = $4232fce010c3a46b$exports.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $0935332a1587f29e$var$baseConsensusStateWithHeight);
        message.height = object.height !== undefined && object.height !== null ? $0935332a1587f29e$exports.Height.fromJSON(object.height) : undefined;
        message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? $4232fce010c3a46b$exports.Any.fromJSON(object.consensusState) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = message.height ? $0935332a1587f29e$exports.Height.toJSON(message.height) : undefined);
        message.consensusState !== undefined && (obj.consensusState = message.consensusState ? $4232fce010c3a46b$exports.Any.toJSON(message.consensusState) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $0935332a1587f29e$var$baseConsensusStateWithHeight);
        message.height = object.height !== undefined && object.height !== null ? $0935332a1587f29e$exports.Height.fromPartial(object.height) : undefined;
        message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? $4232fce010c3a46b$exports.Any.fromPartial(object.consensusState) : undefined;
        return message;
    }
};
const $0935332a1587f29e$var$baseClientConsensusStates = {
    clientId: ""
};
$0935332a1587f29e$exports.ClientConsensusStates = {
    encode (message, writer = $0935332a1587f29e$var$minimal_1.default.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        for (const v of message.consensusStates)$0935332a1587f29e$exports.ConsensusStateWithHeight.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0935332a1587f29e$var$minimal_1.default.Reader ? input : new $0935332a1587f29e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $0935332a1587f29e$var$baseClientConsensusStates);
        message.consensusStates = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.consensusStates.push($0935332a1587f29e$exports.ConsensusStateWithHeight.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $0935332a1587f29e$var$baseClientConsensusStates);
        message.clientId = object.clientId !== undefined && object.clientId !== null ? String(object.clientId) : "";
        message.consensusStates = ((_a = object.consensusStates) !== null && _a !== void 0 ? _a : []).map((e)=>$0935332a1587f29e$exports.ConsensusStateWithHeight.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        if (message.consensusStates) obj.consensusStates = message.consensusStates.map((e)=>e ? $0935332a1587f29e$exports.ConsensusStateWithHeight.toJSON(e) : undefined);
        else obj.consensusStates = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $0935332a1587f29e$var$baseClientConsensusStates);
        message.clientId = (_a = object.clientId) !== null && _a !== void 0 ? _a : "";
        message.consensusStates = ((_b = object.consensusStates) === null || _b === void 0 ? void 0 : _b.map((e)=>$0935332a1587f29e$exports.ConsensusStateWithHeight.fromPartial(e))) || [];
        return message;
    }
};
const $0935332a1587f29e$var$baseClientUpdateProposal = {
    title: "",
    description: "",
    clientId: ""
};
$0935332a1587f29e$exports.ClientUpdateProposal = {
    encode (message, writer = $0935332a1587f29e$var$minimal_1.default.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        if (message.clientId !== "") writer.uint32(26).string(message.clientId);
        if (message.header !== undefined) $4232fce010c3a46b$exports.Any.encode(message.header, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0935332a1587f29e$var$minimal_1.default.Reader ? input : new $0935332a1587f29e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $0935332a1587f29e$var$baseClientUpdateProposal);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.clientId = reader.string();
                    break;
                case 4:
                    message.header = $4232fce010c3a46b$exports.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $0935332a1587f29e$var$baseClientUpdateProposal);
        message.title = object.title !== undefined && object.title !== null ? String(object.title) : "";
        message.description = object.description !== undefined && object.description !== null ? String(object.description) : "";
        message.clientId = object.clientId !== undefined && object.clientId !== null ? String(object.clientId) : "";
        message.header = object.header !== undefined && object.header !== null ? $4232fce010c3a46b$exports.Any.fromJSON(object.header) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.header !== undefined && (obj.header = message.header ? $4232fce010c3a46b$exports.Any.toJSON(message.header) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $0935332a1587f29e$var$baseClientUpdateProposal);
        message.title = (_a = object.title) !== null && _a !== void 0 ? _a : "";
        message.description = (_b = object.description) !== null && _b !== void 0 ? _b : "";
        message.clientId = (_c = object.clientId) !== null && _c !== void 0 ? _c : "";
        message.header = object.header !== undefined && object.header !== null ? $4232fce010c3a46b$exports.Any.fromPartial(object.header) : undefined;
        return message;
    }
};
const $0935332a1587f29e$var$baseHeight = {
    revisionNumber: $0935332a1587f29e$var$long_1.default.UZERO,
    revisionHeight: $0935332a1587f29e$var$long_1.default.UZERO
};
$0935332a1587f29e$exports.Height = {
    encode (message, writer = $0935332a1587f29e$var$minimal_1.default.Writer.create()) {
        if (!message.revisionNumber.isZero()) writer.uint32(8).uint64(message.revisionNumber);
        if (!message.revisionHeight.isZero()) writer.uint32(16).uint64(message.revisionHeight);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0935332a1587f29e$var$minimal_1.default.Reader ? input : new $0935332a1587f29e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $0935332a1587f29e$var$baseHeight);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.revisionNumber = reader.uint64();
                    break;
                case 2:
                    message.revisionHeight = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $0935332a1587f29e$var$baseHeight);
        message.revisionNumber = object.revisionNumber !== undefined && object.revisionNumber !== null ? $0935332a1587f29e$var$long_1.default.fromString(object.revisionNumber) : $0935332a1587f29e$var$long_1.default.UZERO;
        message.revisionHeight = object.revisionHeight !== undefined && object.revisionHeight !== null ? $0935332a1587f29e$var$long_1.default.fromString(object.revisionHeight) : $0935332a1587f29e$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.revisionNumber !== undefined && (obj.revisionNumber = (message.revisionNumber || $0935332a1587f29e$var$long_1.default.UZERO).toString());
        message.revisionHeight !== undefined && (obj.revisionHeight = (message.revisionHeight || $0935332a1587f29e$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $0935332a1587f29e$var$baseHeight);
        message.revisionNumber = object.revisionNumber !== undefined && object.revisionNumber !== null ? $0935332a1587f29e$var$long_1.default.fromValue(object.revisionNumber) : $0935332a1587f29e$var$long_1.default.UZERO;
        message.revisionHeight = object.revisionHeight !== undefined && object.revisionHeight !== null ? $0935332a1587f29e$var$long_1.default.fromValue(object.revisionHeight) : $0935332a1587f29e$var$long_1.default.UZERO;
        return message;
    }
};
const $0935332a1587f29e$var$baseParams = {
    allowedClients: ""
};
$0935332a1587f29e$exports.Params = {
    encode (message, writer = $0935332a1587f29e$var$minimal_1.default.Writer.create()) {
        for (const v of message.allowedClients)writer.uint32(10).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0935332a1587f29e$var$minimal_1.default.Reader ? input : new $0935332a1587f29e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $0935332a1587f29e$var$baseParams);
        message.allowedClients = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.allowedClients.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $0935332a1587f29e$var$baseParams);
        message.allowedClients = ((_a = object.allowedClients) !== null && _a !== void 0 ? _a : []).map((e)=>String(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.allowedClients) obj.allowedClients = message.allowedClients.map((e)=>e);
        else obj.allowedClients = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $0935332a1587f29e$var$baseParams);
        message.allowedClients = ((_a = object.allowedClients) === null || _a === void 0 ? void 0 : _a.map((e)=>e)) || [];
        return message;
    }
};
if ($0935332a1587f29e$var$minimal_1.default.util.Long !== $0935332a1587f29e$var$long_1.default) {
    $0935332a1587f29e$var$minimal_1.default.util.Long = $0935332a1587f29e$var$long_1.default;
    $0935332a1587f29e$var$minimal_1.default.configure();
}


$1f4036e8aebd4a0e$exports.protobufPackage = "ibc.applications.transfer.v1";
const $1f4036e8aebd4a0e$var$baseMsgTransfer = {
    sourcePort: "",
    sourceChannel: "",
    sender: "",
    receiver: "",
    timeoutTimestamp: $1f4036e8aebd4a0e$var$long_1.default.UZERO
};
$1f4036e8aebd4a0e$exports.MsgTransfer = {
    encode (message, writer = $1f4036e8aebd4a0e$var$minimal_1.default.Writer.create()) {
        if (message.sourcePort !== "") writer.uint32(10).string(message.sourcePort);
        if (message.sourceChannel !== "") writer.uint32(18).string(message.sourceChannel);
        if (message.token !== undefined) $82ef09d1a8e2224d$exports.Coin.encode(message.token, writer.uint32(26).fork()).ldelim();
        if (message.sender !== "") writer.uint32(34).string(message.sender);
        if (message.receiver !== "") writer.uint32(42).string(message.receiver);
        if (message.timeoutHeight !== undefined) $0935332a1587f29e$exports.Height.encode(message.timeoutHeight, writer.uint32(50).fork()).ldelim();
        if (!message.timeoutTimestamp.isZero()) writer.uint32(56).uint64(message.timeoutTimestamp);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1f4036e8aebd4a0e$var$minimal_1.default.Reader ? input : new $1f4036e8aebd4a0e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $1f4036e8aebd4a0e$var$baseMsgTransfer);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sourcePort = reader.string();
                    break;
                case 2:
                    message.sourceChannel = reader.string();
                    break;
                case 3:
                    message.token = $82ef09d1a8e2224d$exports.Coin.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.sender = reader.string();
                    break;
                case 5:
                    message.receiver = reader.string();
                    break;
                case 6:
                    message.timeoutHeight = $0935332a1587f29e$exports.Height.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.timeoutTimestamp = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $1f4036e8aebd4a0e$var$baseMsgTransfer);
        message.sourcePort = object.sourcePort !== undefined && object.sourcePort !== null ? String(object.sourcePort) : "";
        message.sourceChannel = object.sourceChannel !== undefined && object.sourceChannel !== null ? String(object.sourceChannel) : "";
        message.token = object.token !== undefined && object.token !== null ? $82ef09d1a8e2224d$exports.Coin.fromJSON(object.token) : undefined;
        message.sender = object.sender !== undefined && object.sender !== null ? String(object.sender) : "";
        message.receiver = object.receiver !== undefined && object.receiver !== null ? String(object.receiver) : "";
        message.timeoutHeight = object.timeoutHeight !== undefined && object.timeoutHeight !== null ? $0935332a1587f29e$exports.Height.fromJSON(object.timeoutHeight) : undefined;
        message.timeoutTimestamp = object.timeoutTimestamp !== undefined && object.timeoutTimestamp !== null ? $1f4036e8aebd4a0e$var$long_1.default.fromString(object.timeoutTimestamp) : $1f4036e8aebd4a0e$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.sourcePort !== undefined && (obj.sourcePort = message.sourcePort);
        message.sourceChannel !== undefined && (obj.sourceChannel = message.sourceChannel);
        message.token !== undefined && (obj.token = message.token ? $82ef09d1a8e2224d$exports.Coin.toJSON(message.token) : undefined);
        message.sender !== undefined && (obj.sender = message.sender);
        message.receiver !== undefined && (obj.receiver = message.receiver);
        message.timeoutHeight !== undefined && (obj.timeoutHeight = message.timeoutHeight ? $0935332a1587f29e$exports.Height.toJSON(message.timeoutHeight) : undefined);
        message.timeoutTimestamp !== undefined && (obj.timeoutTimestamp = (message.timeoutTimestamp || $1f4036e8aebd4a0e$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = Object.assign({}, $1f4036e8aebd4a0e$var$baseMsgTransfer);
        message.sourcePort = (_a = object.sourcePort) !== null && _a !== void 0 ? _a : "";
        message.sourceChannel = (_b = object.sourceChannel) !== null && _b !== void 0 ? _b : "";
        message.token = object.token !== undefined && object.token !== null ? $82ef09d1a8e2224d$exports.Coin.fromPartial(object.token) : undefined;
        message.sender = (_c = object.sender) !== null && _c !== void 0 ? _c : "";
        message.receiver = (_d = object.receiver) !== null && _d !== void 0 ? _d : "";
        message.timeoutHeight = object.timeoutHeight !== undefined && object.timeoutHeight !== null ? $0935332a1587f29e$exports.Height.fromPartial(object.timeoutHeight) : undefined;
        message.timeoutTimestamp = object.timeoutTimestamp !== undefined && object.timeoutTimestamp !== null ? $1f4036e8aebd4a0e$var$long_1.default.fromValue(object.timeoutTimestamp) : $1f4036e8aebd4a0e$var$long_1.default.UZERO;
        return message;
    }
};
const $1f4036e8aebd4a0e$var$baseMsgTransferResponse = {};
$1f4036e8aebd4a0e$exports.MsgTransferResponse = {
    encode (_, writer = $1f4036e8aebd4a0e$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1f4036e8aebd4a0e$var$minimal_1.default.Reader ? input : new $1f4036e8aebd4a0e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $1f4036e8aebd4a0e$var$baseMsgTransferResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $1f4036e8aebd4a0e$var$baseMsgTransferResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $1f4036e8aebd4a0e$var$baseMsgTransferResponse);
        return message;
    }
};
class $1f4036e8aebd4a0e$var$MsgClientImpl {
    Transfer(request) {
        const data = $1f4036e8aebd4a0e$exports.MsgTransfer.encode(request).finish();
        const promise = this.rpc.request("ibc.applications.transfer.v1.Msg", "Transfer", data);
        return promise.then((data)=>$1f4036e8aebd4a0e$exports.MsgTransferResponse.decode(new $1f4036e8aebd4a0e$var$minimal_1.default.Reader(data)));
    }
    constructor(rpc){
        this.rpc = rpc;
        this.Transfer = this.Transfer.bind(this);
    }
}
$1f4036e8aebd4a0e$exports.MsgClientImpl = $1f4036e8aebd4a0e$var$MsgClientImpl;
if ($1f4036e8aebd4a0e$var$minimal_1.default.util.Long !== $1f4036e8aebd4a0e$var$long_1.default) {
    $1f4036e8aebd4a0e$var$minimal_1.default.util.Long = $1f4036e8aebd4a0e$var$long_1.default;
    $1f4036e8aebd4a0e$var$minimal_1.default.configure();
}


var $68521e6ff41dbbae$exports = {};
"use strict";
var $68521e6ff41dbbae$var$__importDefault = $68521e6ff41dbbae$exports && $68521e6ff41dbbae$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($68521e6ff41dbbae$exports, "__esModule", {
    value: true
});
$68521e6ff41dbbae$exports.MsgClientImpl = $68521e6ff41dbbae$exports.MsgAcknowledgementResponse = $68521e6ff41dbbae$exports.MsgAcknowledgement = $68521e6ff41dbbae$exports.MsgTimeoutOnCloseResponse = $68521e6ff41dbbae$exports.MsgTimeoutOnClose = $68521e6ff41dbbae$exports.MsgTimeoutResponse = $68521e6ff41dbbae$exports.MsgTimeout = $68521e6ff41dbbae$exports.MsgRecvPacketResponse = $68521e6ff41dbbae$exports.MsgRecvPacket = $68521e6ff41dbbae$exports.MsgChannelCloseConfirmResponse = $68521e6ff41dbbae$exports.MsgChannelCloseConfirm = $68521e6ff41dbbae$exports.MsgChannelCloseInitResponse = $68521e6ff41dbbae$exports.MsgChannelCloseInit = $68521e6ff41dbbae$exports.MsgChannelOpenConfirmResponse = $68521e6ff41dbbae$exports.MsgChannelOpenConfirm = $68521e6ff41dbbae$exports.MsgChannelOpenAckResponse = $68521e6ff41dbbae$exports.MsgChannelOpenAck = $68521e6ff41dbbae$exports.MsgChannelOpenTryResponse = $68521e6ff41dbbae$exports.MsgChannelOpenTry = $68521e6ff41dbbae$exports.MsgChannelOpenInitResponse = $68521e6ff41dbbae$exports.MsgChannelOpenInit = $68521e6ff41dbbae$exports.protobufPackage = void 0;

/* eslint-disable */ const $68521e6ff41dbbae$var$long_1 = $68521e6ff41dbbae$var$__importDefault((parcelRequire("9A55m")));

const $68521e6ff41dbbae$var$minimal_1 = $68521e6ff41dbbae$var$__importDefault((parcelRequire("i2pIU")));
var $b98b08f8901f4c6b$exports = {};
"use strict";
var $b98b08f8901f4c6b$var$__importDefault = $b98b08f8901f4c6b$exports && $b98b08f8901f4c6b$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($b98b08f8901f4c6b$exports, "__esModule", {
    value: true
});
$b98b08f8901f4c6b$exports.Acknowledgement = $b98b08f8901f4c6b$exports.PacketState = $b98b08f8901f4c6b$exports.Packet = $b98b08f8901f4c6b$exports.Counterparty = $b98b08f8901f4c6b$exports.IdentifiedChannel = $b98b08f8901f4c6b$exports.Channel = $b98b08f8901f4c6b$exports.orderToJSON = $b98b08f8901f4c6b$exports.orderFromJSON = $b98b08f8901f4c6b$exports.Order = $b98b08f8901f4c6b$exports.stateToJSON = $b98b08f8901f4c6b$exports.stateFromJSON = $b98b08f8901f4c6b$exports.State = $b98b08f8901f4c6b$exports.protobufPackage = void 0;

/* eslint-disable */ const $b98b08f8901f4c6b$var$long_1 = $b98b08f8901f4c6b$var$__importDefault((parcelRequire("9A55m")));

const $b98b08f8901f4c6b$var$minimal_1 = $b98b08f8901f4c6b$var$__importDefault((parcelRequire("i2pIU")));

$b98b08f8901f4c6b$exports.protobufPackage = "ibc.core.channel.v1";
/**
 * State defines if a channel is in one of the following states:
 * CLOSED, INIT, TRYOPEN, OPEN or UNINITIALIZED.
 */ var $b98b08f8901f4c6b$var$State;
(function(State) {
    /** STATE_UNINITIALIZED_UNSPECIFIED - Default State */ State[State["STATE_UNINITIALIZED_UNSPECIFIED"] = 0] = "STATE_UNINITIALIZED_UNSPECIFIED";
    /** STATE_INIT - A channel has just started the opening handshake. */ State[State["STATE_INIT"] = 1] = "STATE_INIT";
    /** STATE_TRYOPEN - A channel has acknowledged the handshake step on the counterparty chain. */ State[State["STATE_TRYOPEN"] = 2] = "STATE_TRYOPEN";
    /**
     * STATE_OPEN - A channel has completed the handshake. Open channels are
     * ready to send and receive packets.
     */ State[State["STATE_OPEN"] = 3] = "STATE_OPEN";
    /**
     * STATE_CLOSED - A channel has been closed and can no longer be used to send or receive
     * packets.
     */ State[State["STATE_CLOSED"] = 4] = "STATE_CLOSED";
    State[State["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($b98b08f8901f4c6b$var$State = $b98b08f8901f4c6b$exports.State || ($b98b08f8901f4c6b$exports.State = {}));
function $b98b08f8901f4c6b$var$stateFromJSON(object) {
    switch(object){
        case 0:
        case "STATE_UNINITIALIZED_UNSPECIFIED":
            return $b98b08f8901f4c6b$var$State.STATE_UNINITIALIZED_UNSPECIFIED;
        case 1:
        case "STATE_INIT":
            return $b98b08f8901f4c6b$var$State.STATE_INIT;
        case 2:
        case "STATE_TRYOPEN":
            return $b98b08f8901f4c6b$var$State.STATE_TRYOPEN;
        case 3:
        case "STATE_OPEN":
            return $b98b08f8901f4c6b$var$State.STATE_OPEN;
        case 4:
        case "STATE_CLOSED":
            return $b98b08f8901f4c6b$var$State.STATE_CLOSED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $b98b08f8901f4c6b$var$State.UNRECOGNIZED;
    }
}
$b98b08f8901f4c6b$exports.stateFromJSON = $b98b08f8901f4c6b$var$stateFromJSON;
function $b98b08f8901f4c6b$var$stateToJSON(object) {
    switch(object){
        case $b98b08f8901f4c6b$var$State.STATE_UNINITIALIZED_UNSPECIFIED:
            return "STATE_UNINITIALIZED_UNSPECIFIED";
        case $b98b08f8901f4c6b$var$State.STATE_INIT:
            return "STATE_INIT";
        case $b98b08f8901f4c6b$var$State.STATE_TRYOPEN:
            return "STATE_TRYOPEN";
        case $b98b08f8901f4c6b$var$State.STATE_OPEN:
            return "STATE_OPEN";
        case $b98b08f8901f4c6b$var$State.STATE_CLOSED:
            return "STATE_CLOSED";
        default:
            return "UNKNOWN";
    }
}
$b98b08f8901f4c6b$exports.stateToJSON = $b98b08f8901f4c6b$var$stateToJSON;
/** Order defines if a channel is ORDERED or UNORDERED */ var $b98b08f8901f4c6b$var$Order;
(function(Order) {
    /** ORDER_NONE_UNSPECIFIED - zero-value for channel ordering */ Order[Order["ORDER_NONE_UNSPECIFIED"] = 0] = "ORDER_NONE_UNSPECIFIED";
    /**
     * ORDER_UNORDERED - packets can be delivered in any order, which may differ from the order in
     * which they were sent.
     */ Order[Order["ORDER_UNORDERED"] = 1] = "ORDER_UNORDERED";
    /** ORDER_ORDERED - packets are delivered exactly in the order which they were sent */ Order[Order["ORDER_ORDERED"] = 2] = "ORDER_ORDERED";
    Order[Order["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($b98b08f8901f4c6b$var$Order = $b98b08f8901f4c6b$exports.Order || ($b98b08f8901f4c6b$exports.Order = {}));
function $b98b08f8901f4c6b$var$orderFromJSON(object) {
    switch(object){
        case 0:
        case "ORDER_NONE_UNSPECIFIED":
            return $b98b08f8901f4c6b$var$Order.ORDER_NONE_UNSPECIFIED;
        case 1:
        case "ORDER_UNORDERED":
            return $b98b08f8901f4c6b$var$Order.ORDER_UNORDERED;
        case 2:
        case "ORDER_ORDERED":
            return $b98b08f8901f4c6b$var$Order.ORDER_ORDERED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $b98b08f8901f4c6b$var$Order.UNRECOGNIZED;
    }
}
$b98b08f8901f4c6b$exports.orderFromJSON = $b98b08f8901f4c6b$var$orderFromJSON;
function $b98b08f8901f4c6b$var$orderToJSON(object) {
    switch(object){
        case $b98b08f8901f4c6b$var$Order.ORDER_NONE_UNSPECIFIED:
            return "ORDER_NONE_UNSPECIFIED";
        case $b98b08f8901f4c6b$var$Order.ORDER_UNORDERED:
            return "ORDER_UNORDERED";
        case $b98b08f8901f4c6b$var$Order.ORDER_ORDERED:
            return "ORDER_ORDERED";
        default:
            return "UNKNOWN";
    }
}
$b98b08f8901f4c6b$exports.orderToJSON = $b98b08f8901f4c6b$var$orderToJSON;
const $b98b08f8901f4c6b$var$baseChannel = {
    state: 0,
    ordering: 0,
    connectionHops: "",
    version: ""
};
$b98b08f8901f4c6b$exports.Channel = {
    encode (message, writer = $b98b08f8901f4c6b$var$minimal_1.default.Writer.create()) {
        if (message.state !== 0) writer.uint32(8).int32(message.state);
        if (message.ordering !== 0) writer.uint32(16).int32(message.ordering);
        if (message.counterparty !== undefined) $b98b08f8901f4c6b$exports.Counterparty.encode(message.counterparty, writer.uint32(26).fork()).ldelim();
        for (const v of message.connectionHops)writer.uint32(34).string(v);
        if (message.version !== "") writer.uint32(42).string(message.version);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b98b08f8901f4c6b$var$minimal_1.default.Reader ? input : new $b98b08f8901f4c6b$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b98b08f8901f4c6b$var$baseChannel);
        message.connectionHops = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.state = reader.int32();
                    break;
                case 2:
                    message.ordering = reader.int32();
                    break;
                case 3:
                    message.counterparty = $b98b08f8901f4c6b$exports.Counterparty.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.connectionHops.push(reader.string());
                    break;
                case 5:
                    message.version = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $b98b08f8901f4c6b$var$baseChannel);
        message.state = object.state !== undefined && object.state !== null ? $b98b08f8901f4c6b$var$stateFromJSON(object.state) : 0;
        message.ordering = object.ordering !== undefined && object.ordering !== null ? $b98b08f8901f4c6b$var$orderFromJSON(object.ordering) : 0;
        message.counterparty = object.counterparty !== undefined && object.counterparty !== null ? $b98b08f8901f4c6b$exports.Counterparty.fromJSON(object.counterparty) : undefined;
        message.connectionHops = ((_a = object.connectionHops) !== null && _a !== void 0 ? _a : []).map((e)=>String(e));
        message.version = object.version !== undefined && object.version !== null ? String(object.version) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.state !== undefined && (obj.state = $b98b08f8901f4c6b$var$stateToJSON(message.state));
        message.ordering !== undefined && (obj.ordering = $b98b08f8901f4c6b$var$orderToJSON(message.ordering));
        message.counterparty !== undefined && (obj.counterparty = message.counterparty ? $b98b08f8901f4c6b$exports.Counterparty.toJSON(message.counterparty) : undefined);
        if (message.connectionHops) obj.connectionHops = message.connectionHops.map((e)=>e);
        else obj.connectionHops = [];
        message.version !== undefined && (obj.version = message.version);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = Object.assign({}, $b98b08f8901f4c6b$var$baseChannel);
        message.state = (_a = object.state) !== null && _a !== void 0 ? _a : 0;
        message.ordering = (_b = object.ordering) !== null && _b !== void 0 ? _b : 0;
        message.counterparty = object.counterparty !== undefined && object.counterparty !== null ? $b98b08f8901f4c6b$exports.Counterparty.fromPartial(object.counterparty) : undefined;
        message.connectionHops = ((_c = object.connectionHops) === null || _c === void 0 ? void 0 : _c.map((e)=>e)) || [];
        message.version = (_d = object.version) !== null && _d !== void 0 ? _d : "";
        return message;
    }
};
const $b98b08f8901f4c6b$var$baseIdentifiedChannel = {
    state: 0,
    ordering: 0,
    connectionHops: "",
    version: "",
    portId: "",
    channelId: ""
};
$b98b08f8901f4c6b$exports.IdentifiedChannel = {
    encode (message, writer = $b98b08f8901f4c6b$var$minimal_1.default.Writer.create()) {
        if (message.state !== 0) writer.uint32(8).int32(message.state);
        if (message.ordering !== 0) writer.uint32(16).int32(message.ordering);
        if (message.counterparty !== undefined) $b98b08f8901f4c6b$exports.Counterparty.encode(message.counterparty, writer.uint32(26).fork()).ldelim();
        for (const v of message.connectionHops)writer.uint32(34).string(v);
        if (message.version !== "") writer.uint32(42).string(message.version);
        if (message.portId !== "") writer.uint32(50).string(message.portId);
        if (message.channelId !== "") writer.uint32(58).string(message.channelId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b98b08f8901f4c6b$var$minimal_1.default.Reader ? input : new $b98b08f8901f4c6b$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b98b08f8901f4c6b$var$baseIdentifiedChannel);
        message.connectionHops = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.state = reader.int32();
                    break;
                case 2:
                    message.ordering = reader.int32();
                    break;
                case 3:
                    message.counterparty = $b98b08f8901f4c6b$exports.Counterparty.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.connectionHops.push(reader.string());
                    break;
                case 5:
                    message.version = reader.string();
                    break;
                case 6:
                    message.portId = reader.string();
                    break;
                case 7:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $b98b08f8901f4c6b$var$baseIdentifiedChannel);
        message.state = object.state !== undefined && object.state !== null ? $b98b08f8901f4c6b$var$stateFromJSON(object.state) : 0;
        message.ordering = object.ordering !== undefined && object.ordering !== null ? $b98b08f8901f4c6b$var$orderFromJSON(object.ordering) : 0;
        message.counterparty = object.counterparty !== undefined && object.counterparty !== null ? $b98b08f8901f4c6b$exports.Counterparty.fromJSON(object.counterparty) : undefined;
        message.connectionHops = ((_a = object.connectionHops) !== null && _a !== void 0 ? _a : []).map((e)=>String(e));
        message.version = object.version !== undefined && object.version !== null ? String(object.version) : "";
        message.portId = object.portId !== undefined && object.portId !== null ? String(object.portId) : "";
        message.channelId = object.channelId !== undefined && object.channelId !== null ? String(object.channelId) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.state !== undefined && (obj.state = $b98b08f8901f4c6b$var$stateToJSON(message.state));
        message.ordering !== undefined && (obj.ordering = $b98b08f8901f4c6b$var$orderToJSON(message.ordering));
        message.counterparty !== undefined && (obj.counterparty = message.counterparty ? $b98b08f8901f4c6b$exports.Counterparty.toJSON(message.counterparty) : undefined);
        if (message.connectionHops) obj.connectionHops = message.connectionHops.map((e)=>e);
        else obj.connectionHops = [];
        message.version !== undefined && (obj.version = message.version);
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e, _f;
        const message = Object.assign({}, $b98b08f8901f4c6b$var$baseIdentifiedChannel);
        message.state = (_a = object.state) !== null && _a !== void 0 ? _a : 0;
        message.ordering = (_b = object.ordering) !== null && _b !== void 0 ? _b : 0;
        message.counterparty = object.counterparty !== undefined && object.counterparty !== null ? $b98b08f8901f4c6b$exports.Counterparty.fromPartial(object.counterparty) : undefined;
        message.connectionHops = ((_c = object.connectionHops) === null || _c === void 0 ? void 0 : _c.map((e)=>e)) || [];
        message.version = (_d = object.version) !== null && _d !== void 0 ? _d : "";
        message.portId = (_e = object.portId) !== null && _e !== void 0 ? _e : "";
        message.channelId = (_f = object.channelId) !== null && _f !== void 0 ? _f : "";
        return message;
    }
};
const $b98b08f8901f4c6b$var$baseCounterparty = {
    portId: "",
    channelId: ""
};
$b98b08f8901f4c6b$exports.Counterparty = {
    encode (message, writer = $b98b08f8901f4c6b$var$minimal_1.default.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b98b08f8901f4c6b$var$minimal_1.default.Reader ? input : new $b98b08f8901f4c6b$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b98b08f8901f4c6b$var$baseCounterparty);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $b98b08f8901f4c6b$var$baseCounterparty);
        message.portId = object.portId !== undefined && object.portId !== null ? String(object.portId) : "";
        message.channelId = object.channelId !== undefined && object.channelId !== null ? String(object.channelId) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $b98b08f8901f4c6b$var$baseCounterparty);
        message.portId = (_a = object.portId) !== null && _a !== void 0 ? _a : "";
        message.channelId = (_b = object.channelId) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
const $b98b08f8901f4c6b$var$basePacket = {
    sequence: $b98b08f8901f4c6b$var$long_1.default.UZERO,
    sourcePort: "",
    sourceChannel: "",
    destinationPort: "",
    destinationChannel: "",
    timeoutTimestamp: $b98b08f8901f4c6b$var$long_1.default.UZERO
};
$b98b08f8901f4c6b$exports.Packet = {
    encode (message, writer = $b98b08f8901f4c6b$var$minimal_1.default.Writer.create()) {
        if (!message.sequence.isZero()) writer.uint32(8).uint64(message.sequence);
        if (message.sourcePort !== "") writer.uint32(18).string(message.sourcePort);
        if (message.sourceChannel !== "") writer.uint32(26).string(message.sourceChannel);
        if (message.destinationPort !== "") writer.uint32(34).string(message.destinationPort);
        if (message.destinationChannel !== "") writer.uint32(42).string(message.destinationChannel);
        if (message.data.length !== 0) writer.uint32(50).bytes(message.data);
        if (message.timeoutHeight !== undefined) $0935332a1587f29e$exports.Height.encode(message.timeoutHeight, writer.uint32(58).fork()).ldelim();
        if (!message.timeoutTimestamp.isZero()) writer.uint32(64).uint64(message.timeoutTimestamp);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b98b08f8901f4c6b$var$minimal_1.default.Reader ? input : new $b98b08f8901f4c6b$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b98b08f8901f4c6b$var$basePacket);
        message.data = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sequence = reader.uint64();
                    break;
                case 2:
                    message.sourcePort = reader.string();
                    break;
                case 3:
                    message.sourceChannel = reader.string();
                    break;
                case 4:
                    message.destinationPort = reader.string();
                    break;
                case 5:
                    message.destinationChannel = reader.string();
                    break;
                case 6:
                    message.data = reader.bytes();
                    break;
                case 7:
                    message.timeoutHeight = $0935332a1587f29e$exports.Height.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.timeoutTimestamp = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $b98b08f8901f4c6b$var$basePacket);
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $b98b08f8901f4c6b$var$long_1.default.fromString(object.sequence) : $b98b08f8901f4c6b$var$long_1.default.UZERO;
        message.sourcePort = object.sourcePort !== undefined && object.sourcePort !== null ? String(object.sourcePort) : "";
        message.sourceChannel = object.sourceChannel !== undefined && object.sourceChannel !== null ? String(object.sourceChannel) : "";
        message.destinationPort = object.destinationPort !== undefined && object.destinationPort !== null ? String(object.destinationPort) : "";
        message.destinationChannel = object.destinationChannel !== undefined && object.destinationChannel !== null ? String(object.destinationChannel) : "";
        message.data = object.data !== undefined && object.data !== null ? $b98b08f8901f4c6b$var$bytesFromBase64(object.data) : new Uint8Array();
        message.timeoutHeight = object.timeoutHeight !== undefined && object.timeoutHeight !== null ? $0935332a1587f29e$exports.Height.fromJSON(object.timeoutHeight) : undefined;
        message.timeoutTimestamp = object.timeoutTimestamp !== undefined && object.timeoutTimestamp !== null ? $b98b08f8901f4c6b$var$long_1.default.fromString(object.timeoutTimestamp) : $b98b08f8901f4c6b$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.sequence !== undefined && (obj.sequence = (message.sequence || $b98b08f8901f4c6b$var$long_1.default.UZERO).toString());
        message.sourcePort !== undefined && (obj.sourcePort = message.sourcePort);
        message.sourceChannel !== undefined && (obj.sourceChannel = message.sourceChannel);
        message.destinationPort !== undefined && (obj.destinationPort = message.destinationPort);
        message.destinationChannel !== undefined && (obj.destinationChannel = message.destinationChannel);
        message.data !== undefined && (obj.data = $b98b08f8901f4c6b$var$base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        message.timeoutHeight !== undefined && (obj.timeoutHeight = message.timeoutHeight ? $0935332a1587f29e$exports.Height.toJSON(message.timeoutHeight) : undefined);
        message.timeoutTimestamp !== undefined && (obj.timeoutTimestamp = (message.timeoutTimestamp || $b98b08f8901f4c6b$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e;
        const message = Object.assign({}, $b98b08f8901f4c6b$var$basePacket);
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $b98b08f8901f4c6b$var$long_1.default.fromValue(object.sequence) : $b98b08f8901f4c6b$var$long_1.default.UZERO;
        message.sourcePort = (_a = object.sourcePort) !== null && _a !== void 0 ? _a : "";
        message.sourceChannel = (_b = object.sourceChannel) !== null && _b !== void 0 ? _b : "";
        message.destinationPort = (_c = object.destinationPort) !== null && _c !== void 0 ? _c : "";
        message.destinationChannel = (_d = object.destinationChannel) !== null && _d !== void 0 ? _d : "";
        message.data = (_e = object.data) !== null && _e !== void 0 ? _e : new Uint8Array();
        message.timeoutHeight = object.timeoutHeight !== undefined && object.timeoutHeight !== null ? $0935332a1587f29e$exports.Height.fromPartial(object.timeoutHeight) : undefined;
        message.timeoutTimestamp = object.timeoutTimestamp !== undefined && object.timeoutTimestamp !== null ? $b98b08f8901f4c6b$var$long_1.default.fromValue(object.timeoutTimestamp) : $b98b08f8901f4c6b$var$long_1.default.UZERO;
        return message;
    }
};
const $b98b08f8901f4c6b$var$basePacketState = {
    portId: "",
    channelId: "",
    sequence: $b98b08f8901f4c6b$var$long_1.default.UZERO
};
$b98b08f8901f4c6b$exports.PacketState = {
    encode (message, writer = $b98b08f8901f4c6b$var$minimal_1.default.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (!message.sequence.isZero()) writer.uint32(24).uint64(message.sequence);
        if (message.data.length !== 0) writer.uint32(34).bytes(message.data);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b98b08f8901f4c6b$var$minimal_1.default.Reader ? input : new $b98b08f8901f4c6b$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b98b08f8901f4c6b$var$basePacketState);
        message.data = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                case 4:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $b98b08f8901f4c6b$var$basePacketState);
        message.portId = object.portId !== undefined && object.portId !== null ? String(object.portId) : "";
        message.channelId = object.channelId !== undefined && object.channelId !== null ? String(object.channelId) : "";
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $b98b08f8901f4c6b$var$long_1.default.fromString(object.sequence) : $b98b08f8901f4c6b$var$long_1.default.UZERO;
        message.data = object.data !== undefined && object.data !== null ? $b98b08f8901f4c6b$var$bytesFromBase64(object.data) : new Uint8Array();
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.sequence !== undefined && (obj.sequence = (message.sequence || $b98b08f8901f4c6b$var$long_1.default.UZERO).toString());
        message.data !== undefined && (obj.data = $b98b08f8901f4c6b$var$base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $b98b08f8901f4c6b$var$basePacketState);
        message.portId = (_a = object.portId) !== null && _a !== void 0 ? _a : "";
        message.channelId = (_b = object.channelId) !== null && _b !== void 0 ? _b : "";
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $b98b08f8901f4c6b$var$long_1.default.fromValue(object.sequence) : $b98b08f8901f4c6b$var$long_1.default.UZERO;
        message.data = (_c = object.data) !== null && _c !== void 0 ? _c : new Uint8Array();
        return message;
    }
};
const $b98b08f8901f4c6b$var$baseAcknowledgement = {};
$b98b08f8901f4c6b$exports.Acknowledgement = {
    encode (message, writer = $b98b08f8901f4c6b$var$minimal_1.default.Writer.create()) {
        if (message.result !== undefined) writer.uint32(170).bytes(message.result);
        if (message.error !== undefined) writer.uint32(178).string(message.error);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b98b08f8901f4c6b$var$minimal_1.default.Reader ? input : new $b98b08f8901f4c6b$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b98b08f8901f4c6b$var$baseAcknowledgement);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 21:
                    message.result = reader.bytes();
                    break;
                case 22:
                    message.error = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $b98b08f8901f4c6b$var$baseAcknowledgement);
        message.result = object.result !== undefined && object.result !== null ? $b98b08f8901f4c6b$var$bytesFromBase64(object.result) : undefined;
        message.error = object.error !== undefined && object.error !== null ? String(object.error) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.result !== undefined && (obj.result = message.result !== undefined ? $b98b08f8901f4c6b$var$base64FromBytes(message.result) : undefined);
        message.error !== undefined && (obj.error = message.error);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $b98b08f8901f4c6b$var$baseAcknowledgement);
        message.result = (_a = object.result) !== null && _a !== void 0 ? _a : undefined;
        message.error = (_b = object.error) !== null && _b !== void 0 ? _b : undefined;
        return message;
    }
};
var $b98b08f8901f4c6b$var$globalThis = (()=>{
    if (typeof $b98b08f8901f4c6b$var$globalThis !== "undefined") return $b98b08f8901f4c6b$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $b98b08f8901f4c6b$var$atob = $b98b08f8901f4c6b$var$globalThis.atob || ((b64)=>$b98b08f8901f4c6b$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $b98b08f8901f4c6b$var$bytesFromBase64(b64) {
    const bin = $b98b08f8901f4c6b$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $b98b08f8901f4c6b$var$btoa = $b98b08f8901f4c6b$var$globalThis.btoa || ((bin)=>$b98b08f8901f4c6b$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $b98b08f8901f4c6b$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $b98b08f8901f4c6b$var$btoa(bin.join(""));
}
if ($b98b08f8901f4c6b$var$minimal_1.default.util.Long !== $b98b08f8901f4c6b$var$long_1.default) {
    $b98b08f8901f4c6b$var$minimal_1.default.util.Long = $b98b08f8901f4c6b$var$long_1.default;
    $b98b08f8901f4c6b$var$minimal_1.default.configure();
}



$68521e6ff41dbbae$exports.protobufPackage = "ibc.core.channel.v1";
const $68521e6ff41dbbae$var$baseMsgChannelOpenInit = {
    portId: "",
    signer: ""
};
$68521e6ff41dbbae$exports.MsgChannelOpenInit = {
    encode (message, writer = $68521e6ff41dbbae$var$minimal_1.default.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channel !== undefined) $b98b08f8901f4c6b$exports.Channel.encode(message.channel, writer.uint32(18).fork()).ldelim();
        if (message.signer !== "") writer.uint32(26).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $68521e6ff41dbbae$var$minimal_1.default.Reader ? input : new $68521e6ff41dbbae$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgChannelOpenInit);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channel = $b98b08f8901f4c6b$exports.Channel.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgChannelOpenInit);
        message.portId = object.portId !== undefined && object.portId !== null ? String(object.portId) : "";
        message.channel = object.channel !== undefined && object.channel !== null ? $b98b08f8901f4c6b$exports.Channel.fromJSON(object.channel) : undefined;
        message.signer = object.signer !== undefined && object.signer !== null ? String(object.signer) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channel !== undefined && (obj.channel = message.channel ? $b98b08f8901f4c6b$exports.Channel.toJSON(message.channel) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgChannelOpenInit);
        message.portId = (_a = object.portId) !== null && _a !== void 0 ? _a : "";
        message.channel = object.channel !== undefined && object.channel !== null ? $b98b08f8901f4c6b$exports.Channel.fromPartial(object.channel) : undefined;
        message.signer = (_b = object.signer) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
const $68521e6ff41dbbae$var$baseMsgChannelOpenInitResponse = {};
$68521e6ff41dbbae$exports.MsgChannelOpenInitResponse = {
    encode (_, writer = $68521e6ff41dbbae$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $68521e6ff41dbbae$var$minimal_1.default.Reader ? input : new $68521e6ff41dbbae$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgChannelOpenInitResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgChannelOpenInitResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgChannelOpenInitResponse);
        return message;
    }
};
const $68521e6ff41dbbae$var$baseMsgChannelOpenTry = {
    portId: "",
    previousChannelId: "",
    counterpartyVersion: "",
    signer: ""
};
$68521e6ff41dbbae$exports.MsgChannelOpenTry = {
    encode (message, writer = $68521e6ff41dbbae$var$minimal_1.default.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.previousChannelId !== "") writer.uint32(18).string(message.previousChannelId);
        if (message.channel !== undefined) $b98b08f8901f4c6b$exports.Channel.encode(message.channel, writer.uint32(26).fork()).ldelim();
        if (message.counterpartyVersion !== "") writer.uint32(34).string(message.counterpartyVersion);
        if (message.proofInit.length !== 0) writer.uint32(42).bytes(message.proofInit);
        if (message.proofHeight !== undefined) $0935332a1587f29e$exports.Height.encode(message.proofHeight, writer.uint32(50).fork()).ldelim();
        if (message.signer !== "") writer.uint32(58).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $68521e6ff41dbbae$var$minimal_1.default.Reader ? input : new $68521e6ff41dbbae$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgChannelOpenTry);
        message.proofInit = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.previousChannelId = reader.string();
                    break;
                case 3:
                    message.channel = $b98b08f8901f4c6b$exports.Channel.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.counterpartyVersion = reader.string();
                    break;
                case 5:
                    message.proofInit = reader.bytes();
                    break;
                case 6:
                    message.proofHeight = $0935332a1587f29e$exports.Height.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgChannelOpenTry);
        message.portId = object.portId !== undefined && object.portId !== null ? String(object.portId) : "";
        message.previousChannelId = object.previousChannelId !== undefined && object.previousChannelId !== null ? String(object.previousChannelId) : "";
        message.channel = object.channel !== undefined && object.channel !== null ? $b98b08f8901f4c6b$exports.Channel.fromJSON(object.channel) : undefined;
        message.counterpartyVersion = object.counterpartyVersion !== undefined && object.counterpartyVersion !== null ? String(object.counterpartyVersion) : "";
        message.proofInit = object.proofInit !== undefined && object.proofInit !== null ? $68521e6ff41dbbae$var$bytesFromBase64(object.proofInit) : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromJSON(object.proofHeight) : undefined;
        message.signer = object.signer !== undefined && object.signer !== null ? String(object.signer) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.previousChannelId !== undefined && (obj.previousChannelId = message.previousChannelId);
        message.channel !== undefined && (obj.channel = message.channel ? $b98b08f8901f4c6b$exports.Channel.toJSON(message.channel) : undefined);
        message.counterpartyVersion !== undefined && (obj.counterpartyVersion = message.counterpartyVersion);
        message.proofInit !== undefined && (obj.proofInit = $68521e6ff41dbbae$var$base64FromBytes(message.proofInit !== undefined ? message.proofInit : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $0935332a1587f29e$exports.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e;
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgChannelOpenTry);
        message.portId = (_a = object.portId) !== null && _a !== void 0 ? _a : "";
        message.previousChannelId = (_b = object.previousChannelId) !== null && _b !== void 0 ? _b : "";
        message.channel = object.channel !== undefined && object.channel !== null ? $b98b08f8901f4c6b$exports.Channel.fromPartial(object.channel) : undefined;
        message.counterpartyVersion = (_c = object.counterpartyVersion) !== null && _c !== void 0 ? _c : "";
        message.proofInit = (_d = object.proofInit) !== null && _d !== void 0 ? _d : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromPartial(object.proofHeight) : undefined;
        message.signer = (_e = object.signer) !== null && _e !== void 0 ? _e : "";
        return message;
    }
};
const $68521e6ff41dbbae$var$baseMsgChannelOpenTryResponse = {};
$68521e6ff41dbbae$exports.MsgChannelOpenTryResponse = {
    encode (_, writer = $68521e6ff41dbbae$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $68521e6ff41dbbae$var$minimal_1.default.Reader ? input : new $68521e6ff41dbbae$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgChannelOpenTryResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgChannelOpenTryResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgChannelOpenTryResponse);
        return message;
    }
};
const $68521e6ff41dbbae$var$baseMsgChannelOpenAck = {
    portId: "",
    channelId: "",
    counterpartyChannelId: "",
    counterpartyVersion: "",
    signer: ""
};
$68521e6ff41dbbae$exports.MsgChannelOpenAck = {
    encode (message, writer = $68521e6ff41dbbae$var$minimal_1.default.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (message.counterpartyChannelId !== "") writer.uint32(26).string(message.counterpartyChannelId);
        if (message.counterpartyVersion !== "") writer.uint32(34).string(message.counterpartyVersion);
        if (message.proofTry.length !== 0) writer.uint32(42).bytes(message.proofTry);
        if (message.proofHeight !== undefined) $0935332a1587f29e$exports.Height.encode(message.proofHeight, writer.uint32(50).fork()).ldelim();
        if (message.signer !== "") writer.uint32(58).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $68521e6ff41dbbae$var$minimal_1.default.Reader ? input : new $68521e6ff41dbbae$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgChannelOpenAck);
        message.proofTry = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.counterpartyChannelId = reader.string();
                    break;
                case 4:
                    message.counterpartyVersion = reader.string();
                    break;
                case 5:
                    message.proofTry = reader.bytes();
                    break;
                case 6:
                    message.proofHeight = $0935332a1587f29e$exports.Height.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgChannelOpenAck);
        message.portId = object.portId !== undefined && object.portId !== null ? String(object.portId) : "";
        message.channelId = object.channelId !== undefined && object.channelId !== null ? String(object.channelId) : "";
        message.counterpartyChannelId = object.counterpartyChannelId !== undefined && object.counterpartyChannelId !== null ? String(object.counterpartyChannelId) : "";
        message.counterpartyVersion = object.counterpartyVersion !== undefined && object.counterpartyVersion !== null ? String(object.counterpartyVersion) : "";
        message.proofTry = object.proofTry !== undefined && object.proofTry !== null ? $68521e6ff41dbbae$var$bytesFromBase64(object.proofTry) : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromJSON(object.proofHeight) : undefined;
        message.signer = object.signer !== undefined && object.signer !== null ? String(object.signer) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.counterpartyChannelId !== undefined && (obj.counterpartyChannelId = message.counterpartyChannelId);
        message.counterpartyVersion !== undefined && (obj.counterpartyVersion = message.counterpartyVersion);
        message.proofTry !== undefined && (obj.proofTry = $68521e6ff41dbbae$var$base64FromBytes(message.proofTry !== undefined ? message.proofTry : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $0935332a1587f29e$exports.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e, _f;
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgChannelOpenAck);
        message.portId = (_a = object.portId) !== null && _a !== void 0 ? _a : "";
        message.channelId = (_b = object.channelId) !== null && _b !== void 0 ? _b : "";
        message.counterpartyChannelId = (_c = object.counterpartyChannelId) !== null && _c !== void 0 ? _c : "";
        message.counterpartyVersion = (_d = object.counterpartyVersion) !== null && _d !== void 0 ? _d : "";
        message.proofTry = (_e = object.proofTry) !== null && _e !== void 0 ? _e : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromPartial(object.proofHeight) : undefined;
        message.signer = (_f = object.signer) !== null && _f !== void 0 ? _f : "";
        return message;
    }
};
const $68521e6ff41dbbae$var$baseMsgChannelOpenAckResponse = {};
$68521e6ff41dbbae$exports.MsgChannelOpenAckResponse = {
    encode (_, writer = $68521e6ff41dbbae$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $68521e6ff41dbbae$var$minimal_1.default.Reader ? input : new $68521e6ff41dbbae$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgChannelOpenAckResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgChannelOpenAckResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgChannelOpenAckResponse);
        return message;
    }
};
const $68521e6ff41dbbae$var$baseMsgChannelOpenConfirm = {
    portId: "",
    channelId: "",
    signer: ""
};
$68521e6ff41dbbae$exports.MsgChannelOpenConfirm = {
    encode (message, writer = $68521e6ff41dbbae$var$minimal_1.default.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (message.proofAck.length !== 0) writer.uint32(26).bytes(message.proofAck);
        if (message.proofHeight !== undefined) $0935332a1587f29e$exports.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        if (message.signer !== "") writer.uint32(42).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $68521e6ff41dbbae$var$minimal_1.default.Reader ? input : new $68521e6ff41dbbae$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgChannelOpenConfirm);
        message.proofAck = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.proofAck = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = $0935332a1587f29e$exports.Height.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgChannelOpenConfirm);
        message.portId = object.portId !== undefined && object.portId !== null ? String(object.portId) : "";
        message.channelId = object.channelId !== undefined && object.channelId !== null ? String(object.channelId) : "";
        message.proofAck = object.proofAck !== undefined && object.proofAck !== null ? $68521e6ff41dbbae$var$bytesFromBase64(object.proofAck) : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromJSON(object.proofHeight) : undefined;
        message.signer = object.signer !== undefined && object.signer !== null ? String(object.signer) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.proofAck !== undefined && (obj.proofAck = $68521e6ff41dbbae$var$base64FromBytes(message.proofAck !== undefined ? message.proofAck : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $0935332a1587f29e$exports.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgChannelOpenConfirm);
        message.portId = (_a = object.portId) !== null && _a !== void 0 ? _a : "";
        message.channelId = (_b = object.channelId) !== null && _b !== void 0 ? _b : "";
        message.proofAck = (_c = object.proofAck) !== null && _c !== void 0 ? _c : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromPartial(object.proofHeight) : undefined;
        message.signer = (_d = object.signer) !== null && _d !== void 0 ? _d : "";
        return message;
    }
};
const $68521e6ff41dbbae$var$baseMsgChannelOpenConfirmResponse = {};
$68521e6ff41dbbae$exports.MsgChannelOpenConfirmResponse = {
    encode (_, writer = $68521e6ff41dbbae$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $68521e6ff41dbbae$var$minimal_1.default.Reader ? input : new $68521e6ff41dbbae$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgChannelOpenConfirmResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgChannelOpenConfirmResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgChannelOpenConfirmResponse);
        return message;
    }
};
const $68521e6ff41dbbae$var$baseMsgChannelCloseInit = {
    portId: "",
    channelId: "",
    signer: ""
};
$68521e6ff41dbbae$exports.MsgChannelCloseInit = {
    encode (message, writer = $68521e6ff41dbbae$var$minimal_1.default.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (message.signer !== "") writer.uint32(26).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $68521e6ff41dbbae$var$minimal_1.default.Reader ? input : new $68521e6ff41dbbae$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgChannelCloseInit);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgChannelCloseInit);
        message.portId = object.portId !== undefined && object.portId !== null ? String(object.portId) : "";
        message.channelId = object.channelId !== undefined && object.channelId !== null ? String(object.channelId) : "";
        message.signer = object.signer !== undefined && object.signer !== null ? String(object.signer) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgChannelCloseInit);
        message.portId = (_a = object.portId) !== null && _a !== void 0 ? _a : "";
        message.channelId = (_b = object.channelId) !== null && _b !== void 0 ? _b : "";
        message.signer = (_c = object.signer) !== null && _c !== void 0 ? _c : "";
        return message;
    }
};
const $68521e6ff41dbbae$var$baseMsgChannelCloseInitResponse = {};
$68521e6ff41dbbae$exports.MsgChannelCloseInitResponse = {
    encode (_, writer = $68521e6ff41dbbae$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $68521e6ff41dbbae$var$minimal_1.default.Reader ? input : new $68521e6ff41dbbae$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgChannelCloseInitResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgChannelCloseInitResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgChannelCloseInitResponse);
        return message;
    }
};
const $68521e6ff41dbbae$var$baseMsgChannelCloseConfirm = {
    portId: "",
    channelId: "",
    signer: ""
};
$68521e6ff41dbbae$exports.MsgChannelCloseConfirm = {
    encode (message, writer = $68521e6ff41dbbae$var$minimal_1.default.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (message.proofInit.length !== 0) writer.uint32(26).bytes(message.proofInit);
        if (message.proofHeight !== undefined) $0935332a1587f29e$exports.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        if (message.signer !== "") writer.uint32(42).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $68521e6ff41dbbae$var$minimal_1.default.Reader ? input : new $68521e6ff41dbbae$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgChannelCloseConfirm);
        message.proofInit = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.proofInit = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = $0935332a1587f29e$exports.Height.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgChannelCloseConfirm);
        message.portId = object.portId !== undefined && object.portId !== null ? String(object.portId) : "";
        message.channelId = object.channelId !== undefined && object.channelId !== null ? String(object.channelId) : "";
        message.proofInit = object.proofInit !== undefined && object.proofInit !== null ? $68521e6ff41dbbae$var$bytesFromBase64(object.proofInit) : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromJSON(object.proofHeight) : undefined;
        message.signer = object.signer !== undefined && object.signer !== null ? String(object.signer) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.proofInit !== undefined && (obj.proofInit = $68521e6ff41dbbae$var$base64FromBytes(message.proofInit !== undefined ? message.proofInit : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $0935332a1587f29e$exports.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgChannelCloseConfirm);
        message.portId = (_a = object.portId) !== null && _a !== void 0 ? _a : "";
        message.channelId = (_b = object.channelId) !== null && _b !== void 0 ? _b : "";
        message.proofInit = (_c = object.proofInit) !== null && _c !== void 0 ? _c : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromPartial(object.proofHeight) : undefined;
        message.signer = (_d = object.signer) !== null && _d !== void 0 ? _d : "";
        return message;
    }
};
const $68521e6ff41dbbae$var$baseMsgChannelCloseConfirmResponse = {};
$68521e6ff41dbbae$exports.MsgChannelCloseConfirmResponse = {
    encode (_, writer = $68521e6ff41dbbae$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $68521e6ff41dbbae$var$minimal_1.default.Reader ? input : new $68521e6ff41dbbae$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgChannelCloseConfirmResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgChannelCloseConfirmResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgChannelCloseConfirmResponse);
        return message;
    }
};
const $68521e6ff41dbbae$var$baseMsgRecvPacket = {
    signer: ""
};
$68521e6ff41dbbae$exports.MsgRecvPacket = {
    encode (message, writer = $68521e6ff41dbbae$var$minimal_1.default.Writer.create()) {
        if (message.packet !== undefined) $b98b08f8901f4c6b$exports.Packet.encode(message.packet, writer.uint32(10).fork()).ldelim();
        if (message.proofCommitment.length !== 0) writer.uint32(18).bytes(message.proofCommitment);
        if (message.proofHeight !== undefined) $0935332a1587f29e$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        if (message.signer !== "") writer.uint32(34).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $68521e6ff41dbbae$var$minimal_1.default.Reader ? input : new $68521e6ff41dbbae$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgRecvPacket);
        message.proofCommitment = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.packet = $b98b08f8901f4c6b$exports.Packet.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proofCommitment = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $0935332a1587f29e$exports.Height.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgRecvPacket);
        message.packet = object.packet !== undefined && object.packet !== null ? $b98b08f8901f4c6b$exports.Packet.fromJSON(object.packet) : undefined;
        message.proofCommitment = object.proofCommitment !== undefined && object.proofCommitment !== null ? $68521e6ff41dbbae$var$bytesFromBase64(object.proofCommitment) : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromJSON(object.proofHeight) : undefined;
        message.signer = object.signer !== undefined && object.signer !== null ? String(object.signer) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.packet !== undefined && (obj.packet = message.packet ? $b98b08f8901f4c6b$exports.Packet.toJSON(message.packet) : undefined);
        message.proofCommitment !== undefined && (obj.proofCommitment = $68521e6ff41dbbae$var$base64FromBytes(message.proofCommitment !== undefined ? message.proofCommitment : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $0935332a1587f29e$exports.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgRecvPacket);
        message.packet = object.packet !== undefined && object.packet !== null ? $b98b08f8901f4c6b$exports.Packet.fromPartial(object.packet) : undefined;
        message.proofCommitment = (_a = object.proofCommitment) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromPartial(object.proofHeight) : undefined;
        message.signer = (_b = object.signer) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
const $68521e6ff41dbbae$var$baseMsgRecvPacketResponse = {};
$68521e6ff41dbbae$exports.MsgRecvPacketResponse = {
    encode (_, writer = $68521e6ff41dbbae$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $68521e6ff41dbbae$var$minimal_1.default.Reader ? input : new $68521e6ff41dbbae$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgRecvPacketResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgRecvPacketResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgRecvPacketResponse);
        return message;
    }
};
const $68521e6ff41dbbae$var$baseMsgTimeout = {
    nextSequenceRecv: $68521e6ff41dbbae$var$long_1.default.UZERO,
    signer: ""
};
$68521e6ff41dbbae$exports.MsgTimeout = {
    encode (message, writer = $68521e6ff41dbbae$var$minimal_1.default.Writer.create()) {
        if (message.packet !== undefined) $b98b08f8901f4c6b$exports.Packet.encode(message.packet, writer.uint32(10).fork()).ldelim();
        if (message.proofUnreceived.length !== 0) writer.uint32(18).bytes(message.proofUnreceived);
        if (message.proofHeight !== undefined) $0935332a1587f29e$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        if (!message.nextSequenceRecv.isZero()) writer.uint32(32).uint64(message.nextSequenceRecv);
        if (message.signer !== "") writer.uint32(42).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $68521e6ff41dbbae$var$minimal_1.default.Reader ? input : new $68521e6ff41dbbae$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgTimeout);
        message.proofUnreceived = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.packet = $b98b08f8901f4c6b$exports.Packet.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proofUnreceived = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $0935332a1587f29e$exports.Height.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.nextSequenceRecv = reader.uint64();
                    break;
                case 5:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgTimeout);
        message.packet = object.packet !== undefined && object.packet !== null ? $b98b08f8901f4c6b$exports.Packet.fromJSON(object.packet) : undefined;
        message.proofUnreceived = object.proofUnreceived !== undefined && object.proofUnreceived !== null ? $68521e6ff41dbbae$var$bytesFromBase64(object.proofUnreceived) : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromJSON(object.proofHeight) : undefined;
        message.nextSequenceRecv = object.nextSequenceRecv !== undefined && object.nextSequenceRecv !== null ? $68521e6ff41dbbae$var$long_1.default.fromString(object.nextSequenceRecv) : $68521e6ff41dbbae$var$long_1.default.UZERO;
        message.signer = object.signer !== undefined && object.signer !== null ? String(object.signer) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.packet !== undefined && (obj.packet = message.packet ? $b98b08f8901f4c6b$exports.Packet.toJSON(message.packet) : undefined);
        message.proofUnreceived !== undefined && (obj.proofUnreceived = $68521e6ff41dbbae$var$base64FromBytes(message.proofUnreceived !== undefined ? message.proofUnreceived : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $0935332a1587f29e$exports.Height.toJSON(message.proofHeight) : undefined);
        message.nextSequenceRecv !== undefined && (obj.nextSequenceRecv = (message.nextSequenceRecv || $68521e6ff41dbbae$var$long_1.default.UZERO).toString());
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgTimeout);
        message.packet = object.packet !== undefined && object.packet !== null ? $b98b08f8901f4c6b$exports.Packet.fromPartial(object.packet) : undefined;
        message.proofUnreceived = (_a = object.proofUnreceived) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromPartial(object.proofHeight) : undefined;
        message.nextSequenceRecv = object.nextSequenceRecv !== undefined && object.nextSequenceRecv !== null ? $68521e6ff41dbbae$var$long_1.default.fromValue(object.nextSequenceRecv) : $68521e6ff41dbbae$var$long_1.default.UZERO;
        message.signer = (_b = object.signer) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
const $68521e6ff41dbbae$var$baseMsgTimeoutResponse = {};
$68521e6ff41dbbae$exports.MsgTimeoutResponse = {
    encode (_, writer = $68521e6ff41dbbae$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $68521e6ff41dbbae$var$minimal_1.default.Reader ? input : new $68521e6ff41dbbae$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgTimeoutResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgTimeoutResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgTimeoutResponse);
        return message;
    }
};
const $68521e6ff41dbbae$var$baseMsgTimeoutOnClose = {
    nextSequenceRecv: $68521e6ff41dbbae$var$long_1.default.UZERO,
    signer: ""
};
$68521e6ff41dbbae$exports.MsgTimeoutOnClose = {
    encode (message, writer = $68521e6ff41dbbae$var$minimal_1.default.Writer.create()) {
        if (message.packet !== undefined) $b98b08f8901f4c6b$exports.Packet.encode(message.packet, writer.uint32(10).fork()).ldelim();
        if (message.proofUnreceived.length !== 0) writer.uint32(18).bytes(message.proofUnreceived);
        if (message.proofClose.length !== 0) writer.uint32(26).bytes(message.proofClose);
        if (message.proofHeight !== undefined) $0935332a1587f29e$exports.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        if (!message.nextSequenceRecv.isZero()) writer.uint32(40).uint64(message.nextSequenceRecv);
        if (message.signer !== "") writer.uint32(50).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $68521e6ff41dbbae$var$minimal_1.default.Reader ? input : new $68521e6ff41dbbae$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgTimeoutOnClose);
        message.proofUnreceived = new Uint8Array();
        message.proofClose = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.packet = $b98b08f8901f4c6b$exports.Packet.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proofUnreceived = reader.bytes();
                    break;
                case 3:
                    message.proofClose = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = $0935332a1587f29e$exports.Height.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.nextSequenceRecv = reader.uint64();
                    break;
                case 6:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgTimeoutOnClose);
        message.packet = object.packet !== undefined && object.packet !== null ? $b98b08f8901f4c6b$exports.Packet.fromJSON(object.packet) : undefined;
        message.proofUnreceived = object.proofUnreceived !== undefined && object.proofUnreceived !== null ? $68521e6ff41dbbae$var$bytesFromBase64(object.proofUnreceived) : new Uint8Array();
        message.proofClose = object.proofClose !== undefined && object.proofClose !== null ? $68521e6ff41dbbae$var$bytesFromBase64(object.proofClose) : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromJSON(object.proofHeight) : undefined;
        message.nextSequenceRecv = object.nextSequenceRecv !== undefined && object.nextSequenceRecv !== null ? $68521e6ff41dbbae$var$long_1.default.fromString(object.nextSequenceRecv) : $68521e6ff41dbbae$var$long_1.default.UZERO;
        message.signer = object.signer !== undefined && object.signer !== null ? String(object.signer) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.packet !== undefined && (obj.packet = message.packet ? $b98b08f8901f4c6b$exports.Packet.toJSON(message.packet) : undefined);
        message.proofUnreceived !== undefined && (obj.proofUnreceived = $68521e6ff41dbbae$var$base64FromBytes(message.proofUnreceived !== undefined ? message.proofUnreceived : new Uint8Array()));
        message.proofClose !== undefined && (obj.proofClose = $68521e6ff41dbbae$var$base64FromBytes(message.proofClose !== undefined ? message.proofClose : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $0935332a1587f29e$exports.Height.toJSON(message.proofHeight) : undefined);
        message.nextSequenceRecv !== undefined && (obj.nextSequenceRecv = (message.nextSequenceRecv || $68521e6ff41dbbae$var$long_1.default.UZERO).toString());
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgTimeoutOnClose);
        message.packet = object.packet !== undefined && object.packet !== null ? $b98b08f8901f4c6b$exports.Packet.fromPartial(object.packet) : undefined;
        message.proofUnreceived = (_a = object.proofUnreceived) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.proofClose = (_b = object.proofClose) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromPartial(object.proofHeight) : undefined;
        message.nextSequenceRecv = object.nextSequenceRecv !== undefined && object.nextSequenceRecv !== null ? $68521e6ff41dbbae$var$long_1.default.fromValue(object.nextSequenceRecv) : $68521e6ff41dbbae$var$long_1.default.UZERO;
        message.signer = (_c = object.signer) !== null && _c !== void 0 ? _c : "";
        return message;
    }
};
const $68521e6ff41dbbae$var$baseMsgTimeoutOnCloseResponse = {};
$68521e6ff41dbbae$exports.MsgTimeoutOnCloseResponse = {
    encode (_, writer = $68521e6ff41dbbae$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $68521e6ff41dbbae$var$minimal_1.default.Reader ? input : new $68521e6ff41dbbae$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgTimeoutOnCloseResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgTimeoutOnCloseResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgTimeoutOnCloseResponse);
        return message;
    }
};
const $68521e6ff41dbbae$var$baseMsgAcknowledgement = {
    signer: ""
};
$68521e6ff41dbbae$exports.MsgAcknowledgement = {
    encode (message, writer = $68521e6ff41dbbae$var$minimal_1.default.Writer.create()) {
        if (message.packet !== undefined) $b98b08f8901f4c6b$exports.Packet.encode(message.packet, writer.uint32(10).fork()).ldelim();
        if (message.acknowledgement.length !== 0) writer.uint32(18).bytes(message.acknowledgement);
        if (message.proofAcked.length !== 0) writer.uint32(26).bytes(message.proofAcked);
        if (message.proofHeight !== undefined) $0935332a1587f29e$exports.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        if (message.signer !== "") writer.uint32(42).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $68521e6ff41dbbae$var$minimal_1.default.Reader ? input : new $68521e6ff41dbbae$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgAcknowledgement);
        message.acknowledgement = new Uint8Array();
        message.proofAcked = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.packet = $b98b08f8901f4c6b$exports.Packet.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.acknowledgement = reader.bytes();
                    break;
                case 3:
                    message.proofAcked = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = $0935332a1587f29e$exports.Height.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgAcknowledgement);
        message.packet = object.packet !== undefined && object.packet !== null ? $b98b08f8901f4c6b$exports.Packet.fromJSON(object.packet) : undefined;
        message.acknowledgement = object.acknowledgement !== undefined && object.acknowledgement !== null ? $68521e6ff41dbbae$var$bytesFromBase64(object.acknowledgement) : new Uint8Array();
        message.proofAcked = object.proofAcked !== undefined && object.proofAcked !== null ? $68521e6ff41dbbae$var$bytesFromBase64(object.proofAcked) : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromJSON(object.proofHeight) : undefined;
        message.signer = object.signer !== undefined && object.signer !== null ? String(object.signer) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.packet !== undefined && (obj.packet = message.packet ? $b98b08f8901f4c6b$exports.Packet.toJSON(message.packet) : undefined);
        message.acknowledgement !== undefined && (obj.acknowledgement = $68521e6ff41dbbae$var$base64FromBytes(message.acknowledgement !== undefined ? message.acknowledgement : new Uint8Array()));
        message.proofAcked !== undefined && (obj.proofAcked = $68521e6ff41dbbae$var$base64FromBytes(message.proofAcked !== undefined ? message.proofAcked : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $0935332a1587f29e$exports.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgAcknowledgement);
        message.packet = object.packet !== undefined && object.packet !== null ? $b98b08f8901f4c6b$exports.Packet.fromPartial(object.packet) : undefined;
        message.acknowledgement = (_a = object.acknowledgement) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.proofAcked = (_b = object.proofAcked) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromPartial(object.proofHeight) : undefined;
        message.signer = (_c = object.signer) !== null && _c !== void 0 ? _c : "";
        return message;
    }
};
const $68521e6ff41dbbae$var$baseMsgAcknowledgementResponse = {};
$68521e6ff41dbbae$exports.MsgAcknowledgementResponse = {
    encode (_, writer = $68521e6ff41dbbae$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $68521e6ff41dbbae$var$minimal_1.default.Reader ? input : new $68521e6ff41dbbae$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgAcknowledgementResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgAcknowledgementResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $68521e6ff41dbbae$var$baseMsgAcknowledgementResponse);
        return message;
    }
};
class $68521e6ff41dbbae$var$MsgClientImpl {
    ChannelOpenInit(request) {
        const data = $68521e6ff41dbbae$exports.MsgChannelOpenInit.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelOpenInit", data);
        return promise.then((data)=>$68521e6ff41dbbae$exports.MsgChannelOpenInitResponse.decode(new $68521e6ff41dbbae$var$minimal_1.default.Reader(data)));
    }
    ChannelOpenTry(request) {
        const data = $68521e6ff41dbbae$exports.MsgChannelOpenTry.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelOpenTry", data);
        return promise.then((data)=>$68521e6ff41dbbae$exports.MsgChannelOpenTryResponse.decode(new $68521e6ff41dbbae$var$minimal_1.default.Reader(data)));
    }
    ChannelOpenAck(request) {
        const data = $68521e6ff41dbbae$exports.MsgChannelOpenAck.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelOpenAck", data);
        return promise.then((data)=>$68521e6ff41dbbae$exports.MsgChannelOpenAckResponse.decode(new $68521e6ff41dbbae$var$minimal_1.default.Reader(data)));
    }
    ChannelOpenConfirm(request) {
        const data = $68521e6ff41dbbae$exports.MsgChannelOpenConfirm.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelOpenConfirm", data);
        return promise.then((data)=>$68521e6ff41dbbae$exports.MsgChannelOpenConfirmResponse.decode(new $68521e6ff41dbbae$var$minimal_1.default.Reader(data)));
    }
    ChannelCloseInit(request) {
        const data = $68521e6ff41dbbae$exports.MsgChannelCloseInit.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelCloseInit", data);
        return promise.then((data)=>$68521e6ff41dbbae$exports.MsgChannelCloseInitResponse.decode(new $68521e6ff41dbbae$var$minimal_1.default.Reader(data)));
    }
    ChannelCloseConfirm(request) {
        const data = $68521e6ff41dbbae$exports.MsgChannelCloseConfirm.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelCloseConfirm", data);
        return promise.then((data)=>$68521e6ff41dbbae$exports.MsgChannelCloseConfirmResponse.decode(new $68521e6ff41dbbae$var$minimal_1.default.Reader(data)));
    }
    RecvPacket(request) {
        const data = $68521e6ff41dbbae$exports.MsgRecvPacket.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "RecvPacket", data);
        return promise.then((data)=>$68521e6ff41dbbae$exports.MsgRecvPacketResponse.decode(new $68521e6ff41dbbae$var$minimal_1.default.Reader(data)));
    }
    Timeout(request) {
        const data = $68521e6ff41dbbae$exports.MsgTimeout.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "Timeout", data);
        return promise.then((data)=>$68521e6ff41dbbae$exports.MsgTimeoutResponse.decode(new $68521e6ff41dbbae$var$minimal_1.default.Reader(data)));
    }
    TimeoutOnClose(request) {
        const data = $68521e6ff41dbbae$exports.MsgTimeoutOnClose.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "TimeoutOnClose", data);
        return promise.then((data)=>$68521e6ff41dbbae$exports.MsgTimeoutOnCloseResponse.decode(new $68521e6ff41dbbae$var$minimal_1.default.Reader(data)));
    }
    Acknowledgement(request) {
        const data = $68521e6ff41dbbae$exports.MsgAcknowledgement.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "Acknowledgement", data);
        return promise.then((data)=>$68521e6ff41dbbae$exports.MsgAcknowledgementResponse.decode(new $68521e6ff41dbbae$var$minimal_1.default.Reader(data)));
    }
    constructor(rpc){
        this.rpc = rpc;
        this.ChannelOpenInit = this.ChannelOpenInit.bind(this);
        this.ChannelOpenTry = this.ChannelOpenTry.bind(this);
        this.ChannelOpenAck = this.ChannelOpenAck.bind(this);
        this.ChannelOpenConfirm = this.ChannelOpenConfirm.bind(this);
        this.ChannelCloseInit = this.ChannelCloseInit.bind(this);
        this.ChannelCloseConfirm = this.ChannelCloseConfirm.bind(this);
        this.RecvPacket = this.RecvPacket.bind(this);
        this.Timeout = this.Timeout.bind(this);
        this.TimeoutOnClose = this.TimeoutOnClose.bind(this);
        this.Acknowledgement = this.Acknowledgement.bind(this);
    }
}
$68521e6ff41dbbae$exports.MsgClientImpl = $68521e6ff41dbbae$var$MsgClientImpl;
var $68521e6ff41dbbae$var$globalThis = (()=>{
    if (typeof $68521e6ff41dbbae$var$globalThis !== "undefined") return $68521e6ff41dbbae$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $68521e6ff41dbbae$var$atob = $68521e6ff41dbbae$var$globalThis.atob || ((b64)=>$68521e6ff41dbbae$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $68521e6ff41dbbae$var$bytesFromBase64(b64) {
    const bin = $68521e6ff41dbbae$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $68521e6ff41dbbae$var$btoa = $68521e6ff41dbbae$var$globalThis.btoa || ((bin)=>$68521e6ff41dbbae$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $68521e6ff41dbbae$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $68521e6ff41dbbae$var$btoa(bin.join(""));
}
if ($68521e6ff41dbbae$var$minimal_1.default.util.Long !== $68521e6ff41dbbae$var$long_1.default) {
    $68521e6ff41dbbae$var$minimal_1.default.util.Long = $68521e6ff41dbbae$var$long_1.default;
    $68521e6ff41dbbae$var$minimal_1.default.configure();
}


var $6894222044d16914$exports = {};
"use strict";
var $6894222044d16914$var$__importDefault = $6894222044d16914$exports && $6894222044d16914$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($6894222044d16914$exports, "__esModule", {
    value: true
});
$6894222044d16914$exports.MsgClientImpl = $6894222044d16914$exports.MsgSubmitMisbehaviourResponse = $6894222044d16914$exports.MsgSubmitMisbehaviour = $6894222044d16914$exports.MsgUpgradeClientResponse = $6894222044d16914$exports.MsgUpgradeClient = $6894222044d16914$exports.MsgUpdateClientResponse = $6894222044d16914$exports.MsgUpdateClient = $6894222044d16914$exports.MsgCreateClientResponse = $6894222044d16914$exports.MsgCreateClient = $6894222044d16914$exports.protobufPackage = void 0;

/* eslint-disable */ const $6894222044d16914$var$long_1 = $6894222044d16914$var$__importDefault((parcelRequire("9A55m")));

const $6894222044d16914$var$minimal_1 = $6894222044d16914$var$__importDefault((parcelRequire("i2pIU")));

$6894222044d16914$exports.protobufPackage = "ibc.core.client.v1";
const $6894222044d16914$var$baseMsgCreateClient = {
    signer: ""
};
$6894222044d16914$exports.MsgCreateClient = {
    encode (message, writer = $6894222044d16914$var$minimal_1.default.Writer.create()) {
        if (message.clientState !== undefined) $4232fce010c3a46b$exports.Any.encode(message.clientState, writer.uint32(10).fork()).ldelim();
        if (message.consensusState !== undefined) $4232fce010c3a46b$exports.Any.encode(message.consensusState, writer.uint32(18).fork()).ldelim();
        if (message.signer !== "") writer.uint32(26).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6894222044d16914$var$minimal_1.default.Reader ? input : new $6894222044d16914$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $6894222044d16914$var$baseMsgCreateClient);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientState = $4232fce010c3a46b$exports.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.consensusState = $4232fce010c3a46b$exports.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $6894222044d16914$var$baseMsgCreateClient);
        message.clientState = object.clientState !== undefined && object.clientState !== null ? $4232fce010c3a46b$exports.Any.fromJSON(object.clientState) : undefined;
        message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? $4232fce010c3a46b$exports.Any.fromJSON(object.consensusState) : undefined;
        message.signer = object.signer !== undefined && object.signer !== null ? String(object.signer) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.clientState !== undefined && (obj.clientState = message.clientState ? $4232fce010c3a46b$exports.Any.toJSON(message.clientState) : undefined);
        message.consensusState !== undefined && (obj.consensusState = message.consensusState ? $4232fce010c3a46b$exports.Any.toJSON(message.consensusState) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $6894222044d16914$var$baseMsgCreateClient);
        message.clientState = object.clientState !== undefined && object.clientState !== null ? $4232fce010c3a46b$exports.Any.fromPartial(object.clientState) : undefined;
        message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? $4232fce010c3a46b$exports.Any.fromPartial(object.consensusState) : undefined;
        message.signer = (_a = object.signer) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
const $6894222044d16914$var$baseMsgCreateClientResponse = {};
$6894222044d16914$exports.MsgCreateClientResponse = {
    encode (_, writer = $6894222044d16914$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6894222044d16914$var$minimal_1.default.Reader ? input : new $6894222044d16914$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $6894222044d16914$var$baseMsgCreateClientResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $6894222044d16914$var$baseMsgCreateClientResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $6894222044d16914$var$baseMsgCreateClientResponse);
        return message;
    }
};
const $6894222044d16914$var$baseMsgUpdateClient = {
    clientId: "",
    signer: ""
};
$6894222044d16914$exports.MsgUpdateClient = {
    encode (message, writer = $6894222044d16914$var$minimal_1.default.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.header !== undefined) $4232fce010c3a46b$exports.Any.encode(message.header, writer.uint32(18).fork()).ldelim();
        if (message.signer !== "") writer.uint32(26).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6894222044d16914$var$minimal_1.default.Reader ? input : new $6894222044d16914$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $6894222044d16914$var$baseMsgUpdateClient);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.header = $4232fce010c3a46b$exports.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $6894222044d16914$var$baseMsgUpdateClient);
        message.clientId = object.clientId !== undefined && object.clientId !== null ? String(object.clientId) : "";
        message.header = object.header !== undefined && object.header !== null ? $4232fce010c3a46b$exports.Any.fromJSON(object.header) : undefined;
        message.signer = object.signer !== undefined && object.signer !== null ? String(object.signer) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.header !== undefined && (obj.header = message.header ? $4232fce010c3a46b$exports.Any.toJSON(message.header) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $6894222044d16914$var$baseMsgUpdateClient);
        message.clientId = (_a = object.clientId) !== null && _a !== void 0 ? _a : "";
        message.header = object.header !== undefined && object.header !== null ? $4232fce010c3a46b$exports.Any.fromPartial(object.header) : undefined;
        message.signer = (_b = object.signer) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
const $6894222044d16914$var$baseMsgUpdateClientResponse = {};
$6894222044d16914$exports.MsgUpdateClientResponse = {
    encode (_, writer = $6894222044d16914$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6894222044d16914$var$minimal_1.default.Reader ? input : new $6894222044d16914$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $6894222044d16914$var$baseMsgUpdateClientResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $6894222044d16914$var$baseMsgUpdateClientResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $6894222044d16914$var$baseMsgUpdateClientResponse);
        return message;
    }
};
const $6894222044d16914$var$baseMsgUpgradeClient = {
    clientId: "",
    signer: ""
};
$6894222044d16914$exports.MsgUpgradeClient = {
    encode (message, writer = $6894222044d16914$var$minimal_1.default.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.clientState !== undefined) $4232fce010c3a46b$exports.Any.encode(message.clientState, writer.uint32(18).fork()).ldelim();
        if (message.consensusState !== undefined) $4232fce010c3a46b$exports.Any.encode(message.consensusState, writer.uint32(26).fork()).ldelim();
        if (message.proofUpgradeClient.length !== 0) writer.uint32(34).bytes(message.proofUpgradeClient);
        if (message.proofUpgradeConsensusState.length !== 0) writer.uint32(42).bytes(message.proofUpgradeConsensusState);
        if (message.signer !== "") writer.uint32(50).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6894222044d16914$var$minimal_1.default.Reader ? input : new $6894222044d16914$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $6894222044d16914$var$baseMsgUpgradeClient);
        message.proofUpgradeClient = new Uint8Array();
        message.proofUpgradeConsensusState = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.clientState = $4232fce010c3a46b$exports.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.consensusState = $4232fce010c3a46b$exports.Any.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.proofUpgradeClient = reader.bytes();
                    break;
                case 5:
                    message.proofUpgradeConsensusState = reader.bytes();
                    break;
                case 6:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $6894222044d16914$var$baseMsgUpgradeClient);
        message.clientId = object.clientId !== undefined && object.clientId !== null ? String(object.clientId) : "";
        message.clientState = object.clientState !== undefined && object.clientState !== null ? $4232fce010c3a46b$exports.Any.fromJSON(object.clientState) : undefined;
        message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? $4232fce010c3a46b$exports.Any.fromJSON(object.consensusState) : undefined;
        message.proofUpgradeClient = object.proofUpgradeClient !== undefined && object.proofUpgradeClient !== null ? $6894222044d16914$var$bytesFromBase64(object.proofUpgradeClient) : new Uint8Array();
        message.proofUpgradeConsensusState = object.proofUpgradeConsensusState !== undefined && object.proofUpgradeConsensusState !== null ? $6894222044d16914$var$bytesFromBase64(object.proofUpgradeConsensusState) : new Uint8Array();
        message.signer = object.signer !== undefined && object.signer !== null ? String(object.signer) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.clientState !== undefined && (obj.clientState = message.clientState ? $4232fce010c3a46b$exports.Any.toJSON(message.clientState) : undefined);
        message.consensusState !== undefined && (obj.consensusState = message.consensusState ? $4232fce010c3a46b$exports.Any.toJSON(message.consensusState) : undefined);
        message.proofUpgradeClient !== undefined && (obj.proofUpgradeClient = $6894222044d16914$var$base64FromBytes(message.proofUpgradeClient !== undefined ? message.proofUpgradeClient : new Uint8Array()));
        message.proofUpgradeConsensusState !== undefined && (obj.proofUpgradeConsensusState = $6894222044d16914$var$base64FromBytes(message.proofUpgradeConsensusState !== undefined ? message.proofUpgradeConsensusState : new Uint8Array()));
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = Object.assign({}, $6894222044d16914$var$baseMsgUpgradeClient);
        message.clientId = (_a = object.clientId) !== null && _a !== void 0 ? _a : "";
        message.clientState = object.clientState !== undefined && object.clientState !== null ? $4232fce010c3a46b$exports.Any.fromPartial(object.clientState) : undefined;
        message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? $4232fce010c3a46b$exports.Any.fromPartial(object.consensusState) : undefined;
        message.proofUpgradeClient = (_b = object.proofUpgradeClient) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.proofUpgradeConsensusState = (_c = object.proofUpgradeConsensusState) !== null && _c !== void 0 ? _c : new Uint8Array();
        message.signer = (_d = object.signer) !== null && _d !== void 0 ? _d : "";
        return message;
    }
};
const $6894222044d16914$var$baseMsgUpgradeClientResponse = {};
$6894222044d16914$exports.MsgUpgradeClientResponse = {
    encode (_, writer = $6894222044d16914$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6894222044d16914$var$minimal_1.default.Reader ? input : new $6894222044d16914$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $6894222044d16914$var$baseMsgUpgradeClientResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $6894222044d16914$var$baseMsgUpgradeClientResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $6894222044d16914$var$baseMsgUpgradeClientResponse);
        return message;
    }
};
const $6894222044d16914$var$baseMsgSubmitMisbehaviour = {
    clientId: "",
    signer: ""
};
$6894222044d16914$exports.MsgSubmitMisbehaviour = {
    encode (message, writer = $6894222044d16914$var$minimal_1.default.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.misbehaviour !== undefined) $4232fce010c3a46b$exports.Any.encode(message.misbehaviour, writer.uint32(18).fork()).ldelim();
        if (message.signer !== "") writer.uint32(26).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6894222044d16914$var$minimal_1.default.Reader ? input : new $6894222044d16914$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $6894222044d16914$var$baseMsgSubmitMisbehaviour);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.misbehaviour = $4232fce010c3a46b$exports.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $6894222044d16914$var$baseMsgSubmitMisbehaviour);
        message.clientId = object.clientId !== undefined && object.clientId !== null ? String(object.clientId) : "";
        message.misbehaviour = object.misbehaviour !== undefined && object.misbehaviour !== null ? $4232fce010c3a46b$exports.Any.fromJSON(object.misbehaviour) : undefined;
        message.signer = object.signer !== undefined && object.signer !== null ? String(object.signer) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.misbehaviour !== undefined && (obj.misbehaviour = message.misbehaviour ? $4232fce010c3a46b$exports.Any.toJSON(message.misbehaviour) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $6894222044d16914$var$baseMsgSubmitMisbehaviour);
        message.clientId = (_a = object.clientId) !== null && _a !== void 0 ? _a : "";
        message.misbehaviour = object.misbehaviour !== undefined && object.misbehaviour !== null ? $4232fce010c3a46b$exports.Any.fromPartial(object.misbehaviour) : undefined;
        message.signer = (_b = object.signer) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
const $6894222044d16914$var$baseMsgSubmitMisbehaviourResponse = {};
$6894222044d16914$exports.MsgSubmitMisbehaviourResponse = {
    encode (_, writer = $6894222044d16914$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6894222044d16914$var$minimal_1.default.Reader ? input : new $6894222044d16914$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $6894222044d16914$var$baseMsgSubmitMisbehaviourResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $6894222044d16914$var$baseMsgSubmitMisbehaviourResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $6894222044d16914$var$baseMsgSubmitMisbehaviourResponse);
        return message;
    }
};
class $6894222044d16914$var$MsgClientImpl {
    CreateClient(request) {
        const data = $6894222044d16914$exports.MsgCreateClient.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Msg", "CreateClient", data);
        return promise.then((data)=>$6894222044d16914$exports.MsgCreateClientResponse.decode(new $6894222044d16914$var$minimal_1.default.Reader(data)));
    }
    UpdateClient(request) {
        const data = $6894222044d16914$exports.MsgUpdateClient.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Msg", "UpdateClient", data);
        return promise.then((data)=>$6894222044d16914$exports.MsgUpdateClientResponse.decode(new $6894222044d16914$var$minimal_1.default.Reader(data)));
    }
    UpgradeClient(request) {
        const data = $6894222044d16914$exports.MsgUpgradeClient.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Msg", "UpgradeClient", data);
        return promise.then((data)=>$6894222044d16914$exports.MsgUpgradeClientResponse.decode(new $6894222044d16914$var$minimal_1.default.Reader(data)));
    }
    SubmitMisbehaviour(request) {
        const data = $6894222044d16914$exports.MsgSubmitMisbehaviour.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Msg", "SubmitMisbehaviour", data);
        return promise.then((data)=>$6894222044d16914$exports.MsgSubmitMisbehaviourResponse.decode(new $6894222044d16914$var$minimal_1.default.Reader(data)));
    }
    constructor(rpc){
        this.rpc = rpc;
        this.CreateClient = this.CreateClient.bind(this);
        this.UpdateClient = this.UpdateClient.bind(this);
        this.UpgradeClient = this.UpgradeClient.bind(this);
        this.SubmitMisbehaviour = this.SubmitMisbehaviour.bind(this);
    }
}
$6894222044d16914$exports.MsgClientImpl = $6894222044d16914$var$MsgClientImpl;
var $6894222044d16914$var$globalThis = (()=>{
    if (typeof $6894222044d16914$var$globalThis !== "undefined") return $6894222044d16914$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $6894222044d16914$var$atob = $6894222044d16914$var$globalThis.atob || ((b64)=>$6894222044d16914$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $6894222044d16914$var$bytesFromBase64(b64) {
    const bin = $6894222044d16914$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $6894222044d16914$var$btoa = $6894222044d16914$var$globalThis.btoa || ((bin)=>$6894222044d16914$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $6894222044d16914$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $6894222044d16914$var$btoa(bin.join(""));
}
if ($6894222044d16914$var$minimal_1.default.util.Long !== $6894222044d16914$var$long_1.default) {
    $6894222044d16914$var$minimal_1.default.util.Long = $6894222044d16914$var$long_1.default;
    $6894222044d16914$var$minimal_1.default.configure();
}


var $8e0bc4d4001974df$exports = {};
"use strict";
var $8e0bc4d4001974df$var$__importDefault = $8e0bc4d4001974df$exports && $8e0bc4d4001974df$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($8e0bc4d4001974df$exports, "__esModule", {
    value: true
});
$8e0bc4d4001974df$exports.MsgClientImpl = $8e0bc4d4001974df$exports.MsgConnectionOpenConfirmResponse = $8e0bc4d4001974df$exports.MsgConnectionOpenConfirm = $8e0bc4d4001974df$exports.MsgConnectionOpenAckResponse = $8e0bc4d4001974df$exports.MsgConnectionOpenAck = $8e0bc4d4001974df$exports.MsgConnectionOpenTryResponse = $8e0bc4d4001974df$exports.MsgConnectionOpenTry = $8e0bc4d4001974df$exports.MsgConnectionOpenInitResponse = $8e0bc4d4001974df$exports.MsgConnectionOpenInit = $8e0bc4d4001974df$exports.protobufPackage = void 0;

/* eslint-disable */ const $8e0bc4d4001974df$var$long_1 = $8e0bc4d4001974df$var$__importDefault((parcelRequire("9A55m")));

const $8e0bc4d4001974df$var$minimal_1 = $8e0bc4d4001974df$var$__importDefault((parcelRequire("i2pIU")));
var $57765dd48e8b80b9$exports = {};
"use strict";
var $57765dd48e8b80b9$var$__importDefault = $57765dd48e8b80b9$exports && $57765dd48e8b80b9$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($57765dd48e8b80b9$exports, "__esModule", {
    value: true
});
$57765dd48e8b80b9$exports.Version = $57765dd48e8b80b9$exports.ConnectionPaths = $57765dd48e8b80b9$exports.ClientPaths = $57765dd48e8b80b9$exports.Counterparty = $57765dd48e8b80b9$exports.IdentifiedConnection = $57765dd48e8b80b9$exports.ConnectionEnd = $57765dd48e8b80b9$exports.stateToJSON = $57765dd48e8b80b9$exports.stateFromJSON = $57765dd48e8b80b9$exports.State = $57765dd48e8b80b9$exports.protobufPackage = void 0;

/* eslint-disable */ const $57765dd48e8b80b9$var$long_1 = $57765dd48e8b80b9$var$__importDefault((parcelRequire("9A55m")));

const $57765dd48e8b80b9$var$minimal_1 = $57765dd48e8b80b9$var$__importDefault((parcelRequire("i2pIU")));
var $7ddd8dfe443ea91e$exports = {};
"use strict";
var $7ddd8dfe443ea91e$var$__importDefault = $7ddd8dfe443ea91e$exports && $7ddd8dfe443ea91e$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($7ddd8dfe443ea91e$exports, "__esModule", {
    value: true
});
$7ddd8dfe443ea91e$exports.MerkleProof = $7ddd8dfe443ea91e$exports.MerklePath = $7ddd8dfe443ea91e$exports.MerklePrefix = $7ddd8dfe443ea91e$exports.MerkleRoot = $7ddd8dfe443ea91e$exports.protobufPackage = void 0;

/* eslint-disable */ const $7ddd8dfe443ea91e$var$long_1 = $7ddd8dfe443ea91e$var$__importDefault((parcelRequire("9A55m")));

const $7ddd8dfe443ea91e$var$minimal_1 = $7ddd8dfe443ea91e$var$__importDefault((parcelRequire("i2pIU")));
var $1a19d06bc6442f29$exports = {};
"use strict";
var $1a19d06bc6442f29$var$__importDefault = $1a19d06bc6442f29$exports && $1a19d06bc6442f29$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($1a19d06bc6442f29$exports, "__esModule", {
    value: true
});
$1a19d06bc6442f29$exports.CompressedNonExistenceProof = $1a19d06bc6442f29$exports.CompressedExistenceProof = $1a19d06bc6442f29$exports.CompressedBatchEntry = $1a19d06bc6442f29$exports.CompressedBatchProof = $1a19d06bc6442f29$exports.BatchEntry = $1a19d06bc6442f29$exports.BatchProof = $1a19d06bc6442f29$exports.InnerSpec = $1a19d06bc6442f29$exports.ProofSpec = $1a19d06bc6442f29$exports.InnerOp = $1a19d06bc6442f29$exports.LeafOp = $1a19d06bc6442f29$exports.CommitmentProof = $1a19d06bc6442f29$exports.NonExistenceProof = $1a19d06bc6442f29$exports.ExistenceProof = $1a19d06bc6442f29$exports.lengthOpToJSON = $1a19d06bc6442f29$exports.lengthOpFromJSON = $1a19d06bc6442f29$exports.LengthOp = $1a19d06bc6442f29$exports.hashOpToJSON = $1a19d06bc6442f29$exports.hashOpFromJSON = $1a19d06bc6442f29$exports.HashOp = $1a19d06bc6442f29$exports.protobufPackage = void 0;

/* eslint-disable */ const $1a19d06bc6442f29$var$long_1 = $1a19d06bc6442f29$var$__importDefault((parcelRequire("9A55m")));

const $1a19d06bc6442f29$var$minimal_1 = $1a19d06bc6442f29$var$__importDefault((parcelRequire("i2pIU")));
$1a19d06bc6442f29$exports.protobufPackage = "ics23";
var $1a19d06bc6442f29$var$HashOp;
(function(HashOp) {
    /** NO_HASH - NO_HASH is the default if no data passed. Note this is an illegal argument some places. */ HashOp[HashOp["NO_HASH"] = 0] = "NO_HASH";
    HashOp[HashOp["SHA256"] = 1] = "SHA256";
    HashOp[HashOp["SHA512"] = 2] = "SHA512";
    HashOp[HashOp["KECCAK"] = 3] = "KECCAK";
    HashOp[HashOp["RIPEMD160"] = 4] = "RIPEMD160";
    /** BITCOIN - ripemd160(sha256(x)) */ HashOp[HashOp["BITCOIN"] = 5] = "BITCOIN";
    HashOp[HashOp["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($1a19d06bc6442f29$var$HashOp = $1a19d06bc6442f29$exports.HashOp || ($1a19d06bc6442f29$exports.HashOp = {}));
function $1a19d06bc6442f29$var$hashOpFromJSON(object) {
    switch(object){
        case 0:
        case "NO_HASH":
            return $1a19d06bc6442f29$var$HashOp.NO_HASH;
        case 1:
        case "SHA256":
            return $1a19d06bc6442f29$var$HashOp.SHA256;
        case 2:
        case "SHA512":
            return $1a19d06bc6442f29$var$HashOp.SHA512;
        case 3:
        case "KECCAK":
            return $1a19d06bc6442f29$var$HashOp.KECCAK;
        case 4:
        case "RIPEMD160":
            return $1a19d06bc6442f29$var$HashOp.RIPEMD160;
        case 5:
        case "BITCOIN":
            return $1a19d06bc6442f29$var$HashOp.BITCOIN;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $1a19d06bc6442f29$var$HashOp.UNRECOGNIZED;
    }
}
$1a19d06bc6442f29$exports.hashOpFromJSON = $1a19d06bc6442f29$var$hashOpFromJSON;
function $1a19d06bc6442f29$var$hashOpToJSON(object) {
    switch(object){
        case $1a19d06bc6442f29$var$HashOp.NO_HASH:
            return "NO_HASH";
        case $1a19d06bc6442f29$var$HashOp.SHA256:
            return "SHA256";
        case $1a19d06bc6442f29$var$HashOp.SHA512:
            return "SHA512";
        case $1a19d06bc6442f29$var$HashOp.KECCAK:
            return "KECCAK";
        case $1a19d06bc6442f29$var$HashOp.RIPEMD160:
            return "RIPEMD160";
        case $1a19d06bc6442f29$var$HashOp.BITCOIN:
            return "BITCOIN";
        default:
            return "UNKNOWN";
    }
}
$1a19d06bc6442f29$exports.hashOpToJSON = $1a19d06bc6442f29$var$hashOpToJSON;
/**
 * LengthOp defines how to process the key and value of the LeafOp
 * to include length information. After encoding the length with the given
 * algorithm, the length will be prepended to the key and value bytes.
 * (Each one with it's own encoded length)
 */ var $1a19d06bc6442f29$var$LengthOp;
(function(LengthOp) {
    /** NO_PREFIX - NO_PREFIX don't include any length info */ LengthOp[LengthOp["NO_PREFIX"] = 0] = "NO_PREFIX";
    /** VAR_PROTO - VAR_PROTO uses protobuf (and go-amino) varint encoding of the length */ LengthOp[LengthOp["VAR_PROTO"] = 1] = "VAR_PROTO";
    /** VAR_RLP - VAR_RLP uses rlp int encoding of the length */ LengthOp[LengthOp["VAR_RLP"] = 2] = "VAR_RLP";
    /** FIXED32_BIG - FIXED32_BIG uses big-endian encoding of the length as a 32 bit integer */ LengthOp[LengthOp["FIXED32_BIG"] = 3] = "FIXED32_BIG";
    /** FIXED32_LITTLE - FIXED32_LITTLE uses little-endian encoding of the length as a 32 bit integer */ LengthOp[LengthOp["FIXED32_LITTLE"] = 4] = "FIXED32_LITTLE";
    /** FIXED64_BIG - FIXED64_BIG uses big-endian encoding of the length as a 64 bit integer */ LengthOp[LengthOp["FIXED64_BIG"] = 5] = "FIXED64_BIG";
    /** FIXED64_LITTLE - FIXED64_LITTLE uses little-endian encoding of the length as a 64 bit integer */ LengthOp[LengthOp["FIXED64_LITTLE"] = 6] = "FIXED64_LITTLE";
    /** REQUIRE_32_BYTES - REQUIRE_32_BYTES is like NONE, but will fail if the input is not exactly 32 bytes (sha256 output) */ LengthOp[LengthOp["REQUIRE_32_BYTES"] = 7] = "REQUIRE_32_BYTES";
    /** REQUIRE_64_BYTES - REQUIRE_64_BYTES is like NONE, but will fail if the input is not exactly 64 bytes (sha512 output) */ LengthOp[LengthOp["REQUIRE_64_BYTES"] = 8] = "REQUIRE_64_BYTES";
    LengthOp[LengthOp["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($1a19d06bc6442f29$var$LengthOp = $1a19d06bc6442f29$exports.LengthOp || ($1a19d06bc6442f29$exports.LengthOp = {}));
function $1a19d06bc6442f29$var$lengthOpFromJSON(object) {
    switch(object){
        case 0:
        case "NO_PREFIX":
            return $1a19d06bc6442f29$var$LengthOp.NO_PREFIX;
        case 1:
        case "VAR_PROTO":
            return $1a19d06bc6442f29$var$LengthOp.VAR_PROTO;
        case 2:
        case "VAR_RLP":
            return $1a19d06bc6442f29$var$LengthOp.VAR_RLP;
        case 3:
        case "FIXED32_BIG":
            return $1a19d06bc6442f29$var$LengthOp.FIXED32_BIG;
        case 4:
        case "FIXED32_LITTLE":
            return $1a19d06bc6442f29$var$LengthOp.FIXED32_LITTLE;
        case 5:
        case "FIXED64_BIG":
            return $1a19d06bc6442f29$var$LengthOp.FIXED64_BIG;
        case 6:
        case "FIXED64_LITTLE":
            return $1a19d06bc6442f29$var$LengthOp.FIXED64_LITTLE;
        case 7:
        case "REQUIRE_32_BYTES":
            return $1a19d06bc6442f29$var$LengthOp.REQUIRE_32_BYTES;
        case 8:
        case "REQUIRE_64_BYTES":
            return $1a19d06bc6442f29$var$LengthOp.REQUIRE_64_BYTES;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $1a19d06bc6442f29$var$LengthOp.UNRECOGNIZED;
    }
}
$1a19d06bc6442f29$exports.lengthOpFromJSON = $1a19d06bc6442f29$var$lengthOpFromJSON;
function $1a19d06bc6442f29$var$lengthOpToJSON(object) {
    switch(object){
        case $1a19d06bc6442f29$var$LengthOp.NO_PREFIX:
            return "NO_PREFIX";
        case $1a19d06bc6442f29$var$LengthOp.VAR_PROTO:
            return "VAR_PROTO";
        case $1a19d06bc6442f29$var$LengthOp.VAR_RLP:
            return "VAR_RLP";
        case $1a19d06bc6442f29$var$LengthOp.FIXED32_BIG:
            return "FIXED32_BIG";
        case $1a19d06bc6442f29$var$LengthOp.FIXED32_LITTLE:
            return "FIXED32_LITTLE";
        case $1a19d06bc6442f29$var$LengthOp.FIXED64_BIG:
            return "FIXED64_BIG";
        case $1a19d06bc6442f29$var$LengthOp.FIXED64_LITTLE:
            return "FIXED64_LITTLE";
        case $1a19d06bc6442f29$var$LengthOp.REQUIRE_32_BYTES:
            return "REQUIRE_32_BYTES";
        case $1a19d06bc6442f29$var$LengthOp.REQUIRE_64_BYTES:
            return "REQUIRE_64_BYTES";
        default:
            return "UNKNOWN";
    }
}
$1a19d06bc6442f29$exports.lengthOpToJSON = $1a19d06bc6442f29$var$lengthOpToJSON;
const $1a19d06bc6442f29$var$baseExistenceProof = {};
$1a19d06bc6442f29$exports.ExistenceProof = {
    encode (message, writer = $1a19d06bc6442f29$var$minimal_1.default.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (message.value.length !== 0) writer.uint32(18).bytes(message.value);
        if (message.leaf !== undefined) $1a19d06bc6442f29$exports.LeafOp.encode(message.leaf, writer.uint32(26).fork()).ldelim();
        for (const v of message.path)$1a19d06bc6442f29$exports.InnerOp.encode(v, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1a19d06bc6442f29$var$minimal_1.default.Reader ? input : new $1a19d06bc6442f29$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $1a19d06bc6442f29$var$baseExistenceProof);
        message.path = [];
        message.key = new Uint8Array();
        message.value = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.value = reader.bytes();
                    break;
                case 3:
                    message.leaf = $1a19d06bc6442f29$exports.LeafOp.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.path.push($1a19d06bc6442f29$exports.InnerOp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $1a19d06bc6442f29$var$baseExistenceProof);
        message.key = object.key !== undefined && object.key !== null ? $1a19d06bc6442f29$var$bytesFromBase64(object.key) : new Uint8Array();
        message.value = object.value !== undefined && object.value !== null ? $1a19d06bc6442f29$var$bytesFromBase64(object.value) : new Uint8Array();
        message.leaf = object.leaf !== undefined && object.leaf !== null ? $1a19d06bc6442f29$exports.LeafOp.fromJSON(object.leaf) : undefined;
        message.path = ((_a = object.path) !== null && _a !== void 0 ? _a : []).map((e)=>$1a19d06bc6442f29$exports.InnerOp.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = $1a19d06bc6442f29$var$base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        message.value !== undefined && (obj.value = $1a19d06bc6442f29$var$base64FromBytes(message.value !== undefined ? message.value : new Uint8Array()));
        message.leaf !== undefined && (obj.leaf = message.leaf ? $1a19d06bc6442f29$exports.LeafOp.toJSON(message.leaf) : undefined);
        if (message.path) obj.path = message.path.map((e)=>e ? $1a19d06bc6442f29$exports.InnerOp.toJSON(e) : undefined);
        else obj.path = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $1a19d06bc6442f29$var$baseExistenceProof);
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.leaf = object.leaf !== undefined && object.leaf !== null ? $1a19d06bc6442f29$exports.LeafOp.fromPartial(object.leaf) : undefined;
        message.path = ((_c = object.path) === null || _c === void 0 ? void 0 : _c.map((e)=>$1a19d06bc6442f29$exports.InnerOp.fromPartial(e))) || [];
        return message;
    }
};
const $1a19d06bc6442f29$var$baseNonExistenceProof = {};
$1a19d06bc6442f29$exports.NonExistenceProof = {
    encode (message, writer = $1a19d06bc6442f29$var$minimal_1.default.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (message.left !== undefined) $1a19d06bc6442f29$exports.ExistenceProof.encode(message.left, writer.uint32(18).fork()).ldelim();
        if (message.right !== undefined) $1a19d06bc6442f29$exports.ExistenceProof.encode(message.right, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1a19d06bc6442f29$var$minimal_1.default.Reader ? input : new $1a19d06bc6442f29$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $1a19d06bc6442f29$var$baseNonExistenceProof);
        message.key = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.left = $1a19d06bc6442f29$exports.ExistenceProof.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.right = $1a19d06bc6442f29$exports.ExistenceProof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $1a19d06bc6442f29$var$baseNonExistenceProof);
        message.key = object.key !== undefined && object.key !== null ? $1a19d06bc6442f29$var$bytesFromBase64(object.key) : new Uint8Array();
        message.left = object.left !== undefined && object.left !== null ? $1a19d06bc6442f29$exports.ExistenceProof.fromJSON(object.left) : undefined;
        message.right = object.right !== undefined && object.right !== null ? $1a19d06bc6442f29$exports.ExistenceProof.fromJSON(object.right) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = $1a19d06bc6442f29$var$base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        message.left !== undefined && (obj.left = message.left ? $1a19d06bc6442f29$exports.ExistenceProof.toJSON(message.left) : undefined);
        message.right !== undefined && (obj.right = message.right ? $1a19d06bc6442f29$exports.ExistenceProof.toJSON(message.right) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $1a19d06bc6442f29$var$baseNonExistenceProof);
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.left = object.left !== undefined && object.left !== null ? $1a19d06bc6442f29$exports.ExistenceProof.fromPartial(object.left) : undefined;
        message.right = object.right !== undefined && object.right !== null ? $1a19d06bc6442f29$exports.ExistenceProof.fromPartial(object.right) : undefined;
        return message;
    }
};
const $1a19d06bc6442f29$var$baseCommitmentProof = {};
$1a19d06bc6442f29$exports.CommitmentProof = {
    encode (message, writer = $1a19d06bc6442f29$var$minimal_1.default.Writer.create()) {
        if (message.exist !== undefined) $1a19d06bc6442f29$exports.ExistenceProof.encode(message.exist, writer.uint32(10).fork()).ldelim();
        if (message.nonexist !== undefined) $1a19d06bc6442f29$exports.NonExistenceProof.encode(message.nonexist, writer.uint32(18).fork()).ldelim();
        if (message.batch !== undefined) $1a19d06bc6442f29$exports.BatchProof.encode(message.batch, writer.uint32(26).fork()).ldelim();
        if (message.compressed !== undefined) $1a19d06bc6442f29$exports.CompressedBatchProof.encode(message.compressed, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1a19d06bc6442f29$var$minimal_1.default.Reader ? input : new $1a19d06bc6442f29$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $1a19d06bc6442f29$var$baseCommitmentProof);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.exist = $1a19d06bc6442f29$exports.ExistenceProof.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.nonexist = $1a19d06bc6442f29$exports.NonExistenceProof.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.batch = $1a19d06bc6442f29$exports.BatchProof.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.compressed = $1a19d06bc6442f29$exports.CompressedBatchProof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $1a19d06bc6442f29$var$baseCommitmentProof);
        message.exist = object.exist !== undefined && object.exist !== null ? $1a19d06bc6442f29$exports.ExistenceProof.fromJSON(object.exist) : undefined;
        message.nonexist = object.nonexist !== undefined && object.nonexist !== null ? $1a19d06bc6442f29$exports.NonExistenceProof.fromJSON(object.nonexist) : undefined;
        message.batch = object.batch !== undefined && object.batch !== null ? $1a19d06bc6442f29$exports.BatchProof.fromJSON(object.batch) : undefined;
        message.compressed = object.compressed !== undefined && object.compressed !== null ? $1a19d06bc6442f29$exports.CompressedBatchProof.fromJSON(object.compressed) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.exist !== undefined && (obj.exist = message.exist ? $1a19d06bc6442f29$exports.ExistenceProof.toJSON(message.exist) : undefined);
        message.nonexist !== undefined && (obj.nonexist = message.nonexist ? $1a19d06bc6442f29$exports.NonExistenceProof.toJSON(message.nonexist) : undefined);
        message.batch !== undefined && (obj.batch = message.batch ? $1a19d06bc6442f29$exports.BatchProof.toJSON(message.batch) : undefined);
        message.compressed !== undefined && (obj.compressed = message.compressed ? $1a19d06bc6442f29$exports.CompressedBatchProof.toJSON(message.compressed) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $1a19d06bc6442f29$var$baseCommitmentProof);
        message.exist = object.exist !== undefined && object.exist !== null ? $1a19d06bc6442f29$exports.ExistenceProof.fromPartial(object.exist) : undefined;
        message.nonexist = object.nonexist !== undefined && object.nonexist !== null ? $1a19d06bc6442f29$exports.NonExistenceProof.fromPartial(object.nonexist) : undefined;
        message.batch = object.batch !== undefined && object.batch !== null ? $1a19d06bc6442f29$exports.BatchProof.fromPartial(object.batch) : undefined;
        message.compressed = object.compressed !== undefined && object.compressed !== null ? $1a19d06bc6442f29$exports.CompressedBatchProof.fromPartial(object.compressed) : undefined;
        return message;
    }
};
const $1a19d06bc6442f29$var$baseLeafOp = {
    hash: 0,
    prehashKey: 0,
    prehashValue: 0,
    length: 0
};
$1a19d06bc6442f29$exports.LeafOp = {
    encode (message, writer = $1a19d06bc6442f29$var$minimal_1.default.Writer.create()) {
        if (message.hash !== 0) writer.uint32(8).int32(message.hash);
        if (message.prehashKey !== 0) writer.uint32(16).int32(message.prehashKey);
        if (message.prehashValue !== 0) writer.uint32(24).int32(message.prehashValue);
        if (message.length !== 0) writer.uint32(32).int32(message.length);
        if (message.prefix.length !== 0) writer.uint32(42).bytes(message.prefix);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1a19d06bc6442f29$var$minimal_1.default.Reader ? input : new $1a19d06bc6442f29$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $1a19d06bc6442f29$var$baseLeafOp);
        message.prefix = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.int32();
                    break;
                case 2:
                    message.prehashKey = reader.int32();
                    break;
                case 3:
                    message.prehashValue = reader.int32();
                    break;
                case 4:
                    message.length = reader.int32();
                    break;
                case 5:
                    message.prefix = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $1a19d06bc6442f29$var$baseLeafOp);
        message.hash = object.hash !== undefined && object.hash !== null ? $1a19d06bc6442f29$var$hashOpFromJSON(object.hash) : 0;
        message.prehashKey = object.prehashKey !== undefined && object.prehashKey !== null ? $1a19d06bc6442f29$var$hashOpFromJSON(object.prehashKey) : 0;
        message.prehashValue = object.prehashValue !== undefined && object.prehashValue !== null ? $1a19d06bc6442f29$var$hashOpFromJSON(object.prehashValue) : 0;
        message.length = object.length !== undefined && object.length !== null ? $1a19d06bc6442f29$var$lengthOpFromJSON(object.length) : 0;
        message.prefix = object.prefix !== undefined && object.prefix !== null ? $1a19d06bc6442f29$var$bytesFromBase64(object.prefix) : new Uint8Array();
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = $1a19d06bc6442f29$var$hashOpToJSON(message.hash));
        message.prehashKey !== undefined && (obj.prehashKey = $1a19d06bc6442f29$var$hashOpToJSON(message.prehashKey));
        message.prehashValue !== undefined && (obj.prehashValue = $1a19d06bc6442f29$var$hashOpToJSON(message.prehashValue));
        message.length !== undefined && (obj.length = $1a19d06bc6442f29$var$lengthOpToJSON(message.length));
        message.prefix !== undefined && (obj.prefix = $1a19d06bc6442f29$var$base64FromBytes(message.prefix !== undefined ? message.prefix : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e;
        const message = Object.assign({}, $1a19d06bc6442f29$var$baseLeafOp);
        message.hash = (_a = object.hash) !== null && _a !== void 0 ? _a : 0;
        message.prehashKey = (_b = object.prehashKey) !== null && _b !== void 0 ? _b : 0;
        message.prehashValue = (_c = object.prehashValue) !== null && _c !== void 0 ? _c : 0;
        message.length = (_d = object.length) !== null && _d !== void 0 ? _d : 0;
        message.prefix = (_e = object.prefix) !== null && _e !== void 0 ? _e : new Uint8Array();
        return message;
    }
};
const $1a19d06bc6442f29$var$baseInnerOp = {
    hash: 0
};
$1a19d06bc6442f29$exports.InnerOp = {
    encode (message, writer = $1a19d06bc6442f29$var$minimal_1.default.Writer.create()) {
        if (message.hash !== 0) writer.uint32(8).int32(message.hash);
        if (message.prefix.length !== 0) writer.uint32(18).bytes(message.prefix);
        if (message.suffix.length !== 0) writer.uint32(26).bytes(message.suffix);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1a19d06bc6442f29$var$minimal_1.default.Reader ? input : new $1a19d06bc6442f29$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $1a19d06bc6442f29$var$baseInnerOp);
        message.prefix = new Uint8Array();
        message.suffix = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.int32();
                    break;
                case 2:
                    message.prefix = reader.bytes();
                    break;
                case 3:
                    message.suffix = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $1a19d06bc6442f29$var$baseInnerOp);
        message.hash = object.hash !== undefined && object.hash !== null ? $1a19d06bc6442f29$var$hashOpFromJSON(object.hash) : 0;
        message.prefix = object.prefix !== undefined && object.prefix !== null ? $1a19d06bc6442f29$var$bytesFromBase64(object.prefix) : new Uint8Array();
        message.suffix = object.suffix !== undefined && object.suffix !== null ? $1a19d06bc6442f29$var$bytesFromBase64(object.suffix) : new Uint8Array();
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = $1a19d06bc6442f29$var$hashOpToJSON(message.hash));
        message.prefix !== undefined && (obj.prefix = $1a19d06bc6442f29$var$base64FromBytes(message.prefix !== undefined ? message.prefix : new Uint8Array()));
        message.suffix !== undefined && (obj.suffix = $1a19d06bc6442f29$var$base64FromBytes(message.suffix !== undefined ? message.suffix : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $1a19d06bc6442f29$var$baseInnerOp);
        message.hash = (_a = object.hash) !== null && _a !== void 0 ? _a : 0;
        message.prefix = (_b = object.prefix) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.suffix = (_c = object.suffix) !== null && _c !== void 0 ? _c : new Uint8Array();
        return message;
    }
};
const $1a19d06bc6442f29$var$baseProofSpec = {
    maxDepth: 0,
    minDepth: 0
};
$1a19d06bc6442f29$exports.ProofSpec = {
    encode (message, writer = $1a19d06bc6442f29$var$minimal_1.default.Writer.create()) {
        if (message.leafSpec !== undefined) $1a19d06bc6442f29$exports.LeafOp.encode(message.leafSpec, writer.uint32(10).fork()).ldelim();
        if (message.innerSpec !== undefined) $1a19d06bc6442f29$exports.InnerSpec.encode(message.innerSpec, writer.uint32(18).fork()).ldelim();
        if (message.maxDepth !== 0) writer.uint32(24).int32(message.maxDepth);
        if (message.minDepth !== 0) writer.uint32(32).int32(message.minDepth);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1a19d06bc6442f29$var$minimal_1.default.Reader ? input : new $1a19d06bc6442f29$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $1a19d06bc6442f29$var$baseProofSpec);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.leafSpec = $1a19d06bc6442f29$exports.LeafOp.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.innerSpec = $1a19d06bc6442f29$exports.InnerSpec.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.maxDepth = reader.int32();
                    break;
                case 4:
                    message.minDepth = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $1a19d06bc6442f29$var$baseProofSpec);
        message.leafSpec = object.leafSpec !== undefined && object.leafSpec !== null ? $1a19d06bc6442f29$exports.LeafOp.fromJSON(object.leafSpec) : undefined;
        message.innerSpec = object.innerSpec !== undefined && object.innerSpec !== null ? $1a19d06bc6442f29$exports.InnerSpec.fromJSON(object.innerSpec) : undefined;
        message.maxDepth = object.maxDepth !== undefined && object.maxDepth !== null ? Number(object.maxDepth) : 0;
        message.minDepth = object.minDepth !== undefined && object.minDepth !== null ? Number(object.minDepth) : 0;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.leafSpec !== undefined && (obj.leafSpec = message.leafSpec ? $1a19d06bc6442f29$exports.LeafOp.toJSON(message.leafSpec) : undefined);
        message.innerSpec !== undefined && (obj.innerSpec = message.innerSpec ? $1a19d06bc6442f29$exports.InnerSpec.toJSON(message.innerSpec) : undefined);
        message.maxDepth !== undefined && (obj.maxDepth = message.maxDepth);
        message.minDepth !== undefined && (obj.minDepth = message.minDepth);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $1a19d06bc6442f29$var$baseProofSpec);
        message.leafSpec = object.leafSpec !== undefined && object.leafSpec !== null ? $1a19d06bc6442f29$exports.LeafOp.fromPartial(object.leafSpec) : undefined;
        message.innerSpec = object.innerSpec !== undefined && object.innerSpec !== null ? $1a19d06bc6442f29$exports.InnerSpec.fromPartial(object.innerSpec) : undefined;
        message.maxDepth = (_a = object.maxDepth) !== null && _a !== void 0 ? _a : 0;
        message.minDepth = (_b = object.minDepth) !== null && _b !== void 0 ? _b : 0;
        return message;
    }
};
const $1a19d06bc6442f29$var$baseInnerSpec = {
    childOrder: 0,
    childSize: 0,
    minPrefixLength: 0,
    maxPrefixLength: 0,
    hash: 0
};
$1a19d06bc6442f29$exports.InnerSpec = {
    encode (message, writer = $1a19d06bc6442f29$var$minimal_1.default.Writer.create()) {
        writer.uint32(10).fork();
        for (const v of message.childOrder)writer.int32(v);
        writer.ldelim();
        if (message.childSize !== 0) writer.uint32(16).int32(message.childSize);
        if (message.minPrefixLength !== 0) writer.uint32(24).int32(message.minPrefixLength);
        if (message.maxPrefixLength !== 0) writer.uint32(32).int32(message.maxPrefixLength);
        if (message.emptyChild.length !== 0) writer.uint32(42).bytes(message.emptyChild);
        if (message.hash !== 0) writer.uint32(48).int32(message.hash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1a19d06bc6442f29$var$minimal_1.default.Reader ? input : new $1a19d06bc6442f29$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $1a19d06bc6442f29$var$baseInnerSpec);
        message.childOrder = [];
        message.emptyChild = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.childOrder.push(reader.int32());
                    } else message.childOrder.push(reader.int32());
                    break;
                case 2:
                    message.childSize = reader.int32();
                    break;
                case 3:
                    message.minPrefixLength = reader.int32();
                    break;
                case 4:
                    message.maxPrefixLength = reader.int32();
                    break;
                case 5:
                    message.emptyChild = reader.bytes();
                    break;
                case 6:
                    message.hash = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $1a19d06bc6442f29$var$baseInnerSpec);
        message.childOrder = ((_a = object.childOrder) !== null && _a !== void 0 ? _a : []).map((e)=>Number(e));
        message.childSize = object.childSize !== undefined && object.childSize !== null ? Number(object.childSize) : 0;
        message.minPrefixLength = object.minPrefixLength !== undefined && object.minPrefixLength !== null ? Number(object.minPrefixLength) : 0;
        message.maxPrefixLength = object.maxPrefixLength !== undefined && object.maxPrefixLength !== null ? Number(object.maxPrefixLength) : 0;
        message.emptyChild = object.emptyChild !== undefined && object.emptyChild !== null ? $1a19d06bc6442f29$var$bytesFromBase64(object.emptyChild) : new Uint8Array();
        message.hash = object.hash !== undefined && object.hash !== null ? $1a19d06bc6442f29$var$hashOpFromJSON(object.hash) : 0;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.childOrder) obj.childOrder = message.childOrder.map((e)=>e);
        else obj.childOrder = [];
        message.childSize !== undefined && (obj.childSize = message.childSize);
        message.minPrefixLength !== undefined && (obj.minPrefixLength = message.minPrefixLength);
        message.maxPrefixLength !== undefined && (obj.maxPrefixLength = message.maxPrefixLength);
        message.emptyChild !== undefined && (obj.emptyChild = $1a19d06bc6442f29$var$base64FromBytes(message.emptyChild !== undefined ? message.emptyChild : new Uint8Array()));
        message.hash !== undefined && (obj.hash = $1a19d06bc6442f29$var$hashOpToJSON(message.hash));
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e, _f;
        const message = Object.assign({}, $1a19d06bc6442f29$var$baseInnerSpec);
        message.childOrder = ((_a = object.childOrder) === null || _a === void 0 ? void 0 : _a.map((e)=>e)) || [];
        message.childSize = (_b = object.childSize) !== null && _b !== void 0 ? _b : 0;
        message.minPrefixLength = (_c = object.minPrefixLength) !== null && _c !== void 0 ? _c : 0;
        message.maxPrefixLength = (_d = object.maxPrefixLength) !== null && _d !== void 0 ? _d : 0;
        message.emptyChild = (_e = object.emptyChild) !== null && _e !== void 0 ? _e : new Uint8Array();
        message.hash = (_f = object.hash) !== null && _f !== void 0 ? _f : 0;
        return message;
    }
};
const $1a19d06bc6442f29$var$baseBatchProof = {};
$1a19d06bc6442f29$exports.BatchProof = {
    encode (message, writer = $1a19d06bc6442f29$var$minimal_1.default.Writer.create()) {
        for (const v of message.entries)$1a19d06bc6442f29$exports.BatchEntry.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1a19d06bc6442f29$var$minimal_1.default.Reader ? input : new $1a19d06bc6442f29$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $1a19d06bc6442f29$var$baseBatchProof);
        message.entries = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.entries.push($1a19d06bc6442f29$exports.BatchEntry.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $1a19d06bc6442f29$var$baseBatchProof);
        message.entries = ((_a = object.entries) !== null && _a !== void 0 ? _a : []).map((e)=>$1a19d06bc6442f29$exports.BatchEntry.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.entries) obj.entries = message.entries.map((e)=>e ? $1a19d06bc6442f29$exports.BatchEntry.toJSON(e) : undefined);
        else obj.entries = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $1a19d06bc6442f29$var$baseBatchProof);
        message.entries = ((_a = object.entries) === null || _a === void 0 ? void 0 : _a.map((e)=>$1a19d06bc6442f29$exports.BatchEntry.fromPartial(e))) || [];
        return message;
    }
};
const $1a19d06bc6442f29$var$baseBatchEntry = {};
$1a19d06bc6442f29$exports.BatchEntry = {
    encode (message, writer = $1a19d06bc6442f29$var$minimal_1.default.Writer.create()) {
        if (message.exist !== undefined) $1a19d06bc6442f29$exports.ExistenceProof.encode(message.exist, writer.uint32(10).fork()).ldelim();
        if (message.nonexist !== undefined) $1a19d06bc6442f29$exports.NonExistenceProof.encode(message.nonexist, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1a19d06bc6442f29$var$minimal_1.default.Reader ? input : new $1a19d06bc6442f29$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $1a19d06bc6442f29$var$baseBatchEntry);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.exist = $1a19d06bc6442f29$exports.ExistenceProof.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.nonexist = $1a19d06bc6442f29$exports.NonExistenceProof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $1a19d06bc6442f29$var$baseBatchEntry);
        message.exist = object.exist !== undefined && object.exist !== null ? $1a19d06bc6442f29$exports.ExistenceProof.fromJSON(object.exist) : undefined;
        message.nonexist = object.nonexist !== undefined && object.nonexist !== null ? $1a19d06bc6442f29$exports.NonExistenceProof.fromJSON(object.nonexist) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.exist !== undefined && (obj.exist = message.exist ? $1a19d06bc6442f29$exports.ExistenceProof.toJSON(message.exist) : undefined);
        message.nonexist !== undefined && (obj.nonexist = message.nonexist ? $1a19d06bc6442f29$exports.NonExistenceProof.toJSON(message.nonexist) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $1a19d06bc6442f29$var$baseBatchEntry);
        message.exist = object.exist !== undefined && object.exist !== null ? $1a19d06bc6442f29$exports.ExistenceProof.fromPartial(object.exist) : undefined;
        message.nonexist = object.nonexist !== undefined && object.nonexist !== null ? $1a19d06bc6442f29$exports.NonExistenceProof.fromPartial(object.nonexist) : undefined;
        return message;
    }
};
const $1a19d06bc6442f29$var$baseCompressedBatchProof = {};
$1a19d06bc6442f29$exports.CompressedBatchProof = {
    encode (message, writer = $1a19d06bc6442f29$var$minimal_1.default.Writer.create()) {
        for (const v of message.entries)$1a19d06bc6442f29$exports.CompressedBatchEntry.encode(v, writer.uint32(10).fork()).ldelim();
        for (const v of message.lookupInners)$1a19d06bc6442f29$exports.InnerOp.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1a19d06bc6442f29$var$minimal_1.default.Reader ? input : new $1a19d06bc6442f29$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $1a19d06bc6442f29$var$baseCompressedBatchProof);
        message.entries = [];
        message.lookupInners = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.entries.push($1a19d06bc6442f29$exports.CompressedBatchEntry.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.lookupInners.push($1a19d06bc6442f29$exports.InnerOp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a, _b;
        const message = Object.assign({}, $1a19d06bc6442f29$var$baseCompressedBatchProof);
        message.entries = ((_a = object.entries) !== null && _a !== void 0 ? _a : []).map((e)=>$1a19d06bc6442f29$exports.CompressedBatchEntry.fromJSON(e));
        message.lookupInners = ((_b = object.lookupInners) !== null && _b !== void 0 ? _b : []).map((e)=>$1a19d06bc6442f29$exports.InnerOp.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.entries) obj.entries = message.entries.map((e)=>e ? $1a19d06bc6442f29$exports.CompressedBatchEntry.toJSON(e) : undefined);
        else obj.entries = [];
        if (message.lookupInners) obj.lookupInners = message.lookupInners.map((e)=>e ? $1a19d06bc6442f29$exports.InnerOp.toJSON(e) : undefined);
        else obj.lookupInners = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $1a19d06bc6442f29$var$baseCompressedBatchProof);
        message.entries = ((_a = object.entries) === null || _a === void 0 ? void 0 : _a.map((e)=>$1a19d06bc6442f29$exports.CompressedBatchEntry.fromPartial(e))) || [];
        message.lookupInners = ((_b = object.lookupInners) === null || _b === void 0 ? void 0 : _b.map((e)=>$1a19d06bc6442f29$exports.InnerOp.fromPartial(e))) || [];
        return message;
    }
};
const $1a19d06bc6442f29$var$baseCompressedBatchEntry = {};
$1a19d06bc6442f29$exports.CompressedBatchEntry = {
    encode (message, writer = $1a19d06bc6442f29$var$minimal_1.default.Writer.create()) {
        if (message.exist !== undefined) $1a19d06bc6442f29$exports.CompressedExistenceProof.encode(message.exist, writer.uint32(10).fork()).ldelim();
        if (message.nonexist !== undefined) $1a19d06bc6442f29$exports.CompressedNonExistenceProof.encode(message.nonexist, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1a19d06bc6442f29$var$minimal_1.default.Reader ? input : new $1a19d06bc6442f29$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $1a19d06bc6442f29$var$baseCompressedBatchEntry);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.exist = $1a19d06bc6442f29$exports.CompressedExistenceProof.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.nonexist = $1a19d06bc6442f29$exports.CompressedNonExistenceProof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $1a19d06bc6442f29$var$baseCompressedBatchEntry);
        message.exist = object.exist !== undefined && object.exist !== null ? $1a19d06bc6442f29$exports.CompressedExistenceProof.fromJSON(object.exist) : undefined;
        message.nonexist = object.nonexist !== undefined && object.nonexist !== null ? $1a19d06bc6442f29$exports.CompressedNonExistenceProof.fromJSON(object.nonexist) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.exist !== undefined && (obj.exist = message.exist ? $1a19d06bc6442f29$exports.CompressedExistenceProof.toJSON(message.exist) : undefined);
        message.nonexist !== undefined && (obj.nonexist = message.nonexist ? $1a19d06bc6442f29$exports.CompressedNonExistenceProof.toJSON(message.nonexist) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $1a19d06bc6442f29$var$baseCompressedBatchEntry);
        message.exist = object.exist !== undefined && object.exist !== null ? $1a19d06bc6442f29$exports.CompressedExistenceProof.fromPartial(object.exist) : undefined;
        message.nonexist = object.nonexist !== undefined && object.nonexist !== null ? $1a19d06bc6442f29$exports.CompressedNonExistenceProof.fromPartial(object.nonexist) : undefined;
        return message;
    }
};
const $1a19d06bc6442f29$var$baseCompressedExistenceProof = {
    path: 0
};
$1a19d06bc6442f29$exports.CompressedExistenceProof = {
    encode (message, writer = $1a19d06bc6442f29$var$minimal_1.default.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (message.value.length !== 0) writer.uint32(18).bytes(message.value);
        if (message.leaf !== undefined) $1a19d06bc6442f29$exports.LeafOp.encode(message.leaf, writer.uint32(26).fork()).ldelim();
        writer.uint32(34).fork();
        for (const v of message.path)writer.int32(v);
        writer.ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1a19d06bc6442f29$var$minimal_1.default.Reader ? input : new $1a19d06bc6442f29$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $1a19d06bc6442f29$var$baseCompressedExistenceProof);
        message.path = [];
        message.key = new Uint8Array();
        message.value = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.value = reader.bytes();
                    break;
                case 3:
                    message.leaf = $1a19d06bc6442f29$exports.LeafOp.decode(reader, reader.uint32());
                    break;
                case 4:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.path.push(reader.int32());
                    } else message.path.push(reader.int32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $1a19d06bc6442f29$var$baseCompressedExistenceProof);
        message.key = object.key !== undefined && object.key !== null ? $1a19d06bc6442f29$var$bytesFromBase64(object.key) : new Uint8Array();
        message.value = object.value !== undefined && object.value !== null ? $1a19d06bc6442f29$var$bytesFromBase64(object.value) : new Uint8Array();
        message.leaf = object.leaf !== undefined && object.leaf !== null ? $1a19d06bc6442f29$exports.LeafOp.fromJSON(object.leaf) : undefined;
        message.path = ((_a = object.path) !== null && _a !== void 0 ? _a : []).map((e)=>Number(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = $1a19d06bc6442f29$var$base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        message.value !== undefined && (obj.value = $1a19d06bc6442f29$var$base64FromBytes(message.value !== undefined ? message.value : new Uint8Array()));
        message.leaf !== undefined && (obj.leaf = message.leaf ? $1a19d06bc6442f29$exports.LeafOp.toJSON(message.leaf) : undefined);
        if (message.path) obj.path = message.path.map((e)=>e);
        else obj.path = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $1a19d06bc6442f29$var$baseCompressedExistenceProof);
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.leaf = object.leaf !== undefined && object.leaf !== null ? $1a19d06bc6442f29$exports.LeafOp.fromPartial(object.leaf) : undefined;
        message.path = ((_c = object.path) === null || _c === void 0 ? void 0 : _c.map((e)=>e)) || [];
        return message;
    }
};
const $1a19d06bc6442f29$var$baseCompressedNonExistenceProof = {};
$1a19d06bc6442f29$exports.CompressedNonExistenceProof = {
    encode (message, writer = $1a19d06bc6442f29$var$minimal_1.default.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (message.left !== undefined) $1a19d06bc6442f29$exports.CompressedExistenceProof.encode(message.left, writer.uint32(18).fork()).ldelim();
        if (message.right !== undefined) $1a19d06bc6442f29$exports.CompressedExistenceProof.encode(message.right, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1a19d06bc6442f29$var$minimal_1.default.Reader ? input : new $1a19d06bc6442f29$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $1a19d06bc6442f29$var$baseCompressedNonExistenceProof);
        message.key = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.left = $1a19d06bc6442f29$exports.CompressedExistenceProof.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.right = $1a19d06bc6442f29$exports.CompressedExistenceProof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $1a19d06bc6442f29$var$baseCompressedNonExistenceProof);
        message.key = object.key !== undefined && object.key !== null ? $1a19d06bc6442f29$var$bytesFromBase64(object.key) : new Uint8Array();
        message.left = object.left !== undefined && object.left !== null ? $1a19d06bc6442f29$exports.CompressedExistenceProof.fromJSON(object.left) : undefined;
        message.right = object.right !== undefined && object.right !== null ? $1a19d06bc6442f29$exports.CompressedExistenceProof.fromJSON(object.right) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = $1a19d06bc6442f29$var$base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        message.left !== undefined && (obj.left = message.left ? $1a19d06bc6442f29$exports.CompressedExistenceProof.toJSON(message.left) : undefined);
        message.right !== undefined && (obj.right = message.right ? $1a19d06bc6442f29$exports.CompressedExistenceProof.toJSON(message.right) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $1a19d06bc6442f29$var$baseCompressedNonExistenceProof);
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.left = object.left !== undefined && object.left !== null ? $1a19d06bc6442f29$exports.CompressedExistenceProof.fromPartial(object.left) : undefined;
        message.right = object.right !== undefined && object.right !== null ? $1a19d06bc6442f29$exports.CompressedExistenceProof.fromPartial(object.right) : undefined;
        return message;
    }
};
var $1a19d06bc6442f29$var$globalThis = (()=>{
    if (typeof $1a19d06bc6442f29$var$globalThis !== "undefined") return $1a19d06bc6442f29$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $1a19d06bc6442f29$var$atob = $1a19d06bc6442f29$var$globalThis.atob || ((b64)=>$1a19d06bc6442f29$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $1a19d06bc6442f29$var$bytesFromBase64(b64) {
    const bin = $1a19d06bc6442f29$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $1a19d06bc6442f29$var$btoa = $1a19d06bc6442f29$var$globalThis.btoa || ((bin)=>$1a19d06bc6442f29$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $1a19d06bc6442f29$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $1a19d06bc6442f29$var$btoa(bin.join(""));
}
if ($1a19d06bc6442f29$var$minimal_1.default.util.Long !== $1a19d06bc6442f29$var$long_1.default) {
    $1a19d06bc6442f29$var$minimal_1.default.util.Long = $1a19d06bc6442f29$var$long_1.default;
    $1a19d06bc6442f29$var$minimal_1.default.configure();
}


$7ddd8dfe443ea91e$exports.protobufPackage = "ibc.core.commitment.v1";
const $7ddd8dfe443ea91e$var$baseMerkleRoot = {};
$7ddd8dfe443ea91e$exports.MerkleRoot = {
    encode (message, writer = $7ddd8dfe443ea91e$var$minimal_1.default.Writer.create()) {
        if (message.hash.length !== 0) writer.uint32(10).bytes(message.hash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7ddd8dfe443ea91e$var$minimal_1.default.Reader ? input : new $7ddd8dfe443ea91e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $7ddd8dfe443ea91e$var$baseMerkleRoot);
        message.hash = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $7ddd8dfe443ea91e$var$baseMerkleRoot);
        message.hash = object.hash !== undefined && object.hash !== null ? $7ddd8dfe443ea91e$var$bytesFromBase64(object.hash) : new Uint8Array();
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = $7ddd8dfe443ea91e$var$base64FromBytes(message.hash !== undefined ? message.hash : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $7ddd8dfe443ea91e$var$baseMerkleRoot);
        message.hash = (_a = object.hash) !== null && _a !== void 0 ? _a : new Uint8Array();
        return message;
    }
};
const $7ddd8dfe443ea91e$var$baseMerklePrefix = {};
$7ddd8dfe443ea91e$exports.MerklePrefix = {
    encode (message, writer = $7ddd8dfe443ea91e$var$minimal_1.default.Writer.create()) {
        if (message.keyPrefix.length !== 0) writer.uint32(10).bytes(message.keyPrefix);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7ddd8dfe443ea91e$var$minimal_1.default.Reader ? input : new $7ddd8dfe443ea91e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $7ddd8dfe443ea91e$var$baseMerklePrefix);
        message.keyPrefix = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.keyPrefix = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $7ddd8dfe443ea91e$var$baseMerklePrefix);
        message.keyPrefix = object.keyPrefix !== undefined && object.keyPrefix !== null ? $7ddd8dfe443ea91e$var$bytesFromBase64(object.keyPrefix) : new Uint8Array();
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.keyPrefix !== undefined && (obj.keyPrefix = $7ddd8dfe443ea91e$var$base64FromBytes(message.keyPrefix !== undefined ? message.keyPrefix : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $7ddd8dfe443ea91e$var$baseMerklePrefix);
        message.keyPrefix = (_a = object.keyPrefix) !== null && _a !== void 0 ? _a : new Uint8Array();
        return message;
    }
};
const $7ddd8dfe443ea91e$var$baseMerklePath = {
    keyPath: ""
};
$7ddd8dfe443ea91e$exports.MerklePath = {
    encode (message, writer = $7ddd8dfe443ea91e$var$minimal_1.default.Writer.create()) {
        for (const v of message.keyPath)writer.uint32(10).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7ddd8dfe443ea91e$var$minimal_1.default.Reader ? input : new $7ddd8dfe443ea91e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $7ddd8dfe443ea91e$var$baseMerklePath);
        message.keyPath = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.keyPath.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $7ddd8dfe443ea91e$var$baseMerklePath);
        message.keyPath = ((_a = object.keyPath) !== null && _a !== void 0 ? _a : []).map((e)=>String(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.keyPath) obj.keyPath = message.keyPath.map((e)=>e);
        else obj.keyPath = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $7ddd8dfe443ea91e$var$baseMerklePath);
        message.keyPath = ((_a = object.keyPath) === null || _a === void 0 ? void 0 : _a.map((e)=>e)) || [];
        return message;
    }
};
const $7ddd8dfe443ea91e$var$baseMerkleProof = {};
$7ddd8dfe443ea91e$exports.MerkleProof = {
    encode (message, writer = $7ddd8dfe443ea91e$var$minimal_1.default.Writer.create()) {
        for (const v of message.proofs)$1a19d06bc6442f29$exports.CommitmentProof.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7ddd8dfe443ea91e$var$minimal_1.default.Reader ? input : new $7ddd8dfe443ea91e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $7ddd8dfe443ea91e$var$baseMerkleProof);
        message.proofs = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proofs.push($1a19d06bc6442f29$exports.CommitmentProof.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $7ddd8dfe443ea91e$var$baseMerkleProof);
        message.proofs = ((_a = object.proofs) !== null && _a !== void 0 ? _a : []).map((e)=>$1a19d06bc6442f29$exports.CommitmentProof.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.proofs) obj.proofs = message.proofs.map((e)=>e ? $1a19d06bc6442f29$exports.CommitmentProof.toJSON(e) : undefined);
        else obj.proofs = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $7ddd8dfe443ea91e$var$baseMerkleProof);
        message.proofs = ((_a = object.proofs) === null || _a === void 0 ? void 0 : _a.map((e)=>$1a19d06bc6442f29$exports.CommitmentProof.fromPartial(e))) || [];
        return message;
    }
};
var $7ddd8dfe443ea91e$var$globalThis = (()=>{
    if (typeof $7ddd8dfe443ea91e$var$globalThis !== "undefined") return $7ddd8dfe443ea91e$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $7ddd8dfe443ea91e$var$atob = $7ddd8dfe443ea91e$var$globalThis.atob || ((b64)=>$7ddd8dfe443ea91e$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $7ddd8dfe443ea91e$var$bytesFromBase64(b64) {
    const bin = $7ddd8dfe443ea91e$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $7ddd8dfe443ea91e$var$btoa = $7ddd8dfe443ea91e$var$globalThis.btoa || ((bin)=>$7ddd8dfe443ea91e$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $7ddd8dfe443ea91e$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $7ddd8dfe443ea91e$var$btoa(bin.join(""));
}
if ($7ddd8dfe443ea91e$var$minimal_1.default.util.Long !== $7ddd8dfe443ea91e$var$long_1.default) {
    $7ddd8dfe443ea91e$var$minimal_1.default.util.Long = $7ddd8dfe443ea91e$var$long_1.default;
    $7ddd8dfe443ea91e$var$minimal_1.default.configure();
}


$57765dd48e8b80b9$exports.protobufPackage = "ibc.core.connection.v1";
/**
 * State defines if a connection is in one of the following states:
 * INIT, TRYOPEN, OPEN or UNINITIALIZED.
 */ var $57765dd48e8b80b9$var$State;
(function(State) {
    /** STATE_UNINITIALIZED_UNSPECIFIED - Default State */ State[State["STATE_UNINITIALIZED_UNSPECIFIED"] = 0] = "STATE_UNINITIALIZED_UNSPECIFIED";
    /** STATE_INIT - A connection end has just started the opening handshake. */ State[State["STATE_INIT"] = 1] = "STATE_INIT";
    /**
     * STATE_TRYOPEN - A connection end has acknowledged the handshake step on the counterparty
     * chain.
     */ State[State["STATE_TRYOPEN"] = 2] = "STATE_TRYOPEN";
    /** STATE_OPEN - A connection end has completed the handshake. */ State[State["STATE_OPEN"] = 3] = "STATE_OPEN";
    State[State["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($57765dd48e8b80b9$var$State = $57765dd48e8b80b9$exports.State || ($57765dd48e8b80b9$exports.State = {}));
function $57765dd48e8b80b9$var$stateFromJSON(object) {
    switch(object){
        case 0:
        case "STATE_UNINITIALIZED_UNSPECIFIED":
            return $57765dd48e8b80b9$var$State.STATE_UNINITIALIZED_UNSPECIFIED;
        case 1:
        case "STATE_INIT":
            return $57765dd48e8b80b9$var$State.STATE_INIT;
        case 2:
        case "STATE_TRYOPEN":
            return $57765dd48e8b80b9$var$State.STATE_TRYOPEN;
        case 3:
        case "STATE_OPEN":
            return $57765dd48e8b80b9$var$State.STATE_OPEN;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $57765dd48e8b80b9$var$State.UNRECOGNIZED;
    }
}
$57765dd48e8b80b9$exports.stateFromJSON = $57765dd48e8b80b9$var$stateFromJSON;
function $57765dd48e8b80b9$var$stateToJSON(object) {
    switch(object){
        case $57765dd48e8b80b9$var$State.STATE_UNINITIALIZED_UNSPECIFIED:
            return "STATE_UNINITIALIZED_UNSPECIFIED";
        case $57765dd48e8b80b9$var$State.STATE_INIT:
            return "STATE_INIT";
        case $57765dd48e8b80b9$var$State.STATE_TRYOPEN:
            return "STATE_TRYOPEN";
        case $57765dd48e8b80b9$var$State.STATE_OPEN:
            return "STATE_OPEN";
        default:
            return "UNKNOWN";
    }
}
$57765dd48e8b80b9$exports.stateToJSON = $57765dd48e8b80b9$var$stateToJSON;
const $57765dd48e8b80b9$var$baseConnectionEnd = {
    clientId: "",
    state: 0,
    delayPeriod: $57765dd48e8b80b9$var$long_1.default.UZERO
};
$57765dd48e8b80b9$exports.ConnectionEnd = {
    encode (message, writer = $57765dd48e8b80b9$var$minimal_1.default.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        for (const v of message.versions)$57765dd48e8b80b9$exports.Version.encode(v, writer.uint32(18).fork()).ldelim();
        if (message.state !== 0) writer.uint32(24).int32(message.state);
        if (message.counterparty !== undefined) $57765dd48e8b80b9$exports.Counterparty.encode(message.counterparty, writer.uint32(34).fork()).ldelim();
        if (!message.delayPeriod.isZero()) writer.uint32(40).uint64(message.delayPeriod);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $57765dd48e8b80b9$var$minimal_1.default.Reader ? input : new $57765dd48e8b80b9$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $57765dd48e8b80b9$var$baseConnectionEnd);
        message.versions = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.versions.push($57765dd48e8b80b9$exports.Version.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.state = reader.int32();
                    break;
                case 4:
                    message.counterparty = $57765dd48e8b80b9$exports.Counterparty.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.delayPeriod = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $57765dd48e8b80b9$var$baseConnectionEnd);
        message.clientId = object.clientId !== undefined && object.clientId !== null ? String(object.clientId) : "";
        message.versions = ((_a = object.versions) !== null && _a !== void 0 ? _a : []).map((e)=>$57765dd48e8b80b9$exports.Version.fromJSON(e));
        message.state = object.state !== undefined && object.state !== null ? $57765dd48e8b80b9$var$stateFromJSON(object.state) : 0;
        message.counterparty = object.counterparty !== undefined && object.counterparty !== null ? $57765dd48e8b80b9$exports.Counterparty.fromJSON(object.counterparty) : undefined;
        message.delayPeriod = object.delayPeriod !== undefined && object.delayPeriod !== null ? $57765dd48e8b80b9$var$long_1.default.fromString(object.delayPeriod) : $57765dd48e8b80b9$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        if (message.versions) obj.versions = message.versions.map((e)=>e ? $57765dd48e8b80b9$exports.Version.toJSON(e) : undefined);
        else obj.versions = [];
        message.state !== undefined && (obj.state = $57765dd48e8b80b9$var$stateToJSON(message.state));
        message.counterparty !== undefined && (obj.counterparty = message.counterparty ? $57765dd48e8b80b9$exports.Counterparty.toJSON(message.counterparty) : undefined);
        message.delayPeriod !== undefined && (obj.delayPeriod = (message.delayPeriod || $57765dd48e8b80b9$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $57765dd48e8b80b9$var$baseConnectionEnd);
        message.clientId = (_a = object.clientId) !== null && _a !== void 0 ? _a : "";
        message.versions = ((_b = object.versions) === null || _b === void 0 ? void 0 : _b.map((e)=>$57765dd48e8b80b9$exports.Version.fromPartial(e))) || [];
        message.state = (_c = object.state) !== null && _c !== void 0 ? _c : 0;
        message.counterparty = object.counterparty !== undefined && object.counterparty !== null ? $57765dd48e8b80b9$exports.Counterparty.fromPartial(object.counterparty) : undefined;
        message.delayPeriod = object.delayPeriod !== undefined && object.delayPeriod !== null ? $57765dd48e8b80b9$var$long_1.default.fromValue(object.delayPeriod) : $57765dd48e8b80b9$var$long_1.default.UZERO;
        return message;
    }
};
const $57765dd48e8b80b9$var$baseIdentifiedConnection = {
    id: "",
    clientId: "",
    state: 0,
    delayPeriod: $57765dd48e8b80b9$var$long_1.default.UZERO
};
$57765dd48e8b80b9$exports.IdentifiedConnection = {
    encode (message, writer = $57765dd48e8b80b9$var$minimal_1.default.Writer.create()) {
        if (message.id !== "") writer.uint32(10).string(message.id);
        if (message.clientId !== "") writer.uint32(18).string(message.clientId);
        for (const v of message.versions)$57765dd48e8b80b9$exports.Version.encode(v, writer.uint32(26).fork()).ldelim();
        if (message.state !== 0) writer.uint32(32).int32(message.state);
        if (message.counterparty !== undefined) $57765dd48e8b80b9$exports.Counterparty.encode(message.counterparty, writer.uint32(42).fork()).ldelim();
        if (!message.delayPeriod.isZero()) writer.uint32(48).uint64(message.delayPeriod);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $57765dd48e8b80b9$var$minimal_1.default.Reader ? input : new $57765dd48e8b80b9$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $57765dd48e8b80b9$var$baseIdentifiedConnection);
        message.versions = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.clientId = reader.string();
                    break;
                case 3:
                    message.versions.push($57765dd48e8b80b9$exports.Version.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.state = reader.int32();
                    break;
                case 5:
                    message.counterparty = $57765dd48e8b80b9$exports.Counterparty.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.delayPeriod = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $57765dd48e8b80b9$var$baseIdentifiedConnection);
        message.id = object.id !== undefined && object.id !== null ? String(object.id) : "";
        message.clientId = object.clientId !== undefined && object.clientId !== null ? String(object.clientId) : "";
        message.versions = ((_a = object.versions) !== null && _a !== void 0 ? _a : []).map((e)=>$57765dd48e8b80b9$exports.Version.fromJSON(e));
        message.state = object.state !== undefined && object.state !== null ? $57765dd48e8b80b9$var$stateFromJSON(object.state) : 0;
        message.counterparty = object.counterparty !== undefined && object.counterparty !== null ? $57765dd48e8b80b9$exports.Counterparty.fromJSON(object.counterparty) : undefined;
        message.delayPeriod = object.delayPeriod !== undefined && object.delayPeriod !== null ? $57765dd48e8b80b9$var$long_1.default.fromString(object.delayPeriod) : $57765dd48e8b80b9$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.id !== undefined && (obj.id = message.id);
        message.clientId !== undefined && (obj.clientId = message.clientId);
        if (message.versions) obj.versions = message.versions.map((e)=>e ? $57765dd48e8b80b9$exports.Version.toJSON(e) : undefined);
        else obj.versions = [];
        message.state !== undefined && (obj.state = $57765dd48e8b80b9$var$stateToJSON(message.state));
        message.counterparty !== undefined && (obj.counterparty = message.counterparty ? $57765dd48e8b80b9$exports.Counterparty.toJSON(message.counterparty) : undefined);
        message.delayPeriod !== undefined && (obj.delayPeriod = (message.delayPeriod || $57765dd48e8b80b9$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = Object.assign({}, $57765dd48e8b80b9$var$baseIdentifiedConnection);
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        message.clientId = (_b = object.clientId) !== null && _b !== void 0 ? _b : "";
        message.versions = ((_c = object.versions) === null || _c === void 0 ? void 0 : _c.map((e)=>$57765dd48e8b80b9$exports.Version.fromPartial(e))) || [];
        message.state = (_d = object.state) !== null && _d !== void 0 ? _d : 0;
        message.counterparty = object.counterparty !== undefined && object.counterparty !== null ? $57765dd48e8b80b9$exports.Counterparty.fromPartial(object.counterparty) : undefined;
        message.delayPeriod = object.delayPeriod !== undefined && object.delayPeriod !== null ? $57765dd48e8b80b9$var$long_1.default.fromValue(object.delayPeriod) : $57765dd48e8b80b9$var$long_1.default.UZERO;
        return message;
    }
};
const $57765dd48e8b80b9$var$baseCounterparty = {
    clientId: "",
    connectionId: ""
};
$57765dd48e8b80b9$exports.Counterparty = {
    encode (message, writer = $57765dd48e8b80b9$var$minimal_1.default.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.connectionId !== "") writer.uint32(18).string(message.connectionId);
        if (message.prefix !== undefined) $7ddd8dfe443ea91e$exports.MerklePrefix.encode(message.prefix, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $57765dd48e8b80b9$var$minimal_1.default.Reader ? input : new $57765dd48e8b80b9$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $57765dd48e8b80b9$var$baseCounterparty);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.connectionId = reader.string();
                    break;
                case 3:
                    message.prefix = $7ddd8dfe443ea91e$exports.MerklePrefix.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $57765dd48e8b80b9$var$baseCounterparty);
        message.clientId = object.clientId !== undefined && object.clientId !== null ? String(object.clientId) : "";
        message.connectionId = object.connectionId !== undefined && object.connectionId !== null ? String(object.connectionId) : "";
        message.prefix = object.prefix !== undefined && object.prefix !== null ? $7ddd8dfe443ea91e$exports.MerklePrefix.fromJSON(object.prefix) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        message.prefix !== undefined && (obj.prefix = message.prefix ? $7ddd8dfe443ea91e$exports.MerklePrefix.toJSON(message.prefix) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $57765dd48e8b80b9$var$baseCounterparty);
        message.clientId = (_a = object.clientId) !== null && _a !== void 0 ? _a : "";
        message.connectionId = (_b = object.connectionId) !== null && _b !== void 0 ? _b : "";
        message.prefix = object.prefix !== undefined && object.prefix !== null ? $7ddd8dfe443ea91e$exports.MerklePrefix.fromPartial(object.prefix) : undefined;
        return message;
    }
};
const $57765dd48e8b80b9$var$baseClientPaths = {
    paths: ""
};
$57765dd48e8b80b9$exports.ClientPaths = {
    encode (message, writer = $57765dd48e8b80b9$var$minimal_1.default.Writer.create()) {
        for (const v of message.paths)writer.uint32(10).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $57765dd48e8b80b9$var$minimal_1.default.Reader ? input : new $57765dd48e8b80b9$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $57765dd48e8b80b9$var$baseClientPaths);
        message.paths = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $57765dd48e8b80b9$var$baseClientPaths);
        message.paths = ((_a = object.paths) !== null && _a !== void 0 ? _a : []).map((e)=>String(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.paths) obj.paths = message.paths.map((e)=>e);
        else obj.paths = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $57765dd48e8b80b9$var$baseClientPaths);
        message.paths = ((_a = object.paths) === null || _a === void 0 ? void 0 : _a.map((e)=>e)) || [];
        return message;
    }
};
const $57765dd48e8b80b9$var$baseConnectionPaths = {
    clientId: "",
    paths: ""
};
$57765dd48e8b80b9$exports.ConnectionPaths = {
    encode (message, writer = $57765dd48e8b80b9$var$minimal_1.default.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        for (const v of message.paths)writer.uint32(18).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $57765dd48e8b80b9$var$minimal_1.default.Reader ? input : new $57765dd48e8b80b9$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $57765dd48e8b80b9$var$baseConnectionPaths);
        message.paths = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.paths.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $57765dd48e8b80b9$var$baseConnectionPaths);
        message.clientId = object.clientId !== undefined && object.clientId !== null ? String(object.clientId) : "";
        message.paths = ((_a = object.paths) !== null && _a !== void 0 ? _a : []).map((e)=>String(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        if (message.paths) obj.paths = message.paths.map((e)=>e);
        else obj.paths = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $57765dd48e8b80b9$var$baseConnectionPaths);
        message.clientId = (_a = object.clientId) !== null && _a !== void 0 ? _a : "";
        message.paths = ((_b = object.paths) === null || _b === void 0 ? void 0 : _b.map((e)=>e)) || [];
        return message;
    }
};
const $57765dd48e8b80b9$var$baseVersion = {
    identifier: "",
    features: ""
};
$57765dd48e8b80b9$exports.Version = {
    encode (message, writer = $57765dd48e8b80b9$var$minimal_1.default.Writer.create()) {
        if (message.identifier !== "") writer.uint32(10).string(message.identifier);
        for (const v of message.features)writer.uint32(18).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $57765dd48e8b80b9$var$minimal_1.default.Reader ? input : new $57765dd48e8b80b9$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $57765dd48e8b80b9$var$baseVersion);
        message.features = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.identifier = reader.string();
                    break;
                case 2:
                    message.features.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $57765dd48e8b80b9$var$baseVersion);
        message.identifier = object.identifier !== undefined && object.identifier !== null ? String(object.identifier) : "";
        message.features = ((_a = object.features) !== null && _a !== void 0 ? _a : []).map((e)=>String(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.identifier !== undefined && (obj.identifier = message.identifier);
        if (message.features) obj.features = message.features.map((e)=>e);
        else obj.features = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $57765dd48e8b80b9$var$baseVersion);
        message.identifier = (_a = object.identifier) !== null && _a !== void 0 ? _a : "";
        message.features = ((_b = object.features) === null || _b === void 0 ? void 0 : _b.map((e)=>e)) || [];
        return message;
    }
};
if ($57765dd48e8b80b9$var$minimal_1.default.util.Long !== $57765dd48e8b80b9$var$long_1.default) {
    $57765dd48e8b80b9$var$minimal_1.default.util.Long = $57765dd48e8b80b9$var$long_1.default;
    $57765dd48e8b80b9$var$minimal_1.default.configure();
}




$8e0bc4d4001974df$exports.protobufPackage = "ibc.core.connection.v1";
const $8e0bc4d4001974df$var$baseMsgConnectionOpenInit = {
    clientId: "",
    delayPeriod: $8e0bc4d4001974df$var$long_1.default.UZERO,
    signer: ""
};
$8e0bc4d4001974df$exports.MsgConnectionOpenInit = {
    encode (message, writer = $8e0bc4d4001974df$var$minimal_1.default.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.counterparty !== undefined) $57765dd48e8b80b9$exports.Counterparty.encode(message.counterparty, writer.uint32(18).fork()).ldelim();
        if (message.version !== undefined) $57765dd48e8b80b9$exports.Version.encode(message.version, writer.uint32(26).fork()).ldelim();
        if (!message.delayPeriod.isZero()) writer.uint32(32).uint64(message.delayPeriod);
        if (message.signer !== "") writer.uint32(42).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8e0bc4d4001974df$var$minimal_1.default.Reader ? input : new $8e0bc4d4001974df$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $8e0bc4d4001974df$var$baseMsgConnectionOpenInit);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.counterparty = $57765dd48e8b80b9$exports.Counterparty.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.version = $57765dd48e8b80b9$exports.Version.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.delayPeriod = reader.uint64();
                    break;
                case 5:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $8e0bc4d4001974df$var$baseMsgConnectionOpenInit);
        message.clientId = object.clientId !== undefined && object.clientId !== null ? String(object.clientId) : "";
        message.counterparty = object.counterparty !== undefined && object.counterparty !== null ? $57765dd48e8b80b9$exports.Counterparty.fromJSON(object.counterparty) : undefined;
        message.version = object.version !== undefined && object.version !== null ? $57765dd48e8b80b9$exports.Version.fromJSON(object.version) : undefined;
        message.delayPeriod = object.delayPeriod !== undefined && object.delayPeriod !== null ? $8e0bc4d4001974df$var$long_1.default.fromString(object.delayPeriod) : $8e0bc4d4001974df$var$long_1.default.UZERO;
        message.signer = object.signer !== undefined && object.signer !== null ? String(object.signer) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.counterparty !== undefined && (obj.counterparty = message.counterparty ? $57765dd48e8b80b9$exports.Counterparty.toJSON(message.counterparty) : undefined);
        message.version !== undefined && (obj.version = message.version ? $57765dd48e8b80b9$exports.Version.toJSON(message.version) : undefined);
        message.delayPeriod !== undefined && (obj.delayPeriod = (message.delayPeriod || $8e0bc4d4001974df$var$long_1.default.UZERO).toString());
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $8e0bc4d4001974df$var$baseMsgConnectionOpenInit);
        message.clientId = (_a = object.clientId) !== null && _a !== void 0 ? _a : "";
        message.counterparty = object.counterparty !== undefined && object.counterparty !== null ? $57765dd48e8b80b9$exports.Counterparty.fromPartial(object.counterparty) : undefined;
        message.version = object.version !== undefined && object.version !== null ? $57765dd48e8b80b9$exports.Version.fromPartial(object.version) : undefined;
        message.delayPeriod = object.delayPeriod !== undefined && object.delayPeriod !== null ? $8e0bc4d4001974df$var$long_1.default.fromValue(object.delayPeriod) : $8e0bc4d4001974df$var$long_1.default.UZERO;
        message.signer = (_b = object.signer) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
const $8e0bc4d4001974df$var$baseMsgConnectionOpenInitResponse = {};
$8e0bc4d4001974df$exports.MsgConnectionOpenInitResponse = {
    encode (_, writer = $8e0bc4d4001974df$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8e0bc4d4001974df$var$minimal_1.default.Reader ? input : new $8e0bc4d4001974df$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $8e0bc4d4001974df$var$baseMsgConnectionOpenInitResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $8e0bc4d4001974df$var$baseMsgConnectionOpenInitResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $8e0bc4d4001974df$var$baseMsgConnectionOpenInitResponse);
        return message;
    }
};
const $8e0bc4d4001974df$var$baseMsgConnectionOpenTry = {
    clientId: "",
    previousConnectionId: "",
    delayPeriod: $8e0bc4d4001974df$var$long_1.default.UZERO,
    signer: ""
};
$8e0bc4d4001974df$exports.MsgConnectionOpenTry = {
    encode (message, writer = $8e0bc4d4001974df$var$minimal_1.default.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.previousConnectionId !== "") writer.uint32(18).string(message.previousConnectionId);
        if (message.clientState !== undefined) $4232fce010c3a46b$exports.Any.encode(message.clientState, writer.uint32(26).fork()).ldelim();
        if (message.counterparty !== undefined) $57765dd48e8b80b9$exports.Counterparty.encode(message.counterparty, writer.uint32(34).fork()).ldelim();
        if (!message.delayPeriod.isZero()) writer.uint32(40).uint64(message.delayPeriod);
        for (const v of message.counterpartyVersions)$57765dd48e8b80b9$exports.Version.encode(v, writer.uint32(50).fork()).ldelim();
        if (message.proofHeight !== undefined) $0935332a1587f29e$exports.Height.encode(message.proofHeight, writer.uint32(58).fork()).ldelim();
        if (message.proofInit.length !== 0) writer.uint32(66).bytes(message.proofInit);
        if (message.proofClient.length !== 0) writer.uint32(74).bytes(message.proofClient);
        if (message.proofConsensus.length !== 0) writer.uint32(82).bytes(message.proofConsensus);
        if (message.consensusHeight !== undefined) $0935332a1587f29e$exports.Height.encode(message.consensusHeight, writer.uint32(90).fork()).ldelim();
        if (message.signer !== "") writer.uint32(98).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8e0bc4d4001974df$var$minimal_1.default.Reader ? input : new $8e0bc4d4001974df$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $8e0bc4d4001974df$var$baseMsgConnectionOpenTry);
        message.counterpartyVersions = [];
        message.proofInit = new Uint8Array();
        message.proofClient = new Uint8Array();
        message.proofConsensus = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.previousConnectionId = reader.string();
                    break;
                case 3:
                    message.clientState = $4232fce010c3a46b$exports.Any.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.counterparty = $57765dd48e8b80b9$exports.Counterparty.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.delayPeriod = reader.uint64();
                    break;
                case 6:
                    message.counterpartyVersions.push($57765dd48e8b80b9$exports.Version.decode(reader, reader.uint32()));
                    break;
                case 7:
                    message.proofHeight = $0935332a1587f29e$exports.Height.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.proofInit = reader.bytes();
                    break;
                case 9:
                    message.proofClient = reader.bytes();
                    break;
                case 10:
                    message.proofConsensus = reader.bytes();
                    break;
                case 11:
                    message.consensusHeight = $0935332a1587f29e$exports.Height.decode(reader, reader.uint32());
                    break;
                case 12:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $8e0bc4d4001974df$var$baseMsgConnectionOpenTry);
        message.clientId = object.clientId !== undefined && object.clientId !== null ? String(object.clientId) : "";
        message.previousConnectionId = object.previousConnectionId !== undefined && object.previousConnectionId !== null ? String(object.previousConnectionId) : "";
        message.clientState = object.clientState !== undefined && object.clientState !== null ? $4232fce010c3a46b$exports.Any.fromJSON(object.clientState) : undefined;
        message.counterparty = object.counterparty !== undefined && object.counterparty !== null ? $57765dd48e8b80b9$exports.Counterparty.fromJSON(object.counterparty) : undefined;
        message.delayPeriod = object.delayPeriod !== undefined && object.delayPeriod !== null ? $8e0bc4d4001974df$var$long_1.default.fromString(object.delayPeriod) : $8e0bc4d4001974df$var$long_1.default.UZERO;
        message.counterpartyVersions = ((_a = object.counterpartyVersions) !== null && _a !== void 0 ? _a : []).map((e)=>$57765dd48e8b80b9$exports.Version.fromJSON(e));
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromJSON(object.proofHeight) : undefined;
        message.proofInit = object.proofInit !== undefined && object.proofInit !== null ? $8e0bc4d4001974df$var$bytesFromBase64(object.proofInit) : new Uint8Array();
        message.proofClient = object.proofClient !== undefined && object.proofClient !== null ? $8e0bc4d4001974df$var$bytesFromBase64(object.proofClient) : new Uint8Array();
        message.proofConsensus = object.proofConsensus !== undefined && object.proofConsensus !== null ? $8e0bc4d4001974df$var$bytesFromBase64(object.proofConsensus) : new Uint8Array();
        message.consensusHeight = object.consensusHeight !== undefined && object.consensusHeight !== null ? $0935332a1587f29e$exports.Height.fromJSON(object.consensusHeight) : undefined;
        message.signer = object.signer !== undefined && object.signer !== null ? String(object.signer) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.previousConnectionId !== undefined && (obj.previousConnectionId = message.previousConnectionId);
        message.clientState !== undefined && (obj.clientState = message.clientState ? $4232fce010c3a46b$exports.Any.toJSON(message.clientState) : undefined);
        message.counterparty !== undefined && (obj.counterparty = message.counterparty ? $57765dd48e8b80b9$exports.Counterparty.toJSON(message.counterparty) : undefined);
        message.delayPeriod !== undefined && (obj.delayPeriod = (message.delayPeriod || $8e0bc4d4001974df$var$long_1.default.UZERO).toString());
        if (message.counterpartyVersions) obj.counterpartyVersions = message.counterpartyVersions.map((e)=>e ? $57765dd48e8b80b9$exports.Version.toJSON(e) : undefined);
        else obj.counterpartyVersions = [];
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $0935332a1587f29e$exports.Height.toJSON(message.proofHeight) : undefined);
        message.proofInit !== undefined && (obj.proofInit = $8e0bc4d4001974df$var$base64FromBytes(message.proofInit !== undefined ? message.proofInit : new Uint8Array()));
        message.proofClient !== undefined && (obj.proofClient = $8e0bc4d4001974df$var$base64FromBytes(message.proofClient !== undefined ? message.proofClient : new Uint8Array()));
        message.proofConsensus !== undefined && (obj.proofConsensus = $8e0bc4d4001974df$var$base64FromBytes(message.proofConsensus !== undefined ? message.proofConsensus : new Uint8Array()));
        message.consensusHeight !== undefined && (obj.consensusHeight = message.consensusHeight ? $0935332a1587f29e$exports.Height.toJSON(message.consensusHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e, _f, _g;
        const message = Object.assign({}, $8e0bc4d4001974df$var$baseMsgConnectionOpenTry);
        message.clientId = (_a = object.clientId) !== null && _a !== void 0 ? _a : "";
        message.previousConnectionId = (_b = object.previousConnectionId) !== null && _b !== void 0 ? _b : "";
        message.clientState = object.clientState !== undefined && object.clientState !== null ? $4232fce010c3a46b$exports.Any.fromPartial(object.clientState) : undefined;
        message.counterparty = object.counterparty !== undefined && object.counterparty !== null ? $57765dd48e8b80b9$exports.Counterparty.fromPartial(object.counterparty) : undefined;
        message.delayPeriod = object.delayPeriod !== undefined && object.delayPeriod !== null ? $8e0bc4d4001974df$var$long_1.default.fromValue(object.delayPeriod) : $8e0bc4d4001974df$var$long_1.default.UZERO;
        message.counterpartyVersions = ((_c = object.counterpartyVersions) === null || _c === void 0 ? void 0 : _c.map((e)=>$57765dd48e8b80b9$exports.Version.fromPartial(e))) || [];
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromPartial(object.proofHeight) : undefined;
        message.proofInit = (_d = object.proofInit) !== null && _d !== void 0 ? _d : new Uint8Array();
        message.proofClient = (_e = object.proofClient) !== null && _e !== void 0 ? _e : new Uint8Array();
        message.proofConsensus = (_f = object.proofConsensus) !== null && _f !== void 0 ? _f : new Uint8Array();
        message.consensusHeight = object.consensusHeight !== undefined && object.consensusHeight !== null ? $0935332a1587f29e$exports.Height.fromPartial(object.consensusHeight) : undefined;
        message.signer = (_g = object.signer) !== null && _g !== void 0 ? _g : "";
        return message;
    }
};
const $8e0bc4d4001974df$var$baseMsgConnectionOpenTryResponse = {};
$8e0bc4d4001974df$exports.MsgConnectionOpenTryResponse = {
    encode (_, writer = $8e0bc4d4001974df$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8e0bc4d4001974df$var$minimal_1.default.Reader ? input : new $8e0bc4d4001974df$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $8e0bc4d4001974df$var$baseMsgConnectionOpenTryResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $8e0bc4d4001974df$var$baseMsgConnectionOpenTryResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $8e0bc4d4001974df$var$baseMsgConnectionOpenTryResponse);
        return message;
    }
};
const $8e0bc4d4001974df$var$baseMsgConnectionOpenAck = {
    connectionId: "",
    counterpartyConnectionId: "",
    signer: ""
};
$8e0bc4d4001974df$exports.MsgConnectionOpenAck = {
    encode (message, writer = $8e0bc4d4001974df$var$minimal_1.default.Writer.create()) {
        if (message.connectionId !== "") writer.uint32(10).string(message.connectionId);
        if (message.counterpartyConnectionId !== "") writer.uint32(18).string(message.counterpartyConnectionId);
        if (message.version !== undefined) $57765dd48e8b80b9$exports.Version.encode(message.version, writer.uint32(26).fork()).ldelim();
        if (message.clientState !== undefined) $4232fce010c3a46b$exports.Any.encode(message.clientState, writer.uint32(34).fork()).ldelim();
        if (message.proofHeight !== undefined) $0935332a1587f29e$exports.Height.encode(message.proofHeight, writer.uint32(42).fork()).ldelim();
        if (message.proofTry.length !== 0) writer.uint32(50).bytes(message.proofTry);
        if (message.proofClient.length !== 0) writer.uint32(58).bytes(message.proofClient);
        if (message.proofConsensus.length !== 0) writer.uint32(66).bytes(message.proofConsensus);
        if (message.consensusHeight !== undefined) $0935332a1587f29e$exports.Height.encode(message.consensusHeight, writer.uint32(74).fork()).ldelim();
        if (message.signer !== "") writer.uint32(82).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8e0bc4d4001974df$var$minimal_1.default.Reader ? input : new $8e0bc4d4001974df$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $8e0bc4d4001974df$var$baseMsgConnectionOpenAck);
        message.proofTry = new Uint8Array();
        message.proofClient = new Uint8Array();
        message.proofConsensus = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connectionId = reader.string();
                    break;
                case 2:
                    message.counterpartyConnectionId = reader.string();
                    break;
                case 3:
                    message.version = $57765dd48e8b80b9$exports.Version.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.clientState = $4232fce010c3a46b$exports.Any.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.proofHeight = $0935332a1587f29e$exports.Height.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.proofTry = reader.bytes();
                    break;
                case 7:
                    message.proofClient = reader.bytes();
                    break;
                case 8:
                    message.proofConsensus = reader.bytes();
                    break;
                case 9:
                    message.consensusHeight = $0935332a1587f29e$exports.Height.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $8e0bc4d4001974df$var$baseMsgConnectionOpenAck);
        message.connectionId = object.connectionId !== undefined && object.connectionId !== null ? String(object.connectionId) : "";
        message.counterpartyConnectionId = object.counterpartyConnectionId !== undefined && object.counterpartyConnectionId !== null ? String(object.counterpartyConnectionId) : "";
        message.version = object.version !== undefined && object.version !== null ? $57765dd48e8b80b9$exports.Version.fromJSON(object.version) : undefined;
        message.clientState = object.clientState !== undefined && object.clientState !== null ? $4232fce010c3a46b$exports.Any.fromJSON(object.clientState) : undefined;
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromJSON(object.proofHeight) : undefined;
        message.proofTry = object.proofTry !== undefined && object.proofTry !== null ? $8e0bc4d4001974df$var$bytesFromBase64(object.proofTry) : new Uint8Array();
        message.proofClient = object.proofClient !== undefined && object.proofClient !== null ? $8e0bc4d4001974df$var$bytesFromBase64(object.proofClient) : new Uint8Array();
        message.proofConsensus = object.proofConsensus !== undefined && object.proofConsensus !== null ? $8e0bc4d4001974df$var$bytesFromBase64(object.proofConsensus) : new Uint8Array();
        message.consensusHeight = object.consensusHeight !== undefined && object.consensusHeight !== null ? $0935332a1587f29e$exports.Height.fromJSON(object.consensusHeight) : undefined;
        message.signer = object.signer !== undefined && object.signer !== null ? String(object.signer) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        message.counterpartyConnectionId !== undefined && (obj.counterpartyConnectionId = message.counterpartyConnectionId);
        message.version !== undefined && (obj.version = message.version ? $57765dd48e8b80b9$exports.Version.toJSON(message.version) : undefined);
        message.clientState !== undefined && (obj.clientState = message.clientState ? $4232fce010c3a46b$exports.Any.toJSON(message.clientState) : undefined);
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $0935332a1587f29e$exports.Height.toJSON(message.proofHeight) : undefined);
        message.proofTry !== undefined && (obj.proofTry = $8e0bc4d4001974df$var$base64FromBytes(message.proofTry !== undefined ? message.proofTry : new Uint8Array()));
        message.proofClient !== undefined && (obj.proofClient = $8e0bc4d4001974df$var$base64FromBytes(message.proofClient !== undefined ? message.proofClient : new Uint8Array()));
        message.proofConsensus !== undefined && (obj.proofConsensus = $8e0bc4d4001974df$var$base64FromBytes(message.proofConsensus !== undefined ? message.proofConsensus : new Uint8Array()));
        message.consensusHeight !== undefined && (obj.consensusHeight = message.consensusHeight ? $0935332a1587f29e$exports.Height.toJSON(message.consensusHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e, _f;
        const message = Object.assign({}, $8e0bc4d4001974df$var$baseMsgConnectionOpenAck);
        message.connectionId = (_a = object.connectionId) !== null && _a !== void 0 ? _a : "";
        message.counterpartyConnectionId = (_b = object.counterpartyConnectionId) !== null && _b !== void 0 ? _b : "";
        message.version = object.version !== undefined && object.version !== null ? $57765dd48e8b80b9$exports.Version.fromPartial(object.version) : undefined;
        message.clientState = object.clientState !== undefined && object.clientState !== null ? $4232fce010c3a46b$exports.Any.fromPartial(object.clientState) : undefined;
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromPartial(object.proofHeight) : undefined;
        message.proofTry = (_c = object.proofTry) !== null && _c !== void 0 ? _c : new Uint8Array();
        message.proofClient = (_d = object.proofClient) !== null && _d !== void 0 ? _d : new Uint8Array();
        message.proofConsensus = (_e = object.proofConsensus) !== null && _e !== void 0 ? _e : new Uint8Array();
        message.consensusHeight = object.consensusHeight !== undefined && object.consensusHeight !== null ? $0935332a1587f29e$exports.Height.fromPartial(object.consensusHeight) : undefined;
        message.signer = (_f = object.signer) !== null && _f !== void 0 ? _f : "";
        return message;
    }
};
const $8e0bc4d4001974df$var$baseMsgConnectionOpenAckResponse = {};
$8e0bc4d4001974df$exports.MsgConnectionOpenAckResponse = {
    encode (_, writer = $8e0bc4d4001974df$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8e0bc4d4001974df$var$minimal_1.default.Reader ? input : new $8e0bc4d4001974df$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $8e0bc4d4001974df$var$baseMsgConnectionOpenAckResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $8e0bc4d4001974df$var$baseMsgConnectionOpenAckResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $8e0bc4d4001974df$var$baseMsgConnectionOpenAckResponse);
        return message;
    }
};
const $8e0bc4d4001974df$var$baseMsgConnectionOpenConfirm = {
    connectionId: "",
    signer: ""
};
$8e0bc4d4001974df$exports.MsgConnectionOpenConfirm = {
    encode (message, writer = $8e0bc4d4001974df$var$minimal_1.default.Writer.create()) {
        if (message.connectionId !== "") writer.uint32(10).string(message.connectionId);
        if (message.proofAck.length !== 0) writer.uint32(18).bytes(message.proofAck);
        if (message.proofHeight !== undefined) $0935332a1587f29e$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        if (message.signer !== "") writer.uint32(34).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8e0bc4d4001974df$var$minimal_1.default.Reader ? input : new $8e0bc4d4001974df$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $8e0bc4d4001974df$var$baseMsgConnectionOpenConfirm);
        message.proofAck = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connectionId = reader.string();
                    break;
                case 2:
                    message.proofAck = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $0935332a1587f29e$exports.Height.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $8e0bc4d4001974df$var$baseMsgConnectionOpenConfirm);
        message.connectionId = object.connectionId !== undefined && object.connectionId !== null ? String(object.connectionId) : "";
        message.proofAck = object.proofAck !== undefined && object.proofAck !== null ? $8e0bc4d4001974df$var$bytesFromBase64(object.proofAck) : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromJSON(object.proofHeight) : undefined;
        message.signer = object.signer !== undefined && object.signer !== null ? String(object.signer) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        message.proofAck !== undefined && (obj.proofAck = $8e0bc4d4001974df$var$base64FromBytes(message.proofAck !== undefined ? message.proofAck : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $0935332a1587f29e$exports.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $8e0bc4d4001974df$var$baseMsgConnectionOpenConfirm);
        message.connectionId = (_a = object.connectionId) !== null && _a !== void 0 ? _a : "";
        message.proofAck = (_b = object.proofAck) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromPartial(object.proofHeight) : undefined;
        message.signer = (_c = object.signer) !== null && _c !== void 0 ? _c : "";
        return message;
    }
};
const $8e0bc4d4001974df$var$baseMsgConnectionOpenConfirmResponse = {};
$8e0bc4d4001974df$exports.MsgConnectionOpenConfirmResponse = {
    encode (_, writer = $8e0bc4d4001974df$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8e0bc4d4001974df$var$minimal_1.default.Reader ? input : new $8e0bc4d4001974df$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $8e0bc4d4001974df$var$baseMsgConnectionOpenConfirmResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $8e0bc4d4001974df$var$baseMsgConnectionOpenConfirmResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $8e0bc4d4001974df$var$baseMsgConnectionOpenConfirmResponse);
        return message;
    }
};
class $8e0bc4d4001974df$var$MsgClientImpl {
    ConnectionOpenInit(request) {
        const data = $8e0bc4d4001974df$exports.MsgConnectionOpenInit.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Msg", "ConnectionOpenInit", data);
        return promise.then((data)=>$8e0bc4d4001974df$exports.MsgConnectionOpenInitResponse.decode(new $8e0bc4d4001974df$var$minimal_1.default.Reader(data)));
    }
    ConnectionOpenTry(request) {
        const data = $8e0bc4d4001974df$exports.MsgConnectionOpenTry.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Msg", "ConnectionOpenTry", data);
        return promise.then((data)=>$8e0bc4d4001974df$exports.MsgConnectionOpenTryResponse.decode(new $8e0bc4d4001974df$var$minimal_1.default.Reader(data)));
    }
    ConnectionOpenAck(request) {
        const data = $8e0bc4d4001974df$exports.MsgConnectionOpenAck.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Msg", "ConnectionOpenAck", data);
        return promise.then((data)=>$8e0bc4d4001974df$exports.MsgConnectionOpenAckResponse.decode(new $8e0bc4d4001974df$var$minimal_1.default.Reader(data)));
    }
    ConnectionOpenConfirm(request) {
        const data = $8e0bc4d4001974df$exports.MsgConnectionOpenConfirm.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Msg", "ConnectionOpenConfirm", data);
        return promise.then((data)=>$8e0bc4d4001974df$exports.MsgConnectionOpenConfirmResponse.decode(new $8e0bc4d4001974df$var$minimal_1.default.Reader(data)));
    }
    constructor(rpc){
        this.rpc = rpc;
        this.ConnectionOpenInit = this.ConnectionOpenInit.bind(this);
        this.ConnectionOpenTry = this.ConnectionOpenTry.bind(this);
        this.ConnectionOpenAck = this.ConnectionOpenAck.bind(this);
        this.ConnectionOpenConfirm = this.ConnectionOpenConfirm.bind(this);
    }
}
$8e0bc4d4001974df$exports.MsgClientImpl = $8e0bc4d4001974df$var$MsgClientImpl;
var $8e0bc4d4001974df$var$globalThis = (()=>{
    if (typeof $8e0bc4d4001974df$var$globalThis !== "undefined") return $8e0bc4d4001974df$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $8e0bc4d4001974df$var$atob = $8e0bc4d4001974df$var$globalThis.atob || ((b64)=>$8e0bc4d4001974df$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $8e0bc4d4001974df$var$bytesFromBase64(b64) {
    const bin = $8e0bc4d4001974df$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $8e0bc4d4001974df$var$btoa = $8e0bc4d4001974df$var$globalThis.btoa || ((bin)=>$8e0bc4d4001974df$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $8e0bc4d4001974df$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $8e0bc4d4001974df$var$btoa(bin.join(""));
}
if ($8e0bc4d4001974df$var$minimal_1.default.util.Long !== $8e0bc4d4001974df$var$long_1.default) {
    $8e0bc4d4001974df$var$minimal_1.default.util.Long = $8e0bc4d4001974df$var$long_1.default;
    $8e0bc4d4001974df$var$minimal_1.default.configure();
}


$cc1ee4a35ebc4a44$exports.ibcTypes = [
    [
        "/ibc.applications.transfer.v1.MsgTransfer",
        $1f4036e8aebd4a0e$exports.MsgTransfer
    ],
    [
        "/ibc.core.channel.v1.MsgAcknowledgement",
        $68521e6ff41dbbae$exports.MsgAcknowledgement
    ],
    [
        "/ibc.core.channel.v1.MsgChannelCloseConfirm",
        $68521e6ff41dbbae$exports.MsgChannelCloseConfirm
    ],
    [
        "/ibc.core.channel.v1.MsgChannelCloseInit",
        $68521e6ff41dbbae$exports.MsgChannelCloseInit
    ],
    [
        "/ibc.core.channel.v1.MsgChannelOpenAck",
        $68521e6ff41dbbae$exports.MsgChannelOpenAck
    ],
    [
        "/ibc.core.channel.v1.MsgChannelOpenConfirm",
        $68521e6ff41dbbae$exports.MsgChannelOpenConfirm
    ],
    [
        "/ibc.core.channel.v1.MsgChannelOpenInit",
        $68521e6ff41dbbae$exports.MsgChannelOpenInit
    ],
    [
        "/ibc.core.channel.v1.MsgChannelOpenTry",
        $68521e6ff41dbbae$exports.MsgChannelOpenTry
    ],
    [
        "/ibc.core.channel.v1.MsgRecvPacket",
        $68521e6ff41dbbae$exports.MsgRecvPacket
    ],
    [
        "/ibc.core.channel.v1.MsgTimeout",
        $68521e6ff41dbbae$exports.MsgTimeout
    ],
    [
        "/ibc.core.channel.v1.MsgTimeoutOnClose",
        $68521e6ff41dbbae$exports.MsgTimeoutOnClose
    ],
    [
        "/ibc.core.client.v1.MsgCreateClient",
        $6894222044d16914$exports.MsgCreateClient
    ],
    [
        "/ibc.core.client.v1.MsgSubmitMisbehaviour",
        $6894222044d16914$exports.MsgSubmitMisbehaviour
    ],
    [
        "/ibc.core.client.v1.MsgUpdateClient",
        $6894222044d16914$exports.MsgUpdateClient
    ],
    [
        "/ibc.core.client.v1.MsgUpgradeClient",
        $6894222044d16914$exports.MsgUpgradeClient
    ],
    [
        "/ibc.core.connection.v1.MsgConnectionOpenAck",
        $8e0bc4d4001974df$exports.MsgConnectionOpenAck
    ],
    [
        "/ibc.core.connection.v1.MsgConnectionOpenConfirm",
        $8e0bc4d4001974df$exports.MsgConnectionOpenConfirm
    ],
    [
        "/ibc.core.connection.v1.MsgConnectionOpenInit",
        $8e0bc4d4001974df$exports.MsgConnectionOpenInit
    ],
    [
        "/ibc.core.connection.v1.MsgConnectionOpenTry",
        $8e0bc4d4001974df$exports.MsgConnectionOpenTry
    ]
];
function $cc1ee4a35ebc4a44$var$isMsgTransferEncodeObject(object) {
    return object.typeUrl === "/ibc.applications.transfer.v1.MsgTransfer";
}
$cc1ee4a35ebc4a44$exports.isMsgTransferEncodeObject = $cc1ee4a35ebc4a44$var$isMsgTransferEncodeObject;


Object.defineProperty($7725f2e3ca016b52$exports, "ibcTypes", {
    enumerable: true,
    get: function() {
        return $cc1ee4a35ebc4a44$exports.ibcTypes;
    }
});
Object.defineProperty($7725f2e3ca016b52$exports, "isMsgTransferEncodeObject", {
    enumerable: true,
    get: function() {
        return $cc1ee4a35ebc4a44$exports.isMsgTransferEncodeObject;
    }
});
var $2c2e312329355287$exports = {};
"use strict";
var $2c2e312329355287$var$__importDefault = $2c2e312329355287$exports && $2c2e312329355287$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($2c2e312329355287$exports, "__esModule", {
    value: true
});
$2c2e312329355287$exports.setupIbcExtension = void 0;

var $5zb9p = parcelRequire("5zb9p");

var $9YIif = parcelRequire("9YIif");
var $702731e477a1a6a1$exports = {};
"use strict";
var $702731e477a1a6a1$var$__importDefault = $702731e477a1a6a1$exports && $702731e477a1a6a1$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($702731e477a1a6a1$exports, "__esModule", {
    value: true
});
$702731e477a1a6a1$exports.QueryClientImpl = $702731e477a1a6a1$exports.QueryParamsResponse = $702731e477a1a6a1$exports.QueryParamsRequest = $702731e477a1a6a1$exports.QueryDenomTracesResponse = $702731e477a1a6a1$exports.QueryDenomTracesRequest = $702731e477a1a6a1$exports.QueryDenomTraceResponse = $702731e477a1a6a1$exports.QueryDenomTraceRequest = $702731e477a1a6a1$exports.protobufPackage = void 0;

/* eslint-disable */ const $702731e477a1a6a1$var$long_1 = $702731e477a1a6a1$var$__importDefault((parcelRequire("9A55m")));

const $702731e477a1a6a1$var$minimal_1 = $702731e477a1a6a1$var$__importDefault((parcelRequire("i2pIU")));
var $28424973bff8485f$exports = {};
"use strict";
var $28424973bff8485f$var$__importDefault = $28424973bff8485f$exports && $28424973bff8485f$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($28424973bff8485f$exports, "__esModule", {
    value: true
});
$28424973bff8485f$exports.Params = $28424973bff8485f$exports.DenomTrace = $28424973bff8485f$exports.FungibleTokenPacketData = $28424973bff8485f$exports.protobufPackage = void 0;

/* eslint-disable */ const $28424973bff8485f$var$long_1 = $28424973bff8485f$var$__importDefault((parcelRequire("9A55m")));

const $28424973bff8485f$var$minimal_1 = $28424973bff8485f$var$__importDefault((parcelRequire("i2pIU")));
$28424973bff8485f$exports.protobufPackage = "ibc.applications.transfer.v1";
const $28424973bff8485f$var$baseFungibleTokenPacketData = {
    denom: "",
    amount: $28424973bff8485f$var$long_1.default.UZERO,
    sender: "",
    receiver: ""
};
$28424973bff8485f$exports.FungibleTokenPacketData = {
    encode (message, writer = $28424973bff8485f$var$minimal_1.default.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (!message.amount.isZero()) writer.uint32(16).uint64(message.amount);
        if (message.sender !== "") writer.uint32(26).string(message.sender);
        if (message.receiver !== "") writer.uint32(34).string(message.receiver);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $28424973bff8485f$var$minimal_1.default.Reader ? input : new $28424973bff8485f$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $28424973bff8485f$var$baseFungibleTokenPacketData);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.amount = reader.uint64();
                    break;
                case 3:
                    message.sender = reader.string();
                    break;
                case 4:
                    message.receiver = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $28424973bff8485f$var$baseFungibleTokenPacketData);
        message.denom = object.denom !== undefined && object.denom !== null ? String(object.denom) : "";
        message.amount = object.amount !== undefined && object.amount !== null ? $28424973bff8485f$var$long_1.default.fromString(object.amount) : $28424973bff8485f$var$long_1.default.UZERO;
        message.sender = object.sender !== undefined && object.sender !== null ? String(object.sender) : "";
        message.receiver = object.receiver !== undefined && object.receiver !== null ? String(object.receiver) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.amount !== undefined && (obj.amount = (message.amount || $28424973bff8485f$var$long_1.default.UZERO).toString());
        message.sender !== undefined && (obj.sender = message.sender);
        message.receiver !== undefined && (obj.receiver = message.receiver);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $28424973bff8485f$var$baseFungibleTokenPacketData);
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        message.amount = object.amount !== undefined && object.amount !== null ? $28424973bff8485f$var$long_1.default.fromValue(object.amount) : $28424973bff8485f$var$long_1.default.UZERO;
        message.sender = (_b = object.sender) !== null && _b !== void 0 ? _b : "";
        message.receiver = (_c = object.receiver) !== null && _c !== void 0 ? _c : "";
        return message;
    }
};
const $28424973bff8485f$var$baseDenomTrace = {
    path: "",
    baseDenom: ""
};
$28424973bff8485f$exports.DenomTrace = {
    encode (message, writer = $28424973bff8485f$var$minimal_1.default.Writer.create()) {
        if (message.path !== "") writer.uint32(10).string(message.path);
        if (message.baseDenom !== "") writer.uint32(18).string(message.baseDenom);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $28424973bff8485f$var$minimal_1.default.Reader ? input : new $28424973bff8485f$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $28424973bff8485f$var$baseDenomTrace);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.path = reader.string();
                    break;
                case 2:
                    message.baseDenom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $28424973bff8485f$var$baseDenomTrace);
        message.path = object.path !== undefined && object.path !== null ? String(object.path) : "";
        message.baseDenom = object.baseDenom !== undefined && object.baseDenom !== null ? String(object.baseDenom) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.path !== undefined && (obj.path = message.path);
        message.baseDenom !== undefined && (obj.baseDenom = message.baseDenom);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $28424973bff8485f$var$baseDenomTrace);
        message.path = (_a = object.path) !== null && _a !== void 0 ? _a : "";
        message.baseDenom = (_b = object.baseDenom) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
const $28424973bff8485f$var$baseParams = {
    sendEnabled: false,
    receiveEnabled: false
};
$28424973bff8485f$exports.Params = {
    encode (message, writer = $28424973bff8485f$var$minimal_1.default.Writer.create()) {
        if (message.sendEnabled === true) writer.uint32(8).bool(message.sendEnabled);
        if (message.receiveEnabled === true) writer.uint32(16).bool(message.receiveEnabled);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $28424973bff8485f$var$minimal_1.default.Reader ? input : new $28424973bff8485f$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $28424973bff8485f$var$baseParams);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sendEnabled = reader.bool();
                    break;
                case 2:
                    message.receiveEnabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $28424973bff8485f$var$baseParams);
        message.sendEnabled = object.sendEnabled !== undefined && object.sendEnabled !== null ? Boolean(object.sendEnabled) : false;
        message.receiveEnabled = object.receiveEnabled !== undefined && object.receiveEnabled !== null ? Boolean(object.receiveEnabled) : false;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.sendEnabled !== undefined && (obj.sendEnabled = message.sendEnabled);
        message.receiveEnabled !== undefined && (obj.receiveEnabled = message.receiveEnabled);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $28424973bff8485f$var$baseParams);
        message.sendEnabled = (_a = object.sendEnabled) !== null && _a !== void 0 ? _a : false;
        message.receiveEnabled = (_b = object.receiveEnabled) !== null && _b !== void 0 ? _b : false;
        return message;
    }
};
if ($28424973bff8485f$var$minimal_1.default.util.Long !== $28424973bff8485f$var$long_1.default) {
    $28424973bff8485f$var$minimal_1.default.util.Long = $28424973bff8485f$var$long_1.default;
    $28424973bff8485f$var$minimal_1.default.configure();
}



$702731e477a1a6a1$exports.protobufPackage = "ibc.applications.transfer.v1";
const $702731e477a1a6a1$var$baseQueryDenomTraceRequest = {
    hash: ""
};
$702731e477a1a6a1$exports.QueryDenomTraceRequest = {
    encode (message, writer = $702731e477a1a6a1$var$minimal_1.default.Writer.create()) {
        if (message.hash !== "") writer.uint32(10).string(message.hash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $702731e477a1a6a1$var$minimal_1.default.Reader ? input : new $702731e477a1a6a1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $702731e477a1a6a1$var$baseQueryDenomTraceRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $702731e477a1a6a1$var$baseQueryDenomTraceRequest);
        message.hash = object.hash !== undefined && object.hash !== null ? String(object.hash) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = message.hash);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $702731e477a1a6a1$var$baseQueryDenomTraceRequest);
        message.hash = (_a = object.hash) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
const $702731e477a1a6a1$var$baseQueryDenomTraceResponse = {};
$702731e477a1a6a1$exports.QueryDenomTraceResponse = {
    encode (message, writer = $702731e477a1a6a1$var$minimal_1.default.Writer.create()) {
        if (message.denomTrace !== undefined) $28424973bff8485f$exports.DenomTrace.encode(message.denomTrace, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $702731e477a1a6a1$var$minimal_1.default.Reader ? input : new $702731e477a1a6a1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $702731e477a1a6a1$var$baseQueryDenomTraceResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denomTrace = $28424973bff8485f$exports.DenomTrace.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $702731e477a1a6a1$var$baseQueryDenomTraceResponse);
        message.denomTrace = object.denomTrace !== undefined && object.denomTrace !== null ? $28424973bff8485f$exports.DenomTrace.fromJSON(object.denomTrace) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.denomTrace !== undefined && (obj.denomTrace = message.denomTrace ? $28424973bff8485f$exports.DenomTrace.toJSON(message.denomTrace) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $702731e477a1a6a1$var$baseQueryDenomTraceResponse);
        message.denomTrace = object.denomTrace !== undefined && object.denomTrace !== null ? $28424973bff8485f$exports.DenomTrace.fromPartial(object.denomTrace) : undefined;
        return message;
    }
};
const $702731e477a1a6a1$var$baseQueryDenomTracesRequest = {};
$702731e477a1a6a1$exports.QueryDenomTracesRequest = {
    encode (message, writer = $702731e477a1a6a1$var$minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $702731e477a1a6a1$var$minimal_1.default.Reader ? input : new $702731e477a1a6a1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $702731e477a1a6a1$var$baseQueryDenomTracesRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pagination = $f01b40e20607eb8e$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $702731e477a1a6a1$var$baseQueryDenomTracesRequest);
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromJSON(object.pagination) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $702731e477a1a6a1$var$baseQueryDenomTracesRequest);
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
const $702731e477a1a6a1$var$baseQueryDenomTracesResponse = {};
$702731e477a1a6a1$exports.QueryDenomTracesResponse = {
    encode (message, writer = $702731e477a1a6a1$var$minimal_1.default.Writer.create()) {
        for (const v of message.denomTraces)$28424973bff8485f$exports.DenomTrace.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $702731e477a1a6a1$var$minimal_1.default.Reader ? input : new $702731e477a1a6a1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $702731e477a1a6a1$var$baseQueryDenomTracesResponse);
        message.denomTraces = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denomTraces.push($28424973bff8485f$exports.DenomTrace.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $f01b40e20607eb8e$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $702731e477a1a6a1$var$baseQueryDenomTracesResponse);
        message.denomTraces = ((_a = object.denomTraces) !== null && _a !== void 0 ? _a : []).map((e)=>$28424973bff8485f$exports.DenomTrace.fromJSON(e));
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromJSON(object.pagination) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.denomTraces) obj.denomTraces = message.denomTraces.map((e)=>e ? $28424973bff8485f$exports.DenomTrace.toJSON(e) : undefined);
        else obj.denomTraces = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $702731e477a1a6a1$var$baseQueryDenomTracesResponse);
        message.denomTraces = ((_a = object.denomTraces) === null || _a === void 0 ? void 0 : _a.map((e)=>$28424973bff8485f$exports.DenomTrace.fromPartial(e))) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
const $702731e477a1a6a1$var$baseQueryParamsRequest = {};
$702731e477a1a6a1$exports.QueryParamsRequest = {
    encode (_, writer = $702731e477a1a6a1$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $702731e477a1a6a1$var$minimal_1.default.Reader ? input : new $702731e477a1a6a1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $702731e477a1a6a1$var$baseQueryParamsRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $702731e477a1a6a1$var$baseQueryParamsRequest);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $702731e477a1a6a1$var$baseQueryParamsRequest);
        return message;
    }
};
const $702731e477a1a6a1$var$baseQueryParamsResponse = {};
$702731e477a1a6a1$exports.QueryParamsResponse = {
    encode (message, writer = $702731e477a1a6a1$var$minimal_1.default.Writer.create()) {
        if (message.params !== undefined) $28424973bff8485f$exports.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $702731e477a1a6a1$var$minimal_1.default.Reader ? input : new $702731e477a1a6a1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $702731e477a1a6a1$var$baseQueryParamsResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $28424973bff8485f$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $702731e477a1a6a1$var$baseQueryParamsResponse);
        message.params = object.params !== undefined && object.params !== null ? $28424973bff8485f$exports.Params.fromJSON(object.params) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? $28424973bff8485f$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $702731e477a1a6a1$var$baseQueryParamsResponse);
        message.params = object.params !== undefined && object.params !== null ? $28424973bff8485f$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
class $702731e477a1a6a1$var$QueryClientImpl {
    DenomTrace(request) {
        const data = $702731e477a1a6a1$exports.QueryDenomTraceRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.applications.transfer.v1.Query", "DenomTrace", data);
        return promise.then((data)=>$702731e477a1a6a1$exports.QueryDenomTraceResponse.decode(new $702731e477a1a6a1$var$minimal_1.default.Reader(data)));
    }
    DenomTraces(request) {
        const data = $702731e477a1a6a1$exports.QueryDenomTracesRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.applications.transfer.v1.Query", "DenomTraces", data);
        return promise.then((data)=>$702731e477a1a6a1$exports.QueryDenomTracesResponse.decode(new $702731e477a1a6a1$var$minimal_1.default.Reader(data)));
    }
    Params(request) {
        const data = $702731e477a1a6a1$exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.applications.transfer.v1.Query", "Params", data);
        return promise.then((data)=>$702731e477a1a6a1$exports.QueryParamsResponse.decode(new $702731e477a1a6a1$var$minimal_1.default.Reader(data)));
    }
    constructor(rpc){
        this.rpc = rpc;
        this.DenomTrace = this.DenomTrace.bind(this);
        this.DenomTraces = this.DenomTraces.bind(this);
        this.Params = this.Params.bind(this);
    }
}
$702731e477a1a6a1$exports.QueryClientImpl = $702731e477a1a6a1$var$QueryClientImpl;
if ($702731e477a1a6a1$var$minimal_1.default.util.Long !== $702731e477a1a6a1$var$long_1.default) {
    $702731e477a1a6a1$var$minimal_1.default.util.Long = $702731e477a1a6a1$var$long_1.default;
    $702731e477a1a6a1$var$minimal_1.default.configure();
}



var $1a62b788fa2f619a$exports = {};
"use strict";
var $1a62b788fa2f619a$var$__importDefault = $1a62b788fa2f619a$exports && $1a62b788fa2f619a$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($1a62b788fa2f619a$exports, "__esModule", {
    value: true
});
$1a62b788fa2f619a$exports.QueryClientImpl = $1a62b788fa2f619a$exports.QueryNextSequenceReceiveResponse = $1a62b788fa2f619a$exports.QueryNextSequenceReceiveRequest = $1a62b788fa2f619a$exports.QueryUnreceivedAcksResponse = $1a62b788fa2f619a$exports.QueryUnreceivedAcksRequest = $1a62b788fa2f619a$exports.QueryUnreceivedPacketsResponse = $1a62b788fa2f619a$exports.QueryUnreceivedPacketsRequest = $1a62b788fa2f619a$exports.QueryPacketAcknowledgementsResponse = $1a62b788fa2f619a$exports.QueryPacketAcknowledgementsRequest = $1a62b788fa2f619a$exports.QueryPacketAcknowledgementResponse = $1a62b788fa2f619a$exports.QueryPacketAcknowledgementRequest = $1a62b788fa2f619a$exports.QueryPacketReceiptResponse = $1a62b788fa2f619a$exports.QueryPacketReceiptRequest = $1a62b788fa2f619a$exports.QueryPacketCommitmentsResponse = $1a62b788fa2f619a$exports.QueryPacketCommitmentsRequest = $1a62b788fa2f619a$exports.QueryPacketCommitmentResponse = $1a62b788fa2f619a$exports.QueryPacketCommitmentRequest = $1a62b788fa2f619a$exports.QueryChannelConsensusStateResponse = $1a62b788fa2f619a$exports.QueryChannelConsensusStateRequest = $1a62b788fa2f619a$exports.QueryChannelClientStateResponse = $1a62b788fa2f619a$exports.QueryChannelClientStateRequest = $1a62b788fa2f619a$exports.QueryConnectionChannelsResponse = $1a62b788fa2f619a$exports.QueryConnectionChannelsRequest = $1a62b788fa2f619a$exports.QueryChannelsResponse = $1a62b788fa2f619a$exports.QueryChannelsRequest = $1a62b788fa2f619a$exports.QueryChannelResponse = $1a62b788fa2f619a$exports.QueryChannelRequest = $1a62b788fa2f619a$exports.protobufPackage = void 0;

/* eslint-disable */ const $1a62b788fa2f619a$var$long_1 = $1a62b788fa2f619a$var$__importDefault((parcelRequire("9A55m")));

const $1a62b788fa2f619a$var$minimal_1 = $1a62b788fa2f619a$var$__importDefault((parcelRequire("i2pIU")));




$1a62b788fa2f619a$exports.protobufPackage = "ibc.core.channel.v1";
const $1a62b788fa2f619a$var$baseQueryChannelRequest = {
    portId: "",
    channelId: ""
};
$1a62b788fa2f619a$exports.QueryChannelRequest = {
    encode (message, writer = $1a62b788fa2f619a$var$minimal_1.default.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1a62b788fa2f619a$var$minimal_1.default.Reader ? input : new $1a62b788fa2f619a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryChannelRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryChannelRequest);
        message.portId = object.portId !== undefined && object.portId !== null ? String(object.portId) : "";
        message.channelId = object.channelId !== undefined && object.channelId !== null ? String(object.channelId) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryChannelRequest);
        message.portId = (_a = object.portId) !== null && _a !== void 0 ? _a : "";
        message.channelId = (_b = object.channelId) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
const $1a62b788fa2f619a$var$baseQueryChannelResponse = {};
$1a62b788fa2f619a$exports.QueryChannelResponse = {
    encode (message, writer = $1a62b788fa2f619a$var$minimal_1.default.Writer.create()) {
        if (message.channel !== undefined) $b98b08f8901f4c6b$exports.Channel.encode(message.channel, writer.uint32(10).fork()).ldelim();
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $0935332a1587f29e$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1a62b788fa2f619a$var$minimal_1.default.Reader ? input : new $1a62b788fa2f619a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryChannelResponse);
        message.proof = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.channel = $b98b08f8901f4c6b$exports.Channel.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $0935332a1587f29e$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryChannelResponse);
        message.channel = object.channel !== undefined && object.channel !== null ? $b98b08f8901f4c6b$exports.Channel.fromJSON(object.channel) : undefined;
        message.proof = object.proof !== undefined && object.proof !== null ? $1a62b788fa2f619a$var$bytesFromBase64(object.proof) : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromJSON(object.proofHeight) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.channel !== undefined && (obj.channel = message.channel ? $b98b08f8901f4c6b$exports.Channel.toJSON(message.channel) : undefined);
        message.proof !== undefined && (obj.proof = $1a62b788fa2f619a$var$base64FromBytes(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $0935332a1587f29e$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryChannelResponse);
        message.channel = object.channel !== undefined && object.channel !== null ? $b98b08f8901f4c6b$exports.Channel.fromPartial(object.channel) : undefined;
        message.proof = (_a = object.proof) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
const $1a62b788fa2f619a$var$baseQueryChannelsRequest = {};
$1a62b788fa2f619a$exports.QueryChannelsRequest = {
    encode (message, writer = $1a62b788fa2f619a$var$minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1a62b788fa2f619a$var$minimal_1.default.Reader ? input : new $1a62b788fa2f619a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryChannelsRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pagination = $f01b40e20607eb8e$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryChannelsRequest);
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromJSON(object.pagination) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryChannelsRequest);
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
const $1a62b788fa2f619a$var$baseQueryChannelsResponse = {};
$1a62b788fa2f619a$exports.QueryChannelsResponse = {
    encode (message, writer = $1a62b788fa2f619a$var$minimal_1.default.Writer.create()) {
        for (const v of message.channels)$b98b08f8901f4c6b$exports.IdentifiedChannel.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        if (message.height !== undefined) $0935332a1587f29e$exports.Height.encode(message.height, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1a62b788fa2f619a$var$minimal_1.default.Reader ? input : new $1a62b788fa2f619a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryChannelsResponse);
        message.channels = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.channels.push($b98b08f8901f4c6b$exports.IdentifiedChannel.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $f01b40e20607eb8e$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = $0935332a1587f29e$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryChannelsResponse);
        message.channels = ((_a = object.channels) !== null && _a !== void 0 ? _a : []).map((e)=>$b98b08f8901f4c6b$exports.IdentifiedChannel.fromJSON(e));
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromJSON(object.pagination) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $0935332a1587f29e$exports.Height.fromJSON(object.height) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.channels) obj.channels = message.channels.map((e)=>e ? $b98b08f8901f4c6b$exports.IdentifiedChannel.toJSON(e) : undefined);
        else obj.channels = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageResponse.toJSON(message.pagination) : undefined);
        message.height !== undefined && (obj.height = message.height ? $0935332a1587f29e$exports.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryChannelsResponse);
        message.channels = ((_a = object.channels) === null || _a === void 0 ? void 0 : _a.map((e)=>$b98b08f8901f4c6b$exports.IdentifiedChannel.fromPartial(e))) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromPartial(object.pagination) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $0935332a1587f29e$exports.Height.fromPartial(object.height) : undefined;
        return message;
    }
};
const $1a62b788fa2f619a$var$baseQueryConnectionChannelsRequest = {
    connection: ""
};
$1a62b788fa2f619a$exports.QueryConnectionChannelsRequest = {
    encode (message, writer = $1a62b788fa2f619a$var$minimal_1.default.Writer.create()) {
        if (message.connection !== "") writer.uint32(10).string(message.connection);
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1a62b788fa2f619a$var$minimal_1.default.Reader ? input : new $1a62b788fa2f619a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryConnectionChannelsRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connection = reader.string();
                    break;
                case 2:
                    message.pagination = $f01b40e20607eb8e$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryConnectionChannelsRequest);
        message.connection = object.connection !== undefined && object.connection !== null ? String(object.connection) : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromJSON(object.pagination) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.connection !== undefined && (obj.connection = message.connection);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryConnectionChannelsRequest);
        message.connection = (_a = object.connection) !== null && _a !== void 0 ? _a : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
const $1a62b788fa2f619a$var$baseQueryConnectionChannelsResponse = {};
$1a62b788fa2f619a$exports.QueryConnectionChannelsResponse = {
    encode (message, writer = $1a62b788fa2f619a$var$minimal_1.default.Writer.create()) {
        for (const v of message.channels)$b98b08f8901f4c6b$exports.IdentifiedChannel.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        if (message.height !== undefined) $0935332a1587f29e$exports.Height.encode(message.height, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1a62b788fa2f619a$var$minimal_1.default.Reader ? input : new $1a62b788fa2f619a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryConnectionChannelsResponse);
        message.channels = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.channels.push($b98b08f8901f4c6b$exports.IdentifiedChannel.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $f01b40e20607eb8e$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = $0935332a1587f29e$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryConnectionChannelsResponse);
        message.channels = ((_a = object.channels) !== null && _a !== void 0 ? _a : []).map((e)=>$b98b08f8901f4c6b$exports.IdentifiedChannel.fromJSON(e));
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromJSON(object.pagination) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $0935332a1587f29e$exports.Height.fromJSON(object.height) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.channels) obj.channels = message.channels.map((e)=>e ? $b98b08f8901f4c6b$exports.IdentifiedChannel.toJSON(e) : undefined);
        else obj.channels = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageResponse.toJSON(message.pagination) : undefined);
        message.height !== undefined && (obj.height = message.height ? $0935332a1587f29e$exports.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryConnectionChannelsResponse);
        message.channels = ((_a = object.channels) === null || _a === void 0 ? void 0 : _a.map((e)=>$b98b08f8901f4c6b$exports.IdentifiedChannel.fromPartial(e))) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromPartial(object.pagination) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $0935332a1587f29e$exports.Height.fromPartial(object.height) : undefined;
        return message;
    }
};
const $1a62b788fa2f619a$var$baseQueryChannelClientStateRequest = {
    portId: "",
    channelId: ""
};
$1a62b788fa2f619a$exports.QueryChannelClientStateRequest = {
    encode (message, writer = $1a62b788fa2f619a$var$minimal_1.default.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1a62b788fa2f619a$var$minimal_1.default.Reader ? input : new $1a62b788fa2f619a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryChannelClientStateRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryChannelClientStateRequest);
        message.portId = object.portId !== undefined && object.portId !== null ? String(object.portId) : "";
        message.channelId = object.channelId !== undefined && object.channelId !== null ? String(object.channelId) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryChannelClientStateRequest);
        message.portId = (_a = object.portId) !== null && _a !== void 0 ? _a : "";
        message.channelId = (_b = object.channelId) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
const $1a62b788fa2f619a$var$baseQueryChannelClientStateResponse = {};
$1a62b788fa2f619a$exports.QueryChannelClientStateResponse = {
    encode (message, writer = $1a62b788fa2f619a$var$minimal_1.default.Writer.create()) {
        if (message.identifiedClientState !== undefined) $0935332a1587f29e$exports.IdentifiedClientState.encode(message.identifiedClientState, writer.uint32(10).fork()).ldelim();
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $0935332a1587f29e$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1a62b788fa2f619a$var$minimal_1.default.Reader ? input : new $1a62b788fa2f619a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryChannelClientStateResponse);
        message.proof = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.identifiedClientState = $0935332a1587f29e$exports.IdentifiedClientState.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $0935332a1587f29e$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryChannelClientStateResponse);
        message.identifiedClientState = object.identifiedClientState !== undefined && object.identifiedClientState !== null ? $0935332a1587f29e$exports.IdentifiedClientState.fromJSON(object.identifiedClientState) : undefined;
        message.proof = object.proof !== undefined && object.proof !== null ? $1a62b788fa2f619a$var$bytesFromBase64(object.proof) : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromJSON(object.proofHeight) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.identifiedClientState !== undefined && (obj.identifiedClientState = message.identifiedClientState ? $0935332a1587f29e$exports.IdentifiedClientState.toJSON(message.identifiedClientState) : undefined);
        message.proof !== undefined && (obj.proof = $1a62b788fa2f619a$var$base64FromBytes(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $0935332a1587f29e$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryChannelClientStateResponse);
        message.identifiedClientState = object.identifiedClientState !== undefined && object.identifiedClientState !== null ? $0935332a1587f29e$exports.IdentifiedClientState.fromPartial(object.identifiedClientState) : undefined;
        message.proof = (_a = object.proof) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
const $1a62b788fa2f619a$var$baseQueryChannelConsensusStateRequest = {
    portId: "",
    channelId: "",
    revisionNumber: $1a62b788fa2f619a$var$long_1.default.UZERO,
    revisionHeight: $1a62b788fa2f619a$var$long_1.default.UZERO
};
$1a62b788fa2f619a$exports.QueryChannelConsensusStateRequest = {
    encode (message, writer = $1a62b788fa2f619a$var$minimal_1.default.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (!message.revisionNumber.isZero()) writer.uint32(24).uint64(message.revisionNumber);
        if (!message.revisionHeight.isZero()) writer.uint32(32).uint64(message.revisionHeight);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1a62b788fa2f619a$var$minimal_1.default.Reader ? input : new $1a62b788fa2f619a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryChannelConsensusStateRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.revisionNumber = reader.uint64();
                    break;
                case 4:
                    message.revisionHeight = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryChannelConsensusStateRequest);
        message.portId = object.portId !== undefined && object.portId !== null ? String(object.portId) : "";
        message.channelId = object.channelId !== undefined && object.channelId !== null ? String(object.channelId) : "";
        message.revisionNumber = object.revisionNumber !== undefined && object.revisionNumber !== null ? $1a62b788fa2f619a$var$long_1.default.fromString(object.revisionNumber) : $1a62b788fa2f619a$var$long_1.default.UZERO;
        message.revisionHeight = object.revisionHeight !== undefined && object.revisionHeight !== null ? $1a62b788fa2f619a$var$long_1.default.fromString(object.revisionHeight) : $1a62b788fa2f619a$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.revisionNumber !== undefined && (obj.revisionNumber = (message.revisionNumber || $1a62b788fa2f619a$var$long_1.default.UZERO).toString());
        message.revisionHeight !== undefined && (obj.revisionHeight = (message.revisionHeight || $1a62b788fa2f619a$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryChannelConsensusStateRequest);
        message.portId = (_a = object.portId) !== null && _a !== void 0 ? _a : "";
        message.channelId = (_b = object.channelId) !== null && _b !== void 0 ? _b : "";
        message.revisionNumber = object.revisionNumber !== undefined && object.revisionNumber !== null ? $1a62b788fa2f619a$var$long_1.default.fromValue(object.revisionNumber) : $1a62b788fa2f619a$var$long_1.default.UZERO;
        message.revisionHeight = object.revisionHeight !== undefined && object.revisionHeight !== null ? $1a62b788fa2f619a$var$long_1.default.fromValue(object.revisionHeight) : $1a62b788fa2f619a$var$long_1.default.UZERO;
        return message;
    }
};
const $1a62b788fa2f619a$var$baseQueryChannelConsensusStateResponse = {
    clientId: ""
};
$1a62b788fa2f619a$exports.QueryChannelConsensusStateResponse = {
    encode (message, writer = $1a62b788fa2f619a$var$minimal_1.default.Writer.create()) {
        if (message.consensusState !== undefined) $4232fce010c3a46b$exports.Any.encode(message.consensusState, writer.uint32(10).fork()).ldelim();
        if (message.clientId !== "") writer.uint32(18).string(message.clientId);
        if (message.proof.length !== 0) writer.uint32(26).bytes(message.proof);
        if (message.proofHeight !== undefined) $0935332a1587f29e$exports.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1a62b788fa2f619a$var$minimal_1.default.Reader ? input : new $1a62b788fa2f619a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryChannelConsensusStateResponse);
        message.proof = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.consensusState = $4232fce010c3a46b$exports.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.clientId = reader.string();
                    break;
                case 3:
                    message.proof = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = $0935332a1587f29e$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryChannelConsensusStateResponse);
        message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? $4232fce010c3a46b$exports.Any.fromJSON(object.consensusState) : undefined;
        message.clientId = object.clientId !== undefined && object.clientId !== null ? String(object.clientId) : "";
        message.proof = object.proof !== undefined && object.proof !== null ? $1a62b788fa2f619a$var$bytesFromBase64(object.proof) : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromJSON(object.proofHeight) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.consensusState !== undefined && (obj.consensusState = message.consensusState ? $4232fce010c3a46b$exports.Any.toJSON(message.consensusState) : undefined);
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.proof !== undefined && (obj.proof = $1a62b788fa2f619a$var$base64FromBytes(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $0935332a1587f29e$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryChannelConsensusStateResponse);
        message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? $4232fce010c3a46b$exports.Any.fromPartial(object.consensusState) : undefined;
        message.clientId = (_a = object.clientId) !== null && _a !== void 0 ? _a : "";
        message.proof = (_b = object.proof) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
const $1a62b788fa2f619a$var$baseQueryPacketCommitmentRequest = {
    portId: "",
    channelId: "",
    sequence: $1a62b788fa2f619a$var$long_1.default.UZERO
};
$1a62b788fa2f619a$exports.QueryPacketCommitmentRequest = {
    encode (message, writer = $1a62b788fa2f619a$var$minimal_1.default.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (!message.sequence.isZero()) writer.uint32(24).uint64(message.sequence);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1a62b788fa2f619a$var$minimal_1.default.Reader ? input : new $1a62b788fa2f619a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryPacketCommitmentRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryPacketCommitmentRequest);
        message.portId = object.portId !== undefined && object.portId !== null ? String(object.portId) : "";
        message.channelId = object.channelId !== undefined && object.channelId !== null ? String(object.channelId) : "";
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $1a62b788fa2f619a$var$long_1.default.fromString(object.sequence) : $1a62b788fa2f619a$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.sequence !== undefined && (obj.sequence = (message.sequence || $1a62b788fa2f619a$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryPacketCommitmentRequest);
        message.portId = (_a = object.portId) !== null && _a !== void 0 ? _a : "";
        message.channelId = (_b = object.channelId) !== null && _b !== void 0 ? _b : "";
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $1a62b788fa2f619a$var$long_1.default.fromValue(object.sequence) : $1a62b788fa2f619a$var$long_1.default.UZERO;
        return message;
    }
};
const $1a62b788fa2f619a$var$baseQueryPacketCommitmentResponse = {};
$1a62b788fa2f619a$exports.QueryPacketCommitmentResponse = {
    encode (message, writer = $1a62b788fa2f619a$var$minimal_1.default.Writer.create()) {
        if (message.commitment.length !== 0) writer.uint32(10).bytes(message.commitment);
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $0935332a1587f29e$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1a62b788fa2f619a$var$minimal_1.default.Reader ? input : new $1a62b788fa2f619a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryPacketCommitmentResponse);
        message.commitment = new Uint8Array();
        message.proof = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.commitment = reader.bytes();
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $0935332a1587f29e$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryPacketCommitmentResponse);
        message.commitment = object.commitment !== undefined && object.commitment !== null ? $1a62b788fa2f619a$var$bytesFromBase64(object.commitment) : new Uint8Array();
        message.proof = object.proof !== undefined && object.proof !== null ? $1a62b788fa2f619a$var$bytesFromBase64(object.proof) : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromJSON(object.proofHeight) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.commitment !== undefined && (obj.commitment = $1a62b788fa2f619a$var$base64FromBytes(message.commitment !== undefined ? message.commitment : new Uint8Array()));
        message.proof !== undefined && (obj.proof = $1a62b788fa2f619a$var$base64FromBytes(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $0935332a1587f29e$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryPacketCommitmentResponse);
        message.commitment = (_a = object.commitment) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.proof = (_b = object.proof) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
const $1a62b788fa2f619a$var$baseQueryPacketCommitmentsRequest = {
    portId: "",
    channelId: ""
};
$1a62b788fa2f619a$exports.QueryPacketCommitmentsRequest = {
    encode (message, writer = $1a62b788fa2f619a$var$minimal_1.default.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageRequest.encode(message.pagination, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1a62b788fa2f619a$var$minimal_1.default.Reader ? input : new $1a62b788fa2f619a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryPacketCommitmentsRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.pagination = $f01b40e20607eb8e$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryPacketCommitmentsRequest);
        message.portId = object.portId !== undefined && object.portId !== null ? String(object.portId) : "";
        message.channelId = object.channelId !== undefined && object.channelId !== null ? String(object.channelId) : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromJSON(object.pagination) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryPacketCommitmentsRequest);
        message.portId = (_a = object.portId) !== null && _a !== void 0 ? _a : "";
        message.channelId = (_b = object.channelId) !== null && _b !== void 0 ? _b : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
const $1a62b788fa2f619a$var$baseQueryPacketCommitmentsResponse = {};
$1a62b788fa2f619a$exports.QueryPacketCommitmentsResponse = {
    encode (message, writer = $1a62b788fa2f619a$var$minimal_1.default.Writer.create()) {
        for (const v of message.commitments)$b98b08f8901f4c6b$exports.PacketState.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        if (message.height !== undefined) $0935332a1587f29e$exports.Height.encode(message.height, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1a62b788fa2f619a$var$minimal_1.default.Reader ? input : new $1a62b788fa2f619a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryPacketCommitmentsResponse);
        message.commitments = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.commitments.push($b98b08f8901f4c6b$exports.PacketState.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $f01b40e20607eb8e$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = $0935332a1587f29e$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryPacketCommitmentsResponse);
        message.commitments = ((_a = object.commitments) !== null && _a !== void 0 ? _a : []).map((e)=>$b98b08f8901f4c6b$exports.PacketState.fromJSON(e));
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromJSON(object.pagination) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $0935332a1587f29e$exports.Height.fromJSON(object.height) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.commitments) obj.commitments = message.commitments.map((e)=>e ? $b98b08f8901f4c6b$exports.PacketState.toJSON(e) : undefined);
        else obj.commitments = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageResponse.toJSON(message.pagination) : undefined);
        message.height !== undefined && (obj.height = message.height ? $0935332a1587f29e$exports.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryPacketCommitmentsResponse);
        message.commitments = ((_a = object.commitments) === null || _a === void 0 ? void 0 : _a.map((e)=>$b98b08f8901f4c6b$exports.PacketState.fromPartial(e))) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromPartial(object.pagination) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $0935332a1587f29e$exports.Height.fromPartial(object.height) : undefined;
        return message;
    }
};
const $1a62b788fa2f619a$var$baseQueryPacketReceiptRequest = {
    portId: "",
    channelId: "",
    sequence: $1a62b788fa2f619a$var$long_1.default.UZERO
};
$1a62b788fa2f619a$exports.QueryPacketReceiptRequest = {
    encode (message, writer = $1a62b788fa2f619a$var$minimal_1.default.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (!message.sequence.isZero()) writer.uint32(24).uint64(message.sequence);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1a62b788fa2f619a$var$minimal_1.default.Reader ? input : new $1a62b788fa2f619a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryPacketReceiptRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryPacketReceiptRequest);
        message.portId = object.portId !== undefined && object.portId !== null ? String(object.portId) : "";
        message.channelId = object.channelId !== undefined && object.channelId !== null ? String(object.channelId) : "";
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $1a62b788fa2f619a$var$long_1.default.fromString(object.sequence) : $1a62b788fa2f619a$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.sequence !== undefined && (obj.sequence = (message.sequence || $1a62b788fa2f619a$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryPacketReceiptRequest);
        message.portId = (_a = object.portId) !== null && _a !== void 0 ? _a : "";
        message.channelId = (_b = object.channelId) !== null && _b !== void 0 ? _b : "";
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $1a62b788fa2f619a$var$long_1.default.fromValue(object.sequence) : $1a62b788fa2f619a$var$long_1.default.UZERO;
        return message;
    }
};
const $1a62b788fa2f619a$var$baseQueryPacketReceiptResponse = {
    received: false
};
$1a62b788fa2f619a$exports.QueryPacketReceiptResponse = {
    encode (message, writer = $1a62b788fa2f619a$var$minimal_1.default.Writer.create()) {
        if (message.received === true) writer.uint32(16).bool(message.received);
        if (message.proof.length !== 0) writer.uint32(26).bytes(message.proof);
        if (message.proofHeight !== undefined) $0935332a1587f29e$exports.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1a62b788fa2f619a$var$minimal_1.default.Reader ? input : new $1a62b788fa2f619a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryPacketReceiptResponse);
        message.proof = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 2:
                    message.received = reader.bool();
                    break;
                case 3:
                    message.proof = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = $0935332a1587f29e$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryPacketReceiptResponse);
        message.received = object.received !== undefined && object.received !== null ? Boolean(object.received) : false;
        message.proof = object.proof !== undefined && object.proof !== null ? $1a62b788fa2f619a$var$bytesFromBase64(object.proof) : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromJSON(object.proofHeight) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.received !== undefined && (obj.received = message.received);
        message.proof !== undefined && (obj.proof = $1a62b788fa2f619a$var$base64FromBytes(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $0935332a1587f29e$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryPacketReceiptResponse);
        message.received = (_a = object.received) !== null && _a !== void 0 ? _a : false;
        message.proof = (_b = object.proof) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
const $1a62b788fa2f619a$var$baseQueryPacketAcknowledgementRequest = {
    portId: "",
    channelId: "",
    sequence: $1a62b788fa2f619a$var$long_1.default.UZERO
};
$1a62b788fa2f619a$exports.QueryPacketAcknowledgementRequest = {
    encode (message, writer = $1a62b788fa2f619a$var$minimal_1.default.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (!message.sequence.isZero()) writer.uint32(24).uint64(message.sequence);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1a62b788fa2f619a$var$minimal_1.default.Reader ? input : new $1a62b788fa2f619a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryPacketAcknowledgementRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryPacketAcknowledgementRequest);
        message.portId = object.portId !== undefined && object.portId !== null ? String(object.portId) : "";
        message.channelId = object.channelId !== undefined && object.channelId !== null ? String(object.channelId) : "";
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $1a62b788fa2f619a$var$long_1.default.fromString(object.sequence) : $1a62b788fa2f619a$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.sequence !== undefined && (obj.sequence = (message.sequence || $1a62b788fa2f619a$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryPacketAcknowledgementRequest);
        message.portId = (_a = object.portId) !== null && _a !== void 0 ? _a : "";
        message.channelId = (_b = object.channelId) !== null && _b !== void 0 ? _b : "";
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $1a62b788fa2f619a$var$long_1.default.fromValue(object.sequence) : $1a62b788fa2f619a$var$long_1.default.UZERO;
        return message;
    }
};
const $1a62b788fa2f619a$var$baseQueryPacketAcknowledgementResponse = {};
$1a62b788fa2f619a$exports.QueryPacketAcknowledgementResponse = {
    encode (message, writer = $1a62b788fa2f619a$var$minimal_1.default.Writer.create()) {
        if (message.acknowledgement.length !== 0) writer.uint32(10).bytes(message.acknowledgement);
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $0935332a1587f29e$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1a62b788fa2f619a$var$minimal_1.default.Reader ? input : new $1a62b788fa2f619a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryPacketAcknowledgementResponse);
        message.acknowledgement = new Uint8Array();
        message.proof = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.acknowledgement = reader.bytes();
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $0935332a1587f29e$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryPacketAcknowledgementResponse);
        message.acknowledgement = object.acknowledgement !== undefined && object.acknowledgement !== null ? $1a62b788fa2f619a$var$bytesFromBase64(object.acknowledgement) : new Uint8Array();
        message.proof = object.proof !== undefined && object.proof !== null ? $1a62b788fa2f619a$var$bytesFromBase64(object.proof) : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromJSON(object.proofHeight) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.acknowledgement !== undefined && (obj.acknowledgement = $1a62b788fa2f619a$var$base64FromBytes(message.acknowledgement !== undefined ? message.acknowledgement : new Uint8Array()));
        message.proof !== undefined && (obj.proof = $1a62b788fa2f619a$var$base64FromBytes(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $0935332a1587f29e$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryPacketAcknowledgementResponse);
        message.acknowledgement = (_a = object.acknowledgement) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.proof = (_b = object.proof) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
const $1a62b788fa2f619a$var$baseQueryPacketAcknowledgementsRequest = {
    portId: "",
    channelId: ""
};
$1a62b788fa2f619a$exports.QueryPacketAcknowledgementsRequest = {
    encode (message, writer = $1a62b788fa2f619a$var$minimal_1.default.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageRequest.encode(message.pagination, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1a62b788fa2f619a$var$minimal_1.default.Reader ? input : new $1a62b788fa2f619a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryPacketAcknowledgementsRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.pagination = $f01b40e20607eb8e$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryPacketAcknowledgementsRequest);
        message.portId = object.portId !== undefined && object.portId !== null ? String(object.portId) : "";
        message.channelId = object.channelId !== undefined && object.channelId !== null ? String(object.channelId) : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromJSON(object.pagination) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryPacketAcknowledgementsRequest);
        message.portId = (_a = object.portId) !== null && _a !== void 0 ? _a : "";
        message.channelId = (_b = object.channelId) !== null && _b !== void 0 ? _b : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
const $1a62b788fa2f619a$var$baseQueryPacketAcknowledgementsResponse = {};
$1a62b788fa2f619a$exports.QueryPacketAcknowledgementsResponse = {
    encode (message, writer = $1a62b788fa2f619a$var$minimal_1.default.Writer.create()) {
        for (const v of message.acknowledgements)$b98b08f8901f4c6b$exports.PacketState.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        if (message.height !== undefined) $0935332a1587f29e$exports.Height.encode(message.height, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1a62b788fa2f619a$var$minimal_1.default.Reader ? input : new $1a62b788fa2f619a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryPacketAcknowledgementsResponse);
        message.acknowledgements = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.acknowledgements.push($b98b08f8901f4c6b$exports.PacketState.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $f01b40e20607eb8e$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = $0935332a1587f29e$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryPacketAcknowledgementsResponse);
        message.acknowledgements = ((_a = object.acknowledgements) !== null && _a !== void 0 ? _a : []).map((e)=>$b98b08f8901f4c6b$exports.PacketState.fromJSON(e));
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromJSON(object.pagination) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $0935332a1587f29e$exports.Height.fromJSON(object.height) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.acknowledgements) obj.acknowledgements = message.acknowledgements.map((e)=>e ? $b98b08f8901f4c6b$exports.PacketState.toJSON(e) : undefined);
        else obj.acknowledgements = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageResponse.toJSON(message.pagination) : undefined);
        message.height !== undefined && (obj.height = message.height ? $0935332a1587f29e$exports.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryPacketAcknowledgementsResponse);
        message.acknowledgements = ((_a = object.acknowledgements) === null || _a === void 0 ? void 0 : _a.map((e)=>$b98b08f8901f4c6b$exports.PacketState.fromPartial(e))) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromPartial(object.pagination) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $0935332a1587f29e$exports.Height.fromPartial(object.height) : undefined;
        return message;
    }
};
const $1a62b788fa2f619a$var$baseQueryUnreceivedPacketsRequest = {
    portId: "",
    channelId: "",
    packetCommitmentSequences: $1a62b788fa2f619a$var$long_1.default.UZERO
};
$1a62b788fa2f619a$exports.QueryUnreceivedPacketsRequest = {
    encode (message, writer = $1a62b788fa2f619a$var$minimal_1.default.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        writer.uint32(26).fork();
        for (const v of message.packetCommitmentSequences)writer.uint64(v);
        writer.ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1a62b788fa2f619a$var$minimal_1.default.Reader ? input : new $1a62b788fa2f619a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryUnreceivedPacketsRequest);
        message.packetCommitmentSequences = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.packetCommitmentSequences.push(reader.uint64());
                    } else message.packetCommitmentSequences.push(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryUnreceivedPacketsRequest);
        message.portId = object.portId !== undefined && object.portId !== null ? String(object.portId) : "";
        message.channelId = object.channelId !== undefined && object.channelId !== null ? String(object.channelId) : "";
        message.packetCommitmentSequences = ((_a = object.packetCommitmentSequences) !== null && _a !== void 0 ? _a : []).map((e)=>$1a62b788fa2f619a$var$long_1.default.fromString(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        if (message.packetCommitmentSequences) obj.packetCommitmentSequences = message.packetCommitmentSequences.map((e)=>(e || $1a62b788fa2f619a$var$long_1.default.UZERO).toString());
        else obj.packetCommitmentSequences = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryUnreceivedPacketsRequest);
        message.portId = (_a = object.portId) !== null && _a !== void 0 ? _a : "";
        message.channelId = (_b = object.channelId) !== null && _b !== void 0 ? _b : "";
        message.packetCommitmentSequences = ((_c = object.packetCommitmentSequences) === null || _c === void 0 ? void 0 : _c.map((e)=>$1a62b788fa2f619a$var$long_1.default.fromValue(e))) || [];
        return message;
    }
};
const $1a62b788fa2f619a$var$baseQueryUnreceivedPacketsResponse = {
    sequences: $1a62b788fa2f619a$var$long_1.default.UZERO
};
$1a62b788fa2f619a$exports.QueryUnreceivedPacketsResponse = {
    encode (message, writer = $1a62b788fa2f619a$var$minimal_1.default.Writer.create()) {
        writer.uint32(10).fork();
        for (const v of message.sequences)writer.uint64(v);
        writer.ldelim();
        if (message.height !== undefined) $0935332a1587f29e$exports.Height.encode(message.height, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1a62b788fa2f619a$var$minimal_1.default.Reader ? input : new $1a62b788fa2f619a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryUnreceivedPacketsResponse);
        message.sequences = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.sequences.push(reader.uint64());
                    } else message.sequences.push(reader.uint64());
                    break;
                case 2:
                    message.height = $0935332a1587f29e$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryUnreceivedPacketsResponse);
        message.sequences = ((_a = object.sequences) !== null && _a !== void 0 ? _a : []).map((e)=>$1a62b788fa2f619a$var$long_1.default.fromString(e));
        message.height = object.height !== undefined && object.height !== null ? $0935332a1587f29e$exports.Height.fromJSON(object.height) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.sequences) obj.sequences = message.sequences.map((e)=>(e || $1a62b788fa2f619a$var$long_1.default.UZERO).toString());
        else obj.sequences = [];
        message.height !== undefined && (obj.height = message.height ? $0935332a1587f29e$exports.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryUnreceivedPacketsResponse);
        message.sequences = ((_a = object.sequences) === null || _a === void 0 ? void 0 : _a.map((e)=>$1a62b788fa2f619a$var$long_1.default.fromValue(e))) || [];
        message.height = object.height !== undefined && object.height !== null ? $0935332a1587f29e$exports.Height.fromPartial(object.height) : undefined;
        return message;
    }
};
const $1a62b788fa2f619a$var$baseQueryUnreceivedAcksRequest = {
    portId: "",
    channelId: "",
    packetAckSequences: $1a62b788fa2f619a$var$long_1.default.UZERO
};
$1a62b788fa2f619a$exports.QueryUnreceivedAcksRequest = {
    encode (message, writer = $1a62b788fa2f619a$var$minimal_1.default.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        writer.uint32(26).fork();
        for (const v of message.packetAckSequences)writer.uint64(v);
        writer.ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1a62b788fa2f619a$var$minimal_1.default.Reader ? input : new $1a62b788fa2f619a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryUnreceivedAcksRequest);
        message.packetAckSequences = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.packetAckSequences.push(reader.uint64());
                    } else message.packetAckSequences.push(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryUnreceivedAcksRequest);
        message.portId = object.portId !== undefined && object.portId !== null ? String(object.portId) : "";
        message.channelId = object.channelId !== undefined && object.channelId !== null ? String(object.channelId) : "";
        message.packetAckSequences = ((_a = object.packetAckSequences) !== null && _a !== void 0 ? _a : []).map((e)=>$1a62b788fa2f619a$var$long_1.default.fromString(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        if (message.packetAckSequences) obj.packetAckSequences = message.packetAckSequences.map((e)=>(e || $1a62b788fa2f619a$var$long_1.default.UZERO).toString());
        else obj.packetAckSequences = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryUnreceivedAcksRequest);
        message.portId = (_a = object.portId) !== null && _a !== void 0 ? _a : "";
        message.channelId = (_b = object.channelId) !== null && _b !== void 0 ? _b : "";
        message.packetAckSequences = ((_c = object.packetAckSequences) === null || _c === void 0 ? void 0 : _c.map((e)=>$1a62b788fa2f619a$var$long_1.default.fromValue(e))) || [];
        return message;
    }
};
const $1a62b788fa2f619a$var$baseQueryUnreceivedAcksResponse = {
    sequences: $1a62b788fa2f619a$var$long_1.default.UZERO
};
$1a62b788fa2f619a$exports.QueryUnreceivedAcksResponse = {
    encode (message, writer = $1a62b788fa2f619a$var$minimal_1.default.Writer.create()) {
        writer.uint32(10).fork();
        for (const v of message.sequences)writer.uint64(v);
        writer.ldelim();
        if (message.height !== undefined) $0935332a1587f29e$exports.Height.encode(message.height, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1a62b788fa2f619a$var$minimal_1.default.Reader ? input : new $1a62b788fa2f619a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryUnreceivedAcksResponse);
        message.sequences = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.sequences.push(reader.uint64());
                    } else message.sequences.push(reader.uint64());
                    break;
                case 2:
                    message.height = $0935332a1587f29e$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryUnreceivedAcksResponse);
        message.sequences = ((_a = object.sequences) !== null && _a !== void 0 ? _a : []).map((e)=>$1a62b788fa2f619a$var$long_1.default.fromString(e));
        message.height = object.height !== undefined && object.height !== null ? $0935332a1587f29e$exports.Height.fromJSON(object.height) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.sequences) obj.sequences = message.sequences.map((e)=>(e || $1a62b788fa2f619a$var$long_1.default.UZERO).toString());
        else obj.sequences = [];
        message.height !== undefined && (obj.height = message.height ? $0935332a1587f29e$exports.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryUnreceivedAcksResponse);
        message.sequences = ((_a = object.sequences) === null || _a === void 0 ? void 0 : _a.map((e)=>$1a62b788fa2f619a$var$long_1.default.fromValue(e))) || [];
        message.height = object.height !== undefined && object.height !== null ? $0935332a1587f29e$exports.Height.fromPartial(object.height) : undefined;
        return message;
    }
};
const $1a62b788fa2f619a$var$baseQueryNextSequenceReceiveRequest = {
    portId: "",
    channelId: ""
};
$1a62b788fa2f619a$exports.QueryNextSequenceReceiveRequest = {
    encode (message, writer = $1a62b788fa2f619a$var$minimal_1.default.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1a62b788fa2f619a$var$minimal_1.default.Reader ? input : new $1a62b788fa2f619a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryNextSequenceReceiveRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryNextSequenceReceiveRequest);
        message.portId = object.portId !== undefined && object.portId !== null ? String(object.portId) : "";
        message.channelId = object.channelId !== undefined && object.channelId !== null ? String(object.channelId) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryNextSequenceReceiveRequest);
        message.portId = (_a = object.portId) !== null && _a !== void 0 ? _a : "";
        message.channelId = (_b = object.channelId) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
const $1a62b788fa2f619a$var$baseQueryNextSequenceReceiveResponse = {
    nextSequenceReceive: $1a62b788fa2f619a$var$long_1.default.UZERO
};
$1a62b788fa2f619a$exports.QueryNextSequenceReceiveResponse = {
    encode (message, writer = $1a62b788fa2f619a$var$minimal_1.default.Writer.create()) {
        if (!message.nextSequenceReceive.isZero()) writer.uint32(8).uint64(message.nextSequenceReceive);
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $0935332a1587f29e$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1a62b788fa2f619a$var$minimal_1.default.Reader ? input : new $1a62b788fa2f619a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryNextSequenceReceiveResponse);
        message.proof = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.nextSequenceReceive = reader.uint64();
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $0935332a1587f29e$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryNextSequenceReceiveResponse);
        message.nextSequenceReceive = object.nextSequenceReceive !== undefined && object.nextSequenceReceive !== null ? $1a62b788fa2f619a$var$long_1.default.fromString(object.nextSequenceReceive) : $1a62b788fa2f619a$var$long_1.default.UZERO;
        message.proof = object.proof !== undefined && object.proof !== null ? $1a62b788fa2f619a$var$bytesFromBase64(object.proof) : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromJSON(object.proofHeight) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.nextSequenceReceive !== undefined && (obj.nextSequenceReceive = (message.nextSequenceReceive || $1a62b788fa2f619a$var$long_1.default.UZERO).toString());
        message.proof !== undefined && (obj.proof = $1a62b788fa2f619a$var$base64FromBytes(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $0935332a1587f29e$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $1a62b788fa2f619a$var$baseQueryNextSequenceReceiveResponse);
        message.nextSequenceReceive = object.nextSequenceReceive !== undefined && object.nextSequenceReceive !== null ? $1a62b788fa2f619a$var$long_1.default.fromValue(object.nextSequenceReceive) : $1a62b788fa2f619a$var$long_1.default.UZERO;
        message.proof = (_a = object.proof) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
class $1a62b788fa2f619a$var$QueryClientImpl {
    Channel(request) {
        const data = $1a62b788fa2f619a$exports.QueryChannelRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "Channel", data);
        return promise.then((data)=>$1a62b788fa2f619a$exports.QueryChannelResponse.decode(new $1a62b788fa2f619a$var$minimal_1.default.Reader(data)));
    }
    Channels(request) {
        const data = $1a62b788fa2f619a$exports.QueryChannelsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "Channels", data);
        return promise.then((data)=>$1a62b788fa2f619a$exports.QueryChannelsResponse.decode(new $1a62b788fa2f619a$var$minimal_1.default.Reader(data)));
    }
    ConnectionChannels(request) {
        const data = $1a62b788fa2f619a$exports.QueryConnectionChannelsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "ConnectionChannels", data);
        return promise.then((data)=>$1a62b788fa2f619a$exports.QueryConnectionChannelsResponse.decode(new $1a62b788fa2f619a$var$minimal_1.default.Reader(data)));
    }
    ChannelClientState(request) {
        const data = $1a62b788fa2f619a$exports.QueryChannelClientStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "ChannelClientState", data);
        return promise.then((data)=>$1a62b788fa2f619a$exports.QueryChannelClientStateResponse.decode(new $1a62b788fa2f619a$var$minimal_1.default.Reader(data)));
    }
    ChannelConsensusState(request) {
        const data = $1a62b788fa2f619a$exports.QueryChannelConsensusStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "ChannelConsensusState", data);
        return promise.then((data)=>$1a62b788fa2f619a$exports.QueryChannelConsensusStateResponse.decode(new $1a62b788fa2f619a$var$minimal_1.default.Reader(data)));
    }
    PacketCommitment(request) {
        const data = $1a62b788fa2f619a$exports.QueryPacketCommitmentRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "PacketCommitment", data);
        return promise.then((data)=>$1a62b788fa2f619a$exports.QueryPacketCommitmentResponse.decode(new $1a62b788fa2f619a$var$minimal_1.default.Reader(data)));
    }
    PacketCommitments(request) {
        const data = $1a62b788fa2f619a$exports.QueryPacketCommitmentsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "PacketCommitments", data);
        return promise.then((data)=>$1a62b788fa2f619a$exports.QueryPacketCommitmentsResponse.decode(new $1a62b788fa2f619a$var$minimal_1.default.Reader(data)));
    }
    PacketReceipt(request) {
        const data = $1a62b788fa2f619a$exports.QueryPacketReceiptRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "PacketReceipt", data);
        return promise.then((data)=>$1a62b788fa2f619a$exports.QueryPacketReceiptResponse.decode(new $1a62b788fa2f619a$var$minimal_1.default.Reader(data)));
    }
    PacketAcknowledgement(request) {
        const data = $1a62b788fa2f619a$exports.QueryPacketAcknowledgementRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "PacketAcknowledgement", data);
        return promise.then((data)=>$1a62b788fa2f619a$exports.QueryPacketAcknowledgementResponse.decode(new $1a62b788fa2f619a$var$minimal_1.default.Reader(data)));
    }
    PacketAcknowledgements(request) {
        const data = $1a62b788fa2f619a$exports.QueryPacketAcknowledgementsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "PacketAcknowledgements", data);
        return promise.then((data)=>$1a62b788fa2f619a$exports.QueryPacketAcknowledgementsResponse.decode(new $1a62b788fa2f619a$var$minimal_1.default.Reader(data)));
    }
    UnreceivedPackets(request) {
        const data = $1a62b788fa2f619a$exports.QueryUnreceivedPacketsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "UnreceivedPackets", data);
        return promise.then((data)=>$1a62b788fa2f619a$exports.QueryUnreceivedPacketsResponse.decode(new $1a62b788fa2f619a$var$minimal_1.default.Reader(data)));
    }
    UnreceivedAcks(request) {
        const data = $1a62b788fa2f619a$exports.QueryUnreceivedAcksRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "UnreceivedAcks", data);
        return promise.then((data)=>$1a62b788fa2f619a$exports.QueryUnreceivedAcksResponse.decode(new $1a62b788fa2f619a$var$minimal_1.default.Reader(data)));
    }
    NextSequenceReceive(request) {
        const data = $1a62b788fa2f619a$exports.QueryNextSequenceReceiveRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "NextSequenceReceive", data);
        return promise.then((data)=>$1a62b788fa2f619a$exports.QueryNextSequenceReceiveResponse.decode(new $1a62b788fa2f619a$var$minimal_1.default.Reader(data)));
    }
    constructor(rpc){
        this.rpc = rpc;
        this.Channel = this.Channel.bind(this);
        this.Channels = this.Channels.bind(this);
        this.ConnectionChannels = this.ConnectionChannels.bind(this);
        this.ChannelClientState = this.ChannelClientState.bind(this);
        this.ChannelConsensusState = this.ChannelConsensusState.bind(this);
        this.PacketCommitment = this.PacketCommitment.bind(this);
        this.PacketCommitments = this.PacketCommitments.bind(this);
        this.PacketReceipt = this.PacketReceipt.bind(this);
        this.PacketAcknowledgement = this.PacketAcknowledgement.bind(this);
        this.PacketAcknowledgements = this.PacketAcknowledgements.bind(this);
        this.UnreceivedPackets = this.UnreceivedPackets.bind(this);
        this.UnreceivedAcks = this.UnreceivedAcks.bind(this);
        this.NextSequenceReceive = this.NextSequenceReceive.bind(this);
    }
}
$1a62b788fa2f619a$exports.QueryClientImpl = $1a62b788fa2f619a$var$QueryClientImpl;
var $1a62b788fa2f619a$var$globalThis = (()=>{
    if (typeof $1a62b788fa2f619a$var$globalThis !== "undefined") return $1a62b788fa2f619a$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $1a62b788fa2f619a$var$atob = $1a62b788fa2f619a$var$globalThis.atob || ((b64)=>$1a62b788fa2f619a$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $1a62b788fa2f619a$var$bytesFromBase64(b64) {
    const bin = $1a62b788fa2f619a$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $1a62b788fa2f619a$var$btoa = $1a62b788fa2f619a$var$globalThis.btoa || ((bin)=>$1a62b788fa2f619a$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $1a62b788fa2f619a$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $1a62b788fa2f619a$var$btoa(bin.join(""));
}
if ($1a62b788fa2f619a$var$minimal_1.default.util.Long !== $1a62b788fa2f619a$var$long_1.default) {
    $1a62b788fa2f619a$var$minimal_1.default.util.Long = $1a62b788fa2f619a$var$long_1.default;
    $1a62b788fa2f619a$var$minimal_1.default.configure();
}


var $23e1cbf14b2581ce$exports = {};
"use strict";
var $23e1cbf14b2581ce$var$__importDefault = $23e1cbf14b2581ce$exports && $23e1cbf14b2581ce$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($23e1cbf14b2581ce$exports, "__esModule", {
    value: true
});
$23e1cbf14b2581ce$exports.QueryClientImpl = $23e1cbf14b2581ce$exports.QueryClientParamsResponse = $23e1cbf14b2581ce$exports.QueryClientParamsRequest = $23e1cbf14b2581ce$exports.QueryConsensusStatesResponse = $23e1cbf14b2581ce$exports.QueryConsensusStatesRequest = $23e1cbf14b2581ce$exports.QueryConsensusStateResponse = $23e1cbf14b2581ce$exports.QueryConsensusStateRequest = $23e1cbf14b2581ce$exports.QueryClientStatesResponse = $23e1cbf14b2581ce$exports.QueryClientStatesRequest = $23e1cbf14b2581ce$exports.QueryClientStateResponse = $23e1cbf14b2581ce$exports.QueryClientStateRequest = $23e1cbf14b2581ce$exports.protobufPackage = void 0;

/* eslint-disable */ const $23e1cbf14b2581ce$var$long_1 = $23e1cbf14b2581ce$var$__importDefault((parcelRequire("9A55m")));

const $23e1cbf14b2581ce$var$minimal_1 = $23e1cbf14b2581ce$var$__importDefault((parcelRequire("i2pIU")));



$23e1cbf14b2581ce$exports.protobufPackage = "ibc.core.client.v1";
const $23e1cbf14b2581ce$var$baseQueryClientStateRequest = {
    clientId: ""
};
$23e1cbf14b2581ce$exports.QueryClientStateRequest = {
    encode (message, writer = $23e1cbf14b2581ce$var$minimal_1.default.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $23e1cbf14b2581ce$var$minimal_1.default.Reader ? input : new $23e1cbf14b2581ce$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $23e1cbf14b2581ce$var$baseQueryClientStateRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $23e1cbf14b2581ce$var$baseQueryClientStateRequest);
        message.clientId = object.clientId !== undefined && object.clientId !== null ? String(object.clientId) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $23e1cbf14b2581ce$var$baseQueryClientStateRequest);
        message.clientId = (_a = object.clientId) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
const $23e1cbf14b2581ce$var$baseQueryClientStateResponse = {};
$23e1cbf14b2581ce$exports.QueryClientStateResponse = {
    encode (message, writer = $23e1cbf14b2581ce$var$minimal_1.default.Writer.create()) {
        if (message.clientState !== undefined) $4232fce010c3a46b$exports.Any.encode(message.clientState, writer.uint32(10).fork()).ldelim();
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $0935332a1587f29e$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $23e1cbf14b2581ce$var$minimal_1.default.Reader ? input : new $23e1cbf14b2581ce$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $23e1cbf14b2581ce$var$baseQueryClientStateResponse);
        message.proof = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientState = $4232fce010c3a46b$exports.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $0935332a1587f29e$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $23e1cbf14b2581ce$var$baseQueryClientStateResponse);
        message.clientState = object.clientState !== undefined && object.clientState !== null ? $4232fce010c3a46b$exports.Any.fromJSON(object.clientState) : undefined;
        message.proof = object.proof !== undefined && object.proof !== null ? $23e1cbf14b2581ce$var$bytesFromBase64(object.proof) : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromJSON(object.proofHeight) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.clientState !== undefined && (obj.clientState = message.clientState ? $4232fce010c3a46b$exports.Any.toJSON(message.clientState) : undefined);
        message.proof !== undefined && (obj.proof = $23e1cbf14b2581ce$var$base64FromBytes(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $0935332a1587f29e$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $23e1cbf14b2581ce$var$baseQueryClientStateResponse);
        message.clientState = object.clientState !== undefined && object.clientState !== null ? $4232fce010c3a46b$exports.Any.fromPartial(object.clientState) : undefined;
        message.proof = (_a = object.proof) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
const $23e1cbf14b2581ce$var$baseQueryClientStatesRequest = {};
$23e1cbf14b2581ce$exports.QueryClientStatesRequest = {
    encode (message, writer = $23e1cbf14b2581ce$var$minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $23e1cbf14b2581ce$var$minimal_1.default.Reader ? input : new $23e1cbf14b2581ce$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $23e1cbf14b2581ce$var$baseQueryClientStatesRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pagination = $f01b40e20607eb8e$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $23e1cbf14b2581ce$var$baseQueryClientStatesRequest);
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromJSON(object.pagination) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $23e1cbf14b2581ce$var$baseQueryClientStatesRequest);
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
const $23e1cbf14b2581ce$var$baseQueryClientStatesResponse = {};
$23e1cbf14b2581ce$exports.QueryClientStatesResponse = {
    encode (message, writer = $23e1cbf14b2581ce$var$minimal_1.default.Writer.create()) {
        for (const v of message.clientStates)$0935332a1587f29e$exports.IdentifiedClientState.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $23e1cbf14b2581ce$var$minimal_1.default.Reader ? input : new $23e1cbf14b2581ce$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $23e1cbf14b2581ce$var$baseQueryClientStatesResponse);
        message.clientStates = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientStates.push($0935332a1587f29e$exports.IdentifiedClientState.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $f01b40e20607eb8e$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $23e1cbf14b2581ce$var$baseQueryClientStatesResponse);
        message.clientStates = ((_a = object.clientStates) !== null && _a !== void 0 ? _a : []).map((e)=>$0935332a1587f29e$exports.IdentifiedClientState.fromJSON(e));
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromJSON(object.pagination) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.clientStates) obj.clientStates = message.clientStates.map((e)=>e ? $0935332a1587f29e$exports.IdentifiedClientState.toJSON(e) : undefined);
        else obj.clientStates = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $23e1cbf14b2581ce$var$baseQueryClientStatesResponse);
        message.clientStates = ((_a = object.clientStates) === null || _a === void 0 ? void 0 : _a.map((e)=>$0935332a1587f29e$exports.IdentifiedClientState.fromPartial(e))) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
const $23e1cbf14b2581ce$var$baseQueryConsensusStateRequest = {
    clientId: "",
    revisionNumber: $23e1cbf14b2581ce$var$long_1.default.UZERO,
    revisionHeight: $23e1cbf14b2581ce$var$long_1.default.UZERO,
    latestHeight: false
};
$23e1cbf14b2581ce$exports.QueryConsensusStateRequest = {
    encode (message, writer = $23e1cbf14b2581ce$var$minimal_1.default.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (!message.revisionNumber.isZero()) writer.uint32(16).uint64(message.revisionNumber);
        if (!message.revisionHeight.isZero()) writer.uint32(24).uint64(message.revisionHeight);
        if (message.latestHeight === true) writer.uint32(32).bool(message.latestHeight);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $23e1cbf14b2581ce$var$minimal_1.default.Reader ? input : new $23e1cbf14b2581ce$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $23e1cbf14b2581ce$var$baseQueryConsensusStateRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.revisionNumber = reader.uint64();
                    break;
                case 3:
                    message.revisionHeight = reader.uint64();
                    break;
                case 4:
                    message.latestHeight = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $23e1cbf14b2581ce$var$baseQueryConsensusStateRequest);
        message.clientId = object.clientId !== undefined && object.clientId !== null ? String(object.clientId) : "";
        message.revisionNumber = object.revisionNumber !== undefined && object.revisionNumber !== null ? $23e1cbf14b2581ce$var$long_1.default.fromString(object.revisionNumber) : $23e1cbf14b2581ce$var$long_1.default.UZERO;
        message.revisionHeight = object.revisionHeight !== undefined && object.revisionHeight !== null ? $23e1cbf14b2581ce$var$long_1.default.fromString(object.revisionHeight) : $23e1cbf14b2581ce$var$long_1.default.UZERO;
        message.latestHeight = object.latestHeight !== undefined && object.latestHeight !== null ? Boolean(object.latestHeight) : false;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.revisionNumber !== undefined && (obj.revisionNumber = (message.revisionNumber || $23e1cbf14b2581ce$var$long_1.default.UZERO).toString());
        message.revisionHeight !== undefined && (obj.revisionHeight = (message.revisionHeight || $23e1cbf14b2581ce$var$long_1.default.UZERO).toString());
        message.latestHeight !== undefined && (obj.latestHeight = message.latestHeight);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $23e1cbf14b2581ce$var$baseQueryConsensusStateRequest);
        message.clientId = (_a = object.clientId) !== null && _a !== void 0 ? _a : "";
        message.revisionNumber = object.revisionNumber !== undefined && object.revisionNumber !== null ? $23e1cbf14b2581ce$var$long_1.default.fromValue(object.revisionNumber) : $23e1cbf14b2581ce$var$long_1.default.UZERO;
        message.revisionHeight = object.revisionHeight !== undefined && object.revisionHeight !== null ? $23e1cbf14b2581ce$var$long_1.default.fromValue(object.revisionHeight) : $23e1cbf14b2581ce$var$long_1.default.UZERO;
        message.latestHeight = (_b = object.latestHeight) !== null && _b !== void 0 ? _b : false;
        return message;
    }
};
const $23e1cbf14b2581ce$var$baseQueryConsensusStateResponse = {};
$23e1cbf14b2581ce$exports.QueryConsensusStateResponse = {
    encode (message, writer = $23e1cbf14b2581ce$var$minimal_1.default.Writer.create()) {
        if (message.consensusState !== undefined) $4232fce010c3a46b$exports.Any.encode(message.consensusState, writer.uint32(10).fork()).ldelim();
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $0935332a1587f29e$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $23e1cbf14b2581ce$var$minimal_1.default.Reader ? input : new $23e1cbf14b2581ce$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $23e1cbf14b2581ce$var$baseQueryConsensusStateResponse);
        message.proof = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.consensusState = $4232fce010c3a46b$exports.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $0935332a1587f29e$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $23e1cbf14b2581ce$var$baseQueryConsensusStateResponse);
        message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? $4232fce010c3a46b$exports.Any.fromJSON(object.consensusState) : undefined;
        message.proof = object.proof !== undefined && object.proof !== null ? $23e1cbf14b2581ce$var$bytesFromBase64(object.proof) : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromJSON(object.proofHeight) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.consensusState !== undefined && (obj.consensusState = message.consensusState ? $4232fce010c3a46b$exports.Any.toJSON(message.consensusState) : undefined);
        message.proof !== undefined && (obj.proof = $23e1cbf14b2581ce$var$base64FromBytes(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $0935332a1587f29e$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $23e1cbf14b2581ce$var$baseQueryConsensusStateResponse);
        message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? $4232fce010c3a46b$exports.Any.fromPartial(object.consensusState) : undefined;
        message.proof = (_a = object.proof) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
const $23e1cbf14b2581ce$var$baseQueryConsensusStatesRequest = {
    clientId: ""
};
$23e1cbf14b2581ce$exports.QueryConsensusStatesRequest = {
    encode (message, writer = $23e1cbf14b2581ce$var$minimal_1.default.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $23e1cbf14b2581ce$var$minimal_1.default.Reader ? input : new $23e1cbf14b2581ce$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $23e1cbf14b2581ce$var$baseQueryConsensusStatesRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.pagination = $f01b40e20607eb8e$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $23e1cbf14b2581ce$var$baseQueryConsensusStatesRequest);
        message.clientId = object.clientId !== undefined && object.clientId !== null ? String(object.clientId) : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromJSON(object.pagination) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $23e1cbf14b2581ce$var$baseQueryConsensusStatesRequest);
        message.clientId = (_a = object.clientId) !== null && _a !== void 0 ? _a : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
const $23e1cbf14b2581ce$var$baseQueryConsensusStatesResponse = {};
$23e1cbf14b2581ce$exports.QueryConsensusStatesResponse = {
    encode (message, writer = $23e1cbf14b2581ce$var$minimal_1.default.Writer.create()) {
        for (const v of message.consensusStates)$0935332a1587f29e$exports.ConsensusStateWithHeight.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $23e1cbf14b2581ce$var$minimal_1.default.Reader ? input : new $23e1cbf14b2581ce$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $23e1cbf14b2581ce$var$baseQueryConsensusStatesResponse);
        message.consensusStates = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.consensusStates.push($0935332a1587f29e$exports.ConsensusStateWithHeight.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $f01b40e20607eb8e$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $23e1cbf14b2581ce$var$baseQueryConsensusStatesResponse);
        message.consensusStates = ((_a = object.consensusStates) !== null && _a !== void 0 ? _a : []).map((e)=>$0935332a1587f29e$exports.ConsensusStateWithHeight.fromJSON(e));
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromJSON(object.pagination) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.consensusStates) obj.consensusStates = message.consensusStates.map((e)=>e ? $0935332a1587f29e$exports.ConsensusStateWithHeight.toJSON(e) : undefined);
        else obj.consensusStates = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $23e1cbf14b2581ce$var$baseQueryConsensusStatesResponse);
        message.consensusStates = ((_a = object.consensusStates) === null || _a === void 0 ? void 0 : _a.map((e)=>$0935332a1587f29e$exports.ConsensusStateWithHeight.fromPartial(e))) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
const $23e1cbf14b2581ce$var$baseQueryClientParamsRequest = {};
$23e1cbf14b2581ce$exports.QueryClientParamsRequest = {
    encode (_, writer = $23e1cbf14b2581ce$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $23e1cbf14b2581ce$var$minimal_1.default.Reader ? input : new $23e1cbf14b2581ce$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $23e1cbf14b2581ce$var$baseQueryClientParamsRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $23e1cbf14b2581ce$var$baseQueryClientParamsRequest);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $23e1cbf14b2581ce$var$baseQueryClientParamsRequest);
        return message;
    }
};
const $23e1cbf14b2581ce$var$baseQueryClientParamsResponse = {};
$23e1cbf14b2581ce$exports.QueryClientParamsResponse = {
    encode (message, writer = $23e1cbf14b2581ce$var$minimal_1.default.Writer.create()) {
        if (message.params !== undefined) $0935332a1587f29e$exports.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $23e1cbf14b2581ce$var$minimal_1.default.Reader ? input : new $23e1cbf14b2581ce$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $23e1cbf14b2581ce$var$baseQueryClientParamsResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $0935332a1587f29e$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $23e1cbf14b2581ce$var$baseQueryClientParamsResponse);
        message.params = object.params !== undefined && object.params !== null ? $0935332a1587f29e$exports.Params.fromJSON(object.params) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? $0935332a1587f29e$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $23e1cbf14b2581ce$var$baseQueryClientParamsResponse);
        message.params = object.params !== undefined && object.params !== null ? $0935332a1587f29e$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
class $23e1cbf14b2581ce$var$QueryClientImpl {
    ClientState(request) {
        const data = $23e1cbf14b2581ce$exports.QueryClientStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "ClientState", data);
        return promise.then((data)=>$23e1cbf14b2581ce$exports.QueryClientStateResponse.decode(new $23e1cbf14b2581ce$var$minimal_1.default.Reader(data)));
    }
    ClientStates(request) {
        const data = $23e1cbf14b2581ce$exports.QueryClientStatesRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "ClientStates", data);
        return promise.then((data)=>$23e1cbf14b2581ce$exports.QueryClientStatesResponse.decode(new $23e1cbf14b2581ce$var$minimal_1.default.Reader(data)));
    }
    ConsensusState(request) {
        const data = $23e1cbf14b2581ce$exports.QueryConsensusStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "ConsensusState", data);
        return promise.then((data)=>$23e1cbf14b2581ce$exports.QueryConsensusStateResponse.decode(new $23e1cbf14b2581ce$var$minimal_1.default.Reader(data)));
    }
    ConsensusStates(request) {
        const data = $23e1cbf14b2581ce$exports.QueryConsensusStatesRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "ConsensusStates", data);
        return promise.then((data)=>$23e1cbf14b2581ce$exports.QueryConsensusStatesResponse.decode(new $23e1cbf14b2581ce$var$minimal_1.default.Reader(data)));
    }
    ClientParams(request) {
        const data = $23e1cbf14b2581ce$exports.QueryClientParamsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "ClientParams", data);
        return promise.then((data)=>$23e1cbf14b2581ce$exports.QueryClientParamsResponse.decode(new $23e1cbf14b2581ce$var$minimal_1.default.Reader(data)));
    }
    constructor(rpc){
        this.rpc = rpc;
        this.ClientState = this.ClientState.bind(this);
        this.ClientStates = this.ClientStates.bind(this);
        this.ConsensusState = this.ConsensusState.bind(this);
        this.ConsensusStates = this.ConsensusStates.bind(this);
        this.ClientParams = this.ClientParams.bind(this);
    }
}
$23e1cbf14b2581ce$exports.QueryClientImpl = $23e1cbf14b2581ce$var$QueryClientImpl;
var $23e1cbf14b2581ce$var$globalThis = (()=>{
    if (typeof $23e1cbf14b2581ce$var$globalThis !== "undefined") return $23e1cbf14b2581ce$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $23e1cbf14b2581ce$var$atob = $23e1cbf14b2581ce$var$globalThis.atob || ((b64)=>$23e1cbf14b2581ce$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $23e1cbf14b2581ce$var$bytesFromBase64(b64) {
    const bin = $23e1cbf14b2581ce$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $23e1cbf14b2581ce$var$btoa = $23e1cbf14b2581ce$var$globalThis.btoa || ((bin)=>$23e1cbf14b2581ce$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $23e1cbf14b2581ce$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $23e1cbf14b2581ce$var$btoa(bin.join(""));
}
if ($23e1cbf14b2581ce$var$minimal_1.default.util.Long !== $23e1cbf14b2581ce$var$long_1.default) {
    $23e1cbf14b2581ce$var$minimal_1.default.util.Long = $23e1cbf14b2581ce$var$long_1.default;
    $23e1cbf14b2581ce$var$minimal_1.default.configure();
}


var $bb5887be70760d1a$exports = {};
"use strict";
var $bb5887be70760d1a$var$__importDefault = $bb5887be70760d1a$exports && $bb5887be70760d1a$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($bb5887be70760d1a$exports, "__esModule", {
    value: true
});
$bb5887be70760d1a$exports.QueryClientImpl = $bb5887be70760d1a$exports.QueryConnectionConsensusStateResponse = $bb5887be70760d1a$exports.QueryConnectionConsensusStateRequest = $bb5887be70760d1a$exports.QueryConnectionClientStateResponse = $bb5887be70760d1a$exports.QueryConnectionClientStateRequest = $bb5887be70760d1a$exports.QueryClientConnectionsResponse = $bb5887be70760d1a$exports.QueryClientConnectionsRequest = $bb5887be70760d1a$exports.QueryConnectionsResponse = $bb5887be70760d1a$exports.QueryConnectionsRequest = $bb5887be70760d1a$exports.QueryConnectionResponse = $bb5887be70760d1a$exports.QueryConnectionRequest = $bb5887be70760d1a$exports.protobufPackage = void 0;

/* eslint-disable */ const $bb5887be70760d1a$var$long_1 = $bb5887be70760d1a$var$__importDefault((parcelRequire("9A55m")));

const $bb5887be70760d1a$var$minimal_1 = $bb5887be70760d1a$var$__importDefault((parcelRequire("i2pIU")));




$bb5887be70760d1a$exports.protobufPackage = "ibc.core.connection.v1";
const $bb5887be70760d1a$var$baseQueryConnectionRequest = {
    connectionId: ""
};
$bb5887be70760d1a$exports.QueryConnectionRequest = {
    encode (message, writer = $bb5887be70760d1a$var$minimal_1.default.Writer.create()) {
        if (message.connectionId !== "") writer.uint32(10).string(message.connectionId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bb5887be70760d1a$var$minimal_1.default.Reader ? input : new $bb5887be70760d1a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bb5887be70760d1a$var$baseQueryConnectionRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connectionId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $bb5887be70760d1a$var$baseQueryConnectionRequest);
        message.connectionId = object.connectionId !== undefined && object.connectionId !== null ? String(object.connectionId) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $bb5887be70760d1a$var$baseQueryConnectionRequest);
        message.connectionId = (_a = object.connectionId) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
const $bb5887be70760d1a$var$baseQueryConnectionResponse = {};
$bb5887be70760d1a$exports.QueryConnectionResponse = {
    encode (message, writer = $bb5887be70760d1a$var$minimal_1.default.Writer.create()) {
        if (message.connection !== undefined) $57765dd48e8b80b9$exports.ConnectionEnd.encode(message.connection, writer.uint32(10).fork()).ldelim();
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $0935332a1587f29e$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bb5887be70760d1a$var$minimal_1.default.Reader ? input : new $bb5887be70760d1a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bb5887be70760d1a$var$baseQueryConnectionResponse);
        message.proof = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connection = $57765dd48e8b80b9$exports.ConnectionEnd.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $0935332a1587f29e$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $bb5887be70760d1a$var$baseQueryConnectionResponse);
        message.connection = object.connection !== undefined && object.connection !== null ? $57765dd48e8b80b9$exports.ConnectionEnd.fromJSON(object.connection) : undefined;
        message.proof = object.proof !== undefined && object.proof !== null ? $bb5887be70760d1a$var$bytesFromBase64(object.proof) : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromJSON(object.proofHeight) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.connection !== undefined && (obj.connection = message.connection ? $57765dd48e8b80b9$exports.ConnectionEnd.toJSON(message.connection) : undefined);
        message.proof !== undefined && (obj.proof = $bb5887be70760d1a$var$base64FromBytes(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $0935332a1587f29e$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $bb5887be70760d1a$var$baseQueryConnectionResponse);
        message.connection = object.connection !== undefined && object.connection !== null ? $57765dd48e8b80b9$exports.ConnectionEnd.fromPartial(object.connection) : undefined;
        message.proof = (_a = object.proof) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
const $bb5887be70760d1a$var$baseQueryConnectionsRequest = {};
$bb5887be70760d1a$exports.QueryConnectionsRequest = {
    encode (message, writer = $bb5887be70760d1a$var$minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bb5887be70760d1a$var$minimal_1.default.Reader ? input : new $bb5887be70760d1a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bb5887be70760d1a$var$baseQueryConnectionsRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pagination = $f01b40e20607eb8e$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $bb5887be70760d1a$var$baseQueryConnectionsRequest);
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromJSON(object.pagination) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $bb5887be70760d1a$var$baseQueryConnectionsRequest);
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
const $bb5887be70760d1a$var$baseQueryConnectionsResponse = {};
$bb5887be70760d1a$exports.QueryConnectionsResponse = {
    encode (message, writer = $bb5887be70760d1a$var$minimal_1.default.Writer.create()) {
        for (const v of message.connections)$57765dd48e8b80b9$exports.IdentifiedConnection.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        if (message.height !== undefined) $0935332a1587f29e$exports.Height.encode(message.height, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bb5887be70760d1a$var$minimal_1.default.Reader ? input : new $bb5887be70760d1a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bb5887be70760d1a$var$baseQueryConnectionsResponse);
        message.connections = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connections.push($57765dd48e8b80b9$exports.IdentifiedConnection.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $f01b40e20607eb8e$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = $0935332a1587f29e$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $bb5887be70760d1a$var$baseQueryConnectionsResponse);
        message.connections = ((_a = object.connections) !== null && _a !== void 0 ? _a : []).map((e)=>$57765dd48e8b80b9$exports.IdentifiedConnection.fromJSON(e));
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromJSON(object.pagination) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $0935332a1587f29e$exports.Height.fromJSON(object.height) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.connections) obj.connections = message.connections.map((e)=>e ? $57765dd48e8b80b9$exports.IdentifiedConnection.toJSON(e) : undefined);
        else obj.connections = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageResponse.toJSON(message.pagination) : undefined);
        message.height !== undefined && (obj.height = message.height ? $0935332a1587f29e$exports.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $bb5887be70760d1a$var$baseQueryConnectionsResponse);
        message.connections = ((_a = object.connections) === null || _a === void 0 ? void 0 : _a.map((e)=>$57765dd48e8b80b9$exports.IdentifiedConnection.fromPartial(e))) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromPartial(object.pagination) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $0935332a1587f29e$exports.Height.fromPartial(object.height) : undefined;
        return message;
    }
};
const $bb5887be70760d1a$var$baseQueryClientConnectionsRequest = {
    clientId: ""
};
$bb5887be70760d1a$exports.QueryClientConnectionsRequest = {
    encode (message, writer = $bb5887be70760d1a$var$minimal_1.default.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bb5887be70760d1a$var$minimal_1.default.Reader ? input : new $bb5887be70760d1a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bb5887be70760d1a$var$baseQueryClientConnectionsRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $bb5887be70760d1a$var$baseQueryClientConnectionsRequest);
        message.clientId = object.clientId !== undefined && object.clientId !== null ? String(object.clientId) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $bb5887be70760d1a$var$baseQueryClientConnectionsRequest);
        message.clientId = (_a = object.clientId) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
const $bb5887be70760d1a$var$baseQueryClientConnectionsResponse = {
    connectionPaths: ""
};
$bb5887be70760d1a$exports.QueryClientConnectionsResponse = {
    encode (message, writer = $bb5887be70760d1a$var$minimal_1.default.Writer.create()) {
        for (const v of message.connectionPaths)writer.uint32(10).string(v);
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $0935332a1587f29e$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bb5887be70760d1a$var$minimal_1.default.Reader ? input : new $bb5887be70760d1a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bb5887be70760d1a$var$baseQueryClientConnectionsResponse);
        message.connectionPaths = [];
        message.proof = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connectionPaths.push(reader.string());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $0935332a1587f29e$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $bb5887be70760d1a$var$baseQueryClientConnectionsResponse);
        message.connectionPaths = ((_a = object.connectionPaths) !== null && _a !== void 0 ? _a : []).map((e)=>String(e));
        message.proof = object.proof !== undefined && object.proof !== null ? $bb5887be70760d1a$var$bytesFromBase64(object.proof) : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromJSON(object.proofHeight) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.connectionPaths) obj.connectionPaths = message.connectionPaths.map((e)=>e);
        else obj.connectionPaths = [];
        message.proof !== undefined && (obj.proof = $bb5887be70760d1a$var$base64FromBytes(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $0935332a1587f29e$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $bb5887be70760d1a$var$baseQueryClientConnectionsResponse);
        message.connectionPaths = ((_a = object.connectionPaths) === null || _a === void 0 ? void 0 : _a.map((e)=>e)) || [];
        message.proof = (_b = object.proof) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
const $bb5887be70760d1a$var$baseQueryConnectionClientStateRequest = {
    connectionId: ""
};
$bb5887be70760d1a$exports.QueryConnectionClientStateRequest = {
    encode (message, writer = $bb5887be70760d1a$var$minimal_1.default.Writer.create()) {
        if (message.connectionId !== "") writer.uint32(10).string(message.connectionId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bb5887be70760d1a$var$minimal_1.default.Reader ? input : new $bb5887be70760d1a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bb5887be70760d1a$var$baseQueryConnectionClientStateRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connectionId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $bb5887be70760d1a$var$baseQueryConnectionClientStateRequest);
        message.connectionId = object.connectionId !== undefined && object.connectionId !== null ? String(object.connectionId) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $bb5887be70760d1a$var$baseQueryConnectionClientStateRequest);
        message.connectionId = (_a = object.connectionId) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
const $bb5887be70760d1a$var$baseQueryConnectionClientStateResponse = {};
$bb5887be70760d1a$exports.QueryConnectionClientStateResponse = {
    encode (message, writer = $bb5887be70760d1a$var$minimal_1.default.Writer.create()) {
        if (message.identifiedClientState !== undefined) $0935332a1587f29e$exports.IdentifiedClientState.encode(message.identifiedClientState, writer.uint32(10).fork()).ldelim();
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $0935332a1587f29e$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bb5887be70760d1a$var$minimal_1.default.Reader ? input : new $bb5887be70760d1a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bb5887be70760d1a$var$baseQueryConnectionClientStateResponse);
        message.proof = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.identifiedClientState = $0935332a1587f29e$exports.IdentifiedClientState.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $0935332a1587f29e$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $bb5887be70760d1a$var$baseQueryConnectionClientStateResponse);
        message.identifiedClientState = object.identifiedClientState !== undefined && object.identifiedClientState !== null ? $0935332a1587f29e$exports.IdentifiedClientState.fromJSON(object.identifiedClientState) : undefined;
        message.proof = object.proof !== undefined && object.proof !== null ? $bb5887be70760d1a$var$bytesFromBase64(object.proof) : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromJSON(object.proofHeight) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.identifiedClientState !== undefined && (obj.identifiedClientState = message.identifiedClientState ? $0935332a1587f29e$exports.IdentifiedClientState.toJSON(message.identifiedClientState) : undefined);
        message.proof !== undefined && (obj.proof = $bb5887be70760d1a$var$base64FromBytes(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $0935332a1587f29e$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $bb5887be70760d1a$var$baseQueryConnectionClientStateResponse);
        message.identifiedClientState = object.identifiedClientState !== undefined && object.identifiedClientState !== null ? $0935332a1587f29e$exports.IdentifiedClientState.fromPartial(object.identifiedClientState) : undefined;
        message.proof = (_a = object.proof) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
const $bb5887be70760d1a$var$baseQueryConnectionConsensusStateRequest = {
    connectionId: "",
    revisionNumber: $bb5887be70760d1a$var$long_1.default.UZERO,
    revisionHeight: $bb5887be70760d1a$var$long_1.default.UZERO
};
$bb5887be70760d1a$exports.QueryConnectionConsensusStateRequest = {
    encode (message, writer = $bb5887be70760d1a$var$minimal_1.default.Writer.create()) {
        if (message.connectionId !== "") writer.uint32(10).string(message.connectionId);
        if (!message.revisionNumber.isZero()) writer.uint32(16).uint64(message.revisionNumber);
        if (!message.revisionHeight.isZero()) writer.uint32(24).uint64(message.revisionHeight);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bb5887be70760d1a$var$minimal_1.default.Reader ? input : new $bb5887be70760d1a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bb5887be70760d1a$var$baseQueryConnectionConsensusStateRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connectionId = reader.string();
                    break;
                case 2:
                    message.revisionNumber = reader.uint64();
                    break;
                case 3:
                    message.revisionHeight = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $bb5887be70760d1a$var$baseQueryConnectionConsensusStateRequest);
        message.connectionId = object.connectionId !== undefined && object.connectionId !== null ? String(object.connectionId) : "";
        message.revisionNumber = object.revisionNumber !== undefined && object.revisionNumber !== null ? $bb5887be70760d1a$var$long_1.default.fromString(object.revisionNumber) : $bb5887be70760d1a$var$long_1.default.UZERO;
        message.revisionHeight = object.revisionHeight !== undefined && object.revisionHeight !== null ? $bb5887be70760d1a$var$long_1.default.fromString(object.revisionHeight) : $bb5887be70760d1a$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        message.revisionNumber !== undefined && (obj.revisionNumber = (message.revisionNumber || $bb5887be70760d1a$var$long_1.default.UZERO).toString());
        message.revisionHeight !== undefined && (obj.revisionHeight = (message.revisionHeight || $bb5887be70760d1a$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $bb5887be70760d1a$var$baseQueryConnectionConsensusStateRequest);
        message.connectionId = (_a = object.connectionId) !== null && _a !== void 0 ? _a : "";
        message.revisionNumber = object.revisionNumber !== undefined && object.revisionNumber !== null ? $bb5887be70760d1a$var$long_1.default.fromValue(object.revisionNumber) : $bb5887be70760d1a$var$long_1.default.UZERO;
        message.revisionHeight = object.revisionHeight !== undefined && object.revisionHeight !== null ? $bb5887be70760d1a$var$long_1.default.fromValue(object.revisionHeight) : $bb5887be70760d1a$var$long_1.default.UZERO;
        return message;
    }
};
const $bb5887be70760d1a$var$baseQueryConnectionConsensusStateResponse = {
    clientId: ""
};
$bb5887be70760d1a$exports.QueryConnectionConsensusStateResponse = {
    encode (message, writer = $bb5887be70760d1a$var$minimal_1.default.Writer.create()) {
        if (message.consensusState !== undefined) $4232fce010c3a46b$exports.Any.encode(message.consensusState, writer.uint32(10).fork()).ldelim();
        if (message.clientId !== "") writer.uint32(18).string(message.clientId);
        if (message.proof.length !== 0) writer.uint32(26).bytes(message.proof);
        if (message.proofHeight !== undefined) $0935332a1587f29e$exports.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bb5887be70760d1a$var$minimal_1.default.Reader ? input : new $bb5887be70760d1a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bb5887be70760d1a$var$baseQueryConnectionConsensusStateResponse);
        message.proof = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.consensusState = $4232fce010c3a46b$exports.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.clientId = reader.string();
                    break;
                case 3:
                    message.proof = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = $0935332a1587f29e$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $bb5887be70760d1a$var$baseQueryConnectionConsensusStateResponse);
        message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? $4232fce010c3a46b$exports.Any.fromJSON(object.consensusState) : undefined;
        message.clientId = object.clientId !== undefined && object.clientId !== null ? String(object.clientId) : "";
        message.proof = object.proof !== undefined && object.proof !== null ? $bb5887be70760d1a$var$bytesFromBase64(object.proof) : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromJSON(object.proofHeight) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.consensusState !== undefined && (obj.consensusState = message.consensusState ? $4232fce010c3a46b$exports.Any.toJSON(message.consensusState) : undefined);
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.proof !== undefined && (obj.proof = $bb5887be70760d1a$var$base64FromBytes(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $0935332a1587f29e$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $bb5887be70760d1a$var$baseQueryConnectionConsensusStateResponse);
        message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? $4232fce010c3a46b$exports.Any.fromPartial(object.consensusState) : undefined;
        message.clientId = (_a = object.clientId) !== null && _a !== void 0 ? _a : "";
        message.proof = (_b = object.proof) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $0935332a1587f29e$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
class $bb5887be70760d1a$var$QueryClientImpl {
    Connection(request) {
        const data = $bb5887be70760d1a$exports.QueryConnectionRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Query", "Connection", data);
        return promise.then((data)=>$bb5887be70760d1a$exports.QueryConnectionResponse.decode(new $bb5887be70760d1a$var$minimal_1.default.Reader(data)));
    }
    Connections(request) {
        const data = $bb5887be70760d1a$exports.QueryConnectionsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Query", "Connections", data);
        return promise.then((data)=>$bb5887be70760d1a$exports.QueryConnectionsResponse.decode(new $bb5887be70760d1a$var$minimal_1.default.Reader(data)));
    }
    ClientConnections(request) {
        const data = $bb5887be70760d1a$exports.QueryClientConnectionsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Query", "ClientConnections", data);
        return promise.then((data)=>$bb5887be70760d1a$exports.QueryClientConnectionsResponse.decode(new $bb5887be70760d1a$var$minimal_1.default.Reader(data)));
    }
    ConnectionClientState(request) {
        const data = $bb5887be70760d1a$exports.QueryConnectionClientStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Query", "ConnectionClientState", data);
        return promise.then((data)=>$bb5887be70760d1a$exports.QueryConnectionClientStateResponse.decode(new $bb5887be70760d1a$var$minimal_1.default.Reader(data)));
    }
    ConnectionConsensusState(request) {
        const data = $bb5887be70760d1a$exports.QueryConnectionConsensusStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Query", "ConnectionConsensusState", data);
        return promise.then((data)=>$bb5887be70760d1a$exports.QueryConnectionConsensusStateResponse.decode(new $bb5887be70760d1a$var$minimal_1.default.Reader(data)));
    }
    constructor(rpc){
        this.rpc = rpc;
        this.Connection = this.Connection.bind(this);
        this.Connections = this.Connections.bind(this);
        this.ClientConnections = this.ClientConnections.bind(this);
        this.ConnectionClientState = this.ConnectionClientState.bind(this);
        this.ConnectionConsensusState = this.ConnectionConsensusState.bind(this);
    }
}
$bb5887be70760d1a$exports.QueryClientImpl = $bb5887be70760d1a$var$QueryClientImpl;
var $bb5887be70760d1a$var$globalThis = (()=>{
    if (typeof $bb5887be70760d1a$var$globalThis !== "undefined") return $bb5887be70760d1a$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $bb5887be70760d1a$var$atob = $bb5887be70760d1a$var$globalThis.atob || ((b64)=>$bb5887be70760d1a$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $bb5887be70760d1a$var$bytesFromBase64(b64) {
    const bin = $bb5887be70760d1a$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $bb5887be70760d1a$var$btoa = $bb5887be70760d1a$var$globalThis.btoa || ((bin)=>$bb5887be70760d1a$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $bb5887be70760d1a$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $bb5887be70760d1a$var$btoa(bin.join(""));
}
if ($bb5887be70760d1a$var$minimal_1.default.util.Long !== $bb5887be70760d1a$var$long_1.default) {
    $bb5887be70760d1a$var$minimal_1.default.util.Long = $bb5887be70760d1a$var$long_1.default;
    $bb5887be70760d1a$var$minimal_1.default.configure();
}


var $b474f8c71dfdb93e$exports = {};
"use strict";
var $b474f8c71dfdb93e$var$__importDefault = $b474f8c71dfdb93e$exports && $b474f8c71dfdb93e$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($b474f8c71dfdb93e$exports, "__esModule", {
    value: true
});
$b474f8c71dfdb93e$exports.Fraction = $b474f8c71dfdb93e$exports.Header = $b474f8c71dfdb93e$exports.Misbehaviour = $b474f8c71dfdb93e$exports.ConsensusState = $b474f8c71dfdb93e$exports.ClientState = $b474f8c71dfdb93e$exports.protobufPackage = void 0;

/* eslint-disable */ const $b474f8c71dfdb93e$var$long_1 = $b474f8c71dfdb93e$var$__importDefault((parcelRequire("9A55m")));

const $b474f8c71dfdb93e$var$minimal_1 = $b474f8c71dfdb93e$var$__importDefault((parcelRequire("i2pIU")));




var $0aefc245ff398d69$exports = {};
"use strict";
var $0aefc245ff398d69$var$__importDefault = $0aefc245ff398d69$exports && $0aefc245ff398d69$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($0aefc245ff398d69$exports, "__esModule", {
    value: true
});
$0aefc245ff398d69$exports.TxProof = $0aefc245ff398d69$exports.BlockMeta = $0aefc245ff398d69$exports.LightBlock = $0aefc245ff398d69$exports.SignedHeader = $0aefc245ff398d69$exports.Proposal = $0aefc245ff398d69$exports.CommitSig = $0aefc245ff398d69$exports.Commit = $0aefc245ff398d69$exports.Vote = $0aefc245ff398d69$exports.Data = $0aefc245ff398d69$exports.Header = $0aefc245ff398d69$exports.BlockID = $0aefc245ff398d69$exports.Part = $0aefc245ff398d69$exports.PartSetHeader = $0aefc245ff398d69$exports.signedMsgTypeToJSON = $0aefc245ff398d69$exports.signedMsgTypeFromJSON = $0aefc245ff398d69$exports.SignedMsgType = $0aefc245ff398d69$exports.blockIDFlagToJSON = $0aefc245ff398d69$exports.blockIDFlagFromJSON = $0aefc245ff398d69$exports.BlockIDFlag = $0aefc245ff398d69$exports.protobufPackage = void 0;

/* eslint-disable */ const $0aefc245ff398d69$var$long_1 = $0aefc245ff398d69$var$__importDefault((parcelRequire("9A55m")));

const $0aefc245ff398d69$var$minimal_1 = $0aefc245ff398d69$var$__importDefault((parcelRequire("i2pIU")));
var $a2ff8534202d742a$exports = {};
"use strict";
var $a2ff8534202d742a$var$__importDefault = $a2ff8534202d742a$exports && $a2ff8534202d742a$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($a2ff8534202d742a$exports, "__esModule", {
    value: true
});
$a2ff8534202d742a$exports.ProofOps = $a2ff8534202d742a$exports.ProofOp = $a2ff8534202d742a$exports.DominoOp = $a2ff8534202d742a$exports.ValueOp = $a2ff8534202d742a$exports.Proof = $a2ff8534202d742a$exports.protobufPackage = void 0;

/* eslint-disable */ const $a2ff8534202d742a$var$long_1 = $a2ff8534202d742a$var$__importDefault((parcelRequire("9A55m")));

const $a2ff8534202d742a$var$minimal_1 = $a2ff8534202d742a$var$__importDefault((parcelRequire("i2pIU")));
$a2ff8534202d742a$exports.protobufPackage = "tendermint.crypto";
const $a2ff8534202d742a$var$baseProof = {
    total: $a2ff8534202d742a$var$long_1.default.ZERO,
    index: $a2ff8534202d742a$var$long_1.default.ZERO
};
$a2ff8534202d742a$exports.Proof = {
    encode (message, writer = $a2ff8534202d742a$var$minimal_1.default.Writer.create()) {
        if (!message.total.isZero()) writer.uint32(8).int64(message.total);
        if (!message.index.isZero()) writer.uint32(16).int64(message.index);
        if (message.leafHash.length !== 0) writer.uint32(26).bytes(message.leafHash);
        for (const v of message.aunts)writer.uint32(34).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a2ff8534202d742a$var$minimal_1.default.Reader ? input : new $a2ff8534202d742a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $a2ff8534202d742a$var$baseProof);
        message.aunts = [];
        message.leafHash = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.total = reader.int64();
                    break;
                case 2:
                    message.index = reader.int64();
                    break;
                case 3:
                    message.leafHash = reader.bytes();
                    break;
                case 4:
                    message.aunts.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $a2ff8534202d742a$var$baseProof);
        message.total = object.total !== undefined && object.total !== null ? $a2ff8534202d742a$var$long_1.default.fromString(object.total) : $a2ff8534202d742a$var$long_1.default.ZERO;
        message.index = object.index !== undefined && object.index !== null ? $a2ff8534202d742a$var$long_1.default.fromString(object.index) : $a2ff8534202d742a$var$long_1.default.ZERO;
        message.leafHash = object.leafHash !== undefined && object.leafHash !== null ? $a2ff8534202d742a$var$bytesFromBase64(object.leafHash) : new Uint8Array();
        message.aunts = ((_a = object.aunts) !== null && _a !== void 0 ? _a : []).map((e)=>$a2ff8534202d742a$var$bytesFromBase64(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.total !== undefined && (obj.total = (message.total || $a2ff8534202d742a$var$long_1.default.ZERO).toString());
        message.index !== undefined && (obj.index = (message.index || $a2ff8534202d742a$var$long_1.default.ZERO).toString());
        message.leafHash !== undefined && (obj.leafHash = $a2ff8534202d742a$var$base64FromBytes(message.leafHash !== undefined ? message.leafHash : new Uint8Array()));
        if (message.aunts) obj.aunts = message.aunts.map((e)=>$a2ff8534202d742a$var$base64FromBytes(e !== undefined ? e : new Uint8Array()));
        else obj.aunts = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $a2ff8534202d742a$var$baseProof);
        message.total = object.total !== undefined && object.total !== null ? $a2ff8534202d742a$var$long_1.default.fromValue(object.total) : $a2ff8534202d742a$var$long_1.default.ZERO;
        message.index = object.index !== undefined && object.index !== null ? $a2ff8534202d742a$var$long_1.default.fromValue(object.index) : $a2ff8534202d742a$var$long_1.default.ZERO;
        message.leafHash = (_a = object.leafHash) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.aunts = ((_b = object.aunts) === null || _b === void 0 ? void 0 : _b.map((e)=>e)) || [];
        return message;
    }
};
const $a2ff8534202d742a$var$baseValueOp = {};
$a2ff8534202d742a$exports.ValueOp = {
    encode (message, writer = $a2ff8534202d742a$var$minimal_1.default.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (message.proof !== undefined) $a2ff8534202d742a$exports.Proof.encode(message.proof, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a2ff8534202d742a$var$minimal_1.default.Reader ? input : new $a2ff8534202d742a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $a2ff8534202d742a$var$baseValueOp);
        message.key = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.proof = $a2ff8534202d742a$exports.Proof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $a2ff8534202d742a$var$baseValueOp);
        message.key = object.key !== undefined && object.key !== null ? $a2ff8534202d742a$var$bytesFromBase64(object.key) : new Uint8Array();
        message.proof = object.proof !== undefined && object.proof !== null ? $a2ff8534202d742a$exports.Proof.fromJSON(object.proof) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = $a2ff8534202d742a$var$base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        message.proof !== undefined && (obj.proof = message.proof ? $a2ff8534202d742a$exports.Proof.toJSON(message.proof) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $a2ff8534202d742a$var$baseValueOp);
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.proof = object.proof !== undefined && object.proof !== null ? $a2ff8534202d742a$exports.Proof.fromPartial(object.proof) : undefined;
        return message;
    }
};
const $a2ff8534202d742a$var$baseDominoOp = {
    key: "",
    input: "",
    output: ""
};
$a2ff8534202d742a$exports.DominoOp = {
    encode (message, writer = $a2ff8534202d742a$var$minimal_1.default.Writer.create()) {
        if (message.key !== "") writer.uint32(10).string(message.key);
        if (message.input !== "") writer.uint32(18).string(message.input);
        if (message.output !== "") writer.uint32(26).string(message.output);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a2ff8534202d742a$var$minimal_1.default.Reader ? input : new $a2ff8534202d742a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $a2ff8534202d742a$var$baseDominoOp);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.input = reader.string();
                    break;
                case 3:
                    message.output = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $a2ff8534202d742a$var$baseDominoOp);
        message.key = object.key !== undefined && object.key !== null ? String(object.key) : "";
        message.input = object.input !== undefined && object.input !== null ? String(object.input) : "";
        message.output = object.output !== undefined && object.output !== null ? String(object.output) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = message.key);
        message.input !== undefined && (obj.input = message.input);
        message.output !== undefined && (obj.output = message.output);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $a2ff8534202d742a$var$baseDominoOp);
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "";
        message.input = (_b = object.input) !== null && _b !== void 0 ? _b : "";
        message.output = (_c = object.output) !== null && _c !== void 0 ? _c : "";
        return message;
    }
};
const $a2ff8534202d742a$var$baseProofOp = {
    type: ""
};
$a2ff8534202d742a$exports.ProofOp = {
    encode (message, writer = $a2ff8534202d742a$var$minimal_1.default.Writer.create()) {
        if (message.type !== "") writer.uint32(10).string(message.type);
        if (message.key.length !== 0) writer.uint32(18).bytes(message.key);
        if (message.data.length !== 0) writer.uint32(26).bytes(message.data);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a2ff8534202d742a$var$minimal_1.default.Reader ? input : new $a2ff8534202d742a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $a2ff8534202d742a$var$baseProofOp);
        message.key = new Uint8Array();
        message.data = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.string();
                    break;
                case 2:
                    message.key = reader.bytes();
                    break;
                case 3:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $a2ff8534202d742a$var$baseProofOp);
        message.type = object.type !== undefined && object.type !== null ? String(object.type) : "";
        message.key = object.key !== undefined && object.key !== null ? $a2ff8534202d742a$var$bytesFromBase64(object.key) : new Uint8Array();
        message.data = object.data !== undefined && object.data !== null ? $a2ff8534202d742a$var$bytesFromBase64(object.data) : new Uint8Array();
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.type !== undefined && (obj.type = message.type);
        message.key !== undefined && (obj.key = $a2ff8534202d742a$var$base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        message.data !== undefined && (obj.data = $a2ff8534202d742a$var$base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $a2ff8534202d742a$var$baseProofOp);
        message.type = (_a = object.type) !== null && _a !== void 0 ? _a : "";
        message.key = (_b = object.key) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.data = (_c = object.data) !== null && _c !== void 0 ? _c : new Uint8Array();
        return message;
    }
};
const $a2ff8534202d742a$var$baseProofOps = {};
$a2ff8534202d742a$exports.ProofOps = {
    encode (message, writer = $a2ff8534202d742a$var$minimal_1.default.Writer.create()) {
        for (const v of message.ops)$a2ff8534202d742a$exports.ProofOp.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a2ff8534202d742a$var$minimal_1.default.Reader ? input : new $a2ff8534202d742a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $a2ff8534202d742a$var$baseProofOps);
        message.ops = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.ops.push($a2ff8534202d742a$exports.ProofOp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $a2ff8534202d742a$var$baseProofOps);
        message.ops = ((_a = object.ops) !== null && _a !== void 0 ? _a : []).map((e)=>$a2ff8534202d742a$exports.ProofOp.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.ops) obj.ops = message.ops.map((e)=>e ? $a2ff8534202d742a$exports.ProofOp.toJSON(e) : undefined);
        else obj.ops = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $a2ff8534202d742a$var$baseProofOps);
        message.ops = ((_a = object.ops) === null || _a === void 0 ? void 0 : _a.map((e)=>$a2ff8534202d742a$exports.ProofOp.fromPartial(e))) || [];
        return message;
    }
};
var $a2ff8534202d742a$var$globalThis = (()=>{
    if (typeof $a2ff8534202d742a$var$globalThis !== "undefined") return $a2ff8534202d742a$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $a2ff8534202d742a$var$atob = $a2ff8534202d742a$var$globalThis.atob || ((b64)=>$a2ff8534202d742a$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $a2ff8534202d742a$var$bytesFromBase64(b64) {
    const bin = $a2ff8534202d742a$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $a2ff8534202d742a$var$btoa = $a2ff8534202d742a$var$globalThis.btoa || ((bin)=>$a2ff8534202d742a$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $a2ff8534202d742a$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $a2ff8534202d742a$var$btoa(bin.join(""));
}
if ($a2ff8534202d742a$var$minimal_1.default.util.Long !== $a2ff8534202d742a$var$long_1.default) {
    $a2ff8534202d742a$var$minimal_1.default.util.Long = $a2ff8534202d742a$var$long_1.default;
    $a2ff8534202d742a$var$minimal_1.default.configure();
}


var $e02d6edf6590358b$exports = {};
"use strict";
var $e02d6edf6590358b$var$__importDefault = $e02d6edf6590358b$exports && $e02d6edf6590358b$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($e02d6edf6590358b$exports, "__esModule", {
    value: true
});
$e02d6edf6590358b$exports.Consensus = $e02d6edf6590358b$exports.App = $e02d6edf6590358b$exports.protobufPackage = void 0;

/* eslint-disable */ const $e02d6edf6590358b$var$long_1 = $e02d6edf6590358b$var$__importDefault((parcelRequire("9A55m")));

const $e02d6edf6590358b$var$minimal_1 = $e02d6edf6590358b$var$__importDefault((parcelRequire("i2pIU")));
$e02d6edf6590358b$exports.protobufPackage = "tendermint.version";
const $e02d6edf6590358b$var$baseApp = {
    protocol: $e02d6edf6590358b$var$long_1.default.UZERO,
    software: ""
};
$e02d6edf6590358b$exports.App = {
    encode (message, writer = $e02d6edf6590358b$var$minimal_1.default.Writer.create()) {
        if (!message.protocol.isZero()) writer.uint32(8).uint64(message.protocol);
        if (message.software !== "") writer.uint32(18).string(message.software);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e02d6edf6590358b$var$minimal_1.default.Reader ? input : new $e02d6edf6590358b$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $e02d6edf6590358b$var$baseApp);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.protocol = reader.uint64();
                    break;
                case 2:
                    message.software = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $e02d6edf6590358b$var$baseApp);
        message.protocol = object.protocol !== undefined && object.protocol !== null ? $e02d6edf6590358b$var$long_1.default.fromString(object.protocol) : $e02d6edf6590358b$var$long_1.default.UZERO;
        message.software = object.software !== undefined && object.software !== null ? String(object.software) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.protocol !== undefined && (obj.protocol = (message.protocol || $e02d6edf6590358b$var$long_1.default.UZERO).toString());
        message.software !== undefined && (obj.software = message.software);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $e02d6edf6590358b$var$baseApp);
        message.protocol = object.protocol !== undefined && object.protocol !== null ? $e02d6edf6590358b$var$long_1.default.fromValue(object.protocol) : $e02d6edf6590358b$var$long_1.default.UZERO;
        message.software = (_a = object.software) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
const $e02d6edf6590358b$var$baseConsensus = {
    block: $e02d6edf6590358b$var$long_1.default.UZERO,
    app: $e02d6edf6590358b$var$long_1.default.UZERO
};
$e02d6edf6590358b$exports.Consensus = {
    encode (message, writer = $e02d6edf6590358b$var$minimal_1.default.Writer.create()) {
        if (!message.block.isZero()) writer.uint32(8).uint64(message.block);
        if (!message.app.isZero()) writer.uint32(16).uint64(message.app);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e02d6edf6590358b$var$minimal_1.default.Reader ? input : new $e02d6edf6590358b$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $e02d6edf6590358b$var$baseConsensus);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.block = reader.uint64();
                    break;
                case 2:
                    message.app = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $e02d6edf6590358b$var$baseConsensus);
        message.block = object.block !== undefined && object.block !== null ? $e02d6edf6590358b$var$long_1.default.fromString(object.block) : $e02d6edf6590358b$var$long_1.default.UZERO;
        message.app = object.app !== undefined && object.app !== null ? $e02d6edf6590358b$var$long_1.default.fromString(object.app) : $e02d6edf6590358b$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.block !== undefined && (obj.block = (message.block || $e02d6edf6590358b$var$long_1.default.UZERO).toString());
        message.app !== undefined && (obj.app = (message.app || $e02d6edf6590358b$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $e02d6edf6590358b$var$baseConsensus);
        message.block = object.block !== undefined && object.block !== null ? $e02d6edf6590358b$var$long_1.default.fromValue(object.block) : $e02d6edf6590358b$var$long_1.default.UZERO;
        message.app = object.app !== undefined && object.app !== null ? $e02d6edf6590358b$var$long_1.default.fromValue(object.app) : $e02d6edf6590358b$var$long_1.default.UZERO;
        return message;
    }
};
if ($e02d6edf6590358b$var$minimal_1.default.util.Long !== $e02d6edf6590358b$var$long_1.default) {
    $e02d6edf6590358b$var$minimal_1.default.util.Long = $e02d6edf6590358b$var$long_1.default;
    $e02d6edf6590358b$var$minimal_1.default.configure();
}



var $b006c8e31e8bc609$exports = {};
"use strict";
var $b006c8e31e8bc609$var$__importDefault = $b006c8e31e8bc609$exports && $b006c8e31e8bc609$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($b006c8e31e8bc609$exports, "__esModule", {
    value: true
});
$b006c8e31e8bc609$exports.SimpleValidator = $b006c8e31e8bc609$exports.Validator = $b006c8e31e8bc609$exports.ValidatorSet = $b006c8e31e8bc609$exports.protobufPackage = void 0;

/* eslint-disable */ const $b006c8e31e8bc609$var$long_1 = $b006c8e31e8bc609$var$__importDefault((parcelRequire("9A55m")));

const $b006c8e31e8bc609$var$minimal_1 = $b006c8e31e8bc609$var$__importDefault((parcelRequire("i2pIU")));
var $a9eed36e4809ba05$exports = {};
"use strict";
var $a9eed36e4809ba05$var$__importDefault = $a9eed36e4809ba05$exports && $a9eed36e4809ba05$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($a9eed36e4809ba05$exports, "__esModule", {
    value: true
});
$a9eed36e4809ba05$exports.PublicKey = $a9eed36e4809ba05$exports.protobufPackage = void 0;

/* eslint-disable */ const $a9eed36e4809ba05$var$long_1 = $a9eed36e4809ba05$var$__importDefault((parcelRequire("9A55m")));

const $a9eed36e4809ba05$var$minimal_1 = $a9eed36e4809ba05$var$__importDefault((parcelRequire("i2pIU")));
$a9eed36e4809ba05$exports.protobufPackage = "tendermint.crypto";
const $a9eed36e4809ba05$var$basePublicKey = {};
$a9eed36e4809ba05$exports.PublicKey = {
    encode (message, writer = $a9eed36e4809ba05$var$minimal_1.default.Writer.create()) {
        if (message.ed25519 !== undefined) writer.uint32(10).bytes(message.ed25519);
        if (message.secp256k1 !== undefined) writer.uint32(18).bytes(message.secp256k1);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a9eed36e4809ba05$var$minimal_1.default.Reader ? input : new $a9eed36e4809ba05$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $a9eed36e4809ba05$var$basePublicKey);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.ed25519 = reader.bytes();
                    break;
                case 2:
                    message.secp256k1 = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $a9eed36e4809ba05$var$basePublicKey);
        message.ed25519 = object.ed25519 !== undefined && object.ed25519 !== null ? $a9eed36e4809ba05$var$bytesFromBase64(object.ed25519) : undefined;
        message.secp256k1 = object.secp256k1 !== undefined && object.secp256k1 !== null ? $a9eed36e4809ba05$var$bytesFromBase64(object.secp256k1) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.ed25519 !== undefined && (obj.ed25519 = message.ed25519 !== undefined ? $a9eed36e4809ba05$var$base64FromBytes(message.ed25519) : undefined);
        message.secp256k1 !== undefined && (obj.secp256k1 = message.secp256k1 !== undefined ? $a9eed36e4809ba05$var$base64FromBytes(message.secp256k1) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $a9eed36e4809ba05$var$basePublicKey);
        message.ed25519 = (_a = object.ed25519) !== null && _a !== void 0 ? _a : undefined;
        message.secp256k1 = (_b = object.secp256k1) !== null && _b !== void 0 ? _b : undefined;
        return message;
    }
};
var $a9eed36e4809ba05$var$globalThis = (()=>{
    if (typeof $a9eed36e4809ba05$var$globalThis !== "undefined") return $a9eed36e4809ba05$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $a9eed36e4809ba05$var$atob = $a9eed36e4809ba05$var$globalThis.atob || ((b64)=>$a9eed36e4809ba05$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $a9eed36e4809ba05$var$bytesFromBase64(b64) {
    const bin = $a9eed36e4809ba05$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $a9eed36e4809ba05$var$btoa = $a9eed36e4809ba05$var$globalThis.btoa || ((bin)=>$a9eed36e4809ba05$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $a9eed36e4809ba05$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $a9eed36e4809ba05$var$btoa(bin.join(""));
}
if ($a9eed36e4809ba05$var$minimal_1.default.util.Long !== $a9eed36e4809ba05$var$long_1.default) {
    $a9eed36e4809ba05$var$minimal_1.default.util.Long = $a9eed36e4809ba05$var$long_1.default;
    $a9eed36e4809ba05$var$minimal_1.default.configure();
}


$b006c8e31e8bc609$exports.protobufPackage = "tendermint.types";
const $b006c8e31e8bc609$var$baseValidatorSet = {
    totalVotingPower: $b006c8e31e8bc609$var$long_1.default.ZERO
};
$b006c8e31e8bc609$exports.ValidatorSet = {
    encode (message, writer = $b006c8e31e8bc609$var$minimal_1.default.Writer.create()) {
        for (const v of message.validators)$b006c8e31e8bc609$exports.Validator.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.proposer !== undefined) $b006c8e31e8bc609$exports.Validator.encode(message.proposer, writer.uint32(18).fork()).ldelim();
        if (!message.totalVotingPower.isZero()) writer.uint32(24).int64(message.totalVotingPower);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b006c8e31e8bc609$var$minimal_1.default.Reader ? input : new $b006c8e31e8bc609$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b006c8e31e8bc609$var$baseValidatorSet);
        message.validators = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validators.push($b006c8e31e8bc609$exports.Validator.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.proposer = $b006c8e31e8bc609$exports.Validator.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.totalVotingPower = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $b006c8e31e8bc609$var$baseValidatorSet);
        message.validators = ((_a = object.validators) !== null && _a !== void 0 ? _a : []).map((e)=>$b006c8e31e8bc609$exports.Validator.fromJSON(e));
        message.proposer = object.proposer !== undefined && object.proposer !== null ? $b006c8e31e8bc609$exports.Validator.fromJSON(object.proposer) : undefined;
        message.totalVotingPower = object.totalVotingPower !== undefined && object.totalVotingPower !== null ? $b006c8e31e8bc609$var$long_1.default.fromString(object.totalVotingPower) : $b006c8e31e8bc609$var$long_1.default.ZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.validators) obj.validators = message.validators.map((e)=>e ? $b006c8e31e8bc609$exports.Validator.toJSON(e) : undefined);
        else obj.validators = [];
        message.proposer !== undefined && (obj.proposer = message.proposer ? $b006c8e31e8bc609$exports.Validator.toJSON(message.proposer) : undefined);
        message.totalVotingPower !== undefined && (obj.totalVotingPower = (message.totalVotingPower || $b006c8e31e8bc609$var$long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $b006c8e31e8bc609$var$baseValidatorSet);
        message.validators = ((_a = object.validators) === null || _a === void 0 ? void 0 : _a.map((e)=>$b006c8e31e8bc609$exports.Validator.fromPartial(e))) || [];
        message.proposer = object.proposer !== undefined && object.proposer !== null ? $b006c8e31e8bc609$exports.Validator.fromPartial(object.proposer) : undefined;
        message.totalVotingPower = object.totalVotingPower !== undefined && object.totalVotingPower !== null ? $b006c8e31e8bc609$var$long_1.default.fromValue(object.totalVotingPower) : $b006c8e31e8bc609$var$long_1.default.ZERO;
        return message;
    }
};
const $b006c8e31e8bc609$var$baseValidator = {
    votingPower: $b006c8e31e8bc609$var$long_1.default.ZERO,
    proposerPriority: $b006c8e31e8bc609$var$long_1.default.ZERO
};
$b006c8e31e8bc609$exports.Validator = {
    encode (message, writer = $b006c8e31e8bc609$var$minimal_1.default.Writer.create()) {
        if (message.address.length !== 0) writer.uint32(10).bytes(message.address);
        if (message.pubKey !== undefined) $a9eed36e4809ba05$exports.PublicKey.encode(message.pubKey, writer.uint32(18).fork()).ldelim();
        if (!message.votingPower.isZero()) writer.uint32(24).int64(message.votingPower);
        if (!message.proposerPriority.isZero()) writer.uint32(32).int64(message.proposerPriority);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b006c8e31e8bc609$var$minimal_1.default.Reader ? input : new $b006c8e31e8bc609$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b006c8e31e8bc609$var$baseValidator);
        message.address = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.bytes();
                    break;
                case 2:
                    message.pubKey = $a9eed36e4809ba05$exports.PublicKey.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.votingPower = reader.int64();
                    break;
                case 4:
                    message.proposerPriority = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $b006c8e31e8bc609$var$baseValidator);
        message.address = object.address !== undefined && object.address !== null ? $b006c8e31e8bc609$var$bytesFromBase64(object.address) : new Uint8Array();
        message.pubKey = object.pubKey !== undefined && object.pubKey !== null ? $a9eed36e4809ba05$exports.PublicKey.fromJSON(object.pubKey) : undefined;
        message.votingPower = object.votingPower !== undefined && object.votingPower !== null ? $b006c8e31e8bc609$var$long_1.default.fromString(object.votingPower) : $b006c8e31e8bc609$var$long_1.default.ZERO;
        message.proposerPriority = object.proposerPriority !== undefined && object.proposerPriority !== null ? $b006c8e31e8bc609$var$long_1.default.fromString(object.proposerPriority) : $b006c8e31e8bc609$var$long_1.default.ZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = $b006c8e31e8bc609$var$base64FromBytes(message.address !== undefined ? message.address : new Uint8Array()));
        message.pubKey !== undefined && (obj.pubKey = message.pubKey ? $a9eed36e4809ba05$exports.PublicKey.toJSON(message.pubKey) : undefined);
        message.votingPower !== undefined && (obj.votingPower = (message.votingPower || $b006c8e31e8bc609$var$long_1.default.ZERO).toString());
        message.proposerPriority !== undefined && (obj.proposerPriority = (message.proposerPriority || $b006c8e31e8bc609$var$long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $b006c8e31e8bc609$var$baseValidator);
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.pubKey = object.pubKey !== undefined && object.pubKey !== null ? $a9eed36e4809ba05$exports.PublicKey.fromPartial(object.pubKey) : undefined;
        message.votingPower = object.votingPower !== undefined && object.votingPower !== null ? $b006c8e31e8bc609$var$long_1.default.fromValue(object.votingPower) : $b006c8e31e8bc609$var$long_1.default.ZERO;
        message.proposerPriority = object.proposerPriority !== undefined && object.proposerPriority !== null ? $b006c8e31e8bc609$var$long_1.default.fromValue(object.proposerPriority) : $b006c8e31e8bc609$var$long_1.default.ZERO;
        return message;
    }
};
const $b006c8e31e8bc609$var$baseSimpleValidator = {
    votingPower: $b006c8e31e8bc609$var$long_1.default.ZERO
};
$b006c8e31e8bc609$exports.SimpleValidator = {
    encode (message, writer = $b006c8e31e8bc609$var$minimal_1.default.Writer.create()) {
        if (message.pubKey !== undefined) $a9eed36e4809ba05$exports.PublicKey.encode(message.pubKey, writer.uint32(10).fork()).ldelim();
        if (!message.votingPower.isZero()) writer.uint32(16).int64(message.votingPower);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b006c8e31e8bc609$var$minimal_1.default.Reader ? input : new $b006c8e31e8bc609$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b006c8e31e8bc609$var$baseSimpleValidator);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pubKey = $a9eed36e4809ba05$exports.PublicKey.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.votingPower = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $b006c8e31e8bc609$var$baseSimpleValidator);
        message.pubKey = object.pubKey !== undefined && object.pubKey !== null ? $a9eed36e4809ba05$exports.PublicKey.fromJSON(object.pubKey) : undefined;
        message.votingPower = object.votingPower !== undefined && object.votingPower !== null ? $b006c8e31e8bc609$var$long_1.default.fromString(object.votingPower) : $b006c8e31e8bc609$var$long_1.default.ZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.pubKey !== undefined && (obj.pubKey = message.pubKey ? $a9eed36e4809ba05$exports.PublicKey.toJSON(message.pubKey) : undefined);
        message.votingPower !== undefined && (obj.votingPower = (message.votingPower || $b006c8e31e8bc609$var$long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $b006c8e31e8bc609$var$baseSimpleValidator);
        message.pubKey = object.pubKey !== undefined && object.pubKey !== null ? $a9eed36e4809ba05$exports.PublicKey.fromPartial(object.pubKey) : undefined;
        message.votingPower = object.votingPower !== undefined && object.votingPower !== null ? $b006c8e31e8bc609$var$long_1.default.fromValue(object.votingPower) : $b006c8e31e8bc609$var$long_1.default.ZERO;
        return message;
    }
};
var $b006c8e31e8bc609$var$globalThis = (()=>{
    if (typeof $b006c8e31e8bc609$var$globalThis !== "undefined") return $b006c8e31e8bc609$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $b006c8e31e8bc609$var$atob = $b006c8e31e8bc609$var$globalThis.atob || ((b64)=>$b006c8e31e8bc609$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $b006c8e31e8bc609$var$bytesFromBase64(b64) {
    const bin = $b006c8e31e8bc609$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $b006c8e31e8bc609$var$btoa = $b006c8e31e8bc609$var$globalThis.btoa || ((bin)=>$b006c8e31e8bc609$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $b006c8e31e8bc609$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $b006c8e31e8bc609$var$btoa(bin.join(""));
}
if ($b006c8e31e8bc609$var$minimal_1.default.util.Long !== $b006c8e31e8bc609$var$long_1.default) {
    $b006c8e31e8bc609$var$minimal_1.default.util.Long = $b006c8e31e8bc609$var$long_1.default;
    $b006c8e31e8bc609$var$minimal_1.default.configure();
}


$0aefc245ff398d69$exports.protobufPackage = "tendermint.types";
/** BlockIdFlag indicates which BlcokID the signature is for */ var $0aefc245ff398d69$var$BlockIDFlag;
(function(BlockIDFlag) {
    BlockIDFlag[BlockIDFlag["BLOCK_ID_FLAG_UNKNOWN"] = 0] = "BLOCK_ID_FLAG_UNKNOWN";
    BlockIDFlag[BlockIDFlag["BLOCK_ID_FLAG_ABSENT"] = 1] = "BLOCK_ID_FLAG_ABSENT";
    BlockIDFlag[BlockIDFlag["BLOCK_ID_FLAG_COMMIT"] = 2] = "BLOCK_ID_FLAG_COMMIT";
    BlockIDFlag[BlockIDFlag["BLOCK_ID_FLAG_NIL"] = 3] = "BLOCK_ID_FLAG_NIL";
    BlockIDFlag[BlockIDFlag["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($0aefc245ff398d69$var$BlockIDFlag = $0aefc245ff398d69$exports.BlockIDFlag || ($0aefc245ff398d69$exports.BlockIDFlag = {}));
function $0aefc245ff398d69$var$blockIDFlagFromJSON(object) {
    switch(object){
        case 0:
        case "BLOCK_ID_FLAG_UNKNOWN":
            return $0aefc245ff398d69$var$BlockIDFlag.BLOCK_ID_FLAG_UNKNOWN;
        case 1:
        case "BLOCK_ID_FLAG_ABSENT":
            return $0aefc245ff398d69$var$BlockIDFlag.BLOCK_ID_FLAG_ABSENT;
        case 2:
        case "BLOCK_ID_FLAG_COMMIT":
            return $0aefc245ff398d69$var$BlockIDFlag.BLOCK_ID_FLAG_COMMIT;
        case 3:
        case "BLOCK_ID_FLAG_NIL":
            return $0aefc245ff398d69$var$BlockIDFlag.BLOCK_ID_FLAG_NIL;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $0aefc245ff398d69$var$BlockIDFlag.UNRECOGNIZED;
    }
}
$0aefc245ff398d69$exports.blockIDFlagFromJSON = $0aefc245ff398d69$var$blockIDFlagFromJSON;
function $0aefc245ff398d69$var$blockIDFlagToJSON(object) {
    switch(object){
        case $0aefc245ff398d69$var$BlockIDFlag.BLOCK_ID_FLAG_UNKNOWN:
            return "BLOCK_ID_FLAG_UNKNOWN";
        case $0aefc245ff398d69$var$BlockIDFlag.BLOCK_ID_FLAG_ABSENT:
            return "BLOCK_ID_FLAG_ABSENT";
        case $0aefc245ff398d69$var$BlockIDFlag.BLOCK_ID_FLAG_COMMIT:
            return "BLOCK_ID_FLAG_COMMIT";
        case $0aefc245ff398d69$var$BlockIDFlag.BLOCK_ID_FLAG_NIL:
            return "BLOCK_ID_FLAG_NIL";
        default:
            return "UNKNOWN";
    }
}
$0aefc245ff398d69$exports.blockIDFlagToJSON = $0aefc245ff398d69$var$blockIDFlagToJSON;
/** SignedMsgType is a type of signed message in the consensus. */ var $0aefc245ff398d69$var$SignedMsgType;
(function(SignedMsgType) {
    SignedMsgType[SignedMsgType["SIGNED_MSG_TYPE_UNKNOWN"] = 0] = "SIGNED_MSG_TYPE_UNKNOWN";
    /** SIGNED_MSG_TYPE_PREVOTE - Votes */ SignedMsgType[SignedMsgType["SIGNED_MSG_TYPE_PREVOTE"] = 1] = "SIGNED_MSG_TYPE_PREVOTE";
    SignedMsgType[SignedMsgType["SIGNED_MSG_TYPE_PRECOMMIT"] = 2] = "SIGNED_MSG_TYPE_PRECOMMIT";
    /** SIGNED_MSG_TYPE_PROPOSAL - Proposals */ SignedMsgType[SignedMsgType["SIGNED_MSG_TYPE_PROPOSAL"] = 32] = "SIGNED_MSG_TYPE_PROPOSAL";
    SignedMsgType[SignedMsgType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($0aefc245ff398d69$var$SignedMsgType = $0aefc245ff398d69$exports.SignedMsgType || ($0aefc245ff398d69$exports.SignedMsgType = {}));
function $0aefc245ff398d69$var$signedMsgTypeFromJSON(object) {
    switch(object){
        case 0:
        case "SIGNED_MSG_TYPE_UNKNOWN":
            return $0aefc245ff398d69$var$SignedMsgType.SIGNED_MSG_TYPE_UNKNOWN;
        case 1:
        case "SIGNED_MSG_TYPE_PREVOTE":
            return $0aefc245ff398d69$var$SignedMsgType.SIGNED_MSG_TYPE_PREVOTE;
        case 2:
        case "SIGNED_MSG_TYPE_PRECOMMIT":
            return $0aefc245ff398d69$var$SignedMsgType.SIGNED_MSG_TYPE_PRECOMMIT;
        case 32:
        case "SIGNED_MSG_TYPE_PROPOSAL":
            return $0aefc245ff398d69$var$SignedMsgType.SIGNED_MSG_TYPE_PROPOSAL;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $0aefc245ff398d69$var$SignedMsgType.UNRECOGNIZED;
    }
}
$0aefc245ff398d69$exports.signedMsgTypeFromJSON = $0aefc245ff398d69$var$signedMsgTypeFromJSON;
function $0aefc245ff398d69$var$signedMsgTypeToJSON(object) {
    switch(object){
        case $0aefc245ff398d69$var$SignedMsgType.SIGNED_MSG_TYPE_UNKNOWN:
            return "SIGNED_MSG_TYPE_UNKNOWN";
        case $0aefc245ff398d69$var$SignedMsgType.SIGNED_MSG_TYPE_PREVOTE:
            return "SIGNED_MSG_TYPE_PREVOTE";
        case $0aefc245ff398d69$var$SignedMsgType.SIGNED_MSG_TYPE_PRECOMMIT:
            return "SIGNED_MSG_TYPE_PRECOMMIT";
        case $0aefc245ff398d69$var$SignedMsgType.SIGNED_MSG_TYPE_PROPOSAL:
            return "SIGNED_MSG_TYPE_PROPOSAL";
        default:
            return "UNKNOWN";
    }
}
$0aefc245ff398d69$exports.signedMsgTypeToJSON = $0aefc245ff398d69$var$signedMsgTypeToJSON;
const $0aefc245ff398d69$var$basePartSetHeader = {
    total: 0
};
$0aefc245ff398d69$exports.PartSetHeader = {
    encode (message, writer = $0aefc245ff398d69$var$minimal_1.default.Writer.create()) {
        if (message.total !== 0) writer.uint32(8).uint32(message.total);
        if (message.hash.length !== 0) writer.uint32(18).bytes(message.hash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0aefc245ff398d69$var$minimal_1.default.Reader ? input : new $0aefc245ff398d69$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $0aefc245ff398d69$var$basePartSetHeader);
        message.hash = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.total = reader.uint32();
                    break;
                case 2:
                    message.hash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $0aefc245ff398d69$var$basePartSetHeader);
        message.total = object.total !== undefined && object.total !== null ? Number(object.total) : 0;
        message.hash = object.hash !== undefined && object.hash !== null ? $0aefc245ff398d69$var$bytesFromBase64(object.hash) : new Uint8Array();
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.total !== undefined && (obj.total = message.total);
        message.hash !== undefined && (obj.hash = $0aefc245ff398d69$var$base64FromBytes(message.hash !== undefined ? message.hash : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $0aefc245ff398d69$var$basePartSetHeader);
        message.total = (_a = object.total) !== null && _a !== void 0 ? _a : 0;
        message.hash = (_b = object.hash) !== null && _b !== void 0 ? _b : new Uint8Array();
        return message;
    }
};
const $0aefc245ff398d69$var$basePart = {
    index: 0
};
$0aefc245ff398d69$exports.Part = {
    encode (message, writer = $0aefc245ff398d69$var$minimal_1.default.Writer.create()) {
        if (message.index !== 0) writer.uint32(8).uint32(message.index);
        if (message.bytes.length !== 0) writer.uint32(18).bytes(message.bytes);
        if (message.proof !== undefined) $a2ff8534202d742a$exports.Proof.encode(message.proof, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0aefc245ff398d69$var$minimal_1.default.Reader ? input : new $0aefc245ff398d69$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $0aefc245ff398d69$var$basePart);
        message.bytes = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.index = reader.uint32();
                    break;
                case 2:
                    message.bytes = reader.bytes();
                    break;
                case 3:
                    message.proof = $a2ff8534202d742a$exports.Proof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $0aefc245ff398d69$var$basePart);
        message.index = object.index !== undefined && object.index !== null ? Number(object.index) : 0;
        message.bytes = object.bytes !== undefined && object.bytes !== null ? $0aefc245ff398d69$var$bytesFromBase64(object.bytes) : new Uint8Array();
        message.proof = object.proof !== undefined && object.proof !== null ? $a2ff8534202d742a$exports.Proof.fromJSON(object.proof) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.index !== undefined && (obj.index = message.index);
        message.bytes !== undefined && (obj.bytes = $0aefc245ff398d69$var$base64FromBytes(message.bytes !== undefined ? message.bytes : new Uint8Array()));
        message.proof !== undefined && (obj.proof = message.proof ? $a2ff8534202d742a$exports.Proof.toJSON(message.proof) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $0aefc245ff398d69$var$basePart);
        message.index = (_a = object.index) !== null && _a !== void 0 ? _a : 0;
        message.bytes = (_b = object.bytes) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.proof = object.proof !== undefined && object.proof !== null ? $a2ff8534202d742a$exports.Proof.fromPartial(object.proof) : undefined;
        return message;
    }
};
const $0aefc245ff398d69$var$baseBlockID = {};
$0aefc245ff398d69$exports.BlockID = {
    encode (message, writer = $0aefc245ff398d69$var$minimal_1.default.Writer.create()) {
        if (message.hash.length !== 0) writer.uint32(10).bytes(message.hash);
        if (message.partSetHeader !== undefined) $0aefc245ff398d69$exports.PartSetHeader.encode(message.partSetHeader, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0aefc245ff398d69$var$minimal_1.default.Reader ? input : new $0aefc245ff398d69$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $0aefc245ff398d69$var$baseBlockID);
        message.hash = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.bytes();
                    break;
                case 2:
                    message.partSetHeader = $0aefc245ff398d69$exports.PartSetHeader.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $0aefc245ff398d69$var$baseBlockID);
        message.hash = object.hash !== undefined && object.hash !== null ? $0aefc245ff398d69$var$bytesFromBase64(object.hash) : new Uint8Array();
        message.partSetHeader = object.partSetHeader !== undefined && object.partSetHeader !== null ? $0aefc245ff398d69$exports.PartSetHeader.fromJSON(object.partSetHeader) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = $0aefc245ff398d69$var$base64FromBytes(message.hash !== undefined ? message.hash : new Uint8Array()));
        message.partSetHeader !== undefined && (obj.partSetHeader = message.partSetHeader ? $0aefc245ff398d69$exports.PartSetHeader.toJSON(message.partSetHeader) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $0aefc245ff398d69$var$baseBlockID);
        message.hash = (_a = object.hash) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.partSetHeader = object.partSetHeader !== undefined && object.partSetHeader !== null ? $0aefc245ff398d69$exports.PartSetHeader.fromPartial(object.partSetHeader) : undefined;
        return message;
    }
};
const $0aefc245ff398d69$var$baseHeader = {
    chainId: "",
    height: $0aefc245ff398d69$var$long_1.default.ZERO
};
$0aefc245ff398d69$exports.Header = {
    encode (message, writer = $0aefc245ff398d69$var$minimal_1.default.Writer.create()) {
        if (message.version !== undefined) $e02d6edf6590358b$exports.Consensus.encode(message.version, writer.uint32(10).fork()).ldelim();
        if (message.chainId !== "") writer.uint32(18).string(message.chainId);
        if (!message.height.isZero()) writer.uint32(24).int64(message.height);
        if (message.time !== undefined) $d6c3291d6aa8eb5b$exports.Timestamp.encode(message.time, writer.uint32(34).fork()).ldelim();
        if (message.lastBlockId !== undefined) $0aefc245ff398d69$exports.BlockID.encode(message.lastBlockId, writer.uint32(42).fork()).ldelim();
        if (message.lastCommitHash.length !== 0) writer.uint32(50).bytes(message.lastCommitHash);
        if (message.dataHash.length !== 0) writer.uint32(58).bytes(message.dataHash);
        if (message.validatorsHash.length !== 0) writer.uint32(66).bytes(message.validatorsHash);
        if (message.nextValidatorsHash.length !== 0) writer.uint32(74).bytes(message.nextValidatorsHash);
        if (message.consensusHash.length !== 0) writer.uint32(82).bytes(message.consensusHash);
        if (message.appHash.length !== 0) writer.uint32(90).bytes(message.appHash);
        if (message.lastResultsHash.length !== 0) writer.uint32(98).bytes(message.lastResultsHash);
        if (message.evidenceHash.length !== 0) writer.uint32(106).bytes(message.evidenceHash);
        if (message.proposerAddress.length !== 0) writer.uint32(114).bytes(message.proposerAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0aefc245ff398d69$var$minimal_1.default.Reader ? input : new $0aefc245ff398d69$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $0aefc245ff398d69$var$baseHeader);
        message.lastCommitHash = new Uint8Array();
        message.dataHash = new Uint8Array();
        message.validatorsHash = new Uint8Array();
        message.nextValidatorsHash = new Uint8Array();
        message.consensusHash = new Uint8Array();
        message.appHash = new Uint8Array();
        message.lastResultsHash = new Uint8Array();
        message.evidenceHash = new Uint8Array();
        message.proposerAddress = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.version = $e02d6edf6590358b$exports.Consensus.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.chainId = reader.string();
                    break;
                case 3:
                    message.height = reader.int64();
                    break;
                case 4:
                    message.time = $d6c3291d6aa8eb5b$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.lastBlockId = $0aefc245ff398d69$exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.lastCommitHash = reader.bytes();
                    break;
                case 7:
                    message.dataHash = reader.bytes();
                    break;
                case 8:
                    message.validatorsHash = reader.bytes();
                    break;
                case 9:
                    message.nextValidatorsHash = reader.bytes();
                    break;
                case 10:
                    message.consensusHash = reader.bytes();
                    break;
                case 11:
                    message.appHash = reader.bytes();
                    break;
                case 12:
                    message.lastResultsHash = reader.bytes();
                    break;
                case 13:
                    message.evidenceHash = reader.bytes();
                    break;
                case 14:
                    message.proposerAddress = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $0aefc245ff398d69$var$baseHeader);
        message.version = object.version !== undefined && object.version !== null ? $e02d6edf6590358b$exports.Consensus.fromJSON(object.version) : undefined;
        message.chainId = object.chainId !== undefined && object.chainId !== null ? String(object.chainId) : "";
        message.height = object.height !== undefined && object.height !== null ? $0aefc245ff398d69$var$long_1.default.fromString(object.height) : $0aefc245ff398d69$var$long_1.default.ZERO;
        message.time = object.time !== undefined && object.time !== null ? $0aefc245ff398d69$var$fromJsonTimestamp(object.time) : undefined;
        message.lastBlockId = object.lastBlockId !== undefined && object.lastBlockId !== null ? $0aefc245ff398d69$exports.BlockID.fromJSON(object.lastBlockId) : undefined;
        message.lastCommitHash = object.lastCommitHash !== undefined && object.lastCommitHash !== null ? $0aefc245ff398d69$var$bytesFromBase64(object.lastCommitHash) : new Uint8Array();
        message.dataHash = object.dataHash !== undefined && object.dataHash !== null ? $0aefc245ff398d69$var$bytesFromBase64(object.dataHash) : new Uint8Array();
        message.validatorsHash = object.validatorsHash !== undefined && object.validatorsHash !== null ? $0aefc245ff398d69$var$bytesFromBase64(object.validatorsHash) : new Uint8Array();
        message.nextValidatorsHash = object.nextValidatorsHash !== undefined && object.nextValidatorsHash !== null ? $0aefc245ff398d69$var$bytesFromBase64(object.nextValidatorsHash) : new Uint8Array();
        message.consensusHash = object.consensusHash !== undefined && object.consensusHash !== null ? $0aefc245ff398d69$var$bytesFromBase64(object.consensusHash) : new Uint8Array();
        message.appHash = object.appHash !== undefined && object.appHash !== null ? $0aefc245ff398d69$var$bytesFromBase64(object.appHash) : new Uint8Array();
        message.lastResultsHash = object.lastResultsHash !== undefined && object.lastResultsHash !== null ? $0aefc245ff398d69$var$bytesFromBase64(object.lastResultsHash) : new Uint8Array();
        message.evidenceHash = object.evidenceHash !== undefined && object.evidenceHash !== null ? $0aefc245ff398d69$var$bytesFromBase64(object.evidenceHash) : new Uint8Array();
        message.proposerAddress = object.proposerAddress !== undefined && object.proposerAddress !== null ? $0aefc245ff398d69$var$bytesFromBase64(object.proposerAddress) : new Uint8Array();
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.version !== undefined && (obj.version = message.version ? $e02d6edf6590358b$exports.Consensus.toJSON(message.version) : undefined);
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.height !== undefined && (obj.height = (message.height || $0aefc245ff398d69$var$long_1.default.ZERO).toString());
        message.time !== undefined && (obj.time = $0aefc245ff398d69$var$fromTimestamp(message.time).toISOString());
        message.lastBlockId !== undefined && (obj.lastBlockId = message.lastBlockId ? $0aefc245ff398d69$exports.BlockID.toJSON(message.lastBlockId) : undefined);
        message.lastCommitHash !== undefined && (obj.lastCommitHash = $0aefc245ff398d69$var$base64FromBytes(message.lastCommitHash !== undefined ? message.lastCommitHash : new Uint8Array()));
        message.dataHash !== undefined && (obj.dataHash = $0aefc245ff398d69$var$base64FromBytes(message.dataHash !== undefined ? message.dataHash : new Uint8Array()));
        message.validatorsHash !== undefined && (obj.validatorsHash = $0aefc245ff398d69$var$base64FromBytes(message.validatorsHash !== undefined ? message.validatorsHash : new Uint8Array()));
        message.nextValidatorsHash !== undefined && (obj.nextValidatorsHash = $0aefc245ff398d69$var$base64FromBytes(message.nextValidatorsHash !== undefined ? message.nextValidatorsHash : new Uint8Array()));
        message.consensusHash !== undefined && (obj.consensusHash = $0aefc245ff398d69$var$base64FromBytes(message.consensusHash !== undefined ? message.consensusHash : new Uint8Array()));
        message.appHash !== undefined && (obj.appHash = $0aefc245ff398d69$var$base64FromBytes(message.appHash !== undefined ? message.appHash : new Uint8Array()));
        message.lastResultsHash !== undefined && (obj.lastResultsHash = $0aefc245ff398d69$var$base64FromBytes(message.lastResultsHash !== undefined ? message.lastResultsHash : new Uint8Array()));
        message.evidenceHash !== undefined && (obj.evidenceHash = $0aefc245ff398d69$var$base64FromBytes(message.evidenceHash !== undefined ? message.evidenceHash : new Uint8Array()));
        message.proposerAddress !== undefined && (obj.proposerAddress = $0aefc245ff398d69$var$base64FromBytes(message.proposerAddress !== undefined ? message.proposerAddress : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        const message = Object.assign({}, $0aefc245ff398d69$var$baseHeader);
        message.version = object.version !== undefined && object.version !== null ? $e02d6edf6590358b$exports.Consensus.fromPartial(object.version) : undefined;
        message.chainId = (_a = object.chainId) !== null && _a !== void 0 ? _a : "";
        message.height = object.height !== undefined && object.height !== null ? $0aefc245ff398d69$var$long_1.default.fromValue(object.height) : $0aefc245ff398d69$var$long_1.default.ZERO;
        message.time = object.time !== undefined && object.time !== null ? $d6c3291d6aa8eb5b$exports.Timestamp.fromPartial(object.time) : undefined;
        message.lastBlockId = object.lastBlockId !== undefined && object.lastBlockId !== null ? $0aefc245ff398d69$exports.BlockID.fromPartial(object.lastBlockId) : undefined;
        message.lastCommitHash = (_b = object.lastCommitHash) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.dataHash = (_c = object.dataHash) !== null && _c !== void 0 ? _c : new Uint8Array();
        message.validatorsHash = (_d = object.validatorsHash) !== null && _d !== void 0 ? _d : new Uint8Array();
        message.nextValidatorsHash = (_e = object.nextValidatorsHash) !== null && _e !== void 0 ? _e : new Uint8Array();
        message.consensusHash = (_f = object.consensusHash) !== null && _f !== void 0 ? _f : new Uint8Array();
        message.appHash = (_g = object.appHash) !== null && _g !== void 0 ? _g : new Uint8Array();
        message.lastResultsHash = (_h = object.lastResultsHash) !== null && _h !== void 0 ? _h : new Uint8Array();
        message.evidenceHash = (_j = object.evidenceHash) !== null && _j !== void 0 ? _j : new Uint8Array();
        message.proposerAddress = (_k = object.proposerAddress) !== null && _k !== void 0 ? _k : new Uint8Array();
        return message;
    }
};
const $0aefc245ff398d69$var$baseData = {};
$0aefc245ff398d69$exports.Data = {
    encode (message, writer = $0aefc245ff398d69$var$minimal_1.default.Writer.create()) {
        for (const v of message.txs)writer.uint32(10).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0aefc245ff398d69$var$minimal_1.default.Reader ? input : new $0aefc245ff398d69$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $0aefc245ff398d69$var$baseData);
        message.txs = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txs.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $0aefc245ff398d69$var$baseData);
        message.txs = ((_a = object.txs) !== null && _a !== void 0 ? _a : []).map((e)=>$0aefc245ff398d69$var$bytesFromBase64(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.txs) obj.txs = message.txs.map((e)=>$0aefc245ff398d69$var$base64FromBytes(e !== undefined ? e : new Uint8Array()));
        else obj.txs = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $0aefc245ff398d69$var$baseData);
        message.txs = ((_a = object.txs) === null || _a === void 0 ? void 0 : _a.map((e)=>e)) || [];
        return message;
    }
};
const $0aefc245ff398d69$var$baseVote = {
    type: 0,
    height: $0aefc245ff398d69$var$long_1.default.ZERO,
    round: 0,
    validatorIndex: 0
};
$0aefc245ff398d69$exports.Vote = {
    encode (message, writer = $0aefc245ff398d69$var$minimal_1.default.Writer.create()) {
        if (message.type !== 0) writer.uint32(8).int32(message.type);
        if (!message.height.isZero()) writer.uint32(16).int64(message.height);
        if (message.round !== 0) writer.uint32(24).int32(message.round);
        if (message.blockId !== undefined) $0aefc245ff398d69$exports.BlockID.encode(message.blockId, writer.uint32(34).fork()).ldelim();
        if (message.timestamp !== undefined) $d6c3291d6aa8eb5b$exports.Timestamp.encode(message.timestamp, writer.uint32(42).fork()).ldelim();
        if (message.validatorAddress.length !== 0) writer.uint32(50).bytes(message.validatorAddress);
        if (message.validatorIndex !== 0) writer.uint32(56).int32(message.validatorIndex);
        if (message.signature.length !== 0) writer.uint32(66).bytes(message.signature);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0aefc245ff398d69$var$minimal_1.default.Reader ? input : new $0aefc245ff398d69$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $0aefc245ff398d69$var$baseVote);
        message.validatorAddress = new Uint8Array();
        message.signature = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.int32();
                    break;
                case 2:
                    message.height = reader.int64();
                    break;
                case 3:
                    message.round = reader.int32();
                    break;
                case 4:
                    message.blockId = $0aefc245ff398d69$exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.timestamp = $d6c3291d6aa8eb5b$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.validatorAddress = reader.bytes();
                    break;
                case 7:
                    message.validatorIndex = reader.int32();
                    break;
                case 8:
                    message.signature = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $0aefc245ff398d69$var$baseVote);
        message.type = object.type !== undefined && object.type !== null ? $0aefc245ff398d69$var$signedMsgTypeFromJSON(object.type) : 0;
        message.height = object.height !== undefined && object.height !== null ? $0aefc245ff398d69$var$long_1.default.fromString(object.height) : $0aefc245ff398d69$var$long_1.default.ZERO;
        message.round = object.round !== undefined && object.round !== null ? Number(object.round) : 0;
        message.blockId = object.blockId !== undefined && object.blockId !== null ? $0aefc245ff398d69$exports.BlockID.fromJSON(object.blockId) : undefined;
        message.timestamp = object.timestamp !== undefined && object.timestamp !== null ? $0aefc245ff398d69$var$fromJsonTimestamp(object.timestamp) : undefined;
        message.validatorAddress = object.validatorAddress !== undefined && object.validatorAddress !== null ? $0aefc245ff398d69$var$bytesFromBase64(object.validatorAddress) : new Uint8Array();
        message.validatorIndex = object.validatorIndex !== undefined && object.validatorIndex !== null ? Number(object.validatorIndex) : 0;
        message.signature = object.signature !== undefined && object.signature !== null ? $0aefc245ff398d69$var$bytesFromBase64(object.signature) : new Uint8Array();
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.type !== undefined && (obj.type = $0aefc245ff398d69$var$signedMsgTypeToJSON(message.type));
        message.height !== undefined && (obj.height = (message.height || $0aefc245ff398d69$var$long_1.default.ZERO).toString());
        message.round !== undefined && (obj.round = message.round);
        message.blockId !== undefined && (obj.blockId = message.blockId ? $0aefc245ff398d69$exports.BlockID.toJSON(message.blockId) : undefined);
        message.timestamp !== undefined && (obj.timestamp = $0aefc245ff398d69$var$fromTimestamp(message.timestamp).toISOString());
        message.validatorAddress !== undefined && (obj.validatorAddress = $0aefc245ff398d69$var$base64FromBytes(message.validatorAddress !== undefined ? message.validatorAddress : new Uint8Array()));
        message.validatorIndex !== undefined && (obj.validatorIndex = message.validatorIndex);
        message.signature !== undefined && (obj.signature = $0aefc245ff398d69$var$base64FromBytes(message.signature !== undefined ? message.signature : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e;
        const message = Object.assign({}, $0aefc245ff398d69$var$baseVote);
        message.type = (_a = object.type) !== null && _a !== void 0 ? _a : 0;
        message.height = object.height !== undefined && object.height !== null ? $0aefc245ff398d69$var$long_1.default.fromValue(object.height) : $0aefc245ff398d69$var$long_1.default.ZERO;
        message.round = (_b = object.round) !== null && _b !== void 0 ? _b : 0;
        message.blockId = object.blockId !== undefined && object.blockId !== null ? $0aefc245ff398d69$exports.BlockID.fromPartial(object.blockId) : undefined;
        message.timestamp = object.timestamp !== undefined && object.timestamp !== null ? $d6c3291d6aa8eb5b$exports.Timestamp.fromPartial(object.timestamp) : undefined;
        message.validatorAddress = (_c = object.validatorAddress) !== null && _c !== void 0 ? _c : new Uint8Array();
        message.validatorIndex = (_d = object.validatorIndex) !== null && _d !== void 0 ? _d : 0;
        message.signature = (_e = object.signature) !== null && _e !== void 0 ? _e : new Uint8Array();
        return message;
    }
};
const $0aefc245ff398d69$var$baseCommit = {
    height: $0aefc245ff398d69$var$long_1.default.ZERO,
    round: 0
};
$0aefc245ff398d69$exports.Commit = {
    encode (message, writer = $0aefc245ff398d69$var$minimal_1.default.Writer.create()) {
        if (!message.height.isZero()) writer.uint32(8).int64(message.height);
        if (message.round !== 0) writer.uint32(16).int32(message.round);
        if (message.blockId !== undefined) $0aefc245ff398d69$exports.BlockID.encode(message.blockId, writer.uint32(26).fork()).ldelim();
        for (const v of message.signatures)$0aefc245ff398d69$exports.CommitSig.encode(v, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0aefc245ff398d69$var$minimal_1.default.Reader ? input : new $0aefc245ff398d69$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $0aefc245ff398d69$var$baseCommit);
        message.signatures = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.int64();
                    break;
                case 2:
                    message.round = reader.int32();
                    break;
                case 3:
                    message.blockId = $0aefc245ff398d69$exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.signatures.push($0aefc245ff398d69$exports.CommitSig.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $0aefc245ff398d69$var$baseCommit);
        message.height = object.height !== undefined && object.height !== null ? $0aefc245ff398d69$var$long_1.default.fromString(object.height) : $0aefc245ff398d69$var$long_1.default.ZERO;
        message.round = object.round !== undefined && object.round !== null ? Number(object.round) : 0;
        message.blockId = object.blockId !== undefined && object.blockId !== null ? $0aefc245ff398d69$exports.BlockID.fromJSON(object.blockId) : undefined;
        message.signatures = ((_a = object.signatures) !== null && _a !== void 0 ? _a : []).map((e)=>$0aefc245ff398d69$exports.CommitSig.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || $0aefc245ff398d69$var$long_1.default.ZERO).toString());
        message.round !== undefined && (obj.round = message.round);
        message.blockId !== undefined && (obj.blockId = message.blockId ? $0aefc245ff398d69$exports.BlockID.toJSON(message.blockId) : undefined);
        if (message.signatures) obj.signatures = message.signatures.map((e)=>e ? $0aefc245ff398d69$exports.CommitSig.toJSON(e) : undefined);
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $0aefc245ff398d69$var$baseCommit);
        message.height = object.height !== undefined && object.height !== null ? $0aefc245ff398d69$var$long_1.default.fromValue(object.height) : $0aefc245ff398d69$var$long_1.default.ZERO;
        message.round = (_a = object.round) !== null && _a !== void 0 ? _a : 0;
        message.blockId = object.blockId !== undefined && object.blockId !== null ? $0aefc245ff398d69$exports.BlockID.fromPartial(object.blockId) : undefined;
        message.signatures = ((_b = object.signatures) === null || _b === void 0 ? void 0 : _b.map((e)=>$0aefc245ff398d69$exports.CommitSig.fromPartial(e))) || [];
        return message;
    }
};
const $0aefc245ff398d69$var$baseCommitSig = {
    blockIdFlag: 0
};
$0aefc245ff398d69$exports.CommitSig = {
    encode (message, writer = $0aefc245ff398d69$var$minimal_1.default.Writer.create()) {
        if (message.blockIdFlag !== 0) writer.uint32(8).int32(message.blockIdFlag);
        if (message.validatorAddress.length !== 0) writer.uint32(18).bytes(message.validatorAddress);
        if (message.timestamp !== undefined) $d6c3291d6aa8eb5b$exports.Timestamp.encode(message.timestamp, writer.uint32(26).fork()).ldelim();
        if (message.signature.length !== 0) writer.uint32(34).bytes(message.signature);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0aefc245ff398d69$var$minimal_1.default.Reader ? input : new $0aefc245ff398d69$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $0aefc245ff398d69$var$baseCommitSig);
        message.validatorAddress = new Uint8Array();
        message.signature = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.blockIdFlag = reader.int32();
                    break;
                case 2:
                    message.validatorAddress = reader.bytes();
                    break;
                case 3:
                    message.timestamp = $d6c3291d6aa8eb5b$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.signature = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $0aefc245ff398d69$var$baseCommitSig);
        message.blockIdFlag = object.blockIdFlag !== undefined && object.blockIdFlag !== null ? $0aefc245ff398d69$var$blockIDFlagFromJSON(object.blockIdFlag) : 0;
        message.validatorAddress = object.validatorAddress !== undefined && object.validatorAddress !== null ? $0aefc245ff398d69$var$bytesFromBase64(object.validatorAddress) : new Uint8Array();
        message.timestamp = object.timestamp !== undefined && object.timestamp !== null ? $0aefc245ff398d69$var$fromJsonTimestamp(object.timestamp) : undefined;
        message.signature = object.signature !== undefined && object.signature !== null ? $0aefc245ff398d69$var$bytesFromBase64(object.signature) : new Uint8Array();
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.blockIdFlag !== undefined && (obj.blockIdFlag = $0aefc245ff398d69$var$blockIDFlagToJSON(message.blockIdFlag));
        message.validatorAddress !== undefined && (obj.validatorAddress = $0aefc245ff398d69$var$base64FromBytes(message.validatorAddress !== undefined ? message.validatorAddress : new Uint8Array()));
        message.timestamp !== undefined && (obj.timestamp = $0aefc245ff398d69$var$fromTimestamp(message.timestamp).toISOString());
        message.signature !== undefined && (obj.signature = $0aefc245ff398d69$var$base64FromBytes(message.signature !== undefined ? message.signature : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $0aefc245ff398d69$var$baseCommitSig);
        message.blockIdFlag = (_a = object.blockIdFlag) !== null && _a !== void 0 ? _a : 0;
        message.validatorAddress = (_b = object.validatorAddress) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.timestamp = object.timestamp !== undefined && object.timestamp !== null ? $d6c3291d6aa8eb5b$exports.Timestamp.fromPartial(object.timestamp) : undefined;
        message.signature = (_c = object.signature) !== null && _c !== void 0 ? _c : new Uint8Array();
        return message;
    }
};
const $0aefc245ff398d69$var$baseProposal = {
    type: 0,
    height: $0aefc245ff398d69$var$long_1.default.ZERO,
    round: 0,
    polRound: 0
};
$0aefc245ff398d69$exports.Proposal = {
    encode (message, writer = $0aefc245ff398d69$var$minimal_1.default.Writer.create()) {
        if (message.type !== 0) writer.uint32(8).int32(message.type);
        if (!message.height.isZero()) writer.uint32(16).int64(message.height);
        if (message.round !== 0) writer.uint32(24).int32(message.round);
        if (message.polRound !== 0) writer.uint32(32).int32(message.polRound);
        if (message.blockId !== undefined) $0aefc245ff398d69$exports.BlockID.encode(message.blockId, writer.uint32(42).fork()).ldelim();
        if (message.timestamp !== undefined) $d6c3291d6aa8eb5b$exports.Timestamp.encode(message.timestamp, writer.uint32(50).fork()).ldelim();
        if (message.signature.length !== 0) writer.uint32(58).bytes(message.signature);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0aefc245ff398d69$var$minimal_1.default.Reader ? input : new $0aefc245ff398d69$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $0aefc245ff398d69$var$baseProposal);
        message.signature = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.int32();
                    break;
                case 2:
                    message.height = reader.int64();
                    break;
                case 3:
                    message.round = reader.int32();
                    break;
                case 4:
                    message.polRound = reader.int32();
                    break;
                case 5:
                    message.blockId = $0aefc245ff398d69$exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.timestamp = $d6c3291d6aa8eb5b$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.signature = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $0aefc245ff398d69$var$baseProposal);
        message.type = object.type !== undefined && object.type !== null ? $0aefc245ff398d69$var$signedMsgTypeFromJSON(object.type) : 0;
        message.height = object.height !== undefined && object.height !== null ? $0aefc245ff398d69$var$long_1.default.fromString(object.height) : $0aefc245ff398d69$var$long_1.default.ZERO;
        message.round = object.round !== undefined && object.round !== null ? Number(object.round) : 0;
        message.polRound = object.polRound !== undefined && object.polRound !== null ? Number(object.polRound) : 0;
        message.blockId = object.blockId !== undefined && object.blockId !== null ? $0aefc245ff398d69$exports.BlockID.fromJSON(object.blockId) : undefined;
        message.timestamp = object.timestamp !== undefined && object.timestamp !== null ? $0aefc245ff398d69$var$fromJsonTimestamp(object.timestamp) : undefined;
        message.signature = object.signature !== undefined && object.signature !== null ? $0aefc245ff398d69$var$bytesFromBase64(object.signature) : new Uint8Array();
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.type !== undefined && (obj.type = $0aefc245ff398d69$var$signedMsgTypeToJSON(message.type));
        message.height !== undefined && (obj.height = (message.height || $0aefc245ff398d69$var$long_1.default.ZERO).toString());
        message.round !== undefined && (obj.round = message.round);
        message.polRound !== undefined && (obj.polRound = message.polRound);
        message.blockId !== undefined && (obj.blockId = message.blockId ? $0aefc245ff398d69$exports.BlockID.toJSON(message.blockId) : undefined);
        message.timestamp !== undefined && (obj.timestamp = $0aefc245ff398d69$var$fromTimestamp(message.timestamp).toISOString());
        message.signature !== undefined && (obj.signature = $0aefc245ff398d69$var$base64FromBytes(message.signature !== undefined ? message.signature : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = Object.assign({}, $0aefc245ff398d69$var$baseProposal);
        message.type = (_a = object.type) !== null && _a !== void 0 ? _a : 0;
        message.height = object.height !== undefined && object.height !== null ? $0aefc245ff398d69$var$long_1.default.fromValue(object.height) : $0aefc245ff398d69$var$long_1.default.ZERO;
        message.round = (_b = object.round) !== null && _b !== void 0 ? _b : 0;
        message.polRound = (_c = object.polRound) !== null && _c !== void 0 ? _c : 0;
        message.blockId = object.blockId !== undefined && object.blockId !== null ? $0aefc245ff398d69$exports.BlockID.fromPartial(object.blockId) : undefined;
        message.timestamp = object.timestamp !== undefined && object.timestamp !== null ? $d6c3291d6aa8eb5b$exports.Timestamp.fromPartial(object.timestamp) : undefined;
        message.signature = (_d = object.signature) !== null && _d !== void 0 ? _d : new Uint8Array();
        return message;
    }
};
const $0aefc245ff398d69$var$baseSignedHeader = {};
$0aefc245ff398d69$exports.SignedHeader = {
    encode (message, writer = $0aefc245ff398d69$var$minimal_1.default.Writer.create()) {
        if (message.header !== undefined) $0aefc245ff398d69$exports.Header.encode(message.header, writer.uint32(10).fork()).ldelim();
        if (message.commit !== undefined) $0aefc245ff398d69$exports.Commit.encode(message.commit, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0aefc245ff398d69$var$minimal_1.default.Reader ? input : new $0aefc245ff398d69$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $0aefc245ff398d69$var$baseSignedHeader);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.header = $0aefc245ff398d69$exports.Header.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.commit = $0aefc245ff398d69$exports.Commit.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $0aefc245ff398d69$var$baseSignedHeader);
        message.header = object.header !== undefined && object.header !== null ? $0aefc245ff398d69$exports.Header.fromJSON(object.header) : undefined;
        message.commit = object.commit !== undefined && object.commit !== null ? $0aefc245ff398d69$exports.Commit.fromJSON(object.commit) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.header !== undefined && (obj.header = message.header ? $0aefc245ff398d69$exports.Header.toJSON(message.header) : undefined);
        message.commit !== undefined && (obj.commit = message.commit ? $0aefc245ff398d69$exports.Commit.toJSON(message.commit) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $0aefc245ff398d69$var$baseSignedHeader);
        message.header = object.header !== undefined && object.header !== null ? $0aefc245ff398d69$exports.Header.fromPartial(object.header) : undefined;
        message.commit = object.commit !== undefined && object.commit !== null ? $0aefc245ff398d69$exports.Commit.fromPartial(object.commit) : undefined;
        return message;
    }
};
const $0aefc245ff398d69$var$baseLightBlock = {};
$0aefc245ff398d69$exports.LightBlock = {
    encode (message, writer = $0aefc245ff398d69$var$minimal_1.default.Writer.create()) {
        if (message.signedHeader !== undefined) $0aefc245ff398d69$exports.SignedHeader.encode(message.signedHeader, writer.uint32(10).fork()).ldelim();
        if (message.validatorSet !== undefined) $b006c8e31e8bc609$exports.ValidatorSet.encode(message.validatorSet, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0aefc245ff398d69$var$minimal_1.default.Reader ? input : new $0aefc245ff398d69$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $0aefc245ff398d69$var$baseLightBlock);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signedHeader = $0aefc245ff398d69$exports.SignedHeader.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.validatorSet = $b006c8e31e8bc609$exports.ValidatorSet.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $0aefc245ff398d69$var$baseLightBlock);
        message.signedHeader = object.signedHeader !== undefined && object.signedHeader !== null ? $0aefc245ff398d69$exports.SignedHeader.fromJSON(object.signedHeader) : undefined;
        message.validatorSet = object.validatorSet !== undefined && object.validatorSet !== null ? $b006c8e31e8bc609$exports.ValidatorSet.fromJSON(object.validatorSet) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.signedHeader !== undefined && (obj.signedHeader = message.signedHeader ? $0aefc245ff398d69$exports.SignedHeader.toJSON(message.signedHeader) : undefined);
        message.validatorSet !== undefined && (obj.validatorSet = message.validatorSet ? $b006c8e31e8bc609$exports.ValidatorSet.toJSON(message.validatorSet) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $0aefc245ff398d69$var$baseLightBlock);
        message.signedHeader = object.signedHeader !== undefined && object.signedHeader !== null ? $0aefc245ff398d69$exports.SignedHeader.fromPartial(object.signedHeader) : undefined;
        message.validatorSet = object.validatorSet !== undefined && object.validatorSet !== null ? $b006c8e31e8bc609$exports.ValidatorSet.fromPartial(object.validatorSet) : undefined;
        return message;
    }
};
const $0aefc245ff398d69$var$baseBlockMeta = {
    blockSize: $0aefc245ff398d69$var$long_1.default.ZERO,
    numTxs: $0aefc245ff398d69$var$long_1.default.ZERO
};
$0aefc245ff398d69$exports.BlockMeta = {
    encode (message, writer = $0aefc245ff398d69$var$minimal_1.default.Writer.create()) {
        if (message.blockId !== undefined) $0aefc245ff398d69$exports.BlockID.encode(message.blockId, writer.uint32(10).fork()).ldelim();
        if (!message.blockSize.isZero()) writer.uint32(16).int64(message.blockSize);
        if (message.header !== undefined) $0aefc245ff398d69$exports.Header.encode(message.header, writer.uint32(26).fork()).ldelim();
        if (!message.numTxs.isZero()) writer.uint32(32).int64(message.numTxs);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0aefc245ff398d69$var$minimal_1.default.Reader ? input : new $0aefc245ff398d69$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $0aefc245ff398d69$var$baseBlockMeta);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.blockId = $0aefc245ff398d69$exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.blockSize = reader.int64();
                    break;
                case 3:
                    message.header = $0aefc245ff398d69$exports.Header.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.numTxs = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $0aefc245ff398d69$var$baseBlockMeta);
        message.blockId = object.blockId !== undefined && object.blockId !== null ? $0aefc245ff398d69$exports.BlockID.fromJSON(object.blockId) : undefined;
        message.blockSize = object.blockSize !== undefined && object.blockSize !== null ? $0aefc245ff398d69$var$long_1.default.fromString(object.blockSize) : $0aefc245ff398d69$var$long_1.default.ZERO;
        message.header = object.header !== undefined && object.header !== null ? $0aefc245ff398d69$exports.Header.fromJSON(object.header) : undefined;
        message.numTxs = object.numTxs !== undefined && object.numTxs !== null ? $0aefc245ff398d69$var$long_1.default.fromString(object.numTxs) : $0aefc245ff398d69$var$long_1.default.ZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.blockId !== undefined && (obj.blockId = message.blockId ? $0aefc245ff398d69$exports.BlockID.toJSON(message.blockId) : undefined);
        message.blockSize !== undefined && (obj.blockSize = (message.blockSize || $0aefc245ff398d69$var$long_1.default.ZERO).toString());
        message.header !== undefined && (obj.header = message.header ? $0aefc245ff398d69$exports.Header.toJSON(message.header) : undefined);
        message.numTxs !== undefined && (obj.numTxs = (message.numTxs || $0aefc245ff398d69$var$long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $0aefc245ff398d69$var$baseBlockMeta);
        message.blockId = object.blockId !== undefined && object.blockId !== null ? $0aefc245ff398d69$exports.BlockID.fromPartial(object.blockId) : undefined;
        message.blockSize = object.blockSize !== undefined && object.blockSize !== null ? $0aefc245ff398d69$var$long_1.default.fromValue(object.blockSize) : $0aefc245ff398d69$var$long_1.default.ZERO;
        message.header = object.header !== undefined && object.header !== null ? $0aefc245ff398d69$exports.Header.fromPartial(object.header) : undefined;
        message.numTxs = object.numTxs !== undefined && object.numTxs !== null ? $0aefc245ff398d69$var$long_1.default.fromValue(object.numTxs) : $0aefc245ff398d69$var$long_1.default.ZERO;
        return message;
    }
};
const $0aefc245ff398d69$var$baseTxProof = {};
$0aefc245ff398d69$exports.TxProof = {
    encode (message, writer = $0aefc245ff398d69$var$minimal_1.default.Writer.create()) {
        if (message.rootHash.length !== 0) writer.uint32(10).bytes(message.rootHash);
        if (message.data.length !== 0) writer.uint32(18).bytes(message.data);
        if (message.proof !== undefined) $a2ff8534202d742a$exports.Proof.encode(message.proof, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0aefc245ff398d69$var$minimal_1.default.Reader ? input : new $0aefc245ff398d69$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $0aefc245ff398d69$var$baseTxProof);
        message.rootHash = new Uint8Array();
        message.data = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.rootHash = reader.bytes();
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                case 3:
                    message.proof = $a2ff8534202d742a$exports.Proof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $0aefc245ff398d69$var$baseTxProof);
        message.rootHash = object.rootHash !== undefined && object.rootHash !== null ? $0aefc245ff398d69$var$bytesFromBase64(object.rootHash) : new Uint8Array();
        message.data = object.data !== undefined && object.data !== null ? $0aefc245ff398d69$var$bytesFromBase64(object.data) : new Uint8Array();
        message.proof = object.proof !== undefined && object.proof !== null ? $a2ff8534202d742a$exports.Proof.fromJSON(object.proof) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.rootHash !== undefined && (obj.rootHash = $0aefc245ff398d69$var$base64FromBytes(message.rootHash !== undefined ? message.rootHash : new Uint8Array()));
        message.data !== undefined && (obj.data = $0aefc245ff398d69$var$base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        message.proof !== undefined && (obj.proof = message.proof ? $a2ff8534202d742a$exports.Proof.toJSON(message.proof) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $0aefc245ff398d69$var$baseTxProof);
        message.rootHash = (_a = object.rootHash) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.data = (_b = object.data) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.proof = object.proof !== undefined && object.proof !== null ? $a2ff8534202d742a$exports.Proof.fromPartial(object.proof) : undefined;
        return message;
    }
};
var $0aefc245ff398d69$var$globalThis = (()=>{
    if (typeof $0aefc245ff398d69$var$globalThis !== "undefined") return $0aefc245ff398d69$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $0aefc245ff398d69$var$atob = $0aefc245ff398d69$var$globalThis.atob || ((b64)=>$0aefc245ff398d69$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $0aefc245ff398d69$var$bytesFromBase64(b64) {
    const bin = $0aefc245ff398d69$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $0aefc245ff398d69$var$btoa = $0aefc245ff398d69$var$globalThis.btoa || ((bin)=>$0aefc245ff398d69$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $0aefc245ff398d69$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $0aefc245ff398d69$var$btoa(bin.join(""));
}
function $0aefc245ff398d69$var$toTimestamp(date) {
    const seconds = $0aefc245ff398d69$var$numberToLong(date.getTime() / 1000);
    const nanos = date.getTime() % 1000 * 1000000;
    return {
        seconds: seconds,
        nanos: nanos
    };
}
function $0aefc245ff398d69$var$fromTimestamp(t) {
    let millis = t.seconds.toNumber() * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function $0aefc245ff398d69$var$fromJsonTimestamp(o) {
    if (o instanceof Date) return $0aefc245ff398d69$var$toTimestamp(o);
    else if (typeof o === "string") return $0aefc245ff398d69$var$toTimestamp(new Date(o));
    else return $d6c3291d6aa8eb5b$exports.Timestamp.fromJSON(o);
}
function $0aefc245ff398d69$var$numberToLong(number) {
    return $0aefc245ff398d69$var$long_1.default.fromNumber(number);
}
if ($0aefc245ff398d69$var$minimal_1.default.util.Long !== $0aefc245ff398d69$var$long_1.default) {
    $0aefc245ff398d69$var$minimal_1.default.util.Long = $0aefc245ff398d69$var$long_1.default;
    $0aefc245ff398d69$var$minimal_1.default.configure();
}




$b474f8c71dfdb93e$exports.protobufPackage = "ibc.lightclients.tendermint.v1";
const $b474f8c71dfdb93e$var$baseClientState = {
    chainId: "",
    upgradePath: "",
    allowUpdateAfterExpiry: false,
    allowUpdateAfterMisbehaviour: false
};
$b474f8c71dfdb93e$exports.ClientState = {
    encode (message, writer = $b474f8c71dfdb93e$var$minimal_1.default.Writer.create()) {
        if (message.chainId !== "") writer.uint32(10).string(message.chainId);
        if (message.trustLevel !== undefined) $b474f8c71dfdb93e$exports.Fraction.encode(message.trustLevel, writer.uint32(18).fork()).ldelim();
        if (message.trustingPeriod !== undefined) $ad1f748ecd469446$exports.Duration.encode(message.trustingPeriod, writer.uint32(26).fork()).ldelim();
        if (message.unbondingPeriod !== undefined) $ad1f748ecd469446$exports.Duration.encode(message.unbondingPeriod, writer.uint32(34).fork()).ldelim();
        if (message.maxClockDrift !== undefined) $ad1f748ecd469446$exports.Duration.encode(message.maxClockDrift, writer.uint32(42).fork()).ldelim();
        if (message.frozenHeight !== undefined) $0935332a1587f29e$exports.Height.encode(message.frozenHeight, writer.uint32(50).fork()).ldelim();
        if (message.latestHeight !== undefined) $0935332a1587f29e$exports.Height.encode(message.latestHeight, writer.uint32(58).fork()).ldelim();
        for (const v of message.proofSpecs)$1a19d06bc6442f29$exports.ProofSpec.encode(v, writer.uint32(66).fork()).ldelim();
        for (const v of message.upgradePath)writer.uint32(74).string(v);
        if (message.allowUpdateAfterExpiry === true) writer.uint32(80).bool(message.allowUpdateAfterExpiry);
        if (message.allowUpdateAfterMisbehaviour === true) writer.uint32(88).bool(message.allowUpdateAfterMisbehaviour);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b474f8c71dfdb93e$var$minimal_1.default.Reader ? input : new $b474f8c71dfdb93e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b474f8c71dfdb93e$var$baseClientState);
        message.proofSpecs = [];
        message.upgradePath = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.chainId = reader.string();
                    break;
                case 2:
                    message.trustLevel = $b474f8c71dfdb93e$exports.Fraction.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.trustingPeriod = $ad1f748ecd469446$exports.Duration.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.unbondingPeriod = $ad1f748ecd469446$exports.Duration.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.maxClockDrift = $ad1f748ecd469446$exports.Duration.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.frozenHeight = $0935332a1587f29e$exports.Height.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.latestHeight = $0935332a1587f29e$exports.Height.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.proofSpecs.push($1a19d06bc6442f29$exports.ProofSpec.decode(reader, reader.uint32()));
                    break;
                case 9:
                    message.upgradePath.push(reader.string());
                    break;
                case 10:
                    message.allowUpdateAfterExpiry = reader.bool();
                    break;
                case 11:
                    message.allowUpdateAfterMisbehaviour = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a, _b;
        const message = Object.assign({}, $b474f8c71dfdb93e$var$baseClientState);
        message.chainId = object.chainId !== undefined && object.chainId !== null ? String(object.chainId) : "";
        message.trustLevel = object.trustLevel !== undefined && object.trustLevel !== null ? $b474f8c71dfdb93e$exports.Fraction.fromJSON(object.trustLevel) : undefined;
        message.trustingPeriod = object.trustingPeriod !== undefined && object.trustingPeriod !== null ? $ad1f748ecd469446$exports.Duration.fromJSON(object.trustingPeriod) : undefined;
        message.unbondingPeriod = object.unbondingPeriod !== undefined && object.unbondingPeriod !== null ? $ad1f748ecd469446$exports.Duration.fromJSON(object.unbondingPeriod) : undefined;
        message.maxClockDrift = object.maxClockDrift !== undefined && object.maxClockDrift !== null ? $ad1f748ecd469446$exports.Duration.fromJSON(object.maxClockDrift) : undefined;
        message.frozenHeight = object.frozenHeight !== undefined && object.frozenHeight !== null ? $0935332a1587f29e$exports.Height.fromJSON(object.frozenHeight) : undefined;
        message.latestHeight = object.latestHeight !== undefined && object.latestHeight !== null ? $0935332a1587f29e$exports.Height.fromJSON(object.latestHeight) : undefined;
        message.proofSpecs = ((_a = object.proofSpecs) !== null && _a !== void 0 ? _a : []).map((e)=>$1a19d06bc6442f29$exports.ProofSpec.fromJSON(e));
        message.upgradePath = ((_b = object.upgradePath) !== null && _b !== void 0 ? _b : []).map((e)=>String(e));
        message.allowUpdateAfterExpiry = object.allowUpdateAfterExpiry !== undefined && object.allowUpdateAfterExpiry !== null ? Boolean(object.allowUpdateAfterExpiry) : false;
        message.allowUpdateAfterMisbehaviour = object.allowUpdateAfterMisbehaviour !== undefined && object.allowUpdateAfterMisbehaviour !== null ? Boolean(object.allowUpdateAfterMisbehaviour) : false;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.trustLevel !== undefined && (obj.trustLevel = message.trustLevel ? $b474f8c71dfdb93e$exports.Fraction.toJSON(message.trustLevel) : undefined);
        message.trustingPeriod !== undefined && (obj.trustingPeriod = message.trustingPeriod ? $ad1f748ecd469446$exports.Duration.toJSON(message.trustingPeriod) : undefined);
        message.unbondingPeriod !== undefined && (obj.unbondingPeriod = message.unbondingPeriod ? $ad1f748ecd469446$exports.Duration.toJSON(message.unbondingPeriod) : undefined);
        message.maxClockDrift !== undefined && (obj.maxClockDrift = message.maxClockDrift ? $ad1f748ecd469446$exports.Duration.toJSON(message.maxClockDrift) : undefined);
        message.frozenHeight !== undefined && (obj.frozenHeight = message.frozenHeight ? $0935332a1587f29e$exports.Height.toJSON(message.frozenHeight) : undefined);
        message.latestHeight !== undefined && (obj.latestHeight = message.latestHeight ? $0935332a1587f29e$exports.Height.toJSON(message.latestHeight) : undefined);
        if (message.proofSpecs) obj.proofSpecs = message.proofSpecs.map((e)=>e ? $1a19d06bc6442f29$exports.ProofSpec.toJSON(e) : undefined);
        else obj.proofSpecs = [];
        if (message.upgradePath) obj.upgradePath = message.upgradePath.map((e)=>e);
        else obj.upgradePath = [];
        message.allowUpdateAfterExpiry !== undefined && (obj.allowUpdateAfterExpiry = message.allowUpdateAfterExpiry);
        message.allowUpdateAfterMisbehaviour !== undefined && (obj.allowUpdateAfterMisbehaviour = message.allowUpdateAfterMisbehaviour);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e;
        const message = Object.assign({}, $b474f8c71dfdb93e$var$baseClientState);
        message.chainId = (_a = object.chainId) !== null && _a !== void 0 ? _a : "";
        message.trustLevel = object.trustLevel !== undefined && object.trustLevel !== null ? $b474f8c71dfdb93e$exports.Fraction.fromPartial(object.trustLevel) : undefined;
        message.trustingPeriod = object.trustingPeriod !== undefined && object.trustingPeriod !== null ? $ad1f748ecd469446$exports.Duration.fromPartial(object.trustingPeriod) : undefined;
        message.unbondingPeriod = object.unbondingPeriod !== undefined && object.unbondingPeriod !== null ? $ad1f748ecd469446$exports.Duration.fromPartial(object.unbondingPeriod) : undefined;
        message.maxClockDrift = object.maxClockDrift !== undefined && object.maxClockDrift !== null ? $ad1f748ecd469446$exports.Duration.fromPartial(object.maxClockDrift) : undefined;
        message.frozenHeight = object.frozenHeight !== undefined && object.frozenHeight !== null ? $0935332a1587f29e$exports.Height.fromPartial(object.frozenHeight) : undefined;
        message.latestHeight = object.latestHeight !== undefined && object.latestHeight !== null ? $0935332a1587f29e$exports.Height.fromPartial(object.latestHeight) : undefined;
        message.proofSpecs = ((_b = object.proofSpecs) === null || _b === void 0 ? void 0 : _b.map((e)=>$1a19d06bc6442f29$exports.ProofSpec.fromPartial(e))) || [];
        message.upgradePath = ((_c = object.upgradePath) === null || _c === void 0 ? void 0 : _c.map((e)=>e)) || [];
        message.allowUpdateAfterExpiry = (_d = object.allowUpdateAfterExpiry) !== null && _d !== void 0 ? _d : false;
        message.allowUpdateAfterMisbehaviour = (_e = object.allowUpdateAfterMisbehaviour) !== null && _e !== void 0 ? _e : false;
        return message;
    }
};
const $b474f8c71dfdb93e$var$baseConsensusState = {};
$b474f8c71dfdb93e$exports.ConsensusState = {
    encode (message, writer = $b474f8c71dfdb93e$var$minimal_1.default.Writer.create()) {
        if (message.timestamp !== undefined) $d6c3291d6aa8eb5b$exports.Timestamp.encode(message.timestamp, writer.uint32(10).fork()).ldelim();
        if (message.root !== undefined) $7ddd8dfe443ea91e$exports.MerkleRoot.encode(message.root, writer.uint32(18).fork()).ldelim();
        if (message.nextValidatorsHash.length !== 0) writer.uint32(26).bytes(message.nextValidatorsHash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b474f8c71dfdb93e$var$minimal_1.default.Reader ? input : new $b474f8c71dfdb93e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b474f8c71dfdb93e$var$baseConsensusState);
        message.nextValidatorsHash = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.timestamp = $d6c3291d6aa8eb5b$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.root = $7ddd8dfe443ea91e$exports.MerkleRoot.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.nextValidatorsHash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $b474f8c71dfdb93e$var$baseConsensusState);
        message.timestamp = object.timestamp !== undefined && object.timestamp !== null ? $b474f8c71dfdb93e$var$fromJsonTimestamp(object.timestamp) : undefined;
        message.root = object.root !== undefined && object.root !== null ? $7ddd8dfe443ea91e$exports.MerkleRoot.fromJSON(object.root) : undefined;
        message.nextValidatorsHash = object.nextValidatorsHash !== undefined && object.nextValidatorsHash !== null ? $b474f8c71dfdb93e$var$bytesFromBase64(object.nextValidatorsHash) : new Uint8Array();
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.timestamp !== undefined && (obj.timestamp = $b474f8c71dfdb93e$var$fromTimestamp(message.timestamp).toISOString());
        message.root !== undefined && (obj.root = message.root ? $7ddd8dfe443ea91e$exports.MerkleRoot.toJSON(message.root) : undefined);
        message.nextValidatorsHash !== undefined && (obj.nextValidatorsHash = $b474f8c71dfdb93e$var$base64FromBytes(message.nextValidatorsHash !== undefined ? message.nextValidatorsHash : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $b474f8c71dfdb93e$var$baseConsensusState);
        message.timestamp = object.timestamp !== undefined && object.timestamp !== null ? $d6c3291d6aa8eb5b$exports.Timestamp.fromPartial(object.timestamp) : undefined;
        message.root = object.root !== undefined && object.root !== null ? $7ddd8dfe443ea91e$exports.MerkleRoot.fromPartial(object.root) : undefined;
        message.nextValidatorsHash = (_a = object.nextValidatorsHash) !== null && _a !== void 0 ? _a : new Uint8Array();
        return message;
    }
};
const $b474f8c71dfdb93e$var$baseMisbehaviour = {
    clientId: ""
};
$b474f8c71dfdb93e$exports.Misbehaviour = {
    encode (message, writer = $b474f8c71dfdb93e$var$minimal_1.default.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.header1 !== undefined) $b474f8c71dfdb93e$exports.Header.encode(message.header1, writer.uint32(18).fork()).ldelim();
        if (message.header2 !== undefined) $b474f8c71dfdb93e$exports.Header.encode(message.header2, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b474f8c71dfdb93e$var$minimal_1.default.Reader ? input : new $b474f8c71dfdb93e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b474f8c71dfdb93e$var$baseMisbehaviour);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.header1 = $b474f8c71dfdb93e$exports.Header.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.header2 = $b474f8c71dfdb93e$exports.Header.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $b474f8c71dfdb93e$var$baseMisbehaviour);
        message.clientId = object.clientId !== undefined && object.clientId !== null ? String(object.clientId) : "";
        message.header1 = object.header1 !== undefined && object.header1 !== null ? $b474f8c71dfdb93e$exports.Header.fromJSON(object.header1) : undefined;
        message.header2 = object.header2 !== undefined && object.header2 !== null ? $b474f8c71dfdb93e$exports.Header.fromJSON(object.header2) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.header1 !== undefined && (obj.header1 = message.header1 ? $b474f8c71dfdb93e$exports.Header.toJSON(message.header1) : undefined);
        message.header2 !== undefined && (obj.header2 = message.header2 ? $b474f8c71dfdb93e$exports.Header.toJSON(message.header2) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $b474f8c71dfdb93e$var$baseMisbehaviour);
        message.clientId = (_a = object.clientId) !== null && _a !== void 0 ? _a : "";
        message.header1 = object.header1 !== undefined && object.header1 !== null ? $b474f8c71dfdb93e$exports.Header.fromPartial(object.header1) : undefined;
        message.header2 = object.header2 !== undefined && object.header2 !== null ? $b474f8c71dfdb93e$exports.Header.fromPartial(object.header2) : undefined;
        return message;
    }
};
const $b474f8c71dfdb93e$var$baseHeader = {};
$b474f8c71dfdb93e$exports.Header = {
    encode (message, writer = $b474f8c71dfdb93e$var$minimal_1.default.Writer.create()) {
        if (message.signedHeader !== undefined) $0aefc245ff398d69$exports.SignedHeader.encode(message.signedHeader, writer.uint32(10).fork()).ldelim();
        if (message.validatorSet !== undefined) $b006c8e31e8bc609$exports.ValidatorSet.encode(message.validatorSet, writer.uint32(18).fork()).ldelim();
        if (message.trustedHeight !== undefined) $0935332a1587f29e$exports.Height.encode(message.trustedHeight, writer.uint32(26).fork()).ldelim();
        if (message.trustedValidators !== undefined) $b006c8e31e8bc609$exports.ValidatorSet.encode(message.trustedValidators, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b474f8c71dfdb93e$var$minimal_1.default.Reader ? input : new $b474f8c71dfdb93e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b474f8c71dfdb93e$var$baseHeader);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signedHeader = $0aefc245ff398d69$exports.SignedHeader.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.validatorSet = $b006c8e31e8bc609$exports.ValidatorSet.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.trustedHeight = $0935332a1587f29e$exports.Height.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.trustedValidators = $b006c8e31e8bc609$exports.ValidatorSet.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $b474f8c71dfdb93e$var$baseHeader);
        message.signedHeader = object.signedHeader !== undefined && object.signedHeader !== null ? $0aefc245ff398d69$exports.SignedHeader.fromJSON(object.signedHeader) : undefined;
        message.validatorSet = object.validatorSet !== undefined && object.validatorSet !== null ? $b006c8e31e8bc609$exports.ValidatorSet.fromJSON(object.validatorSet) : undefined;
        message.trustedHeight = object.trustedHeight !== undefined && object.trustedHeight !== null ? $0935332a1587f29e$exports.Height.fromJSON(object.trustedHeight) : undefined;
        message.trustedValidators = object.trustedValidators !== undefined && object.trustedValidators !== null ? $b006c8e31e8bc609$exports.ValidatorSet.fromJSON(object.trustedValidators) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.signedHeader !== undefined && (obj.signedHeader = message.signedHeader ? $0aefc245ff398d69$exports.SignedHeader.toJSON(message.signedHeader) : undefined);
        message.validatorSet !== undefined && (obj.validatorSet = message.validatorSet ? $b006c8e31e8bc609$exports.ValidatorSet.toJSON(message.validatorSet) : undefined);
        message.trustedHeight !== undefined && (obj.trustedHeight = message.trustedHeight ? $0935332a1587f29e$exports.Height.toJSON(message.trustedHeight) : undefined);
        message.trustedValidators !== undefined && (obj.trustedValidators = message.trustedValidators ? $b006c8e31e8bc609$exports.ValidatorSet.toJSON(message.trustedValidators) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $b474f8c71dfdb93e$var$baseHeader);
        message.signedHeader = object.signedHeader !== undefined && object.signedHeader !== null ? $0aefc245ff398d69$exports.SignedHeader.fromPartial(object.signedHeader) : undefined;
        message.validatorSet = object.validatorSet !== undefined && object.validatorSet !== null ? $b006c8e31e8bc609$exports.ValidatorSet.fromPartial(object.validatorSet) : undefined;
        message.trustedHeight = object.trustedHeight !== undefined && object.trustedHeight !== null ? $0935332a1587f29e$exports.Height.fromPartial(object.trustedHeight) : undefined;
        message.trustedValidators = object.trustedValidators !== undefined && object.trustedValidators !== null ? $b006c8e31e8bc609$exports.ValidatorSet.fromPartial(object.trustedValidators) : undefined;
        return message;
    }
};
const $b474f8c71dfdb93e$var$baseFraction = {
    numerator: $b474f8c71dfdb93e$var$long_1.default.UZERO,
    denominator: $b474f8c71dfdb93e$var$long_1.default.UZERO
};
$b474f8c71dfdb93e$exports.Fraction = {
    encode (message, writer = $b474f8c71dfdb93e$var$minimal_1.default.Writer.create()) {
        if (!message.numerator.isZero()) writer.uint32(8).uint64(message.numerator);
        if (!message.denominator.isZero()) writer.uint32(16).uint64(message.denominator);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b474f8c71dfdb93e$var$minimal_1.default.Reader ? input : new $b474f8c71dfdb93e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $b474f8c71dfdb93e$var$baseFraction);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.numerator = reader.uint64();
                    break;
                case 2:
                    message.denominator = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $b474f8c71dfdb93e$var$baseFraction);
        message.numerator = object.numerator !== undefined && object.numerator !== null ? $b474f8c71dfdb93e$var$long_1.default.fromString(object.numerator) : $b474f8c71dfdb93e$var$long_1.default.UZERO;
        message.denominator = object.denominator !== undefined && object.denominator !== null ? $b474f8c71dfdb93e$var$long_1.default.fromString(object.denominator) : $b474f8c71dfdb93e$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.numerator !== undefined && (obj.numerator = (message.numerator || $b474f8c71dfdb93e$var$long_1.default.UZERO).toString());
        message.denominator !== undefined && (obj.denominator = (message.denominator || $b474f8c71dfdb93e$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $b474f8c71dfdb93e$var$baseFraction);
        message.numerator = object.numerator !== undefined && object.numerator !== null ? $b474f8c71dfdb93e$var$long_1.default.fromValue(object.numerator) : $b474f8c71dfdb93e$var$long_1.default.UZERO;
        message.denominator = object.denominator !== undefined && object.denominator !== null ? $b474f8c71dfdb93e$var$long_1.default.fromValue(object.denominator) : $b474f8c71dfdb93e$var$long_1.default.UZERO;
        return message;
    }
};
var $b474f8c71dfdb93e$var$globalThis = (()=>{
    if (typeof $b474f8c71dfdb93e$var$globalThis !== "undefined") return $b474f8c71dfdb93e$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $b474f8c71dfdb93e$var$atob = $b474f8c71dfdb93e$var$globalThis.atob || ((b64)=>$b474f8c71dfdb93e$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $b474f8c71dfdb93e$var$bytesFromBase64(b64) {
    const bin = $b474f8c71dfdb93e$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $b474f8c71dfdb93e$var$btoa = $b474f8c71dfdb93e$var$globalThis.btoa || ((bin)=>$b474f8c71dfdb93e$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $b474f8c71dfdb93e$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $b474f8c71dfdb93e$var$btoa(bin.join(""));
}
function $b474f8c71dfdb93e$var$toTimestamp(date) {
    const seconds = $b474f8c71dfdb93e$var$numberToLong(date.getTime() / 1000);
    const nanos = date.getTime() % 1000 * 1000000;
    return {
        seconds: seconds,
        nanos: nanos
    };
}
function $b474f8c71dfdb93e$var$fromTimestamp(t) {
    let millis = t.seconds.toNumber() * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function $b474f8c71dfdb93e$var$fromJsonTimestamp(o) {
    if (o instanceof Date) return $b474f8c71dfdb93e$var$toTimestamp(o);
    else if (typeof o === "string") return $b474f8c71dfdb93e$var$toTimestamp(new Date(o));
    else return $d6c3291d6aa8eb5b$exports.Timestamp.fromJSON(o);
}
function $b474f8c71dfdb93e$var$numberToLong(number) {
    return $b474f8c71dfdb93e$var$long_1.default.fromNumber(number);
}
if ($b474f8c71dfdb93e$var$minimal_1.default.util.Long !== $b474f8c71dfdb93e$var$long_1.default) {
    $b474f8c71dfdb93e$var$minimal_1.default.util.Long = $b474f8c71dfdb93e$var$long_1.default;
    $b474f8c71dfdb93e$var$minimal_1.default.configure();
}



const $2c2e312329355287$var$long_1 = $2c2e312329355287$var$__importDefault((parcelRequire("9A55m")));

function $2c2e312329355287$var$decodeTendermintClientStateAny(clientState) {
    if ((clientState === null || clientState === void 0 ? void 0 : clientState.typeUrl) !== "/ibc.lightclients.tendermint.v1.ClientState") throw new Error(`Unexpected client state type: ${clientState === null || clientState === void 0 ? void 0 : clientState.typeUrl}`);
    return $b474f8c71dfdb93e$exports.ClientState.decode(clientState.value);
}
function $2c2e312329355287$var$decodeTendermintConsensusStateAny(clientState) {
    if ((clientState === null || clientState === void 0 ? void 0 : clientState.typeUrl) !== "/ibc.lightclients.tendermint.v1.ConsensusState") throw new Error(`Unexpected client state type: ${clientState === null || clientState === void 0 ? void 0 : clientState.typeUrl}`);
    return $b474f8c71dfdb93e$exports.ConsensusState.decode(clientState.value);
}
function $2c2e312329355287$var$setupIbcExtension(base) {
    const rpc = (0, $ffdede50deec576f$exports.createProtobufRpcClient)(base);
    // Use these services to get easy typed access to query methods
    // These cannot be used for proof verification
    const channelQueryService = new $1a62b788fa2f619a$exports.QueryClientImpl(rpc);
    const clientQueryService = new $23e1cbf14b2581ce$exports.QueryClientImpl(rpc);
    const connectionQueryService = new $bb5887be70760d1a$exports.QueryClientImpl(rpc);
    const transferQueryService = new $702731e477a1a6a1$exports.QueryClientImpl(rpc);
    return {
        ibc: {
            channel: {
                channel: async (portId, channelId)=>channelQueryService.Channel({
                        portId: portId,
                        channelId: channelId
                    }),
                channels: async (paginationKey)=>channelQueryService.Channels({
                        pagination: (0, $ffdede50deec576f$exports.createPagination)(paginationKey)
                    }),
                allChannels: async ()=>{
                    var _a;
                    const channels = [];
                    let response;
                    let key;
                    do {
                        response = await channelQueryService.Channels({
                            pagination: (0, $ffdede50deec576f$exports.createPagination)(key)
                        });
                        channels.push(...response.channels);
                        key = (_a = response.pagination) === null || _a === void 0 ? void 0 : _a.nextKey;
                    }while (key && key.length);
                    return {
                        channels: channels,
                        height: response.height
                    };
                },
                connectionChannels: async (connection, paginationKey)=>channelQueryService.ConnectionChannels({
                        connection: connection,
                        pagination: (0, $ffdede50deec576f$exports.createPagination)(paginationKey)
                    }),
                allConnectionChannels: async (connection)=>{
                    var _a;
                    const channels = [];
                    let response;
                    let key;
                    do {
                        response = await channelQueryService.ConnectionChannels({
                            connection: connection,
                            pagination: (0, $ffdede50deec576f$exports.createPagination)(key)
                        });
                        channels.push(...response.channels);
                        key = (_a = response.pagination) === null || _a === void 0 ? void 0 : _a.nextKey;
                    }while (key && key.length);
                    return {
                        channels: channels,
                        height: response.height
                    };
                },
                clientState: async (portId, channelId)=>channelQueryService.ChannelClientState({
                        portId: portId,
                        channelId: channelId
                    }),
                consensusState: async (portId, channelId, revisionNumber, revisionHeight)=>channelQueryService.ChannelConsensusState({
                        portId: portId,
                        channelId: channelId,
                        revisionNumber: $2c2e312329355287$var$long_1.default.fromNumber(revisionNumber, true),
                        revisionHeight: $2c2e312329355287$var$long_1.default.fromNumber(revisionHeight, true)
                    }),
                packetCommitment: async (portId, channelId, sequence)=>channelQueryService.PacketCommitment({
                        portId: portId,
                        channelId: channelId,
                        sequence: sequence
                    }),
                packetCommitments: async (portId, channelId, paginationKey)=>channelQueryService.PacketCommitments({
                        channelId: channelId,
                        portId: portId,
                        pagination: (0, $ffdede50deec576f$exports.createPagination)(paginationKey)
                    }),
                allPacketCommitments: async (portId, channelId)=>{
                    var _a;
                    const commitments = [];
                    let response;
                    let key;
                    do {
                        response = await channelQueryService.PacketCommitments({
                            channelId: channelId,
                            portId: portId,
                            pagination: (0, $ffdede50deec576f$exports.createPagination)(key)
                        });
                        commitments.push(...response.commitments);
                        key = (_a = response.pagination) === null || _a === void 0 ? void 0 : _a.nextKey;
                    }while (key && key.length);
                    return {
                        commitments: commitments,
                        height: response.height
                    };
                },
                packetReceipt: async (portId, channelId, sequence)=>channelQueryService.PacketReceipt({
                        portId: portId,
                        channelId: channelId,
                        sequence: $2c2e312329355287$var$long_1.default.fromNumber(sequence, true)
                    }),
                packetAcknowledgement: async (portId, channelId, sequence)=>channelQueryService.PacketAcknowledgement({
                        portId: portId,
                        channelId: channelId,
                        sequence: $2c2e312329355287$var$long_1.default.fromNumber(sequence, true)
                    }),
                packetAcknowledgements: async (portId, channelId, paginationKey)=>channelQueryService.PacketAcknowledgements({
                        portId: portId,
                        channelId: channelId,
                        pagination: (0, $ffdede50deec576f$exports.createPagination)(paginationKey)
                    }),
                allPacketAcknowledgements: async (portId, channelId)=>{
                    var _a;
                    const acknowledgements = [];
                    let response;
                    let key;
                    do {
                        response = await channelQueryService.PacketAcknowledgements({
                            channelId: channelId,
                            portId: portId,
                            pagination: (0, $ffdede50deec576f$exports.createPagination)(key)
                        });
                        acknowledgements.push(...response.acknowledgements);
                        key = (_a = response.pagination) === null || _a === void 0 ? void 0 : _a.nextKey;
                    }while (key && key.length);
                    return {
                        acknowledgements: acknowledgements,
                        height: response.height
                    };
                },
                unreceivedPackets: async (portId, channelId, packetCommitmentSequences)=>channelQueryService.UnreceivedPackets({
                        portId: portId,
                        channelId: channelId,
                        packetCommitmentSequences: packetCommitmentSequences.map((s)=>$2c2e312329355287$var$long_1.default.fromNumber(s, true))
                    }),
                unreceivedAcks: async (portId, channelId, packetAckSequences)=>channelQueryService.UnreceivedAcks({
                        portId: portId,
                        channelId: channelId,
                        packetAckSequences: packetAckSequences.map((s)=>$2c2e312329355287$var$long_1.default.fromNumber(s, true))
                    }),
                nextSequenceReceive: async (portId, channelId)=>channelQueryService.NextSequenceReceive({
                        portId: portId,
                        channelId: channelId
                    })
            },
            client: {
                state: async (clientId)=>clientQueryService.ClientState({
                        clientId: clientId
                    }),
                states: async (paginationKey)=>clientQueryService.ClientStates({
                        pagination: (0, $ffdede50deec576f$exports.createPagination)(paginationKey)
                    }),
                allStates: async ()=>{
                    var _a;
                    const clientStates = [];
                    let response;
                    let key;
                    do {
                        response = await clientQueryService.ClientStates({
                            pagination: (0, $ffdede50deec576f$exports.createPagination)(key)
                        });
                        clientStates.push(...response.clientStates);
                        key = (_a = response.pagination) === null || _a === void 0 ? void 0 : _a.nextKey;
                    }while (key && key.length);
                    return {
                        clientStates: clientStates
                    };
                },
                consensusState: async (clientId, consensusHeight)=>clientQueryService.ConsensusState($23e1cbf14b2581ce$exports.QueryConsensusStateRequest.fromPartial({
                        clientId: clientId,
                        revisionHeight: consensusHeight !== undefined ? $2c2e312329355287$var$long_1.default.fromNumber(consensusHeight, true) : undefined,
                        latestHeight: consensusHeight === undefined
                    })),
                consensusStates: async (clientId, paginationKey)=>clientQueryService.ConsensusStates({
                        clientId: clientId,
                        pagination: (0, $ffdede50deec576f$exports.createPagination)(paginationKey)
                    }),
                allConsensusStates: async (clientId)=>{
                    var _a;
                    const consensusStates = [];
                    let response;
                    let key;
                    do {
                        response = await clientQueryService.ConsensusStates({
                            clientId: clientId,
                            pagination: (0, $ffdede50deec576f$exports.createPagination)(key)
                        });
                        consensusStates.push(...response.consensusStates);
                        key = (_a = response.pagination) === null || _a === void 0 ? void 0 : _a.nextKey;
                    }while (key && key.length);
                    return {
                        consensusStates: consensusStates
                    };
                },
                params: async ()=>clientQueryService.ClientParams({}),
                stateTm: async (clientId)=>{
                    const response = await clientQueryService.ClientState({
                        clientId: clientId
                    });
                    return $2c2e312329355287$var$decodeTendermintClientStateAny(response.clientState);
                },
                statesTm: async (paginationKey)=>{
                    const { clientStates: clientStates } = await clientQueryService.ClientStates({
                        pagination: (0, $ffdede50deec576f$exports.createPagination)(paginationKey)
                    });
                    return clientStates.map(({ clientState: clientState })=>$2c2e312329355287$var$decodeTendermintClientStateAny(clientState));
                },
                allStatesTm: async ()=>{
                    var _a;
                    const clientStates = [];
                    let response;
                    let key;
                    do {
                        response = await clientQueryService.ClientStates({
                            pagination: (0, $ffdede50deec576f$exports.createPagination)(key)
                        });
                        clientStates.push(...response.clientStates);
                        key = (_a = response.pagination) === null || _a === void 0 ? void 0 : _a.nextKey;
                    }while (key && key.length);
                    return clientStates.map(({ clientState: clientState })=>$2c2e312329355287$var$decodeTendermintClientStateAny(clientState));
                },
                consensusStateTm: async (clientId, consensusHeight)=>{
                    const response = await clientQueryService.ConsensusState($23e1cbf14b2581ce$exports.QueryConsensusStateRequest.fromPartial({
                        clientId: clientId,
                        revisionHeight: consensusHeight === null || consensusHeight === void 0 ? void 0 : consensusHeight.revisionHeight,
                        revisionNumber: consensusHeight === null || consensusHeight === void 0 ? void 0 : consensusHeight.revisionNumber,
                        latestHeight: consensusHeight === undefined
                    }));
                    return $2c2e312329355287$var$decodeTendermintConsensusStateAny(response.consensusState);
                }
            },
            connection: {
                connection: async (connectionId)=>connectionQueryService.Connection({
                        connectionId: connectionId
                    }),
                connections: async (paginationKey)=>connectionQueryService.Connections({
                        pagination: (0, $ffdede50deec576f$exports.createPagination)(paginationKey)
                    }),
                allConnections: async ()=>{
                    var _a;
                    const connections = [];
                    let response;
                    let key;
                    do {
                        response = await connectionQueryService.Connections({
                            pagination: (0, $ffdede50deec576f$exports.createPagination)(key)
                        });
                        connections.push(...response.connections);
                        key = (_a = response.pagination) === null || _a === void 0 ? void 0 : _a.nextKey;
                    }while (key && key.length);
                    return {
                        connections: connections,
                        height: response.height
                    };
                },
                clientConnections: async (clientId)=>connectionQueryService.ClientConnections({
                        clientId: clientId
                    }),
                clientState: async (connectionId)=>connectionQueryService.ConnectionClientState({
                        connectionId: connectionId
                    }),
                consensusState: async (connectionId, revisionHeight)=>connectionQueryService.ConnectionConsensusState($bb5887be70760d1a$exports.QueryConnectionConsensusStateRequest.fromPartial({
                        connectionId: connectionId,
                        revisionHeight: $2c2e312329355287$var$long_1.default.fromNumber(revisionHeight, true)
                    }))
            },
            transfer: {
                denomTrace: async (hash)=>transferQueryService.DenomTrace({
                        hash: hash
                    }),
                denomTraces: async (paginationKey)=>transferQueryService.DenomTraces({
                        pagination: (0, $ffdede50deec576f$exports.createPagination)(paginationKey)
                    }),
                allDenomTraces: async ()=>{
                    var _a;
                    const denomTraces = [];
                    let response;
                    let key;
                    do {
                        response = await transferQueryService.DenomTraces({
                            pagination: (0, $ffdede50deec576f$exports.createPagination)(key)
                        });
                        denomTraces.push(...response.denomTraces);
                        key = (_a = response.pagination) === null || _a === void 0 ? void 0 : _a.nextKey;
                    }while (key && key.length);
                    return {
                        denomTraces: denomTraces
                    };
                },
                params: async ()=>transferQueryService.Params({})
            },
            verified: {
                channel: {
                    channel: async (portId, channelId)=>{
                        // keeper: https://github.com/cosmos/cosmos-sdk/blob/3bafd8255a502e5a9cee07391cf8261538245dfd/x/ibc/04-channel/keeper/keeper.go#L55-L65
                        // key: https://github.com/cosmos/cosmos-sdk/blob/ef0a7344af345882729598bc2958a21143930a6b/x/ibc/24-host/keys.go#L117-L120
                        const key = (0, $5zb9p.toAscii)(`channelEnds/ports/${portId}/channels/${channelId}`);
                        const responseData = await base.queryVerified("ibc", key);
                        return responseData.length ? $b98b08f8901f4c6b$exports.Channel.decode(responseData) : null;
                    },
                    packetCommitment: async (portId, channelId, sequence)=>{
                        // keeper: https://github.com/cosmos/cosmos-sdk/blob/3bafd8255a502e5a9cee07391cf8261538245dfd/x/ibc/04-channel/keeper/keeper.go#L128-L133
                        // key: https://github.com/cosmos/cosmos-sdk/blob/ef0a7344af345882729598bc2958a21143930a6b/x/ibc/24-host/keys.go#L183-L185
                        const key = (0, $5zb9p.toAscii)(`commitments/ports/${portId}/channels/${channelId}/packets/${sequence}`);
                        const responseData = await base.queryVerified("ibc", key);
                        // keeper code doesn't parse, but returns raw
                        return responseData;
                    },
                    packetAcknowledgement: async (portId, channelId, sequence)=>{
                        // keeper: https://github.com/cosmos/cosmos-sdk/blob/3bafd8255a502e5a9cee07391cf8261538245dfd/x/ibc/04-channel/keeper/keeper.go#L159-L166
                        // key: https://github.com/cosmos/cosmos-sdk/blob/ef0a7344af345882729598bc2958a21143930a6b/x/ibc/24-host/keys.go#L153-L156
                        const key = (0, $5zb9p.toAscii)(`acks/ports/${portId}/channels/${channelId}/acknowledgements/${sequence}`);
                        const responseData = await base.queryVerified("ibc", key);
                        // keeper code doesn't parse, but returns raw
                        return responseData;
                    },
                    nextSequenceReceive: async (portId, channelId)=>{
                        // keeper: https://github.com/cosmos/cosmos-sdk/blob/3bafd8255a502e5a9cee07391cf8261538245dfd/x/ibc/04-channel/keeper/keeper.go#L92-L101
                        // key: https://github.com/cosmos/cosmos-sdk/blob/ef0a7344af345882729598bc2958a21143930a6b/x/ibc/24-host/keys.go#L133-L136
                        const key = (0, $5zb9p.toAscii)(`seqAcks/ports/${portId}/channels/${channelId}/nextSequenceAck`);
                        const responseData = await base.queryVerified("ibc", key);
                        return responseData.length ? $9YIif.Uint64.fromBytes(responseData).toNumber() : null;
                    }
                }
            }
        }
    };
}
$2c2e312329355287$exports.setupIbcExtension = $2c2e312329355287$var$setupIbcExtension;


Object.defineProperty($7725f2e3ca016b52$exports, "setupIbcExtension", {
    enumerable: true,
    get: function() {
        return $2c2e312329355287$exports.setupIbcExtension;
    }
});
var $bc7f5ee243357870$exports = {};
"use strict";
Object.defineProperty($bc7f5ee243357870$exports, "__esModule", {
    value: true
});
$bc7f5ee243357870$exports.setupMintExtension = void 0;

var $F6P8J = parcelRequire("F6P8J");
var $9e5c082c528731ae$exports = {};
"use strict";
var $9e5c082c528731ae$var$__importDefault = $9e5c082c528731ae$exports && $9e5c082c528731ae$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($9e5c082c528731ae$exports, "__esModule", {
    value: true
});
$9e5c082c528731ae$exports.QueryClientImpl = $9e5c082c528731ae$exports.QueryAnnualProvisionsResponse = $9e5c082c528731ae$exports.QueryAnnualProvisionsRequest = $9e5c082c528731ae$exports.QueryInflationResponse = $9e5c082c528731ae$exports.QueryInflationRequest = $9e5c082c528731ae$exports.QueryParamsResponse = $9e5c082c528731ae$exports.QueryParamsRequest = $9e5c082c528731ae$exports.protobufPackage = void 0;

/* eslint-disable */ const $9e5c082c528731ae$var$long_1 = $9e5c082c528731ae$var$__importDefault((parcelRequire("9A55m")));

const $9e5c082c528731ae$var$minimal_1 = $9e5c082c528731ae$var$__importDefault((parcelRequire("i2pIU")));
var $ffa05dcc70cfdc19$exports = {};
"use strict";
var $ffa05dcc70cfdc19$var$__importDefault = $ffa05dcc70cfdc19$exports && $ffa05dcc70cfdc19$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($ffa05dcc70cfdc19$exports, "__esModule", {
    value: true
});
$ffa05dcc70cfdc19$exports.Params = $ffa05dcc70cfdc19$exports.Minter = $ffa05dcc70cfdc19$exports.protobufPackage = void 0;

/* eslint-disable */ const $ffa05dcc70cfdc19$var$long_1 = $ffa05dcc70cfdc19$var$__importDefault((parcelRequire("9A55m")));

const $ffa05dcc70cfdc19$var$minimal_1 = $ffa05dcc70cfdc19$var$__importDefault((parcelRequire("i2pIU")));
$ffa05dcc70cfdc19$exports.protobufPackage = "cosmos.mint.v1beta1";
const $ffa05dcc70cfdc19$var$baseMinter = {
    inflation: "",
    annualProvisions: ""
};
$ffa05dcc70cfdc19$exports.Minter = {
    encode (message, writer = $ffa05dcc70cfdc19$var$minimal_1.default.Writer.create()) {
        if (message.inflation !== "") writer.uint32(10).string(message.inflation);
        if (message.annualProvisions !== "") writer.uint32(18).string(message.annualProvisions);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ffa05dcc70cfdc19$var$minimal_1.default.Reader ? input : new $ffa05dcc70cfdc19$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ffa05dcc70cfdc19$var$baseMinter);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.inflation = reader.string();
                    break;
                case 2:
                    message.annualProvisions = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ffa05dcc70cfdc19$var$baseMinter);
        message.inflation = object.inflation !== undefined && object.inflation !== null ? String(object.inflation) : "";
        message.annualProvisions = object.annualProvisions !== undefined && object.annualProvisions !== null ? String(object.annualProvisions) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.inflation !== undefined && (obj.inflation = message.inflation);
        message.annualProvisions !== undefined && (obj.annualProvisions = message.annualProvisions);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $ffa05dcc70cfdc19$var$baseMinter);
        message.inflation = (_a = object.inflation) !== null && _a !== void 0 ? _a : "";
        message.annualProvisions = (_b = object.annualProvisions) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
const $ffa05dcc70cfdc19$var$baseParams = {
    mintDenom: "",
    inflationRateChange: "",
    inflationMax: "",
    inflationMin: "",
    goalBonded: "",
    blocksPerYear: $ffa05dcc70cfdc19$var$long_1.default.UZERO
};
$ffa05dcc70cfdc19$exports.Params = {
    encode (message, writer = $ffa05dcc70cfdc19$var$minimal_1.default.Writer.create()) {
        if (message.mintDenom !== "") writer.uint32(10).string(message.mintDenom);
        if (message.inflationRateChange !== "") writer.uint32(18).string(message.inflationRateChange);
        if (message.inflationMax !== "") writer.uint32(26).string(message.inflationMax);
        if (message.inflationMin !== "") writer.uint32(34).string(message.inflationMin);
        if (message.goalBonded !== "") writer.uint32(42).string(message.goalBonded);
        if (!message.blocksPerYear.isZero()) writer.uint32(48).uint64(message.blocksPerYear);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ffa05dcc70cfdc19$var$minimal_1.default.Reader ? input : new $ffa05dcc70cfdc19$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $ffa05dcc70cfdc19$var$baseParams);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.mintDenom = reader.string();
                    break;
                case 2:
                    message.inflationRateChange = reader.string();
                    break;
                case 3:
                    message.inflationMax = reader.string();
                    break;
                case 4:
                    message.inflationMin = reader.string();
                    break;
                case 5:
                    message.goalBonded = reader.string();
                    break;
                case 6:
                    message.blocksPerYear = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $ffa05dcc70cfdc19$var$baseParams);
        message.mintDenom = object.mintDenom !== undefined && object.mintDenom !== null ? String(object.mintDenom) : "";
        message.inflationRateChange = object.inflationRateChange !== undefined && object.inflationRateChange !== null ? String(object.inflationRateChange) : "";
        message.inflationMax = object.inflationMax !== undefined && object.inflationMax !== null ? String(object.inflationMax) : "";
        message.inflationMin = object.inflationMin !== undefined && object.inflationMin !== null ? String(object.inflationMin) : "";
        message.goalBonded = object.goalBonded !== undefined && object.goalBonded !== null ? String(object.goalBonded) : "";
        message.blocksPerYear = object.blocksPerYear !== undefined && object.blocksPerYear !== null ? $ffa05dcc70cfdc19$var$long_1.default.fromString(object.blocksPerYear) : $ffa05dcc70cfdc19$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.mintDenom !== undefined && (obj.mintDenom = message.mintDenom);
        message.inflationRateChange !== undefined && (obj.inflationRateChange = message.inflationRateChange);
        message.inflationMax !== undefined && (obj.inflationMax = message.inflationMax);
        message.inflationMin !== undefined && (obj.inflationMin = message.inflationMin);
        message.goalBonded !== undefined && (obj.goalBonded = message.goalBonded);
        message.blocksPerYear !== undefined && (obj.blocksPerYear = (message.blocksPerYear || $ffa05dcc70cfdc19$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e;
        const message = Object.assign({}, $ffa05dcc70cfdc19$var$baseParams);
        message.mintDenom = (_a = object.mintDenom) !== null && _a !== void 0 ? _a : "";
        message.inflationRateChange = (_b = object.inflationRateChange) !== null && _b !== void 0 ? _b : "";
        message.inflationMax = (_c = object.inflationMax) !== null && _c !== void 0 ? _c : "";
        message.inflationMin = (_d = object.inflationMin) !== null && _d !== void 0 ? _d : "";
        message.goalBonded = (_e = object.goalBonded) !== null && _e !== void 0 ? _e : "";
        message.blocksPerYear = object.blocksPerYear !== undefined && object.blocksPerYear !== null ? $ffa05dcc70cfdc19$var$long_1.default.fromValue(object.blocksPerYear) : $ffa05dcc70cfdc19$var$long_1.default.UZERO;
        return message;
    }
};
if ($ffa05dcc70cfdc19$var$minimal_1.default.util.Long !== $ffa05dcc70cfdc19$var$long_1.default) {
    $ffa05dcc70cfdc19$var$minimal_1.default.util.Long = $ffa05dcc70cfdc19$var$long_1.default;
    $ffa05dcc70cfdc19$var$minimal_1.default.configure();
}


$9e5c082c528731ae$exports.protobufPackage = "cosmos.mint.v1beta1";
const $9e5c082c528731ae$var$baseQueryParamsRequest = {};
$9e5c082c528731ae$exports.QueryParamsRequest = {
    encode (_, writer = $9e5c082c528731ae$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9e5c082c528731ae$var$minimal_1.default.Reader ? input : new $9e5c082c528731ae$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9e5c082c528731ae$var$baseQueryParamsRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $9e5c082c528731ae$var$baseQueryParamsRequest);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $9e5c082c528731ae$var$baseQueryParamsRequest);
        return message;
    }
};
const $9e5c082c528731ae$var$baseQueryParamsResponse = {};
$9e5c082c528731ae$exports.QueryParamsResponse = {
    encode (message, writer = $9e5c082c528731ae$var$minimal_1.default.Writer.create()) {
        if (message.params !== undefined) $ffa05dcc70cfdc19$exports.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9e5c082c528731ae$var$minimal_1.default.Reader ? input : new $9e5c082c528731ae$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9e5c082c528731ae$var$baseQueryParamsResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $ffa05dcc70cfdc19$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9e5c082c528731ae$var$baseQueryParamsResponse);
        message.params = object.params !== undefined && object.params !== null ? $ffa05dcc70cfdc19$exports.Params.fromJSON(object.params) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? $ffa05dcc70cfdc19$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $9e5c082c528731ae$var$baseQueryParamsResponse);
        message.params = object.params !== undefined && object.params !== null ? $ffa05dcc70cfdc19$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
const $9e5c082c528731ae$var$baseQueryInflationRequest = {};
$9e5c082c528731ae$exports.QueryInflationRequest = {
    encode (_, writer = $9e5c082c528731ae$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9e5c082c528731ae$var$minimal_1.default.Reader ? input : new $9e5c082c528731ae$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9e5c082c528731ae$var$baseQueryInflationRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $9e5c082c528731ae$var$baseQueryInflationRequest);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $9e5c082c528731ae$var$baseQueryInflationRequest);
        return message;
    }
};
const $9e5c082c528731ae$var$baseQueryInflationResponse = {};
$9e5c082c528731ae$exports.QueryInflationResponse = {
    encode (message, writer = $9e5c082c528731ae$var$minimal_1.default.Writer.create()) {
        if (message.inflation.length !== 0) writer.uint32(10).bytes(message.inflation);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9e5c082c528731ae$var$minimal_1.default.Reader ? input : new $9e5c082c528731ae$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9e5c082c528731ae$var$baseQueryInflationResponse);
        message.inflation = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.inflation = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9e5c082c528731ae$var$baseQueryInflationResponse);
        message.inflation = object.inflation !== undefined && object.inflation !== null ? $9e5c082c528731ae$var$bytesFromBase64(object.inflation) : new Uint8Array();
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.inflation !== undefined && (obj.inflation = $9e5c082c528731ae$var$base64FromBytes(message.inflation !== undefined ? message.inflation : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $9e5c082c528731ae$var$baseQueryInflationResponse);
        message.inflation = (_a = object.inflation) !== null && _a !== void 0 ? _a : new Uint8Array();
        return message;
    }
};
const $9e5c082c528731ae$var$baseQueryAnnualProvisionsRequest = {};
$9e5c082c528731ae$exports.QueryAnnualProvisionsRequest = {
    encode (_, writer = $9e5c082c528731ae$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9e5c082c528731ae$var$minimal_1.default.Reader ? input : new $9e5c082c528731ae$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9e5c082c528731ae$var$baseQueryAnnualProvisionsRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $9e5c082c528731ae$var$baseQueryAnnualProvisionsRequest);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $9e5c082c528731ae$var$baseQueryAnnualProvisionsRequest);
        return message;
    }
};
const $9e5c082c528731ae$var$baseQueryAnnualProvisionsResponse = {};
$9e5c082c528731ae$exports.QueryAnnualProvisionsResponse = {
    encode (message, writer = $9e5c082c528731ae$var$minimal_1.default.Writer.create()) {
        if (message.annualProvisions.length !== 0) writer.uint32(10).bytes(message.annualProvisions);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9e5c082c528731ae$var$minimal_1.default.Reader ? input : new $9e5c082c528731ae$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $9e5c082c528731ae$var$baseQueryAnnualProvisionsResponse);
        message.annualProvisions = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.annualProvisions = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $9e5c082c528731ae$var$baseQueryAnnualProvisionsResponse);
        message.annualProvisions = object.annualProvisions !== undefined && object.annualProvisions !== null ? $9e5c082c528731ae$var$bytesFromBase64(object.annualProvisions) : new Uint8Array();
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.annualProvisions !== undefined && (obj.annualProvisions = $9e5c082c528731ae$var$base64FromBytes(message.annualProvisions !== undefined ? message.annualProvisions : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $9e5c082c528731ae$var$baseQueryAnnualProvisionsResponse);
        message.annualProvisions = (_a = object.annualProvisions) !== null && _a !== void 0 ? _a : new Uint8Array();
        return message;
    }
};
class $9e5c082c528731ae$var$QueryClientImpl {
    Params(request) {
        const data = $9e5c082c528731ae$exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.mint.v1beta1.Query", "Params", data);
        return promise.then((data)=>$9e5c082c528731ae$exports.QueryParamsResponse.decode(new $9e5c082c528731ae$var$minimal_1.default.Reader(data)));
    }
    Inflation(request) {
        const data = $9e5c082c528731ae$exports.QueryInflationRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.mint.v1beta1.Query", "Inflation", data);
        return promise.then((data)=>$9e5c082c528731ae$exports.QueryInflationResponse.decode(new $9e5c082c528731ae$var$minimal_1.default.Reader(data)));
    }
    AnnualProvisions(request) {
        const data = $9e5c082c528731ae$exports.QueryAnnualProvisionsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.mint.v1beta1.Query", "AnnualProvisions", data);
        return promise.then((data)=>$9e5c082c528731ae$exports.QueryAnnualProvisionsResponse.decode(new $9e5c082c528731ae$var$minimal_1.default.Reader(data)));
    }
    constructor(rpc){
        this.rpc = rpc;
        this.Params = this.Params.bind(this);
        this.Inflation = this.Inflation.bind(this);
        this.AnnualProvisions = this.AnnualProvisions.bind(this);
    }
}
$9e5c082c528731ae$exports.QueryClientImpl = $9e5c082c528731ae$var$QueryClientImpl;
var $9e5c082c528731ae$var$globalThis = (()=>{
    if (typeof $9e5c082c528731ae$var$globalThis !== "undefined") return $9e5c082c528731ae$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $9e5c082c528731ae$var$atob = $9e5c082c528731ae$var$globalThis.atob || ((b64)=>$9e5c082c528731ae$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $9e5c082c528731ae$var$bytesFromBase64(b64) {
    const bin = $9e5c082c528731ae$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $9e5c082c528731ae$var$btoa = $9e5c082c528731ae$var$globalThis.btoa || ((bin)=>$9e5c082c528731ae$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $9e5c082c528731ae$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $9e5c082c528731ae$var$btoa(bin.join(""));
}
if ($9e5c082c528731ae$var$minimal_1.default.util.Long !== $9e5c082c528731ae$var$long_1.default) {
    $9e5c082c528731ae$var$minimal_1.default.util.Long = $9e5c082c528731ae$var$long_1.default;
    $9e5c082c528731ae$var$minimal_1.default.configure();
}



function $bc7f5ee243357870$var$setupMintExtension(base) {
    const rpc = (0, $ffdede50deec576f$exports.createProtobufRpcClient)(base);
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const queryService = new $9e5c082c528731ae$exports.QueryClientImpl(rpc);
    return {
        mint: {
            params: async ()=>{
                const { params: params } = await queryService.Params({});
                (0, $F6P8J.assert)(params);
                return {
                    blocksPerYear: params.blocksPerYear,
                    goalBonded: (0, $ffdede50deec576f$exports.decodeCosmosSdkDecFromProto)(params.goalBonded),
                    inflationMin: (0, $ffdede50deec576f$exports.decodeCosmosSdkDecFromProto)(params.inflationMin),
                    inflationMax: (0, $ffdede50deec576f$exports.decodeCosmosSdkDecFromProto)(params.inflationMax),
                    inflationRateChange: (0, $ffdede50deec576f$exports.decodeCosmosSdkDecFromProto)(params.inflationRateChange),
                    mintDenom: params.mintDenom
                };
            },
            inflation: async ()=>{
                const { inflation: inflation } = await queryService.Inflation({});
                return (0, $ffdede50deec576f$exports.decodeCosmosSdkDecFromProto)(inflation);
            },
            annualProvisions: async ()=>{
                const { annualProvisions: annualProvisions } = await queryService.AnnualProvisions({});
                return (0, $ffdede50deec576f$exports.decodeCosmosSdkDecFromProto)(annualProvisions);
            }
        }
    };
}
$bc7f5ee243357870$exports.setupMintExtension = $bc7f5ee243357870$var$setupMintExtension;


Object.defineProperty($7725f2e3ca016b52$exports, "setupMintExtension", {
    enumerable: true,
    get: function() {
        return $bc7f5ee243357870$exports.setupMintExtension;
    }
});
var $43aab686cf9620cb$exports = {};
"use strict";
Object.defineProperty($43aab686cf9620cb$exports, "__esModule", {
    value: true
});
$43aab686cf9620cb$exports.createSlashingAminoConverters = $43aab686cf9620cb$exports.isAminoMsgUnjail = void 0;
function $43aab686cf9620cb$var$isAminoMsgUnjail(msg) {
    return msg.type === "cosmos-sdk/MsgUnjail";
}
$43aab686cf9620cb$exports.isAminoMsgUnjail = $43aab686cf9620cb$var$isAminoMsgUnjail;
function $43aab686cf9620cb$var$createSlashingAminoConverters() {
    throw new Error("Not implemented");
}
$43aab686cf9620cb$exports.createSlashingAminoConverters = $43aab686cf9620cb$var$createSlashingAminoConverters;


Object.defineProperty($7725f2e3ca016b52$exports, "createSlashingAminoConverters", {
    enumerable: true,
    get: function() {
        return $43aab686cf9620cb$exports.createSlashingAminoConverters;
    }
});
Object.defineProperty($7725f2e3ca016b52$exports, "isAminoMsgUnjail", {
    enumerable: true,
    get: function() {
        return $43aab686cf9620cb$exports.isAminoMsgUnjail;
    }
});
var $0b7f32445130cee5$exports = {};
"use strict";
Object.defineProperty($0b7f32445130cee5$exports, "__esModule", {
    value: true
});
$0b7f32445130cee5$exports.setupSlashingExtension = void 0;
var $d62a101e8d82d47b$exports = {};
"use strict";
var $d62a101e8d82d47b$var$__importDefault = $d62a101e8d82d47b$exports && $d62a101e8d82d47b$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($d62a101e8d82d47b$exports, "__esModule", {
    value: true
});
$d62a101e8d82d47b$exports.QueryClientImpl = $d62a101e8d82d47b$exports.QuerySigningInfosResponse = $d62a101e8d82d47b$exports.QuerySigningInfosRequest = $d62a101e8d82d47b$exports.QuerySigningInfoResponse = $d62a101e8d82d47b$exports.QuerySigningInfoRequest = $d62a101e8d82d47b$exports.QueryParamsResponse = $d62a101e8d82d47b$exports.QueryParamsRequest = $d62a101e8d82d47b$exports.protobufPackage = void 0;

/* eslint-disable */ const $d62a101e8d82d47b$var$long_1 = $d62a101e8d82d47b$var$__importDefault((parcelRequire("9A55m")));

const $d62a101e8d82d47b$var$minimal_1 = $d62a101e8d82d47b$var$__importDefault((parcelRequire("i2pIU")));
var $bab8c8a9ce5cc70a$exports = {};
"use strict";
var $bab8c8a9ce5cc70a$var$__importDefault = $bab8c8a9ce5cc70a$exports && $bab8c8a9ce5cc70a$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($bab8c8a9ce5cc70a$exports, "__esModule", {
    value: true
});
$bab8c8a9ce5cc70a$exports.Params = $bab8c8a9ce5cc70a$exports.ValidatorSigningInfo = $bab8c8a9ce5cc70a$exports.protobufPackage = void 0;

/* eslint-disable */ const $bab8c8a9ce5cc70a$var$long_1 = $bab8c8a9ce5cc70a$var$__importDefault((parcelRequire("9A55m")));

const $bab8c8a9ce5cc70a$var$minimal_1 = $bab8c8a9ce5cc70a$var$__importDefault((parcelRequire("i2pIU")));


$bab8c8a9ce5cc70a$exports.protobufPackage = "cosmos.slashing.v1beta1";
const $bab8c8a9ce5cc70a$var$baseValidatorSigningInfo = {
    address: "",
    startHeight: $bab8c8a9ce5cc70a$var$long_1.default.ZERO,
    indexOffset: $bab8c8a9ce5cc70a$var$long_1.default.ZERO,
    tombstoned: false,
    missedBlocksCounter: $bab8c8a9ce5cc70a$var$long_1.default.ZERO
};
$bab8c8a9ce5cc70a$exports.ValidatorSigningInfo = {
    encode (message, writer = $bab8c8a9ce5cc70a$var$minimal_1.default.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (!message.startHeight.isZero()) writer.uint32(16).int64(message.startHeight);
        if (!message.indexOffset.isZero()) writer.uint32(24).int64(message.indexOffset);
        if (message.jailedUntil !== undefined) $d6c3291d6aa8eb5b$exports.Timestamp.encode(message.jailedUntil, writer.uint32(34).fork()).ldelim();
        if (message.tombstoned === true) writer.uint32(40).bool(message.tombstoned);
        if (!message.missedBlocksCounter.isZero()) writer.uint32(48).int64(message.missedBlocksCounter);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bab8c8a9ce5cc70a$var$minimal_1.default.Reader ? input : new $bab8c8a9ce5cc70a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bab8c8a9ce5cc70a$var$baseValidatorSigningInfo);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.startHeight = reader.int64();
                    break;
                case 3:
                    message.indexOffset = reader.int64();
                    break;
                case 4:
                    message.jailedUntil = $d6c3291d6aa8eb5b$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.tombstoned = reader.bool();
                    break;
                case 6:
                    message.missedBlocksCounter = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $bab8c8a9ce5cc70a$var$baseValidatorSigningInfo);
        message.address = object.address !== undefined && object.address !== null ? String(object.address) : "";
        message.startHeight = object.startHeight !== undefined && object.startHeight !== null ? $bab8c8a9ce5cc70a$var$long_1.default.fromString(object.startHeight) : $bab8c8a9ce5cc70a$var$long_1.default.ZERO;
        message.indexOffset = object.indexOffset !== undefined && object.indexOffset !== null ? $bab8c8a9ce5cc70a$var$long_1.default.fromString(object.indexOffset) : $bab8c8a9ce5cc70a$var$long_1.default.ZERO;
        message.jailedUntil = object.jailedUntil !== undefined && object.jailedUntil !== null ? $bab8c8a9ce5cc70a$var$fromJsonTimestamp(object.jailedUntil) : undefined;
        message.tombstoned = object.tombstoned !== undefined && object.tombstoned !== null ? Boolean(object.tombstoned) : false;
        message.missedBlocksCounter = object.missedBlocksCounter !== undefined && object.missedBlocksCounter !== null ? $bab8c8a9ce5cc70a$var$long_1.default.fromString(object.missedBlocksCounter) : $bab8c8a9ce5cc70a$var$long_1.default.ZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.startHeight !== undefined && (obj.startHeight = (message.startHeight || $bab8c8a9ce5cc70a$var$long_1.default.ZERO).toString());
        message.indexOffset !== undefined && (obj.indexOffset = (message.indexOffset || $bab8c8a9ce5cc70a$var$long_1.default.ZERO).toString());
        message.jailedUntil !== undefined && (obj.jailedUntil = $bab8c8a9ce5cc70a$var$fromTimestamp(message.jailedUntil).toISOString());
        message.tombstoned !== undefined && (obj.tombstoned = message.tombstoned);
        message.missedBlocksCounter !== undefined && (obj.missedBlocksCounter = (message.missedBlocksCounter || $bab8c8a9ce5cc70a$var$long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $bab8c8a9ce5cc70a$var$baseValidatorSigningInfo);
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        message.startHeight = object.startHeight !== undefined && object.startHeight !== null ? $bab8c8a9ce5cc70a$var$long_1.default.fromValue(object.startHeight) : $bab8c8a9ce5cc70a$var$long_1.default.ZERO;
        message.indexOffset = object.indexOffset !== undefined && object.indexOffset !== null ? $bab8c8a9ce5cc70a$var$long_1.default.fromValue(object.indexOffset) : $bab8c8a9ce5cc70a$var$long_1.default.ZERO;
        message.jailedUntil = object.jailedUntil !== undefined && object.jailedUntil !== null ? $d6c3291d6aa8eb5b$exports.Timestamp.fromPartial(object.jailedUntil) : undefined;
        message.tombstoned = (_b = object.tombstoned) !== null && _b !== void 0 ? _b : false;
        message.missedBlocksCounter = object.missedBlocksCounter !== undefined && object.missedBlocksCounter !== null ? $bab8c8a9ce5cc70a$var$long_1.default.fromValue(object.missedBlocksCounter) : $bab8c8a9ce5cc70a$var$long_1.default.ZERO;
        return message;
    }
};
const $bab8c8a9ce5cc70a$var$baseParams = {
    signedBlocksWindow: $bab8c8a9ce5cc70a$var$long_1.default.ZERO
};
$bab8c8a9ce5cc70a$exports.Params = {
    encode (message, writer = $bab8c8a9ce5cc70a$var$minimal_1.default.Writer.create()) {
        if (!message.signedBlocksWindow.isZero()) writer.uint32(8).int64(message.signedBlocksWindow);
        if (message.minSignedPerWindow.length !== 0) writer.uint32(18).bytes(message.minSignedPerWindow);
        if (message.downtimeJailDuration !== undefined) $ad1f748ecd469446$exports.Duration.encode(message.downtimeJailDuration, writer.uint32(26).fork()).ldelim();
        if (message.slashFractionDoubleSign.length !== 0) writer.uint32(34).bytes(message.slashFractionDoubleSign);
        if (message.slashFractionDowntime.length !== 0) writer.uint32(42).bytes(message.slashFractionDowntime);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bab8c8a9ce5cc70a$var$minimal_1.default.Reader ? input : new $bab8c8a9ce5cc70a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bab8c8a9ce5cc70a$var$baseParams);
        message.minSignedPerWindow = new Uint8Array();
        message.slashFractionDoubleSign = new Uint8Array();
        message.slashFractionDowntime = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signedBlocksWindow = reader.int64();
                    break;
                case 2:
                    message.minSignedPerWindow = reader.bytes();
                    break;
                case 3:
                    message.downtimeJailDuration = $ad1f748ecd469446$exports.Duration.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.slashFractionDoubleSign = reader.bytes();
                    break;
                case 5:
                    message.slashFractionDowntime = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $bab8c8a9ce5cc70a$var$baseParams);
        message.signedBlocksWindow = object.signedBlocksWindow !== undefined && object.signedBlocksWindow !== null ? $bab8c8a9ce5cc70a$var$long_1.default.fromString(object.signedBlocksWindow) : $bab8c8a9ce5cc70a$var$long_1.default.ZERO;
        message.minSignedPerWindow = object.minSignedPerWindow !== undefined && object.minSignedPerWindow !== null ? $bab8c8a9ce5cc70a$var$bytesFromBase64(object.minSignedPerWindow) : new Uint8Array();
        message.downtimeJailDuration = object.downtimeJailDuration !== undefined && object.downtimeJailDuration !== null ? $ad1f748ecd469446$exports.Duration.fromJSON(object.downtimeJailDuration) : undefined;
        message.slashFractionDoubleSign = object.slashFractionDoubleSign !== undefined && object.slashFractionDoubleSign !== null ? $bab8c8a9ce5cc70a$var$bytesFromBase64(object.slashFractionDoubleSign) : new Uint8Array();
        message.slashFractionDowntime = object.slashFractionDowntime !== undefined && object.slashFractionDowntime !== null ? $bab8c8a9ce5cc70a$var$bytesFromBase64(object.slashFractionDowntime) : new Uint8Array();
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.signedBlocksWindow !== undefined && (obj.signedBlocksWindow = (message.signedBlocksWindow || $bab8c8a9ce5cc70a$var$long_1.default.ZERO).toString());
        message.minSignedPerWindow !== undefined && (obj.minSignedPerWindow = $bab8c8a9ce5cc70a$var$base64FromBytes(message.minSignedPerWindow !== undefined ? message.minSignedPerWindow : new Uint8Array()));
        message.downtimeJailDuration !== undefined && (obj.downtimeJailDuration = message.downtimeJailDuration ? $ad1f748ecd469446$exports.Duration.toJSON(message.downtimeJailDuration) : undefined);
        message.slashFractionDoubleSign !== undefined && (obj.slashFractionDoubleSign = $bab8c8a9ce5cc70a$var$base64FromBytes(message.slashFractionDoubleSign !== undefined ? message.slashFractionDoubleSign : new Uint8Array()));
        message.slashFractionDowntime !== undefined && (obj.slashFractionDowntime = $bab8c8a9ce5cc70a$var$base64FromBytes(message.slashFractionDowntime !== undefined ? message.slashFractionDowntime : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $bab8c8a9ce5cc70a$var$baseParams);
        message.signedBlocksWindow = object.signedBlocksWindow !== undefined && object.signedBlocksWindow !== null ? $bab8c8a9ce5cc70a$var$long_1.default.fromValue(object.signedBlocksWindow) : $bab8c8a9ce5cc70a$var$long_1.default.ZERO;
        message.minSignedPerWindow = (_a = object.minSignedPerWindow) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.downtimeJailDuration = object.downtimeJailDuration !== undefined && object.downtimeJailDuration !== null ? $ad1f748ecd469446$exports.Duration.fromPartial(object.downtimeJailDuration) : undefined;
        message.slashFractionDoubleSign = (_b = object.slashFractionDoubleSign) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.slashFractionDowntime = (_c = object.slashFractionDowntime) !== null && _c !== void 0 ? _c : new Uint8Array();
        return message;
    }
};
var $bab8c8a9ce5cc70a$var$globalThis = (()=>{
    if (typeof $bab8c8a9ce5cc70a$var$globalThis !== "undefined") return $bab8c8a9ce5cc70a$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $bab8c8a9ce5cc70a$var$atob = $bab8c8a9ce5cc70a$var$globalThis.atob || ((b64)=>$bab8c8a9ce5cc70a$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $bab8c8a9ce5cc70a$var$bytesFromBase64(b64) {
    const bin = $bab8c8a9ce5cc70a$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $bab8c8a9ce5cc70a$var$btoa = $bab8c8a9ce5cc70a$var$globalThis.btoa || ((bin)=>$bab8c8a9ce5cc70a$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $bab8c8a9ce5cc70a$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $bab8c8a9ce5cc70a$var$btoa(bin.join(""));
}
function $bab8c8a9ce5cc70a$var$toTimestamp(date) {
    const seconds = $bab8c8a9ce5cc70a$var$numberToLong(date.getTime() / 1000);
    const nanos = date.getTime() % 1000 * 1000000;
    return {
        seconds: seconds,
        nanos: nanos
    };
}
function $bab8c8a9ce5cc70a$var$fromTimestamp(t) {
    let millis = t.seconds.toNumber() * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function $bab8c8a9ce5cc70a$var$fromJsonTimestamp(o) {
    if (o instanceof Date) return $bab8c8a9ce5cc70a$var$toTimestamp(o);
    else if (typeof o === "string") return $bab8c8a9ce5cc70a$var$toTimestamp(new Date(o));
    else return $d6c3291d6aa8eb5b$exports.Timestamp.fromJSON(o);
}
function $bab8c8a9ce5cc70a$var$numberToLong(number) {
    return $bab8c8a9ce5cc70a$var$long_1.default.fromNumber(number);
}
if ($bab8c8a9ce5cc70a$var$minimal_1.default.util.Long !== $bab8c8a9ce5cc70a$var$long_1.default) {
    $bab8c8a9ce5cc70a$var$minimal_1.default.util.Long = $bab8c8a9ce5cc70a$var$long_1.default;
    $bab8c8a9ce5cc70a$var$minimal_1.default.configure();
}



$d62a101e8d82d47b$exports.protobufPackage = "cosmos.slashing.v1beta1";
const $d62a101e8d82d47b$var$baseQueryParamsRequest = {};
$d62a101e8d82d47b$exports.QueryParamsRequest = {
    encode (_, writer = $d62a101e8d82d47b$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d62a101e8d82d47b$var$minimal_1.default.Reader ? input : new $d62a101e8d82d47b$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $d62a101e8d82d47b$var$baseQueryParamsRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $d62a101e8d82d47b$var$baseQueryParamsRequest);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $d62a101e8d82d47b$var$baseQueryParamsRequest);
        return message;
    }
};
const $d62a101e8d82d47b$var$baseQueryParamsResponse = {};
$d62a101e8d82d47b$exports.QueryParamsResponse = {
    encode (message, writer = $d62a101e8d82d47b$var$minimal_1.default.Writer.create()) {
        if (message.params !== undefined) $bab8c8a9ce5cc70a$exports.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d62a101e8d82d47b$var$minimal_1.default.Reader ? input : new $d62a101e8d82d47b$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $d62a101e8d82d47b$var$baseQueryParamsResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $bab8c8a9ce5cc70a$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $d62a101e8d82d47b$var$baseQueryParamsResponse);
        message.params = object.params !== undefined && object.params !== null ? $bab8c8a9ce5cc70a$exports.Params.fromJSON(object.params) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? $bab8c8a9ce5cc70a$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $d62a101e8d82d47b$var$baseQueryParamsResponse);
        message.params = object.params !== undefined && object.params !== null ? $bab8c8a9ce5cc70a$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
const $d62a101e8d82d47b$var$baseQuerySigningInfoRequest = {
    consAddress: ""
};
$d62a101e8d82d47b$exports.QuerySigningInfoRequest = {
    encode (message, writer = $d62a101e8d82d47b$var$minimal_1.default.Writer.create()) {
        if (message.consAddress !== "") writer.uint32(10).string(message.consAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d62a101e8d82d47b$var$minimal_1.default.Reader ? input : new $d62a101e8d82d47b$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $d62a101e8d82d47b$var$baseQuerySigningInfoRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.consAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $d62a101e8d82d47b$var$baseQuerySigningInfoRequest);
        message.consAddress = object.consAddress !== undefined && object.consAddress !== null ? String(object.consAddress) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.consAddress !== undefined && (obj.consAddress = message.consAddress);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $d62a101e8d82d47b$var$baseQuerySigningInfoRequest);
        message.consAddress = (_a = object.consAddress) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
const $d62a101e8d82d47b$var$baseQuerySigningInfoResponse = {};
$d62a101e8d82d47b$exports.QuerySigningInfoResponse = {
    encode (message, writer = $d62a101e8d82d47b$var$minimal_1.default.Writer.create()) {
        if (message.valSigningInfo !== undefined) $bab8c8a9ce5cc70a$exports.ValidatorSigningInfo.encode(message.valSigningInfo, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d62a101e8d82d47b$var$minimal_1.default.Reader ? input : new $d62a101e8d82d47b$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $d62a101e8d82d47b$var$baseQuerySigningInfoResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.valSigningInfo = $bab8c8a9ce5cc70a$exports.ValidatorSigningInfo.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $d62a101e8d82d47b$var$baseQuerySigningInfoResponse);
        message.valSigningInfo = object.valSigningInfo !== undefined && object.valSigningInfo !== null ? $bab8c8a9ce5cc70a$exports.ValidatorSigningInfo.fromJSON(object.valSigningInfo) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.valSigningInfo !== undefined && (obj.valSigningInfo = message.valSigningInfo ? $bab8c8a9ce5cc70a$exports.ValidatorSigningInfo.toJSON(message.valSigningInfo) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $d62a101e8d82d47b$var$baseQuerySigningInfoResponse);
        message.valSigningInfo = object.valSigningInfo !== undefined && object.valSigningInfo !== null ? $bab8c8a9ce5cc70a$exports.ValidatorSigningInfo.fromPartial(object.valSigningInfo) : undefined;
        return message;
    }
};
const $d62a101e8d82d47b$var$baseQuerySigningInfosRequest = {};
$d62a101e8d82d47b$exports.QuerySigningInfosRequest = {
    encode (message, writer = $d62a101e8d82d47b$var$minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d62a101e8d82d47b$var$minimal_1.default.Reader ? input : new $d62a101e8d82d47b$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $d62a101e8d82d47b$var$baseQuerySigningInfosRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pagination = $f01b40e20607eb8e$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $d62a101e8d82d47b$var$baseQuerySigningInfosRequest);
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromJSON(object.pagination) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $d62a101e8d82d47b$var$baseQuerySigningInfosRequest);
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
const $d62a101e8d82d47b$var$baseQuerySigningInfosResponse = {};
$d62a101e8d82d47b$exports.QuerySigningInfosResponse = {
    encode (message, writer = $d62a101e8d82d47b$var$minimal_1.default.Writer.create()) {
        for (const v of message.info)$bab8c8a9ce5cc70a$exports.ValidatorSigningInfo.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d62a101e8d82d47b$var$minimal_1.default.Reader ? input : new $d62a101e8d82d47b$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $d62a101e8d82d47b$var$baseQuerySigningInfosResponse);
        message.info = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.info.push($bab8c8a9ce5cc70a$exports.ValidatorSigningInfo.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $f01b40e20607eb8e$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $d62a101e8d82d47b$var$baseQuerySigningInfosResponse);
        message.info = ((_a = object.info) !== null && _a !== void 0 ? _a : []).map((e)=>$bab8c8a9ce5cc70a$exports.ValidatorSigningInfo.fromJSON(e));
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromJSON(object.pagination) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.info) obj.info = message.info.map((e)=>e ? $bab8c8a9ce5cc70a$exports.ValidatorSigningInfo.toJSON(e) : undefined);
        else obj.info = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $d62a101e8d82d47b$var$baseQuerySigningInfosResponse);
        message.info = ((_a = object.info) === null || _a === void 0 ? void 0 : _a.map((e)=>$bab8c8a9ce5cc70a$exports.ValidatorSigningInfo.fromPartial(e))) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
class $d62a101e8d82d47b$var$QueryClientImpl {
    Params(request) {
        const data = $d62a101e8d82d47b$exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.slashing.v1beta1.Query", "Params", data);
        return promise.then((data)=>$d62a101e8d82d47b$exports.QueryParamsResponse.decode(new $d62a101e8d82d47b$var$minimal_1.default.Reader(data)));
    }
    SigningInfo(request) {
        const data = $d62a101e8d82d47b$exports.QuerySigningInfoRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.slashing.v1beta1.Query", "SigningInfo", data);
        return promise.then((data)=>$d62a101e8d82d47b$exports.QuerySigningInfoResponse.decode(new $d62a101e8d82d47b$var$minimal_1.default.Reader(data)));
    }
    SigningInfos(request) {
        const data = $d62a101e8d82d47b$exports.QuerySigningInfosRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.slashing.v1beta1.Query", "SigningInfos", data);
        return promise.then((data)=>$d62a101e8d82d47b$exports.QuerySigningInfosResponse.decode(new $d62a101e8d82d47b$var$minimal_1.default.Reader(data)));
    }
    constructor(rpc){
        this.rpc = rpc;
        this.Params = this.Params.bind(this);
        this.SigningInfo = this.SigningInfo.bind(this);
        this.SigningInfos = this.SigningInfos.bind(this);
    }
}
$d62a101e8d82d47b$exports.QueryClientImpl = $d62a101e8d82d47b$var$QueryClientImpl;
if ($d62a101e8d82d47b$var$minimal_1.default.util.Long !== $d62a101e8d82d47b$var$long_1.default) {
    $d62a101e8d82d47b$var$minimal_1.default.util.Long = $d62a101e8d82d47b$var$long_1.default;
    $d62a101e8d82d47b$var$minimal_1.default.configure();
}



function $0b7f32445130cee5$var$setupSlashingExtension(base) {
    const rpc = (0, $ffdede50deec576f$exports.createProtobufRpcClient)(base);
    const queryService = new $d62a101e8d82d47b$exports.QueryClientImpl(rpc);
    return {
        slashing: {
            signingInfo: async (consAddress)=>{
                const response = await queryService.SigningInfo({
                    consAddress: consAddress
                });
                return response;
            },
            signingInfos: async (paginationKey)=>{
                const response = await queryService.SigningInfos({
                    pagination: (0, $ffdede50deec576f$exports.createPagination)(paginationKey)
                });
                return response;
            },
            params: async ()=>{
                const response = await queryService.Params({});
                return response;
            }
        }
    };
}
$0b7f32445130cee5$exports.setupSlashingExtension = $0b7f32445130cee5$var$setupSlashingExtension;


Object.defineProperty($7725f2e3ca016b52$exports, "setupSlashingExtension", {
    enumerable: true,
    get: function() {
        return $0b7f32445130cee5$exports.setupSlashingExtension;
    }
});
var $60fd337025b45544$exports = {};
"use strict";
Object.defineProperty($60fd337025b45544$exports, "__esModule", {
    value: true
});
$60fd337025b45544$exports.createStakingAminoConverters = $60fd337025b45544$exports.isAminoMsgUndelegate = $60fd337025b45544$exports.isAminoMsgBeginRedelegate = $60fd337025b45544$exports.isAminoMsgDelegate = $60fd337025b45544$exports.isAminoMsgEditValidator = $60fd337025b45544$exports.isAminoMsgCreateValidator = void 0;


var $5zb9p = parcelRequire("5zb9p");

var $F6P8J = parcelRequire("F6P8J");
function $60fd337025b45544$var$isAminoMsgCreateValidator(msg) {
    return msg.type === "cosmos-sdk/MsgCreateValidator";
}
$60fd337025b45544$exports.isAminoMsgCreateValidator = $60fd337025b45544$var$isAminoMsgCreateValidator;
function $60fd337025b45544$var$isAminoMsgEditValidator(msg) {
    return msg.type === "cosmos-sdk/MsgEditValidator";
}
$60fd337025b45544$exports.isAminoMsgEditValidator = $60fd337025b45544$var$isAminoMsgEditValidator;
function $60fd337025b45544$var$isAminoMsgDelegate(msg) {
    return msg.type === "cosmos-sdk/MsgDelegate";
}
$60fd337025b45544$exports.isAminoMsgDelegate = $60fd337025b45544$var$isAminoMsgDelegate;
function $60fd337025b45544$var$isAminoMsgBeginRedelegate(msg) {
    return msg.type === "cosmos-sdk/MsgBeginRedelegate";
}
$60fd337025b45544$exports.isAminoMsgBeginRedelegate = $60fd337025b45544$var$isAminoMsgBeginRedelegate;
function $60fd337025b45544$var$isAminoMsgUndelegate(msg) {
    return msg.type === "cosmos-sdk/MsgUndelegate";
}
$60fd337025b45544$exports.isAminoMsgUndelegate = $60fd337025b45544$var$isAminoMsgUndelegate;
function $60fd337025b45544$var$createStakingAminoConverters(prefix) {
    return {
        "/cosmos.staking.v1beta1.MsgBeginRedelegate": {
            aminoType: "cosmos-sdk/MsgBeginRedelegate",
            toAmino: ({ delegatorAddress: delegatorAddress, validatorSrcAddress: validatorSrcAddress, validatorDstAddress: validatorDstAddress, amount: amount })=>{
                (0, $F6P8J.assertDefinedAndNotNull)(amount, "missing amount");
                return {
                    delegator_address: delegatorAddress,
                    validator_src_address: validatorSrcAddress,
                    validator_dst_address: validatorDstAddress,
                    amount: amount
                };
            },
            fromAmino: ({ delegator_address: delegator_address, validator_src_address: validator_src_address, validator_dst_address: validator_dst_address, amount: amount })=>({
                    delegatorAddress: delegator_address,
                    validatorSrcAddress: validator_src_address,
                    validatorDstAddress: validator_dst_address,
                    amount: amount
                })
        },
        "/cosmos.staking.v1beta1.MsgCreateValidator": {
            aminoType: "cosmos-sdk/MsgCreateValidator",
            toAmino: ({ description: description, commission: commission, minSelfDelegation: minSelfDelegation, delegatorAddress: delegatorAddress, validatorAddress: validatorAddress, pubkey: pubkey, value: value })=>{
                (0, $F6P8J.assertDefinedAndNotNull)(description, "missing description");
                (0, $F6P8J.assertDefinedAndNotNull)(commission, "missing commission");
                (0, $F6P8J.assertDefinedAndNotNull)(pubkey, "missing pubkey");
                (0, $F6P8J.assertDefinedAndNotNull)(value, "missing value");
                return {
                    description: {
                        moniker: description.moniker,
                        identity: description.identity,
                        website: description.website,
                        security_contact: description.securityContact,
                        details: description.details
                    },
                    commission: {
                        rate: commission.rate,
                        max_rate: commission.maxRate,
                        max_change_rate: commission.maxChangeRate
                    },
                    min_self_delegation: minSelfDelegation,
                    delegator_address: delegatorAddress,
                    validator_address: validatorAddress,
                    pubkey: (0, $111142153d5adf1c$exports.encodeBech32Pubkey)({
                        type: "tendermint/PubKeySecp256k1",
                        value: (0, $5zb9p.toBase64)(pubkey.value)
                    }, prefix),
                    value: value
                };
            },
            fromAmino: ({ description: description, commission: commission, min_self_delegation: min_self_delegation, delegator_address: delegator_address, validator_address: validator_address, pubkey: pubkey, value: value })=>{
                const decodedPubkey = (0, $111142153d5adf1c$exports.decodeBech32Pubkey)(pubkey);
                if (decodedPubkey.type !== "tendermint/PubKeySecp256k1") throw new Error("Only Secp256k1 public keys are supported");
                return {
                    description: {
                        moniker: description.moniker,
                        identity: description.identity,
                        website: description.website,
                        securityContact: description.security_contact,
                        details: description.details
                    },
                    commission: {
                        rate: commission.rate,
                        maxRate: commission.max_rate,
                        maxChangeRate: commission.max_change_rate
                    },
                    minSelfDelegation: min_self_delegation,
                    delegatorAddress: delegator_address,
                    validatorAddress: validator_address,
                    pubkey: {
                        typeUrl: "/cosmos.crypto.secp256k1.PubKey",
                        value: (0, $5zb9p.fromBase64)(decodedPubkey.value)
                    },
                    value: value
                };
            }
        },
        "/cosmos.staking.v1beta1.MsgDelegate": {
            aminoType: "cosmos-sdk/MsgDelegate",
            toAmino: ({ delegatorAddress: delegatorAddress, validatorAddress: validatorAddress, amount: amount })=>{
                (0, $F6P8J.assertDefinedAndNotNull)(amount, "missing amount");
                return {
                    delegator_address: delegatorAddress,
                    validator_address: validatorAddress,
                    amount: amount
                };
            },
            fromAmino: ({ delegator_address: delegator_address, validator_address: validator_address, amount: amount })=>({
                    delegatorAddress: delegator_address,
                    validatorAddress: validator_address,
                    amount: amount
                })
        },
        "/cosmos.staking.v1beta1.MsgEditValidator": {
            aminoType: "cosmos-sdk/MsgEditValidator",
            toAmino: ({ description: description, commissionRate: commissionRate, minSelfDelegation: minSelfDelegation, validatorAddress: validatorAddress })=>{
                (0, $F6P8J.assertDefinedAndNotNull)(description, "missing description");
                return {
                    description: {
                        moniker: description.moniker,
                        identity: description.identity,
                        website: description.website,
                        security_contact: description.securityContact,
                        details: description.details
                    },
                    commission_rate: commissionRate,
                    min_self_delegation: minSelfDelegation,
                    validator_address: validatorAddress
                };
            },
            fromAmino: ({ description: description, commission_rate: commission_rate, min_self_delegation: min_self_delegation, validator_address: validator_address })=>({
                    description: {
                        moniker: description.moniker,
                        identity: description.identity,
                        website: description.website,
                        securityContact: description.security_contact,
                        details: description.details
                    },
                    commissionRate: commission_rate,
                    minSelfDelegation: min_self_delegation,
                    validatorAddress: validator_address
                })
        },
        "/cosmos.staking.v1beta1.MsgUndelegate": {
            aminoType: "cosmos-sdk/MsgUndelegate",
            toAmino: ({ delegatorAddress: delegatorAddress, validatorAddress: validatorAddress, amount: amount })=>{
                (0, $F6P8J.assertDefinedAndNotNull)(amount, "missing amount");
                return {
                    delegator_address: delegatorAddress,
                    validator_address: validatorAddress,
                    amount: amount
                };
            },
            fromAmino: ({ delegator_address: delegator_address, validator_address: validator_address, amount: amount })=>({
                    delegatorAddress: delegator_address,
                    validatorAddress: validator_address,
                    amount: amount
                })
        }
    };
}
$60fd337025b45544$exports.createStakingAminoConverters = $60fd337025b45544$var$createStakingAminoConverters;


Object.defineProperty($7725f2e3ca016b52$exports, "createStakingAminoConverters", {
    enumerable: true,
    get: function() {
        return $60fd337025b45544$exports.createStakingAminoConverters;
    }
});
Object.defineProperty($7725f2e3ca016b52$exports, "isAminoMsgBeginRedelegate", {
    enumerable: true,
    get: function() {
        return $60fd337025b45544$exports.isAminoMsgBeginRedelegate;
    }
});
Object.defineProperty($7725f2e3ca016b52$exports, "isAminoMsgCreateValidator", {
    enumerable: true,
    get: function() {
        return $60fd337025b45544$exports.isAminoMsgCreateValidator;
    }
});
Object.defineProperty($7725f2e3ca016b52$exports, "isAminoMsgDelegate", {
    enumerable: true,
    get: function() {
        return $60fd337025b45544$exports.isAminoMsgDelegate;
    }
});
Object.defineProperty($7725f2e3ca016b52$exports, "isAminoMsgEditValidator", {
    enumerable: true,
    get: function() {
        return $60fd337025b45544$exports.isAminoMsgEditValidator;
    }
});
Object.defineProperty($7725f2e3ca016b52$exports, "isAminoMsgUndelegate", {
    enumerable: true,
    get: function() {
        return $60fd337025b45544$exports.isAminoMsgUndelegate;
    }
});
var $e390e8698d1c9020$exports = {};
"use strict";
Object.defineProperty($e390e8698d1c9020$exports, "__esModule", {
    value: true
});
$e390e8698d1c9020$exports.isMsgUndelegateEncodeObject = $e390e8698d1c9020$exports.isMsgDelegateEncodeObject = $e390e8698d1c9020$exports.stakingTypes = void 0;
var $0000c3e2167efb84$exports = {};
"use strict";
var $0000c3e2167efb84$var$__importDefault = $0000c3e2167efb84$exports && $0000c3e2167efb84$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($0000c3e2167efb84$exports, "__esModule", {
    value: true
});
$0000c3e2167efb84$exports.MsgClientImpl = $0000c3e2167efb84$exports.MsgUndelegateResponse = $0000c3e2167efb84$exports.MsgUndelegate = $0000c3e2167efb84$exports.MsgBeginRedelegateResponse = $0000c3e2167efb84$exports.MsgBeginRedelegate = $0000c3e2167efb84$exports.MsgDelegateResponse = $0000c3e2167efb84$exports.MsgDelegate = $0000c3e2167efb84$exports.MsgEditValidatorResponse = $0000c3e2167efb84$exports.MsgEditValidator = $0000c3e2167efb84$exports.MsgCreateValidatorResponse = $0000c3e2167efb84$exports.MsgCreateValidator = $0000c3e2167efb84$exports.protobufPackage = void 0;

/* eslint-disable */ const $0000c3e2167efb84$var$long_1 = $0000c3e2167efb84$var$__importDefault((parcelRequire("9A55m")));

const $0000c3e2167efb84$var$minimal_1 = $0000c3e2167efb84$var$__importDefault((parcelRequire("i2pIU")));
var $73d6a52fa40919be$exports = {};
"use strict";
var $73d6a52fa40919be$var$__importDefault = $73d6a52fa40919be$exports && $73d6a52fa40919be$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($73d6a52fa40919be$exports, "__esModule", {
    value: true
});
$73d6a52fa40919be$exports.Pool = $73d6a52fa40919be$exports.RedelegationResponse = $73d6a52fa40919be$exports.RedelegationEntryResponse = $73d6a52fa40919be$exports.DelegationResponse = $73d6a52fa40919be$exports.Params = $73d6a52fa40919be$exports.Redelegation = $73d6a52fa40919be$exports.RedelegationEntry = $73d6a52fa40919be$exports.UnbondingDelegationEntry = $73d6a52fa40919be$exports.UnbondingDelegation = $73d6a52fa40919be$exports.Delegation = $73d6a52fa40919be$exports.DVVTriplets = $73d6a52fa40919be$exports.DVVTriplet = $73d6a52fa40919be$exports.DVPairs = $73d6a52fa40919be$exports.DVPair = $73d6a52fa40919be$exports.ValAddresses = $73d6a52fa40919be$exports.Validator = $73d6a52fa40919be$exports.Description = $73d6a52fa40919be$exports.Commission = $73d6a52fa40919be$exports.CommissionRates = $73d6a52fa40919be$exports.HistoricalInfo = $73d6a52fa40919be$exports.bondStatusToJSON = $73d6a52fa40919be$exports.bondStatusFromJSON = $73d6a52fa40919be$exports.BondStatus = $73d6a52fa40919be$exports.protobufPackage = void 0;

/* eslint-disable */ const $73d6a52fa40919be$var$long_1 = $73d6a52fa40919be$var$__importDefault((parcelRequire("9A55m")));

const $73d6a52fa40919be$var$minimal_1 = $73d6a52fa40919be$var$__importDefault((parcelRequire("i2pIU")));





$73d6a52fa40919be$exports.protobufPackage = "cosmos.staking.v1beta1";
/** BondStatus is the status of a validator. */ var $73d6a52fa40919be$var$BondStatus;
(function(BondStatus) {
    /** BOND_STATUS_UNSPECIFIED - UNSPECIFIED defines an invalid validator status. */ BondStatus[BondStatus["BOND_STATUS_UNSPECIFIED"] = 0] = "BOND_STATUS_UNSPECIFIED";
    /** BOND_STATUS_UNBONDED - UNBONDED defines a validator that is not bonded. */ BondStatus[BondStatus["BOND_STATUS_UNBONDED"] = 1] = "BOND_STATUS_UNBONDED";
    /** BOND_STATUS_UNBONDING - UNBONDING defines a validator that is unbonding. */ BondStatus[BondStatus["BOND_STATUS_UNBONDING"] = 2] = "BOND_STATUS_UNBONDING";
    /** BOND_STATUS_BONDED - BONDED defines a validator that is bonded. */ BondStatus[BondStatus["BOND_STATUS_BONDED"] = 3] = "BOND_STATUS_BONDED";
    BondStatus[BondStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($73d6a52fa40919be$var$BondStatus = $73d6a52fa40919be$exports.BondStatus || ($73d6a52fa40919be$exports.BondStatus = {}));
function $73d6a52fa40919be$var$bondStatusFromJSON(object) {
    switch(object){
        case 0:
        case "BOND_STATUS_UNSPECIFIED":
            return $73d6a52fa40919be$var$BondStatus.BOND_STATUS_UNSPECIFIED;
        case 1:
        case "BOND_STATUS_UNBONDED":
            return $73d6a52fa40919be$var$BondStatus.BOND_STATUS_UNBONDED;
        case 2:
        case "BOND_STATUS_UNBONDING":
            return $73d6a52fa40919be$var$BondStatus.BOND_STATUS_UNBONDING;
        case 3:
        case "BOND_STATUS_BONDED":
            return $73d6a52fa40919be$var$BondStatus.BOND_STATUS_BONDED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $73d6a52fa40919be$var$BondStatus.UNRECOGNIZED;
    }
}
$73d6a52fa40919be$exports.bondStatusFromJSON = $73d6a52fa40919be$var$bondStatusFromJSON;
function $73d6a52fa40919be$var$bondStatusToJSON(object) {
    switch(object){
        case $73d6a52fa40919be$var$BondStatus.BOND_STATUS_UNSPECIFIED:
            return "BOND_STATUS_UNSPECIFIED";
        case $73d6a52fa40919be$var$BondStatus.BOND_STATUS_UNBONDED:
            return "BOND_STATUS_UNBONDED";
        case $73d6a52fa40919be$var$BondStatus.BOND_STATUS_UNBONDING:
            return "BOND_STATUS_UNBONDING";
        case $73d6a52fa40919be$var$BondStatus.BOND_STATUS_BONDED:
            return "BOND_STATUS_BONDED";
        default:
            return "UNKNOWN";
    }
}
$73d6a52fa40919be$exports.bondStatusToJSON = $73d6a52fa40919be$var$bondStatusToJSON;
const $73d6a52fa40919be$var$baseHistoricalInfo = {};
$73d6a52fa40919be$exports.HistoricalInfo = {
    encode (message, writer = $73d6a52fa40919be$var$minimal_1.default.Writer.create()) {
        if (message.header !== undefined) $0aefc245ff398d69$exports.Header.encode(message.header, writer.uint32(10).fork()).ldelim();
        for (const v of message.valset)$73d6a52fa40919be$exports.Validator.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $73d6a52fa40919be$var$minimal_1.default.Reader ? input : new $73d6a52fa40919be$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $73d6a52fa40919be$var$baseHistoricalInfo);
        message.valset = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.header = $0aefc245ff398d69$exports.Header.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.valset.push($73d6a52fa40919be$exports.Validator.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $73d6a52fa40919be$var$baseHistoricalInfo);
        message.header = object.header !== undefined && object.header !== null ? $0aefc245ff398d69$exports.Header.fromJSON(object.header) : undefined;
        message.valset = ((_a = object.valset) !== null && _a !== void 0 ? _a : []).map((e)=>$73d6a52fa40919be$exports.Validator.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.header !== undefined && (obj.header = message.header ? $0aefc245ff398d69$exports.Header.toJSON(message.header) : undefined);
        if (message.valset) obj.valset = message.valset.map((e)=>e ? $73d6a52fa40919be$exports.Validator.toJSON(e) : undefined);
        else obj.valset = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $73d6a52fa40919be$var$baseHistoricalInfo);
        message.header = object.header !== undefined && object.header !== null ? $0aefc245ff398d69$exports.Header.fromPartial(object.header) : undefined;
        message.valset = ((_a = object.valset) === null || _a === void 0 ? void 0 : _a.map((e)=>$73d6a52fa40919be$exports.Validator.fromPartial(e))) || [];
        return message;
    }
};
const $73d6a52fa40919be$var$baseCommissionRates = {
    rate: "",
    maxRate: "",
    maxChangeRate: ""
};
$73d6a52fa40919be$exports.CommissionRates = {
    encode (message, writer = $73d6a52fa40919be$var$minimal_1.default.Writer.create()) {
        if (message.rate !== "") writer.uint32(10).string(message.rate);
        if (message.maxRate !== "") writer.uint32(18).string(message.maxRate);
        if (message.maxChangeRate !== "") writer.uint32(26).string(message.maxChangeRate);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $73d6a52fa40919be$var$minimal_1.default.Reader ? input : new $73d6a52fa40919be$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $73d6a52fa40919be$var$baseCommissionRates);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.rate = reader.string();
                    break;
                case 2:
                    message.maxRate = reader.string();
                    break;
                case 3:
                    message.maxChangeRate = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $73d6a52fa40919be$var$baseCommissionRates);
        message.rate = object.rate !== undefined && object.rate !== null ? String(object.rate) : "";
        message.maxRate = object.maxRate !== undefined && object.maxRate !== null ? String(object.maxRate) : "";
        message.maxChangeRate = object.maxChangeRate !== undefined && object.maxChangeRate !== null ? String(object.maxChangeRate) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.rate !== undefined && (obj.rate = message.rate);
        message.maxRate !== undefined && (obj.maxRate = message.maxRate);
        message.maxChangeRate !== undefined && (obj.maxChangeRate = message.maxChangeRate);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $73d6a52fa40919be$var$baseCommissionRates);
        message.rate = (_a = object.rate) !== null && _a !== void 0 ? _a : "";
        message.maxRate = (_b = object.maxRate) !== null && _b !== void 0 ? _b : "";
        message.maxChangeRate = (_c = object.maxChangeRate) !== null && _c !== void 0 ? _c : "";
        return message;
    }
};
const $73d6a52fa40919be$var$baseCommission = {};
$73d6a52fa40919be$exports.Commission = {
    encode (message, writer = $73d6a52fa40919be$var$minimal_1.default.Writer.create()) {
        if (message.commissionRates !== undefined) $73d6a52fa40919be$exports.CommissionRates.encode(message.commissionRates, writer.uint32(10).fork()).ldelim();
        if (message.updateTime !== undefined) $d6c3291d6aa8eb5b$exports.Timestamp.encode(message.updateTime, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $73d6a52fa40919be$var$minimal_1.default.Reader ? input : new $73d6a52fa40919be$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $73d6a52fa40919be$var$baseCommission);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.commissionRates = $73d6a52fa40919be$exports.CommissionRates.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.updateTime = $d6c3291d6aa8eb5b$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $73d6a52fa40919be$var$baseCommission);
        message.commissionRates = object.commissionRates !== undefined && object.commissionRates !== null ? $73d6a52fa40919be$exports.CommissionRates.fromJSON(object.commissionRates) : undefined;
        message.updateTime = object.updateTime !== undefined && object.updateTime !== null ? $73d6a52fa40919be$var$fromJsonTimestamp(object.updateTime) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.commissionRates !== undefined && (obj.commissionRates = message.commissionRates ? $73d6a52fa40919be$exports.CommissionRates.toJSON(message.commissionRates) : undefined);
        message.updateTime !== undefined && (obj.updateTime = $73d6a52fa40919be$var$fromTimestamp(message.updateTime).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $73d6a52fa40919be$var$baseCommission);
        message.commissionRates = object.commissionRates !== undefined && object.commissionRates !== null ? $73d6a52fa40919be$exports.CommissionRates.fromPartial(object.commissionRates) : undefined;
        message.updateTime = object.updateTime !== undefined && object.updateTime !== null ? $d6c3291d6aa8eb5b$exports.Timestamp.fromPartial(object.updateTime) : undefined;
        return message;
    }
};
const $73d6a52fa40919be$var$baseDescription = {
    moniker: "",
    identity: "",
    website: "",
    securityContact: "",
    details: ""
};
$73d6a52fa40919be$exports.Description = {
    encode (message, writer = $73d6a52fa40919be$var$minimal_1.default.Writer.create()) {
        if (message.moniker !== "") writer.uint32(10).string(message.moniker);
        if (message.identity !== "") writer.uint32(18).string(message.identity);
        if (message.website !== "") writer.uint32(26).string(message.website);
        if (message.securityContact !== "") writer.uint32(34).string(message.securityContact);
        if (message.details !== "") writer.uint32(42).string(message.details);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $73d6a52fa40919be$var$minimal_1.default.Reader ? input : new $73d6a52fa40919be$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $73d6a52fa40919be$var$baseDescription);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.moniker = reader.string();
                    break;
                case 2:
                    message.identity = reader.string();
                    break;
                case 3:
                    message.website = reader.string();
                    break;
                case 4:
                    message.securityContact = reader.string();
                    break;
                case 5:
                    message.details = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $73d6a52fa40919be$var$baseDescription);
        message.moniker = object.moniker !== undefined && object.moniker !== null ? String(object.moniker) : "";
        message.identity = object.identity !== undefined && object.identity !== null ? String(object.identity) : "";
        message.website = object.website !== undefined && object.website !== null ? String(object.website) : "";
        message.securityContact = object.securityContact !== undefined && object.securityContact !== null ? String(object.securityContact) : "";
        message.details = object.details !== undefined && object.details !== null ? String(object.details) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.moniker !== undefined && (obj.moniker = message.moniker);
        message.identity !== undefined && (obj.identity = message.identity);
        message.website !== undefined && (obj.website = message.website);
        message.securityContact !== undefined && (obj.securityContact = message.securityContact);
        message.details !== undefined && (obj.details = message.details);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e;
        const message = Object.assign({}, $73d6a52fa40919be$var$baseDescription);
        message.moniker = (_a = object.moniker) !== null && _a !== void 0 ? _a : "";
        message.identity = (_b = object.identity) !== null && _b !== void 0 ? _b : "";
        message.website = (_c = object.website) !== null && _c !== void 0 ? _c : "";
        message.securityContact = (_d = object.securityContact) !== null && _d !== void 0 ? _d : "";
        message.details = (_e = object.details) !== null && _e !== void 0 ? _e : "";
        return message;
    }
};
const $73d6a52fa40919be$var$baseValidator = {
    operatorAddress: "",
    jailed: false,
    status: 0,
    tokens: "",
    delegatorShares: "",
    unbondingHeight: $73d6a52fa40919be$var$long_1.default.ZERO,
    minSelfDelegation: ""
};
$73d6a52fa40919be$exports.Validator = {
    encode (message, writer = $73d6a52fa40919be$var$minimal_1.default.Writer.create()) {
        if (message.operatorAddress !== "") writer.uint32(10).string(message.operatorAddress);
        if (message.consensusPubkey !== undefined) $4232fce010c3a46b$exports.Any.encode(message.consensusPubkey, writer.uint32(18).fork()).ldelim();
        if (message.jailed === true) writer.uint32(24).bool(message.jailed);
        if (message.status !== 0) writer.uint32(32).int32(message.status);
        if (message.tokens !== "") writer.uint32(42).string(message.tokens);
        if (message.delegatorShares !== "") writer.uint32(50).string(message.delegatorShares);
        if (message.description !== undefined) $73d6a52fa40919be$exports.Description.encode(message.description, writer.uint32(58).fork()).ldelim();
        if (!message.unbondingHeight.isZero()) writer.uint32(64).int64(message.unbondingHeight);
        if (message.unbondingTime !== undefined) $d6c3291d6aa8eb5b$exports.Timestamp.encode(message.unbondingTime, writer.uint32(74).fork()).ldelim();
        if (message.commission !== undefined) $73d6a52fa40919be$exports.Commission.encode(message.commission, writer.uint32(82).fork()).ldelim();
        if (message.minSelfDelegation !== "") writer.uint32(90).string(message.minSelfDelegation);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $73d6a52fa40919be$var$minimal_1.default.Reader ? input : new $73d6a52fa40919be$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $73d6a52fa40919be$var$baseValidator);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.operatorAddress = reader.string();
                    break;
                case 2:
                    message.consensusPubkey = $4232fce010c3a46b$exports.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.jailed = reader.bool();
                    break;
                case 4:
                    message.status = reader.int32();
                    break;
                case 5:
                    message.tokens = reader.string();
                    break;
                case 6:
                    message.delegatorShares = reader.string();
                    break;
                case 7:
                    message.description = $73d6a52fa40919be$exports.Description.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.unbondingHeight = reader.int64();
                    break;
                case 9:
                    message.unbondingTime = $d6c3291d6aa8eb5b$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.commission = $73d6a52fa40919be$exports.Commission.decode(reader, reader.uint32());
                    break;
                case 11:
                    message.minSelfDelegation = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $73d6a52fa40919be$var$baseValidator);
        message.operatorAddress = object.operatorAddress !== undefined && object.operatorAddress !== null ? String(object.operatorAddress) : "";
        message.consensusPubkey = object.consensusPubkey !== undefined && object.consensusPubkey !== null ? $4232fce010c3a46b$exports.Any.fromJSON(object.consensusPubkey) : undefined;
        message.jailed = object.jailed !== undefined && object.jailed !== null ? Boolean(object.jailed) : false;
        message.status = object.status !== undefined && object.status !== null ? $73d6a52fa40919be$var$bondStatusFromJSON(object.status) : 0;
        message.tokens = object.tokens !== undefined && object.tokens !== null ? String(object.tokens) : "";
        message.delegatorShares = object.delegatorShares !== undefined && object.delegatorShares !== null ? String(object.delegatorShares) : "";
        message.description = object.description !== undefined && object.description !== null ? $73d6a52fa40919be$exports.Description.fromJSON(object.description) : undefined;
        message.unbondingHeight = object.unbondingHeight !== undefined && object.unbondingHeight !== null ? $73d6a52fa40919be$var$long_1.default.fromString(object.unbondingHeight) : $73d6a52fa40919be$var$long_1.default.ZERO;
        message.unbondingTime = object.unbondingTime !== undefined && object.unbondingTime !== null ? $73d6a52fa40919be$var$fromJsonTimestamp(object.unbondingTime) : undefined;
        message.commission = object.commission !== undefined && object.commission !== null ? $73d6a52fa40919be$exports.Commission.fromJSON(object.commission) : undefined;
        message.minSelfDelegation = object.minSelfDelegation !== undefined && object.minSelfDelegation !== null ? String(object.minSelfDelegation) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.operatorAddress !== undefined && (obj.operatorAddress = message.operatorAddress);
        message.consensusPubkey !== undefined && (obj.consensusPubkey = message.consensusPubkey ? $4232fce010c3a46b$exports.Any.toJSON(message.consensusPubkey) : undefined);
        message.jailed !== undefined && (obj.jailed = message.jailed);
        message.status !== undefined && (obj.status = $73d6a52fa40919be$var$bondStatusToJSON(message.status));
        message.tokens !== undefined && (obj.tokens = message.tokens);
        message.delegatorShares !== undefined && (obj.delegatorShares = message.delegatorShares);
        message.description !== undefined && (obj.description = message.description ? $73d6a52fa40919be$exports.Description.toJSON(message.description) : undefined);
        message.unbondingHeight !== undefined && (obj.unbondingHeight = (message.unbondingHeight || $73d6a52fa40919be$var$long_1.default.ZERO).toString());
        message.unbondingTime !== undefined && (obj.unbondingTime = $73d6a52fa40919be$var$fromTimestamp(message.unbondingTime).toISOString());
        message.commission !== undefined && (obj.commission = message.commission ? $73d6a52fa40919be$exports.Commission.toJSON(message.commission) : undefined);
        message.minSelfDelegation !== undefined && (obj.minSelfDelegation = message.minSelfDelegation);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e, _f;
        const message = Object.assign({}, $73d6a52fa40919be$var$baseValidator);
        message.operatorAddress = (_a = object.operatorAddress) !== null && _a !== void 0 ? _a : "";
        message.consensusPubkey = object.consensusPubkey !== undefined && object.consensusPubkey !== null ? $4232fce010c3a46b$exports.Any.fromPartial(object.consensusPubkey) : undefined;
        message.jailed = (_b = object.jailed) !== null && _b !== void 0 ? _b : false;
        message.status = (_c = object.status) !== null && _c !== void 0 ? _c : 0;
        message.tokens = (_d = object.tokens) !== null && _d !== void 0 ? _d : "";
        message.delegatorShares = (_e = object.delegatorShares) !== null && _e !== void 0 ? _e : "";
        message.description = object.description !== undefined && object.description !== null ? $73d6a52fa40919be$exports.Description.fromPartial(object.description) : undefined;
        message.unbondingHeight = object.unbondingHeight !== undefined && object.unbondingHeight !== null ? $73d6a52fa40919be$var$long_1.default.fromValue(object.unbondingHeight) : $73d6a52fa40919be$var$long_1.default.ZERO;
        message.unbondingTime = object.unbondingTime !== undefined && object.unbondingTime !== null ? $d6c3291d6aa8eb5b$exports.Timestamp.fromPartial(object.unbondingTime) : undefined;
        message.commission = object.commission !== undefined && object.commission !== null ? $73d6a52fa40919be$exports.Commission.fromPartial(object.commission) : undefined;
        message.minSelfDelegation = (_f = object.minSelfDelegation) !== null && _f !== void 0 ? _f : "";
        return message;
    }
};
const $73d6a52fa40919be$var$baseValAddresses = {
    addresses: ""
};
$73d6a52fa40919be$exports.ValAddresses = {
    encode (message, writer = $73d6a52fa40919be$var$minimal_1.default.Writer.create()) {
        for (const v of message.addresses)writer.uint32(10).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $73d6a52fa40919be$var$minimal_1.default.Reader ? input : new $73d6a52fa40919be$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $73d6a52fa40919be$var$baseValAddresses);
        message.addresses = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.addresses.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $73d6a52fa40919be$var$baseValAddresses);
        message.addresses = ((_a = object.addresses) !== null && _a !== void 0 ? _a : []).map((e)=>String(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.addresses) obj.addresses = message.addresses.map((e)=>e);
        else obj.addresses = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $73d6a52fa40919be$var$baseValAddresses);
        message.addresses = ((_a = object.addresses) === null || _a === void 0 ? void 0 : _a.map((e)=>e)) || [];
        return message;
    }
};
const $73d6a52fa40919be$var$baseDVPair = {
    delegatorAddress: "",
    validatorAddress: ""
};
$73d6a52fa40919be$exports.DVPair = {
    encode (message, writer = $73d6a52fa40919be$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $73d6a52fa40919be$var$minimal_1.default.Reader ? input : new $73d6a52fa40919be$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $73d6a52fa40919be$var$baseDVPair);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $73d6a52fa40919be$var$baseDVPair);
        message.delegatorAddress = object.delegatorAddress !== undefined && object.delegatorAddress !== null ? String(object.delegatorAddress) : "";
        message.validatorAddress = object.validatorAddress !== undefined && object.validatorAddress !== null ? String(object.validatorAddress) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $73d6a52fa40919be$var$baseDVPair);
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorAddress = (_b = object.validatorAddress) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
const $73d6a52fa40919be$var$baseDVPairs = {};
$73d6a52fa40919be$exports.DVPairs = {
    encode (message, writer = $73d6a52fa40919be$var$minimal_1.default.Writer.create()) {
        for (const v of message.pairs)$73d6a52fa40919be$exports.DVPair.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $73d6a52fa40919be$var$minimal_1.default.Reader ? input : new $73d6a52fa40919be$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $73d6a52fa40919be$var$baseDVPairs);
        message.pairs = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pairs.push($73d6a52fa40919be$exports.DVPair.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $73d6a52fa40919be$var$baseDVPairs);
        message.pairs = ((_a = object.pairs) !== null && _a !== void 0 ? _a : []).map((e)=>$73d6a52fa40919be$exports.DVPair.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.pairs) obj.pairs = message.pairs.map((e)=>e ? $73d6a52fa40919be$exports.DVPair.toJSON(e) : undefined);
        else obj.pairs = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $73d6a52fa40919be$var$baseDVPairs);
        message.pairs = ((_a = object.pairs) === null || _a === void 0 ? void 0 : _a.map((e)=>$73d6a52fa40919be$exports.DVPair.fromPartial(e))) || [];
        return message;
    }
};
const $73d6a52fa40919be$var$baseDVVTriplet = {
    delegatorAddress: "",
    validatorSrcAddress: "",
    validatorDstAddress: ""
};
$73d6a52fa40919be$exports.DVVTriplet = {
    encode (message, writer = $73d6a52fa40919be$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorSrcAddress !== "") writer.uint32(18).string(message.validatorSrcAddress);
        if (message.validatorDstAddress !== "") writer.uint32(26).string(message.validatorDstAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $73d6a52fa40919be$var$minimal_1.default.Reader ? input : new $73d6a52fa40919be$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $73d6a52fa40919be$var$baseDVVTriplet);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorSrcAddress = reader.string();
                    break;
                case 3:
                    message.validatorDstAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $73d6a52fa40919be$var$baseDVVTriplet);
        message.delegatorAddress = object.delegatorAddress !== undefined && object.delegatorAddress !== null ? String(object.delegatorAddress) : "";
        message.validatorSrcAddress = object.validatorSrcAddress !== undefined && object.validatorSrcAddress !== null ? String(object.validatorSrcAddress) : "";
        message.validatorDstAddress = object.validatorDstAddress !== undefined && object.validatorDstAddress !== null ? String(object.validatorDstAddress) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorSrcAddress !== undefined && (obj.validatorSrcAddress = message.validatorSrcAddress);
        message.validatorDstAddress !== undefined && (obj.validatorDstAddress = message.validatorDstAddress);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $73d6a52fa40919be$var$baseDVVTriplet);
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorSrcAddress = (_b = object.validatorSrcAddress) !== null && _b !== void 0 ? _b : "";
        message.validatorDstAddress = (_c = object.validatorDstAddress) !== null && _c !== void 0 ? _c : "";
        return message;
    }
};
const $73d6a52fa40919be$var$baseDVVTriplets = {};
$73d6a52fa40919be$exports.DVVTriplets = {
    encode (message, writer = $73d6a52fa40919be$var$minimal_1.default.Writer.create()) {
        for (const v of message.triplets)$73d6a52fa40919be$exports.DVVTriplet.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $73d6a52fa40919be$var$minimal_1.default.Reader ? input : new $73d6a52fa40919be$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $73d6a52fa40919be$var$baseDVVTriplets);
        message.triplets = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.triplets.push($73d6a52fa40919be$exports.DVVTriplet.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $73d6a52fa40919be$var$baseDVVTriplets);
        message.triplets = ((_a = object.triplets) !== null && _a !== void 0 ? _a : []).map((e)=>$73d6a52fa40919be$exports.DVVTriplet.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.triplets) obj.triplets = message.triplets.map((e)=>e ? $73d6a52fa40919be$exports.DVVTriplet.toJSON(e) : undefined);
        else obj.triplets = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $73d6a52fa40919be$var$baseDVVTriplets);
        message.triplets = ((_a = object.triplets) === null || _a === void 0 ? void 0 : _a.map((e)=>$73d6a52fa40919be$exports.DVVTriplet.fromPartial(e))) || [];
        return message;
    }
};
const $73d6a52fa40919be$var$baseDelegation = {
    delegatorAddress: "",
    validatorAddress: "",
    shares: ""
};
$73d6a52fa40919be$exports.Delegation = {
    encode (message, writer = $73d6a52fa40919be$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        if (message.shares !== "") writer.uint32(26).string(message.shares);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $73d6a52fa40919be$var$minimal_1.default.Reader ? input : new $73d6a52fa40919be$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $73d6a52fa40919be$var$baseDelegation);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.shares = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $73d6a52fa40919be$var$baseDelegation);
        message.delegatorAddress = object.delegatorAddress !== undefined && object.delegatorAddress !== null ? String(object.delegatorAddress) : "";
        message.validatorAddress = object.validatorAddress !== undefined && object.validatorAddress !== null ? String(object.validatorAddress) : "";
        message.shares = object.shares !== undefined && object.shares !== null ? String(object.shares) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.shares !== undefined && (obj.shares = message.shares);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $73d6a52fa40919be$var$baseDelegation);
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorAddress = (_b = object.validatorAddress) !== null && _b !== void 0 ? _b : "";
        message.shares = (_c = object.shares) !== null && _c !== void 0 ? _c : "";
        return message;
    }
};
const $73d6a52fa40919be$var$baseUnbondingDelegation = {
    delegatorAddress: "",
    validatorAddress: ""
};
$73d6a52fa40919be$exports.UnbondingDelegation = {
    encode (message, writer = $73d6a52fa40919be$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        for (const v of message.entries)$73d6a52fa40919be$exports.UnbondingDelegationEntry.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $73d6a52fa40919be$var$minimal_1.default.Reader ? input : new $73d6a52fa40919be$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $73d6a52fa40919be$var$baseUnbondingDelegation);
        message.entries = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.entries.push($73d6a52fa40919be$exports.UnbondingDelegationEntry.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $73d6a52fa40919be$var$baseUnbondingDelegation);
        message.delegatorAddress = object.delegatorAddress !== undefined && object.delegatorAddress !== null ? String(object.delegatorAddress) : "";
        message.validatorAddress = object.validatorAddress !== undefined && object.validatorAddress !== null ? String(object.validatorAddress) : "";
        message.entries = ((_a = object.entries) !== null && _a !== void 0 ? _a : []).map((e)=>$73d6a52fa40919be$exports.UnbondingDelegationEntry.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        if (message.entries) obj.entries = message.entries.map((e)=>e ? $73d6a52fa40919be$exports.UnbondingDelegationEntry.toJSON(e) : undefined);
        else obj.entries = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $73d6a52fa40919be$var$baseUnbondingDelegation);
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorAddress = (_b = object.validatorAddress) !== null && _b !== void 0 ? _b : "";
        message.entries = ((_c = object.entries) === null || _c === void 0 ? void 0 : _c.map((e)=>$73d6a52fa40919be$exports.UnbondingDelegationEntry.fromPartial(e))) || [];
        return message;
    }
};
const $73d6a52fa40919be$var$baseUnbondingDelegationEntry = {
    creationHeight: $73d6a52fa40919be$var$long_1.default.ZERO,
    initialBalance: "",
    balance: ""
};
$73d6a52fa40919be$exports.UnbondingDelegationEntry = {
    encode (message, writer = $73d6a52fa40919be$var$minimal_1.default.Writer.create()) {
        if (!message.creationHeight.isZero()) writer.uint32(8).int64(message.creationHeight);
        if (message.completionTime !== undefined) $d6c3291d6aa8eb5b$exports.Timestamp.encode(message.completionTime, writer.uint32(18).fork()).ldelim();
        if (message.initialBalance !== "") writer.uint32(26).string(message.initialBalance);
        if (message.balance !== "") writer.uint32(34).string(message.balance);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $73d6a52fa40919be$var$minimal_1.default.Reader ? input : new $73d6a52fa40919be$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $73d6a52fa40919be$var$baseUnbondingDelegationEntry);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.creationHeight = reader.int64();
                    break;
                case 2:
                    message.completionTime = $d6c3291d6aa8eb5b$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.initialBalance = reader.string();
                    break;
                case 4:
                    message.balance = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $73d6a52fa40919be$var$baseUnbondingDelegationEntry);
        message.creationHeight = object.creationHeight !== undefined && object.creationHeight !== null ? $73d6a52fa40919be$var$long_1.default.fromString(object.creationHeight) : $73d6a52fa40919be$var$long_1.default.ZERO;
        message.completionTime = object.completionTime !== undefined && object.completionTime !== null ? $73d6a52fa40919be$var$fromJsonTimestamp(object.completionTime) : undefined;
        message.initialBalance = object.initialBalance !== undefined && object.initialBalance !== null ? String(object.initialBalance) : "";
        message.balance = object.balance !== undefined && object.balance !== null ? String(object.balance) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.creationHeight !== undefined && (obj.creationHeight = (message.creationHeight || $73d6a52fa40919be$var$long_1.default.ZERO).toString());
        message.completionTime !== undefined && (obj.completionTime = $73d6a52fa40919be$var$fromTimestamp(message.completionTime).toISOString());
        message.initialBalance !== undefined && (obj.initialBalance = message.initialBalance);
        message.balance !== undefined && (obj.balance = message.balance);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $73d6a52fa40919be$var$baseUnbondingDelegationEntry);
        message.creationHeight = object.creationHeight !== undefined && object.creationHeight !== null ? $73d6a52fa40919be$var$long_1.default.fromValue(object.creationHeight) : $73d6a52fa40919be$var$long_1.default.ZERO;
        message.completionTime = object.completionTime !== undefined && object.completionTime !== null ? $d6c3291d6aa8eb5b$exports.Timestamp.fromPartial(object.completionTime) : undefined;
        message.initialBalance = (_a = object.initialBalance) !== null && _a !== void 0 ? _a : "";
        message.balance = (_b = object.balance) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
const $73d6a52fa40919be$var$baseRedelegationEntry = {
    creationHeight: $73d6a52fa40919be$var$long_1.default.ZERO,
    initialBalance: "",
    sharesDst: ""
};
$73d6a52fa40919be$exports.RedelegationEntry = {
    encode (message, writer = $73d6a52fa40919be$var$minimal_1.default.Writer.create()) {
        if (!message.creationHeight.isZero()) writer.uint32(8).int64(message.creationHeight);
        if (message.completionTime !== undefined) $d6c3291d6aa8eb5b$exports.Timestamp.encode(message.completionTime, writer.uint32(18).fork()).ldelim();
        if (message.initialBalance !== "") writer.uint32(26).string(message.initialBalance);
        if (message.sharesDst !== "") writer.uint32(34).string(message.sharesDst);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $73d6a52fa40919be$var$minimal_1.default.Reader ? input : new $73d6a52fa40919be$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $73d6a52fa40919be$var$baseRedelegationEntry);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.creationHeight = reader.int64();
                    break;
                case 2:
                    message.completionTime = $d6c3291d6aa8eb5b$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.initialBalance = reader.string();
                    break;
                case 4:
                    message.sharesDst = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $73d6a52fa40919be$var$baseRedelegationEntry);
        message.creationHeight = object.creationHeight !== undefined && object.creationHeight !== null ? $73d6a52fa40919be$var$long_1.default.fromString(object.creationHeight) : $73d6a52fa40919be$var$long_1.default.ZERO;
        message.completionTime = object.completionTime !== undefined && object.completionTime !== null ? $73d6a52fa40919be$var$fromJsonTimestamp(object.completionTime) : undefined;
        message.initialBalance = object.initialBalance !== undefined && object.initialBalance !== null ? String(object.initialBalance) : "";
        message.sharesDst = object.sharesDst !== undefined && object.sharesDst !== null ? String(object.sharesDst) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.creationHeight !== undefined && (obj.creationHeight = (message.creationHeight || $73d6a52fa40919be$var$long_1.default.ZERO).toString());
        message.completionTime !== undefined && (obj.completionTime = $73d6a52fa40919be$var$fromTimestamp(message.completionTime).toISOString());
        message.initialBalance !== undefined && (obj.initialBalance = message.initialBalance);
        message.sharesDst !== undefined && (obj.sharesDst = message.sharesDst);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $73d6a52fa40919be$var$baseRedelegationEntry);
        message.creationHeight = object.creationHeight !== undefined && object.creationHeight !== null ? $73d6a52fa40919be$var$long_1.default.fromValue(object.creationHeight) : $73d6a52fa40919be$var$long_1.default.ZERO;
        message.completionTime = object.completionTime !== undefined && object.completionTime !== null ? $d6c3291d6aa8eb5b$exports.Timestamp.fromPartial(object.completionTime) : undefined;
        message.initialBalance = (_a = object.initialBalance) !== null && _a !== void 0 ? _a : "";
        message.sharesDst = (_b = object.sharesDst) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
const $73d6a52fa40919be$var$baseRedelegation = {
    delegatorAddress: "",
    validatorSrcAddress: "",
    validatorDstAddress: ""
};
$73d6a52fa40919be$exports.Redelegation = {
    encode (message, writer = $73d6a52fa40919be$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorSrcAddress !== "") writer.uint32(18).string(message.validatorSrcAddress);
        if (message.validatorDstAddress !== "") writer.uint32(26).string(message.validatorDstAddress);
        for (const v of message.entries)$73d6a52fa40919be$exports.RedelegationEntry.encode(v, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $73d6a52fa40919be$var$minimal_1.default.Reader ? input : new $73d6a52fa40919be$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $73d6a52fa40919be$var$baseRedelegation);
        message.entries = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorSrcAddress = reader.string();
                    break;
                case 3:
                    message.validatorDstAddress = reader.string();
                    break;
                case 4:
                    message.entries.push($73d6a52fa40919be$exports.RedelegationEntry.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $73d6a52fa40919be$var$baseRedelegation);
        message.delegatorAddress = object.delegatorAddress !== undefined && object.delegatorAddress !== null ? String(object.delegatorAddress) : "";
        message.validatorSrcAddress = object.validatorSrcAddress !== undefined && object.validatorSrcAddress !== null ? String(object.validatorSrcAddress) : "";
        message.validatorDstAddress = object.validatorDstAddress !== undefined && object.validatorDstAddress !== null ? String(object.validatorDstAddress) : "";
        message.entries = ((_a = object.entries) !== null && _a !== void 0 ? _a : []).map((e)=>$73d6a52fa40919be$exports.RedelegationEntry.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorSrcAddress !== undefined && (obj.validatorSrcAddress = message.validatorSrcAddress);
        message.validatorDstAddress !== undefined && (obj.validatorDstAddress = message.validatorDstAddress);
        if (message.entries) obj.entries = message.entries.map((e)=>e ? $73d6a52fa40919be$exports.RedelegationEntry.toJSON(e) : undefined);
        else obj.entries = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = Object.assign({}, $73d6a52fa40919be$var$baseRedelegation);
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorSrcAddress = (_b = object.validatorSrcAddress) !== null && _b !== void 0 ? _b : "";
        message.validatorDstAddress = (_c = object.validatorDstAddress) !== null && _c !== void 0 ? _c : "";
        message.entries = ((_d = object.entries) === null || _d === void 0 ? void 0 : _d.map((e)=>$73d6a52fa40919be$exports.RedelegationEntry.fromPartial(e))) || [];
        return message;
    }
};
const $73d6a52fa40919be$var$baseParams = {
    maxValidators: 0,
    maxEntries: 0,
    historicalEntries: 0,
    bondDenom: ""
};
$73d6a52fa40919be$exports.Params = {
    encode (message, writer = $73d6a52fa40919be$var$minimal_1.default.Writer.create()) {
        if (message.unbondingTime !== undefined) $ad1f748ecd469446$exports.Duration.encode(message.unbondingTime, writer.uint32(10).fork()).ldelim();
        if (message.maxValidators !== 0) writer.uint32(16).uint32(message.maxValidators);
        if (message.maxEntries !== 0) writer.uint32(24).uint32(message.maxEntries);
        if (message.historicalEntries !== 0) writer.uint32(32).uint32(message.historicalEntries);
        if (message.bondDenom !== "") writer.uint32(42).string(message.bondDenom);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $73d6a52fa40919be$var$minimal_1.default.Reader ? input : new $73d6a52fa40919be$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $73d6a52fa40919be$var$baseParams);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.unbondingTime = $ad1f748ecd469446$exports.Duration.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.maxValidators = reader.uint32();
                    break;
                case 3:
                    message.maxEntries = reader.uint32();
                    break;
                case 4:
                    message.historicalEntries = reader.uint32();
                    break;
                case 5:
                    message.bondDenom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $73d6a52fa40919be$var$baseParams);
        message.unbondingTime = object.unbondingTime !== undefined && object.unbondingTime !== null ? $ad1f748ecd469446$exports.Duration.fromJSON(object.unbondingTime) : undefined;
        message.maxValidators = object.maxValidators !== undefined && object.maxValidators !== null ? Number(object.maxValidators) : 0;
        message.maxEntries = object.maxEntries !== undefined && object.maxEntries !== null ? Number(object.maxEntries) : 0;
        message.historicalEntries = object.historicalEntries !== undefined && object.historicalEntries !== null ? Number(object.historicalEntries) : 0;
        message.bondDenom = object.bondDenom !== undefined && object.bondDenom !== null ? String(object.bondDenom) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.unbondingTime !== undefined && (obj.unbondingTime = message.unbondingTime ? $ad1f748ecd469446$exports.Duration.toJSON(message.unbondingTime) : undefined);
        message.maxValidators !== undefined && (obj.maxValidators = message.maxValidators);
        message.maxEntries !== undefined && (obj.maxEntries = message.maxEntries);
        message.historicalEntries !== undefined && (obj.historicalEntries = message.historicalEntries);
        message.bondDenom !== undefined && (obj.bondDenom = message.bondDenom);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = Object.assign({}, $73d6a52fa40919be$var$baseParams);
        message.unbondingTime = object.unbondingTime !== undefined && object.unbondingTime !== null ? $ad1f748ecd469446$exports.Duration.fromPartial(object.unbondingTime) : undefined;
        message.maxValidators = (_a = object.maxValidators) !== null && _a !== void 0 ? _a : 0;
        message.maxEntries = (_b = object.maxEntries) !== null && _b !== void 0 ? _b : 0;
        message.historicalEntries = (_c = object.historicalEntries) !== null && _c !== void 0 ? _c : 0;
        message.bondDenom = (_d = object.bondDenom) !== null && _d !== void 0 ? _d : "";
        return message;
    }
};
const $73d6a52fa40919be$var$baseDelegationResponse = {};
$73d6a52fa40919be$exports.DelegationResponse = {
    encode (message, writer = $73d6a52fa40919be$var$minimal_1.default.Writer.create()) {
        if (message.delegation !== undefined) $73d6a52fa40919be$exports.Delegation.encode(message.delegation, writer.uint32(10).fork()).ldelim();
        if (message.balance !== undefined) $82ef09d1a8e2224d$exports.Coin.encode(message.balance, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $73d6a52fa40919be$var$minimal_1.default.Reader ? input : new $73d6a52fa40919be$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $73d6a52fa40919be$var$baseDelegationResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegation = $73d6a52fa40919be$exports.Delegation.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.balance = $82ef09d1a8e2224d$exports.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $73d6a52fa40919be$var$baseDelegationResponse);
        message.delegation = object.delegation !== undefined && object.delegation !== null ? $73d6a52fa40919be$exports.Delegation.fromJSON(object.delegation) : undefined;
        message.balance = object.balance !== undefined && object.balance !== null ? $82ef09d1a8e2224d$exports.Coin.fromJSON(object.balance) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.delegation !== undefined && (obj.delegation = message.delegation ? $73d6a52fa40919be$exports.Delegation.toJSON(message.delegation) : undefined);
        message.balance !== undefined && (obj.balance = message.balance ? $82ef09d1a8e2224d$exports.Coin.toJSON(message.balance) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $73d6a52fa40919be$var$baseDelegationResponse);
        message.delegation = object.delegation !== undefined && object.delegation !== null ? $73d6a52fa40919be$exports.Delegation.fromPartial(object.delegation) : undefined;
        message.balance = object.balance !== undefined && object.balance !== null ? $82ef09d1a8e2224d$exports.Coin.fromPartial(object.balance) : undefined;
        return message;
    }
};
const $73d6a52fa40919be$var$baseRedelegationEntryResponse = {
    balance: ""
};
$73d6a52fa40919be$exports.RedelegationEntryResponse = {
    encode (message, writer = $73d6a52fa40919be$var$minimal_1.default.Writer.create()) {
        if (message.redelegationEntry !== undefined) $73d6a52fa40919be$exports.RedelegationEntry.encode(message.redelegationEntry, writer.uint32(10).fork()).ldelim();
        if (message.balance !== "") writer.uint32(34).string(message.balance);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $73d6a52fa40919be$var$minimal_1.default.Reader ? input : new $73d6a52fa40919be$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $73d6a52fa40919be$var$baseRedelegationEntryResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.redelegationEntry = $73d6a52fa40919be$exports.RedelegationEntry.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.balance = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $73d6a52fa40919be$var$baseRedelegationEntryResponse);
        message.redelegationEntry = object.redelegationEntry !== undefined && object.redelegationEntry !== null ? $73d6a52fa40919be$exports.RedelegationEntry.fromJSON(object.redelegationEntry) : undefined;
        message.balance = object.balance !== undefined && object.balance !== null ? String(object.balance) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.redelegationEntry !== undefined && (obj.redelegationEntry = message.redelegationEntry ? $73d6a52fa40919be$exports.RedelegationEntry.toJSON(message.redelegationEntry) : undefined);
        message.balance !== undefined && (obj.balance = message.balance);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $73d6a52fa40919be$var$baseRedelegationEntryResponse);
        message.redelegationEntry = object.redelegationEntry !== undefined && object.redelegationEntry !== null ? $73d6a52fa40919be$exports.RedelegationEntry.fromPartial(object.redelegationEntry) : undefined;
        message.balance = (_a = object.balance) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
const $73d6a52fa40919be$var$baseRedelegationResponse = {};
$73d6a52fa40919be$exports.RedelegationResponse = {
    encode (message, writer = $73d6a52fa40919be$var$minimal_1.default.Writer.create()) {
        if (message.redelegation !== undefined) $73d6a52fa40919be$exports.Redelegation.encode(message.redelegation, writer.uint32(10).fork()).ldelim();
        for (const v of message.entries)$73d6a52fa40919be$exports.RedelegationEntryResponse.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $73d6a52fa40919be$var$minimal_1.default.Reader ? input : new $73d6a52fa40919be$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $73d6a52fa40919be$var$baseRedelegationResponse);
        message.entries = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.redelegation = $73d6a52fa40919be$exports.Redelegation.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.entries.push($73d6a52fa40919be$exports.RedelegationEntryResponse.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $73d6a52fa40919be$var$baseRedelegationResponse);
        message.redelegation = object.redelegation !== undefined && object.redelegation !== null ? $73d6a52fa40919be$exports.Redelegation.fromJSON(object.redelegation) : undefined;
        message.entries = ((_a = object.entries) !== null && _a !== void 0 ? _a : []).map((e)=>$73d6a52fa40919be$exports.RedelegationEntryResponse.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.redelegation !== undefined && (obj.redelegation = message.redelegation ? $73d6a52fa40919be$exports.Redelegation.toJSON(message.redelegation) : undefined);
        if (message.entries) obj.entries = message.entries.map((e)=>e ? $73d6a52fa40919be$exports.RedelegationEntryResponse.toJSON(e) : undefined);
        else obj.entries = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $73d6a52fa40919be$var$baseRedelegationResponse);
        message.redelegation = object.redelegation !== undefined && object.redelegation !== null ? $73d6a52fa40919be$exports.Redelegation.fromPartial(object.redelegation) : undefined;
        message.entries = ((_a = object.entries) === null || _a === void 0 ? void 0 : _a.map((e)=>$73d6a52fa40919be$exports.RedelegationEntryResponse.fromPartial(e))) || [];
        return message;
    }
};
const $73d6a52fa40919be$var$basePool = {
    notBondedTokens: "",
    bondedTokens: ""
};
$73d6a52fa40919be$exports.Pool = {
    encode (message, writer = $73d6a52fa40919be$var$minimal_1.default.Writer.create()) {
        if (message.notBondedTokens !== "") writer.uint32(10).string(message.notBondedTokens);
        if (message.bondedTokens !== "") writer.uint32(18).string(message.bondedTokens);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $73d6a52fa40919be$var$minimal_1.default.Reader ? input : new $73d6a52fa40919be$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $73d6a52fa40919be$var$basePool);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.notBondedTokens = reader.string();
                    break;
                case 2:
                    message.bondedTokens = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $73d6a52fa40919be$var$basePool);
        message.notBondedTokens = object.notBondedTokens !== undefined && object.notBondedTokens !== null ? String(object.notBondedTokens) : "";
        message.bondedTokens = object.bondedTokens !== undefined && object.bondedTokens !== null ? String(object.bondedTokens) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.notBondedTokens !== undefined && (obj.notBondedTokens = message.notBondedTokens);
        message.bondedTokens !== undefined && (obj.bondedTokens = message.bondedTokens);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $73d6a52fa40919be$var$basePool);
        message.notBondedTokens = (_a = object.notBondedTokens) !== null && _a !== void 0 ? _a : "";
        message.bondedTokens = (_b = object.bondedTokens) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $73d6a52fa40919be$var$toTimestamp(date) {
    const seconds = $73d6a52fa40919be$var$numberToLong(date.getTime() / 1000);
    const nanos = date.getTime() % 1000 * 1000000;
    return {
        seconds: seconds,
        nanos: nanos
    };
}
function $73d6a52fa40919be$var$fromTimestamp(t) {
    let millis = t.seconds.toNumber() * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function $73d6a52fa40919be$var$fromJsonTimestamp(o) {
    if (o instanceof Date) return $73d6a52fa40919be$var$toTimestamp(o);
    else if (typeof o === "string") return $73d6a52fa40919be$var$toTimestamp(new Date(o));
    else return $d6c3291d6aa8eb5b$exports.Timestamp.fromJSON(o);
}
function $73d6a52fa40919be$var$numberToLong(number) {
    return $73d6a52fa40919be$var$long_1.default.fromNumber(number);
}
if ($73d6a52fa40919be$var$minimal_1.default.util.Long !== $73d6a52fa40919be$var$long_1.default) {
    $73d6a52fa40919be$var$minimal_1.default.util.Long = $73d6a52fa40919be$var$long_1.default;
    $73d6a52fa40919be$var$minimal_1.default.configure();
}





$0000c3e2167efb84$exports.protobufPackage = "cosmos.staking.v1beta1";
const $0000c3e2167efb84$var$baseMsgCreateValidator = {
    minSelfDelegation: "",
    delegatorAddress: "",
    validatorAddress: ""
};
$0000c3e2167efb84$exports.MsgCreateValidator = {
    encode (message, writer = $0000c3e2167efb84$var$minimal_1.default.Writer.create()) {
        if (message.description !== undefined) $73d6a52fa40919be$exports.Description.encode(message.description, writer.uint32(10).fork()).ldelim();
        if (message.commission !== undefined) $73d6a52fa40919be$exports.CommissionRates.encode(message.commission, writer.uint32(18).fork()).ldelim();
        if (message.minSelfDelegation !== "") writer.uint32(26).string(message.minSelfDelegation);
        if (message.delegatorAddress !== "") writer.uint32(34).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(42).string(message.validatorAddress);
        if (message.pubkey !== undefined) $4232fce010c3a46b$exports.Any.encode(message.pubkey, writer.uint32(50).fork()).ldelim();
        if (message.value !== undefined) $82ef09d1a8e2224d$exports.Coin.encode(message.value, writer.uint32(58).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0000c3e2167efb84$var$minimal_1.default.Reader ? input : new $0000c3e2167efb84$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $0000c3e2167efb84$var$baseMsgCreateValidator);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.description = $73d6a52fa40919be$exports.Description.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.commission = $73d6a52fa40919be$exports.CommissionRates.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.minSelfDelegation = reader.string();
                    break;
                case 4:
                    message.delegatorAddress = reader.string();
                    break;
                case 5:
                    message.validatorAddress = reader.string();
                    break;
                case 6:
                    message.pubkey = $4232fce010c3a46b$exports.Any.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.value = $82ef09d1a8e2224d$exports.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $0000c3e2167efb84$var$baseMsgCreateValidator);
        message.description = object.description !== undefined && object.description !== null ? $73d6a52fa40919be$exports.Description.fromJSON(object.description) : undefined;
        message.commission = object.commission !== undefined && object.commission !== null ? $73d6a52fa40919be$exports.CommissionRates.fromJSON(object.commission) : undefined;
        message.minSelfDelegation = object.minSelfDelegation !== undefined && object.minSelfDelegation !== null ? String(object.minSelfDelegation) : "";
        message.delegatorAddress = object.delegatorAddress !== undefined && object.delegatorAddress !== null ? String(object.delegatorAddress) : "";
        message.validatorAddress = object.validatorAddress !== undefined && object.validatorAddress !== null ? String(object.validatorAddress) : "";
        message.pubkey = object.pubkey !== undefined && object.pubkey !== null ? $4232fce010c3a46b$exports.Any.fromJSON(object.pubkey) : undefined;
        message.value = object.value !== undefined && object.value !== null ? $82ef09d1a8e2224d$exports.Coin.fromJSON(object.value) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.description !== undefined && (obj.description = message.description ? $73d6a52fa40919be$exports.Description.toJSON(message.description) : undefined);
        message.commission !== undefined && (obj.commission = message.commission ? $73d6a52fa40919be$exports.CommissionRates.toJSON(message.commission) : undefined);
        message.minSelfDelegation !== undefined && (obj.minSelfDelegation = message.minSelfDelegation);
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.pubkey !== undefined && (obj.pubkey = message.pubkey ? $4232fce010c3a46b$exports.Any.toJSON(message.pubkey) : undefined);
        message.value !== undefined && (obj.value = message.value ? $82ef09d1a8e2224d$exports.Coin.toJSON(message.value) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $0000c3e2167efb84$var$baseMsgCreateValidator);
        message.description = object.description !== undefined && object.description !== null ? $73d6a52fa40919be$exports.Description.fromPartial(object.description) : undefined;
        message.commission = object.commission !== undefined && object.commission !== null ? $73d6a52fa40919be$exports.CommissionRates.fromPartial(object.commission) : undefined;
        message.minSelfDelegation = (_a = object.minSelfDelegation) !== null && _a !== void 0 ? _a : "";
        message.delegatorAddress = (_b = object.delegatorAddress) !== null && _b !== void 0 ? _b : "";
        message.validatorAddress = (_c = object.validatorAddress) !== null && _c !== void 0 ? _c : "";
        message.pubkey = object.pubkey !== undefined && object.pubkey !== null ? $4232fce010c3a46b$exports.Any.fromPartial(object.pubkey) : undefined;
        message.value = object.value !== undefined && object.value !== null ? $82ef09d1a8e2224d$exports.Coin.fromPartial(object.value) : undefined;
        return message;
    }
};
const $0000c3e2167efb84$var$baseMsgCreateValidatorResponse = {};
$0000c3e2167efb84$exports.MsgCreateValidatorResponse = {
    encode (_, writer = $0000c3e2167efb84$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0000c3e2167efb84$var$minimal_1.default.Reader ? input : new $0000c3e2167efb84$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $0000c3e2167efb84$var$baseMsgCreateValidatorResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $0000c3e2167efb84$var$baseMsgCreateValidatorResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $0000c3e2167efb84$var$baseMsgCreateValidatorResponse);
        return message;
    }
};
const $0000c3e2167efb84$var$baseMsgEditValidator = {
    validatorAddress: "",
    commissionRate: "",
    minSelfDelegation: ""
};
$0000c3e2167efb84$exports.MsgEditValidator = {
    encode (message, writer = $0000c3e2167efb84$var$minimal_1.default.Writer.create()) {
        if (message.description !== undefined) $73d6a52fa40919be$exports.Description.encode(message.description, writer.uint32(10).fork()).ldelim();
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        if (message.commissionRate !== "") writer.uint32(26).string(message.commissionRate);
        if (message.minSelfDelegation !== "") writer.uint32(34).string(message.minSelfDelegation);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0000c3e2167efb84$var$minimal_1.default.Reader ? input : new $0000c3e2167efb84$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $0000c3e2167efb84$var$baseMsgEditValidator);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.description = $73d6a52fa40919be$exports.Description.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.commissionRate = reader.string();
                    break;
                case 4:
                    message.minSelfDelegation = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $0000c3e2167efb84$var$baseMsgEditValidator);
        message.description = object.description !== undefined && object.description !== null ? $73d6a52fa40919be$exports.Description.fromJSON(object.description) : undefined;
        message.validatorAddress = object.validatorAddress !== undefined && object.validatorAddress !== null ? String(object.validatorAddress) : "";
        message.commissionRate = object.commissionRate !== undefined && object.commissionRate !== null ? String(object.commissionRate) : "";
        message.minSelfDelegation = object.minSelfDelegation !== undefined && object.minSelfDelegation !== null ? String(object.minSelfDelegation) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.description !== undefined && (obj.description = message.description ? $73d6a52fa40919be$exports.Description.toJSON(message.description) : undefined);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.commissionRate !== undefined && (obj.commissionRate = message.commissionRate);
        message.minSelfDelegation !== undefined && (obj.minSelfDelegation = message.minSelfDelegation);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $0000c3e2167efb84$var$baseMsgEditValidator);
        message.description = object.description !== undefined && object.description !== null ? $73d6a52fa40919be$exports.Description.fromPartial(object.description) : undefined;
        message.validatorAddress = (_a = object.validatorAddress) !== null && _a !== void 0 ? _a : "";
        message.commissionRate = (_b = object.commissionRate) !== null && _b !== void 0 ? _b : "";
        message.minSelfDelegation = (_c = object.minSelfDelegation) !== null && _c !== void 0 ? _c : "";
        return message;
    }
};
const $0000c3e2167efb84$var$baseMsgEditValidatorResponse = {};
$0000c3e2167efb84$exports.MsgEditValidatorResponse = {
    encode (_, writer = $0000c3e2167efb84$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0000c3e2167efb84$var$minimal_1.default.Reader ? input : new $0000c3e2167efb84$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $0000c3e2167efb84$var$baseMsgEditValidatorResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $0000c3e2167efb84$var$baseMsgEditValidatorResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $0000c3e2167efb84$var$baseMsgEditValidatorResponse);
        return message;
    }
};
const $0000c3e2167efb84$var$baseMsgDelegate = {
    delegatorAddress: "",
    validatorAddress: ""
};
$0000c3e2167efb84$exports.MsgDelegate = {
    encode (message, writer = $0000c3e2167efb84$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        if (message.amount !== undefined) $82ef09d1a8e2224d$exports.Coin.encode(message.amount, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0000c3e2167efb84$var$minimal_1.default.Reader ? input : new $0000c3e2167efb84$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $0000c3e2167efb84$var$baseMsgDelegate);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.amount = $82ef09d1a8e2224d$exports.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $0000c3e2167efb84$var$baseMsgDelegate);
        message.delegatorAddress = object.delegatorAddress !== undefined && object.delegatorAddress !== null ? String(object.delegatorAddress) : "";
        message.validatorAddress = object.validatorAddress !== undefined && object.validatorAddress !== null ? String(object.validatorAddress) : "";
        message.amount = object.amount !== undefined && object.amount !== null ? $82ef09d1a8e2224d$exports.Coin.fromJSON(object.amount) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.amount !== undefined && (obj.amount = message.amount ? $82ef09d1a8e2224d$exports.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $0000c3e2167efb84$var$baseMsgDelegate);
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorAddress = (_b = object.validatorAddress) !== null && _b !== void 0 ? _b : "";
        message.amount = object.amount !== undefined && object.amount !== null ? $82ef09d1a8e2224d$exports.Coin.fromPartial(object.amount) : undefined;
        return message;
    }
};
const $0000c3e2167efb84$var$baseMsgDelegateResponse = {};
$0000c3e2167efb84$exports.MsgDelegateResponse = {
    encode (_, writer = $0000c3e2167efb84$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0000c3e2167efb84$var$minimal_1.default.Reader ? input : new $0000c3e2167efb84$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $0000c3e2167efb84$var$baseMsgDelegateResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $0000c3e2167efb84$var$baseMsgDelegateResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $0000c3e2167efb84$var$baseMsgDelegateResponse);
        return message;
    }
};
const $0000c3e2167efb84$var$baseMsgBeginRedelegate = {
    delegatorAddress: "",
    validatorSrcAddress: "",
    validatorDstAddress: ""
};
$0000c3e2167efb84$exports.MsgBeginRedelegate = {
    encode (message, writer = $0000c3e2167efb84$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorSrcAddress !== "") writer.uint32(18).string(message.validatorSrcAddress);
        if (message.validatorDstAddress !== "") writer.uint32(26).string(message.validatorDstAddress);
        if (message.amount !== undefined) $82ef09d1a8e2224d$exports.Coin.encode(message.amount, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0000c3e2167efb84$var$minimal_1.default.Reader ? input : new $0000c3e2167efb84$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $0000c3e2167efb84$var$baseMsgBeginRedelegate);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorSrcAddress = reader.string();
                    break;
                case 3:
                    message.validatorDstAddress = reader.string();
                    break;
                case 4:
                    message.amount = $82ef09d1a8e2224d$exports.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $0000c3e2167efb84$var$baseMsgBeginRedelegate);
        message.delegatorAddress = object.delegatorAddress !== undefined && object.delegatorAddress !== null ? String(object.delegatorAddress) : "";
        message.validatorSrcAddress = object.validatorSrcAddress !== undefined && object.validatorSrcAddress !== null ? String(object.validatorSrcAddress) : "";
        message.validatorDstAddress = object.validatorDstAddress !== undefined && object.validatorDstAddress !== null ? String(object.validatorDstAddress) : "";
        message.amount = object.amount !== undefined && object.amount !== null ? $82ef09d1a8e2224d$exports.Coin.fromJSON(object.amount) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorSrcAddress !== undefined && (obj.validatorSrcAddress = message.validatorSrcAddress);
        message.validatorDstAddress !== undefined && (obj.validatorDstAddress = message.validatorDstAddress);
        message.amount !== undefined && (obj.amount = message.amount ? $82ef09d1a8e2224d$exports.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $0000c3e2167efb84$var$baseMsgBeginRedelegate);
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorSrcAddress = (_b = object.validatorSrcAddress) !== null && _b !== void 0 ? _b : "";
        message.validatorDstAddress = (_c = object.validatorDstAddress) !== null && _c !== void 0 ? _c : "";
        message.amount = object.amount !== undefined && object.amount !== null ? $82ef09d1a8e2224d$exports.Coin.fromPartial(object.amount) : undefined;
        return message;
    }
};
const $0000c3e2167efb84$var$baseMsgBeginRedelegateResponse = {};
$0000c3e2167efb84$exports.MsgBeginRedelegateResponse = {
    encode (message, writer = $0000c3e2167efb84$var$minimal_1.default.Writer.create()) {
        if (message.completionTime !== undefined) $d6c3291d6aa8eb5b$exports.Timestamp.encode(message.completionTime, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0000c3e2167efb84$var$minimal_1.default.Reader ? input : new $0000c3e2167efb84$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $0000c3e2167efb84$var$baseMsgBeginRedelegateResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.completionTime = $d6c3291d6aa8eb5b$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $0000c3e2167efb84$var$baseMsgBeginRedelegateResponse);
        message.completionTime = object.completionTime !== undefined && object.completionTime !== null ? $0000c3e2167efb84$var$fromJsonTimestamp(object.completionTime) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.completionTime !== undefined && (obj.completionTime = $0000c3e2167efb84$var$fromTimestamp(message.completionTime).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $0000c3e2167efb84$var$baseMsgBeginRedelegateResponse);
        message.completionTime = object.completionTime !== undefined && object.completionTime !== null ? $d6c3291d6aa8eb5b$exports.Timestamp.fromPartial(object.completionTime) : undefined;
        return message;
    }
};
const $0000c3e2167efb84$var$baseMsgUndelegate = {
    delegatorAddress: "",
    validatorAddress: ""
};
$0000c3e2167efb84$exports.MsgUndelegate = {
    encode (message, writer = $0000c3e2167efb84$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        if (message.amount !== undefined) $82ef09d1a8e2224d$exports.Coin.encode(message.amount, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0000c3e2167efb84$var$minimal_1.default.Reader ? input : new $0000c3e2167efb84$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $0000c3e2167efb84$var$baseMsgUndelegate);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.amount = $82ef09d1a8e2224d$exports.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $0000c3e2167efb84$var$baseMsgUndelegate);
        message.delegatorAddress = object.delegatorAddress !== undefined && object.delegatorAddress !== null ? String(object.delegatorAddress) : "";
        message.validatorAddress = object.validatorAddress !== undefined && object.validatorAddress !== null ? String(object.validatorAddress) : "";
        message.amount = object.amount !== undefined && object.amount !== null ? $82ef09d1a8e2224d$exports.Coin.fromJSON(object.amount) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.amount !== undefined && (obj.amount = message.amount ? $82ef09d1a8e2224d$exports.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $0000c3e2167efb84$var$baseMsgUndelegate);
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorAddress = (_b = object.validatorAddress) !== null && _b !== void 0 ? _b : "";
        message.amount = object.amount !== undefined && object.amount !== null ? $82ef09d1a8e2224d$exports.Coin.fromPartial(object.amount) : undefined;
        return message;
    }
};
const $0000c3e2167efb84$var$baseMsgUndelegateResponse = {};
$0000c3e2167efb84$exports.MsgUndelegateResponse = {
    encode (message, writer = $0000c3e2167efb84$var$minimal_1.default.Writer.create()) {
        if (message.completionTime !== undefined) $d6c3291d6aa8eb5b$exports.Timestamp.encode(message.completionTime, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0000c3e2167efb84$var$minimal_1.default.Reader ? input : new $0000c3e2167efb84$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $0000c3e2167efb84$var$baseMsgUndelegateResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.completionTime = $d6c3291d6aa8eb5b$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $0000c3e2167efb84$var$baseMsgUndelegateResponse);
        message.completionTime = object.completionTime !== undefined && object.completionTime !== null ? $0000c3e2167efb84$var$fromJsonTimestamp(object.completionTime) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.completionTime !== undefined && (obj.completionTime = $0000c3e2167efb84$var$fromTimestamp(message.completionTime).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $0000c3e2167efb84$var$baseMsgUndelegateResponse);
        message.completionTime = object.completionTime !== undefined && object.completionTime !== null ? $d6c3291d6aa8eb5b$exports.Timestamp.fromPartial(object.completionTime) : undefined;
        return message;
    }
};
class $0000c3e2167efb84$var$MsgClientImpl {
    CreateValidator(request) {
        const data = $0000c3e2167efb84$exports.MsgCreateValidator.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "CreateValidator", data);
        return promise.then((data)=>$0000c3e2167efb84$exports.MsgCreateValidatorResponse.decode(new $0000c3e2167efb84$var$minimal_1.default.Reader(data)));
    }
    EditValidator(request) {
        const data = $0000c3e2167efb84$exports.MsgEditValidator.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "EditValidator", data);
        return promise.then((data)=>$0000c3e2167efb84$exports.MsgEditValidatorResponse.decode(new $0000c3e2167efb84$var$minimal_1.default.Reader(data)));
    }
    Delegate(request) {
        const data = $0000c3e2167efb84$exports.MsgDelegate.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "Delegate", data);
        return promise.then((data)=>$0000c3e2167efb84$exports.MsgDelegateResponse.decode(new $0000c3e2167efb84$var$minimal_1.default.Reader(data)));
    }
    BeginRedelegate(request) {
        const data = $0000c3e2167efb84$exports.MsgBeginRedelegate.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "BeginRedelegate", data);
        return promise.then((data)=>$0000c3e2167efb84$exports.MsgBeginRedelegateResponse.decode(new $0000c3e2167efb84$var$minimal_1.default.Reader(data)));
    }
    Undelegate(request) {
        const data = $0000c3e2167efb84$exports.MsgUndelegate.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "Undelegate", data);
        return promise.then((data)=>$0000c3e2167efb84$exports.MsgUndelegateResponse.decode(new $0000c3e2167efb84$var$minimal_1.default.Reader(data)));
    }
    constructor(rpc){
        this.rpc = rpc;
        this.CreateValidator = this.CreateValidator.bind(this);
        this.EditValidator = this.EditValidator.bind(this);
        this.Delegate = this.Delegate.bind(this);
        this.BeginRedelegate = this.BeginRedelegate.bind(this);
        this.Undelegate = this.Undelegate.bind(this);
    }
}
$0000c3e2167efb84$exports.MsgClientImpl = $0000c3e2167efb84$var$MsgClientImpl;
function $0000c3e2167efb84$var$toTimestamp(date) {
    const seconds = $0000c3e2167efb84$var$numberToLong(date.getTime() / 1000);
    const nanos = date.getTime() % 1000 * 1000000;
    return {
        seconds: seconds,
        nanos: nanos
    };
}
function $0000c3e2167efb84$var$fromTimestamp(t) {
    let millis = t.seconds.toNumber() * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function $0000c3e2167efb84$var$fromJsonTimestamp(o) {
    if (o instanceof Date) return $0000c3e2167efb84$var$toTimestamp(o);
    else if (typeof o === "string") return $0000c3e2167efb84$var$toTimestamp(new Date(o));
    else return $d6c3291d6aa8eb5b$exports.Timestamp.fromJSON(o);
}
function $0000c3e2167efb84$var$numberToLong(number) {
    return $0000c3e2167efb84$var$long_1.default.fromNumber(number);
}
if ($0000c3e2167efb84$var$minimal_1.default.util.Long !== $0000c3e2167efb84$var$long_1.default) {
    $0000c3e2167efb84$var$minimal_1.default.util.Long = $0000c3e2167efb84$var$long_1.default;
    $0000c3e2167efb84$var$minimal_1.default.configure();
}


$e390e8698d1c9020$exports.stakingTypes = [
    [
        "/cosmos.staking.v1beta1.MsgBeginRedelegate",
        $0000c3e2167efb84$exports.MsgBeginRedelegate
    ],
    [
        "/cosmos.staking.v1beta1.MsgCreateValidator",
        $0000c3e2167efb84$exports.MsgCreateValidator
    ],
    [
        "/cosmos.staking.v1beta1.MsgDelegate",
        $0000c3e2167efb84$exports.MsgDelegate
    ],
    [
        "/cosmos.staking.v1beta1.MsgEditValidator",
        $0000c3e2167efb84$exports.MsgEditValidator
    ],
    [
        "/cosmos.staking.v1beta1.MsgUndelegate",
        $0000c3e2167efb84$exports.MsgUndelegate
    ]
];
function $e390e8698d1c9020$var$isMsgDelegateEncodeObject(object) {
    return object.typeUrl === "/cosmos.staking.v1beta1.MsgDelegate";
}
$e390e8698d1c9020$exports.isMsgDelegateEncodeObject = $e390e8698d1c9020$var$isMsgDelegateEncodeObject;
function $e390e8698d1c9020$var$isMsgUndelegateEncodeObject(object) {
    return object.typeUrl === "/cosmos.staking.v1beta1.MsgUndelegate";
}
$e390e8698d1c9020$exports.isMsgUndelegateEncodeObject = $e390e8698d1c9020$var$isMsgUndelegateEncodeObject;


Object.defineProperty($7725f2e3ca016b52$exports, "isMsgDelegateEncodeObject", {
    enumerable: true,
    get: function() {
        return $e390e8698d1c9020$exports.isMsgDelegateEncodeObject;
    }
});
Object.defineProperty($7725f2e3ca016b52$exports, "isMsgUndelegateEncodeObject", {
    enumerable: true,
    get: function() {
        return $e390e8698d1c9020$exports.isMsgUndelegateEncodeObject;
    }
});
Object.defineProperty($7725f2e3ca016b52$exports, "stakingTypes", {
    enumerable: true,
    get: function() {
        return $e390e8698d1c9020$exports.stakingTypes;
    }
});
var $7d4764ca152ad318$exports = {};
"use strict";
var $7d4764ca152ad318$var$__importDefault = $7d4764ca152ad318$exports && $7d4764ca152ad318$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($7d4764ca152ad318$exports, "__esModule", {
    value: true
});
$7d4764ca152ad318$exports.setupStakingExtension = void 0;
var $2c38ecbf2748a0b4$exports = {};
"use strict";
var $2c38ecbf2748a0b4$var$__importDefault = $2c38ecbf2748a0b4$exports && $2c38ecbf2748a0b4$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($2c38ecbf2748a0b4$exports, "__esModule", {
    value: true
});
$2c38ecbf2748a0b4$exports.QueryClientImpl = $2c38ecbf2748a0b4$exports.QueryParamsResponse = $2c38ecbf2748a0b4$exports.QueryParamsRequest = $2c38ecbf2748a0b4$exports.QueryPoolResponse = $2c38ecbf2748a0b4$exports.QueryPoolRequest = $2c38ecbf2748a0b4$exports.QueryHistoricalInfoResponse = $2c38ecbf2748a0b4$exports.QueryHistoricalInfoRequest = $2c38ecbf2748a0b4$exports.QueryDelegatorValidatorResponse = $2c38ecbf2748a0b4$exports.QueryDelegatorValidatorRequest = $2c38ecbf2748a0b4$exports.QueryDelegatorValidatorsResponse = $2c38ecbf2748a0b4$exports.QueryDelegatorValidatorsRequest = $2c38ecbf2748a0b4$exports.QueryRedelegationsResponse = $2c38ecbf2748a0b4$exports.QueryRedelegationsRequest = $2c38ecbf2748a0b4$exports.QueryDelegatorUnbondingDelegationsResponse = $2c38ecbf2748a0b4$exports.QueryDelegatorUnbondingDelegationsRequest = $2c38ecbf2748a0b4$exports.QueryDelegatorDelegationsResponse = $2c38ecbf2748a0b4$exports.QueryDelegatorDelegationsRequest = $2c38ecbf2748a0b4$exports.QueryUnbondingDelegationResponse = $2c38ecbf2748a0b4$exports.QueryUnbondingDelegationRequest = $2c38ecbf2748a0b4$exports.QueryDelegationResponse = $2c38ecbf2748a0b4$exports.QueryDelegationRequest = $2c38ecbf2748a0b4$exports.QueryValidatorUnbondingDelegationsResponse = $2c38ecbf2748a0b4$exports.QueryValidatorUnbondingDelegationsRequest = $2c38ecbf2748a0b4$exports.QueryValidatorDelegationsResponse = $2c38ecbf2748a0b4$exports.QueryValidatorDelegationsRequest = $2c38ecbf2748a0b4$exports.QueryValidatorResponse = $2c38ecbf2748a0b4$exports.QueryValidatorRequest = $2c38ecbf2748a0b4$exports.QueryValidatorsResponse = $2c38ecbf2748a0b4$exports.QueryValidatorsRequest = $2c38ecbf2748a0b4$exports.protobufPackage = void 0;

/* eslint-disable */ const $2c38ecbf2748a0b4$var$long_1 = $2c38ecbf2748a0b4$var$__importDefault((parcelRequire("9A55m")));

const $2c38ecbf2748a0b4$var$minimal_1 = $2c38ecbf2748a0b4$var$__importDefault((parcelRequire("i2pIU")));


$2c38ecbf2748a0b4$exports.protobufPackage = "cosmos.staking.v1beta1";
const $2c38ecbf2748a0b4$var$baseQueryValidatorsRequest = {
    status: ""
};
$2c38ecbf2748a0b4$exports.QueryValidatorsRequest = {
    encode (message, writer = $2c38ecbf2748a0b4$var$minimal_1.default.Writer.create()) {
        if (message.status !== "") writer.uint32(10).string(message.status);
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2c38ecbf2748a0b4$var$minimal_1.default.Reader ? input : new $2c38ecbf2748a0b4$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryValidatorsRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.status = reader.string();
                    break;
                case 2:
                    message.pagination = $f01b40e20607eb8e$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryValidatorsRequest);
        message.status = object.status !== undefined && object.status !== null ? String(object.status) : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromJSON(object.pagination) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.status !== undefined && (obj.status = message.status);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryValidatorsRequest);
        message.status = (_a = object.status) !== null && _a !== void 0 ? _a : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
const $2c38ecbf2748a0b4$var$baseQueryValidatorsResponse = {};
$2c38ecbf2748a0b4$exports.QueryValidatorsResponse = {
    encode (message, writer = $2c38ecbf2748a0b4$var$minimal_1.default.Writer.create()) {
        for (const v of message.validators)$73d6a52fa40919be$exports.Validator.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2c38ecbf2748a0b4$var$minimal_1.default.Reader ? input : new $2c38ecbf2748a0b4$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryValidatorsResponse);
        message.validators = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validators.push($73d6a52fa40919be$exports.Validator.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $f01b40e20607eb8e$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryValidatorsResponse);
        message.validators = ((_a = object.validators) !== null && _a !== void 0 ? _a : []).map((e)=>$73d6a52fa40919be$exports.Validator.fromJSON(e));
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromJSON(object.pagination) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.validators) obj.validators = message.validators.map((e)=>e ? $73d6a52fa40919be$exports.Validator.toJSON(e) : undefined);
        else obj.validators = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryValidatorsResponse);
        message.validators = ((_a = object.validators) === null || _a === void 0 ? void 0 : _a.map((e)=>$73d6a52fa40919be$exports.Validator.fromPartial(e))) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
const $2c38ecbf2748a0b4$var$baseQueryValidatorRequest = {
    validatorAddr: ""
};
$2c38ecbf2748a0b4$exports.QueryValidatorRequest = {
    encode (message, writer = $2c38ecbf2748a0b4$var$minimal_1.default.Writer.create()) {
        if (message.validatorAddr !== "") writer.uint32(10).string(message.validatorAddr);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2c38ecbf2748a0b4$var$minimal_1.default.Reader ? input : new $2c38ecbf2748a0b4$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryValidatorRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddr = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryValidatorRequest);
        message.validatorAddr = object.validatorAddr !== undefined && object.validatorAddr !== null ? String(object.validatorAddr) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.validatorAddr !== undefined && (obj.validatorAddr = message.validatorAddr);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryValidatorRequest);
        message.validatorAddr = (_a = object.validatorAddr) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
const $2c38ecbf2748a0b4$var$baseQueryValidatorResponse = {};
$2c38ecbf2748a0b4$exports.QueryValidatorResponse = {
    encode (message, writer = $2c38ecbf2748a0b4$var$minimal_1.default.Writer.create()) {
        if (message.validator !== undefined) $73d6a52fa40919be$exports.Validator.encode(message.validator, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2c38ecbf2748a0b4$var$minimal_1.default.Reader ? input : new $2c38ecbf2748a0b4$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryValidatorResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validator = $73d6a52fa40919be$exports.Validator.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryValidatorResponse);
        message.validator = object.validator !== undefined && object.validator !== null ? $73d6a52fa40919be$exports.Validator.fromJSON(object.validator) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.validator !== undefined && (obj.validator = message.validator ? $73d6a52fa40919be$exports.Validator.toJSON(message.validator) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryValidatorResponse);
        message.validator = object.validator !== undefined && object.validator !== null ? $73d6a52fa40919be$exports.Validator.fromPartial(object.validator) : undefined;
        return message;
    }
};
const $2c38ecbf2748a0b4$var$baseQueryValidatorDelegationsRequest = {
    validatorAddr: ""
};
$2c38ecbf2748a0b4$exports.QueryValidatorDelegationsRequest = {
    encode (message, writer = $2c38ecbf2748a0b4$var$minimal_1.default.Writer.create()) {
        if (message.validatorAddr !== "") writer.uint32(10).string(message.validatorAddr);
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2c38ecbf2748a0b4$var$minimal_1.default.Reader ? input : new $2c38ecbf2748a0b4$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryValidatorDelegationsRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddr = reader.string();
                    break;
                case 2:
                    message.pagination = $f01b40e20607eb8e$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryValidatorDelegationsRequest);
        message.validatorAddr = object.validatorAddr !== undefined && object.validatorAddr !== null ? String(object.validatorAddr) : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromJSON(object.pagination) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.validatorAddr !== undefined && (obj.validatorAddr = message.validatorAddr);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryValidatorDelegationsRequest);
        message.validatorAddr = (_a = object.validatorAddr) !== null && _a !== void 0 ? _a : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
const $2c38ecbf2748a0b4$var$baseQueryValidatorDelegationsResponse = {};
$2c38ecbf2748a0b4$exports.QueryValidatorDelegationsResponse = {
    encode (message, writer = $2c38ecbf2748a0b4$var$minimal_1.default.Writer.create()) {
        for (const v of message.delegationResponses)$73d6a52fa40919be$exports.DelegationResponse.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2c38ecbf2748a0b4$var$minimal_1.default.Reader ? input : new $2c38ecbf2748a0b4$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryValidatorDelegationsResponse);
        message.delegationResponses = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegationResponses.push($73d6a52fa40919be$exports.DelegationResponse.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $f01b40e20607eb8e$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryValidatorDelegationsResponse);
        message.delegationResponses = ((_a = object.delegationResponses) !== null && _a !== void 0 ? _a : []).map((e)=>$73d6a52fa40919be$exports.DelegationResponse.fromJSON(e));
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromJSON(object.pagination) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.delegationResponses) obj.delegationResponses = message.delegationResponses.map((e)=>e ? $73d6a52fa40919be$exports.DelegationResponse.toJSON(e) : undefined);
        else obj.delegationResponses = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryValidatorDelegationsResponse);
        message.delegationResponses = ((_a = object.delegationResponses) === null || _a === void 0 ? void 0 : _a.map((e)=>$73d6a52fa40919be$exports.DelegationResponse.fromPartial(e))) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
const $2c38ecbf2748a0b4$var$baseQueryValidatorUnbondingDelegationsRequest = {
    validatorAddr: ""
};
$2c38ecbf2748a0b4$exports.QueryValidatorUnbondingDelegationsRequest = {
    encode (message, writer = $2c38ecbf2748a0b4$var$minimal_1.default.Writer.create()) {
        if (message.validatorAddr !== "") writer.uint32(10).string(message.validatorAddr);
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2c38ecbf2748a0b4$var$minimal_1.default.Reader ? input : new $2c38ecbf2748a0b4$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryValidatorUnbondingDelegationsRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddr = reader.string();
                    break;
                case 2:
                    message.pagination = $f01b40e20607eb8e$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryValidatorUnbondingDelegationsRequest);
        message.validatorAddr = object.validatorAddr !== undefined && object.validatorAddr !== null ? String(object.validatorAddr) : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromJSON(object.pagination) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.validatorAddr !== undefined && (obj.validatorAddr = message.validatorAddr);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryValidatorUnbondingDelegationsRequest);
        message.validatorAddr = (_a = object.validatorAddr) !== null && _a !== void 0 ? _a : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
const $2c38ecbf2748a0b4$var$baseQueryValidatorUnbondingDelegationsResponse = {};
$2c38ecbf2748a0b4$exports.QueryValidatorUnbondingDelegationsResponse = {
    encode (message, writer = $2c38ecbf2748a0b4$var$minimal_1.default.Writer.create()) {
        for (const v of message.unbondingResponses)$73d6a52fa40919be$exports.UnbondingDelegation.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2c38ecbf2748a0b4$var$minimal_1.default.Reader ? input : new $2c38ecbf2748a0b4$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryValidatorUnbondingDelegationsResponse);
        message.unbondingResponses = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.unbondingResponses.push($73d6a52fa40919be$exports.UnbondingDelegation.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $f01b40e20607eb8e$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryValidatorUnbondingDelegationsResponse);
        message.unbondingResponses = ((_a = object.unbondingResponses) !== null && _a !== void 0 ? _a : []).map((e)=>$73d6a52fa40919be$exports.UnbondingDelegation.fromJSON(e));
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromJSON(object.pagination) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.unbondingResponses) obj.unbondingResponses = message.unbondingResponses.map((e)=>e ? $73d6a52fa40919be$exports.UnbondingDelegation.toJSON(e) : undefined);
        else obj.unbondingResponses = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryValidatorUnbondingDelegationsResponse);
        message.unbondingResponses = ((_a = object.unbondingResponses) === null || _a === void 0 ? void 0 : _a.map((e)=>$73d6a52fa40919be$exports.UnbondingDelegation.fromPartial(e))) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
const $2c38ecbf2748a0b4$var$baseQueryDelegationRequest = {
    delegatorAddr: "",
    validatorAddr: ""
};
$2c38ecbf2748a0b4$exports.QueryDelegationRequest = {
    encode (message, writer = $2c38ecbf2748a0b4$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddr !== "") writer.uint32(10).string(message.delegatorAddr);
        if (message.validatorAddr !== "") writer.uint32(18).string(message.validatorAddr);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2c38ecbf2748a0b4$var$minimal_1.default.Reader ? input : new $2c38ecbf2748a0b4$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryDelegationRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.validatorAddr = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryDelegationRequest);
        message.delegatorAddr = object.delegatorAddr !== undefined && object.delegatorAddr !== null ? String(object.delegatorAddr) : "";
        message.validatorAddr = object.validatorAddr !== undefined && object.validatorAddr !== null ? String(object.validatorAddr) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.validatorAddr !== undefined && (obj.validatorAddr = message.validatorAddr);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryDelegationRequest);
        message.delegatorAddr = (_a = object.delegatorAddr) !== null && _a !== void 0 ? _a : "";
        message.validatorAddr = (_b = object.validatorAddr) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
const $2c38ecbf2748a0b4$var$baseQueryDelegationResponse = {};
$2c38ecbf2748a0b4$exports.QueryDelegationResponse = {
    encode (message, writer = $2c38ecbf2748a0b4$var$minimal_1.default.Writer.create()) {
        if (message.delegationResponse !== undefined) $73d6a52fa40919be$exports.DelegationResponse.encode(message.delegationResponse, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2c38ecbf2748a0b4$var$minimal_1.default.Reader ? input : new $2c38ecbf2748a0b4$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryDelegationResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegationResponse = $73d6a52fa40919be$exports.DelegationResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryDelegationResponse);
        message.delegationResponse = object.delegationResponse !== undefined && object.delegationResponse !== null ? $73d6a52fa40919be$exports.DelegationResponse.fromJSON(object.delegationResponse) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.delegationResponse !== undefined && (obj.delegationResponse = message.delegationResponse ? $73d6a52fa40919be$exports.DelegationResponse.toJSON(message.delegationResponse) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryDelegationResponse);
        message.delegationResponse = object.delegationResponse !== undefined && object.delegationResponse !== null ? $73d6a52fa40919be$exports.DelegationResponse.fromPartial(object.delegationResponse) : undefined;
        return message;
    }
};
const $2c38ecbf2748a0b4$var$baseQueryUnbondingDelegationRequest = {
    delegatorAddr: "",
    validatorAddr: ""
};
$2c38ecbf2748a0b4$exports.QueryUnbondingDelegationRequest = {
    encode (message, writer = $2c38ecbf2748a0b4$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddr !== "") writer.uint32(10).string(message.delegatorAddr);
        if (message.validatorAddr !== "") writer.uint32(18).string(message.validatorAddr);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2c38ecbf2748a0b4$var$minimal_1.default.Reader ? input : new $2c38ecbf2748a0b4$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryUnbondingDelegationRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.validatorAddr = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryUnbondingDelegationRequest);
        message.delegatorAddr = object.delegatorAddr !== undefined && object.delegatorAddr !== null ? String(object.delegatorAddr) : "";
        message.validatorAddr = object.validatorAddr !== undefined && object.validatorAddr !== null ? String(object.validatorAddr) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.validatorAddr !== undefined && (obj.validatorAddr = message.validatorAddr);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryUnbondingDelegationRequest);
        message.delegatorAddr = (_a = object.delegatorAddr) !== null && _a !== void 0 ? _a : "";
        message.validatorAddr = (_b = object.validatorAddr) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
const $2c38ecbf2748a0b4$var$baseQueryUnbondingDelegationResponse = {};
$2c38ecbf2748a0b4$exports.QueryUnbondingDelegationResponse = {
    encode (message, writer = $2c38ecbf2748a0b4$var$minimal_1.default.Writer.create()) {
        if (message.unbond !== undefined) $73d6a52fa40919be$exports.UnbondingDelegation.encode(message.unbond, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2c38ecbf2748a0b4$var$minimal_1.default.Reader ? input : new $2c38ecbf2748a0b4$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryUnbondingDelegationResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.unbond = $73d6a52fa40919be$exports.UnbondingDelegation.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryUnbondingDelegationResponse);
        message.unbond = object.unbond !== undefined && object.unbond !== null ? $73d6a52fa40919be$exports.UnbondingDelegation.fromJSON(object.unbond) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.unbond !== undefined && (obj.unbond = message.unbond ? $73d6a52fa40919be$exports.UnbondingDelegation.toJSON(message.unbond) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryUnbondingDelegationResponse);
        message.unbond = object.unbond !== undefined && object.unbond !== null ? $73d6a52fa40919be$exports.UnbondingDelegation.fromPartial(object.unbond) : undefined;
        return message;
    }
};
const $2c38ecbf2748a0b4$var$baseQueryDelegatorDelegationsRequest = {
    delegatorAddr: ""
};
$2c38ecbf2748a0b4$exports.QueryDelegatorDelegationsRequest = {
    encode (message, writer = $2c38ecbf2748a0b4$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddr !== "") writer.uint32(10).string(message.delegatorAddr);
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2c38ecbf2748a0b4$var$minimal_1.default.Reader ? input : new $2c38ecbf2748a0b4$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryDelegatorDelegationsRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.pagination = $f01b40e20607eb8e$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryDelegatorDelegationsRequest);
        message.delegatorAddr = object.delegatorAddr !== undefined && object.delegatorAddr !== null ? String(object.delegatorAddr) : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromJSON(object.pagination) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryDelegatorDelegationsRequest);
        message.delegatorAddr = (_a = object.delegatorAddr) !== null && _a !== void 0 ? _a : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
const $2c38ecbf2748a0b4$var$baseQueryDelegatorDelegationsResponse = {};
$2c38ecbf2748a0b4$exports.QueryDelegatorDelegationsResponse = {
    encode (message, writer = $2c38ecbf2748a0b4$var$minimal_1.default.Writer.create()) {
        for (const v of message.delegationResponses)$73d6a52fa40919be$exports.DelegationResponse.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2c38ecbf2748a0b4$var$minimal_1.default.Reader ? input : new $2c38ecbf2748a0b4$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryDelegatorDelegationsResponse);
        message.delegationResponses = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegationResponses.push($73d6a52fa40919be$exports.DelegationResponse.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $f01b40e20607eb8e$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryDelegatorDelegationsResponse);
        message.delegationResponses = ((_a = object.delegationResponses) !== null && _a !== void 0 ? _a : []).map((e)=>$73d6a52fa40919be$exports.DelegationResponse.fromJSON(e));
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromJSON(object.pagination) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.delegationResponses) obj.delegationResponses = message.delegationResponses.map((e)=>e ? $73d6a52fa40919be$exports.DelegationResponse.toJSON(e) : undefined);
        else obj.delegationResponses = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryDelegatorDelegationsResponse);
        message.delegationResponses = ((_a = object.delegationResponses) === null || _a === void 0 ? void 0 : _a.map((e)=>$73d6a52fa40919be$exports.DelegationResponse.fromPartial(e))) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
const $2c38ecbf2748a0b4$var$baseQueryDelegatorUnbondingDelegationsRequest = {
    delegatorAddr: ""
};
$2c38ecbf2748a0b4$exports.QueryDelegatorUnbondingDelegationsRequest = {
    encode (message, writer = $2c38ecbf2748a0b4$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddr !== "") writer.uint32(10).string(message.delegatorAddr);
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2c38ecbf2748a0b4$var$minimal_1.default.Reader ? input : new $2c38ecbf2748a0b4$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryDelegatorUnbondingDelegationsRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.pagination = $f01b40e20607eb8e$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryDelegatorUnbondingDelegationsRequest);
        message.delegatorAddr = object.delegatorAddr !== undefined && object.delegatorAddr !== null ? String(object.delegatorAddr) : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromJSON(object.pagination) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryDelegatorUnbondingDelegationsRequest);
        message.delegatorAddr = (_a = object.delegatorAddr) !== null && _a !== void 0 ? _a : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
const $2c38ecbf2748a0b4$var$baseQueryDelegatorUnbondingDelegationsResponse = {};
$2c38ecbf2748a0b4$exports.QueryDelegatorUnbondingDelegationsResponse = {
    encode (message, writer = $2c38ecbf2748a0b4$var$minimal_1.default.Writer.create()) {
        for (const v of message.unbondingResponses)$73d6a52fa40919be$exports.UnbondingDelegation.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2c38ecbf2748a0b4$var$minimal_1.default.Reader ? input : new $2c38ecbf2748a0b4$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryDelegatorUnbondingDelegationsResponse);
        message.unbondingResponses = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.unbondingResponses.push($73d6a52fa40919be$exports.UnbondingDelegation.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $f01b40e20607eb8e$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryDelegatorUnbondingDelegationsResponse);
        message.unbondingResponses = ((_a = object.unbondingResponses) !== null && _a !== void 0 ? _a : []).map((e)=>$73d6a52fa40919be$exports.UnbondingDelegation.fromJSON(e));
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromJSON(object.pagination) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.unbondingResponses) obj.unbondingResponses = message.unbondingResponses.map((e)=>e ? $73d6a52fa40919be$exports.UnbondingDelegation.toJSON(e) : undefined);
        else obj.unbondingResponses = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryDelegatorUnbondingDelegationsResponse);
        message.unbondingResponses = ((_a = object.unbondingResponses) === null || _a === void 0 ? void 0 : _a.map((e)=>$73d6a52fa40919be$exports.UnbondingDelegation.fromPartial(e))) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
const $2c38ecbf2748a0b4$var$baseQueryRedelegationsRequest = {
    delegatorAddr: "",
    srcValidatorAddr: "",
    dstValidatorAddr: ""
};
$2c38ecbf2748a0b4$exports.QueryRedelegationsRequest = {
    encode (message, writer = $2c38ecbf2748a0b4$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddr !== "") writer.uint32(10).string(message.delegatorAddr);
        if (message.srcValidatorAddr !== "") writer.uint32(18).string(message.srcValidatorAddr);
        if (message.dstValidatorAddr !== "") writer.uint32(26).string(message.dstValidatorAddr);
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageRequest.encode(message.pagination, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2c38ecbf2748a0b4$var$minimal_1.default.Reader ? input : new $2c38ecbf2748a0b4$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryRedelegationsRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.srcValidatorAddr = reader.string();
                    break;
                case 3:
                    message.dstValidatorAddr = reader.string();
                    break;
                case 4:
                    message.pagination = $f01b40e20607eb8e$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryRedelegationsRequest);
        message.delegatorAddr = object.delegatorAddr !== undefined && object.delegatorAddr !== null ? String(object.delegatorAddr) : "";
        message.srcValidatorAddr = object.srcValidatorAddr !== undefined && object.srcValidatorAddr !== null ? String(object.srcValidatorAddr) : "";
        message.dstValidatorAddr = object.dstValidatorAddr !== undefined && object.dstValidatorAddr !== null ? String(object.dstValidatorAddr) : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromJSON(object.pagination) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.srcValidatorAddr !== undefined && (obj.srcValidatorAddr = message.srcValidatorAddr);
        message.dstValidatorAddr !== undefined && (obj.dstValidatorAddr = message.dstValidatorAddr);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryRedelegationsRequest);
        message.delegatorAddr = (_a = object.delegatorAddr) !== null && _a !== void 0 ? _a : "";
        message.srcValidatorAddr = (_b = object.srcValidatorAddr) !== null && _b !== void 0 ? _b : "";
        message.dstValidatorAddr = (_c = object.dstValidatorAddr) !== null && _c !== void 0 ? _c : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
const $2c38ecbf2748a0b4$var$baseQueryRedelegationsResponse = {};
$2c38ecbf2748a0b4$exports.QueryRedelegationsResponse = {
    encode (message, writer = $2c38ecbf2748a0b4$var$minimal_1.default.Writer.create()) {
        for (const v of message.redelegationResponses)$73d6a52fa40919be$exports.RedelegationResponse.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2c38ecbf2748a0b4$var$minimal_1.default.Reader ? input : new $2c38ecbf2748a0b4$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryRedelegationsResponse);
        message.redelegationResponses = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.redelegationResponses.push($73d6a52fa40919be$exports.RedelegationResponse.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $f01b40e20607eb8e$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryRedelegationsResponse);
        message.redelegationResponses = ((_a = object.redelegationResponses) !== null && _a !== void 0 ? _a : []).map((e)=>$73d6a52fa40919be$exports.RedelegationResponse.fromJSON(e));
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromJSON(object.pagination) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.redelegationResponses) obj.redelegationResponses = message.redelegationResponses.map((e)=>e ? $73d6a52fa40919be$exports.RedelegationResponse.toJSON(e) : undefined);
        else obj.redelegationResponses = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryRedelegationsResponse);
        message.redelegationResponses = ((_a = object.redelegationResponses) === null || _a === void 0 ? void 0 : _a.map((e)=>$73d6a52fa40919be$exports.RedelegationResponse.fromPartial(e))) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
const $2c38ecbf2748a0b4$var$baseQueryDelegatorValidatorsRequest = {
    delegatorAddr: ""
};
$2c38ecbf2748a0b4$exports.QueryDelegatorValidatorsRequest = {
    encode (message, writer = $2c38ecbf2748a0b4$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddr !== "") writer.uint32(10).string(message.delegatorAddr);
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2c38ecbf2748a0b4$var$minimal_1.default.Reader ? input : new $2c38ecbf2748a0b4$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryDelegatorValidatorsRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.pagination = $f01b40e20607eb8e$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryDelegatorValidatorsRequest);
        message.delegatorAddr = object.delegatorAddr !== undefined && object.delegatorAddr !== null ? String(object.delegatorAddr) : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromJSON(object.pagination) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryDelegatorValidatorsRequest);
        message.delegatorAddr = (_a = object.delegatorAddr) !== null && _a !== void 0 ? _a : "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
const $2c38ecbf2748a0b4$var$baseQueryDelegatorValidatorsResponse = {};
$2c38ecbf2748a0b4$exports.QueryDelegatorValidatorsResponse = {
    encode (message, writer = $2c38ecbf2748a0b4$var$minimal_1.default.Writer.create()) {
        for (const v of message.validators)$73d6a52fa40919be$exports.Validator.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2c38ecbf2748a0b4$var$minimal_1.default.Reader ? input : new $2c38ecbf2748a0b4$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryDelegatorValidatorsResponse);
        message.validators = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validators.push($73d6a52fa40919be$exports.Validator.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $f01b40e20607eb8e$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryDelegatorValidatorsResponse);
        message.validators = ((_a = object.validators) !== null && _a !== void 0 ? _a : []).map((e)=>$73d6a52fa40919be$exports.Validator.fromJSON(e));
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromJSON(object.pagination) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.validators) obj.validators = message.validators.map((e)=>e ? $73d6a52fa40919be$exports.Validator.toJSON(e) : undefined);
        else obj.validators = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryDelegatorValidatorsResponse);
        message.validators = ((_a = object.validators) === null || _a === void 0 ? void 0 : _a.map((e)=>$73d6a52fa40919be$exports.Validator.fromPartial(e))) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
const $2c38ecbf2748a0b4$var$baseQueryDelegatorValidatorRequest = {
    delegatorAddr: "",
    validatorAddr: ""
};
$2c38ecbf2748a0b4$exports.QueryDelegatorValidatorRequest = {
    encode (message, writer = $2c38ecbf2748a0b4$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddr !== "") writer.uint32(10).string(message.delegatorAddr);
        if (message.validatorAddr !== "") writer.uint32(18).string(message.validatorAddr);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2c38ecbf2748a0b4$var$minimal_1.default.Reader ? input : new $2c38ecbf2748a0b4$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryDelegatorValidatorRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.validatorAddr = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryDelegatorValidatorRequest);
        message.delegatorAddr = object.delegatorAddr !== undefined && object.delegatorAddr !== null ? String(object.delegatorAddr) : "";
        message.validatorAddr = object.validatorAddr !== undefined && object.validatorAddr !== null ? String(object.validatorAddr) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.validatorAddr !== undefined && (obj.validatorAddr = message.validatorAddr);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryDelegatorValidatorRequest);
        message.delegatorAddr = (_a = object.delegatorAddr) !== null && _a !== void 0 ? _a : "";
        message.validatorAddr = (_b = object.validatorAddr) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
const $2c38ecbf2748a0b4$var$baseQueryDelegatorValidatorResponse = {};
$2c38ecbf2748a0b4$exports.QueryDelegatorValidatorResponse = {
    encode (message, writer = $2c38ecbf2748a0b4$var$minimal_1.default.Writer.create()) {
        if (message.validator !== undefined) $73d6a52fa40919be$exports.Validator.encode(message.validator, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2c38ecbf2748a0b4$var$minimal_1.default.Reader ? input : new $2c38ecbf2748a0b4$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryDelegatorValidatorResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validator = $73d6a52fa40919be$exports.Validator.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryDelegatorValidatorResponse);
        message.validator = object.validator !== undefined && object.validator !== null ? $73d6a52fa40919be$exports.Validator.fromJSON(object.validator) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.validator !== undefined && (obj.validator = message.validator ? $73d6a52fa40919be$exports.Validator.toJSON(message.validator) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryDelegatorValidatorResponse);
        message.validator = object.validator !== undefined && object.validator !== null ? $73d6a52fa40919be$exports.Validator.fromPartial(object.validator) : undefined;
        return message;
    }
};
const $2c38ecbf2748a0b4$var$baseQueryHistoricalInfoRequest = {
    height: $2c38ecbf2748a0b4$var$long_1.default.ZERO
};
$2c38ecbf2748a0b4$exports.QueryHistoricalInfoRequest = {
    encode (message, writer = $2c38ecbf2748a0b4$var$minimal_1.default.Writer.create()) {
        if (!message.height.isZero()) writer.uint32(8).int64(message.height);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2c38ecbf2748a0b4$var$minimal_1.default.Reader ? input : new $2c38ecbf2748a0b4$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryHistoricalInfoRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryHistoricalInfoRequest);
        message.height = object.height !== undefined && object.height !== null ? $2c38ecbf2748a0b4$var$long_1.default.fromString(object.height) : $2c38ecbf2748a0b4$var$long_1.default.ZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || $2c38ecbf2748a0b4$var$long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryHistoricalInfoRequest);
        message.height = object.height !== undefined && object.height !== null ? $2c38ecbf2748a0b4$var$long_1.default.fromValue(object.height) : $2c38ecbf2748a0b4$var$long_1.default.ZERO;
        return message;
    }
};
const $2c38ecbf2748a0b4$var$baseQueryHistoricalInfoResponse = {};
$2c38ecbf2748a0b4$exports.QueryHistoricalInfoResponse = {
    encode (message, writer = $2c38ecbf2748a0b4$var$minimal_1.default.Writer.create()) {
        if (message.hist !== undefined) $73d6a52fa40919be$exports.HistoricalInfo.encode(message.hist, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2c38ecbf2748a0b4$var$minimal_1.default.Reader ? input : new $2c38ecbf2748a0b4$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryHistoricalInfoResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hist = $73d6a52fa40919be$exports.HistoricalInfo.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryHistoricalInfoResponse);
        message.hist = object.hist !== undefined && object.hist !== null ? $73d6a52fa40919be$exports.HistoricalInfo.fromJSON(object.hist) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.hist !== undefined && (obj.hist = message.hist ? $73d6a52fa40919be$exports.HistoricalInfo.toJSON(message.hist) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryHistoricalInfoResponse);
        message.hist = object.hist !== undefined && object.hist !== null ? $73d6a52fa40919be$exports.HistoricalInfo.fromPartial(object.hist) : undefined;
        return message;
    }
};
const $2c38ecbf2748a0b4$var$baseQueryPoolRequest = {};
$2c38ecbf2748a0b4$exports.QueryPoolRequest = {
    encode (_, writer = $2c38ecbf2748a0b4$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2c38ecbf2748a0b4$var$minimal_1.default.Reader ? input : new $2c38ecbf2748a0b4$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryPoolRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryPoolRequest);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryPoolRequest);
        return message;
    }
};
const $2c38ecbf2748a0b4$var$baseQueryPoolResponse = {};
$2c38ecbf2748a0b4$exports.QueryPoolResponse = {
    encode (message, writer = $2c38ecbf2748a0b4$var$minimal_1.default.Writer.create()) {
        if (message.pool !== undefined) $73d6a52fa40919be$exports.Pool.encode(message.pool, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2c38ecbf2748a0b4$var$minimal_1.default.Reader ? input : new $2c38ecbf2748a0b4$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryPoolResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pool = $73d6a52fa40919be$exports.Pool.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryPoolResponse);
        message.pool = object.pool !== undefined && object.pool !== null ? $73d6a52fa40919be$exports.Pool.fromJSON(object.pool) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.pool !== undefined && (obj.pool = message.pool ? $73d6a52fa40919be$exports.Pool.toJSON(message.pool) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryPoolResponse);
        message.pool = object.pool !== undefined && object.pool !== null ? $73d6a52fa40919be$exports.Pool.fromPartial(object.pool) : undefined;
        return message;
    }
};
const $2c38ecbf2748a0b4$var$baseQueryParamsRequest = {};
$2c38ecbf2748a0b4$exports.QueryParamsRequest = {
    encode (_, writer = $2c38ecbf2748a0b4$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2c38ecbf2748a0b4$var$minimal_1.default.Reader ? input : new $2c38ecbf2748a0b4$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryParamsRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryParamsRequest);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryParamsRequest);
        return message;
    }
};
const $2c38ecbf2748a0b4$var$baseQueryParamsResponse = {};
$2c38ecbf2748a0b4$exports.QueryParamsResponse = {
    encode (message, writer = $2c38ecbf2748a0b4$var$minimal_1.default.Writer.create()) {
        if (message.params !== undefined) $73d6a52fa40919be$exports.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2c38ecbf2748a0b4$var$minimal_1.default.Reader ? input : new $2c38ecbf2748a0b4$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryParamsResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $73d6a52fa40919be$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryParamsResponse);
        message.params = object.params !== undefined && object.params !== null ? $73d6a52fa40919be$exports.Params.fromJSON(object.params) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? $73d6a52fa40919be$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $2c38ecbf2748a0b4$var$baseQueryParamsResponse);
        message.params = object.params !== undefined && object.params !== null ? $73d6a52fa40919be$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
class $2c38ecbf2748a0b4$var$QueryClientImpl {
    Validators(request) {
        const data = $2c38ecbf2748a0b4$exports.QueryValidatorsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Validators", data);
        return promise.then((data)=>$2c38ecbf2748a0b4$exports.QueryValidatorsResponse.decode(new $2c38ecbf2748a0b4$var$minimal_1.default.Reader(data)));
    }
    Validator(request) {
        const data = $2c38ecbf2748a0b4$exports.QueryValidatorRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Validator", data);
        return promise.then((data)=>$2c38ecbf2748a0b4$exports.QueryValidatorResponse.decode(new $2c38ecbf2748a0b4$var$minimal_1.default.Reader(data)));
    }
    ValidatorDelegations(request) {
        const data = $2c38ecbf2748a0b4$exports.QueryValidatorDelegationsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "ValidatorDelegations", data);
        return promise.then((data)=>$2c38ecbf2748a0b4$exports.QueryValidatorDelegationsResponse.decode(new $2c38ecbf2748a0b4$var$minimal_1.default.Reader(data)));
    }
    ValidatorUnbondingDelegations(request) {
        const data = $2c38ecbf2748a0b4$exports.QueryValidatorUnbondingDelegationsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "ValidatorUnbondingDelegations", data);
        return promise.then((data)=>$2c38ecbf2748a0b4$exports.QueryValidatorUnbondingDelegationsResponse.decode(new $2c38ecbf2748a0b4$var$minimal_1.default.Reader(data)));
    }
    Delegation(request) {
        const data = $2c38ecbf2748a0b4$exports.QueryDelegationRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Delegation", data);
        return promise.then((data)=>$2c38ecbf2748a0b4$exports.QueryDelegationResponse.decode(new $2c38ecbf2748a0b4$var$minimal_1.default.Reader(data)));
    }
    UnbondingDelegation(request) {
        const data = $2c38ecbf2748a0b4$exports.QueryUnbondingDelegationRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "UnbondingDelegation", data);
        return promise.then((data)=>$2c38ecbf2748a0b4$exports.QueryUnbondingDelegationResponse.decode(new $2c38ecbf2748a0b4$var$minimal_1.default.Reader(data)));
    }
    DelegatorDelegations(request) {
        const data = $2c38ecbf2748a0b4$exports.QueryDelegatorDelegationsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "DelegatorDelegations", data);
        return promise.then((data)=>$2c38ecbf2748a0b4$exports.QueryDelegatorDelegationsResponse.decode(new $2c38ecbf2748a0b4$var$minimal_1.default.Reader(data)));
    }
    DelegatorUnbondingDelegations(request) {
        const data = $2c38ecbf2748a0b4$exports.QueryDelegatorUnbondingDelegationsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "DelegatorUnbondingDelegations", data);
        return promise.then((data)=>$2c38ecbf2748a0b4$exports.QueryDelegatorUnbondingDelegationsResponse.decode(new $2c38ecbf2748a0b4$var$minimal_1.default.Reader(data)));
    }
    Redelegations(request) {
        const data = $2c38ecbf2748a0b4$exports.QueryRedelegationsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Redelegations", data);
        return promise.then((data)=>$2c38ecbf2748a0b4$exports.QueryRedelegationsResponse.decode(new $2c38ecbf2748a0b4$var$minimal_1.default.Reader(data)));
    }
    DelegatorValidators(request) {
        const data = $2c38ecbf2748a0b4$exports.QueryDelegatorValidatorsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "DelegatorValidators", data);
        return promise.then((data)=>$2c38ecbf2748a0b4$exports.QueryDelegatorValidatorsResponse.decode(new $2c38ecbf2748a0b4$var$minimal_1.default.Reader(data)));
    }
    DelegatorValidator(request) {
        const data = $2c38ecbf2748a0b4$exports.QueryDelegatorValidatorRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "DelegatorValidator", data);
        return promise.then((data)=>$2c38ecbf2748a0b4$exports.QueryDelegatorValidatorResponse.decode(new $2c38ecbf2748a0b4$var$minimal_1.default.Reader(data)));
    }
    HistoricalInfo(request) {
        const data = $2c38ecbf2748a0b4$exports.QueryHistoricalInfoRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "HistoricalInfo", data);
        return promise.then((data)=>$2c38ecbf2748a0b4$exports.QueryHistoricalInfoResponse.decode(new $2c38ecbf2748a0b4$var$minimal_1.default.Reader(data)));
    }
    Pool(request) {
        const data = $2c38ecbf2748a0b4$exports.QueryPoolRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Pool", data);
        return promise.then((data)=>$2c38ecbf2748a0b4$exports.QueryPoolResponse.decode(new $2c38ecbf2748a0b4$var$minimal_1.default.Reader(data)));
    }
    Params(request) {
        const data = $2c38ecbf2748a0b4$exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Params", data);
        return promise.then((data)=>$2c38ecbf2748a0b4$exports.QueryParamsResponse.decode(new $2c38ecbf2748a0b4$var$minimal_1.default.Reader(data)));
    }
    constructor(rpc){
        this.rpc = rpc;
        this.Validators = this.Validators.bind(this);
        this.Validator = this.Validator.bind(this);
        this.ValidatorDelegations = this.ValidatorDelegations.bind(this);
        this.ValidatorUnbondingDelegations = this.ValidatorUnbondingDelegations.bind(this);
        this.Delegation = this.Delegation.bind(this);
        this.UnbondingDelegation = this.UnbondingDelegation.bind(this);
        this.DelegatorDelegations = this.DelegatorDelegations.bind(this);
        this.DelegatorUnbondingDelegations = this.DelegatorUnbondingDelegations.bind(this);
        this.Redelegations = this.Redelegations.bind(this);
        this.DelegatorValidators = this.DelegatorValidators.bind(this);
        this.DelegatorValidator = this.DelegatorValidator.bind(this);
        this.HistoricalInfo = this.HistoricalInfo.bind(this);
        this.Pool = this.Pool.bind(this);
        this.Params = this.Params.bind(this);
    }
}
$2c38ecbf2748a0b4$exports.QueryClientImpl = $2c38ecbf2748a0b4$var$QueryClientImpl;
if ($2c38ecbf2748a0b4$var$minimal_1.default.util.Long !== $2c38ecbf2748a0b4$var$long_1.default) {
    $2c38ecbf2748a0b4$var$minimal_1.default.util.Long = $2c38ecbf2748a0b4$var$long_1.default;
    $2c38ecbf2748a0b4$var$minimal_1.default.configure();
}



const $7d4764ca152ad318$var$long_1 = $7d4764ca152ad318$var$__importDefault((parcelRequire("9A55m")));

function $7d4764ca152ad318$var$setupStakingExtension(base) {
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const rpc = (0, $ffdede50deec576f$exports.createProtobufRpcClient)(base);
    const queryService = new $2c38ecbf2748a0b4$exports.QueryClientImpl(rpc);
    return {
        staking: {
            delegation: async (delegatorAddress, validatorAddress)=>{
                const response = await queryService.Delegation({
                    delegatorAddr: delegatorAddress,
                    validatorAddr: validatorAddress
                });
                return response;
            },
            delegatorDelegations: async (delegatorAddress, paginationKey)=>{
                const response = await queryService.DelegatorDelegations({
                    delegatorAddr: delegatorAddress,
                    pagination: (0, $ffdede50deec576f$exports.createPagination)(paginationKey)
                });
                return response;
            },
            delegatorUnbondingDelegations: async (delegatorAddress, paginationKey)=>{
                const response = await queryService.DelegatorUnbondingDelegations({
                    delegatorAddr: delegatorAddress,
                    pagination: (0, $ffdede50deec576f$exports.createPagination)(paginationKey)
                });
                return response;
            },
            delegatorValidator: async (delegatorAddress, validatorAddress)=>{
                const response = await queryService.DelegatorValidator({
                    delegatorAddr: delegatorAddress,
                    validatorAddr: validatorAddress
                });
                return response;
            },
            delegatorValidators: async (delegatorAddress, paginationKey)=>{
                const response = await queryService.DelegatorValidators({
                    delegatorAddr: delegatorAddress,
                    pagination: (0, $ffdede50deec576f$exports.createPagination)(paginationKey)
                });
                return response;
            },
            historicalInfo: async (height)=>{
                const response = await queryService.HistoricalInfo({
                    height: $7d4764ca152ad318$var$long_1.default.fromNumber(height, true)
                });
                return response;
            },
            params: async ()=>{
                const response = await queryService.Params({});
                return response;
            },
            pool: async ()=>{
                const response = await queryService.Pool({});
                return response;
            },
            redelegations: async (delegatorAddress, sourceValidatorAddress, destinationValidatorAddress, paginationKey)=>{
                const response = await queryService.Redelegations({
                    delegatorAddr: delegatorAddress,
                    srcValidatorAddr: sourceValidatorAddress,
                    dstValidatorAddr: destinationValidatorAddress,
                    pagination: (0, $ffdede50deec576f$exports.createPagination)(paginationKey)
                });
                return response;
            },
            unbondingDelegation: async (delegatorAddress, validatorAddress)=>{
                const response = await queryService.UnbondingDelegation({
                    delegatorAddr: delegatorAddress,
                    validatorAddr: validatorAddress
                });
                return response;
            },
            validator: async (validatorAddress)=>{
                const response = await queryService.Validator({
                    validatorAddr: validatorAddress
                });
                return response;
            },
            validatorDelegations: async (validatorAddress, paginationKey)=>{
                const response = await queryService.ValidatorDelegations({
                    validatorAddr: validatorAddress,
                    pagination: (0, $ffdede50deec576f$exports.createPagination)(paginationKey)
                });
                return response;
            },
            validators: async (status, paginationKey)=>{
                const response = await queryService.Validators({
                    status: status,
                    pagination: (0, $ffdede50deec576f$exports.createPagination)(paginationKey)
                });
                return response;
            },
            validatorUnbondingDelegations: async (validatorAddress, paginationKey)=>{
                const response = await queryService.ValidatorUnbondingDelegations({
                    validatorAddr: validatorAddress,
                    pagination: (0, $ffdede50deec576f$exports.createPagination)(paginationKey)
                });
                return response;
            }
        }
    };
}
$7d4764ca152ad318$exports.setupStakingExtension = $7d4764ca152ad318$var$setupStakingExtension;


Object.defineProperty($7725f2e3ca016b52$exports, "setupStakingExtension", {
    enumerable: true,
    get: function() {
        return $7d4764ca152ad318$exports.setupStakingExtension;
    }
});
var $252fdb30ead3e767$exports = {};
"use strict";
var $252fdb30ead3e767$var$__importDefault = $252fdb30ead3e767$exports && $252fdb30ead3e767$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($252fdb30ead3e767$exports, "__esModule", {
    value: true
});
$252fdb30ead3e767$exports.setupTxExtension = void 0;


var $fa044eea89982613$exports = {};
"use strict";
var $fa044eea89982613$var$__importDefault = $fa044eea89982613$exports && $fa044eea89982613$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($fa044eea89982613$exports, "__esModule", {
    value: true
});
$fa044eea89982613$exports.ServiceClientImpl = $fa044eea89982613$exports.GetTxResponse = $fa044eea89982613$exports.GetTxRequest = $fa044eea89982613$exports.SimulateResponse = $fa044eea89982613$exports.SimulateRequest = $fa044eea89982613$exports.BroadcastTxResponse = $fa044eea89982613$exports.BroadcastTxRequest = $fa044eea89982613$exports.GetTxsEventResponse = $fa044eea89982613$exports.GetTxsEventRequest = $fa044eea89982613$exports.broadcastModeToJSON = $fa044eea89982613$exports.broadcastModeFromJSON = $fa044eea89982613$exports.BroadcastMode = $fa044eea89982613$exports.orderByToJSON = $fa044eea89982613$exports.orderByFromJSON = $fa044eea89982613$exports.OrderBy = $fa044eea89982613$exports.protobufPackage = void 0;

/* eslint-disable */ const $fa044eea89982613$var$long_1 = $fa044eea89982613$var$__importDefault((parcelRequire("9A55m")));

const $fa044eea89982613$var$minimal_1 = $fa044eea89982613$var$__importDefault((parcelRequire("i2pIU")));

var $da5fef019d15e5f1$exports = {};
"use strict";
var $da5fef019d15e5f1$var$__importDefault = $da5fef019d15e5f1$exports && $da5fef019d15e5f1$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($da5fef019d15e5f1$exports, "__esModule", {
    value: true
});
$da5fef019d15e5f1$exports.SearchTxsResult = $da5fef019d15e5f1$exports.TxMsgData = $da5fef019d15e5f1$exports.MsgData = $da5fef019d15e5f1$exports.SimulationResponse = $da5fef019d15e5f1$exports.Result = $da5fef019d15e5f1$exports.GasInfo = $da5fef019d15e5f1$exports.Attribute = $da5fef019d15e5f1$exports.StringEvent = $da5fef019d15e5f1$exports.ABCIMessageLog = $da5fef019d15e5f1$exports.TxResponse = $da5fef019d15e5f1$exports.protobufPackage = void 0;

/* eslint-disable */ const $da5fef019d15e5f1$var$long_1 = $da5fef019d15e5f1$var$__importDefault((parcelRequire("9A55m")));

const $da5fef019d15e5f1$var$minimal_1 = $da5fef019d15e5f1$var$__importDefault((parcelRequire("i2pIU")));

var $bbde53696c124e5e$exports = {};
"use strict";
var $bbde53696c124e5e$var$__importDefault = $bbde53696c124e5e$exports && $bbde53696c124e5e$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($bbde53696c124e5e$exports, "__esModule", {
    value: true
});
$bbde53696c124e5e$exports.Event = $bbde53696c124e5e$exports.LastCommitInfo = $bbde53696c124e5e$exports.BlockParams = $bbde53696c124e5e$exports.ConsensusParams = $bbde53696c124e5e$exports.ResponseApplySnapshotChunk = $bbde53696c124e5e$exports.ResponseLoadSnapshotChunk = $bbde53696c124e5e$exports.ResponseOfferSnapshot = $bbde53696c124e5e$exports.ResponseListSnapshots = $bbde53696c124e5e$exports.ResponseCommit = $bbde53696c124e5e$exports.ResponseEndBlock = $bbde53696c124e5e$exports.ResponseDeliverTx = $bbde53696c124e5e$exports.ResponseCheckTx = $bbde53696c124e5e$exports.ResponseBeginBlock = $bbde53696c124e5e$exports.ResponseQuery = $bbde53696c124e5e$exports.ResponseInitChain = $bbde53696c124e5e$exports.ResponseSetOption = $bbde53696c124e5e$exports.ResponseInfo = $bbde53696c124e5e$exports.ResponseFlush = $bbde53696c124e5e$exports.ResponseEcho = $bbde53696c124e5e$exports.ResponseException = $bbde53696c124e5e$exports.Response = $bbde53696c124e5e$exports.RequestApplySnapshotChunk = $bbde53696c124e5e$exports.RequestLoadSnapshotChunk = $bbde53696c124e5e$exports.RequestOfferSnapshot = $bbde53696c124e5e$exports.RequestListSnapshots = $bbde53696c124e5e$exports.RequestCommit = $bbde53696c124e5e$exports.RequestEndBlock = $bbde53696c124e5e$exports.RequestDeliverTx = $bbde53696c124e5e$exports.RequestCheckTx = $bbde53696c124e5e$exports.RequestBeginBlock = $bbde53696c124e5e$exports.RequestQuery = $bbde53696c124e5e$exports.RequestInitChain = $bbde53696c124e5e$exports.RequestSetOption = $bbde53696c124e5e$exports.RequestInfo = $bbde53696c124e5e$exports.RequestFlush = $bbde53696c124e5e$exports.RequestEcho = $bbde53696c124e5e$exports.Request = $bbde53696c124e5e$exports.responseApplySnapshotChunk_ResultToJSON = $bbde53696c124e5e$exports.responseApplySnapshotChunk_ResultFromJSON = $bbde53696c124e5e$exports.ResponseApplySnapshotChunk_Result = $bbde53696c124e5e$exports.responseOfferSnapshot_ResultToJSON = $bbde53696c124e5e$exports.responseOfferSnapshot_ResultFromJSON = $bbde53696c124e5e$exports.ResponseOfferSnapshot_Result = $bbde53696c124e5e$exports.evidenceTypeToJSON = $bbde53696c124e5e$exports.evidenceTypeFromJSON = $bbde53696c124e5e$exports.EvidenceType = $bbde53696c124e5e$exports.checkTxTypeToJSON = $bbde53696c124e5e$exports.checkTxTypeFromJSON = $bbde53696c124e5e$exports.CheckTxType = $bbde53696c124e5e$exports.protobufPackage = void 0;
$bbde53696c124e5e$exports.ABCIApplicationClientImpl = $bbde53696c124e5e$exports.Snapshot = $bbde53696c124e5e$exports.Evidence = $bbde53696c124e5e$exports.VoteInfo = $bbde53696c124e5e$exports.ValidatorUpdate = $bbde53696c124e5e$exports.Validator = $bbde53696c124e5e$exports.TxResult = $bbde53696c124e5e$exports.EventAttribute = void 0;

/* eslint-disable */ const $bbde53696c124e5e$var$long_1 = $bbde53696c124e5e$var$__importDefault((parcelRequire("9A55m")));

const $bbde53696c124e5e$var$minimal_1 = $bbde53696c124e5e$var$__importDefault((parcelRequire("i2pIU")));



var $8f32fca53ba3eb82$exports = {};
"use strict";
var $8f32fca53ba3eb82$var$__importDefault = $8f32fca53ba3eb82$exports && $8f32fca53ba3eb82$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($8f32fca53ba3eb82$exports, "__esModule", {
    value: true
});
$8f32fca53ba3eb82$exports.HashedParams = $8f32fca53ba3eb82$exports.VersionParams = $8f32fca53ba3eb82$exports.ValidatorParams = $8f32fca53ba3eb82$exports.EvidenceParams = $8f32fca53ba3eb82$exports.BlockParams = $8f32fca53ba3eb82$exports.ConsensusParams = $8f32fca53ba3eb82$exports.protobufPackage = void 0;

/* eslint-disable */ const $8f32fca53ba3eb82$var$long_1 = $8f32fca53ba3eb82$var$__importDefault((parcelRequire("9A55m")));

const $8f32fca53ba3eb82$var$minimal_1 = $8f32fca53ba3eb82$var$__importDefault((parcelRequire("i2pIU")));

$8f32fca53ba3eb82$exports.protobufPackage = "tendermint.types";
const $8f32fca53ba3eb82$var$baseConsensusParams = {};
$8f32fca53ba3eb82$exports.ConsensusParams = {
    encode (message, writer = $8f32fca53ba3eb82$var$minimal_1.default.Writer.create()) {
        if (message.block !== undefined) $8f32fca53ba3eb82$exports.BlockParams.encode(message.block, writer.uint32(10).fork()).ldelim();
        if (message.evidence !== undefined) $8f32fca53ba3eb82$exports.EvidenceParams.encode(message.evidence, writer.uint32(18).fork()).ldelim();
        if (message.validator !== undefined) $8f32fca53ba3eb82$exports.ValidatorParams.encode(message.validator, writer.uint32(26).fork()).ldelim();
        if (message.version !== undefined) $8f32fca53ba3eb82$exports.VersionParams.encode(message.version, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8f32fca53ba3eb82$var$minimal_1.default.Reader ? input : new $8f32fca53ba3eb82$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $8f32fca53ba3eb82$var$baseConsensusParams);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.block = $8f32fca53ba3eb82$exports.BlockParams.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.evidence = $8f32fca53ba3eb82$exports.EvidenceParams.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.validator = $8f32fca53ba3eb82$exports.ValidatorParams.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.version = $8f32fca53ba3eb82$exports.VersionParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $8f32fca53ba3eb82$var$baseConsensusParams);
        message.block = object.block !== undefined && object.block !== null ? $8f32fca53ba3eb82$exports.BlockParams.fromJSON(object.block) : undefined;
        message.evidence = object.evidence !== undefined && object.evidence !== null ? $8f32fca53ba3eb82$exports.EvidenceParams.fromJSON(object.evidence) : undefined;
        message.validator = object.validator !== undefined && object.validator !== null ? $8f32fca53ba3eb82$exports.ValidatorParams.fromJSON(object.validator) : undefined;
        message.version = object.version !== undefined && object.version !== null ? $8f32fca53ba3eb82$exports.VersionParams.fromJSON(object.version) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.block !== undefined && (obj.block = message.block ? $8f32fca53ba3eb82$exports.BlockParams.toJSON(message.block) : undefined);
        message.evidence !== undefined && (obj.evidence = message.evidence ? $8f32fca53ba3eb82$exports.EvidenceParams.toJSON(message.evidence) : undefined);
        message.validator !== undefined && (obj.validator = message.validator ? $8f32fca53ba3eb82$exports.ValidatorParams.toJSON(message.validator) : undefined);
        message.version !== undefined && (obj.version = message.version ? $8f32fca53ba3eb82$exports.VersionParams.toJSON(message.version) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $8f32fca53ba3eb82$var$baseConsensusParams);
        message.block = object.block !== undefined && object.block !== null ? $8f32fca53ba3eb82$exports.BlockParams.fromPartial(object.block) : undefined;
        message.evidence = object.evidence !== undefined && object.evidence !== null ? $8f32fca53ba3eb82$exports.EvidenceParams.fromPartial(object.evidence) : undefined;
        message.validator = object.validator !== undefined && object.validator !== null ? $8f32fca53ba3eb82$exports.ValidatorParams.fromPartial(object.validator) : undefined;
        message.version = object.version !== undefined && object.version !== null ? $8f32fca53ba3eb82$exports.VersionParams.fromPartial(object.version) : undefined;
        return message;
    }
};
const $8f32fca53ba3eb82$var$baseBlockParams = {
    maxBytes: $8f32fca53ba3eb82$var$long_1.default.ZERO,
    maxGas: $8f32fca53ba3eb82$var$long_1.default.ZERO,
    timeIotaMs: $8f32fca53ba3eb82$var$long_1.default.ZERO
};
$8f32fca53ba3eb82$exports.BlockParams = {
    encode (message, writer = $8f32fca53ba3eb82$var$minimal_1.default.Writer.create()) {
        if (!message.maxBytes.isZero()) writer.uint32(8).int64(message.maxBytes);
        if (!message.maxGas.isZero()) writer.uint32(16).int64(message.maxGas);
        if (!message.timeIotaMs.isZero()) writer.uint32(24).int64(message.timeIotaMs);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8f32fca53ba3eb82$var$minimal_1.default.Reader ? input : new $8f32fca53ba3eb82$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $8f32fca53ba3eb82$var$baseBlockParams);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.maxBytes = reader.int64();
                    break;
                case 2:
                    message.maxGas = reader.int64();
                    break;
                case 3:
                    message.timeIotaMs = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $8f32fca53ba3eb82$var$baseBlockParams);
        message.maxBytes = object.maxBytes !== undefined && object.maxBytes !== null ? $8f32fca53ba3eb82$var$long_1.default.fromString(object.maxBytes) : $8f32fca53ba3eb82$var$long_1.default.ZERO;
        message.maxGas = object.maxGas !== undefined && object.maxGas !== null ? $8f32fca53ba3eb82$var$long_1.default.fromString(object.maxGas) : $8f32fca53ba3eb82$var$long_1.default.ZERO;
        message.timeIotaMs = object.timeIotaMs !== undefined && object.timeIotaMs !== null ? $8f32fca53ba3eb82$var$long_1.default.fromString(object.timeIotaMs) : $8f32fca53ba3eb82$var$long_1.default.ZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.maxBytes !== undefined && (obj.maxBytes = (message.maxBytes || $8f32fca53ba3eb82$var$long_1.default.ZERO).toString());
        message.maxGas !== undefined && (obj.maxGas = (message.maxGas || $8f32fca53ba3eb82$var$long_1.default.ZERO).toString());
        message.timeIotaMs !== undefined && (obj.timeIotaMs = (message.timeIotaMs || $8f32fca53ba3eb82$var$long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $8f32fca53ba3eb82$var$baseBlockParams);
        message.maxBytes = object.maxBytes !== undefined && object.maxBytes !== null ? $8f32fca53ba3eb82$var$long_1.default.fromValue(object.maxBytes) : $8f32fca53ba3eb82$var$long_1.default.ZERO;
        message.maxGas = object.maxGas !== undefined && object.maxGas !== null ? $8f32fca53ba3eb82$var$long_1.default.fromValue(object.maxGas) : $8f32fca53ba3eb82$var$long_1.default.ZERO;
        message.timeIotaMs = object.timeIotaMs !== undefined && object.timeIotaMs !== null ? $8f32fca53ba3eb82$var$long_1.default.fromValue(object.timeIotaMs) : $8f32fca53ba3eb82$var$long_1.default.ZERO;
        return message;
    }
};
const $8f32fca53ba3eb82$var$baseEvidenceParams = {
    maxAgeNumBlocks: $8f32fca53ba3eb82$var$long_1.default.ZERO,
    maxBytes: $8f32fca53ba3eb82$var$long_1.default.ZERO
};
$8f32fca53ba3eb82$exports.EvidenceParams = {
    encode (message, writer = $8f32fca53ba3eb82$var$minimal_1.default.Writer.create()) {
        if (!message.maxAgeNumBlocks.isZero()) writer.uint32(8).int64(message.maxAgeNumBlocks);
        if (message.maxAgeDuration !== undefined) $ad1f748ecd469446$exports.Duration.encode(message.maxAgeDuration, writer.uint32(18).fork()).ldelim();
        if (!message.maxBytes.isZero()) writer.uint32(24).int64(message.maxBytes);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8f32fca53ba3eb82$var$minimal_1.default.Reader ? input : new $8f32fca53ba3eb82$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $8f32fca53ba3eb82$var$baseEvidenceParams);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.maxAgeNumBlocks = reader.int64();
                    break;
                case 2:
                    message.maxAgeDuration = $ad1f748ecd469446$exports.Duration.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.maxBytes = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $8f32fca53ba3eb82$var$baseEvidenceParams);
        message.maxAgeNumBlocks = object.maxAgeNumBlocks !== undefined && object.maxAgeNumBlocks !== null ? $8f32fca53ba3eb82$var$long_1.default.fromString(object.maxAgeNumBlocks) : $8f32fca53ba3eb82$var$long_1.default.ZERO;
        message.maxAgeDuration = object.maxAgeDuration !== undefined && object.maxAgeDuration !== null ? $ad1f748ecd469446$exports.Duration.fromJSON(object.maxAgeDuration) : undefined;
        message.maxBytes = object.maxBytes !== undefined && object.maxBytes !== null ? $8f32fca53ba3eb82$var$long_1.default.fromString(object.maxBytes) : $8f32fca53ba3eb82$var$long_1.default.ZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.maxAgeNumBlocks !== undefined && (obj.maxAgeNumBlocks = (message.maxAgeNumBlocks || $8f32fca53ba3eb82$var$long_1.default.ZERO).toString());
        message.maxAgeDuration !== undefined && (obj.maxAgeDuration = message.maxAgeDuration ? $ad1f748ecd469446$exports.Duration.toJSON(message.maxAgeDuration) : undefined);
        message.maxBytes !== undefined && (obj.maxBytes = (message.maxBytes || $8f32fca53ba3eb82$var$long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $8f32fca53ba3eb82$var$baseEvidenceParams);
        message.maxAgeNumBlocks = object.maxAgeNumBlocks !== undefined && object.maxAgeNumBlocks !== null ? $8f32fca53ba3eb82$var$long_1.default.fromValue(object.maxAgeNumBlocks) : $8f32fca53ba3eb82$var$long_1.default.ZERO;
        message.maxAgeDuration = object.maxAgeDuration !== undefined && object.maxAgeDuration !== null ? $ad1f748ecd469446$exports.Duration.fromPartial(object.maxAgeDuration) : undefined;
        message.maxBytes = object.maxBytes !== undefined && object.maxBytes !== null ? $8f32fca53ba3eb82$var$long_1.default.fromValue(object.maxBytes) : $8f32fca53ba3eb82$var$long_1.default.ZERO;
        return message;
    }
};
const $8f32fca53ba3eb82$var$baseValidatorParams = {
    pubKeyTypes: ""
};
$8f32fca53ba3eb82$exports.ValidatorParams = {
    encode (message, writer = $8f32fca53ba3eb82$var$minimal_1.default.Writer.create()) {
        for (const v of message.pubKeyTypes)writer.uint32(10).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8f32fca53ba3eb82$var$minimal_1.default.Reader ? input : new $8f32fca53ba3eb82$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $8f32fca53ba3eb82$var$baseValidatorParams);
        message.pubKeyTypes = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pubKeyTypes.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $8f32fca53ba3eb82$var$baseValidatorParams);
        message.pubKeyTypes = ((_a = object.pubKeyTypes) !== null && _a !== void 0 ? _a : []).map((e)=>String(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.pubKeyTypes) obj.pubKeyTypes = message.pubKeyTypes.map((e)=>e);
        else obj.pubKeyTypes = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $8f32fca53ba3eb82$var$baseValidatorParams);
        message.pubKeyTypes = ((_a = object.pubKeyTypes) === null || _a === void 0 ? void 0 : _a.map((e)=>e)) || [];
        return message;
    }
};
const $8f32fca53ba3eb82$var$baseVersionParams = {
    appVersion: $8f32fca53ba3eb82$var$long_1.default.UZERO
};
$8f32fca53ba3eb82$exports.VersionParams = {
    encode (message, writer = $8f32fca53ba3eb82$var$minimal_1.default.Writer.create()) {
        if (!message.appVersion.isZero()) writer.uint32(8).uint64(message.appVersion);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8f32fca53ba3eb82$var$minimal_1.default.Reader ? input : new $8f32fca53ba3eb82$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $8f32fca53ba3eb82$var$baseVersionParams);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.appVersion = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $8f32fca53ba3eb82$var$baseVersionParams);
        message.appVersion = object.appVersion !== undefined && object.appVersion !== null ? $8f32fca53ba3eb82$var$long_1.default.fromString(object.appVersion) : $8f32fca53ba3eb82$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.appVersion !== undefined && (obj.appVersion = (message.appVersion || $8f32fca53ba3eb82$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $8f32fca53ba3eb82$var$baseVersionParams);
        message.appVersion = object.appVersion !== undefined && object.appVersion !== null ? $8f32fca53ba3eb82$var$long_1.default.fromValue(object.appVersion) : $8f32fca53ba3eb82$var$long_1.default.UZERO;
        return message;
    }
};
const $8f32fca53ba3eb82$var$baseHashedParams = {
    blockMaxBytes: $8f32fca53ba3eb82$var$long_1.default.ZERO,
    blockMaxGas: $8f32fca53ba3eb82$var$long_1.default.ZERO
};
$8f32fca53ba3eb82$exports.HashedParams = {
    encode (message, writer = $8f32fca53ba3eb82$var$minimal_1.default.Writer.create()) {
        if (!message.blockMaxBytes.isZero()) writer.uint32(8).int64(message.blockMaxBytes);
        if (!message.blockMaxGas.isZero()) writer.uint32(16).int64(message.blockMaxGas);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8f32fca53ba3eb82$var$minimal_1.default.Reader ? input : new $8f32fca53ba3eb82$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $8f32fca53ba3eb82$var$baseHashedParams);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.blockMaxBytes = reader.int64();
                    break;
                case 2:
                    message.blockMaxGas = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $8f32fca53ba3eb82$var$baseHashedParams);
        message.blockMaxBytes = object.blockMaxBytes !== undefined && object.blockMaxBytes !== null ? $8f32fca53ba3eb82$var$long_1.default.fromString(object.blockMaxBytes) : $8f32fca53ba3eb82$var$long_1.default.ZERO;
        message.blockMaxGas = object.blockMaxGas !== undefined && object.blockMaxGas !== null ? $8f32fca53ba3eb82$var$long_1.default.fromString(object.blockMaxGas) : $8f32fca53ba3eb82$var$long_1.default.ZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.blockMaxBytes !== undefined && (obj.blockMaxBytes = (message.blockMaxBytes || $8f32fca53ba3eb82$var$long_1.default.ZERO).toString());
        message.blockMaxGas !== undefined && (obj.blockMaxGas = (message.blockMaxGas || $8f32fca53ba3eb82$var$long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $8f32fca53ba3eb82$var$baseHashedParams);
        message.blockMaxBytes = object.blockMaxBytes !== undefined && object.blockMaxBytes !== null ? $8f32fca53ba3eb82$var$long_1.default.fromValue(object.blockMaxBytes) : $8f32fca53ba3eb82$var$long_1.default.ZERO;
        message.blockMaxGas = object.blockMaxGas !== undefined && object.blockMaxGas !== null ? $8f32fca53ba3eb82$var$long_1.default.fromValue(object.blockMaxGas) : $8f32fca53ba3eb82$var$long_1.default.ZERO;
        return message;
    }
};
if ($8f32fca53ba3eb82$var$minimal_1.default.util.Long !== $8f32fca53ba3eb82$var$long_1.default) {
    $8f32fca53ba3eb82$var$minimal_1.default.util.Long = $8f32fca53ba3eb82$var$long_1.default;
    $8f32fca53ba3eb82$var$minimal_1.default.configure();
}



$bbde53696c124e5e$exports.protobufPackage = "tendermint.abci";
var $bbde53696c124e5e$var$CheckTxType;
(function(CheckTxType) {
    CheckTxType[CheckTxType["NEW"] = 0] = "NEW";
    CheckTxType[CheckTxType["RECHECK"] = 1] = "RECHECK";
    CheckTxType[CheckTxType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($bbde53696c124e5e$var$CheckTxType = $bbde53696c124e5e$exports.CheckTxType || ($bbde53696c124e5e$exports.CheckTxType = {}));
function $bbde53696c124e5e$var$checkTxTypeFromJSON(object) {
    switch(object){
        case 0:
        case "NEW":
            return $bbde53696c124e5e$var$CheckTxType.NEW;
        case 1:
        case "RECHECK":
            return $bbde53696c124e5e$var$CheckTxType.RECHECK;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $bbde53696c124e5e$var$CheckTxType.UNRECOGNIZED;
    }
}
$bbde53696c124e5e$exports.checkTxTypeFromJSON = $bbde53696c124e5e$var$checkTxTypeFromJSON;
function $bbde53696c124e5e$var$checkTxTypeToJSON(object) {
    switch(object){
        case $bbde53696c124e5e$var$CheckTxType.NEW:
            return "NEW";
        case $bbde53696c124e5e$var$CheckTxType.RECHECK:
            return "RECHECK";
        default:
            return "UNKNOWN";
    }
}
$bbde53696c124e5e$exports.checkTxTypeToJSON = $bbde53696c124e5e$var$checkTxTypeToJSON;
var $bbde53696c124e5e$var$EvidenceType;
(function(EvidenceType) {
    EvidenceType[EvidenceType["UNKNOWN"] = 0] = "UNKNOWN";
    EvidenceType[EvidenceType["DUPLICATE_VOTE"] = 1] = "DUPLICATE_VOTE";
    EvidenceType[EvidenceType["LIGHT_CLIENT_ATTACK"] = 2] = "LIGHT_CLIENT_ATTACK";
    EvidenceType[EvidenceType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($bbde53696c124e5e$var$EvidenceType = $bbde53696c124e5e$exports.EvidenceType || ($bbde53696c124e5e$exports.EvidenceType = {}));
function $bbde53696c124e5e$var$evidenceTypeFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN":
            return $bbde53696c124e5e$var$EvidenceType.UNKNOWN;
        case 1:
        case "DUPLICATE_VOTE":
            return $bbde53696c124e5e$var$EvidenceType.DUPLICATE_VOTE;
        case 2:
        case "LIGHT_CLIENT_ATTACK":
            return $bbde53696c124e5e$var$EvidenceType.LIGHT_CLIENT_ATTACK;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $bbde53696c124e5e$var$EvidenceType.UNRECOGNIZED;
    }
}
$bbde53696c124e5e$exports.evidenceTypeFromJSON = $bbde53696c124e5e$var$evidenceTypeFromJSON;
function $bbde53696c124e5e$var$evidenceTypeToJSON(object) {
    switch(object){
        case $bbde53696c124e5e$var$EvidenceType.UNKNOWN:
            return "UNKNOWN";
        case $bbde53696c124e5e$var$EvidenceType.DUPLICATE_VOTE:
            return "DUPLICATE_VOTE";
        case $bbde53696c124e5e$var$EvidenceType.LIGHT_CLIENT_ATTACK:
            return "LIGHT_CLIENT_ATTACK";
        default:
            return "UNKNOWN";
    }
}
$bbde53696c124e5e$exports.evidenceTypeToJSON = $bbde53696c124e5e$var$evidenceTypeToJSON;
var $bbde53696c124e5e$var$ResponseOfferSnapshot_Result;
(function(ResponseOfferSnapshot_Result) {
    /** UNKNOWN - Unknown result, abort all snapshot restoration */ ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["UNKNOWN"] = 0] = "UNKNOWN";
    /** ACCEPT - Snapshot accepted, apply chunks */ ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["ACCEPT"] = 1] = "ACCEPT";
    /** ABORT - Abort all snapshot restoration */ ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["ABORT"] = 2] = "ABORT";
    /** REJECT - Reject this specific snapshot, try others */ ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["REJECT"] = 3] = "REJECT";
    /** REJECT_FORMAT - Reject all snapshots of this format, try others */ ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["REJECT_FORMAT"] = 4] = "REJECT_FORMAT";
    /** REJECT_SENDER - Reject all snapshots from the sender(s), try others */ ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["REJECT_SENDER"] = 5] = "REJECT_SENDER";
    ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($bbde53696c124e5e$var$ResponseOfferSnapshot_Result = $bbde53696c124e5e$exports.ResponseOfferSnapshot_Result || ($bbde53696c124e5e$exports.ResponseOfferSnapshot_Result = {}));
function $bbde53696c124e5e$var$responseOfferSnapshot_ResultFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN":
            return $bbde53696c124e5e$var$ResponseOfferSnapshot_Result.UNKNOWN;
        case 1:
        case "ACCEPT":
            return $bbde53696c124e5e$var$ResponseOfferSnapshot_Result.ACCEPT;
        case 2:
        case "ABORT":
            return $bbde53696c124e5e$var$ResponseOfferSnapshot_Result.ABORT;
        case 3:
        case "REJECT":
            return $bbde53696c124e5e$var$ResponseOfferSnapshot_Result.REJECT;
        case 4:
        case "REJECT_FORMAT":
            return $bbde53696c124e5e$var$ResponseOfferSnapshot_Result.REJECT_FORMAT;
        case 5:
        case "REJECT_SENDER":
            return $bbde53696c124e5e$var$ResponseOfferSnapshot_Result.REJECT_SENDER;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $bbde53696c124e5e$var$ResponseOfferSnapshot_Result.UNRECOGNIZED;
    }
}
$bbde53696c124e5e$exports.responseOfferSnapshot_ResultFromJSON = $bbde53696c124e5e$var$responseOfferSnapshot_ResultFromJSON;
function $bbde53696c124e5e$var$responseOfferSnapshot_ResultToJSON(object) {
    switch(object){
        case $bbde53696c124e5e$var$ResponseOfferSnapshot_Result.UNKNOWN:
            return "UNKNOWN";
        case $bbde53696c124e5e$var$ResponseOfferSnapshot_Result.ACCEPT:
            return "ACCEPT";
        case $bbde53696c124e5e$var$ResponseOfferSnapshot_Result.ABORT:
            return "ABORT";
        case $bbde53696c124e5e$var$ResponseOfferSnapshot_Result.REJECT:
            return "REJECT";
        case $bbde53696c124e5e$var$ResponseOfferSnapshot_Result.REJECT_FORMAT:
            return "REJECT_FORMAT";
        case $bbde53696c124e5e$var$ResponseOfferSnapshot_Result.REJECT_SENDER:
            return "REJECT_SENDER";
        default:
            return "UNKNOWN";
    }
}
$bbde53696c124e5e$exports.responseOfferSnapshot_ResultToJSON = $bbde53696c124e5e$var$responseOfferSnapshot_ResultToJSON;
var $bbde53696c124e5e$var$ResponseApplySnapshotChunk_Result;
(function(ResponseApplySnapshotChunk_Result) {
    /** UNKNOWN - Unknown result, abort all snapshot restoration */ ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["UNKNOWN"] = 0] = "UNKNOWN";
    /** ACCEPT - Chunk successfully accepted */ ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["ACCEPT"] = 1] = "ACCEPT";
    /** ABORT - Abort all snapshot restoration */ ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["ABORT"] = 2] = "ABORT";
    /** RETRY - Retry chunk (combine with refetch and reject) */ ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["RETRY"] = 3] = "RETRY";
    /** RETRY_SNAPSHOT - Retry snapshot (combine with refetch and reject) */ ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["RETRY_SNAPSHOT"] = 4] = "RETRY_SNAPSHOT";
    /** REJECT_SNAPSHOT - Reject this snapshot, try others */ ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["REJECT_SNAPSHOT"] = 5] = "REJECT_SNAPSHOT";
    ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($bbde53696c124e5e$var$ResponseApplySnapshotChunk_Result = $bbde53696c124e5e$exports.ResponseApplySnapshotChunk_Result || ($bbde53696c124e5e$exports.ResponseApplySnapshotChunk_Result = {}));
function $bbde53696c124e5e$var$responseApplySnapshotChunk_ResultFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN":
            return $bbde53696c124e5e$var$ResponseApplySnapshotChunk_Result.UNKNOWN;
        case 1:
        case "ACCEPT":
            return $bbde53696c124e5e$var$ResponseApplySnapshotChunk_Result.ACCEPT;
        case 2:
        case "ABORT":
            return $bbde53696c124e5e$var$ResponseApplySnapshotChunk_Result.ABORT;
        case 3:
        case "RETRY":
            return $bbde53696c124e5e$var$ResponseApplySnapshotChunk_Result.RETRY;
        case 4:
        case "RETRY_SNAPSHOT":
            return $bbde53696c124e5e$var$ResponseApplySnapshotChunk_Result.RETRY_SNAPSHOT;
        case 5:
        case "REJECT_SNAPSHOT":
            return $bbde53696c124e5e$var$ResponseApplySnapshotChunk_Result.REJECT_SNAPSHOT;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $bbde53696c124e5e$var$ResponseApplySnapshotChunk_Result.UNRECOGNIZED;
    }
}
$bbde53696c124e5e$exports.responseApplySnapshotChunk_ResultFromJSON = $bbde53696c124e5e$var$responseApplySnapshotChunk_ResultFromJSON;
function $bbde53696c124e5e$var$responseApplySnapshotChunk_ResultToJSON(object) {
    switch(object){
        case $bbde53696c124e5e$var$ResponseApplySnapshotChunk_Result.UNKNOWN:
            return "UNKNOWN";
        case $bbde53696c124e5e$var$ResponseApplySnapshotChunk_Result.ACCEPT:
            return "ACCEPT";
        case $bbde53696c124e5e$var$ResponseApplySnapshotChunk_Result.ABORT:
            return "ABORT";
        case $bbde53696c124e5e$var$ResponseApplySnapshotChunk_Result.RETRY:
            return "RETRY";
        case $bbde53696c124e5e$var$ResponseApplySnapshotChunk_Result.RETRY_SNAPSHOT:
            return "RETRY_SNAPSHOT";
        case $bbde53696c124e5e$var$ResponseApplySnapshotChunk_Result.REJECT_SNAPSHOT:
            return "REJECT_SNAPSHOT";
        default:
            return "UNKNOWN";
    }
}
$bbde53696c124e5e$exports.responseApplySnapshotChunk_ResultToJSON = $bbde53696c124e5e$var$responseApplySnapshotChunk_ResultToJSON;
const $bbde53696c124e5e$var$baseRequest = {};
$bbde53696c124e5e$exports.Request = {
    encode (message, writer = $bbde53696c124e5e$var$minimal_1.default.Writer.create()) {
        if (message.echo !== undefined) $bbde53696c124e5e$exports.RequestEcho.encode(message.echo, writer.uint32(10).fork()).ldelim();
        if (message.flush !== undefined) $bbde53696c124e5e$exports.RequestFlush.encode(message.flush, writer.uint32(18).fork()).ldelim();
        if (message.info !== undefined) $bbde53696c124e5e$exports.RequestInfo.encode(message.info, writer.uint32(26).fork()).ldelim();
        if (message.setOption !== undefined) $bbde53696c124e5e$exports.RequestSetOption.encode(message.setOption, writer.uint32(34).fork()).ldelim();
        if (message.initChain !== undefined) $bbde53696c124e5e$exports.RequestInitChain.encode(message.initChain, writer.uint32(42).fork()).ldelim();
        if (message.query !== undefined) $bbde53696c124e5e$exports.RequestQuery.encode(message.query, writer.uint32(50).fork()).ldelim();
        if (message.beginBlock !== undefined) $bbde53696c124e5e$exports.RequestBeginBlock.encode(message.beginBlock, writer.uint32(58).fork()).ldelim();
        if (message.checkTx !== undefined) $bbde53696c124e5e$exports.RequestCheckTx.encode(message.checkTx, writer.uint32(66).fork()).ldelim();
        if (message.deliverTx !== undefined) $bbde53696c124e5e$exports.RequestDeliverTx.encode(message.deliverTx, writer.uint32(74).fork()).ldelim();
        if (message.endBlock !== undefined) $bbde53696c124e5e$exports.RequestEndBlock.encode(message.endBlock, writer.uint32(82).fork()).ldelim();
        if (message.commit !== undefined) $bbde53696c124e5e$exports.RequestCommit.encode(message.commit, writer.uint32(90).fork()).ldelim();
        if (message.listSnapshots !== undefined) $bbde53696c124e5e$exports.RequestListSnapshots.encode(message.listSnapshots, writer.uint32(98).fork()).ldelim();
        if (message.offerSnapshot !== undefined) $bbde53696c124e5e$exports.RequestOfferSnapshot.encode(message.offerSnapshot, writer.uint32(106).fork()).ldelim();
        if (message.loadSnapshotChunk !== undefined) $bbde53696c124e5e$exports.RequestLoadSnapshotChunk.encode(message.loadSnapshotChunk, writer.uint32(114).fork()).ldelim();
        if (message.applySnapshotChunk !== undefined) $bbde53696c124e5e$exports.RequestApplySnapshotChunk.encode(message.applySnapshotChunk, writer.uint32(122).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bbde53696c124e5e$var$minimal_1.default.Reader ? input : new $bbde53696c124e5e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.echo = $bbde53696c124e5e$exports.RequestEcho.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.flush = $bbde53696c124e5e$exports.RequestFlush.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.info = $bbde53696c124e5e$exports.RequestInfo.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.setOption = $bbde53696c124e5e$exports.RequestSetOption.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.initChain = $bbde53696c124e5e$exports.RequestInitChain.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.query = $bbde53696c124e5e$exports.RequestQuery.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.beginBlock = $bbde53696c124e5e$exports.RequestBeginBlock.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.checkTx = $bbde53696c124e5e$exports.RequestCheckTx.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.deliverTx = $bbde53696c124e5e$exports.RequestDeliverTx.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.endBlock = $bbde53696c124e5e$exports.RequestEndBlock.decode(reader, reader.uint32());
                    break;
                case 11:
                    message.commit = $bbde53696c124e5e$exports.RequestCommit.decode(reader, reader.uint32());
                    break;
                case 12:
                    message.listSnapshots = $bbde53696c124e5e$exports.RequestListSnapshots.decode(reader, reader.uint32());
                    break;
                case 13:
                    message.offerSnapshot = $bbde53696c124e5e$exports.RequestOfferSnapshot.decode(reader, reader.uint32());
                    break;
                case 14:
                    message.loadSnapshotChunk = $bbde53696c124e5e$exports.RequestLoadSnapshotChunk.decode(reader, reader.uint32());
                    break;
                case 15:
                    message.applySnapshotChunk = $bbde53696c124e5e$exports.RequestApplySnapshotChunk.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequest);
        message.echo = object.echo !== undefined && object.echo !== null ? $bbde53696c124e5e$exports.RequestEcho.fromJSON(object.echo) : undefined;
        message.flush = object.flush !== undefined && object.flush !== null ? $bbde53696c124e5e$exports.RequestFlush.fromJSON(object.flush) : undefined;
        message.info = object.info !== undefined && object.info !== null ? $bbde53696c124e5e$exports.RequestInfo.fromJSON(object.info) : undefined;
        message.setOption = object.setOption !== undefined && object.setOption !== null ? $bbde53696c124e5e$exports.RequestSetOption.fromJSON(object.setOption) : undefined;
        message.initChain = object.initChain !== undefined && object.initChain !== null ? $bbde53696c124e5e$exports.RequestInitChain.fromJSON(object.initChain) : undefined;
        message.query = object.query !== undefined && object.query !== null ? $bbde53696c124e5e$exports.RequestQuery.fromJSON(object.query) : undefined;
        message.beginBlock = object.beginBlock !== undefined && object.beginBlock !== null ? $bbde53696c124e5e$exports.RequestBeginBlock.fromJSON(object.beginBlock) : undefined;
        message.checkTx = object.checkTx !== undefined && object.checkTx !== null ? $bbde53696c124e5e$exports.RequestCheckTx.fromJSON(object.checkTx) : undefined;
        message.deliverTx = object.deliverTx !== undefined && object.deliverTx !== null ? $bbde53696c124e5e$exports.RequestDeliverTx.fromJSON(object.deliverTx) : undefined;
        message.endBlock = object.endBlock !== undefined && object.endBlock !== null ? $bbde53696c124e5e$exports.RequestEndBlock.fromJSON(object.endBlock) : undefined;
        message.commit = object.commit !== undefined && object.commit !== null ? $bbde53696c124e5e$exports.RequestCommit.fromJSON(object.commit) : undefined;
        message.listSnapshots = object.listSnapshots !== undefined && object.listSnapshots !== null ? $bbde53696c124e5e$exports.RequestListSnapshots.fromJSON(object.listSnapshots) : undefined;
        message.offerSnapshot = object.offerSnapshot !== undefined && object.offerSnapshot !== null ? $bbde53696c124e5e$exports.RequestOfferSnapshot.fromJSON(object.offerSnapshot) : undefined;
        message.loadSnapshotChunk = object.loadSnapshotChunk !== undefined && object.loadSnapshotChunk !== null ? $bbde53696c124e5e$exports.RequestLoadSnapshotChunk.fromJSON(object.loadSnapshotChunk) : undefined;
        message.applySnapshotChunk = object.applySnapshotChunk !== undefined && object.applySnapshotChunk !== null ? $bbde53696c124e5e$exports.RequestApplySnapshotChunk.fromJSON(object.applySnapshotChunk) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.echo !== undefined && (obj.echo = message.echo ? $bbde53696c124e5e$exports.RequestEcho.toJSON(message.echo) : undefined);
        message.flush !== undefined && (obj.flush = message.flush ? $bbde53696c124e5e$exports.RequestFlush.toJSON(message.flush) : undefined);
        message.info !== undefined && (obj.info = message.info ? $bbde53696c124e5e$exports.RequestInfo.toJSON(message.info) : undefined);
        message.setOption !== undefined && (obj.setOption = message.setOption ? $bbde53696c124e5e$exports.RequestSetOption.toJSON(message.setOption) : undefined);
        message.initChain !== undefined && (obj.initChain = message.initChain ? $bbde53696c124e5e$exports.RequestInitChain.toJSON(message.initChain) : undefined);
        message.query !== undefined && (obj.query = message.query ? $bbde53696c124e5e$exports.RequestQuery.toJSON(message.query) : undefined);
        message.beginBlock !== undefined && (obj.beginBlock = message.beginBlock ? $bbde53696c124e5e$exports.RequestBeginBlock.toJSON(message.beginBlock) : undefined);
        message.checkTx !== undefined && (obj.checkTx = message.checkTx ? $bbde53696c124e5e$exports.RequestCheckTx.toJSON(message.checkTx) : undefined);
        message.deliverTx !== undefined && (obj.deliverTx = message.deliverTx ? $bbde53696c124e5e$exports.RequestDeliverTx.toJSON(message.deliverTx) : undefined);
        message.endBlock !== undefined && (obj.endBlock = message.endBlock ? $bbde53696c124e5e$exports.RequestEndBlock.toJSON(message.endBlock) : undefined);
        message.commit !== undefined && (obj.commit = message.commit ? $bbde53696c124e5e$exports.RequestCommit.toJSON(message.commit) : undefined);
        message.listSnapshots !== undefined && (obj.listSnapshots = message.listSnapshots ? $bbde53696c124e5e$exports.RequestListSnapshots.toJSON(message.listSnapshots) : undefined);
        message.offerSnapshot !== undefined && (obj.offerSnapshot = message.offerSnapshot ? $bbde53696c124e5e$exports.RequestOfferSnapshot.toJSON(message.offerSnapshot) : undefined);
        message.loadSnapshotChunk !== undefined && (obj.loadSnapshotChunk = message.loadSnapshotChunk ? $bbde53696c124e5e$exports.RequestLoadSnapshotChunk.toJSON(message.loadSnapshotChunk) : undefined);
        message.applySnapshotChunk !== undefined && (obj.applySnapshotChunk = message.applySnapshotChunk ? $bbde53696c124e5e$exports.RequestApplySnapshotChunk.toJSON(message.applySnapshotChunk) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequest);
        message.echo = object.echo !== undefined && object.echo !== null ? $bbde53696c124e5e$exports.RequestEcho.fromPartial(object.echo) : undefined;
        message.flush = object.flush !== undefined && object.flush !== null ? $bbde53696c124e5e$exports.RequestFlush.fromPartial(object.flush) : undefined;
        message.info = object.info !== undefined && object.info !== null ? $bbde53696c124e5e$exports.RequestInfo.fromPartial(object.info) : undefined;
        message.setOption = object.setOption !== undefined && object.setOption !== null ? $bbde53696c124e5e$exports.RequestSetOption.fromPartial(object.setOption) : undefined;
        message.initChain = object.initChain !== undefined && object.initChain !== null ? $bbde53696c124e5e$exports.RequestInitChain.fromPartial(object.initChain) : undefined;
        message.query = object.query !== undefined && object.query !== null ? $bbde53696c124e5e$exports.RequestQuery.fromPartial(object.query) : undefined;
        message.beginBlock = object.beginBlock !== undefined && object.beginBlock !== null ? $bbde53696c124e5e$exports.RequestBeginBlock.fromPartial(object.beginBlock) : undefined;
        message.checkTx = object.checkTx !== undefined && object.checkTx !== null ? $bbde53696c124e5e$exports.RequestCheckTx.fromPartial(object.checkTx) : undefined;
        message.deliverTx = object.deliverTx !== undefined && object.deliverTx !== null ? $bbde53696c124e5e$exports.RequestDeliverTx.fromPartial(object.deliverTx) : undefined;
        message.endBlock = object.endBlock !== undefined && object.endBlock !== null ? $bbde53696c124e5e$exports.RequestEndBlock.fromPartial(object.endBlock) : undefined;
        message.commit = object.commit !== undefined && object.commit !== null ? $bbde53696c124e5e$exports.RequestCommit.fromPartial(object.commit) : undefined;
        message.listSnapshots = object.listSnapshots !== undefined && object.listSnapshots !== null ? $bbde53696c124e5e$exports.RequestListSnapshots.fromPartial(object.listSnapshots) : undefined;
        message.offerSnapshot = object.offerSnapshot !== undefined && object.offerSnapshot !== null ? $bbde53696c124e5e$exports.RequestOfferSnapshot.fromPartial(object.offerSnapshot) : undefined;
        message.loadSnapshotChunk = object.loadSnapshotChunk !== undefined && object.loadSnapshotChunk !== null ? $bbde53696c124e5e$exports.RequestLoadSnapshotChunk.fromPartial(object.loadSnapshotChunk) : undefined;
        message.applySnapshotChunk = object.applySnapshotChunk !== undefined && object.applySnapshotChunk !== null ? $bbde53696c124e5e$exports.RequestApplySnapshotChunk.fromPartial(object.applySnapshotChunk) : undefined;
        return message;
    }
};
const $bbde53696c124e5e$var$baseRequestEcho = {
    message: ""
};
$bbde53696c124e5e$exports.RequestEcho = {
    encode (message, writer = $bbde53696c124e5e$var$minimal_1.default.Writer.create()) {
        if (message.message !== "") writer.uint32(10).string(message.message);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bbde53696c124e5e$var$minimal_1.default.Reader ? input : new $bbde53696c124e5e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestEcho);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.message = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestEcho);
        message.message = object.message !== undefined && object.message !== null ? String(object.message) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.message !== undefined && (obj.message = message.message);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestEcho);
        message.message = (_a = object.message) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
const $bbde53696c124e5e$var$baseRequestFlush = {};
$bbde53696c124e5e$exports.RequestFlush = {
    encode (_, writer = $bbde53696c124e5e$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bbde53696c124e5e$var$minimal_1.default.Reader ? input : new $bbde53696c124e5e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestFlush);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestFlush);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestFlush);
        return message;
    }
};
const $bbde53696c124e5e$var$baseRequestInfo = {
    version: "",
    blockVersion: $bbde53696c124e5e$var$long_1.default.UZERO,
    p2pVersion: $bbde53696c124e5e$var$long_1.default.UZERO
};
$bbde53696c124e5e$exports.RequestInfo = {
    encode (message, writer = $bbde53696c124e5e$var$minimal_1.default.Writer.create()) {
        if (message.version !== "") writer.uint32(10).string(message.version);
        if (!message.blockVersion.isZero()) writer.uint32(16).uint64(message.blockVersion);
        if (!message.p2pVersion.isZero()) writer.uint32(24).uint64(message.p2pVersion);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bbde53696c124e5e$var$minimal_1.default.Reader ? input : new $bbde53696c124e5e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestInfo);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.version = reader.string();
                    break;
                case 2:
                    message.blockVersion = reader.uint64();
                    break;
                case 3:
                    message.p2pVersion = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestInfo);
        message.version = object.version !== undefined && object.version !== null ? String(object.version) : "";
        message.blockVersion = object.blockVersion !== undefined && object.blockVersion !== null ? $bbde53696c124e5e$var$long_1.default.fromString(object.blockVersion) : $bbde53696c124e5e$var$long_1.default.UZERO;
        message.p2pVersion = object.p2pVersion !== undefined && object.p2pVersion !== null ? $bbde53696c124e5e$var$long_1.default.fromString(object.p2pVersion) : $bbde53696c124e5e$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.version !== undefined && (obj.version = message.version);
        message.blockVersion !== undefined && (obj.blockVersion = (message.blockVersion || $bbde53696c124e5e$var$long_1.default.UZERO).toString());
        message.p2pVersion !== undefined && (obj.p2pVersion = (message.p2pVersion || $bbde53696c124e5e$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestInfo);
        message.version = (_a = object.version) !== null && _a !== void 0 ? _a : "";
        message.blockVersion = object.blockVersion !== undefined && object.blockVersion !== null ? $bbde53696c124e5e$var$long_1.default.fromValue(object.blockVersion) : $bbde53696c124e5e$var$long_1.default.UZERO;
        message.p2pVersion = object.p2pVersion !== undefined && object.p2pVersion !== null ? $bbde53696c124e5e$var$long_1.default.fromValue(object.p2pVersion) : $bbde53696c124e5e$var$long_1.default.UZERO;
        return message;
    }
};
const $bbde53696c124e5e$var$baseRequestSetOption = {
    key: "",
    value: ""
};
$bbde53696c124e5e$exports.RequestSetOption = {
    encode (message, writer = $bbde53696c124e5e$var$minimal_1.default.Writer.create()) {
        if (message.key !== "") writer.uint32(10).string(message.key);
        if (message.value !== "") writer.uint32(18).string(message.value);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bbde53696c124e5e$var$minimal_1.default.Reader ? input : new $bbde53696c124e5e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestSetOption);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.value = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestSetOption);
        message.key = object.key !== undefined && object.key !== null ? String(object.key) : "";
        message.value = object.value !== undefined && object.value !== null ? String(object.value) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = message.key);
        message.value !== undefined && (obj.value = message.value);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestSetOption);
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "";
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
const $bbde53696c124e5e$var$baseRequestInitChain = {
    chainId: "",
    initialHeight: $bbde53696c124e5e$var$long_1.default.ZERO
};
$bbde53696c124e5e$exports.RequestInitChain = {
    encode (message, writer = $bbde53696c124e5e$var$minimal_1.default.Writer.create()) {
        if (message.time !== undefined) $d6c3291d6aa8eb5b$exports.Timestamp.encode(message.time, writer.uint32(10).fork()).ldelim();
        if (message.chainId !== "") writer.uint32(18).string(message.chainId);
        if (message.consensusParams !== undefined) $bbde53696c124e5e$exports.ConsensusParams.encode(message.consensusParams, writer.uint32(26).fork()).ldelim();
        for (const v of message.validators)$bbde53696c124e5e$exports.ValidatorUpdate.encode(v, writer.uint32(34).fork()).ldelim();
        if (message.appStateBytes.length !== 0) writer.uint32(42).bytes(message.appStateBytes);
        if (!message.initialHeight.isZero()) writer.uint32(48).int64(message.initialHeight);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bbde53696c124e5e$var$minimal_1.default.Reader ? input : new $bbde53696c124e5e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestInitChain);
        message.validators = [];
        message.appStateBytes = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.time = $d6c3291d6aa8eb5b$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.chainId = reader.string();
                    break;
                case 3:
                    message.consensusParams = $bbde53696c124e5e$exports.ConsensusParams.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.validators.push($bbde53696c124e5e$exports.ValidatorUpdate.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.appStateBytes = reader.bytes();
                    break;
                case 6:
                    message.initialHeight = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestInitChain);
        message.time = object.time !== undefined && object.time !== null ? $bbde53696c124e5e$var$fromJsonTimestamp(object.time) : undefined;
        message.chainId = object.chainId !== undefined && object.chainId !== null ? String(object.chainId) : "";
        message.consensusParams = object.consensusParams !== undefined && object.consensusParams !== null ? $bbde53696c124e5e$exports.ConsensusParams.fromJSON(object.consensusParams) : undefined;
        message.validators = ((_a = object.validators) !== null && _a !== void 0 ? _a : []).map((e)=>$bbde53696c124e5e$exports.ValidatorUpdate.fromJSON(e));
        message.appStateBytes = object.appStateBytes !== undefined && object.appStateBytes !== null ? $bbde53696c124e5e$var$bytesFromBase64(object.appStateBytes) : new Uint8Array();
        message.initialHeight = object.initialHeight !== undefined && object.initialHeight !== null ? $bbde53696c124e5e$var$long_1.default.fromString(object.initialHeight) : $bbde53696c124e5e$var$long_1.default.ZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.time !== undefined && (obj.time = $bbde53696c124e5e$var$fromTimestamp(message.time).toISOString());
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.consensusParams !== undefined && (obj.consensusParams = message.consensusParams ? $bbde53696c124e5e$exports.ConsensusParams.toJSON(message.consensusParams) : undefined);
        if (message.validators) obj.validators = message.validators.map((e)=>e ? $bbde53696c124e5e$exports.ValidatorUpdate.toJSON(e) : undefined);
        else obj.validators = [];
        message.appStateBytes !== undefined && (obj.appStateBytes = $bbde53696c124e5e$var$base64FromBytes(message.appStateBytes !== undefined ? message.appStateBytes : new Uint8Array()));
        message.initialHeight !== undefined && (obj.initialHeight = (message.initialHeight || $bbde53696c124e5e$var$long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestInitChain);
        message.time = object.time !== undefined && object.time !== null ? $d6c3291d6aa8eb5b$exports.Timestamp.fromPartial(object.time) : undefined;
        message.chainId = (_a = object.chainId) !== null && _a !== void 0 ? _a : "";
        message.consensusParams = object.consensusParams !== undefined && object.consensusParams !== null ? $bbde53696c124e5e$exports.ConsensusParams.fromPartial(object.consensusParams) : undefined;
        message.validators = ((_b = object.validators) === null || _b === void 0 ? void 0 : _b.map((e)=>$bbde53696c124e5e$exports.ValidatorUpdate.fromPartial(e))) || [];
        message.appStateBytes = (_c = object.appStateBytes) !== null && _c !== void 0 ? _c : new Uint8Array();
        message.initialHeight = object.initialHeight !== undefined && object.initialHeight !== null ? $bbde53696c124e5e$var$long_1.default.fromValue(object.initialHeight) : $bbde53696c124e5e$var$long_1.default.ZERO;
        return message;
    }
};
const $bbde53696c124e5e$var$baseRequestQuery = {
    path: "",
    height: $bbde53696c124e5e$var$long_1.default.ZERO,
    prove: false
};
$bbde53696c124e5e$exports.RequestQuery = {
    encode (message, writer = $bbde53696c124e5e$var$minimal_1.default.Writer.create()) {
        if (message.data.length !== 0) writer.uint32(10).bytes(message.data);
        if (message.path !== "") writer.uint32(18).string(message.path);
        if (!message.height.isZero()) writer.uint32(24).int64(message.height);
        if (message.prove === true) writer.uint32(32).bool(message.prove);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bbde53696c124e5e$var$minimal_1.default.Reader ? input : new $bbde53696c124e5e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestQuery);
        message.data = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.data = reader.bytes();
                    break;
                case 2:
                    message.path = reader.string();
                    break;
                case 3:
                    message.height = reader.int64();
                    break;
                case 4:
                    message.prove = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestQuery);
        message.data = object.data !== undefined && object.data !== null ? $bbde53696c124e5e$var$bytesFromBase64(object.data) : new Uint8Array();
        message.path = object.path !== undefined && object.path !== null ? String(object.path) : "";
        message.height = object.height !== undefined && object.height !== null ? $bbde53696c124e5e$var$long_1.default.fromString(object.height) : $bbde53696c124e5e$var$long_1.default.ZERO;
        message.prove = object.prove !== undefined && object.prove !== null ? Boolean(object.prove) : false;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.data !== undefined && (obj.data = $bbde53696c124e5e$var$base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        message.path !== undefined && (obj.path = message.path);
        message.height !== undefined && (obj.height = (message.height || $bbde53696c124e5e$var$long_1.default.ZERO).toString());
        message.prove !== undefined && (obj.prove = message.prove);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestQuery);
        message.data = (_a = object.data) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.path = (_b = object.path) !== null && _b !== void 0 ? _b : "";
        message.height = object.height !== undefined && object.height !== null ? $bbde53696c124e5e$var$long_1.default.fromValue(object.height) : $bbde53696c124e5e$var$long_1.default.ZERO;
        message.prove = (_c = object.prove) !== null && _c !== void 0 ? _c : false;
        return message;
    }
};
const $bbde53696c124e5e$var$baseRequestBeginBlock = {};
$bbde53696c124e5e$exports.RequestBeginBlock = {
    encode (message, writer = $bbde53696c124e5e$var$minimal_1.default.Writer.create()) {
        if (message.hash.length !== 0) writer.uint32(10).bytes(message.hash);
        if (message.header !== undefined) $0aefc245ff398d69$exports.Header.encode(message.header, writer.uint32(18).fork()).ldelim();
        if (message.lastCommitInfo !== undefined) $bbde53696c124e5e$exports.LastCommitInfo.encode(message.lastCommitInfo, writer.uint32(26).fork()).ldelim();
        for (const v of message.byzantineValidators)$bbde53696c124e5e$exports.Evidence.encode(v, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bbde53696c124e5e$var$minimal_1.default.Reader ? input : new $bbde53696c124e5e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestBeginBlock);
        message.byzantineValidators = [];
        message.hash = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.bytes();
                    break;
                case 2:
                    message.header = $0aefc245ff398d69$exports.Header.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.lastCommitInfo = $bbde53696c124e5e$exports.LastCommitInfo.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.byzantineValidators.push($bbde53696c124e5e$exports.Evidence.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestBeginBlock);
        message.hash = object.hash !== undefined && object.hash !== null ? $bbde53696c124e5e$var$bytesFromBase64(object.hash) : new Uint8Array();
        message.header = object.header !== undefined && object.header !== null ? $0aefc245ff398d69$exports.Header.fromJSON(object.header) : undefined;
        message.lastCommitInfo = object.lastCommitInfo !== undefined && object.lastCommitInfo !== null ? $bbde53696c124e5e$exports.LastCommitInfo.fromJSON(object.lastCommitInfo) : undefined;
        message.byzantineValidators = ((_a = object.byzantineValidators) !== null && _a !== void 0 ? _a : []).map((e)=>$bbde53696c124e5e$exports.Evidence.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = $bbde53696c124e5e$var$base64FromBytes(message.hash !== undefined ? message.hash : new Uint8Array()));
        message.header !== undefined && (obj.header = message.header ? $0aefc245ff398d69$exports.Header.toJSON(message.header) : undefined);
        message.lastCommitInfo !== undefined && (obj.lastCommitInfo = message.lastCommitInfo ? $bbde53696c124e5e$exports.LastCommitInfo.toJSON(message.lastCommitInfo) : undefined);
        if (message.byzantineValidators) obj.byzantineValidators = message.byzantineValidators.map((e)=>e ? $bbde53696c124e5e$exports.Evidence.toJSON(e) : undefined);
        else obj.byzantineValidators = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestBeginBlock);
        message.hash = (_a = object.hash) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.header = object.header !== undefined && object.header !== null ? $0aefc245ff398d69$exports.Header.fromPartial(object.header) : undefined;
        message.lastCommitInfo = object.lastCommitInfo !== undefined && object.lastCommitInfo !== null ? $bbde53696c124e5e$exports.LastCommitInfo.fromPartial(object.lastCommitInfo) : undefined;
        message.byzantineValidators = ((_b = object.byzantineValidators) === null || _b === void 0 ? void 0 : _b.map((e)=>$bbde53696c124e5e$exports.Evidence.fromPartial(e))) || [];
        return message;
    }
};
const $bbde53696c124e5e$var$baseRequestCheckTx = {
    type: 0
};
$bbde53696c124e5e$exports.RequestCheckTx = {
    encode (message, writer = $bbde53696c124e5e$var$minimal_1.default.Writer.create()) {
        if (message.tx.length !== 0) writer.uint32(10).bytes(message.tx);
        if (message.type !== 0) writer.uint32(16).int32(message.type);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bbde53696c124e5e$var$minimal_1.default.Reader ? input : new $bbde53696c124e5e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestCheckTx);
        message.tx = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.tx = reader.bytes();
                    break;
                case 2:
                    message.type = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestCheckTx);
        message.tx = object.tx !== undefined && object.tx !== null ? $bbde53696c124e5e$var$bytesFromBase64(object.tx) : new Uint8Array();
        message.type = object.type !== undefined && object.type !== null ? $bbde53696c124e5e$var$checkTxTypeFromJSON(object.type) : 0;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.tx !== undefined && (obj.tx = $bbde53696c124e5e$var$base64FromBytes(message.tx !== undefined ? message.tx : new Uint8Array()));
        message.type !== undefined && (obj.type = $bbde53696c124e5e$var$checkTxTypeToJSON(message.type));
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestCheckTx);
        message.tx = (_a = object.tx) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.type = (_b = object.type) !== null && _b !== void 0 ? _b : 0;
        return message;
    }
};
const $bbde53696c124e5e$var$baseRequestDeliverTx = {};
$bbde53696c124e5e$exports.RequestDeliverTx = {
    encode (message, writer = $bbde53696c124e5e$var$minimal_1.default.Writer.create()) {
        if (message.tx.length !== 0) writer.uint32(10).bytes(message.tx);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bbde53696c124e5e$var$minimal_1.default.Reader ? input : new $bbde53696c124e5e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestDeliverTx);
        message.tx = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.tx = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestDeliverTx);
        message.tx = object.tx !== undefined && object.tx !== null ? $bbde53696c124e5e$var$bytesFromBase64(object.tx) : new Uint8Array();
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.tx !== undefined && (obj.tx = $bbde53696c124e5e$var$base64FromBytes(message.tx !== undefined ? message.tx : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestDeliverTx);
        message.tx = (_a = object.tx) !== null && _a !== void 0 ? _a : new Uint8Array();
        return message;
    }
};
const $bbde53696c124e5e$var$baseRequestEndBlock = {
    height: $bbde53696c124e5e$var$long_1.default.ZERO
};
$bbde53696c124e5e$exports.RequestEndBlock = {
    encode (message, writer = $bbde53696c124e5e$var$minimal_1.default.Writer.create()) {
        if (!message.height.isZero()) writer.uint32(8).int64(message.height);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bbde53696c124e5e$var$minimal_1.default.Reader ? input : new $bbde53696c124e5e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestEndBlock);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestEndBlock);
        message.height = object.height !== undefined && object.height !== null ? $bbde53696c124e5e$var$long_1.default.fromString(object.height) : $bbde53696c124e5e$var$long_1.default.ZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || $bbde53696c124e5e$var$long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestEndBlock);
        message.height = object.height !== undefined && object.height !== null ? $bbde53696c124e5e$var$long_1.default.fromValue(object.height) : $bbde53696c124e5e$var$long_1.default.ZERO;
        return message;
    }
};
const $bbde53696c124e5e$var$baseRequestCommit = {};
$bbde53696c124e5e$exports.RequestCommit = {
    encode (_, writer = $bbde53696c124e5e$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bbde53696c124e5e$var$minimal_1.default.Reader ? input : new $bbde53696c124e5e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestCommit);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestCommit);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestCommit);
        return message;
    }
};
const $bbde53696c124e5e$var$baseRequestListSnapshots = {};
$bbde53696c124e5e$exports.RequestListSnapshots = {
    encode (_, writer = $bbde53696c124e5e$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bbde53696c124e5e$var$minimal_1.default.Reader ? input : new $bbde53696c124e5e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestListSnapshots);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestListSnapshots);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestListSnapshots);
        return message;
    }
};
const $bbde53696c124e5e$var$baseRequestOfferSnapshot = {};
$bbde53696c124e5e$exports.RequestOfferSnapshot = {
    encode (message, writer = $bbde53696c124e5e$var$minimal_1.default.Writer.create()) {
        if (message.snapshot !== undefined) $bbde53696c124e5e$exports.Snapshot.encode(message.snapshot, writer.uint32(10).fork()).ldelim();
        if (message.appHash.length !== 0) writer.uint32(18).bytes(message.appHash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bbde53696c124e5e$var$minimal_1.default.Reader ? input : new $bbde53696c124e5e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestOfferSnapshot);
        message.appHash = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.snapshot = $bbde53696c124e5e$exports.Snapshot.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.appHash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestOfferSnapshot);
        message.snapshot = object.snapshot !== undefined && object.snapshot !== null ? $bbde53696c124e5e$exports.Snapshot.fromJSON(object.snapshot) : undefined;
        message.appHash = object.appHash !== undefined && object.appHash !== null ? $bbde53696c124e5e$var$bytesFromBase64(object.appHash) : new Uint8Array();
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.snapshot !== undefined && (obj.snapshot = message.snapshot ? $bbde53696c124e5e$exports.Snapshot.toJSON(message.snapshot) : undefined);
        message.appHash !== undefined && (obj.appHash = $bbde53696c124e5e$var$base64FromBytes(message.appHash !== undefined ? message.appHash : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestOfferSnapshot);
        message.snapshot = object.snapshot !== undefined && object.snapshot !== null ? $bbde53696c124e5e$exports.Snapshot.fromPartial(object.snapshot) : undefined;
        message.appHash = (_a = object.appHash) !== null && _a !== void 0 ? _a : new Uint8Array();
        return message;
    }
};
const $bbde53696c124e5e$var$baseRequestLoadSnapshotChunk = {
    height: $bbde53696c124e5e$var$long_1.default.UZERO,
    format: 0,
    chunk: 0
};
$bbde53696c124e5e$exports.RequestLoadSnapshotChunk = {
    encode (message, writer = $bbde53696c124e5e$var$minimal_1.default.Writer.create()) {
        if (!message.height.isZero()) writer.uint32(8).uint64(message.height);
        if (message.format !== 0) writer.uint32(16).uint32(message.format);
        if (message.chunk !== 0) writer.uint32(24).uint32(message.chunk);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bbde53696c124e5e$var$minimal_1.default.Reader ? input : new $bbde53696c124e5e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestLoadSnapshotChunk);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.uint64();
                    break;
                case 2:
                    message.format = reader.uint32();
                    break;
                case 3:
                    message.chunk = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestLoadSnapshotChunk);
        message.height = object.height !== undefined && object.height !== null ? $bbde53696c124e5e$var$long_1.default.fromString(object.height) : $bbde53696c124e5e$var$long_1.default.UZERO;
        message.format = object.format !== undefined && object.format !== null ? Number(object.format) : 0;
        message.chunk = object.chunk !== undefined && object.chunk !== null ? Number(object.chunk) : 0;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || $bbde53696c124e5e$var$long_1.default.UZERO).toString());
        message.format !== undefined && (obj.format = message.format);
        message.chunk !== undefined && (obj.chunk = message.chunk);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestLoadSnapshotChunk);
        message.height = object.height !== undefined && object.height !== null ? $bbde53696c124e5e$var$long_1.default.fromValue(object.height) : $bbde53696c124e5e$var$long_1.default.UZERO;
        message.format = (_a = object.format) !== null && _a !== void 0 ? _a : 0;
        message.chunk = (_b = object.chunk) !== null && _b !== void 0 ? _b : 0;
        return message;
    }
};
const $bbde53696c124e5e$var$baseRequestApplySnapshotChunk = {
    index: 0,
    sender: ""
};
$bbde53696c124e5e$exports.RequestApplySnapshotChunk = {
    encode (message, writer = $bbde53696c124e5e$var$minimal_1.default.Writer.create()) {
        if (message.index !== 0) writer.uint32(8).uint32(message.index);
        if (message.chunk.length !== 0) writer.uint32(18).bytes(message.chunk);
        if (message.sender !== "") writer.uint32(26).string(message.sender);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bbde53696c124e5e$var$minimal_1.default.Reader ? input : new $bbde53696c124e5e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestApplySnapshotChunk);
        message.chunk = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.index = reader.uint32();
                    break;
                case 2:
                    message.chunk = reader.bytes();
                    break;
                case 3:
                    message.sender = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestApplySnapshotChunk);
        message.index = object.index !== undefined && object.index !== null ? Number(object.index) : 0;
        message.chunk = object.chunk !== undefined && object.chunk !== null ? $bbde53696c124e5e$var$bytesFromBase64(object.chunk) : new Uint8Array();
        message.sender = object.sender !== undefined && object.sender !== null ? String(object.sender) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.index !== undefined && (obj.index = message.index);
        message.chunk !== undefined && (obj.chunk = $bbde53696c124e5e$var$base64FromBytes(message.chunk !== undefined ? message.chunk : new Uint8Array()));
        message.sender !== undefined && (obj.sender = message.sender);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseRequestApplySnapshotChunk);
        message.index = (_a = object.index) !== null && _a !== void 0 ? _a : 0;
        message.chunk = (_b = object.chunk) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.sender = (_c = object.sender) !== null && _c !== void 0 ? _c : "";
        return message;
    }
};
const $bbde53696c124e5e$var$baseResponse = {};
$bbde53696c124e5e$exports.Response = {
    encode (message, writer = $bbde53696c124e5e$var$minimal_1.default.Writer.create()) {
        if (message.exception !== undefined) $bbde53696c124e5e$exports.ResponseException.encode(message.exception, writer.uint32(10).fork()).ldelim();
        if (message.echo !== undefined) $bbde53696c124e5e$exports.ResponseEcho.encode(message.echo, writer.uint32(18).fork()).ldelim();
        if (message.flush !== undefined) $bbde53696c124e5e$exports.ResponseFlush.encode(message.flush, writer.uint32(26).fork()).ldelim();
        if (message.info !== undefined) $bbde53696c124e5e$exports.ResponseInfo.encode(message.info, writer.uint32(34).fork()).ldelim();
        if (message.setOption !== undefined) $bbde53696c124e5e$exports.ResponseSetOption.encode(message.setOption, writer.uint32(42).fork()).ldelim();
        if (message.initChain !== undefined) $bbde53696c124e5e$exports.ResponseInitChain.encode(message.initChain, writer.uint32(50).fork()).ldelim();
        if (message.query !== undefined) $bbde53696c124e5e$exports.ResponseQuery.encode(message.query, writer.uint32(58).fork()).ldelim();
        if (message.beginBlock !== undefined) $bbde53696c124e5e$exports.ResponseBeginBlock.encode(message.beginBlock, writer.uint32(66).fork()).ldelim();
        if (message.checkTx !== undefined) $bbde53696c124e5e$exports.ResponseCheckTx.encode(message.checkTx, writer.uint32(74).fork()).ldelim();
        if (message.deliverTx !== undefined) $bbde53696c124e5e$exports.ResponseDeliverTx.encode(message.deliverTx, writer.uint32(82).fork()).ldelim();
        if (message.endBlock !== undefined) $bbde53696c124e5e$exports.ResponseEndBlock.encode(message.endBlock, writer.uint32(90).fork()).ldelim();
        if (message.commit !== undefined) $bbde53696c124e5e$exports.ResponseCommit.encode(message.commit, writer.uint32(98).fork()).ldelim();
        if (message.listSnapshots !== undefined) $bbde53696c124e5e$exports.ResponseListSnapshots.encode(message.listSnapshots, writer.uint32(106).fork()).ldelim();
        if (message.offerSnapshot !== undefined) $bbde53696c124e5e$exports.ResponseOfferSnapshot.encode(message.offerSnapshot, writer.uint32(114).fork()).ldelim();
        if (message.loadSnapshotChunk !== undefined) $bbde53696c124e5e$exports.ResponseLoadSnapshotChunk.encode(message.loadSnapshotChunk, writer.uint32(122).fork()).ldelim();
        if (message.applySnapshotChunk !== undefined) $bbde53696c124e5e$exports.ResponseApplySnapshotChunk.encode(message.applySnapshotChunk, writer.uint32(130).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bbde53696c124e5e$var$minimal_1.default.Reader ? input : new $bbde53696c124e5e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.exception = $bbde53696c124e5e$exports.ResponseException.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.echo = $bbde53696c124e5e$exports.ResponseEcho.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.flush = $bbde53696c124e5e$exports.ResponseFlush.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.info = $bbde53696c124e5e$exports.ResponseInfo.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.setOption = $bbde53696c124e5e$exports.ResponseSetOption.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.initChain = $bbde53696c124e5e$exports.ResponseInitChain.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.query = $bbde53696c124e5e$exports.ResponseQuery.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.beginBlock = $bbde53696c124e5e$exports.ResponseBeginBlock.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.checkTx = $bbde53696c124e5e$exports.ResponseCheckTx.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.deliverTx = $bbde53696c124e5e$exports.ResponseDeliverTx.decode(reader, reader.uint32());
                    break;
                case 11:
                    message.endBlock = $bbde53696c124e5e$exports.ResponseEndBlock.decode(reader, reader.uint32());
                    break;
                case 12:
                    message.commit = $bbde53696c124e5e$exports.ResponseCommit.decode(reader, reader.uint32());
                    break;
                case 13:
                    message.listSnapshots = $bbde53696c124e5e$exports.ResponseListSnapshots.decode(reader, reader.uint32());
                    break;
                case 14:
                    message.offerSnapshot = $bbde53696c124e5e$exports.ResponseOfferSnapshot.decode(reader, reader.uint32());
                    break;
                case 15:
                    message.loadSnapshotChunk = $bbde53696c124e5e$exports.ResponseLoadSnapshotChunk.decode(reader, reader.uint32());
                    break;
                case 16:
                    message.applySnapshotChunk = $bbde53696c124e5e$exports.ResponseApplySnapshotChunk.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponse);
        message.exception = object.exception !== undefined && object.exception !== null ? $bbde53696c124e5e$exports.ResponseException.fromJSON(object.exception) : undefined;
        message.echo = object.echo !== undefined && object.echo !== null ? $bbde53696c124e5e$exports.ResponseEcho.fromJSON(object.echo) : undefined;
        message.flush = object.flush !== undefined && object.flush !== null ? $bbde53696c124e5e$exports.ResponseFlush.fromJSON(object.flush) : undefined;
        message.info = object.info !== undefined && object.info !== null ? $bbde53696c124e5e$exports.ResponseInfo.fromJSON(object.info) : undefined;
        message.setOption = object.setOption !== undefined && object.setOption !== null ? $bbde53696c124e5e$exports.ResponseSetOption.fromJSON(object.setOption) : undefined;
        message.initChain = object.initChain !== undefined && object.initChain !== null ? $bbde53696c124e5e$exports.ResponseInitChain.fromJSON(object.initChain) : undefined;
        message.query = object.query !== undefined && object.query !== null ? $bbde53696c124e5e$exports.ResponseQuery.fromJSON(object.query) : undefined;
        message.beginBlock = object.beginBlock !== undefined && object.beginBlock !== null ? $bbde53696c124e5e$exports.ResponseBeginBlock.fromJSON(object.beginBlock) : undefined;
        message.checkTx = object.checkTx !== undefined && object.checkTx !== null ? $bbde53696c124e5e$exports.ResponseCheckTx.fromJSON(object.checkTx) : undefined;
        message.deliverTx = object.deliverTx !== undefined && object.deliverTx !== null ? $bbde53696c124e5e$exports.ResponseDeliverTx.fromJSON(object.deliverTx) : undefined;
        message.endBlock = object.endBlock !== undefined && object.endBlock !== null ? $bbde53696c124e5e$exports.ResponseEndBlock.fromJSON(object.endBlock) : undefined;
        message.commit = object.commit !== undefined && object.commit !== null ? $bbde53696c124e5e$exports.ResponseCommit.fromJSON(object.commit) : undefined;
        message.listSnapshots = object.listSnapshots !== undefined && object.listSnapshots !== null ? $bbde53696c124e5e$exports.ResponseListSnapshots.fromJSON(object.listSnapshots) : undefined;
        message.offerSnapshot = object.offerSnapshot !== undefined && object.offerSnapshot !== null ? $bbde53696c124e5e$exports.ResponseOfferSnapshot.fromJSON(object.offerSnapshot) : undefined;
        message.loadSnapshotChunk = object.loadSnapshotChunk !== undefined && object.loadSnapshotChunk !== null ? $bbde53696c124e5e$exports.ResponseLoadSnapshotChunk.fromJSON(object.loadSnapshotChunk) : undefined;
        message.applySnapshotChunk = object.applySnapshotChunk !== undefined && object.applySnapshotChunk !== null ? $bbde53696c124e5e$exports.ResponseApplySnapshotChunk.fromJSON(object.applySnapshotChunk) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.exception !== undefined && (obj.exception = message.exception ? $bbde53696c124e5e$exports.ResponseException.toJSON(message.exception) : undefined);
        message.echo !== undefined && (obj.echo = message.echo ? $bbde53696c124e5e$exports.ResponseEcho.toJSON(message.echo) : undefined);
        message.flush !== undefined && (obj.flush = message.flush ? $bbde53696c124e5e$exports.ResponseFlush.toJSON(message.flush) : undefined);
        message.info !== undefined && (obj.info = message.info ? $bbde53696c124e5e$exports.ResponseInfo.toJSON(message.info) : undefined);
        message.setOption !== undefined && (obj.setOption = message.setOption ? $bbde53696c124e5e$exports.ResponseSetOption.toJSON(message.setOption) : undefined);
        message.initChain !== undefined && (obj.initChain = message.initChain ? $bbde53696c124e5e$exports.ResponseInitChain.toJSON(message.initChain) : undefined);
        message.query !== undefined && (obj.query = message.query ? $bbde53696c124e5e$exports.ResponseQuery.toJSON(message.query) : undefined);
        message.beginBlock !== undefined && (obj.beginBlock = message.beginBlock ? $bbde53696c124e5e$exports.ResponseBeginBlock.toJSON(message.beginBlock) : undefined);
        message.checkTx !== undefined && (obj.checkTx = message.checkTx ? $bbde53696c124e5e$exports.ResponseCheckTx.toJSON(message.checkTx) : undefined);
        message.deliverTx !== undefined && (obj.deliverTx = message.deliverTx ? $bbde53696c124e5e$exports.ResponseDeliverTx.toJSON(message.deliverTx) : undefined);
        message.endBlock !== undefined && (obj.endBlock = message.endBlock ? $bbde53696c124e5e$exports.ResponseEndBlock.toJSON(message.endBlock) : undefined);
        message.commit !== undefined && (obj.commit = message.commit ? $bbde53696c124e5e$exports.ResponseCommit.toJSON(message.commit) : undefined);
        message.listSnapshots !== undefined && (obj.listSnapshots = message.listSnapshots ? $bbde53696c124e5e$exports.ResponseListSnapshots.toJSON(message.listSnapshots) : undefined);
        message.offerSnapshot !== undefined && (obj.offerSnapshot = message.offerSnapshot ? $bbde53696c124e5e$exports.ResponseOfferSnapshot.toJSON(message.offerSnapshot) : undefined);
        message.loadSnapshotChunk !== undefined && (obj.loadSnapshotChunk = message.loadSnapshotChunk ? $bbde53696c124e5e$exports.ResponseLoadSnapshotChunk.toJSON(message.loadSnapshotChunk) : undefined);
        message.applySnapshotChunk !== undefined && (obj.applySnapshotChunk = message.applySnapshotChunk ? $bbde53696c124e5e$exports.ResponseApplySnapshotChunk.toJSON(message.applySnapshotChunk) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponse);
        message.exception = object.exception !== undefined && object.exception !== null ? $bbde53696c124e5e$exports.ResponseException.fromPartial(object.exception) : undefined;
        message.echo = object.echo !== undefined && object.echo !== null ? $bbde53696c124e5e$exports.ResponseEcho.fromPartial(object.echo) : undefined;
        message.flush = object.flush !== undefined && object.flush !== null ? $bbde53696c124e5e$exports.ResponseFlush.fromPartial(object.flush) : undefined;
        message.info = object.info !== undefined && object.info !== null ? $bbde53696c124e5e$exports.ResponseInfo.fromPartial(object.info) : undefined;
        message.setOption = object.setOption !== undefined && object.setOption !== null ? $bbde53696c124e5e$exports.ResponseSetOption.fromPartial(object.setOption) : undefined;
        message.initChain = object.initChain !== undefined && object.initChain !== null ? $bbde53696c124e5e$exports.ResponseInitChain.fromPartial(object.initChain) : undefined;
        message.query = object.query !== undefined && object.query !== null ? $bbde53696c124e5e$exports.ResponseQuery.fromPartial(object.query) : undefined;
        message.beginBlock = object.beginBlock !== undefined && object.beginBlock !== null ? $bbde53696c124e5e$exports.ResponseBeginBlock.fromPartial(object.beginBlock) : undefined;
        message.checkTx = object.checkTx !== undefined && object.checkTx !== null ? $bbde53696c124e5e$exports.ResponseCheckTx.fromPartial(object.checkTx) : undefined;
        message.deliverTx = object.deliverTx !== undefined && object.deliverTx !== null ? $bbde53696c124e5e$exports.ResponseDeliverTx.fromPartial(object.deliverTx) : undefined;
        message.endBlock = object.endBlock !== undefined && object.endBlock !== null ? $bbde53696c124e5e$exports.ResponseEndBlock.fromPartial(object.endBlock) : undefined;
        message.commit = object.commit !== undefined && object.commit !== null ? $bbde53696c124e5e$exports.ResponseCommit.fromPartial(object.commit) : undefined;
        message.listSnapshots = object.listSnapshots !== undefined && object.listSnapshots !== null ? $bbde53696c124e5e$exports.ResponseListSnapshots.fromPartial(object.listSnapshots) : undefined;
        message.offerSnapshot = object.offerSnapshot !== undefined && object.offerSnapshot !== null ? $bbde53696c124e5e$exports.ResponseOfferSnapshot.fromPartial(object.offerSnapshot) : undefined;
        message.loadSnapshotChunk = object.loadSnapshotChunk !== undefined && object.loadSnapshotChunk !== null ? $bbde53696c124e5e$exports.ResponseLoadSnapshotChunk.fromPartial(object.loadSnapshotChunk) : undefined;
        message.applySnapshotChunk = object.applySnapshotChunk !== undefined && object.applySnapshotChunk !== null ? $bbde53696c124e5e$exports.ResponseApplySnapshotChunk.fromPartial(object.applySnapshotChunk) : undefined;
        return message;
    }
};
const $bbde53696c124e5e$var$baseResponseException = {
    error: ""
};
$bbde53696c124e5e$exports.ResponseException = {
    encode (message, writer = $bbde53696c124e5e$var$minimal_1.default.Writer.create()) {
        if (message.error !== "") writer.uint32(10).string(message.error);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bbde53696c124e5e$var$minimal_1.default.Reader ? input : new $bbde53696c124e5e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseException);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.error = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseException);
        message.error = object.error !== undefined && object.error !== null ? String(object.error) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.error !== undefined && (obj.error = message.error);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseException);
        message.error = (_a = object.error) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
const $bbde53696c124e5e$var$baseResponseEcho = {
    message: ""
};
$bbde53696c124e5e$exports.ResponseEcho = {
    encode (message, writer = $bbde53696c124e5e$var$minimal_1.default.Writer.create()) {
        if (message.message !== "") writer.uint32(10).string(message.message);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bbde53696c124e5e$var$minimal_1.default.Reader ? input : new $bbde53696c124e5e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseEcho);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.message = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseEcho);
        message.message = object.message !== undefined && object.message !== null ? String(object.message) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.message !== undefined && (obj.message = message.message);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseEcho);
        message.message = (_a = object.message) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
const $bbde53696c124e5e$var$baseResponseFlush = {};
$bbde53696c124e5e$exports.ResponseFlush = {
    encode (_, writer = $bbde53696c124e5e$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bbde53696c124e5e$var$minimal_1.default.Reader ? input : new $bbde53696c124e5e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseFlush);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseFlush);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseFlush);
        return message;
    }
};
const $bbde53696c124e5e$var$baseResponseInfo = {
    data: "",
    version: "",
    appVersion: $bbde53696c124e5e$var$long_1.default.UZERO,
    lastBlockHeight: $bbde53696c124e5e$var$long_1.default.ZERO
};
$bbde53696c124e5e$exports.ResponseInfo = {
    encode (message, writer = $bbde53696c124e5e$var$minimal_1.default.Writer.create()) {
        if (message.data !== "") writer.uint32(10).string(message.data);
        if (message.version !== "") writer.uint32(18).string(message.version);
        if (!message.appVersion.isZero()) writer.uint32(24).uint64(message.appVersion);
        if (!message.lastBlockHeight.isZero()) writer.uint32(32).int64(message.lastBlockHeight);
        if (message.lastBlockAppHash.length !== 0) writer.uint32(42).bytes(message.lastBlockAppHash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bbde53696c124e5e$var$minimal_1.default.Reader ? input : new $bbde53696c124e5e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseInfo);
        message.lastBlockAppHash = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.data = reader.string();
                    break;
                case 2:
                    message.version = reader.string();
                    break;
                case 3:
                    message.appVersion = reader.uint64();
                    break;
                case 4:
                    message.lastBlockHeight = reader.int64();
                    break;
                case 5:
                    message.lastBlockAppHash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseInfo);
        message.data = object.data !== undefined && object.data !== null ? String(object.data) : "";
        message.version = object.version !== undefined && object.version !== null ? String(object.version) : "";
        message.appVersion = object.appVersion !== undefined && object.appVersion !== null ? $bbde53696c124e5e$var$long_1.default.fromString(object.appVersion) : $bbde53696c124e5e$var$long_1.default.UZERO;
        message.lastBlockHeight = object.lastBlockHeight !== undefined && object.lastBlockHeight !== null ? $bbde53696c124e5e$var$long_1.default.fromString(object.lastBlockHeight) : $bbde53696c124e5e$var$long_1.default.ZERO;
        message.lastBlockAppHash = object.lastBlockAppHash !== undefined && object.lastBlockAppHash !== null ? $bbde53696c124e5e$var$bytesFromBase64(object.lastBlockAppHash) : new Uint8Array();
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.data !== undefined && (obj.data = message.data);
        message.version !== undefined && (obj.version = message.version);
        message.appVersion !== undefined && (obj.appVersion = (message.appVersion || $bbde53696c124e5e$var$long_1.default.UZERO).toString());
        message.lastBlockHeight !== undefined && (obj.lastBlockHeight = (message.lastBlockHeight || $bbde53696c124e5e$var$long_1.default.ZERO).toString());
        message.lastBlockAppHash !== undefined && (obj.lastBlockAppHash = $bbde53696c124e5e$var$base64FromBytes(message.lastBlockAppHash !== undefined ? message.lastBlockAppHash : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseInfo);
        message.data = (_a = object.data) !== null && _a !== void 0 ? _a : "";
        message.version = (_b = object.version) !== null && _b !== void 0 ? _b : "";
        message.appVersion = object.appVersion !== undefined && object.appVersion !== null ? $bbde53696c124e5e$var$long_1.default.fromValue(object.appVersion) : $bbde53696c124e5e$var$long_1.default.UZERO;
        message.lastBlockHeight = object.lastBlockHeight !== undefined && object.lastBlockHeight !== null ? $bbde53696c124e5e$var$long_1.default.fromValue(object.lastBlockHeight) : $bbde53696c124e5e$var$long_1.default.ZERO;
        message.lastBlockAppHash = (_c = object.lastBlockAppHash) !== null && _c !== void 0 ? _c : new Uint8Array();
        return message;
    }
};
const $bbde53696c124e5e$var$baseResponseSetOption = {
    code: 0,
    log: "",
    info: ""
};
$bbde53696c124e5e$exports.ResponseSetOption = {
    encode (message, writer = $bbde53696c124e5e$var$minimal_1.default.Writer.create()) {
        if (message.code !== 0) writer.uint32(8).uint32(message.code);
        if (message.log !== "") writer.uint32(26).string(message.log);
        if (message.info !== "") writer.uint32(34).string(message.info);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bbde53696c124e5e$var$minimal_1.default.Reader ? input : new $bbde53696c124e5e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseSetOption);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.code = reader.uint32();
                    break;
                case 3:
                    message.log = reader.string();
                    break;
                case 4:
                    message.info = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseSetOption);
        message.code = object.code !== undefined && object.code !== null ? Number(object.code) : 0;
        message.log = object.log !== undefined && object.log !== null ? String(object.log) : "";
        message.info = object.info !== undefined && object.info !== null ? String(object.info) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.code !== undefined && (obj.code = message.code);
        message.log !== undefined && (obj.log = message.log);
        message.info !== undefined && (obj.info = message.info);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseSetOption);
        message.code = (_a = object.code) !== null && _a !== void 0 ? _a : 0;
        message.log = (_b = object.log) !== null && _b !== void 0 ? _b : "";
        message.info = (_c = object.info) !== null && _c !== void 0 ? _c : "";
        return message;
    }
};
const $bbde53696c124e5e$var$baseResponseInitChain = {};
$bbde53696c124e5e$exports.ResponseInitChain = {
    encode (message, writer = $bbde53696c124e5e$var$minimal_1.default.Writer.create()) {
        if (message.consensusParams !== undefined) $bbde53696c124e5e$exports.ConsensusParams.encode(message.consensusParams, writer.uint32(10).fork()).ldelim();
        for (const v of message.validators)$bbde53696c124e5e$exports.ValidatorUpdate.encode(v, writer.uint32(18).fork()).ldelim();
        if (message.appHash.length !== 0) writer.uint32(26).bytes(message.appHash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bbde53696c124e5e$var$minimal_1.default.Reader ? input : new $bbde53696c124e5e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseInitChain);
        message.validators = [];
        message.appHash = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.consensusParams = $bbde53696c124e5e$exports.ConsensusParams.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.validators.push($bbde53696c124e5e$exports.ValidatorUpdate.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.appHash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseInitChain);
        message.consensusParams = object.consensusParams !== undefined && object.consensusParams !== null ? $bbde53696c124e5e$exports.ConsensusParams.fromJSON(object.consensusParams) : undefined;
        message.validators = ((_a = object.validators) !== null && _a !== void 0 ? _a : []).map((e)=>$bbde53696c124e5e$exports.ValidatorUpdate.fromJSON(e));
        message.appHash = object.appHash !== undefined && object.appHash !== null ? $bbde53696c124e5e$var$bytesFromBase64(object.appHash) : new Uint8Array();
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.consensusParams !== undefined && (obj.consensusParams = message.consensusParams ? $bbde53696c124e5e$exports.ConsensusParams.toJSON(message.consensusParams) : undefined);
        if (message.validators) obj.validators = message.validators.map((e)=>e ? $bbde53696c124e5e$exports.ValidatorUpdate.toJSON(e) : undefined);
        else obj.validators = [];
        message.appHash !== undefined && (obj.appHash = $bbde53696c124e5e$var$base64FromBytes(message.appHash !== undefined ? message.appHash : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseInitChain);
        message.consensusParams = object.consensusParams !== undefined && object.consensusParams !== null ? $bbde53696c124e5e$exports.ConsensusParams.fromPartial(object.consensusParams) : undefined;
        message.validators = ((_a = object.validators) === null || _a === void 0 ? void 0 : _a.map((e)=>$bbde53696c124e5e$exports.ValidatorUpdate.fromPartial(e))) || [];
        message.appHash = (_b = object.appHash) !== null && _b !== void 0 ? _b : new Uint8Array();
        return message;
    }
};
const $bbde53696c124e5e$var$baseResponseQuery = {
    code: 0,
    log: "",
    info: "",
    index: $bbde53696c124e5e$var$long_1.default.ZERO,
    height: $bbde53696c124e5e$var$long_1.default.ZERO,
    codespace: ""
};
$bbde53696c124e5e$exports.ResponseQuery = {
    encode (message, writer = $bbde53696c124e5e$var$minimal_1.default.Writer.create()) {
        if (message.code !== 0) writer.uint32(8).uint32(message.code);
        if (message.log !== "") writer.uint32(26).string(message.log);
        if (message.info !== "") writer.uint32(34).string(message.info);
        if (!message.index.isZero()) writer.uint32(40).int64(message.index);
        if (message.key.length !== 0) writer.uint32(50).bytes(message.key);
        if (message.value.length !== 0) writer.uint32(58).bytes(message.value);
        if (message.proofOps !== undefined) $a2ff8534202d742a$exports.ProofOps.encode(message.proofOps, writer.uint32(66).fork()).ldelim();
        if (!message.height.isZero()) writer.uint32(72).int64(message.height);
        if (message.codespace !== "") writer.uint32(82).string(message.codespace);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bbde53696c124e5e$var$minimal_1.default.Reader ? input : new $bbde53696c124e5e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseQuery);
        message.key = new Uint8Array();
        message.value = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.code = reader.uint32();
                    break;
                case 3:
                    message.log = reader.string();
                    break;
                case 4:
                    message.info = reader.string();
                    break;
                case 5:
                    message.index = reader.int64();
                    break;
                case 6:
                    message.key = reader.bytes();
                    break;
                case 7:
                    message.value = reader.bytes();
                    break;
                case 8:
                    message.proofOps = $a2ff8534202d742a$exports.ProofOps.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.height = reader.int64();
                    break;
                case 10:
                    message.codespace = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseQuery);
        message.code = object.code !== undefined && object.code !== null ? Number(object.code) : 0;
        message.log = object.log !== undefined && object.log !== null ? String(object.log) : "";
        message.info = object.info !== undefined && object.info !== null ? String(object.info) : "";
        message.index = object.index !== undefined && object.index !== null ? $bbde53696c124e5e$var$long_1.default.fromString(object.index) : $bbde53696c124e5e$var$long_1.default.ZERO;
        message.key = object.key !== undefined && object.key !== null ? $bbde53696c124e5e$var$bytesFromBase64(object.key) : new Uint8Array();
        message.value = object.value !== undefined && object.value !== null ? $bbde53696c124e5e$var$bytesFromBase64(object.value) : new Uint8Array();
        message.proofOps = object.proofOps !== undefined && object.proofOps !== null ? $a2ff8534202d742a$exports.ProofOps.fromJSON(object.proofOps) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $bbde53696c124e5e$var$long_1.default.fromString(object.height) : $bbde53696c124e5e$var$long_1.default.ZERO;
        message.codespace = object.codespace !== undefined && object.codespace !== null ? String(object.codespace) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.code !== undefined && (obj.code = message.code);
        message.log !== undefined && (obj.log = message.log);
        message.info !== undefined && (obj.info = message.info);
        message.index !== undefined && (obj.index = (message.index || $bbde53696c124e5e$var$long_1.default.ZERO).toString());
        message.key !== undefined && (obj.key = $bbde53696c124e5e$var$base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        message.value !== undefined && (obj.value = $bbde53696c124e5e$var$base64FromBytes(message.value !== undefined ? message.value : new Uint8Array()));
        message.proofOps !== undefined && (obj.proofOps = message.proofOps ? $a2ff8534202d742a$exports.ProofOps.toJSON(message.proofOps) : undefined);
        message.height !== undefined && (obj.height = (message.height || $bbde53696c124e5e$var$long_1.default.ZERO).toString());
        message.codespace !== undefined && (obj.codespace = message.codespace);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e, _f;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseQuery);
        message.code = (_a = object.code) !== null && _a !== void 0 ? _a : 0;
        message.log = (_b = object.log) !== null && _b !== void 0 ? _b : "";
        message.info = (_c = object.info) !== null && _c !== void 0 ? _c : "";
        message.index = object.index !== undefined && object.index !== null ? $bbde53696c124e5e$var$long_1.default.fromValue(object.index) : $bbde53696c124e5e$var$long_1.default.ZERO;
        message.key = (_d = object.key) !== null && _d !== void 0 ? _d : new Uint8Array();
        message.value = (_e = object.value) !== null && _e !== void 0 ? _e : new Uint8Array();
        message.proofOps = object.proofOps !== undefined && object.proofOps !== null ? $a2ff8534202d742a$exports.ProofOps.fromPartial(object.proofOps) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $bbde53696c124e5e$var$long_1.default.fromValue(object.height) : $bbde53696c124e5e$var$long_1.default.ZERO;
        message.codespace = (_f = object.codespace) !== null && _f !== void 0 ? _f : "";
        return message;
    }
};
const $bbde53696c124e5e$var$baseResponseBeginBlock = {};
$bbde53696c124e5e$exports.ResponseBeginBlock = {
    encode (message, writer = $bbde53696c124e5e$var$minimal_1.default.Writer.create()) {
        for (const v of message.events)$bbde53696c124e5e$exports.Event.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bbde53696c124e5e$var$minimal_1.default.Reader ? input : new $bbde53696c124e5e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseBeginBlock);
        message.events = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.events.push($bbde53696c124e5e$exports.Event.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseBeginBlock);
        message.events = ((_a = object.events) !== null && _a !== void 0 ? _a : []).map((e)=>$bbde53696c124e5e$exports.Event.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.events) obj.events = message.events.map((e)=>e ? $bbde53696c124e5e$exports.Event.toJSON(e) : undefined);
        else obj.events = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseBeginBlock);
        message.events = ((_a = object.events) === null || _a === void 0 ? void 0 : _a.map((e)=>$bbde53696c124e5e$exports.Event.fromPartial(e))) || [];
        return message;
    }
};
const $bbde53696c124e5e$var$baseResponseCheckTx = {
    code: 0,
    log: "",
    info: "",
    gasWanted: $bbde53696c124e5e$var$long_1.default.ZERO,
    gasUsed: $bbde53696c124e5e$var$long_1.default.ZERO,
    codespace: ""
};
$bbde53696c124e5e$exports.ResponseCheckTx = {
    encode (message, writer = $bbde53696c124e5e$var$minimal_1.default.Writer.create()) {
        if (message.code !== 0) writer.uint32(8).uint32(message.code);
        if (message.data.length !== 0) writer.uint32(18).bytes(message.data);
        if (message.log !== "") writer.uint32(26).string(message.log);
        if (message.info !== "") writer.uint32(34).string(message.info);
        if (!message.gasWanted.isZero()) writer.uint32(40).int64(message.gasWanted);
        if (!message.gasUsed.isZero()) writer.uint32(48).int64(message.gasUsed);
        for (const v of message.events)$bbde53696c124e5e$exports.Event.encode(v, writer.uint32(58).fork()).ldelim();
        if (message.codespace !== "") writer.uint32(66).string(message.codespace);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bbde53696c124e5e$var$minimal_1.default.Reader ? input : new $bbde53696c124e5e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseCheckTx);
        message.events = [];
        message.data = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.code = reader.uint32();
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                case 3:
                    message.log = reader.string();
                    break;
                case 4:
                    message.info = reader.string();
                    break;
                case 5:
                    message.gasWanted = reader.int64();
                    break;
                case 6:
                    message.gasUsed = reader.int64();
                    break;
                case 7:
                    message.events.push($bbde53696c124e5e$exports.Event.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.codespace = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseCheckTx);
        message.code = object.code !== undefined && object.code !== null ? Number(object.code) : 0;
        message.data = object.data !== undefined && object.data !== null ? $bbde53696c124e5e$var$bytesFromBase64(object.data) : new Uint8Array();
        message.log = object.log !== undefined && object.log !== null ? String(object.log) : "";
        message.info = object.info !== undefined && object.info !== null ? String(object.info) : "";
        message.gasWanted = object.gas_wanted !== undefined && object.gas_wanted !== null ? $bbde53696c124e5e$var$long_1.default.fromString(object.gas_wanted) : $bbde53696c124e5e$var$long_1.default.ZERO;
        message.gasUsed = object.gas_used !== undefined && object.gas_used !== null ? $bbde53696c124e5e$var$long_1.default.fromString(object.gas_used) : $bbde53696c124e5e$var$long_1.default.ZERO;
        message.events = ((_a = object.events) !== null && _a !== void 0 ? _a : []).map((e)=>$bbde53696c124e5e$exports.Event.fromJSON(e));
        message.codespace = object.codespace !== undefined && object.codespace !== null ? String(object.codespace) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.code !== undefined && (obj.code = message.code);
        message.data !== undefined && (obj.data = $bbde53696c124e5e$var$base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        message.log !== undefined && (obj.log = message.log);
        message.info !== undefined && (obj.info = message.info);
        message.gasWanted !== undefined && (obj.gas_wanted = (message.gasWanted || $bbde53696c124e5e$var$long_1.default.ZERO).toString());
        message.gasUsed !== undefined && (obj.gas_used = (message.gasUsed || $bbde53696c124e5e$var$long_1.default.ZERO).toString());
        if (message.events) obj.events = message.events.map((e)=>e ? $bbde53696c124e5e$exports.Event.toJSON(e) : undefined);
        else obj.events = [];
        message.codespace !== undefined && (obj.codespace = message.codespace);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e, _f;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseCheckTx);
        message.code = (_a = object.code) !== null && _a !== void 0 ? _a : 0;
        message.data = (_b = object.data) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.log = (_c = object.log) !== null && _c !== void 0 ? _c : "";
        message.info = (_d = object.info) !== null && _d !== void 0 ? _d : "";
        message.gasWanted = object.gasWanted !== undefined && object.gasWanted !== null ? $bbde53696c124e5e$var$long_1.default.fromValue(object.gasWanted) : $bbde53696c124e5e$var$long_1.default.ZERO;
        message.gasUsed = object.gasUsed !== undefined && object.gasUsed !== null ? $bbde53696c124e5e$var$long_1.default.fromValue(object.gasUsed) : $bbde53696c124e5e$var$long_1.default.ZERO;
        message.events = ((_e = object.events) === null || _e === void 0 ? void 0 : _e.map((e)=>$bbde53696c124e5e$exports.Event.fromPartial(e))) || [];
        message.codespace = (_f = object.codespace) !== null && _f !== void 0 ? _f : "";
        return message;
    }
};
const $bbde53696c124e5e$var$baseResponseDeliverTx = {
    code: 0,
    log: "",
    info: "",
    gasWanted: $bbde53696c124e5e$var$long_1.default.ZERO,
    gasUsed: $bbde53696c124e5e$var$long_1.default.ZERO,
    codespace: ""
};
$bbde53696c124e5e$exports.ResponseDeliverTx = {
    encode (message, writer = $bbde53696c124e5e$var$minimal_1.default.Writer.create()) {
        if (message.code !== 0) writer.uint32(8).uint32(message.code);
        if (message.data.length !== 0) writer.uint32(18).bytes(message.data);
        if (message.log !== "") writer.uint32(26).string(message.log);
        if (message.info !== "") writer.uint32(34).string(message.info);
        if (!message.gasWanted.isZero()) writer.uint32(40).int64(message.gasWanted);
        if (!message.gasUsed.isZero()) writer.uint32(48).int64(message.gasUsed);
        for (const v of message.events)$bbde53696c124e5e$exports.Event.encode(v, writer.uint32(58).fork()).ldelim();
        if (message.codespace !== "") writer.uint32(66).string(message.codespace);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bbde53696c124e5e$var$minimal_1.default.Reader ? input : new $bbde53696c124e5e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseDeliverTx);
        message.events = [];
        message.data = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.code = reader.uint32();
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                case 3:
                    message.log = reader.string();
                    break;
                case 4:
                    message.info = reader.string();
                    break;
                case 5:
                    message.gasWanted = reader.int64();
                    break;
                case 6:
                    message.gasUsed = reader.int64();
                    break;
                case 7:
                    message.events.push($bbde53696c124e5e$exports.Event.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.codespace = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseDeliverTx);
        message.code = object.code !== undefined && object.code !== null ? Number(object.code) : 0;
        message.data = object.data !== undefined && object.data !== null ? $bbde53696c124e5e$var$bytesFromBase64(object.data) : new Uint8Array();
        message.log = object.log !== undefined && object.log !== null ? String(object.log) : "";
        message.info = object.info !== undefined && object.info !== null ? String(object.info) : "";
        message.gasWanted = object.gas_wanted !== undefined && object.gas_wanted !== null ? $bbde53696c124e5e$var$long_1.default.fromString(object.gas_wanted) : $bbde53696c124e5e$var$long_1.default.ZERO;
        message.gasUsed = object.gas_used !== undefined && object.gas_used !== null ? $bbde53696c124e5e$var$long_1.default.fromString(object.gas_used) : $bbde53696c124e5e$var$long_1.default.ZERO;
        message.events = ((_a = object.events) !== null && _a !== void 0 ? _a : []).map((e)=>$bbde53696c124e5e$exports.Event.fromJSON(e));
        message.codespace = object.codespace !== undefined && object.codespace !== null ? String(object.codespace) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.code !== undefined && (obj.code = message.code);
        message.data !== undefined && (obj.data = $bbde53696c124e5e$var$base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        message.log !== undefined && (obj.log = message.log);
        message.info !== undefined && (obj.info = message.info);
        message.gasWanted !== undefined && (obj.gas_wanted = (message.gasWanted || $bbde53696c124e5e$var$long_1.default.ZERO).toString());
        message.gasUsed !== undefined && (obj.gas_used = (message.gasUsed || $bbde53696c124e5e$var$long_1.default.ZERO).toString());
        if (message.events) obj.events = message.events.map((e)=>e ? $bbde53696c124e5e$exports.Event.toJSON(e) : undefined);
        else obj.events = [];
        message.codespace !== undefined && (obj.codespace = message.codespace);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e, _f;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseDeliverTx);
        message.code = (_a = object.code) !== null && _a !== void 0 ? _a : 0;
        message.data = (_b = object.data) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.log = (_c = object.log) !== null && _c !== void 0 ? _c : "";
        message.info = (_d = object.info) !== null && _d !== void 0 ? _d : "";
        message.gasWanted = object.gasWanted !== undefined && object.gasWanted !== null ? $bbde53696c124e5e$var$long_1.default.fromValue(object.gasWanted) : $bbde53696c124e5e$var$long_1.default.ZERO;
        message.gasUsed = object.gasUsed !== undefined && object.gasUsed !== null ? $bbde53696c124e5e$var$long_1.default.fromValue(object.gasUsed) : $bbde53696c124e5e$var$long_1.default.ZERO;
        message.events = ((_e = object.events) === null || _e === void 0 ? void 0 : _e.map((e)=>$bbde53696c124e5e$exports.Event.fromPartial(e))) || [];
        message.codespace = (_f = object.codespace) !== null && _f !== void 0 ? _f : "";
        return message;
    }
};
const $bbde53696c124e5e$var$baseResponseEndBlock = {};
$bbde53696c124e5e$exports.ResponseEndBlock = {
    encode (message, writer = $bbde53696c124e5e$var$minimal_1.default.Writer.create()) {
        for (const v of message.validatorUpdates)$bbde53696c124e5e$exports.ValidatorUpdate.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.consensusParamUpdates !== undefined) $bbde53696c124e5e$exports.ConsensusParams.encode(message.consensusParamUpdates, writer.uint32(18).fork()).ldelim();
        for (const v of message.events)$bbde53696c124e5e$exports.Event.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bbde53696c124e5e$var$minimal_1.default.Reader ? input : new $bbde53696c124e5e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseEndBlock);
        message.validatorUpdates = [];
        message.events = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorUpdates.push($bbde53696c124e5e$exports.ValidatorUpdate.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.consensusParamUpdates = $bbde53696c124e5e$exports.ConsensusParams.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.events.push($bbde53696c124e5e$exports.Event.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a, _b;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseEndBlock);
        message.validatorUpdates = ((_a = object.validatorUpdates) !== null && _a !== void 0 ? _a : []).map((e)=>$bbde53696c124e5e$exports.ValidatorUpdate.fromJSON(e));
        message.consensusParamUpdates = object.consensusParamUpdates !== undefined && object.consensusParamUpdates !== null ? $bbde53696c124e5e$exports.ConsensusParams.fromJSON(object.consensusParamUpdates) : undefined;
        message.events = ((_b = object.events) !== null && _b !== void 0 ? _b : []).map((e)=>$bbde53696c124e5e$exports.Event.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.validatorUpdates) obj.validatorUpdates = message.validatorUpdates.map((e)=>e ? $bbde53696c124e5e$exports.ValidatorUpdate.toJSON(e) : undefined);
        else obj.validatorUpdates = [];
        message.consensusParamUpdates !== undefined && (obj.consensusParamUpdates = message.consensusParamUpdates ? $bbde53696c124e5e$exports.ConsensusParams.toJSON(message.consensusParamUpdates) : undefined);
        if (message.events) obj.events = message.events.map((e)=>e ? $bbde53696c124e5e$exports.Event.toJSON(e) : undefined);
        else obj.events = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseEndBlock);
        message.validatorUpdates = ((_a = object.validatorUpdates) === null || _a === void 0 ? void 0 : _a.map((e)=>$bbde53696c124e5e$exports.ValidatorUpdate.fromPartial(e))) || [];
        message.consensusParamUpdates = object.consensusParamUpdates !== undefined && object.consensusParamUpdates !== null ? $bbde53696c124e5e$exports.ConsensusParams.fromPartial(object.consensusParamUpdates) : undefined;
        message.events = ((_b = object.events) === null || _b === void 0 ? void 0 : _b.map((e)=>$bbde53696c124e5e$exports.Event.fromPartial(e))) || [];
        return message;
    }
};
const $bbde53696c124e5e$var$baseResponseCommit = {
    retainHeight: $bbde53696c124e5e$var$long_1.default.ZERO
};
$bbde53696c124e5e$exports.ResponseCommit = {
    encode (message, writer = $bbde53696c124e5e$var$minimal_1.default.Writer.create()) {
        if (message.data.length !== 0) writer.uint32(18).bytes(message.data);
        if (!message.retainHeight.isZero()) writer.uint32(24).int64(message.retainHeight);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bbde53696c124e5e$var$minimal_1.default.Reader ? input : new $bbde53696c124e5e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseCommit);
        message.data = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 2:
                    message.data = reader.bytes();
                    break;
                case 3:
                    message.retainHeight = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseCommit);
        message.data = object.data !== undefined && object.data !== null ? $bbde53696c124e5e$var$bytesFromBase64(object.data) : new Uint8Array();
        message.retainHeight = object.retainHeight !== undefined && object.retainHeight !== null ? $bbde53696c124e5e$var$long_1.default.fromString(object.retainHeight) : $bbde53696c124e5e$var$long_1.default.ZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.data !== undefined && (obj.data = $bbde53696c124e5e$var$base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        message.retainHeight !== undefined && (obj.retainHeight = (message.retainHeight || $bbde53696c124e5e$var$long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseCommit);
        message.data = (_a = object.data) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.retainHeight = object.retainHeight !== undefined && object.retainHeight !== null ? $bbde53696c124e5e$var$long_1.default.fromValue(object.retainHeight) : $bbde53696c124e5e$var$long_1.default.ZERO;
        return message;
    }
};
const $bbde53696c124e5e$var$baseResponseListSnapshots = {};
$bbde53696c124e5e$exports.ResponseListSnapshots = {
    encode (message, writer = $bbde53696c124e5e$var$minimal_1.default.Writer.create()) {
        for (const v of message.snapshots)$bbde53696c124e5e$exports.Snapshot.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bbde53696c124e5e$var$minimal_1.default.Reader ? input : new $bbde53696c124e5e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseListSnapshots);
        message.snapshots = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.snapshots.push($bbde53696c124e5e$exports.Snapshot.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseListSnapshots);
        message.snapshots = ((_a = object.snapshots) !== null && _a !== void 0 ? _a : []).map((e)=>$bbde53696c124e5e$exports.Snapshot.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.snapshots) obj.snapshots = message.snapshots.map((e)=>e ? $bbde53696c124e5e$exports.Snapshot.toJSON(e) : undefined);
        else obj.snapshots = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseListSnapshots);
        message.snapshots = ((_a = object.snapshots) === null || _a === void 0 ? void 0 : _a.map((e)=>$bbde53696c124e5e$exports.Snapshot.fromPartial(e))) || [];
        return message;
    }
};
const $bbde53696c124e5e$var$baseResponseOfferSnapshot = {
    result: 0
};
$bbde53696c124e5e$exports.ResponseOfferSnapshot = {
    encode (message, writer = $bbde53696c124e5e$var$minimal_1.default.Writer.create()) {
        if (message.result !== 0) writer.uint32(8).int32(message.result);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bbde53696c124e5e$var$minimal_1.default.Reader ? input : new $bbde53696c124e5e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseOfferSnapshot);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.result = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseOfferSnapshot);
        message.result = object.result !== undefined && object.result !== null ? $bbde53696c124e5e$var$responseOfferSnapshot_ResultFromJSON(object.result) : 0;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.result !== undefined && (obj.result = $bbde53696c124e5e$var$responseOfferSnapshot_ResultToJSON(message.result));
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseOfferSnapshot);
        message.result = (_a = object.result) !== null && _a !== void 0 ? _a : 0;
        return message;
    }
};
const $bbde53696c124e5e$var$baseResponseLoadSnapshotChunk = {};
$bbde53696c124e5e$exports.ResponseLoadSnapshotChunk = {
    encode (message, writer = $bbde53696c124e5e$var$minimal_1.default.Writer.create()) {
        if (message.chunk.length !== 0) writer.uint32(10).bytes(message.chunk);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bbde53696c124e5e$var$minimal_1.default.Reader ? input : new $bbde53696c124e5e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseLoadSnapshotChunk);
        message.chunk = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.chunk = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseLoadSnapshotChunk);
        message.chunk = object.chunk !== undefined && object.chunk !== null ? $bbde53696c124e5e$var$bytesFromBase64(object.chunk) : new Uint8Array();
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.chunk !== undefined && (obj.chunk = $bbde53696c124e5e$var$base64FromBytes(message.chunk !== undefined ? message.chunk : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseLoadSnapshotChunk);
        message.chunk = (_a = object.chunk) !== null && _a !== void 0 ? _a : new Uint8Array();
        return message;
    }
};
const $bbde53696c124e5e$var$baseResponseApplySnapshotChunk = {
    result: 0,
    refetchChunks: 0,
    rejectSenders: ""
};
$bbde53696c124e5e$exports.ResponseApplySnapshotChunk = {
    encode (message, writer = $bbde53696c124e5e$var$minimal_1.default.Writer.create()) {
        if (message.result !== 0) writer.uint32(8).int32(message.result);
        writer.uint32(18).fork();
        for (const v of message.refetchChunks)writer.uint32(v);
        writer.ldelim();
        for (const v of message.rejectSenders)writer.uint32(26).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bbde53696c124e5e$var$minimal_1.default.Reader ? input : new $bbde53696c124e5e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseApplySnapshotChunk);
        message.refetchChunks = [];
        message.rejectSenders = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.result = reader.int32();
                    break;
                case 2:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.refetchChunks.push(reader.uint32());
                    } else message.refetchChunks.push(reader.uint32());
                    break;
                case 3:
                    message.rejectSenders.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a, _b;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseApplySnapshotChunk);
        message.result = object.result !== undefined && object.result !== null ? $bbde53696c124e5e$var$responseApplySnapshotChunk_ResultFromJSON(object.result) : 0;
        message.refetchChunks = ((_a = object.refetchChunks) !== null && _a !== void 0 ? _a : []).map((e)=>Number(e));
        message.rejectSenders = ((_b = object.rejectSenders) !== null && _b !== void 0 ? _b : []).map((e)=>String(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.result !== undefined && (obj.result = $bbde53696c124e5e$var$responseApplySnapshotChunk_ResultToJSON(message.result));
        if (message.refetchChunks) obj.refetchChunks = message.refetchChunks.map((e)=>e);
        else obj.refetchChunks = [];
        if (message.rejectSenders) obj.rejectSenders = message.rejectSenders.map((e)=>e);
        else obj.rejectSenders = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseResponseApplySnapshotChunk);
        message.result = (_a = object.result) !== null && _a !== void 0 ? _a : 0;
        message.refetchChunks = ((_b = object.refetchChunks) === null || _b === void 0 ? void 0 : _b.map((e)=>e)) || [];
        message.rejectSenders = ((_c = object.rejectSenders) === null || _c === void 0 ? void 0 : _c.map((e)=>e)) || [];
        return message;
    }
};
const $bbde53696c124e5e$var$baseConsensusParams = {};
$bbde53696c124e5e$exports.ConsensusParams = {
    encode (message, writer = $bbde53696c124e5e$var$minimal_1.default.Writer.create()) {
        if (message.block !== undefined) $bbde53696c124e5e$exports.BlockParams.encode(message.block, writer.uint32(10).fork()).ldelim();
        if (message.evidence !== undefined) $8f32fca53ba3eb82$exports.EvidenceParams.encode(message.evidence, writer.uint32(18).fork()).ldelim();
        if (message.validator !== undefined) $8f32fca53ba3eb82$exports.ValidatorParams.encode(message.validator, writer.uint32(26).fork()).ldelim();
        if (message.version !== undefined) $8f32fca53ba3eb82$exports.VersionParams.encode(message.version, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bbde53696c124e5e$var$minimal_1.default.Reader ? input : new $bbde53696c124e5e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseConsensusParams);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.block = $bbde53696c124e5e$exports.BlockParams.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.evidence = $8f32fca53ba3eb82$exports.EvidenceParams.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.validator = $8f32fca53ba3eb82$exports.ValidatorParams.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.version = $8f32fca53ba3eb82$exports.VersionParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $bbde53696c124e5e$var$baseConsensusParams);
        message.block = object.block !== undefined && object.block !== null ? $bbde53696c124e5e$exports.BlockParams.fromJSON(object.block) : undefined;
        message.evidence = object.evidence !== undefined && object.evidence !== null ? $8f32fca53ba3eb82$exports.EvidenceParams.fromJSON(object.evidence) : undefined;
        message.validator = object.validator !== undefined && object.validator !== null ? $8f32fca53ba3eb82$exports.ValidatorParams.fromJSON(object.validator) : undefined;
        message.version = object.version !== undefined && object.version !== null ? $8f32fca53ba3eb82$exports.VersionParams.fromJSON(object.version) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.block !== undefined && (obj.block = message.block ? $bbde53696c124e5e$exports.BlockParams.toJSON(message.block) : undefined);
        message.evidence !== undefined && (obj.evidence = message.evidence ? $8f32fca53ba3eb82$exports.EvidenceParams.toJSON(message.evidence) : undefined);
        message.validator !== undefined && (obj.validator = message.validator ? $8f32fca53ba3eb82$exports.ValidatorParams.toJSON(message.validator) : undefined);
        message.version !== undefined && (obj.version = message.version ? $8f32fca53ba3eb82$exports.VersionParams.toJSON(message.version) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $bbde53696c124e5e$var$baseConsensusParams);
        message.block = object.block !== undefined && object.block !== null ? $bbde53696c124e5e$exports.BlockParams.fromPartial(object.block) : undefined;
        message.evidence = object.evidence !== undefined && object.evidence !== null ? $8f32fca53ba3eb82$exports.EvidenceParams.fromPartial(object.evidence) : undefined;
        message.validator = object.validator !== undefined && object.validator !== null ? $8f32fca53ba3eb82$exports.ValidatorParams.fromPartial(object.validator) : undefined;
        message.version = object.version !== undefined && object.version !== null ? $8f32fca53ba3eb82$exports.VersionParams.fromPartial(object.version) : undefined;
        return message;
    }
};
const $bbde53696c124e5e$var$baseBlockParams = {
    maxBytes: $bbde53696c124e5e$var$long_1.default.ZERO,
    maxGas: $bbde53696c124e5e$var$long_1.default.ZERO
};
$bbde53696c124e5e$exports.BlockParams = {
    encode (message, writer = $bbde53696c124e5e$var$minimal_1.default.Writer.create()) {
        if (!message.maxBytes.isZero()) writer.uint32(8).int64(message.maxBytes);
        if (!message.maxGas.isZero()) writer.uint32(16).int64(message.maxGas);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bbde53696c124e5e$var$minimal_1.default.Reader ? input : new $bbde53696c124e5e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseBlockParams);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.maxBytes = reader.int64();
                    break;
                case 2:
                    message.maxGas = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $bbde53696c124e5e$var$baseBlockParams);
        message.maxBytes = object.maxBytes !== undefined && object.maxBytes !== null ? $bbde53696c124e5e$var$long_1.default.fromString(object.maxBytes) : $bbde53696c124e5e$var$long_1.default.ZERO;
        message.maxGas = object.maxGas !== undefined && object.maxGas !== null ? $bbde53696c124e5e$var$long_1.default.fromString(object.maxGas) : $bbde53696c124e5e$var$long_1.default.ZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.maxBytes !== undefined && (obj.maxBytes = (message.maxBytes || $bbde53696c124e5e$var$long_1.default.ZERO).toString());
        message.maxGas !== undefined && (obj.maxGas = (message.maxGas || $bbde53696c124e5e$var$long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $bbde53696c124e5e$var$baseBlockParams);
        message.maxBytes = object.maxBytes !== undefined && object.maxBytes !== null ? $bbde53696c124e5e$var$long_1.default.fromValue(object.maxBytes) : $bbde53696c124e5e$var$long_1.default.ZERO;
        message.maxGas = object.maxGas !== undefined && object.maxGas !== null ? $bbde53696c124e5e$var$long_1.default.fromValue(object.maxGas) : $bbde53696c124e5e$var$long_1.default.ZERO;
        return message;
    }
};
const $bbde53696c124e5e$var$baseLastCommitInfo = {
    round: 0
};
$bbde53696c124e5e$exports.LastCommitInfo = {
    encode (message, writer = $bbde53696c124e5e$var$minimal_1.default.Writer.create()) {
        if (message.round !== 0) writer.uint32(8).int32(message.round);
        for (const v of message.votes)$bbde53696c124e5e$exports.VoteInfo.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bbde53696c124e5e$var$minimal_1.default.Reader ? input : new $bbde53696c124e5e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseLastCommitInfo);
        message.votes = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.round = reader.int32();
                    break;
                case 2:
                    message.votes.push($bbde53696c124e5e$exports.VoteInfo.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseLastCommitInfo);
        message.round = object.round !== undefined && object.round !== null ? Number(object.round) : 0;
        message.votes = ((_a = object.votes) !== null && _a !== void 0 ? _a : []).map((e)=>$bbde53696c124e5e$exports.VoteInfo.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.round !== undefined && (obj.round = message.round);
        if (message.votes) obj.votes = message.votes.map((e)=>e ? $bbde53696c124e5e$exports.VoteInfo.toJSON(e) : undefined);
        else obj.votes = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseLastCommitInfo);
        message.round = (_a = object.round) !== null && _a !== void 0 ? _a : 0;
        message.votes = ((_b = object.votes) === null || _b === void 0 ? void 0 : _b.map((e)=>$bbde53696c124e5e$exports.VoteInfo.fromPartial(e))) || [];
        return message;
    }
};
const $bbde53696c124e5e$var$baseEvent = {
    type: ""
};
$bbde53696c124e5e$exports.Event = {
    encode (message, writer = $bbde53696c124e5e$var$minimal_1.default.Writer.create()) {
        if (message.type !== "") writer.uint32(10).string(message.type);
        for (const v of message.attributes)$bbde53696c124e5e$exports.EventAttribute.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bbde53696c124e5e$var$minimal_1.default.Reader ? input : new $bbde53696c124e5e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseEvent);
        message.attributes = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.string();
                    break;
                case 2:
                    message.attributes.push($bbde53696c124e5e$exports.EventAttribute.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseEvent);
        message.type = object.type !== undefined && object.type !== null ? String(object.type) : "";
        message.attributes = ((_a = object.attributes) !== null && _a !== void 0 ? _a : []).map((e)=>$bbde53696c124e5e$exports.EventAttribute.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.type !== undefined && (obj.type = message.type);
        if (message.attributes) obj.attributes = message.attributes.map((e)=>e ? $bbde53696c124e5e$exports.EventAttribute.toJSON(e) : undefined);
        else obj.attributes = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseEvent);
        message.type = (_a = object.type) !== null && _a !== void 0 ? _a : "";
        message.attributes = ((_b = object.attributes) === null || _b === void 0 ? void 0 : _b.map((e)=>$bbde53696c124e5e$exports.EventAttribute.fromPartial(e))) || [];
        return message;
    }
};
const $bbde53696c124e5e$var$baseEventAttribute = {
    index: false
};
$bbde53696c124e5e$exports.EventAttribute = {
    encode (message, writer = $bbde53696c124e5e$var$minimal_1.default.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (message.value.length !== 0) writer.uint32(18).bytes(message.value);
        if (message.index === true) writer.uint32(24).bool(message.index);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bbde53696c124e5e$var$minimal_1.default.Reader ? input : new $bbde53696c124e5e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseEventAttribute);
        message.key = new Uint8Array();
        message.value = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.value = reader.bytes();
                    break;
                case 3:
                    message.index = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $bbde53696c124e5e$var$baseEventAttribute);
        message.key = object.key !== undefined && object.key !== null ? $bbde53696c124e5e$var$bytesFromBase64(object.key) : new Uint8Array();
        message.value = object.value !== undefined && object.value !== null ? $bbde53696c124e5e$var$bytesFromBase64(object.value) : new Uint8Array();
        message.index = object.index !== undefined && object.index !== null ? Boolean(object.index) : false;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = $bbde53696c124e5e$var$base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        message.value !== undefined && (obj.value = $bbde53696c124e5e$var$base64FromBytes(message.value !== undefined ? message.value : new Uint8Array()));
        message.index !== undefined && (obj.index = message.index);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseEventAttribute);
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.index = (_c = object.index) !== null && _c !== void 0 ? _c : false;
        return message;
    }
};
const $bbde53696c124e5e$var$baseTxResult = {
    height: $bbde53696c124e5e$var$long_1.default.ZERO,
    index: 0
};
$bbde53696c124e5e$exports.TxResult = {
    encode (message, writer = $bbde53696c124e5e$var$minimal_1.default.Writer.create()) {
        if (!message.height.isZero()) writer.uint32(8).int64(message.height);
        if (message.index !== 0) writer.uint32(16).uint32(message.index);
        if (message.tx.length !== 0) writer.uint32(26).bytes(message.tx);
        if (message.result !== undefined) $bbde53696c124e5e$exports.ResponseDeliverTx.encode(message.result, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bbde53696c124e5e$var$minimal_1.default.Reader ? input : new $bbde53696c124e5e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseTxResult);
        message.tx = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.int64();
                    break;
                case 2:
                    message.index = reader.uint32();
                    break;
                case 3:
                    message.tx = reader.bytes();
                    break;
                case 4:
                    message.result = $bbde53696c124e5e$exports.ResponseDeliverTx.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $bbde53696c124e5e$var$baseTxResult);
        message.height = object.height !== undefined && object.height !== null ? $bbde53696c124e5e$var$long_1.default.fromString(object.height) : $bbde53696c124e5e$var$long_1.default.ZERO;
        message.index = object.index !== undefined && object.index !== null ? Number(object.index) : 0;
        message.tx = object.tx !== undefined && object.tx !== null ? $bbde53696c124e5e$var$bytesFromBase64(object.tx) : new Uint8Array();
        message.result = object.result !== undefined && object.result !== null ? $bbde53696c124e5e$exports.ResponseDeliverTx.fromJSON(object.result) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || $bbde53696c124e5e$var$long_1.default.ZERO).toString());
        message.index !== undefined && (obj.index = message.index);
        message.tx !== undefined && (obj.tx = $bbde53696c124e5e$var$base64FromBytes(message.tx !== undefined ? message.tx : new Uint8Array()));
        message.result !== undefined && (obj.result = message.result ? $bbde53696c124e5e$exports.ResponseDeliverTx.toJSON(message.result) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseTxResult);
        message.height = object.height !== undefined && object.height !== null ? $bbde53696c124e5e$var$long_1.default.fromValue(object.height) : $bbde53696c124e5e$var$long_1.default.ZERO;
        message.index = (_a = object.index) !== null && _a !== void 0 ? _a : 0;
        message.tx = (_b = object.tx) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.result = object.result !== undefined && object.result !== null ? $bbde53696c124e5e$exports.ResponseDeliverTx.fromPartial(object.result) : undefined;
        return message;
    }
};
const $bbde53696c124e5e$var$baseValidator = {
    power: $bbde53696c124e5e$var$long_1.default.ZERO
};
$bbde53696c124e5e$exports.Validator = {
    encode (message, writer = $bbde53696c124e5e$var$minimal_1.default.Writer.create()) {
        if (message.address.length !== 0) writer.uint32(10).bytes(message.address);
        if (!message.power.isZero()) writer.uint32(24).int64(message.power);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bbde53696c124e5e$var$minimal_1.default.Reader ? input : new $bbde53696c124e5e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseValidator);
        message.address = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.bytes();
                    break;
                case 3:
                    message.power = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $bbde53696c124e5e$var$baseValidator);
        message.address = object.address !== undefined && object.address !== null ? $bbde53696c124e5e$var$bytesFromBase64(object.address) : new Uint8Array();
        message.power = object.power !== undefined && object.power !== null ? $bbde53696c124e5e$var$long_1.default.fromString(object.power) : $bbde53696c124e5e$var$long_1.default.ZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = $bbde53696c124e5e$var$base64FromBytes(message.address !== undefined ? message.address : new Uint8Array()));
        message.power !== undefined && (obj.power = (message.power || $bbde53696c124e5e$var$long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseValidator);
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.power = object.power !== undefined && object.power !== null ? $bbde53696c124e5e$var$long_1.default.fromValue(object.power) : $bbde53696c124e5e$var$long_1.default.ZERO;
        return message;
    }
};
const $bbde53696c124e5e$var$baseValidatorUpdate = {
    power: $bbde53696c124e5e$var$long_1.default.ZERO
};
$bbde53696c124e5e$exports.ValidatorUpdate = {
    encode (message, writer = $bbde53696c124e5e$var$minimal_1.default.Writer.create()) {
        if (message.pubKey !== undefined) $a9eed36e4809ba05$exports.PublicKey.encode(message.pubKey, writer.uint32(10).fork()).ldelim();
        if (!message.power.isZero()) writer.uint32(16).int64(message.power);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bbde53696c124e5e$var$minimal_1.default.Reader ? input : new $bbde53696c124e5e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseValidatorUpdate);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pubKey = $a9eed36e4809ba05$exports.PublicKey.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.power = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $bbde53696c124e5e$var$baseValidatorUpdate);
        message.pubKey = object.pubKey !== undefined && object.pubKey !== null ? $a9eed36e4809ba05$exports.PublicKey.fromJSON(object.pubKey) : undefined;
        message.power = object.power !== undefined && object.power !== null ? $bbde53696c124e5e$var$long_1.default.fromString(object.power) : $bbde53696c124e5e$var$long_1.default.ZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.pubKey !== undefined && (obj.pubKey = message.pubKey ? $a9eed36e4809ba05$exports.PublicKey.toJSON(message.pubKey) : undefined);
        message.power !== undefined && (obj.power = (message.power || $bbde53696c124e5e$var$long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $bbde53696c124e5e$var$baseValidatorUpdate);
        message.pubKey = object.pubKey !== undefined && object.pubKey !== null ? $a9eed36e4809ba05$exports.PublicKey.fromPartial(object.pubKey) : undefined;
        message.power = object.power !== undefined && object.power !== null ? $bbde53696c124e5e$var$long_1.default.fromValue(object.power) : $bbde53696c124e5e$var$long_1.default.ZERO;
        return message;
    }
};
const $bbde53696c124e5e$var$baseVoteInfo = {
    signedLastBlock: false
};
$bbde53696c124e5e$exports.VoteInfo = {
    encode (message, writer = $bbde53696c124e5e$var$minimal_1.default.Writer.create()) {
        if (message.validator !== undefined) $bbde53696c124e5e$exports.Validator.encode(message.validator, writer.uint32(10).fork()).ldelim();
        if (message.signedLastBlock === true) writer.uint32(16).bool(message.signedLastBlock);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bbde53696c124e5e$var$minimal_1.default.Reader ? input : new $bbde53696c124e5e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseVoteInfo);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validator = $bbde53696c124e5e$exports.Validator.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.signedLastBlock = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $bbde53696c124e5e$var$baseVoteInfo);
        message.validator = object.validator !== undefined && object.validator !== null ? $bbde53696c124e5e$exports.Validator.fromJSON(object.validator) : undefined;
        message.signedLastBlock = object.signedLastBlock !== undefined && object.signedLastBlock !== null ? Boolean(object.signedLastBlock) : false;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.validator !== undefined && (obj.validator = message.validator ? $bbde53696c124e5e$exports.Validator.toJSON(message.validator) : undefined);
        message.signedLastBlock !== undefined && (obj.signedLastBlock = message.signedLastBlock);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseVoteInfo);
        message.validator = object.validator !== undefined && object.validator !== null ? $bbde53696c124e5e$exports.Validator.fromPartial(object.validator) : undefined;
        message.signedLastBlock = (_a = object.signedLastBlock) !== null && _a !== void 0 ? _a : false;
        return message;
    }
};
const $bbde53696c124e5e$var$baseEvidence = {
    type: 0,
    height: $bbde53696c124e5e$var$long_1.default.ZERO,
    totalVotingPower: $bbde53696c124e5e$var$long_1.default.ZERO
};
$bbde53696c124e5e$exports.Evidence = {
    encode (message, writer = $bbde53696c124e5e$var$minimal_1.default.Writer.create()) {
        if (message.type !== 0) writer.uint32(8).int32(message.type);
        if (message.validator !== undefined) $bbde53696c124e5e$exports.Validator.encode(message.validator, writer.uint32(18).fork()).ldelim();
        if (!message.height.isZero()) writer.uint32(24).int64(message.height);
        if (message.time !== undefined) $d6c3291d6aa8eb5b$exports.Timestamp.encode(message.time, writer.uint32(34).fork()).ldelim();
        if (!message.totalVotingPower.isZero()) writer.uint32(40).int64(message.totalVotingPower);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bbde53696c124e5e$var$minimal_1.default.Reader ? input : new $bbde53696c124e5e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseEvidence);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.int32();
                    break;
                case 2:
                    message.validator = $bbde53696c124e5e$exports.Validator.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = reader.int64();
                    break;
                case 4:
                    message.time = $d6c3291d6aa8eb5b$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.totalVotingPower = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $bbde53696c124e5e$var$baseEvidence);
        message.type = object.type !== undefined && object.type !== null ? $bbde53696c124e5e$var$evidenceTypeFromJSON(object.type) : 0;
        message.validator = object.validator !== undefined && object.validator !== null ? $bbde53696c124e5e$exports.Validator.fromJSON(object.validator) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $bbde53696c124e5e$var$long_1.default.fromString(object.height) : $bbde53696c124e5e$var$long_1.default.ZERO;
        message.time = object.time !== undefined && object.time !== null ? $bbde53696c124e5e$var$fromJsonTimestamp(object.time) : undefined;
        message.totalVotingPower = object.totalVotingPower !== undefined && object.totalVotingPower !== null ? $bbde53696c124e5e$var$long_1.default.fromString(object.totalVotingPower) : $bbde53696c124e5e$var$long_1.default.ZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.type !== undefined && (obj.type = $bbde53696c124e5e$var$evidenceTypeToJSON(message.type));
        message.validator !== undefined && (obj.validator = message.validator ? $bbde53696c124e5e$exports.Validator.toJSON(message.validator) : undefined);
        message.height !== undefined && (obj.height = (message.height || $bbde53696c124e5e$var$long_1.default.ZERO).toString());
        message.time !== undefined && (obj.time = $bbde53696c124e5e$var$fromTimestamp(message.time).toISOString());
        message.totalVotingPower !== undefined && (obj.totalVotingPower = (message.totalVotingPower || $bbde53696c124e5e$var$long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseEvidence);
        message.type = (_a = object.type) !== null && _a !== void 0 ? _a : 0;
        message.validator = object.validator !== undefined && object.validator !== null ? $bbde53696c124e5e$exports.Validator.fromPartial(object.validator) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $bbde53696c124e5e$var$long_1.default.fromValue(object.height) : $bbde53696c124e5e$var$long_1.default.ZERO;
        message.time = object.time !== undefined && object.time !== null ? $d6c3291d6aa8eb5b$exports.Timestamp.fromPartial(object.time) : undefined;
        message.totalVotingPower = object.totalVotingPower !== undefined && object.totalVotingPower !== null ? $bbde53696c124e5e$var$long_1.default.fromValue(object.totalVotingPower) : $bbde53696c124e5e$var$long_1.default.ZERO;
        return message;
    }
};
const $bbde53696c124e5e$var$baseSnapshot = {
    height: $bbde53696c124e5e$var$long_1.default.UZERO,
    format: 0,
    chunks: 0
};
$bbde53696c124e5e$exports.Snapshot = {
    encode (message, writer = $bbde53696c124e5e$var$minimal_1.default.Writer.create()) {
        if (!message.height.isZero()) writer.uint32(8).uint64(message.height);
        if (message.format !== 0) writer.uint32(16).uint32(message.format);
        if (message.chunks !== 0) writer.uint32(24).uint32(message.chunks);
        if (message.hash.length !== 0) writer.uint32(34).bytes(message.hash);
        if (message.metadata.length !== 0) writer.uint32(42).bytes(message.metadata);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bbde53696c124e5e$var$minimal_1.default.Reader ? input : new $bbde53696c124e5e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseSnapshot);
        message.hash = new Uint8Array();
        message.metadata = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.uint64();
                    break;
                case 2:
                    message.format = reader.uint32();
                    break;
                case 3:
                    message.chunks = reader.uint32();
                    break;
                case 4:
                    message.hash = reader.bytes();
                    break;
                case 5:
                    message.metadata = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $bbde53696c124e5e$var$baseSnapshot);
        message.height = object.height !== undefined && object.height !== null ? $bbde53696c124e5e$var$long_1.default.fromString(object.height) : $bbde53696c124e5e$var$long_1.default.UZERO;
        message.format = object.format !== undefined && object.format !== null ? Number(object.format) : 0;
        message.chunks = object.chunks !== undefined && object.chunks !== null ? Number(object.chunks) : 0;
        message.hash = object.hash !== undefined && object.hash !== null ? $bbde53696c124e5e$var$bytesFromBase64(object.hash) : new Uint8Array();
        message.metadata = object.metadata !== undefined && object.metadata !== null ? $bbde53696c124e5e$var$bytesFromBase64(object.metadata) : new Uint8Array();
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || $bbde53696c124e5e$var$long_1.default.UZERO).toString());
        message.format !== undefined && (obj.format = message.format);
        message.chunks !== undefined && (obj.chunks = message.chunks);
        message.hash !== undefined && (obj.hash = $bbde53696c124e5e$var$base64FromBytes(message.hash !== undefined ? message.hash : new Uint8Array()));
        message.metadata !== undefined && (obj.metadata = $bbde53696c124e5e$var$base64FromBytes(message.metadata !== undefined ? message.metadata : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = Object.assign({}, $bbde53696c124e5e$var$baseSnapshot);
        message.height = object.height !== undefined && object.height !== null ? $bbde53696c124e5e$var$long_1.default.fromValue(object.height) : $bbde53696c124e5e$var$long_1.default.UZERO;
        message.format = (_a = object.format) !== null && _a !== void 0 ? _a : 0;
        message.chunks = (_b = object.chunks) !== null && _b !== void 0 ? _b : 0;
        message.hash = (_c = object.hash) !== null && _c !== void 0 ? _c : new Uint8Array();
        message.metadata = (_d = object.metadata) !== null && _d !== void 0 ? _d : new Uint8Array();
        return message;
    }
};
class $bbde53696c124e5e$var$ABCIApplicationClientImpl {
    Echo(request) {
        const data = $bbde53696c124e5e$exports.RequestEcho.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "Echo", data);
        return promise.then((data)=>$bbde53696c124e5e$exports.ResponseEcho.decode(new $bbde53696c124e5e$var$minimal_1.default.Reader(data)));
    }
    Flush(request) {
        const data = $bbde53696c124e5e$exports.RequestFlush.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "Flush", data);
        return promise.then((data)=>$bbde53696c124e5e$exports.ResponseFlush.decode(new $bbde53696c124e5e$var$minimal_1.default.Reader(data)));
    }
    Info(request) {
        const data = $bbde53696c124e5e$exports.RequestInfo.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "Info", data);
        return promise.then((data)=>$bbde53696c124e5e$exports.ResponseInfo.decode(new $bbde53696c124e5e$var$minimal_1.default.Reader(data)));
    }
    SetOption(request) {
        const data = $bbde53696c124e5e$exports.RequestSetOption.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "SetOption", data);
        return promise.then((data)=>$bbde53696c124e5e$exports.ResponseSetOption.decode(new $bbde53696c124e5e$var$minimal_1.default.Reader(data)));
    }
    DeliverTx(request) {
        const data = $bbde53696c124e5e$exports.RequestDeliverTx.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "DeliverTx", data);
        return promise.then((data)=>$bbde53696c124e5e$exports.ResponseDeliverTx.decode(new $bbde53696c124e5e$var$minimal_1.default.Reader(data)));
    }
    CheckTx(request) {
        const data = $bbde53696c124e5e$exports.RequestCheckTx.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "CheckTx", data);
        return promise.then((data)=>$bbde53696c124e5e$exports.ResponseCheckTx.decode(new $bbde53696c124e5e$var$minimal_1.default.Reader(data)));
    }
    Query(request) {
        const data = $bbde53696c124e5e$exports.RequestQuery.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "Query", data);
        return promise.then((data)=>$bbde53696c124e5e$exports.ResponseQuery.decode(new $bbde53696c124e5e$var$minimal_1.default.Reader(data)));
    }
    Commit(request) {
        const data = $bbde53696c124e5e$exports.RequestCommit.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "Commit", data);
        return promise.then((data)=>$bbde53696c124e5e$exports.ResponseCommit.decode(new $bbde53696c124e5e$var$minimal_1.default.Reader(data)));
    }
    InitChain(request) {
        const data = $bbde53696c124e5e$exports.RequestInitChain.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "InitChain", data);
        return promise.then((data)=>$bbde53696c124e5e$exports.ResponseInitChain.decode(new $bbde53696c124e5e$var$minimal_1.default.Reader(data)));
    }
    BeginBlock(request) {
        const data = $bbde53696c124e5e$exports.RequestBeginBlock.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "BeginBlock", data);
        return promise.then((data)=>$bbde53696c124e5e$exports.ResponseBeginBlock.decode(new $bbde53696c124e5e$var$minimal_1.default.Reader(data)));
    }
    EndBlock(request) {
        const data = $bbde53696c124e5e$exports.RequestEndBlock.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "EndBlock", data);
        return promise.then((data)=>$bbde53696c124e5e$exports.ResponseEndBlock.decode(new $bbde53696c124e5e$var$minimal_1.default.Reader(data)));
    }
    ListSnapshots(request) {
        const data = $bbde53696c124e5e$exports.RequestListSnapshots.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "ListSnapshots", data);
        return promise.then((data)=>$bbde53696c124e5e$exports.ResponseListSnapshots.decode(new $bbde53696c124e5e$var$minimal_1.default.Reader(data)));
    }
    OfferSnapshot(request) {
        const data = $bbde53696c124e5e$exports.RequestOfferSnapshot.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "OfferSnapshot", data);
        return promise.then((data)=>$bbde53696c124e5e$exports.ResponseOfferSnapshot.decode(new $bbde53696c124e5e$var$minimal_1.default.Reader(data)));
    }
    LoadSnapshotChunk(request) {
        const data = $bbde53696c124e5e$exports.RequestLoadSnapshotChunk.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "LoadSnapshotChunk", data);
        return promise.then((data)=>$bbde53696c124e5e$exports.ResponseLoadSnapshotChunk.decode(new $bbde53696c124e5e$var$minimal_1.default.Reader(data)));
    }
    ApplySnapshotChunk(request) {
        const data = $bbde53696c124e5e$exports.RequestApplySnapshotChunk.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "ApplySnapshotChunk", data);
        return promise.then((data)=>$bbde53696c124e5e$exports.ResponseApplySnapshotChunk.decode(new $bbde53696c124e5e$var$minimal_1.default.Reader(data)));
    }
    constructor(rpc){
        this.rpc = rpc;
        this.Echo = this.Echo.bind(this);
        this.Flush = this.Flush.bind(this);
        this.Info = this.Info.bind(this);
        this.SetOption = this.SetOption.bind(this);
        this.DeliverTx = this.DeliverTx.bind(this);
        this.CheckTx = this.CheckTx.bind(this);
        this.Query = this.Query.bind(this);
        this.Commit = this.Commit.bind(this);
        this.InitChain = this.InitChain.bind(this);
        this.BeginBlock = this.BeginBlock.bind(this);
        this.EndBlock = this.EndBlock.bind(this);
        this.ListSnapshots = this.ListSnapshots.bind(this);
        this.OfferSnapshot = this.OfferSnapshot.bind(this);
        this.LoadSnapshotChunk = this.LoadSnapshotChunk.bind(this);
        this.ApplySnapshotChunk = this.ApplySnapshotChunk.bind(this);
    }
}
$bbde53696c124e5e$exports.ABCIApplicationClientImpl = $bbde53696c124e5e$var$ABCIApplicationClientImpl;
var $bbde53696c124e5e$var$globalThis = (()=>{
    if (typeof $bbde53696c124e5e$var$globalThis !== "undefined") return $bbde53696c124e5e$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $bbde53696c124e5e$var$atob = $bbde53696c124e5e$var$globalThis.atob || ((b64)=>$bbde53696c124e5e$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $bbde53696c124e5e$var$bytesFromBase64(b64) {
    const bin = $bbde53696c124e5e$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $bbde53696c124e5e$var$btoa = $bbde53696c124e5e$var$globalThis.btoa || ((bin)=>$bbde53696c124e5e$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $bbde53696c124e5e$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $bbde53696c124e5e$var$btoa(bin.join(""));
}
function $bbde53696c124e5e$var$toTimestamp(date) {
    const seconds = $bbde53696c124e5e$var$numberToLong(date.getTime() / 1000);
    const nanos = date.getTime() % 1000 * 1000000;
    return {
        seconds: seconds,
        nanos: nanos
    };
}
function $bbde53696c124e5e$var$fromTimestamp(t) {
    let millis = t.seconds.toNumber() * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function $bbde53696c124e5e$var$fromJsonTimestamp(o) {
    if (o instanceof Date) return $bbde53696c124e5e$var$toTimestamp(o);
    else if (typeof o === "string") return $bbde53696c124e5e$var$toTimestamp(new Date(o));
    else return $d6c3291d6aa8eb5b$exports.Timestamp.fromJSON(o);
}
function $bbde53696c124e5e$var$numberToLong(number) {
    return $bbde53696c124e5e$var$long_1.default.fromNumber(number);
}
if ($bbde53696c124e5e$var$minimal_1.default.util.Long !== $bbde53696c124e5e$var$long_1.default) {
    $bbde53696c124e5e$var$minimal_1.default.util.Long = $bbde53696c124e5e$var$long_1.default;
    $bbde53696c124e5e$var$minimal_1.default.configure();
}


$da5fef019d15e5f1$exports.protobufPackage = "cosmos.base.abci.v1beta1";
const $da5fef019d15e5f1$var$baseTxResponse = {
    height: $da5fef019d15e5f1$var$long_1.default.ZERO,
    txhash: "",
    codespace: "",
    code: 0,
    data: "",
    rawLog: "",
    info: "",
    gasWanted: $da5fef019d15e5f1$var$long_1.default.ZERO,
    gasUsed: $da5fef019d15e5f1$var$long_1.default.ZERO,
    timestamp: ""
};
$da5fef019d15e5f1$exports.TxResponse = {
    encode (message, writer = $da5fef019d15e5f1$var$minimal_1.default.Writer.create()) {
        if (!message.height.isZero()) writer.uint32(8).int64(message.height);
        if (message.txhash !== "") writer.uint32(18).string(message.txhash);
        if (message.codespace !== "") writer.uint32(26).string(message.codespace);
        if (message.code !== 0) writer.uint32(32).uint32(message.code);
        if (message.data !== "") writer.uint32(42).string(message.data);
        if (message.rawLog !== "") writer.uint32(50).string(message.rawLog);
        for (const v of message.logs)$da5fef019d15e5f1$exports.ABCIMessageLog.encode(v, writer.uint32(58).fork()).ldelim();
        if (message.info !== "") writer.uint32(66).string(message.info);
        if (!message.gasWanted.isZero()) writer.uint32(72).int64(message.gasWanted);
        if (!message.gasUsed.isZero()) writer.uint32(80).int64(message.gasUsed);
        if (message.tx !== undefined) $4232fce010c3a46b$exports.Any.encode(message.tx, writer.uint32(90).fork()).ldelim();
        if (message.timestamp !== "") writer.uint32(98).string(message.timestamp);
        for (const v of message.events)$bbde53696c124e5e$exports.Event.encode(v, writer.uint32(106).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $da5fef019d15e5f1$var$minimal_1.default.Reader ? input : new $da5fef019d15e5f1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $da5fef019d15e5f1$var$baseTxResponse);
        message.logs = [];
        message.events = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.int64();
                    break;
                case 2:
                    message.txhash = reader.string();
                    break;
                case 3:
                    message.codespace = reader.string();
                    break;
                case 4:
                    message.code = reader.uint32();
                    break;
                case 5:
                    message.data = reader.string();
                    break;
                case 6:
                    message.rawLog = reader.string();
                    break;
                case 7:
                    message.logs.push($da5fef019d15e5f1$exports.ABCIMessageLog.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.info = reader.string();
                    break;
                case 9:
                    message.gasWanted = reader.int64();
                    break;
                case 10:
                    message.gasUsed = reader.int64();
                    break;
                case 11:
                    message.tx = $4232fce010c3a46b$exports.Any.decode(reader, reader.uint32());
                    break;
                case 12:
                    message.timestamp = reader.string();
                    break;
                case 13:
                    message.events.push($bbde53696c124e5e$exports.Event.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a, _b;
        const message = Object.assign({}, $da5fef019d15e5f1$var$baseTxResponse);
        message.height = object.height !== undefined && object.height !== null ? $da5fef019d15e5f1$var$long_1.default.fromString(object.height) : $da5fef019d15e5f1$var$long_1.default.ZERO;
        message.txhash = object.txhash !== undefined && object.txhash !== null ? String(object.txhash) : "";
        message.codespace = object.codespace !== undefined && object.codespace !== null ? String(object.codespace) : "";
        message.code = object.code !== undefined && object.code !== null ? Number(object.code) : 0;
        message.data = object.data !== undefined && object.data !== null ? String(object.data) : "";
        message.rawLog = object.rawLog !== undefined && object.rawLog !== null ? String(object.rawLog) : "";
        message.logs = ((_a = object.logs) !== null && _a !== void 0 ? _a : []).map((e)=>$da5fef019d15e5f1$exports.ABCIMessageLog.fromJSON(e));
        message.info = object.info !== undefined && object.info !== null ? String(object.info) : "";
        message.gasWanted = object.gasWanted !== undefined && object.gasWanted !== null ? $da5fef019d15e5f1$var$long_1.default.fromString(object.gasWanted) : $da5fef019d15e5f1$var$long_1.default.ZERO;
        message.gasUsed = object.gasUsed !== undefined && object.gasUsed !== null ? $da5fef019d15e5f1$var$long_1.default.fromString(object.gasUsed) : $da5fef019d15e5f1$var$long_1.default.ZERO;
        message.tx = object.tx !== undefined && object.tx !== null ? $4232fce010c3a46b$exports.Any.fromJSON(object.tx) : undefined;
        message.timestamp = object.timestamp !== undefined && object.timestamp !== null ? String(object.timestamp) : "";
        message.events = ((_b = object.events) !== null && _b !== void 0 ? _b : []).map((e)=>$bbde53696c124e5e$exports.Event.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || $da5fef019d15e5f1$var$long_1.default.ZERO).toString());
        message.txhash !== undefined && (obj.txhash = message.txhash);
        message.codespace !== undefined && (obj.codespace = message.codespace);
        message.code !== undefined && (obj.code = message.code);
        message.data !== undefined && (obj.data = message.data);
        message.rawLog !== undefined && (obj.rawLog = message.rawLog);
        if (message.logs) obj.logs = message.logs.map((e)=>e ? $da5fef019d15e5f1$exports.ABCIMessageLog.toJSON(e) : undefined);
        else obj.logs = [];
        message.info !== undefined && (obj.info = message.info);
        message.gasWanted !== undefined && (obj.gasWanted = (message.gasWanted || $da5fef019d15e5f1$var$long_1.default.ZERO).toString());
        message.gasUsed !== undefined && (obj.gasUsed = (message.gasUsed || $da5fef019d15e5f1$var$long_1.default.ZERO).toString());
        message.tx !== undefined && (obj.tx = message.tx ? $4232fce010c3a46b$exports.Any.toJSON(message.tx) : undefined);
        message.timestamp !== undefined && (obj.timestamp = message.timestamp);
        if (message.events) obj.events = message.events.map((e)=>e ? $bbde53696c124e5e$exports.Event.toJSON(e) : undefined);
        else obj.events = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        const message = Object.assign({}, $da5fef019d15e5f1$var$baseTxResponse);
        message.height = object.height !== undefined && object.height !== null ? $da5fef019d15e5f1$var$long_1.default.fromValue(object.height) : $da5fef019d15e5f1$var$long_1.default.ZERO;
        message.txhash = (_a = object.txhash) !== null && _a !== void 0 ? _a : "";
        message.codespace = (_b = object.codespace) !== null && _b !== void 0 ? _b : "";
        message.code = (_c = object.code) !== null && _c !== void 0 ? _c : 0;
        message.data = (_d = object.data) !== null && _d !== void 0 ? _d : "";
        message.rawLog = (_e = object.rawLog) !== null && _e !== void 0 ? _e : "";
        message.logs = ((_f = object.logs) === null || _f === void 0 ? void 0 : _f.map((e)=>$da5fef019d15e5f1$exports.ABCIMessageLog.fromPartial(e))) || [];
        message.info = (_g = object.info) !== null && _g !== void 0 ? _g : "";
        message.gasWanted = object.gasWanted !== undefined && object.gasWanted !== null ? $da5fef019d15e5f1$var$long_1.default.fromValue(object.gasWanted) : $da5fef019d15e5f1$var$long_1.default.ZERO;
        message.gasUsed = object.gasUsed !== undefined && object.gasUsed !== null ? $da5fef019d15e5f1$var$long_1.default.fromValue(object.gasUsed) : $da5fef019d15e5f1$var$long_1.default.ZERO;
        message.tx = object.tx !== undefined && object.tx !== null ? $4232fce010c3a46b$exports.Any.fromPartial(object.tx) : undefined;
        message.timestamp = (_h = object.timestamp) !== null && _h !== void 0 ? _h : "";
        message.events = ((_j = object.events) === null || _j === void 0 ? void 0 : _j.map((e)=>$bbde53696c124e5e$exports.Event.fromPartial(e))) || [];
        return message;
    }
};
const $da5fef019d15e5f1$var$baseABCIMessageLog = {
    msgIndex: 0,
    log: ""
};
$da5fef019d15e5f1$exports.ABCIMessageLog = {
    encode (message, writer = $da5fef019d15e5f1$var$minimal_1.default.Writer.create()) {
        if (message.msgIndex !== 0) writer.uint32(8).uint32(message.msgIndex);
        if (message.log !== "") writer.uint32(18).string(message.log);
        for (const v of message.events)$da5fef019d15e5f1$exports.StringEvent.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $da5fef019d15e5f1$var$minimal_1.default.Reader ? input : new $da5fef019d15e5f1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $da5fef019d15e5f1$var$baseABCIMessageLog);
        message.events = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.msgIndex = reader.uint32();
                    break;
                case 2:
                    message.log = reader.string();
                    break;
                case 3:
                    message.events.push($da5fef019d15e5f1$exports.StringEvent.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $da5fef019d15e5f1$var$baseABCIMessageLog);
        message.msgIndex = object.msgIndex !== undefined && object.msgIndex !== null ? Number(object.msgIndex) : 0;
        message.log = object.log !== undefined && object.log !== null ? String(object.log) : "";
        message.events = ((_a = object.events) !== null && _a !== void 0 ? _a : []).map((e)=>$da5fef019d15e5f1$exports.StringEvent.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.msgIndex !== undefined && (obj.msgIndex = message.msgIndex);
        message.log !== undefined && (obj.log = message.log);
        if (message.events) obj.events = message.events.map((e)=>e ? $da5fef019d15e5f1$exports.StringEvent.toJSON(e) : undefined);
        else obj.events = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $da5fef019d15e5f1$var$baseABCIMessageLog);
        message.msgIndex = (_a = object.msgIndex) !== null && _a !== void 0 ? _a : 0;
        message.log = (_b = object.log) !== null && _b !== void 0 ? _b : "";
        message.events = ((_c = object.events) === null || _c === void 0 ? void 0 : _c.map((e)=>$da5fef019d15e5f1$exports.StringEvent.fromPartial(e))) || [];
        return message;
    }
};
const $da5fef019d15e5f1$var$baseStringEvent = {
    type: ""
};
$da5fef019d15e5f1$exports.StringEvent = {
    encode (message, writer = $da5fef019d15e5f1$var$minimal_1.default.Writer.create()) {
        if (message.type !== "") writer.uint32(10).string(message.type);
        for (const v of message.attributes)$da5fef019d15e5f1$exports.Attribute.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $da5fef019d15e5f1$var$minimal_1.default.Reader ? input : new $da5fef019d15e5f1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $da5fef019d15e5f1$var$baseStringEvent);
        message.attributes = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.string();
                    break;
                case 2:
                    message.attributes.push($da5fef019d15e5f1$exports.Attribute.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $da5fef019d15e5f1$var$baseStringEvent);
        message.type = object.type !== undefined && object.type !== null ? String(object.type) : "";
        message.attributes = ((_a = object.attributes) !== null && _a !== void 0 ? _a : []).map((e)=>$da5fef019d15e5f1$exports.Attribute.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.type !== undefined && (obj.type = message.type);
        if (message.attributes) obj.attributes = message.attributes.map((e)=>e ? $da5fef019d15e5f1$exports.Attribute.toJSON(e) : undefined);
        else obj.attributes = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $da5fef019d15e5f1$var$baseStringEvent);
        message.type = (_a = object.type) !== null && _a !== void 0 ? _a : "";
        message.attributes = ((_b = object.attributes) === null || _b === void 0 ? void 0 : _b.map((e)=>$da5fef019d15e5f1$exports.Attribute.fromPartial(e))) || [];
        return message;
    }
};
const $da5fef019d15e5f1$var$baseAttribute = {
    key: "",
    value: ""
};
$da5fef019d15e5f1$exports.Attribute = {
    encode (message, writer = $da5fef019d15e5f1$var$minimal_1.default.Writer.create()) {
        if (message.key !== "") writer.uint32(10).string(message.key);
        if (message.value !== "") writer.uint32(18).string(message.value);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $da5fef019d15e5f1$var$minimal_1.default.Reader ? input : new $da5fef019d15e5f1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $da5fef019d15e5f1$var$baseAttribute);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.value = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $da5fef019d15e5f1$var$baseAttribute);
        message.key = object.key !== undefined && object.key !== null ? String(object.key) : "";
        message.value = object.value !== undefined && object.value !== null ? String(object.value) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = message.key);
        message.value !== undefined && (obj.value = message.value);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $da5fef019d15e5f1$var$baseAttribute);
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "";
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
const $da5fef019d15e5f1$var$baseGasInfo = {
    gasWanted: $da5fef019d15e5f1$var$long_1.default.UZERO,
    gasUsed: $da5fef019d15e5f1$var$long_1.default.UZERO
};
$da5fef019d15e5f1$exports.GasInfo = {
    encode (message, writer = $da5fef019d15e5f1$var$minimal_1.default.Writer.create()) {
        if (!message.gasWanted.isZero()) writer.uint32(8).uint64(message.gasWanted);
        if (!message.gasUsed.isZero()) writer.uint32(16).uint64(message.gasUsed);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $da5fef019d15e5f1$var$minimal_1.default.Reader ? input : new $da5fef019d15e5f1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $da5fef019d15e5f1$var$baseGasInfo);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.gasWanted = reader.uint64();
                    break;
                case 2:
                    message.gasUsed = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $da5fef019d15e5f1$var$baseGasInfo);
        message.gasWanted = object.gasWanted !== undefined && object.gasWanted !== null ? $da5fef019d15e5f1$var$long_1.default.fromString(object.gasWanted) : $da5fef019d15e5f1$var$long_1.default.UZERO;
        message.gasUsed = object.gasUsed !== undefined && object.gasUsed !== null ? $da5fef019d15e5f1$var$long_1.default.fromString(object.gasUsed) : $da5fef019d15e5f1$var$long_1.default.UZERO;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.gasWanted !== undefined && (obj.gasWanted = (message.gasWanted || $da5fef019d15e5f1$var$long_1.default.UZERO).toString());
        message.gasUsed !== undefined && (obj.gasUsed = (message.gasUsed || $da5fef019d15e5f1$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $da5fef019d15e5f1$var$baseGasInfo);
        message.gasWanted = object.gasWanted !== undefined && object.gasWanted !== null ? $da5fef019d15e5f1$var$long_1.default.fromValue(object.gasWanted) : $da5fef019d15e5f1$var$long_1.default.UZERO;
        message.gasUsed = object.gasUsed !== undefined && object.gasUsed !== null ? $da5fef019d15e5f1$var$long_1.default.fromValue(object.gasUsed) : $da5fef019d15e5f1$var$long_1.default.UZERO;
        return message;
    }
};
const $da5fef019d15e5f1$var$baseResult = {
    log: ""
};
$da5fef019d15e5f1$exports.Result = {
    encode (message, writer = $da5fef019d15e5f1$var$minimal_1.default.Writer.create()) {
        if (message.data.length !== 0) writer.uint32(10).bytes(message.data);
        if (message.log !== "") writer.uint32(18).string(message.log);
        for (const v of message.events)$bbde53696c124e5e$exports.Event.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $da5fef019d15e5f1$var$minimal_1.default.Reader ? input : new $da5fef019d15e5f1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $da5fef019d15e5f1$var$baseResult);
        message.events = [];
        message.data = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.data = reader.bytes();
                    break;
                case 2:
                    message.log = reader.string();
                    break;
                case 3:
                    message.events.push($bbde53696c124e5e$exports.Event.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $da5fef019d15e5f1$var$baseResult);
        message.data = object.data !== undefined && object.data !== null ? $da5fef019d15e5f1$var$bytesFromBase64(object.data) : new Uint8Array();
        message.log = object.log !== undefined && object.log !== null ? String(object.log) : "";
        message.events = ((_a = object.events) !== null && _a !== void 0 ? _a : []).map((e)=>$bbde53696c124e5e$exports.Event.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.data !== undefined && (obj.data = $da5fef019d15e5f1$var$base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        message.log !== undefined && (obj.log = message.log);
        if (message.events) obj.events = message.events.map((e)=>e ? $bbde53696c124e5e$exports.Event.toJSON(e) : undefined);
        else obj.events = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = Object.assign({}, $da5fef019d15e5f1$var$baseResult);
        message.data = (_a = object.data) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.log = (_b = object.log) !== null && _b !== void 0 ? _b : "";
        message.events = ((_c = object.events) === null || _c === void 0 ? void 0 : _c.map((e)=>$bbde53696c124e5e$exports.Event.fromPartial(e))) || [];
        return message;
    }
};
const $da5fef019d15e5f1$var$baseSimulationResponse = {};
$da5fef019d15e5f1$exports.SimulationResponse = {
    encode (message, writer = $da5fef019d15e5f1$var$minimal_1.default.Writer.create()) {
        if (message.gasInfo !== undefined) $da5fef019d15e5f1$exports.GasInfo.encode(message.gasInfo, writer.uint32(10).fork()).ldelim();
        if (message.result !== undefined) $da5fef019d15e5f1$exports.Result.encode(message.result, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $da5fef019d15e5f1$var$minimal_1.default.Reader ? input : new $da5fef019d15e5f1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $da5fef019d15e5f1$var$baseSimulationResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.gasInfo = $da5fef019d15e5f1$exports.GasInfo.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.result = $da5fef019d15e5f1$exports.Result.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $da5fef019d15e5f1$var$baseSimulationResponse);
        message.gasInfo = object.gasInfo !== undefined && object.gasInfo !== null ? $da5fef019d15e5f1$exports.GasInfo.fromJSON(object.gasInfo) : undefined;
        message.result = object.result !== undefined && object.result !== null ? $da5fef019d15e5f1$exports.Result.fromJSON(object.result) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.gasInfo !== undefined && (obj.gasInfo = message.gasInfo ? $da5fef019d15e5f1$exports.GasInfo.toJSON(message.gasInfo) : undefined);
        message.result !== undefined && (obj.result = message.result ? $da5fef019d15e5f1$exports.Result.toJSON(message.result) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $da5fef019d15e5f1$var$baseSimulationResponse);
        message.gasInfo = object.gasInfo !== undefined && object.gasInfo !== null ? $da5fef019d15e5f1$exports.GasInfo.fromPartial(object.gasInfo) : undefined;
        message.result = object.result !== undefined && object.result !== null ? $da5fef019d15e5f1$exports.Result.fromPartial(object.result) : undefined;
        return message;
    }
};
const $da5fef019d15e5f1$var$baseMsgData = {
    msgType: ""
};
$da5fef019d15e5f1$exports.MsgData = {
    encode (message, writer = $da5fef019d15e5f1$var$minimal_1.default.Writer.create()) {
        if (message.msgType !== "") writer.uint32(10).string(message.msgType);
        if (message.data.length !== 0) writer.uint32(18).bytes(message.data);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $da5fef019d15e5f1$var$minimal_1.default.Reader ? input : new $da5fef019d15e5f1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $da5fef019d15e5f1$var$baseMsgData);
        message.data = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.msgType = reader.string();
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $da5fef019d15e5f1$var$baseMsgData);
        message.msgType = object.msgType !== undefined && object.msgType !== null ? String(object.msgType) : "";
        message.data = object.data !== undefined && object.data !== null ? $da5fef019d15e5f1$var$bytesFromBase64(object.data) : new Uint8Array();
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.msgType !== undefined && (obj.msgType = message.msgType);
        message.data !== undefined && (obj.data = $da5fef019d15e5f1$var$base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $da5fef019d15e5f1$var$baseMsgData);
        message.msgType = (_a = object.msgType) !== null && _a !== void 0 ? _a : "";
        message.data = (_b = object.data) !== null && _b !== void 0 ? _b : new Uint8Array();
        return message;
    }
};
const $da5fef019d15e5f1$var$baseTxMsgData = {};
$da5fef019d15e5f1$exports.TxMsgData = {
    encode (message, writer = $da5fef019d15e5f1$var$minimal_1.default.Writer.create()) {
        for (const v of message.data)$da5fef019d15e5f1$exports.MsgData.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $da5fef019d15e5f1$var$minimal_1.default.Reader ? input : new $da5fef019d15e5f1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $da5fef019d15e5f1$var$baseTxMsgData);
        message.data = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.data.push($da5fef019d15e5f1$exports.MsgData.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $da5fef019d15e5f1$var$baseTxMsgData);
        message.data = ((_a = object.data) !== null && _a !== void 0 ? _a : []).map((e)=>$da5fef019d15e5f1$exports.MsgData.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.data) obj.data = message.data.map((e)=>e ? $da5fef019d15e5f1$exports.MsgData.toJSON(e) : undefined);
        else obj.data = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $da5fef019d15e5f1$var$baseTxMsgData);
        message.data = ((_a = object.data) === null || _a === void 0 ? void 0 : _a.map((e)=>$da5fef019d15e5f1$exports.MsgData.fromPartial(e))) || [];
        return message;
    }
};
const $da5fef019d15e5f1$var$baseSearchTxsResult = {
    totalCount: $da5fef019d15e5f1$var$long_1.default.UZERO,
    count: $da5fef019d15e5f1$var$long_1.default.UZERO,
    pageNumber: $da5fef019d15e5f1$var$long_1.default.UZERO,
    pageTotal: $da5fef019d15e5f1$var$long_1.default.UZERO,
    limit: $da5fef019d15e5f1$var$long_1.default.UZERO
};
$da5fef019d15e5f1$exports.SearchTxsResult = {
    encode (message, writer = $da5fef019d15e5f1$var$minimal_1.default.Writer.create()) {
        if (!message.totalCount.isZero()) writer.uint32(8).uint64(message.totalCount);
        if (!message.count.isZero()) writer.uint32(16).uint64(message.count);
        if (!message.pageNumber.isZero()) writer.uint32(24).uint64(message.pageNumber);
        if (!message.pageTotal.isZero()) writer.uint32(32).uint64(message.pageTotal);
        if (!message.limit.isZero()) writer.uint32(40).uint64(message.limit);
        for (const v of message.txs)$da5fef019d15e5f1$exports.TxResponse.encode(v, writer.uint32(50).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $da5fef019d15e5f1$var$minimal_1.default.Reader ? input : new $da5fef019d15e5f1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $da5fef019d15e5f1$var$baseSearchTxsResult);
        message.txs = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.totalCount = reader.uint64();
                    break;
                case 2:
                    message.count = reader.uint64();
                    break;
                case 3:
                    message.pageNumber = reader.uint64();
                    break;
                case 4:
                    message.pageTotal = reader.uint64();
                    break;
                case 5:
                    message.limit = reader.uint64();
                    break;
                case 6:
                    message.txs.push($da5fef019d15e5f1$exports.TxResponse.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $da5fef019d15e5f1$var$baseSearchTxsResult);
        message.totalCount = object.totalCount !== undefined && object.totalCount !== null ? $da5fef019d15e5f1$var$long_1.default.fromString(object.totalCount) : $da5fef019d15e5f1$var$long_1.default.UZERO;
        message.count = object.count !== undefined && object.count !== null ? $da5fef019d15e5f1$var$long_1.default.fromString(object.count) : $da5fef019d15e5f1$var$long_1.default.UZERO;
        message.pageNumber = object.pageNumber !== undefined && object.pageNumber !== null ? $da5fef019d15e5f1$var$long_1.default.fromString(object.pageNumber) : $da5fef019d15e5f1$var$long_1.default.UZERO;
        message.pageTotal = object.pageTotal !== undefined && object.pageTotal !== null ? $da5fef019d15e5f1$var$long_1.default.fromString(object.pageTotal) : $da5fef019d15e5f1$var$long_1.default.UZERO;
        message.limit = object.limit !== undefined && object.limit !== null ? $da5fef019d15e5f1$var$long_1.default.fromString(object.limit) : $da5fef019d15e5f1$var$long_1.default.UZERO;
        message.txs = ((_a = object.txs) !== null && _a !== void 0 ? _a : []).map((e)=>$da5fef019d15e5f1$exports.TxResponse.fromJSON(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.totalCount !== undefined && (obj.totalCount = (message.totalCount || $da5fef019d15e5f1$var$long_1.default.UZERO).toString());
        message.count !== undefined && (obj.count = (message.count || $da5fef019d15e5f1$var$long_1.default.UZERO).toString());
        message.pageNumber !== undefined && (obj.pageNumber = (message.pageNumber || $da5fef019d15e5f1$var$long_1.default.UZERO).toString());
        message.pageTotal !== undefined && (obj.pageTotal = (message.pageTotal || $da5fef019d15e5f1$var$long_1.default.UZERO).toString());
        message.limit !== undefined && (obj.limit = (message.limit || $da5fef019d15e5f1$var$long_1.default.UZERO).toString());
        if (message.txs) obj.txs = message.txs.map((e)=>e ? $da5fef019d15e5f1$exports.TxResponse.toJSON(e) : undefined);
        else obj.txs = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $da5fef019d15e5f1$var$baseSearchTxsResult);
        message.totalCount = object.totalCount !== undefined && object.totalCount !== null ? $da5fef019d15e5f1$var$long_1.default.fromValue(object.totalCount) : $da5fef019d15e5f1$var$long_1.default.UZERO;
        message.count = object.count !== undefined && object.count !== null ? $da5fef019d15e5f1$var$long_1.default.fromValue(object.count) : $da5fef019d15e5f1$var$long_1.default.UZERO;
        message.pageNumber = object.pageNumber !== undefined && object.pageNumber !== null ? $da5fef019d15e5f1$var$long_1.default.fromValue(object.pageNumber) : $da5fef019d15e5f1$var$long_1.default.UZERO;
        message.pageTotal = object.pageTotal !== undefined && object.pageTotal !== null ? $da5fef019d15e5f1$var$long_1.default.fromValue(object.pageTotal) : $da5fef019d15e5f1$var$long_1.default.UZERO;
        message.limit = object.limit !== undefined && object.limit !== null ? $da5fef019d15e5f1$var$long_1.default.fromValue(object.limit) : $da5fef019d15e5f1$var$long_1.default.UZERO;
        message.txs = ((_a = object.txs) === null || _a === void 0 ? void 0 : _a.map((e)=>$da5fef019d15e5f1$exports.TxResponse.fromPartial(e))) || [];
        return message;
    }
};
var $da5fef019d15e5f1$var$globalThis = (()=>{
    if (typeof $da5fef019d15e5f1$var$globalThis !== "undefined") return $da5fef019d15e5f1$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $da5fef019d15e5f1$var$atob = $da5fef019d15e5f1$var$globalThis.atob || ((b64)=>$da5fef019d15e5f1$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $da5fef019d15e5f1$var$bytesFromBase64(b64) {
    const bin = $da5fef019d15e5f1$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $da5fef019d15e5f1$var$btoa = $da5fef019d15e5f1$var$globalThis.btoa || ((bin)=>$da5fef019d15e5f1$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $da5fef019d15e5f1$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $da5fef019d15e5f1$var$btoa(bin.join(""));
}
if ($da5fef019d15e5f1$var$minimal_1.default.util.Long !== $da5fef019d15e5f1$var$long_1.default) {
    $da5fef019d15e5f1$var$minimal_1.default.util.Long = $da5fef019d15e5f1$var$long_1.default;
    $da5fef019d15e5f1$var$minimal_1.default.configure();
}



$fa044eea89982613$exports.protobufPackage = "cosmos.tx.v1beta1";
/** OrderBy defines the sorting order */ var $fa044eea89982613$var$OrderBy;
(function(OrderBy) {
    /** ORDER_BY_UNSPECIFIED - ORDER_BY_UNSPECIFIED specifies an unknown sorting order. OrderBy defaults to ASC in this case. */ OrderBy[OrderBy["ORDER_BY_UNSPECIFIED"] = 0] = "ORDER_BY_UNSPECIFIED";
    /** ORDER_BY_ASC - ORDER_BY_ASC defines ascending order */ OrderBy[OrderBy["ORDER_BY_ASC"] = 1] = "ORDER_BY_ASC";
    /** ORDER_BY_DESC - ORDER_BY_DESC defines descending order */ OrderBy[OrderBy["ORDER_BY_DESC"] = 2] = "ORDER_BY_DESC";
    OrderBy[OrderBy["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($fa044eea89982613$var$OrderBy = $fa044eea89982613$exports.OrderBy || ($fa044eea89982613$exports.OrderBy = {}));
function $fa044eea89982613$var$orderByFromJSON(object) {
    switch(object){
        case 0:
        case "ORDER_BY_UNSPECIFIED":
            return $fa044eea89982613$var$OrderBy.ORDER_BY_UNSPECIFIED;
        case 1:
        case "ORDER_BY_ASC":
            return $fa044eea89982613$var$OrderBy.ORDER_BY_ASC;
        case 2:
        case "ORDER_BY_DESC":
            return $fa044eea89982613$var$OrderBy.ORDER_BY_DESC;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $fa044eea89982613$var$OrderBy.UNRECOGNIZED;
    }
}
$fa044eea89982613$exports.orderByFromJSON = $fa044eea89982613$var$orderByFromJSON;
function $fa044eea89982613$var$orderByToJSON(object) {
    switch(object){
        case $fa044eea89982613$var$OrderBy.ORDER_BY_UNSPECIFIED:
            return "ORDER_BY_UNSPECIFIED";
        case $fa044eea89982613$var$OrderBy.ORDER_BY_ASC:
            return "ORDER_BY_ASC";
        case $fa044eea89982613$var$OrderBy.ORDER_BY_DESC:
            return "ORDER_BY_DESC";
        default:
            return "UNKNOWN";
    }
}
$fa044eea89982613$exports.orderByToJSON = $fa044eea89982613$var$orderByToJSON;
/** BroadcastMode specifies the broadcast mode for the TxService.Broadcast RPC method. */ var $fa044eea89982613$var$BroadcastMode;
(function(BroadcastMode) {
    /** BROADCAST_MODE_UNSPECIFIED - zero-value for mode ordering */ BroadcastMode[BroadcastMode["BROADCAST_MODE_UNSPECIFIED"] = 0] = "BROADCAST_MODE_UNSPECIFIED";
    /**
     * BROADCAST_MODE_BLOCK - BROADCAST_MODE_BLOCK defines a tx broadcasting mode where the client waits for
     * the tx to be committed in a block.
     */ BroadcastMode[BroadcastMode["BROADCAST_MODE_BLOCK"] = 1] = "BROADCAST_MODE_BLOCK";
    /**
     * BROADCAST_MODE_SYNC - BROADCAST_MODE_SYNC defines a tx broadcasting mode where the client waits for
     * a CheckTx execution response only.
     */ BroadcastMode[BroadcastMode["BROADCAST_MODE_SYNC"] = 2] = "BROADCAST_MODE_SYNC";
    /**
     * BROADCAST_MODE_ASYNC - BROADCAST_MODE_ASYNC defines a tx broadcasting mode where the client returns
     * immediately.
     */ BroadcastMode[BroadcastMode["BROADCAST_MODE_ASYNC"] = 3] = "BROADCAST_MODE_ASYNC";
    BroadcastMode[BroadcastMode["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($fa044eea89982613$var$BroadcastMode = $fa044eea89982613$exports.BroadcastMode || ($fa044eea89982613$exports.BroadcastMode = {}));
function $fa044eea89982613$var$broadcastModeFromJSON(object) {
    switch(object){
        case 0:
        case "BROADCAST_MODE_UNSPECIFIED":
            return $fa044eea89982613$var$BroadcastMode.BROADCAST_MODE_UNSPECIFIED;
        case 1:
        case "BROADCAST_MODE_BLOCK":
            return $fa044eea89982613$var$BroadcastMode.BROADCAST_MODE_BLOCK;
        case 2:
        case "BROADCAST_MODE_SYNC":
            return $fa044eea89982613$var$BroadcastMode.BROADCAST_MODE_SYNC;
        case 3:
        case "BROADCAST_MODE_ASYNC":
            return $fa044eea89982613$var$BroadcastMode.BROADCAST_MODE_ASYNC;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $fa044eea89982613$var$BroadcastMode.UNRECOGNIZED;
    }
}
$fa044eea89982613$exports.broadcastModeFromJSON = $fa044eea89982613$var$broadcastModeFromJSON;
function $fa044eea89982613$var$broadcastModeToJSON(object) {
    switch(object){
        case $fa044eea89982613$var$BroadcastMode.BROADCAST_MODE_UNSPECIFIED:
            return "BROADCAST_MODE_UNSPECIFIED";
        case $fa044eea89982613$var$BroadcastMode.BROADCAST_MODE_BLOCK:
            return "BROADCAST_MODE_BLOCK";
        case $fa044eea89982613$var$BroadcastMode.BROADCAST_MODE_SYNC:
            return "BROADCAST_MODE_SYNC";
        case $fa044eea89982613$var$BroadcastMode.BROADCAST_MODE_ASYNC:
            return "BROADCAST_MODE_ASYNC";
        default:
            return "UNKNOWN";
    }
}
$fa044eea89982613$exports.broadcastModeToJSON = $fa044eea89982613$var$broadcastModeToJSON;
const $fa044eea89982613$var$baseGetTxsEventRequest = {
    events: "",
    orderBy: 0
};
$fa044eea89982613$exports.GetTxsEventRequest = {
    encode (message, writer = $fa044eea89982613$var$minimal_1.default.Writer.create()) {
        for (const v of message.events)writer.uint32(10).string(v);
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        if (message.orderBy !== 0) writer.uint32(24).int32(message.orderBy);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fa044eea89982613$var$minimal_1.default.Reader ? input : new $fa044eea89982613$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $fa044eea89982613$var$baseGetTxsEventRequest);
        message.events = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.events.push(reader.string());
                    break;
                case 2:
                    message.pagination = $f01b40e20607eb8e$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.orderBy = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $fa044eea89982613$var$baseGetTxsEventRequest);
        message.events = ((_a = object.events) !== null && _a !== void 0 ? _a : []).map((e)=>String(e));
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromJSON(object.pagination) : undefined;
        message.orderBy = object.orderBy !== undefined && object.orderBy !== null ? $fa044eea89982613$var$orderByFromJSON(object.orderBy) : 0;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.events) obj.events = message.events.map((e)=>e);
        else obj.events = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageRequest.toJSON(message.pagination) : undefined);
        message.orderBy !== undefined && (obj.orderBy = $fa044eea89982613$var$orderByToJSON(message.orderBy));
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $fa044eea89982613$var$baseGetTxsEventRequest);
        message.events = ((_a = object.events) === null || _a === void 0 ? void 0 : _a.map((e)=>e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageRequest.fromPartial(object.pagination) : undefined;
        message.orderBy = (_b = object.orderBy) !== null && _b !== void 0 ? _b : 0;
        return message;
    }
};
const $fa044eea89982613$var$baseGetTxsEventResponse = {};
$fa044eea89982613$exports.GetTxsEventResponse = {
    encode (message, writer = $fa044eea89982613$var$minimal_1.default.Writer.create()) {
        for (const v of message.txs)$07786b3434b3c544$exports.Tx.encode(v, writer.uint32(10).fork()).ldelim();
        for (const v of message.txResponses)$da5fef019d15e5f1$exports.TxResponse.encode(v, writer.uint32(18).fork()).ldelim();
        if (message.pagination !== undefined) $f01b40e20607eb8e$exports.PageResponse.encode(message.pagination, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fa044eea89982613$var$minimal_1.default.Reader ? input : new $fa044eea89982613$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $fa044eea89982613$var$baseGetTxsEventResponse);
        message.txs = [];
        message.txResponses = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txs.push($07786b3434b3c544$exports.Tx.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.txResponses.push($da5fef019d15e5f1$exports.TxResponse.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.pagination = $f01b40e20607eb8e$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a, _b;
        const message = Object.assign({}, $fa044eea89982613$var$baseGetTxsEventResponse);
        message.txs = ((_a = object.txs) !== null && _a !== void 0 ? _a : []).map((e)=>$07786b3434b3c544$exports.Tx.fromJSON(e));
        message.txResponses = ((_b = object.txResponses) !== null && _b !== void 0 ? _b : []).map((e)=>$da5fef019d15e5f1$exports.TxResponse.fromJSON(e));
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromJSON(object.pagination) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.txs) obj.txs = message.txs.map((e)=>e ? $07786b3434b3c544$exports.Tx.toJSON(e) : undefined);
        else obj.txs = [];
        if (message.txResponses) obj.txResponses = message.txResponses.map((e)=>e ? $da5fef019d15e5f1$exports.TxResponse.toJSON(e) : undefined);
        else obj.txResponses = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $f01b40e20607eb8e$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $fa044eea89982613$var$baseGetTxsEventResponse);
        message.txs = ((_a = object.txs) === null || _a === void 0 ? void 0 : _a.map((e)=>$07786b3434b3c544$exports.Tx.fromPartial(e))) || [];
        message.txResponses = ((_b = object.txResponses) === null || _b === void 0 ? void 0 : _b.map((e)=>$da5fef019d15e5f1$exports.TxResponse.fromPartial(e))) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $f01b40e20607eb8e$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
const $fa044eea89982613$var$baseBroadcastTxRequest = {
    mode: 0
};
$fa044eea89982613$exports.BroadcastTxRequest = {
    encode (message, writer = $fa044eea89982613$var$minimal_1.default.Writer.create()) {
        if (message.txBytes.length !== 0) writer.uint32(10).bytes(message.txBytes);
        if (message.mode !== 0) writer.uint32(16).int32(message.mode);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fa044eea89982613$var$minimal_1.default.Reader ? input : new $fa044eea89982613$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $fa044eea89982613$var$baseBroadcastTxRequest);
        message.txBytes = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txBytes = reader.bytes();
                    break;
                case 2:
                    message.mode = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $fa044eea89982613$var$baseBroadcastTxRequest);
        message.txBytes = object.txBytes !== undefined && object.txBytes !== null ? $fa044eea89982613$var$bytesFromBase64(object.txBytes) : new Uint8Array();
        message.mode = object.mode !== undefined && object.mode !== null ? $fa044eea89982613$var$broadcastModeFromJSON(object.mode) : 0;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.txBytes !== undefined && (obj.txBytes = $fa044eea89982613$var$base64FromBytes(message.txBytes !== undefined ? message.txBytes : new Uint8Array()));
        message.mode !== undefined && (obj.mode = $fa044eea89982613$var$broadcastModeToJSON(message.mode));
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = Object.assign({}, $fa044eea89982613$var$baseBroadcastTxRequest);
        message.txBytes = (_a = object.txBytes) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.mode = (_b = object.mode) !== null && _b !== void 0 ? _b : 0;
        return message;
    }
};
const $fa044eea89982613$var$baseBroadcastTxResponse = {};
$fa044eea89982613$exports.BroadcastTxResponse = {
    encode (message, writer = $fa044eea89982613$var$minimal_1.default.Writer.create()) {
        if (message.txResponse !== undefined) $da5fef019d15e5f1$exports.TxResponse.encode(message.txResponse, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fa044eea89982613$var$minimal_1.default.Reader ? input : new $fa044eea89982613$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $fa044eea89982613$var$baseBroadcastTxResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txResponse = $da5fef019d15e5f1$exports.TxResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $fa044eea89982613$var$baseBroadcastTxResponse);
        message.txResponse = object.txResponse !== undefined && object.txResponse !== null ? $da5fef019d15e5f1$exports.TxResponse.fromJSON(object.txResponse) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.txResponse !== undefined && (obj.txResponse = message.txResponse ? $da5fef019d15e5f1$exports.TxResponse.toJSON(message.txResponse) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $fa044eea89982613$var$baseBroadcastTxResponse);
        message.txResponse = object.txResponse !== undefined && object.txResponse !== null ? $da5fef019d15e5f1$exports.TxResponse.fromPartial(object.txResponse) : undefined;
        return message;
    }
};
const $fa044eea89982613$var$baseSimulateRequest = {};
$fa044eea89982613$exports.SimulateRequest = {
    encode (message, writer = $fa044eea89982613$var$minimal_1.default.Writer.create()) {
        if (message.tx !== undefined) $07786b3434b3c544$exports.Tx.encode(message.tx, writer.uint32(10).fork()).ldelim();
        if (message.txBytes.length !== 0) writer.uint32(18).bytes(message.txBytes);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fa044eea89982613$var$minimal_1.default.Reader ? input : new $fa044eea89982613$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $fa044eea89982613$var$baseSimulateRequest);
        message.txBytes = new Uint8Array();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.tx = $07786b3434b3c544$exports.Tx.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.txBytes = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $fa044eea89982613$var$baseSimulateRequest);
        message.tx = object.tx !== undefined && object.tx !== null ? $07786b3434b3c544$exports.Tx.fromJSON(object.tx) : undefined;
        message.txBytes = object.txBytes !== undefined && object.txBytes !== null ? $fa044eea89982613$var$bytesFromBase64(object.txBytes) : new Uint8Array();
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.tx !== undefined && (obj.tx = message.tx ? $07786b3434b3c544$exports.Tx.toJSON(message.tx) : undefined);
        message.txBytes !== undefined && (obj.txBytes = $fa044eea89982613$var$base64FromBytes(message.txBytes !== undefined ? message.txBytes : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $fa044eea89982613$var$baseSimulateRequest);
        message.tx = object.tx !== undefined && object.tx !== null ? $07786b3434b3c544$exports.Tx.fromPartial(object.tx) : undefined;
        message.txBytes = (_a = object.txBytes) !== null && _a !== void 0 ? _a : new Uint8Array();
        return message;
    }
};
const $fa044eea89982613$var$baseSimulateResponse = {};
$fa044eea89982613$exports.SimulateResponse = {
    encode (message, writer = $fa044eea89982613$var$minimal_1.default.Writer.create()) {
        if (message.gasInfo !== undefined) $da5fef019d15e5f1$exports.GasInfo.encode(message.gasInfo, writer.uint32(10).fork()).ldelim();
        if (message.result !== undefined) $da5fef019d15e5f1$exports.Result.encode(message.result, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fa044eea89982613$var$minimal_1.default.Reader ? input : new $fa044eea89982613$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $fa044eea89982613$var$baseSimulateResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.gasInfo = $da5fef019d15e5f1$exports.GasInfo.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.result = $da5fef019d15e5f1$exports.Result.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $fa044eea89982613$var$baseSimulateResponse);
        message.gasInfo = object.gasInfo !== undefined && object.gasInfo !== null ? $da5fef019d15e5f1$exports.GasInfo.fromJSON(object.gasInfo) : undefined;
        message.result = object.result !== undefined && object.result !== null ? $da5fef019d15e5f1$exports.Result.fromJSON(object.result) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.gasInfo !== undefined && (obj.gasInfo = message.gasInfo ? $da5fef019d15e5f1$exports.GasInfo.toJSON(message.gasInfo) : undefined);
        message.result !== undefined && (obj.result = message.result ? $da5fef019d15e5f1$exports.Result.toJSON(message.result) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $fa044eea89982613$var$baseSimulateResponse);
        message.gasInfo = object.gasInfo !== undefined && object.gasInfo !== null ? $da5fef019d15e5f1$exports.GasInfo.fromPartial(object.gasInfo) : undefined;
        message.result = object.result !== undefined && object.result !== null ? $da5fef019d15e5f1$exports.Result.fromPartial(object.result) : undefined;
        return message;
    }
};
const $fa044eea89982613$var$baseGetTxRequest = {
    hash: ""
};
$fa044eea89982613$exports.GetTxRequest = {
    encode (message, writer = $fa044eea89982613$var$minimal_1.default.Writer.create()) {
        if (message.hash !== "") writer.uint32(10).string(message.hash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fa044eea89982613$var$minimal_1.default.Reader ? input : new $fa044eea89982613$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $fa044eea89982613$var$baseGetTxRequest);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $fa044eea89982613$var$baseGetTxRequest);
        message.hash = object.hash !== undefined && object.hash !== null ? String(object.hash) : "";
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = message.hash);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $fa044eea89982613$var$baseGetTxRequest);
        message.hash = (_a = object.hash) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
const $fa044eea89982613$var$baseGetTxResponse = {};
$fa044eea89982613$exports.GetTxResponse = {
    encode (message, writer = $fa044eea89982613$var$minimal_1.default.Writer.create()) {
        if (message.tx !== undefined) $07786b3434b3c544$exports.Tx.encode(message.tx, writer.uint32(10).fork()).ldelim();
        if (message.txResponse !== undefined) $da5fef019d15e5f1$exports.TxResponse.encode(message.txResponse, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fa044eea89982613$var$minimal_1.default.Reader ? input : new $fa044eea89982613$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $fa044eea89982613$var$baseGetTxResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.tx = $07786b3434b3c544$exports.Tx.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.txResponse = $da5fef019d15e5f1$exports.TxResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $fa044eea89982613$var$baseGetTxResponse);
        message.tx = object.tx !== undefined && object.tx !== null ? $07786b3434b3c544$exports.Tx.fromJSON(object.tx) : undefined;
        message.txResponse = object.txResponse !== undefined && object.txResponse !== null ? $da5fef019d15e5f1$exports.TxResponse.fromJSON(object.txResponse) : undefined;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.tx !== undefined && (obj.tx = message.tx ? $07786b3434b3c544$exports.Tx.toJSON(message.tx) : undefined);
        message.txResponse !== undefined && (obj.txResponse = message.txResponse ? $da5fef019d15e5f1$exports.TxResponse.toJSON(message.txResponse) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = Object.assign({}, $fa044eea89982613$var$baseGetTxResponse);
        message.tx = object.tx !== undefined && object.tx !== null ? $07786b3434b3c544$exports.Tx.fromPartial(object.tx) : undefined;
        message.txResponse = object.txResponse !== undefined && object.txResponse !== null ? $da5fef019d15e5f1$exports.TxResponse.fromPartial(object.txResponse) : undefined;
        return message;
    }
};
class $fa044eea89982613$var$ServiceClientImpl {
    Simulate(request) {
        const data = $fa044eea89982613$exports.SimulateRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "Simulate", data);
        return promise.then((data)=>$fa044eea89982613$exports.SimulateResponse.decode(new $fa044eea89982613$var$minimal_1.default.Reader(data)));
    }
    GetTx(request) {
        const data = $fa044eea89982613$exports.GetTxRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "GetTx", data);
        return promise.then((data)=>$fa044eea89982613$exports.GetTxResponse.decode(new $fa044eea89982613$var$minimal_1.default.Reader(data)));
    }
    BroadcastTx(request) {
        const data = $fa044eea89982613$exports.BroadcastTxRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "BroadcastTx", data);
        return promise.then((data)=>$fa044eea89982613$exports.BroadcastTxResponse.decode(new $fa044eea89982613$var$minimal_1.default.Reader(data)));
    }
    GetTxsEvent(request) {
        const data = $fa044eea89982613$exports.GetTxsEventRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "GetTxsEvent", data);
        return promise.then((data)=>$fa044eea89982613$exports.GetTxsEventResponse.decode(new $fa044eea89982613$var$minimal_1.default.Reader(data)));
    }
    constructor(rpc){
        this.rpc = rpc;
        this.Simulate = this.Simulate.bind(this);
        this.GetTx = this.GetTx.bind(this);
        this.BroadcastTx = this.BroadcastTx.bind(this);
        this.GetTxsEvent = this.GetTxsEvent.bind(this);
    }
}
$fa044eea89982613$exports.ServiceClientImpl = $fa044eea89982613$var$ServiceClientImpl;
var $fa044eea89982613$var$globalThis = (()=>{
    if (typeof $fa044eea89982613$var$globalThis !== "undefined") return $fa044eea89982613$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $fa044eea89982613$var$atob = $fa044eea89982613$var$globalThis.atob || ((b64)=>$fa044eea89982613$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $fa044eea89982613$var$bytesFromBase64(b64) {
    const bin = $fa044eea89982613$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $fa044eea89982613$var$btoa = $fa044eea89982613$var$globalThis.btoa || ((bin)=>$fa044eea89982613$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $fa044eea89982613$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $fa044eea89982613$var$btoa(bin.join(""));
}
if ($fa044eea89982613$var$minimal_1.default.util.Long !== $fa044eea89982613$var$long_1.default) {
    $fa044eea89982613$var$minimal_1.default.util.Long = $fa044eea89982613$var$long_1.default;
    $fa044eea89982613$var$minimal_1.default.configure();
}




const $252fdb30ead3e767$var$long_1 = $252fdb30ead3e767$var$__importDefault((parcelRequire("9A55m")));

function $252fdb30ead3e767$var$setupTxExtension(base) {
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const rpc = (0, $ffdede50deec576f$exports.createProtobufRpcClient)(base);
    const queryService = new $fa044eea89982613$exports.ServiceClientImpl(rpc);
    return {
        tx: {
            getTx: async (txId)=>{
                const request = {
                    hash: txId
                };
                const response = await queryService.GetTx(request);
                return response;
            },
            simulate: async (messages, memo, signer, sequence)=>{
                const request = $fa044eea89982613$exports.SimulateRequest.fromPartial({
                    tx: $07786b3434b3c544$exports.Tx.fromPartial({
                        authInfo: $07786b3434b3c544$exports.AuthInfo.fromPartial({
                            fee: $07786b3434b3c544$exports.Fee.fromPartial({}),
                            signerInfos: [
                                {
                                    publicKey: (0, $eb9a28d0d0241b06$exports.encodePubkey)(signer),
                                    sequence: $252fdb30ead3e767$var$long_1.default.fromNumber(sequence, true),
                                    modeInfo: {
                                        single: {
                                            mode: $d422a57cb1210f8b$exports.SignMode.SIGN_MODE_UNSPECIFIED
                                        }
                                    }
                                }
                            ]
                        }),
                        body: $07786b3434b3c544$exports.TxBody.fromPartial({
                            messages: Array.from(messages),
                            memo: memo
                        }),
                        signatures: [
                            new Uint8Array()
                        ]
                    }),
                    // Sending serialized `txBytes` is the future. But
                    // this is not available in Comsos SDK 0.42.
                    txBytes: undefined
                });
                const response = await queryService.Simulate(request);
                return response;
            }
        }
    };
}
$252fdb30ead3e767$exports.setupTxExtension = $252fdb30ead3e767$var$setupTxExtension;


Object.defineProperty($7725f2e3ca016b52$exports, "setupTxExtension", {
    enumerable: true,
    get: function() {
        return $252fdb30ead3e767$exports.setupTxExtension;
    }
});
var $07bc9eb894f8a92e$exports = {};
"use strict";
Object.defineProperty($07bc9eb894f8a92e$exports, "__esModule", {
    value: true
});
$07bc9eb894f8a92e$exports.createVestingAminoConverters = void 0;
function $07bc9eb894f8a92e$var$createVestingAminoConverters() {
    return {
        "/cosmos.vesting.v1beta1.MsgCreateVestingAccount": "not_supported_by_chain"
    };
}
$07bc9eb894f8a92e$exports.createVestingAminoConverters = $07bc9eb894f8a92e$var$createVestingAminoConverters;


Object.defineProperty($7725f2e3ca016b52$exports, "createVestingAminoConverters", {
    enumerable: true,
    get: function() {
        return $07bc9eb894f8a92e$exports.createVestingAminoConverters;
    }
});
var $7927f6a81d9e8d44$exports = {};
"use strict";
Object.defineProperty($7927f6a81d9e8d44$exports, "__esModule", {
    value: true
});
$7927f6a81d9e8d44$exports.vestingTypes = void 0;
var $fb92d9266d1db5b4$exports = {};
"use strict";
var $fb92d9266d1db5b4$var$__importDefault = $fb92d9266d1db5b4$exports && $fb92d9266d1db5b4$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($fb92d9266d1db5b4$exports, "__esModule", {
    value: true
});
$fb92d9266d1db5b4$exports.MsgClientImpl = $fb92d9266d1db5b4$exports.MsgCreateVestingAccountResponse = $fb92d9266d1db5b4$exports.MsgCreateVestingAccount = $fb92d9266d1db5b4$exports.protobufPackage = void 0;

/* eslint-disable */ const $fb92d9266d1db5b4$var$long_1 = $fb92d9266d1db5b4$var$__importDefault((parcelRequire("9A55m")));

const $fb92d9266d1db5b4$var$minimal_1 = $fb92d9266d1db5b4$var$__importDefault((parcelRequire("i2pIU")));

$fb92d9266d1db5b4$exports.protobufPackage = "cosmos.vesting.v1beta1";
const $fb92d9266d1db5b4$var$baseMsgCreateVestingAccount = {
    fromAddress: "",
    toAddress: "",
    endTime: $fb92d9266d1db5b4$var$long_1.default.ZERO,
    delayed: false
};
$fb92d9266d1db5b4$exports.MsgCreateVestingAccount = {
    encode (message, writer = $fb92d9266d1db5b4$var$minimal_1.default.Writer.create()) {
        if (message.fromAddress !== "") writer.uint32(10).string(message.fromAddress);
        if (message.toAddress !== "") writer.uint32(18).string(message.toAddress);
        for (const v of message.amount)$82ef09d1a8e2224d$exports.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        if (!message.endTime.isZero()) writer.uint32(32).int64(message.endTime);
        if (message.delayed === true) writer.uint32(40).bool(message.delayed);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fb92d9266d1db5b4$var$minimal_1.default.Reader ? input : new $fb92d9266d1db5b4$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $fb92d9266d1db5b4$var$baseMsgCreateVestingAccount);
        message.amount = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.fromAddress = reader.string();
                    break;
                case 2:
                    message.toAddress = reader.string();
                    break;
                case 3:
                    message.amount.push($82ef09d1a8e2224d$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.endTime = reader.int64();
                    break;
                case 5:
                    message.delayed = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $fb92d9266d1db5b4$var$baseMsgCreateVestingAccount);
        message.fromAddress = object.fromAddress !== undefined && object.fromAddress !== null ? String(object.fromAddress) : "";
        message.toAddress = object.toAddress !== undefined && object.toAddress !== null ? String(object.toAddress) : "";
        message.amount = ((_a = object.amount) !== null && _a !== void 0 ? _a : []).map((e)=>$82ef09d1a8e2224d$exports.Coin.fromJSON(e));
        message.endTime = object.endTime !== undefined && object.endTime !== null ? $fb92d9266d1db5b4$var$long_1.default.fromString(object.endTime) : $fb92d9266d1db5b4$var$long_1.default.ZERO;
        message.delayed = object.delayed !== undefined && object.delayed !== null ? Boolean(object.delayed) : false;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.fromAddress !== undefined && (obj.fromAddress = message.fromAddress);
        message.toAddress !== undefined && (obj.toAddress = message.toAddress);
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $82ef09d1a8e2224d$exports.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        message.endTime !== undefined && (obj.endTime = (message.endTime || $fb92d9266d1db5b4$var$long_1.default.ZERO).toString());
        message.delayed !== undefined && (obj.delayed = message.delayed);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = Object.assign({}, $fb92d9266d1db5b4$var$baseMsgCreateVestingAccount);
        message.fromAddress = (_a = object.fromAddress) !== null && _a !== void 0 ? _a : "";
        message.toAddress = (_b = object.toAddress) !== null && _b !== void 0 ? _b : "";
        message.amount = ((_c = object.amount) === null || _c === void 0 ? void 0 : _c.map((e)=>$82ef09d1a8e2224d$exports.Coin.fromPartial(e))) || [];
        message.endTime = object.endTime !== undefined && object.endTime !== null ? $fb92d9266d1db5b4$var$long_1.default.fromValue(object.endTime) : $fb92d9266d1db5b4$var$long_1.default.ZERO;
        message.delayed = (_d = object.delayed) !== null && _d !== void 0 ? _d : false;
        return message;
    }
};
const $fb92d9266d1db5b4$var$baseMsgCreateVestingAccountResponse = {};
$fb92d9266d1db5b4$exports.MsgCreateVestingAccountResponse = {
    encode (_, writer = $fb92d9266d1db5b4$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fb92d9266d1db5b4$var$minimal_1.default.Reader ? input : new $fb92d9266d1db5b4$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $fb92d9266d1db5b4$var$baseMsgCreateVestingAccountResponse);
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        const message = Object.assign({}, $fb92d9266d1db5b4$var$baseMsgCreateVestingAccountResponse);
        return message;
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = Object.assign({}, $fb92d9266d1db5b4$var$baseMsgCreateVestingAccountResponse);
        return message;
    }
};
class $fb92d9266d1db5b4$var$MsgClientImpl {
    CreateVestingAccount(request) {
        const data = $fb92d9266d1db5b4$exports.MsgCreateVestingAccount.encode(request).finish();
        const promise = this.rpc.request("cosmos.vesting.v1beta1.Msg", "CreateVestingAccount", data);
        return promise.then((data)=>$fb92d9266d1db5b4$exports.MsgCreateVestingAccountResponse.decode(new $fb92d9266d1db5b4$var$minimal_1.default.Reader(data)));
    }
    constructor(rpc){
        this.rpc = rpc;
        this.CreateVestingAccount = this.CreateVestingAccount.bind(this);
    }
}
$fb92d9266d1db5b4$exports.MsgClientImpl = $fb92d9266d1db5b4$var$MsgClientImpl;
if ($fb92d9266d1db5b4$var$minimal_1.default.util.Long !== $fb92d9266d1db5b4$var$long_1.default) {
    $fb92d9266d1db5b4$var$minimal_1.default.util.Long = $fb92d9266d1db5b4$var$long_1.default;
    $fb92d9266d1db5b4$var$minimal_1.default.configure();
}


$7927f6a81d9e8d44$exports.vestingTypes = [
    [
        "/cosmos.vesting.v1beta1.MsgCreateVestingAccount",
        $fb92d9266d1db5b4$exports.MsgCreateVestingAccount
    ]
];


Object.defineProperty($7725f2e3ca016b52$exports, "vestingTypes", {
    enumerable: true,
    get: function() {
        return $7927f6a81d9e8d44$exports.vestingTypes;
    }
});


Object.defineProperty($842e3ecb6082807a$exports, "isAminoMsgBeginRedelegate", {
    enumerable: true,
    get: function() {
        return $7725f2e3ca016b52$exports.isAminoMsgBeginRedelegate;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "isAminoMsgCreateValidator", {
    enumerable: true,
    get: function() {
        return $7725f2e3ca016b52$exports.isAminoMsgCreateValidator;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "isAminoMsgDelegate", {
    enumerable: true,
    get: function() {
        return $7725f2e3ca016b52$exports.isAminoMsgDelegate;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "isAminoMsgDeposit", {
    enumerable: true,
    get: function() {
        return $7725f2e3ca016b52$exports.isAminoMsgDeposit;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "isAminoMsgEditValidator", {
    enumerable: true,
    get: function() {
        return $7725f2e3ca016b52$exports.isAminoMsgEditValidator;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "isAminoMsgFundCommunityPool", {
    enumerable: true,
    get: function() {
        return $7725f2e3ca016b52$exports.isAminoMsgFundCommunityPool;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "isAminoMsgMultiSend", {
    enumerable: true,
    get: function() {
        return $7725f2e3ca016b52$exports.isAminoMsgMultiSend;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "isAminoMsgSend", {
    enumerable: true,
    get: function() {
        return $7725f2e3ca016b52$exports.isAminoMsgSend;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "isAminoMsgSetWithdrawAddress", {
    enumerable: true,
    get: function() {
        return $7725f2e3ca016b52$exports.isAminoMsgSetWithdrawAddress;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "isAminoMsgSubmitEvidence", {
    enumerable: true,
    get: function() {
        return $7725f2e3ca016b52$exports.isAminoMsgSubmitEvidence;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "isAminoMsgSubmitProposal", {
    enumerable: true,
    get: function() {
        return $7725f2e3ca016b52$exports.isAminoMsgSubmitProposal;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "isAminoMsgUndelegate", {
    enumerable: true,
    get: function() {
        return $7725f2e3ca016b52$exports.isAminoMsgUndelegate;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "isAminoMsgUnjail", {
    enumerable: true,
    get: function() {
        return $7725f2e3ca016b52$exports.isAminoMsgUnjail;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "isAminoMsgVerifyInvariant", {
    enumerable: true,
    get: function() {
        return $7725f2e3ca016b52$exports.isAminoMsgVerifyInvariant;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "isAminoMsgVote", {
    enumerable: true,
    get: function() {
        return $7725f2e3ca016b52$exports.isAminoMsgVote;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "isAminoMsgWithdrawDelegatorReward", {
    enumerable: true,
    get: function() {
        return $7725f2e3ca016b52$exports.isAminoMsgWithdrawDelegatorReward;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "isAminoMsgWithdrawValidatorCommission", {
    enumerable: true,
    get: function() {
        return $7725f2e3ca016b52$exports.isAminoMsgWithdrawValidatorCommission;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "isMsgDelegateEncodeObject", {
    enumerable: true,
    get: function() {
        return $7725f2e3ca016b52$exports.isMsgDelegateEncodeObject;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "isMsgDepositEncodeObject", {
    enumerable: true,
    get: function() {
        return $7725f2e3ca016b52$exports.isMsgDepositEncodeObject;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "isMsgSendEncodeObject", {
    enumerable: true,
    get: function() {
        return $7725f2e3ca016b52$exports.isMsgSendEncodeObject;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "isMsgSubmitProposalEncodeObject", {
    enumerable: true,
    get: function() {
        return $7725f2e3ca016b52$exports.isMsgSubmitProposalEncodeObject;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "isMsgTransferEncodeObject", {
    enumerable: true,
    get: function() {
        return $7725f2e3ca016b52$exports.isMsgTransferEncodeObject;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "isMsgUndelegateEncodeObject", {
    enumerable: true,
    get: function() {
        return $7725f2e3ca016b52$exports.isMsgUndelegateEncodeObject;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "isMsgVoteEncodeObject", {
    enumerable: true,
    get: function() {
        return $7725f2e3ca016b52$exports.isMsgVoteEncodeObject;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "isMsgWithdrawDelegatorRewardEncodeObject", {
    enumerable: true,
    get: function() {
        return $7725f2e3ca016b52$exports.isMsgWithdrawDelegatorRewardEncodeObject;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "setupAuthExtension", {
    enumerable: true,
    get: function() {
        return $7725f2e3ca016b52$exports.setupAuthExtension;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "setupBankExtension", {
    enumerable: true,
    get: function() {
        return $7725f2e3ca016b52$exports.setupBankExtension;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "setupDistributionExtension", {
    enumerable: true,
    get: function() {
        return $7725f2e3ca016b52$exports.setupDistributionExtension;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "setupGovExtension", {
    enumerable: true,
    get: function() {
        return $7725f2e3ca016b52$exports.setupGovExtension;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "setupIbcExtension", {
    enumerable: true,
    get: function() {
        return $7725f2e3ca016b52$exports.setupIbcExtension;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "setupMintExtension", {
    enumerable: true,
    get: function() {
        return $7725f2e3ca016b52$exports.setupMintExtension;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "setupStakingExtension", {
    enumerable: true,
    get: function() {
        return $7725f2e3ca016b52$exports.setupStakingExtension;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "setupTxExtension", {
    enumerable: true,
    get: function() {
        return $7725f2e3ca016b52$exports.setupTxExtension;
    }
});

Object.defineProperty($842e3ecb6082807a$exports, "createAuthzAminoConverters", {
    enumerable: true,
    get: function() {
        return $7725f2e3ca016b52$exports.createAuthzAminoConverters;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "createBankAminoConverters", {
    enumerable: true,
    get: function() {
        return $7725f2e3ca016b52$exports.createBankAminoConverters;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "createDistributionAminoConverters", {
    enumerable: true,
    get: function() {
        return $7725f2e3ca016b52$exports.createDistributionAminoConverters;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "createFreegrantAminoConverters", {
    enumerable: true,
    get: function() {
        return $7725f2e3ca016b52$exports.createFreegrantAminoConverters;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "createGovAminoConverters", {
    enumerable: true,
    get: function() {
        return $7725f2e3ca016b52$exports.createGovAminoConverters;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "createIbcAminoConverters", {
    enumerable: true,
    get: function() {
        return $7725f2e3ca016b52$exports.createIbcAminoConverters;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "createStakingAminoConverters", {
    enumerable: true,
    get: function() {
        return $7725f2e3ca016b52$exports.createStakingAminoConverters;
    }
});
var $7bb1498cd77a472e$exports = {};
"use strict";
var $7bb1498cd77a472e$var$__importDefault = $7bb1498cd77a472e$exports && $7bb1498cd77a472e$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($7bb1498cd77a472e$exports, "__esModule", {
    value: true
});
$7bb1498cd77a472e$exports.makeMultisignedTx = $7bb1498cd77a472e$exports.makeCompactBitArray = void 0;


var $5zb9p = parcelRequire("5zb9p");






const $7bb1498cd77a472e$var$long_1 = $7bb1498cd77a472e$var$__importDefault((parcelRequire("9A55m")));
function $7bb1498cd77a472e$var$makeCompactBitArray(bits) {
    const byteCount = Math.ceil(bits.length / 8);
    const extraBits = bits.length - Math.floor(bits.length / 8) * 8;
    const bytes = new Uint8Array(byteCount); // zero-filled
    bits.forEach((value, index)=>{
        const bytePos = Math.floor(index / 8);
        const bitPos = index % 8;
        // eslint-disable-next-line no-bitwise
        if (value) bytes[bytePos] |= 1 << 7 - bitPos;
    });
    return $a28ec594ef179a17$exports.CompactBitArray.fromPartial({
        elems: bytes,
        extraBitsStored: extraBits
    });
}
$7bb1498cd77a472e$exports.makeCompactBitArray = $7bb1498cd77a472e$var$makeCompactBitArray;
function $7bb1498cd77a472e$var$makeMultisignedTx(multisigPubkey, sequence, fee, bodyBytes, signatures) {
    const addresses = Array.from(signatures.keys());
    const prefix = (0, $5zb9p.fromBech32)(addresses[0]).prefix;
    const signers = Array(multisigPubkey.value.pubkeys.length).fill(false);
    const signaturesList = new Array();
    for(let i = 0; i < multisigPubkey.value.pubkeys.length; i++){
        const signerAddress = (0, $111142153d5adf1c$exports.pubkeyToAddress)(multisigPubkey.value.pubkeys[i], prefix);
        const signature = signatures.get(signerAddress);
        if (signature) {
            signers[i] = true;
            signaturesList.push(signature);
        }
    }
    const signerInfo = {
        publicKey: (0, $eb9a28d0d0241b06$exports.encodePubkey)(multisigPubkey),
        modeInfo: {
            multi: {
                bitarray: $7bb1498cd77a472e$var$makeCompactBitArray(signers),
                modeInfos: signaturesList.map((_)=>({
                        single: {
                            mode: $d422a57cb1210f8b$exports.SignMode.SIGN_MODE_LEGACY_AMINO_JSON
                        }
                    }))
            }
        },
        sequence: $7bb1498cd77a472e$var$long_1.default.fromNumber(sequence)
    };
    const authInfo = $07786b3434b3c544$exports.AuthInfo.fromPartial({
        signerInfos: [
            signerInfo
        ],
        fee: {
            amount: [
                ...fee.amount
            ],
            gasLimit: $7bb1498cd77a472e$var$long_1.default.fromString(fee.gas)
        }
    });
    const authInfoBytes = $07786b3434b3c544$exports.AuthInfo.encode(authInfo).finish();
    const signedTx = $07786b3434b3c544$exports.TxRaw.fromPartial({
        bodyBytes: bodyBytes,
        authInfoBytes: authInfoBytes,
        signatures: [
            $a28ec594ef179a17$exports.MultiSignature.encode($a28ec594ef179a17$exports.MultiSignature.fromPartial({
                signatures: signaturesList
            })).finish()
        ]
    });
    return signedTx;
}
$7bb1498cd77a472e$exports.makeMultisignedTx = $7bb1498cd77a472e$var$makeMultisignedTx;


Object.defineProperty($842e3ecb6082807a$exports, "makeMultisignedTx", {
    enumerable: true,
    get: function() {
        return $7bb1498cd77a472e$exports.makeMultisignedTx;
    }
});

Object.defineProperty($842e3ecb6082807a$exports, "createPagination", {
    enumerable: true,
    get: function() {
        return $ffdede50deec576f$exports.createPagination;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "createProtobufRpcClient", {
    enumerable: true,
    get: function() {
        return $ffdede50deec576f$exports.createProtobufRpcClient;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "decodeCosmosSdkDecFromProto", {
    enumerable: true,
    get: function() {
        return $ffdede50deec576f$exports.decodeCosmosSdkDecFromProto;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "QueryClient", {
    enumerable: true,
    get: function() {
        return $ffdede50deec576f$exports.QueryClient;
    }
});
var $f8e2b1d842158517$exports = {};
"use strict";
Object.defineProperty($f8e2b1d842158517$exports, "__esModule", {
    value: true
});
$f8e2b1d842158517$exports.isSearchByTagsQuery = $f8e2b1d842158517$exports.isSearchBySentFromOrToQuery = $f8e2b1d842158517$exports.isSearchByHeightQuery = void 0;
function $f8e2b1d842158517$var$isSearchByHeightQuery(query) {
    return query.height !== undefined;
}
$f8e2b1d842158517$exports.isSearchByHeightQuery = $f8e2b1d842158517$var$isSearchByHeightQuery;
function $f8e2b1d842158517$var$isSearchBySentFromOrToQuery(query) {
    return query.sentFromOrTo !== undefined;
}
$f8e2b1d842158517$exports.isSearchBySentFromOrToQuery = $f8e2b1d842158517$var$isSearchBySentFromOrToQuery;
function $f8e2b1d842158517$var$isSearchByTagsQuery(query) {
    return query.tags !== undefined;
}
$f8e2b1d842158517$exports.isSearchByTagsQuery = $f8e2b1d842158517$var$isSearchByTagsQuery;


Object.defineProperty($842e3ecb6082807a$exports, "isSearchByHeightQuery", {
    enumerable: true,
    get: function() {
        return $f8e2b1d842158517$exports.isSearchByHeightQuery;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "isSearchBySentFromOrToQuery", {
    enumerable: true,
    get: function() {
        return $f8e2b1d842158517$exports.isSearchBySentFromOrToQuery;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "isSearchByTagsQuery", {
    enumerable: true,
    get: function() {
        return $f8e2b1d842158517$exports.isSearchByTagsQuery;
    }
});
var $d8c8afe933e1a422$exports = {};
"use strict";
var $d8c8afe933e1a422$var$__importDefault = $d8c8afe933e1a422$exports && $d8c8afe933e1a422$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($d8c8afe933e1a422$exports, "__esModule", {
    value: true
});
$d8c8afe933e1a422$exports.SigningStargateClient = $d8c8afe933e1a422$exports.defaultRegistryTypes = void 0;


var $5zb9p = parcelRequire("5zb9p");

var $9YIif = parcelRequire("9YIif");

var $2e6803a040cc66a1$exports = {};
"use strict";
var $2e6803a040cc66a1$var$__createBinding = $2e6803a040cc66a1$exports && $2e6803a040cc66a1$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2e6803a040cc66a1$var$__setModuleDefault = $2e6803a040cc66a1$exports && $2e6803a040cc66a1$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $2e6803a040cc66a1$var$__importStar = $2e6803a040cc66a1$exports && $2e6803a040cc66a1$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $2e6803a040cc66a1$var$__createBinding(result, mod, k);
    }
    $2e6803a040cc66a1$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($2e6803a040cc66a1$exports, "__esModule", {
    value: true
});
$2e6803a040cc66a1$exports.BlockIdFlag = $2e6803a040cc66a1$exports.Tendermint34Client = $2e6803a040cc66a1$exports.tendermint34 = $2e6803a040cc66a1$exports.VoteType = $2e6803a040cc66a1$exports.SubscriptionEventType = $2e6803a040cc66a1$exports.Method = $2e6803a040cc66a1$exports.broadcastTxSyncSuccess = $2e6803a040cc66a1$exports.broadcastTxCommitSuccess = $2e6803a040cc66a1$exports.WebsocketClient = $2e6803a040cc66a1$exports.HttpClient = $2e6803a040cc66a1$exports.toSeconds = $2e6803a040cc66a1$exports.toRfc3339WithNanoseconds = $2e6803a040cc66a1$exports.fromSeconds = $2e6803a040cc66a1$exports.fromRfc3339WithNanoseconds = $2e6803a040cc66a1$exports.DateTime = $2e6803a040cc66a1$exports.rawSecp256k1PubkeyToRawAddress = $2e6803a040cc66a1$exports.rawEd25519PubkeyToRawAddress = $2e6803a040cc66a1$exports.pubkeyToRawAddress = $2e6803a040cc66a1$exports.pubkeyToAddress = void 0;
var $5cba317b174a87f4$exports = {};
"use strict";
Object.defineProperty($5cba317b174a87f4$exports, "__esModule", {
    value: true
});
$5cba317b174a87f4$exports.pubkeyToAddress = $5cba317b174a87f4$exports.pubkeyToRawAddress = $5cba317b174a87f4$exports.rawSecp256k1PubkeyToRawAddress = $5cba317b174a87f4$exports.rawEd25519PubkeyToRawAddress = void 0;

var $9Nqq4 = parcelRequire("9Nqq4");

var $5zb9p = parcelRequire("5zb9p");
function $5cba317b174a87f4$var$rawEd25519PubkeyToRawAddress(pubkeyData) {
    if (pubkeyData.length !== 32) throw new Error(`Invalid Ed25519 pubkey length: ${pubkeyData.length}`);
    return (0, $9Nqq4.sha256)(pubkeyData).slice(0, 20);
}
$5cba317b174a87f4$exports.rawEd25519PubkeyToRawAddress = $5cba317b174a87f4$var$rawEd25519PubkeyToRawAddress;
function $5cba317b174a87f4$var$rawSecp256k1PubkeyToRawAddress(pubkeyData) {
    if (pubkeyData.length !== 33) throw new Error(`Invalid Secp256k1 pubkey length (compressed): ${pubkeyData.length}`);
    return (0, $9Nqq4.ripemd160)((0, $9Nqq4.sha256)(pubkeyData));
}
$5cba317b174a87f4$exports.rawSecp256k1PubkeyToRawAddress = $5cba317b174a87f4$var$rawSecp256k1PubkeyToRawAddress;
// For secp256k1 this assumes we already have a compressed pubkey.
function $5cba317b174a87f4$var$pubkeyToRawAddress(type, data) {
    switch(type){
        case "ed25519":
            return $5cba317b174a87f4$var$rawEd25519PubkeyToRawAddress(data);
        case "secp256k1":
            return $5cba317b174a87f4$var$rawSecp256k1PubkeyToRawAddress(data);
        default:
            // Keep this case here to guard against new types being added but not handled
            throw new Error(`Pubkey type ${type} not supported`);
    }
}
$5cba317b174a87f4$exports.pubkeyToRawAddress = $5cba317b174a87f4$var$pubkeyToRawAddress;
function $5cba317b174a87f4$var$pubkeyToAddress(type, data) {
    return (0, $5zb9p.toHex)($5cba317b174a87f4$var$pubkeyToRawAddress(type, data)).toUpperCase();
}
$5cba317b174a87f4$exports.pubkeyToAddress = $5cba317b174a87f4$var$pubkeyToAddress;


Object.defineProperty($2e6803a040cc66a1$exports, "pubkeyToAddress", {
    enumerable: true,
    get: function() {
        return $5cba317b174a87f4$exports.pubkeyToAddress;
    }
});
Object.defineProperty($2e6803a040cc66a1$exports, "pubkeyToRawAddress", {
    enumerable: true,
    get: function() {
        return $5cba317b174a87f4$exports.pubkeyToRawAddress;
    }
});
Object.defineProperty($2e6803a040cc66a1$exports, "rawEd25519PubkeyToRawAddress", {
    enumerable: true,
    get: function() {
        return $5cba317b174a87f4$exports.rawEd25519PubkeyToRawAddress;
    }
});
Object.defineProperty($2e6803a040cc66a1$exports, "rawSecp256k1PubkeyToRawAddress", {
    enumerable: true,
    get: function() {
        return $5cba317b174a87f4$exports.rawSecp256k1PubkeyToRawAddress;
    }
});

var $aRP0Z = parcelRequire("aRP0Z");
Object.defineProperty($2e6803a040cc66a1$exports, "DateTime", {
    enumerable: true,
    get: function() {
        return $aRP0Z.DateTime;
    }
});
Object.defineProperty($2e6803a040cc66a1$exports, "fromRfc3339WithNanoseconds", {
    enumerable: true,
    get: function() {
        return $aRP0Z.fromRfc3339WithNanoseconds;
    }
});
Object.defineProperty($2e6803a040cc66a1$exports, "fromSeconds", {
    enumerable: true,
    get: function() {
        return $aRP0Z.fromSeconds;
    }
});
Object.defineProperty($2e6803a040cc66a1$exports, "toRfc3339WithNanoseconds", {
    enumerable: true,
    get: function() {
        return $aRP0Z.toRfc3339WithNanoseconds;
    }
});
Object.defineProperty($2e6803a040cc66a1$exports, "toSeconds", {
    enumerable: true,
    get: function() {
        return $aRP0Z.toSeconds;
    }
});

var $lqv7L = parcelRequire("lqv7L");
Object.defineProperty($2e6803a040cc66a1$exports, "HttpClient", {
    enumerable: true,
    get: function() {
        return $lqv7L.HttpClient;
    }
});
Object.defineProperty($2e6803a040cc66a1$exports, "WebsocketClient", {
    enumerable: true,
    get: function() {
        return $lqv7L.WebsocketClient;
    }
});

Object.defineProperty($2e6803a040cc66a1$exports, "broadcastTxCommitSuccess", {
    enumerable: true,
    get: function() {
        return (parcelRequire("3yx4f")).broadcastTxCommitSuccess;
    }
});
Object.defineProperty($2e6803a040cc66a1$exports, "broadcastTxSyncSuccess", {
    enumerable: true,
    get: function() {
        return (parcelRequire("3yx4f")).broadcastTxSyncSuccess;
    }
});
Object.defineProperty($2e6803a040cc66a1$exports, "Method", {
    enumerable: true,
    get: function() {
        return (parcelRequire("3yx4f")).Method;
    }
});
Object.defineProperty($2e6803a040cc66a1$exports, "SubscriptionEventType", {
    enumerable: true,
    get: function() {
        return (parcelRequire("3yx4f")).SubscriptionEventType;
    }
});
Object.defineProperty($2e6803a040cc66a1$exports, "VoteType", {
    enumerable: true,
    get: function() {
        return (parcelRequire("3yx4f")).VoteType;
    }
});

$2e6803a040cc66a1$exports.tendermint34 = $2e6803a040cc66a1$var$__importStar((parcelRequire("3yx4f")));

Object.defineProperty($2e6803a040cc66a1$exports, "Tendermint34Client", {
    enumerable: true,
    get: function() {
        return (parcelRequire("3yx4f")).Tendermint34Client;
    }
});

var $lfB3U = parcelRequire("lfB3U");
Object.defineProperty($2e6803a040cc66a1$exports, "BlockIdFlag", {
    enumerable: true,
    get: function() {
        return $lfB3U.BlockIdFlag;
    }
});



var $F6P8J = parcelRequire("F6P8J");







const $d8c8afe933e1a422$var$long_1 = $d8c8afe933e1a422$var$__importDefault((parcelRequire("9A55m")));




var $71e6e57c9b0332e1$exports = {};
"use strict";
Object.defineProperty($71e6e57c9b0332e1$exports, "__esModule", {
    value: true
});
$71e6e57c9b0332e1$exports.StargateClient = $71e6e57c9b0332e1$exports.assertIsDeliverTxFailure = $71e6e57c9b0332e1$exports.assertIsDeliverTxSuccess = $71e6e57c9b0332e1$exports.isDeliverTxSuccess = $71e6e57c9b0332e1$exports.isDeliverTxFailure = $71e6e57c9b0332e1$exports.TimeoutError = void 0;


var $5zb9p = parcelRequire("5zb9p");

var $9YIif = parcelRequire("9YIif");


var $F6P8J = parcelRequire("F6P8J");




class $71e6e57c9b0332e1$var$TimeoutError extends Error {
    constructor(message, txId){
        super(message);
        this.txId = txId;
    }
}
$71e6e57c9b0332e1$exports.TimeoutError = $71e6e57c9b0332e1$var$TimeoutError;
function $71e6e57c9b0332e1$var$isDeliverTxFailure(result) {
    return !!result.code;
}
$71e6e57c9b0332e1$exports.isDeliverTxFailure = $71e6e57c9b0332e1$var$isDeliverTxFailure;
function $71e6e57c9b0332e1$var$isDeliverTxSuccess(result) {
    return !$71e6e57c9b0332e1$var$isDeliverTxFailure(result);
}
$71e6e57c9b0332e1$exports.isDeliverTxSuccess = $71e6e57c9b0332e1$var$isDeliverTxSuccess;
/**
 * Ensures the given result is a success. Throws a detailed error message otherwise.
 */ function $71e6e57c9b0332e1$var$assertIsDeliverTxSuccess(result) {
    if ($71e6e57c9b0332e1$var$isDeliverTxFailure(result)) throw new Error(`Error when broadcasting tx ${result.transactionHash} at height ${result.height}. Code: ${result.code}; Raw log: ${result.rawLog}`);
}
$71e6e57c9b0332e1$exports.assertIsDeliverTxSuccess = $71e6e57c9b0332e1$var$assertIsDeliverTxSuccess;
/**
 * Ensures the given result is a failure. Throws a detailed error message otherwise.
 */ function $71e6e57c9b0332e1$var$assertIsDeliverTxFailure(result) {
    if ($71e6e57c9b0332e1$var$isDeliverTxSuccess(result)) throw new Error(`Transaction ${result.transactionHash} did not fail at height ${result.height}. Code: ${result.code}; Raw log: ${result.rawLog}`);
}
$71e6e57c9b0332e1$exports.assertIsDeliverTxFailure = $71e6e57c9b0332e1$var$assertIsDeliverTxFailure;
class $71e6e57c9b0332e1$var$StargateClient {
    static async connect(endpoint, options = {}) {
        const tmClient = await $2e6803a040cc66a1$exports.Tendermint34Client.connect(endpoint);
        return new $71e6e57c9b0332e1$var$StargateClient(tmClient, options);
    }
    getTmClient() {
        return this.tmClient;
    }
    forceGetTmClient() {
        if (!this.tmClient) throw new Error("Tendermint client not available. You cannot use online functionality in offline mode.");
        return this.tmClient;
    }
    getQueryClient() {
        return this.queryClient;
    }
    forceGetQueryClient() {
        if (!this.queryClient) throw new Error("Query client not available. You cannot use online functionality in offline mode.");
        return this.queryClient;
    }
    async getChainId() {
        if (!this.chainId) {
            const response = await this.forceGetTmClient().status();
            const chainId = response.nodeInfo.network;
            if (!chainId) throw new Error("Chain ID must not be empty");
            this.chainId = chainId;
        }
        return this.chainId;
    }
    async getHeight() {
        const status = await this.forceGetTmClient().status();
        return status.syncInfo.latestBlockHeight;
    }
    async getAccount(searchAddress) {
        try {
            const account = await this.forceGetQueryClient().auth.account(searchAddress);
            return account ? this.accountParser(account) : null;
        } catch (error) {
            if (/rpc error: code = NotFound/i.test(error.toString())) return null;
            throw error;
        }
    }
    async getSequence(address) {
        const account = await this.getAccount(address);
        if (!account) throw new Error("Account does not exist on chain. Send some tokens there before trying to query sequence.");
        return {
            accountNumber: account.accountNumber,
            sequence: account.sequence
        };
    }
    async getBlock(height) {
        const response = await this.forceGetTmClient().block(height);
        return {
            id: (0, $5zb9p.toHex)(response.blockId.hash).toUpperCase(),
            header: {
                version: {
                    block: new $9YIif.Uint53(response.block.header.version.block).toString(),
                    app: new $9YIif.Uint53(response.block.header.version.app).toString()
                },
                height: response.block.header.height,
                chainId: response.block.header.chainId,
                time: (0, $2e6803a040cc66a1$exports.toRfc3339WithNanoseconds)(response.block.header.time)
            },
            txs: response.block.txs
        };
    }
    async getBalance(address, searchDenom) {
        return this.forceGetQueryClient().bank.balance(address, searchDenom);
    }
    /**
     * Queries all balances for all denoms that belong to this address.
     *
     * Uses the grpc queries (which iterates over the store internally), and we cannot get
     * proofs from such a method.
     */ async getAllBalances(address) {
        return this.forceGetQueryClient().bank.allBalances(address);
    }
    async getBalanceStaked(address) {
        const allDelegations = [];
        let startAtKey = undefined;
        do {
            const { delegationResponses: delegationResponses, pagination: pagination } = await this.forceGetQueryClient().staking.delegatorDelegations(address, startAtKey);
            const loadedDelegations = delegationResponses || [];
            allDelegations.push(...loadedDelegations);
            startAtKey = pagination === null || pagination === void 0 ? void 0 : pagination.nextKey;
        }while (startAtKey !== undefined && startAtKey.length !== 0);
        const sumValues = allDelegations.reduce((previousValue, currentValue)=>{
            // Safe because field is set to non-nullable (https://github.com/cosmos/cosmos-sdk/blob/v0.45.3/proto/cosmos/staking/v1beta1/staking.proto#L295)
            (0, $F6P8J.assert)(currentValue.balance);
            return previousValue !== null ? (0, $111142153d5adf1c$exports.addCoins)(previousValue, currentValue.balance) : currentValue.balance;
        }, null);
        return sumValues;
    }
    async getDelegation(delegatorAddress, validatorAddress) {
        var _a;
        let delegatedAmount;
        try {
            delegatedAmount = (_a = (await this.forceGetQueryClient().staking.delegation(delegatorAddress, validatorAddress)).delegationResponse) === null || _a === void 0 ? void 0 : _a.balance;
        } catch (e) {
            if (e.toString().includes("key not found")) ;
            else throw e;
        }
        return delegatedAmount || null;
    }
    async getTx(id) {
        var _a;
        const results = await this.txsQuery(`tx.hash='${id}'`);
        return (_a = results[0]) !== null && _a !== void 0 ? _a : null;
    }
    async searchTx(query, filter = {}) {
        const minHeight = filter.minHeight || 0;
        const maxHeight = filter.maxHeight || Number.MAX_SAFE_INTEGER;
        if (maxHeight < minHeight) return []; // optional optimization
        function withFilters(originalQuery) {
            return `${originalQuery} AND tx.height>=${minHeight} AND tx.height<=${maxHeight}`;
        }
        let txs;
        if ((0, $f8e2b1d842158517$exports.isSearchByHeightQuery)(query)) txs = query.height >= minHeight && query.height <= maxHeight ? await this.txsQuery(`tx.height=${query.height}`) : [];
        else if ((0, $f8e2b1d842158517$exports.isSearchBySentFromOrToQuery)(query)) {
            const sentQuery = withFilters(`message.module='bank' AND transfer.sender='${query.sentFromOrTo}'`);
            const receivedQuery = withFilters(`message.module='bank' AND transfer.recipient='${query.sentFromOrTo}'`);
            const [sent, received] = await Promise.all([
                sentQuery,
                receivedQuery
            ].map((rawQuery)=>this.txsQuery(rawQuery)));
            const sentHashes = sent.map((t)=>t.hash);
            txs = [
                ...sent,
                ...received.filter((t)=>!sentHashes.includes(t.hash))
            ];
        } else if ((0, $f8e2b1d842158517$exports.isSearchByTagsQuery)(query)) {
            const rawQuery = withFilters(query.tags.map((t)=>`${t.key}='${t.value}'`).join(" AND "));
            txs = await this.txsQuery(rawQuery);
        } else throw new Error("Unknown query type");
        const filtered = txs.filter((tx)=>tx.height >= minHeight && tx.height <= maxHeight);
        return filtered;
    }
    disconnect() {
        if (this.tmClient) this.tmClient.disconnect();
    }
    /**
     * Broadcasts a signed transaction to the network and monitors its inclusion in a block.
     *
     * If broadcasting is rejected by the node for some reason (e.g. because of a CheckTx failure),
     * an error is thrown.
     *
     * If the transaction is not included in a block before the provided timeout, this errors with a `TimeoutError`.
     *
     * If the transaction is included in a block, a `DeliverTxResponse` is returned. The caller then
     * usually needs to check for execution success or failure.
     */ async broadcastTx(tx, timeoutMs = 60000, pollIntervalMs = 3000) {
        let timedOut = false;
        const txPollTimeout = setTimeout(()=>{
            timedOut = true;
        }, timeoutMs);
        const pollForTx = async (txId)=>{
            if (timedOut) throw new $71e6e57c9b0332e1$var$TimeoutError(`Transaction with ID ${txId} was submitted but was not yet found on the chain. You might want to check later. There was a wait of ${timeoutMs / 1000} seconds.`, txId);
            await (0, $F6P8J.sleep)(pollIntervalMs);
            const result = await this.getTx(txId);
            return result ? {
                code: result.code,
                height: result.height,
                rawLog: result.rawLog,
                transactionHash: txId,
                gasUsed: result.gasUsed,
                gasWanted: result.gasWanted
            } : pollForTx(txId);
        };
        const broadcasted = await this.forceGetTmClient().broadcastTxSync({
            tx: tx
        });
        if (broadcasted.code) return Promise.reject(new Error(`Broadcasting transaction failed with code ${broadcasted.code} (codespace: ${broadcasted.codeSpace}). Log: ${broadcasted.log}`));
        const transactionId = (0, $5zb9p.toHex)(broadcasted.hash).toUpperCase();
        return new Promise((resolve, reject)=>pollForTx(transactionId).then((value)=>{
                clearTimeout(txPollTimeout);
                resolve(value);
            }, (error)=>{
                clearTimeout(txPollTimeout);
                reject(error);
            }));
    }
    async txsQuery(query) {
        const results = await this.forceGetTmClient().txSearchAll({
            query: query
        });
        return results.txs.map((tx)=>{
            return {
                height: tx.height,
                hash: (0, $5zb9p.toHex)(tx.hash).toUpperCase(),
                code: tx.result.code,
                rawLog: tx.result.log || "",
                tx: tx.tx,
                gasUsed: tx.result.gasUsed,
                gasWanted: tx.result.gasWanted
            };
        });
    }
    constructor(tmClient, options){
        if (tmClient) {
            this.tmClient = tmClient;
            this.queryClient = $ffdede50deec576f$exports.QueryClient.withExtensions(tmClient, $7725f2e3ca016b52$exports.setupAuthExtension, $7725f2e3ca016b52$exports.setupBankExtension, $7725f2e3ca016b52$exports.setupStakingExtension, $7725f2e3ca016b52$exports.setupTxExtension);
        }
        const { accountParser: accountParser = $f152202261c35b7c$exports.accountFromAny } = options;
        this.accountParser = accountParser;
    }
}
$71e6e57c9b0332e1$exports.StargateClient = $71e6e57c9b0332e1$var$StargateClient;


$d8c8afe933e1a422$exports.defaultRegistryTypes = [
    [
        "/cosmos.base.v1beta1.Coin",
        $82ef09d1a8e2224d$exports.Coin
    ],
    ...$7725f2e3ca016b52$exports.authzTypes,
    ...$7725f2e3ca016b52$exports.bankTypes,
    ...$7725f2e3ca016b52$exports.distributionTypes,
    ...$7725f2e3ca016b52$exports.feegrantTypes,
    ...$7725f2e3ca016b52$exports.govTypes,
    ...$7725f2e3ca016b52$exports.stakingTypes,
    ...$7725f2e3ca016b52$exports.ibcTypes,
    ...$7725f2e3ca016b52$exports.vestingTypes
];
function $d8c8afe933e1a422$var$createDefaultRegistry() {
    return new $eb9a28d0d0241b06$exports.Registry($d8c8afe933e1a422$exports.defaultRegistryTypes);
}
function $d8c8afe933e1a422$var$createDefaultTypes(prefix) {
    return {
        ...(0, $7725f2e3ca016b52$exports.createAuthzAminoConverters)(),
        ...(0, $7725f2e3ca016b52$exports.createBankAminoConverters)(),
        ...(0, $7725f2e3ca016b52$exports.createDistributionAminoConverters)(),
        ...(0, $7725f2e3ca016b52$exports.createGovAminoConverters)(),
        ...(0, $7725f2e3ca016b52$exports.createStakingAminoConverters)(prefix),
        ...(0, $7725f2e3ca016b52$exports.createIbcAminoConverters)(),
        ...(0, $7725f2e3ca016b52$exports.createFreegrantAminoConverters)(),
        ...(0, $7725f2e3ca016b52$exports.createVestingAminoConverters)()
    };
}
class $d8c8afe933e1a422$var$SigningStargateClient extends $71e6e57c9b0332e1$exports.StargateClient {
    static async connectWithSigner(endpoint, signer, options = {}) {
        const tmClient = await $2e6803a040cc66a1$exports.Tendermint34Client.connect(endpoint);
        return new $d8c8afe933e1a422$var$SigningStargateClient(tmClient, signer, options);
    }
    /**
     * Creates a client in offline mode.
     *
     * This should only be used in niche cases where you know exactly what you're doing,
     * e.g. when building an offline signing application.
     *
     * When you try to use online functionality with such a signer, an
     * exception will be raised.
     */ static async offline(signer, options = {}) {
        return new $d8c8afe933e1a422$var$SigningStargateClient(undefined, signer, options);
    }
    async simulate(signerAddress, messages, memo) {
        const anyMsgs = messages.map((m)=>this.registry.encodeAsAny(m));
        const accountFromSigner = (await this.signer.getAccounts()).find((account)=>account.address === signerAddress);
        if (!accountFromSigner) throw new Error("Failed to retrieve account from signer");
        const pubkey = (0, $111142153d5adf1c$exports.encodeSecp256k1Pubkey)(accountFromSigner.pubkey);
        const { sequence: sequence } = await this.getSequence(signerAddress);
        const { gasInfo: gasInfo } = await this.forceGetQueryClient().tx.simulate(anyMsgs, memo, pubkey, sequence);
        (0, $F6P8J.assertDefined)(gasInfo);
        return $9YIif.Uint53.fromString(gasInfo.gasUsed.toString()).toNumber();
    }
    async sendTokens(senderAddress, recipientAddress, amount, fee, memo = "") {
        const sendMsg = {
            typeUrl: "/cosmos.bank.v1beta1.MsgSend",
            value: {
                fromAddress: senderAddress,
                toAddress: recipientAddress,
                amount: [
                    ...amount
                ]
            }
        };
        return this.signAndBroadcast(senderAddress, [
            sendMsg
        ], fee, memo);
    }
    async delegateTokens(delegatorAddress, validatorAddress, amount, fee, memo = "") {
        const delegateMsg = {
            typeUrl: "/cosmos.staking.v1beta1.MsgDelegate",
            value: $0000c3e2167efb84$exports.MsgDelegate.fromPartial({
                delegatorAddress: delegatorAddress,
                validatorAddress: validatorAddress,
                amount: amount
            })
        };
        return this.signAndBroadcast(delegatorAddress, [
            delegateMsg
        ], fee, memo);
    }
    async undelegateTokens(delegatorAddress, validatorAddress, amount, fee, memo = "") {
        const undelegateMsg = {
            typeUrl: "/cosmos.staking.v1beta1.MsgUndelegate",
            value: $0000c3e2167efb84$exports.MsgUndelegate.fromPartial({
                delegatorAddress: delegatorAddress,
                validatorAddress: validatorAddress,
                amount: amount
            })
        };
        return this.signAndBroadcast(delegatorAddress, [
            undelegateMsg
        ], fee, memo);
    }
    async withdrawRewards(delegatorAddress, validatorAddress, fee, memo = "") {
        const withdrawMsg = {
            typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
            value: $770beae6d633ee1a$exports.MsgWithdrawDelegatorReward.fromPartial({
                delegatorAddress: delegatorAddress,
                validatorAddress: validatorAddress
            })
        };
        return this.signAndBroadcast(delegatorAddress, [
            withdrawMsg
        ], fee, memo);
    }
    async sendIbcTokens(senderAddress, recipientAddress, transferAmount, sourcePort, sourceChannel, timeoutHeight, /** timeout in seconds */ timeoutTimestamp, fee, memo = "") {
        const timeoutTimestampNanoseconds = timeoutTimestamp ? $d8c8afe933e1a422$var$long_1.default.fromNumber(timeoutTimestamp).multiply(1000000000) : undefined;
        const transferMsg = {
            typeUrl: "/ibc.applications.transfer.v1.MsgTransfer",
            value: $1f4036e8aebd4a0e$exports.MsgTransfer.fromPartial({
                sourcePort: sourcePort,
                sourceChannel: sourceChannel,
                sender: senderAddress,
                receiver: recipientAddress,
                token: transferAmount,
                timeoutHeight: timeoutHeight,
                timeoutTimestamp: timeoutTimestampNanoseconds
            })
        };
        return this.signAndBroadcast(senderAddress, [
            transferMsg
        ], fee, memo);
    }
    async signAndBroadcast(signerAddress, messages, fee, memo = "") {
        let usedFee;
        if (fee == "auto" || typeof fee === "number") {
            (0, $F6P8J.assertDefined)(this.gasPrice, "Gas price must be set in the client options when auto gas is used.");
            const gasEstimation = await this.simulate(signerAddress, messages, memo);
            const multiplier = typeof fee === "number" ? fee : 1.3;
            usedFee = (0, $7e86b235f7779e86$exports.calculateFee)(Math.round(gasEstimation * multiplier), this.gasPrice);
        } else usedFee = fee;
        const txRaw = await this.sign(signerAddress, messages, usedFee, memo);
        const txBytes = $07786b3434b3c544$exports.TxRaw.encode(txRaw).finish();
        return this.broadcastTx(txBytes, this.broadcastTimeoutMs, this.broadcastPollIntervalMs);
    }
    /**
     * Gets account number and sequence from the API, creates a sign doc,
     * creates a single signature and assembles the signed transaction.
     *
     * The sign mode (SIGN_MODE_DIRECT or SIGN_MODE_LEGACY_AMINO_JSON) is determined by this client's signer.
     *
     * You can pass signer data (account number, sequence and chain ID) explicitly instead of querying them
     * from the chain. This is needed when signing for a multisig account, but it also allows for offline signing
     * (See the SigningStargateClient.offline constructor).
     */ async sign(signerAddress, messages, fee, memo, explicitSignerData) {
        let signerData;
        if (explicitSignerData) signerData = explicitSignerData;
        else {
            const { accountNumber: accountNumber, sequence: sequence } = await this.getSequence(signerAddress);
            const chainId = await this.getChainId();
            signerData = {
                accountNumber: accountNumber,
                sequence: sequence,
                chainId: chainId
            };
        }
        return (0, $eb9a28d0d0241b06$exports.isOfflineDirectSigner)(this.signer) ? this.signDirect(signerAddress, messages, fee, memo, signerData) : this.signAmino(signerAddress, messages, fee, memo, signerData);
    }
    async signAmino(signerAddress, messages, fee, memo, { accountNumber: accountNumber, sequence: sequence, chainId: chainId }) {
        (0, $F6P8J.assert)(!(0, $eb9a28d0d0241b06$exports.isOfflineDirectSigner)(this.signer));
        const accountFromSigner = (await this.signer.getAccounts()).find((account)=>account.address === signerAddress);
        if (!accountFromSigner) throw new Error("Failed to retrieve account from signer");
        const pubkey = (0, $eb9a28d0d0241b06$exports.encodePubkey)((0, $111142153d5adf1c$exports.encodeSecp256k1Pubkey)(accountFromSigner.pubkey));
        const signMode = $d422a57cb1210f8b$exports.SignMode.SIGN_MODE_LEGACY_AMINO_JSON;
        const msgs = messages.map((msg)=>this.aminoTypes.toAmino(msg));
        const signDoc = (0, $111142153d5adf1c$exports.makeSignDoc)(msgs, fee, chainId, memo, accountNumber, sequence);
        const { signature: signature, signed: signed } = await this.signer.signAmino(signerAddress, signDoc);
        const signedTxBody = {
            messages: signed.msgs.map((msg)=>this.aminoTypes.fromAmino(msg)),
            memo: signed.memo
        };
        const signedTxBodyEncodeObject = {
            typeUrl: "/cosmos.tx.v1beta1.TxBody",
            value: signedTxBody
        };
        const signedTxBodyBytes = this.registry.encode(signedTxBodyEncodeObject);
        const signedGasLimit = $9YIif.Int53.fromString(signed.fee.gas).toNumber();
        const signedSequence = $9YIif.Int53.fromString(signed.sequence).toNumber();
        const signedAuthInfoBytes = (0, $eb9a28d0d0241b06$exports.makeAuthInfoBytes)([
            {
                pubkey: pubkey,
                sequence: signedSequence
            }
        ], signed.fee.amount, signedGasLimit, signMode);
        return $07786b3434b3c544$exports.TxRaw.fromPartial({
            bodyBytes: signedTxBodyBytes,
            authInfoBytes: signedAuthInfoBytes,
            signatures: [
                (0, $5zb9p.fromBase64)(signature.signature)
            ]
        });
    }
    async signDirect(signerAddress, messages, fee, memo, { accountNumber: accountNumber, sequence: sequence, chainId: chainId }) {
        (0, $F6P8J.assert)((0, $eb9a28d0d0241b06$exports.isOfflineDirectSigner)(this.signer));
        const accountFromSigner = (await this.signer.getAccounts()).find((account)=>account.address === signerAddress);
        if (!accountFromSigner) throw new Error("Failed to retrieve account from signer");
        const pubkey = (0, $eb9a28d0d0241b06$exports.encodePubkey)((0, $111142153d5adf1c$exports.encodeSecp256k1Pubkey)(accountFromSigner.pubkey));
        const txBodyEncodeObject = {
            typeUrl: "/cosmos.tx.v1beta1.TxBody",
            value: {
                messages: messages,
                memo: memo
            }
        };
        const txBodyBytes = this.registry.encode(txBodyEncodeObject);
        const gasLimit = $9YIif.Int53.fromString(fee.gas).toNumber();
        const authInfoBytes = (0, $eb9a28d0d0241b06$exports.makeAuthInfoBytes)([
            {
                pubkey: pubkey,
                sequence: sequence
            }
        ], fee.amount, gasLimit);
        const signDoc = (0, $eb9a28d0d0241b06$exports.makeSignDoc)(txBodyBytes, authInfoBytes, chainId, accountNumber);
        const { signature: signature, signed: signed } = await this.signer.signDirect(signerAddress, signDoc);
        return $07786b3434b3c544$exports.TxRaw.fromPartial({
            bodyBytes: signed.bodyBytes,
            authInfoBytes: signed.authInfoBytes,
            signatures: [
                (0, $5zb9p.fromBase64)(signature.signature)
            ]
        });
    }
    constructor(tmClient, signer, options){
        var _a;
        super(tmClient, options);
        // TODO: do we really want to set a default here? Ideally we could get it from the signer such that users only have to set it once.
        const prefix = (_a = options.prefix) !== null && _a !== void 0 ? _a : "cosmos";
        const { registry: registry = $d8c8afe933e1a422$var$createDefaultRegistry(), aminoTypes: aminoTypes = new $e47c3667af262a39$exports.AminoTypes($d8c8afe933e1a422$var$createDefaultTypes(prefix)) } = options;
        this.registry = registry;
        this.aminoTypes = aminoTypes;
        this.signer = signer;
        this.broadcastTimeoutMs = options.broadcastTimeoutMs;
        this.broadcastPollIntervalMs = options.broadcastPollIntervalMs;
        this.gasPrice = options.gasPrice;
    }
}
$d8c8afe933e1a422$exports.SigningStargateClient = $d8c8afe933e1a422$var$SigningStargateClient;


Object.defineProperty($842e3ecb6082807a$exports, "defaultRegistryTypes", {
    enumerable: true,
    get: function() {
        return $d8c8afe933e1a422$exports.defaultRegistryTypes;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "SigningStargateClient", {
    enumerable: true,
    get: function() {
        return $d8c8afe933e1a422$exports.SigningStargateClient;
    }
});

Object.defineProperty($842e3ecb6082807a$exports, "assertIsDeliverTxFailure", {
    enumerable: true,
    get: function() {
        return $71e6e57c9b0332e1$exports.assertIsDeliverTxFailure;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "assertIsDeliverTxSuccess", {
    enumerable: true,
    get: function() {
        return $71e6e57c9b0332e1$exports.assertIsDeliverTxSuccess;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "isDeliverTxFailure", {
    enumerable: true,
    get: function() {
        return $71e6e57c9b0332e1$exports.isDeliverTxFailure;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "isDeliverTxSuccess", {
    enumerable: true,
    get: function() {
        return $71e6e57c9b0332e1$exports.isDeliverTxSuccess;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "StargateClient", {
    enumerable: true,
    get: function() {
        return $71e6e57c9b0332e1$exports.StargateClient;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "TimeoutError", {
    enumerable: true,
    get: function() {
        return $71e6e57c9b0332e1$exports.TimeoutError;
    }
});

Object.defineProperty($842e3ecb6082807a$exports, "coin", {
    enumerable: true,
    get: function() {
        return $eb9a28d0d0241b06$exports.coin;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "coins", {
    enumerable: true,
    get: function() {
        return $eb9a28d0d0241b06$exports.coins;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "makeCosmoshubPath", {
    enumerable: true,
    get: function() {
        return $eb9a28d0d0241b06$exports.makeCosmoshubPath;
    }
});
Object.defineProperty($842e3ecb6082807a$exports, "parseCoins", {
    enumerable: true,
    get: function() {
        return $eb9a28d0d0241b06$exports.parseCoins;
    }
});


var $18d826a12788a23d$exports = {};

$18d826a12788a23d$exports = (parcelRequire("hjpZr"));


var $dd3057ce36414b67$exports = {};
"use strict";
const $dd3057ce36414b67$var$denyList = new Set([
    "ENOTFOUND",
    "ENETUNREACH",
    // SSL errors from https://github.com/nodejs/node/blob/fc8e3e2cdc521978351de257030db0076d79e0ab/src/crypto/crypto_common.cc#L301-L328
    "UNABLE_TO_GET_ISSUER_CERT",
    "UNABLE_TO_GET_CRL",
    "UNABLE_TO_DECRYPT_CERT_SIGNATURE",
    "UNABLE_TO_DECRYPT_CRL_SIGNATURE",
    "UNABLE_TO_DECODE_ISSUER_PUBLIC_KEY",
    "CERT_SIGNATURE_FAILURE",
    "CRL_SIGNATURE_FAILURE",
    "CERT_NOT_YET_VALID",
    "CERT_HAS_EXPIRED",
    "CRL_NOT_YET_VALID",
    "CRL_HAS_EXPIRED",
    "ERROR_IN_CERT_NOT_BEFORE_FIELD",
    "ERROR_IN_CERT_NOT_AFTER_FIELD",
    "ERROR_IN_CRL_LAST_UPDATE_FIELD",
    "ERROR_IN_CRL_NEXT_UPDATE_FIELD",
    "OUT_OF_MEM",
    "DEPTH_ZERO_SELF_SIGNED_CERT",
    "SELF_SIGNED_CERT_IN_CHAIN",
    "UNABLE_TO_GET_ISSUER_CERT_LOCALLY",
    "UNABLE_TO_VERIFY_LEAF_SIGNATURE",
    "CERT_CHAIN_TOO_LONG",
    "CERT_REVOKED",
    "INVALID_CA",
    "PATH_LENGTH_EXCEEDED",
    "INVALID_PURPOSE",
    "CERT_UNTRUSTED",
    "CERT_REJECTED",
    "HOSTNAME_MISMATCH"
]);
// TODO: Use `error?.code` when targeting Node.js 14
$dd3057ce36414b67$exports = (error)=>!$dd3057ce36414b67$var$denyList.has(error && error.code);


function $a489a0800c277305$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $a489a0800c277305$var$_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $a489a0800c277305$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $a489a0800c277305$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function $a489a0800c277305$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a489a0800c277305$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $a489a0800c277305$var$ownKeys(Object(source), true).forEach(function(key) {
            $a489a0800c277305$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $a489a0800c277305$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a489a0800c277305$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $a489a0800c277305$export$76a88f7de6507443 = "axios-retry";
function $a489a0800c277305$export$476aa014e2fd89d5(error) {
    var CODE_EXCLUDE_LIST = [
        "ERR_CANCELED",
        "ECONNABORTED"
    ];
    return !error.response && Boolean(error.code) && // Prevents retrying cancelled requests
    !CODE_EXCLUDE_LIST.includes(error.code) && // Prevents retrying timed out & cancelled requests
    (0, (/*@__PURE__*/$parcel$interopDefault($dd3057ce36414b67$exports)))(error) // Prevents retrying unsafe errors
    ;
}
var $a489a0800c277305$var$SAFE_HTTP_METHODS = [
    "get",
    "head",
    "options"
];
var $a489a0800c277305$var$IDEMPOTENT_HTTP_METHODS = $a489a0800c277305$var$SAFE_HTTP_METHODS.concat([
    "put",
    "delete"
]);
function $a489a0800c277305$export$5f1dc21fa925930b(error) {
    return error.code !== "ECONNABORTED" && (!error.response || error.response.status >= 500 && error.response.status <= 599);
}
function $a489a0800c277305$export$693cf906fd8817e5(error) {
    if (!error.config) // Cannot determine if the request can be retried
    return false;
    return $a489a0800c277305$export$5f1dc21fa925930b(error) && $a489a0800c277305$var$SAFE_HTTP_METHODS.indexOf(error.config.method) !== -1;
}
function $a489a0800c277305$export$d26799ad4978234d(error) {
    if (!error.config) // Cannot determine if the request can be retried
    return false;
    return $a489a0800c277305$export$5f1dc21fa925930b(error) && $a489a0800c277305$var$IDEMPOTENT_HTTP_METHODS.indexOf(error.config.method) !== -1;
}
function $a489a0800c277305$export$606bf0a2b170eb2(error) {
    return $a489a0800c277305$export$476aa014e2fd89d5(error) || $a489a0800c277305$export$d26799ad4978234d(error);
}
/**
 * @return {number} - delay in milliseconds, always 0
 */ function $a489a0800c277305$var$noDelay() {
    return 0;
}
function $a489a0800c277305$export$ce2bf54576c66713() {
    var retryNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var error = arguments.length > 1 ? arguments[1] : undefined;
    var delayFactor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
    var delay = Math.pow(2, retryNumber) * delayFactor;
    var randomSum = delay * 0.2 * Math.random(); // 0-20% of the delay
    return delay + randomSum;
}
var $a489a0800c277305$export$93ca5d3f8675ae4c = {
    retries: 3,
    retryCondition: $a489a0800c277305$export$606bf0a2b170eb2,
    retryDelay: $a489a0800c277305$var$noDelay,
    shouldResetTimeout: false,
    onRetry: ()=>{}
};
/**
 * Returns the axios-retry options for the current request
 * @param  {AxiosRequestConfig} config
 * @param  {IAxiosRetryConfig} defaultOptions
 * @return {IAxiosRetryConfigExtended}
 */ function $a489a0800c277305$var$getRequestOptions(config, defaultOptions) {
    return $a489a0800c277305$var$_objectSpread($a489a0800c277305$var$_objectSpread($a489a0800c277305$var$_objectSpread({}, $a489a0800c277305$export$93ca5d3f8675ae4c), defaultOptions), config[$a489a0800c277305$export$76a88f7de6507443]);
}
/**
 * Initializes and returns the retry state for the given request/config
 * @param  {AxiosRequestConfig} config
 * @param  {IAxiosRetryConfig} defaultOptions
 * @return {IAxiosRetryConfigExtended}
 */ function $a489a0800c277305$var$getCurrentState(config, defaultOptions) {
    var currentState = $a489a0800c277305$var$getRequestOptions(config, defaultOptions);
    currentState.retryCount = currentState.retryCount || 0;
    config[$a489a0800c277305$export$76a88f7de6507443] = currentState;
    return currentState;
}
/**
 * @param  {Axios} axios
 * @param  {AxiosRequestConfig} config
 */ function $a489a0800c277305$var$fixConfig(axios, config) {
    if (axios.defaults.agent === config.agent) delete config.agent;
    if (axios.defaults.httpAgent === config.httpAgent) delete config.httpAgent;
    if (axios.defaults.httpsAgent === config.httpsAgent) delete config.httpsAgent;
}
/**
 * Checks retryCondition if request can be retried. Handles it's returning value or Promise.
 * @param  {IAxiosRetryConfigExtended} currentState
 * @param  {Error} error
 * @return {Promise<boolean>}
 */ function $a489a0800c277305$var$shouldRetry(_x, _x2) {
    return $a489a0800c277305$var$_shouldRetry.apply(this, arguments);
}
/**
 * Adds response interceptors to an axios instance to retry requests failed due to network issues
 *
 * @example
 *
 * import axios from 'axios';
 *
 * axiosRetry(axios, { retries: 3 });
 *
 * axios.get('http://example.com/test') // The first request fails and the second returns 'ok'
 *   .then(result => {
 *     result.data; // 'ok'
 *   });
 *
 * // Exponential back-off retry delay between requests
 * axiosRetry(axios, { retryDelay : axiosRetry.exponentialDelay});
 *
 * // Custom retry delay
 * axiosRetry(axios, { retryDelay : (retryCount) => {
 *   return retryCount * 1000;
 * }});
 *
 * // Also works with custom axios instances
 * const client = axios.create({ baseURL: 'http://example.com' });
 * axiosRetry(client, { retries: 3 });
 *
 * client.get('/test') // The first request fails and the second returns 'ok'
 *   .then(result => {
 *     result.data; // 'ok'
 *   });
 *
 * // Allows request-specific configuration
 * client
 *   .get('/test', {
 *     'axios-retry': {
 *       retries: 0
 *     }
 *   })
 *   .catch(error => { // The first request fails
 *     error !== undefined
 *   });
 *
 * @param {Axios} axios An axios instance (the axios object or one created from axios.create)
 * @param {Object} [defaultOptions]
 * @param {number} [defaultOptions.retries=3] Number of retries
 * @param {boolean} [defaultOptions.shouldResetTimeout=false]
 *        Defines if the timeout should be reset between retries
 * @param {Function} [defaultOptions.retryCondition=isNetworkOrIdempotentRequestError]
 *        A function to determine if the error can be retried
 * @param {Function} [defaultOptions.retryDelay=noDelay]
 *        A function to determine the delay between retry requests
 * @param {Function} [defaultOptions.onRetry=()=>{}]
 *        A function to get notified when a retry occurs
 * @return {{ requestInterceptorId: number, responseInterceptorId: number }}
 *        The ids of the interceptors added to the request and to the response (so they can be ejected at a later time)
 */ function $a489a0800c277305$var$_shouldRetry() {
    $a489a0800c277305$var$_shouldRetry = $a489a0800c277305$var$_asyncToGenerator(function*(currentState, error) {
        var { retries: retries, retryCondition: retryCondition } = currentState;
        var shouldRetryOrPromise = currentState.retryCount < retries && retryCondition(error); // This could be a promise
        if (typeof shouldRetryOrPromise === "object") try {
            var shouldRetryPromiseResult = yield shouldRetryOrPromise; // keep return true unless shouldRetryPromiseResult return false for compatibility
            return shouldRetryPromiseResult !== false;
        } catch (_err) {
            return false;
        }
        return shouldRetryOrPromise;
    });
    return $a489a0800c277305$var$_shouldRetry.apply(this, arguments);
}
function $a489a0800c277305$export$2e2bcd8739ae039(axios, defaultOptions) {
    var requestInterceptorId = axios.interceptors.request.use((config)=>{
        var currentState = $a489a0800c277305$var$getCurrentState(config, defaultOptions);
        currentState.lastRequestTime = Date.now();
        return config;
    });
    var responseInterceptorId = axios.interceptors.response.use(null, /*#__PURE__*/ function() {
        var _ref = $a489a0800c277305$var$_asyncToGenerator(function*(error) {
            var { config: config } = error; // If we have no information to retry the request
            if (!config) return Promise.reject(error);
            var currentState = $a489a0800c277305$var$getCurrentState(config, defaultOptions);
            if (yield $a489a0800c277305$var$shouldRetry(currentState, error)) {
                currentState.retryCount += 1;
                var { retryDelay: retryDelay, shouldResetTimeout: shouldResetTimeout, onRetry: onRetry } = currentState;
                var delay = retryDelay(currentState.retryCount, error); // Axios fails merging this configuration to the default configuration because it has an issue
                // with circular structures: https://github.com/mzabriskie/axios/issues/370
                $a489a0800c277305$var$fixConfig(axios, config);
                if (!shouldResetTimeout && config.timeout && currentState.lastRequestTime) {
                    var lastRequestDuration = Date.now() - currentState.lastRequestTime;
                    var timeout = config.timeout - lastRequestDuration - delay;
                    if (timeout <= 0) return Promise.reject(error);
                    config.timeout = timeout;
                }
                config.transformRequest = [
                    (data)=>data
                ];
                yield onRetry(currentState.retryCount, error, config);
                return new Promise((resolve)=>setTimeout(()=>resolve(axios(config)), delay));
            }
            return Promise.reject(error);
        });
        return function(_x3) {
            return _ref.apply(this, arguments);
        };
    }());
    return {
        requestInterceptorId: requestInterceptorId,
        responseInterceptorId: responseInterceptorId
    };
} // Compatibility with CommonJS
$a489a0800c277305$export$2e2bcd8739ae039.isNetworkError = $a489a0800c277305$export$476aa014e2fd89d5;
$a489a0800c277305$export$2e2bcd8739ae039.isSafeRequestError = $a489a0800c277305$export$693cf906fd8817e5;
$a489a0800c277305$export$2e2bcd8739ae039.isIdempotentRequestError = $a489a0800c277305$export$d26799ad4978234d;
$a489a0800c277305$export$2e2bcd8739ae039.isNetworkOrIdempotentRequestError = $a489a0800c277305$export$606bf0a2b170eb2;
$a489a0800c277305$export$2e2bcd8739ae039.exponentialDelay = $a489a0800c277305$export$ce2bf54576c66713;
$a489a0800c277305$export$2e2bcd8739ae039.isRetryableError = $a489a0800c277305$export$5f1dc21fa925930b;



var $c9wMV = parcelRequire("c9wMV");
const $acad5245990092ac$var$QueryClient = async (chainId, restUrls, opts)=>{
    const config = (0, (/*@__PURE__*/$parcel$interopDefault($c9wMV))).merge({
        connectTimeout: 10000
    }, opts);
    const restUrl = await findAvailableUrl(restUrls, "rest", {
        timeout: config.connectTimeout
    });
    function getAllValidators(pageSize, opts, pageCallback) {
        return getAllPages((nextKey)=>{
            return getValidators(pageSize, opts, nextKey);
        }, pageCallback).then((pages)=>{
            const validators = (0, (/*@__PURE__*/$parcel$interopDefault($c9wMV))).shuffle(pages.map((el)=>el.validators).flat());
            return validators.reduce((a, v)=>({
                    ...a,
                    [v.operator_address]: v
                }), {});
        });
    }
    function getValidators(pageSize, opts, nextKey) {
        opts = opts || {};
        const searchParams = new URLSearchParams();
        if (opts.status) searchParams.append("status", opts.status);
        if (pageSize) searchParams.append("pagination.limit", pageSize);
        if (nextKey) searchParams.append("pagination.key", nextKey);
        return (0, (/*@__PURE__*/$parcel$interopDefault($18d826a12788a23d$exports))).get(apiUrl("staking", `validators?${searchParams.toString()}`), {
            timeout: opts.timeout || 10000
        }).then((res)=>res.data);
    }
    function getAllValidatorDelegations(validatorAddress, pageSize, opts, pageCallback) {
        return getAllPages((nextKey)=>{
            return getValidatorDelegations(validatorAddress, pageSize, opts, nextKey);
        }, pageCallback).then((pages)=>{
            return pages.map((el)=>el.delegation_responses).flat();
        });
    }
    function getValidatorDelegations(validatorAddress, pageSize, opts, nextKey) {
        const searchParams = new URLSearchParams();
        if (pageSize) searchParams.append("pagination.limit", pageSize);
        if (nextKey) searchParams.append("pagination.key", nextKey);
        return (0, (/*@__PURE__*/$parcel$interopDefault($18d826a12788a23d$exports))).get(apiUrl("staking", `validators/${validatorAddress}/delegations?${searchParams.toString()}`), opts).then((res)=>res.data);
    }
    function getBalance(address, denom, opts) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($18d826a12788a23d$exports))).get(apiUrl("bank", `balances/${address}`), opts).then((res)=>res.data).then((result)=>{
            var _result_balances;
            if (!denom) return result.balances;
            const balance = ((_result_balances = result.balances) === null || _result_balances === void 0 ? void 0 : _result_balances.find((element)=>element.denom === denom)) || {
                denom: denom,
                amount: 0
            };
            return balance;
        });
    }
    function getDelegations(address) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($18d826a12788a23d$exports))).get(apiUrl("staking", `delegations/${address}`)).then((res)=>res.data).then((result)=>{
            const delegations = result.delegation_responses.reduce((a, v)=>({
                    ...a,
                    [v.delegation.validator_address]: v
                }), {});
            return delegations;
        });
    }
    function getRewards(address, opts) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($18d826a12788a23d$exports))).get(apiUrl("distribution", `delegators/${address}/rewards`), opts).then((res)=>res.data).then((result)=>{
            const rewards = result.rewards.reduce((a, v)=>({
                    ...a,
                    [v.validator_address]: v
                }), {});
            return rewards;
        });
    }
    function getCommission(validatorAddress, opts) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($18d826a12788a23d$exports))).get(apiUrl("distribution", `validators/${validatorAddress}/commission`), opts).then((res)=>res.data).then((result)=>{
            return result.commission;
        });
    }
    function getProposals(opts) {
        const { pageSize: pageSize } = opts || {};
        return getAllPages((nextKey)=>{
            const searchParams = new URLSearchParams();
            searchParams.append("pagination.limit", pageSize || 100);
            if (nextKey) searchParams.append("pagination.key", nextKey);
            return (0, (/*@__PURE__*/$parcel$interopDefault($18d826a12788a23d$exports))).get(apiUrl("gov", `proposals?${searchParams.toString()}`), opts).then((res)=>res.data);
        }).then((pages)=>{
            return pages.map((el)=>el.proposals).flat();
        });
    }
    function getProposalTally(proposal_id, opts) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($18d826a12788a23d$exports))).get(apiUrl("gov", `proposals/${proposal_id}/tally`), opts).then((res)=>res.data);
    }
    function getProposalVote(proposal_id, address, opts) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($18d826a12788a23d$exports))).get(apiUrl("gov", `proposals/${proposal_id}/votes/${address}`), opts).then((res)=>res.data);
    }
    function getGranteeGrants(grantee, opts, pageCallback) {
        const { pageSize: pageSize } = opts || {};
        return getAllPages((nextKey)=>{
            const searchParams = new URLSearchParams();
            searchParams.append("pagination.limit", pageSize || 100);
            if (nextKey) searchParams.append("pagination.key", nextKey);
            return (0, (/*@__PURE__*/$parcel$interopDefault($18d826a12788a23d$exports))).get(apiUrl("authz", `grants/grantee/${grantee}?${searchParams.toString()}`), opts).then((res)=>res.data);
        }, pageCallback).then((pages)=>{
            return pages.map((el)=>el.grants).flat();
        });
    }
    function getGranterGrants(granter, opts, pageCallback) {
        const { pageSize: pageSize } = opts || {};
        return getAllPages((nextKey)=>{
            const searchParams = new URLSearchParams();
            searchParams.append("pagination.limit", pageSize || 100);
            if (nextKey) searchParams.append("pagination.key", nextKey);
            return (0, (/*@__PURE__*/$parcel$interopDefault($18d826a12788a23d$exports))).get(apiUrl("authz", `grants/granter/${granter}?${searchParams.toString()}`), opts).then((res)=>res.data);
        }, pageCallback).then((pages)=>{
            return pages.map((el)=>el.grants).flat();
        });
    }
    function getGrants(grantee, granter, opts) {
        const searchParams = new URLSearchParams();
        if (grantee) searchParams.append("grantee", grantee);
        if (granter) searchParams.append("granter", granter);
        return (0, (/*@__PURE__*/$parcel$interopDefault($18d826a12788a23d$exports))).get(apiUrl("authz", `grants?${searchParams.toString()}`), opts).then((res)=>res.data).then((result)=>{
            return result.grants;
        });
    }
    function getWithdrawAddress(address, opts) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($18d826a12788a23d$exports))).get(apiUrl("distribution", `delegators/${address}/withdraw_address`)).then((res)=>res.data).then((result)=>{
            return result.withdraw_address;
        });
    }
    function getTransactions(params, _opts) {
        const { pageSize: pageSize, order: order, retries: retries, ...opts } = _opts;
        const searchParams = new URLSearchParams();
        params.forEach(({ key: key, value: value })=>{
            searchParams.append(key, value);
        });
        if (pageSize) searchParams.append("pagination.limit", pageSize);
        if (order) searchParams.append("order_by", order);
        const client = (0, (/*@__PURE__*/$parcel$interopDefault($18d826a12788a23d$exports))).create({
            baseURL: restUrl
        });
        (0, $a489a0800c277305$export$2e2bcd8739ae039)(client, {
            retries: retries || 0,
            shouldResetTimeout: true,
            retryCondition: (e)=>true
        });
        return client.get(apiPath("tx", `txs?${searchParams.toString()}`), opts).then((res)=>res.data);
    }
    async function getAllPages(getPage, pageCallback) {
        let pages = [];
        let nextKey, error;
        do {
            var _result_pagination;
            const result = await getPage(nextKey);
            pages.push(result);
            nextKey = (_result_pagination = result.pagination) === null || _result_pagination === void 0 ? void 0 : _result_pagination.next_key;
            if (pageCallback) await pageCallback(pages);
        }while (nextKey);
        return pages;
    }
    async function findAvailableUrl(urls, type, opts) {
        if (!urls) return;
        if (!Array.isArray(urls)) {
            if (urls.match("cosmos.directory")) return urls // cosmos.directory health checks already
            ;
            else urls = [
                urls
            ];
        }
        const path = type === "rest" ? apiPath("/base/tendermint", "blocks/latest") : "/block";
        return Promise.any(urls.map(async (url)=>{
            url = url.replace(/\/$/, "");
            try {
                var _data_block_header, _data_block;
                let data = await getLatestBlock(url, type, path, opts);
                if (type === "rpc") data = data.result;
                if (((_data_block = data.block) === null || _data_block === void 0 ? void 0 : (_data_block_header = _data_block.header) === null || _data_block_header === void 0 ? void 0 : _data_block_header.chain_id) === chainId) return url;
            } catch  {}
        }));
    }
    async function getLatestBlock(url, type, path, opts) {
        const { timeout: timeout } = opts || {};
        try {
            return await (0, (/*@__PURE__*/$parcel$interopDefault($18d826a12788a23d$exports))).get(url + path, {
                timeout: timeout
            }).then((res)=>res.data);
        } catch (error) {
            var _error_response;
            const fallback = type === "rest" && "/blocks/latest";
            if (fallback && fallback !== path && ((_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.status) === 501) return getLatestBlock(url, type, fallback, opts);
            throw error;
        }
    }
    function apiUrl(type, path) {
        return restUrl + apiPath(type, path);
    }
    function apiPath(type, path) {
        const versions = config.apiVersions || {};
        const version = versions[type] || "v1beta1";
        return `/cosmos/${type}/${version}/${path}`;
    }
    return {
        connected: !!restUrl,
        restUrl: restUrl,
        getAllValidators: getAllValidators,
        getValidators: getValidators,
        getAllValidatorDelegations: getAllValidatorDelegations,
        getValidatorDelegations: getValidatorDelegations,
        getBalance: getBalance,
        getDelegations: getDelegations,
        getRewards: getRewards,
        getCommission: getCommission,
        getProposals: getProposals,
        getProposalTally: getProposalTally,
        getProposalVote: getProposalVote,
        getGrants: getGrants,
        getGranteeGrants: getGranteeGrants,
        getGranterGrants: getGranterGrants,
        getWithdrawAddress: getWithdrawAddress,
        getTransactions: getTransactions
    };
};
var $acad5245990092ac$export$2e2bcd8739ae039 = $acad5245990092ac$var$QueryClient;



var $5zb9p = parcelRequire("5zb9p");
const $19dc38683859cbfa$var$Validator = (network, data)=>{
    var _data_slashes;
    const address = data.operator_address;
    const { delegations: delegations } = data;
    const totalSlashes = (_data_slashes = data.slashes) === null || _data_slashes === void 0 ? void 0 : _data_slashes.length;
    const blockPeriod = data.missed_blocks_periods && data.missed_blocks_periods.slice(-1)[0];
    const uptime = (blockPeriod === null || blockPeriod === void 0 ? void 0 : blockPeriod.blocks) && (blockPeriod.blocks - blockPeriod.missed) / blockPeriod.blocks;
    const missedBlocks = blockPeriod === null || blockPeriod === void 0 ? void 0 : blockPeriod.missed;
    const totalTokens = delegations === null || delegations === void 0 ? void 0 : delegations.total_tokens_display;
    const totalUsd = delegations === null || delegations === void 0 ? void 0 : delegations.total_usd;
    const totalUsers = delegations === null || delegations === void 0 ? void 0 : delegations.total_count;
    const commissionRate = data.commission.commission_rates.rate;
    function isValidatorOperator(address) {
        if (!address || !window.atob) return false;
        const prefix = network.prefix;
        const validatorOperator = (0, $5zb9p.Bech32).encode(prefix, (0, $5zb9p.Bech32).decode(data.operator_address).data);
        return validatorOperator === address;
    }
    function getAPR() {
        if (!data.active) return 0;
        else return network.chain.estimatedApr * (1 - commissionRate);
    }
    function getAPY(operator) {
        const apr = getAPR();
        if (!apr) return 0;
        const periodPerYear = operator && network.chain.authzSupport ? operator.runsPerDay(network.data.maxPerDay) * 365 : 1;
        return (1 + apr / periodPerYear) ** periodPerYear - 1;
    }
    return {
        ...data,
        address: address,
        commissionRate: commissionRate,
        totalTokens: totalTokens,
        totalUsd: totalUsd,
        totalUsers: totalUsers,
        totalSlashes: totalSlashes,
        uptime: uptime,
        missedBlocks: missedBlocks,
        isValidatorOperator: isValidatorOperator,
        getAPR: getAPR,
        getAPY: getAPY
    };
};
var $19dc38683859cbfa$export$2e2bcd8739ae039 = $19dc38683859cbfa$var$Validator;



var $2KWqD = parcelRequire("2KWqD");
let $9fe350d0491bbfca$var$durationRE = /(-?(?:\d+\.?\d*|\d*\.?\d+)(?:e[-+]?\d+)?)\s*([\p{L}]*)/uig;
/**
 * conversion ratios
 */ $9fe350d0491bbfca$var$parse.nanosecond = $9fe350d0491bbfca$var$parse.ns = 1 / 1e6;
$9fe350d0491bbfca$var$parse["\xb5s"] = $9fe350d0491bbfca$var$parse["\u03BCs"] = $9fe350d0491bbfca$var$parse.us = $9fe350d0491bbfca$var$parse.microsecond = 0.001;
$9fe350d0491bbfca$var$parse.millisecond = $9fe350d0491bbfca$var$parse.ms = $9fe350d0491bbfca$var$parse[""] = 1;
$9fe350d0491bbfca$var$parse.second = $9fe350d0491bbfca$var$parse.sec = $9fe350d0491bbfca$var$parse.s = $9fe350d0491bbfca$var$parse.ms * 1000;
$9fe350d0491bbfca$var$parse.minute = $9fe350d0491bbfca$var$parse.min = $9fe350d0491bbfca$var$parse.m = $9fe350d0491bbfca$var$parse.s * 60;
$9fe350d0491bbfca$var$parse.hour = $9fe350d0491bbfca$var$parse.hr = $9fe350d0491bbfca$var$parse.h = $9fe350d0491bbfca$var$parse.m * 60;
$9fe350d0491bbfca$var$parse.day = $9fe350d0491bbfca$var$parse.d = $9fe350d0491bbfca$var$parse.h * 24;
$9fe350d0491bbfca$var$parse.week = $9fe350d0491bbfca$var$parse.wk = $9fe350d0491bbfca$var$parse.w = $9fe350d0491bbfca$var$parse.d * 7;
$9fe350d0491bbfca$var$parse.month = $9fe350d0491bbfca$var$parse.b = $9fe350d0491bbfca$var$parse.d * 30.4375;
$9fe350d0491bbfca$var$parse.year = $9fe350d0491bbfca$var$parse.yr = $9fe350d0491bbfca$var$parse.y = $9fe350d0491bbfca$var$parse.d * 365.25;
/**
 * convert `str` to ms
 *
 * @param {String} str
 * @param {String} format
 * @return {Number}
 */ function $9fe350d0491bbfca$var$parse(str = "", format = "ms") {
    var result = null;
    // ignore commas/placeholders
    str = (str + "").replace(/(\d)[,_](\d)/g, "$1$2");
    var isNegative = str[0] === "-";
    str.replace($9fe350d0491bbfca$var$durationRE, function(_, n, units) {
        units = $9fe350d0491bbfca$var$unitRatio(units);
        if (units) result = (result || 0) + Math.abs(parseFloat(n, 10)) * units;
    });
    return result && result / ($9fe350d0491bbfca$var$unitRatio(format) || 1) * (isNegative ? -1 : 1);
}
function $9fe350d0491bbfca$var$unitRatio(str) {
    return $9fe350d0491bbfca$var$parse[str] || $9fe350d0491bbfca$var$parse[str.toLowerCase().replace(/s$/, "")];
}
var $9fe350d0491bbfca$export$2e2bcd8739ae039 = $9fe350d0491bbfca$var$parse;



var $c9wMV = parcelRequire("c9wMV");
const $73281e074eb928de$var$Operator = (network, data)=>{
    var _data_description;
    const { address: address } = data;
    const botAddress = data.restake.address;
    let runTime = data.restake.run_time;
    runTime = runTime && Array.isArray(runTime) ? runTime : [
        runTime === null || runTime === void 0 ? void 0 : runTime.split(",")
    ].flat();
    const minimumReward = data.restake.minimum_reward;
    function missedRunCount(lastExec) {
        if (lastExec === false) return 9999;
        let count = 0;
        let times = runTimes().reverse();
        let date = times[0];
        while(date && date.isAfter(lastExec)){
            times.forEach((time)=>{
                if (time.isBefore() && time.isAfter(lastExec)) count++;
            });
            times = runTimes(date.subtract(1, "day").startOf("day")).reverse();
            date = times[0];
        }
        return count;
    }
    function isInterval() {
        return runTime.length === 1 && runTime[0].startsWith("every");
    }
    function runTimes(start) {
        if (!runTime) return [];
        start = start || (0, (/*@__PURE__*/$parcel$interopDefault($2KWqD)))().startOf("day");
        return (0, (/*@__PURE__*/$parcel$interopDefault($c9wMV))).compact(runTime.map((time)=>{
            if (time.startsWith("every")) {
                let date = start.clone();
                const interval = (0, $9fe350d0491bbfca$export$2e2bcd8739ae039)(time.replace("every ", ""));
                if (!interval) return;
                return [
                    ...Array(Math.floor((0, $9fe350d0491bbfca$export$2e2bcd8739ae039)("1d") / interval))
                ].map((_, i)=>{
                    let current = date.clone();
                    date.add(interval, "ms");
                    return current;
                });
            } else {
                let date = start.clone();
                let [hours, minutes, seconds] = time.split(":");
                if (parseInt(hours) >= 24) hours = 0;
                date.utc(true).add({
                    hours: hours,
                    minutes: minutes,
                    seconds: seconds
                });
                return date;
            }
        }).flat()).sort((a, b)=>a.valueOf() - b.valueOf());
    }
    function runsPerDay(max) {
        let runs = runTimes().length;
        return max && runs > max ? max : runs;
    }
    function runTimesString() {
        if (!isInterval()) {
            if (runTime.length > 1) return `at ${runTime.join(", ")}`;
            else return `at ${runTime.join(", ")} every day`;
        }
        return runTime.join(", ");
    }
    function frequency(includeEvery) {
        if (runTime.length > 1 && !isInterval()) return runTime.length + "x daily";
        else {
            if (isInterval()) return includeEvery ? runTime[0] : runTime[0].replace("every ", "");
            return "daily";
        }
    }
    function nextRun() {
        const today = runTimes();
        const tomorrow = runTimes((0, (/*@__PURE__*/$parcel$interopDefault($2KWqD)))().startOf("day").add(1, "day"));
        return [
            ...today,
            ...tomorrow
        ].find((el)=>el.isAfter());
    }
    return {
        address: address,
        botAddress: botAddress,
        runTime: runTime,
        minimumReward: minimumReward,
        moniker: (_data_description = data.description) === null || _data_description === void 0 ? void 0 : _data_description.moniker,
        description: data.description,
        data: data,
        nextRun: nextRun,
        frequency: frequency,
        runTimes: runTimes,
        runTimesString: runTimesString,
        runsPerDay: runsPerDay,
        missedRunCount: missedRunCount
    };
};
var $73281e074eb928de$export$2e2bcd8739ae039 = $73281e074eb928de$var$Operator;


/**
 * Compare [semver](https://semver.org/) version strings to find greater, equal or lesser.
 * This library supports the full semver specification, including comparing versions with different number of digits like `1.0.0`, `1.0`, `1`, and pre-release versions like `1.0.0-alpha`.
 * @param v1 - First version to compare
 * @param v2 - Second version to compare
 * @returns Numeric value compatible with the [Array.sort(fn) interface](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort#Parameters).
 */ const $1dd4b4fedd5b4fb7$export$66e1c0999abad646 = (v1, v2)=>{
    // validate input and split into segments
    const n1 = $1dd4b4fedd5b4fb7$var$validateAndParse(v1);
    const n2 = $1dd4b4fedd5b4fb7$var$validateAndParse(v2);
    // pop off the patch
    const p1 = n1.pop();
    const p2 = n2.pop();
    // validate numbers
    const r = $1dd4b4fedd5b4fb7$var$compareSegments(n1, n2);
    if (r !== 0) return r;
    // validate pre-release
    if (p1 && p2) return $1dd4b4fedd5b4fb7$var$compareSegments(p1.split("."), p2.split("."));
    else if (p1 || p2) return p1 ? -1 : 1;
    return 0;
};
const $1dd4b4fedd5b4fb7$export$a22775fa5e2eebd9 = (version)=>typeof version === "string" && /^[v\d]/.test(version) && $1dd4b4fedd5b4fb7$var$semver.test(version);
const $1dd4b4fedd5b4fb7$export$398604a469f7de9a = (v1, v2, operator)=>{
    // validate input operator
    $1dd4b4fedd5b4fb7$var$assertValidOperator(operator);
    // since result of compareVersions can only be -1 or 0 or 1
    // a simple map can be used to replace switch
    const res = $1dd4b4fedd5b4fb7$export$66e1c0999abad646(v1, v2);
    return $1dd4b4fedd5b4fb7$var$operatorResMap[operator].includes(res);
};
const $1dd4b4fedd5b4fb7$export$b8fab89fe6d5d7da = (version, range)=>{
    // if no range operator then "="
    const m = range.match(/^([<>=~^]+)/);
    const op = m ? m[1] : "=";
    // if gt/lt/eq then operator compare
    if (op !== "^" && op !== "~") return $1dd4b4fedd5b4fb7$export$398604a469f7de9a(version, range, op);
    // else range of either "~" or "^" is assumed
    const [v1, v2, v3, , vp] = $1dd4b4fedd5b4fb7$var$validateAndParse(version);
    const [r1, r2, r3, , rp] = $1dd4b4fedd5b4fb7$var$validateAndParse(range);
    const v = [
        v1,
        v2,
        v3
    ];
    const r = [
        r1,
        r2 !== null && r2 !== void 0 ? r2 : "x",
        r3 !== null && r3 !== void 0 ? r3 : "x"
    ];
    // validate pre-release
    if (rp) {
        if (!vp) return false;
        if ($1dd4b4fedd5b4fb7$var$compareSegments(v, r) !== 0) return false;
        if ($1dd4b4fedd5b4fb7$var$compareSegments(vp.split("."), rp.split(".")) === -1) return false;
    }
    // first non-zero number
    const nonZero = r.findIndex((v)=>v !== "0") + 1;
    // pointer to where segments can be >=
    const i = op === "~" ? 2 : nonZero > 1 ? nonZero : 1;
    // before pointer must be equal
    if ($1dd4b4fedd5b4fb7$var$compareSegments(v.slice(0, i), r.slice(0, i)) !== 0) return false;
    // after pointer must be >=
    if ($1dd4b4fedd5b4fb7$var$compareSegments(v.slice(i), r.slice(i)) === -1) return false;
    return true;
};
const $1dd4b4fedd5b4fb7$var$semver = /^[v^~<>=]*?(\d+)(?:\.([x*]|\d+)(?:\.([x*]|\d+)(?:\.([x*]|\d+))?(?:-([\da-z\-]+(?:\.[\da-z\-]+)*))?(?:\+[\da-z\-]+(?:\.[\da-z\-]+)*)?)?)?$/i;
const $1dd4b4fedd5b4fb7$var$validateAndParse = (version)=>{
    if (typeof version !== "string") throw new TypeError("Invalid argument expected string");
    const match = version.match($1dd4b4fedd5b4fb7$var$semver);
    if (!match) throw new Error(`Invalid argument not valid semver ('${version}' received)`);
    match.shift();
    return match;
};
const $1dd4b4fedd5b4fb7$var$isWildcard = (s)=>s === "*" || s === "x" || s === "X";
const $1dd4b4fedd5b4fb7$var$tryParse = (v)=>{
    const n = parseInt(v, 10);
    return isNaN(n) ? v : n;
};
const $1dd4b4fedd5b4fb7$var$forceType = (a, b)=>typeof a !== typeof b ? [
        String(a),
        String(b)
    ] : [
        a,
        b
    ];
const $1dd4b4fedd5b4fb7$var$compareStrings = (a, b)=>{
    if ($1dd4b4fedd5b4fb7$var$isWildcard(a) || $1dd4b4fedd5b4fb7$var$isWildcard(b)) return 0;
    const [ap, bp] = $1dd4b4fedd5b4fb7$var$forceType($1dd4b4fedd5b4fb7$var$tryParse(a), $1dd4b4fedd5b4fb7$var$tryParse(b));
    if (ap > bp) return 1;
    if (ap < bp) return -1;
    return 0;
};
const $1dd4b4fedd5b4fb7$var$compareSegments = (a, b)=>{
    for(let i = 0; i < Math.max(a.length, b.length); i++){
        const r = $1dd4b4fedd5b4fb7$var$compareStrings(a[i] || "0", b[i] || "0");
        if (r !== 0) return r;
    }
    return 0;
};
const $1dd4b4fedd5b4fb7$var$operatorResMap = {
    ">": [
        1
    ],
    ">=": [
        0,
        1
    ],
    "=": [
        0
    ],
    "<=": [
        -1,
        0
    ],
    "<": [
        -1
    ]
};
const $1dd4b4fedd5b4fb7$var$allowedOperators = Object.keys($1dd4b4fedd5b4fb7$var$operatorResMap);
const $1dd4b4fedd5b4fb7$var$assertValidOperator = (op)=>{
    if (typeof op !== "string") throw new TypeError(`Invalid operator type, expected string but got ${typeof op}`);
    if ($1dd4b4fedd5b4fb7$var$allowedOperators.indexOf(op) === -1) throw new Error(`Invalid operator, expected one of ${$1dd4b4fedd5b4fb7$var$allowedOperators.join("|")}`);
};


function $24ca8b3f69fe785b$var$ChainAsset(data) {
    const { symbol: symbol, base: base, display: display, image: image } = data;
    var _display_exponent;
    const decimals = (_display_exponent = display === null || display === void 0 ? void 0 : display.exponent) !== null && _display_exponent !== void 0 ? _display_exponent : 6;
    return {
        ...data,
        symbol: symbol,
        base: base,
        display: display,
        decimals: decimals,
        image: image
    };
}
var $24ca8b3f69fe785b$export$2e2bcd8739ae039 = $24ca8b3f69fe785b$var$ChainAsset;


const $2aa44fc0f61c63b7$var$Chain = (data)=>{
    var _data_assets, _data_params, _data_params1, _baseAsset_base, _baseAsset_display;
    const assets = ((_data_assets = data.assets) === null || _data_assets === void 0 ? void 0 : _data_assets.map((el)=>(0, $24ca8b3f69fe785b$export$2e2bcd8739ae039)(el))) || [];
    const baseAsset = assets[0];
    const { cosmos_sdk_version: cosmos_sdk_version } = data.versions || {};
    const slip44 = data.slip44 || 118;
    var _data_ledgerSupport;
    const ledgerSupport = (_data_ledgerSupport = data.ledgerSupport) !== null && _data_ledgerSupport !== void 0 ? _data_ledgerSupport : slip44 !== 60 // no ethereum ledger support for now
    ;
    const sdk46OrLater = (0, $1dd4b4fedd5b4fb7$export$a22775fa5e2eebd9)(cosmos_sdk_version) && (0, $1dd4b4fedd5b4fb7$export$66e1c0999abad646)(cosmos_sdk_version, "0.46") >= 0;
    const sdkAuthzAminoSupport = sdk46OrLater;
    var _data_authzSupport;
    const authzSupport = (_data_authzSupport = data.authzSupport) !== null && _data_authzSupport !== void 0 ? _data_authzSupport : (_data_params = data.params) === null || _data_params === void 0 ? void 0 : _data_params.authz;
    var _data_authzAminoSupport;
    const authzAminoSupport = (_data_authzAminoSupport = data.authzAminoSupport) !== null && _data_authzAminoSupport !== void 0 ? _data_authzAminoSupport : true;
    var _data_authzAminoGenericOnly;
    const authzAminoGenericOnly = authzAminoSupport && ((_data_authzAminoGenericOnly = data.authzAminoGenericOnly) !== null && _data_authzAminoGenericOnly !== void 0 ? _data_authzAminoGenericOnly : !sdkAuthzAminoSupport);
    var _data_authzAminoLiftedValues;
    const authzAminoLiftedValues = authzAminoSupport && ((_data_authzAminoLiftedValues = data.authzAminoLiftedValues) !== null && _data_authzAminoLiftedValues !== void 0 ? _data_authzAminoLiftedValues : authzAminoGenericOnly);
    const authzAminoExecPreventTypes = data.authzAminoExecPreventTypes || [];
    const apiVersions = {
        gov: sdk46OrLater ? "v1" : "v1beta1",
        ...data.apiVersions || {}
    };
    return {
        ...data,
        prettyName: data.prettyName || data.pretty_name,
        chainId: data.chainId || data.chain_id,
        prefix: data.prefix || data.bech32_prefix,
        slip44: slip44,
        estimatedApr: (_data_params1 = data.params) === null || _data_params1 === void 0 ? void 0 : _data_params1.calculated_apr,
        ledgerSupport: ledgerSupport,
        authzSupport: authzSupport,
        authzAminoSupport: authzAminoSupport,
        authzAminoGenericOnly: authzAminoGenericOnly,
        authzAminoLiftedValues: authzAminoLiftedValues,
        authzAminoExecPreventTypes: authzAminoExecPreventTypes,
        apiVersions: apiVersions,
        denom: data.denom || (baseAsset === null || baseAsset === void 0 ? void 0 : (_baseAsset_base = baseAsset.base) === null || _baseAsset_base === void 0 ? void 0 : _baseAsset_base.denom),
        display: data.display || (baseAsset === null || baseAsset === void 0 ? void 0 : (_baseAsset_display = baseAsset.display) === null || _baseAsset_display === void 0 ? void 0 : _baseAsset_display.denom),
        symbol: data.symbol || (baseAsset === null || baseAsset === void 0 ? void 0 : baseAsset.symbol),
        decimals: data.decimals || (baseAsset === null || baseAsset === void 0 ? void 0 : baseAsset.decimals),
        image: data.image || (baseAsset === null || baseAsset === void 0 ? void 0 : baseAsset.image),
        coinGeckoId: baseAsset === null || baseAsset === void 0 ? void 0 : baseAsset.coingecko_id,
        assets: assets,
        baseAsset: baseAsset
    };
};
var $2aa44fc0f61c63b7$export$2e2bcd8739ae039 = $2aa44fc0f61c63b7$var$Chain;



function $490ed7ae18117c88$var$CosmosDirectory(testnet) {
    const protocol = "https";
    const mainnetDomain = "cosmos.directory";
    const testnetDomain = "testcosmos.directory";
    const domain = testnet ? testnetDomain : mainnetDomain;
    const rpcBase = `${protocol}://rpc.${domain}`;
    const restBase = `${protocol}://rest.${domain}`;
    const chainsUrl = `${protocol}://chains.${domain}`;
    const validatorsUrl = `${protocol}://validators.${domain}`;
    function rpcUrl(name) {
        return rpcBase + "/" + name;
    }
    function restUrl(name) {
        return restBase + "/" + name;
    }
    function getChains() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($18d826a12788a23d$exports))).get(chainsUrl).then((res)=>res.data).then((data)=>Array.isArray(data) ? data : data.chains) // deprecate
        .then((data)=>data.reduce((a, v)=>({
                    ...a,
                    [v.path]: v
                }), {}));
    }
    function getChainData(name) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($18d826a12788a23d$exports))).get([
            chainsUrl,
            name
        ].join("/")).then((res)=>res.data.chain);
    }
    async function getTokenData(name) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($18d826a12788a23d$exports))).get([
            chainsUrl,
            name,
            "assetlist"
        ].join("/")).then((res)=>res.data);
    }
    function getValidators(chainName) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($18d826a12788a23d$exports))).get(validatorsUrl + "/chains/" + chainName).then((res)=>res.data.validators);
    }
    function getRegistryValidator(validatorName) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($18d826a12788a23d$exports))).get(validatorsUrl + "/" + validatorName).then((res)=>res.data.validator);
    }
    function getOperatorAddresses() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($18d826a12788a23d$exports))).get(validatorsUrl).then((res)=>res.data).then((data)=>Array.isArray(data) ? data : data.validators) // deprecate
        .then((data)=>data.reduce((sum, validator)=>{
                validator.chains.forEach((chain)=>{
                    sum[chain.name] = sum[chain.name] || {};
                    if (chain.restake) sum[chain.name][chain.address] = chain.restake;
                }, {});
                return sum;
            }, {}));
    }
    return {
        testnet: testnet,
        domain: domain,
        rpcUrl: rpcUrl,
        restUrl: restUrl,
        getChains: getChains,
        getChainData: getChainData,
        getTokenData: getTokenData,
        getValidators: getValidators,
        getRegistryValidator: getRegistryValidator,
        getOperatorAddresses: getOperatorAddresses
    };
}
var $490ed7ae18117c88$export$2e2bcd8739ae039 = $490ed7ae18117c88$var$CosmosDirectory;


class $d07b3fb94219a1b2$var$Network {
    connectedDirectory() {
        const proxy_status = this.chain ? this.chain["proxy_status"] : this.data["proxy_status"];
        return proxy_status && [
            "rest"
        ].every((type)=>proxy_status[type]);
    }
    estimateOperatorCount() {
        if (!this.operatorAddresses) return 0;
        return Object.keys(this.operatorAddresses).filter((el)=>this.allowOperator(el)).length;
    }
    allowOperator(address) {
        const allow = this.data.allowOperators;
        const block = this.data.blockOperators;
        if (allow && !allow.includes(address)) return false;
        if (block && block.includes(address)) return false;
        return true;
    }
    async load() {
        const chainData = await this.directory.getChainData(this.data.name);
        this.setChain({
            ...this.data,
            ...chainData
        });
        this.validators = (await this.directory.getValidators(this.name)).map((data)=>{
            return (0, $19dc38683859cbfa$export$2e2bcd8739ae039)(this, data);
        });
        this.operators = (this.data.operators || this.validators.filter((el)=>el.restake && this.allowOperator(el.operator_address))).map((data)=>{
            return (0, $73281e074eb928de$export$2e2bcd8739ae039)(this, data);
        });
        this.operatorCount = this.operators.length;
    }
    async setChain(data) {
        var _this_chain_fees_fee_tokens, _this_chain_fees;
        this.chain = (0, $2aa44fc0f61c63b7$export$2e2bcd8739ae039)(data);
        this.prettyName = this.chain.prettyName;
        this.chainId = this.chain.chainId;
        this.prefix = this.chain.prefix;
        this.slip44 = this.chain.slip44;
        this.assets = this.chain.assets;
        this.baseAsset = this.chain.baseAsset;
        this.denom = this.chain.denom;
        this.display = this.chain.display;
        this.symbol = this.chain.symbol;
        this.decimals = this.chain.decimals;
        this.image = this.chain.image;
        this.coinGeckoId = this.chain.coinGeckoId;
        this.estimatedApr = this.chain.estimatedApr;
        this.apyEnabled = data.apyEnabled !== false && !!this.estimatedApr && this.estimatedApr > 0;
        var _this_chain_ledgerSupport;
        this.ledgerSupport = (_this_chain_ledgerSupport = this.chain.ledgerSupport) !== null && _this_chain_ledgerSupport !== void 0 ? _this_chain_ledgerSupport : true;
        this.authzSupport = this.chain.authzSupport;
        this.authzAminoSupport = this.chain.authzAminoSupport;
        this.authzAminoGenericOnly = this.chain.authzAminoGenericOnly;
        this.authzAminoLiftedValues = this.chain.authzAminoLiftedValues;
        this.authzAminoExecPreventTypes = this.chain.authzAminoExecPreventTypes;
        this.txTimeout = this.data.txTimeout || 60000;
        this.keywords = this.buildKeywords();
        const feeConfig = (_this_chain_fees = this.chain.fees) === null || _this_chain_fees === void 0 ? void 0 : (_this_chain_fees_fee_tokens = _this_chain_fees.fee_tokens) === null || _this_chain_fees_fee_tokens === void 0 ? void 0 : _this_chain_fees_fee_tokens.find((el)=>el.denom === this.denom);
        let gasPrice;
        if (this.data.gasPrice) {
            gasPrice = (0, $ed89d4c20b089b73$export$98e628dec113755e)((0, $842e3ecb6082807a$exports.GasPrice).fromString(this.data.gasPrice).amount.toString());
            var _feeConfig_average_gas_price, _feeConfig_high_gas_price;
            this.gasPriceStep = this.data.gasPriceStep || {
                "low": gasPrice,
                "average": (_feeConfig_average_gas_price = feeConfig === null || feeConfig === void 0 ? void 0 : feeConfig.average_gas_price) !== null && _feeConfig_average_gas_price !== void 0 ? _feeConfig_average_gas_price : gasPrice,
                "high": (_feeConfig_high_gas_price = feeConfig === null || feeConfig === void 0 ? void 0 : feeConfig.high_gas_price) !== null && _feeConfig_high_gas_price !== void 0 ? _feeConfig_high_gas_price : (0, $ed89d4c20b089b73$export$2060d2db72cce88f)(gasPrice, 2)
            };
        } else {
            var _feeConfig_low_gas_price;
            const minimumGasPrice = (_feeConfig_low_gas_price = feeConfig === null || feeConfig === void 0 ? void 0 : feeConfig.low_gas_price) !== null && _feeConfig_low_gas_price !== void 0 ? _feeConfig_low_gas_price : feeConfig === null || feeConfig === void 0 ? void 0 : feeConfig.fixed_min_gas_price;
            let defaultGasPrice = (0, $ed89d4c20b089b73$export$98e628dec113755e)((0, $ed89d4c20b089b73$export$d9468344d3651243)((0, $ed89d4c20b089b73$export$8576f72eb7f14a7e)((0, $ed89d4c20b089b73$export$2060d2db72cce88f)(0.000000025, (0, $ed89d4c20b089b73$export$9c297f60e22e3389)(10, this.decimals || 6))), {
                precision: 14
            }));
            if (minimumGasPrice != undefined && (0, $ed89d4c20b089b73$export$a94a7414fa942aea)(minimumGasPrice, defaultGasPrice)) defaultGasPrice = minimumGasPrice;
            var _feeConfig_average_gas_price1;
            gasPrice = (_feeConfig_average_gas_price1 = feeConfig === null || feeConfig === void 0 ? void 0 : feeConfig.average_gas_price) !== null && _feeConfig_average_gas_price1 !== void 0 ? _feeConfig_average_gas_price1 : defaultGasPrice;
            var _feeConfig_high_gas_price1;
            this.gasPriceStep = this.data.gasPriceStep || {
                "low": minimumGasPrice !== null && minimumGasPrice !== void 0 ? minimumGasPrice : (0, $ed89d4c20b089b73$export$2060d2db72cce88f)(gasPrice, 0.5),
                "average": gasPrice,
                "high": (_feeConfig_high_gas_price1 = feeConfig === null || feeConfig === void 0 ? void 0 : feeConfig.high_gas_price) !== null && _feeConfig_high_gas_price1 !== void 0 ? _feeConfig_high_gas_price1 : (0, $ed89d4c20b089b73$export$2060d2db72cce88f)(gasPrice, 2)
            };
        }
        this.gasPrice = gasPrice + this.denom;
        this.gasModifier = this.data.gasModifier || 1.5;
    }
    async connect(opts) {
        try {
            this.queryClient = await (0, $acad5245990092ac$export$2e2bcd8739ae039)(this.chain.chainId, this.restUrl, {
                connectTimeout: opts === null || opts === void 0 ? void 0 : opts.timeout,
                apiVersions: this.chain.apiVersions
            });
            this.restUrl = this.queryClient.restUrl;
            this.connected = this.queryClient.connected && (!this.usingDirectory || this.connectedDirectory());
        } catch (error) {
            console.log(error);
            this.connected = false;
        }
    }
    async getApy(validators, operators) {
        let validatorApy = {};
        for (const [address, validator] of Object.entries(validators)){
            const operator = operators.find((el)=>el.address === address);
            validatorApy[address] = validator.getAPY(operator);
        }
        return validatorApy;
    }
    getOperator(operatorAddress) {
        return this.operators.find((elem)=>elem.address === operatorAddress);
    }
    getOperatorByBotAddress(botAddress) {
        return this.operators.find((elem)=>elem.botAddress === botAddress);
    }
    getOperators() {
        return this.sortOperators();
    }
    sortOperators() {
        const random = (0, (/*@__PURE__*/$parcel$interopDefault($c9wMV))).shuffle(this.operators);
        if (this.data.ownerAddress) return (0, (/*@__PURE__*/$parcel$interopDefault($c9wMV))).sortBy(random, ({ address: address })=>address === this.data.ownerAddress ? 0 : 1);
        return random;
    }
    getValidators(opts) {
        opts = opts || {};
        return (this.validators || []).filter((validator)=>{
            if (opts.status) return validator.status === opts.status;
            return true;
        }).reduce((a, v)=>({
                ...a,
                [v.operator_address]: v
            }), {});
    }
    buildKeywords() {
        var _this_chain;
        return (0, (/*@__PURE__*/$parcel$interopDefault($c9wMV))).compact([
            ...((_this_chain = this.chain) === null || _this_chain === void 0 ? void 0 : _this_chain.keywords) || [],
            this.authzSupport && "authz",
            this.authzAminoSupport && "full authz ledger"
        ]);
    }
    constructor(data, operatorAddresses){
        var _data_operators;
        this.data = data;
        this.enabled = data.enabled;
        this.experimental = data.experimental;
        this.operatorAddresses = operatorAddresses || {};
        this.operatorCount = ((_data_operators = data.operators) === null || _data_operators === void 0 ? void 0 : _data_operators.length) || this.estimateOperatorCount();
        this.name = data.path || data.name;
        this.path = data.path || data.name;
        this.image = data.image;
        this.prettyName = data.prettyName || data.pretty_name;
        this.default = data.default;
        this.testnet = data.testnet || data.network_type === "testnet";
        this.setChain(this.data);
        this.directory = (0, $490ed7ae18117c88$export$2e2bcd8739ae039)(this.testnet);
        this.rpcUrl = this.directory.rpcUrl(this.name) // only used for Keplr suggestChain
        ;
        this.restUrl = data.restUrl || this.directory.restUrl(this.name);
        this.usingDirectory = !![
            this.restUrl
        ].find((el)=>{
            const match = (el)=>el.match("cosmos.directory");
            if (Array.isArray(el)) return el.find(match);
            else return match(el);
        });
        this.online = !this.usingDirectory || this.connectedDirectory();
    }
}
var $d07b3fb94219a1b2$export$2e2bcd8739ae039 = $d07b3fb94219a1b2$var$Network;







var $6cds3 = parcelRequire("6cds3");

var $c9wMV = parcelRequire("c9wMV");


var $6cds3 = parcelRequire("6cds3");
var $4f9f942c686c93eb$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = "";
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") return arg;
        if (typeof arg !== "object") return "";
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
        var classes = "";
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + " " + newClass;
        return value + newClass;
    }
    if (0, $4f9f942c686c93eb$exports) {
        classNames.default = classNames;
        $4f9f942c686c93eb$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $6cds3 = parcelRequire("6cds3");
function $9c3c5e85872c2b24$export$2e2bcd8739ae039() {
    $9c3c5e85872c2b24$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9c3c5e85872c2b24$export$2e2bcd8739ae039.apply(this, arguments);
}


function $6204ff68428e4ae4$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var $6cds3 = parcelRequire("6cds3");
var $5bef91bad9982985$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $5bef91bad9982985$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$5bef91bad9982985$exports = $5bef91bad9982985$var$invariant;


var $f41bc34c5b654f11$var$noop = function noop() {};
function $f41bc34c5b654f11$var$readOnlyPropType(handler, name) {
    return function(props, propName) {
        if (props[propName] !== undefined) {
            if (!props[handler]) return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + $f41bc34c5b654f11$export$26cbf8c37e721e67(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
        }
    };
}
function $f41bc34c5b654f11$export$8abd944bed26e726(controlledValues, displayName) {
    var propTypes = {};
    Object.keys(controlledValues).forEach(function(prop) {
        // add default propTypes for folks that use runtime checks
        propTypes[$f41bc34c5b654f11$export$26cbf8c37e721e67(prop)] = $f41bc34c5b654f11$var$noop;
        var handler;
    });
    return propTypes;
}
function $f41bc34c5b654f11$export$12ae2baa35bd9b8b(props, prop) {
    return props[prop] !== undefined;
}
function $f41bc34c5b654f11$export$26cbf8c37e721e67(key) {
    return "default" + key.charAt(0).toUpperCase() + key.substr(1);
}
function $f41bc34c5b654f11$export$95e5b18573b29087(component) {
    return !!component && (typeof component !== "function" || component.prototype && component.prototype.isReactComponent);
}


function $ebeccf058174fd37$var$_toPropertyKey(arg) {
    var key = $ebeccf058174fd37$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $ebeccf058174fd37$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $ebeccf058174fd37$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    var wasPropRef = (0, $6cds3.useRef)(propValue !== undefined);
    var _useState = (0, $6cds3.useState)(defaultValue), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $6cds3.useCallback)(function(value) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            if (handler) handler.apply(void 0, [
                value
            ].concat(args));
            setState(value);
        }, [
            handler
        ])
    ];
}
function $ebeccf058174fd37$export$2e2bcd8739ae039(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _extends2;
        var _ref = result, defaultValue = _ref[$f41bc34c5b654f11$export$26cbf8c37e721e67(fieldName)], propsValue = _ref[fieldName], rest = (0, $6204ff68428e4ae4$export$2e2bcd8739ae039)(_ref, [
            $f41bc34c5b654f11$export$26cbf8c37e721e67(fieldName),
            fieldName
        ].map($ebeccf058174fd37$var$_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = $ebeccf058174fd37$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        return (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
    }, props);
}




function $50859a28edac1620$export$2e2bcd8739ae039(o, p) {
    $50859a28edac1620$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $50859a28edac1620$export$2e2bcd8739ae039(o, p);
}


function $dfde6adacd9b015f$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $50859a28edac1620$export$2e2bcd8739ae039)(subClass, superClass);
}



var $6cds3 = parcelRequire("6cds3");
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $223d4890b03ba6bc$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $223d4890b03ba6bc$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $223d4890b03ba6bc$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$223d4890b03ba6bc$var$componentWillMount.__suppressDeprecationWarning = true;
$223d4890b03ba6bc$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$223d4890b03ba6bc$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $223d4890b03ba6bc$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error("Can only polyfill class components");
    if (typeof Component.getDerivedStateFromProps !== "function" && typeof prototype.getSnapshotBeforeUpdate !== "function") return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === "function") foundWillMountName = "componentWillMount";
    else if (typeof prototype.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
    if (typeof prototype.componentWillReceiveProps === "function") foundWillReceivePropsName = "componentWillReceiveProps";
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
    if (typeof prototype.componentWillUpdate === "function") foundWillUpdateName = "componentWillUpdate";
    else if (typeof prototype.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
        throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + componentName + " uses " + newApiName + " but also contains the following legacy lifecycles:" + (foundWillMountName !== null ? "\n  " + foundWillMountName : "") + (foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "") + (foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\n" + "https://fb.me/react-async-component-lifecycle-hooks");
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === "function") {
        prototype.componentWillMount = $223d4890b03ba6bc$var$componentWillMount;
        prototype.componentWillReceiveProps = $223d4890b03ba6bc$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === "function") {
        if (typeof prototype.componentDidUpdate !== "function") throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
        prototype.componentWillUpdate = $223d4890b03ba6bc$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}




var $e181104069ce8d89$var$_jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";
function $e181104069ce8d89$export$2e2bcd8739ae039(Component, controlledValues, methods) {
    if (methods === void 0) methods = [];
    var displayName = Component.displayName || Component.name || "Component";
    var canAcceptRef = $f41bc34c5b654f11$export$95e5b18573b29087(Component);
    var controlledProps = Object.keys(controlledValues);
    var PROPS_TO_OMIT = controlledProps.map($f41bc34c5b654f11$export$26cbf8c37e721e67);
    !(canAcceptRef || !methods.length) && (0, (/*@__PURE__*/$parcel$interopDefault($5bef91bad9982985$exports)))(false);
    var UncontrolledComponent = /*#__PURE__*/ function(_React$Component) {
        (0, $dfde6adacd9b015f$export$2e2bcd8739ae039)(UncontrolledComponent, _React$Component);
        function UncontrolledComponent() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.handlers = Object.create(null);
            controlledProps.forEach(function(propName) {
                var handlerName = controlledValues[propName];
                var handleChange = function handleChange(value) {
                    if (_this.props[handlerName]) {
                        var _this$props;
                        _this._notifying = true;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        (_this$props = _this.props)[handlerName].apply(_this$props, [
                            value
                        ].concat(args));
                        _this._notifying = false;
                    }
                    if (!_this.unmounted) _this.setState(function(_ref) {
                        var _extends2;
                        var values = _ref.values;
                        return {
                            values: (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
                        };
                    });
                };
                _this.handlers[handlerName] = handleChange;
            });
            if (methods.length) _this.attachRef = function(ref) {
                _this.inner = ref;
            };
            var values = Object.create(null);
            controlledProps.forEach(function(key) {
                values[key] = _this.props[$f41bc34c5b654f11$export$26cbf8c37e721e67(key)];
            });
            _this.state = {
                values: values,
                prevProps: {}
            };
            return _this;
        }
        var _proto = UncontrolledComponent.prototype;
        _proto.shouldComponentUpdate = function shouldComponentUpdate() {
            //let setState trigger the update
            return !this._notifying;
        };
        UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
            var values = _ref2.values, prevProps = _ref2.prevProps;
            var nextState = {
                values: (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)(Object.create(null), values),
                prevProps: {}
            };
            controlledProps.forEach(function(key) {
                /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */ nextState.prevProps[key] = props[key];
                if (!$f41bc34c5b654f11$export$12ae2baa35bd9b8b(props, key) && $f41bc34c5b654f11$export$12ae2baa35bd9b8b(prevProps, key)) nextState.values[key] = props[$f41bc34c5b654f11$export$26cbf8c37e721e67(key)];
            });
            return nextState;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.unmounted = true;
        };
        _proto.render = function render() {
            var _this2 = this;
            var _this$props2 = this.props, innerRef = _this$props2.innerRef, props = (0, $6204ff68428e4ae4$export$2e2bcd8739ae039)(_this$props2, [
                "innerRef"
            ]);
            PROPS_TO_OMIT.forEach(function(prop) {
                delete props[prop];
            });
            var newProps = {};
            controlledProps.forEach(function(propName) {
                var propValue = _this2.props[propName];
                newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement(Component, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, props, newProps, this.handlers, {
                ref: innerRef || this.attachRef
            }));
        };
        return UncontrolledComponent;
    }((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Component);
    (0, $223d4890b03ba6bc$export$cea1c58a6db52bca)(UncontrolledComponent);
    UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
    UncontrolledComponent.propTypes = (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({
        innerRef: function innerRef() {}
    }, $f41bc34c5b654f11$export$8abd944bed26e726(controlledValues, displayName));
    methods.forEach(function(method) {
        UncontrolledComponent.prototype[method] = function $proxiedMethod() {
            var _this$inner;
            return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
        };
    });
    var WrappedComponent = UncontrolledComponent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).forwardRef) {
        WrappedComponent = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).forwardRef(function(props, ref) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement(UncontrolledComponent, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, props, {
                innerRef: ref,
                __source: {
                    fileName: $e181104069ce8d89$var$_jsxFileName,
                    lineNumber: 128
                },
                __self: this
            }));
        });
        WrappedComponent.propTypes = UncontrolledComponent.propTypes;
    }
    WrappedComponent.ControlledComponent = Component;
    /**
   * useful when wrapping a Component and you want to control
   * everything
   */ WrappedComponent.deferControlTo = function(newComponent, additions, nextMethods) {
        if (additions === void 0) additions = {};
        return $e181104069ce8d89$export$2e2bcd8739ae039(newComponent, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, controlledValues, additions), nextMethods);
    };
    return WrappedComponent;
}





var $6cds3 = parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $a95735966e1ddc82$var$useCommittedRef(value) {
    const ref = (0, $6cds3.useRef)(value);
    (0, $6cds3.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $a95735966e1ddc82$export$2e2bcd8739ae039 = $a95735966e1ddc82$var$useCommittedRef;


function $cfbeaaf7204fcb02$export$2e2bcd8739ae039(fn) {
    const ref = (0, $a95735966e1ddc82$export$2e2bcd8739ae039)(fn);
    return (0, $6cds3.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}



var $6cds3 = parcelRequire("6cds3");

"use client";
const $c5d3aca6e909caf5$export$666ad80b5007f835 = [
    "xxl",
    "xl",
    "lg",
    "md",
    "sm",
    "xs"
];
const $c5d3aca6e909caf5$export$ff817e17bad2e091 = "xs";
const $c5d3aca6e909caf5$var$ThemeContext = /*#__PURE__*/ $6cds3.createContext({
    prefixes: {},
    breakpoints: $c5d3aca6e909caf5$export$666ad80b5007f835,
    minBreakpoint: $c5d3aca6e909caf5$export$ff817e17bad2e091
});
const { Consumer: $c5d3aca6e909caf5$export$b631efc24e9d5e2f, Provider: $c5d3aca6e909caf5$var$Provider } = $c5d3aca6e909caf5$var$ThemeContext;
function $c5d3aca6e909caf5$var$ThemeProvider({ prefixes: prefixes = {}, breakpoints: breakpoints = $c5d3aca6e909caf5$export$666ad80b5007f835, minBreakpoint: minBreakpoint = $c5d3aca6e909caf5$export$ff817e17bad2e091, dir: dir, children: children }) {
    const contextValue = (0, $6cds3.useMemo)(()=>({
            prefixes: {
                ...prefixes
            },
            breakpoints: breakpoints,
            minBreakpoint: minBreakpoint,
            dir: dir
        }), [
        prefixes,
        breakpoints,
        minBreakpoint,
        dir
    ]);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($c5d3aca6e909caf5$var$Provider, {
        value: contextValue,
        children: children
    });
}
function $c5d3aca6e909caf5$export$7f387860ebffb32c(prefix, defaultPrefix) {
    const { prefixes: prefixes } = (0, $6cds3.useContext)($c5d3aca6e909caf5$var$ThemeContext);
    return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function $c5d3aca6e909caf5$export$8970c8db816a5863() {
    const { breakpoints: breakpoints } = (0, $6cds3.useContext)($c5d3aca6e909caf5$var$ThemeContext);
    return breakpoints;
}
function $c5d3aca6e909caf5$export$d926d6ef38f3fd32() {
    const { minBreakpoint: minBreakpoint } = (0, $6cds3.useContext)($c5d3aca6e909caf5$var$ThemeContext);
    return minBreakpoint;
}
function $c5d3aca6e909caf5$export$35e511eefa30ac5a() {
    const { dir: dir } = (0, $6cds3.useContext)($c5d3aca6e909caf5$var$ThemeContext);
    return dir === "rtl";
}
function $c5d3aca6e909caf5$export$ce75053c20498f85(Component, opts) {
    if (typeof opts === "string") opts = {
        prefix: opts
    };
    const isClassy = Component.prototype && Component.prototype.isReactComponent;
    // If it's a functional component make sure we don't break it with a ref
    const { prefix: prefix, forwardRefAs: forwardRefAs = isClassy ? "ref" : "innerRef" } = opts;
    const Wrapped = /*#__PURE__*/ $6cds3.forwardRef(({ ...props }, ref)=>{
        props[forwardRefAs] = ref;
        const bsPrefix = $c5d3aca6e909caf5$export$7f387860ebffb32c(props.bsPrefix, prefix);
        return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
            ...props,
            bsPrefix: bsPrefix
        });
    });
    Wrapped.displayName = `Bootstrap(${Component.displayName || Component.name})`;
    return Wrapped;
}
var $c5d3aca6e909caf5$export$2e2bcd8739ae039 = $c5d3aca6e909caf5$var$ThemeProvider;



var $6cds3 = parcelRequire("6cds3");



var $6cds3 = parcelRequire("6cds3");


var $4209f4cdd547894e$export$2e2bcd8739ae039 = (className)=>/*#__PURE__*/ $6cds3.forwardRef((p, ref)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
            ...p,
            ref: ref,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(p.className, className)
        }));



"use client";
const $fca72bed1e552cab$var$DivStyledAsH4 = (0, $4209f4cdd547894e$export$2e2bcd8739ae039)("h4");
$fca72bed1e552cab$var$DivStyledAsH4.displayName = "DivStyledAsH4";
const $fca72bed1e552cab$var$AlertHeading = /*#__PURE__*/ $6cds3.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $fca72bed1e552cab$var$DivStyledAsH4, ...props }, ref)=>{
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "alert-heading");
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, bsPrefix),
        ...props
    });
});
$fca72bed1e552cab$var$AlertHeading.displayName = "AlertHeading";
var $fca72bed1e552cab$export$2e2bcd8739ae039 = $fca72bed1e552cab$var$AlertHeading;



var $6cds3 = parcelRequire("6cds3");


var $6cds3 = parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");
function $6c24397ccd0ea65a$export$2e2bcd8739ae039() {
    return (0, $6cds3.useState)(null);
}





var $6cds3 = parcelRequire("6cds3");

function $d3bd603bbc88b0d1$export$2e2bcd8739ae039(eventTarget, event, listener, capture = false) {
    const handler = (0, $cfbeaaf7204fcb02$export$2e2bcd8739ae039)(listener);
    (0, $6cds3.useEffect)(()=>{
        const target = typeof eventTarget === "function" ? eventTarget() : eventTarget;
        target.addEventListener(event, handler, capture);
        return ()=>target.removeEventListener(event, handler, capture);
    }, [
        eventTarget
    ]);
}




var $6cds3 = parcelRequire("6cds3");
function $422b1d42d20df3b4$export$2e2bcd8739ae039(event, handler, capture = false) {
    const documentTarget = (0, $6cds3.useCallback)(()=>document, []);
    return (0, $d3bd603bbc88b0d1$export$2e2bcd8739ae039)(documentTarget, event, handler, capture);
}



var $6cds3 = parcelRequire("6cds3");

/**
 * Creates a `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  function Timer() {
 *    const [timer, setTimer] = useState(0)
 *    useInterval(() => setTimer(i => i + 1), 1000)
 *
 *    return <span>{timer} seconds past</span>
 *  }
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 */ /**
 * Creates a pausable `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [paused, setPaused] = useState(false)
 *  const [timer, setTimer] = useState(0)
 *
 *  useInterval(() => setTimer(i => i + 1), 1000, paused)
 *
 *  return (
 *    <span>
 *      {timer} seconds past
 *
 *      <button onClick={() => setPaused(p => !p)}>{paused ? 'Play' : 'Pause' }</button>
 *    </span>
 * )
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 */ /**
 * Creates a pausable `setInterval` that _fires_ immediately and is
 * properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [timer, setTimer] = useState(-1)
 *  useInterval(() => setTimer(i => i + 1), 1000, false, true)
 *
 *  // will update to 0 on the first effect
 *  return <span>{timer} seconds past</span>
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 * @param runImmediately Whether to run the function immediately on mount or unpause
 * rather than waiting for the first interval to elapse
 *

 */ function $38676cc6599a71bc$var$useInterval(fn, ms, paused = false, runImmediately = false) {
    let handle;
    const fnRef = (0, $a95735966e1ddc82$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $a95735966e1ddc82$export$2e2bcd8739ae039)(paused);
    const tick = ()=>{
        if (pausedRef.current) return;
        fnRef.current();
        schedule(); // eslint-disable-line no-use-before-define
    };
    const schedule = ()=>{
        clearTimeout(handle);
        handle = setTimeout(tick, ms);
    };
    (0, $6cds3.useEffect)(()=>{
        if (runImmediately) tick();
        else schedule();
        return ()=>clearTimeout(handle);
    }, [
        paused,
        runImmediately
    ]);
}
var $38676cc6599a71bc$export$2e2bcd8739ae039 = $38676cc6599a71bc$var$useInterval;



var $6cds3 = parcelRequire("6cds3");

function $8e337e7e61b12fba$var$useRafInterval(fn, ms, paused = false) {
    let handle;
    let start = new Date().getTime();
    const fnRef = (0, $a95735966e1ddc82$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $a95735966e1ddc82$export$2e2bcd8739ae039)(paused);
    function loop() {
        const current = new Date().getTime();
        const delta = current - start;
        if (pausedRef.current) return;
        if (delta >= ms && fnRef.current) {
            fnRef.current();
            start = new Date().getTime();
        }
        cancelAnimationFrame(handle);
        handle = requestAnimationFrame(loop);
    }
    (0, $6cds3.useEffect)(()=>{
        handle = requestAnimationFrame(loop);
        return ()=>cancelAnimationFrame(handle);
    }, []);
}
var $8e337e7e61b12fba$export$2e2bcd8739ae039 = $8e337e7e61b12fba$var$useRafInterval;



var $6cds3 = parcelRequire("6cds3");
function $f8af3ed06ade2471$export$2e2bcd8739ae039(initialState) {
    const [state, setState] = (0, $6cds3.useState)(initialState);
    const updater = (0, $6cds3.useCallback)((update)=>{
        if (update === null) return;
        if (typeof update === "function") setState((state)=>{
            const nextState = update(state);
            return nextState == null ? state : Object.assign({}, state, nextState);
        });
        else setState((state)=>Object.assign({}, state, update));
    }, [
        setState
    ]);
    return [
        state,
        updater
    ];
}



function $d1241ec1b37215cf$export$2e2bcd8739ae039(props, gDSFP, initialState) {
    const [state, setState] = (0, $f8af3ed06ade2471$export$2e2bcd8739ae039)(initialState);
    const nextState = gDSFP(props, state);
    if (nextState !== null) setState(nextState);
    return [
        state,
        setState
    ];
}



var $6cds3 = parcelRequire("6cds3");
function $316c1fef2af83f46$export$2e2bcd8739ae039() {
    const mounted = (0, $6cds3.useRef)(true);
    const isMounted = (0, $6cds3.useRef)(()=>mounted.current);
    (0, $6cds3.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}



var $6cds3 = parcelRequire("6cds3");
function $e9b4c74f20368aab$export$2e2bcd8739ae039(value) {
    const ref = (0, $6cds3.useRef)(null);
    (0, $6cds3.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
}



var $6cds3 = parcelRequire("6cds3");
function $b73c5cef85ed7244$export$2e2bcd8739ae039(imageOrUrl, crossOrigin) {
    const [state, setState] = (0, $6cds3.useState)({
        image: null,
        error: null
    });
    (0, $6cds3.useEffect)(()=>{
        if (!imageOrUrl) return undefined;
        let image;
        if (typeof imageOrUrl === "string") {
            image = new Image();
            if (crossOrigin) image.crossOrigin = crossOrigin;
            image.src = imageOrUrl;
        } else {
            image = imageOrUrl;
            if (image.complete && image.naturalHeight > 0) {
                setState({
                    image: image,
                    error: null
                });
                return;
            }
        }
        function onLoad() {
            setState({
                image: image,
                error: null
            });
        }
        function onError(error) {
            setState({
                image: image,
                error: error
            });
        }
        image.addEventListener("load", onLoad);
        image.addEventListener("error", onError);
        return ()=>{
            image.removeEventListener("load", onLoad);
            image.removeEventListener("error", onError);
        };
    }, [
        imageOrUrl,
        crossOrigin
    ]);
    return state;
}



var $6cds3 = parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");
const $ac9facc4976791bd$var$isReactNative = typeof $parcel$global !== "undefined" && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === "ReactNative";
const $ac9facc4976791bd$var$isDOM = typeof document !== "undefined";
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $ac9facc4976791bd$export$2e2bcd8739ae039 = $ac9facc4976791bd$var$isDOM || $ac9facc4976791bd$var$isReactNative ? (0, $6cds3.useLayoutEffect) : (0, $6cds3.useEffect);


const $3b1d2a9e26733369$var$targetMap = new WeakMap();
let $3b1d2a9e26733369$var$resizeObserver;
function $3b1d2a9e26733369$var$getResizeObserver() {
    // eslint-disable-next-line no-return-assign
    return $3b1d2a9e26733369$var$resizeObserver = $3b1d2a9e26733369$var$resizeObserver || new window.ResizeObserver((entries)=>{
        entries.forEach((entry)=>{
            const handler = $3b1d2a9e26733369$var$targetMap.get(entry.target);
            if (handler) handler(entry.contentRect);
        });
    });
}
function $3b1d2a9e26733369$export$2e2bcd8739ae039(element) {
    const [rect, setRect] = (0, $6cds3.useState)(null);
    (0, $ac9facc4976791bd$export$2e2bcd8739ae039)(()=>{
        if (!element) return;
        $3b1d2a9e26733369$var$getResizeObserver().observe(element);
        setRect(element.getBoundingClientRect());
        $3b1d2a9e26733369$var$targetMap.set(element, (rect)=>{
            setRect(rect);
        });
        return ()=>{
            $3b1d2a9e26733369$var$targetMap.delete(element);
        };
    }, [
        element
    ]);
    return rect;
}





var $6cds3 = parcelRequire("6cds3");

const $79267241913a4681$var$_excluded = [
    "as",
    "disabled"
];
function $79267241913a4681$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $79267241913a4681$export$72369ab2cc99204b(href) {
    return !href || href.trim() === "#";
}
function $79267241913a4681$export$a0ee72f2c720a5c3({ tagName: tagName, disabled: disabled, href: href, target: target, rel: rel, role: role, onClick: onClick, tabIndex: tabIndex = 0, type: type }) {
    if (!tagName) {
        if (href != null || target != null || rel != null) tagName = "a";
        else tagName = "button";
    }
    const meta = {
        tagName: tagName
    };
    if (tagName === "button") return [
        {
            type: type || "button",
            disabled: disabled
        },
        meta
    ];
    const handleClick = (event)=>{
        if (disabled || tagName === "a" && $79267241913a4681$export$72369ab2cc99204b(href)) event.preventDefault();
        if (disabled) {
            event.stopPropagation();
            return;
        }
        onClick == null || onClick(event);
    };
    const handleKeyDown = (event)=>{
        if (event.key === " ") {
            event.preventDefault();
            handleClick(event);
        }
    };
    if (tagName === "a") {
        // Ensure there's a href so Enter can trigger anchor button.
        href || (href = "#");
        if (disabled) href = undefined;
    }
    return [
        {
            role: role != null ? role : "button",
            // explicitly undefined so that it overrides the props disabled in a spread
            // e.g. <Tag {...props} {...hookProps} />
            disabled: undefined,
            tabIndex: disabled ? undefined : tabIndex,
            href: href,
            target: tagName === "a" ? target : undefined,
            "aria-disabled": !disabled ? undefined : disabled,
            rel: tagName === "a" ? rel : undefined,
            onClick: handleClick,
            onKeyDown: handleKeyDown
        },
        meta
    ];
}
const $79267241913a4681$var$Button = /*#__PURE__*/ $6cds3.forwardRef((_ref, ref)=>{
    let { as: asProp, disabled: disabled } = _ref, props = $79267241913a4681$var$_objectWithoutPropertiesLoose(_ref, $79267241913a4681$var$_excluded);
    const [buttonProps, { tagName: Component }] = $79267241913a4681$export$a0ee72f2c720a5c3(Object.assign({
        tagName: asProp,
        disabled: disabled
    }, props));
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, Object.assign({}, props, buttonProps, {
        ref: ref
    }));
});
$79267241913a4681$var$Button.displayName = "Button";
var $79267241913a4681$export$2e2bcd8739ae039 = $79267241913a4681$var$Button;



const $047dad24ed49ca20$var$_excluded = [
    "onKeyDown"
];
function $047dad24ed49ca20$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $047dad24ed49ca20$export$72369ab2cc99204b(href) {
    return !href || href.trim() === "#";
}
/**
 * An generic `<a>` component that covers a few A11y cases, ensuring that
 * cases where the `href` is missing or trivial like "#" are treated like buttons.
 */ const $047dad24ed49ca20$var$Anchor = /*#__PURE__*/ $6cds3.forwardRef((_ref, ref)=>{
    let { onKeyDown: onKeyDown } = _ref, props = $047dad24ed49ca20$var$_objectWithoutPropertiesLoose(_ref, $047dad24ed49ca20$var$_excluded);
    const [buttonProps] = (0, $79267241913a4681$export$a0ee72f2c720a5c3)(Object.assign({
        tagName: "a"
    }, props));
    const handleKeyDown = (0, $cfbeaaf7204fcb02$export$2e2bcd8739ae039)((e)=>{
        buttonProps.onKeyDown(e);
        onKeyDown == null || onKeyDown(e);
    });
    if ($047dad24ed49ca20$export$72369ab2cc99204b(props.href) || props.role === "button") return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", Object.assign({
        ref: ref
    }, props, buttonProps, {
        onKeyDown: handleKeyDown
    }));
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", Object.assign({
        ref: ref
    }, props, {
        onKeyDown: onKeyDown
    }));
});
$047dad24ed49ca20$var$Anchor.displayName = "Anchor";
var $047dad24ed49ca20$export$2e2bcd8739ae039 = $047dad24ed49ca20$var$Anchor;




"use client";
const $0d483073f10a0e20$var$AlertLink = /*#__PURE__*/ $6cds3.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = (0, $047dad24ed49ca20$export$2e2bcd8739ae039), ...props }, ref)=>{
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "alert-link");
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, bsPrefix),
        ...props
    });
});
$0d483073f10a0e20$var$AlertLink.displayName = "AlertLink";
var $0d483073f10a0e20$export$2e2bcd8739ae039 = $0d483073f10a0e20$var$AlertLink;




var $6cds3 = parcelRequire("6cds3");




var $6cds3 = parcelRequire("6cds3");

var $c6a0ec579ecacc40$export$2e2bcd8739ae039 = {
    disabled: false
};




var $6cds3 = parcelRequire("6cds3");
var $1314d46969e1885b$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createContext(null);


var $2dd67d835621c5d6$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $e4b1ba7c3a6ebf93$export$bb38bb9a1161268 = "unmounted";
var $e4b1ba7c3a6ebf93$export$84cbff306f539230 = "exited";
var $e4b1ba7c3a6ebf93$export$df38205c966be359 = "entering";
var $e4b1ba7c3a6ebf93$export$78e9e6e3e014d60a = "entered";
var $e4b1ba7c3a6ebf93$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $e4b1ba7c3a6ebf93$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $dfde6adacd9b015f$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $e4b1ba7c3a6ebf93$export$84cbff306f539230;
                _this.appearStatus = $e4b1ba7c3a6ebf93$export$df38205c966be359;
            } else initialStatus = $e4b1ba7c3a6ebf93$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $e4b1ba7c3a6ebf93$export$bb38bb9a1161268;
        else initialStatus = $e4b1ba7c3a6ebf93$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $e4b1ba7c3a6ebf93$export$bb38bb9a1161268) return {
            status: $e4b1ba7c3a6ebf93$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $e4b1ba7c3a6ebf93$export$df38205c966be359 && status !== $e4b1ba7c3a6ebf93$export$78e9e6e3e014d60a) nextStatus = $e4b1ba7c3a6ebf93$export$df38205c966be359;
            } else if (status === $e4b1ba7c3a6ebf93$export$df38205c966be359 || status === $e4b1ba7c3a6ebf93$export$78e9e6e3e014d60a) nextStatus = $e4b1ba7c3a6ebf93$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $e4b1ba7c3a6ebf93$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($6d4849ee44552f5f$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $2dd67d835621c5d6$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $e4b1ba7c3a6ebf93$export$84cbff306f539230) this.setState({
            status: $e4b1ba7c3a6ebf93$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($6d4849ee44552f5f$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $c6a0ec579ecacc40$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $e4b1ba7c3a6ebf93$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $e4b1ba7c3a6ebf93$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $e4b1ba7c3a6ebf93$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($6d4849ee44552f5f$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $c6a0ec579ecacc40$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $e4b1ba7c3a6ebf93$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $e4b1ba7c3a6ebf93$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $e4b1ba7c3a6ebf93$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($6d4849ee44552f5f$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $e4b1ba7c3a6ebf93$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $6204ff68428e4ae4$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement((0, $1314d46969e1885b$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Component);
$e4b1ba7c3a6ebf93$var$Transition.contextType = (0, $1314d46969e1885b$export$2e2bcd8739ae039);
$e4b1ba7c3a6ebf93$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $e4b1ba7c3a6ebf93$var$noop() {}
$e4b1ba7c3a6ebf93$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $e4b1ba7c3a6ebf93$var$noop,
    onEntering: $e4b1ba7c3a6ebf93$var$noop,
    onEntered: $e4b1ba7c3a6ebf93$var$noop,
    onExit: $e4b1ba7c3a6ebf93$var$noop,
    onExiting: $e4b1ba7c3a6ebf93$var$noop,
    onExited: $e4b1ba7c3a6ebf93$var$noop
};
$e4b1ba7c3a6ebf93$var$Transition.UNMOUNTED = $e4b1ba7c3a6ebf93$export$bb38bb9a1161268;
$e4b1ba7c3a6ebf93$var$Transition.EXITED = $e4b1ba7c3a6ebf93$export$84cbff306f539230;
$e4b1ba7c3a6ebf93$var$Transition.ENTERING = $e4b1ba7c3a6ebf93$export$df38205c966be359;
$e4b1ba7c3a6ebf93$var$Transition.ENTERED = $e4b1ba7c3a6ebf93$export$78e9e6e3e014d60a;
$e4b1ba7c3a6ebf93$var$Transition.EXITING = $e4b1ba7c3a6ebf93$export$4aacc83d4d59139f;
var $e4b1ba7c3a6ebf93$export$2e2bcd8739ae039 = $e4b1ba7c3a6ebf93$var$Transition;


/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ function $f52efbbd31c95236$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


function $c608827f7bfddae8$export$2e2bcd8739ae039(node) {
    var doc = (0, $f52efbbd31c95236$export$2e2bcd8739ae039)(node);
    return doc && doc.defaultView || window;
}


function $b1904b134be7a562$export$2e2bcd8739ae039(node, psuedoElement) {
    return (0, $c608827f7bfddae8$export$2e2bcd8739ae039)(node).getComputedStyle(node, psuedoElement);
}


/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ var $a8ce93d754d2efd9$var$rUpper = /([A-Z])/g;
function $a8ce93d754d2efd9$export$2e2bcd8739ae039(string) {
    return string.replace($a8ce93d754d2efd9$var$rUpper, "-$1").toLowerCase();
}


var $cf2746b7304edca4$var$msPattern = /^ms-/;
function $cf2746b7304edca4$export$2e2bcd8739ae039(string) {
    return (0, $a8ce93d754d2efd9$export$2e2bcd8739ae039)(string).replace($cf2746b7304edca4$var$msPattern, "-ms-");
}


var $0a0d5de0e654b589$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $0a0d5de0e654b589$export$2e2bcd8739ae039(value) {
    return !!(value && $0a0d5de0e654b589$var$supportedTransforms.test(value));
}


function $c70c5acd84b310f3$var$style(node, property) {
    var css = "";
    var transforms = "";
    if (typeof property === "string") return node.style.getPropertyValue((0, $cf2746b7304edca4$export$2e2bcd8739ae039)(property)) || (0, $b1904b134be7a562$export$2e2bcd8739ae039)(node).getPropertyValue((0, $cf2746b7304edca4$export$2e2bcd8739ae039)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, $cf2746b7304edca4$export$2e2bcd8739ae039)(key));
        else if ((0, $0a0d5de0e654b589$export$2e2bcd8739ae039)(key)) transforms += key + "(" + value + ") ";
        else css += (0, $cf2746b7304edca4$export$2e2bcd8739ae039)(key) + ": " + value + ";";
    });
    if (transforms) css += "transform: " + transforms + ";";
    node.style.cssText += ";" + css;
}
var $c70c5acd84b310f3$export$2e2bcd8739ae039 = $c70c5acd84b310f3$var$style;



/* eslint-disable no-return-assign */ var $72899b21b69d5129$export$2e2bcd8739ae039 = !!(typeof window !== "undefined" && window.document && window.document.createElement);


var $a0bafde1ed7798b0$export$63fefd044b2bc624 = false;
var $a0bafde1ed7798b0$export$a614c6b395900f69 = false;
try {
    var $a0bafde1ed7798b0$var$options = {
        get passive () {
            return $a0bafde1ed7798b0$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $a0bafde1ed7798b0$export$a614c6b395900f69 = $a0bafde1ed7798b0$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $72899b21b69d5129$export$2e2bcd8739ae039) {
        window.addEventListener("test", $a0bafde1ed7798b0$var$options, $a0bafde1ed7798b0$var$options);
        window.removeEventListener("test", $a0bafde1ed7798b0$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $a0bafde1ed7798b0$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== "boolean" && !$a0bafde1ed7798b0$export$a614c6b395900f69) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$a0bafde1ed7798b0$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $a0bafde1ed7798b0$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $a0bafde1ed7798b0$export$2e2bcd8739ae039 = $a0bafde1ed7798b0$var$addEventListener;


/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $7988376756273ef1$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== "boolean" ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $7988376756273ef1$export$2e2bcd8739ae039 = $7988376756273ef1$var$removeEventListener;


function $4ca9d7ffc3c5ea9f$var$listen(node, eventName, handler, options) {
    (0, $a0bafde1ed7798b0$export$2e2bcd8739ae039)(node, eventName, handler, options);
    return function() {
        (0, $7988376756273ef1$export$2e2bcd8739ae039)(node, eventName, handler, options);
    };
}
var $4ca9d7ffc3c5ea9f$export$2e2bcd8739ae039 = $4ca9d7ffc3c5ea9f$var$listen;


/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */ function $462a41759376e5ec$export$2e2bcd8739ae039(node, eventName, bubbles, cancelable) {
    if (bubbles === void 0) bubbles = false;
    if (cancelable === void 0) cancelable = true;
    if (node) {
        var event = document.createEvent("HTMLEvents");
        event.initEvent(eventName, bubbles, cancelable);
        node.dispatchEvent(event);
    }
}


function $ee3572b014b87ebd$var$parseDuration(node) {
    var str = (0, $c70c5acd84b310f3$export$2e2bcd8739ae039)(node, "transitionDuration") || "";
    var mult = str.indexOf("ms") === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $ee3572b014b87ebd$var$emulateTransitionEnd(element, duration, padding) {
    if (padding === void 0) padding = 5;
    var called = false;
    var handle = setTimeout(function() {
        if (!called) (0, $462a41759376e5ec$export$2e2bcd8739ae039)(element, "transitionend", true);
    }, duration + padding);
    var remove = (0, $4ca9d7ffc3c5ea9f$export$2e2bcd8739ae039)(element, "transitionend", function() {
        called = true;
    }, {
        once: true
    });
    return function() {
        clearTimeout(handle);
        remove();
    };
}
function $ee3572b014b87ebd$export$2e2bcd8739ae039(element, handler, duration, padding) {
    if (duration == null) duration = $ee3572b014b87ebd$var$parseDuration(element) || 0;
    var removeEmulate = $ee3572b014b87ebd$var$emulateTransitionEnd(element, duration, padding);
    var remove = (0, $4ca9d7ffc3c5ea9f$export$2e2bcd8739ae039)(element, "transitionend", handler);
    return function() {
        removeEmulate();
        remove();
    };
}


function $564ddf315628faa7$var$parseDuration(node, property) {
    const str = (0, $c70c5acd84b310f3$export$2e2bcd8739ae039)(node, property) || "";
    const mult = str.indexOf("ms") === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $564ddf315628faa7$export$2e2bcd8739ae039(element, handler) {
    const duration = $564ddf315628faa7$var$parseDuration(element, "transitionDuration");
    const delay = $564ddf315628faa7$var$parseDuration(element, "transitionDelay");
    const remove = (0, $ee3572b014b87ebd$export$2e2bcd8739ae039)(element, (e)=>{
        if (e.target === element) {
            remove();
            handler(e);
        }
    }, duration + delay);
}


// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function $19a9523538451f23$export$2e2bcd8739ae039(node) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    node.offsetHeight;
}



var $6cds3 = parcelRequire("6cds3");


var $6cds3 = parcelRequire("6cds3");
const $2921c5d455351cc0$var$toFnRef = (ref)=>!ref || typeof ref === "function" ? ref : (value)=>{
        ref.current = value;
    };
function $2921c5d455351cc0$export$c9058316764c140e(refA, refB) {
    const a = $2921c5d455351cc0$var$toFnRef(refA);
    const b = $2921c5d455351cc0$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $2921c5d455351cc0$var$useMergedRefs(refA, refB) {
    return (0, $6cds3.useMemo)(()=>$2921c5d455351cc0$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $2921c5d455351cc0$export$2e2bcd8739ae039 = $2921c5d455351cc0$var$useMergedRefs;



function $42088736fa8dcd8f$export$2e2bcd8739ae039(componentOrElement) {
    if (componentOrElement && "setState" in componentOrElement) return (0, (/*@__PURE__*/$parcel$interopDefault($6d4849ee44552f5f$exports))).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}



"use client";
// Normalizes Transition callbacks when nodeRef is used.
const $9bb091aefa5eb510$var$TransitionWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).forwardRef(({ onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children, childRef: childRef, ...props }, ref)=>{
    const nodeRef = (0, $6cds3.useRef)(null);
    const mergedRef = (0, $2921c5d455351cc0$export$2e2bcd8739ae039)(nodeRef, childRef);
    const attachRef = (r)=>{
        mergedRef((0, $42088736fa8dcd8f$export$2e2bcd8739ae039)(r));
    };
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    /* eslint-disable react-hooks/exhaustive-deps */ const handleEnter = (0, $6cds3.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $6cds3.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $6cds3.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $6cds3.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $6cds3.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $6cds3.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $6cds3.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e4b1ba7c3a6ebf93$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        children: typeof children === "function" ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, {
                ...innerProps,
                ref: attachRef
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).cloneElement(children, {
            ref: attachRef
        })
    });
});
var $9bb091aefa5eb510$export$2e2bcd8739ae039 = $9bb091aefa5eb510$var$TransitionWrapper;



const $9d1648789ad43db2$var$fadeStyles = {
    [(0, $e4b1ba7c3a6ebf93$export$df38205c966be359)]: "show",
    [(0, $e4b1ba7c3a6ebf93$export$78e9e6e3e014d60a)]: "show"
};
const $9d1648789ad43db2$var$Fade = /*#__PURE__*/ $6cds3.forwardRef(({ className: className, children: children, transitionClasses: transitionClasses = {}, onEnter: onEnter, ...rest }, ref)=>{
    const props = {
        in: false,
        timeout: 300,
        mountOnEnter: false,
        unmountOnExit: false,
        appear: false,
        ...rest
    };
    const handleEnter = (0, $6cds3.useCallback)((node, isAppearing)=>{
        (0, $19a9523538451f23$export$2e2bcd8739ae039)(node);
        onEnter == null || onEnter(node, isAppearing);
    }, [
        onEnter
    ]);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9bb091aefa5eb510$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $564ddf315628faa7$export$2e2bcd8739ae039),
        ...props,
        onEnter: handleEnter,
        childRef: children.ref,
        children: (status, innerProps)=>/*#__PURE__*/ $6cds3.cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))("fade", className, children.props.className, $9d1648789ad43db2$var$fadeStyles[status], transitionClasses[status])
            })
    });
});
$9d1648789ad43db2$var$Fade.displayName = "Fade";
var $9d1648789ad43db2$export$2e2bcd8739ae039 = $9d1648789ad43db2$var$Fade;



var $aMJGV = parcelRequire("aMJGV");

var $6cds3 = parcelRequire("6cds3");


const $0a4b69d94c7ec063$var$propTypes = {
    /** An accessible label indicating the relevant information about the Close Button. */ "aria-label": (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
    /** A callback fired after the Close Button is clicked. */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).func,
    /**
   * Render different color variant for the button.
   *
   * Omitting this will render the default dark color.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).oneOf([
        "white"
    ])
};
const $0a4b69d94c7ec063$var$CloseButton = /*#__PURE__*/ $6cds3.forwardRef(({ className: className, variant: variant, "aria-label": ariaLabel = "Close", ...props }, ref)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
        ref: ref,
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))("btn-close", variant && `btn-close-${variant}`, className),
        "aria-label": ariaLabel,
        ...props
    }));
$0a4b69d94c7ec063$var$CloseButton.displayName = "CloseButton";
$0a4b69d94c7ec063$var$CloseButton.propTypes = $0a4b69d94c7ec063$var$propTypes;
var $0a4b69d94c7ec063$export$2e2bcd8739ae039 = $0a4b69d94c7ec063$var$CloseButton;



"use client";
const $0e96a7241eeb31a8$var$Alert = /*#__PURE__*/ $6cds3.forwardRef((uncontrolledProps, ref)=>{
    const { bsPrefix: bsPrefix, show: show = true, closeLabel: closeLabel = "Close alert", closeVariant: closeVariant, className: className, children: children, variant: variant = "primary", onClose: onClose, dismissible: dismissible, transition: transition = (0, $9d1648789ad43db2$export$2e2bcd8739ae039), ...props } = (0, $ebeccf058174fd37$export$2e2bcd8739ae039)(uncontrolledProps, {
        show: "onClose"
    });
    const prefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "alert");
    const handleClose = (0, $cfbeaaf7204fcb02$export$2e2bcd8739ae039)((e)=>{
        if (onClose) onClose(false, e);
    });
    const Transition = transition === true ? (0, $9d1648789ad43db2$export$2e2bcd8739ae039) : transition;
    const alert = /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        role: "alert",
        ...!Transition ? props : undefined,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, prefix, variant && `${prefix}-${variant}`, dismissible && `${prefix}-dismissible`),
        children: [
            dismissible && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0a4b69d94c7ec063$export$2e2bcd8739ae039), {
                onClick: handleClose,
                "aria-label": closeLabel,
                variant: closeVariant
            }),
            children
        ]
    });
    if (!Transition) return show ? alert : null;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Transition, {
        unmountOnExit: true,
        ...props,
        ref: undefined,
        in: show,
        children: alert
    });
});
$0e96a7241eeb31a8$var$Alert.displayName = "Alert";
var $0e96a7241eeb31a8$export$2e2bcd8739ae039 = Object.assign($0e96a7241eeb31a8$var$Alert, {
    Link: (0, $0d483073f10a0e20$export$2e2bcd8739ae039),
    Heading: (0, $fca72bed1e552cab$export$2e2bcd8739ae039)
});


function $c9bd276a69168a44$var$AlertMessage(props) {
    const [show, setShow] = (0, $6cds3.useState)(false);
    const dismissible = props.dismissible === false ? false : true;
    (0, $6cds3.useEffect)(()=>{
        setShow(!!props.message || !!props.children);
    }, [
        props.message,
        props.children
    ]);
    function onClose() {
        setShow(false);
        props.onClose && props.onClose();
    }
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: show && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e96a7241eeb31a8$export$2e2bcd8739ae039), {
            className: `text-center ${props.className}`,
            variant: props.variant || "danger",
            onClose: onClose,
            dismissible: dismissible,
            children: props.message || props.children
        })
    });
}
var $c9bd276a69168a44$export$2e2bcd8739ae039 = $c9bd276a69168a44$var$AlertMessage;




var $6cds3 = parcelRequire("6cds3");


var $6cds3 = parcelRequire("6cds3");



"use client";
const $a73f5336dfd04f2d$var$Button = /*#__PURE__*/ $6cds3.forwardRef(({ as: as, bsPrefix: bsPrefix, variant: variant = "primary", size: size, active: active = false, disabled: disabled = false, className: className, ...props }, ref)=>{
    const prefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "btn");
    const [buttonProps, { tagName: tagName }] = (0, $79267241913a4681$export$a0ee72f2c720a5c3)({
        tagName: as,
        disabled: disabled,
        ...props
    });
    const Component = tagName;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        ...buttonProps,
        ...props,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, prefix, active && "active", variant && `${prefix}-${variant}`, size && `${prefix}-${size}`, props.href && disabled && "disabled")
    });
});
$a73f5336dfd04f2d$var$Button.displayName = "Button";
var $a73f5336dfd04f2d$export$2e2bcd8739ae039 = $a73f5336dfd04f2d$var$Button;



var $6cds3 = parcelRequire("6cds3");


"use client";
const $e44c6ff59d2a760f$var$Badge = /*#__PURE__*/ $6cds3.forwardRef(({ bsPrefix: bsPrefix, bg: bg = "primary", pill: pill = false, text: text, className: className, as: Component = "span", ...props }, ref)=>{
    const prefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "badge");
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, prefix, pill && `rounded-pill`, text && `text-${text}`, bg && `bg-${bg}`)
    });
});
$e44c6ff59d2a760f$var$Badge.displayName = "Badge";
var $e44c6ff59d2a760f$export$2e2bcd8739ae039 = $e44c6ff59d2a760f$var$Badge;







var $a3337508e7d42005$var$size;
function $a3337508e7d42005$export$2e2bcd8739ae039(recalc) {
    if (!$a3337508e7d42005$var$size && $a3337508e7d42005$var$size !== 0 || recalc) {
        if (0, $72899b21b69d5129$export$2e2bcd8739ae039) {
            var scrollDiv = document.createElement("div");
            scrollDiv.style.position = "absolute";
            scrollDiv.style.top = "-9999px";
            scrollDiv.style.width = "50px";
            scrollDiv.style.height = "50px";
            scrollDiv.style.overflow = "scroll";
            document.body.appendChild(scrollDiv);
            $a3337508e7d42005$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return $a3337508e7d42005$var$size;
}






var $6cds3 = parcelRequire("6cds3");
function $69b6a8b3e84fd627$export$2e2bcd8739ae039(value) {
    const valueRef = (0, $6cds3.useRef)(value);
    valueRef.current = value;
    return valueRef;
}



var $6cds3 = parcelRequire("6cds3");
function $9b0b5255176140e6$export$2e2bcd8739ae039(fn) {
    const onUnmount = (0, $69b6a8b3e84fd627$export$2e2bcd8739ae039)(fn);
    (0, $6cds3.useEffect)(()=>()=>onUnmount.current(), []);
}




var $6cds3 = parcelRequire("6cds3");

function $89f862a28381cd6f$export$2e2bcd8739ae039(doc) {
    if (doc === void 0) doc = (0, $f52efbbd31c95236$export$2e2bcd8739ae039)();
    // Support: IE 9 only
    // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
    try {
        var active = doc.activeElement; // IE11 returns a seemingly empty object in some cases when accessing
        // document.activeElement from an <iframe>
        if (!active || !active.nodeName) return null;
        return active;
    } catch (e) {
        /* ie throws if no active element */ return doc.body;
    }
}


/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ function $bcd2f9d8e6f19108$export$2e2bcd8739ae039(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}





var $6cds3 = parcelRequire("6cds3");






const $6e6a9ad066805249$export$fd7bcb7e9bef4e8a = `data-rr-ui-`;
const $6e6a9ad066805249$export$635202801f9383a0 = `rrUi`;
function $6e6a9ad066805249$export$5cc3b7b83e34ade7(property) {
    return `${$6e6a9ad066805249$export$fd7bcb7e9bef4e8a}${property}`;
}
function $6e6a9ad066805249$export$7776c0a7cd2eb3e0(property) {
    return `${$6e6a9ad066805249$export$635202801f9383a0}${property}`;
}


/**
 * Get the width of the vertical window scrollbar if it's visible
 */ function $f0fd97f9044a2bf3$export$2e2bcd8739ae039(ownerDocument = document) {
    const window = ownerDocument.defaultView;
    return Math.abs(window.innerWidth - ownerDocument.documentElement.clientWidth);
}


const $084357f82de5a301$export$1a88c12b8b979fa0 = (0, $6e6a9ad066805249$export$5cc3b7b83e34ade7)("modal-open");
/**
 * Manages a stack of Modals as well as ensuring
 * body scrolling is is disabled and padding accounted for
 */ class $084357f82de5a301$var$ModalManager {
    getScrollbarWidth() {
        return (0, $f0fd97f9044a2bf3$export$2e2bcd8739ae039)(this.ownerDocument);
    }
    getElement() {
        return (this.ownerDocument || document).body;
    }
    setModalAttributes(_modal) {
    // For overriding
    }
    removeModalAttributes(_modal) {
    // For overriding
    }
    setContainerStyle(containerState) {
        const style = {
            overflow: "hidden"
        };
        // we are only interested in the actual `style` here
        // because we will override it
        const paddingProp = this.isRTL ? "paddingLeft" : "paddingRight";
        const container = this.getElement();
        containerState.style = {
            overflow: container.style.overflow,
            [paddingProp]: container.style[paddingProp]
        };
        if (containerState.scrollBarWidth) // use computed style, here to get the real padding
        // to add our scrollbar width
        style[paddingProp] = `${parseInt((0, $c70c5acd84b310f3$export$2e2bcd8739ae039)(container, paddingProp) || "0", 10) + containerState.scrollBarWidth}px`;
        container.setAttribute($084357f82de5a301$export$1a88c12b8b979fa0, "");
        (0, $c70c5acd84b310f3$export$2e2bcd8739ae039)(container, style);
    }
    reset() {
        [
            ...this.modals
        ].forEach((m)=>this.remove(m));
    }
    removeContainerStyle(containerState) {
        const container = this.getElement();
        container.removeAttribute($084357f82de5a301$export$1a88c12b8b979fa0);
        Object.assign(container.style, containerState.style);
    }
    add(modal) {
        let modalIdx = this.modals.indexOf(modal);
        if (modalIdx !== -1) return modalIdx;
        modalIdx = this.modals.length;
        this.modals.push(modal);
        this.setModalAttributes(modal);
        if (modalIdx !== 0) return modalIdx;
        this.state = {
            scrollBarWidth: this.getScrollbarWidth(),
            style: {}
        };
        if (this.handleContainerOverflow) this.setContainerStyle(this.state);
        return modalIdx;
    }
    remove(modal) {
        const modalIdx = this.modals.indexOf(modal);
        if (modalIdx === -1) return;
        this.modals.splice(modalIdx, 1);
        // if that was the last modal in a container,
        // clean up the container
        if (!this.modals.length && this.handleContainerOverflow) this.removeContainerStyle(this.state);
        this.removeModalAttributes(modal);
    }
    isTopModal(modal) {
        return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
    }
    constructor({ ownerDocument: ownerDocument, handleContainerOverflow: handleContainerOverflow = true, isRTL: isRTL = false } = {}){
        this.handleContainerOverflow = handleContainerOverflow;
        this.isRTL = isRTL;
        this.modals = [];
        this.ownerDocument = ownerDocument;
    }
}
var $084357f82de5a301$export$2e2bcd8739ae039 = $084357f82de5a301$var$ModalManager;





var $6cds3 = parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");

const $51c759f15d660954$var$Context = /*#__PURE__*/ (0, $6cds3.createContext)((0, $72899b21b69d5129$export$2e2bcd8739ae039) ? window : undefined);
const $51c759f15d660954$export$f7d306aeb1cf5fbc = $51c759f15d660954$var$Context.Provider;
function $51c759f15d660954$export$2e2bcd8739ae039() {
    return (0, $6cds3.useContext)($51c759f15d660954$var$Context);
}


const $6436e539995da412$export$c91fd81e6d65f84a = (ref, document)=>{
    if (!(0, $72899b21b69d5129$export$2e2bcd8739ae039)) return null;
    if (ref == null) return (document || (0, $f52efbbd31c95236$export$2e2bcd8739ae039)()).body;
    if (typeof ref === "function") ref = ref();
    if (ref && "current" in ref) ref = ref.current;
    if (ref && ("nodeType" in ref || ref.getBoundingClientRect)) return ref;
    return null;
};
function $6436e539995da412$export$2e2bcd8739ae039(ref, onResolved) {
    const window = (0, $51c759f15d660954$export$2e2bcd8739ae039)();
    const [resolvedRef, setRef] = (0, $6cds3.useState)(()=>$6436e539995da412$export$c91fd81e6d65f84a(ref, window == null ? void 0 : window.document));
    if (!resolvedRef) {
        const earlyRef = $6436e539995da412$export$c91fd81e6d65f84a(ref);
        if (earlyRef) setRef(earlyRef);
    }
    (0, $6cds3.useEffect)(()=>{
        if (onResolved && resolvedRef) onResolved(resolvedRef);
    }, [
        onResolved,
        resolvedRef
    ]);
    (0, $6cds3.useEffect)(()=>{
        const nextRef = $6436e539995da412$export$c91fd81e6d65f84a(ref);
        if (nextRef !== resolvedRef) setRef(nextRef);
    }, [
        ref,
        resolvedRef
    ]);
    return resolvedRef;
}







var $6cds3 = parcelRequire("6cds3");



var $6cds3 = parcelRequire("6cds3");
function $dcc4effa3b2c68e8$var$NoopTransition({ children: children, in: inProp, onExited: onExited, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit }) {
    const ref = (0, $6cds3.useRef)(null);
    const hasEnteredRef = (0, $6cds3.useRef)(inProp);
    const handleExited = (0, $cfbeaaf7204fcb02$export$2e2bcd8739ae039)(onExited);
    (0, $6cds3.useEffect)(()=>{
        if (inProp) hasEnteredRef.current = true;
        else handleExited(ref.current);
    }, [
        inProp,
        handleExited
    ]);
    const combinedRef = (0, $2921c5d455351cc0$export$2e2bcd8739ae039)(ref, children.ref);
    const child = /*#__PURE__*/ (0, $6cds3.cloneElement)(children, {
        ref: combinedRef
    });
    if (inProp) return child;
    if (unmountOnExit) return null;
    if (!hasEnteredRef.current && mountOnEnter) return null;
    return child;
}
var $dcc4effa3b2c68e8$export$2e2bcd8739ae039 = $dcc4effa3b2c68e8$var$NoopTransition;



function $fd01075742e0e0b6$export$7b286972b8d8ccbf({ in: inProp, onTransition: onTransition }) {
    const ref = (0, $6cds3.useRef)(null);
    const isInitialRef = (0, $6cds3.useRef)(true);
    const handleTransition = (0, $cfbeaaf7204fcb02$export$2e2bcd8739ae039)(onTransition);
    (0, $ac9facc4976791bd$export$2e2bcd8739ae039)(()=>{
        if (!ref.current) return undefined;
        let stale = false;
        handleTransition({
            in: inProp,
            element: ref.current,
            initial: isInitialRef.current,
            isStale: ()=>stale
        });
        return ()=>{
            stale = true;
        };
    }, [
        inProp,
        handleTransition
    ]);
    (0, $ac9facc4976791bd$export$2e2bcd8739ae039)(()=>{
        isInitialRef.current = false;
        // this is for strict mode
        return ()=>{
            isInitialRef.current = true;
        };
    }, []);
    return ref;
}
function $fd01075742e0e0b6$export$2e2bcd8739ae039({ children: children, in: inProp, onExited: onExited, onEntered: onEntered, transition: transition }) {
    const [exited, setExited] = (0, $6cds3.useState)(!inProp);
    // TODO: I think this needs to be in an effect
    if (inProp && exited) setExited(false);
    const ref = $fd01075742e0e0b6$export$7b286972b8d8ccbf({
        in: !!inProp,
        onTransition: (options)=>{
            const onFinish = ()=>{
                if (options.isStale()) return;
                if (options.in) onEntered == null || onEntered(options.element, options.initial);
                else {
                    setExited(true);
                    onExited == null || onExited(options.element);
                }
            };
            Promise.resolve(transition(options)).then(onFinish, (error)=>{
                if (!options.in) setExited(true);
                throw error;
            });
        }
    });
    const combinedRef = (0, $2921c5d455351cc0$export$2e2bcd8739ae039)(ref, children.ref);
    return exited && !inProp ? null : /*#__PURE__*/ (0, $6cds3.cloneElement)(children, {
        ref: combinedRef
    });
}
function $fd01075742e0e0b6$export$f41d64aae6d6dba5(Component, runTransition, props) {
    if (Component) return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, Object.assign({}, props));
    if (runTransition) return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($fd01075742e0e0b6$export$2e2bcd8739ae039, Object.assign({}, props, {
        transition: runTransition
    }));
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dcc4effa3b2c68e8$export$2e2bcd8739ae039), Object.assign({}, props));
}


/* eslint-disable import/prefer-default-export */ function $3baa31eadc645da2$export$806fcc22e55e107d(e) {
    return e.code === "Escape" || e.keyCode === 27;
}



const $ff7ce879cf38438a$var$_excluded = [
    "show",
    "role",
    "className",
    "style",
    "children",
    "backdrop",
    "keyboard",
    "onBackdropClick",
    "onEscapeKeyDown",
    "transition",
    "runTransition",
    "backdropTransition",
    "runBackdropTransition",
    "autoFocus",
    "enforceFocus",
    "restoreFocus",
    "restoreFocusOptions",
    "renderDialog",
    "renderBackdrop",
    "manager",
    "container",
    "onShow",
    "onHide",
    "onExit",
    "onExited",
    "onExiting",
    "onEnter",
    "onEntering",
    "onEntered"
];
function $ff7ce879cf38438a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
let $ff7ce879cf38438a$var$manager;
function $ff7ce879cf38438a$var$getManager(window) {
    if (!$ff7ce879cf38438a$var$manager) $ff7ce879cf38438a$var$manager = new (0, $084357f82de5a301$export$2e2bcd8739ae039)({
        ownerDocument: window == null ? void 0 : window.document
    });
    return $ff7ce879cf38438a$var$manager;
}
function $ff7ce879cf38438a$var$useModalManager(provided) {
    const window = (0, $51c759f15d660954$export$2e2bcd8739ae039)();
    const modalManager = provided || $ff7ce879cf38438a$var$getManager(window);
    const modal = (0, $6cds3.useRef)({
        dialog: null,
        backdrop: null
    });
    return Object.assign(modal.current, {
        add: ()=>modalManager.add(modal.current),
        remove: ()=>modalManager.remove(modal.current),
        isTopModal: ()=>modalManager.isTopModal(modal.current),
        setDialogRef: (0, $6cds3.useCallback)((ref)=>{
            modal.current.dialog = ref;
        }, []),
        setBackdropRef: (0, $6cds3.useCallback)((ref)=>{
            modal.current.backdrop = ref;
        }, [])
    });
}
const $ff7ce879cf38438a$var$Modal = /*#__PURE__*/ (0, $6cds3.forwardRef)((_ref, ref)=>{
    let { show: show = false, role: role = "dialog", className: className, style: style, children: children, backdrop: backdrop = true, keyboard: keyboard = true, onBackdropClick: onBackdropClick, onEscapeKeyDown: onEscapeKeyDown, transition: transition, runTransition: runTransition, backdropTransition: backdropTransition, runBackdropTransition: runBackdropTransition, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, renderDialog: renderDialog, renderBackdrop: renderBackdrop = (props)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({}, props)), manager: providedManager, container: containerRef, onShow: onShow, onHide: onHide = ()=>{}, onExit: onExit, onExited: onExited, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered } = _ref, rest = $ff7ce879cf38438a$var$_objectWithoutPropertiesLoose(_ref, $ff7ce879cf38438a$var$_excluded);
    const ownerWindow = (0, $51c759f15d660954$export$2e2bcd8739ae039)();
    const container = (0, $6436e539995da412$export$2e2bcd8739ae039)(containerRef);
    const modal = $ff7ce879cf38438a$var$useModalManager(providedManager);
    const isMounted = (0, $316c1fef2af83f46$export$2e2bcd8739ae039)();
    const prevShow = (0, $e9b4c74f20368aab$export$2e2bcd8739ae039)(show);
    const [exited, setExited] = (0, $6cds3.useState)(!show);
    const lastFocusRef = (0, $6cds3.useRef)(null);
    (0, $6cds3.useImperativeHandle)(ref, ()=>modal, [
        modal
    ]);
    if ((0, $72899b21b69d5129$export$2e2bcd8739ae039) && !prevShow && show) lastFocusRef.current = (0, $89f862a28381cd6f$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
    // TODO: I think this needs to be in an effect
    if (show && exited) setExited(false);
    const handleShow = (0, $cfbeaaf7204fcb02$export$2e2bcd8739ae039)(()=>{
        modal.add();
        removeKeydownListenerRef.current = (0, $4ca9d7ffc3c5ea9f$export$2e2bcd8739ae039)(document, "keydown", handleDocumentKeyDown);
        removeFocusListenerRef.current = (0, $4ca9d7ffc3c5ea9f$export$2e2bcd8739ae039)(document, "focus", // the timeout is necessary b/c this will run before the new modal is mounted
        // and so steals focus from it
        ()=>setTimeout(handleEnforceFocus), true);
        if (onShow) onShow();
        // autofocus after onShow to not trigger a focus event for previous
        // modals before this one is shown.
        if (autoFocus) {
            var _modal$dialog$ownerDo, _modal$dialog;
            const currentActiveElement = (0, $89f862a28381cd6f$export$2e2bcd8739ae039)((_modal$dialog$ownerDo = (_modal$dialog = modal.dialog) == null ? void 0 : _modal$dialog.ownerDocument) != null ? _modal$dialog$ownerDo : ownerWindow == null ? void 0 : ownerWindow.document);
            if (modal.dialog && currentActiveElement && !(0, $bcd2f9d8e6f19108$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) {
                lastFocusRef.current = currentActiveElement;
                modal.dialog.focus();
            }
        }
    });
    const handleHide = (0, $cfbeaaf7204fcb02$export$2e2bcd8739ae039)(()=>{
        modal.remove();
        removeKeydownListenerRef.current == null || removeKeydownListenerRef.current();
        removeFocusListenerRef.current == null || removeFocusListenerRef.current();
        if (restoreFocus) {
            var _lastFocusRef$current;
            // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
            (_lastFocusRef$current = lastFocusRef.current) == null || _lastFocusRef$current.focus == null || _lastFocusRef$current.focus(restoreFocusOptions);
            lastFocusRef.current = null;
        }
    });
    // TODO: try and combine these effects: https://github.com/react-bootstrap/react-overlays/pull/794#discussion_r409954120
    // Show logic when:
    //  - show is `true` _and_ `container` has resolved
    (0, $6cds3.useEffect)(()=>{
        if (!show || !container) return;
        handleShow();
    }, [
        show,
        container,
        /* should never change: */ handleShow
    ]);
    // Hide cleanup logic when:
    //  - `exited` switches to true
    //  - component unmounts;
    (0, $6cds3.useEffect)(()=>{
        if (!exited) return;
        handleHide();
    }, [
        exited,
        handleHide
    ]);
    (0, $9b0b5255176140e6$export$2e2bcd8739ae039)(()=>{
        handleHide();
    });
    // --------------------------------
    const handleEnforceFocus = (0, $cfbeaaf7204fcb02$export$2e2bcd8739ae039)(()=>{
        if (!enforceFocus || !isMounted() || !modal.isTopModal()) return;
        const currentActiveElement = (0, $89f862a28381cd6f$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
        if (modal.dialog && currentActiveElement && !(0, $bcd2f9d8e6f19108$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) modal.dialog.focus();
    });
    const handleBackdropClick = (0, $cfbeaaf7204fcb02$export$2e2bcd8739ae039)((e)=>{
        if (e.target !== e.currentTarget) return;
        onBackdropClick == null || onBackdropClick(e);
        if (backdrop === true) onHide();
    });
    const handleDocumentKeyDown = (0, $cfbeaaf7204fcb02$export$2e2bcd8739ae039)((e)=>{
        if (keyboard && (0, $3baa31eadc645da2$export$806fcc22e55e107d)(e) && modal.isTopModal()) {
            onEscapeKeyDown == null || onEscapeKeyDown(e);
            if (!e.defaultPrevented) onHide();
        }
    });
    const removeFocusListenerRef = (0, $6cds3.useRef)();
    const removeKeydownListenerRef = (0, $6cds3.useRef)();
    const handleHidden = (...args)=>{
        setExited(true);
        onExited == null || onExited(...args);
    };
    if (!container) return null;
    const dialogProps = Object.assign({
        role: role,
        ref: modal.setDialogRef,
        // apparently only works on the dialog role element
        "aria-modal": role === "dialog" ? true : undefined
    }, rest, {
        style: style,
        className: className,
        tabIndex: -1
    });
    let dialog = renderDialog ? renderDialog(dialogProps) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", Object.assign({}, dialogProps, {
        children: /*#__PURE__*/ $6cds3.cloneElement(children, {
            role: "document"
        })
    }));
    dialog = (0, $fd01075742e0e0b6$export$f41d64aae6d6dba5)(transition, runTransition, {
        unmountOnExit: true,
        mountOnEnter: true,
        appear: true,
        in: !!show,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        children: dialog
    });
    let backdropElement = null;
    if (backdrop) {
        backdropElement = renderBackdrop({
            ref: modal.setBackdropRef,
            onClick: handleBackdropClick
        });
        backdropElement = (0, $fd01075742e0e0b6$export$f41d64aae6d6dba5)(backdropTransition, runBackdropTransition, {
            in: !!show,
            appear: true,
            mountOnEnter: true,
            unmountOnExit: true,
            children: backdropElement
        });
    }
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6d4849ee44552f5f$exports))).createPortal(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
            children: [
                backdropElement,
                dialog
            ]
        }), container)
    });
});
$ff7ce879cf38438a$var$Modal.displayName = "Modal";
var $ff7ce879cf38438a$export$2e2bcd8739ae039 = Object.assign($ff7ce879cf38438a$var$Modal, {
    Manager: (0, $084357f82de5a301$export$2e2bcd8739ae039)
});


/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $6e92aadc75b4abf4$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $e19126e9af75eaab$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $6e92aadc75b4abf4$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}



var $557b64d4dca42129$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function $557b64d4dca42129$export$2e2bcd8739ae039(element, selector) {
    return $557b64d4dca42129$var$toArray(element.querySelectorAll(selector));
}


function $bf9dd674acfe2810$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function $bf9dd674acfe2810$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = $bf9dd674acfe2810$var$replaceClassName(element.className, className);
    else element.setAttribute("class", $bf9dd674acfe2810$var$replaceClassName(element.className && element.className.baseVal || "", className));
}



const $53087d07edd6b6cc$var$Selector = {
    FIXED_CONTENT: ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top",
    STICKY_CONTENT: ".sticky-top",
    NAVBAR_TOGGLER: ".navbar-toggler"
};
class $53087d07edd6b6cc$var$BootstrapModalManager extends (0, $084357f82de5a301$export$2e2bcd8739ae039) {
    adjustAndStore(prop, element, adjust) {
        const actual = element.style[prop];
        // TODO: DOMStringMap and CSSStyleDeclaration aren't strictly compatible
        // @ts-ignore
        element.dataset[prop] = actual;
        (0, $c70c5acd84b310f3$export$2e2bcd8739ae039)(element, {
            [prop]: `${parseFloat((0, $c70c5acd84b310f3$export$2e2bcd8739ae039)(element, prop)) + adjust}px`
        });
    }
    restore(prop, element) {
        const value = element.dataset[prop];
        if (value !== undefined) {
            delete element.dataset[prop];
            (0, $c70c5acd84b310f3$export$2e2bcd8739ae039)(element, {
                [prop]: value
            });
        }
    }
    setContainerStyle(containerState) {
        super.setContainerStyle(containerState);
        const container = this.getElement();
        (0, $e19126e9af75eaab$export$2e2bcd8739ae039)(container, "modal-open");
        if (!containerState.scrollBarWidth) return;
        const paddingProp = this.isRTL ? "paddingLeft" : "paddingRight";
        const marginProp = this.isRTL ? "marginLeft" : "marginRight";
        (0, $557b64d4dca42129$export$2e2bcd8739ae039)(container, $53087d07edd6b6cc$var$Selector.FIXED_CONTENT).forEach((el)=>this.adjustAndStore(paddingProp, el, containerState.scrollBarWidth));
        (0, $557b64d4dca42129$export$2e2bcd8739ae039)(container, $53087d07edd6b6cc$var$Selector.STICKY_CONTENT).forEach((el)=>this.adjustAndStore(marginProp, el, -containerState.scrollBarWidth));
        (0, $557b64d4dca42129$export$2e2bcd8739ae039)(container, $53087d07edd6b6cc$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.adjustAndStore(marginProp, el, containerState.scrollBarWidth));
    }
    removeContainerStyle(containerState) {
        super.removeContainerStyle(containerState);
        const container = this.getElement();
        (0, $bf9dd674acfe2810$export$2e2bcd8739ae039)(container, "modal-open");
        const paddingProp = this.isRTL ? "paddingLeft" : "paddingRight";
        const marginProp = this.isRTL ? "marginLeft" : "marginRight";
        (0, $557b64d4dca42129$export$2e2bcd8739ae039)(container, $53087d07edd6b6cc$var$Selector.FIXED_CONTENT).forEach((el)=>this.restore(paddingProp, el));
        (0, $557b64d4dca42129$export$2e2bcd8739ae039)(container, $53087d07edd6b6cc$var$Selector.STICKY_CONTENT).forEach((el)=>this.restore(marginProp, el));
        (0, $557b64d4dca42129$export$2e2bcd8739ae039)(container, $53087d07edd6b6cc$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.restore(marginProp, el));
    }
}
let $53087d07edd6b6cc$var$sharedManager;
function $53087d07edd6b6cc$export$a03641438014b436(options) {
    if (!$53087d07edd6b6cc$var$sharedManager) $53087d07edd6b6cc$var$sharedManager = new $53087d07edd6b6cc$var$BootstrapModalManager(options);
    return $53087d07edd6b6cc$var$sharedManager;
}
var $53087d07edd6b6cc$export$2e2bcd8739ae039 = $53087d07edd6b6cc$var$BootstrapModalManager;




var $6cds3 = parcelRequire("6cds3");



"use client";
const $a6cb65f8854c7adc$var$ModalBody = /*#__PURE__*/ $6cds3.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", ...props }, ref)=>{
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "modal-body");
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, bsPrefix),
        ...props
    });
});
$a6cb65f8854c7adc$var$ModalBody.displayName = "ModalBody";
var $a6cb65f8854c7adc$export$2e2bcd8739ae039 = $a6cb65f8854c7adc$var$ModalBody;



var $6cds3 = parcelRequire("6cds3");
"use client";
const $c2ec00bdc56ab783$var$ModalContext = /*#__PURE__*/ $6cds3.createContext({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onHide () {}
});
var $c2ec00bdc56ab783$export$2e2bcd8739ae039 = $c2ec00bdc56ab783$var$ModalContext;




var $6cds3 = parcelRequire("6cds3");


"use client";
const $2f029ac57422b9cc$var$ModalDialog = /*#__PURE__*/ $6cds3.forwardRef(({ bsPrefix: bsPrefix, className: className, contentClassName: contentClassName, centered: centered, size: size, fullscreen: fullscreen, children: children, scrollable: scrollable, ...props }, ref)=>{
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "modal");
    const dialogClass = `${bsPrefix}-dialog`;
    const fullScreenClass = typeof fullscreen === "string" ? `${bsPrefix}-fullscreen-${fullscreen}` : `${bsPrefix}-fullscreen`;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(dialogClass, className, size && `${bsPrefix}-${size}`, centered && `${dialogClass}-centered`, scrollable && `${dialogClass}-scrollable`, fullscreen && fullScreenClass),
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(`${bsPrefix}-content`, contentClassName),
            children: children
        })
    });
});
$2f029ac57422b9cc$var$ModalDialog.displayName = "ModalDialog";
var $2f029ac57422b9cc$export$2e2bcd8739ae039 = $2f029ac57422b9cc$var$ModalDialog;



var $6cds3 = parcelRequire("6cds3");



"use client";
const $b9aa4632010f19be$var$ModalFooter = /*#__PURE__*/ $6cds3.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", ...props }, ref)=>{
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "modal-footer");
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, bsPrefix),
        ...props
    });
});
$b9aa4632010f19be$var$ModalFooter.displayName = "ModalFooter";
var $b9aa4632010f19be$export$2e2bcd8739ae039 = $b9aa4632010f19be$var$ModalFooter;




var $6cds3 = parcelRequire("6cds3");


var $6cds3 = parcelRequire("6cds3");




"use client";
const $232dc4c02efc0ee7$var$AbstractModalHeader = /*#__PURE__*/ $6cds3.forwardRef(({ closeLabel: closeLabel = "Close", closeVariant: closeVariant, closeButton: closeButton = false, onHide: onHide, children: children, ...props }, ref)=>{
    const context = (0, $6cds3.useContext)((0, $c2ec00bdc56ab783$export$2e2bcd8739ae039));
    const handleClick = (0, $cfbeaaf7204fcb02$export$2e2bcd8739ae039)(()=>{
        context == null || context.onHide();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        ref: ref,
        ...props,
        children: [
            children,
            closeButton && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0a4b69d94c7ec063$export$2e2bcd8739ae039), {
                "aria-label": closeLabel,
                variant: closeVariant,
                onClick: handleClick
            })
        ]
    });
});
var $232dc4c02efc0ee7$export$2e2bcd8739ae039 = $232dc4c02efc0ee7$var$AbstractModalHeader;



"use client";
const $ce092bd1b7ec4131$var$ModalHeader = /*#__PURE__*/ $6cds3.forwardRef(({ bsPrefix: bsPrefix, className: className, closeLabel: closeLabel = "Close", closeButton: closeButton = false, ...props }, ref)=>{
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "modal-header");
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $232dc4c02efc0ee7$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    });
});
$ce092bd1b7ec4131$var$ModalHeader.displayName = "ModalHeader";
var $ce092bd1b7ec4131$export$2e2bcd8739ae039 = $ce092bd1b7ec4131$var$ModalHeader;



var $6cds3 = parcelRequire("6cds3");




"use client";
const $560894915916b156$var$DivStyledAsH4 = (0, $4209f4cdd547894e$export$2e2bcd8739ae039)("h4");
const $560894915916b156$var$ModalTitle = /*#__PURE__*/ $6cds3.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $560894915916b156$var$DivStyledAsH4, ...props }, ref)=>{
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "modal-title");
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, bsPrefix),
        ...props
    });
});
$560894915916b156$var$ModalTitle.displayName = "ModalTitle";
var $560894915916b156$export$2e2bcd8739ae039 = $560894915916b156$var$ModalTitle;




"use client";
/* eslint-disable no-use-before-define, react/no-multi-comp */ function $3485727b0a1e4042$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9d1648789ad43db2$export$2e2bcd8739ae039), {
        ...props,
        timeout: null
    });
}
function $3485727b0a1e4042$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9d1648789ad43db2$export$2e2bcd8739ae039), {
        ...props,
        timeout: null
    });
}
/* eslint-enable no-use-before-define */ const $3485727b0a1e4042$var$Modal = /*#__PURE__*/ $6cds3.forwardRef(({ bsPrefix: bsPrefix, className: className, style: style, dialogClassName: dialogClassName, contentClassName: contentClassName, children: children, dialogAs: Dialog = (0, $2f029ac57422b9cc$export$2e2bcd8739ae039), "data-bs-theme": dataBsTheme, "aria-labelledby": ariaLabelledby, "aria-describedby": ariaDescribedby, "aria-label": ariaLabel, show: /* BaseModal props */ show = false, animation: animation = true, backdrop: backdrop = true, keyboard: keyboard = true, onEscapeKeyDown: onEscapeKeyDown, onShow: onShow, onHide: onHide, container: container, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onExited: onExited, backdropClassName: backdropClassName, manager: propsManager, ...props }, ref)=>{
    const [modalStyle, setStyle] = (0, $6cds3.useState)({});
    const [animateStaticModal, setAnimateStaticModal] = (0, $6cds3.useState)(false);
    const waitingForMouseUpRef = (0, $6cds3.useRef)(false);
    const ignoreBackdropClickRef = (0, $6cds3.useRef)(false);
    const removeStaticModalAnimationRef = (0, $6cds3.useRef)(null);
    const [modal, setModalRef] = (0, $6c24397ccd0ea65a$export$2e2bcd8739ae039)();
    const mergedRef = (0, $2921c5d455351cc0$export$2e2bcd8739ae039)(ref, setModalRef);
    const handleHide = (0, $cfbeaaf7204fcb02$export$2e2bcd8739ae039)(onHide);
    const isRTL = (0, $c5d3aca6e909caf5$export$35e511eefa30ac5a)();
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "modal");
    const modalContext = (0, $6cds3.useMemo)(()=>({
            onHide: handleHide
        }), [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        return (0, $53087d07edd6b6cc$export$a03641438014b436)({
            isRTL: isRTL
        });
    }
    function updateDialogStyle(node) {
        if (!(0, $72899b21b69d5129$export$2e2bcd8739ae039)) return;
        const containerIsOverflowing = getModalManager().getScrollbarWidth() > 0;
        const modalIsOverflowing = node.scrollHeight > (0, $f52efbbd31c95236$export$2e2bcd8739ae039)(node).documentElement.clientHeight;
        setStyle({
            paddingRight: containerIsOverflowing && !modalIsOverflowing ? (0, $a3337508e7d42005$export$2e2bcd8739ae039)() : undefined,
            paddingLeft: !containerIsOverflowing && modalIsOverflowing ? (0, $a3337508e7d42005$export$2e2bcd8739ae039)() : undefined
        });
    }
    const handleWindowResize = (0, $cfbeaaf7204fcb02$export$2e2bcd8739ae039)(()=>{
        if (modal) updateDialogStyle(modal.dialog);
    });
    (0, $9b0b5255176140e6$export$2e2bcd8739ae039)(()=>{
        (0, $7988376756273ef1$export$2e2bcd8739ae039)(window, "resize", handleWindowResize);
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
    });
    // We prevent the modal from closing during a drag by detecting where the
    // click originates from. If it starts in the modal and then ends outside
    // don't close.
    const handleDialogMouseDown = ()=>{
        waitingForMouseUpRef.current = true;
    };
    const handleMouseUp = (e)=>{
        if (waitingForMouseUpRef.current && modal && e.target === modal.dialog) ignoreBackdropClickRef.current = true;
        waitingForMouseUpRef.current = false;
    };
    const handleStaticModalAnimation = ()=>{
        setAnimateStaticModal(true);
        removeStaticModalAnimationRef.current = (0, $ee3572b014b87ebd$export$2e2bcd8739ae039)(modal.dialog, ()=>{
            setAnimateStaticModal(false);
        });
    };
    const handleStaticBackdropClick = (e)=>{
        if (e.target !== e.currentTarget) return;
        handleStaticModalAnimation();
    };
    const handleClick = (e)=>{
        if (backdrop === "static") {
            handleStaticBackdropClick(e);
            return;
        }
        if (ignoreBackdropClickRef.current || e.target !== e.currentTarget) {
            ignoreBackdropClickRef.current = false;
            return;
        }
        onHide == null || onHide();
    };
    const handleEscapeKeyDown = (e)=>{
        if (keyboard) onEscapeKeyDown == null || onEscapeKeyDown(e);
        else {
            // Call preventDefault to stop modal from closing in @restart/ui.
            e.preventDefault();
            if (backdrop === "static") // Play static modal animation.
            handleStaticModalAnimation();
        }
    };
    const handleEnter = (node, isAppearing)=>{
        if (node) updateDialogStyle(node);
        onEnter == null || onEnter(node, isAppearing);
    };
    const handleExit = (node)=>{
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
        onExit == null || onExit(node);
    };
    const handleEntering = (node, isAppearing)=>{
        onEntering == null || onEntering(node, isAppearing);
        // FIXME: This should work even when animation is disabled.
        (0, $a0bafde1ed7798b0$export$2e2bcd8739ae039)(window, "resize", handleWindowResize);
    };
    const handleExited = (node)=>{
        if (node) node.style.display = ""; // RHL removes it sometimes
        onExited == null || onExited(node);
        // FIXME: This should work even when animation is disabled.
        (0, $7988376756273ef1$export$2e2bcd8739ae039)(window, "resize", handleWindowResize);
    };
    const renderBackdrop = (0, $6cds3.useCallback)((backdropProps)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
            ...backdropProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(`${bsPrefix}-backdrop`, backdropClassName, !animation && "show")
        }), [
        animation,
        backdropClassName,
        bsPrefix
    ]);
    const baseModalStyle = {
        ...style,
        ...modalStyle
    };
    // If `display` is not set to block, autoFocus inside the modal fails
    // https://github.com/react-bootstrap/react-bootstrap/issues/5102
    baseModalStyle.display = "block";
    const renderDialog = (dialogProps)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
            role: "dialog",
            ...dialogProps,
            style: baseModalStyle,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, bsPrefix, animateStaticModal && `${bsPrefix}-static`, !animation && "show"),
            onClick: backdrop ? handleClick : undefined,
            onMouseUp: handleMouseUp,
            "data-bs-theme": dataBsTheme,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledby,
            "aria-describedby": ariaDescribedby,
            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Dialog, {
                ...props,
                onMouseDown: handleDialogMouseDown,
                className: dialogClassName,
                contentClassName: contentClassName,
                children: children
            })
        });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $c2ec00bdc56ab783$export$2e2bcd8739ae039).Provider, {
        value: modalContext,
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $ff7ce879cf38438a$export$2e2bcd8739ae039), {
            show: show,
            ref: mergedRef,
            backdrop: backdrop,
            container: container,
            keyboard: true // Always set true - see handleEscapeKeyDown
            ,
            autoFocus: autoFocus,
            enforceFocus: enforceFocus,
            restoreFocus: restoreFocus,
            restoreFocusOptions: restoreFocusOptions,
            onEscapeKeyDown: handleEscapeKeyDown,
            onShow: onShow,
            onHide: onHide,
            onEnter: handleEnter,
            onEntering: handleEntering,
            onEntered: onEntered,
            onExit: handleExit,
            onExiting: onExiting,
            onExited: handleExited,
            manager: getModalManager(),
            transition: animation ? $3485727b0a1e4042$var$DialogTransition : undefined,
            backdropTransition: animation ? $3485727b0a1e4042$var$BackdropTransition : undefined,
            renderBackdrop: renderBackdrop,
            renderDialog: renderDialog
        })
    });
});
$3485727b0a1e4042$var$Modal.displayName = "Modal";
var $3485727b0a1e4042$export$2e2bcd8739ae039 = Object.assign($3485727b0a1e4042$var$Modal, {
    Body: (0, $a6cb65f8854c7adc$export$2e2bcd8739ae039),
    Header: (0, $ce092bd1b7ec4131$export$2e2bcd8739ae039),
    Title: (0, $560894915916b156$export$2e2bcd8739ae039),
    Footer: (0, $b9aa4632010f19be$export$2e2bcd8739ae039),
    Dialog: (0, $2f029ac57422b9cc$export$2e2bcd8739ae039),
    TRANSITION_DURATION: 300,
    BACKDROP_TRANSITION_DURATION: 150
});



var $aMJGV = parcelRequire("aMJGV");

var $6cds3 = parcelRequire("6cds3");


var $6cds3 = parcelRequire("6cds3");


var $6cds3 = parcelRequire("6cds3");

var $aMJGV = parcelRequire("aMJGV");

const $100487d512bec47d$var$propTypes = {
    /**
   * Specify whether the feedback is for valid or invalid fields
   *
   * @type {('valid'|'invalid')}
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
    /** Display feedback as a tooltip. */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).elementType
};
const $100487d512bec47d$var$Feedback = /*#__PURE__*/ $6cds3.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ as: Component = "div", className: className, type: type = "valid", tooltip: tooltip = false, ...props }, ref)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, `${type}-${tooltip ? "tooltip" : "feedback"}`)
    }));
$100487d512bec47d$var$Feedback.displayName = "Feedback";
$100487d512bec47d$var$Feedback.propTypes = $100487d512bec47d$var$propTypes;
var $100487d512bec47d$export$2e2bcd8739ae039 = $100487d512bec47d$var$Feedback;




var $6cds3 = parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");
"use client";
// TODO
const $8c018e7634ec59ca$var$FormContext = /*#__PURE__*/ $6cds3.createContext({});
var $8c018e7634ec59ca$export$2e2bcd8739ae039 = $8c018e7634ec59ca$var$FormContext;




"use client";
const $eae2b6222d0080cd$var$FormCheckInput = /*#__PURE__*/ $6cds3.forwardRef(({ id: id, bsPrefix: bsPrefix, className: className, type: type = "checkbox", isValid: isValid = false, isInvalid: isInvalid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "input", ...props }, ref)=>{
    const { controlId: controlId } = (0, $6cds3.useContext)((0, $8c018e7634ec59ca$export$2e2bcd8739ae039));
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "form-check-input");
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        ...props,
        ref: ref,
        type: type,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, bsPrefix, isValid && "is-valid", isInvalid && "is-invalid")
    });
});
$eae2b6222d0080cd$var$FormCheckInput.displayName = "FormCheckInput";
var $eae2b6222d0080cd$export$2e2bcd8739ae039 = $eae2b6222d0080cd$var$FormCheckInput;




var $6cds3 = parcelRequire("6cds3");



"use client";
const $01055931313eaf1b$var$FormCheckLabel = /*#__PURE__*/ $6cds3.forwardRef(({ bsPrefix: bsPrefix, className: className, htmlFor: htmlFor, ...props }, ref)=>{
    const { controlId: controlId } = (0, $6cds3.useContext)((0, $8c018e7634ec59ca$export$2e2bcd8739ae039));
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "form-check-label");
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("label", {
        ...props,
        ref: ref,
        htmlFor: htmlFor || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, bsPrefix)
    });
});
$01055931313eaf1b$var$FormCheckLabel.displayName = "FormCheckLabel";
var $01055931313eaf1b$export$2e2bcd8739ae039 = $01055931313eaf1b$var$FormCheckLabel;





var $6cds3 = parcelRequire("6cds3");
/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */ function $400379245e9e6b68$export$871de8747c9eaa88(children, func) {
    let index = 0;
    return $6cds3.Children.map(children, (child)=>/*#__PURE__*/ $6cds3.isValidElement(child) ? func(child, index++) : child);
}
/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */ function $400379245e9e6b68$export$4b80e395e36b5a56(children, func) {
    let index = 0;
    $6cds3.Children.forEach(children, (child)=>{
        if (/*#__PURE__*/ $6cds3.isValidElement(child)) func(child, index++);
    });
}
/**
 * Finds whether a component's `children` prop includes a React element of the
 * specified type.
 */ function $400379245e9e6b68$export$500fd6099226ffae(children, type) {
    return $6cds3.Children.toArray(children).some((child)=>/*#__PURE__*/ $6cds3.isValidElement(child) && child.type === type);
}



"use client";
const $9f9314c2dc5735cc$var$FormCheck = /*#__PURE__*/ $6cds3.forwardRef(({ id: id, bsPrefix: bsPrefix, bsSwitchPrefix: bsSwitchPrefix, inline: inline = false, reverse: reverse = false, disabled: disabled = false, isValid: isValid = false, isInvalid: isInvalid = false, feedbackTooltip: feedbackTooltip = false, feedback: feedback, feedbackType: feedbackType, className: className, style: style, title: title = "", type: type = "checkbox", label: label, children: children, as: // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as = "input", ...props }, ref)=>{
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "form-check");
    bsSwitchPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsSwitchPrefix, "form-switch");
    const { controlId: controlId } = (0, $6cds3.useContext)((0, $8c018e7634ec59ca$export$2e2bcd8739ae039));
    const innerFormContext = (0, $6cds3.useMemo)(()=>({
            controlId: id || controlId
        }), [
        controlId,
        id
    ]);
    const hasLabel = !children && label != null && label !== false || (0, $400379245e9e6b68$export$500fd6099226ffae)(children, (0, $01055931313eaf1b$export$2e2bcd8739ae039));
    const input = /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $eae2b6222d0080cd$export$2e2bcd8739ae039), {
        ...props,
        type: type === "switch" ? "checkbox" : type,
        ref: ref,
        isValid: isValid,
        isInvalid: isInvalid,
        disabled: disabled,
        as: as
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8c018e7634ec59ca$export$2e2bcd8739ae039).Provider, {
        value: innerFormContext,
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
            style: style,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, hasLabel && bsPrefix, inline && `${bsPrefix}-inline`, reverse && `${bsPrefix}-reverse`, type === "switch" && bsSwitchPrefix),
            children: children || /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                children: [
                    input,
                    hasLabel && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $01055931313eaf1b$export$2e2bcd8739ae039), {
                        title: title,
                        children: label
                    }),
                    feedback && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $100487d512bec47d$export$2e2bcd8739ae039), {
                        type: feedbackType,
                        tooltip: feedbackTooltip,
                        children: feedback
                    })
                ]
            })
        })
    });
});
$9f9314c2dc5735cc$var$FormCheck.displayName = "FormCheck";
var $9f9314c2dc5735cc$export$2e2bcd8739ae039 = Object.assign($9f9314c2dc5735cc$var$FormCheck, {
    Input: (0, $eae2b6222d0080cd$export$2e2bcd8739ae039),
    Label: (0, $01055931313eaf1b$export$2e2bcd8739ae039)
});




var $6cds3 = parcelRequire("6cds3");
var $00abd41c79c40b14$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $00abd41c79c40b14$var$__DEV__ = false;
var $00abd41c79c40b14$var$warning = function() {};
if ($00abd41c79c40b14$var$__DEV__) {
    var $00abd41c79c40b14$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $00abd41c79c40b14$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $00abd41c79c40b14$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$00abd41c79c40b14$exports = $00abd41c79c40b14$var$warning;






"use client";
const $1ad7d3bae909e73b$var$FormControl = /*#__PURE__*/ $6cds3.forwardRef(({ bsPrefix: bsPrefix, type: type, size: size, htmlSize: htmlSize, id: id, className: className, isValid: isValid = false, isInvalid: isInvalid = false, plaintext: plaintext, readOnly: readOnly, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "input", ...props }, ref)=>{
    const { controlId: controlId } = (0, $6cds3.useContext)((0, $8c018e7634ec59ca$export$2e2bcd8739ae039));
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "form-control");
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        ...props,
        type: type,
        size: htmlSize,
        ref: ref,
        readOnly: readOnly,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, plaintext ? `${bsPrefix}-plaintext` : bsPrefix, size && `${bsPrefix}-${size}`, type === "color" && `${bsPrefix}-color`, isValid && "is-valid", isInvalid && "is-invalid")
    });
});
$1ad7d3bae909e73b$var$FormControl.displayName = "FormControl";
var $1ad7d3bae909e73b$export$2e2bcd8739ae039 = Object.assign($1ad7d3bae909e73b$var$FormControl, {
    Feedback: $100487d512bec47d$export$2e2bcd8739ae039
});



var $6cds3 = parcelRequire("6cds3");



"use client";
const $6bd7c7ede3e04bee$var$FormFloating = /*#__PURE__*/ $6cds3.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", ...props }, ref)=>{
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "form-floating");
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, bsPrefix),
        ...props
    });
});
$6bd7c7ede3e04bee$var$FormFloating.displayName = "FormFloating";
var $6bd7c7ede3e04bee$export$2e2bcd8739ae039 = $6bd7c7ede3e04bee$var$FormFloating;



var $6cds3 = parcelRequire("6cds3");


const $074513ec39e88e72$var$FormGroup = /*#__PURE__*/ $6cds3.forwardRef(({ controlId: controlId, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div", ...props }, ref)=>{
    const context = (0, $6cds3.useMemo)(()=>({
            controlId: controlId
        }), [
        controlId
    ]);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8c018e7634ec59ca$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
            ...props,
            ref: ref
        })
    });
});
$074513ec39e88e72$var$FormGroup.displayName = "FormGroup";
var $074513ec39e88e72$export$2e2bcd8739ae039 = $074513ec39e88e72$var$FormGroup;




var $6cds3 = parcelRequire("6cds3");



var $6cds3 = parcelRequire("6cds3");


"use client";
function $08ac016305091294$export$2ed43d61a0a9f5a3({ as: as, bsPrefix: bsPrefix, className: className, ...props }) {
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "col");
    const breakpoints = (0, $c5d3aca6e909caf5$export$8970c8db816a5863)();
    const minBreakpoint = (0, $c5d3aca6e909caf5$export$d926d6ef38f3fd32)();
    const spans = [];
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let span;
        let offset;
        let order;
        if (typeof propValue === "object" && propValue != null) ({ span: span, offset: offset, order: order } = propValue);
        else span = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : "";
        if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
        if (order != null) classes.push(`order${infix}-${order}`);
        if (offset != null) classes.push(`offset${infix}-${offset}`);
    });
    return [
        {
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, ...spans, ...classes)
        },
        {
            as: as,
            bsPrefix: bsPrefix,
            spans: spans
        }
    ];
}
const $08ac016305091294$var$Col = /*#__PURE__*/ $6cds3.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref)=>{
    const [{ className: className, ...colProps }, { as: Component = "div", bsPrefix: bsPrefix, spans: spans }] = $08ac016305091294$export$2ed43d61a0a9f5a3(props);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        ...colProps,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, !spans.length && bsPrefix)
    });
});
$08ac016305091294$var$Col.displayName = "Col";
var $08ac016305091294$export$2e2bcd8739ae039 = $08ac016305091294$var$Col;





"use client";
const $860b21010d77f828$var$FormLabel = /*#__PURE__*/ $6cds3.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "label", bsPrefix: bsPrefix, column: column = false, visuallyHidden: visuallyHidden = false, className: className, htmlFor: htmlFor, ...props }, ref)=>{
    const { controlId: controlId } = (0, $6cds3.useContext)((0, $8c018e7634ec59ca$export$2e2bcd8739ae039));
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "form-label");
    let columnClass = "col-form-label";
    if (typeof column === "string") columnClass = `${columnClass} ${columnClass}-${column}`;
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, bsPrefix, visuallyHidden && "visually-hidden", column && columnClass);
    htmlFor = htmlFor || controlId;
    if (column) return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $08ac016305091294$export$2e2bcd8739ae039), {
        ref: ref,
        as: "label",
        className: classes,
        htmlFor: htmlFor,
        ...props
    });
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control
    (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        ref: ref,
        className: classes,
        htmlFor: htmlFor,
        ...props
    }));
});
$860b21010d77f828$var$FormLabel.displayName = "FormLabel";
var $860b21010d77f828$export$2e2bcd8739ae039 = $860b21010d77f828$var$FormLabel;




var $6cds3 = parcelRequire("6cds3");



"use client";
const $85bcff7de8bc00c9$var$FormRange = /*#__PURE__*/ $6cds3.forwardRef(({ bsPrefix: bsPrefix, className: className, id: id, ...props }, ref)=>{
    const { controlId: controlId } = (0, $6cds3.useContext)((0, $8c018e7634ec59ca$export$2e2bcd8739ae039));
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "form-range");
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
        ...props,
        type: "range",
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, bsPrefix),
        id: id || controlId
    });
});
$85bcff7de8bc00c9$var$FormRange.displayName = "FormRange";
var $85bcff7de8bc00c9$export$2e2bcd8739ae039 = $85bcff7de8bc00c9$var$FormRange;




var $6cds3 = parcelRequire("6cds3");



"use client";
const $3fa7c2ef7ea5570b$var$FormSelect = /*#__PURE__*/ $6cds3.forwardRef(({ bsPrefix: bsPrefix, size: size, htmlSize: htmlSize, className: className, isValid: isValid = false, isInvalid: isInvalid = false, id: id, ...props }, ref)=>{
    const { controlId: controlId } = (0, $6cds3.useContext)((0, $8c018e7634ec59ca$export$2e2bcd8739ae039));
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "form-select");
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("select", {
        ...props,
        size: htmlSize,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, bsPrefix, size && `${bsPrefix}-${size}`, isValid && `is-valid`, isInvalid && `is-invalid`),
        id: id || controlId
    });
});
$3fa7c2ef7ea5570b$var$FormSelect.displayName = "FormSelect";
var $3fa7c2ef7ea5570b$export$2e2bcd8739ae039 = $3fa7c2ef7ea5570b$var$FormSelect;




var $6cds3 = parcelRequire("6cds3");


"use client";
const $66e5cf0b697e4190$var$FormText = /*#__PURE__*/ $6cds3.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix: bsPrefix, className: className, as: Component = "small", muted: muted, ...props }, ref)=>{
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "form-text");
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, bsPrefix, muted && "text-muted")
    });
});
$66e5cf0b697e4190$var$FormText.displayName = "FormText";
var $66e5cf0b697e4190$export$2e2bcd8739ae039 = $66e5cf0b697e4190$var$FormText;



var $6cds3 = parcelRequire("6cds3");


const $b077ca20b43db69e$var$Switch = /*#__PURE__*/ $6cds3.forwardRef((props, ref)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9f9314c2dc5735cc$export$2e2bcd8739ae039), {
        ...props,
        ref: ref,
        type: "switch"
    }));
$b077ca20b43db69e$var$Switch.displayName = "Switch";
var $b077ca20b43db69e$export$2e2bcd8739ae039 = Object.assign($b077ca20b43db69e$var$Switch, {
    Input: (0, $9f9314c2dc5735cc$export$2e2bcd8739ae039).Input,
    Label: (0, $9f9314c2dc5735cc$export$2e2bcd8739ae039).Label
});




var $6cds3 = parcelRequire("6cds3");



"use client";
const $50a3ef04e6072481$var$FloatingLabel = /*#__PURE__*/ $6cds3.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, controlId: controlId, label: label, ...props }, ref)=>{
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "form-floating");
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $074513ec39e88e72$export$2e2bcd8739ae039), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, bsPrefix),
        controlId: controlId,
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("label", {
                htmlFor: controlId,
                children: label
            })
        ]
    });
});
$50a3ef04e6072481$var$FloatingLabel.displayName = "FloatingLabel";
var $50a3ef04e6072481$export$2e2bcd8739ae039 = $50a3ef04e6072481$var$FloatingLabel;



const $5bcc3964c8b09067$var$propTypes = {
    /**
   * The Form `ref` will be forwarded to the underlying element,
   * which means, unless it's rendered `as` a composite component,
   * it will be a DOM node, when resolved.
   *
   * @type {ReactRef}
   * @alias ref
   */ _ref: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).any,
    /**
   * Mark a form as having been validated. Setting it to `true` will
   * toggle any validation styles on the forms elements.
   */ validated: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).elementType
};
const $5bcc3964c8b09067$var$Form = /*#__PURE__*/ $6cds3.forwardRef(({ className: className, validated: validated, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "form", ...props }, ref)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, validated && "was-validated")
    }));
$5bcc3964c8b09067$var$Form.displayName = "Form";
$5bcc3964c8b09067$var$Form.propTypes = $5bcc3964c8b09067$var$propTypes;
var $5bcc3964c8b09067$export$2e2bcd8739ae039 = Object.assign($5bcc3964c8b09067$var$Form, {
    Group: (0, $074513ec39e88e72$export$2e2bcd8739ae039),
    Control: (0, $1ad7d3bae909e73b$export$2e2bcd8739ae039),
    Floating: (0, $6bd7c7ede3e04bee$export$2e2bcd8739ae039),
    Check: (0, $9f9314c2dc5735cc$export$2e2bcd8739ae039),
    Switch: $b077ca20b43db69e$export$2e2bcd8739ae039,
    Label: (0, $860b21010d77f828$export$2e2bcd8739ae039),
    Text: (0, $66e5cf0b697e4190$export$2e2bcd8739ae039),
    Range: (0, $85bcff7de8bc00c9$export$2e2bcd8739ae039),
    Select: (0, $3fa7c2ef7ea5570b$export$2e2bcd8739ae039),
    FloatingLabel: $50a3ef04e6072481$export$2e2bcd8739ae039
});


function $eed97d47c423435d$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $eed97d47c423435d$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $eed97d47c423435d$export$2e2bcd8739ae039(o);
}



function $8c0883e9635940ff$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $eed97d47c423435d$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $eed97d47c423435d$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $ca9f2a3c06394527$export$2e2bcd8739ae039(t) {
    var i = (0, $8c0883e9635940ff$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $eed97d47c423435d$export$2e2bcd8739ae039)(i) ? i : String(i);
}


function $c5ff8c04c412c17d$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $ca9f2a3c06394527$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $fd7f409eefb792f2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fd7f409eefb792f2$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fd7f409eefb792f2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fd7f409eefb792f2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


function $c7e822a596b8c194$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}


function $804b0001382a3e76$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $fcc9984cfdd13319$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $15235f62ba686e41$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $fcc9984cfdd13319$export$2e2bcd8739ae039)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $fcc9984cfdd13319$export$2e2bcd8739ae039)(o, minLen);
}


function $17534272d1aea10e$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $c6d07f6509b171c8$export$2e2bcd8739ae039(arr, i) {
    return (0, $c7e822a596b8c194$export$2e2bcd8739ae039)(arr) || (0, $804b0001382a3e76$export$2e2bcd8739ae039)(arr, i) || (0, $15235f62ba686e41$export$2e2bcd8739ae039)(arr, i) || (0, $17534272d1aea10e$export$2e2bcd8739ae039)();
}



function $3790664e4a835b94$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $6204ff68428e4ae4$export$2e2bcd8739ae039)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}



var $6cds3 = parcelRequire("6cds3");
var $5e78cf16b39d7fc6$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $5e78cf16b39d7fc6$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? "" : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $3790664e4a835b94$export$2e2bcd8739ae039)(_ref, $5e78cf16b39d7fc6$var$_excluded);
    var _useState = (0, $6cds3.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $c6d07f6509b171c8$export$2e2bcd8739ae039)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $6cds3.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $c6d07f6509b171c8$export$2e2bcd8739ae039)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $6cds3.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $c6d07f6509b171c8$export$2e2bcd8739ae039)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $6cds3.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === "function") propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $6cds3.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === "function") newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $6cds3.useCallback)(function() {
        if (typeof propsOnMenuOpen === "function") propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $6cds3.useCallback)(function() {
        if (typeof propsOnMenuClose === "function") propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $fd7f409eefb792f2$export$2e2bcd8739ae039)((0, $fd7f409eefb792f2$export$2e2bcd8739ae039)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}




var $6cds3 = parcelRequire("6cds3");


function $f50e9ddf3899eedf$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}



function $73a5a93d106b2fb4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $ca9f2a3c06394527$export$2e2bcd8739ae039)(descriptor.key), descriptor);
    }
}
function $73a5a93d106b2fb4$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $73a5a93d106b2fb4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $73a5a93d106b2fb4$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}



function $9ac022430c6bab36$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $50859a28edac1620$export$2e2bcd8739ae039)(subClass, superClass);
}


function $939928d339059212$export$2e2bcd8739ae039(o) {
    $939928d339059212$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $939928d339059212$export$2e2bcd8739ae039(o);
}


function $93787dd14a8735f7$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($93787dd14a8735f7$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}



function $a5c883865d903b3c$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $6105dfc2330f8db5$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $eed97d47c423435d$export$2e2bcd8739ae039)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $a5c883865d903b3c$export$2e2bcd8739ae039)(self);
}


function $9113642ee56fc20c$export$2e2bcd8739ae039(Derived) {
    var hasNativeReflectConstruct = (0, $93787dd14a8735f7$export$2e2bcd8739ae039)();
    return function _createSuperInternal() {
        var Super = (0, $939928d339059212$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $939928d339059212$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $6105dfc2330f8db5$export$2e2bcd8739ae039)(this, result);
    };
}



function $9347b80b725c3427$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $fcc9984cfdd13319$export$2e2bcd8739ae039)(arr);
}


function $8ca1e66e961fcfa1$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}



function $479203899f86d351$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $544a4c0a6fa69128$export$2e2bcd8739ae039(arr) {
    return (0, $9347b80b725c3427$export$2e2bcd8739ae039)(arr) || (0, $8ca1e66e961fcfa1$export$2e2bcd8739ae039)(arr) || (0, $15235f62ba686e41$export$2e2bcd8739ae039)(arr) || (0, $479203899f86d351$export$2e2bcd8739ae039)();
}



var $6cds3 = parcelRequire("6cds3");



var $6cds3 = parcelRequire("6cds3");
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $78914a89e069f624$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $78914a89e069f624$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $78914a89e069f624$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($78914a89e069f624$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $78914a89e069f624$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


var $55fca618e7164f46$export$71ad59f2e432cfe8 = "-ms-";
var $55fca618e7164f46$export$2c0f367103c8d01c = "-moz-";
var $55fca618e7164f46$export$39dfd62a25e0fe93 = "-webkit-";
var $55fca618e7164f46$export$a29989082612d0d9 = "comm";
var $55fca618e7164f46$export$aa3a2e812ca8570d = "rule";
var $55fca618e7164f46$export$527d108ccf083c2b = "decl";
var $55fca618e7164f46$export$d3d35020fa5b54f0 = "@page";
var $55fca618e7164f46$export$500415a86c544f73 = "@media";
var $55fca618e7164f46$export$a763edbf796b780a = "@import";
var $55fca618e7164f46$export$2790aeb8b4e5c826 = "@charset";
var $55fca618e7164f46$export$1cc683e23b84b133 = "@viewport";
var $55fca618e7164f46$export$9447a5efea57e862 = "@supports";
var $55fca618e7164f46$export$ef011b4e114b1fba = "@document";
var $55fca618e7164f46$export$6aad947bda0f3f46 = "@namespace";
var $55fca618e7164f46$export$b44a8529a35fcb60 = "@keyframes";
var $55fca618e7164f46$export$2c16de31893252e6 = "@font-face";
var $55fca618e7164f46$export$3d846dd52e150c6f = "@counter-style";
var $55fca618e7164f46$export$22314bfbb57653fe = "@font-feature-values";
var $55fca618e7164f46$export$d773506282b3cfe6 = "@layer";
var $55fca618e7164f46$export$2335f513bbd82c6d = Math.abs;
var $55fca618e7164f46$export$6788812c4e6611e6 = String.fromCharCode;
var $55fca618e7164f46$export$e6e34fd1f2686227 = Object.assign;
function $55fca618e7164f46$export$d6af199866bfb566(e, r) {
    return $55fca618e7164f46$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $55fca618e7164f46$export$a9db5e087081082d(e, 0)) << 2 ^ $55fca618e7164f46$export$a9db5e087081082d(e, 1)) << 2 ^ $55fca618e7164f46$export$a9db5e087081082d(e, 2)) << 2 ^ $55fca618e7164f46$export$a9db5e087081082d(e, 3) : 0;
}
function $55fca618e7164f46$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $55fca618e7164f46$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $55fca618e7164f46$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $55fca618e7164f46$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $55fca618e7164f46$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $55fca618e7164f46$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $55fca618e7164f46$export$36776f635604f274(e) {
    return e.length;
}
function $55fca618e7164f46$export$f9084667e487ed46(e) {
    return e.length;
}
function $55fca618e7164f46$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $55fca618e7164f46$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $55fca618e7164f46$export$53f1d5ea8de3d7c = 1;
var $55fca618e7164f46$export$4e0c71f277ca26b3 = 1;
var $55fca618e7164f46$export$f24224f1c91d8156 = 0;
var $55fca618e7164f46$export$5880b8b5730aff45 = 0;
var $55fca618e7164f46$export$c0306caf338ac095 = 0;
var $55fca618e7164f46$export$30a86d91af8ff6e6 = "";
function $55fca618e7164f46$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $55fca618e7164f46$export$53f1d5ea8de3d7c,
        column: $55fca618e7164f46$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $55fca618e7164f46$export$784d13d8ee351f07(e, r) {
    return $55fca618e7164f46$export$e6e34fd1f2686227($55fca618e7164f46$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $55fca618e7164f46$export$eba6f6f03b0a92e7() {
    return $55fca618e7164f46$export$c0306caf338ac095;
}
function $55fca618e7164f46$export$232faf9add678146() {
    $55fca618e7164f46$export$c0306caf338ac095 = $55fca618e7164f46$export$5880b8b5730aff45 > 0 ? $55fca618e7164f46$export$a9db5e087081082d($55fca618e7164f46$export$30a86d91af8ff6e6, --$55fca618e7164f46$export$5880b8b5730aff45) : 0;
    if ($55fca618e7164f46$export$4e0c71f277ca26b3--, $55fca618e7164f46$export$c0306caf338ac095 === 10) $55fca618e7164f46$export$4e0c71f277ca26b3 = 1, $55fca618e7164f46$export$53f1d5ea8de3d7c--;
    return $55fca618e7164f46$export$c0306caf338ac095;
}
function $55fca618e7164f46$export$48cfd1e771a65c4f() {
    $55fca618e7164f46$export$c0306caf338ac095 = $55fca618e7164f46$export$5880b8b5730aff45 < $55fca618e7164f46$export$f24224f1c91d8156 ? $55fca618e7164f46$export$a9db5e087081082d($55fca618e7164f46$export$30a86d91af8ff6e6, $55fca618e7164f46$export$5880b8b5730aff45++) : 0;
    if ($55fca618e7164f46$export$4e0c71f277ca26b3++, $55fca618e7164f46$export$c0306caf338ac095 === 10) $55fca618e7164f46$export$4e0c71f277ca26b3 = 1, $55fca618e7164f46$export$53f1d5ea8de3d7c++;
    return $55fca618e7164f46$export$c0306caf338ac095;
}
function $55fca618e7164f46$export$4d3fb11e950abb9e() {
    return $55fca618e7164f46$export$a9db5e087081082d($55fca618e7164f46$export$30a86d91af8ff6e6, $55fca618e7164f46$export$5880b8b5730aff45);
}
function $55fca618e7164f46$export$e88cb2efb12ae807() {
    return $55fca618e7164f46$export$5880b8b5730aff45;
}
function $55fca618e7164f46$export$58adb3bec8346d0f(e, r) {
    return $55fca618e7164f46$export$2f35ab04d2335697($55fca618e7164f46$export$30a86d91af8ff6e6, e, r);
}
function $55fca618e7164f46$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $55fca618e7164f46$export$2de70f21292aac9e(e) {
    return $55fca618e7164f46$export$53f1d5ea8de3d7c = $55fca618e7164f46$export$4e0c71f277ca26b3 = 1, $55fca618e7164f46$export$f24224f1c91d8156 = $55fca618e7164f46$export$36776f635604f274($55fca618e7164f46$export$30a86d91af8ff6e6 = e), $55fca618e7164f46$export$5880b8b5730aff45 = 0, [];
}
function $55fca618e7164f46$export$45918ac1574455b1(e) {
    return $55fca618e7164f46$export$30a86d91af8ff6e6 = "", e;
}
function $55fca618e7164f46$export$410ac95b9ec204b8(e) {
    return $55fca618e7164f46$export$87c2784dc9fc4ab($55fca618e7164f46$export$58adb3bec8346d0f($55fca618e7164f46$export$5880b8b5730aff45 - 1, $55fca618e7164f46$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $55fca618e7164f46$export$660b2ee2d4fb4eff(e) {
    return $55fca618e7164f46$export$45918ac1574455b1($55fca618e7164f46$export$5f8c09e3ae6f64e1($55fca618e7164f46$export$2de70f21292aac9e(e)));
}
function $55fca618e7164f46$export$7af1228ff777d175(e) {
    while($55fca618e7164f46$export$c0306caf338ac095 = $55fca618e7164f46$export$4d3fb11e950abb9e())if ($55fca618e7164f46$export$c0306caf338ac095 < 33) $55fca618e7164f46$export$48cfd1e771a65c4f();
    else break;
    return $55fca618e7164f46$export$9e1725a4cfeada27(e) > 2 || $55fca618e7164f46$export$9e1725a4cfeada27($55fca618e7164f46$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $55fca618e7164f46$export$5f8c09e3ae6f64e1(e) {
    while($55fca618e7164f46$export$48cfd1e771a65c4f())switch($55fca618e7164f46$export$9e1725a4cfeada27($55fca618e7164f46$export$c0306caf338ac095)){
        case 0:
            $55fca618e7164f46$export$10d8903dec122b9d($55fca618e7164f46$export$c2ab62c7bf24634($55fca618e7164f46$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $55fca618e7164f46$export$10d8903dec122b9d($55fca618e7164f46$export$410ac95b9ec204b8($55fca618e7164f46$export$c0306caf338ac095), e);
            break;
        default:
            $55fca618e7164f46$export$10d8903dec122b9d($55fca618e7164f46$export$6788812c4e6611e6($55fca618e7164f46$export$c0306caf338ac095), e);
    }
    return e;
}
function $55fca618e7164f46$export$955ba06d119e085e(e, r) {
    while(--r && $55fca618e7164f46$export$48cfd1e771a65c4f())if ($55fca618e7164f46$export$c0306caf338ac095 < 48 || $55fca618e7164f46$export$c0306caf338ac095 > 102 || $55fca618e7164f46$export$c0306caf338ac095 > 57 && $55fca618e7164f46$export$c0306caf338ac095 < 65 || $55fca618e7164f46$export$c0306caf338ac095 > 70 && $55fca618e7164f46$export$c0306caf338ac095 < 97) break;
    return $55fca618e7164f46$export$58adb3bec8346d0f(e, $55fca618e7164f46$export$e88cb2efb12ae807() + (r < 6 && $55fca618e7164f46$export$4d3fb11e950abb9e() == 32 && $55fca618e7164f46$export$48cfd1e771a65c4f() == 32));
}
function $55fca618e7164f46$export$c889f2fcc19dbf12(e) {
    while($55fca618e7164f46$export$48cfd1e771a65c4f())switch($55fca618e7164f46$export$c0306caf338ac095){
        case e:
            return $55fca618e7164f46$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $55fca618e7164f46$export$c889f2fcc19dbf12($55fca618e7164f46$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $55fca618e7164f46$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $55fca618e7164f46$export$48cfd1e771a65c4f();
            break;
    }
    return $55fca618e7164f46$export$5880b8b5730aff45;
}
function $55fca618e7164f46$export$4254d4e2b3745c4c(e, r) {
    while($55fca618e7164f46$export$48cfd1e771a65c4f())if (e + $55fca618e7164f46$export$c0306caf338ac095 === 57) break;
    else if (e + $55fca618e7164f46$export$c0306caf338ac095 === 84 && $55fca618e7164f46$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $55fca618e7164f46$export$58adb3bec8346d0f(r, $55fca618e7164f46$export$5880b8b5730aff45 - 1) + "*" + $55fca618e7164f46$export$6788812c4e6611e6(e === 47 ? e : $55fca618e7164f46$export$48cfd1e771a65c4f());
}
function $55fca618e7164f46$export$c2ab62c7bf24634(e) {
    while(!$55fca618e7164f46$export$9e1725a4cfeada27($55fca618e7164f46$export$4d3fb11e950abb9e()))$55fca618e7164f46$export$48cfd1e771a65c4f();
    return $55fca618e7164f46$export$58adb3bec8346d0f(e, $55fca618e7164f46$export$5880b8b5730aff45);
}
function $55fca618e7164f46$export$ef7acd7185315e22(e) {
    return $55fca618e7164f46$export$45918ac1574455b1($55fca618e7164f46$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $55fca618e7164f46$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $55fca618e7164f46$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $55fca618e7164f46$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $55fca618e7164f46$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($55fca618e7164f46$export$f8e21b1e77979a08(j += $55fca618e7164f46$export$77ad94ebf1c2b9ed($55fca618e7164f46$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $55fca618e7164f46$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $55fca618e7164f46$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $55fca618e7164f46$export$955ba06d119e085e($55fca618e7164f46$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($55fca618e7164f46$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $55fca618e7164f46$export$10d8903dec122b9d($55fca618e7164f46$export$4a34f930e789283c($55fca618e7164f46$export$4254d4e2b3745c4c($55fca618e7164f46$export$48cfd1e771a65c4f(), $55fca618e7164f46$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $55fca618e7164f46$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $55fca618e7164f46$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $55fca618e7164f46$export$36776f635604f274(j) - l) $55fca618e7164f46$export$10d8903dec122b9d(p > 32 ? $55fca618e7164f46$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $55fca618e7164f46$export$f8483753829ec8f3($55fca618e7164f46$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $55fca618e7164f46$export$10d8903dec122b9d(y = $55fca618e7164f46$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $55fca618e7164f46$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $55fca618e7164f46$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $55fca618e7164f46$export$98e6a39c04603d36(e, y, y, n && $55fca618e7164f46$export$10d8903dec122b9d($55fca618e7164f46$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $55fca618e7164f46$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $55fca618e7164f46$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $55fca618e7164f46$export$232faf9add678146() == 125) continue;
            }
            switch(j += $55fca618e7164f46$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($55fca618e7164f46$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($55fca618e7164f46$export$4d3fb11e950abb9e() === 45) j += $55fca618e7164f46$export$410ac95b9ec204b8($55fca618e7164f46$export$48cfd1e771a65c4f());
                    v = $55fca618e7164f46$export$4d3fb11e950abb9e(), o = l = $55fca618e7164f46$export$36776f635604f274(g = j += $55fca618e7164f46$export$c2ab62c7bf24634($55fca618e7164f46$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $55fca618e7164f46$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $55fca618e7164f46$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $55fca618e7164f46$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $55fca618e7164f46$export$2f35ab04d2335697(e, v + 1, v = $55fca618e7164f46$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $55fca618e7164f46$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $55fca618e7164f46$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $55fca618e7164f46$export$35059013cd4a06db(e, r, a, s === 0 ? $55fca618e7164f46$export$aa3a2e812ca8570d : i, f, o, l);
}
function $55fca618e7164f46$export$4a34f930e789283c(e, r, a) {
    return $55fca618e7164f46$export$35059013cd4a06db(e, r, a, $55fca618e7164f46$export$a29989082612d0d9, $55fca618e7164f46$export$6788812c4e6611e6($55fca618e7164f46$export$eba6f6f03b0a92e7()), $55fca618e7164f46$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $55fca618e7164f46$export$f8483753829ec8f3(e, r, a, n) {
    return $55fca618e7164f46$export$35059013cd4a06db(e, r, a, $55fca618e7164f46$export$527d108ccf083c2b, $55fca618e7164f46$export$2f35ab04d2335697(e, 0, n), $55fca618e7164f46$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $55fca618e7164f46$export$82e9f45cca5ba907(n, c, s) {
    switch($55fca618e7164f46$export$d6af199866bfb566(n, c)){
        case 5103:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $55fca618e7164f46$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$2c0f367103c8d01c + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($55fca618e7164f46$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $55fca618e7164f46$export$39dfd62a25e0fe93 + "box-$1$2" + $55fca618e7164f46$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + "flex-item-" + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$55fca618e7164f46$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $55fca618e7164f46$export$71ad59f2e432cfe8 + "grid-row-" + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + "flex-line-pack" + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + "box-" + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, "-grow", "") + $55fca618e7164f46$export$39dfd62a25e0fe93 + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $55fca618e7164f46$export$39dfd62a25e0fe93 + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $55fca618e7164f46$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $55fca618e7164f46$export$77ad94ebf1c2b9ed($55fca618e7164f46$export$77ad94ebf1c2b9ed($55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $55fca618e7164f46$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $55fca618e7164f46$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $55fca618e7164f46$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $55fca618e7164f46$export$77ad94ebf1c2b9ed($55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $55fca618e7164f46$export$39dfd62a25e0fe93 + "box-pack:$3" + $55fca618e7164f46$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $55fca618e7164f46$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$55fca618e7164f46$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $55fca618e7164f46$export$71ad59f2e432cfe8 + "grid-column-align" + $55fca618e7164f46$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $55fca618e7164f46$export$71ad59f2e432cfe8 + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $55fca618e7164f46$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$55fca618e7164f46$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $55fca618e7164f46$export$71ad59f2e432cfe8 + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $55fca618e7164f46$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$55fca618e7164f46$export$f8e21b1e77979a08(s, "span") ? $55fca618e7164f46$export$4659b591c19bdf3d(s, /\d+/) : +$55fca618e7164f46$export$4659b591c19bdf3d(s, /\d+/) - +$55fca618e7164f46$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $55fca618e7164f46$export$71ad59f2e432cfe8 + $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $55fca618e7164f46$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $55fca618e7164f46$export$71ad59f2e432cfe8 + $55fca618e7164f46$export$77ad94ebf1c2b9ed($55fca618e7164f46$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $55fca618e7164f46$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($55fca618e7164f46$export$36776f635604f274(n) - 1 - c > 6) switch($55fca618e7164f46$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($55fca618e7164f46$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $55fca618e7164f46$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $55fca618e7164f46$export$2c0f367103c8d01c + ($55fca618e7164f46$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$55fca618e7164f46$export$f8e21b1e77979a08(n, "stretch") ? $55fca618e7164f46$export$82e9f45cca5ba907($55fca618e7164f46$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $55fca618e7164f46$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $55fca618e7164f46$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($55fca618e7164f46$export$a9db5e087081082d(n, c + 6) === 121) return $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, ":", ":" + $55fca618e7164f46$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($55fca618e7164f46$export$a9db5e087081082d(n, $55fca618e7164f46$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $55fca618e7164f46$export$39dfd62a25e0fe93 + ($55fca618e7164f46$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $55fca618e7164f46$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $55fca618e7164f46$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, ":", ":" + $55fca618e7164f46$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $55fca618e7164f46$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $55fca618e7164f46$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $55fca618e7164f46$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $55fca618e7164f46$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $55fca618e7164f46$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $55fca618e7164f46$export$a763edbf796b780a:
        case $55fca618e7164f46$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $55fca618e7164f46$export$a29989082612d0d9:
            return "";
        case $55fca618e7164f46$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $55fca618e7164f46$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $55fca618e7164f46$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $55fca618e7164f46$export$36776f635604f274(a = $55fca618e7164f46$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $55fca618e7164f46$export$5a7767152ae0305f(e) {
    var r = $55fca618e7164f46$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $55fca618e7164f46$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $55fca618e7164f46$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $55fca618e7164f46$export$527d108ccf083c2b:
                n.return = $55fca618e7164f46$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $55fca618e7164f46$export$b44a8529a35fcb60:
                return $55fca618e7164f46$export$dfdc1655ccc5b9cb([
                    $55fca618e7164f46$export$784d13d8ee351f07(n, {
                        value: $55fca618e7164f46$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $55fca618e7164f46$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $55fca618e7164f46$export$aa3a2e812ca8570d:
                if (n.length) return $55fca618e7164f46$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($55fca618e7164f46$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $55fca618e7164f46$export$dfdc1655ccc5b9cb([
                                $55fca618e7164f46$export$784d13d8ee351f07(n, {
                                    props: [
                                        $55fca618e7164f46$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $55fca618e7164f46$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $55fca618e7164f46$export$dfdc1655ccc5b9cb([
                                $55fca618e7164f46$export$784d13d8ee351f07(n, {
                                    props: [
                                        $55fca618e7164f46$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $55fca618e7164f46$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $55fca618e7164f46$export$784d13d8ee351f07(n, {
                                    props: [
                                        $55fca618e7164f46$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $55fca618e7164f46$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $55fca618e7164f46$export$784d13d8ee351f07(n, {
                                    props: [
                                        $55fca618e7164f46$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $55fca618e7164f46$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $55fca618e7164f46$export$76a88f7de6507443(e) {
    switch(e.type){
        case $55fca618e7164f46$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $55fca618e7164f46$export$1be1fc439b849fdf($55fca618e7164f46$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($55fca618e7164f46$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $55fca618e7164f46$export$2f35ab04d2335697(r, 1, $55fca618e7164f46$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $55fca618e7164f46$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $55fca618e7164f46$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $55fca618e7164f46$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $db59aaf4afe46724$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};


function $cc7fdb626f425e02$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $4d6bef5101ace00d$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $55fca618e7164f46$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $55fca618e7164f46$export$9e1725a4cfeada27)(character)) break;
        (0, $55fca618e7164f46$export$48cfd1e771a65c4f)();
    }
    return (0, $55fca618e7164f46$export$58adb3bec8346d0f)(begin, (0, $55fca618e7164f46$export$5880b8b5730aff45));
};
var $4d6bef5101ace00d$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $55fca618e7164f46$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $55fca618e7164f46$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $4d6bef5101ace00d$var$identifierWithPointTracking((0, $55fca618e7164f46$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $55fca618e7164f46$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $55fca618e7164f46$export$4d3fb11e950abb9e)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $55fca618e7164f46$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $55fca618e7164f46$export$48cfd1e771a65c4f)());
    return parsed;
};
var $4d6bef5101ace00d$var$getRules = function getRules(value, points) {
    return (0, $55fca618e7164f46$export$45918ac1574455b1)($4d6bef5101ace00d$var$toRules((0, $55fca618e7164f46$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $4d6bef5101ace00d$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $4d6bef5101ace00d$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$4d6bef5101ace00d$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $4d6bef5101ace00d$var$fixedElements.set(element, true);
    var points = [];
    var rules = $4d6bef5101ace00d$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $4d6bef5101ace00d$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $4d6bef5101ace00d$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $4d6bef5101ace00d$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($4d6bef5101ace00d$var$ignoreFlag) > -1;
};
var $4d6bef5101ace00d$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($4d6bef5101ace00d$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $4d6bef5101ace00d$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $4d6bef5101ace00d$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$4d6bef5101ace00d$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $4d6bef5101ace00d$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $4d6bef5101ace00d$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$4d6bef5101ace00d$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $4d6bef5101ace00d$var$nullifyElement(element);
    } else if ($4d6bef5101ace00d$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $4d6bef5101ace00d$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $4d6bef5101ace00d$var$prefix(value, length) {
    switch((0, $55fca618e7164f46$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $55fca618e7164f46$export$39dfd62a25e0fe93) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $55fca618e7164f46$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $55fca618e7164f46$export$39dfd62a25e0fe93) + value + (0, $55fca618e7164f46$export$2c0f367103c8d01c) + value + (0, $55fca618e7164f46$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $55fca618e7164f46$export$39dfd62a25e0fe93) + value + (0, $55fca618e7164f46$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $55fca618e7164f46$export$39dfd62a25e0fe93) + value + (0, $55fca618e7164f46$export$71ad59f2e432cfe8) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $55fca618e7164f46$export$39dfd62a25e0fe93) + value + (0, $55fca618e7164f46$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $55fca618e7164f46$export$39dfd62a25e0fe93) + "box-$1$2" + (0, $55fca618e7164f46$export$71ad59f2e432cfe8) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $55fca618e7164f46$export$39dfd62a25e0fe93) + value + (0, $55fca618e7164f46$export$71ad59f2e432cfe8) + "flex-item-" + (0, $55fca618e7164f46$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $55fca618e7164f46$export$39dfd62a25e0fe93) + value + (0, $55fca618e7164f46$export$71ad59f2e432cfe8) + "flex-line-pack" + (0, $55fca618e7164f46$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $55fca618e7164f46$export$39dfd62a25e0fe93) + value + (0, $55fca618e7164f46$export$71ad59f2e432cfe8) + (0, $55fca618e7164f46$export$77ad94ebf1c2b9ed)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $55fca618e7164f46$export$39dfd62a25e0fe93) + value + (0, $55fca618e7164f46$export$71ad59f2e432cfe8) + (0, $55fca618e7164f46$export$77ad94ebf1c2b9ed)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $55fca618e7164f46$export$39dfd62a25e0fe93) + "box-" + (0, $55fca618e7164f46$export$77ad94ebf1c2b9ed)(value, "-grow", "") + (0, $55fca618e7164f46$export$39dfd62a25e0fe93) + value + (0, $55fca618e7164f46$export$71ad59f2e432cfe8) + (0, $55fca618e7164f46$export$77ad94ebf1c2b9ed)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $55fca618e7164f46$export$39dfd62a25e0fe93) + (0, $55fca618e7164f46$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, "$1" + (0, $55fca618e7164f46$export$39dfd62a25e0fe93) + "$2") + value;
        // cursor
        case 6187:
            return (0, $55fca618e7164f46$export$77ad94ebf1c2b9ed)((0, $55fca618e7164f46$export$77ad94ebf1c2b9ed)((0, $55fca618e7164f46$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $55fca618e7164f46$export$39dfd62a25e0fe93) + "$1"), /(image-set)/, (0, $55fca618e7164f46$export$39dfd62a25e0fe93) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $55fca618e7164f46$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $55fca618e7164f46$export$39dfd62a25e0fe93) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $55fca618e7164f46$export$77ad94ebf1c2b9ed)((0, $55fca618e7164f46$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $55fca618e7164f46$export$39dfd62a25e0fe93) + "box-pack:$3" + (0, $55fca618e7164f46$export$71ad59f2e432cfe8) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $55fca618e7164f46$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $55fca618e7164f46$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $55fca618e7164f46$export$39dfd62a25e0fe93) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $55fca618e7164f46$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $55fca618e7164f46$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $55fca618e7164f46$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $55fca618e7164f46$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $55fca618e7164f46$export$39dfd62a25e0fe93) + "$2-$3" + "$1" + (0, $55fca618e7164f46$export$2c0f367103c8d01c) + ((0, $55fca618e7164f46$export$a9db5e087081082d)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $55fca618e7164f46$export$f8e21b1e77979a08)(value, "stretch") ? $4d6bef5101ace00d$var$prefix((0, $55fca618e7164f46$export$77ad94ebf1c2b9ed)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $55fca618e7164f46$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $55fca618e7164f46$export$a9db5e087081082d)(value, (0, $55fca618e7164f46$export$36776f635604f274)(value) - 3 - (~(0, $55fca618e7164f46$export$f8e21b1e77979a08)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $55fca618e7164f46$export$77ad94ebf1c2b9ed)(value, ":", ":" + (0, $55fca618e7164f46$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $55fca618e7164f46$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $55fca618e7164f46$export$39dfd62a25e0fe93) + ((0, $55fca618e7164f46$export$a9db5e087081082d)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $55fca618e7164f46$export$39dfd62a25e0fe93) + "$2$3" + "$1" + (0, $55fca618e7164f46$export$71ad59f2e432cfe8) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $55fca618e7164f46$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $55fca618e7164f46$export$39dfd62a25e0fe93) + value + (0, $55fca618e7164f46$export$71ad59f2e432cfe8) + (0, $55fca618e7164f46$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $55fca618e7164f46$export$39dfd62a25e0fe93) + value + (0, $55fca618e7164f46$export$71ad59f2e432cfe8) + (0, $55fca618e7164f46$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $55fca618e7164f46$export$39dfd62a25e0fe93) + value + (0, $55fca618e7164f46$export$71ad59f2e432cfe8) + (0, $55fca618e7164f46$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $55fca618e7164f46$export$39dfd62a25e0fe93) + value + (0, $55fca618e7164f46$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $4d6bef5101ace00d$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $55fca618e7164f46$export$527d108ccf083c2b:
                element["return"] = $4d6bef5101ace00d$var$prefix(element.value, element.length);
                break;
            case 0, $55fca618e7164f46$export$b44a8529a35fcb60:
                return (0, $55fca618e7164f46$export$dfdc1655ccc5b9cb)([
                    (0, $55fca618e7164f46$export$784d13d8ee351f07)(element, {
                        value: (0, $55fca618e7164f46$export$77ad94ebf1c2b9ed)(element.value, "@", "@" + (0, $55fca618e7164f46$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $55fca618e7164f46$export$aa3a2e812ca8570d:
                if (element.length) return (0, $55fca618e7164f46$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $55fca618e7164f46$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $55fca618e7164f46$export$dfdc1655ccc5b9cb)([
                                (0, $55fca618e7164f46$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $55fca618e7164f46$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ":" + (0, $55fca618e7164f46$export$2c0f367103c8d01c) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $55fca618e7164f46$export$dfdc1655ccc5b9cb)([
                                (0, $55fca618e7164f46$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $55fca618e7164f46$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ":" + (0, $55fca618e7164f46$export$39dfd62a25e0fe93) + "input-$1")
                                    ]
                                }),
                                (0, $55fca618e7164f46$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $55fca618e7164f46$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ":" + (0, $55fca618e7164f46$export$2c0f367103c8d01c) + "$1")
                                    ]
                                }),
                                (0, $55fca618e7164f46$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $55fca618e7164f46$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $55fca618e7164f46$export$71ad59f2e432cfe8) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $4d6bef5101ace00d$var$defaultStylisPlugins = [
    $4d6bef5101ace00d$var$prefixer
];
var $4d6bef5101ace00d$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $4d6bef5101ace00d$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $4d6bef5101ace00d$var$compat,
        $4d6bef5101ace00d$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $55fca618e7164f46$export$fac44ee5b035f737),
        (0, $55fca618e7164f46$export$38bcb760f1d4871c)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $55fca618e7164f46$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $55fca618e7164f46$export$dfdc1655ccc5b9cb)((0, $55fca618e7164f46$export$ef7acd7185315e22)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $78914a89e069f624$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};




var $af10e3f63daf3025$exports = {};
"use strict";
var $426c7baebabc049b$exports = {};
"use strict";

$426c7baebabc049b$exports = (parcelRequire("hFtc0"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $af10e3f63daf3025$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $af10e3f63daf3025$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $af10e3f63daf3025$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $af10e3f63daf3025$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $af10e3f63daf3025$var$TYPE_STATICS = {};
$af10e3f63daf3025$var$TYPE_STATICS[$426c7baebabc049b$exports.ForwardRef] = $af10e3f63daf3025$var$FORWARD_REF_STATICS;
$af10e3f63daf3025$var$TYPE_STATICS[$426c7baebabc049b$exports.Memo] = $af10e3f63daf3025$var$MEMO_STATICS;
function $af10e3f63daf3025$var$getStatics(component) {
    // React v16.11 and below
    if ($426c7baebabc049b$exports.isMemo(component)) return $af10e3f63daf3025$var$MEMO_STATICS;
     // React v16.12 and above
    return $af10e3f63daf3025$var$TYPE_STATICS[component["$$typeof"]] || $af10e3f63daf3025$var$REACT_STATICS;
}
var $af10e3f63daf3025$var$defineProperty = Object.defineProperty;
var $af10e3f63daf3025$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $af10e3f63daf3025$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $af10e3f63daf3025$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $af10e3f63daf3025$var$getPrototypeOf = Object.getPrototypeOf;
var $af10e3f63daf3025$var$objectPrototype = Object.prototype;
function $af10e3f63daf3025$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($af10e3f63daf3025$var$objectPrototype) {
            var inheritedComponent = $af10e3f63daf3025$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $af10e3f63daf3025$var$objectPrototype) $af10e3f63daf3025$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $af10e3f63daf3025$var$getOwnPropertyNames(sourceComponent);
        if ($af10e3f63daf3025$var$getOwnPropertySymbols) keys = keys.concat($af10e3f63daf3025$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $af10e3f63daf3025$var$getStatics(targetComponent);
        var sourceStatics = $af10e3f63daf3025$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$af10e3f63daf3025$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $af10e3f63daf3025$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $af10e3f63daf3025$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$af10e3f63daf3025$exports = $af10e3f63daf3025$var$hoistNonReactStatics;


// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $f7e3536e590c5735$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($af10e3f63daf3025$exports)))(targetComponent, sourceComponent);
};


var $e07ed173578a1d54$var$isBrowser = true;
function $e07ed173578a1d54$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $e07ed173578a1d54$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $e07ed173578a1d54$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $e07ed173578a1d54$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $e07ed173578a1d54$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $f0870afdfe966906$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $b62f2dc75e2ff17e$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $85a93a92bf0430bc$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $85a93a92bf0430bc$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $85a93a92bf0430bc$var$hyphenateRegex = /[A-Z]|^ms/g;
var $85a93a92bf0430bc$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $85a93a92bf0430bc$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $85a93a92bf0430bc$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $85a93a92bf0430bc$var$processStyleName = /* #__PURE__ */ (0, $cc7fdb626f425e02$export$2e2bcd8739ae039)(function(styleName) {
    return $85a93a92bf0430bc$var$isCustomProperty(styleName) ? styleName : styleName.replace($85a93a92bf0430bc$var$hyphenateRegex, "-$&").toLowerCase();
});
var $85a93a92bf0430bc$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($85a93a92bf0430bc$var$animationRegex, function(match, p1, p2) {
                $85a93a92bf0430bc$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $85a93a92bf0430bc$var$cursor
                };
                return p1;
            });
    }
    if ((0, $b62f2dc75e2ff17e$export$2e2bcd8739ae039)[key] !== 1 && !$85a93a92bf0430bc$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $85a93a92bf0430bc$var$contentValuePattern, $85a93a92bf0430bc$var$contentValues, $85a93a92bf0430bc$var$oldProcessStyleValue, $85a93a92bf0430bc$var$msPattern, $85a93a92bf0430bc$var$hyphenPattern, $85a93a92bf0430bc$var$hyphenatedCache;
var $85a93a92bf0430bc$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $85a93a92bf0430bc$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $85a93a92bf0430bc$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $85a93a92bf0430bc$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $85a93a92bf0430bc$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $85a93a92bf0430bc$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $85a93a92bf0430bc$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $85a93a92bf0430bc$var$cursor;
                var result = interpolation(mergedProps);
                $85a93a92bf0430bc$var$cursor = previousCursor;
                return $85a93a92bf0430bc$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $85a93a92bf0430bc$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $85a93a92bf0430bc$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($85a93a92bf0430bc$var$isProcessableValue(value)) string += $85a93a92bf0430bc$var$processStyleName(_key) + ":" + $85a93a92bf0430bc$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($85a93a92bf0430bc$var$isProcessableValue(value[_i])) string += $85a93a92bf0430bc$var$processStyleName(_key) + ":" + $85a93a92bf0430bc$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $85a93a92bf0430bc$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $85a93a92bf0430bc$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $85a93a92bf0430bc$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $85a93a92bf0430bc$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $85a93a92bf0430bc$var$cursor;
var $85a93a92bf0430bc$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $85a93a92bf0430bc$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $85a93a92bf0430bc$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $85a93a92bf0430bc$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $85a93a92bf0430bc$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $85a93a92bf0430bc$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $f0870afdfe966906$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $85a93a92bf0430bc$var$cursor
    };
};



var $6cds3 = parcelRequire("6cds3");
var $71f3b247da06e75a$var$syncFallback = function syncFallback(create) {
    return create();
};
var $71f3b247da06e75a$var$useInsertionEffect = $6cds3.useInsertionEffect ? $6cds3.useInsertionEffect : false;
var $71f3b247da06e75a$export$db21c7ffa21794e7 = $71f3b247da06e75a$var$useInsertionEffect || $71f3b247da06e75a$var$syncFallback;
var $71f3b247da06e75a$export$811a713a7276cb9d = $71f3b247da06e75a$var$useInsertionEffect || $6cds3.useLayoutEffect;


var $d45a4a2414093d11$export$23f2a1d2818174ef = true;
var $d45a4a2414093d11$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $d45a4a2414093d11$var$EmotionCacheContext = /* #__PURE__ */ $6cds3.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $4d6bef5101ace00d$export$2e2bcd8739ae039)({
    key: "css"
}) : null);
var $d45a4a2414093d11$export$e7094788287c5e9b = $d45a4a2414093d11$var$EmotionCacheContext.Provider;
var $d45a4a2414093d11$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $6cds3.useContext)($d45a4a2414093d11$var$EmotionCacheContext);
};
var $d45a4a2414093d11$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $6cds3.useContext)($d45a4a2414093d11$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$d45a4a2414093d11$export$23f2a1d2818174ef) $d45a4a2414093d11$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $6cds3.useContext)($d45a4a2414093d11$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $4d6bef5101ace00d$export$2e2bcd8739ae039)({
                key: "css"
            });
            return /*#__PURE__*/ $6cds3.createElement($d45a4a2414093d11$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $d45a4a2414093d11$export$971d5caa766a69d7 = /* #__PURE__ */ $6cds3.createContext({});
var $d45a4a2414093d11$export$3b14a55fb2447963 = function useTheme() {
    return $6cds3.useContext($d45a4a2414093d11$export$971d5caa766a69d7);
};
var $d45a4a2414093d11$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, outerTheme, theme);
};
var $d45a4a2414093d11$var$createCacheWithTheme = /* #__PURE__ */ (0, $db59aaf4afe46724$export$2e2bcd8739ae039)(function(outerTheme) {
    return (0, $db59aaf4afe46724$export$2e2bcd8739ae039)(function(theme) {
        return $d45a4a2414093d11$var$getTheme(outerTheme, theme);
    });
});
var $d45a4a2414093d11$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $6cds3.useContext($d45a4a2414093d11$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $d45a4a2414093d11$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $6cds3.createElement($d45a4a2414093d11$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $d45a4a2414093d11$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $6cds3.useContext($d45a4a2414093d11$export$971d5caa766a69d7);
        return /*#__PURE__*/ $6cds3.createElement(Component, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $6cds3.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $f7e3536e590c5735$export$2e2bcd8739ae039)(WithTheme, Component);
}
var $d45a4a2414093d11$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $d45a4a2414093d11$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $d45a4a2414093d11$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $d45a4a2414093d11$var$getLastPart(match[1]);
    return undefined;
};
var $d45a4a2414093d11$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $d45a4a2414093d11$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $d45a4a2414093d11$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $d45a4a2414093d11$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($d45a4a2414093d11$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $d45a4a2414093d11$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $d45a4a2414093d11$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $d45a4a2414093d11$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $d45a4a2414093d11$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($d45a4a2414093d11$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$d45a4a2414093d11$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $d45a4a2414093d11$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $e07ed173578a1d54$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    (0, $71f3b247da06e75a$export$db21c7ffa21794e7)(function() {
        return (0, $e07ed173578a1d54$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    return null;
};
var $d45a4a2414093d11$var$Emotion = /* #__PURE__ */ $d45a4a2414093d11$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$d45a4a2414093d11$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $e07ed173578a1d54$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $85a93a92bf0430bc$export$6321afa313b251b5)(registeredStyles, undefined, $6cds3.useContext($d45a4a2414093d11$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($d45a4a2414093d11$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $d45a4a2414093d11$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $6cds3.createElement($6cds3.Fragment, null, /*#__PURE__*/ $6cds3.createElement($d45a4a2414093d11$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $6cds3.createElement(WrappedComponent, newProps));
});
var $d45a4a2414093d11$export$a9c23c6ac3fc3eca = $d45a4a2414093d11$var$Emotion;



var $6cds3 = parcelRequire("6cds3");








var $dacd7d2074e32fea$var$pkg = {
    name: "@emotion/react",
    version: "11.11.3",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.3",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.2",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $dacd7d2074e32fea$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $d45a4a2414093d11$export$dda1d9f60106f0e9).call(props, "css")) // $FlowFixMe
    return $6cds3.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $d45a4a2414093d11$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $d45a4a2414093d11$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $6cds3.createElement.apply(null, createElementArgArray);
};
var $dacd7d2074e32fea$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $dacd7d2074e32fea$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $d45a4a2414093d11$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $85a93a92bf0430bc$export$6321afa313b251b5)([
        styles
    ], undefined, $6cds3.useContext((0, $d45a4a2414093d11$export$971d5caa766a69d7)));
    if (!(0, $d45a4a2414093d11$export$23f2a1d2818174ef)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $6cds3.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $6cds3.useRef();
    (0, $71f3b247da06e75a$export$811a713a7276cb9d)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $71f3b247da06e75a$export$811a713a7276cb9d)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $e07ed173578a1d54$export$6f077d94b33a01aa)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $dacd7d2074e32fea$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $85a93a92bf0430bc$export$6321afa313b251b5)(args);
}
var $dacd7d2074e32fea$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $dacd7d2074e32fea$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $dacd7d2074e32fea$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $dacd7d2074e32fea$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $e07ed173578a1d54$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $dacd7d2074e32fea$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $71f3b247da06e75a$export$db21c7ffa21794e7)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $e07ed173578a1d54$export$6f077d94b33a01aa)(cache, serializedArr[i], false);
    });
    return null;
};
var $dacd7d2074e32fea$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $d45a4a2414093d11$export$efccba1c4a2ef57b)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $85a93a92bf0430bc$export$6321afa313b251b5)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $e07ed173578a1d54$export$580009a5da2a8b4b)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $dacd7d2074e32fea$var$merge(cache.registered, css, $dacd7d2074e32fea$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $6cds3.useContext((0, $d45a4a2414093d11$export$971d5caa766a69d7))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $6cds3.createElement($6cds3.Fragment, null, /*#__PURE__*/ $6cds3.createElement($dacd7d2074e32fea$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $dacd7d2074e32fea$var$isBrowser, $dacd7d2074e32fea$var$isTestEnv, $dacd7d2074e32fea$var$globalContext, $dacd7d2074e32fea$var$globalKey;





function $026910be6cf4e9f3$export$2e2bcd8739ae039(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}




var $6cds3 = parcelRequire("6cds3");

/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $3a46a5f0b2822573$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $3a46a5f0b2822573$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $3a46a5f0b2822573$export$803cd8101b6c182b = /*#__PURE__*/ $3a46a5f0b2822573$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $3a46a5f0b2822573$export$27b07d8a310ed8b5[0], side + "-" + $3a46a5f0b2822573$export$27b07d8a310ed8b5[1]), []);
const $3a46a5f0b2822573$export$96ec731ed4dcb222 = Math.min;
const $3a46a5f0b2822573$export$8960430cfd85939f = Math.max;
const $3a46a5f0b2822573$export$2077e0241d6afd3c = Math.round;
const $3a46a5f0b2822573$export$a3fe094919f356fd = Math.floor;
const $3a46a5f0b2822573$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $3a46a5f0b2822573$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $3a46a5f0b2822573$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $3a46a5f0b2822573$export$7d15b64cf5a3a4c4(start, value, end) {
    return $3a46a5f0b2822573$export$8960430cfd85939f(start, $3a46a5f0b2822573$export$96ec731ed4dcb222(value, end));
}
function $3a46a5f0b2822573$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $3a46a5f0b2822573$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $3a46a5f0b2822573$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $3a46a5f0b2822573$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $3a46a5f0b2822573$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $3a46a5f0b2822573$export$f28e8f882010718a(placement) {
    return [
        "top",
        "bottom"
    ].includes($3a46a5f0b2822573$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $3a46a5f0b2822573$export$2b57e0052a6d6d4c(placement) {
    return $3a46a5f0b2822573$export$8a000a963141ac32($3a46a5f0b2822573$export$f28e8f882010718a(placement));
}
function $3a46a5f0b2822573$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $3a46a5f0b2822573$export$f0989780f32bfcda(placement);
    const alignmentAxis = $3a46a5f0b2822573$export$2b57e0052a6d6d4c(placement);
    const length = $3a46a5f0b2822573$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $3a46a5f0b2822573$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $3a46a5f0b2822573$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $3a46a5f0b2822573$export$496432a3699e50b1(placement) {
    const oppositePlacement = $3a46a5f0b2822573$export$9c5e28bad23365fa(placement);
    return [
        $3a46a5f0b2822573$export$2b182c584985588b(placement),
        oppositePlacement,
        $3a46a5f0b2822573$export$2b182c584985588b(oppositePlacement)
    ];
}
function $3a46a5f0b2822573$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$3a46a5f0b2822573$var$oppositeAlignmentMap[alignment]);
}
function $3a46a5f0b2822573$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $3a46a5f0b2822573$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $3a46a5f0b2822573$export$f0989780f32bfcda(placement);
    let list = $3a46a5f0b2822573$var$getSideList($3a46a5f0b2822573$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($3a46a5f0b2822573$export$2b182c584985588b));
    }
    return list;
}
function $3a46a5f0b2822573$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$3a46a5f0b2822573$var$oppositeSideMap[side]);
}
function $3a46a5f0b2822573$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $3a46a5f0b2822573$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $3a46a5f0b2822573$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $3a46a5f0b2822573$export$ee05aea0aeecbad4(rect) {
    return {
        ...rect,
        top: rect.y,
        left: rect.x,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    };
}


function $f5dbeeabf004a4ed$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $3a46a5f0b2822573$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $3a46a5f0b2822573$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $3a46a5f0b2822573$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $3a46a5f0b2822573$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $3a46a5f0b2822573$export$f0989780f32bfcda)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $f5dbeeabf004a4ed$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $f5dbeeabf004a4ed$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $f5dbeeabf004a4ed$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $f5dbeeabf004a4ed$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = (0, $3a46a5f0b2822573$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $3a46a5f0b2822573$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $3a46a5f0b2822573$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        ...rects.floating,
        x: x,
        y: y
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $3a46a5f0b2822573$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $f5dbeeabf004a4ed$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $3a46a5f0b2822573$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $3a46a5f0b2822573$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $3a46a5f0b2822573$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $3a46a5f0b2822573$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $3a46a5f0b2822573$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $3a46a5f0b2822573$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $3a46a5f0b2822573$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $3a46a5f0b2822573$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $f5dbeeabf004a4ed$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $3a46a5f0b2822573$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $3a46a5f0b2822573$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $3a46a5f0b2822573$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $3a46a5f0b2822573$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $3a46a5f0b2822573$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $f5dbeeabf004a4ed$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $3a46a5f0b2822573$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $3a46a5f0b2822573$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $3a46a5f0b2822573$export$803cd8101b6c182b) ? $f5dbeeabf004a4ed$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $f5dbeeabf004a4ed$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $3a46a5f0b2822573$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $3a46a5f0b2822573$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $3a46a5f0b2822573$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $3a46a5f0b2822573$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $f5dbeeabf004a4ed$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $3a46a5f0b2822573$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $3a46a5f0b2822573$export$3c915306cb7fc97a)(placement);
            const isBasePlacement = (0, $3a46a5f0b2822573$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $3a46a5f0b2822573$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $3a46a5f0b2822573$export$496432a3699e50b1)(initialPlacement));
            if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== "none") fallbackPlacements.push(...(0, $3a46a5f0b2822573$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $f5dbeeabf004a4ed$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $3a46a5f0b2822573$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$map$so;
                            const placement = (_overflowsData$map$so = overflowsData.map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $f5dbeeabf004a4ed$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $f5dbeeabf004a4ed$var$isAnySideFullyClipped(overflow) {
    return (0, $3a46a5f0b2822573$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $f5dbeeabf004a4ed$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = "referenceHidden", ...detectOverflowOptions } = (0, $3a46a5f0b2822573$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $f5dbeeabf004a4ed$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $f5dbeeabf004a4ed$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $f5dbeeabf004a4ed$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $f5dbeeabf004a4ed$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $f5dbeeabf004a4ed$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $f5dbeeabf004a4ed$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $f5dbeeabf004a4ed$var$getBoundingRect(rects) {
    const minX = (0, $3a46a5f0b2822573$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $3a46a5f0b2822573$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $3a46a5f0b2822573$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $3a46a5f0b2822573$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $f5dbeeabf004a4ed$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $3a46a5f0b2822573$export$ee05aea0aeecbad4)($f5dbeeabf004a4ed$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $f5dbeeabf004a4ed$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $3a46a5f0b2822573$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $f5dbeeabf004a4ed$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $3a46a5f0b2822573$export$ee05aea0aeecbad4)($f5dbeeabf004a4ed$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $3a46a5f0b2822573$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $3a46a5f0b2822573$export$f28e8f882010718a)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $3a46a5f0b2822573$export$3c915306cb7fc97a)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $3a46a5f0b2822573$export$3c915306cb7fc97a)(placement) === "left";
                    const maxRight = (0, $3a46a5f0b2822573$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $3a46a5f0b2822573$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $f5dbeeabf004a4ed$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $3a46a5f0b2822573$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $3a46a5f0b2822573$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $3a46a5f0b2822573$export$f28e8f882010718a)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $3a46a5f0b2822573$export$fef61f332f2c0afc)(options, state);
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null,
        ...rawValue
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $f5dbeeabf004a4ed$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $f5dbeeabf004a4ed$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $f5dbeeabf004a4ed$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $3a46a5f0b2822573$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $f5dbeeabf004a4ed$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $3a46a5f0b2822573$export$f28e8f882010718a)((0, $3a46a5f0b2822573$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $3a46a5f0b2822573$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $3a46a5f0b2822573$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $3a46a5f0b2822573$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $f5dbeeabf004a4ed$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $3a46a5f0b2822573$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $3a46a5f0b2822573$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $3a46a5f0b2822573$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $3a46a5f0b2822573$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, $3a46a5f0b2822573$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $f5dbeeabf004a4ed$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $3a46a5f0b2822573$export$fef61f332f2c0afc)(options, state);
            const overflow = await $f5dbeeabf004a4ed$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $3a46a5f0b2822573$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $3a46a5f0b2822573$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $3a46a5f0b2822573$export$f28e8f882010718a)(placement) === "y";
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const overflowAvailableHeight = height - overflow[heightSide];
            const overflowAvailableWidth = width - overflow[widthSide];
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (isYAxis) {
                const maximumClippingWidth = width - overflow.left - overflow.right;
                availableWidth = alignment || noShift ? (0, $3a46a5f0b2822573$export$96ec731ed4dcb222)(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
            } else {
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                availableHeight = alignment || noShift ? (0, $3a46a5f0b2822573$export$96ec731ed4dcb222)(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
            }
            if (noShift && !alignment) {
                const xMin = (0, $3a46a5f0b2822573$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $3a46a5f0b2822573$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $3a46a5f0b2822573$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $3a46a5f0b2822573$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $3a46a5f0b2822573$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $3a46a5f0b2822573$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $9de86d0040c7d208$export$651544f548703224(node) {
    if ($9de86d0040c7d208$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $9de86d0040c7d208$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $9de86d0040c7d208$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($9de86d0040c7d208$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $9de86d0040c7d208$export$8ee0fc9ee280b4ee(value) {
    return value instanceof Node || value instanceof $9de86d0040c7d208$export$38b2d434cce3ea22(value).Node;
}
function $9de86d0040c7d208$export$45a5e7f76e0caa8d(value) {
    return value instanceof Element || value instanceof $9de86d0040c7d208$export$38b2d434cce3ea22(value).Element;
}
function $9de86d0040c7d208$export$1b3bfaa9684536aa(value) {
    return value instanceof HTMLElement || value instanceof $9de86d0040c7d208$export$38b2d434cce3ea22(value).HTMLElement;
}
function $9de86d0040c7d208$export$af51f0f06c0f328a(value) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $9de86d0040c7d208$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $9de86d0040c7d208$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $9de86d0040c7d208$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $9de86d0040c7d208$export$71535ffaa902797f(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($9de86d0040c7d208$export$651544f548703224(element));
}
function $9de86d0040c7d208$export$d6c4e8150c35fed1(element) {
    const webkit = $9de86d0040c7d208$export$78551043582a6a98();
    const css = $9de86d0040c7d208$export$3735103072e4a80(element);
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $9de86d0040c7d208$export$940d8225183e1404(element) {
    let currentNode = $9de86d0040c7d208$export$4e12058fc4d51d56(element);
    while($9de86d0040c7d208$export$1b3bfaa9684536aa(currentNode) && !$9de86d0040c7d208$export$d1162fb0b6d4cd51(currentNode)){
        if ($9de86d0040c7d208$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else currentNode = $9de86d0040c7d208$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $9de86d0040c7d208$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $9de86d0040c7d208$export$d1162fb0b6d4cd51(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($9de86d0040c7d208$export$651544f548703224(node));
}
function $9de86d0040c7d208$export$3735103072e4a80(element) {
    return $9de86d0040c7d208$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $9de86d0040c7d208$export$dc8fc79fa2800137(element) {
    if ($9de86d0040c7d208$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function $9de86d0040c7d208$export$4e12058fc4d51d56(node) {
    if ($9de86d0040c7d208$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $9de86d0040c7d208$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $9de86d0040c7d208$export$e495491855dc5418(node);
    return $9de86d0040c7d208$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $9de86d0040c7d208$export$7cd01a57c8ca906c(node) {
    const parentNode = $9de86d0040c7d208$export$4e12058fc4d51d56(node);
    if ($9de86d0040c7d208$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($9de86d0040c7d208$export$1b3bfaa9684536aa(parentNode) && $9de86d0040c7d208$export$989e911fa9af580a(parentNode)) return parentNode;
    return $9de86d0040c7d208$export$7cd01a57c8ca906c(parentNode);
}
function $9de86d0040c7d208$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $9de86d0040c7d208$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $9de86d0040c7d208$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $9de86d0040c7d208$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? $9de86d0040c7d208$export$3b57c1601291186b(win.frameElement) : []);
    return list.concat(scrollableAncestor, $9de86d0040c7d208$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}


function $f3e37db8bfe4dcf2$var$getCssDimensions(element) {
    const css = (0, $9de86d0040c7d208$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $9de86d0040c7d208$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $3a46a5f0b2822573$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $3a46a5f0b2822573$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $f3e37db8bfe4dcf2$var$unwrapElement(element) {
    return !(0, $9de86d0040c7d208$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $f3e37db8bfe4dcf2$var$getScale(element) {
    const domElement = $f3e37db8bfe4dcf2$var$unwrapElement(element);
    if (!(0, $9de86d0040c7d208$export$1b3bfaa9684536aa)(domElement)) return (0, $3a46a5f0b2822573$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $f3e37db8bfe4dcf2$var$getCssDimensions(domElement);
    let x = ($ ? (0, $3a46a5f0b2822573$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $3a46a5f0b2822573$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $f3e37db8bfe4dcf2$var$noOffsets = /*#__PURE__*/ (0, $3a46a5f0b2822573$export$a397704b5e280835)(0);
function $f3e37db8bfe4dcf2$var$getVisualOffsets(element) {
    const win = (0, $9de86d0040c7d208$export$38b2d434cce3ea22)(element);
    if (!(0, $9de86d0040c7d208$export$78551043582a6a98)() || !win.visualViewport) return $f3e37db8bfe4dcf2$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $f3e37db8bfe4dcf2$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $9de86d0040c7d208$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $f3e37db8bfe4dcf2$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $f3e37db8bfe4dcf2$var$unwrapElement(element);
    let scale = (0, $3a46a5f0b2822573$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $9de86d0040c7d208$export$45a5e7f76e0caa8d)(offsetParent)) scale = $f3e37db8bfe4dcf2$var$getScale(offsetParent);
        } else scale = $f3e37db8bfe4dcf2$var$getScale(element);
    }
    const visualOffsets = $f3e37db8bfe4dcf2$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $f3e37db8bfe4dcf2$var$getVisualOffsets(domElement) : (0, $3a46a5f0b2822573$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $9de86d0040c7d208$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $9de86d0040c7d208$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $9de86d0040c7d208$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = currentWin.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $f3e37db8bfe4dcf2$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $9de86d0040c7d208$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $9de86d0040c7d208$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = currentWin.frameElement;
        }
    }
    return (0, $3a46a5f0b2822573$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
const $f3e37db8bfe4dcf2$var$topLayerSelectors = [
    ":popover-open",
    ":modal"
];
function $f3e37db8bfe4dcf2$var$isTopLayer(floating) {
    return $f3e37db8bfe4dcf2$var$topLayerSelectors.some((selector)=>{
        try {
            return floating.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $f3e37db8bfe4dcf2$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === "fixed";
    const documentElement = (0, $9de86d0040c7d208$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? $f3e37db8bfe4dcf2$var$isTopLayer(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $3a46a5f0b2822573$export$a397704b5e280835)(1);
    const offsets = (0, $3a46a5f0b2822573$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $9de86d0040c7d208$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $9de86d0040c7d208$export$651544f548703224)(offsetParent) !== "body" || (0, $9de86d0040c7d208$export$989e911fa9af580a)(documentElement)) scroll = (0, $9de86d0040c7d208$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $9de86d0040c7d208$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $f3e37db8bfe4dcf2$var$getBoundingClientRect(offsetParent);
            scale = $f3e37db8bfe4dcf2$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $f3e37db8bfe4dcf2$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
function $f3e37db8bfe4dcf2$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $f3e37db8bfe4dcf2$var$getBoundingClientRect((0, $9de86d0040c7d208$export$e495491855dc5418)(element)).left + (0, $9de86d0040c7d208$export$dc8fc79fa2800137)(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $f3e37db8bfe4dcf2$var$getDocumentRect(element) {
    const html = (0, $9de86d0040c7d208$export$e495491855dc5418)(element);
    const scroll = (0, $9de86d0040c7d208$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $3a46a5f0b2822573$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $3a46a5f0b2822573$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $f3e37db8bfe4dcf2$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $9de86d0040c7d208$export$3735103072e4a80)(body).direction === "rtl") x += (0, $3a46a5f0b2822573$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $f3e37db8bfe4dcf2$var$getViewportRect(element, strategy) {
    const win = (0, $9de86d0040c7d208$export$38b2d434cce3ea22)(element);
    const html = (0, $9de86d0040c7d208$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $9de86d0040c7d208$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $f3e37db8bfe4dcf2$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $f3e37db8bfe4dcf2$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $9de86d0040c7d208$export$1b3bfaa9684536aa)(element) ? $f3e37db8bfe4dcf2$var$getScale(element) : (0, $3a46a5f0b2822573$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $f3e37db8bfe4dcf2$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $f3e37db8bfe4dcf2$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $f3e37db8bfe4dcf2$var$getDocumentRect((0, $9de86d0040c7d208$export$e495491855dc5418)(element));
    else if ((0, $9de86d0040c7d208$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $f3e37db8bfe4dcf2$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $f3e37db8bfe4dcf2$var$getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return (0, $3a46a5f0b2822573$export$ee05aea0aeecbad4)(rect);
}
function $f3e37db8bfe4dcf2$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $9de86d0040c7d208$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $9de86d0040c7d208$export$45a5e7f76e0caa8d)(parentNode) || (0, $9de86d0040c7d208$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $9de86d0040c7d208$export$3735103072e4a80)(parentNode).position === "fixed" || $f3e37db8bfe4dcf2$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $f3e37db8bfe4dcf2$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $9de86d0040c7d208$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $9de86d0040c7d208$export$45a5e7f76e0caa8d)(el) && (0, $9de86d0040c7d208$export$651544f548703224)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $9de86d0040c7d208$export$3735103072e4a80)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $9de86d0040c7d208$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $9de86d0040c7d208$export$45a5e7f76e0caa8d)(currentNode) && !(0, $9de86d0040c7d208$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $9de86d0040c7d208$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $9de86d0040c7d208$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, $9de86d0040c7d208$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $f3e37db8bfe4dcf2$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $9de86d0040c7d208$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $f3e37db8bfe4dcf2$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? $f3e37db8bfe4dcf2$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $f3e37db8bfe4dcf2$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $3a46a5f0b2822573$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $3a46a5f0b2822573$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $3a46a5f0b2822573$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3a46a5f0b2822573$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $f3e37db8bfe4dcf2$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $f3e37db8bfe4dcf2$var$getDimensions(element) {
    const { width: width, height: height } = $f3e37db8bfe4dcf2$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $f3e37db8bfe4dcf2$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $9de86d0040c7d208$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $9de86d0040c7d208$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $f3e37db8bfe4dcf2$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $3a46a5f0b2822573$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $9de86d0040c7d208$export$651544f548703224)(offsetParent) !== "body" || (0, $9de86d0040c7d208$export$989e911fa9af580a)(documentElement)) scroll = (0, $9de86d0040c7d208$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $f3e37db8bfe4dcf2$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $f3e37db8bfe4dcf2$var$getWindowScrollBarX(documentElement);
    }
    const x = rect.left + scroll.scrollLeft - offsets.x;
    const y = rect.top + scroll.scrollTop - offsets.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $f3e37db8bfe4dcf2$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $9de86d0040c7d208$export$1b3bfaa9684536aa)(element) || (0, $9de86d0040c7d208$export$3735103072e4a80)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $f3e37db8bfe4dcf2$var$getOffsetParent(element, polyfill) {
    const window = (0, $9de86d0040c7d208$export$38b2d434cce3ea22)(element);
    if (!(0, $9de86d0040c7d208$export$1b3bfaa9684536aa)(element) || $f3e37db8bfe4dcf2$var$isTopLayer(element)) return window;
    let offsetParent = $f3e37db8bfe4dcf2$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $9de86d0040c7d208$export$71535ffaa902797f)(offsetParent) && (0, $9de86d0040c7d208$export$3735103072e4a80)(offsetParent).position === "static")offsetParent = $f3e37db8bfe4dcf2$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && ((0, $9de86d0040c7d208$export$651544f548703224)(offsetParent) === "html" || (0, $9de86d0040c7d208$export$651544f548703224)(offsetParent) === "body" && (0, $9de86d0040c7d208$export$3735103072e4a80)(offsetParent).position === "static" && !(0, $9de86d0040c7d208$export$d6c4e8150c35fed1)(offsetParent))) return window;
    return offsetParent || (0, $9de86d0040c7d208$export$940d8225183e1404)(element) || window;
}
const $f3e37db8bfe4dcf2$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $f3e37db8bfe4dcf2$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    return {
        reference: $f3e37db8bfe4dcf2$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            ...await getDimensionsFn(data.floating)
        }
    };
};
function $f3e37db8bfe4dcf2$var$isRTL(element) {
    return (0, $9de86d0040c7d208$export$3735103072e4a80)(element).direction === "rtl";
}
const $f3e37db8bfe4dcf2$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $f3e37db8bfe4dcf2$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $9de86d0040c7d208$export$e495491855dc5418,
    getClippingRect: $f3e37db8bfe4dcf2$var$getClippingRect,
    getOffsetParent: $f3e37db8bfe4dcf2$var$getOffsetParent,
    getElementRects: $f3e37db8bfe4dcf2$var$getElementRects,
    getClientRects: $f3e37db8bfe4dcf2$var$getClientRects,
    getDimensions: $f3e37db8bfe4dcf2$var$getDimensions,
    getScale: $f3e37db8bfe4dcf2$var$getScale,
    isElement: $9de86d0040c7d208$export$45a5e7f76e0caa8d,
    isRTL: $f3e37db8bfe4dcf2$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $f3e37db8bfe4dcf2$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $9de86d0040c7d208$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $3a46a5f0b2822573$export$a3fe094919f356fd)(top);
        const insetRight = (0, $3a46a5f0b2822573$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $3a46a5f0b2822573$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $3a46a5f0b2822573$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $3a46a5f0b2822573$export$8960430cfd85939f)(0, (0, $3a46a5f0b2822573$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 100);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $f3e37db8bfe4dcf2$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $f3e37db8bfe4dcf2$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $9de86d0040c7d208$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $9de86d0040c7d208$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $f3e37db8bfe4dcf2$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $f3e37db8bfe4dcf2$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $f3e37db8bfe4dcf2$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $f3e37db8bfe4dcf2$export$91fb6ecbd551914 = (0, $f5dbeeabf004a4ed$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $f3e37db8bfe4dcf2$export$fba63a578e423eb = (0, $f5dbeeabf004a4ed$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $f3e37db8bfe4dcf2$export$8a83211c878a3f1f = (0, $f5dbeeabf004a4ed$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $f3e37db8bfe4dcf2$export$346677f925de839c = (0, $f5dbeeabf004a4ed$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $f3e37db8bfe4dcf2$export$fe8985bb6374093c = (0, $f5dbeeabf004a4ed$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $f3e37db8bfe4dcf2$export$f2120bbfa5450bd2 = (0, $f5dbeeabf004a4ed$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $f3e37db8bfe4dcf2$export$18c8ad048e32c7d5 = (0, $f5dbeeabf004a4ed$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $f3e37db8bfe4dcf2$export$7bf07e38f3dc4b69 = (0, $f5dbeeabf004a4ed$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $f3e37db8bfe4dcf2$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $f3e37db8bfe4dcf2$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $f5dbeeabf004a4ed$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $6cds3 = parcelRequire("6cds3");
var $4fe0ff6a5f0ce1c6$var$index = (0, $6cds3.useLayoutEffect);
var $4fe0ff6a5f0ce1c6$export$2e2bcd8739ae039 = $4fe0ff6a5f0ce1c6$var$index;


var $7fb581e3a321cc3d$var$_excluded$4 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $7fb581e3a321cc3d$export$b4171a6734a65d42 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $7fb581e3a321cc3d$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === "-") return prefix + name;
    else return prefix + "__" + name;
}
function $7fb581e3a321cc3d$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($7fb581e3a321cc3d$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(" ");
}
// ==============================
// Clean Value
// ==============================
var $7fb581e3a321cc3d$export$7f8ddf7c7c20b3cd = function cleanValue(value) {
    if ($7fb581e3a321cc3d$var$isArray(value)) return value.filter(Boolean);
    if ((0, $eed97d47c423435d$export$2e2bcd8739ae039)(value) === "object" && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $7fb581e3a321cc3d$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $3790664e4a835b94$export$2e2bcd8739ae039)(props, $7fb581e3a321cc3d$var$_excluded$4);
    return (0, $fd7f409eefb792f2$export$2e2bcd8739ae039)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $7fb581e3a321cc3d$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $7fb581e3a321cc3d$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === "string") return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $7fb581e3a321cc3d$export$2329c99376c9d0a4(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $7fb581e3a321cc3d$var$normalizedHeight(el) {
    if ($7fb581e3a321cc3d$export$2329c99376c9d0a4(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $7fb581e3a321cc3d$var$getScrollTop(el) {
    if ($7fb581e3a321cc3d$export$2329c99376c9d0a4(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $7fb581e3a321cc3d$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($7fb581e3a321cc3d$export$2329c99376c9d0a4(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $7fb581e3a321cc3d$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === "absolute";
    var overflowRx = /(auto|scroll)/;
    if (style.position === "fixed") return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === "static") continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $7fb581e3a321cc3d$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $7fb581e3a321cc3d$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $7fb581e3a321cc3d$export$b4171a6734a65d42;
    var start = $7fb581e3a321cc3d$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $7fb581e3a321cc3d$var$easeOutCubic(currentTime, start, change, duration);
        $7fb581e3a321cc3d$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $7fb581e3a321cc3d$export$9bb611d729802a56(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $7fb581e3a321cc3d$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $7fb581e3a321cc3d$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $7fb581e3a321cc3d$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $7fb581e3a321cc3d$export$df995fae86a55f06() {
    try {
        document.createEvent("TouchEvent");
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $7fb581e3a321cc3d$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $7fb581e3a321cc3d$var$passiveOptionAccessed = false;
var $7fb581e3a321cc3d$var$options = {
    get passive () {
        return $7fb581e3a321cc3d$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $7fb581e3a321cc3d$var$w = typeof window !== "undefined" ? window : {};
if ($7fb581e3a321cc3d$var$w.addEventListener && $7fb581e3a321cc3d$var$w.removeEventListener) {
    $7fb581e3a321cc3d$var$w.addEventListener("p", $7fb581e3a321cc3d$export$b4171a6734a65d42, $7fb581e3a321cc3d$var$options);
    $7fb581e3a321cc3d$var$w.removeEventListener("p", $7fb581e3a321cc3d$export$b4171a6734a65d42, false);
}
var $7fb581e3a321cc3d$export$2408f22a0fab9ae5 = $7fb581e3a321cc3d$var$passiveOptionAccessed;
function $7fb581e3a321cc3d$export$3466f893ebf79586(item) {
    return item != null;
}
function $7fb581e3a321cc3d$var$isArray(arg) {
    return Array.isArray(arg);
}
function $7fb581e3a321cc3d$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $7fb581e3a321cc3d$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $7fb581e3a321cc3d$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $7fb581e3a321cc3d$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $c6d07f6509b171c8$export$2e2bcd8739ae039)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $c6d07f6509b171c8$export$2e2bcd8739ae039)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $7fb581e3a321cc3d$var$_excluded$3 = [
    "children",
    "innerProps"
], $7fb581e3a321cc3d$var$_excluded2$1 = [
    "children",
    "innerProps"
];
function $7fb581e3a321cc3d$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $7fb581e3a321cc3d$var$getScrollParent(menuEl);
    var defaultState = {
        placement: "bottom",
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $7fb581e3a321cc3d$var$normalizedHeight(scrollParent);
    var scrollTop = $7fb581e3a321cc3d$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case "auto":
        case "bottom":
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $7fb581e3a321cc3d$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $7fb581e3a321cc3d$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: "bottom",
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === "auto" || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === "bottom") {
                if (shouldScroll) $7fb581e3a321cc3d$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case "top":
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: "top",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $7fb581e3a321cc3d$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $7fb581e3a321cc3d$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error('Invalid placement provided "'.concat(preferredPlacement, '".'));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $7fb581e3a321cc3d$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: "top",
        top: "bottom"
    };
    return placement ? placementToCSSProp[placement] : "bottom";
}
var $7fb581e3a321cc3d$var$coercePlacement = function coercePlacement(p) {
    return p === "auto" ? "bottom" : p;
};
var $7fb581e3a321cc3d$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $fd7f409eefb792f2$export$2e2bcd8739ae039)((_objectSpread2 = {
        label: "menu"
    }, (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)(_objectSpread2, $7fb581e3a321cc3d$var$alignToControl(placement), "100%"), (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)(_objectSpread2, "position", "absolute"), (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)(_objectSpread2, "width", "100%"), (0, $c5ff8c04c412c17d$export$2e2bcd8739ae039)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $7fb581e3a321cc3d$var$PortalPlacementContext = /*#__PURE__*/ (0, $6cds3.createContext)(null);
// NOTE: internal only
var $7fb581e3a321cc3d$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $6cds3.useContext)($7fb581e3a321cc3d$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $6cds3.useRef)(null);
    var _useState = (0, $6cds3.useState)(maxMenuHeight), _useState2 = (0, $c6d07f6509b171c8$export$2e2bcd8739ae039)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $6cds3.useState)(null), _useState4 = (0, $c6d07f6509b171c8$export$2e2bcd8739ae039)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $4fe0ff6a5f0ce1c6$export$2e2bcd8739ae039)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === "fixed";
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $7fb581e3a321cc3d$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $fd7f409eefb792f2$export$2e2bcd8739ae039)((0, $fd7f409eefb792f2$export$2e2bcd8739ae039)({}, props), {}, {
            placement: placement || $7fb581e3a321cc3d$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $7fb581e3a321cc3d$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)("div", (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, $7fb581e3a321cc3d$var$getStyleProps(props, "menu", {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var $7fb581e3a321cc3d$var$Menu$1 = $7fb581e3a321cc3d$var$Menu;
// ==============================
// Menu List
// ==============================
var $7fb581e3a321cc3d$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $fd7f409eefb792f2$export$2e2bcd8739ae039)({
        maxHeight: maxHeight,
        overflowY: "auto",
        position: "relative",
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: "touch"
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $7fb581e3a321cc3d$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)("div", (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, $7fb581e3a321cc3d$var$getStyleProps(props, "menuList", {
        "menu-list": true,
        "menu-list--is-multi": isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $7fb581e3a321cc3d$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $fd7f409eefb792f2$export$2e2bcd8739ae039)({
        textAlign: "center"
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $7fb581e3a321cc3d$export$3b14a55fb2447963 = $7fb581e3a321cc3d$var$noticeCSS;
var $7fb581e3a321cc3d$export$342063e11d6c3cad = $7fb581e3a321cc3d$var$noticeCSS;
var $7fb581e3a321cc3d$var$NoOptionsMessage = function NoOptionsMessage(_ref6) {
    var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? "No options" : _ref6$children, innerProps = _ref6.innerProps, restProps = (0, $3790664e4a835b94$export$2e2bcd8739ae039)(_ref6, $7fb581e3a321cc3d$var$_excluded$3);
    return (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)("div", (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, $7fb581e3a321cc3d$var$getStyleProps((0, $fd7f409eefb792f2$export$2e2bcd8739ae039)((0, $fd7f409eefb792f2$export$2e2bcd8739ae039)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "noOptionsMessage", {
        "menu-notice": true,
        "menu-notice--no-options": true
    }), innerProps), children);
};
var $7fb581e3a321cc3d$var$LoadingMessage = function LoadingMessage(_ref7) {
    var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? "Loading..." : _ref7$children, innerProps = _ref7.innerProps, restProps = (0, $3790664e4a835b94$export$2e2bcd8739ae039)(_ref7, $7fb581e3a321cc3d$var$_excluded2$1);
    return (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)("div", (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, $7fb581e3a321cc3d$var$getStyleProps((0, $fd7f409eefb792f2$export$2e2bcd8739ae039)((0, $fd7f409eefb792f2$export$2e2bcd8739ae039)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "loadingMessage", {
        "menu-notice": true,
        "menu-notice--loading": true
    }), innerProps), children);
};
// ==============================
// Menu Portal
// ==============================
var $7fb581e3a321cc3d$export$ae1af26003f05816 = function menuPortalCSS(_ref8) {
    var rect = _ref8.rect, offset = _ref8.offset, position = _ref8.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $7fb581e3a321cc3d$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $6cds3.useRef)(null);
    var cleanupRef = (0, $6cds3.useRef)(null);
    var _useState5 = (0, $6cds3.useState)($7fb581e3a321cc3d$var$coercePlacement(menuPlacement)), _useState6 = (0, $c6d07f6509b171c8$export$2e2bcd8739ae039)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $6cds3.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $6cds3.useState)(null), _useState8 = (0, $c6d07f6509b171c8$export$2e2bcd8739ae039)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $6cds3.useCallback)(function() {
        if (!controlElement) return;
        var rect = $7fb581e3a321cc3d$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === "fixed" ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $4fe0ff6a5f0ce1c6$export$2e2bcd8739ae039)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $6cds3.useCallback)(function() {
        if (typeof cleanupRef.current === "function") {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $f3e37db8bfe4dcf2$export$deee3a793edee05f)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: "ResizeObserver" in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $4fe0ff6a5f0ce1c6$export$2e2bcd8739ae039)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $6cds3.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== "fixed" || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)("div", (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({
        ref: setMenuPortalElement
    }, $7fb581e3a321cc3d$var$getStyleProps((0, $fd7f409eefb792f2$export$2e2bcd8739ae039)((0, $fd7f409eefb792f2$export$2e2bcd8739ae039)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), "menuPortal", {
        "menu-portal": true
    }), innerProps), children);
    return (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)($7fb581e3a321cc3d$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $6d4849ee44552f5f$exports.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $7fb581e3a321cc3d$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: "container",
        direction: isRtl ? "rtl" : undefined,
        pointerEvents: isDisabled ? "none" : undefined,
        // cancel mouse events when disabled
        position: "relative"
    };
};
var $7fb581e3a321cc3d$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)("div", (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, $7fb581e3a321cc3d$var$getStyleProps(props, "container", {
        "--is-disabled": isDisabled,
        "--is-rtl": isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $7fb581e3a321cc3d$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $fd7f409eefb792f2$export$2e2bcd8739ae039)({
        alignItems: "center",
        display: isMulti && hasValue && controlShouldRenderValue ? "flex" : "grid",
        flex: 1,
        flexWrap: "wrap",
        WebkitOverflowScrolling: "touch",
        position: "relative",
        overflow: "hidden"
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $7fb581e3a321cc3d$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)("div", (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, $7fb581e3a321cc3d$var$getStyleProps(props, "valueContainer", {
        "value-container": true,
        "value-container--is-multi": isMulti,
        "value-container--has-value": hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $7fb581e3a321cc3d$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: "center",
        alignSelf: "stretch",
        display: "flex",
        flexShrink: 0
    };
};
var $7fb581e3a321cc3d$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)("div", (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, $7fb581e3a321cc3d$var$getStyleProps(props, "indicatorsContainer", {
        indicators: true
    }), innerProps), children);
};
var $7fb581e3a321cc3d$var$_templateObject;
var $7fb581e3a321cc3d$var$_excluded$2 = [
    "size"
], $7fb581e3a321cc3d$var$_excluded2 = [
    "innerProps",
    "isRtl",
    "size"
];
function $7fb581e3a321cc3d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $7fb581e3a321cc3d$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $7fb581e3a321cc3d$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $3790664e4a835b94$export$2e2bcd8739ae039)(_ref, $7fb581e3a321cc3d$var$_excluded$2);
    return (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)("svg", (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $7fb581e3a321cc3d$var$_ref2
    }, props));
};
var $7fb581e3a321cc3d$var$CrossIcon = function CrossIcon(props) {
    return (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)($7fb581e3a321cc3d$var$Svg, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({
        size: 20
    }, props), (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $7fb581e3a321cc3d$var$DownChevron = function DownChevron(props) {
    return (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)($7fb581e3a321cc3d$var$Svg, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({
        size: 20
    }, props), (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $7fb581e3a321cc3d$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $fd7f409eefb792f2$export$2e2bcd8739ae039)({
        label: "indicatorContainer",
        display: "flex",
        transition: "color 150ms"
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ":hover": {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $7fb581e3a321cc3d$export$f1e1789686576879 = $7fb581e3a321cc3d$var$baseCSS;
var $7fb581e3a321cc3d$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)("div", (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, $7fb581e3a321cc3d$var$getStyleProps(props, "dropdownIndicator", {
        indicator: true,
        "dropdown-indicator": true
    }), innerProps), children || (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)($7fb581e3a321cc3d$var$DownChevron, null));
};
var $7fb581e3a321cc3d$export$407448d2b89b1813 = $7fb581e3a321cc3d$var$baseCSS;
var $7fb581e3a321cc3d$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)("div", (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, $7fb581e3a321cc3d$var$getStyleProps(props, "clearIndicator", {
        indicator: true,
        "clear-indicator": true
    }), innerProps), children || (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)($7fb581e3a321cc3d$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $7fb581e3a321cc3d$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $fd7f409eefb792f2$export$2e2bcd8739ae039)({
        label: "indicatorSeparator",
        alignSelf: "stretch",
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $7fb581e3a321cc3d$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)("span", (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, innerProps, $7fb581e3a321cc3d$var$getStyleProps(props, "indicatorSeparator", {
        "indicator-separator": true
    })));
};
// ==============================
// Loading
// ==============================
var $7fb581e3a321cc3d$var$loadingDotAnimations = (0, $dacd7d2074e32fea$export$d25ddfdf17c3ad3e)($7fb581e3a321cc3d$var$_templateObject || ($7fb581e3a321cc3d$var$_templateObject = (0, $026910be6cf4e9f3$export$2e2bcd8739ae039)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $7fb581e3a321cc3d$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $fd7f409eefb792f2$export$2e2bcd8739ae039)({
        label: "loadingIndicator",
        display: "flex",
        transition: "color 150ms",
        alignSelf: "center",
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: "center",
        verticalAlign: "middle"
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $7fb581e3a321cc3d$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)("span", {
        css: /*#__PURE__*/ (0, $dacd7d2074e32fea$export$dbf350e5966cf602)({
            animation: "".concat($7fb581e3a321cc3d$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: "currentColor",
            borderRadius: "1em",
            display: "inline-block",
            marginLeft: offset ? "1em" : undefined,
            height: "1em",
            verticalAlign: "top",
            width: "1em"
        }, "", "")
    });
};
var $7fb581e3a321cc3d$var$LoadingIndicator = function LoadingIndicator(_ref7) {
    var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = (0, $3790664e4a835b94$export$2e2bcd8739ae039)(_ref7, $7fb581e3a321cc3d$var$_excluded2);
    return (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)("div", (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, $7fb581e3a321cc3d$var$getStyleProps((0, $fd7f409eefb792f2$export$2e2bcd8739ae039)((0, $fd7f409eefb792f2$export$2e2bcd8739ae039)({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), "loadingIndicator", {
        indicator: true,
        "loading-indicator": true
    }), innerProps), (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)($7fb581e3a321cc3d$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)($7fb581e3a321cc3d$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)($7fb581e3a321cc3d$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
var $7fb581e3a321cc3d$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $fd7f409eefb792f2$export$2e2bcd8739ae039)({
        label: "control",
        alignItems: "center",
        cursor: "default",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        minHeight: spacing.controlHeight,
        outline: "0 !important",
        position: "relative",
        transition: "all 100ms"
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: "solid",
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        "&:hover": {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $7fb581e3a321cc3d$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)("div", (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({
        ref: innerRef
    }, $7fb581e3a321cc3d$var$getStyleProps(props, "control", {
        control: true,
        "control--is-disabled": isDisabled,
        "control--is-focused": isFocused,
        "control--menu-is-open": menuIsOpen
    }), innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var $7fb581e3a321cc3d$var$Control$1 = $7fb581e3a321cc3d$var$Control;
var $7fb581e3a321cc3d$var$_excluded$1 = [
    "data"
];
var $7fb581e3a321cc3d$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $7fb581e3a321cc3d$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)("div", (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, $7fb581e3a321cc3d$var$getStyleProps(props, "group", {
        group: true
    }), innerProps), (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)(Heading, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)("div", null, children));
};
var $7fb581e3a321cc3d$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $fd7f409eefb792f2$export$2e2bcd8739ae039)({
        label: "group",
        cursor: "default",
        display: "block"
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: "75%",
        fontWeight: 500,
        marginBottom: "0.25em",
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: "uppercase"
    });
};
var $7fb581e3a321cc3d$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $7fb581e3a321cc3d$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $3790664e4a835b94$export$2e2bcd8739ae039)(_cleanCommonProps, $7fb581e3a321cc3d$var$_excluded$1);
    return (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)("div", (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, $7fb581e3a321cc3d$var$getStyleProps(props, "groupHeading", {
        "group-heading": true
    }), innerProps));
};
var $7fb581e3a321cc3d$var$Group$1 = $7fb581e3a321cc3d$var$Group;
var $7fb581e3a321cc3d$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $7fb581e3a321cc3d$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $fd7f409eefb792f2$export$2e2bcd8739ae039)((0, $fd7f409eefb792f2$export$2e2bcd8739ae039)({
        visibility: isDisabled ? "hidden" : "visible",
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? "translateZ(0)" : ""
    }, $7fb581e3a321cc3d$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $7fb581e3a321cc3d$var$spacingStyle = {
    gridArea: "1 / 2",
    font: "inherit",
    minWidth: "2px",
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $7fb581e3a321cc3d$var$containerStyle = {
    flex: "1 1 auto",
    display: "inline-grid",
    gridArea: "1 / 1 / 2 / 3",
    gridTemplateColumns: "0 min-content",
    "&:after": (0, $fd7f409eefb792f2$export$2e2bcd8739ae039)({
        content: 'attr(data-value) " "',
        visibility: "hidden",
        whiteSpace: "pre"
    }, $7fb581e3a321cc3d$var$spacingStyle)
};
var $7fb581e3a321cc3d$var$inputStyle = function inputStyle(isHidden) {
    return (0, $fd7f409eefb792f2$export$2e2bcd8739ae039)({
        label: "input",
        color: "inherit",
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: "100%"
    }, $7fb581e3a321cc3d$var$spacingStyle);
};
var $7fb581e3a321cc3d$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $7fb581e3a321cc3d$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $3790664e4a835b94$export$2e2bcd8739ae039)(_cleanCommonProps, $7fb581e3a321cc3d$var$_excluded);
    return (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)("div", (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, $7fb581e3a321cc3d$var$getStyleProps(props, "input", {
        "input-container": true
    }), {
        "data-value": value || ""
    }), (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)("input", (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $7fb581e3a321cc3d$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $7fb581e3a321cc3d$var$Input$1 = $7fb581e3a321cc3d$var$Input;
var $7fb581e3a321cc3d$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $fd7f409eefb792f2$export$2e2bcd8739ae039)({
        label: "multiValue",
        display: "flex",
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $7fb581e3a321cc3d$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $fd7f409eefb792f2$export$2e2bcd8739ae039)({
        overflow: "hidden",
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? "ellipsis" : undefined,
        whiteSpace: "nowrap"
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: "85%",
        padding: 3,
        paddingLeft: 6
    });
};
var $7fb581e3a321cc3d$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $fd7f409eefb792f2$export$2e2bcd8739ae039)({
        alignItems: "center",
        display: "flex"
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ":hover": {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $7fb581e3a321cc3d$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)("div", innerProps, children);
};
var $7fb581e3a321cc3d$var$MultiValueContainer = $7fb581e3a321cc3d$var$MultiValueGeneric;
var $7fb581e3a321cc3d$var$MultiValueLabel = $7fb581e3a321cc3d$var$MultiValueGeneric;
function $7fb581e3a321cc3d$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)("div", (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({
        role: "button"
    }, innerProps), children || (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)($7fb581e3a321cc3d$var$CrossIcon, {
        size: 14
    }));
}
var $7fb581e3a321cc3d$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)(Container, {
        data: data,
        innerProps: (0, $fd7f409eefb792f2$export$2e2bcd8739ae039)((0, $fd7f409eefb792f2$export$2e2bcd8739ae039)({}, $7fb581e3a321cc3d$var$getStyleProps(props, "multiValue", {
            "multi-value": true,
            "multi-value--is-disabled": isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)(Label, {
        data: data,
        innerProps: (0, $fd7f409eefb792f2$export$2e2bcd8739ae039)({}, $7fb581e3a321cc3d$var$getStyleProps(props, "multiValueLabel", {
            "multi-value__label": true
        })),
        selectProps: selectProps
    }, children), (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)(Remove, {
        data: data,
        innerProps: (0, $fd7f409eefb792f2$export$2e2bcd8739ae039)((0, $fd7f409eefb792f2$export$2e2bcd8739ae039)({}, $7fb581e3a321cc3d$var$getStyleProps(props, "multiValueRemove", {
            "multi-value__remove": true
        })), {}, {
            "aria-label": "Remove ".concat(children || "option")
        }, removeProps),
        selectProps: selectProps
    }));
};
var $7fb581e3a321cc3d$var$MultiValue$1 = $7fb581e3a321cc3d$var$MultiValue;
var $7fb581e3a321cc3d$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $fd7f409eefb792f2$export$2e2bcd8739ae039)({
        label: "option",
        cursor: "default",
        display: "block",
        fontSize: "inherit",
        width: "100%",
        userSelect: "none",
        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : "transparent",
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : "inherit",
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ":active": {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $7fb581e3a321cc3d$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)("div", (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, $7fb581e3a321cc3d$var$getStyleProps(props, "option", {
        option: true,
        "option--is-disabled": isDisabled,
        "option--is-focused": isFocused,
        "option--is-selected": isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $7fb581e3a321cc3d$var$Option$1 = $7fb581e3a321cc3d$var$Option;
var $7fb581e3a321cc3d$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $fd7f409eefb792f2$export$2e2bcd8739ae039)({
        label: "placeholder",
        gridArea: "1 / 1 / 2 / 3"
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $7fb581e3a321cc3d$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)("div", (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, $7fb581e3a321cc3d$var$getStyleProps(props, "placeholder", {
        placeholder: true
    }), innerProps), children);
};
var $7fb581e3a321cc3d$var$Placeholder$1 = $7fb581e3a321cc3d$var$Placeholder;
var $7fb581e3a321cc3d$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $fd7f409eefb792f2$export$2e2bcd8739ae039)({
        label: "singleValue",
        gridArea: "1 / 1 / 2 / 3",
        maxWidth: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $7fb581e3a321cc3d$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)("div", (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, $7fb581e3a321cc3d$var$getStyleProps(props, "singleValue", {
        "single-value": true,
        "single-value--is-disabled": isDisabled
    }), innerProps), children);
};
var $7fb581e3a321cc3d$var$SingleValue$1 = $7fb581e3a321cc3d$var$SingleValue;
var $7fb581e3a321cc3d$export$db3b6bfb95261072 = {
    ClearIndicator: $7fb581e3a321cc3d$var$ClearIndicator,
    Control: $7fb581e3a321cc3d$var$Control$1,
    DropdownIndicator: $7fb581e3a321cc3d$var$DropdownIndicator,
    DownChevron: $7fb581e3a321cc3d$var$DownChevron,
    CrossIcon: $7fb581e3a321cc3d$var$CrossIcon,
    Group: $7fb581e3a321cc3d$var$Group$1,
    GroupHeading: $7fb581e3a321cc3d$var$GroupHeading,
    IndicatorsContainer: $7fb581e3a321cc3d$var$IndicatorsContainer,
    IndicatorSeparator: $7fb581e3a321cc3d$var$IndicatorSeparator,
    Input: $7fb581e3a321cc3d$var$Input$1,
    LoadingIndicator: $7fb581e3a321cc3d$var$LoadingIndicator,
    Menu: $7fb581e3a321cc3d$var$Menu$1,
    MenuList: $7fb581e3a321cc3d$var$MenuList,
    MenuPortal: $7fb581e3a321cc3d$var$MenuPortal,
    LoadingMessage: $7fb581e3a321cc3d$var$LoadingMessage,
    NoOptionsMessage: $7fb581e3a321cc3d$var$NoOptionsMessage,
    MultiValue: $7fb581e3a321cc3d$var$MultiValue$1,
    MultiValueContainer: $7fb581e3a321cc3d$var$MultiValueContainer,
    MultiValueLabel: $7fb581e3a321cc3d$var$MultiValueLabel,
    MultiValueRemove: $7fb581e3a321cc3d$var$MultiValueRemove,
    Option: $7fb581e3a321cc3d$var$Option$1,
    Placeholder: $7fb581e3a321cc3d$var$Placeholder$1,
    SelectContainer: $7fb581e3a321cc3d$var$SelectContainer,
    SingleValue: $7fb581e3a321cc3d$var$SingleValue$1,
    ValueContainer: $7fb581e3a321cc3d$var$ValueContainer
};
var $7fb581e3a321cc3d$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $fd7f409eefb792f2$export$2e2bcd8739ae039)((0, $fd7f409eefb792f2$export$2e2bcd8739ae039)({}, $7fb581e3a321cc3d$export$db3b6bfb95261072), props.components);
};



var $8f22dd427dbeede0$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $8f22dd427dbeede0$var$isEqual(first, second) {
    if (first === second) return true;
    if ($8f22dd427dbeede0$var$safeIsNaN(first) && $8f22dd427dbeede0$var$safeIsNaN(second)) return true;
    return false;
}
function $8f22dd427dbeede0$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$8f22dd427dbeede0$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $8f22dd427dbeede0$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $8f22dd427dbeede0$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}



function $586501d4645e6e14$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $586501d4645e6e14$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $586501d4645e6e14$var$A11yText = function A11yText(props) {
    return (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)("span", (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({
        css: $586501d4645e6e14$var$_ref
    }, props));
};
var $586501d4645e6e14$var$A11yText$1 = $586501d4645e6e14$var$A11yText;
var $586501d4645e6e14$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, tabSelectsValue = props.tabSelectsValue, context = props.context, isInitialFocus = props.isInitialFocus;
        switch(context){
            case "menu":
                return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(tabSelectsValue ? ", press Tab to select the option and exit the menu" : "", ".");
            case "input":
                return isInitialFocus ? "".concat(props["aria-label"] || "Select", " is focused ").concat(isSearchable ? ",type to refine list" : "", ", press Down to open the menu, ").concat(isMulti ? " press left to focus selected values" : "") : "";
            case "value":
                return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
            default:
                return "";
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? "" : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case "deselect-option":
            case "pop-value":
            case "remove-value":
                return "option ".concat(label, ", deselected.");
            case "clear":
                return "All selected options have been cleared.";
            case "initial-input-focus":
                return "option".concat(labels.length > 1 ? "s" : "", " ").concat(labels.join(","), ", selected.");
            case "select-option":
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return "";
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? "" : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected, isAppleDevice = props.isAppleDevice;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : "";
        };
        if (context === "value" && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === "menu" && isAppleDevice) {
            var disabled = isDisabled ? " disabled" : "";
            var status = "".concat(isSelected ? " selected" : "").concat(disabled);
            return "".concat(label).concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return "";
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? " for search term " + inputValue : "", ".");
    }
};
var $586501d4645e6e14$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id, isAppleDevice = props.isAppleDevice;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue, isLoading = selectProps.isLoading;
    var ariaLabel = selectProps["aria-label"];
    var ariaLive = selectProps["aria-live"];
    // Update aria live message configuration when prop changes
    var messages = (0, $6cds3.useMemo)(function() {
        return (0, $fd7f409eefb792f2$export$2e2bcd8739ae039)((0, $fd7f409eefb792f2$export$2e2bcd8739ae039)({}, $586501d4645e6e14$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $6cds3.useMemo)(function() {
        var message = "";
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : "";
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $fd7f409eefb792f2$export$2e2bcd8739ae039)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $6cds3.useMemo)(function() {
        var focusMsg = "";
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? "menu" : "value",
                selectValue: selectValue,
                isAppleDevice: isAppleDevice
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isAppleDevice
    ]);
    var ariaResults = (0, $6cds3.useMemo)(function() {
        var resultsMsg = "";
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus";
    var ariaGuidance = (0, $6cds3.useMemo)(function() {
        var guidanceMsg = "";
        if (messages.guidance) {
            var context = focusedValue ? "value" : menuIsOpen ? "menu" : "input";
            guidanceMsg = messages.guidance({
                "aria-label": ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    var ScreenReaderText = (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)((0, $6cds3.Fragment), null, (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)("span", {
        id: "aria-focused"
    }, ariaFocused), (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)("span", {
        id: "aria-results"
    }, ariaResults), (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)("span", {
        id: "aria-guidance"
    }, ariaGuidance));
    return (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)((0, $6cds3.Fragment), null, (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)($586501d4645e6e14$var$A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)($586501d4645e6e14$var$A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        role: "log"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $586501d4645e6e14$var$LiveRegion$1 = $586501d4645e6e14$var$LiveRegion;
var $586501d4645e6e14$var$diacritics = [
    {
        base: "A",
        letters: "A\u24B6\uFF21\xc0\xc1\xc2\u1EA6\u1EA4\u1EAA\u1EA8\xc3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xc4\u01DE\u1EA2\xc5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: "AA",
        letters: "\uA732"
    },
    {
        base: "AE",
        letters: "\xc6\u01FC\u01E2"
    },
    {
        base: "AO",
        letters: "\uA734"
    },
    {
        base: "AU",
        letters: "\uA736"
    },
    {
        base: "AV",
        letters: "\uA738\uA73A"
    },
    {
        base: "AY",
        letters: "\uA73C"
    },
    {
        base: "B",
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: "C",
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xc7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: "D",
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: "DZ",
        letters: "\u01F1\u01C4"
    },
    {
        base: "Dz",
        letters: "\u01F2\u01C5"
    },
    {
        base: "E",
        letters: "E\u24BA\uFF25\xc8\xc9\xca\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xcb\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: "F",
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: "G",
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: "H",
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: "I",
        letters: "I\u24BE\uFF29\xcc\xcd\xce\u0128\u012A\u012C\u0130\xcf\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: "J",
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: "K",
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: "L",
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: "LJ",
        letters: "\u01C7"
    },
    {
        base: "Lj",
        letters: "\u01C8"
    },
    {
        base: "M",
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: "N",
        letters: "N\u24C3\uFF2E\u01F8\u0143\xd1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: "NJ",
        letters: "\u01CA"
    },
    {
        base: "Nj",
        letters: "\u01CB"
    },
    {
        base: "O",
        letters: "O\u24C4\uFF2F\xd2\xd3\xd4\u1ED2\u1ED0\u1ED6\u1ED4\xd5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xd6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xd8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: "OI",
        letters: "\u01A2"
    },
    {
        base: "OO",
        letters: "\uA74E"
    },
    {
        base: "OU",
        letters: "\u0222"
    },
    {
        base: "P",
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: "Q",
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: "R",
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: "S",
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: "T",
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: "TZ",
        letters: "\uA728"
    },
    {
        base: "U",
        letters: "U\u24CA\uFF35\xd9\xda\xdb\u0168\u1E78\u016A\u1E7A\u016C\xdc\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: "V",
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: "VY",
        letters: "\uA760"
    },
    {
        base: "W",
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: "X",
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: "Y",
        letters: "Y\u24CE\uFF39\u1EF2\xdd\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: "Z",
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: "a",
        letters: "a\u24D0\uFF41\u1E9A\xe0\xe1\xe2\u1EA7\u1EA5\u1EAB\u1EA9\xe3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xe4\u01DF\u1EA3\xe5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: "aa",
        letters: "\uA733"
    },
    {
        base: "ae",
        letters: "\xe6\u01FD\u01E3"
    },
    {
        base: "ao",
        letters: "\uA735"
    },
    {
        base: "au",
        letters: "\uA737"
    },
    {
        base: "av",
        letters: "\uA739\uA73B"
    },
    {
        base: "ay",
        letters: "\uA73D"
    },
    {
        base: "b",
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: "c",
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xe7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: "d",
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: "dz",
        letters: "\u01F3\u01C6"
    },
    {
        base: "e",
        letters: "e\u24D4\uFF45\xe8\xe9\xea\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xeb\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: "f",
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: "g",
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: "h",
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: "hv",
        letters: "\u0195"
    },
    {
        base: "i",
        letters: "i\u24D8\uFF49\xec\xed\xee\u0129\u012B\u012D\xef\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: "j",
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: "k",
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: "l",
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: "lj",
        letters: "\u01C9"
    },
    {
        base: "m",
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: "n",
        letters: "n\u24DD\uFF4E\u01F9\u0144\xf1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: "nj",
        letters: "\u01CC"
    },
    {
        base: "o",
        letters: "o\u24DE\uFF4F\xf2\xf3\xf4\u1ED3\u1ED1\u1ED7\u1ED5\xf5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xf6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xf8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: "oi",
        letters: "\u01A3"
    },
    {
        base: "ou",
        letters: "\u0223"
    },
    {
        base: "oo",
        letters: "\uA74F"
    },
    {
        base: "p",
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: "q",
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: "r",
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: "s",
        letters: "s\u24E2\uFF53\xdf\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: "t",
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: "tz",
        letters: "\uA729"
    },
    {
        base: "u",
        letters: "u\u24E4\uFF55\xf9\xfa\xfb\u0169\u1E79\u016B\u1E7B\u016D\xfc\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: "v",
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: "vy",
        letters: "\uA761"
    },
    {
        base: "w",
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: "x",
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: "y",
        letters: "y\u24E8\uFF59\u1EF3\xfd\u0177\u1EF9\u0233\u1E8F\xff\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: "z",
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $586501d4645e6e14$var$anyDiacritic = new RegExp("[" + $586501d4645e6e14$var$diacritics.map(function(d) {
    return d.letters;
}).join("") + "]", "g");
var $586501d4645e6e14$var$diacriticToBase = {};
for(var $586501d4645e6e14$var$i = 0; $586501d4645e6e14$var$i < $586501d4645e6e14$var$diacritics.length; $586501d4645e6e14$var$i++){
    var $586501d4645e6e14$var$diacritic = $586501d4645e6e14$var$diacritics[$586501d4645e6e14$var$i];
    for(var $586501d4645e6e14$var$j = 0; $586501d4645e6e14$var$j < $586501d4645e6e14$var$diacritic.letters.length; $586501d4645e6e14$var$j++)$586501d4645e6e14$var$diacriticToBase[$586501d4645e6e14$var$diacritic.letters[$586501d4645e6e14$var$j]] = $586501d4645e6e14$var$diacritic.base;
}
var $586501d4645e6e14$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($586501d4645e6e14$var$anyDiacritic, function(match) {
        return $586501d4645e6e14$var$diacriticToBase[match];
    });
};
var $586501d4645e6e14$var$memoizedStripDiacriticsForInput = (0, $8f22dd427dbeede0$export$2e2bcd8739ae039)($586501d4645e6e14$var$stripDiacritics);
var $586501d4645e6e14$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, "");
};
var $586501d4645e6e14$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $586501d4645e6e14$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $fd7f409eefb792f2$export$2e2bcd8739ae039)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $586501d4645e6e14$var$defaultStringify,
            trim: true,
            matchFrom: "any"
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $586501d4645e6e14$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $586501d4645e6e14$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $586501d4645e6e14$var$memoizedStripDiacriticsForInput(input);
            candidate = $586501d4645e6e14$var$stripDiacritics(candidate);
        }
        return matchFrom === "start" ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $586501d4645e6e14$var$_excluded = [
    "innerRef"
];
function $586501d4645e6e14$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $3790664e4a835b94$export$2e2bcd8739ae039)(_ref, $586501d4645e6e14$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $7fb581e3a321cc3d$export$43caf9889c228507)(props, "onExited", "in", "enter", "exit", "appear");
    return (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)("input", (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $dacd7d2074e32fea$export$dbf350e5966cf602)({
            label: "dummyInput",
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: "transparent",
            fontSize: "inherit",
            gridArea: "1 / 1 / 2 / 3",
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: "transparent",
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: "relative",
            transform: "scale(.01)"
        }, "", "")
    }));
}
var $586501d4645e6e14$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $586501d4645e6e14$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $6cds3.useRef)(false);
    var isTop = (0, $6cds3.useRef)(false);
    var touchStart = (0, $6cds3.useRef)(0);
    var scrollTarget = (0, $6cds3.useRef)(null);
    var handleEventDelta = (0, $6cds3.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $586501d4645e6e14$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $6cds3.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $6cds3.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $6cds3.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $6cds3.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $7fb581e3a321cc3d$export$2408f22a0fab9ae5) ? {
            passive: false
        } : false;
        el.addEventListener("wheel", onWheel, notPassive);
        el.addEventListener("touchstart", onTouchStart, notPassive);
        el.addEventListener("touchmove", onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $6cds3.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener("wheel", onWheel, false);
        el.removeEventListener("touchstart", onTouchStart, false);
        el.removeEventListener("touchmove", onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $6cds3.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $586501d4645e6e14$var$STYLE_KEYS = [
    "boxSizing",
    "height",
    "overflow",
    "paddingRight",
    "position"
];
var $586501d4645e6e14$var$LOCK_STYLES = {
    boxSizing: "border-box",
    // account for possible declaration `width: 100%;` on body
    overflow: "hidden",
    position: "relative",
    height: "100%"
};
function $586501d4645e6e14$var$preventTouchMove(e) {
    e.preventDefault();
}
function $586501d4645e6e14$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $586501d4645e6e14$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $586501d4645e6e14$var$isTouchDevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
}
var $586501d4645e6e14$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var $586501d4645e6e14$var$activeScrollLocks = 0;
var $586501d4645e6e14$var$listenerOptions = {
    capture: false,
    passive: false
};
function $586501d4645e6e14$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $6cds3.useRef)({});
    var scrollTarget = (0, $6cds3.useRef)(null);
    var addScrollLock = (0, $6cds3.useCallback)(function(touchScrollTarget) {
        if (!$586501d4645e6e14$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $586501d4645e6e14$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $586501d4645e6e14$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($586501d4645e6e14$var$LOCK_STYLES).forEach(function(key) {
                var val = $586501d4645e6e14$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $586501d4645e6e14$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener("touchmove", $586501d4645e6e14$var$preventTouchMove, $586501d4645e6e14$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener("touchstart", $586501d4645e6e14$var$preventInertiaScroll, $586501d4645e6e14$var$listenerOptions);
                touchScrollTarget.addEventListener("touchmove", $586501d4645e6e14$var$allowTouchMove, $586501d4645e6e14$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $586501d4645e6e14$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $6cds3.useCallback)(function(touchScrollTarget) {
        if (!$586501d4645e6e14$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $586501d4645e6e14$var$activeScrollLocks = Math.max($586501d4645e6e14$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $586501d4645e6e14$var$activeScrollLocks < 1) $586501d4645e6e14$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $586501d4645e6e14$var$isTouchDevice()) {
            target.removeEventListener("touchmove", $586501d4645e6e14$var$preventTouchMove, $586501d4645e6e14$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener("touchstart", $586501d4645e6e14$var$preventInertiaScroll, $586501d4645e6e14$var$listenerOptions);
                touchScrollTarget.removeEventListener("touchmove", $586501d4645e6e14$var$allowTouchMove, $586501d4645e6e14$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $6cds3.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $586501d4645e6e14$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $586501d4645e6e14$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var $586501d4645e6e14$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $586501d4645e6e14$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $586501d4645e6e14$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $586501d4645e6e14$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)((0, $6cds3.Fragment), null, lockEnabled && (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)("div", {
        onClick: $586501d4645e6e14$var$blurSelectInput,
        css: $586501d4645e6e14$var$_ref2$1
    }), children(targetRef));
}
function $586501d4645e6e14$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $586501d4645e6e14$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $586501d4645e6e14$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $dacd7d2074e32fea$export$c8a8987d4410bf2d)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $586501d4645e6e14$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $586501d4645e6e14$var$RequiredInput$1 = $586501d4645e6e14$var$RequiredInput;
/// <reference types="user-agent-data-types" />
function $586501d4645e6e14$var$testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== "undefined" && window.navigator != null ? re.test(((_window$navigator$use = window.navigator["userAgentData"]) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function $586501d4645e6e14$var$isIPhone() {
    return $586501d4645e6e14$var$testPlatform(/^iPhone/i);
}
function $586501d4645e6e14$var$isMac() {
    return $586501d4645e6e14$var$testPlatform(/^Mac/i);
}
function $586501d4645e6e14$var$isIPad() {
    return $586501d4645e6e14$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $586501d4645e6e14$var$isMac() && navigator.maxTouchPoints > 1;
}
function $586501d4645e6e14$var$isIOS() {
    return $586501d4645e6e14$var$isIPhone() || $586501d4645e6e14$var$isIPad();
}
function $586501d4645e6e14$var$isAppleDevice() {
    return $586501d4645e6e14$var$isMac() || $586501d4645e6e14$var$isIOS();
}
var $586501d4645e6e14$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $586501d4645e6e14$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $586501d4645e6e14$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $586501d4645e6e14$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $586501d4645e6e14$var$defaultStyles = {
    clearIndicator: (0, $7fb581e3a321cc3d$export$407448d2b89b1813),
    container: (0, $7fb581e3a321cc3d$export$8b22cf2602fb60ce),
    control: (0, $7fb581e3a321cc3d$export$4368d992c4eafac0),
    dropdownIndicator: (0, $7fb581e3a321cc3d$export$f1e1789686576879),
    group: (0, $7fb581e3a321cc3d$export$39b482c5e57630a8),
    groupHeading: (0, $7fb581e3a321cc3d$export$2d1720544b23b823),
    indicatorsContainer: (0, $7fb581e3a321cc3d$export$23f2a1d2818174ef),
    indicatorSeparator: (0, $7fb581e3a321cc3d$export$dda1d9f60106f0e9),
    input: (0, $7fb581e3a321cc3d$export$35e795649ee09318),
    loadingIndicator: (0, $7fb581e3a321cc3d$export$882b5998b3b9117c),
    loadingMessage: (0, $7fb581e3a321cc3d$export$342063e11d6c3cad),
    menu: (0, $7fb581e3a321cc3d$export$953cecd6e717a553),
    menuList: (0, $7fb581e3a321cc3d$export$7ccc53e8f1e7dfc5),
    menuPortal: (0, $7fb581e3a321cc3d$export$ae1af26003f05816),
    multiValue: (0, $7fb581e3a321cc3d$export$ffb5f4729a158638),
    multiValueLabel: (0, $7fb581e3a321cc3d$export$9e5f44173e64f162),
    multiValueRemove: (0, $7fb581e3a321cc3d$export$625550452a3fa3ec),
    noOptionsMessage: (0, $7fb581e3a321cc3d$export$3b14a55fb2447963),
    option: (0, $7fb581e3a321cc3d$export$90a7f3efeed30595),
    placeholder: (0, $7fb581e3a321cc3d$export$efccba1c4a2ef57b),
    singleValue: (0, $7fb581e3a321cc3d$export$d141bba7fdc215a3),
    valueContainer: (0, $7fb581e3a321cc3d$export$4a5767248b18ef41)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $586501d4645e6e14$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $fd7f409eefb792f2$export$2e2bcd8739ae039)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $586501d4645e6e14$var$colors = {
    primary: "#2684FF",
    primary75: "#4C9AFF",
    primary50: "#B2D4FF",
    primary25: "#DEEBFF",
    danger: "#DE350B",
    dangerLight: "#FFBDAD",
    neutral0: "hsl(0, 0%, 100%)",
    neutral5: "hsl(0, 0%, 95%)",
    neutral10: "hsl(0, 0%, 90%)",
    neutral20: "hsl(0, 0%, 80%)",
    neutral30: "hsl(0, 0%, 70%)",
    neutral40: "hsl(0, 0%, 60%)",
    neutral50: "hsl(0, 0%, 50%)",
    neutral60: "hsl(0, 0%, 40%)",
    neutral70: "hsl(0, 0%, 30%)",
    neutral80: "hsl(0, 0%, 20%)",
    neutral90: "hsl(0, 0%, 10%)"
};
var $586501d4645e6e14$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $586501d4645e6e14$var$baseUnit = 4;
// The minimum height of the control
var $586501d4645e6e14$var$controlHeight = 38;
// The amount of space between the control and menu */
var $586501d4645e6e14$var$menuGutter = $586501d4645e6e14$var$baseUnit * 2;
var $586501d4645e6e14$var$spacing = {
    baseUnit: $586501d4645e6e14$var$baseUnit,
    controlHeight: $586501d4645e6e14$var$controlHeight,
    menuGutter: $586501d4645e6e14$var$menuGutter
};
var $586501d4645e6e14$export$4368d992c4eafac0 = {
    borderRadius: $586501d4645e6e14$var$borderRadius,
    colors: $586501d4645e6e14$var$colors,
    spacing: $586501d4645e6e14$var$spacing
};
var $586501d4645e6e14$export$407448d2b89b1813 = {
    "aria-live": "polite",
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $7fb581e3a321cc3d$export$df995fae86a55f06)(),
    captureMenuScroll: !(0, $7fb581e3a321cc3d$export$df995fae86a55f06)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $586501d4645e6e14$export$db3b6bfb95261072(),
    formatGroupLabel: $586501d4645e6e14$var$formatGroupLabel,
    getOptionLabel: $586501d4645e6e14$export$8b22cf2602fb60ce,
    getOptionValue: $586501d4645e6e14$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $586501d4645e6e14$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return "Loading...";
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: "bottom",
    menuPosition: "absolute",
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $7fb581e3a321cc3d$export$ebd11618f299a286)(),
    noOptionsMessage: function noOptionsMessage() {
        return "No options";
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: "Select...",
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? "s" : "", " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $586501d4645e6e14$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $586501d4645e6e14$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $586501d4645e6e14$var$_isOptionSelected(props, option, selectValue);
    var label = $586501d4645e6e14$var$getOptionLabel(props, option);
    var value = $586501d4645e6e14$var$getOptionValue(props, option);
    return {
        type: "option",
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $586501d4645e6e14$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ("options" in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $586501d4645e6e14$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $586501d4645e6e14$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: "group",
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $586501d4645e6e14$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $586501d4645e6e14$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $7fb581e3a321cc3d$export$3466f893ebf79586));
}
function $586501d4645e6e14$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, $544a4c0a6fa69128$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $586501d4645e6e14$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, $544a4c0a6fa69128$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $586501d4645e6e14$var$buildFocusableOptions(props, selectValue) {
    return $586501d4645e6e14$var$buildFocusableOptionsFromCategorizedOptions($586501d4645e6e14$var$buildCategorizedOptions(props, selectValue));
}
function $586501d4645e6e14$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? "" : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$586501d4645e6e14$var$shouldHideSelectedOptions(props) || !isSelected) && $586501d4645e6e14$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $586501d4645e6e14$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $586501d4645e6e14$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $586501d4645e6e14$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $586501d4645e6e14$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $586501d4645e6e14$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $586501d4645e6e14$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === "function" ? props.isOptionDisabled(option, selectValue) : false;
}
function $586501d4645e6e14$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === "function") return props.isOptionSelected(option, selectValue);
    var candidate = $586501d4645e6e14$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $586501d4645e6e14$var$getOptionValue(props, i) === candidate;
    });
}
function $586501d4645e6e14$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $586501d4645e6e14$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $586501d4645e6e14$var$instanceId = 1;
var $586501d4645e6e14$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $9ac022430c6bab36$export$2e2bcd8739ae039)(Select, _Component);
    var _super = (0, $9113642ee56fc20c$export$2e2bcd8739ae039)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $f50e9ddf3899eedf$export$2e2bcd8739ae039)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ""
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.isAppleDevice = $586501d4645e6e14$var$isAppleDevice();
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange("", {
                action: "set-value",
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $7fb581e3a321cc3d$export$ef35774e6d314e91)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), "deselect-option", newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $7fb581e3a321cc3d$export$ef35774e6d314e91)([].concat((0, $544a4c0a6fa69128$export$2e2bcd8739ae039)(selectValue), [
                    newValue
                ])), "select-option", newValue);
                else _this.setValue((0, $7fb581e3a321cc3d$export$e7094788287c5e9b)(newValue), "select-option");
            } else {
                _this.ariaOnChange((0, $7fb581e3a321cc3d$export$e7094788287c5e9b)(newValue), {
                    action: "select-option",
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $7fb581e3a321cc3d$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "remove-value",
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $7fb581e3a321cc3d$export$96f57966bedc81b4)(_this.props.isMulti, [], null), {
                action: "clear",
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $7fb581e3a321cc3d$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "pop-value",
                removedValue: lastSelectedValue
            });
        };
        _this.getFocusedOptionId = function(focusedOption) {
            return $586501d4645e6e14$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        };
        _this.getFocusableOptionsWithIds = function() {
            return $586501d4645e6e14$var$buildFocusableOptionsWithIds($586501d4645e6e14$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId("option"));
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $7fb581e3a321cc3d$export$a9c23c6ac3fc3eca).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $586501d4645e6e14$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $586501d4645e6e14$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $586501d4645e6e14$var$defaultStyles[key](props, unstyled);
            base.boxSizing = "border-box";
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $7fb581e3a321cc3d$export$d66501df72047452)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $586501d4645e6e14$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $586501d4645e6e14$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $fd7f409eefb792f2$export$2e2bcd8739ae039)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu("first");
            } else if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") _this.onMenuClose();
            if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu("first");
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === "touchend") _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === "boolean") {
                if (event.target instanceof HTMLElement && (0, $7fb581e3a321cc3d$export$2329c99376c9d0a4)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === "function") {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: "input-change",
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu("first");
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange("", {
                action: "input-blur",
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $586501d4645e6e14$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === "function") {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case "ArrowLeft":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("previous");
                    break;
                case "ArrowRight":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("next");
                    break;
                case "Delete":
                case "Backspace":
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case "Tab":
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case "Enter":
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case "Escape":
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange("", {
                            action: "menu-close",
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case " ":
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu("first");
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case "ArrowUp":
                    if (menuIsOpen) _this.focusOption("up");
                    else _this.openMenu("last");
                    break;
                case "ArrowDown":
                    if (menuIsOpen) _this.focusOption("down");
                    else _this.openMenu("first");
                    break;
                case "PageUp":
                    if (!menuIsOpen) return;
                    _this.focusOption("pageup");
                    break;
                case "PageDown":
                    if (!menuIsOpen) return;
                    _this.focusOption("pagedown");
                    break;
                case "Home":
                    if (!menuIsOpen) return;
                    _this.focusOption("first");
                    break;
                case "End":
                    if (!menuIsOpen) return;
                    _this.focusOption("last");
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.state.instancePrefix = "react-select-" + (_this.props.instanceId || ++$586501d4645e6e14$var$instanceId);
        _this.state.selectValue = (0, $7fb581e3a321cc3d$export$7f8ddf7c7c20b3cd)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $586501d4645e6e14$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, $73a5a93d106b2fb4$export$2e2bcd8739ae039)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener("scroll", this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $7fb581e3a321cc3d$export$9bb611d729802a56)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $7fb581e3a321cc3d$export$9bb611d729802a56)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener("scroll", this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange("", {
                    action: "menu-close",
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === "first" ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex],
                    focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case "previous":
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case "next":
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "first";
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === "up") nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === "down") nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === "pageup") {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === "pagedown") {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === "last") nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $586501d4645e6e14$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === "function") return this.props.theme($586501d4645e6e14$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $fd7f409eefb792f2$export$2e2bcd8739ae039)((0, $fd7f409eefb792f2$export$2e2bcd8739ae039)({}, $586501d4645e6e14$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $586501d4645e6e14$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $586501d4645e6e14$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $586501d4645e6e14$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === "function") {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener("compositionstart", this.onCompositionStart, false);
                    document.addEventListener("compositionend", this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("compositionstart", this.onCompositionStart);
                    document.removeEventListener("compositionend", this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener("touchstart", this.onTouchStart, false);
                    document.addEventListener("touchmove", this.onTouchMove, false);
                    document.addEventListener("touchend", this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("touchstart", this.onTouchStart);
                    document.removeEventListener("touchmove", this.onTouchMove);
                    document.removeEventListener("touchend", this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId("input");
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $fd7f409eefb792f2$export$2e2bcd8739ae039)((0, $fd7f409eefb792f2$export$2e2bcd8739ae039)((0, $fd7f409eefb792f2$export$2e2bcd8739ae039)({
                    "aria-autocomplete": "list",
                    "aria-expanded": menuIsOpen,
                    "aria-haspopup": true,
                    "aria-errormessage": this.props["aria-errormessage"],
                    "aria-invalid": this.props["aria-invalid"],
                    "aria-label": this.props["aria-label"],
                    "aria-labelledby": this.props["aria-labelledby"],
                    "aria-required": required,
                    role: "combobox",
                    "aria-activedescendant": this.isAppleDevice ? undefined : this.state.focusedOptionId || ""
                }, menuIsOpen && {
                    "aria-controls": this.getElementId("listbox")
                }), !isSearchable && {
                    "aria-readonly": true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus" && {
                    "aria-describedby": this.getElementId("live-region")
                } : {
                    "aria-describedby": this.getElementId("placeholder")
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $6cds3.createElement($586501d4645e6e14$var$DummyInput, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $7fb581e3a321cc3d$export$b4171a6734a65d42),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $6cds3.createElement(Input, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $6cds3.createElement(Placeholder, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId("placeholder")
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $6cds3.createElement(MultiValue, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, "value"));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $6cds3.createElement(SingleValue, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, "value"));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $6cds3.createElement(ClearIndicator, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $6cds3.createElement(LoadingIndicator, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $6cds3.createElement(IndicatorSeparator, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $6cds3.createElement(DropdownIndicator, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId("option"), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1,
                        role: "option",
                        "aria-selected": _this4.isAppleDevice ? undefined : isSelected // is not supported on Apple devices
                    };
                    return /*#__PURE__*/ $6cds3.createElement(Option, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, "menu"));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === "group") {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId("group"), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $6cds3.createElement(Group, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === "option") return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $6cds3.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $6cds3.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $6cds3.createElement((0, $7fb581e3a321cc3d$export$3a1a48c8f6ef640e), (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $6cds3.createElement(Menu, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $6cds3.createElement($586501d4645e6e14$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $6cds3.createElement(MenuList, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: {
                                role: "listbox",
                                "aria-multiselectable": commonProps.isMulti,
                                id: _this4.getElementId("listbox")
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === "fixed" ? /*#__PURE__*/ $6cds3.createElement(MenuPortal, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $6cds3.createElement($586501d4645e6e14$var$RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $6cds3.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $6cds3.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $6cds3.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $6cds3.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : "";
                    return /*#__PURE__*/ $6cds3.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $6cds3.createElement($586501d4645e6e14$var$LiveRegion$1, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, commonProps, {
                    id: this.getElementId("live-region"),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions,
                    isAppleDevice: this.isAppleDevice
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $6cds3.createElement(SelectContainer, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $6cds3.createElement(Control, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $6cds3.createElement(ValueContainer, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $6cds3.createElement(IndicatorsContainer, (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $7fb581e3a321cc3d$export$7f8ddf7c7c20b3cd)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $586501d4645e6e14$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $586501d4645e6e14$var$buildFocusableOptionsWithIds($586501d4645e6e14$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $586501d4645e6e14$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $586501d4645e6e14$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $586501d4645e6e14$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $7fb581e3a321cc3d$export$96f57966bedc81b4)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: "initial-input-focus"
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus") newAriaSelection = null;
                return (0, $fd7f409eefb792f2$export$2e2bcd8739ae039)((0, $fd7f409eefb792f2$export$2e2bcd8739ae039)((0, $fd7f409eefb792f2$export$2e2bcd8739ae039)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $6cds3.Component));
$586501d4645e6e14$export$25ce5a424b770e84.defaultProps = $586501d4645e6e14$export$407448d2b89b1813;





var $69ab4f53e5c4540b$exports = {};

function $69ab4f53e5c4540b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $69ab4f53e5c4540b$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $69ab4f53e5c4540b$var$ownKeys(Object(t), !0).forEach(function(r) {
            $4a3adae6c43f9f2f$exports(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $69ab4f53e5c4540b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
$69ab4f53e5c4540b$exports = $69ab4f53e5c4540b$var$_objectSpread2, $69ab4f53e5c4540b$exports.__esModule = true, $69ab4f53e5c4540b$exports["default"] = $69ab4f53e5c4540b$exports;


var $feefb54ed6a061ff$exports = {};
var $5b178763441f13c8$exports = {};
function $5b178763441f13c8$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
$5b178763441f13c8$exports = $5b178763441f13c8$var$_arrayWithHoles, $5b178763441f13c8$exports.__esModule = true, $5b178763441f13c8$exports["default"] = $5b178763441f13c8$exports;


var $32ff8fde3807427c$exports = {};
function $32ff8fde3807427c$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
$32ff8fde3807427c$exports = $32ff8fde3807427c$var$_iterableToArrayLimit, $32ff8fde3807427c$exports.__esModule = true, $32ff8fde3807427c$exports["default"] = $32ff8fde3807427c$exports;


var $1aed6582a65e9993$exports = {};
var $5ef1ba8774ea9333$exports = {};
function $5ef1ba8774ea9333$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
$5ef1ba8774ea9333$exports = $5ef1ba8774ea9333$var$_arrayLikeToArray, $5ef1ba8774ea9333$exports.__esModule = true, $5ef1ba8774ea9333$exports["default"] = $5ef1ba8774ea9333$exports;


function $1aed6582a65e9993$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5ef1ba8774ea9333$exports(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5ef1ba8774ea9333$exports(o, minLen);
}
$1aed6582a65e9993$exports = $1aed6582a65e9993$var$_unsupportedIterableToArray, $1aed6582a65e9993$exports.__esModule = true, $1aed6582a65e9993$exports["default"] = $1aed6582a65e9993$exports;


var $0f0553a9657dafbb$exports = {};
function $0f0553a9657dafbb$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$0f0553a9657dafbb$exports = $0f0553a9657dafbb$var$_nonIterableRest, $0f0553a9657dafbb$exports.__esModule = true, $0f0553a9657dafbb$exports["default"] = $0f0553a9657dafbb$exports;


function $feefb54ed6a061ff$var$_slicedToArray(arr, i) {
    return $5b178763441f13c8$exports(arr) || $32ff8fde3807427c$exports(arr, i) || $1aed6582a65e9993$exports(arr, i) || $0f0553a9657dafbb$exports();
}
$feefb54ed6a061ff$exports = $feefb54ed6a061ff$var$_slicedToArray, $feefb54ed6a061ff$exports.__esModule = true, $feefb54ed6a061ff$exports["default"] = $feefb54ed6a061ff$exports;


var $50d831fb25df4c53$exports = {};
var $a9e2abcfaf1610ac$exports = {};
function $a9e2abcfaf1610ac$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
$a9e2abcfaf1610ac$exports = $a9e2abcfaf1610ac$var$_objectWithoutPropertiesLoose, $a9e2abcfaf1610ac$exports.__esModule = true, $a9e2abcfaf1610ac$exports["default"] = $a9e2abcfaf1610ac$exports;


function $50d831fb25df4c53$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a9e2abcfaf1610ac$exports(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
$50d831fb25df4c53$exports = $50d831fb25df4c53$var$_objectWithoutProperties, $50d831fb25df4c53$exports.__esModule = true, $50d831fb25df4c53$exports["default"] = $50d831fb25df4c53$exports;


var $e7a0d6117b14408a$exports = {};
function $e7a0d6117b14408a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
$e7a0d6117b14408a$exports = $e7a0d6117b14408a$var$_classCallCheck, $e7a0d6117b14408a$exports.__esModule = true, $e7a0d6117b14408a$exports["default"] = $e7a0d6117b14408a$exports;


var $c46baee137ba8899$exports = {};

function $c46baee137ba8899$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $3bc9bf0cfc9870da$exports(descriptor.key), descriptor);
    }
}
function $c46baee137ba8899$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c46baee137ba8899$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c46baee137ba8899$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
$c46baee137ba8899$exports = $c46baee137ba8899$var$_createClass, $c46baee137ba8899$exports.__esModule = true, $c46baee137ba8899$exports["default"] = $c46baee137ba8899$exports;


var $588e0b70f964bc48$exports = {};
var $0ec6d5652e8f014e$exports = {};
function $0ec6d5652e8f014e$var$_setPrototypeOf(o, p) {
    $0ec6d5652e8f014e$exports = $0ec6d5652e8f014e$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    }, $0ec6d5652e8f014e$exports.__esModule = true, $0ec6d5652e8f014e$exports["default"] = $0ec6d5652e8f014e$exports;
    return $0ec6d5652e8f014e$var$_setPrototypeOf(o, p);
}
$0ec6d5652e8f014e$exports = $0ec6d5652e8f014e$var$_setPrototypeOf, $0ec6d5652e8f014e$exports.__esModule = true, $0ec6d5652e8f014e$exports["default"] = $0ec6d5652e8f014e$exports;


function $588e0b70f964bc48$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $0ec6d5652e8f014e$exports(subClass, superClass);
}
$588e0b70f964bc48$exports = $588e0b70f964bc48$var$_inherits, $588e0b70f964bc48$exports.__esModule = true, $588e0b70f964bc48$exports["default"] = $588e0b70f964bc48$exports;


var $09979d885d9d69d7$exports = {};
var $6f1de2b7a6bf7757$exports = {};
function $6f1de2b7a6bf7757$var$_getPrototypeOf(o) {
    $6f1de2b7a6bf7757$exports = $6f1de2b7a6bf7757$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    }, $6f1de2b7a6bf7757$exports.__esModule = true, $6f1de2b7a6bf7757$exports["default"] = $6f1de2b7a6bf7757$exports;
    return $6f1de2b7a6bf7757$var$_getPrototypeOf(o);
}
$6f1de2b7a6bf7757$exports = $6f1de2b7a6bf7757$var$_getPrototypeOf, $6f1de2b7a6bf7757$exports.__esModule = true, $6f1de2b7a6bf7757$exports["default"] = $6f1de2b7a6bf7757$exports;


var $26a68b5ff9a00d2e$exports = {};
function $26a68b5ff9a00d2e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($26a68b5ff9a00d2e$exports = $26a68b5ff9a00d2e$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, $26a68b5ff9a00d2e$exports.__esModule = true, $26a68b5ff9a00d2e$exports["default"] = $26a68b5ff9a00d2e$exports)();
}
$26a68b5ff9a00d2e$exports = $26a68b5ff9a00d2e$var$_isNativeReflectConstruct, $26a68b5ff9a00d2e$exports.__esModule = true, $26a68b5ff9a00d2e$exports["default"] = $26a68b5ff9a00d2e$exports;


var $1b128f50ed4aaaa8$exports = {};

var $1b128f50ed4aaaa8$var$_typeof = $cb41ce2cd8de63fa$exports.default;
var $94af5531e360635d$exports = {};
function $94af5531e360635d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
$94af5531e360635d$exports = $94af5531e360635d$var$_assertThisInitialized, $94af5531e360635d$exports.__esModule = true, $94af5531e360635d$exports["default"] = $94af5531e360635d$exports;


function $1b128f50ed4aaaa8$var$_possibleConstructorReturn(self, call) {
    if (call && ($1b128f50ed4aaaa8$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $94af5531e360635d$exports(self);
}
$1b128f50ed4aaaa8$exports = $1b128f50ed4aaaa8$var$_possibleConstructorReturn, $1b128f50ed4aaaa8$exports.__esModule = true, $1b128f50ed4aaaa8$exports["default"] = $1b128f50ed4aaaa8$exports;


function $09979d885d9d69d7$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $26a68b5ff9a00d2e$exports();
    return function _createSuperInternal() {
        var Super = $6f1de2b7a6bf7757$exports(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $6f1de2b7a6bf7757$exports(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $1b128f50ed4aaaa8$exports(this, result);
    };
}
$09979d885d9d69d7$exports = $09979d885d9d69d7$var$_createSuper, $09979d885d9d69d7$exports.__esModule = true, $09979d885d9d69d7$exports["default"] = $09979d885d9d69d7$exports;


var $7de4253d508a1f16$exports = {};
var $bb85e4815818da55$exports = {};

function $bb85e4815818da55$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $5ef1ba8774ea9333$exports(arr);
}
$bb85e4815818da55$exports = $bb85e4815818da55$var$_arrayWithoutHoles, $bb85e4815818da55$exports.__esModule = true, $bb85e4815818da55$exports["default"] = $bb85e4815818da55$exports;


var $4bae5520d2b7cff6$exports = {};
function $4bae5520d2b7cff6$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
$4bae5520d2b7cff6$exports = $4bae5520d2b7cff6$var$_iterableToArray, $4bae5520d2b7cff6$exports.__esModule = true, $4bae5520d2b7cff6$exports["default"] = $4bae5520d2b7cff6$exports;



var $0b71306a702cf22f$exports = {};
function $0b71306a702cf22f$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$0b71306a702cf22f$exports = $0b71306a702cf22f$var$_nonIterableSpread, $0b71306a702cf22f$exports.__esModule = true, $0b71306a702cf22f$exports["default"] = $0b71306a702cf22f$exports;


function $7de4253d508a1f16$var$_toConsumableArray(arr) {
    return $bb85e4815818da55$exports(arr) || $4bae5520d2b7cff6$exports(arr) || $1aed6582a65e9993$exports(arr) || $0b71306a702cf22f$exports();
}
$7de4253d508a1f16$exports = $7de4253d508a1f16$var$_toConsumableArray, $7de4253d508a1f16$exports.__esModule = true, $7de4253d508a1f16$exports["default"] = $7de4253d508a1f16$exports;




var $a6637ae8d7c5a468$exports = {};
function $a6637ae8d7c5a468$var$_taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
$a6637ae8d7c5a468$exports = $a6637ae8d7c5a468$var$_taggedTemplateLiteral, $a6637ae8d7c5a468$exports.__esModule = true, $a6637ae8d7c5a468$exports["default"] = $a6637ae8d7c5a468$exports;






var $5e385862a1a4c8ce$var$StateManagedSelect = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $5e78cf16b39d7fc6$export$3b14a55fb2447963)(props);
    return /*#__PURE__*/ $6cds3.createElement((0, $586501d4645e6e14$export$25ce5a424b770e84), (0, $9c3c5e85872c2b24$export$2e2bcd8739ae039)({
        ref: ref
    }, baseSelectProps));
});
var $5e385862a1a4c8ce$export$2e2bcd8739ae039 = $5e385862a1a4c8ce$var$StateManagedSelect;
var $5e385862a1a4c8ce$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $6cds3.useMemo)(function() {
        return (0, $4d6bef5101ace00d$export$2e2bcd8739ae039)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $6cds3.createElement((0, $d45a4a2414093d11$export$e7094788287c5e9b), {
        value: emotionCache
    }, children);
};



parcelRequire("6cds3");
parcelRequire("c9wMV");

var $6cds3 = parcelRequire("6cds3");

var $aMJGV = parcelRequire("aMJGV");
var $98e6c3958c713811$var$_excluded = [
    "color",
    "size",
    "title"
];
function $98e6c3958c713811$var$_extends() {
    $98e6c3958c713811$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $98e6c3958c713811$var$_extends.apply(this, arguments);
}
function $98e6c3958c713811$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $98e6c3958c713811$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $98e6c3958c713811$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $98e6c3958c713811$var$CheckCircle = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, rest = $98e6c3958c713811$var$_objectWithoutProperties(_ref, $98e6c3958c713811$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("svg", $98e6c3958c713811$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"
    }));
});
$98e6c3958c713811$var$CheckCircle.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string
};
$98e6c3958c713811$var$CheckCircle.defaultProps = {
    color: "currentColor",
    size: "1em",
    title: null
};
var $98e6c3958c713811$export$2e2bcd8739ae039 = $98e6c3958c713811$var$CheckCircle;


var $6cds3 = parcelRequire("6cds3");

var $aMJGV = parcelRequire("aMJGV");
var $ac4c3421df377bd7$var$_excluded = [
    "color",
    "size",
    "title"
];
function $ac4c3421df377bd7$var$_extends() {
    $ac4c3421df377bd7$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ac4c3421df377bd7$var$_extends.apply(this, arguments);
}
function $ac4c3421df377bd7$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ac4c3421df377bd7$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $ac4c3421df377bd7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $ac4c3421df377bd7$var$XCircle = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, rest = $ac4c3421df377bd7$var$_objectWithoutProperties(_ref, $ac4c3421df377bd7$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("svg", $ac4c3421df377bd7$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"
    }));
});
$ac4c3421df377bd7$var$XCircle.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string
};
$ac4c3421df377bd7$var$XCircle.defaultProps = {
    color: "currentColor",
    size: "1em",
    title: null
};
var $ac4c3421df377bd7$export$2e2bcd8739ae039 = $ac4c3421df377bd7$var$XCircle;


var $6cds3 = parcelRequire("6cds3");

var $aMJGV = parcelRequire("aMJGV");
var $8643049b4ee40688$var$_excluded = [
    "color",
    "size",
    "title"
];
function $8643049b4ee40688$var$_extends() {
    $8643049b4ee40688$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8643049b4ee40688$var$_extends.apply(this, arguments);
}
function $8643049b4ee40688$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $8643049b4ee40688$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $8643049b4ee40688$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $8643049b4ee40688$var$InfoCircle = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, rest = $8643049b4ee40688$var$_objectWithoutProperties(_ref, $8643049b4ee40688$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("svg", $8643049b4ee40688$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
    }));
});
$8643049b4ee40688$var$InfoCircle.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string
};
$8643049b4ee40688$var$InfoCircle.defaultProps = {
    color: "currentColor",
    size: "1em",
    title: null
};
var $8643049b4ee40688$export$2e2bcd8739ae039 = $8643049b4ee40688$var$InfoCircle;






var $aMJGV = parcelRequire("aMJGV");

var $6cds3 = parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");


/*
 * Browsers including Internet Explorer, Chrome, Safari, and Firefox store the
 * delay as a 32-bit signed integer internally. This causes an integer overflow
 * when using delays larger than 2,147,483,647 ms (about 24.8 days),
 * resulting in the timeout being executed immediately.
 *
 * via: https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/setTimeout
 */ const $be71fffe37357017$var$MAX_DELAY_MS = 2 ** 31 - 1;
function $be71fffe37357017$var$setChainedTimeout(handleRef, fn, timeoutAtMs) {
    const delayMs = timeoutAtMs - Date.now();
    handleRef.current = delayMs <= $be71fffe37357017$var$MAX_DELAY_MS ? setTimeout(fn, delayMs) : setTimeout(()=>$be71fffe37357017$var$setChainedTimeout(handleRef, fn, timeoutAtMs), $be71fffe37357017$var$MAX_DELAY_MS);
}
function $be71fffe37357017$export$2e2bcd8739ae039() {
    const isMounted = (0, $316c1fef2af83f46$export$2e2bcd8739ae039)();
    // types are confused between node and web here IDK
    const handleRef = (0, $6cds3.useRef)();
    (0, $9b0b5255176140e6$export$2e2bcd8739ae039)(()=>clearTimeout(handleRef.current));
    return (0, $6cds3.useMemo)(()=>{
        const clear = ()=>clearTimeout(handleRef.current);
        function set(fn, delayMs = 0) {
            if (!isMounted()) return;
            clear();
            if (delayMs <= $be71fffe37357017$var$MAX_DELAY_MS) // For simplicity, if the timeout is short, just set a normal timeout.
            handleRef.current = setTimeout(fn, delayMs);
            else $be71fffe37357017$var$setChainedTimeout(handleRef, fn, Date.now() + delayMs);
        }
        return {
            set: set,
            clear: clear,
            handleRef: handleRef
        };
    }, []);
}






var $6cds3 = parcelRequire("6cds3");


var $6cds3 = parcelRequire("6cds3");




var $6cds3 = parcelRequire("6cds3");
var $5a6576f79ab32dab$var$has = Object.prototype.hasOwnProperty;
function $5a6576f79ab32dab$var$find(iter, tar, key) {
    for (key of iter.keys()){
        if ($5a6576f79ab32dab$export$de8294bb3be0322f(key, tar)) return key;
    }
}
function $5a6576f79ab32dab$export$de8294bb3be0322f(foo, bar) {
    var ctor, len, tmp;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $5a6576f79ab32dab$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (ctor === Set) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len;
                if (tmp && typeof tmp === "object") {
                    tmp = $5a6576f79ab32dab$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!bar.has(tmp)) return false;
            }
            return true;
        }
        if (ctor === Map) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len[0];
                if (tmp && typeof tmp === "object") {
                    tmp = $5a6576f79ab32dab$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!$5a6576f79ab32dab$export$de8294bb3be0322f(len[1], bar.get(tmp))) return false;
            }
            return true;
        }
        if (ctor === ArrayBuffer) {
            foo = new Uint8Array(foo);
            bar = new Uint8Array(bar);
        } else if (ctor === DataView) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo.getInt8(len) === bar.getInt8(len));
            }
            return len === -1;
        }
        if (ArrayBuffer.isView(foo)) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo[len] === bar[len]);
            }
            return len === -1;
        }
        if (!ctor || typeof foo === "object") {
            len = 0;
            for(ctor in foo){
                if ($5a6576f79ab32dab$var$has.call(foo, ctor) && ++len && !$5a6576f79ab32dab$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$5a6576f79ab32dab$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}



var $6cds3 = parcelRequire("6cds3");

/**
 * `useSafeState` takes the return value of a `useState` hook and wraps the
 * setter to prevent updates onces the component has unmounted. Can used
 * with `useMergeState` and `useStateAsync` as well
 *
 * @param state The return value of a useStateHook
 *
 * ```ts
 * const [show, setShow] = useSafeState(useState(true));
 * ```
 */ function $dbcefa4139b16bdd$var$useSafeState(state) {
    const isMounted = (0, $316c1fef2af83f46$export$2e2bcd8739ae039)();
    return [
        state[0],
        (0, $6cds3.useCallback)((nextState)=>{
            if (!isMounted()) return;
            return state[1](nextState);
        }, [
            isMounted,
            state[1]
        ])
    ];
}
var $dbcefa4139b16bdd$export$2e2bcd8739ae039 = $dbcefa4139b16bdd$var$useSafeState;



function $092f29fbb30c478d$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}


function $680cda951cc660bc$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $01cb709cd5370de9$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $680cda951cc660bc$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $01cb709cd5370de9$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $680cda951cc660bc$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $01cb709cd5370de9$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $680cda951cc660bc$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $3a3207884994be75$export$8960430cfd85939f = Math.max;
var $3a3207884994be75$export$96ec731ed4dcb222 = Math.min;
var $3a3207884994be75$export$2077e0241d6afd3c = Math.round;



function $df39890b6b1fe461$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $7dfa0e76e710c36d$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $df39890b6b1fe461$export$2e2bcd8739ae039)());
}


function $4e0071e6daf7da37$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $01cb709cd5370de9$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $3a3207884994be75$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $3a3207884994be75$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $01cb709cd5370de9$export$45a5e7f76e0caa8d)(element) ? (0, $680cda951cc660bc$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $7dfa0e76e710c36d$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $b2894a9909fee0ac$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $4e0071e6daf7da37$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $83fd88a53251902b$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $01cb709cd5370de9$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $6c7ca167d1d5c39d$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}



function $ac546328a2948766$export$2e2bcd8739ae039(element) {
    return (0, $680cda951cc660bc$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $c6f42873e503164d$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $6c7ca167d1d5c39d$export$2e2bcd8739ae039)(element)) >= 0;
}




function $60de3c72b5fe89e5$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $01cb709cd5370de9$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $20dcc294d1d30f92$export$2e2bcd8739ae039(element) {
    if ((0, $6c7ca167d1d5c39d$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $01cb709cd5370de9$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $60de3c72b5fe89e5$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $6e5ac768271f57bc$var$getTrueOffsetParent(element) {
    if (!(0, $01cb709cd5370de9$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $ac546328a2948766$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $6e5ac768271f57bc$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $df39890b6b1fe461$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $df39890b6b1fe461$export$2e2bcd8739ae039)());
    if (isIE && (0, $01cb709cd5370de9$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $ac546328a2948766$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $20dcc294d1d30f92$export$2e2bcd8739ae039)(element);
    if ((0, $01cb709cd5370de9$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $01cb709cd5370de9$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $6c7ca167d1d5c39d$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $ac546328a2948766$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $6e5ac768271f57bc$export$2e2bcd8739ae039(element) {
    var window = (0, $680cda951cc660bc$export$2e2bcd8739ae039)(element);
    var offsetParent = $6e5ac768271f57bc$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $c6f42873e503164d$export$2e2bcd8739ae039)(offsetParent) && (0, $ac546328a2948766$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $6e5ac768271f57bc$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $6c7ca167d1d5c39d$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $6c7ca167d1d5c39d$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $ac546328a2948766$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $6e5ac768271f57bc$var$getContainingBlock(element) || window;
}


function $970cf293f9df027a$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $c9e3301473df22b5$export$f28d906d67a997f3(min, value, max) {
    return (0, $3a3207884994be75$export$8960430cfd85939f)(min, (0, $3a3207884994be75$export$96ec731ed4dcb222)(value, max));
}
function $c9e3301473df22b5$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $c9e3301473df22b5$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $effa0f9252b5a3d7$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $187f466242a79629$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $effa0f9252b5a3d7$export$2e2bcd8739ae039)(), paddingObject);
}


function $0522e2269b8d4a43$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


var $a92a4cb9dbfa10a1$export$1e95b668f3b82d = "top";
var $a92a4cb9dbfa10a1$export$40e543e69a8b3fbb = "bottom";
var $a92a4cb9dbfa10a1$export$79ffe56a765070d2 = "right";
var $a92a4cb9dbfa10a1$export$eabcd2c8791e7bf4 = "left";
var $a92a4cb9dbfa10a1$export$dfb5619354ba860 = "auto";
var $a92a4cb9dbfa10a1$export$aec2ce47c367b8c3 = [
    $a92a4cb9dbfa10a1$export$1e95b668f3b82d,
    $a92a4cb9dbfa10a1$export$40e543e69a8b3fbb,
    $a92a4cb9dbfa10a1$export$79ffe56a765070d2,
    $a92a4cb9dbfa10a1$export$eabcd2c8791e7bf4
];
var $a92a4cb9dbfa10a1$export$b3571188c770cc5a = "start";
var $a92a4cb9dbfa10a1$export$bd5df0f255a350f8 = "end";
var $a92a4cb9dbfa10a1$export$390fd549c5303b4d = "clippingParents";
var $a92a4cb9dbfa10a1$export$d7b7311ec04a3e8f = "viewport";
var $a92a4cb9dbfa10a1$export$ae5ab1c730825774 = "popper";
var $a92a4cb9dbfa10a1$export$ca50aac9f3ba507f = "reference";
var $a92a4cb9dbfa10a1$export$368f9a87e87fa4e1 = /*#__PURE__*/ $a92a4cb9dbfa10a1$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $a92a4cb9dbfa10a1$export$b3571188c770cc5a,
        placement + "-" + $a92a4cb9dbfa10a1$export$bd5df0f255a350f8
    ]);
}, []);
var $a92a4cb9dbfa10a1$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($a92a4cb9dbfa10a1$export$aec2ce47c367b8c3, [
    $a92a4cb9dbfa10a1$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $a92a4cb9dbfa10a1$export$b3571188c770cc5a,
        placement + "-" + $a92a4cb9dbfa10a1$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $a92a4cb9dbfa10a1$export$421679a7c3d56e = "beforeRead";
var $a92a4cb9dbfa10a1$export$aafa59e2e03f2942 = "read";
var $a92a4cb9dbfa10a1$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $a92a4cb9dbfa10a1$export$c65e99957a05207c = "beforeMain";
var $a92a4cb9dbfa10a1$export$f22da7240b7add18 = "main";
var $a92a4cb9dbfa10a1$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $a92a4cb9dbfa10a1$export$8d4d2d70e7d46032 = "beforeWrite";
var $a92a4cb9dbfa10a1$export$68d8715fc104d294 = "write";
var $a92a4cb9dbfa10a1$export$70a6e5159acce2e6 = "afterWrite";
var $a92a4cb9dbfa10a1$export$d087d3878fdf71d5 = [
    $a92a4cb9dbfa10a1$export$421679a7c3d56e,
    $a92a4cb9dbfa10a1$export$aafa59e2e03f2942,
    $a92a4cb9dbfa10a1$export$6964f6c886723980,
    $a92a4cb9dbfa10a1$export$c65e99957a05207c,
    $a92a4cb9dbfa10a1$export$f22da7240b7add18,
    $a92a4cb9dbfa10a1$export$bab79516f2d662fe,
    $a92a4cb9dbfa10a1$export$8d4d2d70e7d46032,
    $a92a4cb9dbfa10a1$export$68d8715fc104d294,
    $a92a4cb9dbfa10a1$export$70a6e5159acce2e6
];


var $b6337715b38d9085$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $187f466242a79629$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $0522e2269b8d4a43$export$2e2bcd8739ae039)(padding, (0, $a92a4cb9dbfa10a1$export$aec2ce47c367b8c3)));
};
function $b6337715b38d9085$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $092f29fbb30c478d$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $970cf293f9df027a$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $a92a4cb9dbfa10a1$export$eabcd2c8791e7bf4),
        (0, $a92a4cb9dbfa10a1$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $b6337715b38d9085$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $b2894a9909fee0ac$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $a92a4cb9dbfa10a1$export$1e95b668f3b82d) : (0, $a92a4cb9dbfa10a1$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $a92a4cb9dbfa10a1$export$40e543e69a8b3fbb) : (0, $a92a4cb9dbfa10a1$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $6e5ac768271f57bc$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $c9e3301473df22b5$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $b6337715b38d9085$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $83fd88a53251902b$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $b6337715b38d9085$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $b6337715b38d9085$var$arrow,
    effect: $b6337715b38d9085$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};








function $e852f6a20205c1ce$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}



var $c870389f1deac918$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $c870389f1deac918$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $3a3207884994be75$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $3a3207884994be75$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $c870389f1deac918$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $a92a4cb9dbfa10a1$export$eabcd2c8791e7bf4);
    var sideY = (0, $a92a4cb9dbfa10a1$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $6e5ac768271f57bc$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $680cda951cc660bc$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $60de3c72b5fe89e5$export$2e2bcd8739ae039)(popper);
            if ((0, $ac546328a2948766$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $a92a4cb9dbfa10a1$export$1e95b668f3b82d) || (placement === (0, $a92a4cb9dbfa10a1$export$eabcd2c8791e7bf4) || placement === (0, $a92a4cb9dbfa10a1$export$79ffe56a765070d2)) && variation === (0, $a92a4cb9dbfa10a1$export$bd5df0f255a350f8)) {
            sideY = (0, $a92a4cb9dbfa10a1$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $a92a4cb9dbfa10a1$export$eabcd2c8791e7bf4) || (placement === (0, $a92a4cb9dbfa10a1$export$1e95b668f3b82d) || placement === (0, $a92a4cb9dbfa10a1$export$40e543e69a8b3fbb)) && variation === (0, $a92a4cb9dbfa10a1$export$bd5df0f255a350f8)) {
            sideX = (0, $a92a4cb9dbfa10a1$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $c870389f1deac918$var$unsetSides);
    var _ref4 = roundOffsets === true ? $c870389f1deac918$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $680cda951cc660bc$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $c870389f1deac918$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $092f29fbb30c478d$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $e852f6a20205c1ce$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $c870389f1deac918$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $c870389f1deac918$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $c870389f1deac918$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $c870389f1deac918$var$computeStyles,
    data: {}
};



var $10a0de36145f49a9$var$passive = {
    passive: true
};
function $10a0de36145f49a9$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $680cda951cc660bc$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $10a0de36145f49a9$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $10a0de36145f49a9$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $10a0de36145f49a9$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $10a0de36145f49a9$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $10a0de36145f49a9$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $10a0de36145f49a9$var$effect,
    data: {}
};


var $6d8c73a1b46a9b24$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $6d8c73a1b46a9b24$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $6d8c73a1b46a9b24$var$hash[matched];
    });
}



var $f5ab67101b5d459e$var$hash = {
    start: "end",
    end: "start"
};
function $f5ab67101b5d459e$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $f5ab67101b5d459e$var$hash[matched];
    });
}








function $f2a509610c26c201$export$2e2bcd8739ae039(node) {
    var win = (0, $680cda951cc660bc$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $e89bf69abcee2f5b$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $4e0071e6daf7da37$export$2e2bcd8739ae039)((0, $60de3c72b5fe89e5$export$2e2bcd8739ae039)(element)).left + (0, $f2a509610c26c201$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $c54f43fb6118314a$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $680cda951cc660bc$export$2e2bcd8739ae039)(element);
    var html = (0, $60de3c72b5fe89e5$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $7dfa0e76e710c36d$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $e89bf69abcee2f5b$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $4929604558ef0f5f$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $60de3c72b5fe89e5$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $f2a509610c26c201$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $3a3207884994be75$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $3a3207884994be75$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $e89bf69abcee2f5b$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $ac546328a2948766$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $3a3207884994be75$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $80b4088260530b35$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $ac546328a2948766$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $76f05b26acfe1b59$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $6c7ca167d1d5c39d$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $01cb709cd5370de9$export$1b3bfaa9684536aa)(node) && (0, $80b4088260530b35$export$2e2bcd8739ae039)(node)) return node;
    return $76f05b26acfe1b59$export$2e2bcd8739ae039((0, $20dcc294d1d30f92$export$2e2bcd8739ae039)(node));
}





function $51f5be067af69cfc$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $76f05b26acfe1b59$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $680cda951cc660bc$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $80b4088260530b35$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($51f5be067af69cfc$export$2e2bcd8739ae039((0, $20dcc294d1d30f92$export$2e2bcd8739ae039)(target)));
}










function $c55422be3a4eb679$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $298c93a8ce7014c1$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $4e0071e6daf7da37$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $298c93a8ce7014c1$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $a92a4cb9dbfa10a1$export$d7b7311ec04a3e8f) ? (0, $c55422be3a4eb679$export$2e2bcd8739ae039)((0, $c54f43fb6118314a$export$2e2bcd8739ae039)(element, strategy)) : (0, $01cb709cd5370de9$export$45a5e7f76e0caa8d)(clippingParent) ? $298c93a8ce7014c1$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $c55422be3a4eb679$export$2e2bcd8739ae039)((0, $4929604558ef0f5f$export$2e2bcd8739ae039)((0, $60de3c72b5fe89e5$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $298c93a8ce7014c1$var$getClippingParents(element) {
    var clippingParents = (0, $51f5be067af69cfc$export$2e2bcd8739ae039)((0, $20dcc294d1d30f92$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $ac546328a2948766$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $01cb709cd5370de9$export$1b3bfaa9684536aa)(element) ? (0, $6e5ac768271f57bc$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $01cb709cd5370de9$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $01cb709cd5370de9$export$45a5e7f76e0caa8d)(clippingParent) && (0, $83fd88a53251902b$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $6c7ca167d1d5c39d$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $298c93a8ce7014c1$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $298c93a8ce7014c1$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $298c93a8ce7014c1$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $3a3207884994be75$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $3a3207884994be75$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $3a3207884994be75$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3a3207884994be75$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $298c93a8ce7014c1$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $b3e9616faa7319e5$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $092f29fbb30c478d$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $e852f6a20205c1ce$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $a92a4cb9dbfa10a1$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $a92a4cb9dbfa10a1$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $a92a4cb9dbfa10a1$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $a92a4cb9dbfa10a1$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $970cf293f9df027a$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $a92a4cb9dbfa10a1$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $a92a4cb9dbfa10a1$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $2849a2a818583889$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $a92a4cb9dbfa10a1$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $a92a4cb9dbfa10a1$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $a92a4cb9dbfa10a1$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $187f466242a79629$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $0522e2269b8d4a43$export$2e2bcd8739ae039)(padding, (0, $a92a4cb9dbfa10a1$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $a92a4cb9dbfa10a1$export$ae5ab1c730825774) ? (0, $a92a4cb9dbfa10a1$export$ca50aac9f3ba507f) : (0, $a92a4cb9dbfa10a1$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $298c93a8ce7014c1$export$2e2bcd8739ae039)((0, $01cb709cd5370de9$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $60de3c72b5fe89e5$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $4e0071e6daf7da37$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $b3e9616faa7319e5$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $c55422be3a4eb679$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $a92a4cb9dbfa10a1$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $a92a4cb9dbfa10a1$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $a92a4cb9dbfa10a1$export$79ffe56a765070d2),
                (0, $a92a4cb9dbfa10a1$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $a92a4cb9dbfa10a1$export$1e95b668f3b82d),
                (0, $a92a4cb9dbfa10a1$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $d278a4f18d95ade3$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $a92a4cb9dbfa10a1$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $e852f6a20205c1ce$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $a92a4cb9dbfa10a1$export$368f9a87e87fa4e1) : (0, $a92a4cb9dbfa10a1$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $e852f6a20205c1ce$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $a92a4cb9dbfa10a1$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $2849a2a818583889$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $092f29fbb30c478d$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $f3963aea6fcb308c$var$getExpandedFallbackPlacements(placement) {
    if ((0, $092f29fbb30c478d$export$2e2bcd8739ae039)(placement) === (0, $a92a4cb9dbfa10a1$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $6d8c73a1b46a9b24$export$2e2bcd8739ae039)(placement);
    return [
        (0, $f5ab67101b5d459e$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $f5ab67101b5d459e$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $f3963aea6fcb308c$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $092f29fbb30c478d$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $6d8c73a1b46a9b24$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $f3963aea6fcb308c$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $092f29fbb30c478d$export$2e2bcd8739ae039)(placement) === (0, $a92a4cb9dbfa10a1$export$dfb5619354ba860) ? (0, $d278a4f18d95ade3$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $092f29fbb30c478d$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $e852f6a20205c1ce$export$2e2bcd8739ae039)(placement) === (0, $a92a4cb9dbfa10a1$export$b3571188c770cc5a);
        var isVertical = [
            (0, $a92a4cb9dbfa10a1$export$1e95b668f3b82d),
            (0, $a92a4cb9dbfa10a1$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $2849a2a818583889$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $a92a4cb9dbfa10a1$export$79ffe56a765070d2) : (0, $a92a4cb9dbfa10a1$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $a92a4cb9dbfa10a1$export$40e543e69a8b3fbb) : (0, $a92a4cb9dbfa10a1$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $6d8c73a1b46a9b24$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $6d8c73a1b46a9b24$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $f3963aea6fcb308c$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $f3963aea6fcb308c$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};




function $9cc77d60c440153c$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $9cc77d60c440153c$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $a92a4cb9dbfa10a1$export$1e95b668f3b82d),
        (0, $a92a4cb9dbfa10a1$export$79ffe56a765070d2),
        (0, $a92a4cb9dbfa10a1$export$40e543e69a8b3fbb),
        (0, $a92a4cb9dbfa10a1$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $9cc77d60c440153c$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $2849a2a818583889$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $2849a2a818583889$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $9cc77d60c440153c$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $9cc77d60c440153c$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $9cc77d60c440153c$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $9cc77d60c440153c$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $9cc77d60c440153c$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $9cc77d60c440153c$var$hide
};




function $c07e6304e1959da3$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $092f29fbb30c478d$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $a92a4cb9dbfa10a1$export$eabcd2c8791e7bf4),
        (0, $a92a4cb9dbfa10a1$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $a92a4cb9dbfa10a1$export$eabcd2c8791e7bf4),
        (0, $a92a4cb9dbfa10a1$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $c07e6304e1959da3$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $a92a4cb9dbfa10a1$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $c07e6304e1959da3$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $c07e6304e1959da3$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $c07e6304e1959da3$var$offset
};



function $5f6bb4712d3020e9$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $b3e9616faa7319e5$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $5f6bb4712d3020e9$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $5f6bb4712d3020e9$var$popperOffsets,
    data: {}
};





function $b36da0ee7d631c78$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}









function $01a3d81a6be66fb9$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $2849a2a818583889$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $092f29fbb30c478d$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $e852f6a20205c1ce$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $970cf293f9df027a$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $b36da0ee7d631c78$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $a92a4cb9dbfa10a1$export$1e95b668f3b82d) : (0, $a92a4cb9dbfa10a1$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $a92a4cb9dbfa10a1$export$40e543e69a8b3fbb) : (0, $a92a4cb9dbfa10a1$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $a92a4cb9dbfa10a1$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $a92a4cb9dbfa10a1$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $b2894a9909fee0ac$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $effa0f9252b5a3d7$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $c9e3301473df22b5$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $6e5ac768271f57bc$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $c9e3301473df22b5$export$f28d906d67a997f3)(tether ? (0, $3a3207884994be75$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $3a3207884994be75$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $a92a4cb9dbfa10a1$export$1e95b668f3b82d) : (0, $a92a4cb9dbfa10a1$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $a92a4cb9dbfa10a1$export$40e543e69a8b3fbb) : (0, $a92a4cb9dbfa10a1$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $a92a4cb9dbfa10a1$export$1e95b668f3b82d),
            (0, $a92a4cb9dbfa10a1$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $c9e3301473df22b5$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $c9e3301473df22b5$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $01a3d81a6be66fb9$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $01a3d81a6be66fb9$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};







function $851b80b84148ded3$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $44003b329810688a$export$2e2bcd8739ae039(node) {
    if (node === (0, $680cda951cc660bc$export$2e2bcd8739ae039)(node) || !(0, $01cb709cd5370de9$export$1b3bfaa9684536aa)(node)) return (0, $f2a509610c26c201$export$2e2bcd8739ae039)(node);
    else return (0, $851b80b84148ded3$export$2e2bcd8739ae039)(node);
}








function $32de2650fb0db184$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $3a3207884994be75$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $3a3207884994be75$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $32de2650fb0db184$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $01cb709cd5370de9$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $01cb709cd5370de9$export$1b3bfaa9684536aa)(offsetParent) && $32de2650fb0db184$var$isElementScaled(offsetParent);
    var documentElement = (0, $60de3c72b5fe89e5$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $4e0071e6daf7da37$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $6c7ca167d1d5c39d$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $80b4088260530b35$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $44003b329810688a$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $01cb709cd5370de9$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $4e0071e6daf7da37$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $e89bf69abcee2f5b$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $38ed97ad88fcd214$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $38ed97ad88fcd214$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $38ed97ad88fcd214$var$order(modifiers); // order based on phase
    return (0, $a92a4cb9dbfa10a1$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $0d7ccab0b96d94e4$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $726f93e228fa9e44$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $4de238329baeea09$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $4de238329baeea09$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $4de238329baeea09$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $4de238329baeea09$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $4de238329baeea09$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $01cb709cd5370de9$export$45a5e7f76e0caa8d)(reference) ? (0, $51f5be067af69cfc$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $51f5be067af69cfc$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $51f5be067af69cfc$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $38ed97ad88fcd214$export$2e2bcd8739ae039)((0, $726f93e228fa9e44$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$4de238329baeea09$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $32de2650fb0db184$export$2e2bcd8739ae039)(reference, (0, $6e5ac768271f57bc$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $b2894a9909fee0ac$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $0d7ccab0b96d94e4$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$4de238329baeea09$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $4de238329baeea09$export$8f7491d57c8f97a9 = /*#__PURE__*/ $4de238329baeea09$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules


const $6ae6833419a578a8$export$8f7491d57c8f97a9 = (0, $4de238329baeea09$export$ed5e13716264f202)({
    defaultModifiers: [
        (0, $9cc77d60c440153c$export$2e2bcd8739ae039),
        (0, $5f6bb4712d3020e9$export$2e2bcd8739ae039),
        (0, $c870389f1deac918$export$2e2bcd8739ae039),
        (0, $10a0de36145f49a9$export$2e2bcd8739ae039),
        (0, $c07e6304e1959da3$export$2e2bcd8739ae039),
        (0, $f3963aea6fcb308c$export$2e2bcd8739ae039),
        (0, $01a3d81a6be66fb9$export$2e2bcd8739ae039),
        (0, $b6337715b38d9085$export$2e2bcd8739ae039)
    ]
});


const $80acecdcbaa1190f$var$_excluded = [
    "enabled",
    "placement",
    "strategy",
    "modifiers"
];
function $80acecdcbaa1190f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $80acecdcbaa1190f$var$disabledApplyStylesModifier = {
    name: "applyStyles",
    enabled: false,
    phase: "afterWrite",
    fn: ()=>undefined
};
// until docjs supports type exports...
const $80acecdcbaa1190f$var$ariaDescribedByModifier = {
    name: "ariaDescribedBy",
    enabled: true,
    phase: "afterWrite",
    effect: ({ state: state })=>()=>{
            const { reference: reference, popper: popper } = state.elements;
            if ("removeAttribute" in reference) {
                const ids = (reference.getAttribute("aria-describedby") || "").split(",").filter((id)=>id.trim() !== popper.id);
                if (!ids.length) reference.removeAttribute("aria-describedby");
                else reference.setAttribute("aria-describedby", ids.join(","));
            }
        },
    fn: ({ state: state })=>{
        var _popper$getAttribute;
        const { popper: popper, reference: reference } = state.elements;
        const role = (_popper$getAttribute = popper.getAttribute("role")) == null ? void 0 : _popper$getAttribute.toLowerCase();
        if (popper.id && role === "tooltip" && "setAttribute" in reference) {
            const ids = reference.getAttribute("aria-describedby");
            if (ids && ids.split(",").indexOf(popper.id) !== -1) return;
            reference.setAttribute("aria-describedby", ids ? `${ids},${popper.id}` : popper.id);
        }
    }
};
const $80acecdcbaa1190f$var$EMPTY_MODIFIERS = [];
/**
 * Position an element relative some reference element using Popper.js
 *
 * @param referenceElement
 * @param popperElement
 * @param {object}      options
 * @param {object=}     options.modifiers Popper.js modifiers
 * @param {boolean=}    options.enabled toggle the popper functionality on/off
 * @param {string=}     options.placement The popper element placement relative to the reference element
 * @param {string=}     options.strategy the positioning strategy
 * @param {function=}   options.onCreate called when the popper is created
 * @param {function=}   options.onUpdate called when the popper is updated
 *
 * @returns {UsePopperState} The popper state
 */ function $80acecdcbaa1190f$var$usePopper(referenceElement, popperElement, _ref = {}) {
    let { enabled: enabled = true, placement: placement = "bottom", strategy: strategy = "absolute", modifiers: modifiers = $80acecdcbaa1190f$var$EMPTY_MODIFIERS } = _ref, config = $80acecdcbaa1190f$var$_objectWithoutPropertiesLoose(_ref, $80acecdcbaa1190f$var$_excluded);
    const prevModifiers = (0, $6cds3.useRef)(modifiers);
    const popperInstanceRef = (0, $6cds3.useRef)();
    const update = (0, $6cds3.useCallback)(()=>{
        var _popperInstanceRef$cu;
        (_popperInstanceRef$cu = popperInstanceRef.current) == null || _popperInstanceRef$cu.update();
    }, []);
    const forceUpdate = (0, $6cds3.useCallback)(()=>{
        var _popperInstanceRef$cu2;
        (_popperInstanceRef$cu2 = popperInstanceRef.current) == null || _popperInstanceRef$cu2.forceUpdate();
    }, []);
    const [popperState, setState] = (0, $dbcefa4139b16bdd$export$2e2bcd8739ae039)((0, $6cds3.useState)({
        placement: placement,
        update: update,
        forceUpdate: forceUpdate,
        attributes: {},
        styles: {
            popper: {},
            arrow: {}
        }
    }));
    const updateModifier = (0, $6cds3.useMemo)(()=>({
            name: "updateStateModifier",
            enabled: true,
            phase: "write",
            requires: [
                "computeStyles"
            ],
            fn: ({ state: state })=>{
                const styles = {};
                const attributes = {};
                Object.keys(state.elements).forEach((element)=>{
                    styles[element] = state.styles[element];
                    attributes[element] = state.attributes[element];
                });
                setState({
                    state: state,
                    styles: styles,
                    attributes: attributes,
                    update: update,
                    forceUpdate: forceUpdate,
                    placement: state.placement
                });
            }
        }), [
        update,
        forceUpdate,
        setState
    ]);
    const nextModifiers = (0, $6cds3.useMemo)(()=>{
        if (!(0, $5a6576f79ab32dab$export$de8294bb3be0322f)(prevModifiers.current, modifiers)) prevModifiers.current = modifiers;
        return prevModifiers.current;
    }, [
        modifiers
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (!popperInstanceRef.current || !enabled) return;
        popperInstanceRef.current.setOptions({
            placement: placement,
            strategy: strategy,
            modifiers: [
                ...nextModifiers,
                updateModifier,
                $80acecdcbaa1190f$var$disabledApplyStylesModifier
            ]
        });
    }, [
        strategy,
        placement,
        updateModifier,
        enabled,
        nextModifiers
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (!enabled || referenceElement == null || popperElement == null) return undefined;
        popperInstanceRef.current = (0, $6ae6833419a578a8$export$8f7491d57c8f97a9)(referenceElement, popperElement, Object.assign({}, config, {
            placement: placement,
            strategy: strategy,
            modifiers: [
                ...nextModifiers,
                $80acecdcbaa1190f$var$ariaDescribedByModifier,
                updateModifier
            ]
        }));
        return ()=>{
            if (popperInstanceRef.current != null) {
                popperInstanceRef.current.destroy();
                popperInstanceRef.current = undefined;
                setState((s)=>Object.assign({}, s, {
                        attributes: {},
                        styles: {
                            popper: {}
                        }
                    }));
            }
        };
    // This is only run once to _create_ the popper
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        enabled,
        referenceElement,
        popperElement
    ]);
    return popperState;
}
var $80acecdcbaa1190f$export$2e2bcd8739ae039 = $80acecdcbaa1190f$var$usePopper;





var $6cds3 = parcelRequire("6cds3");





var $6cds3 = parcelRequire("6cds3");


const $50719ea8fa0478c2$var$noop = ()=>{};
function $50719ea8fa0478c2$var$isLeftClickEvent(event) {
    return event.button === 0;
}
function $50719ea8fa0478c2$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
const $50719ea8fa0478c2$export$347601c75fcd4732 = (ref)=>ref && ("current" in ref ? ref.current : ref);
const $50719ea8fa0478c2$var$InitialTriggerEvents = {
    click: "mousedown",
    mouseup: "mousedown",
    pointerup: "pointerdown"
};
/**
 * The `useClickOutside` hook registers your callback on the document that fires
 * when a pointer event is registered outside of the provided ref or element.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onClickOutside
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $50719ea8fa0478c2$var$useClickOutside(ref, onClickOutside = $50719ea8fa0478c2$var$noop, { disabled: disabled, clickTrigger: clickTrigger = "click" } = {}) {
    const preventMouseClickOutsideRef = (0, $6cds3.useRef)(false);
    const waitingForTrigger = (0, $6cds3.useRef)(false);
    const handleMouseCapture = (0, $6cds3.useCallback)((e)=>{
        const currentTarget = $50719ea8fa0478c2$export$347601c75fcd4732(ref);
        (0, (/*@__PURE__*/$parcel$interopDefault($00abd41c79c40b14$exports)))(!!currentTarget, "ClickOutside captured a close event but does not have a ref to compare it to. useClickOutside(), should be passed a ref that resolves to a DOM node");
        preventMouseClickOutsideRef.current = !currentTarget || $50719ea8fa0478c2$var$isModifiedEvent(e) || !$50719ea8fa0478c2$var$isLeftClickEvent(e) || !!(0, $bcd2f9d8e6f19108$export$2e2bcd8739ae039)(currentTarget, e.target) || waitingForTrigger.current;
        waitingForTrigger.current = false;
    }, [
        ref
    ]);
    const handleInitialMouse = (0, $cfbeaaf7204fcb02$export$2e2bcd8739ae039)((e)=>{
        const currentTarget = $50719ea8fa0478c2$export$347601c75fcd4732(ref);
        if (currentTarget && (0, $bcd2f9d8e6f19108$export$2e2bcd8739ae039)(currentTarget, e.target)) waitingForTrigger.current = true;
    });
    const handleMouse = (0, $cfbeaaf7204fcb02$export$2e2bcd8739ae039)((e)=>{
        if (!preventMouseClickOutsideRef.current) onClickOutside(e);
    });
    (0, $6cds3.useEffect)(()=>{
        var _ownerWindow$event, _ownerWindow$parent;
        if (disabled || ref == null) return undefined;
        const doc = (0, $f52efbbd31c95236$export$2e2bcd8739ae039)($50719ea8fa0478c2$export$347601c75fcd4732(ref));
        const ownerWindow = doc.defaultView || window;
        // Store the current event to avoid triggering handlers immediately
        // For things rendered in an iframe, the event might originate on the parent window
        // so we should fall back to that global event if the local one doesn't exist
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (_ownerWindow$event = ownerWindow.event) != null ? _ownerWindow$event : (_ownerWindow$parent = ownerWindow.parent) == null ? void 0 : _ownerWindow$parent.event;
        let removeInitialTriggerListener = null;
        if ($50719ea8fa0478c2$var$InitialTriggerEvents[clickTrigger]) removeInitialTriggerListener = (0, $4ca9d7ffc3c5ea9f$export$2e2bcd8739ae039)(doc, $50719ea8fa0478c2$var$InitialTriggerEvents[clickTrigger], handleInitialMouse, true);
        // Use capture for this listener so it fires before React's listener, to
        // avoid false positives in the contains() check below if the target DOM
        // element is removed in the React mouse callback.
        const removeMouseCaptureListener = (0, $4ca9d7ffc3c5ea9f$export$2e2bcd8739ae039)(doc, clickTrigger, handleMouseCapture, true);
        const removeMouseListener = (0, $4ca9d7ffc3c5ea9f$export$2e2bcd8739ae039)(doc, clickTrigger, (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleMouse(e);
        });
        let mobileSafariHackListeners = [];
        if ("ontouchstart" in doc.documentElement) mobileSafariHackListeners = [].slice.call(doc.body.children).map((el)=>(0, $4ca9d7ffc3c5ea9f$export$2e2bcd8739ae039)(el, "mousemove", $50719ea8fa0478c2$var$noop));
        return ()=>{
            removeInitialTriggerListener == null || removeInitialTriggerListener();
            removeMouseCaptureListener();
            removeMouseListener();
            mobileSafariHackListeners.forEach((remove)=>remove());
        };
    }, [
        ref,
        disabled,
        clickTrigger,
        handleMouseCapture,
        handleInitialMouse,
        handleMouse
    ]);
}
var $50719ea8fa0478c2$export$2e2bcd8739ae039 = $50719ea8fa0478c2$var$useClickOutside;



const $a0094ea225c70cc0$var$noop = ()=>{};
/**
 * The `useRootClose` hook registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onRootClose
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $a0094ea225c70cc0$var$useRootClose(ref, onRootClose, { disabled: disabled, clickTrigger: clickTrigger } = {}) {
    const onClose = onRootClose || $a0094ea225c70cc0$var$noop;
    (0, $50719ea8fa0478c2$export$2e2bcd8739ae039)(ref, onClose, {
        disabled: disabled,
        clickTrigger: clickTrigger
    });
    const handleKeyUp = (0, $cfbeaaf7204fcb02$export$2e2bcd8739ae039)((e)=>{
        if ((0, $3baa31eadc645da2$export$806fcc22e55e107d)(e)) onClose(e);
    });
    (0, $6cds3.useEffect)(()=>{
        if (disabled || ref == null) return undefined;
        const doc = (0, $f52efbbd31c95236$export$2e2bcd8739ae039)((0, $50719ea8fa0478c2$export$347601c75fcd4732)(ref));
        // Store the current event to avoid triggering handlers immediately
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (doc.defaultView || window).event;
        const removeKeyupListener = (0, $4ca9d7ffc3c5ea9f$export$2e2bcd8739ae039)(doc, "keyup", (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleKeyUp(e);
        });
        return ()=>{
            removeKeyupListener();
        };
    }, [
        ref,
        disabled,
        handleKeyUp
    ]);
}
var $a0094ea225c70cc0$export$2e2bcd8739ae039 = $a0094ea225c70cc0$var$useRootClose;



function $e7278278b40c06c3$export$ba6dad097c8f5c38(modifiers) {
    const result = {};
    if (!Array.isArray(modifiers)) return modifiers || result;
    // eslint-disable-next-line no-unused-expressions
    modifiers == null || modifiers.forEach((m)=>{
        result[m.name] = m;
    });
    return result;
}
function $e7278278b40c06c3$export$af3a999d4a134c86(map = {}) {
    if (Array.isArray(map)) return map;
    return Object.keys(map).map((k)=>{
        map[k].name = k;
        return map[k];
    });
}
function $e7278278b40c06c3$export$2e2bcd8739ae039({ enabled: enabled, enableEvents: enableEvents, placement: placement, flip: flip, offset: offset, fixed: fixed, containerPadding: containerPadding, arrowElement: arrowElement, popperConfig: popperConfig = {} }) {
    var _modifiers$eventListe, _modifiers$preventOve, _modifiers$preventOve2, _modifiers$offset, _modifiers$arrow;
    const modifiers = $e7278278b40c06c3$export$ba6dad097c8f5c38(popperConfig.modifiers);
    return Object.assign({}, popperConfig, {
        placement: placement,
        enabled: enabled,
        strategy: fixed ? "fixed" : popperConfig.strategy,
        modifiers: $e7278278b40c06c3$export$af3a999d4a134c86(Object.assign({}, modifiers, {
            eventListeners: {
                enabled: enableEvents,
                options: (_modifiers$eventListe = modifiers.eventListeners) == null ? void 0 : _modifiers$eventListe.options
            },
            preventOverflow: Object.assign({}, modifiers.preventOverflow, {
                options: containerPadding ? Object.assign({
                    padding: containerPadding
                }, (_modifiers$preventOve = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve.options) : (_modifiers$preventOve2 = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve2.options
            }),
            offset: {
                options: Object.assign({
                    offset: offset
                }, (_modifiers$offset = modifiers.offset) == null ? void 0 : _modifiers$offset.options)
            },
            arrow: Object.assign({}, modifiers.arrow, {
                enabled: !!arrowElement,
                options: Object.assign({}, (_modifiers$arrow = modifiers.arrow) == null ? void 0 : _modifiers$arrow.options, {
                    element: arrowElement
                })
            }),
            flip: Object.assign({
                enabled: !!flip
            }, modifiers.flip)
        }))
    });
}



/**
 * Built on top of `Popper.js`, the overlay component is
 * great for custom tooltip overlays.
 */ const $517e7436ccbae920$var$Overlay = /*#__PURE__*/ $6cds3.forwardRef((props, outerRef)=>{
    const { flip: flip, offset: offset, placement: placement, containerPadding: containerPadding, popperConfig: popperConfig = {}, transition: Transition, runTransition: runTransition } = props;
    const [rootElement, attachRef] = (0, $6c24397ccd0ea65a$export$2e2bcd8739ae039)();
    const [arrowElement, attachArrowRef] = (0, $6c24397ccd0ea65a$export$2e2bcd8739ae039)();
    const mergedRef = (0, $2921c5d455351cc0$export$2e2bcd8739ae039)(attachRef, outerRef);
    const container = (0, $6436e539995da412$export$2e2bcd8739ae039)(props.container);
    const target = (0, $6436e539995da412$export$2e2bcd8739ae039)(props.target);
    const [exited, setExited] = (0, $6cds3.useState)(!props.show);
    const popper = (0, $80acecdcbaa1190f$export$2e2bcd8739ae039)(target, rootElement, (0, $e7278278b40c06c3$export$2e2bcd8739ae039)({
        placement: placement,
        enableEvents: !!props.show,
        containerPadding: containerPadding || 5,
        flip: flip,
        offset: offset,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    }));
    // TODO: I think this needs to be in an effect
    if (props.show && exited) setExited(false);
    const handleHidden = (...args)=>{
        setExited(true);
        if (props.onExited) props.onExited(...args);
    };
    // Don't un-render the overlay while it's transitioning out.
    const mountOverlay = props.show || !exited;
    (0, $a0094ea225c70cc0$export$2e2bcd8739ae039)(rootElement, props.onHide, {
        disabled: !props.rootClose || props.rootCloseDisabled,
        clickTrigger: props.rootCloseEvent
    });
    if (!mountOverlay) // Don't bother showing anything if we don't have to.
    return null;
    const { onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered } = props;
    let child = props.children(Object.assign({}, popper.attributes.popper, {
        style: popper.styles.popper,
        ref: mergedRef
    }), {
        popper: popper,
        placement: placement,
        show: !!props.show,
        arrowProps: Object.assign({}, popper.attributes.arrow, {
            style: popper.styles.arrow,
            ref: attachArrowRef
        })
    });
    child = (0, $fd01075742e0e0b6$export$f41d64aae6d6dba5)(Transition, runTransition, {
        in: !!props.show,
        appear: true,
        mountOnEnter: true,
        unmountOnExit: true,
        children: child,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered
    });
    return container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6d4849ee44552f5f$exports))).createPortal(child, container) : null;
});
$517e7436ccbae920$var$Overlay.displayName = "Overlay";
var $517e7436ccbae920$export$2e2bcd8739ae039 = $517e7436ccbae920$var$Overlay;






var $6cds3 = parcelRequire("6cds3");




var $6cds3 = parcelRequire("6cds3");


var $6cds3 = parcelRequire("6cds3");



"use client";
const $dd7a77bc09e76051$var$PopoverHeader = /*#__PURE__*/ $6cds3.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", ...props }, ref)=>{
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "popover-header");
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, bsPrefix),
        ...props
    });
});
$dd7a77bc09e76051$var$PopoverHeader.displayName = "PopoverHeader";
var $dd7a77bc09e76051$export$2e2bcd8739ae039 = $dd7a77bc09e76051$var$PopoverHeader;



var $6cds3 = parcelRequire("6cds3");



"use client";
const $997601f2b19a6114$var$PopoverBody = /*#__PURE__*/ $6cds3.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", ...props }, ref)=>{
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "popover-body");
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, bsPrefix),
        ...props
    });
});
$997601f2b19a6114$var$PopoverBody.displayName = "PopoverBody";
var $997601f2b19a6114$export$2e2bcd8739ae039 = $997601f2b19a6114$var$PopoverBody;



var $6cds3 = parcelRequire("6cds3");
class $68433914638606d9$export$34582a676b91ff07 extends $6cds3.Component {
}
function $68433914638606d9$export$c15856915a9b3464(placement, isRTL) {
    let bsDirection = placement;
    if (placement === "left") bsDirection = isRTL ? "end" : "start";
    else if (placement === "right") bsDirection = isRTL ? "start" : "end";
    return bsDirection;
}


function $0da6115c2832d6b2$export$2e2bcd8739ae039(position = "absolute") {
    return {
        position: position,
        top: "0",
        left: "0",
        opacity: "0",
        pointerEvents: "none"
    };
}



"use client";
const $5f5df6c07f99c0ef$var$Popover = /*#__PURE__*/ $6cds3.forwardRef(({ bsPrefix: bsPrefix, placement: placement = "right", className: className, style: style, children: children, body: body, arrowProps: arrowProps, hasDoneInitialMeasure: hasDoneInitialMeasure, popper: popper, show: show, ...props }, ref)=>{
    const decoratedBsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "popover");
    const isRTL = (0, $c5d3aca6e909caf5$export$35e511eefa30ac5a)();
    const [primaryPlacement] = (placement == null ? void 0 : placement.split("-")) || [];
    const bsDirection = (0, $68433914638606d9$export$c15856915a9b3464)(primaryPlacement, isRTL);
    let computedStyle = style;
    if (show && !hasDoneInitialMeasure) computedStyle = {
        ...style,
        ...(0, $0da6115c2832d6b2$export$2e2bcd8739ae039)(popper == null ? void 0 : popper.strategy)
    };
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        ref: ref,
        role: "tooltip",
        style: computedStyle,
        "x-placement": primaryPlacement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, decoratedBsPrefix, primaryPlacement && `bs-popover-${bsDirection}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: "popover-arrow",
                ...arrowProps
            }),
            body ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $997601f2b19a6114$export$2e2bcd8739ae039), {
                children: children
            }) : children
        ]
    });
});
var $5f5df6c07f99c0ef$export$2e2bcd8739ae039 = Object.assign($5f5df6c07f99c0ef$var$Popover, {
    Header: (0, $dd7a77bc09e76051$export$2e2bcd8739ae039),
    Body: (0, $997601f2b19a6114$export$2e2bcd8739ae039),
    // Default popover offset.
    // https://github.com/twbs/bootstrap/blob/5c32767e0e0dbac2d934bcdee03719a65d3f1187/js/src/popover.js#L28
    POPPER_OFFSET: [
        0,
        8
    ]
});




var $6cds3 = parcelRequire("6cds3");




"use client";
const $75c21e5a46e079cb$var$Tooltip = /*#__PURE__*/ $6cds3.forwardRef(({ bsPrefix: bsPrefix, placement: placement = "right", className: className, style: style, children: children, arrowProps: arrowProps, hasDoneInitialMeasure: hasDoneInitialMeasure, popper: popper, show: show, ...props }, ref)=>{
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "tooltip");
    const isRTL = (0, $c5d3aca6e909caf5$export$35e511eefa30ac5a)();
    const [primaryPlacement] = (placement == null ? void 0 : placement.split("-")) || [];
    const bsDirection = (0, $68433914638606d9$export$c15856915a9b3464)(primaryPlacement, isRTL);
    let computedStyle = style;
    if (show && !hasDoneInitialMeasure) computedStyle = {
        ...style,
        ...(0, $0da6115c2832d6b2$export$2e2bcd8739ae039)(popper == null ? void 0 : popper.strategy)
    };
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        ref: ref,
        style: computedStyle,
        role: "tooltip",
        "x-placement": primaryPlacement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, bsPrefix, `bs-tooltip-${bsDirection}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: "tooltip-arrow",
                ...arrowProps
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: `${bsPrefix}-inner`,
                children: children
            })
        ]
    });
});
$75c21e5a46e079cb$var$Tooltip.displayName = "Tooltip";
var $75c21e5a46e079cb$export$2e2bcd8739ae039 = Object.assign($75c21e5a46e079cb$var$Tooltip, {
    // Default tooltip offset.
    // https://github.com/twbs/bootstrap/blob/beca2a6c7f6bc88b6449339fc76edcda832c59e5/js/src/tooltip.js#L65
    TOOLTIP_OFFSET: [
        0,
        6
    ]
});


"use client";
function $0c824df544add4d0$export$2e2bcd8739ae039(customOffset) {
    const overlayRef = (0, $6cds3.useRef)(null);
    const popoverClass = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(undefined, "popover");
    const tooltipClass = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(undefined, "tooltip");
    const offset = (0, $6cds3.useMemo)(()=>({
            name: "offset",
            options: {
                offset: ()=>{
                    if (customOffset) return customOffset;
                    if (overlayRef.current) {
                        if ((0, $6e92aadc75b4abf4$export$2e2bcd8739ae039)(overlayRef.current, popoverClass)) return (0, $5f5df6c07f99c0ef$export$2e2bcd8739ae039).POPPER_OFFSET;
                        if ((0, $6e92aadc75b4abf4$export$2e2bcd8739ae039)(overlayRef.current, tooltipClass)) return (0, $75c21e5a46e079cb$export$2e2bcd8739ae039).TOOLTIP_OFFSET;
                    }
                    return [
                        0,
                        0
                    ];
                }
            }
        }), [
        customOffset,
        popoverClass,
        tooltipClass
    ]);
    return [
        overlayRef,
        [
            offset
        ]
    ];
}





"use client";
function $1e49270660e3cca2$var$wrapRefs(props, arrowProps) {
    const { ref: ref } = props;
    const { ref: aRef } = arrowProps;
    props.ref = ref.__wrapped || (ref.__wrapped = (r)=>ref((0, $42088736fa8dcd8f$export$2e2bcd8739ae039)(r)));
    arrowProps.ref = aRef.__wrapped || (aRef.__wrapped = (r)=>aRef((0, $42088736fa8dcd8f$export$2e2bcd8739ae039)(r)));
}
const $1e49270660e3cca2$var$Overlay = /*#__PURE__*/ $6cds3.forwardRef(({ children: overlay, transition: transition = (0, $9d1648789ad43db2$export$2e2bcd8739ae039), popperConfig: popperConfig = {}, rootClose: rootClose = false, placement: placement = "top", show: outerShow = false, ...outerProps }, outerRef)=>{
    const popperRef = (0, $6cds3.useRef)({});
    const [firstRenderedState, setFirstRenderedState] = (0, $6cds3.useState)(null);
    const [ref, modifiers] = (0, $0c824df544add4d0$export$2e2bcd8739ae039)(outerProps.offset);
    const mergedRef = (0, $2921c5d455351cc0$export$2e2bcd8739ae039)(outerRef, ref);
    const actualTransition = transition === true ? (0, $9d1648789ad43db2$export$2e2bcd8739ae039) : transition || undefined;
    const handleFirstUpdate = (0, $cfbeaaf7204fcb02$export$2e2bcd8739ae039)((state)=>{
        setFirstRenderedState(state);
        popperConfig == null || popperConfig.onFirstUpdate == null || popperConfig.onFirstUpdate(state);
    });
    (0, $ac9facc4976791bd$export$2e2bcd8739ae039)(()=>{
        if (firstRenderedState && outerProps.target) // Must wait for target element to resolve before updating popper.
        popperRef.current.scheduleUpdate == null || popperRef.current.scheduleUpdate();
    }, [
        firstRenderedState,
        outerProps.target
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (!outerShow) setFirstRenderedState(null);
    }, [
        outerShow
    ]);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $517e7436ccbae920$export$2e2bcd8739ae039), {
        ...outerProps,
        ref: mergedRef,
        popperConfig: {
            ...popperConfig,
            modifiers: modifiers.concat(popperConfig.modifiers || []),
            onFirstUpdate: handleFirstUpdate
        },
        transition: actualTransition,
        rootClose: rootClose,
        placement: placement,
        show: outerShow,
        children: (overlayProps, { arrowProps: arrowProps, popper: popperObj, show: show })=>{
            var _popperObj$state, _popperObj$state$modi;
            $1e49270660e3cca2$var$wrapRefs(overlayProps, arrowProps);
            // Need to get placement from popper object, handling case when overlay is flipped using 'flip' prop
            const updatedPlacement = popperObj == null ? void 0 : popperObj.placement;
            const popper = Object.assign(popperRef.current, {
                state: popperObj == null ? void 0 : popperObj.state,
                scheduleUpdate: popperObj == null ? void 0 : popperObj.update,
                placement: updatedPlacement,
                outOfBoundaries: (popperObj == null ? void 0 : (_popperObj$state = popperObj.state) == null ? void 0 : (_popperObj$state$modi = _popperObj$state.modifiersData.hide) == null ? void 0 : _popperObj$state$modi.isReferenceHidden) || false,
                strategy: popperConfig.strategy
            });
            const hasDoneInitialMeasure = !!firstRenderedState;
            if (typeof overlay === "function") return overlay({
                ...overlayProps,
                placement: updatedPlacement,
                show: show,
                ...!transition && show && {
                    className: "show"
                },
                popper: popper,
                arrowProps: arrowProps,
                hasDoneInitialMeasure: hasDoneInitialMeasure
            });
            return /*#__PURE__*/ $6cds3.cloneElement(overlay, {
                ...overlayProps,
                placement: updatedPlacement,
                arrowProps: arrowProps,
                popper: popper,
                hasDoneInitialMeasure: hasDoneInitialMeasure,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(overlay.props.className, !transition && show && "show"),
                style: {
                    ...overlay.props.style,
                    ...overlayProps.style
                }
            });
        }
    });
});
$1e49270660e3cca2$var$Overlay.displayName = "Overlay";
var $1e49270660e3cca2$export$2e2bcd8739ae039 = $1e49270660e3cca2$var$Overlay;




"use client";
function $843e0f89d5f7d219$var$normalizeDelay(delay) {
    return delay && typeof delay === "object" ? delay : {
        show: delay,
        hide: delay
    };
}
// Simple implementation of mouseEnter and mouseLeave.
// React's built version is broken: https://github.com/facebook/react/issues/4251
// for cases when the trigger is disabled and mouseOut/Over can cause flicker
// moving from one child element to another.
function $843e0f89d5f7d219$var$handleMouseOverOut(// eslint-disable-next-line @typescript-eslint/no-shadow
handler, args, relatedNative) {
    const [e] = args;
    const target = e.currentTarget;
    const related = e.relatedTarget || e.nativeEvent[relatedNative];
    if ((!related || related !== target) && !(0, $bcd2f9d8e6f19108$export$2e2bcd8739ae039)(target, related)) handler(...args);
}
const $843e0f89d5f7d219$var$triggerType = (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).oneOf([
    "click",
    "hover",
    "focus"
]);
const $843e0f89d5f7d219$var$OverlayTrigger = ({ trigger: trigger = [
    "hover",
    "focus"
], overlay: overlay, children: children, popperConfig: popperConfig = {}, show: propsShow, defaultShow: defaultShow = false, onToggle: onToggle, delay: propsDelay, placement: placement, flip: flip = placement && placement.indexOf("auto") !== -1, ...props })=>{
    const triggerNodeRef = (0, $6cds3.useRef)(null);
    const mergedRef = (0, $2921c5d455351cc0$export$2e2bcd8739ae039)(triggerNodeRef, children.ref);
    const timeout = (0, $be71fffe37357017$export$2e2bcd8739ae039)();
    const hoverStateRef = (0, $6cds3.useRef)("");
    const [show, setShow] = (0, $ebeccf058174fd37$export$2ee51287a16ca325)(propsShow, defaultShow, onToggle);
    const delay = $843e0f89d5f7d219$var$normalizeDelay(propsDelay);
    const { onFocus: onFocus, onBlur: onBlur, onClick: onClick } = typeof children !== "function" ? $6cds3.Children.only(children).props : {};
    const attachRef = (r)=>{
        mergedRef((0, $42088736fa8dcd8f$export$2e2bcd8739ae039)(r));
    };
    const handleShow = (0, $6cds3.useCallback)(()=>{
        timeout.clear();
        hoverStateRef.current = "show";
        if (!delay.show) {
            setShow(true);
            return;
        }
        timeout.set(()=>{
            if (hoverStateRef.current === "show") setShow(true);
        }, delay.show);
    }, [
        delay.show,
        setShow,
        timeout
    ]);
    const handleHide = (0, $6cds3.useCallback)(()=>{
        timeout.clear();
        hoverStateRef.current = "hide";
        if (!delay.hide) {
            setShow(false);
            return;
        }
        timeout.set(()=>{
            if (hoverStateRef.current === "hide") setShow(false);
        }, delay.hide);
    }, [
        delay.hide,
        setShow,
        timeout
    ]);
    const handleFocus = (0, $6cds3.useCallback)((...args)=>{
        handleShow();
        onFocus == null || onFocus(...args);
    }, [
        handleShow,
        onFocus
    ]);
    const handleBlur = (0, $6cds3.useCallback)((...args)=>{
        handleHide();
        onBlur == null || onBlur(...args);
    }, [
        handleHide,
        onBlur
    ]);
    const handleClick = (0, $6cds3.useCallback)((...args)=>{
        setShow(!show);
        onClick == null || onClick(...args);
    }, [
        onClick,
        setShow,
        show
    ]);
    const handleMouseOver = (0, $6cds3.useCallback)((...args)=>{
        $843e0f89d5f7d219$var$handleMouseOverOut(handleShow, args, "fromElement");
    }, [
        handleShow
    ]);
    const handleMouseOut = (0, $6cds3.useCallback)((...args)=>{
        $843e0f89d5f7d219$var$handleMouseOverOut(handleHide, args, "toElement");
    }, [
        handleHide
    ]);
    const triggers = trigger == null ? [] : [].concat(trigger);
    const triggerProps = {
        ref: attachRef
    };
    if (triggers.indexOf("click") !== -1) triggerProps.onClick = handleClick;
    if (triggers.indexOf("focus") !== -1) {
        triggerProps.onFocus = handleFocus;
        triggerProps.onBlur = handleBlur;
    }
    if (triggers.indexOf("hover") !== -1) {
        triggerProps.onMouseOver = handleMouseOver;
        triggerProps.onMouseOut = handleMouseOut;
    }
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: [
            typeof children === "function" ? children(triggerProps) : /*#__PURE__*/ (0, $6cds3.cloneElement)(children, triggerProps),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $1e49270660e3cca2$export$2e2bcd8739ae039), {
                ...props,
                show: show,
                onHide: handleHide,
                flip: flip,
                placement: placement,
                popperConfig: popperConfig,
                target: triggerNodeRef.current,
                children: overlay
            })
        ]
    });
};
var $843e0f89d5f7d219$export$2e2bcd8739ae039 = $843e0f89d5f7d219$var$OverlayTrigger;


function $dc7c852c832d97ac$var$TooltipIcon(props) {
    if (!props.tooltip && !props.children) return props.icon;
    if (!props.icon && !props.children) return null;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $843e0f89d5f7d219$export$2e2bcd8739ae039), {
            placement: props.placement || "top",
            rootClose: props.rootClose,
            overlay: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $75c21e5a46e079cb$export$2e2bcd8739ae039), {
                id: `tooltip-${props.key}`,
                children: props.tooltip || props.children
            }),
            children: props.icon || props.children
        }, props.identifier)
    });
}
var $dc7c852c832d97ac$export$2e2bcd8739ae039 = $dc7c852c832d97ac$var$TooltipIcon;


var $4f7c0ff5199c3ac7$exports = {};

$4f7c0ff5199c3ac7$exports = (parcelRequire("17QCl")).getBundleURL("7lpHJ") + "coingecko.9a701a5c.png";


function $98ff89a109cb64fc$var$NetworkChecks(props) {
    var _baseAsset_prices;
    const { network: network, error: error, skipConnected: skipConnected } = props;
    const baseAsset = network === null || network === void 0 ? void 0 : network.baseAsset;
    const price = baseAsset === null || baseAsset === void 0 ? void 0 : (_baseAsset_prices = baseAsset.prices) === null || _baseAsset_prices === void 0 ? void 0 : _baseAsset_prices.coingecko;
    function renderCheck({ title: title, failTitle: failTitle, description: description, failDescription: failDescription, state: state, successClass: successClass, failClass: failClass, identifier: identifier, icon: icon }) {
        const className = state ? successClass || "success" : failClass || "warning";
        const content = /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
            className: "small",
            children: [
                icon ? icon : state ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $98e6c3958c713811$export$2e2bcd8739ae039), {
                    className: "me-2 mb-1"
                }) : failClass === "danger" ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $ac4c3421df377bd7$export$2e2bcd8739ae039), {
                    className: "me-2 mb-1"
                }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8643049b4ee40688$export$2e2bcd8739ae039), {
                    className: "me-2 mb-1"
                }),
                state ? title : failTitle || title
            ]
        });
        return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("li", {
            className: `list-group-item list-group-item-${className}`,
            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc7c852c832d97ac$export$2e2bcd8739ae039), {
                icon: content,
                identifier: identifier,
                tooltip: state ? description : failDescription || description
            })
        }, identifier);
    }
    const className = [
        "list-group",
        props.className
    ].join(" ");
    const operatorCheck = {
        title: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("span", {
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                    children: network.operatorCount
                }),
                " REStake operators"
            ]
        }),
        failTitle: "No REStake operators",
        failDescription: "There are no operators for this network yet. You can stake and compound manually in the meantime."
    };
    if (!network.authzSupport && network.operatorCount > 0) operatorCheck.failTitle = operatorCheck.title, operatorCheck.failDescription = "Authz is disabled but there are operators ready when support is added.";
    const testedCheck = {
        title: "Tested with REStake",
        failTitle: "Experimental support",
        failDescription: "This network was added to REStake automatically and has not been thoroughly tested yet."
    };
    if (!network.authzSupport && !network.experimental) testedCheck.description = "Authz is disabled but all other features have been fully tested.";
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("ul", {
        className: className,
        style: props.style,
        children: [
            renderCheck({
                title: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                    children: `$${price && price.usd.toLocaleString(undefined, {
                        maximumFractionDigits: 8,
                        minimumFractionDigits: 2
                    })}`
                }),
                failTitle: "Price unknown",
                state: price === null || price === void 0 ? void 0 : price.usd,
                identifier: "price",
                icon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($4f7c0ff5199c3ac7$exports))),
                    style: {
                        width: "1em",
                        height: "1em"
                    },
                    className: "me-2 mb-1"
                }),
                failClass: "success"
            }),
            renderCheck({
                title: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                    children: `${(0, $ed89d4c20b089b73$export$2077e0241d6afd3c)(network.estimatedApr * 100, 2).toLocaleString()}% APR`
                }),
                failTitle: "APR unknown",
                state: network.estimatedApr,
                identifier: "apr"
            }),
            !skipConnected && renderCheck({
                title: "API connected",
                failTitle: "API offline",
                failDescription: error,
                state: network.connected && !error,
                failClass: "danger",
                identifier: "network"
            }),
            renderCheck({
                title: !network.authzAminoGenericOnly ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                    children: "Full Authz support"
                }) : "Authz support",
                failTitle: "Authz not supported",
                failDescription: "This network doesn't support Authz just yet. You can stake and compound manually, REStake will update automatically when support is added.",
                state: network.authzSupport,
                identifier: "authz"
            }),
            renderCheck({
                ...operatorCheck,
                state: network.authzSupport && network.operatorCount > 0,
                identifier: "operators"
            }),
            renderCheck({
                ...testedCheck,
                state: !network.experimental,
                identifier: "experimental"
            })
        ]
    });
}
var $98ff89a109cb64fc$export$2e2bcd8739ae039 = $98ff89a109cb64fc$var$NetworkChecks;



parcelRequire("6cds3");
function $a1ed1e534eec315a$var$NetworkImage(props) {
    let { network: network, assetlist: assetlist, width: width, height: height, alt: alt } = props;
    height = height || 30;
    width = width || 30;
    let fallbackImage = `https://craftypixels.com/placeholder-image/${width}x${height}/ffffff/a6a6a6&text=missing`;
    let image;
    if (assetlist) {
        var _baseAsset_logo_URIs, _baseAsset_logo_URIs1;
        const baseAsset = assetlist.assets && assetlist.assets[0];
        image = (baseAsset === null || baseAsset === void 0 ? void 0 : (_baseAsset_logo_URIs = baseAsset.logo_URIs) === null || _baseAsset_logo_URIs === void 0 ? void 0 : _baseAsset_logo_URIs.svg) || (baseAsset === null || baseAsset === void 0 ? void 0 : (_baseAsset_logo_URIs1 = baseAsset.logo_URIs) === null || _baseAsset_logo_URIs1 === void 0 ? void 0 : _baseAsset_logo_URIs1.png);
    }
    image = image || network.image;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
        src: image || fallbackImage,
        width: width,
        height: height,
        alt: alt,
        className: `rounded-circle ${props.className}`,
        onError: ({ currentTarget: currentTarget })=>{
            currentTarget.onerror = null; // prevents looping
            currentTarget.src = fallbackImage;
        }
    });
}
var $a1ed1e534eec315a$export$2e2bcd8739ae039 = $a1ed1e534eec315a$var$NetworkImage;


function $b1b72b76c330b00f$var$NetworkSelect(props) {
    var _props_network_baseAsset_prices, _props_network_baseAsset, _props_network;
    const [show, setShow] = (0, $6cds3.useState)(props.show);
    const [loading, setLoading] = (0, $6cds3.useState)(false);
    const [error, setError] = (0, $6cds3.useState)(false);
    const [selectedNetwork, setSelectedNetwork] = (0, $6cds3.useState)();
    const [options, setOptions] = (0, $6cds3.useReducer)((state, newState)=>({
            ...state,
            ...newState
        }), {
        networks: [],
        operators: [],
        network: {
            value: ""
        }
    });
    function handleOpen() {
        setSelectedNetwork(props.network);
        setShow(true);
    }
    function handleClose() {
        setSelectedNetwork();
        setShow(false);
        props.onHide();
    }
    function handleSubmit(event) {
        event.preventDefault();
        props.changeNetwork(selectedNetwork);
        handleClose();
    }
    function selectNetwork(newValue) {
        const network = props.networks[newValue.value.replace(/^(favourite-)/, "")];
        if (network) {
            setLoading(true);
            setError(false);
            network.load().then(()=>{
                setSelectedNetwork(network);
                if (network.usingDirectory && !network.connectedDirectory()) throw false;
                return network.connect().then(()=>{
                    if (network.connected) setLoading(false);
                    else throw false;
                });
            }).catch((error)=>{
                console.log(error);
                setError("Could not connect to this network. Try again later");
                setLoading(false);
            });
        }
    }
    function selectedOption() {
        let networks = options.networks;
        if (options.grouped) networks = options.grouped.map((el)=>el.options).flat();
        return networks.find((el)=>el.value === options.network);
    }
    (0, $6cds3.useEffect)(()=>{
        if (props.show && !show) handleOpen();
        else if (!props.show && show) handleClose();
    }, [
        props.show
    ]);
    (0, $6cds3.useEffect)(()=>{
        const networks = Object.values(props.networks).sort((a, b)=>a.name > b.name ? 1 : -1);
        const networkOptions = networks.map((network)=>{
            return {
                value: network.path,
                label: network.prettyName,
                image: network.image,
                operatorCount: network.operatorCount,
                authz: network.authzSupport,
                online: network.online,
                experimental: network.experimental
            };
        });
        const isFavourite = selectedNetwork && props.favourites && props.favourites.includes(selectedNetwork.path);
        setOptions({
            networks: networkOptions,
            network: isFavourite ? `favourite-${selectedNetwork.path}` : selectedNetwork && selectedNetwork.path,
            grouped: props.favourites && props.favourites.length > 0 && [
                {
                    label: "Favourites",
                    options: networkOptions.filter((el)=>props.favourites.includes(el.value)).map((el)=>{
                        return {
                            ...el,
                            value: `favourite-${el.value}`
                        };
                    })
                },
                {
                    label: "All Networks",
                    options: networkOptions
                }
            ]
        });
    }, [
        props.networks,
        selectedNetwork
    ]);
    const price = (_props_network = props.network) === null || _props_network === void 0 ? void 0 : (_props_network_baseAsset = _props_network.baseAsset) === null || _props_network_baseAsset === void 0 ? void 0 : (_props_network_baseAsset_prices = _props_network_baseAsset.prices) === null || _props_network_baseAsset_prices === void 0 ? void 0 : _props_network_baseAsset_prices.coingecko;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $a73f5336dfd04f2d$export$2e2bcd8739ae039), {
                onClick: handleOpen,
                variant: "link",
                className: "d-flex flex-nowrap text-nowrap align-items-center text-reset text-decoration-none border-secondary btn-outline-light",
                role: "button",
                children: [
                    props.network ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: "avatar avatar-sm rounded-circle text-white",
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                    alt: props.network.prettyName,
                                    src: props.network.image,
                                    height: 30,
                                    width: 30
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                className: "d-none d-md-block mx-2",
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                        className: "h6",
                                        children: props.network.prettyName
                                    }),
                                    !!(price === null || price === void 0 ? void 0 : price.usd) && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("em", {
                                        className: "text-muted small",
                                        children: [
                                            "\xa0 $",
                                            price.usd.toLocaleString(undefined, {
                                                maximumFractionDigits: 4,
                                                minimumFractionDigits: 2
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: "d-none d-md-block ms-2",
                                children: props.network.authzSupport ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e44c6ff59d2a760f$export$2e2bcd8739ae039), {
                                    className: "rounded-pill",
                                    bg: "success",
                                    children: "Authz"
                                }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e44c6ff59d2a760f$export$2e2bcd8739ae039), {
                                    className: "rounded-pill text-decoration-line-through",
                                    bg: "danger",
                                    children: "Authz"
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                            className: "d-none d-md-block ms-2",
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                className: "h6",
                                children: "Choose a Network"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "ms-2",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("i", {
                            className: "bi bi-chevron-down text-muted text-xs"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $3485727b0a1e4042$export$2e2bcd8739ae039), {
                show: show,
                onHide: handleClose,
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $3485727b0a1e4042$export$2e2bcd8739ae039).Header, {
                        closeButton: true,
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $3485727b0a1e4042$export$2e2bcd8739ae039).Title, {
                            children: "Change Network"
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $3485727b0a1e4042$export$2e2bcd8739ae039).Body, {
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039), {
                            onSubmit: handleSubmit,
                            children: [
                                props.networks && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                    className: "row mb-3",
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                        className: "col",
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5e385862a1a4c8ce$export$2e2bcd8739ae039), {
                                            value: selectedOption(),
                                            isClearable: false,
                                            name: "network",
                                            options: options.grouped || options.networks,
                                            onChange: selectNetwork,
                                            formatOptionLabel: (network)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                                    className: "d-flex" + (!network.online ? " text-muted" : ""),
                                                    children: [
                                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                                            className: "pe-2",
                                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a1ed1e534eec315a$export$2e2bcd8739ae039), {
                                                                network: network,
                                                                width: 30,
                                                                height: 30,
                                                                alt: network.label
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                                            className: "pt-1 me-auto",
                                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("span", {
                                                                className: "ms-1",
                                                                children: [
                                                                    network.label,
                                                                    " ",
                                                                    !network.online && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("small", {
                                                                        children: "(Offline)"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                                            className: "text-end pt-1 d-none d-sm-block",
                                                            children: network.operatorCount > 0 && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("small", {
                                                                children: [
                                                                    network.operatorCount,
                                                                    " Operator",
                                                                    network.operatorCount > 1 ? "s" : ""
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                                            className: "text-end pt-1",
                                                            children: network.authz ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e44c6ff59d2a760f$export$2e2bcd8739ae039), {
                                                                className: `ms-3 rounded-pill` + (!network.online ? " opacity-50" : ""),
                                                                bg: "success",
                                                                children: "Authz"
                                                            }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e44c6ff59d2a760f$export$2e2bcd8739ae039), {
                                                                className: `ms-3 rounded-pill text-decoration-line-through` + (!network.online ? " opacity-50" : ""),
                                                                bg: "danger",
                                                                children: "Authz"
                                                            })
                                                        })
                                                    ]
                                                }),
                                            theme: (theme)=>({
                                                    ...theme,
                                                    colors: {
                                                        ...theme.colors,
                                                        neutral0: "var(--bs-body-bg)",
                                                        neutral80: "var(--bs-body)",
                                                        primary25: "var(--bs-light)"
                                                    }
                                                })
                                        })
                                    })
                                }),
                                selectedNetwork && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $98ff89a109cb64fc$export$2e2bcd8739ae039), {
                                            network: selectedNetwork,
                                            error: error
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                            className: "text-center mt-4 mb-2",
                                            children: !loading ? !error && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a73f5336dfd04f2d$export$2e2bcd8739ae039), {
                                                type: "submit",
                                                className: "btn btn-primary btn-lg",
                                                children: "Change network"
                                            }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $a73f5336dfd04f2d$export$2e2bcd8739ae039), {
                                                className: "btn-primary btn-lg mr-5",
                                                disabled: true,
                                                children: [
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                        className: "spinner-border spinner-border-sm",
                                                        role: "status",
                                                        "aria-hidden": "true"
                                                    }),
                                                    "\xa0 Updating..."
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
var $b1b72b76c330b00f$export$2e2bcd8739ae039 = $b1b72b76c330b00f$var$NetworkSelect;




var $6cds3 = parcelRequire("6cds3");

var $c9wMV = parcelRequire("c9wMV");






var $c9wMV = parcelRequire("c9wMV");


var $8089e3720f1b5af3$exports = {};
"use strict";
/**
 * There are cases where important information is at the end of the string and truncating the end isn't helpful.
 * This function solves that.
 *
 * @param  {string} str         String to be truncated
 * @param  {number} frontLen    Number of characters to be remained in front.
 * @param  {number} backLen     Number of characters to be remained at the back.
 * @param  {string} truncateStr String that is replaced the truncated portion
 * @return {string}             Truncated string. Defaults to '&hellip;' if unspecified.
 */ $8089e3720f1b5af3$exports = function(str, frontLen, backLen, truncateStr) {
    if (str === null) return "";
    var strLen = str.length;
    // Setting default values
    frontLen = ~~frontLen // will cast to integer
    ;
    backLen = ~~backLen;
    truncateStr = truncateStr || "&hellip;";
    if (frontLen === 0 && backLen === 0 || frontLen >= strLen || backLen >= strLen || frontLen + backLen >= strLen) return str;
    else if (backLen === 0) return str.slice(0, frontLen) + truncateStr;
    else return str.slice(0, frontLen) + truncateStr + str.slice(strLen - backLen);
};


function $2a6bf51ee962800d$export$c0dbb1ea68a069d3(...args) {
    console.log("[" + new Date().toISOString().substring(11, 23) + "]", ...args);
}
function $2a6bf51ee962800d$export$3c9d1e4131afeeb8(amount, denom) {
    return (0, $842e3ecb6082807a$exports.coin)((0, $ed89d4c20b089b73$export$d9468344d3651243)((0, $ed89d4c20b089b73$export$a3fe094919f356fd)(amount), {
        notation: "fixed"
    }), denom);
}
function $2a6bf51ee962800d$export$5bc2b158205eb1d6(...args) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9wMV))).compact(args).join(" ");
}
function $2a6bf51ee962800d$export$cd8822fabcdefd67(address) {
    const firstDigit = address.search(/\d/);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8089e3720f1b5af3$exports)))(address, firstDigit + 6, 6, "\u2026");
}
function $2a6bf51ee962800d$export$31d336b0b7e2f20(rewards, denom, type) {
    var _rewards_type;
    if (!rewards) return 0;
    type = type || "reward";
    const reward = rewards && ((_rewards_type = rewards[type]) === null || _rewards_type === void 0 ? void 0 : _rewards_type.find((el)=>el.denom === denom));
    return reward ? (0, $ed89d4c20b089b73$export$8576f72eb7f14a7e)(reward.amount) : 0;
}
function $2a6bf51ee962800d$export$e7ef98792bab6700(networks, overrides) {
    networks = networks.reduce((a, v)=>({
            ...a,
            [v.name]: v
        }), {});
    const names = [
        ...Object.keys(networks),
        ...Object.keys(overrides)
    ];
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9wMV))).uniq(names).sort().map((name)=>{
        let network = networks[name];
        let override = overrides[name];
        if (!network || !network.name) network = {
            name: name,
            ...network
        };
        if (!override) return network;
        override.overriden = true;
        return (0, (/*@__PURE__*/$parcel$interopDefault($c9wMV))).mergeWith(network, override, (a, b)=>(0, (/*@__PURE__*/$parcel$interopDefault($c9wMV))).isArray(b) ? b : undefined);
    });
}
function $2a6bf51ee962800d$export$61d88097eacac343(grantee, messages) {
    return {
        typeUrl: "/cosmos.authz.v1beta1.MsgExec",
        value: {
            grantee: grantee,
            msgs: messages
        }
    };
}
function $2a6bf51ee962800d$export$9df738dbed799d5(type, typeUrl, value, shouldExec) {
    if (shouldExec) return {
        typeUrl: typeUrl,
        value: type.encode(type.fromPartial(value)).finish()
    };
    else return {
        typeUrl: typeUrl,
        value: value
    };
}
function $2a6bf51ee962800d$export$c5197dfe1b46ea0(grants, grantee, granter) {
    // claimGrant is removed but we track for now to allow revoke
    const claimGrant = grants.find((el)=>{
        if ((!el.grantee || el.grantee === grantee) && (!el.granter || el.granter === granter) && el.authorization["@type"] === "/cosmos.authz.v1beta1.GenericAuthorization" && el.authorization.msg === "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward") return Date.parse(el.expiration) > new Date();
        else return false;
    });
    const stakeGrant = grants.find((el)=>{
        if ((!el.grantee || el.grantee === grantee) && (!el.granter || el.granter === granter) && (el.authorization["@type"] === "/cosmos.staking.v1beta1.StakeAuthorization" || // Handle GenericAuthorization for Ledger
        el.authorization["@type"] === "/cosmos.authz.v1beta1.GenericAuthorization" && el.authorization.msg === "/cosmos.staking.v1beta1.MsgDelegate")) return Date.parse(el.expiration) > new Date();
        else return false;
    });
    return {
        claimGrant: claimGrant,
        stakeGrant: stakeGrant
    };
}
function $2a6bf51ee962800d$export$a939ddd3409bd57a(array, callbackfn) {
    return Promise.all(array.map(callbackfn));
}
function $2a6bf51ee962800d$export$4650fa2d799cbf63(array, callbackfn) {
    return $2a6bf51ee962800d$export$a939ddd3409bd57a(array, callbackfn).then((findMap)=>{
        return array.find((value, index)=>findMap[index]);
    });
}
function $2a6bf51ee962800d$export$30ee5c6810ce1ce2(array, callbackfn) {
    return $2a6bf51ee962800d$export$a939ddd3409bd57a(array, callbackfn).then((filterMap)=>{
        return array.filter((value, index)=>filterMap[index]);
    });
}
async function $2a6bf51ee962800d$export$7f6ea9e52e3e8720(calls, count, batchCallback) {
    const batchCalls = (0, (/*@__PURE__*/$parcel$interopDefault($c9wMV))).chunk(calls, count);
    let results = [];
    let index = 0;
    for (const batchCall of batchCalls){
        const batchResults = await $2a6bf51ee962800d$export$a939ddd3409bd57a(batchCall, (call)=>call());
        results.push(batchResults);
        if (batchCallback) await batchCallback(batchResults, index);
        index++;
    }
    return results.flat();
}
async function $2a6bf51ee962800d$export$6d0f20a121527483(calls, count) {
    const batchCalls = (0, (/*@__PURE__*/$parcel$interopDefault($c9wMV))).chunk(calls, count);
    for (const batchCall of batchCalls)await $2a6bf51ee962800d$export$a939ddd3409bd57a(batchCall, (call)=>call());
}
function $2a6bf51ee962800d$export$9ae6b564c4c11ac(wallet) {
    if (wallet.authzSupport()) return null;
    if (wallet.signerProvider.isLedger()) return `${wallet.signerProvider.label} can't send Authz transactions with Ledger on ${wallet.network.prettyName} just yet.`;
    else return `${wallet.props.wallet.signerProvider.label} can't send Authz transactions on ${wallet.network.prettyName} just yet.`;
}




var $6cds3 = parcelRequire("6cds3");



var $6cds3 = parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");
function $69251a9c8fba185a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $69251a9c8fba185a$var$_toPropertyKey(arg) {
    var key = $69251a9c8fba185a$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $69251a9c8fba185a$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $69251a9c8fba185a$export$26cbf8c37e721e67(key) {
    return "default" + key.charAt(0).toUpperCase() + key.substr(1);
}
function $69251a9c8fba185a$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    const wasPropRef = (0, $6cds3.useRef)(propValue !== undefined);
    const [stateValue, setState] = (0, $6cds3.useState)(defaultValue);
    const isProp = propValue !== undefined;
    const wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $6cds3.useCallback)((...args)=>{
            const [value, ...rest] = args;
            let returnValue = handler == null ? void 0 : handler(value, ...rest);
            setState(value);
            return returnValue;
        }, [
            handler
        ])
    ];
}
function $69251a9c8fba185a$export$ec55e9daaf703a7d(props, config) {
    return Object.keys(config).reduce((result, fieldName)=>{
        const _ref = result, _defaultKey = $69251a9c8fba185a$export$26cbf8c37e721e67(fieldName), { [_defaultKey]: defaultValue, [fieldName]: propsValue } = _ref, rest = $69251a9c8fba185a$var$_objectWithoutPropertiesLoose(_ref, [
            _defaultKey,
            fieldName
        ].map($69251a9c8fba185a$var$_toPropertyKey));
        const handlerName = config[fieldName];
        const [value, handler] = $69251a9c8fba185a$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]);
        return Object.assign({}, rest, {
            [fieldName]: value,
            [handlerName]: handler
        });
    }, props);
}




var $6cds3 = parcelRequire("6cds3");
function $6f65c8e52908cbfc$export$2e2bcd8739ae039() {
    // The toggling state value is designed to defeat React optimizations for skipping
    // updates when they are strictly equal to the last state value
    const [, dispatch] = (0, $6cds3.useReducer)((state)=>!state, false);
    return dispatch;
}





var $6cds3 = parcelRequire("6cds3");
const $2c7225bf1d745884$var$DropdownContext = /*#__PURE__*/ $6cds3.createContext(null);
var $2c7225bf1d745884$export$2e2bcd8739ae039 = $2c7225bf1d745884$var$DropdownContext;



var $6cds3 = parcelRequire("6cds3");






const $8db6e76678fd7810$var$_excluded = [
    "children"
];
function $8db6e76678fd7810$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $8db6e76678fd7810$var$noop = ()=>{};
function $8db6e76678fd7810$export$133c4d08f3775d64(options = {}) {
    const context = (0, $6cds3.useContext)((0, $2c7225bf1d745884$export$2e2bcd8739ae039));
    const [arrowElement, attachArrowRef] = (0, $6c24397ccd0ea65a$export$2e2bcd8739ae039)();
    const hasShownRef = (0, $6cds3.useRef)(false);
    const { flip: flip, offset: offset, rootCloseEvent: rootCloseEvent, fixed: fixed = false, placement: placementOverride, popperConfig: popperConfig = {}, enableEventListeners: enableEventListeners = true, usePopper: shouldUsePopper = !!context } = options;
    const show = (context == null ? void 0 : context.show) == null ? !!options.show : context.show;
    if (show && !hasShownRef.current) hasShownRef.current = true;
    const handleClose = (e)=>{
        context == null || context.toggle(false, e);
    };
    const { placement: placement, setMenu: setMenu, menuElement: menuElement, toggleElement: toggleElement } = context || {};
    const popper = (0, $80acecdcbaa1190f$export$2e2bcd8739ae039)(toggleElement, menuElement, (0, $e7278278b40c06c3$export$2e2bcd8739ae039)({
        placement: placementOverride || placement || "bottom-start",
        enabled: shouldUsePopper,
        enableEvents: enableEventListeners == null ? show : enableEventListeners,
        offset: offset,
        flip: flip,
        fixed: fixed,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    }));
    const menuProps = Object.assign({
        ref: setMenu || $8db6e76678fd7810$var$noop,
        "aria-labelledby": toggleElement == null ? void 0 : toggleElement.id
    }, popper.attributes.popper, {
        style: popper.styles.popper
    });
    const metadata = {
        show: show,
        placement: placement,
        hasShown: hasShownRef.current,
        toggle: context == null ? void 0 : context.toggle,
        popper: shouldUsePopper ? popper : null,
        arrowProps: shouldUsePopper ? Object.assign({
            ref: attachArrowRef
        }, popper.attributes.arrow, {
            style: popper.styles.arrow
        }) : {}
    };
    (0, $50719ea8fa0478c2$export$2e2bcd8739ae039)(menuElement, handleClose, {
        clickTrigger: rootCloseEvent,
        disabled: !show
    });
    return [
        menuProps,
        metadata
    ];
}
const $8db6e76678fd7810$var$defaultProps = {
    usePopper: true
};
/**
 * Also exported as `<Dropdown.Menu>` from `Dropdown`.
 *
 * @displayName DropdownMenu
 * @memberOf Dropdown
 */ function $8db6e76678fd7810$var$DropdownMenu(_ref) {
    let { children: children } = _ref, options = $8db6e76678fd7810$var$_objectWithoutPropertiesLoose(_ref, $8db6e76678fd7810$var$_excluded);
    const [props, meta] = $8db6e76678fd7810$export$133c4d08f3775d64(options);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: children(props, meta)
    });
}
$8db6e76678fd7810$var$DropdownMenu.displayName = "DropdownMenu";
$8db6e76678fd7810$var$DropdownMenu.defaultProps = $8db6e76678fd7810$var$defaultProps;
var /** @component */ $8db6e76678fd7810$export$2e2bcd8739ae039 = $8db6e76678fd7810$var$DropdownMenu;



var $6cds3 = parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rulesdir/useLayoutEffectRule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $2714160d09cd0aeb$var$$b5e257d569688ac6$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $2714160d09cd0aeb$var$$b5e257d569688ac6$var$SSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createContext($2714160d09cd0aeb$var$$b5e257d569688ac6$var$defaultContext);
const $2714160d09cd0aeb$var$$b5e257d569688ac6$var$IsSSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createContext(false);
// This is only used in React < 18.
function $2714160d09cd0aeb$var$$b5e257d569688ac6$var$LegacySSRProvider(props) {
    let cur = (0, $6cds3.useContext)($2714160d09cd0aeb$var$$b5e257d569688ac6$var$SSRContext);
    let counter = $2714160d09cd0aeb$var$$b5e257d569688ac6$var$useCounter(cur === $2714160d09cd0aeb$var$$b5e257d569688ac6$var$defaultContext);
    let [isSSR, setIsSSR] = (0, $6cds3.useState)(true);
    let value = (0, $6cds3.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $2714160d09cd0aeb$var$$b5e257d569688ac6$var$defaultContext ? "" : `${cur.prefix}-${counter}`,
            current: 0
        }), [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== "undefined") (0, $6cds3.useLayoutEffect)(()=>{
        setIsSSR(false);
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($2714160d09cd0aeb$var$$b5e257d569688ac6$var$SSRContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($2714160d09cd0aeb$var$$b5e257d569688ac6$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
let $2714160d09cd0aeb$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = false;
function $2714160d09cd0aeb$export$9f8ac96af4b1b2ae(props) {
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($6cds3)))["useId"] === "function") {
        if (!$2714160d09cd0aeb$var$$b5e257d569688ac6$var$warnedAboutSSRProvider) {
            console.warn("In React 18, SSRProvider is not necessary and is a noop. You can remove it from your app.");
            $2714160d09cd0aeb$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = true;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Fragment, null, props.children);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($2714160d09cd0aeb$var$$b5e257d569688ac6$var$LegacySSRProvider, props);
}
let $2714160d09cd0aeb$var$$b5e257d569688ac6$var$canUseDOM = Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
let $2714160d09cd0aeb$var$$b5e257d569688ac6$var$componentIds = new WeakMap();
function $2714160d09cd0aeb$var$$b5e257d569688ac6$var$useCounter(isDisabled = false) {
    let ctx = (0, $6cds3.useContext)($2714160d09cd0aeb$var$$b5e257d569688ac6$var$SSRContext);
    let ref = (0, $6cds3.useRef)(null);
    // eslint-disable-next-line rulesdir/pure-render
    if (ref.current === null && !isDisabled) {
        var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        // @ts-ignore
        let currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
        if (currentOwner) {
            let prevComponentValue = $2714160d09cd0aeb$var$$b5e257d569688ac6$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $2714160d09cd0aeb$var$$b5e257d569688ac6$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                ctx.current = prevComponentValue.id;
                $2714160d09cd0aeb$var$$b5e257d569688ac6$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rulesdir/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rulesdir/pure-render
    return ref.current;
}
function $2714160d09cd0aeb$var$$b5e257d569688ac6$var$useLegacySSRSafeId(defaultId) {
    let ctx = (0, $6cds3.useContext)($2714160d09cd0aeb$var$$b5e257d569688ac6$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    if (ctx === $2714160d09cd0aeb$var$$b5e257d569688ac6$var$defaultContext && !$2714160d09cd0aeb$var$$b5e257d569688ac6$var$canUseDOM) console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
    let counter = $2714160d09cd0aeb$var$$b5e257d569688ac6$var$useCounter(!!defaultId);
    let prefix = `react-aria${ctx.prefix}`;
    return defaultId || `${prefix}-${counter}`;
}
function $2714160d09cd0aeb$var$$b5e257d569688ac6$var$useModernSSRSafeId(defaultId) {
    // @ts-ignore
    let id = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useId();
    let [didSSR] = (0, $6cds3.useState)($2714160d09cd0aeb$export$535bd6ca7f90a273());
    let prefix = didSSR || false ? "react-aria" : `react-aria${$2714160d09cd0aeb$var$$b5e257d569688ac6$var$defaultContext.prefix}`;
    return defaultId || `${prefix}-${id}`;
}
const $2714160d09cd0aeb$export$619500959fc48b26 = typeof (0, (/*@__PURE__*/$parcel$interopDefault($6cds3)))["useId"] === "function" ? $2714160d09cd0aeb$var$$b5e257d569688ac6$var$useModernSSRSafeId : $2714160d09cd0aeb$var$$b5e257d569688ac6$var$useLegacySSRSafeId;
function $2714160d09cd0aeb$var$$b5e257d569688ac6$var$getSnapshot() {
    return false;
}
function $2714160d09cd0aeb$var$$b5e257d569688ac6$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $2714160d09cd0aeb$var$$b5e257d569688ac6$var$subscribe(onStoreChange) {
    // noop
    return ()=>{};
}
function $2714160d09cd0aeb$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($6cds3)))["useSyncExternalStore"] === "function") return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3)))["useSyncExternalStore"]($2714160d09cd0aeb$var$$b5e257d569688ac6$var$subscribe, $2714160d09cd0aeb$var$$b5e257d569688ac6$var$getSnapshot, $2714160d09cd0aeb$var$$b5e257d569688ac6$var$getServerSnapshot);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $6cds3.useContext)($2714160d09cd0aeb$var$$b5e257d569688ac6$var$IsSSRContext);
}




const $2b9b2ada6a532f31$export$386b1213cf9779d8 = (el)=>{
    var _el$getAttribute;
    return ((_el$getAttribute = el.getAttribute("role")) == null ? void 0 : _el$getAttribute.toLowerCase()) === "menu";
};
const $2b9b2ada6a532f31$var$noop = ()=>{};
function $2b9b2ada6a532f31$export$96df6c7c5036b9a2() {
    const id = (0, $2714160d09cd0aeb$export$619500959fc48b26)();
    const { show: show = false, toggle: toggle = $2b9b2ada6a532f31$var$noop, setToggle: setToggle, menuElement: menuElement } = (0, $6cds3.useContext)((0, $2c7225bf1d745884$export$2e2bcd8739ae039)) || {};
    const handleClick = (0, $6cds3.useCallback)((e)=>{
        toggle(!show, e);
    }, [
        show,
        toggle
    ]);
    const props = {
        id: id,
        ref: setToggle || $2b9b2ada6a532f31$var$noop,
        onClick: handleClick,
        "aria-expanded": !!show
    };
    // This is maybe better down in an effect, but
    // the component is going to update anyway when the menu element
    // is set so might return new props.
    if (menuElement && $2b9b2ada6a532f31$export$386b1213cf9779d8(menuElement)) props["aria-haspopup"] = true;
    return [
        props,
        {
            show: show,
            toggle: toggle
        }
    ];
}
/**
 * Also exported as `<Dropdown.Toggle>` from `Dropdown`.
 *
 * @displayName DropdownToggle
 * @memberOf Dropdown
 */ function $2b9b2ada6a532f31$var$DropdownToggle({ children: children }) {
    const [props, meta] = $2b9b2ada6a532f31$export$96df6c7c5036b9a2();
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: children(props, meta)
    });
}
$2b9b2ada6a532f31$var$DropdownToggle.displayName = "DropdownToggle";
var /** @component */ $2b9b2ada6a532f31$export$2e2bcd8739ae039 = $2b9b2ada6a532f31$var$DropdownToggle;



var $6cds3 = parcelRequire("6cds3");


var $6cds3 = parcelRequire("6cds3");
const $a140b6f07d6ac44a$var$SelectableContext = /*#__PURE__*/ $6cds3.createContext(null);
const $a140b6f07d6ac44a$export$eef49b42fde998a3 = (eventKey, href = null)=>{
    if (eventKey != null) return String(eventKey);
    return href || null;
};
var $a140b6f07d6ac44a$export$2e2bcd8739ae039 = $a140b6f07d6ac44a$var$SelectableContext;



var $6cds3 = parcelRequire("6cds3");
const $8b39ba1004e4380e$var$NavContext = /*#__PURE__*/ $6cds3.createContext(null);
$8b39ba1004e4380e$var$NavContext.displayName = "NavContext";
var $8b39ba1004e4380e$export$2e2bcd8739ae039 = $8b39ba1004e4380e$var$NavContext;





const $c474c338622d9f76$var$_excluded = [
    "eventKey",
    "disabled",
    "onClick",
    "active",
    "as"
];
function $c474c338622d9f76$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $c474c338622d9f76$export$522d7e1e4e0e22b2({ key: key, href: href, active: active, disabled: disabled, onClick: onClick }) {
    const onSelectCtx = (0, $6cds3.useContext)((0, $a140b6f07d6ac44a$export$2e2bcd8739ae039));
    const navContext = (0, $6cds3.useContext)((0, $8b39ba1004e4380e$export$2e2bcd8739ae039));
    const { activeKey: activeKey } = navContext || {};
    const eventKey = (0, $a140b6f07d6ac44a$export$eef49b42fde998a3)(key, href);
    const isActive = active == null && key != null ? (0, $a140b6f07d6ac44a$export$eef49b42fde998a3)(activeKey) === eventKey : active;
    const handleClick = (0, $cfbeaaf7204fcb02$export$2e2bcd8739ae039)((event)=>{
        if (disabled) return;
        onClick == null || onClick(event);
        if (onSelectCtx && !event.isPropagationStopped()) onSelectCtx(eventKey, event);
    });
    return [
        {
            onClick: handleClick,
            "aria-disabled": disabled || undefined,
            "aria-selected": isActive,
            [(0, $6e6a9ad066805249$export$5cc3b7b83e34ade7)("dropdown-item")]: ""
        },
        {
            isActive: isActive
        }
    ];
}
const $c474c338622d9f76$var$DropdownItem = /*#__PURE__*/ $6cds3.forwardRef((_ref, ref)=>{
    let { eventKey: eventKey, disabled: disabled, onClick: onClick, active: active, as: Component = (0, $79267241913a4681$export$2e2bcd8739ae039) } = _ref, props = $c474c338622d9f76$var$_objectWithoutPropertiesLoose(_ref, $c474c338622d9f76$var$_excluded);
    const [dropdownItemProps] = $c474c338622d9f76$export$522d7e1e4e0e22b2({
        key: eventKey,
        href: props.href,
        disabled: disabled,
        onClick: onClick,
        active: active
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, Object.assign({}, props, {
        ref: ref
    }, dropdownItemProps));
});
$c474c338622d9f76$var$DropdownItem.displayName = "DropdownItem";
var $c474c338622d9f76$export$2e2bcd8739ae039 = $c474c338622d9f76$var$DropdownItem;






function $90176979a0004578$var$useRefWithUpdate() {
    const forceUpdate = (0, $6f65c8e52908cbfc$export$2e2bcd8739ae039)();
    const ref = (0, $6cds3.useRef)(null);
    const attachRef = (0, $6cds3.useCallback)((element)=>{
        ref.current = element;
        // ensure that a menu set triggers an update for consumers
        forceUpdate();
    }, [
        forceUpdate
    ]);
    return [
        ref,
        attachRef
    ];
}
/**
 * @displayName Dropdown
 * @public
 */ function $90176979a0004578$var$Dropdown({ defaultShow: defaultShow, show: rawShow, onSelect: onSelect, onToggle: rawOnToggle, itemSelector: itemSelector = `* [${(0, $6e6a9ad066805249$export$5cc3b7b83e34ade7)("dropdown-item")}]`, focusFirstItemOnShow: focusFirstItemOnShow, placement: placement = "bottom-start", children: children }) {
    const window = (0, $51c759f15d660954$export$2e2bcd8739ae039)();
    const [show, onToggle] = (0, $69251a9c8fba185a$export$2ee51287a16ca325)(rawShow, defaultShow, rawOnToggle);
    // We use normal refs instead of useCallbackRef in order to populate the
    // the value as quickly as possible, otherwise the effect to focus the element
    // may run before the state value is set
    const [menuRef, setMenu] = $90176979a0004578$var$useRefWithUpdate();
    const menuElement = menuRef.current;
    const [toggleRef, setToggle] = $90176979a0004578$var$useRefWithUpdate();
    const toggleElement = toggleRef.current;
    const lastShow = (0, $e9b4c74f20368aab$export$2e2bcd8739ae039)(show);
    const lastSourceEvent = (0, $6cds3.useRef)(null);
    const focusInDropdown = (0, $6cds3.useRef)(false);
    const onSelectCtx = (0, $6cds3.useContext)((0, $a140b6f07d6ac44a$export$2e2bcd8739ae039));
    const toggle = (0, $6cds3.useCallback)((nextShow, event, source = event == null ? void 0 : event.type)=>{
        onToggle(nextShow, {
            originalEvent: event,
            source: source
        });
    }, [
        onToggle
    ]);
    const handleSelect = (0, $cfbeaaf7204fcb02$export$2e2bcd8739ae039)((key, event)=>{
        onSelect == null || onSelect(key, event);
        toggle(false, event, "select");
        if (!event.isPropagationStopped()) onSelectCtx == null || onSelectCtx(key, event);
    });
    const context = (0, $6cds3.useMemo)(()=>({
            toggle: toggle,
            placement: placement,
            show: show,
            menuElement: menuElement,
            toggleElement: toggleElement,
            setMenu: setMenu,
            setToggle: setToggle
        }), [
        toggle,
        placement,
        show,
        menuElement,
        toggleElement,
        setMenu,
        setToggle
    ]);
    if (menuElement && lastShow && !show) focusInDropdown.current = menuElement.contains(menuElement.ownerDocument.activeElement);
    const focusToggle = (0, $cfbeaaf7204fcb02$export$2e2bcd8739ae039)(()=>{
        if (toggleElement && toggleElement.focus) toggleElement.focus();
    });
    const maybeFocusFirst = (0, $cfbeaaf7204fcb02$export$2e2bcd8739ae039)(()=>{
        const type = lastSourceEvent.current;
        let focusType = focusFirstItemOnShow;
        if (focusType == null) focusType = menuRef.current && (0, $2b9b2ada6a532f31$export$386b1213cf9779d8)(menuRef.current) ? "keyboard" : false;
        if (focusType === false || focusType === "keyboard" && !/^key.+$/.test(type)) return;
        const first = (0, $557b64d4dca42129$export$2e2bcd8739ae039)(menuRef.current, itemSelector)[0];
        if (first && first.focus) first.focus();
    });
    (0, $6cds3.useEffect)(()=>{
        if (show) maybeFocusFirst();
        else if (focusInDropdown.current) {
            focusInDropdown.current = false;
            focusToggle();
        }
    // only `show` should be changing
    }, [
        show,
        focusInDropdown,
        focusToggle,
        maybeFocusFirst
    ]);
    (0, $6cds3.useEffect)(()=>{
        lastSourceEvent.current = null;
    });
    const getNextFocusedChild = (current, offset)=>{
        if (!menuRef.current) return null;
        const items = (0, $557b64d4dca42129$export$2e2bcd8739ae039)(menuRef.current, itemSelector);
        let index = items.indexOf(current) + offset;
        index = Math.max(0, Math.min(index, items.length));
        return items[index];
    };
    (0, $d3bd603bbc88b0d1$export$2e2bcd8739ae039)((0, $6cds3.useCallback)(()=>window.document, [
        window
    ]), "keydown", (event)=>{
        var _menuRef$current, _toggleRef$current;
        const { key: key } = event;
        const target = event.target;
        const fromMenu = (_menuRef$current = menuRef.current) == null ? void 0 : _menuRef$current.contains(target);
        const fromToggle = (_toggleRef$current = toggleRef.current) == null ? void 0 : _toggleRef$current.contains(target);
        // Second only to https://github.com/twbs/bootstrap/blob/8cfbf6933b8a0146ac3fbc369f19e520bd1ebdac/js/src/dropdown.js#L400
        // in inscrutability
        const isInput = /input|textarea/i.test(target.tagName);
        if (isInput && (key === " " || key !== "Escape" && fromMenu || key === "Escape" && target.type === "search")) return;
        if (!fromMenu && !fromToggle) return;
        if (key === "Tab" && (!menuRef.current || !show)) return;
        lastSourceEvent.current = event.type;
        const meta = {
            originalEvent: event,
            source: event.type
        };
        switch(key){
            case "ArrowUp":
                {
                    const next = getNextFocusedChild(target, -1);
                    if (next && next.focus) next.focus();
                    event.preventDefault();
                    return;
                }
            case "ArrowDown":
                event.preventDefault();
                if (!show) onToggle(true, meta);
                else {
                    const next = getNextFocusedChild(target, 1);
                    if (next && next.focus) next.focus();
                }
                return;
            case "Tab":
                // on keydown the target is the element being tabbed FROM, we need that
                // to know if this event is relevant to this dropdown (e.g. in this menu).
                // On `keyup` the target is the element being tagged TO which we use to check
                // if focus has left the menu
                (0, $a0bafde1ed7798b0$export$2e2bcd8739ae039)(target.ownerDocument, "keyup", (e)=>{
                    var _menuRef$current2;
                    if (e.key === "Tab" && !e.target || !((_menuRef$current2 = menuRef.current) != null && _menuRef$current2.contains(e.target))) onToggle(false, meta);
                }, {
                    once: true
                });
                break;
            case "Escape":
                if (key === "Escape") {
                    event.preventDefault();
                    event.stopPropagation();
                }
                onToggle(false, meta);
                break;
            default:
        }
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a140b6f07d6ac44a$export$2e2bcd8739ae039).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2c7225bf1d745884$export$2e2bcd8739ae039).Provider, {
            value: context,
            children: children
        })
    });
}
$90176979a0004578$var$Dropdown.displayName = "Dropdown";
$90176979a0004578$var$Dropdown.Menu = (0, $8db6e76678fd7810$export$2e2bcd8739ae039);
$90176979a0004578$var$Dropdown.Toggle = (0, $2b9b2ada6a532f31$export$2e2bcd8739ae039);
$90176979a0004578$var$Dropdown.Item = (0, $c474c338622d9f76$export$2e2bcd8739ae039);
var $90176979a0004578$export$2e2bcd8739ae039 = $90176979a0004578$var$Dropdown;





var $6cds3 = parcelRequire("6cds3");
"use client";
const $f8b99613323254bf$var$DropdownContext = /*#__PURE__*/ $6cds3.createContext({});
$f8b99613323254bf$var$DropdownContext.displayName = "DropdownContext";
var $f8b99613323254bf$export$2e2bcd8739ae039 = $f8b99613323254bf$var$DropdownContext;



var $6cds3 = parcelRequire("6cds3");



"use client";
const $da3bfc79083ad169$var$DropdownDivider = /*#__PURE__*/ $6cds3.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "hr", role: role = "separator", ...props }, ref)=>{
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "dropdown-divider");
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, bsPrefix),
        role: role,
        ...props
    });
});
$da3bfc79083ad169$var$DropdownDivider.displayName = "DropdownDivider";
var $da3bfc79083ad169$export$2e2bcd8739ae039 = $da3bfc79083ad169$var$DropdownDivider;



var $6cds3 = parcelRequire("6cds3");



"use client";
const $6c78f0285091f61a$var$DropdownHeader = /*#__PURE__*/ $6cds3.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", role: role = "heading", ...props }, ref)=>{
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "dropdown-header");
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, bsPrefix),
        role: role,
        ...props
    });
});
$6c78f0285091f61a$var$DropdownHeader.displayName = "DropdownHeader";
var $6c78f0285091f61a$export$2e2bcd8739ae039 = $6c78f0285091f61a$var$DropdownHeader;




var $6cds3 = parcelRequire("6cds3");




"use client";
const $ed02e7bd45a91a27$var$DropdownItem = /*#__PURE__*/ $6cds3.forwardRef(({ bsPrefix: bsPrefix, className: className, eventKey: eventKey, disabled: disabled = false, onClick: onClick, active: active, as: Component = (0, $047dad24ed49ca20$export$2e2bcd8739ae039), ...props }, ref)=>{
    const prefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "dropdown-item");
    const [dropdownItemProps, meta] = (0, $c474c338622d9f76$export$522d7e1e4e0e22b2)({
        key: eventKey,
        href: props.href,
        disabled: disabled,
        onClick: onClick,
        active: active
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        ...props,
        ...dropdownItemProps,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, prefix, meta.isActive && "active", disabled && "disabled")
    });
});
$ed02e7bd45a91a27$var$DropdownItem.displayName = "DropdownItem";
var $ed02e7bd45a91a27$export$2e2bcd8739ae039 = $ed02e7bd45a91a27$var$DropdownItem;



var $6cds3 = parcelRequire("6cds3");



"use client";
const $1fbcb147a3bfd66a$var$DropdownItemText = /*#__PURE__*/ $6cds3.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "span", ...props }, ref)=>{
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "dropdown-item-text");
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, bsPrefix),
        ...props
    });
});
$1fbcb147a3bfd66a$var$DropdownItemText.displayName = "DropdownItemText";
var $1fbcb147a3bfd66a$export$2e2bcd8739ae039 = $1fbcb147a3bfd66a$var$DropdownItemText;




var $6cds3 = parcelRequire("6cds3");






var $6cds3 = parcelRequire("6cds3");
"use client";
const $5aa975014647668d$var$context = /*#__PURE__*/ $6cds3.createContext(null);
$5aa975014647668d$var$context.displayName = "InputGroupContext";
var $5aa975014647668d$export$2e2bcd8739ae039 = $5aa975014647668d$var$context;



var $6cds3 = parcelRequire("6cds3");
"use client";
// TODO: check
const $978fc16477bde29f$var$context = /*#__PURE__*/ $6cds3.createContext(null);
$978fc16477bde29f$var$context.displayName = "NavbarContext";
var $978fc16477bde29f$export$2e2bcd8739ae039 = $978fc16477bde29f$var$context;




parcelRequire("6cds3");

function $9e6b237fedb7e0e3$export$2e2bcd8739ae039(ref, componentName) {
    return ref;
}




"use client";
function $4027964e1c4c7475$export$a2c648e264f4a946(alignEnd, dropDirection, isRTL) {
    const topStart = isRTL ? "top-end" : "top-start";
    const topEnd = isRTL ? "top-start" : "top-end";
    const bottomStart = isRTL ? "bottom-end" : "bottom-start";
    const bottomEnd = isRTL ? "bottom-start" : "bottom-end";
    const leftStart = isRTL ? "right-start" : "left-start";
    const leftEnd = isRTL ? "right-end" : "left-end";
    const rightStart = isRTL ? "left-start" : "right-start";
    const rightEnd = isRTL ? "left-end" : "right-end";
    let placement = alignEnd ? bottomEnd : bottomStart;
    if (dropDirection === "up") placement = alignEnd ? topEnd : topStart;
    else if (dropDirection === "end") placement = alignEnd ? rightEnd : rightStart;
    else if (dropDirection === "start") placement = alignEnd ? leftEnd : leftStart;
    else if (dropDirection === "down-centered") placement = "bottom";
    else if (dropDirection === "up-centered") placement = "top";
    return placement;
}
const $4027964e1c4c7475$var$DropdownMenu = /*#__PURE__*/ $6cds3.forwardRef(({ bsPrefix: bsPrefix, className: className, align: align, rootCloseEvent: rootCloseEvent, flip: flip = true, show: showProps, renderOnMount: renderOnMount, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div", popperConfig: popperConfig, variant: variant, ...props }, ref)=>{
    let alignEnd = false;
    const isNavbar = (0, $6cds3.useContext)((0, $978fc16477bde29f$export$2e2bcd8739ae039));
    const prefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "dropdown-menu");
    const { align: contextAlign, drop: drop, isRTL: isRTL } = (0, $6cds3.useContext)((0, $f8b99613323254bf$export$2e2bcd8739ae039));
    align = align || contextAlign;
    const isInputGroup = (0, $6cds3.useContext)((0, $5aa975014647668d$export$2e2bcd8739ae039));
    const alignClasses = [];
    if (align) {
        if (typeof align === "object") {
            const keys = Object.keys(align);
            if (keys.length) {
                const brkPoint = keys[0];
                const direction = align[brkPoint];
                // .dropdown-menu-end is required for responsively aligning
                // left in addition to align left classes.
                alignEnd = direction === "start";
                alignClasses.push(`${prefix}-${brkPoint}-${direction}`);
            }
        } else if (align === "end") alignEnd = true;
    }
    const placement = $4027964e1c4c7475$export$a2c648e264f4a946(alignEnd, drop, isRTL);
    const [menuProps, { hasShown: hasShown, popper: popper, show: show, toggle: toggle }] = (0, $8db6e76678fd7810$export$133c4d08f3775d64)({
        flip: flip,
        rootCloseEvent: rootCloseEvent,
        show: showProps,
        usePopper: !isNavbar && alignClasses.length === 0,
        offset: [
            0,
            2
        ],
        popperConfig: popperConfig,
        placement: placement
    });
    menuProps.ref = (0, $2921c5d455351cc0$export$2e2bcd8739ae039)((0, $9e6b237fedb7e0e3$export$2e2bcd8739ae039)(ref, "DropdownMenu"), menuProps.ref);
    (0, $ac9facc4976791bd$export$2e2bcd8739ae039)(()=>{
        // Popper's initial position for the menu is incorrect when
        // renderOnMount=true. Need to call update() to correct it.
        if (show) popper == null || popper.update();
    }, [
        show
    ]);
    if (!hasShown && !renderOnMount && !isInputGroup) return null;
    // For custom components provide additional, non-DOM, props;
    if (typeof Component !== "string") {
        menuProps.show = show;
        menuProps.close = ()=>toggle == null ? void 0 : toggle(false);
        menuProps.align = align;
    }
    let style = props.style;
    if (popper != null && popper.placement) {
        // we don't need the default popper style,
        // menus are display: none when not shown.
        style = {
            ...props.style,
            ...menuProps.style
        };
        props["x-placement"] = popper.placement;
    }
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        ...props,
        ...menuProps,
        style: style,
        ...(alignClasses.length || isNavbar) && {
            "data-bs-popper": "static"
        },
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, prefix, show && "show", alignEnd && `${prefix}-end`, variant && `${prefix}-${variant}`, ...alignClasses)
    });
});
$4027964e1c4c7475$var$DropdownMenu.displayName = "DropdownMenu";
var $4027964e1c4c7475$export$2e2bcd8739ae039 = $4027964e1c4c7475$var$DropdownMenu;







var $6cds3 = parcelRequire("6cds3");




"use client";
const $fd798c397bbc61cc$var$DropdownToggle = /*#__PURE__*/ $6cds3.forwardRef(({ bsPrefix: bsPrefix, split: split, className: className, childBsPrefix: childBsPrefix, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = (0, $a73f5336dfd04f2d$export$2e2bcd8739ae039), ...props }, ref)=>{
    const prefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "dropdown-toggle");
    const dropdownContext = (0, $6cds3.useContext)((0, $2c7225bf1d745884$export$2e2bcd8739ae039));
    if (childBsPrefix !== undefined) props.bsPrefix = childBsPrefix;
    const [toggleProps] = (0, $2b9b2ada6a532f31$export$96df6c7c5036b9a2)();
    toggleProps.ref = (0, $2921c5d455351cc0$export$2e2bcd8739ae039)(toggleProps.ref, (0, $9e6b237fedb7e0e3$export$2e2bcd8739ae039)(ref, "DropdownToggle"));
    // This intentionally forwards size and variant (if set) to the
    // underlying component, to allow it to render size and style variants.
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, prefix, split && `${prefix}-split`, (dropdownContext == null ? void 0 : dropdownContext.show) && "show"),
        ...toggleProps,
        ...props
    });
});
$fd798c397bbc61cc$var$DropdownToggle.displayName = "DropdownToggle";
var $fd798c397bbc61cc$export$2e2bcd8739ae039 = $fd798c397bbc61cc$var$DropdownToggle;






"use client";
const $47cad3b7d9bae545$var$Dropdown = /*#__PURE__*/ $6cds3.forwardRef((pProps, ref)=>{
    const { bsPrefix: bsPrefix, drop: drop = "down", show: show, className: className, align: align = "start", onSelect: onSelect, onToggle: onToggle, focusFirstItemOnShow: focusFirstItemOnShow, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = "div", navbar: _4, autoClose: autoClose = true, ...props } = (0, $ebeccf058174fd37$export$2e2bcd8739ae039)(pProps, {
        show: "onToggle"
    });
    const isInputGroup = (0, $6cds3.useContext)((0, $5aa975014647668d$export$2e2bcd8739ae039));
    const prefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "dropdown");
    const isRTL = (0, $c5d3aca6e909caf5$export$35e511eefa30ac5a)();
    const isClosingPermitted = (source)=>{
        // autoClose=false only permits close on button click
        if (autoClose === false) return source === "click";
        // autoClose=inside doesn't permit close on rootClose
        if (autoClose === "inside") return source !== "rootClose";
        // autoClose=outside doesn't permit close on select
        if (autoClose === "outside") return source !== "select";
        return true;
    };
    const handleToggle = (0, $cfbeaaf7204fcb02$export$2e2bcd8739ae039)((nextShow, meta)=>{
        var _meta$originalEvent, _meta$originalEvent$t;
        /** Checking if target of event is ToggleButton,
     * if it is then nullify mousedown event
     */ const isToggleButton = (_meta$originalEvent = meta.originalEvent) == null ? void 0 : (_meta$originalEvent$t = _meta$originalEvent.target) == null ? void 0 : _meta$originalEvent$t.classList.contains("dropdown-toggle");
        if (isToggleButton && meta.source === "mousedown") return;
        if (meta.originalEvent.currentTarget === document && (meta.source !== "keydown" || meta.originalEvent.key === "Escape")) meta.source = "rootClose";
        if (isClosingPermitted(meta.source)) onToggle == null || onToggle(nextShow, meta);
    });
    const alignEnd = align === "end";
    const placement = (0, $4027964e1c4c7475$export$a2c648e264f4a946)(alignEnd, drop, isRTL);
    const contextValue = (0, $6cds3.useMemo)(()=>({
            align: align,
            drop: drop,
            isRTL: isRTL
        }), [
        align,
        drop,
        isRTL
    ]);
    const directionClasses = {
        down: prefix,
        "down-centered": `${prefix}-center`,
        up: "dropup",
        "up-centered": "dropup-center dropup",
        end: "dropend",
        start: "dropstart"
    };
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f8b99613323254bf$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $90176979a0004578$export$2e2bcd8739ae039), {
            placement: placement,
            show: show,
            onSelect: onSelect,
            onToggle: handleToggle,
            focusFirstItemOnShow: focusFirstItemOnShow,
            itemSelector: `.${prefix}-item:not(.disabled):not(:disabled)`,
            children: isInputGroup ? props.children : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
                ...props,
                ref: ref,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, show && "show", directionClasses[drop])
            })
        })
    });
});
$47cad3b7d9bae545$var$Dropdown.displayName = "Dropdown";
var $47cad3b7d9bae545$export$2e2bcd8739ae039 = Object.assign($47cad3b7d9bae545$var$Dropdown, {
    Toggle: (0, $fd798c397bbc61cc$export$2e2bcd8739ae039),
    Menu: (0, $4027964e1c4c7475$export$2e2bcd8739ae039),
    Item: (0, $ed02e7bd45a91a27$export$2e2bcd8739ae039),
    ItemText: (0, $1fbcb147a3bfd66a$export$2e2bcd8739ae039),
    Divider: (0, $da3bfc79083ad169$export$2e2bcd8739ae039),
    Header: (0, $6c78f0285091f61a$export$2e2bcd8739ae039)
});



function $5bf75ab82b3b05cf$var$ClaimRewards(props) {
    const { network: network, address: address, wallet: wallet, signingClient: signingClient, rewards: rewards } = props;
    async function claim() {
        props.setError();
        props.setLoading(true);
        const validatorRewards = mapRewards();
        const gasSimMessages = buildMessages(validatorRewards);
        let gas;
        try {
            gas = await signingClient.simulate(wallet.address, gasSimMessages);
        } catch (error) {
            props.setLoading(false);
            props.setError("Failed to broadcast: " + error.message);
            return;
        }
        const fee = signingClient.getFee(gas);
        const feeAmount = fee.amount[0].amount;
        const totalReward = validatorRewards.reduce((sum, validatorReward)=>(0, $ed89d4c20b089b73$export$e16d8520af44a096)(sum, (0, $ed89d4c20b089b73$export$8576f72eb7f14a7e)(validatorReward.reward)), 0);
        const adjustedValidatorRewards = validatorRewards.map((validatorReward)=>{
            const shareOfFee = (0, $ed89d4c20b089b73$export$2060d2db72cce88f)((0, $ed89d4c20b089b73$export$cd007d971a5a2143)((0, $ed89d4c20b089b73$export$8576f72eb7f14a7e)(validatorReward.reward), totalReward), feeAmount); // To take a proportional amount from each validator relative to total reward
            return {
                validatorAddress: validatorReward.validatorAddress,
                reward: (0, $ed89d4c20b089b73$export$4e2d2ead65e5f7e3)(validatorReward.reward, shareOfFee)
            };
        });
        if (!props.commission && (adjustedValidatorRewards.length < 1 || adjustedValidatorRewards.some((validatorReward)=>validatorReward.reward <= 0))) {
            props.setLoading(false);
            props.setError("Reward is too low");
            return;
        }
        let messages = buildMessages(adjustedValidatorRewards);
        try {
            gas = gas || await signingClient.simulate(wallet.address, messages);
        } catch (error) {
            props.setLoading(false);
            props.setError("Failed to broadcast: " + error.message);
            return;
        }
        console.log(messages, gas);
        const signAndBroadcast = signingClient.signAndBroadcastWithoutBalanceCheck;
        signAndBroadcast(wallet.address, messages, gas).then((result)=>{
            console.log("Successfully broadcasted:", result);
            props.setLoading(false);
            props.onClaimRewards(result);
        }, (error)=>{
            console.log("Failed to broadcast:", error);
            props.setLoading(false);
            props.setError("Failed to broadcast: " + error.message);
        });
    }
    function mapRewards() {
        if (!rewards) return [];
        const validatorRewards = rewards.map((reward)=>{
            return {
                validatorAddress: reward.validator_address,
                reward: (0, $2a6bf51ee962800d$export$31d336b0b7e2f20)(reward, network.denom)
            };
        }).filter((validatorReward)=>validatorReward.reward);
        return validatorRewards;
    }
    // Expects a map of string -> string (validator -> reward)
    function buildMessages(validatorRewards) {
        return validatorRewards.map((validatorReward)=>{
            let valMessages = [];
            if (props.restake) valMessages.push((0, $2a6bf51ee962800d$export$9df738dbed799d5)((0, $0000c3e2167efb84$exports.MsgDelegate), "/cosmos.staking.v1beta1.MsgDelegate", {
                delegatorAddress: address,
                validatorAddress: validatorReward.validatorAddress,
                amount: (0, $2a6bf51ee962800d$export$3c9d1e4131afeeb8)(validatorReward.reward, network.denom)
            }, (wallet === null || wallet === void 0 ? void 0 : wallet.address) !== address));
            else valMessages.push((0, $2a6bf51ee962800d$export$9df738dbed799d5)((0, $770beae6d633ee1a$exports.MsgWithdrawDelegatorReward), "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward", {
                delegatorAddress: address,
                validatorAddress: validatorReward.validatorAddress
            }, (wallet === null || wallet === void 0 ? void 0 : wallet.address) !== address));
            if (props.commission) valMessages.push((0, $2a6bf51ee962800d$export$9df738dbed799d5)((0, $770beae6d633ee1a$exports.MsgWithdrawValidatorCommission), "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission", {
                validatorAddress: validatorReward.validatorAddress
            }, (wallet === null || wallet === void 0 ? void 0 : wallet.address) !== address));
            if ((wallet === null || wallet === void 0 ? void 0 : wallet.address) !== address) return [
                (0, $2a6bf51ee962800d$export$61d88097eacac343)(wallet.address, valMessages)
            ];
            else return valMessages;
        }).flat();
    }
    function hasPermission() {
        const permissions = [];
        if (props.restake) permissions.push("Delegate");
        if (!props.restake) permissions.push("WithdrawDelegatorReward");
        if (props.commission) permissions.push("WithdrawValidatorCommission");
        return permissions.every((type)=>wallet === null || wallet === void 0 ? void 0 : wallet.hasPermission(address, type));
    }
    function buttonText() {
        if (props.buttonText) return props.buttonText;
        if (props.restake) return "Manual Compound";
        else if (props.commission) return "Claim Commission";
        else return "Claim Rewards";
    }
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: props.button ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a73f5336dfd04f2d$export$2e2bcd8739ae039), {
            variant: props.variant,
            size: props.size,
            disabled: props.disabled || !hasPermission(),
            onClick: ()=>claim(),
            children: buttonText()
        }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $47cad3b7d9bae545$export$2e2bcd8739ae039).Item, {
            as: "button",
            disabled: props.disabled || !hasPermission(),
            onClick: ()=>claim(),
            children: buttonText()
        })
    });
}
var $5bf75ab82b3b05cf$export$2e2bcd8739ae039 = $5bf75ab82b3b05cf$var$ClaimRewards;




var $6cds3 = parcelRequire("6cds3");


var $2KWqD = parcelRequire("2KWqD");

function $ed81bcc8e8ff6731$var$ValidatorImage(props) {
    const { validator: validator } = props;
    const className = props.className || "";
    const defaultSize = !props.width || props.width > 30 ? "lg" : "sm";
    const imageUrl = validator.mintscan_image || validator.keybase_image;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: imageUrl && imageUrl !== "" ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
            className: "rounded-circle border border-light " + className,
            width: props.width || 40,
            height: props.height || 40,
            src: imageUrl
        }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
            className: `btn-circle btn-circle-${defaultSize} text-center bg-light rounded-circle border border-light d-inline-block ` + className,
            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("i", {
                className: "bi bi-person-lines-fill"
            })
        })
    });
}
var $ed81bcc8e8ff6731$export$2e2bcd8739ae039 = $ed81bcc8e8ff6731$var$ValidatorImage;




function $d3d2619c03629196$var$ValidatorName(props) {
    var _validator_description;
    const { validator: validator, fallback: fallback } = props;
    if (!validator) return fallback || null;
    const moniker = ((_validator_description = validator.description) === null || _validator_description === void 0 ? void 0 : _validator_description.moniker) || validator.name || "Unknown";
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
        className: props.className,
        children: moniker
    });
}
var $d3d2619c03629196$export$2e2bcd8739ae039 = $d3d2619c03629196$var$ValidatorName;


function $92fd314e58b58199$var$ValidatorLink(props) {
    let validator = props.validator;
    if (!validator && props.operator) validator = props.operator;
    if (!validator) return props.fallback || null;
    const website = ()=>{
        let url = validator.description && validator.description.website;
        if (!url) return;
        return url.startsWith("http") ? url : "https://" + url;
    };
    if (!website()) return props.children || /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $d3d2619c03629196$export$2e2bcd8739ae039), {
        validator: validator
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
        href: website(),
        target: "_blank",
        rel: "noreferrer",
        className: [
            props.className,
            "text-reset text-decoration-none"
        ].join(" "),
        children: props.children || /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $d3d2619c03629196$export$2e2bcd8739ae039), {
            validator: validator
        })
    });
}
var $92fd314e58b58199$export$2e2bcd8739ae039 = $92fd314e58b58199$var$ValidatorLink;




var $6cds3 = parcelRequire("6cds3");


function $fefc374772824467$var$AboutLedger(props) {
    var _validator_restake;
    let [searchParams, setSearchParams] = (0, $0e36e707c39d0f3a$export$f1a78c17382fe22a)();
    const aboutParam = searchParams.get("about");
    const { network: network, validator: validator } = props;
    const { daemon_name: daemon_name, chain_id: chain_id, node_home: node_home, codebase: codebase } = network.chain;
    const { git_repo: git_repo, binaries: binaries } = codebase || {};
    const address = (validator === null || validator === void 0 ? void 0 : (_validator_restake = validator.restake) === null || _validator_restake === void 0 ? void 0 : _validator_restake.address) || /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("kbd", {
        children: "GrantAddress"
    });
    const show = props.show || aboutParam == "ledger" && network.authzSupport;
    (0, $6cds3.useEffect)(()=>{
        if (show && !aboutParam) setSearchParams({
            about: "ledger"
        });
    }, [
        show,
        aboutParam
    ]);
    function onHide() {
        setSearchParams({});
        props.onHide();
    }
    const content = /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("h5", {
                children: [
                    "How to use a Ledger with ",
                    validator ? validator.moniker : "REStake"
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                children: [
                    "Right now there is a limitation in Cosmos SDK which prevents using a Ledger device with the REStake UI. It is possible though to send a slightly modified version of the grants using the ",
                    network.prettyName,
                    " CLI client."
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                children: [
                    "The commands needed are detailed below thanks to the awesome ",
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                        href: "https://twitter.com/gjermundbjaanes",
                        target: "_blank",
                        children: "@gjermundbjaanes"
                    }),
                    " who put together ",
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                        href: "https://gjermund.tech/blog/making-ledger-work-on-restake/",
                        target: "_blank",
                        children: "a more detailed guide and CLI tool"
                    }),
                    " to make the process easier."
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                children: [
                    !validator ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("span", {
                        children: [
                            "You can find ",
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                                children: "validator specific instructions"
                            }),
                            " in a tab on the validator's page, with their REStake address pre-filled."
                        ]
                    }) : `${validator.moniker}'s REStake address has been pre-filled below.`,
                    " Instructions are specific to the Network you have selected."
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                    children: "You should only attempt this if you have a basic understanding of using a command line tool."
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("h5", {
                children: [
                    "Download CLI client for ",
                    network.prettyName
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                children: [
                    "Skip this step if you've already installed ",
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("code", {
                        children: daemon_name || network.prettyName
                    }),
                    "."
                ]
            }),
            binaries && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h6", {
                        children: "Install from pre-built binaries"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                        children: "Download one of the pre-built binaries and use that instead of building from source."
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                        children: [
                            "The binary ",
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                                children: "may not have been built with ledger support"
                            }),
                            " so you might still need the source method."
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                        children: Object.entries(binaries).map(([key, item])=>{
                            return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("strong", {
                                        children: [
                                            key,
                                            ":"
                                        ]
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                                        href: item,
                                        target: "_blank",
                                        children: item
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {})
                                ]
                            }, key);
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h6", {
                        children: "Alternative install from source"
                    })
                ]
            }),
            git_repo ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                        children: [
                            "Clone and install the ",
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("code", {
                                children: daemon_name || network.prettyName
                            }),
                            " CLI client from ",
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                                href: git_repo,
                                target: "_blank",
                                children: git_repo
                            }),
                            ". The standard Tendermint installation process is detailed below, but you might need to check the documentation for project specific install."
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("pre", {
                        className: "pre-scrollable text-wrap",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("code", {
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                                    children: [
                                        "git clone ",
                                        git_repo,
                                        " restake_",
                                        network.name
                                    ]
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                                    children: [
                                        "cd restake_",
                                        network.name
                                    ]
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                    children: "make install"
                                })
                            ]
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                children: [
                    "Download and install the ",
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("code", {
                        children: daemon_name || network.prettyName
                    }),
                    " CLI client from the project's documentation."
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h5", {
                children: "Add Ledger as a key"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                children: [
                    "Skip this step if you already have your ledger setup with ",
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("code", {
                        children: daemon_name || network.prettyName
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                children: [
                    "Add your Ledger as a new key. The below example will use the key name ",
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("kbd", {
                        children: "ledger"
                    }),
                    " and the default install directory",
                    node_home ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                        children: [
                            "(",
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("code", {
                                children: node_home
                            }),
                            ")"
                        ]
                    }) : "",
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                children: "Make sure your Ledger is plugged in, unlocked and the Cosmos app is open."
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("pre", {
                className: "text-wrap",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("code", {
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                        children: [
                            daemon_name ? daemon_name : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("kbd", {
                                children: "DaemonName"
                            }),
                            " keys add ",
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("kbd", {
                                children: "ledger"
                            }),
                            " --ledger --keyring-backend file"
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h5", {
                children: "Grant permission to delegate rewards"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                children: [
                    "Finally you need to grant the final permission to allow the validator to send ",
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("code", {
                        children: "Delegate"
                    }),
                    " messages. This is different to the REStake UI which also limits the validator address the address can delegate to. The REStake script will handle this difference and it doesn't present much of a security problem."
                ]
            }),
            !validator && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                children: [
                    "Make sure you enter your validator's REStake address in place of ",
                    address,
                    ". You can find instructions in a tab on the validator's page with their address pre-filled."
                ]
            }),
            validator && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                children: [
                    validator.moniker,
                    "'s REStake address has been pre-filled below (",
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("code", {
                        children: address
                    }),
                    ")."
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("pre", {
                className: "text-wrap",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("code", {
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                        children: [
                            daemon_name ? daemon_name : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("kbd", {
                                children: "DaemonName"
                            }),
                            " tx authz grant ",
                            address,
                            " generic --msg-type /cosmos.staking.v1beta1.MsgDelegate --from ",
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("kbd", {
                                children: "ledger"
                            }),
                            " --ledger --chain-id ",
                            chain_id,
                            " --node https://rpc.cosmos.directory:443/",
                            network.name,
                            " --keyring-backend file --gas auto --gas-prices ",
                            network.gasPrice,
                            " --gas-adjustment 1.5"
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                children: [
                    "REStake previously required a ",
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("code", {
                        children: "Withdraw"
                    }),
                    " grant however this is no longer necessary."
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h5", {
                children: "Fin."
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                children: [
                    "That's it! ",
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                        children: "So long as you have an active delegation with them,"
                    }),
                    " your validator should now pick up your ledger's address as a valid REStake user if they're running the latest version. If you don't see the restaking happening, reach out to them to update."
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                children: "The UI will show the current state of your grant with the validator, you just won't be able to revoke."
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                children: "We will make sure the UI supports these grant types once Ledger integration is possible."
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                children: [
                    "For more detailed instructions check out ",
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                        href: "https://twitter.com/gjermundbjaanes",
                        target: "_blank",
                        children: "@gjermundbjaanes"
                    }),
                    "'s awesome ",
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                        href: "https://gjermund.tech/blog/making-ledger-work-on-restake/",
                        target: "_blank",
                        children: "guide and helper tool"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("hr", {}),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h5", {
                children: "Revoke permissions"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                children: "Revoking the grants is just another command. You need to revoke each permission individually."
            }),
            !validator && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                children: [
                    "Make sure you enter your validator's REStake address in place of ",
                    address,
                    ". You can find instructions in a tab on the validator's page with their address pre-filled."
                ]
            }),
            validator && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                children: [
                    validator.moniker,
                    "'s REStake address has been pre-filled below (",
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("code", {
                        children: address
                    }),
                    ")."
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("pre", {
                className: "text-wrap",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("code", {
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                        children: [
                            daemon_name ? daemon_name : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("kbd", {
                                children: "DaemonName"
                            }),
                            " tx authz revoke ",
                            address,
                            " /cosmos.staking.v1beta1.MsgDelegate --from ",
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("kbd", {
                                children: "ledger"
                            }),
                            " --ledger --chain-id ",
                            chain_id,
                            " --node https://rpc.cosmos.directory:443/",
                            network.name,
                            " --keyring-backend file --gas auto --gas-prices ",
                            network.gasPrice,
                            " --gas-adjustment 1.5"
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                children: [
                    "If you have previously granted ",
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("code", {
                        children: "Withdraw"
                    }),
                    " permissions, these are no longer required and can be safely removed."
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("pre", {
                className: "text-wrap",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("code", {
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                        children: [
                            daemon_name ? daemon_name : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("kbd", {
                                children: "DaemonName"
                            }),
                            " tx authz revoke ",
                            address,
                            " /cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward --from ",
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("kbd", {
                                children: "ledger"
                            }),
                            " --ledger --chain-id ",
                            chain_id,
                            " --node https://rpc.cosmos.directory:443/",
                            network.name,
                            " --keyring-backend file --gas auto --gas-prices ",
                            network.gasPrice,
                            " --gas-adjustment 1.5"
                        ]
                    })
                })
            })
        ]
    });
    if (props.modal === false) return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
        className: "small",
        children: content
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $3485727b0a1e4042$export$2e2bcd8739ae039), {
            size: "lg",
            show: show,
            onHide: ()=>onHide(),
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $3485727b0a1e4042$export$2e2bcd8739ae039).Header, {
                    closeButton: true,
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $3485727b0a1e4042$export$2e2bcd8739ae039).Title, {
                        children: "Ledger"
                    })
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $3485727b0a1e4042$export$2e2bcd8739ae039).Body, {
                    className: "small",
                    children: content
                })
            ]
        })
    });
}
var $fefc374772824467$export$2e2bcd8739ae039 = $fefc374772824467$var$AboutLedger;



var $aMJGV = parcelRequire("aMJGV");
parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");



var $6cds3 = parcelRequire("6cds3");
const $616d6f6e71c91894$var$TabContext = /*#__PURE__*/ $6cds3.createContext(null);
var $616d6f6e71c91894$export$2e2bcd8739ae039 = $616d6f6e71c91894$var$TabContext;




var $6cds3 = parcelRequire("6cds3");




const $a539e81cf9332719$var$_excluded = [
    "active",
    "eventKey",
    "mountOnEnter",
    "transition",
    "unmountOnExit",
    "role",
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited"
], $a539e81cf9332719$var$_excluded2 = [
    "activeKey",
    "getControlledId",
    "getControllerId"
], $a539e81cf9332719$var$_excluded3 = [
    "as"
];
function $a539e81cf9332719$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $a539e81cf9332719$export$fae0121b5afe572d(_ref) {
    let { active: active, eventKey: eventKey, mountOnEnter: mountOnEnter, transition: transition, unmountOnExit: unmountOnExit, role: role = "tabpanel", onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited } = _ref, props = $a539e81cf9332719$var$_objectWithoutPropertiesLoose(_ref, $a539e81cf9332719$var$_excluded);
    const context = (0, $6cds3.useContext)((0, $616d6f6e71c91894$export$2e2bcd8739ae039));
    if (!context) return [
        Object.assign({}, props, {
            role: role
        }),
        {
            eventKey: eventKey,
            isActive: active,
            mountOnEnter: mountOnEnter,
            transition: transition,
            unmountOnExit: unmountOnExit,
            onEnter: onEnter,
            onEntering: onEntering,
            onEntered: onEntered,
            onExit: onExit,
            onExiting: onExiting,
            onExited: onExited
        }
    ];
    const { activeKey: activeKey, getControlledId: getControlledId, getControllerId: getControllerId } = context, rest = $a539e81cf9332719$var$_objectWithoutPropertiesLoose(context, $a539e81cf9332719$var$_excluded2);
    const key = (0, $a140b6f07d6ac44a$export$eef49b42fde998a3)(eventKey);
    return [
        Object.assign({}, props, {
            role: role,
            id: getControlledId(eventKey),
            "aria-labelledby": getControllerId(eventKey)
        }),
        {
            eventKey: eventKey,
            isActive: active == null && key != null ? (0, $a140b6f07d6ac44a$export$eef49b42fde998a3)(activeKey) === key : active,
            transition: transition || rest.transition,
            mountOnEnter: mountOnEnter != null ? mountOnEnter : rest.mountOnEnter,
            unmountOnExit: unmountOnExit != null ? unmountOnExit : rest.unmountOnExit,
            onEnter: onEnter,
            onEntering: onEntering,
            onEntered: onEntered,
            onExit: onExit,
            onExiting: onExiting,
            onExited: onExited
        }
    ];
}
const $a539e81cf9332719$var$TabPanel = /*#__PURE__*/ $6cds3.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(_ref2, ref)=>{
    let { as: Component = "div" } = _ref2, props = $a539e81cf9332719$var$_objectWithoutPropertiesLoose(_ref2, $a539e81cf9332719$var$_excluded3);
    const [tabPanelProps, { isActive: isActive, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit, transition: Transition = (0, $dcc4effa3b2c68e8$export$2e2bcd8739ae039) }] = $a539e81cf9332719$export$fae0121b5afe572d(props);
    // We provide an empty the TabContext so `<Nav>`s in `<TabPanel>`s don't
    // conflict with the top level one.
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $616d6f6e71c91894$export$2e2bcd8739ae039).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a140b6f07d6ac44a$export$2e2bcd8739ae039).Provider, {
            value: null,
            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Transition, {
                in: isActive,
                onEnter: onEnter,
                onEntering: onEntering,
                onEntered: onEntered,
                onExit: onExit,
                onExiting: onExiting,
                onExited: onExited,
                mountOnEnter: mountOnEnter,
                unmountOnExit: unmountOnExit,
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, Object.assign({}, tabPanelProps, {
                    ref: ref,
                    hidden: !isActive,
                    "aria-hidden": !isActive
                }))
            })
        })
    });
});
$a539e81cf9332719$var$TabPanel.displayName = "TabPanel";
var $a539e81cf9332719$export$2e2bcd8739ae039 = $a539e81cf9332719$var$TabPanel;



const $d83dc0bec5efc430$var$Tabs = (props)=>{
    const { id: userId, generateChildId: generateCustomChildId, onSelect: propsOnSelect, activeKey: propsActiveKey, defaultActiveKey: defaultActiveKey, transition: transition, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit, children: children } = props;
    const [activeKey, onSelect] = (0, $69251a9c8fba185a$export$2ee51287a16ca325)(propsActiveKey, defaultActiveKey, propsOnSelect);
    const id = (0, $2714160d09cd0aeb$export$619500959fc48b26)(userId);
    const generateChildId = (0, $6cds3.useMemo)(()=>generateCustomChildId || ((key, type)=>id ? `${id}-${type}-${key}` : null), [
        id,
        generateCustomChildId
    ]);
    const tabContext = (0, $6cds3.useMemo)(()=>({
            onSelect: onSelect,
            activeKey: activeKey,
            transition: transition,
            mountOnEnter: mountOnEnter || false,
            unmountOnExit: unmountOnExit || false,
            getControlledId: (key)=>generateChildId(key, "tabpane"),
            getControllerId: (key)=>generateChildId(key, "tab")
        }), [
        onSelect,
        activeKey,
        transition,
        mountOnEnter,
        unmountOnExit,
        generateChildId
    ]);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $616d6f6e71c91894$export$2e2bcd8739ae039).Provider, {
        value: tabContext,
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a140b6f07d6ac44a$export$2e2bcd8739ae039).Provider, {
            value: onSelect || null,
            children: children
        })
    });
};
$d83dc0bec5efc430$var$Tabs.Panel = (0, $a539e81cf9332719$export$2e2bcd8739ae039);
var $d83dc0bec5efc430$export$2e2bcd8739ae039 = $d83dc0bec5efc430$var$Tabs;




function $82378ca700dec06c$export$2e2bcd8739ae039(transition) {
    if (typeof transition === "boolean") return transition ? (0, $9d1648789ad43db2$export$2e2bcd8739ae039) : (0, $dcc4effa3b2c68e8$export$2e2bcd8739ae039);
    return transition;
}



const $e61ff0d402b7eccf$var$TabContainer = ({ transition: transition, ...props })=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $d83dc0bec5efc430$export$2e2bcd8739ae039), {
        ...props,
        transition: (0, $82378ca700dec06c$export$2e2bcd8739ae039)(transition)
    });
$e61ff0d402b7eccf$var$TabContainer.displayName = "TabContainer";
var $e61ff0d402b7eccf$export$2e2bcd8739ae039 = $e61ff0d402b7eccf$var$TabContainer;



var $6cds3 = parcelRequire("6cds3");



"use client";
const $61f90cee8e2555a2$var$TabContent = /*#__PURE__*/ $6cds3.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", ...props }, ref)=>{
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "tab-content");
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, bsPrefix),
        ...props
    });
});
$61f90cee8e2555a2$var$TabContent.displayName = "TabContent";
var $61f90cee8e2555a2$export$2e2bcd8739ae039 = $61f90cee8e2555a2$var$TabContent;




var $6cds3 = parcelRequire("6cds3");







"use client";
const $f2010f18f0b3857e$var$TabPane = /*#__PURE__*/ $6cds3.forwardRef(({ bsPrefix: bsPrefix, transition: transition, ...props }, ref)=>{
    const [{ className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = "div", ...rest }, { isActive: isActive, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit, transition: Transition = (0, $9d1648789ad43db2$export$2e2bcd8739ae039) }] = (0, $a539e81cf9332719$export$fae0121b5afe572d)({
        ...props,
        transition: (0, $82378ca700dec06c$export$2e2bcd8739ae039)(transition)
    });
    const prefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "tab-pane");
    // We provide an empty the TabContext so `<Nav>`s in `<TabPanel>`s don't
    // conflict with the top level one.
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $616d6f6e71c91894$export$2e2bcd8739ae039).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a140b6f07d6ac44a$export$2e2bcd8739ae039).Provider, {
            value: null,
            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Transition, {
                in: isActive,
                onEnter: onEnter,
                onEntering: onEntering,
                onEntered: onEntered,
                onExit: onExit,
                onExiting: onExiting,
                onExited: onExited,
                mountOnEnter: mountOnEnter,
                unmountOnExit: unmountOnExit,
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
                    ...rest,
                    ref: ref,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, prefix, isActive && "active")
                })
            })
        })
    });
});
$f2010f18f0b3857e$var$TabPane.displayName = "TabPane";
var $f2010f18f0b3857e$export$2e2bcd8739ae039 = $f2010f18f0b3857e$var$TabPane;


/* eslint-disable react/no-unused-prop-types */ const $bf31903d44b6b079$var$propTypes = {
    eventKey: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).number
    ]),
    /**
   * Content for the tab title.
   */ title: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).node.isRequired,
    /**
   * The disabled state of the tab.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).bool,
    /**
   * Class to pass to the underlying nav link.
   */ tabClassName: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
    /**
   * Object containing attributes to pass to underlying nav link.
   */ tabAttrs: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).object
};
const $bf31903d44b6b079$var$Tab = ()=>{
    throw new Error("ReactBootstrap: The `Tab` component is not meant to be rendered! It's an abstract component that is only valid as a direct Child of the `Tabs` Component. For custom tabs components use TabPane and TabsContainer directly");
};
$bf31903d44b6b079$var$Tab.propTypes = $bf31903d44b6b079$var$propTypes;
var $bf31903d44b6b079$export$2e2bcd8739ae039 = Object.assign($bf31903d44b6b079$var$Tab, {
    Container: (0, $e61ff0d402b7eccf$export$2e2bcd8739ae039),
    Content: (0, $61f90cee8e2555a2$export$2e2bcd8739ae039),
    Pane: (0, $f2010f18f0b3857e$export$2e2bcd8739ae039)
});


var $c8d7a9d381e759df$exports = {};
"use strict";
Object.defineProperty($c8d7a9d381e759df$exports, "__esModule", {
    value: true
});
$c8d7a9d381e759df$exports.default = $c8d7a9d381e759df$var$all;
var $b3106624178a9c21$exports = {};
"use strict";
Object.defineProperty($b3106624178a9c21$exports, "__esModule", {
    value: true
});
$b3106624178a9c21$exports.default = $b3106624178a9c21$var$createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */ // Mostly taken from ReactPropTypes.
function $b3106624178a9c21$var$createChainableTypeChecker(validate) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        var componentNameSafe = componentName || "<<anonymous>>";
        var propFullNameSafe = propFullName || propName;
        if (props[propName] == null) {
            if (isRequired) return new Error("Required " + location + " `" + propFullNameSafe + "` was not specified " + ("in `" + componentNameSafe + "`."));
            return null;
        }
        for(var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++)args[_key - 6] = arguments[_key];
        return validate.apply(undefined, [
            props,
            propName,
            componentNameSafe,
            location,
            propFullNameSafe
        ].concat(args));
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
}
$b3106624178a9c21$exports = $b3106624178a9c21$exports["default"];


var $c8d7a9d381e759df$var$_createChainableTypeChecker2 = $c8d7a9d381e759df$var$_interopRequireDefault($b3106624178a9c21$exports);
function $c8d7a9d381e759df$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c8d7a9d381e759df$var$all() {
    for(var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++)validators[_key] = arguments[_key];
    function allPropTypes() {
        for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var error = null;
        validators.forEach(function(validator) {
            if (error != null) return;
            var result = validator.apply(undefined, args);
            if (result != null) error = result;
        });
        return error;
    }
    return (0, $c8d7a9d381e759df$var$_createChainableTypeChecker2.default)(allPropTypes);
}
$c8d7a9d381e759df$exports = $c8d7a9d381e759df$exports["default"];



var $6cds3 = parcelRequire("6cds3");



var $6cds3 = parcelRequire("6cds3");







var $6cds3 = parcelRequire("6cds3");







const $645ac68959354b01$var$_excluded = [
    "as",
    "active",
    "eventKey"
];
function $645ac68959354b01$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $645ac68959354b01$export$d7a68693710982a({ key: key, onClick: onClick, active: active, id: id, role: role, disabled: disabled }) {
    const parentOnSelect = (0, $6cds3.useContext)((0, $a140b6f07d6ac44a$export$2e2bcd8739ae039));
    const navContext = (0, $6cds3.useContext)((0, $8b39ba1004e4380e$export$2e2bcd8739ae039));
    const tabContext = (0, $6cds3.useContext)((0, $616d6f6e71c91894$export$2e2bcd8739ae039));
    let isActive = active;
    const props = {
        role: role
    };
    if (navContext) {
        if (!role && navContext.role === "tablist") props.role = "tab";
        const contextControllerId = navContext.getControllerId(key != null ? key : null);
        const contextControlledId = navContext.getControlledId(key != null ? key : null);
        // @ts-ignore
        props[(0, $6e6a9ad066805249$export$5cc3b7b83e34ade7)("event-key")] = key;
        props.id = contextControllerId || id;
        isActive = active == null && key != null ? navContext.activeKey === key : active;
        /**
     * Simplified scenario for `mountOnEnter`.
     *
     * While it would make sense to keep 'aria-controls' for tabs that have been mounted at least
     * once, it would also complicate the code quite a bit, for very little gain.
     * The following implementation is probably good enough.
     *
     * @see https://github.com/react-restart/ui/pull/40#issuecomment-1009971561
     */ if (isActive || !(tabContext != null && tabContext.unmountOnExit) && !(tabContext != null && tabContext.mountOnEnter)) props["aria-controls"] = contextControlledId;
    }
    if (props.role === "tab") {
        props["aria-selected"] = isActive;
        if (!isActive) props.tabIndex = -1;
        if (disabled) {
            props.tabIndex = -1;
            props["aria-disabled"] = true;
        }
    }
    props.onClick = (0, $cfbeaaf7204fcb02$export$2e2bcd8739ae039)((e)=>{
        if (disabled) return;
        onClick == null || onClick(e);
        if (key == null) return;
        if (parentOnSelect && !e.isPropagationStopped()) parentOnSelect(key, e);
    });
    return [
        props,
        {
            isActive: isActive
        }
    ];
}
const $645ac68959354b01$var$NavItem = /*#__PURE__*/ $6cds3.forwardRef((_ref, ref)=>{
    let { as: Component = (0, $79267241913a4681$export$2e2bcd8739ae039), active: active, eventKey: eventKey } = _ref, options = $645ac68959354b01$var$_objectWithoutPropertiesLoose(_ref, $645ac68959354b01$var$_excluded);
    const [props, meta] = $645ac68959354b01$export$d7a68693710982a(Object.assign({
        key: (0, $a140b6f07d6ac44a$export$eef49b42fde998a3)(eventKey, options.href),
        active: active
    }, options));
    // @ts-ignore
    props[(0, $6e6a9ad066805249$export$5cc3b7b83e34ade7)("active")] = meta.isActive;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, Object.assign({}, options, props, {
        ref: ref
    }));
});
$645ac68959354b01$var$NavItem.displayName = "NavItem";
var $645ac68959354b01$export$2e2bcd8739ae039 = $645ac68959354b01$var$NavItem;



const $86c5c3a07030ba43$var$_excluded = [
    "as",
    "onSelect",
    "activeKey",
    "role",
    "onKeyDown"
];
function $86c5c3a07030ba43$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $86c5c3a07030ba43$var$noop = ()=>{};
const $86c5c3a07030ba43$var$EVENT_KEY_ATTR = (0, $6e6a9ad066805249$export$5cc3b7b83e34ade7)("event-key");
const $86c5c3a07030ba43$var$Nav = /*#__PURE__*/ $6cds3.forwardRef((_ref, ref)=>{
    let { // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = "div", onSelect: onSelect, activeKey: activeKey, role: role, onKeyDown: onKeyDown } = _ref, props = $86c5c3a07030ba43$var$_objectWithoutPropertiesLoose(_ref, $86c5c3a07030ba43$var$_excluded);
    // A ref and forceUpdate for refocus, b/c we only want to trigger when needed
    // and don't want to reset the set in the effect
    const forceUpdate = (0, $6f65c8e52908cbfc$export$2e2bcd8739ae039)();
    const needsRefocusRef = (0, $6cds3.useRef)(false);
    const parentOnSelect = (0, $6cds3.useContext)((0, $a140b6f07d6ac44a$export$2e2bcd8739ae039));
    const tabContext = (0, $6cds3.useContext)((0, $616d6f6e71c91894$export$2e2bcd8739ae039));
    let getControlledId, getControllerId;
    if (tabContext) {
        role = role || "tablist";
        activeKey = tabContext.activeKey;
        // TODO: do we need to duplicate these?
        getControlledId = tabContext.getControlledId;
        getControllerId = tabContext.getControllerId;
    }
    const listNode = (0, $6cds3.useRef)(null);
    const getNextActiveTab = (offset)=>{
        const currentListNode = listNode.current;
        if (!currentListNode) return null;
        const items = (0, $557b64d4dca42129$export$2e2bcd8739ae039)(currentListNode, `[${$86c5c3a07030ba43$var$EVENT_KEY_ATTR}]:not([aria-disabled=true])`);
        const activeChild = currentListNode.querySelector("[aria-selected=true]");
        if (!activeChild || activeChild !== document.activeElement) return null;
        const index = items.indexOf(activeChild);
        if (index === -1) return null;
        let nextIndex = index + offset;
        if (nextIndex >= items.length) nextIndex = 0;
        if (nextIndex < 0) nextIndex = items.length - 1;
        return items[nextIndex];
    };
    const handleSelect = (key, event)=>{
        if (key == null) return;
        onSelect == null || onSelect(key, event);
        parentOnSelect == null || parentOnSelect(key, event);
    };
    const handleKeyDown = (event)=>{
        onKeyDown == null || onKeyDown(event);
        if (!tabContext) return;
        let nextActiveChild;
        switch(event.key){
            case "ArrowLeft":
            case "ArrowUp":
                nextActiveChild = getNextActiveTab(-1);
                break;
            case "ArrowRight":
            case "ArrowDown":
                nextActiveChild = getNextActiveTab(1);
                break;
            default:
                return;
        }
        if (!nextActiveChild) return;
        event.preventDefault();
        handleSelect(nextActiveChild.dataset[(0, $6e6a9ad066805249$export$7776c0a7cd2eb3e0)("EventKey")] || null, event);
        needsRefocusRef.current = true;
        forceUpdate();
    };
    (0, $6cds3.useEffect)(()=>{
        if (listNode.current && needsRefocusRef.current) {
            const activeChild = listNode.current.querySelector(`[${$86c5c3a07030ba43$var$EVENT_KEY_ATTR}][aria-selected=true]`);
            activeChild == null || activeChild.focus();
        }
        needsRefocusRef.current = false;
    });
    const mergedRef = (0, $2921c5d455351cc0$export$2e2bcd8739ae039)(ref, listNode);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a140b6f07d6ac44a$export$2e2bcd8739ae039).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8b39ba1004e4380e$export$2e2bcd8739ae039).Provider, {
            value: {
                role: role,
                // used by NavLink to determine it's role
                activeKey: (0, $a140b6f07d6ac44a$export$eef49b42fde998a3)(activeKey),
                getControlledId: getControlledId || $86c5c3a07030ba43$var$noop,
                getControllerId: getControllerId || $86c5c3a07030ba43$var$noop
            },
            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, Object.assign({}, props, {
                onKeyDown: handleKeyDown,
                ref: mergedRef,
                role: role
            }))
        })
    });
});
$86c5c3a07030ba43$var$Nav.displayName = "Nav";
var $86c5c3a07030ba43$export$2e2bcd8739ae039 = Object.assign($86c5c3a07030ba43$var$Nav, {
    Item: (0, $645ac68959354b01$export$2e2bcd8739ae039)
});





var $6cds3 = parcelRequire("6cds3");
"use client";
const $5ff0b908721f444d$var$context = /*#__PURE__*/ $6cds3.createContext(null);
$5ff0b908721f444d$var$context.displayName = "CardHeaderContext";
var $5ff0b908721f444d$export$2e2bcd8739ae039 = $5ff0b908721f444d$var$context;



var $6cds3 = parcelRequire("6cds3");



"use client";
const $a8bf266d3383cc0e$var$NavItem = /*#__PURE__*/ $6cds3.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", ...props }, ref)=>{
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "nav-item");
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, bsPrefix),
        ...props
    });
});
$a8bf266d3383cc0e$var$NavItem.displayName = "NavItem";
var $a8bf266d3383cc0e$export$2e2bcd8739ae039 = $a8bf266d3383cc0e$var$NavItem;




var $6cds3 = parcelRequire("6cds3");





"use client";
const $a5218c3e3d2db8e1$var$NavLink = /*#__PURE__*/ $6cds3.forwardRef(({ bsPrefix: bsPrefix, className: className, as: Component = (0, $047dad24ed49ca20$export$2e2bcd8739ae039), active: active, eventKey: eventKey, disabled: disabled = false, ...props }, ref)=>{
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "nav-link");
    const [navItemProps, meta] = (0, $645ac68959354b01$export$d7a68693710982a)({
        key: (0, $a140b6f07d6ac44a$export$eef49b42fde998a3)(eventKey, props.href),
        active: active,
        disabled: disabled,
        ...props
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        ...props,
        ...navItemProps,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, bsPrefix, disabled && "disabled", meta.isActive && "active")
    });
});
$a5218c3e3d2db8e1$var$NavLink.displayName = "NavLink";
var $a5218c3e3d2db8e1$export$2e2bcd8739ae039 = $a5218c3e3d2db8e1$var$NavLink;



"use client";
const $85f5d0e6280a2ccf$var$Nav = /*#__PURE__*/ $6cds3.forwardRef((uncontrolledProps, ref)=>{
    const { as: as = "div", bsPrefix: initialBsPrefix, variant: variant, fill: fill = false, justify: justify = false, navbar: navbar, navbarScroll: navbarScroll, className: className, activeKey: activeKey, ...props } = (0, $ebeccf058174fd37$export$2e2bcd8739ae039)(uncontrolledProps, {
        activeKey: "onSelect"
    });
    const bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(initialBsPrefix, "nav");
    let navbarBsPrefix;
    let cardHeaderBsPrefix;
    let isNavbar = false;
    const navbarContext = (0, $6cds3.useContext)((0, $978fc16477bde29f$export$2e2bcd8739ae039));
    const cardHeaderContext = (0, $6cds3.useContext)((0, $5ff0b908721f444d$export$2e2bcd8739ae039));
    if (navbarContext) {
        navbarBsPrefix = navbarContext.bsPrefix;
        isNavbar = navbar == null ? true : navbar;
    } else if (cardHeaderContext) ({ cardHeaderBsPrefix: cardHeaderBsPrefix } = cardHeaderContext);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $86c5c3a07030ba43$export$2e2bcd8739ae039), {
        as: as,
        ref: ref,
        activeKey: activeKey,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, {
            [bsPrefix]: !isNavbar,
            [`${navbarBsPrefix}-nav`]: isNavbar,
            [`${navbarBsPrefix}-nav-scroll`]: isNavbar && navbarScroll,
            [`${cardHeaderBsPrefix}-${variant}`]: !!cardHeaderBsPrefix,
            [`${bsPrefix}-${variant}`]: !!variant,
            [`${bsPrefix}-fill`]: fill,
            [`${bsPrefix}-justified`]: justify
        }),
        ...props
    });
});
$85f5d0e6280a2ccf$var$Nav.displayName = "Nav";
var $85f5d0e6280a2ccf$export$2e2bcd8739ae039 = Object.assign($85f5d0e6280a2ccf$var$Nav, {
    Item: (0, $a8bf266d3383cc0e$export$2e2bcd8739ae039),
    Link: (0, $a5218c3e3d2db8e1$export$2e2bcd8739ae039)
});




var $6cds3 = parcelRequire("6cds3");


var $2KWqD = parcelRequire("2KWqD");


var $6cds3 = parcelRequire("6cds3");


"use client";
const $36688d56d3c1862c$var$Table = /*#__PURE__*/ $6cds3.forwardRef(({ bsPrefix: bsPrefix, className: className, striped: striped, bordered: bordered, borderless: borderless, hover: hover, size: size, variant: variant, responsive: responsive, ...props }, ref)=>{
    const decoratedBsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "table");
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, decoratedBsPrefix, variant && `${decoratedBsPrefix}-${variant}`, size && `${decoratedBsPrefix}-${size}`, striped && `${decoratedBsPrefix}-${typeof striped === "string" ? `striped-${striped}` : "striped"}`, bordered && `${decoratedBsPrefix}-bordered`, borderless && `${decoratedBsPrefix}-borderless`, hover && `${decoratedBsPrefix}-hover`);
    const table = /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("table", {
        ...props,
        className: classes,
        ref: ref
    });
    if (responsive) {
        let responsiveClass = `${decoratedBsPrefix}-responsive`;
        if (typeof responsive === "string") responsiveClass = `${responsiveClass}-${responsive}`;
        return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
            className: responsiveClass,
            children: table
        });
    }
    return table;
});
var $36688d56d3c1862c$export$2e2bcd8739ae039 = $36688d56d3c1862c$var$Table;



var $6cds3 = parcelRequire("6cds3");


"use client";
const $39ebe134e7977f3e$var$Spinner = /*#__PURE__*/ $6cds3.forwardRef(({ bsPrefix: bsPrefix, variant: variant, animation: animation = "border", size: size, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div", className: className, ...props }, ref)=>{
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "spinner");
    const bsSpinnerPrefix = `${bsPrefix}-${animation}`;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, bsSpinnerPrefix, size && `${bsSpinnerPrefix}-${size}`, variant && `text-${variant}`)
    });
});
$39ebe134e7977f3e$var$Spinner.displayName = "Spinner";
var $39ebe134e7977f3e$export$2e2bcd8739ae039 = $39ebe134e7977f3e$var$Spinner;



var $6cds3 = parcelRequire("6cds3");

var $aMJGV = parcelRequire("aMJGV");
var $8288da627a9a79fa$var$_excluded = [
    "color",
    "size",
    "title"
];
function $8288da627a9a79fa$var$_extends() {
    $8288da627a9a79fa$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8288da627a9a79fa$var$_extends.apply(this, arguments);
}
function $8288da627a9a79fa$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $8288da627a9a79fa$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $8288da627a9a79fa$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $8288da627a9a79fa$var$ChevronLeft = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, rest = $8288da627a9a79fa$var$_objectWithoutProperties(_ref, $8288da627a9a79fa$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("svg", $8288da627a9a79fa$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        fillRule: "evenodd",
        d: "M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"
    }));
});
$8288da627a9a79fa$var$ChevronLeft.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string
};
$8288da627a9a79fa$var$ChevronLeft.defaultProps = {
    color: "currentColor",
    size: "1em",
    title: null
};
var $8288da627a9a79fa$export$2e2bcd8739ae039 = $8288da627a9a79fa$var$ChevronLeft;


var $6cds3 = parcelRequire("6cds3");

var $aMJGV = parcelRequire("aMJGV");
var $f97e350cddc6443b$var$_excluded = [
    "color",
    "size",
    "title"
];
function $f97e350cddc6443b$var$_extends() {
    $f97e350cddc6443b$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f97e350cddc6443b$var$_extends.apply(this, arguments);
}
function $f97e350cddc6443b$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $f97e350cddc6443b$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $f97e350cddc6443b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $f97e350cddc6443b$var$QuestionCircle = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, rest = $f97e350cddc6443b$var$_objectWithoutProperties(_ref, $f97e350cddc6443b$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("svg", $f97e350cddc6443b$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286m1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94"
    }));
});
$f97e350cddc6443b$var$QuestionCircle.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string
};
$f97e350cddc6443b$var$QuestionCircle.defaultProps = {
    color: "currentColor",
    size: "1em",
    title: null
};
var $f97e350cddc6443b$export$2e2bcd8739ae039 = $f97e350cddc6443b$var$QuestionCircle;



parcelRequire("c9wMV");

function $edd3c36e8c82dfd7$var$Coins(props) {
    var _coins_denom;
    const { asset: asset, coins: coins, fullPrecision: fullPrecision, inBaseDenom: inBaseDenom, hideValue: hideValue, className: className } = props;
    let { decimals: decimals, symbol: symbol, prices: prices } = asset || {};
    const { coingecko: coingecko } = prices || {};
    decimals = decimals !== null && decimals !== void 0 ? decimals : 6;
    symbol = symbol || (coins === null || coins === void 0 ? void 0 : (_coins_denom = coins.denom) === null || _coins_denom === void 0 ? void 0 : _coins_denom.toUpperCase());
    function amount(coins) {
        if (inBaseDenom) return coins.amount;
        const prec = precision(coins);
        return separator((0, $ed89d4c20b089b73$export$d9468344d3651243)((0, $ed89d4c20b089b73$export$2077e0241d6afd3c)((0, $ed89d4c20b089b73$export$cd007d971a5a2143)((0, $ed89d4c20b089b73$export$8576f72eb7f14a7e)(coins.amount), Math.pow(10, decimals)), prec), {
            notation: "fixed"
        }));
    }
    function value(coins) {
        return (coins.amount / Math.pow(10, decimals) * coingecko.usd).toLocaleString(undefined, {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2
        });
    }
    function separator(stringNum) {
        var str = stringNum.split(".");
        str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return str.join(".");
    }
    if (!coins || !coins.denom) return null;
    function precision(coins) {
        if (fullPrecision) return decimals;
        if (props.precision) return props.precision;
        if (coins.amount >= 1000 * Math.pow(10, decimals)) return 2;
        if (coins.amount >= 100 * Math.pow(10, decimals)) return 3;
        return 6;
    }
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("span", {
        className: [
            "d-inline-block m-0 coins",
            className
        ].join(" "),
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                        className: "amount",
                        children: amount(coins)
                    }),
                    "\xa0",
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("small", {
                        className: "denom",
                        children: symbol
                    })
                ]
            }),
            !!(coingecko === null || coingecko === void 0 ? void 0 : coingecko.usd) && !hideValue && !!coins.amount && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("em", {
                        className: "text-muted",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("span", {
                            className: "amount",
                            children: [
                                "$",
                                value(coins)
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
var $edd3c36e8c82dfd7$export$2e2bcd8739ae039 = $edd3c36e8c82dfd7$var$Coins;





var $6cds3 = parcelRequire("6cds3");





function $44ae7ef333bfe594$var$DelegateForm(props) {
    const { network: network, wallet: wallet, address: address, validator: validator, selectedValidator: selectedValidator, action: action } = props;
    const [state, setState] = (0, $6cds3.useReducer)((state, newState)=>({
            ...state,
            ...newState
        }), {
        amount: "",
        memo: ""
    });
    function handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        setState({
            [name]: value
        });
    }
    async function handleSubmit(event) {
        event.preventDefault();
        setState({
            loading: true,
            error: null
        });
        const amount = state.amount;
        const memo = state.memo;
        const client = props.signingClient;
        const decimals = (0, $ed89d4c20b089b73$export$9c297f60e22e3389)(10, network.decimals);
        const denomAmount = (0, $ed89d4c20b089b73$export$8576f72eb7f14a7e)((0, $ed89d4c20b089b73$export$2060d2db72cce88f)(amount, decimals));
        let messages = buildMessages(denomAmount);
        let gas;
        try {
            gas = await client.simulate(wallet.address, messages);
        } catch (error) {
            setState({
                loading: false,
                error: error.message
            });
            return;
        }
        client.signAndBroadcast(wallet.address, messages, gas, memo).then((result)=>{
            console.log("Successfully broadcasted:", result);
            setState({
                loading: false,
                error: null
            });
            props.onDelegate();
        }, (error)=>{
            console.log("Failed to broadcast:", error);
            setState({
                loading: false,
                error: `Failed to broadcast: ${error.message}`
            });
        });
    }
    function buildMessages(amount) {
        let message, type, typeUrl, value;
        if (action === "redelegate") {
            type = (0, $0000c3e2167efb84$exports.MsgBeginRedelegate);
            typeUrl = "/cosmos.staking.v1beta1.MsgBeginRedelegate";
            value = {
                delegatorAddress: address,
                validatorSrcAddress: validator.operator_address,
                validatorDstAddress: selectedValidator.operator_address,
                amount: (0, $2a6bf51ee962800d$export$3c9d1e4131afeeb8)(amount, network.denom)
            };
        } else {
            type = action === "undelegate" ? (0, $0000c3e2167efb84$exports.MsgUndelegate) : (0, $0000c3e2167efb84$exports.MsgDelegate);
            typeUrl = "/cosmos.staking.v1beta1.Msg" + (action === "undelegate" ? "Undelegate" : "Delegate");
            value = {
                delegatorAddress: address,
                validatorAddress: validator.operator_address,
                amount: (0, $2a6bf51ee962800d$export$3c9d1e4131afeeb8)(amount, network.denom)
            };
        }
        if ((wallet === null || wallet === void 0 ? void 0 : wallet.address) !== address) message = (0, $2a6bf51ee962800d$export$61d88097eacac343)(wallet.address, [
            {
                typeUrl: typeUrl,
                value: type.encode(type.fromPartial(value)).finish()
            }
        ]);
        else message = {
            typeUrl: typeUrl,
            value: value
        };
        return [
            message
        ];
    }
    function hasPermission() {
        const permission = action === "redelegate" ? "BeginRedelegate" : action === "undelegate" ? "Undelegate" : "Delegate";
        return wallet === null || wallet === void 0 ? void 0 : wallet.hasPermission(address, permission);
    }
    async function setAvailableAmount() {
        if (!wallet) return;
        setState({
            error: undefined
        });
        const messages = buildMessages((0, $ed89d4c20b089b73$export$2060d2db72cce88f)(availableBalance().amount, 0.95));
        const decimals = (0, $ed89d4c20b089b73$export$9c297f60e22e3389)(10, network.decimals);
        const balance = (0, $ed89d4c20b089b73$export$8576f72eb7f14a7e)(availableBalance().amount);
        if ([
            "redelegate",
            "undelegate"
        ].includes(action)) return setState({
            amount: (0, $ed89d4c20b089b73$export$cd007d971a5a2143)(balance, decimals)
        });
        props.signingClient.simulate(wallet.address, messages).then((gas)=>{
            const gasPrice = props.signingClient.getFee(gas).amount[0].amount;
            const saveTxFeeNum = 10;
            const amount = (0, $ed89d4c20b089b73$export$cd007d971a5a2143)((0, $ed89d4c20b089b73$export$4e2d2ead65e5f7e3)(balance, (0, $ed89d4c20b089b73$export$2060d2db72cce88f)(gasPrice, saveTxFeeNum)), decimals);
            setState({
                amount: amount > 0 ? amount : 0
            });
        }, (error)=>{
            setState({
                error: error.message
            });
        });
    }
    function availableBalance() {
        if ([
            "redelegate",
            "undelegate"
        ].includes(action)) return (props.delegation || {}).balance;
        else return props.balance;
    }
    function actionText() {
        if (action === "redelegate") return "Redelegate";
        if (action === "undelegate") return "Undelegate";
        return "Delegate";
    }
    function denom() {
        return network.symbol;
    }
    function step() {
        return 1 / (0, $ed89d4c20b089b73$export$9c297f60e22e3389)(10, network.decimals);
    }
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: [
            state.error && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e96a7241eeb31a8$export$2e2bcd8739ae039), {
                variant: "danger",
                children: state.error
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039), {
                onSubmit: handleSubmit,
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("fieldset", {
                    disabled: !address || !wallet,
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039).Group, {
                            className: "mb-3",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039).Label, {
                                    children: "Amount"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                    className: "mb-3",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                            className: "input-group",
                                            children: [
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039).Control, {
                                                    name: "amount",
                                                    type: "number",
                                                    min: 0,
                                                    step: step(),
                                                    placeholder: "10",
                                                    required: true,
                                                    value: state.amount,
                                                    onChange: handleInputChange
                                                }),
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                    className: "input-group-text",
                                                    children: denom()
                                                })
                                            ]
                                        }),
                                        availableBalance() && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                            className: "form-text text-end",
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("span", {
                                                role: "button",
                                                onClick: ()=>setAvailableAmount(),
                                                children: [
                                                    "Available: ",
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $edd3c36e8c82dfd7$export$2e2bcd8739ae039), {
                                                        coins: availableBalance(),
                                                        asset: network.baseAsset,
                                                        fullPrecision: true,
                                                        hideValue: true
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039).Group, {
                            className: "mb-3",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039).Label, {
                                    children: "Memo"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039).Control, {
                                    name: "memo",
                                    as: "textarea",
                                    rows: 3,
                                    value: state.memo,
                                    onChange: handleInputChange
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                            className: "d-flex justify-content-end gap-2",
                            children: !state.loading ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                                children: [
                                    props.closeForm && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a73f5336dfd04f2d$export$2e2bcd8739ae039), {
                                        variant: "secondary",
                                        onClick: props.closeForm,
                                        children: "Cancel"
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a73f5336dfd04f2d$export$2e2bcd8739ae039), {
                                        type: "submit",
                                        disabled: !hasPermission(),
                                        className: "btn btn-primary",
                                        children: actionText()
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $a73f5336dfd04f2d$export$2e2bcd8739ae039), {
                                className: "btn btn-primary",
                                type: "button",
                                disabled: true,
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                        className: "spinner-border spinner-border-sm",
                                        role: "status",
                                        "aria-hidden": "true"
                                    }),
                                    "\xa0"
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
}
var $44ae7ef333bfe594$export$2e2bcd8739ae039 = $44ae7ef333bfe594$var$DelegateForm;






var $6cds3 = parcelRequire("6cds3");

var $c9wMV = parcelRequire("c9wMV");
class $2ee411b7ad359e70$export$2e2bcd8739ae039 {
    static getDescendantProperty(object, path, list = []) {
        let firstSegment;
        let remaining;
        let dotIndex;
        let value;
        let index;
        let length;
        if (path) {
            dotIndex = path.indexOf(".");
            if (dotIndex === -1) firstSegment = path;
            else {
                firstSegment = path.slice(0, dotIndex);
                remaining = path.slice(dotIndex + 1);
            }
            value = object[firstSegment];
            if (value !== null && typeof value !== "undefined") {
                if (!remaining && (typeof value === "string" || typeof value === "number")) list.push(value);
                else if (Object.prototype.toString.call(value) === "[object Array]") for(index = 0, length = value.length; index < length; index++)$2ee411b7ad359e70$export$2e2bcd8739ae039.getDescendantProperty(value[index], remaining, list);
                else if (remaining) $2ee411b7ad359e70$export$2e2bcd8739ae039.getDescendantProperty(value, remaining, list);
            }
        } else list.push(object);
        return list;
    }
}


class $69a568a3ebbe1e4c$export$2e2bcd8739ae039 {
    search(query = "") {
        if (query === "") return this.haystack;
        const results = [];
        for(let i = 0; i < this.haystack.length; i++){
            const item = this.haystack[i];
            if (this.keys.length === 0) {
                const score = $69a568a3ebbe1e4c$export$2e2bcd8739ae039.isMatch(item, query, this.options.caseSensitive);
                if (score) results.push({
                    item: item,
                    score: score
                });
            } else for(let y = 0; y < this.keys.length; y++){
                const propertyValues = (0, $2ee411b7ad359e70$export$2e2bcd8739ae039).getDescendantProperty(item, this.keys[y]);
                let found = false;
                for(let z = 0; z < propertyValues.length; z++){
                    const score = $69a568a3ebbe1e4c$export$2e2bcd8739ae039.isMatch(propertyValues[z], query, this.options.caseSensitive);
                    if (score) {
                        found = true;
                        results.push({
                            item: item,
                            score: score
                        });
                        break;
                    }
                }
                if (found) break;
            }
        }
        if (this.options.sort) results.sort((a, b)=>a.score - b.score);
        return results.map((result)=>result.item);
    }
    static isMatch(item, query, caseSensitive) {
        item = String(item);
        query = String(query);
        if (!caseSensitive) {
            item = item.toLocaleLowerCase();
            query = query.toLocaleLowerCase();
        }
        const indexes = $69a568a3ebbe1e4c$export$2e2bcd8739ae039.nearestIndexesFor(item, query);
        if (!indexes) return false;
        // Exact matches should be first.
        if (item === query) return 1;
        // If we have more than 2 letters, matches close to each other should be first.
        if (indexes.length > 1) return 2 + (indexes[indexes.length - 1] - indexes[0]);
        // Matches closest to the start of the string should be first.
        return 2 + indexes[0];
    }
    static nearestIndexesFor(item, query) {
        const letters = query.split("");
        let indexes = [];
        const indexesOfFirstLetter = $69a568a3ebbe1e4c$export$2e2bcd8739ae039.indexesOfFirstLetter(item, query);
        indexesOfFirstLetter.forEach((startingIndex, loopingIndex)=>{
            let index = startingIndex + 1;
            indexes[loopingIndex] = [
                startingIndex
            ];
            for(let i = 1; i < letters.length; i++){
                const letter = letters[i];
                index = item.indexOf(letter, index);
                if (index === -1) {
                    indexes[loopingIndex] = false;
                    break;
                }
                indexes[loopingIndex].push(index);
                index++;
            }
        });
        indexes = indexes.filter((letterIndexes)=>letterIndexes !== false);
        if (!indexes.length) return false;
        return indexes.sort((a, b)=>{
            if (a.length === 1) return a[0] - b[0];
            a = a[a.length - 1] - a[0];
            b = b[b.length - 1] - b[0];
            return a - b;
        })[0];
    }
    static indexesOfFirstLetter(item, query) {
        const match = query[0];
        return item.split("").map((letter, index)=>{
            if (letter !== match) return false;
            return index;
        }).filter((index)=>index !== false);
    }
    constructor(haystack = [], keys = [], options = {}){
        if (!Array.isArray(keys)) {
            options = keys;
            keys = [];
        }
        this.haystack = haystack;
        this.keys = keys;
        this.options = Object.assign({
            caseSensitive: false,
            sort: false
        }, options);
    }
}













var $6cds3 = parcelRequire("6cds3");

var $aMJGV = parcelRequire("aMJGV");
var $4929e07a18e71701$var$_excluded = [
    "color",
    "size",
    "title"
];
function $4929e07a18e71701$var$_extends() {
    $4929e07a18e71701$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4929e07a18e71701$var$_extends.apply(this, arguments);
}
function $4929e07a18e71701$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $4929e07a18e71701$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $4929e07a18e71701$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $4929e07a18e71701$var$HeartPulse = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, rest = $4929e07a18e71701$var$_objectWithoutProperties(_ref, $4929e07a18e71701$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("svg", $4929e07a18e71701$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053.918 3.995.78 5.323 1.508 7H.43c-2.128-5.697 4.165-8.83 7.394-5.857q.09.083.176.171a3 3 0 0 1 .176-.17c3.23-2.974 9.522.159 7.394 5.856h-1.078c.728-1.677.59-3.005.108-3.947C13.486.878 10.4.28 8.717 2.01zM2.212 10h1.315C4.593 11.183 6.05 12.458 8 13.795c1.949-1.337 3.407-2.612 4.473-3.795h1.315c-1.265 1.566-3.14 3.25-5.788 5-2.648-1.75-4.523-3.434-5.788-5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "M10.464 3.314a.5.5 0 0 0-.945.049L7.921 8.956 6.464 5.314a.5.5 0 0 0-.88-.091L3.732 8H.5a.5.5 0 0 0 0 1H4a.5.5 0 0 0 .416-.223l1.473-2.209 1.647 4.118a.5.5 0 0 0 .945-.049l1.598-5.593 1.457 3.642A.5.5 0 0 0 12 9h3.5a.5.5 0 0 0 0-1h-3.162z"
    }));
});
$4929e07a18e71701$var$HeartPulse.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string
};
$4929e07a18e71701$var$HeartPulse.defaultProps = {
    color: "currentColor",
    size: "1em",
    title: null
};
var $4929e07a18e71701$export$2e2bcd8739ae039 = $4929e07a18e71701$var$HeartPulse;


var $b83a46f38d226ab2$exports = {};

$b83a46f38d226ab2$exports = (parcelRequire("17QCl")).getBundleURL("7lpHJ") + "staking-rewards.629f8782.svg";


var $5aac1fcc9673a60f$exports = {};

$5aac1fcc9673a60f$exports = (parcelRequire("17QCl")).getBundleURL("7lpHJ") + "staking-rewards-white.3f0d7deb.svg";


var $85d9906f095262df$exports = {};

$85d9906f095262df$exports = (parcelRequire("17QCl")).getBundleURL("7lpHJ") + "staking-rewards-verified.b78dfa54.svg";


var $02179335a0a91884$exports = {};

$02179335a0a91884$exports = (parcelRequire("17QCl")).getBundleURL("7lpHJ") + "staking-rewards-verified-white.6a309a0a.svg";


var $d84639c200d8b38e$exports = {};

$d84639c200d8b38e$exports = (parcelRequire("17QCl")).getBundleURL("7lpHJ") + "cosmostation.9b05d607.svg";


var $d9e45806e289e16c$exports = {};

$d9e45806e289e16c$exports = (parcelRequire("17QCl")).getBundleURL("7lpHJ") + "ping-pub.7c1a9deb.svg";


var $5df7560a289826c8$exports = {};

$5df7560a289826c8$exports = (parcelRequire("17QCl")).getBundleURL("7lpHJ") + "nodes-guru.1b4b3ead.svg";


function $46b1c64d9a49f85d$var$ValidatorServices(props) {
    var _validator_services, _network_chain_explorers, _network_chain_explorers1, _network_chain_explorers2;
    const { validator: validator, network: network, theme: theme } = props;
    const services = [];
    if (validator.path === "ecostake") {
        const publicNodes = Object.entries(validator.public_nodes || {}).length;
        let tooltip = "Created REStake and cosmos.directory";
        if (publicNodes) tooltip = /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
            children: [
                tooltip,
                ", and provides public nodes"
            ]
        });
        services.push({
            key: "nodes",
            tooltip: tooltip,
            render: ()=>{
                return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                    to: `/${network.path}/${validator.address}`,
                    className: "text-reset",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4929e07a18e71701$export$2e2bcd8739ae039), {
                        height: props.height || 18,
                        width: props.width || 18,
                        className: "d-block text-success"
                    })
                });
            }
        });
    } else if (Object.entries(validator.public_nodes || {}).length) services.push({
        key: "nodes",
        tooltip: "Provides public nodes used by REStake and other apps",
        render: ()=>{
            return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                to: `/${network.path}/${validator.address}`,
                className: "text-reset",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4929e07a18e71701$export$2e2bcd8739ae039), {
                    height: props.height || 18,
                    width: props.width || 18,
                    className: "d-block"
                })
            });
        }
    });
    if ((_validator_services = validator.services) === null || _validator_services === void 0 ? void 0 : _validator_services.staking_rewards) {
        let verified = validator.services.staking_rewards.verified;
        let icon = verified ? (0, (/*@__PURE__*/$parcel$interopDefault($85d9906f095262df$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($b83a46f38d226ab2$exports)));
        if (theme === "dark") icon = verified ? (0, (/*@__PURE__*/$parcel$interopDefault($02179335a0a91884$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($5aac1fcc9673a60f$exports)));
        services.push({
            key: "stakingrewards",
            tooltip: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("span", {
                children: [
                    "Staking Rewards ",
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                    verified ? "Verified" : "",
                    " Provider"
                ]
            }),
            icon: icon,
            url: `https://www.stakingrewards.com/savings/${validator.services.staking_rewards.slug}`
        });
    }
    const mintscan = (_network_chain_explorers = network.chain.explorers) === null || _network_chain_explorers === void 0 ? void 0 : _network_chain_explorers.find((el)=>el.kind === "mintscan");
    if (mintscan) services.push({
        key: "mintscan",
        tooltip: "Mintscan Profile",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d84639c200d8b38e$exports))),
        url: `${mintscan.url}/validators/${validator.address}`
    });
    const ping = (_network_chain_explorers1 = network.chain.explorers) === null || _network_chain_explorers1 === void 0 ? void 0 : _network_chain_explorers1.find((el)=>el.kind === "ping.pub");
    if (ping) services.push({
        key: "pingpub",
        tooltip: "Ping.pub Profile",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d9e45806e289e16c$exports))),
        url: `${ping.url}/staking/${validator.address}`
    });
    const guru = (_network_chain_explorers2 = network.chain.explorers) === null || _network_chain_explorers2 === void 0 ? void 0 : _network_chain_explorers2.find((el)=>el.kind === "explorers.guru");
    if (guru) services.push({
        key: "nodesguru",
        tooltip: "[NG] Explorers Profile",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5df7560a289826c8$exports))),
        url: `${guru.url}/validator/${validator.address}`
    });
    const showServices = services.filter((el)=>{
        if (props.show && !props.show.includes(el.key)) return false;
        if (props.exclude && props.exclude.includes(el.key)) return false;
        return true;
    });
    if (!showServices.length) return null;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
        className: "d-flex gap-2 align-items-center",
        children: showServices.map((service)=>{
            return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $843e0f89d5f7d219$export$2e2bcd8739ae039), {
                placement: "top",
                rootClose: true,
                overlay: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $75c21e5a46e079cb$export$2e2bcd8739ae039), {
                    id: `tooltip-${service.key}`,
                    children: service.tooltip
                }),
                children: service.render ? service.render() : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                    href: service.url,
                    target: service.target || "_blank",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                        src: service.icon,
                        height: props.height || 20,
                        className: "d-block"
                    })
                })
            }, service.key);
        })
    });
}
var $46b1c64d9a49f85d$export$2e2bcd8739ae039 = $46b1c64d9a49f85d$var$ValidatorServices;



parcelRequire("6cds3");
parcelRequire("c9wMV");



var $6cds3 = parcelRequire("6cds3");

var $aMJGV = parcelRequire("aMJGV");
var $15b3d4314270139f$var$_excluded = [
    "color",
    "size",
    "title"
];
function $15b3d4314270139f$var$_extends() {
    $15b3d4314270139f$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $15b3d4314270139f$var$_extends.apply(this, arguments);
}
function $15b3d4314270139f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $15b3d4314270139f$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $15b3d4314270139f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $15b3d4314270139f$var$ToggleOn = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, rest = $15b3d4314270139f$var$_objectWithoutProperties(_ref, $15b3d4314270139f$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("svg", $15b3d4314270139f$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "M5 3a5 5 0 0 0 0 10h6a5 5 0 0 0 0-10zm6 9a4 4 0 1 1 0-8 4 4 0 0 1 0 8"
    }));
});
$15b3d4314270139f$var$ToggleOn.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string
};
$15b3d4314270139f$var$ToggleOn.defaultProps = {
    color: "currentColor",
    size: "1em",
    title: null
};
var $15b3d4314270139f$export$2e2bcd8739ae039 = $15b3d4314270139f$var$ToggleOn;


var $6cds3 = parcelRequire("6cds3");

var $aMJGV = parcelRequire("aMJGV");
var $f674aa637402f61c$var$_excluded = [
    "color",
    "size",
    "title"
];
function $f674aa637402f61c$var$_extends() {
    $f674aa637402f61c$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f674aa637402f61c$var$_extends.apply(this, arguments);
}
function $f674aa637402f61c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $f674aa637402f61c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $f674aa637402f61c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $f674aa637402f61c$var$ToggleOff = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, rest = $f674aa637402f61c$var$_objectWithoutProperties(_ref, $f674aa637402f61c$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("svg", $f674aa637402f61c$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "M11 4a4 4 0 0 1 0 8H8a5 5 0 0 0 2-4 5 5 0 0 0-2-4zm-6 8a4 4 0 1 1 0-8 4 4 0 0 1 0 8M0 8a5 5 0 0 0 5 5h6a5 5 0 0 0 0-10H5a5 5 0 0 0-5 5"
    }));
});
$f674aa637402f61c$var$ToggleOff.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string
};
$f674aa637402f61c$var$ToggleOff.defaultProps = {
    color: "currentColor",
    size: "1em",
    title: null
};
var $f674aa637402f61c$export$2e2bcd8739ae039 = $f674aa637402f61c$var$ToggleOff;




function $77a1c6abbf48696a$var$REStakeStatus(props) {
    const { network: network, validator: validator, operator: operator, delegation: delegation, grants: grants, authzSupport: authzSupport, className: className } = props;
    const minimumReward = operator && {
        amount: operator.minimumReward,
        denom: network.denom
    };
    let content, icon, tooltip;
    let styleClass = "text-decoration-underline";
    if (operator) {
        let tooltipContent;
        if (authzSupport) {
            if (delegation) {
                if (grants === null || grants === void 0 ? void 0 : grants.grantsValid) {
                    let limit;
                    if (grants.maxTokens) limit = /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                            "(",
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $edd3c36e8c82dfd7$export$2e2bcd8739ae039), {
                                coins: {
                                    amount: grants.maxTokens,
                                    denom: network.denom
                                },
                                asset: network.baseAsset,
                                fullPrecision: true,
                                hideValue: true
                            }),
                            " remaining)"
                        ]
                    });
                    else limit = "(no limit)";
                    tooltipContent = /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("span", {
                        children: [
                            "Grant active ",
                            limit
                        ]
                    });
                    // styleClass = 'text-success'
                    // styleClass = 'fst-italic'
                    icon = /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $15b3d4314270139f$export$2e2bcd8739ae039), {
                        className: "d-block text-success"
                    });
                } else if (grants === null || grants === void 0 ? void 0 : grants.grantsExist) {
                    tooltipContent = "Update grants to enable REStake";
                    icon = /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f674aa637402f61c$export$2e2bcd8739ae039), {
                        className: "d-block text-danger"
                    });
                // styleClass = 'text-danger'
                } else {
                    tooltipContent = "Grant to enable REStake";
                    icon = /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f674aa637402f61c$export$2e2bcd8739ae039), {
                        className: "d-block text-muted"
                    });
                }
            } else tooltipContent = "Delegate to enable REStake";
        } else tooltipContent = `Enable REStake once ${network.prettyName} supports Authz`;
        if (props.isLoading("grants")) icon = /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $39ebe134e7977f3e$export$2e2bcd8739ae039), {
            animation: "border",
            role: "status",
            className: "spinner-border-sm",
            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                className: "visually-hidden",
                children: "Loading..."
            })
        });
        content = /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
            className: "d-flex flex-column align-items-center",
            children: [
                icon,
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("small", {
                        className: (0, $2a6bf51ee962800d$export$5bc2b158205eb1d6)(`text-nowrap text-decoration-underline d-block`, styleClass, className),
                        children: operator.frequency()
                    })
                })
            ]
        });
        tooltip = /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
            className: "mt-2 text-center",
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                    children: [
                        "REStakes ",
                        operator.runTimesString()
                    ]
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                    children: [
                        "Minimum reward is",
                        " ",
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $edd3c36e8c82dfd7$export$2e2bcd8739ae039), {
                            coins: minimumReward,
                            asset: network.baseAsset,
                            fullPrecision: true,
                            hideValue: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                    children: tooltipContent
                })
            ]
        });
    } else {
        content = /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $ac4c3421df377bd7$export$2e2bcd8739ae039), {
            className: (0, $2a6bf51ee962800d$export$5bc2b158205eb1d6)(`opacity-50`, className)
        });
        tooltip = "This validator is not a REStake operator";
    }
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
        role: props.onClick ? "button" : "",
        onClick: props.onClick,
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc7c852c832d97ac$export$2e2bcd8739ae039), {
            icon: content,
            identifier: validator.operator_address,
            rootClose: true,
            tooltip: tooltip
        })
    });
}
var $77a1c6abbf48696a$export$2e2bcd8739ae039 = $77a1c6abbf48696a$var$REStakeStatus;


function $163e26a5c9452562$var$Validators(props) {
    const { address: address, wallet: wallet, network: network, validators: validators, operators: operators, delegations: delegations, operatorGrants: operatorGrants } = props;
    const [filter, setFilter] = (0, $6cds3.useReducer)((state, newState)=>({
            ...state,
            ...newState
        }), {
        keywords: "",
        status: "active",
        group: "delegated"
    });
    const [results, setResults] = (0, $6cds3.useState)([]);
    const showCommission = results && Object.values(results).find((el)=>el.isValidatorOperator(address));
    (0, $6cds3.useEffect)(()=>{
        if (delegations && filter.group !== "delegated") return setFilter({
            group: "delegated"
        });
    }, [
        Object.keys(delegations || {}).length
    ]);
    (0, $6cds3.useEffect)(()=>{
        let filtered = filteredValidators(validators, filter);
        let group = filter.group;
        while(filtered.length < 1 && group !== "all"){
            group = "all";
            filtered = filteredValidators(validators, {
                ...filter,
                group: group
            });
            if (filtered.length > 0 || group === "all") return setFilter({
                group: group
            });
        }
        setResults(filtered);
    }, [
        validators,
        operators,
        delegations,
        operatorGrants,
        filter
    ]);
    function sortValidators(validators) {
        validators = (0, (/*@__PURE__*/$parcel$interopDefault($c9wMV))).sortBy(validators, ({ operator_address: address })=>{
            var _delegation_balance;
            const delegation = delegations && delegations[address];
            return 0 - ((delegation === null || delegation === void 0 ? void 0 : (_delegation_balance = delegation.balance) === null || _delegation_balance === void 0 ? void 0 : _delegation_balance.amount) || 0);
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($c9wMV))).sortBy(validators, ({ operator_address: address, public_nodes: public_nodes, path: path })=>{
            if (network.data.ownerAddress === address) return -6;
            if (path === "ecostake") return -5;
            const delegation = delegations && delegations[address];
            const publicNodes = Object.entries(public_nodes || {}).length > 0;
            const operator = operators && operators.find((el)=>el.address === address);
            let score = 1;
            if (delegation) score = operator ? -3 : -2;
            else if (operator) score = -1;
            if (publicNodes) score--;
            return score;
        });
    }
    function filterValidators(event) {
        setFilter({
            keywords: event.target.value
        });
    }
    function filteredValidators(validators, filter) {
        let searchResults;
        if (props.exclude) searchResults = Object.values((0, (/*@__PURE__*/$parcel$interopDefault($c9wMV))).omit(validators, props.exclude));
        else searchResults = Object.values(validators);
        const { keywords: keywords, status: status, group: group } = filter;
        if (status) searchResults = searchResults.filter((result)=>{
            if (status === "active") return result.status === "BOND_STATUS_BONDED";
            else if (status === "inactive") return result.status !== "BOND_STATUS_BONDED";
            else return true;
        });
        searchResults = filterByGroup(searchResults, group);
        if (!keywords || keywords === "") return sortValidators(searchResults);
        const searcher = new (0, $69a568a3ebbe1e4c$export$2e2bcd8739ae039)(searchResults, [
            "description.moniker"
        ], {
            sort: true
        });
        return searcher.search(keywords);
    }
    function filterByGroup(validators, group) {
        switch(group){
            case "delegated":
                validators = validators.filter(({ operator_address: address })=>{
                    return delegations && delegations[address];
                });
                break;
        }
        return validators;
    }
    function operatorForValidator(validatorAddress) {
        return operators.find((el)=>el.address === validatorAddress);
    }
    function renderValidator(validator) {
        const validatorAddress = validator.operator_address;
        const delegation = delegations && delegations[validatorAddress];
        const validatorOperator = validator.isValidatorOperator(address);
        const rewards = props.rewards && props.rewards[validatorAddress];
        const denomRewards = rewards && rewards.reward.find((reward)=>reward.denom === network.denom);
        const commission = props.commission && props.commission[validatorAddress];
        const denomCommission = commission && commission.commission.find((commission)=>commission.denom === network.denom);
        const operator = operatorForValidator(validatorAddress);
        const grants = operator && operatorGrants[operator.botAddress];
        let rowVariant;
        if (validatorOperator) rowVariant = "table-info";
        const delegationBalance = delegation && delegation.balance || {
            amount: 0,
            denom: network.denom
        };
        let badge;
        if (validator.jailed) badge = {
            bg: "danger",
            text: "Jailed"
        };
        else if (!validator.active) badge = {
            bg: "light",
            text: "Inactive"
        };
        return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
            className: rowVariant,
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                    className: "px-1",
                    width: 30,
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $ed81bcc8e8ff6731$export$2e2bcd8739ae039), {
                        validator: validator,
                        width: 30,
                        height: 30
                    })
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                    className: "ps-1 text-break",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        role: "button",
                        onClick: ()=>props.showValidator(validator, {
                                activeTab: "profile"
                            }),
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            className: "d-flex align-items-start align-items-sm-center justify-content-end flex-column flex-sm-row gap-1 gap-sm-3",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $d3d2619c03629196$export$2e2bcd8739ae039), {
                                    validator: validator,
                                    className: "me-auto"
                                }),
                                badge ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("small", {
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e44c6ff59d2a760f$export$2e2bcd8739ae039), {
                                        bg: badge.bg,
                                        className: "opacity-75",
                                        children: badge.text
                                    })
                                }) : null,
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                    className: "text-muted small d-none d-md-block",
                                    children: [
                                        "#",
                                        validator.rank
                                    ]
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                    className: "text-center",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $77a1c6abbf48696a$export$2e2bcd8739ae039), {
                        network: network,
                        validator: validator,
                        operator: operator,
                        delegation: delegation,
                        rewards: rewards,
                        grants: grants,
                        authzSupport: props.authzSupport,
                        isLoading: props.isLoading,
                        onClick: ()=>props.showValidator(validator, {
                                activeTab: "stake"
                            })
                    })
                }),
                network.apyEnabled && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                    className: "text-center",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                        role: "button",
                        onClick: ()=>props.showValidator(validator, {
                                activeTab: "stake"
                            }),
                        children: props.validatorApy[validatorAddress] !== undefined ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("small", {
                            children: (0, $ed89d4c20b089b73$export$2077e0241d6afd3c)(props.validatorApy[validatorAddress] * 100, 1).toLocaleString() + "%"
                        }) : "-"
                    })
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                    className: network.apyEnabled ? "text-center d-none d-lg-table-cell" : "text-center",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("small", {
                        children: [
                            (0, $ed89d4c20b089b73$export$d9468344d3651243)(validator.commission.commission_rates.rate * 100, 2),
                            "%"
                        ]
                    })
                }),
                props.isLoading("delegations") || Object.keys(delegations || {}).length ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                    className: filter.group === "delegated" ? "" : "d-none d-sm-table-cell",
                    children: !props.isLoading("delegations") ? (delegationBalance === null || delegationBalance === void 0 ? void 0 : delegationBalance.amount) ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        role: "button",
                        onClick: ()=>props.showValidator(validator, {
                                activeTab: "stake"
                            }),
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("small", {
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $edd3c36e8c82dfd7$export$2e2bcd8739ae039), {
                                coins: delegationBalance,
                                asset: network.baseAsset,
                                precision: 3
                            })
                        })
                    }) : null : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $39ebe134e7977f3e$export$2e2bcd8739ae039), {
                        animation: "border",
                        role: "status",
                        className: "spinner-border-sm text-secondary",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                            className: "visually-hidden",
                            children: "Loading..."
                        })
                    })
                }) : null,
                filter.group === "delegated" && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                    children: !props.modal && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                        className: "d-none d-md-table-cell",
                        children: !props.isLoading("rewards") ? denomRewards && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                            role: "button",
                            onClick: ()=>props.showValidator(validator, {
                                    activeTab: "stake"
                                }),
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("small", {
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $edd3c36e8c82dfd7$export$2e2bcd8739ae039), {
                                    coins: denomRewards,
                                    asset: network.baseAsset,
                                    precision: 3
                                }, denomRewards.denom)
                            })
                        }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $39ebe134e7977f3e$export$2e2bcd8739ae039), {
                            animation: "border",
                            role: "status",
                            className: "spinner-border-sm text-secondary",
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                className: "visually-hidden",
                                children: "Loading..."
                            })
                        })
                    })
                }),
                !props.modal && showCommission && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                    className: "d-none d-lg-table-cell",
                    children: !props.isLoading("commission") ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        role: "button",
                        onClick: ()=>props.showValidator(validator, {
                                activeTab: "stake"
                            }),
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("small", {
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $edd3c36e8c82dfd7$export$2e2bcd8739ae039), {
                                coins: denomCommission,
                                asset: network.baseAsset,
                                precision: 3
                            })
                        })
                    }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $39ebe134e7977f3e$export$2e2bcd8739ae039), {
                        animation: "border",
                        role: "status",
                        className: "spinner-border-sm text-secondary",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                            className: "visually-hidden",
                            children: "Loading..."
                        })
                    })
                }),
                !props.modal && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                    className: filter.group === "delegated" ? "d-none d-sm-table-cell" : "",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "d-grid justify-content-end align-items-center",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $46b1c64d9a49f85d$export$2e2bcd8739ae039), {
                            validator: validator,
                            network: network,
                            show: [
                                "stakingrewards",
                                "nodes"
                            ],
                            theme: props.theme
                        })
                    })
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                    className: "d-none d-sm-table-cell",
                    width: 60,
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "d-grid justify-content-end align-items-center",
                        children: props.buttonText ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a73f5336dfd04f2d$export$2e2bcd8739ae039), {
                            size: "sm",
                            onClick: ()=>props.showValidator(validator, {
                                    activeTab: "stake"
                                }),
                            children: props.buttonText
                        }) : props.manageControl ? props.manageControl({
                            validator: validator,
                            operator: operator,
                            delegation: delegation,
                            rewards: rewards,
                            grants: grants,
                            filter: filter
                        }) : null
                    })
                })
            ]
        }, validatorAddress);
    }
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: "d-flex flex-wrap justify-content-between align-items-start mb-3 position-relative",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "d-none d-sm-flex",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            className: "input-group",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                    className: "form-control border-right-0 border",
                                    onChange: filterValidators,
                                    value: filter.keywords,
                                    type: "text",
                                    placeholder: "Search..",
                                    style: {
                                        maxWidth: 150
                                    }
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                    className: "input-group-append",
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                                        className: "btn btn-light text-dark border-left-0 border",
                                        type: "button",
                                        onClick: ()=>setFilter({
                                                keywords: ""
                                            }),
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $ac4c3421df377bd7$export$2e2bcd8739ae039), {})
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "w-100 d-flex d-sm-none mb-2",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            className: "input-group",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                    className: "form-control border-right-0 border",
                                    onChange: filterValidators,
                                    value: filter.keywords,
                                    type: "text",
                                    placeholder: "Search.."
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                    className: "input-group-append",
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                                        className: "btn btn-light text-dark border-left-0 border",
                                        type: "button",
                                        onClick: ()=>setFilter({
                                                keywords: ""
                                            }),
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $ac4c3421df377bd7$export$2e2bcd8739ae039), {})
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: `${!props.modal && "d-md-flex"} d-none justify-content-center align-self-center`,
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $85f5d0e6280a2ccf$export$2e2bcd8739ae039), {
                            fill: true,
                            variant: "pills",
                            activeKey: filter.group,
                            className: `flex-row${props.modal ? " small" : ""}`,
                            onSelect: (e)=>setFilter({
                                    group: e
                                }),
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $85f5d0e6280a2ccf$export$2e2bcd8739ae039).Item, {
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $85f5d0e6280a2ccf$export$2e2bcd8739ae039).Link, {
                                        eventKey: "delegated",
                                        disabled: filteredValidators(validators, {
                                            ...filter,
                                            group: "delegated"
                                        }).length < 1,
                                        children: "My Delegations"
                                    })
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $85f5d0e6280a2ccf$export$2e2bcd8739ae039).Item, {
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $85f5d0e6280a2ccf$export$2e2bcd8739ae039).Link, {
                                        eventKey: "all",
                                        children: "All Validators"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: `d-flex ${!props.modal && "d-md-none"} justify-content-center`,
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("select", {
                            className: "form-select w-auto h-auto",
                            "aria-label": "Delegation group",
                            value: filter.group,
                            onChange: (e)=>setFilter({
                                    group: e.target.value
                                }),
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                                    value: "delegated",
                                    disabled: filteredValidators(validators, {
                                        ...filter,
                                        group: "delegated"
                                    }).length < 1,
                                    children: "My Delegations"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                                    value: "all",
                                    children: "All Validators"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "d-flex justify-content-end",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("select", {
                            className: "form-select w-auto h-auto",
                            "aria-label": "Validator status",
                            value: filter.status,
                            onChange: (e)=>setFilter({
                                    status: e.target.value
                                }),
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                                    value: "active",
                                    children: "Active"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                                    value: "inactive",
                                    children: "Inactive"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                                    value: "all",
                                    children: "All"
                                })
                            ]
                        })
                    })
                ]
            }),
            results.length > 0 && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $36688d56d3c1862c$export$2e2bcd8739ae039), {
                className: "align-middle table-striped",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("th", {
                                    colSpan: 2,
                                    children: "Validator"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("th", {
                                    className: "text-center",
                                    children: "REStake"
                                }),
                                network.apyEnabled && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("th", {
                                    className: "text-center",
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc7c852c832d97ac$export$2e2bcd8739ae039), {
                                        icon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                            className: "text-decoration-underline",
                                            children: "APY"
                                        }),
                                        identifier: "delegations-apy",
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                            className: "mt-2 text-center",
                                            children: [
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                                    children: "Based on commission, compounding frequency and recent block times."
                                                }),
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                                    children: "This is a best case scenario and may not be 100% accurate."
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("th", {
                                    className: network.apyEnabled ? "text-center d-none d-lg-table-cell" : "text-center",
                                    children: "Fee"
                                }),
                                props.isLoading("delegations") || Object.keys(delegations || {}).length ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("th", {
                                    className: filter.group === "delegated" ? "" : "d-none d-sm-table-cell",
                                    children: "Delegation"
                                }) : null,
                                filter.group === "delegated" && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                                    children: !props.modal && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("th", {
                                        className: "d-none d-md-table-cell",
                                        children: "Rewards"
                                    })
                                }),
                                !props.modal && showCommission && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("th", {
                                    className: "d-none d-lg-table-cell",
                                    children: "Commission"
                                }),
                                !props.modal && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("th", {
                                    className: filter.group === "delegated" ? "d-none d-sm-table-cell" : ""
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("th", {
                                    className: "d-none d-sm-table-cell text-center"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("tbody", {
                        children: results.map((item)=>renderValidator(item))
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("tfoot", {
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                    colSpan: 2
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                    className: "text-center"
                                }),
                                network.apyEnabled && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                    className: "text-center"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                    className: network.apyEnabled ? "text-center d-none d-lg-table-cell" : "text-center"
                                }),
                                props.isLoading("delegations") || Object.keys(delegations || {}).length ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                    className: filter.group === "delegated" ? "" : "d-none d-sm-table-cell",
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                                        className: "small",
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $edd3c36e8c82dfd7$export$2e2bcd8739ae039), {
                                            coins: {
                                                amount: results.reduce((sum, result)=>{
                                                    const delegation = delegations && delegations[result.operator_address];
                                                    if (!delegation) return sum;
                                                    return (0, $ed89d4c20b089b73$export$e16d8520af44a096)(sum, delegation.balance.amount);
                                                }, 0),
                                                denom: network.denom
                                            },
                                            asset: network.baseAsset,
                                            precision: 3
                                        })
                                    })
                                }) : null,
                                filter.group === "delegated" && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                                    children: !props.modal && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                        className: "d-none d-md-table-cell",
                                        children: props.rewards && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                                            className: "small",
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $edd3c36e8c82dfd7$export$2e2bcd8739ae039), {
                                                coins: {
                                                    amount: results.reduce((sum, result)=>{
                                                        var _props_rewards_result_operator_address_reward, _props_rewards_result_operator_address;
                                                        const reward = (_props_rewards_result_operator_address = props.rewards[result.operator_address]) === null || _props_rewards_result_operator_address === void 0 ? void 0 : (_props_rewards_result_operator_address_reward = _props_rewards_result_operator_address.reward) === null || _props_rewards_result_operator_address_reward === void 0 ? void 0 : _props_rewards_result_operator_address_reward.find((el)=>el.denom === network.denom);
                                                        if (!reward) return sum;
                                                        return (0, $ed89d4c20b089b73$export$e16d8520af44a096)(sum, reward.amount);
                                                    }, 0),
                                                    denom: network.denom
                                                },
                                                asset: network.baseAsset,
                                                precision: 3
                                            })
                                        })
                                    })
                                }),
                                !props.modal && showCommission && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                    className: "d-none d-lg-table-cell",
                                    children: props.commission && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                                        className: "small",
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $edd3c36e8c82dfd7$export$2e2bcd8739ae039), {
                                            coins: {
                                                amount: results.reduce((sum, result)=>{
                                                    var _props_commission_result_operator_address_commission, _props_commission_result_operator_address;
                                                    const commission = (_props_commission_result_operator_address = props.commission[result.operator_address]) === null || _props_commission_result_operator_address === void 0 ? void 0 : (_props_commission_result_operator_address_commission = _props_commission_result_operator_address.commission) === null || _props_commission_result_operator_address_commission === void 0 ? void 0 : _props_commission_result_operator_address_commission.find((el)=>el.denom === network.denom);
                                                    if (!commission) return sum;
                                                    return (0, $ed89d4c20b089b73$export$e16d8520af44a096)(sum, commission.amount);
                                                }, 0),
                                                denom: network.denom
                                            },
                                            asset: network.baseAsset,
                                            precision: 3
                                        })
                                    })
                                }),
                                !props.modal && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                    className: filter.group === "delegated" ? "d-none d-sm-table-cell" : ""
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                    className: "d-none d-sm-table-cell"
                                })
                            ]
                        })
                    })
                ]
            }),
            results.length < 1 && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                className: "text-center my-5",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("em", {
                    children: "No validators found"
                })
            })
        ]
    });
}
var $163e26a5c9452562$export$2e2bcd8739ae039 = $163e26a5c9452562$var$Validators;





var $6cds3 = parcelRequire("6cds3");

var $2KWqD = parcelRequire("2KWqD");


var $59076e9d218a77a1$exports = {};
"use strict";
var $59076e9d218a77a1$var$__importDefault = $59076e9d218a77a1$exports && $59076e9d218a77a1$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($59076e9d218a77a1$exports, "__esModule", {
    value: true
});
$59076e9d218a77a1$exports.StakeAuthorization_Validators = $59076e9d218a77a1$exports.StakeAuthorization = $59076e9d218a77a1$exports.authorizationTypeToJSON = $59076e9d218a77a1$exports.authorizationTypeFromJSON = $59076e9d218a77a1$exports.AuthorizationType = $59076e9d218a77a1$exports.protobufPackage = void 0;

/* eslint-disable */ const $59076e9d218a77a1$var$long_1 = $59076e9d218a77a1$var$__importDefault((parcelRequire("9A55m")));

const $59076e9d218a77a1$var$minimal_1 = $59076e9d218a77a1$var$__importDefault((parcelRequire("i2pIU")));

$59076e9d218a77a1$exports.protobufPackage = "cosmos.staking.v1beta1";
/**
 * AuthorizationType defines the type of staking module authorization type
 *
 * Since: cosmos-sdk 0.43
 */ var $59076e9d218a77a1$var$AuthorizationType;
(function(AuthorizationType) {
    /** AUTHORIZATION_TYPE_UNSPECIFIED - AUTHORIZATION_TYPE_UNSPECIFIED specifies an unknown authorization type */ AuthorizationType[AuthorizationType["AUTHORIZATION_TYPE_UNSPECIFIED"] = 0] = "AUTHORIZATION_TYPE_UNSPECIFIED";
    /** AUTHORIZATION_TYPE_DELEGATE - AUTHORIZATION_TYPE_DELEGATE defines an authorization type for Msg/Delegate */ AuthorizationType[AuthorizationType["AUTHORIZATION_TYPE_DELEGATE"] = 1] = "AUTHORIZATION_TYPE_DELEGATE";
    /** AUTHORIZATION_TYPE_UNDELEGATE - AUTHORIZATION_TYPE_UNDELEGATE defines an authorization type for Msg/Undelegate */ AuthorizationType[AuthorizationType["AUTHORIZATION_TYPE_UNDELEGATE"] = 2] = "AUTHORIZATION_TYPE_UNDELEGATE";
    /** AUTHORIZATION_TYPE_REDELEGATE - AUTHORIZATION_TYPE_REDELEGATE defines an authorization type for Msg/BeginRedelegate */ AuthorizationType[AuthorizationType["AUTHORIZATION_TYPE_REDELEGATE"] = 3] = "AUTHORIZATION_TYPE_REDELEGATE";
    AuthorizationType[AuthorizationType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($59076e9d218a77a1$var$AuthorizationType = $59076e9d218a77a1$exports.AuthorizationType || ($59076e9d218a77a1$exports.AuthorizationType = {}));
function $59076e9d218a77a1$var$authorizationTypeFromJSON(object) {
    switch(object){
        case 0:
        case "AUTHORIZATION_TYPE_UNSPECIFIED":
            return $59076e9d218a77a1$var$AuthorizationType.AUTHORIZATION_TYPE_UNSPECIFIED;
        case 1:
        case "AUTHORIZATION_TYPE_DELEGATE":
            return $59076e9d218a77a1$var$AuthorizationType.AUTHORIZATION_TYPE_DELEGATE;
        case 2:
        case "AUTHORIZATION_TYPE_UNDELEGATE":
            return $59076e9d218a77a1$var$AuthorizationType.AUTHORIZATION_TYPE_UNDELEGATE;
        case 3:
        case "AUTHORIZATION_TYPE_REDELEGATE":
            return $59076e9d218a77a1$var$AuthorizationType.AUTHORIZATION_TYPE_REDELEGATE;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $59076e9d218a77a1$var$AuthorizationType.UNRECOGNIZED;
    }
}
$59076e9d218a77a1$exports.authorizationTypeFromJSON = $59076e9d218a77a1$var$authorizationTypeFromJSON;
function $59076e9d218a77a1$var$authorizationTypeToJSON(object) {
    switch(object){
        case $59076e9d218a77a1$var$AuthorizationType.AUTHORIZATION_TYPE_UNSPECIFIED:
            return "AUTHORIZATION_TYPE_UNSPECIFIED";
        case $59076e9d218a77a1$var$AuthorizationType.AUTHORIZATION_TYPE_DELEGATE:
            return "AUTHORIZATION_TYPE_DELEGATE";
        case $59076e9d218a77a1$var$AuthorizationType.AUTHORIZATION_TYPE_UNDELEGATE:
            return "AUTHORIZATION_TYPE_UNDELEGATE";
        case $59076e9d218a77a1$var$AuthorizationType.AUTHORIZATION_TYPE_REDELEGATE:
            return "AUTHORIZATION_TYPE_REDELEGATE";
        default:
            return "UNKNOWN";
    }
}
$59076e9d218a77a1$exports.authorizationTypeToJSON = $59076e9d218a77a1$var$authorizationTypeToJSON;
const $59076e9d218a77a1$var$baseStakeAuthorization = {
    authorizationType: 0
};
$59076e9d218a77a1$exports.StakeAuthorization = {
    encode (message, writer = $59076e9d218a77a1$var$minimal_1.default.Writer.create()) {
        if (message.maxTokens !== undefined) $82ef09d1a8e2224d$exports.Coin.encode(message.maxTokens, writer.uint32(10).fork()).ldelim();
        if (message.allowList !== undefined) $59076e9d218a77a1$exports.StakeAuthorization_Validators.encode(message.allowList, writer.uint32(18).fork()).ldelim();
        if (message.denyList !== undefined) $59076e9d218a77a1$exports.StakeAuthorization_Validators.encode(message.denyList, writer.uint32(26).fork()).ldelim();
        if (message.authorizationType !== 0) writer.uint32(32).int32(message.authorizationType);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $59076e9d218a77a1$var$minimal_1.default.Reader ? input : new $59076e9d218a77a1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $59076e9d218a77a1$var$baseStakeAuthorization);
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.maxTokens = $82ef09d1a8e2224d$exports.Coin.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.allowList = $59076e9d218a77a1$exports.StakeAuthorization_Validators.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.denyList = $59076e9d218a77a1$exports.StakeAuthorization_Validators.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.authorizationType = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        const message = Object.assign({}, $59076e9d218a77a1$var$baseStakeAuthorization);
        message.maxTokens = object.maxTokens !== undefined && object.maxTokens !== null ? $82ef09d1a8e2224d$exports.Coin.fromJSON(object.maxTokens) : undefined;
        message.allowList = object.allowList !== undefined && object.allowList !== null ? $59076e9d218a77a1$exports.StakeAuthorization_Validators.fromJSON(object.allowList) : undefined;
        message.denyList = object.denyList !== undefined && object.denyList !== null ? $59076e9d218a77a1$exports.StakeAuthorization_Validators.fromJSON(object.denyList) : undefined;
        message.authorizationType = object.authorizationType !== undefined && object.authorizationType !== null ? $59076e9d218a77a1$var$authorizationTypeFromJSON(object.authorizationType) : 0;
        return message;
    },
    toJSON (message) {
        const obj = {};
        message.maxTokens !== undefined && (obj.maxTokens = message.maxTokens ? $82ef09d1a8e2224d$exports.Coin.toJSON(message.maxTokens) : undefined);
        message.allowList !== undefined && (obj.allowList = message.allowList ? $59076e9d218a77a1$exports.StakeAuthorization_Validators.toJSON(message.allowList) : undefined);
        message.denyList !== undefined && (obj.denyList = message.denyList ? $59076e9d218a77a1$exports.StakeAuthorization_Validators.toJSON(message.denyList) : undefined);
        message.authorizationType !== undefined && (obj.authorizationType = $59076e9d218a77a1$var$authorizationTypeToJSON(message.authorizationType));
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $59076e9d218a77a1$var$baseStakeAuthorization);
        message.maxTokens = object.maxTokens !== undefined && object.maxTokens !== null ? $82ef09d1a8e2224d$exports.Coin.fromPartial(object.maxTokens) : undefined;
        message.allowList = object.allowList !== undefined && object.allowList !== null ? $59076e9d218a77a1$exports.StakeAuthorization_Validators.fromPartial(object.allowList) : undefined;
        message.denyList = object.denyList !== undefined && object.denyList !== null ? $59076e9d218a77a1$exports.StakeAuthorization_Validators.fromPartial(object.denyList) : undefined;
        message.authorizationType = (_a = object.authorizationType) !== null && _a !== void 0 ? _a : 0;
        return message;
    }
};
const $59076e9d218a77a1$var$baseStakeAuthorization_Validators = {
    address: ""
};
$59076e9d218a77a1$exports.StakeAuthorization_Validators = {
    encode (message, writer = $59076e9d218a77a1$var$minimal_1.default.Writer.create()) {
        for (const v of message.address)writer.uint32(10).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $59076e9d218a77a1$var$minimal_1.default.Reader ? input : new $59076e9d218a77a1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, $59076e9d218a77a1$var$baseStakeAuthorization_Validators);
        message.address = [];
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        var _a;
        const message = Object.assign({}, $59076e9d218a77a1$var$baseStakeAuthorization_Validators);
        message.address = ((_a = object.address) !== null && _a !== void 0 ? _a : []).map((e)=>String(e));
        return message;
    },
    toJSON (message) {
        const obj = {};
        if (message.address) obj.address = message.address.map((e)=>e);
        else obj.address = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = Object.assign({}, $59076e9d218a77a1$var$baseStakeAuthorization_Validators);
        message.address = ((_a = object.address) === null || _a === void 0 ? void 0 : _a.map((e)=>e)) || [];
        return message;
    }
};
if ($59076e9d218a77a1$var$minimal_1.default.util.Long !== $59076e9d218a77a1$var$long_1.default) {
    $59076e9d218a77a1$var$minimal_1.default.util.Long = $59076e9d218a77a1$var$long_1.default;
    $59076e9d218a77a1$var$minimal_1.default.configure();
}









var $c9wMV = parcelRequire("c9wMV");



function $a299f73caa82e67f$var$RevokeGrant(props) {
    const { address: address, wallet: wallet, grantAddress: grantAddress, grants: grants, signingClient: signingClient } = props;
    const buttonText = props.buttonText || "Revoke";
    async function revoke() {
        props.setError(null);
        if (props.setLoading) props.setLoading(true);
        let msgTypes = (0, (/*@__PURE__*/$parcel$interopDefault($c9wMV))).compact(grants).map((grant)=>{
            switch(grant.authorization["@type"]){
                case "/cosmos.staking.v1beta1.StakeAuthorization":
                    return "/cosmos.staking.v1beta1.MsgDelegate";
                case "/cosmos.authz.v1beta1.GenericAuthorization":
                    return grant.authorization.msg;
            }
        });
        let messages = msgTypes.map((type)=>buildRevokeMsg(type));
        if ((wallet === null || wallet === void 0 ? void 0 : wallet.address) !== address) messages = [
            (0, $2a6bf51ee962800d$export$61d88097eacac343)(wallet.address, messages)
        ];
        console.log(messages);
        try {
            const gas = await signingClient.simulate(wallet.address, messages);
            const result = await signingClient.signAndBroadcast(wallet.address, messages, gas);
            console.log("Successfully broadcasted:", result);
            if (props.setLoading) props.setLoading(false);
            props.onRevoke(grantAddress, msgTypes);
        } catch (error) {
            console.log("Failed to broadcast:", error);
            if (props.setLoading) props.setLoading(false);
            props.setError("Failed to broadcast: " + error.message);
        }
    }
    function buildRevokeMsg(type) {
        return (0, $2a6bf51ee962800d$export$9df738dbed799d5)((0, $d189b8fd7c99c4ec$exports.MsgRevoke), "/cosmos.authz.v1beta1.MsgRevoke", {
            granter: address,
            grantee: grantAddress,
            msgTypeUrl: type
        }, (wallet === null || wallet === void 0 ? void 0 : wallet.address) !== address);
    }
    function disabled() {
        return props.disabled || !(wallet === null || wallet === void 0 ? void 0 : wallet.hasPermission(address, "Revoke")) || !(wallet === null || wallet === void 0 ? void 0 : wallet.authzSupport());
    }
    if (props.button) return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a73f5336dfd04f2d$export$2e2bcd8739ae039), {
        variant: "danger",
        size: props.size,
        disabled: disabled(),
        onClick: ()=>revoke(),
        children: buttonText
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $47cad3b7d9bae545$export$2e2bcd8739ae039).Item, {
        as: "button",
        disabled: disabled(),
        onClick: ()=>revoke(),
        children: buttonText
    });
}
var $a299f73caa82e67f$export$2e2bcd8739ae039 = $a299f73caa82e67f$var$RevokeGrant;





function $d3ba8decaba28359$var$OperatorLastRestakeAlert(props) {
    const { operator: operator, lastExec: lastExec } = props;
    function showWarning() {
        if (!operator || lastExec == null) return;
        const missedRuns = operator.missedRunCount(lastExec);
        return missedRuns > Math.min(30, operator.runsPerDay() * 2);
    }
    if (!showWarning()) return null;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $c9bd276a69168a44$export$2e2bcd8739ae039), {
        variant: "danger",
        dismissible: false,
        children: "This validator has not REStaked recently."
    });
}
var $d3ba8decaba28359$export$2e2bcd8739ae039 = $d3ba8decaba28359$var$OperatorLastRestakeAlert;


function $8449cad4e489c157$var$REStakeGrantForm(props) {
    const { grants: grants, wallet: wallet, operator: operator, address: address, network: network, lastExec: lastExec } = props;
    const { stakeGrant: stakeGrant, maxTokens: maxTokens, validators: validators } = grants || {};
    const defaultExpiry = (0, (/*@__PURE__*/$parcel$interopDefault($2KWqD)))().add(1, "year");
    const [loading, setLoading] = (0, $6cds3.useState)(false);
    const [error, setError] = (0, $6cds3.useState)();
    const [state, setState] = (0, $6cds3.useReducer)((state, newState)=>({
            ...state,
            ...newState
        }), {
        maxTokensValue: "",
        expiryDateValue: defaultExpiry.format("YYYY-MM-DD")
    });
    const genericGrantOnly = wallet.signAminoSupportOnly() && network.authzAminoGenericOnly;
    const reward = (0, $2a6bf51ee962800d$export$31d336b0b7e2f20)(props.rewards, network.denom);
    (0, $6cds3.useEffect)(()=>{
        setState({
            validators: validators || !stakeGrant && !genericGrantOnly && [
                operator.address
            ],
            maxTokens: maxTokens,
            expiryDate: expiryDate()
        });
    }, [
        grants,
        operator
    ]);
    (0, $6cds3.useEffect)(()=>{
        setState({
            expiryDateValue: (expiryDate() || defaultExpiry).format("YYYY-MM-DD"),
            maxTokensValue: maxTokens && state.maxTokensValue === "" ? (0, $ed89d4c20b089b73$export$cd007d971a5a2143)((0, $ed89d4c20b089b73$export$8576f72eb7f14a7e)(maxTokens), (0, $ed89d4c20b089b73$export$9c297f60e22e3389)(10, network.decimals)) : maxTokens ? state.maxTokensValue : ""
        });
    }, [
        operator
    ]);
    function handleInputChange(e) {
        setState({
            [e.target.name]: e.target.value
        });
    }
    function expiryDate() {
        const stakeExpiry = stakeGrant && stakeGrant.expiration && (0, (/*@__PURE__*/$parcel$interopDefault($2KWqD)))(stakeGrant.expiration);
        return stakeExpiry;
    }
    function maxTokensDenom() {
        if (state.maxTokensValue === "") return;
        const decimals = (0, $ed89d4c20b089b73$export$9c297f60e22e3389)(10, network.decimals);
        return (0, $ed89d4c20b089b73$export$8576f72eb7f14a7e)((0, $ed89d4c20b089b73$export$2060d2db72cce88f)(state.maxTokensValue, decimals));
    }
    function maxTokensValid() {
        return !maxTokensDenom() || (0, $ed89d4c20b089b73$export$a94a7414fa942aea)(maxTokensDenom(), reward);
    }
    function showLoading(isLoading) {
        setLoading(isLoading);
        props.setLoading && props.setLoading(isLoading);
    }
    function handleSubmit(event) {
        event.preventDefault();
        setError(null);
        showLoading(true);
        const expiry = (0, (/*@__PURE__*/$parcel$interopDefault($2KWqD)))(state.expiryDateValue);
        let maxTokens;
        if (state.maxTokensValue !== "") maxTokens = (0, $2a6bf51ee962800d$export$3c9d1e4131afeeb8)(maxTokensDenom(), network.denom);
        let messages;
        if (genericGrantOnly) messages = [
            buildGrantMsg("/cosmos.authz.v1beta1.GenericAuthorization", (0, $e556dc7c9dd62702$exports.GenericAuthorization).encode((0, $e556dc7c9dd62702$exports.GenericAuthorization).fromPartial({
                msg: "/cosmos.staking.v1beta1.MsgDelegate"
            })).finish(), expiry)
        ];
        else messages = [
            buildGrantMsg("/cosmos.staking.v1beta1.StakeAuthorization", (0, $59076e9d218a77a1$exports.StakeAuthorization).encode((0, $59076e9d218a77a1$exports.StakeAuthorization).fromPartial({
                allowList: {
                    address: [
                        operator.address
                    ]
                },
                maxTokens: maxTokens,
                authorizationType: 1
            })).finish(), expiry)
        ];
        console.log(messages);
        props.signingClient.signAndBroadcast(wallet.address, messages).then((result)=>{
            console.log("Successfully broadcasted:", result);
            showLoading(false);
            props.onGrant(operator.botAddress, {
                grantee: operator.botAddress,
                granter: address,
                expiration: expiry,
                authorization: genericGrantOnly ? {
                    "@type": "/cosmos.authz.v1beta1.GenericAuthorization",
                    msg: "/cosmos.staking.v1beta1.MsgDelegate"
                } : {
                    "@type": "/cosmos.staking.v1beta1.StakeAuthorization",
                    max_tokens: maxTokens,
                    allow_list: {
                        address: [
                            operator.address
                        ]
                    }
                }
            });
        }, (error)=>{
            console.log("Failed to broadcast:", error);
            showLoading(false);
            setError("Failed to broadcast: " + error.message);
        });
    }
    function buildGrantMsg(type, authValue, expiryDate) {
        const value = {
            granter: address,
            grantee: operator.botAddress,
            grant: {
                authorization: {
                    typeUrl: type,
                    value: authValue
                },
                expiration: (0, $d6c3291d6aa8eb5b$exports.Timestamp).fromPartial({
                    seconds: expiryDate.unix(),
                    nanos: 0
                })
            }
        };
        if ((wallet === null || wallet === void 0 ? void 0 : wallet.address) !== address) return (0, $2a6bf51ee962800d$export$61d88097eacac343)(wallet.address, [
            {
                typeUrl: "/cosmos.authz.v1beta1.MsgGrant",
                value: (0, $d189b8fd7c99c4ec$exports.MsgGrant).encode((0, $d189b8fd7c99c4ec$exports.MsgGrant).fromPartial(value)).finish()
            }
        ]);
        else return {
            typeUrl: "/cosmos.authz.v1beta1.MsgGrant",
            value: value
        };
    }
    function grantInformation() {
        return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                    className: "small",
                    children: [
                        operator.moniker,
                        " will be able to carry out the following transactions on your behalf:"
                    ]
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                    className: "small",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                            children: "Delegate"
                        }),
                        " - allowed to delegate ",
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("em", {
                            children: maxTokensDenom() ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $edd3c36e8c82dfd7$export$2e2bcd8739ae039), {
                                coins: {
                                    amount: maxTokensDenom(),
                                    denom: network.denom
                                },
                                asset: network.baseAsset,
                                fullPrecision: true,
                                hideValue: true
                            }) : "any amount"
                        }),
                        " to ",
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("em", {
                            children: !state.validators ? "any validator" : !state.validators.length || state.validators.length === 1 && state.validators.includes(operator.address) ? "only their own validator" : "validators " + state.validators.join(", ")
                        }),
                        "."
                    ]
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                    className: "small",
                    children: [
                        "This grant will expire automatically on ",
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("em", {
                            children: state.expiryDateValue
                        }),
                        "."
                    ]
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                    className: "small",
                    children: [
                        "REStake only re-delegates ",
                        operator.moniker,
                        "'s accrued rewards and tries not to touch your balance."
                    ]
                }),
                genericGrantOnly && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                    className: "small",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("em", {
                        children: [
                            network.prettyName,
                            " only supports generic Authz grants with this wallet, full support is coming soon."
                        ]
                    })
                })
            ]
        });
    }
    const step = ()=>{
        return 1 / (0, $ed89d4c20b089b73$export$9c297f60e22e3389)(10, network.decimals);
    };
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $d3ba8decaba28359$export$2e2bcd8739ae039), {
                operator: operator,
                lastExec: lastExec
            }),
            error && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $c9bd276a69168a44$export$2e2bcd8739ae039), {
                variant: "danger",
                className: "text-break small",
                children: error
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039), {
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: "col-12 col-md-6 order-md-1 mb-3",
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("fieldset", {
                                    disabled: !props.address || !props.wallet,
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039).Group, {
                                            className: "mb-3",
                                            children: [
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039).Label, {
                                                    children: "Max amount"
                                                }),
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                                    className: "mb-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                                            className: "input-group",
                                                            children: [
                                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039).Control, {
                                                                    type: "number",
                                                                    disabled: genericGrantOnly,
                                                                    name: "maxTokensValue",
                                                                    min: (0, $ed89d4c20b089b73$export$cd007d971a5a2143)(1, (0, $ed89d4c20b089b73$export$9c297f60e22e3389)(10, network.decimals)),
                                                                    className: !maxTokensValid() ? "is-invalid" : "is-valid",
                                                                    step: step(),
                                                                    placeholder: maxTokens ? (0, $ed89d4c20b089b73$export$cd007d971a5a2143)((0, $ed89d4c20b089b73$export$8576f72eb7f14a7e)(maxTokens), (0, $ed89d4c20b089b73$export$9c297f60e22e3389)(10, network.decimals)) : "Unlimited",
                                                                    required: false,
                                                                    value: state.maxTokensValue,
                                                                    onChange: handleInputChange
                                                                }),
                                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                                    className: "input-group-text",
                                                                    children: network.symbol
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                                            className: "form-text text-end",
                                                            children: genericGrantOnly ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                                                                children: [
                                                                    network.prettyName,
                                                                    " does not support amount with this wallet yet"
                                                                ]
                                                            }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                                                                children: [
                                                                    "Reduces with every delegation made by the validator",
                                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                                                                    "Leave empty for unlimited"
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039).Group, {
                                            className: "mb-3",
                                            children: [
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039).Label, {
                                                    children: "Expiry date"
                                                }),
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039).Control, {
                                                    type: "date",
                                                    className: "text-start",
                                                    name: "expiryDateValue",
                                                    min: (0, (/*@__PURE__*/$parcel$interopDefault($2KWqD)))().format("YYYY-MM-DD"),
                                                    required: true,
                                                    value: state.expiryDateValue,
                                                    onChange: handleInputChange
                                                }),
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                                    className: "form-text text-end",
                                                    children: "Date the grant expires, after which you will need to re-grant"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: "col-12 col-md-6 mb-3",
                                children: grantInformation()
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "text-end",
                        children: !loading ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            className: "d-flex justify-content-end gap-2",
                            children: [
                                props.closeForm && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a73f5336dfd04f2d$export$2e2bcd8739ae039), {
                                    variant: "secondary",
                                    onClick: props.closeForm,
                                    children: "Cancel"
                                }),
                                (grants === null || grants === void 0 ? void 0 : grants.grantsExist) && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a299f73caa82e67f$export$2e2bcd8739ae039), {
                                    button: true,
                                    address: address,
                                    wallet: wallet,
                                    operator: operator,
                                    grants: [
                                        grants.stakeGrant,
                                        grants.claimGrant
                                    ],
                                    grantAddress: operator.botAddress,
                                    signingClient: props.signingClient,
                                    onRevoke: props.onRevoke,
                                    setLoading: (loading)=>showLoading(loading),
                                    setError: setError,
                                    buttonText: "Disable"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a73f5336dfd04f2d$export$2e2bcd8739ae039), {
                                    type: "submit",
                                    disabled: !(wallet === null || wallet === void 0 ? void 0 : wallet.hasPermission(address, "Grant")),
                                    className: "btn btn-primary",
                                    children: (grants === null || grants === void 0 ? void 0 : grants.grantsExist) ? "Update" : "Enable REStake"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $a73f5336dfd04f2d$export$2e2bcd8739ae039), {
                            className: "btn btn-primary",
                            type: "button",
                            disabled: true,
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                    className: "spinner-border spinner-border-sm",
                                    role: "status",
                                    "aria-hidden": "true"
                                }),
                                "\xa0"
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
var $8449cad4e489c157$export$2e2bcd8739ae039 = $8449cad4e489c157$var$REStakeGrantForm;




var $6cds3 = parcelRequire("6cds3");
var $e546e10a1daf5b5e$exports = {};
"use strict";
var $b9ab6c3d0caa6e24$exports = {};
"use strict";
function $b9ab6c3d0caa6e24$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $b9ab6c3d0caa6e24$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $b9ab6c3d0caa6e24$var$_typeof(obj);
}
Object.defineProperty($b9ab6c3d0caa6e24$exports, "__esModule", {
    value: true
});
$b9ab6c3d0caa6e24$exports.CopyToClipboard = void 0;

var $b9ab6c3d0caa6e24$var$_react = $b9ab6c3d0caa6e24$var$_interopRequireDefault((parcelRequire("6cds3")));

var $b9ab6c3d0caa6e24$var$_copyToClipboard = $b9ab6c3d0caa6e24$var$_interopRequireDefault((parcelRequire("1iAxI")));
var $b9ab6c3d0caa6e24$var$_excluded = [
    "text",
    "onCopy",
    "options",
    "children"
];
function $b9ab6c3d0caa6e24$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $b9ab6c3d0caa6e24$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b9ab6c3d0caa6e24$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b9ab6c3d0caa6e24$var$ownKeys(Object(source), !0).forEach(function(key) {
            $b9ab6c3d0caa6e24$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b9ab6c3d0caa6e24$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b9ab6c3d0caa6e24$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b9ab6c3d0caa6e24$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $b9ab6c3d0caa6e24$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $b9ab6c3d0caa6e24$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b9ab6c3d0caa6e24$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $b9ab6c3d0caa6e24$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b9ab6c3d0caa6e24$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b9ab6c3d0caa6e24$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $b9ab6c3d0caa6e24$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $b9ab6c3d0caa6e24$var$_setPrototypeOf(subClass, superClass);
}
function $b9ab6c3d0caa6e24$var$_setPrototypeOf(o, p) {
    $b9ab6c3d0caa6e24$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b9ab6c3d0caa6e24$var$_setPrototypeOf(o, p);
}
function $b9ab6c3d0caa6e24$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $b9ab6c3d0caa6e24$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $b9ab6c3d0caa6e24$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $b9ab6c3d0caa6e24$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $b9ab6c3d0caa6e24$var$_possibleConstructorReturn(this, result);
    };
}
function $b9ab6c3d0caa6e24$var$_possibleConstructorReturn(self, call) {
    if (call && ($b9ab6c3d0caa6e24$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $b9ab6c3d0caa6e24$var$_assertThisInitialized(self);
}
function $b9ab6c3d0caa6e24$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $b9ab6c3d0caa6e24$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $b9ab6c3d0caa6e24$var$_getPrototypeOf(o) {
    $b9ab6c3d0caa6e24$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $b9ab6c3d0caa6e24$var$_getPrototypeOf(o);
}
function $b9ab6c3d0caa6e24$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $b9ab6c3d0caa6e24$var$CopyToClipboard = /*#__PURE__*/ function(_React$PureComponent) {
    $b9ab6c3d0caa6e24$var$_inherits(CopyToClipboard, _React$PureComponent);
    var _super = $b9ab6c3d0caa6e24$var$_createSuper(CopyToClipboard);
    function CopyToClipboard() {
        var _this;
        $b9ab6c3d0caa6e24$var$_classCallCheck(this, CopyToClipboard);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $b9ab6c3d0caa6e24$var$_defineProperty($b9ab6c3d0caa6e24$var$_assertThisInitialized(_this), "onClick", function(event) {
            var _this$props = _this.props, text = _this$props.text, onCopy = _this$props.onCopy, children = _this$props.children, options = _this$props.options;
            var elem = $b9ab6c3d0caa6e24$var$_react["default"].Children.only(children);
            var result = (0, $b9ab6c3d0caa6e24$var$_copyToClipboard["default"])(text, options);
            if (onCopy) onCopy(text, result);
             // Bypass onClick if it was present
            if (elem && elem.props && typeof elem.props.onClick === "function") elem.props.onClick(event);
        });
        return _this;
    }
    $b9ab6c3d0caa6e24$var$_createClass(CopyToClipboard, [
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, _text = _this$props2.text, _onCopy = _this$props2.onCopy, _options = _this$props2.options, children = _this$props2.children, props = $b9ab6c3d0caa6e24$var$_objectWithoutProperties(_this$props2, $b9ab6c3d0caa6e24$var$_excluded);
                var elem = $b9ab6c3d0caa6e24$var$_react["default"].Children.only(children);
                return /*#__PURE__*/ $b9ab6c3d0caa6e24$var$_react["default"].cloneElement(elem, $b9ab6c3d0caa6e24$var$_objectSpread($b9ab6c3d0caa6e24$var$_objectSpread({}, props), {}, {
                    onClick: this.onClick
                }));
            }
        }
    ]);
    return CopyToClipboard;
}($b9ab6c3d0caa6e24$var$_react["default"].PureComponent);
$b9ab6c3d0caa6e24$exports.CopyToClipboard = $b9ab6c3d0caa6e24$var$CopyToClipboard;
$b9ab6c3d0caa6e24$var$_defineProperty($b9ab6c3d0caa6e24$var$CopyToClipboard, "defaultProps", {
    onCopy: undefined,
    options: undefined
});


var $e546e10a1daf5b5e$var$CopyToClipboard = $b9ab6c3d0caa6e24$exports.CopyToClipboard;
$e546e10a1daf5b5e$var$CopyToClipboard.CopyToClipboard = $e546e10a1daf5b5e$var$CopyToClipboard;
$e546e10a1daf5b5e$exports = $e546e10a1daf5b5e$var$CopyToClipboard;



var $6cds3 = parcelRequire("6cds3");

var $aMJGV = parcelRequire("aMJGV");
var $73debbb3a1242b4c$var$_excluded = [
    "color",
    "size",
    "title"
];
function $73debbb3a1242b4c$var$_extends() {
    $73debbb3a1242b4c$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $73debbb3a1242b4c$var$_extends.apply(this, arguments);
}
function $73debbb3a1242b4c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $73debbb3a1242b4c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $73debbb3a1242b4c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $73debbb3a1242b4c$var$ClipboardCheck = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, rest = $73debbb3a1242b4c$var$_objectWithoutProperties(_ref, $73debbb3a1242b4c$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("svg", $73debbb3a1242b4c$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        fillRule: "evenodd",
        d: "M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0z"
    }));
});
$73debbb3a1242b4c$var$ClipboardCheck.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string
};
$73debbb3a1242b4c$var$ClipboardCheck.defaultProps = {
    color: "currentColor",
    size: "1em",
    title: null
};
var $73debbb3a1242b4c$export$2e2bcd8739ae039 = $73debbb3a1242b4c$var$ClipboardCheck;


var $6cds3 = parcelRequire("6cds3");

var $aMJGV = parcelRequire("aMJGV");
var $5602cbef70cef3bb$var$_excluded = [
    "color",
    "size",
    "title"
];
function $5602cbef70cef3bb$var$_extends() {
    $5602cbef70cef3bb$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5602cbef70cef3bb$var$_extends.apply(this, arguments);
}
function $5602cbef70cef3bb$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $5602cbef70cef3bb$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $5602cbef70cef3bb$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $5602cbef70cef3bb$var$Clipboard = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, rest = $5602cbef70cef3bb$var$_objectWithoutProperties(_ref, $5602cbef70cef3bb$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("svg", $5602cbef70cef3bb$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0z"
    }));
});
$5602cbef70cef3bb$var$Clipboard.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string
};
$5602cbef70cef3bb$var$Clipboard.defaultProps = {
    color: "currentColor",
    size: "1em",
    title: null
};
var $5602cbef70cef3bb$export$2e2bcd8739ae039 = $5602cbef70cef3bb$var$Clipboard;




function $9c3e840bb4db5007$var$Address(props) {
    const { address: address } = props;
    const [copied, setCopied] = (0, $6cds3.useState)(false);
    function setCopiedTimeout() {
        setCopied(true);
        setTimeout(()=>{
            setCopied(false);
        }, 2000);
    }
    const Element = props.as ? props.as : "span";
    const className = [
        `address-container d-flex align-items-center hover-show`,
        props.className
    ].join(" ");
    const addressClassName = [
        `address`,
        props.addressClassName
    ].join(" ");
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Element, {
                className: addressClassName,
                role: props.onClick && "button",
                onClick: props.onClick,
                children: (0, $2a6bf51ee962800d$export$cd8822fabcdefd67)(address)
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc7c852c832d97ac$export$2e2bcd8739ae039), {
                tooltip: "Copy address",
                rootClose: true,
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                    className: "ms-2",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e546e10a1daf5b5e$exports))), {
                        text: address,
                        onCopy: ()=>setCopiedTimeout(),
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                            role: "button",
                            children: copied ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $73debbb3a1242b4c$export$2e2bcd8739ae039), {
                                className: "d-block"
                            }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5602cbef70cef3bb$export$2e2bcd8739ae039), {
                                className: "d-block hover-target"
                            })
                        })
                    })
                })
            }),
            props.children
        ]
    });
}
var $9c3e840bb4db5007$export$2e2bcd8739ae039 = $9c3e840bb4db5007$var$Address;





function $2e2d1aba03134c53$var$OperatorLastRestake(props) {
    const { operator: operator, lastExec: lastExec } = props;
    function classname() {
        if (!operator || lastExec == null) return;
        const missedRuns = operator.missedRunCount(lastExec);
        const warning = missedRuns > Math.min(20, operator.runsPerDay());
        const error = missedRuns > Math.min(30, operator.runsPerDay() * 2);
        return error ? "text-danger" : warning ? "text-warning" : "text-success";
    }
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: "d-flex align-items-center",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                children: lastExec != null ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                    className: classname(operator, lastExec),
                    children: lastExec ? lastExec === null || lastExec === void 0 ? void 0 : lastExec.fromNow() : "Not recently"
                }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                    className: "spinner-border spinner-border-sm",
                    role: "status",
                    "aria-hidden": "true"
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc7c852c832d97ac$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f97e350cddc6443b$export$2e2bcd8739ae039), {
                    className: "ms-2"
                }),
                identifier: operator.address,
                tooltip: "Based on the last REStake transaction sent by this validator for any of their users. Not every run generates a transaction."
            })
        ]
    });
}
var $2e2d1aba03134c53$export$2e2bcd8739ae039 = $2e2d1aba03134c53$var$OperatorLastRestake;



parcelRequire("6cds3");


var $aFk2u = parcelRequire("aFk2u");

function $a4a4080ed61929e8$var$CountdownRestake(props) {
    const { operator: operator, network: network, maxAmount: maxAmount, icon: icon } = props;
    const nextRun = ()=>{
        if (!operator) return null;
        return operator.nextRun();
    };
    const countdownRenderer = ({ hours: hours, minutes: minutes, seconds: seconds, completed: completed })=>{
        var _nextRun;
        let string = (_nextRun = nextRun()) === null || _nextRun === void 0 ? void 0 : _nextRun.fromNow(false);
        if (props.renderText) return props.renderText(string);
        return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                children: string
            })
        });
    };
    if (!nextRun()) return null;
    return icon ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc7c852c832d97ac$export$2e2bcd8739ae039), {
        icon: icon,
        identifier: operator.address,
        rootClose: props.rootClose,
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
            className: "mt-2 text-center",
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $aFk2u.default), {
                    date: nextRun().unix(),
                    renderer: countdownRenderer
                }),
                maxAmount && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                    children: [
                        "Grant remaining: ",
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $edd3c36e8c82dfd7$export$2e2bcd8739ae039), {
                            coins: {
                                amount: maxAmount,
                                denom: props.network.denom
                            },
                            asset: network.baseAsset,
                            fullPrecision: true,
                            hideValue: true
                        })
                    ]
                })
            ]
        })
    }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $aFk2u.default), {
                date: nextRun().unix(),
                renderer: countdownRenderer
            }),
            maxAmount && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                children: [
                    "Grant remaining: ",
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $edd3c36e8c82dfd7$export$2e2bcd8739ae039), {
                        coins: {
                            amount: maxAmount,
                            denom: props.network.denom
                        },
                        asset: network.baseAsset,
                        fullPrecision: true,
                        hideValue: true
                    })
                ]
            })
        ]
    });
}
var $a4a4080ed61929e8$export$2e2bcd8739ae039 = $a4a4080ed61929e8$var$CountdownRestake;




function $5d49fb3667eae65e$var$ValidatorStatus(props) {
    const { validator: validator } = props;
    if (!validator) return null;
    const status = validator.active ? "Active" : validator.jailed ? "Jailed" : validator.active != null ? "Inactive" : "Unknown";
    let className = validator.active ? "" : "text-danger";
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
        className: className,
        children: status
    });
}
var $5d49fb3667eae65e$export$2e2bcd8739ae039 = $5d49fb3667eae65e$var$ValidatorStatus;


function $820674bc8d9aaa39$var$ValidatorStake(props) {
    var _delegation_balance, _delegation_balance1, _delegation_balance2, _delegation_balance3;
    const { network: network, validator: validator, operator: operator, balance: balance, wallet: wallet, address: address, lastExec: lastExec } = props;
    const [action, setAction] = (0, $6cds3.useState)(props.action);
    const [selectedValidator, setSelectedValidator] = (0, $6cds3.useState)();
    const [loading, setLoading] = (0, $6cds3.useState)(false);
    const [error, setError] = (0, $6cds3.useState)();
    const delegation = props.delegations && props.delegations[validator.address];
    const validatorRewards = props.rewards && props.rewards[validator.address];
    const reward = (0, $2a6bf51ee962800d$export$31d336b0b7e2f20)(validatorRewards, network.denom);
    const validatorCommission = props.commission && props.commission[validator.address];
    const commission = (0, $2a6bf51ee962800d$export$31d336b0b7e2f20)(validatorCommission, network.denom, "commission");
    const validatorGrants = props.grants && operator && props.grants[operator.botAddress];
    const { grantsValid: grantsValid, grantsExist: grantsExist, maxTokens: maxTokens, stakeGrant: stakeGrant } = validatorGrants || {};
    (0, $6cds3.useEffect)(()=>{
        setAction(props.action);
    }, [
        props.action
    ]);
    (0, $6cds3.useEffect)(()=>{
        setError();
        props.onChangeAction && props.onChangeAction(action);
    }, [
        action
    ]);
    function actionText() {
        if (action === "redelegate") {
            if (selectedValidator) return `Redelegate to ${selectedValidator.moniker}`;
            return "Redelegate to...";
        }
        if (action === "undelegate") return `Undelegate from ${validator.moniker}`;
        if (action === "grant") return `${grantsValid ? "Manage" : "Enable"} ${validator.moniker} REStake`;
        return `Delegate to  ${validator.moniker}`;
    }
    function onDelegate() {
        setAction();
        props.onDelegate();
    }
    function onGrant(grantee, grant) {
        setAction();
        props.onGrant(grantee, grant);
    }
    function onRevoke(grantee, msgTypes) {
        setAction();
        props.onRevoke(grantee, msgTypes);
    }
    const minimumReward = ()=>{
        return {
            amount: operator.minimumReward,
            denom: network.denom
        };
    };
    function expiryDate() {
        const stakeExpiry = stakeGrant && stakeGrant.expiration && (0, (/*@__PURE__*/$parcel$interopDefault($2KWqD)))(stakeGrant.expiration);
        return stakeExpiry;
    }
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: [
            error && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $c9bd276a69168a44$export$2e2bcd8739ae039), {
                variant: "danger",
                dismissible: true,
                children: error
            }),
            action ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        className: "d-flex align-items-center my-3",
                        children: [
                            action && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8288da627a9a79fa$export$2e2bcd8739ae039), {
                                className: "me-1",
                                role: "button",
                                onClick: ()=>{
                                    action === "redelegate" && selectedValidator ? setSelectedValidator() : setAction();
                                }
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h5", {
                                className: "m-0",
                                children: actionText()
                            })
                        ]
                    }),
                    action === "redelegate" && !selectedValidator ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $163e26a5c9452562$export$2e2bcd8739ae039), {
                                modal: true,
                                network: network,
                                address: props.address,
                                wallet: props.wallet,
                                validators: props.validators,
                                operators: props.operators,
                                exclude: [
                                    validator.operator_address
                                ],
                                validatorApy: props.validatorApy,
                                rewards: props.rewards,
                                delegations: props.delegations,
                                operatorGrants: props.grants,
                                authzSupport: props.authzSupport,
                                restakePossible: props.restakePossible,
                                showValidator: setSelectedValidator,
                                isLoading: props.isLoading,
                                buttonText: "Redelegate"
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: "d-flex justify-content-end gap-2",
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a73f5336dfd04f2d$export$2e2bcd8739ae039), {
                                    variant: "secondary",
                                    onClick: ()=>setAction(),
                                    children: "Cancel"
                                })
                            })
                        ]
                    }) : action === "grant" ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8449cad4e489c157$export$2e2bcd8739ae039), {
                        network: network,
                        address: props.address,
                        wallet: props.wallet,
                        operator: operator,
                        lastExec: lastExec,
                        grants: validatorGrants,
                        delegation: delegation,
                        rewards: validatorRewards,
                        validatorApy: props.validatorApy,
                        authzSupport: props.authzSupport,
                        restakePossible: props.restakePossible,
                        signingClient: props.signingClient,
                        closeForm: ()=>setAction(),
                        onGrant: onGrant,
                        onRevoke: onRevoke
                    }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $44ae7ef333bfe594$export$2e2bcd8739ae039), {
                        action: action,
                        network: network,
                        validator: validator,
                        selectedValidator: selectedValidator,
                        address: address,
                        wallet: wallet,
                        balance: balance,
                        delegation: delegation,
                        signingClient: props.signingClient,
                        closeForm: ()=>setAction(),
                        onDelegate: onDelegate
                    })
                ]
            }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: "col-12 col-lg-6 small mb-3",
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $36688d56d3c1862c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tbody", {
                                        children: [
                                            !validator.active && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                        scope: "row",
                                                        children: "Status"
                                                    }),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5d49fb3667eae65e$export$2e2bcd8739ae039), {
                                                            validator: validator
                                                        })
                                                    })
                                                ]
                                            }),
                                            network.apyEnabled && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                                scope: "row",
                                                                children: "APR"
                                                            }),
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                                                    className: "d-flex align-items-center",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("span", {
                                                                            children: [
                                                                                (0, $ed89d4c20b089b73$export$2077e0241d6afd3c)(validator.getAPR() * 100, 2).toLocaleString(),
                                                                                "%"
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc7c852c832d97ac$export$2e2bcd8739ae039), {
                                                                            icon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f97e350cddc6443b$export$2e2bcd8739ae039), {
                                                                                className: "ms-2"
                                                                            }),
                                                                            identifier: "delegations-apr",
                                                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                                                                className: "mt-2 text-center",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                                                                                        children: [
                                                                                            (0, $ed89d4c20b089b73$export$2077e0241d6afd3c)(network.chain.estimatedApr * 100, 2).toLocaleString(),
                                                                                            "% staking APR",
                                                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                                                                                            "- ",
                                                                                            validator.commissionRate * 100,
                                                                                            "% commission"
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                                                                        children: "Staking APR is calculated based on recent block time and is not guaranteed."
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    operator && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                                scope: "row",
                                                                children: "APY"
                                                            }),
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                                                    className: "d-flex align-items-center",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("span", {
                                                                            children: [
                                                                                (0, $ed89d4c20b089b73$export$2077e0241d6afd3c)(validator.getAPY(operator) * 100, 2).toLocaleString(),
                                                                                "%"
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc7c852c832d97ac$export$2e2bcd8739ae039), {
                                                                            icon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f97e350cddc6443b$export$2e2bcd8739ae039), {
                                                                                className: "ms-2"
                                                                            }),
                                                                            identifier: "delegations-apy",
                                                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                                                                className: "mt-2 text-center",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                                                                                        children: [
                                                                                            (0, $ed89d4c20b089b73$export$2077e0241d6afd3c)(validator.getAPR() * 100, 2).toLocaleString(),
                                                                                            "% APR compounded ",
                                                                                            operator.frequency(true),
                                                                                            " by ",
                                                                                            validator.moniker,
                                                                                            "."
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                                                                        children: "This is an estimate and best case scenario."
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            address && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                        scope: "row",
                                                        children: "Delegation"
                                                    }),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                        className: "text-break",
                                                        children: !props.isLoading("delegations") ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $edd3c36e8c82dfd7$export$2e2bcd8739ae039), {
                                                            coins: (delegation === null || delegation === void 0 ? void 0 : delegation.balance) || {
                                                                amount: 0,
                                                                denom: network.denom
                                                            },
                                                            asset: network.baseAsset,
                                                            fullPrecision: true
                                                        }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $39ebe134e7977f3e$export$2e2bcd8739ae039), {
                                                            animation: "border",
                                                            role: "status",
                                                            className: "spinner-border-sm",
                                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                                className: "visually-hidden",
                                                                children: "Loading..."
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            (delegation === null || delegation === void 0 ? void 0 : (_delegation_balance = delegation.balance) === null || _delegation_balance === void 0 ? void 0 : _delegation_balance.amount) && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                        scope: "row",
                                                        children: "Rewards"
                                                    }),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                        children: !props.isLoading("rewards") ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $edd3c36e8c82dfd7$export$2e2bcd8739ae039), {
                                                            coins: {
                                                                amount: reward,
                                                                denom: network.denom
                                                            },
                                                            asset: network.baseAsset,
                                                            fullPrecision: true
                                                        }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $39ebe134e7977f3e$export$2e2bcd8739ae039), {
                                                            animation: "border",
                                                            role: "status",
                                                            className: "spinner-border-sm",
                                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                                className: "visually-hidden",
                                                                children: "Loading..."
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            !!commission && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                        scope: "row",
                                                        children: "Commission"
                                                    }),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                        children: !props.isLoading("commission") ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $edd3c36e8c82dfd7$export$2e2bcd8739ae039), {
                                                            coins: {
                                                                amount: commission,
                                                                denom: network.denom
                                                            },
                                                            asset: network.baseAsset,
                                                            fullPrecision: true
                                                        }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $39ebe134e7977f3e$export$2e2bcd8739ae039), {
                                                            animation: "border",
                                                            role: "status",
                                                            className: "spinner-border-sm",
                                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                                className: "visually-hidden",
                                                                children: "Loading..."
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: "col-12 col-lg-6 small mb-3",
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $36688d56d3c1862c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tbody", {
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                        scope: "row",
                                                        children: "REStake"
                                                    }),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                        children: operator ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc7c852c832d97ac$export$2e2bcd8739ae039), {
                                                            icon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $98e6c3958c713811$export$2e2bcd8739ae039), {
                                                                className: "text-success"
                                                            }),
                                                            identifier: validator.operator_address,
                                                            tooltip: "This validator can REStake your rewards"
                                                        }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc7c852c832d97ac$export$2e2bcd8739ae039), {
                                                            icon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $ac4c3421df377bd7$export$2e2bcd8739ae039), {
                                                                className: "opacity-50"
                                                            }),
                                                            identifier: validator.operator_address,
                                                            tooltip: "This validator is not a REStake operator"
                                                        })
                                                    })
                                                ]
                                            }),
                                            operator && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                                scope: "row",
                                                                children: "Frequency"
                                                            }),
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                                    children: operator.runTimesString()
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                                scope: "row",
                                                                children: "Minimum Reward"
                                                            }),
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $edd3c36e8c82dfd7$export$2e2bcd8739ae039), {
                                                                    coins: minimumReward(),
                                                                    asset: network.baseAsset,
                                                                    fullPrecision: true,
                                                                    hideValue: true
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    network.authzSupport && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                                        scope: "row",
                                                                        children: "Last REStake"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2e2d1aba03134c53$export$2e2bcd8739ae039), {
                                                                            operator: operator,
                                                                            lastExec: lastExec
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                                        scope: "row",
                                                                        children: "Next REStake"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a4a4080ed61929e8$export$2e2bcd8739ae039), {
                                                                            network: network,
                                                                            operator: operator
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                                scope: "row",
                                                                children: "REStake Address"
                                                            }),
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                                className: "text-break",
                                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9c3e840bb4db5007$export$2e2bcd8739ae039), {
                                                                    address: operator.botAddress
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    props.address && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                                        scope: "row",
                                                                        children: "Grant Status"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                                        children: !props.isLoading("grants") ? grantsValid ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("span", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                                                    className: "text-success",
                                                                                    children: "Active"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                                                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("small", {
                                                                                    className: "text-muted",
                                                                                    children: [
                                                                                        "expires ",
                                                                                        expiryDate().fromNow()
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }) : grantsExist ? validatorGrants.validators && !validatorGrants.validators.includes(validator.address) ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                                            className: "text-danger",
                                                                            children: "Grant invalid"
                                                                        }) : maxTokens && (0, $ed89d4c20b089b73$export$3f732695c1493aec)(maxTokens, reward) ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                                            className: "text-danger",
                                                                            children: "Not enough grant remaining"
                                                                        }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                                            className: "text-danger",
                                                                            children: "Invalid / total delegation reached"
                                                                        }) : network.authzSupport ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("em", {
                                                                            children: "Inactive"
                                                                        }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("em", {
                                                                            children: "Authz not supported"
                                                                        }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $39ebe134e7977f3e$export$2e2bcd8739ae039), {
                                                                            animation: "border",
                                                                            role: "status",
                                                                            className: "spinner-border-sm",
                                                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                                                className: "visually-hidden",
                                                                                children: "Loading..."
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            grantsExist && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                                        scope: "row",
                                                                        children: "Grant Remaining"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                                        className: !reward || maxTokens == null || (0, $ed89d4c20b089b73$export$a94a7414fa942aea)(maxTokens, reward) ? "text-success" : "text-danger",
                                                                        children: maxTokens ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $edd3c36e8c82dfd7$export$2e2bcd8739ae039), {
                                                                            coins: {
                                                                                amount: maxTokens,
                                                                                denom: network.denom
                                                                            },
                                                                            asset: network.baseAsset,
                                                                            fullPrecision: true
                                                                        }) : "Unlimited"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        className: "d-flex justify-content-end gap-2",
                        children: [
                            (delegation === null || delegation === void 0 ? void 0 : (_delegation_balance1 = delegation.balance) === null || _delegation_balance1 === void 0 ? void 0 : _delegation_balance1.amount) && wallet && (!loading ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $47cad3b7d9bae545$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $47cad3b7d9bae545$export$2e2bcd8739ae039).Toggle, {
                                        variant: "secondary",
                                        children: "Manage"
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $47cad3b7d9bae545$export$2e2bcd8739ae039).Menu, {
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5bf75ab82b3b05cf$export$2e2bcd8739ae039), {
                                                network: network,
                                                address: address,
                                                wallet: wallet,
                                                rewards: validatorRewards && [
                                                    validatorRewards
                                                ],
                                                signingClient: props.signingClient,
                                                onClaimRewards: props.onClaimRewards,
                                                setLoading: (loading)=>setLoading(loading),
                                                setError: setError
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5bf75ab82b3b05cf$export$2e2bcd8739ae039), {
                                                restake: true,
                                                network: network,
                                                address: address,
                                                wallet: wallet,
                                                rewards: validatorRewards && [
                                                    validatorRewards
                                                ],
                                                signingClient: props.signingClient,
                                                onClaimRewards: props.onClaimRewards,
                                                setLoading: (loading)=>setLoading(loading),
                                                setError: setError
                                            }),
                                            !!commission && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5bf75ab82b3b05cf$export$2e2bcd8739ae039), {
                                                commission: true,
                                                network: network,
                                                address: address,
                                                wallet: wallet,
                                                rewards: validatorRewards && [
                                                    validatorRewards
                                                ],
                                                signingClient: props.signingClient,
                                                onClaimRewards: props.onClaimRewards,
                                                setLoading: (loading)=>setLoading(loading),
                                                setError: setError
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("hr", {}),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $47cad3b7d9bae545$export$2e2bcd8739ae039).Item, {
                                                as: "button",
                                                disabled: !(wallet === null || wallet === void 0 ? void 0 : wallet.hasPermission(address, "BeginRedelegate")),
                                                onClick: ()=>{
                                                    setSelectedValidator();
                                                    setAction("redelegate");
                                                },
                                                children: "Redelegate"
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $47cad3b7d9bae545$export$2e2bcd8739ae039).Item, {
                                                as: "button",
                                                disabled: !(wallet === null || wallet === void 0 ? void 0 : wallet.hasPermission(address, "Undelegate")),
                                                onClick: ()=>setAction("undelegate"),
                                                children: "Undelegate"
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $a73f5336dfd04f2d$export$2e2bcd8739ae039), {
                                className: "btn-sm btn-secondary",
                                disabled: true,
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                        className: "spinner-border spinner-border-sm",
                                        role: "status",
                                        "aria-hidden": "true"
                                    }),
                                    "\xa0"
                                ]
                            })),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc7c852c832d97ac$export$2e2bcd8739ae039), {
                                icon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a73f5336dfd04f2d$export$2e2bcd8739ae039), {
                                        variant: "primary",
                                        disabled: !(wallet === null || wallet === void 0 ? void 0 : wallet.hasPermission(address, "Delegate")),
                                        onClick: ()=>setAction("delegate"),
                                        children: "Delegate"
                                    })
                                }),
                                identifier: validator.operator_address,
                                tooltip: !wallet ? `Connect a wallet to delegate` : !(wallet === null || wallet === void 0 ? void 0 : wallet.hasPermission(address, "Delegate")) && `You don't have permission to do that.`
                            }),
                            operator && grantsValid ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $47cad3b7d9bae545$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $47cad3b7d9bae545$export$2e2bcd8739ae039).Toggle, {
                                        variant: "success",
                                        disabled: !props.restakePossible,
                                        children: "REStake"
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $47cad3b7d9bae545$export$2e2bcd8739ae039).Menu, {
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $47cad3b7d9bae545$export$2e2bcd8739ae039).Item, {
                                                as: "button",
                                                disabled: !(wallet === null || wallet === void 0 ? void 0 : wallet.hasPermission(address, "Grant")) && !(wallet === null || wallet === void 0 ? void 0 : wallet.hasPermission(address, "Revoke")),
                                                onClick: ()=>{
                                                    setAction("grant");
                                                },
                                                children: "Manage Grant"
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a299f73caa82e67f$export$2e2bcd8739ae039), {
                                                address: props.address,
                                                wallet: props.wallet,
                                                grantAddress: operator.botAddress,
                                                grants: [
                                                    validatorGrants.stakeGrant,
                                                    validatorGrants.claimGrant
                                                ],
                                                buttonText: "Disable REStake",
                                                signingClient: props.signingClient,
                                                onRevoke: onRevoke,
                                                setLoading: (loading)=>setLoading(loading),
                                                setError: setError
                                            })
                                        ]
                                    })
                                ]
                            }) : operator && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc7c852c832d97ac$export$2e2bcd8739ae039), {
                                icon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a73f5336dfd04f2d$export$2e2bcd8739ae039), {
                                        variant: "success",
                                        disabled: !props.restakePossible || !(delegation === null || delegation === void 0 ? void 0 : (_delegation_balance2 = delegation.balance) === null || _delegation_balance2 === void 0 ? void 0 : _delegation_balance2.amount) || !(wallet === null || wallet === void 0 ? void 0 : wallet.hasPermission(address, "Grant")),
                                        onClick: ()=>setAction("grant"),
                                        children: "Enable REStake"
                                    })
                                }),
                                identifier: validator.operator_address,
                                tooltip: !network.authzSupport ? `${props.network.prettyName} doesn't support Authz just yet` : !wallet ? `Connect a wallet to enable REStake` : !wallet.authzSupport() ? (0, $2a6bf51ee962800d$export$9ae6b564c4c11ac)(wallet) : !(delegation === null || delegation === void 0 ? void 0 : (_delegation_balance3 = delegation.balance) === null || _delegation_balance3 === void 0 ? void 0 : _delegation_balance3.amount) ? `You must delegate to ${validator.moniker} before they can REStake for you.` : !(wallet === null || wallet === void 0 ? void 0 : wallet.hasPermission(address, "Grant")) && `You don't have permission to do that.`
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $820674bc8d9aaa39$export$2e2bcd8739ae039 = $820674bc8d9aaa39$var$ValidatorStake;




var $c9wMV = parcelRequire("c9wMV");
parcelRequire("6cds3");









var $6cds3 = parcelRequire("6cds3");

var $c9wMV = parcelRequire("c9wMV");



function $14e1681d8434ab7d$var$ValidatorNetworks(props) {
    const { validator: validator, registryData: registryData, network: network, networks: networks } = props;
    const [networkLoading, setNetworkLoading] = (0, $6cds3.useState)();
    (0, $6cds3.useEffect)(()=>{
        if (network) setNetworkLoading(null);
    }, [
        network
    ]);
    if (!(registryData === null || registryData === void 0 ? void 0 : registryData.chains)) return null;
    const validatorNetworks = (0, (/*@__PURE__*/$parcel$interopDefault($c9wMV))).uniqBy((0, (/*@__PURE__*/$parcel$interopDefault($c9wMV))).compact(registryData.chains.map((chain)=>{
        const chainNetwork = networks[chain.name];
        if (chainNetwork) {
            const { online: online } = chainNetwork;
            const active = network.path === chainNetwork.path;
            return {
                key: chain.name,
                name: chainNetwork.prettyName,
                image: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a1ed1e534eec315a$export$2e2bcd8739ae039), {
                    network: chainNetwork,
                    height: 20,
                    width: 20,
                    className: active ? "border border-2 border-info" : ""
                }),
                path: `/${chainNetwork.path}/${chain.address}`,
                active: active,
                online: online
            };
        }
    })), "key").sort((a, b)=>a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: "d-flex flex-wrap gap-1 align-items-center",
        children: [
            validatorNetworks.map((validatorNetwork)=>{
                return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $843e0f89d5f7d219$export$2e2bcd8739ae039), {
                    placement: "top",
                    overlay: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $75c21e5a46e079cb$export$2e2bcd8739ae039), {
                        id: `tooltip-${validatorNetwork.key}`,
                        children: [
                            validatorNetwork.name,
                            !validatorNetwork.online && " (API Offline)"
                        ]
                    }),
                    children: !validatorNetwork.online || validatorNetwork.active ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                        children: validatorNetwork.image
                    }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                        to: validatorNetwork.path,
                        onClick: ()=>setNetworkLoading(validatorNetwork.path),
                        children: validatorNetwork.image
                    })
                }, validatorNetwork.key);
            }),
            networkLoading && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $39ebe134e7977f3e$export$2e2bcd8739ae039), {
                size: "sm",
                animation: "border",
                role: "status",
                className: "mt-1",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                    className: "visually-hidden",
                    children: "Loading..."
                })
            })
        ]
    });
}
var $14e1681d8434ab7d$export$2e2bcd8739ae039 = $14e1681d8434ab7d$var$ValidatorNetworks;





var $bc16b7934b04462e$exports = {};

$bc16b7934b04462e$exports = (parcelRequire("17QCl")).getBundleURL("7lpHJ") + "skip.b81c9815.svg";


var $d6e43182cbd7a614$exports = {};

$d6e43182cbd7a614$exports = (parcelRequire("17QCl")).getBundleURL("7lpHJ") + "skip-white.9623180f.svg";


function $a0f9548cacceb33a$var$ValidatorProfile(props) {
    var _validator_description, _validator_description1, _validator_description2, _network_chain_services, _validator_services;
    const { validator: validator, operator: operator, network: network, networks: networks, registryData: registryData, lastExec: lastExec } = props;
    const minimumReward = ()=>{
        return {
            amount: operator.minimumReward,
            denom: network.denom
        };
    };
    function uptime() {
        if (!validator.uptime) return;
        const period = validator.uptime_periods.slice(-1)[0];
        const blockPeriod = validator.missed_blocks_periods.slice(-1)[0];
        const uptime = /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("span", {
            children: [
                (0, (/*@__PURE__*/$parcel$interopDefault($c9wMV))).round(period.uptime * 100, 2),
                "% ",
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("small", {
                    children: [
                        "(missed ",
                        blockPeriod.missed.toLocaleString(),
                        " of ",
                        blockPeriod.blocks.toLocaleString(),
                        " blocks)"
                    ]
                })
            ]
        });
        if (!validator.slashes) return uptime;
        const slashes = /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("small", {
            children: validator.slashes.length < 1 ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                children: "Never slashed"
            }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                children: [
                    "Slashed ",
                    validator.slashes.length,
                    " times (",
                    (0, (/*@__PURE__*/$parcel$interopDefault($c9wMV))).round((0, $ed89d4c20b089b73$export$2060d2db72cce88f)(validator.slashes.reduce((sum, s)=>(0, $ed89d4c20b089b73$export$e16d8520af44a096)(sum, s.fraction), 0), 100), 2),
                    "% total stake)"
                ]
            })
        });
        return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("span", {
            children: [
                uptime,
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                slashes
            ]
        });
    }
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
            className: "row",
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                    className: "col-12 col-lg-6 small mb-3",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $36688d56d3c1862c$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tbody", {
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                            scope: "row",
                                            children: "Validator Address"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                            className: "text-break",
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9c3e840bb4db5007$export$2e2bcd8739ae039), {
                                                address: validator.operator_address
                                            })
                                        })
                                    ]
                                }),
                                !validator.active && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                            scope: "row",
                                            children: "Status"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5d49fb3667eae65e$export$2e2bcd8739ae039), {
                                                validator: validator
                                            })
                                        })
                                    ]
                                }),
                                uptime() && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                            scope: "row",
                                            children: "Uptime"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                            children: uptime()
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                            scope: "row",
                                            children: "REStake"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                            children: !!operator ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $36688d56d3c1862c$export$2e2bcd8739ae039), {
                                                className: "m-0 table-sm",
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tbody", {
                                                    className: "small",
                                                    children: [
                                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                                    children: "Frequency"
                                                                }),
                                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                                    children: operator.runTimesString()
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                                    className: network.authzSupport ? "" : "border-bottom-0",
                                                                    children: "Minimum rewards"
                                                                }),
                                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                                    className: network.authzSupport ? "" : "border-bottom-0",
                                                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $edd3c36e8c82dfd7$export$2e2bcd8739ae039), {
                                                                        coins: minimumReward(),
                                                                        asset: network.baseAsset,
                                                                        fullPrecision: true,
                                                                        hideValue: true
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        network.authzSupport && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                                    className: "border-bottom-0",
                                                                    children: "Last REStake"
                                                                }),
                                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                                    className: "border-bottom-0",
                                                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2e2d1aba03134c53$export$2e2bcd8739ae039), {
                                                                        operator: operator,
                                                                        lastExec: lastExec
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc7c852c832d97ac$export$2e2bcd8739ae039), {
                                                icon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $ac4c3421df377bd7$export$2e2bcd8739ae039), {
                                                    className: "opacity-50"
                                                }),
                                                identifier: validator.operator_address,
                                                tooltip: "This validator is not a REStake operator"
                                            })
                                        })
                                    ]
                                }),
                                network.apyEnabled && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                            scope: "row",
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc7c852c832d97ac$export$2e2bcd8739ae039), {
                                                icon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                    className: "text-decoration-underline",
                                                    children: "APY"
                                                }),
                                                identifier: "delegations-apy",
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                                    className: "mt-2 text-center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                                            children: "Based on commission, compounding frequency and estimated block times."
                                                        }),
                                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                                            children: "This is an estimate and best case scenario."
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                            children: props.validatorApy[validator.operator_address] ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("span", {
                                                children: [
                                                    (0, $ed89d4c20b089b73$export$2077e0241d6afd3c)(props.validatorApy[validator.operator_address] * 100, 2).toLocaleString(),
                                                    "%"
                                                ]
                                            }) : "-"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                            scope: "row",
                                            children: "Commission"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("span", {
                                                children: [
                                                    validator.commission.commission_rates.rate * 100,
                                                    "%"
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                            scope: "row",
                                            children: "Rank"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("span", {
                                                children: [
                                                    "#",
                                                    validator.rank
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                            scope: "row",
                                            children: "Voting power"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $edd3c36e8c82dfd7$export$2e2bcd8739ae039), {
                                                    coins: {
                                                        amount: validator.tokens,
                                                        denom: network.denom
                                                    },
                                                    asset: network.baseAsset
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                    className: "col-12 col-lg-6 small mb-3",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $36688d56d3c1862c$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tbody", {
                                children: [
                                    !!((_validator_description = validator.description) === null || _validator_description === void 0 ? void 0 : _validator_description.security_contact) && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                scope: "row",
                                                children: "Contact"
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                                                    href: `mailto:${validator.description.security_contact}`,
                                                    children: validator.description.security_contact
                                                })
                                            })
                                        ]
                                    }),
                                    !!((_validator_description1 = validator.description) === null || _validator_description1 === void 0 ? void 0 : _validator_description1.website) && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                scope: "row",
                                                children: "Website"
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                className: "text-break",
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $92fd314e58b58199$export$2e2bcd8739ae039), {
                                                    className: "text-decoration-underline",
                                                    validator: validator,
                                                    children: validator.description.website
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                className: "align-middle",
                                                scope: "row",
                                                children: "Profiles"
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $46b1c64d9a49f85d$export$2e2bcd8739ae039), {
                                                    validator: validator,
                                                    network: network,
                                                    theme: props.theme,
                                                    exclude: [
                                                        "nodes",
                                                        "skip"
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    (validator === null || validator === void 0 ? void 0 : validator.path) && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                className: "align-middle",
                                                scope: "row",
                                                children: "Networks"
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                className: "w-75",
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $14e1681d8434ab7d$export$2e2bcd8739ae039), {
                                                    validator: validator,
                                                    registryData: registryData,
                                                    network: network,
                                                    networks: networks
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                            className: "mb-4",
                            children: (_validator_description2 = validator.description) === null || _validator_description2 === void 0 ? void 0 : _validator_description2.details
                        }),
                        !!((_network_chain_services = network.chain.services) === null || _network_chain_services === void 0 ? void 0 : _network_chain_services.skip) && !!((_validator_services = validator.services) === null || _validator_services === void 0 ? void 0 : _validator_services.skip) && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                                    className: "mb-2 d-flex align-items-center gap-1",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                                            href: "https://skip.money",
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                                src: props.theme === "dark" ? (0, (/*@__PURE__*/$parcel$interopDefault($d6e43182cbd7a614$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($bc16b7934b04462e$exports))),
                                                height: 14,
                                                className: "d-block"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                                            children: "Skip MEV"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $36688d56d3c1862c$export$2e2bcd8739ae039), {
                                    className: "table-sm",
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tbody", {
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                        children: "Status"
                                                    }),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                        children: validator.services.skip.active ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                                    className: "text-success",
                                                                    children: "Active"
                                                                }),
                                                                validator.services.skip.front_running_protection && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                                                                        "Front-running protected"
                                                                    ]
                                                                })
                                                            ]
                                                        }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                            className: "text-warning",
                                                            children: "Inactive"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                        children: "Network profit"
                                                    }),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("td", {
                                                        children: [
                                                            100 - validator.services.skip.val_payment_percentage,
                                                            "%",
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $edd3c36e8c82dfd7$export$2e2bcd8739ae039), {
                                                                coins: {
                                                                    amount: validator.services.skip.network_profit,
                                                                    denom: network.denom
                                                                },
                                                                asset: network.baseAsset,
                                                                hideValue: true
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                        className: "border-bottom-0",
                                                        children: "Validator profit"
                                                    }),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("td", {
                                                        className: "border-bottom-0",
                                                        children: [
                                                            validator.services.skip.val_payment_percentage,
                                                            "%",
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $edd3c36e8c82dfd7$export$2e2bcd8739ae039), {
                                                                coins: {
                                                                    amount: validator.services.skip.val_profit,
                                                                    denom: network.denom
                                                                },
                                                                asset: network.baseAsset,
                                                                hideValue: true
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        Object.entries(validator.public_nodes || {}).length > 0 && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                                    className: "mb-2 d-flex align-items-center gap-1",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4929e07a18e71701$export$2e2bcd8739ae039), {}),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                                            children: "Public Nodes"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $36688d56d3c1862c$export$2e2bcd8739ae039), {
                                    className: "table-sm",
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("tbody", {
                                        children: Object.entries(validator.public_nodes).map(([type, nodes])=>{
                                            return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                        children: type.toUpperCase()
                                                    }),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                        className: "list-group list-group-flush flex-fill",
                                                        children: nodes.map((api)=>{
                                                            return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                                                                href: api.address,
                                                                target: "_blank",
                                                                className: "text-reset text-decoration-underline",
                                                                children: api.address
                                                            });
                                                        }).reduce((prev, curr)=>[
                                                                prev,
                                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                                                                curr
                                                            ])
                                                    })
                                                ]
                                            }, type);
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
var $a0f9548cacceb33a$export$2e2bcd8739ae039 = $a0f9548cacceb33a$var$ValidatorProfile;


function $ca14c642216b0f3d$var$ValidatorModal(props) {
    const { validator: validator, delegations: delegations, operators: operators, network: network, validators: validators, grants: grants } = props;
    const navigate = (0, $4a3e215446c0ed92$export$9770f232ac06a008)();
    const params = (0, $4a3e215446c0ed92$export$99eaa27ddbbb95ef)();
    const [activeTab, setActiveTab] = (0, $6cds3.useState)(params.section || "profile");
    const [registryData, setRegistryData] = (0, $6cds3.useState)({});
    const [lastExec, setLastExec] = (0, $6cds3.useState)();
    let operator;
    if (operators && validator) operator = network.getOperator(validator.operator_address);
    (0, $6cds3.useEffect)(()=>{
        setRegistryData();
        setLastExec();
    }, [
        validator
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (registryData == null) {
            getRegistryData();
            const interval = setInterval(()=>{
                getRegistryData();
            }, 15000);
            return ()=>clearInterval(interval);
        }
    }, [
        validator,
        registryData
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (lastExec == null) {
            getLastExec(2);
            const interval = setInterval(()=>{
                getLastExec();
            }, 60000);
            return ()=>clearInterval(interval);
        }
    }, [
        operator,
        lastExec
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (params.network !== network.name) return;
        const shouldShow = props.show && validator;
        const shouldChangeValidator = params.validator !== (validator === null || validator === void 0 ? void 0 : validator.operator_address);
        const shouldChangeTab = activeTab === "profile" ? !!params.section : params.section !== activeTab;
        const shouldChangeUrl = shouldShow && (shouldChangeValidator || shouldChangeTab);
        if (shouldChangeUrl) navigate(`/${network.name}/${validator.operator_address}${activeTab === "profile" ? "" : `/${activeTab}`}`);
        else if (params.validator && props.show === false) navigate(`/${network.name}`);
    }, [
        props.show,
        activeTab,
        validator
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (props.activeTab && props.activeTab != activeTab) setTab(props.activeTab);
        else if (params.section && params.section != activeTab) {
            const section = [
                "delegate",
                "restake"
            ].includes(params.section) ? "stake" : params.section;
            setTab(section);
        } else if (!activeTab || !props.show) setTab("profile");
    }, [
        props.show
    ]);
    function setTab(tab) {
        setActiveTab(tab || "profile");
    }
    function handleClose() {
        props.hideModal();
    }
    function getRegistryData() {
        if ((validator === null || validator === void 0 ? void 0 : validator.path) && network.directory) network.directory.getRegistryValidator(validator.path).then((data)=>{
            setRegistryData(data);
        });
        else setRegistryData({});
    }
    function getLastExec(emptyResponseRetries) {
        if (!operator || !network.authzSupport) {
            setLastExec();
            return;
        }
        network.queryClient.getTransactions([
            {
                key: "events",
                value: `message.action='/cosmos.authz.v1beta1.MsgExec'`
            },
            {
                key: "events",
                value: `message.sender='${operator.botAddress}'`
            }
        ], {
            pageSize: 1,
            order: 2,
            retries: 3,
            timeout: 15000
        }).then((data)=>{
            var _data_tx_responses;
            if (((_data_tx_responses = data.tx_responses) === null || _data_tx_responses === void 0 ? void 0 : _data_tx_responses.length) > 0) setLastExec((0, (/*@__PURE__*/$parcel$interopDefault($2KWqD)))(data.tx_responses[0].timestamp));
            else if (emptyResponseRetries && lastExec == null) getLastExec(emptyResponseRetries - 1);
            else if (lastExec == null) setLastExec(false);
        }).catch((error)=>console.log(error));
    }
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $3485727b0a1e4042$export$2e2bcd8739ae039), {
            size: "lg",
            show: props.show,
            onHide: handleClose,
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $3485727b0a1e4042$export$2e2bcd8739ae039).Header, {
                    closeButton: true,
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $3485727b0a1e4042$export$2e2bcd8739ae039).Title, {
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            className: "d-flex align-items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $ed81bcc8e8ff6731$export$2e2bcd8739ae039), {
                                    validator: validator
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $92fd314e58b58199$export$2e2bcd8739ae039), {
                                    validator: validator
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $3485727b0a1e4042$export$2e2bcd8739ae039).Body, {
                    children: [
                        validator && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $bf31903d44b6b079$export$2e2bcd8739ae039).Container, {
                            activeKey: activeTab,
                            onSelect: (k)=>setTab(k),
                            id: "validator-tabs",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $85f5d0e6280a2ccf$export$2e2bcd8739ae039), {
                                    variant: "tabs",
                                    className: "small mb-3 d-flex",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $85f5d0e6280a2ccf$export$2e2bcd8739ae039).Item, {
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $85f5d0e6280a2ccf$export$2e2bcd8739ae039).Link, {
                                                role: "button",
                                                eventKey: "profile",
                                                children: "Profile"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $85f5d0e6280a2ccf$export$2e2bcd8739ae039).Item, {
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $85f5d0e6280a2ccf$export$2e2bcd8739ae039).Link, {
                                                role: "button",
                                                eventKey: "stake",
                                                children: "Stake"
                                            })
                                        }),
                                        network.authzSupport && !network.authzAminoSupport && operator && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $85f5d0e6280a2ccf$export$2e2bcd8739ae039).Item, {
                                            className: "d-none d-md-flex",
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $85f5d0e6280a2ccf$export$2e2bcd8739ae039).Link, {
                                                role: "button",
                                                eventKey: "ledger",
                                                children: "Ledger"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $bf31903d44b6b079$export$2e2bcd8739ae039).Content, {
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $bf31903d44b6b079$export$2e2bcd8739ae039).Pane, {
                                            eventKey: "profile",
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a0f9548cacceb33a$export$2e2bcd8739ae039), {
                                                theme: props.theme,
                                                network: network,
                                                networks: props.networks,
                                                validator: validator,
                                                operator: operator,
                                                registryData: registryData,
                                                lastExec: lastExec,
                                                validatorApy: props.validatorApy
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $bf31903d44b6b079$export$2e2bcd8739ae039).Pane, {
                                            eventKey: "stake",
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $820674bc8d9aaa39$export$2e2bcd8739ae039), {
                                                network: network,
                                                validator: validator,
                                                operator: operator,
                                                lastExec: lastExec,
                                                validators: validators,
                                                operators: operators,
                                                address: props.address,
                                                wallet: props.wallet,
                                                balance: props.balance,
                                                delegations: delegations,
                                                rewards: props.rewards,
                                                grants: props.grants,
                                                commission: props.commission,
                                                validatorApy: props.validatorApy,
                                                authzSupport: props.authzSupport,
                                                restakePossible: props.restakePossible,
                                                signingClient: props.signingClient,
                                                isLoading: props.isLoading,
                                                onDelegate: props.onDelegate,
                                                onClaimRewards: props.onClaimRewards,
                                                onGrant: props.onGrant,
                                                onRevoke: props.onRevoke
                                            })
                                        }),
                                        network.authzSupport && !network.authzAminoSupport && operator && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $bf31903d44b6b079$export$2e2bcd8739ae039).Pane, {
                                            eventKey: "ledger",
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fefc374772824467$export$2e2bcd8739ae039), {
                                                network: network,
                                                validator: validator,
                                                modal: false
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        activeTab === "profile" && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                            className: "d-flex justify-content-end gap-2",
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a73f5336dfd04f2d$export$2e2bcd8739ae039), {
                                variant: "primary",
                                onClick: ()=>setTab("stake"),
                                children: "Stake"
                            })
                        })
                    ]
                })
            ]
        })
    });
}
var $ca14c642216b0f3d$export$2e2bcd8739ae039 = $ca14c642216b0f3d$var$ValidatorModal;





var $6cds3 = parcelRequire("6cds3");

var $aMJGV = parcelRequire("aMJGV");
var $f51c8b9ad49a08d3$var$_excluded = [
    "color",
    "size",
    "title"
];
function $f51c8b9ad49a08d3$var$_extends() {
    $f51c8b9ad49a08d3$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f51c8b9ad49a08d3$var$_extends.apply(this, arguments);
}
function $f51c8b9ad49a08d3$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $f51c8b9ad49a08d3$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $f51c8b9ad49a08d3$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $f51c8b9ad49a08d3$var$Gear = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, rest = $f51c8b9ad49a08d3$var$_objectWithoutProperties(_ref, $f51c8b9ad49a08d3$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("svg", $f51c8b9ad49a08d3$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492M5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115z"
    }));
});
$f51c8b9ad49a08d3$var$Gear.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string
};
$f51c8b9ad49a08d3$var$Gear.defaultProps = {
    color: "currentColor",
    size: "1em",
    title: null
};
var $f51c8b9ad49a08d3$export$2e2bcd8739ae039 = $f51c8b9ad49a08d3$var$Gear;




class $cb41a1cd6099839c$var$Delegations extends (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Component {
    async componentDidMount() {
        var _this_props_wallet;
        const walletAuthzSupport = (_this_props_wallet = this.props.wallet) === null || _this_props_wallet === void 0 ? void 0 : _this_props_wallet.authzSupport();
        this.setState({
            walletAuthzSupport: walletAuthzSupport
        });
        this.refresh(true);
        if (this.props.validator) this.showValidatorModal(this.props.validator);
    }
    async componentDidUpdate(prevProps, prevState) {
        if (prevProps.validator !== this.props.validator && this.props.validator) this.showValidatorModal(this.props.validator);
        if (this.props.network !== prevProps.network && !this.props.address || this.props.address !== prevProps.address) {
            var _this_props_wallet;
            this.clearRefreshInterval();
            const walletAuthzSupport = (_this_props_wallet = this.props.wallet) === null || _this_props_wallet === void 0 ? void 0 : _this_props_wallet.authzSupport();
            this.setState({
                walletAuthzSupport: walletAuthzSupport,
                delegations: undefined,
                rewards: undefined,
                commission: {},
                validatorApy: {},
                operatorGrants: {},
                error: null
            });
            this.refresh(false);
        }
        if (this.props.grants !== prevProps.grants) this.getGrants();
    }
    componentWillUnmount() {
        this.clearRefreshInterval();
    }
    async refresh(getGrants) {
        this.calculateApy();
        await this.getDelegations();
        if (getGrants) this.getGrants();
        this.getWithdrawAddress();
        this.getRewards();
        this.refreshInterval();
    }
    refreshInterval() {
        const refreshInterval = setInterval(()=>{
            this.props.getBalance();
            this.getRewards(true);
        }, 15000);
        const delegateInterval = setInterval(()=>{
            this.getDelegations(true);
        }, 30000);
        this.setState({
            refreshInterval: refreshInterval,
            delegateInterval: delegateInterval
        });
    }
    clearRefreshInterval() {
        clearInterval(this.state.refreshInterval);
        clearInterval(this.state.delegateInterval);
    }
    async getDelegations(hideError) {
        if (!this.props.address) return;
        const address = this.props.address;
        return this.props.queryClient.getDelegations(address).then((delegations)=>{
            const orderedAddresses = Object.keys(this.props.validators);
            delegations = orderedAddresses.reduce((sum, address)=>{
                if (delegations[address] && delegations[address].balance.amount !== "0") sum[address] = delegations[address];
                return sum;
            }, {});
            if (address === this.props.address) this.setState({
                delegations: delegations,
                error: null
            });
        }, (error)=>{
            if (address !== this.props.address) return;
            if ([
                404,
                500
            ].includes(error.response && error.response.status) && !this.state.delegations) this.setState({
                delegations: {},
                error: null
            });
            else if (!hideError) this.setState({
                error: "Failed to load delegations."
            });
        });
    }
    async getWithdrawAddress() {
        if (!this.props.address) return;
        const address = this.props.address;
        return this.props.queryClient.getWithdrawAddress(address).then((withdraw)=>{
            if (withdraw !== address) this.setState({
                error: "You have a different withdraw address set. REStake WILL NOT WORK!"
            });
        }, (error)=>{
            console.log("Failed to get withdraw address", error);
        });
    }
    getRewards(hideError) {
        if (!this.props.address) return;
        this.props.queryClient.getRewards(this.props.address, this.props.network.denom).then((rewards)=>{
            this.setState({
                rewards: rewards
            });
        }, (error)=>{
            if ([
                404,
                500
            ].includes(error.response && error.response.status) && !this.state.rewards) this.setState({
                rewards: {}
            });
            else if (!hideError) this.setState({
                error: "Failed to get rewards."
            });
        });
        Object.values(this.props.validators).forEach((validator)=>{
            if (validator.isValidatorOperator(this.props.address)) this.props.queryClient.getCommission(validator.address).then((commission)=>{
                this.setState((state, props)=>({
                        commission: (0, (/*@__PURE__*/$parcel$interopDefault($c9wMV))).set(state.commission, validator.address, commission)
                    }));
            });
        });
    }
    async calculateApy() {
        if (!this.props.network.apyEnabled || !this.props.network.getApy) return;
        this.props.network.getApy(this.props.validators, this.props.operators).then((validatorApy)=>{
            this.setState({
                validatorApy: validatorApy
            });
        }, (error)=>{
            console.log(error);
            this.setState({
                error: "Failed to get APY."
            });
        });
    }
    async getGrants() {
        var _this_props_grants;
        if (!((_this_props_grants = this.props.grants) === null || _this_props_grants === void 0 ? void 0 : _this_props_grants.granter)) return;
        const operatorGrants = this.props.operators.reduce((sum, operator)=>{
            const grantee = operator.botAddress;
            sum[grantee] = this.buildGrants(this.props.grants.granter, grantee, this.props.address);
            return sum;
        }, {});
        this.setState({
            operatorGrants: operatorGrants
        });
    }
    buildGrants(grants, grantee, granter) {
        const { claimGrant: claimGrant, stakeGrant: stakeGrant } = (0, $2a6bf51ee962800d$export$c5197dfe1b46ea0)(grants, grantee, granter);
        let grantValidators, maxTokens;
        if (stakeGrant) {
            const { allow_list: allow_list, deny_list: deny_list, max_tokens: max_tokens } = stakeGrant.authorization;
            if (allow_list === null || allow_list === void 0 ? void 0 : allow_list.address) grantValidators = allow_list.address;
            else if (deny_list === null || deny_list === void 0 ? void 0 : deny_list.address) grantValidators = deny_list.address.includes("") ? [] : this.props.validators.map((el)=>el.address).filter((address)=>!deny_list.address.includes(address));
            maxTokens = max_tokens;
        }
        return {
            claimGrant: claimGrant,
            stakeGrant: stakeGrant,
            validators: grantValidators,
            maxTokens: maxTokens ? (0, $ed89d4c20b089b73$export$8576f72eb7f14a7e)(maxTokens.amount) : null
        };
    }
    isValidatorOperator() {
        if (!this.props.address) return false;
        return Object.values(this.props.validators).some((validator)=>validator.isValidatorOperator(this.props.address));
    }
    isLoading(type) {
        if (!this.props.address) return false;
        const loaders = {
            "delegations": ()=>!this.state.delegations,
            "grants": ()=>{
                var _this_props_network, _this_props_grants;
                return ((_this_props_network = this.props.network) === null || _this_props_network === void 0 ? void 0 : _this_props_network.authzSupport) && !((_this_props_grants = this.props.grants) === null || _this_props_grants === void 0 ? void 0 : _this_props_grants.granter);
            },
            "rewards": ()=>!this.state.rewards,
            "commission": ()=>this.isValidatorOperator() && !this.state.commission
        };
        if (!type) return Object.values(loaders).some((value)=>value());
        return loaders[type] ? loaders[type]() : false;
    }
    onGrant(grantAddress, grant) {
        const operator = this.props.operators.find((el)=>el.botAddress === grantAddress);
        if (operator) this.setState((state, props)=>({
                error: null,
                validatorLoading: (0, (/*@__PURE__*/$parcel$interopDefault($c9wMV))).set(state.validatorLoading, operator.address, false)
            }));
        this.props.onGrant(grantAddress, grant);
    }
    onRevoke(grantAddress, msgTypes) {
        const operator = this.props.operators.find((el)=>el.botAddress === grantAddress);
        if (operator) this.setState((state, props)=>({
                error: null,
                validatorLoading: (0, (/*@__PURE__*/$parcel$interopDefault($c9wMV))).set(state.validatorLoading, operator.address, false)
            }));
        else this.setState({
            error: null
        });
        this.props.onRevoke(grantAddress, msgTypes);
    }
    onClaimRewards() {
        this.setState({
            claimLoading: false,
            validatorLoading: {},
            error: null
        });
        setTimeout(()=>{
            this.props.getBalance();
            this.getDelegations();
            this.getRewards();
        }, 3000);
    }
    setClaimLoading(value) {
        if (value) this.setState({
            error: null
        });
        this.setState({
            claimLoading: !!value
        });
    }
    setValidatorLoading(validatorAddress, value) {
        if (value) this.setState({
            error: null
        });
        this.setState((state, props)=>({
                validatorLoading: (0, (/*@__PURE__*/$parcel$interopDefault($c9wMV))).set(state.validatorLoading, validatorAddress, value)
            }));
    }
    setError(error) {
        this.setState({
            error: error
        });
    }
    authzSupport() {
        return this.props.network.authzSupport;
    }
    operatorGrants() {
        if (!this.state.operatorGrants) return {};
        return this.props.operators.reduce((sum, operator)=>{
            let grant = this.state.operatorGrants[operator.botAddress];
            if (!grant) grant = this.defaultGrant;
            sum[operator.botAddress] = {
                ...grant,
                grantsValid: !!(grant.stakeGrant && (!grant.validators || grant.validators.includes(operator.address)) && (grant.maxTokens === null || (0, $ed89d4c20b089b73$export$a94a7414fa942aea)(grant.maxTokens, (0, $2a6bf51ee962800d$export$31d336b0b7e2f20)(this.state.rewards, this.props.network.denom)))),
                grantsExist: !!(grant.claimGrant || grant.stakeGrant)
            };
            return sum;
        }, {});
    }
    restakePossible() {
        return this.props.address && this.state.walletAuthzSupport && this.authzSupport();
    }
    totalRewards(validators) {
        if (!this.state.rewards) return;
        const denom = this.props.network.denom;
        const total = Object.values(this.state.rewards).reduce((sum, item)=>{
            const reward = item.reward.find((el)=>el.denom === denom);
            if (reward && (validators === undefined || validators.includes(item.validator_address))) return sum + parseInt(reward.amount);
            return sum;
        }, 0);
        return {
            amount: total,
            denom: denom
        };
    }
    showValidatorModal(validator, opts) {
        opts = opts || {};
        this.setState({
            validatorModal: {
                show: true,
                validator: validator,
                ...opts
            }
        });
    }
    hideValidatorModal(opts) {
        opts = opts || {};
        this.setState((state, props)=>{
            return {
                validatorModal: {
                    ...state.validatorModal,
                    show: false
                }
            };
        });
    }
    renderValidatorModal() {
        const validatorModal = this.state.validatorModal;
        return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $ca14c642216b0f3d$export$2e2bcd8739ae039), {
            show: validatorModal.show,
            theme: this.props.theme,
            validator: validatorModal.validator,
            activeTab: validatorModal.activeTab,
            network: this.props.network,
            networks: this.props.networks,
            address: this.props.address,
            wallet: this.props.wallet,
            validators: this.props.validators,
            validatorApy: this.state.validatorApy,
            operators: this.props.operators,
            balance: this.props.balance,
            rewards: this.state.rewards,
            commission: this.state.commission,
            delegations: this.state.delegations || {},
            grants: this.operatorGrants(),
            authzSupport: this.authzSupport(),
            restakePossible: this.restakePossible(),
            signingClient: this.props.signingClient,
            isLoading: this.isLoading,
            hideModal: this.hideValidatorModal,
            onDelegate: this.onClaimRewards,
            onGrant: this.onGrant,
            onRevoke: this.onRevoke,
            onClaimRewards: this.onClaimRewards,
            setError: this.setError
        });
    }
    render() {
        if (!this.props.validators) return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
            className: "text-center",
            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $39ebe134e7977f3e$export$2e2bcd8739ae039), {
                animation: "border",
                role: "status",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                    className: "visually-hidden",
                    children: "Loading..."
                })
            })
        });
        const alerts = /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
            children: [
                !this.authzSupport() && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $c9bd276a69168a44$export$2e2bcd8739ae039), {
                    variant: "info",
                    dismissible: false,
                    children: [
                        this.props.network.prettyName,
                        " doesn't support Authz just yet. You can stake and compound manually, REStake will update automatically when support is added."
                    ]
                }),
                this.authzSupport() && this.props.operators.length > 0 && this.props.wallet && !this.state.walletAuthzSupport && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $c9bd276a69168a44$export$2e2bcd8739ae039), {
                        variant: "warning",
                        dismissible: false,
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                className: "mb-0",
                                children: (0, $2a6bf51ee962800d$export$9ae6b564c4c11ac)(this.props.wallet)
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $c9bd276a69168a44$export$2e2bcd8739ae039), {
                    message: this.state.error
                }),
                this.props.network && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fefc374772824467$export$2e2bcd8739ae039), {
                    show: this.state.showAboutLedger,
                    onHide: ()=>this.setState({
                            showAboutLedger: false
                        }),
                    network: this.props.network
                })
            ]
        });
        return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
            children: [
                alerts,
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                    className: "mb-2",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $163e26a5c9452562$export$2e2bcd8739ae039), {
                        theme: this.props.theme,
                        network: this.props.network,
                        address: this.props.address,
                        wallet: this.props.wallet,
                        validators: this.props.validators,
                        operators: this.props.operators,
                        validatorApy: this.state.validatorApy,
                        delegations: this.state.delegations,
                        rewards: this.state.rewards,
                        commission: this.state.commission,
                        signingClient: this.props.signingClient,
                        operatorGrants: this.operatorGrants(),
                        authzSupport: this.authzSupport(),
                        restakePossible: this.restakePossible(),
                        showValidator: this.showValidatorModal,
                        isLoading: this.isLoading,
                        setError: this.setError,
                        onClaimRewards: this.onClaimRewards,
                        onRevoke: this.onRevoke,
                        manageControl: ({ validator: validator, operator: operator, delegation: delegation, rewards: rewards, grants: grants, filter: filter })=>{
                            const { network: network, wallet: wallet, address: address } = this.props;
                            const validatorAddress = validator.operator_address;
                            const validatorOperator = validator.isValidatorOperator(address);
                            return !this.state.validatorLoading[validatorAddress] ? filter.group === "delegated" && delegation ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $47cad3b7d9bae545$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $47cad3b7d9bae545$export$2e2bcd8739ae039).Toggle, {
                                        variant: "secondary",
                                        size: "sm",
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f51c8b9ad49a08d3$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $47cad3b7d9bae545$export$2e2bcd8739ae039).Menu, {
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $47cad3b7d9bae545$export$2e2bcd8739ae039).Item, {
                                                as: "button",
                                                onClick: ()=>this.showValidatorModal(validator, {
                                                        activeTab: "profile"
                                                    }),
                                                children: [
                                                    "View ",
                                                    validator.moniker
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("hr", {}),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5bf75ab82b3b05cf$export$2e2bcd8739ae039), {
                                                network: network,
                                                address: address,
                                                wallet: wallet,
                                                rewards: [
                                                    rewards
                                                ],
                                                signingClient: this.props.signingClient,
                                                onClaimRewards: this.onClaimRewards,
                                                setLoading: (loading)=>this.setValidatorLoading(validatorAddress, loading),
                                                setError: this.setError
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5bf75ab82b3b05cf$export$2e2bcd8739ae039), {
                                                restake: true,
                                                network: network,
                                                address: address,
                                                wallet: wallet,
                                                rewards: [
                                                    rewards
                                                ],
                                                signingClient: this.props.signingClient,
                                                onClaimRewards: this.onClaimRewards,
                                                setLoading: (loading)=>this.setValidatorLoading(validatorAddress, loading),
                                                setError: this.setError
                                            }),
                                            validatorOperator && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("hr", {}),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5bf75ab82b3b05cf$export$2e2bcd8739ae039), {
                                                        commission: true,
                                                        network: network,
                                                        address: address,
                                                        wallet: wallet,
                                                        rewards: [
                                                            rewards
                                                        ],
                                                        signingClient: this.props.signingClient,
                                                        onClaimRewards: this.onClaimRewards,
                                                        setLoading: (loading)=>this.setValidatorLoading(validatorAddress, loading),
                                                        setError: this.setError
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a73f5336dfd04f2d$export$2e2bcd8739ae039), {
                                variant: "primary",
                                size: "sm",
                                onClick: ()=>this.showValidatorModal(validator),
                                children: "View"
                            }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $a73f5336dfd04f2d$export$2e2bcd8739ae039), {
                                className: "btn-sm btn-secondary",
                                disabled: true,
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                        className: "spinner-border spinner-border-sm",
                                        role: "status",
                                        "aria-hidden": "true"
                                    }),
                                    "\xa0"
                                ]
                            });
                        }
                    })
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                            className: "col"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                            className: "col",
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: "d-grid gap-2 d-md-flex justify-content-end",
                                children: this.state.rewards && (!this.state.claimLoading && !this.isLoading("rewards") ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $47cad3b7d9bae545$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $47cad3b7d9bae545$export$2e2bcd8739ae039).Toggle, {
                                            variant: "secondary",
                                            id: "claim-dropdown",
                                            disabled: this.totalRewards().amount === 0,
                                            children: "All Rewards"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $47cad3b7d9bae545$export$2e2bcd8739ae039).Menu, {
                                            children: [
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5bf75ab82b3b05cf$export$2e2bcd8739ae039), {
                                                    network: this.props.network,
                                                    address: this.props.address,
                                                    wallet: this.props.wallet,
                                                    rewards: Object.values(this.state.rewards || {}),
                                                    signingClient: this.props.signingClient,
                                                    onClaimRewards: this.onClaimRewards,
                                                    setLoading: this.setClaimLoading,
                                                    setError: this.setError
                                                }),
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5bf75ab82b3b05cf$export$2e2bcd8739ae039), {
                                                    restake: true,
                                                    network: this.props.network,
                                                    address: this.props.address,
                                                    wallet: this.props.wallet,
                                                    rewards: Object.values(this.state.rewards || {}),
                                                    signingClient: this.props.signingClient,
                                                    onClaimRewards: this.onClaimRewards,
                                                    setLoading: this.setClaimLoading,
                                                    setError: this.setError
                                                })
                                            ]
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $a73f5336dfd04f2d$export$2e2bcd8739ae039), {
                                    className: "btn-secondary mr-5",
                                    disabled: true,
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                            className: "spinner-border spinner-border-sm",
                                            role: "status",
                                            "aria-hidden": "true"
                                        }),
                                        "\xa0"
                                    ]
                                }))
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("hr", {}),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                    className: "mt-5 text-center",
                    children: [
                        "Enabling REStake will authorize the validator to send ",
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("em", {
                            children: "Delegate"
                        }),
                        " transactions on your behalf for 1 year ",
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                            href: "https://docs.cosmos.network/master/modules/authz/",
                            target: "_blank",
                            rel: "noreferrer",
                            className: "text-reset",
                            children: "using Authz"
                        }),
                        ".",
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                        "They will only be authorized to delegate to their own validator. You can revoke the authorization at any time and everything is open source."
                    ]
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                    className: "text-center mb-4",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                        children: "The validators will pay the transaction fees for you."
                    })
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                    className: "text-center mb-5",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a73f5336dfd04f2d$export$2e2bcd8739ae039), {
                        onClick: this.props.showAbout,
                        variant: "outline-secondary",
                        children: "More info"
                    })
                }),
                this.renderValidatorModal()
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            operatorGrants: {},
            validatorLoading: {},
            validatorApy: {},
            validatorModal: {},
            commission: {}
        };
        this.setError = this.setError.bind(this);
        this.setClaimLoading = this.setClaimLoading.bind(this);
        this.onClaimRewards = this.onClaimRewards.bind(this);
        this.onGrant = this.onGrant.bind(this);
        this.onRevoke = this.onRevoke.bind(this);
        this.isLoading = this.isLoading.bind(this);
        this.showValidatorModal = this.showValidatorModal.bind(this);
        this.setValidatorLoading = this.setValidatorLoading.bind(this);
        this.hideValidatorModal = this.hideValidatorModal.bind(this);
        this.defaultGrant = {
            claimGrant: null,
            stakeGrant: null,
            validators: [],
            grantsValid: false,
            grantsExist: false
        };
    }
}
var $cb41a1cd6099839c$export$2e2bcd8739ae039 = $cb41a1cd6099839c$var$Delegations;





var $6cds3 = parcelRequire("6cds3");


function $c8f11f34c20eefe4$var$About(props) {
    let [searchParams, setSearchParams] = (0, $0e36e707c39d0f3a$export$f1a78c17382fe22a)();
    const aboutParam = searchParams.get("about");
    const show = props.show || aboutParam == "restake";
    (0, $6cds3.useEffect)(()=>{
        if (show && !aboutParam) setSearchParams({
            about: "restake"
        });
    }, [
        show,
        aboutParam
    ]);
    function onHide() {
        setSearchParams({});
        props.onHide();
    }
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $3485727b0a1e4042$export$2e2bcd8739ae039), {
            show: show,
            onHide: ()=>onHide(),
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $3485727b0a1e4042$export$2e2bcd8739ae039).Header, {
                    closeButton: true,
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $3485727b0a1e4042$export$2e2bcd8739ae039).Title, {
                        children: "About REStake"
                    })
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $3485727b0a1e4042$export$2e2bcd8739ae039).Body, {
                    className: "small",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h5", {
                            children: "How REStake works"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                            children: "REStake makes use of a new feature in Cosmos blockchains called Authz. This allows a validator (or any other wallet) to send certain pre-authorized transactions on your behalf."
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                            children: "When you enable REStake you authorize the validator to send Delegate messages for their own validator address. The validator cannot delegate to any other validators, and the authorisation expires automatically after one year and you can revoke at any time."
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                            children: "You can also optionally add a total number of tokens the validator is allowed to delegate, or adjust the expiry date."
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h5", {
                            children: "How to use REStake"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("ol", {
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("li", {
                                    children: "Choose a network. Some don't support Authz yet but many do."
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("li", {
                                    children: "Delegate to any validators who offers the REStake service."
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("li", {
                                    children: "Enable REStake on the validators you want to compound rewards."
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("li", {
                                    children: "Watch the countdown timer and profit!"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h5", {
                            children: "Run REStake yourself"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                            children: "REStake is intended to be run by as many validators as possible, giving delegators the choice of who to auto-compound their rewards with. Ask your favourite validator to become an operator or run it yourself, it's easy!"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                            children: [
                                "The project is entirely open source and instructions for running and contributing to REStake can be ",
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                                    href: "https://github.com/eco-stake/restake",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: "found on Github"
                                }),
                                "."
                            ]
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h5", {
                            children: "ECO Stake \uD83C\uDF31"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                            children: [
                                "ECO Stake is an independent, climate positive validator focussed on building useful tools for the Cosmos ecosystem. We built REStake to make it easy for all validators to run an autocompounder with Authz, and it's one of many projects we work on in the ecosystem. ",
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                                    href: "https://ecostake.com",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: "Delegate with us"
                                }),
                                " to support more projects like this."
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
var $c8f11f34c20eefe4$export$2e2bcd8739ae039 = $c8f11f34c20eefe4$var$About;





var $6cds3 = parcelRequire("6cds3");


"use client";
const $99251645f92da11d$var$Container = /*#__PURE__*/ $6cds3.forwardRef(({ bsPrefix: bsPrefix, fluid: fluid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div", className: className, ...props }, ref)=>{
    const prefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "container");
    const suffix = typeof fluid === "string" ? `-${fluid}` : "-fluid";
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, fluid ? `${prefix}${suffix}` : prefix)
    });
});
$99251645f92da11d$var$Container.displayName = "Container";
var $99251645f92da11d$export$2e2bcd8739ae039 = $99251645f92da11d$var$Container;



var $6cds3 = parcelRequire("6cds3");




var $6cds3 = parcelRequire("6cds3");


"use client";
const $9452897da317bbd0$var$NavbarBrand = /*#__PURE__*/ $6cds3.forwardRef(({ bsPrefix: bsPrefix, className: className, as: as, ...props }, ref)=>{
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "navbar-brand");
    const Component = as || (props.href ? "a" : "span");
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, bsPrefix)
    });
});
$9452897da317bbd0$var$NavbarBrand.displayName = "NavbarBrand";
var $9452897da317bbd0$export$2e2bcd8739ae039 = $9452897da317bbd0$var$NavbarBrand;



var $6cds3 = parcelRequire("6cds3");



var $6cds3 = parcelRequire("6cds3");


/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */ function $0bdc0ebf509860a1$var$createChainedFunction(...funcs) {
    return funcs.filter((f)=>f != null).reduce((acc, f)=>{
        if (typeof f !== "function") throw new Error("Invalid Argument Type, must only provide functions, undefined, or null.");
        if (acc === null) return f;
        return function chainedFunction(...args) {
            // @ts-ignore
            acc.apply(this, args);
            // @ts-ignore
            f.apply(this, args);
        };
    }, null);
}
var $0bdc0ebf509860a1$export$2e2bcd8739ae039 = $0bdc0ebf509860a1$var$createChainedFunction;





const $004d922d79fe0b8b$var$MARGINS = {
    height: [
        "marginTop",
        "marginBottom"
    ],
    width: [
        "marginLeft",
        "marginRight"
    ]
};
function $004d922d79fe0b8b$var$getDefaultDimensionValue(dimension, elem) {
    const offset = `offset${dimension[0].toUpperCase()}${dimension.slice(1)}`;
    const value = elem[offset];
    const margins = $004d922d79fe0b8b$var$MARGINS[dimension];
    return value + // @ts-ignore
    parseInt((0, $c70c5acd84b310f3$export$2e2bcd8739ae039)(elem, margins[0]), 10) + // @ts-ignore
    parseInt((0, $c70c5acd84b310f3$export$2e2bcd8739ae039)(elem, margins[1]), 10);
}
const $004d922d79fe0b8b$var$collapseStyles = {
    [(0, $e4b1ba7c3a6ebf93$export$84cbff306f539230)]: "collapse",
    [(0, $e4b1ba7c3a6ebf93$export$4aacc83d4d59139f)]: "collapsing",
    [(0, $e4b1ba7c3a6ebf93$export$df38205c966be359)]: "collapsing",
    [(0, $e4b1ba7c3a6ebf93$export$78e9e6e3e014d60a)]: "collapse show"
};
const $004d922d79fe0b8b$var$Collapse = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).forwardRef(({ onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, className: className, children: children, dimension: dimension = "height", in: inProp = false, timeout: timeout = 300, mountOnEnter: mountOnEnter = false, unmountOnExit: unmountOnExit = false, appear: appear = false, getDimensionValue: getDimensionValue = $004d922d79fe0b8b$var$getDefaultDimensionValue, ...props }, ref)=>{
    /* Compute dimension */ const computedDimension = typeof dimension === "function" ? dimension() : dimension;
    /* -- Expanding -- */ const handleEnter = (0, $6cds3.useMemo)(()=>(0, $0bdc0ebf509860a1$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = "0";
        }, onEnter), [
        computedDimension,
        onEnter
    ]);
    const handleEntering = (0, $6cds3.useMemo)(()=>(0, $0bdc0ebf509860a1$export$2e2bcd8739ae039)((elem)=>{
            const scroll = `scroll${computedDimension[0].toUpperCase()}${computedDimension.slice(1)}`;
            elem.style[computedDimension] = `${elem[scroll]}px`;
        }, onEntering), [
        computedDimension,
        onEntering
    ]);
    const handleEntered = (0, $6cds3.useMemo)(()=>(0, $0bdc0ebf509860a1$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = null;
        }, onEntered), [
        computedDimension,
        onEntered
    ]);
    /* -- Collapsing -- */ const handleExit = (0, $6cds3.useMemo)(()=>(0, $0bdc0ebf509860a1$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = `${getDimensionValue(computedDimension, elem)}px`;
            (0, $19a9523538451f23$export$2e2bcd8739ae039)(elem);
        }, onExit), [
        onExit,
        getDimensionValue,
        computedDimension
    ]);
    const handleExiting = (0, $6cds3.useMemo)(()=>(0, $0bdc0ebf509860a1$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = null;
        }, onExiting), [
        computedDimension,
        onExiting
    ]);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9bb091aefa5eb510$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $564ddf315628faa7$export$2e2bcd8739ae039),
        ...props,
        "aria-expanded": props.role ? inProp : null,
        onEnter: handleEnter,
        onEntering: handleEntering,
        onEntered: handleEntered,
        onExit: handleExit,
        onExiting: handleExiting,
        childRef: children.ref,
        in: inProp,
        timeout: timeout,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        children: (state, innerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, children.props.className, $004d922d79fe0b8b$var$collapseStyles[state], computedDimension === "width" && "collapse-horizontal")
            })
    });
});
var // @ts-ignore
$004d922d79fe0b8b$export$2e2bcd8739ae039 = $004d922d79fe0b8b$var$Collapse;





"use client";
const $4a69c0674892cb21$var$NavbarCollapse = /*#__PURE__*/ $6cds3.forwardRef(({ children: children, bsPrefix: bsPrefix, ...props }, ref)=>{
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "navbar-collapse");
    const context = (0, $6cds3.useContext)((0, $978fc16477bde29f$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $004d922d79fe0b8b$export$2e2bcd8739ae039), {
        in: !!(context && context.expanded),
        ...props,
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
            ref: ref,
            className: bsPrefix,
            children: children
        })
    });
});
$4a69c0674892cb21$var$NavbarCollapse.displayName = "NavbarCollapse";
var $4a69c0674892cb21$export$2e2bcd8739ae039 = $4a69c0674892cb21$var$NavbarCollapse;




var $6cds3 = parcelRequire("6cds3");




"use client";
const $483bde2d92fc4302$var$NavbarToggle = /*#__PURE__*/ $6cds3.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, label: label = "Toggle navigation", // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "button", onClick: onClick, ...props }, ref)=>{
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "navbar-toggler");
    const { onToggle: onToggle, expanded: expanded } = (0, $6cds3.useContext)((0, $978fc16477bde29f$export$2e2bcd8739ae039)) || {};
    const handleClick = (0, $cfbeaaf7204fcb02$export$2e2bcd8739ae039)((e)=>{
        if (onClick) onClick(e);
        if (onToggle) onToggle();
    });
    if (Component === "button") props.type = "button";
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        ...props,
        ref: ref,
        onClick: handleClick,
        "aria-label": label,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, bsPrefix, !expanded && "collapsed"),
        children: children || /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
            className: `${bsPrefix}-icon`
        })
    });
});
$483bde2d92fc4302$var$NavbarToggle.displayName = "NavbarToggle";
var $483bde2d92fc4302$export$2e2bcd8739ae039 = $483bde2d92fc4302$var$NavbarToggle;



var $6cds3 = parcelRequire("6cds3");



var $6cds3 = parcelRequire("6cds3");
const $d0aed080f2986237$var$matchersByWindow = new WeakMap();
const $d0aed080f2986237$var$getMatcher = (query, targetWindow)=>{
    if (!query || !targetWindow) return undefined;
    const matchers = $d0aed080f2986237$var$matchersByWindow.get(targetWindow) || new Map();
    $d0aed080f2986237$var$matchersByWindow.set(targetWindow, matchers);
    let mql = matchers.get(query);
    if (!mql) {
        mql = targetWindow.matchMedia(query);
        mql.refCount = 0;
        matchers.set(mql.media, mql);
    }
    return mql;
};
function $d0aed080f2986237$export$2e2bcd8739ae039(query, targetWindow = typeof window === "undefined" ? undefined : window) {
    const mql = $d0aed080f2986237$var$getMatcher(query, targetWindow);
    const [matches, setMatches] = (0, $6cds3.useState)(()=>mql ? mql.matches : false);
    (0, $ac9facc4976791bd$export$2e2bcd8739ae039)(()=>{
        let mql = $d0aed080f2986237$var$getMatcher(query, targetWindow);
        if (!mql) return setMatches(false);
        let matchers = $d0aed080f2986237$var$matchersByWindow.get(targetWindow);
        const handleChange = ()=>{
            setMatches(mql.matches);
        };
        mql.refCount++;
        mql.addListener(handleChange);
        handleChange();
        return ()=>{
            mql.removeListener(handleChange);
            mql.refCount--;
            if (mql.refCount <= 0) matchers == null || matchers.delete(mql.media);
            mql = undefined;
        };
    }, [
        query
    ]);
    return matches;
}



var $6cds3 = parcelRequire("6cds3");
function $77dd0bf458a56536$export$9c6950edc251641e(breakpointValues) {
    const names = Object.keys(breakpointValues);
    function and(query, next) {
        if (query === next) return next;
        return query ? `${query} and ${next}` : next;
    }
    function getNext(breakpoint) {
        return names[Math.min(names.indexOf(breakpoint) + 1, names.length - 1)];
    }
    function getMaxQuery(breakpoint) {
        const next = getNext(breakpoint);
        let value = breakpointValues[next];
        if (typeof value === "number") value = `${value - 0.2}px`;
        else value = `calc(${value} - 0.2px)`;
        return `(max-width: ${value})`;
    }
    function getMinQuery(breakpoint) {
        let value = breakpointValues[breakpoint];
        if (typeof value === "number") value = `${value}px`;
        return `(min-width: ${value})`;
    }
    /**
   * Match a set of breakpoints
   *
   * ```tsx
   * const MidSizeOnly = () => {
   *   const isMid = useBreakpoint({ lg: 'down', sm: 'up' });
   *
   *   if (isMid) return <div>On a Reasonable sized Screen!</div>
   *   return null;
   * }
   * ```
   * @param breakpointMap An object map of breakpoints and directions, queries are constructed using "and" to join
   * breakpoints together
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ /**
   * Match a single breakpoint exactly, up, or down.
   *
   * ```tsx
   * const PhoneOnly = () => {
   *   const isSmall = useBreakpoint('sm', 'down');
   *
   *   if (isSmall) return <div>On a Small Screen!</div>
   *   return null;
   * }
   * ```
   *
   * @param breakpoint The breakpoint key
   * @param direction A direction 'up' for a max, 'down' for min, true to match only the breakpoint
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ function useBreakpoint(breakpointOrMap, direction, window) {
        let breakpointMap;
        if (typeof breakpointOrMap === "object") {
            breakpointMap = breakpointOrMap;
            window = direction;
            direction = true;
        } else {
            direction = direction || true;
            breakpointMap = {
                [breakpointOrMap]: direction
            };
        }
        let query = (0, $6cds3.useMemo)(()=>Object.entries(breakpointMap).reduce((query, [key, direction])=>{
                if (direction === "up" || direction === true) query = and(query, getMinQuery(key));
                if (direction === "down" || direction === true) query = and(query, getMaxQuery(key));
                return query;
            }, ""), [
            JSON.stringify(breakpointMap)
        ]);
        return (0, $d0aed080f2986237$export$2e2bcd8739ae039)(query, window);
    }
    return useBreakpoint;
}
const $77dd0bf458a56536$var$useBreakpoint = $77dd0bf458a56536$export$9c6950edc251641e({
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400
});
var $77dd0bf458a56536$export$2e2bcd8739ae039 = $77dd0bf458a56536$var$useBreakpoint;




var $6cds3 = parcelRequire("6cds3");



var $6cds3 = parcelRequire("6cds3");



"use client";
const $3afca74406154896$var$OffcanvasBody = /*#__PURE__*/ $6cds3.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", ...props }, ref)=>{
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "offcanvas-body");
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, bsPrefix),
        ...props
    });
});
$3afca74406154896$var$OffcanvasBody.displayName = "OffcanvasBody";
var $3afca74406154896$export$2e2bcd8739ae039 = $3afca74406154896$var$OffcanvasBody;




var $6cds3 = parcelRequire("6cds3");





"use client";
const $a9eac842a23b729b$var$transitionStyles = {
    [(0, $e4b1ba7c3a6ebf93$export$df38205c966be359)]: "show",
    [(0, $e4b1ba7c3a6ebf93$export$78e9e6e3e014d60a)]: "show"
};
const $a9eac842a23b729b$var$OffcanvasToggling = /*#__PURE__*/ $6cds3.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, in: inProp = false, mountOnEnter: mountOnEnter = false, unmountOnExit: unmountOnExit = false, appear: appear = false, ...props }, ref)=>{
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "offcanvas");
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9bb091aefa5eb510$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $564ddf315628faa7$export$2e2bcd8739ae039),
        in: inProp,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        ...props,
        childRef: children.ref,
        children: (status, innerProps)=>/*#__PURE__*/ $6cds3.cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, children.props.className, (status === (0, $e4b1ba7c3a6ebf93$export$df38205c966be359) || status === (0, $e4b1ba7c3a6ebf93$export$4aacc83d4d59139f)) && `${bsPrefix}-toggling`, $a9eac842a23b729b$var$transitionStyles[status])
            })
    });
});
$a9eac842a23b729b$var$OffcanvasToggling.displayName = "OffcanvasToggling";
var $a9eac842a23b729b$export$2e2bcd8739ae039 = $a9eac842a23b729b$var$OffcanvasToggling;






var $6cds3 = parcelRequire("6cds3");



"use client";
const $d8328906348fd74c$var$OffcanvasHeader = /*#__PURE__*/ $6cds3.forwardRef(({ bsPrefix: bsPrefix, className: className, closeLabel: closeLabel = "Close", closeButton: closeButton = false, ...props }, ref)=>{
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "offcanvas-header");
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $232dc4c02efc0ee7$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    });
});
$d8328906348fd74c$var$OffcanvasHeader.displayName = "OffcanvasHeader";
var $d8328906348fd74c$export$2e2bcd8739ae039 = $d8328906348fd74c$var$OffcanvasHeader;



var $6cds3 = parcelRequire("6cds3");




"use client";
const $70fb3f84265f2068$var$DivStyledAsH5 = (0, $4209f4cdd547894e$export$2e2bcd8739ae039)("h5");
const $70fb3f84265f2068$var$OffcanvasTitle = /*#__PURE__*/ $6cds3.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $70fb3f84265f2068$var$DivStyledAsH5, ...props }, ref)=>{
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "offcanvas-title");
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, bsPrefix),
        ...props
    });
});
$70fb3f84265f2068$var$OffcanvasTitle.displayName = "OffcanvasTitle";
var $70fb3f84265f2068$export$2e2bcd8739ae039 = $70fb3f84265f2068$var$OffcanvasTitle;





"use client";
function $a13c6fd85dd6263d$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a9eac842a23b729b$export$2e2bcd8739ae039), {
        ...props
    });
}
function $a13c6fd85dd6263d$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9d1648789ad43db2$export$2e2bcd8739ae039), {
        ...props
    });
}
const $a13c6fd85dd6263d$var$Offcanvas = /*#__PURE__*/ $6cds3.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, "aria-labelledby": ariaLabelledby, placement: placement = "start", responsive: responsive, show: /* BaseModal props */ show = false, backdrop: backdrop = true, keyboard: keyboard = true, scroll: scroll = false, onEscapeKeyDown: onEscapeKeyDown, onShow: onShow, onHide: onHide, container: container, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onExited: onExited, backdropClassName: backdropClassName, manager: propsManager, renderStaticNode: renderStaticNode = false, ...props }, ref)=>{
    const modalManager = (0, $6cds3.useRef)();
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "offcanvas");
    const { onToggle: onToggle } = (0, $6cds3.useContext)((0, $978fc16477bde29f$export$2e2bcd8739ae039)) || {};
    const [showOffcanvas, setShowOffcanvas] = (0, $6cds3.useState)(false);
    const hideResponsiveOffcanvas = (0, $77dd0bf458a56536$export$2e2bcd8739ae039)(responsive || "xs", "up");
    (0, $6cds3.useEffect)(()=>{
        // Handles the case where screen is resized while the responsive
        // offcanvas is shown. If `responsive` not provided, just use `show`.
        setShowOffcanvas(responsive ? show && !hideResponsiveOffcanvas : show);
    }, [
        show,
        responsive,
        hideResponsiveOffcanvas
    ]);
    const handleHide = (0, $cfbeaaf7204fcb02$export$2e2bcd8739ae039)(()=>{
        onToggle == null || onToggle();
        onHide == null || onHide();
    });
    const modalContext = (0, $6cds3.useMemo)(()=>({
            onHide: handleHide
        }), [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        if (scroll) {
            // Have to use a different modal manager since the shared
            // one handles overflow.
            if (!modalManager.current) modalManager.current = new (0, $53087d07edd6b6cc$export$2e2bcd8739ae039)({
                handleContainerOverflow: false
            });
            return modalManager.current;
        }
        return (0, $53087d07edd6b6cc$export$a03641438014b436)();
    }
    const handleEnter = (node, ...args)=>{
        if (node) node.style.visibility = "visible";
        onEnter == null || onEnter(node, ...args);
    };
    const handleExited = (node, ...args)=>{
        if (node) node.style.visibility = "";
        onExited == null || onExited(...args);
    };
    const renderBackdrop = (0, $6cds3.useCallback)((backdropProps)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
            ...backdropProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(`${bsPrefix}-backdrop`, backdropClassName)
        }), [
        backdropClassName,
        bsPrefix
    ]);
    const renderDialog = (dialogProps)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
            ...dialogProps,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, responsive ? `${bsPrefix}-${responsive}` : bsPrefix, `${bsPrefix}-${placement}`),
            "aria-labelledby": ariaLabelledby,
            children: children
        });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: [
            !showOffcanvas && (responsive || renderStaticNode) && renderDialog({}),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $c2ec00bdc56ab783$export$2e2bcd8739ae039).Provider, {
                value: modalContext,
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $ff7ce879cf38438a$export$2e2bcd8739ae039), {
                    show: showOffcanvas,
                    ref: ref,
                    backdrop: backdrop,
                    container: container,
                    keyboard: keyboard,
                    autoFocus: autoFocus,
                    enforceFocus: enforceFocus && !scroll,
                    restoreFocus: restoreFocus,
                    restoreFocusOptions: restoreFocusOptions,
                    onEscapeKeyDown: onEscapeKeyDown,
                    onShow: onShow,
                    onHide: handleHide,
                    onEnter: handleEnter,
                    onEntering: onEntering,
                    onEntered: onEntered,
                    onExit: onExit,
                    onExiting: onExiting,
                    onExited: handleExited,
                    manager: getModalManager(),
                    transition: $a13c6fd85dd6263d$var$DialogTransition,
                    backdropTransition: $a13c6fd85dd6263d$var$BackdropTransition,
                    renderBackdrop: renderBackdrop,
                    renderDialog: renderDialog
                })
            })
        ]
    });
});
$a13c6fd85dd6263d$var$Offcanvas.displayName = "Offcanvas";
var $a13c6fd85dd6263d$export$2e2bcd8739ae039 = Object.assign($a13c6fd85dd6263d$var$Offcanvas, {
    Body: (0, $3afca74406154896$export$2e2bcd8739ae039),
    Header: (0, $d8328906348fd74c$export$2e2bcd8739ae039),
    Title: (0, $70fb3f84265f2068$export$2e2bcd8739ae039)
});




"use client";
const $61b512f3710f85fc$var$NavbarOffcanvas = /*#__PURE__*/ $6cds3.forwardRef((props, ref)=>{
    const context = (0, $6cds3.useContext)((0, $978fc16477bde29f$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a13c6fd85dd6263d$export$2e2bcd8739ae039), {
        ref: ref,
        show: !!(context != null && context.expanded),
        ...props,
        renderStaticNode: true
    });
});
$61b512f3710f85fc$var$NavbarOffcanvas.displayName = "NavbarOffcanvas";
var $61b512f3710f85fc$export$2e2bcd8739ae039 = $61b512f3710f85fc$var$NavbarOffcanvas;





var $6cds3 = parcelRequire("6cds3");



"use client";
const $df7e852327187a2e$var$NavbarText = /*#__PURE__*/ $6cds3.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "span", ...props }, ref)=>{
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "navbar-text");
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, bsPrefix),
        ...props
    });
});
$df7e852327187a2e$var$NavbarText.displayName = "NavbarText";
var $df7e852327187a2e$export$2e2bcd8739ae039 = $df7e852327187a2e$var$NavbarText;



"use client";
const $dc1f9dddc97a5e79$var$Navbar = /*#__PURE__*/ $6cds3.forwardRef((props, ref)=>{
    const { bsPrefix: initialBsPrefix, expand: expand = true, variant: variant = "light", bg: bg, fixed: fixed, sticky: sticky, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = "nav", expanded: expanded, onToggle: onToggle, onSelect: onSelect, collapseOnSelect: collapseOnSelect = false, ...controlledProps } = (0, $ebeccf058174fd37$export$2e2bcd8739ae039)(props, {
        expanded: "onToggle"
    });
    const bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(initialBsPrefix, "navbar");
    const handleCollapse = (0, $6cds3.useCallback)((...args)=>{
        onSelect == null || onSelect(...args);
        if (collapseOnSelect && expanded) onToggle == null || onToggle(false);
    }, [
        onSelect,
        collapseOnSelect,
        expanded,
        onToggle
    ]);
    // will result in some false positives but that seems better
    // than false negatives. strict `undefined` check allows explicit
    // "nulling" of the role if the user really doesn't want one
    if (controlledProps.role === undefined && Component !== "nav") controlledProps.role = "navigation";
    let expandClass = `${bsPrefix}-expand`;
    if (typeof expand === "string") expandClass = `${expandClass}-${expand}`;
    const navbarContext = (0, $6cds3.useMemo)(()=>({
            onToggle: ()=>onToggle == null ? void 0 : onToggle(!expanded),
            bsPrefix: bsPrefix,
            expanded: !!expanded,
            expand: expand
        }), [
        bsPrefix,
        expanded,
        expand,
        onToggle
    ]);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $978fc16477bde29f$export$2e2bcd8739ae039).Provider, {
        value: navbarContext,
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a140b6f07d6ac44a$export$2e2bcd8739ae039).Provider, {
            value: handleCollapse,
            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
                ref: ref,
                ...controlledProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, bsPrefix, expand && expandClass, variant && `${bsPrefix}-${variant}`, bg && `bg-${bg}`, sticky && `sticky-${sticky}`, fixed && `fixed-${fixed}`)
            })
        })
    });
});
$dc1f9dddc97a5e79$var$Navbar.displayName = "Navbar";
var $dc1f9dddc97a5e79$export$2e2bcd8739ae039 = Object.assign($dc1f9dddc97a5e79$var$Navbar, {
    Brand: (0, $9452897da317bbd0$export$2e2bcd8739ae039),
    Collapse: (0, $4a69c0674892cb21$export$2e2bcd8739ae039),
    Offcanvas: (0, $61b512f3710f85fc$export$2e2bcd8739ae039),
    Text: (0, $df7e852327187a2e$export$2e2bcd8739ae039),
    Toggle: (0, $483bde2d92fc4302$export$2e2bcd8739ae039)
});



var $6cds3 = parcelRequire("6cds3");


"use client";
const $5a495f88153c14dd$var$ButtonGroup = /*#__PURE__*/ $6cds3.forwardRef(({ bsPrefix: bsPrefix, size: size, vertical: vertical = false, className: className, role: role = "group", // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div", ...rest }, ref)=>{
    const prefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "btn-group");
    let baseClass = prefix;
    if (vertical) baseClass = `${prefix}-vertical`;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        ...rest,
        ref: ref,
        role: role,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, baseClass, size && `${prefix}-${size}`)
    });
});
$5a495f88153c14dd$var$ButtonGroup.displayName = "ButtonGroup";
var $5a495f88153c14dd$export$2e2bcd8739ae039 = $5a495f88153c14dd$var$ButtonGroup;



var $6cds3 = parcelRequire("6cds3");

var $aMJGV = parcelRequire("aMJGV");
var $5555b2a88ddd6ca2$var$_excluded = [
    "color",
    "size",
    "title"
];
function $5555b2a88ddd6ca2$var$_extends() {
    $5555b2a88ddd6ca2$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5555b2a88ddd6ca2$var$_extends.apply(this, arguments);
}
function $5555b2a88ddd6ca2$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $5555b2a88ddd6ca2$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $5555b2a88ddd6ca2$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $5555b2a88ddd6ca2$var$DropletHalf = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, rest = $5555b2a88ddd6ca2$var$_objectWithoutProperties(_ref, $5555b2a88ddd6ca2$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("svg", $5555b2a88ddd6ca2$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        fillRule: "evenodd",
        d: "M7.21.8C7.69.295 8 0 8 0q.164.544.371 1.038c.812 1.946 2.073 3.35 3.197 4.6C12.878 7.096 14 8.345 14 10a6 6 0 0 1-12 0C2 6.668 5.58 2.517 7.21.8m.413 1.021A31 31 0 0 0 5.794 3.99c-.726.95-1.436 2.008-1.96 3.07C3.304 8.133 3 9.138 3 10c0 0 2.5 1.5 5 .5s5-.5 5-.5c0-1.201-.796-2.157-2.181-3.7l-.03-.032C9.75 5.11 8.5 3.72 7.623 1.82z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        fillRule: "evenodd",
        d: "M4.553 7.776c.82-1.641 1.717-2.753 2.093-3.13l.708.708c-.29.29-1.128 1.311-1.907 2.87z"
    }));
});
$5555b2a88ddd6ca2$var$DropletHalf.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string
};
$5555b2a88ddd6ca2$var$DropletHalf.defaultProps = {
    color: "currentColor",
    size: "1em",
    title: null
};
var $5555b2a88ddd6ca2$export$2e2bcd8739ae039 = $5555b2a88ddd6ca2$var$DropletHalf;


var $6cds3 = parcelRequire("6cds3");

var $aMJGV = parcelRequire("aMJGV");
var $71f64457e7ee5e3d$var$_excluded = [
    "color",
    "size",
    "title"
];
function $71f64457e7ee5e3d$var$_extends() {
    $71f64457e7ee5e3d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $71f64457e7ee5e3d$var$_extends.apply(this, arguments);
}
function $71f64457e7ee5e3d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $71f64457e7ee5e3d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $71f64457e7ee5e3d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $71f64457e7ee5e3d$var$DropletFill = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, rest = $71f64457e7ee5e3d$var$_objectWithoutProperties(_ref, $71f64457e7ee5e3d$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("svg", $71f64457e7ee5e3d$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "M8 16a6 6 0 0 0 6-6c0-1.655-1.122-2.904-2.432-4.362C10.254 4.176 8.75 2.503 8 0c0 0-6 5.686-6 10a6 6 0 0 0 6 6M6.646 4.646l.708.708c-.29.29-1.128 1.311-1.907 2.87l-.894-.448c.82-1.641 1.717-2.753 2.093-3.13"
    }));
});
$71f64457e7ee5e3d$var$DropletFill.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string
};
$71f64457e7ee5e3d$var$DropletFill.defaultProps = {
    color: "currentColor",
    size: "1em",
    title: null
};
var $71f64457e7ee5e3d$export$2e2bcd8739ae039 = $71f64457e7ee5e3d$var$DropletFill;


var $6cds3 = parcelRequire("6cds3");

var $aMJGV = parcelRequire("aMJGV");
var $e0cf018f143bcd60$var$_excluded = [
    "color",
    "size",
    "title"
];
function $e0cf018f143bcd60$var$_extends() {
    $e0cf018f143bcd60$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e0cf018f143bcd60$var$_extends.apply(this, arguments);
}
function $e0cf018f143bcd60$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e0cf018f143bcd60$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e0cf018f143bcd60$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $e0cf018f143bcd60$var$Droplet = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, rest = $e0cf018f143bcd60$var$_objectWithoutProperties(_ref, $e0cf018f143bcd60$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("svg", $e0cf018f143bcd60$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        fillRule: "evenodd",
        d: "M7.21.8C7.69.295 8 0 8 0q.164.544.371 1.038c.812 1.946 2.073 3.35 3.197 4.6C12.878 7.096 14 8.345 14 10a6 6 0 0 1-12 0C2 6.668 5.58 2.517 7.21.8m.413 1.021A31 31 0 0 0 5.794 3.99c-.726.95-1.436 2.008-1.96 3.07C3.304 8.133 3 9.138 3 10a5 5 0 0 0 10 0c0-1.201-.796-2.157-2.181-3.7l-.03-.032C9.75 5.11 8.5 3.72 7.623 1.82z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        fillRule: "evenodd",
        d: "M4.553 7.776c.82-1.641 1.717-2.753 2.093-3.13l.708.708c-.29.29-1.128 1.311-1.907 2.87z"
    }));
});
$e0cf018f143bcd60$var$Droplet.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string
};
$e0cf018f143bcd60$var$Droplet.defaultProps = {
    color: "currentColor",
    size: "1em",
    title: null
};
var $e0cf018f143bcd60$export$2e2bcd8739ae039 = $e0cf018f143bcd60$var$Droplet;


var $6cds3 = parcelRequire("6cds3");

var $aMJGV = parcelRequire("aMJGV");
var $c101c58977bda107$var$_excluded = [
    "color",
    "size",
    "title"
];
function $c101c58977bda107$var$_extends() {
    $c101c58977bda107$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c101c58977bda107$var$_extends.apply(this, arguments);
}
function $c101c58977bda107$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $c101c58977bda107$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $c101c58977bda107$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $c101c58977bda107$var$WrenchAdjustableCircleFill = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, rest = $c101c58977bda107$var$_objectWithoutProperties(_ref, $c101c58977bda107$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("svg", $c101c58977bda107$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "M6.705 8.139a.25.25 0 0 0-.288-.376l-1.5.5.159.474.808-.27-.595.894a.25.25 0 0 0 .287.376l.808-.27-.595.894a.25.25 0 0 0 .287.376l1.5-.5-.159-.474-.808.27.596-.894a.25.25 0 0 0-.288-.376l-.808.27z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m-6.202-4.751 1.988-1.657a4.5 4.5 0 0 1 7.537-4.623L7.497 6.5l1 2.5 1.333 3.11c-.56.251-1.18.39-1.833.39a4.5 4.5 0 0 1-1.592-.29L4.747 14.2a7.03 7.03 0 0 1-2.949-2.951M12.496 8a4.5 4.5 0 0 1-1.703 3.526L9.497 8.5l2.959-1.11q.04.3.04.61"
    }));
});
$c101c58977bda107$var$WrenchAdjustableCircleFill.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string
};
$c101c58977bda107$var$WrenchAdjustableCircleFill.defaultProps = {
    color: "currentColor",
    size: "1em",
    title: null
};
var $c101c58977bda107$export$2e2bcd8739ae039 = $c101c58977bda107$var$WrenchAdjustableCircleFill;


var $6cds3 = parcelRequire("6cds3");

var $aMJGV = parcelRequire("aMJGV");
var $919d8f7a86c784de$var$_excluded = [
    "color",
    "size",
    "title"
];
function $919d8f7a86c784de$var$_extends() {
    $919d8f7a86c784de$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $919d8f7a86c784de$var$_extends.apply(this, arguments);
}
function $919d8f7a86c784de$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $919d8f7a86c784de$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $919d8f7a86c784de$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $919d8f7a86c784de$var$WrenchAdjustableCircle = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, rest = $919d8f7a86c784de$var$_objectWithoutProperties(_ref, $919d8f7a86c784de$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("svg", $919d8f7a86c784de$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "M12.496 8a4.5 4.5 0 0 1-1.703 3.526L9.497 8.5l2.959-1.11q.04.3.04.61"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-1 0a7 7 0 1 0-13.202 3.249l1.988-1.657a4.5 4.5 0 0 1 7.537-4.623L7.497 6.5l1 2.5 1.333 3.11c-.56.251-1.18.39-1.833.39a4.5 4.5 0 0 1-1.592-.29L4.747 14.2A7 7 0 0 0 15 8m-8.295.139a.25.25 0 0 0-.288-.376l-1.5.5.159.474.808-.27-.595.894a.25.25 0 0 0 .287.376l.808-.27-.595.894a.25.25 0 0 0 .287.376l1.5-.5-.159-.474-.808.27.596-.894a.25.25 0 0 0-.288-.376l-.808.27z"
    }));
});
$919d8f7a86c784de$var$WrenchAdjustableCircle.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string
};
$919d8f7a86c784de$var$WrenchAdjustableCircle.defaultProps = {
    color: "currentColor",
    size: "1em",
    title: null
};
var $919d8f7a86c784de$export$2e2bcd8739ae039 = $919d8f7a86c784de$var$WrenchAdjustableCircle;


var $6cds3 = parcelRequire("6cds3");

var $aMJGV = parcelRequire("aMJGV");
var $8f99976611234862$var$_excluded = [
    "color",
    "size",
    "title"
];
function $8f99976611234862$var$_extends() {
    $8f99976611234862$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8f99976611234862$var$_extends.apply(this, arguments);
}
function $8f99976611234862$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $8f99976611234862$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $8f99976611234862$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $8f99976611234862$var$Stars = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, rest = $8f99976611234862$var$_objectWithoutProperties(_ref, $8f99976611234862$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("svg", $8f99976611234862$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "M7.657 6.247c.11-.33.576-.33.686 0l.645 1.937a2.89 2.89 0 0 0 1.829 1.828l1.936.645c.33.11.33.576 0 .686l-1.937.645a2.89 2.89 0 0 0-1.828 1.829l-.645 1.936a.361.361 0 0 1-.686 0l-.645-1.937a2.89 2.89 0 0 0-1.828-1.828l-1.937-.645a.361.361 0 0 1 0-.686l1.937-.645a2.89 2.89 0 0 0 1.828-1.828zM3.794 1.148a.217.217 0 0 1 .412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 0 1 0 .412l-1.162.387A1.73 1.73 0 0 0 4.593 5.69l-.387 1.162a.217.217 0 0 1-.412 0L3.407 5.69A1.73 1.73 0 0 0 2.31 4.593l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.387A1.73 1.73 0 0 0 3.407 2.31zM10.863.099a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 0 1 0 .274l-.774.258a1.16 1.16 0 0 0-.732.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.16 1.16 0 0 0-.732-.732L9.1 2.137a.145.145 0 0 1 0-.274l.774-.258c.346-.115.617-.386.732-.732z"
    }));
});
$8f99976611234862$var$Stars.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string
};
$8f99976611234862$var$Stars.defaultProps = {
    color: "currentColor",
    size: "1em",
    title: null
};
var $8f99976611234862$export$2e2bcd8739ae039 = $8f99976611234862$var$Stars;


var $6cds3 = parcelRequire("6cds3");

var $aMJGV = parcelRequire("aMJGV");
var $a764e00b89eb1737$var$_excluded = [
    "color",
    "size",
    "title"
];
function $a764e00b89eb1737$var$_extends() {
    $a764e00b89eb1737$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a764e00b89eb1737$var$_extends.apply(this, arguments);
}
function $a764e00b89eb1737$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a764e00b89eb1737$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a764e00b89eb1737$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $a764e00b89eb1737$var$Coin = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, rest = $a764e00b89eb1737$var$_objectWithoutProperties(_ref, $a764e00b89eb1737$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("svg", $a764e00b89eb1737$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "M5.5 9.511c.076.954.83 1.697 2.182 1.785V12h.6v-.709c1.4-.098 2.218-.846 2.218-1.932 0-.987-.626-1.496-1.745-1.76l-.473-.112V5.57c.6.068.982.396 1.074.85h1.052c-.076-.919-.864-1.638-2.126-1.716V4h-.6v.719c-1.195.117-2.01.836-2.01 1.853 0 .9.606 1.472 1.613 1.707l.397.098v2.034c-.615-.093-1.022-.43-1.114-.9zm2.177-2.166c-.59-.137-.91-.416-.91-.836 0-.47.345-.822.915-.925v1.76h-.005zm.692 1.193c.717.166 1.048.435 1.048.91 0 .542-.412.914-1.135.982V8.518z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "M8 13.5a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11m0 .5A6 6 0 1 0 8 2a6 6 0 0 0 0 12"
    }));
});
$a764e00b89eb1737$var$Coin.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string
};
$a764e00b89eb1737$var$Coin.defaultProps = {
    color: "currentColor",
    size: "1em",
    title: null
};
var $a764e00b89eb1737$export$2e2bcd8739ae039 = $a764e00b89eb1737$var$Coin;


var $6cds3 = parcelRequire("6cds3");

var $aMJGV = parcelRequire("aMJGV");
var $35bb2be1292df2d9$var$_excluded = [
    "color",
    "size",
    "title"
];
function $35bb2be1292df2d9$var$_extends() {
    $35bb2be1292df2d9$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $35bb2be1292df2d9$var$_extends.apply(this, arguments);
}
function $35bb2be1292df2d9$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $35bb2be1292df2d9$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $35bb2be1292df2d9$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $35bb2be1292df2d9$var$EnvelopePaper = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, rest = $35bb2be1292df2d9$var$_objectWithoutProperties(_ref, $35bb2be1292df2d9$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("svg", $35bb2be1292df2d9$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "M4 0a2 2 0 0 0-2 2v1.133l-.941.502A2 2 0 0 0 0 5.4V14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V5.4a2 2 0 0 0-1.059-1.765L14 3.133V2a2 2 0 0 0-2-2zm10 4.267.47.25A1 1 0 0 1 15 5.4v.817l-1 .6zm-1 3.15-3.75 2.25L8 8.917l-1.25.75L3 7.417V2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1zm-11-.6-1-.6V5.4a1 1 0 0 1 .53-.882L2 4.267zm13 .566v5.734l-4.778-2.867zm-.035 6.88A1 1 0 0 1 14 15H2a1 1 0 0 1-.965-.738L8 10.083zM1 13.116V7.383l4.778 2.867L1 13.117Z"
    }));
});
$35bb2be1292df2d9$var$EnvelopePaper.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string
};
$35bb2be1292df2d9$var$EnvelopePaper.defaultProps = {
    color: "currentColor",
    size: "1em",
    title: null
};
var $35bb2be1292df2d9$export$2e2bcd8739ae039 = $35bb2be1292df2d9$var$EnvelopePaper;


var $6cds3 = parcelRequire("6cds3");

var $aMJGV = parcelRequire("aMJGV");
var $ace35481abdb3b8c$var$_excluded = [
    "color",
    "size",
    "title"
];
function $ace35481abdb3b8c$var$_extends() {
    $ace35481abdb3b8c$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ace35481abdb3b8c$var$_extends.apply(this, arguments);
}
function $ace35481abdb3b8c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ace35481abdb3b8c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $ace35481abdb3b8c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $ace35481abdb3b8c$var$Magic = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, rest = $ace35481abdb3b8c$var$_objectWithoutProperties(_ref, $ace35481abdb3b8c$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("svg", $ace35481abdb3b8c$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "M9.5 2.672a.5.5 0 1 0 1 0V.843a.5.5 0 0 0-1 0zm4.5.035A.5.5 0 0 0 13.293 2L12 3.293a.5.5 0 1 0 .707.707zM7.293 4A.5.5 0 1 0 8 3.293L6.707 2A.5.5 0 0 0 6 2.707zm-.621 2.5a.5.5 0 1 0 0-1H4.843a.5.5 0 1 0 0 1zm8.485 0a.5.5 0 1 0 0-1h-1.829a.5.5 0 0 0 0 1zM13.293 10A.5.5 0 1 0 14 9.293L12.707 8a.5.5 0 1 0-.707.707zM9.5 11.157a.5.5 0 0 0 1 0V9.328a.5.5 0 0 0-1 0zm1.854-5.097a.5.5 0 0 0 0-.706l-.708-.708a.5.5 0 0 0-.707 0L8.646 5.94a.5.5 0 0 0 0 .707l.708.708a.5.5 0 0 0 .707 0l1.293-1.293Zm-3 3a.5.5 0 0 0 0-.706l-.708-.708a.5.5 0 0 0-.707 0L.646 13.94a.5.5 0 0 0 0 .707l.708.708a.5.5 0 0 0 .707 0z"
    }));
});
$ace35481abdb3b8c$var$Magic.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string
};
$ace35481abdb3b8c$var$Magic.defaultProps = {
    color: "currentColor",
    size: "1em",
    title: null
};
var $ace35481abdb3b8c$export$2e2bcd8739ae039 = $ace35481abdb3b8c$var$Magic;


var $6cds3 = parcelRequire("6cds3");

var $aMJGV = parcelRequire("aMJGV");
var $439c909092c9bb4d$var$_excluded = [
    "color",
    "size",
    "title"
];
function $439c909092c9bb4d$var$_extends() {
    $439c909092c9bb4d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $439c909092c9bb4d$var$_extends.apply(this, arguments);
}
function $439c909092c9bb4d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $439c909092c9bb4d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $439c909092c9bb4d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $439c909092c9bb4d$var$Key = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, rest = $439c909092c9bb4d$var$_objectWithoutProperties(_ref, $439c909092c9bb4d$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("svg", $439c909092c9bb4d$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "M0 8a4 4 0 0 1 7.465-2H14a.5.5 0 0 1 .354.146l1.5 1.5a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0L13 9.207l-.646.647a.5.5 0 0 1-.708 0L11 9.207l-.646.647a.5.5 0 0 1-.708 0L9 9.207l-.646.647A.5.5 0 0 1 8 10h-.535A4 4 0 0 1 0 8m4-3a3 3 0 1 0 2.712 4.285A.5.5 0 0 1 7.163 9h.63l.853-.854a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.793-.793-1-1h-6.63a.5.5 0 0 1-.451-.285A3 3 0 0 0 4 5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "M4 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
    }));
});
$439c909092c9bb4d$var$Key.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string
};
$439c909092c9bb4d$var$Key.defaultProps = {
    color: "currentColor",
    size: "1em",
    title: null
};
var $439c909092c9bb4d$export$2e2bcd8739ae039 = $439c909092c9bb4d$var$Key;


var $6cds3 = parcelRequire("6cds3");

var $aMJGV = parcelRequire("aMJGV");
var $0d0d1fef9e2b8fcf$var$_excluded = [
    "color",
    "size",
    "title"
];
function $0d0d1fef9e2b8fcf$var$_extends() {
    $0d0d1fef9e2b8fcf$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0d0d1fef9e2b8fcf$var$_extends.apply(this, arguments);
}
function $0d0d1fef9e2b8fcf$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $0d0d1fef9e2b8fcf$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $0d0d1fef9e2b8fcf$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $0d0d1fef9e2b8fcf$var$Eye = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, rest = $0d0d1fef9e2b8fcf$var$_objectWithoutProperties(_ref, $0d0d1fef9e2b8fcf$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("svg", $0d0d1fef9e2b8fcf$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0"
    }));
});
$0d0d1fef9e2b8fcf$var$Eye.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string
};
$0d0d1fef9e2b8fcf$var$Eye.defaultProps = {
    color: "currentColor",
    size: "1em",
    title: null
};
var $0d0d1fef9e2b8fcf$export$2e2bcd8739ae039 = $0d0d1fef9e2b8fcf$var$Eye;


var $6cds3 = parcelRequire("6cds3");

var $aMJGV = parcelRequire("aMJGV");
var $053e6fdc626b068a$var$_excluded = [
    "color",
    "size",
    "title"
];
function $053e6fdc626b068a$var$_extends() {
    $053e6fdc626b068a$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $053e6fdc626b068a$var$_extends.apply(this, arguments);
}
function $053e6fdc626b068a$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $053e6fdc626b068a$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $053e6fdc626b068a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $053e6fdc626b068a$var$CashCoin = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, rest = $053e6fdc626b068a$var$_objectWithoutProperties(_ref, $053e6fdc626b068a$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("svg", $053e6fdc626b068a$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        fillRule: "evenodd",
        d: "M11 15a4 4 0 1 0 0-8 4 4 0 0 0 0 8m5-4a5 5 0 1 1-10 0 5 5 0 0 1 10 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "M9.438 11.944c.047.596.518 1.06 1.363 1.116v.44h.375v-.443c.875-.061 1.386-.529 1.386-1.207 0-.618-.39-.936-1.09-1.1l-.296-.07v-1.2c.376.043.614.248.671.532h.658c-.047-.575-.54-1.024-1.329-1.073V8.5h-.375v.45c-.747.073-1.255.522-1.255 1.158 0 .562.378.92 1.007 1.066l.248.061v1.272c-.384-.058-.639-.27-.696-.563h-.668zm1.36-1.354c-.369-.085-.569-.26-.569-.522 0-.294.216-.514.572-.578v1.1zm.432.746c.449.104.655.272.655.569 0 .339-.257.571-.709.614v-1.195z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "M1 0a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h4.083q.088-.517.258-1H3a2 2 0 0 0-2-2V3a2 2 0 0 0 2-2h10a2 2 0 0 0 2 2v3.528c.38.34.717.728 1 1.154V1a1 1 0 0 0-1-1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "M9.998 5.083 10 5a2 2 0 1 0-3.132 1.65 6 6 0 0 1 3.13-1.567"
    }));
});
$053e6fdc626b068a$var$CashCoin.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string
};
$053e6fdc626b068a$var$CashCoin.defaultProps = {
    color: "currentColor",
    size: "1em",
    title: null
};
var $053e6fdc626b068a$export$2e2bcd8739ae039 = $053e6fdc626b068a$var$CashCoin;




var $6cds3 = parcelRequire("6cds3");

class $ae76c41a34495815$var$GitHubButton extends (0, $6cds3.PureComponent) {
    render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("span", {
            ref: this.$
        }, (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("a", {
            ...this.props,
            ref: this._
        }, this.props.children));
    }
    componentDidMount() {
        this.paint();
    }
    getSnapshotBeforeUpdate() {
        this.reset();
        return null;
    }
    componentDidUpdate() {
        this.paint();
    }
    componentWillUnmount() {
        this.reset();
    }
    paint() {
        const _ = this.$.current.appendChild(document.createElement("span"));
        (parcelRequire("1hqAq")).then(({ render: render })=>{
            if (this._.current != null) render(_.appendChild(this._.current), function(el) {
                try {
                    _.parentNode.replaceChild(el, _);
                } catch (_) {}
            });
        });
    }
    reset() {
        this.$.current.replaceChild(this._.current, this.$.current.lastChild);
    }
    constructor(props){
        super(props);
        this.$ = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createRef();
        this._ = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createRef();
    }
}
var $ae76c41a34495815$export$2e2bcd8739ae039 = $ae76c41a34495815$var$GitHubButton;


var $7c846a15465cce4a$exports = {};

$7c846a15465cce4a$exports = (parcelRequire("17QCl")).getBundleURL("7lpHJ") + "logo.54b3d73e.png";


var $a7b2057ce332323b$exports = {};

$a7b2057ce332323b$exports = (parcelRequire("17QCl")).getBundleURL("7lpHJ") + "logo@2x.cf27bf02.png";


var $4b2174e61fd9240a$exports = {};

$4b2174e61fd9240a$exports = (parcelRequire("17QCl")).getBundleURL("7lpHJ") + "logo@3x.b134ce59.png";


var $9423e3c32dfe8181$exports = {};

$9423e3c32dfe8181$exports = (parcelRequire("17QCl")).getBundleURL("7lpHJ") + "logo-white.7089cb5d.png";


var $5ebfdabee7765f00$exports = {};

$5ebfdabee7765f00$exports = (parcelRequire("17QCl")).getBundleURL("7lpHJ") + "logo-white@2x.2694fdf1.png";


var $c39fb6ed17b44c3e$exports = {};

$c39fb6ed17b44c3e$exports = (parcelRequire("17QCl")).getBundleURL("7lpHJ") + "logo-white@3x.c5b9c5f8.png";


var $37212c70dd010488$exports = {};

$37212c70dd010488$exports = (parcelRequire("17QCl")).getBundleURL("7lpHJ") + "powered-by-akash.cf0ce61b.svg";


var $7795e70cea840c4a$exports = {};

$7795e70cea840c4a$exports = (parcelRequire("17QCl")).getBundleURL("7lpHJ") + "powered-by-akash-white.97304638.svg";


var $c845e611e0d858e2$exports = {};

$c845e611e0d858e2$exports = (parcelRequire("17QCl")).getBundleURL("7lpHJ") + "providedby.9635655d.svg";


var $2560efb14bcc55a9$exports = {};

$2560efb14bcc55a9$exports = (parcelRequire("17QCl")).getBundleURL("7lpHJ") + "providedbywhite.1d00e321.svg";





var $6cds3 = parcelRequire("6cds3");

var $c9wMV = parcelRequire("c9wMV");





var $6cds3 = parcelRequire("6cds3");
var $d85ff2c90168cfc4$exports = {};


!function(e, t) {
    $d85ff2c90168cfc4$exports = t((parcelRequire("2KWqD")), (parcelRequire("6cds3")));
}($d85ff2c90168cfc4$exports, function(e, t) {
    return function(e) {
        var t = {};
        function n(r) {
            if (t[r]) return t[r].exports;
            var o = t[r] = {
                i: r,
                l: !1,
                exports: {}
            };
            return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
        }
        return n.m = e, n.c = t, n.d = function(e, t, r) {
            n.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: r
            });
        }, n.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, n.t = function(e, t) {
            if (1 & t && (e = n(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var r = Object.create(null);
            if (n.r(r), Object.defineProperty(r, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var o in e)n.d(r, o, (function(t) {
                return e[t];
            }).bind(null, o));
            return r;
        }, n.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return n.d(t, "a", t), t;
        }, n.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, n.p = "", n(n.s = 6);
    }([
        function(e, t, n) {
            e.exports = n(3)();
        },
        function(t, n) {
            t.exports = e;
        },
        function(e, n) {
            e.exports = t;
        },
        function(e, t, n) {
            "use strict";
            var r = n(4);
            function o() {}
            function i() {}
            i.resetWarningCache = o, e.exports = function() {
                function e(e, t, n, o, i, a) {
                    if (a !== r) {
                        var l = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                        throw l.name = "Invariant Violation", l;
                    }
                }
                function t() {
                    return e;
                }
                e.isRequired = e;
                var n = {
                    array: e,
                    bool: e,
                    func: e,
                    number: e,
                    object: e,
                    string: e,
                    symbol: e,
                    any: e,
                    arrayOf: t,
                    element: e,
                    elementType: e,
                    instanceOf: t,
                    node: e,
                    objectOf: t,
                    oneOf: t,
                    oneOfType: t,
                    shape: t,
                    exact: t,
                    checkPropTypes: i,
                    resetWarningCache: o
                };
                return n.PropTypes = n, n;
            };
        },
        function(e, t, n) {
            "use strict";
            e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
        },
        function(e, t, n) {
            var r, o, i, a, l;
            /*! Moment Duration Format v2.2.2
 *  https://github.com/jsmreese/moment-duration-format
 *  Date: 2018-02-16
 *
 *  Duration format plugin function for the Moment.js library
 *  http://momentjs.com/
 *
 *  Copyright 2018 John Madhavan-Reese
 *  Released under the MIT license
 */ a = this, l = function(e) {
                var t = !1, n = !1, r = !1, o = !1, i = "escape years months weeks days hours minutes seconds milliseconds general".split(" "), a = [
                    {
                        type: "seconds",
                        targets: [
                            {
                                type: "minutes",
                                value: 60
                            },
                            {
                                type: "hours",
                                value: 3600
                            },
                            {
                                type: "days",
                                value: 86400
                            },
                            {
                                type: "weeks",
                                value: 604800
                            },
                            {
                                type: "months",
                                value: 2678400
                            },
                            {
                                type: "years",
                                value: 31536e3
                            }
                        ]
                    },
                    {
                        type: "minutes",
                        targets: [
                            {
                                type: "hours",
                                value: 60
                            },
                            {
                                type: "days",
                                value: 1440
                            },
                            {
                                type: "weeks",
                                value: 10080
                            },
                            {
                                type: "months",
                                value: 44640
                            },
                            {
                                type: "years",
                                value: 525600
                            }
                        ]
                    },
                    {
                        type: "hours",
                        targets: [
                            {
                                type: "days",
                                value: 24
                            },
                            {
                                type: "weeks",
                                value: 168
                            },
                            {
                                type: "months",
                                value: 744
                            },
                            {
                                type: "years",
                                value: 8760
                            }
                        ]
                    },
                    {
                        type: "days",
                        targets: [
                            {
                                type: "weeks",
                                value: 7
                            },
                            {
                                type: "months",
                                value: 31
                            },
                            {
                                type: "years",
                                value: 365
                            }
                        ]
                    },
                    {
                        type: "months",
                        targets: [
                            {
                                type: "years",
                                value: 12
                            }
                        ]
                    }
                ];
                function l(e, t) {
                    return !(t.length > e.length) && -1 !== e.indexOf(t);
                }
                function u(e) {
                    for(var t = ""; e;)t += "0", e -= 1;
                    return t;
                }
                function s(e, t) {
                    var n = e + "+" + v(V(t).sort(), function(e) {
                        return e + ":" + t[e];
                    }).join(",");
                    return s.cache[n] || (s.cache[n] = Intl.NumberFormat(e, t)), s.cache[n];
                }
                function c(e, t, i) {
                    var a, l, f, m = t.useToLocaleString, p = t.useGrouping, g = p && t.grouping.slice(), y = t.maximumSignificantDigits, h = t.minimumIntegerDigits || 1, d = t.fractionDigits || 0, v = t.groupingSeparator, b = t.decimalSeparator;
                    if (m && i) {
                        var w, S = {
                            minimumIntegerDigits: h,
                            useGrouping: p
                        };
                        return d && (S.maximumFractionDigits = d, S.minimumFractionDigits = d), y && e > 0 && (S.maximumSignificantDigits = y), r ? (o || ((w = x({}, t)).useGrouping = !1, w.decimalSeparator = ".", e = parseFloat(c(e, w), 10)), s(i, S).format(e)) : (n || ((w = x({}, t)).useGrouping = !1, w.decimalSeparator = ".", e = parseFloat(c(e, w), 10)), e.toLocaleString(i, S));
                    }
                    var T = (y ? e.toPrecision(y + 1) : e.toFixed(d + 1)).split("e");
                    f = T[1] || "", l = (T = T[0].split("."))[1] || "";
                    var O = (a = T[0] || "").length, _ = l.length, V = O + _, D = a + l;
                    (y && V === y + 1 || !y && _ === d + 1) && ((D = function(e) {
                        for(var t = e.split("").reverse(), n = 0, r = !0; r && n < t.length;)n ? "9" === t[n] ? t[n] = "0" : (t[n] = (parseInt(t[n], 10) + 1).toString(), r = !1) : (parseInt(t[n], 10) < 5 && (r = !1), t[n] = "0"), n += 1;
                        return r && t.push("1"), t.reverse().join("");
                    }(D)).length === V + 1 && (O += 1), _ && (D = D.slice(0, -1)), a = D.slice(0, O), l = D.slice(O)), y && (l = l.replace(/0*$/, ""));
                    var j = parseInt(f, 10);
                    j > 0 ? l.length <= j ? (a += l += u(j - l.length), l = "") : (a += l.slice(0, j), l = l.slice(j)) : j < 0 && (l = u(Math.abs(j) - a.length) + a + l, a = "0"), y || ((l = l.slice(0, d)).length < d && (l += u(d - l.length)), a.length < h && (a = u(h - a.length) + a));
                    var M, P = "";
                    if (p) for(T = a; T.length;)g.length && (M = g.shift()), P && (P = v + P), P = T.slice(-M) + P, T = T.slice(0, -M);
                    else P = a;
                    return l && (P = P + b + l), P;
                }
                function f(e, t) {
                    return e.label.length > t.label.length ? -1 : e.label.length < t.label.length ? 1 : 0;
                }
                function m(e, t) {
                    var n = [];
                    return d(V(t), function(r) {
                        if ("_durationLabels" === r.slice(0, 15)) {
                            var o = r.slice(15).toLowerCase();
                            d(V(t[r]), function(i) {
                                i.slice(0, 1) === e && n.push({
                                    type: o,
                                    key: i,
                                    label: t[r][i]
                                });
                            });
                        }
                    }), n;
                }
                s.cache = {};
                var p = {
                    durationLabelsStandard: {
                        S: "millisecond",
                        SS: "milliseconds",
                        s: "second",
                        ss: "seconds",
                        m: "minute",
                        mm: "minutes",
                        h: "hour",
                        hh: "hours",
                        d: "day",
                        dd: "days",
                        w: "week",
                        ww: "weeks",
                        M: "month",
                        MM: "months",
                        y: "year",
                        yy: "years"
                    },
                    durationLabelsShort: {
                        S: "msec",
                        SS: "msecs",
                        s: "sec",
                        ss: "secs",
                        m: "min",
                        mm: "mins",
                        h: "hr",
                        hh: "hrs",
                        d: "dy",
                        dd: "dys",
                        w: "wk",
                        ww: "wks",
                        M: "mo",
                        MM: "mos",
                        y: "yr",
                        yy: "yrs"
                    },
                    durationTimeTemplates: {
                        HMS: "h:mm:ss",
                        HM: "h:mm",
                        MS: "m:ss"
                    },
                    durationLabelTypes: [
                        {
                            type: "standard",
                            string: "__"
                        },
                        {
                            type: "short",
                            string: "_"
                        }
                    ],
                    durationPluralKey: function(e, t, n) {
                        return 1 === t && null === n ? e : e + e;
                    }
                };
                function g(e) {
                    return "[object Array]" === Object.prototype.toString.call(e);
                }
                function y(e) {
                    return "[object Object]" === Object.prototype.toString.call(e);
                }
                function h(e, t) {
                    var n, r = 0, o = e && e.length || 0;
                    for("function" != typeof t && (n = t, t = function(e) {
                        return e === n;
                    }); r < o;){
                        if (t(e[r])) return e[r];
                        r += 1;
                    }
                }
                function d(e, t) {
                    var n = 0, r = e.length;
                    if (e && r) for(; n < r;){
                        if (!1 === t(e[n], n)) return;
                        n += 1;
                    }
                }
                function v(e, t) {
                    var n = 0, r = e.length, o = [];
                    if (!e || !r) return o;
                    for(; n < r;)o[n] = t(e[n], n), n += 1;
                    return o;
                }
                function b(e, t) {
                    return v(e, function(e) {
                        return e[t];
                    });
                }
                function w(e) {
                    var t = [];
                    return d(e, function(e) {
                        e && t.push(e);
                    }), t;
                }
                function S(e) {
                    var t = [];
                    return d(e, function(e) {
                        h(t, e) || t.push(e);
                    }), t;
                }
                function T(e, t) {
                    var n = [];
                    return d(e, function(e) {
                        d(t, function(t) {
                            e === t && n.push(e);
                        });
                    }), S(n);
                }
                function O(e, t) {
                    var n = [];
                    return d(e, function(r, o) {
                        if (!t(r)) return n = e.slice(o), !1;
                    }), n;
                }
                function _(e, t) {
                    return O(e.slice().reverse(), t).reverse();
                }
                function x(e, t) {
                    for(var n in t)t.hasOwnProperty(n) && (e[n] = t[n]);
                    return e;
                }
                function V(e) {
                    var t = [];
                    for(var n in e)e.hasOwnProperty(n) && t.push(n);
                    return t;
                }
                function D(e, t) {
                    var n = 0, r = e.length;
                    if (!e || !r) return !1;
                    for(; n < r;){
                        if (!0 === t(e[n], n)) return !0;
                        n += 1;
                    }
                    return !1;
                }
                function j(e) {
                    var t = [];
                    return d(e, function(e) {
                        t = t.concat(e);
                    }), t;
                }
                function M(e) {
                    return "3.6" === e(3.55, "en", {
                        useGrouping: !1,
                        minimumIntegerDigits: 1,
                        minimumFractionDigits: 1,
                        maximumFractionDigits: 1
                    });
                }
                function P(e) {
                    var t = !0;
                    return !!((t = (t = (t = t && "1" === e(1, "en", {
                        minimumIntegerDigits: 1
                    })) && "01" === e(1, "en", {
                        minimumIntegerDigits: 2
                    })) && "001" === e(1, "en", {
                        minimumIntegerDigits: 3
                    })) && (t = (t = (t = (t = t && "100" === e(99.99, "en", {
                        maximumFractionDigits: 0,
                        minimumFractionDigits: 0
                    })) && "100.0" === e(99.99, "en", {
                        maximumFractionDigits: 1,
                        minimumFractionDigits: 1
                    })) && "99.99" === e(99.99, "en", {
                        maximumFractionDigits: 2,
                        minimumFractionDigits: 2
                    })) && "99.990" === e(99.99, "en", {
                        maximumFractionDigits: 3,
                        minimumFractionDigits: 3
                    })) && (t = (t = (t = (t = (t = t && "100" === e(99.99, "en", {
                        maximumSignificantDigits: 1
                    })) && "100" === e(99.99, "en", {
                        maximumSignificantDigits: 2
                    })) && "100" === e(99.99, "en", {
                        maximumSignificantDigits: 3
                    })) && "99.99" === e(99.99, "en", {
                        maximumSignificantDigits: 4
                    })) && "99.99" === e(99.99, "en", {
                        maximumSignificantDigits: 5
                    })) && (t = (t = t && "1,000" === e(1e3, "en", {
                        useGrouping: !0
                    })) && "1000" === e(1e3, "en", {
                        useGrouping: !1
                    })));
                }
                function k() {
                    var e, t = [].slice.call(arguments), n = {};
                    if (d(t, function(t, r) {
                        if (!r) {
                            if (!g(t)) throw "Expected array as the first argument to durationsFormat.";
                            e = t;
                        }
                        "string" != typeof t && "function" != typeof t ? "number" != typeof t ? y(t) && x(n, t) : n.precision = t : n.template = t;
                    }), !e || !e.length) return [];
                    n.returnMomentTypes = !0;
                    var r = v(e, function(e) {
                        return e.format(n);
                    }), o = T(i, S(b(j(r), "type"))), a = n.largest;
                    return a && (o = o.slice(0, a)), n.returnMomentTypes = !1, n.outputTypes = o, v(e, function(e) {
                        return e.format(n);
                    });
                }
                function E() {
                    var n = [].slice.call(arguments), o = x({}, this.format.defaults), u = this.asMilliseconds(), s = this.asMonths();
                    "function" == typeof this.isValid && !1 === this.isValid() && (u = 0, s = 0);
                    var j = u < 0, M = e.duration(Math.abs(u), "milliseconds"), P = e.duration(Math.abs(s), "months");
                    d(n, function(e) {
                        "string" != typeof e && "function" != typeof e ? "number" != typeof e ? y(e) && x(o, e) : o.precision = e : o.template = e;
                    });
                    var k = {
                        years: "y",
                        months: "M",
                        weeks: "w",
                        days: "d",
                        hours: "h",
                        minutes: "m",
                        seconds: "s",
                        milliseconds: "S"
                    }, E = {
                        escape: /\[(.+?)\]/,
                        years: /\*?[Yy]+/,
                        months: /\*?M+/,
                        weeks: /\*?[Ww]+/,
                        days: /\*?[Dd]+/,
                        hours: /\*?[Hh]+/,
                        minutes: /\*?m+/,
                        seconds: /\*?s+/,
                        milliseconds: /\*?S+/,
                        general: /.+?/
                    };
                    o.types = i;
                    var L = function(e) {
                        return h(i, function(t) {
                            return E[t].test(e);
                        });
                    }, F = new RegExp(v(i, function(e) {
                        return E[e].source;
                    }).join("|"), "g");
                    o.duration = this;
                    var I = "function" == typeof o.template ? o.template.apply(o) : o.template, N = o.outputTypes, C = o.returnMomentTypes, R = o.largest, G = [];
                    N || (g(o.stopTrim) && (o.stopTrim = o.stopTrim.join("")), o.stopTrim && d(o.stopTrim.match(F), function(e) {
                        var t = L(e);
                        "escape" !== t && "general" !== t && G.push(t);
                    }));
                    var U = e.localeData();
                    U || (U = {}), d(V(p), function(e) {
                        "function" != typeof p[e] ? U["_" + e] || (U["_" + e] = p[e]) : U[e] || (U[e] = p[e]);
                    }), d(V(U._durationTimeTemplates), function(e) {
                        I = I.replace("_" + e + "_", U._durationTimeTemplates[e]);
                    });
                    var q = o.userLocale || e.locale(), z = o.useLeftUnits, H = o.usePlural, W = o.precision, $ = o.forceLength, A = o.useGrouping, B = o.trunc, K = o.useSignificantDigits && W > 0, Y = K ? o.precision : 0, J = Y, Q = o.minValue, X = !1, Z = o.maxValue, ee = !1, te = o.useToLocaleString, ne = o.groupingSeparator, re = o.decimalSeparator, oe = o.grouping;
                    te = te && (t || r);
                    var ie = o.trim;
                    g(ie) && (ie = ie.join(" ")), null === ie && (R || Z || K) && (ie = "all"), null !== ie && !0 !== ie && "left" !== ie && "right" !== ie || (ie = "large"), !1 === ie && (ie = "");
                    var ae = function(e) {
                        return e.test(ie);
                    }, le = /large/, ue = /small/, se = /both/, ce = /mid/, fe = /^all|[^sm]all/, me = /final/, pe = R > 0 || D([
                        le,
                        se,
                        fe
                    ], ae), ge = D([
                        ue,
                        se,
                        fe
                    ], ae), ye = D([
                        ce,
                        fe
                    ], ae), he = D([
                        me,
                        fe
                    ], ae), de = v(I.match(F), function(e, t) {
                        var n = L(e);
                        return "*" === e.slice(0, 1) && (e = e.slice(1), "escape" !== n && "general" !== n && G.push(n)), {
                            index: t,
                            length: e.length,
                            text: "",
                            token: "escape" === n ? e.replace(E.escape, "$1") : e,
                            type: "escape" === n || "general" === n ? null : n
                        };
                    }), ve = {
                        index: 0,
                        length: 0,
                        token: "",
                        text: "",
                        type: null
                    }, be = [];
                    z && de.reverse(), d(de, function(e) {
                        if (e.type) return (ve.type || ve.text) && be.push(ve), void (ve = e);
                        z ? ve.text = e.token + ve.text : ve.text += e.token;
                    }), (ve.type || ve.text) && be.push(ve), z && be.reverse();
                    var we = T(i, S(w(b(be, "type"))));
                    if (!we.length) return b(be, "text").join("");
                    we = v(we, function(e, t) {
                        var n, r = t + 1 === we.length, i = !t;
                        n = "years" === e || "months" === e ? P.as(e) : M.as(e);
                        var a = Math.floor(n), l = n - a, u = h(be, function(t) {
                            return e === t.type;
                        });
                        return i && Z && n > Z && (ee = !0), r && Q && Math.abs(o.duration.as(e)) < Q && (X = !0), i && null === $ && u.length > 1 && ($ = !0), M.subtract(a, e), P.subtract(a, e), {
                            rawValue: n,
                            wholeValue: a,
                            decimalValue: r ? l : 0,
                            isSmallest: r,
                            isLargest: i,
                            type: e,
                            tokenLength: u.length
                        };
                    });
                    var Se = B ? Math.floor : Math.round, Te = function(e, t) {
                        var n = Math.pow(10, t);
                        return Se(e * n) / n;
                    }, Oe = !1, _e = !1, xe = function(e, t) {
                        var n = {
                            useGrouping: A,
                            groupingSeparator: ne,
                            decimalSeparator: re,
                            grouping: oe,
                            useToLocaleString: te
                        };
                        return K && (Y <= 0 ? (e.rawValue = 0, e.wholeValue = 0, e.decimalValue = 0) : (n.maximumSignificantDigits = Y, e.significantDigits = Y)), ee && !_e && (e.isLargest ? (e.wholeValue = Z, e.decimalValue = 0) : (e.wholeValue = 0, e.decimalValue = 0)), X && !_e && (e.isSmallest ? (e.wholeValue = Q, e.decimalValue = 0) : (e.wholeValue = 0, e.decimalValue = 0)), e.isSmallest || e.significantDigits && e.significantDigits - e.wholeValue.toString().length <= 0 ? W < 0 ? e.value = Te(e.wholeValue, W) : 0 === W ? e.value = Se(e.wholeValue + e.decimalValue) : K ? (e.value = B ? Te(e.rawValue, Y - e.wholeValue.toString().length) : e.rawValue, e.wholeValue && (Y -= e.wholeValue.toString().length)) : (n.fractionDigits = W, e.value = B ? e.wholeValue + Te(e.decimalValue, W) : e.wholeValue + e.decimalValue) : K && e.wholeValue ? (e.value = Math.round(Te(e.wholeValue, e.significantDigits - e.wholeValue.toString().length)), Y -= e.wholeValue.toString().length) : e.value = e.wholeValue, e.tokenLength > 1 && ($ || Oe) && (n.minimumIntegerDigits = e.tokenLength, _e && n.maximumSignificantDigits < e.tokenLength && delete n.maximumSignificantDigits), !Oe && (e.value > 0 || "" === ie || h(G, e.type) || h(N, e.type)) && (Oe = !0), e.formattedValue = c(e.value, n, q), n.useGrouping = !1, n.decimalSeparator = ".", e.formattedValueEn = c(e.value, n, "en"), 2 === e.tokenLength && "milliseconds" === e.type && (e.formattedValueMS = c(e.value, {
                            minimumIntegerDigits: 3,
                            useGrouping: !1
                        }, "en").slice(0, 2)), e;
                    };
                    if ((we = w(we = v(we, xe))).length > 1) {
                        var Ve = function(e) {
                            return h(we, function(t) {
                                return t.type === e;
                            });
                        }, De = function(e) {
                            var t = Ve(e.type);
                            t && d(e.targets, function(e) {
                                var n = Ve(e.type);
                                n && parseInt(t.formattedValueEn, 10) === e.value && (t.rawValue = 0, t.wholeValue = 0, t.decimalValue = 0, n.rawValue += 1, n.wholeValue += 1, n.decimalValue = 0, n.formattedValueEn = n.wholeValue.toString(), _e = !0);
                            });
                        };
                        d(a, De);
                    }
                    return _e && (Oe = !1, Y = J, we = w(we = v(we, xe))), !N || ee && !o.trim ? (pe && (we = O(we, function(e) {
                        return !e.isSmallest && !e.wholeValue && !h(G, e.type);
                    })), R && we.length && (we = we.slice(0, R)), ge && we.length > 1 && (we = _(we, function(e) {
                        return !e.wholeValue && !h(G, e.type) && !e.isLargest;
                    })), ye && (we = w(we = v(we, function(e, t) {
                        return t > 0 && t < we.length - 1 && !e.wholeValue ? null : e;
                    }))), !he || 1 !== we.length || we[0].wholeValue || !B && we[0].isSmallest && we[0].rawValue < Q || (we = [])) : we = w(we = v(we, function(e) {
                        return h(N, function(t) {
                            return e.type === t;
                        }) ? e : null;
                    })), C ? we : (d(be, function(e) {
                        var t = k[e.type], n = h(we, function(t) {
                            return t.type === e.type;
                        });
                        if (t && n) {
                            var r = n.formattedValueEn.split(".");
                            r[0] = parseInt(r[0], 10), r[1] ? r[1] = parseFloat("0." + r[1], 10) : r[1] = null;
                            var o = U.durationPluralKey(t, r[0], r[1]), i = m(t, U), a = !1, u = {};
                            d(U._durationLabelTypes, function(t) {
                                var n = h(i, function(e) {
                                    return e.type === t.type && e.key === o;
                                });
                                n && (u[n.type] = n.label, l(e.text, t.string) && (e.text = e.text.replace(t.string, n.label), a = !0));
                            }), H && !a && (i.sort(f), d(i, function(t) {
                                return u[t.type] === t.label ? !l(e.text, t.label) && void 0 : l(e.text, t.label) ? (e.text = e.text.replace(t.label, u[t.type]), !1) : void 0;
                            }));
                        }
                    }), (be = v(be, function(e) {
                        if (!e.type) return e.text;
                        var t = h(we, function(t) {
                            return t.type === e.type;
                        });
                        if (!t) return "";
                        var n = "";
                        return z && (n += e.text), (j && ee || !j && X) && (n += "< ", ee = !1, X = !1), (j && X || !j && ee) && (n += "> ", ee = !1, X = !1), j && (t.value > 0 || "" === ie || h(G, t.type) || h(N, t.type)) && (n += "-", j = !1), "milliseconds" === e.type && t.formattedValueMS ? n += t.formattedValueMS : n += t.formattedValue, z || (n += e.text), n;
                    })).join("").replace(/(,| |:|\.)*$/, "").replace(/^(,| |:|\.)*/, ""));
                }
                function L() {
                    var e = this.duration, t = function(t) {
                        return e._data[t];
                    }, n = h(this.types, t), r = function(e, t) {
                        for(var n = e.length; n -= 1;)if (t(e[n])) return e[n];
                    }(this.types, t);
                    switch(n){
                        case "milliseconds":
                            return "S __";
                        case "seconds":
                        case "minutes":
                            return "*_MS_";
                        case "hours":
                            return "_HMS_";
                        case "days":
                            if (n === r) return "d __";
                        case "weeks":
                            return n === r ? "w __" : (null === this.trim && (this.trim = "both"), "w __, d __, h __");
                        case "months":
                            if (n === r) return "M __";
                        case "years":
                            return n === r ? "y __" : (null === this.trim && (this.trim = "both"), "y __, M __, d __");
                        default:
                            return null === this.trim && (this.trim = "both"), "y __, d __, h __, m __, s __";
                    }
                }
                function F(e) {
                    if (!e) throw "Moment Duration Format init cannot find moment instance.";
                    e.duration.format = k, e.duration.fn.format = E, e.duration.fn.format.defaults = {
                        trim: null,
                        stopTrim: null,
                        largest: null,
                        maxValue: null,
                        minValue: null,
                        precision: 0,
                        trunc: !1,
                        forceLength: null,
                        userLocale: null,
                        usePlural: !0,
                        useLeftUnits: !1,
                        useGrouping: !0,
                        useSignificantDigits: !1,
                        template: L,
                        useToLocaleString: !0,
                        groupingSeparator: ",",
                        decimalSeparator: ".",
                        grouping: [
                            3
                        ]
                    }, e.updateLocale("en", p);
                }
                var I = function(e, t, n) {
                    return e.toLocaleString(t, n);
                };
                t = function() {
                    try {
                        0..toLocaleString("i");
                    } catch (e) {
                        return "RangeError" === e.name;
                    }
                    return !1;
                }() && P(I), n = t && M(I);
                var N = function(e, t, n) {
                    if ("undefined" != typeof window && window && window.Intl && window.Intl.NumberFormat) return window.Intl.NumberFormat(t, n).format(e);
                };
                return r = P(N), o = r && M(N), F(e), F;
            }, o = [
                n(1)
            ], void 0 === (i = "function" == typeof (r = l) ? r.apply(t, o) : r) || (e.exports = i), a && (a.momentDurationFormatSetup = a.moment ? l(a.moment) : l);
        },
        function(e, t, n) {
            "use strict";
            n.r(t), n.d(t, "default", function() {
                return _;
            });
            var r = n(2), o = n.n(r), i = n(0), a = n.n(i), l = n(1), u = n.n(l);
            n(5);
            function s(e) {
                return (s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            function c(e, t) {
                var n = Object.keys(e);
                if (Object.getOwnPropertySymbols) {
                    var r = Object.getOwnPropertySymbols(e);
                    t && (r = r.filter(function(t) {
                        return Object.getOwnPropertyDescriptor(e, t).enumerable;
                    })), n.push.apply(n, r);
                }
                return n;
            }
            function f(e, t) {
                if (null == e) return {};
                var n, r, o = function(e, t) {
                    if (null == e) return {};
                    var n, r, o = {}, i = Object.keys(e);
                    for(r = 0; r < i.length; r++)n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
                    return o;
                }(e, t);
                if (Object.getOwnPropertySymbols) {
                    var i = Object.getOwnPropertySymbols(e);
                    for(r = 0; r < i.length; r++)n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
                }
                return o;
            }
            function m(e, t) {
                for(var n = 0; n < t.length; n++){
                    var r = t[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                }
            }
            function p(e, t, n) {
                return t && m(e.prototype, t), n && m(e, n), e;
            }
            function g(e, t) {
                return (g = Object.setPrototypeOf || function(e, t) {
                    return e.__proto__ = t, e;
                })(e, t);
            }
            function y(e) {
                var t = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }();
                return function() {
                    var n, r = v(e);
                    if (t) {
                        var o = v(this).constructor;
                        n = Reflect.construct(r, arguments, o);
                    } else n = r.apply(this, arguments);
                    return h(this, n);
                };
            }
            function h(e, t) {
                return !t || "object" !== s(t) && "function" != typeof t ? d(e) : t;
            }
            function d(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }
            function v(e) {
                return (v = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                    return e.__proto__ || Object.getPrototypeOf(e);
                })(e);
            }
            function b(e, t, n) {
                return t in e ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : e[t] = n, e;
            }
            var w = [
                a.a.string,
                a.a.number,
                a.a.array,
                a.a.object
            ], S = [
                a.a.string,
                a.a.array
            ], T = [
                a.a.object,
                a.a.bool
            ], O = [
                a.a.string,
                a.a.bool
            ], _ = function(e) {
                !function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                    e.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: e,
                            writable: !0,
                            configurable: !0
                        }
                    }), t && g(e, t);
                }(n, e);
                var t = y(n);
                function n(e) {
                    var r;
                    return function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, n), b(d(r = t.call(this, e)), "setTimer", function() {
                        var e = r.props.interval;
                        r.clearTimer(), n.pooledTimer || 0 === e || (r.timer = setInterval(function() {
                            r.update(r.props);
                        }, e));
                    }), b(d(r), "getTitle", function() {
                        var e = r.props.titleFormat, t = n.getDatetime(r.props), o = e || n.globalFormat;
                        return t.format(o);
                    }), b(d(r), "clearTimer", function() {
                        !n.pooledTimer && r.timer && (clearInterval(r.timer), r.timer = null), n.pooledTimer && !r.timer && n.removePooledElement(d(r));
                    }), n.globalMoment || (n.globalMoment = u.a), r.state = {
                        content: ""
                    }, r.timer = null, r;
                }
                return p(n, null, [
                    {
                        key: "startPooledTimer",
                        value: function() {
                            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 6e4;
                            n.clearPooledTimer(), n.pooledTimer = setInterval(function() {
                                n.pooledElements.forEach(function(e) {
                                    0 !== e.props.interval && e.update();
                                });
                            }, e);
                        }
                    },
                    {
                        key: "clearPooledTimer",
                        value: function() {
                            n.pooledTimer && (clearInterval(n.pooledTimer), n.pooledTimer = null, n.pooledElements = []);
                        }
                    },
                    {
                        key: "pushPooledElement",
                        value: function(e) {
                            e instanceof n ? -1 === n.pooledElements.indexOf(e) && n.pooledElements.push(e) : console.error("Element not an instance of Moment.");
                        }
                    },
                    {
                        key: "removePooledElement",
                        value: function(e) {
                            var t = n.pooledElements.indexOf(e);
                            -1 !== t && n.pooledElements.splice(t, 1);
                        }
                    },
                    {
                        key: "getDatetime",
                        value: function(e) {
                            var t = e.utc, r = e.unix, o = e.date, i = e.locale, a = e.parse, l = e.tz, u = e.local;
                            o = o || e.children, a = a || n.globalParse, u = u || n.globalLocal, l = l || n.globalTimezone, i = n.globalLocale ? n.globalLocale : i || n.globalMoment.locale();
                            var s = null;
                            return s = t ? n.globalMoment.utc(o, a, i) : r ? n.globalMoment(1e3 * o, a, i) : n.globalMoment(o, a, i), l ? s = s.tz(l) : u && (s = s.local()), s;
                        }
                    },
                    {
                        key: "getContent",
                        value: function(e) {
                            var t = e.fromNow, r = e.fromNowDuring, o = e.from, i = e.add, a = e.subtract, l = e.toNow, s = e.to, c = e.ago, f = e.calendar, m = e.diff, p = e.duration, g = e.durationFromNow, y = e.unit, h = e.decimal, d = e.trim, v = e.format;
                            v = v || n.globalFormat;
                            var b = n.getDatetime(e);
                            i && b.add(i), a && b.subtract(a);
                            var w = Boolean(r) && -b.diff(u()()) < r, S = "";
                            return S = !v || w || g || p ? o ? b.from(o, c) : t || w ? b.fromNow(c) : s ? b.to(s, c) : l ? b.toNow(c) : f ? b.calendar(null, f) : m ? b.diff(m, y, h) : p ? b.diff(p) : g ? u()().diff(b) : b.toString() : b.format(v), (p || g) && (S = (S = u.a.duration(S)).format(v, {
                                trim: d
                            })), S = (n.globalFilter || e.filter)(S);
                        }
                    }
                ]), p(n, [
                    {
                        key: "componentDidMount",
                        value: function() {
                            this.setTimer(), n.pooledTimer && n.pushPooledElement(this);
                        }
                    },
                    {
                        key: "componentDidUpdate",
                        value: function(e) {
                            var t = this.props.interval;
                            e.interval !== t && this.setTimer();
                        }
                    },
                    {
                        key: "componentWillUnmount",
                        value: function() {
                            this.clearTimer();
                        }
                    },
                    {
                        key: "update",
                        value: function(e) {
                            var t = e || this.props, r = t.onChange, o = n.getContent(t);
                            this.setState({
                                content: o
                            }, function() {
                                r(o);
                            });
                        }
                    },
                    {
                        key: "render",
                        value: function() {
                            var e, t, r, i, a = this.props, l = a.withTitle, u = a.element, s = f(a, [
                                "withTitle",
                                "element"
                            ]), m = this.state.content, p = (e = s, t = n.propTypes, r = Object.keys(t), i = Object.assign({}, e), Object.keys(i).filter(function(e) {
                                return -1 !== r.indexOf(e);
                            }).forEach(function(e) {
                                return delete i[e];
                            }), i);
                            return l && (p.title = this.getTitle()), o.a.createElement(u || n.globalElement, function(e) {
                                for(var t = 1; t < arguments.length; t++){
                                    var n = null != arguments[t] ? arguments[t] : {};
                                    t % 2 ? c(Object(n), !0).forEach(function(t) {
                                        b(e, t, n[t]);
                                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : c(Object(n)).forEach(function(t) {
                                        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                                    });
                                }
                                return e;
                            }({
                                dateTime: n.getDatetime(this.props)
                            }, p), m);
                        }
                    }
                ], [
                    {
                        key: "getDerivedStateFromProps",
                        value: function(e) {
                            return {
                                content: n.getContent(e)
                            };
                        }
                    }
                ]), n;
            }(o.a.Component);
            b(_, "propTypes", {
                element: a.a.any,
                date: a.a.oneOfType(w),
                parse: a.a.oneOfType(S),
                format: a.a.string,
                add: a.a.object,
                subtract: a.a.object,
                ago: a.a.bool,
                fromNow: a.a.bool,
                fromNowDuring: a.a.number,
                from: a.a.oneOfType(w),
                toNow: a.a.bool,
                to: a.a.oneOfType(w),
                calendar: a.a.oneOfType(T),
                unix: a.a.bool,
                utc: a.a.bool,
                local: a.a.bool,
                tz: a.a.string,
                withTitle: a.a.bool,
                titleFormat: a.a.string,
                locale: a.a.string,
                interval: a.a.number,
                diff: a.a.oneOfType(w),
                duration: a.a.oneOfType(w),
                durationFromNow: a.a.bool,
                trim: a.a.oneOfType(O),
                unit: a.a.string,
                decimal: a.a.bool,
                filter: a.a.func,
                onChange: a.a.func
            }), b(_, "defaultProps", {
                element: null,
                fromNow: !1,
                toNow: !1,
                calendar: !1,
                ago: !1,
                unix: !1,
                utc: !1,
                local: !1,
                unit: null,
                withTitle: !1,
                trim: !1,
                decimal: !1,
                titleFormat: "",
                interval: 6e4,
                filter: function(e) {
                    return e;
                },
                onChange: function() {}
            }), b(_, "globalMoment", null), b(_, "globalLocale", null), b(_, "globalLocal", null), b(_, "globalFormat", null), b(_, "globalParse", null), b(_, "globalFilter", null), b(_, "globalElement", "time"), b(_, "globalTimezone", null), b(_, "pooledElements", []), b(_, "pooledTimer", null);
        }
    ]);
});



var $c9wMV = parcelRequire("c9wMV");




parcelRequire("6cds3");

var $c9wMV = parcelRequire("c9wMV");



var $6cds3 = parcelRequire("6cds3");



"use client";
const $ef8501a4a8330b14$var$ROUND_PRECISION = 1000;
/**
 * Validate that children, if any, are instances of `ProgressBar`.
 */ function $ef8501a4a8330b14$var$onlyProgressBar(props, propName, componentName) {
    const children = props[propName];
    if (!children) return null;
    let error = null;
    $6cds3.Children.forEach(children, (child)=>{
        if (error) return;
        /**
     * Compare types in a way that works with libraries that patch and proxy
     * components like react-hot-loader.
     *
     * see https://github.com/gaearon/react-hot-loader#checking-element-types
     */ // eslint-disable-next-line @typescript-eslint/no-use-before-define
        const element = /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($ef8501a4a8330b14$var$ProgressBar, {});
        if (child.type === element.type) return;
        const childType = child.type;
        const childIdentifier = /*#__PURE__*/ $6cds3.isValidElement(child) ? childType.displayName || childType.name || childType : child;
        error = new Error(`Children of ${componentName} can contain only ProgressBar ` + `components. Found ${childIdentifier}.`);
    });
    return error;
}
function $ef8501a4a8330b14$var$getPercentage(now, min, max) {
    const percentage = (now - min) / (max - min) * 100;
    return Math.round(percentage * $ef8501a4a8330b14$var$ROUND_PRECISION) / $ef8501a4a8330b14$var$ROUND_PRECISION;
}
function $ef8501a4a8330b14$var$renderProgressBar({ min: min, now: now, max: max, label: label, visuallyHidden: visuallyHidden, striped: striped, animated: animated, className: className, style: style, variant: variant, bsPrefix: bsPrefix, ...props }, ref) {
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
        ref: ref,
        ...props,
        role: "progressbar",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, `${bsPrefix}-bar`, {
            [`bg-${variant}`]: variant,
            [`${bsPrefix}-bar-animated`]: animated,
            [`${bsPrefix}-bar-striped`]: animated || striped
        }),
        style: {
            width: `${$ef8501a4a8330b14$var$getPercentage(now, min, max)}%`,
            ...style
        },
        "aria-valuenow": now,
        "aria-valuemin": min,
        "aria-valuemax": max,
        children: visuallyHidden ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
            className: "visually-hidden",
            children: label
        }) : label
    });
}
const $ef8501a4a8330b14$var$ProgressBar = /*#__PURE__*/ $6cds3.forwardRef(({ isChild: isChild = false, ...rest }, ref)=>{
    const props = {
        min: 0,
        max: 100,
        animated: false,
        visuallyHidden: false,
        striped: false,
        ...rest
    };
    props.bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(props.bsPrefix, "progress");
    if (isChild) return $ef8501a4a8330b14$var$renderProgressBar(props, ref);
    const { min: min, now: now, max: max, label: label, visuallyHidden: visuallyHidden, striped: striped, animated: animated, bsPrefix: bsPrefix, variant: variant, className: className, children: children, ...wrapperProps } = props;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
        ref: ref,
        ...wrapperProps,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, bsPrefix),
        children: children ? (0, $400379245e9e6b68$export$871de8747c9eaa88)(children, (child)=>/*#__PURE__*/ (0, $6cds3.cloneElement)(child, {
                isChild: true
            })) : $ef8501a4a8330b14$var$renderProgressBar({
            min: min,
            now: now,
            max: max,
            label: label,
            visuallyHidden: visuallyHidden,
            striped: striped,
            animated: animated,
            bsPrefix: bsPrefix,
            variant: variant
        }, ref)
    });
});
$ef8501a4a8330b14$var$ProgressBar.displayName = "ProgressBar";
var $ef8501a4a8330b14$export$2e2bcd8739ae039 = $ef8501a4a8330b14$var$ProgressBar;


function $ee5b19fa9f9150ab$var$ProposalProgress(props) {
    const { proposal: proposal, tally: tally } = props;
    const { proposal_id: proposal_id, status: status } = proposal;
    if (!tally) return null;
    if (status === "PROPOSAL_STATUS_DEPOSIT_PERIOD") return null;
    const variants = {
        "yes": "success",
        "abstain": "info",
        "no": "danger",
        "no_with_veto": "danger"
    };
    const total = Object.values(tally).reduce((sum, value)=>(0, $ed89d4c20b089b73$export$e16d8520af44a096)(sum, value), 0);
    if (total === 0) return null;
    const progress = Object.keys(tally).reduce((sum, key)=>{
        sum[key] = (0, $ed89d4c20b089b73$export$2060d2db72cce88f)((0, $ed89d4c20b089b73$export$cd007d971a5a2143)(tally[key], total), 100);
        return sum;
    }, {});
    function variant(key) {
        return variants[key.replace("_count", "")];
    }
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $843e0f89d5f7d219$export$2e2bcd8739ae039), {
        overlay: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $75c21e5a46e079cb$export$2e2bcd8739ae039), {
            id: `tooltip-progress-${proposal_id}`,
            children: Object.entries(progress).map(([key, value])=>{
                return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                    className: "mb-2",
                    children: [
                        [
                            (0, (/*@__PURE__*/$parcel$interopDefault($c9wMV))).startCase(key),
                            (0, $ed89d4c20b089b73$export$d9468344d3651243)(value, {
                                precision: 2,
                                notation: "fixed"
                            })
                        ].join(": "),
                        "%"
                    ]
                }, key);
            })
        }),
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $ef8501a4a8330b14$export$2e2bcd8739ae039), {
            style: {
                height: props.height || 15
            },
            children: Object.entries(progress).map(([key, value])=>{
                return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $ef8501a4a8330b14$export$2e2bcd8739ae039), {
                    variant: variant(key),
                    now: value,
                    label: `${(0, $ed89d4c20b089b73$export$d9468344d3651243)(value, {
                        precision: 0,
                        notation: "fixed"
                    })}%`
                }, key);
            })
        })
    });
}
var $ee5b19fa9f9150ab$export$2e2bcd8739ae039 = $ee5b19fa9f9150ab$var$ProposalProgress;


const $c353f6c871ff77a0$export$22dfa22445c4c90 = {
    "": "All",
    "PROPOSAL_STATUS_DEPOSIT_PERIOD": "Deposit Period",
    "PROPOSAL_STATUS_VOTING_PERIOD": "Voting Period",
    "PROPOSAL_STATUS_PASSED": "Passed",
    "PROPOSAL_STATUS_REJECTED": "Rejected",
    "PROPOSAL_STATUS_FAILED": "Failed"
};
const $c353f6c871ff77a0$var$Proposal = (data)=>{
    let { proposal_id: proposal_id, content: content, messages: messages, metadata: metadata } = data;
    if (!proposal_id && data.id) proposal_id = data.id;
    let title, description, typeHuman;
    if (metadata) try {
        metadata = JSON.parse(metadata);
        title = metadata.title;
        description = metadata.summary;
    } catch (e) {
        console.log(e);
    }
    if (messages) {
        var _messages_find;
        content = (_messages_find = messages.find((el)=>el["@type"] === "/cosmos.gov.v1.MsgExecLegacyContent")) === null || _messages_find === void 0 ? void 0 : _messages_find.content;
        messages = messages.filter((el)=>el["@type"] !== "/cosmos.gov.v1.MsgExecLegacyContent");
        typeHuman = messages.map((el)=>el["@type"].split(".").reverse()[0]).join(", ");
    }
    if (content) {
        title = title || content.title;
        description = description || content.description;
        typeHuman = typeHuman || (content["@type"] ? content["@type"].split(".").reverse()[0] : "Unknown");
    }
    title = title || typeHuman;
    description = description || metadata;
    const statusHuman = $c353f6c871ff77a0$export$22dfa22445c4c90[data.status];
    const isDeposit = data.status === "PROPOSAL_STATUS_DEPOSIT_PERIOD";
    const isVoting = data.status === "PROPOSAL_STATUS_VOTING_PERIOD";
    return {
        ...data,
        proposal_id: proposal_id,
        title: title,
        typeHuman: typeHuman,
        statusHuman: statusHuman,
        description: description,
        content: content,
        metadata: metadata,
        messages: messages,
        isDeposit: isDeposit,
        isVoting: isVoting
    };
};
var $c353f6c871ff77a0$export$2e2bcd8739ae039 = $c353f6c871ff77a0$var$Proposal;


function $653f5b7d06fe127c$var$Proposals(props) {
    const { proposals: proposals, tallies: tallies, votes: votes } = props;
    const [filter, setFilter] = (0, $6cds3.useState)({
        keywords: "",
        status: "",
        group: "voting"
    });
    const [results, setResults] = (0, $6cds3.useState)([]);
    (0, $6cds3.useEffect)(()=>{
        let filtered = filteredProposals(proposals, filter);
        let group = filter.group;
        while(filtered.length < 1 && group !== "all"){
            group = "all";
            filtered = filteredProposals(proposals, {
                ...filter,
                group: group
            });
            if (filtered.length > 0 || group === "all") return setFilter({
                ...filter,
                group: group
            });
        }
        setResults(filtered);
    }, [
        proposals,
        filter
    ]);
    function sortProposals(proposals) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($c9wMV))).sortBy(proposals, ({ proposal_id: proposal_id })=>{
            return 0 - parseInt(proposal_id);
        });
    }
    function filterProposals(event) {
        setFilter({
            ...filter,
            keywords: event.target.value
        });
    }
    function filteredProposals(proposals, filter) {
        let searchResults = proposals;
        const { keywords: keywords, status: status, group: group } = filter;
        if (status) searchResults = searchResults.filter((result)=>{
            return result.status === status;
        });
        searchResults = filterByGroup(searchResults, group);
        if (!keywords || keywords === "") return sortProposals(searchResults);
        const searcher = new (0, $69a568a3ebbe1e4c$export$2e2bcd8739ae039)(searchResults, [
            "content.title"
        ], {
            sort: true
        });
        return searcher.search(keywords);
    }
    function filterByGroup(proposals, group) {
        switch(group){
            case "voting":
                proposals = proposals.filter((proposal)=>proposal.isVoting);
                break;
        }
        return proposals;
    }
    function renderProposal(proposal) {
        const proposalId = proposal.proposal_id;
        const vote = votes[proposalId];
        return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                    className: "d-none d-md-table-cell",
                    children: proposalId
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                        role: "button",
                        onClick: ()=>props.showProposal(proposal),
                        children: proposal.title
                    })
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                    className: "d-none d-sm-table-cell text-center text-nowrap",
                    children: proposal.statusHuman
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                    className: "d-none d-sm-table-cell text-center text-nowrap",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d85ff2c90168cfc4$exports))), {
                        fromNow: true,
                        children: proposal.isDeposit ? proposal.deposit_end_time : proposal.voting_end_time
                    })
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                    className: "text-center",
                    children: proposal.isVoting && (vote ? vote.optionHuman : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $ac4c3421df377bd7$export$2e2bcd8739ae039), {
                        className: "opacity-50"
                    }))
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                    className: "d-none d-md-table-cell text-center",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $ee5b19fa9f9150ab$export$2e2bcd8739ae039), {
                        proposal: proposal,
                        tally: tallies[proposalId]
                    })
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "d-grid gap-2 d-md-flex justify-content-end",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a73f5336dfd04f2d$export$2e2bcd8739ae039), {
                            size: "sm",
                            onClick: ()=>props.showProposal(proposal),
                            children: "View"
                        })
                    })
                })
            ]
        }, proposalId);
    }
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: "d-flex flex-wrap justify-content-center align-items-start mb-3 position-relative",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "d-none d-md-flex me-5",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            className: "input-group",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                    className: "form-control border-right-0 border",
                                    onChange: filterProposals,
                                    value: filter.keywords,
                                    type: "text",
                                    placeholder: "Search.."
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                    className: "input-group-append",
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                                        className: "btn btn-light text-dark border-left-0 border",
                                        type: "button",
                                        onClick: ()=>setFilter({
                                                ...filter,
                                                keywords: ""
                                            }),
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $ac4c3421df377bd7$export$2e2bcd8739ae039), {})
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "w-100 d-flex d-md-none mb-2",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            className: "input-group",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                    className: "form-control border-right-0 border",
                                    onChange: filterProposals,
                                    value: filter.keywords,
                                    type: "text",
                                    placeholder: "Search.."
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                    className: "input-group-append",
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                                        className: "btn btn-light text-dark border-left-0 border",
                                        type: "button",
                                        onClick: ()=>setFilter({
                                                ...filter,
                                                keywords: ""
                                            }),
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $ac4c3421df377bd7$export$2e2bcd8739ae039), {})
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "d-lg-flex d-none position-absolute mx-auto justify-content-center align-self-center",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $85f5d0e6280a2ccf$export$2e2bcd8739ae039), {
                            fill: true,
                            variant: "pills",
                            activeKey: filter.group,
                            className: `${props.modal ? " small" : ""}`,
                            onSelect: (e)=>setFilter({
                                    ...filter,
                                    group: e
                                }),
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $85f5d0e6280a2ccf$export$2e2bcd8739ae039).Item, {
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $85f5d0e6280a2ccf$export$2e2bcd8739ae039).Link, {
                                        eventKey: "voting",
                                        disabled: filteredProposals(proposals, {
                                            ...filter,
                                            group: "voting"
                                        }).length < 1,
                                        children: "Voting Period"
                                    })
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $85f5d0e6280a2ccf$export$2e2bcd8739ae039).Item, {
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $85f5d0e6280a2ccf$export$2e2bcd8739ae039).Link, {
                                        eventKey: "all",
                                        children: "All Proposals"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "d-flex d-lg-none justify-content-center",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("select", {
                            className: "form-select w-auto h-auto",
                            "aria-label": "Proposal group",
                            value: filter.group,
                            onChange: (e)=>setFilter({
                                    ...filter,
                                    group: e.target.value
                                }),
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                                    value: "voting",
                                    disabled: filteredProposals(proposals, {
                                        ...filter,
                                        group: "voting"
                                    }).length < 1,
                                    children: "Voting Period"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                                    value: "all",
                                    children: "All"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "flex-fill d-flex justify-content-end",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("select", {
                            className: "form-select w-auto h-auto",
                            "aria-label": "Proposal status",
                            value: filter.status,
                            onChange: (e)=>setFilter({
                                    ...filter,
                                    status: e.target.value
                                }),
                            children: Object.entries((0, $c353f6c871ff77a0$export$22dfa22445c4c90)).map(([key, value])=>{
                                return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                                    value: key,
                                    children: value
                                }, key);
                            })
                        })
                    })
                ]
            }),
            results.length > 0 && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $36688d56d3c1862c$export$2e2bcd8739ae039), {
                className: "align-middle table-striped",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("th", {
                                    className: "d-none d-md-table-cell",
                                    children: "#"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("th", {
                                    children: "Proposal"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("th", {
                                    className: "d-none d-sm-table-cell text-center",
                                    children: "Status"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("th", {
                                    className: "d-none d-sm-table-cell text-center",
                                    children: "End Time"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("th", {
                                    className: "text-center",
                                    children: "Vote"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("th", {
                                    className: "d-none d-md-table-cell text-center",
                                    children: "Progress"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("th", {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("tbody", {
                        children: results.map((item)=>renderProposal(item))
                    })
                ]
            }),
            results.length < 1 && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                className: "text-center my-5",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("em", {
                    children: "No proposals found"
                })
            })
        ]
    });
}
var $653f5b7d06fe127c$export$2e2bcd8739ae039 = $653f5b7d06fe127c$var$Proposals;




parcelRequire("6cds3");



var $6cds3 = parcelRequire("6cds3");

/**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('react').ReactElement<{}>} ReactElement
 * @typedef {import('unified').PluggableList} PluggableList
 * @typedef {import('hast').Root} Root
 * @typedef {import('./rehype-filter.js').Options} FilterOptions
 * @typedef {import('./ast-to-react.js').Options} TransformOptions
 *
 * @typedef CoreOptions
 * @property {string} children
 *
 * @typedef PluginOptions
 * @property {PluggableList} [remarkPlugins=[]]
 * @property {PluggableList} [rehypePlugins=[]]
 * @property {import('remark-rehype').Options | undefined} [remarkRehypeOptions={}]
 *
 * @typedef LayoutOptions
 * @property {string} [className]
 *
 * @typedef {CoreOptions & PluginOptions & LayoutOptions & FilterOptions & TransformOptions} ReactMarkdownOptions
 *
 * @typedef Deprecation
 * @property {string} id
 * @property {string} [to]
 */ 
var $6cds3 = parcelRequire("6cds3");
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 * @typedef {import('./minurl.shared.js').URL} URL
 * @typedef {import('../index.js').Data} Data
 * @typedef {import('../index.js').Value} Value
 */ /**
 * @typedef {Record<string, unknown> & {type: string, position?: Position | undefined}} NodeLike
 *
 * @typedef {'ascii' | 'utf8' | 'utf-8' | 'utf16le' | 'ucs2' | 'ucs-2' | 'base64' | 'base64url' | 'latin1' | 'binary' | 'hex'} BufferEncoding
 *   Encodings supported by the buffer class.
 *
 *   This is a copy of the types from Node, copied to prevent Node globals from
 *   being needed.
 *   Copied from: <https://github.com/DefinitelyTyped/DefinitelyTyped/blob/90a4ec8/types/node/buffer.d.ts#L170>
 *
 * @typedef {Options | URL | Value | VFile} Compatible
 *   Things that can be passed to the constructor.
 *
 * @typedef VFileCoreOptions
 *   Set multiple values.
 * @property {Value | null | undefined} [value]
 *   Set `value`.
 * @property {string | null | undefined} [cwd]
 *   Set `cwd`.
 * @property {Array<string> | null | undefined} [history]
 *   Set `history`.
 * @property {URL | string | null | undefined} [path]
 *   Set `path`.
 * @property {string | null | undefined} [basename]
 *   Set `basename`.
 * @property {string | null | undefined} [stem]
 *   Set `stem`.
 * @property {string | null | undefined} [extname]
 *   Set `extname`.
 * @property {string | null | undefined} [dirname]
 *   Set `dirname`.
 * @property {Data | null | undefined} [data]
 *   Set `data`.
 *
 * @typedef Map
 *   Raw source map.
 *
 *   See:
 *   <https://github.com/mozilla/source-map/blob/58819f0/source-map.d.ts#L15-L23>.
 * @property {number} version
 *   Which version of the source map spec this map is following.
 * @property {Array<string>} sources
 *   An array of URLs to the original source files.
 * @property {Array<string>} names
 *   An array of identifiers which can be referenced by individual mappings.
 * @property {string | undefined} [sourceRoot]
 *   The URL root from which all sources are relative.
 * @property {Array<string> | undefined} [sourcesContent]
 *   An array of contents of the original source files.
 * @property {string} mappings
 *   A string of base64 VLQs which contain the actual mappings.
 * @property {string} file
 *   The generated file this source map is associated with.
 *
 * @typedef {{[key: string]: unknown} & VFileCoreOptions} Options
 *   Configuration.
 *
 *   A bunch of keys that will be shallow copied over to the new file.
 *
 * @typedef {Record<string, unknown>} ReporterSettings
 *   Configuration for reporters.
 */ /**
 * @template {ReporterSettings} Settings
 *   Options type.
 * @callback Reporter
 *   Type for a reporter.
 * @param {Array<VFile>} files
 *   Files to report.
 * @param {Settings} options
 *   Configuration.
 * @returns {string}
 *   Report.
 */ var $8047608098cfc36b$exports = {};
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ $8047608098cfc36b$exports = function isBuffer(obj) {
    return obj != null && obj.constructor != null && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
};


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 * @typedef {object & {type: string, position?: Position | undefined}} NodeLike
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */ /**
 * Serialize the positional info of a point, position (start and end points),
 * or node.
 *
 * @param {Node | NodeLike | Position | PositionLike | Point | PointLike | null | undefined} [value]
 *   Node, position, or point.
 * @returns {string}
 *   Pretty printed positional info of a node (`string`).
 *
 *   In the format of a range `ls:cs-le:ce` (when given `node` or `position`)
 *   or a point `l:c` (when given `point`), where `l` stands for line, `c` for
 *   column, `s` for `start`, and `e` for end.
 *   An empty string (`''`) is returned if the given value is neither `node`,
 *   `position`, nor `point`.
 */ function $9ac9f153417ad004$export$c304dd45fe166145(value) {
    // Nothing.
    if (!value || typeof value !== "object") return "";
    // Node.
    if ("position" in value || "type" in value) return $9ac9f153417ad004$var$position(value.position);
    // Position.
    if ("start" in value || "end" in value) return $9ac9f153417ad004$var$position(value);
    // Point.
    if ("line" in value || "column" in value) return $9ac9f153417ad004$var$point(value);
    // ?
    return "";
}
/**
 * @param {Point | PointLike | null | undefined} point
 * @returns {string}
 */ function $9ac9f153417ad004$var$point(point) {
    return $9ac9f153417ad004$var$index(point && point.line) + ":" + $9ac9f153417ad004$var$index(point && point.column);
}
/**
 * @param {Position | PositionLike | null | undefined} pos
 * @returns {string}
 */ function $9ac9f153417ad004$var$position(pos) {
    return $9ac9f153417ad004$var$point(pos && pos.start) + "-" + $9ac9f153417ad004$var$point(pos && pos.end);
}
/**
 * @param {number | null | undefined} value
 * @returns {number}
 */ function $9ac9f153417ad004$var$index(value) {
    return value && typeof value === "number" ? value : 1;
}


class $ce209b6eb7da7cf9$export$752e5c445fe834ef extends Error {
    /**
   * Create a message for `reason` at `place` from `origin`.
   *
   * When an error is passed in as `reason`, the `stack` is copied.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   *
   *   > 👉 **Note**: you should use markdown.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */ // To do: next major: expose `undefined` everywhere instead of `null`.
    constructor(reason, place, origin){
        /** @type {[string | null, string | null]} */ const parts = [
            null,
            null
        ];
        /** @type {Position} */ let position = {
            // @ts-expect-error: we always follows the structure of `position`.
            start: {
                line: null,
                column: null
            },
            // @ts-expect-error: "
            end: {
                line: null,
                column: null
            }
        };
        super();
        if (typeof place === "string") {
            origin = place;
            place = undefined;
        }
        if (typeof origin === "string") {
            const index = origin.indexOf(":");
            if (index === -1) parts[1] = origin;
            else {
                parts[0] = origin.slice(0, index);
                parts[1] = origin.slice(index + 1);
            }
        }
        if (place) {
            // Node.
            if ("type" in place || "position" in place) {
                if (place.position) // To do: next major: deep clone.
                // @ts-expect-error: looks like a position.
                position = place.position;
            } else if ("start" in place || "end" in place) // @ts-expect-error: looks like a position.
            // To do: next major: deep clone.
            position = place;
            else if ("line" in place || "column" in place) // To do: next major: deep clone.
            position.start = place;
        }
        // Fields from `Error`.
        /**
     * Serialized positional info of error.
     *
     * On normal errors, this would be something like `ParseError`, buit in
     * `VFile` messages we use this space to show where an error happened.
     */ this.name = (0, $9ac9f153417ad004$export$c304dd45fe166145)(place) || "1:1";
        /**
     * Reason for message.
     *
     * @type {string}
     */ this.message = typeof reason === "object" ? reason.message : reason;
        /**
     * Stack of message.
     *
     * This is used by normal errors to show where something happened in
     * programming code, irrelevant for `VFile` messages,
     *
     * @type {string}
     */ this.stack = "";
        if (typeof reason === "object" && reason.stack) this.stack = reason.stack;
        /**
     * Reason for message.
     *
     * > 👉 **Note**: you should use markdown.
     *
     * @type {string}
     */ this.reason = this.message;
        /* eslint-disable no-unused-expressions */ /**
     * State of problem.
     *
     * * `true` — marks associated file as no longer processable (error)
     * * `false` — necessitates a (potential) change (warning)
     * * `null | undefined` — for things that might not need changing (info)
     *
     * @type {boolean | null | undefined}
     */ this.fatal;
        /**
     * Starting line of error.
     *
     * @type {number | null}
     */ this.line = position.start.line;
        /**
     * Starting column of error.
     *
     * @type {number | null}
     */ this.column = position.start.column;
        /**
     * Full unist position.
     *
     * @type {Position | null}
     */ this.position = position;
        /**
     * Namespace of message (example: `'my-package'`).
     *
     * @type {string | null}
     */ this.source = parts[0];
        /**
     * Category of message (example: `'my-rule'`).
     *
     * @type {string | null}
     */ this.ruleId = parts[1];
        /**
     * Path of a file (used throughout the `VFile` ecosystem).
     *
     * @type {string | null}
     */ this.file;
        // The following fields are “well known”.
        // Not standard.
        // Feel free to add other non-standard fields to your messages.
        /**
     * Specify the source value that’s being reported, which is deemed
     * incorrect.
     *
     * @type {string | null}
     */ this.actual;
        /**
     * Suggest acceptable values that can be used instead of `actual`.
     *
     * @type {Array<string> | null}
     */ this.expected;
        /**
     * Link to docs for the message.
     *
     * > 👉 **Note**: this must be an absolute URL that can be passed as `x`
     * > to `new URL(x)`.
     *
     * @type {string | null}
     */ this.url;
        /**
     * Long form description of the message (you should use markdown).
     *
     * @type {string | null}
     */ this.note;
    /* eslint-enable no-unused-expressions */ }
}
$ce209b6eb7da7cf9$export$752e5c445fe834ef.prototype.file = "";
$ce209b6eb7da7cf9$export$752e5c445fe834ef.prototype.name = "";
$ce209b6eb7da7cf9$export$752e5c445fe834ef.prototype.reason = "";
$ce209b6eb7da7cf9$export$752e5c445fe834ef.prototype.message = "";
$ce209b6eb7da7cf9$export$752e5c445fe834ef.prototype.stack = "";
$ce209b6eb7da7cf9$export$752e5c445fe834ef.prototype.fatal = null;
$ce209b6eb7da7cf9$export$752e5c445fe834ef.prototype.column = null;
$ce209b6eb7da7cf9$export$752e5c445fe834ef.prototype.line = null;
$ce209b6eb7da7cf9$export$752e5c445fe834ef.prototype.source = null;
$ce209b6eb7da7cf9$export$752e5c445fe834ef.prototype.ruleId = null;
$ce209b6eb7da7cf9$export$752e5c445fe834ef.prototype.position = null;


// A derivative work based on:
// <https://github.com/browserify/path-browserify>.
// Which is licensed:
//
// MIT License
//
// Copyright (c) 2013 James Halliday
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
// A derivative work based on:
//
// Parts of that are extracted from Node’s internal `path` module:
// <https://github.com/nodejs/node/blob/master/lib/path.js>.
// Which is licensed:
//
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
const $bd505282e03af022$export$bb654e07daaf8c3a = {
    basename: $bd505282e03af022$var$basename,
    dirname: $bd505282e03af022$var$dirname,
    extname: $bd505282e03af022$var$extname,
    join: $bd505282e03af022$var$join,
    sep: "/"
};
/* eslint-disable max-depth, complexity */ /**
 * Get the basename from a path.
 *
 * @param {string} path
 *   File path.
 * @param {string | undefined} [ext]
 *   Extension to strip.
 * @returns {string}
 *   Stem or basename.
 */ function $bd505282e03af022$var$basename(path, ext) {
    if (ext !== undefined && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
    $bd505282e03af022$var$assertPath(path);
    let start = 0;
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let seenNonSlash;
    if (ext === undefined || ext.length === 0 || ext.length > path.length) {
        while(index--){
            if (path.charCodeAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            {
                if (seenNonSlash) {
                    start = index + 1;
                    break;
                }
            } else if (end < 0) {
                // We saw the first non-path separator, mark this as the end of our
                // path component.
                seenNonSlash = true;
                end = index + 1;
            }
        }
        return end < 0 ? "" : path.slice(start, end);
    }
    if (ext === path) return "";
    let firstNonSlashEnd = -1;
    let extIndex = ext.length - 1;
    while(index--){
        if (path.charCodeAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now.
        {
            if (seenNonSlash) {
                start = index + 1;
                break;
            }
        } else {
            if (firstNonSlashEnd < 0) {
                // We saw the first non-path separator, remember this index in case
                // we need it if the extension ends up not matching.
                seenNonSlash = true;
                firstNonSlashEnd = index + 1;
            }
            if (extIndex > -1) {
                // Try to match the explicit extension.
                if (path.charCodeAt(index) === ext.charCodeAt(extIndex--)) {
                    if (extIndex < 0) // We matched the extension, so mark this as the end of our path
                    // component
                    end = index;
                } else {
                    // Extension does not match, so our result is the entire path
                    // component
                    extIndex = -1;
                    end = firstNonSlashEnd;
                }
            }
        }
    }
    if (start === end) end = firstNonSlashEnd;
    else if (end < 0) end = path.length;
    return path.slice(start, end);
}
/**
 * Get the dirname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ function $bd505282e03af022$var$dirname(path) {
    $bd505282e03af022$var$assertPath(path);
    if (path.length === 0) return ".";
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    // Prefix `--` is important to not run on `0`.
    while(--index){
        if (path.charCodeAt(index) === 47 /* `/` */ ) {
            if (unmatchedSlash) {
                end = index;
                break;
            }
        } else if (!unmatchedSlash) // We saw the first non-path separator
        unmatchedSlash = true;
    }
    return end < 0 ? path.charCodeAt(0) === 47 /* `/` */  ? "/" : "." : end === 1 && path.charCodeAt(0) === 47 /* `/` */  ? "//" : path.slice(0, end);
}
/**
 * Get an extname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   Extname.
 */ function $bd505282e03af022$var$extname(path) {
    $bd505282e03af022$var$assertPath(path);
    let index = path.length;
    let end = -1;
    let startPart = 0;
    let startDot = -1;
    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find.
    let preDotState = 0;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    while(index--){
        const code = path.charCodeAt(index);
        if (code === 47 /* `/` */ ) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            if (unmatchedSlash) {
                startPart = index + 1;
                break;
            }
            continue;
        }
        if (end < 0) {
            // We saw the first non-path separator, mark this as the end of our
            // extension.
            unmatchedSlash = true;
            end = index + 1;
        }
        if (code === 46 /* `.` */ ) {
            // If this is our first dot, mark it as the start of our extension.
            if (startDot < 0) startDot = index;
            else if (preDotState !== 1) preDotState = 1;
        } else if (startDot > -1) // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension.
        preDotState = -1;
    }
    if (startDot < 0 || end < 0 || // We saw a non-dot character immediately before the dot.
    preDotState === 0 || // The (right-most) trimmed path component is exactly `..`.
    preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
    return path.slice(startDot, end);
}
/**
 * Join segments from a path.
 *
 * @param {Array<string>} segments
 *   Path segments.
 * @returns {string}
 *   File path.
 */ function $bd505282e03af022$var$join(...segments) {
    let index = -1;
    /** @type {string | undefined} */ let joined;
    while(++index < segments.length){
        $bd505282e03af022$var$assertPath(segments[index]);
        if (segments[index]) joined = joined === undefined ? segments[index] : joined + "/" + segments[index];
    }
    return joined === undefined ? "." : $bd505282e03af022$var$normalize(joined);
}
/**
 * Normalize a basic file path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ // Note: `normalize` is not exposed as `path.normalize`, so some code is
// manually removed from it.
function $bd505282e03af022$var$normalize(path) {
    $bd505282e03af022$var$assertPath(path);
    const absolute = path.charCodeAt(0) === 47 /* `/` */ ;
    // Normalize the path according to POSIX rules.
    let value = $bd505282e03af022$var$normalizeString(path, !absolute);
    if (value.length === 0 && !absolute) value = ".";
    if (value.length > 0 && path.charCodeAt(path.length - 1) === 47 /* / */ ) value += "/";
    return absolute ? "/" + value : value;
}
/**
 * Resolve `.` and `..` elements in a path with directory names.
 *
 * @param {string} path
 *   File path.
 * @param {boolean} allowAboveRoot
 *   Whether `..` can move above root.
 * @returns {string}
 *   File path.
 */ function $bd505282e03af022$var$normalizeString(path, allowAboveRoot) {
    let result = "";
    let lastSegmentLength = 0;
    let lastSlash = -1;
    let dots = 0;
    let index = -1;
    /** @type {number | undefined} */ let code;
    /** @type {number} */ let lastSlashIndex;
    while(++index <= path.length){
        if (index < path.length) code = path.charCodeAt(index);
        else if (code === 47 /* `/` */ ) break;
        else code = 47 /* `/` */ ;
        if (code === 47 /* `/` */ ) {
            if (lastSlash === index - 1 || dots === 1) ;
            else if (lastSlash !== index - 1 && dots === 2) {
                if (result.length < 2 || lastSegmentLength !== 2 || result.charCodeAt(result.length - 1) !== 46 /* `.` */  || result.charCodeAt(result.length - 2) !== 46 /* `.` */ ) {
                    if (result.length > 2) {
                        lastSlashIndex = result.lastIndexOf("/");
                        if (lastSlashIndex !== result.length - 1) {
                            if (lastSlashIndex < 0) {
                                result = "";
                                lastSegmentLength = 0;
                            } else {
                                result = result.slice(0, lastSlashIndex);
                                lastSegmentLength = result.length - 1 - result.lastIndexOf("/");
                            }
                            lastSlash = index;
                            dots = 0;
                            continue;
                        }
                    } else if (result.length > 0) {
                        result = "";
                        lastSegmentLength = 0;
                        lastSlash = index;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    result = result.length > 0 ? result + "/.." : "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (result.length > 0) result += "/" + path.slice(lastSlash + 1, index);
                else result = path.slice(lastSlash + 1, index);
                lastSegmentLength = index - lastSlash - 1;
            }
            lastSlash = index;
            dots = 0;
        } else if (code === 46 /* `.` */  && dots > -1) dots++;
        else dots = -1;
    }
    return result;
}
/**
 * Make sure `path` is a string.
 *
 * @param {string} path
 *   File path.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $bd505282e03af022$var$assertPath(path) {
    if (typeof path !== "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
} /* eslint-enable max-depth, complexity */ 


// Somewhat based on:
// <https://github.com/defunctzombie/node-process/blob/master/browser.js>.
// But I don’t think one tiny line of code can be copyrighted. 😅
const $050ee5e3e47b101d$export$97a5aaf482767187 = {
    cwd: $050ee5e3e47b101d$var$cwd
};
function $050ee5e3e47b101d$var$cwd() {
    return "/";
}


/// <reference lib="dom" />
/**
 * @typedef URL
 * @property {string} hash
 * @property {string} host
 * @property {string} hostname
 * @property {string} href
 * @property {string} origin
 * @property {string} password
 * @property {string} pathname
 * @property {string} port
 * @property {string} protocol
 * @property {string} search
 * @property {any} searchParams
 * @property {string} username
 * @property {() => string} toString
 * @property {() => string} toJSON
 */ /**
 * Check if `fileUrlOrPath` looks like a URL.
 *
 * @param {unknown} fileUrlOrPath
 *   File path or URL.
 * @returns {fileUrlOrPath is URL}
 *   Whether it’s a URL.
 */ // From: <https://github.com/nodejs/node/blob/fcf8ba4/lib/internal/url.js#L1501>
function $c1a8d28b10b02a3a$export$8304a22d431f958(fileUrlOrPath) {
    return fileUrlOrPath !== null && typeof fileUrlOrPath === "object" && // @ts-expect-error: indexable.
    fileUrlOrPath.href && // @ts-expect-error: indexable.
    fileUrlOrPath.origin;
}


function $0c5367ff62762346$export$9b2b676c902de799(path) {
    if (typeof path === "string") path = new URL(path);
    else if (!(0, $c1a8d28b10b02a3a$export$8304a22d431f958)(path)) {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('The "path" argument must be of type string or an instance of URL. Received `' + path + "`");
        error.code = "ERR_INVALID_ARG_TYPE";
        throw error;
    }
    if (path.protocol !== "file:") {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError("The URL must be of scheme file");
        error.code = "ERR_INVALID_URL_SCHEME";
        throw error;
    }
    return $0c5367ff62762346$var$getPathFromURLPosix(path);
}
/**
 * Get a path from a POSIX URL.
 *
 * @param {URL} url
 *   URL.
 * @returns {string}
 *   File path.
 */ function $0c5367ff62762346$var$getPathFromURLPosix(url) {
    if (url.hostname !== "") {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('File URL host must be "localhost" or empty on darwin');
        error.code = "ERR_INVALID_FILE_URL_HOST";
        throw error;
    }
    const pathname = url.pathname;
    let index = -1;
    while(++index < pathname.length)if (pathname.charCodeAt(index) === 37 /* `%` */  && pathname.charCodeAt(index + 1) === 50 /* `2` */ ) {
        const third = pathname.charCodeAt(index + 2);
        if (third === 70 /* `F` */  || third === 102 /* `f` */ ) {
            /** @type {NodeJS.ErrnoException} */ const error = new TypeError("File URL path must not include encoded / characters");
            error.code = "ERR_INVALID_FILE_URL_PATH";
            throw error;
        }
    }
    return decodeURIComponent(pathname);
}


/**
 * Order of setting (least specific to most), we need this because otherwise
 * `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
 * stem can be set.
 *
 * @type {Array<'basename' | 'dirname' | 'extname' | 'history' | 'path' | 'stem'>}
 */ const $4168e83a03b7d9cb$var$order = [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
];
class $4168e83a03b7d9cb$export$93dff69eb10dc7ce {
    /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   */ get path() {
        return this.history[this.history.length - 1];
    }
    /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {string | URL} path
   */ set path(path) {
        if ((0, $c1a8d28b10b02a3a$export$8304a22d431f958)(path)) path = (0, $0c5367ff62762346$export$9b2b676c902de799)(path);
        $4168e83a03b7d9cb$var$assertNonEmpty(path, "path");
        if (this.path !== path) this.history.push(path);
    }
    /**
   * Get the parent path (example: `'~'`).
   */ get dirname() {
        return typeof this.path === "string" ? (0, $bd505282e03af022$export$bb654e07daaf8c3a).dirname(this.path) : undefined;
    }
    /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   */ set dirname(dirname) {
        $4168e83a03b7d9cb$var$assertPath(this.basename, "dirname");
        this.path = (0, $bd505282e03af022$export$bb654e07daaf8c3a).join(dirname || "", this.basename);
    }
    /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   */ get basename() {
        return typeof this.path === "string" ? (0, $bd505282e03af022$export$bb654e07daaf8c3a).basename(this.path) : undefined;
    }
    /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */ set basename(basename) {
        $4168e83a03b7d9cb$var$assertNonEmpty(basename, "basename");
        $4168e83a03b7d9cb$var$assertPart(basename, "basename");
        this.path = (0, $bd505282e03af022$export$bb654e07daaf8c3a).join(this.dirname || "", basename);
    }
    /**
   * Get the extname (including dot) (example: `'.js'`).
   */ get extname() {
        return typeof this.path === "string" ? (0, $bd505282e03af022$export$bb654e07daaf8c3a).extname(this.path) : undefined;
    }
    /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   */ set extname(extname) {
        $4168e83a03b7d9cb$var$assertPart(extname, "extname");
        $4168e83a03b7d9cb$var$assertPath(this.dirname, "extname");
        if (extname) {
            if (extname.charCodeAt(0) !== 46 /* `.` */ ) throw new Error("`extname` must start with `.`");
            if (extname.includes(".", 1)) throw new Error("`extname` cannot contain multiple dots");
        }
        this.path = (0, $bd505282e03af022$export$bb654e07daaf8c3a).join(this.dirname, this.stem + (extname || ""));
    }
    /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   */ get stem() {
        return typeof this.path === "string" ? (0, $bd505282e03af022$export$bb654e07daaf8c3a).basename(this.path, this.extname) : undefined;
    }
    /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */ set stem(stem) {
        $4168e83a03b7d9cb$var$assertNonEmpty(stem, "stem");
        $4168e83a03b7d9cb$var$assertPart(stem, "stem");
        this.path = (0, $bd505282e03af022$export$bb654e07daaf8c3a).join(this.dirname || "", stem + (this.extname || ""));
    }
    /**
   * Serialize the file.
   *
   * @param {BufferEncoding | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Buffer`
   *   (default: `'utf8'`).
   * @returns {string}
   *   Serialized file.
   */ toString(encoding) {
        return (this.value || "").toString(encoding || undefined);
    }
    /**
   * Create a warning message associated with the file.
   *
   * Its `fatal` is set to `false` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ message(reason, place, origin) {
        const message = new (0, $ce209b6eb7da7cf9$export$752e5c445fe834ef)(reason, place, origin);
        if (this.path) {
            message.name = this.path + ":" + message.name;
            message.file = this.path;
        }
        message.fatal = false;
        this.messages.push(message);
        return message;
    }
    /**
   * Create an info message associated with the file.
   *
   * Its `fatal` is set to `null` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ info(reason, place, origin) {
        const message = this.message(reason, place, origin);
        message.fatal = null;
        return message;
    }
    /**
   * Create a fatal error associated with the file.
   *
   * Its `fatal` is set to `true` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * > 👉 **Note**: a fatal error means that a file is no longer processable.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Message.
   * @throws {VFileMessage}
   *   Message.
   */ fail(reason, place, origin) {
        const message = this.message(reason, place, origin);
        message.fatal = true;
        throw message;
    }
    /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Buffer` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */ constructor(value){
        /** @type {Options | VFile} */ let options;
        if (!value) options = {};
        else if (typeof value === "string" || $4168e83a03b7d9cb$var$buffer(value)) options = {
            value: value
        };
        else if ((0, $c1a8d28b10b02a3a$export$8304a22d431f958)(value)) options = {
            path: value
        };
        else options = value;
        /**
     * Place to store custom information (default: `{}`).
     *
     * It’s OK to store custom data directly on the file but moving it to
     * `data` is recommended.
     *
     * @type {Data}
     */ this.data = {};
        /**
     * List of messages associated with the file.
     *
     * @type {Array<VFileMessage>}
     */ this.messages = [];
        /**
     * List of filepaths the file moved between.
     *
     * The first is the original path and the last is the current path.
     *
     * @type {Array<string>}
     */ this.history = [];
        /**
     * Base of `path` (default: `process.cwd()` or `'/'` in browsers).
     *
     * @type {string}
     */ this.cwd = (0, $050ee5e3e47b101d$export$97a5aaf482767187).cwd();
        /* eslint-disable no-unused-expressions */ /**
     * Raw value.
     *
     * @type {Value}
     */ this.value;
        // The below are non-standard, they are “well-known”.
        // As in, used in several tools.
        /**
     * Whether a file was saved to disk.
     *
     * This is used by vfile reporters.
     *
     * @type {boolean}
     */ this.stored;
        /**
     * Custom, non-string, compiled, representation.
     *
     * This is used by unified to store non-string results.
     * One example is when turning markdown into React nodes.
     *
     * @type {unknown}
     */ this.result;
        /**
     * Source map.
     *
     * This type is equivalent to the `RawSourceMap` type from the `source-map`
     * module.
     *
     * @type {Map | null | undefined}
     */ this.map;
        /* eslint-enable no-unused-expressions */ // Set path related properties in the correct order.
        let index = -1;
        while(++index < $4168e83a03b7d9cb$var$order.length){
            const prop = $4168e83a03b7d9cb$var$order[index];
            // Note: we specifically use `in` instead of `hasOwnProperty` to accept
            // `vfile`s too.
            if (prop in options && options[prop] !== undefined && options[prop] !== null) // @ts-expect-error: TS doesn’t understand basic reality.
            this[prop] = prop === "history" ? [
                ...options[prop]
            ] : options[prop];
        }
        /** @type {string} */ let prop;
        // Set non-path related properties.
        for(prop in options)// @ts-expect-error: fine to set other things.
        if (!$4168e83a03b7d9cb$var$order.includes(prop)) // @ts-expect-error: fine to set other things.
        this[prop] = options[prop];
    }
}
/**
 * Assert that `part` is not a path (as in, does not contain `path.sep`).
 *
 * @param {string | null | undefined} part
 *   File path part.
 * @param {string} name
 *   Part name.
 * @returns {void}
 *   Nothing.
 */ function $4168e83a03b7d9cb$var$assertPart(part, name) {
    if (part && part.includes((0, $bd505282e03af022$export$bb654e07daaf8c3a).sep)) throw new Error("`" + name + "` cannot be a path: did not expect `" + (0, $bd505282e03af022$export$bb654e07daaf8c3a).sep + "`");
}
/**
 * Assert that `part` is not empty.
 *
 * @param {string | undefined} part
 *   Thing.
 * @param {string} name
 *   Part name.
 * @returns {asserts part is string}
 *   Nothing.
 */ function $4168e83a03b7d9cb$var$assertNonEmpty(part, name) {
    if (!part) throw new Error("`" + name + "` cannot be empty");
}
/**
 * Assert `path` exists.
 *
 * @param {string | undefined} path
 *   Path.
 * @param {string} name
 *   Dependency name.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $4168e83a03b7d9cb$var$assertPath(path, name) {
    if (!path) throw new Error("Setting `" + name + "` requires `path` to be set too");
}
/**
 * Assert `value` is a buffer.
 *
 * @param {unknown} value
 *   thing.
 * @returns {value is Buffer}
 *   Whether `value` is a Node.js buffer.
 */ function $4168e83a03b7d9cb$var$buffer(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8047608098cfc36b$exports)))(value);
}


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('vfile').VFileCompatible} VFileCompatible
 * @typedef {import('vfile').VFileValue} VFileValue
 * @typedef {import('..').Processor} Processor
 * @typedef {import('..').Plugin} Plugin
 * @typedef {import('..').Preset} Preset
 * @typedef {import('..').Pluggable} Pluggable
 * @typedef {import('..').PluggableList} PluggableList
 * @typedef {import('..').Transformer} Transformer
 * @typedef {import('..').Parser} Parser
 * @typedef {import('..').Compiler} Compiler
 * @typedef {import('..').RunCallback} RunCallback
 * @typedef {import('..').ProcessCallback} ProcessCallback
 *
 * @typedef Context
 * @property {Node} tree
 * @property {VFile} file
 */ /**
 * Throw a given error.
 *
 * @param {Error|null|undefined} [error]
 *   Maybe error.
 * @returns {asserts error is null|undefined}
 */ function $7c61147c2f3db9c9$export$dd911e13ecb11e05(error) {
    if (error) throw error;
}



var $2b835e93137de681$exports = {};
"use strict";
var $2b835e93137de681$var$hasOwn = Object.prototype.hasOwnProperty;
var $2b835e93137de681$var$toStr = Object.prototype.toString;
var $2b835e93137de681$var$defineProperty = Object.defineProperty;
var $2b835e93137de681$var$gOPD = Object.getOwnPropertyDescriptor;
var $2b835e93137de681$var$isArray = function isArray(arr) {
    if (typeof Array.isArray === "function") return Array.isArray(arr);
    return $2b835e93137de681$var$toStr.call(arr) === "[object Array]";
};
var $2b835e93137de681$var$isPlainObject = function isPlainObject(obj) {
    if (!obj || $2b835e93137de681$var$toStr.call(obj) !== "[object Object]") return false;
    var hasOwnConstructor = $2b835e93137de681$var$hasOwn.call(obj, "constructor");
    var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && $2b835e93137de681$var$hasOwn.call(obj.constructor.prototype, "isPrototypeOf");
    // Not own constructor property must be Object
    if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) return false;
    // Own properties are enumerated firstly, so to speed up,
    // if last one is own, then all properties are own.
    var key;
    for(key in obj);
    return typeof key === "undefined" || $2b835e93137de681$var$hasOwn.call(obj, key);
};
// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var $2b835e93137de681$var$setProperty = function setProperty(target, options) {
    if ($2b835e93137de681$var$defineProperty && options.name === "__proto__") $2b835e93137de681$var$defineProperty(target, options.name, {
        enumerable: true,
        configurable: true,
        value: options.newValue,
        writable: true
    });
    else target[options.name] = options.newValue;
};
// Return undefined instead of __proto__ if '__proto__' is not an own property
var $2b835e93137de681$var$getProperty = function getProperty(obj, name) {
    if (name === "__proto__") {
        if (!$2b835e93137de681$var$hasOwn.call(obj, name)) return void 0;
        else if ($2b835e93137de681$var$gOPD) // In early versions of node, obj['__proto__'] is buggy when obj has
        // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
        return $2b835e93137de681$var$gOPD(obj, name).value;
    }
    return obj[name];
};
$2b835e93137de681$exports = function extend() {
    var options, name, src, copy, copyIsArray, clone;
    var target = arguments[0];
    var i = 1;
    var length = arguments.length;
    var deep = false;
    // Handle a deep copy situation
    if (typeof target === "boolean") {
        deep = target;
        target = arguments[1] || {};
        // skip the boolean and the target
        i = 2;
    }
    if (target == null || typeof target !== "object" && typeof target !== "function") target = {};
    for(; i < length; ++i){
        options = arguments[i];
        // Only deal with non-null/undefined values
        if (options != null) // Extend the base object
        for(name in options){
            src = $2b835e93137de681$var$getProperty(target, name);
            copy = $2b835e93137de681$var$getProperty(options, name);
            // Prevent never-ending loop
            if (target !== copy) {
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && ($2b835e93137de681$var$isPlainObject(copy) || (copyIsArray = $2b835e93137de681$var$isArray(copy)))) {
                    if (copyIsArray) {
                        copyIsArray = false;
                        clone = src && $2b835e93137de681$var$isArray(src) ? src : [];
                    } else clone = src && $2b835e93137de681$var$isPlainObject(src) ? src : {};
                    // Never move original objects, clone them
                    $2b835e93137de681$var$setProperty(target, {
                        name: name,
                        newValue: extend(deep, clone, copy)
                    });
                // Don't bring in undefined values
                } else if (typeof copy !== "undefined") $2b835e93137de681$var$setProperty(target, {
                    name: name,
                    newValue: copy
                });
            }
        }
    }
    // Return the modified object
    return target;
};


function $e9b6de03ec23fa82$export$2e2bcd8739ae039(value) {
    if (typeof value !== "object" || value === null) return false;
    const prototype = Object.getPrototypeOf(value);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
}


// To do: remove `void`s
// To do: remove `null` from output of our APIs, allow it as user APIs.
/**
 * @typedef {(error?: Error | null | undefined, ...output: Array<any>) => void} Callback
 *   Callback.
 *
 * @typedef {(...input: Array<any>) => any} Middleware
 *   Ware.
 *
 * @typedef Pipeline
 *   Pipeline.
 * @property {Run} run
 *   Run the pipeline.
 * @property {Use} use
 *   Add middleware.
 *
 * @typedef {(...input: Array<any>) => void} Run
 *   Call all middleware.
 *
 *   Calls `done` on completion with either an error or the output of the
 *   last middleware.
 *
 *   > 👉 **Note**: as the length of input defines whether async functions get a
 *   > `next` function,
 *   > it’s recommended to keep `input` at one value normally.

 *
 * @typedef {(fn: Middleware) => Pipeline} Use
 *   Add middleware.
 */ /**
 * Create new middleware.
 *
 * @returns {Pipeline}
 *   Pipeline.
 */ function $025f7c29713202a1$export$91b56f5ca106aa43() {
    /** @type {Array<Middleware>} */ const fns = [];
    /** @type {Pipeline} */ const pipeline = {
        run: run,
        use: use
    };
    return pipeline;
    /** @type {Run} */ function run(...values) {
        let middlewareIndex = -1;
        /** @type {Callback} */ const callback = values.pop();
        if (typeof callback !== "function") throw new TypeError("Expected function as last argument, not " + callback);
        next(null, ...values);
        /**
     * Run the next `fn`, or we’re done.
     *
     * @param {Error | null | undefined} error
     * @param {Array<any>} output
     */ function next(error, ...output) {
            const fn = fns[++middlewareIndex];
            let index = -1;
            if (error) {
                callback(error);
                return;
            }
            // Copy non-nullish input into values.
            while(++index < values.length)if (output[index] === null || output[index] === undefined) output[index] = values[index];
            // Save the newly created `output` for the next call.
            values = output;
            // Next or done.
            if (fn) $025f7c29713202a1$export$4997ffc0176396a6(fn, next)(...output);
            else callback(null, ...output);
        }
    }
    /** @type {Use} */ function use(middelware) {
        if (typeof middelware !== "function") throw new TypeError("Expected `middelware` to be a function, not " + middelware);
        fns.push(middelware);
        return pipeline;
    }
}
function $025f7c29713202a1$export$4997ffc0176396a6(middleware, callback) {
    /** @type {boolean} */ let called;
    return wrapped;
    /**
   * Call `middleware`.
   * @this {any}
   * @param {Array<any>} parameters
   * @returns {void}
   */ function wrapped(...parameters) {
        const fnExpectsCallback = middleware.length > parameters.length;
        /** @type {any} */ let result;
        if (fnExpectsCallback) parameters.push(done);
        try {
            result = middleware.apply(this, parameters);
        } catch (error) {
            const exception = /** @type {Error} */ error;
            // Well, this is quite the pickle.
            // `middleware` received a callback and called it synchronously, but that
            // threw an error.
            // The only thing left to do is to throw the thing instead.
            if (fnExpectsCallback && called) throw exception;
            return done(exception);
        }
        if (!fnExpectsCallback) {
            if (result && result.then && typeof result.then === "function") result.then(then, done);
            else if (result instanceof Error) done(result);
            else then(result);
        }
    }
    /**
   * Call `callback`, only once.
   *
   * @type {Callback}
   */ function done(error, ...output) {
        if (!called) {
            called = true;
            callback(error, ...output);
        }
    }
    /**
   * Call `done` with one value.
   *
   * @param {any} [value]
   */ function then(value) {
        done(null, value);
    }
}




const $2b28392ffeb05167$export$7cc1b2fe10c52bb = $2b28392ffeb05167$var$base().freeze();
const $2b28392ffeb05167$var$own = {}.hasOwnProperty;
// Function to create the first processor.
/**
 * @returns {Processor}
 */ function $2b28392ffeb05167$var$base() {
    const transformers = (0, $025f7c29713202a1$export$91b56f5ca106aa43)();
    /** @type {Processor['attachers']} */ const attachers = [];
    /** @type {Record<string, unknown>} */ let namespace = {};
    /** @type {boolean|undefined} */ let frozen;
    let freezeIndex = -1;
    // Data management.
    // @ts-expect-error: overloads are handled.
    processor.data = data;
    processor.Parser = undefined;
    processor.Compiler = undefined;
    // Lock.
    processor.freeze = freeze;
    // Plugins.
    processor.attachers = attachers;
    // @ts-expect-error: overloads are handled.
    processor.use = use;
    // API.
    processor.parse = parse;
    processor.stringify = stringify;
    // @ts-expect-error: overloads are handled.
    processor.run = run;
    processor.runSync = runSync;
    // @ts-expect-error: overloads are handled.
    processor.process = process;
    processor.processSync = processSync;
    // Expose.
    return processor;
    // Create a new processor based on the processor in the current scope.
    /** @type {Processor} */ function processor() {
        const destination = $2b28392ffeb05167$var$base();
        let index = -1;
        while(++index < attachers.length)destination.use(...attachers[index]);
        destination.data((0, (/*@__PURE__*/$parcel$interopDefault($2b835e93137de681$exports)))(true, {}, namespace));
        return destination;
    }
    /**
   * @param {string|Record<string, unknown>} [key]
   * @param {unknown} [value]
   * @returns {unknown}
   */ function data(key, value) {
        if (typeof key === "string") {
            // Set `key`.
            if (arguments.length === 2) {
                $2b28392ffeb05167$var$assertUnfrozen("data", frozen);
                namespace[key] = value;
                return processor;
            }
            // Get `key`.
            return $2b28392ffeb05167$var$own.call(namespace, key) && namespace[key] || null;
        }
        // Set space.
        if (key) {
            $2b28392ffeb05167$var$assertUnfrozen("data", frozen);
            namespace = key;
            return processor;
        }
        // Get space.
        return namespace;
    }
    /** @type {Processor['freeze']} */ function freeze() {
        if (frozen) return processor;
        while(++freezeIndex < attachers.length){
            const [attacher, ...options] = attachers[freezeIndex];
            if (options[0] === false) continue;
            if (options[0] === true) options[0] = undefined;
            /** @type {Transformer|void} */ const transformer = attacher.call(processor, ...options);
            if (typeof transformer === "function") transformers.use(transformer);
        }
        frozen = true;
        freezeIndex = Number.POSITIVE_INFINITY;
        return processor;
    }
    /**
   * @param {Pluggable|null|undefined} [value]
   * @param {...unknown} options
   * @returns {Processor}
   */ function use(value, ...options) {
        /** @type {Record<string, unknown>|undefined} */ let settings;
        $2b28392ffeb05167$var$assertUnfrozen("use", frozen);
        if (value === null || value === undefined) ;
        else if (typeof value === "function") addPlugin(value, ...options);
        else if (typeof value === "object") {
            if (Array.isArray(value)) addList(value);
            else addPreset(value);
        } else throw new TypeError("Expected usable value, not `" + value + "`");
        if (settings) namespace.settings = Object.assign(namespace.settings || {}, settings);
        return processor;
        /**
     * @param {import('..').Pluggable<unknown[]>} value
     * @returns {void}
     */ function add(value) {
            if (typeof value === "function") addPlugin(value);
            else if (typeof value === "object") {
                if (Array.isArray(value)) {
                    const [plugin, ...options] = value;
                    addPlugin(plugin, ...options);
                } else addPreset(value);
            } else throw new TypeError("Expected usable value, not `" + value + "`");
        }
        /**
     * @param {Preset} result
     * @returns {void}
     */ function addPreset(result) {
            addList(result.plugins);
            if (result.settings) settings = Object.assign(settings || {}, result.settings);
        }
        /**
     * @param {PluggableList|null|undefined} [plugins]
     * @returns {void}
     */ function addList(plugins) {
            let index = -1;
            if (plugins === null || plugins === undefined) ;
            else if (Array.isArray(plugins)) while(++index < plugins.length){
                const thing = plugins[index];
                add(thing);
            }
            else throw new TypeError("Expected a list of plugins, not `" + plugins + "`");
        }
        /**
     * @param {Plugin} plugin
     * @param {...unknown} [value]
     * @returns {void}
     */ function addPlugin(plugin, value) {
            let index = -1;
            /** @type {Processor['attachers'][number]|undefined} */ let entry;
            while(++index < attachers.length)if (attachers[index][0] === plugin) {
                entry = attachers[index];
                break;
            }
            if (entry) {
                if ((0, $e9b6de03ec23fa82$export$2e2bcd8739ae039)(entry[1]) && (0, $e9b6de03ec23fa82$export$2e2bcd8739ae039)(value)) value = (0, (/*@__PURE__*/$parcel$interopDefault($2b835e93137de681$exports)))(true, entry[1], value);
                entry[1] = value;
            } else // @ts-expect-error: fine.
            attachers.push([
                ...arguments
            ]);
        }
    }
    /** @type {Processor['parse']} */ function parse(doc) {
        processor.freeze();
        const file = $2b28392ffeb05167$var$vfile(doc);
        const Parser = processor.Parser;
        $2b28392ffeb05167$var$assertParser("parse", Parser);
        if ($2b28392ffeb05167$var$newable(Parser, "parse")) // @ts-expect-error: `newable` checks this.
        return new Parser(String(file), file).parse();
        // @ts-expect-error: `newable` checks this.
        return Parser(String(file), file) // eslint-disable-line new-cap
        ;
    }
    /** @type {Processor['stringify']} */ function stringify(node, doc) {
        processor.freeze();
        const file = $2b28392ffeb05167$var$vfile(doc);
        const Compiler = processor.Compiler;
        $2b28392ffeb05167$var$assertCompiler("stringify", Compiler);
        $2b28392ffeb05167$var$assertNode(node);
        if ($2b28392ffeb05167$var$newable(Compiler, "compile")) // @ts-expect-error: `newable` checks this.
        return new Compiler(node, file).compile();
        // @ts-expect-error: `newable` checks this.
        return Compiler(node, file) // eslint-disable-line new-cap
        ;
    }
    /**
   * @param {Node} node
   * @param {VFileCompatible|RunCallback} [doc]
   * @param {RunCallback} [callback]
   * @returns {Promise<Node>|void}
   */ function run(node, doc, callback) {
        $2b28392ffeb05167$var$assertNode(node);
        processor.freeze();
        if (!callback && typeof doc === "function") {
            callback = doc;
            doc = undefined;
        }
        if (!callback) return new Promise(executor);
        executor(null, callback);
        /**
     * @param {null|((node: Node) => void)} resolve
     * @param {(error: Error) => void} reject
     * @returns {void}
     */ function executor(resolve, reject) {
            // @ts-expect-error: `doc` can’t be a callback anymore, we checked.
            transformers.run(node, $2b28392ffeb05167$var$vfile(doc), done);
            /**
       * @param {Error|null} error
       * @param {Node} tree
       * @param {VFile} file
       * @returns {void}
       */ function done(error, tree, file) {
                tree = tree || node;
                if (error) reject(error);
                else if (resolve) resolve(tree);
                else // @ts-expect-error: `callback` is defined if `resolve` is not.
                callback(null, tree, file);
            }
        }
    }
    /** @type {Processor['runSync']} */ function runSync(node, file) {
        /** @type {Node|undefined} */ let result;
        /** @type {boolean|undefined} */ let complete;
        processor.run(node, file, done);
        $2b28392ffeb05167$var$assertDone("runSync", "run", complete);
        // @ts-expect-error: we either bailed on an error or have a tree.
        return result;
        /**
     * @param {Error|null} [error]
     * @param {Node} [tree]
     * @returns {void}
     */ function done(error, tree) {
            (0, $7c61147c2f3db9c9$export$dd911e13ecb11e05)(error);
            result = tree;
            complete = true;
        }
    }
    /**
   * @param {VFileCompatible} doc
   * @param {ProcessCallback} [callback]
   * @returns {Promise<VFile>|undefined}
   */ function process(doc, callback) {
        processor.freeze();
        $2b28392ffeb05167$var$assertParser("process", processor.Parser);
        $2b28392ffeb05167$var$assertCompiler("process", processor.Compiler);
        if (!callback) return new Promise(executor);
        executor(null, callback);
        /**
     * @param {null|((file: VFile) => void)} resolve
     * @param {(error?: Error|null|undefined) => void} reject
     * @returns {void}
     */ function executor(resolve, reject) {
            const file = $2b28392ffeb05167$var$vfile(doc);
            processor.run(processor.parse(file), file, (error, tree, file)=>{
                if (error || !tree || !file) done(error);
                else {
                    /** @type {unknown} */ const result = processor.stringify(tree, file);
                    if (result === undefined || result === null) ;
                    else if ($2b28392ffeb05167$var$looksLikeAVFileValue(result)) file.value = result;
                    else file.result = result;
                    done(error, file);
                }
            });
            /**
       * @param {Error|null|undefined} [error]
       * @param {VFile|undefined} [file]
       * @returns {void}
       */ function done(error, file) {
                if (error || !file) reject(error);
                else if (resolve) resolve(file);
                else // @ts-expect-error: `callback` is defined if `resolve` is not.
                callback(null, file);
            }
        }
    }
    /** @type {Processor['processSync']} */ function processSync(doc) {
        /** @type {boolean|undefined} */ let complete;
        processor.freeze();
        $2b28392ffeb05167$var$assertParser("processSync", processor.Parser);
        $2b28392ffeb05167$var$assertCompiler("processSync", processor.Compiler);
        const file = $2b28392ffeb05167$var$vfile(doc);
        processor.process(file, done);
        $2b28392ffeb05167$var$assertDone("processSync", "process", complete);
        return file;
        /**
     * @param {Error|null|undefined} [error]
     * @returns {void}
     */ function done(error) {
            complete = true;
            (0, $7c61147c2f3db9c9$export$dd911e13ecb11e05)(error);
        }
    }
}
/**
 * Check if `value` is a constructor.
 *
 * @param {unknown} value
 * @param {string} name
 * @returns {boolean}
 */ function $2b28392ffeb05167$var$newable(value, name) {
    return typeof value === "function" && // Prototypes do exist.
    // type-coverage:ignore-next-line
    value.prototype && // A function with keys in its prototype is probably a constructor.
    // Classes’ prototype methods are not enumerable, so we check if some value
    // exists in the prototype.
    // type-coverage:ignore-next-line
    ($2b28392ffeb05167$var$keys(value.prototype) || name in value.prototype);
}
/**
 * Check if `value` is an object with keys.
 *
 * @param {Record<string, unknown>} value
 * @returns {boolean}
 */ function $2b28392ffeb05167$var$keys(value) {
    /** @type {string} */ let key;
    for(key in value){
        if ($2b28392ffeb05167$var$own.call(value, key)) return true;
    }
    return false;
}
/**
 * Assert a parser is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Parser}
 */ function $2b28392ffeb05167$var$assertParser(name, value) {
    if (typeof value !== "function") throw new TypeError("Cannot `" + name + "` without `Parser`");
}
/**
 * Assert a compiler is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Compiler}
 */ function $2b28392ffeb05167$var$assertCompiler(name, value) {
    if (typeof value !== "function") throw new TypeError("Cannot `" + name + "` without `Compiler`");
}
/**
 * Assert the processor is not frozen.
 *
 * @param {string} name
 * @param {unknown} frozen
 * @returns {asserts frozen is false}
 */ function $2b28392ffeb05167$var$assertUnfrozen(name, frozen) {
    if (frozen) throw new Error("Cannot call `" + name + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`.");
}
/**
 * Assert `node` is a unist node.
 *
 * @param {unknown} node
 * @returns {asserts node is Node}
 */ function $2b28392ffeb05167$var$assertNode(node) {
    // `isPlainObj` unfortunately uses `any` instead of `unknown`.
    // type-coverage:ignore-next-line
    if (!(0, $e9b6de03ec23fa82$export$2e2bcd8739ae039)(node) || typeof node.type !== "string") throw new TypeError("Expected node, got `" + node + "`");
}
/**
 * Assert that `complete` is `true`.
 *
 * @param {string} name
 * @param {string} asyncName
 * @param {unknown} complete
 * @returns {asserts complete is true}
 */ function $2b28392ffeb05167$var$assertDone(name, asyncName, complete) {
    if (!complete) throw new Error("`" + name + "` finished async. Use `" + asyncName + "` instead");
}
/**
 * @param {VFileCompatible} [value]
 * @returns {VFile}
 */ function $2b28392ffeb05167$var$vfile(value) {
    return $2b28392ffeb05167$var$looksLikeAVFile(value) ? value : new (0, $4168e83a03b7d9cb$export$93dff69eb10dc7ce)(value);
}
/**
 * @param {VFileCompatible} [value]
 * @returns {value is VFile}
 */ function $2b28392ffeb05167$var$looksLikeAVFile(value) {
    return Boolean(value && typeof value === "object" && "message" in value && "messages" in value);
}
/**
 * @param {unknown} [value]
 * @returns {value is VFileValue}
 */ function $2b28392ffeb05167$var$looksLikeAVFileValue(value) {
    return typeof value === "string" || (0, (/*@__PURE__*/$parcel$interopDefault($8047608098cfc36b$exports)))(value);
}


/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-from-markdown').Options} Options
 */ /**
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Value} Value
 *
 * @typedef {import('unist').Parent} UnistParent
 * @typedef {import('unist').Point} Point
 *
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 * @typedef {import('mdast').StaticPhrasingContent} StaticPhrasingContent
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Break} Break
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('mdast').Code} Code
 * @typedef {import('mdast').Definition} Definition
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('mdast').HTML} HTML
 * @typedef {import('mdast').Image} Image
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('mdast').List} List
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('mdast').Text} Text
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('mdast').ReferenceType} ReferenceType
 * @typedef {import('../index.js').CompileData} CompileData
 */ /**
 * @typedef {Root | Content} Node
 * @typedef {Extract<Node, UnistParent>} Parent
 *
 * @typedef {Omit<UnistParent, 'type' | 'children'> & {type: 'fragment', children: Array<PhrasingContent>}} Fragment
 */ /**
 * @callback Transform
 *   Extra transform, to change the AST afterwards.
 * @param {Root} tree
 *   Tree to transform.
 * @returns {Root | undefined | null | void}
 *   New tree or nothing (in which case the current tree is used).
 *
 * @callback Handle
 *   Handle a token.
 * @param {CompileContext} this
 *   Context.
 * @param {Token} token
 *   Current token.
 * @returns {void}
 *   Nothing.
 *
 * @typedef {Record<string, Handle>} Handles
 *   Token types mapping to handles
 *
 * @callback OnEnterError
 *   Handle the case where the `right` token is open, but it is closed (by the
 *   `left` token) or because we reached the end of the document.
 * @param {Omit<CompileContext, 'sliceSerialize'>} this
 *   Context.
 * @param {Token | undefined} left
 *   Left token.
 * @param {Token} right
 *   Right token.
 * @returns {void}
 *   Nothing.
 *
 * @callback OnExitError
 *   Handle the case where the `right` token is open but it is closed by
 *   exiting the `left` token.
 * @param {Omit<CompileContext, 'sliceSerialize'>} this
 *   Context.
 * @param {Token} left
 *   Left token.
 * @param {Token} right
 *   Right token.
 * @returns {void}
 *   Nothing.
 *
 * @typedef {[Token, OnEnterError | undefined]} TokenTuple
 *   Open token on the stack, with an optional error handler for when
 *   that token isn’t closed properly.
 */ /**
 * @typedef Config
 *   Configuration.
 *
 *   We have our defaults, but extensions will add more.
 * @property {Array<string>} canContainEols
 *   Token types where line endings are used.
 * @property {Handles} enter
 *   Opening handles.
 * @property {Handles} exit
 *   Closing handles.
 * @property {Array<Transform>} transforms
 *   Tree transforms.
 *
 * @typedef {Partial<Config>} Extension
 *   Change how markdown tokens from micromark are turned into mdast.
 *
 * @typedef CompileContext
 *   mdast compiler context.
 * @property {Array<Node | Fragment>} stack
 *   Stack of nodes.
 * @property {Array<TokenTuple>} tokenStack
 *   Stack of tokens.
 * @property {<Key extends keyof CompileData>(key: Key) => CompileData[Key]} getData
 *   Get data from the key/value store.
 * @property {<Key extends keyof CompileData>(key: Key, value?: CompileData[Key]) => void} setData
 *   Set data into the key/value store.
 * @property {(this: CompileContext) => void} buffer
 *   Capture some of the output data.
 * @property {(this: CompileContext) => string} resume
 *   Stop capturing and access the output data.
 * @property {<Kind extends Node>(this: CompileContext, node: Kind, token: Token, onError?: OnEnterError) => Kind} enter
 *   Enter a token.
 * @property {(this: CompileContext, token: Token, onError?: OnExitError) => Node} exit
 *   Exit a token.
 * @property {TokenizeContext['sliceSerialize']} sliceSerialize
 *   Get the string value of a token.
 * @property {Config} config
 *   Configuration.
 *
 * @typedef FromMarkdownOptions
 *   Configuration for how to build mdast.
 * @property {Array<Extension | Array<Extension>> | null | undefined} [mdastExtensions]
 *   Extensions for this utility to change how tokens are turned into a tree.
 *
 * @typedef {ParseOptions & FromMarkdownOptions} Options
 *   Configuration.
 */ // To do: micromark: create a registry of tokens?
// To do: next major: don’t return given `Node` from `enter`.
// To do: next major: remove setter/getter.
/**
 * @typedef {import('mdast').Root|import('mdast').Content} Node
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [includeImageAlt=true]
 *   Whether to use `alt` for `image`s.
 * @property {boolean | null | undefined} [includeHtml=true]
 *   Whether to use `value` of HTML.
 */ /** @type {Options} */ const $650eacefe04ddf2f$var$emptyOptions = {};
function $650eacefe04ddf2f$export$f84e8e69fd4488a5(value, options) {
    const settings = options || $650eacefe04ddf2f$var$emptyOptions;
    const includeImageAlt = typeof settings.includeImageAlt === "boolean" ? settings.includeImageAlt : true;
    const includeHtml = typeof settings.includeHtml === "boolean" ? settings.includeHtml : true;
    return $650eacefe04ddf2f$var$one(value, includeImageAlt, includeHtml);
}
/**
 * One node or several nodes.
 *
 * @param {unknown} value
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized node.
 */ function $650eacefe04ddf2f$var$one(value, includeImageAlt, includeHtml) {
    if ($650eacefe04ddf2f$var$node(value)) {
        if ("value" in value) return value.type === "html" && !includeHtml ? "" : value.value;
        if (includeImageAlt && "alt" in value && value.alt) return value.alt;
        if ("children" in value) return $650eacefe04ddf2f$var$all(value.children, includeImageAlt, includeHtml);
    }
    if (Array.isArray(value)) return $650eacefe04ddf2f$var$all(value, includeImageAlt, includeHtml);
    return "";
}
/**
 * Serialize a list of nodes.
 *
 * @param {Array<unknown>} values
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized nodes.
 */ function $650eacefe04ddf2f$var$all(values, includeImageAlt, includeHtml) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    while(++index < values.length)result[index] = $650eacefe04ddf2f$var$one(values[index], includeImageAlt, includeHtml);
    return result.join("");
}
/**
 * Check if `value` looks like a node.
 *
 * @param {unknown} value
 *   Thing.
 * @returns {value is Node}
 *   Whether `value` is a node.
 */ function $650eacefe04ddf2f$var$node(value) {
    return Boolean(value && typeof value === "object");
}


/**
 * @typedef {import('micromark-util-types').Create} Create
 * @typedef {import('micromark-util-types').FullNormalizedExtension} FullNormalizedExtension
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 */ /**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Handles} Handles
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').NormalizedExtension} NormalizedExtension
 */ /**
 * Like `Array#splice`, but smarter for giant arrays.
 *
 * `Array#splice` takes all items to be inserted as individual argument which
 * causes a stack overflow in V8 when trying to insert 100k items for instance.
 *
 * Otherwise, this does not return the removed items, and takes `items` as an
 * array instead of rest parameters.
 *
 * @template {unknown} T
 *   Item type.
 * @param {Array<T>} list
 *   List to operate on.
 * @param {number} start
 *   Index to remove/insert at (can be negative).
 * @param {number} remove
 *   Number of items to remove.
 * @param {Array<T>} items
 *   Items to inject into `list`.
 * @returns {void}
 *   Nothing.
 */ function $f35ae38d0ff93729$export$869882364835d202(list, start, remove, items) {
    const end = list.length;
    let chunkStart = 0;
    /** @type {Array<unknown>} */ let parameters;
    // Make start between zero and `end` (included).
    if (start < 0) start = -start > end ? 0 : end + start;
    else start = start > end ? end : start;
    remove = remove > 0 ? remove : 0;
    // No need to chunk the items if there’s only a couple (10k) items.
    if (items.length < 10000) {
        parameters = Array.from(items);
        parameters.unshift(start, remove);
        // @ts-expect-error Hush, it’s fine.
        list.splice(...parameters);
    } else {
        // Delete `remove` items starting from `start`
        if (remove) list.splice(start, remove);
        // Insert the items in chunks to not cause stack overflows.
        while(chunkStart < items.length){
            parameters = items.slice(chunkStart, chunkStart + 10000);
            parameters.unshift(start, 0);
            // @ts-expect-error Hush, it’s fine.
            list.splice(...parameters);
            chunkStart += 10000;
            start += 10000;
        }
    }
}
function $f35ae38d0ff93729$export$4cbf152802aa238(list, items) {
    if (list.length > 0) {
        $f35ae38d0ff93729$export$869882364835d202(list, list.length, 0, items);
        return list;
    }
    return items;
}


const $36dbe5ae75482411$var$hasOwnProperty = {}.hasOwnProperty;
function $36dbe5ae75482411$export$86a865d89ef3c690(extensions) {
    /** @type {NormalizedExtension} */ const all = {};
    let index = -1;
    while(++index < extensions.length)$36dbe5ae75482411$var$syntaxExtension(all, extensions[index]);
    return all;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {NormalizedExtension} all
 *   Extension to merge into.
 * @param {Extension} extension
 *   Extension to merge.
 * @returns {void}
 */ function $36dbe5ae75482411$var$syntaxExtension(all, extension) {
    /** @type {keyof Extension} */ let hook;
    for(hook in extension){
        const maybe = $36dbe5ae75482411$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        /** @type {Record<string, unknown>} */ const left = maybe || (all[hook] = {});
        /** @type {Record<string, unknown> | undefined} */ const right = extension[hook];
        /** @type {string} */ let code;
        if (right) for(code in right){
            if (!$36dbe5ae75482411$var$hasOwnProperty.call(left, code)) left[code] = [];
            const value = right[code];
            $36dbe5ae75482411$var$constructs(// @ts-expect-error Looks like a list.
            left[code], Array.isArray(value) ? value : value ? [
                value
            ] : []);
        }
    }
}
/**
 * Merge `list` into `existing` (both lists of constructs).
 * Mutates `existing`.
 *
 * @param {Array<unknown>} existing
 * @param {Array<unknown>} list
 * @returns {void}
 */ function $36dbe5ae75482411$var$constructs(existing, list) {
    let index = -1;
    /** @type {Array<unknown>} */ const before = [];
    while(++index < list.length)(list[index].add === "after" ? existing : before).push(list[index]);
    (0, $f35ae38d0ff93729$export$869882364835d202)(existing, 0, 0, before);
}
function $36dbe5ae75482411$export$eaf8c406dfb0a620(htmlExtensions) {
    /** @type {HtmlExtension} */ const handlers = {};
    let index = -1;
    while(++index < htmlExtensions.length)$36dbe5ae75482411$var$htmlExtension(handlers, htmlExtensions[index]);
    return handlers;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {HtmlExtension} all
 *   Extension to merge into.
 * @param {HtmlExtension} extension
 *   Extension to merge.
 * @returns {void}
 */ function $36dbe5ae75482411$var$htmlExtension(all, extension) {
    /** @type {keyof HtmlExtension} */ let hook;
    for(hook in extension){
        const maybe = $36dbe5ae75482411$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        const left = maybe || (all[hook] = {});
        const right = extension[hook];
        /** @type {keyof Handles} */ let type;
        if (right) for(type in right)// @ts-expect-error assume document vs regular handler are managed correctly.
        left[type] = right[type];
    }
}


/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ /**
 * @typedef {import('micromark-util-types').Code} Code
 */ // This module is generated by `script/`.
//
// CommonMark handles attention (emphasis, strong) markers based on what comes
// before or after them.
// One such difference is if those characters are Unicode punctuation.
// This script is generated from the Unicode data.
/**
 * Regular expression that matches a unicode punctuation character.
 */ const $2051eff0ccd9b1c1$export$85b5101f24802e8c = /[!-\/:-@\[-`\{-~\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/;


const $fc9672c731708cc1$export$d65d6b62c24d5436 = $fc9672c731708cc1$var$regexCheck(/[A-Za-z]/);
const $fc9672c731708cc1$export$75c76db11865a9f4 = $fc9672c731708cc1$var$regexCheck(/[\dA-Za-z]/);
const $fc9672c731708cc1$export$4397998b34fe597d = $fc9672c731708cc1$var$regexCheck(/[#-'*+\--9=?A-Z^-~]/);
function $fc9672c731708cc1$export$67dbf494fc8394df(code) {
    return(// Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code !== null && (code < 32 || code === 127));
}
const $fc9672c731708cc1$export$ca8b5b1a6c320e6e = $fc9672c731708cc1$var$regexCheck(/\d/);
const $fc9672c731708cc1$export$eca2752363989806 = $fc9672c731708cc1$var$regexCheck(/[\dA-Fa-f]/);
const $fc9672c731708cc1$export$35794a7d1db99380 = $fc9672c731708cc1$var$regexCheck(/[!-/:-@[-`{-~]/);
function $fc9672c731708cc1$export$34a1dff1c0936953(code) {
    return code !== null && code < -2;
}
function $fc9672c731708cc1$export$a30284361b3814b7(code) {
    return code !== null && (code < 0 || code === 32);
}
function $fc9672c731708cc1$export$2c6cf65c1127992a(code) {
    return code === -2 || code === -1 || code === 32;
}
const $fc9672c731708cc1$export$aa04114dd888a7a0 = $fc9672c731708cc1$var$regexCheck((0, $2051eff0ccd9b1c1$export$85b5101f24802e8c));
const $fc9672c731708cc1$export$a0ff789c034ffdf4 = $fc9672c731708cc1$var$regexCheck(/\s/);
/**
 * Create a code check from a regex.
 *
 * @param {RegExp} regex
 * @returns {(code: Code) => boolean}
 */ function $fc9672c731708cc1$var$regexCheck(regex) {
    return check;
    /**
   * Check whether a code matches the bound regex.
   *
   * @param {Code} code
   *   Character code.
   * @returns {boolean}
   *   Whether the character code matches the bound regex.
   */ function check(code) {
        return code !== null && regex.test(String.fromCharCode(code));
    }
}


function $048e24d1164dbff0$export$ae105c1eb063a0a2(effects, ok, type, max) {
    const limit = max ? max - 1 : Number.POSITIVE_INFINITY;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $fc9672c731708cc1$export$2c6cf65c1127992a)(code)) {
            effects.enter(type);
            return prefix(code);
        }
        return ok(code);
    }
    /** @type {State} */ function prefix(code) {
        if ((0, $fc9672c731708cc1$export$2c6cf65c1127992a)(code) && size++ < limit) {
            effects.consume(code);
            return prefix;
        }
        effects.exit(type);
        return ok(code);
    }
}



const $6e3e75f09c1bc935$export$a7db06668cad9adb = {
    tokenize: $6e3e75f09c1bc935$var$initializeContent
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $6e3e75f09c1bc935$var$initializeContent(effects) {
    const contentStart = effects.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
    /** @type {Token} */ let previous;
    return contentStart;
    /** @type {State} */ function afterContentStartConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $048e24d1164dbff0$export$ae105c1eb063a0a2)(effects, contentStart, "linePrefix");
    }
    /** @type {State} */ function paragraphInitial(code) {
        effects.enter("paragraph");
        return lineStart(code);
    }
    /** @type {State} */ function lineStart(code) {
        const token = effects.enter("chunkText", {
            contentType: "text",
            previous: previous
        });
        if (previous) previous.next = token;
        previous = token;
        return data(code);
    }
    /** @type {State} */ function data(code) {
        if (code === null) {
            effects.exit("chunkText");
            effects.exit("paragraph");
            effects.consume(code);
            return;
        }
        if ((0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            effects.exit("chunkText");
            return lineStart;
        }
        // Data.
        effects.consume(code);
        return data;
    }
}


/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ContainerState} ContainerState
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {[Construct, ContainerState]} StackItem
 */ 


const $aee28eb89d776f63$export$5a7bfc01df82fcd1 = {
    tokenize: $aee28eb89d776f63$var$initializeDocument
};
/** @type {Construct} */ const $aee28eb89d776f63$var$containerConstruct = {
    tokenize: $aee28eb89d776f63$var$tokenizeContainer
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $aee28eb89d776f63$var$initializeDocument(effects) {
    const self = this;
    /** @type {Array<StackItem>} */ const stack = [];
    let continued = 0;
    /** @type {TokenizeContext | undefined} */ let childFlow;
    /** @type {Token | undefined} */ let childToken;
    /** @type {number} */ let lineStartOffset;
    return start;
    /** @type {State} */ function start(code) {
        // First we iterate through the open blocks, starting with the root
        // document, and descending through last children down to the last open
        // block.
        // Each block imposes a condition that the line must satisfy if the block is
        // to remain open.
        // For example, a block quote requires a `>` character.
        // A paragraph requires a non-blank line.
        // In this phase we may match all or just some of the open blocks.
        // But we cannot close unmatched blocks yet, because we may have a lazy
        // continuation line.
        if (continued < stack.length) {
            const item = stack[continued];
            self.containerState = item[1];
            return effects.attempt(item[0].continuation, documentContinue, checkNewContainers)(code);
        }
        // Done.
        return checkNewContainers(code);
    }
    /** @type {State} */ function documentContinue(code) {
        continued++;
        // Note: this field is called `_closeFlow` but it also closes containers.
        // Perhaps a good idea to rename it but it’s already used in the wild by
        // extensions.
        if (self.containerState._closeFlow) {
            self.containerState._closeFlow = undefined;
            if (childFlow) closeFlow();
            // Note: this algorithm for moving events around is similar to the
            // algorithm when dealing with lazy lines in `writeToChild`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {Point | undefined} */ let point;
            // Find the flow chunk.
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === "exit" && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                point = self.events[indexBeforeFlow][1].end;
                break;
            }
            exitContainers(continued);
            // Fix positions.
            let index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = Object.assign({}, point);
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $f35ae38d0ff93729$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
            return checkNewContainers(code);
        }
        return start(code);
    }
    /** @type {State} */ function checkNewContainers(code) {
        // Next, after consuming the continuation markers for existing blocks, we
        // look for new block starts (e.g. `>` for a block quote).
        // If we encounter a new block start, we close any blocks unmatched in
        // step 1 before creating the new block as a child of the last matched
        // block.
        if (continued === stack.length) {
            // No need to `check` whether there’s a container, of `exitContainers`
            // would be moot.
            // We can instead immediately `attempt` to parse one.
            if (!childFlow) return documentContinued(code);
            // If we have concrete content, such as block HTML or fenced code,
            // we can’t have containers “pierce” into them, so we can immediately
            // start.
            if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) return flowStart(code);
            // If we do have flow, it could still be a blank line,
            // but we’d be interrupting it w/ a new container if there’s a current
            // construct.
            // To do: next major: remove `_gfmTableDynamicInterruptHack` (no longer
            // needed in micromark-extension-gfm-table@1.0.6).
            self.interrupt = Boolean(childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack);
        }
        // Check if there is a new container.
        self.containerState = {};
        return effects.check($aee28eb89d776f63$var$containerConstruct, thereIsANewContainer, thereIsNoNewContainer)(code);
    }
    /** @type {State} */ function thereIsANewContainer(code) {
        if (childFlow) closeFlow();
        exitContainers(continued);
        return documentContinued(code);
    }
    /** @type {State} */ function thereIsNoNewContainer(code) {
        self.parser.lazy[self.now().line] = continued !== stack.length;
        lineStartOffset = self.now().offset;
        return flowStart(code);
    }
    /** @type {State} */ function documentContinued(code) {
        // Try new containers.
        self.containerState = {};
        return effects.attempt($aee28eb89d776f63$var$containerConstruct, containerContinue, flowStart)(code);
    }
    /** @type {State} */ function containerContinue(code) {
        continued++;
        stack.push([
            self.currentConstruct,
            self.containerState
        ]);
        // Try another.
        return documentContinued(code);
    }
    /** @type {State} */ function flowStart(code) {
        if (code === null) {
            if (childFlow) closeFlow();
            exitContainers(0);
            effects.consume(code);
            return;
        }
        childFlow = childFlow || self.parser.flow(self.now());
        effects.enter("chunkFlow", {
            contentType: "flow",
            previous: childToken,
            _tokenizer: childFlow
        });
        return flowContinue(code);
    }
    /** @type {State} */ function flowContinue(code) {
        if (code === null) {
            writeToChild(effects.exit("chunkFlow"), true);
            exitContainers(0);
            effects.consume(code);
            return;
        }
        if ((0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            writeToChild(effects.exit("chunkFlow"));
            // Get ready for the next line.
            continued = 0;
            self.interrupt = undefined;
            return start;
        }
        effects.consume(code);
        return flowContinue;
    }
    /**
   * @param {Token} token
   * @param {boolean | undefined} [eof]
   * @returns {void}
   */ function writeToChild(token, eof) {
        const stream = self.sliceStream(token);
        if (eof) stream.push(null);
        token.previous = childToken;
        if (childToken) childToken.next = token;
        childToken = token;
        childFlow.defineSkip(token.start);
        childFlow.write(stream);
        // Alright, so we just added a lazy line:
        //
        // ```markdown
        // > a
        // b.
        //
        // Or:
        //
        // > ~~~c
        // d
        //
        // Or:
        //
        // > | e |
        // f
        // ```
        //
        // The construct in the second example (fenced code) does not accept lazy
        // lines, so it marked itself as done at the end of its first line, and
        // then the content construct parses `d`.
        // Most constructs in markdown match on the first line: if the first line
        // forms a construct, a non-lazy line can’t “unmake” it.
        //
        // The construct in the third example is potentially a GFM table, and
        // those are *weird*.
        // It *could* be a table, from the first line, if the following line
        // matches a condition.
        // In this case, that second line is lazy, which “unmakes” the first line
        // and turns the whole into one content block.
        //
        // We’ve now parsed the non-lazy and the lazy line, and can figure out
        // whether the lazy line started a new flow block.
        // If it did, we exit the current containers between the two flow blocks.
        if (self.parser.lazy[token.start.line]) {
            let index = childFlow.events.length;
            while(index--){
                if (// The token starts before the line ending…
                childFlow.events[index][1].start.offset < lineStartOffset && // …and either is not ended yet…
                (!childFlow.events[index][1].end || // …or ends after it.
                childFlow.events[index][1].end.offset > lineStartOffset)) // Exit: there’s still something open, which means it’s a lazy line
                // part of something.
                return;
            }
            // Note: this algorithm for moving events around is similar to the
            // algorithm when closing flow in `documentContinue`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {boolean | undefined} */ let seen;
            /** @type {Point | undefined} */ let point;
            // Find the previous chunk (the one before the lazy line).
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === "exit" && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                if (seen) {
                    point = self.events[indexBeforeFlow][1].end;
                    break;
                }
                seen = true;
            }
            exitContainers(continued);
            // Fix positions.
            index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = Object.assign({}, point);
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $f35ae38d0ff93729$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
        }
    }
    /**
   * @param {number} size
   * @returns {void}
   */ function exitContainers(size) {
        let index = stack.length;
        // Exit open containers.
        while(index-- > size){
            const entry = stack[index];
            self.containerState = entry[1];
            entry[0].exit.call(self, effects);
        }
        stack.length = size;
    }
    function closeFlow() {
        childFlow.write([
            null
        ]);
        childToken = undefined;
        childFlow = undefined;
        self.containerState._closeFlow = undefined;
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $aee28eb89d776f63$var$tokenizeContainer(effects, ok, nok) {
    // Always populated by defaults.
    return (0, $048e24d1164dbff0$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.document, ok, nok), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4);
}


/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $ec58cd122e396498$export$d50d28ce3ab2a612 = {
    tokenize: $ec58cd122e396498$var$tokenizeBlankLine,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $ec58cd122e396498$var$tokenizeBlankLine(effects, ok, nok) {
    return start;
    /**
   * Start of blank line.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *     ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        return (0, $fc9672c731708cc1$export$2c6cf65c1127992a)(code) ? (0, $048e24d1164dbff0$export$ae105c1eb063a0a2)(effects, after, "linePrefix")(code) : after(code);
    }
    /**
   * At eof/eol, after optional whitespace.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *       ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return code === null || (0, $fc9672c731708cc1$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Token} Token
 */ 
function $486a8072789116a0$export$12949d1dd00fddf4(events) {
    /** @type {Record<string, number>} */ const jumps = {};
    let index = -1;
    /** @type {Event} */ let event;
    /** @type {number | undefined} */ let lineIndex;
    /** @type {number} */ let otherIndex;
    /** @type {Event} */ let otherEvent;
    /** @type {Array<Event>} */ let parameters;
    /** @type {Array<Event>} */ let subevents;
    /** @type {boolean | undefined} */ let more;
    while(++index < events.length){
        while(index in jumps)index = jumps[index];
        event = events[index];
        // Add a hook for the GFM tasklist extension, which needs to know if text
        // is in the first content of a list item.
        if (index && event[1].type === "chunkFlow" && events[index - 1][1].type === "listItemPrefix") {
            subevents = event[1]._tokenizer.events;
            otherIndex = 0;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "lineEndingBlank") otherIndex += 2;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "content") while(++otherIndex < subevents.length){
                if (subevents[otherIndex][1].type === "content") break;
                if (subevents[otherIndex][1].type === "chunkText") {
                    subevents[otherIndex][1]._isInFirstContentOfListItem = true;
                    otherIndex++;
                }
            }
        }
        // Enter.
        if (event[0] === "enter") {
            if (event[1].contentType) {
                Object.assign(jumps, $486a8072789116a0$var$subcontent(events, index));
                index = jumps[index];
                more = true;
            }
        } else if (event[1]._container) {
            otherIndex = index;
            lineIndex = undefined;
            while(otherIndex--){
                otherEvent = events[otherIndex];
                if (otherEvent[1].type === "lineEnding" || otherEvent[1].type === "lineEndingBlank") {
                    if (otherEvent[0] === "enter") {
                        if (lineIndex) events[lineIndex][1].type = "lineEndingBlank";
                        otherEvent[1].type = "lineEnding";
                        lineIndex = otherIndex;
                    }
                } else break;
            }
            if (lineIndex) {
                // Fix position.
                event[1].end = Object.assign({}, events[lineIndex][1].start);
                // Switch container exit w/ line endings.
                parameters = events.slice(lineIndex, index);
                parameters.unshift(event);
                (0, $f35ae38d0ff93729$export$869882364835d202)(events, lineIndex, index - lineIndex + 1, parameters);
            }
        }
    }
    return !more;
}
/**
 * Tokenize embedded tokens.
 *
 * @param {Array<Event>} events
 * @param {number} eventIndex
 * @returns {Record<string, number>}
 */ function $486a8072789116a0$var$subcontent(events, eventIndex) {
    const token = events[eventIndex][1];
    const context = events[eventIndex][2];
    let startPosition = eventIndex - 1;
    /** @type {Array<number>} */ const startPositions = [];
    const tokenizer = token._tokenizer || context.parser[token.contentType](token.start);
    const childEvents = tokenizer.events;
    /** @type {Array<[number, number]>} */ const jumps = [];
    /** @type {Record<string, number>} */ const gaps = {};
    /** @type {Array<Chunk>} */ let stream;
    /** @type {Token | undefined} */ let previous;
    let index = -1;
    /** @type {Token | undefined} */ let current = token;
    let adjust = 0;
    let start = 0;
    const breaks = [
        start
    ];
    // Loop forward through the linked tokens to pass them in order to the
    // subtokenizer.
    while(current){
        // Find the position of the event for this token.
        while(events[++startPosition][1] !== current);
        startPositions.push(startPosition);
        if (!current._tokenizer) {
            stream = context.sliceStream(current);
            if (!current.next) stream.push(null);
            if (previous) tokenizer.defineSkip(current.start);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = true;
            tokenizer.write(stream);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = undefined;
        }
        // Unravel the next token.
        previous = current;
        current = current.next;
    }
    // Now, loop back through all events (and linked tokens), to figure out which
    // parts belong where.
    current = token;
    while(++index < childEvents.length)if (// Find a void token that includes a break.
    childEvents[index][0] === "exit" && childEvents[index - 1][0] === "enter" && childEvents[index][1].type === childEvents[index - 1][1].type && childEvents[index][1].start.line !== childEvents[index][1].end.line) {
        start = index + 1;
        breaks.push(start);
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
        current = current.next;
    }
    // Help GC.
    tokenizer.events = [];
    // If there’s one more token (which is the cases for lines that end in an
    // EOF), that’s perfect: the last point we found starts it.
    // If there isn’t then make sure any remaining content is added to it.
    if (current) {
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
    } else breaks.pop();
    // Now splice the events from the subtokenizer into the current events,
    // moving back to front so that splice indices aren’t affected.
    index = breaks.length;
    while(index--){
        const slice = childEvents.slice(breaks[index], breaks[index + 1]);
        const start = startPositions.pop();
        jumps.unshift([
            start,
            start + slice.length - 1
        ]);
        (0, $f35ae38d0ff93729$export$869882364835d202)(events, start, 2, slice);
    }
    index = -1;
    while(++index < jumps.length){
        gaps[adjust + jumps[index][0]] = adjust + jumps[index][1];
        adjust += jumps[index][1] - jumps[index][0] - 1;
    }
    return gaps;
}


const $93b2107474d04ce0$export$a7db06668cad9adb = {
    tokenize: $93b2107474d04ce0$var$tokenizeContent,
    resolve: $93b2107474d04ce0$var$resolveContent
};
/** @type {Construct} */ const $93b2107474d04ce0$var$continuationConstruct = {
    tokenize: $93b2107474d04ce0$var$tokenizeContinuation,
    partial: true
};
/**
 * Content is transparent: it’s parsed right now. That way, definitions are also
 * parsed right now: before text in paragraphs (specifically, media) are parsed.
 *
 * @type {Resolver}
 */ function $93b2107474d04ce0$var$resolveContent(events) {
    (0, $486a8072789116a0$export$12949d1dd00fddf4)(events);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $93b2107474d04ce0$var$tokenizeContent(effects, ok) {
    /** @type {Token | undefined} */ let previous;
    return chunkStart;
    /**
   * Before a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^
   * ```
   *
   * @type {State}
   */ function chunkStart(code) {
        effects.enter("content");
        previous = effects.enter("chunkContent", {
            contentType: "content"
        });
        return chunkInside(code);
    }
    /**
   * In a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^^^
   * ```
   *
   * @type {State}
   */ function chunkInside(code) {
        if (code === null) return contentEnd(code);
        // To do: in `markdown-rs`, each line is parsed on its own, and everything
        // is stitched together resolving.
        if ((0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) return effects.check($93b2107474d04ce0$var$continuationConstruct, contentContinue, contentEnd)(code);
        // Data.
        effects.consume(code);
        return chunkInside;
    }
    /**
   *
   *
   * @type {State}
   */ function contentEnd(code) {
        effects.exit("chunkContent");
        effects.exit("content");
        return ok(code);
    }
    /**
   *
   *
   * @type {State}
   */ function contentContinue(code) {
        effects.consume(code);
        effects.exit("chunkContent");
        previous.next = effects.enter("chunkContent", {
            contentType: "content",
            previous: previous
        });
        previous = previous.next;
        return chunkInside;
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $93b2107474d04ce0$var$tokenizeContinuation(effects, ok, nok) {
    const self = this;
    return startLookahead;
    /**
   *
   *
   * @type {State}
   */ function startLookahead(code) {
        effects.exit("chunkContent");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $048e24d1164dbff0$export$ae105c1eb063a0a2)(effects, prefixed, "linePrefix");
    }
    /**
   *
   *
   * @type {State}
   */ function prefixed(code) {
        if (code === null || (0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) return nok(code);
        // Always populated by defaults.
        const tail = self.events[self.events.length - 1];
        if (!self.parser.constructs.disable.null.includes("codeIndented") && tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4) return ok(code);
        return effects.interrupt(self.parser.constructs.flow, nok, ok)(code);
    }
}




const $57a9355f3895b732$export$ccc7b0636abaffc3 = {
    tokenize: $57a9355f3895b732$var$initializeFlow
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $57a9355f3895b732$var$initializeFlow(effects) {
    const self = this;
    const initial = effects.attempt(// Try to parse a blank line.
    (0, $ec58cd122e396498$export$d50d28ce3ab2a612), atBlankEnding, // Try to parse initial flow (essentially, only code).
    effects.attempt(this.parser.constructs.flowInitial, afterConstruct, (0, $048e24d1164dbff0$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.flow, afterConstruct, effects.attempt((0, $93b2107474d04ce0$export$a7db06668cad9adb), afterConstruct)), "linePrefix")));
    return initial;
    /** @type {State} */ function atBlankEnding(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEndingBlank");
        effects.consume(code);
        effects.exit("lineEndingBlank");
        self.currentConstruct = undefined;
        return initial;
    }
    /** @type {State} */ function afterConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        self.currentConstruct = undefined;
        return initial;
    }
}


/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ const $a41923ffc7408b35$export$50397835cbfdbc24 = {
    resolveAll: $a41923ffc7408b35$var$createResolver()
};
const $a41923ffc7408b35$export$22b082955e083ec3 = $a41923ffc7408b35$var$initializeFactory("string");
const $a41923ffc7408b35$export$6f093cfa640b7166 = $a41923ffc7408b35$var$initializeFactory("text");
/**
 * @param {'string' | 'text'} field
 * @returns {InitialConstruct}
 */ function $a41923ffc7408b35$var$initializeFactory(field) {
    return {
        tokenize: initializeText,
        resolveAll: $a41923ffc7408b35$var$createResolver(field === "text" ? $a41923ffc7408b35$var$resolveAllLineSuffixes : undefined)
    };
    /**
   * @this {TokenizeContext}
   * @type {Initializer}
   */ function initializeText(effects) {
        const self = this;
        const constructs = this.parser.constructs[field];
        const text = effects.attempt(constructs, start, notText);
        return start;
        /** @type {State} */ function start(code) {
            return atBreak(code) ? text(code) : notText(code);
        }
        /** @type {State} */ function notText(code) {
            if (code === null) {
                effects.consume(code);
                return;
            }
            effects.enter("data");
            effects.consume(code);
            return data;
        }
        /** @type {State} */ function data(code) {
            if (atBreak(code)) {
                effects.exit("data");
                return text(code);
            }
            // Data.
            effects.consume(code);
            return data;
        }
        /**
     * @param {Code} code
     * @returns {boolean}
     */ function atBreak(code) {
            if (code === null) return true;
            const list = constructs[code];
            let index = -1;
            if (list) // Always populated by defaults.
            while(++index < list.length){
                const item = list[index];
                if (!item.previous || item.previous.call(self, self.previous)) return true;
            }
            return false;
        }
    }
}
/**
 * @param {Resolver | undefined} [extraResolver]
 * @returns {Resolver}
 */ function $a41923ffc7408b35$var$createResolver(extraResolver) {
    return resolveAllText;
    /** @type {Resolver} */ function resolveAllText(events, context) {
        let index = -1;
        /** @type {number | undefined} */ let enter;
        // A rather boring computation (to merge adjacent `data` events) which
        // improves mm performance by 29%.
        while(++index <= events.length){
            if (enter === undefined) {
                if (events[index] && events[index][1].type === "data") {
                    enter = index;
                    index++;
                }
            } else if (!events[index] || events[index][1].type !== "data") {
                // Don’t do anything if there is one data token.
                if (index !== enter + 2) {
                    events[enter][1].end = events[index - 1][1].end;
                    events.splice(enter + 2, index - enter - 2);
                    index = enter + 2;
                }
                enter = undefined;
            }
        }
        return extraResolver ? extraResolver(events, context) : events;
    }
}
/**
 * A rather ugly set of instructions which again looks at chunks in the input
 * stream.
 * The reason to do this here is that it is *much* faster to parse in reverse.
 * And that we can’t hook into `null` to split the line suffix before an EOF.
 * To do: figure out if we can make this into a clean utility, or even in core.
 * As it will be useful for GFMs literal autolink extension (and maybe even
 * tables?)
 *
 * @type {Resolver}
 */ function $a41923ffc7408b35$var$resolveAllLineSuffixes(events, context) {
    let eventIndex = 0 // Skip first.
    ;
    while(++eventIndex <= events.length)if ((eventIndex === events.length || events[eventIndex][1].type === "lineEnding") && events[eventIndex - 1][1].type === "data") {
        const data = events[eventIndex - 1][1];
        const chunks = context.sliceStream(data);
        let index = chunks.length;
        let bufferIndex = -1;
        let size = 0;
        /** @type {boolean | undefined} */ let tabs;
        while(index--){
            const chunk = chunks[index];
            if (typeof chunk === "string") {
                bufferIndex = chunk.length;
                while(chunk.charCodeAt(bufferIndex - 1) === 32){
                    size++;
                    bufferIndex--;
                }
                if (bufferIndex) break;
                bufferIndex = -1;
            } else if (chunk === -2) {
                tabs = true;
                size++;
            } else if (chunk === -1) ;
            else {
                // Replacement character, exit.
                index++;
                break;
            }
        }
        if (size) {
            const token = {
                type: eventIndex === events.length || tabs || size < 2 ? "lineSuffix" : "hardBreakTrailing",
                start: {
                    line: data.end.line,
                    column: data.end.column - size,
                    offset: data.end.offset - size,
                    _index: data.start._index + index,
                    _bufferIndex: index ? bufferIndex : data.start._bufferIndex + bufferIndex
                },
                end: Object.assign({}, data.end)
            };
            data.end = Object.assign({}, token.start);
            if (data.start.offset === data.end.offset) Object.assign(data, token);
            else {
                events.splice(eventIndex, 0, [
                    "enter",
                    token,
                    context
                ], [
                    "exit",
                    token,
                    context
                ]);
                eventIndex += 2;
            }
        }
        eventIndex++;
    }
    return events;
}


/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ConstructRecord} ConstructRecord
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenType} TokenType
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * @callback Restore
 * @returns {void}
 *
 * @typedef Info
 * @property {Restore} restore
 * @property {number} from
 *
 * @callback ReturnHandle
 *   Handle a successful run.
 * @param {Construct} construct
 * @param {Info} info
 * @returns {void}
 */ 

/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * Call all `resolveAll`s.
 *
 * @param {Array<{resolveAll?: Resolver | undefined}>} constructs
 *   List of constructs, optionally with `resolveAll`s.
 * @param {Array<Event>} events
 *   List of events.
 * @param {TokenizeContext} context
 *   Context used by `tokenize`.
 * @returns {Array<Event>}
 *   Changed events.
 */ function $0358419463affc45$export$3ff61ec196ff408b(constructs, events, context) {
    /** @type {Array<Resolver>} */ const called = [];
    let index = -1;
    while(++index < constructs.length){
        const resolve = constructs[index].resolveAll;
        if (resolve && !called.includes(resolve)) {
            events = resolve(events, context);
            called.push(resolve);
        }
    }
    return events;
}


function $5e20a0230da3aec5$export$ae34f10ee4b29837(parser, initialize, from) {
    /** @type {Point} */ let point = Object.assign(from ? Object.assign({}, from) : {
        line: 1,
        column: 1,
        offset: 0
    }, {
        _index: 0,
        _bufferIndex: -1
    });
    /** @type {Record<string, number>} */ const columnStart = {};
    /** @type {Array<Construct>} */ const resolveAllConstructs = [];
    /** @type {Array<Chunk>} */ let chunks = [];
    /** @type {Array<Token>} */ let stack = [];
    /** @type {boolean | undefined} */ let consumed = true;
    /**
   * Tools used for tokenizing.
   *
   * @type {Effects}
   */ const effects = {
        consume: consume,
        enter: enter,
        exit: exit,
        attempt: constructFactory(onsuccessfulconstruct),
        check: constructFactory(onsuccessfulcheck),
        interrupt: constructFactory(onsuccessfulcheck, {
            interrupt: true
        })
    };
    /**
   * State and tools for resolving and serializing.
   *
   * @type {TokenizeContext}
   */ const context = {
        previous: null,
        code: null,
        containerState: {},
        events: [],
        parser: parser,
        sliceStream: sliceStream,
        sliceSerialize: sliceSerialize,
        now: now,
        defineSkip: defineSkip,
        write: write
    };
    /**
   * The state function.
   *
   * @type {State | void}
   */ let state = initialize.tokenize.call(context, effects);
    /**
   * Track which character we expect to be consumed, to catch bugs.
   *
   * @type {Code}
   */ let expectedCode;
    if (initialize.resolveAll) resolveAllConstructs.push(initialize);
    return context;
    /** @type {TokenizeContext['write']} */ function write(slice) {
        chunks = (0, $f35ae38d0ff93729$export$4cbf152802aa238)(chunks, slice);
        main();
        // Exit if we’re not done, resolve might change stuff.
        if (chunks[chunks.length - 1] !== null) return [];
        addResult(initialize, 0);
        // Otherwise, resolve, and exit.
        context.events = (0, $0358419463affc45$export$3ff61ec196ff408b)(resolveAllConstructs, context.events, context);
        return context.events;
    }
    //
    // Tools.
    //
    /** @type {TokenizeContext['sliceSerialize']} */ function sliceSerialize(token, expandTabs) {
        return $5e20a0230da3aec5$var$serializeChunks(sliceStream(token), expandTabs);
    }
    /** @type {TokenizeContext['sliceStream']} */ function sliceStream(token) {
        return $5e20a0230da3aec5$var$sliceChunks(chunks, token);
    }
    /** @type {TokenizeContext['now']} */ function now() {
        // This is a hot path, so we clone manually instead of `Object.assign({}, point)`
        const { line: line, column: column, offset: offset, _index: _index, _bufferIndex: _bufferIndex } = point;
        return {
            line: line,
            column: column,
            offset: offset,
            _index: _index,
            _bufferIndex: _bufferIndex
        };
    }
    /** @type {TokenizeContext['defineSkip']} */ function defineSkip(value) {
        columnStart[value.line] = value.column;
        accountForPotentialSkip();
    }
    //
    // State management.
    //
    /**
   * Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
   * `consume`).
   * Here is where we walk through the chunks, which either include strings of
   * several characters, or numerical character codes.
   * The reason to do this in a loop instead of a call is so the stack can
   * drain.
   *
   * @returns {void}
   */ function main() {
        /** @type {number} */ let chunkIndex;
        while(point._index < chunks.length){
            const chunk = chunks[point._index];
            // If we’re in a buffer chunk, loop through it.
            if (typeof chunk === "string") {
                chunkIndex = point._index;
                if (point._bufferIndex < 0) point._bufferIndex = 0;
                while(point._index === chunkIndex && point._bufferIndex < chunk.length)go(chunk.charCodeAt(point._bufferIndex));
            } else go(chunk);
        }
    }
    /**
   * Deal with one code.
   *
   * @param {Code} code
   * @returns {void}
   */ function go(code) {
        consumed = undefined;
        expectedCode = code;
        state = state(code);
    }
    /** @type {Effects['consume']} */ function consume(code) {
        if ((0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) {
            point.line++;
            point.column = 1;
            point.offset += code === -3 ? 2 : 1;
            accountForPotentialSkip();
        } else if (code !== -1) {
            point.column++;
            point.offset++;
        }
        // Not in a string chunk.
        if (point._bufferIndex < 0) point._index++;
        else {
            point._bufferIndex++;
            // At end of string chunk.
            // @ts-expect-error Points w/ non-negative `_bufferIndex` reference
            // strings.
            if (point._bufferIndex === chunks[point._index].length) {
                point._bufferIndex = -1;
                point._index++;
            }
        }
        // Expose the previous character.
        context.previous = code;
        // Mark as consumed.
        consumed = true;
    }
    /** @type {Effects['enter']} */ function enter(type, fields) {
        /** @type {Token} */ // @ts-expect-error Patch instead of assign required fields to help GC.
        const token = fields || {};
        token.type = type;
        token.start = now();
        context.events.push([
            "enter",
            token,
            context
        ]);
        stack.push(token);
        return token;
    }
    /** @type {Effects['exit']} */ function exit(type) {
        const token = stack.pop();
        token.end = now();
        context.events.push([
            "exit",
            token,
            context
        ]);
        return token;
    }
    /**
   * Use results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulconstruct(construct, info) {
        addResult(construct, info.from);
    }
    /**
   * Discard results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulcheck(_, info) {
        info.restore();
    }
    /**
   * Factory to attempt/check/interrupt.
   *
   * @param {ReturnHandle} onreturn
   * @param {{interrupt?: boolean | undefined} | undefined} [fields]
   */ function constructFactory(onreturn, fields) {
        return hook;
        /**
     * Handle either an object mapping codes to constructs, a list of
     * constructs, or a single construct.
     *
     * @param {Array<Construct> | Construct | ConstructRecord} constructs
     * @param {State} returnState
     * @param {State | undefined} [bogusState]
     * @returns {State}
     */ function hook(constructs, returnState, bogusState) {
            /** @type {Array<Construct>} */ let listOfConstructs;
            /** @type {number} */ let constructIndex;
            /** @type {Construct} */ let currentConstruct;
            /** @type {Info} */ let info;
            return Array.isArray(constructs) ? handleListOfConstructs(constructs) : "tokenize" in constructs ? handleListOfConstructs([
                constructs
            ]) : handleMapOfConstructs(constructs);
            /**
       * Handle a list of construct.
       *
       * @param {ConstructRecord} map
       * @returns {State}
       */ function handleMapOfConstructs(map) {
                return start;
                /** @type {State} */ function start(code) {
                    const def = code !== null && map[code];
                    const all = code !== null && map.null;
                    const list = [
                        // To do: add more extension tests.
                        /* c8 ignore next 2 */ ...Array.isArray(def) ? def : def ? [
                            def
                        ] : [],
                        ...Array.isArray(all) ? all : all ? [
                            all
                        ] : []
                    ];
                    return handleListOfConstructs(list)(code);
                }
            }
            /**
       * Handle a list of construct.
       *
       * @param {Array<Construct>} list
       * @returns {State}
       */ function handleListOfConstructs(list) {
                listOfConstructs = list;
                constructIndex = 0;
                if (list.length === 0) return bogusState;
                return handleConstruct(list[constructIndex]);
            }
            /**
       * Handle a single construct.
       *
       * @param {Construct} construct
       * @returns {State}
       */ function handleConstruct(construct) {
                return start;
                /** @type {State} */ function start(code) {
                    // To do: not needed to store if there is no bogus state, probably?
                    // Currently doesn’t work because `inspect` in document does a check
                    // w/o a bogus, which doesn’t make sense. But it does seem to help perf
                    // by not storing.
                    info = store();
                    currentConstruct = construct;
                    if (!construct.partial) context.currentConstruct = construct;
                    // Always populated by defaults.
                    if (construct.name && context.parser.constructs.disable.null.includes(construct.name)) return nok(code);
                    return construct.tokenize.call(// If we do have fields, create an object w/ `context` as its
                    // prototype.
                    // This allows a “live binding”, which is needed for `interrupt`.
                    fields ? Object.assign(Object.create(context), fields) : context, effects, ok, nok)(code);
                }
            }
            /** @type {State} */ function ok(code) {
                consumed = true;
                onreturn(currentConstruct, info);
                return returnState;
            }
            /** @type {State} */ function nok(code) {
                consumed = true;
                info.restore();
                if (++constructIndex < listOfConstructs.length) return handleConstruct(listOfConstructs[constructIndex]);
                return bogusState;
            }
        }
    }
    /**
   * @param {Construct} construct
   * @param {number} from
   * @returns {void}
   */ function addResult(construct, from) {
        if (construct.resolveAll && !resolveAllConstructs.includes(construct)) resolveAllConstructs.push(construct);
        if (construct.resolve) (0, $f35ae38d0ff93729$export$869882364835d202)(context.events, from, context.events.length - from, construct.resolve(context.events.slice(from), context));
        if (construct.resolveTo) context.events = construct.resolveTo(context.events, context);
    }
    /**
   * Store state.
   *
   * @returns {Info}
   */ function store() {
        const startPoint = now();
        const startPrevious = context.previous;
        const startCurrentConstruct = context.currentConstruct;
        const startEventsIndex = context.events.length;
        const startStack = Array.from(stack);
        return {
            restore: restore,
            from: startEventsIndex
        };
        /**
     * Restore state.
     *
     * @returns {void}
     */ function restore() {
            point = startPoint;
            context.previous = startPrevious;
            context.currentConstruct = startCurrentConstruct;
            context.events.length = startEventsIndex;
            stack = startStack;
            accountForPotentialSkip();
        }
    }
    /**
   * Move the current point a bit forward in the line when it’s on a column
   * skip.
   *
   * @returns {void}
   */ function accountForPotentialSkip() {
        if (point.line in columnStart && point.column < 2) {
            point.column = columnStart[point.line];
            point.offset += columnStart[point.line] - 1;
        }
    }
}
/**
 * Get the chunks from a slice of chunks in the range of a token.
 *
 * @param {Array<Chunk>} chunks
 * @param {Pick<Token, 'end' | 'start'>} token
 * @returns {Array<Chunk>}
 */ function $5e20a0230da3aec5$var$sliceChunks(chunks, token) {
    const startIndex = token.start._index;
    const startBufferIndex = token.start._bufferIndex;
    const endIndex = token.end._index;
    const endBufferIndex = token.end._bufferIndex;
    /** @type {Array<Chunk>} */ let view;
    if (startIndex === endIndex) // @ts-expect-error `_bufferIndex` is used on string chunks.
    view = [
        chunks[startIndex].slice(startBufferIndex, endBufferIndex)
    ];
    else {
        view = chunks.slice(startIndex, endIndex);
        if (startBufferIndex > -1) {
            const head = view[0];
            if (typeof head === "string") view[0] = head.slice(startBufferIndex);
            else view.shift();
        }
        if (endBufferIndex > 0) // @ts-expect-error `_bufferIndex` is used on string chunks.
        view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
    return view;
}
/**
 * Get the string value of a slice of chunks.
 *
 * @param {Array<Chunk>} chunks
 * @param {boolean | undefined} [expandTabs=false]
 * @returns {string}
 */ function $5e20a0230da3aec5$var$serializeChunks(chunks, expandTabs) {
    let index = -1;
    /** @type {Array<string>} */ const result = [];
    /** @type {boolean | undefined} */ let atTab;
    while(++index < chunks.length){
        const chunk = chunks[index];
        /** @type {string} */ let value;
        if (typeof chunk === "string") value = chunk;
        else switch(chunk){
            case -5:
                value = "\r";
                break;
            case -4:
                value = "\n";
                break;
            case -3:
                value = "\r\n";
                break;
            case -2:
                value = expandTabs ? " " : "	";
                break;
            case -1:
                if (!expandTabs && atTab) continue;
                value = " ";
                break;
            default:
                // Currently only replacement character.
                value = String.fromCharCode(chunk);
        }
        atTab = chunk === -2;
        result.push(value);
    }
    return result.join("");
}


var $f0dbdc5ddfff416b$exports = {};

$parcel$export($f0dbdc5ddfff416b$exports, "document", function () { return $f0dbdc5ddfff416b$export$5a7bfc01df82fcd1; });
$parcel$export($f0dbdc5ddfff416b$exports, "contentInitial", function () { return $f0dbdc5ddfff416b$export$5a2181fb44b58173; });
$parcel$export($f0dbdc5ddfff416b$exports, "flowInitial", function () { return $f0dbdc5ddfff416b$export$cf8bead395eff824; });
$parcel$export($f0dbdc5ddfff416b$exports, "flow", function () { return $f0dbdc5ddfff416b$export$ccc7b0636abaffc3; });
$parcel$export($f0dbdc5ddfff416b$exports, "string", function () { return $f0dbdc5ddfff416b$export$22b082955e083ec3; });
$parcel$export($f0dbdc5ddfff416b$exports, "text", function () { return $f0dbdc5ddfff416b$export$6f093cfa640b7166; });
$parcel$export($f0dbdc5ddfff416b$exports, "insideSpan", function () { return $f0dbdc5ddfff416b$export$d44f260a3f9b69f5; });
$parcel$export($f0dbdc5ddfff416b$exports, "attentionMarkers", function () { return $f0dbdc5ddfff416b$export$b9c0b60d74426aea; });
$parcel$export($f0dbdc5ddfff416b$exports, "disable", function () { return $f0dbdc5ddfff416b$export$e20fbacbb41798b; });
/**
 * @typedef {import('micromark-util-types').Extension} Extension
 */ /**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ContainerState} ContainerState
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 


/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $b0a6b81550e558dc$export$ba7b13e047416c03 = {
    name: "thematicBreak",
    tokenize: $b0a6b81550e558dc$var$tokenizeThematicBreak
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $b0a6b81550e558dc$var$tokenizeThematicBreak(effects, ok, nok) {
    let size = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of thematic break.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("thematicBreak");
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * After optional whitespace, at marker.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        marker = code;
        return atBreak(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.enter("thematicBreakSequence");
            return sequence(code);
        }
        if (size >= 3 && (code === null || (0, $fc9672c731708cc1$export$34a1dff1c0936953)(code))) {
            effects.exit("thematicBreak");
            return ok(code);
        }
        return nok(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function sequence(code) {
        if (code === marker) {
            effects.consume(code);
            size++;
            return sequence;
        }
        effects.exit("thematicBreakSequence");
        return (0, $fc9672c731708cc1$export$2c6cf65c1127992a)(code) ? (0, $048e24d1164dbff0$export$ae105c1eb063a0a2)(effects, atBreak, "whitespace")(code) : atBreak(code);
    }
}


const $9d2275ffc8036224$export$8837f4fc672e936d = {
    name: "list",
    tokenize: $9d2275ffc8036224$var$tokenizeListStart,
    continuation: {
        tokenize: $9d2275ffc8036224$var$tokenizeListContinuation
    },
    exit: $9d2275ffc8036224$var$tokenizeListEnd
};
/** @type {Construct} */ const $9d2275ffc8036224$var$listItemPrefixWhitespaceConstruct = {
    tokenize: $9d2275ffc8036224$var$tokenizeListItemPrefixWhitespace,
    partial: true
};
/** @type {Construct} */ const $9d2275ffc8036224$var$indentConstruct = {
    tokenize: $9d2275ffc8036224$var$tokenizeIndent,
    partial: true
};
// To do: `markdown-rs` parses list items on their own and later stitches them
// together.
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $9d2275ffc8036224$var$tokenizeListStart(effects, ok, nok) {
    const self = this;
    const tail = self.events[self.events.length - 1];
    let initialSize = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        const kind = self.containerState.type || (code === 42 || code === 43 || code === 45 ? "listUnordered" : "listOrdered");
        if (kind === "listUnordered" ? !self.containerState.marker || code === self.containerState.marker : (0, $fc9672c731708cc1$export$ca8b5b1a6c320e6e)(code)) {
            if (!self.containerState.type) {
                self.containerState.type = kind;
                effects.enter(kind, {
                    _container: true
                });
            }
            if (kind === "listUnordered") {
                effects.enter("listItemPrefix");
                return code === 42 || code === 45 ? effects.check((0, $b0a6b81550e558dc$export$ba7b13e047416c03), nok, atMarker)(code) : atMarker(code);
            }
            if (!self.interrupt || code === 49) {
                effects.enter("listItemPrefix");
                effects.enter("listItemValue");
                return inside(code);
            }
        }
        return nok(code);
    }
    /** @type {State} */ function inside(code) {
        if ((0, $fc9672c731708cc1$export$ca8b5b1a6c320e6e)(code) && ++size < 10) {
            effects.consume(code);
            return inside;
        }
        if ((!self.interrupt || size < 2) && (self.containerState.marker ? code === self.containerState.marker : code === 41 || code === 46)) {
            effects.exit("listItemValue");
            return atMarker(code);
        }
        return nok(code);
    }
    /**
   * @type {State}
   **/ function atMarker(code) {
        effects.enter("listItemMarker");
        effects.consume(code);
        effects.exit("listItemMarker");
        self.containerState.marker = self.containerState.marker || code;
        return effects.check((0, $ec58cd122e396498$export$d50d28ce3ab2a612), // Can’t be empty when interrupting.
        self.interrupt ? nok : onBlank, effects.attempt($9d2275ffc8036224$var$listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix));
    }
    /** @type {State} */ function onBlank(code) {
        self.containerState.initialBlankLine = true;
        initialSize++;
        return endOfPrefix(code);
    }
    /** @type {State} */ function otherPrefix(code) {
        if ((0, $fc9672c731708cc1$export$2c6cf65c1127992a)(code)) {
            effects.enter("listItemPrefixWhitespace");
            effects.consume(code);
            effects.exit("listItemPrefixWhitespace");
            return endOfPrefix;
        }
        return nok(code);
    }
    /** @type {State} */ function endOfPrefix(code) {
        self.containerState.size = initialSize + self.sliceSerialize(effects.exit("listItemPrefix"), true).length;
        return ok(code);
    }
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $9d2275ffc8036224$var$tokenizeListContinuation(effects, ok, nok) {
    const self = this;
    self.containerState._closeFlow = undefined;
    return effects.check((0, $ec58cd122e396498$export$d50d28ce3ab2a612), onBlank, notBlank);
    /** @type {State} */ function onBlank(code) {
        self.containerState.furtherBlankLines = self.containerState.furtherBlankLines || self.containerState.initialBlankLine;
        // We have a blank line.
        // Still, try to consume at most the items size.
        return (0, $048e24d1164dbff0$export$ae105c1eb063a0a2)(effects, ok, "listItemIndent", self.containerState.size + 1)(code);
    }
    /** @type {State} */ function notBlank(code) {
        if (self.containerState.furtherBlankLines || !(0, $fc9672c731708cc1$export$2c6cf65c1127992a)(code)) {
            self.containerState.furtherBlankLines = undefined;
            self.containerState.initialBlankLine = undefined;
            return notInCurrentItem(code);
        }
        self.containerState.furtherBlankLines = undefined;
        self.containerState.initialBlankLine = undefined;
        return effects.attempt($9d2275ffc8036224$var$indentConstruct, ok, notInCurrentItem)(code);
    }
    /** @type {State} */ function notInCurrentItem(code) {
        // While we do continue, we signal that the flow should be closed.
        self.containerState._closeFlow = true;
        // As we’re closing flow, we’re no longer interrupting.
        self.interrupt = undefined;
        // Always populated by defaults.
        return (0, $048e24d1164dbff0$export$ae105c1eb063a0a2)(effects, effects.attempt($9d2275ffc8036224$export$8837f4fc672e936d, ok, nok), "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code);
    }
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $9d2275ffc8036224$var$tokenizeIndent(effects, ok, nok) {
    const self = this;
    return (0, $048e24d1164dbff0$export$ae105c1eb063a0a2)(effects, afterPrefix, "listItemIndent", self.containerState.size + 1);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "listItemIndent" && tail[2].sliceSerialize(tail[1], true).length === self.containerState.size ? ok(code) : nok(code);
    }
}
/**
 * @type {Exiter}
 * @this {TokenizeContext}
 */ function $9d2275ffc8036224$var$tokenizeListEnd(effects) {
    effects.exit(this.containerState.type);
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $9d2275ffc8036224$var$tokenizeListItemPrefixWhitespace(effects, ok, nok) {
    const self = this;
    // Always populated by defaults.
    return (0, $048e24d1164dbff0$export$ae105c1eb063a0a2)(effects, afterPrefix, "listItemPrefixWhitespace", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 5);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return !(0, $fc9672c731708cc1$export$2c6cf65c1127992a)(code) && tail && tail[1].type === "listItemPrefixWhitespace" ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $ba63f97097a04927$export$200dcd0a5903c968 = {
    name: "blockQuote",
    tokenize: $ba63f97097a04927$var$tokenizeBlockQuoteStart,
    continuation: {
        tokenize: $ba63f97097a04927$var$tokenizeBlockQuoteContinuation
    },
    exit: $ba63f97097a04927$var$exit
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $ba63f97097a04927$var$tokenizeBlockQuoteStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of block quote.
   *
   * ```markdown
   * > | > a
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 62) {
            const state = self.containerState;
            if (!state.open) {
                effects.enter("blockQuote", {
                    _container: true
                });
                state.open = true;
            }
            effects.enter("blockQuotePrefix");
            effects.enter("blockQuoteMarker");
            effects.consume(code);
            effects.exit("blockQuoteMarker");
            return after;
        }
        return nok(code);
    }
    /**
   * After `>`, before optional whitespace.
   *
   * ```markdown
   * > | > a
   *      ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if ((0, $fc9672c731708cc1$export$2c6cf65c1127992a)(code)) {
            effects.enter("blockQuotePrefixWhitespace");
            effects.consume(code);
            effects.exit("blockQuotePrefixWhitespace");
            effects.exit("blockQuotePrefix");
            return ok;
        }
        effects.exit("blockQuotePrefix");
        return ok(code);
    }
}
/**
 * Start of block quote continuation.
 *
 * ```markdown
 *   | > a
 * > | > b
 *     ^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $ba63f97097a04927$var$tokenizeBlockQuoteContinuation(effects, ok, nok) {
    const self = this;
    return contStart;
    /**
   * Start of block quote continuation.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contStart(code) {
        if ((0, $fc9672c731708cc1$export$2c6cf65c1127992a)(code)) // Always populated by defaults.
        return (0, $048e24d1164dbff0$export$ae105c1eb063a0a2)(effects, contBefore, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code);
        return contBefore(code);
    }
    /**
   * At `>`, after optional whitespace.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contBefore(code) {
        return effects.attempt($ba63f97097a04927$export$200dcd0a5903c968, ok, nok)(code);
    }
}
/** @type {Exiter} */ function $ba63f97097a04927$var$exit(effects) {
    effects.exit("blockQuote");
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 
function $f6170ccff5f40987$export$2e6c8deaa96af245(effects, ok, nok, type, literalType, literalMarkerType, rawType, stringType, max) {
    const limit = max || Number.POSITIVE_INFINITY;
    let balance = 0;
    return start;
    /**
   * Start of destination.
   *
   * ```markdown
   * > | <aa>
   *     ^
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 60) {
            effects.enter(type);
            effects.enter(literalType);
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            return enclosedBefore;
        }
        // ASCII control, space, closing paren.
        if (code === null || code === 32 || code === 41 || (0, $fc9672c731708cc1$export$67dbf494fc8394df)(code)) return nok(code);
        effects.enter(type);
        effects.enter(rawType);
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return raw(code);
    }
    /**
   * After `<`, at an enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosedBefore(code) {
        if (code === 62) {
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            effects.exit(literalType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return enclosed(code);
    }
    /**
   * In enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosed(code) {
        if (code === 62) {
            effects.exit("chunkString");
            effects.exit(stringType);
            return enclosedBefore(code);
        }
        if (code === null || code === 60 || (0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? enclosedEscape : enclosed;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | <a\*a>
   *        ^
   * ```
   *
   * @type {State}
   */ function enclosedEscape(code) {
        if (code === 60 || code === 62 || code === 92) {
            effects.consume(code);
            return enclosed;
        }
        return enclosed(code);
    }
    /**
   * In raw destination.
   *
   * ```markdown
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function raw(code) {
        if (!balance && (code === null || code === 41 || (0, $fc9672c731708cc1$export$a30284361b3814b7)(code))) {
            effects.exit("chunkString");
            effects.exit(stringType);
            effects.exit(rawType);
            effects.exit(type);
            return ok(code);
        }
        if (balance < limit && code === 40) {
            effects.consume(code);
            balance++;
            return raw;
        }
        if (code === 41) {
            effects.consume(code);
            balance--;
            return raw;
        }
        // ASCII control (but *not* `\0`) and space and `(`.
        // Note: in `markdown-rs`, `\0` exists in codes, in `micromark-js` it
        // doesn’t.
        if (code === null || code === 32 || code === 40 || (0, $fc9672c731708cc1$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? rawEscape : raw;
    }
    /**
   * After `\`, at special character.
   *
   * ```markdown
   * > | a\*a
   *       ^
   * ```
   *
   * @type {State}
   */ function rawEscape(code) {
        if (code === 40 || code === 41 || code === 92) {
            effects.consume(code);
            return raw;
        }
        return raw(code);
    }
}


/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 
function $dae414fe47944717$export$7b768614d8ba97a7(effects, ok, nok, type, markerType, stringType) {
    const self = this;
    let size = 0;
    /** @type {boolean} */ let seen;
    return start;
    /**
   * Start of label.
   *
   * ```markdown
   * > | [a]
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        effects.enter(stringType);
        return atBreak;
    }
    /**
   * In label, at something, before something else.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (size > 999 || code === null || code === 91 || code === 93 && !seen || // To do: remove in the future once we’ve switched from
        // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
        // which doesn’t need this.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ code === 94 && !size && "_hiddenFootnoteSupport" in self.parser.constructs) return nok(code);
        if (code === 93) {
            effects.exit(stringType);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        // To do: indent? Link chunks and EOLs together?
        if ((0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return atBreak;
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return labelInside(code);
    }
    /**
   * In label, in text.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function labelInside(code) {
        if (code === null || code === 91 || code === 93 || (0, $fc9672c731708cc1$export$34a1dff1c0936953)(code) || size++ > 999) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        if (!seen) seen = !(0, $fc9672c731708cc1$export$2c6cf65c1127992a)(code);
        return code === 92 ? labelEscape : labelInside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | [a\*a]
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return labelInside;
        }
        return labelInside(code);
    }
}



/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 

function $2fb3af385627b3ae$export$f970569cc855e483(effects, ok, nok, type, markerType, stringType) {
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of title.
   *
   * ```markdown
   * > | "a"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 34 || code === 39 || code === 40) {
            effects.enter(type);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            marker = code === 40 ? 41 : code;
            return begin;
        }
        return nok(code);
    }
    /**
   * After opening marker.
   *
   * This is also used at the closing marker.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function begin(code) {
        if (code === marker) {
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        return atBreak(code);
    }
    /**
   * At something, before something else.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.exit(stringType);
            return begin(marker);
        }
        if (code === null) return nok(code);
        // Note: blank lines can’t exist in content.
        if ((0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) {
            // To do: use `space_or_tab_eol_with_options`, connect.
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return (0, $048e24d1164dbff0$export$ae105c1eb063a0a2)(effects, atBreak, "linePrefix");
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return inside(code);
    }
    /**
   *
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker || code === null || (0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        return code === 92 ? escape : inside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | "a\*b"
   *      ^
   * ```
   *
   * @type {State}
   */ function escape(code) {
        if (code === marker || code === 92) {
            effects.consume(code);
            return inside;
        }
        return inside(code);
    }
}


/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 */ 

function $10fe82f467633c08$export$1f27bd1aa33ce173(effects, ok) {
    /** @type {boolean} */ let seen;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            seen = true;
            return start;
        }
        if ((0, $fc9672c731708cc1$export$2c6cf65c1127992a)(code)) return (0, $048e24d1164dbff0$export$ae105c1eb063a0a2)(effects, start, seen ? "linePrefix" : "lineSuffix")(code);
        return ok(code);
    }
}



/**
 * Normalize an identifier (as found in references, definitions).
 *
 * Collapses markdown whitespace, trim, and then lower- and uppercase.
 *
 * Some characters are considered “uppercase”, such as U+03F4 (`ϴ`), but if their
 * lowercase counterpart (U+03B8 (`θ`)) is uppercased will result in a different
 * uppercase character (U+0398 (`Θ`)).
 * So, to get a canonical form, we perform both lower- and uppercase.
 *
 * Using uppercase last makes sure keys will never interact with default
 * prototypal values (such as `constructor`): nothing in the prototype of
 * `Object` is uppercase.
 *
 * @param {string} value
 *   Identifier to normalize.
 * @returns {string}
 *   Normalized identifier.
 */ function $3ef6ca0a03bd4b95$export$806d55e226cfcd08(value) {
    return value// Collapse markdown whitespace.
    .replace(/[\t\n\r ]+/g, " ")// Trim.
    .replace(/^ | $/g, "")// Some characters are considered “uppercase”, but if their lowercase
    // counterpart is uppercased will result in a different uppercase
    // character.
    // Hence, to get that form, we perform both lower- and uppercase.
    // Upper case makes sure keys will not interact with default prototypal
    // methods: no method is uppercase.
    .toLowerCase().toUpperCase();
}


const $0c16db9749037080$export$69f215ed977cdb73 = {
    name: "definition",
    tokenize: $0c16db9749037080$var$tokenizeDefinition
};
/** @type {Construct} */ const $0c16db9749037080$var$titleBefore = {
    tokenize: $0c16db9749037080$var$tokenizeTitleBefore,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $0c16db9749037080$var$tokenizeDefinition(effects, ok, nok) {
    const self = this;
    /** @type {string} */ let identifier;
    return start;
    /**
   * At start of a definition.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Do not interrupt paragraphs (but do follow definitions).
        // To do: do `interrupt` the way `markdown-rs` does.
        // To do: parse whitespace the way `markdown-rs` does.
        effects.enter("definition");
        return before(code);
    }
    /**
   * After optional whitespace, at `[`.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        // To do: parse whitespace the way `markdown-rs` does.
        return (0, $dae414fe47944717$export$7b768614d8ba97a7).call(self, effects, labelAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionLabel", "definitionLabelMarker", "definitionLabelString")(code);
    }
    /**
   * After label.
   *
   * ```markdown
   * > | [a]: b "c"
   *        ^
   * ```
   *
   * @type {State}
   */ function labelAfter(code) {
        identifier = (0, $3ef6ca0a03bd4b95$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1));
        if (code === 58) {
            effects.enter("definitionMarker");
            effects.consume(code);
            effects.exit("definitionMarker");
            return markerAfter;
        }
        return nok(code);
    }
    /**
   * After marker.
   *
   * ```markdown
   * > | [a]: b "c"
   *         ^
   * ```
   *
   * @type {State}
   */ function markerAfter(code) {
        // Note: whitespace is optional.
        return (0, $fc9672c731708cc1$export$a30284361b3814b7)(code) ? (0, $10fe82f467633c08$export$1f27bd1aa33ce173)(effects, destinationBefore)(code) : destinationBefore(code);
    }
    /**
   * Before destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *          ^
   * ```
   *
   * @type {State}
   */ function destinationBefore(code) {
        return (0, $f6170ccff5f40987$export$2e6c8deaa96af245)(effects, destinationAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionDestination", "definitionDestinationLiteral", "definitionDestinationLiteralMarker", "definitionDestinationRaw", "definitionDestinationString")(code);
    }
    /**
   * After destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function destinationAfter(code) {
        return effects.attempt($0c16db9749037080$var$titleBefore, after, after)(code);
    }
    /**
   * After definition.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return (0, $fc9672c731708cc1$export$2c6cf65c1127992a)(code) ? (0, $048e24d1164dbff0$export$ae105c1eb063a0a2)(effects, afterWhitespace, "whitespace")(code) : afterWhitespace(code);
    }
    /**
   * After definition, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function afterWhitespace(code) {
        if (code === null || (0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) {
            effects.exit("definition");
            // Note: we don’t care about uniqueness.
            // It’s likely that that doesn’t happen very frequently.
            // It is more likely that it wastes precious time.
            self.parser.defined.push(identifier);
            // To do: `markdown-rs` interrupt.
            // // You’d be interrupting.
            // tokenizer.interrupt = true
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $0c16db9749037080$var$tokenizeTitleBefore(effects, ok, nok) {
    return titleBefore;
    /**
   * After destination, at whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function titleBefore(code) {
        return (0, $fc9672c731708cc1$export$a30284361b3814b7)(code) ? (0, $10fe82f467633c08$export$1f27bd1aa33ce173)(effects, beforeMarker)(code) : nok(code);
    }
    /**
   * At title.
   *
   * ```markdown
   *   | [a]: b
   * > | "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function beforeMarker(code) {
        return (0, $2fb3af385627b3ae$export$f970569cc855e483)(effects, titleAfter, nok, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(code);
    }
    /**
   * After title.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfter(code) {
        return (0, $fc9672c731708cc1$export$2c6cf65c1127992a)(code) ? (0, $048e24d1164dbff0$export$ae105c1eb063a0a2)(effects, titleAfterOptionalWhitespace, "whitespace")(code) : titleAfterOptionalWhitespace(code);
    }
    /**
   * After title, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfterOptionalWhitespace(code) {
        return code === null || (0, $fc9672c731708cc1$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $5c0982932c83eb47$export$47910b7ab28d1853 = {
    name: "codeIndented",
    tokenize: $5c0982932c83eb47$var$tokenizeCodeIndented
};
/** @type {Construct} */ const $5c0982932c83eb47$var$furtherStart = {
    tokenize: $5c0982932c83eb47$var$tokenizeFurtherStart,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $5c0982932c83eb47$var$tokenizeCodeIndented(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of code (indented).
   *
   * > **Parsing note**: it is not needed to check if this first line is a
   * > filled line (that it has a non-whitespace character), because blank lines
   * > are parsed already, so we never run into that.
   *
   * ```markdown
   * > |     aaa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: manually check if interrupting like `markdown-rs`.
        effects.enter("codeIndented");
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $048e24d1164dbff0$export$ae105c1eb063a0a2)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? atBreak(code) : nok(code);
    }
    /**
   * At a break.
   *
   * ```markdown
   * > |     aaa
   *         ^  ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === null) return after(code);
        if ((0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) return effects.attempt($5c0982932c83eb47$var$furtherStart, atBreak, after)(code);
        effects.enter("codeFlowValue");
        return inside(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   * > |     aaa
   *         ^^^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === null || (0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFlowValue");
            return atBreak(code);
        }
        effects.consume(code);
        return inside;
    }
    /** @type {State} */ function after(code) {
        effects.exit("codeIndented");
        // To do: allow interrupting like `markdown-rs`.
        // Feel free to interrupt.
        // tokenizer.interrupt = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $5c0982932c83eb47$var$tokenizeFurtherStart(effects, ok, nok) {
    const self = this;
    return furtherStart;
    /**
   * At eol, trying to parse another indent.
   *
   * ```markdown
   * > |     aaa
   *            ^
   *   |     bbb
   * ```
   *
   * @type {State}
   */ function furtherStart(code) {
        // To do: improve `lazy` / `pierce` handling.
        // If this is a lazy line, it can’t be code.
        if (self.parser.lazy[self.now().line]) return nok(code);
        if ((0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return furtherStart;
        }
        // To do: the code here in `micromark-js` is a bit different from
        // `markdown-rs` because there it can attempt spaces.
        // We can’t yet.
        //
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $048e24d1164dbff0$export$ae105c1eb063a0a2)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? ok(code) : (0, $fc9672c731708cc1$export$34a1dff1c0936953)(code) ? furtherStart(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 


const $046517131d3e5864$export$3871e9deb360695c = {
    name: "headingAtx",
    tokenize: $046517131d3e5864$var$tokenizeHeadingAtx,
    resolve: $046517131d3e5864$var$resolveHeadingAtx
};
/** @type {Resolver} */ function $046517131d3e5864$var$resolveHeadingAtx(events, context) {
    let contentEnd = events.length - 2;
    let contentStart = 3;
    /** @type {Token} */ let content;
    /** @type {Token} */ let text;
    // Prefix whitespace, part of the opening.
    if (events[contentStart][1].type === "whitespace") contentStart += 2;
    // Suffix whitespace, part of the closing.
    if (contentEnd - 2 > contentStart && events[contentEnd][1].type === "whitespace") contentEnd -= 2;
    if (events[contentEnd][1].type === "atxHeadingSequence" && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === "whitespace")) contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
    if (contentEnd > contentStart) {
        content = {
            type: "atxHeadingText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end
        };
        text = {
            type: "chunkText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end,
            contentType: "text"
        };
        (0, $f35ae38d0ff93729$export$869882364835d202)(events, contentStart, contentEnd - contentStart + 1, [
            [
                "enter",
                content,
                context
            ],
            [
                "enter",
                text,
                context
            ],
            [
                "exit",
                text,
                context
            ],
            [
                "exit",
                content,
                context
            ]
        ]);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $046517131d3e5864$var$tokenizeHeadingAtx(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of a heading (atx).
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        effects.enter("atxHeading");
        return before(code);
    }
    /**
   * After optional whitespace, at `#`.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("atxHeadingSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 35 && size++ < 6) {
            effects.consume(code);
            return sequenceOpen;
        }
        // Always at least one `#`.
        if (code === null || (0, $fc9672c731708cc1$export$a30284361b3814b7)(code)) {
            effects.exit("atxHeadingSequence");
            return atBreak(code);
        }
        return nok(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ## aa
   *       ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === 35) {
            effects.enter("atxHeadingSequence");
            return sequenceFurther(code);
        }
        if (code === null || (0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) {
            effects.exit("atxHeading");
            // To do: interrupt like `markdown-rs`.
            // // Feel free to interrupt.
            // tokenizer.interrupt = false
            return ok(code);
        }
        if ((0, $fc9672c731708cc1$export$2c6cf65c1127992a)(code)) return (0, $048e24d1164dbff0$export$ae105c1eb063a0a2)(effects, atBreak, "whitespace")(code);
        // To do: generate `data` tokens, add the `text` token later.
        // Needs edit map, see: `markdown.rs`.
        effects.enter("atxHeadingText");
        return data(code);
    }
    /**
   * In further sequence (after whitespace).
   *
   * Could be normal “visible” hashes in the heading or a final sequence.
   *
   * ```markdown
   * > | ## aa ##
   *           ^
   * ```
   *
   * @type {State}
   */ function sequenceFurther(code) {
        if (code === 35) {
            effects.consume(code);
            return sequenceFurther;
        }
        effects.exit("atxHeadingSequence");
        return atBreak(code);
    }
    /**
   * In text.
   *
   * ```markdown
   * > | ## aa
   *        ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 35 || (0, $fc9672c731708cc1$export$a30284361b3814b7)(code)) {
            effects.exit("atxHeadingText");
            return atBreak(code);
        }
        effects.consume(code);
        return data;
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $0dc87b78dd2f0e5f$export$e104e2de391dfde9 = {
    name: "setextUnderline",
    tokenize: $0dc87b78dd2f0e5f$var$tokenizeSetextUnderline,
    resolveTo: $0dc87b78dd2f0e5f$var$resolveToSetextUnderline
};
/** @type {Resolver} */ function $0dc87b78dd2f0e5f$var$resolveToSetextUnderline(events, context) {
    // To do: resolve like `markdown-rs`.
    let index = events.length;
    /** @type {number | undefined} */ let content;
    /** @type {number | undefined} */ let text;
    /** @type {number | undefined} */ let definition;
    // Find the opening of the content.
    // It’ll always exist: we don’t tokenize if it isn’t there.
    while(index--)if (events[index][0] === "enter") {
        if (events[index][1].type === "content") {
            content = index;
            break;
        }
        if (events[index][1].type === "paragraph") text = index;
    } else {
        if (events[index][1].type === "content") // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1);
        if (!definition && events[index][1].type === "definition") definition = index;
    }
    const heading = {
        type: "setextHeading",
        start: Object.assign({}, events[text][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    // Change the paragraph to setext heading text.
    events[text][1].type = "setextHeadingText";
    // If we have definitions in the content, we’ll keep on having content,
    // but we need move it.
    if (definition) {
        events.splice(text, 0, [
            "enter",
            heading,
            context
        ]);
        events.splice(definition + 1, 0, [
            "exit",
            events[content][1],
            context
        ]);
        events[content][1].end = Object.assign({}, events[definition][1].end);
    } else events[content][1] = heading;
    // Add the heading exit at the end.
    events.push([
        "exit",
        heading,
        context
    ]);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $0dc87b78dd2f0e5f$var$tokenizeSetextUnderline(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * At start of heading (setext) underline.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        let index = self.events.length;
        /** @type {boolean | undefined} */ let paragraph;
        // Find an opening.
        while(index--)// Skip enter/exit of line ending, line prefix, and content.
        // We can now either have a definition or a paragraph.
        if (self.events[index][1].type !== "lineEnding" && self.events[index][1].type !== "linePrefix" && self.events[index][1].type !== "content") {
            paragraph = self.events[index][1].type === "paragraph";
            break;
        }
        // To do: handle lazy/pierce like `markdown-rs`.
        // To do: parse indent like `markdown-rs`.
        if (!self.parser.lazy[self.now().line] && (self.interrupt || paragraph)) {
            effects.enter("setextHeadingLine");
            marker = code;
            return before(code);
        }
        return nok(code);
    }
    /**
   * After optional whitespace, at `-` or `=`.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("setextHeadingLineSequence");
        return inside(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        effects.exit("setextHeadingLineSequence");
        return (0, $fc9672c731708cc1$export$2c6cf65c1127992a)(code) ? (0, $048e24d1164dbff0$export$ae105c1eb063a0a2)(effects, after, "lineSuffix")(code) : after(code);
    }
    /**
   * After sequence, after optional whitespace.
   *
   * ```markdown
   *   | aa
   * > | ==
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if (code === null || (0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) {
            effects.exit("setextHeadingLine");
            return ok(code);
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
/**
 * List of lowercase HTML “block” tag names.
 *
 * The list, when parsing HTML (flow), results in more relaxed rules (condition
 * 6).
 * Because they are known blocks, the HTML-like syntax doesn’t have to be
 * strictly parsed.
 * For tag names not in this list, a more strict algorithm (condition 7) is used
 * to detect whether the HTML-like syntax is seen as HTML (flow) or not.
 *
 * This is copied from:
 * <https://spec.commonmark.org/0.30/#html-blocks>.
 *
 * > 👉 **Note**: `search` was added in `CommonMark@0.31`.
 */ const $ae37e43fcb53106b$export$7364aee1c59d1879 = [
    "address",
    "article",
    "aside",
    "base",
    "basefont",
    "blockquote",
    "body",
    "caption",
    "center",
    "col",
    "colgroup",
    "dd",
    "details",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "frame",
    "frameset",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hr",
    "html",
    "iframe",
    "legend",
    "li",
    "link",
    "main",
    "menu",
    "menuitem",
    "nav",
    "noframes",
    "ol",
    "optgroup",
    "option",
    "p",
    "param",
    "search",
    "section",
    "summary",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "title",
    "tr",
    "track",
    "ul"
];
const $ae37e43fcb53106b$export$948e66da505d080 = [
    "pre",
    "script",
    "style",
    "textarea"
];



const $bdc188be0bb97958$export$476ac411cb7d0d8f = {
    name: "htmlFlow",
    tokenize: $bdc188be0bb97958$var$tokenizeHtmlFlow,
    resolveTo: $bdc188be0bb97958$var$resolveToHtmlFlow,
    concrete: true
};
/** @type {Construct} */ const $bdc188be0bb97958$var$blankLineBefore = {
    tokenize: $bdc188be0bb97958$var$tokenizeBlankLineBefore,
    partial: true
};
const $bdc188be0bb97958$var$nonLazyContinuationStart = {
    tokenize: $bdc188be0bb97958$var$tokenizeNonLazyContinuationStart,
    partial: true
};
/** @type {Resolver} */ function $bdc188be0bb97958$var$resolveToHtmlFlow(events) {
    let index = events.length;
    while(index--){
        if (events[index][0] === "enter" && events[index][1].type === "htmlFlow") break;
    }
    if (index > 1 && events[index - 2][1].type === "linePrefix") {
        // Add the prefix start to the HTML token.
        events[index][1].start = events[index - 2][1].start;
        // Add the prefix start to the HTML line token.
        events[index + 1][1].start = events[index - 2][1].start;
        // Remove the line prefix.
        events.splice(index - 2, 2);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $bdc188be0bb97958$var$tokenizeHtmlFlow(effects, ok, nok) {
    const self = this;
    /** @type {number} */ let marker;
    /** @type {boolean} */ let closingTag;
    /** @type {string} */ let buffer;
    /** @type {number} */ let index;
    /** @type {Code} */ let markerB;
    return start;
    /**
   * Start of HTML (flow).
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * At `<`, after optional whitespace.
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("htmlFlow");
        effects.enter("htmlFlowData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | <x />
   *      ^
   * > | <!doctype>
   *      ^
   * > | <!--xxx-->
   *      ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            closingTag = true;
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            marker = 3;
            // To do:
            // tokenizer.concrete = true
            // To do: use `markdown-rs` style interrupt.
            // While we’re in an instruction instead of a declaration, we’re on a `?`
            // right now, so we do need to search for `>`, similar to declarations.
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        // ASCII alphabetical.
        if ((0, $fc9672c731708cc1$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | <!doctype>
   *       ^
   * > | <!--xxx-->
   *       ^
   * > | <![CDATA[>&<]]>
   *       ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            marker = 2;
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            marker = 5;
            index = 0;
            return cdataOpenInside;
        }
        // ASCII alphabetical.
        if ((0, $fc9672c731708cc1$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            marker = 4;
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<!-`, inside a comment, at another `-`.
   *
   * ```markdown
   * > | <!--xxx-->
   *        ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<![`, inside CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *        ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            if (index === value.length) // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
            return cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | </x>
   *       ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        if ((0, $fc9672c731708cc1$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * In tag name.
   *
   * ```markdown
   * > | <ab>
   *      ^^
   * > | </ab>
   *       ^^
   * ```
   *
   * @type {State}
   */ function tagName(code) {
        if (code === null || code === 47 || code === 62 || (0, $fc9672c731708cc1$export$a30284361b3814b7)(code)) {
            const slash = code === 47;
            const name = buffer.toLowerCase();
            if (!slash && !closingTag && (0, $ae37e43fcb53106b$export$948e66da505d080).includes(name)) {
                marker = 1;
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            if ((0, $ae37e43fcb53106b$export$7364aee1c59d1879).includes(buffer.toLowerCase())) {
                marker = 6;
                if (slash) {
                    effects.consume(code);
                    return basicSelfClosing;
                }
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            marker = 7;
            // Do not support complete HTML when interrupting.
            return self.interrupt && !self.parser.lazy[self.now().line] ? nok(code) : closingTag ? completeClosingTagAfter(code) : completeAttributeNameBefore(code);
        }
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $fc9672c731708cc1$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            buffer += String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After closing slash of a basic tag name.
   *
   * ```markdown
   * > | <div/>
   *          ^
   * ```
   *
   * @type {State}
   */ function basicSelfClosing(code) {
        if (code === 62) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
        }
        return nok(code);
    }
    /**
   * After closing slash of a complete tag name.
   *
   * ```markdown
   * > | <x/>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeClosingTagAfter(code) {
        if ((0, $fc9672c731708cc1$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeClosingTagAfter;
        }
        return completeEnd(code);
    }
    /**
   * At an attribute name.
   *
   * At first, this state is used after a complete tag name, after whitespace,
   * where it expects optional attributes or the end of the tag.
   * It is also reused after attributes, when expecting more optional
   * attributes.
   *
   * ```markdown
   * > | <a />
   *        ^
   * > | <a :b>
   *        ^
   * > | <a _b>
   *        ^
   * > | <a b>
   *        ^
   * > | <a >
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameBefore(code) {
        if (code === 47) {
            effects.consume(code);
            return completeEnd;
        }
        // ASCII alphanumerical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $fc9672c731708cc1$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        if ((0, $fc9672c731708cc1$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameBefore;
        }
        return completeEnd(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | <a :b>
   *         ^
   * > | <a _b>
   *         ^
   * > | <a b>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeName(code) {
        // ASCII alphanumerical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $fc9672c731708cc1$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        return completeAttributeNameAfter(code);
    }
    /**
   * After attribute name, at an optional initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | <a b>
   *         ^
   * > | <a b=c>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        if ((0, $fc9672c731708cc1$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameAfter;
        }
        return completeAttributeNameBefore(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * > | <a b="c">
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            markerB = code;
            return completeAttributeValueQuoted;
        }
        if ((0, $fc9672c731708cc1$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        return completeAttributeValueUnquoted(code);
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | <a b="c">
   *           ^
   * > | <a b='c'>
   *           ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuoted(code) {
        if (code === markerB) {
            effects.consume(code);
            markerB = null;
            return completeAttributeValueQuotedAfter;
        }
        if (code === null || (0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return completeAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 47 || code === 60 || code === 61 || code === 62 || code === 96 || (0, $fc9672c731708cc1$export$a30284361b3814b7)(code)) return completeAttributeNameAfter(code);
        effects.consume(code);
        return completeAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the
   * end of the tag.
   *
   * ```markdown
   * > | <a b="c">
   *            ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $fc9672c731708cc1$export$2c6cf65c1127992a)(code)) return completeAttributeNameBefore(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a complete tag where only an `>` is allowed.
   *
   * ```markdown
   * > | <a b="c">
   *             ^
   * ```
   *
   * @type {State}
   */ function completeEnd(code) {
        if (code === 62) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * After `>` in a complete tag.
   *
   * ```markdown
   * > | <x>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAfter(code) {
        if (code === null || (0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) // // Do not form containers.
        // tokenizer.concrete = true
        return continuation(code);
        if ((0, $fc9672c731708cc1$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * In continuation of any HTML kind.
   *
   * ```markdown
   * > | <!--xxx-->
   *          ^
   * ```
   *
   * @type {State}
   */ function continuation(code) {
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationCommentInside;
        }
        if (code === 60 && marker === 1) {
            effects.consume(code);
            return continuationRawTagOpen;
        }
        if (code === 62 && marker === 4) {
            effects.consume(code);
            return continuationClose;
        }
        if (code === 63 && marker === 3) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        if (code === 93 && marker === 5) {
            effects.consume(code);
            return continuationCdataInside;
        }
        if ((0, $fc9672c731708cc1$export$34a1dff1c0936953)(code) && (marker === 6 || marker === 7)) {
            effects.exit("htmlFlowData");
            return effects.check($bdc188be0bb97958$var$blankLineBefore, continuationAfter, continuationStart)(code);
        }
        if (code === null || (0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) {
            effects.exit("htmlFlowData");
            return continuationStart(code);
        }
        effects.consume(code);
        return continuation;
    }
    /**
   * In continuation, at eol.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStart(code) {
        return effects.check($bdc188be0bb97958$var$nonLazyContinuationStart, continuationStartNonLazy, continuationAfter)(code);
    }
    /**
   * In continuation, at eol, before non-lazy content.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStartNonLazy(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return continuationBefore;
    }
    /**
   * In continuation, before non-lazy content.
   *
   * ```markdown
   *   | <x>
   * > | asd
   *     ^
   * ```
   *
   * @type {State}
   */ function continuationBefore(code) {
        if (code === null || (0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) return continuationStart(code);
        effects.enter("htmlFlowData");
        return continuation(code);
    }
    /**
   * In comment continuation, after one `-`, expecting another.
   *
   * ```markdown
   * > | <!--xxx-->
   *             ^
   * ```
   *
   * @type {State}
   */ function continuationCommentInside(code) {
        if (code === 45) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `<`, at `/`.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                            ^
   * ```
   *
   * @type {State}
   */ function continuationRawTagOpen(code) {
        if (code === 47) {
            effects.consume(code);
            buffer = "";
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `</`, in a raw tag name.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                             ^^^^^^
   * ```
   *
   * @type {State}
   */ function continuationRawEndTag(code) {
        if (code === 62) {
            const name = buffer.toLowerCase();
            if ((0, $ae37e43fcb53106b$export$948e66da505d080).includes(name)) {
                effects.consume(code);
                return continuationClose;
            }
            return continuation(code);
        }
        if ((0, $fc9672c731708cc1$export$d65d6b62c24d5436)(code) && buffer.length < 8) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer += String.fromCharCode(code);
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In cdata continuation, after `]`, expecting `]>`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *                  ^
   * ```
   *
   * @type {State}
   */ function continuationCdataInside(code) {
        if (code === 93) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In declaration or instruction continuation, at `>`.
   *
   * ```markdown
   * > | <!-->
   *         ^
   * > | <?>
   *       ^
   * > | <!q>
   *        ^
   * > | <!--ab-->
   *             ^
   * > | <![CDATA[>&<]]>
   *                   ^
   * ```
   *
   * @type {State}
   */ function continuationDeclarationInside(code) {
        if (code === 62) {
            effects.consume(code);
            return continuationClose;
        }
        // More dashes.
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In closed continuation: everything we get until the eol/eof is part of it.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationClose(code) {
        if (code === null || (0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) {
            effects.exit("htmlFlowData");
            return continuationAfter(code);
        }
        effects.consume(code);
        return continuationClose;
    }
    /**
   * Done.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationAfter(code) {
        effects.exit("htmlFlow");
        // // Feel free to interrupt.
        // tokenizer.interrupt = false
        // // No longer concrete.
        // tokenizer.concrete = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $bdc188be0bb97958$var$tokenizeNonLazyContinuationStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * At eol, before continuation.
   *
   * ```markdown
   * > | * ```js
   *            ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        if ((0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return after;
        }
        return nok(code);
    }
    /**
   * A continuation.
   *
   * ```markdown
   *   | * ```js
   * > | b
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $bdc188be0bb97958$var$tokenizeBlankLineBefore(effects, ok, nok) {
    return start;
    /**
   * Before eol, expecting blank line.
   *
   * ```markdown
   * > | <div>
   *          ^
   *   |
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return effects.attempt((0, $ec58cd122e396498$export$d50d28ce3ab2a612), ok, nok);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

/** @type {Construct} */ const $5059684b0e990637$var$nonLazyContinuation = {
    tokenize: $5059684b0e990637$var$tokenizeNonLazyContinuation,
    partial: true
};
const $5059684b0e990637$export$c23e4921f8d87e7c = {
    name: "codeFenced",
    tokenize: $5059684b0e990637$var$tokenizeCodeFenced,
    concrete: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $5059684b0e990637$var$tokenizeCodeFenced(effects, ok, nok) {
    const self = this;
    /** @type {Construct} */ const closeStart = {
        tokenize: tokenizeCloseStart,
        partial: true
    };
    let initialPrefix = 0;
    let sizeOpen = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of code.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse whitespace like `markdown-rs`.
        return beforeSequenceOpen(code);
    }
    /**
   * In opening fence, after prefix, at sequence.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeSequenceOpen(code) {
        const tail = self.events[self.events.length - 1];
        initialPrefix = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
        marker = code;
        effects.enter("codeFenced");
        effects.enter("codeFencedFence");
        effects.enter("codeFencedFenceSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening fence sequence.
   *
   * ```markdown
   * > | ~~~js
   *      ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === marker) {
            sizeOpen++;
            effects.consume(code);
            return sequenceOpen;
        }
        if (sizeOpen < 3) return nok(code);
        effects.exit("codeFencedFenceSequence");
        return (0, $fc9672c731708cc1$export$2c6cf65c1127992a)(code) ? (0, $048e24d1164dbff0$export$ae105c1eb063a0a2)(effects, infoBefore, "whitespace")(code) : infoBefore(code);
    }
    /**
   * In opening fence, after the sequence (and optional whitespace), before info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function infoBefore(code) {
        if (code === null || (0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFencedFence");
            return self.interrupt ? ok(code) : effects.check($5059684b0e990637$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        }
        effects.enter("codeFencedFenceInfo");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return info(code);
    }
    /**
   * In info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function info(code) {
        if (code === null || (0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return infoBefore(code);
        }
        if ((0, $fc9672c731708cc1$export$2c6cf65c1127992a)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return (0, $048e24d1164dbff0$export$ae105c1eb063a0a2)(effects, metaBefore, "whitespace")(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return info;
    }
    /**
   * In opening fence, after info and whitespace, before meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function metaBefore(code) {
        if (code === null || (0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) return infoBefore(code);
        effects.enter("codeFencedFenceMeta");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return meta(code);
    }
    /**
   * In meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function meta(code) {
        if (code === null || (0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceMeta");
            return infoBefore(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return meta;
    }
    /**
   * At eol/eof in code, before a non-lazy closing fence or content.
   *
   * ```markdown
   * > | ~~~js
   *          ^
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function atNonLazyBreak(code) {
        return effects.attempt(closeStart, after, contentBefore)(code);
    }
    /**
   * Before code content, not a closing fence, at eol.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentBefore(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return contentStart;
    }
    /**
   * Before code content, not a closing fence.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentStart(code) {
        return initialPrefix > 0 && (0, $fc9672c731708cc1$export$2c6cf65c1127992a)(code) ? (0, $048e24d1164dbff0$export$ae105c1eb063a0a2)(effects, beforeContentChunk, "linePrefix", initialPrefix + 1)(code) : beforeContentChunk(code);
    }
    /**
   * Before code content, after optional prefix.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeContentChunk(code) {
        if (code === null || (0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) return effects.check($5059684b0e990637$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        effects.enter("codeFlowValue");
        return contentChunk(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^^^^^^^^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentChunk(code) {
        if (code === null || (0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFlowValue");
            return beforeContentChunk(code);
        }
        effects.consume(code);
        return contentChunk;
    }
    /**
   * After code.
   *
   * ```markdown
   *   | ~~~js
   *   | alert(1)
   * > | ~~~
   *        ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        effects.exit("codeFenced");
        return ok(code);
    }
    /**
   * @this {TokenizeContext}
   * @type {Tokenizer}
   */ function tokenizeCloseStart(effects, ok, nok) {
        let size = 0;
        return startBefore;
        /**
     *
     *
     * @type {State}
     */ function startBefore(code) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return start;
        }
        /**
     * Before closing fence, at optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function start(code) {
            // Always populated by defaults.
            // To do: `enter` here or in next state?
            effects.enter("codeFencedFence");
            return (0, $fc9672c731708cc1$export$2c6cf65c1127992a)(code) ? (0, $048e24d1164dbff0$export$ae105c1eb063a0a2)(effects, beforeSequenceClose, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code) : beforeSequenceClose(code);
        }
        /**
     * In closing fence, after optional whitespace, at sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function beforeSequenceClose(code) {
            if (code === marker) {
                effects.enter("codeFencedFenceSequence");
                return sequenceClose(code);
            }
            return nok(code);
        }
        /**
     * In closing fence sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function sequenceClose(code) {
            if (code === marker) {
                size++;
                effects.consume(code);
                return sequenceClose;
            }
            if (size >= sizeOpen) {
                effects.exit("codeFencedFenceSequence");
                return (0, $fc9672c731708cc1$export$2c6cf65c1127992a)(code) ? (0, $048e24d1164dbff0$export$ae105c1eb063a0a2)(effects, sequenceCloseAfter, "whitespace")(code) : sequenceCloseAfter(code);
            }
            return nok(code);
        }
        /**
     * After closing fence sequence, after optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *        ^
     * ```
     *
     * @type {State}
     */ function sequenceCloseAfter(code) {
            if (code === null || (0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) {
                effects.exit("codeFencedFence");
                return ok(code);
            }
            return nok(code);
        }
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $5059684b0e990637$var$tokenizeNonLazyContinuation(effects, ok, nok) {
    const self = this;
    return start;
    /**
   *
   *
   * @type {State}
   */ function start(code) {
        if (code === null) return nok(code);
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineStart;
    }
    /**
   *
   *
   * @type {State}
   */ function lineStart(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * Map of named character references.
 *
 * @type {Record<string, string>}
 */ const $75a937ab4ffa700e$export$ec810d1aafce79a7 = {
    AElig: "\xc6",
    AMP: "&",
    Aacute: "\xc1",
    Abreve: "\u0102",
    Acirc: "\xc2",
    Acy: "\u0410",
    Afr: "\uD835\uDD04",
    Agrave: "\xc0",
    Alpha: "\u0391",
    Amacr: "\u0100",
    And: "\u2A53",
    Aogon: "\u0104",
    Aopf: "\uD835\uDD38",
    ApplyFunction: "\u2061",
    Aring: "\xc5",
    Ascr: "\uD835\uDC9C",
    Assign: "\u2254",
    Atilde: "\xc3",
    Auml: "\xc4",
    Backslash: "\u2216",
    Barv: "\u2AE7",
    Barwed: "\u2306",
    Bcy: "\u0411",
    Because: "\u2235",
    Bernoullis: "\u212C",
    Beta: "\u0392",
    Bfr: "\uD835\uDD05",
    Bopf: "\uD835\uDD39",
    Breve: "\u02D8",
    Bscr: "\u212C",
    Bumpeq: "\u224E",
    CHcy: "\u0427",
    COPY: "\xa9",
    Cacute: "\u0106",
    Cap: "\u22D2",
    CapitalDifferentialD: "\u2145",
    Cayleys: "\u212D",
    Ccaron: "\u010C",
    Ccedil: "\xc7",
    Ccirc: "\u0108",
    Cconint: "\u2230",
    Cdot: "\u010A",
    Cedilla: "\xb8",
    CenterDot: "\xb7",
    Cfr: "\u212D",
    Chi: "\u03A7",
    CircleDot: "\u2299",
    CircleMinus: "\u2296",
    CirclePlus: "\u2295",
    CircleTimes: "\u2297",
    ClockwiseContourIntegral: "\u2232",
    CloseCurlyDoubleQuote: "\u201D",
    CloseCurlyQuote: "\u2019",
    Colon: "\u2237",
    Colone: "\u2A74",
    Congruent: "\u2261",
    Conint: "\u222F",
    ContourIntegral: "\u222E",
    Copf: "\u2102",
    Coproduct: "\u2210",
    CounterClockwiseContourIntegral: "\u2233",
    Cross: "\u2A2F",
    Cscr: "\uD835\uDC9E",
    Cup: "\u22D3",
    CupCap: "\u224D",
    DD: "\u2145",
    DDotrahd: "\u2911",
    DJcy: "\u0402",
    DScy: "\u0405",
    DZcy: "\u040F",
    Dagger: "\u2021",
    Darr: "\u21A1",
    Dashv: "\u2AE4",
    Dcaron: "\u010E",
    Dcy: "\u0414",
    Del: "\u2207",
    Delta: "\u0394",
    Dfr: "\uD835\uDD07",
    DiacriticalAcute: "\xb4",
    DiacriticalDot: "\u02D9",
    DiacriticalDoubleAcute: "\u02DD",
    DiacriticalGrave: "`",
    DiacriticalTilde: "\u02DC",
    Diamond: "\u22C4",
    DifferentialD: "\u2146",
    Dopf: "\uD835\uDD3B",
    Dot: "\xa8",
    DotDot: "\u20DC",
    DotEqual: "\u2250",
    DoubleContourIntegral: "\u222F",
    DoubleDot: "\xa8",
    DoubleDownArrow: "\u21D3",
    DoubleLeftArrow: "\u21D0",
    DoubleLeftRightArrow: "\u21D4",
    DoubleLeftTee: "\u2AE4",
    DoubleLongLeftArrow: "\u27F8",
    DoubleLongLeftRightArrow: "\u27FA",
    DoubleLongRightArrow: "\u27F9",
    DoubleRightArrow: "\u21D2",
    DoubleRightTee: "\u22A8",
    DoubleUpArrow: "\u21D1",
    DoubleUpDownArrow: "\u21D5",
    DoubleVerticalBar: "\u2225",
    DownArrow: "\u2193",
    DownArrowBar: "\u2913",
    DownArrowUpArrow: "\u21F5",
    DownBreve: "\u0311",
    DownLeftRightVector: "\u2950",
    DownLeftTeeVector: "\u295E",
    DownLeftVector: "\u21BD",
    DownLeftVectorBar: "\u2956",
    DownRightTeeVector: "\u295F",
    DownRightVector: "\u21C1",
    DownRightVectorBar: "\u2957",
    DownTee: "\u22A4",
    DownTeeArrow: "\u21A7",
    Downarrow: "\u21D3",
    Dscr: "\uD835\uDC9F",
    Dstrok: "\u0110",
    ENG: "\u014A",
    ETH: "\xd0",
    Eacute: "\xc9",
    Ecaron: "\u011A",
    Ecirc: "\xca",
    Ecy: "\u042D",
    Edot: "\u0116",
    Efr: "\uD835\uDD08",
    Egrave: "\xc8",
    Element: "\u2208",
    Emacr: "\u0112",
    EmptySmallSquare: "\u25FB",
    EmptyVerySmallSquare: "\u25AB",
    Eogon: "\u0118",
    Eopf: "\uD835\uDD3C",
    Epsilon: "\u0395",
    Equal: "\u2A75",
    EqualTilde: "\u2242",
    Equilibrium: "\u21CC",
    Escr: "\u2130",
    Esim: "\u2A73",
    Eta: "\u0397",
    Euml: "\xcb",
    Exists: "\u2203",
    ExponentialE: "\u2147",
    Fcy: "\u0424",
    Ffr: "\uD835\uDD09",
    FilledSmallSquare: "\u25FC",
    FilledVerySmallSquare: "\u25AA",
    Fopf: "\uD835\uDD3D",
    ForAll: "\u2200",
    Fouriertrf: "\u2131",
    Fscr: "\u2131",
    GJcy: "\u0403",
    GT: ">",
    Gamma: "\u0393",
    Gammad: "\u03DC",
    Gbreve: "\u011E",
    Gcedil: "\u0122",
    Gcirc: "\u011C",
    Gcy: "\u0413",
    Gdot: "\u0120",
    Gfr: "\uD835\uDD0A",
    Gg: "\u22D9",
    Gopf: "\uD835\uDD3E",
    GreaterEqual: "\u2265",
    GreaterEqualLess: "\u22DB",
    GreaterFullEqual: "\u2267",
    GreaterGreater: "\u2AA2",
    GreaterLess: "\u2277",
    GreaterSlantEqual: "\u2A7E",
    GreaterTilde: "\u2273",
    Gscr: "\uD835\uDCA2",
    Gt: "\u226B",
    HARDcy: "\u042A",
    Hacek: "\u02C7",
    Hat: "^",
    Hcirc: "\u0124",
    Hfr: "\u210C",
    HilbertSpace: "\u210B",
    Hopf: "\u210D",
    HorizontalLine: "\u2500",
    Hscr: "\u210B",
    Hstrok: "\u0126",
    HumpDownHump: "\u224E",
    HumpEqual: "\u224F",
    IEcy: "\u0415",
    IJlig: "\u0132",
    IOcy: "\u0401",
    Iacute: "\xcd",
    Icirc: "\xce",
    Icy: "\u0418",
    Idot: "\u0130",
    Ifr: "\u2111",
    Igrave: "\xcc",
    Im: "\u2111",
    Imacr: "\u012A",
    ImaginaryI: "\u2148",
    Implies: "\u21D2",
    Int: "\u222C",
    Integral: "\u222B",
    Intersection: "\u22C2",
    InvisibleComma: "\u2063",
    InvisibleTimes: "\u2062",
    Iogon: "\u012E",
    Iopf: "\uD835\uDD40",
    Iota: "\u0399",
    Iscr: "\u2110",
    Itilde: "\u0128",
    Iukcy: "\u0406",
    Iuml: "\xcf",
    Jcirc: "\u0134",
    Jcy: "\u0419",
    Jfr: "\uD835\uDD0D",
    Jopf: "\uD835\uDD41",
    Jscr: "\uD835\uDCA5",
    Jsercy: "\u0408",
    Jukcy: "\u0404",
    KHcy: "\u0425",
    KJcy: "\u040C",
    Kappa: "\u039A",
    Kcedil: "\u0136",
    Kcy: "\u041A",
    Kfr: "\uD835\uDD0E",
    Kopf: "\uD835\uDD42",
    Kscr: "\uD835\uDCA6",
    LJcy: "\u0409",
    LT: "<",
    Lacute: "\u0139",
    Lambda: "\u039B",
    Lang: "\u27EA",
    Laplacetrf: "\u2112",
    Larr: "\u219E",
    Lcaron: "\u013D",
    Lcedil: "\u013B",
    Lcy: "\u041B",
    LeftAngleBracket: "\u27E8",
    LeftArrow: "\u2190",
    LeftArrowBar: "\u21E4",
    LeftArrowRightArrow: "\u21C6",
    LeftCeiling: "\u2308",
    LeftDoubleBracket: "\u27E6",
    LeftDownTeeVector: "\u2961",
    LeftDownVector: "\u21C3",
    LeftDownVectorBar: "\u2959",
    LeftFloor: "\u230A",
    LeftRightArrow: "\u2194",
    LeftRightVector: "\u294E",
    LeftTee: "\u22A3",
    LeftTeeArrow: "\u21A4",
    LeftTeeVector: "\u295A",
    LeftTriangle: "\u22B2",
    LeftTriangleBar: "\u29CF",
    LeftTriangleEqual: "\u22B4",
    LeftUpDownVector: "\u2951",
    LeftUpTeeVector: "\u2960",
    LeftUpVector: "\u21BF",
    LeftUpVectorBar: "\u2958",
    LeftVector: "\u21BC",
    LeftVectorBar: "\u2952",
    Leftarrow: "\u21D0",
    Leftrightarrow: "\u21D4",
    LessEqualGreater: "\u22DA",
    LessFullEqual: "\u2266",
    LessGreater: "\u2276",
    LessLess: "\u2AA1",
    LessSlantEqual: "\u2A7D",
    LessTilde: "\u2272",
    Lfr: "\uD835\uDD0F",
    Ll: "\u22D8",
    Lleftarrow: "\u21DA",
    Lmidot: "\u013F",
    LongLeftArrow: "\u27F5",
    LongLeftRightArrow: "\u27F7",
    LongRightArrow: "\u27F6",
    Longleftarrow: "\u27F8",
    Longleftrightarrow: "\u27FA",
    Longrightarrow: "\u27F9",
    Lopf: "\uD835\uDD43",
    LowerLeftArrow: "\u2199",
    LowerRightArrow: "\u2198",
    Lscr: "\u2112",
    Lsh: "\u21B0",
    Lstrok: "\u0141",
    Lt: "\u226A",
    Map: "\u2905",
    Mcy: "\u041C",
    MediumSpace: "\u205F",
    Mellintrf: "\u2133",
    Mfr: "\uD835\uDD10",
    MinusPlus: "\u2213",
    Mopf: "\uD835\uDD44",
    Mscr: "\u2133",
    Mu: "\u039C",
    NJcy: "\u040A",
    Nacute: "\u0143",
    Ncaron: "\u0147",
    Ncedil: "\u0145",
    Ncy: "\u041D",
    NegativeMediumSpace: "\u200B",
    NegativeThickSpace: "\u200B",
    NegativeThinSpace: "\u200B",
    NegativeVeryThinSpace: "\u200B",
    NestedGreaterGreater: "\u226B",
    NestedLessLess: "\u226A",
    NewLine: "\n",
    Nfr: "\uD835\uDD11",
    NoBreak: "\u2060",
    NonBreakingSpace: "\xa0",
    Nopf: "\u2115",
    Not: "\u2AEC",
    NotCongruent: "\u2262",
    NotCupCap: "\u226D",
    NotDoubleVerticalBar: "\u2226",
    NotElement: "\u2209",
    NotEqual: "\u2260",
    NotEqualTilde: "\u2242\u0338",
    NotExists: "\u2204",
    NotGreater: "\u226F",
    NotGreaterEqual: "\u2271",
    NotGreaterFullEqual: "\u2267\u0338",
    NotGreaterGreater: "\u226B\u0338",
    NotGreaterLess: "\u2279",
    NotGreaterSlantEqual: "\u2A7E\u0338",
    NotGreaterTilde: "\u2275",
    NotHumpDownHump: "\u224E\u0338",
    NotHumpEqual: "\u224F\u0338",
    NotLeftTriangle: "\u22EA",
    NotLeftTriangleBar: "\u29CF\u0338",
    NotLeftTriangleEqual: "\u22EC",
    NotLess: "\u226E",
    NotLessEqual: "\u2270",
    NotLessGreater: "\u2278",
    NotLessLess: "\u226A\u0338",
    NotLessSlantEqual: "\u2A7D\u0338",
    NotLessTilde: "\u2274",
    NotNestedGreaterGreater: "\u2AA2\u0338",
    NotNestedLessLess: "\u2AA1\u0338",
    NotPrecedes: "\u2280",
    NotPrecedesEqual: "\u2AAF\u0338",
    NotPrecedesSlantEqual: "\u22E0",
    NotReverseElement: "\u220C",
    NotRightTriangle: "\u22EB",
    NotRightTriangleBar: "\u29D0\u0338",
    NotRightTriangleEqual: "\u22ED",
    NotSquareSubset: "\u228F\u0338",
    NotSquareSubsetEqual: "\u22E2",
    NotSquareSuperset: "\u2290\u0338",
    NotSquareSupersetEqual: "\u22E3",
    NotSubset: "\u2282\u20D2",
    NotSubsetEqual: "\u2288",
    NotSucceeds: "\u2281",
    NotSucceedsEqual: "\u2AB0\u0338",
    NotSucceedsSlantEqual: "\u22E1",
    NotSucceedsTilde: "\u227F\u0338",
    NotSuperset: "\u2283\u20D2",
    NotSupersetEqual: "\u2289",
    NotTilde: "\u2241",
    NotTildeEqual: "\u2244",
    NotTildeFullEqual: "\u2247",
    NotTildeTilde: "\u2249",
    NotVerticalBar: "\u2224",
    Nscr: "\uD835\uDCA9",
    Ntilde: "\xd1",
    Nu: "\u039D",
    OElig: "\u0152",
    Oacute: "\xd3",
    Ocirc: "\xd4",
    Ocy: "\u041E",
    Odblac: "\u0150",
    Ofr: "\uD835\uDD12",
    Ograve: "\xd2",
    Omacr: "\u014C",
    Omega: "\u03A9",
    Omicron: "\u039F",
    Oopf: "\uD835\uDD46",
    OpenCurlyDoubleQuote: "\u201C",
    OpenCurlyQuote: "\u2018",
    Or: "\u2A54",
    Oscr: "\uD835\uDCAA",
    Oslash: "\xd8",
    Otilde: "\xd5",
    Otimes: "\u2A37",
    Ouml: "\xd6",
    OverBar: "\u203E",
    OverBrace: "\u23DE",
    OverBracket: "\u23B4",
    OverParenthesis: "\u23DC",
    PartialD: "\u2202",
    Pcy: "\u041F",
    Pfr: "\uD835\uDD13",
    Phi: "\u03A6",
    Pi: "\u03A0",
    PlusMinus: "\xb1",
    Poincareplane: "\u210C",
    Popf: "\u2119",
    Pr: "\u2ABB",
    Precedes: "\u227A",
    PrecedesEqual: "\u2AAF",
    PrecedesSlantEqual: "\u227C",
    PrecedesTilde: "\u227E",
    Prime: "\u2033",
    Product: "\u220F",
    Proportion: "\u2237",
    Proportional: "\u221D",
    Pscr: "\uD835\uDCAB",
    Psi: "\u03A8",
    QUOT: '"',
    Qfr: "\uD835\uDD14",
    Qopf: "\u211A",
    Qscr: "\uD835\uDCAC",
    RBarr: "\u2910",
    REG: "\xae",
    Racute: "\u0154",
    Rang: "\u27EB",
    Rarr: "\u21A0",
    Rarrtl: "\u2916",
    Rcaron: "\u0158",
    Rcedil: "\u0156",
    Rcy: "\u0420",
    Re: "\u211C",
    ReverseElement: "\u220B",
    ReverseEquilibrium: "\u21CB",
    ReverseUpEquilibrium: "\u296F",
    Rfr: "\u211C",
    Rho: "\u03A1",
    RightAngleBracket: "\u27E9",
    RightArrow: "\u2192",
    RightArrowBar: "\u21E5",
    RightArrowLeftArrow: "\u21C4",
    RightCeiling: "\u2309",
    RightDoubleBracket: "\u27E7",
    RightDownTeeVector: "\u295D",
    RightDownVector: "\u21C2",
    RightDownVectorBar: "\u2955",
    RightFloor: "\u230B",
    RightTee: "\u22A2",
    RightTeeArrow: "\u21A6",
    RightTeeVector: "\u295B",
    RightTriangle: "\u22B3",
    RightTriangleBar: "\u29D0",
    RightTriangleEqual: "\u22B5",
    RightUpDownVector: "\u294F",
    RightUpTeeVector: "\u295C",
    RightUpVector: "\u21BE",
    RightUpVectorBar: "\u2954",
    RightVector: "\u21C0",
    RightVectorBar: "\u2953",
    Rightarrow: "\u21D2",
    Ropf: "\u211D",
    RoundImplies: "\u2970",
    Rrightarrow: "\u21DB",
    Rscr: "\u211B",
    Rsh: "\u21B1",
    RuleDelayed: "\u29F4",
    SHCHcy: "\u0429",
    SHcy: "\u0428",
    SOFTcy: "\u042C",
    Sacute: "\u015A",
    Sc: "\u2ABC",
    Scaron: "\u0160",
    Scedil: "\u015E",
    Scirc: "\u015C",
    Scy: "\u0421",
    Sfr: "\uD835\uDD16",
    ShortDownArrow: "\u2193",
    ShortLeftArrow: "\u2190",
    ShortRightArrow: "\u2192",
    ShortUpArrow: "\u2191",
    Sigma: "\u03A3",
    SmallCircle: "\u2218",
    Sopf: "\uD835\uDD4A",
    Sqrt: "\u221A",
    Square: "\u25A1",
    SquareIntersection: "\u2293",
    SquareSubset: "\u228F",
    SquareSubsetEqual: "\u2291",
    SquareSuperset: "\u2290",
    SquareSupersetEqual: "\u2292",
    SquareUnion: "\u2294",
    Sscr: "\uD835\uDCAE",
    Star: "\u22C6",
    Sub: "\u22D0",
    Subset: "\u22D0",
    SubsetEqual: "\u2286",
    Succeeds: "\u227B",
    SucceedsEqual: "\u2AB0",
    SucceedsSlantEqual: "\u227D",
    SucceedsTilde: "\u227F",
    SuchThat: "\u220B",
    Sum: "\u2211",
    Sup: "\u22D1",
    Superset: "\u2283",
    SupersetEqual: "\u2287",
    Supset: "\u22D1",
    THORN: "\xde",
    TRADE: "\u2122",
    TSHcy: "\u040B",
    TScy: "\u0426",
    Tab: "	",
    Tau: "\u03A4",
    Tcaron: "\u0164",
    Tcedil: "\u0162",
    Tcy: "\u0422",
    Tfr: "\uD835\uDD17",
    Therefore: "\u2234",
    Theta: "\u0398",
    ThickSpace: "\u205F\u200A",
    ThinSpace: "\u2009",
    Tilde: "\u223C",
    TildeEqual: "\u2243",
    TildeFullEqual: "\u2245",
    TildeTilde: "\u2248",
    Topf: "\uD835\uDD4B",
    TripleDot: "\u20DB",
    Tscr: "\uD835\uDCAF",
    Tstrok: "\u0166",
    Uacute: "\xda",
    Uarr: "\u219F",
    Uarrocir: "\u2949",
    Ubrcy: "\u040E",
    Ubreve: "\u016C",
    Ucirc: "\xdb",
    Ucy: "\u0423",
    Udblac: "\u0170",
    Ufr: "\uD835\uDD18",
    Ugrave: "\xd9",
    Umacr: "\u016A",
    UnderBar: "_",
    UnderBrace: "\u23DF",
    UnderBracket: "\u23B5",
    UnderParenthesis: "\u23DD",
    Union: "\u22C3",
    UnionPlus: "\u228E",
    Uogon: "\u0172",
    Uopf: "\uD835\uDD4C",
    UpArrow: "\u2191",
    UpArrowBar: "\u2912",
    UpArrowDownArrow: "\u21C5",
    UpDownArrow: "\u2195",
    UpEquilibrium: "\u296E",
    UpTee: "\u22A5",
    UpTeeArrow: "\u21A5",
    Uparrow: "\u21D1",
    Updownarrow: "\u21D5",
    UpperLeftArrow: "\u2196",
    UpperRightArrow: "\u2197",
    Upsi: "\u03D2",
    Upsilon: "\u03A5",
    Uring: "\u016E",
    Uscr: "\uD835\uDCB0",
    Utilde: "\u0168",
    Uuml: "\xdc",
    VDash: "\u22AB",
    Vbar: "\u2AEB",
    Vcy: "\u0412",
    Vdash: "\u22A9",
    Vdashl: "\u2AE6",
    Vee: "\u22C1",
    Verbar: "\u2016",
    Vert: "\u2016",
    VerticalBar: "\u2223",
    VerticalLine: "|",
    VerticalSeparator: "\u2758",
    VerticalTilde: "\u2240",
    VeryThinSpace: "\u200A",
    Vfr: "\uD835\uDD19",
    Vopf: "\uD835\uDD4D",
    Vscr: "\uD835\uDCB1",
    Vvdash: "\u22AA",
    Wcirc: "\u0174",
    Wedge: "\u22C0",
    Wfr: "\uD835\uDD1A",
    Wopf: "\uD835\uDD4E",
    Wscr: "\uD835\uDCB2",
    Xfr: "\uD835\uDD1B",
    Xi: "\u039E",
    Xopf: "\uD835\uDD4F",
    Xscr: "\uD835\uDCB3",
    YAcy: "\u042F",
    YIcy: "\u0407",
    YUcy: "\u042E",
    Yacute: "\xdd",
    Ycirc: "\u0176",
    Ycy: "\u042B",
    Yfr: "\uD835\uDD1C",
    Yopf: "\uD835\uDD50",
    Yscr: "\uD835\uDCB4",
    Yuml: "\u0178",
    ZHcy: "\u0416",
    Zacute: "\u0179",
    Zcaron: "\u017D",
    Zcy: "\u0417",
    Zdot: "\u017B",
    ZeroWidthSpace: "\u200B",
    Zeta: "\u0396",
    Zfr: "\u2128",
    Zopf: "\u2124",
    Zscr: "\uD835\uDCB5",
    aacute: "\xe1",
    abreve: "\u0103",
    ac: "\u223E",
    acE: "\u223E\u0333",
    acd: "\u223F",
    acirc: "\xe2",
    acute: "\xb4",
    acy: "\u0430",
    aelig: "\xe6",
    af: "\u2061",
    afr: "\uD835\uDD1E",
    agrave: "\xe0",
    alefsym: "\u2135",
    aleph: "\u2135",
    alpha: "\u03B1",
    amacr: "\u0101",
    amalg: "\u2A3F",
    amp: "&",
    and: "\u2227",
    andand: "\u2A55",
    andd: "\u2A5C",
    andslope: "\u2A58",
    andv: "\u2A5A",
    ang: "\u2220",
    ange: "\u29A4",
    angle: "\u2220",
    angmsd: "\u2221",
    angmsdaa: "\u29A8",
    angmsdab: "\u29A9",
    angmsdac: "\u29AA",
    angmsdad: "\u29AB",
    angmsdae: "\u29AC",
    angmsdaf: "\u29AD",
    angmsdag: "\u29AE",
    angmsdah: "\u29AF",
    angrt: "\u221F",
    angrtvb: "\u22BE",
    angrtvbd: "\u299D",
    angsph: "\u2222",
    angst: "\xc5",
    angzarr: "\u237C",
    aogon: "\u0105",
    aopf: "\uD835\uDD52",
    ap: "\u2248",
    apE: "\u2A70",
    apacir: "\u2A6F",
    ape: "\u224A",
    apid: "\u224B",
    apos: "'",
    approx: "\u2248",
    approxeq: "\u224A",
    aring: "\xe5",
    ascr: "\uD835\uDCB6",
    ast: "*",
    asymp: "\u2248",
    asympeq: "\u224D",
    atilde: "\xe3",
    auml: "\xe4",
    awconint: "\u2233",
    awint: "\u2A11",
    bNot: "\u2AED",
    backcong: "\u224C",
    backepsilon: "\u03F6",
    backprime: "\u2035",
    backsim: "\u223D",
    backsimeq: "\u22CD",
    barvee: "\u22BD",
    barwed: "\u2305",
    barwedge: "\u2305",
    bbrk: "\u23B5",
    bbrktbrk: "\u23B6",
    bcong: "\u224C",
    bcy: "\u0431",
    bdquo: "\u201E",
    becaus: "\u2235",
    because: "\u2235",
    bemptyv: "\u29B0",
    bepsi: "\u03F6",
    bernou: "\u212C",
    beta: "\u03B2",
    beth: "\u2136",
    between: "\u226C",
    bfr: "\uD835\uDD1F",
    bigcap: "\u22C2",
    bigcirc: "\u25EF",
    bigcup: "\u22C3",
    bigodot: "\u2A00",
    bigoplus: "\u2A01",
    bigotimes: "\u2A02",
    bigsqcup: "\u2A06",
    bigstar: "\u2605",
    bigtriangledown: "\u25BD",
    bigtriangleup: "\u25B3",
    biguplus: "\u2A04",
    bigvee: "\u22C1",
    bigwedge: "\u22C0",
    bkarow: "\u290D",
    blacklozenge: "\u29EB",
    blacksquare: "\u25AA",
    blacktriangle: "\u25B4",
    blacktriangledown: "\u25BE",
    blacktriangleleft: "\u25C2",
    blacktriangleright: "\u25B8",
    blank: "\u2423",
    blk12: "\u2592",
    blk14: "\u2591",
    blk34: "\u2593",
    block: "\u2588",
    bne: "=\u20E5",
    bnequiv: "\u2261\u20E5",
    bnot: "\u2310",
    bopf: "\uD835\uDD53",
    bot: "\u22A5",
    bottom: "\u22A5",
    bowtie: "\u22C8",
    boxDL: "\u2557",
    boxDR: "\u2554",
    boxDl: "\u2556",
    boxDr: "\u2553",
    boxH: "\u2550",
    boxHD: "\u2566",
    boxHU: "\u2569",
    boxHd: "\u2564",
    boxHu: "\u2567",
    boxUL: "\u255D",
    boxUR: "\u255A",
    boxUl: "\u255C",
    boxUr: "\u2559",
    boxV: "\u2551",
    boxVH: "\u256C",
    boxVL: "\u2563",
    boxVR: "\u2560",
    boxVh: "\u256B",
    boxVl: "\u2562",
    boxVr: "\u255F",
    boxbox: "\u29C9",
    boxdL: "\u2555",
    boxdR: "\u2552",
    boxdl: "\u2510",
    boxdr: "\u250C",
    boxh: "\u2500",
    boxhD: "\u2565",
    boxhU: "\u2568",
    boxhd: "\u252C",
    boxhu: "\u2534",
    boxminus: "\u229F",
    boxplus: "\u229E",
    boxtimes: "\u22A0",
    boxuL: "\u255B",
    boxuR: "\u2558",
    boxul: "\u2518",
    boxur: "\u2514",
    boxv: "\u2502",
    boxvH: "\u256A",
    boxvL: "\u2561",
    boxvR: "\u255E",
    boxvh: "\u253C",
    boxvl: "\u2524",
    boxvr: "\u251C",
    bprime: "\u2035",
    breve: "\u02D8",
    brvbar: "\xa6",
    bscr: "\uD835\uDCB7",
    bsemi: "\u204F",
    bsim: "\u223D",
    bsime: "\u22CD",
    bsol: "\\",
    bsolb: "\u29C5",
    bsolhsub: "\u27C8",
    bull: "\u2022",
    bullet: "\u2022",
    bump: "\u224E",
    bumpE: "\u2AAE",
    bumpe: "\u224F",
    bumpeq: "\u224F",
    cacute: "\u0107",
    cap: "\u2229",
    capand: "\u2A44",
    capbrcup: "\u2A49",
    capcap: "\u2A4B",
    capcup: "\u2A47",
    capdot: "\u2A40",
    caps: "\u2229\uFE00",
    caret: "\u2041",
    caron: "\u02C7",
    ccaps: "\u2A4D",
    ccaron: "\u010D",
    ccedil: "\xe7",
    ccirc: "\u0109",
    ccups: "\u2A4C",
    ccupssm: "\u2A50",
    cdot: "\u010B",
    cedil: "\xb8",
    cemptyv: "\u29B2",
    cent: "\xa2",
    centerdot: "\xb7",
    cfr: "\uD835\uDD20",
    chcy: "\u0447",
    check: "\u2713",
    checkmark: "\u2713",
    chi: "\u03C7",
    cir: "\u25CB",
    cirE: "\u29C3",
    circ: "\u02C6",
    circeq: "\u2257",
    circlearrowleft: "\u21BA",
    circlearrowright: "\u21BB",
    circledR: "\xae",
    circledS: "\u24C8",
    circledast: "\u229B",
    circledcirc: "\u229A",
    circleddash: "\u229D",
    cire: "\u2257",
    cirfnint: "\u2A10",
    cirmid: "\u2AEF",
    cirscir: "\u29C2",
    clubs: "\u2663",
    clubsuit: "\u2663",
    colon: ":",
    colone: "\u2254",
    coloneq: "\u2254",
    comma: ",",
    commat: "@",
    comp: "\u2201",
    compfn: "\u2218",
    complement: "\u2201",
    complexes: "\u2102",
    cong: "\u2245",
    congdot: "\u2A6D",
    conint: "\u222E",
    copf: "\uD835\uDD54",
    coprod: "\u2210",
    copy: "\xa9",
    copysr: "\u2117",
    crarr: "\u21B5",
    cross: "\u2717",
    cscr: "\uD835\uDCB8",
    csub: "\u2ACF",
    csube: "\u2AD1",
    csup: "\u2AD0",
    csupe: "\u2AD2",
    ctdot: "\u22EF",
    cudarrl: "\u2938",
    cudarrr: "\u2935",
    cuepr: "\u22DE",
    cuesc: "\u22DF",
    cularr: "\u21B6",
    cularrp: "\u293D",
    cup: "\u222A",
    cupbrcap: "\u2A48",
    cupcap: "\u2A46",
    cupcup: "\u2A4A",
    cupdot: "\u228D",
    cupor: "\u2A45",
    cups: "\u222A\uFE00",
    curarr: "\u21B7",
    curarrm: "\u293C",
    curlyeqprec: "\u22DE",
    curlyeqsucc: "\u22DF",
    curlyvee: "\u22CE",
    curlywedge: "\u22CF",
    curren: "\xa4",
    curvearrowleft: "\u21B6",
    curvearrowright: "\u21B7",
    cuvee: "\u22CE",
    cuwed: "\u22CF",
    cwconint: "\u2232",
    cwint: "\u2231",
    cylcty: "\u232D",
    dArr: "\u21D3",
    dHar: "\u2965",
    dagger: "\u2020",
    daleth: "\u2138",
    darr: "\u2193",
    dash: "\u2010",
    dashv: "\u22A3",
    dbkarow: "\u290F",
    dblac: "\u02DD",
    dcaron: "\u010F",
    dcy: "\u0434",
    dd: "\u2146",
    ddagger: "\u2021",
    ddarr: "\u21CA",
    ddotseq: "\u2A77",
    deg: "\xb0",
    delta: "\u03B4",
    demptyv: "\u29B1",
    dfisht: "\u297F",
    dfr: "\uD835\uDD21",
    dharl: "\u21C3",
    dharr: "\u21C2",
    diam: "\u22C4",
    diamond: "\u22C4",
    diamondsuit: "\u2666",
    diams: "\u2666",
    die: "\xa8",
    digamma: "\u03DD",
    disin: "\u22F2",
    div: "\xf7",
    divide: "\xf7",
    divideontimes: "\u22C7",
    divonx: "\u22C7",
    djcy: "\u0452",
    dlcorn: "\u231E",
    dlcrop: "\u230D",
    dollar: "$",
    dopf: "\uD835\uDD55",
    dot: "\u02D9",
    doteq: "\u2250",
    doteqdot: "\u2251",
    dotminus: "\u2238",
    dotplus: "\u2214",
    dotsquare: "\u22A1",
    doublebarwedge: "\u2306",
    downarrow: "\u2193",
    downdownarrows: "\u21CA",
    downharpoonleft: "\u21C3",
    downharpoonright: "\u21C2",
    drbkarow: "\u2910",
    drcorn: "\u231F",
    drcrop: "\u230C",
    dscr: "\uD835\uDCB9",
    dscy: "\u0455",
    dsol: "\u29F6",
    dstrok: "\u0111",
    dtdot: "\u22F1",
    dtri: "\u25BF",
    dtrif: "\u25BE",
    duarr: "\u21F5",
    duhar: "\u296F",
    dwangle: "\u29A6",
    dzcy: "\u045F",
    dzigrarr: "\u27FF",
    eDDot: "\u2A77",
    eDot: "\u2251",
    eacute: "\xe9",
    easter: "\u2A6E",
    ecaron: "\u011B",
    ecir: "\u2256",
    ecirc: "\xea",
    ecolon: "\u2255",
    ecy: "\u044D",
    edot: "\u0117",
    ee: "\u2147",
    efDot: "\u2252",
    efr: "\uD835\uDD22",
    eg: "\u2A9A",
    egrave: "\xe8",
    egs: "\u2A96",
    egsdot: "\u2A98",
    el: "\u2A99",
    elinters: "\u23E7",
    ell: "\u2113",
    els: "\u2A95",
    elsdot: "\u2A97",
    emacr: "\u0113",
    empty: "\u2205",
    emptyset: "\u2205",
    emptyv: "\u2205",
    emsp13: "\u2004",
    emsp14: "\u2005",
    emsp: "\u2003",
    eng: "\u014B",
    ensp: "\u2002",
    eogon: "\u0119",
    eopf: "\uD835\uDD56",
    epar: "\u22D5",
    eparsl: "\u29E3",
    eplus: "\u2A71",
    epsi: "\u03B5",
    epsilon: "\u03B5",
    epsiv: "\u03F5",
    eqcirc: "\u2256",
    eqcolon: "\u2255",
    eqsim: "\u2242",
    eqslantgtr: "\u2A96",
    eqslantless: "\u2A95",
    equals: "=",
    equest: "\u225F",
    equiv: "\u2261",
    equivDD: "\u2A78",
    eqvparsl: "\u29E5",
    erDot: "\u2253",
    erarr: "\u2971",
    escr: "\u212F",
    esdot: "\u2250",
    esim: "\u2242",
    eta: "\u03B7",
    eth: "\xf0",
    euml: "\xeb",
    euro: "\u20AC",
    excl: "!",
    exist: "\u2203",
    expectation: "\u2130",
    exponentiale: "\u2147",
    fallingdotseq: "\u2252",
    fcy: "\u0444",
    female: "\u2640",
    ffilig: "\uFB03",
    fflig: "\uFB00",
    ffllig: "\uFB04",
    ffr: "\uD835\uDD23",
    filig: "\uFB01",
    fjlig: "fj",
    flat: "\u266D",
    fllig: "\uFB02",
    fltns: "\u25B1",
    fnof: "\u0192",
    fopf: "\uD835\uDD57",
    forall: "\u2200",
    fork: "\u22D4",
    forkv: "\u2AD9",
    fpartint: "\u2A0D",
    frac12: "\xbd",
    frac13: "\u2153",
    frac14: "\xbc",
    frac15: "\u2155",
    frac16: "\u2159",
    frac18: "\u215B",
    frac23: "\u2154",
    frac25: "\u2156",
    frac34: "\xbe",
    frac35: "\u2157",
    frac38: "\u215C",
    frac45: "\u2158",
    frac56: "\u215A",
    frac58: "\u215D",
    frac78: "\u215E",
    frasl: "\u2044",
    frown: "\u2322",
    fscr: "\uD835\uDCBB",
    gE: "\u2267",
    gEl: "\u2A8C",
    gacute: "\u01F5",
    gamma: "\u03B3",
    gammad: "\u03DD",
    gap: "\u2A86",
    gbreve: "\u011F",
    gcirc: "\u011D",
    gcy: "\u0433",
    gdot: "\u0121",
    ge: "\u2265",
    gel: "\u22DB",
    geq: "\u2265",
    geqq: "\u2267",
    geqslant: "\u2A7E",
    ges: "\u2A7E",
    gescc: "\u2AA9",
    gesdot: "\u2A80",
    gesdoto: "\u2A82",
    gesdotol: "\u2A84",
    gesl: "\u22DB\uFE00",
    gesles: "\u2A94",
    gfr: "\uD835\uDD24",
    gg: "\u226B",
    ggg: "\u22D9",
    gimel: "\u2137",
    gjcy: "\u0453",
    gl: "\u2277",
    glE: "\u2A92",
    gla: "\u2AA5",
    glj: "\u2AA4",
    gnE: "\u2269",
    gnap: "\u2A8A",
    gnapprox: "\u2A8A",
    gne: "\u2A88",
    gneq: "\u2A88",
    gneqq: "\u2269",
    gnsim: "\u22E7",
    gopf: "\uD835\uDD58",
    grave: "`",
    gscr: "\u210A",
    gsim: "\u2273",
    gsime: "\u2A8E",
    gsiml: "\u2A90",
    gt: ">",
    gtcc: "\u2AA7",
    gtcir: "\u2A7A",
    gtdot: "\u22D7",
    gtlPar: "\u2995",
    gtquest: "\u2A7C",
    gtrapprox: "\u2A86",
    gtrarr: "\u2978",
    gtrdot: "\u22D7",
    gtreqless: "\u22DB",
    gtreqqless: "\u2A8C",
    gtrless: "\u2277",
    gtrsim: "\u2273",
    gvertneqq: "\u2269\uFE00",
    gvnE: "\u2269\uFE00",
    hArr: "\u21D4",
    hairsp: "\u200A",
    half: "\xbd",
    hamilt: "\u210B",
    hardcy: "\u044A",
    harr: "\u2194",
    harrcir: "\u2948",
    harrw: "\u21AD",
    hbar: "\u210F",
    hcirc: "\u0125",
    hearts: "\u2665",
    heartsuit: "\u2665",
    hellip: "\u2026",
    hercon: "\u22B9",
    hfr: "\uD835\uDD25",
    hksearow: "\u2925",
    hkswarow: "\u2926",
    hoarr: "\u21FF",
    homtht: "\u223B",
    hookleftarrow: "\u21A9",
    hookrightarrow: "\u21AA",
    hopf: "\uD835\uDD59",
    horbar: "\u2015",
    hscr: "\uD835\uDCBD",
    hslash: "\u210F",
    hstrok: "\u0127",
    hybull: "\u2043",
    hyphen: "\u2010",
    iacute: "\xed",
    ic: "\u2063",
    icirc: "\xee",
    icy: "\u0438",
    iecy: "\u0435",
    iexcl: "\xa1",
    iff: "\u21D4",
    ifr: "\uD835\uDD26",
    igrave: "\xec",
    ii: "\u2148",
    iiiint: "\u2A0C",
    iiint: "\u222D",
    iinfin: "\u29DC",
    iiota: "\u2129",
    ijlig: "\u0133",
    imacr: "\u012B",
    image: "\u2111",
    imagline: "\u2110",
    imagpart: "\u2111",
    imath: "\u0131",
    imof: "\u22B7",
    imped: "\u01B5",
    in: "\u2208",
    incare: "\u2105",
    infin: "\u221E",
    infintie: "\u29DD",
    inodot: "\u0131",
    int: "\u222B",
    intcal: "\u22BA",
    integers: "\u2124",
    intercal: "\u22BA",
    intlarhk: "\u2A17",
    intprod: "\u2A3C",
    iocy: "\u0451",
    iogon: "\u012F",
    iopf: "\uD835\uDD5A",
    iota: "\u03B9",
    iprod: "\u2A3C",
    iquest: "\xbf",
    iscr: "\uD835\uDCBE",
    isin: "\u2208",
    isinE: "\u22F9",
    isindot: "\u22F5",
    isins: "\u22F4",
    isinsv: "\u22F3",
    isinv: "\u2208",
    it: "\u2062",
    itilde: "\u0129",
    iukcy: "\u0456",
    iuml: "\xef",
    jcirc: "\u0135",
    jcy: "\u0439",
    jfr: "\uD835\uDD27",
    jmath: "\u0237",
    jopf: "\uD835\uDD5B",
    jscr: "\uD835\uDCBF",
    jsercy: "\u0458",
    jukcy: "\u0454",
    kappa: "\u03BA",
    kappav: "\u03F0",
    kcedil: "\u0137",
    kcy: "\u043A",
    kfr: "\uD835\uDD28",
    kgreen: "\u0138",
    khcy: "\u0445",
    kjcy: "\u045C",
    kopf: "\uD835\uDD5C",
    kscr: "\uD835\uDCC0",
    lAarr: "\u21DA",
    lArr: "\u21D0",
    lAtail: "\u291B",
    lBarr: "\u290E",
    lE: "\u2266",
    lEg: "\u2A8B",
    lHar: "\u2962",
    lacute: "\u013A",
    laemptyv: "\u29B4",
    lagran: "\u2112",
    lambda: "\u03BB",
    lang: "\u27E8",
    langd: "\u2991",
    langle: "\u27E8",
    lap: "\u2A85",
    laquo: "\xab",
    larr: "\u2190",
    larrb: "\u21E4",
    larrbfs: "\u291F",
    larrfs: "\u291D",
    larrhk: "\u21A9",
    larrlp: "\u21AB",
    larrpl: "\u2939",
    larrsim: "\u2973",
    larrtl: "\u21A2",
    lat: "\u2AAB",
    latail: "\u2919",
    late: "\u2AAD",
    lates: "\u2AAD\uFE00",
    lbarr: "\u290C",
    lbbrk: "\u2772",
    lbrace: "{",
    lbrack: "[",
    lbrke: "\u298B",
    lbrksld: "\u298F",
    lbrkslu: "\u298D",
    lcaron: "\u013E",
    lcedil: "\u013C",
    lceil: "\u2308",
    lcub: "{",
    lcy: "\u043B",
    ldca: "\u2936",
    ldquo: "\u201C",
    ldquor: "\u201E",
    ldrdhar: "\u2967",
    ldrushar: "\u294B",
    ldsh: "\u21B2",
    le: "\u2264",
    leftarrow: "\u2190",
    leftarrowtail: "\u21A2",
    leftharpoondown: "\u21BD",
    leftharpoonup: "\u21BC",
    leftleftarrows: "\u21C7",
    leftrightarrow: "\u2194",
    leftrightarrows: "\u21C6",
    leftrightharpoons: "\u21CB",
    leftrightsquigarrow: "\u21AD",
    leftthreetimes: "\u22CB",
    leg: "\u22DA",
    leq: "\u2264",
    leqq: "\u2266",
    leqslant: "\u2A7D",
    les: "\u2A7D",
    lescc: "\u2AA8",
    lesdot: "\u2A7F",
    lesdoto: "\u2A81",
    lesdotor: "\u2A83",
    lesg: "\u22DA\uFE00",
    lesges: "\u2A93",
    lessapprox: "\u2A85",
    lessdot: "\u22D6",
    lesseqgtr: "\u22DA",
    lesseqqgtr: "\u2A8B",
    lessgtr: "\u2276",
    lesssim: "\u2272",
    lfisht: "\u297C",
    lfloor: "\u230A",
    lfr: "\uD835\uDD29",
    lg: "\u2276",
    lgE: "\u2A91",
    lhard: "\u21BD",
    lharu: "\u21BC",
    lharul: "\u296A",
    lhblk: "\u2584",
    ljcy: "\u0459",
    ll: "\u226A",
    llarr: "\u21C7",
    llcorner: "\u231E",
    llhard: "\u296B",
    lltri: "\u25FA",
    lmidot: "\u0140",
    lmoust: "\u23B0",
    lmoustache: "\u23B0",
    lnE: "\u2268",
    lnap: "\u2A89",
    lnapprox: "\u2A89",
    lne: "\u2A87",
    lneq: "\u2A87",
    lneqq: "\u2268",
    lnsim: "\u22E6",
    loang: "\u27EC",
    loarr: "\u21FD",
    lobrk: "\u27E6",
    longleftarrow: "\u27F5",
    longleftrightarrow: "\u27F7",
    longmapsto: "\u27FC",
    longrightarrow: "\u27F6",
    looparrowleft: "\u21AB",
    looparrowright: "\u21AC",
    lopar: "\u2985",
    lopf: "\uD835\uDD5D",
    loplus: "\u2A2D",
    lotimes: "\u2A34",
    lowast: "\u2217",
    lowbar: "_",
    loz: "\u25CA",
    lozenge: "\u25CA",
    lozf: "\u29EB",
    lpar: "(",
    lparlt: "\u2993",
    lrarr: "\u21C6",
    lrcorner: "\u231F",
    lrhar: "\u21CB",
    lrhard: "\u296D",
    lrm: "\u200E",
    lrtri: "\u22BF",
    lsaquo: "\u2039",
    lscr: "\uD835\uDCC1",
    lsh: "\u21B0",
    lsim: "\u2272",
    lsime: "\u2A8D",
    lsimg: "\u2A8F",
    lsqb: "[",
    lsquo: "\u2018",
    lsquor: "\u201A",
    lstrok: "\u0142",
    lt: "<",
    ltcc: "\u2AA6",
    ltcir: "\u2A79",
    ltdot: "\u22D6",
    lthree: "\u22CB",
    ltimes: "\u22C9",
    ltlarr: "\u2976",
    ltquest: "\u2A7B",
    ltrPar: "\u2996",
    ltri: "\u25C3",
    ltrie: "\u22B4",
    ltrif: "\u25C2",
    lurdshar: "\u294A",
    luruhar: "\u2966",
    lvertneqq: "\u2268\uFE00",
    lvnE: "\u2268\uFE00",
    mDDot: "\u223A",
    macr: "\xaf",
    male: "\u2642",
    malt: "\u2720",
    maltese: "\u2720",
    map: "\u21A6",
    mapsto: "\u21A6",
    mapstodown: "\u21A7",
    mapstoleft: "\u21A4",
    mapstoup: "\u21A5",
    marker: "\u25AE",
    mcomma: "\u2A29",
    mcy: "\u043C",
    mdash: "\u2014",
    measuredangle: "\u2221",
    mfr: "\uD835\uDD2A",
    mho: "\u2127",
    micro: "\xb5",
    mid: "\u2223",
    midast: "*",
    midcir: "\u2AF0",
    middot: "\xb7",
    minus: "\u2212",
    minusb: "\u229F",
    minusd: "\u2238",
    minusdu: "\u2A2A",
    mlcp: "\u2ADB",
    mldr: "\u2026",
    mnplus: "\u2213",
    models: "\u22A7",
    mopf: "\uD835\uDD5E",
    mp: "\u2213",
    mscr: "\uD835\uDCC2",
    mstpos: "\u223E",
    mu: "\u03BC",
    multimap: "\u22B8",
    mumap: "\u22B8",
    nGg: "\u22D9\u0338",
    nGt: "\u226B\u20D2",
    nGtv: "\u226B\u0338",
    nLeftarrow: "\u21CD",
    nLeftrightarrow: "\u21CE",
    nLl: "\u22D8\u0338",
    nLt: "\u226A\u20D2",
    nLtv: "\u226A\u0338",
    nRightarrow: "\u21CF",
    nVDash: "\u22AF",
    nVdash: "\u22AE",
    nabla: "\u2207",
    nacute: "\u0144",
    nang: "\u2220\u20D2",
    nap: "\u2249",
    napE: "\u2A70\u0338",
    napid: "\u224B\u0338",
    napos: "\u0149",
    napprox: "\u2249",
    natur: "\u266E",
    natural: "\u266E",
    naturals: "\u2115",
    nbsp: "\xa0",
    nbump: "\u224E\u0338",
    nbumpe: "\u224F\u0338",
    ncap: "\u2A43",
    ncaron: "\u0148",
    ncedil: "\u0146",
    ncong: "\u2247",
    ncongdot: "\u2A6D\u0338",
    ncup: "\u2A42",
    ncy: "\u043D",
    ndash: "\u2013",
    ne: "\u2260",
    neArr: "\u21D7",
    nearhk: "\u2924",
    nearr: "\u2197",
    nearrow: "\u2197",
    nedot: "\u2250\u0338",
    nequiv: "\u2262",
    nesear: "\u2928",
    nesim: "\u2242\u0338",
    nexist: "\u2204",
    nexists: "\u2204",
    nfr: "\uD835\uDD2B",
    ngE: "\u2267\u0338",
    nge: "\u2271",
    ngeq: "\u2271",
    ngeqq: "\u2267\u0338",
    ngeqslant: "\u2A7E\u0338",
    nges: "\u2A7E\u0338",
    ngsim: "\u2275",
    ngt: "\u226F",
    ngtr: "\u226F",
    nhArr: "\u21CE",
    nharr: "\u21AE",
    nhpar: "\u2AF2",
    ni: "\u220B",
    nis: "\u22FC",
    nisd: "\u22FA",
    niv: "\u220B",
    njcy: "\u045A",
    nlArr: "\u21CD",
    nlE: "\u2266\u0338",
    nlarr: "\u219A",
    nldr: "\u2025",
    nle: "\u2270",
    nleftarrow: "\u219A",
    nleftrightarrow: "\u21AE",
    nleq: "\u2270",
    nleqq: "\u2266\u0338",
    nleqslant: "\u2A7D\u0338",
    nles: "\u2A7D\u0338",
    nless: "\u226E",
    nlsim: "\u2274",
    nlt: "\u226E",
    nltri: "\u22EA",
    nltrie: "\u22EC",
    nmid: "\u2224",
    nopf: "\uD835\uDD5F",
    not: "\xac",
    notin: "\u2209",
    notinE: "\u22F9\u0338",
    notindot: "\u22F5\u0338",
    notinva: "\u2209",
    notinvb: "\u22F7",
    notinvc: "\u22F6",
    notni: "\u220C",
    notniva: "\u220C",
    notnivb: "\u22FE",
    notnivc: "\u22FD",
    npar: "\u2226",
    nparallel: "\u2226",
    nparsl: "\u2AFD\u20E5",
    npart: "\u2202\u0338",
    npolint: "\u2A14",
    npr: "\u2280",
    nprcue: "\u22E0",
    npre: "\u2AAF\u0338",
    nprec: "\u2280",
    npreceq: "\u2AAF\u0338",
    nrArr: "\u21CF",
    nrarr: "\u219B",
    nrarrc: "\u2933\u0338",
    nrarrw: "\u219D\u0338",
    nrightarrow: "\u219B",
    nrtri: "\u22EB",
    nrtrie: "\u22ED",
    nsc: "\u2281",
    nsccue: "\u22E1",
    nsce: "\u2AB0\u0338",
    nscr: "\uD835\uDCC3",
    nshortmid: "\u2224",
    nshortparallel: "\u2226",
    nsim: "\u2241",
    nsime: "\u2244",
    nsimeq: "\u2244",
    nsmid: "\u2224",
    nspar: "\u2226",
    nsqsube: "\u22E2",
    nsqsupe: "\u22E3",
    nsub: "\u2284",
    nsubE: "\u2AC5\u0338",
    nsube: "\u2288",
    nsubset: "\u2282\u20D2",
    nsubseteq: "\u2288",
    nsubseteqq: "\u2AC5\u0338",
    nsucc: "\u2281",
    nsucceq: "\u2AB0\u0338",
    nsup: "\u2285",
    nsupE: "\u2AC6\u0338",
    nsupe: "\u2289",
    nsupset: "\u2283\u20D2",
    nsupseteq: "\u2289",
    nsupseteqq: "\u2AC6\u0338",
    ntgl: "\u2279",
    ntilde: "\xf1",
    ntlg: "\u2278",
    ntriangleleft: "\u22EA",
    ntrianglelefteq: "\u22EC",
    ntriangleright: "\u22EB",
    ntrianglerighteq: "\u22ED",
    nu: "\u03BD",
    num: "#",
    numero: "\u2116",
    numsp: "\u2007",
    nvDash: "\u22AD",
    nvHarr: "\u2904",
    nvap: "\u224D\u20D2",
    nvdash: "\u22AC",
    nvge: "\u2265\u20D2",
    nvgt: ">\u20D2",
    nvinfin: "\u29DE",
    nvlArr: "\u2902",
    nvle: "\u2264\u20D2",
    nvlt: "<\u20D2",
    nvltrie: "\u22B4\u20D2",
    nvrArr: "\u2903",
    nvrtrie: "\u22B5\u20D2",
    nvsim: "\u223C\u20D2",
    nwArr: "\u21D6",
    nwarhk: "\u2923",
    nwarr: "\u2196",
    nwarrow: "\u2196",
    nwnear: "\u2927",
    oS: "\u24C8",
    oacute: "\xf3",
    oast: "\u229B",
    ocir: "\u229A",
    ocirc: "\xf4",
    ocy: "\u043E",
    odash: "\u229D",
    odblac: "\u0151",
    odiv: "\u2A38",
    odot: "\u2299",
    odsold: "\u29BC",
    oelig: "\u0153",
    ofcir: "\u29BF",
    ofr: "\uD835\uDD2C",
    ogon: "\u02DB",
    ograve: "\xf2",
    ogt: "\u29C1",
    ohbar: "\u29B5",
    ohm: "\u03A9",
    oint: "\u222E",
    olarr: "\u21BA",
    olcir: "\u29BE",
    olcross: "\u29BB",
    oline: "\u203E",
    olt: "\u29C0",
    omacr: "\u014D",
    omega: "\u03C9",
    omicron: "\u03BF",
    omid: "\u29B6",
    ominus: "\u2296",
    oopf: "\uD835\uDD60",
    opar: "\u29B7",
    operp: "\u29B9",
    oplus: "\u2295",
    or: "\u2228",
    orarr: "\u21BB",
    ord: "\u2A5D",
    order: "\u2134",
    orderof: "\u2134",
    ordf: "\xaa",
    ordm: "\xba",
    origof: "\u22B6",
    oror: "\u2A56",
    orslope: "\u2A57",
    orv: "\u2A5B",
    oscr: "\u2134",
    oslash: "\xf8",
    osol: "\u2298",
    otilde: "\xf5",
    otimes: "\u2297",
    otimesas: "\u2A36",
    ouml: "\xf6",
    ovbar: "\u233D",
    par: "\u2225",
    para: "\xb6",
    parallel: "\u2225",
    parsim: "\u2AF3",
    parsl: "\u2AFD",
    part: "\u2202",
    pcy: "\u043F",
    percnt: "%",
    period: ".",
    permil: "\u2030",
    perp: "\u22A5",
    pertenk: "\u2031",
    pfr: "\uD835\uDD2D",
    phi: "\u03C6",
    phiv: "\u03D5",
    phmmat: "\u2133",
    phone: "\u260E",
    pi: "\u03C0",
    pitchfork: "\u22D4",
    piv: "\u03D6",
    planck: "\u210F",
    planckh: "\u210E",
    plankv: "\u210F",
    plus: "+",
    plusacir: "\u2A23",
    plusb: "\u229E",
    pluscir: "\u2A22",
    plusdo: "\u2214",
    plusdu: "\u2A25",
    pluse: "\u2A72",
    plusmn: "\xb1",
    plussim: "\u2A26",
    plustwo: "\u2A27",
    pm: "\xb1",
    pointint: "\u2A15",
    popf: "\uD835\uDD61",
    pound: "\xa3",
    pr: "\u227A",
    prE: "\u2AB3",
    prap: "\u2AB7",
    prcue: "\u227C",
    pre: "\u2AAF",
    prec: "\u227A",
    precapprox: "\u2AB7",
    preccurlyeq: "\u227C",
    preceq: "\u2AAF",
    precnapprox: "\u2AB9",
    precneqq: "\u2AB5",
    precnsim: "\u22E8",
    precsim: "\u227E",
    prime: "\u2032",
    primes: "\u2119",
    prnE: "\u2AB5",
    prnap: "\u2AB9",
    prnsim: "\u22E8",
    prod: "\u220F",
    profalar: "\u232E",
    profline: "\u2312",
    profsurf: "\u2313",
    prop: "\u221D",
    propto: "\u221D",
    prsim: "\u227E",
    prurel: "\u22B0",
    pscr: "\uD835\uDCC5",
    psi: "\u03C8",
    puncsp: "\u2008",
    qfr: "\uD835\uDD2E",
    qint: "\u2A0C",
    qopf: "\uD835\uDD62",
    qprime: "\u2057",
    qscr: "\uD835\uDCC6",
    quaternions: "\u210D",
    quatint: "\u2A16",
    quest: "?",
    questeq: "\u225F",
    quot: '"',
    rAarr: "\u21DB",
    rArr: "\u21D2",
    rAtail: "\u291C",
    rBarr: "\u290F",
    rHar: "\u2964",
    race: "\u223D\u0331",
    racute: "\u0155",
    radic: "\u221A",
    raemptyv: "\u29B3",
    rang: "\u27E9",
    rangd: "\u2992",
    range: "\u29A5",
    rangle: "\u27E9",
    raquo: "\xbb",
    rarr: "\u2192",
    rarrap: "\u2975",
    rarrb: "\u21E5",
    rarrbfs: "\u2920",
    rarrc: "\u2933",
    rarrfs: "\u291E",
    rarrhk: "\u21AA",
    rarrlp: "\u21AC",
    rarrpl: "\u2945",
    rarrsim: "\u2974",
    rarrtl: "\u21A3",
    rarrw: "\u219D",
    ratail: "\u291A",
    ratio: "\u2236",
    rationals: "\u211A",
    rbarr: "\u290D",
    rbbrk: "\u2773",
    rbrace: "}",
    rbrack: "]",
    rbrke: "\u298C",
    rbrksld: "\u298E",
    rbrkslu: "\u2990",
    rcaron: "\u0159",
    rcedil: "\u0157",
    rceil: "\u2309",
    rcub: "}",
    rcy: "\u0440",
    rdca: "\u2937",
    rdldhar: "\u2969",
    rdquo: "\u201D",
    rdquor: "\u201D",
    rdsh: "\u21B3",
    real: "\u211C",
    realine: "\u211B",
    realpart: "\u211C",
    reals: "\u211D",
    rect: "\u25AD",
    reg: "\xae",
    rfisht: "\u297D",
    rfloor: "\u230B",
    rfr: "\uD835\uDD2F",
    rhard: "\u21C1",
    rharu: "\u21C0",
    rharul: "\u296C",
    rho: "\u03C1",
    rhov: "\u03F1",
    rightarrow: "\u2192",
    rightarrowtail: "\u21A3",
    rightharpoondown: "\u21C1",
    rightharpoonup: "\u21C0",
    rightleftarrows: "\u21C4",
    rightleftharpoons: "\u21CC",
    rightrightarrows: "\u21C9",
    rightsquigarrow: "\u219D",
    rightthreetimes: "\u22CC",
    ring: "\u02DA",
    risingdotseq: "\u2253",
    rlarr: "\u21C4",
    rlhar: "\u21CC",
    rlm: "\u200F",
    rmoust: "\u23B1",
    rmoustache: "\u23B1",
    rnmid: "\u2AEE",
    roang: "\u27ED",
    roarr: "\u21FE",
    robrk: "\u27E7",
    ropar: "\u2986",
    ropf: "\uD835\uDD63",
    roplus: "\u2A2E",
    rotimes: "\u2A35",
    rpar: ")",
    rpargt: "\u2994",
    rppolint: "\u2A12",
    rrarr: "\u21C9",
    rsaquo: "\u203A",
    rscr: "\uD835\uDCC7",
    rsh: "\u21B1",
    rsqb: "]",
    rsquo: "\u2019",
    rsquor: "\u2019",
    rthree: "\u22CC",
    rtimes: "\u22CA",
    rtri: "\u25B9",
    rtrie: "\u22B5",
    rtrif: "\u25B8",
    rtriltri: "\u29CE",
    ruluhar: "\u2968",
    rx: "\u211E",
    sacute: "\u015B",
    sbquo: "\u201A",
    sc: "\u227B",
    scE: "\u2AB4",
    scap: "\u2AB8",
    scaron: "\u0161",
    sccue: "\u227D",
    sce: "\u2AB0",
    scedil: "\u015F",
    scirc: "\u015D",
    scnE: "\u2AB6",
    scnap: "\u2ABA",
    scnsim: "\u22E9",
    scpolint: "\u2A13",
    scsim: "\u227F",
    scy: "\u0441",
    sdot: "\u22C5",
    sdotb: "\u22A1",
    sdote: "\u2A66",
    seArr: "\u21D8",
    searhk: "\u2925",
    searr: "\u2198",
    searrow: "\u2198",
    sect: "\xa7",
    semi: ";",
    seswar: "\u2929",
    setminus: "\u2216",
    setmn: "\u2216",
    sext: "\u2736",
    sfr: "\uD835\uDD30",
    sfrown: "\u2322",
    sharp: "\u266F",
    shchcy: "\u0449",
    shcy: "\u0448",
    shortmid: "\u2223",
    shortparallel: "\u2225",
    shy: "\xad",
    sigma: "\u03C3",
    sigmaf: "\u03C2",
    sigmav: "\u03C2",
    sim: "\u223C",
    simdot: "\u2A6A",
    sime: "\u2243",
    simeq: "\u2243",
    simg: "\u2A9E",
    simgE: "\u2AA0",
    siml: "\u2A9D",
    simlE: "\u2A9F",
    simne: "\u2246",
    simplus: "\u2A24",
    simrarr: "\u2972",
    slarr: "\u2190",
    smallsetminus: "\u2216",
    smashp: "\u2A33",
    smeparsl: "\u29E4",
    smid: "\u2223",
    smile: "\u2323",
    smt: "\u2AAA",
    smte: "\u2AAC",
    smtes: "\u2AAC\uFE00",
    softcy: "\u044C",
    sol: "/",
    solb: "\u29C4",
    solbar: "\u233F",
    sopf: "\uD835\uDD64",
    spades: "\u2660",
    spadesuit: "\u2660",
    spar: "\u2225",
    sqcap: "\u2293",
    sqcaps: "\u2293\uFE00",
    sqcup: "\u2294",
    sqcups: "\u2294\uFE00",
    sqsub: "\u228F",
    sqsube: "\u2291",
    sqsubset: "\u228F",
    sqsubseteq: "\u2291",
    sqsup: "\u2290",
    sqsupe: "\u2292",
    sqsupset: "\u2290",
    sqsupseteq: "\u2292",
    squ: "\u25A1",
    square: "\u25A1",
    squarf: "\u25AA",
    squf: "\u25AA",
    srarr: "\u2192",
    sscr: "\uD835\uDCC8",
    ssetmn: "\u2216",
    ssmile: "\u2323",
    sstarf: "\u22C6",
    star: "\u2606",
    starf: "\u2605",
    straightepsilon: "\u03F5",
    straightphi: "\u03D5",
    strns: "\xaf",
    sub: "\u2282",
    subE: "\u2AC5",
    subdot: "\u2ABD",
    sube: "\u2286",
    subedot: "\u2AC3",
    submult: "\u2AC1",
    subnE: "\u2ACB",
    subne: "\u228A",
    subplus: "\u2ABF",
    subrarr: "\u2979",
    subset: "\u2282",
    subseteq: "\u2286",
    subseteqq: "\u2AC5",
    subsetneq: "\u228A",
    subsetneqq: "\u2ACB",
    subsim: "\u2AC7",
    subsub: "\u2AD5",
    subsup: "\u2AD3",
    succ: "\u227B",
    succapprox: "\u2AB8",
    succcurlyeq: "\u227D",
    succeq: "\u2AB0",
    succnapprox: "\u2ABA",
    succneqq: "\u2AB6",
    succnsim: "\u22E9",
    succsim: "\u227F",
    sum: "\u2211",
    sung: "\u266A",
    sup1: "\xb9",
    sup2: "\xb2",
    sup3: "\xb3",
    sup: "\u2283",
    supE: "\u2AC6",
    supdot: "\u2ABE",
    supdsub: "\u2AD8",
    supe: "\u2287",
    supedot: "\u2AC4",
    suphsol: "\u27C9",
    suphsub: "\u2AD7",
    suplarr: "\u297B",
    supmult: "\u2AC2",
    supnE: "\u2ACC",
    supne: "\u228B",
    supplus: "\u2AC0",
    supset: "\u2283",
    supseteq: "\u2287",
    supseteqq: "\u2AC6",
    supsetneq: "\u228B",
    supsetneqq: "\u2ACC",
    supsim: "\u2AC8",
    supsub: "\u2AD4",
    supsup: "\u2AD6",
    swArr: "\u21D9",
    swarhk: "\u2926",
    swarr: "\u2199",
    swarrow: "\u2199",
    swnwar: "\u292A",
    szlig: "\xdf",
    target: "\u2316",
    tau: "\u03C4",
    tbrk: "\u23B4",
    tcaron: "\u0165",
    tcedil: "\u0163",
    tcy: "\u0442",
    tdot: "\u20DB",
    telrec: "\u2315",
    tfr: "\uD835\uDD31",
    there4: "\u2234",
    therefore: "\u2234",
    theta: "\u03B8",
    thetasym: "\u03D1",
    thetav: "\u03D1",
    thickapprox: "\u2248",
    thicksim: "\u223C",
    thinsp: "\u2009",
    thkap: "\u2248",
    thksim: "\u223C",
    thorn: "\xfe",
    tilde: "\u02DC",
    times: "\xd7",
    timesb: "\u22A0",
    timesbar: "\u2A31",
    timesd: "\u2A30",
    tint: "\u222D",
    toea: "\u2928",
    top: "\u22A4",
    topbot: "\u2336",
    topcir: "\u2AF1",
    topf: "\uD835\uDD65",
    topfork: "\u2ADA",
    tosa: "\u2929",
    tprime: "\u2034",
    trade: "\u2122",
    triangle: "\u25B5",
    triangledown: "\u25BF",
    triangleleft: "\u25C3",
    trianglelefteq: "\u22B4",
    triangleq: "\u225C",
    triangleright: "\u25B9",
    trianglerighteq: "\u22B5",
    tridot: "\u25EC",
    trie: "\u225C",
    triminus: "\u2A3A",
    triplus: "\u2A39",
    trisb: "\u29CD",
    tritime: "\u2A3B",
    trpezium: "\u23E2",
    tscr: "\uD835\uDCC9",
    tscy: "\u0446",
    tshcy: "\u045B",
    tstrok: "\u0167",
    twixt: "\u226C",
    twoheadleftarrow: "\u219E",
    twoheadrightarrow: "\u21A0",
    uArr: "\u21D1",
    uHar: "\u2963",
    uacute: "\xfa",
    uarr: "\u2191",
    ubrcy: "\u045E",
    ubreve: "\u016D",
    ucirc: "\xfb",
    ucy: "\u0443",
    udarr: "\u21C5",
    udblac: "\u0171",
    udhar: "\u296E",
    ufisht: "\u297E",
    ufr: "\uD835\uDD32",
    ugrave: "\xf9",
    uharl: "\u21BF",
    uharr: "\u21BE",
    uhblk: "\u2580",
    ulcorn: "\u231C",
    ulcorner: "\u231C",
    ulcrop: "\u230F",
    ultri: "\u25F8",
    umacr: "\u016B",
    uml: "\xa8",
    uogon: "\u0173",
    uopf: "\uD835\uDD66",
    uparrow: "\u2191",
    updownarrow: "\u2195",
    upharpoonleft: "\u21BF",
    upharpoonright: "\u21BE",
    uplus: "\u228E",
    upsi: "\u03C5",
    upsih: "\u03D2",
    upsilon: "\u03C5",
    upuparrows: "\u21C8",
    urcorn: "\u231D",
    urcorner: "\u231D",
    urcrop: "\u230E",
    uring: "\u016F",
    urtri: "\u25F9",
    uscr: "\uD835\uDCCA",
    utdot: "\u22F0",
    utilde: "\u0169",
    utri: "\u25B5",
    utrif: "\u25B4",
    uuarr: "\u21C8",
    uuml: "\xfc",
    uwangle: "\u29A7",
    vArr: "\u21D5",
    vBar: "\u2AE8",
    vBarv: "\u2AE9",
    vDash: "\u22A8",
    vangrt: "\u299C",
    varepsilon: "\u03F5",
    varkappa: "\u03F0",
    varnothing: "\u2205",
    varphi: "\u03D5",
    varpi: "\u03D6",
    varpropto: "\u221D",
    varr: "\u2195",
    varrho: "\u03F1",
    varsigma: "\u03C2",
    varsubsetneq: "\u228A\uFE00",
    varsubsetneqq: "\u2ACB\uFE00",
    varsupsetneq: "\u228B\uFE00",
    varsupsetneqq: "\u2ACC\uFE00",
    vartheta: "\u03D1",
    vartriangleleft: "\u22B2",
    vartriangleright: "\u22B3",
    vcy: "\u0432",
    vdash: "\u22A2",
    vee: "\u2228",
    veebar: "\u22BB",
    veeeq: "\u225A",
    vellip: "\u22EE",
    verbar: "|",
    vert: "|",
    vfr: "\uD835\uDD33",
    vltri: "\u22B2",
    vnsub: "\u2282\u20D2",
    vnsup: "\u2283\u20D2",
    vopf: "\uD835\uDD67",
    vprop: "\u221D",
    vrtri: "\u22B3",
    vscr: "\uD835\uDCCB",
    vsubnE: "\u2ACB\uFE00",
    vsubne: "\u228A\uFE00",
    vsupnE: "\u2ACC\uFE00",
    vsupne: "\u228B\uFE00",
    vzigzag: "\u299A",
    wcirc: "\u0175",
    wedbar: "\u2A5F",
    wedge: "\u2227",
    wedgeq: "\u2259",
    weierp: "\u2118",
    wfr: "\uD835\uDD34",
    wopf: "\uD835\uDD68",
    wp: "\u2118",
    wr: "\u2240",
    wreath: "\u2240",
    wscr: "\uD835\uDCCC",
    xcap: "\u22C2",
    xcirc: "\u25EF",
    xcup: "\u22C3",
    xdtri: "\u25BD",
    xfr: "\uD835\uDD35",
    xhArr: "\u27FA",
    xharr: "\u27F7",
    xi: "\u03BE",
    xlArr: "\u27F8",
    xlarr: "\u27F5",
    xmap: "\u27FC",
    xnis: "\u22FB",
    xodot: "\u2A00",
    xopf: "\uD835\uDD69",
    xoplus: "\u2A01",
    xotime: "\u2A02",
    xrArr: "\u27F9",
    xrarr: "\u27F6",
    xscr: "\uD835\uDCCD",
    xsqcup: "\u2A06",
    xuplus: "\u2A04",
    xutri: "\u25B3",
    xvee: "\u22C1",
    xwedge: "\u22C0",
    yacute: "\xfd",
    yacy: "\u044F",
    ycirc: "\u0177",
    ycy: "\u044B",
    yen: "\xa5",
    yfr: "\uD835\uDD36",
    yicy: "\u0457",
    yopf: "\uD835\uDD6A",
    yscr: "\uD835\uDCCE",
    yucy: "\u044E",
    yuml: "\xff",
    zacute: "\u017A",
    zcaron: "\u017E",
    zcy: "\u0437",
    zdot: "\u017C",
    zeetrf: "\u2128",
    zeta: "\u03B6",
    zfr: "\uD835\uDD37",
    zhcy: "\u0436",
    zigrarr: "\u21DD",
    zopf: "\uD835\uDD6B",
    zscr: "\uD835\uDCCF",
    zwj: "\u200D",
    zwnj: "\u200C"
};


const $a0142f714959f094$var$own = {}.hasOwnProperty;
function $a0142f714959f094$export$289b6a6320f709b4(value) {
    return $a0142f714959f094$var$own.call((0, $75a937ab4ffa700e$export$ec810d1aafce79a7), value) ? (0, $75a937ab4ffa700e$export$ec810d1aafce79a7)[value] : false;
}



const $e3962d05dd481fa9$export$e31905600aaf3d8e = {
    name: "characterReference",
    tokenize: $e3962d05dd481fa9$var$tokenizeCharacterReference
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $e3962d05dd481fa9$var$tokenizeCharacterReference(effects, ok, nok) {
    const self = this;
    let size = 0;
    /** @type {number} */ let max;
    /** @type {(code: Code) => boolean} */ let test;
    return start;
    /**
   * Start of character reference.
   *
   * ```markdown
   * > | a&amp;b
   *      ^
   * > | a&#123;b
   *      ^
   * > | a&#x9;b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterReference");
        effects.enter("characterReferenceMarker");
        effects.consume(code);
        effects.exit("characterReferenceMarker");
        return open;
    }
    /**
   * After `&`, at `#` for numeric references or alphanumeric for named
   * references.
   *
   * ```markdown
   * > | a&amp;b
   *       ^
   * > | a&#123;b
   *       ^
   * > | a&#x9;b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 35) {
            effects.enter("characterReferenceMarkerNumeric");
            effects.consume(code);
            effects.exit("characterReferenceMarkerNumeric");
            return numeric;
        }
        effects.enter("characterReferenceValue");
        max = 31;
        test = (0, $fc9672c731708cc1$export$75c76db11865a9f4);
        return value(code);
    }
    /**
   * After `#`, at `x` for hexadecimals or digit for decimals.
   *
   * ```markdown
   * > | a&#123;b
   *        ^
   * > | a&#x9;b
   *        ^
   * ```
   *
   * @type {State}
   */ function numeric(code) {
        if (code === 88 || code === 120) {
            effects.enter("characterReferenceMarkerHexadecimal");
            effects.consume(code);
            effects.exit("characterReferenceMarkerHexadecimal");
            effects.enter("characterReferenceValue");
            max = 6;
            test = (0, $fc9672c731708cc1$export$eca2752363989806);
            return value;
        }
        effects.enter("characterReferenceValue");
        max = 7;
        test = (0, $fc9672c731708cc1$export$ca8b5b1a6c320e6e);
        return value(code);
    }
    /**
   * After markers (`&#x`, `&#`, or `&`), in value, before `;`.
   *
   * The character reference kind defines what and how many characters are
   * allowed.
   *
   * ```markdown
   * > | a&amp;b
   *       ^^^
   * > | a&#123;b
   *        ^^^
   * > | a&#x9;b
   *         ^
   * ```
   *
   * @type {State}
   */ function value(code) {
        if (code === 59 && size) {
            const token = effects.exit("characterReferenceValue");
            if (test === (0, $fc9672c731708cc1$export$75c76db11865a9f4) && !(0, $a0142f714959f094$export$289b6a6320f709b4)(self.sliceSerialize(token))) return nok(code);
            // To do: `markdown-rs` uses a different name:
            // `CharacterReferenceMarkerSemi`.
            effects.enter("characterReferenceMarker");
            effects.consume(code);
            effects.exit("characterReferenceMarker");
            effects.exit("characterReference");
            return ok;
        }
        if (test(code) && size++ < max) {
            effects.consume(code);
            return value;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $d4aebffcf6fbba28$export$2005478564e78d96 = {
    name: "characterEscape",
    tokenize: $d4aebffcf6fbba28$var$tokenizeCharacterEscape
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $d4aebffcf6fbba28$var$tokenizeCharacterEscape(effects, ok, nok) {
    return start;
    /**
   * Start of character escape.
   *
   * ```markdown
   * > | a\*b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterEscape");
        effects.enter("escapeMarker");
        effects.consume(code);
        effects.exit("escapeMarker");
        return inside;
    }
    /**
   * After `\`, at punctuation.
   *
   * ```markdown
   * > | a\*b
   *       ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // ASCII punctuation.
        if ((0, $fc9672c731708cc1$export$35794a7d1db99380)(code)) {
            effects.enter("characterEscapeValue");
            effects.consume(code);
            effects.exit("characterEscapeValue");
            effects.exit("characterEscape");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $e875d12858e7a81d$export$8e62e0ad51c97b2 = {
    name: "lineEnding",
    tokenize: $e875d12858e7a81d$var$tokenizeLineEnding
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $e875d12858e7a81d$var$tokenizeLineEnding(effects, ok) {
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $048e24d1164dbff0$export$ae105c1eb063a0a2)(effects, ok, "linePrefix");
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 







const $5fc8429df603bf23$export$470a5dafbbf62654 = {
    name: "labelEnd",
    tokenize: $5fc8429df603bf23$var$tokenizeLabelEnd,
    resolveTo: $5fc8429df603bf23$var$resolveToLabelEnd,
    resolveAll: $5fc8429df603bf23$var$resolveAllLabelEnd
};
/** @type {Construct} */ const $5fc8429df603bf23$var$resourceConstruct = {
    tokenize: $5fc8429df603bf23$var$tokenizeResource
};
/** @type {Construct} */ const $5fc8429df603bf23$var$referenceFullConstruct = {
    tokenize: $5fc8429df603bf23$var$tokenizeReferenceFull
};
/** @type {Construct} */ const $5fc8429df603bf23$var$referenceCollapsedConstruct = {
    tokenize: $5fc8429df603bf23$var$tokenizeReferenceCollapsed
};
/** @type {Resolver} */ function $5fc8429df603bf23$var$resolveAllLabelEnd(events) {
    let index = -1;
    while(++index < events.length){
        const token = events[index][1];
        if (token.type === "labelImage" || token.type === "labelLink" || token.type === "labelEnd") {
            // Remove the marker.
            events.splice(index + 1, token.type === "labelImage" ? 4 : 2);
            token.type = "data";
            index++;
        }
    }
    return events;
}
/** @type {Resolver} */ function $5fc8429df603bf23$var$resolveToLabelEnd(events, context) {
    let index = events.length;
    let offset = 0;
    /** @type {Token} */ let token;
    /** @type {number | undefined} */ let open;
    /** @type {number | undefined} */ let close;
    /** @type {Array<Event>} */ let media;
    // Find an opening.
    while(index--){
        token = events[index][1];
        if (open) {
            // If we see another link, or inactive link label, we’ve been here before.
            if (token.type === "link" || token.type === "labelLink" && token._inactive) break;
            // Mark other link openings as inactive, as we can’t have links in
            // links.
            if (events[index][0] === "enter" && token.type === "labelLink") token._inactive = true;
        } else if (close) {
            if (events[index][0] === "enter" && (token.type === "labelImage" || token.type === "labelLink") && !token._balanced) {
                open = index;
                if (token.type !== "labelLink") {
                    offset = 2;
                    break;
                }
            }
        } else if (token.type === "labelEnd") close = index;
    }
    const group = {
        type: events[open][1].type === "labelLink" ? "link" : "image",
        start: Object.assign({}, events[open][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    const label = {
        type: "label",
        start: Object.assign({}, events[open][1].start),
        end: Object.assign({}, events[close][1].end)
    };
    const text = {
        type: "labelText",
        start: Object.assign({}, events[open + offset + 2][1].end),
        end: Object.assign({}, events[close - 2][1].start)
    };
    media = [
        [
            "enter",
            group,
            context
        ],
        [
            "enter",
            label,
            context
        ]
    ];
    // Opening marker.
    media = (0, $f35ae38d0ff93729$export$4cbf152802aa238)(media, events.slice(open + 1, open + offset + 3));
    // Text open.
    media = (0, $f35ae38d0ff93729$export$4cbf152802aa238)(media, [
        [
            "enter",
            text,
            context
        ]
    ]);
    // Always populated by defaults.
    // Between.
    media = (0, $f35ae38d0ff93729$export$4cbf152802aa238)(media, (0, $0358419463affc45$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + offset + 4, close - 3), context));
    // Text close, marker close, label close.
    media = (0, $f35ae38d0ff93729$export$4cbf152802aa238)(media, [
        [
            "exit",
            text,
            context
        ],
        events[close - 2],
        events[close - 1],
        [
            "exit",
            label,
            context
        ]
    ]);
    // Reference, resource, or so.
    media = (0, $f35ae38d0ff93729$export$4cbf152802aa238)(media, events.slice(close + 1));
    // Media close.
    media = (0, $f35ae38d0ff93729$export$4cbf152802aa238)(media, [
        [
            "exit",
            group,
            context
        ]
    ]);
    (0, $f35ae38d0ff93729$export$869882364835d202)(events, open, events.length, media);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $5fc8429df603bf23$var$tokenizeLabelEnd(effects, ok, nok) {
    const self = this;
    let index = self.events.length;
    /** @type {Token} */ let labelStart;
    /** @type {boolean} */ let defined;
    // Find an opening.
    while(index--)if ((self.events[index][1].type === "labelImage" || self.events[index][1].type === "labelLink") && !self.events[index][1]._balanced) {
        labelStart = self.events[index][1];
        break;
    }
    return start;
    /**
   * Start of label end.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   * ```
   *
   * @type {State}
   */ function start(code) {
        // If there is not an okay opening.
        if (!labelStart) return nok(code);
        // If the corresponding label (link) start is marked as inactive,
        // it means we’d be wrapping a link, like this:
        //
        // ```markdown
        // > | a [b [c](d) e](f) g.
        //                  ^
        // ```
        //
        // We can’t have that, so it’s just balanced brackets.
        if (labelStart._inactive) return labelEndNok(code);
        defined = self.parser.defined.includes((0, $3ef6ca0a03bd4b95$export$806d55e226cfcd08)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        })));
        effects.enter("labelEnd");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelEnd");
        return after;
    }
    /**
   * After `]`.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Note: `markdown-rs` also parses GFM footnotes here, which for us is in
        // an extension.
        // Resource (`[asd](fgh)`)?
        if (code === 40) return effects.attempt($5fc8429df603bf23$var$resourceConstruct, labelEndOk, defined ? labelEndOk : labelEndNok)(code);
        // Full (`[asd][fgh]`) or collapsed (`[asd][]`) reference?
        if (code === 91) return effects.attempt($5fc8429df603bf23$var$referenceFullConstruct, labelEndOk, defined ? referenceNotFull : labelEndNok)(code);
        // Shortcut (`[asd]`) reference?
        return defined ? labelEndOk(code) : labelEndNok(code);
    }
    /**
   * After `]`, at `[`, but not at a full reference.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] b
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceNotFull(code) {
        return effects.attempt($5fc8429df603bf23$var$referenceCollapsedConstruct, labelEndOk, labelEndNok)(code);
    }
    /**
   * Done, we found something.
   *
   * ```markdown
   * > | [a](b) c
   *           ^
   * > | [a][b] c
   *           ^
   * > | [a][] b
   *          ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndOk(code) {
        // Note: `markdown-rs` does a bunch of stuff here.
        return ok(code);
    }
    /**
   * Done, it’s nothing.
   *
   * There was an okay opening, but we didn’t match anything.
   *
   * ```markdown
   * > | [a](b c
   *        ^
   * > | [a][b c
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndNok(code) {
        labelStart._balanced = true;
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $5fc8429df603bf23$var$tokenizeResource(effects, ok, nok) {
    return resourceStart;
    /**
   * At a resource.
   *
   * ```markdown
   * > | [a](b) c
   *        ^
   * ```
   *
   * @type {State}
   */ function resourceStart(code) {
        effects.enter("resource");
        effects.enter("resourceMarker");
        effects.consume(code);
        effects.exit("resourceMarker");
        return resourceBefore;
    }
    /**
   * In resource, after `(`, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceBefore(code) {
        return (0, $fc9672c731708cc1$export$a30284361b3814b7)(code) ? (0, $10fe82f467633c08$export$1f27bd1aa33ce173)(effects, resourceOpen)(code) : resourceOpen(code);
    }
    /**
   * In resource, after optional whitespace, at `)` or a destination.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceOpen(code) {
        if (code === 41) return resourceEnd(code);
        return (0, $f6170ccff5f40987$export$2e6c8deaa96af245)(effects, resourceDestinationAfter, resourceDestinationMissing, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(code);
    }
    /**
   * In resource, after destination, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationAfter(code) {
        return (0, $fc9672c731708cc1$export$a30284361b3814b7)(code) ? (0, $10fe82f467633c08$export$1f27bd1aa33ce173)(effects, resourceBetween)(code) : resourceEnd(code);
    }
    /**
   * At invalid destination.
   *
   * ```markdown
   * > | [a](<<) b
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationMissing(code) {
        return nok(code);
    }
    /**
   * In resource, after destination and whitespace, at `(` or title.
   *
   * ```markdown
   * > | [a](b ) c
   *           ^
   * ```
   *
   * @type {State}
   */ function resourceBetween(code) {
        if (code === 34 || code === 39 || code === 40) return (0, $2fb3af385627b3ae$export$f970569cc855e483)(effects, resourceTitleAfter, nok, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(code);
        return resourceEnd(code);
    }
    /**
   * In resource, after title, at optional whitespace.
   *
   * ```markdown
   * > | [a](b "c") d
   *              ^
   * ```
   *
   * @type {State}
   */ function resourceTitleAfter(code) {
        return (0, $fc9672c731708cc1$export$a30284361b3814b7)(code) ? (0, $10fe82f467633c08$export$1f27bd1aa33ce173)(effects, resourceEnd)(code) : resourceEnd(code);
    }
    /**
   * In resource, at `)`.
   *
   * ```markdown
   * > | [a](b) d
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceEnd(code) {
        if (code === 41) {
            effects.enter("resourceMarker");
            effects.consume(code);
            effects.exit("resourceMarker");
            effects.exit("resource");
            return ok;
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $5fc8429df603bf23$var$tokenizeReferenceFull(effects, ok, nok) {
    const self = this;
    return referenceFull;
    /**
   * In a reference (full), at the `[`.
   *
   * ```markdown
   * > | [a][b] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFull(code) {
        return (0, $dae414fe47944717$export$7b768614d8ba97a7).call(self, effects, referenceFullAfter, referenceFullMissing, "reference", "referenceMarker", "referenceString")(code);
    }
    /**
   * In a reference (full), after `]`.
   *
   * ```markdown
   * > | [a][b] d
   *          ^
   * ```
   *
   * @type {State}
   */ function referenceFullAfter(code) {
        return self.parser.defined.includes((0, $3ef6ca0a03bd4b95$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1))) ? ok(code) : nok(code);
    }
    /**
   * In reference (full) that was missing.
   *
   * ```markdown
   * > | [a][b d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFullMissing(code) {
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $5fc8429df603bf23$var$tokenizeReferenceCollapsed(effects, ok, nok) {
    return referenceCollapsedStart;
    /**
   * In reference (collapsed), at `[`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceCollapsedStart(code) {
        // We only attempt a collapsed label if there’s a `[`.
        effects.enter("reference");
        effects.enter("referenceMarker");
        effects.consume(code);
        effects.exit("referenceMarker");
        return referenceCollapsedOpen;
    }
    /**
   * In reference (collapsed), at `]`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *         ^
   * ```
   *
   *  @type {State}
   */ function referenceCollapsedOpen(code) {
        if (code === 93) {
            effects.enter("referenceMarker");
            effects.consume(code);
            effects.exit("referenceMarker");
            effects.exit("reference");
            return ok;
        }
        return nok(code);
    }
}


const $bb0654ec53ee1e2c$export$3d754936e25aa5f5 = {
    name: "labelStartImage",
    tokenize: $bb0654ec53ee1e2c$var$tokenizeLabelStartImage,
    resolveAll: (0, $5fc8429df603bf23$export$470a5dafbbf62654).resolveAll
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $bb0654ec53ee1e2c$var$tokenizeLabelStartImage(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (image) start.
   *
   * ```markdown
   * > | a ![b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelImage");
        effects.enter("labelImageMarker");
        effects.consume(code);
        effects.exit("labelImageMarker");
        return open;
    }
    /**
   * After `!`, at `[`.
   *
   * ```markdown
   * > | a ![b] c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 91) {
            effects.enter("labelMarker");
            effects.consume(code);
            effects.exit("labelMarker");
            effects.exit("labelImage");
            return after;
        }
        return nok(code);
    }
    /**
   * After `![`.
   *
   * ```markdown
   * > | a ![b] c
   *         ^
   * ```
   *
   * This is needed in because, when GFM footnotes are enabled, images never
   * form when started with a `^`.
   * Instead, links form:
   *
   * ```markdown
   * ![^a](b)
   *
   * ![^a][b]
   *
   * [b]: c
   * ```
   *
   * ```html
   * <p>!<a href=\"b\">^a</a></p>
   * <p>!<a href=\"c\">^a</a></p>
   * ```
   *
   * @type {State}
   */ function after(code) {
        // To do: use a new field to do this, this is still needed for
        // `micromark-extension-gfm-footnote`, but the `label-start-link`
        // behavior isn’t.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && "_hiddenFootnoteSupport" in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
/**
 * @typedef {import('micromark-util-types').Code} Code
 */ 
function $5d99f7ce7d58a5ed$export$e3902bc0d835cad0(code) {
    if (code === null || (0, $fc9672c731708cc1$export$a30284361b3814b7)(code) || (0, $fc9672c731708cc1$export$a0ff789c034ffdf4)(code)) return 1;
    if ((0, $fc9672c731708cc1$export$aa04114dd888a7a0)(code)) return 2;
}



const $023bfd95d1b612da$export$45b92471da762af7 = {
    name: "attention",
    tokenize: $023bfd95d1b612da$var$tokenizeAttention,
    resolveAll: $023bfd95d1b612da$var$resolveAllAttention
};
/**
 * Take all events and resolve attention to emphasis or strong.
 *
 * @type {Resolver}
 */ function $023bfd95d1b612da$var$resolveAllAttention(events, context) {
    let index = -1;
    /** @type {number} */ let open;
    /** @type {Token} */ let group;
    /** @type {Token} */ let text;
    /** @type {Token} */ let openingSequence;
    /** @type {Token} */ let closingSequence;
    /** @type {number} */ let use;
    /** @type {Array<Event>} */ let nextEvents;
    /** @type {number} */ let offset;
    // Walk through all events.
    //
    // Note: performance of this is fine on an mb of normal markdown, but it’s
    // a bottleneck for malicious stuff.
    while(++index < events.length)// Find a token that can close.
    if (events[index][0] === "enter" && events[index][1].type === "attentionSequence" && events[index][1]._close) {
        open = index;
        // Now walk back to find an opener.
        while(open--)// Find a token that can open the closer.
        if (events[open][0] === "exit" && events[open][1].type === "attentionSequence" && events[open][1]._open && // If the markers are the same:
        context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index][1]).charCodeAt(0)) {
            // If the opening can close or the closing can open,
            // and the close size *is not* a multiple of three,
            // but the sum of the opening and closing size *is* multiple of three,
            // then don’t match.
            if ((events[open][1]._close || events[index][1]._open) && (events[index][1].end.offset - events[index][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index][1].end.offset - events[index][1].start.offset) % 3)) continue;
            // Number of markers to use from the sequence.
            use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index][1].end.offset - events[index][1].start.offset > 1 ? 2 : 1;
            const start = Object.assign({}, events[open][1].end);
            const end = Object.assign({}, events[index][1].start);
            $023bfd95d1b612da$var$movePoint(start, -use);
            $023bfd95d1b612da$var$movePoint(end, use);
            openingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: start,
                end: Object.assign({}, events[open][1].end)
            };
            closingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: Object.assign({}, events[index][1].start),
                end: end
            };
            text = {
                type: use > 1 ? "strongText" : "emphasisText",
                start: Object.assign({}, events[open][1].end),
                end: Object.assign({}, events[index][1].start)
            };
            group = {
                type: use > 1 ? "strong" : "emphasis",
                start: Object.assign({}, openingSequence.start),
                end: Object.assign({}, closingSequence.end)
            };
            events[open][1].end = Object.assign({}, openingSequence.start);
            events[index][1].start = Object.assign({}, closingSequence.end);
            nextEvents = [];
            // If there are more markers in the opening, add them before.
            if (events[open][1].end.offset - events[open][1].start.offset) nextEvents = (0, $f35ae38d0ff93729$export$4cbf152802aa238)(nextEvents, [
                [
                    "enter",
                    events[open][1],
                    context
                ],
                [
                    "exit",
                    events[open][1],
                    context
                ]
            ]);
            // Opening.
            nextEvents = (0, $f35ae38d0ff93729$export$4cbf152802aa238)(nextEvents, [
                [
                    "enter",
                    group,
                    context
                ],
                [
                    "enter",
                    openingSequence,
                    context
                ],
                [
                    "exit",
                    openingSequence,
                    context
                ],
                [
                    "enter",
                    text,
                    context
                ]
            ]);
            // Always populated by defaults.
            // Between.
            nextEvents = (0, $f35ae38d0ff93729$export$4cbf152802aa238)(nextEvents, (0, $0358419463affc45$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context));
            // Closing.
            nextEvents = (0, $f35ae38d0ff93729$export$4cbf152802aa238)(nextEvents, [
                [
                    "exit",
                    text,
                    context
                ],
                [
                    "enter",
                    closingSequence,
                    context
                ],
                [
                    "exit",
                    closingSequence,
                    context
                ],
                [
                    "exit",
                    group,
                    context
                ]
            ]);
            // If there are more markers in the closing, add them after.
            if (events[index][1].end.offset - events[index][1].start.offset) {
                offset = 2;
                nextEvents = (0, $f35ae38d0ff93729$export$4cbf152802aa238)(nextEvents, [
                    [
                        "enter",
                        events[index][1],
                        context
                    ],
                    [
                        "exit",
                        events[index][1],
                        context
                    ]
                ]);
            } else offset = 0;
            (0, $f35ae38d0ff93729$export$869882364835d202)(events, open - 1, index - open + 3, nextEvents);
            index = open + nextEvents.length - offset - 2;
            break;
        }
    }
    // Remove remaining sequences.
    index = -1;
    while(++index < events.length)if (events[index][1].type === "attentionSequence") events[index][1].type = "data";
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $023bfd95d1b612da$var$tokenizeAttention(effects, ok) {
    const attentionMarkers = this.parser.constructs.attentionMarkers.null;
    const previous = this.previous;
    const before = (0, $5d99f7ce7d58a5ed$export$e3902bc0d835cad0)(previous);
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Before a sequence.
   *
   * ```markdown
   * > | **
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        marker = code;
        effects.enter("attentionSequence");
        return inside(code);
    }
    /**
   * In a sequence.
   *
   * ```markdown
   * > | **
   *     ^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        const token = effects.exit("attentionSequence");
        // To do: next major: move this to resolver, just like `markdown-rs`.
        const after = (0, $5d99f7ce7d58a5ed$export$e3902bc0d835cad0)(code);
        // Always populated by defaults.
        const open = !after || after === 2 && before || attentionMarkers.includes(code);
        const close = !before || before === 2 && after || attentionMarkers.includes(previous);
        token._open = Boolean(marker === 42 ? open : open && (before || !close));
        token._close = Boolean(marker === 42 ? close : close && (after || !open));
        return ok(code);
    }
}
/**
 * Move a point a bit.
 *
 * Note: `move` only works inside lines! It’s not possible to move past other
 * chunks (replacement characters, tabs, or line endings).
 *
 * @param {Point} point
 * @param {number} offset
 * @returns {void}
 */ function $023bfd95d1b612da$var$movePoint(point, offset) {
    point.column += offset;
    point.offset += offset;
    point._bufferIndex += offset;
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $531f538707dcd8f9$export$17ddf85e4c916ad6 = {
    name: "autolink",
    tokenize: $531f538707dcd8f9$var$tokenizeAutolink
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $531f538707dcd8f9$var$tokenizeAutolink(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of an autolink.
   *
   * ```markdown
   * > | a<https://example.com>b
   *      ^
   * > | a<user@example.com>b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("autolink");
        effects.enter("autolinkMarker");
        effects.consume(code);
        effects.exit("autolinkMarker");
        effects.enter("autolinkProtocol");
        return open;
    }
    /**
   * After `<`, at protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *       ^
   * > | a<user@example.com>b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if ((0, $fc9672c731708cc1$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return schemeOrEmailAtext;
        }
        return emailAtext(code);
    }
    /**
   * At second byte of protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeOrEmailAtext(code) {
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if (code === 43 || code === 45 || code === 46 || (0, $fc9672c731708cc1$export$75c76db11865a9f4)(code)) {
            // Count the previous alphabetical from `open` too.
            size = 1;
            return schemeInsideOrEmailAtext(code);
        }
        return emailAtext(code);
    }
    /**
   * In ambiguous protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeInsideOrEmailAtext(code) {
        if (code === 58) {
            effects.consume(code);
            size = 0;
            return urlInside;
        }
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if ((code === 43 || code === 45 || code === 46 || (0, $fc9672c731708cc1$export$75c76db11865a9f4)(code)) && size++ < 32) {
            effects.consume(code);
            return schemeInsideOrEmailAtext;
        }
        size = 0;
        return emailAtext(code);
    }
    /**
   * After protocol, in URL.
   *
   * ```markdown
   * > | a<https://example.com>b
   *             ^
   * ```
   *
   * @type {State}
   */ function urlInside(code) {
        if (code === 62) {
            effects.exit("autolinkProtocol");
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        // ASCII control, space, or `<`.
        if (code === null || code === 32 || code === 60 || (0, $fc9672c731708cc1$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return urlInside;
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *              ^
   * ```
   *
   * @type {State}
   */ function emailAtext(code) {
        if (code === 64) {
            effects.consume(code);
            return emailAtSignOrDot;
        }
        if ((0, $fc9672c731708cc1$export$4397998b34fe597d)(code)) {
            effects.consume(code);
            return emailAtext;
        }
        return nok(code);
    }
    /**
   * In label, after at-sign or dot.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                 ^       ^
   * ```
   *
   * @type {State}
   */ function emailAtSignOrDot(code) {
        return (0, $fc9672c731708cc1$export$75c76db11865a9f4)(code) ? emailLabel(code) : nok(code);
    }
    /**
   * In label, where `.` and `>` are allowed.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                   ^
   * ```
   *
   * @type {State}
   */ function emailLabel(code) {
        if (code === 46) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if (code === 62) {
            // Exit, then change the token type.
            effects.exit("autolinkProtocol").type = "autolinkEmail";
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        return emailValue(code);
    }
    /**
   * In label, where `.` and `>` are *not* allowed.
   *
   * Though, this is also used in `emailLabel` to parse other values.
   *
   * ```markdown
   * > | a<user.name@ex-ample.com>b
   *                    ^
   * ```
   *
   * @type {State}
   */ function emailValue(code) {
        // ASCII alphanumeric or `-`.
        if ((code === 45 || (0, $fc9672c731708cc1$export$75c76db11865a9f4)(code)) && size++ < 63) {
            const next = code === 45 ? emailValue : emailLabel;
            effects.consume(code);
            return next;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $c991f7f4768fe341$export$398af27f284914fe = {
    name: "htmlText",
    tokenize: $c991f7f4768fe341$var$tokenizeHtmlText
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $c991f7f4768fe341$var$tokenizeHtmlText(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code> | undefined} */ let marker;
    /** @type {number} */ let index;
    /** @type {State} */ let returnState;
    return start;
    /**
   * Start of HTML (text).
   *
   * ```markdown
   * > | a <b> c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("htmlText");
        effects.enter("htmlTextData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | a <b> c
   *        ^
   * > | a <!doctype> c
   *        ^
   * > | a <!--b--> c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            return instruction;
        }
        // ASCII alphabetical.
        if ((0, $fc9672c731708cc1$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | a <!doctype> c
   *         ^
   * > | a <!--b--> c
   *         ^
   * > | a <![CDATA[>&<]]> c
   *         ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            index = 0;
            return cdataOpenInside;
        }
        if ((0, $fc9672c731708cc1$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return declaration;
        }
        return nok(code);
    }
    /**
   * In a comment, after `<!-`, at another `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *          ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return nok(code);
    }
    /**
   * In comment.
   *
   * ```markdown
   * > | a <!--b--> c
   *           ^
   * ```
   *
   * @type {State}
   */ function comment(code) {
        if (code === null) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentClose;
        }
        if ((0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) {
            returnState = comment;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return comment;
    }
    /**
   * In comment, after `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *             ^
   * ```
   *
   * @type {State}
   */ function commentClose(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return comment(code);
    }
    /**
   * In comment, after `--`.
   *
   * ```markdown
   * > | a <!--b--> c
   *              ^
   * ```
   *
   * @type {State}
   */ function commentEnd(code) {
        return code === 62 ? end(code) : code === 45 ? commentClose(code) : comment(code);
    }
    /**
   * After `<![`, in CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *          ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            return index === value.length ? cdata : cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * In CDATA.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                ^^^
   * ```
   *
   * @type {State}
   */ function cdata(code) {
        if (code === null) return nok(code);
        if (code === 93) {
            effects.consume(code);
            return cdataClose;
        }
        if ((0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) {
            returnState = cdata;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return cdata;
    }
    /**
   * In CDATA, after `]`, at another `]`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                    ^
   * ```
   *
   * @type {State}
   */ function cdataClose(code) {
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In CDATA, after `]]`, at `>`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                     ^
   * ```
   *
   * @type {State}
   */ function cdataEnd(code) {
        if (code === 62) return end(code);
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In declaration.
   *
   * ```markdown
   * > | a <!b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function declaration(code) {
        if (code === null || code === 62) return end(code);
        if ((0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) {
            returnState = declaration;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return declaration;
    }
    /**
   * In instruction.
   *
   * ```markdown
   * > | a <?b?> c
   *         ^
   * ```
   *
   * @type {State}
   */ function instruction(code) {
        if (code === null) return nok(code);
        if (code === 63) {
            effects.consume(code);
            return instructionClose;
        }
        if ((0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) {
            returnState = instruction;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return instruction;
    }
    /**
   * In instruction, after `?`, at `>`.
   *
   * ```markdown
   * > | a <?b?> c
   *           ^
   * ```
   *
   * @type {State}
   */ function instructionClose(code) {
        return code === 62 ? end(code) : instruction(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | a </b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        // ASCII alphabetical.
        if ((0, $fc9672c731708cc1$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return nok(code);
    }
    /**
   * After `</x`, in a tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagClose(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $fc9672c731708cc1$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return tagCloseBetween(code);
    }
    /**
   * In closing tag, after tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagCloseBetween(code) {
        if ((0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) {
            returnState = tagCloseBetween;
            return lineEndingBefore(code);
        }
        if ((0, $fc9672c731708cc1$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagCloseBetween;
        }
        return end(code);
    }
    /**
   * After `<x`, in opening tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpen(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $fc9672c731708cc1$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        if (code === 47 || code === 62 || (0, $fc9672c731708cc1$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In opening tag, after tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpenBetween(code) {
        if (code === 47) {
            effects.consume(code);
            return end;
        }
        // ASCII alphabetical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $fc9672c731708cc1$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        if ((0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenBetween;
            return lineEndingBefore(code);
        }
        if ((0, $fc9672c731708cc1$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenBetween;
        }
        return end(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | a <b c> d
   *          ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeName(code) {
        // ASCII alphabetical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $fc9672c731708cc1$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        return tagOpenAttributeNameAfter(code);
    }
    /**
   * After attribute name, before initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | a <b c> d
   *           ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        if ((0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeNameAfter;
            return lineEndingBefore(code);
        }
        if ((0, $fc9672c731708cc1$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeNameAfter;
        }
        return tagOpenBetween(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return tagOpenAttributeValueQuoted;
        }
        if ((0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueBefore;
            return lineEndingBefore(code);
        }
        if ((0, $fc9672c731708cc1$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | a <b c="d"> e
   *             ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuoted(code) {
        if (code === marker) {
            effects.consume(code);
            marker = undefined;
            return tagOpenAttributeValueQuotedAfter;
        }
        if (code === null) return nok(code);
        if ((0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueQuoted;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return tagOpenAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 96) return nok(code);
        if (code === 47 || code === 62 || (0, $fc9672c731708cc1$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the end
   * of the tag.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $fc9672c731708cc1$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a tag where only an `>` is allowed.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function end(code) {
        if (code === 62) {
            effects.consume(code);
            effects.exit("htmlTextData");
            effects.exit("htmlText");
            return ok;
        }
        return nok(code);
    }
    /**
   * At eol.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   * > | a <!--a
   *            ^
   *   | b-->
   * ```
   *
   * @type {State}
   */ function lineEndingBefore(code) {
        effects.exit("htmlTextData");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineEndingAfter;
    }
    /**
   * After eol, at optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfter(code) {
        // Always populated by defaults.
        return (0, $fc9672c731708cc1$export$2c6cf65c1127992a)(code) ? (0, $048e24d1164dbff0$export$ae105c1eb063a0a2)(effects, lineEndingAfterPrefix, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code) : lineEndingAfterPrefix(code);
    }
    /**
   * After eol, after optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfterPrefix(code) {
        effects.enter("htmlTextData");
        return returnState(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $785876b8558a7a7a$export$5c0cee0701a3b584 = {
    name: "labelStartLink",
    tokenize: $785876b8558a7a7a$var$tokenizeLabelStartLink,
    resolveAll: (0, $5fc8429df603bf23$export$470a5dafbbf62654).resolveAll
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $785876b8558a7a7a$var$tokenizeLabelStartLink(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (link) start.
   *
   * ```markdown
   * > | a [b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelLink");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelLink");
        return after;
    }
    /** @type {State} */ function after(code) {
        // To do: this isn’t needed in `micromark-extension-gfm-footnote`,
        // remove.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && "_hiddenFootnoteSupport" in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $3162a17ad47420d9$export$86c573ab9e06f418 = {
    name: "hardBreakEscape",
    tokenize: $3162a17ad47420d9$var$tokenizeHardBreakEscape
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $3162a17ad47420d9$var$tokenizeHardBreakEscape(effects, ok, nok) {
    return start;
    /**
   * Start of a hard break (escape).
   *
   * ```markdown
   * > | a\
   *      ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("hardBreakEscape");
        effects.consume(code);
        return after;
    }
    /**
   * After `\`, at eol.
   *
   * ```markdown
   * > | a\
   *       ^
   *   | b
   * ```
   *
   *  @type {State}
   */ function after(code) {
        if ((0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) {
            effects.exit("hardBreakEscape");
            return ok(code);
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Previous} Previous
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $51d58e4cc89d4d1b$export$d24f93e715f9df88 = {
    name: "codeText",
    tokenize: $51d58e4cc89d4d1b$var$tokenizeCodeText,
    resolve: $51d58e4cc89d4d1b$var$resolveCodeText,
    previous: $51d58e4cc89d4d1b$var$previous
};
// To do: next major: don’t resolve, like `markdown-rs`.
/** @type {Resolver} */ function $51d58e4cc89d4d1b$var$resolveCodeText(events) {
    let tailExitIndex = events.length - 4;
    let headEnterIndex = 3;
    /** @type {number} */ let index;
    /** @type {number | undefined} */ let enter;
    // If we start and end with an EOL or a space.
    if ((events[headEnterIndex][1].type === "lineEnding" || events[headEnterIndex][1].type === "space") && (events[tailExitIndex][1].type === "lineEnding" || events[tailExitIndex][1].type === "space")) {
        index = headEnterIndex;
        // And we have data.
        while(++index < tailExitIndex)if (events[index][1].type === "codeTextData") {
            // Then we have padding.
            events[headEnterIndex][1].type = "codeTextPadding";
            events[tailExitIndex][1].type = "codeTextPadding";
            headEnterIndex += 2;
            tailExitIndex -= 2;
            break;
        }
    }
    // Merge adjacent spaces and data.
    index = headEnterIndex - 1;
    tailExitIndex++;
    while(++index <= tailExitIndex){
        if (enter === undefined) {
            if (index !== tailExitIndex && events[index][1].type !== "lineEnding") enter = index;
        } else if (index === tailExitIndex || events[index][1].type === "lineEnding") {
            events[enter][1].type = "codeTextData";
            if (index !== enter + 2) {
                events[enter][1].end = events[index - 1][1].end;
                events.splice(enter + 2, index - enter - 2);
                tailExitIndex -= index - enter - 2;
                index = enter + 2;
            }
            enter = undefined;
        }
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Previous}
 */ function $51d58e4cc89d4d1b$var$previous(code) {
    // If there is a previous code, there will always be a tail.
    return code !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $51d58e4cc89d4d1b$var$tokenizeCodeText(effects, ok, nok) {
    const self = this;
    let sizeOpen = 0;
    /** @type {number} */ let size;
    /** @type {Token} */ let token;
    return start;
    /**
   * Start of code (text).
   *
   * ```markdown
   * > | `a`
   *     ^
   * > | \`a`
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("codeText");
        effects.enter("codeTextSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | `a`
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 96) {
            effects.consume(code);
            sizeOpen++;
            return sequenceOpen;
        }
        effects.exit("codeTextSequence");
        return between(code);
    }
    /**
   * Between something and something else.
   *
   * ```markdown
   * > | `a`
   *      ^^
   * ```
   *
   * @type {State}
   */ function between(code) {
        // EOF.
        if (code === null) return nok(code);
        // To do: next major: don’t do spaces in resolve, but when compiling,
        // like `markdown-rs`.
        // Tabs don’t work, and virtual spaces don’t make sense.
        if (code === 32) {
            effects.enter("space");
            effects.consume(code);
            effects.exit("space");
            return between;
        }
        // Closing fence? Could also be data.
        if (code === 96) {
            token = effects.enter("codeTextSequence");
            size = 0;
            return sequenceClose(code);
        }
        if ((0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return between;
        }
        // Data.
        effects.enter("codeTextData");
        return data(code);
    }
    /**
   * In data.
   *
   * ```markdown
   * > | `a`
   *      ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 32 || code === 96 || (0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) {
            effects.exit("codeTextData");
            return between(code);
        }
        effects.consume(code);
        return data;
    }
    /**
   * In closing sequence.
   *
   * ```markdown
   * > | `a`
   *       ^
   * ```
   *
   * @type {State}
   */ function sequenceClose(code) {
        // More.
        if (code === 96) {
            effects.consume(code);
            size++;
            return sequenceClose;
        }
        // Done!
        if (size === sizeOpen) {
            effects.exit("codeTextSequence");
            effects.exit("codeText");
            return ok(code);
        }
        // More or less accents: mark as data.
        token.type = "codeTextData";
        return data(code);
    }
}



const $f0dbdc5ddfff416b$export$5a7bfc01df82fcd1 = {
    [42]: (0, $9d2275ffc8036224$export$8837f4fc672e936d),
    [43]: (0, $9d2275ffc8036224$export$8837f4fc672e936d),
    [45]: (0, $9d2275ffc8036224$export$8837f4fc672e936d),
    [48]: (0, $9d2275ffc8036224$export$8837f4fc672e936d),
    [49]: (0, $9d2275ffc8036224$export$8837f4fc672e936d),
    [50]: (0, $9d2275ffc8036224$export$8837f4fc672e936d),
    [51]: (0, $9d2275ffc8036224$export$8837f4fc672e936d),
    [52]: (0, $9d2275ffc8036224$export$8837f4fc672e936d),
    [53]: (0, $9d2275ffc8036224$export$8837f4fc672e936d),
    [54]: (0, $9d2275ffc8036224$export$8837f4fc672e936d),
    [55]: (0, $9d2275ffc8036224$export$8837f4fc672e936d),
    [56]: (0, $9d2275ffc8036224$export$8837f4fc672e936d),
    [57]: (0, $9d2275ffc8036224$export$8837f4fc672e936d),
    [62]: (0, $ba63f97097a04927$export$200dcd0a5903c968)
};
const $f0dbdc5ddfff416b$export$5a2181fb44b58173 = {
    [91]: (0, $0c16db9749037080$export$69f215ed977cdb73)
};
const $f0dbdc5ddfff416b$export$cf8bead395eff824 = {
    [-2]: (0, $5c0982932c83eb47$export$47910b7ab28d1853),
    [-1]: (0, $5c0982932c83eb47$export$47910b7ab28d1853),
    [32]: (0, $5c0982932c83eb47$export$47910b7ab28d1853)
};
const $f0dbdc5ddfff416b$export$ccc7b0636abaffc3 = {
    [35]: (0, $046517131d3e5864$export$3871e9deb360695c),
    [42]: (0, $b0a6b81550e558dc$export$ba7b13e047416c03),
    [45]: [
        (0, $0dc87b78dd2f0e5f$export$e104e2de391dfde9),
        (0, $b0a6b81550e558dc$export$ba7b13e047416c03)
    ],
    [60]: (0, $bdc188be0bb97958$export$476ac411cb7d0d8f),
    [61]: (0, $0dc87b78dd2f0e5f$export$e104e2de391dfde9),
    [95]: (0, $b0a6b81550e558dc$export$ba7b13e047416c03),
    [96]: (0, $5059684b0e990637$export$c23e4921f8d87e7c),
    [126]: (0, $5059684b0e990637$export$c23e4921f8d87e7c)
};
const $f0dbdc5ddfff416b$export$22b082955e083ec3 = {
    [38]: (0, $e3962d05dd481fa9$export$e31905600aaf3d8e),
    [92]: (0, $d4aebffcf6fbba28$export$2005478564e78d96)
};
const $f0dbdc5ddfff416b$export$6f093cfa640b7166 = {
    [-5]: (0, $e875d12858e7a81d$export$8e62e0ad51c97b2),
    [-4]: (0, $e875d12858e7a81d$export$8e62e0ad51c97b2),
    [-3]: (0, $e875d12858e7a81d$export$8e62e0ad51c97b2),
    [33]: (0, $bb0654ec53ee1e2c$export$3d754936e25aa5f5),
    [38]: (0, $e3962d05dd481fa9$export$e31905600aaf3d8e),
    [42]: (0, $023bfd95d1b612da$export$45b92471da762af7),
    [60]: [
        (0, $531f538707dcd8f9$export$17ddf85e4c916ad6),
        (0, $c991f7f4768fe341$export$398af27f284914fe)
    ],
    [91]: (0, $785876b8558a7a7a$export$5c0cee0701a3b584),
    [92]: [
        (0, $3162a17ad47420d9$export$86c573ab9e06f418),
        (0, $d4aebffcf6fbba28$export$2005478564e78d96)
    ],
    [93]: (0, $5fc8429df603bf23$export$470a5dafbbf62654),
    [95]: (0, $023bfd95d1b612da$export$45b92471da762af7),
    [96]: (0, $51d58e4cc89d4d1b$export$d24f93e715f9df88)
};
const $f0dbdc5ddfff416b$export$d44f260a3f9b69f5 = {
    null: [
        (0, $023bfd95d1b612da$export$45b92471da762af7),
        (0, $a41923ffc7408b35$export$50397835cbfdbc24)
    ]
};
const $f0dbdc5ddfff416b$export$b9c0b60d74426aea = {
    null: [
        42,
        95
    ]
};
const $f0dbdc5ddfff416b$export$e20fbacbb41798b = {
    null: []
};


function $acd984dd2edef18e$export$98e6a39c04603d36(options) {
    const settings = options || {};
    const constructs = /** @type {FullNormalizedExtension} */ (0, $36dbe5ae75482411$export$86a865d89ef3c690)([
        $f0dbdc5ddfff416b$exports,
        ...settings.extensions || []
    ]);
    /** @type {ParseContext} */ const parser = {
        defined: [],
        lazy: {},
        constructs: constructs,
        content: create((0, $6e3e75f09c1bc935$export$a7db06668cad9adb)),
        document: create((0, $aee28eb89d776f63$export$5a7bfc01df82fcd1)),
        flow: create((0, $57a9355f3895b732$export$ccc7b0636abaffc3)),
        string: create((0, $a41923ffc7408b35$export$22b082955e083ec3)),
        text: create((0, $a41923ffc7408b35$export$6f093cfa640b7166))
    };
    return parser;
    /**
   * @param {InitialConstruct} initial
   */ function create(initial) {
        return creator;
        /** @type {Create} */ function creator(from) {
            return (0, $5e20a0230da3aec5$export$ae34f10ee4b29837)(parser, initial, from);
        }
    }
}


/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Value} Value
 */ /**
 * @callback Preprocessor
 * @param {Value} value
 * @param {Encoding | null | undefined} [encoding]
 * @param {boolean | null | undefined} [end=false]
 * @returns {Array<Chunk>}
 */ const $d7e16551018435c4$var$search = /[\0\t\n\r]/g;
function $d7e16551018435c4$export$fc37fe19dfda43ee() {
    let column = 1;
    let buffer = "";
    /** @type {boolean | undefined} */ let start = true;
    /** @type {boolean | undefined} */ let atCarriageReturn;
    return preprocessor;
    /** @type {Preprocessor} */ function preprocessor(value, encoding, end) {
        /** @type {Array<Chunk>} */ const chunks = [];
        /** @type {RegExpMatchArray | null} */ let match;
        /** @type {number} */ let next;
        /** @type {number} */ let startPosition;
        /** @type {number} */ let endPosition;
        /** @type {Code} */ let code;
        // @ts-expect-error `Buffer` does allow an encoding.
        value = buffer + value.toString(encoding);
        startPosition = 0;
        buffer = "";
        if (start) {
            // To do: `markdown-rs` actually parses BOMs (byte order mark).
            if (value.charCodeAt(0) === 65279) startPosition++;
            start = undefined;
        }
        while(startPosition < value.length){
            $d7e16551018435c4$var$search.lastIndex = startPosition;
            match = $d7e16551018435c4$var$search.exec(value);
            endPosition = match && match.index !== undefined ? match.index : value.length;
            code = value.charCodeAt(endPosition);
            if (!match) {
                buffer = value.slice(startPosition);
                break;
            }
            if (code === 10 && startPosition === endPosition && atCarriageReturn) {
                chunks.push(-3);
                atCarriageReturn = undefined;
            } else {
                if (atCarriageReturn) {
                    chunks.push(-5);
                    atCarriageReturn = undefined;
                }
                if (startPosition < endPosition) {
                    chunks.push(value.slice(startPosition, endPosition));
                    column += endPosition - startPosition;
                }
                switch(code){
                    case 0:
                        chunks.push(65533);
                        column++;
                        break;
                    case 9:
                        next = Math.ceil(column / 4) * 4;
                        chunks.push(-2);
                        while(column++ < next)chunks.push(-1);
                        break;
                    case 10:
                        chunks.push(-4);
                        column = 1;
                        break;
                    default:
                        atCarriageReturn = true;
                        column = 1;
                }
            }
            startPosition = endPosition + 1;
        }
        if (end) {
            if (atCarriageReturn) chunks.push(-5);
            if (buffer) chunks.push(buffer);
            chunks.push(null);
        }
        return chunks;
    }
}


/**
 * @typedef {import('micromark-util-types').Event} Event
 */ 
function $e4eef691940a823f$export$bd0e6e1378a871d7(events) {
    while(!(0, $486a8072789116a0$export$12949d1dd00fddf4)(events));
    return events;
}


/**
 * Turn the number (in string form as either hexa- or plain decimal) coming from
 * a numeric character reference into a character.
 *
 * Sort of like `String.fromCharCode(Number.parseInt(value, base))`, but makes
 * non-characters and control characters safe.
 *
 * @param {string} value
 *   Value to decode.
 * @param {number} base
 *   Numeric base.
 * @returns {string}
 *   Character.
 */ function $f7cecd713bc3c84c$export$15a69557afac2c20(value, base) {
    const code = Number.parseInt(value, base);
    if (// C0 except for HT, LF, FF, CR, space.
    code < 9 || code === 11 || code > 13 && code < 32 || // Control character (DEL) of C0, and C1 controls.
    code > 126 && code < 160 || // Lone high surrogates and low surrogates.
    code > 55295 && code < 57344 || // Noncharacters.
    code > 64975 && code < 65008 || (code & 65535) === 65535 || (code & 65535) === 65534 /* eslint-enable no-bitwise */  || // Out of range
    code > 1114111) return "\uFFFD";
    return String.fromCharCode(code);
}




const $e66b99c65d529aab$var$characterEscapeOrReference = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function $e66b99c65d529aab$export$a0fb664af7d0cc44(value) {
    return value.replace($e66b99c65d529aab$var$characterEscapeOrReference, $e66b99c65d529aab$var$decode);
}
/**
 * @param {string} $0
 * @param {string} $1
 * @param {string} $2
 * @returns {string}
 */ function $e66b99c65d529aab$var$decode($0, $1, $2) {
    if ($1) // Escape.
    return $1;
    // Reference.
    const head = $2.charCodeAt(0);
    if (head === 35) {
        const head = $2.charCodeAt(1);
        const hex = head === 120 || head === 88;
        return (0, $f7cecd713bc3c84c$export$15a69557afac2c20)($2.slice(hex ? 2 : 1), hex ? 16 : 10);
    }
    return (0, $a0142f714959f094$export$289b6a6320f709b4)($2) || $0;
}





const $b3481c659297d965$var$own = {}.hasOwnProperty;
const $b3481c659297d965$export$d744d789c09bfde6 = /**
   * @type {(
   *   ((value: Value, encoding: Encoding, options?: Options | null | undefined) => Root) &
   *   ((value: Value, options?: Options | null | undefined) => Root)
   * )}
   */ /**
   * @param {Value} value
   * @param {Encoding | Options | null | undefined} [encoding]
   * @param {Options | null | undefined} [options]
   * @returns {Root}
   */ function(value, encoding, options) {
    if (typeof encoding !== "string") {
        options = encoding;
        encoding = undefined;
    }
    return $b3481c659297d965$var$compiler(options)((0, $e4eef691940a823f$export$bd0e6e1378a871d7)((0, $acd984dd2edef18e$export$98e6a39c04603d36)(options).document().write((0, $d7e16551018435c4$export$fc37fe19dfda43ee)()(value, encoding, true))));
};
/**
 * Note this compiler only understand complete buffering, not streaming.
 *
 * @param {Options | null | undefined} [options]
 */ function $b3481c659297d965$var$compiler(options) {
    /** @type {Config} */ const config = {
        transforms: [],
        canContainEols: [
            "emphasis",
            "fragment",
            "heading",
            "paragraph",
            "strong"
        ],
        enter: {
            autolink: opener(link),
            autolinkProtocol: onenterdata,
            autolinkEmail: onenterdata,
            atxHeading: opener(heading),
            blockQuote: opener(blockQuote),
            characterEscape: onenterdata,
            characterReference: onenterdata,
            codeFenced: opener(codeFlow),
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: opener(codeFlow, buffer),
            codeText: opener(codeText, buffer),
            codeTextData: onenterdata,
            data: onenterdata,
            codeFlowValue: onenterdata,
            definition: opener(definition),
            definitionDestinationString: buffer,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: opener(emphasis),
            hardBreakEscape: opener(hardBreak),
            hardBreakTrailing: opener(hardBreak),
            htmlFlow: opener(html, buffer),
            htmlFlowData: onenterdata,
            htmlText: opener(html, buffer),
            htmlTextData: onenterdata,
            image: opener(image),
            label: buffer,
            link: opener(link),
            listItem: opener(listItem),
            listItemValue: onenterlistitemvalue,
            listOrdered: opener(list, onenterlistordered),
            listUnordered: opener(list),
            paragraph: opener(paragraph),
            reference: onenterreference,
            referenceString: buffer,
            resourceDestinationString: buffer,
            resourceTitleString: buffer,
            setextHeading: opener(heading),
            strong: opener(strong),
            thematicBreak: opener(thematicBreak)
        },
        exit: {
            atxHeading: closer(),
            atxHeadingSequence: onexitatxheadingsequence,
            autolink: closer(),
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: closer(),
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            codeFenced: closer(onexitcodefenced),
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onexitcodefencedfencemeta,
            codeFlowValue: onexitdata,
            codeIndented: closer(onexitcodeindented),
            codeText: closer(onexitcodetext),
            codeTextData: onexitdata,
            data: onexitdata,
            definition: closer(),
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: closer(),
            hardBreakEscape: closer(onexithardbreak),
            hardBreakTrailing: closer(onexithardbreak),
            htmlFlow: closer(onexithtmlflow),
            htmlFlowData: onexitdata,
            htmlText: closer(onexithtmltext),
            htmlTextData: onexitdata,
            image: closer(onexitimage),
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: closer(onexitlink),
            listItem: closer(),
            listOrdered: closer(),
            listUnordered: closer(),
            paragraph: closer(),
            referenceString: onexitreferencestring,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            resource: onexitresource,
            setextHeading: closer(onexitsetextheading),
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: closer(),
            thematicBreak: closer()
        }
    };
    $b3481c659297d965$var$configure(config, (options || {}).mdastExtensions || []);
    /** @type {CompileData} */ const data = {};
    return compile;
    /**
   * Turn micromark events into an mdast tree.
   *
   * @param {Array<Event>} events
   *   Events.
   * @returns {Root}
   *   mdast tree.
   */ function compile(events) {
        /** @type {Root} */ let tree = {
            type: "root",
            children: []
        };
        /** @type {Omit<CompileContext, 'sliceSerialize'>} */ const context = {
            stack: [
                tree
            ],
            tokenStack: [],
            config: config,
            enter: enter,
            exit: exit,
            buffer: buffer,
            resume: resume,
            setData: setData,
            getData: getData
        };
        /** @type {Array<number>} */ const listStack = [];
        let index = -1;
        while(++index < events.length)// We preprocess lists to add `listItem` tokens, and to infer whether
        // items the list itself are spread out.
        if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
            if (events[index][0] === "enter") listStack.push(index);
            else {
                const tail = listStack.pop();
                index = prepareList(events, tail, index);
            }
        }
        index = -1;
        while(++index < events.length){
            const handler = config[events[index][0]];
            if ($b3481c659297d965$var$own.call(handler, events[index][1].type)) handler[events[index][1].type].call(Object.assign({
                sliceSerialize: events[index][2].sliceSerialize
            }, context), events[index][1]);
        }
        // Handle tokens still being open.
        if (context.tokenStack.length > 0) {
            const tail = context.tokenStack[context.tokenStack.length - 1];
            const handler = tail[1] || $b3481c659297d965$var$defaultOnError;
            handler.call(context, undefined, tail[0]);
        }
        // Figure out `root` position.
        tree.position = {
            start: $b3481c659297d965$var$point(events.length > 0 ? events[0][1].start : {
                line: 1,
                column: 1,
                offset: 0
            }),
            end: $b3481c659297d965$var$point(events.length > 0 ? events[events.length - 2][1].end : {
                line: 1,
                column: 1,
                offset: 0
            })
        };
        // Call transforms.
        index = -1;
        while(++index < config.transforms.length)tree = config.transforms[index](tree) || tree;
        return tree;
    }
    /**
   * @param {Array<Event>} events
   * @param {number} start
   * @param {number} length
   * @returns {number}
   */ function prepareList(events, start, length) {
        let index = start - 1;
        let containerBalance = -1;
        let listSpread = false;
        /** @type {Token | undefined} */ let listItem;
        /** @type {number | undefined} */ let lineIndex;
        /** @type {number | undefined} */ let firstBlankLineIndex;
        /** @type {boolean | undefined} */ let atMarker;
        while(++index <= length){
            const event = events[index];
            if (event[1].type === "listUnordered" || event[1].type === "listOrdered" || event[1].type === "blockQuote") {
                if (event[0] === "enter") containerBalance++;
                else containerBalance--;
                atMarker = undefined;
            } else if (event[1].type === "lineEndingBlank") {
                if (event[0] === "enter") {
                    if (listItem && !atMarker && !containerBalance && !firstBlankLineIndex) firstBlankLineIndex = index;
                    atMarker = undefined;
                }
            } else if (event[1].type === "linePrefix" || event[1].type === "listItemValue" || event[1].type === "listItemMarker" || event[1].type === "listItemPrefix" || event[1].type === "listItemPrefixWhitespace") ;
            else atMarker = undefined;
            if (!containerBalance && event[0] === "enter" && event[1].type === "listItemPrefix" || containerBalance === -1 && event[0] === "exit" && (event[1].type === "listUnordered" || event[1].type === "listOrdered")) {
                if (listItem) {
                    let tailIndex = index;
                    lineIndex = undefined;
                    while(tailIndex--){
                        const tailEvent = events[tailIndex];
                        if (tailEvent[1].type === "lineEnding" || tailEvent[1].type === "lineEndingBlank") {
                            if (tailEvent[0] === "exit") continue;
                            if (lineIndex) {
                                events[lineIndex][1].type = "lineEndingBlank";
                                listSpread = true;
                            }
                            tailEvent[1].type = "lineEnding";
                            lineIndex = tailIndex;
                        } else if (tailEvent[1].type === "linePrefix" || tailEvent[1].type === "blockQuotePrefix" || tailEvent[1].type === "blockQuotePrefixWhitespace" || tailEvent[1].type === "blockQuoteMarker" || tailEvent[1].type === "listItemIndent") ;
                        else break;
                    }
                    if (firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex)) listItem._spread = true;
                    // Fix position.
                    listItem.end = Object.assign({}, lineIndex ? events[lineIndex][1].start : event[1].end);
                    events.splice(lineIndex || index, 0, [
                        "exit",
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                }
                // Create a new list item.
                if (event[1].type === "listItemPrefix") {
                    listItem = {
                        type: "listItem",
                        _spread: false,
                        start: Object.assign({}, event[1].start),
                        // @ts-expect-error: we’ll add `end` in a second.
                        end: undefined
                    };
                    // @ts-expect-error: `listItem` is most definitely defined, TS...
                    events.splice(index, 0, [
                        "enter",
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                    firstBlankLineIndex = undefined;
                    atMarker = true;
                }
            }
        }
        events[start][1]._spread = listSpread;
        return length;
    }
    /**
   * Set data.
   *
   * @template {keyof CompileData} Key
   *   Field type.
   * @param {Key} key
   *   Key of field.
   * @param {CompileData[Key]} [value]
   *   New value.
   * @returns {void}
   *   Nothing.
   */ function setData(key, value) {
        data[key] = value;
    }
    /**
   * Get data.
   *
   * @template {keyof CompileData} Key
   *   Field type.
   * @param {Key} key
   *   Key of field.
   * @returns {CompileData[Key]}
   *   Value.
   */ function getData(key) {
        return data[key];
    }
    /**
   * Create an opener handle.
   *
   * @param {(token: Token) => Node} create
   *   Create a node.
   * @param {Handle} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function opener(create, and) {
        return open;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {void}
     */ function open(token) {
            enter.call(this, create(token), token);
            if (and) and.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @returns {void}
   */ function buffer() {
        this.stack.push({
            type: "fragment",
            children: []
        });
    }
    /**
   * @template {Node} Kind
   *   Node type.
   * @this {CompileContext}
   *   Context.
   * @param {Kind} node
   *   Node to enter.
   * @param {Token} token
   *   Corresponding token.
   * @param {OnEnterError | undefined} [errorHandler]
   *   Handle the case where this token is open, but it is closed by something else.
   * @returns {Kind}
   *   The given node.
   */ function enter(node, token, errorHandler) {
        const parent = this.stack[this.stack.length - 1];
        // @ts-expect-error: Assume `Node` can exist as a child of `parent`.
        parent.children.push(node);
        this.stack.push(node);
        this.tokenStack.push([
            token,
            errorHandler
        ]);
        // @ts-expect-error: `end` will be patched later.
        node.position = {
            start: $b3481c659297d965$var$point(token.start)
        };
        return node;
    }
    /**
   * Create a closer handle.
   *
   * @param {Handle} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function closer(and) {
        return close;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {void}
     */ function close(token) {
            if (and) and.call(this, token);
            exit.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   *   Context.
   * @param {Token} token
   *   Corresponding token.
   * @param {OnExitError | undefined} [onExitError]
   *   Handle the case where another token is open.
   * @returns {Node}
   *   The closed node.
   */ function exit(token, onExitError) {
        const node = this.stack.pop();
        const open = this.tokenStack.pop();
        if (!open) throw new Error("Cannot close `" + token.type + "` (" + (0, $9ac9f153417ad004$export$c304dd45fe166145)({
            start: token.start,
            end: token.end
        }) + "): it\u2019s not open");
        else if (open[0].type !== token.type) {
            if (onExitError) onExitError.call(this, token, open[0]);
            else {
                const handler = open[1] || $b3481c659297d965$var$defaultOnError;
                handler.call(this, token, open[0]);
            }
        }
        node.position.end = $b3481c659297d965$var$point(token.end);
        return node;
    }
    /**
   * @this {CompileContext}
   * @returns {string}
   */ function resume() {
        return (0, $650eacefe04ddf2f$export$f84e8e69fd4488a5)(this.stack.pop());
    }
    //
    // Handlers.
    //
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered() {
        setData("expectingFirstListItemValue", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (getData("expectingFirstListItemValue")) {
            const ancestor = this.stack[this.stack.length - 2];
            ancestor.start = Number.parseInt(this.sliceSerialize(token), 10);
            setData("expectingFirstListItemValue");
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.lang = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfencemeta() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.meta = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        // Exit if this is the closing fence.
        if (getData("flowCodeInside")) return;
        this.buffer();
        setData("flowCodeInside", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefenced() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, "");
        setData("flowCodeInside");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeindented() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/(\r?\n|\r)$/g, "");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.label = label;
        node.identifier = (0, $3ef6ca0a03bd4b95$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        const node = this.stack[this.stack.length - 1];
        if (!node.depth) {
            const depth = this.sliceSerialize(token).length;
            node.depth = depth;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        setData("setextHeadingSlurpLineEnding", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        const node = this.stack[this.stack.length - 1];
        node.depth = this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        setData("setextHeadingSlurpLineEnding");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdata(token) {
        const node = this.stack[this.stack.length - 1];
        let tail = node.children[node.children.length - 1];
        if (!tail || tail.type !== "text") {
            // Add a new text node.
            tail = text();
            // @ts-expect-error: we’ll add `end` later.
            tail.position = {
                start: $b3481c659297d965$var$point(token.start)
            };
            // @ts-expect-error: Assume `parent` accepts `text`.
            node.children.push(tail);
        }
        this.stack.push(tail);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        const tail = this.stack.pop();
        tail.value += this.sliceSerialize(token);
        tail.position.end = $b3481c659297d965$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        const context = this.stack[this.stack.length - 1];
        // If we’re at a hard break, include the line ending in there.
        if (getData("atHardBreak")) {
            const tail = context.children[context.children.length - 1];
            tail.position.end = $b3481c659297d965$var$point(token.end);
            setData("atHardBreak");
            return;
        }
        if (!getData("setextHeadingSlurpLineEnding") && config.canContainEols.includes(context.type)) {
            onenterdata.call(this, token);
            onexitdata.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        setData("atHardBreak", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmlflow() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmltext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodetext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlink() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (getData("inReference")) {
            /** @type {ReferenceType} */ const referenceType = getData("referenceType") || "shortcut";
            node.type += "Reference";
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        setData("referenceType");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitimage() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (getData("inReference")) {
            /** @type {ReferenceType} */ const referenceType = getData("referenceType") || "shortcut";
            node.type += "Reference";
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        setData("referenceType");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        const string = this.sliceSerialize(token);
        const ancestor = this.stack[this.stack.length - 2];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        ancestor.label = (0, $e66b99c65d529aab$export$a0fb664af7d0cc44)(string);
        // @ts-expect-error: same as above.
        ancestor.identifier = (0, $3ef6ca0a03bd4b95$export$806d55e226cfcd08)(string).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        const fragment = this.stack[this.stack.length - 1];
        const value = this.resume();
        const node = this.stack[this.stack.length - 1];
        // Assume a reference.
        setData("inReference", true);
        if (node.type === "link") {
            /** @type {Array<StaticPhrasingContent>} */ // @ts-expect-error: Assume static phrasing content.
            const children = fragment.children;
            node.children = children;
        } else node.alt = value;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresource() {
        setData("inReference");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterreference() {
        setData("referenceType", "collapsed");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        node.label = label;
        // @ts-expect-error: same as above.
        node.identifier = (0, $3ef6ca0a03bd4b95$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
        setData("referenceType", "full");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencemarker(token) {
        setData("characterReferenceType", token.type);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        const data = this.sliceSerialize(token);
        const type = getData("characterReferenceType");
        /** @type {string} */ let value;
        if (type) {
            value = (0, $f7cecd713bc3c84c$export$15a69557afac2c20)(data, type === "characterReferenceMarkerNumeric" ? 10 : 16);
            setData("characterReferenceType");
        } else {
            const result = (0, $a0142f714959f094$export$289b6a6320f709b4)(data);
            value = result;
        }
        const tail = this.stack.pop();
        tail.value += value;
        tail.position.end = $b3481c659297d965$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = "mailto:" + this.sliceSerialize(token);
    }
    //
    // Creaters.
    //
    /** @returns {Blockquote} */ function blockQuote() {
        return {
            type: "blockquote",
            children: []
        };
    }
    /** @returns {Code} */ function codeFlow() {
        return {
            type: "code",
            lang: null,
            meta: null,
            value: ""
        };
    }
    /** @returns {InlineCode} */ function codeText() {
        return {
            type: "inlineCode",
            value: ""
        };
    }
    /** @returns {Definition} */ function definition() {
        return {
            type: "definition",
            identifier: "",
            label: null,
            title: null,
            url: ""
        };
    }
    /** @returns {Emphasis} */ function emphasis() {
        return {
            type: "emphasis",
            children: []
        };
    }
    /** @returns {Heading} */ function heading() {
        // @ts-expect-error `depth` will be set later.
        return {
            type: "heading",
            depth: undefined,
            children: []
        };
    }
    /** @returns {Break} */ function hardBreak() {
        return {
            type: "break"
        };
    }
    /** @returns {HTML} */ function html() {
        return {
            type: "html",
            value: ""
        };
    }
    /** @returns {Image} */ function image() {
        return {
            type: "image",
            title: null,
            url: "",
            alt: null
        };
    }
    /** @returns {Link} */ function link() {
        return {
            type: "link",
            title: null,
            url: "",
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {List}
   */ function list(token) {
        return {
            type: "list",
            ordered: token.type === "listOrdered",
            start: null,
            spread: token._spread,
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {ListItem}
   */ function listItem(token) {
        return {
            type: "listItem",
            spread: token._spread,
            checked: null,
            children: []
        };
    }
    /** @returns {Paragraph} */ function paragraph() {
        return {
            type: "paragraph",
            children: []
        };
    }
    /** @returns {Strong} */ function strong() {
        return {
            type: "strong",
            children: []
        };
    }
    /** @returns {Text} */ function text() {
        return {
            type: "text",
            value: ""
        };
    }
    /** @returns {ThematicBreak} */ function thematicBreak() {
        return {
            type: "thematicBreak"
        };
    }
}
/**
 * Copy a point-like value.
 *
 * @param {Point} d
 *   Point-like value.
 * @returns {Point}
 *   unist point.
 */ function $b3481c659297d965$var$point(d) {
    return {
        line: d.line,
        column: d.column,
        offset: d.offset
    };
}
/**
 * @param {Config} combined
 * @param {Array<Extension | Array<Extension>>} extensions
 * @returns {void}
 */ function $b3481c659297d965$var$configure(combined, extensions) {
    let index = -1;
    while(++index < extensions.length){
        const value = extensions[index];
        if (Array.isArray(value)) $b3481c659297d965$var$configure(combined, value);
        else $b3481c659297d965$var$extension(combined, value);
    }
}
/**
 * @param {Config} combined
 * @param {Extension} extension
 * @returns {void}
 */ function $b3481c659297d965$var$extension(combined, extension) {
    /** @type {keyof Extension} */ let key;
    for(key in extension)if ($b3481c659297d965$var$own.call(extension, key)) {
        if (key === "canContainEols") {
            const right = extension[key];
            if (right) combined[key].push(...right);
        } else if (key === "transforms") {
            const right = extension[key];
            if (right) combined[key].push(...right);
        } else if (key === "enter" || key === "exit") {
            const right = extension[key];
            if (right) Object.assign(combined[key], right);
        }
    }
}
/** @type {OnEnterError} */ function $b3481c659297d965$var$defaultOnError(left, right) {
    if (left) throw new Error("Cannot close `" + left.type + "` (" + (0, $9ac9f153417ad004$export$c304dd45fe166145)({
        start: left.start,
        end: left.end
    }) + "): a different token (`" + right.type + "`, " + (0, $9ac9f153417ad004$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ") is open");
    else throw new Error("Cannot close document, a token (`" + right.type + "`, " + (0, $9ac9f153417ad004$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ") is still open");
}


function $8943f7d469b81540$export$2e2bcd8739ae039(options) {
    /** @type {import('unified').ParserFunction<Root>} */ const parser = (doc)=>{
        // Assume options.
        const settings = /** @type {Options} */ this.data("settings");
        return (0, $b3481c659297d965$export$d744d789c09bfde6)(doc, Object.assign({}, settings, options, {
            // Note: these options are not in the readme.
            // The goal is for them to be set by plugins on `data` instead of being
            // passed by users.
            extensions: this.data("micromarkExtensions") || [],
            mdastExtensions: this.data("fromMarkdownExtensions") || []
        }));
    };
    Object.assign(this, {
        Parser: parser
    });
}


/**
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('mdast-util-to-hast').Options} Options
 * @typedef {import('unified').Processor<any, any, any, any>} Processor
 *
 * @typedef {import('mdast-util-to-hast')} DoNotTouchAsThisImportIncludesRawInTree
 */ /**
 * @typedef {import('hast').Content} HastContent
 * @typedef {import('hast').Root} HastRoot
 *
 * @typedef {import('mdast').Content} MdastContent
 * @typedef {import('mdast').Root} MdastRoot
 *
 * @typedef {import('./state.js').Options} Options
 */ /**
 * @typedef {HastRoot | HastContent} HastNodes
 * @typedef {MdastRoot | MdastContent} MdastNodes
 */ /**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 *
 * @typedef {import('./state.js').State} State
 */ 
const $6d5ebc861e636d9c$var$characterReferences = {
    '"': "quot",
    "&": "amp",
    "<": "lt",
    ">": "gt"
};
function $6d5ebc861e636d9c$export$c564cdbbe6da493(value) {
    return value.replace(/["&<>]/g, replace);
    /**
   * @param {string} value
   * @returns {string}
   */ function replace(value) {
        // @ts-expect-error Hush, it’s fine.
        return "&" + $6d5ebc861e636d9c$var$characterReferences[value] + ";";
    }
}


function $71b8b713c55a94fa$export$d130a2d684099e5a(url, protocol) {
    const value = (0, $6d5ebc861e636d9c$export$c564cdbbe6da493)($71b8b713c55a94fa$export$e42a3e39590d28b5(url || ""));
    if (!protocol) return value;
    const colon = value.indexOf(":");
    const questionMark = value.indexOf("?");
    const numberSign = value.indexOf("#");
    const slash = value.indexOf("/");
    if (// If there is no protocol, it’s relative.
    colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash > -1 && colon > slash || questionMark > -1 && colon > questionMark || numberSign > -1 && colon > numberSign || // It is a protocol, it should be allowed.
    protocol.test(value.slice(0, colon))) return value;
    return "";
}
function $71b8b713c55a94fa$export$e42a3e39590d28b5(value) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    let start = 0;
    let skip = 0;
    while(++index < value.length){
        const code = value.charCodeAt(index);
        /** @type {string} */ let replace = "";
        // A correct percent encoded value.
        if (code === 37 && (0, $fc9672c731708cc1$export$75c76db11865a9f4)(value.charCodeAt(index + 1)) && (0, $fc9672c731708cc1$export$75c76db11865a9f4)(value.charCodeAt(index + 2))) skip = 2;
        else if (code < 128) {
            if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code))) replace = String.fromCharCode(code);
        } else if (code > 55295 && code < 57344) {
            const next = value.charCodeAt(index + 1);
            // A correct surrogate pair.
            if (code < 56320 && next > 56319 && next < 57344) {
                replace = String.fromCharCode(code, next);
                skip = 1;
            } else replace = "\uFFFD";
        } else replace = String.fromCharCode(code);
        if (replace) {
            result.push(value.slice(start, index), encodeURIComponent(replace));
            start = index + skip + 1;
            replace = "";
        }
        if (skip) {
            index += skip;
            skip = 0;
        }
    }
    return result.join("") + value.slice(start);
}


function $2fef6b3d3c71f718$export$adb608be33961c98(state) {
    /** @type {Array<ElementContent>} */ const listItems = [];
    let index = -1;
    while(++index < state.footnoteOrder.length){
        const def = state.footnoteById[state.footnoteOrder[index]];
        if (!def) continue;
        const content = state.all(def);
        const id = String(def.identifier).toUpperCase();
        const safeId = (0, $71b8b713c55a94fa$export$e42a3e39590d28b5)(id.toLowerCase());
        let referenceIndex = 0;
        /** @type {Array<ElementContent>} */ const backReferences = [];
        while(++referenceIndex <= state.footnoteCounts[id]){
            /** @type {Element} */ const backReference = {
                type: "element",
                tagName: "a",
                properties: {
                    href: "#" + state.clobberPrefix + "fnref-" + safeId + (referenceIndex > 1 ? "-" + referenceIndex : ""),
                    dataFootnoteBackref: true,
                    className: [
                        "data-footnote-backref"
                    ],
                    ariaLabel: state.footnoteBackLabel
                },
                children: [
                    {
                        type: "text",
                        value: "\u21A9"
                    }
                ]
            };
            if (referenceIndex > 1) backReference.children.push({
                type: "element",
                tagName: "sup",
                children: [
                    {
                        type: "text",
                        value: String(referenceIndex)
                    }
                ]
            });
            if (backReferences.length > 0) backReferences.push({
                type: "text",
                value: " "
            });
            backReferences.push(backReference);
        }
        const tail = content[content.length - 1];
        if (tail && tail.type === "element" && tail.tagName === "p") {
            const tailTail = tail.children[tail.children.length - 1];
            if (tailTail && tailTail.type === "text") tailTail.value += " ";
            else tail.children.push({
                type: "text",
                value: " "
            });
            tail.children.push(...backReferences);
        } else content.push(...backReferences);
        /** @type {Element} */ const listItem = {
            type: "element",
            tagName: "li",
            properties: {
                id: state.clobberPrefix + "fn-" + safeId
            },
            children: state.wrap(content, true)
        };
        state.patch(def, listItem);
        listItems.push(listItem);
    }
    if (listItems.length === 0) return;
    return {
        type: "element",
        tagName: "section",
        properties: {
            dataFootnotes: true,
            className: [
                "footnotes"
            ]
        },
        children: [
            {
                type: "element",
                tagName: state.footnoteLabelTagName,
                properties: {
                    // To do: use structured clone.
                    ...JSON.parse(JSON.stringify(state.footnoteLabelProperties)),
                    id: "footnote-label"
                },
                children: [
                    {
                        type: "text",
                        value: state.footnoteLabel
                    }
                ]
            },
            {
                type: "text",
                value: "\n"
            },
            {
                type: "element",
                tagName: "ol",
                properties: {},
                children: state.wrap(listItems, true)
            },
            {
                type: "text",
                value: "\n"
            }
        ]
    };
}


/**
 * @typedef {import('hast').Content} HastContent
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('hast').ElementContent} HastElementContent
 * @typedef {import('hast').Properties} HastProperties
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('hast').Text} HastText
 *
 * @typedef {import('mdast').Content} MdastContent
 * @typedef {import('mdast').Definition} MdastDefinition
 * @typedef {import('mdast').FootnoteDefinition} MdastFootnoteDefinition
 * @typedef {import('mdast').Parent} MdastParent
 * @typedef {import('mdast').Root} MdastRoot
 */ /**
 * @typedef {HastRoot | HastContent} HastNodes
 * @typedef {MdastRoot | MdastContent} MdastNodes
 * @typedef {Extract<MdastNodes, MdastParent>} MdastParents
 *
 * @typedef EmbeddedHastFields
 *   hast fields.
 * @property {string | null | undefined} [hName]
 *   Generate a specific element with this tag name instead.
 * @property {HastProperties | null | undefined} [hProperties]
 *   Generate an element with these properties instead.
 * @property {Array<HastElementContent> | null | undefined} [hChildren]
 *   Generate an element with this content instead.
 *
 * @typedef {Record<string, unknown> & EmbeddedHastFields} MdastData
 *   mdast data with embedded hast fields.
 *
 * @typedef {MdastNodes & {data?: MdastData | null | undefined}} MdastNodeWithData
 *   mdast node with embedded hast data.
 *
 * @typedef PointLike
 *   Point-like value.
 * @property {number | null | undefined} [line]
 *   Line.
 * @property {number | null | undefined} [column]
 *   Column.
 * @property {number | null | undefined} [offset]
 *   Offset.
 *
 * @typedef PositionLike
 *   Position-like value.
 * @property {PointLike | null | undefined} [start]
 *   Point-like value.
 * @property {PointLike | null | undefined} [end]
 *   Point-like value.
 *
 * @callback Handler
 *   Handle a node.
 * @param {State} state
 *   Info passed around.
 * @param {any} node
 *   mdast node to handle.
 * @param {MdastParents | null | undefined} parent
 *   Parent of `node`.
 * @returns {HastElementContent | Array<HastElementContent> | null | undefined}
 *   hast node.
 *
 * @callback HFunctionProps
 *   Signature of `state` for when props are passed.
 * @param {MdastNodes | PositionLike | null | undefined} node
 *   mdast node or unist position.
 * @param {string} tagName
 *   HTML tag name.
 * @param {HastProperties} props
 *   Properties.
 * @param {Array<HastElementContent> | null | undefined} [children]
 *   hast content.
 * @returns {HastElement}
 *   Compiled element.
 *
 * @callback HFunctionNoProps
 *   Signature of `state` for when no props are passed.
 * @param {MdastNodes | PositionLike | null | undefined} node
 *   mdast node or unist position.
 * @param {string} tagName
 *   HTML tag name.
 * @param {Array<HastElementContent> | null | undefined} [children]
 *   hast content.
 * @returns {HastElement}
 *   Compiled element.
 *
 * @typedef HFields
 *   Info on `state`.
 * @property {boolean} dangerous
 *   Whether HTML is allowed.
 * @property {string} clobberPrefix
 *   Prefix to use to prevent DOM clobbering.
 * @property {string} footnoteLabel
 *   Label to use to introduce the footnote section.
 * @property {string} footnoteLabelTagName
 *   HTML used for the footnote label.
 * @property {HastProperties} footnoteLabelProperties
 *   Properties on the HTML tag used for the footnote label.
 * @property {string} footnoteBackLabel
 *   Label to use from backreferences back to their footnote call.
 * @property {(identifier: string) => MdastDefinition | null} definition
 *   Definition cache.
 * @property {Record<string, MdastFootnoteDefinition>} footnoteById
 *   Footnote definitions by their identifier.
 * @property {Array<string>} footnoteOrder
 *   Identifiers of order when footnote calls first appear in tree order.
 * @property {Record<string, number>} footnoteCounts
 *   Counts for how often the same footnote was called.
 * @property {Handlers} handlers
 *   Applied handlers.
 * @property {Handler} unknownHandler
 *   Handler for any none not in `passThrough` or otherwise handled.
 * @property {(from: MdastNodes, node: HastNodes) => void} patch
 *   Copy a node’s positional info.
 * @property {<Type extends HastNodes>(from: MdastNodes, to: Type) => Type | HastElement} applyData
 *   Honor the `data` of `from`, and generate an element instead of `node`.
 * @property {(node: MdastNodes, parent: MdastParents | null | undefined) => HastElementContent | Array<HastElementContent> | null | undefined} one
 *   Transform an mdast node to hast.
 * @property {(node: MdastNodes) => Array<HastElementContent>} all
 *   Transform the children of an mdast parent to hast.
 * @property {<Type extends HastContent>(nodes: Array<Type>, loose?: boolean | null | undefined) => Array<Type | HastText>} wrap
 *   Wrap `nodes` with line endings between each node, adds initial/final line endings when `loose`.
 * @property {(left: MdastNodeWithData | PositionLike | null | undefined, right: HastElementContent) => HastElementContent} augment
 *   Like `state` but lower-level and usable on non-elements.
 *   Deprecated: use `patch` and `applyData`.
 * @property {Array<string>} passThrough
 *   List of node types to pass through untouched (except for their children).
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [allowDangerousHtml=false]
 *   Whether to persist raw HTML in markdown in the hast tree.
 * @property {string | null | undefined} [clobberPrefix='user-content-']
 *   Prefix to use before the `id` attribute on footnotes to prevent it from
 *   *clobbering*.
 * @property {string | null | undefined} [footnoteBackLabel='Back to content']
 *   Label to use from backreferences back to their footnote call (affects
 *   screen readers).
 * @property {string | null | undefined} [footnoteLabel='Footnotes']
 *   Label to use for the footnotes section (affects screen readers).
 * @property {HastProperties | null | undefined} [footnoteLabelProperties={className: ['sr-only']}]
 *   Properties to use on the footnote label (note that `id: 'footnote-label'`
 *   is always added as footnote calls use it with `aria-describedby` to
 *   provide an accessible label).
 * @property {string | null | undefined} [footnoteLabelTagName='h2']
 *   Tag name to use for the footnote label.
 * @property {Handlers | null | undefined} [handlers]
 *   Extra handlers for nodes.
 * @property {Array<string> | null | undefined} [passThrough]
 *   List of custom mdast node types to pass through (keep) in hast (note that
 *   the node itself is passed, but eventual children are transformed).
 * @property {Handler | null | undefined} [unknownHandler]
 *   Handler for all unknown nodes.
 *
 * @typedef {Record<string, Handler>} Handlers
 *   Handle nodes.
 *
 * @typedef {HFunctionProps & HFunctionNoProps & HFields} State
 *   Info passed around.
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 */ /**
 * Check if `Child` can be a child of `Ancestor`.
 *
 * Returns the ancestor when `Child` can be a child of `Ancestor`, or returns
 * `never`.
 *
 * @template {Node} Ancestor
 *   Node type.
 * @template {Node} Child
 *   Node type.
 * @typedef {(
 *   Ancestor extends Parent
 *     ? Child extends Ancestor['children'][number]
 *       ? Ancestor
 *       : never
 *     : never
 * )} ParentsOf
 */ /**
 * @template {Node} [Visited=Node]
 *   Visited node type.
 * @template {Parent} [Ancestor=Parent]
 *   Ancestor type.
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform `parent`.
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of `parent` still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Visited extends Node ? number | null : never} index
 *   Index of `node` in `parent`.
 * @param {Ancestor extends Node ? Ancestor | null : never} parent
 *   Parent of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 */ /**
 * Build a typed `Visitor` function from a node and all possible parents.
 *
 * It will infer which values are passed as `node` and which as `parent`.
 *
 * @template {Node} Visited
 *   Node type.
 * @template {Parent} Ancestor
 *   Parent type.
 * @typedef {Visitor<Visited, ParentsOf<Ancestor, Visited>>} BuildVisitorFromMatch
 */ /**
 * Build a typed `Visitor` function from a list of descendants and a test.
 *
 * It will infer which values are passed as `node` and which as `parent`.
 *
 * @template {Node} Descendant
 *   Node type.
 * @template {Test} Check
 *   Test type.
 * @typedef {(
 *   BuildVisitorFromMatch<
 *     import('unist-util-visit-parents/complex-types.js').Matches<Descendant, Check>,
 *     Extract<Descendant, Parent>
 *   >
 * )} BuildVisitorFromDescendants
 */ /**
 * Build a typed `Visitor` function from a tree and a test.
 *
 * It will infer which values are passed as `node` and which as `parent`.
 *
 * @template {Node} [Tree=Node]
 *   Node type.
 * @template {Test} [Check=string]
 *   Test type.
 * @typedef {(
 *   BuildVisitorFromDescendants<
 *     import('unist-util-visit-parents/complex-types.js').InclusiveDescendant<Tree>,
 *     Check
 *   >
 * )} BuildVisitor
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 */ /**
 * @typedef {boolean | 'skip'} Action
 *   Union of the action types.
 *
 * @typedef {number} Index
 *   Move to the sibling at `index` next (after node itself is completely
 *   traversed).
 *
 *   Useful if mutating the tree, such as removing the node the visitor is
 *   currently on, or any of its previous siblings.
 *   Results less than 0 or greater than or equal to `children.length` stop
 *   traversing the parent.
 *
 * @typedef {[(Action | null | undefined | void)?, (Index | null | undefined)?]} ActionTuple
 *   List with one or two values, the first an action, the second an index.
 *
 * @typedef {Action | ActionTuple | Index | null | undefined | void} VisitorResult
 *   Any value that can be returned from a visitor.
 */ /**
 * @template {Node} [Visited=Node]
 *   Visited node type.
 * @template {Parent} [Ancestor=Parent]
 *   Ancestor type.
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform the parent of node (the last of `ancestors`).
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of an ancestor still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Array<Ancestor>} ancestors
 *   Ancestors of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 */ /**
 * @template {Node} [Tree=Node]
 *   Tree type.
 * @template {Test} [Check=string]
 *   Test type.
 * @typedef {Visitor<import('./complex-types.js').Matches<import('./complex-types.js').InclusiveDescendant<Tree>, Check>, Extract<import('./complex-types.js').InclusiveDescendant<Tree>, Parent>>} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parents`.
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 */ /**
 * @typedef {Record<string, unknown>} Props
 * @typedef {null | undefined | string | Props | TestFunctionAnything | Array<string | Props | TestFunctionAnything>} Test
 *   Check for an arbitrary node, unaware of TypeScript inferral.
 *
 * @callback TestFunctionAnything
 *   Check if a node passes a test, unaware of TypeScript inferral.
 * @param {unknown} this
 *   The given context.
 * @param {Node} node
 *   A node.
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean | void}
 *   Whether this node passes the test.
 */ /**
 * @template {Node} Kind
 *   Node type.
 * @typedef {Kind['type'] | Partial<Kind> | TestFunctionPredicate<Kind> | Array<Kind['type'] | Partial<Kind> | TestFunctionPredicate<Kind>>} PredicateTest
 *   Check for a node that can be inferred by TypeScript.
 */ /**
 * Check if a node passes a certain test.
 *
 * @template {Node} Kind
 *   Node type.
 * @callback TestFunctionPredicate
 *   Complex test function for a node that can be inferred by TypeScript.
 * @param {Node} node
 *   A node.
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {node is Kind}
 *   Whether this node passes the test.
 */ /**
 * @callback AssertAnything
 *   Check that an arbitrary value is a node, unaware of TypeScript inferral.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean}
 *   Whether this is a node and passes a test.
 */ /**
 * Check if a node is a node and passes a certain node test.
 *
 * @template {Node} Kind
 *   Node type.
 * @callback AssertPredicate
 *   Check that an arbitrary value is a specific node, aware of TypeScript.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {node is Kind}
 *   Whether this is a node and passes a test.
 */ /**
 * Check if `node` is a `Node` and whether it passes the given test.
 *
 * @param node
 *   Thing to check, typically `Node`.
 * @param test
 *   A check for a specific node.
 * @param index
 *   The node’s position in its parent.
 * @param parent
 *   The node’s parent.
 * @returns
 *   Whether `node` is a node and passes a test.
 */ const $56aea44d55896096$export$226b3eccf92c9ed9 = /**
   * @type {(
   *   (() => false) &
   *   (<Kind extends Node = Node>(node: unknown, test: PredicateTest<Kind>, index: number, parent: Parent, context?: unknown) => node is Kind) &
   *   (<Kind extends Node = Node>(node: unknown, test: PredicateTest<Kind>, index?: null | undefined, parent?: null | undefined, context?: unknown) => node is Kind) &
   *   ((node: unknown, test: Test, index: number, parent: Parent, context?: unknown) => boolean) &
   *   ((node: unknown, test?: Test, index?: null | undefined, parent?: null | undefined, context?: unknown) => boolean)
   * )}
   */ /**
     * @param {unknown} [node]
     * @param {Test} [test]
     * @param {number | null | undefined} [index]
     * @param {Parent | null | undefined} [parent]
     * @param {unknown} [context]
     * @returns {boolean}
     */ // eslint-disable-next-line max-params
function is(node, test, index, parent, context) {
    const check = $56aea44d55896096$export$9c68d69a4c5bbcf9(test);
    if (index !== undefined && index !== null && (typeof index !== "number" || index < 0 || index === Number.POSITIVE_INFINITY)) throw new Error("Expected positive finite index");
    if (parent !== undefined && parent !== null && (!is(parent) || !parent.children)) throw new Error("Expected parent node");
    if ((parent === undefined || parent === null) !== (index === undefined || index === null)) throw new Error("Expected both parent and index");
    // @ts-expect-error Looks like a node.
    return node && node.type && typeof node.type === "string" ? Boolean(check.call(context, node, index, parent)) : false;
};
const $56aea44d55896096$export$9c68d69a4c5bbcf9 = /**
   * @type {(
   *   (<Kind extends Node>(test: PredicateTest<Kind>) => AssertPredicate<Kind>) &
   *   ((test?: Test) => AssertAnything)
   * )}
   */ /**
     * @param {Test} [test]
     * @returns {AssertAnything}
     */ function(test) {
    if (test === undefined || test === null) return $56aea44d55896096$var$ok;
    if (typeof test === "string") return $56aea44d55896096$var$typeFactory(test);
    if (typeof test === "object") return Array.isArray(test) ? $56aea44d55896096$var$anyFactory(test) : $56aea44d55896096$var$propsFactory(test);
    if (typeof test === "function") return $56aea44d55896096$var$castFactory(test);
    throw new Error("Expected function, string, or object as test");
};
/**
 * @param {Array<string | Props | TestFunctionAnything>} tests
 * @returns {AssertAnything}
 */ function $56aea44d55896096$var$anyFactory(tests) {
    /** @type {Array<AssertAnything>} */ const checks = [];
    let index = -1;
    while(++index < tests.length)checks[index] = $56aea44d55896096$export$9c68d69a4c5bbcf9(tests[index]);
    return $56aea44d55896096$var$castFactory(any);
    /**
   * @this {unknown}
   * @param {Array<unknown>} parameters
   * @returns {boolean}
   */ function any(...parameters) {
        let index = -1;
        while(++index < checks.length){
            if (checks[index].call(this, ...parameters)) return true;
        }
        return false;
    }
}
/**
 * Turn an object into a test for a node with a certain fields.
 *
 * @param {Props} check
 * @returns {AssertAnything}
 */ function $56aea44d55896096$var$propsFactory(check) {
    return $56aea44d55896096$var$castFactory(all);
    /**
   * @param {Node} node
   * @returns {boolean}
   */ function all(node) {
        /** @type {string} */ let key;
        for(key in check){
            // @ts-expect-error: hush, it sure works as an index.
            if (node[key] !== check[key]) return false;
        }
        return true;
    }
}
/**
 * Turn a string into a test for a node with a certain type.
 *
 * @param {string} check
 * @returns {AssertAnything}
 */ function $56aea44d55896096$var$typeFactory(check) {
    return $56aea44d55896096$var$castFactory(type);
    /**
   * @param {Node} node
   */ function type(node) {
        return node && node.type === check;
    }
}
/**
 * Turn a custom test into a test for a node that passes that test.
 *
 * @param {TestFunctionAnything} check
 * @returns {AssertAnything}
 */ function $56aea44d55896096$var$castFactory(check) {
    return assertion;
    /**
   * @this {unknown}
   * @param {unknown} node
   * @param {Array<unknown>} parameters
   * @returns {boolean}
   */ function assertion(node, ...parameters) {
        return Boolean(node && typeof node === "object" && "type" in node && // @ts-expect-error: fine.
        Boolean(check.call(this, node, ...parameters)));
    }
}
function $56aea44d55896096$var$ok() {
    return true;
}


/**
 * @param {string} d
 * @returns {string}
 */ function $b6082889b9744ae1$export$35e9368ef982300f(d) {
    return d;
}


const $63387b479ea86693$export$f4d8133c446fe484 = true;
const $63387b479ea86693$export$7f100f842f565dc9 = false;
const $63387b479ea86693$export$8773f85c2fb2c116 = "skip";
const $63387b479ea86693$export$70008a21eb6de899 = /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */ /**
     * @param {Node} tree
     * @param {Test} test
     * @param {Visitor<Node>} visitor
     * @param {boolean | null | undefined} [reverse]
     * @returns {void}
     */ function(tree, test, visitor, reverse) {
    if (typeof test === "function" && typeof visitor !== "function") {
        reverse = visitor;
        // @ts-expect-error no visitor given, so `visitor` is test.
        visitor = test;
        test = null;
    }
    const is = (0, $56aea44d55896096$export$9c68d69a4c5bbcf9)(test);
    const step = reverse ? -1 : 1;
    factory(tree, undefined, [])();
    /**
       * @param {Node} node
       * @param {number | undefined} index
       * @param {Array<Parent>} parents
       */ function factory(node, index, parents) {
        /** @type {Record<string, unknown>} */ // @ts-expect-error: hush
        const value = node && typeof node === "object" ? node : {};
        if (typeof value.type === "string") {
            const name = // `hast`
            typeof value.tagName === "string" ? value.tagName : typeof value.name === "string" ? value.name : undefined;
            Object.defineProperty(visit, "name", {
                value: "node (" + (0, $b6082889b9744ae1$export$35e9368ef982300f)(node.type + (name ? "<" + name + ">" : "")) + ")"
            });
        }
        return visit;
        function visit() {
            /** @type {ActionTuple} */ let result = [];
            /** @type {ActionTuple} */ let subresult;
            /** @type {number} */ let offset;
            /** @type {Array<Parent>} */ let grandparents;
            if (!test || is(node, index, parents[parents.length - 1] || null)) {
                result = $63387b479ea86693$var$toResult(visitor(node, parents));
                if (result[0] === $63387b479ea86693$export$7f100f842f565dc9) return result;
            }
            // @ts-expect-error looks like a parent.
            if (node.children && result[0] !== $63387b479ea86693$export$8773f85c2fb2c116) {
                // @ts-expect-error looks like a parent.
                offset = (reverse ? node.children.length : -1) + step;
                // @ts-expect-error looks like a parent.
                grandparents = parents.concat(node);
                // @ts-expect-error looks like a parent.
                while(offset > -1 && offset < node.children.length){
                    // @ts-expect-error looks like a parent.
                    subresult = factory(node.children[offset], offset, grandparents)();
                    if (subresult[0] === $63387b479ea86693$export$7f100f842f565dc9) return subresult;
                    offset = typeof subresult[1] === "number" ? subresult[1] : offset + step;
                }
            }
            return result;
        }
    }
};
/**
 * Turn a return value into a clean result.
 *
 * @param {VisitorResult} value
 *   Valid return values from visitors.
 * @returns {ActionTuple}
 *   Clean result.
 */ function $63387b479ea86693$var$toResult(value) {
    if (Array.isArray(value)) return value;
    if (typeof value === "number") return [
        $63387b479ea86693$export$f4d8133c446fe484,
        value
    ];
    return [
        value
    ];
}


const $4eca242b64be92f7$export$bf638b60ea8b89b7 = /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */ /**
     * @param {Node} tree
     * @param {Test} test
     * @param {Visitor} visitor
     * @param {boolean | null | undefined} [reverse]
     * @returns {void}
     */ function(tree, test, visitor, reverse) {
    if (typeof test === "function" && typeof visitor !== "function") {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    (0, $63387b479ea86693$export$70008a21eb6de899)(tree, test, overload, reverse);
    /**
       * @param {Node} node
       * @param {Array<Parent>} parents
       */ function overload(node, parents) {
        const parent = parents[parents.length - 1];
        return visitor(node, parent ? parent.children.indexOf(node) : null, parent);
    }
};


/**
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */ /**
 * Get the starting point of `node`.
 *
 * @param node
 *   Node.
 * @returns
 *   Point.
 */ const $523db341d04a4f44$export$771bf3e4949bfbee = $523db341d04a4f44$var$point("start");
const $523db341d04a4f44$export$da309cdce9dc2a25 = $523db341d04a4f44$var$point("end");
function $523db341d04a4f44$export$5880b8b5730aff45(node) {
    return {
        start: $523db341d04a4f44$export$771bf3e4949bfbee(node),
        end: $523db341d04a4f44$export$da309cdce9dc2a25(node)
    };
}
/**
 * Get the positional info of `node`.
 *
 * @param {'start' | 'end'} type
 *   Side.
 * @returns
 *   Getter.
 */ function $523db341d04a4f44$var$point(type) {
    return point;
    /**
   * Get the point info of `node` at a bound side.
   *
   * @param {NodeLike | Node | null | undefined} [node]
   * @returns {Point}
   */ function point(node) {
        const point = node && node.position && node.position[type] || {};
        // To do: next major: don’t return points when invalid.
        return {
            // @ts-expect-error: in practice, null is allowed.
            line: point.line || null,
            // @ts-expect-error: in practice, null is allowed.
            column: point.column || null,
            // @ts-expect-error: in practice, null is allowed.
            offset: point.offset > -1 ? point.offset : null
        };
    }
}


/**
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef NodeLike
 * @property {PositionLike | null | undefined} [position]
 */ /**
 * Check if `node` is generated.
 *
 * @param {NodeLike | null | undefined} [node]
 *   Node to check.
 * @returns {boolean}
 *   Whether `node` is generated (does not have positional info).
 */ function $a0e1ebbf1f6cb515$export$41ad1363166ec91a(node) {
    return !node || !node.position || !node.position.start || !node.position.start.line || !node.position.start.column || !node.position.end || !node.position.end.line || !node.position.end.column;
}


/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Definition} Definition
 */ /**
 * @typedef {Root | Content} Node
 *
 * @callback GetDefinition
 *   Get a definition by identifier.
 * @param {string | null | undefined} [identifier]
 *   Identifier of definition.
 * @returns {Definition | null}
 *   Definition corresponding to `identifier` or `null`.
 */ 
const $1db3ee3d8fadb554$var$own = {}.hasOwnProperty;
function $1db3ee3d8fadb554$export$d79264f26953ec1(tree) {
    /** @type {Record<string, Definition>} */ const cache = Object.create(null);
    if (!tree || !tree.type) throw new Error("mdast-util-definitions expected node");
    (0, $4eca242b64be92f7$export$bf638b60ea8b89b7)(tree, "definition", (definition)=>{
        const id = $1db3ee3d8fadb554$var$clean(definition.identifier);
        if (id && !$1db3ee3d8fadb554$var$own.call(cache, id)) cache[id] = definition;
    });
    return definition;
    /** @type {GetDefinition} */ function definition(identifier) {
        const id = $1db3ee3d8fadb554$var$clean(identifier);
        // To do: next major: return `undefined` when not found.
        return id && $1db3ee3d8fadb554$var$own.call(cache, id) ? cache[id] : null;
    }
}
/**
 * @param {string | null | undefined} [value]
 * @returns {string}
 */ function $1db3ee3d8fadb554$var$clean(value) {
    return String(value || "").toUpperCase();
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `blockquote` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Blockquote} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $d242e085104ba3f8$export$67dc04e652a298ca(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "blockquote",
        properties: {},
        children: state.wrap(state.all(node), true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').Break} Break
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `break` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Break} node
 *   mdast node.
 * @returns {Array<Element | Text>}
 *   hast element content.
 */ function $633b1517e412e1a1$export$371da9dd35aba193(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "br",
        properties: {},
        children: []
    };
    state.patch(node, result);
    return [
        state.applyData(node, result),
        {
            type: "text",
            value: "\n"
        }
    ];
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Code} Code
 * @typedef {import('../state.js').State} State

 */ /**
 * Turn an mdast `code` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Code} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $c207a8a7cb19052d$export$6565f9f03506010b(state, node) {
    const value = node.value ? node.value + "\n" : "";
    // To do: next major, use `node.lang` w/o regex, the splitting’s been going
    // on for years in remark now.
    const lang = node.lang ? node.lang.match(/^[^ \t]+(?=[ \t]|$)/) : null;
    /** @type {Properties} */ const properties = {};
    if (lang) properties.className = [
        "language-" + lang
    ];
    // Create `<code>`.
    /** @type {Element} */ let result = {
        type: "element",
        tagName: "code",
        properties: properties,
        children: [
            {
                type: "text",
                value: value
            }
        ]
    };
    if (node.meta) result.data = {
        meta: node.meta
    };
    state.patch(node, result);
    result = state.applyData(node, result);
    // Create `<pre>`.
    result = {
        type: "element",
        tagName: "pre",
        properties: {},
        children: [
            result
        ]
    };
    state.patch(node, result);
    return result;
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Delete} Delete
 * @typedef {import('../state.js').State} State

 */ /**
 * Turn an mdast `delete` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Delete} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $e3c4b29a785a71d8$export$19426ff118fe8be(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "del",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `emphasis` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Emphasis} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $575a776c8f8e5137$export$bef81ba411953b51(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "em",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('mdast').FootnoteReference} FootnoteReference
 * @typedef {import('hast').Element} Element
 * @typedef {import('../state.js').State} State
 */ 
function $c9f498205c95616a$export$7f87ee744075c1ba(state, node) {
    const id = String(node.identifier).toUpperCase();
    const safeId = (0, $71b8b713c55a94fa$export$e42a3e39590d28b5)(id.toLowerCase());
    const index = state.footnoteOrder.indexOf(id);
    /** @type {number} */ let counter;
    if (index === -1) {
        state.footnoteOrder.push(id);
        state.footnoteCounts[id] = 1;
        counter = state.footnoteOrder.length;
    } else {
        state.footnoteCounts[id]++;
        counter = index + 1;
    }
    const reuseCounter = state.footnoteCounts[id];
    /** @type {Element} */ const link = {
        type: "element",
        tagName: "a",
        properties: {
            href: "#" + state.clobberPrefix + "fn-" + safeId,
            id: state.clobberPrefix + "fnref-" + safeId + (reuseCounter > 1 ? "-" + reuseCounter : ""),
            dataFootnoteRef: true,
            ariaDescribedBy: [
                "footnote-label"
            ]
        },
        children: [
            {
                type: "text",
                value: String(counter)
            }
        ]
    };
    state.patch(node, link);
    /** @type {Element} */ const sup = {
        type: "element",
        tagName: "sup",
        properties: {},
        children: [
            link
        ]
    };
    state.patch(node, sup);
    return state.applyData(node, sup);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Footnote} Footnote
 * @typedef {import('../state.js').State} State
 */ 
function $b3d0668491332358$export$3b6a720baa2c20ec(state, node) {
    const footnoteById = state.footnoteById;
    let no = 1;
    while(no in footnoteById)no++;
    const identifier = String(no);
    footnoteById[identifier] = {
        type: "footnoteDefinition",
        identifier: identifier,
        children: [
            {
                type: "paragraph",
                children: node.children
            }
        ],
        position: node.position
    };
    return (0, $c9f498205c95616a$export$7f87ee744075c1ba)(state, {
        type: "footnoteReference",
        identifier: identifier,
        position: node.position
    });
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `heading` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Heading} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $24f83cabfb6ba370$export$46e4a324ac90507f(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "h" + node.depth,
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').HTML} Html
 * @typedef {import('../state.js').State} State
 * @typedef {import('../../index.js').Raw} Raw
 */ /**
 * Turn an mdast `html` node into hast (`raw` node in dangerous mode, otherwise
 * nothing).
 *
 * @param {State} state
 *   Info passed around.
 * @param {Html} node
 *   mdast node.
 * @returns {Raw | Element | null}
 *   hast node.
 */ function $f2e1e0eb01bb20bf$export$c0bb0b647f701bb5(state, node) {
    if (state.dangerous) {
        /** @type {Raw} */ const result = {
            type: "raw",
            value: node.value
        };
        state.patch(node, result);
        return state.applyData(node, result);
    }
    // To do: next major: return `undefined`.
    return null;
}


/**
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('../state.js').State} State
 */ 
/**
 * @typedef {import('hast').ElementContent} ElementContent
 *
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Reference} Reference
 * @typedef {import('mdast').Root} Root
 *
 * @typedef {import('./state.js').State} State
 */ /**
 * @typedef {Root | Content} Nodes
 * @typedef {Extract<Nodes, Reference>} References
 */ // To do: next major: always return array.
/**
 * Return the content of a reference without definition as plain text.
 *
 * @param {State} state
 *   Info passed around.
 * @param {References} node
 *   Reference node (image, link).
 * @returns {ElementContent | Array<ElementContent>}
 *   hast content.
 */ function $77d43adcb88d6a00$export$3fdd26f3d9e7dc78(state, node) {
    const subtype = node.referenceType;
    let suffix = "]";
    if (subtype === "collapsed") suffix += "[]";
    else if (subtype === "full") suffix += "[" + (node.label || node.identifier) + "]";
    if (node.type === "imageReference") return {
        type: "text",
        value: "![" + node.alt + suffix
    };
    const contents = state.all(node);
    const head = contents[0];
    if (head && head.type === "text") head.value = "[" + head.value;
    else contents.unshift({
        type: "text",
        value: "["
    });
    const tail = contents[contents.length - 1];
    if (tail && tail.type === "text") tail.value += suffix;
    else contents.push({
        type: "text",
        value: suffix
    });
    return contents;
}


function $681bd17cef0949b9$export$f281796f6bc3b8db(state, node) {
    const def = state.definition(node.identifier);
    if (!def) return (0, $77d43adcb88d6a00$export$3fdd26f3d9e7dc78)(state, node);
    /** @type {Properties} */ const properties = {
        src: (0, $71b8b713c55a94fa$export$e42a3e39590d28b5)(def.url || ""),
        alt: node.alt
    };
    if (def.title !== null && def.title !== undefined) properties.title = def.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "img",
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Image} Image
 * @typedef {import('../state.js').State} State
 */ 
function $4e441523cdd32e5b$export$5c452ff88e35e47d(state, node) {
    /** @type {Properties} */ const properties = {
        src: (0, $71b8b713c55a94fa$export$e42a3e39590d28b5)(node.url)
    };
    if (node.alt !== null && node.alt !== undefined) properties.alt = node.alt;
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "img",
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `inlineCode` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {InlineCode} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $7e2718cca44b11f8$export$91b9bee19a0d8569(state, node) {
    /** @type {Text} */ const text = {
        type: "text",
        value: node.value.replace(/\r?\n|\r/g, " ")
    };
    state.patch(node, text);
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "code",
        properties: {},
        children: [
            text
        ]
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('../state.js').State} State
 */ 

function $c7e9ccbb9238ed8b$export$e6c469b1b7b2bc6a(state, node) {
    const def = state.definition(node.identifier);
    if (!def) return (0, $77d43adcb88d6a00$export$3fdd26f3d9e7dc78)(state, node);
    /** @type {Properties} */ const properties = {
        href: (0, $71b8b713c55a94fa$export$e42a3e39590d28b5)(def.url || "")
    };
    if (def.title !== null && def.title !== undefined) properties.title = def.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "a",
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Link} Link
 * @typedef {import('../state.js').State} State
 */ 
function $db94ffb885af320d$export$9c30223ca0a664fb(state, node) {
    /** @type {Properties} */ const properties = {
        href: (0, $71b8b713c55a94fa$export$e42a3e39590d28b5)(node.url)
    };
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "a",
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('../state.js').State} State
 */ /**
 * @typedef {Root | Content} Nodes
 * @typedef {Extract<Nodes, Parent>} Parents
 */ /**
 * Turn an mdast `listItem` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ListItem} node
 *   mdast node.
 * @param {Parents | null | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */ function $e631e57959208ed4$export$76c7e83ecc9cdf05(state, node, parent) {
    const results = state.all(node);
    const loose = parent ? $e631e57959208ed4$var$listLoose(parent) : $e631e57959208ed4$var$listItemLoose(node);
    /** @type {Properties} */ const properties = {};
    /** @type {Array<ElementContent>} */ const children = [];
    if (typeof node.checked === "boolean") {
        const head = results[0];
        /** @type {Element} */ let paragraph;
        if (head && head.type === "element" && head.tagName === "p") paragraph = head;
        else {
            paragraph = {
                type: "element",
                tagName: "p",
                properties: {},
                children: []
            };
            results.unshift(paragraph);
        }
        if (paragraph.children.length > 0) paragraph.children.unshift({
            type: "text",
            value: " "
        });
        paragraph.children.unshift({
            type: "element",
            tagName: "input",
            properties: {
                type: "checkbox",
                checked: node.checked,
                disabled: true
            },
            children: []
        });
        // According to github-markdown-css, this class hides bullet.
        // See: <https://github.com/sindresorhus/github-markdown-css>.
        properties.className = [
            "task-list-item"
        ];
    }
    let index = -1;
    while(++index < results.length){
        const child = results[index];
        // Add eols before nodes, except if this is a loose, first paragraph.
        if (loose || index !== 0 || child.type !== "element" || child.tagName !== "p") children.push({
            type: "text",
            value: "\n"
        });
        if (child.type === "element" && child.tagName === "p" && !loose) children.push(...child.children);
        else children.push(child);
    }
    const tail = results[results.length - 1];
    // Add a final eol.
    if (tail && (loose || tail.type !== "element" || tail.tagName !== "p")) children.push({
        type: "text",
        value: "\n"
    });
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "li",
        properties: properties,
        children: children
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
/**
 * @param {Parents} node
 * @return {Boolean}
 */ function $e631e57959208ed4$var$listLoose(node) {
    let loose = false;
    if (node.type === "list") {
        loose = node.spread || false;
        const children = node.children;
        let index = -1;
        while(!loose && ++index < children.length)loose = $e631e57959208ed4$var$listItemLoose(children[index]);
    }
    return loose;
}
/**
 * @param {ListItem} node
 * @return {Boolean}
 */ function $e631e57959208ed4$var$listItemLoose(node) {
    const spread = node.spread;
    return spread === undefined || spread === null ? node.children.length > 1 : spread;
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').List} List
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `list` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {List} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $ec1629c18cf7ef3a$export$8837f4fc672e936d(state, node) {
    /** @type {Properties} */ const properties = {};
    const results = state.all(node);
    let index = -1;
    if (typeof node.start === "number" && node.start !== 1) properties.start = node.start;
    // Like GitHub, add a class for custom styling.
    while(++index < results.length){
        const child = results[index];
        if (child.type === "element" && child.tagName === "li" && child.properties && Array.isArray(child.properties.className) && child.properties.className.includes("task-list-item")) {
            properties.className = [
                "contains-task-list"
            ];
            break;
        }
    }
    /** @type {Element} */ const result = {
        type: "element",
        tagName: node.ordered ? "ol" : "ul",
        properties: properties,
        children: state.wrap(results, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `paragraph` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Paragraph} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $cfe2f4433f9c1be4$export$9c206ddddb32a9b(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "p",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `root` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastRoot} node
 *   mdast node.
 * @returns {HastRoot | HastElement}
 *   hast node.
 */ function $3558513919212946$export$e8e78c978b129247(state, node) {
    /** @type {HastRoot} */ const result = {
        type: "root",
        children: state.wrap(state.all(node))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `strong` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Strong} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $6bf7a7749e4b085a$export$59ae2c325a998f89(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "strong",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Table} Table
 * @typedef {import('../state.js').State} State
 */ 
function $7d870ff20f68676f$export$9852986a3ec5f6a0(state, node) {
    const rows = state.all(node);
    const firstRow = rows.shift();
    /** @type {Array<Element>} */ const tableContent = [];
    if (firstRow) {
        /** @type {Element} */ const head = {
            type: "element",
            tagName: "thead",
            properties: {},
            children: state.wrap([
                firstRow
            ], true)
        };
        state.patch(node.children[0], head);
        tableContent.push(head);
    }
    if (rows.length > 0) {
        /** @type {Element} */ const body = {
            type: "element",
            tagName: "tbody",
            properties: {},
            children: state.wrap(rows, true)
        };
        const start = (0, $523db341d04a4f44$export$771bf3e4949bfbee)(node.children[1]);
        const end = (0, $523db341d04a4f44$export$da309cdce9dc2a25)(node.children[node.children.length - 1]);
        if (start.line && end.line) body.position = {
            start: start,
            end: end
        };
        tableContent.push(body);
    }
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "table",
        properties: {},
        children: state.wrap(tableContent, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').TableRow} TableRow
 * @typedef {import('../state.js').State} State
 */ /**
 * @typedef {Root | Content} Nodes
 * @typedef {Extract<Nodes, Parent>} Parents
 */ /**
 * Turn an mdast `tableRow` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableRow} node
 *   mdast node.
 * @param {Parents | null | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */ function $ee4c412ae252045d$export$ce666bf02318c957(state, node, parent) {
    const siblings = parent ? parent.children : undefined;
    // Generate a body row when without parent.
    const rowIndex = siblings ? siblings.indexOf(node) : 1;
    const tagName = rowIndex === 0 ? "th" : "td";
    const align = parent && parent.type === "table" ? parent.align : undefined;
    const length = align ? align.length : node.children.length;
    let cellIndex = -1;
    /** @type {Array<ElementContent>} */ const cells = [];
    while(++cellIndex < length){
        // Note: can also be undefined.
        const cell = node.children[cellIndex];
        /** @type {Properties} */ const properties = {};
        const alignValue = align ? align[cellIndex] : undefined;
        if (alignValue) properties.align = alignValue;
        /** @type {Element} */ let result = {
            type: "element",
            tagName: tagName,
            properties: properties,
            children: []
        };
        if (cell) {
            result.children = state.all(cell);
            state.patch(cell, result);
            result = state.applyData(node, result);
        }
        cells.push(result);
    }
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "tr",
        properties: {},
        children: state.wrap(cells, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `tableCell` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableCell} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $ef32404369db060d$export$e1e720e5f4603e6a(state, node) {
    // Note: this function is normally not called: see `table-row` for how rows
    // and their cells are compiled.
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "td",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('hast').Text} HastText
 * @typedef {import('mdast').Text} MdastText
 * @typedef {import('../state.js').State} State
 */ const $efbee8c8fdf5312c$var$tab = 9 /* `\t` */ ;
const $efbee8c8fdf5312c$var$space = 32 /* ` ` */ ;
function $efbee8c8fdf5312c$export$a771f20bdd13def9(value) {
    const source = String(value);
    const search = /\r?\n|\r/g;
    let match = search.exec(source);
    let last = 0;
    /** @type {Array<string>} */ const lines = [];
    while(match){
        lines.push($efbee8c8fdf5312c$var$trimLine(source.slice(last, match.index), last > 0, true), match[0]);
        last = match.index + match[0].length;
        match = search.exec(source);
    }
    lines.push($efbee8c8fdf5312c$var$trimLine(source.slice(last), last > 0, false));
    return lines.join("");
}
/**
 * @param {string} value
 *   Line to trim.
 * @param {boolean} start
 *   Whether to trim the start of the line.
 * @param {boolean} end
 *   Whether to trim the end of the line.
 * @returns {string}
 *   Trimmed line.
 */ function $efbee8c8fdf5312c$var$trimLine(value, start, end) {
    let startIndex = 0;
    let endIndex = value.length;
    if (start) {
        let code = value.codePointAt(startIndex);
        while(code === $efbee8c8fdf5312c$var$tab || code === $efbee8c8fdf5312c$var$space){
            startIndex++;
            code = value.codePointAt(startIndex);
        }
    }
    if (end) {
        let code = value.codePointAt(endIndex - 1);
        while(code === $efbee8c8fdf5312c$var$tab || code === $efbee8c8fdf5312c$var$space){
            endIndex--;
            code = value.codePointAt(endIndex - 1);
        }
    }
    return endIndex > startIndex ? value.slice(startIndex, endIndex) : "";
}


function $1773135610ce6f72$export$6f093cfa640b7166(state, node) {
    /** @type {HastText} */ const result = {
        type: "text",
        value: (0, $efbee8c8fdf5312c$export$a771f20bdd13def9)(String(node.value))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `thematicBreak` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ThematicBreak} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $6f3afb72d4e44aef$export$ba7b13e047416c03(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "hr",
        properties: {},
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


const $fbe0e3949c99d45b$export$455ce229eb3d2472 = {
    blockquote: $d242e085104ba3f8$export$67dc04e652a298ca,
    break: (0, $633b1517e412e1a1$export$371da9dd35aba193),
    code: $c207a8a7cb19052d$export$6565f9f03506010b,
    delete: (0, $e3c4b29a785a71d8$export$19426ff118fe8be),
    emphasis: $575a776c8f8e5137$export$bef81ba411953b51,
    footnoteReference: $c9f498205c95616a$export$7f87ee744075c1ba,
    footnote: $b3d0668491332358$export$3b6a720baa2c20ec,
    heading: $24f83cabfb6ba370$export$46e4a324ac90507f,
    html: $f2e1e0eb01bb20bf$export$c0bb0b647f701bb5,
    imageReference: $681bd17cef0949b9$export$f281796f6bc3b8db,
    image: $4e441523cdd32e5b$export$5c452ff88e35e47d,
    inlineCode: $7e2718cca44b11f8$export$91b9bee19a0d8569,
    linkReference: $c7e9ccbb9238ed8b$export$e6c469b1b7b2bc6a,
    link: $db94ffb885af320d$export$9c30223ca0a664fb,
    listItem: $e631e57959208ed4$export$76c7e83ecc9cdf05,
    list: $ec1629c18cf7ef3a$export$8837f4fc672e936d,
    paragraph: $cfe2f4433f9c1be4$export$9c206ddddb32a9b,
    root: $3558513919212946$export$e8e78c978b129247,
    strong: $6bf7a7749e4b085a$export$59ae2c325a998f89,
    table: $7d870ff20f68676f$export$9852986a3ec5f6a0,
    tableCell: $ef32404369db060d$export$e1e720e5f4603e6a,
    tableRow: $ee4c412ae252045d$export$ce666bf02318c957,
    text: $1773135610ce6f72$export$6f093cfa640b7166,
    thematicBreak: $6f3afb72d4e44aef$export$ba7b13e047416c03,
    toml: $fbe0e3949c99d45b$var$ignore,
    yaml: $fbe0e3949c99d45b$var$ignore,
    definition: $fbe0e3949c99d45b$var$ignore,
    footnoteDefinition: $fbe0e3949c99d45b$var$ignore
};
// Return nothing for nodes that are ignored.
function $fbe0e3949c99d45b$var$ignore() {
    // To do: next major: return `undefined`.
    return null;
}


const $2a582231fb1c4a06$var$own = {}.hasOwnProperty;
function $2a582231fb1c4a06$export$e6a0daad8304de(tree, options) {
    const settings = options || {};
    const dangerous = settings.allowDangerousHtml || false;
    /** @type {Record<string, MdastFootnoteDefinition>} */ const footnoteById = {};
    // To do: next major: add `options` to state, remove:
    // `dangerous`, `clobberPrefix`, `footnoteLabel`, `footnoteLabelTagName`,
    // `footnoteLabelProperties`, `footnoteBackLabel`, `passThrough`,
    // `unknownHandler`.
    // To do: next major: move to `state.options.allowDangerousHtml`.
    state.dangerous = dangerous;
    // To do: next major: move to `state.options`.
    state.clobberPrefix = settings.clobberPrefix === undefined || settings.clobberPrefix === null ? "user-content-" : settings.clobberPrefix;
    // To do: next major: move to `state.options`.
    state.footnoteLabel = settings.footnoteLabel || "Footnotes";
    // To do: next major: move to `state.options`.
    state.footnoteLabelTagName = settings.footnoteLabelTagName || "h2";
    // To do: next major: move to `state.options`.
    state.footnoteLabelProperties = settings.footnoteLabelProperties || {
        className: [
            "sr-only"
        ]
    };
    // To do: next major: move to `state.options`.
    state.footnoteBackLabel = settings.footnoteBackLabel || "Back to content";
    // To do: next major: move to `state.options`.
    state.unknownHandler = settings.unknownHandler;
    // To do: next major: move to `state.options`.
    state.passThrough = settings.passThrough;
    state.handlers = {
        ...(0, $fbe0e3949c99d45b$export$455ce229eb3d2472),
        ...settings.handlers
    };
    // To do: next major: replace utility with `definitionById` object, so we
    // only walk once (as we need footnotes too).
    state.definition = (0, $1db3ee3d8fadb554$export$d79264f26953ec1)(tree);
    state.footnoteById = footnoteById;
    /** @type {Array<string>} */ state.footnoteOrder = [];
    /** @type {Record<string, number>} */ state.footnoteCounts = {};
    state.patch = $2a582231fb1c4a06$var$patch;
    state.applyData = $2a582231fb1c4a06$var$applyData;
    state.one = oneBound;
    state.all = allBound;
    state.wrap = $2a582231fb1c4a06$export$4997ffc0176396a6;
    // To do: next major: remove `augment`.
    state.augment = augment;
    (0, $4eca242b64be92f7$export$bf638b60ea8b89b7)(tree, "footnoteDefinition", (definition)=>{
        const id = String(definition.identifier).toUpperCase();
        // Mimick CM behavior of link definitions.
        // See: <https://github.com/syntax-tree/mdast-util-definitions/blob/8290999/index.js#L26>.
        if (!$2a582231fb1c4a06$var$own.call(footnoteById, id)) footnoteById[id] = definition;
    });
    // @ts-expect-error Hush, it’s fine!
    return state;
    /**
   * Finalise the created `right`, a hast node, from `left`, an mdast node.
   *
   * @param {MdastNodeWithData | PositionLike | null | undefined} left
   * @param {HastElementContent} right
   * @returns {HastElementContent}
   */ /* c8 ignore start */ // To do: next major: remove.
    function augment(left, right) {
        // Handle `data.hName`, `data.hProperties, `data.hChildren`.
        if (left && "data" in left && left.data) {
            /** @type {MdastData} */ const data = left.data;
            if (data.hName) {
                if (right.type !== "element") right = {
                    type: "element",
                    tagName: "",
                    properties: {},
                    children: []
                };
                right.tagName = data.hName;
            }
            if (right.type === "element" && data.hProperties) right.properties = {
                ...right.properties,
                ...data.hProperties
            };
            if ("children" in right && right.children && data.hChildren) right.children = data.hChildren;
        }
        if (left) {
            const ctx = "type" in left ? left : {
                position: left
            };
            if (!(0, $a0e1ebbf1f6cb515$export$41ad1363166ec91a)(ctx)) // @ts-expect-error: fine.
            right.position = {
                start: (0, $523db341d04a4f44$export$771bf3e4949bfbee)(ctx),
                end: (0, $523db341d04a4f44$export$da309cdce9dc2a25)(ctx)
            };
        }
        return right;
    }
    /* c8 ignore stop */ /**
   * Create an element for `node`.
   *
   * @type {HFunctionProps}
   */ /* c8 ignore start */ // To do: next major: remove.
    function state(node, tagName, props, children) {
        if (Array.isArray(props)) {
            children = props;
            props = {};
        }
        // @ts-expect-error augmenting an element yields an element.
        return augment(node, {
            type: "element",
            tagName: tagName,
            properties: props || {},
            children: children || []
        });
    }
    /* c8 ignore stop */ /**
   * Transform an mdast node into a hast node.
   *
   * @param {MdastNodes} node
   *   mdast node.
   * @param {MdastParents | null | undefined} [parent]
   *   Parent of `node`.
   * @returns {HastElementContent | Array<HastElementContent> | null | undefined}
   *   Resulting hast node.
   */ function oneBound(node, parent) {
        // @ts-expect-error: that’s a state :)
        return $2a582231fb1c4a06$export$80bf7733f1207381(state, node, parent);
    }
    /**
   * Transform the children of an mdast node into hast nodes.
   *
   * @param {MdastNodes} parent
   *   mdast node to compile
   * @returns {Array<HastElementContent>}
   *   Resulting hast nodes.
   */ function allBound(parent) {
        // @ts-expect-error: that’s a state :)
        return $2a582231fb1c4a06$export$84bf76cd7afc7469(state, parent);
    }
}
/**
 * Copy a node’s positional info.
 *
 * @param {MdastNodes} from
 *   mdast node to copy from.
 * @param {HastNodes} to
 *   hast node to copy into.
 * @returns {void}
 *   Nothing.
 */ function $2a582231fb1c4a06$var$patch(from, to) {
    if (from.position) to.position = (0, $523db341d04a4f44$export$5880b8b5730aff45)(from);
}
/**
 * Honor the `data` of `from` and maybe generate an element instead of `to`.
 *
 * @template {HastNodes} Type
 *   Node type.
 * @param {MdastNodes} from
 *   mdast node to use data from.
 * @param {Type} to
 *   hast node to change.
 * @returns {Type | HastElement}
 *   Nothing.
 */ function $2a582231fb1c4a06$var$applyData(from, to) {
    /** @type {Type | HastElement} */ let result = to;
    // Handle `data.hName`, `data.hProperties, `data.hChildren`.
    if (from && from.data) {
        const hName = from.data.hName;
        const hChildren = from.data.hChildren;
        const hProperties = from.data.hProperties;
        if (typeof hName === "string") {
            // Transforming the node resulted in an element with a different name
            // than wanted:
            if (result.type === "element") result.tagName = hName;
            else result = {
                type: "element",
                tagName: hName,
                properties: {},
                children: []
            };
        }
        if (result.type === "element" && hProperties) result.properties = {
            ...result.properties,
            ...hProperties
        };
        if ("children" in result && result.children && hChildren !== null && hChildren !== undefined) // @ts-expect-error: assume valid children are defined.
        result.children = hChildren;
    }
    return result;
}
function $2a582231fb1c4a06$export$80bf7733f1207381(state, node, parent) {
    const type = node && node.type;
    // Fail on non-nodes.
    if (!type) throw new Error("Expected node, got `" + node + "`");
    if ($2a582231fb1c4a06$var$own.call(state.handlers, type)) return state.handlers[type](state, node, parent);
    if (state.passThrough && state.passThrough.includes(type)) // To do: next major: deep clone.
    // @ts-expect-error: types of passed through nodes are expected to be added manually.
    return "children" in node ? {
        ...node,
        children: $2a582231fb1c4a06$export$84bf76cd7afc7469(state, node)
    } : node;
    if (state.unknownHandler) return state.unknownHandler(state, node, parent);
    return $2a582231fb1c4a06$var$defaultUnknownHandler(state, node);
}
function $2a582231fb1c4a06$export$84bf76cd7afc7469(state, parent) {
    /** @type {Array<HastElementContent>} */ const values = [];
    if ("children" in parent) {
        const nodes = parent.children;
        let index = -1;
        while(++index < nodes.length){
            const result = $2a582231fb1c4a06$export$80bf7733f1207381(state, nodes[index], parent);
            // To do: see if we van clean this? Can we merge texts?
            if (result) {
                if (index && nodes[index - 1].type === "break") {
                    if (!Array.isArray(result) && result.type === "text") result.value = result.value.replace(/^\s+/, "");
                    if (!Array.isArray(result) && result.type === "element") {
                        const head = result.children[0];
                        if (head && head.type === "text") head.value = head.value.replace(/^\s+/, "");
                    }
                }
                if (Array.isArray(result)) values.push(...result);
                else values.push(result);
            }
        }
    }
    return values;
}
/**
 * Transform an unknown node.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastNodes} node
 *   Unknown mdast node.
 * @returns {HastText | HastElement}
 *   Resulting hast node.
 */ function $2a582231fb1c4a06$var$defaultUnknownHandler(state, node) {
    const data = node.data || {};
    /** @type {HastText | HastElement} */ const result = "value" in node && !($2a582231fb1c4a06$var$own.call(data, "hProperties") || $2a582231fb1c4a06$var$own.call(data, "hChildren")) ? {
        type: "text",
        value: node.value
    } : {
        type: "element",
        tagName: "div",
        properties: {},
        children: $2a582231fb1c4a06$export$84bf76cd7afc7469(state, node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
function $2a582231fb1c4a06$export$4997ffc0176396a6(nodes, loose) {
    /** @type {Array<Type | HastText>} */ const result = [];
    let index = -1;
    if (loose) result.push({
        type: "text",
        value: "\n"
    });
    while(++index < nodes.length){
        if (index) result.push({
            type: "text",
            value: "\n"
        });
        result.push(nodes[index]);
    }
    if (loose && nodes.length > 0) result.push({
        type: "text",
        value: "\n"
    });
    return result;
}


function $5e12bd5bbdd137e9$export$c0e4c5cf07538633(tree, options) {
    const state = (0, $2a582231fb1c4a06$export$e6a0daad8304de)(tree, options);
    const node = state.one(tree, null);
    const foot = (0, $2fef6b3d3c71f718$export$adb608be33961c98)(state);
    if (foot) // @ts-expect-error If there’s a footer, there were definitions, meaning block
    // content.
    // So assume `node` is a parent node.
    node.children.push({
        type: "text",
        value: "\n"
    }, foot);
    // To do: next major: always return root?
    return Array.isArray(node) ? {
        type: "root",
        children: node
    } : node;
}


// Note: the `<MdastRoot, HastRoot>` overload doesn’t seem to work :'(
/**
 * Plugin that turns markdown into HTML to support rehype.
 *
 * *   If a destination processor is given, that processor runs with a new HTML
 *     (hast) tree (bridge-mode).
 *     As the given processor runs with a hast tree, and rehype plugins support
 *     hast, that means rehype plugins can be used with the given processor.
 *     The hast tree is discarded in the end.
 *     It’s highly unlikely that you want to do this.
 * *   The common case is to not pass a destination processor, in which case the
 *     current processor continues running with a new HTML (hast) tree
 *     (mutate-mode).
 *     As the current processor continues with a hast tree, and rehype plugins
 *     support hast, that means rehype plugins can be used after
 *     `remark-rehype`.
 *     It’s likely that this is what you want to do.
 *
 * @param destination
 *   Optional unified processor.
 * @param options
 *   Options passed to `mdast-util-to-hast`.
 */ const $da90f3b8a7ea3e41$var$remarkRehype = /** @type {(import('unified').Plugin<[Processor, Options?]|[null|undefined, Options?]|[Options]|[], MdastRoot>)} */ function(destination, options) {
    return destination && "run" in destination ? $da90f3b8a7ea3e41$var$bridge(destination, options) : $da90f3b8a7ea3e41$var$mutate(destination || options);
};
var $da90f3b8a7ea3e41$export$2e2bcd8739ae039 = $da90f3b8a7ea3e41$var$remarkRehype;
/**
 * Bridge-mode.
 * Runs the destination with the new hast tree.
 *
 * @type {import('unified').Plugin<[Processor, Options?], MdastRoot>}
 */ function $da90f3b8a7ea3e41$var$bridge(destination, options) {
    return (node, file, next)=>{
        destination.run((0, $5e12bd5bbdd137e9$export$c0e4c5cf07538633)(node, options), file, (error)=>{
            next(error);
        });
    };
}
/**
 * Mutate-mode.
 * Further plugins run on the hast tree.
 *
 * @type {import('unified').Plugin<[Options?]|void[], MdastRoot, HastRoot>}
 */ function $da90f3b8a7ea3e41$var$mutate(options) {
    // @ts-expect-error: assume a corresponding node is returned by `toHast`.
    return (node)=>(0, $5e12bd5bbdd137e9$export$c0e4c5cf07538633)(node, options);
}



var $aMJGV = parcelRequire("aMJGV");
/**
 * @typedef {import('./lib/util/info.js').Info} Info
 * @typedef {import('./lib/util/schema.js').Schema} Schema
 */ /**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 */ /**
 * @typedef {import('./info.js').Info} Info
 * @typedef {Record<string, Info>} Properties
 * @typedef {Record<string, string>} Normal
 */ class $2b47a7211df630eb$export$19342e026b58ebb7 {
    /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */ constructor(property, normal, space){
        this.property = property;
        this.normal = normal;
        if (space) this.space = space;
    }
}
/** @type {Properties} */ $2b47a7211df630eb$export$19342e026b58ebb7.prototype.property = {};
/** @type {Normal} */ $2b47a7211df630eb$export$19342e026b58ebb7.prototype.normal = {};
/** @type {string|null} */ $2b47a7211df630eb$export$19342e026b58ebb7.prototype.space = null;


function $b3a48325d91bf280$export$4950aa0f605343fb(definitions, space) {
    /** @type {Properties} */ const property = {};
    /** @type {Normal} */ const normal = {};
    let index = -1;
    while(++index < definitions.length){
        Object.assign(property, definitions[index].property);
        Object.assign(normal, definitions[index].normal);
    }
    return new (0, $2b47a7211df630eb$export$19342e026b58ebb7)(property, normal, space);
}


/**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 *
 * @typedef {Record<string, string>} Attributes
 *
 * @typedef {Object} Definition
 * @property {Record<string, number|null>} properties
 * @property {(attributes: Attributes, property: string) => string} transform
 * @property {string} [space]
 * @property {Attributes} [attributes]
 * @property {Array<string>} [mustUseProperty]
 */ /**
 * @param {string} value
 * @returns {string}
 */ function $104dbd7c605e9c49$export$a3295358bff77e(value) {
    return value.toLowerCase();
}



class $745dee82661052ac$export$c4868e4a24d48fad {
    /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */ constructor(property, attribute){
        /** @type {string} */ this.property = property;
        /** @type {string} */ this.attribute = attribute;
    }
}
/** @type {string|null} */ $745dee82661052ac$export$c4868e4a24d48fad.prototype.space = null;
$745dee82661052ac$export$c4868e4a24d48fad.prototype.boolean = false;
$745dee82661052ac$export$c4868e4a24d48fad.prototype.booleanish = false;
$745dee82661052ac$export$c4868e4a24d48fad.prototype.overloadedBoolean = false;
$745dee82661052ac$export$c4868e4a24d48fad.prototype.number = false;
$745dee82661052ac$export$c4868e4a24d48fad.prototype.commaSeparated = false;
$745dee82661052ac$export$c4868e4a24d48fad.prototype.spaceSeparated = false;
$745dee82661052ac$export$c4868e4a24d48fad.prototype.commaOrSpaceSeparated = false;
$745dee82661052ac$export$c4868e4a24d48fad.prototype.mustUseProperty = false;
$745dee82661052ac$export$c4868e4a24d48fad.prototype.defined = false;


var $36849e0eaf9cb699$exports = {};

$parcel$export($36849e0eaf9cb699$exports, "boolean", function () { return $36849e0eaf9cb699$export$4a21f16c33752377; });
$parcel$export($36849e0eaf9cb699$exports, "booleanish", function () { return $36849e0eaf9cb699$export$55e9e1fbc638dc8f; });
$parcel$export($36849e0eaf9cb699$exports, "overloadedBoolean", function () { return $36849e0eaf9cb699$export$242ac3d3042558aa; });
$parcel$export($36849e0eaf9cb699$exports, "number", function () { return $36849e0eaf9cb699$export$98e628dec113755e; });
$parcel$export($36849e0eaf9cb699$exports, "spaceSeparated", function () { return $36849e0eaf9cb699$export$ab8645c862eb5a3e; });
$parcel$export($36849e0eaf9cb699$exports, "commaSeparated", function () { return $36849e0eaf9cb699$export$9c8d678629b3d3; });
$parcel$export($36849e0eaf9cb699$exports, "commaOrSpaceSeparated", function () { return $36849e0eaf9cb699$export$2ad25cfebf36cacd; });
let $36849e0eaf9cb699$var$powers = 0;
const $36849e0eaf9cb699$export$4a21f16c33752377 = $36849e0eaf9cb699$var$increment();
const $36849e0eaf9cb699$export$55e9e1fbc638dc8f = $36849e0eaf9cb699$var$increment();
const $36849e0eaf9cb699$export$242ac3d3042558aa = $36849e0eaf9cb699$var$increment();
const $36849e0eaf9cb699$export$98e628dec113755e = $36849e0eaf9cb699$var$increment();
const $36849e0eaf9cb699$export$ab8645c862eb5a3e = $36849e0eaf9cb699$var$increment();
const $36849e0eaf9cb699$export$9c8d678629b3d3 = $36849e0eaf9cb699$var$increment();
const $36849e0eaf9cb699$export$2ad25cfebf36cacd = $36849e0eaf9cb699$var$increment();
function $36849e0eaf9cb699$var$increment() {
    return 2 ** ++$36849e0eaf9cb699$var$powers;
}


/** @type {Array<keyof types>} */ // @ts-expect-error: hush.
const $6b356b3398566d36$var$checks = Object.keys($36849e0eaf9cb699$exports);
class $6b356b3398566d36$export$ea6b9f0064e88c9b extends (0, $745dee82661052ac$export$c4868e4a24d48fad) {
    /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */ constructor(property, attribute, mask, space){
        let index = -1;
        super(property, attribute);
        $6b356b3398566d36$var$mark(this, "space", space);
        if (typeof mask === "number") while(++index < $6b356b3398566d36$var$checks.length){
            const check = $6b356b3398566d36$var$checks[index];
            $6b356b3398566d36$var$mark(this, $6b356b3398566d36$var$checks[index], (mask & $36849e0eaf9cb699$exports[check]) === $36849e0eaf9cb699$exports[check]);
        }
    }
}
$6b356b3398566d36$export$ea6b9f0064e88c9b.prototype.defined = true;
/**
 * @param {DefinedInfo} values
 * @param {string} key
 * @param {unknown} value
 */ function $6b356b3398566d36$var$mark(values, key, value) {
    if (value) // @ts-expect-error: assume `value` matches the expected value of `key`.
    values[key] = value;
}


const $48f49204fef71f27$var$own = {}.hasOwnProperty;
function $48f49204fef71f27$export$185802fd694ee1f5(definition) {
    /** @type {Properties} */ const property = {};
    /** @type {Normal} */ const normal = {};
    /** @type {string} */ let prop;
    for(prop in definition.properties)if ($48f49204fef71f27$var$own.call(definition.properties, prop)) {
        const value = definition.properties[prop];
        const info = new (0, $6b356b3398566d36$export$ea6b9f0064e88c9b)(prop, definition.transform(definition.attributes || {}, prop), value, definition.space);
        if (definition.mustUseProperty && definition.mustUseProperty.includes(prop)) info.mustUseProperty = true;
        property[prop] = info;
        normal[(0, $104dbd7c605e9c49$export$a3295358bff77e)(prop)] = prop;
        normal[(0, $104dbd7c605e9c49$export$a3295358bff77e)(info.attribute)] = prop;
    }
    return new (0, $2b47a7211df630eb$export$19342e026b58ebb7)(property, normal, definition.space);
}


const $6da52ca508f6ba5f$export$2bd1230ec7600845 = (0, $48f49204fef71f27$export$185802fd694ee1f5)({
    space: "xlink",
    transform (_, prop) {
        return "xlink:" + prop.slice(5).toLowerCase();
    },
    properties: {
        xLinkActuate: null,
        xLinkArcRole: null,
        xLinkHref: null,
        xLinkRole: null,
        xLinkShow: null,
        xLinkTitle: null,
        xLinkType: null
    }
});



const $033fa216ce000390$export$f2913fe8983302e = (0, $48f49204fef71f27$export$185802fd694ee1f5)({
    space: "xml",
    transform (_, prop) {
        return "xml:" + prop.slice(3).toLowerCase();
    },
    properties: {
        xmlLang: null,
        xmlBase: null,
        xmlSpace: null
    }
});



/**
 * @param {Record<string, string>} attributes
 * @param {string} attribute
 * @returns {string}
 */ function $a1e3f2db5dc0e699$export$5b10b3bc32d7efbc(attributes, attribute) {
    return attribute in attributes ? attributes[attribute] : attribute;
}


function $13bf1f82a92db732$export$32b9e4cec9c208e1(attributes, property) {
    return (0, $a1e3f2db5dc0e699$export$5b10b3bc32d7efbc)(attributes, property.toLowerCase());
}


const $78e4052598572435$export$e20c24a128671213 = (0, $48f49204fef71f27$export$185802fd694ee1f5)({
    space: "xmlns",
    attributes: {
        xmlnsxlink: "xmlns:xlink"
    },
    transform: (0, $13bf1f82a92db732$export$32b9e4cec9c208e1),
    properties: {
        xmlns: null,
        xmlnsXLink: null
    }
});




const $82e562d4bebf3f08$export$4d2d26490572750a = (0, $48f49204fef71f27$export$185802fd694ee1f5)({
    transform (_, prop) {
        return prop === "role" ? prop : "aria-" + prop.slice(4).toLowerCase();
    },
    properties: {
        ariaActiveDescendant: null,
        ariaAtomic: (0, $36849e0eaf9cb699$export$55e9e1fbc638dc8f),
        ariaAutoComplete: null,
        ariaBusy: (0, $36849e0eaf9cb699$export$55e9e1fbc638dc8f),
        ariaChecked: (0, $36849e0eaf9cb699$export$55e9e1fbc638dc8f),
        ariaColCount: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        ariaColIndex: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        ariaColSpan: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        ariaControls: (0, $36849e0eaf9cb699$export$ab8645c862eb5a3e),
        ariaCurrent: null,
        ariaDescribedBy: (0, $36849e0eaf9cb699$export$ab8645c862eb5a3e),
        ariaDetails: null,
        ariaDisabled: (0, $36849e0eaf9cb699$export$55e9e1fbc638dc8f),
        ariaDropEffect: (0, $36849e0eaf9cb699$export$ab8645c862eb5a3e),
        ariaErrorMessage: null,
        ariaExpanded: (0, $36849e0eaf9cb699$export$55e9e1fbc638dc8f),
        ariaFlowTo: (0, $36849e0eaf9cb699$export$ab8645c862eb5a3e),
        ariaGrabbed: (0, $36849e0eaf9cb699$export$55e9e1fbc638dc8f),
        ariaHasPopup: null,
        ariaHidden: (0, $36849e0eaf9cb699$export$55e9e1fbc638dc8f),
        ariaInvalid: null,
        ariaKeyShortcuts: null,
        ariaLabel: null,
        ariaLabelledBy: (0, $36849e0eaf9cb699$export$ab8645c862eb5a3e),
        ariaLevel: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        ariaLive: null,
        ariaModal: (0, $36849e0eaf9cb699$export$55e9e1fbc638dc8f),
        ariaMultiLine: (0, $36849e0eaf9cb699$export$55e9e1fbc638dc8f),
        ariaMultiSelectable: (0, $36849e0eaf9cb699$export$55e9e1fbc638dc8f),
        ariaOrientation: null,
        ariaOwns: (0, $36849e0eaf9cb699$export$ab8645c862eb5a3e),
        ariaPlaceholder: null,
        ariaPosInSet: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        ariaPressed: (0, $36849e0eaf9cb699$export$55e9e1fbc638dc8f),
        ariaReadOnly: (0, $36849e0eaf9cb699$export$55e9e1fbc638dc8f),
        ariaRelevant: null,
        ariaRequired: (0, $36849e0eaf9cb699$export$55e9e1fbc638dc8f),
        ariaRoleDescription: (0, $36849e0eaf9cb699$export$ab8645c862eb5a3e),
        ariaRowCount: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        ariaRowIndex: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        ariaRowSpan: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        ariaSelected: (0, $36849e0eaf9cb699$export$55e9e1fbc638dc8f),
        ariaSetSize: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        ariaSort: null,
        ariaValueMax: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        ariaValueMin: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        ariaValueNow: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        ariaValueText: null,
        role: null
    }
});





const $e61f7a44d6307dc5$export$c0bb0b647f701bb5 = (0, $48f49204fef71f27$export$185802fd694ee1f5)({
    space: "html",
    attributes: {
        acceptcharset: "accept-charset",
        classname: "class",
        htmlfor: "for",
        httpequiv: "http-equiv"
    },
    transform: (0, $13bf1f82a92db732$export$32b9e4cec9c208e1),
    mustUseProperty: [
        "checked",
        "multiple",
        "muted",
        "selected"
    ],
    properties: {
        // Standard Properties.
        abbr: null,
        accept: (0, $36849e0eaf9cb699$export$9c8d678629b3d3),
        acceptCharset: (0, $36849e0eaf9cb699$export$ab8645c862eb5a3e),
        accessKey: (0, $36849e0eaf9cb699$export$ab8645c862eb5a3e),
        action: null,
        allow: null,
        allowFullScreen: (0, $36849e0eaf9cb699$export$4a21f16c33752377),
        allowPaymentRequest: (0, $36849e0eaf9cb699$export$4a21f16c33752377),
        allowUserMedia: (0, $36849e0eaf9cb699$export$4a21f16c33752377),
        alt: null,
        as: null,
        async: (0, $36849e0eaf9cb699$export$4a21f16c33752377),
        autoCapitalize: null,
        autoComplete: (0, $36849e0eaf9cb699$export$ab8645c862eb5a3e),
        autoFocus: (0, $36849e0eaf9cb699$export$4a21f16c33752377),
        autoPlay: (0, $36849e0eaf9cb699$export$4a21f16c33752377),
        blocking: (0, $36849e0eaf9cb699$export$ab8645c862eb5a3e),
        capture: null,
        charSet: null,
        checked: (0, $36849e0eaf9cb699$export$4a21f16c33752377),
        cite: null,
        className: (0, $36849e0eaf9cb699$export$ab8645c862eb5a3e),
        cols: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        colSpan: null,
        content: null,
        contentEditable: (0, $36849e0eaf9cb699$export$55e9e1fbc638dc8f),
        controls: (0, $36849e0eaf9cb699$export$4a21f16c33752377),
        controlsList: (0, $36849e0eaf9cb699$export$ab8645c862eb5a3e),
        coords: (0, $36849e0eaf9cb699$export$98e628dec113755e) | (0, $36849e0eaf9cb699$export$9c8d678629b3d3),
        crossOrigin: null,
        data: null,
        dateTime: null,
        decoding: null,
        default: (0, $36849e0eaf9cb699$export$4a21f16c33752377),
        defer: (0, $36849e0eaf9cb699$export$4a21f16c33752377),
        dir: null,
        dirName: null,
        disabled: (0, $36849e0eaf9cb699$export$4a21f16c33752377),
        download: (0, $36849e0eaf9cb699$export$242ac3d3042558aa),
        draggable: (0, $36849e0eaf9cb699$export$55e9e1fbc638dc8f),
        encType: null,
        enterKeyHint: null,
        fetchPriority: null,
        form: null,
        formAction: null,
        formEncType: null,
        formMethod: null,
        formNoValidate: (0, $36849e0eaf9cb699$export$4a21f16c33752377),
        formTarget: null,
        headers: (0, $36849e0eaf9cb699$export$ab8645c862eb5a3e),
        height: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        hidden: (0, $36849e0eaf9cb699$export$4a21f16c33752377),
        high: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        href: null,
        hrefLang: null,
        htmlFor: (0, $36849e0eaf9cb699$export$ab8645c862eb5a3e),
        httpEquiv: (0, $36849e0eaf9cb699$export$ab8645c862eb5a3e),
        id: null,
        imageSizes: null,
        imageSrcSet: null,
        inert: (0, $36849e0eaf9cb699$export$4a21f16c33752377),
        inputMode: null,
        integrity: null,
        is: null,
        isMap: (0, $36849e0eaf9cb699$export$4a21f16c33752377),
        itemId: null,
        itemProp: (0, $36849e0eaf9cb699$export$ab8645c862eb5a3e),
        itemRef: (0, $36849e0eaf9cb699$export$ab8645c862eb5a3e),
        itemScope: (0, $36849e0eaf9cb699$export$4a21f16c33752377),
        itemType: (0, $36849e0eaf9cb699$export$ab8645c862eb5a3e),
        kind: null,
        label: null,
        lang: null,
        language: null,
        list: null,
        loading: null,
        loop: (0, $36849e0eaf9cb699$export$4a21f16c33752377),
        low: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        manifest: null,
        max: null,
        maxLength: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        media: null,
        method: null,
        min: null,
        minLength: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        multiple: (0, $36849e0eaf9cb699$export$4a21f16c33752377),
        muted: (0, $36849e0eaf9cb699$export$4a21f16c33752377),
        name: null,
        nonce: null,
        noModule: (0, $36849e0eaf9cb699$export$4a21f16c33752377),
        noValidate: (0, $36849e0eaf9cb699$export$4a21f16c33752377),
        onAbort: null,
        onAfterPrint: null,
        onAuxClick: null,
        onBeforeMatch: null,
        onBeforePrint: null,
        onBeforeToggle: null,
        onBeforeUnload: null,
        onBlur: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onContextLost: null,
        onContextMenu: null,
        onContextRestored: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFormData: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLanguageChange: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadEnd: null,
        onLoadStart: null,
        onMessage: null,
        onMessageError: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRejectionHandled: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onScrollEnd: null,
        onSecurityPolicyViolation: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onSlotChange: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnhandledRejection: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onWheel: null,
        open: (0, $36849e0eaf9cb699$export$4a21f16c33752377),
        optimum: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        pattern: null,
        ping: (0, $36849e0eaf9cb699$export$ab8645c862eb5a3e),
        placeholder: null,
        playsInline: (0, $36849e0eaf9cb699$export$4a21f16c33752377),
        popover: null,
        popoverTarget: null,
        popoverTargetAction: null,
        poster: null,
        preload: null,
        readOnly: (0, $36849e0eaf9cb699$export$4a21f16c33752377),
        referrerPolicy: null,
        rel: (0, $36849e0eaf9cb699$export$ab8645c862eb5a3e),
        required: (0, $36849e0eaf9cb699$export$4a21f16c33752377),
        reversed: (0, $36849e0eaf9cb699$export$4a21f16c33752377),
        rows: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        rowSpan: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        sandbox: (0, $36849e0eaf9cb699$export$ab8645c862eb5a3e),
        scope: null,
        scoped: (0, $36849e0eaf9cb699$export$4a21f16c33752377),
        seamless: (0, $36849e0eaf9cb699$export$4a21f16c33752377),
        selected: (0, $36849e0eaf9cb699$export$4a21f16c33752377),
        shadowRootDelegatesFocus: (0, $36849e0eaf9cb699$export$4a21f16c33752377),
        shadowRootMode: null,
        shape: null,
        size: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        sizes: null,
        slot: null,
        span: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        spellCheck: (0, $36849e0eaf9cb699$export$55e9e1fbc638dc8f),
        src: null,
        srcDoc: null,
        srcLang: null,
        srcSet: null,
        start: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        step: null,
        style: null,
        tabIndex: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        target: null,
        title: null,
        translate: null,
        type: null,
        typeMustMatch: (0, $36849e0eaf9cb699$export$4a21f16c33752377),
        useMap: null,
        value: (0, $36849e0eaf9cb699$export$55e9e1fbc638dc8f),
        width: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        wrap: null,
        // Legacy.
        // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
        align: null,
        aLink: null,
        archive: (0, $36849e0eaf9cb699$export$ab8645c862eb5a3e),
        axis: null,
        background: null,
        bgColor: null,
        border: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        borderColor: null,
        bottomMargin: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        cellPadding: null,
        cellSpacing: null,
        char: null,
        charOff: null,
        classId: null,
        clear: null,
        code: null,
        codeBase: null,
        codeType: null,
        color: null,
        compact: (0, $36849e0eaf9cb699$export$4a21f16c33752377),
        declare: (0, $36849e0eaf9cb699$export$4a21f16c33752377),
        event: null,
        face: null,
        frame: null,
        frameBorder: null,
        hSpace: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        leftMargin: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        link: null,
        longDesc: null,
        lowSrc: null,
        marginHeight: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        marginWidth: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        noResize: (0, $36849e0eaf9cb699$export$4a21f16c33752377),
        noHref: (0, $36849e0eaf9cb699$export$4a21f16c33752377),
        noShade: (0, $36849e0eaf9cb699$export$4a21f16c33752377),
        noWrap: (0, $36849e0eaf9cb699$export$4a21f16c33752377),
        object: null,
        profile: null,
        prompt: null,
        rev: null,
        rightMargin: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        rules: null,
        scheme: null,
        scrolling: (0, $36849e0eaf9cb699$export$55e9e1fbc638dc8f),
        standby: null,
        summary: null,
        text: null,
        topMargin: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        valueType: null,
        version: null,
        vAlign: null,
        vLink: null,
        vSpace: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        // Non-standard Properties.
        allowTransparency: null,
        autoCorrect: null,
        autoSave: null,
        disablePictureInPicture: (0, $36849e0eaf9cb699$export$4a21f16c33752377),
        disableRemotePlayback: (0, $36849e0eaf9cb699$export$4a21f16c33752377),
        prefix: null,
        property: null,
        results: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        security: null,
        unselectable: null
    }
});





const $51d24df213ff8bc6$export$7ed1367e7fa1ad68 = (0, $48f49204fef71f27$export$185802fd694ee1f5)({
    space: "svg",
    attributes: {
        accentHeight: "accent-height",
        alignmentBaseline: "alignment-baseline",
        arabicForm: "arabic-form",
        baselineShift: "baseline-shift",
        capHeight: "cap-height",
        className: "class",
        clipPath: "clip-path",
        clipRule: "clip-rule",
        colorInterpolation: "color-interpolation",
        colorInterpolationFilters: "color-interpolation-filters",
        colorProfile: "color-profile",
        colorRendering: "color-rendering",
        crossOrigin: "crossorigin",
        dataType: "datatype",
        dominantBaseline: "dominant-baseline",
        enableBackground: "enable-background",
        fillOpacity: "fill-opacity",
        fillRule: "fill-rule",
        floodColor: "flood-color",
        floodOpacity: "flood-opacity",
        fontFamily: "font-family",
        fontSize: "font-size",
        fontSizeAdjust: "font-size-adjust",
        fontStretch: "font-stretch",
        fontStyle: "font-style",
        fontVariant: "font-variant",
        fontWeight: "font-weight",
        glyphName: "glyph-name",
        glyphOrientationHorizontal: "glyph-orientation-horizontal",
        glyphOrientationVertical: "glyph-orientation-vertical",
        hrefLang: "hreflang",
        horizAdvX: "horiz-adv-x",
        horizOriginX: "horiz-origin-x",
        horizOriginY: "horiz-origin-y",
        imageRendering: "image-rendering",
        letterSpacing: "letter-spacing",
        lightingColor: "lighting-color",
        markerEnd: "marker-end",
        markerMid: "marker-mid",
        markerStart: "marker-start",
        navDown: "nav-down",
        navDownLeft: "nav-down-left",
        navDownRight: "nav-down-right",
        navLeft: "nav-left",
        navNext: "nav-next",
        navPrev: "nav-prev",
        navRight: "nav-right",
        navUp: "nav-up",
        navUpLeft: "nav-up-left",
        navUpRight: "nav-up-right",
        onAbort: "onabort",
        onActivate: "onactivate",
        onAfterPrint: "onafterprint",
        onBeforePrint: "onbeforeprint",
        onBegin: "onbegin",
        onCancel: "oncancel",
        onCanPlay: "oncanplay",
        onCanPlayThrough: "oncanplaythrough",
        onChange: "onchange",
        onClick: "onclick",
        onClose: "onclose",
        onCopy: "oncopy",
        onCueChange: "oncuechange",
        onCut: "oncut",
        onDblClick: "ondblclick",
        onDrag: "ondrag",
        onDragEnd: "ondragend",
        onDragEnter: "ondragenter",
        onDragExit: "ondragexit",
        onDragLeave: "ondragleave",
        onDragOver: "ondragover",
        onDragStart: "ondragstart",
        onDrop: "ondrop",
        onDurationChange: "ondurationchange",
        onEmptied: "onemptied",
        onEnd: "onend",
        onEnded: "onended",
        onError: "onerror",
        onFocus: "onfocus",
        onFocusIn: "onfocusin",
        onFocusOut: "onfocusout",
        onHashChange: "onhashchange",
        onInput: "oninput",
        onInvalid: "oninvalid",
        onKeyDown: "onkeydown",
        onKeyPress: "onkeypress",
        onKeyUp: "onkeyup",
        onLoad: "onload",
        onLoadedData: "onloadeddata",
        onLoadedMetadata: "onloadedmetadata",
        onLoadStart: "onloadstart",
        onMessage: "onmessage",
        onMouseDown: "onmousedown",
        onMouseEnter: "onmouseenter",
        onMouseLeave: "onmouseleave",
        onMouseMove: "onmousemove",
        onMouseOut: "onmouseout",
        onMouseOver: "onmouseover",
        onMouseUp: "onmouseup",
        onMouseWheel: "onmousewheel",
        onOffline: "onoffline",
        onOnline: "ononline",
        onPageHide: "onpagehide",
        onPageShow: "onpageshow",
        onPaste: "onpaste",
        onPause: "onpause",
        onPlay: "onplay",
        onPlaying: "onplaying",
        onPopState: "onpopstate",
        onProgress: "onprogress",
        onRateChange: "onratechange",
        onRepeat: "onrepeat",
        onReset: "onreset",
        onResize: "onresize",
        onScroll: "onscroll",
        onSeeked: "onseeked",
        onSeeking: "onseeking",
        onSelect: "onselect",
        onShow: "onshow",
        onStalled: "onstalled",
        onStorage: "onstorage",
        onSubmit: "onsubmit",
        onSuspend: "onsuspend",
        onTimeUpdate: "ontimeupdate",
        onToggle: "ontoggle",
        onUnload: "onunload",
        onVolumeChange: "onvolumechange",
        onWaiting: "onwaiting",
        onZoom: "onzoom",
        overlinePosition: "overline-position",
        overlineThickness: "overline-thickness",
        paintOrder: "paint-order",
        panose1: "panose-1",
        pointerEvents: "pointer-events",
        referrerPolicy: "referrerpolicy",
        renderingIntent: "rendering-intent",
        shapeRendering: "shape-rendering",
        stopColor: "stop-color",
        stopOpacity: "stop-opacity",
        strikethroughPosition: "strikethrough-position",
        strikethroughThickness: "strikethrough-thickness",
        strokeDashArray: "stroke-dasharray",
        strokeDashOffset: "stroke-dashoffset",
        strokeLineCap: "stroke-linecap",
        strokeLineJoin: "stroke-linejoin",
        strokeMiterLimit: "stroke-miterlimit",
        strokeOpacity: "stroke-opacity",
        strokeWidth: "stroke-width",
        tabIndex: "tabindex",
        textAnchor: "text-anchor",
        textDecoration: "text-decoration",
        textRendering: "text-rendering",
        transformOrigin: "transform-origin",
        typeOf: "typeof",
        underlinePosition: "underline-position",
        underlineThickness: "underline-thickness",
        unicodeBidi: "unicode-bidi",
        unicodeRange: "unicode-range",
        unitsPerEm: "units-per-em",
        vAlphabetic: "v-alphabetic",
        vHanging: "v-hanging",
        vIdeographic: "v-ideographic",
        vMathematical: "v-mathematical",
        vectorEffect: "vector-effect",
        vertAdvY: "vert-adv-y",
        vertOriginX: "vert-origin-x",
        vertOriginY: "vert-origin-y",
        wordSpacing: "word-spacing",
        writingMode: "writing-mode",
        xHeight: "x-height",
        // These were camelcased in Tiny. Now lowercased in SVG 2
        playbackOrder: "playbackorder",
        timelineBegin: "timelinebegin"
    },
    transform: (0, $a1e3f2db5dc0e699$export$5b10b3bc32d7efbc),
    properties: {
        about: (0, $36849e0eaf9cb699$export$2ad25cfebf36cacd),
        accentHeight: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        accumulate: null,
        additive: null,
        alignmentBaseline: null,
        alphabetic: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        amplitude: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        arabicForm: null,
        ascent: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        attributeName: null,
        attributeType: null,
        azimuth: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        bandwidth: null,
        baselineShift: null,
        baseFrequency: null,
        baseProfile: null,
        bbox: null,
        begin: null,
        bias: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        by: null,
        calcMode: null,
        capHeight: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        className: (0, $36849e0eaf9cb699$export$ab8645c862eb5a3e),
        clip: null,
        clipPath: null,
        clipPathUnits: null,
        clipRule: null,
        color: null,
        colorInterpolation: null,
        colorInterpolationFilters: null,
        colorProfile: null,
        colorRendering: null,
        content: null,
        contentScriptType: null,
        contentStyleType: null,
        crossOrigin: null,
        cursor: null,
        cx: null,
        cy: null,
        d: null,
        dataType: null,
        defaultAction: null,
        descent: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        diffuseConstant: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        direction: null,
        display: null,
        dur: null,
        divisor: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        dominantBaseline: null,
        download: (0, $36849e0eaf9cb699$export$4a21f16c33752377),
        dx: null,
        dy: null,
        edgeMode: null,
        editable: null,
        elevation: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        enableBackground: null,
        end: null,
        event: null,
        exponent: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        externalResourcesRequired: null,
        fill: null,
        fillOpacity: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        fillRule: null,
        filter: null,
        filterRes: null,
        filterUnits: null,
        floodColor: null,
        floodOpacity: null,
        focusable: null,
        focusHighlight: null,
        fontFamily: null,
        fontSize: null,
        fontSizeAdjust: null,
        fontStretch: null,
        fontStyle: null,
        fontVariant: null,
        fontWeight: null,
        format: null,
        fr: null,
        from: null,
        fx: null,
        fy: null,
        g1: (0, $36849e0eaf9cb699$export$9c8d678629b3d3),
        g2: (0, $36849e0eaf9cb699$export$9c8d678629b3d3),
        glyphName: (0, $36849e0eaf9cb699$export$9c8d678629b3d3),
        glyphOrientationHorizontal: null,
        glyphOrientationVertical: null,
        glyphRef: null,
        gradientTransform: null,
        gradientUnits: null,
        handler: null,
        hanging: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        hatchContentUnits: null,
        hatchUnits: null,
        height: null,
        href: null,
        hrefLang: null,
        horizAdvX: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        horizOriginX: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        horizOriginY: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        id: null,
        ideographic: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        imageRendering: null,
        initialVisibility: null,
        in: null,
        in2: null,
        intercept: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        k: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        k1: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        k2: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        k3: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        k4: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        kernelMatrix: (0, $36849e0eaf9cb699$export$2ad25cfebf36cacd),
        kernelUnitLength: null,
        keyPoints: null,
        keySplines: null,
        keyTimes: null,
        kerning: null,
        lang: null,
        lengthAdjust: null,
        letterSpacing: null,
        lightingColor: null,
        limitingConeAngle: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        local: null,
        markerEnd: null,
        markerMid: null,
        markerStart: null,
        markerHeight: null,
        markerUnits: null,
        markerWidth: null,
        mask: null,
        maskContentUnits: null,
        maskUnits: null,
        mathematical: null,
        max: null,
        media: null,
        mediaCharacterEncoding: null,
        mediaContentEncodings: null,
        mediaSize: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        mediaTime: null,
        method: null,
        min: null,
        mode: null,
        name: null,
        navDown: null,
        navDownLeft: null,
        navDownRight: null,
        navLeft: null,
        navNext: null,
        navPrev: null,
        navRight: null,
        navUp: null,
        navUpLeft: null,
        navUpRight: null,
        numOctaves: null,
        observer: null,
        offset: null,
        onAbort: null,
        onActivate: null,
        onAfterPrint: null,
        onBeforePrint: null,
        onBegin: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnd: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFocusIn: null,
        onFocusOut: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadStart: null,
        onMessage: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onMouseWheel: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRepeat: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onShow: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onZoom: null,
        opacity: null,
        operator: null,
        order: null,
        orient: null,
        orientation: null,
        origin: null,
        overflow: null,
        overlay: null,
        overlinePosition: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        overlineThickness: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        paintOrder: null,
        panose1: null,
        path: null,
        pathLength: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        patternContentUnits: null,
        patternTransform: null,
        patternUnits: null,
        phase: null,
        ping: (0, $36849e0eaf9cb699$export$ab8645c862eb5a3e),
        pitch: null,
        playbackOrder: null,
        pointerEvents: null,
        points: null,
        pointsAtX: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        pointsAtY: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        pointsAtZ: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        preserveAlpha: null,
        preserveAspectRatio: null,
        primitiveUnits: null,
        propagate: null,
        property: (0, $36849e0eaf9cb699$export$2ad25cfebf36cacd),
        r: null,
        radius: null,
        referrerPolicy: null,
        refX: null,
        refY: null,
        rel: (0, $36849e0eaf9cb699$export$2ad25cfebf36cacd),
        rev: (0, $36849e0eaf9cb699$export$2ad25cfebf36cacd),
        renderingIntent: null,
        repeatCount: null,
        repeatDur: null,
        requiredExtensions: (0, $36849e0eaf9cb699$export$2ad25cfebf36cacd),
        requiredFeatures: (0, $36849e0eaf9cb699$export$2ad25cfebf36cacd),
        requiredFonts: (0, $36849e0eaf9cb699$export$2ad25cfebf36cacd),
        requiredFormats: (0, $36849e0eaf9cb699$export$2ad25cfebf36cacd),
        resource: null,
        restart: null,
        result: null,
        rotate: null,
        rx: null,
        ry: null,
        scale: null,
        seed: null,
        shapeRendering: null,
        side: null,
        slope: null,
        snapshotTime: null,
        specularConstant: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        specularExponent: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        spreadMethod: null,
        spacing: null,
        startOffset: null,
        stdDeviation: null,
        stemh: null,
        stemv: null,
        stitchTiles: null,
        stopColor: null,
        stopOpacity: null,
        strikethroughPosition: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        strikethroughThickness: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        string: null,
        stroke: null,
        strokeDashArray: (0, $36849e0eaf9cb699$export$2ad25cfebf36cacd),
        strokeDashOffset: null,
        strokeLineCap: null,
        strokeLineJoin: null,
        strokeMiterLimit: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        strokeOpacity: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        strokeWidth: null,
        style: null,
        surfaceScale: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        syncBehavior: null,
        syncBehaviorDefault: null,
        syncMaster: null,
        syncTolerance: null,
        syncToleranceDefault: null,
        systemLanguage: (0, $36849e0eaf9cb699$export$2ad25cfebf36cacd),
        tabIndex: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        tableValues: null,
        target: null,
        targetX: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        targetY: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        textAnchor: null,
        textDecoration: null,
        textRendering: null,
        textLength: null,
        timelineBegin: null,
        title: null,
        transformBehavior: null,
        type: null,
        typeOf: (0, $36849e0eaf9cb699$export$2ad25cfebf36cacd),
        to: null,
        transform: null,
        transformOrigin: null,
        u1: null,
        u2: null,
        underlinePosition: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        underlineThickness: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        unicode: null,
        unicodeBidi: null,
        unicodeRange: null,
        unitsPerEm: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        values: null,
        vAlphabetic: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        vMathematical: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        vectorEffect: null,
        vHanging: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        vIdeographic: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        version: null,
        vertAdvY: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        vertOriginX: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        vertOriginY: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        viewBox: null,
        viewTarget: null,
        visibility: null,
        width: null,
        widths: null,
        wordSpacing: null,
        writingMode: null,
        x: null,
        x1: null,
        x2: null,
        xChannelSelector: null,
        xHeight: (0, $36849e0eaf9cb699$export$98e628dec113755e),
        y: null,
        y1: null,
        y2: null,
        yChannelSelector: null,
        z: null,
        zoomAndPan: null
    }
});


/**
 * @typedef {import('./util/schema.js').Schema} Schema
 */ 


const $d0810cab7d64d1bb$var$valid = /^data[-\w.:]+$/i;
const $d0810cab7d64d1bb$var$dash = /-[a-z]/g;
const $d0810cab7d64d1bb$var$cap = /[A-Z]/g;
function $d0810cab7d64d1bb$export$71aa6c912b956294(schema, value) {
    const normal = (0, $104dbd7c605e9c49$export$a3295358bff77e)(value);
    let prop = value;
    let Type = (0, $745dee82661052ac$export$c4868e4a24d48fad);
    if (normal in schema.normal) return schema.property[schema.normal[normal]];
    if (normal.length > 4 && normal.slice(0, 4) === "data" && $d0810cab7d64d1bb$var$valid.test(value)) {
        // Attribute or property.
        if (value.charAt(4) === "-") {
            // Turn it into a property.
            const rest = value.slice(5).replace($d0810cab7d64d1bb$var$dash, $d0810cab7d64d1bb$var$camelcase);
            prop = "data" + rest.charAt(0).toUpperCase() + rest.slice(1);
        } else {
            // Turn it into an attribute.
            const rest = value.slice(4);
            if (!$d0810cab7d64d1bb$var$dash.test(rest)) {
                let dashes = rest.replace($d0810cab7d64d1bb$var$cap, $d0810cab7d64d1bb$var$kebab);
                if (dashes.charAt(0) !== "-") dashes = "-" + dashes;
                value = "data" + dashes;
            }
        }
        Type = (0, $6b356b3398566d36$export$ea6b9f0064e88c9b);
    }
    return new Type(prop, value);
}
/**
 * @param {string} $0
 * @returns {string}
 */ function $d0810cab7d64d1bb$var$kebab($0) {
    return "-" + $0.toLowerCase();
}
/**
 * @param {string} $0
 * @returns {string}
 */ function $d0810cab7d64d1bb$var$camelcase($0) {
    return $0.charAt(1).toUpperCase();
}


/**
 * `hast` is close to `React`, but differs in a couple of cases.
 *
 * To get a React property from a hast property, check if it is in
 * `hastToReact`, if it is, then use the corresponding value,
 * otherwise, use the hast property.
 *
 * @type {Record<string, string>}
 */ const $e5a51b6331c488a7$export$d8abd7e5fb6871f9 = {
    classId: "classID",
    dataType: "datatype",
    itemId: "itemID",
    strokeDashArray: "strokeDasharray",
    strokeDashOffset: "strokeDashoffset",
    strokeLineCap: "strokeLinecap",
    strokeLineJoin: "strokeLinejoin",
    strokeMiterLimit: "strokeMiterlimit",
    typeOf: "typeof",
    xLinkActuate: "xlinkActuate",
    xLinkArcRole: "xlinkArcrole",
    xLinkHref: "xlinkHref",
    xLinkRole: "xlinkRole",
    xLinkShow: "xlinkShow",
    xLinkTitle: "xlinkTitle",
    xLinkType: "xlinkType",
    xmlnsXLink: "xmlnsXlink"
};



const $f89eec41ea745ec7$export$c0bb0b647f701bb5 = (0, $b3a48325d91bf280$export$4950aa0f605343fb)([
    (0, $033fa216ce000390$export$f2913fe8983302e),
    (0, $6da52ca508f6ba5f$export$2bd1230ec7600845),
    (0, $78e4052598572435$export$e20c24a128671213),
    (0, $82e562d4bebf3f08$export$4d2d26490572750a),
    (0, $e61f7a44d6307dc5$export$c0bb0b647f701bb5)
], "html");
const $f89eec41ea745ec7$export$7ed1367e7fa1ad68 = (0, $b3a48325d91bf280$export$4950aa0f605343fb)([
    (0, $033fa216ce000390$export$f2913fe8983302e),
    (0, $6da52ca508f6ba5f$export$2bd1230ec7600845),
    (0, $78e4052598572435$export$e20c24a128671213),
    (0, $82e562d4bebf3f08$export$4d2d26490572750a),
    (0, $51d24df213ff8bc6$export$7ed1367e7fa1ad68)
], "svg");



function $86dd33034183e52e$export$2e2bcd8739ae039(options) {
    if (options.allowedElements && options.disallowedElements) throw new TypeError("Only one of `allowedElements` and `disallowedElements` should be defined");
    if (options.allowedElements || options.disallowedElements || options.allowElement) return (tree)=>{
        (0, $4eca242b64be92f7$export$bf638b60ea8b89b7)(tree, "element", (node, index, parent_)=>{
            const parent = /** @type {Element|Root} */ parent_;
            /** @type {boolean|undefined} */ let remove;
            if (options.allowedElements) remove = !options.allowedElements.includes(node.tagName);
            else if (options.disallowedElements) remove = options.disallowedElements.includes(node.tagName);
            if (!remove && options.allowElement && typeof index === "number") remove = !options.allowElement(node, index, parent);
            if (remove && typeof index === "number") {
                if (options.unwrapDisallowed && node.children) parent.children.splice(index, 1, ...node.children);
                else parent.children.splice(index, 1);
                return index;
            }
            return undefined;
        });
    };
}


/**
 * @template T
 * @typedef {import('react').ComponentType<T>} ComponentType<T>
 */ /**
 * @template {import('react').ElementType} T
 * @typedef {import('react').ComponentPropsWithoutRef<T>} ComponentPropsWithoutRef<T>
 */ /**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('unist').Position} Position
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').Text} Text
 * @typedef {import('hast').Comment} Comment
 * @typedef {import('hast').DocType} Doctype
 * @typedef {import('property-information').Info} Info
 * @typedef {import('property-information').Schema} Schema
 * @typedef {import('./complex-types.js').ReactMarkdownProps} ReactMarkdownProps
 *
 * @typedef Raw
 * @property {'raw'} type
 * @property {string} value
 *
 * @typedef Context
 * @property {Options} options
 * @property {Schema} schema
 * @property {number} listDepth
 *
 * @callback TransformLink
 * @param {string} href
 * @param {Array<ElementContent>} children
 * @param {string?} title
 * @returns {string}
 *
 * @callback TransformImage
 * @param {string} src
 * @param {string} alt
 * @param {string?} title
 * @returns {string}
 *
 * @typedef {import('react').HTMLAttributeAnchorTarget} TransformLinkTargetType
 *
 * @callback TransformLinkTarget
 * @param {string} href
 * @param {Array<ElementContent>} children
 * @param {string?} title
 * @returns {TransformLinkTargetType|undefined}
 *
 * @typedef {keyof JSX.IntrinsicElements} ReactMarkdownNames
 *
 * To do: is `data-sourcepos` typeable?
 *
 * @typedef {ComponentPropsWithoutRef<'code'> & ReactMarkdownProps & {inline?: boolean}} CodeProps
 * @typedef {ComponentPropsWithoutRef<'h1'> & ReactMarkdownProps & {level: number}} HeadingProps
 * @typedef {ComponentPropsWithoutRef<'li'> & ReactMarkdownProps & {checked: boolean|null, index: number, ordered: boolean}} LiProps
 * @typedef {ComponentPropsWithoutRef<'ol'> & ReactMarkdownProps & {depth: number, ordered: true}} OrderedListProps
 * @typedef {ComponentPropsWithoutRef<'td'> & ReactMarkdownProps & {style?: Record<string, unknown>, isHeader: false}} TableDataCellProps
 * @typedef {ComponentPropsWithoutRef<'th'> & ReactMarkdownProps & {style?: Record<string, unknown>, isHeader: true}} TableHeaderCellProps
 * @typedef {ComponentPropsWithoutRef<'tr'> & ReactMarkdownProps & {isHeader: boolean}} TableRowProps
 * @typedef {ComponentPropsWithoutRef<'ul'> & ReactMarkdownProps & {depth: number, ordered: false}} UnorderedListProps
 *
 * @typedef {ComponentType<CodeProps>} CodeComponent
 * @typedef {ComponentType<HeadingProps>} HeadingComponent
 * @typedef {ComponentType<LiProps>} LiComponent
 * @typedef {ComponentType<OrderedListProps>} OrderedListComponent
 * @typedef {ComponentType<TableDataCellProps>} TableDataCellComponent
 * @typedef {ComponentType<TableHeaderCellProps>} TableHeaderCellComponent
 * @typedef {ComponentType<TableRowProps>} TableRowComponent
 * @typedef {ComponentType<UnorderedListProps>} UnorderedListComponent
 *
 * @typedef SpecialComponents
 * @property {CodeComponent|ReactMarkdownNames} code
 * @property {HeadingComponent|ReactMarkdownNames} h1
 * @property {HeadingComponent|ReactMarkdownNames} h2
 * @property {HeadingComponent|ReactMarkdownNames} h3
 * @property {HeadingComponent|ReactMarkdownNames} h4
 * @property {HeadingComponent|ReactMarkdownNames} h5
 * @property {HeadingComponent|ReactMarkdownNames} h6
 * @property {LiComponent|ReactMarkdownNames} li
 * @property {OrderedListComponent|ReactMarkdownNames} ol
 * @property {TableDataCellComponent|ReactMarkdownNames} td
 * @property {TableHeaderCellComponent|ReactMarkdownNames} th
 * @property {TableRowComponent|ReactMarkdownNames} tr
 * @property {UnorderedListComponent|ReactMarkdownNames} ul
 *
 * @typedef {Partial<Omit<import('./complex-types.js').NormalComponents, keyof SpecialComponents> & SpecialComponents>} Components
 *
 * @typedef Options
 * @property {boolean} [sourcePos=false]
 * @property {boolean} [rawSourcePos=false]
 * @property {boolean} [skipHtml=false]
 * @property {boolean} [includeElementIndex=false]
 * @property {null|false|TransformLink} [transformLinkUri]
 * @property {TransformImage} [transformImageUri]
 * @property {TransformLinkTargetType|TransformLinkTarget} [linkTarget]
 * @property {Components} [components]
 */ 
var $6cds3 = parcelRequire("6cds3");
var $36328e834d15f05b$exports = {};
"use strict";

$36328e834d15f05b$exports = (parcelRequire("3aI4s"));


/**
 * Check if the given value is *inter-element whitespace*.
 *
 * @param {unknown} thing
 *   Thing to check (typically `Node` or `string`).
 * @returns {boolean}
 *   Whether the `value` is inter-element whitespace (`boolean`): consisting of
 *   zero or more of space, tab (`\t`), line feed (`\n`), carriage return
 *   (`\r`), or form feed (`\f`).
 *   If a node is passed it must be a `Text` node, whose `value` field is
 *   checked.
 */ function $3c72c5ebd7659842$export$7af1228ff777d175(thing) {
    /** @type {string} */ const value = // @ts-expect-error looks like a node.
    thing && typeof thing === "object" && thing.type === "text" ? thing.value || "" : thing;
    // HTML whitespace expression.
    // See <https://infra.spec.whatwg.org/#ascii-whitespace>.
    return typeof value === "string" && value.replace(/[ \t\n\f\r]/g, "") === "";
}



/**
 * Parse space-separated tokens to an array of strings.
 *
 * @param {string} value
 *   Space-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $2c35b94f24bb1e99$export$98e6a39c04603d36(value) {
    const input = String(value || "").trim();
    return input ? input.split(/[ \t\n\r\f]+/g) : [];
}
function $2c35b94f24bb1e99$export$fac44ee5b035f737(values) {
    return values.join(" ").trim();
}


/**
 * @typedef Options
 *   Configuration for `stringify`.
 * @property {boolean} [padLeft=true]
 *   Whether to pad a space before a token.
 * @property {boolean} [padRight=false]
 *   Whether to pad a space after a token.
 */ /**
 * @typedef {Options} StringifyOptions
 *   Please use `StringifyOptions` instead.
 */ /**
 * Parse comma-separated tokens to an array.
 *
 * @param {string} value
 *   Comma-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $bf54ed0d8eef9d66$export$98e6a39c04603d36(value) {
    /** @type {Array<string>} */ const tokens = [];
    const input = String(value || "");
    let index = input.indexOf(",");
    let start = 0;
    /** @type {boolean} */ let end = false;
    while(!end){
        if (index === -1) {
            index = input.length;
            end = true;
        }
        const token = input.slice(start, index).trim();
        if (token || !end) tokens.push(token);
        start = index + 1;
        index = input.indexOf(",", start);
    }
    return tokens;
}
function $bf54ed0d8eef9d66$export$fac44ee5b035f737(values, options) {
    const settings = options || {};
    // Ensure the last empty entry is seen.
    const input = values[values.length - 1] === "" ? [
        ...values,
        ""
    ] : values;
    return input.join((settings.padRight ? " " : "") + "," + (settings.padLeft === false ? "" : " ")).trim();
}


var $75eca83c5cdc64d2$exports = {};
var $83a5530fc9b247bd$exports = {};
// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var $83a5530fc9b247bd$var$COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var $83a5530fc9b247bd$var$NEWLINE_REGEX = /\n/g;
var $83a5530fc9b247bd$var$WHITESPACE_REGEX = /^\s*/;
// declaration
var $83a5530fc9b247bd$var$PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var $83a5530fc9b247bd$var$COLON_REGEX = /^:\s*/;
var $83a5530fc9b247bd$var$VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var $83a5530fc9b247bd$var$SEMICOLON_REGEX = /^[;\s]*/;
// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var $83a5530fc9b247bd$var$TRIM_REGEX = /^\s+|\s+$/g;
// strings
var $83a5530fc9b247bd$var$NEWLINE = "\n";
var $83a5530fc9b247bd$var$FORWARD_SLASH = "/";
var $83a5530fc9b247bd$var$ASTERISK = "*";
var $83a5530fc9b247bd$var$EMPTY_STRING = "";
// types
var $83a5530fc9b247bd$var$TYPE_COMMENT = "comment";
var $83a5530fc9b247bd$var$TYPE_DECLARATION = "declaration";
/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */ $83a5530fc9b247bd$exports = function(style, options) {
    if (typeof style !== "string") throw new TypeError("First argument must be a string");
    if (!style) return [];
    options = options || {};
    /**
   * Positional.
   */ var lineno = 1;
    var column = 1;
    /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */ function updatePosition(str) {
        var lines = str.match($83a5530fc9b247bd$var$NEWLINE_REGEX);
        if (lines) lineno += lines.length;
        var i = str.lastIndexOf($83a5530fc9b247bd$var$NEWLINE);
        column = ~i ? str.length - i : column + str.length;
    }
    /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */ function position() {
        var start = {
            line: lineno,
            column: column
        };
        return function(node) {
            node.position = new Position(start);
            whitespace();
            return node;
        };
    }
    /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */ function Position(start) {
        this.start = start;
        this.end = {
            line: lineno,
            column: column
        };
        this.source = options.source;
    }
    /**
   * Non-enumerable source string.
   */ Position.prototype.content = style;
    var errorsList = [];
    /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */ function error(msg) {
        var err = new Error(options.source + ":" + lineno + ":" + column + ": " + msg);
        err.reason = msg;
        err.filename = options.source;
        err.line = lineno;
        err.column = column;
        err.source = style;
        if (options.silent) errorsList.push(err);
        else throw err;
    }
    /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */ function match(re) {
        var m = re.exec(style);
        if (!m) return;
        var str = m[0];
        updatePosition(str);
        style = style.slice(str.length);
        return m;
    }
    /**
   * Parse whitespace.
   */ function whitespace() {
        match($83a5530fc9b247bd$var$WHITESPACE_REGEX);
    }
    /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */ function comments(rules) {
        var c;
        rules = rules || [];
        while(c = comment())if (c !== false) rules.push(c);
        return rules;
    }
    /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */ function comment() {
        var pos = position();
        if ($83a5530fc9b247bd$var$FORWARD_SLASH != style.charAt(0) || $83a5530fc9b247bd$var$ASTERISK != style.charAt(1)) return;
        var i = 2;
        while($83a5530fc9b247bd$var$EMPTY_STRING != style.charAt(i) && ($83a5530fc9b247bd$var$ASTERISK != style.charAt(i) || $83a5530fc9b247bd$var$FORWARD_SLASH != style.charAt(i + 1)))++i;
        i += 2;
        if ($83a5530fc9b247bd$var$EMPTY_STRING === style.charAt(i - 1)) return error("End of comment missing");
        var str = style.slice(2, i - 2);
        column += 2;
        updatePosition(str);
        style = style.slice(i);
        column += 2;
        return pos({
            type: $83a5530fc9b247bd$var$TYPE_COMMENT,
            comment: str
        });
    }
    /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */ function declaration() {
        var pos = position();
        // prop
        var prop = match($83a5530fc9b247bd$var$PROPERTY_REGEX);
        if (!prop) return;
        comment();
        // :
        if (!match($83a5530fc9b247bd$var$COLON_REGEX)) return error("property missing ':'");
        // val
        var val = match($83a5530fc9b247bd$var$VALUE_REGEX);
        var ret = pos({
            type: $83a5530fc9b247bd$var$TYPE_DECLARATION,
            property: $83a5530fc9b247bd$var$trim(prop[0].replace($83a5530fc9b247bd$var$COMMENT_REGEX, $83a5530fc9b247bd$var$EMPTY_STRING)),
            value: val ? $83a5530fc9b247bd$var$trim(val[0].replace($83a5530fc9b247bd$var$COMMENT_REGEX, $83a5530fc9b247bd$var$EMPTY_STRING)) : $83a5530fc9b247bd$var$EMPTY_STRING
        });
        // ;
        match($83a5530fc9b247bd$var$SEMICOLON_REGEX);
        return ret;
    }
    /**
   * Parse declarations.
   *
   * @return {Object[]}
   */ function declarations() {
        var decls = [];
        comments(decls);
        // declarations
        var decl;
        while(decl = declaration())if (decl !== false) {
            decls.push(decl);
            comments(decls);
        }
        return decls;
    }
    whitespace();
    return declarations();
};
/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */ function $83a5530fc9b247bd$var$trim(str) {
    return str ? str.replace($83a5530fc9b247bd$var$TRIM_REGEX, $83a5530fc9b247bd$var$EMPTY_STRING) : $83a5530fc9b247bd$var$EMPTY_STRING;
}


/**
 * Parses inline style to object.
 *
 * @example
 * // returns { 'line-height': '42' }
 * StyleToObject('line-height: 42;');
 *
 * @param  {String}      style      - The inline style.
 * @param  {Function}    [iterator] - The iterator function.
 * @return {null|Object}
 */ function $75eca83c5cdc64d2$var$StyleToObject(style, iterator) {
    var output = null;
    if (!style || typeof style !== "string") return output;
    var declaration;
    var declarations = $83a5530fc9b247bd$exports(style);
    var hasIterator = typeof iterator === "function";
    var property;
    var value;
    for(var i = 0, len = declarations.length; i < len; i++){
        declaration = declarations[i];
        property = declaration.property;
        value = declaration.value;
        if (hasIterator) iterator(property, value, declaration);
        else if (value) {
            output || (output = {});
            output[property] = value;
        }
    }
    return output;
}
$75eca83c5cdc64d2$exports = $75eca83c5cdc64d2$var$StyleToObject;
$75eca83c5cdc64d2$exports.default = $75eca83c5cdc64d2$var$StyleToObject; // ESM support


var $4a630e60e1f7c37c$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($75eca83c5cdc64d2$exports)));


const $ce73fda79b7fa7c6$var$protocols = [
    "http",
    "https",
    "mailto",
    "tel"
];
function $ce73fda79b7fa7c6$export$b83532a10e2e268b(uri) {
    const url = (uri || "").trim();
    const first = url.charAt(0);
    if (first === "#" || first === "/") return url;
    const colon = url.indexOf(":");
    if (colon === -1) return url;
    let index = -1;
    while(++index < $ce73fda79b7fa7c6$var$protocols.length){
        const protocol = $ce73fda79b7fa7c6$var$protocols[index];
        if (colon === protocol.length && url.slice(0, protocol.length).toLowerCase() === protocol) return url;
    }
    index = url.indexOf("?");
    if (index !== -1 && colon > index) return url;
    index = url.indexOf("#");
    if (index !== -1 && colon > index) return url;
    // eslint-disable-next-line no-script-url
    return "javascript:void(0)";
}


const $076e3bd4c2a8e0a9$var$own = {}.hasOwnProperty;
// The table-related elements that must not contain whitespace text according
// to React.
const $076e3bd4c2a8e0a9$var$tableElements = new Set([
    "table",
    "thead",
    "tbody",
    "tfoot",
    "tr"
]);
function $076e3bd4c2a8e0a9$export$4b745c302603ab5d(context, node) {
    /** @type {Array<ReactNode>} */ const children = [];
    let childIndex = -1;
    /** @type {Comment|Doctype|Element|Raw|Text} */ let child;
    while(++childIndex < node.children.length){
        child = node.children[childIndex];
        if (child.type === "element") children.push($076e3bd4c2a8e0a9$var$toReact(context, child, childIndex, node));
        else if (child.type === "text") // Currently, a warning is triggered by react for *any* white space in
        // tables.
        // So we drop it.
        // See: <https://github.com/facebook/react/pull/7081>.
        // See: <https://github.com/facebook/react/pull/7515>.
        // See: <https://github.com/remarkjs/remark-react/issues/64>.
        // See: <https://github.com/remarkjs/react-markdown/issues/576>.
        {
            if (node.type !== "element" || !$076e3bd4c2a8e0a9$var$tableElements.has(node.tagName) || !(0, $3c72c5ebd7659842$export$7af1228ff777d175)(child)) children.push(child.value);
        } else if (child.type === "raw" && !context.options.skipHtml) // Default behavior is to show (encoded) HTML.
        children.push(child.value);
    }
    return children;
}
/**
 * @param {Context} context
 * @param {Element} node
 * @param {number} index
 * @param {Element|Root} parent
 */ function $076e3bd4c2a8e0a9$var$toReact(context, node, index, parent) {
    const options = context.options;
    const transform = options.transformLinkUri === undefined ? (0, $ce73fda79b7fa7c6$export$b83532a10e2e268b) : options.transformLinkUri;
    const parentSchema = context.schema;
    /** @type {ReactMarkdownNames} */ // @ts-expect-error assume a known HTML/SVG element.
    const name = node.tagName;
    /** @type {Record<string, unknown>} */ const properties = {};
    let schema = parentSchema;
    /** @type {string} */ let property;
    if (parentSchema.space === "html" && name === "svg") {
        schema = (0, $f89eec41ea745ec7$export$7ed1367e7fa1ad68);
        context.schema = schema;
    }
    if (node.properties) {
        for(property in node.properties)if ($076e3bd4c2a8e0a9$var$own.call(node.properties, property)) $076e3bd4c2a8e0a9$var$addProperty(properties, property, node.properties[property], context);
    }
    if (name === "ol" || name === "ul") context.listDepth++;
    const children = $076e3bd4c2a8e0a9$export$4b745c302603ab5d(context, node);
    if (name === "ol" || name === "ul") context.listDepth--;
    // Restore parent schema.
    context.schema = parentSchema;
    // Nodes created by plugins do not have positional info, in which case we use
    // an object that matches the position interface.
    const position = node.position || {
        start: {
            line: null,
            column: null,
            offset: null
        },
        end: {
            line: null,
            column: null,
            offset: null
        }
    };
    const component = options.components && $076e3bd4c2a8e0a9$var$own.call(options.components, name) ? options.components[name] : name;
    const basic = typeof component === "string" || component === (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Fragment;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($36328e834d15f05b$exports))).isValidElementType(component)) throw new TypeError(`Component for name \`${name}\` not defined or is not renderable`);
    properties.key = index;
    if (name === "a" && options.linkTarget) properties.target = typeof options.linkTarget === "function" ? options.linkTarget(String(properties.href || ""), node.children, typeof properties.title === "string" ? properties.title : null) : options.linkTarget;
    if (name === "a" && transform) properties.href = transform(String(properties.href || ""), node.children, typeof properties.title === "string" ? properties.title : null);
    if (!basic && name === "code" && parent.type === "element" && parent.tagName !== "pre") properties.inline = true;
    if (!basic && (name === "h1" || name === "h2" || name === "h3" || name === "h4" || name === "h5" || name === "h6")) properties.level = Number.parseInt(name.charAt(1), 10);
    if (name === "img" && options.transformImageUri) properties.src = options.transformImageUri(String(properties.src || ""), String(properties.alt || ""), typeof properties.title === "string" ? properties.title : null);
    if (!basic && name === "li" && parent.type === "element") {
        const input = $076e3bd4c2a8e0a9$var$getInputElement(node);
        properties.checked = input && input.properties ? Boolean(input.properties.checked) : null;
        properties.index = $076e3bd4c2a8e0a9$var$getElementsBeforeCount(parent, node);
        properties.ordered = parent.tagName === "ol";
    }
    if (!basic && (name === "ol" || name === "ul")) {
        properties.ordered = name === "ol";
        properties.depth = context.listDepth;
    }
    if (name === "td" || name === "th") {
        if (properties.align) {
            if (!properties.style) properties.style = {};
            // @ts-expect-error assume `style` is an object
            properties.style.textAlign = properties.align;
            delete properties.align;
        }
        if (!basic) properties.isHeader = name === "th";
    }
    if (!basic && name === "tr" && parent.type === "element") properties.isHeader = Boolean(parent.tagName === "thead");
    // If `sourcePos` is given, pass source information (line/column info from markdown source).
    if (options.sourcePos) properties["data-sourcepos"] = $076e3bd4c2a8e0a9$var$flattenPosition(position);
    if (!basic && options.rawSourcePos) properties.sourcePosition = node.position;
    // If `includeElementIndex` is given, pass node index info to components.
    if (!basic && options.includeElementIndex) {
        properties.index = $076e3bd4c2a8e0a9$var$getElementsBeforeCount(parent, node);
        properties.siblingCount = $076e3bd4c2a8e0a9$var$getElementsBeforeCount(parent);
    }
    if (!basic) properties.node = node;
    // Ensure no React warnings are emitted for void elements w/ children.
    return children.length > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement(component, properties, children) : (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement(component, properties);
}
/**
 * @param {Element|Root} node
 * @returns {Element?}
 */ function $076e3bd4c2a8e0a9$var$getInputElement(node) {
    let index = -1;
    while(++index < node.children.length){
        const child = node.children[index];
        if (child.type === "element" && child.tagName === "input") return child;
    }
    return null;
}
/**
 * @param {Element|Root} parent
 * @param {Element} [node]
 * @returns {number}
 */ function $076e3bd4c2a8e0a9$var$getElementsBeforeCount(parent, node) {
    let index = -1;
    let count = 0;
    while(++index < parent.children.length){
        if (parent.children[index] === node) break;
        if (parent.children[index].type === "element") count++;
    }
    return count;
}
/**
 * @param {Record<string, unknown>} props
 * @param {string} prop
 * @param {unknown} value
 * @param {Context} ctx
 */ function $076e3bd4c2a8e0a9$var$addProperty(props, prop, value, ctx) {
    const info = (0, $d0810cab7d64d1bb$export$71aa6c912b956294)(ctx.schema, prop);
    let result = value;
    // Ignore nullish and `NaN` values.
    // eslint-disable-next-line no-self-compare
    if (result === null || result === undefined || result !== result) return;
    // Accept `array`.
    // Most props are space-separated.
    if (Array.isArray(result)) result = info.commaSeparated ? (0, $bf54ed0d8eef9d66$export$fac44ee5b035f737)(result) : (0, $2c35b94f24bb1e99$export$fac44ee5b035f737)(result);
    if (info.property === "style" && typeof result === "string") result = $076e3bd4c2a8e0a9$var$parseStyle(result);
    if (info.space && info.property) props[$076e3bd4c2a8e0a9$var$own.call((0, $e5a51b6331c488a7$export$d8abd7e5fb6871f9), info.property) ? (0, $e5a51b6331c488a7$export$d8abd7e5fb6871f9)[info.property] : info.property] = result;
    else if (info.attribute) props[info.attribute] = result;
}
/**
 * @param {string} value
 * @returns {Record<string, string>}
 */ function $076e3bd4c2a8e0a9$var$parseStyle(value) {
    /** @type {Record<string, string>} */ const result = {};
    try {
        (0, $4a630e60e1f7c37c$export$2e2bcd8739ae039)(value, iterator);
    } catch  {
    // Silent.
    }
    return result;
    /**
   * @param {string} name
   * @param {string} v
   */ function iterator(name, v) {
        const k = name.slice(0, 4) === "-ms-" ? `ms-${name.slice(4)}` : name;
        result[k.replace(/-([a-z])/g, $076e3bd4c2a8e0a9$var$styleReplacer)] = v;
    }
}
/**
 * @param {unknown} _
 * @param {string} $1
 */ function $076e3bd4c2a8e0a9$var$styleReplacer(_, $1) {
    return $1.toUpperCase();
}
/**
 * @param {Position|{start: {line: null, column: null, offset: null}, end: {line: null, column: null, offset: null}}} pos
 * @returns {string}
 */ function $076e3bd4c2a8e0a9$var$flattenPosition(pos) {
    return [
        pos.start.line,
        ":",
        pos.start.column,
        "-",
        pos.end.line,
        ":",
        pos.end.column
    ].map(String).join("");
}


const $09a0bcde9ff9c8f5$var$own = {}.hasOwnProperty;
const $09a0bcde9ff9c8f5$var$changelog = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md";
/** @type {Record<string, Deprecation>} */ const $09a0bcde9ff9c8f5$var$deprecated = {
    plugins: {
        to: "remarkPlugins",
        id: "change-plugins-to-remarkplugins"
    },
    renderers: {
        to: "components",
        id: "change-renderers-to-components"
    },
    astPlugins: {
        id: "remove-buggy-html-in-markdown-parser"
    },
    allowDangerousHtml: {
        id: "remove-buggy-html-in-markdown-parser"
    },
    escapeHtml: {
        id: "remove-buggy-html-in-markdown-parser"
    },
    source: {
        to: "children",
        id: "change-source-to-children"
    },
    allowNode: {
        to: "allowElement",
        id: "replace-allownode-allowedtypes-and-disallowedtypes"
    },
    allowedTypes: {
        to: "allowedElements",
        id: "replace-allownode-allowedtypes-and-disallowedtypes"
    },
    disallowedTypes: {
        to: "disallowedElements",
        id: "replace-allownode-allowedtypes-and-disallowedtypes"
    },
    includeNodeIndex: {
        to: "includeElementIndex",
        id: "change-includenodeindex-to-includeelementindex"
    }
};
function $09a0bcde9ff9c8f5$export$83ef7ab426386201(options) {
    for(const key in $09a0bcde9ff9c8f5$var$deprecated)if ($09a0bcde9ff9c8f5$var$own.call($09a0bcde9ff9c8f5$var$deprecated, key) && $09a0bcde9ff9c8f5$var$own.call(options, key)) {
        const deprecation = $09a0bcde9ff9c8f5$var$deprecated[key];
        console.warn(`[react-markdown] Warning: please ${deprecation.to ? `use \`${deprecation.to}\` instead of` : "remove"} \`${key}\` (see <${$09a0bcde9ff9c8f5$var$changelog}#${deprecation.id}> for more info)`);
        delete $09a0bcde9ff9c8f5$var$deprecated[key];
    }
    const processor = (0, $2b28392ffeb05167$export$7cc1b2fe10c52bb)().use((0, $8943f7d469b81540$export$2e2bcd8739ae039)).use(options.remarkPlugins || []).use((0, $da90f3b8a7ea3e41$export$2e2bcd8739ae039), {
        ...options.remarkRehypeOptions,
        allowDangerousHtml: true
    }).use(options.rehypePlugins || []).use((0, $86dd33034183e52e$export$2e2bcd8739ae039), options);
    const file = new (0, $4168e83a03b7d9cb$export$93dff69eb10dc7ce)();
    if (typeof options.children === "string") file.value = options.children;
    else if (options.children !== undefined && options.children !== null) console.warn(`[react-markdown] Warning: please pass a string as \`children\` (not: \`${options.children}\`)`);
    const hastNode = processor.runSync(processor.parse(file), file);
    if (hastNode.type !== "root") throw new TypeError("Expected a `root` node");
    /** @type {ReactElement} */ let result = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Fragment, {}, (0, $076e3bd4c2a8e0a9$export$4b745c302603ab5d)({
        options: options,
        schema: (0, $f89eec41ea745ec7$export$c0bb0b647f701bb5),
        listDepth: 0
    }, hastNode));
    if (options.className) result = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("div", {
        className: options.className
    }, result);
    return result;
}
$09a0bcde9ff9c8f5$export$83ef7ab426386201.propTypes = {
    // Core options:
    children: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
    // Layout options:
    className: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
    // Filter options:
    allowElement: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).func,
    allowedElements: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string),
    disallowedElements: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string),
    unwrapDisallowed: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).bool,
    // Plugin options:
    remarkPlugins: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).bool,
            (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).arrayOf(// prettier-ignore
            // type-coverage:ignore-next-line
            (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).any)
        ]))
    ])),
    rehypePlugins: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).bool,
            (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).arrayOf(// prettier-ignore
            // type-coverage:ignore-next-line
            (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).any)
        ]))
    ])),
    // Transform options:
    sourcePos: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).bool,
    rawSourcePos: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).bool,
    skipHtml: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).bool,
    includeElementIndex: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).bool,
    transformLinkUri: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).bool
    ]),
    linkTarget: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string
    ]),
    transformImageUri: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).func,
    components: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).object
};


/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('micromark-extension-gfm').Options & import('mdast-util-gfm').Options} Options
 */ /**
 * @typedef {import('micromark-extension-gfm-footnote').HtmlOptions} HtmlOptions
 * @typedef {import('micromark-extension-gfm-strikethrough').Options} Options
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ 
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').ConstructRecord} ConstructRecord
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Previous} Previous
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $abebd4901e9bd1ed$var$wwwPrefix = {
    tokenize: $abebd4901e9bd1ed$var$tokenizeWwwPrefix,
    partial: true
};
const $abebd4901e9bd1ed$var$domain = {
    tokenize: $abebd4901e9bd1ed$var$tokenizeDomain,
    partial: true
};
const $abebd4901e9bd1ed$var$path = {
    tokenize: $abebd4901e9bd1ed$var$tokenizePath,
    partial: true
};
const $abebd4901e9bd1ed$var$trail = {
    tokenize: $abebd4901e9bd1ed$var$tokenizeTrail,
    partial: true
};
const $abebd4901e9bd1ed$var$emailDomainDotTrail = {
    tokenize: $abebd4901e9bd1ed$var$tokenizeEmailDomainDotTrail,
    partial: true
};
const $abebd4901e9bd1ed$var$wwwAutolink = {
    tokenize: $abebd4901e9bd1ed$var$tokenizeWwwAutolink,
    previous: $abebd4901e9bd1ed$var$previousWww
};
const $abebd4901e9bd1ed$var$protocolAutolink = {
    tokenize: $abebd4901e9bd1ed$var$tokenizeProtocolAutolink,
    previous: $abebd4901e9bd1ed$var$previousProtocol
};
const $abebd4901e9bd1ed$var$emailAutolink = {
    tokenize: $abebd4901e9bd1ed$var$tokenizeEmailAutolink,
    previous: $abebd4901e9bd1ed$var$previousEmail
};
/** @type {ConstructRecord} */ const $abebd4901e9bd1ed$var$text = {};
const $abebd4901e9bd1ed$export$608123d9b549151 = {
    text: $abebd4901e9bd1ed$var$text
};
/** @type {Code} */ let $abebd4901e9bd1ed$var$code = 48;
// Add alphanumerics.
while($abebd4901e9bd1ed$var$code < 123){
    $abebd4901e9bd1ed$var$text[$abebd4901e9bd1ed$var$code] = $abebd4901e9bd1ed$var$emailAutolink;
    $abebd4901e9bd1ed$var$code++;
    if ($abebd4901e9bd1ed$var$code === 58) $abebd4901e9bd1ed$var$code = 65;
    else if ($abebd4901e9bd1ed$var$code === 91) $abebd4901e9bd1ed$var$code = 97;
}
$abebd4901e9bd1ed$var$text[43] = $abebd4901e9bd1ed$var$emailAutolink;
$abebd4901e9bd1ed$var$text[45] = $abebd4901e9bd1ed$var$emailAutolink;
$abebd4901e9bd1ed$var$text[46] = $abebd4901e9bd1ed$var$emailAutolink;
$abebd4901e9bd1ed$var$text[95] = $abebd4901e9bd1ed$var$emailAutolink;
$abebd4901e9bd1ed$var$text[72] = [
    $abebd4901e9bd1ed$var$emailAutolink,
    $abebd4901e9bd1ed$var$protocolAutolink
];
$abebd4901e9bd1ed$var$text[104] = [
    $abebd4901e9bd1ed$var$emailAutolink,
    $abebd4901e9bd1ed$var$protocolAutolink
];
$abebd4901e9bd1ed$var$text[87] = [
    $abebd4901e9bd1ed$var$emailAutolink,
    $abebd4901e9bd1ed$var$wwwAutolink
];
$abebd4901e9bd1ed$var$text[119] = [
    $abebd4901e9bd1ed$var$emailAutolink,
    $abebd4901e9bd1ed$var$wwwAutolink
];
// To do: perform email autolink literals on events, afterwards.
// That’s where `markdown-rs` and `cmark-gfm` perform it.
// It should look for `@`, then for atext backwards, and then for a label
// forwards.
// To do: `mailto:`, `xmpp:` protocol as prefix.
/**
 * Email autolink literal.
 *
 * ```markdown
 * > | a contact@example.org b
 *       ^^^^^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $abebd4901e9bd1ed$var$tokenizeEmailAutolink(effects, ok, nok) {
    const self = this;
    /** @type {boolean | undefined} */ let dot;
    /** @type {boolean} */ let data;
    return start;
    /**
   * Start of email autolink literal.
   *
   * ```markdown
   * > | a contact@example.org b
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (!$abebd4901e9bd1ed$var$gfmAtext(code) || !$abebd4901e9bd1ed$var$previousEmail.call(self, self.previous) || $abebd4901e9bd1ed$var$previousUnbalanced(self.events)) return nok(code);
        effects.enter("literalAutolink");
        effects.enter("literalAutolinkEmail");
        return atext(code);
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a contact@example.org b
   *       ^
   * ```
   *
   * @type {State}
   */ function atext(code) {
        if ($abebd4901e9bd1ed$var$gfmAtext(code)) {
            effects.consume(code);
            return atext;
        }
        if (code === 64) {
            effects.consume(code);
            return emailDomain;
        }
        return nok(code);
    }
    /**
   * In email domain.
   *
   * The reference code is a bit overly complex as it handles the `@`, of which
   * there may be just one.
   * Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L318>
   *
   * ```markdown
   * > | a contact@example.org b
   *               ^
   * ```
   *
   * @type {State}
   */ function emailDomain(code) {
        // Dot followed by alphanumerical (not `-` or `_`).
        if (code === 46) return effects.check($abebd4901e9bd1ed$var$emailDomainDotTrail, emailDomainAfter, emailDomainDot)(code);
        // Alphanumerical, `-`, and `_`.
        if (code === 45 || code === 95 || (0, $fc9672c731708cc1$export$75c76db11865a9f4)(code)) {
            data = true;
            effects.consume(code);
            return emailDomain;
        }
        // To do: `/` if xmpp.
        // Note: normally we’d truncate trailing punctuation from the link.
        // However, email autolink literals cannot contain any of those markers,
        // except for `.`, but that can only occur if it isn’t trailing.
        // So we can ignore truncating!
        return emailDomainAfter(code);
    }
    /**
   * In email domain, on dot that is not a trail.
   *
   * ```markdown
   * > | a contact@example.org b
   *                      ^
   * ```
   *
   * @type {State}
   */ function emailDomainDot(code) {
        effects.consume(code);
        dot = true;
        return emailDomain;
    }
    /**
   * After email domain.
   *
   * ```markdown
   * > | a contact@example.org b
   *                          ^
   * ```
   *
   * @type {State}
   */ function emailDomainAfter(code) {
        // Domain must not be empty, must include a dot, and must end in alphabetical.
        // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L332>.
        if (data && dot && (0, $fc9672c731708cc1$export$d65d6b62c24d5436)(self.previous)) {
            effects.exit("literalAutolinkEmail");
            effects.exit("literalAutolink");
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * `www` autolink literal.
 *
 * ```markdown
 * > | a www.example.org b
 *       ^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $abebd4901e9bd1ed$var$tokenizeWwwAutolink(effects, ok, nok) {
    const self = this;
    return wwwStart;
    /**
   * Start of www autolink literal.
   *
   * ```markdown
   * > | www.example.com/a?b#c
   *     ^
   * ```
   *
   * @type {State}
   */ function wwwStart(code) {
        if (code !== 87 && code !== 119 || !$abebd4901e9bd1ed$var$previousWww.call(self, self.previous) || $abebd4901e9bd1ed$var$previousUnbalanced(self.events)) return nok(code);
        effects.enter("literalAutolink");
        effects.enter("literalAutolinkWww");
        // Note: we *check*, so we can discard the `www.` we parsed.
        // If it worked, we consider it as a part of the domain.
        return effects.check($abebd4901e9bd1ed$var$wwwPrefix, effects.attempt($abebd4901e9bd1ed$var$domain, effects.attempt($abebd4901e9bd1ed$var$path, wwwAfter), nok), nok)(code);
    }
    /**
   * After a www autolink literal.
   *
   * ```markdown
   * > | www.example.com/a?b#c
   *                          ^
   * ```
   *
   * @type {State}
   */ function wwwAfter(code) {
        effects.exit("literalAutolinkWww");
        effects.exit("literalAutolink");
        return ok(code);
    }
}
/**
 * Protocol autolink literal.
 *
 * ```markdown
 * > | a https://example.org b
 *       ^^^^^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $abebd4901e9bd1ed$var$tokenizeProtocolAutolink(effects, ok, nok) {
    const self = this;
    let buffer = "";
    let seen = false;
    return protocolStart;
    /**
   * Start of protocol autolink literal.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *     ^
   * ```
   *
   * @type {State}
   */ function protocolStart(code) {
        if ((code === 72 || code === 104) && $abebd4901e9bd1ed$var$previousProtocol.call(self, self.previous) && !$abebd4901e9bd1ed$var$previousUnbalanced(self.events)) {
            effects.enter("literalAutolink");
            effects.enter("literalAutolinkHttp");
            buffer += String.fromCodePoint(code);
            effects.consume(code);
            return protocolPrefixInside;
        }
        return nok(code);
    }
    /**
   * In protocol.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *     ^^^^^
   * ```
   *
   * @type {State}
   */ function protocolPrefixInside(code) {
        // `5` is size of `https`
        if ((0, $fc9672c731708cc1$export$d65d6b62c24d5436)(code) && buffer.length < 5) {
            // @ts-expect-error: definitely number.
            buffer += String.fromCodePoint(code);
            effects.consume(code);
            return protocolPrefixInside;
        }
        if (code === 58) {
            const protocol = buffer.toLowerCase();
            if (protocol === "http" || protocol === "https") {
                effects.consume(code);
                return protocolSlashesInside;
            }
        }
        return nok(code);
    }
    /**
   * In slashes.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *           ^^
   * ```
   *
   * @type {State}
   */ function protocolSlashesInside(code) {
        if (code === 47) {
            effects.consume(code);
            if (seen) return afterProtocol;
            seen = true;
            return protocolSlashesInside;
        }
        return nok(code);
    }
    /**
   * After protocol, before domain.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *             ^
   * ```
   *
   * @type {State}
   */ function afterProtocol(code) {
        // To do: this is different from `markdown-rs`:
        // https://github.com/wooorm/markdown-rs/blob/b3a921c761309ae00a51fe348d8a43adbc54b518/src/construct/gfm_autolink_literal.rs#L172-L182
        return code === null || (0, $fc9672c731708cc1$export$67dbf494fc8394df)(code) || (0, $fc9672c731708cc1$export$a30284361b3814b7)(code) || (0, $fc9672c731708cc1$export$a0ff789c034ffdf4)(code) || (0, $fc9672c731708cc1$export$aa04114dd888a7a0)(code) ? nok(code) : effects.attempt($abebd4901e9bd1ed$var$domain, effects.attempt($abebd4901e9bd1ed$var$path, protocolAfter), nok)(code);
    }
    /**
   * After a protocol autolink literal.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *                              ^
   * ```
   *
   * @type {State}
   */ function protocolAfter(code) {
        effects.exit("literalAutolinkHttp");
        effects.exit("literalAutolink");
        return ok(code);
    }
}
/**
 * `www` prefix.
 *
 * ```markdown
 * > | a www.example.org b
 *       ^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $abebd4901e9bd1ed$var$tokenizeWwwPrefix(effects, ok, nok) {
    let size = 0;
    return wwwPrefixInside;
    /**
   * In www prefix.
   *
   * ```markdown
   * > | www.example.com
   *     ^^^^
   * ```
   *
   * @type {State}
   */ function wwwPrefixInside(code) {
        if ((code === 87 || code === 119) && size < 3) {
            size++;
            effects.consume(code);
            return wwwPrefixInside;
        }
        if (code === 46 && size === 3) {
            effects.consume(code);
            return wwwPrefixAfter;
        }
        return nok(code);
    }
    /**
   * After www prefix.
   *
   * ```markdown
   * > | www.example.com
   *         ^
   * ```
   *
   * @type {State}
   */ function wwwPrefixAfter(code) {
        // If there is *anything*, we can link.
        return code === null ? nok(code) : ok(code);
    }
}
/**
 * Domain.
 *
 * ```markdown
 * > | a https://example.org b
 *               ^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $abebd4901e9bd1ed$var$tokenizeDomain(effects, ok, nok) {
    /** @type {boolean | undefined} */ let underscoreInLastSegment;
    /** @type {boolean | undefined} */ let underscoreInLastLastSegment;
    /** @type {boolean | undefined} */ let seen;
    return domainInside;
    /**
   * In domain.
   *
   * ```markdown
   * > | https://example.com/a
   *             ^^^^^^^^^^^
   * ```
   *
   * @type {State}
   */ function domainInside(code) {
        // Check whether this marker, which is a trailing punctuation
        // marker, optionally followed by more trailing markers, and then
        // followed by an end.
        if (code === 46 || code === 95) return effects.check($abebd4901e9bd1ed$var$trail, domainAfter, domainAtPunctuation)(code);
        // GH documents that only alphanumerics (other than `-`, `.`, and `_`) can
        // occur, which sounds like ASCII only, but they also support `www.點看.com`,
        // so that’s Unicode.
        // Instead of some new production for Unicode alphanumerics, markdown
        // already has that for Unicode punctuation and whitespace, so use those.
        // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L12>.
        if (code === null || (0, $fc9672c731708cc1$export$a30284361b3814b7)(code) || (0, $fc9672c731708cc1$export$a0ff789c034ffdf4)(code) || code !== 45 && (0, $fc9672c731708cc1$export$aa04114dd888a7a0)(code)) return domainAfter(code);
        seen = true;
        effects.consume(code);
        return domainInside;
    }
    /**
   * In domain, at potential trailing punctuation, that was not trailing.
   *
   * ```markdown
   * > | https://example.com
   *                    ^
   * ```
   *
   * @type {State}
   */ function domainAtPunctuation(code) {
        // There is an underscore in the last segment of the domain
        if (code === 95) underscoreInLastSegment = true;
        else {
            underscoreInLastLastSegment = underscoreInLastSegment;
            underscoreInLastSegment = undefined;
        }
        effects.consume(code);
        return domainInside;
    }
    /**
   * After domain.
   *
   * ```markdown
   * > | https://example.com/a
   *                        ^
   * ```
   *
   * @type {State} */ function domainAfter(code) {
        // Note: that’s GH says a dot is needed, but it’s not true:
        // <https://github.com/github/cmark-gfm/issues/279>
        if (underscoreInLastLastSegment || underscoreInLastSegment || !seen) return nok(code);
        return ok(code);
    }
}
/**
 * Path.
 *
 * ```markdown
 * > | a https://example.org/stuff b
 *                          ^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $abebd4901e9bd1ed$var$tokenizePath(effects, ok) {
    let sizeOpen = 0;
    let sizeClose = 0;
    return pathInside;
    /**
   * In path.
   *
   * ```markdown
   * > | https://example.com/a
   *                        ^^
   * ```
   *
   * @type {State}
   */ function pathInside(code) {
        if (code === 40) {
            sizeOpen++;
            effects.consume(code);
            return pathInside;
        }
        // To do: `markdown-rs` also needs this.
        // If this is a paren, and there are less closings than openings,
        // we don’t check for a trail.
        if (code === 41 && sizeClose < sizeOpen) return pathAtPunctuation(code);
        // Check whether this trailing punctuation marker is optionally
        // followed by more trailing markers, and then followed
        // by an end.
        if (code === 33 || code === 34 || code === 38 || code === 39 || code === 41 || code === 42 || code === 44 || code === 46 || code === 58 || code === 59 || code === 60 || code === 63 || code === 93 || code === 95 || code === 126) return effects.check($abebd4901e9bd1ed$var$trail, ok, pathAtPunctuation)(code);
        if (code === null || (0, $fc9672c731708cc1$export$a30284361b3814b7)(code) || (0, $fc9672c731708cc1$export$a0ff789c034ffdf4)(code)) return ok(code);
        effects.consume(code);
        return pathInside;
    }
    /**
   * In path, at potential trailing punctuation, that was not trailing.
   *
   * ```markdown
   * > | https://example.com/a"b
   *                          ^
   * ```
   *
   * @type {State}
   */ function pathAtPunctuation(code) {
        // Count closing parens.
        if (code === 41) sizeClose++;
        effects.consume(code);
        return pathInside;
    }
}
/**
 * Trail.
 *
 * This calls `ok` if this *is* the trail, followed by an end, which means
 * the entire trail is not part of the link.
 * It calls `nok` if this *is* part of the link.
 *
 * ```markdown
 * > | https://example.com").
 *                        ^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $abebd4901e9bd1ed$var$tokenizeTrail(effects, ok, nok) {
    return trail;
    /**
   * In trail of domain or path.
   *
   * ```markdown
   * > | https://example.com").
   *                        ^
   * ```
   *
   * @type {State}
   */ function trail(code) {
        // Regular trailing punctuation.
        if (code === 33 || code === 34 || code === 39 || code === 41 || code === 42 || code === 44 || code === 46 || code === 58 || code === 59 || code === 63 || code === 95 || code === 126) {
            effects.consume(code);
            return trail;
        }
        // `&` followed by one or more alphabeticals and then a `;`, is
        // as a whole considered as trailing punctuation.
        // In all other cases, it is considered as continuation of the URL.
        if (code === 38) {
            effects.consume(code);
            return trailCharRefStart;
        }
        // Needed because we allow literals after `[`, as we fix:
        // <https://github.com/github/cmark-gfm/issues/278>.
        // Check that it is not followed by `(` or `[`.
        if (code === 93) {
            effects.consume(code);
            return trailBracketAfter;
        }
        if (// `<` is an end.
        code === 60 || // So is whitespace.
        code === null || (0, $fc9672c731708cc1$export$a30284361b3814b7)(code) || (0, $fc9672c731708cc1$export$a0ff789c034ffdf4)(code)) return ok(code);
        return nok(code);
    }
    /**
   * In trail, after `]`.
   *
   * > 👉 **Note**: this deviates from `cmark-gfm` to fix a bug.
   * > See end of <https://github.com/github/cmark-gfm/issues/278> for more.
   *
   * ```markdown
   * > | https://example.com](
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailBracketAfter(code) {
        // Whitespace or something that could start a resource or reference is the end.
        // Switch back to trail otherwise.
        if (code === null || code === 40 || code === 91 || (0, $fc9672c731708cc1$export$a30284361b3814b7)(code) || (0, $fc9672c731708cc1$export$a0ff789c034ffdf4)(code)) return ok(code);
        return trail(code);
    }
    /**
   * In character-reference like trail, after `&`.
   *
   * ```markdown
   * > | https://example.com&amp;).
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailCharRefStart(code) {
        // When non-alpha, it’s not a trail.
        return (0, $fc9672c731708cc1$export$d65d6b62c24d5436)(code) ? trailCharRefInside(code) : nok(code);
    }
    /**
   * In character-reference like trail.
   *
   * ```markdown
   * > | https://example.com&amp;).
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailCharRefInside(code) {
        // Switch back to trail if this is well-formed.
        if (code === 59) {
            effects.consume(code);
            return trail;
        }
        if ((0, $fc9672c731708cc1$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return trailCharRefInside;
        }
        // It’s not a trail.
        return nok(code);
    }
}
/**
 * Dot in email domain trail.
 *
 * This calls `ok` if this *is* the trail, followed by an end, which means
 * the trail is not part of the link.
 * It calls `nok` if this *is* part of the link.
 *
 * ```markdown
 * > | contact@example.org.
 *                        ^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $abebd4901e9bd1ed$var$tokenizeEmailDomainDotTrail(effects, ok, nok) {
    return start;
    /**
   * Dot.
   *
   * ```markdown
   * > | contact@example.org.
   *                    ^   ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Must be dot.
        effects.consume(code);
        return after;
    }
    /**
   * After dot.
   *
   * ```markdown
   * > | contact@example.org.
   *                     ^   ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Not a trail if alphanumeric.
        return (0, $fc9672c731708cc1$export$75c76db11865a9f4)(code) ? nok(code) : ok(code);
    }
}
/**
 * See:
 * <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L156>.
 *
 * @type {Previous}
 */ function $abebd4901e9bd1ed$var$previousWww(code) {
    return code === null || code === 40 || code === 42 || code === 95 || code === 91 || code === 93 || code === 126 || (0, $fc9672c731708cc1$export$a30284361b3814b7)(code);
}
/**
 * See:
 * <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L214>.
 *
 * @type {Previous}
 */ function $abebd4901e9bd1ed$var$previousProtocol(code) {
    return !(0, $fc9672c731708cc1$export$d65d6b62c24d5436)(code);
}
/**
 * @this {TokenizeContext}
 * @type {Previous}
 */ function $abebd4901e9bd1ed$var$previousEmail(code) {
    // Do not allow a slash “inside” atext.
    // The reference code is a bit weird, but that’s what it results in.
    // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L307>.
    // Other than slash, every preceding character is allowed.
    return !(code === 47 || $abebd4901e9bd1ed$var$gfmAtext(code));
}
/**
 * @param {Code} code
 * @returns {boolean}
 */ function $abebd4901e9bd1ed$var$gfmAtext(code) {
    return code === 43 || code === 45 || code === 46 || code === 95 || (0, $fc9672c731708cc1$export$75c76db11865a9f4)(code);
}
/**
 * @param {Array<Event>} events
 * @returns {boolean}
 */ function $abebd4901e9bd1ed$var$previousUnbalanced(events) {
    let index = events.length;
    let result = false;
    while(index--){
        const token = events[index][1];
        if ((token.type === "labelLink" || token.type === "labelImage") && !token._balanced) {
            result = true;
            break;
        }
        // If we’ve seen this token, and it was marked as not having any unbalanced
        // bracket before it, we can exit.
        if (token._gfmAutolinkLiteralWalkedInto) {
            result = false;
            break;
        }
    }
    if (events.length > 0 && !result) // Mark the last token as “walked into” w/o finding
    // anything.
    events[events.length - 1][1]._gfmAutolinkLiteralWalkedInto = true;
    return result;
}

/**
 * @typedef {import('micromark-util-types').CompileContext} CompileContext
 * @typedef {import('micromark-util-types').Handle} Handle
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').Token} Token
 */ 
const $cc989f8f74aefa60$export$999603f1f1c3d2f9 = {
    exit: {
        literalAutolinkEmail: $cc989f8f74aefa60$var$literalAutolinkEmail,
        literalAutolinkHttp: $cc989f8f74aefa60$var$literalAutolinkHttp,
        literalAutolinkWww: $cc989f8f74aefa60$var$literalAutolinkWww
    }
};
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $cc989f8f74aefa60$var$literalAutolinkWww(token) {
    $cc989f8f74aefa60$var$anchorFromToken.call(this, token, "http://");
}
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $cc989f8f74aefa60$var$literalAutolinkEmail(token) {
    $cc989f8f74aefa60$var$anchorFromToken.call(this, token, "mailto:");
}
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $cc989f8f74aefa60$var$literalAutolinkHttp(token) {
    $cc989f8f74aefa60$var$anchorFromToken.call(this, token);
}
/**
 * @this CompileContext
 * @param {Token} token
 * @param {string | null | undefined} [protocol]
 * @returns {void}
 */ function $cc989f8f74aefa60$var$anchorFromToken(token, protocol) {
    const url = this.sliceSerialize(token);
    this.tag('<a href="' + (0, $71b8b713c55a94fa$export$d130a2d684099e5a)((protocol || "") + url) + '">');
    this.raw(this.encode(url));
    this.tag("</a>");
}


/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 



const $54355b33de88f7ed$var$indent = {
    tokenize: $54355b33de88f7ed$var$tokenizeIndent,
    partial: true
};
function $54355b33de88f7ed$export$c82499b6656305df() {
    /** @type {Extension} */ return {
        document: {
            [91]: {
                tokenize: $54355b33de88f7ed$var$tokenizeDefinitionStart,
                continuation: {
                    tokenize: $54355b33de88f7ed$var$tokenizeDefinitionContinuation
                },
                exit: $54355b33de88f7ed$var$gfmFootnoteDefinitionEnd
            }
        },
        text: {
            [91]: {
                tokenize: $54355b33de88f7ed$var$tokenizeGfmFootnoteCall
            },
            [93]: {
                add: "after",
                tokenize: $54355b33de88f7ed$var$tokenizePotentialGfmFootnoteCall,
                resolveTo: $54355b33de88f7ed$var$resolveToPotentialGfmFootnoteCall
            }
        }
    };
}
// To do: remove after micromark update.
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $54355b33de88f7ed$var$tokenizePotentialGfmFootnoteCall(effects, ok, nok) {
    const self = this;
    let index = self.events.length;
    /** @type {Array<string>} */ // @ts-expect-error It’s fine!
    const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    /** @type {Token} */ let labelStart;
    // Find an opening.
    while(index--){
        const token = self.events[index][1];
        if (token.type === "labelImage") {
            labelStart = token;
            break;
        }
        // Exit if we’ve walked far enough.
        if (token.type === "gfmFootnoteCall" || token.type === "labelLink" || token.type === "label" || token.type === "image" || token.type === "link") break;
    }
    return start;
    /**
   * @type {State}
   */ function start(code) {
        if (!labelStart || !labelStart._balanced) return nok(code);
        const id = (0, $3ef6ca0a03bd4b95$export$806d55e226cfcd08)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        }));
        if (id.codePointAt(0) !== 94 || !defined.includes(id.slice(1))) return nok(code);
        effects.enter("gfmFootnoteCallLabelMarker");
        effects.consume(code);
        effects.exit("gfmFootnoteCallLabelMarker");
        return ok(code);
    }
}
// To do: remove after micromark update.
/** @type {Resolver} */ function $54355b33de88f7ed$var$resolveToPotentialGfmFootnoteCall(events, context) {
    let index = events.length;
    /** @type {Token | undefined} */ let labelStart;
    // Find an opening.
    while(index--)if (events[index][1].type === "labelImage" && events[index][0] === "enter") {
        labelStart = events[index][1];
        break;
    }
    // Change the `labelImageMarker` to a `data`.
    events[index + 1][1].type = "data";
    events[index + 3][1].type = "gfmFootnoteCallLabelMarker";
    // The whole (without `!`):
    /** @type {Token} */ const call = {
        type: "gfmFootnoteCall",
        start: Object.assign({}, events[index + 3][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    // The `^` marker
    /** @type {Token} */ const marker = {
        type: "gfmFootnoteCallMarker",
        start: Object.assign({}, events[index + 3][1].end),
        end: Object.assign({}, events[index + 3][1].end)
    };
    // Increment the end 1 character.
    marker.end.column++;
    marker.end.offset++;
    marker.end._bufferIndex++;
    /** @type {Token} */ const string = {
        type: "gfmFootnoteCallString",
        start: Object.assign({}, marker.end),
        end: Object.assign({}, events[events.length - 1][1].start)
    };
    /** @type {Token} */ const chunk = {
        type: "chunkString",
        contentType: "string",
        start: Object.assign({}, string.start),
        end: Object.assign({}, string.end)
    };
    /** @type {Array<Event>} */ const replacement = [
        // Take the `labelImageMarker` (now `data`, the `!`)
        events[index + 1],
        events[index + 2],
        [
            "enter",
            call,
            context
        ],
        // The `[`
        events[index + 3],
        events[index + 4],
        // The `^`.
        [
            "enter",
            marker,
            context
        ],
        [
            "exit",
            marker,
            context
        ],
        // Everything in between.
        [
            "enter",
            string,
            context
        ],
        [
            "enter",
            chunk,
            context
        ],
        [
            "exit",
            chunk,
            context
        ],
        [
            "exit",
            string,
            context
        ],
        // The ending (`]`, properly parsed and labelled).
        events[events.length - 2],
        events[events.length - 1],
        [
            "exit",
            call,
            context
        ]
    ];
    events.splice(index, events.length - index + 1, ...replacement);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $54355b33de88f7ed$var$tokenizeGfmFootnoteCall(effects, ok, nok) {
    const self = this;
    /** @type {Array<string>} */ // @ts-expect-error It’s fine!
    const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    let size = 0;
    /** @type {boolean} */ let data;
    // Note: the implementation of `markdown-rs` is different, because it houses
    // core *and* extensions in one project.
    // Therefore, it can include footnote logic inside `label-end`.
    // We can’t do that, but luckily, we can parse footnotes in a simpler way than
    // needed for labels.
    return start;
    /**
   * Start of footnote label.
   *
   * ```markdown
   * > | a [^b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("gfmFootnoteCall");
        effects.enter("gfmFootnoteCallLabelMarker");
        effects.consume(code);
        effects.exit("gfmFootnoteCallLabelMarker");
        return callStart;
    }
    /**
   * After `[`, at `^`.
   *
   * ```markdown
   * > | a [^b] c
   *        ^
   * ```
   *
   * @type {State}
   */ function callStart(code) {
        if (code !== 94) return nok(code);
        effects.enter("gfmFootnoteCallMarker");
        effects.consume(code);
        effects.exit("gfmFootnoteCallMarker");
        effects.enter("gfmFootnoteCallString");
        effects.enter("chunkString").contentType = "string";
        return callData;
    }
    /**
   * In label.
   *
   * ```markdown
   * > | a [^b] c
   *         ^
   * ```
   *
   * @type {State}
   */ function callData(code) {
        if (// Too long.
        size > 999 || // Closing brace with nothing.
        code === 93 && !data || // Space or tab is not supported by GFM for some reason.
        // `\n` and `[` not being supported makes sense.
        code === null || code === 91 || (0, $fc9672c731708cc1$export$a30284361b3814b7)(code)) return nok(code);
        if (code === 93) {
            effects.exit("chunkString");
            const token = effects.exit("gfmFootnoteCallString");
            if (!defined.includes((0, $3ef6ca0a03bd4b95$export$806d55e226cfcd08)(self.sliceSerialize(token)))) return nok(code);
            effects.enter("gfmFootnoteCallLabelMarker");
            effects.consume(code);
            effects.exit("gfmFootnoteCallLabelMarker");
            effects.exit("gfmFootnoteCall");
            return ok;
        }
        if (!(0, $fc9672c731708cc1$export$a30284361b3814b7)(code)) data = true;
        size++;
        effects.consume(code);
        return code === 92 ? callEscape : callData;
    }
    /**
   * On character after escape.
   *
   * ```markdown
   * > | a [^b\c] d
   *           ^
   * ```
   *
   * @type {State}
   */ function callEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return callData;
        }
        return callData(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $54355b33de88f7ed$var$tokenizeDefinitionStart(effects, ok, nok) {
    const self = this;
    /** @type {Array<string>} */ // @ts-expect-error It’s fine!
    const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    /** @type {string} */ let identifier;
    let size = 0;
    /** @type {boolean | undefined} */ let data;
    return start;
    /**
   * Start of GFM footnote definition.
   *
   * ```markdown
   * > | [^a]: b
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("gfmFootnoteDefinition")._container = true;
        effects.enter("gfmFootnoteDefinitionLabel");
        effects.enter("gfmFootnoteDefinitionLabelMarker");
        effects.consume(code);
        effects.exit("gfmFootnoteDefinitionLabelMarker");
        return labelAtMarker;
    }
    /**
   * In label, at caret.
   *
   * ```markdown
   * > | [^a]: b
   *      ^
   * ```
   *
   * @type {State}
   */ function labelAtMarker(code) {
        if (code === 94) {
            effects.enter("gfmFootnoteDefinitionMarker");
            effects.consume(code);
            effects.exit("gfmFootnoteDefinitionMarker");
            effects.enter("gfmFootnoteDefinitionLabelString");
            effects.enter("chunkString").contentType = "string";
            return labelInside;
        }
        return nok(code);
    }
    /**
   * In label.
   *
   * > 👉 **Note**: `cmark-gfm` prevents whitespace from occurring in footnote
   * > definition labels.
   *
   * ```markdown
   * > | [^a]: b
   *       ^
   * ```
   *
   * @type {State}
   */ function labelInside(code) {
        if (// Too long.
        size > 999 || // Closing brace with nothing.
        code === 93 && !data || // Space or tab is not supported by GFM for some reason.
        // `\n` and `[` not being supported makes sense.
        code === null || code === 91 || (0, $fc9672c731708cc1$export$a30284361b3814b7)(code)) return nok(code);
        if (code === 93) {
            effects.exit("chunkString");
            const token = effects.exit("gfmFootnoteDefinitionLabelString");
            identifier = (0, $3ef6ca0a03bd4b95$export$806d55e226cfcd08)(self.sliceSerialize(token));
            effects.enter("gfmFootnoteDefinitionLabelMarker");
            effects.consume(code);
            effects.exit("gfmFootnoteDefinitionLabelMarker");
            effects.exit("gfmFootnoteDefinitionLabel");
            return labelAfter;
        }
        if (!(0, $fc9672c731708cc1$export$a30284361b3814b7)(code)) data = true;
        size++;
        effects.consume(code);
        return code === 92 ? labelEscape : labelInside;
    }
    /**
   * After `\`, at a special character.
   *
   * > 👉 **Note**: `cmark-gfm` currently does not support escaped brackets:
   * > <https://github.com/github/cmark-gfm/issues/240>
   *
   * ```markdown
   * > | [^a\*b]: c
   *         ^
   * ```
   *
   * @type {State}
   */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return labelInside;
        }
        return labelInside(code);
    }
    /**
   * After definition label.
   *
   * ```markdown
   * > | [^a]: b
   *         ^
   * ```
   *
   * @type {State}
   */ function labelAfter(code) {
        if (code === 58) {
            effects.enter("definitionMarker");
            effects.consume(code);
            effects.exit("definitionMarker");
            if (!defined.includes(identifier)) defined.push(identifier);
            // Any whitespace after the marker is eaten, forming indented code
            // is not possible.
            // No space is also fine, just like a block quote marker.
            return (0, $048e24d1164dbff0$export$ae105c1eb063a0a2)(effects, whitespaceAfter, "gfmFootnoteDefinitionWhitespace");
        }
        return nok(code);
    }
    /**
   * After definition prefix.
   *
   * ```markdown
   * > | [^a]: b
   *           ^
   * ```
   *
   * @type {State}
   */ function whitespaceAfter(code) {
        // `markdown-rs` has a wrapping token for the prefix that is closed here.
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $54355b33de88f7ed$var$tokenizeDefinitionContinuation(effects, ok, nok) {
    /// Start of footnote definition continuation.
    ///
    /// ```markdown
    ///   | [^a]: b
    /// > |     c
    ///     ^
    /// ```
    //
    // Either a blank line, which is okay, or an indented thing.
    return effects.check((0, $ec58cd122e396498$export$d50d28ce3ab2a612), ok, effects.attempt($54355b33de88f7ed$var$indent, ok, nok));
}
/** @type {Exiter} */ function $54355b33de88f7ed$var$gfmFootnoteDefinitionEnd(effects) {
    effects.exit("gfmFootnoteDefinition");
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $54355b33de88f7ed$var$tokenizeIndent(effects, ok, nok) {
    const self = this;
    return (0, $048e24d1164dbff0$export$ae105c1eb063a0a2)(effects, afterPrefix, "gfmFootnoteDefinitionIndent", 5);
    /**
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "gfmFootnoteDefinitionIndent" && tail[2].sliceSerialize(tail[1], true).length === 4 ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ /**
 * @callback BackLabelTemplate
 *   Generate a back label dynamically.
 *
 *   For the following markdown:
 *
 *   ```markdown
 *   Alpha[^micromark], bravo[^micromark], and charlie[^remark].
 *
 *   [^remark]: things about remark
 *   [^micromark]: things about micromark
 *   ```
 *
 *   This function will be called with:
 *
 *   * `0` and `0` for the backreference from `things about micromark` to
 *      `alpha`, as it is the first used definition, and the first call to it
 *   * `0` and `1` for the backreference from `things about micromark` to
 *      `bravo`, as it is the first used definition, and the second call to it
 *   * `1` and `0` for the backreference from `things about remark` to
 *      `charlie`, as it is the second used definition
 * @param {number} referenceIndex
 *   Index of the definition in the order that they are first referenced,
 *   0-indexed.
 * @param {number} rereferenceIndex
 *   Index of calls to the same definition, 0-indexed.
 * @returns {string}
 *   Back label to use when linking back from definitions to their reference.
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {string} [clobberPrefix='user-content-']
 *   Prefix to use before the `id` attribute on footnotes to prevent them from
 *   *clobbering*.
 *
 *   The default is `'user-content-'`.
 *   Pass `''` for trusted markdown and when you are careful with
 *   polyfilling.
 *   You could pass a different prefix.
 *
 *   DOM clobbering is this:
 *
 *   ```html
 *   <p id="x"></p>
 *   <script>alert(x) // `x` now refers to the `p#x` DOM element</script>
 *   ```
 *
 *   The above example shows that elements are made available by browsers, by
 *   their ID, on the `window` object.
 *   This is a security risk because you might be expecting some other variable
 *   at that place.
 *   It can also break polyfills.
 *   Using a prefix solves these problems.
 * @property {string} [label='Footnotes']
 *   Textual label to use for the footnotes section.
 *
 *   The default value is `'Footnotes'`.
 *   Change it when the markdown is not in English.
 *
 *   This label is typically hidden visually (assuming a `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass different attributes with the `labelAttributes` option.
 * @property {string} [labelAttributes='class="sr-only"']
 *   Attributes to use on the footnote label.
 *
 *   Change it to show the label and add other attributes.
 *
 *   This label is typically hidden visually (assuming an `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass an empty string.
 *   You can also add different attributes.
 *
 *   > 👉 **Note**: `id="footnote-label"` is always added, because footnote
 *   > calls use it with `aria-describedby` to provide an accessible label.
 * @property {string} [labelTagName='h2']
 *   HTML tag name to use for the footnote label element.
 *
 *   Change it to match your document structure.
 *
 *   This label is typically hidden visually (assuming a `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass different attributes with the `labelAttributes` option.
 * @property {BackLabelTemplate | string} [backLabel]
 *   Textual label to describe the backreference back to references.
 *
 *   The default value is:
 *
 *   ```js
 *   function defaultBackLabel(referenceIndex, rereferenceIndex) {
 *    return (
 *      'Back to reference ' +
 *      (referenceIndex + 1) +
 *      (rereferenceIndex > 1 ? '-' + rereferenceIndex : '')
 *    )
 *  }
 *   ```
 *
 *   Change it when the markdown is not in English.
 *
 *   This label is used in the `aria-label` attribute on each backreference
 *   (the `↩` links).
 *   It affects users of assistive technology.
 */ 

const $edfad8c81dffa5d6$var$own = {}.hasOwnProperty;
/** @type {Options} */ const $edfad8c81dffa5d6$var$emptyOptions = {};
function $edfad8c81dffa5d6$export$a18c77a47f4154b6(referenceIndex, rereferenceIndex) {
    return "Back to reference " + (referenceIndex + 1) + (rereferenceIndex > 1 ? "-" + rereferenceIndex : "");
}
function $edfad8c81dffa5d6$export$a731a1f6cf81900c(options) {
    const config = options || $edfad8c81dffa5d6$var$emptyOptions;
    const label = config.label || "Footnotes";
    const labelTagName = config.labelTagName || "h2";
    const labelAttributes = config.labelAttributes === null || config.labelAttributes === undefined ? 'class="sr-only"' : config.labelAttributes;
    const backLabel = config.backLabel || $edfad8c81dffa5d6$export$a18c77a47f4154b6;
    const clobberPrefix = config.clobberPrefix === null || config.clobberPrefix === undefined ? "user-content-" : config.clobberPrefix;
    return {
        enter: {
            gfmFootnoteDefinition () {
                const stack = this.getData("tightStack");
                stack.push(false);
            },
            gfmFootnoteDefinitionLabelString () {
                this.buffer();
            },
            gfmFootnoteCallString () {
                this.buffer();
            }
        },
        exit: {
            gfmFootnoteDefinition () {
                let definitions = this.getData("gfmFootnoteDefinitions");
                const footnoteStack = this.getData("gfmFootnoteDefinitionStack");
                const tightStack = this.getData("tightStack");
                const current = footnoteStack.pop();
                const value = this.resume();
                if (!definitions) this.setData("gfmFootnoteDefinitions", definitions = {});
                if (!$edfad8c81dffa5d6$var$own.call(definitions, current)) definitions[current] = value;
                tightStack.pop();
                this.setData("slurpOneLineEnding", true);
                // “Hack” to prevent a line ending from showing up if we’re in a definition in
                // an empty list item.
                this.setData("lastWasTag");
            },
            gfmFootnoteDefinitionLabelString (token) {
                let footnoteStack = /** @type {Array<string>} */ this.getData("gfmFootnoteDefinitionStack");
                if (!footnoteStack) this.setData("gfmFootnoteDefinitionStack", footnoteStack = []);
                footnoteStack.push((0, $3ef6ca0a03bd4b95$export$806d55e226cfcd08)(this.sliceSerialize(token)));
                this.resume() // Drop the label.
                ;
                this.buffer() // Get ready for a value.
                ;
            },
            gfmFootnoteCallString (token) {
                let calls = this.getData("gfmFootnoteCallOrder");
                let counts = this.getData("gfmFootnoteCallCounts");
                const id = (0, $3ef6ca0a03bd4b95$export$806d55e226cfcd08)(this.sliceSerialize(token));
                /** @type {number} */ let counter;
                this.resume();
                if (!calls) this.setData("gfmFootnoteCallOrder", calls = []);
                if (!counts) this.setData("gfmFootnoteCallCounts", counts = {});
                const index = calls.indexOf(id);
                const safeId = (0, $71b8b713c55a94fa$export$d130a2d684099e5a)(id.toLowerCase());
                if (index === -1) {
                    calls.push(id);
                    counts[id] = 1;
                    counter = calls.length;
                } else {
                    counts[id]++;
                    counter = index + 1;
                }
                const reuseCounter = counts[id];
                this.tag('<sup><a href="#' + clobberPrefix + "fn-" + safeId + '" id="' + clobberPrefix + "fnref-" + safeId + (reuseCounter > 1 ? "-" + reuseCounter : "") + '" data-footnote-ref="" aria-describedby="footnote-label">' + String(counter) + "</a></sup>");
            },
            null () {
                const calls = /** @type {Array<string>} */ this.getData("gfmFootnoteCallOrder") || [];
                const counts = /** @type {Record<string, number>} */ this.getData("gfmFootnoteCallCounts") || {};
                const definitions = /** @type {Record<string, string>} */ this.getData("gfmFootnoteDefinitions") || {};
                let index = -1;
                if (calls.length > 0) {
                    this.lineEndingIfNeeded();
                    this.tag('<section data-footnotes="" class="footnotes"><' + labelTagName + ' id="footnote-label"' + (labelAttributes ? " " + labelAttributes : "") + ">");
                    this.raw(this.encode(label));
                    this.tag("</" + labelTagName + ">");
                    this.lineEndingIfNeeded();
                    this.tag("<ol>");
                }
                while(++index < calls.length){
                    // Called definitions are always defined.
                    const id = calls[index];
                    const safeId = (0, $71b8b713c55a94fa$export$d130a2d684099e5a)(id.toLowerCase());
                    let referenceIndex = 0;
                    /** @type {Array<string>} */ const references = [];
                    while(++referenceIndex <= counts[id])references.push('<a href="#' + clobberPrefix + "fnref-" + safeId + (referenceIndex > 1 ? "-" + referenceIndex : "") + '" data-footnote-backref="" aria-label="' + this.encode(typeof backLabel === "string" ? backLabel : backLabel(index, referenceIndex)) + '" class="data-footnote-backref">\u21A9' + (referenceIndex > 1 ? "<sup>" + referenceIndex + "</sup>" : "") + "</a>");
                    const reference = references.join(" ");
                    let injected = false;
                    this.lineEndingIfNeeded();
                    this.tag('<li id="' + clobberPrefix + "fn-" + safeId + '">');
                    this.lineEndingIfNeeded();
                    this.tag(definitions[id].replace(/<\/p>(?:\r?\n|\r)?$/, (/** @type {string} */ $0)=>{
                        injected = true;
                        return " " + reference + $0;
                    }));
                    if (!injected) {
                        this.lineEndingIfNeeded();
                        this.tag(reference);
                    }
                    this.lineEndingIfNeeded();
                    this.tag("</li>");
                }
                if (calls.length > 0) {
                    this.lineEndingIfNeeded();
                    this.tag("</ol>");
                    this.lineEndingIfNeeded();
                    this.tag("</section>");
                }
            }
        }
    };
}


/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean} [singleTilde=true]
 *   Whether to support strikethrough with a single tilde.
 *
 *   Single tildes work on github.com, but are technically prohibited by the
 *   GFM spec.
 */ 


function $ebfdc2aaa2f0f66c$export$8bbec8ea1400a00e(options) {
    const options_ = options || {};
    let single = options_.singleTilde;
    const tokenizer = {
        tokenize: tokenizeStrikethrough,
        resolveAll: resolveAllStrikethrough
    };
    if (single === null || single === undefined) single = true;
    return {
        text: {
            [126]: tokenizer
        },
        insideSpan: {
            null: [
                tokenizer
            ]
        },
        attentionMarkers: {
            null: [
                126
            ]
        }
    };
    /**
   * Take events and resolve strikethrough.
   *
   * @type {Resolver}
   */ function resolveAllStrikethrough(events, context) {
        let index = -1;
        // Walk through all events.
        while(++index < events.length)// Find a token that can close.
        if (events[index][0] === "enter" && events[index][1].type === "strikethroughSequenceTemporary" && events[index][1]._close) {
            let open = index;
            // Now walk back to find an opener.
            while(open--)// Find a token that can open the closer.
            if (events[open][0] === "exit" && events[open][1].type === "strikethroughSequenceTemporary" && events[open][1]._open && // If the sizes are the same:
            events[index][1].end.offset - events[index][1].start.offset === events[open][1].end.offset - events[open][1].start.offset) {
                events[index][1].type = "strikethroughSequence";
                events[open][1].type = "strikethroughSequence";
                /** @type {Token} */ const strikethrough = {
                    type: "strikethrough",
                    start: Object.assign({}, events[open][1].start),
                    end: Object.assign({}, events[index][1].end)
                };
                /** @type {Token} */ const text = {
                    type: "strikethroughText",
                    start: Object.assign({}, events[open][1].end),
                    end: Object.assign({}, events[index][1].start)
                };
                // Opening.
                /** @type {Array<Event>} */ const nextEvents = [
                    [
                        "enter",
                        strikethrough,
                        context
                    ],
                    [
                        "enter",
                        events[open][1],
                        context
                    ],
                    [
                        "exit",
                        events[open][1],
                        context
                    ],
                    [
                        "enter",
                        text,
                        context
                    ]
                ];
                const insideSpan = context.parser.constructs.insideSpan.null;
                if (insideSpan) // Between.
                (0, $f35ae38d0ff93729$export$869882364835d202)(nextEvents, nextEvents.length, 0, (0, $0358419463affc45$export$3ff61ec196ff408b)(insideSpan, events.slice(open + 1, index), context));
                // Closing.
                (0, $f35ae38d0ff93729$export$869882364835d202)(nextEvents, nextEvents.length, 0, [
                    [
                        "exit",
                        text,
                        context
                    ],
                    [
                        "enter",
                        events[index][1],
                        context
                    ],
                    [
                        "exit",
                        events[index][1],
                        context
                    ],
                    [
                        "exit",
                        strikethrough,
                        context
                    ]
                ]);
                (0, $f35ae38d0ff93729$export$869882364835d202)(events, open - 1, index - open + 3, nextEvents);
                index = open + nextEvents.length - 2;
                break;
            }
        }
        index = -1;
        while(++index < events.length)if (events[index][1].type === "strikethroughSequenceTemporary") events[index][1].type = "data";
        return events;
    }
    /**
   * @this {TokenizeContext}
   * @type {Tokenizer}
   */ function tokenizeStrikethrough(effects, ok, nok) {
        const previous = this.previous;
        const events = this.events;
        let size = 0;
        return start;
        /** @type {State} */ function start(code) {
            if (previous === 126 && events[events.length - 1][1].type !== "characterEscape") return nok(code);
            effects.enter("strikethroughSequenceTemporary");
            return more(code);
        }
        /** @type {State} */ function more(code) {
            const before = (0, $5d99f7ce7d58a5ed$export$e3902bc0d835cad0)(previous);
            if (code === 126) {
                // If this is the third marker, exit.
                if (size > 1) return nok(code);
                effects.consume(code);
                size++;
                return more;
            }
            if (size < 2 && !single) return nok(code);
            const token = effects.exit("strikethroughSequenceTemporary");
            const after = (0, $5d99f7ce7d58a5ed$export$e3902bc0d835cad0)(code);
            token._open = !after || after === 2 && Boolean(before);
            token._close = !before || before === 2 && Boolean(after);
            return ok(code);
        }
    }
}

/**
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ // To do: next major: expose function instead of object.
/**
 * Extension for `micromark` that can be passed in `htmlExtensions`, to
 * support GFM strikethrough when serializing to HTML.
 *
 * @type {HtmlExtension}
 */ const $1440838da5572fdb$export$58acedca46108820 = {
    enter: {
        strikethrough () {
            this.tag("<del>");
        }
    },
    exit: {
        strikethrough () {
            this.tag("</del>");
        }
    }
};


/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {[number, number, number, number]} Range
 *   Cell info.
 *
 * @typedef {0 | 1 | 2 | 3} RowKind
 *   Where we are: `1` for head row, `2` for delimiter row, `3` for body row.
 */ 

/**
 * @typedef {import('micromark-util-types').Event} Event
 */ // Port of `edit_map.rs` from `markdown-rs`.
// This should move to `markdown-js` later.
// Deal with several changes in events, batching them together.
//
// Preferably, changes should be kept to a minimum.
// Sometimes, it’s needed to change the list of events, because parsing can be
// messy, and it helps to expose a cleaner interface of events to the compiler
// and other users.
// It can also help to merge many adjacent similar events.
// And, in other cases, it’s needed to parse subcontent: pass some events
// through another tokenizer and inject the result.
/**
 * @typedef {[number, number, Array<Event>]} Change
 * @typedef {[number, number, number]} Jump
 */ /**
 * Tracks a bunch of edits.
 */ class $fd021270952e58e1$export$9348908dd4518b4a {
    /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {void}
   */ add(index, remove, add) {
        $fd021270952e58e1$var$addImpl(this, index, remove, add);
    }
    // To do: not used here.
    // /**
    //  * Create an edit: but insert `add` before existing additions.
    //  *
    //  * @param {number} index
    //  * @param {number} remove
    //  * @param {Array<Event>} add
    //  * @returns {void}
    //  */
    // addBefore(index, remove, add) {
    //   addImpl(this, index, remove, add, true)
    // }
    /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {void}
   */ consume(events) {
        this.map.sort((a, b)=>a[0] - b[0]);
        /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */ if (this.map.length === 0) return;
        // To do: if links are added in events, like they are in `markdown-rs`,
        // this is needed.
        // // Calculate jumps: where items in the current list move to.
        // /** @type {Array<Jump>} */
        // const jumps = []
        // let index = 0
        // let addAcc = 0
        // let removeAcc = 0
        // while (index < this.map.length) {
        //   const [at, remove, add] = this.map[index]
        //   removeAcc += remove
        //   addAcc += add.length
        //   jumps.push([at, removeAcc, addAcc])
        //   index += 1
        // }
        //
        // . shiftLinks(events, jumps)
        let index = this.map.length;
        /** @type {Array<Array<Event>>} */ const vecs = [];
        while(index > 0){
            index -= 1;
            vecs.push(events.slice(this.map[index][0] + this.map[index][1]));
            // eslint-disable-next-line unicorn/no-array-push-push
            vecs.push(this.map[index][2]);
            // Truncate rest.
            events.length = this.map[index][0];
        }
        vecs.push([
            ...events
        ]);
        events.length = 0;
        let slice = vecs.pop();
        while(slice){
            events.push(...slice);
            slice = vecs.pop();
        }
        // Truncate everything.
        this.map.length = 0;
    }
    /**
   * Create a new edit map.
   */ constructor(){
        /**
     * Record of changes.
     *
     * @type {Array<Change>}
     */ this.map = [];
    }
}
/**
 * Create an edit.
 *
 * @param {EditMap} editMap
 * @param {number} at
 * @param {number} remove
 * @param {Array<Event>} add
 * @returns {void}
 */ function $fd021270952e58e1$var$addImpl(editMap, at, remove, add) {
    let index = 0;
    /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */ if (remove === 0 && add.length === 0) return;
    while(index < editMap.map.length){
        if (editMap.map[index][0] === at) {
            editMap.map[index][1] += remove;
            // To do: before not used.
            // if (before) {
            //   add.push(...editMap.map[index][2])
            //   editMap.map[index][2] = add
            // } else {
            editMap.map[index][2].push(...add);
            // }
            return;
        }
        index += 1;
    }
    editMap.map.push([
        at,
        remove,
        add
    ]);
} // /**
 //  * Shift `previous` and `next` links according to `jumps`.
 //  *
 //  * This fixes links in case there are events removed or added between them.
 //  *
 //  * @param {Array<Event>} events
 //  * @param {Array<Jump>} jumps
 //  */
 // function shiftLinks(events, jumps) {
 //   let jumpIndex = 0
 //   let index = 0
 //   let add = 0
 //   let rm = 0
 //   while (index < events.length) {
 //     const rmCurr = rm
 //     while (jumpIndex < jumps.length && jumps[jumpIndex][0] <= index) {
 //       add = jumps[jumpIndex][2]
 //       rm = jumps[jumpIndex][1]
 //       jumpIndex += 1
 //     }
 //     // Ignore items that will be removed.
 //     if (rm > rmCurr) {
 //       index += rm - rmCurr
 //     } else {
 //       console.log('to do: links?', add, rmCurr)
 //       // ?
 //       // if let Some(link) = &events[index].link {
 //       //     if let Some(next) = link.next {
 //       //         events[next].link.as_mut().unwrap().previous = Some(index + add - rm);
 //       //         while jumpIndex < jumps.len() && jumps[jumpIndex].0 <= next {
 //       //             add = jumps[jumpIndex].2;
 //       //             rm = jumps[jumpIndex].1;
 //       //             jumpIndex += 1;
 //       //         }
 //       //         events[index].link.as_mut().unwrap().next = Some(next + add - rm);
 //       //         index = next;
 //       //         continue;
 //       //     }
 //       // }
 //       index += 1
 //     }
 //   }
 // }


/**
 * @typedef {import('micromark-util-types').Event} Event
 */ /**
 * @typedef {'left' | 'center' | 'right' | 'none'} Align
 */ /**
 * Figure out the alignment of a GFM table.
 *
 * @param {Array<Event>} events
 * @param {number} index
 * @returns {Array<Align>}
 */ function $e56613dad0c380e0$export$bbf4fe2c547a4878(events, index) {
    let inDelimiterRow = false;
    /** @type {Array<Align>} */ const align = [];
    while(index < events.length){
        const event = events[index];
        if (inDelimiterRow) {
            if (event[0] === "enter") // Start of alignment value: set a new column.
            // To do: `markdown-rs` uses `tableDelimiterCellValue`.
            {
                if (event[1].type === "tableContent") align.push(events[index + 1][1].type === "tableDelimiterMarker" ? "left" : "none");
            } else if (event[1].type === "tableContent") {
                if (events[index - 1][1].type === "tableDelimiterMarker") {
                    const alignIndex = align.length - 1;
                    align[alignIndex] = align[alignIndex] === "left" ? "center" : "right";
                }
            } else if (event[1].type === "tableDelimiterRow") break;
        } else if (event[0] === "enter" && event[1].type === "tableDelimiterRow") inDelimiterRow = true;
        index += 1;
    }
    return align;
}


const $feb7e1ae20b78262$export$e36cebda627bf2dd = {
    flow: {
        null: {
            tokenize: $feb7e1ae20b78262$var$tokenizeTable,
            resolveAll: $feb7e1ae20b78262$var$resolveTable
        }
    }
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $feb7e1ae20b78262$var$tokenizeTable(effects, ok, nok) {
    const self = this;
    let size = 0;
    let sizeB = 0;
    /** @type {boolean | undefined} */ let seen;
    return start;
    /**
   * Start of a GFM table.
   *
   * If there is a valid table row or table head before, then we try to parse
   * another row.
   * Otherwise, we try to parse a head.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   * > | | b |
   *     ^
   * ```
   * @type {State}
   */ function start(code) {
        let index = self.events.length - 1;
        while(index > -1){
            const type = self.events[index][1].type;
            if (type === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
            type === "linePrefix") index--;
            else break;
        }
        const tail = index > -1 ? self.events[index][1].type : null;
        const next = tail === "tableHead" || tail === "tableRow" ? bodyRowStart : headRowBefore;
        // Don’t allow lazy body rows.
        if (next === bodyRowStart && self.parser.lazy[self.now().line]) return nok(code);
        return next(code);
    }
    /**
   * Before table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowBefore(code) {
        effects.enter("tableHead");
        effects.enter("tableRow");
        return headRowStart(code);
    }
    /**
   * Before table head row, after whitespace.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowStart(code) {
        if (code === 124) return headRowBreak(code);
        // To do: micromark-js should let us parse our own whitespace in extensions,
        // like `markdown-rs`:
        //
        // ```js
        // // 4+ spaces.
        // if (markdownSpace(code)) {
        //   return nok(code)
        // }
        // ```
        seen = true;
        // Count the first character, that isn’t a pipe, double.
        sizeB += 1;
        return headRowBreak(code);
    }
    /**
   * At break in table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *       ^
   *         ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowBreak(code) {
        if (code === null) // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
        return nok(code);
        if ((0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) {
            // If anything other than one pipe (ignoring whitespace) was used, it’s fine.
            if (sizeB > 1) {
                sizeB = 0;
                // To do: check if this works.
                // Feel free to interrupt:
                self.interrupt = true;
                effects.exit("tableRow");
                effects.enter("lineEnding");
                effects.consume(code);
                effects.exit("lineEnding");
                return headDelimiterStart;
            }
            // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
            return nok(code);
        }
        if ((0, $fc9672c731708cc1$export$2c6cf65c1127992a)(code)) // To do: check if this is fine.
        // effects.attempt(State::Next(StateName::GfmTableHeadRowBreak), State::Nok)
        // State::Retry(space_or_tab(tokenizer))
        return (0, $048e24d1164dbff0$export$ae105c1eb063a0a2)(effects, headRowBreak, "whitespace")(code);
        sizeB += 1;
        if (seen) {
            seen = false;
            // Header cell count.
            size += 1;
        }
        if (code === 124) {
            effects.enter("tableCellDivider");
            effects.consume(code);
            effects.exit("tableCellDivider");
            // Whether a delimiter was seen.
            seen = true;
            return headRowBreak;
        }
        // Anything else is cell data.
        effects.enter("data");
        return headRowData(code);
    }
    /**
   * In table head row data.
   *
   * ```markdown
   * > | | a |
   *       ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowData(code) {
        if (code === null || code === 124 || (0, $fc9672c731708cc1$export$a30284361b3814b7)(code)) {
            effects.exit("data");
            return headRowBreak(code);
        }
        effects.consume(code);
        return code === 92 ? headRowEscape : headRowData;
    }
    /**
   * In table head row escape.
   *
   * ```markdown
   * > | | a\-b |
   *         ^
   *   | | ---- |
   *   | | c    |
   * ```
   *
   * @type {State}
   */ function headRowEscape(code) {
        if (code === 92 || code === 124) {
            effects.consume(code);
            return headRowData;
        }
        return headRowData(code);
    }
    /**
   * Before delimiter row.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headDelimiterStart(code) {
        // Reset `interrupt`.
        self.interrupt = false;
        // Note: in `markdown-rs`, we need to handle piercing here too.
        if (self.parser.lazy[self.now().line]) return nok(code);
        effects.enter("tableDelimiterRow");
        // Track if we’ve seen a `:` or `|`.
        seen = false;
        if ((0, $fc9672c731708cc1$export$2c6cf65c1127992a)(code)) return (0, $048e24d1164dbff0$export$ae105c1eb063a0a2)(effects, headDelimiterBefore, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code);
        return headDelimiterBefore(code);
    }
    /**
   * Before delimiter row, after optional whitespace.
   *
   * Reused when a `|` is found later, to parse another cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headDelimiterBefore(code) {
        if (code === 45 || code === 58) return headDelimiterValueBefore(code);
        if (code === 124) {
            seen = true;
            // If we start with a pipe, we open a cell marker.
            effects.enter("tableCellDivider");
            effects.consume(code);
            effects.exit("tableCellDivider");
            return headDelimiterCellBefore;
        }
        // More whitespace / empty row not allowed at start.
        return headDelimiterNok(code);
    }
    /**
   * After `|`, before delimiter cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *      ^
   * ```
   *
   * @type {State}
   */ function headDelimiterCellBefore(code) {
        if ((0, $fc9672c731708cc1$export$2c6cf65c1127992a)(code)) return (0, $048e24d1164dbff0$export$ae105c1eb063a0a2)(effects, headDelimiterValueBefore, "whitespace")(code);
        return headDelimiterValueBefore(code);
    }
    /**
   * Before delimiter cell value.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterValueBefore(code) {
        // Align: left.
        if (code === 58) {
            sizeB += 1;
            seen = true;
            effects.enter("tableDelimiterMarker");
            effects.consume(code);
            effects.exit("tableDelimiterMarker");
            return headDelimiterLeftAlignmentAfter;
        }
        // Align: none.
        if (code === 45) {
            sizeB += 1;
            // To do: seems weird that this *isn’t* left aligned, but that state is used?
            return headDelimiterLeftAlignmentAfter(code);
        }
        if (code === null || (0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) return headDelimiterCellAfter(code);
        return headDelimiterNok(code);
    }
    /**
   * After delimiter cell left alignment marker.
   *
   * ```markdown
   *   | | a  |
   * > | | :- |
   *        ^
   * ```
   *
   * @type {State}
   */ function headDelimiterLeftAlignmentAfter(code) {
        if (code === 45) {
            effects.enter("tableDelimiterFiller");
            return headDelimiterFiller(code);
        }
        // Anything else is not ok after the left-align colon.
        return headDelimiterNok(code);
    }
    /**
   * In delimiter cell filler.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterFiller(code) {
        if (code === 45) {
            effects.consume(code);
            return headDelimiterFiller;
        }
        // Align is `center` if it was `left`, `right` otherwise.
        if (code === 58) {
            seen = true;
            effects.exit("tableDelimiterFiller");
            effects.enter("tableDelimiterMarker");
            effects.consume(code);
            effects.exit("tableDelimiterMarker");
            return headDelimiterRightAlignmentAfter;
        }
        effects.exit("tableDelimiterFiller");
        return headDelimiterRightAlignmentAfter(code);
    }
    /**
   * After delimiter cell right alignment marker.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *         ^
   * ```
   *
   * @type {State}
   */ function headDelimiterRightAlignmentAfter(code) {
        if ((0, $fc9672c731708cc1$export$2c6cf65c1127992a)(code)) return (0, $048e24d1164dbff0$export$ae105c1eb063a0a2)(effects, headDelimiterCellAfter, "whitespace")(code);
        return headDelimiterCellAfter(code);
    }
    /**
   * After delimiter cell.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *          ^
   * ```
   *
   * @type {State}
   */ function headDelimiterCellAfter(code) {
        if (code === 124) return headDelimiterBefore(code);
        if (code === null || (0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) {
            // Exit when:
            // * there was no `:` or `|` at all (it’s a thematic break or setext
            //   underline instead)
            // * the header cell count is not the delimiter cell count
            if (!seen || size !== sizeB) return headDelimiterNok(code);
            // Note: in markdown-rs`, a reset is needed here.
            effects.exit("tableDelimiterRow");
            effects.exit("tableHead");
            // To do: in `markdown-rs`, resolvers need to be registered manually.
            // effects.register_resolver(ResolveName::GfmTable)
            return ok(code);
        }
        return headDelimiterNok(code);
    }
    /**
   * In delimiter row, at a disallowed byte.
   *
   * ```markdown
   *   | | a |
   * > | | x |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterNok(code) {
        // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
        return nok(code);
    }
    /**
   * Before table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   * ```
   *
   * @type {State}
   */ function bodyRowStart(code) {
        // Note: in `markdown-rs` we need to manually take care of a prefix,
        // but in `micromark-js` that is done for us, so if we’re here, we’re
        // never at whitespace.
        effects.enter("tableRow");
        return bodyRowBreak(code);
    }
    /**
   * At break in table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   *       ^
   *         ^
   * ```
   *
   * @type {State}
   */ function bodyRowBreak(code) {
        if (code === 124) {
            effects.enter("tableCellDivider");
            effects.consume(code);
            effects.exit("tableCellDivider");
            return bodyRowBreak;
        }
        if (code === null || (0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) {
            effects.exit("tableRow");
            return ok(code);
        }
        if ((0, $fc9672c731708cc1$export$2c6cf65c1127992a)(code)) return (0, $048e24d1164dbff0$export$ae105c1eb063a0a2)(effects, bodyRowBreak, "whitespace")(code);
        // Anything else is cell content.
        effects.enter("data");
        return bodyRowData(code);
    }
    /**
   * In table body row data.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *       ^
   * ```
   *
   * @type {State}
   */ function bodyRowData(code) {
        if (code === null || code === 124 || (0, $fc9672c731708cc1$export$a30284361b3814b7)(code)) {
            effects.exit("data");
            return bodyRowBreak(code);
        }
        effects.consume(code);
        return code === 92 ? bodyRowEscape : bodyRowData;
    }
    /**
   * In table body row escape.
   *
   * ```markdown
   *   | | a    |
   *   | | ---- |
   * > | | b\-c |
   *         ^
   * ```
   *
   * @type {State}
   */ function bodyRowEscape(code) {
        if (code === 92 || code === 124) {
            effects.consume(code);
            return bodyRowData;
        }
        return bodyRowData(code);
    }
}
/** @type {Resolver} */ // eslint-disable-next-line complexity
function $feb7e1ae20b78262$var$resolveTable(events, context) {
    let index = -1;
    let inFirstCellAwaitingPipe = true;
    /** @type {RowKind} */ let rowKind = 0;
    /** @type {Range} */ let lastCell = [
        0,
        0,
        0,
        0
    ];
    /** @type {Range} */ let cell = [
        0,
        0,
        0,
        0
    ];
    let afterHeadAwaitingFirstBodyRow = false;
    let lastTableEnd = 0;
    /** @type {Token | undefined} */ let currentTable;
    /** @type {Token | undefined} */ let currentBody;
    /** @type {Token | undefined} */ let currentCell;
    const map = new (0, $fd021270952e58e1$export$9348908dd4518b4a)();
    while(++index < events.length){
        const event = events[index];
        const token = event[1];
        if (event[0] === "enter") {
            // Start of head.
            if (token.type === "tableHead") {
                afterHeadAwaitingFirstBodyRow = false;
                // Inject previous (body end and) table end.
                if (lastTableEnd !== 0) {
                    $feb7e1ae20b78262$var$flushTableEnd(map, context, lastTableEnd, currentTable, currentBody);
                    currentBody = undefined;
                    lastTableEnd = 0;
                }
                // Inject table start.
                currentTable = {
                    type: "table",
                    start: Object.assign({}, token.start),
                    // Note: correct end is set later.
                    end: Object.assign({}, token.end)
                };
                map.add(index, 0, [
                    [
                        "enter",
                        currentTable,
                        context
                    ]
                ]);
            } else if (token.type === "tableRow" || token.type === "tableDelimiterRow") {
                inFirstCellAwaitingPipe = true;
                currentCell = undefined;
                lastCell = [
                    0,
                    0,
                    0,
                    0
                ];
                cell = [
                    0,
                    index + 1,
                    0,
                    0
                ];
                // Inject table body start.
                if (afterHeadAwaitingFirstBodyRow) {
                    afterHeadAwaitingFirstBodyRow = false;
                    currentBody = {
                        type: "tableBody",
                        start: Object.assign({}, token.start),
                        // Note: correct end is set later.
                        end: Object.assign({}, token.end)
                    };
                    map.add(index, 0, [
                        [
                            "enter",
                            currentBody,
                            context
                        ]
                    ]);
                }
                rowKind = token.type === "tableDelimiterRow" ? 2 : currentBody ? 3 : 1;
            } else if (rowKind && (token.type === "data" || token.type === "tableDelimiterMarker" || token.type === "tableDelimiterFiller")) {
                inFirstCellAwaitingPipe = false;
                // First value in cell.
                if (cell[2] === 0) {
                    if (lastCell[1] !== 0) {
                        cell[0] = cell[1];
                        currentCell = $feb7e1ae20b78262$var$flushCell(map, context, lastCell, rowKind, undefined, currentCell);
                        lastCell = [
                            0,
                            0,
                            0,
                            0
                        ];
                    }
                    cell[2] = index;
                }
            } else if (token.type === "tableCellDivider") {
                if (inFirstCellAwaitingPipe) inFirstCellAwaitingPipe = false;
                else {
                    if (lastCell[1] !== 0) {
                        cell[0] = cell[1];
                        currentCell = $feb7e1ae20b78262$var$flushCell(map, context, lastCell, rowKind, undefined, currentCell);
                    }
                    lastCell = cell;
                    cell = [
                        lastCell[1],
                        index,
                        0,
                        0
                    ];
                }
            }
        } else if (token.type === "tableHead") {
            afterHeadAwaitingFirstBodyRow = true;
            lastTableEnd = index;
        } else if (token.type === "tableRow" || token.type === "tableDelimiterRow") {
            lastTableEnd = index;
            if (lastCell[1] !== 0) {
                cell[0] = cell[1];
                currentCell = $feb7e1ae20b78262$var$flushCell(map, context, lastCell, rowKind, index, currentCell);
            } else if (cell[1] !== 0) currentCell = $feb7e1ae20b78262$var$flushCell(map, context, cell, rowKind, index, currentCell);
            rowKind = 0;
        } else if (rowKind && (token.type === "data" || token.type === "tableDelimiterMarker" || token.type === "tableDelimiterFiller")) cell[3] = index;
    }
    if (lastTableEnd !== 0) $feb7e1ae20b78262$var$flushTableEnd(map, context, lastTableEnd, currentTable, currentBody);
    map.consume(context.events);
    // To do: move this into `html`, when events are exposed there.
    // That’s what `markdown-rs` does.
    // That needs updates to `mdast-util-gfm-table`.
    index = -1;
    while(++index < context.events.length){
        const event = context.events[index];
        if (event[0] === "enter" && event[1].type === "table") event[1]._align = (0, $e56613dad0c380e0$export$bbf4fe2c547a4878)(context.events, index);
    }
    return events;
}
/// Generate a cell.
/**
 *
 * @param {EditMap} map
 * @param {TokenizeContext} context
 * @param {Range} range
 * @param {RowKind} rowKind
 * @param {number | undefined} rowEnd
 * @param {Token | undefined} previousCell
 * @returns {Token | undefined}
 */ // eslint-disable-next-line max-params
function $feb7e1ae20b78262$var$flushCell(map, context, range, rowKind, rowEnd, previousCell) {
    // `markdown-rs` uses:
    // rowKind === 2 ? 'tableDelimiterCell' : 'tableCell'
    const groupName = rowKind === 1 ? "tableHeader" : rowKind === 2 ? "tableDelimiter" : "tableData";
    // `markdown-rs` uses:
    // rowKind === 2 ? 'tableDelimiterCellValue' : 'tableCellText'
    const valueName = "tableContent";
    // Insert an exit for the previous cell, if there is one.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //          ^-- exit
    //           ^^^^-- this cell
    // ```
    if (range[0] !== 0) {
        previousCell.end = Object.assign({}, $feb7e1ae20b78262$var$getPoint(context.events, range[0]));
        map.add(range[0], 0, [
            [
                "exit",
                previousCell,
                context
            ]
        ]);
    }
    // Insert enter of this cell.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //           ^-- enter
    //           ^^^^-- this cell
    // ```
    const now = $feb7e1ae20b78262$var$getPoint(context.events, range[1]);
    previousCell = {
        type: groupName,
        start: Object.assign({}, now),
        // Note: correct end is set later.
        end: Object.assign({}, now)
    };
    map.add(range[1], 0, [
        [
            "enter",
            previousCell,
            context
        ]
    ]);
    // Insert text start at first data start and end at last data end, and
    // remove events between.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //            ^-- enter
    //             ^-- exit
    //           ^^^^-- this cell
    // ```
    if (range[2] !== 0) {
        const relatedStart = $feb7e1ae20b78262$var$getPoint(context.events, range[2]);
        const relatedEnd = $feb7e1ae20b78262$var$getPoint(context.events, range[3]);
        /** @type {Token} */ const valueToken = {
            type: valueName,
            start: Object.assign({}, relatedStart),
            end: Object.assign({}, relatedEnd)
        };
        map.add(range[2], 0, [
            [
                "enter",
                valueToken,
                context
            ]
        ]);
        if (rowKind !== 2) {
            // Fix positional info on remaining events
            const start = context.events[range[2]];
            const end = context.events[range[3]];
            start[1].end = Object.assign({}, end[1].end);
            start[1].type = "chunkText";
            start[1].contentType = "text";
            // Remove if needed.
            if (range[3] > range[2] + 1) {
                const a = range[2] + 1;
                const b = range[3] - range[2] - 1;
                map.add(a, b, []);
            }
        }
        map.add(range[3] + 1, 0, [
            [
                "exit",
                valueToken,
                context
            ]
        ]);
    }
    // Insert an exit for the last cell, if at the row end.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //                    ^-- exit
    //               ^^^^^^-- this cell (the last one contains two “between” parts)
    // ```
    if (rowEnd !== undefined) {
        previousCell.end = Object.assign({}, $feb7e1ae20b78262$var$getPoint(context.events, rowEnd));
        map.add(rowEnd, 0, [
            [
                "exit",
                previousCell,
                context
            ]
        ]);
        previousCell = undefined;
    }
    return previousCell;
}
/**
 * Generate table end (and table body end).
 *
 * @param {EditMap} map
 * @param {TokenizeContext} context
 * @param {number} index
 * @param {Token} table
 * @param {Token | undefined} tableBody
 */ // eslint-disable-next-line max-params
function $feb7e1ae20b78262$var$flushTableEnd(map, context, index, table, tableBody) {
    /** @type {Array<Event>} */ const exits = [];
    const related = $feb7e1ae20b78262$var$getPoint(context.events, index);
    if (tableBody) {
        tableBody.end = Object.assign({}, related);
        exits.push([
            "exit",
            tableBody,
            context
        ]);
    }
    table.end = Object.assign({}, related);
    exits.push([
        "exit",
        table,
        context
    ]);
    map.add(index + 1, 0, exits);
}
/**
 * @param {Array<Event>} events
 * @param {number} index
 * @returns {readonly Point}
 */ function $feb7e1ae20b78262$var$getPoint(events, index) {
    const event = events[index];
    const side = event[0] === "enter" ? "start" : "end";
    return event[1][side];
}

/**
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ /**
 * @typedef {import('./infer.js').Align} Align
 */ const $6c2b886113873a59$var$alignment = {
    none: "",
    left: ' align="left"',
    right: ' align="right"',
    center: ' align="center"'
};
const $6c2b886113873a59$export$c64626c032567c7f = {
    enter: {
        table (token) {
            const tableAlign = token._align;
            this.lineEndingIfNeeded();
            this.tag("<table>");
            this.setData("tableAlign", tableAlign);
        },
        tableBody () {
            this.tag("<tbody>");
        },
        tableData () {
            const tableAlign = this.getData("tableAlign");
            const tableColumn = this.getData("tableColumn");
            const align = $6c2b886113873a59$var$alignment[tableAlign[tableColumn]];
            if (align === undefined) // Capture results to ignore them.
            this.buffer();
            else {
                this.lineEndingIfNeeded();
                this.tag("<td" + align + ">");
            }
        },
        tableHead () {
            this.lineEndingIfNeeded();
            this.tag("<thead>");
        },
        tableHeader () {
            const tableAlign = this.getData("tableAlign");
            const tableColumn = this.getData("tableColumn");
            const align = $6c2b886113873a59$var$alignment[tableAlign[tableColumn]];
            this.lineEndingIfNeeded();
            this.tag("<th" + align + ">");
        },
        tableRow () {
            this.setData("tableColumn", 0);
            this.lineEndingIfNeeded();
            this.tag("<tr>");
        }
    },
    exit: {
        // Overwrite the default code text data handler to unescape escaped pipes when
        // they are in tables.
        codeTextData (token) {
            let value = this.sliceSerialize(token);
            if (this.getData("tableAlign")) value = value.replace(/\\([\\|])/g, $6c2b886113873a59$var$replace);
            this.raw(this.encode(value));
        },
        table () {
            this.setData("tableAlign");
            // Note: we don’t set `slurpAllLineEndings` anymore, in delimiter rows,
            // but we do need to reset it to match a funky newline GH generates for
            // list items combined with tables.
            this.setData("slurpAllLineEndings");
            this.lineEndingIfNeeded();
            this.tag("</table>");
        },
        tableBody () {
            this.lineEndingIfNeeded();
            this.tag("</tbody>");
        },
        tableData () {
            const tableAlign = this.getData("tableAlign");
            const tableColumn = this.getData("tableColumn");
            if (tableColumn in tableAlign) {
                this.tag("</td>");
                this.setData("tableColumn", tableColumn + 1);
            } else // Stop capturing.
            this.resume();
        },
        tableHead () {
            this.lineEndingIfNeeded();
            this.tag("</thead>");
        },
        tableHeader () {
            const tableColumn = this.getData("tableColumn");
            this.tag("</th>");
            this.setData("tableColumn", tableColumn + 1);
        },
        tableRow () {
            const tableAlign = this.getData("tableAlign");
            let tableColumn = this.getData("tableColumn");
            while(tableColumn < tableAlign.length){
                this.lineEndingIfNeeded();
                this.tag("<td" + $6c2b886113873a59$var$alignment[tableAlign[tableColumn]] + "></td>");
                tableColumn++;
            }
            this.setData("tableColumn", tableColumn);
            this.lineEndingIfNeeded();
            this.tag("</tr>");
        }
    }
};
/**
 * @param {string} $0
 * @param {string} $1
 * @returns {string}
 */ function $6c2b886113873a59$var$replace($0, $1) {
    // Pipes work, backslashes don’t (but can’t escape pipes).
    return $1 === "|" ? $1 : $0;
}


/**
 * @typedef {import('micromark-util-types').CompileContext} CompileContext
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').Token} Token
 */ // An opening or closing tag start, followed by a case-insensitive specific tag name,
// followed by HTML whitespace, a greater than, or a slash.
const $5445aab38530b507$var$reFlow = /<(\/?)(iframe|noembed|noframes|plaintext|script|style|title|textarea|xmp)(?=[\t\n\f\r />])/gi;
// As HTML (text) parses tags separately (and very strictly), we don’t need to be
// global.
const $5445aab38530b507$var$reText = new RegExp("^" + $5445aab38530b507$var$reFlow.source, "i");
const $5445aab38530b507$export$c9bf87ea36d00682 = {
    exit: {
        htmlFlowData (token) {
            $5445aab38530b507$var$exitHtmlData.call(this, token, $5445aab38530b507$var$reFlow);
        },
        htmlTextData (token) {
            $5445aab38530b507$var$exitHtmlData.call(this, token, $5445aab38530b507$var$reText);
        }
    }
};
/**
 * @this {CompileContext}
 * @param {Token} token
 * @param {RegExp} filter
 */ function $5445aab38530b507$var$exitHtmlData(token, filter) {
    let value = this.sliceSerialize(token);
    if (this.options.allowDangerousHtml) value = value.replace(filter, "&lt;$1$2");
    this.raw(this.encode(value));
}


/**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $298ac0d10f30f18c$var$tasklistCheck = {
    tokenize: $298ac0d10f30f18c$var$tokenizeTasklistCheck
};
const $298ac0d10f30f18c$export$2912e8b2802475ff = {
    text: {
        [91]: $298ac0d10f30f18c$var$tasklistCheck
    }
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $298ac0d10f30f18c$var$tokenizeTasklistCheck(effects, ok, nok) {
    const self = this;
    return open;
    /**
   * At start of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (// Exit if there’s stuff before.
        self.previous !== null || // Exit if not in the first content that is the first child of a list
        // item.
        !self._gfmTasklistFirstContentOfListItem) return nok(code);
        effects.enter("taskListCheck");
        effects.enter("taskListCheckMarker");
        effects.consume(code);
        effects.exit("taskListCheckMarker");
        return inside;
    }
    /**
   * In task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *        ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // Currently we match how GH works in files.
        // To match how GH works in comments, use `markdownSpace` (`[\t ]`) instead
        // of `markdownLineEndingOrSpace` (`[\t\n\r ]`).
        if ((0, $fc9672c731708cc1$export$a30284361b3814b7)(code)) {
            effects.enter("taskListCheckValueUnchecked");
            effects.consume(code);
            effects.exit("taskListCheckValueUnchecked");
            return close;
        }
        if (code === 88 || code === 120) {
            effects.enter("taskListCheckValueChecked");
            effects.consume(code);
            effects.exit("taskListCheckValueChecked");
            return close;
        }
        return nok(code);
    }
    /**
   * At close of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *         ^
   * ```
   *
   * @type {State}
   */ function close(code) {
        if (code === 93) {
            effects.enter("taskListCheckMarker");
            effects.consume(code);
            effects.exit("taskListCheckMarker");
            effects.exit("taskListCheck");
            return after;
        }
        return nok(code);
    }
    /**
   * @type {State}
   */ function after(code) {
        // EOL in paragraph means there must be something else after it.
        if ((0, $fc9672c731708cc1$export$34a1dff1c0936953)(code)) return ok(code);
        // Space or tab?
        // Check what comes after.
        if ((0, $fc9672c731708cc1$export$2c6cf65c1127992a)(code)) return effects.check({
            tokenize: $298ac0d10f30f18c$var$spaceThenNonSpace
        }, ok, nok)(code);
        // EOF, or non-whitespace, both wrong.
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $298ac0d10f30f18c$var$spaceThenNonSpace(effects, ok, nok) {
    return (0, $048e24d1164dbff0$export$ae105c1eb063a0a2)(effects, after, "whitespace");
    /**
   * After whitespace, after task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *           ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // EOF means there was nothing, so bad.
        // EOL means there’s content after it, so good.
        // Impossible to have more spaces.
        // Anything else is good.
        return code === null ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ // To do: next major: expose function to make extension.
/**
 * Extension for `micromark` that can be passed in `htmlExtensions` to
 * support GFM task list items when serializing to HTML.
 *
 * @type {HtmlExtension}
 */ const $bc9c98a563aba884$export$4b6a13e2af1b08ed = {
    enter: {
        taskListCheck () {
            this.tag('<input type="checkbox" disabled="" ');
        }
    },
    exit: {
        taskListCheck () {
            this.tag("/>");
        },
        taskListCheckValueChecked () {
            this.tag('checked="" ');
        }
    }
};


function $a2ecb74ac5dcb4ac$export$59ffe8c4d7a4aab2(options) {
    return (0, $36dbe5ae75482411$export$86a865d89ef3c690)([
        (0, $abebd4901e9bd1ed$export$608123d9b549151),
        (0, $54355b33de88f7ed$export$c82499b6656305df)(),
        (0, $ebfdc2aaa2f0f66c$export$8bbec8ea1400a00e)(options),
        (0, $feb7e1ae20b78262$export$e36cebda627bf2dd),
        (0, $298ac0d10f30f18c$export$2912e8b2802475ff)
    ]);
}
function $a2ecb74ac5dcb4ac$export$6983b82e6105d62a(options) {
    return (0, $36dbe5ae75482411$export$eaf8c406dfb0a620)([
        (0, $cc989f8f74aefa60$export$999603f1f1c3d2f9),
        (0, $edfad8c81dffa5d6$export$a731a1f6cf81900c)(options),
        (0, $1440838da5572fdb$export$58acedca46108820),
        (0, $6c2b886113873a59$export$c64626c032567c7f),
        (0, $5445aab38530b507$export$c9bf87ea36d00682),
        (0, $bc9c98a563aba884$export$4b6a13e2af1b08ed)
    ]);
}


/**
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 */ /**
 * @typedef {import('mdast-util-gfm-table').Options} Options
 *   Configuration.
 */ /**
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-from-markdown').Transform} FromMarkdownTransform
 *
 * @typedef {import('mdast-util-to-markdown').ConstructName} ConstructName
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 *
 * @typedef {import('mdast-util-find-and-replace').ReplaceFunction} ReplaceFunction
 * @typedef {import('mdast-util-find-and-replace').RegExpMatchObject} RegExpMatchObject
 */ /**
 * Count how often a character (or substring) is used in a string.
 *
 * @param {string} value
 *   Value to search in.
 * @param {string} character
 *   Character (or substring) to look for.
 * @return {number}
 *   Number of times `character` occurred in `value`.
 */ function $4428521df5b22323$export$fa42eaa97a352e23(value, character) {
    const source = String(value);
    if (typeof character !== "string") throw new TypeError("Expected character");
    let count = 0;
    let index = source.indexOf(character);
    while(index !== -1){
        count++;
        index = source.indexOf(character, index + character.length);
    }
    return count;
}


/**
 * @typedef {import('mdast').Parent} MdastParent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 * @typedef {import('mdast').Text} Text
 * @typedef {import('unist-util-visit-parents').Test} Test
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 */ /**
 * @typedef {Content | Root} Node
 * @typedef {Extract<Node, MdastParent>} Parent
 * @typedef {Exclude<Parent, Root>} ContentParent
 *
 * @typedef RegExpMatchObject
 *   Info on the match.
 * @property {number} index
 *   The index of the search at which the result was found.
 * @property {string} input
 *   A copy of the search string in the text node.
 * @property {[Root, ...Array<ContentParent>, Text]} stack
 *   All ancestors of the text node, where the last node is the text itself.
 *
 * @callback ReplaceFunction
 *   Callback called when a search matches.
 * @param {...any} parameters
 *   The parameters are the result of corresponding search expression:
 *
 *   * `value` (`string`) — whole match
 *   * `...capture` (`Array<string>`) — matches from regex capture groups
 *   * `match` (`RegExpMatchObject`) — info on the match
 * @returns {Array<PhrasingContent> | PhrasingContent | string | false | undefined | null}
 *   Thing to replace with.
 *
 *   * when `null`, `undefined`, `''`, remove the match
 *   * …or when `false`, do not replace at all
 *   * …or when `string`, replace with a text node of that value
 *   * …or when `Node` or `Array<Node>`, replace with those nodes
 *
 * @typedef {string | RegExp} Find
 *   Pattern to find.
 *
 *   Strings are escaped and then turned into global expressions.
 *
 * @typedef {Array<FindAndReplaceTuple>} FindAndReplaceList
 *   Several find and replaces, in array form.
 * @typedef {Record<string, Replace>} FindAndReplaceSchema
 *   Several find and replaces, in object form.
 * @typedef {[Find, Replace]} FindAndReplaceTuple
 *   Find and replace in tuple form.
 * @typedef {string | ReplaceFunction} Replace
 *   Thing to replace with.
 * @typedef {[RegExp, ReplaceFunction]} Pair
 *   Normalized find and replace.
 * @typedef {Array<Pair>} Pairs
 *   All find and replaced.
 *
 * @typedef Options
 *   Configuration.
 * @property {Test | null | undefined} [ignore]
 *   Test for which nodes to ignore.
 */ function $f039bd226781f9ea$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new TypeError("Expected a string");
    // Escape characters with special meaning either inside or outside character sets.
    // Use a simple backslash escape when it’s always valid, and a `\xnn` escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
    return string.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}




const $5319e31119ad9453$var$own = {}.hasOwnProperty;
const $5319e31119ad9453$export$fb306ebf003fc574 = /**
   * @type {(
   *   (<Tree extends Node>(tree: Tree, find: Find, replace?: Replace | null | undefined, options?: Options | null | undefined) => Tree) &
   *   (<Tree extends Node>(tree: Tree, schema: FindAndReplaceSchema | FindAndReplaceList, options?: Options | null | undefined) => Tree)
   * )}
   **/ /**
     * @template {Node} Tree
     * @param {Tree} tree
     * @param {Find | FindAndReplaceSchema | FindAndReplaceList} find
     * @param {Replace | Options | null | undefined} [replace]
     * @param {Options | null | undefined} [options]
     * @returns {Tree}
     */ function(tree, find, replace, options) {
    /** @type {Options | null | undefined} */ let settings;
    /** @type {FindAndReplaceSchema|FindAndReplaceList} */ let schema;
    if (typeof find === "string" || find instanceof RegExp) {
        // @ts-expect-error don’t expect options twice.
        schema = [
            [
                find,
                replace
            ]
        ];
        settings = options;
    } else {
        schema = find;
        // @ts-expect-error don’t expect replace twice.
        settings = replace;
    }
    if (!settings) settings = {};
    const ignored = (0, $56aea44d55896096$export$9c68d69a4c5bbcf9)(settings.ignore || []);
    const pairs = $5319e31119ad9453$var$toPairs(schema);
    let pairIndex = -1;
    while(++pairIndex < pairs.length)(0, $63387b479ea86693$export$70008a21eb6de899)(tree, "text", visitor);
    // To do next major: don’t return the given tree.
    return tree;
    /** @type {import('unist-util-visit-parents/complex-types.js').BuildVisitor<Root, 'text'>} */ function visitor(node, parents) {
        let index = -1;
        /** @type {Parent | undefined} */ let grandparent;
        while(++index < parents.length){
            const parent = parents[index];
            if (ignored(parent, // @ts-expect-error: TS doesn’t understand but it’s perfect.
            grandparent ? grandparent.children.indexOf(parent) : undefined, grandparent)) return;
            grandparent = parent;
        }
        if (grandparent) return handler(node, parents);
    }
    /**
       * Handle a text node which is not in an ignored parent.
       *
       * @param {Text} node
       *   Text node.
       * @param {Array<Parent>} parents
       *   Parents.
       * @returns {VisitorResult}
       *   Result.
       */ function handler(node, parents) {
        const parent = parents[parents.length - 1];
        const find = pairs[pairIndex][0];
        const replace = pairs[pairIndex][1];
        let start = 0;
        // @ts-expect-error: TS is wrong, some of these children can be text.
        const index = parent.children.indexOf(node);
        let change = false;
        /** @type {Array<PhrasingContent>} */ let nodes = [];
        find.lastIndex = 0;
        let match = find.exec(node.value);
        while(match){
            const position = match.index;
            /** @type {RegExpMatchObject} */ const matchObject = {
                index: match.index,
                input: match.input,
                // @ts-expect-error: stack is fine.
                stack: [
                    ...parents,
                    node
                ]
            };
            let value = replace(...match, matchObject);
            if (typeof value === "string") value = value.length > 0 ? {
                type: "text",
                value: value
            } : undefined;
            // It wasn’t a match after all.
            if (value !== false) {
                if (start !== position) nodes.push({
                    type: "text",
                    value: node.value.slice(start, position)
                });
                if (Array.isArray(value)) nodes.push(...value);
                else if (value) nodes.push(value);
                start = position + match[0].length;
                change = true;
            }
            if (!find.global) break;
            match = find.exec(node.value);
        }
        if (change) {
            if (start < node.value.length) nodes.push({
                type: "text",
                value: node.value.slice(start)
            });
            parent.children.splice(index, 1, ...nodes);
        } else nodes = [
            node
        ];
        return index + nodes.length;
    }
};
/**
 * Turn a schema into pairs.
 *
 * @param {FindAndReplaceSchema | FindAndReplaceList} schema
 *   Schema.
 * @returns {Pairs}
 *   Clean pairs.
 */ function $5319e31119ad9453$var$toPairs(schema) {
    /** @type {Pairs} */ const result = [];
    if (typeof schema !== "object") throw new TypeError("Expected array or object as schema");
    if (Array.isArray(schema)) {
        let index = -1;
        while(++index < schema.length)result.push([
            $5319e31119ad9453$var$toExpression(schema[index][0]),
            $5319e31119ad9453$var$toFunction(schema[index][1])
        ]);
    } else {
        /** @type {string} */ let key;
        for(key in schema)if ($5319e31119ad9453$var$own.call(schema, key)) result.push([
            $5319e31119ad9453$var$toExpression(key),
            $5319e31119ad9453$var$toFunction(schema[key])
        ]);
    }
    return result;
}
/**
 * Turn a find into an expression.
 *
 * @param {Find} find
 *   Find.
 * @returns {RegExp}
 *   Expression.
 */ function $5319e31119ad9453$var$toExpression(find) {
    return typeof find === "string" ? new RegExp((0, $f039bd226781f9ea$export$2e2bcd8739ae039)(find), "g") : find;
}
/**
 * Turn a replace into a function.
 *
 * @param {Replace} replace
 *   Replace.
 * @returns {ReplaceFunction}
 *   Function.
 */ function $5319e31119ad9453$var$toFunction(replace) {
    return typeof replace === "function" ? replace : ()=>replace;
}



/** @type {ConstructName} */ const $c0da0703951bf573$var$inConstruct = "phrasing";
/** @type {Array<ConstructName>} */ const $c0da0703951bf573$var$notInConstruct = [
    "autolink",
    "link",
    "image",
    "label"
];
const $c0da0703951bf573$export$b6afdfff2163546f = {
    transforms: [
        $c0da0703951bf573$var$transformGfmAutolinkLiterals
    ],
    enter: {
        literalAutolink: $c0da0703951bf573$var$enterLiteralAutolink,
        literalAutolinkEmail: $c0da0703951bf573$var$enterLiteralAutolinkValue,
        literalAutolinkHttp: $c0da0703951bf573$var$enterLiteralAutolinkValue,
        literalAutolinkWww: $c0da0703951bf573$var$enterLiteralAutolinkValue
    },
    exit: {
        literalAutolink: $c0da0703951bf573$var$exitLiteralAutolink,
        literalAutolinkEmail: $c0da0703951bf573$var$exitLiteralAutolinkEmail,
        literalAutolinkHttp: $c0da0703951bf573$var$exitLiteralAutolinkHttp,
        literalAutolinkWww: $c0da0703951bf573$var$exitLiteralAutolinkWww
    }
};
const $c0da0703951bf573$export$d3ace9096b01c39d = {
    unsafe: [
        {
            character: "@",
            before: "[+\\-.\\w]",
            after: "[\\-.\\w]",
            inConstruct: $c0da0703951bf573$var$inConstruct,
            notInConstruct: $c0da0703951bf573$var$notInConstruct
        },
        {
            character: ".",
            before: "[Ww]",
            after: "[\\-.\\w]",
            inConstruct: $c0da0703951bf573$var$inConstruct,
            notInConstruct: $c0da0703951bf573$var$notInConstruct
        },
        {
            character: ":",
            before: "[ps]",
            after: "\\/",
            inConstruct: $c0da0703951bf573$var$inConstruct,
            notInConstruct: $c0da0703951bf573$var$notInConstruct
        }
    ]
};
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $c0da0703951bf573$var$enterLiteralAutolink(token) {
    this.enter({
        type: "link",
        title: null,
        url: "",
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $c0da0703951bf573$var$enterLiteralAutolinkValue(token) {
    this.config.enter.autolinkProtocol.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $c0da0703951bf573$var$exitLiteralAutolinkHttp(token) {
    this.config.exit.autolinkProtocol.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $c0da0703951bf573$var$exitLiteralAutolinkWww(token) {
    this.config.exit.data.call(this, token);
    const node = /** @type {Link} */ this.stack[this.stack.length - 1];
    node.url = "http://" + this.sliceSerialize(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $c0da0703951bf573$var$exitLiteralAutolinkEmail(token) {
    this.config.exit.autolinkEmail.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $c0da0703951bf573$var$exitLiteralAutolink(token) {
    this.exit(token);
}
/** @type {FromMarkdownTransform} */ function $c0da0703951bf573$var$transformGfmAutolinkLiterals(tree) {
    (0, $5319e31119ad9453$export$fb306ebf003fc574)(tree, [
        [
            /(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi,
            $c0da0703951bf573$var$findUrl
        ],
        [
            /([-.\w+]+)@([-\w]+(?:\.[-\w]+)+)/g,
            $c0da0703951bf573$var$findEmail
        ]
    ], {
        ignore: [
            "link",
            "linkReference"
        ]
    });
}
/**
 * @type {ReplaceFunction}
 * @param {string} _
 * @param {string} protocol
 * @param {string} domain
 * @param {string} path
 * @param {RegExpMatchObject} match
 * @returns {Link | Array<PhrasingContent> | false}
 */ // eslint-disable-next-line max-params
function $c0da0703951bf573$var$findUrl(_, protocol, domain, path, match) {
    let prefix = "";
    // Not an expected previous character.
    if (!$c0da0703951bf573$var$previous(match)) return false;
    // Treat `www` as part of the domain.
    if (/^w/i.test(protocol)) {
        domain = protocol + domain;
        protocol = "";
        prefix = "http://";
    }
    if (!$c0da0703951bf573$var$isCorrectDomain(domain)) return false;
    const parts = $c0da0703951bf573$var$splitUrl(domain + path);
    if (!parts[0]) return false;
    /** @type {Link} */ const result = {
        type: "link",
        title: null,
        url: prefix + protocol + parts[0],
        children: [
            {
                type: "text",
                value: protocol + parts[0]
            }
        ]
    };
    if (parts[1]) return [
        result,
        {
            type: "text",
            value: parts[1]
        }
    ];
    return result;
}
/**
 * @type {ReplaceFunction}
 * @param {string} _
 * @param {string} atext
 * @param {string} label
 * @param {RegExpMatchObject} match
 * @returns {Link | false}
 */ function $c0da0703951bf573$var$findEmail(_, atext, label, match) {
    if (// Not an expected previous character.
    !$c0da0703951bf573$var$previous(match, true) || // Label ends in not allowed character.
    /[-\d_]$/.test(label)) return false;
    return {
        type: "link",
        title: null,
        url: "mailto:" + atext + "@" + label,
        children: [
            {
                type: "text",
                value: atext + "@" + label
            }
        ]
    };
}
/**
 * @param {string} domain
 * @returns {boolean}
 */ function $c0da0703951bf573$var$isCorrectDomain(domain) {
    const parts = domain.split(".");
    if (parts.length < 2 || parts[parts.length - 1] && (/_/.test(parts[parts.length - 1]) || !/[a-zA-Z\d]/.test(parts[parts.length - 1])) || parts[parts.length - 2] && (/_/.test(parts[parts.length - 2]) || !/[a-zA-Z\d]/.test(parts[parts.length - 2]))) return false;
    return true;
}
/**
 * @param {string} url
 * @returns {[string, string | undefined]}
 */ function $c0da0703951bf573$var$splitUrl(url) {
    const trailExec = /[!"&'),.:;<>?\]}]+$/.exec(url);
    if (!trailExec) return [
        url,
        undefined
    ];
    url = url.slice(0, trailExec.index);
    let trail = trailExec[0];
    let closingParenIndex = trail.indexOf(")");
    const openingParens = (0, $4428521df5b22323$export$fa42eaa97a352e23)(url, "(");
    let closingParens = (0, $4428521df5b22323$export$fa42eaa97a352e23)(url, ")");
    while(closingParenIndex !== -1 && openingParens > closingParens){
        url += trail.slice(0, closingParenIndex + 1);
        trail = trail.slice(closingParenIndex + 1);
        closingParenIndex = trail.indexOf(")");
        closingParens++;
    }
    return [
        url,
        trail
    ];
}
/**
 * @param {RegExpMatchObject} match
 * @param {boolean | null | undefined} [email=false]
 * @returns {boolean}
 */ function $c0da0703951bf573$var$previous(match, email) {
    const code = match.input.charCodeAt(match.index - 1);
    return (match.index === 0 || (0, $fc9672c731708cc1$export$a0ff789c034ffdf4)(code) || (0, $fc9672c731708cc1$export$aa04114dd888a7a0)(code)) && (!email || code !== 47);
}


/**
 * @typedef {import('mdast').FootnoteReference} FootnoteReference
 * @typedef {import('mdast').FootnoteDefinition} FootnoteDefinition
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Map} Map
 */ 
/**
 * @typedef {import('../types.js').AssociationId} AssociationId
 */ 
function $2812f17c7b49a988$export$c4ca1a6065421754(node) {
    if (node.label || !node.identifier) return node.label || "";
    return (0, $e66b99c65d529aab$export$a0fb664af7d0cc44)(node.identifier);
}


/**
 * @typedef {import('../types.js').FlowContent} FlowContent
 * @typedef {import('../types.js').Node} Node
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').TrackFields} TrackFields
 */ /**
 * @param {Parent & {children: Array<FlowContent>}} parent
 *   Parent of flow nodes.
 * @param {State} state
 *   Info passed around about the current state.
 * @param {TrackFields} info
 *   Info on where we are in the document we are generating.
 * @returns {string}
 *   Serialized children, joined by (blank) lines.
 */ function $3c7981b220d3c271$export$134f7fdacfea8b16(parent, state, info) {
    const indexStack = state.indexStack;
    const children = parent.children || [];
    const tracker = state.createTracker(info);
    /** @type {Array<string>} */ const results = [];
    let index = -1;
    indexStack.push(-1);
    while(++index < children.length){
        const child = children[index];
        indexStack[indexStack.length - 1] = index;
        results.push(tracker.move(state.handle(child, parent, state, {
            before: "\n",
            after: "\n",
            ...tracker.current()
        })));
        if (child.type !== "list") state.bulletLastUsed = undefined;
        if (index < children.length - 1) results.push(tracker.move($3c7981b220d3c271$var$between(child, children[index + 1], parent, state)));
    }
    indexStack.pop();
    return results.join("");
}
/**
 * @param {Node} left
 * @param {Node} right
 * @param {Parent} parent
 * @param {State} state
 * @returns {string}
 */ function $3c7981b220d3c271$var$between(left, right, parent, state) {
    let index = state.join.length;
    while(index--){
        const result = state.join[index](left, right, parent, state);
        if (result === true || result === 1) break;
        if (typeof result === "number") return "\n".repeat(1 + result);
        if (result === false) return "\n\n<!---->\n\n";
    }
    return "\n\n";
}


/**
 * @typedef {import('../types.js').IndentLines} IndentLines
 */ const $fdb9cc8ce6464cf6$var$eol = /\r?\n|\r/g;
function $fdb9cc8ce6464cf6$export$7c3cf23d514b264a(value, map) {
    /** @type {Array<string>} */ const result = [];
    let start = 0;
    let line = 0;
    /** @type {RegExpExecArray | null} */ let match;
    while(match = $fdb9cc8ce6464cf6$var$eol.exec(value)){
        one(value.slice(start, match.index));
        result.push(match[0]);
        start = match.index + match[0].length;
        line++;
    }
    one(value.slice(start));
    return result.join("");
    /**
   * @param {string} value
   */ function one(value) {
        result.push(map(value, line, !value));
    }
}


/**
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').SafeConfig} SafeConfig
 */ /**
 * @typedef {import('../types.js').Unsafe} Unsafe
 */ /**
 * @param {Unsafe} pattern
 * @returns {RegExp}
 */ function $3aa4f544553907e2$export$7993761911514c15(pattern) {
    if (!pattern._compiled) {
        const before = (pattern.atBreak ? "[\\r\\n][\\t ]*" : "") + (pattern.before ? "(?:" + pattern.before + ")" : "");
        pattern._compiled = new RegExp((before ? "(" + before + ")" : "") + (/[|\\{}()[\]^$+*?.-]/.test(pattern.character) ? "\\" : "") + pattern.character + (pattern.after ? "(?:" + pattern.after + ")" : ""), "g");
    }
    return pattern._compiled;
}


/**
 * @typedef {import('../types.js').Unsafe} Unsafe
 * @typedef {import('../types.js').ConstructName} ConstructName
 */ /**
 * @param {Array<ConstructName>} stack
 * @param {Unsafe} pattern
 * @returns {boolean}
 */ function $c567432e2df75ee7$export$78221a09424368d(stack, pattern) {
    return $c567432e2df75ee7$var$listInScope(stack, pattern.inConstruct, true) && !$c567432e2df75ee7$var$listInScope(stack, pattern.notInConstruct, false);
}
/**
 * @param {Array<ConstructName>} stack
 * @param {Unsafe['inConstruct']} list
 * @param {boolean} none
 * @returns {boolean}
 */ function $c567432e2df75ee7$var$listInScope(stack, list, none) {
    if (typeof list === "string") list = [
        list
    ];
    if (!list || list.length === 0) return none;
    let index = -1;
    while(++index < list.length){
        if (stack.includes(list[index])) return true;
    }
    return false;
}


function $e7078af5950d4863$export$170b8c323eee7bec(state, input, config) {
    const value = (config.before || "") + (input || "") + (config.after || "");
    /** @type {Array<number>} */ const positions = [];
    /** @type {Array<string>} */ const result = [];
    /** @type {Record<number, {before: boolean, after: boolean}>} */ const infos = {};
    let index = -1;
    while(++index < state.unsafe.length){
        const pattern = state.unsafe[index];
        if (!(0, $c567432e2df75ee7$export$78221a09424368d)(state.stack, pattern)) continue;
        const expression = (0, $3aa4f544553907e2$export$7993761911514c15)(pattern);
        /** @type {RegExpExecArray | null} */ let match;
        while(match = expression.exec(value)){
            const before = "before" in pattern || Boolean(pattern.atBreak);
            const after = "after" in pattern;
            const position = match.index + (before ? match[1].length : 0);
            if (positions.includes(position)) {
                if (infos[position].before && !before) infos[position].before = false;
                if (infos[position].after && !after) infos[position].after = false;
            } else {
                positions.push(position);
                infos[position] = {
                    before: before,
                    after: after
                };
            }
        }
    }
    positions.sort($e7078af5950d4863$var$numerical);
    let start = config.before ? config.before.length : 0;
    const end = value.length - (config.after ? config.after.length : 0);
    index = -1;
    while(++index < positions.length){
        const position = positions[index];
        // Character before or after matched:
        if (position < start || position >= end) continue;
        // If this character is supposed to be escaped because it has a condition on
        // the next character, and the next character is definitly being escaped,
        // then skip this escape.
        if (position + 1 < end && positions[index + 1] === position + 1 && infos[position].after && !infos[position + 1].before && !infos[position + 1].after || positions[index - 1] === position - 1 && infos[position].before && !infos[position - 1].before && !infos[position - 1].after) continue;
        if (start !== position) // If we have to use a character reference, an ampersand would be more
        // correct, but as backslashes only care about punctuation, either will
        // do the trick
        result.push($e7078af5950d4863$var$escapeBackslashes(value.slice(start, position), "\\"));
        start = position;
        if (/[!-/:-@[-`{-~]/.test(value.charAt(position)) && (!config.encode || !config.encode.includes(value.charAt(position)))) // Character escape.
        result.push("\\");
        else {
            // Character reference.
            result.push("&#x" + value.charCodeAt(position).toString(16).toUpperCase() + ";");
            start++;
        }
    }
    result.push($e7078af5950d4863$var$escapeBackslashes(value.slice(start, end), config.after));
    return result.join("");
}
/**
 * @param {number} a
 * @param {number} b
 * @returns {number}
 */ function $e7078af5950d4863$var$numerical(a, b) {
    return a - b;
}
/**
 * @param {string} value
 * @param {string} after
 * @returns {string}
 */ function $e7078af5950d4863$var$escapeBackslashes(value, after) {
    const expression = /\\(?=[!-/:-@[-`{-~])/g;
    /** @type {Array<number>} */ const positions = [];
    /** @type {Array<string>} */ const results = [];
    const whole = value + after;
    let index = -1;
    let start = 0;
    /** @type {RegExpExecArray | null} */ let match;
    while(match = expression.exec(whole))positions.push(match.index);
    while(++index < positions.length){
        if (start !== positions[index]) results.push(value.slice(start, positions[index]));
        results.push("\\");
        start = positions[index];
    }
    results.push(value.slice(start));
    return results.join("");
}


/**
 * @typedef {import('../types.js').CreateTracker} CreateTracker
 * @typedef {import('../types.js').TrackCurrent} TrackCurrent
 * @typedef {import('../types.js').TrackMove} TrackMove
 * @typedef {import('../types.js').TrackShift} TrackShift
 */ /**
 * Track positional info in the output.
 *
 * @type {CreateTracker}
 */ function $72d43c206f37763e$export$6b2a7d5132615086(config) {
    // Defaults are used to prevent crashes when older utilities somehow activate
    // this code.
    /* c8 ignore next 5 */ const options = config || {};
    const now = options.now || {};
    let lineShift = options.lineShift || 0;
    let line = now.line || 1;
    let column = now.column || 1;
    return {
        move: move,
        current: current,
        shift: shift
    };
    /**
   * Get the current tracked info.
   *
   * @type {TrackCurrent}
   */ function current() {
        return {
            now: {
                line: line,
                column: column
            },
            lineShift: lineShift
        };
    }
    /**
   * Define an increased line shift (the typical indent for lines).
   *
   * @type {TrackShift}
   */ function shift(value) {
        lineShift += value;
    }
    /**
   * Move past some generated markdown.
   *
   * @type {TrackMove}
   */ function move(input) {
        // eslint-disable-next-line unicorn/prefer-default-parameters
        const value = input || "";
        const chunks = value.split(/\r?\n|\r/g);
        const tail = chunks[chunks.length - 1];
        line += chunks.length - 1;
        column = chunks.length === 1 ? column + tail.length : 1 + tail.length + lineShift;
        return value;
    }
}


$ea7fd1b0a639e11e$var$footnoteReference.peek = $ea7fd1b0a639e11e$var$footnoteReferencePeek;
function $ea7fd1b0a639e11e$export$c9d5ad4bdf6ff801() {
    return {
        enter: {
            gfmFootnoteDefinition: $ea7fd1b0a639e11e$var$enterFootnoteDefinition,
            gfmFootnoteDefinitionLabelString: $ea7fd1b0a639e11e$var$enterFootnoteDefinitionLabelString,
            gfmFootnoteCall: $ea7fd1b0a639e11e$var$enterFootnoteCall,
            gfmFootnoteCallString: $ea7fd1b0a639e11e$var$enterFootnoteCallString
        },
        exit: {
            gfmFootnoteDefinition: $ea7fd1b0a639e11e$var$exitFootnoteDefinition,
            gfmFootnoteDefinitionLabelString: $ea7fd1b0a639e11e$var$exitFootnoteDefinitionLabelString,
            gfmFootnoteCall: $ea7fd1b0a639e11e$var$exitFootnoteCall,
            gfmFootnoteCallString: $ea7fd1b0a639e11e$var$exitFootnoteCallString
        }
    };
}
function $ea7fd1b0a639e11e$export$3727766a73a6c09f() {
    return {
        // This is on by default already.
        unsafe: [
            {
                character: "[",
                inConstruct: [
                    "phrasing",
                    "label",
                    "reference"
                ]
            }
        ],
        handlers: {
            footnoteDefinition: $ea7fd1b0a639e11e$var$footnoteDefinition,
            footnoteReference: $ea7fd1b0a639e11e$var$footnoteReference
        }
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $ea7fd1b0a639e11e$var$enterFootnoteDefinition(token) {
    this.enter({
        type: "footnoteDefinition",
        identifier: "",
        label: "",
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $ea7fd1b0a639e11e$var$enterFootnoteDefinitionLabelString() {
    this.buffer();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $ea7fd1b0a639e11e$var$exitFootnoteDefinitionLabelString(token) {
    const label = this.resume();
    const node = /** @type {FootnoteDefinition} */ this.stack[this.stack.length - 1];
    node.label = label;
    node.identifier = (0, $3ef6ca0a03bd4b95$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $ea7fd1b0a639e11e$var$exitFootnoteDefinition(token) {
    this.exit(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $ea7fd1b0a639e11e$var$enterFootnoteCall(token) {
    this.enter({
        type: "footnoteReference",
        identifier: "",
        label: ""
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $ea7fd1b0a639e11e$var$enterFootnoteCallString() {
    this.buffer();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $ea7fd1b0a639e11e$var$exitFootnoteCallString(token) {
    const label = this.resume();
    const node = /** @type {FootnoteDefinition} */ this.stack[this.stack.length - 1];
    node.label = label;
    node.identifier = (0, $3ef6ca0a03bd4b95$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $ea7fd1b0a639e11e$var$exitFootnoteCall(token) {
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {FootnoteReference} node
 */ function $ea7fd1b0a639e11e$var$footnoteReference(node, _, context, safeOptions) {
    const tracker = (0, $72d43c206f37763e$export$6b2a7d5132615086)(safeOptions);
    let value = tracker.move("[^");
    const exit = context.enter("footnoteReference");
    const subexit = context.enter("reference");
    value += tracker.move((0, $e7078af5950d4863$export$170b8c323eee7bec)(context, (0, $2812f17c7b49a988$export$c4ca1a6065421754)(node), {
        ...tracker.current(),
        before: value,
        after: "]"
    }));
    subexit();
    exit();
    value += tracker.move("]");
    return value;
}
/** @type {ToMarkdownHandle} */ function $ea7fd1b0a639e11e$var$footnoteReferencePeek() {
    return "[";
}
/**
 * @type {ToMarkdownHandle}
 * @param {FootnoteDefinition} node
 */ function $ea7fd1b0a639e11e$var$footnoteDefinition(node, _, context, safeOptions) {
    const tracker = (0, $72d43c206f37763e$export$6b2a7d5132615086)(safeOptions);
    let value = tracker.move("[^");
    const exit = context.enter("footnoteDefinition");
    const subexit = context.enter("label");
    value += tracker.move((0, $e7078af5950d4863$export$170b8c323eee7bec)(context, (0, $2812f17c7b49a988$export$c4ca1a6065421754)(node), {
        ...tracker.current(),
        before: value,
        after: "]"
    }));
    subexit();
    value += tracker.move("]:" + (node.children && node.children.length > 0 ? " " : ""));
    tracker.shift(4);
    value += tracker.move((0, $fdb9cc8ce6464cf6$export$7c3cf23d514b264a)((0, $3c7981b220d3c271$export$134f7fdacfea8b16)(node, context, tracker.current()), $ea7fd1b0a639e11e$var$map));
    exit();
    return value;
}
/** @type {Map} */ function $ea7fd1b0a639e11e$var$map(line, index, blank) {
    if (index === 0) return line;
    return (blank ? "" : "    ") + line;
}


/**
 * @typedef {import('mdast').Delete} Delete
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').ConstructName} ConstructName
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 */ /**
 * @typedef {import('../types.js').Handle} Handle
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').PhrasingContent} PhrasingContent
 * @typedef {import('../types.js').State} State
 */ /**
 * Serialize the children of a parent that contains phrasing children.
 *
 * These children will be joined flush together.
 *
 * @param {Parent & {children: Array<PhrasingContent>}} parent
 *   Parent of flow nodes.
 * @param {State} state
 *   Info passed around about the current state.
 * @param {Info} info
 *   Info on where we are in the document we are generating.
 * @returns {string}
 *   Serialized children, joined together.
 */ function $cb2d12e2841dabd8$export$f4090a9439f37631(parent, state, info) {
    const indexStack = state.indexStack;
    const children = parent.children || [];
    /** @type {Array<string>} */ const results = [];
    let index = -1;
    let before = info.before;
    indexStack.push(-1);
    let tracker = state.createTracker(info);
    while(++index < children.length){
        const child = children[index];
        /** @type {string} */ let after;
        indexStack[indexStack.length - 1] = index;
        if (index + 1 < children.length) {
            /** @type {Handle} */ // @ts-expect-error: hush, it’s actually a `zwitch`.
            let handle = state.handle.handlers[children[index + 1].type];
            /** @type {Handle} */ // @ts-expect-error: hush, it’s actually a `zwitch`.
            if (handle && handle.peek) handle = handle.peek;
            after = handle ? handle(children[index + 1], parent, state, {
                before: "",
                after: "",
                ...tracker.current()
            }).charAt(0) : "";
        } else after = info.after;
        // In some cases, html (text) can be found in phrasing right after an eol.
        // When we’d serialize that, in most cases that would be seen as html
        // (flow).
        // As we can’t escape or so to prevent it from happening, we take a somewhat
        // reasonable approach: replace that eol with a space.
        // See: <https://github.com/syntax-tree/mdast-util-to-markdown/issues/15>
        if (results.length > 0 && (before === "\r" || before === "\n") && child.type === "html") {
            results[results.length - 1] = results[results.length - 1].replace(/(\r?\n|\r)$/, " ");
            before = " ";
            // To do: does this work to reset tracker?
            tracker = state.createTracker(info);
            tracker.move(results.join(""));
        }
        results.push(tracker.move(state.handle(child, parent, state, {
            ...tracker.current(),
            before: before,
            after: after
        })));
        before = results[results.length - 1].slice(-1);
    }
    indexStack.pop();
    return results.join("");
}



// To do: next major: expose functions.
// To do: next major: use `state`, state utilities.
/**
 * List of constructs that occur in phrasing (paragraphs, headings), but cannot
 * contain strikethrough.
 * So they sort of cancel each other out.
 * Note: could use a better name.
 *
 * Note: keep in sync with: <https://github.com/syntax-tree/mdast-util-to-markdown/blob/8ce8dbf/lib/unsafe.js#L14>
 *
 * @type {Array<ConstructName>}
 */ const $d164bd1b02bdadc0$var$constructsWithoutStrikethrough = [
    "autolink",
    "destinationLiteral",
    "destinationRaw",
    "reference",
    "titleQuote",
    "titleApostrophe"
];
$d164bd1b02bdadc0$var$handleDelete.peek = $d164bd1b02bdadc0$var$peekDelete;
const $d164bd1b02bdadc0$export$34d64e709dd0b9bb = {
    canContainEols: [
        "delete"
    ],
    enter: {
        strikethrough: $d164bd1b02bdadc0$var$enterStrikethrough
    },
    exit: {
        strikethrough: $d164bd1b02bdadc0$var$exitStrikethrough
    }
};
const $d164bd1b02bdadc0$export$1632835bd2c84956 = {
    unsafe: [
        {
            character: "~",
            inConstruct: "phrasing",
            notInConstruct: $d164bd1b02bdadc0$var$constructsWithoutStrikethrough
        }
    ],
    handlers: {
        delete: $d164bd1b02bdadc0$var$handleDelete
    }
};
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $d164bd1b02bdadc0$var$enterStrikethrough(token) {
    this.enter({
        type: "delete",
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $d164bd1b02bdadc0$var$exitStrikethrough(token) {
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {Delete} node
 */ function $d164bd1b02bdadc0$var$handleDelete(node, _, context, safeOptions) {
    const tracker = (0, $72d43c206f37763e$export$6b2a7d5132615086)(safeOptions);
    const exit = context.enter("strikethrough");
    let value = tracker.move("~~");
    value += (0, $cb2d12e2841dabd8$export$f4090a9439f37631)(node, context, {
        ...tracker.current(),
        before: value,
        after: "~"
    });
    value += tracker.move("~~");
    exit();
    return value;
}
/** @type {ToMarkdownHandle} */ function $d164bd1b02bdadc0$var$peekDelete() {
    return "~";
}


/**
 * @typedef {import('mdast').Table} Table
 * @typedef {import('mdast').TableRow} TableRow
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('mdast').InlineCode} InlineCode
 *
 * @typedef {import('markdown-table').MarkdownTableOptions} MarkdownTableOptions
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Context} ToMarkdownContext
 * @typedef {import('mdast-util-to-markdown').SafeOptions} SafeOptions
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [tableCellPadding=true]
 *   Whether to add a space of padding between delimiters and cells.
 * @property {boolean | null | undefined} [tablePipeAlign=true]
 *   Whether to align the delimiters.
 * @property {MarkdownTableOptions['stringLength'] | null | undefined} [stringLength]
 *   Function to detect the length of table cell content, used when aligning
 *   the delimiters between cells
 */ 
/**
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 */ 
$2e90dbe895841ef7$export$91b9bee19a0d8569.peek = $2e90dbe895841ef7$var$inlineCodePeek;
function $2e90dbe895841ef7$export$91b9bee19a0d8569(node, _, state) {
    let value = node.value || "";
    let sequence = "`";
    let index = -1;
    // If there is a single grave accent on its own in the code, use a fence of
    // two.
    // If there are two in a row, use one.
    while(new RegExp("(^|[^`])" + sequence + "([^`]|$)").test(value))sequence += "`";
    // If this is not just spaces or eols (tabs don’t count), and either the
    // first or last character are a space, eol, or tick, then pad with spaces.
    if (/[^ \r\n]/.test(value) && (/^[ \r\n]/.test(value) && /[ \r\n]$/.test(value) || /^`|`$/.test(value))) value = " " + value + " ";
    // We have a potential problem: certain characters after eols could result in
    // blocks being seen.
    // For example, if someone injected the string `'\n# b'`, then that would
    // result in an ATX heading.
    // We can’t escape characters in `inlineCode`, but because eols are
    // transformed to spaces when going from markdown to HTML anyway, we can swap
    // them out.
    while(++index < state.unsafe.length){
        const pattern = state.unsafe[index];
        const expression = (0, $3aa4f544553907e2$export$7993761911514c15)(pattern);
        /** @type {RegExpExecArray | null} */ let match;
        // Only look for `atBreak`s.
        // Btw: note that `atBreak` patterns will always start the regex at LF or
        // CR.
        if (!pattern.atBreak) continue;
        while(match = expression.exec(value)){
            let position = match.index;
            // Support CRLF (patterns only look for one of the characters).
            if (value.charCodeAt(position) === 10 /* `\n` */  && value.charCodeAt(position - 1) === 13 /* `\r` */ ) position--;
            value = value.slice(0, position) + " " + value.slice(match.index + 1);
        }
    }
    return sequence + value + sequence;
}
/**
 * @returns {string}
 */ function $2e90dbe895841ef7$var$inlineCodePeek() {
    return "`";
}


/**
 * @typedef Options
 *   Configuration (optional).
 * @property {string|null|ReadonlyArray<string|null|undefined>} [align]
 *   One style for all columns, or styles for their respective columns.
 *   Each style is either `'l'` (left), `'r'` (right), or `'c'` (center).
 *   Other values are treated as `''`, which doesn’t place the colon in the
 *   alignment row but does align left.
 *   *Only the lowercased first character is used, so `Right` is fine.*
 * @property {boolean} [padding=true]
 *   Whether to add a space of padding between delimiters and cells.
 *
 *   When `true`, there is padding:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there is no padding:
 *
 *   ```markdown
 *   |Alpha|B    |
 *   |-----|-----|
 *   |C    |Delta|
 *   ```
 * @property {boolean} [delimiterStart=true]
 *   Whether to begin each row with the delimiter.
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are starting delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no starting delimiters:
 *
 *   ```markdown
 *   Alpha | B     |
 *   ----- | ----- |
 *   C     | Delta |
 *   ```
 * @property {boolean} [delimiterEnd=true]
 *   Whether to end each row with the delimiter.
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B
 *   | ----- | -----
 *   | C     | Delta
 *   ```
 * @property {boolean} [alignDelimiters=true]
 *   Whether to align the delimiters.
 *   By default, they are aligned:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   Pass `false` to make them staggered:
 *
 *   ```markdown
 *   | Alpha | B |
 *   | - | - |
 *   | C | Delta |
 *   ```
 * @property {(value: string) => number} [stringLength]
 *   Function to detect the length of table cell content.
 *   This is used when aligning the delimiters (`|`) between table cells.
 *   Full-width characters and emoji mess up delimiter alignment when viewing
 *   the markdown source.
 *   To fix this, you can pass this function, which receives the cell content
 *   and returns its “visible” size.
 *   Note that what is and isn’t visible depends on where the text is displayed.
 *
 *   Without such a function, the following:
 *
 *   ```js
 *   markdownTable([
 *     ['Alpha', 'Bravo'],
 *     ['中文', 'Charlie'],
 *     ['👩‍❤️‍👩', 'Delta']
 *   ])
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo |
 *   | - | - |
 *   | 中文 | Charlie |
 *   | 👩‍❤️‍👩 | Delta |
 *   ```
 *
 *   With [`string-width`](https://github.com/sindresorhus/string-width):
 *
 *   ```js
 *   import stringWidth from 'string-width'
 *
 *   markdownTable(
 *     [
 *       ['Alpha', 'Bravo'],
 *       ['中文', 'Charlie'],
 *       ['👩‍❤️‍👩', 'Delta']
 *     ],
 *     {stringLength: stringWidth}
 *   )
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo   |
 *   | ----- | ------- |
 *   | 中文  | Charlie |
 *   | 👩‍❤️‍👩    | Delta   |
 *   ```
 */ /**
 * @typedef {Options} MarkdownTableOptions
 * @todo
 *   Remove next major.
 */ /**
 * Generate a markdown ([GFM](https://docs.github.com/en/github/writing-on-github/working-with-advanced-formatting/organizing-information-with-tables)) table..
 *
 * @param {ReadonlyArray<ReadonlyArray<string|null|undefined>>} table
 *   Table data (matrix of strings).
 * @param {Options} [options]
 *   Configuration (optional).
 * @returns {string}
 */ function $f0348d3c1462458d$export$cdb7288612c4f3d6(table, options = {}) {
    const align = (options.align || []).concat();
    const stringLength = options.stringLength || $f0348d3c1462458d$var$defaultStringLength;
    /** @type {Array<number>} Character codes as symbols for alignment per column. */ const alignments = [];
    /** @type {Array<Array<string>>} Cells per row. */ const cellMatrix = [];
    /** @type {Array<Array<number>>} Sizes of each cell per row. */ const sizeMatrix = [];
    /** @type {Array<number>} */ const longestCellByColumn = [];
    let mostCellsPerRow = 0;
    let rowIndex = -1;
    // This is a superfluous loop if we don’t align delimiters, but otherwise we’d
    // do superfluous work when aligning, so optimize for aligning.
    while(++rowIndex < table.length){
        /** @type {Array<string>} */ const row = [];
        /** @type {Array<number>} */ const sizes = [];
        let columnIndex = -1;
        if (table[rowIndex].length > mostCellsPerRow) mostCellsPerRow = table[rowIndex].length;
        while(++columnIndex < table[rowIndex].length){
            const cell = $f0348d3c1462458d$var$serialize(table[rowIndex][columnIndex]);
            if (options.alignDelimiters !== false) {
                const size = stringLength(cell);
                sizes[columnIndex] = size;
                if (longestCellByColumn[columnIndex] === undefined || size > longestCellByColumn[columnIndex]) longestCellByColumn[columnIndex] = size;
            }
            row.push(cell);
        }
        cellMatrix[rowIndex] = row;
        sizeMatrix[rowIndex] = sizes;
    }
    // Figure out which alignments to use.
    let columnIndex = -1;
    if (typeof align === "object" && "length" in align) while(++columnIndex < mostCellsPerRow)alignments[columnIndex] = $f0348d3c1462458d$var$toAlignment(align[columnIndex]);
    else {
        const code = $f0348d3c1462458d$var$toAlignment(align);
        while(++columnIndex < mostCellsPerRow)alignments[columnIndex] = code;
    }
    // Inject the alignment row.
    columnIndex = -1;
    /** @type {Array<string>} */ const row = [];
    /** @type {Array<number>} */ const sizes = [];
    while(++columnIndex < mostCellsPerRow){
        const code = alignments[columnIndex];
        let before = "";
        let after = "";
        if (code === 99 /* `c` */ ) {
            before = ":";
            after = ":";
        } else if (code === 108 /* `l` */ ) before = ":";
        else if (code === 114 /* `r` */ ) after = ":";
        // There *must* be at least one hyphen-minus in each alignment cell.
        let size = options.alignDelimiters === false ? 1 : Math.max(1, longestCellByColumn[columnIndex] - before.length - after.length);
        const cell = before + "-".repeat(size) + after;
        if (options.alignDelimiters !== false) {
            size = before.length + size + after.length;
            if (size > longestCellByColumn[columnIndex]) longestCellByColumn[columnIndex] = size;
            sizes[columnIndex] = size;
        }
        row[columnIndex] = cell;
    }
    // Inject the alignment row.
    cellMatrix.splice(1, 0, row);
    sizeMatrix.splice(1, 0, sizes);
    rowIndex = -1;
    /** @type {Array<string>} */ const lines = [];
    while(++rowIndex < cellMatrix.length){
        const row = cellMatrix[rowIndex];
        const sizes = sizeMatrix[rowIndex];
        columnIndex = -1;
        /** @type {Array<string>} */ const line = [];
        while(++columnIndex < mostCellsPerRow){
            const cell = row[columnIndex] || "";
            let before = "";
            let after = "";
            if (options.alignDelimiters !== false) {
                const size = longestCellByColumn[columnIndex] - (sizes[columnIndex] || 0);
                const code = alignments[columnIndex];
                if (code === 114 /* `r` */ ) before = " ".repeat(size);
                else if (code === 99 /* `c` */ ) {
                    if (size % 2) {
                        before = " ".repeat(size / 2 + 0.5);
                        after = " ".repeat(size / 2 - 0.5);
                    } else {
                        before = " ".repeat(size / 2);
                        after = before;
                    }
                } else after = " ".repeat(size);
            }
            if (options.delimiterStart !== false && !columnIndex) line.push("|");
            if (options.padding !== false && // Don’t add the opening space if we’re not aligning and the cell is
            // empty: there will be a closing space.
            !(options.alignDelimiters === false && cell === "") && (options.delimiterStart !== false || columnIndex)) line.push(" ");
            if (options.alignDelimiters !== false) line.push(before);
            line.push(cell);
            if (options.alignDelimiters !== false) line.push(after);
            if (options.padding !== false) line.push(" ");
            if (options.delimiterEnd !== false || columnIndex !== mostCellsPerRow - 1) line.push("|");
        }
        lines.push(options.delimiterEnd === false ? line.join("").replace(/ +$/, "") : line.join(""));
    }
    return lines.join("\n");
}
/**
 * @param {string|null|undefined} [value]
 * @returns {string}
 */ function $f0348d3c1462458d$var$serialize(value) {
    return value === null || value === undefined ? "" : String(value);
}
/**
 * @param {string} value
 * @returns {number}
 */ function $f0348d3c1462458d$var$defaultStringLength(value) {
    return value.length;
}
/**
 * @param {string|null|undefined} value
 * @returns {number}
 */ function $f0348d3c1462458d$var$toAlignment(value) {
    const code = typeof value === "string" ? value.codePointAt(0) : 0;
    return code === 67 /* `C` */  || code === 99 /* `c` */  ? 99 /* `c` */  : code === 76 /* `L` */  || code === 108 /* `l` */  ? 108 /* `l` */  : code === 82 /* `R` */  || code === 114 /* `r` */  ? 114 /* `r` */  : 0;
}


const $101385a39e95c157$export$8bd0ec8ecf6adb7d = {
    enter: {
        table: $101385a39e95c157$var$enterTable,
        tableData: $101385a39e95c157$var$enterCell,
        tableHeader: $101385a39e95c157$var$enterCell,
        tableRow: $101385a39e95c157$var$enterRow
    },
    exit: {
        codeText: $101385a39e95c157$var$exitCodeText,
        table: $101385a39e95c157$var$exitTable,
        tableData: $101385a39e95c157$var$exit,
        tableHeader: $101385a39e95c157$var$exit,
        tableRow: $101385a39e95c157$var$exit
    }
};
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $101385a39e95c157$var$enterTable(token) {
    /** @type {Array<'left' | 'right' | 'center' | 'none'>} */ // @ts-expect-error: `align` is custom.
    const align = token._align;
    this.enter({
        type: "table",
        align: align.map((d)=>d === "none" ? null : d),
        children: []
    }, token);
    this.setData("inTable", true);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $101385a39e95c157$var$exitTable(token) {
    this.exit(token);
    this.setData("inTable");
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $101385a39e95c157$var$enterRow(token) {
    this.enter({
        type: "tableRow",
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $101385a39e95c157$var$exit(token) {
    this.exit(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $101385a39e95c157$var$enterCell(token) {
    this.enter({
        type: "tableCell",
        children: []
    }, token);
}
// Overwrite the default code text data handler to unescape escaped pipes when
// they are in tables.
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $101385a39e95c157$var$exitCodeText(token) {
    let value = this.resume();
    if (this.getData("inTable")) value = value.replace(/\\([\\|])/g, $101385a39e95c157$var$replace);
    const node = /** @type {InlineCode} */ this.stack[this.stack.length - 1];
    node.value = value;
    this.exit(token);
}
/**
 * @param {string} $0
 * @param {string} $1
 * @returns {string}
 */ function $101385a39e95c157$var$replace($0, $1) {
    // Pipes work, backslashes don’t (but can’t escape pipes).
    return $1 === "|" ? $1 : $0;
}
function $101385a39e95c157$export$dafcad76ea6e0045(options) {
    const settings = options || {};
    const padding = settings.tableCellPadding;
    const alignDelimiters = settings.tablePipeAlign;
    const stringLength = settings.stringLength;
    const around = padding ? " " : "|";
    return {
        unsafe: [
            {
                character: "\r",
                inConstruct: "tableCell"
            },
            {
                character: "\n",
                inConstruct: "tableCell"
            },
            // A pipe, when followed by a tab or space (padding), or a dash or colon
            // (unpadded delimiter row), could result in a table.
            {
                atBreak: true,
                character: "|",
                after: "[	 :-]"
            },
            // A pipe in a cell must be encoded.
            {
                character: "|",
                inConstruct: "tableCell"
            },
            // A colon must be followed by a dash, in which case it could start a
            // delimiter row.
            {
                atBreak: true,
                character: ":",
                after: "-"
            },
            // A delimiter row can also start with a dash, when followed by more
            // dashes, a colon, or a pipe.
            // This is a stricter version than the built in check for lists, thematic
            // breaks, and setex heading underlines though:
            // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
            {
                atBreak: true,
                character: "-",
                after: "[:|-]"
            }
        ],
        handlers: {
            table: handleTable,
            tableRow: handleTableRow,
            tableCell: handleTableCell,
            inlineCode: inlineCodeWithTable
        }
    };
    /**
   * @type {ToMarkdownHandle}
   * @param {Table} node
   */ function handleTable(node, _, context, safeOptions) {
        return serializeData(handleTableAsData(node, context, safeOptions), node.align);
    }
    /**
   * This function isn’t really used normally, because we handle rows at the
   * table level.
   * But, if someone passes in a table row, this ensures we make somewhat sense.
   *
   * @type {ToMarkdownHandle}
   * @param {TableRow} node
   */ function handleTableRow(node, _, context, safeOptions) {
        const row = handleTableRowAsData(node, context, safeOptions);
        const value = serializeData([
            row
        ]);
        // `markdown-table` will always add an align row
        return value.slice(0, value.indexOf("\n"));
    }
    /**
   * @type {ToMarkdownHandle}
   * @param {TableCell} node
   */ function handleTableCell(node, _, context, safeOptions) {
        const exit = context.enter("tableCell");
        const subexit = context.enter("phrasing");
        const value = (0, $cb2d12e2841dabd8$export$f4090a9439f37631)(node, context, {
            ...safeOptions,
            before: around,
            after: around
        });
        subexit();
        exit();
        return value;
    }
    /**
   * @param {Array<Array<string>>} matrix
   * @param {Array<string | null | undefined> | null | undefined} [align]
   */ function serializeData(matrix, align) {
        return (0, $f0348d3c1462458d$export$cdb7288612c4f3d6)(matrix, {
            align: align,
            alignDelimiters: // @ts-expect-error: `markdown-table` types should support `null`.
            alignDelimiters,
            padding: // @ts-expect-error: `markdown-table` types should support `null`.
            padding,
            stringLength: // @ts-expect-error: `markdown-table` types should support `null`.
            stringLength
        });
    }
    /**
   * @param {Table} node
   * @param {ToMarkdownContext} context
   * @param {SafeOptions} safeOptions
   */ function handleTableAsData(node, context, safeOptions) {
        const children = node.children;
        let index = -1;
        /** @type {Array<Array<string>>} */ const result = [];
        const subexit = context.enter("table");
        while(++index < children.length)result[index] = handleTableRowAsData(children[index], context, safeOptions);
        subexit();
        return result;
    }
    /**
   * @param {TableRow} node
   * @param {ToMarkdownContext} context
   * @param {SafeOptions} safeOptions
   */ function handleTableRowAsData(node, context, safeOptions) {
        const children = node.children;
        let index = -1;
        /** @type {Array<string>} */ const result = [];
        const subexit = context.enter("tableRow");
        while(++index < children.length)// Note: the positional info as used here is incorrect.
        // Making it correct would be impossible due to aligning cells?
        // And it would need copy/pasting `markdown-table` into this project.
        result[index] = handleTableCell(children[index], node, context, safeOptions);
        subexit();
        return result;
    }
    /**
   * @type {ToMarkdownHandle}
   * @param {InlineCode} node
   */ function inlineCodeWithTable(node, parent, context) {
        let value = (0, $2e90dbe895841ef7$export$91b9bee19a0d8569)(node, parent, context);
        if (context.stack.includes("tableCell")) value = value.replace(/\|/g, "\\$&");
        return value;
    }
}


/**
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 */ /**
 * @typedef {Extract<Root | Content, Parent>} Parents
 */ /**
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('../types.js').Map} Map
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Info} Info
 */ /**
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Options} Options
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['bullet'], null | undefined>}
 */ function $5755c5124752e00f$export$7425517207a4d0ae(state) {
    const marker = state.options.bullet || "*";
    if (marker !== "*" && marker !== "+" && marker !== "-") throw new Error("Cannot serialize items with `" + marker + "` for `options.bullet`, expected `*`, `+`, or `-`");
    return marker;
}


/**
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Options} Options
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['listItemIndent'], null | undefined>}
 */ function $660283e6d4bd30e6$export$2d5358b63da92261(state) {
    const style = state.options.listItemIndent || "tab";
    // To do: remove in a major.
    // @ts-expect-error: deprecated.
    if (style === 1 || style === "1") return "one";
    if (style !== "tab" && style !== "one" && style !== "mixed") throw new Error("Cannot serialize items with `" + style + "` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`");
    return style;
}


function $6c425db4d9a373d3$export$76c7e83ecc9cdf05(node, parent, state, info) {
    const listItemIndent = (0, $660283e6d4bd30e6$export$2d5358b63da92261)(state);
    let bullet = state.bulletCurrent || (0, $5755c5124752e00f$export$7425517207a4d0ae)(state);
    // Add the marker value for ordered lists.
    if (parent && parent.type === "list" && parent.ordered) bullet = (typeof parent.start === "number" && parent.start > -1 ? parent.start : 1) + (state.options.incrementListMarker === false ? 0 : parent.children.indexOf(node)) + bullet;
    let size = bullet.length + 1;
    if (listItemIndent === "tab" || listItemIndent === "mixed" && (parent && parent.type === "list" && parent.spread || node.spread)) size = Math.ceil(size / 4) * 4;
    const tracker = state.createTracker(info);
    tracker.move(bullet + " ".repeat(size - bullet.length));
    tracker.shift(size);
    const exit = state.enter("listItem");
    const value = state.indentLines(state.containerFlow(node, tracker.current()), map);
    exit();
    return value;
    /** @type {Map} */ function map(line, index, blank) {
        if (index) return (blank ? "" : " ".repeat(size)) + line;
        return (blank ? bullet : bullet + " ".repeat(size - bullet.length)) + line;
    }
}



const $ec5caf251b62b791$export$a427a608608b215f = {
    exit: {
        taskListCheckValueChecked: $ec5caf251b62b791$var$exitCheck,
        taskListCheckValueUnchecked: $ec5caf251b62b791$var$exitCheck,
        paragraph: $ec5caf251b62b791$var$exitParagraphWithTaskListItem
    }
};
const $ec5caf251b62b791$export$9975722e7e834b78 = {
    unsafe: [
        {
            atBreak: true,
            character: "-",
            after: "[:|-]"
        }
    ],
    handlers: {
        listItem: $ec5caf251b62b791$var$listItemWithTaskListItem
    }
};
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $ec5caf251b62b791$var$exitCheck(token) {
    const node = /** @type {ListItem} */ this.stack[this.stack.length - 2];
    // We’re always in a paragraph, in a list item.
    node.checked = token.type === "taskListCheckValueChecked";
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $ec5caf251b62b791$var$exitParagraphWithTaskListItem(token) {
    const parent = /** @type {Parents} */ this.stack[this.stack.length - 2];
    if (parent && parent.type === "listItem" && typeof parent.checked === "boolean") {
        const node = /** @type {Paragraph} */ this.stack[this.stack.length - 1];
        const head = node.children[0];
        if (head && head.type === "text") {
            const siblings = parent.children;
            let index = -1;
            /** @type {Paragraph | undefined} */ let firstParaghraph;
            while(++index < siblings.length){
                const sibling = siblings[index];
                if (sibling.type === "paragraph") {
                    firstParaghraph = sibling;
                    break;
                }
            }
            if (firstParaghraph === node) {
                // Must start with a space or a tab.
                head.value = head.value.slice(1);
                if (head.value.length === 0) node.children.shift();
                else if (node.position && head.position && typeof head.position.start.offset === "number") {
                    head.position.start.column++;
                    head.position.start.offset++;
                    node.position.start = Object.assign({}, head.position.start);
                }
            }
        }
    }
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {ListItem} node
 */ function $ec5caf251b62b791$var$listItemWithTaskListItem(node, parent, context, safeOptions) {
    const head = node.children[0];
    const checkable = typeof node.checked === "boolean" && head && head.type === "paragraph";
    const checkbox = "[" + (node.checked ? "x" : " ") + "] ";
    const tracker = (0, $72d43c206f37763e$export$6b2a7d5132615086)(safeOptions);
    if (checkable) tracker.move(checkbox);
    let value = (0, $6c425db4d9a373d3$export$76c7e83ecc9cdf05)(node, parent, context, {
        ...safeOptions,
        ...tracker.current()
    });
    if (checkable) value = value.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, check);
    return value;
    /**
   * @param {string} $0
   * @returns {string}
   */ function check($0) {
        return $0 + checkbox;
    }
}


function $dceea09077a3a9f8$export$95adae814eb7433e() {
    return [
        (0, $c0da0703951bf573$export$b6afdfff2163546f),
        (0, $ea7fd1b0a639e11e$export$c9d5ad4bdf6ff801)(),
        (0, $d164bd1b02bdadc0$export$34d64e709dd0b9bb),
        (0, $101385a39e95c157$export$8bd0ec8ecf6adb7d),
        (0, $ec5caf251b62b791$export$a427a608608b215f)
    ];
}
function $dceea09077a3a9f8$export$ea77de6901e7c72b(options) {
    return {
        extensions: [
            (0, $c0da0703951bf573$export$d3ace9096b01c39d),
            (0, $ea7fd1b0a639e11e$export$3727766a73a6c09f)(),
            (0, $d164bd1b02bdadc0$export$1632835bd2c84956),
            (0, $101385a39e95c157$export$dafcad76ea6e0045)(options),
            (0, $ec5caf251b62b791$export$9975722e7e834b78)
        ]
    };
}


function $1613ab4053498619$export$2e2bcd8739ae039(options = {}) {
    const data = this.data();
    add("micromarkExtensions", (0, $a2ecb74ac5dcb4ac$export$59ffe8c4d7a4aab2)(options));
    add("fromMarkdownExtensions", (0, $dceea09077a3a9f8$export$95adae814eb7433e)());
    add("toMarkdownExtensions", (0, $dceea09077a3a9f8$export$ea77de6901e7c72b)(options));
    /**
   * @param {string} field
   * @param {unknown} value
   */ function add(field, value) {
        const list = /** @type {unknown[]} */ // Other extensions
        /* c8 ignore next 2 */ data[field] ? data[field] : data[field] = [];
        list.push(value);
    }
}







var $6cds3 = parcelRequire("6cds3");

var $c9wMV = parcelRequire("c9wMV");



const $7a39fa520f733ab7$export$ef13eb3baee5c6d8 = {
    "VOTE_OPTION_YES": "Yes",
    "VOTE_OPTION_NO": "No",
    "VOTE_OPTION_ABSTAIN": "Abstain",
    "VOTE_OPTION_NO_WITH_VETO": "No with Veto"
};
const $7a39fa520f733ab7$export$6c0aeb1c99e9784a = {
    "VOTE_OPTION_YES": 1,
    "VOTE_OPTION_NO": 3,
    "VOTE_OPTION_NO_WITH_VETO": 4,
    "VOTE_OPTION_ABSTAIN": 2
};
const $7a39fa520f733ab7$var$Vote = (data)=>{
    var _data_options;
    let option = data.option;
    let optionHuman = $7a39fa520f733ab7$export$ef13eb3baee5c6d8[data.option];
    let optionValue = $7a39fa520f733ab7$export$6c0aeb1c99e9784a[data.option];
    if (!optionValue && ((_data_options = data.options) === null || _data_options === void 0 ? void 0 : _data_options.length)) {
        var _data_options_find;
        option = (_data_options_find = data.options.find((el)=>(0, $ed89d4c20b089b73$export$411ce8e5a71e3069)(el.weight, 1))) === null || _data_options_find === void 0 ? void 0 : _data_options_find.option;
        optionHuman = option ? $7a39fa520f733ab7$export$ef13eb3baee5c6d8[option] : "Multiple";
        optionValue = option ? $7a39fa520f733ab7$export$6c0aeb1c99e9784a[option] : null // doesn't support multiple right now
        ;
    }
    return {
        ...data,
        option: option,
        optionHuman: optionHuman,
        optionValue: optionValue
    };
};
var $7a39fa520f733ab7$export$2e2bcd8739ae039 = $7a39fa520f733ab7$var$Vote;



function $f378934368962876$var$VoteForm(props) {
    const { proposal: proposal, vote: vote, address: address, wallet: wallet, granter: granter, setError: setError } = props;
    const { proposal_id: proposal_id } = proposal;
    const choices = {
        "VOTE_OPTION_YES": "Yes",
        "VOTE_OPTION_NO": "No",
        "VOTE_OPTION_NO_WITH_VETO": "No with Veto",
        "VOTE_OPTION_ABSTAIN": "Abstain"
    };
    const choiceIndices = {
        "VOTE_OPTION_YES": 1,
        "VOTE_OPTION_NO": 3,
        "VOTE_OPTION_NO_WITH_VETO": 4,
        "VOTE_OPTION_ABSTAIN": 2
    };
    const [choice, setChoice] = (0, $6cds3.useState)(vote === null || vote === void 0 ? void 0 : vote.option);
    const [loading, setLoading] = (0, $6cds3.useState)();
    (0, $6cds3.useEffect)(()=>{
        setChoice(vote === null || vote === void 0 ? void 0 : vote.option);
    }, [
        vote
    ]);
    function handleVoteChange(event) {
        setChoice(event.target.name);
    }
    function handleSubmit(event) {
        event.preventDefault();
        if (!choice) return setError("Please choose an option");
        setLoading(true);
        setError();
        const newVote = (0, $7a39fa520f733ab7$export$2e2bcd8739ae039)({
            proposal_id: proposal_id,
            voter: granter || wallet.address,
            option: choice,
            options: [
                {
                    choice: choice,
                    weight: "1.000000000000000000"
                }
            ]
        });
        let message;
        const value = {
            proposalId: proposal.proposal_id,
            voter: newVote.voter,
            option: newVote.optionValue
        };
        if (granter) message = (0, $2a6bf51ee962800d$export$61d88097eacac343)(wallet.address, [
            {
                typeUrl: "/cosmos.gov.v1beta1.MsgVote",
                value: (0, $45c64d9a52e17eab$exports.MsgVote).encode((0, $45c64d9a52e17eab$exports.MsgVote).fromPartial(value)).finish()
            }
        ]);
        else message = {
            typeUrl: "/cosmos.gov.v1beta1.MsgVote",
            value: value
        };
        console.log(message);
        props.signingClient.signAndBroadcast(wallet.address, [
            message
        ]).then((result)=>{
            console.log("Successfully broadcasted:", result);
            setLoading(false);
            setError(null);
            props.onVote(proposal, newVote);
        }, (error)=>{
            console.log("Failed to broadcast:", error);
            setLoading(false);
            setError(error.message);
        });
    }
    const voteChanged = vote && vote.option !== choice;
    function canVote() {
        if (!(wallet === null || wallet === void 0 ? void 0 : wallet.address) || !proposal.isVoting) return false;
        if (!hasPermission()) return false;
        return choice && (!vote || vote && voteChanged);
    }
    function hasPermission() {
        return wallet && wallet.hasPermission(granter || wallet.address, "Vote");
    }
    function buttonText() {
        if (!proposal.isVoting) return proposal.isDeposit ? "Voting not started" : "Voting ended";
        return vote ? voteChanged ? "Change vote" : "Voted" : "Vote";
    }
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039), {
            onSubmit: handleSubmit,
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039).Group, {
                    className: "border-top pt-2 my-2",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "row pe-lg-5",
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($c9wMV))).chunk(Object.entries(choices), 2).map((group, index)=>{
                            return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: "col-6",
                                children: group.map(([key, value])=>{
                                    const voteChoice = vote && key === vote.option;
                                    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                        className: "mb-2",
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039).Check, {
                                            type: "radio",
                                            id: `vote-${key}`,
                                            children: [
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039).Check.Input, {
                                                    type: "radio",
                                                    name: key,
                                                    checked: key === choice,
                                                    disabled: !proposal.isVoting || !hasPermission(),
                                                    onChange: handleVoteChange
                                                }),
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039).Check.Label, {
                                                    className: "d-block text-nowrap",
                                                    children: voteChoice ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                                                        children: value
                                                    }) : value
                                                })
                                            ]
                                        })
                                    }, `vote-${key}`);
                                })
                            }, index);
                        }).flat()
                    })
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                    className: "text-end",
                    children: !loading ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a73f5336dfd04f2d$export$2e2bcd8739ae039), {
                        type: "submit",
                        disabled: !canVote(),
                        className: "btn btn-primary",
                        children: buttonText()
                    }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $a73f5336dfd04f2d$export$2e2bcd8739ae039), {
                        className: "btn btn-primary",
                        type: "button",
                        disabled: true,
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                className: "spinner-border spinner-border-sm",
                                role: "status",
                                "aria-hidden": "true"
                            }),
                            "\xa0"
                        ]
                    })
                })
            ]
        })
    });
}
var $f378934368962876$export$2e2bcd8739ae039 = $f378934368962876$var$VoteForm;




function $bf0d10e303f4c7b0$var$ProposalDetails(props) {
    const { proposal: proposal, tally: tally, vote: vote, network: network } = props;
    const [granter, setGranter] = (0, $6cds3.useState)();
    const [granterVote, setGranterVote] = (0, $6cds3.useState)();
    const [error, setError] = (0, $6cds3.useState)();
    const { proposal_id: proposal_id, title: title, description: description } = proposal;
    const fixDescription = description.replace(/\\n/g, "  \n");
    (0, $6cds3.useEffect)(()=>{
        var _props_wallet;
        if (props.address !== ((_props_wallet = props.wallet) === null || _props_wallet === void 0 ? void 0 : _props_wallet.address) && props.granters.includes(props.address)) setGranter(props.address);
    }, [
        props.address
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (granter) props.queryClient.getProposalVote(proposal_id, granter).then((result)=>{
            return setGranterVote((0, $7a39fa520f733ab7$export$2e2bcd8739ae039)(result.vote));
        }).catch((error)=>{
            setGranterVote(null);
        });
        else setGranterVote(null);
    }, [
        granter
    ]);
    function onVote(proposal, vote) {
        if (granter && props.address !== granter) setGranterVote(vote);
        else props.onVote(proposal, vote);
    }
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: [
            error && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $c9bd276a69168a44$export$2e2bcd8739ae039), {
                variant: "danger",
                className: "text-break small",
                children: error
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "col-12 col-lg-6",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $36688d56d3c1862c$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tbody", {
                                className: "small",
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                scope: "row",
                                                children: "ID"
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("td", {
                                                className: "text-break",
                                                children: [
                                                    "#",
                                                    proposal_id
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                scope: "row",
                                                children: "Status"
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                children: proposal.statusHuman
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                scope: "row",
                                                children: "Type"
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                children: proposal.typeHuman
                                            })
                                        ]
                                    }),
                                    !proposal.isDeposit && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                        scope: "row",
                                                        children: "Submit time"
                                                    }),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d85ff2c90168cfc4$exports))), {
                                                            format: "LLL",
                                                            children: proposal.submit_time
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                        scope: "row",
                                                        children: "Voting end time"
                                                    }),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d85ff2c90168cfc4$exports))), {
                                                            format: "LLL",
                                                            children: proposal.voting_end_time
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    proposal.isDeposit && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                        scope: "row",
                                                        children: "Deposit end time"
                                                    }),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d85ff2c90168cfc4$exports))), {
                                                            format: "LLL",
                                                            children: proposal.deposit_end_time
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                        scope: "row",
                                                        children: "Total deposit"
                                                    }),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                        children: proposal.total_deposit.map((coins)=>{
                                                            return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $edd3c36e8c82dfd7$export$2e2bcd8739ae039), {
                                                                coins: coins,
                                                                asset: network.baseAsset
                                                            }, coins.denom);
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    props.address && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        className: "col-12 col-lg-6",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                className: "mb-2",
                                children: props.granters.length > 0 ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("select", {
                                    className: "form-select form-select-sm",
                                    "aria-label": "Granter",
                                    value: granter,
                                    onChange: (e)=>setGranter(e.target.value),
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                                            value: "",
                                            children: "Your vote"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("optgroup", {
                                            label: "Authz Grants",
                                            children: props.granters.map((granterAddress)=>{
                                                const favourite = props.favouriteAddresses.find((el)=>el.address === granterAddress);
                                                return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                                                    value: granterAddress,
                                                    children: (favourite === null || favourite === void 0 ? void 0 : favourite.label) || granterAddress
                                                }, granterAddress);
                                            })
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                                    children: "Your Vote"
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f378934368962876$export$2e2bcd8739ae039), {
                                network: network,
                                proposal: proposal,
                                vote: granter ? granterVote : vote,
                                address: props.address,
                                wallet: props.wallet,
                                granter: granter,
                                signingClient: props.signingClient,
                                onVote: onVote,
                                setError: setError
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: "mb-4 mt-2",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $ee5b19fa9f9150ab$export$2e2bcd8739ae039), {
                    proposal: proposal,
                    tally: tally,
                    height: 25
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: "row mt-3",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                    className: "col",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h5", {
                            className: "mb-3",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $09a0bcde9ff9c8f5$export$83ef7ab426386201), {
                            children: fixDescription,
                            remarkPlugins: [
                                (0, $1613ab4053498619$export$2e2bcd8739ae039)
                            ],
                            components: {
                                h1: "h5",
                                h2: "h6",
                                h3: "h6",
                                h4: "h6",
                                h5: "h6",
                                h6: "h6",
                                table: ({ node: node, ...props })=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("table", {
                                        className: "table",
                                        ...props
                                    })
                            }
                        })
                    ]
                })
            })
        ]
    });
}
var $bf0d10e303f4c7b0$export$2e2bcd8739ae039 = $bf0d10e303f4c7b0$var$ProposalDetails;


function $3eb6e77a3e6170ad$var$ProposalModal(props) {
    const { show: show, proposal: proposal, tally: tally, vote: vote, network: network, address: address } = props;
    const handleClose = ()=>{
        props.closeProposal();
    };
    if (!proposal) return null;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $3485727b0a1e4042$export$2e2bcd8739ae039), {
            size: "lg",
            show: show,
            onHide: handleClose,
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $3485727b0a1e4042$export$2e2bcd8739ae039).Header, {
                    closeButton: true,
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $3485727b0a1e4042$export$2e2bcd8739ae039).Title, {
                        className: "text-truncate pe-4",
                        children: proposal.title
                    })
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $3485727b0a1e4042$export$2e2bcd8739ae039).Body, {
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $bf0d10e303f4c7b0$export$2e2bcd8739ae039), {
                        network: network,
                        proposal: proposal,
                        tally: tally,
                        vote: vote,
                        address: props.address,
                        wallet: props.wallet,
                        granters: props.granters,
                        favouriteAddresses: props.favouriteAddresses,
                        queryClient: props.queryClient,
                        signingClient: props.signingClient,
                        onVote: props.onVote
                    })
                })
            ]
        })
    });
}
var $3eb6e77a3e6170ad$export$2e2bcd8739ae039 = $3eb6e77a3e6170ad$var$ProposalModal;




function $da3aff51a5e73f86$var$Voting(props) {
    const { address: address, wallet: wallet, network: network } = props;
    const [showModal, setShowModal] = (0, $6cds3.useState)();
    const [proposal, setProposal] = (0, $6cds3.useState)();
    const [proposals, setProposals] = (0, $6cds3.useState)();
    const [tallies, setTallies] = (0, $6cds3.useReducer)((tallies, newTallies)=>!newTallies ? {} : {
            ...tallies,
            ...newTallies
        }, {});
    const [votes, setVotes] = (0, $6cds3.useReducer)((votes, newVotes)=>!newVotes ? {} : {
            ...votes,
            ...newVotes
        }, {});
    const [error, setError] = (0, $6cds3.useState)();
    const navigate = (0, $4a3e215446c0ed92$export$9770f232ac06a008)();
    const params = (0, $4a3e215446c0ed92$export$99eaa27ddbbb95ef)();
    const voteGrants = ((wallet === null || wallet === void 0 ? void 0 : wallet.grants) || []).filter((grant)=>{
        return grant.authorization["@type"] === "/cosmos.authz.v1beta1.GenericAuthorization" && grant.authorization.msg === "/cosmos.gov.v1beta1.MsgVote";
    });
    (0, $6cds3.useEffect)(()=>{
        setProposals(false);
        setTallies(false);
        setVotes(false);
        setError(false);
        getProposals({
            clearExisting: true
        });
    }, [
        network
    ]);
    (0, $6cds3.useEffect)(()=>{
        const interval = setInterval(()=>{
            getProposals();
        }, 120000);
        return ()=>clearInterval(interval);
    }, [
        network
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (!proposals || !params.proposalId) return;
        const prop = proposals.find((el)=>el.proposal_id === params.proposalId);
        if (prop) showProposal(prop);
        else if (proposal) {
            setProposal(null);
            closeProposal();
        }
    }, [
        proposals,
        params.proposalId
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (!proposals) return;
        getTallies(proposals);
        if (address) getVotes(proposals);
    }, [
        proposals
    ]);
    (0, $6cds3.useEffect)(()=>{
        setVotes(false);
        if (proposals && address) getVotes(proposals, {
            clearExisting: true
        });
    }, [
        address
    ]);
    async function getProposals(opts) {
        if (!props.queryClient) return;
        const { clearExisting: clearExisting } = opts || {};
        try {
            let newProposals = await props.queryClient.getProposals();
            newProposals = newProposals.map((el)=>(0, $c353f6c871ff77a0$export$2e2bcd8739ae039)(el));
            setError();
            setProposals(sortProposals(newProposals));
            setTallies(newProposals.reduce((sum, proposal)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($c9wMV))).every(Object.values(proposal.final_tally_result), (el)=>el === "0")) sum[proposal.proposal_id] = proposal.final_tally_result;
                return sum;
            }, {}));
        } catch (error) {
            if (!proposals || clearExisting) setProposals([]);
            setError(`Failed to load proposals: ${error.message}`);
        }
    }
    async function getTallies(proposals) {
        const calls = proposals.map((proposal)=>{
            return ()=>{
                const { proposal_id: proposal_id, final_tally_result: result } = proposal;
                if (tallies[proposal_id]) return;
                const talliesInvalid = (0, (/*@__PURE__*/$parcel$interopDefault($c9wMV))).every(Object.values(result), (el)=>el === "0");
                if (proposal.isVoting && talliesInvalid) return props.queryClient.getProposalTally(proposal_id).then((result)=>{
                    return setTallies({
                        [proposal_id]: result.tally
                    });
                });
            };
        });
        await (0, $2a6bf51ee962800d$export$6d0f20a121527483)(calls, 2);
    }
    async function getVotes(proposals, opts) {
        const { clearExisting: clearExisting } = opts || {};
        const calls = proposals.filter((el)=>el.status === "PROPOSAL_STATUS_VOTING_PERIOD").map((proposal)=>{
            return ()=>{
                const { proposal_id: proposal_id } = proposal;
                if (votes[proposal_id] && !clearExisting) return;
                return props.queryClient.getProposalVote(proposal_id, address).then((result)=>{
                    return setVotes({
                        [proposal_id]: (0, $7a39fa520f733ab7$export$2e2bcd8739ae039)(result.vote)
                    });
                }).catch((error)=>{});
            };
        });
        await (0, $2a6bf51ee962800d$export$6d0f20a121527483)(calls, 2);
    }
    function showProposal(proposal) {
        setProposal(proposal);
        setShowModal(true);
        if (proposal.proposal_id !== params.proposalId) navigate(`/${network.name}/vote/${proposal.proposal_id}`);
    }
    function closeProposal() {
        setShowModal(false);
        navigate(`/${network.name}/vote`);
    }
    function onVote(proposal, vote) {
        setError(null);
        setVotes({
            [proposal.proposal_id]: vote
        });
        closeProposal();
    }
    function sortProposals(proposals) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($c9wMV))).sortBy(proposals, ({ proposal_id: proposal_id })=>{
            return 0 - parseInt(proposal_id);
        });
    }
    if (!proposals) return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
        className: "text-center",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $39ebe134e7977f3e$export$2e2bcd8739ae039), {
            animation: "border",
            role: "status",
            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                className: "visually-hidden",
                children: "Loading..."
            })
        })
    });
    const alerts = /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $c9bd276a69168a44$export$2e2bcd8739ae039), {
            message: error
        })
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: [
            alerts,
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: "mb-2",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $653f5b7d06fe127c$export$2e2bcd8739ae039), {
                    network: network,
                    address: address,
                    proposals: proposals,
                    tallies: tallies,
                    votes: votes,
                    signingClient: props.signingClient,
                    showProposal: showProposal,
                    setError: setError,
                    onVote: onVote
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $3eb6e77a3e6170ad$export$2e2bcd8739ae039), {
                show: showModal,
                proposal: proposal,
                network: network,
                wallet: wallet,
                address: address,
                tally: proposal && tallies[proposal.proposal_id],
                vote: proposal && votes[proposal.proposal_id],
                granters: voteGrants.map((el)=>el.granter),
                favouriteAddresses: props.favouriteAddresses,
                queryClient: props.queryClient,
                signingClient: props.signingClient,
                closeProposal: closeProposal,
                onVote: onVote,
                setError: setError
            })
        ]
    });
}
var $da3aff51a5e73f86$export$2e2bcd8739ae039 = $da3aff51a5e73f86$var$Voting;




var $6cds3 = parcelRequire("6cds3");
parcelRequire("c9wMV");



var $6cds3 = parcelRequire("6cds3");


"use client";
const $d393be44ad07b2ae$var$Row = /*#__PURE__*/ $6cds3.forwardRef(({ bsPrefix: bsPrefix, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div", ...props }, ref)=>{
    const decoratedBsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "row");
    const breakpoints = (0, $c5d3aca6e909caf5$export$8970c8db816a5863)();
    const minBreakpoint = (0, $c5d3aca6e909caf5$export$d926d6ef38f3fd32)();
    const sizePrefix = `${decoratedBsPrefix}-cols`;
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let cols;
        if (propValue != null && typeof propValue === "object") ({ cols: cols } = propValue);
        else cols = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : "";
        if (cols != null) classes.push(`${sizePrefix}${infix}-${cols}`);
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, decoratedBsPrefix, ...classes)
    });
});
$d393be44ad07b2ae$var$Row.displayName = "Row";
var $d393be44ad07b2ae$export$2e2bcd8739ae039 = $d393be44ad07b2ae$var$Row;



var $6cds3 = parcelRequire("6cds3");


var $6cds3 = parcelRequire("6cds3");



"use client";
const $2b986c13a708a6db$var$CardBody = /*#__PURE__*/ $6cds3.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", ...props }, ref)=>{
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "card-body");
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, bsPrefix),
        ...props
    });
});
$2b986c13a708a6db$var$CardBody.displayName = "CardBody";
var $2b986c13a708a6db$export$2e2bcd8739ae039 = $2b986c13a708a6db$var$CardBody;



var $6cds3 = parcelRequire("6cds3");



"use client";
const $f7962ade78f9929b$var$CardFooter = /*#__PURE__*/ $6cds3.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", ...props }, ref)=>{
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "card-footer");
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, bsPrefix),
        ...props
    });
});
$f7962ade78f9929b$var$CardFooter.displayName = "CardFooter";
var $f7962ade78f9929b$export$2e2bcd8739ae039 = $f7962ade78f9929b$var$CardFooter;




var $6cds3 = parcelRequire("6cds3");



"use client";
const $5394fb92b3e72a0e$var$CardHeader = /*#__PURE__*/ $6cds3.forwardRef(({ bsPrefix: bsPrefix, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div", ...props }, ref)=>{
    const prefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "card-header");
    const contextValue = (0, $6cds3.useMemo)(()=>({
            cardHeaderBsPrefix: prefix
        }), [
        prefix
    ]);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5ff0b908721f444d$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
            ref: ref,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, prefix)
        })
    });
});
$5394fb92b3e72a0e$var$CardHeader.displayName = "CardHeader";
var $5394fb92b3e72a0e$export$2e2bcd8739ae039 = $5394fb92b3e72a0e$var$CardHeader;




var $6cds3 = parcelRequire("6cds3");


"use client";
const $1cab5a27e17b73f0$var$CardImg = /*#__PURE__*/ $6cds3.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix: bsPrefix, className: className, variant: variant, as: Component = "img", ...props }, ref)=>{
    const prefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "card-img");
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(variant ? `${prefix}-${variant}` : prefix, className),
        ...props
    });
});
$1cab5a27e17b73f0$var$CardImg.displayName = "CardImg";
var $1cab5a27e17b73f0$export$2e2bcd8739ae039 = $1cab5a27e17b73f0$var$CardImg;



var $6cds3 = parcelRequire("6cds3");



"use client";
const $21e61cdec2541d20$var$CardImgOverlay = /*#__PURE__*/ $6cds3.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", ...props }, ref)=>{
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "card-img-overlay");
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, bsPrefix),
        ...props
    });
});
$21e61cdec2541d20$var$CardImgOverlay.displayName = "CardImgOverlay";
var $21e61cdec2541d20$export$2e2bcd8739ae039 = $21e61cdec2541d20$var$CardImgOverlay;



var $6cds3 = parcelRequire("6cds3");



"use client";
const $40d5c92eb89a1892$var$CardLink = /*#__PURE__*/ $6cds3.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "a", ...props }, ref)=>{
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "card-link");
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, bsPrefix),
        ...props
    });
});
$40d5c92eb89a1892$var$CardLink.displayName = "CardLink";
var $40d5c92eb89a1892$export$2e2bcd8739ae039 = $40d5c92eb89a1892$var$CardLink;



var $6cds3 = parcelRequire("6cds3");




"use client";
const $0b8bc5fcb7727868$var$DivStyledAsH6 = (0, $4209f4cdd547894e$export$2e2bcd8739ae039)("h6");
const $0b8bc5fcb7727868$var$CardSubtitle = /*#__PURE__*/ $6cds3.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $0b8bc5fcb7727868$var$DivStyledAsH6, ...props }, ref)=>{
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "card-subtitle");
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, bsPrefix),
        ...props
    });
});
$0b8bc5fcb7727868$var$CardSubtitle.displayName = "CardSubtitle";
var $0b8bc5fcb7727868$export$2e2bcd8739ae039 = $0b8bc5fcb7727868$var$CardSubtitle;



var $6cds3 = parcelRequire("6cds3");



"use client";
const $ae025746916351fa$var$CardText = /*#__PURE__*/ $6cds3.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "p", ...props }, ref)=>{
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "card-text");
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, bsPrefix),
        ...props
    });
});
$ae025746916351fa$var$CardText.displayName = "CardText";
var $ae025746916351fa$export$2e2bcd8739ae039 = $ae025746916351fa$var$CardText;



var $6cds3 = parcelRequire("6cds3");




"use client";
const $40c78c76a2c252ca$var$DivStyledAsH5 = (0, $4209f4cdd547894e$export$2e2bcd8739ae039)("h5");
const $40c78c76a2c252ca$var$CardTitle = /*#__PURE__*/ $6cds3.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $40c78c76a2c252ca$var$DivStyledAsH5, ...props }, ref)=>{
    bsPrefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "card-title");
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, bsPrefix),
        ...props
    });
});
$40c78c76a2c252ca$var$CardTitle.displayName = "CardTitle";
var $40c78c76a2c252ca$export$2e2bcd8739ae039 = $40c78c76a2c252ca$var$CardTitle;



"use client";
const $9a7385a7aa1c4a07$var$Card = /*#__PURE__*/ $6cds3.forwardRef(({ bsPrefix: bsPrefix, className: className, bg: bg, text: text, border: border, body: body = false, children: children, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div", ...props }, ref)=>{
    const prefix = (0, $c5d3aca6e909caf5$export$7f387860ebffb32c)(bsPrefix, "card");
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4f9f942c686c93eb$exports)))(className, prefix, bg && `bg-${bg}`, text && `text-${text}`, border && `border-${border}`),
        children: body ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2b986c13a708a6db$export$2e2bcd8739ae039), {
            children: children
        }) : children
    });
});
$9a7385a7aa1c4a07$var$Card.displayName = "Card";
var $9a7385a7aa1c4a07$export$2e2bcd8739ae039 = Object.assign($9a7385a7aa1c4a07$var$Card, {
    Img: (0, $1cab5a27e17b73f0$export$2e2bcd8739ae039),
    Title: (0, $40c78c76a2c252ca$export$2e2bcd8739ae039),
    Subtitle: (0, $0b8bc5fcb7727868$export$2e2bcd8739ae039),
    Body: (0, $2b986c13a708a6db$export$2e2bcd8739ae039),
    Link: (0, $40d5c92eb89a1892$export$2e2bcd8739ae039),
    Text: (0, $ae025746916351fa$export$2e2bcd8739ae039),
    Header: (0, $5394fb92b3e72a0e$export$2e2bcd8739ae039),
    Footer: (0, $f7962ade78f9929b$export$2e2bcd8739ae039),
    ImgOverlay: (0, $21e61cdec2541d20$export$2e2bcd8739ae039)
});



var $6cds3 = parcelRequire("6cds3");

var $aMJGV = parcelRequire("aMJGV");
var $91a47db30da79c21$var$_excluded = [
    "color",
    "size",
    "title"
];
function $91a47db30da79c21$var$_extends() {
    $91a47db30da79c21$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $91a47db30da79c21$var$_extends.apply(this, arguments);
}
function $91a47db30da79c21$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $91a47db30da79c21$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $91a47db30da79c21$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $91a47db30da79c21$var$BookmarkStarFill = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, rest = $91a47db30da79c21$var$_objectWithoutProperties(_ref, $91a47db30da79c21$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("svg", $91a47db30da79c21$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        fillRule: "evenodd",
        d: "M2 15.5V2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.74.439L8 13.069l-5.26 2.87A.5.5 0 0 1 2 15.5M8.16 4.1a.178.178 0 0 0-.32 0l-.634 1.285a.18.18 0 0 1-.134.098l-1.42.206a.178.178 0 0 0-.098.303L6.58 6.993c.042.041.061.1.051.158L6.39 8.565a.178.178 0 0 0 .258.187l1.27-.668a.18.18 0 0 1 .165 0l1.27.668a.178.178 0 0 0 .257-.187L9.368 7.15a.18.18 0 0 1 .05-.158l1.028-1.001a.178.178 0 0 0-.098-.303l-1.42-.206a.18.18 0 0 1-.134-.098z"
    }));
});
$91a47db30da79c21$var$BookmarkStarFill.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string
};
$91a47db30da79c21$var$BookmarkStarFill.defaultProps = {
    color: "currentColor",
    size: "1em",
    title: null
};
var $91a47db30da79c21$export$2e2bcd8739ae039 = $91a47db30da79c21$var$BookmarkStarFill;


var $6cds3 = parcelRequire("6cds3");

var $aMJGV = parcelRequire("aMJGV");
var $4051d8d4e84b1401$var$_excluded = [
    "color",
    "size",
    "title"
];
function $4051d8d4e84b1401$var$_extends() {
    $4051d8d4e84b1401$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4051d8d4e84b1401$var$_extends.apply(this, arguments);
}
function $4051d8d4e84b1401$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $4051d8d4e84b1401$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $4051d8d4e84b1401$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $4051d8d4e84b1401$var$BookmarkStar = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, rest = $4051d8d4e84b1401$var$_objectWithoutProperties(_ref, $4051d8d4e84b1401$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("svg", $4051d8d4e84b1401$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "M7.84 4.1a.178.178 0 0 1 .32 0l.634 1.285a.18.18 0 0 0 .134.098l1.42.206c.145.021.204.2.098.303L9.42 6.993a.18.18 0 0 0-.051.158l.242 1.414a.178.178 0 0 1-.258.187l-1.27-.668a.18.18 0 0 0-.165 0l-1.27.668a.178.178 0 0 1-.257-.187l.242-1.414a.18.18 0 0 0-.05-.158l-1.03-1.001a.178.178 0 0 1 .098-.303l1.42-.206a.18.18 0 0 0 .134-.098z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1z"
    }));
});
$4051d8d4e84b1401$var$BookmarkStar.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string
};
$4051d8d4e84b1401$var$BookmarkStar.defaultProps = {
    color: "currentColor",
    size: "1em",
    title: null
};
var $4051d8d4e84b1401$export$2e2bcd8739ae039 = $4051d8d4e84b1401$var$BookmarkStar;




function $1b8985cc0d82b13f$var$Networks(props) {
    const { networks: networks, favourites: favourites } = props;
    const [filter, setFilter] = (0, $6cds3.useState)({
        keywords: "",
        group: "favourites"
    });
    const [results, setResults] = (0, $6cds3.useState)([]);
    (0, $6cds3.useEffect)(()=>{
        let filtered = filteredNetworks(networks, filter);
        let group = filter.group;
        while(filtered.length < 1 && group !== "all"){
            group = "all";
            filtered = filteredNetworks(networks, {
                ...filter,
                group: group
            });
            if (filtered.length > 0 || group === "all") return setFilter({
                ...filter,
                group: group
            });
        }
        setResults(filtered);
    }, [
        networks,
        filter
    ]);
    function filterNetworks(event) {
        setFilter({
            ...filter,
            keywords: event.target.value
        });
    }
    function filteredNetworks(networks, filter) {
        let searchResults = networks;
        const { keywords: keywords, group: group } = filter;
        switch(group){
            case "favourites":
                searchResults = searchResults.filter((network)=>favourites.includes(network.path));
                break;
        }
        if (!keywords || keywords === "") return searchResults;
        const searcher = new (0, $69a568a3ebbe1e4c$export$2e2bcd8739ae039)(searchResults, [
            "prettyName",
            "keywords"
        ], {
            sort: true
        });
        return searcher.search(keywords);
    }
    async function changeNetwork(network) {
        if (!network.online) return;
        await network.load();
        await network.connect();
        props.changeNetwork(network);
    }
    function toggleFavourite(network) {
        props.toggleFavourite(network);
    }
    function renderFavourite(network) {
        const favourited = favourites.includes(network.path);
        const className = "text-success favourite-" + (favourited ? "on" : "off");
        return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
            className: className,
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $91a47db30da79c21$export$2e2bcd8739ae039), {
                    width: 20,
                    height: 20,
                    className: "on"
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4051d8d4e84b1401$export$2e2bcd8739ae039), {
                    width: 20,
                    height: 20,
                    className: "off"
                })
            ]
        });
    }
    function renderNetworks(networks, opts) {
        return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $d393be44ad07b2ae$export$2e2bcd8739ae039), {
            xs: 1,
            sm: 2,
            lg: 3,
            xxl: 4,
            className: "g-4 justify-content-center",
            children: networks.map((network)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $08ac016305091294$export$2e2bcd8739ae039), {
                    className: network.online ? "" : "opacity-50",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $9a7385a7aa1c4a07$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                onClick: ()=>toggleFavourite(network),
                                role: "button",
                                className: "text-right position-absolute top-0 end-0 py-1 px-2",
                                style: {
                                    zIndex: 2
                                },
                                children: renderFavourite(network)
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                role: network.online ? "button" : "",
                                className: "stretched-link",
                                onClick: ()=>changeNetwork(network),
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $d393be44ad07b2ae$export$2e2bcd8739ae039), {
                                    className: "g-0",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $08ac016305091294$export$2e2bcd8739ae039), {
                                            xs: 3,
                                            className: "text-center",
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a1ed1e534eec315a$export$2e2bcd8739ae039), {
                                                network: network,
                                                width: 60,
                                                height: 60,
                                                className: "m-2 shadow overflow-hidden rounded-circle"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $08ac016305091294$export$2e2bcd8739ae039), {
                                            xs: 9,
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $9a7385a7aa1c4a07$export$2e2bcd8739ae039).Body, {
                                                children: [
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9a7385a7aa1c4a07$export$2e2bcd8739ae039).Title, {
                                                        className: "text-truncate",
                                                        children: network.prettyName
                                                    }),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $98ff89a109cb64fc$export$2e2bcd8739ae039), {
                                                        network: network,
                                                        className: "small",
                                                        skipConnected: true,
                                                        style: {
                                                            position: "relative",
                                                            zIndex: 2
                                                        }
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }, network.path))
        });
    }
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: "d-flex flex-nowrap justify-content-center align-items-start mb-3 position-relative",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "flex-fill flex-md-grow-0 me-2 me-md-5 mb-2 mb-md-0",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            className: "input-group",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                    className: "form-control border-right-0 border",
                                    onChange: filterNetworks,
                                    value: filter.keywords,
                                    type: "text",
                                    placeholder: "Search.."
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                    className: "input-group-append",
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                                        className: "btn btn-light text-dark border-left-0 border",
                                        type: "button",
                                        onClick: ()=>setFilter({
                                                ...filter,
                                                keywords: ""
                                            }),
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $ac4c3421df377bd7$export$2e2bcd8739ae039), {})
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "d-lg-flex d-none position-absolute mx-auto justify-content-center align-self-center",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $85f5d0e6280a2ccf$export$2e2bcd8739ae039), {
                            fill: true,
                            variant: "pills",
                            activeKey: filter.group,
                            className: `flex-row${props.modal ? " small" : ""}`,
                            onSelect: (e)=>setFilter({
                                    ...filter,
                                    group: e
                                }),
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $85f5d0e6280a2ccf$export$2e2bcd8739ae039).Item, {
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $85f5d0e6280a2ccf$export$2e2bcd8739ae039).Link, {
                                        eventKey: "favourites",
                                        disabled: filteredNetworks(networks, {
                                            ...filter,
                                            group: "favourites"
                                        }).length < 1,
                                        children: "Favourites"
                                    })
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $85f5d0e6280a2ccf$export$2e2bcd8739ae039).Item, {
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $85f5d0e6280a2ccf$export$2e2bcd8739ae039).Link, {
                                        eventKey: "all",
                                        children: "All Networks"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "d-flex d-lg-none justify-content-end",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("select", {
                            className: "form-select w-auto h-auto d-lg-none",
                            "aria-label": "Network group",
                            value: filter.group,
                            onChange: (e)=>setFilter({
                                    ...filter,
                                    group: e.target.value
                                }),
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                                    value: "favourites",
                                    disabled: filteredNetworks(networks, {
                                        ...filter,
                                        group: "favourites"
                                    }).length < 1,
                                    children: "Favourites"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                                    value: "all",
                                    children: "All"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "flex-fill d-none d-lg-flex justify-content-end"
                    })
                ]
            }),
            renderNetworks(results)
        ]
    });
}
var $1b8985cc0d82b13f$export$2e2bcd8739ae039 = $1b8985cc0d82b13f$var$Networks;




var $6cds3 = parcelRequire("6cds3");

var $c9wMV = parcelRequire("c9wMV");









var $6cds3 = parcelRequire("6cds3");

var $c9wMV = parcelRequire("c9wMV");

var $2KWqD = parcelRequire("2KWqD");






var $c9wMV = parcelRequire("c9wMV");




var $F6P8J = parcelRequire("F6P8J");

var $5zb9p = parcelRequire("5zb9p");



var $c9wMV = parcelRequire("c9wMV");

var $9A55m = parcelRequire("9A55m");




var $5zb9p = parcelRequire("5zb9p");




var $2KWqD = parcelRequire("2KWqD");


function $6a80dd8c03835090$var$createAuthzAuthorizationAminoConverter() {
    return {
        "/cosmos.authz.v1beta1.GenericAuthorization": {
            aminoType: "cosmos-sdk/GenericAuthorization",
            toAmino: (value)=>(0, $e556dc7c9dd62702$exports.GenericAuthorization).decode(value),
            fromAmino: ({ msg: msg })=>(0, $e556dc7c9dd62702$exports.GenericAuthorization).encode((0, $e556dc7c9dd62702$exports.GenericAuthorization).fromPartial({
                    msg: msg
                })).finish()
        },
        "/cosmos.staking.v1beta1.StakeAuthorization": {
            aminoType: "cosmos-sdk/StakeAuthorization",
            toAmino: (value)=>{
                const { allowList: allowList, maxTokens: maxTokens, authorizationType: authorizationType } = (0, $59076e9d218a77a1$exports.StakeAuthorization).decode(value);
                return {
                    Validators: {
                        type: "cosmos-sdk/StakeAuthorization/AllowList",
                        value: {
                            allow_list: allowList
                        }
                    },
                    max_tokens: maxTokens,
                    authorization_type: authorizationType
                };
            },
            fromAmino: ({ allow_list: allow_list, max_tokens: max_tokens, authorization_type: authorization_type })=>(0, $59076e9d218a77a1$exports.StakeAuthorization).encode((0, $59076e9d218a77a1$exports.StakeAuthorization).fromPartial({
                    allowList: allow_list,
                    maxTokens: max_tokens,
                    authorizationType: authorization_type
                })).finish()
        }
    };
}
const $6a80dd8c03835090$var$dateConverter = {
    toAmino (date) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($2KWqD)))(date.seconds.toNumber() * 1000).utc().format();
    },
    fromAmino (date) {
        return {
            seconds: (0, (/*@__PURE__*/$parcel$interopDefault($2KWqD)))(date).unix(),
            nanos: 0
        };
    }
};
function $6a80dd8c03835090$export$b261a15a181896a4() {
    const grantConverter = $6a80dd8c03835090$var$createAuthzAuthorizationAminoConverter();
    return {
        "/cosmos.authz.v1beta1.MsgGrant": {
            aminoType: "cosmos-sdk/MsgGrant",
            toAmino: ({ granter: granter, grantee: grantee, grant: grant })=>{
                const converter = grantConverter[grant.authorization.typeUrl];
                return {
                    granter: granter,
                    grantee: grantee,
                    grant: {
                        authorization: {
                            type: converter.aminoType,
                            value: converter.toAmino(grant.authorization.value)
                        },
                        expiration: $6a80dd8c03835090$var$dateConverter.toAmino(grant.expiration)
                    }
                };
            },
            fromAmino: ({ granter: granter, grantee: grantee, grant: grant })=>{
                const protoType = Object.keys(grantConverter).find((type)=>grantConverter[type].aminoType === grant.authorization.type);
                const converter = grantConverter[protoType];
                return {
                    granter: granter,
                    grantee: grantee,
                    grant: {
                        authorization: {
                            typeUrl: protoType,
                            value: converter.fromAmino(grant.authorization.value)
                        },
                        expiration: $6a80dd8c03835090$var$dateConverter.fromAmino(grant.expiration)
                    }
                };
            }
        },
        "/cosmos.authz.v1beta1.MsgRevoke": {
            aminoType: "cosmos-sdk/MsgRevoke",
            toAmino: ({ granter: granter, grantee: grantee, msgTypeUrl: msgTypeUrl })=>({
                    granter: granter,
                    grantee: grantee,
                    msg_type_url: msgTypeUrl
                }),
            fromAmino: ({ granter: granter, grantee: grantee, msg_type_url: msg_type_url })=>({
                    granter: granter,
                    grantee: grantee,
                    msgTypeUrl: msg_type_url
                })
        }
    };
}
function $6a80dd8c03835090$export$dd0a3f156a9714bc(registry, aminoTypes) {
    return {
        "/cosmos.authz.v1beta1.MsgExec": {
            aminoType: "cosmos-sdk/MsgExec",
            toAmino: ({ grantee: grantee, msgs: msgs })=>({
                    grantee: grantee,
                    msgs: msgs.map(({ typeUrl: typeUrl, value: value })=>{
                        const msgType = registry.lookupType(typeUrl);
                        return aminoTypes.toAmino({
                            typeUrl: typeUrl,
                            value: msgType.decode(value)
                        });
                    })
                }),
            fromAmino: ({ grantee: grantee, msgs: msgs })=>({
                    grantee: grantee,
                    msgs: msgs.map(({ type: type, value: value })=>{
                        const proto = aminoTypes.fromAmino({
                            type: type,
                            value: value
                        });
                        const typeUrl = proto.typeUrl;
                        const msgType = registry.lookupType(typeUrl);
                        return {
                            typeUrl: typeUrl,
                            value: msgType.encode(msgType.fromPartial(proto.value)).finish()
                        };
                    })
                })
        }
    };
}



var $gzLuY = parcelRequire("gzLuY");
var $98afdf262baaac44$require$Buffer = $gzLuY.Buffer;
class $98afdf262baaac44$export$2e2bcd8739ae039 {
    async sign(account, messages, memo, fee) {
        const { chainId: chainId } = this.network;
        const { account_number: accountNumber, sequence: sequence, address: address } = account;
        const txBodyBytes = this.makeBodyBytes(messages, memo);
        let aminoMsgs;
        try {
            aminoMsgs = this.convertToAmino(messages);
        } catch (e) {
            console.log(e);
        }
        if (aminoMsgs && this.signerProvider.signAminoSupport()) {
            // Sign as amino if possible for Ledger and Keplr support
            const signDoc = (0, $111142153d5adf1c$exports.makeSignDoc)(aminoMsgs, fee, chainId, memo, accountNumber, sequence);
            const { signature: signature, signed: signed } = await this.signerProvider.signAmino(address, signDoc);
            const authInfoBytes = await this.makeAuthInfoBytes(account, {
                amount: signed.fee.amount,
                gasLimit: signed.fee.gas
            }, (0, $d422a57cb1210f8b$exports.SignMode).SIGN_MODE_LEGACY_AMINO_JSON);
            return {
                bodyBytes: this.makeBodyBytes(messages, signed.memo),
                authInfoBytes: authInfoBytes,
                signatures: [
                    $98afdf262baaac44$require$Buffer.from(signature.signature, "base64")
                ]
            };
        } else if (this.signerProvider.signDirectSupport()) {
            // Sign using standard protobuf messages
            const authInfoBytes = await this.makeAuthInfoBytes(account, {
                amount: fee.amount,
                gasLimit: fee.gas
            }, (0, $d422a57cb1210f8b$exports.SignMode).SIGN_MODE_DIRECT);
            const signDoc = (0, $eb9a28d0d0241b06$exports.makeSignDoc)(txBodyBytes, authInfoBytes, chainId, accountNumber);
            const { signature: signature, signed: signed } = await this.signerProvider.signDirect(address, signDoc);
            return {
                bodyBytes: signed.bodyBytes,
                authInfoBytes: signed.authInfoBytes,
                signatures: [
                    (0, $5zb9p.fromBase64)(signature.signature)
                ]
            };
        } else throw new Error("Unable to sign message with this wallet/signer");
    }
    async simulate(account, messages, memo, fee) {
        return {
            bodyBytes: this.makeBodyBytes(messages, memo),
            authInfoBytes: await this.makeAuthInfoBytes(account, {
                amount: fee.amount,
                gasLimit: fee.gas
            }, (0, $d422a57cb1210f8b$exports.SignMode).SIGN_MODE_UNSPECIFIED),
            signatures: [
                new Uint8Array()
            ]
        };
    }
    convertToAmino(messages) {
        return messages.map((message)=>{
            if (message.typeUrl.startsWith("/cosmos.authz")) {
                if (!this.network.authzAminoSupport) throw new Error("This chain does not support amino conversion for Authz messages");
                if (this.network.authzAminoGenericOnly && this.signerProvider.signDirectSupport()) throw new Error("This chain does not fully support amino conversion for Authz messages, using signDirect instead");
            }
            if (message.typeUrl === "/cosmos.authz.v1beta1.MsgExec") {
                const execTypes = message.value.msgs.map((msg)=>msg.typeUrl);
                const preventedTypes = execTypes.filter((type)=>this.network.authzAminoExecPreventTypes.some((prevent)=>type.match((0, (/*@__PURE__*/$parcel$interopDefault($c9wMV))).escapeRegExp(prevent))));
                if (preventedTypes.length > 0) throw new Error(`This chain does not support amino conversion for Authz Exec with types: ${preventedTypes.join(", ")}`);
            }
            let aminoMessage = this.aminoTypes.toAmino(message);
            if (this.network.authzAminoLiftedValues) switch(aminoMessage.type){
                case "cosmos-sdk/MsgGrant":
                    aminoMessage = aminoMessage.value;
                    aminoMessage.grant.authorization = aminoMessage.grant.authorization.value;
                    break;
                case "cosmos-sdk/MsgRevoke":
                    aminoMessage = aminoMessage.value;
                    break;
                case "cosmos-sdk/MsgExec":
                    throw new Error("This chain does not support amino conversion for MsgExec");
            }
            return aminoMessage;
        });
    }
    makeBodyBytes(messages, memo) {
        const anyMsgs = messages.map((m)=>this.registry.encodeAsAny(m));
        return (0, $07786b3434b3c544$exports.TxBody).encode((0, $07786b3434b3c544$exports.TxBody).fromPartial({
            messages: anyMsgs,
            memo: memo
        })).finish();
    }
    async makeAuthInfoBytes(account, fee, mode) {
        const { sequence: sequence } = account;
        const accountFromSigner = (await this.signerProvider.getAccounts())[0];
        if (!accountFromSigner) throw new Error("Failed to retrieve account from signer");
        const signerPubkey = accountFromSigner.pubkey;
        return (0, $07786b3434b3c544$exports.AuthInfo).encode({
            signerInfos: [
                {
                    publicKey: {
                        typeUrl: this.pubkeyTypeUrl(account.pub_key),
                        value: (0, $25ad8429c4974c2b$exports.PubKey).encode({
                            key: signerPubkey
                        }).finish()
                    },
                    sequence: (0, (/*@__PURE__*/$parcel$interopDefault($9A55m))).fromNumber(sequence, true),
                    modeInfo: {
                        single: {
                            mode: mode
                        }
                    }
                }
            ],
            fee: (0, $07786b3434b3c544$exports.Fee).fromPartial(fee)
        }).finish();
    }
    pubkeyTypeUrl(pub_key) {
        if (pub_key && pub_key["@type"]) return pub_key["@type"];
        if (this.network.path === "injective") return "/injective.crypto.v1beta1.ethsecp256k1.PubKey";
        if (this.network.slip44 === 60) return "/ethermint.crypto.v1.ethsecp256k1.PubKey";
        return "/cosmos.crypto.secp256k1.PubKey";
    }
    constructor(network, signerProvider){
        this.network = network;
        this.signerProvider = signerProvider;
        this.registry = new (0, $eb9a28d0d0241b06$exports.Registry)((0, $842e3ecb6082807a$exports.defaultRegistryTypes));
        const defaultConverters = {
            ...(0, $6a80dd8c03835090$export$b261a15a181896a4)(),
            ...(0, $842e3ecb6082807a$exports.createBankAminoConverters)(),
            ...(0, $842e3ecb6082807a$exports.createDistributionAminoConverters)(),
            ...(0, $842e3ecb6082807a$exports.createGovAminoConverters)(),
            ...(0, $842e3ecb6082807a$exports.createStakingAminoConverters)(this.network.prefix),
            ...(0, $842e3ecb6082807a$exports.createIbcAminoConverters)(),
            ...(0, $842e3ecb6082807a$exports.createFreegrantAminoConverters)()
        };
        let aminoTypes = new (0, $842e3ecb6082807a$exports.AminoTypes)(defaultConverters);
        this.aminoTypes = new (0, $842e3ecb6082807a$exports.AminoTypes)({
            ...defaultConverters,
            ...(0, $6a80dd8c03835090$export$dd0a3f156a9714bc)(this.registry, aminoTypes)
        });
    }
}


var $330d4c42ac3e87e2$exports = {};
"use strict";
var $330d4c42ac3e87e2$var$__createBinding = $330d4c42ac3e87e2$exports && $330d4c42ac3e87e2$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $330d4c42ac3e87e2$var$__exportStar = $330d4c42ac3e87e2$exports && $330d4c42ac3e87e2$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $330d4c42ac3e87e2$var$__createBinding(exports1, m, p);
};
Object.defineProperty($330d4c42ac3e87e2$exports, "__esModule", {
    value: true
});

$330d4c42ac3e87e2$var$__exportStar((parcelRequire("6cKfH")), $330d4c42ac3e87e2$exports);

$330d4c42ac3e87e2$var$__exportStar((parcelRequire("hg3FK")), $330d4c42ac3e87e2$exports);

$330d4c42ac3e87e2$var$__exportStar((parcelRequire("JBm1g")), $330d4c42ac3e87e2$exports);

$330d4c42ac3e87e2$var$__exportStar((parcelRequire("cufBA")), $330d4c42ac3e87e2$exports);

$330d4c42ac3e87e2$var$__exportStar((parcelRequire("lNUVY")), $330d4c42ac3e87e2$exports);



class $f954f58a88889884$export$2e2bcd8739ae039 extends (0, $98afdf262baaac44$export$2e2bcd8739ae039) {
    convertToAmino(messages) {
        return super.convertToAmino(messages).map((message)=>{
            // Terra uses custom Amino message types, use Terra.js to convert them
            return (0, $330d4c42ac3e87e2$exports.Msg).fromAmino(message).toAmino(true);
        });
    }
}


const $454bdf3eccc48d5c$var$adapters = {
    terra: (0, $f954f58a88889884$export$2e2bcd8739ae039)
};
function $454bdf3eccc48d5c$var$SigningClient(network, signerProvider) {
    const adapter = new ($454bdf3eccc48d5c$var$adapters[network.path] || (0, $98afdf262baaac44$export$2e2bcd8739ae039))(network, signerProvider);
    const { restUrl: restUrl, gasPrice: defaultGasPrice, gasModifier: defaultGasModifier } = network;
    function getAccount(address) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($18d826a12788a23d$exports))).get(restUrl + "/cosmos/auth/v1beta1/accounts/" + address).then((res)=>res.data.account).then((value)=>{
            if (!value) throw new Error("Failed to fetch account, please try again");
            // see https://github.com/chainapsis/keplr-wallet/blob/7ca025d32db7873b7a870e69a4a42b525e379132/packages/cosmos/src/account/index.ts#L73
            // If the chain modifies the account type, handle the case where the account type embeds the base account.
            // (Actually, the only existent case is ethermint, and this is the line for handling ethermint)
            const baseAccount = value.BaseAccount || value.baseAccount || value.base_account;
            if (baseAccount) value = baseAccount;
            // If the account is the vesting account that embeds the base vesting account,
            // the actual base account exists under the base vesting account.
            // But, this can be different according to the version of cosmos-sdk.
            // So, anyway, try to parse it by some ways...
            const baseVestingAccount = value.BaseVestingAccount || value.baseVestingAccount || value.base_vesting_account;
            if (baseVestingAccount) {
                value = baseVestingAccount;
                const baseAccount = value.BaseAccount || value.baseAccount || value.base_account;
                if (baseAccount) value = baseAccount;
            }
            // Handle nested account like Desmos
            const nestedAccount = value.account;
            if (nestedAccount) value = nestedAccount;
            return value;
        }).catch((error)=>{
            var _error_response;
            if (((_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.status) === 404) throw new Error("Account does not exist on chain");
            else throw error;
        });
    }
    // vendored to handle large integers
    // https://github.com/cosmos/cosmjs/blob/0f0c9d8a754cbf01e17acf51d3f2dbdeaae60757/packages/stargate/src/fee.ts
    function calculateFee(gasLimit, gasPrice) {
        const processedGasPrice = typeof gasPrice === "string" ? (0, $842e3ecb6082807a$exports.GasPrice).fromString(gasPrice) : gasPrice;
        const { denom: denom, amount: gasPriceAmount } = processedGasPrice;
        const amount = (0, $ed89d4c20b089b73$export$803ce6b71a0a94b2)((0, $ed89d4c20b089b73$export$8576f72eb7f14a7e)((0, $ed89d4c20b089b73$export$2060d2db72cce88f)((0, $ed89d4c20b089b73$export$8576f72eb7f14a7e)(gasPriceAmount.toString()), (0, $ed89d4c20b089b73$export$8576f72eb7f14a7e)(gasLimit.toString()))));
        return {
            amount: [
                (0, $2a6bf51ee962800d$export$3c9d1e4131afeeb8)(amount, denom)
            ],
            gas: gasLimit.toString()
        };
    }
    function getFee(gas, gasPrice) {
        if (!gas) gas = 200000;
        return calculateFee(gas, gasPrice || defaultGasPrice);
    }
    async function signAndBroadcastWithoutBalanceCheck(address, msgs, gas, memo, gasPrice) {
        const defaultOptions = (0, (/*@__PURE__*/$parcel$interopDefault($c9wMV))).cloneDeep(signerProvider.getOptions());
        signerProvider.setOptions({
            sign: {
                disableBalanceCheck: true
            }
        });
        try {
            return await signAndBroadcast(address, msgs, gas, memo, gasPrice);
        } finally{
            signerProvider.setOptions(defaultOptions);
        }
    }
    async function signAndBroadcast(address, messages, gas, memo, gasPrice) {
        if (!gas) gas = await simulate(address, messages, memo);
        const fee = getFee(gas, gasPrice);
        const txBody = await sign(address, messages, memo, fee);
        return broadcast(txBody);
    }
    async function sign(address, messages, memo, fee) {
        const account = await getAccount(address);
        return adapter.sign(account, messages, memo, fee);
    }
    async function simulate(address, messages, memo, modifier) {
        const account = await getAccount(address);
        const fee = getFee(100000);
        const txBody = await adapter.simulate(account, messages, memo, fee);
        try {
            const estimate = await (0, (/*@__PURE__*/$parcel$interopDefault($18d826a12788a23d$exports))).post(restUrl + "/cosmos/tx/v1beta1/simulate", {
                tx_bytes: (0, $5zb9p.toBase64)((0, $07786b3434b3c544$exports.TxRaw).encode(txBody).finish())
            }).then((el)=>el.data.gas_info.gas_used);
            return parseInt(estimate * (modifier || defaultGasModifier));
        } catch (error) {
            var _error_response_data, _error_response;
            throw new Error(((_error_response = error.response) === null || _error_response === void 0 ? void 0 : (_error_response_data = _error_response.data) === null || _error_response_data === void 0 ? void 0 : _error_response_data.message) || error.message);
        }
    }
    async function broadcast(txBody) {
        const timeoutMs = network.txTimeout || 60000;
        const pollIntervalMs = 3000;
        let timedOut = false;
        const txPollTimeout = setTimeout(()=>{
            timedOut = true;
        }, timeoutMs);
        const pollForTx = async (txId)=>{
            if (timedOut) throw new Error(`Transaction with ID ${txId} was submitted but was not yet found on the chain. You might want to check later. There was a wait of ${timeoutMs / 1000} seconds.`);
            await (0, $F6P8J.sleep)(pollIntervalMs);
            try {
                const response = await (0, (/*@__PURE__*/$parcel$interopDefault($18d826a12788a23d$exports))).get(restUrl + "/cosmos/tx/v1beta1/txs/" + txId);
                const result = parseTxResult(response.data.tx_response);
                return result;
            } catch  {
                return pollForTx(txId);
            }
        };
        const response = await (0, (/*@__PURE__*/$parcel$interopDefault($18d826a12788a23d$exports))).post(restUrl + "/cosmos/tx/v1beta1/txs", {
            tx_bytes: (0, $5zb9p.toBase64)((0, $07786b3434b3c544$exports.TxRaw).encode(txBody).finish()),
            mode: "BROADCAST_MODE_SYNC"
        });
        const result = parseTxResult(response.data.tx_response);
        (0, $842e3ecb6082807a$exports.assertIsDeliverTxSuccess)(result);
        return pollForTx(result.transactionHash).then((value)=>{
            clearTimeout(txPollTimeout);
            (0, $842e3ecb6082807a$exports.assertIsDeliverTxSuccess)(value);
            return value;
        }, (error)=>{
            clearTimeout(txPollTimeout);
            return error;
        });
    }
    function parseTxResult(result) {
        return {
            code: result.code,
            height: result.height,
            rawLog: result.raw_log,
            transactionHash: result.txhash,
            gasUsed: result.gas_used,
            gasWanted: result.gas_wanted
        };
    }
    return {
        signerProvider: signerProvider,
        registry: adapter.registry,
        getFee: getFee,
        simulate: simulate,
        signAndBroadcast: signAndBroadcast,
        signAndBroadcastWithoutBalanceCheck: signAndBroadcastWithoutBalanceCheck
    };
}
var $454bdf3eccc48d5c$export$2e2bcd8739ae039 = $454bdf3eccc48d5c$var$SigningClient;


const $9928af9f183fd222$export$e4d84787c2301878 = [
    "/cosmos.gov.v1beta1.MsgVote",
    "/cosmos.gov.v1beta1.MsgDeposit",
    "/cosmos.gov.v1beta1.MsgSubmitProposal",
    "/cosmos.bank.v1beta1.MsgSend",
    "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
    "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission",
    "/cosmos.staking.v1beta1.MsgDelegate",
    "/cosmos.staking.v1beta1.MsgUndelegate",
    "/cosmos.staking.v1beta1.MsgBeginRedelegate",
    "/cosmos.authz.v1beta1.MsgGrant",
    "/cosmos.authz.v1beta1.MsgRevoke",
    "Custom"
];
class $9928af9f183fd222$var$Wallet {
    async connect() {
        var _this_key;
        this.key = await this.signerProvider.connect(this.network);
        this.name = (_this_key = this.key) === null || _this_key === void 0 ? void 0 : _this_key.name;
        return this.key;
    }
    hasPermission(address, action) {
        if (address === this.address) return true;
        if (!this.authzSupport()) return false;
        let message = $9928af9f183fd222$export$e4d84787c2301878.find((el)=>{
            return el.split(".").slice(-1)[0].replace("Msg", "") === action;
        });
        message = message || action;
        return this.grants.some((grant)=>{
            return grant.granter === address && grant.authorization["@type"] === "/cosmos.authz.v1beta1.GenericAuthorization" && grant.authorization.msg === message;
        });
    }
    authzSupport() {
        if (this.signDirectSupport()) return true;
        if (this.network.authzAminoLiftedValues && !this.signerProvider.authzAminoLiftedValueSupport) return false;
        return this.network.authzAminoSupport && this.signAminoSupport();
    }
    signAminoSupportOnly() {
        return !this.signDirectSupport() && this.signAminoSupport();
    }
    signDirectSupport() {
        return this.signerProvider.signDirectSupport();
    }
    signAminoSupport() {
        return this.signerProvider.signAminoSupport();
    }
    async getAddress() {
        if (!this.address) this.address = await this.signerProvider.getAddress();
        return this.address;
    }
    constructor(network, signerProvider){
        this.network = network;
        this.signerProvider = signerProvider;
        this.grants = [];
    }
}
var $9928af9f183fd222$export$2e2bcd8739ae039 = $9928af9f183fd222$var$Wallet;



function $b1d6f299365b3215$var$GrantModal(props) {
    const { show: show, network: network, address: address, wallet: wallet } = props;
    const walletAuthzSupport = wallet === null || wallet === void 0 ? void 0 : wallet.authzSupport();
    const defaultExpiry = (0, (/*@__PURE__*/$parcel$interopDefault($2KWqD)))().add(1, "year");
    const [loading, setLoading] = (0, $6cds3.useState)(false);
    const [error, setError] = (0, $6cds3.useState)();
    const [state, setState] = (0, $6cds3.useState)({
        maxTokensValue: "",
        expiryDateValue: defaultExpiry.format("YYYY-MM-DD")
    });
    const [showLedger, setShowLedger] = (0, $6cds3.useState)(!walletAuthzSupport);
    const { daemon_name: daemon_name, chain_id: chain_id } = network.chain;
    (0, $6cds3.useEffect)(()=>{
        setState({
            ...state,
            granteeValue: "",
            customGranteeValue: "",
            expiryDateValue: defaultExpiry.format("YYYY-MM-DD"),
            grantTypeValue: "/cosmos.authz.v1beta1.GenericAuthorization",
            messageTypeValue: (0, $9928af9f183fd222$export$e4d84787c2301878)[0],
            customMessageTypeValue: ""
        });
        setShowLedger(!walletAuthzSupport);
        setError(null);
    }, [
        address
    ]);
    function handleInputChange(e) {
        setState({
            ...state,
            [e.target.name]: e.target.value
        });
    }
    function showLoading(isLoading) {
        setLoading(isLoading);
        props.setLoading && props.setLoading(isLoading);
    }
    function messageType() {
        return state.messageTypeValue === "Custom" ? state.customMessageTypeValue : state.messageTypeValue;
    }
    function handleSubmit(event) {
        event.preventDefault();
        if (!address || !walletAuthzSupport || !valid()) return;
        showLoading(true);
        const expiry = (0, (/*@__PURE__*/$parcel$interopDefault($2KWqD)))(state.expiryDateValue);
        const messages = [
            buildGrantMsg(state.grantTypeValue, (0, $e556dc7c9dd62702$exports.GenericAuthorization).encode((0, $e556dc7c9dd62702$exports.GenericAuthorization).fromPartial({
                msg: messageType()
            })).finish(), expiry)
        ];
        console.log(messages);
        props.signingClient.signAndBroadcast(wallet.address, messages).then((result)=>{
            console.log("Successfully broadcasted:", result);
            showLoading(false);
            props.onGrant(grantee(), {
                grantee: grantee(),
                granter: address,
                expiration: expiry,
                authorization: {
                    "@type": state.grantTypeValue,
                    msg: messageType()
                }
            });
        }, (error)=>{
            console.log("Failed to broadcast:", error);
            showLoading(false);
            setError("Failed to broadcast: " + error.message);
        });
    }
    function handleClose() {
        setError(null);
        props.onHide();
    }
    function buildGrantMsg(type, authValue, expiryDate) {
        const value = {
            granter: address,
            grantee: grantee(),
            grant: {
                authorization: {
                    typeUrl: type,
                    value: authValue
                },
                expiration: (0, $d6c3291d6aa8eb5b$exports.Timestamp).fromPartial({
                    seconds: expiryDate.unix(),
                    nanos: 0
                })
            }
        };
        if ((wallet === null || wallet === void 0 ? void 0 : wallet.address) !== address) return (0, $2a6bf51ee962800d$export$61d88097eacac343)(wallet.address, [
            {
                typeUrl: "/cosmos.authz.v1beta1.MsgGrant",
                value: (0, $d189b8fd7c99c4ec$exports.MsgGrant).encode((0, $d189b8fd7c99c4ec$exports.MsgGrant).fromPartial(value)).finish()
            }
        ]);
        else return {
            typeUrl: "/cosmos.authz.v1beta1.MsgGrant",
            value: value
        };
    }
    function grantee() {
        return state.granteeValue === "custom" ? state.customGranteeValue : state.granteeValue;
    }
    function valid() {
        return state.granteeValue && validGrantee() && !!messageType() && (wallet === null || wallet === void 0 ? void 0 : wallet.hasPermission(address, "Grant"));
    }
    function validGrantee() {
        const value = grantee();
        if (!value) return true;
        return !network.prefix || value.startsWith(network.prefix);
    }
    function favourites() {
        return props.favouriteAddresses.filter((el)=>el.address !== props.address);
    }
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $3485727b0a1e4042$export$2e2bcd8739ae039), {
            show: show,
            onHide: handleClose,
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $3485727b0a1e4042$export$2e2bcd8739ae039).Header, {
                    closeButton: true,
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $3485727b0a1e4042$export$2e2bcd8739ae039).Title, {
                        className: "text-truncate pe-4",
                        children: address && !!walletAuthzSupport ? "New Grant" : "CLI/Ledger instructions"
                    })
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $3485727b0a1e4042$export$2e2bcd8739ae039).Body, {
                    children: [
                        error && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $c9bd276a69168a44$export$2e2bcd8739ae039), {
                            variant: "danger",
                            className: "text-break small",
                            children: error
                        }),
                        !address || !walletAuthzSupport && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                children: "Enter your grant details to generate the relevant CLI command."
                            })
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039), {
                            onSubmit: handleSubmit,
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039).Group, {
                                    className: "mb-3",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039).Label, {
                                            children: "Grantee"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("select", {
                                            className: "form-select",
                                            name: "granteeValue",
                                            "aria-label": "Grantee",
                                            value: state.granteeValue,
                                            onChange: handleInputChange,
                                            children: [
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                                                    value: "",
                                                    disabled: true,
                                                    children: "Choose address"
                                                }),
                                                favourites().length > 0 && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("optgroup", {
                                                    label: "Favourites",
                                                    children: favourites().map(({ label: label, address: address })=>{
                                                        if (props.address === address) return null;
                                                        return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                                                            value: address,
                                                            children: label || (0, $2a6bf51ee962800d$export$cd8822fabcdefd67)(address)
                                                        }, address);
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                                                    value: "custom",
                                                    children: "Custom"
                                                })
                                            ]
                                        }),
                                        state.granteeValue === "custom" && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039).Control, {
                                            placeholder: `${network.prefix}1...`,
                                            className: "mt-1",
                                            type: "text",
                                            name: "customGranteeValue",
                                            required: true,
                                            value: state.customGranteeValue,
                                            isInvalid: !validGrantee(),
                                            onChange: handleInputChange
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039).Group, {
                                    className: "mb-3",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039).Label, {
                                            children: "Expiry date"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039).Control, {
                                            type: "date",
                                            name: "expiryDateValue",
                                            min: (0, (/*@__PURE__*/$parcel$interopDefault($2KWqD)))().format("YYYY-MM-DD"),
                                            required: true,
                                            value: state.expiryDateValue,
                                            onChange: handleInputChange
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039).Group, {
                                    className: "mb-3",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039).Label, {
                                            children: "Grant type"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("select", {
                                            className: "form-select",
                                            name: "grantTypeValue",
                                            "aria-label": "Grant type",
                                            value: state.grantTypeValue,
                                            onChange: handleInputChange,
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                                                value: "/cosmos.authz.v1beta1.GenericAuthorization",
                                                children: "GenericAuthorization"
                                            })
                                        })
                                    ]
                                }),
                                state.grantTypeValue === "/cosmos.authz.v1beta1.GenericAuthorization" && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039).Group, {
                                            className: "mb-3",
                                            children: [
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039).Label, {
                                                    children: "Message type"
                                                }),
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("select", {
                                                    className: "form-select",
                                                    name: "messageTypeValue",
                                                    "aria-label": "Message type",
                                                    value: state.messageTypeValue,
                                                    onChange: handleInputChange,
                                                    children: (0, $9928af9f183fd222$export$e4d84787c2301878).map((type)=>{
                                                        return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                                                            value: type,
                                                            children: (0, (/*@__PURE__*/$parcel$interopDefault($c9wMV))).startCase(type.split(".").slice(-1)[0].replace("Msg", ""))
                                                        }, type);
                                                    })
                                                })
                                            ]
                                        }),
                                        state.messageTypeValue === "Custom" && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039).Group, {
                                            className: "mb-3",
                                            children: [
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039).Label, {
                                                    children: "Type URL"
                                                }),
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039).Control, {
                                                    type: "text",
                                                    name: "customMessageTypeValue",
                                                    required: true,
                                                    value: state.customMessageTypeValue,
                                                    onChange: handleInputChange
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                                            children: "Incorrect use of Authz grants can be as dangerous as giving away your mnemonic."
                                        }),
                                        " Make sure you trust the Grantee address and understand the permissions you are granting."
                                    ]
                                }),
                                address && !!walletAuthzSupport && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                                    className: "text-end",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a73f5336dfd04f2d$export$2e2bcd8739ae039), {
                                            variant: "link",
                                            onClick: ()=>setShowLedger(!showLedger),
                                            "aria-controls": "example-collapse-text",
                                            "aria-expanded": showLedger,
                                            children: "CLI command"
                                        }),
                                        !loading ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a73f5336dfd04f2d$export$2e2bcd8739ae039), {
                                            type: "submit",
                                            className: "btn btn-primary ms-2",
                                            disabled: !valid(),
                                            children: "Create grant"
                                        }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $a73f5336dfd04f2d$export$2e2bcd8739ae039), {
                                            className: "btn btn-primary",
                                            type: "button",
                                            disabled: true,
                                            children: [
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                    className: "spinner-border spinner-border-sm",
                                                    role: "status",
                                                    "aria-hidden": "true"
                                                }),
                                                "\xa0"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $004d922d79fe0b8b$export$2e2bcd8739ae039), {
                                    in: showLedger,
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("pre", {
                                        className: "text-wrap",
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("code", {
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                                                children: [
                                                    daemon_name ? daemon_name : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("kbd", {
                                                        children: "<chaind>"
                                                    }),
                                                    " tx authz grant \\",
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("kbd", {
                                                        children: grantee() || "<grantee>"
                                                    }),
                                                    " generic \\",
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                                                    "--msg-type ",
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("kbd", {
                                                        children: messageType()
                                                    }),
                                                    " \\",
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                                                    "--expiration ",
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("kbd", {
                                                        children: (0, (/*@__PURE__*/$parcel$interopDefault($2KWqD)))(state.expiryDateValue).unix()
                                                    }),
                                                    " \\",
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                                                    "--chain-id ",
                                                    chain_id,
                                                    " \\",
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                                                    "--node https://rpc.cosmos.directory:443/",
                                                    network.name,
                                                    " \\",
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                                                    "--gas auto --gas-prices ",
                                                    network.gasPrice,
                                                    " \\",
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                                                    "--gas-adjustment 1.5 \\",
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                                                    "--from ",
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("kbd", {
                                                        children: "my-key"
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
var $b1d6f299365b3215$export$2e2bcd8739ae039 = $b1d6f299365b3215$var$GrantModal;



parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");

var $aMJGV = parcelRequire("aMJGV");
var $05f2de82034c82a2$var$_excluded = [
    "color",
    "size",
    "title"
];
function $05f2de82034c82a2$var$_extends() {
    $05f2de82034c82a2$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $05f2de82034c82a2$var$_extends.apply(this, arguments);
}
function $05f2de82034c82a2$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $05f2de82034c82a2$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $05f2de82034c82a2$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $05f2de82034c82a2$var$BookmarkPlusFill = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, rest = $05f2de82034c82a2$var$_objectWithoutProperties(_ref, $05f2de82034c82a2$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("svg", $05f2de82034c82a2$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        fillRule: "evenodd",
        d: "M2 15.5V2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.74.439L8 13.069l-5.26 2.87A.5.5 0 0 1 2 15.5m6.5-11a.5.5 0 0 0-1 0V6H6a.5.5 0 0 0 0 1h1.5v1.5a.5.5 0 0 0 1 0V7H10a.5.5 0 0 0 0-1H8.5z"
    }));
});
$05f2de82034c82a2$var$BookmarkPlusFill.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string
};
$05f2de82034c82a2$var$BookmarkPlusFill.defaultProps = {
    color: "currentColor",
    size: "1em",
    title: null
};
var $05f2de82034c82a2$export$2e2bcd8739ae039 = $05f2de82034c82a2$var$BookmarkPlusFill;


var $6cds3 = parcelRequire("6cds3");

var $aMJGV = parcelRequire("aMJGV");
var $2fb52149aef87594$var$_excluded = [
    "color",
    "size",
    "title"
];
function $2fb52149aef87594$var$_extends() {
    $2fb52149aef87594$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2fb52149aef87594$var$_extends.apply(this, arguments);
}
function $2fb52149aef87594$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $2fb52149aef87594$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $2fb52149aef87594$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $2fb52149aef87594$var$BookmarkPlus = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, rest = $2fb52149aef87594$var$_objectWithoutProperties(_ref, $2fb52149aef87594$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("svg", $2fb52149aef87594$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "M8 4a.5.5 0 0 1 .5.5V6H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V7H6a.5.5 0 0 1 0-1h1.5V4.5A.5.5 0 0 1 8 4"
    }));
});
$2fb52149aef87594$var$BookmarkPlus.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string
};
$2fb52149aef87594$var$BookmarkPlus.defaultProps = {
    color: "currentColor",
    size: "1em",
    title: null
};
var $2fb52149aef87594$export$2e2bcd8739ae039 = $2fb52149aef87594$var$BookmarkPlus;



function $ae24f4fe768ad0c2$var$Favourite(props) {
    const { favourites: favourites, value: value, toggle: toggle, label: label } = props;
    const key = props.key || "address";
    const favourited = favourites.some((el)=>el[key] === value);
    const className = `${props.className} favourite-${favourited ? "on" : "off"}`;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc7c852c832d97ac$export$2e2bcd8739ae039), {
        tooltip: `${favourited ? "Remove saved address" : "Save address"}`,
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
            role: "button",
            onClick: ()=>toggle(value, label),
            className: className,
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $05f2de82034c82a2$export$2e2bcd8739ae039), {
                    width: 20,
                    height: 20,
                    className: "on"
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2fb52149aef87594$export$2e2bcd8739ae039), {
                    width: 20,
                    height: 20,
                    className: "off"
                })
            ]
        })
    });
}
var $ae24f4fe768ad0c2$export$2e2bcd8739ae039 = $ae24f4fe768ad0c2$var$Favourite;




function $ca2b4419ac054a4c$var$Grants(props) {
    var _props_wallet;
    const { address: address, wallet: wallet, network: network, operators: operators, validators: validators, grants: grants } = props;
    const [error, setError] = (0, $6cds3.useState)();
    const [showModal, setShowModal] = (0, $6cds3.useState)();
    const [grantsLoading, setGrantLoading] = (0, $6cds3.useReducer)((grantsLoading, newGrantsLoading)=>({
            ...grantsLoading,
            ...newGrantsLoading
        }), {});
    const [filter, setFilter] = (0, $6cds3.useState)({
        keywords: "",
        group: "granter"
    });
    const [results, setResults] = (0, $6cds3.useState)([]);
    const walletAuthzSupport = (_props_wallet = props.wallet) === null || _props_wallet === void 0 ? void 0 : _props_wallet.authzSupport();
    (0, $6cds3.useEffect)(()=>{
        if (!grants) return;
        let filtered = filteredGrants(grants, filter);
        let group = filter.group;
        while(filtered.length < 1 && group !== "grantee"){
            group = "grantee";
            filtered = filteredGrants(grants, {
                ...filter,
                group: group
            });
            if (filtered.length > 0 || group === "all") return setFilter({
                ...filter,
                group: group
            });
        }
        setResults(filtered);
    }, [
        grants,
        filter
    ]);
    function sortGrants(grants) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($c9wMV))).sortBy(grants, ({ expiration: expiration })=>{
            return new Date(expiration);
        });
    }
    function filterGrants(event) {
        setFilter({
            ...filter,
            keywords: event.target.value
        });
    }
    function filteredGrants(grants, filter) {
        let searchResults = grants;
        const { keywords: keywords, group: group } = filter;
        searchResults = filterByGroup(searchResults, group);
        if (!keywords || keywords === "") return sortGrants(searchResults);
        const searcher = new (0, $69a568a3ebbe1e4c$export$2e2bcd8739ae039)(searchResults, [
            "grantee",
            "granter",
            "authorization.@type",
            "authorization.msg"
        ], {
            sort: true
        });
        return searcher.search(keywords);
    }
    function filterByGroup(grants, group) {
        switch(group){
            case "grantee":
                grants = grants.grantee;
                break;
            case "granter":
                grants = grants.granter;
                break;
        }
        return grants;
    }
    function validatorForGrantAddress(grantAddress) {
        const operator = operators.find((el)=>el.botAddress === grantAddress);
        if (!operator) return null;
        return validators[operator.address];
    }
    function renderGrantData(grant) {
        const maxTokens = grant.authorization.max_tokens;
        switch(grant.authorization["@type"]){
            case "/cosmos.staking.v1beta1.StakeAuthorization":
                const restrictionType = grant.authorization.allow_list ? "Validators" : "Denied Validators";
                const restrictionList = grant.authorization.allow_list || grant.authorization.deny_list;
                return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("small", {
                    children: [
                        "Maximum: ",
                        maxTokens ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $edd3c36e8c82dfd7$export$2e2bcd8739ae039), {
                            coins: maxTokens,
                            asset: network.baseAsset,
                            fullPrecision: true,
                            hideValue: true
                        }) : "unlimited",
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                        restrictionType,
                        ": ",
                        restrictionList.address.map((address)=>{
                            const validator = validators[address];
                            return address ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                children: (validator === null || validator === void 0 ? void 0 : validator.moniker) || /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9c3e840bb4db5007$export$2e2bcd8739ae039), {
                                    address: address
                                })
                            }, address) : null;
                        })
                    ]
                });
            case "/cosmos.authz.v1beta1.GenericAuthorization":
                return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("small", {
                    children: [
                        "Message: ",
                        grant.authorization.msg.split(".").slice(-1)[0]
                    ]
                });
        }
    }
    function closeModal() {
        setShowModal(false);
    }
    function onGrant(grantee, grant) {
        setError(false);
        closeModal();
        props.onGrant(grantee, grant);
    }
    function onRevoke(grantee, msgTypes) {
        setError(false);
        props.onRevoke(grantee, msgTypes);
    }
    function renderGrant(grant) {
        const { granter: granter, grantee: grantee, authorization: authorization, expiration: expiration } = grant;
        const validator = filter.group === "granter" && validatorForGrantAddress(grant.grantee);
        const favourite = props.favouriteAddresses && props.favouriteAddresses.find((el)=>el.address === (filter.group === "granter" ? grantee : granter));
        const grantId = `${granter}-${grantee}-${authorization["@type"]}-${authorization.msg}`;
        return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                    className: "text-break",
                    children: filter.group === "grantee" ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        className: "d-flex",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $ae24f4fe768ad0c2$export$2e2bcd8739ae039), {
                                favourites: props.favouriteAddresses,
                                value: granter,
                                toggle: props.toggleFavouriteAddress
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                className: "ps-2",
                                children: (favourite === null || favourite === void 0 ? void 0 : favourite.label) || /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9c3e840bb4db5007$export$2e2bcd8739ae039), {
                                    address: granter
                                })
                            })
                        ]
                    }) : validator ? validator.moniker : (favourite === null || favourite === void 0 ? void 0 : favourite.label) || /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9c3e840bb4db5007$export$2e2bcd8739ae039), {
                        address: grantee
                    })
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                    children: authorization["@type"].split(".").slice(-1)[0]
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                    className: "d-none d-lg-table-cell",
                    children: renderGrantData(grant)
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                    className: "d-none d-md-table-cell",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d85ff2c90168cfc4$exports))), {
                        format: "LLL",
                        children: expiration
                    })
                }),
                filter.group === "granter" && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "d-grid gap-2 d-md-flex justify-content-end",
                        children: !grantsLoading[grantId] ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a299f73caa82e67f$export$2e2bcd8739ae039), {
                            address: address,
                            wallet: wallet,
                            grantAddress: grantee,
                            button: true,
                            size: "sm",
                            grants: [
                                grant
                            ],
                            signingClient: props.signingClient,
                            onRevoke: onRevoke,
                            setLoading: (loading)=>setGrantLoading({
                                    [grantId]: loading
                                }),
                            setError: setError
                        }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $a73f5336dfd04f2d$export$2e2bcd8739ae039), {
                            className: "btn-sm btn-danger mr-5",
                            disabled: true,
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                    className: "spinner-border spinner-border-sm",
                                    role: "status",
                                    "aria-hidden": "true"
                                }),
                                "\xa0"
                            ]
                        })
                    })
                })
            ]
        }, grantId);
    }
    if (!grants) return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
        className: "text-center",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $39ebe134e7977f3e$export$2e2bcd8739ae039), {
            animation: "border",
            role: "status",
            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                className: "visually-hidden",
                children: "Loading..."
            })
        })
    });
    const alerts = /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: [
            !props.grantQuerySupport && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $c9bd276a69168a44$export$2e2bcd8739ae039), {
                variant: "warning",
                children: [
                    "Grants cannot be queried on this network yet. ",
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                        role: "button",
                        className: "text-decoration-underline",
                        onClick: props.showFavouriteAddresses,
                        children: "Save addresses"
                    }),
                    " first to see their grants."
                ]
            }),
            props.grantQuerySupport && !walletAuthzSupport && !!props.wallet && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $c9bd276a69168a44$export$2e2bcd8739ae039), {
                variant: "warning",
                dismissible: false,
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                    className: "mb-0",
                    children: (0, $2a6bf51ee962800d$export$9ae6b564c4c11ac)(props.wallet)
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $c9bd276a69168a44$export$2e2bcd8739ae039), {
                message: error
            })
        ]
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: [
            alerts,
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        className: "d-flex flex-wrap justify-content-center align-items-start mb-3 position-relative",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: "d-none d-md-flex me-5",
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                    className: "input-group",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                            className: "form-control border-right-0 border",
                                            onChange: filterGrants,
                                            value: filter.keywords,
                                            type: "text",
                                            placeholder: "Search.."
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                            className: "input-group-append",
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                                                className: "btn btn-light text-dark border-left-0 border",
                                                type: "button",
                                                onClick: ()=>setFilter({
                                                        ...filter,
                                                        keywords: ""
                                                    }),
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $ac4c3421df377bd7$export$2e2bcd8739ae039), {})
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: "w-100 d-flex d-md-none mb-2",
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                    className: "input-group",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                            className: "form-control border-right-0 border",
                                            onChange: filterGrants,
                                            value: filter.keywords,
                                            type: "text",
                                            placeholder: "Search.."
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                            className: "input-group-append",
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                                                className: "btn btn-light text-dark border-left-0 border",
                                                type: "button",
                                                onClick: ()=>setFilter({
                                                        ...filter,
                                                        keywords: ""
                                                    }),
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $ac4c3421df377bd7$export$2e2bcd8739ae039), {})
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: "d-lg-flex d-none position-absolute mx-auto justify-content-center align-self-center",
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $85f5d0e6280a2ccf$export$2e2bcd8739ae039), {
                                    fill: true,
                                    variant: "pills",
                                    activeKey: filter.group,
                                    className: `${props.modal ? " small" : ""}`,
                                    onSelect: (e)=>setFilter({
                                            ...filter,
                                            group: e
                                        }),
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $85f5d0e6280a2ccf$export$2e2bcd8739ae039).Item, {
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $85f5d0e6280a2ccf$export$2e2bcd8739ae039).Link, {
                                                eventKey: "granter",
                                                disabled: filteredGrants(grants, {
                                                    ...filter,
                                                    group: "granter"
                                                }).length < 1,
                                                children: "Granted by me"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $85f5d0e6280a2ccf$export$2e2bcd8739ae039).Item, {
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $85f5d0e6280a2ccf$export$2e2bcd8739ae039).Link, {
                                                eventKey: "grantee",
                                                disabled: filteredGrants(grants, {
                                                    ...filter,
                                                    group: "grantee"
                                                }).length < 1,
                                                children: "Granted to me"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: "d-flex d-lg-none justify-content-center",
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("select", {
                                    className: "form-select w-auto h-auto",
                                    "aria-label": "Grant group",
                                    value: filter.group,
                                    onChange: (e)=>setFilter({
                                            ...filter,
                                            group: e.target.value
                                        }),
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                                            value: "granter",
                                            disabled: filteredGrants(grants, {
                                                ...filter,
                                                group: "granter"
                                            }).length < 1,
                                            children: "Granted by me"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                                            value: "grantee",
                                            disabled: filteredGrants(grants, {
                                                ...filter,
                                                group: "grantee"
                                            }).length < 1,
                                            children: "Granted to me"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: "flex-fill d-flex justify-content-end",
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a73f5336dfd04f2d$export$2e2bcd8739ae039), {
                                    variant: "primary",
                                    disabled: !(wallet === null || wallet === void 0 ? void 0 : wallet.hasPermission(address, "Grant")),
                                    onClick: ()=>setShowModal(true),
                                    children: address && !!walletAuthzSupport ? "New Grant" : "CLI/Ledger Instructions"
                                })
                            })
                        ]
                    }),
                    results.length > 0 && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $36688d56d3c1862c$export$2e2bcd8739ae039), {
                        className: "align-middle table-striped",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("th", {
                                            children: filter.group === "grantee" ? "Granter" : "Grantee"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("th", {
                                            children: "Type"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("th", {
                                            className: "d-none d-lg-table-cell",
                                            children: "Data"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("th", {
                                            className: "d-none d-md-table-cell",
                                            children: "Expiration"
                                        }),
                                        filter.group === "granter" && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("th", {})
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("tbody", {
                                children: results.map((item)=>renderGrant(item))
                            })
                        ]
                    }),
                    results.length < 1 && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                        className: "text-center my-5",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("em", {
                            children: "No grants found"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $b1d6f299365b3215$export$2e2bcd8739ae039), {
                show: showModal,
                network: props.network,
                address: props.address,
                wallet: props.wallet,
                favouriteAddresses: props.favouriteAddresses,
                signingClient: props.signingClient,
                onHide: closeModal,
                onGrant: onGrant
            })
        ]
    });
}
var $ca2b4419ac054a4c$export$2e2bcd8739ae039 = $ca2b4419ac054a4c$var$Grants;





var $6cds3 = parcelRequire("6cds3");

var $c9wMV = parcelRequire("c9wMV");






var $6cds3 = parcelRequire("6cds3");


var $6cds3 = parcelRequire("6cds3");

var $aMJGV = parcelRequire("aMJGV");
var $a6648b30c67faf62$var$_excluded = [
    "color",
    "size",
    "title"
];
function $a6648b30c67faf62$var$_extends() {
    $a6648b30c67faf62$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a6648b30c67faf62$var$_extends.apply(this, arguments);
}
function $a6648b30c67faf62$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a6648b30c67faf62$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a6648b30c67faf62$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $a6648b30c67faf62$var$PlusCircle = /*#__PURE__*/ (0, $6cds3.forwardRef)(function(_ref, ref) {
    var color = _ref.color, size = _ref.size, title = _ref.title, rest = $a6648b30c67faf62$var$_objectWithoutProperties(_ref, $a6648b30c67faf62$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("svg", $a6648b30c67faf62$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        d: "M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"
    }));
});
$a6648b30c67faf62$var$PlusCircle.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($aMJGV))).string
};
$a6648b30c67faf62$var$PlusCircle.defaultProps = {
    color: "currentColor",
    size: "1em",
    title: null
};
var $a6648b30c67faf62$export$2e2bcd8739ae039 = $a6648b30c67faf62$var$PlusCircle;




function $994c8053a485a06f$var$SavedAddresses(props) {
    const { network: network, networks: networks, favouriteAddresses: favouriteAddresses, updateFavouriteAddresses: updateFavouriteAddresses } = props;
    const [newAddress, setNewAddress] = (0, $6cds3.useState)("");
    const [newLabel, setNewLabel] = (0, $6cds3.useState)("");
    const [selectedNetwork, setSelectedNetwork] = (0, $6cds3.useState)(network);
    const networkAddresses = selectedNetwork && favouriteAddresses[selectedNetwork.path] || [];
    (0, $6cds3.useEffect)(()=>{
        setSelectedNetwork(network);
    }, [
        network
    ]);
    function setAddress(address) {
        if (selectedNetwork.path === network.path) props.setAddress(address);
    }
    function updateAddress(address, label) {
        updateFavouriteAddresses({
            ...favouriteAddresses,
            [network.path]: networkAddresses.map((data)=>{
                if (data.address === address) return {
                    ...data,
                    label: label
                };
                return data;
            })
        });
    }
    function removeAddress(address) {
        updateFavouriteAddresses({
            ...favouriteAddresses,
            [network.path]: networkAddresses.filter((data)=>data.address !== address)
        });
    }
    function addAddress(event) {
        event.preventDefault();
        if (!validNewAddress()) return;
        updateFavouriteAddresses({
            ...favouriteAddresses,
            [network.path]: [
                ...networkAddresses,
                {
                    address: newAddress,
                    label: newLabel
                }
            ]
        });
        setNewAddress("");
        setNewLabel("");
    }
    function validNewAddress() {
        return newAddress !== "" && !networkAddresses.some((el)=>el.address === newAddress);
    }
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("select", {
                className: "form-select mb-2",
                "aria-label": "Network",
                value: selectedNetwork === null || selectedNetwork === void 0 ? void 0 : selectedNetwork.path,
                onChange: (e)=>setSelectedNetwork(networks.find((el)=>el.path === e.target.value)),
                children: networks.map((network)=>{
                    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                        value: network.path,
                        children: network.prettyName
                    }, network.path);
                })
            }),
            selectedNetwork && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039), {
                    onSubmit: addAddress,
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $36688d56d3c1862c$export$2e2bcd8739ae039), {
                        className: "align-middle table-striped",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("th", {
                                            children: "Address"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("th", {
                                            children: "Label"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("th", {})
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tbody", {
                                children: [
                                    networkAddresses.map(({ label: label, address: address })=>{
                                        var _props_wallet;
                                        return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                    className: "text-break",
                                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9c3e840bb4db5007$export$2e2bcd8739ae039), {
                                                        address: address,
                                                        onClick: ()=>props.address !== address && setAddress(address),
                                                        as: props.address === address && "strong",
                                                        addressClassName: "flex-fill"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039).Control, {
                                                        size: "sm",
                                                        value: label || "",
                                                        onChange: (e)=>updateAddress(address, e.target.value)
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                                        className: "d-flex justify-content-end align-items-center gap-3",
                                                        children: [
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                                                className: "d-flex flex-column flex-sm-row justify-content-end align-items-center gap-1 gap-sm-2",
                                                                children: [
                                                                    ((_props_wallet = props.wallet) === null || _props_wallet === void 0 ? void 0 : _props_wallet.address) === address && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc7c852c832d97ac$export$2e2bcd8739ae039), {
                                                                        icon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $439c909092c9bb4d$export$2e2bcd8739ae039), {}),
                                                                        identifier: `${address}-wallet`,
                                                                        tooltip: "This is your connected wallet"
                                                                    }),
                                                                    props.address === address && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc7c852c832d97ac$export$2e2bcd8739ae039), {
                                                                        icon: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0d0d1fef9e2b8fcf$export$2e2bcd8739ae039), {}),
                                                                        identifier: `${address}-view`,
                                                                        tooltip: "This is the address you are viewing"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $47cad3b7d9bae545$export$2e2bcd8739ae039), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $47cad3b7d9bae545$export$2e2bcd8739ae039).Toggle, {
                                                                        variant: "secondary",
                                                                        size: "sm",
                                                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f51c8b9ad49a08d3$export$2e2bcd8739ae039), {})
                                                                    }),
                                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $47cad3b7d9bae545$export$2e2bcd8739ae039).Menu, {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $47cad3b7d9bae545$export$2e2bcd8739ae039).Item, {
                                                                                as: "button",
                                                                                disabled: props.address === address,
                                                                                onClick: ()=>setAddress(address),
                                                                                children: props.address === address ? "Viewing address" : "View address"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $47cad3b7d9bae545$export$2e2bcd8739ae039).Item, {
                                                                                as: "button",
                                                                                onClick: ()=>removeAddress(address),
                                                                                children: "Remove saved address"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }, address);
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039).Control, {
                                                    size: "sm",
                                                    placeholder: `${selectedNetwork.prefix}1...`,
                                                    value: newAddress,
                                                    required: true,
                                                    isInvalid: newAddress !== "" && !validNewAddress(),
                                                    onChange: (e)=>setNewAddress(e.target.value)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039).Control, {
                                                    size: "sm",
                                                    placeholder: "Label",
                                                    value: newLabel,
                                                    onChange: (e)=>setNewLabel(e.target.value)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                                    className: "text-end",
                                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $a73f5336dfd04f2d$export$2e2bcd8739ae039), {
                                                        type: "submit",
                                                        variant: "secondary",
                                                        size: "sm",
                                                        children: [
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                                className: "d-none d-lg-inline",
                                                                children: "Add address"
                                                            }),
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a6648b30c67faf62$export$2e2bcd8739ae039), {
                                                                className: "d-inline d-lg-none"
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                children: "Save addresses to easily find and view them, and carry out any granted actions in the REStake UI on their behalf."
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                children: "Select 'View address' for any saved address to enter View mode and see REStake as they would - useful for monitoring other addresses quickly."
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                children: "If a saved address has granted you any permissions, REStake will detect them and enable the relevant features in View mode. This can make it very easy to manage staking and governance for multiple wallets."
            })
        ]
    });
}
var $994c8053a485a06f$export$2e2bcd8739ae039 = $994c8053a485a06f$var$SavedAddresses;


function $80695f04909a9613$var$WalletModal(props) {
    var _props_signerProvider;
    const { show: show, network: network, wallet: wallet, favouriteAddresses: favouriteAddresses } = props;
    const [activeTab, setActiveTab] = (0, $6cds3.useState)(props.activeTab || wallet ? "wallet" : "saved");
    (0, $6cds3.useEffect)(()=>{
        if (props.activeTab && props.activeTab != activeTab) setActiveTab(props.activeTab);
        else if (!props.show) setActiveTab();
    }, [
        props.show
    ]);
    function onHide() {
        props.onHide();
    }
    if (!network) return null;
    // const balances = _.sortBy((props.balances || []).map(balance => {
    const balances = (0, (/*@__PURE__*/$parcel$interopDefault($c9wMV))).sortBy((props.balances || []).filter((el)=>el.denom === network.denom).map((balance)=>{
        const asset = network.assets.find((a)=>{
            var _a_base;
            return ((_a_base = a.base) === null || _a_base === void 0 ? void 0 : _a_base.denom) === balance.denom;
        });
        return {
            ...balance,
            asset: asset
        };
    }), ({ asset: asset })=>{
        var _asset_base;
        if (!asset) return 0;
        if (network.denom === ((_asset_base = asset.base) === null || _asset_base === void 0 ? void 0 : _asset_base.denom)) return -2;
        return -1;
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $3485727b0a1e4042$export$2e2bcd8739ae039), {
            size: "lg",
            show: show,
            onHide: ()=>onHide(),
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $3485727b0a1e4042$export$2e2bcd8739ae039).Header, {
                    closeButton: true,
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $3485727b0a1e4042$export$2e2bcd8739ae039).Title, {
                        children: "Wallet"
                    })
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $3485727b0a1e4042$export$2e2bcd8739ae039).Body, {
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $bf31903d44b6b079$export$2e2bcd8739ae039).Container, {
                        activeKey: activeTab,
                        onSelect: (k)=>setActiveTab(k),
                        id: "wallet-tabs",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $85f5d0e6280a2ccf$export$2e2bcd8739ae039), {
                                variant: "tabs",
                                className: "small mb-3 d-flex",
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $85f5d0e6280a2ccf$export$2e2bcd8739ae039).Item, {
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $85f5d0e6280a2ccf$export$2e2bcd8739ae039).Link, {
                                            role: "button",
                                            eventKey: "wallet",
                                            disabled: !wallet,
                                            children: "Wallet"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $85f5d0e6280a2ccf$export$2e2bcd8739ae039).Item, {
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $85f5d0e6280a2ccf$export$2e2bcd8739ae039).Link, {
                                            role: "button",
                                            eventKey: "saved",
                                            children: "Saved Addresses"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $bf31903d44b6b079$export$2e2bcd8739ae039).Content, {
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $bf31903d44b6b079$export$2e2bcd8739ae039).Pane, {
                                        eventKey: "wallet",
                                        className: "small",
                                        children: wallet && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $36688d56d3c1862c$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tbody", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                                        scope: "row",
                                                                        children: "Wallet Provider"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                                        className: "text-break",
                                                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                                                            className: "d-flex gap-2",
                                                                            children: ((_props_signerProvider = props.signerProvider) === null || _props_signerProvider === void 0 ? void 0 : _props_signerProvider.label) || "None"
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            wallet.name && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                                        scope: "row",
                                                                        children: "Wallet Name"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                                        className: "text-break",
                                                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                                                            className: "d-flex gap-2",
                                                                            children: wallet.name
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                                        scope: "row",
                                                                        children: "Address"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                                        className: "text-break",
                                                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                                                            className: "d-flex gap-2",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $9c3e840bb4db5007$export$2e2bcd8739ae039), {
                                                                                    address: wallet.address
                                                                                }),
                                                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $ae24f4fe768ad0c2$export$2e2bcd8739ae039), {
                                                                                    favourites: favouriteAddresses[network.path] || [],
                                                                                    value: wallet.address,
                                                                                    label: props.address === (wallet === null || wallet === void 0 ? void 0 : wallet.address) && wallet.name,
                                                                                    toggle: props.toggleFavouriteAddress
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                                        scope: "row",
                                                                        children: "Balance"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                                                        className: "text-break",
                                                                        children: balances.map((balance)=>{
                                                                            return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                                                                className: "d-flex align-items-center gap-2",
                                                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $edd3c36e8c82dfd7$export$2e2bcd8739ae039), {
                                                                                    coins: balance,
                                                                                    asset: balance.asset
                                                                                })
                                                                            }, balance.denom);
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                                    className: "d-flex justify-content-end gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a73f5336dfd04f2d$export$2e2bcd8739ae039), {
                                                            variant: "secondary",
                                                            disabled: wallet.address === props.address,
                                                            onClick: ()=>props.setAddress(wallet.address),
                                                            children: wallet.address === props.address ? "Viewing wallet" : "View wallet"
                                                        }),
                                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a73f5336dfd04f2d$export$2e2bcd8739ae039), {
                                                            variant: "primary",
                                                            onClick: ()=>setActiveTab("saved"),
                                                            children: "Saved addresses"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $bf31903d44b6b079$export$2e2bcd8739ae039).Pane, {
                                        eventKey: "saved",
                                        className: "small",
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $994c8053a485a06f$export$2e2bcd8739ae039), {
                                            network: props.network,
                                            networks: props.networks,
                                            address: props.address,
                                            wallet: props.wallet,
                                            favouriteAddresses: props.favouriteAddresses,
                                            updateFavouriteAddresses: props.updateFavouriteAddresses,
                                            setAddress: props.setAddress
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}
var $80695f04909a9613$export$2e2bcd8739ae039 = $80695f04909a9613$var$WalletModal;





var $6cds3 = parcelRequire("6cds3");
parcelRequire("c9wMV");






function $802aa9996099ad6f$var$SendModal(props) {
    const { show: show, network: network, address: address, wallet: wallet } = props;
    const [loading, setLoading] = (0, $6cds3.useState)(false);
    const [error, setError] = (0, $6cds3.useState)();
    const [state, setState] = (0, $6cds3.useState)({
        recipientValue: "",
        customRecipientValue: "",
        memoValue: ""
    });
    const denom = network && network.symbol;
    const step = 1 / (0, $ed89d4c20b089b73$export$9c297f60e22e3389)(10, (network === null || network === void 0 ? void 0 : network.decimals) || 6);
    (0, $6cds3.useEffect)(()=>{
        setState({
            ...state,
            recipientValue: "",
            customRecipientValue: "",
            amountValue: "",
            memoValue: ""
        });
        setError(null);
    }, [
        address
    ]);
    function handleInputChange(e) {
        setState({
            ...state,
            [e.target.name]: e.target.value
        });
    }
    function showLoading(isLoading) {
        setLoading(isLoading);
        props.setLoading && props.setLoading(isLoading);
    }
    function handleSubmit(event) {
        event.preventDefault();
        if (!valid()) return;
        showLoading(true);
        const coinValue = coinAmount();
        const messages = [
            buildSendMsg(address, recipient(), [
                coinValue
            ])
        ];
        console.log(messages);
        props.signingClient.signAndBroadcast(wallet.address, messages, null, state.memoValue).then((result)=>{
            console.log("Successfully broadcasted:", result);
            showLoading(false);
            setState({
                recipientValue: "",
                customRecipientValue: "",
                amountValue: "",
                memoValue: ""
            });
            props.onSend(recipient(), coinValue);
        }, (error)=>{
            console.log("Failed to broadcast:", error);
            showLoading(false);
            setError("Failed to broadcast: " + error.message);
        });
    }
    function handleClose() {
        setError(null);
        props.onHide();
    }
    function buildSendMsg(address, recipient, amount) {
        let message = (0, $2a6bf51ee962800d$export$9df738dbed799d5)((0, $d1741032746595ab$exports.MsgSend), "/cosmos.bank.v1beta1.MsgSend", {
            fromAddress: address,
            toAddress: recipient,
            amount: amount
        }, (wallet === null || wallet === void 0 ? void 0 : wallet.address) !== address);
        if ((wallet === null || wallet === void 0 ? void 0 : wallet.address) !== address) return (0, $2a6bf51ee962800d$export$61d88097eacac343)(wallet.address, [
            message
        ]);
        return message;
    }
    async function setAvailableAmount() {
        setError(null);
        const decimals = (0, $ed89d4c20b089b73$export$9c297f60e22e3389)(10, network.decimals);
        const coinValue = (0, $2a6bf51ee962800d$export$3c9d1e4131afeeb8)((0, $ed89d4c20b089b73$export$2060d2db72cce88f)(props.balance.amount, 0.95), network.denom);
        const message = buildSendMsg(address, recipient(), [
            coinValue
        ]);
        props.signingClient.simulate(wallet.address, [
            message
        ]).then((gas)=>{
            const gasPrice = props.signingClient.getFee(gas).amount[0].amount;
            const amount = (0, $ed89d4c20b089b73$export$cd007d971a5a2143)((0, $ed89d4c20b089b73$export$4e2d2ead65e5f7e3)((0, $ed89d4c20b089b73$export$8576f72eb7f14a7e)(props.balance.amount), gasPrice), decimals);
            setState({
                ...state,
                amountValue: amount > 0 ? amount : 0
            });
        }, (error)=>{
            console.log(error);
            setError(error.message);
        });
    }
    function recipient() {
        return state.recipientValue === "custom" ? state.customRecipientValue : state.recipientValue;
    }
    function coinAmount() {
        if (!state.amountValue) return null;
        const decimals = (0, $ed89d4c20b089b73$export$9c297f60e22e3389)(10, network.decimals);
        const denomAmount = (0, $ed89d4c20b089b73$export$2060d2db72cce88f)(state.amountValue, decimals);
        if (denomAmount > 0) return (0, $2a6bf51ee962800d$export$3c9d1e4131afeeb8)(denomAmount, network.denom);
    }
    function valid() {
        if (!state.recipientValue) return true;
        return validRecipient() && coinAmount() && (wallet === null || wallet === void 0 ? void 0 : wallet.hasPermission(address, "Send"));
    }
    function validAmount() {
        if (!state.amountValue) return true;
        return !!coinAmount();
    }
    function validRecipient() {
        const value = state.recipientValue === "custom" ? state.customRecipientValue : state.recipientValue;
        if (!value) return true;
        return !network.prefix || value.startsWith(network.prefix);
    }
    function favourites() {
        return props.favouriteAddresses.filter((el)=>el.address !== props.address);
    }
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $3485727b0a1e4042$export$2e2bcd8739ae039), {
            show: show,
            onHide: handleClose,
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $3485727b0a1e4042$export$2e2bcd8739ae039).Header, {
                    closeButton: true,
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $3485727b0a1e4042$export$2e2bcd8739ae039).Title, {
                        className: "text-truncate pe-4",
                        children: "Send"
                    })
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $3485727b0a1e4042$export$2e2bcd8739ae039).Body, {
                    children: [
                        error && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $c9bd276a69168a44$export$2e2bcd8739ae039), {
                            variant: "danger",
                            className: "text-break small",
                            children: error
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039), {
                            onSubmit: handleSubmit,
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039).Group, {
                                    className: "mb-3",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039).Label, {
                                            children: "Recipient"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("select", {
                                            className: "form-select",
                                            name: "recipientValue",
                                            "aria-label": "Recipient",
                                            value: state.recipientValue,
                                            onChange: handleInputChange,
                                            children: [
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                                                    value: "",
                                                    disabled: true,
                                                    children: "Choose address"
                                                }),
                                                favourites().length > 0 && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("optgroup", {
                                                    label: "Favourites",
                                                    children: favourites().map(({ label: label, address: address })=>{
                                                        if (props.address === address) return null;
                                                        return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                                                            value: address,
                                                            children: label || (0, $2a6bf51ee962800d$export$cd8822fabcdefd67)(address)
                                                        }, address);
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                                                    value: "custom",
                                                    children: "Custom"
                                                })
                                            ]
                                        }),
                                        state.recipientValue === "custom" && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039).Control, {
                                            placeholder: `${network.prefix}1...`,
                                            className: "mt-1",
                                            type: "text",
                                            name: "customRecipientValue",
                                            required: true,
                                            value: state.customRecipientValue,
                                            isInvalid: !validRecipient(),
                                            onChange: handleInputChange
                                        })
                                    ]
                                }),
                                recipient() && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039).Group, {
                                            className: "mb-3",
                                            children: [
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039).Label, {
                                                    children: "Amount"
                                                }),
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                                    className: "mb-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                                            className: "input-group",
                                                            children: [
                                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039).Control, {
                                                                    name: "amountValue",
                                                                    type: "number",
                                                                    min: 0,
                                                                    step: step,
                                                                    placeholder: "10",
                                                                    required: true,
                                                                    isInvalid: !validAmount(),
                                                                    value: state.amountValue,
                                                                    onChange: handleInputChange
                                                                }),
                                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                                    className: "input-group-text",
                                                                    children: denom
                                                                })
                                                            ]
                                                        }),
                                                        props.balance && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                                            className: "form-text text-end",
                                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("span", {
                                                                role: "button",
                                                                onClick: ()=>setAvailableAmount(),
                                                                children: [
                                                                    "Available: ",
                                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $edd3c36e8c82dfd7$export$2e2bcd8739ae039), {
                                                                        coins: props.balance,
                                                                        asset: network.baseAsset,
                                                                        fullPrecision: true,
                                                                        hideValue: true
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039).Group, {
                                            className: "mb-3",
                                            children: [
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039).Label, {
                                                    children: "Memo"
                                                }),
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5bcc3964c8b09067$export$2e2bcd8739ae039).Control, {
                                                    name: "memoValue",
                                                    as: "textarea",
                                                    rows: 3,
                                                    value: state.memoValue,
                                                    onChange: handleInputChange
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                            className: "text-end",
                                            children: !loading ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $a73f5336dfd04f2d$export$2e2bcd8739ae039), {
                                                type: "submit",
                                                className: "btn btn-primary ms-2",
                                                disabled: !valid(),
                                                children: [
                                                    "Send ",
                                                    coinAmount() && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $edd3c36e8c82dfd7$export$2e2bcd8739ae039), {
                                                        coins: coinAmount(),
                                                        asset: network.baseAsset,
                                                        fullPrecision: true,
                                                        hideValue: true
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $a73f5336dfd04f2d$export$2e2bcd8739ae039), {
                                                className: "btn btn-primary",
                                                type: "button",
                                                disabled: true,
                                                children: [
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                        className: "spinner-border spinner-border-sm",
                                                        role: "status",
                                                        "aria-hidden": "true"
                                                    }),
                                                    "\xa0"
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
var $802aa9996099ad6f$export$2e2bcd8739ae039 = $802aa9996099ad6f$var$SendModal;


function $9dcc00a39e7f7954$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}



var $c9wMV = parcelRequire("c9wMV");

class $d967e091f8d134a2$export$2e2bcd8739ae039 {
    available() {
        return !!this.provider;
    }
    connected() {
        return this.available();
    }
    isLedger() {
        var _this_key, _this_key1;
        return ((_this_key = this.key) === null || _this_key === void 0 ? void 0 : _this_key.isNanoLedger) || ((_this_key1 = this.key) === null || _this_key1 === void 0 ? void 0 : _this_key1.isHardware);
    }
    signDirectSupport() {
        var _this_signer;
        return !!((_this_signer = this.signer) === null || _this_signer === void 0 ? void 0 : _this_signer.signDirect);
    }
    signAminoSupport() {
        var _this_signer;
        return !!((_this_signer = this.signer) === null || _this_signer === void 0 ? void 0 : _this_signer.signAmino);
    }
    async connect(network) {
        this.key = null;
        this.signer = null;
        try {
            await this.enable(network);
            await this.getKey(network);
            await this.getSigner(network);
            return this.key;
        } catch (e) {
            console.log(e);
            if (!this.suggestChainSupport) this.handleEnableError(network, e);
            try {
                await this.suggestChain(network);
                await this.getKey(network);
                await this.getSigner(network);
                return this.key;
            } catch (s) {
                console.log(s);
                this.handleSuggestError(network, e);
            }
        }
    }
    disconnect() {}
    enable(network) {
        const { chainId: chainId } = network;
        return this.provider.enable(chainId);
    }
    async getKey(network) {
        if (!this.key) {
            const { chainId: chainId } = network;
            this.key = await this.provider.getKey(chainId);
        }
        return this.key;
    }
    async getSigner(network) {
        if (!this.signer) {
            const { chainId: chainId } = network;
            this.signer = await this.provider.getOfflineSignerAuto(chainId);
        }
        return this.signer;
    }
    async getAddress() {
        if (this.signer.getAddress) return this.signer.getAddress();
        else {
            const accounts = await this.getAccounts();
            return accounts[0].address;
        }
    }
    getAccounts() {
        return this.signer.getAccounts();
    }
    signDirect(...args) {
        return this.signer.signDirect(...args);
    }
    signAmino(...args) {
        return this.signer.signAmino(...args);
    }
    suggestChain(network) {
        if (this.suggestChainSupport) return this.provider.experimentalSuggestChain(this.suggestChainData(network));
        else throw new Error(`${network.prettyName} (${network.chainId}) is not supported`);
    }
    handleEnableError(network, error) {
        throw error;
    }
    handleSuggestError(network, error) {
        throw error;
    }
    setOptions(options) {
        return {};
    }
    getOptions() {
        return {};
    }
    suggestChainData(network) {
        const currency = {
            coinDenom: network.symbol,
            coinMinimalDenom: network.denom,
            coinDecimals: network.decimals
        };
        if (network.coinGeckoId) currency.coinGeckoId = network.coinGeckoId;
        const data = {
            rpc: network.rpcUrl,
            rest: network.restUrl,
            chainId: network.chainId,
            chainName: network.prettyName,
            stakeCurrency: currency,
            bip44: {
                coinType: network.slip44
            },
            walletUrlForStaking: "https://restake.app/" + network.name,
            bech32Config: {
                bech32PrefixAccAddr: network.prefix,
                bech32PrefixAccPub: network.prefix + "pub",
                bech32PrefixValAddr: network.prefix + "valoper",
                bech32PrefixValPub: network.prefix + "valoperpub",
                bech32PrefixConsAddr: network.prefix + "valcons",
                bech32PrefixConsPub: network.prefix + "valconspub"
            },
            currencies: [
                currency
            ],
            feeCurrencies: [
                {
                    ...currency,
                    gasPriceStep: network.gasPriceStep
                }
            ]
        };
        if (network.data.keplrFeatures) data.features = network.data.keplrFeatures;
        else if (network.slip44 === 60) data.features = [
            "ibc-transfer",
            "ibc-go",
            "eth-address-gen",
            "eth-key-sign"
        ];
        return data;
    }
    constructor(provider){
        (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(this, "suggestChainSupport", true);
        (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(this, "authzAminoLiftedValueSupport", true);
        this.provider = provider;
    }
}


class $843b5e8118d7625d$export$2e2bcd8739ae039 extends (0, $d967e091f8d134a2$export$2e2bcd8739ae039) {
    enable(network) {
        this.setOptions({
            sign: {
                preferNoSetFee: true
            }
        });
        return super.enable(network);
    }
    setOptions(options) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($c9wMV))).merge(this.provider.defaultOptions, options);
    }
    getOptions() {
        return this.provider.defaultOptions;
    }
    constructor(...args){
        super(...args);
        (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(this, "name", "keplr");
        (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(this, "label", "Keplr Extension");
        (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(this, "keychangeEvent", "keplr_keystorechange");
    }
}




class $2de96e54271aad9b$export$2e2bcd8739ae039 extends (0, $d967e091f8d134a2$export$2e2bcd8739ae039) {
    enable(network) {
        const { chainId: chainId } = network;
        return this.provider.connect(chainId);
    }
    suggestChain(network) {
        return this.provider.importZone(this.suggestChainData(network));
    }
    constructor(...args){
        super(...args);
        (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(this, "name", "falcon");
        (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(this, "label", "Falcon Wallet");
        (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(this, "keychangeEvent", "falcon_keystorechange");
    }
}



parcelRequire("c9wMV");

var $ebde00c1b0cc12c6$exports = {};
"use strict";
Object.defineProperty($ebde00c1b0cc12c6$exports, "__esModule", {
    value: true
});
$ebde00c1b0cc12c6$exports.getWindowMetadata = void 0;
var $a0e56578b19ed86c$exports = {};
"use strict";
Object.defineProperty($a0e56578b19ed86c$exports, "__esModule", {
    value: true
});
$a0e56578b19ed86c$exports.getLocalStorage = $a0e56578b19ed86c$exports.getLocalStorageOrThrow = $a0e56578b19ed86c$exports.getCrypto = $a0e56578b19ed86c$exports.getCryptoOrThrow = $a0e56578b19ed86c$exports.getLocation = $a0e56578b19ed86c$exports.getLocationOrThrow = $a0e56578b19ed86c$exports.getNavigator = $a0e56578b19ed86c$exports.getNavigatorOrThrow = $a0e56578b19ed86c$exports.getDocument = $a0e56578b19ed86c$exports.getDocumentOrThrow = $a0e56578b19ed86c$exports.getFromWindowOrThrow = $a0e56578b19ed86c$exports.getFromWindow = void 0;
function $a0e56578b19ed86c$var$getFromWindow(name) {
    let res = undefined;
    if (typeof window !== "undefined" && typeof window[name] !== "undefined") res = window[name];
    return res;
}
$a0e56578b19ed86c$exports.getFromWindow = $a0e56578b19ed86c$var$getFromWindow;
function $a0e56578b19ed86c$var$getFromWindowOrThrow(name) {
    const res = $a0e56578b19ed86c$var$getFromWindow(name);
    if (!res) throw new Error(`${name} is not defined in Window`);
    return res;
}
$a0e56578b19ed86c$exports.getFromWindowOrThrow = $a0e56578b19ed86c$var$getFromWindowOrThrow;
function $a0e56578b19ed86c$var$getDocumentOrThrow() {
    return $a0e56578b19ed86c$var$getFromWindowOrThrow("document");
}
$a0e56578b19ed86c$exports.getDocumentOrThrow = $a0e56578b19ed86c$var$getDocumentOrThrow;
function $a0e56578b19ed86c$var$getDocument() {
    return $a0e56578b19ed86c$var$getFromWindow("document");
}
$a0e56578b19ed86c$exports.getDocument = $a0e56578b19ed86c$var$getDocument;
function $a0e56578b19ed86c$var$getNavigatorOrThrow() {
    return $a0e56578b19ed86c$var$getFromWindowOrThrow("navigator");
}
$a0e56578b19ed86c$exports.getNavigatorOrThrow = $a0e56578b19ed86c$var$getNavigatorOrThrow;
function $a0e56578b19ed86c$var$getNavigator() {
    return $a0e56578b19ed86c$var$getFromWindow("navigator");
}
$a0e56578b19ed86c$exports.getNavigator = $a0e56578b19ed86c$var$getNavigator;
function $a0e56578b19ed86c$var$getLocationOrThrow() {
    return $a0e56578b19ed86c$var$getFromWindowOrThrow("location");
}
$a0e56578b19ed86c$exports.getLocationOrThrow = $a0e56578b19ed86c$var$getLocationOrThrow;
function $a0e56578b19ed86c$var$getLocation() {
    return $a0e56578b19ed86c$var$getFromWindow("location");
}
$a0e56578b19ed86c$exports.getLocation = $a0e56578b19ed86c$var$getLocation;
function $a0e56578b19ed86c$var$getCryptoOrThrow() {
    return $a0e56578b19ed86c$var$getFromWindowOrThrow("crypto");
}
$a0e56578b19ed86c$exports.getCryptoOrThrow = $a0e56578b19ed86c$var$getCryptoOrThrow;
function $a0e56578b19ed86c$var$getCrypto() {
    return $a0e56578b19ed86c$var$getFromWindow("crypto");
}
$a0e56578b19ed86c$exports.getCrypto = $a0e56578b19ed86c$var$getCrypto;
function $a0e56578b19ed86c$var$getLocalStorageOrThrow() {
    return $a0e56578b19ed86c$var$getFromWindowOrThrow("localStorage");
}
$a0e56578b19ed86c$exports.getLocalStorageOrThrow = $a0e56578b19ed86c$var$getLocalStorageOrThrow;
function $a0e56578b19ed86c$var$getLocalStorage() {
    return $a0e56578b19ed86c$var$getFromWindow("localStorage");
}
$a0e56578b19ed86c$exports.getLocalStorage = $a0e56578b19ed86c$var$getLocalStorage;


function $ebde00c1b0cc12c6$var$getWindowMetadata() {
    let doc;
    let loc;
    try {
        doc = $a0e56578b19ed86c$exports.getDocumentOrThrow();
        loc = $a0e56578b19ed86c$exports.getLocationOrThrow();
    } catch (e) {
        return null;
    }
    function getIcons() {
        const links = doc.getElementsByTagName("link");
        const icons = [];
        for(let i = 0; i < links.length; i++){
            const link = links[i];
            const rel = link.getAttribute("rel");
            if (rel) {
                if (rel.toLowerCase().indexOf("icon") > -1) {
                    const href = link.getAttribute("href");
                    if (href) {
                        if (href.toLowerCase().indexOf("https:") === -1 && href.toLowerCase().indexOf("http:") === -1 && href.indexOf("//") !== 0) {
                            let absoluteHref = loc.protocol + "//" + loc.host;
                            if (href.indexOf("/") === 0) absoluteHref += href;
                            else {
                                const path = loc.pathname.split("/");
                                path.pop();
                                const finalPath = path.join("/");
                                absoluteHref += finalPath + "/" + href;
                            }
                            icons.push(absoluteHref);
                        } else if (href.indexOf("//") === 0) {
                            const absoluteUrl = loc.protocol + href;
                            icons.push(absoluteUrl);
                        } else icons.push(href);
                    }
                }
            }
        }
        return icons;
    }
    function getWindowMetadataOfAny(...args) {
        const metaTags = doc.getElementsByTagName("meta");
        for(let i = 0; i < metaTags.length; i++){
            const tag = metaTags[i];
            const attributes = [
                "itemprop",
                "property",
                "name"
            ].map((target)=>tag.getAttribute(target)).filter((attr)=>{
                if (attr) return args.includes(attr);
                return false;
            });
            if (attributes.length && attributes) {
                const content = tag.getAttribute("content");
                if (content) return content;
            }
        }
        return "";
    }
    function getName() {
        let name = getWindowMetadataOfAny("name", "og:site_name", "og:title", "twitter:title");
        if (!name) name = doc.title;
        return name;
    }
    function getDescription() {
        const description = getWindowMetadataOfAny("description", "og:description", "twitter:description", "keywords");
        return description;
    }
    const name = getName();
    const description = getDescription();
    const url = loc.origin;
    const icons = getIcons();
    const meta = {
        description: description,
        url: url,
        icons: icons,
        name: name
    };
    return meta;
}
$ebde00c1b0cc12c6$exports.getWindowMetadata = $ebde00c1b0cc12c6$var$getWindowMetadata;




var $a8i8g = parcelRequire("a8i8g");
var $930acd34d9ee3c02$var$__spreadArrays = undefined && undefined.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
var $930acd34d9ee3c02$export$8fa985da04a86f0 = /** @class */ function() {
    function BrowserInfo(name, version, os) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.type = "browser";
    }
    return BrowserInfo;
}();
var $930acd34d9ee3c02$export$62457c674e0167c0 = /** @class */ function() {
    function NodeInfo(version) {
        this.version = version;
        this.type = "node";
        this.name = "node";
        this.os = $a8i8g.platform;
    }
    return NodeInfo;
}();
var $930acd34d9ee3c02$export$775de176f06fc21 = /** @class */ function() {
    function SearchBotDeviceInfo(name, version, os, bot) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.bot = bot;
        this.type = "bot-device";
    }
    return SearchBotDeviceInfo;
}();
var $930acd34d9ee3c02$export$cb435e1e9f86c1ff = /** @class */ function() {
    function BotInfo() {
        this.type = "bot";
        this.bot = true; // NOTE: deprecated test name instead
        this.name = "bot";
        this.version = null;
        this.os = null;
    }
    return BotInfo;
}();
var $930acd34d9ee3c02$export$7c78fe95a9d9b03e = /** @class */ function() {
    function ReactNativeInfo() {
        this.type = "react-native";
        this.name = "react-native";
        this.version = null;
        this.os = null;
    }
    return ReactNativeInfo;
}();
// tslint:disable-next-line:max-line-length
var $930acd34d9ee3c02$var$SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
var $930acd34d9ee3c02$var$SEARCHBOT_OS_REGEX = /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/;
var $930acd34d9ee3c02$var$REQUIRED_VERSION_PARTS = 3;
var $930acd34d9ee3c02$var$userAgentRules = [
    [
        "aol",
        /AOLShield\/([0-9\._]+)/
    ],
    [
        "edge",
        /Edge\/([0-9\._]+)/
    ],
    [
        "edge-ios",
        /EdgiOS\/([0-9\._]+)/
    ],
    [
        "yandexbrowser",
        /YaBrowser\/([0-9\._]+)/
    ],
    [
        "kakaotalk",
        /KAKAOTALK\s([0-9\.]+)/
    ],
    [
        "samsung",
        /SamsungBrowser\/([0-9\.]+)/
    ],
    [
        "silk",
        /\bSilk\/([0-9._-]+)\b/
    ],
    [
        "miui",
        /MiuiBrowser\/([0-9\.]+)$/
    ],
    [
        "beaker",
        /BeakerBrowser\/([0-9\.]+)/
    ],
    [
        "edge-chromium",
        /EdgA?\/([0-9\.]+)/
    ],
    [
        "chromium-webview",
        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "chrome",
        /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "phantomjs",
        /PhantomJS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "crios",
        /CriOS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "firefox",
        /Firefox\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "fxios",
        /FxiOS\/([0-9\.]+)/
    ],
    [
        "opera-mini",
        /Opera Mini.*Version\/([0-9\.]+)/
    ],
    [
        "opera",
        /Opera\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "opera",
        /OPR\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "ie",
        /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/
    ],
    [
        "ie",
        /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/
    ],
    [
        "ie",
        /MSIE\s(7\.0)/
    ],
    [
        "bb10",
        /BB10;\sTouch.*Version\/([0-9\.]+)/
    ],
    [
        "android",
        /Android\s([0-9\.]+)/
    ],
    [
        "ios",
        /Version\/([0-9\._]+).*Mobile.*Safari.*/
    ],
    [
        "safari",
        /Version\/([0-9\._]+).*Safari/
    ],
    [
        "facebook",
        /FBAV\/([0-9\.]+)/
    ],
    [
        "instagram",
        /Instagram\s([0-9\.]+)/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Mobile/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Gecko\)$/
    ],
    [
        "searchbot",
        $930acd34d9ee3c02$var$SEARCHBOX_UA_REGEX
    ]
];
var $930acd34d9ee3c02$var$operatingSystemRules = [
    [
        "iOS",
        /iP(hone|od|ad)/
    ],
    [
        "Android OS",
        /Android/
    ],
    [
        "BlackBerry OS",
        /BlackBerry|BB10/
    ],
    [
        "Windows Mobile",
        /IEMobile/
    ],
    [
        "Amazon OS",
        /Kindle/
    ],
    [
        "Windows 3.11",
        /Win16/
    ],
    [
        "Windows 95",
        /(Windows 95)|(Win95)|(Windows_95)/
    ],
    [
        "Windows 98",
        /(Windows 98)|(Win98)/
    ],
    [
        "Windows 2000",
        /(Windows NT 5.0)|(Windows 2000)/
    ],
    [
        "Windows XP",
        /(Windows NT 5.1)|(Windows XP)/
    ],
    [
        "Windows Server 2003",
        /(Windows NT 5.2)/
    ],
    [
        "Windows Vista",
        /(Windows NT 6.0)/
    ],
    [
        "Windows 7",
        /(Windows NT 6.1)/
    ],
    [
        "Windows 8",
        /(Windows NT 6.2)/
    ],
    [
        "Windows 8.1",
        /(Windows NT 6.3)/
    ],
    [
        "Windows 10",
        /(Windows NT 10.0)/
    ],
    [
        "Windows ME",
        /Windows ME/
    ],
    [
        "Open BSD",
        /OpenBSD/
    ],
    [
        "Sun OS",
        /SunOS/
    ],
    [
        "Chrome OS",
        /CrOS/
    ],
    [
        "Linux",
        /(Linux)|(X11)/
    ],
    [
        "Mac OS",
        /(Mac_PowerPC)|(Macintosh)/
    ],
    [
        "QNX",
        /QNX/
    ],
    [
        "BeOS",
        /BeOS/
    ],
    [
        "OS/2",
        /OS\/2/
    ]
];
function $930acd34d9ee3c02$export$17b446b869dad473(userAgent) {
    if (!!userAgent) return $930acd34d9ee3c02$export$1184956100eddc3c(userAgent);
    if (typeof document === "undefined" && typeof navigator !== "undefined" && navigator.product === "ReactNative") return new $930acd34d9ee3c02$export$7c78fe95a9d9b03e();
    if (typeof navigator !== "undefined") return $930acd34d9ee3c02$export$1184956100eddc3c(navigator.userAgent);
    return $930acd34d9ee3c02$export$bf2c6630ab904918();
}
function $930acd34d9ee3c02$var$matchUserAgent(ua) {
    // opted for using reduce here rather than Array#first with a regex.test call
    // this is primarily because using the reduce we only perform the regex
    // execution once rather than once for the test and for the exec again below
    // probably something that needs to be benchmarked though
    return ua !== "" && $930acd34d9ee3c02$var$userAgentRules.reduce(function(matched, _a) {
        var browser = _a[0], regex = _a[1];
        if (matched) return matched;
        var uaMatch = regex.exec(ua);
        return !!uaMatch && [
            browser,
            uaMatch
        ];
    }, false);
}
function $930acd34d9ee3c02$export$89ca9f8ca1a50fd5(ua) {
    var data = $930acd34d9ee3c02$var$matchUserAgent(ua);
    return data ? data[0] : null;
}
function $930acd34d9ee3c02$export$1184956100eddc3c(ua) {
    var matchedRule = $930acd34d9ee3c02$var$matchUserAgent(ua);
    if (!matchedRule) return null;
    var name = matchedRule[0], match = matchedRule[1];
    if (name === "searchbot") return new $930acd34d9ee3c02$export$cb435e1e9f86c1ff();
    var versionParts = match[1] && match[1].split(/[._]/).slice(0, 3);
    if (versionParts) {
        if (versionParts.length < $930acd34d9ee3c02$var$REQUIRED_VERSION_PARTS) versionParts = $930acd34d9ee3c02$var$__spreadArrays(versionParts, $930acd34d9ee3c02$var$createVersionParts($930acd34d9ee3c02$var$REQUIRED_VERSION_PARTS - versionParts.length));
    } else versionParts = [];
    var version = versionParts.join(".");
    var os = $930acd34d9ee3c02$export$3070bd282ec37ea8(ua);
    var searchBotMatch = $930acd34d9ee3c02$var$SEARCHBOT_OS_REGEX.exec(ua);
    if (searchBotMatch && searchBotMatch[1]) return new $930acd34d9ee3c02$export$775de176f06fc21(name, version, os, searchBotMatch[1]);
    return new $930acd34d9ee3c02$export$8fa985da04a86f0(name, version, os);
}
function $930acd34d9ee3c02$export$3070bd282ec37ea8(ua) {
    for(var ii = 0, count = $930acd34d9ee3c02$var$operatingSystemRules.length; ii < count; ii++){
        var _a = $930acd34d9ee3c02$var$operatingSystemRules[ii], os = _a[0], regex = _a[1];
        var match = regex.exec(ua);
        if (match) return os;
    }
    return null;
}
function $930acd34d9ee3c02$export$bf2c6630ab904918() {
    var isNode = typeof $a8i8g !== "undefined" && $a8i8g.version;
    return isNode ? new $930acd34d9ee3c02$export$62457c674e0167c0($a8i8g.version.slice(1)) : null;
}
function $930acd34d9ee3c02$var$createVersionParts(count) {
    var output = [];
    for(var ii = 0; ii < count; ii++)output.push("0");
    return output;
}


function $4397f25fd0309dd4$export$dcbc6a021acd8a16(userAgent) {
    return (0, $930acd34d9ee3c02$export$17b446b869dad473)(userAgent);
}
function $4397f25fd0309dd4$export$3070bd282ec37ea8() {
    const env = $4397f25fd0309dd4$export$dcbc6a021acd8a16();
    return env && env.os ? env.os : undefined;
}
function $4397f25fd0309dd4$export$a11b0059900ceec8() {
    const os = $4397f25fd0309dd4$export$3070bd282ec37ea8();
    return os ? os.toLowerCase().includes("android") : false;
}
function $4397f25fd0309dd4$export$fedb369cb70207f1() {
    const os = $4397f25fd0309dd4$export$3070bd282ec37ea8();
    return os ? os.toLowerCase().includes("ios") || os.toLowerCase().includes("mac") && navigator.maxTouchPoints > 1 : false;
}
function $4397f25fd0309dd4$export$d0a8044dce8ff2fc() {
    const os = $4397f25fd0309dd4$export$3070bd282ec37ea8();
    return os ? $4397f25fd0309dd4$export$a11b0059900ceec8() || $4397f25fd0309dd4$export$fedb369cb70207f1() : false;
}
function $4397f25fd0309dd4$export$8ee0fc9ee280b4ee() {
    const env = $4397f25fd0309dd4$export$dcbc6a021acd8a16();
    const result = env && env.name ? env.name.toLowerCase() === "node" : false;
    return result;
}
function $4397f25fd0309dd4$export$4e09c449d6c407f7() {
    const result = !$4397f25fd0309dd4$export$8ee0fc9ee280b4ee() && !!$4397f25fd0309dd4$export$a56241c767c1d89f();
    return result;
}
const $4397f25fd0309dd4$export$25be0381df63ebd5 = $a0e56578b19ed86c$exports.getFromWindow;
const $4397f25fd0309dd4$export$c85f9b510b4fe84c = $a0e56578b19ed86c$exports.getFromWindowOrThrow;
const $4397f25fd0309dd4$export$e7811bb19a3a9eaa = $a0e56578b19ed86c$exports.getDocumentOrThrow;
const $4397f25fd0309dd4$export$f65ca476c09acec0 = $a0e56578b19ed86c$exports.getDocument;
const $4397f25fd0309dd4$export$95e1d39c71d5b00f = $a0e56578b19ed86c$exports.getNavigatorOrThrow;
const $4397f25fd0309dd4$export$a56241c767c1d89f = $a0e56578b19ed86c$exports.getNavigator;
const $4397f25fd0309dd4$export$37148d9b63a38297 = $a0e56578b19ed86c$exports.getLocationOrThrow;
const $4397f25fd0309dd4$export$e7fd20fad3cf4b5f = $a0e56578b19ed86c$exports.getLocation;
const $4397f25fd0309dd4$export$5241e685605f5490 = $a0e56578b19ed86c$exports.getCryptoOrThrow;
const $4397f25fd0309dd4$export$e003cc239f955cb6 = $a0e56578b19ed86c$exports.getCrypto;
const $4397f25fd0309dd4$export$dfe7ad38c072b863 = $a0e56578b19ed86c$exports.getLocalStorageOrThrow;
const $4397f25fd0309dd4$export$d3720feff416e85b = $a0e56578b19ed86c$exports.getLocalStorage;
function $4397f25fd0309dd4$export$2d100c5be8d65eb6() {
    return $ebde00c1b0cc12c6$exports.getWindowMetadata();
}


function $f6693945620c7b84$export$84137bb44359aed5(value) {
    if (typeof value !== "string") throw new Error(`Cannot safe json parse value of type ${typeof value}`);
    try {
        return JSON.parse(value);
    } catch (_a) {
        return value;
    }
}
function $f6693945620c7b84$export$abc3f407e87918a4(value) {
    return typeof value === "string" ? value : JSON.stringify(value);
}


const $f39399cf9c45db6d$export$84137bb44359aed5 = $f6693945620c7b84$export$84137bb44359aed5;
const $f39399cf9c45db6d$export$abc3f407e87918a4 = $f6693945620c7b84$export$abc3f407e87918a4;




function $5ba673e8a8315e9b$export$95b8dcaf726c617c(key, data) {
    const raw = (0, $f39399cf9c45db6d$export$abc3f407e87918a4)(data);
    const local = (0, $4397f25fd0309dd4$export$d3720feff416e85b)();
    if (local) local.setItem(key, raw);
}
function $5ba673e8a8315e9b$export$36f42a3d63632e68(key) {
    let data = null;
    let raw = null;
    const local = (0, $4397f25fd0309dd4$export$d3720feff416e85b)();
    if (local) raw = local.getItem(key);
    data = raw ? (0, $f39399cf9c45db6d$export$84137bb44359aed5)(raw) : raw;
    return data;
}
function $5ba673e8a8315e9b$export$1609d3fefbbf941f(key) {
    const local = (0, $4397f25fd0309dd4$export$d3720feff416e85b)();
    if (local) local.removeItem(key);
}



const $07fea8146e621393$export$102966ddb8cb050 = "WALLETCONNECT_DEEPLINK_CHOICE";
function $07fea8146e621393$export$bcf1e30d9b1e22a(uri, entry) {
    const encodedUri = encodeURIComponent(uri);
    return entry.universalLink ? `${entry.universalLink}/wc?uri=${encodedUri}` : entry.deepLink ? `${entry.deepLink}${entry.deepLink.endsWith(":") ? "//" : "/"}wc?uri=${encodedUri}` : "";
}
function $07fea8146e621393$export$3de1e3477deac8ef(data) {
    const focusUri = data.href.split("?")[0];
    (0, $5ba673e8a8315e9b$export$95b8dcaf726c617c)($07fea8146e621393$export$102966ddb8cb050, Object.assign(Object.assign({}, data), {
        href: focusUri
    }));
}
function $07fea8146e621393$export$db69ac4645f70b86(registry, name) {
    return registry.filter((entry)=>entry.name.toLowerCase().includes(name.toLowerCase()))[0];
}
function $07fea8146e621393$export$d8a522cf118d3893(registry, whitelist) {
    let links = registry;
    if (whitelist) links = whitelist.map((name)=>$07fea8146e621393$export$db69ac4645f70b86(registry, name)).filter(Boolean);
    return links;
}


const $eb6d3fb854fb52a0$var$API_URL = "https://registry.walletconnect.com";
function $eb6d3fb854fb52a0$export$d64c12c3326912dd() {
    return $eb6d3fb854fb52a0$var$API_URL + "/api/v2/wallets";
}
function $eb6d3fb854fb52a0$export$ecc47222fa066b1e() {
    return $eb6d3fb854fb52a0$var$API_URL + "/api/v2/dapps";
}
function $eb6d3fb854fb52a0$export$60e740ac780c3b42(entry, platform = "mobile") {
    var _a;
    return {
        name: entry.name || "",
        shortName: entry.metadata.shortName || "",
        color: entry.metadata.colors.primary || "",
        logo: (_a = entry.image_url.sm) !== null && _a !== void 0 ? _a : "",
        universalLink: entry[platform].universal || "",
        deepLink: entry[platform].native || ""
    };
}
function $eb6d3fb854fb52a0$export$7c943590ffef9dd9(registry, platform = "mobile") {
    return Object.values(registry).filter((entry)=>!!entry[platform].universal || !!entry[platform].native).map((entry)=>$eb6d3fb854fb52a0$export$60e740ac780c3b42(entry, platform));
}




class $88285097bf3611ed$export$2e2bcd8739ae039 extends (0, $d967e091f8d134a2$export$2e2bcd8739ae039) {
    async connect(network) {
        if (this.provider) return super.connect(network);
        else if ((0, $4397f25fd0309dd4$export$d0a8044dce8ff2fc)()) {
            window.location.href = "https://leapcosmoswallet.page.link/HawhyWcCuygLbkvT6";
            throw new Error("Please use the in-app browser to access REStake.");
        }
    }
    available() {
        return !!this.provider || (0, $4397f25fd0309dd4$export$d0a8044dce8ff2fc)();
    }
    constructor(...args){
        super(...args);
        (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(this, "name", "leap");
        (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(this, "label", "Leap Wallet");
        (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(this, "keychangeEvent", "leap_keystorechange");
    }
}




const $b71c237f18518b05$export$c0bad5548e0b6bf1 = [
    "session_request",
    "session_update",
    "exchange_key",
    "connect",
    "disconnect",
    "display_uri",
    "modal_closed",
    "transport_open",
    "transport_close",
    "transport_error"
];
const $b71c237f18518b05$export$9e4c3f5a97a9dcc3 = [
    "eth_sendTransaction",
    "eth_signTransaction",
    "eth_sign",
    "eth_signTypedData",
    "eth_signTypedData_v1",
    "eth_signTypedData_v2",
    "eth_signTypedData_v3",
    "eth_signTypedData_v4",
    "personal_sign",
    "wallet_addEthereumChain",
    "wallet_switchEthereumChain",
    "wallet_getPermissions",
    "wallet_requestPermissions",
    "wallet_registerOnboarding",
    "wallet_watchAsset",
    "wallet_scanQRCode"
];
const $b71c237f18518b05$export$b54b35303430ecbf = [
    "eth_accounts",
    "eth_chainId",
    "net_version"
];
const $b71c237f18518b05$export$5ee9f0819fdedae1 = {
    1: "mainnet",
    3: "ropsten",
    4: "rinkeby",
    5: "goerli",
    42: "kovan"
};



var $icOy8 = parcelRequire("icOy8");
var $c6be14923938ad48$exports = {};
$c6be14923938ad48$exports = $c6be14923938ad48$var$isTypedArray;
$c6be14923938ad48$var$isTypedArray.strict = $c6be14923938ad48$var$isStrictTypedArray;
$c6be14923938ad48$var$isTypedArray.loose = $c6be14923938ad48$var$isLooseTypedArray;
var $c6be14923938ad48$var$toString = Object.prototype.toString;
var $c6be14923938ad48$var$names = {
    "[object Int8Array]": true,
    "[object Int16Array]": true,
    "[object Int32Array]": true,
    "[object Uint8Array]": true,
    "[object Uint8ClampedArray]": true,
    "[object Uint16Array]": true,
    "[object Uint32Array]": true,
    "[object Float32Array]": true,
    "[object Float64Array]": true
};
function $c6be14923938ad48$var$isTypedArray(arr) {
    return $c6be14923938ad48$var$isStrictTypedArray(arr) || $c6be14923938ad48$var$isLooseTypedArray(arr);
}
function $c6be14923938ad48$var$isStrictTypedArray(arr) {
    return arr instanceof Int8Array || arr instanceof Int16Array || arr instanceof Int32Array || arr instanceof Uint8Array || arr instanceof Uint8ClampedArray || arr instanceof Uint16Array || arr instanceof Uint32Array || arr instanceof Float32Array || arr instanceof Float64Array;
}
function $c6be14923938ad48$var$isLooseTypedArray(arr) {
    return $c6be14923938ad48$var$names[$c6be14923938ad48$var$toString.call(arr)];
}


var $35c1040a71f97c1f$exports = {};
/**
 * Convert a typed array to a Buffer without a copy
 *
 * Author:   Feross Aboukhadijeh <https://feross.org>
 * License:  MIT
 *
 * `npm install typedarray-to-buffer`
 */ 
var $gzLuY = parcelRequire("gzLuY");
var $35c1040a71f97c1f$require$Buffer = $gzLuY.Buffer;

var $35c1040a71f97c1f$require$isTypedArray = $c6be14923938ad48$exports.strict;
$35c1040a71f97c1f$exports = function typedarrayToBuffer(arr) {
    if ($35c1040a71f97c1f$require$isTypedArray(arr)) {
        // To avoid a copy, use the typed array's underlying ArrayBuffer to back new Buffer
        var buf = $35c1040a71f97c1f$require$Buffer.from(arr.buffer);
        if (arr.byteLength !== arr.buffer.byteLength) // Respect the "view", i.e. byteOffset and byteLength, without doing a copy
        buf = buf.slice(arr.byteOffset, arr.byteOffset + arr.byteLength);
        return buf;
    } else // Pass through all other types to `Buffer.from`
    return $35c1040a71f97c1f$require$Buffer.from(arr);
};



var $gzLuY = parcelRequire("gzLuY");
var $7551102ca62ff8ae$require$Buffer = $gzLuY.Buffer;
const $7551102ca62ff8ae$var$ENC_HEX = "hex";
const $7551102ca62ff8ae$var$ENC_UTF8 = "utf8";
const $7551102ca62ff8ae$var$ENC_BIN = "binary";
const $7551102ca62ff8ae$var$TYPE_BUFFER = "buffer";
const $7551102ca62ff8ae$var$TYPE_ARRAY = "array";
const $7551102ca62ff8ae$var$TYPE_TYPED_ARRAY = "typed-array";
const $7551102ca62ff8ae$var$TYPE_ARRAY_BUFFER = "array-buffer";
const $7551102ca62ff8ae$var$STRING_ZERO = "0";
function $7551102ca62ff8ae$export$9b5ed7081d0cfa58(buf) {
    return new Uint8Array(buf);
}
function $7551102ca62ff8ae$export$c48fc777188c96e3(buf, prefixed = false) {
    const hex = buf.toString($7551102ca62ff8ae$var$ENC_HEX);
    return prefixed ? $7551102ca62ff8ae$export$c7dec2a5deb37361(hex) : hex;
}
function $7551102ca62ff8ae$export$a4bb1a98a4cc455(buf) {
    return buf.toString($7551102ca62ff8ae$var$ENC_UTF8);
}
function $7551102ca62ff8ae$export$b91271ed380b6df8(buf) {
    return buf.readUIntBE(0, buf.length);
}
function $7551102ca62ff8ae$export$9c29188089200d2b(buf) {
    return $7551102ca62ff8ae$export$42ec9942a5551744($7551102ca62ff8ae$export$9b5ed7081d0cfa58(buf));
}
function $7551102ca62ff8ae$export$1eb84f36023740c(arr) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($35c1040a71f97c1f$exports)))(arr);
}
function $7551102ca62ff8ae$export$9794ce7150434ee(arr, prefixed = false) {
    return $7551102ca62ff8ae$export$c48fc777188c96e3($7551102ca62ff8ae$export$1eb84f36023740c(arr), prefixed);
}
function $7551102ca62ff8ae$export$72f33cf4e661f197(arr) {
    return $7551102ca62ff8ae$export$a4bb1a98a4cc455($7551102ca62ff8ae$export$1eb84f36023740c(arr));
}
function $7551102ca62ff8ae$export$c0c67b67c531aea4(arr) {
    return $7551102ca62ff8ae$export$b91271ed380b6df8($7551102ca62ff8ae$export$1eb84f36023740c(arr));
}
function $7551102ca62ff8ae$export$42ec9942a5551744(arr) {
    return Array.from(arr).map($7551102ca62ff8ae$export$c9248f474737b396).join("");
}
function $7551102ca62ff8ae$export$de4231026bca1594(hex) {
    return $7551102ca62ff8ae$require$Buffer.from($7551102ca62ff8ae$export$999052bd72869f3a(hex), $7551102ca62ff8ae$var$ENC_HEX);
}
function $7551102ca62ff8ae$export$c318328836320ba5(hex) {
    return $7551102ca62ff8ae$export$9b5ed7081d0cfa58($7551102ca62ff8ae$export$de4231026bca1594(hex));
}
function $7551102ca62ff8ae$export$966dea6757c0197(hex) {
    return $7551102ca62ff8ae$export$a4bb1a98a4cc455($7551102ca62ff8ae$export$de4231026bca1594(hex));
}
function $7551102ca62ff8ae$export$d57f2bacc26b4249(hex) {
    return $7551102ca62ff8ae$export$c0c67b67c531aea4($7551102ca62ff8ae$export$c318328836320ba5(hex));
}
function $7551102ca62ff8ae$export$f7e0d8803cecbdc0(hex) {
    return $7551102ca62ff8ae$export$42ec9942a5551744($7551102ca62ff8ae$export$c318328836320ba5(hex));
}
function $7551102ca62ff8ae$export$f93b3fa5fd97a11f(utf8) {
    return $7551102ca62ff8ae$require$Buffer.from(utf8, $7551102ca62ff8ae$var$ENC_UTF8);
}
function $7551102ca62ff8ae$export$161387ce93217b03(utf8) {
    return $7551102ca62ff8ae$export$9b5ed7081d0cfa58($7551102ca62ff8ae$export$f93b3fa5fd97a11f(utf8));
}
function $7551102ca62ff8ae$export$7579354b96718fb8(utf8, prefixed = false) {
    return $7551102ca62ff8ae$export$c48fc777188c96e3($7551102ca62ff8ae$export$f93b3fa5fd97a11f(utf8), prefixed);
}
function $7551102ca62ff8ae$export$33ba5b8909457e3a(utf8) {
    const num = parseInt(utf8, 10);
    $7551102ca62ff8ae$var$assert($7551102ca62ff8ae$var$isDefined(num), "Number can only safely store up to 53 bits");
    return num;
}
function $7551102ca62ff8ae$export$fc75bd64bd7a8cd7(utf8) {
    return $7551102ca62ff8ae$export$42ec9942a5551744($7551102ca62ff8ae$export$161387ce93217b03(utf8));
}
function $7551102ca62ff8ae$export$e6e040540f7cfd7a(num) {
    return $7551102ca62ff8ae$export$2c11125c9e7f7082($7551102ca62ff8ae$export$c9248f474737b396(num));
}
function $7551102ca62ff8ae$export$64b9b7c6df806f78(num) {
    return $7551102ca62ff8ae$export$899bb2a911b65162($7551102ca62ff8ae$export$c9248f474737b396(num));
}
function $7551102ca62ff8ae$export$4e87185b7ecfeec4(num, prefixed) {
    return $7551102ca62ff8ae$export$5c5ae0648719df4e($7551102ca62ff8ae$export$c9248f474737b396(num), prefixed);
}
function $7551102ca62ff8ae$export$a7e25b1a47650b03(num) {
    return `${num}`;
}
function $7551102ca62ff8ae$export$c9248f474737b396(num) {
    const bin = (num >>> 0).toString(2);
    return $7551102ca62ff8ae$export$b167c7a51314f76c(bin);
}
function $7551102ca62ff8ae$export$2c11125c9e7f7082(bin) {
    return $7551102ca62ff8ae$export$1eb84f36023740c($7551102ca62ff8ae$export$899bb2a911b65162(bin));
}
function $7551102ca62ff8ae$export$899bb2a911b65162(bin) {
    return new Uint8Array($7551102ca62ff8ae$export$85373b842352e83f(bin).map((x)=>parseInt(x, 2)));
}
function $7551102ca62ff8ae$export$5c5ae0648719df4e(bin, prefixed) {
    return $7551102ca62ff8ae$export$9794ce7150434ee($7551102ca62ff8ae$export$899bb2a911b65162(bin), prefixed);
}
function $7551102ca62ff8ae$export$af1616afb1dc823(bin) {
    return $7551102ca62ff8ae$export$72f33cf4e661f197($7551102ca62ff8ae$export$899bb2a911b65162(bin));
}
function $7551102ca62ff8ae$export$d510e0b7c8525b6c(bin) {
    return $7551102ca62ff8ae$export$c0c67b67c531aea4($7551102ca62ff8ae$export$899bb2a911b65162(bin));
}
function $7551102ca62ff8ae$export$d6860093d88e7e64(str) {
    if (typeof str !== "string" || !new RegExp(/^[01]+$/).test(str)) return false;
    if (str.length % 8 !== 0) return false;
    return true;
}
function $7551102ca62ff8ae$export$b02a40aff8e4ad18(str, length) {
    if (typeof str !== "string" || !str.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (length && str.length !== 2 + 2 * length) return false;
    return true;
}
function $7551102ca62ff8ae$export$a7884ebc965f8f54(val) {
    return $7551102ca62ff8ae$require$Buffer.isBuffer(val);
}
function $7551102ca62ff8ae$export$b119cc7e1840e59c(val) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($c6be14923938ad48$exports))).strict(val) && !$7551102ca62ff8ae$export$a7884ebc965f8f54(val);
}
function $7551102ca62ff8ae$export$9dd3754ae86f0017(val) {
    return !$7551102ca62ff8ae$export$b119cc7e1840e59c(val) && !$7551102ca62ff8ae$export$a7884ebc965f8f54(val) && typeof val.byteLength !== "undefined";
}
function $7551102ca62ff8ae$export$e2b5c5db9e2009fd(val) {
    if ($7551102ca62ff8ae$export$a7884ebc965f8f54(val)) return $7551102ca62ff8ae$var$TYPE_BUFFER;
    else if ($7551102ca62ff8ae$export$b119cc7e1840e59c(val)) return $7551102ca62ff8ae$var$TYPE_TYPED_ARRAY;
    else if ($7551102ca62ff8ae$export$9dd3754ae86f0017(val)) return $7551102ca62ff8ae$var$TYPE_ARRAY_BUFFER;
    else if (Array.isArray(val)) return $7551102ca62ff8ae$var$TYPE_ARRAY;
    else return typeof val;
}
function $7551102ca62ff8ae$export$badc544e0651b6b1(str) {
    if ($7551102ca62ff8ae$export$d6860093d88e7e64(str)) return $7551102ca62ff8ae$var$ENC_BIN;
    if ($7551102ca62ff8ae$export$b02a40aff8e4ad18(str)) return $7551102ca62ff8ae$var$ENC_HEX;
    return $7551102ca62ff8ae$var$ENC_UTF8;
}
function $7551102ca62ff8ae$export$28e250f55413be00(...args) {
    const result = $7551102ca62ff8ae$require$Buffer.concat(args);
    return result;
}
function $7551102ca62ff8ae$export$e989d07ee174d99d(...args) {
    let result = [];
    args.forEach((arg)=>result = result.concat(Array.from(arg)));
    return new Uint8Array([
        ...result
    ]);
}
function $7551102ca62ff8ae$export$c5557f40488c48ec(data, length) {
    const diff = data.length - length;
    if (diff > 0) data = data.slice(diff);
    return data;
}
function $7551102ca62ff8ae$export$da8e5da96e287379(data, length) {
    return data.slice(0, length);
}
function $7551102ca62ff8ae$export$7d00ccbd2e7529cf(length, byteSize = 8) {
    const remainder = length % byteSize;
    return remainder ? (length - remainder) / byteSize * byteSize + byteSize : length;
}
function $7551102ca62ff8ae$export$85373b842352e83f(str, byteSize = 8) {
    const bytes = $7551102ca62ff8ae$export$b167c7a51314f76c(str).match(new RegExp(`.{${byteSize}}`, "gi"));
    return Array.from(bytes || []);
}
function $7551102ca62ff8ae$export$df453304795155df(str) {
    return $7551102ca62ff8ae$export$85373b842352e83f(str).map($7551102ca62ff8ae$var$reverseString).join("");
}
function $7551102ca62ff8ae$export$26429bcac30c76e(str) {
    return $7551102ca62ff8ae$export$5c5ae0648719df4e($7551102ca62ff8ae$export$df453304795155df($7551102ca62ff8ae$export$f7e0d8803cecbdc0(str)));
}
function $7551102ca62ff8ae$export$b167c7a51314f76c(str, byteSize = 8, padding = $7551102ca62ff8ae$var$STRING_ZERO) {
    return $7551102ca62ff8ae$export$bc3bea8325045070(str, $7551102ca62ff8ae$export$7d00ccbd2e7529cf(str.length, byteSize), padding);
}
function $7551102ca62ff8ae$export$bc3bea8325045070(str, length, padding = $7551102ca62ff8ae$var$STRING_ZERO) {
    return $7551102ca62ff8ae$var$padString(str, length, true, padding);
}
function $7551102ca62ff8ae$export$7e24a29324041c48(str, length, padding = $7551102ca62ff8ae$var$STRING_ZERO) {
    return $7551102ca62ff8ae$var$padString(str, length, false, padding);
}
function $7551102ca62ff8ae$export$999052bd72869f3a(hex) {
    return hex.replace(/^0x/, "");
}
function $7551102ca62ff8ae$export$c7dec2a5deb37361(hex) {
    return hex.startsWith("0x") ? hex : `0x${hex}`;
}
function $7551102ca62ff8ae$export$1cd910b238e58ea4(hex) {
    hex = $7551102ca62ff8ae$export$999052bd72869f3a(hex);
    hex = $7551102ca62ff8ae$export$b167c7a51314f76c(hex, 2);
    if (hex) hex = $7551102ca62ff8ae$export$c7dec2a5deb37361(hex);
    return hex;
}
function $7551102ca62ff8ae$export$43135df02265efe5(hex) {
    const prefixed = hex.startsWith("0x");
    hex = $7551102ca62ff8ae$export$999052bd72869f3a(hex);
    hex = hex.startsWith($7551102ca62ff8ae$var$STRING_ZERO) ? hex.substring(1) : hex;
    return prefixed ? $7551102ca62ff8ae$export$c7dec2a5deb37361(hex) : hex;
}
function $7551102ca62ff8ae$var$isUndefined(value) {
    return typeof value === "undefined";
}
function $7551102ca62ff8ae$var$isDefined(value) {
    return !$7551102ca62ff8ae$var$isUndefined(value);
}
function $7551102ca62ff8ae$var$assert(assertion, errorMessage) {
    if (!assertion) throw new Error(errorMessage);
}
function $7551102ca62ff8ae$var$reverseString(str) {
    return str.split("").reverse().join("");
}
function $7551102ca62ff8ae$var$padString(str, length, left, padding = $7551102ca62ff8ae$var$STRING_ZERO) {
    const diff = length - str.length;
    let result = str;
    if (diff > 0) {
        const pad = padding.repeat(diff);
        result = left ? pad + str : str + pad;
    }
    return result;
}


function $ecd06230a68a2b13$export$a7b301160c60ad85(arrBuf) {
    return $7551102ca62ff8ae$export$1eb84f36023740c(new Uint8Array(arrBuf));
}
function $ecd06230a68a2b13$export$7cf29a0396d2533f(arrBuf) {
    return $7551102ca62ff8ae$export$72f33cf4e661f197(new Uint8Array(arrBuf));
}
function $ecd06230a68a2b13$export$8b01e252c0d068e3(arrBuf, noPrefix) {
    return $7551102ca62ff8ae$export$9794ce7150434ee(new Uint8Array(arrBuf), !noPrefix);
}
function $ecd06230a68a2b13$export$7712f4d46970b4c9(arrBuf) {
    return $7551102ca62ff8ae$export$c0c67b67c531aea4(new Uint8Array(arrBuf));
}
function $ecd06230a68a2b13$export$52c89ebcdc4f53f2(...args) {
    return $7551102ca62ff8ae$export$c318328836320ba5(args.map((b)=>$7551102ca62ff8ae$export$9794ce7150434ee(new Uint8Array(b))).join("")).buffer;
}
function $ecd06230a68a2b13$export$9e8479d6da7d49b(buf) {
    return $7551102ca62ff8ae$export$9b5ed7081d0cfa58(buf).buffer;
}
function $ecd06230a68a2b13$export$af609cfbd583c2f7(buf) {
    return $7551102ca62ff8ae$export$a4bb1a98a4cc455(buf);
}
function $ecd06230a68a2b13$export$749e48bcc9ec7385(buf, noPrefix) {
    return $7551102ca62ff8ae$export$c48fc777188c96e3(buf, !noPrefix);
}
function $ecd06230a68a2b13$export$96c8d4cbf276fff3(buf) {
    return $7551102ca62ff8ae$export$b91271ed380b6df8(buf);
}
function $ecd06230a68a2b13$export$28e250f55413be00(...args) {
    return $7551102ca62ff8ae$export$28e250f55413be00(...args);
}
function $ecd06230a68a2b13$export$d6c83d80118a888c(utf8) {
    return $7551102ca62ff8ae$export$161387ce93217b03(utf8).buffer;
}
function $ecd06230a68a2b13$export$794e0d50eb242e9b(utf8) {
    return $7551102ca62ff8ae$export$f93b3fa5fd97a11f(utf8);
}
function $ecd06230a68a2b13$export$ed749ba24ad35542(utf8, noPrefix) {
    return $7551102ca62ff8ae$export$7579354b96718fb8(utf8, !noPrefix);
}
function $ecd06230a68a2b13$export$99ec40ddc5052d1c(utf8) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($icOy8)))(utf8, 10).toNumber();
}
function $ecd06230a68a2b13$export$68b55ccd9c0ec1c1(hex) {
    return $7551102ca62ff8ae$export$de4231026bca1594(hex);
}
function $ecd06230a68a2b13$export$633e071b9b71ac06(hex) {
    return $7551102ca62ff8ae$export$c318328836320ba5(hex).buffer;
}
function $ecd06230a68a2b13$export$e5bf32ffe17fcb58(hex) {
    return $7551102ca62ff8ae$export$966dea6757c0197(hex);
}
function $ecd06230a68a2b13$export$afc4bcb8951531a3(hex) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($icOy8)))($7551102ca62ff8ae$export$999052bd72869f3a(hex), "hex").toNumber();
}
function $ecd06230a68a2b13$export$474870eae8445805(num) {
    return $7551102ca62ff8ae$export$e6e040540f7cfd7a(num);
}
function $ecd06230a68a2b13$export$3fd793ce278b95c0(num) {
    return $7551102ca62ff8ae$export$64b9b7c6df806f78(num).buffer;
}
function $ecd06230a68a2b13$export$7e5cf8c43c985a13(num) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($icOy8)))(num).toString();
}
function $ecd06230a68a2b13$export$e8a05eea239bf16c(num, noPrefix) {
    const hex = $7551102ca62ff8ae$export$999052bd72869f3a($7551102ca62ff8ae$export$1cd910b238e58ea4(new (0, (/*@__PURE__*/$parcel$interopDefault($icOy8)))(num).toString(16)));
    return noPrefix ? hex : $7551102ca62ff8ae$export$c7dec2a5deb37361(hex);
}



var $cCjFr = parcelRequire("cCjFr");



var $8acb6fbf5ed71ddf$exports = {};
$parcel$export($8acb6fbf5ed71ddf$exports, "payloadId", function () { return $acc49a9628dc2606$exports.payloadId; });
$parcel$export($8acb6fbf5ed71ddf$exports, "payloadId", function () { return $b7a4d9ee4dcd8904$export$2f5364a5d4b80251; });
const $1716b89068af4533$export$2ecaad7eb5cc1f25 = "PARSE_ERROR";
const $1716b89068af4533$export$c77b2f9ece3946ce = "INVALID_REQUEST";
const $1716b89068af4533$export$e8d537b30db778d6 = "METHOD_NOT_FOUND";
const $1716b89068af4533$export$13aae195c7978fb1 = "INVALID_PARAMS";
const $1716b89068af4533$export$f6e3abf3038d348f = "INTERNAL_ERROR";
const $1716b89068af4533$export$125ebd30471ac25c = "SERVER_ERROR";
const $1716b89068af4533$export$af84821b5448ca78 = [
    -32700,
    -32600,
    -32601,
    -32602,
    -32603
];
const $1716b89068af4533$export$fff5b44b15c75f69 = [
    -32000,
    -32099
];
const $1716b89068af4533$export$cca5387ab287e1ae = {
    [$1716b89068af4533$export$2ecaad7eb5cc1f25]: {
        code: -32700,
        message: "Parse error"
    },
    [$1716b89068af4533$export$c77b2f9ece3946ce]: {
        code: -32600,
        message: "Invalid Request"
    },
    [$1716b89068af4533$export$e8d537b30db778d6]: {
        code: -32601,
        message: "Method not found"
    },
    [$1716b89068af4533$export$13aae195c7978fb1]: {
        code: -32602,
        message: "Invalid params"
    },
    [$1716b89068af4533$export$f6e3abf3038d348f]: {
        code: -32603,
        message: "Internal error"
    },
    [$1716b89068af4533$export$125ebd30471ac25c]: {
        code: -32000,
        message: "Server error"
    }
};
const $1716b89068af4533$export$d166979eca925bce = $1716b89068af4533$export$125ebd30471ac25c;



function $9bb30ce112e9c611$export$e463129eb4bc487f(code) {
    return code <= (0, $1716b89068af4533$export$fff5b44b15c75f69)[0] && code >= (0, $1716b89068af4533$export$fff5b44b15c75f69)[1];
}
function $9bb30ce112e9c611$export$2ae0ec6393ab16c3(code) {
    return (0, $1716b89068af4533$export$af84821b5448ca78).includes(code);
}
function $9bb30ce112e9c611$export$7543109e66e1748d(code) {
    return typeof code === "number";
}
function $9bb30ce112e9c611$export$e1599abf47b5b568(type) {
    if (!Object.keys((0, $1716b89068af4533$export$cca5387ab287e1ae)).includes(type)) return (0, $1716b89068af4533$export$cca5387ab287e1ae)[0, $1716b89068af4533$export$d166979eca925bce];
    return (0, $1716b89068af4533$export$cca5387ab287e1ae)[type];
}
function $9bb30ce112e9c611$export$60a3bac005957e12(code) {
    const match = Object.values((0, $1716b89068af4533$export$cca5387ab287e1ae)).find((e)=>e.code === code);
    if (!match) return (0, $1716b89068af4533$export$cca5387ab287e1ae)[0, $1716b89068af4533$export$d166979eca925bce];
    return match;
}
function $9bb30ce112e9c611$export$6be064b82176dd99(response) {
    if (typeof response.error.code === "undefined") return {
        valid: false,
        error: "Missing code for JSON-RPC error"
    };
    if (typeof response.error.message === "undefined") return {
        valid: false,
        error: "Missing message for JSON-RPC error"
    };
    if (!$9bb30ce112e9c611$export$7543109e66e1748d(response.error.code)) return {
        valid: false,
        error: `Invalid error code type for JSON-RPC: ${response.error.code}`
    };
    if ($9bb30ce112e9c611$export$2ae0ec6393ab16c3(response.error.code)) {
        const error = $9bb30ce112e9c611$export$60a3bac005957e12(response.error.code);
        if (error.message !== (0, $1716b89068af4533$export$cca5387ab287e1ae)[0, $1716b89068af4533$export$d166979eca925bce].message && response.error.message === error.message) return {
            valid: false,
            error: `Invalid error code message for JSON-RPC: ${response.error.code}`
        };
    }
    return {
        valid: true
    };
}
function $9bb30ce112e9c611$export$f555d7d8f922e407(e, url, type) {
    return e.message.includes("getaddrinfo ENOTFOUND") || e.message.includes("connect ECONNREFUSED") ? new Error(`Unavailable ${type} RPC url at ${url}`) : e;
}


var $acc49a9628dc2606$exports = {};
"use strict";
Object.defineProperty($acc49a9628dc2606$exports, "__esModule", {
    value: true
});
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $5c2a37736a53c5f6$var$extendStatics = function(d, b) {
    $5c2a37736a53c5f6$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $5c2a37736a53c5f6$var$extendStatics(d, b);
};
function $5c2a37736a53c5f6$export$a8ba968b8961cb8a(d, b) {
    $5c2a37736a53c5f6$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c2a37736a53c5f6$export$18ce0697a983be9b = function() {
    $5c2a37736a53c5f6$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c2a37736a53c5f6$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c2a37736a53c5f6$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c2a37736a53c5f6$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c2a37736a53c5f6$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c2a37736a53c5f6$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c2a37736a53c5f6$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c2a37736a53c5f6$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $5c2a37736a53c5f6$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $5c2a37736a53c5f6$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $5c2a37736a53c5f6$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c2a37736a53c5f6$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c2a37736a53c5f6$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c2a37736a53c5f6$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c2a37736a53c5f6$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c2a37736a53c5f6$export$10c90e4f7922046c(v) {
    return this instanceof $5c2a37736a53c5f6$export$10c90e4f7922046c ? (this.v = v, this) : new $5c2a37736a53c5f6$export$10c90e4f7922046c(v);
}
function $5c2a37736a53c5f6$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c2a37736a53c5f6$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c2a37736a53c5f6$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c2a37736a53c5f6$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c2a37736a53c5f6$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c2a37736a53c5f6$export$19a8beecd37a4c45 === "function" ? $5c2a37736a53c5f6$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c2a37736a53c5f6$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $5c2a37736a53c5f6$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $5c2a37736a53c5f6$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c2a37736a53c5f6$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $5c2a37736a53c5f6$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}



$5c2a37736a53c5f6$export$f33643c0debef087((parcelRequire("eOzb5")), $acc49a9628dc2606$exports);

$5c2a37736a53c5f6$export$f33643c0debef087((parcelRequire("ar1Qx")), $acc49a9628dc2606$exports);


const $0983bab3a99d105e$export$d1694901a048d7c8 = (0, $acc49a9628dc2606$exports.isNode);




function $b7a4d9ee4dcd8904$export$2f5364a5d4b80251(entropy = 3) {
    const date = Date.now() * Math.pow(10, entropy);
    const extra = Math.floor(Math.random() * Math.pow(10, entropy));
    return date + extra;
}
function $b7a4d9ee4dcd8904$export$799a3db5df197877(entropy = 6) {
    return BigInt($b7a4d9ee4dcd8904$export$2f5364a5d4b80251(entropy));
}
function $b7a4d9ee4dcd8904$export$11d081ebb32d4398(method, params, id) {
    return {
        id: id || $b7a4d9ee4dcd8904$export$2f5364a5d4b80251(),
        jsonrpc: "2.0",
        method: method,
        params: params
    };
}
function $b7a4d9ee4dcd8904$export$478fdea01c2a3198(id, result) {
    return {
        id: id,
        jsonrpc: "2.0",
        result: result
    };
}
function $b7a4d9ee4dcd8904$export$9f7302ae26c3f77(id, error, data) {
    return {
        id: id,
        jsonrpc: "2.0",
        error: $b7a4d9ee4dcd8904$export$5201d50a34753d71(error, data)
    };
}
function $b7a4d9ee4dcd8904$export$5201d50a34753d71(error, data) {
    if (typeof error === "undefined") return (0, $9bb30ce112e9c611$export$e1599abf47b5b568)((0, $1716b89068af4533$export$f6e3abf3038d348f));
    if (typeof error === "string") error = Object.assign(Object.assign({}, (0, $9bb30ce112e9c611$export$e1599abf47b5b568)((0, $1716b89068af4533$export$125ebd30471ac25c))), {
        message: error
    });
    if (typeof data !== "undefined") error.data = data;
    if ((0, $9bb30ce112e9c611$export$2ae0ec6393ab16c3)(error.code)) error = (0, $9bb30ce112e9c611$export$60a3bac005957e12)(error.code);
    return error;
}


function $52279927992406f8$export$9f3e656a7f6a3adc(route) {
    if (route.includes("*")) return $52279927992406f8$export$8e8b9bea55b56df2(route);
    if (/\W/g.test(route)) return false;
    return true;
}
function $52279927992406f8$export$c7e2040809cad2c4(route) {
    return route === "*";
}
function $52279927992406f8$export$8e8b9bea55b56df2(route) {
    if ($52279927992406f8$export$c7e2040809cad2c4(route)) return true;
    if (!route.includes("*")) return false;
    if (route.split("*").length !== 2) return false;
    if (route.split("*").filter((x)=>x.trim() === "").length !== 1) return false;
    return true;
}
function $52279927992406f8$export$2d48faaafcc8fbdc(route) {
    return !$52279927992406f8$export$c7e2040809cad2c4(route) && $52279927992406f8$export$8e8b9bea55b56df2(route) && !route.split("*")[0].trim();
}
function $52279927992406f8$export$be298a4710fab756(route) {
    return !$52279927992406f8$export$c7e2040809cad2c4(route) && $52279927992406f8$export$8e8b9bea55b56df2(route) && !route.split("*")[1].trim();
}




class $f6c613f8af8f776f$export$ab429ec7e240e546 {
}



class $1fb138719ee0abe9$export$77d426dd89724fbe extends (0, $f6c613f8af8f776f$export$ab429ec7e240e546) {
    constructor(opts){
        super();
    }
}
class $1fb138719ee0abe9$export$cb916a2eed49af33 extends (0, $f6c613f8af8f776f$export$ab429ec7e240e546) {
    constructor(){
        super();
    }
}
class $1fb138719ee0abe9$export$46957420a688a16d extends $1fb138719ee0abe9$export$cb916a2eed49af33 {
    constructor(connection){
        super();
    }
}








const $aa403329d72831ae$var$HTTP_REGEX = "^https?:";
const $aa403329d72831ae$var$WS_REGEX = "^wss?:";
function $aa403329d72831ae$var$getUrlProtocol(url) {
    const matches = url.match(new RegExp(/^\w+:/, "gi"));
    if (!matches || !matches.length) return;
    return matches[0];
}
function $aa403329d72831ae$var$matchRegexProtocol(url, regex) {
    const protocol = $aa403329d72831ae$var$getUrlProtocol(url);
    if (typeof protocol === "undefined") return false;
    return new RegExp(regex).test(protocol);
}
function $aa403329d72831ae$export$206c3129b8bb1b4f(url) {
    return $aa403329d72831ae$var$matchRegexProtocol(url, $aa403329d72831ae$var$HTTP_REGEX);
}
function $aa403329d72831ae$export$4e4463e75eccf20c(url) {
    return $aa403329d72831ae$var$matchRegexProtocol(url, $aa403329d72831ae$var$WS_REGEX);
}
function $aa403329d72831ae$export$8eb4a0a481601f29(url) {
    return new RegExp("wss?://localhost(:d{2,5})?").test(url);
}


function $ba06546f2e9fb24b$export$bf3617e9fafa893f(payload) {
    return typeof payload === "object" && "id" in payload && "jsonrpc" in payload && payload.jsonrpc === "2.0";
}
function $ba06546f2e9fb24b$export$f6e4034abe07d2a5(payload) {
    return $ba06546f2e9fb24b$export$bf3617e9fafa893f(payload) && "method" in payload;
}
function $ba06546f2e9fb24b$export$308ba927de2bcbe8(payload) {
    return $ba06546f2e9fb24b$export$bf3617e9fafa893f(payload) && ($ba06546f2e9fb24b$export$cb3d3b20e3223d77(payload) || $ba06546f2e9fb24b$export$5662a1047b4d1d15(payload));
}
function $ba06546f2e9fb24b$export$cb3d3b20e3223d77(payload) {
    return "result" in payload;
}
function $ba06546f2e9fb24b$export$5662a1047b4d1d15(payload) {
    return "error" in payload;
}
function $ba06546f2e9fb24b$export$ae97720cc2d120d4(validation) {
    return "error" in validation && validation.valid === false;
}





function $0a9a41272ffd2cc1$export$1cd910b238e58ea4(hex) {
    return $7551102ca62ff8ae$export$1cd910b238e58ea4(hex);
}
function $0a9a41272ffd2cc1$export$c7dec2a5deb37361(hex) {
    return $7551102ca62ff8ae$export$c7dec2a5deb37361(hex);
}
function $0a9a41272ffd2cc1$export$999052bd72869f3a(hex) {
    return $7551102ca62ff8ae$export$999052bd72869f3a(hex);
}
function $0a9a41272ffd2cc1$export$43135df02265efe5(hex) {
    return $7551102ca62ff8ae$export$43135df02265efe5($7551102ca62ff8ae$export$c7dec2a5deb37361(hex));
}
const $0a9a41272ffd2cc1$export$2f5364a5d4b80251 = $b7a4d9ee4dcd8904$export$2f5364a5d4b80251;
function $0a9a41272ffd2cc1$export$31b40729666a4ae0() {
    const result = ((a, b)=>{
        for(b = a = ""; a++ < 36; b += a * 51 & 52 ? (a ^ 15 ? 8 ^ Math.random() * (a ^ 20 ? 16 : 4) : 4).toString(16) : "-");
        return b;
    })();
    return result;
}
function $0a9a41272ffd2cc1$export$fd85fde5373f97ba() {
    console.warn("DEPRECATION WARNING: This WalletConnect client library will be deprecated in favor of @walletconnect/client. Please check docs.walletconnect.org to learn more about this migration!");
}
function $0a9a41272ffd2cc1$export$62ac5fc702ebcb68(chainId, infuraId) {
    let rpcUrl;
    const network = (0, $b71c237f18518b05$export$5ee9f0819fdedae1)[chainId];
    if (network) rpcUrl = `https://${network}.infura.io/v3/${infuraId}`;
    return rpcUrl;
}
function $0a9a41272ffd2cc1$export$cea56c0e6b0b9390(chainId, rpc) {
    let rpcUrl;
    const infuraUrl = $0a9a41272ffd2cc1$export$62ac5fc702ebcb68(chainId, rpc.infuraId);
    if (rpc.custom && rpc.custom[chainId]) rpcUrl = rpc.custom[chainId];
    else if (infuraUrl) rpcUrl = infuraUrl;
    return rpcUrl;
}




function $fbfdf11c2e07721a$export$78d1711480f95c3e(value) {
    return value === "" || typeof value === "string" && value.trim() === "";
}
function $fbfdf11c2e07721a$export$4c0262a4f954db45(array) {
    return !(array && array.length);
}
function $fbfdf11c2e07721a$export$a7884ebc965f8f54(val) {
    return $7551102ca62ff8ae$export$a7884ebc965f8f54(val);
}
function $fbfdf11c2e07721a$export$b119cc7e1840e59c(val) {
    return $7551102ca62ff8ae$export$b119cc7e1840e59c(val);
}
function $fbfdf11c2e07721a$export$9dd3754ae86f0017(val) {
    return $7551102ca62ff8ae$export$9dd3754ae86f0017(val);
}
function $fbfdf11c2e07721a$export$e2b5c5db9e2009fd(val) {
    return $7551102ca62ff8ae$export$e2b5c5db9e2009fd(val);
}
function $fbfdf11c2e07721a$export$badc544e0651b6b1(val) {
    return $7551102ca62ff8ae$export$badc544e0651b6b1(val);
}
function $fbfdf11c2e07721a$export$b02a40aff8e4ad18(value, length) {
    return $7551102ca62ff8ae$export$b02a40aff8e4ad18(value, length);
}
function $fbfdf11c2e07721a$export$8e958a884a97ccbc(object) {
    return typeof object.params === "object";
}
function $fbfdf11c2e07721a$export$f6e4034abe07d2a5(object) {
    return typeof object.method !== "undefined";
}
function $fbfdf11c2e07721a$export$bf64516915508215(object) {
    return typeof object.result !== "undefined";
}
function $fbfdf11c2e07721a$export$ec4292c7205b27a1(object) {
    return typeof object.error !== "undefined";
}
function $fbfdf11c2e07721a$export$b27ccd6cf6073c1c(object) {
    return typeof object.event !== "undefined";
}
function $fbfdf11c2e07721a$export$2e32023fa7d50f70(event) {
    return (0, $b71c237f18518b05$export$c0bad5548e0b6bf1).includes(event) || event.startsWith("wc_");
}
function $fbfdf11c2e07721a$export$882c355a4e040212(request) {
    if (request.method.startsWith("wc_")) return true;
    if ((0, $b71c237f18518b05$export$9e4c3f5a97a9dcc3).includes(request.method)) return false;
    return true;
}


function $56813b230210f2fa$export$34daaec7218b1cd8(address) {
    address = (0, $7551102ca62ff8ae$export$999052bd72869f3a)(address.toLowerCase());
    const hash = (0, $7551102ca62ff8ae$export$999052bd72869f3a)((0, $cCjFr.keccak_256)((0, $ecd06230a68a2b13$export$794e0d50eb242e9b)(address)));
    let checksum = "";
    for(let i = 0; i < address.length; i++)if (parseInt(hash[i], 16) > 7) checksum += address[i].toUpperCase();
    else checksum += address[i];
    return (0, $7551102ca62ff8ae$export$c7dec2a5deb37361)(checksum);
}
const $56813b230210f2fa$export$1987372119294ebb = (address)=>{
    if (!address) return false;
    else if (address.toLowerCase().substring(0, 2) !== "0x") return false;
    else if (!/^(0x)?[0-9a-f]{40}$/i.test(address)) return false;
    else if (/^(0x)?[0-9a-f]{40}$/.test(address) || /^(0x)?[0-9A-F]{40}$/.test(address)) return true;
    else return address === $56813b230210f2fa$export$34daaec7218b1cd8(address);
};
function $56813b230210f2fa$export$9ea5af239472ab5b(params) {
    if (!(0, $fbfdf11c2e07721a$export$4c0262a4f954db45)(params) && !(0, $fbfdf11c2e07721a$export$b02a40aff8e4ad18)(params[0])) params[0] = (0, $ecd06230a68a2b13$export$ed749ba24ad35542)(params[0]);
    return params;
}
function $56813b230210f2fa$export$fd7575db8179ef2c(txData) {
    if (typeof txData.type !== "undefined" && txData.type !== "0") return txData;
    if (typeof txData.from === "undefined" || !$56813b230210f2fa$export$1987372119294ebb(txData.from)) throw new Error(`Transaction object must include a valid 'from' value.`);
    function parseHexValues(value) {
        let result = value;
        if (typeof value === "number" || typeof value === "string" && !(0, $fbfdf11c2e07721a$export$78d1711480f95c3e)(value)) {
            if (!(0, $fbfdf11c2e07721a$export$b02a40aff8e4ad18)(value)) result = (0, $ecd06230a68a2b13$export$e8a05eea239bf16c)(value);
            else if (typeof value === "string") result = (0, $0a9a41272ffd2cc1$export$1cd910b238e58ea4)(value);
        }
        if (typeof result === "string") result = (0, $0a9a41272ffd2cc1$export$43135df02265efe5)(result);
        return result;
    }
    const txDataRPC = {
        from: (0, $0a9a41272ffd2cc1$export$1cd910b238e58ea4)(txData.from),
        to: typeof txData.to === "undefined" ? undefined : (0, $0a9a41272ffd2cc1$export$1cd910b238e58ea4)(txData.to),
        gasPrice: typeof txData.gasPrice === "undefined" ? "" : parseHexValues(txData.gasPrice),
        gas: typeof txData.gas === "undefined" ? typeof txData.gasLimit === "undefined" ? "" : parseHexValues(txData.gasLimit) : parseHexValues(txData.gas),
        value: typeof txData.value === "undefined" ? "" : parseHexValues(txData.value),
        nonce: typeof txData.nonce === "undefined" ? "" : parseHexValues(txData.nonce),
        data: typeof txData.data === "undefined" ? "" : (0, $0a9a41272ffd2cc1$export$1cd910b238e58ea4)(txData.data) || "0x"
    };
    const prunable = [
        "gasPrice",
        "gas",
        "value",
        "nonce"
    ];
    Object.keys(txDataRPC).forEach((key)=>{
        if ((typeof txDataRPC[key] === "undefined" || typeof txDataRPC[key] === "string" && !txDataRPC[key].trim().length) && prunable.includes(key)) delete txDataRPC[key];
    });
    return txDataRPC;
}



function $0da9db9ff9940f21$export$1d1d2ed6b55cf67f(originalFn, thisArg) {
    const promisifiedFunction = async (...callArgs)=>{
        return new Promise((resolve, reject)=>{
            const callback = (err, data)=>{
                if (err === null || typeof err === "undefined") reject(err);
                resolve(data);
            };
            originalFn.apply(thisArg, [
                ...callArgs,
                callback
            ]);
        });
    };
    return promisifiedFunction;
}
function $0da9db9ff9940f21$export$94837ed80cea2156(error) {
    const message = error.message || "Failed or Rejected Request";
    let code = -32000;
    if (error && !error.code) switch(message){
        case "Parse error":
            code = -32700;
            break;
        case "Invalid request":
            code = -32600;
            break;
        case "Method not found":
            code = -32601;
            break;
        case "Invalid params":
            code = -32602;
            break;
        case "Internal error":
            code = -32603;
            break;
        default:
            code = -32000;
            break;
    }
    const result = {
        code: code,
        message: message
    };
    if (error.data) result.data = error.data;
    return result;
}


var $cf7912be0f61f53e$export$f9380c9a627682d3;
var $cf7912be0f61f53e$export$98e6a39c04603d36;
var $cf7912be0f61f53e$export$fac44ee5b035f737;
var $cf7912be0f61f53e$export$7a5253c0f62e0150;
var $cf7912be0f61f53e$export$a8c1621ea79325d3;
"use strict";
var $c0f7daa5d58ccdfa$exports = {};
"use strict";
$c0f7daa5d58ccdfa$exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);


var $905438c344b17ab7$exports = {};
"use strict";
var $905438c344b17ab7$var$token = "%[a-f0-9]{2}";
var $905438c344b17ab7$var$singleMatcher = new RegExp("(" + $905438c344b17ab7$var$token + ")|([^%]+?)", "gi");
var $905438c344b17ab7$var$multiMatcher = new RegExp("(" + $905438c344b17ab7$var$token + ")+", "gi");
function $905438c344b17ab7$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(""))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $905438c344b17ab7$var$decodeComponents(left), $905438c344b17ab7$var$decodeComponents(right));
}
function $905438c344b17ab7$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($905438c344b17ab7$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $905438c344b17ab7$var$decodeComponents(tokens, i).join("");
            tokens = input.match($905438c344b17ab7$var$singleMatcher) || [];
        }
        return input;
    }
}
function $905438c344b17ab7$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        "%FE%FF": "\uFFFD\uFFFD",
        "%FF%FE": "\uFFFD\uFFFD"
    };
    var match = $905438c344b17ab7$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $905438c344b17ab7$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $905438c344b17ab7$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap["%C2"] = "\uFFFD";
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, "g"), replaceMap[key]);
    }
    return input;
}
$905438c344b17ab7$exports = function(encodedURI) {
    if (typeof encodedURI !== "string") throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof encodedURI + "`");
    try {
        encodedURI = encodedURI.replace(/\+/g, " ");
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $905438c344b17ab7$var$customDecodeURIComponent(encodedURI);
    }
};


var $17c2405f5b21daa0$exports = {};
"use strict";
$17c2405f5b21daa0$exports = (string, separator)=>{
    if (!(typeof string === "string" && typeof separator === "string")) throw new TypeError("Expected the arguments to be of type `string`");
    if (separator === "") return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};


const $cf7912be0f61f53e$var$isNullOrUndefined = (value)=>value === null || value === undefined;
function $cf7912be0f61f53e$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $cf7912be0f61f53e$var$encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $cf7912be0f61f53e$var$encode(key, options),
                            "[",
                            $cf7912be0f61f53e$var$encode(index, options),
                            "]=",
                            $cf7912be0f61f53e$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "bracket":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $cf7912be0f61f53e$var$encode(key, options),
                            "[]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $cf7912be0f61f53e$var$encode(key, options),
                            "[]=",
                            $cf7912be0f61f53e$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "comma":
        case "separator":
            return (key)=>(result, value)=>{
                    if (value === null || value === undefined || value.length === 0) return result;
                    if (result.length === 0) return [
                        [
                            $cf7912be0f61f53e$var$encode(key, options),
                            "=",
                            $cf7912be0f61f53e$var$encode(value, options)
                        ].join("")
                    ];
                    return [
                        [
                            result,
                            $cf7912be0f61f53e$var$encode(value, options)
                        ].join(options.arrayFormatSeparator)
                    ];
                };
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        $cf7912be0f61f53e$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $cf7912be0f61f53e$var$encode(key, options),
                            "=",
                            $cf7912be0f61f53e$var$encode(value, options)
                        ].join("")
                    ];
                };
    }
}
function $cf7912be0f61f53e$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "comma":
        case "separator":
            return (key, value, accumulator)=>{
                const isArray = typeof value === "string" && value.split("").indexOf(options.arrayFormatSeparator) > -1;
                const newValue = isArray ? value.split(options.arrayFormatSeparator).map((item)=>$cf7912be0f61f53e$var$decode(item, options)) : value === null ? value : $cf7912be0f61f53e$var$decode(value, options);
                accumulator[key] = newValue;
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $cf7912be0f61f53e$var$validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function $cf7912be0f61f53e$var$encode(value, options) {
    if (options.encode) return options.strict ? $c0f7daa5d58ccdfa$exports(value) : encodeURIComponent(value);
    return value;
}
function $cf7912be0f61f53e$var$decode(value, options) {
    if (options.decode) return $905438c344b17ab7$exports(value);
    return value;
}
function $cf7912be0f61f53e$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return $cf7912be0f61f53e$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $cf7912be0f61f53e$var$removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $cf7912be0f61f53e$var$getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $cf7912be0f61f53e$var$extract(input) {
    input = $cf7912be0f61f53e$var$removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function $cf7912be0f61f53e$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function $cf7912be0f61f53e$var$parse(input, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $cf7912be0f61f53e$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $cf7912be0f61f53e$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof input !== "string") return ret;
    input = input.trim().replace(/^[?#&]/, "");
    if (!input) return ret;
    for (const param of input.split("&")){
        let [key, value] = $17c2405f5b21daa0$exports(options.decode ? param.replace(/\+/g, " ") : param, "=");
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            "comma",
            "separator"
        ].includes(options.arrayFormat) ? value : $cf7912be0f61f53e$var$decode(value, options);
        formatter($cf7912be0f61f53e$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === "object" && value !== null) for (const k of Object.keys(value))value[k] = $cf7912be0f61f53e$var$parseValue(value[k], options);
        else ret[key] = $cf7912be0f61f53e$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $cf7912be0f61f53e$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$cf7912be0f61f53e$export$f9380c9a627682d3 = $cf7912be0f61f53e$var$extract;
$cf7912be0f61f53e$export$98e6a39c04603d36 = $cf7912be0f61f53e$var$parse;
$cf7912be0f61f53e$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return "";
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ","
    }, options);
    $cf7912be0f61f53e$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $cf7912be0f61f53e$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    const formatter = $cf7912be0f61f53e$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return "";
        if (value === null) return $cf7912be0f61f53e$var$encode(key, options);
        if (Array.isArray(value)) return value.reduce(formatter(key), []).join("&");
        return $cf7912be0f61f53e$var$encode(key, options) + "=" + $cf7912be0f61f53e$var$encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
};
$cf7912be0f61f53e$export$7a5253c0f62e0150 = (input, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url, hash] = $17c2405f5b21daa0$exports(input, "#");
    return Object.assign({
        url: url.split("?")[0] || "",
        query: $cf7912be0f61f53e$var$parse($cf7912be0f61f53e$var$extract(input), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $cf7912be0f61f53e$var$decode(hash, options)
    } : {});
};
$cf7912be0f61f53e$export$a8c1621ea79325d3 = (input, options)=>{
    options = Object.assign({
        encode: true,
        strict: true
    }, options);
    const url = $cf7912be0f61f53e$var$removeHash(input.url).split("?")[0] || "";
    const queryFromUrl = $cf7912be0f61f53e$export$f9380c9a627682d3(input.url);
    const parsedQueryFromUrl = $cf7912be0f61f53e$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, input.query);
    let queryString = $cf7912be0f61f53e$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $cf7912be0f61f53e$var$getHash(input.url);
    if (input.fragmentIdentifier) hash = `#${$cf7912be0f61f53e$var$encode(input.fragmentIdentifier, options)}`;
    return `${url}${queryString}${hash}`;
};


function $cb664a221be5a3cf$export$18380b9f669996bd(url) {
    const pathEnd = url.indexOf("?") !== -1 ? url.indexOf("?") : undefined;
    const queryString = typeof pathEnd !== "undefined" ? url.substr(pathEnd) : "";
    return queryString;
}
function $cb664a221be5a3cf$export$c4147c69f6845da(queryString, newQueryParams) {
    let queryParams = $cb664a221be5a3cf$export$66256f83798e5415(queryString);
    queryParams = Object.assign(Object.assign({}, queryParams), newQueryParams);
    queryString = $cb664a221be5a3cf$export$ae09827f8bd52688(queryParams);
    return queryString;
}
function $cb664a221be5a3cf$export$66256f83798e5415(queryString) {
    return $cf7912be0f61f53e$export$98e6a39c04603d36(queryString);
}
function $cb664a221be5a3cf$export$ae09827f8bd52688(queryParams) {
    return $cf7912be0f61f53e$export$fac44ee5b035f737(queryParams);
}


function $cb4230317c4fae18$export$c1de2fee7beefe38(object) {
    return typeof object.bridge !== "undefined";
}
function $cb4230317c4fae18$export$f0e17f110fdf26d7(str) {
    const pathStart = str.indexOf(":");
    const pathEnd = str.indexOf("?") !== -1 ? str.indexOf("?") : undefined;
    const protocol = str.substring(0, pathStart);
    const path = str.substring(pathStart + 1, pathEnd);
    function parseRequiredParams(path) {
        const separator = "@";
        const values = path.split(separator);
        const requiredParams = {
            handshakeTopic: values[0],
            version: parseInt(values[1], 10)
        };
        return requiredParams;
    }
    const requiredParams = parseRequiredParams(path);
    const queryString = typeof pathEnd !== "undefined" ? str.substr(pathEnd) : "";
    function parseQueryParams(queryString) {
        const result = (0, $cb664a221be5a3cf$export$66256f83798e5415)(queryString);
        const parameters = {
            key: result.key || "",
            bridge: result.bridge || ""
        };
        return parameters;
    }
    const queryParams = parseQueryParams(queryString);
    const result = Object.assign(Object.assign({
        protocol: protocol
    }, requiredParams), queryParams);
    return result;
}







class $6e50bee63ba141e0$var$NetworkMonitor {
    on(event, callback) {
        this._eventEmitters.push({
            event: event,
            callback: callback
        });
    }
    trigger(event) {
        let eventEmitters = [];
        if (event) eventEmitters = this._eventEmitters.filter((eventEmitter)=>eventEmitter.event === event);
        eventEmitters.forEach((eventEmitter)=>{
            eventEmitter.callback();
        });
    }
    constructor(){
        this._eventEmitters = [];
        if (typeof window !== "undefined" && typeof window.addEventListener !== "undefined") {
            window.addEventListener("online", ()=>this.trigger("online"));
            window.addEventListener("offline", ()=>this.trigger("offline"));
        }
    }
}
var $6e50bee63ba141e0$export$2e2bcd8739ae039 = $6e50bee63ba141e0$var$NetworkMonitor;



const $81eca0b5d0fd3720$var$WS = typeof $parcel$global.WebSocket !== "undefined" ? $parcel$global.WebSocket : (parcelRequire("8IOxf"));
class $81eca0b5d0fd3720$var$SocketTransport {
    set readyState(value) {}
    get readyState() {
        return this._socket ? this._socket.readyState : -1;
    }
    set connecting(value) {}
    get connecting() {
        return this.readyState === 0;
    }
    set connected(value) {}
    get connected() {
        return this.readyState === 1;
    }
    set closing(value) {}
    get closing() {
        return this.readyState === 2;
    }
    set closed(value) {}
    get closed() {
        return this.readyState === 3;
    }
    open() {
        this._socketCreate();
    }
    close() {
        this._socketClose();
    }
    send(message, topic, silent) {
        if (!topic || typeof topic !== "string") throw new Error("Missing or invalid topic field");
        this._socketSend({
            topic: topic,
            type: "pub",
            payload: message,
            silent: !!silent
        });
    }
    subscribe(topic) {
        this._socketSend({
            topic: topic,
            type: "sub",
            payload: "",
            silent: true
        });
    }
    on(event, callback) {
        this._events.push({
            event: event,
            callback: callback
        });
    }
    _socketCreate() {
        if (this._nextSocket) return;
        const url = $81eca0b5d0fd3720$var$getWebSocketUrl(this._url, this._protocol, this._version);
        this._nextSocket = new $81eca0b5d0fd3720$var$WS(url);
        if (!this._nextSocket) throw new Error("Failed to create socket");
        this._nextSocket.onmessage = (event)=>this._socketReceive(event);
        this._nextSocket.onopen = ()=>this._socketOpen();
        this._nextSocket.onerror = (event)=>this._socketError(event);
        this._nextSocket.onclose = ()=>{
            setTimeout(()=>{
                this._nextSocket = null;
                this._socketCreate();
            }, 1000);
        };
    }
    _socketOpen() {
        this._socketClose();
        this._socket = this._nextSocket;
        this._nextSocket = null;
        this._queueSubscriptions();
        this._pushQueue();
    }
    _socketClose() {
        if (this._socket) {
            this._socket.onclose = ()=>{};
            this._socket.close();
        }
    }
    _socketSend(socketMessage) {
        const message = JSON.stringify(socketMessage);
        if (this._socket && this._socket.readyState === 1) this._socket.send(message);
        else {
            this._setToQueue(socketMessage);
            this._socketCreate();
        }
    }
    async _socketReceive(event) {
        let socketMessage;
        try {
            socketMessage = JSON.parse(event.data);
        } catch (error) {
            return;
        }
        this._socketSend({
            topic: socketMessage.topic,
            type: "ack",
            payload: "",
            silent: true
        });
        if (this._socket && this._socket.readyState === 1) {
            const events = this._events.filter((event)=>event.event === "message");
            if (events && events.length) events.forEach((event)=>event.callback(socketMessage));
        }
    }
    _socketError(e) {
        const events = this._events.filter((event)=>event.event === "error");
        if (events && events.length) events.forEach((event)=>event.callback(e));
    }
    _queueSubscriptions() {
        const subscriptions = this._subscriptions;
        subscriptions.forEach((topic)=>this._queue.push({
                topic: topic,
                type: "sub",
                payload: "",
                silent: true
            }));
        this._subscriptions = this.opts.subscriptions || [];
    }
    _setToQueue(socketMessage) {
        this._queue.push(socketMessage);
    }
    _pushQueue() {
        const queue = this._queue;
        queue.forEach((socketMessage)=>this._socketSend(socketMessage));
        this._queue = [];
    }
    constructor(opts){
        this.opts = opts;
        this._queue = [];
        this._events = [];
        this._subscriptions = [];
        this._protocol = opts.protocol;
        this._version = opts.version;
        this._url = "";
        this._netMonitor = null;
        this._socket = null;
        this._nextSocket = null;
        this._subscriptions = opts.subscriptions || [];
        this._netMonitor = opts.netMonitor || new (0, $6e50bee63ba141e0$export$2e2bcd8739ae039)();
        if (!opts.url || typeof opts.url !== "string") throw new Error("Missing or invalid WebSocket url");
        this._url = opts.url;
        this._netMonitor.on("online", ()=>this._socketCreate());
    }
}
function $81eca0b5d0fd3720$var$getWebSocketUrl(_url, protocol, version) {
    var _a, _b;
    const url = _url.startsWith("https") ? _url.replace("https", "wss") : _url.startsWith("http") ? _url.replace("http", "ws") : _url;
    const splitUrl = url.split("?");
    const params = (0, $4397f25fd0309dd4$export$4e09c449d6c407f7)() ? {
        protocol: protocol,
        version: version,
        env: "browser",
        host: ((_a = (0, $4397f25fd0309dd4$export$e7fd20fad3cf4b5f)()) === null || _a === void 0 ? void 0 : _a.host) || ""
    } : {
        protocol: protocol,
        version: version,
        env: ((_b = (0, $4397f25fd0309dd4$export$dcbc6a021acd8a16)()) === null || _b === void 0 ? void 0 : _b.name) || ""
    };
    const queryString = (0, $cb664a221be5a3cf$export$c4147c69f6845da)((0, $cb664a221be5a3cf$export$18380b9f669996bd)(splitUrl[1] || ""), params);
    return splitUrl[0] + "?" + queryString;
}
var $81eca0b5d0fd3720$export$2e2bcd8739ae039 = $81eca0b5d0fd3720$var$SocketTransport;


const $a54b6ede9afe5260$export$8218801f34064eb7 = "Session currently connected";
const $a54b6ede9afe5260$export$89468c57aa345e6d = "Session currently disconnected";
const $a54b6ede9afe5260$export$51e1dc59adfbc2c6 = "Session Rejected";
const $a54b6ede9afe5260$export$f6de36bb540db24a = "Missing JSON RPC response";
const $a54b6ede9afe5260$export$8d916de3ff4bf6c7 = `JSON-RPC success response must include "result" field`;
const $a54b6ede9afe5260$export$da94bc99564f6bb6 = `JSON-RPC error response must include "error" field`;
const $a54b6ede9afe5260$export$d284d2b67d122b06 = `JSON RPC request must have valid "method" value`;
const $a54b6ede9afe5260$export$b728a3781ce730 = `JSON RPC request must have valid "id" value`;
const $a54b6ede9afe5260$export$7a2af96276314dd1 = "Missing one of the required parameters: bridge / uri / session";
const $a54b6ede9afe5260$export$74b421ca1ff0efe7 = "JSON RPC response format is invalid";
const $a54b6ede9afe5260$export$e4155024a1048b1c = "URI format is invalid";
const $a54b6ede9afe5260$export$afd655165af1035b = "QRCode Modal not provided";
const $a54b6ede9afe5260$export$1a9cd9ed46f7c7e7 = "User close QRCode Modal";



class $6ff2ee7229921df8$var$EventManager {
    subscribe(eventEmitter) {
        this._eventEmitters.push(eventEmitter);
    }
    unsubscribe(event) {
        this._eventEmitters = this._eventEmitters.filter((x)=>x.event !== event);
    }
    trigger(payload) {
        let eventEmitters = [];
        let event;
        if ((0, $fbfdf11c2e07721a$export$f6e4034abe07d2a5)(payload)) event = payload.method;
        else if ((0, $fbfdf11c2e07721a$export$bf64516915508215)(payload) || (0, $fbfdf11c2e07721a$export$ec4292c7205b27a1)(payload)) event = `response:${payload.id}`;
        else if ((0, $fbfdf11c2e07721a$export$b27ccd6cf6073c1c)(payload)) event = payload.event;
        else event = "";
        if (event) eventEmitters = this._eventEmitters.filter((eventEmitter)=>eventEmitter.event === event);
        if ((!eventEmitters || !eventEmitters.length) && !(0, $fbfdf11c2e07721a$export$2e32023fa7d50f70)(event) && !(0, $fbfdf11c2e07721a$export$b27ccd6cf6073c1c)(event)) eventEmitters = this._eventEmitters.filter((eventEmitter)=>eventEmitter.event === "call_request");
        eventEmitters.forEach((eventEmitter)=>{
            if ((0, $fbfdf11c2e07721a$export$ec4292c7205b27a1)(payload)) {
                const error = new Error(payload.error.message);
                eventEmitter.callback(error, null);
            } else eventEmitter.callback(null, payload);
        });
    }
    constructor(){
        this._eventEmitters = [];
    }
}
var $6ff2ee7229921df8$export$2e2bcd8739ae039 = $6ff2ee7229921df8$var$EventManager;



class $e5d2cf756046daa2$var$SessionStorage {
    getSession() {
        let session = null;
        const json = (0, $5ba673e8a8315e9b$export$36f42a3d63632e68)(this.storageId);
        if (json && (0, $cb4230317c4fae18$export$c1de2fee7beefe38)(json)) session = json;
        return session;
    }
    setSession(session) {
        (0, $5ba673e8a8315e9b$export$95b8dcaf726c617c)(this.storageId, session);
        return session;
    }
    removeSession() {
        (0, $5ba673e8a8315e9b$export$1609d3fefbbf941f)(this.storageId);
    }
    constructor(storageId = "walletconnect"){
        this.storageId = storageId;
    }
}
var $e5d2cf756046daa2$export$2e2bcd8739ae039 = $e5d2cf756046daa2$var$SessionStorage;


const $abea7bccac8b5f35$var$domain = "walletconnect.org";
const $abea7bccac8b5f35$var$alphanumerical = "abcdefghijklmnopqrstuvwxyz0123456789";
const $abea7bccac8b5f35$var$bridges = $abea7bccac8b5f35$var$alphanumerical.split("").map((char)=>`https://${char}.bridge.walletconnect.org`);
function $abea7bccac8b5f35$export$b1f55e94ac826a0b(url) {
    let hostname = url.indexOf("//") > -1 ? url.split("/")[2] : url.split("/")[0];
    hostname = hostname.split(":")[0];
    hostname = hostname.split("?")[0];
    return hostname;
}
function $abea7bccac8b5f35$export$c9bcf07e1a7784a6(url) {
    return $abea7bccac8b5f35$export$b1f55e94ac826a0b(url).split(".").slice(-2).join(".");
}
function $abea7bccac8b5f35$export$71450b19692d8df5() {
    return Math.floor(Math.random() * $abea7bccac8b5f35$var$bridges.length);
}
function $abea7bccac8b5f35$export$8cd159640314e276() {
    return $abea7bccac8b5f35$var$bridges[$abea7bccac8b5f35$export$71450b19692d8df5()];
}
function $abea7bccac8b5f35$export$5bf6e3050ab1e795(url) {
    return $abea7bccac8b5f35$export$c9bcf07e1a7784a6(url) === $abea7bccac8b5f35$var$domain;
}
function $abea7bccac8b5f35$export$93ba7ece4fc32f8a(url) {
    if ($abea7bccac8b5f35$export$5bf6e3050ab1e795(url)) return $abea7bccac8b5f35$export$8cd159640314e276();
    return url;
}


class $8d4ea25a69db1500$var$Connector {
    set bridge(value) {
        if (!value) return;
        this._bridge = value;
    }
    get bridge() {
        return this._bridge;
    }
    set key(value) {
        if (!value) return;
        const key = (0, $ecd06230a68a2b13$export$633e071b9b71ac06)(value);
        this._key = key;
    }
    get key() {
        if (this._key) {
            const key = (0, $ecd06230a68a2b13$export$8b01e252c0d068e3)(this._key, true);
            return key;
        }
        return "";
    }
    set clientId(value) {
        if (!value) return;
        this._clientId = value;
    }
    get clientId() {
        let clientId = this._clientId;
        if (!clientId) clientId = this._clientId = (0, $0a9a41272ffd2cc1$export$31b40729666a4ae0)();
        return this._clientId;
    }
    set peerId(value) {
        if (!value) return;
        this._peerId = value;
    }
    get peerId() {
        return this._peerId;
    }
    set clientMeta(value) {}
    get clientMeta() {
        let clientMeta = this._clientMeta;
        if (!clientMeta) clientMeta = this._clientMeta = (0, $4397f25fd0309dd4$export$2d100c5be8d65eb6)();
        return clientMeta;
    }
    set peerMeta(value) {
        this._peerMeta = value;
    }
    get peerMeta() {
        const peerMeta = this._peerMeta;
        return peerMeta;
    }
    set handshakeTopic(value) {
        if (!value) return;
        this._handshakeTopic = value;
    }
    get handshakeTopic() {
        return this._handshakeTopic;
    }
    set handshakeId(value) {
        if (!value) return;
        this._handshakeId = value;
    }
    get handshakeId() {
        return this._handshakeId;
    }
    get uri() {
        const _uri = this._formatUri();
        return _uri;
    }
    set uri(value) {
        if (!value) return;
        const { handshakeTopic: handshakeTopic, bridge: bridge, key: key } = this._parseUri(value);
        this.handshakeTopic = handshakeTopic;
        this.bridge = bridge;
        this.key = key;
    }
    set chainId(value) {
        this._chainId = value;
    }
    get chainId() {
        const chainId = this._chainId;
        return chainId;
    }
    set networkId(value) {
        this._networkId = value;
    }
    get networkId() {
        const networkId = this._networkId;
        return networkId;
    }
    set accounts(value) {
        this._accounts = value;
    }
    get accounts() {
        const accounts = this._accounts;
        return accounts;
    }
    set rpcUrl(value) {
        this._rpcUrl = value;
    }
    get rpcUrl() {
        const rpcUrl = this._rpcUrl;
        return rpcUrl;
    }
    set connected(value) {}
    get connected() {
        return this._connected;
    }
    set pending(value) {}
    get pending() {
        return !!this._handshakeTopic;
    }
    get session() {
        return {
            connected: this.connected,
            accounts: this.accounts,
            chainId: this.chainId,
            bridge: this.bridge,
            key: this.key,
            clientId: this.clientId,
            clientMeta: this.clientMeta,
            peerId: this.peerId,
            peerMeta: this.peerMeta,
            handshakeId: this.handshakeId,
            handshakeTopic: this.handshakeTopic
        };
    }
    set session(value) {
        if (!value) return;
        this._connected = value.connected;
        this.accounts = value.accounts;
        this.chainId = value.chainId;
        this.bridge = value.bridge;
        this.key = value.key;
        this.clientId = value.clientId;
        this.clientMeta = value.clientMeta;
        this.peerId = value.peerId;
        this.peerMeta = value.peerMeta;
        this.handshakeId = value.handshakeId;
        this.handshakeTopic = value.handshakeTopic;
    }
    on(event, callback) {
        const eventEmitter = {
            event: event,
            callback: callback
        };
        this._eventManager.subscribe(eventEmitter);
    }
    off(event) {
        this._eventManager.unsubscribe(event);
    }
    async createInstantRequest(instantRequest) {
        this._key = await this._generateKey();
        const request = this._formatRequest({
            method: "wc_instantRequest",
            params: [
                {
                    peerId: this.clientId,
                    peerMeta: this.clientMeta,
                    request: this._formatRequest(instantRequest)
                }
            ]
        });
        this.handshakeId = request.id;
        this.handshakeTopic = (0, $0a9a41272ffd2cc1$export$31b40729666a4ae0)();
        this._eventManager.trigger({
            event: "display_uri",
            params: [
                this.uri
            ]
        });
        this.on("modal_closed", ()=>{
            throw new Error((0, $a54b6ede9afe5260$export$1a9cd9ed46f7c7e7));
        });
        const endInstantRequest = ()=>{
            this.killSession();
        };
        try {
            const result = await this._sendCallRequest(request);
            if (result) endInstantRequest();
            return result;
        } catch (error) {
            endInstantRequest();
            throw error;
        }
    }
    async connect(opts) {
        if (!this._qrcodeModal) throw new Error((0, $a54b6ede9afe5260$export$afd655165af1035b));
        if (this.connected) return {
            chainId: this.chainId,
            accounts: this.accounts
        };
        await this.createSession(opts);
        return new Promise(async (resolve, reject)=>{
            this.on("modal_closed", ()=>reject(new Error((0, $a54b6ede9afe5260$export$1a9cd9ed46f7c7e7))));
            this.on("connect", (error, payload)=>{
                if (error) return reject(error);
                resolve(payload.params[0]);
            });
        });
    }
    async createSession(opts) {
        if (this._connected) throw new Error((0, $a54b6ede9afe5260$export$8218801f34064eb7));
        if (this.pending) return;
        this._key = await this._generateKey();
        const request = this._formatRequest({
            method: "wc_sessionRequest",
            params: [
                {
                    peerId: this.clientId,
                    peerMeta: this.clientMeta,
                    chainId: opts && opts.chainId ? opts.chainId : null
                }
            ]
        });
        this.handshakeId = request.id;
        this.handshakeTopic = (0, $0a9a41272ffd2cc1$export$31b40729666a4ae0)();
        this._sendSessionRequest(request, "Session update rejected", {
            topic: this.handshakeTopic
        });
        this._eventManager.trigger({
            event: "display_uri",
            params: [
                this.uri
            ]
        });
    }
    approveSession(sessionStatus) {
        if (this._connected) throw new Error((0, $a54b6ede9afe5260$export$8218801f34064eb7));
        this.chainId = sessionStatus.chainId;
        this.accounts = sessionStatus.accounts;
        this.networkId = sessionStatus.networkId || 0;
        this.rpcUrl = sessionStatus.rpcUrl || "";
        const sessionParams = {
            approved: true,
            chainId: this.chainId,
            networkId: this.networkId,
            accounts: this.accounts,
            rpcUrl: this.rpcUrl,
            peerId: this.clientId,
            peerMeta: this.clientMeta
        };
        const response = {
            id: this.handshakeId,
            jsonrpc: "2.0",
            result: sessionParams
        };
        this._sendResponse(response);
        this._connected = true;
        this._setStorageSession();
        this._eventManager.trigger({
            event: "connect",
            params: [
                {
                    peerId: this.peerId,
                    peerMeta: this.peerMeta,
                    chainId: this.chainId,
                    accounts: this.accounts
                }
            ]
        });
    }
    rejectSession(sessionError) {
        if (this._connected) throw new Error((0, $a54b6ede9afe5260$export$8218801f34064eb7));
        const message = sessionError && sessionError.message ? sessionError.message : (0, $a54b6ede9afe5260$export$51e1dc59adfbc2c6);
        const response = this._formatResponse({
            id: this.handshakeId,
            error: {
                message: message
            }
        });
        this._sendResponse(response);
        this._connected = false;
        this._eventManager.trigger({
            event: "disconnect",
            params: [
                {
                    message: message
                }
            ]
        });
        this._removeStorageSession();
    }
    updateSession(sessionStatus) {
        if (!this._connected) throw new Error((0, $a54b6ede9afe5260$export$89468c57aa345e6d));
        this.chainId = sessionStatus.chainId;
        this.accounts = sessionStatus.accounts;
        this.networkId = sessionStatus.networkId || 0;
        this.rpcUrl = sessionStatus.rpcUrl || "";
        const sessionParams = {
            approved: true,
            chainId: this.chainId,
            networkId: this.networkId,
            accounts: this.accounts,
            rpcUrl: this.rpcUrl
        };
        const request = this._formatRequest({
            method: "wc_sessionUpdate",
            params: [
                sessionParams
            ]
        });
        this._sendSessionRequest(request, "Session update rejected");
        this._eventManager.trigger({
            event: "session_update",
            params: [
                {
                    chainId: this.chainId,
                    accounts: this.accounts
                }
            ]
        });
        this._manageStorageSession();
    }
    async killSession(sessionError) {
        const message = sessionError ? sessionError.message : "Session Disconnected";
        const sessionParams = {
            approved: false,
            chainId: null,
            networkId: null,
            accounts: null
        };
        const request = this._formatRequest({
            method: "wc_sessionUpdate",
            params: [
                sessionParams
            ]
        });
        await this._sendRequest(request);
        this._handleSessionDisconnect(message);
    }
    async sendTransaction(tx) {
        if (!this._connected) throw new Error((0, $a54b6ede9afe5260$export$89468c57aa345e6d));
        const parsedTx = (0, $56813b230210f2fa$export$fd7575db8179ef2c)(tx);
        const request = this._formatRequest({
            method: "eth_sendTransaction",
            params: [
                parsedTx
            ]
        });
        const result = await this._sendCallRequest(request);
        return result;
    }
    async signTransaction(tx) {
        if (!this._connected) throw new Error((0, $a54b6ede9afe5260$export$89468c57aa345e6d));
        const parsedTx = (0, $56813b230210f2fa$export$fd7575db8179ef2c)(tx);
        const request = this._formatRequest({
            method: "eth_signTransaction",
            params: [
                parsedTx
            ]
        });
        const result = await this._sendCallRequest(request);
        return result;
    }
    async signMessage(params) {
        if (!this._connected) throw new Error((0, $a54b6ede9afe5260$export$89468c57aa345e6d));
        const request = this._formatRequest({
            method: "eth_sign",
            params: params
        });
        const result = await this._sendCallRequest(request);
        return result;
    }
    async signPersonalMessage(params) {
        if (!this._connected) throw new Error((0, $a54b6ede9afe5260$export$89468c57aa345e6d));
        params = (0, $56813b230210f2fa$export$9ea5af239472ab5b)(params);
        const request = this._formatRequest({
            method: "personal_sign",
            params: params
        });
        const result = await this._sendCallRequest(request);
        return result;
    }
    async signTypedData(params) {
        if (!this._connected) throw new Error((0, $a54b6ede9afe5260$export$89468c57aa345e6d));
        const request = this._formatRequest({
            method: "eth_signTypedData",
            params: params
        });
        const result = await this._sendCallRequest(request);
        return result;
    }
    async updateChain(chainParams) {
        if (!this._connected) throw new Error("Session currently disconnected");
        const request = this._formatRequest({
            method: "wallet_updateChain",
            params: [
                chainParams
            ]
        });
        const result = await this._sendCallRequest(request);
        return result;
    }
    unsafeSend(request, options) {
        this._sendRequest(request, options);
        this._eventManager.trigger({
            event: "call_request_sent",
            params: [
                {
                    request: request,
                    options: options
                }
            ]
        });
        return new Promise((resolve, reject)=>{
            this._subscribeToResponse(request.id, (error, payload)=>{
                if (error) {
                    reject(error);
                    return;
                }
                if (!payload) throw new Error((0, $a54b6ede9afe5260$export$f6de36bb540db24a));
                resolve(payload);
            });
        });
    }
    async sendCustomRequest(request, options) {
        if (!this._connected) throw new Error((0, $a54b6ede9afe5260$export$89468c57aa345e6d));
        switch(request.method){
            case "eth_accounts":
                return this.accounts;
            case "eth_chainId":
                return (0, $ecd06230a68a2b13$export$e8a05eea239bf16c)(this.chainId);
            case "eth_sendTransaction":
            case "eth_signTransaction":
                if (request.params) request.params[0] = (0, $56813b230210f2fa$export$fd7575db8179ef2c)(request.params[0]);
                break;
            case "personal_sign":
                if (request.params) request.params = (0, $56813b230210f2fa$export$9ea5af239472ab5b)(request.params);
                break;
            default:
                break;
        }
        const formattedRequest = this._formatRequest(request);
        const result = await this._sendCallRequest(formattedRequest, options);
        return result;
    }
    approveRequest(response) {
        if ((0, $fbfdf11c2e07721a$export$bf64516915508215)(response)) {
            const formattedResponse = this._formatResponse(response);
            this._sendResponse(formattedResponse);
        } else throw new Error((0, $a54b6ede9afe5260$export$8d916de3ff4bf6c7));
    }
    rejectRequest(response) {
        if ((0, $fbfdf11c2e07721a$export$ec4292c7205b27a1)(response)) {
            const formattedResponse = this._formatResponse(response);
            this._sendResponse(formattedResponse);
        } else throw new Error((0, $a54b6ede9afe5260$export$da94bc99564f6bb6));
    }
    transportClose() {
        this._transport.close();
    }
    async _sendRequest(request, options) {
        const callRequest = this._formatRequest(request);
        const encryptionPayload = await this._encrypt(callRequest);
        const topic = typeof (options === null || options === void 0 ? void 0 : options.topic) !== "undefined" ? options.topic : this.peerId;
        const payload = JSON.stringify(encryptionPayload);
        const silent = typeof (options === null || options === void 0 ? void 0 : options.forcePushNotification) !== "undefined" ? !options.forcePushNotification : (0, $fbfdf11c2e07721a$export$882c355a4e040212)(callRequest);
        this._transport.send(payload, topic, silent);
    }
    async _sendResponse(response) {
        const encryptionPayload = await this._encrypt(response);
        const topic = this.peerId;
        const payload = JSON.stringify(encryptionPayload);
        const silent = true;
        this._transport.send(payload, topic, silent);
    }
    async _sendSessionRequest(request, errorMsg, options) {
        this._sendRequest(request, options);
        this._subscribeToSessionResponse(request.id, errorMsg);
    }
    _sendCallRequest(request, options) {
        this._sendRequest(request, options);
        this._eventManager.trigger({
            event: "call_request_sent",
            params: [
                {
                    request: request,
                    options: options
                }
            ]
        });
        return this._subscribeToCallResponse(request.id);
    }
    _formatRequest(request) {
        if (typeof request.method === "undefined") throw new Error((0, $a54b6ede9afe5260$export$d284d2b67d122b06));
        const formattedRequest = {
            id: typeof request.id === "undefined" ? (0, $0a9a41272ffd2cc1$export$2f5364a5d4b80251)() : request.id,
            jsonrpc: "2.0",
            method: request.method,
            params: typeof request.params === "undefined" ? [] : request.params
        };
        return formattedRequest;
    }
    _formatResponse(response) {
        if (typeof response.id === "undefined") throw new Error((0, $a54b6ede9afe5260$export$b728a3781ce730));
        const baseResponse = {
            id: response.id,
            jsonrpc: "2.0"
        };
        if ((0, $fbfdf11c2e07721a$export$ec4292c7205b27a1)(response)) {
            const error = (0, $0da9db9ff9940f21$export$94837ed80cea2156)(response.error);
            const errorResponse = Object.assign(Object.assign(Object.assign({}, baseResponse), response), {
                error: error
            });
            return errorResponse;
        } else if ((0, $fbfdf11c2e07721a$export$bf64516915508215)(response)) {
            const successResponse = Object.assign(Object.assign({}, baseResponse), response);
            return successResponse;
        }
        throw new Error((0, $a54b6ede9afe5260$export$74b421ca1ff0efe7));
    }
    _handleSessionDisconnect(errorMsg) {
        const message = errorMsg || "Session Disconnected";
        if (!this._connected) {
            if (this._qrcodeModal) this._qrcodeModal.close();
            (0, $5ba673e8a8315e9b$export$1609d3fefbbf941f)((0, $07fea8146e621393$export$102966ddb8cb050));
        }
        if (this._connected) this._connected = false;
        if (this._handshakeId) this._handshakeId = 0;
        if (this._handshakeTopic) this._handshakeTopic = "";
        if (this._peerId) this._peerId = "";
        this._eventManager.trigger({
            event: "disconnect",
            params: [
                {
                    message: message
                }
            ]
        });
        this._removeStorageSession();
        this.transportClose();
    }
    _handleSessionResponse(errorMsg, sessionParams) {
        if (sessionParams) {
            if (sessionParams.approved) {
                if (!this._connected) {
                    this._connected = true;
                    if (sessionParams.chainId) this.chainId = sessionParams.chainId;
                    if (sessionParams.accounts) this.accounts = sessionParams.accounts;
                    if (sessionParams.peerId && !this.peerId) this.peerId = sessionParams.peerId;
                    if (sessionParams.peerMeta && !this.peerMeta) this.peerMeta = sessionParams.peerMeta;
                    this._eventManager.trigger({
                        event: "connect",
                        params: [
                            {
                                peerId: this.peerId,
                                peerMeta: this.peerMeta,
                                chainId: this.chainId,
                                accounts: this.accounts
                            }
                        ]
                    });
                } else {
                    if (sessionParams.chainId) this.chainId = sessionParams.chainId;
                    if (sessionParams.accounts) this.accounts = sessionParams.accounts;
                    this._eventManager.trigger({
                        event: "session_update",
                        params: [
                            {
                                chainId: this.chainId,
                                accounts: this.accounts
                            }
                        ]
                    });
                }
                this._manageStorageSession();
            } else this._handleSessionDisconnect(errorMsg);
        } else this._handleSessionDisconnect(errorMsg);
    }
    async _handleIncomingMessages(socketMessage) {
        const activeTopics = [
            this.clientId,
            this.handshakeTopic
        ];
        if (!activeTopics.includes(socketMessage.topic)) return;
        let encryptionPayload;
        try {
            encryptionPayload = JSON.parse(socketMessage.payload);
        } catch (error) {
            return;
        }
        const payload = await this._decrypt(encryptionPayload);
        if (payload) this._eventManager.trigger(payload);
    }
    _subscribeToSessionRequest() {
        this._transport.subscribe(this.handshakeTopic);
    }
    _subscribeToResponse(id, callback) {
        this.on(`response:${id}`, callback);
    }
    _subscribeToSessionResponse(id, errorMsg) {
        this._subscribeToResponse(id, (error, payload)=>{
            if (error) {
                this._handleSessionResponse(error.message);
                return;
            }
            if ((0, $fbfdf11c2e07721a$export$bf64516915508215)(payload)) this._handleSessionResponse(errorMsg, payload.result);
            else if (payload.error && payload.error.message) this._handleSessionResponse(payload.error.message);
            else this._handleSessionResponse(errorMsg);
        });
    }
    _subscribeToCallResponse(id) {
        return new Promise((resolve, reject)=>{
            this._subscribeToResponse(id, (error, payload)=>{
                if (error) {
                    reject(error);
                    return;
                }
                if ((0, $fbfdf11c2e07721a$export$bf64516915508215)(payload)) resolve(payload.result);
                else if (payload.error && payload.error.message) reject(payload.error);
                else reject(new Error((0, $a54b6ede9afe5260$export$74b421ca1ff0efe7)));
            });
        });
    }
    _subscribeToInternalEvents() {
        this.on("display_uri", ()=>{
            if (this._qrcodeModal) this._qrcodeModal.open(this.uri, ()=>{
                this._eventManager.trigger({
                    event: "modal_closed",
                    params: []
                });
            }, this._qrcodeModalOptions);
        });
        this.on("connect", ()=>{
            if (this._qrcodeModal) this._qrcodeModal.close();
        });
        this.on("call_request_sent", (error, payload)=>{
            const { request: request } = payload.params[0];
            if ((0, $4397f25fd0309dd4$export$d0a8044dce8ff2fc)() && this._signingMethods.includes(request.method)) {
                const mobileLinkUrl = (0, $5ba673e8a8315e9b$export$36f42a3d63632e68)((0, $07fea8146e621393$export$102966ddb8cb050));
                if (mobileLinkUrl) window.location.href = mobileLinkUrl.href;
            }
        });
        this.on("wc_sessionRequest", (error, payload)=>{
            if (error) this._eventManager.trigger({
                event: "error",
                params: [
                    {
                        code: "SESSION_REQUEST_ERROR",
                        message: error.toString()
                    }
                ]
            });
            this.handshakeId = payload.id;
            this.peerId = payload.params[0].peerId;
            this.peerMeta = payload.params[0].peerMeta;
            const internalPayload = Object.assign(Object.assign({}, payload), {
                method: "session_request"
            });
            this._eventManager.trigger(internalPayload);
        });
        this.on("wc_sessionUpdate", (error, payload)=>{
            if (error) this._handleSessionResponse(error.message);
            this._handleSessionResponse("Session disconnected", payload.params[0]);
        });
    }
    _initTransport() {
        this._transport.on("message", (socketMessage)=>this._handleIncomingMessages(socketMessage));
        this._transport.on("open", ()=>this._eventManager.trigger({
                event: "transport_open",
                params: []
            }));
        this._transport.on("close", ()=>this._eventManager.trigger({
                event: "transport_close",
                params: []
            }));
        this._transport.on("error", ()=>this._eventManager.trigger({
                event: "transport_error",
                params: [
                    "Websocket connection failed"
                ]
            }));
        this._transport.open();
    }
    _formatUri() {
        const protocol = this.protocol;
        const handshakeTopic = this.handshakeTopic;
        const version = this.version;
        const bridge = encodeURIComponent(this.bridge);
        const key = this.key;
        const uri = `${protocol}:${handshakeTopic}@${version}?bridge=${bridge}&key=${key}`;
        return uri;
    }
    _parseUri(uri) {
        const result = (0, $cb4230317c4fae18$export$f0e17f110fdf26d7)(uri);
        if (result.protocol === this.protocol) {
            if (!result.handshakeTopic) throw Error("Invalid or missing handshakeTopic parameter value");
            const handshakeTopic = result.handshakeTopic;
            if (!result.bridge) throw Error("Invalid or missing bridge url parameter value");
            const bridge = decodeURIComponent(result.bridge);
            if (!result.key) throw Error("Invalid or missing key parameter value");
            const key = result.key;
            return {
                handshakeTopic: handshakeTopic,
                bridge: bridge,
                key: key
            };
        } else throw new Error((0, $a54b6ede9afe5260$export$e4155024a1048b1c));
    }
    async _generateKey() {
        if (this._cryptoLib) {
            const result = await this._cryptoLib.generateKey();
            return result;
        }
        return null;
    }
    async _encrypt(data) {
        const key = this._key;
        if (this._cryptoLib && key) {
            const result = await this._cryptoLib.encrypt(data, key);
            return result;
        }
        return null;
    }
    async _decrypt(payload) {
        const key = this._key;
        if (this._cryptoLib && key) {
            const result = await this._cryptoLib.decrypt(payload, key);
            return result;
        }
        return null;
    }
    _getStorageSession() {
        let result = null;
        if (this._sessionStorage) result = this._sessionStorage.getSession();
        return result;
    }
    _setStorageSession() {
        if (this._sessionStorage) this._sessionStorage.setSession(this.session);
    }
    _removeStorageSession() {
        if (this._sessionStorage) this._sessionStorage.removeSession();
    }
    _manageStorageSession() {
        if (this._connected) this._setStorageSession();
        else this._removeStorageSession();
    }
    _registerPushServer(pushServerOpts) {
        if (!pushServerOpts.url || typeof pushServerOpts.url !== "string") throw Error("Invalid or missing pushServerOpts.url parameter value");
        if (!pushServerOpts.type || typeof pushServerOpts.type !== "string") throw Error("Invalid or missing pushServerOpts.type parameter value");
        if (!pushServerOpts.token || typeof pushServerOpts.token !== "string") throw Error("Invalid or missing pushServerOpts.token parameter value");
        const pushSubscription = {
            bridge: this.bridge,
            topic: this.clientId,
            type: pushServerOpts.type,
            token: pushServerOpts.token,
            peerName: "",
            language: pushServerOpts.language || ""
        };
        this.on("connect", async (error, payload)=>{
            if (error) throw error;
            if (pushServerOpts.peerMeta) {
                const peerName = payload.params[0].peerMeta.name;
                pushSubscription.peerName = peerName;
            }
            try {
                const response = await fetch(`${pushServerOpts.url}/new`, {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(pushSubscription)
                });
                const json = await response.json();
                if (!json.success) throw Error("Failed to register in Push Server");
            } catch (error) {
                throw Error("Failed to register in Push Server");
            }
        });
    }
    constructor(opts){
        this.protocol = "wc";
        this.version = 1;
        this._bridge = "";
        this._key = null;
        this._clientId = "";
        this._clientMeta = null;
        this._peerId = "";
        this._peerMeta = null;
        this._handshakeId = 0;
        this._handshakeTopic = "";
        this._connected = false;
        this._accounts = [];
        this._chainId = 0;
        this._networkId = 0;
        this._rpcUrl = "";
        this._eventManager = new (0, $6ff2ee7229921df8$export$2e2bcd8739ae039)();
        this._clientMeta = (0, $4397f25fd0309dd4$export$2d100c5be8d65eb6)() || opts.connectorOpts.clientMeta || null;
        this._cryptoLib = opts.cryptoLib;
        this._sessionStorage = opts.sessionStorage || new (0, $e5d2cf756046daa2$export$2e2bcd8739ae039)(opts.connectorOpts.storageId);
        this._qrcodeModal = opts.connectorOpts.qrcodeModal;
        this._qrcodeModalOptions = opts.connectorOpts.qrcodeModalOptions;
        this._signingMethods = [
            ...(0, $b71c237f18518b05$export$9e4c3f5a97a9dcc3),
            ...opts.connectorOpts.signingMethods || []
        ];
        if (!opts.connectorOpts.bridge && !opts.connectorOpts.uri && !opts.connectorOpts.session) throw new Error((0, $a54b6ede9afe5260$export$7a2af96276314dd1));
        if (opts.connectorOpts.bridge) this.bridge = (0, $abea7bccac8b5f35$export$93ba7ece4fc32f8a)(opts.connectorOpts.bridge);
        if (opts.connectorOpts.uri) this.uri = opts.connectorOpts.uri;
        const session = opts.connectorOpts.session || this._getStorageSession();
        if (session) this.session = session;
        if (this.handshakeId) this._subscribeToSessionResponse(this.handshakeId, "Session request rejected");
        this._transport = opts.transport || new (0, $81eca0b5d0fd3720$export$2e2bcd8739ae039)({
            protocol: this.protocol,
            version: this.version,
            url: this.bridge,
            subscriptions: [
                this.clientId
            ]
        });
        this._subscribeToInternalEvents();
        this._initTransport();
        if (opts.connectorOpts.uri) this._subscribeToSessionRequest();
        if (opts.pushServerOpts) this._registerPushServer(opts.pushServerOpts);
    }
}
var $8d4ea25a69db1500$export$2e2bcd8739ae039 = $8d4ea25a69db1500$var$Connector;


var $168706d0a6c87e4f$exports = {};

$parcel$export($168706d0a6c87e4f$exports, "generateKey", function () { return $168706d0a6c87e4f$export$3a7728e868aa3ebd; });
$parcel$export($168706d0a6c87e4f$exports, "verifyHmac", function () { return $168706d0a6c87e4f$export$93ad2aa2bd731155; });
$parcel$export($168706d0a6c87e4f$exports, "encrypt", function () { return $168706d0a6c87e4f$export$5b0f6292f11d1d18; });
$parcel$export($168706d0a6c87e4f$exports, "decrypt", function () { return $168706d0a6c87e4f$export$e85a0c9a1067c5d3; });
var $4d2179922e809b86$exports = {};
$parcel$export($4d2179922e809b86$exports, "randomBytes", function () { return $5c599142a758b0ac$export$5f828d93ff035aa8; });
$parcel$export($4d2179922e809b86$exports, "aesCbcEncrypt", function () { return $9520cc07f0ce51c1$export$c9d43017a409b226; });
$parcel$export($4d2179922e809b86$exports, "aesCbcDecrypt", function () { return $9520cc07f0ce51c1$export$49288eda994c6761; });
$parcel$export($4d2179922e809b86$exports, "hmacSha256Sign", function () { return $3ffe2662492d5057$export$9fd309376b6641d3; });

function $5c599142a758b0ac$export$5f828d93ff035aa8(length) {
    const browserCrypto = $acc49a9628dc2606$exports.getBrowerCrypto();
    return browserCrypto.getRandomValues(new Uint8Array(length));
}



const $cbd0e0434a0f0410$export$37e1c246ed1b49f2 = 0;
const $cbd0e0434a0f0410$export$cf0ae40a9c9fc3f7 = 1;
const $cbd0e0434a0f0410$export$1266b059a746a22b = 16;
const $cbd0e0434a0f0410$export$f2e288260fb130db = 32;
const $cbd0e0434a0f0410$export$182c8efa5c6e90ac = 64;
const $cbd0e0434a0f0410$export$d70ce1e12e9d5cef = 128;
const $cbd0e0434a0f0410$export$953cb02a26682ea5 = 256;
const $cbd0e0434a0f0410$export$74ad9631b3a87abc = 512;
const $cbd0e0434a0f0410$export$5eda6c44649508f9 = 1024;


const $61546dd2a56b34e4$export$57b321afd44811e7 = (0, $cbd0e0434a0f0410$export$953cb02a26682ea5);
const $61546dd2a56b34e4$export$62e8813dced0812a = (0, $cbd0e0434a0f0410$export$953cb02a26682ea5);
const $61546dd2a56b34e4$export$b5c923943c7f0255 = "AES-CBC";
const $61546dd2a56b34e4$export$21e3339a05d71ed = `SHA-${$61546dd2a56b34e4$export$57b321afd44811e7}`;
const $61546dd2a56b34e4$export$37d64ec71bf22ed2 = "HMAC";
const $61546dd2a56b34e4$export$9395dcba8bd30070 = "SHA-256";
const $61546dd2a56b34e4$export$b10921a0a344906 = "SHA-512";
const $61546dd2a56b34e4$export$53dc593bd6b5640d = `aes-${$61546dd2a56b34e4$export$57b321afd44811e7}-cbc`;
const $61546dd2a56b34e4$export$702c83b43e733a7e = `sha${$61546dd2a56b34e4$export$62e8813dced0812a}`;
const $61546dd2a56b34e4$export$11227fa01ad79d8 = "sha256";
const $61546dd2a56b34e4$export$40214bc1ad6db763 = "sha512";
const $61546dd2a56b34e4$export$565769138b375849 = "ripemd160";
const $61546dd2a56b34e4$export$d8332b4891ba289a = (0, $cbd0e0434a0f0410$export$cf0ae40a9c9fc3f7);
const $61546dd2a56b34e4$export$ff7f6eaed58f6467 = (0, $cbd0e0434a0f0410$export$f2e288260fb130db);
const $61546dd2a56b34e4$export$3b52de7932b3569f = (0, $cbd0e0434a0f0410$export$1266b059a746a22b);
const $61546dd2a56b34e4$export$e7fdf9c90f561019 = (0, $cbd0e0434a0f0410$export$f2e288260fb130db);


const $025631166ca66c13$export$1d4d1d5262be036e = "hex";
const $025631166ca66c13$export$8e33b095afc64663 = "utf8";


const $2d74d1ad2f1d60d0$export$b33451774d73cfd5 = "Bad MAC";



const $59f18640b7ec7d46$export$70ca4c927d020663 = "encrypt";
const $59f18640b7ec7d46$export$6aff24c0e778d7b7 = "decrypt";
const $59f18640b7ec7d46$export$bf68c38c996091ff = "sign";
const $59f18640b7ec7d46$export$d956658bc4106b57 = "verify";




function $95cbde16655ae687$export$6f29ed9fbf36cb16(type) {
    return type === (0, $61546dd2a56b34e4$export$b5c923943c7f0255) ? {
        length: (0, $61546dd2a56b34e4$export$57b321afd44811e7),
        name: (0, $61546dd2a56b34e4$export$b5c923943c7f0255)
    } : {
        hash: {
            name: (0, $61546dd2a56b34e4$export$21e3339a05d71ed)
        },
        name: (0, $61546dd2a56b34e4$export$37d64ec71bf22ed2)
    };
}
function $95cbde16655ae687$export$f64f7bbcb068a5cf(type) {
    return type === (0, $61546dd2a56b34e4$export$b5c923943c7f0255) ? [
        (0, $59f18640b7ec7d46$export$70ca4c927d020663),
        (0, $59f18640b7ec7d46$export$6aff24c0e778d7b7)
    ] : [
        (0, $59f18640b7ec7d46$export$bf68c38c996091ff),
        (0, $59f18640b7ec7d46$export$d956658bc4106b57)
    ];
}
async function $95cbde16655ae687$export$78c6e1b064d8507a(cryptoKey, type = (0, $61546dd2a56b34e4$export$b5c923943c7f0255)) {
    const subtle = $acc49a9628dc2606$exports.getSubtleCrypto();
    return new Uint8Array(await subtle.exportKey("raw", cryptoKey));
}
async function $95cbde16655ae687$export$e93649673a333adf(buffer, type = (0, $61546dd2a56b34e4$export$b5c923943c7f0255)) {
    return $acc49a9628dc2606$exports.getSubtleCrypto().importKey("raw", buffer, $95cbde16655ae687$export$6f29ed9fbf36cb16(type), true, $95cbde16655ae687$export$f64f7bbcb068a5cf(type));
}
async function $95cbde16655ae687$export$41e0508eb63addd2(iv, key, data) {
    const subtle = $acc49a9628dc2606$exports.getSubtleCrypto();
    const cryptoKey = await $95cbde16655ae687$export$e93649673a333adf(key, (0, $61546dd2a56b34e4$export$b5c923943c7f0255));
    const result = await subtle.encrypt({
        iv: iv,
        name: (0, $61546dd2a56b34e4$export$b5c923943c7f0255)
    }, cryptoKey, data);
    return new Uint8Array(result);
}
async function $95cbde16655ae687$export$a0e91cd3effa6beb(iv, key, data) {
    const subtle = $acc49a9628dc2606$exports.getSubtleCrypto();
    const cryptoKey = await $95cbde16655ae687$export$e93649673a333adf(key, (0, $61546dd2a56b34e4$export$b5c923943c7f0255));
    const result = await subtle.decrypt({
        iv: iv,
        name: (0, $61546dd2a56b34e4$export$b5c923943c7f0255)
    }, cryptoKey, data);
    return new Uint8Array(result);
}
async function $95cbde16655ae687$export$8f8f3ede092ed4ff(key, data) {
    const subtle = $acc49a9628dc2606$exports.getSubtleCrypto();
    const cryptoKey = await $95cbde16655ae687$export$e93649673a333adf(key, (0, $61546dd2a56b34e4$export$37d64ec71bf22ed2));
    const signature = await subtle.sign({
        length: (0, $61546dd2a56b34e4$export$62e8813dced0812a),
        name: (0, $61546dd2a56b34e4$export$37d64ec71bf22ed2)
    }, cryptoKey, data);
    return new Uint8Array(signature);
}
async function $95cbde16655ae687$export$288acb327d57e925(key, data) {
    const subtle = $acc49a9628dc2606$exports.getSubtleCrypto();
    const cryptoKey = await $95cbde16655ae687$export$e93649673a333adf(key, (0, $61546dd2a56b34e4$export$37d64ec71bf22ed2));
    const signature = await subtle.sign({
        length: (0, $cbd0e0434a0f0410$export$74ad9631b3a87abc),
        name: (0, $61546dd2a56b34e4$export$37d64ec71bf22ed2)
    }, cryptoKey, data);
    return new Uint8Array(signature);
}
async function $95cbde16655ae687$export$b1fb4bee277f22e3(data) {
    const subtle = $acc49a9628dc2606$exports.getSubtleCrypto();
    const result = await subtle.digest({
        name: (0, $61546dd2a56b34e4$export$9395dcba8bd30070)
    }, data);
    return new Uint8Array(result);
}
async function $95cbde16655ae687$export$5cdfdb6db5e33bae(data) {
    const subtle = $acc49a9628dc2606$exports.getSubtleCrypto();
    const result = await subtle.digest({
        name: (0, $61546dd2a56b34e4$export$b10921a0a344906)
    }, data);
    return new Uint8Array(result);
}


function $9520cc07f0ce51c1$export$c9d43017a409b226(iv, key, data) {
    return (0, $95cbde16655ae687$export$41e0508eb63addd2)(iv, key, data);
}
function $9520cc07f0ce51c1$export$49288eda994c6761(iv, key, data) {
    return (0, $95cbde16655ae687$export$a0e91cd3effa6beb)(iv, key, data);
}



var $143f0de29ff481ed$exports = {};
$parcel$export($143f0de29ff481ed$exports, "randomBytes", function () { return $acc49a9628dc2606$exports.randomBytes; });
$parcel$export($143f0de29ff481ed$exports, "hmacSha256Sign", function () { return $acc49a9628dc2606$exports.hmacSha256Sign; });
$parcel$export($143f0de29ff481ed$exports, "aesCbcEncrypt", function () { return $acc49a9628dc2606$exports.aesCbcEncrypt; });
$parcel$export($143f0de29ff481ed$exports, "aesCbcDecrypt", function () { return $acc49a9628dc2606$exports.aesCbcDecrypt; });
$parcel$export($143f0de29ff481ed$exports, "isConstantTime", function () { return $acc49a9628dc2606$exports.isConstantTime; });
$parcel$export($143f0de29ff481ed$exports, "isConstantTime", function () { return $283742bc3c969feb$export$6f1587ff4769f507; });



const $daa326de430c494b$var$PADDING = [
    [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16
    ],
    [
        15,
        15,
        15,
        15,
        15,
        15,
        15,
        15,
        15,
        15,
        15,
        15,
        15,
        15,
        15
    ],
    [
        14,
        14,
        14,
        14,
        14,
        14,
        14,
        14,
        14,
        14,
        14,
        14,
        14,
        14
    ],
    [
        13,
        13,
        13,
        13,
        13,
        13,
        13,
        13,
        13,
        13,
        13,
        13,
        13
    ],
    [
        12,
        12,
        12,
        12,
        12,
        12,
        12,
        12,
        12,
        12,
        12,
        12
    ],
    [
        11,
        11,
        11,
        11,
        11,
        11,
        11,
        11,
        11,
        11,
        11
    ],
    [
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10
    ],
    [
        9,
        9,
        9,
        9,
        9,
        9,
        9,
        9,
        9
    ],
    [
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8
    ],
    [
        7,
        7,
        7,
        7,
        7,
        7,
        7
    ],
    [
        6,
        6,
        6,
        6,
        6,
        6
    ],
    [
        5,
        5,
        5,
        5,
        5
    ],
    [
        4,
        4,
        4,
        4
    ],
    [
        3,
        3,
        3
    ],
    [
        2,
        2
    ],
    [
        1
    ]
];
const $daa326de430c494b$export$d50f98f934c5e59a = {
    pad (plaintext) {
        const padding = $daa326de430c494b$var$PADDING[plaintext.byteLength % 16 || 0];
        const result = new Uint8Array(plaintext.byteLength + padding.length);
        result.set(plaintext);
        result.set(padding, plaintext.byteLength);
        return result;
    },
    unpad (padded) {
        return padded.subarray(0, padded.byteLength - padded[padded.byteLength - 1]);
    }
};


var $385802d386343242$exports = {};


function $283742bc3c969feb$export$a7a9523472993e97(condition, message) {
    if (!condition) throw new Error(message || "Assertion failed");
}
function $283742bc3c969feb$export$6f1587ff4769f507(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;
    let res = 0;
    for(let i = 0; i < arr1.length; i++)res |= arr1[i] ^ arr2[i];
    return res === 0;
}


$parcel$exportWildcard($143f0de29ff481ed$exports, $385802d386343242$exports);


async function $3ffe2662492d5057$export$9fd309376b6641d3(key, msg) {
    const result = await (0, $95cbde16655ae687$export$8f8f3ede092ed4ff)(key, msg);
    return result;
}
async function $3ffe2662492d5057$export$5782b7a1d40c5c48(key, msg, sig) {
    const expectedSig = await (0, $95cbde16655ae687$export$8f8f3ede092ed4ff)(key, msg);
    const result = (0, $283742bc3c969feb$export$6f1587ff4769f507)(expectedSig, sig);
    return result;
}
async function $3ffe2662492d5057$export$eed19c1b09501b8b(key, msg) {
    const result = await (0, $95cbde16655ae687$export$288acb327d57e925)(key, msg);
    return result;
}
async function $3ffe2662492d5057$export$498d47a31c102b1b(key, msg, sig) {
    const expectedSig = await (0, $95cbde16655ae687$export$288acb327d57e925)(key, msg);
    const result = (0, $283742bc3c969feb$export$6f1587ff4769f507)(expectedSig, sig);
    return result;
}



async function $8dc7fc09f49f2652$export$bced8d2aada2d1c9(msg) {
    const result = await (0, $95cbde16655ae687$export$b1fb4bee277f22e3)(msg);
    return result;
}
async function $8dc7fc09f49f2652$export$a888d2532e6dc7bb(msg) {
    const result = await (0, $95cbde16655ae687$export$5cdfdb6db5e33bae)(msg);
    return result;
}
async function $8dc7fc09f49f2652$export$d1cea0ee4e3f0d3e(msg) {
    throw new Error("Not supported for Browser async methods, use sync instead!");
}




$parcel$exportWildcard($4d2179922e809b86$exports, $143f0de29ff481ed$exports);




async function $168706d0a6c87e4f$export$3a7728e868aa3ebd(length) {
    const _length = (length || 256) / 8;
    const bytes = $5c599142a758b0ac$export$5f828d93ff035aa8(_length);
    const result = (0, $ecd06230a68a2b13$export$9e8479d6da7d49b)($7551102ca62ff8ae$export$1eb84f36023740c(bytes));
    return result;
}
async function $168706d0a6c87e4f$export$93ad2aa2bd731155(payload, key) {
    const cipherText = $7551102ca62ff8ae$export$c318328836320ba5(payload.data);
    const iv = $7551102ca62ff8ae$export$c318328836320ba5(payload.iv);
    const hmac = $7551102ca62ff8ae$export$c318328836320ba5(payload.hmac);
    const hmacHex = $7551102ca62ff8ae$export$9794ce7150434ee(hmac, false);
    const unsigned = $7551102ca62ff8ae$export$e989d07ee174d99d(cipherText, iv);
    const chmac = await $3ffe2662492d5057$export$9fd309376b6641d3(key, unsigned);
    const chmacHex = $7551102ca62ff8ae$export$9794ce7150434ee(chmac, false);
    if ($7551102ca62ff8ae$export$999052bd72869f3a(hmacHex) === $7551102ca62ff8ae$export$999052bd72869f3a(chmacHex)) return true;
    return false;
}
async function $168706d0a6c87e4f$export$5b0f6292f11d1d18(data, key, providedIv) {
    const _key = $7551102ca62ff8ae$export$9b5ed7081d0cfa58((0, $ecd06230a68a2b13$export$a7b301160c60ad85)(key));
    const ivArrayBuffer = providedIv || await $168706d0a6c87e4f$export$3a7728e868aa3ebd(128);
    const iv = $7551102ca62ff8ae$export$9b5ed7081d0cfa58((0, $ecd06230a68a2b13$export$a7b301160c60ad85)(ivArrayBuffer));
    const ivHex = $7551102ca62ff8ae$export$9794ce7150434ee(iv, false);
    const contentString = JSON.stringify(data);
    const content = $7551102ca62ff8ae$export$161387ce93217b03(contentString);
    const cipherText = await $9520cc07f0ce51c1$export$c9d43017a409b226(iv, _key, content);
    const cipherTextHex = $7551102ca62ff8ae$export$9794ce7150434ee(cipherText, false);
    const unsigned = $7551102ca62ff8ae$export$e989d07ee174d99d(cipherText, iv);
    const hmac = await $3ffe2662492d5057$export$9fd309376b6641d3(_key, unsigned);
    const hmacHex = $7551102ca62ff8ae$export$9794ce7150434ee(hmac, false);
    return {
        data: cipherTextHex,
        hmac: hmacHex,
        iv: ivHex
    };
}
async function $168706d0a6c87e4f$export$e85a0c9a1067c5d3(payload, key) {
    const _key = $7551102ca62ff8ae$export$9b5ed7081d0cfa58((0, $ecd06230a68a2b13$export$a7b301160c60ad85)(key));
    if (!_key) throw new Error("Missing key: required for decryption");
    const verified = await $168706d0a6c87e4f$export$93ad2aa2bd731155(payload, _key);
    if (!verified) return null;
    const cipherText = $7551102ca62ff8ae$export$c318328836320ba5(payload.data);
    const iv = $7551102ca62ff8ae$export$c318328836320ba5(payload.iv);
    const buffer = await $9520cc07f0ce51c1$export$49288eda994c6761(iv, _key, cipherText);
    const utf8 = $7551102ca62ff8ae$export$72f33cf4e661f197(buffer);
    let data;
    try {
        data = JSON.parse(utf8);
    } catch (error) {
        return null;
    }
    return data;
}


class $761d2c651afa0f1a$var$WalletConnect extends (0, $8d4ea25a69db1500$export$2e2bcd8739ae039) {
    constructor(connectorOpts, pushServerOpts){
        super({
            cryptoLib: $168706d0a6c87e4f$exports,
            connectorOpts: connectorOpts,
            pushServerOpts: pushServerOpts
        });
    }
}
var $761d2c651afa0f1a$export$2e2bcd8739ae039 = $761d2c651afa0f1a$var$WalletConnect;


var $3d3115b5882cbab7$exports = {};
"use strict";
var $3d3115b5882cbab7$var$__awaiter = $3d3115b5882cbab7$exports && $3d3115b5882cbab7$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $3d3115b5882cbab7$var$__importDefault = $3d3115b5882cbab7$exports && $3d3115b5882cbab7$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($3d3115b5882cbab7$exports, "__esModule", {
    value: true
});
$3d3115b5882cbab7$exports.KeplrWalletConnectV1 = void 0;
var $546da64b15370fe7$exports = {};
"use strict";
var $546da64b15370fe7$var$__createBinding = $546da64b15370fe7$exports && $546da64b15370fe7$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $546da64b15370fe7$var$__exportStar = $546da64b15370fe7$exports && $546da64b15370fe7$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $546da64b15370fe7$var$__createBinding(exports1, m, p);
};
Object.defineProperty($546da64b15370fe7$exports, "__esModule", {
    value: true
});

$546da64b15370fe7$var$__exportStar((parcelRequire("aGpG0")), $546da64b15370fe7$exports);

$546da64b15370fe7$var$__exportStar((parcelRequire("5pFPa")), $546da64b15370fe7$exports);

$546da64b15370fe7$var$__exportStar((parcelRequire("3RsMA")), $546da64b15370fe7$exports);

$546da64b15370fe7$var$__exportStar((parcelRequire("barq0")), $546da64b15370fe7$exports);




const $3d3115b5882cbab7$var$deepmerge_1 = $3d3115b5882cbab7$var$__importDefault((parcelRequire("8LGKR")));

var $gzLuY = parcelRequire("gzLuY");
var $c521a793bfff88c4$exports = {};
"use strict";
var $c521a793bfff88c4$var$__createBinding = $c521a793bfff88c4$exports && $c521a793bfff88c4$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c521a793bfff88c4$var$__exportStar = $c521a793bfff88c4$exports && $c521a793bfff88c4$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c521a793bfff88c4$var$__createBinding(exports1, m, p);
};
Object.defineProperty($c521a793bfff88c4$exports, "__esModule", {
    value: true
});

$c521a793bfff88c4$var$__exportStar((parcelRequire("2UwcM")), $c521a793bfff88c4$exports);

$c521a793bfff88c4$var$__exportStar((parcelRequire("b3McW")), $c521a793bfff88c4$exports);

$c521a793bfff88c4$var$__exportStar((parcelRequire("b1wkq")), $c521a793bfff88c4$exports);

$c521a793bfff88c4$var$__exportStar((parcelRequire("lcQNw")), $c521a793bfff88c4$exports);

$c521a793bfff88c4$var$__exportStar((parcelRequire("1JhRD")), $c521a793bfff88c4$exports);

$c521a793bfff88c4$var$__exportStar((parcelRequire("aGL8U")), $c521a793bfff88c4$exports);

$c521a793bfff88c4$var$__exportStar((parcelRequire("jr1yD")), $c521a793bfff88c4$exports);


// VersionFormatRegExp checks if a chainID is in the format required for parsing versions
// The chainID should be in the form: `{identifier}-{version}`
const $3d3115b5882cbab7$var$ChainVersionFormatRegExp = /(.+)-([\d]+)/;
function $3d3115b5882cbab7$var$parseChainId(chainId) {
    const split = chainId.split($3d3115b5882cbab7$var$ChainVersionFormatRegExp).filter(Boolean);
    if (split.length !== 2) return {
        identifier: chainId,
        version: 0
    };
    else return {
        identifier: split[0],
        version: parseInt(split[1])
    };
}
class $3d3115b5882cbab7$var$KeplrWalletConnectV1 {
    clearSaved() {
        return $3d3115b5882cbab7$var$__awaiter(this, void 0, void 0, function*() {
            const kvStore = this.options.kvStore;
            yield Promise.all([
                kvStore.set(this.getKeyHasEnabled(), null),
                kvStore.set(this.getKeyLastSeenKey(), null)
            ]);
        });
    }
    sendCustomRequest(request, options) {
        return $3d3115b5882cbab7$var$__awaiter(this, void 0, void 0, function*() {
            if (this.options.onBeforeSendRequest) yield this.options.onBeforeSendRequest(request, options);
            const res = yield this.connector.sendCustomRequest(request, options);
            if (this.options.onAfterSendRequest) yield this.options.onAfterSendRequest(res, request, options);
            return res;
        });
    }
    enable(chainIds) {
        return $3d3115b5882cbab7$var$__awaiter(this, void 0, void 0, function*() {
            if (typeof chainIds === "string") chainIds = [
                chainIds
            ];
            const hasEnabledChainIds = yield this.getHasEnabledChainIds();
            let allEnabled = true;
            for (const chainId of chainIds)if (hasEnabledChainIds.indexOf(chainId) < 0) {
                allEnabled = false;
                break;
            }
            if (allEnabled) return;
            yield this.sendCustomRequest({
                id: $0a9a41272ffd2cc1$export$2f5364a5d4b80251(),
                jsonrpc: "2.0",
                method: "keplr_enable_wallet_connect_v1",
                params: chainIds
            });
            yield this.saveHasEnabledChainIds(chainIds);
        });
    }
    getKeyHasEnabled() {
        return `${this.connector.session.handshakeTopic}-enabled`;
    }
    getHasEnabledChainIds() {
        var _a;
        return $3d3115b5882cbab7$var$__awaiter(this, void 0, void 0, function*() {
            return (_a = yield this.options.kvStore.get(this.getKeyHasEnabled())) !== null && _a !== void 0 ? _a : [];
        });
    }
    saveHasEnabledChainIds(chainIds) {
        return $3d3115b5882cbab7$var$__awaiter(this, void 0, void 0, function*() {
            const hasEnabledChainIds = yield this.getHasEnabledChainIds();
            for (const chainId of chainIds)if (hasEnabledChainIds.indexOf(chainId) < 0) hasEnabledChainIds.push(chainId);
            yield this.options.kvStore.set(this.getKeyHasEnabled(), hasEnabledChainIds);
        });
    }
    enigmaDecrypt(_chainId, _ciphertext, _nonce) {
        throw new Error("Not yet implemented");
    }
    enigmaEncrypt(_chainId, _contractCodeHash, // eslint-disable-next-line @typescript-eslint/ban-types
    _msg) {
        throw new Error("Not yet implemented");
    }
    experimentalSuggestChain(_chainInfo) {
        throw new Error("Not yet implemented");
    }
    getEnigmaPubKey(_chainId) {
        throw new Error("Not yet implemented");
    }
    getEnigmaTxEncryptionKey(_chainId, _nonce) {
        throw new Error("Not yet implemented");
    }
    getEnigmaUtils(_chainId) {
        throw new Error("Not yet implemented");
    }
    getKey(chainId) {
        return $3d3115b5882cbab7$var$__awaiter(this, void 0, void 0, function*() {
            const lastSeenKey = yield this.getLastSeenKey(chainId);
            if (lastSeenKey) return {
                address: $gzLuY.Buffer.from(lastSeenKey.address, "hex"),
                algo: lastSeenKey.algo,
                bech32Address: lastSeenKey.bech32Address,
                isKeystone: lastSeenKey.isKeystone,
                isNanoLedger: lastSeenKey.isNanoLedger,
                name: lastSeenKey.name,
                pubKey: $gzLuY.Buffer.from(lastSeenKey.pubKey, "hex")
            };
            const response = (yield this.sendCustomRequest({
                id: $0a9a41272ffd2cc1$export$2f5364a5d4b80251(),
                jsonrpc: "2.0",
                method: "keplr_get_key_wallet_connect_v1",
                params: [
                    chainId
                ]
            }))[0];
            yield this.saveLastSeenKey(chainId, response);
            return {
                address: $gzLuY.Buffer.from(response.address, "hex"),
                algo: response.algo,
                bech32Address: response.bech32Address,
                isKeystone: response.isKeystone,
                isNanoLedger: response.isNanoLedger,
                name: response.name,
                pubKey: $gzLuY.Buffer.from(response.pubKey, "hex")
            };
        });
    }
    getKeyLastSeenKey() {
        return `${this.connector.session.handshakeTopic}-key`;
    }
    getLastSeenKey(chainId) {
        return $3d3115b5882cbab7$var$__awaiter(this, void 0, void 0, function*() {
            const saved = yield this.getAllLastSeenKey();
            if (!saved) return undefined;
            return saved[chainId];
        });
    }
    getAllLastSeenKey() {
        return $3d3115b5882cbab7$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.options.kvStore.get(this.getKeyLastSeenKey());
        });
    }
    saveAllLastSeenKey(data) {
        return $3d3115b5882cbab7$var$__awaiter(this, void 0, void 0, function*() {
            yield this.options.kvStore.set(this.getKeyLastSeenKey(), data);
        });
    }
    saveLastSeenKey(chainId, response) {
        return $3d3115b5882cbab7$var$__awaiter(this, void 0, void 0, function*() {
            let saved = yield this.getAllLastSeenKey();
            if (!saved) saved = {};
            saved[chainId] = response;
            yield this.saveAllLastSeenKey(saved);
        });
    }
    signArbitrary(_chainId, _signer, _data) {
        throw new Error("Not yet implemented");
    }
    verifyArbitrary(_chainId, _signer, _data, _signature) {
        throw new Error("Not yet implemented");
    }
    signEthereum(_chainId, _signer, _data, _mode) {
        throw new Error("Not yet implemented");
    }
    signICNSAdr36(_chainId, _contractAddress, _owner, _username, _addressChainIds) {
        throw new Error("Not yet implemented");
    }
    getOfflineSigner(chainId) {
        return new $546da64b15370fe7$exports.CosmJSOfflineSigner(chainId, this);
    }
    getOfflineSignerAuto(chainId) {
        return $3d3115b5882cbab7$var$__awaiter(this, void 0, void 0, function*() {
            const key = yield this.getKey(chainId);
            if (key.isNanoLedger) return new $546da64b15370fe7$exports.CosmJSOfflineSignerOnlyAmino(chainId, this);
            return new $546da64b15370fe7$exports.CosmJSOfflineSigner(chainId, this);
        });
    }
    getOfflineSignerOnlyAmino(chainId) {
        return new $546da64b15370fe7$exports.CosmJSOfflineSignerOnlyAmino(chainId, this);
    }
    getSecret20ViewingKey(_chainId, _contractAddress) {
        throw new Error("Not yet implemented");
    }
    /**
     * In the extension environment, this API let the extension to send the tx on behalf of the client.
     * But, in the wallet connect environment, in order to send the tx on behalf of the client, wallet should receive the tx data from remote.
     * However, this approach is not efficient and hard to ensure the stability and `KeplrWalletConnect` should have the informations of rpc and rest endpoints.
     * So, rather than implementing this, just fallback to the client sided implementation or throw error of the client sided implementation is not delivered to the `options`.
     * @param chainId
     * @param stdTx
     * @param mode
     */ sendTx(chainId, tx, mode) {
        if (this.options.sendTx) return this.options.sendTx(chainId, tx, mode);
        throw new Error("send tx is not delivered by options");
    }
    signAmino(chainId, signer, signDoc, signOptions = {}) {
        var _a;
        return $3d3115b5882cbab7$var$__awaiter(this, void 0, void 0, function*() {
            return (yield this.sendCustomRequest({
                id: $0a9a41272ffd2cc1$export$2f5364a5d4b80251(),
                jsonrpc: "2.0",
                method: "keplr_sign_amino_wallet_connect_v1",
                params: [
                    chainId,
                    signer,
                    signDoc,
                    $3d3115b5882cbab7$var$deepmerge_1.default((_a = this.defaultOptions.sign) !== null && _a !== void 0 ? _a : {}, signOptions)
                ]
            }))[0];
        });
    }
    signDirect(_chainId, _signer, _signDoc, _signOptions = {}) {
        throw new Error("Not yet implemented");
    }
    suggestToken(_chainId, _contractAddress, _viewingKey) {
        throw new Error("Not yet implemented");
    }
    experimentalSignEIP712CosmosTx_v0(_chainId, _signer, _eip712, _signDoc, _signOptions = {}) {
        throw new Error("Not yet implemented");
    }
    getChainInfosWithoutEndpoints() {
        throw new Error("Not yet implemented");
    }
    disable(_chainIds) {
        throw new Error("Not yet implemented");
    }
    changeKeyRingName(_opts) {
        throw new Error("Not yet implemented");
    }
    constructor(connector, options = {}){
        this.connector = connector;
        this.options = options;
        this.version = "0.9.0";
        this.mode = "walletconnect";
        this.defaultOptions = {};
        this.onCallReqeust = (error, payload)=>$3d3115b5882cbab7$var$__awaiter(this, void 0, void 0, function*() {
                if (error) {
                    console.log(error);
                    return;
                }
                if (!payload) return;
                if (payload.method === "keplr_keystore_may_changed_event_wallet_connect_v1") {
                    const param = payload.params[0];
                    if (!param) return;
                    const lastSeenKeys = yield this.getAllLastSeenKey();
                    if (!lastSeenKeys) return;
                    const mayChangedKeyMap = {};
                    for (const mayChangedKey of param.keys)mayChangedKeyMap[mayChangedKey.chainIdentifier] = {
                        address: mayChangedKey.address,
                        algo: param.algo,
                        bech32Address: mayChangedKey.bech32Address,
                        isKeystone: param.isKeystone,
                        isNanoLedger: param.isNanoLedger,
                        name: param.name,
                        pubKey: mayChangedKey.pubKey
                    };
                    let hasChanged = false;
                    for (const chainId of Object.keys(lastSeenKeys)){
                        const savedKey = lastSeenKeys[chainId];
                        if (savedKey) {
                            const { identifier: identifier } = $3d3115b5882cbab7$var$parseChainId(chainId);
                            const mayChangedKey = mayChangedKeyMap[identifier];
                            if (mayChangedKey) {
                                if (mayChangedKey.algo !== savedKey.algo || mayChangedKey.name !== savedKey.name || mayChangedKey.isKeystone !== savedKey.isKeystone || mayChangedKey.isNanoLedger !== savedKey.isNanoLedger || mayChangedKey.address !== savedKey.address || mayChangedKey.bech32Address !== savedKey.bech32Address || mayChangedKey.pubKey !== savedKey.pubKey) {
                                    hasChanged = true;
                                    lastSeenKeys[chainId] = mayChangedKey;
                                }
                            }
                        }
                    }
                    if (hasChanged) {
                        yield this.saveAllLastSeenKey(lastSeenKeys);
                        window.dispatchEvent(new Event("keplr_keystorechange"));
                    }
                }
            });
        if (!options.kvStore) options.kvStore = new $c521a793bfff88c4$exports.IndexedDBKVStore("keplr_wallet_connect");
        connector.on("disconnect", ()=>{
            this.clearSaved();
        });
        connector.on("call_request", this.onCallReqeust);
    }
}
$3d3115b5882cbab7$exports.KeplrWalletConnectV1 = $3d3115b5882cbab7$var$KeplrWalletConnectV1;



class $87bfb1122f1dee8d$export$2e2bcd8739ae039 extends (0, $d967e091f8d134a2$export$2e2bcd8739ae039) {
    available() {
        return true;
    }
    connected() {
        return this.connector.connected;
    }
    async connect(network) {
        let key;
        try {
            this.connectModal.open();
            key = await super.connect(network);
            this.connectModal.close();
            return key;
        } catch (error) {
            this.connectModal.close();
            throw error;
        }
    }
    async enable(network) {
        await this.createSession();
        await this.provider.enable(network.chainId);
    }
    async disconnect() {
        var _this_provider;
        return (_this_provider = this.provider) === null || _this_provider === void 0 ? void 0 : _this_provider.clearSaved();
    }
    async forceDisconnect() {
        try {
            this.disconnect();
            this.connector.killSession();
        } catch (error) {
            console.log(error);
        }
    }
    getSigner(network) {
        if (!this.signer) {
            const { chainId: chainId } = network;
            // this.signer = await this.provider.getOfflineSignerAuto(chainId) // no signDirect support currently
            this.signer = this.provider.getOfflineSignerOnlyAmino(chainId);
        }
        return this.signer;
    }
    async createSession() {
        if (!this.connector.connected) {
            this.connector.createSession();
            return new Promise((resolve, reject)=>{
                this.connector.on("connect", (error)=>{
                    if (error) reject(error);
                    else {
                        this.provider = new (0, $3d3115b5882cbab7$exports.KeplrWalletConnectV1)(this.connector);
                        resolve();
                    }
                });
            });
        } else {
            this.provider = new (0, $3d3115b5882cbab7$exports.KeplrWalletConnectV1)(this.connector);
            return Promise.resolve();
        }
    }
    handleEnableError(network, error) {
        switch(error === null || error === void 0 ? void 0 : error.message){
            case `There is no chain info for ${network.chainId}`:
                throw new Error(`${network.prettyName} (${network.chainId}) is not supported`);
            default:
                super.handleEnableError(network, error);
        }
    }
    constructor({ connectModal: connectModal }){
        super();
        (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(this, "name", "keplr-mobile");
        (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(this, "label", "Keplr Mobile");
        (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(this, "keychangeEvent", "keplr_keystorechange");
        (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(this, "suggestChainSupport", false);
        this.connectModal = connectModal;
        this.connector = new (0, $761d2c651afa0f1a$export$2e2bcd8739ae039)({
            bridge: "https://bridge.walletconnect.org",
            signingMethods: [
                "keplr_enable_wallet_connect_v1",
                "keplr_sign_amino_wallet_connect_v1"
            ],
            qrcodeModal: this.connectModal
        });
    }
}




var $6cds3 = parcelRequire("6cds3");



var $6cds3 = parcelRequire("6cds3");
var $65a4d498522b436f$var$__defProp = Object.defineProperty;
var $65a4d498522b436f$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $65a4d498522b436f$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $65a4d498522b436f$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $65a4d498522b436f$var$__defNormalProp = (obj, key, value)=>key in obj ? $65a4d498522b436f$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $65a4d498522b436f$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($65a4d498522b436f$var$__hasOwnProp.call(b, prop)) $65a4d498522b436f$var$__defNormalProp(a, prop, b[prop]);
    if ($65a4d498522b436f$var$__getOwnPropSymbols) {
        for (var prop of $65a4d498522b436f$var$__getOwnPropSymbols(b))if ($65a4d498522b436f$var$__propIsEnum.call(b, prop)) $65a4d498522b436f$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $65a4d498522b436f$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($65a4d498522b436f$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $65a4d498522b436f$var$__getOwnPropSymbols) {
        for (var prop of $65a4d498522b436f$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $65a4d498522b436f$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/third-party/qrcodegen/index.ts
/**
 * @license QR Code generator library (TypeScript)
 * Copyright (c) Project Nayuki.
 * SPDX-License-Identifier: MIT
 */ var $65a4d498522b436f$var$qrcodegen;
((qrcodegen2)=>{
    const _QrCode = class {
        static encodeText(text, ecl) {
            const segs = qrcodegen2.QrSegment.makeSegments(text);
            return _QrCode.encodeSegments(segs, ecl);
        }
        static encodeBinary(data, ecl) {
            const seg = qrcodegen2.QrSegment.makeBytes(data);
            return _QrCode.encodeSegments([
                seg
            ], ecl);
        }
        static encodeSegments(segs, ecl, minVersion = 1, maxVersion = 40, mask = -1, boostEcl = true) {
            if (!(_QrCode.MIN_VERSION <= minVersion && minVersion <= maxVersion && maxVersion <= _QrCode.MAX_VERSION) || mask < -1 || mask > 7) throw new RangeError("Invalid value");
            let version;
            let dataUsedBits;
            for(version = minVersion;; version++){
                const dataCapacityBits2 = _QrCode.getNumDataCodewords(version, ecl) * 8;
                const usedBits = QrSegment.getTotalBits(segs, version);
                if (usedBits <= dataCapacityBits2) {
                    dataUsedBits = usedBits;
                    break;
                }
                if (version >= maxVersion) throw new RangeError("Data too long");
            }
            for (const newEcl of [
                _QrCode.Ecc.MEDIUM,
                _QrCode.Ecc.QUARTILE,
                _QrCode.Ecc.HIGH
            ])if (boostEcl && dataUsedBits <= _QrCode.getNumDataCodewords(version, newEcl) * 8) ecl = newEcl;
            let bb = [];
            for (const seg of segs){
                appendBits(seg.mode.modeBits, 4, bb);
                appendBits(seg.numChars, seg.mode.numCharCountBits(version), bb);
                for (const b of seg.getData())bb.push(b);
            }
            assert(bb.length == dataUsedBits);
            const dataCapacityBits = _QrCode.getNumDataCodewords(version, ecl) * 8;
            assert(bb.length <= dataCapacityBits);
            appendBits(0, Math.min(4, dataCapacityBits - bb.length), bb);
            appendBits(0, (8 - bb.length % 8) % 8, bb);
            assert(bb.length % 8 == 0);
            for(let padByte = 236; bb.length < dataCapacityBits; padByte ^= 253)appendBits(padByte, 8, bb);
            let dataCodewords = [];
            while(dataCodewords.length * 8 < bb.length)dataCodewords.push(0);
            bb.forEach((b, i)=>dataCodewords[i >>> 3] |= b << 7 - (i & 7));
            return new _QrCode(version, ecl, dataCodewords, mask);
        }
        getModule(x, y) {
            return 0 <= x && x < this.size && 0 <= y && y < this.size && this.modules[y][x];
        }
        getModules() {
            return this.modules;
        }
        drawFunctionPatterns() {
            for(let i = 0; i < this.size; i++){
                this.setFunctionModule(6, i, i % 2 == 0);
                this.setFunctionModule(i, 6, i % 2 == 0);
            }
            this.drawFinderPattern(3, 3);
            this.drawFinderPattern(this.size - 4, 3);
            this.drawFinderPattern(3, this.size - 4);
            const alignPatPos = this.getAlignmentPatternPositions();
            const numAlign = alignPatPos.length;
            for(let i = 0; i < numAlign; i++){
                for(let j = 0; j < numAlign; j++)if (!(i == 0 && j == 0 || i == 0 && j == numAlign - 1 || i == numAlign - 1 && j == 0)) this.drawAlignmentPattern(alignPatPos[i], alignPatPos[j]);
            }
            this.drawFormatBits(0);
            this.drawVersion();
        }
        drawFormatBits(mask) {
            const data = this.errorCorrectionLevel.formatBits << 3 | mask;
            let rem = data;
            for(let i = 0; i < 10; i++)rem = rem << 1 ^ (rem >>> 9) * 1335;
            const bits = (data << 10 | rem) ^ 21522;
            assert(bits >>> 15 == 0);
            for(let i = 0; i <= 5; i++)this.setFunctionModule(8, i, getBit(bits, i));
            this.setFunctionModule(8, 7, getBit(bits, 6));
            this.setFunctionModule(8, 8, getBit(bits, 7));
            this.setFunctionModule(7, 8, getBit(bits, 8));
            for(let i = 9; i < 15; i++)this.setFunctionModule(14 - i, 8, getBit(bits, i));
            for(let i = 0; i < 8; i++)this.setFunctionModule(this.size - 1 - i, 8, getBit(bits, i));
            for(let i = 8; i < 15; i++)this.setFunctionModule(8, this.size - 15 + i, getBit(bits, i));
            this.setFunctionModule(8, this.size - 8, true);
        }
        drawVersion() {
            if (this.version < 7) return;
            let rem = this.version;
            for(let i = 0; i < 12; i++)rem = rem << 1 ^ (rem >>> 11) * 7973;
            const bits = this.version << 12 | rem;
            assert(bits >>> 18 == 0);
            for(let i = 0; i < 18; i++){
                const color = getBit(bits, i);
                const a = this.size - 11 + i % 3;
                const b = Math.floor(i / 3);
                this.setFunctionModule(a, b, color);
                this.setFunctionModule(b, a, color);
            }
        }
        drawFinderPattern(x, y) {
            for(let dy = -4; dy <= 4; dy++)for(let dx = -4; dx <= 4; dx++){
                const dist = Math.max(Math.abs(dx), Math.abs(dy));
                const xx = x + dx;
                const yy = y + dy;
                if (0 <= xx && xx < this.size && 0 <= yy && yy < this.size) this.setFunctionModule(xx, yy, dist != 2 && dist != 4);
            }
        }
        drawAlignmentPattern(x, y) {
            for(let dy = -2; dy <= 2; dy++)for(let dx = -2; dx <= 2; dx++)this.setFunctionModule(x + dx, y + dy, Math.max(Math.abs(dx), Math.abs(dy)) != 1);
        }
        setFunctionModule(x, y, isDark) {
            this.modules[y][x] = isDark;
            this.isFunction[y][x] = true;
        }
        addEccAndInterleave(data) {
            const ver = this.version;
            const ecl = this.errorCorrectionLevel;
            if (data.length != _QrCode.getNumDataCodewords(ver, ecl)) throw new RangeError("Invalid argument");
            const numBlocks = _QrCode.NUM_ERROR_CORRECTION_BLOCKS[ecl.ordinal][ver];
            const blockEccLen = _QrCode.ECC_CODEWORDS_PER_BLOCK[ecl.ordinal][ver];
            const rawCodewords = Math.floor(_QrCode.getNumRawDataModules(ver) / 8);
            const numShortBlocks = numBlocks - rawCodewords % numBlocks;
            const shortBlockLen = Math.floor(rawCodewords / numBlocks);
            let blocks = [];
            const rsDiv = _QrCode.reedSolomonComputeDivisor(blockEccLen);
            for(let i = 0, k = 0; i < numBlocks; i++){
                let dat = data.slice(k, k + shortBlockLen - blockEccLen + (i < numShortBlocks ? 0 : 1));
                k += dat.length;
                const ecc = _QrCode.reedSolomonComputeRemainder(dat, rsDiv);
                if (i < numShortBlocks) dat.push(0);
                blocks.push(dat.concat(ecc));
            }
            let result = [];
            for(let i = 0; i < blocks[0].length; i++)blocks.forEach((block, j)=>{
                if (i != shortBlockLen - blockEccLen || j >= numShortBlocks) result.push(block[i]);
            });
            assert(result.length == rawCodewords);
            return result;
        }
        drawCodewords(data) {
            if (data.length != Math.floor(_QrCode.getNumRawDataModules(this.version) / 8)) throw new RangeError("Invalid argument");
            let i = 0;
            for(let right = this.size - 1; right >= 1; right -= 2){
                if (right == 6) right = 5;
                for(let vert = 0; vert < this.size; vert++)for(let j = 0; j < 2; j++){
                    const x = right - j;
                    const upward = (right + 1 & 2) == 0;
                    const y = upward ? this.size - 1 - vert : vert;
                    if (!this.isFunction[y][x] && i < data.length * 8) {
                        this.modules[y][x] = getBit(data[i >>> 3], 7 - (i & 7));
                        i++;
                    }
                }
            }
            assert(i == data.length * 8);
        }
        applyMask(mask) {
            if (mask < 0 || mask > 7) throw new RangeError("Mask value out of range");
            for(let y = 0; y < this.size; y++)for(let x = 0; x < this.size; x++){
                let invert;
                switch(mask){
                    case 0:
                        invert = (x + y) % 2 == 0;
                        break;
                    case 1:
                        invert = y % 2 == 0;
                        break;
                    case 2:
                        invert = x % 3 == 0;
                        break;
                    case 3:
                        invert = (x + y) % 3 == 0;
                        break;
                    case 4:
                        invert = (Math.floor(x / 3) + Math.floor(y / 2)) % 2 == 0;
                        break;
                    case 5:
                        invert = x * y % 2 + x * y % 3 == 0;
                        break;
                    case 6:
                        invert = (x * y % 2 + x * y % 3) % 2 == 0;
                        break;
                    case 7:
                        invert = ((x + y) % 2 + x * y % 3) % 2 == 0;
                        break;
                    default:
                        throw new Error("Unreachable");
                }
                if (!this.isFunction[y][x] && invert) this.modules[y][x] = !this.modules[y][x];
            }
        }
        getPenaltyScore() {
            let result = 0;
            for(let y = 0; y < this.size; y++){
                let runColor = false;
                let runX = 0;
                let runHistory = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ];
                for(let x = 0; x < this.size; x++)if (this.modules[y][x] == runColor) {
                    runX++;
                    if (runX == 5) result += _QrCode.PENALTY_N1;
                    else if (runX > 5) result++;
                } else {
                    this.finderPenaltyAddHistory(runX, runHistory);
                    if (!runColor) result += this.finderPenaltyCountPatterns(runHistory) * _QrCode.PENALTY_N3;
                    runColor = this.modules[y][x];
                    runX = 1;
                }
                result += this.finderPenaltyTerminateAndCount(runColor, runX, runHistory) * _QrCode.PENALTY_N3;
            }
            for(let x = 0; x < this.size; x++){
                let runColor = false;
                let runY = 0;
                let runHistory = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ];
                for(let y = 0; y < this.size; y++)if (this.modules[y][x] == runColor) {
                    runY++;
                    if (runY == 5) result += _QrCode.PENALTY_N1;
                    else if (runY > 5) result++;
                } else {
                    this.finderPenaltyAddHistory(runY, runHistory);
                    if (!runColor) result += this.finderPenaltyCountPatterns(runHistory) * _QrCode.PENALTY_N3;
                    runColor = this.modules[y][x];
                    runY = 1;
                }
                result += this.finderPenaltyTerminateAndCount(runColor, runY, runHistory) * _QrCode.PENALTY_N3;
            }
            for(let y = 0; y < this.size - 1; y++)for(let x = 0; x < this.size - 1; x++){
                const color = this.modules[y][x];
                if (color == this.modules[y][x + 1] && color == this.modules[y + 1][x] && color == this.modules[y + 1][x + 1]) result += _QrCode.PENALTY_N2;
            }
            let dark = 0;
            for (const row of this.modules)dark = row.reduce((sum, color)=>sum + (color ? 1 : 0), dark);
            const total = this.size * this.size;
            const k = Math.ceil(Math.abs(dark * 20 - total * 10) / total) - 1;
            assert(0 <= k && k <= 9);
            result += k * _QrCode.PENALTY_N4;
            assert(0 <= result && result <= 2568888);
            return result;
        }
        getAlignmentPatternPositions() {
            if (this.version == 1) return [];
            else {
                const numAlign = Math.floor(this.version / 7) + 2;
                const step = this.version == 32 ? 26 : Math.ceil((this.version * 4 + 4) / (numAlign * 2 - 2)) * 2;
                let result = [
                    6
                ];
                for(let pos = this.size - 7; result.length < numAlign; pos -= step)result.splice(1, 0, pos);
                return result;
            }
        }
        static getNumRawDataModules(ver) {
            if (ver < _QrCode.MIN_VERSION || ver > _QrCode.MAX_VERSION) throw new RangeError("Version number out of range");
            let result = (16 * ver + 128) * ver + 64;
            if (ver >= 2) {
                const numAlign = Math.floor(ver / 7) + 2;
                result -= (25 * numAlign - 10) * numAlign - 55;
                if (ver >= 7) result -= 36;
            }
            assert(208 <= result && result <= 29648);
            return result;
        }
        static getNumDataCodewords(ver, ecl) {
            return Math.floor(_QrCode.getNumRawDataModules(ver) / 8) - _QrCode.ECC_CODEWORDS_PER_BLOCK[ecl.ordinal][ver] * _QrCode.NUM_ERROR_CORRECTION_BLOCKS[ecl.ordinal][ver];
        }
        static reedSolomonComputeDivisor(degree) {
            if (degree < 1 || degree > 255) throw new RangeError("Degree out of range");
            let result = [];
            for(let i = 0; i < degree - 1; i++)result.push(0);
            result.push(1);
            let root = 1;
            for(let i = 0; i < degree; i++){
                for(let j = 0; j < result.length; j++){
                    result[j] = _QrCode.reedSolomonMultiply(result[j], root);
                    if (j + 1 < result.length) result[j] ^= result[j + 1];
                }
                root = _QrCode.reedSolomonMultiply(root, 2);
            }
            return result;
        }
        static reedSolomonComputeRemainder(data, divisor) {
            let result = divisor.map((_)=>0);
            for (const b of data){
                const factor = b ^ result.shift();
                result.push(0);
                divisor.forEach((coef, i)=>result[i] ^= _QrCode.reedSolomonMultiply(coef, factor));
            }
            return result;
        }
        static reedSolomonMultiply(x, y) {
            if (x >>> 8 != 0 || y >>> 8 != 0) throw new RangeError("Byte out of range");
            let z = 0;
            for(let i = 7; i >= 0; i--){
                z = z << 1 ^ (z >>> 7) * 285;
                z ^= (y >>> i & 1) * x;
            }
            assert(z >>> 8 == 0);
            return z;
        }
        finderPenaltyCountPatterns(runHistory) {
            const n = runHistory[1];
            assert(n <= this.size * 3);
            const core = n > 0 && runHistory[2] == n && runHistory[3] == n * 3 && runHistory[4] == n && runHistory[5] == n;
            return (core && runHistory[0] >= n * 4 && runHistory[6] >= n ? 1 : 0) + (core && runHistory[6] >= n * 4 && runHistory[0] >= n ? 1 : 0);
        }
        finderPenaltyTerminateAndCount(currentRunColor, currentRunLength, runHistory) {
            if (currentRunColor) {
                this.finderPenaltyAddHistory(currentRunLength, runHistory);
                currentRunLength = 0;
            }
            currentRunLength += this.size;
            this.finderPenaltyAddHistory(currentRunLength, runHistory);
            return this.finderPenaltyCountPatterns(runHistory);
        }
        finderPenaltyAddHistory(currentRunLength, runHistory) {
            if (runHistory[0] == 0) currentRunLength += this.size;
            runHistory.pop();
            runHistory.unshift(currentRunLength);
        }
        constructor(version, errorCorrectionLevel, dataCodewords, msk){
            this.version = version;
            this.errorCorrectionLevel = errorCorrectionLevel;
            this.modules = [];
            this.isFunction = [];
            if (version < _QrCode.MIN_VERSION || version > _QrCode.MAX_VERSION) throw new RangeError("Version value out of range");
            if (msk < -1 || msk > 7) throw new RangeError("Mask value out of range");
            this.size = version * 4 + 17;
            let row = [];
            for(let i = 0; i < this.size; i++)row.push(false);
            for(let i = 0; i < this.size; i++){
                this.modules.push(row.slice());
                this.isFunction.push(row.slice());
            }
            this.drawFunctionPatterns();
            const allCodewords = this.addEccAndInterleave(dataCodewords);
            this.drawCodewords(allCodewords);
            if (msk == -1) {
                let minPenalty = 1e9;
                for(let i = 0; i < 8; i++){
                    this.applyMask(i);
                    this.drawFormatBits(i);
                    const penalty = this.getPenaltyScore();
                    if (penalty < minPenalty) {
                        msk = i;
                        minPenalty = penalty;
                    }
                    this.applyMask(i);
                }
            }
            assert(0 <= msk && msk <= 7);
            this.mask = msk;
            this.applyMask(msk);
            this.drawFormatBits(msk);
            this.isFunction = [];
        }
    };
    let QrCode = _QrCode;
    QrCode.MIN_VERSION = 1;
    QrCode.MAX_VERSION = 40;
    QrCode.PENALTY_N1 = 3;
    QrCode.PENALTY_N2 = 3;
    QrCode.PENALTY_N3 = 40;
    QrCode.PENALTY_N4 = 10;
    QrCode.ECC_CODEWORDS_PER_BLOCK = [
        [
            -1,
            7,
            10,
            15,
            20,
            26,
            18,
            20,
            24,
            30,
            18,
            20,
            24,
            26,
            30,
            22,
            24,
            28,
            30,
            28,
            28,
            28,
            28,
            30,
            30,
            26,
            28,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30
        ],
        [
            -1,
            10,
            16,
            26,
            18,
            24,
            16,
            18,
            22,
            22,
            26,
            30,
            22,
            22,
            24,
            24,
            28,
            28,
            26,
            26,
            26,
            26,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28
        ],
        [
            -1,
            13,
            22,
            18,
            26,
            18,
            24,
            18,
            22,
            20,
            24,
            28,
            26,
            24,
            20,
            30,
            24,
            28,
            28,
            26,
            30,
            28,
            30,
            30,
            30,
            30,
            28,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30
        ],
        [
            -1,
            17,
            28,
            22,
            16,
            22,
            28,
            26,
            26,
            24,
            28,
            24,
            28,
            22,
            24,
            24,
            30,
            28,
            28,
            26,
            28,
            30,
            24,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30
        ]
    ];
    QrCode.NUM_ERROR_CORRECTION_BLOCKS = [
        [
            -1,
            1,
            1,
            1,
            1,
            1,
            2,
            2,
            2,
            2,
            4,
            4,
            4,
            4,
            4,
            6,
            6,
            6,
            6,
            7,
            8,
            8,
            9,
            9,
            10,
            12,
            12,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            19,
            20,
            21,
            22,
            24,
            25
        ],
        [
            -1,
            1,
            1,
            1,
            2,
            2,
            4,
            4,
            4,
            5,
            5,
            5,
            8,
            9,
            9,
            10,
            10,
            11,
            13,
            14,
            16,
            17,
            17,
            18,
            20,
            21,
            23,
            25,
            26,
            28,
            29,
            31,
            33,
            35,
            37,
            38,
            40,
            43,
            45,
            47,
            49
        ],
        [
            -1,
            1,
            1,
            2,
            2,
            4,
            4,
            6,
            6,
            8,
            8,
            8,
            10,
            12,
            16,
            12,
            17,
            16,
            18,
            21,
            20,
            23,
            23,
            25,
            27,
            29,
            34,
            34,
            35,
            38,
            40,
            43,
            45,
            48,
            51,
            53,
            56,
            59,
            62,
            65,
            68
        ],
        [
            -1,
            1,
            1,
            2,
            4,
            4,
            4,
            5,
            6,
            8,
            8,
            11,
            11,
            16,
            16,
            18,
            16,
            19,
            21,
            25,
            25,
            25,
            34,
            30,
            32,
            35,
            37,
            40,
            42,
            45,
            48,
            51,
            54,
            57,
            60,
            63,
            66,
            70,
            74,
            77,
            81
        ]
    ];
    qrcodegen2.QrCode = QrCode;
    function appendBits(val, len, bb) {
        if (len < 0 || len > 31 || val >>> len != 0) throw new RangeError("Value out of range");
        for(let i = len - 1; i >= 0; i--)bb.push(val >>> i & 1);
    }
    function getBit(x, i) {
        return (x >>> i & 1) != 0;
    }
    function assert(cond) {
        if (!cond) throw new Error("Assertion error");
    }
    const _QrSegment = class {
        static makeBytes(data) {
            let bb = [];
            for (const b of data)appendBits(b, 8, bb);
            return new _QrSegment(_QrSegment.Mode.BYTE, data.length, bb);
        }
        static makeNumeric(digits) {
            if (!_QrSegment.isNumeric(digits)) throw new RangeError("String contains non-numeric characters");
            let bb = [];
            for(let i = 0; i < digits.length;){
                const n = Math.min(digits.length - i, 3);
                appendBits(parseInt(digits.substr(i, n), 10), n * 3 + 1, bb);
                i += n;
            }
            return new _QrSegment(_QrSegment.Mode.NUMERIC, digits.length, bb);
        }
        static makeAlphanumeric(text) {
            if (!_QrSegment.isAlphanumeric(text)) throw new RangeError("String contains unencodable characters in alphanumeric mode");
            let bb = [];
            let i;
            for(i = 0; i + 2 <= text.length; i += 2){
                let temp = _QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i)) * 45;
                temp += _QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i + 1));
                appendBits(temp, 11, bb);
            }
            if (i < text.length) appendBits(_QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i)), 6, bb);
            return new _QrSegment(_QrSegment.Mode.ALPHANUMERIC, text.length, bb);
        }
        static makeSegments(text) {
            if (text == "") return [];
            else if (_QrSegment.isNumeric(text)) return [
                _QrSegment.makeNumeric(text)
            ];
            else if (_QrSegment.isAlphanumeric(text)) return [
                _QrSegment.makeAlphanumeric(text)
            ];
            else return [
                _QrSegment.makeBytes(_QrSegment.toUtf8ByteArray(text))
            ];
        }
        static makeEci(assignVal) {
            let bb = [];
            if (assignVal < 0) throw new RangeError("ECI assignment value out of range");
            else if (assignVal < 128) appendBits(assignVal, 8, bb);
            else if (assignVal < 16384) {
                appendBits(2, 2, bb);
                appendBits(assignVal, 14, bb);
            } else if (assignVal < 1e6) {
                appendBits(6, 3, bb);
                appendBits(assignVal, 21, bb);
            } else throw new RangeError("ECI assignment value out of range");
            return new _QrSegment(_QrSegment.Mode.ECI, 0, bb);
        }
        static isNumeric(text) {
            return _QrSegment.NUMERIC_REGEX.test(text);
        }
        static isAlphanumeric(text) {
            return _QrSegment.ALPHANUMERIC_REGEX.test(text);
        }
        getData() {
            return this.bitData.slice();
        }
        static getTotalBits(segs, version) {
            let result = 0;
            for (const seg of segs){
                const ccbits = seg.mode.numCharCountBits(version);
                if (seg.numChars >= 1 << ccbits) return Infinity;
                result += 4 + ccbits + seg.bitData.length;
            }
            return result;
        }
        static toUtf8ByteArray(str) {
            str = encodeURI(str);
            let result = [];
            for(let i = 0; i < str.length; i++)if (str.charAt(i) != "%") result.push(str.charCodeAt(i));
            else {
                result.push(parseInt(str.substr(i + 1, 2), 16));
                i += 2;
            }
            return result;
        }
        constructor(mode, numChars, bitData){
            this.mode = mode;
            this.numChars = numChars;
            this.bitData = bitData;
            if (numChars < 0) throw new RangeError("Invalid argument");
            this.bitData = bitData.slice();
        }
    };
    let QrSegment = _QrSegment;
    QrSegment.NUMERIC_REGEX = /^[0-9]*$/;
    QrSegment.ALPHANUMERIC_REGEX = /^[A-Z0-9 $%*+.\/:-]*$/;
    QrSegment.ALPHANUMERIC_CHARSET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:";
    qrcodegen2.QrSegment = QrSegment;
})($65a4d498522b436f$var$qrcodegen || ($65a4d498522b436f$var$qrcodegen = {}));
((qrcodegen2)=>{
    let QrCode;
    ((QrCode2)=>{
        const _Ecc = class {
            constructor(ordinal, formatBits){
                this.ordinal = ordinal;
                this.formatBits = formatBits;
            }
        };
        let Ecc = _Ecc;
        Ecc.LOW = new _Ecc(0, 1);
        Ecc.MEDIUM = new _Ecc(1, 0);
        Ecc.QUARTILE = new _Ecc(2, 3);
        Ecc.HIGH = new _Ecc(3, 2);
        QrCode2.Ecc = Ecc;
    })(QrCode = qrcodegen2.QrCode || (qrcodegen2.QrCode = {}));
})($65a4d498522b436f$var$qrcodegen || ($65a4d498522b436f$var$qrcodegen = {}));
((qrcodegen2)=>{
    let QrSegment;
    ((QrSegment2)=>{
        const _Mode = class {
            numCharCountBits(ver) {
                return this.numBitsCharCount[Math.floor((ver + 7) / 17)];
            }
            constructor(modeBits, numBitsCharCount){
                this.modeBits = modeBits;
                this.numBitsCharCount = numBitsCharCount;
            }
        };
        let Mode = _Mode;
        Mode.NUMERIC = new _Mode(1, [
            10,
            12,
            14
        ]);
        Mode.ALPHANUMERIC = new _Mode(2, [
            9,
            11,
            13
        ]);
        Mode.BYTE = new _Mode(4, [
            8,
            16,
            16
        ]);
        Mode.KANJI = new _Mode(8, [
            8,
            10,
            12
        ]);
        Mode.ECI = new _Mode(7, [
            0,
            0,
            0
        ]);
        QrSegment2.Mode = Mode;
    })(QrSegment = qrcodegen2.QrSegment || (qrcodegen2.QrSegment = {}));
})($65a4d498522b436f$var$qrcodegen || ($65a4d498522b436f$var$qrcodegen = {}));
var $65a4d498522b436f$var$qrcodegen_default = $65a4d498522b436f$var$qrcodegen;
// src/index.tsx
/**
 * @license qrcode.react
 * Copyright (c) Paul O'Shannessy
 * SPDX-License-Identifier: ISC
 */ var $65a4d498522b436f$var$ERROR_LEVEL_MAP = {
    L: $65a4d498522b436f$var$qrcodegen_default.QrCode.Ecc.LOW,
    M: $65a4d498522b436f$var$qrcodegen_default.QrCode.Ecc.MEDIUM,
    Q: $65a4d498522b436f$var$qrcodegen_default.QrCode.Ecc.QUARTILE,
    H: $65a4d498522b436f$var$qrcodegen_default.QrCode.Ecc.HIGH
};
var $65a4d498522b436f$var$DEFAULT_SIZE = 128;
var $65a4d498522b436f$var$DEFAULT_LEVEL = "L";
var $65a4d498522b436f$var$DEFAULT_BGCOLOR = "#FFFFFF";
var $65a4d498522b436f$var$DEFAULT_FGCOLOR = "#000000";
var $65a4d498522b436f$var$DEFAULT_INCLUDEMARGIN = false;
var $65a4d498522b436f$var$MARGIN_SIZE = 4;
var $65a4d498522b436f$var$DEFAULT_IMG_SCALE = 0.1;
function $65a4d498522b436f$var$generatePath(modules, margin = 0) {
    const ops = [];
    modules.forEach(function(row, y) {
        let start = null;
        row.forEach(function(cell, x) {
            if (!cell && start !== null) {
                ops.push(`M${start + margin} ${y + margin}h${x - start}v1H${start + margin}z`);
                start = null;
                return;
            }
            if (x === row.length - 1) {
                if (!cell) return;
                if (start === null) ops.push(`M${x + margin},${y + margin} h1v1H${x + margin}z`);
                else ops.push(`M${start + margin},${y + margin} h${x + 1 - start}v1H${start + margin}z`);
                return;
            }
            if (cell && start === null) start = x;
        });
    });
    return ops.join("");
}
function $65a4d498522b436f$var$excavateModules(modules, excavation) {
    return modules.slice().map((row, y)=>{
        if (y < excavation.y || y >= excavation.y + excavation.h) return row;
        return row.map((cell, x)=>{
            if (x < excavation.x || x >= excavation.x + excavation.w) return cell;
            return false;
        });
    });
}
function $65a4d498522b436f$var$getImageSettings(cells, size, includeMargin, imageSettings) {
    if (imageSettings == null) return null;
    const margin = includeMargin ? $65a4d498522b436f$var$MARGIN_SIZE : 0;
    const numCells = cells.length + margin * 2;
    const defaultSize = Math.floor(size * $65a4d498522b436f$var$DEFAULT_IMG_SCALE);
    const scale = numCells / size;
    const w = (imageSettings.width || defaultSize) * scale;
    const h = (imageSettings.height || defaultSize) * scale;
    const x = imageSettings.x == null ? cells.length / 2 - w / 2 : imageSettings.x * scale;
    const y = imageSettings.y == null ? cells.length / 2 - h / 2 : imageSettings.y * scale;
    let excavation = null;
    if (imageSettings.excavate) {
        let floorX = Math.floor(x);
        let floorY = Math.floor(y);
        let ceilW = Math.ceil(w + x - floorX);
        let ceilH = Math.ceil(h + y - floorY);
        excavation = {
            x: floorX,
            y: floorY,
            w: ceilW,
            h: ceilH
        };
    }
    return {
        x: x,
        y: y,
        h: h,
        w: w,
        excavation: excavation
    };
}
var $65a4d498522b436f$var$SUPPORTS_PATH2D = function() {
    try {
        new Path2D().addPath(new Path2D());
    } catch (e) {
        return false;
    }
    return true;
}();
function $65a4d498522b436f$export$7e3713cf0c0fe9d0(props) {
    const _a = props, { value: value, size: size = $65a4d498522b436f$var$DEFAULT_SIZE, level: level = $65a4d498522b436f$var$DEFAULT_LEVEL, bgColor: bgColor = $65a4d498522b436f$var$DEFAULT_BGCOLOR, fgColor: fgColor = $65a4d498522b436f$var$DEFAULT_FGCOLOR, includeMargin: includeMargin = $65a4d498522b436f$var$DEFAULT_INCLUDEMARGIN, style: style, imageSettings: imageSettings } = _a, otherProps = $65a4d498522b436f$var$__objRest(_a, [
        "value",
        "size",
        "level",
        "bgColor",
        "fgColor",
        "includeMargin",
        "style",
        "imageSettings"
    ]);
    const imgSrc = imageSettings == null ? void 0 : imageSettings.src;
    const _canvas = (0, $6cds3.useRef)(null);
    const _image = (0, $6cds3.useRef)(null);
    const [isImgLoaded, setIsImageLoaded] = (0, $6cds3.useState)(false);
    (0, $6cds3.useEffect)(()=>{
        if (_canvas.current != null) {
            const canvas = _canvas.current;
            const ctx = canvas.getContext("2d");
            if (!ctx) return;
            let cells = $65a4d498522b436f$var$qrcodegen_default.QrCode.encodeText(value, $65a4d498522b436f$var$ERROR_LEVEL_MAP[level]).getModules();
            const margin = includeMargin ? $65a4d498522b436f$var$MARGIN_SIZE : 0;
            const numCells = cells.length + margin * 2;
            const calculatedImageSettings = $65a4d498522b436f$var$getImageSettings(cells, size, includeMargin, imageSettings);
            const image = _image.current;
            const haveImageToRender = calculatedImageSettings != null && image !== null && image.complete && image.naturalHeight !== 0 && image.naturalWidth !== 0;
            if (haveImageToRender) {
                if (calculatedImageSettings.excavation != null) cells = $65a4d498522b436f$var$excavateModules(cells, calculatedImageSettings.excavation);
            }
            const pixelRatio = window.devicePixelRatio || 1;
            canvas.height = canvas.width = size * pixelRatio;
            const scale = size / numCells * pixelRatio;
            ctx.scale(scale, scale);
            ctx.fillStyle = bgColor;
            ctx.fillRect(0, 0, numCells, numCells);
            ctx.fillStyle = fgColor;
            if ($65a4d498522b436f$var$SUPPORTS_PATH2D) ctx.fill(new Path2D($65a4d498522b436f$var$generatePath(cells, margin)));
            else cells.forEach(function(row, rdx) {
                row.forEach(function(cell, cdx) {
                    if (cell) ctx.fillRect(cdx + margin, rdx + margin, 1, 1);
                });
            });
            if (haveImageToRender) ctx.drawImage(image, calculatedImageSettings.x + margin, calculatedImageSettings.y + margin, calculatedImageSettings.w, calculatedImageSettings.h);
        }
    });
    (0, $6cds3.useEffect)(()=>{
        setIsImageLoaded(false);
    }, [
        imgSrc
    ]);
    const canvasStyle = $65a4d498522b436f$var$__spreadValues({
        height: size,
        width: size
    }, style);
    let img = null;
    if (imgSrc != null) img = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("img", {
        src: imgSrc,
        key: imgSrc,
        style: {
            display: "none"
        },
        onLoad: ()=>{
            setIsImageLoaded(true);
        },
        ref: _image
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("canvas", $65a4d498522b436f$var$__spreadValues({
        style: canvasStyle,
        height: size,
        width: size,
        ref: _canvas
    }, otherProps)), img);
}
function $65a4d498522b436f$export$10307208e61210e9(props) {
    const _a = props, { value: value, size: size = $65a4d498522b436f$var$DEFAULT_SIZE, level: level = $65a4d498522b436f$var$DEFAULT_LEVEL, bgColor: bgColor = $65a4d498522b436f$var$DEFAULT_BGCOLOR, fgColor: fgColor = $65a4d498522b436f$var$DEFAULT_FGCOLOR, includeMargin: includeMargin = $65a4d498522b436f$var$DEFAULT_INCLUDEMARGIN, imageSettings: imageSettings } = _a, otherProps = $65a4d498522b436f$var$__objRest(_a, [
        "value",
        "size",
        "level",
        "bgColor",
        "fgColor",
        "includeMargin",
        "imageSettings"
    ]);
    let cells = $65a4d498522b436f$var$qrcodegen_default.QrCode.encodeText(value, $65a4d498522b436f$var$ERROR_LEVEL_MAP[level]).getModules();
    const margin = includeMargin ? $65a4d498522b436f$var$MARGIN_SIZE : 0;
    const numCells = cells.length + margin * 2;
    const calculatedImageSettings = $65a4d498522b436f$var$getImageSettings(cells, size, includeMargin, imageSettings);
    let image = null;
    if (imageSettings != null && calculatedImageSettings != null) {
        if (calculatedImageSettings.excavation != null) cells = $65a4d498522b436f$var$excavateModules(cells, calculatedImageSettings.excavation);
        image = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("image", {
            xlinkHref: imageSettings.src,
            height: calculatedImageSettings.h,
            width: calculatedImageSettings.w,
            x: calculatedImageSettings.x + margin,
            y: calculatedImageSettings.y + margin,
            preserveAspectRatio: "none"
        });
    }
    const fgPath = $65a4d498522b436f$var$generatePath(cells, margin);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("svg", $65a4d498522b436f$var$__spreadValues({
        height: size,
        width: size,
        viewBox: `0 0 ${numCells} ${numCells}`
    }, otherProps), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        fill: bgColor,
        d: `M0,0 h${numCells}v${numCells}H0z`,
        shapeRendering: "crispEdges"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("path", {
        fill: fgColor,
        d: fgPath,
        shapeRendering: "crispEdges"
    }), image);
}
var $65a4d498522b436f$export$2e2bcd8739ae039 = (props)=>{
    const _a = props, { renderAs: renderAs } = _a, otherProps = $65a4d498522b436f$var$__objRest(_a, [
        "renderAs"
    ]);
    if (renderAs === "svg") return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($65a4d498522b436f$export$10307208e61210e9, $65a4d498522b436f$var$__spreadValues({}, otherProps));
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($65a4d498522b436f$export$7e3713cf0c0fe9d0, $65a4d498522b436f$var$__spreadValues({}, otherProps));
};


function $22927c0bb5ffd6de$var$ConnectWalletModal(props) {
    const { show: show, signerProvider: signerProvider, uri: uri, callback: callback, onClose: onClose } = props;
    const [checkMobile] = (0, $6cds3.useState)(()=>(0, $4397f25fd0309dd4$export$d0a8044dce8ff2fc)());
    const [checkAndroid] = (0, $6cds3.useState)(()=>(0, $4397f25fd0309dd4$export$a11b0059900ceec8)());
    const [showQrCode, setShowQrCode] = (0, $6cds3.useState)(!checkMobile);
    const navigateToAppURL = (0, $6cds3.useMemo)(()=>{
        if (checkMobile) {
            const uriStr = uri ? `?${uri}` : "";
            if (checkAndroid) return `intent://wcV1${uriStr}#Intent;package=com.chainapsis.keplr;scheme=keplrwallet;end;`;
            else return `keplrwallet://wcV1${uriStr}`;
        }
    }, [
        checkAndroid,
        checkMobile,
        uri
    ]);
    function handleClose() {
        onClose();
        callback && callback();
    }
    function forceDisconnect() {
        signerProvider === null || signerProvider === void 0 ? void 0 : signerProvider.forceDisconnect();
        handleClose();
    }
    const walletName = (signerProvider === null || signerProvider === void 0 ? void 0 : signerProvider.label) || "Wallet";
    const title = !checkMobile && uri ? "Scan QR Code" : `Connect ${walletName}`;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $3485727b0a1e4042$export$2e2bcd8739ae039), {
            size: "md",
            show: show,
            onHide: handleClose,
            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $3485727b0a1e4042$export$2e2bcd8739ae039).Header, {
                        closeButton: true,
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $3485727b0a1e4042$export$2e2bcd8739ae039).Title, {
                            className: "text-truncate pe-4",
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $3485727b0a1e4042$export$2e2bcd8739ae039).Body, {
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            className: "text-center",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                    children: `Open your ${walletName} app to continue...`
                                }),
                                checkMobile && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a73f5336dfd04f2d$export$2e2bcd8739ae039), {
                                            onClick: ()=>{
                                                if (navigateToAppURL) window.location.href = navigateToAppURL;
                                            },
                                            children: "Open App"
                                        }),
                                        uri && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                            className: "my-2",
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $a73f5336dfd04f2d$export$2e2bcd8739ae039), {
                                                variant: "text",
                                                onClick: ()=>setShowQrCode(!showQrCode),
                                                children: [
                                                    showQrCode ? "Hide" : "Show",
                                                    " QR Code"
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                    className: "text-center",
                                    children: uri ? showQrCode && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $65a4d498522b436f$export$2e2bcd8739ae039), {
                                        size: 300,
                                        value: uri
                                    }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $39ebe134e7977f3e$export$2e2bcd8739ae039), {
                                        animation: "border",
                                        role: "status",
                                        className: "spinner-border-sm mt-5",
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                            className: "visually-hidden",
                                            children: "Loading..."
                                        })
                                    })
                                }),
                                !uri && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                    className: "mt-5",
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a73f5336dfd04f2d$export$2e2bcd8739ae039), {
                                        size: "sm",
                                        onClick: forceDisconnect,
                                        variant: "danger",
                                        children: "Disconnect session"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}
var $22927c0bb5ffd6de$export$2e2bcd8739ae039 = $22927c0bb5ffd6de$var$ConnectWalletModal;




parcelRequire("c9wMV");

class $369b3790db0d9a9c$export$2e2bcd8739ae039 extends (0, $843b5e8118d7625d$export$2e2bcd8739ae039) {
    async getSigner(network) {
        if (!this.signer) {
            const { chainId: chainId } = network;
            if (this.isLedger()) this.signer = await this.provider.getOfflineSignerOnlyAmino(chainId);
            else this.signer = await this.provider.getOfflineSigner(chainId);
        }
        return this.signer;
    }
    suggestChain(network) {
        return this.cosmostationProvider.request({
            method: "cos_addChain",
            params: this.suggestChainData(network)
        });
    }
    suggestChainData(network) {
        var _network_data_keplrFeatures;
        const data = {
            chainId: network.chainId,
            chainName: network.prettyName,
            addressPrefix: network.prefix,
            baseDenom: network.denom,
            displayDenom: network.symbol,
            restURL: network.restUrl,
            coinType: `${network.slip44}`,
            decimals: network.decimals,
            gasRate: {
                // optional (default: { average: '0.025', low: '0.0025', tiny: '0.00025' })
                average: `${network.gasPriceStep.high}`,
                low: `${network.gasPriceStep.average}`,
                tiny: `${network.gasPriceStep.low}`
            }
        };
        if (((_network_data_keplrFeatures = network.data.keplrFeatures) === null || _network_data_keplrFeatures === void 0 ? void 0 : _network_data_keplrFeatures.includes("eth-address-gen")) || network.slip44 === 60) data.type = "ETHERMINT";
        return data;
    }
    constructor(keplrProvider, cosmostationProvider){
        super(keplrProvider);
        (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(this, "name", "cosmostation");
        (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(this, "label", "Cosmostation Wallet");
        (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(this, "keychangeEvent", "cosmostation_keystorechange");
        (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(this, "authzAminoLiftedValueSupport", false);
        this.cosmostationProvider = cosmostationProvider;
    }
}



class $983d6cbbf805859b$var$App extends (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Component {
    async componentDidMount() {
        this.connect();
        window.addEventListener("load", this.connectAuto);
        this.signerProviders.forEach((provider)=>{
            const connector = (event)=>this.connectAuto(event, provider.name);
            this.signerConnectors[provider.name] = connector;
            window.addEventListener(provider.keychangeEvent, connector);
        });
    }
    async componentDidUpdate(prevProps, prevState) {
        if (!this.props.network) return;
        if (this.props.network !== prevProps.network) {
            this.clearRefreshInterval();
            this.setState({
                balance: undefined,
                address: undefined,
                wallet: undefined,
                grants: undefined,
                error: undefined
            });
            this.connect();
        } else if (this.state.address != prevState.address) {
            this.clearRefreshInterval();
            this.setState({
                balance: undefined,
                grants: undefined,
                error: undefined
            });
            this.getBalance();
            this.getGrants().then(()=>{
                this.refreshInterval();
            });
        }
    }
    componentWillUnmount() {
        this.clearRefreshInterval();
        window.removeEventListener("load", this.connectAuto);
        this.signerProviders.forEach((provider)=>{
            window.removeEventListener(provider.keychangeEvent, this.signerConnectors[provider.name]);
        });
    }
    showNetworkSelect() {
        this.setState({
            showNetworkSelect: true
        });
    }
    connected() {
        var _this_props_network;
        return (_this_props_network = this.props.network) === null || _this_props_network === void 0 ? void 0 : _this_props_network.connected;
    }
    getSignerProvider(providerKey) {
        return providerKey && this.signerProviders.find((el)=>el.name === providerKey);
    }
    disconnect() {
        var _this_state_signerProvider;
        localStorage.removeItem("connected");
        (_this_state_signerProvider = this.state.signerProvider) === null || _this_state_signerProvider === void 0 ? void 0 : _this_state_signerProvider.disconnect();
        this.setState({
            error: null,
            address: null,
            balance: null,
            wallet: null,
            signingClient: null,
            signerProvider: null
        });
    }
    connectAuto(event, providerKey) {
        return this.connect(providerKey);
    }
    async connect(providerKey, manual) {
        if (this.props.network && !this.connected()) return this.setState({
            error: "Could not connect to any available API servers"
        });
        let storedKey = localStorage.getItem("connected");
        if (storedKey === "1") {
            storedKey = "keplr";
            localStorage.setItem("connected", storedKey);
        }
        const signerProvider = this.getSignerProvider(providerKey || storedKey);
        if (!signerProvider) return;
        providerKey = signerProvider.name;
        if (manual && !signerProvider.available()) return this.setState({
            providerError: providerKey
        });
        const { network: network } = this.props;
        if (!network || !signerProvider.available()) return;
        if (!manual && (providerKey !== storedKey || !signerProvider.connected())) return;
        this.setState({
            signerProvider: signerProvider
        });
        const wallet = new (0, $9928af9f183fd222$export$2e2bcd8739ae039)(network, signerProvider);
        try {
            const key = await wallet.connect();
            if (!network.ledgerSupport && (key.isNanoLedger || key.isHardware)) throw new Error("Ledger support is coming soon");
        } catch (e) {
            return this.setState({
                error: `Unable to connect to ${(signerProvider === null || signerProvider === void 0 ? void 0 : signerProvider.label) || "signer"}: ${e.message}`,
                address: null,
                wallet: null,
                signingClient: null
            });
        }
        try {
            const signingClient = (0, $454bdf3eccc48d5c$export$2e2bcd8739ae039)(network, signerProvider);
            signingClient.registry.register("/cosmos.authz.v1beta1.MsgGrant", (0, $d189b8fd7c99c4ec$exports.MsgGrant));
            signingClient.registry.register("/cosmos.authz.v1beta1.MsgRevoke", (0, $d189b8fd7c99c4ec$exports.MsgRevoke));
            const address = await wallet.getAddress();
            localStorage.setItem("connected", providerKey);
            this.setState({
                address: address,
                wallet: wallet,
                signingClient: signingClient,
                error: false,
                qrCodeUri: null,
                qrCodeCallback: null
            });
        } catch (e) {
            console.log(e);
            return this.setState({
                error: `Failed to connect to ${(signerProvider === null || signerProvider === void 0 ? void 0 : signerProvider.label) || "signer"}: ${e.message}`
            });
        }
    }
    refreshInterval() {
        this.setState({
            refresh: true
        });
        this.refreshTimeout();
    }
    refreshTimeout() {
        if (!this.state.refresh) return;
        const grantTimeout = setTimeout(()=>{
            this.getGrants().then(()=>{
                this.refreshTimeout();
            });
        }, 60000);
        this.setState({
            grantTimeout: grantTimeout
        });
    }
    clearRefreshInterval() {
        clearTimeout(this.state.grantTimeout);
        this.setState({
            refresh: false
        });
    }
    toggleFavourite(network) {
        const { favourites: favourites } = this.state;
        let newFavourites;
        if (favourites.includes(network.path)) newFavourites = favourites.filter((el)=>el !== network.path);
        else newFavourites = [
            ...favourites,
            network.path
        ];
        localStorage.setItem("favourites", JSON.stringify(newFavourites));
        this.setState({
            favourites: newFavourites
        });
    }
    toggleFavouriteAddress(address, label) {
        const favourites = this.favouriteAddresses();
        let newFavourites;
        if (favourites.some((el)=>el.address === address)) newFavourites = favourites.filter((el)=>el.address !== address);
        else newFavourites = [
            ...favourites,
            {
                address: address,
                label: label
            }
        ];
        this.updateFavouriteAddresses({
            ...this.state.favouriteAddresses,
            [this.props.network.path]: newFavourites
        });
    }
    updateFavouriteAddresses(newFavourites) {
        localStorage.setItem("favourite-addresses", JSON.stringify(newFavourites));
        this.setState({
            favouriteAddresses: newFavourites
        });
    }
    favouriteAddresses() {
        return this.state.favouriteAddresses[this.props.network.path] || [];
    }
    currentFavouriteAddress() {
        return this.favouriteAddresses().find((el)=>el.address === this.state.address);
    }
    otherFavouriteAddresses() {
        return this.favouriteAddresses().filter((el)=>{
            var _this_state_wallet;
            return el.address !== ((_this_state_wallet = this.state.wallet) === null || _this_state_wallet === void 0 ? void 0 : _this_state_wallet.address);
        });
    }
    viewingWallet() {
        var _this_state_wallet;
        return this.state.address && this.state.address === ((_this_state_wallet = this.state.wallet) === null || _this_state_wallet === void 0 ? void 0 : _this_state_wallet.address);
    }
    addressName() {
        var _this_currentFavouriteAddress;
        if (!this.state.address) return null;
        if (this.viewingWallet()) return this.state.wallet.name;
        return ((_this_currentFavouriteAddress = this.currentFavouriteAddress()) === null || _this_currentFavouriteAddress === void 0 ? void 0 : _this_currentFavouriteAddress.label) || this.state.address;
    }
    async getBalance() {
        if (!this.state.address) return;
        this.props.queryClient.getBalance(this.state.address).then((balances)=>{
            const balance = (balances === null || balances === void 0 ? void 0 : balances.find((element)=>element.denom === this.props.network.denom)) || {
                denom: this.props.network.denom,
                amount: 0
            };
            this.setState({
                balance: balance,
                balances: balances,
                error: null
            });
        }, (error)=>console.log(error));
    }
    async getGrants() {
        if (!this.state.address || !this.props.network.authzSupport) return;
        const address = this.state.address;
        let granterGrants, granteeGrants, grantQuerySupport;
        try {
            granterGrants = await this.props.queryClient.getGranterGrants(address);
            this.setGrants(address, granterGrants, "granter", true);
            granteeGrants = await this.props.queryClient.getGranteeGrants(address);
            return this.setGrants(address, granteeGrants, "grantee");
        } catch (error) {
            var _error_response;
            console.log("Failed to get all grants in batch", error.message);
            grantQuerySupport = ((_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.status) !== 501;
            this.setState((state)=>{
                if (address !== state.address) return {};
                return {
                    grantQuerySupport: grantQuerySupport
                };
            });
            if (grantQuerySupport) return this.setState({
                error: "Failed to load all grants"
            });
        }
        let addresses = this.props.operators.map((el)=>el.botAddress);
        const favourites = this.favouriteAddresses();
        addresses = addresses.concat(favourites.filter((el)=>!addresses.includes(el.address)).map((el)=>el.address));
        granterGrants = await this.getGrantsIndividually(addresses.map((el)=>{
            return {
                grantee: el,
                granter: address
            };
        }));
        this.setGrants(address, granterGrants, "granter", grantQuerySupport);
        granteeGrants = await this.getGrantsIndividually(favourites.map((el)=>{
            return {
                granter: el.address,
                grantee: address
            };
        }));
        this.setGrants(address, granteeGrants, "grantee", grantQuerySupport);
    }
    async getGrantsIndividually(grants) {
        const address = this.state.address;
        const calls = grants.map(({ granter: granter, grantee: grantee })=>{
            return ()=>{
                if (address !== this.state.address) return;
                return this.props.queryClient.getGrants(grantee, granter).then((result)=>{
                    return result.map((grant)=>{
                        return {
                            ...grant,
                            grantee: grantee,
                            granter: granter
                        };
                    });
                });
            };
        });
        const batchCalls = (0, (/*@__PURE__*/$parcel$interopDefault($c9wMV))).chunk(calls, 5);
        let allGrants = [];
        for (const batchCall of batchCalls){
            if (address !== this.state.address) return;
            const grants = (await Promise.allSettled(batchCall.map((call)=>call()))).map((el)=>el.status === "fulfilled" && el.value);
            allGrants = allGrants.concat((0, (/*@__PURE__*/$parcel$interopDefault($c9wMV))).compact(grants.flat()));
        }
        return allGrants;
    }
    setGrants(address, grants, type, grantQuerySupport) {
        var _this_state_wallet;
        if (type === "grantee" && ((_this_state_wallet = this.state.wallet) === null || _this_state_wallet === void 0 ? void 0 : _this_state_wallet.address) === address) this.state.wallet.grants = grants || [];
        if (address !== this.state.address) return;
        this.setState((state)=>{
            if (address !== state.address) return {};
            return {
                grants: {
                    ...state.grants,
                    [type]: grants
                },
                grantQuerySupport: grantQuerySupport !== null && grantQuerySupport !== void 0 ? grantQuerySupport : state.grantQuerySupport
            };
        });
    }
    onSend(recipient, amount) {
        this.setState({
            showSendModal: false
        });
        setTimeout(()=>{
            this.getBalance();
        }, 2000);
    }
    onGrant(grantee, grant) {
        const filterGrant = (el)=>{
            if (el.grantee !== grantee) return true;
            if (el.authorization["@type"] === grant.authorization["@type"] && el.authorization.msg === grant.authorization.msg) return false;
            return true;
        };
        this.setState((state, props)=>{
            var _state_grants_granter;
            if (!state.grants) return {};
            const granterGrants = ((_state_grants_granter = state.grants.granter) === null || _state_grants_granter === void 0 ? void 0 : _state_grants_granter.filter(filterGrant)) || [];
            granterGrants.push(grant);
            return {
                grants: {
                    ...state.grants,
                    granter: granterGrants
                }
            };
        });
        if (this.state.wallet && grantee === this.state.wallet.address) {
            const grants = this.state.wallet.grants.filter(filterGrant);
            grants.push(grant);
            this.state.wallet.grants = grants;
        }
    }
    onRevoke(grantee, msgTypes) {
        const filterGrant = (el)=>{
            if (el.grantee !== grantee) return true;
            if (msgTypes.includes("/cosmos.staking.v1beta1.MsgDelegate")) {
                if (el.authorization["@type"] === "/cosmos.staking.v1beta1.StakeAuthorization") return false;
            }
            if (el.authorization["@type"] === "/cosmos.authz.v1beta1.GenericAuthorization" && msgTypes.includes(el.authorization.msg)) return false;
            return true;
        };
        this.setState((state, props)=>{
            if (!state.grants || !state.grants.granter) return {};
            const granterGrants = state.grants.granter.filter(filterGrant);
            return {
                grants: {
                    ...state.grants,
                    granter: granterGrants
                }
            };
        });
        if (this.state.wallet && grantee === this.state.wallet.address) this.state.wallet.grants = this.state.wallet.grants.filter(filterGrant);
    }
    showWalletModal(opts) {
        opts = opts || {};
        this.setState((state)=>{
            return {
                walletModal: {
                    ...state.validatorModal,
                    show: true,
                    ...opts
                }
            };
        });
    }
    hideWalletModal(opts) {
        opts = opts || {};
        this.setState((state)=>{
            return {
                walletModal: {
                    ...state.walletModal,
                    show: false
                }
            };
        });
    }
    setCopied() {
        this.setState({
            copied: true
        });
        setTimeout(()=>{
            this.setState({
                copied: false
            });
        }, 2000);
    }
    themeIcon() {
        const { theme: theme, themeChoice: themeChoice, themeDefault: themeDefault, setThemeChoice: setThemeChoice } = this.props;
        let icon, switchTo;
        let iconProps = {
            size: "1.4em",
            className: "me-3",
            role: "button",
            onClick: ()=>setThemeChoice(switchTo)
        };
        if (themeChoice === "auto") {
            icon = /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5555b2a88ddd6ca2$export$2e2bcd8739ae039), {
                ...iconProps
            });
            switchTo = theme === "dark" ? "light" : "dark";
        } else {
            icon = themeChoice === "dark" ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $71f64457e7ee5e3d$export$2e2bcd8739ae039), {
                ...iconProps
            }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e0cf018f143bcd60$export$2e2bcd8739ae039), {
                ...iconProps
            });
            switchTo = themeDefault !== theme ? "auto" : theme === "dark" ? "light" : "dark";
        }
        const tooltip = `Switch to ${switchTo} mode`;
        return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc7c852c832d97ac$export$2e2bcd8739ae039), {
                icon: icon,
                tooltip: tooltip,
                placement: "left",
                rootClose: true
            })
        });
    }
    networkIcon() {
        let icon, mode;
        let iconProps = {
            size: "1.4em",
            className: "mx-2 mx-md-3",
            role: "button",
            onClick: ()=>this.props.changeNetworkMode(mode)
        };
        if (this.props.directory.testnet) {
            iconProps.className = iconProps.className + " text-warning";
            icon = /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $c101c58977bda107$export$2e2bcd8739ae039), {
                ...iconProps
            });
            mode = "mainnet";
        } else {
            iconProps.className = iconProps.className + " text-muted";
            icon = /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $919d8f7a86c784de$export$2e2bcd8739ae039), {
                ...iconProps
            });
            mode = "testnet";
        }
        const tooltip = `Switch to ${mode}`;
        return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
            className: "text-reset",
            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc7c852c832d97ac$export$2e2bcd8739ae039), {
                icon: icon,
                tooltip: tooltip,
                placement: "left"
            })
        });
    }
    introText() {
        switch(this.props.active){
            case "networks":
                return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("span", {
                    children: [
                        "REStake automatically imports ",
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                            href: "https://cosmos.network/",
                            target: "_blank",
                            className: "text-reset",
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                                children: "Cosmos"
                            })
                        }),
                        " chains from the ",
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                            href: "https://github.com/cosmos/chain-registry",
                            target: "_blank",
                            className: "text-reset",
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                                children: "Chain Registry"
                            })
                        })
                    ]
                });
            case "voting":
                return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("span", {
                    children: [
                        "REStake let's you vote on behalf of your other ",
                        this.props.network && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                            onClick: this.showNetworkSelect,
                            className: "text-decoration-underline",
                            role: "button",
                            children: this.props.network.prettyName
                        }),
                        " wallets using Authz"
                    ]
                });
            case "grants":
                return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("span", {
                    children: [
                        "REStake manages all your ",
                        this.props.network && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                            onClick: this.showNetworkSelect,
                            className: "text-decoration-underline",
                            role: "button",
                            children: this.props.network.prettyName
                        }),
                        " Authz grants in one place"
                    ]
                });
        }
        return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("span", {
            children: [
                "REStake allows validators to ",
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                    onClick: ()=>this.setState({
                            showAbout: true
                        }),
                    className: "text-decoration-underline",
                    role: "button",
                    children: "auto-compound"
                }),
                " your ",
                this.props.network && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("strong", {
                    onClick: this.showNetworkSelect,
                    className: "text-decoration-underline",
                    role: "button",
                    children: this.props.network.prettyName
                }),
                " staking rewards"
            ]
        });
    }
    render() {
        var _this_state_wallet, _this_state_wallet1, _this_state_signerProvider, _this_props_network, _this_state_walletModal, _this_state_walletModal1;
        return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $99251645f92da11d$export$2e2bcd8739ae039), {
            fluid: "lg",
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("header", {
                    className: "",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            className: "d-flex justify-content-between align-items-center py-3 border-bottom",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                    className: "logo d-flex align-items-end text-reset text-decoration-none",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                            onClick: ()=>this.props.setActive("networks"),
                                            role: "button",
                                            className: "text-reset text-decoration-none",
                                            children: this.props.theme === "light" ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($7c846a15465cce4a$exports))),
                                                srcSet: `${(0, (/*@__PURE__*/$parcel$interopDefault($a7b2057ce332323b$exports)))} 2x, ${(0, (/*@__PURE__*/$parcel$interopDefault($4b2174e61fd9240a$exports)))} 3x`,
                                                alt: "REStake"
                                            }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($9423e3c32dfe8181$exports))),
                                                srcSet: `${(0, (/*@__PURE__*/$parcel$interopDefault($5ebfdabee7765f00$exports)))} 2x, ${(0, (/*@__PURE__*/$parcel$interopDefault($c39fb6ed17b44c3e$exports)))} 3x`,
                                                alt: "REStake"
                                            })
                                        }),
                                        this.props.directory.testnet && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("small", {
                                            className: "ms-2 text-muted",
                                            children: "testnet"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                    className: "d-flex align-items-center text-reset text-decoration-none",
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                        className: "lead fs-6 text-center m-0 px-3 d-lg-block d-none",
                                        children: this.introText()
                                    })
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                    className: "d-flex align-items-center text-reset text-decoration-none",
                                    children: [
                                        this.networkIcon(),
                                        this.themeIcon(),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $b1b72b76c330b00f$export$2e2bcd8739ae039), {
                                            show: this.state.showNetworkSelect,
                                            onHide: ()=>{
                                                this.setState({
                                                    showNetworkSelect: false
                                                });
                                            },
                                            networks: this.props.networks,
                                            network: this.props.network,
                                            favourites: this.state.favourites || [],
                                            validators: this.props.validators,
                                            changeNetwork: this.props.changeNetwork
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            className: "d-flex justify-content-between border-bottom",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc1f9dddc97a5e79$export$2e2bcd8739ae039), {
                                    className: `navbar navbar-expand ${this.props.theme === "dark" ? "navbar-dark" : "navbar-light"}`,
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                        className: "justify-content-center",
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $85f5d0e6280a2ccf$export$2e2bcd8739ae039), {
                                            activeKey: this.props.active,
                                            onSelect: (e)=>this.props.setActive(e),
                                            children: [
                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                                    className: "nav-item pe-2 border-end",
                                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $85f5d0e6280a2ccf$export$2e2bcd8739ae039).Link, {
                                                        eventKey: "networks",
                                                        children: [
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8f99976611234862$export$2e2bcd8739ae039), {
                                                                className: "mb-1 me-1"
                                                            }),
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                                className: "d-none d-sm-inline",
                                                                children: " Explore"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                this.props.network && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                                            className: "nav-item px-2 border-end",
                                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $85f5d0e6280a2ccf$export$2e2bcd8739ae039).Link, {
                                                                eventKey: "delegations",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a764e00b89eb1737$export$2e2bcd8739ae039), {
                                                                        className: "mb-1 me-1"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                                        className: "d-none d-sm-inline",
                                                                        children: " Stake"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                                            className: "nav-item px-2 border-end",
                                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $85f5d0e6280a2ccf$export$2e2bcd8739ae039).Link, {
                                                                eventKey: "voting",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $35bb2be1292df2d9$export$2e2bcd8739ae039), {
                                                                        className: "mb-1 me-1"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                                        className: "d-none d-sm-inline",
                                                                        children: " Vote"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        this.state.address && this.props.network.authzSupport && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                                            className: "nav-item ps-2",
                                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $85f5d0e6280a2ccf$export$2e2bcd8739ae039).Link, {
                                                                eventKey: "grants",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $ace35481abdb3b8c$export$2e2bcd8739ae039), {
                                                                        className: "mb-1 me-1"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                                        className: "d-none d-sm-inline",
                                                                        children: " Grant"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("nav", {
                                    className: `navbar navbar-expand ${this.props.theme === "dark" ? "navbar-dark" : "navbar-light"}`,
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                        className: "justify-content-center",
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("ul", {
                                            className: "navbar-nav",
                                            children: this.props.network && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                                                children: [
                                                    (this.state.wallet || this.favouriteAddresses().length > 0) && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("li", {
                                                        className: "nav-item pe-3 border-end d-flex align-items-center",
                                                        children: [
                                                            this.state.address && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                                        className: "d-none d-md-inline pe-2",
                                                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $ae24f4fe768ad0c2$export$2e2bcd8739ae039), {
                                                                            favourites: this.favouriteAddresses(),
                                                                            value: this.state.address,
                                                                            label: this.viewingWallet() && ((_this_state_wallet = this.state.wallet) === null || _this_state_wallet === void 0 ? void 0 : _this_state_wallet.name),
                                                                            toggle: this.toggleFavouriteAddress
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                                        children: this.viewingWallet() ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc7c852c832d97ac$export$2e2bcd8739ae039), {
                                                                            tooltip: "Viewing your wallet",
                                                                            rootClose: true,
                                                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                                                role: "button",
                                                                                onClick: ()=>this.showWalletModal({
                                                                                        activeTab: "wallet"
                                                                                    }),
                                                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $439c909092c9bb4d$export$2e2bcd8739ae039), {})
                                                                            })
                                                                        }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc7c852c832d97ac$export$2e2bcd8739ae039), {
                                                                            tooltip: "Viewing saved address",
                                                                            rootClose: true,
                                                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                                                role: "button",
                                                                                onClick: ()=>this.showWalletModal({
                                                                                        activeTab: "saved"
                                                                                    }),
                                                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0d0d1fef9e2b8fcf$export$2e2bcd8739ae039), {})
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            this.otherFavouriteAddresses().length < 1 && this.state.wallet ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                                role: "button",
                                                                onClick: ()=>this.showWalletModal({
                                                                        activeTab: "wallet"
                                                                    }),
                                                                className: "small d-none d-lg-inline ms-2",
                                                                children: this.state.wallet.name || (0, $2a6bf51ee962800d$export$cd8822fabcdefd67)(this.state.wallet.address)
                                                            }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("select", {
                                                                className: "form-select form-select-sm d-none d-lg-block ms-2",
                                                                "aria-label": "Address",
                                                                value: this.state.address || "",
                                                                onChange: (e)=>this.setState({
                                                                        address: e.target.value
                                                                    }),
                                                                style: {
                                                                    maxWidth: 200
                                                                },
                                                                children: [
                                                                    this.state.wallet ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("optgroup", {
                                                                        label: this.state.signerProvider.label,
                                                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                                                                            value: this.state.wallet.address,
                                                                            children: this.state.wallet.name || (0, $2a6bf51ee962800d$export$cd8822fabcdefd67)(this.state.wallet.address)
                                                                        })
                                                                    }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                                                                        value: "",
                                                                        children: "Choose address"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("optgroup", {
                                                                        label: "Saved",
                                                                        children: this.otherFavouriteAddresses().map(({ address: address, label: label })=>{
                                                                            return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                                                                                value: address,
                                                                                children: label || (0, $2a6bf51ee962800d$export$cd8822fabcdefd67)(address)
                                                                            }, address);
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            this.state.address && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                                className: "d-none d-md-inline ms-2",
                                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $dc7c852c832d97ac$export$2e2bcd8739ae039), {
                                                                    tooltip: "Copy address",
                                                                    rootClose: true,
                                                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e546e10a1daf5b5e$exports.CopyToClipboard), {
                                                                            text: this.state.address,
                                                                            onCopy: ()=>this.setCopied(),
                                                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                                                role: "button",
                                                                                className: "d-flex align-items-center",
                                                                                children: this.state.copied ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $73debbb3a1242b4c$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5602cbef70cef3bb$export$2e2bcd8739ae039), {})
                                                                            })
                                                                        })
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    this.state.address && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("li", {
                                                        className: "nav-item px-3 border-end align-items-center d-none d-md-flex",
                                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                                            role: "button",
                                                            onClick: ()=>this.showWalletModal({
                                                                    activeTab: this.state.wallet ? "wallet" : "saved"
                                                                }),
                                                            children: this.state.balance ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $edd3c36e8c82dfd7$export$2e2bcd8739ae039), {
                                                                coins: this.state.balance,
                                                                asset: this.props.network.baseAsset,
                                                                className: "small text-end"
                                                            }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $39ebe134e7977f3e$export$2e2bcd8739ae039), {
                                                                animation: "border",
                                                                role: "status",
                                                                className: "spinner-border-sm text-secondary",
                                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                                    className: "visually-hidden",
                                                                    children: "Loading..."
                                                                })
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("li", {
                                                        className: "nav-item ps-3 d-flex align-items-center",
                                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $47cad3b7d9bae545$export$2e2bcd8739ae039), {
                                                            as: (0, $5a495f88153c14dd$export$2e2bcd8739ae039),
                                                            children: [
                                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $47cad3b7d9bae545$export$2e2bcd8739ae039).Toggle, {
                                                                    size: "sm",
                                                                    className: "rounded",
                                                                    children: this.state.address ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                                                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $053e6fdc626b068a$export$2e2bcd8739ae039), {
                                                                            className: "me-1"
                                                                        })
                                                                    }) : "Connect"
                                                                }),
                                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $47cad3b7d9bae545$export$2e2bcd8739ae039).Menu, {
                                                                    children: [
                                                                        this.state.address && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                                                            className: "d-block d-md-none",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $47cad3b7d9bae545$export$2e2bcd8739ae039).Header, {
                                                                                    className: "text-truncate",
                                                                                    children: this.addressName()
                                                                                }),
                                                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $47cad3b7d9bae545$export$2e2bcd8739ae039).Item, {
                                                                                    as: "button",
                                                                                    onClick: ()=>this.showWalletModal({
                                                                                            activeTab: this.state.wallet ? "wallet" : "saved"
                                                                                        }),
                                                                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $edd3c36e8c82dfd7$export$2e2bcd8739ae039), {
                                                                                        coins: this.state.balance,
                                                                                        asset: this.props.network.baseAsset,
                                                                                        className: "small"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $47cad3b7d9bae545$export$2e2bcd8739ae039).Divider, {})
                                                                            ]
                                                                        }),
                                                                        this.state.wallet ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                                                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $47cad3b7d9bae545$export$2e2bcd8739ae039).Item, {
                                                                                as: "button",
                                                                                disabled: !((_this_state_wallet1 = this.state.wallet) === null || _this_state_wallet1 === void 0 ? void 0 : _this_state_wallet1.hasPermission(this.state.address, "Send")),
                                                                                onClick: ()=>this.setState({
                                                                                        showSendModal: true
                                                                                    }),
                                                                                children: [
                                                                                    "Send ",
                                                                                    this.props.network.symbol
                                                                                ]
                                                                            })
                                                                        }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                                                                            children: [
                                                                                this.signerProviders.map((provider)=>{
                                                                                    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $47cad3b7d9bae545$export$2e2bcd8739ae039).Item, {
                                                                                        as: "button",
                                                                                        onClick: ()=>this.connect(provider.name, true),
                                                                                        disabled: !provider.available(),
                                                                                        children: [
                                                                                            "Connect ",
                                                                                            provider.label
                                                                                        ]
                                                                                    }, provider.name);
                                                                                }),
                                                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $47cad3b7d9bae545$export$2e2bcd8739ae039).Divider, {})
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $47cad3b7d9bae545$export$2e2bcd8739ae039).Item, {
                                                                            as: "button",
                                                                            onClick: ()=>this.showWalletModal({
                                                                                    activeTab: "saved"
                                                                                }),
                                                                            children: "Saved Addresses"
                                                                        }),
                                                                        this.state.address && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $47cad3b7d9bae545$export$2e2bcd8739ae039).Divider, {}),
                                                                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $47cad3b7d9bae545$export$2e2bcd8739ae039).Item, {
                                                                                    as: "button",
                                                                                    onClick: this.disconnect,
                                                                                    children: this.state.wallet ? `Disconnect ${(_this_state_signerProvider = this.state.signerProvider) === null || _this_state_signerProvider === void 0 ? void 0 : _this_state_signerProvider.label}` : "Close"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                    className: "my-4",
                    children: [
                        ((_this_props_network = this.props.network) === null || _this_props_network === void 0 ? void 0 : _this_props_network.experimental) && this.props.active !== "networks" && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $c9bd276a69168a44$export$2e2bcd8739ae039), {
                            variant: "info",
                            dismissible: false,
                            children: [
                                "This network was added to REStake automatically and has not been thoroughly tested yet. ",
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                                    href: "https://github.com/eco-stake/restake-ui/issues",
                                    target: "_blank",
                                    children: "Raise an issue"
                                }),
                                " if you have any problems."
                            ]
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $c9bd276a69168a44$export$2e2bcd8739ae039), {
                            message: this.state.error,
                            variant: "danger",
                            dismissible: false
                        }),
                        (this.state.providerError, false),
                        this.props.active === "networks" && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $1b8985cc0d82b13f$export$2e2bcd8739ae039), {
                            networks: Object.values(this.props.networks),
                            changeNetwork: this.props.changeNetwork,
                            favourites: this.state.favourites,
                            toggleFavourite: this.toggleFavourite
                        }),
                        this.props.active === "delegations" && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $cb41a1cd6099839c$export$2e2bcd8739ae039), {
                                theme: this.props.theme,
                                network: this.props.network,
                                networks: this.props.networks,
                                address: this.state.address,
                                wallet: this.state.wallet,
                                balance: this.state.balance,
                                operators: this.props.operators,
                                validators: this.props.validators,
                                validator: this.props.validator,
                                grants: this.state.grants,
                                getBalance: this.getBalance,
                                showAbout: ()=>this.setState({
                                        showAbout: true
                                    }),
                                onGrant: this.onGrant,
                                onRevoke: this.onRevoke,
                                queryClient: this.props.queryClient,
                                signingClient: this.state.signingClient
                            })
                        }),
                        this.props.active === "voting" && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $da3aff51a5e73f86$export$2e2bcd8739ae039), {
                            network: this.props.network,
                            address: this.state.address,
                            wallet: this.state.wallet,
                            favouriteAddresses: this.favouriteAddresses(),
                            queryClient: this.props.queryClient,
                            signingClient: this.state.signingClient
                        }),
                        this.props.active === "grants" && this.state.address && this.props.network.authzSupport && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $ca2b4419ac054a4c$export$2e2bcd8739ae039), {
                            network: this.props.network,
                            address: this.state.address,
                            wallet: this.state.wallet,
                            grants: this.state.grants,
                            operators: this.props.operators,
                            validators: this.props.validators,
                            favouriteAddresses: this.favouriteAddresses(),
                            showFavouriteAddresses: ()=>this.showWalletModal({
                                    activeTab: "saved"
                                }),
                            toggleFavouriteAddress: this.toggleFavouriteAddress,
                            onGrant: this.onGrant,
                            onRevoke: this.onRevoke,
                            queryClient: this.props.queryClient,
                            grantQuerySupport: this.state.grantQuerySupport,
                            signingClient: this.state.signingClient
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("footer", {
                    className: "d-flex flex-wrap justify-content-between align-items-center py-3 my-4 border-top",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                            href: "https://cogwheel.zone",
                            target: "_blank",
                            rel: "noreferrer",
                            className: "col-md-4 mb-0 text-muted",
                            children: this.props.theme === "light" ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($c845e611e0d858e2$exports))),
                                alt: "By Cogwheel Pos Validator",
                                width: 200
                            }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($2560efb14bcc55a9$exports))),
                                alt: "By Cogwheel Pos Validator",
                                width: 200
                            })
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            className: "col-md-4 align-items-center text-center me-lg-auto",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("a", {
                                    href: "https://ecostake.com",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    className: "text-reset text-decoration-none d-block mb-2",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                            className: "d-none d-sm-inline",
                                            children: "Built with \uD83D\uDC9A\xa0"
                                        }),
                                        " by ECO Stake \uD83C\uDF31"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("a", {
                                    href: `https://explorer.cogwheel.zone`,
                                    target: "_blank",
                                    className: "text-reset text-decoration-none d-block small",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                            className: "d-none d-sm-inline",
                                            children: "Manage your assets on"
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("u", {
                                            children: "explorer.cogwheel.zone"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                            className: "col-md-4 mb-0 text-muted text-end justify-content-end d-none d-lg-flex",
                            children: this.props.theme === "light" ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $ae76c41a34495815$export$2e2bcd8739ae039), {
                                href: "https://github.com/eco-stake/restake",
                                "data-icon": "octicon-star",
                                "data-size": "large",
                                "data-show-count": "true",
                                "aria-label": "Star eco-stake/restake on GitHub",
                                children: "Star"
                            }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $ae76c41a34495815$export$2e2bcd8739ae039), {
                                href: "https://github.com/eco-stake/restake",
                                "data-icon": "octicon-star",
                                "data-size": "large",
                                "data-show-count": "true",
                                "aria-label": "Star eco-stake/restake on GitHub",
                                "data-color-scheme": "no-preference: dark; light: dark; dark: dark;",
                                children: "Star"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $c8f11f34c20eefe4$export$2e2bcd8739ae039), {
                    show: this.state.showAbout,
                    onHide: ()=>this.setState({
                            showAbout: false
                        })
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $80695f04909a9613$export$2e2bcd8739ae039), {
                    show: (_this_state_walletModal = this.state.walletModal) === null || _this_state_walletModal === void 0 ? void 0 : _this_state_walletModal.show,
                    onHide: ()=>this.hideWalletModal(),
                    activeTab: (_this_state_walletModal1 = this.state.walletModal) === null || _this_state_walletModal1 === void 0 ? void 0 : _this_state_walletModal1.activeTab,
                    network: this.props.network,
                    networks: Object.values(this.props.networks),
                    address: this.state.address,
                    wallet: this.state.wallet,
                    signerProvider: this.state.signerProvider,
                    balances: this.state.balances,
                    favouriteAddresses: this.state.favouriteAddresses,
                    updateFavouriteAddresses: this.updateFavouriteAddresses,
                    toggleFavouriteAddress: this.toggleFavouriteAddress,
                    setAddress: (value)=>{
                        this.setState({
                            address: value
                        });
                        this.hideWalletModal();
                    }
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $22927c0bb5ffd6de$export$2e2bcd8739ae039), {
                    show: this.state.connectWallet,
                    signerProvider: this.state.signerProvider,
                    uri: this.state.qrCodeUri,
                    callback: this.state.qrCodeCallback,
                    onClose: ()=>this.setState({
                            connectWallet: false
                        })
                }),
                this.props.network && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $802aa9996099ad6f$export$2e2bcd8739ae039), {
                    show: this.state.showSendModal,
                    network: this.props.network,
                    address: this.state.address,
                    wallet: this.state.wallet,
                    balance: this.state.balance,
                    favouriteAddresses: this.favouriteAddresses(),
                    signingClient: this.state.signingClient,
                    onHide: ()=>this.setState({
                            showSendModal: false
                        }),
                    onSend: this.onSend
                })
            ]
        });
    }
    constructor(props){
        var _window_cosmostation_providers, _window_cosmostation, _window_cosmostation1;
        super(props);
        const favouriteJson = localStorage.getItem("favourites");
        const favouriteAddressJson = localStorage.getItem("favourite-addresses");
        this.state = {
            favourites: favouriteJson ? JSON.parse(favouriteJson) : [],
            favouriteAddresses: favouriteAddressJson ? JSON.parse(favouriteAddressJson) : {}
        };
        this.signerProviders = [
            new (0, $843b5e8118d7625d$export$2e2bcd8739ae039)(window.keplr),
            new (0, $88285097bf3611ed$export$2e2bcd8739ae039)(window.leap),
            new (0, $369b3790db0d9a9c$export$2e2bcd8739ae039)((_window_cosmostation = window.cosmostation) === null || _window_cosmostation === void 0 ? void 0 : (_window_cosmostation_providers = _window_cosmostation.providers) === null || _window_cosmostation_providers === void 0 ? void 0 : _window_cosmostation_providers.keplr, (_window_cosmostation1 = window.cosmostation) === null || _window_cosmostation1 === void 0 ? void 0 : _window_cosmostation1.cosmos),
            new (0, $87bfb1122f1dee8d$export$2e2bcd8739ae039)({
                connectModal: {
                    open: (uri, callback)=>{
                        this.setState({
                            connectWallet: true,
                            qrCodeUri: uri || this.state.qrCodeUri,
                            qrCodeCallback: callback || this.state.qrCodeCallback
                        });
                    },
                    close: ()=>{
                        this.setState({
                            connectWallet: false
                        });
                    }
                }
            })
        ];
        this.signerConnectors = {};
        this.connectAuto = this.connectAuto.bind(this);
        this.disconnect = this.disconnect.bind(this);
        this.showNetworkSelect = this.showNetworkSelect.bind(this);
        this.getBalance = this.getBalance.bind(this);
        this.onSend = this.onSend.bind(this);
        this.onGrant = this.onGrant.bind(this);
        this.onRevoke = this.onRevoke.bind(this);
        this.toggleFavourite = this.toggleFavourite.bind(this);
        this.toggleFavouriteAddress = this.toggleFavouriteAddress.bind(this);
        this.updateFavouriteAddresses = this.updateFavouriteAddresses.bind(this);
    }
}
var $983d6cbbf805859b$export$2e2bcd8739ae039 = $983d6cbbf805859b$var$App;




var $164ff6e7304fa298$exports = {};
$164ff6e7304fa298$exports = JSON.parse('[{"name":"osmosis","ownerAddress":"osmovaloper1u5v0m74mql5nzfx2yh43s2tke4mvzghr6m2n5t","maxPerDay":1,"apiVersions":{"gov":"v1beta1"},"authzAminoExecPreventTypes":["/cosmos.gov."]},{"name":"juno","ownerAddress":"junovaloper19ur8r2l25qhsy9xvej5zgpuc5cpn6syydmwtrt"},{"name":"cosmoshub","ownerAddress":"cosmosvaloper1a37ze3yrr2y9nn98l6frhjskmufvd40cpyd0gq"},{"name":"akash","ownerAddress":"akashvaloper1xgnd8aach3vawsl38snpydkng2nv8a4kqgs8hf"},{"name":"chihuahua","ownerAddress":"chihuahuavaloper19vwcee000fhazmpt4ultvnnkhfh23ppwxll8zz"},{"name":"gravitybridge"},{"name":"regen","ownerAddress":"regenvaloper1c4y3j05qx652rnxm5mg4yesqdkmhz2f6dl7hhk","authzAminoExecPreventTypes":["/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission"]},{"name":"terra","authzAminoLiftedValues":false},{"name":"terra2"},{"name":"sentinel"},{"name":"dig"},{"name":"bitcanna"},{"name":"emoney"},{"name":"kava"},{"name":"desmos","authzAminoGenericOnly":false},{"name":"cryptoorgchain","ownerAddress":"crocncl10mfs428fyntu296dgh5fmhvdzrr2stlaekcrp9","authzAminoExecPreventTypes":["/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission"]},{"name":"evmos","ownerAddress":"evmosvaloper1umk407eed7af6anvut6llg2zevnf0dn0feqqny","txTimeout":120000,"maxPerDay":1,"gasPrice":"75000000000aevmos","authzAminoExecPreventTypes":["/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission"]},{"name":"sifchain"},{"name":"lumnetwork"},{"name":"stargaze"},{"name":"comdex","ownerAddress":"comdexvaloper17f70yjkvmvld379904jaddx9h0f74n32pjtmp6","apiVersions":{"gov":"v1beta1"},"authzAminoExecPreventTypes":["/cosmos.gov.","/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission"]},{"name":"cheqd"},{"name":"umee"},{"name":"bitsong"},{"name":"persistence"},{"name":"agoric"},{"name":"impacthub"},{"name":"kichain"},{"name":"sommelier"},{"name":"konstellation"},{"name":"fetchhub"},{"name":"cerberus"},{"name":"secretnetwork","authzAminoGenericOnly":false},{"name":"bostrom"},{"name":"starname"},{"name":"rizon"},{"name":"decentr"},{"name":"assetmantle","ownerAddress":"mantlevaloper1fqs7gakxdmujtk0qufdzth5pfyspus3yx394zd"},{"name":"crescent"},{"name":"meme"},{"name":"cronos","enabled":false},{"name":"harpoon","ownerAddress":"kujiravaloper1vue5lawr3s0au9zj0aqeft5aknx6cjq6w5ghca","testnet":true},{"name":"kujira","ownerAddress":"kujiravaloper1vue5lawr3s0au9zj0aqeft5aknx6cjq6w5ghca"},{"name":"genesisl1","txTimeout":120000},{"name":"tgrade","enabled":false},{"name":"aioz","enabled":false},{"name":"echelon"},{"name":"kichaintestnet","testnet":true},{"name":"likecoin"},{"name":"passage","ownerAddress":"pasgvaloper196rujtjehu0dfc7y85lkcaps6tel76g3l9knjy"},{"name":"stride","ownerAddress":"stridevaloper1x2kta40h5rnymtjn6ys7vk2d87xu7y6zfu9j3r","authzSupport":false},{"name":"pulsar","testnet":true},{"name":"teritori","ownerAddress":"torivaloper1d5u07lhelk6lal44a0myvufurvsqk5d499h9hz"},{"name":"rebus"},{"name":"jackal","ownerAddress":"jklvaloper1rdyunvvqg2l3723hlyjvvsnkd4vg338uar8q2s"},{"name":"oraichain"},{"name":"acrechain"},{"name":"mars","ownerAddress":"marsvaloper1hvtaqw9mlwc0a4cdx6g3klk8acfc6z3yazzk8a","authzAminoExecPreventTypes":["/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission"]},{"name":"planq"},{"name":"injective","ownerAddress":"injvaloper1vqz7mgm47xhx25xu5g9qagnz48naks6pk6fmg2","authzAminoExecPreventTypes":["/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission"]},{"name":"xpla"},{"name":"kyve","ownerAddress":"kyvevaloper1egqphd8yjdfv84fl825grwgna0pf2emagdmnz8","authzAminoExecPreventTypes":["/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission"]},{"name":"quicksilver","maxPerDay":1},{"name":"chain4energy"},{"name":"coreum","ownerAddress":"corevaloper1py9v5f7e4aaka55lwtthk30scxhnqfa6agwxt8"},{"name":"nois","ownerAddress":"noisvaloper198un95fs7wxqkv53zhc8hjcyga8qgswtv82x9w"},{"name":"omniflixhub","ownerAddress":"omniflixvaloper19d782trtcj4yq9lm7nxy3xs3xjg8vjktn3sjsd"},{"name":"empowerchain","ownerAddress":"empowervaloper1msjwmclw77h5j0t69n7j2p9ur5ra46uxqaedxz"}]');


const $5248266a0be8360f$var$LIGHT_THEME = "cosmo";
const $5248266a0be8360f$var$DARK_THEME = "superhero";
function $5248266a0be8360f$var$NetworkFinder() {
    const params = (0, $4a3e215446c0ed92$export$99eaa27ddbbb95ef)();
    const navigate = (0, $4a3e215446c0ed92$export$9770f232ac06a008)();
    const voteMatch = (0, $4a3e215446c0ed92$export$6c330e8992e8a295)("/:network/vote/*");
    const grantMatch = (0, $4a3e215446c0ed92$export$6c330e8992e8a295)("/:network/grants");
    const networkMode = "mainnet";
    const directory = getDirectory();
    const LS_THEME_KEY = "restake-theme";
    const LS_THEME = localStorage.getItem(LS_THEME_KEY);
    const [theme, setTheme] = (0, $6cds3.useState)();
    const [themeChoice, setThemeChoice] = (0, $6cds3.useState)(LS_THEME || "auto");
    const [themeDefault, setThemeDefault] = (0, $6cds3.useState)("light");
    const [state, setState] = (0, $6cds3.useReducer)((state, newState)=>({
            ...state,
            ...newState
        }), {
        loading: true,
        networks: {},
        operators: [],
        validators: {},
        networkMode: networkMode,
        directory: directory
    });
    function getDirectory() {
        let testnet = networkMode === "testnet";
        if (params.network && !testnet) {
            const data = (0, (/*@__PURE__*/$parcel$interopDefault($164ff6e7304fa298$exports))).find((el)=>el.name === params.network);
            if (data && data.testnet) testnet = true;
        }
        return (0, $490ed7ae18117c88$export$2e2bcd8739ae039)(testnet);
    }
    async function getNetworks() {
        let registryNetworks, operatorAddresses;
        try {
            registryNetworks = await state.directory.getChains();
            operatorAddresses = await state.directory.getOperatorAddresses();
        } catch (error) {
            setState({
                error: error.message,
                loading: false
            });
            return {};
        }
        const networks = Object.values(registryNetworks).map((data)=>{
            const networkData = (0, (/*@__PURE__*/$parcel$interopDefault($164ff6e7304fa298$exports))).find((el)=>el.name === data.path);
            if (networkData && networkData.enabled === false) return;
            if (!data.image || data.status === "killed") return;
            if (!networkData) data.experimental = true;
            return new (0, $d07b3fb94219a1b2$export$2e2bcd8739ae039)({
                ...data,
                ...networkData
            }, operatorAddresses[data.path]);
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($c9wMV))).compact(networks).reduce((a, v)=>({
                ...a,
                [v.path]: v
            }), {});
    }
    function changeNetworkMode(networkMode) {
        let domain = undefined;
        if (domain) window.location.replace("https://" + domain);
        else {
            const directory = (0, $490ed7ae18117c88$export$2e2bcd8739ae039)(networkMode === "testnet");
            setState({
                networkMode: networkMode,
                directory: directory,
                active: "networks",
                network: null,
                queryClient: null,
                networks: {},
                validators: {},
                operators: []
            });
        }
    }
    function changeNetwork(network) {
        if (!network) return;
        setState({
            network: network,
            queryClient: network.queryClient,
            validators: network.getValidators(),
            operators: network.getOperators(),
            loading: false
        });
        if (voteMatch) setActive("voting", network);
        else if (grantMatch && network.authzSupport) setActive("grants", network);
        else setActive("delegations", network);
    }
    function setActive(active, network) {
        network = network || state.network;
        switch(active){
            case "grants":
                navigate("/" + network.path + "/grants");
                break;
            case "voting":
                navigate("/" + network.path + "/vote");
                break;
            case "delegations":
                navigate("/" + network.path);
                break;
            default:
                navigate("/");
                break;
        }
        setState({
            active: active
        });
        const body = document.querySelector("#root");
        body.scrollIntoView({}, 500);
    }
    (0, $6cds3.useEffect)(()=>{
        const setThemeEvent = (event)=>{
            setTheme(event.matches ? "dark" : "light");
            setThemeDefault(event.matches ? "dark" : "light");
        };
        const matchMedia = window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)");
        if (themeChoice !== "auto") setTheme(themeChoice);
        else if (matchMedia) {
            matchMedia.addEventListener("change", setThemeEvent);
            setThemeEvent(matchMedia);
        } else setTheme("light");
        if (localStorage.getItem(LS_THEME_KEY) !== themeChoice) localStorage.setItem(LS_THEME_KEY, themeChoice);
        return ()=>{
            matchMedia && matchMedia.removeEventListener("change", setThemeEvent);
        };
    }, [
        themeChoice
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (theme) {
            const themeLink = document.getElementById("theme-style");
            const themeName = theme === "dark" ? $5248266a0be8360f$var$DARK_THEME : $5248266a0be8360f$var$LIGHT_THEME;
            themeLink.setAttribute("href", `https://cdn.jsdelivr.net/npm/bootswatch@5.1.3/dist/${themeName}/bootstrap.min.css`);
            document.body.classList.toggle("dark-theme", theme === "dark");
        }
    }, [
        theme
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (state.error) return;
        if (!Object.keys(state.networks).length) {
            setState({
                loading: true
            });
            getNetworks().then((networks)=>{
                setState({
                    networks: networks
                });
            });
        }
    }, [
        state.networks
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (!params.network) setState({
            active: "networks"
        });
    }, [
        voteMatch,
        grantMatch,
        params.network
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (Object.keys(state.networks).length && (!state.network || state.network.path !== params.network)) {
            let networkName = params.network;
            const network = state.networks[networkName];
            if (!network) {
                navigate("/");
                setState({
                    loading: false
                });
                return;
            }
            if (params.network != networkName) navigate("/" + networkName);
            network.load().then(()=>{
                return network.connect().then(()=>{
                    if (network.connected) setState({
                        active: grantMatch ? "grants" : voteMatch ? "voting" : "delegations",
                        network: network,
                        queryClient: network.queryClient,
                        validators: network.getValidators(),
                        operators: network.getOperators(),
                        loading: false
                    });
                    else throw false;
                });
            }).catch((error)=>{
                console.log(error);
                changeNetwork(network);
            });
        }
    }, [
        state.networks,
        state.network,
        params.network,
        navigate
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (params.validator && state.validators[params.validator]) setState({
            validator: state.validators[params.validator]
        });
        else if (state.validator) setState({
            validator: null
        });
    }, [
        state.validators,
        params.validator
    ]);
    if (state.error) return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $c9bd276a69168a44$export$2e2bcd8739ae039), {
        message: state.error,
        variant: "danger",
        dismissible: false
    });
    if (state.loading) return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
        className: "pt-5 text-center",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $39ebe134e7977f3e$export$2e2bcd8739ae039), {
            animation: "border",
            role: "status",
            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                className: "visually-hidden",
                children: "Loading..."
            })
        })
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $983d6cbbf805859b$export$2e2bcd8739ae039), {
        networks: state.networks,
        network: state.network,
        active: state.active,
        queryClient: state.queryClient,
        networkMode: state.networkMode,
        directory: state.directory,
        changeNetworkMode: changeNetworkMode,
        operators: state.operators,
        validators: state.validators,
        validator: state.validator,
        changeNetwork: (network, validators)=>changeNetwork(network, validators),
        setActive: setActive,
        theme: theme,
        themeChoice: themeChoice,
        themeDefault: themeDefault,
        setThemeChoice: setThemeChoice
    });
}
var $5248266a0be8360f$export$2e2bcd8739ae039 = $5248266a0be8360f$var$NetworkFinder;



const $bd51d500f2b4d742$var$reportWebVitals = (onPerfEntry)=>{
    if (onPerfEntry && onPerfEntry instanceof Function) (parcelRequire("86xDK")).then(({ getCLS: getCLS, getFID: getFID, getFCP: getFCP, getLCP: getLCP, getTTFB: getTTFB })=>{
        getCLS(onPerfEntry);
        getFID(onPerfEntry);
        getFCP(onPerfEntry);
        getLCP(onPerfEntry);
        getTTFB(onPerfEntry);
    });
};
var $bd51d500f2b4d742$export$2e2bcd8739ae039 = $bd51d500f2b4d742$var$reportWebVitals;



const $f25e85c08ff84b11$var$app = /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).StrictMode, {
    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$9ba4e89fdfa1fc54), {
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $4a3e215446c0ed92$export$3565eb3d00ca5a74), {
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4a3e215446c0ed92$export$e7b0ac011bb776c6), {
                    path: "/",
                    element: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5248266a0be8360f$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4a3e215446c0ed92$export$e7b0ac011bb776c6), {
                    path: "/:network",
                    element: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5248266a0be8360f$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4a3e215446c0ed92$export$e7b0ac011bb776c6), {
                    path: "/:network/vote",
                    element: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5248266a0be8360f$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4a3e215446c0ed92$export$e7b0ac011bb776c6), {
                    path: "/:network/vote/:proposalId",
                    element: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5248266a0be8360f$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4a3e215446c0ed92$export$e7b0ac011bb776c6), {
                    path: "/:network/grant",
                    element: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5248266a0be8360f$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4a3e215446c0ed92$export$e7b0ac011bb776c6), {
                    path: "/:network/:validator",
                    element: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5248266a0be8360f$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4a3e215446c0ed92$export$e7b0ac011bb776c6), {
                    path: "/:network/:validator/:section",
                    element: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5248266a0be8360f$export$2e2bcd8739ae039), {})
                })
            ]
        })
    })
});
(0, (/*@__PURE__*/$parcel$interopDefault($6d4849ee44552f5f$exports))).render($f25e85c08ff84b11$var$app, document.getElementById("root"));
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
(0, $bd51d500f2b4d742$export$2e2bcd8739ae039)();

})();
//# sourceMappingURL=index.42550485.js.map
